var _defineProperty = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _assertThisInitialized = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("react-dom"));else if ("function" == typeof define && define.amd) define(["React", "ReactDOM"], t);else {
    var n = "object" == typeof exports ? t(require("react"), require("react-dom")) : t(e.React, e.ReactDOM);
    for (var r in n) ("object" == typeof exports ? exports : e)[r] = n[r];
  }
}(window, function (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
        return e[t];
      }.bind(null, i));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = "./src/index.ts");
  }({
    "./node_modules/@babel/runtime/helpers/arrayWithHoles.js": function node_modulesBabelRuntimeHelpersArrayWithHolesJs(e, t) {
      e.exports = function (e) {
        if (Array.isArray(e)) return e;
      };
    },
    "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js": function node_modulesBabelRuntimeHelpersArrayWithoutHolesJs(e, t) {
      e.exports = function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
      };
    },
    "./node_modules/@babel/runtime/helpers/assertThisInitialized.js": function node_modulesBabelRuntimeHelpersAssertThisInitializedJs(e, t) {
      e.exports = function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      };
    },
    "./node_modules/@babel/runtime/helpers/classCallCheck.js": function node_modulesBabelRuntimeHelpersClassCallCheckJs(e, t) {
      e.exports = function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      };
    },
    "./node_modules/@babel/runtime/helpers/createClass.js": function node_modulesBabelRuntimeHelpersCreateClassJs(e, t) {
      function n(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      e.exports = function (e, t, r) {
        return t && n(e.prototype, t), r && n(e, r), e;
      };
    },
    "./node_modules/@babel/runtime/helpers/defineProperty.js": function node_modulesBabelRuntimeHelpersDefinePropertyJs(e, t) {
      e.exports = function (e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      };
    },
    "./node_modules/@babel/runtime/helpers/esm/extends.js": function node_modulesBabelRuntimeHelpersEsmExtendsJs(e, t, n) {
      "use strict";

      function r() {
        return (r = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      n.d(t, "a", function () {
        return r;
      });
    },
    "./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js": function node_modulesBabelRuntimeHelpersEsmObjectWithoutPropertiesLooseJs(e, t, n) {
      "use strict";

      function r(e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          o = Object.keys(e);
        for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
      }
      n.d(t, "a", function () {
        return r;
      });
    },
    "./node_modules/@babel/runtime/helpers/extends.js": function node_modulesBabelRuntimeHelpersExtendsJs(e, t) {
      function n() {
        return e.exports = n = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }, n.apply(this, arguments);
      }
      e.exports = n;
    },
    "./node_modules/@babel/runtime/helpers/get.js": function node_modulesBabelRuntimeHelpersGetJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/superPropBase.js");
      function i(t, n, o) {
        return "undefined" != typeof Reflect && Reflect.get ? e.exports = i = Reflect.get : e.exports = i = function i(e, t, n) {
          var i = r(e, t);
          if (i) {
            var o = Object.getOwnPropertyDescriptor(i, t);
            return o.get ? o.get.call(n) : o.value;
          }
        }, i(t, n, o || t);
      }
      e.exports = i;
    },
    "./node_modules/@babel/runtime/helpers/getPrototypeOf.js": function node_modulesBabelRuntimeHelpersGetPrototypeOfJs(e, t) {
      function n(t) {
        return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, n(t);
      }
      e.exports = n;
    },
    "./node_modules/@babel/runtime/helpers/inherits.js": function node_modulesBabelRuntimeHelpersInheritsJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/setPrototypeOf.js");
      e.exports = function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && r(e, t);
      };
    },
    "./node_modules/@babel/runtime/helpers/inheritsLoose.js": function node_modulesBabelRuntimeHelpersInheritsLooseJs(e, t) {
      e.exports = function (e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
      };
    },
    "./node_modules/@babel/runtime/helpers/iterableToArray.js": function node_modulesBabelRuntimeHelpersIterableToArrayJs(e, t) {
      e.exports = function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      };
    },
    "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js": function node_modulesBabelRuntimeHelpersIterableToArrayLimitJs(e, t) {
      e.exports = function (e, t) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
          var n = [],
            r = !0,
            i = !1,
            o = void 0;
          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (i) throw o;
            }
          }
          return n;
        }
      };
    },
    "./node_modules/@babel/runtime/helpers/nonIterableRest.js": function node_modulesBabelRuntimeHelpersNonIterableRestJs(e, t) {
      e.exports = function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    },
    "./node_modules/@babel/runtime/helpers/nonIterableSpread.js": function node_modulesBabelRuntimeHelpersNonIterableSpreadJs(e, t) {
      e.exports = function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      };
    },
    "./node_modules/@babel/runtime/helpers/objectSpread.js": function node_modulesBabelRuntimeHelpersObjectSpreadJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/defineProperty.js");
      e.exports = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? Object(arguments[t]) : {},
            i = Object.keys(n);
          "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          }))), i.forEach(function (t) {
            r(e, t, n[t]);
          });
        }
        return e;
      };
    },
    "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js": function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");
      e.exports = function (e, t) {
        if (null == e) return {};
        var n,
          i,
          o = r(e, t);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);
          for (i = 0; i < a.length; i++) n = a[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
        }
        return o;
      };
    },
    "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js": function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesLooseJs(e, t) {
      e.exports = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          o = Object.keys(e);
        for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
      };
    },
    "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js": function node_modulesBabelRuntimeHelpersPossibleConstructorReturnJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/typeof.js"),
        i = n("./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
      e.exports = function (e, t) {
        return !t || "object" !== r(t) && "function" != typeof t ? i(e) : t;
      };
    },
    "./node_modules/@babel/runtime/helpers/setPrototypeOf.js": function node_modulesBabelRuntimeHelpersSetPrototypeOfJs(e, t) {
      function n(t, r) {
        return e.exports = n = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, n(t, r);
      }
      e.exports = n;
    },
    "./node_modules/@babel/runtime/helpers/slicedToArray.js": function node_modulesBabelRuntimeHelpersSlicedToArrayJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/arrayWithHoles.js"),
        i = n("./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js"),
        o = n("./node_modules/@babel/runtime/helpers/nonIterableRest.js");
      e.exports = function (e, t) {
        return r(e) || i(e, t) || o();
      };
    },
    "./node_modules/@babel/runtime/helpers/superPropBase.js": function node_modulesBabelRuntimeHelpersSuperPropBaseJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
      e.exports = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = r(e)););
        return e;
      };
    },
    "./node_modules/@babel/runtime/helpers/toConsumableArray.js": function node_modulesBabelRuntimeHelpersToConsumableArrayJs(e, t, n) {
      var r = n("./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js"),
        i = n("./node_modules/@babel/runtime/helpers/iterableToArray.js"),
        o = n("./node_modules/@babel/runtime/helpers/nonIterableSpread.js");
      e.exports = function (e) {
        return r(e) || i(e) || o();
      };
    },
    "./node_modules/@babel/runtime/helpers/typeof.js": function node_modulesBabelRuntimeHelpersTypeofJs(e, t) {
      function n(t) {
        return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = n = function n(e) {
          return typeof e;
        } : e.exports = n = function n(e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, n(t);
      }
      e.exports = n;
    },
    "./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js": function node_modulesEmotionIsPropValidDistIsPropValidBrowserEsmJs(e, t, n) {
      "use strict";

      var r = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
        i = function (e) {
          var t = {};
          return function (n) {
            return void 0 === t[n] && (t[n] = e(n)), t[n];
          };
        }(function (e) {
          return r.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
        });
      t.a = i;
    },
    "./node_modules/@emotion/unitless/dist/unitless.browser.esm.js": function node_modulesEmotionUnitlessDistUnitlessBrowserEsmJs(e, t, n) {
      "use strict";

      t.a = {
        animationIterationCount: 1,
        borderImageOutset: 1,
        borderImageSlice: 1,
        borderImageWidth: 1,
        boxFlex: 1,
        boxFlexGroup: 1,
        boxOrdinalGroup: 1,
        columnCount: 1,
        columns: 1,
        flex: 1,
        flexGrow: 1,
        flexPositive: 1,
        flexShrink: 1,
        flexNegative: 1,
        flexOrder: 1,
        gridRow: 1,
        gridRowEnd: 1,
        gridRowSpan: 1,
        gridRowStart: 1,
        gridColumn: 1,
        gridColumnEnd: 1,
        gridColumnSpan: 1,
        gridColumnStart: 1,
        msGridRow: 1,
        msGridRowSpan: 1,
        msGridColumn: 1,
        msGridColumnSpan: 1,
        fontWeight: 1,
        lineHeight: 1,
        opacity: 1,
        order: 1,
        orphans: 1,
        tabSize: 1,
        widows: 1,
        zIndex: 1,
        zoom: 1,
        WebkitLineClamp: 1,
        fillOpacity: 1,
        floodOpacity: 1,
        stopOpacity: 1,
        strokeDasharray: 1,
        strokeDashoffset: 1,
        strokeMiterlimit: 1,
        strokeOpacity: 1,
        strokeWidth: 1
      };
    },
    "./node_modules/@semantic-ui-react/event-stack/lib/cjs/event-stack.production.js": function node_modulesSemanticUiReactEventStackLibCjsEventStackProductionJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/exenv/index.js");
      n("./node_modules/prop-types/index.js");
      var i = n("react");
      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function a(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function s(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function l(e, t, n) {
        return t && s(e.prototype, t), n && s(e, n), e;
      }
      function u(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && function (e, t) {
          (Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }(e, t);
      }
      function d(e) {
        return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function h(e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      var f = function () {
        function e(t) {
          a(this, e), u(this, "handlers", void 0), this.handlers = t.slice(0);
        }
        return l(e, [{
          key: "addHandlers",
          value: function value(t) {
            for (var n = this.handlers.slice(0), r = t.length, i = 0; i < r; i += 1) n.push(t[i]);
            return new e(n);
          }
        }, {
          key: "dispatchEvent",
          value: function value(e, t) {
            var n = this.handlers.length - 1;
            if (t) {
              for (var r = n; r >= 0; r -= 1) this.handlers[r].called || (this.handlers[r].called = !0, this.handlers[r](e));
              for (var i = n; i >= 0; i -= 1) this.handlers[i].called = !1;
            } else (0, this.handlers[n])(e);
          }
        }, {
          key: "hasHandlers",
          value: function value() {
            return this.handlers.length > 0;
          }
        }, {
          key: "removeHandlers",
          value: function value(t) {
            for (var n = [], r = this.handlers.length, i = 0; i < r; i += 1) {
              var o = this.handlers[i];
              -1 === t.indexOf(o) && n.push(o);
            }
            return new e(n);
          }
        }]), e;
      }();
      function p(e) {
        var t = new Map();
        return e.forEach(function (e, n) {
          t.set(n, e);
        }), t;
      }
      function m(e) {
        return Array.isArray(e) ? e : [e];
      }
      function g(e) {
        return "document" === e ? document : "window" === e ? window : function (e) {
          return null !== e && "object" === o(e) && e.hasOwnProperty("current");
        }(e) ? e.current || document : e || document;
      }
      var v = function () {
        function e(t, n) {
          a(this, e), u(this, "handlerSets", void 0), u(this, "poolName", void 0), this.handlerSets = n, this.poolName = t;
        }
        return l(e, [{
          key: "addHandlers",
          value: function value(t, n) {
            var r = p(this.handlerSets);
            if (r.has(t)) {
              var i = r.get(t);
              r.set(t, i.addHandlers(n));
            } else r.set(t, new f(n));
            return new e(this.poolName, r);
          }
        }, {
          key: "dispatchEvent",
          value: function value(e, t) {
            var n = this.handlerSets.get(e),
              r = "default" === this.poolName;
            n && n.dispatchEvent(t, r);
          }
        }, {
          key: "hasHandlers",
          value: function value(e) {
            if (!e) return this.handlerSets.size > 0;
            var t = this.handlerSets.get(e);
            return !!t && t.hasHandlers();
          }
        }, {
          key: "removeHandlers",
          value: function value(t, n) {
            var r = p(this.handlerSets);
            if (!r.has(t)) return new e(this.poolName, r);
            var i = r.get(t).removeHandlers(n);
            return i.hasHandlers() ? r.set(t, i) : r.delete(t), new e(this.poolName, r);
          }
        }]), e;
      }();
      u(v, "createByType", function (e, t, n) {
        var r = new Map();
        return r.set(t, new f(n)), new v(e, r);
      });
      var y = function () {
          function e(t) {
            var n = this;
            a(this, e), u(this, "handlers", new Map()), u(this, "pools", new Map()), u(this, "target", void 0), u(this, "createEmitter", function (e) {
              return function (t) {
                n.pools.forEach(function (n) {
                  n.dispatchEvent(e, t);
                });
              };
            }), this.target = t;
          }
          return l(e, [{
            key: "addHandlers",
            value: function value(e, t, n) {
              if (this.pools.has(e)) {
                var r = this.pools.get(e);
                this.pools.set(e, r.addHandlers(t, n));
              } else this.pools.set(e, v.createByType(e, t, n));
              this.handlers.has(t) || this.addTargetHandler(t);
            }
          }, {
            key: "hasHandlers",
            value: function value() {
              return this.handlers.size > 0;
            }
          }, {
            key: "removeHandlers",
            value: function value(e, t, n) {
              if (this.pools.has(e)) {
                var r = this.pools.get(e).removeHandlers(t, n);
                r.hasHandlers() ? this.pools.set(e, r) : this.pools.delete(e);
                var i = !1;
                this.pools.forEach(function (e) {
                  return i = i || e.hasHandlers(t);
                }), i || this.removeTargetHandler(t);
              }
            }
          }, {
            key: "addTargetHandler",
            value: function value(e) {
              var t = this.createEmitter(e);
              this.handlers.set(e, t), this.target.addEventListener(e, t, !0);
            }
          }, {
            key: "removeTargetHandler",
            value: function value(e) {
              this.handlers.has(e) && (this.target.removeEventListener(e, this.handlers.get(e), !0), this.handlers.delete(e));
            }
          }]), e;
        }(),
        b = new (function () {
          function e() {
            var t = this;
            a(this, e), u(this, "targets", new Map()), u(this, "getTarget", function (e) {
              var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                r = g(e);
              if (t.targets.has(r)) return t.targets.get(r);
              if (!n) return null;
              var i = new y(r);
              return t.targets.set(r, i), i;
            }), u(this, "removeTarget", function (e) {
              t.targets.delete(g(e));
            });
          }
          return l(e, [{
            key: "sub",
            value: function value(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (r.canUseDOM) {
                var i = n.target,
                  o = void 0 === i ? document : i,
                  a = n.pool,
                  s = void 0 === a ? "default" : a;
                this.getTarget(o).addHandlers(s, e, m(t));
              }
            }
          }, {
            key: "unsub",
            value: function value(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (r.canUseDOM) {
                var i = n.target,
                  o = void 0 === i ? document : i,
                  a = n.pool,
                  s = void 0 === a ? "default" : a,
                  l = this.getTarget(o, !1);
                l && (l.removeHandlers(s, e, m(t)), l.hasHandlers() || this.removeTarget(o));
              }
            }
          }]), e;
        }())(),
        _ = function (e) {
          function t() {
            return a(this, t), h(this, d(t).apply(this, arguments));
          }
          return c(t, i.PureComponent), l(t, [{
            key: "componentDidMount",
            value: function value() {
              this.subscribe(this.props);
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              this.unsubscribe(e), this.subscribe(this.props);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.unsubscribe(this.props);
            }
          }, {
            key: "subscribe",
            value: function value(e) {
              var t = e.name,
                n = e.on,
                r = e.pool,
                i = e.target;
              b.sub(t, n, {
                pool: r,
                target: i
              });
            }
          }, {
            key: "unsubscribe",
            value: function value(e) {
              var t = e.name,
                n = e.on,
                r = e.pool,
                i = e.target;
              b.unsub(t, n, {
                pool: r,
                target: i
              });
            }
          }, {
            key: "render",
            value: function value() {
              return null;
            }
          }]), t;
        }();
      u(_, "defaultProps", {
        pool: "default",
        target: "document"
      }), _.propTypes = {}, t.instance = b, t.default = _;
    },
    "./node_modules/@semantic-ui-react/event-stack/lib/index.js": function node_modulesSemanticUiReactEventStackLibIndexJs(e, t, n) {
      "use strict";

      var r;
      r = n("./node_modules/@semantic-ui-react/event-stack/lib/cjs/event-stack.production.js"), e.exports = r.default, e.exports.instance = r.instance;
    },
    "./node_modules/@stardust-ui/react-component-event-listener/dist/es/EventListener.js": function node_modulesStardustUiReactComponentEventListenerDistEsEventListenerJs(e, t, n) {
      "use strict";

      n("./node_modules/prop-types/index.js");
      var r = n("./node_modules/@stardust-ui/react-component-event-listener/dist/es/useEventListener.js");
      function i(e) {
        return Object(r.a)(e), null;
      }
      i.displayName = "EventListener", i.propTypes = {}, i.defaultProps = {
        capture: !1
      }, t.a = i;
    },
    "./node_modules/@stardust-ui/react-component-event-listener/dist/es/index.js": function node_modulesStardustUiReactComponentEventListenerDistEsIndexJs(e, t, n) {
      "use strict";

      n.d(t, "documentRef", function () {
        return r;
      });
      var r = {
        current: "undefined" == typeof document ? null : document
      };
      "undefined" == typeof window || window;
    },
    "./node_modules/@stardust-ui/react-component-event-listener/dist/es/useEventListener.js": function node_modulesStardustUiReactComponentEventListenerDistEsUseEventListenerJs(e, t, n) {
      "use strict";

      var r = n("react"),
        i = function i(e, t) {
          return e && !!e.current && !!e.current[t];
        };
      t.a = function (e) {
        var t = e.capture,
          n = e.listener,
          o = e.type,
          a = e.targetRef,
          s = r.useRef(n);
        s.current = n;
        var l = r.useCallback(function (e) {
          return s.current(e);
        }, []);
        r.useEffect(function () {
          return i(a, "addEventListener") && a.current.addEventListener(o, l, t), function () {
            i(a, "removeEventListener") && a.current.removeEventListener(o, l, t);
          };
        }, [t, a, o]);
      };
    },
    "./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js": function node_modulesTensorflowTfjsCoreDistTfCoreEsmJs(e, t, n) {
      "use strict";

      n.r(t), function (e, r, i, o) {
        n.d(t, "setBackend", function () {
          return Bu;
        }), n.d(t, "getBackend", function () {
          return Fu;
        }), n.d(t, "disposeVariables", function () {
          return zu;
        }), n.d(t, "memory", function () {
          return Uu;
        }), n.d(t, "version_core", function () {
          return Tu;
        }), n.d(t, "nextFrame", function () {
          return Cl;
        }), n.d(t, "environment", function () {
          return ye;
        }), n.d(t, "io", function () {
          return gu;
        }), n.d(t, "math", function () {
          return yu;
        }), n.d(t, "serialization", function () {
          return wu;
        }), n.d(t, "test_util", function () {
          return Eu;
        }), n.d(t, "util", function () {
          return q;
        }), n.d(t, "webgl", function () {
          return Mu;
        }), n.d(t, "AdadeltaOptimizer", function () {
          return ku;
        }), n.d(t, "AdagradOptimizer", function () {
          return Pu;
        }), n.d(t, "AdamOptimizer", function () {
          return Ou;
        }), n.d(t, "AdamaxOptimizer", function () {
          return Ru;
        }), n.d(t, "MomentumOptimizer", function () {
          return ju;
        }), n.d(t, "Optimizer", function () {
          return Cu;
        }), n.d(t, "RMSPropOptimizer", function () {
          return Nu;
        }), n.d(t, "SGDOptimizer", function () {
          return Iu;
        }), n.d(t, "Tensor", function () {
          return te;
        }), n.d(t, "TensorBuffer", function () {
          return Z;
        }), n.d(t, "variable", function () {
          return re;
        }), n.d(t, "Variable", function () {
          return ne;
        }), n.d(t, "Rank", function () {
          return wt;
        }), n.d(t, "Reduction", function () {
          return nl;
        }), n.d(t, "ENV", function () {
          return ve;
        }), n.d(t, "Environment", function () {
          return ge;
        }), n.d(t, "KernelBackend", function () {
          return It;
        }), n.d(t, "DataStorage", function () {
          return Rt;
        }), n.d(t, "image", function () {
          return Al;
        }), n.d(t, "linalg", function () {
          return vl;
        }), n.d(t, "losses", function () {
          return fl;
        }), n.d(t, "spectral", function () {
          return el;
        }), n.d(t, "op", function () {
          return nt;
        }), n.d(t, "batchNormalization2d", function () {
          return Qo;
        }), n.d(t, "batchNormalization3d", function () {
          return Jo;
        }), n.d(t, "batchNormalization4d", function () {
          return ea;
        }), n.d(t, "batchNormalization", function () {
          return ta;
        }), n.d(t, "complex", function () {
          return ot;
        }), n.d(t, "real", function () {
          return at;
        }), n.d(t, "imag", function () {
          return st;
        }), n.d(t, "concat", function () {
          return Ai;
        }), n.d(t, "concat1d", function () {
          return Ei;
        }), n.d(t, "concat2d", function () {
          return Ti;
        }), n.d(t, "concat3d", function () {
          return Mi;
        }), n.d(t, "concat4d", function () {
          return Ci;
        }), n.d(t, "split", function () {
          return ki;
        }), n.d(t, "conv1d", function () {
          return pa;
        }), n.d(t, "conv2d", function () {
          return ma;
        }), n.d(t, "conv2dDerFilter", function () {
          return ga;
        }), n.d(t, "depthwiseConv2d", function () {
          return va;
        }), n.d(t, "separableConv2d", function () {
          return ya;
        }), n.d(t, "conv2dTranspose", function () {
          return ba;
        }), n.d(t, "matMul", function () {
          return ua;
        }), n.d(t, "dot", function () {
          return ca;
        }), n.d(t, "outerProduct", function () {
          return da;
        }), n.d(t, "reverse", function () {
          return _a;
        }), n.d(t, "reverse1d", function () {
          return xa;
        }), n.d(t, "reverse2d", function () {
          return wa;
        }), n.d(t, "reverse3d", function () {
          return Sa;
        }), n.d(t, "reverse4d", function () {
          return Aa;
        }), n.d(t, "maxPool", function () {
          return Ma;
        }), n.d(t, "avgPool", function () {
          return Ca;
        }), n.d(t, "pool", function () {
          return ka;
        }), n.d(t, "slice", function () {
          return Pa;
        }), n.d(t, "slice1d", function () {
          return Oa;
        }), n.d(t, "slice2d", function () {
          return Ra;
        }), n.d(t, "slice3d", function () {
          return Ia;
        }), n.d(t, "slice4d", function () {
          return ja;
        }), n.d(t, "abs", function () {
          return bo;
        }), n.d(t, "acos", function () {
          return _o;
        }), n.d(t, "acosh", function () {
          return xo;
        }), n.d(t, "asin", function () {
          return wo;
        }), n.d(t, "asinh", function () {
          return So;
        }), n.d(t, "atan", function () {
          return Ao;
        }), n.d(t, "atanh", function () {
          return Eo;
        }), n.d(t, "ceil", function () {
          return To;
        }), n.d(t, "clipByValue", function () {
          return Mo;
        }), n.d(t, "cos", function () {
          return Co;
        }), n.d(t, "cosh", function () {
          return ko;
        }), n.d(t, "erf", function () {
          return Po;
        }), n.d(t, "exp", function () {
          return Oo;
        }), n.d(t, "expm1", function () {
          return Ro;
        }), n.d(t, "floor", function () {
          return Io;
        }), n.d(t, "log", function () {
          return jo;
        }), n.d(t, "log1p", function () {
          return No;
        }), n.d(t, "logSigmoid", function () {
          return Lo;
        }), n.d(t, "neg", function () {
          return Do;
        }), n.d(t, "reciprocal", function () {
          return Bo;
        }), n.d(t, "round", function () {
          return Fo;
        }), n.d(t, "rsqrt", function () {
          return zo;
        }), n.d(t, "sigmoid", function () {
          return Uo;
        }), n.d(t, "sign", function () {
          return Go;
        }), n.d(t, "sin", function () {
          return Vo;
        }), n.d(t, "sinh", function () {
          return Ho;
        }), n.d(t, "softplus", function () {
          return qo;
        }), n.d(t, "sqrt", function () {
          return Wo;
        }), n.d(t, "square", function () {
          return $o;
        }), n.d(t, "step", function () {
          return Xo;
        }), n.d(t, "tan", function () {
          return Yo;
        }), n.d(t, "tanh", function () {
          return Ko;
        }), n.d(t, "all", function () {
          return La;
        }), n.d(t, "any", function () {
          return Da;
        }), n.d(t, "argMax", function () {
          return Ba;
        }), n.d(t, "argMin", function () {
          return Fa;
        }), n.d(t, "logSumExp", function () {
          return za;
        }), n.d(t, "max", function () {
          return Ua;
        }), n.d(t, "mean", function () {
          return Ga;
        }), n.d(t, "min", function () {
          return Va;
        }), n.d(t, "moments", function () {
          return Ha;
        }), n.d(t, "sum", function () {
          return qa;
        }), n.d(t, "prod", function () {
          return Wa;
        }), n.d(t, "equal", function () {
          return $a;
        }), n.d(t, "equalStrict", function () {
          return Xa;
        }), n.d(t, "greater", function () {
          return Ya;
        }), n.d(t, "greaterEqual", function () {
          return Ka;
        }), n.d(t, "greaterEqualStrict", function () {
          return Za;
        }), n.d(t, "greaterStrict", function () {
          return Qa;
        }), n.d(t, "less", function () {
          return Ja;
        }), n.d(t, "lessEqual", function () {
          return es;
        }), n.d(t, "lessEqualStrict", function () {
          return ts;
        }), n.d(t, "lessStrict", function () {
          return ns;
        }), n.d(t, "notEqual", function () {
          return rs;
        }), n.d(t, "notEqualStrict", function () {
          return is;
        }), n.d(t, "add", function () {
          return os;
        }), n.d(t, "addN", function () {
          return as;
        }), n.d(t, "addStrict", function () {
          return ss;
        }), n.d(t, "atan2", function () {
          return ls;
        }), n.d(t, "div", function () {
          return us;
        }), n.d(t, "divStrict", function () {
          return cs;
        }), n.d(t, "floorDiv", function () {
          return ds;
        }), n.d(t, "maximum", function () {
          return hs;
        }), n.d(t, "maximumStrict", function () {
          return fs;
        }), n.d(t, "minimum", function () {
          return ps;
        }), n.d(t, "minimumStrict", function () {
          return ms;
        }), n.d(t, "mod", function () {
          return gs;
        }), n.d(t, "modStrict", function () {
          return vs;
        }), n.d(t, "mul", function () {
          return ys;
        }), n.d(t, "mulStrict", function () {
          return bs;
        }), n.d(t, "pow", function () {
          return _s;
        }), n.d(t, "powStrict", function () {
          return xs;
        }), n.d(t, "squaredDifference", function () {
          return ws;
        }), n.d(t, "squaredDifferenceStrict", function () {
          return Ss;
        }), n.d(t, "sub", function () {
          return As;
        }), n.d(t, "subStrict", function () {
          return Es;
        }), n.d(t, "elu", function () {
          return Rs;
        }), n.d(t, "leakyRelu", function () {
          return Is;
        }), n.d(t, "prelu", function () {
          return js;
        }), n.d(t, "relu", function () {
          return Ns;
        }), n.d(t, "selu", function () {
          return Ls;
        }), n.d(t, "logicalAnd", function () {
          return Ts;
        }), n.d(t, "logicalNot", function () {
          return Ms;
        }), n.d(t, "logicalOr", function () {
          return Cs;
        }), n.d(t, "logicalXor", function () {
          return ks;
        }), n.d(t, "where", function () {
          return Ps;
        }), n.d(t, "whereAsync", function () {
          return Os;
        }), n.d(t, "buffer", function () {
          return Ui;
        }), n.d(t, "toPixels", function () {
          return zi;
        }), n.d(t, "print", function () {
          return Gi;
        }), n.d(t, "batchToSpaceND", function () {
          return Vi;
        }), n.d(t, "cast", function () {
          return Hi;
        }), n.d(t, "clone", function () {
          return qi;
        }), n.d(t, "cumsum", function () {
          return Wi;
        }), n.d(t, "depthToSpace", function () {
          return $i;
        }), n.d(t, "expandDims", function () {
          return Xi;
        }), n.d(t, "eye", function () {
          return Yi;
        }), n.d(t, "fromPixels", function () {
          return Ki;
        }), n.d(t, "multinomial", function () {
          return Zi;
        }), n.d(t, "oneHot", function () {
          return Qi;
        }), n.d(t, "pad", function () {
          return Ji;
        }), n.d(t, "pad1d", function () {
          return eo;
        }), n.d(t, "pad2d", function () {
          return to;
        }), n.d(t, "pad3d", function () {
          return no;
        }), n.d(t, "pad4d", function () {
          return ro;
        }), n.d(t, "rand", function () {
          return io;
        }), n.d(t, "randomNormal", function () {
          return oo;
        }), n.d(t, "randomUniform", function () {
          return ao;
        }), n.d(t, "reshape", function () {
          return so;
        }), n.d(t, "spaceToBatchND", function () {
          return lo;
        }), n.d(t, "squeeze", function () {
          return uo;
        }), n.d(t, "stack", function () {
          return co;
        }), n.d(t, "tile", function () {
          return ho;
        }), n.d(t, "truncatedNormal", function () {
          return fo;
        }), n.d(t, "unstack", function () {
          return po;
        }), n.d(t, "setdiff1dAsync", function () {
          return mo;
        }), n.d(t, "fill", function () {
          return yt;
        }), n.d(t, "linspace", function () {
          return bt;
        }), n.d(t, "ones", function () {
          return gt;
        }), n.d(t, "range", function () {
          return _t;
        }), n.d(t, "scalar", function () {
          return ut;
        }), n.d(t, "tensor", function () {
          return lt;
        }), n.d(t, "tensor1d", function () {
          return ct;
        }), n.d(t, "tensor2d", function () {
          return dt;
        }), n.d(t, "tensor3d", function () {
          return ht;
        }), n.d(t, "tensor4d", function () {
          return ft;
        }), n.d(t, "tensor5d", function () {
          return pt;
        }), n.d(t, "tensor6d", function () {
          return mt;
        }), n.d(t, "zeros", function () {
          return vt;
        }), n.d(t, "onesLike", function () {
          return Mt;
        }), n.d(t, "zerosLike", function () {
          return Ct;
        }), n.d(t, "transpose", function () {
          return Ds;
        }), n.d(t, "softmax", function () {
          return rt;
        }), n.d(t, "logSoftmax", function () {
          return it;
        }), n.d(t, "localResponseNormalization", function () {
          return Bs;
        }), n.d(t, "norm", function () {
          return Fs;
        }), n.d(t, "gather", function () {
          return Gs;
        }), n.d(t, "unsortedSegmentSum", function () {
          return Vs;
        }), n.d(t, "basicLSTMCell", function () {
          return Hs;
        }), n.d(t, "multiRNNCell", function () {
          return qs;
        }), n.d(t, "movingAverage", function () {
          return Ws;
        }), n.d(t, "stridedSlice", function () {
          return $s;
        }), n.d(t, "topk", function () {
          return Xs;
        }), n.d(t, "scatterND", function () {
          return Ys;
        }), n.d(t, "fft", function () {
          return Ks;
        }), n.d(t, "ifft", function () {
          return Zs;
        }), n.d(t, "rfft", function () {
          return Qs;
        }), n.d(t, "irfft", function () {
          return Js;
        }), n.d(t, "sparseToDense", function () {
          return tl;
        }), n.d(t, "gatherND", function () {
          return rl;
        }), n.d(t, "train", function () {
          return Du;
        }), n.d(t, "tidy", function () {
          return Te;
        }), n.d(t, "keep", function () {
          return Me;
        }), n.d(t, "dispose", function () {
          return Ce;
        }), n.d(t, "time", function () {
          return ke;
        }), n.d(t, "profile", function () {
          return Pe;
        }), n.d(t, "customGrad", function () {
          return Ae;
        }), n.d(t, "grad", function () {
          return be;
        }), n.d(t, "grads", function () {
          return _e;
        }), n.d(t, "valueAndGrad", function () {
          return xe;
        }), n.d(t, "valueAndGrads", function () {
          return we;
        }), n.d(t, "variableGrads", function () {
          return Se;
        });
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        var a = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        };
        function s(e, t) {
          function n() {
            this.constructor = e;
          }
          a(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var l = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        };
        function u(e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        }
        function c(e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        }
        var d = {},
          h = {
            alpha: !1,
            antialias: !1,
            premultipliedAlpha: !1,
            preserveDrawingBuffer: !1,
            depth: !1,
            stencil: !1,
            failIfMajorPerformanceCaveat: !0
          };
        function f(e) {
          e in d || (document.createElement("canvas").addEventListener("webglcontextlost", function (t) {
            t.preventDefault(), delete d[e];
          }, !1), d[e] = function (e) {
            if (1 !== e && 2 !== e) throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");
            var t = document.createElement("canvas");
            return 1 === e ? t.getContext("webgl", h) || t.getContext("experimental-webgl", h) : t.getContext("webgl2", h);
          }(e));
          var t = d[e];
          return t.isContextLost() ? (delete d[e], f(e)) : (t.disable(t.DEPTH_TEST), t.disable(t.STENCIL_TEST), t.disable(t.BLEND), t.disable(t.DITHER), t.disable(t.POLYGON_OFFSET_FILL), t.disable(t.SAMPLE_COVERAGE), t.enable(t.SCISSOR_TEST), t.enable(t.CULL_FACE), t.cullFace(t.BACK), d[e]);
        }
        function p(e) {
          for (var t = e.length, n = 0, r = 0; t > 0;) r = Math.random() * t | 0, n = e[--t], e[t] = e[r], e[r] = n;
        }
        function m(e, t, n) {
          return Math.max(e, Math.min(t, n));
        }
        function g(e) {
          return e % 2 == 0 ? e : e + 1;
        }
        function v(e) {
          for (var t = 0, n = 0; n < e.length; n++) t += e[n];
          return t;
        }
        function y(e, t) {
          var n = Math.random();
          return t * n + (1 - n) * e;
        }
        function b(e, t) {
          if (!e) throw new Error("string" == typeof t ? t : t());
        }
        function _(e, t, n) {
          void 0 === n && (n = ""), b(A(e, t), n + " Shapes " + e + " and " + t + " must match");
        }
        function x(e) {
          b(null != e, "The input to the tensor constructor must be a non-null value.");
        }
        function w(e, t) {
          if (void 0 === t && (t = []), Array.isArray(e)) for (var n = 0; n < e.length; ++n) w(e[n], t);else t.push(e);
          return t;
        }
        function S(e) {
          if (0 === e.length) return 1;
          for (var t = e[0], n = 1; n < e.length; n++) t *= e[n];
          return t;
        }
        function A(e, t) {
          if (e === t) return !0;
          if (null == e || null == t) return !1;
          if (e.length !== t.length) return !1;
          for (var n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
          return !0;
        }
        function E(e) {
          return e % 1 == 0;
        }
        function T(e) {
          if (null != Math.tanh) return Math.tanh(e);
          if (e === 1 / 0) return 1;
          if (e === -1 / 0) return -1;
          var t = Math.exp(2 * e);
          return (t - 1) / (t + 1);
        }
        function M(e) {
          for (var t = Math.floor(Math.sqrt(e)); t > 1; --t) if (e % t == 0) return [t, e / t];
          return [1, e];
        }
        function C(e, t) {
          return t <= e.length ? e : e + " ".repeat(t - e.length);
        }
        function k(e, t, n) {
          return void 0 === t && (t = function t(e) {
            return 0;
          }), new Promise(function (r, i) {
            var o = 0,
              a = function a() {
                if (e()) r();else {
                  var s = t(++o);
                  null != n && o >= n ? i() : setTimeout(a, s);
                }
              };
            a();
          });
        }
        function P(e, t) {
          for (var n = 1, r = -1, i = 0; i < e.length; ++i) if (e[i] >= 0) n *= e[i];else if (-1 === e[i]) {
            if (-1 !== r) throw Error("Shapes can only have 1 implicit size. Found -1 at dim " + r + " and dim " + i);
            r = i;
          } else if (e[i] < 0) throw Error("Shapes can not be < 0. Found " + e[i] + " at dim " + i);
          if (-1 === r) {
            if (t > 0 && t !== n) throw Error("Size(" + t + ") must match the product of shape " + e);
            return e;
          }
          if (0 === n) throw Error("Cannot infer the missing size in [" + e + "] when there are 0 elements");
          if (t % n != 0) throw Error("The implicit shape can't be a fractional number. Got " + t + " / " + n);
          var o = e.slice();
          return o[r] = t / n, o;
        }
        function O(e, t) {
          for (var n = [], r = [], i = 0, o = 0; o < e.length; ++o) {
            if (null != t) {
              if (t[i] === o && 1 !== e[o]) throw new Error("Can't squeeze axis " + o + " since its dim '" + e[o] + "' is not 1");
              (null == t[i] || t[i] > o) && 1 === e[o] && (n.push(e[o]), r.push(o)), t[i] <= o && i++;
            }
            1 !== e[o] && (n.push(e[o]), r.push(o));
          }
          return {
            newShape: n,
            keptDims: r
          };
        }
        function R(e, t) {
          var n = null;
          if (null == e || "float32" === e) n = new Float32Array(t);else if ("int32" === e) n = new Int32Array(t);else {
            if ("bool" !== e) throw new Error("Unknown data type " + e);
            n = new Uint8Array(t);
          }
          return n;
        }
        function I(e, t, n) {
          if ("float32" === t) for (var r = 0; r < e.length; r++) if (isNaN(e[r])) throw Error("The result of the '" + n + "' has NaNs.");
        }
        function j(e, t) {
          if ("float32" !== t) for (var n = 0; n < e.length; n++) if (isNaN(e[n])) throw Error("NaN is not a valid value for dtype: '" + t + "'.");
        }
        function N(e, t) {
          return !("complex64" === t || "float32" === t && "complex64" !== e || "int32" === t && "float32" !== e && "complex64" !== e || "bool" === t && "bool" === e);
        }
        function L(e) {
          return e instanceof Float32Array || e instanceof Int32Array || e instanceof Uint8Array;
        }
        function D(e) {
          if ("float32" === e || "int32" === e) return 4;
          if ("complex64" === e) return 8;
          if ("bool" === e) return 1;
          throw new Error("Unknown dtype " + e);
        }
        function B(e) {
          return !!(e && e.constructor && e.call && e.apply);
        }
        function F(e, t) {
          for (var n = t; n < e; ++n) if (e % n == 0) return n;
          return e;
        }
        function z(e) {
          var t = e.length;
          if (t < 2) return [];
          var n = new Array(t - 1);
          n[t - 2] = e[t - 1];
          for (var r = t - 3; r >= 0; --r) n[r] = n[r + 1] * e[r + 1];
          return n;
        }
        function U(e, t, n) {
          return function (e, t) {
            return e instanceof Float32Array && "float32" === t || e instanceof Int32Array && "int32" === t || e instanceof Uint8Array && "bool" === t;
          }(e, t) ? e : (Array.isArray(e) && (e = w(e)), function (e, t, n) {
            if (null == t || "float32" === t || "complex64" === t) return new Float32Array(e);
            if ("int32" === t) return n && j(e, t), new Int32Array(e);
            if ("bool" === t) {
              for (var r = new Uint8Array(e.length), i = 0; i < r.length; ++i) 0 !== Math.round(e[i]) && (r[i] = 1);
              return r;
            }
            throw new Error("Unknown data type " + t);
          }(e, t, n));
        }
        function G(e, t) {
          for (var n = V(e, t), r = 0; r < n.length; r++) n[r] = 1;
          return n;
        }
        function V(e, t) {
          if (null == t || "float32" === t || "complex64" === t) return new Float32Array(e);
          if ("int32" === t) return new Int32Array(e);
          if ("bool" === t) return new Uint8Array(e);
          throw new Error("Unknown data type " + t);
        }
        function H() {
          if ("undefined" != typeof performance) return performance.now();
          if (void 0 !== e) {
            var t = e.hrtime();
            return 1e3 * t[0] + t[1] / 1e6;
          }
          throw new Error("Cannot measure time in this environment. You should run tf.js in the browser or in Node.js");
        }
        var q = Object.freeze({
            shuffle: p,
            clamp: m,
            nearestLargerEven: g,
            sum: v,
            randUniform: y,
            distSquared: function distSquared(e, t) {
              for (var n = 0, r = 0; r < e.length; r++) {
                var i = Number(e[r]) - Number(t[r]);
                n += i * i;
              }
              return n;
            },
            assert: b,
            assertShapesMatch: _,
            assertNonNull: x,
            flatten: w,
            sizeFromShape: S,
            isScalarShape: function isScalarShape(e) {
              return 0 === e.length;
            },
            arraysEqual: A,
            isInt: E,
            tanh: T,
            sizeToSquarishShape: M,
            createShuffledIndices: function createShuffledIndices(e) {
              for (var t = new Uint32Array(e), n = 0; n < e; ++n) t[n] = n;
              return p(t), t;
            },
            rightPad: C,
            repeatedTry: k,
            inferFromImplicitShape: P,
            squeezeShape: O,
            getTypedArrayFromDType: R,
            checkComputationForNaN: I,
            checkConversionForNaN: j,
            hasEncodingLoss: N,
            isTypedArray: L,
            bytesPerElement: D,
            isFunction: B,
            nearestDivisor: F,
            computeStrides: z,
            toTypedArray: U,
            makeOnesTypedArray: G,
            makeZerosTypedArray: V,
            now: H
          }),
          W = function () {
            function e(e, t) {
              this.backendTimer = e, this.logger = t, null == t && (this.logger = new $());
            }
            return e.prototype.profileKernel = function (e, t) {
              var n,
                r = this,
                i = this.backendTimer.time(function () {
                  n = t();
                });
              return (Array.isArray(n) ? n : [n]).forEach(function (t) {
                var n = t.dataSync();
                I(n, t.dtype, e), i.then(function (i) {
                  var o = "";
                  null != i.getExtraProfileInfo && (o = i.getExtraProfileInfo()), r.logger.logKernelProfile(e, t, n, i.kernelMs, o);
                });
              }), n;
            }, e;
          }(),
          $ = function () {
            function e() {}
            return e.prototype.logKernelProfile = function (e, t, n, r, i) {
              var o = C(r + "ms", 9),
                a = C(e, 25),
                s = t.rank,
                l = t.size,
                u = C(t.shape.toString(), 14);
              console.log("%c" + a + "\t%c" + o + "\t%c" + s + "D " + u + "\t%c" + l + "\t%c" + i, "font-weight:bold", "color:red", "color:blue", "color: orange", "color: green");
            }, e;
          }();
        function X(e, t, n, r) {
          var i = z(t),
            o = function (e, t, n, r) {
              var i = S(t),
                o = r[r.length - 1],
                a = new Array(o).fill(0),
                s = t.length,
                l = "complex64" === n ? K(e) : e;
              if (s > 1) for (var u = 0; u < i / o; u++) for (var c = u * o, d = 0; d < o; d++) a[d] = Math.max(a[d], Y(l[c + d], 0).length);
              return a;
            }(e, t, n, i),
            a = t.length,
            s = function e(t, n, r, i, o, a) {
              void 0 === a && (a = !0);
              var s = "complex64" === r ? 2 : 1,
                l = n[0],
                u = n.length;
              if (0 === u) return "complex64" === r ? [Y(K(t)[0], 0)] : [t[0].toString()];
              if (1 === u) {
                if (l > 20) {
                  var c = 3 * s,
                    d = Array.from(t.subarray(0, c)),
                    h = Array.from(t.subarray(l - 3 * s, l));
                  return "complex64" === r && (d = K(d), h = K(h)), ["[" + d.map(function (e, t) {
                    return Y(e, o[t]);
                  }).join(", ") + ", ..., " + h.map(function (e, t) {
                    return Y(e, o[l - 3 + t]);
                  }).join(", ") + "]"];
                }
                return ["[" + ("complex64" === r ? K(t) : Array.from(t)).map(function (e, t) {
                  return Y(e, o[t]);
                }).join(", ") + "]"];
              }
              var f = n.slice(1),
                p = i.slice(1),
                m = i[0] * s,
                g = [];
              if (l > 20) {
                for (var v = 0; v < 3; v++) {
                  var y = (b = v * m) + m;
                  g.push.apply(g, e(t.subarray(b, y), f, r, p, o, !1));
                }
                for (g.push("..."), v = l - 3; v < l; v++) y = (b = v * m) + m, g.push.apply(g, e(t.subarray(b, y), f, r, p, o, v === l - 1));
              } else for (v = 0; v < l; v++) {
                var b;
                y = (b = v * m) + m, g.push.apply(g, e(t.subarray(b, y), f, r, p, o, v === l - 1));
              }
              var _ = 2 === u ? "," : "";
              for (g[0] = "[" + g[0] + _, v = 1; v < g.length - 1; v++) g[v] = " " + g[v] + _;
              var x = ",\n";
              for (v = 2; v < u; v++) x += "\n";
              return g[g.length - 1] = " " + g[g.length - 1] + "]" + (a ? "" : x), g;
            }(e, t, n, i, o),
            l = ["Tensor"];
          return r && (l.push("  dtype: " + n), l.push("  rank: " + a), l.push("  shape: [" + t + "]"), l.push("  values:")), l.push(s.map(function (e) {
            return "    " + e;
          }).join("\n")), l.join("\n");
        }
        function Y(e, t) {
          return C(Array.isArray(e) ? parseFloat(e[0].toFixed(7)) + " + " + parseFloat(e[1].toFixed(7)) + "j" : parseFloat(e.toFixed(7)).toString(), t);
        }
        function K(e) {
          for (var t = [], n = 0; n < e.length; n += 2) t.push([e[n], e[n + 1]]);
          return t;
        }
        var Z = function () {
            function e(e, t, n) {
              if (this.dtype = t, this.shape = e.slice(), this.size = S(e), null != n) {
                var r = n.length;
                b(r === this.size, "Length of values '" + r + "' does not match the size inferred by the shape '" + this.size + "'.");
              }
              if ("complex64" === t) throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");
              this.values = n || R(t, S(this.shape)), this.strides = z(e);
            }
            return e.prototype.set = function (e) {
              for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
              0 === t.length && (t = [0]), b(t.length === this.rank, "The number of provided coordinates (" + t.length + ") must match the rank (" + this.rank + ")");
              var r = this.locToIndex(t);
              this.values[r] = e;
            }, e.prototype.get = function () {
              for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
              0 === e.length && (e = [0]);
              for (var n = e[e.length - 1], r = 0; r < e.length - 1; ++r) n += this.strides[r] * e[r];
              return this.values[n];
            }, e.prototype.locToIndex = function (e) {
              if (0 === this.rank) return 0;
              if (1 === this.rank) return e[0];
              for (var t = e[e.length - 1], n = 0; n < e.length - 1; ++n) t += this.strides[n] * e[n];
              return t;
            }, e.prototype.indexToLoc = function (e) {
              if (0 === this.rank) return [];
              if (1 === this.rank) return [e];
              for (var t = new Array(this.shape.length), n = 0; n < t.length - 1; ++n) t[n] = Math.floor(e / this.strides[n]), e -= t[n] * this.strides[n];
              return t[t.length - 1] = e, t;
            }, Object.defineProperty(e.prototype, "rank", {
              get: function get() {
                return this.shape.length;
              },
              enumerable: !0,
              configurable: !0
            }), e.prototype.toTensor = function () {
              return te.make(this.shape, {
                values: this.values
              }, this.dtype);
            }, e;
          }(),
          Q = null,
          J = null;
        function ee(e) {
          Q = e;
        }
        var te = function () {
          function e(e, t, n, r) {
            this.isDisposedInternal = !1, this.shape = e.slice(), this.dtype = t || "float32", this.size = S(e), null != n && b(this.size === n.length, "Based on the provided shape, [" + e + "], and dtype " + this.dtype + ", the tensor should have " + this.size + " values but has " + n.length), this.strides = z(e), this.dataId = null != r ? r : {}, this.id = Q().nextTensorId(), this.rankType = this.rank < 5 ? this.rank.toString() : "higher", Q().registerTensor(this), null != n && Q().write(this.dataId, n);
          }
          return e.make = function (t, n, r) {
            return new e(t, r, n.values, n.dataId);
          }, e.prototype.flatten = function () {
            return this.throwIfDisposed(), this.as1D();
          }, e.prototype.asScalar = function () {
            return this.throwIfDisposed(), b(1 === this.size, "The array must have only 1 element."), this.reshape([]);
          }, e.prototype.as1D = function () {
            return this.throwIfDisposed(), this.reshape([this.size]);
          }, e.prototype.as2D = function (e, t) {
            return this.throwIfDisposed(), this.reshape([e, t]);
          }, e.prototype.as3D = function (e, t, n) {
            return this.throwIfDisposed(), this.reshape([e, t, n]);
          }, e.prototype.as4D = function (e, t, n, r) {
            return this.throwIfDisposed(), this.reshape([e, t, n, r]);
          }, e.prototype.asType = function (e) {
            return this.throwIfDisposed(), J.cast(this, e);
          }, Object.defineProperty(e.prototype, "rank", {
            get: function get() {
              return this.shape.length;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.get = function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            b(e.length === this.rank, "Number of coordinates in get() must match the rank of the tensor"), b("complex64" !== this.dtype, "Tensor.get() is not supported for complex64 tensors yet."), this.throwIfDisposed(), 0 === e.length && (e = [0]);
            for (var n = e[e.length - 1], r = 0; r < e.length - 1; ++r) n += this.strides[r] * e[r];
            return this.dataSync()[n];
          }, e.prototype.buffer = function () {
            return J.buffer(this.shape, this.dtype, this.dataSync());
          }, e.prototype.data = function () {
            return u(this, void 0, void 0, function () {
              return c(this, function (e) {
                return this.throwIfDisposed(), [2, Q().read(this.dataId)];
              });
            });
          }, e.prototype.dataSync = function () {
            return this.throwIfDisposed(), Q().readSync(this.dataId);
          }, e.prototype.dispose = function () {
            this.isDisposed || (Q().disposeTensor(this), this.isDisposedInternal = !0);
          }, Object.defineProperty(e.prototype, "isDisposed", {
            get: function get() {
              return this.isDisposedInternal;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.throwIfDisposed = function () {
            if (this.isDisposed) throw new Error("Tensor is disposed.");
          }, e.prototype.toFloat = function () {
            return this.asType("float32");
          }, e.prototype.toInt = function () {
            return this.asType("int32");
          }, e.prototype.toBool = function () {
            return this.asType("bool");
          }, e.prototype.print = function (e) {
            return void 0 === e && (e = !1), J.print(this, e);
          }, e.prototype.reshape = function (e) {
            return this.throwIfDisposed(), J.reshape(this, e);
          }, e.prototype.reshapeAs = function (e) {
            return this.throwIfDisposed(), this.reshape(e.shape);
          }, e.prototype.expandDims = function (e) {
            return void 0 === e && (e = 0), J.expandDims(this, e);
          }, e.prototype.cumsum = function (e, t, n) {
            return void 0 === e && (e = 0), void 0 === t && (t = !1), void 0 === n && (n = !1), J.cumsum(this, e, t, n);
          }, e.prototype.squeeze = function (e) {
            return this.throwIfDisposed(), J.squeeze(this, e);
          }, e.prototype.clone = function () {
            return this.throwIfDisposed(), J.clone(this);
          }, e.prototype.toString = function (e) {
            return void 0 === e && (e = !1), X(this.dataSync(), this.shape, this.dtype, e);
          }, e.prototype.tile = function (e) {
            return this.throwIfDisposed(), J.tile(this, e);
          }, e.prototype.gather = function (e, t) {
            return void 0 === t && (t = 0), this.throwIfDisposed(), J.gather(this, e, t);
          }, e.prototype.matMul = function (e, t, n) {
            return void 0 === t && (t = !1), void 0 === n && (n = !1), this.throwIfDisposed(), J.matMul(this, e, t, n);
          }, e.prototype.dot = function (e) {
            return this.throwIfDisposed(), J.dot(this, e);
          }, e.prototype.norm = function (e, t, n) {
            return void 0 === e && (e = "euclidean"), void 0 === t && (t = null), void 0 === n && (n = !1), this.throwIfDisposed(), J.norm(this, e, t, n);
          }, e.prototype.slice = function (e, t) {
            return this.throwIfDisposed(), J.slice(this, e, t);
          }, e.prototype.reverse = function (e) {
            return this.throwIfDisposed(), J.reverse(this, e);
          }, e.prototype.concat = function (e, t) {
            return void 0 === t && (t = 0), this.throwIfDisposed(), J.concat([this, e], t);
          }, e.prototype.split = function (e, t) {
            return void 0 === t && (t = 0), this.throwIfDisposed(), J.split(this, e, t);
          }, e.prototype.stack = function (e, t) {
            return void 0 === t && (t = 0), J.stack([this, e], t);
          }, e.prototype.unstack = function (e, t) {
            return void 0 === t && (t = 0), J.unstack(this, t);
          }, e.prototype.pad = function (e, t) {
            return void 0 === t && (t = 0), J.pad(this, e, t);
          }, e.prototype.batchNormalization = function (e, t, n, r, i) {
            return void 0 === n && (n = .001), this.throwIfDisposed(), J.batchNormalization(this, e, t, n, r, i);
          }, e.prototype.all = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.all(this, e, t);
          }, e.prototype.any = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.any(this, e, t);
          }, e.prototype.logSumExp = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.logSumExp(this, e, t);
          }, e.prototype.sum = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.sum(this, e, t);
          }, e.prototype.prod = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.prod(this, e, t);
          }, e.prototype.mean = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.mean(this, e, t);
          }, e.prototype.min = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.min(this, e, t);
          }, e.prototype.max = function (e, t) {
            return void 0 === e && (e = null), void 0 === t && (t = !1), this.throwIfDisposed(), J.max(this, e, t);
          }, e.prototype.argMin = function (e) {
            return void 0 === e && (e = null), this.throwIfDisposed(), J.argMin(this, e);
          }, e.prototype.argMax = function (e) {
            return void 0 === e && (e = null), this.throwIfDisposed(), J.argMax(this, e);
          }, e.prototype.cast = function (e) {
            return this.throwIfDisposed(), J.cast(this, e);
          }, e.prototype.add = function (e) {
            return this.throwIfDisposed(), J.add(this, e);
          }, e.prototype.addStrict = function (e) {
            return this.throwIfDisposed(), J.addStrict(this, e);
          }, e.prototype.atan2 = function (e) {
            return this.throwIfDisposed(), J.atan2(this, e);
          }, e.prototype.sub = function (e) {
            return this.throwIfDisposed(), J.sub(this, e);
          }, e.prototype.subStrict = function (e) {
            return this.throwIfDisposed(), J.subStrict(this, e);
          }, e.prototype.pow = function (e) {
            return this.throwIfDisposed(), J.pow(this, e);
          }, e.prototype.powStrict = function (e) {
            return this.throwIfDisposed(), J.powStrict(this, e);
          }, e.prototype.mul = function (e) {
            return this.throwIfDisposed(), J.mul(this, e);
          }, e.prototype.mulStrict = function (e) {
            return this.throwIfDisposed(), J.mulStrict(this, e);
          }, e.prototype.div = function (e) {
            return this.throwIfDisposed(), J.div(this, e);
          }, e.prototype.floorDiv = function (e) {
            return this.throwIfDisposed(), J.floorDiv(this, e);
          }, e.prototype.divStrict = function (e) {
            return this.throwIfDisposed(), J.divStrict(this, e);
          }, e.prototype.minimum = function (e) {
            return this.throwIfDisposed(), J.minimum(this, e);
          }, e.prototype.minimumStrict = function (e) {
            return this.throwIfDisposed(), J.minimumStrict(this, e);
          }, e.prototype.maximum = function (e) {
            return this.throwIfDisposed(), J.maximum(this, e);
          }, e.prototype.maximumStrict = function (e) {
            return this.throwIfDisposed(), J.maximumStrict(this, e);
          }, e.prototype.mod = function (e) {
            return this.throwIfDisposed(), J.mod(this, e);
          }, e.prototype.modStrict = function (e) {
            return this.throwIfDisposed(), J.modStrict(this, e);
          }, e.prototype.squaredDifference = function (e) {
            return this.throwIfDisposed(), J.squaredDifference(this, e);
          }, e.prototype.squaredDifferenceStrict = function (e) {
            return this.throwIfDisposed(), J.squaredDifferenceStrict(this, e);
          }, e.prototype.transpose = function (e) {
            return this.throwIfDisposed(), J.transpose(this, e);
          }, e.prototype.notEqual = function (e) {
            return this.throwIfDisposed(), J.notEqual(this, e);
          }, e.prototype.notEqualStrict = function (e) {
            return this.throwIfDisposed(), J.notEqualStrict(this, e);
          }, e.prototype.less = function (e) {
            return this.throwIfDisposed(), J.less(this, e);
          }, e.prototype.lessStrict = function (e) {
            return this.throwIfDisposed(), J.lessStrict(this, e);
          }, e.prototype.equal = function (e) {
            return this.throwIfDisposed(), J.equal(this, e);
          }, e.prototype.equalStrict = function (e) {
            return this.throwIfDisposed(), J.equalStrict(this, e);
          }, e.prototype.lessEqual = function (e) {
            return this.throwIfDisposed(), J.lessEqual(this, e);
          }, e.prototype.lessEqualStrict = function (e) {
            return this.throwIfDisposed(), J.lessEqualStrict(this, e);
          }, e.prototype.greater = function (e) {
            return this.throwIfDisposed(), J.greater(this, e);
          }, e.prototype.greaterStrict = function (e) {
            return this.throwIfDisposed(), J.greaterStrict(this, e);
          }, e.prototype.greaterEqual = function (e) {
            return this.throwIfDisposed(), J.greaterEqual(this, e);
          }, e.prototype.greaterEqualStrict = function (e) {
            return this.throwIfDisposed(), J.greaterEqualStrict(this, e);
          }, e.prototype.logicalAnd = function (e) {
            return this.throwIfDisposed(), J.logicalAnd(this, e);
          }, e.prototype.logicalOr = function (e) {
            return this.throwIfDisposed(), J.logicalOr(this, e);
          }, e.prototype.logicalNot = function () {
            return this.throwIfDisposed(), J.logicalNot(this);
          }, e.prototype.logicalXor = function (e) {
            return this.throwIfDisposed(), J.logicalXor(this, e);
          }, e.prototype.where = function (e, t) {
            return this.throwIfDisposed(), J.where(e, this, t);
          }, e.prototype.neg = function () {
            return this.throwIfDisposed(), J.neg(this);
          }, e.prototype.ceil = function () {
            return this.throwIfDisposed(), J.ceil(this);
          }, e.prototype.floor = function () {
            return this.throwIfDisposed(), J.floor(this);
          }, e.prototype.sign = function () {
            return this.throwIfDisposed(), J.sign(this);
          }, e.prototype.exp = function () {
            return this.throwIfDisposed(), J.exp(this);
          }, e.prototype.expm1 = function () {
            return this.throwIfDisposed(), J.expm1(this);
          }, e.prototype.log = function () {
            return this.throwIfDisposed(), J.log(this);
          }, e.prototype.log1p = function () {
            return this.throwIfDisposed(), J.log1p(this);
          }, e.prototype.sqrt = function () {
            return this.throwIfDisposed(), J.sqrt(this);
          }, e.prototype.rsqrt = function () {
            return this.throwIfDisposed(), J.rsqrt(this);
          }, e.prototype.square = function () {
            return this.throwIfDisposed(), J.square(this);
          }, e.prototype.reciprocal = function () {
            return this.throwIfDisposed(), J.reciprocal(this);
          }, e.prototype.abs = function () {
            return this.throwIfDisposed(), J.abs(this);
          }, e.prototype.clipByValue = function (e, t) {
            return this.throwIfDisposed(), J.clipByValue(this, e, t);
          }, e.prototype.relu = function () {
            return this.throwIfDisposed(), J.relu(this);
          }, e.prototype.elu = function () {
            return this.throwIfDisposed(), J.elu(this);
          }, e.prototype.selu = function () {
            return this.throwIfDisposed(), J.selu(this);
          }, e.prototype.leakyRelu = function (e) {
            return void 0 === e && (e = .2), this.throwIfDisposed(), J.leakyRelu(this, e);
          }, e.prototype.prelu = function (e) {
            return this.throwIfDisposed(), J.prelu(this, e);
          }, e.prototype.sigmoid = function () {
            return this.throwIfDisposed(), J.sigmoid(this);
          }, e.prototype.logSigmoid = function () {
            return this.throwIfDisposed(), J.logSigmoid(this);
          }, e.prototype.softplus = function () {
            return this.throwIfDisposed(), J.softplus(this);
          }, e.prototype.zerosLike = function () {
            return this.throwIfDisposed(), J.zerosLike(this);
          }, e.prototype.onesLike = function () {
            return this.throwIfDisposed(), J.onesLike(this);
          }, e.prototype.sin = function () {
            return this.throwIfDisposed(), J.sin(this);
          }, e.prototype.cos = function () {
            return this.throwIfDisposed(), J.cos(this);
          }, e.prototype.tan = function () {
            return this.throwIfDisposed(), J.tan(this);
          }, e.prototype.asin = function () {
            return this.throwIfDisposed(), J.asin(this);
          }, e.prototype.acos = function () {
            return this.throwIfDisposed(), J.acos(this);
          }, e.prototype.atan = function () {
            return this.throwIfDisposed(), J.atan(this);
          }, e.prototype.sinh = function () {
            return this.throwIfDisposed(), J.sinh(this);
          }, e.prototype.cosh = function () {
            return this.throwIfDisposed(), J.cosh(this);
          }, e.prototype.tanh = function () {
            return this.throwIfDisposed(), J.tanh(this);
          }, e.prototype.asinh = function () {
            return this.throwIfDisposed(), J.asinh(this);
          }, e.prototype.acosh = function () {
            return this.throwIfDisposed(), J.acosh(this);
          }, e.prototype.atanh = function () {
            return this.throwIfDisposed(), J.atanh(this);
          }, e.prototype.erf = function () {
            return this.throwIfDisposed(), J.erf(this);
          }, e.prototype.round = function () {
            return this.throwIfDisposed(), J.round(this);
          }, e.prototype.step = function (e) {
            return void 0 === e && (e = 0), this.throwIfDisposed(), J.step(this, e);
          }, e.prototype.softmax = function (e) {
            return void 0 === e && (e = -1), this.throwIfDisposed(), J.softmax(this, e);
          }, e.prototype.logSoftmax = function (e) {
            return void 0 === e && (e = -1), this.throwIfDisposed(), J.logSoftmax(this, e);
          }, e.prototype.resizeBilinear = function (e, t) {
            return void 0 === t && (t = !1), this.throwIfDisposed(), J.image.resizeBilinear(this, e, t);
          }, e.prototype.resizeNearestNeighbor = function (e, t) {
            return void 0 === t && (t = !1), this.throwIfDisposed(), J.image.resizeNearestNeighbor(this, e, t);
          }, e.prototype.conv1d = function (e, t, n, r, i, o) {
            return void 0 === r && (r = "NWC"), void 0 === i && (i = 1), this.throwIfDisposed(), J.conv1d(this, e, t, n, r, i, o);
          }, e.prototype.conv2d = function (e, t, n, r, i, o) {
            return void 0 === r && (r = "NHWC"), void 0 === i && (i = [1, 1]), this.throwIfDisposed(), J.conv2d(this, e, t, n, r, i, o);
          }, e.prototype.conv2dTranspose = function (e, t, n, r, i) {
            return this.throwIfDisposed(), J.conv2dTranspose(this, e, t, n, r, i);
          }, e.prototype.depthwiseConv2D = function (e, t, n, r, i, o) {
            return void 0 === r && (r = "NHWC"), void 0 === i && (i = [1, 1]), this.throwIfDisposed(), J.depthwiseConv2d(this, e, t, n, r, i, o);
          }, e.prototype.separableConv2d = function (e, t, n, r, i, o) {
            return void 0 === i && (i = [1, 1]), void 0 === o && (o = "NHWC"), this.throwIfDisposed(), J.separableConv2d(this, e, t, n, r, i, o);
          }, e.prototype.avgPool = function (e, t, n, r) {
            return this.throwIfDisposed(), J.avgPool(this, e, t, n, r);
          }, e.prototype.maxPool = function (e, t, n, r) {
            return this.throwIfDisposed(), J.maxPool(this, e, t, n, r);
          }, e.prototype.localResponseNormalization = function (e, t, n, r) {
            return void 0 === e && (e = 5), void 0 === t && (t = 1), void 0 === n && (n = 1), void 0 === r && (r = .5), J.localResponseNormalization(this, e, t, n, r);
          }, e.prototype.pool = function (e, t, n, r, i) {
            return this.throwIfDisposed(), J.pool(this, e, t, n, r, i);
          }, e.prototype.variable = function (e, t, n) {
            return void 0 === e && (e = !0), this.throwIfDisposed(), ne.variable(this, e, t, n);
          }, e.prototype.unsortedSegmentSum = function (e, t) {
            return this.throwIfDisposed(), J.unsortedSegmentSum(this, e, t);
          }, e.prototype.batchToSpaceND = function (e, t) {
            return this.throwIfDisposed(), J.batchToSpaceND(this, e, t);
          }, e.prototype.spaceToBatchND = function (e, t) {
            return this.throwIfDisposed(), J.spaceToBatchND(this, e, t);
          }, e.prototype.topk = function (e, t) {
            return void 0 === e && (e = 1), void 0 === t && (t = !0), this.throwIfDisposed(), J.topk(this, e, t);
          }, e.prototype.stridedSlice = function (e, t, n, r, i) {
            return void 0 === r && (r = 0), void 0 === i && (i = 0), this.throwIfDisposed(), J.stridedSlice(this, e, t, n, r, i);
          }, e.prototype.depthToSpace = function (e, t) {
            return this.throwIfDisposed(), J.depthToSpace(this, e, t);
          }, e.prototype.fft = function () {
            return this.throwIfDisposed(), J.spectral.fft(this);
          }, e.prototype.ifft = function () {
            return this.throwIfDisposed(), J.spectral.ifft(this);
          }, e;
        }();
        Object.defineProperty(te, Symbol.hasInstance, {
          value: function value(e) {
            return !!e && null != e.shape && null != e.dtype;
          }
        });
        var ne = function (e) {
          function t(t, n, r) {
            void 0 === n && (n = !0);
            var i = e.call(this, t.shape, t.dtype, null, t.dataId) || this;
            i.trainable = n, i.name = r, null == i.name && (i.name = Q().nextVariableId().toString());
            try {
              Q().registerVariable(i);
            } catch (e) {
              throw Q().disposeTensor(i), e;
            }
            return i;
          }
          return s(t, e), t.variable = function (e, n, r, i) {
            return void 0 === n && (n = !0), null != i && i !== e.dtype && (e = e.asType(i)), new t(e, n, r);
          }, t.prototype.assign = function (e) {
            if (e.dtype !== this.dtype) throw new Error("dtype of the new value (" + e.dtype + ") and previous value (" + this.dtype + ") must match");
            if (!A(e.shape, this.shape)) throw new Error("shape of the new value (" + e.shape + ") and previous value (" + this.shape + ") must match");
            Q().disposeTensor(this), this.dataId = e.dataId, Q().registerTensor(this);
          }, t;
        }(te);
        Object.defineProperty(ne, Symbol.hasInstance, {
          value: function value(e) {
            return e instanceof te && null != e.assign && e.assign instanceof Function;
          }
        });
        var re = ne.variable;
        function ie(e, t) {
          b(e.dtype === t.dtype, "The dtypes of the first(" + e.dtype + ") and second(" + t.dtype + ") input must match");
        }
        function oe(e) {
          var t = [];
          return function e(t, n, r) {
            if (null != t) if (t instanceof te) n.push(t);else if (function (e) {
              return Array.isArray(e) || "object" == typeof e;
            }(t)) {
              var i = t;
              for (var o in i) {
                var a = i[o];
                r.has(a) || (r.add(a), e(a, n, r));
              }
            }
          }(e, t, new Set()), t;
        }
        var ae,
          se,
          le = function () {
            function e(e, t, n) {
              this.backend = e, this.safeMode = t, this.debugMode = n, this.registeredVariables = {}, this.nextTapeNodeId = 0, this.numBytes = 0, this.numTensors = 0, this.numDataBuffers = 0, this.profiling = !1, this.gradientScopeCount = 0, this.customGradientDepth = 0, this.keepTensors = new Set(), this.tensorInfo = new WeakMap(), this.activeScope = {
                track: [],
                name: "default scope"
              }, this.scopeStack = [this.activeScope], this.profiler = new W(e), this.activeProfile = {
                newBytes: 0,
                newTensors: 0,
                peakBytes: 0,
                kernels: [],
                result: null
              };
            }
            return e.prototype.moveData = function (e) {
              this.write(e, this.readSync(e));
            }, e.prototype.tidy = function (e, t, n) {
              var r = this;
              void 0 === n && (n = !1);
              var i,
                o = null;
              if (null == t) {
                if ("function" != typeof e) throw new Error("Please provide a function to tidy()");
                t = e;
              } else {
                if ("string" != typeof e && !(e instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
                if ("function" != typeof t) throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
                o = e;
              }
              return this.scopedRun(function () {
                return r.startScope(o, n);
              }, function () {
                return r.endScope(i, n);
              }, function () {
                return (i = t()) instanceof Promise && console.error("Cannot return a Promise inside of tidy."), i;
              });
            }, e.prototype.scopedRun = function (e, t, n) {
              e();
              try {
                var r = n();
                return t(), r;
              } catch (e) {
                throw t(), e;
              }
            }, e.prototype.nextTensorId = function () {
              return e.nextTensorId++;
            }, e.prototype.nextVariableId = function () {
              return e.nextVariableId++;
            }, e.prototype.runKernel = function (e, t, n) {
              var r,
                i = this,
                o = [],
                a = function a(e) {
                  return o.push(e), e;
                },
                s = this.activeScope.name,
                l = this.numBytes,
                u = this.numTensors;
              if (this.scopedRun(function () {
                return i.customGradientDepth++;
              }, function () {
                return i.customGradientDepth--;
              }, function () {
                r = i.debugMode() ? i.profiler.profileKernel(s, function () {
                  return e(i.backend, a);
                }) : e(i.backend, a);
              }), this.shouldRecord()) {
                var c = {
                  id: this.nextTapeNodeId++,
                  name: s,
                  inputs: t,
                  outputs: Array.isArray(r) ? r : [r]
                };
                null != n && (c.gradient = function (e) {
                  return n(e, o);
                }), this.activeTape.push(c);
              }
              return this.profiling && this.activeProfile.kernels.push({
                name: s,
                bytesAdded: this.numBytes - l,
                totalBytesSnapshot: this.numBytes,
                tensorsAdded: this.numTensors - u,
                totalTensorsSnapshot: this.numTensors,
                inputShapes: Object.keys(t).map(function (e) {
                  return t[e].shape;
                }),
                outputShape: Array.isArray(r) ? r.map(function (e) {
                  return e.shape;
                }) : r.shape
              }), r;
            }, e.prototype.registerTensor = function (e) {
              var t = this.tensorInfo.has(e.dataId) ? this.tensorInfo.get(e.dataId).refCount : 0;
              this.numTensors++, 0 === t && (this.numDataBuffers++, "complex64" !== e.dtype && (this.numBytes += S(e.shape) * D(e.dtype)), this.tensorInfo.set(e.dataId, {
                backend: this.backend,
                dtype: e.dtype,
                shape: e.shape,
                refCount: 0
              }), this.backend.register(e.dataId, e.shape, e.dtype)), this.tensorInfo.get(e.dataId).refCount++, e instanceof ne || this.track(e);
            }, e.prototype.registerVariable = function (e) {
              if (null != this.registeredVariables[e.name]) throw new Error("Variable with name " + e.name + " was already registered");
              this.registeredVariables[e.name] = e;
            }, e.prototype.disposeTensor = function (e) {
              this.tensorInfo.has(e.dataId) && (this.keepTensors.has(e.id) && this.keepTensors.delete(e.id), this.numTensors--, this.tensorInfo.get(e.dataId).refCount <= 1 ? (this.tensorInfo.get(e.dataId).backend.disposeData(e.dataId), this.numDataBuffers--, "complex64" !== e.dtype && (this.numBytes -= S(e.shape) * D(e.dtype)), this.tensorInfo.delete(e.dataId)) : this.tensorInfo.get(e.dataId).refCount--);
            }, e.prototype.disposeVariables = function () {
              for (var e in this.registeredVariables) {
                var t = this.registeredVariables[e];
                this.disposeTensor(t), delete this.registeredVariables[e];
              }
            }, e.prototype.memory = function () {
              var e = this.backend.memory();
              return e.numTensors = this.numTensors, e.numDataBuffers = this.numDataBuffers, e.numBytes = this.numBytes, e;
            }, e.prototype.profile = function (e) {
              return u(this, void 0, void 0, function () {
                var t, n;
                return c(this, function (r) {
                  return this.profiling = !0, t = this.numBytes, n = this.numTensors, this.activeProfile.kernels = [], this.activeProfile.result = e(), this.profiling = !1, this.activeProfile.peakBytes = Math.max.apply(Math, this.activeProfile.kernels.map(function (e) {
                    return e.totalBytesSnapshot;
                  })), this.activeProfile.newBytes = this.numBytes - t, this.activeProfile.newTensors = this.numTensors - n, [2, this.activeProfile];
                });
              });
            }, e.prototype.shouldRecord = function () {
              return null != this.activeTape && 0 === this.customGradientDepth;
            }, e.prototype.addTapeNode = function (e, t, n) {
              var r = {};
              e.forEach(function (e, t) {
                r[t] = e;
              });
              var i = {
                id: this.nextTapeNodeId++,
                name: this.activeScope.name,
                inputs: r,
                outputs: [t],
                gradient: function gradient(e) {
                  var t = {};
                  return n(e).forEach(function (e, n) {
                    t[n] = function () {
                      return e;
                    };
                  }), t;
                }
              };
              this.activeTape.push(i);
            }, e.prototype.keep = function (e) {
              if (1 === this.scopeStack.length && this.safeMode) throw new Error("Safe mode is ON. Enclose all tensor operations inside tf.tidy(): tf.tidy(() => {...}) to avoid memory leaks.");
              return this.keepTensors.add(e.id), e;
            }, e.prototype.startScope = function (e, t) {
              void 0 === t && (t = !1), t && 0 === this.gradientScopeCount && (this.activeTape = []), t && this.gradientScopeCount++;
              var n = {
                track: [],
                name: "unnamed scope"
              };
              e && (n.name = e), this.scopeStack.push(n), this.activeScope = n;
            }, e.prototype.endScope = function (e, t) {
              var n = this;
              void 0 === t && (t = !1), t && (this.gradientScopeCount--, 0 === this.gradientScopeCount && (this.activeTape = null));
              var r = new Set(this.keepTensors),
                i = oe(e);
              i.forEach(function (e) {
                return r.add(e.id);
              });
              for (var o = 0; o < this.activeScope.track.length; o++) {
                var a = this.activeScope.track[o];
                r.has(a.id) || (null != this.activeTape ? i.push(a) : a.dispose());
              }
              var s = this.scopeStack.pop();
              this.activeScope = 0 === this.scopeStack.length ? {
                track: [],
                name: "default scope"
              } : this.scopeStack[this.scopeStack.length - 1], i.forEach(function (e) {
                !n.keepTensors.has(e.id) && function (e, t) {
                  for (var n = 0; n < t.length; n++) if (t[n].id === e.id) return !0;
                  return !1;
                }(e, s.track) && n.track(e);
              });
            }, e.prototype.gradients = function (e, t, n, r) {
              var i = this;
              return void 0 === r && (r = !1), b(t.length > 0, "gradients() received an empty list of xs."), this.tidy("gradients", function () {
                var o = e();
                b(o instanceof te, "The result y returned by f() must be a tensor.");
                var a = function (e, t, n) {
                  for (var r = {}, i = {}, o = 0; o < t.length; o++) r[t[o].id] = !0;
                  for (o = 0; o < e.length; o++) {
                    var a = (p = e[o]).inputs;
                    for (var s in a) {
                      for (var l = a[s], u = !1, c = 0; c < t.length; c++) if (r[l.id]) {
                        p.outputs.forEach(function (e) {
                          return r[e.id] = !0;
                        }), u = !0, i[p.id] = !0;
                        break;
                      }
                      if (u) break;
                    }
                  }
                  var d = {};
                  d[n.id] = !0;
                  var h = {};
                  for (o = e.length - 1; o >= 0; o--) for (a = (p = e[o]).inputs, c = 0; c < p.outputs.length; c++) if (d[p.outputs[c].id]) {
                    for (var s in a) d[a[s].id] = !0, h[p.id] = !0;
                    break;
                  }
                  var f = [];
                  for (o = 0; o < e.length; o++) {
                    var p;
                    if (i[(p = e[o]).id] && h[p.id]) {
                      var m = {};
                      for (var s in p.inputs) {
                        var g = p.inputs[s];
                        r[g.id] && (m[s] = g);
                      }
                      var v = Object.assign({}, p);
                      v.inputs = m, v.outputs = p.outputs, f.push(v);
                    }
                  }
                  return f;
                }(i.activeTape, t, o);
                if (!r && 0 === a.length && t.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
                var s = {};
                return s[o.id] = null == n ? function (e) {
                  var t = G(S(e), "float32");
                  return te.make(e, {
                    values: t
                  });
                }(o.shape) : n, function (e, t) {
                  for (var n = function n(_n2) {
                      var r = t[_n2],
                        i = [];
                      if (r.outputs.forEach(function (t) {
                        var n = e[t.id];
                        if (null != n) i.push(n);else {
                          var r = te.make(t.shape, {
                            values: V(t.size, t.dtype)
                          }, t.dtype);
                          i.push(r);
                        }
                      }), null == r.gradient) throw new Error("Cannot compute gradient: gradient function not found for " + r.name + ".");
                      var o = r.gradient(1 === r.outputs.length ? i[0] : i);
                      for (var a in r.inputs) {
                        if (!(a in o)) throw new Error("Cannot backprop through input " + a + ". Available gradients found: " + Object.keys(o) + ".");
                        var s = o[a](),
                          l = r.inputs[a];
                        if (!A(s.shape, l.shape)) throw new Error("Error in gradient for op " + r.name + ". The gradient of input '" + a + "' has shape '" + s.shape + "', which does not match the shape of the input '" + l.shape + "'");
                        if (null == e[l.id]) e[l.id] = s;else {
                          var u = e[l.id];
                          e[l.id] = u.add(s), u.dispose();
                        }
                      }
                    }, r = t.length - 1; r >= 0; r--) n(r);
                }(s, a), {
                  value: o,
                  grads: t.map(function (e) {
                    return s[e.id];
                  })
                };
              }, !0);
            }, e.prototype.customGrad = function (e) {
              var t = this;
              return b(B(e), "The f passed in customGrad(f) must be a function."), function () {
                for (var n, r, i = [], o = 0; o < arguments.length; o++) i[o] = arguments[o];
                return b(i.every(function (e) {
                  return e instanceof te;
                }), "The args passed in customGrad(f)(x1, x2,...) must all be tensors"), t.scopedRun(function () {
                  return t.customGradientDepth++;
                }, function () {
                  return t.customGradientDepth--;
                }, function () {
                  r = t.tidy(e.name, function () {
                    var t = e.apply(void 0, i),
                      r = t.value,
                      o = t.gradFunc;
                    return b(r instanceof te, "The function f passed in customGrad(f) must return an object where `obj.value` is a tensor"), b(B(o), "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function."), n = o, r;
                  }, !0);
                }), t.shouldRecord() && t.addTapeNode(i, r, function (e) {
                  var t = n(e),
                    r = Array.isArray(t) ? t : [t];
                  return b(r.length === i.length, "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...)."), b(r.every(function (e) {
                    return e instanceof te;
                  }), "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors."), r;
                }), r;
              };
            }, e.prototype.write = function (e, t) {
              var n = this.tensorInfo.get(e);
              this.backend !== n.backend && (n.backend.disposeData(e), n.backend = this.backend, this.backend.register(e, n.shape, n.dtype)), this.backend.write(e, t);
            }, e.prototype.readSync = function (e) {
              return this.tensorInfo.get(e).backend.readSync(e);
            }, e.prototype.read = function (e) {
              return this.tensorInfo.get(e).backend.read(e);
            }, e.prototype.fromPixels = function (e, t) {
              return this.backend.fromPixels(e, t);
            }, e.prototype.time = function (e) {
              return u(this, void 0, void 0, function () {
                var t, n;
                return c(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return t = H(), [4, this.backend.time(e)];
                    case 1:
                      return (n = r.sent()).wallMs = H() - t, [2, n];
                  }
                });
              });
            }, e.prototype.track = function (e) {
              if (1 === this.scopeStack.length && this.safeMode) throw new Error("Safe mode is ON. Enclose all tensor operations inside tf.tidy(): tf.tidy(() => {op();...}); to avoid memory leaks.");
              return this.activeScope.track.push(e), e;
            }, e.nextTensorId = 0, e.nextVariableId = 0, e;
          }();
        (se = ae || (ae = {}))[se.NUMBER = 0] = "NUMBER", se[se.BOOLEAN = 1] = "BOOLEAN", se[se.STRING = 2] = "STRING";
        var ue,
          ce = [{
            name: "DEBUG",
            type: ae.BOOLEAN
          }, {
            name: "IS_BROWSER",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_LAZILY_UNPACK",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_CPU_FORWARD",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_PACK_BATCHNORMALIZATION",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_CONV_IM2COL",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_MAX_TEXTURE_SIZE",
            type: ae.NUMBER
          }, {
            name: "WEBGL_PAGING_ENABLED",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION",
            type: ae.NUMBER
          }, {
            name: "WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_VERSION",
            type: ae.NUMBER
          }, {
            name: "WEBGL_RENDER_FLOAT32_ENABLED",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_DOWNLOAD_FLOAT_ENABLED",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_FENCE_API_ENABLED",
            type: ae.BOOLEAN
          }, {
            name: "WEBGL_SIZE_UPLOAD_UNIFORM",
            type: ae.NUMBER
          }, {
            name: "BACKEND",
            type: ae.STRING
          }, {
            name: "EPSILON",
            type: ae.NUMBER
          }, {
            name: "PROD",
            type: ae.BOOLEAN
          }, {
            name: "TENSORLIKE_CHECK_SHAPE_CONSISTENCY",
            type: ae.BOOLEAN
          }];
        function de(e) {
          try {
            if (null != f(e)) return !0;
          } catch (e) {
            return !1;
          }
          return !1;
        }
        function he() {
          var e = {};
          if ("undefined" == typeof window || void 0 === window.location || void 0 === window.location.search) return e;
          var t = function (e) {
            var t = {};
            return e.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, function (e) {
              for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
              return me(t, n[0], n[1]), n.join("=");
            }), t;
          }(window.location.search);
          if ("tfjsflags" in t) {
            var n = {};
            t.tfjsflags.split(",").forEach(function (e) {
              var t = e.split(":"),
                r = t[0],
                i = t[1];
              n[r] = i;
            }), ce.forEach(function (t) {
              t.name in n && (console.log("Setting feature override from URL " + t.name + ": " + n[t.name]), t.type === ae.NUMBER ? e[t.name] = +n[t.name] : t.type === ae.BOOLEAN ? e[t.name] = "true" === n[t.name] : t.type === ae.STRING ? e[t.name] = n[t.name] : console.warn("Unknown URL param: " + t.name + "."));
            });
          }
          return e;
        }
        function fe(e, t) {
          return null != e.getExtension(t);
        }
        function pe(e, t) {
          var n = e.createFramebuffer(),
            r = e.createTexture();
          e.bindTexture(e.TEXTURE_2D, r);
          var i = 2 === t ? e.RGBA32F : e.RGBA;
          e.texImage2D(e.TEXTURE_2D, 0, i, 1, 1, 0, e.RGBA, e.FLOAT, null), e.bindFramebuffer(e.FRAMEBUFFER, n), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, r, 0);
          var o = e.checkFramebufferStatus(e.FRAMEBUFFER) === e.FRAMEBUFFER_COMPLETE;
          return e.bindTexture(e.TEXTURE_2D, null), e.bindFramebuffer(e.FRAMEBUFFER, null), e.deleteTexture(r), e.deleteFramebuffer(n), o;
        }
        function me(e, t, n) {
          e[decodeURIComponent(t)] = decodeURIComponent(n || "");
        }
        var ge = function () {
          function t(e) {
            this.features = {}, this.registry = {}, null != e && (this.features = e), this.get("DEBUG") && console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
          }
          return t.setBackend = function (e, t) {
            if (void 0 === t && (t = !1), !(e in ve.registry)) throw new Error("Backend name '" + e + "' not found in registry");
            ve.engine.backend = ve.findBackend(e), ve.backendName = e;
          }, t.getBackend = function () {
            return ve.initEngine(), ve.backendName;
          }, t.disposeVariables = function () {
            ve.engine.disposeVariables();
          }, t.memory = function () {
            return ve.engine.memory();
          }, t.profile = function (e) {
            return ve.engine.profile(e);
          }, t.tidy = function (e, t, n) {
            return void 0 === n && (n = !1), ve.engine.tidy(e, t, n);
          }, t.dispose = function (e) {
            oe(e).forEach(function (e) {
              return e.dispose();
            });
          }, t.keep = function (e) {
            return ve.engine.keep(e);
          }, t.time = function (e) {
            return ve.engine.time(e);
          }, t.prototype.get = function (e) {
            return e in this.features || (this.features[e] = this.evaluateFeature(e)), this.features[e];
          }, t.prototype.getFeatures = function () {
            return this.features;
          }, t.prototype.set = function (e, t) {
            this.features[e] = t;
          }, t.prototype.getBestBackendName = function () {
            var e = this;
            if (0 === Object.keys(this.registry).length) throw new Error("No backend found in registry.");
            return Object.keys(this.registry).map(function (t) {
              return {
                name: t,
                entry: e.registry[t]
              };
            }).sort(function (e, t) {
              return t.entry.priority - e.entry.priority;
            })[0].name;
          }, t.prototype.evaluateFeature = function (t) {
            if ("DEBUG" === t) return !1;
            if ("IS_BROWSER" === t) return "undefined" != typeof window;
            if ("IS_NODE" === t) return void 0 !== e && void 0 !== e.versions && void 0 !== e.versions.node;
            if ("IS_CHROME" === t) return "undefined" != typeof navigator && null != navigator && null != navigator.userAgent && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            if ("WEBGL_CPU_FORWARD" === t) return !0;
            if ("WEBGL_PACK_BATCHNORMALIZATION" === t) return !1;
            if ("WEBGL_LAZILY_UNPACK" === t) return !1;
            if ("WEBGL_CONV_IM2COL" === t) return !1;
            if ("WEBGL_PAGING_ENABLED" === t) return this.get("IS_BROWSER") && !this.get("PROD");
            if ("WEBGL_MAX_TEXTURE_SIZE" === t) return function (e) {
              if (null == ue) {
                var t = f(e);
                ue = t.getParameter(t.MAX_TEXTURE_SIZE);
              }
              return ue;
            }(this.get("WEBGL_VERSION"));
            if ("IS_TEST" === t) return !1;
            if ("BACKEND" === t) return this.getBestBackendName();
            if ("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION" === t) {
              var n = this.get("WEBGL_VERSION");
              return 0 === n ? 0 : function (e) {
                if (0 === e) return 0;
                var t = f(e);
                return fe(t, "EXT_disjoint_timer_query_webgl2") && 2 === e ? 2 : fe(t, "EXT_disjoint_timer_query") ? 1 : 0;
              }(n);
            }
            if ("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE" === t) return this.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 && !function () {
              var e = navigator.userAgent || navigator.vendor || window.opera;
              return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
            }();
            if ("HAS_WEBGL" === t) return this.get("WEBGL_VERSION") > 0;
            if ("WEBGL_VERSION" === t) return de(2) ? 2 : de(1) ? 1 : 0;
            if ("WEBGL_RENDER_FLOAT32_ENABLED" === t) return function (e) {
              if (0 === e) return !1;
              var t = f(e);
              if (1 === e) {
                if (!fe(t, "OES_texture_float")) return !1;
              } else if (!fe(t, "EXT_color_buffer_float")) return !1;
              return pe(t, e);
            }(this.get("WEBGL_VERSION"));
            if ("WEBGL_DOWNLOAD_FLOAT_ENABLED" === t) return function (e) {
              if (0 === e) return !1;
              var t = f(e);
              if (1 === e) {
                if (!fe(t, "OES_texture_float")) return !1;
                if (!fe(t, "WEBGL_color_buffer_float")) return !1;
              } else if (!fe(t, "EXT_color_buffer_float")) return !1;
              return pe(t, e);
            }(this.get("WEBGL_VERSION"));
            if ("WEBGL_FENCE_API_ENABLED" === t) return function (e) {
              return 2 === e && null != f(e).fenceSync;
            }(this.get("WEBGL_VERSION"));
            if ("WEBGL_SIZE_UPLOAD_UNIFORM" === t) return this.get("WEBGL_RENDER_FLOAT32_ENABLED") ? 4 : 0;
            if ("TEST_EPSILON" === t) return 32 === this.backend.floatPrecision() ? .001 : .1;
            if ("EPSILON" === t) return 32 === this.backend.floatPrecision() ? 1e-7 : 1e-4;
            if ("PROD" === t) return !1;
            if ("TENSORLIKE_CHECK_SHAPE_CONSISTENCY" === t) return !this.get("PROD");
            throw new Error("Unknown feature " + t + ".");
          }, t.prototype.setFeatures = function (e) {
            this.features = Object.assign({}, e);
          }, t.prototype.reset = function () {
            this.features = he(), null != this.globalEngine && (this.globalEngine = null);
          }, Object.defineProperty(t.prototype, "backend", {
            get: function get() {
              return this.engine.backend;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.findBackend = function (e) {
            return e in this.registry ? this.registry[e].backend : null;
          }, t.prototype.registerBackend = function (e, t, n, r) {
            var i = this;
            if (void 0 === n && (n = 1), e in this.registry) return console.warn(e + " backend was already registered. Reusing existing backend"), null != r && r(function () {
              return i.engine;
            }), !1;
            try {
              var o = t();
              return o.setDataMover({
                moveData: function moveData(e) {
                  return i.engine.moveData(e);
                }
              }), this.registry[e] = {
                backend: o,
                priority: n
              }, !0;
            } catch (t) {
              return console.warn("Registration of backend " + e + " failed"), console.warn(t.stack || t.message), !1;
            }
          }, t.prototype.removeBackend = function (e) {
            if (!(e in this.registry)) throw new Error(e + " backend not found in registry");
            this.registry[e].backend.dispose(), delete this.registry[e];
          }, Object.defineProperty(t.prototype, "engine", {
            get: function get() {
              return this.initEngine(), this.globalEngine;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.initEngine = function () {
            var e = this;
            if (null == this.globalEngine) {
              this.backendName = this.get("BACKEND");
              var t = this.findBackend(this.backendName);
              this.globalEngine = new le(t, !1, function () {
                return e.get("DEBUG");
              });
            }
          }, t;
        }();
        var ve = function () {
            var t = function () {
              var t;
              if ("undefined" != typeof window) t = window;else {
                if (void 0 === e) throw new Error("Could not find a global object");
                t = e;
              }
              return t;
            }();
            return null == t.ENV && (t.ENV = new ge(he()), ee(function () {
              return t.ENV.engine;
            })), t.ENV;
          }(),
          ye = Object.freeze({
            EPSILON_FLOAT16: 1e-4,
            EPSILON_FLOAT32: 1e-7,
            Environment: ge,
            ENV: ve
          });
        function be(e) {
          return b(B(e), "The f passed in grad(f) must be a function"), function (t, n) {
            return b(t instanceof te, "The x passed in grad(f)(x) must be a tensor"), b(null == n || n instanceof te, "The dy passed in grad(f)(x, dy) must be a tensor"), ve.engine.tidy(function () {
              var r = ve.engine.gradients(function () {
                  return e(t);
                }, [t], n),
                i = r.value,
                o = r.grads;
              return null != n && _(i.shape, n.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)"), Ee(o), o[0];
            });
          };
        }
        function _e(e) {
          return b(B(e), "The f passed in grads(f) must be a function"), function (t, n) {
            return b(Array.isArray(t) && t.every(function (e) {
              return e instanceof te;
            }), "The args passed in grads(f)(args) must be an array of tensors"), b(null == n || n instanceof te, "The dy passed in grads(f)(args, dy) must be a tensor"), ve.engine.tidy(function () {
              var r = ve.engine.gradients(function () {
                  return e.apply(void 0, t);
                }, t, n),
                i = r.value,
                o = r.grads;
              return null != n && _(i.shape, n.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), Ee(o), o;
            });
          };
        }
        function xe(e) {
          return b(B(e), "The f passed in valueAndGrad(f) must be a function"), function (t, n) {
            b(t instanceof te, "The x passed in valueAndGrad(f)(x) must be a tensor"), b(null == n || n instanceof te, "The dy passed in valueAndGrad(f)(x, dy) must be a tensor");
            var r = ve.engine.gradients(function () {
                return e(t);
              }, [t], n),
              i = r.grads,
              o = r.value;
            return Ee(i), {
              grad: i[0],
              value: o
            };
          };
        }
        function we(e) {
          return b(B(e), "The f passed in valueAndGrads(f) must be a function"), function (t, n) {
            b(Array.isArray(t) && t.every(function (e) {
              return e instanceof te;
            }), "The args passed in valueAndGrads(f)(args) must be array of tensors"), b(null == n || n instanceof te, "The dy passed in valueAndGrads(f)(args, dy) must be a tensor");
            var r = ve.engine.gradients(function () {
              return e.apply(void 0, t);
            }, t, n);
            return null != n && _(r.value.shape, n.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), Ee(r.grads), r;
          };
        }
        function Se(e, t) {
          if (b(B(e), "The f passed in variableGrads(f) must be a function"), b(null == t || Array.isArray(t) && t.every(function (e) {
            return e instanceof ne;
          }), "The varList passed in variableGrads(f, varList) must be an array of variables"), null == t) for (var n in t = [], ve.engine.registeredVariables) t.push(ve.engine.registeredVariables[n]);
          var r = t.length;
          b((t = t.filter(function (e) {
            return e.trainable;
          })).length > 0, "variableGrads() expects at least one of the input variables to be trainable, but none of the " + r + " variables is trainable.");
          var i = ve.engine.gradients(e, t, null, !0),
            o = i.value,
            a = i.grads;
          b(a.some(function (e) {
            return null != e;
          }), "Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize()."), b(0 === o.rank, "The f passed in variableGrads(f) must return a scalar, but it returned a rank-" + o.rank + " tensor");
          var s = {};
          return t.forEach(function (e, t) {
            null != a[t] && (s[e.name] = a[t]);
          }), {
            value: o,
            grads: s
          };
        }
        function Ae(e) {
          return ve.engine.customGrad(e);
        }
        function Ee(e) {
          if (e.filter(function (e) {
            return null == e;
          }).length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that\n    the f you passed encloses all operations that lead from x to y.");
        }
        var Te = ge.tidy,
          Me = ge.keep,
          Ce = ge.dispose,
          ke = ge.time,
          Pe = ge.profile;
        function Oe() {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          ve.get("IS_TEST") || console.warn.apply(console, e);
        }
        function Re(e, t, n, r) {
          void 0 === r && (r = !0);
          var i = [];
          if (r) (i = i.concat(t.slice(0))).push(e[0] / n), i = i.concat(e.slice(1));else {
            i = i.concat(e[0]);
            for (var o = t.length, a = 0; a < o; ++a) i = i.concat([e[a + 1] / t[a], t[a]]);
            i = i.concat(e.slice(o + 1));
          }
          return i;
        }
        function Ie(e, t, n) {
          void 0 === n && (n = !0);
          var r = [];
          if (n) {
            r.push(t);
            for (var i = t + 1; i < e; ++i) i <= 2 * t ? (r.push(i), r.push(i - (t + 1))) : r.push(i);
          } else {
            var o = [],
              a = [];
            for (i = 1; i < e; ++i) i >= 2 * t + 1 || i % 2 == 1 ? a.push(i) : o.push(i);
            r.push.apply(r, o), r.push(0), r.push.apply(r, a);
          }
          return r;
        }
        function je(e, t, n, r) {
          void 0 === r && (r = !0);
          var i = [];
          r ? i.push(e[0] / n) : i.push(e[0] * n);
          for (var o = 1; o < e.length; ++o) o <= t.length ? r ? i.push(t[o - 1] * e[o]) : i.push(e[o] / t[o - 1]) : i.push(e[o]);
          return i;
        }
        function Ne(e, t) {
          for (var n = [0], r = 0; r < t; ++r) n.push(e[r][0]);
          return n;
        }
        function Le(e, t, n) {
          for (var r = e.slice(0, 1), i = 0; i < n; ++i) r.push(e[i + 1] - t[i][0] - t[i][1]);
          return r;
        }
        function De(e, t) {
          for (var n = 0; n < e.length; ++n) if (e[e.length - n - 1] !== t - 1 - n) return !1;
          return !0;
        }
        function Be(e, t) {
          for (var n = [], r = e.length, i = 0; i < r; i++) -1 === t.indexOf(i) && n.push(e[i]);
          return [n, t.map(function (t) {
            return e[t];
          })];
        }
        function Fe(e, t) {
          return function (e, t, n) {
            for (var r = e.length + t.length, i = [], o = 0, a = 0, s = 0; s < r; s++) -1 === n.indexOf(s) ? i.push(e[o++]) : i.push(t[a++]);
            return i;
          }(e, t.map(function (e) {
            return 1;
          }), t);
        }
        function ze(e, t) {
          var n = t.length;
          return b((e = null == e ? t.map(function (e, t) {
            return t;
          }) : [].concat(e)).every(function (e) {
            return e >= -n && e < n;
          }), "All values in axis param must be in range [-" + n + ", " + n + ") but got axis " + e), b(e.every(function (e) {
            return E(e);
          }), "All values in axis param must be integers but got axis " + e), e.map(function (e) {
            return e < 0 ? n + e : e;
          });
        }
        function Ue(e, t, n) {
          b(De(t, n), e + " supports only inner-most axes for now. Got axes " + t + " and rank-" + n + " input.");
        }
        function Ge(e, t) {
          if (De(e, t)) return null;
          for (var n = [], r = 0; r < t; ++r) -1 === e.indexOf(r) && n.push(r);
          return e.forEach(function (e) {
            return n.push(e);
          }), n;
        }
        function Ve(e) {
          return e.map(function (e, t) {
            return [t, e];
          }).sort(function (e, t) {
            return e[1] - t[1];
          }).map(function (e) {
            return e[0];
          });
        }
        function He(e, t) {
          for (var n = [], r = t - e; r < t; ++r) n.push(r);
          return n;
        }
        function qe(e, t) {
          for (var n = e[0].slice(), r = 1; r < e.length; r++) n[t] += e[r][t];
          return n;
        }
        function We(e, t) {
          if (e.rank < 1) throw new Error("tf.gatherND() expects the input to be rank 1 or higher, but the rank was " + e.rank + ".");
          if (t.rank < 1) throw new Error("tf.gatherND() expects the indices to be rank 1 or higher, but the rank was " + t.rank + ".");
          if ("int32" !== t.dtype) throw new Error("tf.gatherND() expects the indices to be int32 type, but the dtype was " + t.dtype + ".");
          if (t.shape[t.rank - 1] > e.rank) throw new Error("index innermost dimension length must be <= tensor rank; saw: " + t.shape[t.rank - 1] + " vs. " + e.rank);
          if (0 === e.size) throw new Error("Requested more than 0 entries, but input is empty. Input shape: " + e.shape + ".");
          for (var n = t.shape, r = n[n.length - 1], i = 1, o = 0; o < n.length - 1; ++o) i *= n[o];
          var a = e.shape,
            s = n.slice();
          s.pop();
          var l = 1;
          for (o = r; o < e.rank; ++o) l *= a[o], s.push(a[o]);
          var u = z(e.shape).map(function (e) {
            return e / l;
          }).concat([1]).slice(0, r);
          return [s, i, l, u];
        }
        function $e(e) {
          return e <= 30 ? e : F(e, Math.floor(Math.sqrt(e)));
        }
        function Xe(e, t, n) {
          if (t.rank < 1) throw new Error("tf.scatterND() expects the indices to be rank 1 or higher, but the rank was " + t.rank + ".");
          if (e.rank < 1) throw new Error("tf.scatterND() expects the updates to be rank 1 or higher, but the rank was " + e.rank + ".");
          if ("int32" !== t.dtype) throw new Error("The dtype of 'indices' should be int32, but got dtype: " + t.dtype);
          if (n.length < 1) throw new Error("Output rank must be greater or equal to 1, but got shape: " + n);
          if (0 === n.length) {
            if (0 === t.size) throw new Error("Indices specified for empty output. indices shape: " + t.shape);
            if (0 === e.size) throw new Error("Updates specified for empty output. updates shape: " + e.shape);
          }
          !function (e, t, n) {
            var r = t.rank > 1 ? t.shape[t.rank - 1] : 1,
              i = t.rank > 1 ? t.rank - 1 : 1,
              o = "Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: " + n.shape + ", indices.shape: " + t.shape + ", shape: " + e + ", sliceDim: " + r + ", and batchDim: " + i + ".";
            if (n.rank < i) throw new Error(o + " update.rank < " + i + ". ");
            if (e.length < r + (n.rank - i)) throw new Error(o + " Output shape length < " + (r + (n.rank - i)));
            if (n.rank !== i + e.length - r) throw new Error(o + " update.rank != " + (i + e.length - r));
            for (var a = 0; a < i; ++a) if (n.shape[a] !== t.shape[a]) throw new Error(o + " updates.shape[" + a + "] (" + n.shape[a] + ") != indices.shape[" + a + "] (" + t.shape[a] + ").");
            for (a = 0; a < n.rank - i; ++a) if (n.shape[a + i] !== e[a + r]) throw new Error(o + " updates.shape[" + (a + i) + "] (" + n.shape[a + i] + ") != shape[" + (a + i) + "] (" + e[a + i] + ")");
          }(n, t, e);
        }
        function Ye(e, t, n) {
          for (var r = t.rank > 1 ? t.shape[t.rank - 1] : 1, i = n.length, o = 1, a = r; a < i; ++a) o *= n[a];
          var s = r < 1 ? 1 : r,
            l = t.size / s,
            u = z(n).concat([1]);
          return {
            sliceRank: r,
            numUpdates: l,
            sliceSize: o,
            strides: u.slice(u.length - r, u.length),
            outputSize: S(n)
          };
        }
        function Ke(e, t, n, r, i, o, a, s, l) {
          if (void 0 === i && (i = 0), void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === s && (s = 0), void 0 === l && (l = 0), 0 !== a) throw new Error("ellipsis mask is not yet supported");
          if (0 !== s) throw new Error("new axis mask is not yet supported");
          for (var u = [], c = [], d = [], h = 0; h < e.length; h++) u[h] = Ze(i, t, r, e, h), c[h] = Qe(o, n, r, e, h), l & 1 << h && (c[h] = u[h] + 1, d.push(h));
          var f = new Array(e.length).fill(0);
          return f = f.map(function (e, t) {
            for (var n = 0, i = u[t]; !(r[t] > 0 ? i >= c[t] : i <= c[t]); i += r[t]) n += 1;
            return n;
          }), [u, f, d];
        }
        function Ze(e, t, n, r, i) {
          var o = t[i];
          e & 1 << i && (o = n[i] > 0 ? Number.MIN_SAFE_INTEGER : Number.MAX_SAFE_INTEGER);
          var a = r[i];
          return o < 0 && (o += a), m(0, o, a - 1);
        }
        function Qe(e, t, n, r, i) {
          var o = t[i];
          e & 1 << i && (o = n[i] > 0 ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER);
          var a = r[i];
          return o < 0 && (o += a), n[i] > 0 ? m(0, o, a) : m(-1, o, a - 1);
        }
        function Je(e) {
          var t = e;
          if (L(e)) return [e.length];
          if (!Array.isArray(e)) return [];
          for (var n = []; t instanceof Array;) n.push(t.length), t = t[0];
          return e instanceof Array && ve.get("TENSORLIKE_CHECK_SHAPE_CONSISTENCY") && function e(t, n, r) {
            if (r = r || [], t instanceof Array) {
              b(n.length > 0, function () {
                return "Element arr[" + r.join("][") + "] should be a primitive, but is an array of " + t.length + " elements";
              }), b(t.length === n[0], function () {
                return "Element arr[" + r.join("][") + "] should have " + n[0] + " elements, but has " + t.length + " elements";
              });
              for (var i = n.slice(1), o = 0; o < t.length; ++o) e(t[o], i, r.concat(o));
            } else b(0 === n.length, function () {
              return "Element arr[" + r.join("][") + "] is a primitive, but should be an array of " + n[0] + " elements";
            });
          }(e, n, []), n;
        }
        function et(e, t, n, r) {
          if (void 0 === r && (r = "float32"), r = r || "float32", e instanceof te) return e;
          if (!L(e) && !Array.isArray(e) && "number" != typeof e && "boolean" != typeof e) throw new Error("Argument '" + t + "' passed to '" + n + "' must be a Tensor or TensorLike, but got " + e.constructor.name);
          var i = Je(e);
          return L(e) || Array.isArray(e) || (e = [e]), te.make(i, {
            values: U(e, r, ve.get("DEBUG"))
          }, r);
        }
        function tt(e, t, n) {
          if (!Array.isArray(e)) throw new Error("Argument " + t + " passed to " + n + " must be a `Tensor[]` or `TensorLike[]`");
          return e.map(function (e, r) {
            return et(e, t + "[" + r + "]", n);
          });
        }
        function nt(e) {
          var t = Object.keys(e);
          if (1 !== t.length) throw new Error("Please provide an object with a single key (operation name) mapping to a function. Got an object with " + t.length + " keys.");
          var n = t[0],
            r = e[n];
          n.endsWith("_") && (n = n.substring(0, n.length - 1));
          var i = function i() {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            ve.engine.startScope(n);
            try {
              var i = r.apply(void 0, e);
              return i instanceof Promise && console.error("Cannot return a Promise inside of tidy."), ve.engine.endScope(i), i;
            } catch (e) {
              throw ve.engine.endScope(null), e;
            }
          };
          return Object.defineProperty(i, "name", {
            value: n,
            configurable: !0
          }), i;
        }
        var rt = nt({
            softmax_: function softmax_(e, t) {
              void 0 === t && (t = -1);
              var n = et(e, "logits", "softmax");
              if (-1 === t && (t = n.rank - 1), t !== n.rank - 1) throw Error("Softmax along a non-last dimension is not yet supported. Logits was rank " + n.rank + " and dim was " + t);
              return Ae(function (e) {
                var n = e.logSumExp([t], !0),
                  r = e.toFloat().sub(n).exp();
                return {
                  value: r,
                  gradFunc: function gradFunc(e) {
                    var n = e.mul(r);
                    return n.sub(n.sum([t], !0).mul(r));
                  }
                };
              })(n);
            }
          }),
          it = nt({
            logSoftmax_: function logSoftmax_(e, t) {
              void 0 === t && (t = -1);
              var n = et(e, "logits", "logSoftmax");
              if (-1 === t && (t = n.rank - 1), t !== n.rank - 1) throw Error("Log Softmax along a non-last dimension is not yet supported. Logits was rank " + n.rank + " and axis was " + t);
              return Ae(function (e) {
                var n = e.max(t, !0),
                  r = e.sub(n),
                  i = r.toFloat().sub(r.exp().sum(t, !0).log());
                return {
                  value: i,
                  gradFunc: function gradFunc(e) {
                    var n = i.exp();
                    return e.sub(e.sum(t, !0).mul(n));
                  }
                };
              })(n);
            }
          });
        var ot = nt({
            complex_: function complex_(e, t) {
              var n = et(e, "real", "complex"),
                r = et(t, "imag", "complex");
              return _(n.shape, r.shape, "real and imag shapes, " + n.shape + " and " + r.shape + ", must match in call to tf.complex()."), ve.engine.runKernel(function (e) {
                return e.complex(n, r);
              }, {
                $real: n,
                $imag: r
              });
            }
          }),
          at = nt({
            real_: function real_(e) {
              var t = et(e, "input", "real");
              return ve.engine.runKernel(function (e) {
                return e.real(t);
              }, {
                $input: t
              });
            }
          }),
          st = nt({
            imag_: function imag_(e) {
              var t = et(e, "input", "imag");
              return ve.engine.runKernel(function (e) {
                return e.imag(t);
              }, {
                $input: t
              });
            }
          });
        function lt(e, t, n) {
          if (void 0 === n && (n = "float32"), "complex64" === n) throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");
          if (!L(e) && !Array.isArray(e) && "number" != typeof e && "boolean" != typeof e) throw new Error("values passed to tensor(values) must be an array of numbers or booleans, or a TypedArray");
          var r = Je(e);
          return null != t && 1 !== r.length && _(t, r, "Error creating a new Tensor. Inferred shape (" + r + ") does not match the provided shape (" + t + "). "), L(e) || Array.isArray(e) || (e = [e]), t = t || r, te.make(t, {
            values: U(e, n, ve.get("DEBUG"))
          }, n);
        }
        function ut(e, t) {
          if (void 0 === t && (t = "float32"), (L(e) || Array.isArray(e)) && "complex64" !== t) throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean)");
          return lt(e, [], t);
        }
        function ct(e, t) {
          void 0 === t && (t = "float32"), x(e);
          var n = Je(e);
          if (1 !== n.length) throw new Error("tensor1d() requires values to be a flat/TypedArray");
          return lt(e, n, t);
        }
        function dt(e, t, n) {
          if (void 0 === n && (n = "float32"), x(e), null != t && 2 !== t.length) throw new Error("tensor2d() requires shape to have two numbers");
          var r = Je(e);
          if (2 !== r.length && 1 !== r.length) throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");
          if (1 === r.length && null == t) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
          return lt(e, t = t || r, n);
        }
        function ht(e, t, n) {
          if (void 0 === n && (n = "float32"), x(e), null != t && 3 !== t.length) throw new Error("tensor3d() requires shape to have three numbers");
          var r = Je(e);
          if (3 !== r.length && 1 !== r.length) throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");
          if (1 === r.length && null == t) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
          return lt(e, t = t || r, n);
        }
        function ft(e, t, n) {
          if (void 0 === n && (n = "float32"), x(e), null != t && 4 !== t.length) throw new Error("tensor4d() requires shape to have four numbers");
          var r = Je(e);
          if (4 !== r.length && 1 !== r.length) throw new Error("tensor4d() requires values to be number[][][][] or flat/TypedArray");
          if (1 === r.length && null == t) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
          return lt(e, t = t || r, n);
        }
        function pt(e, t, n) {
          if (void 0 === n && (n = "float32"), x(e), null != t && 5 !== t.length) throw new Error("tensor5d() requires shape to have five numbers");
          var r = Je(e);
          if (5 !== r.length && 1 !== r.length) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
          if (1 === r.length && null == t) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
          return lt(e, t = t || r, n);
        }
        function mt(e, t, n) {
          if (void 0 === n && (n = "float32"), x(e), null != t && 6 !== t.length) throw new Error("tensor6d() requires shape to have six numbers");
          var r = Je(e);
          if (6 !== r.length && 1 !== r.length) throw new Error("tensor6d() requires values to be number[][][][] or flat/TypedArray");
          if (1 === r.length && null == t) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
          return lt(e, t = t || r, n);
        }
        function gt(e, t) {
          if (void 0 === t && (t = "float32"), "complex64" === t) {
            var n = gt(e, "float32"),
              r = gt(e, "float32");
            return ot(n, r);
          }
          var i = G(S(e), t);
          return te.make(e, {
            values: i
          }, t);
        }
        function vt(e, t) {
          if (void 0 === t && (t = "float32"), "complex64" === t) {
            var n = vt(e, "float32"),
              r = vt(e, "float32");
            return ot(n, r);
          }
          var i = V(S(e), t);
          return te.make(e, {
            values: i
          }, t);
        }
        function yt(e, t, n) {
          void 0 === n && (n = "float32");
          var r = R(n, S(e));
          return r.fill(t), te.make(e, {
            values: r
          }, n);
        }
        function bt(e, t, n) {
          if (0 === n) throw new Error("Cannot request zero samples");
          var r = (t - e) / (n - 1),
            i = V(n, "float32");
          i[0] = e;
          for (var o = 1; o < i.length; o++) i[o] = i[o - 1] + r;
          return ct(i, "float32");
        }
        function _t(e, t, n, r) {
          if (void 0 === n && (n = 1), void 0 === r && (r = "float32"), 0 === n) throw new Error("Cannot have a step of zero");
          if (e === t || e < t && n < 0 || t < e && n > 1) return vt([0], r);
          var i = V(Math.abs(Math.ceil((t - e) / n)), r);
          t < e && 1 === n && (n = -1), i[0] = e;
          for (var o = 1; o < i.length; o++) i[o] = i[o - 1] + n;
          return ct(i, r);
        }
        var xt,
          wt,
          St,
          At,
          Et,
          Tt,
          Mt = nt({
            onesLike_: function onesLike_(e) {
              var t = et(e, "x", "onesLike");
              return gt(t.shape, t.dtype);
            }
          }),
          Ct = nt({
            zerosLike_: function zerosLike_(e) {
              var t = et(e, "x", "zerosLike");
              return vt(t.shape, t.dtype);
            }
          });
        !function (e) {
          e.float32 = "float32", e.int32 = "int32", e.bool = "bool";
        }(xt || (xt = {})), function (e) {
          e.R0 = "R0", e.R1 = "R1", e.R2 = "R2", e.R3 = "R3", e.R4 = "R4", e.R5 = "R5", e.R6 = "R6";
        }(wt || (wt = {})), function (e) {
          e.float32 = "float32", e.int32 = "int32", e.bool = "int32", e.complex64 = "complex64";
        }(St || (St = {})), function (e) {
          e.float32 = "float32", e.int32 = "int32", e.bool = "bool", e.complex64 = "complex64";
        }(At || (At = {})), function (e) {
          e.float32 = "float32", e.int32 = "float32", e.bool = "float32", e.complex64 = "complex64";
        }(Et || (Et = {})), function (e) {
          e.float32 = "complex64", e.int32 = "complex64", e.bool = "complex64", e.complex64 = "complex64";
        }(Tt || (Tt = {}));
        var kt = {
          float32: Et,
          int32: St,
          bool: At,
          complex64: Tt
        };
        function Pt(e, t) {
          return kt[e][t];
        }
        function Ot(e) {
          return Pt(e, "int32");
        }
        var Rt = function () {
            function e(e) {
              this.dataMover = e, this.data = new WeakMap();
            }
            return e.prototype.get = function (e) {
              return this.data.has(e) || this.dataMover.moveData(e), this.data.get(e);
            }, e.prototype.set = function (e, t) {
              this.data.set(e, t);
            }, e.prototype.has = function (e) {
              return this.data.has(e);
            }, e.prototype.delete = function (e) {
              return this.data.delete(e);
            }, e;
          }(),
          It = function () {
            function e() {}
            return e.prototype.time = function (e) {
              throw new Error("Not yet implemented.");
            }, e.prototype.read = function (e) {
              throw new Error("Not yet implemented.");
            }, e.prototype.readSync = function (e) {
              throw new Error("Not yet implemented.");
            }, e.prototype.disposeData = function (e) {
              throw new Error("Not yet implemented.");
            }, e.prototype.write = function (e, t) {
              throw new Error("Not yet implemented.");
            }, e.prototype.fromPixels = function (e, t) {
              throw new Error("Not yet implemented.");
            }, e.prototype.register = function (e, t, n) {
              throw new Error("Not yet implemented.");
            }, e.prototype.memory = function () {
              throw new Error("Not yet implemented.");
            }, e.prototype.floatPrecision = function () {
              throw new Error("Not yet implemented");
            }, e.prototype.batchMatMul = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.slice = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.stridedSlice = function (e, t, n, r, i, o, a, s, l) {
              throw new Error("Not yet implemented");
            }, e.prototype.reverse = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.concat = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.neg = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.add = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.addN = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.subtract = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.multiply = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.realDivide = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.floorDiv = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.sum = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.prod = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.unsortedSegmentSum = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.argMin = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.argMax = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.equal = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.notEqual = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.less = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.lessEqual = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.greater = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.greaterEqual = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.logicalNot = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.logicalAnd = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.logicalOr = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.where = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.select = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.topk = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.min = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.minimum = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.mod = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.max = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.maximum = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.all = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.any = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.squaredDifference = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.ceil = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.floor = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.round = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.sign = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.pow = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.exp = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.expm1 = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.log = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.log1p = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.sqrt = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.rsqrt = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.square = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.reciprocal = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.relu = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.elu = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.eluDer = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.selu = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.int = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.clip = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.abs = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.complexAbs = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.sigmoid = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.softplus = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.sin = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.cos = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.tan = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.asin = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.acos = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.atan = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.atan2 = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.sinh = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.cosh = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.tanh = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.asinh = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.acosh = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.atanh = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.erf = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.step = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.conv2d = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.conv2dDerInput = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.conv2dDerFilter = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.depthwiseConv2D = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.depthwiseConv2DDerInput = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.depthwiseConv2DDerFilter = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.maxPool = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.maxPoolBackprop = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.avgPool = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.avgPoolBackprop = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.reshape = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.cast = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.tile = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.pad = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.transpose = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.gather = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.gatherND = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.scatterND = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.batchToSpaceND = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.spaceToBatchND = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.resizeBilinear = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.resizeBilinearBackprop = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.resizeNearestNeighbor = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.resizeNearestNeighborBackprop = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.batchNormalization = function (e, t, n, r, i, o) {
              throw new Error("Not yet implemented");
            }, e.prototype.localResponseNormalization4D = function (e, t, n, r, i) {
              throw new Error("Not yet implemented");
            }, e.prototype.LRNGrad = function (e, t, n, r, i, o, a) {
              throw new Error("Not yet implemented");
            }, e.prototype.multinomial = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.oneHot = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.cumsum = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.nonMaxSuppression = function (e, t, n, r, i) {
              throw new Error("Not yet implemented");
            }, e.prototype.fft = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.ifft = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.complex = function (e, t) {
              throw new Error("Not yet implemented");
            }, e.prototype.real = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.imag = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.cropAndResize = function (e, t, n, r, i, o) {
              throw new Error("Not yet implemented");
            }, e.prototype.depthToSpace = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.split = function (e, t, n) {
              throw new Error("Not yet implemented");
            }, e.prototype.sparseToDense = function (e, t, n, r) {
              throw new Error("Not yet implemented");
            }, e.prototype.setDataMover = function (e) {
              throw new Error("Not yet implemented");
            }, e.prototype.dispose = function () {
              throw new Error("Not yet implemented");
            }, e;
          }();
        function jt(e, t, n) {
          if ("complex64" === t) {
            if ("complex64" === e.dtype) return e.clone();
            var r = vt(e.shape),
              i = e.toFloat(),
              o = n.complex(i, r);
            return r.dispose(), i.dispose(), o;
          }
          if (!N(e.dtype, t)) return te.make(e.shape, {
            dataId: e.dataId
          }, t);
          if ("complex64" === e.dtype) {
            var a = n.real(e);
            return o = a.cast(t), a.dispose(), o;
          }
          if ("int32" === t) return n.int(e);
          if ("bool" === t) {
            var s = ut(0, e.dtype);
            return o = n.notEqual(e, s), s.dispose(), o;
          }
          throw new Error("Error in Cast: unknown dtype argument (" + t + ")");
        }
        function Nt(e, t) {
          return te.make(t, {
            dataId: e.dataId
          }, e.dtype);
        }
        function Lt(e, t) {
          if (e.length !== t.length) throw new Error("Cannot merge real and imag arrays of different lengths. real:" + e.length + ", imag: " + t.length + ".");
          for (var n = new Float32Array(2 * e.length), r = 0; r < n.length; r += 2) n[r] = e[r / 2], n[r + 1] = t[r / 2];
          return n;
        }
        function Dt(e, t) {
          return {
            real: e[2 * t],
            imag: e[2 * t + 1]
          };
        }
        function Bt(e, t, n, r) {
          e[2 * r] = t, e[2 * r + 1] = n;
        }
        function Ft(e, t, n) {
          var r = (n ? 2 : -2) * Math.PI * (e / t);
          return {
            real: Math.cos(r),
            imag: Math.sin(r)
          };
        }
        function zt(e, t, n, r, i) {
          for (var o = Array.from(t).map(function (e, t) {
              return {
                score: e,
                boxIndex: t
              };
            }).filter(function (e) {
              return e.score > i;
            }).sort(function (e, t) {
              return t.score - e.score;
            }), a = [], s = 0; s < o.length; s++) {
            var l = o[s],
              u = l.score,
              c = l.boxIndex;
            if (u < i) break;
            for (var d = !1, h = a.length - 1; h >= 0; --h) if (Ut(e, c, a[h]) >= r) {
              d = !0;
              break;
            }
            if (!d && (a.push(c), a.length >= n)) break;
          }
          return ct(a, "int32");
        }
        function Ut(e, t, n) {
          var r = e.subarray(4 * t, 4 * t + 4),
            i = e.subarray(4 * n, 4 * n + 4),
            o = Math.min(r[0], r[2]),
            a = Math.min(r[1], r[3]),
            s = Math.max(r[0], r[2]),
            l = Math.max(r[1], r[3]),
            u = Math.min(i[0], i[2]),
            c = Math.min(i[1], i[3]),
            d = Math.max(i[0], i[2]),
            h = Math.max(i[1], i[3]),
            f = (s - o) * (l - a),
            p = (d - u) * (h - c);
          if (f <= 0 || p <= 0) return 0;
          var m = Math.max(o, u),
            g = Math.max(a, c),
            v = Math.min(s, d),
            y = Math.min(l, h),
            b = Math.max(v - m, 0) * Math.max(y - g, 0);
          return b / (f + p - b);
        }
        function Gt(e, t, n) {
          var r = Array(e.rank).fill(0),
            i = e.shape.slice();
          return t.map(function (t) {
            i[n] = t;
            var o = e.slice(r, i);
            return r[n] += t, o;
          });
        }
        function Vt(e, t, n, r, i) {
          for (var o = t[t.length - 1], a = [e.length / o, o], s = a[0], l = a[1], u = R(n, s * r), c = R("int32", s * r), d = 0; d < s; d++) {
            for (var h = d * l, f = e.subarray(h, h + l), p = [], m = 0; m < f.length; m++) p.push({
              value: f[m],
              index: m
            });
            p.sort(function (e, t) {
              return t.value - e.value;
            });
            var g = d * r,
              v = u.subarray(g, g + r),
              y = c.subarray(g, g + r);
            for (m = 0; m < r; m++) v[m] = p[m].value, y[m] = p[m].index;
          }
          var b = t.slice();
          return b[b.length - 1] = r, [lt(u, b, n), lt(c, b, "int32")];
        }
        var Ht = function Ht(e, t, n) {
            this.variableNames = ["A"];
            var r = e.windowSize,
              i = e.batchSize,
              o = e.inSize,
              a = Math.ceil(o / r);
            n || this.variableNames.push("bestIndicesA"), this.outputShape = [i, a];
            var s = "max" === t ? ">" : "<",
              l = n ? "inOffset + i;" : "round(getBestIndicesA(batch, inOffset + i));";
            this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + r + ";\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < " + r + "; i++) {\n          int inIdx = " + l + ";\n          float candidate = getA(batch, inIdx);\n          if (candidate " + s + " bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    ";
          },
          qt = function qt(e) {
            this.variableNames = ["dy"], this.outputShape = e.inShape;
            var t = e.filterHeight,
              n = e.filterWidth,
              r = e.strideHeight,
              i = e.strideWidth,
              o = e.dilationHeight,
              a = e.dilationWidth,
              s = e.effectiveFilterHeight,
              l = e.effectiveFilterWidth,
              u = s - 1 - e.padInfo.top,
              c = l - 1 - e.padInfo.left,
              d = 1 / (t * n);
            this.userCode = "\n      const ivec2 pads = ivec2(" + u + ", " + c + ");\n      const float avgMultiplier = float(" + d + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + s + ";\n            wR += " + o + ") {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + l + ";\n            wC+= " + a + ") {\n            float dyC = float(dyCCorner + wC) / " + i + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          };
        function Wt(e, t) {
          for (var n = e.length, r = [], i = 0; i < n; i++) {
            var o = n - 1 - i,
              a = e[o] || 1;
            (t[t.length - 1 - i] || 1) > 1 && 1 === a && r.unshift(o);
          }
          return r;
        }
        function $t(e, t) {
          for (var n = [], r = 0; r < t.length; r++) {
            var i = e[e.length - r - 1],
              o = t.length - r - 1,
              a = t[o];
            (null == i || 1 === i && a > 1) && n.unshift(o);
          }
          return n;
        }
        function Xt(e, t) {
          for (var n = [], r = Math.max(e.length, t.length), i = 0; i < r; i++) {
            var o = e[e.length - i - 1];
            null == o && (o = 1);
            var a = t[t.length - i - 1];
            if (null == a && (a = 1), 1 === o) n.unshift(a);else if (1 === a) n.unshift(o);else {
              if (o !== a) throw Error("Operands could not be broadcast together with shapes " + e + " and " + t + ".");
              n.unshift(o);
            }
          }
          return n;
        }
        var Yt = function Yt(e, t, n, r, i, o) {
            this.outputShape = [], this.supportsBroadcasting = !0, this.variableNames = ["x", "mean", "variance"], Xt(e, t), Xt(e, n);
            var a = "0.0";
            null != r && (Xt(e, r), this.variableNames.push("offset"), a = "getOffsetAtOutCoords()");
            var s = "1.0";
            null != i && (Xt(e, i), this.variableNames.push("scale"), s = "getScaleAtOutCoords()"), this.outputShape = e, this.userCode = "\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = " + a + ";\n        float scale = " + s + ";\n        float inv = scale * inversesqrt(variance + float(" + o + "));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    ";
          },
          Kt = function Kt(e, t, n, r, i, o) {
            this.supportsBroadcasting = !0, this.usesPackedTextures = !0, this.variableNames = ["x", "mean", "variance"], Xt(e, t), Xt(e, n);
            var a = Zt("mean", t.length),
              s = Zt("variance", n.length),
              l = "vec4 offset = vec4(0.0)";
            null != r && (Xt(e, r), this.variableNames.push("offset"), l = Zt("offset", r.length));
            var u = "vec4 scale = vec4(1.0)";
            null != i && (Xt(e, i), this.variableNames.push("scale"), u = Zt("scale", i.length)), this.outputShape = e, this.userCode = "\n      void main() {\n        ivec4 rc = getOutputCoords();\n\n        " + l + ";\n        " + u + ";\n\n        vec4 x = getX(rc.x, rc.y, rc.z, rc.w);\n        " + a + ";\n        " + s + ";\n\n        vec4 inv = scale * inversesqrt(variance + vec4(" + o + "));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    ";
          };
        function Zt(e, t) {
          var n = "get" + e.charAt(0).toUpperCase() + e.slice(1);
          return 1 === t ? "\n      vec4 " + e + "Sample = " + n + "(rc.w);\n      vec4 " + e + " = vec4(" + e + "Sample.xy, " + e + "Sample.xy);\n    " : "vec4 " + e + " = " + n + "(rc.x, rc.y, rc.z, rc.w)";
        }
        var Qt = "return areal * breal - aimag * bimag;",
          Jt = "return areal * bimag + aimag * breal;",
          en = function en(e, t, n) {
            this.variableNames = ["AReal", "AImag", "BReal", "BImag"], this.supportsBroadcasting = !0, this.outputShape = Xt(t, n), this.userCode = "\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        " + e + "\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    ";
          },
          tn = "return a + b;",
          nn = "return a - b;",
          rn = function () {
            function e(e, t, n) {
              this.variableNames = ["A", "B"], this.supportsBroadcasting = !0, this.outputShape = Xt(t, n), this.userCode = "\n      uniform float NAN;\n      float binaryOperation(float a, float b) {\n        " + e + "\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    ";
            }
            return e.prototype.getCustomSetupFunc = function () {
              var e = this;
              return function (t, n) {
                null == e.startLoc && (e.startLoc = t.getUniformLocationNoThrow(n, "NAN"), null == e.startLoc) || t.gl.uniform1f(e.startLoc, NaN);
              };
            }, e;
          }(),
          on = function on(e, t, n) {
            this.variableNames = ["A"], this.outputShape = e, this.userCode = "\n      void main() {\n        float value = getAAtOutCoords();\n        if (isNaN(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, float(" + t + "), float(" + n + ")));\n      }\n    ";
          },
          an = function an(e) {
            this.variableNames = ["real", "imag"], this.outputShape = e, this.userCode = "\n      void main() {\n        float re = abs(getRealAtOutCoords());\n        float im = abs(getImagAtOutCoords());\n        float mx = max(re, im);\n\n        // sadly the length function in glsl is not underflow-safe\n        // (at least not on Intel GPUs). So the safe solution is\n        // to ensure underflow-safety in all cases.\n        setOutput(\n          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))\n        );\n      }\n    ";
          },
          sn = function sn(e, t) {
            this.variableNames = ["A", "B"], this.outputShape = [], this.outputShape = qe([e, t], 1), this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        float value = 0.0;\n        if (yC < " + e[1] + ") {\n          value = getA(yR, yC);\n        } else {\n          yC -= " + e[1] + ";\n          value = getB(yR, yC);\n        }\n\n        setOutput(value);\n      }\n    ";
          },
          ln = function ln(e) {
            this.variableNames = ["x", "dy"], this.outputShape = e.filterShape;
            var t = e.strideHeight,
              n = e.strideWidth,
              r = e.padInfo.top,
              i = e.padInfo.left;
            this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + e.batchSize + "; b++) {\n          for (int yR = 0; yR < " + e.outHeight + "; yR++) {\n            int xR = wR + yR * " + t + " - " + r + ";\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + e.outWidth + "; yC++) {\n              int xC = wC + yC * " + n + " - " + i + ";\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          un = function un(e) {
            this.variableNames = ["dy", "W"], this.outputShape = e.inShape;
            var t = e.filterHeight,
              n = e.filterWidth,
              r = e.strideHeight,
              i = e.strideWidth,
              o = t - 1 - e.padInfo.top,
              a = n - 1 - e.padInfo.left;
            this.userCode = "\n      const ivec2 pads = ivec2(" + o + ", " + a + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + t + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + t + " - 1 - wR;\n\n          for (int wC = 0; wC < " + n + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + i + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + n + " - 1 - wC;\n\n            for (int d2 = 0; d2 < " + e.outChannels + "; d2++) {\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, d2);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          cn = function cn(e) {
            this.variableNames = ["x", "dy"], this.outputShape = e.filterShape;
            var t = e.strideHeight,
              n = e.strideWidth,
              r = e.padInfo.top,
              i = e.padInfo.left,
              o = e.outChannels / e.inChannels;
            this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * " + o + " + dm;\n\n        float dotProd = 0.0;\n\n        // TODO: Vec4 over the batch size\n        for (int b = 0; b < " + e.batchSize + "; b++) {\n          for (int yR = 0; yR < " + e.outHeight + "; yR++) {\n            int xR = wR + yR * " + t + " - " + r + ";\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + e.outWidth + "; yC++) {\n              int xC = wC + yC * " + n + " - " + i + ";\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          dn = function dn(e) {
            this.variableNames = ["dy", "W"], this.outputShape = e.inShape;
            var t = e.filterHeight,
              n = e.filterWidth,
              r = e.strideHeight,
              i = e.strideWidth,
              o = t - 1 - e.padInfo.top,
              a = n - 1 - e.padInfo.left,
              s = e.outChannels / e.inChannels;
            this.userCode = "\n      const ivec2 pads = ivec2(" + o + ", " + a + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < " + t + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + t + " - 1 - wR;\n\n          for (int wC = 0; wC < " + n + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + i + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + n + " - 1 - wC;\n\n            // TODO: Vec4 over the channelMul\n            for (int dm = 0; dm < " + s + "; dm++) {\n              int d2 = d1 * " + s + " + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          hn = function hn(e) {
            this.variableNames = ["x", "W"], this.outputShape = e.outShape;
            var t = e.padInfo.top,
              n = e.padInfo.left,
              r = e.strideHeight,
              i = e.strideWidth,
              o = e.dilationHeight,
              a = e.dilationWidth,
              s = e.filterHeight,
              l = e.filterWidth,
              u = 4 * Math.floor(e.inChannels / 4),
              c = e.inChannels % 4;
            this.userCode = "\n      const ivec2 strides = ivec2(" + r + ", " + i + ");\n      const ivec2 pads = ivec2(" + t + ", " + n + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + s + "; wR++) {\n          int xR = xRCorner + wR * " + o + ";\n\n          if (xR < 0 || xR >= " + e.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + l + "; wC++) {\n            int xC = xCCorner + wC * " + a + ";\n\n            if (xC < 0 || xC >= " + e.inWidth + ") {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < " + u + "; d1 += 4) {\n              vec4 xValues = vec4(\n                getX(batch, xR, xC, d1),\n                getX(batch, xR, xC, d1 + 1),\n                getX(batch, xR, xC, d1 + 2),\n                getX(batch, xR, xC, d1 + 3)\n              );\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              dotProd += dot(xValues, wValues);\n            }\n\n            if (" + (1 === c) + ") {\n              dotProd +=\n                getX(batch, xR, xC, " + u + ") *\n                getW(wR, wC, " + u + ", d2);\n            } else if (" + (2 === c) + ") {\n              vec2 xValues = vec2(\n                getX(batch, xR, xC, " + u + "),\n                getX(batch, xR, xC, " + u + " + 1)\n              );\n              vec2 wValues = vec2(\n                getW(wR, wC, " + u + ", d2),\n                getW(wR, wC, " + u + " + 1, d2)\n              );\n              dotProd += dot(xValues, wValues);\n            } else if (" + (3 === c) + ") {\n              vec3 xValues = vec3(\n                getX(batch, xR, xC, " + u + "),\n                getX(batch, xR, xC, " + u + " + 1),\n                getX(batch, xR, xC, " + u + " + 2)\n              );\n              vec3 wValues = vec3(\n                getW(wR, wC, " + u + ", d2),\n                getW(wR, wC, " + u + " + 1, d2),\n                getW(wR, wC, " + u + " + 2, d2)\n              );\n              dotProd += dot(xValues, wValues);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          fn = function fn(e) {
            this.variableNames = ["x", "W"], this.outputShape = e.outShape;
            var t = e.inHeight,
              n = e.inWidth,
              r = e.padInfo.top,
              i = e.padInfo.left,
              o = e.strideHeight,
              a = e.strideWidth,
              s = e.dilationHeight,
              l = e.dilationWidth,
              u = e.filterHeight,
              c = e.filterWidth,
              d = e.outChannels / e.inChannels;
            this.userCode = "\n      const ivec2 strides = ivec2(" + o + ", " + a + ");\n      const ivec2 pads = ivec2(" + r + ", " + i + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / " + d + ";\n        int q = d2 - d1 * " + d + ";\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TODO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < " + u + "; wR++) {\n          int xR = xRCorner + wR * " + s + ";\n\n          if (xR < 0 || xR >= " + t + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + c + "; wC++) {\n            int xC = xCCorner + wC * " + l + ";\n\n            if (xC < 0 || xC >= " + n + ") {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          pn = function pn(e, t, n, r, i) {
            this.variableNames = ["Image", "Boxes", "BoxInd"], this.outputShape = [];
            var o = e[0],
              a = e[1],
              s = e[2],
              l = e[3],
              u = t[0],
              c = n[0],
              d = n[1];
            this.outputShape = [u, c, d, l];
            var h = "bilinear" === r ? 1 : 0,
              f = [a - 1 + ".0", s - 1 + ".0"],
              p = f[0],
              m = f[1],
              g = c > 1 ? ["" + (a - 1) / (c - 1), "(y2-y1) * height_ratio", "y1*" + p + " + float(y)*(height_scale)"] : ["0.0", "0.0", "0.5 * (y1+y2) * " + p],
              v = g[0],
              y = g[1],
              b = g[2],
              _ = d > 1 ? ["" + (s - 1) / (d - 1), "(x2-x1) * width_ratio", "x1*" + m + " + float(x)*(width_scale)"] : ["0.0", "0.0", "0.5 * (x1+x2) * " + m],
              x = _[0],
              w = _[1],
              S = _[2];
            this.userCode = "\n      const float height_ratio = float(" + v + ");\n      const float width_ratio = float(" + x + ");\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= " + o + ") {\n          return;\n        }\n\n        float height_scale = " + y + ";\n        float width_scale = " + w + ";\n\n        float in_y = " + b + ";\n        if( in_y < 0.0 || in_y > " + p + " ) {\n          setOutput(float(" + i + "));\n          return;\n        }\n        float in_x = " + S + ";\n        if( in_x < 0.0 || in_x > " + m + " ) {\n          setOutput(float(" + i + "));\n          return;\n        }\n\n        vec2 sourceFracIndexRC = vec2(in_y,in_x);\n        if(" + h + " == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n          ivec2 sourceCeilRC = ivec2(ceil(sourceFracIndexRC));\n\n          float topLeft = getImage(b, sourceFloorRC.x, sourceFloorRC.y, d);\n          float bottomLeft = getImage(b, sourceCeilRC.x, sourceFloorRC.y, d);\n          float topRight = getImage(b, sourceFloorRC.x, sourceCeilRC.y, d);\n          float bottomRight = getImage(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n          vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n          float top = topLeft + (topRight - topLeft) * fracRC.y;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n          float newValue = top + (bottom - top) * fracRC.x;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestRC = ivec2(floor(\n            sourceFracIndexRC + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestRC.x, sourceNearestRC.y, d);\n          setOutput(newValue);\n        }\n      }\n    ";
          };
        function mn(e, t, n) {
          void 0 === n && (n = "index");
          var r = z(t);
          return r.map(function (t, i) {
            return "int " + e[i] + " = " + n + " / " + t + "; " + (i === r.length - 1 ? "int " + e[i + 1] + " = " + n + " - " + e[i] + " * " + t : "index -= " + e[i] + " * " + t) + ";";
          }).join("");
        }
        function gn(e) {
          return 1 === e.length ? "" + e[0] : "vec" + e.length + "(" + e.join(",") + ")";
        }
        function vn(e, t, n, r, i) {
          var o = e.map(function (e) {
            var t = S(e.shapeInfo.logicalShape);
            return e.shapeInfo.isUniform ? "uniform float " + e.name + (t > 1 ? "[" + t + "]" : "") + ";" : "uniform sampler2D " + e.name + ";";
          });
          o = o.join("\n");
          var a,
            s,
            l = e.map(function (e) {
              return function (e, t, n) {
                var r = function (e) {
                  var t = e.name,
                    n = "get" + t.charAt(0).toUpperCase() + t.slice(1) + "Flat",
                    r = S(e.shapeInfo.logicalShape);
                  if (e.shapeInfo.isUniform) return 1 === r ? "float " + n + "(int index) {return " + t + ";}" : "\n      float " + n + "(int index) {\n        for (int i = 0; i < " + r + "; i++) {\n          if (i == index) {\n            return " + t + "[i];\n          }\n        }\n      }\n    ";
                  var i = e.shapeInfo.texShape,
                    o = i[0],
                    a = i[1];
                  return 1 === a && 1 === o ? "\n      float " + n + "(int index) {\n        return sampleTexture(" + t + ", halfCR);\n      }\n    " : 1 === a ? "\n      float " + n + "(int index) {\n        vec2 uv = vec2(0.5, (float(index) + 0.5) / " + o + ".0);\n        return sampleTexture(" + t + ", uv);\n      }\n    " : 1 === o ? "\n      float " + n + "(int index) {\n        vec2 uv = vec2((float(index) + 0.5) / " + a + ".0, 0.5);\n        return sampleTexture(" + t + ", uv);\n      }\n    " : "\n    float " + n + "(int index) {\n      vec2 uv = UVfrom1D(" + o + ", " + a + ", index);\n      return sampleTexture(" + t + ", uv);\n    }\n  ";
                }(e);
                return e.shapeInfo.isPacked ? r += bn(e) : r += yn(e), (n || A(e.shapeInfo.logicalShape, t.logicalShape)) && (r += function (e, t, n) {
                  var r = e.name,
                    i = r.charAt(0).toUpperCase() + r.slice(1),
                    o = "get" + i + "AtOutCoords",
                    a = Wt(e.shapeInfo.logicalShape, t.logicalShape),
                    s = e.shapeInfo.logicalShape.length,
                    l = t.logicalShape.length,
                    u = n && (l > s || a.length > 0),
                    c = function (e) {
                      for (var t = 0; t < e.length; t++) if (e[t] !== t) return !1;
                      return !0;
                    }(a),
                    d = e.shapeInfo.isUniform;
                  if (u && !c) return function (e, t, n, r) {
                    var i = e.shapeInfo.logicalShape.length,
                      o = t.logicalShape.length,
                      a = "int";
                    2 === o ? a = "ivec2" : 3 === o ? a = "ivec3" : 4 === o && (a = "ivec4");
                    var s = Wt(e.shapeInfo.logicalShape, t.logicalShape),
                      l = o - i;
                    return "\n    float " + r + "() {\n      " + a + " coords = getOutputCoords();\n      " + (0 === i ? "" : o < 2 && s.length >= 1 ? "coords = 0;" : s.map(function (e) {
                      return "coords[" + (e + l) + "] = 0;";
                    }).join("\n")) + "\n      return get" + n + "(" + (o < 2 && i > 0 ? "coords" : e.shapeInfo.logicalShape.map(function (e, t) {
                      return "coords[" + (t + l) + "]";
                    }).join(", ")) + ");\n    }\n  ";
                  }(e, t, i, o);
                  var h = S(e.shapeInfo.logicalShape),
                    f = "";
                  u && c && (f = "\n        int mainPart = index / " + h + ";\n        index -= mainPart * " + h + ";\n      ");
                  var p = t.texShape;
                  if (d) return 1 === h ? "float " + o + "() {return " + r + ";}" : "\n      float " + o + "() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                              vec2(" + p[0] + ", " + p[1] + "));\n        int index = resTexRC.x * " + p[1] + " + resTexRC.y;\n        " + f + "\n        return get" + i + "Flat(index);\n      }\n    ";
                  var m = e.shapeInfo.texShape;
                  return A(m, p) ? "\n      float " + o + "() {\n        return sampleTexture(" + r + ", resultUV);\n      }\n    " : "\n    float " + o + "() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + p[0] + ", " + p[1] + "));\n      int index = resTexRC.x * " + p[1] + " + resTexRC.y;\n      " + f + "\n      int texR = index / " + m[1] + ";\n      int texC = index - texR * " + m[1] + ";\n      vec2 uv = (vec2(texC, texR) + halfCR) /\n                 vec2(" + m[1] + ".0, " + m[0] + ".0);\n\n      return sampleTexture(" + r + ", uv);\n    }\n  ";
                }(e, t, n)), r;
              }(e, t, r);
            }).join("\n"),
            u = t.texShape,
            c = Sn;
          return t.isPacked ? (a = function (e, t) {
            switch (e.length) {
              case 0:
                return "\n    int getOutputCoords() {\n      return 0;\n    }\n  ";
              case 1:
                return function (e, t) {
                  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)];
                  return 1 === t[0] ? "\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * " + n[1] + ".0);\n      }\n    " : 1 === t[1] ? "\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * " + n[0] + ".0);\n      }\n    " : "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      return resTexRC.x * " + n[1] + " + resTexRC.y;\n    }\n  ";
                }(0, t);
              case 2:
                return function (e, t) {
                  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)];
                  if (A(e, t)) return "\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2(" + n[0] + ", " + n[1] + "));\n      }\n    ";
                  var r = Math.ceil(e[1] / 2);
                  return "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec2(r, c);\n    }\n  ";
                }(e, t);
              case 3:
                return function (e, t) {
                  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)],
                    r = Math.ceil(e[2] / 2),
                    i = r * Math.ceil(e[1] / 2);
                  return "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n\n      int b = index / " + i + ";\n      index -= b * " + i + ";\n\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec3(b, r, c);\n    }\n  ";
                }(e, t);
              case 4:
                return function (e, t) {
                  var n = [Math.ceil(t[0] / 2), Math.ceil(t[1] / 2)],
                    r = Math.ceil(e[3] / 2),
                    i = r * Math.ceil(e[2] / 2),
                    o = i * e[1];
                  return "\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n\n      int b2 = index / " + o + ";\n      index -= b2 * " + o + ";\n\n      int b = index / " + i + ";\n      index -= b * " + i + ";\n\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec4(b2, b, r, c);\n    }\n  ";
                }(e, t);
              default:
                throw new Error(e.length + "-D packed output coordinate fetching is not yet supported");
            }
          }(t.logicalShape, u), s = wn) : (a = function (e, t) {
            switch (e.length) {
              case 0:
                return "\n    int getOutputCoords() {\n      return 0;\n    }\n  ";
              case 1:
                return function (e, t) {
                  return 1 === t[0] ? "\n      int getOutputCoords() {\n        return int(resultUV.x * " + t[1] + ".0);\n      }\n    " : 1 === t[1] ? "\n      int getOutputCoords() {\n        return int(resultUV.y * " + t[0] + ".0);\n      }\n    " : "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + t[0] + ", " + t[1] + "));\n      return resTexRC.x * " + t[1] + " + resTexRC.y;\n    }\n  ";
                }(0, t);
              case 2:
                return function (e, t) {
                  return A(e, t) ? "\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(" + t[0] + ", " + t[1] + "));\n      }\n    " : 1 === e[1] ? "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + t[0] + ", " + t[1] + "));\n        int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    " : 1 === e[0] ? "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + t[0] + ", " + t[1] + "));\n        int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n        return ivec2(0, index);\n      }\n    " : "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n      int r = index / " + e[1] + ";\n      int c = index - r * " + e[1] + ";\n      return ivec2(r, c);\n    }\n  ";
                }(e, t);
              case 3:
                return function (e, t) {
                  var n = mn(["r", "c", "d"], e);
                  return "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n      " + n + "\n      return ivec3(r, c, d);\n    }\n  ";
                }(e, t);
              case 4:
                return function (e, t) {
                  var n = mn(["r", "c", "d", "d2"], e);
                  return "\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n      " + n + "\n      return ivec4(r, c, d, d2);\n    }\n  ";
                }(e, t);
              case 5:
                return function (e, t) {
                  var n = mn(["r", "c", "d", "d2", "d3"], e);
                  return "\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2(" + t[0] + ",\n                             " + t[1] + "));\n\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n\n      " + n + "\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  ";
                }(e, t);
              case 6:
                return function (e, t) {
                  var n = mn(["r", "c", "d", "d2", "d3", "d4"], e);
                  return "\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + t[0] + ", " + t[1] + "));\n      int index = resTexRC.x * " + t[1] + " + resTexRC.y;\n\n      " + n + "\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  ";
                }(e, t);
              default:
                throw new Error(e.length + "-D output sampling is not yet supported");
            }
          }(t.logicalShape, u), s = xn), i && (c += An), [c, _n, s, o, a, l, n].join("\n");
        }
        function yn(e) {
          var t = e.shapeInfo.logicalShape;
          switch (t.length) {
            case 0:
              return function (e) {
                var t = e.name,
                  n = "get" + t.charAt(0).toUpperCase() + t.slice(1);
                return e.shapeInfo.isUniform ? "float " + n + "() {return " + t + ";}" : "\n    float " + n + "() {\n      return sampleTexture(" + t + ", halfCR);\n    }\n  ";
              }(e);
            case 1:
              return function (e) {
                var t = e.name,
                  n = "get" + t.charAt(0).toUpperCase() + t.slice(1);
                return "\n    float " + n + "(int index) {\n      return " + n + "Flat(index);\n    }\n  ";
              }(e);
            case 2:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = e.shapeInfo.texShape;
                if (null != i && A(t, i)) {
                  var o = i[0];
                  return "\n    float " + r + "(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2(" + i[1] + ".0, " + o + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
                }
                var a = O(t),
                  s = a.newShape,
                  l = a.keptDims,
                  u = s;
                if (u.length < t.length) return "\n      " + yn(Tn(e, u)) + "\n      float " + r + "(int row, int col) {\n        return " + r + "(" + Mn(["row", "col"], l) + ");\n      }\n    ";
                if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col) {\n        float index = dot(vec2(row, col), vec2(" + t[1] + ", 1));\n        return " + r + "Flat(round(index));\n      }\n    ";
                var c = i[0],
                  d = i[1];
                return 1 === d ? "\n    float " + r + "(int row, int col) {\n      float index = dot(vec2(row, col), vec2(" + t[1] + ", 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / " + c + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  " : 1 === c ? "\n    float " + r + "(int row, int col) {\n      float index = dot(vec2(row, col), vec2(" + t[1] + ", 1));\n      vec2 uv = vec2((index + 0.5) / " + d + ".0, 0.5);\n      return sampleTexture(" + n + ", uv);\n    }\n  " : "\n  float " + r + "(int row, int col) {\n    vec2 uv = UVfrom2D(" + c + ", " + d + ", " + t[1] + ", row, col);\n    return sampleTexture(" + n + ", uv);\n  }\n";
              }(e);
            case 3:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = t[1] * t[2],
                  o = t[2],
                  a = O(t),
                  s = a.newShape,
                  l = a.keptDims,
                  u = s;
                if (u.length < t.length) return "\n        " + yn(Tn(e, u)) + "\n        float " + r + "(int row, int col, int depth) {\n          return " + r + "(" + Mn(["row", "col", "depth"], l) + ");\n        }\n      ";
                if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth) {\n        float index = dot(vec3(row, col, depth),\n                          vec3(" + i + ", " + o + ", 1));\n        return " + r + "Flat(round(index));\n      }\n    ";
                var c = e.shapeInfo.texShape,
                  d = c[0],
                  h = c[1];
                return h === i ? "\n        float " + r + "(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2(" + o + ", 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2(" + h + ".0, " + d + ".0);\n          return sampleTexture(" + n + ", uv);\n        }\n      " : h === o ? "\n    float " + r + "(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2(" + t[1] + ", 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + h + ".0, " + d + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  " : "\n      float " + r + "(int row, int col, int depth) {\n        vec2 uv = UVfrom3D(\n            " + d + ", " + h + ", " + i + ", " + o + ", row, col, depth);\n        return sampleTexture(" + n + ", uv);\n      }\n  ";
              }(e);
            case 4:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = t[3],
                  o = t[2] * i,
                  a = t[1] * o,
                  s = O(t),
                  l = s.newShape,
                  u = s.keptDims;
                if (l.length < t.length) return "\n      " + yn(Tn(e, l)) + "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        return " + r + "(" + Mn(["row", "col", "depth", "depth2"], u) + ");\n      }\n    ";
                if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float index = dot(vec4(row, col, depth, depth2),\n                          vec4(" + a + ", " + o + ", " + i + ", 1));\n        return " + r + "Flat(round(index));\n      }\n    ";
                var c = e.shapeInfo.texShape,
                  d = c[0],
                  h = c[1];
                return h === a ? "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2), vec3(" + o + ", " + i + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + h + ".0, " + d + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : h === i ? "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(" + t[1] * t[2] + ", " + t[2] + ", 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + h + ".0, " + d + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : "\n    float " + r + "(int row, int col, int depth, int depth2) {\n      vec2 uv = UVfrom4D(" + d + ", " + h + ", " + a + ", " + o + ",\n          " + i + ", row, col, depth, depth2);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
              }(e);
            case 5:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = t[4],
                  o = t[3] * i,
                  a = t[2] * o,
                  s = t[1] * a,
                  l = O(t),
                  u = l.newShape,
                  c = l.keptDims;
                if (u.length < t.length) return "\n      " + yn(Tn(e, u)) + "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        return " + r + "(" + Mn(["row", "col", "depth", "depth2", "depth3"], c) + ");\n      }\n    ";
                if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + s + ", " + a + ", " + o + ", " + i + ")) +\n          depth3;\n        return " + r + "Flat(index);\n      }\n    ";
                var d = e.shapeInfo.texShape,
                  h = d[0],
                  f = d[1];
                return f === s ? "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(\n          vec4(col, depth, depth2, depth3),\n          vec4(" + a + ", " + o + ", " + i + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + f + ".0, " + h + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : f === i ? "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + t[1] * t[2] * t[3] + ", " + t[2] * t[3] + ",\n            " + t[3] + ", 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + f + ".0, " + h + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : "\n    float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n      vec2 uv = UVfrom5D(" + h + ", " + f + ", " + s + ", " + a + ",\n          " + o + ", " + i + ", row, col, depth, depth2, depth3);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
              }(e);
            case 6:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = t[5],
                  o = t[4] * i,
                  a = t[3] * o,
                  s = t[2] * a,
                  l = t[1] * s,
                  u = O(t),
                  c = u.newShape,
                  d = u.keptDims;
                if (c.length < t.length) return "\n      " + yn(Tn(e, c)) + "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return " + r + "(" + Mn(["row", "col", "depth", "depth2", "depth3", "depth4"], d) + ");\n      }\n    ";
                if (e.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + l + ", " + s + ", " + a + ", " + o + ")) +\n          dot(\n            vec2(depth3, depth4),\n            vec2(" + i + ", 1));\n        return " + r + "Flat(index);\n      }\n    ";
                var h = e.shapeInfo.texShape,
                  f = h[0],
                  p = h[1];
                return p === l ? "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(\n          vec4(col, depth, depth2, depth3),\n          vec4(" + s + ", " + a + ", " + o + ", " + i + ")) + depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + p + ".0, " + f + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : p === i ? "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + t[1] * t[2] * t[3] * t[4] + ",\n               " + t[2] * t[3] * t[4] + ",\n               " + t[3] * t[4] + ",\n               " + t[4] + ")) + depth3;\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + p + ".0, " + f + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    " : "\n    float " + r + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      vec2 uv = UVfrom6D(" + f + ", " + p + ", " + l + ", " + s + ",\n          " + a + ", " + o + ", " + i + "\n          ,row, col, depth, depth2, depth3, depth4);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
              }(e);
            default:
              throw new Error(t.length + "-D input sampling is not yet supported");
          }
        }
        function bn(e) {
          var t = e.shapeInfo.logicalShape;
          switch (t.length) {
            case 1:
              return function (e) {
                var t = e.name,
                  n = "get" + t.charAt(0).toUpperCase() + t.slice(1),
                  r = e.shapeInfo.texShape,
                  i = [Math.ceil(r[0] / 2), Math.ceil(r[1] / 2)];
                return "\n    vec4 " + n + "(int index) {\n      vec2 uv = packedUVfrom1D(\n        " + i[0] + ", " + i[1] + ", index);\n      return texture2D(" + t + ", uv);\n    }\n  ";
              }(e);
            case 2:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = e.shapeInfo.texShape,
                  o = i[0],
                  a = i[1];
                if (null != i && A(t, i)) return "\n      vec4 " + r + "(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(" + a + ".0, " + o + ".0);\n\n        return texture2D(" + n + ", uv);\n      }\n    ";
                var s = [Math.ceil(i[0] / 2), Math.ceil(i[1] / 2)];
                return "\n    vec4 " + r + "(int row, int col) {\n      vec2 uv = packedUVfrom2D(" + Math.ceil(t[1] / 2) + ", " + s[0] + ", " + s[1] + ", row, col);\n      return texture2D(" + n + ", uv);\n    }\n  ";
              }(e);
            case 3:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = e.shapeInfo.texShape,
                  o = [Math.ceil(i[0] / 2), Math.ceil(i[1] / 2)];
                if (1 === t[0]) return "\n        " + bn(Tn(e, t.slice(1))) + "\n        vec4 " + r + "(int b, int row, int col) {\n          return " + r + "(" + Mn(["b", "row", "col"], [1, 2]) + ");\n        }\n      ";
                var a = o[0],
                  s = o[1],
                  l = Math.ceil(t[2] / 2);
                return "\n    vec4 " + r + "(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        " + a + ", " + s + ", " + l * Math.ceil(t[1] / 2) + ", " + l + ", b, row, col);\n      return texture2D(" + n + ", uv);\n    }\n  ";
              }(e);
            case 4:
              return function (e) {
                var t = e.shapeInfo.logicalShape,
                  n = e.name,
                  r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
                  i = e.shapeInfo.texShape,
                  o = [Math.ceil(i[0] / 2), Math.ceil(i[1] / 2)],
                  a = o[0],
                  s = o[1],
                  l = Math.ceil(t[3] / 2),
                  u = l * Math.ceil(t[2] / 2);
                return "\n    vec4 " + r + "(int b2, int b, int row, int col) {\n      vec2 uv = packedUVfrom4D(\n        " + a + ", " + s + ", " + u * t[1] + ",\n        " + u + ", " + l + ", b2, b, row, col);\n      return texture2D(" + n + ", uv);\n    }\n  ";
              }(e);
            default:
              throw new Error("Packed " + t.length + "-D input sampling is not yet supported");
          }
        }
        var _n = "\n  float sampleTexture(sampler2D textureSampler, vec2 uv) {\n    return texture2D(textureSampler, uv).r;\n  }\n",
          xn = "\n  void setOutput(float val) {\n    gl_FragColor = vec4(val, 0, 0, 0);\n  }\n",
          wn = "\n  void setOutput(vec4 val) {\n    gl_FragColor = val;\n  }\n",
          Sn = "\n  precision highp float;\n  precision highp int;\n  varying vec2 resultUV;\n  const vec2 halfCR = vec2(0.5, 0.5);\n\n  struct ivec5\n  {\n    int x;\n    int y;\n    int z;\n    int w;\n    int u;\n  };\n\n  struct ivec6\n  {\n    int x;\n    int y;\n    int z;\n    int w;\n    int u;\n    int v;\n  };\n\n  bool isNaN(float val) {\n    return (val < 1.0 || 0.0 < val || val == 0.0) ? false : true;\n  }\n\n  bool hasNaN(vec4 values) {\n    vec4 v1 = values * values;\n    vec4 v2 = values * values;\n    return any(notEqual(v1, v2));\n  }\n\n  float getNaN(vec4 values) {\n    return dot(vec4(1), values);\n  }\n\n  int round(float value) {\n    return int(floor(value + 0.5));\n  }\n\n  int imod(int x, int y) {\n    return x - y * (x / y);\n  }\n\n  //Based on the work of Dave Hoskins\n  //https://www.shadertoy.com/view/4djSRW\n  #define HASHSCALE1 443.8975\n  float random(float seed){\n    vec2 p = resultUV * seed;\n    vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n    p3 += dot(p3, p3.yzx + 19.19);\n    return fract((p3.x + p3.y) * p3.z);\n  }\n\n  \nvec2 UVfrom1D(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n\n  \nvec2 UVfrom2D(int texNumR, int texNumC, int numC, int row, int col) {\n  int index = row * numC + col;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n\n  \nvec2 UVfrom3D(int texNumR, int texNumC, int stride0,\n    int stride1, int row, int col, int depth) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n\n  \nvec2 UVfrom4D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int row, int col, int depth,\n    int depth2) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth * stride2 + depth2;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom4D(int texNumR, int texNumC, int texelsInBatch2,\n    int texelsInBatch, int texelsInLogicalRow, int b2, int b,\n    int row, int col) {\n  int index = b2 * texelsInBatch2 + b * texelsInBatch +\n    (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n\n  \nvec2 UVfrom5D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int stride3, int row, int col, int depth,\n    int depth2, int depth3) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 +\n              depth * stride2 + depth2 * stride3 + depth3;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n\n  \nvec2 UVfrom6D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int stride3, int stride4,\n    int row, int col, int depth, int depth2, int depth3, int depth4) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth * stride2 + depth2 *\n    stride3 + depth3 * stride4 + depth4;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n\n",
          An = "\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";
        function En(e) {
          if (e <= 1) return "int";
          if (2 === e) return "ivec2";
          if (3 === e) return "ivec3";
          if (4 === e) return "ivec4";
          if (5 === e) return "ivec5";
          if (6 === e) return "ivec6";
          throw Error("GPU for rank " + e + " is not yet supported");
        }
        function Tn(e, t) {
          var n = JSON.parse(JSON.stringify(e));
          return n.shapeInfo.logicalShape = t, n;
        }
        function Mn(e, t) {
          return t.map(function (t) {
            return e[t];
          }).join(", ");
        }
        var Cn = function Cn(e, t, n) {
          this.variableNames = ["x"], this.outputShape = e;
          var r = e.length,
            i = e[e.length - 1],
            o = n ? "<" : ">";
          this.userCode = "\n      int getIndex(int i) {\n        " + (n ? "return " + i + " -i - 1;" : "return i;") + "\n      }\n\n      void main() {\n        " + En(r) + " coords = getOutputCoords();\n        int end = " + kn(r, "coords") + ";\n        float val = 0.0;\n        for (int i = " + i + " - 1; i >= 0; i -= 1) {\n          int idx = getIndex(i);\n          if (idx " + o + " end) {\n            continue;\n          }\n          if (idx == end && " + t + ") {\n            continue;\n          }\n          " + kn(r, "coords") + " = idx;\n          val += getX(" + function (e, t) {
            if (1 === e) return "" + t;
            if (2 === e) return t + ".x, " + t + ".y";
            if (3 === e) return t + ".x, " + t + ".y, " + t + ".z";
            if (4 === e) return t + ".x, " + t + ".y, " + t + ".z, " + t + ".w";
            throw Error("Cumulative sum for rank " + e + " is not yet supported");
          }(r, "coords") + ");\n        }\n        setOutput(val);\n      }\n    ";
        };
        function kn(e, t) {
          if (1 === e) return "" + t;
          if (2 === e) return t + ".y";
          if (3 === e) return t + ".z";
          if (4 === e) return t + ".w";
          throw Error("Cumulative sum for rank " + e + " is not yet supported");
        }
        var Pn = function () {
            function e(e, t, n) {
              this.variableNames = ["x"], this.outputShape = [], this.outputShape = e, this.blockSize = t, this.dataFormat = n, this.userCode = "\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = " + this.getHeightCoordString() + ";\n      int w = " + this.getWidthCoordString() + ";\n      int d = " + this.getDepthCoordString() + ";\n\n      int in_h = h / " + t + ";\n      int offset_h = imod(h, " + t + ");\n      int in_w = w / " + t + ";\n      int offset_w = imod(w, " + t + ");\n      int offset_d = (offset_h * " + t + " + offset_w) *\n        " + this.getOutputDepthSize() + ";\n      int in_d = d + offset_d;\n\n      float result = " + this.getInputSamplingString() + ";\n      setOutput(result);\n    }\n  ";
            }
            return e.prototype.getHeightCoordString = function () {
              return "NHWC" === this.dataFormat ? "coords[1]" : "coords[2]";
            }, e.prototype.getWidthCoordString = function () {
              return "NHWC" === this.dataFormat ? "coords[2]" : "coords[3]";
            }, e.prototype.getDepthCoordString = function () {
              return "NHWC" === this.dataFormat ? "coords[3]" : "coords[1]";
            }, e.prototype.getOutputDepthSize = function () {
              return "NHWC" === this.dataFormat ? this.outputShape[3] : this.outputShape[1];
            }, e.prototype.getInputSamplingString = function () {
              return "NHWC" === this.dataFormat ? "getX(b, in_h, in_w, in_d)" : "getX(b, in_d, in_h, in_w)";
            }, e;
          }(),
          On = function On(e) {
            this.variableNames = ["A"], this.outputShape = e, this.userCode = "\n      const float FLOAT_MAX = 1.70141184e38;\n      const float FLOAT_MIN = 1.17549435e-38;\n\n      lowp vec4 encode_float(highp float v) {\n        if (isNaN(v)) {\n          return vec4(255, 255, 255, 255);\n        }\n\n        highp float av = abs(v);\n\n        if(av < FLOAT_MIN) {\n          return vec4(0.0, 0.0, 0.0, 0.0);\n        } else if(v > FLOAT_MAX) {\n          return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n        } else if(v < -FLOAT_MAX) {\n          return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n        }\n\n        highp vec4 c = vec4(0,0,0,0);\n\n        highp float e = floor(log2(av));\n        highp float m = exp2(fract(log2(av))) - 1.0;\n\n        c[2] = floor(128.0 * m);\n        m -= c[2] / 128.0;\n        c[1] = floor(32768.0 * m);\n        m -= c[1] / 32768.0;\n        c[0] = floor(8388608.0 * m);\n\n        highp float ebias = e + 127.0;\n        c[3] = floor(ebias / 2.0);\n        ebias -= c[3] * 2.0;\n        c[2] += floor(ebias) * 128.0;\n\n        c[3] += 128.0 * step(0.0, -v);\n\n        return c / 255.0;\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        gl_FragColor = encode_float(x);\n      }\n    ";
          },
          Rn = "return real * expR - imag * expI;",
          In = "return real * expI + imag * expR;",
          jn = function jn(e, t, n) {
            this.variableNames = ["real", "imag"];
            var r = t[1];
            this.outputShape = t;
            var i = n ? "2.0 * " + Math.PI : "-2.0 * " + Math.PI,
              o = n ? r + ".0" : "1.0";
            this.userCode = "\n      const float exponentMultiplier = " + i + ";\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        " + e + "\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float(" + r + ");\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < " + r + "; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / " + o + ";\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    ";
          },
          Nn = function Nn(e) {
            this.variableNames = ["A"];
            var t = e[0],
              n = e[1];
            this.outputShape = e, this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + n + ".0, " + t + ".0);\n\n        vec4 values = texture2D(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    ";
          },
          Ln = function Ln(e, t, n) {
            this.variableNames = ["A", "indices"];
            var r = e.slice();
            r[n] = t, this.outputShape = r, this.rank = r.length;
            var i = En(this.rank),
              o = function (e, t) {
                var n = e.length;
                if (n > 4) throw Error("Gather for rank " + n + " is not yet supported");
                if (1 === n) return "int(getIndices(resRC))";
                for (var r = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"], i = [], o = 0; o < e.length; o++) o === t ? i.push("int(getIndices(" + r[o] + "))") : i.push("" + r[o]);
                return i.join();
              }(e, n);
            this.userCode = "\n      void main() {\n        " + i + " resRC = getOutputCoords();\n        setOutput(getA(" + o + "));\n      }\n    ";
          };
        var Dn,
          Bn,
          Fn = function Fn(e, t, n) {
            this.sliceDim = e, this.strides = t, this.variableNames = ["x", "indices"], this.outputShape = n;
            var r = En(t.length),
              i = En(n.length),
              o = this.sliceDim > 1 ? "strides[j]" : "strides";
            this.userCode = "\n        " + r + " strides = " + r + "(" + this.strides + ");\n         void main() {\n          " + i + " coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < " + this.sliceDim + "; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * " + o + ";\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      ";
          };
        function zn(e, t) {
          return [t, e];
        }
        function Un(e, t) {
          return e * t;
        }
        function Gn(e, t, n) {
          var r = function (e, t) {
            if (e % t != 0) throw new Error("unpackedSize (" + e + ") must be a multiple of " + t);
            return e / t;
          }(e.length, n);
          if (t.length < r) throw new Error("matrix length (" + t.length + ") must be >= " + r);
          for (var i = 0, o = 0; o < e.length; o += n) t[i++] = e[o];
        }
        function Vn(e, t) {
          return [Math.ceil(t / 2), Math.ceil(e / 2)];
        }
        function Hn(e, t) {
          var n = Vn(e, t);
          return n[0] * n[1] * 4;
        }
        function qn(e, t) {
          var n = t();
          return Xn(e), n;
        }
        !function (e) {
          e[e.RENDER = 0] = "RENDER", e[e.UPLOAD = 1] = "UPLOAD", e[e.PIXELS = 2] = "PIXELS", e[e.DOWNLOAD = 3] = "DOWNLOAD";
        }(Dn || (Dn = {})), function (e) {
          e[e.UNPACKED_FLOAT16 = 0] = "UNPACKED_FLOAT16", e[e.UNPACKED_FLOAT32 = 1] = "UNPACKED_FLOAT32", e[e.PACKED_4X1_UNSIGNED_BYTE = 2] = "PACKED_4X1_UNSIGNED_BYTE", e[e.PACKED_2X2_FLOAT32 = 3] = "PACKED_2X2_FLOAT32", e[e.PACKED_2X2_FLOAT16 = 4] = "PACKED_2X2_FLOAT16";
        }(Bn || (Bn = {}));
        var Wn = !1;
        function $n(e) {
          Wn = e;
        }
        function Xn(e) {
          if (Wn) {
            var t = e.getError();
            if (t !== e.NO_ERROR) throw new Error("WebGL Error: " + Yn(e, t));
          }
        }
        function Yn(e, t) {
          switch (t) {
            case e.NO_ERROR:
              return "NO_ERROR";
            case e.INVALID_ENUM:
              return "INVALID_ENUM";
            case e.INVALID_VALUE:
              return "INVALID_VALUE";
            case e.INVALID_OPERATION:
              return "INVALID_OPERATION";
            case e.INVALID_FRAMEBUFFER_OPERATION:
              return "INVALID_FRAMEBUFFER_OPERATION";
            case e.OUT_OF_MEMORY:
              return "OUT_OF_MEMORY";
            case e.CONTEXT_LOST_WEBGL:
              return "CONTEXT_LOST_WEBGL";
            default:
              return "Unknown error code " + t;
          }
        }
        function Kn(e, t) {
          return yr(e, function () {
            return e.getExtension(t);
          }, 'Extension "' + t + '" not supported on this browser.');
        }
        function Zn(e, t) {
          var n = yr(e, function () {
            return e.createShader(e.VERTEX_SHADER);
          }, "Unable to create vertex WebGLShader.");
          if (qn(e, function () {
            return e.shaderSource(n, t);
          }), qn(e, function () {
            return e.compileShader(n);
          }), !1 === e.getShaderParameter(n, e.COMPILE_STATUS)) throw console.log(e.getShaderInfoLog(n)), new Error("Failed to compile vertex shader.");
          return n;
        }
        function Qn(e, t) {
          var n = yr(e, function () {
            return e.createShader(e.FRAGMENT_SHADER);
          }, "Unable to create fragment WebGLShader.");
          if (qn(e, function () {
            return e.shaderSource(n, t);
          }), qn(e, function () {
            return e.compileShader(n);
          }), !1 === e.getShaderParameter(n, e.COMPILE_STATUS)) throw function (e, t) {
            var n = Jn.exec(t);
            if (null == n) return console.log("Couldn't parse line number in error: " + t), void console.log(e);
            for (var r = +n[1], i = e.split("\n"), o = i.length.toString().length + 2, a = i.map(function (e, t) {
                return C((t + 1).toString(), o) + e;
              }), s = 0, l = 0; l < a.length; l++) s = Math.max(a[l].length, s);
            var u = a.slice(0, r - 1),
              c = a.slice(r - 1, r),
              d = a.slice(r);
            console.log(u.join("\n")), console.log(t.split("\n")[0]), console.log("%c " + C(c[0], s), "border:1px solid red; background-color:#e3d2d2; color:#a61717"), console.log(d.join("\n"));
          }(t, e.getShaderInfoLog(n)), new Error("Failed to compile fragment shader.");
          return n;
        }
        var Jn = /ERROR: [0-9]+:([0-9]+):/g;
        function er(e) {
          return yr(e, function () {
            return e.createProgram();
          }, "Unable to create WebGLProgram.");
        }
        function tr(e, t) {
          if (qn(e, function () {
            return e.linkProgram(t);
          }), !1 === e.getProgramParameter(t, e.LINK_STATUS)) throw console.log(e.getProgramInfoLog(t)), new Error("Failed to link vertex and fragment shaders.");
        }
        function nr(e, t) {
          if (qn(e, function () {
            return e.validateProgram(t);
          }), !1 === e.getProgramParameter(t, e.VALIDATE_STATUS)) throw console.log(e.getProgramInfoLog(t)), new Error("Shader program validation failed.");
        }
        function rr(e, t) {
          var n = yr(e, function () {
            return e.createBuffer();
          }, "Unable to create WebGLBuffer");
          return qn(e, function () {
            return e.bindBuffer(e.ARRAY_BUFFER, n);
          }), qn(e, function () {
            return e.bufferData(e.ARRAY_BUFFER, t, e.STATIC_DRAW);
          }), n;
        }
        function ir(e, t) {
          var n = yr(e, function () {
            return e.createBuffer();
          }, "Unable to create WebGLBuffer");
          return qn(e, function () {
            return e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, n);
          }), qn(e, function () {
            return e.bufferData(e.ELEMENT_ARRAY_BUFFER, t, e.STATIC_DRAW);
          }), n;
        }
        function or() {
          return 2 === ve.get("WEBGL_VERSION") ? 1 : 4;
        }
        function ar(e) {
          return yr(e, function () {
            return e.createTexture();
          }, "Unable to create WebGLTexture.");
        }
        function sr(e, t) {
          var n = ve.get("WEBGL_MAX_TEXTURE_SIZE");
          if (e <= 0 || t <= 0) {
            var r = "[" + e + "x" + t + "]";
            throw new Error("Requested texture size " + r + " is invalid.");
          }
          if (e > n || t > n) throw r = "[" + e + "x" + t + "]", new Error("Requested texture size " + r + " greater than WebGL maximum on this browser / GPU [" + n + "x" + n + "].");
        }
        function lr(e) {
          return yr(e, function () {
            return e.createFramebuffer();
          }, "Unable to create WebGLFramebuffer.");
        }
        function ur(e, t, n, r, i, o, a) {
          var s = e.getAttribLocation(t, n);
          return -1 !== s && (qn(e, function () {
            return e.bindBuffer(e.ARRAY_BUFFER, r);
          }), qn(e, function () {
            return e.vertexAttribPointer(s, i, e.FLOAT, !1, o, a);
          }), qn(e, function () {
            return e.enableVertexAttribArray(s);
          }), !0);
        }
        function cr(e, t, n) {
          br(e, n), qn(e, function () {
            return e.activeTexture(e.TEXTURE0 + n);
          }), qn(e, function () {
            return e.bindTexture(e.TEXTURE_2D, t);
          });
        }
        function dr(e, t, n) {
          return yr(e, function () {
            return e.getUniformLocation(t, n);
          }, 'uniform "' + n + '" not present in program.');
        }
        function hr(e, t, n) {
          return e.getUniformLocation(t, n);
        }
        function fr(e, t, n, r, i) {
          qn(e, function () {
            return cr(e, n, i);
          }), qn(e, function () {
            return e.uniform1i(r, i);
          });
        }
        function pr(e, t, n) {
          qn(e, function () {
            return e.bindFramebuffer(e.FRAMEBUFFER, n);
          }), qn(e, function () {
            return e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t, 0);
          });
        }
        function mr(e, t) {
          qn(e, function () {
            return e.bindFramebuffer(e.FRAMEBUFFER, t);
          }), qn(e, function () {
            return e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, null, 0);
          });
        }
        function gr(e) {
          var t = e.checkFramebufferStatus(e.FRAMEBUFFER);
          if (t !== e.FRAMEBUFFER_COMPLETE) throw new Error("Error binding framebuffer: " + vr(e, t));
        }
        function vr(e, t) {
          switch (t) {
            case e.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
              return "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
            case e.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
              return "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
            case e.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
              return "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
            case e.FRAMEBUFFER_UNSUPPORTED:
              return "FRAMEBUFFER_UNSUPPORTED";
            default:
              return "unknown error " + t;
          }
        }
        function yr(e, t, n) {
          var r = qn(e, function () {
            return t();
          });
          if (null == r) throw new Error(n);
          return r;
        }
        function br(e, t) {
          var n = e.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1,
            r = t + e.TEXTURE0;
          if (r < e.TEXTURE0 || r > n) throw new Error("textureUnit must be in [gl.TEXTURE0, gl.TEXTURE" + n + "].");
        }
        function _r(e, t) {
          void 0 === t && (t = !1);
          var n = ve.get("WEBGL_MAX_TEXTURE_SIZE");
          if (t && (n *= 2, e = e.map(function (t, n) {
            return n >= e.length - 2 ? g(e[n]) : e[n];
          })), 2 !== e.length) {
            var r = O(e);
            e = r.newShape;
          }
          var i = S(e);
          return e.length <= 1 && i <= n ? [i, 1] : 2 === e.length && e[0] <= n && e[1] <= n ? e : 3 === e.length && e[0] * e[1] <= n && e[2] <= n ? [e[0] * e[1], e[2]] : 3 === e.length && e[0] <= n && e[1] * e[2] <= n ? [e[0], e[1] * e[2]] : 4 === e.length && e[0] * e[1] * e[2] <= n && e[3] <= n ? [e[0] * e[1] * e[2], e[3]] : 4 === e.length && e[0] <= n && e[1] * e[2] * e[3] <= n ? [e[0], e[1] * e[2] * e[3]] : M(i);
        }
        function xr(e) {
          return e % 2 == 0;
        }
        function wr(e, t) {
          if (A(e = e.slice(-2), t = t.slice(-2))) return !0;
          if (!e.length || !t.length) return !0;
          if (0 === e[0] || 0 === e[1] || 0 === t[0] || 0 === t[1]) return !0;
          if (e.length !== t.length) {
            var n = e.slice(-1)[0],
              r = t.slice(-1)[0];
            if (n === r) return !0;
            if (xr(n) && xr(r) && (1 === e[0] || 1 === t[0])) return !0;
          } else if (xr(e[0]) && xr(t[0])) {
            if (xr(e[1]) && xr(t[1])) return !0;
            if (e[1] === t[1]) return !0;
          }
          return !1;
        }
        var Sr = Object.freeze({
          callAndCheck: qn,
          enableDebugWebGLErrorChecking: $n,
          checkWebGLError: Xn,
          getWebGLErrorMessage: Yn,
          getExtensionOrThrow: Kn,
          createVertexShader: Zn,
          createFragmentShader: Qn,
          createProgram: er,
          linkProgram: tr,
          validateProgram: nr,
          createStaticVertexBuffer: rr,
          createStaticIndexBuffer: ir,
          getNumChannels: or,
          createTexture: ar,
          validateTextureSize: sr,
          createFramebuffer: lr,
          bindVertexBufferToProgramAttribute: ur,
          bindTextureUnit: cr,
          unbindTextureUnit: function unbindTextureUnit(e, t) {
            br(e, t), qn(e, function () {
              return e.activeTexture(e.TEXTURE0 + t);
            }), qn(e, function () {
              return e.bindTexture(e.TEXTURE_2D, null);
            });
          },
          getProgramUniformLocationOrThrow: dr,
          getProgramUniformLocation: hr,
          bindTextureToProgramUniformSampler: fr,
          bindCanvasToFramebuffer: function bindCanvasToFramebuffer(e) {
            qn(e, function () {
              return e.bindFramebuffer(e.FRAMEBUFFER, null);
            }), qn(e, function () {
              return e.viewport(0, 0, e.canvas.width, e.canvas.height);
            }), qn(e, function () {
              return e.scissor(0, 0, e.canvas.width, e.canvas.height);
            });
          },
          bindColorTextureToFramebuffer: pr,
          unbindColorTextureFromFramebuffer: mr,
          validateFramebuffer: gr,
          getFramebufferErrorMessage: vr,
          getTextureShapeFromLogicalShape: _r,
          isReshapeFree: wr
        });
        function Ar(e) {
          return Zn(e, "\n    precision highp float;\n    attribute vec3 clipSpacePos;\n    attribute vec2 uv;\n    varying vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }");
        }
        function Er(e) {
          return rr(e, new Float32Array([-1, 1, 0, 0, 1, -1, -1, 0, 0, 0, 1, 1, 0, 1, 1, 1, -1, 0, 1, 0]));
        }
        function Tr(e) {
          return ir(e, new Uint16Array([0, 1, 2, 2, 1, 3]));
        }
        function Mr(e, t) {
          var n,
            r,
            i,
            o,
            a,
            s,
            l,
            u = e;
          return 2 === ve.get("WEBGL_VERSION") ? (n = u.R32F, r = u.R16F, i = u.RGBA32F, o = u.RED, a = 4, s = 1, l = u.HALF_FLOAT) : (n = e.RGBA, r = e.RGBA, i = u.RGBA, o = e.RGBA, a = 4, s = 4, l = null != t ? t.HALF_FLOAT_OES : null), {
            internalFormatFloat: n,
            internalFormatHalfFloat: r,
            internalFormatPackedFloat: i,
            textureFormatFloat: o,
            downloadTextureFormat: e.RGBA,
            downloadUnpackNumChannels: a,
            defaultNumChannels: s,
            textureTypeHalfFloat: l
          };
        }
        function Cr(e, t, n, r, i, o) {
          sr(t, n);
          var a = ar(e),
            s = e.TEXTURE_2D;
          return qn(e, function () {
            return e.bindTexture(s, a);
          }), qn(e, function () {
            return e.texParameteri(s, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
          }), qn(e, function () {
            return e.texParameteri(s, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
          }), qn(e, function () {
            return e.texParameteri(s, e.TEXTURE_MIN_FILTER, e.NEAREST);
          }), qn(e, function () {
            return e.texParameteri(s, e.TEXTURE_MAG_FILTER, e.NEAREST);
          }), qn(e, function () {
            return e.texImage2D(s, 0, r, t, n, 0, i, o, null);
          }), qn(e, function () {
            return e.bindTexture(e.TEXTURE_2D, null);
          }), a;
        }
        function kr(e, t, n, r) {
          var i = zn(t, n);
          return Cr(e, i[0], i[1], r.internalFormatFloat, r.textureFormatFloat, e.FLOAT);
        }
        function Pr(e, t, n, r) {
          var i = zn(t, n);
          return Cr(e, i[0], i[1], r.internalFormatFloat, r.textureFormatFloat, r.textureTypeHalfFloat);
        }
        function Or(e, t, n, r) {
          var i = zn(t, n);
          return Cr(e, i[0], i[1], e.RGBA, e.RGBA, e.UNSIGNED_BYTE);
        }
        function Rr(e, t, n, r) {
          var i = Vn(t, n);
          return Cr(e, i[0], i[1], r.internalFormatPackedFloat, e.RGBA, e.FLOAT);
        }
        function Ir(e, t, n, r) {
          var i = Vn(t, n);
          return Cr(e, i[0], i[1], r.internalFormatHalfFloat, e.RGBA, r.textureTypeHalfFloat);
        }
        function jr(e, t, n) {
          return qn(e, function () {
            return e.bindBuffer(e.ARRAY_BUFFER, n);
          }), ur(e, t, "clipSpacePos", n, 3, 20, 0) && ur(e, t, "uv", n, 2, 20, 12);
        }
        function Nr(e, t, n) {
          qn(e, function () {
            return e.bindTexture(e.TEXTURE_2D, t);
          }), qn(e, function () {
            return e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, n);
          }), qn(e, function () {
            return e.bindTexture(e.TEXTURE_2D, null);
          });
        }
        function Lr(e, t, n, r, i, o) {
          sr(n, r), qn(e, function () {
            return e.bindTexture(e.TEXTURE_2D, t);
          }), qn(e, function () {
            return e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, n, r, o, e.FLOAT, i);
          }), qn(e, function () {
            return e.bindTexture(e.TEXTURE_2D, null);
          });
        }
        function Dr(e, t, n, r, i, o, a) {
          var s,
            l = zn(n, r),
            u = l[0],
            c = l[1];
          1 === a.defaultNumChannels ? s = i : function (e, t, n) {
            var r = Un(e.length, n);
            if (t.length < r) throw new Error("unpackedArray length (" + t.length + ") must be >= " + r);
            for (var i = 0, o = 0; o < e.length; ++o) t[i] = e[o], i += n;
          }(i, s = new Float32Array(Un(i.length, o)), o), Lr(e, t, u, c, s, a.textureFormatFloat);
        }
        function Br(e, t, n, r, i, o, a) {
          var s = Vn(r, i),
            l = s[0],
            u = s[1],
            c = new Float32Array(Hn(r, i));
          (function (e, t, n, r, i) {
            var o = Hn(n, r);
            if (i.length < o) throw new Error("packedRGBA length (" + i.length + ") must be >=\n        " + o);
            for (var a = r % 2 == 1, s = n % 2 == 1, l = Math.floor(r / 2), u = Math.floor(n / 2), c = Math.ceil(r / 2), d = c * Math.ceil(n / 2), h = g(n) * g(r), f = 0; f < t; f++) {
              for (var p = f * n * r, m = f * h, v = a ? 4 : 0, y = r, b = m, _ = 0; _ < u; ++_) {
                for (var x = 2 * _ * r, w = 0; w < l; ++w) {
                  var S = p + x + 2 * w;
                  i[b] = e[S], i[b + 1] = e[S + 1], i[b + 2] = e[S + y], i[b + 3] = e[S + y + 1], b += 4;
                }
                b += v;
              }
              if (a) {
                S = p + r - 1, b = m + 4 * (c - 1);
                var A = 2 * r;
                for (v = 4 * c, _ = 0; _ < u; ++_) i[b] = e[S], i[b + 2] = e[S + r], S += A, b += v;
              }
              if (s) {
                for (S = p + (n - 1) * r, b = m + 4 * (d - c), w = 0; w < l; ++w) i[b++] = e[S++], i[b++] = e[S++], b += 2;
                a && s && (i[m + h - 4] = e[S]);
              }
            }
          })(o, n, r, i, c), Lr(e, t, l, u, c, e.RGBA);
        }
        function Fr(e, t, n, r, i) {
          var o = t;
          if (2 === ve.get("WEBGL_VERSION")) {
            var a = e,
              s = a.createBuffer();
            qn(e, function () {
              return e.bindBuffer(a.PIXEL_PACK_BUFFER, s);
            });
            var l = 4 * Un(n * r, i.downloadUnpackNumChannels);
            qn(e, function () {
              return e.bufferData(a.PIXEL_PACK_BUFFER, l, e.STATIC_DRAW);
            }), qn(e, function () {
              return a.readPixels(0, 0, r, n, e.RGBA, e.FLOAT, 0);
            }), qn(e, function () {
              return e.bindBuffer(a.PIXEL_PACK_BUFFER, null);
            }), o = s;
          }
          return o;
        }
        function zr(e, t, n, r, i) {
          var o = e,
            a = new Float32Array(Un(n * r, i.downloadUnpackNumChannels));
          o.bindBuffer(e.ARRAY_BUFFER, t), o.getBufferSubData(e.ARRAY_BUFFER, 0, a), o.bindBuffer(e.ARRAY_BUFFER, null);
          var s = new Float32Array(n * r);
          return Gn(a, s, i.downloadUnpackNumChannels), s;
        }
        function Ur(e, t, n, r) {
          var i = zn(t, n),
            o = i[0],
            a = i[1],
            s = new Float32Array(Un(t * n, r.downloadUnpackNumChannels));
          qn(e, function () {
            return e.readPixels(0, 0, o, a, r.downloadTextureFormat, e.FLOAT, s);
          });
          var l = new Float32Array(t * n);
          return Gn(s, l, r.downloadUnpackNumChannels), l;
        }
        function Gr(e, t, n, r) {
          var i = zn(t, n),
            o = i[0],
            a = i[1],
            s = new Uint8Array(Un(t * n, 4));
          return qn(e, function () {
            return e.readPixels(0, 0, o, a, r.downloadTextureFormat, e.UNSIGNED_BYTE, s);
          }), new Float32Array(s.buffer);
        }
        function Vr(e, t, n, r, i, o, a) {
          var s = Vn(i, o),
            l = s[0],
            u = s[1],
            c = new Float32Array(Hn(i, o));
          qn(e, function () {
            return e.readPixels(0, 0, l, u, e.RGBA, e.FLOAT, c);
          });
          var d = new Float32Array(S([t, n, r]));
          return function (e, t, n, r, i) {
            var o = n * r;
            if (i.length < o) throw new Error("matrix length (" + i.length + ") must be >= " + o);
            for (var a = r % 2 == 1, s = n % 2 == 1, l = Math.floor(r / 2), u = Math.floor(n / 2), c = Math.ceil(r / 2), d = c * Math.ceil(n / 2), h = g(n) * g(r), f = 0; f < t; f++) {
              for (var p = f * n * r, m = f * h, v = a ? 4 : 0, y = r + (a ? 1 : 0), b = m, _ = p, x = p + r, w = 0; w < u; ++w) {
                for (var S = 0; S < l; ++S) i[_++] = e[b++], i[_++] = e[b++], i[x++] = e[b++], i[x++] = e[b++];
                b += v, _ += y, x += y;
              }
              if (a) {
                b = m + 4 * (c - 1);
                var A = p + r - 1;
                for (v = 4 * c, y = 2 * r, w = 0; w < u; ++w) i[A] = e[b], i[A + r] = e[b + 2], b += v, A += y;
              }
              if (s) {
                for (b = m + 4 * (d - c), A = p + (n - 1) * r, S = 0; S < l; ++S) i[A++] = e[b++], i[A++] = e[b++], b += 2;
                a && (i[p + n * r - 1] = e[b]);
              }
            }
            return i;
          }(c, t, n, r, d);
        }
        var Hr = Object.freeze({
            createVertexShader: Ar,
            createVertexBuffer: Er,
            createIndexBuffer: Tr,
            getTextureConfig: Mr,
            createFloat32MatrixTexture: kr,
            createFloat16MatrixTexture: Pr,
            createUnsignedBytesMatrixTexture: Or,
            createPackedMatrixTexture: Rr,
            createFloat16PackedMatrixTexture: Ir,
            bindVertexProgramAttributeStreams: jr,
            uploadPixelDataToTexture: Nr,
            uploadMatrixToTexture: Dr,
            uploadMatrixToPackedTexture: Br,
            maybeCreateBufferFromOutputTexture: Fr,
            downloadFloat32MatrixFromBuffer: zr,
            downloadFloat32MatrixFromOutputTexture: Ur,
            downloadByteEncodedFloatMatrixFromOutputTexture: Gr,
            downloadMatrixFromPackedOutputTexture: Vr
          }),
          qr = function () {
            function e(e) {
              this.outputTexture = null, this.program = null, this.disposed = !1, this.autoDebugValidate = !1, this.vertexAttrsAreBound = !1, this.itemsToPoll = [], this.gl = null != e ? e : f(ve.get("WEBGL_VERSION")), 1 === ve.get("WEBGL_VERSION") ? (this.textureFloatExtension = Kn(this.gl, "OES_texture_float"), this.colorBufferFloatExtension = this.gl.getExtension("WEBGL_color_buffer_float"), ve.get("WEBGL_RENDER_FLOAT32_ENABLED") || (this.textureHalfFloatExtension = Kn(this.gl, "OES_texture_half_float"), this.colorBufferHalfFloatExtension = this.gl.getExtension("EXT_color_buffer_half_float"))) : this.colorBufferFloatExtension = Kn(this.gl, "EXT_color_buffer_float"), this.vertexBuffer = Er(this.gl), this.indexBuffer = Tr(this.gl), this.framebuffer = lr(this.gl), this.textureConfig = Mr(this.gl, this.textureHalfFloatExtension);
            }
            return e.prototype.dispose = function () {
              var e = this;
              if (!this.disposed) {
                null != this.program && console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."), null != this.outputTexture && console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
                var t = this.gl;
                qn(t, function () {
                  return t.finish();
                }), qn(t, function () {
                  return t.bindFramebuffer(t.FRAMEBUFFER, null);
                }), qn(t, function () {
                  return t.deleteFramebuffer(e.framebuffer);
                }), qn(t, function () {
                  return t.bindBuffer(t.ARRAY_BUFFER, null);
                }), qn(t, function () {
                  return t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, null);
                }), qn(t, function () {
                  return t.deleteBuffer(e.indexBuffer);
                }), this.disposed = !0;
              }
            }, e.prototype.enableAutomaticDebugValidation = function (e) {
              this.autoDebugValidate = e, $n(e);
            }, e.prototype.createFloat32MatrixTexture = function (e, t) {
              return this.throwIfDisposed(), kr(this.gl, e, t, this.textureConfig);
            }, e.prototype.createFloat16MatrixTexture = function (e, t) {
              return this.throwIfDisposed(), Pr(this.gl, e, t, this.textureConfig);
            }, e.prototype.createUnsignedBytesMatrixTexture = function (e, t) {
              return this.throwIfDisposed(), Or(this.gl, e, t, this.textureConfig);
            }, e.prototype.uploadPixelDataToTexture = function (e, t) {
              this.throwIfDisposed(), Nr(this.gl, e, t);
            }, e.prototype.createFloat16PackedMatrixTexture = function (e, t) {
              return this.throwIfDisposed(), Ir(this.gl, e, t, this.textureConfig);
            }, e.prototype.createPackedMatrixTexture = function (e, t) {
              return this.throwIfDisposed(), Rr(this.gl, e, t, this.textureConfig);
            }, e.prototype.deleteMatrixTexture = function (e) {
              var t = this;
              this.throwIfDisposed(), this.outputTexture === e && (mr(this.gl, this.framebuffer), this.outputTexture = null), qn(this.gl, function () {
                return t.gl.deleteTexture(e);
              });
            }, e.prototype.uploadMatrixToTexture = function (e, t, n, r) {
              this.throwIfDisposed();
              var i = or();
              return Dr(this.gl, e, t, n, r, i, this.textureConfig);
            }, e.prototype.uploadMatrixToPackedTexture = function (e, t, n, r, i) {
              return this.throwIfDisposed(), Br(this.gl, e, t, n, r, i, this.textureConfig);
            }, e.prototype.downloadFloat32MatrixFromOutputTexture = function (e, t, n) {
              var r = this;
              return this.downloadMatrixDriver(e, function () {
                return Ur(r.gl, t, n, r.textureConfig);
              });
            }, e.prototype.downloadByteEncodedFloatMatrixFromOutputTexture = function (e, t, n) {
              var r = this;
              return this.downloadMatrixDriver(e, function () {
                return Gr(r.gl, t, n, r.textureConfig);
              });
            }, e.prototype.downloadFloat32MatrixFromBuffer = function (e, t, n) {
              return zr(this.gl, e, t, n, this.textureConfig);
            }, e.prototype.maybeCreateBufferFromTexture = function (e, t, n) {
              this.bindTextureToFrameBuffer(e);
              var r = Fr(this.gl, e, t, n, this.textureConfig);
              return this.unbindTextureToFrameBuffer(), r;
            }, e.prototype.createAndWaitForFence = function () {
              var e = this.createFence(this.gl);
              return this.pollFence(e);
            }, e.prototype.createFence = function (e) {
              var t,
                n,
                r = this;
              if (ve.get("WEBGL_FENCE_API_ENABLED")) {
                var i = e,
                  o = i.fenceSync(i.SYNC_GPU_COMMANDS_COMPLETE, 0);
                e.flush(), n = function n() {
                  var e = i.clientWaitSync(o, 0, 0);
                  return e === i.ALREADY_SIGNALED || e === i.CONDITION_SATISFIED;
                }, t = o;
              } else ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (t = this.beginQuery(), this.endQuery(), n = function n() {
                return r.isQueryAvailable(t, ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
              }) : n = function n() {
                return !0;
              };
              return {
                query: t,
                isFencePassed: n
              };
            }, e.prototype.downloadMatrixFromPackedTexture = function (e, t, n, r, i, o) {
              var a = this;
              return this.downloadMatrixDriver(e, function () {
                return Vr(a.gl, t, n, r, i, o, a.textureConfig);
              });
            }, e.prototype.createProgram = function (e) {
              this.throwIfDisposed();
              var t = this.gl,
                n = Qn(t, e),
                r = Ar(t),
                i = er(t);
              return qn(t, function () {
                return t.attachShader(i, r);
              }), qn(t, function () {
                return t.attachShader(i, n);
              }), tr(t, i), this.autoDebugValidate && nr(t, i), this.vertexAttrsAreBound || (this.setProgram(i), this.vertexAttrsAreBound = jr(t, this.program, this.vertexBuffer)), i;
            }, e.prototype.deleteProgram = function (e) {
              var t = this;
              this.throwIfDisposed(), e === this.program && (this.program = null), null != e && qn(this.gl, function () {
                return t.gl.deleteProgram(e);
              });
            }, e.prototype.setProgram = function (e) {
              var t = this;
              this.throwIfDisposed(), this.program = e, null != this.program && this.autoDebugValidate && nr(this.gl, this.program), qn(this.gl, function () {
                return t.gl.useProgram(e);
              });
            }, e.prototype.getUniformLocation = function (e, t, n) {
              return void 0 === n && (n = !0), this.throwIfDisposed(), n ? dr(this.gl, e, t) : hr(this.gl, e, t);
            }, e.prototype.getAttributeLocation = function (e, t) {
              var n = this;
              return this.throwIfDisposed(), qn(this.gl, function () {
                return n.gl.getAttribLocation(e, t);
              });
            }, e.prototype.getUniformLocationNoThrow = function (e, t) {
              return this.throwIfDisposed(), this.gl.getUniformLocation(e, t);
            }, e.prototype.setInputMatrixTexture = function (e, t, n) {
              this.throwIfDisposed(), this.throwIfNoProgram(), fr(this.gl, this.program, e, t, n);
            }, e.prototype.setOutputMatrixTexture = function (e, t, n) {
              this.setOutputMatrixTextureDriver(e, n, t);
            }, e.prototype.setOutputPackedMatrixTexture = function (e, t, n) {
              this.throwIfDisposed();
              var r = Vn(t, n),
                i = r[0],
                o = r[1];
              this.setOutputMatrixTextureDriver(e, i, o);
            }, e.prototype.setOutputMatrixWriteRegion = function (e, t, n, r) {
              this.setOutputMatrixWriteRegionDriver(n, e, r, t);
            }, e.prototype.setOutputPackedMatrixWriteRegion = function (e, t, n, r) {
              throw new Error("setOutputPackedMatrixWriteRegion not implemented.");
            }, e.prototype.debugValidate = function () {
              null != this.program && nr(this.gl, this.program), gr(this.gl);
            }, e.prototype.executeProgram = function () {
              this.throwIfDisposed(), this.throwIfNoProgram();
              var e = this.gl;
              this.autoDebugValidate && this.debugValidate(), qn(e, function () {
                return e.drawElements(e.TRIANGLES, 6, e.UNSIGNED_SHORT, 0);
              });
            }, e.prototype.blockUntilAllProgramsCompleted = function () {
              var e = this;
              this.throwIfDisposed(), qn(this.gl, function () {
                return e.gl.finish();
              });
            }, e.prototype.getQueryTimerExtension = function () {
              return null == this.disjointQueryTimerExtension && (this.disjointQueryTimerExtension = Kn(this.gl, 2 === ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") ? "EXT_disjoint_timer_query_webgl2" : "EXT_disjoint_timer_query")), this.disjointQueryTimerExtension;
            }, e.prototype.getQueryTimerExtensionWebGL2 = function () {
              return this.getQueryTimerExtension();
            }, e.prototype.getQueryTimerExtensionWebGL1 = function () {
              return this.getQueryTimerExtension();
            }, e.prototype.beginQuery = function () {
              if (2 === ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
                var e = this.gl,
                  t = this.getQueryTimerExtensionWebGL2(),
                  n = e.createQuery();
                return e.beginQuery(t.TIME_ELAPSED_EXT, n), n;
              }
              var r = this.getQueryTimerExtensionWebGL1(),
                i = r.createQueryEXT();
              return r.beginQueryEXT(r.TIME_ELAPSED_EXT, i), i;
            }, e.prototype.endQuery = function () {
              if (2 !== ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
                var e = this.getQueryTimerExtensionWebGL1();
                e.endQueryEXT(e.TIME_ELAPSED_EXT);
              } else {
                var t = this.gl,
                  n = this.getQueryTimerExtensionWebGL2();
                t.endQuery(n.TIME_ELAPSED_EXT);
              }
            }, e.prototype.waitForQueryAndGetTime = function (e) {
              return u(this, void 0, void 0, function () {
                var t = this;
                return c(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return [4, k(function () {
                        return t.disposed || t.isQueryAvailable(e, ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
                      })];
                    case 1:
                      return n.sent(), [2, this.getQueryTime(e, ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))];
                  }
                });
              });
            }, e.prototype.getQueryTime = function (e, t) {
              if (0 === t) return null;
              if (2 === t) {
                var n = this.gl;
                return n.getQueryParameter(e, n.QUERY_RESULT) / 1e6;
              }
              var r = this.getQueryTimerExtensionWebGL1();
              return r.getQueryObjectEXT(e, r.QUERY_RESULT_EXT) / 1e6;
            }, e.prototype.isQueryAvailable = function (e, t) {
              if (0 === t) return !0;
              if (2 === t) {
                var n = this.gl,
                  r = this.getQueryTimerExtensionWebGL2(),
                  i = n.getQueryParameter(e, n.QUERY_RESULT_AVAILABLE);
                return null == this.disjoint && (this.disjoint = this.gl.getParameter(r.GPU_DISJOINT_EXT)), i && !this.disjoint;
              }
              return i = (r = this.getQueryTimerExtensionWebGL1()).getQueryObjectEXT(e, r.QUERY_RESULT_AVAILABLE_EXT), null == this.disjoint && (this.disjoint = this.gl.getParameter(r.GPU_DISJOINT_EXT)), i && !this.disjoint;
            }, e.prototype.pollFence = function (e) {
              var t = this;
              return new Promise(function (n) {
                t.addItemToPoll(function () {
                  return e.isFencePassed();
                }, function () {
                  return n();
                });
              });
            }, e.prototype.pollItems = function () {
              for (var e = function (e) {
                  for (var t = 0, n = e.length - 1, r = -1; t <= n;) {
                    var i = t + n >> 1;
                    e[i]() ? (r = i, t = i + 1) : n = i - 1;
                  }
                  return r;
                }(this.itemsToPoll.map(function (e) {
                  return e.isDoneFn;
                })), t = 0; t <= e; ++t) (0, this.itemsToPoll[t].resolveFn)();
              this.itemsToPoll = this.itemsToPoll.slice(e + 1);
            }, e.prototype.addItemToPoll = function (e, t) {
              var n = this;
              this.itemsToPoll.push({
                isDoneFn: e,
                resolveFn: t
              }), this.itemsToPoll.length > 1 || k(function () {
                return n.pollItems(), 0 === n.itemsToPoll.length;
              });
            }, e.prototype.bindTextureToFrameBuffer = function (e) {
              this.throwIfDisposed(), pr(this.gl, e, this.framebuffer), this.autoDebugValidate && gr(this.gl);
            }, e.prototype.unbindTextureToFrameBuffer = function () {
              null != this.outputTexture ? (pr(this.gl, this.outputTexture, this.framebuffer), this.autoDebugValidate && gr(this.gl)) : mr(this.gl, this.framebuffer);
            }, e.prototype.downloadMatrixDriver = function (e, t) {
              this.bindTextureToFrameBuffer(e);
              var n = t();
              return this.unbindTextureToFrameBuffer(), n;
            }, e.prototype.setOutputMatrixTextureDriver = function (e, t, n) {
              this.throwIfDisposed();
              var r = this.gl;
              pr(r, e, this.framebuffer), this.autoDebugValidate && gr(r), this.outputTexture = e, qn(r, function () {
                return r.viewport(0, 0, t, n);
              }), qn(r, function () {
                return r.scissor(0, 0, t, n);
              });
            }, e.prototype.setOutputMatrixWriteRegionDriver = function (e, t, n, r) {
              var i = this;
              this.throwIfDisposed(), qn(this.gl, function () {
                return i.gl.scissor(e, t, n, r);
              });
            }, e.prototype.throwIfDisposed = function () {
              if (this.disposed) throw new Error("Attempted to use disposed GPGPUContext.");
            }, e.prototype.throwIfNoProgram = function () {
              if (null == this.program) throw new Error("No GPU program is currently set.");
            }, e;
          }();
        function Wr(e, t) {
          if (e.length !== t.length) throw Error("Binary was compiled with " + e.length + " inputs, but was executed with " + t.length + " inputs");
          e.forEach(function (e, n) {
            var r = e.logicalShape,
              i = t[n],
              o = i.shape;
            if (!A(r, o)) throw Error("Binary was compiled with different shapes than the current args. Shapes " + r + " and " + o + " must match");
            if (!e.isUniform || !i.isUniform) {
              var a = e.texShape,
                s = i.isUniform ? null : i.texData.texShape;
              if (!A(a, s)) throw Error("Binary was compiled with different texture shapes than the current args. Shape " + a + " and " + s + " must match");
            }
          });
        }
        var $r = function $r(e, t, n) {
            this.variableNames = ["A"], this.outputShape = e;
            var r = n.filterWidth,
              i = n.inChannels,
              o = n.strideWidth,
              a = n.strideHeight,
              s = n.padInfo,
              l = n.outWidth,
              u = n.dilationWidth,
              c = n.dilationHeight,
              d = s.left,
              h = s.top,
              f = i * r;
            this.userCode = "\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            int blockIndex = rc.y + col;\n            int pos = rc.x + row;\n\n            if(blockIndex >= " + e[1] + " || pos >= " + e[0] + ") continue;\n\n            int offsetY = int(blockIndex / (" + l + ")) * " + a + " - " + h + ";\n            int d0 = offsetY + " + c + " * (pos / " + f + ");\n\n            if(d0 >= " + t[0] + " || d0 < 0) continue;\n\n            int offsetX = int(mod(float(blockIndex), " + l + ".) * " + o + ". - " + d + ".);\n            int d1 = offsetX + " + u + " * (int(mod(float(pos), " + f + ".) / " + i + ".));\n\n            if(d1 >= " + t[1] + " || d1 < 0) continue;\n\n            result[row * 2 + col] = getA(d0, d1, int(mod(float(pos), " + i + ".)));\n          }\n        }\n\n        gl_FragColor = result;\n      }\n    ";
          },
          Xr = function Xr(e, t, n, r, i) {
            this.variableNames = ["x"], this.outputShape = [];
            var o,
              a = t,
              s = e[3] - 1;
            this.outputShape = e;
            var l = "float(" + n + ") + float(" + r + ") * sum";
            o = .5 === i ? "inversesqrt(" + l + ")" : 1 === i ? "1.0/(" + l + ")" : "exp(log(" + l + ") * float(-" + i + "));", this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -" + a + "; j <= " + a + "; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  " + s + ") {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * " + o + ";\n        setOutput(val);\n      }\n    ";
          },
          Yr = function Yr(e, t, n, r, i) {
            this.variableNames = ["inputImage", "outputImage", "dy"], this.outputShape = [], this.outputShape = e, this.depth = e[3], this.depthRadius = t, this.bias = n, this.alpha = r, this.beta = i, this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < " + this.depth + "; ++d) {\n          int depthBegin = int(max(0.0, float(d - " + t + ")));\n          int depthEnd = int(min(float(" + this.depth + "),\n              float(d + " + t + " + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = " + this.depth + ";\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float(" + r + ") * norm + float(" + n + ");\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float(" + r + ")\n                * float(" + i + ")\n                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * " + i + ");\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    ";
          },
          Kr = function Kr(e) {
            this.variableNames = ["dy", "maxPos"], this.outputShape = e.inShape;
            var t = e.strideHeight,
              n = e.strideWidth,
              r = e.dilationHeight,
              i = e.effectiveFilterHeight,
              o = e.effectiveFilterWidth,
              a = i - 1 - e.padInfo.top,
              s = o - 1 - e.padInfo.left,
              l = i * o - 1;
            this.userCode = "\n      const ivec2 pads = ivec2(" + a + ", " + s + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + i + ";\n          wR += " + r + ") {\n          float dyR = float(dyRCorner + wR) / " + t + ".0;\n\n          if (dyR < 0.0 || dyR >= " + e.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + o + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + n + ".0;\n\n            if (dyC < 0.0 || dyC >= " + e.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = " + l + " - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * " + o + " + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
          },
          Zr = function Zr(e, t, n, r) {
            void 0 === n && (n = !1), void 0 === r && (r = !1), this.variableNames = ["matrixA", "matrixB"];
            var i = e[0],
              o = n ? e[2] : e[1],
              a = r ? t[1] : t[2],
              s = n ? e[1] : e[2];
            this.outputShape = [i, o, a];
            var l = function l(e, t) {
                return n ? "batch, " + t + " + " + e + ", aRow" : "batch, aRow, " + t + " + " + e;
              },
              u = function u(e, t) {
                return r ? "batch, bCol, " + t + " + " + e : "batch, " + t + " + " + e + ", bCol";
              },
              c = 4 * Math.floor(s / 4),
              d = s % 4;
            this.userCode = " float dotARowBCol(int batch, int aRow, int bCol) {\n      float result = 0.0;\n      for (int i = 0; i < " + c + "; i += 4) {\n        vec4 a = vec4(\n          getMatrixA(" + l(0, "i") + "),\n          getMatrixA(" + l(1, "i") + "),\n          getMatrixA(" + l(2, "i") + "),\n          getMatrixA(" + l(3, "i") + ")\n        );\n        vec4 b = vec4(\n          getMatrixB(" + u(0, "i") + "),\n          getMatrixB(" + u(1, "i") + "),\n          getMatrixB(" + u(2, "i") + "),\n          getMatrixB(" + u(3, "i") + ")\n        );\n\n        result += dot(a, b);\n      }\n\n      if (" + (1 === d) + ") {\n        result += getMatrixA(" + l(0, c) + ") *\n          getMatrixB(" + u(0, c) + ");\n      } else if (" + (2 === d) + ") {\n        vec2 a = vec2(\n          getMatrixA(" + l(0, c) + "),\n          getMatrixA(" + l(1, c) + ")\n        );\n        vec2 b = vec2(\n          getMatrixB(" + u(0, c) + "),\n          getMatrixB(" + u(1, c) + ")\n        );\n        result += dot(a, b);\n      } else if (" + (3 === d) + ") {\n        vec3 a = vec3(\n          getMatrixA(" + l(0, c) + "),\n          getMatrixA(" + l(1, c) + "),\n          getMatrixA(" + l(2, c) + ")\n        );\n        vec3 b = vec3(\n          getMatrixB(" + u(0, c) + "),\n          getMatrixB(" + u(1, c) + "),\n          getMatrixB(" + u(2, c) + ")\n        );\n        result += dot(a, b);\n      }\n\n      return result;\n    }\n\n    void main() {\n      ivec3 resBRC = getOutputCoords();\n      setOutput(dotARowBCol(resBRC.x, resBRC.y, resBRC.z));\n    }\n    ";
          },
          Qr = function Qr(e, t, n, r, i) {
            void 0 === r && (r = !1), void 0 === i && (i = !1), this.variableNames = ["matrixA", "matrixB"], this.usesPackedTextures = !0, this.outputShape = n;
            var o = r ? e[0] : e[1],
              a = Math.ceil(o / 2),
              s = r ? "i * 2, rc.x" : "rc.x, i * 2",
              l = i ? "rc.y, i * 2" : "i * 2, rc.y",
              u = r ? ["a.xxyy", "a.zzww"] : ["a.xxzz", "a.yyww"],
              c = i ? ["b.xzxz", "b.ywyw"] : ["b.xyxy", "b.zwzw"];
            this.userCode = "\n      const float sharedDimension = " + a + ".0;\n\n      vec4 dot2x2ARowBCol(ivec2 rc) {\n        vec4 result = vec4(0);\n        for (int i = 0; i < " + a + "; i++) {\n          vec4 a = getMatrixA(" + s + ");\n          vec4 b = getMatrixB(" + l + ");\n\n          result += (" + u[0] + " * " + c[0] + ") + (" + u[1] + " * " + c[1] + ");\n        }\n        return result;\n      }\n\n      void main() {\n        ivec2 rc = getOutputCoords();\n        setOutput(dot2x2ARowBCol(rc));\n      }\n    ";
          },
          Jr = function () {
            function e(e, t, n) {
              this.variableNames = ["probs"], this.outputShape = [e, n], this.userCode = "\n      uniform float seed;\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < " + (t - 1) + "; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float(" + (t - 1) + "));\n      }\n    ";
            }
            return e.prototype.getCustomSetupFunc = function (e) {
              var t = this;
              return function (n, r) {
                null == t.seedLoc && (t.seedLoc = n.getUniformLocation(r, "seed")), n.gl.uniform1f(t.seedLoc, e);
              };
            }, e;
          }(),
          ei = function ei(e, t, n, r) {
            this.variableNames = ["indices"], this.outputShape = [e, t], this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float(" + r + "), float(" + n + "),\n                      float(index == coords.y)));\n      }\n    ";
          };
        function ti(e, t) {
          return 1 === t ? [e] : function (e, t) {
            return ["x", "y", "z", "w", "u", "v"].slice(0, t).map(function (t) {
              return e + "." + t;
            });
          }(e, t);
        }
        var ni = function ni(e) {
          this.variableNames = ["A"], this.outputShape = e;
          var t = e.length,
            n = ti("rc", t),
            r = En(t),
            i = function (e, t, n) {
              if (1 === e) return "rc > " + t[0];
              for (var r = "", i = e - 2; i < e; i++) r += n[i] + " >= " + t[i], i < e - 1 && (r += "||");
              return r;
            }(t, e, n),
            o = function (e, t, n, r) {
              if (1 === e) return "";
              var i = r.slice(-2);
              return "\n    int r = " + i[0] + ";\n    int c = " + i[1] + ";\n    int rp1 = r + 1;\n    int cp1 = c + 1;\n\n    bool cEdge = cp1 >= " + t + ";\n    bool rEdge = rp1 >= " + n + ";\n  ";
            }(t, e[e.length - 1], e[e.length - 2], n),
            a = function (e, t) {
              var n = e.length,
                r = function (e, t) {
                  for (var n = [], r = 0; r <= 1; r++) for (var i = 0; i <= 1; i++) {
                    for (var o = (0 === r ? "r" : "rp1") + ", " + (0 === i ? "c" : "cp1"), a = 2; a < e; a++) o = t[t.length - 1 - a] + "," + o;
                    n.push(o);
                  }
                  return n;
                }(n, t);
              return 1 === n ? "getA(rc),\n            rc + 1 >= " + e[0] + " ? 0. : getA(rc + 1),\n            0, 0" : "getA(" + r[0] + "),\n          cEdge ? 0. : getA(" + r[1] + "),\n          rEdge ? 0. : getA(" + r[2] + "),\n          rEdge || cEdge ? 0. : getA(" + r[3] + ")";
            }(e, n);
          this.userCode = "\n      void main() {\n        " + r + " rc = getOutputCoords();\n\n        if(" + i + ") {\n          gl_FragColor = vec4(0);\n        } else {\n          " + o + "\n\n          setOutput(vec4(" + a + "));\n        }\n      }\n    ";
        };
        var ri = function ri(e, t, n) {
            this.variableNames = ["x"], this.outputShape = t.map(function (t, n) {
              return t[0] + e[n] + t[1];
            });
            var r = e.length,
              i = En(r),
              o = t.map(function (e) {
                return e[0];
              }).join(","),
              a = t.map(function (t, n) {
                return t[0] + e[n];
              }).join(","),
              s = ["coords[0]", "coords[1]", "coords[2]", "coords[3]"].slice(0, r);
            this.userCode = 1 !== r ? "\n      " + i + " start = " + i + "(" + o + ");\n      " + i + " end = " + i + "(" + a + ");\n\n      void main() {\n        " + i + " outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(float(" + n + "));\n        } else {\n          " + i + " coords = outC - start;\n          setOutput(getX(" + s + "));\n        }\n      }\n    " : "\n        int start = " + o + ";\n        int end = " + a + ";\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(float(" + n + "));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      ";
          },
          ii = function ii(e, t, n) {
            if (this.variableNames = ["x"], "avg" === t && n) throw new Error("Cannot compute positions for average pool.");
            var r = e.filterWidth,
              i = e.strideHeight,
              o = e.strideWidth,
              a = e.dilationHeight,
              s = e.dilationWidth,
              l = e.effectiveFilterHeight,
              u = e.effectiveFilterWidth,
              c = e.padInfo.top,
              d = e.padInfo.left;
            this.outputShape = e.outShape;
            var h = "avg" === t,
              f = "0.0";
            if (h || (f = "-1.0 / 0.0"), n) this.userCode = "\n        const ivec2 strides = ivec2(" + i + ", " + o + ");\n        const ivec2 pads = ivec2(" + c + ", " + d + ");\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < " + l + ";\n              wR += " + a + ") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= " + e.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + u + ";\n                wC += " + s + ") {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= " + e.inWidth + ") {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value >= currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = wR * " + u + " + wC;\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";else {
              var p = t + "(" + t + "(" + t + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
              "avg" === t && (p = "avgValue / count");
              var m = 4 * Math.floor(r / 4),
                g = r % 4,
                v = "\n      if (" + h + ") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    ";
              this.userCode = "\n      const ivec2 strides = ivec2(" + i + ", " + o + ");\n      const ivec2 pads = ivec2(" + c + ", " + d + ");\n      const float initializationValue = " + f + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= " + e.inWidth + ") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(" + f + ");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < " + l + ";\n            wR += " + a + ") {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= " + e.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + m + "; wC += 4) {\n            int xC = xCCorner + wC * " + s + ";\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              getValue(batch, xR, xC + 2 * " + s + ", d),\n              getValue(batch, xR, xC + 3 * " + s + ", d)\n            );\n\n            " + v + "\n          }\n\n          int xC = xCCorner + " + m + ";\n          if (" + (1 === g) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            " + v + "\n          } else if (" + (2 === g) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              initializationValue,\n              initializationValue\n            );\n\n            " + v + "\n          } else if (" + (3 === g) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              getValue(batch, xR, xC + 2 * " + s + ", d),\n              initializationValue\n            );\n\n            " + v + "\n          }\n        }\n        setOutput(" + p + ");\n      }\n    ";
            }
          },
          oi = function oi(e, t) {
            this.variableNames = ["x"];
            var n = e.windowSize,
              r = e.batchSize,
              i = e.inSize,
              o = Math.ceil(i / n);
            this.outputShape = [r, o];
            var a = "0.0",
              s = "";
            "prod" === t ? a = "1.0" : "min" === t ? (a = "1.0 / 0.0", s = "min") : "max" === t && (a = "-1.0 / 0.0", s = "max");
            var l = t + "(" + t + "(" + t + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
            "sum" === t ? l = "sumValue" : "prod" === t ? l = "prodValue" : "all" === t ? l = "allValue" : "any" === t && (l = "anyValue");
            var u = 4 * Math.floor(n / 4),
              c = n % 4,
              d = "\n      if (" + ("sum" === t) + ") {\n        sumValue += dot(values, ones);\n      } else if (" + ("prod" === t) + ") {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = " + s + "(values, minMaxValue);\n      }\n    ",
              h = "vec4";
            "all" === t ? (a = "1.0", d = "\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ", h = "bvec4") : "any" === t && (a = "0.0", d = "\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ", h = "bvec4");
            var f = "";
            i % n > 0 && (f = "\n        if (inIdx < 0 || inIdx >= " + i + ") {\n          return initializationValue;\n        }\n      "), this.userCode = "\n      const float initializationValue = " + a + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        " + f + "\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + n + ";\n\n        vec4 minMaxValue = vec4(" + a + ");\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < " + u + "; i += 4) {\n          int inIdx = inOffset + i;\n          " + h + " values = " + h + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          " + d + "\n        }\n\n        int inIdx = inOffset + " + u + ";\n        if (" + (1 === c) + ") {\n          " + h + " values = " + h + "(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          " + d + "\n        } else if (" + (2 === c) + ") {\n          " + h + " values = " + h + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          " + d + "\n        } else if (" + (3 === c) + ") {\n          " + h + " values = " + h + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          " + d + "\n        }\n        setOutput(" + l + ");\n      }\n    ";
          },
          ai = function ai(e, t) {
            this.variableNames = ["A"], this.usesPackedTextures = !0, this.outputShape = e;
            for (var n = "", r = 0; r < 4; r++) {
              var i = "thisRC = rc;";
              r % 2 == 1 && (i += "thisRC.z += 1;"), r > 1 && (i += "thisRC.y += 1;"), n += "\n        " + i + "\n        " + (r > 0 ? "if(thisRC.y < rows && thisRC.z < cols){" : "") + "\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[" + r + "] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        " + (r > 0 ? "}" : "") + "\n      ";
            }
            this.userCode = "\n      " + function (e) {
              return "\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      " + mn(["r", "c", "d"], e) + "\n      return ivec3(r, c, d);\n    }\n  ";
            }(t) + "\n      " + function (e) {
              return "\n    int getFlatIndex(ivec3 coords) {\n      return round(" + function (e, t) {
                if (e.length !== t.length) throw new Error("Vectors to be dotted must be of the same length -got " + e.length + " and " + t.length);
                for (var n = [], r = Math.floor(e.length / 4), i = e.length % 4, o = 0; o < r; o++) {
                  var a = e.slice(4 * o, 4 * o + 4),
                    s = t.slice(4 * o, 4 * o + 4);
                  n.push(gn(a) + ", " + gn(s));
                }
                return 0 !== i && (a = e.slice(4 * r), s = t.slice(4 * r), 1 === a.length && (a = a.map(function (e) {
                  return "float(" + e + ")";
                }), s = s.map(function (e) {
                  return "float(" + e + ")";
                })), n.push(gn(a) + ", " + gn(s))), n.map(function (e, t) {
                  return "dot(" + e + ")";
                }).join("+");
              }(["coords.x", "coords.y", "coords.z"], z(e).map(function (e) {
                return e.toString();
              }).concat(["1."])) + ");\n    }\n  ";
            }(e) + "\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = " + e[1] + ";\n        int cols = " + e[2] + ";\n\n        " + n + "\n\n        setOutput(result);\n      }\n    ";
          };
        var si = function si(e, t, n) {
            this.variableNames = ["dy"], this.outputShape = [], this.outputShape = t.shape;
            var r = t.shape,
              i = r[1],
              o = r[2],
              a = e.shape,
              s = a[1],
              l = a[2],
              u = [n && s > 1 ? i - 1 : i, n && l > 1 ? o - 1 : o],
              c = [n && s > 1 ? s - 1 : s, n && l > 1 ? l - 1 : l],
              d = u[0] / c[0],
              h = u[1] / c[1],
              f = 1 / d,
              p = 1 / h,
              m = 2 * Math.ceil(f) + 2,
              g = 2 * Math.ceil(p) + 2;
            this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + d + ");\n        const float widthScale = float(" + h + ");\n\n        const float invHeightScale = float(" + f + ");\n        const float invWidthScale = float(" + p + ");\n\n        const int winHeight = int(" + m + ");\n        const int winWidth = int(" + g + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + s + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + l + ") {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), " + (i - 1) + ".0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), " + (o - 1) + ".0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
          },
          li = function li(e, t, n, r) {
            this.variableNames = ["A"], this.outputShape = [];
            var i = e[0],
              o = e[1],
              a = e[2],
              s = e[3];
            this.outputShape = [i, t, n, s];
            var l = [r && t > 1 ? o - 1 : o, r && n > 1 ? a - 1 : a],
              u = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n];
            this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + l[0] / u[0] + ",\n          " + l[1] / u[1] + ");\n      const vec2 inputShapeRC = vec2(" + o + ".0, " + a + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    ";
          },
          ui = function ui(e, t, n) {
            this.variableNames = ["dy"], this.outputShape = [], this.outputShape = t.shape;
            var r = t.shape,
              i = r[1],
              o = r[2],
              a = e.shape,
              s = a[1],
              l = a[2],
              u = [n && s > 1 ? i - 1 : i, n && l > 1 ? o - 1 : o],
              c = [n && s > 1 ? s - 1 : s, n && l > 1 ? l - 1 : l],
              d = u[0] / c[0],
              h = u[1] / c[1],
              f = 1 / d,
              p = 1 / h,
              m = 2 * Math.ceil(f) + 2,
              g = 2 * Math.ceil(p) + 2;
            this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + d + ");\n        const float widthScale = float(" + h + ");\n\n        const float invHeightScale = float(" + f + ");\n        const float invWidthScale = float(" + p + ");\n\n        const int winHeight = int(" + m + ");\n        const int winWidth = int(" + g + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + s + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + l + ") {\n              continue;\n            }\n\n            float sourceFracRow =\n              float(" + u[0] + ") *\n                (float(dyR) / float(" + c[0] + "));\n\n            float sourceFracCol =\n                float(" + u[1] + ") *\n                  (float(dyC) / float(" + c[1] + "));\n\n            int sourceNearestRow = int(min(\n                float(int(" + i + ") - 1),\n                " + n + " ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int(" + o + ") - 1),\n                " + n + " ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
          },
          ci = function ci(e, t, n, r) {
            this.variableNames = ["A"], this.outputShape = [];
            var i = e[0],
              o = e[1],
              a = e[2],
              s = e[3];
            this.outputShape = [i, t, n, s];
            var l = [r && t > 1 ? o - 1 : o, r && n > 1 ? a - 1 : a],
              u = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n],
              c = r ? "0.5" : "0.0";
            this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + l[0] / u[0] + ",\n          " + l[1] / u[1] + ");\n      const vec2 inputShapeRC = vec2(" + o + ".0, " + a + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + " + c + ")));\n\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    ";
          },
          di = function di(e, t) {
            this.variableNames = ["x"];
            var n = e.length;
            if (n > 4) throw new Error("WebGL backend: Reverse of rank-" + n + " tensor is not yet supported");
            if (this.outputShape = e, 1 !== n) {
              var r = e.map(function (n, r) {
                  return function (n) {
                    return -1 !== t.indexOf(n) && 1 !== e[n] ? e[n] + " - coords[" + n + "] - 1" : "coords[" + n + "]";
                  }(r);
                }).join(","),
                i = En(n);
              this.userCode = "\n      void main() {\n        " + i + " coords = getOutputCoords();\n        setOutput(getX(" + r + "));\n      }\n    ";
            } else this.userCode = "\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX(" + e[0] + " - coord - 1));\n        }\n      ";
          },
          hi = function hi(e, t, n, r, i, o, a) {
            void 0 === a && (a = !0), this.variableNames = ["updates", "indices", "defaultValue"], this.outputShape = o;
            var s = En(i.length),
              l = En(o.length),
              u = "";
            1 === n ? u = "i" : 2 === n && (u = "i, j");
            var c = "getIndices(" + u + ")",
              d = "";
            1 === r ? d = "i" : 2 === r && (d = "i, coords[1]");
            var h = "getUpdates(" + d + ")",
              f = t > 1 ? "strides[j]" : "strides";
            this.userCode = "\n        " + s + " strides = " + s + "(" + i + ");\n\n        void main() {\n          " + l + " coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < " + e + "; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < " + t + "; j++) {\n              int index = round(" + c + ");\n              flattenedIndex += index * " + f + ";\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += " + h + ";\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      ";
          },
          fi = function fi(e, t) {
            this.variableNames = ["x", "segmentIds"];
            var n = e.windowSize,
              r = e.batchSize,
              i = e.inSize,
              o = e.numSegments,
              a = o * Math.ceil(i / n);
            this.outputShape = [r, a];
            var s = 4 * Math.floor(n / 4),
              l = n % 4,
              u = "\n        sumValue += dot(values, filter);\n    ",
              c = "";
            i % n > 0 && (c = "\n        if (inIdx < 0 || inIdx >= " + i + ") {\n          return initializationValue;\n        }\n      ");
            var d = "";
            i % n > 0 && (d = "\n        if (inIdx < 0 || inIdx >= " + i + ") {\n          return -1.0;\n        }\n      "), this.userCode = "\n      const float initializationValue = 0.0;\n\n      float getValue(int batch, int inIdx) {\n        " + c + "\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        " + d + "\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          " + o + ")) * float(" + n + "));\n        int currentSeg = int(mod(float(outIdx), float(" + o + ")));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < " + s + "; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          " + u + "\n        }\n\n        int inIdx = inOffset + " + s + ";\n        if (" + (1 === l) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          " + u + "\n        } else if (" + (2 === l) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          " + u + "\n        } else if (" + (3 === l) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          " + u + "\n        }\n        setOutput(sumValue);\n      }\n    ";
          },
          pi = function pi(e, t, n) {
            var r, i;
            if (this.variableNames = ["c", "a", "b"], this.outputShape = t, n > 4) throw Error("Where for rank " + n + " is not yet supported");
            if (1 === n) i = "resRC", r = "resRC";else {
              for (var o = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"], a = [], s = [], l = 0; l < t.length; l++) s.push("" + o[l]), l < e && a.push("" + o[l]);
              r = a.join(), i = s.join();
            }
            var u = En(n);
            this.userCode = "\n      void main() {\n        " + u + " resRC = getOutputCoords();\n        float cVal = getC(" + r + ");\n        if (cVal >= 1.0) {\n          setOutput(getA(" + i + "));\n        } else {\n          setOutput(getB(" + i + "));\n        }\n      }\n    ";
          },
          mi = function () {
            function e(e) {
              this.variableNames = ["source"], this.outputShape = e, this.rank = e.length;
              var t = En(this.rank),
                n = function (e) {
                  if (1 === e) return "sourceLoc";
                  if (2 === e) return "sourceLoc.x, sourceLoc.y";
                  if (3 === e) return "sourceLoc.x, sourceLoc.y, sourceLoc.z";
                  if (4 === e) return "sourceLoc.x, sourceLoc.y, sourceLoc.z, sourceLoc.w";
                  throw Error("Slicing for rank " + e + " is not yet supported");
                }(this.rank);
              this.userCode = "\n      uniform " + t + " start;\n\n      void main() {\n        " + t + " sourceLoc = start + getOutputCoords();\n        setOutput(getSource(" + n + "));\n      }\n    ";
            }
            return e.prototype.getCustomSetupFunc = function (e) {
              var t = this;
              if (e.length !== this.rank) throw Error("The rank (" + this.rank + ") of the program must match the length of start (" + e.length + ")");
              return function (n, r) {
                if (null != t.startLoc || (t.startLoc = n.getUniformLocationNoThrow(r, "start"), null != t.startLoc)) if (1 === t.rank) n.gl.uniform1i(t.startLoc, e[0]);else if (2 === t.rank) n.gl.uniform2i(t.startLoc, e[0], e[1]);else if (3 === t.rank) n.gl.uniform3i(t.startLoc, e[0], e[1], e[2]);else {
                  if (4 !== t.rank) throw Error("Slicing for rank " + t.rank + " is not yet supported");
                  n.gl.uniform4i(t.startLoc, e[0], e[1], e[2], e[3]);
                }
              };
            }, e;
          }();
        var gi = function gi(e, t, n, r) {
            this.variableNames = ["x"];
            var i = n.filter(function (e, t) {
              return -1 === r.indexOf(t);
            });
            this.outputShape = i;
            var o = n.length,
              a = En(n.length),
              s = En(i.length),
              l = "";
            if (1 === o) l = "coords * strides + begin";else {
              var u = 0;
              l = n.map(function (e, t) {
                return -1 === r.indexOf(t) ? (u++, 1 === i.length ? "coords * strides[" + t + "] + begin[" + t + "]" : "coords[" + (u - 1) + "] * strides[" + t + "] + begin[" + t + "]") : "begin[" + t + "]";
              }).join(",");
            }
            this.userCode = "\n      " + a + " begin = " + a + "(" + e + ");\n      " + a + " strides = " + a + "(" + t + ");\n\n      void main() {\n        " + s + " coords = getOutputCoords();\n        setOutput(getX(" + l + "));\n      }\n    ";
          },
          vi = function () {
            function e(e) {
              this.gpgpu = e, this.numUsedTextures = 0, this.numFreeTextures = 0, this.freeTextures = {}, this.logEnabled = !1, this.usedTextures = {};
            }
            return e.prototype.acquireTexture = function (e, t, n) {
              var r,
                i = yi(t, n),
                o = bi(e, i, n);
              if (o in this.freeTextures || (this.freeTextures[o] = []), o in this.usedTextures || (this.usedTextures[o] = []), this.freeTextures[o].length > 0) {
                this.numFreeTextures--, this.numUsedTextures++, this.log();
                var a = this.freeTextures[o].shift();
                return this.usedTextures[o].push(a), a;
              }
              return this.numUsedTextures++, this.log(), i === Bn.PACKED_2X2_FLOAT32 ? r = this.gpgpu.createPackedMatrixTexture(e[0], e[1]) : i === Bn.PACKED_2X2_FLOAT16 ? r = this.gpgpu.createFloat16PackedMatrixTexture(e[0], e[1]) : i === Bn.UNPACKED_FLOAT32 ? r = this.gpgpu.createFloat32MatrixTexture(e[0], e[1]) : i === Bn.UNPACKED_FLOAT16 ? r = this.gpgpu.createFloat16MatrixTexture(e[0], e[1]) : i === Bn.PACKED_4X1_UNSIGNED_BYTE && (r = this.gpgpu.createUnsignedBytesMatrixTexture(e[0], e[1])), this.usedTextures[o].push(r), r;
            }, e.prototype.releaseTexture = function (e, t, n, r) {
              if (null != this.freeTextures) {
                var i = bi(t, yi(n, r), r);
                i in this.freeTextures || (this.freeTextures[i] = []), this.freeTextures[i].push(e), this.numFreeTextures++, this.numUsedTextures--;
                var o = this.usedTextures[i],
                  a = o.indexOf(e);
                if (a < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
                o.splice(a, 1), this.log();
              }
            }, e.prototype.log = function () {
              if (this.logEnabled) {
                var e = this.numFreeTextures + this.numUsedTextures;
                console.log("Free/Used", this.numFreeTextures + " / " + this.numUsedTextures, "(" + e + ")");
              }
            }, e.prototype.getNumUsedTextures = function () {
              return this.numUsedTextures;
            }, e.prototype.getNumFreeTextures = function () {
              return this.numFreeTextures;
            }, e.prototype.dispose = function () {
              var e = this;
              if (null != this.freeTextures) {
                for (var t in this.freeTextures) this.freeTextures[t].forEach(function (t) {
                  e.gpgpu.deleteMatrixTexture(t);
                });
                for (var t in this.usedTextures) this.usedTextures[t].forEach(function (t) {
                  e.gpgpu.deleteMatrixTexture(t);
                });
                this.freeTextures = null, this.usedTextures = null, this.numUsedTextures = 0, this.numFreeTextures = 0;
              }
            }, e;
          }();
        function yi(e, t) {
          if (t) return ve.get("WEBGL_RENDER_FLOAT32_ENABLED") ? Bn.PACKED_2X2_FLOAT32 : Bn.PACKED_2X2_FLOAT16;
          if (e === Dn.DOWNLOAD || e === Dn.PIXELS) return Bn.PACKED_4X1_UNSIGNED_BYTE;
          if (e === Dn.UPLOAD) return Bn.UNPACKED_FLOAT32;
          if (e === Dn.RENDER) return ve.get("WEBGL_RENDER_FLOAT32_ENABLED") ? Bn.UNPACKED_FLOAT32 : Bn.UNPACKED_FLOAT16;
          throw new Error("Unknown logical texture type " + e);
        }
        function bi(e, t, n) {
          return e[0] + "_" + e[1] + "_" + t + "_" + n;
        }
        var _i = function _i(e, t) {
          this.variableNames = ["A"];
          for (var n = new Array(e.length), r = 0; r < n.length; r++) n[r] = e[r] * t[r];
          this.outputShape = n, this.rank = n.length;
          var i = En(this.rank),
            o = function (e) {
              var t = e.length;
              if (t > 5) throw Error("Tile for rank " + t + " is not yet supported");
              if (1 === t) return "imod(resRC, " + e[0] + ")";
              for (var n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u"], r = [], i = 0; i < e.length; i++) r.push("imod(" + n[i] + ", " + e[i] + ")");
              return r.join();
            }(e);
          this.userCode = "\n      void main() {\n        " + i + " resRC = getOutputCoords();\n        setOutput(getA(" + o + "));\n      }\n    ";
        };
        var xi = function xi(e, t) {
          this.variableNames = ["A"];
          for (var n = new Array(e.length), r = 0; r < n.length; r++) n[r] = e[t[r]];
          this.outputShape = n, this.rank = n.length;
          var i = En(this.rank),
            o = function (e) {
              var t = e.length;
              if (t > 6) throw Error("Transpose for rank " + t + " is not yet supported");
              for (var n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u", "resRC.v"], r = new Array(t), i = 0; i < e.length; i++) r[e[i]] = n[i];
              return r.join();
            }(t);
          this.userCode = "\n    void main() {\n      " + i + " resRC = getOutputCoords();\n      setOutput(getA(" + o + "));\n    }\n    ";
        };
        var wi = function () {
          function e(e, t) {
            this.variableNames = ["A"], this.outputShape = e, this.userCode = "\n      uniform float NAN;\n      float unaryOperation(float x) {\n        " + t + "\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    ";
          }
          return e.prototype.getCustomSetupFunc = function () {
            var e = this;
            return function (t, n) {
              null == e.startLoc && (e.startLoc = t.getUniformLocationNoThrow(n, "NAN"), null == e.startLoc) || t.gl.uniform1f(e.startLoc, NaN);
            };
          }, e;
        }();
        var Si = function Si(e) {
          this.variableNames = ["A"], this.usesPackedTextures = !0, this.outputShape = e;
          var t = e.length,
            n = ti("rc", t),
            r = En(t),
            i = function (e, t) {
              if (1 === e) return "rc";
              for (var n = "", r = 0; r < e; r++) n += t[r], r < e - 1 && (n += ",");
              return n;
            }(t, n),
            o = n.slice(-2),
            a = 1 === t ? "rc" : "vec2(" + o.join(",") + ")";
          this.userCode = "\n      void main() {\n        " + r + " rc = getOutputCoords();\n        vec4 packedInput = getA(" + i + ");\n\n        setOutput(getChannel(packedInput, " + a + "));\n      }\n    ";
        };
        var Ai = nt({
            concat_: function concat_(e, t) {
              void 0 === t && (t = 0), b(e.length >= 1, "Pass at least one tensor to concat");
              var n = tt(e, "tensors", "concat");
              t = ze(t, n[0].shape)[0];
              var r = qe(n.map(function (e) {
                return e.shape;
              }), t);
              if (0 === S(r)) return lt([], r);
              if (1 === (n = n.filter(function (e) {
                return e.size > 0;
              })).length) return n[0];
              var i = n.map(function (e) {
                return e.shape;
              });
              !function (e, t) {
                var n = e[0].length;
                e.forEach(function (e, t) {
                  b(e.length === n, "Error in concat" + n + "D: rank of tensors[" + t + "] must be the same as the rank of the rest (" + n + ")");
                }), b(t >= 0 && t < n, "Error in concat" + n + "D: axis must be between 0 and " + (n - 1) + ".");
                var r = e[0];
                e.forEach(function (e, i) {
                  for (var o = 0; o < n; o++) b(o === t || e[o] === r[o], "Error in concat" + n + "D: Shape of tensors[" + i + "] (" + e + ") does not match the shape of the rest (" + r + ") along the non-concatenated axis " + i + ".");
                });
              }(i, t);
              var o = n;
              return ve.engine.runKernel(function (e) {
                return e.concat(n, t);
              }, o, function (e) {
                var n = i.map(function (e) {
                  return e[t];
                });
                return ki(e, n, t).map(function (e) {
                  return function () {
                    return e;
                  };
                });
              });
            }
          }),
          Ei = nt({
            concat1d_: function concat1d_(e) {
              return Ai(e, 0);
            }
          }),
          Ti = nt({
            concat2d_: function concat2d_(e, t) {
              return Ai(e, t);
            }
          }),
          Mi = nt({
            concat3d_: function concat3d_(e, t) {
              return Ai(e, t);
            }
          }),
          Ci = nt({
            concat4d_: function concat4d_(e, t) {
              return Ai(e, t);
            }
          }),
          ki = nt({
            split_: function split_(e, t, n) {
              void 0 === n && (n = 0);
              var r,
                i = et(e, "x", "split");
              return n = ze(n, i.shape)[0], "number" == typeof t ? (b(i.shape[n] % t == 0, "Number of splits must evenly divide the axis."), r = Array(t).fill(i.shape[n] / t)) : (b(i.shape[n] === t.reduce(function (e, t) {
                return e + t;
              }), "The sum of sizes must match the size of the axis dimension."), r = t), ve.engine.runKernel(function (e) {
                return e.split(i, r, n);
              }, {
                $x: i
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ai(e, n);
                  }
                };
              });
            }
          });
        "undefined" != typeof window ? window : void 0 !== r || "undefined" != typeof self && self;
        function Pi(e, t) {
          return e(t = {
            exports: {}
          }, t.exports), t.exports;
        }
        var Oi = Pi(function (e) {
            !function (e, t, n) {
              function r(e, t) {
                return t.c = e.c, t.s0 = e.s0, t.s1 = e.s1, t.s2 = e.s2, t;
              }
              function i(e, t) {
                var n = new function (e) {
                    var t,
                      n = this,
                      r = (t = 4022871197, function (e) {
                        e = e.toString();
                        for (var n = 0; n < e.length; n++) {
                          var r = .02519603282416938 * (t += e.charCodeAt(n));
                          r -= t = r >>> 0, t = (r *= t) >>> 0, t += 4294967296 * (r -= t);
                        }
                        return 2.3283064365386963e-10 * (t >>> 0);
                      });
                    n.next = function () {
                      var e = 2091639 * n.s0 + 2.3283064365386963e-10 * n.c;
                      return n.s0 = n.s1, n.s1 = n.s2, n.s2 = e - (n.c = 0 | e);
                    }, n.c = 1, n.s0 = r(" "), n.s1 = r(" "), n.s2 = r(" "), n.s0 -= r(e), n.s0 < 0 && (n.s0 += 1), n.s1 -= r(e), n.s1 < 0 && (n.s1 += 1), n.s2 -= r(e), n.s2 < 0 && (n.s2 += 1), r = null;
                  }(e),
                  i = t && t.state,
                  o = n.next;
                return o.int32 = function () {
                  return 4294967296 * n.next() | 0;
                }, o.double = function () {
                  return o() + 11102230246251565e-32 * (2097152 * o() | 0);
                }, o.quick = o, i && ("object" == typeof i && r(i, n), o.state = function () {
                  return r(n, {});
                }), o;
              }
              t && t.exports ? t.exports = i : this.alea = i;
            }(0, e);
          }),
          Ri = Pi(function (e) {
            !function (e, t, n) {
              function r(e, t) {
                return t.x = e.x, t.y = e.y, t.z = e.z, t.w = e.w, t;
              }
              function i(e, t) {
                var n = new function (e) {
                    var t = this,
                      n = "";
                    t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.next = function () {
                      var e = t.x ^ t.x << 11;
                      return t.x = t.y, t.y = t.z, t.z = t.w, t.w ^= t.w >>> 19 ^ e ^ e >>> 8;
                    }, e === (0 | e) ? t.x = e : n += e;
                    for (var r = 0; r < n.length + 64; r++) t.x ^= 0 | n.charCodeAt(r), t.next();
                  }(e),
                  i = t && t.state,
                  o = function o() {
                    return (n.next() >>> 0) / 4294967296;
                  };
                return o.double = function () {
                  do {
                    var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
                  } while (0 === e);
                  return e;
                }, o.int32 = n.next, o.quick = o, i && ("object" == typeof i && r(i, n), o.state = function () {
                  return r(n, {});
                }), o;
              }
              t && t.exports ? t.exports = i : this.xor128 = i;
            }(0, e);
          }),
          Ii = Pi(function (e) {
            !function (e, t, n) {
              function r(e, t) {
                return t.x = e.x, t.y = e.y, t.z = e.z, t.w = e.w, t.v = e.v, t.d = e.d, t;
              }
              function i(e, t) {
                var n = new function (e) {
                    var t = this,
                      n = "";
                    t.next = function () {
                      var e = t.x ^ t.x >>> 2;
                      return t.x = t.y, t.y = t.z, t.z = t.w, t.w = t.v, (t.d = t.d + 362437 | 0) + (t.v = t.v ^ t.v << 4 ^ e ^ e << 1) | 0;
                    }, t.x = 0, t.y = 0, t.z = 0, t.w = 0, t.v = 0, e === (0 | e) ? t.x = e : n += e;
                    for (var r = 0; r < n.length + 64; r++) t.x ^= 0 | n.charCodeAt(r), r == n.length && (t.d = t.x << 10 ^ t.x >>> 4), t.next();
                  }(e),
                  i = t && t.state,
                  o = function o() {
                    return (n.next() >>> 0) / 4294967296;
                  };
                return o.double = function () {
                  do {
                    var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
                  } while (0 === e);
                  return e;
                }, o.int32 = n.next, o.quick = o, i && ("object" == typeof i && r(i, n), o.state = function () {
                  return r(n, {});
                }), o;
              }
              t && t.exports ? t.exports = i : this.xorwow = i;
            }(0, e);
          }),
          ji = Pi(function (e) {
            !function (e, t, n) {
              function r(e, t) {
                return t.x = e.x.slice(), t.i = e.i, t;
              }
              function i(e, t) {
                null == e && (e = +new Date());
                var n = new function (e) {
                    var t = this;
                    t.next = function () {
                      var e,
                        n,
                        r = t.x,
                        i = t.i;
                      return e = r[i], n = (e ^= e >>> 7) ^ e << 24, n ^= (e = r[i + 1 & 7]) ^ e >>> 10, n ^= (e = r[i + 3 & 7]) ^ e >>> 3, n ^= (e = r[i + 4 & 7]) ^ e << 7, e = r[i + 7 & 7], n ^= (e ^= e << 13) ^ e << 9, r[i] = n, t.i = i + 1 & 7, n;
                    }, function (e, t) {
                      var n,
                        r = [];
                      if (t === (0 | t)) r[0] = t;else for (t = "" + t, n = 0; n < t.length; ++n) r[7 & n] = r[7 & n] << 15 ^ t.charCodeAt(n) + r[n + 1 & 7] << 13;
                      for (; r.length < 8;) r.push(0);
                      for (n = 0; n < 8 && 0 === r[n]; ++n);
                      for (8 == n ? r[7] = -1 : r[n], e.x = r, e.i = 0, n = 256; n > 0; --n) e.next();
                    }(t, e);
                  }(e),
                  i = t && t.state,
                  o = function o() {
                    return (n.next() >>> 0) / 4294967296;
                  };
                return o.double = function () {
                  do {
                    var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
                  } while (0 === e);
                  return e;
                }, o.int32 = n.next, o.quick = o, i && (i.x && r(i, n), o.state = function () {
                  return r(n, {});
                }), o;
              }
              t && t.exports ? t.exports = i : this.xorshift7 = i;
            }(0, e);
          }),
          Ni = Pi(function (e) {
            !function (e, t, n) {
              function r(e, t) {
                return t.i = e.i, t.w = e.w, t.X = e.X.slice(), t;
              }
              function i(e, t) {
                null == e && (e = +new Date());
                var n = new function (e) {
                    var t = this;
                    t.next = function () {
                      var e,
                        n,
                        r = t.w,
                        i = t.X,
                        o = t.i;
                      return t.w = r = r + 1640531527 | 0, n = i[o + 34 & 127], e = i[o = o + 1 & 127], n ^= n << 13, e ^= e << 17, n ^= n >>> 15, e ^= e >>> 12, n = i[o] = n ^ e, t.i = o, n + (r ^ r >>> 16) | 0;
                    }, function (e, t) {
                      var n,
                        r,
                        i,
                        o,
                        a,
                        s = [],
                        l = 128;
                      for (t === (0 | t) ? (r = t, t = null) : (t += "\0", r = 0, l = Math.max(l, t.length)), i = 0, o = -32; o < l; ++o) t && (r ^= t.charCodeAt((o + 32) % t.length)), 0 === o && (a = r), r ^= r << 10, r ^= r >>> 15, r ^= r << 4, r ^= r >>> 13, o >= 0 && (a = a + 1640531527 | 0, i = 0 == (n = s[127 & o] ^= r + a) ? i + 1 : 0);
                      for (i >= 128 && (s[127 & (t && t.length || 0)] = -1), i = 127, o = 512; o > 0; --o) r = s[i + 34 & 127], n = s[i = i + 1 & 127], r ^= r << 13, n ^= n << 17, r ^= r >>> 15, n ^= n >>> 12, s[i] = r ^ n;
                      e.w = a, e.X = s, e.i = i;
                    }(t, e);
                  }(e),
                  i = t && t.state,
                  o = function o() {
                    return (n.next() >>> 0) / 4294967296;
                  };
                return o.double = function () {
                  do {
                    var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
                  } while (0 === e);
                  return e;
                }, o.int32 = n.next, o.quick = o, i && (i.X && r(i, n), o.state = function () {
                  return r(n, {});
                }), o;
              }
              t && t.exports ? t.exports = i : this.xor4096 = i;
            }(0, e);
          }),
          Li = Pi(function (e) {
            !function (e, t, n) {
              function r(e, t) {
                return t.a = e.a, t.b = e.b, t.c = e.c, t.d = e.d, t;
              }
              function i(e, t) {
                var n = new function (e) {
                    var t = this,
                      n = "";
                    t.next = function () {
                      var e = t.b,
                        n = t.c,
                        r = t.d,
                        i = t.a;
                      return e = e << 25 ^ e >>> 7 ^ n, n = n - r | 0, r = r << 24 ^ r >>> 8 ^ i, i = i - e | 0, t.b = e = e << 20 ^ e >>> 12 ^ n, t.c = n = n - r | 0, t.d = r << 16 ^ n >>> 16 ^ i, t.a = i - e | 0;
                    }, t.a = 0, t.b = 0, t.c = -1640531527, t.d = 1367130551, e === Math.floor(e) ? (t.a = e / 4294967296 | 0, t.b = 0 | e) : n += e;
                    for (var r = 0; r < n.length + 20; r++) t.b ^= 0 | n.charCodeAt(r), t.next();
                  }(e),
                  i = t && t.state,
                  o = function o() {
                    return (n.next() >>> 0) / 4294967296;
                  };
                return o.double = function () {
                  do {
                    var e = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21);
                  } while (0 === e);
                  return e;
                }, o.int32 = n.next, o.quick = o, i && ("object" == typeof i && r(i, n), o.state = function () {
                  return r(n, {});
                }), o;
              }
              t && t.exports ? t.exports = i : this.tychei = i;
            }(0, e);
          }),
          Di = Pi(function (e) {
            !function (t, r) {
              var i,
                o = this,
                a = 256,
                s = "random",
                l = r.pow(a, 6),
                u = r.pow(2, 52),
                c = 2 * u,
                d = 255;
              function h(e, n, h) {
                var g = [],
                  v = p(function e(t, n) {
                    var r,
                      i = [],
                      o = typeof t;
                    if (n && "object" == o) for (r in t) try {
                      i.push(e(t[r], n - 1));
                    } catch (e) {}
                    return i.length ? i : "string" == o ? t : t + "\0";
                  }((n = 1 == n ? {
                    entropy: !0
                  } : n || {}).entropy ? [e, m(t)] : null == e ? function () {
                    try {
                      var e;
                      return i && (e = i.randomBytes) ? e = e(a) : (e = new Uint8Array(a), (o.crypto || o.msCrypto).getRandomValues(e)), m(e);
                    } catch (e) {
                      var n = o.navigator,
                        r = n && n.plugins;
                      return [+new Date(), o, r, o.screen, m(t)];
                    }
                  }() : e, 3), g),
                  y = new function (e) {
                    var t,
                      n = e.length,
                      r = this,
                      i = 0,
                      o = r.i = r.j = 0,
                      s = r.S = [];
                    for (n || (e = [n++]); i < a;) s[i] = i++;
                    for (i = 0; i < a; i++) s[i] = s[o = d & o + e[i % n] + (t = s[i])], s[o] = t;
                    (r.g = function (e) {
                      for (var t, n = 0, i = r.i, o = r.j, s = r.S; e--;) t = s[i = d & i + 1], n = n * a + s[d & (s[i] = s[o = d & o + t]) + (s[o] = t)];
                      return r.i = i, r.j = o, n;
                    })(a);
                  }(g),
                  b = function b() {
                    for (var e = y.g(6), t = l, n = 0; e < u;) e = (e + n) * a, t *= a, n = y.g(1);
                    for (; e >= c;) e /= 2, t /= 2, n >>>= 1;
                    return (e + n) / t;
                  };
                return b.int32 = function () {
                  return 0 | y.g(4);
                }, b.quick = function () {
                  return y.g(4) / 4294967296;
                }, b.double = b, p(m(y.S), t), (n.pass || h || function (e, t, n, i) {
                  return i && (i.S && f(i, y), e.state = function () {
                    return f(y, {});
                  }), n ? (r[s] = e, t) : e;
                })(b, v, "global" in n ? n.global : this == r, n.state);
              }
              function f(e, t) {
                return t.i = e.i, t.j = e.j, t.S = e.S.slice(), t;
              }
              function p(e, t) {
                for (var n, r = e + "", i = 0; i < r.length;) t[d & i] = d & (n ^= 19 * t[d & i]) + r.charCodeAt(i++);
                return m(t);
              }
              function m(e) {
                return String.fromCharCode.apply(0, e);
              }
              if (r.seedrandom = h, p(r.random(), t), e.exports) {
                e.exports = h;
                try {
                  i = n("./node_modules/crypto-browserify/index.js");
                } catch (e) {}
              }
            }([], Math);
          });
        Di.alea = Oi, Di.xor128 = Ri, Di.xorwow = Ii, Di.xorshift7 = ji, Di.xor4096 = Ni, Di.tychei = Li;
        var Bi = Di.alea,
          Fi = function () {
            function e(e, t, n, r, i) {
              this.mean = e, this.stdDev = t, this.dtype = n, this.nextVal = NaN, this.truncated = r, this.truncated && (this.upper = this.mean + 2 * this.stdDev, this.lower = this.mean - 2 * this.stdDev);
              var o = i || Math.random();
              this.random = Bi(o.toString());
            }
            return e.prototype.nextValue = function () {
              if (!isNaN(this.nextVal)) {
                var e = this.nextVal;
                return this.nextVal = NaN, e;
              }
              for (var t, n, r = !1; !r;) {
                var i = void 0,
                  o = void 0,
                  a = void 0;
                do {
                  a = (i = 2 * this.random() - 1) * i + (o = 2 * this.random() - 1) * o;
                } while (a >= 1 || 0 === a);
                var s = Math.sqrt(-2 * Math.log(a) / a);
                t = this.mean + this.stdDev * i * s, n = this.mean + this.stdDev * o * s, this.truncated && !this.isValidTruncated(t) || (r = !0);
              }
              return this.truncated && !this.isValidTruncated(n) || (this.nextVal = this.convertValue(n)), this.convertValue(t);
            }, e.prototype.convertValue = function (e) {
              return null == this.dtype || "float32" === this.dtype ? e : Math.round(e);
            }, e.prototype.isValidTruncated = function (e) {
              return e <= this.upper && e >= this.lower;
            }, e;
          }();
        function zi(e, t) {
          return u(this, void 0, void 0, function () {
            var n, r, i, o, a, s, l, u, d, h, f, p, m, g, v, y, b, _, x, w;
            return c(this, function (c) {
              switch (c.label) {
                case 0:
                  if (2 !== (n = et(e, "img", "toPixels", "int32")).rank && 3 !== n.rank) throw new Error("toPixels only supports rank 2 or 3 tensors, got rank " + n.rank + ".");
                  if (r = n.shape.slice(0, 2), i = r[0], o = r[1], (a = 2 === n.rank ? 1 : n.shape[2]) > 4 || 2 === a) throw new Error("toPixels only supports depth of size 1, 3 or 4 but got " + a);
                  return s = n.min(), l = n.max(), [4, s.data()];
                case 1:
                  return u = c.sent()[0], [4, l.data()];
                case 2:
                  if (d = c.sent()[0], s.dispose(), l.dispose(), "float32" === n.dtype) {
                    if (u < 0 || d > 1) throw new Error("Tensor values for a float32 Tensor must be in the range [0 - 1] but got range [" + u + " - " + d + "].");
                  } else {
                    if ("int32" !== n.dtype) throw new Error("Unsupported type for toPixels: " + n.dtype + ". Please use float32 or int32 tensors.");
                    if (u < 0 || d > 255) throw new Error("Tensor values for a int32 Tensor must be in the range [0 - 255] but got range [" + u + " - " + d + "].");
                  }
                  return [4, n.data()];
                case 3:
                  for (h = c.sent(), f = "float32" === n.dtype ? 255 : 1, p = new Uint8ClampedArray(o * i * 4), m = 0; m < i * o; ++m) g = void 0, v = void 0, y = void 0, b = void 0, 1 === a ? (g = h[m] * f, v = h[m] * f, y = h[m] * f, b = 255) : 3 === a ? (g = h[3 * m] * f, v = h[3 * m + 1] * f, y = h[3 * m + 2] * f, b = 255) : 4 === a && (g = h[4 * m] * f, v = h[4 * m + 1] * f, y = h[4 * m + 2] * f, b = h[4 * m + 3] * f), p[0 + (_ = 4 * m)] = Math.round(g), p[_ + 1] = Math.round(v), p[_ + 2] = Math.round(y), p[_ + 3] = Math.round(b);
                  return null != t && (t.width = o, t.height = i, x = t.getContext("2d"), w = new ImageData(p, o, i), x.putImageData(w, 0, 0)), n !== e && n.dispose(), [2, p];
              }
            });
          });
        }
        function Ui(e, t, n) {
          return void 0 === t && (t = "float32"), new Z(e, t, n);
        }
        function Gi(e, t) {
          void 0 === t && (t = !1), console.log(e.toString(t));
        }
        var Vi = nt({
            batchToSpaceND_: function batchToSpaceND_(e, t, n) {
              var r = et(e, "x", "batchToSpaceND"),
                i = t.reduce(function (e, t) {
                  return e * t;
                });
              return b(r.rank >= 1 + t.length, "input rank is " + r.rank + " but should be > than blockShape.length " + t.length), b(n.length === t.length, "crops.length is " + n.length + " but should be equal to blockShape.length  " + t.length), b(r.shape[0] % i == 0, "input tensor batch is " + r.shape[0] + " but is not divisible by the product of the elements of blockShape " + t.join(" * ") + " === " + i), ve.engine.runKernel(function (e) {
                return e.batchToSpaceND(r, t, n);
              }, {
                $x: r
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.spaceToBatchND(t, n);
                  }
                };
              });
            }
          }),
          Hi = nt({
            cast_: function cast_(e, t) {
              var n = et(e, "x", "cast");
              return ve.engine.runKernel(function (e) {
                return e.cast(n, t);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.clone();
                  }
                };
              });
            }
          }),
          qi = nt({
            clone_: function clone_(e) {
              var t = et(e, "x", "clone");
              return ve.engine.runKernel(function (e) {
                return te.make(t.shape, {
                  dataId: t.dataId
                }, t.dtype);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.toFloat();
                  }
                };
              });
            }
          }),
          Wi = nt({
            cumsum_: function cumsum_(e, t, n, r) {
              void 0 === t && (t = 0), void 0 === n && (n = !1), void 0 === r && (r = !1);
              var i = et(e, "x", "cumsum"),
                o = Ge([t |= 0], i.rank),
                a = i;
              null != o && (a = i.transpose(o));
              var s = He(1, i.rank)[0],
                l = ve.engine.runKernel(function (e) {
                  return e.cumsum(a, s, n, r);
                }, {
                  permutedX: a
                }, function (e) {
                  return {
                    permutedX: function permutedX() {
                      return e.cumsum(t, n, !r);
                    }
                  };
                });
              return null != o && (l = l.transpose(o)), l;
            }
          }),
          $i = nt({
            depthToSpace_: function depthToSpace_(e, t, n) {
              void 0 === n && (n = "NHWC");
              var r = et(e, "x", "depthToSpace"),
                i = "NHWC" === n ? r.shape[1] : r.shape[2],
                o = "NHWC" === n ? r.shape[2] : r.shape[3],
                a = "NHWC" === n ? r.shape[3] : r.shape[1];
              return b(i * t >= 0, "Negative dimension size caused by overflow when multiplying\n      " + i + " and " + t + "  for depthToSpace with input shape\n      " + r.shape), b(o * t >= 0, "Negative dimension size caused by overflow when multiplying\n      " + o + " and " + t + " for depthToSpace with input shape\n          " + r.shape), b(a % (t * t) == 0, "Dimension size must be evenly divisible by " + t * t + " but is " + a + " for depthToSpace with input shape " + r.shape), ve.engine.runKernel(function (e) {
                return e.depthToSpace(r, t, n);
              }, {
                $x: r
              });
            }
          }),
          Xi = nt({
            expandDims_: function expandDims_(e, t) {
              void 0 === t && (t = 0);
              var n = et(e, "x", "expandDims");
              b(t <= n.rank, "Axis must be <= rank of the tensor");
              var r = n.shape.slice();
              return t < 0 && (b(-(n.rank + 1) <= t, "Axis must be in the interval [" + -(n.rank + 1) + ", " + n.rank + "]"), t = n.rank + t + 1), r.splice(t, 0, 1), so(n, r);
            }
          }),
          Yi = nt({
            eye_: function eye_(e, t, n, r) {
              void 0 === r && (r = "float32"), null == t && (t = e);
              for (var i = Ui([e, t], r), o = e <= t ? e : t, a = 0; a < o; ++a) i.set(1, a, a);
              var s = i.toTensor().as2D(e, t);
              if (null == n) return s;
              if (1 === n.length) return ho(Xi(s, 0), [n[0], 1, 1]);
              if (2 === n.length) return ho(Xi(Xi(s, 0), 0), [n[0], n[1], 1, 1]);
              if (3 === n.length) return ho(Xi(Xi(Xi(s, 0), 0), 0), [n[0], n[1], n[2], 1, 1]);
              throw new Error("eye() currently supports only 1D and 2D batchShapes, but received " + n.length + "D.");
            }
          }),
          Ki = nt({
            fromPixels_: function fromPixels_(e, t) {
              if (void 0 === t && (t = 3), t > 4) throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");
              return ve.engine.fromPixels(e, t);
            }
          }),
          Zi = nt({
            multinomial_: function multinomial_(e, t, n, r) {
              void 0 === r && (r = !1);
              var i = et(e, "logits", "multinomial"),
                o = i.size,
                a = i.rank;
              if (o < 2) throw new Error("Error in multinomial: you need at least 2 outcomes, but got " + o + ".");
              if (a > 2) throw new Error("Rank of probabilities must be 1 or 2, but is " + a);
              n = n || Math.random();
              var s = 1 === a ? i.as2D(1, -1) : i,
                l = ve.engine.runKernel(function (e) {
                  return e.multinomial(s, r, t, n);
                }, {
                  logits2D: s
                });
              return 1 === a ? l.as1D() : l;
            }
          }),
          Qi = nt({
            oneHot_: function oneHot_(e, t, n, r) {
              void 0 === n && (n = 1), void 0 === r && (r = 0);
              var i = et(e, "indices", "oneHot", "int32");
              if (b("int32" === i.dtype, "Indices must be of dtype `int32`"), t < 2) throw new Error("Error in oneHot: depth must be >=2, but it is " + t);
              return ve.engine.runKernel(function (e) {
                return e.oneHot(i, t, n, r);
              }, {
                $indices: i
              }, function (e) {
                return {
                  $indices: function $indices() {
                    return Ct(i);
                  }
                };
              });
            }
          }),
          Ji = nt({
            pad_: function pad_(e, t, n) {
              void 0 === n && (n = 0);
              var r = et(e, "x", "pad");
              if (0 === r.rank) throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");
              var i = t.map(function (e) {
                return e[0];
              });
              return ve.engine.runKernel(function (e) {
                return e.pad(r, t, n);
              }, {
                $x: r
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.slice(i, r.shape);
                  }
                };
              });
            }
          }),
          eo = nt({
            pad1d_: function pad1d_(e, t, n) {
              return void 0 === n && (n = 0), b(2 === t.length, "Invalid number of paddings. Must be length of 2."), Ji(e, [t], n);
            }
          }),
          to = nt({
            pad2d_: function pad2d_(e, t, n) {
              return void 0 === n && (n = 0), b(2 === t.length && 2 === t[0].length && 2 === t[1].length, "Invalid number of paddings. Must be length of 2 each."), Ji(e, t, n);
            }
          }),
          no = nt({
            pad3d_: function pad3d_(e, t, n) {
              return void 0 === n && (n = 0), b(3 === t.length && 2 === t[0].length && 2 === t[1].length && 2 === t[2].length, "Invalid number of paddings. Must be length of 2 each."), Ji(e, t, n);
            }
          }),
          ro = nt({
            pad4d_: function pad4d_(e, t, n) {
              return void 0 === n && (n = 0), b(4 === t.length && 2 === t[0].length && 2 === t[1].length && 2 === t[2].length && 2 === t[3].length, "Invalid number of paddings. Must be length of 2 each."), Ji(e, t, n);
            }
          }),
          io = nt({
            rand_: function rand_(e, t, n) {
              var r = S(e),
                i = null;
              if (null == n || "float32" === n) i = new Float32Array(r);else if ("int32" === n) i = new Int32Array(r);else {
                if ("bool" !== n) throw new Error("Unknown data type " + n);
                i = new Uint8Array(r);
              }
              for (var o = 0; o < r; o++) i[o] = t();
              return te.make(e, {
                values: i
              }, n);
            }
          }),
          oo = nt({
            randomNormal_: function randomNormal_(e, t, n, r, i) {
              if (void 0 === t && (t = 0), void 0 === n && (n = 1), null != r && "bool" === r) throw new Error("Unsupported data type " + r);
              for (var o = new Fi(t, n, r, !1, i), a = Ui(e, r), s = 0; s < a.values.length; s++) a.values[s] = o.nextValue();
              return a.toTensor();
            }
          }),
          ao = nt({
            randomUniform_: function randomUniform_(e, t, n, r) {
              void 0 === t && (t = 0), void 0 === n && (n = 1), void 0 === r && (r = "float32");
              for (var i = Ui(e, r), o = 0; o < i.values.length; o++) i.values[o] = y(t, n);
              return i.toTensor();
            }
          }),
          so = nt({
            reshape_: function reshape_(e, t) {
              var n = et(e, "x", "reshape");
              return t = P(t, n.size), b(n.size === S(t), "new shape and old shape must have the same number of elements."), ve.engine.runKernel(function (e) {
                return e.reshape(n, t);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.reshape(n.shape);
                  }
                };
              });
            }
          }),
          lo = nt({
            spaceToBatchND_: function spaceToBatchND_(e, t, n) {
              var r = et(e, "x", "spaceToBatchND");
              return b(r.rank >= 1 + t.length, "input rank " + r.rank + " should be > than [blockShape] " + t.length), b(n.length === t.length, "paddings.shape[0] " + n.length + " must be equal to [blockShape] " + t.length), b(r.shape.reduce(function (e, r, i) {
                return i > 0 && i <= t.length ? e && (r + n[i - 1][0] + n[i - 1][1]) % t[i - 1] == 0 : e;
              }, !0), "input spatial dimensions " + r.shape.slice(1) + " with paddings " + n.toString() + " must be divisible by blockShapes " + t.toString()), ve.engine.runKernel(function (e) {
                return e.spaceToBatchND(r, t, n);
              }, {
                $x: r
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.batchToSpaceND(t, n);
                  }
                };
              });
            }
          }),
          uo = nt({
            squeeze_: function squeeze_(e, t) {
              var n = et(e, "x", "squeeze");
              return so(n, O(n.shape, t).newShape);
            }
          }),
          co = nt({
            stack_: function stack_(e, t) {
              void 0 === t && (t = 0);
              var n = tt(e, "tensors", "stack");
              if (b(n.length >= 1, "Pass at least one tensor to tf.stack"), 1 === n.length) return n[0].expandDims(t);
              var r = n[0].rank,
                i = n[0].shape,
                o = n[0].dtype;
              b(t <= r, "Axis must be <= rank of the tensor"), n.forEach(function (e) {
                _(i, e.shape, "All tensors passed to stack must have matching shapes");
              }), n.forEach(function (e) {
                b(o === e.dtype, "All tensors passed to stack must have matching dtypes");
              });
              var a = n.map(function (e) {
                return e.expandDims(t);
              });
              return Ai(a, t);
            }
          }),
          ho = nt({
            tile_: function tile_(e, t) {
              var n = et(e, "x", "tile");
              return b(n.rank === t.length, "Error in transpose: rank of input " + n.rank + " must match length of reps " + t + "."), ve.engine.runKernel(function (e) {
                return e.tile(n, t);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    var r = Ct(n);
                    if (1 === n.rank) for (var i = 0; i < t[0]; ++i) r = r.add(e.slice([i * n.shape[0]], [n.shape[0]]));else if (2 === n.rank) for (i = 0; i < t[0]; ++i) for (var o = 0; o < t[1]; ++o) r = r.add(e.slice([i * n.shape[0], o * n.shape[1]], [n.shape[0], n.shape[1]]));else if (3 === n.rank) for (i = 0; i < t[0]; ++i) for (o = 0; o < t[1]; ++o) for (var a = 0; a < t[2]; ++a) r = r.add(e.slice([i * n.shape[0], o * n.shape[1], a * n.shape[2]], [n.shape[0], n.shape[1], n.shape[2]]));else {
                      if (4 !== n.rank) throw new Error("Gradient for tile operation is not implemented for rank-" + n.rank + " tensors yet.");
                      for (i = 0; i < t[0]; ++i) for (o = 0; o < t[1]; ++o) for (a = 0; a < t[2]; ++a) for (var s = 0; s < t[3]; ++s) r = r.add(e.slice([i * n.shape[0], o * n.shape[1], a * n.shape[2], s * n.shape[3]], [n.shape[0], n.shape[1], n.shape[2], n.shape[3]]));
                    }
                    return r;
                  }
                };
              });
            }
          }),
          fo = nt({
            truncatedNormal_: function truncatedNormal_(e, t, n, r, i) {
              if (void 0 === t && (t = 0), void 0 === n && (n = 1), null != r && "bool" === r) throw new Error("Unsupported data type " + r);
              for (var o = new Fi(t, n, r, !0, i), a = Ui(e, r), s = 0; s < a.values.length; s++) a.values[s] = o.nextValue();
              return a.toTensor();
            }
          }),
          po = nt({
            unstack_: function unstack_(e, t) {
              void 0 === t && (t = 0);
              for (var n, r = et(e, "x", "unstack"), i = r.shape[t], o = Array(r.rank - 1).fill(0), a = 0, s = 0; s < r.rank; s++) s !== t && (o[a] = r.shape[s], a++);
              n = Array(i).fill(1);
              var l = Array(r.rank).fill(0),
                u = r.shape.slice();
              return n.map(function (e) {
                u[t] = e;
                var n = r.slice(l, u);
                return l[t] += e, n.reshape(o);
              });
            }
          }),
          mo = function mo(e, t) {
            return u(this, void 0, void 0, function () {
              var n, r, i, o, a, s, l, u, d, h;
              return c(this, function (c) {
                switch (c.label) {
                  case 0:
                    return n = et(e, "x", "setdiff1d"), r = et(t, "y", "setdiff1d"), b(n.dtype === r.dtype, "x and y should have the same dtype, but got x (" + n.dtype + ") and y (" + r.dtype + ")."), b(1 === n.rank, "x should be 1D tensor, but got x (" + n.shape + ")."), b(1 === r.rank, "y should be 1D tensor, but got y (" + r.shape + ")."), [4, n.data()];
                  case 1:
                    return i = c.sent(), [4, r.data()];
                  case 2:
                    for (o = c.sent(), a = new Set(o), s = 0, d = 0; d < i.length; d++) a.has(i[d]) || s++;
                    for (l = new Z([s], n.dtype), u = new Z([s], "int32"), d = 0, h = 0; d < i.length; d++) a.has(i[d]) || (l.values[h] = i[d], u.values[h] = d, h++);
                    return [2, [l.toTensor(), u.toTensor()]];
                }
              });
            });
          };
        function go(e, t) {
          for (var n = [], r = 0; r < t.length; r++) t[r] && n.push(r);
          var i = Ui(e, "int32"),
            o = Ui([n.length, e.length], "int32");
          for (r = 0; r < n.length; r++) {
            var a = i.indexToLoc(n[r]),
              s = r * e.length;
            o.values.set(a, s);
          }
          return o.toTensor();
        }
        var vo = function () {
          function e(e, t) {
            if (void 0 === t && (t = !0), this.gpgpu = e, this.delayedStorage = t, this.pendingRead = new WeakMap(), this.pendingDisposal = new WeakSet(), this.lruDataGPU = [], this.numBytesInGPU = 0, this.uploadWaitMs = 0, this.downloadWaitMs = 0, this.binaryCache = {}, this.disposed = !1, ve.get("WEBGL_VERSION") < 1) throw new Error("WebGL is not supported on this device");
            if (null == e) {
              var n = f(ve.get("WEBGL_VERSION"));
              this.gpgpu = new qr(n), this.canvas = n.canvas, this.gpgpuCreatedLocally = !0;
            } else this.gpgpuCreatedLocally = !1, this.canvas = e.gl.canvas;
            ve.get("WEBGL_PAGING_ENABLED") && (this.NUM_BYTES_BEFORE_PAGING = window.screen.height * window.screen.width * window.devicePixelRatio * 300), this.textureManager = new vi(this.gpgpu);
          }
          return e.prototype.register = function (e, t, n) {
            if (this.texData.has(e)) throw new Error("Data buffer is already registered");
            this.texData.set(e, {
              shape: t,
              dtype: n,
              values: null,
              texture: null,
              complexTensors: null,
              texShape: null,
              usage: Dn.RENDER,
              isPacked: !1
            });
          }, e.prototype.setDataMover = function (e) {
            this.texData = new Rt(e);
          }, e.prototype.fromPixels = function (e, t) {
            if (null == e) throw new Error("pixels passed to tf.fromPixels() can not be null");
            var n = [e.height, e.width],
              r = [e.height, e.width, t];
            if (!(e instanceof HTMLVideoElement || e instanceof HTMLImageElement || e instanceof HTMLCanvasElement || e instanceof ImageData)) throw new Error("pixels passed to tf.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement or ImageData, but was " + e.constructor.name);
            if (e instanceof HTMLVideoElement) {
              if (null == this.fromPixels2DContext) {
                if (!ve.get("IS_BROWSER")) throw new Error("Can't read pixels from HTMLImageElement outside the browser.");
                if ("complete" !== document.readyState) throw new Error("The DOM is not ready yet. Please call tf.fromPixels() once the DOM is ready. One way to do that is to add an event listener for `DOMContentLoaded` on the document object");
                this.fromPixels2DContext = document.createElement("canvas").getContext("2d");
              }
              this.fromPixels2DContext.canvas.width = e.width, this.fromPixels2DContext.canvas.height = e.height, this.fromPixels2DContext.drawImage(e, 0, 0, e.width, e.height), e = this.fromPixels2DContext.canvas;
            }
            var i = this.makeTensorHandle(n, "int32");
            this.texData.get(i.dataId).usage = Dn.PIXELS, this.gpgpu.uploadPixelDataToTexture(this.getTexture(i.dataId), e);
            var o = new Nn(r),
              a = this.compileAndRun(o, [i]);
            return this.disposeData(i.dataId), a;
          }, e.prototype.makeTensorHandle = function (e, t) {
            var n = {};
            return this.register(n, e, t), {
              dataId: n,
              shape: e,
              dtype: t
            };
          }, e.prototype.write = function (e, t) {
            if (null == t) throw new Error("MathBackendWebGL.write(): values can not be null");
            var n = this.texData.get(e),
              r = n.texture,
              i = n.texShape,
              o = n.usage,
              a = n.dtype,
              s = n.isPacked;
            if ("complex64" === a) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
            null != r && (this.releaseTexture(e, r, i, o, s), n.texture = null, n.texShape = null), n.usage = Dn.UPLOAD, n.values = t, this.delayedStorage || this.uploadToGPU(e);
          }, e.prototype.readSync = function (e) {
            var t = this.texData.get(e),
              n = t.values,
              r = t.dtype,
              i = t.complexTensors;
            if (null != n) return this.convertAndCacheOnCPU(e);
            var o,
              a,
              s = null != this.activeTimers;
            return s && (o = performance.now()), a = "complex64" === r ? Lt(i.real.dataSync(), i.imag.dataSync()) : this.getValuesFromTexture(e), s && (this.downloadWaitMs += performance.now() - o), this.convertAndCacheOnCPU(e, a);
          }, e.prototype.read = function (e) {
            return u(this, void 0, void 0, function () {
              var t, n, r, i, o, a, s, l, u;
              return c(this, function (c) {
                switch (c.label) {
                  case 0:
                    if (this.pendingRead.has(e)) return t = this.pendingRead.get(e), [2, new Promise(function (e) {
                      return t.push(e);
                    })];
                    if (n = this.texData.get(e), r = n.texture, i = n.values, o = n.texShape, null != i) return [2, this.convertAndCacheOnCPU(e)];
                    if (this.pendingRead.set(e, []), !ve.get("WEBGL_DOWNLOAD_FLOAT_ENABLED") && 2 === ve.get("WEBGL_VERSION")) throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");
                    return a = this.gpgpu.maybeCreateBufferFromTexture(r, o[0], o[1]), [4, this.gpgpu.createAndWaitForFence()];
                  case 1:
                    return c.sent(), s = a instanceof WebGLTexture ? this.getValuesFromTexture(e) : this.gpgpu.downloadFloat32MatrixFromBuffer(a, o[0], o[1]), l = this.convertAndCacheOnCPU(e, s), u = this.pendingRead.get(e), this.pendingRead.delete(e), u.forEach(function (e) {
                      return e(l);
                    }), this.pendingDisposal.has(e) && (this.pendingDisposal.delete(e), this.disposeData(e)), [2, l];
                }
              });
            });
          }, e.prototype.getValuesFromTexture = function (e) {
            var t = this.texData.get(e),
              n = t.shape,
              r = t.dtype,
              i = t.texture,
              o = t.texShape;
            if (ve.get("WEBGL_DOWNLOAD_FLOAT_ENABLED")) {
              if (this.texData.get(e).isPacked) {
                var a = S(n.slice(0, n.length - 2)),
                  s = n.length > 1 ? n[n.length - 2] : 1,
                  l = n[n.length - 1];
                return this.gpgpu.downloadMatrixFromPackedTexture(i, a, s, l, o[0], o[1]);
              }
              return this.gpgpu.downloadFloat32MatrixFromOutputTexture(i, o[0], o[1]);
            }
            var u = this.makeTensorHandle(n, "float32");
            u.size = S(n), this.texData.get(u.dataId).usage = Dn.DOWNLOAD;
            var c = new On(n);
            this.compileAndRun(c, [{
              shape: n,
              dtype: r,
              dataId: e
            }], u, null, !1);
            var d = this.texData.get(u.dataId),
              h = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(d.texture, d.texShape[0], d.texShape[1]);
            return this.disposeData(u.dataId), h;
          }, e.prototype.time = function (e) {
            return u(this, void 0, void 0, function () {
              var t, n, r, i, o, a, s;
              return c(this, function (l) {
                switch (l.label) {
                  case 0:
                    return t = this.activeTimers, n = [], r = !1, null == this.programTimersStack ? (this.programTimersStack = n, r = !0) : this.activeTimers.push(n), this.activeTimers = n, e(), i = w(this.activeTimers.map(function (e) {
                      return e.query;
                    })).filter(function (e) {
                      return null != e;
                    }), o = w(this.activeTimers.map(function (e) {
                      return e.name;
                    })).filter(function (e) {
                      return null != e;
                    }), this.activeTimers = t, r && (this.programTimersStack = null), [4, Promise.all(i)];
                  case 1:
                    return a = l.sent(), s = {
                      uploadWaitMs: this.uploadWaitMs,
                      downloadWaitMs: this.downloadWaitMs,
                      kernelMs: v(a),
                      getExtraProfileInfo: function getExtraProfileInfo() {
                        return a.map(function (e, t) {
                          return {
                            name: o[t],
                            ms: e
                          };
                        }).map(function (e) {
                          return e.name + ": " + e.ms;
                        }).join(", ");
                      },
                      wallMs: null
                    }, this.uploadWaitMs = 0, this.downloadWaitMs = 0, [2, s];
                }
              });
            });
          }, e.prototype.memory = function () {
            return {
              unreliable: !1,
              numBytesInGPU: this.numBytesInGPU
            };
          }, e.prototype.startTimer = function () {
            return ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? this.gpgpu.beginQuery() : {
              startMs: performance.now(),
              endMs: null
            };
          }, e.prototype.endTimer = function (e) {
            return ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (this.gpgpu.endQuery(), e) : (e.endMs = performance.now(), e);
          }, e.prototype.getQueryTime = function (e) {
            return u(this, void 0, void 0, function () {
              var t;
              return c(this, function (n) {
                return ve.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? [2, this.gpgpu.waitForQueryAndGetTime(e)] : [2, (t = e).endMs - t.startMs];
              });
            });
          }, e.prototype.disposeData = function (e) {
            if (!this.pendingDisposal.has(e)) if (this.pendingRead.has(e)) this.pendingDisposal.add(e);else if (this.texData.has(e)) {
              var t = this.texData.get(e),
                n = t.texture,
                r = t.texShape,
                i = t.usage,
                o = t.complexTensors,
                a = t.isPacked;
              null != n && this.releaseTexture(e, n, r, i, a), null != o && (o.real.dispose(), o.imag.dispose()), this.texData.delete(e);
            }
          }, e.prototype.getTexture = function (e) {
            return this.uploadToGPU(e), this.texData.get(e).texture;
          }, e.prototype.getCPUBackend = function () {
            return ve.get("WEBGL_CPU_FORWARD") ? (null == this.cpuBackend && (this.cpuBackend = ve.findBackend("cpu")), this.cpuBackend) : null;
          }, e.prototype.shouldExecuteOnCPU = function (e, t) {
            var n = this;
            return void 0 === t && (t = 10), null != this.getCPUBackend() && e.every(function (e) {
              return null == n.texData.get(e.dataId).texture && e.size < t;
            });
          }, e.prototype.getGPGPUContext = function () {
            return this.gpgpu;
          }, e.prototype.getCanvas = function () {
            return this.canvas;
          }, e.prototype.complex = function (e, t) {
            var n = this.makeOutputArray(e.shape, "complex64");
            return this.texData.get(n.dataId).complexTensors = {
              real: ve.engine.keep(e.clone()),
              imag: ve.engine.keep(t.clone())
            }, n;
          }, e.prototype.real = function (e) {
            return this.texData.get(e.dataId).complexTensors.real.clone();
          }, e.prototype.imag = function (e) {
            return this.texData.get(e.dataId).complexTensors.imag.clone();
          }, e.prototype.slice = function (e, t, n) {
            if (this.shouldExecuteOnCPU([e])) return this.cpuBackend.slice(e, t, n);
            var r = new mi(n),
              i = r.getCustomSetupFunc(t);
            return this.compileAndRun(r, [e], null, i);
          }, e.prototype.stridedSlice = function (e, t, n, r, i, o, a, s, l) {
            if (this.shouldExecuteOnCPU([e])) return this.cpuBackend.stridedSlice(e, t, n, r, i, o, a, s, l);
            var u = Ke(e.shape, t, n, r, i, o, a, s, l),
              c = u[0],
              d = u[1],
              h = u[2],
              f = d.filter(function (e, t) {
                return -1 === h.indexOf(t);
              });
            if (f.some(function (e) {
              return 0 === e;
            })) return lt([], f);
            var p = new gi(c, r, d, h);
            return this.compileAndRun(p, [e]);
          }, e.prototype.reverse = function (e, t) {
            var n = new di(e.shape, t);
            return this.compileAndRun(n, [e]);
          }, e.prototype.concat2Tensors = function (e, t, n) {
            var r = qe([e.shape, t.shape], n),
              i = e.as2D(-1, S(e.shape.slice(n))),
              o = t.as2D(-1, S(t.shape.slice(n))),
              a = new sn(i.shape, o.shape);
            return this.compileAndRun(a, [i, o]).reshape(r);
          }, e.prototype.concat = function (e, t) {
            if (this.shouldExecuteOnCPU(e)) return this.cpuBackend.concat(e, t);
            if (1 === e.length) return e[0];
            for (var n = e[0], r = 1; r < e.length; ++r) n = this.concat2Tensors(n, e[r], t);
            return n;
          }, e.prototype.neg = function (e) {
            var t = new wi(e.shape, "return -x;");
            return this.compileAndRun(t, [e]);
          }, e.prototype.batchMatMul = function (e, t, n, r) {
            var i = n ? e.shape[2] : e.shape[1],
              o = r ? t.shape[1] : t.shape[2],
              a = n ? e.shape[1] : e.shape[2],
              s = e.shape[0];
            if ((1 === i || 1 === o) && a > 1e3) {
              n && (e = e.transpose([0, 2, 1])), r && (t = t.transpose([0, 2, 1]));
              var l = 1 === o ? e : e.as3D(s, a, 1),
                u = 1 === o ? 2 : 1,
                c = 1 === o ? t.as3D(s, 1, a) : t;
              return this.multiply(l, c).sum(u, !0);
            }
            if (1 === s) {
              var d = e.as2D(e.shape[1], e.shape[2]),
                h = t.as2D(t.shape[1], t.shape[2]),
                f = new Qr(d.shape, h.shape, [i, o], n, r),
                p = this.compileAndRun(f, [d, h], this.makePackedTensor(f.outputShape));
              return !1 === ve.get("WEBGL_LAZILY_UNPACK") && (p = this.unpackTensor(p)), p.reshape([1, p.shape[0], p.shape[1]]);
            }
            return this.compileAndRun(new Zr(e.shape, t.shape, n, r), [e, t]);
          }, e.prototype.multiply = function (e, t) {
            if ("complex64" === e.dtype) {
              var n = this.texData.get(e.dataId),
                r = this.texData.get(t.dataId),
                i = new en(Qt, e.shape, t.shape),
                o = new en(Jt, e.shape, t.shape),
                a = [this.makeComplexComponentTensorHandle(e, n.complexTensors.real), this.makeComplexComponentTensorHandle(e, n.complexTensors.imag), this.makeComplexComponentTensorHandle(t, r.complexTensors.real), this.makeComplexComponentTensorHandle(t, r.complexTensors.imag)],
                s = this.compileAndRun(i, a),
                l = this.compileAndRun(o, a),
                u = this.complex(s, l);
              return s.dispose(), l.dispose(), u;
            }
            if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.multiply(e, t);
            var c = new rn("return a * b;", e.shape, t.shape),
              d = this.makeOutputArray(c.outputShape, e.dtype);
            return this.compileAndRun(c, [e, t], d);
          }, e.prototype.batchNormalization = function (e, t, n, r, i, o) {
            var a = [e, t, n],
              s = null;
            null != o && (s = o.shape, a.push(o));
            var l = null;
            null != i && (l = i.shape, a.push(i));
            var u = null,
              c = Yt;
            ve.get("WEBGL_PACK_BATCHNORMALIZATION") && (u = this.makePackedTensor(e.shape), c = Kt);
            var d = new c(e.shape, t.shape, n.shape, s, l, r);
            return this.compileAndRun(d, a, u);
          }, e.prototype.localResponseNormalization4D = function (e, t, n, r, i) {
            var o = new Xr(e.shape, t, n, r, i);
            return this.compileAndRun(o, [e]);
          }, e.prototype.LRNGrad = function (e, t, n, r, i, o, a) {
            var s = new Yr(t.shape, r, i, o, a);
            return this.compileAndRun(s, [t, n, e]);
          }, e.prototype.tile = function (e, t) {
            var n = new _i(e.shape, t);
            return this.compileAndRun(n, [e]);
          }, e.prototype.pad = function (e, t, n) {
            var r = new ri(e.shape, t, n);
            return this.compileAndRun(r, [e]);
          }, e.prototype.transpose = function (e, t) {
            var n = new xi(e.shape, t);
            return this.compileAndRun(n, [e]);
          }, e.prototype.gather = function (e, t, n) {
            var r = new Ln(e.shape, t.size, n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.batchToSpaceND = function (e, t, n) {
            b(e.rank <= 4, "batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
            var r = t.reduce(function (e, t) {
                return e * t;
              }),
              i = Re(e.shape, t, r),
              o = Ie(i.length, t.length),
              a = je(e.shape, t, r),
              s = Ne(n, t.length),
              l = Le(a, n, t.length);
            return e.reshape(i).transpose(o).reshape(a).slice(s, l);
          }, e.prototype.spaceToBatchND = function (e, t, n) {
            b(e.rank <= 4, "spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
            var r = t.reduce(function (e, t) {
                return e * t;
              }),
              i = [[0, 0]];
            i.push.apply(i, n);
            for (var o = 1 + t.length; o < e.shape.length; ++o) i.push([0, 0]);
            var a = e.pad(i),
              s = Re(a.shape, t, r, !1),
              l = Ie(s.length, t.length, !1),
              u = je(a.shape, t, r, !1);
            return a.reshape(s).transpose(l).reshape(u);
          }, e.prototype.reduce = function (e, t, n) {
            var r = e.shape[0],
              i = e.shape[1],
              o = $e(i),
              a = new oi({
                windowSize: o,
                inSize: i,
                batchSize: r
              }, t),
              s = a.outputShape,
              l = s[0],
              u = s[1],
              c = this.makeOutputArray([l, u], n);
            return this.compileAndRun(a, [e], c), 1 === c.shape[1] ? c : this.reduce(c, t, n);
          }, e.prototype.argReduce = function (e, t, n) {
            void 0 === n && (n = null);
            var r = e.shape[0],
              i = e.shape[1];
            null != n && (r = n.shape[0], i = n.shape[1]);
            var o = $e(i),
              a = new Ht({
                windowSize: o,
                inSize: i,
                batchSize: r
              }, t, null == n),
              s = a.outputShape,
              l = s[0],
              u = s[1],
              c = this.makeOutputArray([l, u], "int32"),
              d = [e];
            return null != n && d.push(n), this.compileAndRun(a, d, c), 1 === c.shape[1] ? c : this.argReduce(e, t, c);
          }, e.prototype.sum = function (e, t) {
            Ue("sum", t, e.rank);
            var n = Be(e.shape, t),
              r = n[0],
              i = S(n[1]),
              o = e.as2D(-1, i),
              a = Ot(e.dtype);
            return this.reduce(o, "sum", a).reshape(r);
          }, e.prototype.prod = function (e, t) {
            var n = Be(e.shape, t),
              r = n[0],
              i = S(n[1]),
              o = e.as2D(-1, i),
              a = Ot(e.dtype);
            return this.reduce(o, "prod", a).reshape(r);
          }, e.prototype.unsortedSegmentSum = function (e, t, n) {
            var r = 0,
              i = Ge([r], e.rank),
              o = e;
            null != i && (o = e.transpose(i), r = He(1, e.rank)[0]);
            var a = function (e, t, n) {
                for (var r = [], i = e.length, o = 0; o < i; o++) o !== t ? r.push(e[o]) : r.push(n);
                return r;
              }(o.shape, r, n),
              s = S([o.shape[r]]),
              l = o.as2D(-1, s),
              u = Ot(e.dtype),
              c = this.segOpCompute(l, "unsortedSegmentSum", t, u, n).reshape(a);
            return null != i && (c = c.transpose(Ve(i))), c;
          }, e.prototype.segOpCompute = function (e, t, n, r, i) {
            var o = e.shape[0],
              a = e.shape[1],
              s = function (e, t) {
                var n,
                  r = !1;
                for (e <= 30 ? (n = e, r = !0) : n = F(e, Math.floor(Math.sqrt(e))); !r;) {
                  if (n > t || n === e) {
                    r = !0;
                    break;
                  }
                  n = F(e, n + 1);
                }
                return n;
              }(a, i),
              l = new fi({
                windowSize: s,
                inSize: a,
                batchSize: o,
                numSegments: i
              }, t),
              u = l.outputShape,
              c = u[0],
              d = u[1],
              h = this.makeOutputArray([c, d], r);
            return this.compileAndRun(l, [e, n], h), h.shape[1] === i ? h : (n = _t(0, i).tile([a / s]), this.segOpCompute(h, t, n, r, i));
          }, e.prototype.argMin = function (e, t) {
            var n = [t];
            Ue("argMin", n, e.rank);
            var r = Be(e.shape, n),
              i = r[0],
              o = S(r[1]),
              a = e.as2D(-1, o);
            return this.argReduce(a, "min").reshape(i);
          }, e.prototype.argMax = function (e, t) {
            var n = [t];
            Ue("argMax", n, e.rank);
            var r = Be(e.shape, n),
              i = r[0],
              o = S(r[1]),
              a = e.as2D(-1, o);
            return this.argReduce(a, "max").reshape(i);
          }, e.prototype.cumsum = function (e, t, n, r) {
            if (t !== e.rank - 1) throw new Error("WebGL cumsum shader expects an inner-most axis=" + (e.rank - 1) + " but got axis=" + t);
            var i = new Cn(e.shape, n, r);
            return this.compileAndRun(i, [e]);
          }, e.prototype.equal = function (e, t) {
            var n = new rn("return float(a == b);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.notEqual = function (e, t) {
            var n = new rn("return float(a != b);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.less = function (e, t) {
            if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.less(e, t);
            var n = new rn("return float(a < b);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.lessEqual = function (e, t) {
            var n = new rn("return float(a <= b);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.greater = function (e, t) {
            if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.greater(e, t);
            var n = new rn("return float(a > b);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.greaterEqual = function (e, t) {
            var n = new rn("return float(a >= b);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.logicalNot = function (e) {
            var t = new wi(e.shape, "return float(!(x >= 1.0));");
            return this.compileAndRun(t, [e]);
          }, e.prototype.logicalAnd = function (e, t) {
            var n = new rn("return float(a >= 1.0 && b >= 1.0);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.logicalOr = function (e, t) {
            var n = new rn("return float(a >= 1.0 || b >= 1.0);", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "bool");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.select = function (e, t, n) {
            var r = new pi(e.rank, t.shape, t.rank),
              i = this.makeOutputArray(r.outputShape, Pt(t.dtype, n.dtype));
            return this.compileAndRun(r, [e, t, n], i);
          }, e.prototype.where = function (e) {
            Oe("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
            var t = e.dataSync();
            return go(e.shape, t);
          }, e.prototype.topk = function (e, t, n) {
            return Vt(e.dataSync(), e.shape, e.dtype, t);
          }, e.prototype.min = function (e, t) {
            Ue("min", t, e.rank);
            var n = Be(e.shape, t),
              r = n[0],
              i = S(n[1]),
              o = e.as2D(-1, i);
            return this.reduce(o, "min", o.dtype).reshape(r);
          }, e.prototype.minimum = function (e, t) {
            if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.minimum(e, t);
            var n = new rn("\n  if (isNaN(a)) return a;\n  if (isNaN(b)) return b;\n\n  return min(a, b);\n", e.shape, t.shape);
            return this.compileAndRun(n, [e, t]);
          }, e.prototype.mod = function (e, t) {
            var n = new rn("if (b == 0.0) return NAN;\n  return mod(a, b);", e.shape, t.shape),
              r = n.getCustomSetupFunc();
            return this.compileAndRun(n, [e, t], null, r);
          }, e.prototype.max = function (e, t) {
            Ue("max", t, e.rank);
            var n = Be(e.shape, t),
              r = n[0],
              i = S(n[1]),
              o = e.as2D(-1, i);
            return this.reduce(o, "max", o.dtype).reshape(r);
          }, e.prototype.maximum = function (e, t) {
            if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.maximum(e, t);
            var n = new rn("\n  if (isNaN(a)) return a;\n  if (isNaN(b)) return b;\n\n  return max(a, b);\n", e.shape, t.shape);
            return this.compileAndRun(n, [e, t]);
          }, e.prototype.all = function (e, t) {
            Ue("all", t, e.rank);
            var n = Be(e.shape, t),
              r = n[0],
              i = S(n[1]),
              o = e.as2D(-1, i);
            return this.reduce(o, "all", o.dtype).reshape(r);
          }, e.prototype.any = function (e, t) {
            Ue("any", t, e.rank);
            var n = Be(e.shape, t),
              r = n[0],
              i = S(n[1]),
              o = e.as2D(-1, i);
            return this.reduce(o, "any", o.dtype).reshape(r);
          }, e.prototype.squaredDifference = function (e, t) {
            var n = new rn("return (a - b) * (a - b);", e.shape, t.shape);
            return this.compileAndRun(n, [e, t]);
          }, e.prototype.realDivide = function (e, t) {
            var n = new rn("if (a == b) return 1.0;\n  return a / b;", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "float32");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.floorDiv = function (e, t) {
            var n = new rn("\n  float resultSign = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  int result = ia / ib;\n  int amodb = ia - ib * result;\n\n  if (resultSign < 0.0 && amodb != 0) {\n    result -= 1;\n  }\n  return float(result);\n", e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, "int32");
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.add = function (e, t) {
            if ("complex64" === e.dtype && "complex64" === t.dtype) return this.complexSeparableBinaryOp(e, t, tn);
            var n = new rn(tn, e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, Pt(e.dtype, t.dtype));
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.complexSeparableBinaryOp = function (e, t, n) {
            var r = this,
              i = this.texData.get(e.dataId),
              o = this.texData.get(t.dataId),
              a = [[i.complexTensors.real, o.complexTensors.real], [i.complexTensors.imag, o.complexTensors.imag]].map(function (i) {
                var o = i[0],
                  a = i[1],
                  s = new rn(n, e.shape, t.shape),
                  l = r.makeOutputArray(s.outputShape, Pt(o.dtype, a.dtype)),
                  u = r.makeComplexComponentTensorHandle(e, o),
                  c = r.makeComplexComponentTensorHandle(t, a);
                return r.compileAndRun(s, [u, c], l);
              }),
              s = a[0],
              l = a[1],
              u = this.complex(s, l);
            return s.dispose(), l.dispose(), u;
          }, e.prototype.makeComplexComponentTensorHandle = function (e, t) {
            return {
              dataId: t.dataId,
              dtype: t.dtype,
              shape: e.shape
            };
          }, e.prototype.addN = function (e) {
            for (var t = e[0], n = 1; n < e.length; n++) t = this.add(t, e[n]);
            return t;
          }, e.prototype.subtract = function (e, t) {
            if ("complex64" === e.dtype && "complex64" === t.dtype) return this.complexSeparableBinaryOp(e, t, nn);
            if (this.shouldExecuteOnCPU([e, t])) return this.cpuBackend.subtract(e, t);
            var n = new rn(nn, e.shape, t.shape),
              r = this.makeOutputArray(n.outputShape, Pt(e.dtype, t.dtype));
            return this.compileAndRun(n, [e, t], r);
          }, e.prototype.pow = function (e, t) {
            var n = new rn("\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nreturn (round(mod(b, 2.0)) == 0 || round(mod(b, 2.0)) == 2) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n", e.shape, t.shape),
              r = n.getCustomSetupFunc(),
              i = this.makeOutputArray(n.outputShape, Pt(e.dtype, t.dtype));
            return this.compileAndRun(n, [e, t], i, r);
          }, e.prototype.ceil = function (e) {
            var t = new wi(e.shape, "return ceil(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.floor = function (e) {
            var t = new wi(e.shape, "return floor(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.sign = function (e) {
            var t = new wi(e.shape, "\n  if (isNaN(x)) { return 0.0; }\n  return sign(x);\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.round = function (e) {
            var t = new wi(e.shape, "\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.exp = function (e) {
            var t = new wi(e.shape, "return exp(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.expm1 = function (e) {
            var t = new wi(e.shape, "return exp(x) - 1.0;");
            return this.compileAndRun(t, [e]);
          }, e.prototype.log = function (e) {
            var t = new wi(e.shape, "if (x < 0.0) return NAN;\n  return log(x);"),
              n = t.getCustomSetupFunc();
            return this.compileAndRun(t, [e], null, n);
          }, e.prototype.log1p = function (e) {
            var t = new wi(e.shape, "return log(1.0 + x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.sqrt = function (e) {
            var t = new wi(e.shape, "return sqrt(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.rsqrt = function (e) {
            var t = new wi(e.shape, "return inversesqrt(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.square = function (e) {
            var t = new wi(e.shape, "return x * x;");
            return this.compileAndRun(t, [e]);
          }, e.prototype.reciprocal = function (e) {
            var t = new wi(e.shape, "return 1.0 / x;");
            return this.compileAndRun(t, [e]);
          }, e.prototype.relu = function (e) {
            var t = new wi(e.shape, "if (isNaN(x)) return x;\n  return (x < 0.0) ? 0.0 : x;\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.elu = function (e) {
            var t = new wi(e.shape, "return (x >= 0.0) ? x : (exp(x) - 1.0);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.eluDer = function (e, t) {
            var n = new rn("return (b >= 1.0) ? a : a * (b + 1.0);", e.shape, t.shape);
            return this.compileAndRun(n, [e, t]);
          }, e.prototype.selu = function (e) {
            var t = new wi(e.shape, "\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = 1.7580993408473768;\n  float scale = 1.0507009873554805;\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.int = function (e) {
            var t = new wi(e.shape, "return float(int(x));"),
              n = this.makeOutputArray(t.outputShape, "int32");
            return this.compileAndRun(t, [e], n);
          }, e.prototype.clip = function (e, t, n) {
            var r = new on(e.shape, t, n);
            return this.compileAndRun(r, [e]);
          }, e.prototype.abs = function (e) {
            var t = new wi(e.shape, "return abs(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.complexAbs = function (e) {
            var t = this.texData.get(e.dataId),
              n = new an(e.shape),
              r = [this.makeComplexComponentTensorHandle(e, t.complexTensors.real), this.makeComplexComponentTensorHandle(e, t.complexTensors.imag)];
            return this.compileAndRun(n, r);
          }, e.prototype.sigmoid = function (e) {
            var t = new wi(e.shape, "return 1.0 / (1.0 + exp(-1.0 * x));");
            return this.compileAndRun(t, [e]);
          }, e.prototype.softplus = function (e) {
            var t = new wi(e.shape, "\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.sin = function (e) {
            var t = new wi(e.shape, "if (isNaN(x)) return x;\n  return sin(x);\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.cos = function (e) {
            var t = new wi(e.shape, "if (isNaN(x)) return x;\n  return cos(x);\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.tan = function (e) {
            var t = new wi(e.shape, "return tan(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.asin = function (e) {
            var t = new wi(e.shape, "return asin(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.acos = function (e) {
            var t = new wi(e.shape, "return acos(x);");
            return this.compileAndRun(t, [e]);
          }, e.prototype.atan = function (e) {
            var t = new wi(e.shape, "if (isNaN(x)) return x;\n  return atan(x);\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.atan2 = function (e, t) {
            var n = new rn("\n  if (isNaN(a)) return a;\n  if (isNaN(b)) return b;\n\n  return atan(a, b);\n", e.shape, t.shape);
            return this.compileAndRun(n, [e, t]);
          }, e.prototype.sinh = function (e) {
            var t = new wi(e.shape, "\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.cosh = function (e) {
            var t = new wi(e.shape, "\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.tanh = function (e) {
            var t = new wi(e.shape, "\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n");
            return this.compileAndRun(t, [e]);
          }, e.prototype.asinh = function (e) {
            var t = new wi(e.shape, "return log(x + sqrt(x * x + 1.0));");
            return this.compileAndRun(t, [e]);
          }, e.prototype.acosh = function (e) {
            var t = new wi(e.shape, "if (isNaN(x)) return x;\n  if (x < 1.0) return NAN;\n  return log(x + sqrt(x * x - 1.0));"),
              n = t.getCustomSetupFunc();
            return this.compileAndRun(t, [e], null, n);
          }, e.prototype.atanh = function (e) {
            var t = new wi(e.shape, "if (isNaN(x)) return x;\n  if ((x < -1.0) || (x > 1.0)) return NAN;\n  return (log(1.0 + x) - log(1.0 - x)) / 2.0;"),
              n = t.getCustomSetupFunc();
            return this.compileAndRun(t, [e], null, n);
          }, e.prototype.erf = function (e) {
            var t = new wi(e.shape, '\n  // Error function is calculated approximately with elementary function.\n  // See "Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables", Abramowitz and Stegun.\n  float p = 0.3275911;\n  float a1 = 0.254829592;\n  float a2 = -0.284496736;\n  float a3 = 1.421413741;\n  float a4 = -1.453152027;\n  float a5 = 1.061405429;\n\n  float t = 1.0 / (1.0 + p * x);\n  return 1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x);\n');
            return this.compileAndRun(t, [e]);
          }, e.prototype.step = function (e, t) {
            var n = new wi(e.shape, function (e) {
              return void 0 === e && (e = 0), "if (isNaN(x)) return x;\n    return x > 0.0 ? 1.0 : float(" + e + ");\n  ";
            }(t));
            return this.compileAndRun(n, [e]);
          }, e.prototype.conv2dWithIm2Row = function (e, t, n) {
            var r = n.filterWidth,
              i = n.filterHeight,
              o = n.inChannels,
              a = n.outWidth,
              s = n.outHeight,
              l = r * i * o,
              u = s * a,
              c = [l, u],
              d = e.squeeze([0]),
              h = t.reshape([l, -1]),
              f = new $r(c, d.shape, n),
              p = this.compileAndRun(f, [d], this.makePackedTensor(c)),
              m = new Qr(p.shape, h.shape, [u, n.outChannels], !0, !1),
              g = this.compileAndRun(m, [p, h], this.makePackedTensor(m.outputShape));
            return !1 === ve.get("WEBGL_LAZILY_UNPACK") && (g = this.unpackTensor(g)), g.reshape([1, s, a, n.outChannels]);
          }, e.prototype.conv2d = function (e, t, n) {
            if (ve.get("WEBGL_CONV_IM2COL") && 1 === e.shape[0]) return this.conv2dWithIm2Row(e, t, n);
            var r = new hn(n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.conv2dDerInput = function (e, t, n) {
            var r = new un(n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.conv2dDerFilter = function (e, t, n) {
            var r = new ln(n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.depthwiseConv2D = function (e, t, n) {
            var r = new fn(n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.depthwiseConv2DDerInput = function (e, t, n) {
            var r = new dn(n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.depthwiseConv2DDerFilter = function (e, t, n) {
            var r = new cn(n);
            return this.compileAndRun(r, [e, t]);
          }, e.prototype.maxPool = function (e, t) {
            var n = new ii(t, "max", !1),
              r = this.makeOutputArray(n.outputShape, e.dtype);
            return this.compileAndRun(n, [e], r);
          }, e.prototype.avgPool = function (e, t) {
            var n = new ii(t, "avg", !1),
              r = this.makeOutputArray(n.outputShape, "float32");
            return this.compileAndRun(n, [e], r);
          }, e.prototype.maxPoolBackprop = function (e, t, n, r) {
            var i = new ii(r, "max", !0),
              o = this.compileAndRun(i, [t]),
              a = new Kr(r),
              s = this.makeOutputArray(a.outputShape, t.dtype),
              l = this.compileAndRun(a, [e, o], s);
            return o.dispose(), l;
          }, e.prototype.avgPoolBackprop = function (e, t, n) {
            var r = new qt(n),
              i = this.makeOutputArray(r.outputShape, t.dtype);
            return this.compileAndRun(r, [e], i);
          }, e.prototype.cast = function (e, t) {
            return jt(e, t, this);
          }, e.prototype.reshape = function (e, t) {
            return this.texData.get(e.dataId).isPacked && !wr(e.shape, t) ? this.packedReshape(e, t) : Nt(e, t);
          }, e.prototype.resizeBilinear = function (e, t, n, r) {
            var i = new li(e.shape, t, n, r);
            return this.compileAndRun(i, [e]);
          }, e.prototype.resizeBilinearBackprop = function (e, t, n) {
            var r = new si(e, t, n);
            return this.compileAndRun(r, [e]);
          }, e.prototype.resizeNearestNeighbor = function (e, t, n, r) {
            var i = new ci(e.shape, t, n, r);
            return this.compileAndRun(i, [e]);
          }, e.prototype.resizeNearestNeighborBackprop = function (e, t, n) {
            var r = new ui(e, t, n);
            return this.compileAndRun(r, [e]);
          }, e.prototype.multinomial = function (e, t, n, r) {
            var i = t ? e : rt(e),
              o = i.shape[0],
              a = i.shape[1],
              s = new Jr(o, a, n),
              l = this.makeOutputArray(s.outputShape, "int32"),
              u = s.getCustomSetupFunc(r);
            return this.compileAndRun(s, [i], l, u);
          }, e.prototype.oneHot = function (e, t, n, r) {
            var i = new ei(e.size, t, n, r);
            return this.compileAndRun(i, [e]);
          }, e.prototype.nonMaxSuppression = function (e, t, n, r, i) {
            return Oe("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead"), zt(e.dataSync(), t.dataSync(), n, r, i);
          }, e.prototype.cropAndResize = function (e, t, n, r, i, o) {
            var a = new pn(e.shape, t.shape, r, i, o);
            return this.compileAndRun(a, [e, t, n]);
          }, e.prototype.depthToSpace = function (e, t, n) {
            b(t > 1, "blockSize should be > 1 for depthToSpace, but was: " + t);
            var r = e.shape[0],
              i = ("NHWC" === n ? e.shape[1] : e.shape[2]) * t,
              o = ("NHWC" === n ? e.shape[2] : e.shape[3]) * t,
              a = ("NHWC" === n ? e.shape[3] : e.shape[1]) / (t * t),
              s = new Pn("NHWC" === n ? [r, i, o, a] : [r, a, i, o], t, n);
            return this.compileAndRun(s, [e]);
          }, e.prototype.split = function (e, t, n) {
            return Gt(e, t, n);
          }, e.prototype.scatterND = function (e, t, n) {
            var r = Ye(0, e, n),
              i = r.sliceRank,
              o = r.numUpdates,
              a = r.sliceSize,
              s = r.strides,
              l = r.outputSize,
              u = [l / a, a],
              c = e.reshape([o, i]),
              d = t.reshape([o, a]);
            if (0 === l) return Nt(lt([]), n);
            var h = ut(0),
              f = new hi(o, i, c.rank, d.rank, s, u);
            return this.compileAndRun(f, [d, c, h]).reshape(n);
          }, e.prototype.sparseToDense = function (e, t, n, r) {
            var i = Ye(0, e, n),
              o = i.sliceRank,
              a = i.numUpdates,
              s = i.strides,
              l = i.outputSize,
              u = new hi(a, o, e.rank, t.rank, s, [l, 1], !1);
            return this.compileAndRun(u, [t, e, r]).reshape(n);
          }, e.prototype.fft = function (e) {
            return this.fftImpl(e, !1);
          }, e.prototype.ifft = function (e) {
            return this.fftImpl(e, !0);
          }, e.prototype.fftImpl = function (e, t) {
            var n = this.texData.get(e.dataId),
              r = new jn(Rn, e.shape, t),
              i = new jn(In, e.shape, t),
              o = [this.makeComplexComponentTensorHandle(e, n.complexTensors.real), this.makeComplexComponentTensorHandle(e, n.complexTensors.imag)],
              a = this.compileAndRun(r, o),
              s = this.compileAndRun(i, o),
              l = this.complex(a, s).as2D(e.shape[0], e.shape[1]);
            return a.dispose(), s.dispose(), l;
          }, e.prototype.gatherND = function (e, t) {
            var n = t.shape,
              r = n[n.length - 1],
              i = We(e, t),
              o = i[0],
              a = i[1],
              s = i[2],
              l = i[3],
              u = t.reshape([a, r]),
              c = e.reshape([e.size / s, s]),
              d = new Fn(r, l, [a, s]);
            return this.compileAndRun(d, [c, u]).reshape(o);
          }, e.prototype.makeOutputArray = function (e, t) {
            return te.make(e, {}, t);
          }, e.prototype.makePackedTensor = function (e) {
            var t = te.make(e, {});
            return this.texData.get(t.dataId).isPacked = !0, t;
          }, e.prototype.unpackTensor = function (e) {
            var t = new Si(e.shape);
            return this.compileAndRun(t, [e]);
          }, e.prototype.getBatchDim = function (e, t) {
            return void 0 === t && (t = 2), S(e.slice(0, e.length - t));
          }, e.prototype.getRowsCols = function (e) {
            if (0 === e.length) throw Error("Cannot get rows and columns of an empty shape array.");
            return [e.length > 1 ? e[e.length - 2] : 1, e[e.length - 1]];
          }, e.prototype.packedReshape = function (e, t) {
            var n = e.reshape([this.getBatchDim(e.shape)].concat(this.getRowsCols(e.shape))),
              r = [this.getBatchDim(t)].concat(this.getRowsCols(t)),
              i = new ai(r, n.shape);
            return this.compileAndRun(i, [n], this.makePackedTensor(r)).reshape(t);
          }, e.prototype.compileAndRun = function (e, t, n, r, i) {
            var o = this;
            if (void 0 === i && (i = !0), null == n && (n = this.makeOutputArray(e.outputShape, t[0].dtype)), 0 === n.size) return this.texData.get(n.dataId).values = R(n.dtype, 0), n;
            var a = t.map(function (t) {
              if ("complex64" === t.dtype) throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");
              var n = o.texData.get(t.dataId);
              if (null == n.texture && (n.isPacked || !e.usesPackedTextures) && S(t.shape) <= ve.get("WEBGL_SIZE_UPLOAD_UNIFORM")) return {
                shape: t.shape,
                texData: null,
                isUniform: !0,
                uniformValues: o.readSync(t.dataId)
              };
              if (n.isPacked !== !!e.usesPackedTextures) {
                var r = void 0,
                  i = void 0;
                n.isPacked ? (r = new Si(t.shape), i = o.compileAndRun(r, [t])) : (r = new ni(t.shape), i = o.compileAndRun(r, [t], o.makePackedTensor(t.shape))), n = o.texData.get(i.dataId), t = i;
              }
              return o.uploadToGPU(t.dataId), {
                shape: t.shape,
                texData: n,
                isUniform: !1
              };
            });
            this.uploadToGPU(n.dataId);
            var s,
              l = {
                shape: n.shape,
                texData: this.texData.get(n.dataId),
                isUniform: !1
              },
              u = function (e, t, n) {
                var r = "";
                t.concat(n).forEach(function (e) {
                  r += e.shape + "_" + (e.isUniform ? "uniform" : e.texData.texShape);
                });
                var i = e.userCode,
                  o = (!0 === e.supportsBroadcasting).toString();
                return e.constructor.name + "_" + o + "_" + r + "_" + i;
              }(e, a, l),
              c = this.getAndSaveBinary(u, function () {
                return function (e, t, n, r) {
                  for (var i = t.userCode, o = n.map(function (e, n) {
                      var r = {
                        logicalShape: e.shape,
                        texShape: e.isUniform ? null : e.texData.texShape,
                        isUniform: e.isUniform,
                        isPacked: !e.isUniform && e.texData.isPacked
                      };
                      return {
                        name: t.variableNames[n],
                        shapeInfo: r
                      };
                    }), a = o.map(function (e) {
                      return e.shapeInfo;
                    }), s = {
                      logicalShape: r.shape,
                      texShape: r.texData.texShape,
                      isUniform: !1,
                      isPacked: r.texData.isPacked
                    }, l = vn(o, s, i, !0 === t.supportsBroadcasting, t.usesPackedTextures), u = e.createProgram(l), c = {}, d = 0; d < t.variableNames.length; d++) {
                    var h = t.variableNames[d];
                    c[h] = e.getUniformLocation(u, h, !1);
                  }
                  return {
                    program: t,
                    source: l,
                    webGLProgram: u,
                    uniformLocations: c,
                    gpgpu: e,
                    inShapeInfos: a,
                    outShapeInfo: s
                  };
                }(o.gpgpu, e, a, l);
              }),
              d = null != this.activeTimers;
            if (d && (s = this.startTimer()), function (e, t, n, r) {
              Wr(e.inShapeInfos, t), Wr([e.outShapeInfo], [n]);
              var i = n.texData.texture,
                o = n.texData.texShape,
                a = e.gpgpu;
              n.texData.isPacked ? a.setOutputPackedMatrixTexture(i, o[0], o[1]) : a.setOutputMatrixTexture(i, o[0], o[1]), a.setProgram(e.webGLProgram), t.forEach(function (t, n) {
                var r = e.program.variableNames[n],
                  i = e.uniformLocations[r];
                if (null != i) {
                  if (t.isUniform) {
                    if (1 === S(t.shape)) a.gl.uniform1f(i, t.uniformValues[0]);else {
                      var o = t.uniformValues;
                      o instanceof Float32Array || (o = new Float32Array(o)), a.gl.uniform1fv(i, o);
                    }
                    return;
                  }
                  var s = t.texData.texture;
                  a.setInputMatrixTexture(s, i, n);
                }
              }), null != r && r(a, e.webGLProgram), a.executeProgram();
            }(c, a, l, r), ve.get("WEBGL_PAGING_ENABLED") && i && this.numBytesInGPU > this.NUM_BYTES_BEFORE_PAGING) for (var h = this.numBytesInGPU - this.NUM_BYTES_BEFORE_PAGING; h > 0 && this.lruDataGPU.length > 0;) {
              var f = this.lruDataGPU.shift(),
                p = this.texData.get(f),
                m = p.shape,
                g = p.dtype;
              h -= this.computeBytes(m, g), this.read(f);
            }
            return d && (s = this.endTimer(s), this.activeTimers.push({
              name: e.constructor.name,
              query: this.getQueryTime(s)
            })), n;
          }, e.prototype.getAndSaveBinary = function (e, t) {
            return e in this.binaryCache || (this.binaryCache[e] = t()), this.binaryCache[e];
          }, e.prototype.getTextureManager = function () {
            return this.textureManager;
          }, e.prototype.dispose = function () {
            if (!this.disposed) {
              for (var e in this.binaryCache) this.gpgpu.deleteProgram(this.binaryCache[e].webGLProgram);
              this.textureManager.dispose(), this.canvas.remove(), null != this.fromPixels2DContext && this.fromPixels2DContext.canvas.remove(), this.gpgpuCreatedLocally && this.gpgpu.dispose(), this.disposed = !0;
            }
          }, e.prototype.floatPrecision = function () {
            var e = this;
            return Te(function () {
              return e.abs(ut(1e-8)).get() > 0 ? 32 : 16;
            });
          }, e.prototype.uploadToGPU = function (e) {
            var t = this.texData.get(e),
              n = t.shape,
              r = t.values,
              i = t.texture,
              o = t.dtype,
              a = t.usage,
              s = t.isPacked;
            if (null == i) {
              var l,
                u = null != this.activeTimers;
              u && (l = performance.now());
              var c = _r(n, s);
              t.texShape = c;
              var d = this.acquireTexture(e, c, a, s);
              if (t.texture = d, null != r) {
                if (s) {
                  var h = S(n.slice(0, n.length - 2)),
                    f = n.length > 1 ? n[n.length - 2] : 1,
                    p = n[n.length - 1];
                  this.gpgpu.uploadMatrixToPackedTexture(d, h, f, p, yo(r, o));
                } else this.gpgpu.uploadMatrixToTexture(d, c[0], c[1], yo(r, o));
                t.values = null, u && (this.uploadWaitMs += performance.now() - l);
              }
            } else ve.get("WEBGL_PAGING_ENABLED") && this.lruDataGPU.indexOf(e) >= 0 && (this.lruDataGPU.splice(this.lruDataGPU.indexOf(e), 1), this.lruDataGPU.push(e));
          }, e.prototype.convertAndCacheOnCPU = function (e, t) {
            var n = this.delayedStorage,
              r = this.texData.get(e),
              i = r.texture,
              o = r.texShape,
              a = r.dtype,
              s = r.usage,
              l = r.isPacked;
            return n && null != i && (this.releaseTexture(e, i, o, s, l), r.texture = null, r.texShape = null), r.usage = Dn.UPLOAD, null != t && (r.values = function (e, t) {
              if ("float32" === t || "complex64" === t) return e;
              if ("int32" === t || "bool" === t) {
                for (var n = "int32" === t ? new Int32Array(e.length) : new Uint8Array(e.length), r = 0; r < n.length; ++r) n[r] = Math.round(e[r]);
                return n;
              }
              throw new Error("Unknown dtype " + t);
            }(t, a)), r.values;
          }, e.prototype.releaseTexture = function (e, t, n, r, i) {
            var o = this.texData.get(e),
              a = o.shape,
              s = o.dtype;
            if (ve.get("WEBGL_PAGING_ENABLED")) {
              var l = this.lruDataGPU.indexOf(e);
              l >= 0 && this.lruDataGPU.splice(l, 1);
            }
            this.numBytesInGPU -= this.computeBytes(a, s), this.textureManager.releaseTexture(t, n, r, i);
          }, e.prototype.acquireTexture = function (e, t, n, r) {
            var i = this.texData.get(e),
              o = i.shape,
              a = i.dtype;
            return ve.get("WEBGL_PAGING_ENABLED") && this.lruDataGPU.push(e), this.numBytesInGPU += this.computeBytes(o, a), this.textureManager.acquireTexture(t, n, r);
          }, e.prototype.computeBytes = function (e, t) {
            return S(e) * D(t);
          }, e;
        }();
        function yo(e, t) {
          return e instanceof Float32Array ? e : new Float32Array(e);
        }
        ve.get("IS_BROWSER") && ve.registerBackend("webgl", function () {
          return new vo();
        }, 2, ee);
        var bo = nt({
            abs_: function abs_(e) {
              var t = et(e, "x", "abs");
              return "complex64" === t.dtype ? ve.engine.runKernel(function (e) {
                return e.complexAbs(t);
              }, {
                $x: t
              }) : ve.engine.runKernel(function (e) {
                return e.abs(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.mulStrict(t.toFloat().step(-1));
                  }
                };
              });
            }
          }),
          _o = nt({
            acos_: function acos_(e) {
              var t = et(e, "x", "acos");
              return ve.engine.runKernel(function (e) {
                return e.acos(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(ut(1).sub(t.toFloat().square()).sqrt()).neg();
                  }
                };
              });
            }
          }),
          xo = nt({
            acosh_: function acosh_(e) {
              var t = et(e, "x", "acosh");
              return ve.engine.runKernel(function (e) {
                return e.acosh(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.toFloat().square().sub(ut(1)).sqrt());
                  }
                };
              });
            }
          }),
          wo = nt({
            asin_: function asin_(e) {
              var t = et(e, "x", "asin");
              return ve.engine.runKernel(function (e) {
                return e.asin(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(ut(1).sub(t.toFloat().square()).sqrt());
                  }
                };
              });
            }
          }),
          So = nt({
            asinh_: function asinh_(e) {
              var t = et(e, "x", "asinh");
              return ve.engine.runKernel(function (e) {
                return e.asinh(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(ut(1).add(t.toFloat().square()).sqrt());
                  }
                };
              });
            }
          }),
          Ao = nt({
            atan_: function atan_(e) {
              var t = et(e, "x", "atan");
              return ve.engine.runKernel(function (e) {
                return e.atan(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(ut(1).add(t.toFloat().square()));
                  }
                };
              });
            }
          }),
          Eo = nt({
            atanh_: function atanh_(e) {
              var t = et(e, "x", "atanh");
              return ve.engine.runKernel(function (e) {
                return e.atanh(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(ut(1).sub(t.toFloat().square()));
                  }
                };
              });
            }
          }),
          To = nt({
            ceil_: function ceil_(e) {
              var t = et(e, "x", "ceil");
              return ve.engine.runKernel(function (e) {
                return e.ceil(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(e);
                  }
                };
              });
            }
          }),
          Mo = nt({
            clipByValue_: function clipByValue_(e, t, n) {
              var r = et(e, "x", "clipByValue");
              return b(t <= n, "Error in clip: min (" + t + ") must be less than or equal to max (" + n + ")."), ve.engine.runKernel(function (e) {
                return e.clip(r, t, n);
              }, {
                $x: r
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.where(r.greaterEqual(ut(t)).logicalAnd(r.lessEqual(ut(n))), Ct(e));
                  }
                };
              });
            }
          }),
          Co = nt({
            cos_: function cos_(e) {
              var t = et(e, "x", "cos");
              return ve.engine.runKernel(function (e) {
                return e.cos(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return t.toFloat().sin().neg().mulStrict(e);
                  }
                };
              });
            }
          }),
          ko = nt({
            cosh_: function cosh_(e) {
              var t = et(e, "x", "cosh");
              return ve.engine.runKernel(function (e) {
                return e.cosh(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return t.toFloat().sinh().mulStrict(e);
                  }
                };
              });
            }
          }),
          Po = nt({
            erf_: function erf_(e) {
              var t = et(e, "x", "erf");
              return b("int32" === t.dtype || "float32" === t.dtype, "Input dtype must be `int32` or `float32`."), "int32" === t.dtype && (t = t.toFloat()), ve.engine.runKernel(function (e) {
                return e.erf(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.mulStrict(ut(2 / Math.sqrt(Math.PI)).mul(t.square().neg().exp()));
                  }
                };
              });
            }
          }),
          Oo = nt({
            exp_: function exp_(e) {
              var t = et(e, "x", "exp");
              return ve.engine.runKernel(function (e, n) {
                return n(e.exp(t));
              }, {
                $x: t
              }, function (e, t) {
                var n = t[0];
                return {
                  $x: function $x() {
                    return e.mulStrict(n);
                  }
                };
              });
            }
          }),
          Ro = nt({
            expm1_: function expm1_(e) {
              var t = et(e, "x", "expm1");
              return ve.engine.runKernel(function (e) {
                return e.expm1(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.mulStrict(t.exp());
                  }
                };
              });
            }
          }),
          Io = nt({
            floor_: function floor_(e) {
              var t = et(e, "x", "floor");
              return ve.engine.runKernel(function (e) {
                return e.floor(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(e);
                  }
                };
              });
            }
          }),
          jo = nt({
            log_: function log_(e) {
              var t = et(e, "x", "log");
              return ve.engine.runKernel(function (e) {
                return e.log(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.toFloat());
                  }
                };
              });
            }
          }),
          No = nt({
            log1p_: function log1p_(e) {
              var t = et(e, "x", "log1p");
              return ve.engine.runKernel(function (e) {
                return e.log1p(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.add(ut(1)));
                  }
                };
              });
            }
          }),
          Lo = nt({
            logSigmoid_: function logSigmoid_(e) {
              var t = et(e, "x", "logSigmoid");
              return ve.engine.runKernel(function (e) {
                return e.softplus(t.neg()).neg();
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.mulStrict(t.neg().sigmoid());
                  }
                };
              });
            }
          }),
          Do = nt({
            neg_: function neg_(e) {
              var t = et(e, "x", "neg");
              return ve.engine.runKernel(function (e) {
                return e.neg(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.neg();
                  }
                };
              });
            }
          }),
          Bo = nt({
            reciprocal_: function reciprocal_(e) {
              var t = et(e, "x", "reciprocal");
              return ve.engine.runKernel(function (e) {
                return e.reciprocal(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.square().neg());
                  }
                };
              });
            }
          }),
          Fo = nt({
            round_: function round_(e) {
              var t = et(e, "x", "round");
              return ve.engine.runKernel(function (e) {
                return e.round(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(e);
                  }
                };
              });
            }
          }),
          zo = nt({
            rsqrt_: function rsqrt_(e) {
              var t = et(e, "x", "rsqrt");
              return ve.engine.runKernel(function (e) {
                return e.rsqrt(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.pow(ut(1.5)).mul(ut(2))).neg();
                  }
                };
              });
            }
          }),
          Uo = nt({
            sigmoid_: function sigmoid_(e) {
              var t = et(e, "x", "sigmoid");
              return ve.engine.runKernel(function (e, n) {
                return n(e.sigmoid(t));
              }, {
                $x: t
              }, function (e, t) {
                var n = t[0];
                return {
                  $x: function $x() {
                    return e.mulStrict(n.mul(ut(1).sub(n)));
                  }
                };
              });
            }
          }),
          Go = nt({
            sign_: function sign_(e) {
              var t = et(e, "x", "sign");
              return ve.engine.runKernel(function (e) {
                return e.sign(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(e);
                  }
                };
              });
            }
          }),
          Vo = nt({
            sin_: function sin_(e) {
              var t = et(e, "x", "sin");
              return ve.engine.runKernel(function (e) {
                return e.sin(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return t.toFloat().cos().mulStrict(e);
                  }
                };
              });
            }
          }),
          Ho = nt({
            sinh_: function sinh_(e) {
              var t = et(e, "x", "sinh");
              return ve.engine.runKernel(function (e) {
                return e.sinh(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return t.toFloat().cosh().mulStrict(e);
                  }
                };
              });
            }
          }),
          qo = nt({
            softplus_: function softplus_(e) {
              var t = et(e, "x", "softplus");
              return ve.engine.runKernel(function (e) {
                return e.softplus(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.mulStrict(t.sigmoid());
                  }
                };
              });
            }
          }),
          Wo = nt({
            sqrt_: function sqrt_(e) {
              var t = et(e, "x", "sqrt");
              return ve.engine.runKernel(function (e) {
                return e.sqrt(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.toFloat().sqrt().mul(ut(2)));
                  }
                };
              });
            }
          }),
          $o = nt({
            square_: function square_(e) {
              var t = et(e, "x", "square");
              return ve.engine.runKernel(function (e) {
                return e.square(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.mulStrict(t.toFloat().mul(ut(2)));
                  }
                };
              });
            }
          }),
          Xo = nt({
            step_: function step_(e, t) {
              void 0 === t && (t = 0);
              var n = et(e, "x", "step");
              return ve.engine.runKernel(function (e) {
                return e.step(n, t);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(e);
                  }
                };
              });
            }
          }),
          Yo = nt({
            tan_: function tan_(e) {
              var t = et(e, "x", "tan");
              return ve.engine.runKernel(function (e) {
                return e.tan(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.divStrict(t.cos().square());
                  }
                };
              });
            }
          }),
          Ko = nt({
            tanh_: function tanh_(e) {
              var t = et(e, "x", "tanh");
              return ve.engine.runKernel(function (e, n) {
                return n(e.tanh(t));
              }, {
                $x: t
              }, function (e, t) {
                var n = t[0];
                return {
                  $x: function $x() {
                    return ut(1).sub(n.square()).mulStrict(e);
                  }
                };
              });
            }
          });
        function Zo(e) {
          return null == e ? null : 0 === e.rank ? e.as1D() : 1 === e.rank ? e : 2 === e.rank ? e.as4D(1, 1, e.shape[0], e.shape[1]) : 3 === e.rank ? e.as4D(1, e.shape[0], e.shape[1], e.shape[2]) : e;
        }
        var Qo = nt({
            batchNormalization2d_: function batchNormalization2d_(e, t, n, r, i, o) {
              void 0 === r && (r = .001);
              var a,
                s,
                l = et(e, "x", "batchNormalization"),
                u = et(t, "mean", "batchNormalization"),
                c = et(n, "variance", "batchNormalization");
              return null != i && (a = et(i, "scale", "batchNormalization")), null != o && (s = et(o, "offset", "batchNormalization")), b(2 === l.rank, "Error in batchNormalization3D: x must be rank 3 but got rank " + l.rank + "."), b(2 === u.rank || 1 === u.rank, "Error in batchNormalization2D: mean must be rank 2 or rank 1 but got rank " + u.rank + "."), b(2 === c.rank || 1 === c.rank, "Error in batchNormalization2D: variance must be rank 2 or rank 1 but got rank " + c.rank + "."), null != a && b(2 === a.rank || 1 === a.rank, "Error in batchNormalization2D: scale must be rank 2 or rank 1 but got rank " + a.rank + "."), null != s && b(2 === s.rank || 1 === s.rank, "Error in batchNormalization2D: offset must be rank 2 or rank 1 but got rank " + s.rank + "."), ta(l, u, c, r, a, s);
            }
          }),
          Jo = nt({
            batchNormalization3d_: function batchNormalization3d_(e, t, n, r, i, o) {
              void 0 === r && (r = .001);
              var a,
                s,
                l = et(e, "x", "batchNormalization"),
                u = et(t, "mean", "batchNormalization"),
                c = et(n, "variance", "batchNormalization");
              return null != i && (a = et(i, "scale", "batchNormalization")), null != o && (s = et(o, "offset", "batchNormalization")), b(3 === l.rank, "Error in batchNormalization3D: x must be rank 3 but got rank " + l.rank + "."), b(3 === u.rank || 1 === u.rank, "Error in batchNormalization3D: mean must be rank 3 or rank 1 but got rank " + u.rank + "."), b(3 === c.rank || 1 === c.rank, "Error in batchNormalization3D: variance must be rank 3 or rank 1 but got rank " + c.rank + "."), null != a && b(3 === a.rank || 1 === a.rank, "Error in batchNormalization3D: scale must be rank 3 or rank 1 but got rank " + a.rank + "."), null != s && b(3 === s.rank || 1 === s.rank, "Error in batchNormalization3D: offset must be rank 3 or rank 1 but got rank " + s.rank + "."), ta(l, u, c, r, a, s);
            }
          }),
          ea = nt({
            batchNormalization4d_: function batchNormalization4d_(e, t, n, r, i, o) {
              void 0 === r && (r = .001);
              var a,
                s,
                l = et(e, "x", "batchNormalization"),
                u = et(t, "mean", "batchNormalization"),
                c = et(n, "variance", "batchNormalization");
              return null != i && (a = et(i, "scale", "batchNormalization")), null != o && (s = et(o, "offset", "batchNormalization")), b(4 === l.rank, "Error in batchNormalization4D: x must be rank 4 but got rank " + l.rank + "."), b(4 === u.rank || 1 === u.rank, "Error in batchNormalization4D: mean must be rank 4 or rank 1 but got rank " + u.rank + "."), b(4 === c.rank || 1 === c.rank, "Error in batchNormalization4D: variance must be rank 4 or rank 1 but got rank " + c.rank + "."), null != a && b(4 === a.rank || 1 === a.rank, "Error in batchNormalization4D: scale must be rank 4 or rank 1 but got rank " + a.rank + "."), null != s && b(4 === s.rank || 1 === s.rank, "Error in batchNormalization4D: offset must be rank 4 or rank 1 but got rank " + s.rank + "."), ta(l, u, c, r, a, s);
            }
          }),
          ta = nt({
            batchNormalization_: function batchNormalization_(e, t, n, r, i, o) {
              void 0 === r && (r = .001);
              var a,
                s,
                l,
                u = et(e, "x", "batchNormalization"),
                c = et(t, "mean", "batchNormalization"),
                d = et(n, "variance", "batchNormalization");
              return null != i && (a = et(i, "scale", "batchNormalization")), null != o && (s = et(o, "offset", "batchNormalization")), b(c.rank === d.rank, "Batch normalization gradient requires mean and variance to have equal ranks."), b(null == s || c.rank === s.rank, "Batch normalization gradient requires mean and offset to have equal ranks."), b(null == a || c.rank === a.rank, "Batch normalization gradient requires mean and scale to have equal ranks."), l = 0 === u.rank || 1 === u.rank ? u.as4D(1, 1, 1, u.size) : 2 === u.rank ? u.as4D(1, 1, u.shape[0], u.shape[1]) : 3 === u.rank ? u.as4D(1, u.shape[0], u.shape[1], u.shape[2]) : u, ve.engine.runKernel(function (e) {
                return e.batchNormalization(l, Zo(c), Zo(d), r, Zo(a), Zo(s));
              }, {
                $x: u,
                $mean: c,
                $variance: d,
                $scale: a,
                $offset: s
              }, function (e) {
                var t = null == a ? ut(1) : a,
                  n = $t(c.shape, l.shape),
                  i = [];
                if (1 === c.rank) {
                  for (var o = 0; o < l.shape.length - 1; ++o) i.push(l.shape[o]);
                  i.push(1);
                }
                var s = u.sub(c),
                  h = e.mul(t),
                  f = zo(d.add(ut(r))),
                  p = f.mul(f).mul(f).mul(ut(-.5));
                return {
                  $x: function $x() {
                    return 1 === c.rank ? e.mul(ho(f.as4D(1, 1, 1, c.shape[0]), i)).mul(t).reshape(u.shape) : e.mul(f).mul(t).reshape(u.shape);
                  },
                  $mean: function $mean() {
                    var e = f.mul(ut(-1)).mul(h);
                    return 1 === c.rank && (e = e.sum(n)), e.reshape(c.shape);
                  },
                  $variance: function $variance() {
                    var e = p.mul(s).mul(h);
                    return 1 === c.rank && (e = e.sum(n)), e.reshape(c.shape);
                  },
                  $scale: function $scale() {
                    var t = s.mul(f),
                      r = e.mul(t);
                    return 1 === c.rank && (r = r.sum(n)), r.reshape(c.shape);
                  },
                  $offset: function $offset() {
                    var t = e;
                    return 1 === c.rank && (t = t.sum(n)), t.reshape(c.shape);
                  }
                };
              }).reshape(u.shape);
            }
          });
        function na(e, t, n, r, i, o, a) {
          void 0 === a && (a = "channelsLast");
          var s,
            l = ia(t),
            u = l[0],
            c = l[1];
          if ("channelsLast" === a) s = [u, c, e[3], e[3]];else {
            if ("channelsFirst" !== a) throw new Error("Unknown dataFormat " + a);
            s = [u, c, e[1], e[1]];
          }
          return ra(e, s, n, r, i, o, !1, a);
        }
        function ra(e, t, n, r, i, o, a, s) {
          void 0 === a && (a = !1), void 0 === s && (s = "channelsLast");
          var l = [-1, -1, -1, -1],
            u = l[0],
            c = l[1],
            d = l[2],
            h = l[3];
          if ("channelsLast" === s) u = e[0], c = e[1], d = e[2], h = e[3];else {
            if ("channelsFirst" !== s) throw new Error("Unknown dataFormat " + s);
            u = e[0], h = e[1], c = e[2], d = e[3];
          }
          var f,
            p = t[0],
            m = t[1],
            g = t[3],
            v = ia(n),
            y = v[0],
            _ = v[1],
            x = ia(r),
            w = x[0],
            S = x[1],
            A = oa(p, w),
            T = oa(m, S),
            M = function (e, t, n, r, i, o, a, s) {
              var l, u, c;
              if ("number" == typeof e) {
                l = {
                  top: e,
                  bottom: e,
                  left: e,
                  right: e,
                  type: 0 === e ? "VALID" : "NUMBER"
                };
                var d = function (e, t, n, r, i, o) {
                  null == i && (i = function (e, t, n, r) {
                    void 0 === r && (r = 1);
                    var i = oa(t, r);
                    return Math.floor((e[0] * (n - 1) - n + i) / 2);
                  }(e, t, r));
                  var a = e[0],
                    s = e[1],
                    l = aa((a - t + 2 * i) / r + 1, o);
                  b(E(l), "The output # of rows (" + l + ") must be an integer. Change the stride and/or zero pad parameters");
                  var u = aa((s - t + 2 * i) / r + 1, o);
                  return b(E(u), "The output # of columns (" + u + ") must be an integer. Change the stride and/or zero pad parameters"), [l, u, n];
                }([t, n, 1], o, 1, r, e, s);
                u = d[0], c = d[1];
              } else if ("same" === e) {
                var h = ((u = Math.ceil(t / r)) - 1) * r + o - t,
                  f = ((c = Math.ceil(n / i)) - 1) * i + a - n,
                  p = Math.floor(h / 2),
                  m = h - p,
                  g = Math.floor(f / 2);
                l = {
                  top: p,
                  bottom: m,
                  left: g,
                  right: f - g,
                  type: "SAME"
                };
              } else {
                if ("valid" !== e) throw Error("Unknown padding parameter: " + e);
                l = {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  type: "VALID"
                }, u = Math.ceil((t - o + 1) / r), c = Math.ceil((n - a + 1) / i);
              }
              return {
                padInfo: l,
                outHeight: u,
                outWidth: c
              };
            }(i, c, d, y, _, A, T, o),
            C = M.padInfo,
            k = M.outHeight,
            P = M.outWidth,
            O = a ? g * h : g;
          return "channelsFirst" === s ? f = [u, O, k, P] : "channelsLast" === s && (f = [u, k, P, O]), {
            batchSize: u,
            dataFormat: s,
            inHeight: c,
            inWidth: d,
            inChannels: h,
            outHeight: k,
            outWidth: P,
            outChannels: O,
            padInfo: C,
            strideHeight: y,
            strideWidth: _,
            filterHeight: p,
            filterWidth: m,
            effectiveFilterHeight: A,
            effectiveFilterWidth: T,
            dilationHeight: w,
            dilationWidth: S,
            inShape: e,
            outShape: f,
            filterShape: t
          };
        }
        function ia(e) {
          return "number" == typeof e ? [e, e] : e;
        }
        function oa(e, t) {
          return t <= 1 ? e : e + (e - 1) * (t - 1);
        }
        function aa(e, t) {
          if (!t) return e;
          switch (t) {
            case "round":
              return Math.round(e);
            case "ceil":
              return Math.ceil(e);
            case "floor":
              return Math.floor(e);
            default:
              throw new Error("Unknown roundingMode " + t);
          }
        }
        function sa(e) {
          var t = ia(e),
            n = t[0],
            r = t[1];
          return 1 === n && 1 === r;
        }
        function la(e, t) {
          return sa(e) || sa(t);
        }
        var ua = nt({
            matMul_: function matMul_(e, t, n, r) {
              void 0 === n && (n = !1), void 0 === r && (r = !1);
              var i = et(e, "a", "matMul"),
                o = et(t, "b", "matMul"),
                a = n ? i.shape[i.rank - 2] : i.shape[i.rank - 1],
                s = r ? o.shape[o.rank - 1] : o.shape[o.rank - 2],
                l = n ? i.shape[i.rank - 1] : i.shape[i.rank - 2],
                u = r ? o.shape[o.rank - 2] : o.shape[o.rank - 1],
                c = i.shape.slice(0, -2),
                d = o.shape.slice(0, -2),
                h = S(c),
                f = S(d);
              b(i.rank >= 2 && o.rank >= 2 && i.rank === o.rank, "Error in matMul: inputs must have the same rank of at least 2, got ranks " + i.rank + " and " + o.rank + "."), b(A(c, d), "Error in matMul: outer dimensions (" + c + ") and (" + d + ") of Tensors with shapes " + i.shape + " and " + o.shape + " must match."), b(a === s, "Error in matMul: inner shapes (" + a + ") and (" + s + ") of Tensors with shapes " + i.shape + " and " + o.shape + " and transposeA=" + n + " and transposeB=" + r + " must match.");
              var p = i.shape.slice(0, -2).concat([l, u]),
                m = n ? i.as3D(h, a, l) : i.as3D(h, l, a),
                g = r ? o.as3D(f, u, s) : o.as3D(f, s, u);
              return ve.engine.runKernel(function (e) {
                return e.batchMatMul(m, g, n, r);
              }, {
                $a: m,
                $b: g
              }, function (e) {
                return n || r ? !n && r ? {
                  $a: function $a() {
                    return e.matMul(g.toFloat(), !1, !1);
                  },
                  $b: function $b() {
                    return e.matMul(m.toFloat(), !0, !1);
                  }
                } : n && !r ? {
                  $a: function $a() {
                    return g.toFloat().matMul(e, !1, !0);
                  },
                  $b: function $b() {
                    return m.toFloat().matMul(e, !1, !1);
                  }
                } : {
                  $a: function $a() {
                    return g.toFloat().matMul(e, !0, !0);
                  },
                  $b: function $b() {
                    return e.matMul(m.toFloat(), !0, !0);
                  }
                } : {
                  $a: function $a() {
                    return e.matMul(g.toFloat(), !1, !0);
                  },
                  $b: function $b() {
                    return m.toFloat().matMul(e, !0, !1);
                  }
                };
              }).reshape(p);
            }
          }),
          ca = nt({
            dot_: function dot_(e, t) {
              var n = et(e, "t1", "dot"),
                r = et(t, "t2", "dot");
              b(!(1 !== n.rank && 2 !== n.rank || 1 !== r.rank && 2 !== r.rank), "Error in dot: inputs must all be rank 1 or 2, but got ranks " + n.rank + " and " + r.rank + ".");
              var i = 1 === n.rank ? n.size : n.shape[1],
                o = 1 === r.rank ? r.size : r.shape[0];
              return b(i === o, "Error in dot: inner dimensions of inputs must match, but got " + i + " and " + o + "."), 1 === n.rank && 1 === r.rank ? n.as2D(1, -1).matMul(r.as2D(-1, 1)).asScalar() : 1 === n.rank && 2 === r.rank ? n.as2D(1, -1).matMul(r.as2D(r.shape[0], r.shape[1])).as1D() : 2 === n.rank && 1 === r.rank ? n.matMul(r.as2D(-1, 1)).as1D() : n.matMul(r.as2D(r.shape[0], r.shape[1]));
            }
          }),
          da = nt({
            outerProduct_: function outerProduct_(e, t) {
              var n = et(e, "v1", "outerProduct"),
                r = et(t, "v2", "outerProduct");
              return b(1 === n.rank && 1 === r.rank, "Error in outerProduct: inputs must be rank 1, but got ranks " + n.rank + " and " + r.rank + "."), n.as2D(-1, 1).matMul(r.as2D(1, -1));
            }
          });
        function ha(e, t, n, r, i, o) {
          b(e.length === t.rank, "Length of inShape (" + e.length + ") and rank of dy (" + t.rank + ") must match");
          var a = e,
            s = t,
            l = !1;
          3 === t.rank && (l = !0, s = t.as4D(1, t.shape[0], t.shape[1], t.shape[2]), a = [1, e[0], e[1], e[2]]);
          var u = a[3],
            c = s.shape[3];
          b(4 === a.length, "Error in conv2dDerInput: inShape must be length 4, but got length " + a.length + "."), b(4 === s.rank, "Error in conv2dDerInput: dy must be rank 4, but got rank " + s.rank), b(4 === n.rank, "Error in conv2dDerInput: filter must be rank 4, but got rank " + n.rank), b(u === n.shape[2], "Error in conv2dDerInput: depth of input (" + u + ") must match input depth for filter " + n.shape[2] + "."), b(c === n.shape[3], "Error in conv2dDerInput: depth of output (" + c + ") must match output depth for filter " + n.shape[3] + "."), null != o && b(E(i), "Error in conv2dDerInput: pad must be an integer when using, dimRoundingMode " + o + " but got pad " + i + ".");
          var d = ra(a, n.shape, r, 1, i, o),
            h = ve.engine.runKernel(function (e) {
              return e.conv2dDerInput(s, n, d);
            }, {
              dy4D: s,
              filter: n
            }, function (e) {
              return {
                dy4D: function dy4D() {
                  return ma(e, n, r, i, "NHWC", 1, o);
                },
                filter: function filter() {
                  return ga(e, s, n.shape, r, i, o);
                }
              };
            });
          return l ? h.as3D(h.shape[1], h.shape[2], h.shape[3]) : h;
        }
        function fa(e, t, n, r, i, o) {
          var a = e;
          3 === e.rank && (a = e.as4D(1, e.shape[0], e.shape[1], e.shape[2]));
          var s = t;
          3 === s.rank && (s = t.as4D(1, t.shape[0], t.shape[1], t.shape[2])), b(4 === a.rank, "Error in conv2dDerFilter: input must be rank 4, but got shape " + a.shape + "."), b(4 === s.rank, "Error in conv2dDerFilter: dy must be rank 4, but got shape " + s.shape + "."), b(4 === n.length, "Error in conv2dDerFilter: filterShape must be length 4, but got " + n + "."), b(a.shape[3] === n[2], "Error in conv2dDerFilter: depth of input " + a.shape[3] + ") must match input depth in filter (" + n[2] + "."), b(s.shape[3] === n[3], "Error in conv2dDerFilter: depth of dy (" + s.shape[3] + ") must match output depth for filter (" + n[3] + ")."), null != o && b(E(i), "Error in conv2dDerFilter: pad must be an integer when using, dimRoundingMode " + o + " but got pad " + i + ".");
          var l = ra(a.shape, n, r, 1, i, o);
          return ve.engine.runKernel(function (e) {
            return e.conv2dDerFilter(a, s, l);
          }, {
            x4D: a,
            dy4D: s
          });
        }
        var pa = nt({
            conv1d_: function conv1d_(e, t, n, r, i, o, a) {
              void 0 === i && (i = "NWC"), void 0 === o && (o = 1);
              var s = et(e, "x", "conv1d"),
                l = et(t, "filter", "conv1d"),
                u = s,
                c = !1;
              2 === s.rank && (c = !0, u = s.as3D(1, s.shape[0], s.shape[1])), b(3 === u.rank, "Error in conv1d: input must be rank 3, but got rank " + u.rank + "."), b(3 === l.rank, "Error in conv1d: filter must be rank 3, but got rank " + l.rank + "."), null != a && b(E(r), "Error in conv1d: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + r + "."), b(u.shape[2] === l.shape[1], "Error in conv1d: depth of input (" + u.shape[2] + ") must match input depth for filter " + l.shape[1] + "."), b(la(n, o), "Error in conv1D: Either stride or dilation must be 1. Got stride " + n + " and dilation '" + o + "'"), b("NWC" === i, "Error in conv1d: got dataFormat of " + i + " but only NWC is currently supported.");
              var d = l.as4D(1, l.shape[0], l.shape[1], l.shape[2]),
                h = u.as4D(u.shape[0], 1, u.shape[1], u.shape[2]),
                f = ma(h, d, [1, n], r, "NHWC", [1, o], a);
              return c ? f.as2D(f.shape[2], f.shape[3]) : f.as3D(f.shape[0], f.shape[2], f.shape[3]);
            }
          }),
          ma = nt({
            conv2d_: function conv2d_(e, t, n, r, i, o, a) {
              void 0 === i && (i = "NHWC"), void 0 === o && (o = [1, 1]);
              var s = et(e, "x", "conv2d"),
                l = et(t, "filter", "conv2d"),
                u = s,
                c = !1;
              3 === s.rank && (c = !0, u = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), b(4 === u.rank, "Error in conv2d: input must be rank 4, but got rank " + u.rank + "."), b(4 === l.rank, "Error in conv2d: filter must be rank 4, but got rank " + l.rank + "."), null != a && b(E(r), "Error in conv2d: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + r + "."), b(u.shape[3] === l.shape[2], "Error in conv2d: depth of input (" + u.shape[3] + ") must match input depth for filter " + l.shape[2] + "."), b(la(n, o), "Error in conv2D: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + o + "'"), b("NHWC" === i, "Error in conv2d: got dataFormat of " + i + " but only NHWC is currently supported.");
              var d,
                h = ra(u.shape, l.shape, n, o, r, a);
              if (1 !== h.filterHeight || 1 !== h.filterWidth || 1 !== h.dilationHeight || 1 !== h.dilationWidth || 1 !== h.strideHeight || 1 !== h.strideWidth || "SAME" !== h.padInfo.type && "VALID" !== h.padInfo.type) d = ve.engine.runKernel(function (e) {
                return e.conv2d(u, l, h);
              }, {
                x: u,
                $filter: l
              }, function (e) {
                return b(sa(o), "Error in gradient of conv2D: dilation rates greater than 1 are notyet supported in gradients. Got dilations '" + o + "'"), {
                  x: function x() {
                    return ha(u.shape, e, l, n, r);
                  },
                  $filter: function $filter() {
                    return fa(u, e, l.shape, n, r);
                  }
                };
              });else {
                var f = u.reshape([-1, h.inChannels]),
                  p = l.reshape([h.inChannels, h.outChannels]);
                d = ua(f, p).reshape(h.outShape);
              }
              return c ? d.as3D(d.shape[1], d.shape[2], d.shape[3]) : d;
            }
          }),
          ga = nt({
            conv2dDerFilter_: fa
          }),
          va = nt({
            depthwiseConv2d_: function depthwiseConv2d_(e, t, n, r, i, o, a) {
              void 0 === i && (i = "NHWC"), void 0 === o && (o = [1, 1]);
              var s = et(e, "x", "depthwiseConv2d"),
                l = et(t, "filter", "depthwiseConv2d"),
                u = s,
                c = !1;
              3 === s.rank && (c = !0, u = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), b(4 === u.rank, "Error in depthwiseConv2d: input must be rank 4, but got rank " + u.rank + "."), b(4 === l.rank, "Error in depthwiseConv2d: filter must be rank 4, but got rank " + l.rank + "."), b(u.shape[3] === l.shape[2], "Error in depthwiseConv2d: number of input channels (" + u.shape[3] + ") must match the inChannels dimension in filter " + l.shape[2] + "."), null == o && (o = [1, 1]), b(la(n, o), "Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + o + "'"), null != a && b(E(r), "Error in depthwiseConv2d: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + r + ".");
              var d = ra(u.shape, l.shape, n, o, r, a, !0),
                h = ve.engine.runKernel(function (e) {
                  return e.depthwiseConv2D(u, l, d);
                }, {
                  x: u,
                  $filter: l
                }, function (e) {
                  return b(sa(o), "Error in gradient of depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '" + o + "'"), {
                    x: function x() {
                      return function (e, t, n, r) {
                        var i = t,
                          o = !1;
                        3 === t.rank && (o = !0, i = t.as4D(1, t.shape[0], t.shape[1], t.shape[2]));
                        var a = ve.engine.runKernel(function (e) {
                          return e.depthwiseConv2DDerInput(i, n, r);
                        }, {
                          dy4D: i
                        });
                        return o ? a.as3D(a.shape[1], a.shape[2], a.shape[3]) : a;
                      }(u.shape, e, l, d);
                    },
                    $filter: function $filter() {
                      return function (e, t, n, r) {
                        var i = e;
                        3 === e.rank && (i = e.as4D(1, e.shape[0], e.shape[1], e.shape[2]));
                        var o = t;
                        return 3 === o.rank && (o = t.as4D(1, t.shape[0], t.shape[1], t.shape[2])), ve.engine.runKernel(function (e) {
                          return e.depthwiseConv2DDerFilter(i, o, r);
                        }, {
                          x4D: i,
                          dy4D: o
                        });
                      }(u, e, l.shape, d);
                    }
                  };
                });
              return c ? h.as3D(h.shape[1], h.shape[2], h.shape[3]) : h;
            }
          }),
          ya = nt({
            separableConv2d_: function separableConv2d_(e, t, n, r, i, o, a) {
              void 0 === o && (o = [1, 1]), void 0 === a && (a = "NHWC");
              var s = et(e, "x", "separableConv2d"),
                l = et(t, "depthwiseFilter", "separableConv2d"),
                u = et(n, "pointwiseFilter", "separableConv2d"),
                c = s,
                d = !1;
              if (3 === s.rank && (d = !0, c = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), "NCHW" === a) throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
              b(4 === c.rank, "Error in separableConv2d: input must be rank 4, but got rank " + c.rank + "."), b(4 === l.rank, "Error in separableConv2d: depthwise filter must be rank 4, but got rank " + l.rank + "."), b(4 === u.rank, "Error in separableConv2d: pointwise filter must be rank 4, but got rank " + l.rank + "."), b(1 === u.shape[0], "Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got " + u.shape[0] + "."), b(1 === u.shape[1], "Error in separableConv2d: the second dimension of pointwise filter  must be 1, but got " + u.shape[1] + ".");
              var h = l.shape[2],
                f = l.shape[3];
              b(u.shape[2] === h * f, "Error in separableConv2d: the third dimension of pointwise filter must be " + h * f + ", but got " + u.shape[2] + ".");
              var p = va(c, l, r, i, a, o),
                m = ma(p, u, 1, "valid", a);
              return d ? m.as3D(m.shape[1], m.shape[2], m.shape[3]) : m;
            }
          }),
          ba = nt({
            conv2dTranspose_: function conv2dTranspose_(e, t, n, r, i, o) {
              return ha(n, et(e, "x", "conv2dTranspose"), et(t, "filter", "conv2dTranspose"), r, i, o);
            }
          });
        var _a = nt({
            reverse_: function reverse_(e, t) {
              var n = et(e, "x", "reverse");
              if (0 === n.rank) return n.clone();
              var r = ze(t, n.shape);
              return ve.engine.runKernel(function (e) {
                return e.reverse(n, r);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    return e.reverse(r);
                  }
                };
              }).reshapeAs(n);
            }
          }),
          xa = nt({
            reverse1d_: function reverse1d_(e) {
              var t = et(e, "x", "reverse");
              return b(1 === t.rank, "Error in reverse1D: x must be rank 1 but got\n             rank " + t.rank + "."), _a(t, 0);
            }
          }),
          wa = nt({
            reverse2d_: function reverse2d_(e, t) {
              var n = et(e, "x", "reverse");
              return b(2 === n.rank, "Error in reverse2D: x must be rank 2 but got\n             rank " + n.rank + "."), _a(n, t);
            }
          }),
          Sa = nt({
            reverse3d_: function reverse3d_(e, t) {
              var n = et(e, "x", "reverse");
              return b(3 === n.rank, "Error in reverse3D: x must be rank 3 but got\n             rank " + n.rank + "."), _a(n, t);
            }
          }),
          Aa = nt({
            reverse4d_: function reverse4d_(e, t) {
              var n = et(e, "x", "reverse");
              return b(4 === n.rank, "Error in reverse4D: x must be rank 4 but got\n             rank " + n.rank + "."), _a(n, t);
            }
          });
        function Ea(e, t, n, r, i, o) {
          var a = et(e, "x", "maxPool"),
            s = a,
            l = !1;
          3 === a.rank && (l = !0, s = a.as4D(1, a.shape[0], a.shape[1], a.shape[2])), null == r && (r = [1, 1]), b(4 === s.rank, "Error in maxPool: input must be rank 4 but got rank " + s.rank + "."), b(la(n, r), "Error in maxPool: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + r + "'"), null != o && b(E(i), "Error in maxPool: pad must be an integer when using, dimRoundingMode " + o + " but got pad " + i + ".");
          var u = na(s.shape, t, n, r, i, o),
            c = ve.engine.runKernel(function (e, t) {
              return t(e.maxPool(s, u));
            }, {
              x: s
            }, function (e, o) {
              var a = o[0];
              return {
                x: function x() {
                  return function (e, t, n, r, i, o, a, s) {
                    var l = et(e, "dy", "maxPoolBackprop"),
                      u = et(t, "input", "maxPoolBackprop"),
                      c = et(n, "output", "maxPoolBackprop");
                    b(u.rank === l.rank, "Rank of input (" + u.rank + ") does not match rank of dy (" + l.rank + ")"), null == o && (o = [1, 1]), b(la(i, o), "Error in maxPoolBackProp: Either strides or dilations must be 1. Got strides " + i + " and dilations '" + o + "'"), b(4 === l.rank, "Error in maxPoolBackprop: dy must be rank 4 but got rank " + l.rank + "."), b(4 === u.rank, "Error in maxPoolBackprop: input must be rank 4 but got rank " + u.rank + "."), null != s && b(E(a), "Error in maxPoolBackprop: pad must be an integer when using, dimRoundingMode " + s + " but got pad " + a + ".");
                    var d = na(u.shape, r, i, o, a, s);
                    return ve.engine.runKernel(function (e) {
                      return e.maxPoolBackprop(l, u, c, d);
                    }, {
                      $dy: l,
                      $input: u
                    });
                  }(e, s, a, t, n, r, i);
                }
              };
            });
          return l ? c.as3D(c.shape[1], c.shape[2], c.shape[3]) : c;
        }
        function Ta(e, t, n, r, i, o) {
          var a = et(e, "x", "avgPool");
          b("float32" === a.dtype, "The input dtype to avgPool must be float32"), null == r && (r = [1, 1]), b(la(n, r), "Error in avgPool: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + r + "'");
          var s = a,
            l = !1;
          3 === a.rank && (l = !0, s = a.as4D(1, a.shape[0], a.shape[1], a.shape[2])), b(4 === s.rank, "Error in avgPool: x must be rank 4 but got rank " + s.rank + "."), null != o && b(E(i), "Error in avgPool: pad must be an integer when using, dimRoundingMode " + o + " but got pad " + i + ".");
          var u = na(s.shape, t, n, r, i),
            c = ve.engine.runKernel(function (e) {
              return e.avgPool(s, u);
            }, {
              x: s
            }, function (e) {
              return {
                x: function x() {
                  return function (e, t, n, r, i, o) {
                    var a = et(e, "dy", "avgPoolBackprop"),
                      s = et(t, "input", "avgPoolBackprop");
                    b(s.rank === a.rank, "Rank of input (" + s.rank + ") does not match rank of dy (" + a.rank + ")"), null == i && (i = [1, 1]), b(la(r, i), "Error in avgPoolBackprop: Either strides or dilations must be 1. Got strides " + r + " and dilations '" + i + "'");
                    var l = s,
                      u = a,
                      c = !1;
                    3 === s.rank && (c = !0, l = s.as4D(1, s.shape[0], s.shape[1], s.shape[2]), u = a.as4D(1, a.shape[0], a.shape[1], a.shape[2])), b(4 === u.rank, "Error in avgPoolBackprop: dy must be rank 4 but got rank " + u.rank + "."), b(4 === l.rank, "Error in avgPoolBackprop: input must be rank 4 but got rank " + l.rank + ".");
                    var d = na(l.shape, n, r, i, o),
                      h = ve.engine.runKernel(function (e) {
                        return e.avgPoolBackprop(u, l, d);
                      }, {
                        dy4D: u,
                        input4D: l
                      });
                    return c ? h.as3D(h.shape[1], h.shape[2], h.shape[3]) : h;
                  }(e, s, t, n, r, i);
                }
              };
            });
          return c = c.cast(a.dtype), l ? c.as3D(c.shape[1], c.shape[2], c.shape[3]) : c;
        }
        var Ma = nt({
            maxPool_: function maxPool_(e, t, n, r, i) {
              return Ea(e, t, n, 1, r, i);
            }
          }),
          Ca = nt({
            avgPool_: function avgPool_(e, t, n, r, i) {
              return Ta(e, t, n, 1, r, i);
            }
          }),
          ka = nt({
            pool_: function pool_(e, t, n, r, i, o) {
              null == i && (i = [1, 1]), null == o && (o = 1), 0 === r && (r = "valid");
              var a = et(e, "x", "maxPool"),
                s = a,
                l = !1;
              3 === a.rank && (l = !0, s = a.as4D(1, a.shape[0], a.shape[1], a.shape[2])), b(la(o, i), "Error in pool: Either strides or dilations must be 1. Got strides " + o + " and dilations '" + i + "'");
              var u,
                c = na(s.shape, t, o, i, r),
                d = [c.dilationHeight, c.dilationWidth];
              u = "same" === r ? function (e, t) {
                var n = e.map(function (e, n) {
                    return e + (e - 1) * (t[n] - 1);
                  }).map(function (e) {
                    return e - 1;
                  }),
                  r = n.map(function (e) {
                    return Math.floor(e / 2);
                  }),
                  i = n.map(function (e, t) {
                    return e - r[t];
                  });
                return n.map(function (e, t) {
                  return [r[t], i[t]];
                });
              }([c.filterHeight, c.filterWidth], d) : [[0, 0], [0, 0]];
              var h = 1 === d[0] && 1 === d[1],
                f = function (e, t, n) {
                  var r = n.map(function (e) {
                      return e[0];
                    }),
                    i = n.map(function (e) {
                      return e[1];
                    }),
                    o = e.concat(r, i),
                    a = t.map(function (e, t) {
                      return (e - o[t] % e) % e;
                    }),
                    s = i.map(function (e, t) {
                      return e + a[t];
                    });
                  return [t.map(function (e, t) {
                    return [r[t], s[t]];
                  }), t.map(function (e, t) {
                    return [0, a[t]];
                  })];
                }([c.inHeight, c.inWidth], d, u),
                p = f[0],
                m = f[1],
                g = h ? r : "valid",
                v = h ? s : lo(s, d, p),
                y = ("avg" === n ? function () {
                  return Ta(v, t, o, 1, g);
                } : function () {
                  return Ea(v, t, o, 1, g);
                })(),
                _ = h ? y : Vi(y, d, m);
              return l ? _.as3D(_.shape[1], _.shape[2], _.shape[3]) : _;
            }
          });
        var Pa = nt({
            slice_: function slice_(e, t, n) {
              var r,
                i,
                o = et(e, "x", "slice");
              if (0 === o.rank) throw new Error("Slicing scalar is not possible");
              r = "number" == typeof t ? [t].concat(new Array(o.rank - 1).fill(0)) : t.length < o.rank ? t.concat(new Array(o.rank - t.length).fill(0)) : t.slice(), i = (i = null == n ? new Array(o.rank).fill(-1) : "number" == typeof n ? [n].concat(new Array(o.rank - 1).fill(-1)) : n.length < o.rank ? n.concat(new Array(o.rank - n.length).fill(-1)) : n).map(function (e, t) {
                return e >= 0 ? e : (b(-1 === e, "Bad value in size"), o.shape[t] - r[t]);
              }), function (e, t, n) {
                b(e.rank === t.length, "Error in slice" + e.rank + "D: Length of begin " + t + " must match the rank of the array (" + e.rank + ")."), b(e.rank === n.length, "Error in slice" + e.rank + "D: Length of size " + n + " must match the rank of the array (" + e.rank + ").");
                for (var r = 0; r < e.rank; ++r) b(t[r] + n[r] <= e.shape[r], "Error in slice" + e.rank + "D: begin[" + r + "] + size[" + r + "] (" + (t[r] + n[r]) + ") would overflow input.shape[" + r + "] (" + e.shape[r] + ")");
              }(o, r, i);
              var a = o.shape;
              return ve.engine.runKernel(function (e) {
                return e.slice(o, r, i);
              }, {
                $x: o
              }, function (e) {
                for (var t = [], n = 0; n < e.rank; n++) t.push([r[n], a[n] - r[n] - i[n]]);
                return {
                  $x: function $x() {
                    return e.pad(t);
                  }
                };
              });
            }
          }),
          Oa = nt({
            slice1d_: function slice1d_(e, t, n) {
              var r = et(e, "x", "slice1d");
              return b(1 === r.rank, "slice1d expects a rank-1 tensor, but got a rank-" + r.rank + " tensor"), Pa(r, [t], [n]);
            }
          }),
          Ra = nt({
            slice2d_: function slice2d_(e, t, n) {
              var r = et(e, "x", "slice2d");
              return b(2 === r.rank, "slice2d expects a rank-2 tensor, but got a rank-" + r.rank + " tensor"), Pa(r, t, n);
            }
          }),
          Ia = nt({
            slice3d_: function slice3d_(e, t, n) {
              var r = et(e, "x", "slice3d");
              return b(3 === r.rank, "slice3d expects a rank-3 tensor, but got a rank-" + r.rank + " tensor"), Pa(r, t, n);
            }
          }),
          ja = nt({
            slice4d_: function slice4d_(e, t, n) {
              var r = et(e, "x", "slice4d");
              return b(4 === r.rank, "slice4d expects a rank-4 tensor, but got a rank-" + r.rank + " tensor"), Pa(r, t, n);
            }
          });
        function Na(e, t, n, r, i) {
          var o = t[0];
          return o.rank < n.rank && (o = o.reshape(Fe(o.shape, r))), e.rank < n.rank && (e = e.reshape(Fe(e.shape, r))), {
            $x: function $x() {
              var t = e.mul(n.equal(o).cast(e.dtype));
              return null == i ? t : t.transpose(i);
            }
          };
        }
        var La = nt({
            all_: function all_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "all", "bool");
              b("bool" === r.dtype, "Error Tensor must be of type bool. Got: " + r.dtype);
              var i = ze(t, r.shape),
                o = i,
                a = Ge(o, r.rank);
              null != a && (r = r.transpose(a), o = He(o.length, r.rank));
              var s = ve.engine.runKernel(function (e) {
                return e.all(r, o);
              }, {
                $x: r
              });
              if (n) {
                var l = Fe(s.shape, i);
                return s.reshape(l);
              }
              return s;
            }
          }),
          Da = nt({
            any_: function any_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "any", "bool");
              b("bool" === r.dtype, "Error Tensor must be of type bool. Got: " + r.dtype);
              var i = ze(t, r.shape),
                o = i,
                a = Ge(o, r.rank);
              null != a && (r = r.transpose(a), o = He(o.length, r.rank));
              var s = ve.engine.runKernel(function (e) {
                return e.any(r, o);
              }, {
                $x: r
              });
              if (n) {
                var l = Fe(s.shape, i);
                return s.reshape(l);
              }
              return s;
            }
          }),
          Ba = nt({
            argMax_: function argMax_(e, t) {
              void 0 === t && (t = 0);
              var n = et(e, "x", "argMax");
              null == t && (t = 0);
              var r = ze(t, n.shape),
                i = Ge(r, n.rank);
              return null != i && (n = n.transpose(i), r = He(r.length, n.rank)), ve.engine.runKernel(function (e) {
                return e.argMax(n, r[0]);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(n);
                  }
                };
              });
            }
          }),
          Fa = nt({
            argMin_: function argMin_(e, t) {
              void 0 === t && (t = 0);
              var n = et(e, "x", "argMin");
              null == t && (t = 0);
              var r = ze(t, n.shape),
                i = Ge(r, n.rank);
              return null != i && (n = n.transpose(i), r = He(r.length, n.rank)), ve.engine.runKernel(function (e) {
                return e.argMin(n, r[0]);
              }, {
                $x: n
              }, function (e) {
                return {
                  $x: function $x() {
                    return Ct(n);
                  }
                };
              });
            }
          }),
          za = nt({
            logSumExp_: function logSumExp_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "logSumExp"),
                i = ze(t, r.shape),
                o = r.max(i, !0),
                a = r.sub(o).exp().sum(i).log(),
                s = o.reshape(a.shape).add(a);
              if (n) {
                var l = Fe(s.shape, i);
                return s.reshape(l);
              }
              return s;
            }
          }),
          Ua = nt({
            max_: function max_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "max"),
                i = r,
                o = ze(t, r.shape),
                a = o,
                s = Ge(a, r.rank);
              null != s && (r = r.transpose(s), a = He(a.length, r.rank));
              var l = ve.engine.runKernel(function (e, t) {
                return t(e.max(r, a));
              }, {
                $x: r
              }, function (e, t) {
                return Na(e, t, i, o, s);
              });
              if (n) {
                var u = Fe(l.shape, o);
                l = l.reshape(u);
              }
              return l;
            }
          }),
          Ga = nt({
            mean_: function mean_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "mean"),
                i = ze(t, r.shape),
                o = S(Be(r.shape, i)[1]);
              return Ae(function (e) {
                var r = ut(o);
                return {
                  value: (r.dtype === e.dtype ? e : e.cast(r.dtype)).div(r).sum(t, n),
                  gradFunc: function gradFunc(t) {
                    var n = e.shape.slice();
                    return i.forEach(function (e) {
                      n[e] = 1;
                    }), t.reshape(n).mul(gt(e.shape, "float32")).div(r);
                  }
                };
              })(r);
            }
          }),
          Va = nt({
            min_: function min_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "min"),
                i = r,
                o = ze(t, r.shape),
                a = o,
                s = Ge(a, r.rank);
              null != s && (r = r.transpose(s), a = He(a.length, r.rank));
              var l = ve.engine.runKernel(function (e, t) {
                return t(e.min(r, a));
              }, {
                $x: r
              }, function (e, t) {
                return Na(e, t, i, o, s);
              });
              if (n) {
                var u = Fe(l.shape, o);
                l = l.reshape(u);
              }
              return l;
            }
          }),
          Ha = nt({
            moments_: function moments_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = ze(t, (e = et(e, "x", "moments")).shape),
                i = e.mean(r, n),
                o = i.shape;
              return n || (o = Fe(i.shape, r)), {
                mean: i,
                variance: e.toFloat().sub(i.reshape(o)).square().mean(r, n)
              };
            }
          }),
          qa = nt({
            sum_: function sum_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "sum");
              "bool" === r.dtype && (r = r.toInt());
              var i = ze(t, r.shape);
              return Ae(function (e) {
                var t = Ge(i, e.rank),
                  r = i,
                  o = e;
                null != t && (o = e.transpose(t), r = He(r.length, e.rank));
                var a = ve.engine.runKernel(function (e) {
                  return e.sum(o, r);
                }, {
                  permutedX: o
                });
                if (n) {
                  var s = Fe(a.shape, i);
                  a = a.reshape(s);
                }
                return {
                  value: a,
                  gradFunc: function gradFunc(t) {
                    var n = e.shape.slice();
                    return i.forEach(function (e) {
                      n[e] = 1;
                    }), t.reshape(n).mul(gt(e.shape, "float32"));
                  }
                };
              })(r);
            }
          }),
          Wa = nt({
            prod_: function prod_(e, t, n) {
              void 0 === t && (t = null), void 0 === n && (n = !1);
              var r = et(e, "x", "prod");
              "bool" === r.dtype && (r = r.toInt());
              var i = ze(t, r.shape),
                o = Ge(i, r.rank),
                a = i,
                s = r;
              null != o && (s = r.transpose(o), a = He(a.length, r.rank));
              var l = ve.engine.runKernel(function (e) {
                return e.prod(s, a);
              }, {
                permutedX: s
              });
              if (n) {
                var u = Fe(l.shape, i);
                l = l.reshape(u);
              }
              return l;
            }
          });
        var $a = nt({
            equal_: function equal_(e, t) {
              var n = et(e, "a", "equal"),
                r = et(t, "b", "equal");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.equal(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          Xa = nt({
            equalStrict_: function equalStrict_(e, t) {
              var n = et(e, "a", "equalStrict"),
                r = et(t, "b", "equalStrict");
              return _(n.shape, r.shape, "Error in equalStrict: "), n.equal(r);
            }
          }),
          Ya = nt({
            greater_: function greater_(e, t) {
              var n = et(e, "a", "greater"),
                r = et(t, "b", "greater");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.greater(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          Ka = nt({
            greaterEqual_: function greaterEqual_(e, t) {
              var n = et(e, "a", "greaterEqual"),
                r = et(t, "b", "greaterEqual");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.greaterEqual(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    return Ct(n);
                  },
                  $b: function $b() {
                    return Ct(r);
                  }
                };
              });
            }
          }),
          Za = nt({
            greaterEqualStrict_: function greaterEqualStrict_(e, t) {
              var n = et(e, "a", "greaterEqualStrict"),
                r = et(t, "b", "greaterEqualStrict");
              return _(n.shape, r.shape, "Error in greaterEqualStrict: "), n.greaterEqual(r);
            }
          }),
          Qa = nt({
            greaterStrict_: function greaterStrict_(e, t) {
              var n = et(e, "a", "greaterStrict"),
                r = et(t, "b", "greaterStrict");
              return _(n.shape, r.shape, "Error in greaterStrict: "), n.greater(r);
            }
          }),
          Ja = nt({
            less_: function less_(e, t) {
              var n = et(e, "a", "less"),
                r = et(t, "b", "less");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.less(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          es = nt({
            lessEqual_: function lessEqual_(e, t) {
              var n = et(e, "a", "lessEqual"),
                r = et(t, "b", "lessEqual");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.lessEqual(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          ts = nt({
            lessEqualStrict_: function lessEqualStrict_(e, t) {
              var n = et(e, "a", "lessEqualStrict"),
                r = et(t, "b", "lessEqualStrict");
              return _(n.shape, r.shape, "Error in lessEqualStrict: "), n.lessEqual(r);
            }
          }),
          ns = nt({
            lessStrict_: function lessStrict_(e, t) {
              var n = et(e, "a", "lessStrict"),
                r = et(t, "b", "lessStrict");
              return _(n.shape, r.shape, "Error in lessStrict: "), n.less(r);
            }
          }),
          rs = nt({
            notEqual_: function notEqual_(e, t) {
              var n = et(e, "a", "notEqual"),
                r = et(t, "b", "notEqual");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.notEqual(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          is = nt({
            notEqualStrict_: function notEqualStrict_(e, t) {
              var n = et(e, "a", "notEqualStrict"),
                r = et(t, "b", "notEqualStrict");
              return _(n.shape, r.shape, "Error in notEqualStrict: "), n.notEqual(r);
            }
          });
        var os = nt({
            add_: function add_(e, t) {
              var n = et(e, "a", "add"),
                r = et(t, "b", "add");
              ie(n, r);
              var i = Xt(n.shape, r.shape);
              return ve.engine.runKernel(function (e) {
                return e.add(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = e,
                      r = $t(n.shape, i);
                    return r.length > 0 && (t = t.sum(r)), t.reshape(n.shape);
                  },
                  $b: function $b() {
                    var t = e,
                      n = $t(r.shape, i);
                    return n.length > 0 && (t = t.sum(n)), t.reshape(r.shape);
                  }
                };
              });
            }
          }),
          as = nt({
            addN_: function addN_(e) {
              b(Array.isArray(e), function () {
                return "The argument passed to tf.addN() must be a list of tensors";
              }), b(e.length >= 1, function () {
                return "Must pass at least one tensor to tf.addN(), but got " + e.length;
              });
              var t = e.map(function (e, t) {
                  return et(e, "tensors" + t, "addN");
                }),
                n = t[0];
              t.forEach(function (e) {
                if (e.dtype !== n.dtype) throw new Error("All tensors passed to tf.addN() must have the same dtype");
              }), t.forEach(function (e) {
                if (!A(e.shape, n.shape)) throw new Error("All tensors passed to tf.addN() must have the same shape");
              });
              var r = t;
              return ve.engine.runKernel(function (e) {
                return e.addN(t);
              }, r, function (e) {
                var n = {};
                return t.forEach(function (t, r) {
                  n[r] = function () {
                    return e.clone();
                  };
                }), n;
              });
            }
          }),
          ss = nt({
            addStrict_: function addStrict_(e, t) {
              return _(e.shape, t.shape, "Error in addStrict: "), e.add(t);
            }
          }),
          ls = nt({
            atan2_: function atan2_(e, t) {
              var n = et(e, "a", "atan2"),
                r = et(t, "b", "atan2");
              ie(n, r);
              var i = Xt(n.shape, r.shape);
              return ve.engine.runKernel(function (e) {
                return e.atan2(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = os(n.square(), r.square()),
                      o = e.mul(r.div(t)),
                      a = $t(n.shape, i);
                    return a.length > 0 && (o = o.sum(a)), o.reshape(n.shape);
                  },
                  $b: function $b() {
                    var t = os(n.square(), r.square()),
                      o = Do(e.mul(n.div(t))),
                      a = $t(r.shape, i);
                    return a.length > 0 && (o = o.sum(a)), o.reshape(r.shape);
                  }
                };
              });
            }
          }),
          us = nt({
            div_: function div_(e, t) {
              var n,
                r = et(e, "a", "div"),
                i = et(t, "b", "div");
              if (ie(r, i), "int32" === r.dtype && "int32" === i.dtype) return ds(r, i);
              n = function n(e) {
                return e.realDivide(r, i);
              };
              var o = Xt(r.shape, i.shape);
              return ve.engine.runKernel(n, {
                $a: r,
                $b: i
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = e.div(i.toFloat()),
                      n = $t(r.shape, o);
                    return n.length > 0 ? t.sum(n).reshape(r.shape) : t;
                  },
                  $b: function $b() {
                    var t = e.mul(r.toFloat()),
                      n = $t(i.shape, o);
                    n.length > 0 && (t = t.sum(n).reshape(i.shape));
                    var a = i.square();
                    return t.div(a.toFloat()).neg();
                  }
                };
              });
            }
          }),
          cs = nt({
            divStrict_: function divStrict_(e, t) {
              return _(e.shape, t.shape, "Error in divideStrict: "), e.div(t);
            }
          }),
          ds = nt({
            floorDiv_: function floorDiv_(e, t) {
              var n = et(e, "a", "floorDiv"),
                r = et(t, "b", "floorDiv");
              ie(n, r);
              var i = Xt(n.shape, r.shape);
              return ve.engine.runKernel(function (e) {
                return e.floorDiv(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = e.div(r.toFloat()),
                      o = $t(n.shape, i);
                    return o.length > 0 ? t.sum(o).reshape(n.shape) : t;
                  },
                  $b: function $b() {
                    var t = e.mul(n.toFloat()),
                      o = $t(r.shape, i);
                    o.length > 0 && (t = t.sum(o).reshape(r.shape));
                    var a = r.square();
                    return t.div(a.toFloat()).neg();
                  }
                };
              });
            }
          }),
          hs = nt({
            maximum_: function maximum_(e, t) {
              var n = et(e, "a", "maximum"),
                r = et(t, "b", "maximum");
              return ie(n, r), "bool" === n.dtype && (n = n.toInt()), "bool" === r.dtype && (r = r.toInt()), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.maximum(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    return e.mul(n.greaterEqual(r).toFloat());
                  },
                  $b: function $b() {
                    return e.mul(n.less(r).toFloat());
                  }
                };
              });
            }
          }),
          fs = nt({
            maximumStrict_: function maximumStrict_(e, t) {
              return _(e.shape, t.shape, "Error in maximumStrict: "), e.maximum(t);
            }
          }),
          ps = nt({
            minimum_: function minimum_(e, t) {
              var n = et(e, "a", "minimum"),
                r = et(t, "b", "minimum");
              return ie(n, r), "bool" === n.dtype && (n = n.toInt()), "bool" === r.dtype && (r = r.toInt()), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.minimum(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    return e.mul(n.lessEqual(r).toFloat());
                  },
                  $b: function $b() {
                    return e.mul(n.greater(r).toFloat());
                  }
                };
              });
            }
          }),
          ms = nt({
            minimumStrict_: function minimumStrict_(e, t) {
              return _(e.shape, t.shape, "Error in minimumStrict: "), e.minimum(t);
            }
          }),
          gs = nt({
            mod_: function mod_(e, t) {
              var n = et(e, "a", "mod"),
                r = et(t, "b", "mod");
              ie(n, r);
              var i = Xt(n.shape, r.shape);
              return ve.engine.runKernel(function (e) {
                return e.mod(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = $t(n.shape, i);
                    return t.length > 0 ? e.sum(t).reshape(n.shape) : e;
                  },
                  $b: function $b() {
                    var t = e.mul(n.div(r).floor().neg()),
                      o = $t(r.shape, i);
                    return o.length > 0 ? t.sum(o).reshape(r.shape) : t;
                  }
                };
              });
            }
          }),
          vs = nt({
            modStrict_: function modStrict_(e, t) {
              return _(e.shape, t.shape, "Error in modStrict: "), e.mod(t);
            }
          }),
          ys = nt({
            mul_: function mul_(e, t) {
              var n = et(e, "a", "mul"),
                r = et(t, "b", "mul");
              ie(n, r);
              var i = Xt(n.shape, r.shape);
              return ve.engine.runKernel(function (e) {
                return e.multiply(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = e.mul(r.toFloat()),
                      o = $t(n.shape, i);
                    return o.length > 0 ? t.sum(o).reshape(n.shape) : t;
                  },
                  $b: function $b() {
                    var t = e.mul(n.toFloat()),
                      o = $t(r.shape, i);
                    return o.length > 0 ? t.sum(o).reshape(r.shape) : t;
                  }
                };
              });
            }
          }),
          bs = nt({
            mulStrict_: function mulStrict_(e, t) {
              return _(e.shape, t.shape, "Error in multiplyStrict: "), e.mul(t);
            }
          }),
          _s = nt({
            pow_: function pow_(e, t) {
              var n = et(e, "base", "pow"),
                r = et(t, "exp", "pow"),
                i = Xt(n.shape, r.shape);
              return e = n.cast(Pt(n.dtype, r.dtype)), t = r.cast(Pt(n.dtype, r.dtype)), ve.engine.runKernel(function (e, t) {
                return t(e.pow(n, r));
              }, {
                $base: n,
                $exp: r
              }, function (e, t) {
                var o = t[0];
                return {
                  $base: function $base() {
                    var t = r.toFloat(),
                      o = e.mul(t.mul(n.pow(t.sub(ut(1))))),
                      a = $t(n.shape, i);
                    return a.length > 0 && (o = o.sum(a)), o.reshape(n.shape);
                  },
                  $exp: function $exp() {
                    var t = e.mul(o.mul(n.log()).toFloat()),
                      a = $t(r.shape, i);
                    return a.length > 0 && (t = t.sum(a)), t.reshape(r.shape);
                  }
                };
              });
            }
          }),
          xs = nt({
            powStrict_: function powStrict_(e, t) {
              return _(e.shape, t.shape, "Error in powStrict: "), e.pow(t);
            }
          }),
          ws = nt({
            squaredDifference_: function squaredDifference_(e, t) {
              var n = et(e, "a", "squaredDifference"),
                r = et(t, "b", "squaredDifference");
              return ie(n, r), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.squaredDifference(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                var t = ut(2);
                return {
                  $a: function $a() {
                    return e.mul(n.sub(r).mul(t));
                  },
                  $b: function $b() {
                    return e.mul(r.sub(n).mul(t));
                  }
                };
              });
            }
          }),
          Ss = nt({
            squaredDifferenceStrict_: function squaredDifferenceStrict_(e, t) {
              return _(e.shape, t.shape, "Error in squaredDifferenceStrict: "), e.squaredDifference(t);
            }
          }),
          As = nt({
            sub_: function sub_(e, t) {
              var n = et(e, "a", "sub"),
                r = et(t, "b", "sub");
              ie(n, r);
              var i = Xt(n.shape, r.shape);
              return ve.engine.runKernel(function (e) {
                return e.subtract(n, r);
              }, {
                $a: n,
                $b: r
              }, function (e) {
                return {
                  $a: function $a() {
                    var t = e,
                      r = $t(n.shape, i);
                    return r.length > 0 && (t = t.sum(r)), t.reshape(n.shape);
                  },
                  $b: function $b() {
                    var t = e,
                      n = $t(r.shape, i);
                    return n.length > 0 && (t = t.sum(n)), t.neg().reshape(r.shape);
                  }
                };
              });
            }
          }),
          Es = nt({
            subStrict_: function subStrict_(e, t) {
              return _(e.shape, t.shape, "Error in subStrict: "), e.sub(t);
            }
          });
        var Ts = nt({
            logicalAnd_: function logicalAnd_(e, t) {
              var n = et(e, "a", "logicalAnd", "bool"),
                r = et(t, "b", "logicalAnd", "bool");
              return b("bool" === n.dtype && "bool" === r.dtype, "Error Array must be of type bool."), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.logicalAnd(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          Ms = nt({
            logicalNot_: function logicalNot_(e) {
              var t = et(e, "x", "logicalNot", "bool");
              return b("bool" === t.dtype, "Error Array must be of type bool."), ve.engine.runKernel(function (e) {
                return e.logicalNot(t);
              }, {
                $x: t
              });
            }
          }),
          Cs = nt({
            logicalOr_: function logicalOr_(e, t) {
              var n = et(e, "a", "logicalOr", "bool"),
                r = et(t, "b", "logicalOr", "bool");
              return b("bool" === n.dtype && "bool" === r.dtype, "Error Array must be of type bool."), Xt(n.shape, r.shape), ve.engine.runKernel(function (e) {
                return e.logicalOr(n, r);
              }, {
                $a: n,
                $b: r
              });
            }
          }),
          ks = nt({
            logicalXor_: function logicalXor_(e, t) {
              var n = et(e, "a", "logicalXor", "bool"),
                r = et(t, "b", "logicalXor", "bool");
              return b("bool" === n.dtype && "bool" === r.dtype, "Error Array must be of type bool."), Xt(n.shape, r.shape), Cs(e, t).logicalAnd(Ts(e, t).logicalNot());
            }
          }),
          Ps = nt({
            where_: function where_(e, t, n) {
              var r = et(t, "a", "where"),
                i = et(n, "b", "where"),
                o = et(e, "condition", "where", "bool");
              return b("bool" === o.dtype, "Error Condition must be of type bool."), _(r.shape, i.shape, "Error in where: "), 1 === o.rank ? b(o.shape[0] === r.shape[0], "The first dimension of `a` must match the size of `condition`.") : _(o.shape, i.shape, "Error in where: "), ve.engine.runKernel(function (e) {
                return e.select(o, r, i);
              }, {
                $condition: o,
                $a: r,
                $b: i
              }, function (e) {
                return {
                  $condition: function $condition() {
                    return Ct(o);
                  },
                  $a: function $a() {
                    return e.mul(o.cast(r.dtype));
                  },
                  $b: function $b() {
                    return e.mul(o.logicalNot().cast(i.dtype));
                  }
                };
              });
            }
          }),
          Os = function Os(e) {
            return u(this, void 0, void 0, function () {
              var t, n, r;
              return c(this, function (i) {
                switch (i.label) {
                  case 0:
                    return b("bool" === (t = et(e, "condition", "where", "bool")).dtype, "Condition must be of type bool."), [4, t.data()];
                  case 1:
                    return n = i.sent(), r = go(t.shape, n), e !== t && t.dispose(), [2, r];
                }
              });
            });
          };
        var Rs = nt({
            elu_: function elu_(e) {
              var t = et(e, "x", "elu");
              return ve.engine.runKernel(function (e, n) {
                return n(e.elu(t));
              }, {
                $x: t
              }, function (e, t) {
                var n = t[0];
                return {
                  $x: function $x() {
                    return ve.engine.runKernel(function (t) {
                      return t.eluDer(e, n);
                    }, {
                      dy: e,
                      y: n
                    });
                  }
                };
              });
            }
          }),
          Is = nt({
            leakyRelu_: function leakyRelu_(e, t) {
              void 0 === t && (t = .2);
              var n = et(e, "x", "leakyRelu");
              return hs(ut(t).mul(n), n);
            }
          }),
          js = nt({
            prelu_: function prelu_(e, t) {
              var n = et(e, "x", "prelu"),
                r = et(t, "alpha", "prelu"),
                i = ut(0);
              return hs(i, n).add(r.mul(ps(i, n)));
            }
          }),
          Ns = nt({
            relu_: function relu_(e) {
              var t = et(e, "x", "relu");
              return "bool" === t.dtype ? t.toInt() : ve.engine.runKernel(function (e) {
                return e.relu(t);
              }, {
                $x: t
              }, function (e) {
                var n = t.step();
                return {
                  $x: function $x() {
                    return e.mulStrict(n.toFloat());
                  }
                };
              });
            }
          }),
          Ls = nt({
            selu_: function selu_(e) {
              var t = et(e, "x", "selu");
              return ve.engine.runKernel(function (e) {
                return e.selu(t);
              }, {
                $x: t
              }, function (e) {
                return {
                  $x: function $x() {
                    var n = t.greater(ut(0)),
                      r = ut(1.7580993408473768),
                      i = ut(1.0507009873554805),
                      o = e.mul(i),
                      a = e.mul(r).mul(t.toFloat().exp());
                    return Ps(n, o, a);
                  }
                };
              });
            }
          });
        var Ds = nt({
          transpose_: function transpose_(e, t) {
            var n = et(e, "x", "transpose");
            return null == t && (t = n.shape.map(function (e, t) {
              return t;
            }).reverse()), b(n.rank === t.length, "Error in transpose: rank of input " + n.rank + " must match length of perm " + t + "."), t.forEach(function (e) {
              b(e >= 0 && e < n.rank, "All entries in 'perm' must be between 0 and " + (n.rank - 1) + " but got " + t);
            }), n.rank <= 1 ? n.clone() : ve.engine.runKernel(function (e) {
              return e.transpose(n, t);
            }, {
              $x: n
            }, function (e) {
              var n = Ve(t);
              return {
                $x: function $x() {
                  return e.transpose(n);
                }
              };
            });
          }
        });
        var Bs = nt({
          localResponseNormalization_: function localResponseNormalization_(e, t, n, r, i) {
            void 0 === t && (t = 5), void 0 === n && (n = 1), void 0 === r && (r = 1), void 0 === i && (i = .5);
            var o = et(e, "x", "localResponseNormalization");
            b(4 === o.rank || 3 === o.rank, "Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank " + o.rank + "."), b(E(t), "Error in localResponseNormalization: depthRadius must be an integer\n                     but got depthRadius " + t + ".");
            var a = o,
              s = !1;
            3 === o.rank && (s = !0, a = o.as4D(1, o.shape[0], o.shape[1], o.shape[2]));
            var l = ve.engine.runKernel(function (e, o) {
              return o(e.localResponseNormalization4D(a, t, n, r, i));
            }, {
              x4D: a
            }, function (e, o) {
              var s = o[0];
              return {
                x4D: function x4D() {
                  return ve.engine.runKernel(function (o) {
                    return o.LRNGrad(e, a, s, t, n, r, i);
                  }, {});
                }
              };
            });
            return s ? l.as3D(l.shape[1], l.shape[2], l.shape[3]) : l;
          }
        });
        var Fs = nt({
          norm_: function norm_(e, t, n, r) {
            void 0 === t && (t = "euclidean"), void 0 === n && (n = null), void 0 === r && (r = !1);
            var i = function e(t, n, r) {
                if (void 0 === r && (r = null), 0 === t.rank) return t.abs();
                if (1 !== t.rank && null === r) return e(t.reshape([-1]), n, r);
                if (1 === t.rank || "number" == typeof r || r instanceof Array && 1 === r.length) {
                  if (1 === n) return t.abs().sum(r);
                  if (n === 1 / 0) return t.abs().max(r);
                  if (n === -1 / 0) return t.abs().min(r);
                  if ("euclidean" === n || 2 === n) return t.abs().pow(ut(2, "int32")).sum(r).sqrt();
                  throw new Error("Error in norm: invalid ord value: " + n);
                }
                if (r instanceof Array && 2 === r.length) {
                  if (1 === n) return t.abs().sum(r[0]).max(r[1] - 1);
                  if (n === 1 / 0) return t.abs().sum(r[1]).max(r[0]);
                  if (n === -1 / 0) return t.abs().sum(r[1]).min(r[0]);
                  if ("fro" === n || "euclidean" === n) return t.square().sum(r).sqrt();
                  throw new Error("Error in norm: invalid ord value: " + n);
                }
                throw new Error("Error in norm: invalid axis: " + r);
              }(e = et(e, "x", "norm"), t, n),
              o = i.shape;
            if (r) {
              var a = ze(n, e.shape);
              o = Fe(i.shape, a);
            }
            return i.reshape(o);
          }
        });
        function zs(e, t) {
          for (var n = [], r = e; r < t; ++r) n.push(r);
          return n;
        }
        function Us(e) {
          for (var t = [], n = 0; n < e.length; ++n) for (var r = 0; r < e[n].length; ++r) t.push(e[n][r]);
          return t;
        }
        var Gs = nt({
            gather_: function gather_(e, t, n) {
              void 0 === n && (n = 0);
              var r = et(e, "x", "gather"),
                i = et(t, "indices", "gather", "int32");
              return b("int32" === i.dtype, "Indices must be of dtype `int32`"), n = ze(n, r.shape)[0], ve.engine.runKernel(function (e) {
                return e.gather(r, i, n);
              }, {
                $x: r
              }, function (e) {
                return {
                  $x: function $x() {
                    if (0 === n) return Vs(e, i, r.shape[n]);
                    var t = r.shape,
                      o = i.size,
                      a = t.slice(0, n),
                      s = a.length,
                      l = t.slice(n, t.length).slice(1),
                      u = l.length,
                      c = zs(0, s),
                      d = zs(s + 1, s + 1 + u),
                      h = Us([a, [o], l]),
                      f = e.reshape(h),
                      p = i.reshape([o]),
                      m = Us([[s], c, d]),
                      g = f.transpose(m),
                      v = Vs(g, p, r.shape[n]),
                      y = Ve(m);
                    return v.transpose(y);
                  }
                };
              });
            }
          }),
          Vs = nt({
            unsortedSegmentSum_: function unsortedSegmentSum_(e, t, n) {
              var r = et(e, "x", "unsortedSegmentSum"),
                i = et(t, "segmentIds", "unsortedSegmentSum", "int32");
              return b("int32" === i.dtype, "segmentIds must be of dtype `int32`"), b(E(n), "numSegments must be of dtype int"), ve.engine.runKernel(function (e) {
                return e.unsortedSegmentSum(r, i, n);
              }, {
                $x: r
              }, function (e) {
                return {
                  $x: function $x() {
                    return function (e, t) {
                      for (var n = hs(t, Ct(t)), r = Gs(e, n), i = Ka(t, ut(0, "int32")), o = r.rank - i.rank, a = 0; a < o; ++a) i = Xi(i, a + 1);
                      i = Ts(i, gt(r.shape, "bool"));
                      var s = Ct(r);
                      return Ps(i, r, s);
                    }(e, i);
                  }
                };
              });
            }
          });
        var Hs = nt({
            basicLSTMCell_: function basicLSTMCell_(e, t, n, r, i, o) {
              var a = et(e, "forgetBias", "basicLSTMCell"),
                s = et(t, "lstmKernel", "basicLSTMCell"),
                l = et(n, "lstmBias", "basicLSTMCell"),
                u = et(r, "data", "basicLSTMCell"),
                c = et(i, "c", "basicLSTMCell"),
                d = et(o, "h", "basicLSTMCell"),
                h = u.concat(d, 1).matMul(s).add(l),
                f = h.shape[0],
                p = h.shape[1] / 4,
                m = [f, p],
                g = h.slice([0, 0], m),
                v = h.slice([0, p], m),
                y = h.slice([0, 2 * p], m),
                b = h.slice([0, 3 * p], m),
                _ = g.sigmoid().mulStrict(v.tanh()).addStrict(c.mulStrict(a.add(y).sigmoid()));
              return [_, _.tanh().mulStrict(b.sigmoid())];
            }
          }),
          qs = nt({
            multiRNNCell_: function multiRNNCell_(e, t, n, r) {
              for (var i = et(t, "data", "multiRNNCell"), o = tt(n, "c", "multiRNNCell"), a = tt(r, "h", "multiRNNCell"), s = i, l = [], u = 0; u < e.length; u++) {
                var c = e[u](s, o[u], a[u]);
                l.push(c[0]), l.push(c[1]), s = c[1];
              }
              var d = [],
                h = [];
              for (u = 0; u < l.length; u += 2) d.push(l[u]), h.push(l[u + 1]);
              return [d, h];
            }
          });
        var Ws = nt({
          movingAverage_: function movingAverage_(e, t, n, r, i) {
            void 0 === i && (i = !0);
            var o = et(e, "v", "movingAverage"),
              a = et(t, "x", "movingAverage"),
              s = et(n, "decay", "movingAverage");
            ie(o, a), b(A(o.shape, a.shape), "Shape mismatch in v and x");
            var l = ut(1),
              u = l.sub(s),
              c = a.sub(o).mul(u);
            if (i) {
              b(null != r, "When using zeroDebias: true, step is required.");
              var d = et(r, "step", "movingAverage");
              c = c.div(l.sub(_s(s, d)));
            }
            return o.add(c);
          }
        });
        var $s = nt({
          stridedSlice_: function stridedSlice_(e, t, n, r, i, o, a, s, l) {
            if (void 0 === i && (i = 0), void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === s && (s = 0), void 0 === l && (l = 0), 0 !== a) throw new Error("ellipsis mask is not yet supported");
            if (0 !== s) throw new Error("new axis mask is not yet supported");
            var u = et(e, "x", "stridedSlice");
            return ve.engine.runKernel(function (e) {
              return e.stridedSlice(u, t, n, r, i, o, a, s, l);
            }, {
              $x: u
            });
          }
        });
        var Xs = nt({
          topk_: function topk_(e, t, n) {
            void 0 === t && (t = 1), void 0 === n && (n = !0);
            var r = et(e, "x", "topk");
            if (0 === r.rank) throw new Error("topk() expects the input to be of rank 1 or higher");
            var i = r.shape[r.shape.length - 1];
            if (t > i) throw new Error("'k' passed to topk() must be <= the last dimension (" + i + ") but got " + t);
            var o = ve.engine.runKernel(function (e) {
              return e.topk(r, t, n);
            }, {
              $x: r
            });
            return {
              values: o[0],
              indices: o[1]
            };
          }
        });
        var Ys = nt({
          scatterND_: function scatterND_(e, t, n) {
            var r = et(e, "indices", "scatterND", "int32"),
              i = et(t, "updates", "scatterND");
            return Xe(i, r, n), ve.engine.runKernel(function (e) {
              return e.scatterND(r, i, n);
            }, {
              $indices: r,
              $updates: i
            });
          }
        });
        var Ks = nt({
            fft_: function fft_(e) {
              b("complex64" === e.dtype, "The dtype for tf.spectral.fft() must be complex64 but got " + e.dtype + ".");
              var t = e.shape[e.shape.length - 1],
                n = e.size / t,
                r = e.as2D(n, t);
              return ve.engine.runKernel(function (e) {
                return e.fft(r);
              }, {
                input: e
              }).reshape(e.shape);
            }
          }),
          Zs = nt({
            ifft_: function ifft_(e) {
              b("complex64" === e.dtype, "The dtype for tf.spectral.ifft() must be complex64 but got " + e.dtype + ".");
              var t = e.shape[e.shape.length - 1],
                n = e.size / t,
                r = e.as2D(n, t);
              return ve.engine.runKernel(function (e) {
                return e.ifft(r);
              }, {
                input: e
              }).reshape(e.shape);
            }
          }),
          Qs = nt({
            rfft_: function rfft_(e) {
              b("float32" === e.dtype, "The dtype for rfft() must be real value but\n    got " + e.dtype);
              var t = e.shape[e.shape.length - 1],
                n = e.size / t,
                r = e.zerosLike(),
                i = ot(e, r).as2D(n, t),
                o = ve.engine.runKernel(function (e) {
                  return e.fft(i);
                }, {
                  complexInput: i
                }),
                a = Math.floor(t / 2) + 1,
                s = at(o),
                l = st(o),
                u = s.split([a, t - a], s.shape.length - 1),
                c = l.split([a, t - a], l.shape.length - 1),
                d = e.shape.slice();
              return d[e.shape.length - 1] = a, ot(u[0], c[0]).reshape(d);
            }
          }),
          Js = nt({
            irfft_: function irfft_(e) {
              var t = e.shape[e.shape.length - 1],
                n = e.size / t;
              if (t <= 2) {
                var r = e.as2D(n, t),
                  i = ve.engine.runKernel(function (e) {
                    return e.ifft(r);
                  }, {
                    complexInput: r
                  });
                return at(i);
              }
              var o = [n, 2 * (t - 1)],
                a = at(e).as2D(n, t),
                s = st(e).as2D(n, t),
                l = a.slice([0, 1], [n, t - 2]).reverse(1),
                u = s.slice([0, 1], [n, t - 2]).reverse(1).mul(ut(-1)),
                c = a.concat(l, 1),
                d = s.concat(u, 1),
                h = ot(c, d).as2D(o[0], o[1]);
              return i = ve.engine.runKernel(function (e) {
                return e.ifft(h);
              }, {
                complexInput: h
              }), at(i);
            }
          }),
          el = Object.freeze({
            fft: Ks,
            ifft: Zs,
            rfft: Qs,
            irfft: Js
          });
        var tl = nt({
          sparseToDense_: function sparseToDense_(e, t, n, r) {
            var i = et(e, "sparseIndices", "sparseToDense", "int32"),
              o = et(t, "sparseValues", "sparseToDense"),
              a = et(r, "defaultValue", "sparseToDense", o.dtype);
            return function (e, t, n, r) {
              if ("int32" !== e.dtype) throw new Error("tf.sparseToDense() expects the indices to be int32 type, but the dtype was " + e.dtype + ".");
              if (e.rank > 2) throw new Error("sparseIndices should be a scalar, vector, or matrix, but got shape " + e.shape + ".");
              var i = e.rank > 0 ? e.shape[0] : 1,
                o = e.rank > 1 ? e.shape[1] : 1;
              if (n.length !== o) throw new Error("outputShape has incorrect number of elements:, " + n.length + ", should be: " + o + ".");
              var a = t.size;
              if (0 !== t.rank && (1 !== t.rank || a !== i)) throw new Error("sparseValues has incorrect shape " + t.shape + ", should be [] or [" + i + "]");
              if (t.dtype !== r.dtype) throw new Error("sparseValues.dtype must match defaultValues.dtype");
            }(i, o, n, a), ve.engine.runKernel(function (e) {
              return e.sparseToDense(i, o, n, a);
            }, {
              $sparseIndices: i,
              $sparseValues: o,
              $defaultValue: a
            });
          }
        });
        var nl,
          rl = nt({
            gatherND_: function gatherND_(e, t) {
              var n = et(t, "indices", "gatherND", "int32"),
                r = et(e, "x", "gatherND");
              return ve.engine.runKernel(function (e) {
                return e.gatherND(r, n);
              }, {
                $x: r,
                $indices: n
              });
            }
          });
        !function (e) {
          e[e.NONE = 0] = "NONE", e[e.MEAN = 1] = "MEAN", e[e.SUM = 2] = "SUM", e[e.SUM_BY_NONZERO_WEIGHTS = 3] = "SUM_BY_NONZERO_WEIGHTS";
        }(nl || (nl = {}));
        var il = nt({
            absoluteDifference_: function absoluteDifference_(e, t, n, r) {
              void 0 === r && (r = nl.SUM_BY_NONZERO_WEIGHTS);
              var i = et(e, "labels", "absoluteDifference"),
                o = et(t, "predictions", "absoluteDifference"),
                a = null;
              null != n && (a = et(n, "weights", "absoluteDifference")), _(i.shape, o.shape, "Error in absoluteDifference: ");
              var s = i.sub(o).abs();
              return ol(s, a, r);
            }
          }),
          ol = nt({
            computeWeightedLoss_: function computeWeightedLoss_(e, t, n) {
              void 0 === n && (n = nl.SUM_BY_NONZERO_WEIGHTS);
              var r = et(e, "losses", "computeWeightedLoss"),
                i = null;
              null != t && (i = et(t, "weights", "computeWeightedLoss"));
              var o = null == i ? r : r.mul(i);
              if (n === nl.NONE) return o;
              if (n === nl.SUM) return o.sum();
              if (n === nl.MEAN) {
                if (null == i) return o.mean();
                var a = S(r.shape) / S(i.shape),
                  s = o.sum().div(i.sum());
                return a > 1 ? s.div(ut(a)) : s;
              }
              if (n === nl.SUM_BY_NONZERO_WEIGHTS) {
                if (null == i) return o.sum().div(ut(r.size));
                var l = i.mul(gt(r.shape)).notEqual(ut(0)).sum().toFloat();
                return o.sum().div(l);
              }
              throw Error("Unknown reduction: " + n);
            }
          }),
          al = nt({
            cosineDistance_: function cosineDistance_(e, t, n, r, i) {
              void 0 === i && (i = nl.SUM_BY_NONZERO_WEIGHTS);
              var o = et(e, "labels", "cosineDistance"),
                a = et(t, "predictions", "cosineDistance"),
                s = null;
              null != r && (s = et(r, "weights", "cosineDistance")), _(o.shape, a.shape, "Error in cosineDistance: ");
              var l = ut(1).sub(o.mul(a).sum(n, !0));
              return ol(l, s, i);
            }
          }),
          sl = nt({
            hingeLoss_: function hingeLoss_(e, t, n, r) {
              void 0 === r && (r = nl.SUM_BY_NONZERO_WEIGHTS);
              var i = et(e, "labels", "hingeLoss"),
                o = et(t, "predictions", "hingeLoss"),
                a = null;
              null != n && (a = et(n, "weights", "hingeLoss")), _(i.shape, o.shape, "Error in hingeLoss: ");
              var s = ut(1);
              i = ut(2).mul(i).sub(s);
              var l = s.sub(i.mul(o)).relu();
              return ol(l, a, r);
            }
          }),
          ll = nt({
            huberLoss_: function huberLoss_(e, t, n, r, i) {
              void 0 === r && (r = 1), void 0 === i && (i = nl.SUM_BY_NONZERO_WEIGHTS);
              var o = et(e, "labels", "huberLoss"),
                a = et(t, "predictions", "huberLoss"),
                s = null;
              null != n && (s = et(n, "weights", "huberLoss")), _(o.shape, a.shape, "Error in huberLoss: ");
              var l = ut(r),
                u = a.sub(o).abs(),
                c = ps(u, l),
                d = u.sub(c),
                h = ut(.5).mul(c.square()).add(l.mul(d));
              return ol(h, s, i);
            }
          }),
          ul = nt({
            logLoss_: function logLoss_(e, t, n, r, i) {
              void 0 === r && (r = 1e-7), void 0 === i && (i = nl.SUM_BY_NONZERO_WEIGHTS);
              var o = et(e, "labels", "logLoss"),
                a = et(t, "predictions", "logLoss"),
                s = null;
              null != n && (s = et(n, "weights", "logLoss")), _(o.shape, a.shape, "Error in logLoss: ");
              var l = ut(1),
                u = ut(r),
                c = o.mul(a.add(u).log()).neg().sub(l.sub(o).mul(l.sub(a).add(u).log()));
              return ol(c, s, i);
            }
          }),
          cl = nt({
            meanSquaredError_: function meanSquaredError_(e, t, n, r) {
              void 0 === r && (r = nl.SUM_BY_NONZERO_WEIGHTS);
              var i = et(e, "labels", "meanSquaredError"),
                o = et(t, "predictions", "meanSquaredError"),
                a = null;
              null != n && (a = et(n, "weights", "meanSquaredError")), _(i.shape, o.shape, "Error in meanSquaredError: ");
              var s = i.squaredDifference(o);
              return ol(s, a, r);
            }
          }),
          dl = nt({
            sigmoidCrossEntropy_: function sigmoidCrossEntropy_(e, t, n, r, i) {
              void 0 === r && (r = 0), void 0 === i && (i = nl.SUM_BY_NONZERO_WEIGHTS);
              var o = et(e, "multiClassLabels", "sigmoidCrossEntropy"),
                a = et(t, "logits", "sigmoidCrossEntropy"),
                s = null;
              if (null != n && (s = et(n, "weights", "sigmoidCrossEntropy")), _(o.shape, a.shape, "Error in sigmoidCrossEntropy: "), r > 0) {
                var l = ut(r),
                  u = ut(1),
                  c = ut(.5);
                o = o.mul(u.sub(l)).add(c.mul(l));
              }
              var d = function (e, t) {
                var n = et(e, "labels", "sigmoidCrossEntropyWithLogits"),
                  r = et(t, "logits", "sigmoidCrossEntropyWithLogits");
                _(n.shape, r.shape, "Error in sigmoidCrossEntropyWithLogits: ");
                var i = r.relu(),
                  o = r.mul(n),
                  a = r.abs().neg().exp().log1p();
                return i.sub(o).add(a);
              }(o, a);
              return ol(d, s, i);
            }
          }),
          hl = nt({
            softmaxCrossEntropy_: function softmaxCrossEntropy_(e, t, n, r, i) {
              void 0 === r && (r = 0), void 0 === i && (i = nl.SUM_BY_NONZERO_WEIGHTS);
              var o = et(e, "onehotLabels", "softmaxCrossEntropy"),
                a = et(t, "logits", "softmaxCrossEntropy"),
                s = null;
              if (null != n && (s = et(n, "weights", "softmaxCrossEntropy")), _(o.shape, a.shape, "Error in softmaxCrossEntropy: "), r > 0) {
                var l = ut(r),
                  u = ut(1),
                  c = ut(o.shape[1]);
                o = o.mul(u.sub(l)).add(l.div(c));
              }
              var d = function (e, t, n) {
                if (void 0 === n && (n = -1), -1 === n && (n = t.rank - 1), n !== t.rank - 1) throw Error("Softmax cross entropy along a non-last dimension is not yet supported. Labels / logits was rank " + t.rank + " and dim was " + n);
                return Ae(function (e, t) {
                  var r = t.logSumExp([n], !0),
                    i = t.toFloat().sub(r);
                  return {
                    value: i.mul(e).neg().sum([n]),
                    gradFunc: function gradFunc(t) {
                      var r = Fe(t.shape, [n]);
                      return [t.reshape(r).mul(e.toFloat().sub(i.exp())), t.reshape(r).mul(i.exp().sub(e.toFloat()))];
                    }
                  };
                })(e, t);
              }(o, a);
              return ol(d, s, i);
            }
          }),
          fl = Object.freeze({
            get Reduction() {
              return nl;
            },
            absoluteDifference: il,
            computeWeightedLoss: ol,
            cosineDistance: al,
            hingeLoss: sl,
            huberLoss: ll,
            logLoss: ul,
            meanSquaredError: cl,
            sigmoidCrossEntropy: dl,
            softmaxCrossEntropy: hl
          });
        function pl(e, t) {
          return void 0 === t && (t = !1), ve.engine.tidy(function () {
            if (2 !== e.shape.length) throw new Error("qr2d() requires a 2D Tensor, but got a " + e.shape.length + "D Tensor.");
            for (var n = e.shape[0], r = e.shape[1], i = Yi(n), o = e.clone(), a = dt([[1]], [1, 1]), s = a.clone(), l = n >= r ? r : n, u = function u(e) {
                var t,
                  l = o,
                  u = s,
                  c = i;
                t = ve.engine.tidy(function () {
                  var t = o.slice([e, e], [n - e, 1]),
                    l = t.norm(),
                    u = o.slice([e, e], [1, 1]),
                    c = u.sign().neg(),
                    d = u.sub(c.mul(l)),
                    h = t.div(d);
                  s = 1 === h.shape[0] ? a.clone() : a.concat(h.slice([1, 0], [h.shape[0] - 1, h.shape[1]]), 0);
                  var f = c.matMul(d).div(l).neg(),
                    p = o.slice([e, 0], [n - e, r]),
                    m = f.mul(s);
                  o = 0 === e ? p.sub(m.matMul(s.transpose().matMul(p))) : o.slice([0, 0], [e, r]).concat(p.sub(m.matMul(s.transpose().matMul(p))), 0);
                  var g = i.slice([0, e], [n, i.shape[1] - e]);
                  return i = 0 === e ? g.sub(g.matMul(s).matMul(m.transpose())) : i.slice([0, 0], [n, e]).concat(g.sub(g.matMul(s).matMul(m.transpose())), 1), [s, o, i];
                }), s = t[0], o = t[1], i = t[2], Ce([l, u, c]);
              }, c = 0; c < l; ++c) u(c);
            return !t && n > r && (i = i.slice([0, 0], [n, r]), o = o.slice([0, 0], [r, r])), [i, o];
          });
        }
        var ml = nt({
            gramSchmidt_: function gramSchmidt_(e) {
              var t;
              if (Array.isArray(e)) {
                t = !1, b(null != e && e.length > 0, "Gram-Schmidt process: input must not be null, undefined, or empty");
                for (var n = e[0].shape[0], r = 1; r < e.length; ++r) b(e[r].shape[0] === n, "Gram-Schmidt: Non-unique lengths found in the input vectors: (" + e[r].shape[0] + " vs. " + n + ")");
              } else t = !0, e = ki(e, e.shape[0], 0).map(function (e) {
                return uo(e, [0]);
              });
              b(e.length <= e[0].shape[0], "Gram-Schmidt: Number of vectors (" + e.length + ") exceeds number of dimensions (" + e[0].shape[0] + ").");
              var i = [],
                o = e,
                a = function a(e) {
                  i.push(ve.engine.tidy(function () {
                    var t = o[e];
                    if (e > 0) for (var n = 0; n < e; ++n) {
                      var r = qa(i[n].mulStrict(t)).mul(i[n]);
                      t = t.sub(r);
                    }
                    return t.div(Fs(t, "euclidean"));
                  }));
                };
              for (r = 0; r < e.length; ++r) a(r);
              return t ? co(i, 0) : i;
            }
          }),
          gl = nt({
            qr_: function qr_(e, t) {
              if (void 0 === t && (t = !1), e.rank < 2) throw new Error("qr() requires input tensor to have a rank >= 2, but got rank " + e.rank);
              if (2 === e.rank) return pl(e, t);
              var n = e.shape.slice(0, e.shape.length - 2).reduce(function (e, t) {
                  return e * t;
                }),
                r = [],
                i = [];
              return po(e.reshape([n, e.shape[e.shape.length - 2], e.shape[e.shape.length - 1]]), 0).forEach(function (e) {
                var n = pl(e, t),
                  o = n[0],
                  a = n[1];
                r.push(o), i.push(a);
              }), [co(r, 0).reshape(e.shape), co(i, 0).reshape(e.shape)];
            }
          }),
          vl = Object.freeze({
            gramSchmidt: ml,
            qr: gl
          });
        function yl(e, t, n, r, i) {
          null == r && (r = .5), null == i && (i = Number.NEGATIVE_INFINITY);
          var o = e.shape[0];
          return n = Math.min(n, o), b(0 <= r && r <= 1, "iouThreshold must be in [0, 1], but was '" + r + "'"), b(2 === e.rank, "boxes must be a 2D tensor, but was of rank '" + e.rank + "'"), b(4 === e.shape[1], "boxes must have 4 columns, but 2nd dimension was " + e.shape[1]), b(1 === t.rank, "scores must be a 1D tensor"), b(t.shape[0] === o, "scores has incompatible shape with boxes. Expected " + o + ", but was " + t.shape[0]), {
            maxOutputSize: n,
            iouThreshold: r,
            scoreThreshold: i
          };
        }
        var bl = nt({
            resizeBilinear_: function resizeBilinear_(e, t, n) {
              void 0 === n && (n = !1);
              var r = et(e, "images", "resizeBilinear");
              b(3 === r.rank || 4 === r.rank, "Error in resizeBilinear: x must be rank 3 or 4, but got rank " + r.rank + "."), b(2 === t.length, "Error in resizeBilinear: new shape must 2D, but got shape " + t + ".");
              var i = r,
                o = !1;
              3 === r.rank && (o = !0, i = r.as4D(1, r.shape[0], r.shape[1], r.shape[2]));
              var a = t[0],
                s = t[1],
                l = ve.engine.runKernel(function (e, t) {
                  return e.resizeBilinear(i, a, s, n);
                }, {
                  batchImages: i
                }, function (e, t) {
                  return {
                    batchImages: function batchImages() {
                      return ve.engine.runKernel(function (t) {
                        return t.resizeBilinearBackprop(e, i, n);
                      }, {});
                    }
                  };
                });
              return o ? l.as3D(l.shape[1], l.shape[2], l.shape[3]) : l;
            }
          }),
          _l = nt({
            resizeNearestNeighbor_: function resizeNearestNeighbor_(e, t, n) {
              void 0 === n && (n = !1);
              var r = et(e, "images", "resizeNearestNeighbor");
              b(3 === r.rank || 4 === r.rank, "Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank " + r.rank + "."), b(2 === t.length, "Error in resizeNearestNeighbor: new shape must 2D, but got shape " + t + "."), b("float32" === r.dtype || "int32" === r.dtype, "`images` must have `int32` or `float32` as dtype");
              var i = r,
                o = !1;
              3 === r.rank && (o = !0, i = r.as4D(1, r.shape[0], r.shape[1], r.shape[2]));
              var a = t[0],
                s = t[1],
                l = ve.engine.runKernel(function (e, t) {
                  return e.resizeNearestNeighbor(i, a, s, n);
                }, {
                  batchImages: i
                }, function (e, t) {
                  return {
                    batchImages: function batchImages() {
                      return ve.engine.runKernel(function (t) {
                        return t.resizeNearestNeighborBackprop(e, i, n);
                      }, {});
                    }
                  };
                });
              return o ? l.as3D(l.shape[1], l.shape[2], l.shape[3]) : l;
            }
          }),
          xl = nt({
            nonMaxSuppression_: function nonMaxSuppression_(e, t, n, r, i) {
              void 0 === r && (r = .5), void 0 === i && (i = Number.NEGATIVE_INFINITY);
              var o = et(e, "boxes", "nonMaxSuppression"),
                a = et(t, "scores", "nonMaxSuppression"),
                s = yl(o, a, n, r, i);
              return n = s.maxOutputSize, r = s.iouThreshold, i = s.scoreThreshold, ve.engine.runKernel(function (e) {
                return e.nonMaxSuppression(o, a, n, r, i);
              }, {
                $boxes: o
              });
            }
          }),
          wl = function wl(e, t, n, r, i) {
            return void 0 === r && (r = .5), void 0 === i && (i = Number.NEGATIVE_INFINITY), u(this, void 0, void 0, function () {
              var o, a, s, l, u, d;
              return c(this, function (c) {
                switch (c.label) {
                  case 0:
                    return o = et(e, "boxes", "nonMaxSuppressionAsync"), a = et(t, "scores", "nonMaxSuppressionAsync"), s = yl(o, a, n, r, i), n = s.maxOutputSize, r = s.iouThreshold, i = s.scoreThreshold, [4, o.data()];
                  case 1:
                    return l = c.sent(), [4, a.data()];
                  case 2:
                    return u = c.sent(), d = zt(l, u, n, r, i), o !== e && o.dispose(), a !== t && a.dispose(), [2, d];
                }
              });
            });
          },
          Sl = function Sl(e, t, n, r, i, o) {
            var a = et(e, "image", "cropAndResize", "float32"),
              s = et(t, "boxes", "cropAndResize", "float32"),
              l = et(n, "boxInd", "cropAndResize", "int32");
            i = i || "bilinear", o = o || 0;
            var u = s.shape[0];
            return b(4 === a.rank, "Error in cropAndResize: image must be rank 4,but got rank " + a.rank + "."), b(2 === s.rank && 4 === s.shape[1], "Error in cropAndResize: boxes must be have size [" + u + ",4] but had shape " + s.shape + "."), b(1 === l.rank && l.shape[0] === u, "Error in cropAndResize: boxInd must be have size [" + u + "] but had shape " + s.shape + "."), b("int32" === l.dtype, "Error in cropAndResize: boxInd must be of dtype int32, but got dtype " + l.dtype + "."), b(2 === r.length, "Error in cropAndResize: cropSize must be of length 2, but got length " + r.length + "."), b(r[0] >= 1 && r[1] >= 1, "cropSize must be atleast [1,1], but was " + r), b("bilinear" === i || "nearest" === i, "method must be bilinear or nearest, but was " + i), ve.engine.runKernel(function (e, t) {
              return e.cropAndResize(a, s, l, r, i, o);
            }, {
              $image: a,
              $boxes: s
            });
          },
          Al = Object.freeze({
            resizeBilinear: bl,
            resizeNearestNeighbor: _l,
            nonMaxSuppression: xl,
            nonMaxSuppressionAsync: wl,
            cropAndResize: Sl
          }),
          El = Object.freeze({
            image: Al,
            linalg: vl,
            losses: fl,
            spectral: el,
            op: nt,
            batchNormalization2d: Qo,
            batchNormalization3d: Jo,
            batchNormalization4d: ea,
            batchNormalization: ta,
            complex: ot,
            real: at,
            imag: st,
            concat: Ai,
            concat1d: Ei,
            concat2d: Ti,
            concat3d: Mi,
            concat4d: Ci,
            split: ki,
            conv1d: pa,
            conv2d: ma,
            conv2dDerFilter: ga,
            depthwiseConv2d: va,
            separableConv2d: ya,
            conv2dTranspose: ba,
            matMul: ua,
            dot: ca,
            outerProduct: da,
            reverse: _a,
            reverse1d: xa,
            reverse2d: wa,
            reverse3d: Sa,
            reverse4d: Aa,
            maxPool: Ma,
            avgPool: Ca,
            pool: ka,
            slice: Pa,
            slice1d: Oa,
            slice2d: Ra,
            slice3d: Ia,
            slice4d: ja,
            abs: bo,
            acos: _o,
            acosh: xo,
            asin: wo,
            asinh: So,
            atan: Ao,
            atanh: Eo,
            ceil: To,
            clipByValue: Mo,
            cos: Co,
            cosh: ko,
            erf: Po,
            exp: Oo,
            expm1: Ro,
            floor: Io,
            log: jo,
            log1p: No,
            logSigmoid: Lo,
            neg: Do,
            reciprocal: Bo,
            round: Fo,
            rsqrt: zo,
            sigmoid: Uo,
            sign: Go,
            sin: Vo,
            sinh: Ho,
            softplus: qo,
            sqrt: Wo,
            square: $o,
            step: Xo,
            tan: Yo,
            tanh: Ko,
            all: La,
            any: Da,
            argMax: Ba,
            argMin: Fa,
            logSumExp: za,
            max: Ua,
            mean: Ga,
            min: Va,
            moments: Ha,
            sum: qa,
            prod: Wa,
            equal: $a,
            equalStrict: Xa,
            greater: Ya,
            greaterEqual: Ka,
            greaterEqualStrict: Za,
            greaterStrict: Qa,
            less: Ja,
            lessEqual: es,
            lessEqualStrict: ts,
            lessStrict: ns,
            notEqual: rs,
            notEqualStrict: is,
            add: os,
            addN: as,
            addStrict: ss,
            atan2: ls,
            div: us,
            divStrict: cs,
            floorDiv: ds,
            maximum: hs,
            maximumStrict: fs,
            minimum: ps,
            minimumStrict: ms,
            mod: gs,
            modStrict: vs,
            mul: ys,
            mulStrict: bs,
            pow: _s,
            powStrict: xs,
            squaredDifference: ws,
            squaredDifferenceStrict: Ss,
            sub: As,
            subStrict: Es,
            elu: Rs,
            leakyRelu: Is,
            prelu: js,
            relu: Ns,
            selu: Ls,
            logicalAnd: Ts,
            logicalNot: Ms,
            logicalOr: Cs,
            logicalXor: ks,
            where: Ps,
            whereAsync: Os,
            buffer: Ui,
            toPixels: zi,
            print: Gi,
            batchToSpaceND: Vi,
            cast: Hi,
            clone: qi,
            cumsum: Wi,
            depthToSpace: $i,
            expandDims: Xi,
            eye: Yi,
            fromPixels: Ki,
            multinomial: Zi,
            oneHot: Qi,
            pad: Ji,
            pad1d: eo,
            pad2d: to,
            pad3d: no,
            pad4d: ro,
            rand: io,
            randomNormal: oo,
            randomUniform: ao,
            reshape: so,
            spaceToBatchND: lo,
            squeeze: uo,
            stack: co,
            tile: ho,
            truncatedNormal: fo,
            unstack: po,
            setdiff1dAsync: mo,
            fill: yt,
            linspace: bt,
            ones: gt,
            range: _t,
            scalar: ut,
            tensor: lt,
            tensor1d: ct,
            tensor2d: dt,
            tensor3d: ht,
            tensor4d: ft,
            tensor5d: pt,
            tensor6d: mt,
            zeros: vt,
            onesLike: Mt,
            zerosLike: Ct,
            transpose: Ds,
            softmax: rt,
            logSoftmax: it,
            localResponseNormalization: Bs,
            norm: Fs,
            gather: Gs,
            unsortedSegmentSum: Vs,
            basicLSTMCell: Hs,
            multiRNNCell: qs,
            movingAverage: Ws,
            stridedSlice: $s,
            topk: Xs,
            scatterND: Ys,
            fft: Ks,
            ifft: Zs,
            rfft: Qs,
            irfft: Js,
            sparseToDense: tl,
            gatherND: rl
          }),
          Tl = function () {
            function e() {
              this.blockSize = 48, this.firstUse = !0, ve.get("IS_BROWSER") && (this.fromPixels2DContext = document.createElement("canvas").getContext("2d"));
            }
            return e.prototype.setDataMover = function (e) {
              this.data = new Rt(e);
            }, e.prototype.register = function (e, t, n) {
              if (this.firstUse && (this.firstUse = !1, ve.get("IS_NODE") && Oe("\n============================\nHi there 👋. Looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, which binds to TensorFlow C++, by running npm i @tensorflow/tfjs-node, or npm i @tensorflow/tfjs-node-gpu if you have CUDA. Then call require('@tensorflow/tfjs-node'); (-gpu suffix for CUDA) at the start of your program. Visit https://github.com/tensorflow/tfjs-node for more details.\n============================\n")), this.data.has(e)) throw new Error("Data buffer is already registered");
              this.data.set(e, {
                dtype: n
              });
            }, e.prototype.write = function (e, t) {
              if (null == t) throw new Error("MathBackendCPU.write(): values can not be null");
              this.data.get(e).values = t;
            }, e.prototype.fromPixels = function (e, t) {
              if (null == e) throw new Error("pixels passed to tf.fromPixels() can not be null");
              var n, r;
              if (ve.get("IS_NODE") && null == e.getContext) throw new Error("When running in node, pixels must be an HTMLCanvasElement like the one returned by the `canvas` npm package");
              if (null != e.getContext) n = e.getContext("2d").getImageData(0, 0, e.width, e.height).data;else if (e instanceof ImageData) n = e.data;else {
                if (!(e instanceof HTMLImageElement || e instanceof HTMLVideoElement)) throw new Error("pixels passed to tf.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement or ImageData, but was " + e.constructor.name);
                if (null == this.fromPixels2DContext) throw new Error("Can't read pixels from HTMLImageElement outside the browser.");
                this.fromPixels2DContext.canvas.width = e.width, this.fromPixels2DContext.canvas.height = e.height, this.fromPixels2DContext.drawImage(e, 0, 0, e.width, e.height), n = this.fromPixels2DContext.getImageData(0, 0, e.width, e.height).data;
              }
              if (4 === t) r = new Int32Array(n);else {
                var i = e.width * e.height;
                r = new Int32Array(i * t);
                for (var o = 0; o < i; o++) for (var a = 0; a < t; ++a) r[o * t + a] = n[4 * o + a];
              }
              return ht(r, [e.height, e.width, t], "int32");
            }, e.prototype.read = function (e) {
              return u(this, void 0, void 0, function () {
                return c(this, function (t) {
                  return [2, this.readSync(e)];
                });
              });
            }, e.prototype.readSync = function (e) {
              var t = this.data.get(e),
                n = t.dtype,
                r = t.complexTensors;
              return "complex64" === n ? Lt(r.real.dataSync(), r.imag.dataSync()) : this.data.get(e).values;
            }, e.prototype.disposeData = function (e) {
              if (this.data.has(e)) {
                var t = this.data.get(e).complexTensors;
                null != t && (t.real.dispose(), t.imag.dispose()), this.data.delete(e);
              }
            }, e.prototype.time = function (e) {
              return u(this, void 0, void 0, function () {
                var t;
                return c(this, function (n) {
                  return t = H(), e(), [2, {
                    kernelMs: H() - t
                  }];
                });
              });
            }, e.prototype.memory = function () {
              return {
                unreliable: !0
              };
            }, e.prototype.complex = function (e, t) {
              var n = te.make(e.shape, {}, "complex64");
              return this.data.get(n.dataId).complexTensors = {
                real: ve.engine.keep(e.clone()),
                imag: ve.engine.keep(t.clone())
              }, n;
            }, e.prototype.real = function (e) {
              return this.data.get(e.dataId).complexTensors.real.clone();
            }, e.prototype.imag = function (e) {
              return this.data.get(e.dataId).complexTensors.imag.clone();
            }, e.prototype.assertNotComplex = function (e, t) {
              Array.isArray(e) || (e = [e]), e.forEach(function (e) {
                null != e && b("complex64" !== e.dtype, t + " does not support complex64 tensors.");
              });
            }, e.prototype.slice = function (e, t, n) {
              this.assertNotComplex(e, "slice");
              for (var r = Ui(n, e.dtype), i = 0; i < r.size; ++i) {
                var o = r.indexToLoc(i),
                  a = o.map(function (e, n) {
                    return e + t[n];
                  });
                r.set.apply(r, [e.get.apply(e, a)].concat(o));
              }
              return r.toTensor();
            }, e.prototype.stridedSlice = function (e, t, n, r, i, o, a, s, l) {
              this.assertNotComplex(e, "stridedSlice");
              var u = Ke(e.shape, t, n, r, i, o, a, s, l),
                c = u[0],
                d = u[1],
                h = u[2],
                f = d.filter(function (e, t) {
                  return -1 === h.indexOf(t);
                });
              if (f.some(function (e) {
                return 0 === e;
              })) return lt([], f);
              for (var p = Ui(d, e.dtype), m = 0; m < p.size; m++) {
                for (var g = p.indexToLoc(m), v = new Array(g.length), y = 0; y < v.length; y++) v[y] = g[y] * r[y] + c[y];
                p.set.apply(p, [e.get.apply(e, v)].concat(g));
              }
              return p.toTensor().reshape(f);
            }, e.prototype.reverse = function (e, t) {
              this.assertNotComplex(e, "reverse");
              for (var n = Ui(e.shape, e.dtype), r = e.buffer(), i = function i(_i2) {
                  var o = n.indexToLoc(_i2),
                    a = o.slice();
                  t.forEach(function (t) {
                    return a[t] = e.shape[t] - 1 - a[t];
                  }), n.set.apply(n, [r.get.apply(r, a)].concat(o));
                }, o = 0; o < n.size; o++) i(o);
              return n.toTensor();
            }, e.prototype.concat = function (e, t) {
              this.assertNotComplex(e, "concat");
              var n = e.map(function (e) {
                  var n = S(e.shape.slice(t));
                  return e.as2D(-1, n);
                }),
                r = qe(n.map(function (e) {
                  return e.shape;
                }), 1),
                i = Ui(r, e[0].dtype).values;
              if (1 === n[0].shape[0]) {
                var o = 0;
                n.forEach(function (e) {
                  i.set(e.dataSync(), o), o += e.size;
                });
              } else {
                var a = 0;
                n.forEach(function (e) {
                  for (var t = e.dataSync(), n = 0, o = 0; o < e.shape[0]; ++o) for (var s = o * r[1] + a, l = 0; l < e.shape[1]; ++l) i[s + l] = t[n++];
                  a += e.shape[1];
                });
              }
              var s = qe(e.map(function (e) {
                return e.shape;
              }), t);
              return lt(i, s, e[0].dtype);
            }, e.prototype.neg = function (e) {
              return this.assertNotComplex(e, "neg"), this.multiply(ut(-1), e);
            }, e.prototype.add = function (e, t) {
              return "complex64" === e.dtype || "complex64" === t.dtype ? this.broadcastedBinaryComplexOp(e.cast("complex64"), t.cast("complex64"), function (e, t, n, r) {
                return {
                  real: e + n,
                  imag: t + r
                };
              }) : this.broadcastedBinaryOp(e, t, Pt(e.dtype, t.dtype), function (e, t) {
                return e + t;
              });
            }, e.prototype.addN = function (e) {
              this.assertNotComplex(e, "addN");
              for (var t = e.map(function (e) {
                  return e.dataSync();
                }), n = Ui(e[0].shape, e[0].dtype), r = n.values, i = 0; i < e.length; i++) for (var o = t[i], a = 0; a < r.length; a++) r[a] += o[a];
              return n.toTensor();
            }, e.prototype.subtract = function (e, t) {
              return "complex64" === e.dtype || "complex64" === t.dtype ? this.broadcastedBinaryComplexOp(e.cast("complex64"), t.cast("complex64"), function (e, t, n, r) {
                return {
                  real: e - n,
                  imag: t - r
                };
              }) : this.broadcastedBinaryOp(e, t, Pt(e.dtype, t.dtype), function (e, t) {
                return e - t;
              });
            }, e.prototype.pow = function (e, t) {
              return this.assertNotComplex([e, t], "pow"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
                return Math.pow(e, t);
              });
            }, e.prototype.batchMatMul = function (e, t, n, r) {
              this.assertNotComplex([e, t], "matMul");
              for (var i = n ? e.shape[1] : e.shape[2], o = n ? e.shape[2] : e.shape[1], a = r ? t.shape[1] : t.shape[2], s = e.shape[0], l = e.dataSync(), u = t.dataSync(), c = n ? [e.strides[0], 1, e.strides[1]] : [e.strides[0], e.strides[1], 1], d = c[0], h = c[1], f = c[2], p = r ? [1, t.strides[1], t.strides[0]] : [t.strides[1], 1, t.strides[0]], m = p[0], g = p[1], v = p[2], y = o * a, b = new Float32Array(s * y), _ = this.blockSize, x = 0; x < s; x++) for (var w = 0; w < o; w += _) for (var S = 0; S < a; S += _) for (var A = 0; A < i; A += _) for (var E = Math.min(w + _, o), T = Math.min(S + _, a), M = Math.min(A + _, i), C = w; C < E; C++) for (var k = S; k < T; k++) {
                for (var P = 0, O = A; O < M; O++) P += l[x * d + C * h + O * f] * u[O * m + k * g + x * v];
                b[x * y + (C * a + k)] += P;
              }
              return ht(b, [s, o, a]);
            }, e.prototype.multiply = function (e, t) {
              return "complex64" === e.dtype || "complex64" === t.dtype ? this.broadcastedBinaryComplexOp(e.cast("complex64"), t.cast("complex64"), function (e, t, n, r) {
                return {
                  real: e * n - t * r,
                  imag: e * r + t * n
                };
              }) : this.broadcastedBinaryOp(e, t, Pt(e.dtype, t.dtype), function (e, t) {
                return e * t;
              });
            }, e.prototype.realDivide = function (e, t) {
              return this.assertNotComplex([e, t], "realDivide"), this.broadcastedBinaryOp(e, t, "float32", function (e, t) {
                return e / t;
              });
            }, e.prototype.floorDiv = function (e, t) {
              return this.assertNotComplex([e, t], "floorDiv"), this.broadcastedBinaryOp(e, t, "int32", function (e, t) {
                return Math.floor(e / t);
              });
            }, e.prototype.sum = function (e, t) {
              this.assertNotComplex(e, "sum"), Ue("sum", t, e.rank);
              for (var n = Be(e.shape, t), r = n[0], i = n[1], o = vt(r, Pt(e.dtype, "int32")), a = S(i), s = o.dataSync(), l = e.dataSync(), u = 0; u < s.length; ++u) {
                for (var c = u * a, d = 0, h = 0; h < a; ++h) d += l[c + h];
                s[u] = d;
              }
              return o;
            }, e.prototype.prod = function (e, t) {
              this.assertNotComplex(e, "sum");
              for (var n = Be(e.shape, t), r = n[0], i = n[1], o = vt(r, Pt(e.dtype, "int32")), a = S(i), s = o.dataSync(), l = e.dataSync(), u = 0; u < s.length; ++u) {
                for (var c = u * a, d = 1, h = 0; h < a; ++h) d *= l[c + h];
                s[u] = d;
              }
              return o;
            }, e.prototype.unsortedSegmentSum = function (e, t, n) {
              this.assertNotComplex(e, "unsortedSegmentSum");
              for (var r = [], i = e.rank - t.rank, o = 0; o < i; ++o) t = t.expandDims(o + 1);
              for (o = 0; o < n; ++o) {
                var a = ut(o, "int32"),
                  s = $a(a, t).asType("float32").mul(e).sum(0);
                r.push(s);
              }
              return co(r);
            }, e.prototype.argMin = function (e, t) {
              this.assertNotComplex(e, "argMin");
              var n = [t];
              Ue("argMin", n, e.rank);
              for (var r = Be(e.shape, n), i = r[0], o = r[1], a = vt(i, "int32"), s = S(o), l = a.dataSync(), u = e.dataSync(), c = 0; c < l.length; ++c) {
                for (var d = c * s, h = u[d], f = 0, p = 0; p < s; ++p) {
                  var m = u[d + p];
                  m < h && (h = m, f = p);
                }
                l[c] = f;
              }
              return a;
            }, e.prototype.argMax = function (e, t) {
              this.assertNotComplex(e, "argMax");
              var n = [t];
              Ue("argMax", n, e.rank);
              for (var r = Be(e.shape, n), i = r[0], o = r[1], a = vt(i, "int32"), s = S(o), l = a.dataSync(), u = e.dataSync(), c = 0; c < l.length; ++c) {
                for (var d = c * s, h = u[d], f = 0, p = 0; p < s; ++p) {
                  var m = u[d + p];
                  m > h && (h = m, f = p);
                }
                l[c] = f;
              }
              return a;
            }, e.prototype.cumsum = function (e, t, n, r) {
              if (this.assertNotComplex(e, "cumsum"), t !== e.rank - 1) throw new Error("backend.cumsum in CPU expects an inner-most axis=" + (e.rank - 1) + " but got axis=" + t);
              for (var i = Pt(e.dtype, "int32"), o = vt(e.shape, i), a = o.dataSync(), s = e.dataSync(), l = e.shape[e.rank - 1], u = r ? function (e, t) {
                  return e + l - t - 1;
                } : function (e, t) {
                  return e + t;
                }, c = 0; c < s.length; c += l) for (var d = 0; d < l; d++) {
                var h = u(c, d);
                if (0 === d) a[h] = n ? 0 : s[h];else {
                  var f = u(c, d - 1);
                  a[h] = n ? s[f] + a[f] : s[h] + a[f];
                }
              }
              return o;
            }, e.prototype.equal = function (e, t) {
              return this.assertNotComplex([e, t], "equal"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e === t ? 1 : 0;
              });
            }, e.prototype.notEqual = function (e, t) {
              return this.assertNotComplex([e, t], "notEqual"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e !== t ? 1 : 0;
              });
            }, e.prototype.less = function (e, t) {
              return this.assertNotComplex([e, t], "less"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e < t ? 1 : 0;
              });
            }, e.prototype.lessEqual = function (e, t) {
              return this.assertNotComplex([e, t], "lessEqual"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e <= t ? 1 : 0;
              });
            }, e.prototype.greater = function (e, t) {
              return this.assertNotComplex([e, t], "greater"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e > t ? 1 : 0;
              });
            }, e.prototype.greaterEqual = function (e, t) {
              return this.assertNotComplex([e, t], "greaterEqual"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e >= t ? 1 : 0;
              });
            }, e.prototype.logicalNot = function (e) {
              this.assertNotComplex(e, "logicalNot");
              for (var t = e.dataSync(), n = new Int32Array(t.length), r = 0; r < t.length; ++r) n[r] = t[r] ? 0 : 1;
              return te.make(e.shape, {
                values: n
              }, "bool");
            }, e.prototype.logicalAnd = function (e, t) {
              return this.assertNotComplex([e, t], "logicalAnd"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e && t;
              });
            }, e.prototype.logicalOr = function (e, t) {
              return this.assertNotComplex([e, t], "logicalOr"), this.broadcastedBinaryOp(e, t, "bool", function (e, t) {
                return e || t;
              });
            }, e.prototype.select = function (e, t, n) {
              this.assertNotComplex([e, t, n], "select");
              for (var r = e.dataSync(), i = t.dataSync(), o = n.dataSync(), a = vt(t.shape, Pt(t.dtype, n.dtype)), s = a.dataSync(), l = 0, u = 0 === e.rank || e.rank > 1 || 1 === t.rank ? 1 : t.shape[1], c = 0; c < r.length; c++) for (var d = 0; d < u; d++) 1 === r[c] ? s[l++] = i[c] : s[l++] = o[c];
              return a;
            }, e.prototype.where = function (e) {
              this.assertNotComplex([e], "where");
              var t = e.dataSync();
              return go(e.shape, t);
            }, e.prototype.topk = function (e, t, n) {
              return this.assertNotComplex(e, "topk"), Vt(e.dataSync(), e.shape, e.dtype, t);
            }, e.prototype.min = function (e, t) {
              this.assertNotComplex(e, "min"), Ue("min", t, e.rank);
              for (var n = Be(e.shape, t), r = n[0], i = n[1], o = vt(r, e.dtype), a = S(i), s = o.dataSync(), l = e.dataSync(), u = 0; u < s.length; ++u) {
                for (var c = u * a, d = l[c], h = 0; h < a; ++h) {
                  var f = l[c + h];
                  f < d && (d = f);
                }
                s[u] = d;
              }
              return o;
            }, e.prototype.minimum = function (e, t) {
              return this.assertNotComplex([e, t], "minimum"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
                return Math.min(e, t);
              });
            }, e.prototype.mod = function (e, t) {
              return this.assertNotComplex([e, t], "mod"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
                var n = e % t;
                return e < 0 && t < 0 || e >= 0 && t >= 0 ? n : (n + t) % t;
              });
            }, e.prototype.max = function (e, t) {
              this.assertNotComplex(e, "max"), Ue("max", t, e.rank);
              for (var n = Be(e.shape, t), r = n[0], i = n[1], o = vt(r, e.dtype), a = S(i), s = o.dataSync(), l = e.dataSync(), u = 0; u < s.length; ++u) {
                for (var c = u * a, d = l[c], h = 0; h < a; ++h) {
                  var f = l[c + h];
                  f > d && (d = f);
                }
                s[u] = d;
              }
              return o;
            }, e.prototype.maximum = function (e, t) {
              return this.assertNotComplex([e, t], "maximum"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
                return Math.max(e, t);
              });
            }, e.prototype.all = function (e, t) {
              this.assertNotComplex(e, "all"), Ue("all", t, e.rank);
              for (var n = Be(e.shape, t), r = n[0], i = n[1], o = vt(r, e.dtype), a = S(i), s = o.dataSync(), l = e.dataSync(), u = 0; u < s.length; ++u) {
                for (var c = u * a, d = l[c], h = 0; h < a; ++h) {
                  var f = l[c + h];
                  d = d && f;
                }
                s[u] = d;
              }
              return o;
            }, e.prototype.any = function (e, t) {
              this.assertNotComplex(e, "any"), Ue("any", t, e.rank);
              for (var n = Be(e.shape, t), r = n[0], i = n[1], o = vt(r, e.dtype), a = S(i), s = o.dataSync(), l = e.dataSync(), u = 0; u < s.length; ++u) {
                for (var c = u * a, d = l[c], h = 0; h < a; ++h) {
                  var f = l[c + h];
                  d = d || f;
                }
                s[u] = d;
              }
              return o;
            }, e.prototype.squaredDifference = function (e, t) {
              return this.assertNotComplex([e, t], "squaredDifference"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
                var n = e - t;
                return n * n;
              });
            }, e.prototype.ceil = function (e) {
              this.assertNotComplex(e, "ceil");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) n[r] = Math.ceil(t[r]);
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.floor = function (e) {
              this.assertNotComplex(e, "floor");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) n[r] = Math.floor(t[r]);
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.sign = function (e) {
              this.assertNotComplex(e, "x");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) t[r] < 0 ? n[r] = -1 : t[r] > 0 ? n[r] = 1 : n[r] = 0;
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.round = function (e) {
              this.assertNotComplex(e, "round");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
                var i = Math.floor(t[r]);
                t[r] - i < .5 ? n[r] = Math.floor(t[r]) : t[r] - i > .5 ? n[r] = Math.ceil(t[r]) : n[r] = i % 2 == 0 ? i : i + 1;
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.exp = function (e) {
              this.assertNotComplex(e, "exp");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) n[r] = Math.exp(t[r]);
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.expm1 = function (e) {
              this.assertNotComplex(e, "expm1");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) n[r] = Math.expm1(t[r]);
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.log = function (e) {
              this.assertNotComplex(e, "log");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
                var i = t[r];
                n[r] = Math.log(i);
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.log1p = function (e) {
              this.assertNotComplex(e, "log1p");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
                var i = t[r];
                n[r] = Math.log1p(i);
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.sqrt = function (e) {
              this.assertNotComplex(e, "sqrt");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
                var i = t[r];
                n[r] = Math.sqrt(i);
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.rsqrt = function (e) {
              this.assertNotComplex(e, "rsqrt");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
                var i = t[r];
                n[r] = 1 / Math.sqrt(i);
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.square = function (e) {
              this.assertNotComplex(e, "square");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) {
                var i = t[r];
                n[r] = i * i;
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.reciprocal = function (e) {
              this.assertNotComplex(e, "reciprocal");
              for (var t = e.dataSync(), n = new Float32Array(t.length), r = 0; r < t.length; ++r) n[r] = 1 / t[r];
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.relu = function (e) {
              this.assertNotComplex(e, "relu");
              for (var t = vt(e.shape, e.dtype), n = t.dataSync(), r = e.dataSync(), i = 0; i < r.length; ++i) n[i] = Math.max(0, r[i]);
              return t;
            }, e.prototype.elu = function (e) {
              this.assertNotComplex(e, "elu");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
                var i = n[r];
                t[r] = i >= 0 ? i : Math.exp(i) - 1;
              }
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.eluDer = function (e, t) {
              this.assertNotComplex([e, t], "eluDer");
              for (var n = new Float32Array(t.size), r = t.dataSync(), i = e.dataSync(), o = 0; o < r.length; ++o) {
                var a = r[o];
                n[o] = a >= 1 ? i[o] : i[o] * (a + 1);
              }
              return te.make(t.shape, {
                values: n
              });
            }, e.prototype.selu = function (e) {
              this.assertNotComplex(e, "selu");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
                var i = n[r];
                t[r] = i >= 0 ? 1.0507009873554805 * i : 1.7580993408473768 * (Math.exp(i) - 1);
              }
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.clip = function (e, t, n) {
              this.assertNotComplex(e, "clip");
              for (var r = new Float32Array(e.size), i = e.dataSync(), o = 0; o < i.length; ++o) {
                var a = i[o];
                r[o] = a > n ? n : a < t ? t : a;
              }
              return te.make(e.shape, {
                values: r
              });
            }, e.prototype.abs = function (e) {
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.abs(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.complexAbs = function (e) {
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < e.size; ++r) {
                var i = n[2 * r],
                  o = n[2 * r + 1];
                t[r] = Math.hypot(i, o);
              }
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.int = function (e) {
              this.assertNotComplex(e, "int");
              for (var t = new Int32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = n[r];
              return te.make(e.shape, {
                values: t
              }, "int32");
            }, e.prototype.sigmoid = function (e) {
              this.assertNotComplex(e, "sigmoid");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = 1 / (1 + Math.exp(-n[r]));
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.softplus = function (e) {
              this.assertNotComplex(e, "softplus");
              for (var t = Math.log(1.1920928955078125e-7) + 2, n = new Float32Array(e.size), r = e.dataSync(), i = 0; i < r.length; ++i) {
                var o,
                  a = r[i] > -t,
                  s = r[i] < t,
                  l = Math.exp(r[i]);
                o = s ? l : a ? r[i] : Math.log(1 + l), n[i] = o;
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.sin = function (e) {
              this.assertNotComplex(e, "sin");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.sin(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.cos = function (e) {
              this.assertNotComplex(e, "cos");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.cos(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.tan = function (e) {
              this.assertNotComplex(e, "tan");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.tan(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.asin = function (e) {
              this.assertNotComplex(e, "asin");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.asin(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.acos = function (e) {
              this.assertNotComplex(e, "acos");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.acos(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.atan = function (e) {
              this.assertNotComplex(e, "atan");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.atan(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.atan2 = function (e, t) {
              return this.assertNotComplex([e, t], "atan2"), this.broadcastedBinaryOp(e, t, e.dtype, function (e, t) {
                return Math.atan2(e, t);
              });
            }, e.prototype.sinh = function (e) {
              this.assertNotComplex(e, "sinh");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.sinh(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.cosh = function (e) {
              this.assertNotComplex(e, "cosh");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.cosh(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.tanh = function (e) {
              this.assertNotComplex(e, "tanh");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = T(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.asinh = function (e) {
              this.assertNotComplex(e, "asinh");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.asinh(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.acosh = function (e) {
              this.assertNotComplex(e, "acosh");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.acosh(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.atanh = function (e) {
              this.assertNotComplex(e, "atanh");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) t[r] = Math.atanh(n[r]);
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.erf = function (e) {
              this.assertNotComplex(e, "erf");
              for (var t = new Float32Array(e.size), n = e.dataSync(), r = 0; r < n.length; ++r) {
                var i = n[r],
                  o = 1 / (1 + .3275911 * i);
                t[r] = 1 - ((((1.061405429 * o - 1.453152027) * o + 1.421413741) * o - .284496736) * o + .254829592) * o * Math.exp(-i * i);
              }
              return te.make(e.shape, {
                values: t
              });
            }, e.prototype.step = function (e, t) {
              void 0 === t && (t = 0), this.assertNotComplex(e, "step");
              for (var n = new Float32Array(e.size), r = e.dataSync(), i = 0; i < r.length; ++i) {
                var o = r[i];
                isNaN(o) ? n[i] = NaN : n[i] = o > 0 ? 1 : t;
              }
              return te.make(e.shape, {
                values: n
              });
            }, e.prototype.conv2d = function (e, t, n) {
              this.assertNotComplex([e, t], "conv2d");
              for (var r = n.filterHeight, i = n.filterWidth, o = n.dilationHeight, a = n.dilationWidth, s = n.padInfo.left, l = n.padInfo.top, u = Ui(n.outShape, e.dtype), c = e.dataSync(), d = t.dataSync(), h = u.values, f = 0; f < n.batchSize; ++f) for (var p = f * e.strides[0], m = f * u.strides[0], g = 0; g < n.outHeight; ++g) for (var v = m + g * u.strides[1], y = g * n.strideHeight - s, b = 0; b < r; b++) {
                var _ = y + b * o;
                if (!(_ < 0 || _ >= n.inHeight)) for (var x = b * t.strides[0], w = p + _ * e.strides[1], S = 0; S < n.outWidth; ++S) for (var A = v + S * n.outChannels, E = S * n.strideWidth - l, T = 0; T < i; T++) {
                  var M = E + T * a;
                  if (!(M < 0 || M >= n.inWidth)) for (var C = x + T * t.strides[1], k = w + M * n.inChannels, P = C, O = 0; O < n.inChannels; ++O) {
                    for (var R = c[k + O], I = 0; I < n.outChannels; ++I) h[A + I] += R * d[P + I];
                    P += n.outChannels;
                  }
                }
              }
              return u.toTensor();
            }, e.prototype.conv2dDerInput = function (e, t, n) {
              this.assertNotComplex([e, t], "conv2dDerInput");
              for (var r = Ui(n.inShape, "float32"), i = r.values, o = r.strides, a = o[0], s = o[1], l = o[2], u = e.dataSync(), c = e.strides, d = c[0], h = c[1], f = c[2], p = t.dataSync(), m = t.strides, g = m[0], v = m[1], y = m[2], b = n.batchSize, _ = n.filterHeight, x = n.filterWidth, w = n.inChannels, S = n.inHeight, A = n.inWidth, E = n.outChannels, T = n.outHeight, M = n.outWidth, C = n.strideHeight, k = n.strideWidth, P = _ - 1 - n.padInfo.top, O = x - 1 - n.padInfo.left, R = 0; R < b; ++R) for (var I = 0; I < w; ++I) for (var j = 0; j < S; ++j) for (var N = j - P, L = Math.max(0, Math.ceil(N / C)), D = Math.min(T, (_ + N) / C), B = 0; B < A; ++B) {
                for (var F = B - O, z = Math.max(0, Math.ceil(F / k)), U = Math.min(M, (x + F) / k), G = 0, V = L; V < D; ++V) for (var H = V * C - N, q = z; q < U; ++q) for (var W = d * R + h * V + f * q, $ = g * (_ - 1 - H) + v * (x - 1 - (q * k - F)) + y * I, X = 0; X < E; ++X) G += u[W + X] * p[$ + X];
                i[a * R + s * j + l * B + I] = G;
              }
              return r.toTensor();
            }, e.prototype.conv2dDerFilter = function (e, t, n) {
              this.assertNotComplex([e, t], "conv2dDerFilter");
              for (var r = n.strideHeight, i = n.strideWidth, o = n.filterHeight, a = n.filterWidth, s = Ui(n.filterShape, "float32"), l = n.padInfo.left, u = n.padInfo.top, c = 0; c < o; ++c) for (var d = Math.max(0, Math.ceil((u - c) / r)), h = Math.min(n.outHeight, (n.inHeight + u - c) / r), f = 0; f < a; ++f) for (var p = Math.max(0, Math.ceil((l - f) / i)), m = Math.min(n.outWidth, (n.inWidth + l - f) / i), g = 0; g < n.inChannels; ++g) for (var v = 0; v < n.outChannels; ++v) {
                for (var y = 0, b = 0; b < n.batchSize; ++b) for (var _ = d; _ < h; ++_) for (var x = c + _ * r - u, w = p; w < m; ++w) {
                  var S = f + w * i - l;
                  y += e.get(b, x, S, g) * t.get(b, _, w, v);
                }
                s.set(y, c, f, g, v);
              }
              return s.toTensor();
            }, e.prototype.depthwiseConv2D = function (e, t, n) {
              this.assertNotComplex([e, t], "depthwiseConv2D");
              for (var r = n.filterHeight, i = n.filterWidth, o = n.dilationHeight, a = n.dilationWidth, s = n.padInfo.left, l = n.padInfo.top, u = n.outChannels / n.inChannels, c = Ui(n.outShape, e.dtype), d = e.dataSync(), h = t.dataSync(), f = c.values, p = 0; p < n.batchSize; ++p) for (var m = p * e.strides[0], g = p * c.strides[0], v = 0; v < n.outHeight; ++v) for (var y = g + v * c.strides[1], b = v * n.strideHeight - s, _ = 0; _ < r; ++_) {
                var x = b + _ * o;
                if (!(x < 0 || x >= n.inHeight)) for (var w = _ * t.strides[0], S = m + x * e.strides[1], A = 0; A < n.outWidth; ++A) for (var E = y + A * c.strides[2], T = A * n.strideWidth - l, M = 0; M < i; ++M) {
                  var C = T + M * a;
                  if (!(C < 0 || C >= n.inWidth)) for (var k = w + M * t.strides[1], P = S + C * n.inChannels, O = E, R = k, I = 0; I < n.inChannels; ++I) {
                    for (var j = d[P + I], N = 0; N < u; ++N) f[O + N] += j * h[R + N];
                    O += u, R += u;
                  }
                }
              }
              return c.toTensor();
            }, e.prototype.depthwiseConv2DDerInput = function (e, t, n) {
              this.assertNotComplex([e, t], "depthwiseConv2DDerInput");
              for (var r = Ui(n.inShape, "float32"), i = r.values, o = r.strides, a = o[0], s = o[1], l = o[2], u = e.dataSync(), c = e.strides, d = c[0], h = c[1], f = c[2], p = t.dataSync(), m = t.strides, g = m[0], v = m[1], y = m[2], b = n.batchSize, _ = n.filterHeight, x = n.filterWidth, w = n.inChannels, S = n.inHeight, A = n.inWidth, E = n.outChannels, T = n.outHeight, M = n.outWidth, C = n.strideHeight, k = n.strideWidth, P = _ - 1 - n.padInfo.top, O = x - 1 - n.padInfo.left, R = E / w, I = 0; I < b; ++I) for (var j = 0; j < w; ++j) for (var N = 0; N < S; ++N) for (var L = N - P, D = Math.max(0, Math.ceil(L / C)), B = Math.min(T, (_ + L) / C), F = 0; F < A; ++F) {
                for (var z = F - O, U = Math.max(0, Math.ceil(z / k)), G = Math.min(M, (x + z) / k), V = 0, H = D; H < B; ++H) for (var q = H * C - L, W = U; W < G; ++W) for (var $ = d * I + h * H + f * W, X = g * (_ - 1 - q) + v * (x - 1 - (W * k - z)) + y * j, Y = 0; Y < R; ++Y) V += u[$ + (j * R + Y)] * p[X + Y];
                i[a * I + s * N + l * F + j] = V;
              }
              return r.toTensor();
            }, e.prototype.depthwiseConv2DDerFilter = function (e, t, n) {
              this.assertNotComplex([e, t], "depthwiseConv2DDerFilter");
              for (var r = n.strideHeight, i = n.strideWidth, o = n.filterHeight, a = n.filterWidth, s = Ui(n.filterShape, "float32"), l = n.padInfo.left, u = n.padInfo.top, c = n.outChannels / n.inChannels, d = 0; d < o; ++d) for (var h = Math.max(0, Math.ceil((u - d) / r)), f = Math.min(n.outHeight, (n.inHeight + u - d) / r), p = 0; p < a; ++p) for (var m = Math.max(0, Math.ceil((l - p) / i)), g = Math.min(n.outWidth, (n.inWidth + l - p) / i), v = 0; v < n.outChannels; ++v) {
                for (var y = Math.trunc(v / c), b = v % c, _ = 0, x = 0; x < n.batchSize; ++x) for (var w = h; w < f; ++w) for (var S = d + w * r - u, A = m; A < g; ++A) {
                  var E = p + A * i - l;
                  _ += e.get(x, S, E, y) * t.get(x, w, A, v);
                }
                s.set(_, d, p, y, b);
              }
              return s.toTensor();
            }, e.prototype.tile = function (e, t) {
              this.assertNotComplex(e, "tile");
              for (var n = new Array(e.rank), r = 0; r < n.length; r++) n[r] = e.shape[r] * t[r];
              var i = Ui(n, e.dtype),
                o = e.buffer();
              for (r = 0; r < i.values.length; ++r) {
                for (var a = i.indexToLoc(r), s = new Array(e.rank), l = 0; l < s.length; l++) s[l] = a[l] % e.shape[l];
                var u = o.locToIndex(s);
                i.values[r] = o.values[u];
              }
              return i.toTensor();
            }, e.prototype.pad = function (e, t, n) {
              this.assertNotComplex(e, "pad");
              var r = t.map(function (t, n) {
                  return t[0] + e.shape[n] + t[1];
                }),
                i = t.map(function (e) {
                  return e[0];
                }),
                o = e.buffer(),
                a = Ui(r, e.dtype);
              0 !== n && a.values.fill(n);
              for (var s = 0; s < e.size; s++) {
                var l = o.indexToLoc(s),
                  u = l.map(function (e, t) {
                    return e + i[t];
                  });
                a.set.apply(a, [e.get.apply(e, l)].concat(u));
              }
              return a.toTensor();
            }, e.prototype.transpose = function (e, t) {
              this.assertNotComplex(e, "transpose");
              for (var n = new Array(e.rank), r = 0; r < n.length; r++) n[r] = e.shape[t[r]];
              var i = e.dataSync(),
                o = Ui(n, e.dtype),
                a = e.buffer();
              for (r = 0; r < e.size; ++r) {
                for (var s = a.indexToLoc(r), l = new Array(s.length), u = 0; u < l.length; u++) l[u] = s[t[u]];
                var c = o.locToIndex(l);
                o.values[c] = i[r];
              }
              return o.toTensor();
            }, e.prototype.gather = function (e, t, n) {
              this.assertNotComplex([e, t], "gather");
              var r = e.shape.slice(),
                i = t.dataSync();
              r[n] = i.length;
              for (var o = Ui(r, e.dtype), a = e.buffer(), s = 0; s < o.size; ++s) {
                var l = o.indexToLoc(s),
                  u = l.slice();
                u[n] = i[l[n]];
                var c = a.locToIndex(u);
                o.values[s] = a.values[c];
              }
              return o.toTensor();
            }, e.prototype.batchToSpaceND = function (e, t, n) {
              this.assertNotComplex([e], "batchToSpaceND");
              var r = t.reduce(function (e, t) {
                  return e * t;
                }),
                i = Re(e.shape, t, r),
                o = Ie(i.length, t.length),
                a = je(e.shape, t, r),
                s = Ne(n, t.length),
                l = Le(a, n, t.length);
              return e.reshape(i).transpose(o).reshape(a).slice(s, l);
            }, e.prototype.spaceToBatchND = function (e, t, n) {
              this.assertNotComplex([e], "spaceToBatchND");
              var r = t.reduce(function (e, t) {
                  return e * t;
                }),
                i = [[0, 0]];
              i.push.apply(i, n);
              for (var o = 1 + t.length; o < e.shape.length; ++o) i.push([0, 0]);
              var a = e.pad(i),
                s = Re(a.shape, t, r, !1),
                l = Ie(s.length, t.length, !1),
                u = je(a.shape, t, r, !1);
              return a.reshape(s).transpose(l).reshape(u);
            }, e.prototype.pool = function (e, t, n) {
              this.assertNotComplex(e, "pool");
              for (var r = t.strideHeight, i = t.strideWidth, o = t.dilationHeight, a = t.dilationWidth, s = t.effectiveFilterHeight, l = t.effectiveFilterWidth, u = t.padInfo.top, c = t.padInfo.left, d = "max" === n ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, h = e.dataSync(), f = Ui(t.outShape, e.dtype), p = f.values, m = t.outShape[1] * t.outShape[2] * t.outShape[3], g = t.outShape[2] * t.outShape[3], v = t.outShape[3], y = 0; y < t.batchSize; ++y) for (var b = y * m, _ = y * e.strides[0], x = 0; x < t.inChannels; ++x) for (var w = 0; w < t.outHeight; ++w) for (var S = w * r - u, A = Math.max(0, S), E = Math.min(t.inHeight, s + S), T = b + w * g, M = 0; M < t.outWidth; ++M) {
                for (var C = M * i - c, k = Math.max(0, C), P = Math.min(t.inWidth, l + C), O = d, R = 0, I = 0, j = A; j < E; j += o) {
                  for (var N = _ + j * e.strides[1], L = k; L < P; L += a) {
                    var D = h[N + L * e.strides[2] + x];
                    "max" === n && D > O ? O = D : "avg" === n && (R += D, I++);
                  }
                  if (isNaN(O)) break;
                }
                p[T + M * v + x] = "avg" === n ? R / I : O;
              }
              return f.toTensor();
            }, e.prototype.maxPool = function (e, t) {
              return this.pool(e, t, "max");
            }, e.prototype.maxPoolPositions = function (e, t) {
              for (var n = Ui(t.outShape, "int32"), r = t.strideHeight, i = t.strideWidth, o = t.dilationHeight, a = t.dilationWidth, s = t.effectiveFilterHeight, l = t.effectiveFilterWidth, u = t.padInfo.top, c = t.padInfo.left, d = 0; d < t.batchSize; ++d) for (var h = 0; h < t.inChannels; ++h) for (var f = 0; f < t.outHeight; ++f) {
                for (var p = f * r - u, m = p; m < 0;) m += o;
                for (var g = Math.min(t.inHeight, s + p), v = 0; v < t.outWidth; ++v) {
                  for (var y = v * i - c, b = y; b < 0;) b += a;
                  for (var _ = Math.min(t.inWidth, l + y), x = Number.NEGATIVE_INFINITY, w = -1, S = m; S < g; S += o) for (var A = S - p, E = b; E < _; E += a) {
                    var T = E - y,
                      M = e.get(d, S, E, h);
                    M > x && (x = M, w = A * l + T);
                  }
                  n.set(w, d, f, v, h);
                }
              }
              return n.toTensor();
            }, e.prototype.maxPoolBackprop = function (e, t, n, r) {
              this.assertNotComplex([t, n], "maxPoolBackprop");
              for (var i = this.maxPoolPositions(t, r), o = r.strideHeight, a = r.strideWidth, s = r.dilationHeight, l = r.dilationWidth, u = r.effectiveFilterHeight, c = r.effectiveFilterWidth, d = c - 1 - r.padInfo.left, h = u - 1 - r.padInfo.top, f = Ui(t.shape, "float32"), p = 0; p < r.batchSize; ++p) for (var m = 0; m < r.inChannels; ++m) for (var g = 0; g < r.inHeight; ++g) for (var v = 0; v < r.inWidth; ++v) {
                for (var y = g - h, b = v - d, _ = 0, x = 0; x < u; x += s) {
                  var w = (y + x) / o;
                  if (!(w < 0 || w >= r.outHeight || Math.floor(w) !== w)) for (var S = 0; S < c; S += l) {
                    var A = (b + S) / a;
                    if (!(A < 0 || A >= r.outWidth || Math.floor(A) !== A)) {
                      var E = u * c - 1 - i.get(p, w, A, m) === x * c + S ? 1 : 0;
                      0 !== E && (_ += e.get(p, w, A, m) * E);
                    }
                  }
                }
                f.set(_, p, g, v, m);
              }
              return f.toTensor();
            }, e.prototype.avgPoolBackprop = function (e, t, n) {
              this.assertNotComplex([e, t], "avgPoolBackprop");
              for (var r = n.strideHeight, i = n.strideWidth, o = n.filterHeight, a = n.filterWidth, s = n.dilationHeight, l = n.dilationWidth, u = n.effectiveFilterHeight, c = n.effectiveFilterWidth, d = c - 1 - n.padInfo.left, h = u - 1 - n.padInfo.top, f = Ui(t.shape, "float32"), p = 1 / (o * a), m = 0; m < n.batchSize; ++m) for (var g = 0; g < n.inChannels; ++g) for (var v = 0; v < n.inHeight; ++v) for (var y = 0; y < n.inWidth; ++y) {
                for (var b = v - h, _ = y - d, x = 0, w = 0; w < u; w += s) {
                  var S = (b + w) / r;
                  if (!(S < 0 || S >= n.outHeight || Math.floor(S) !== S)) for (var A = 0; A < c; A += l) {
                    var E = (_ + A) / i;
                    E < 0 || E >= n.outWidth || Math.floor(E) !== E || (x += e.get(m, S, E, g));
                  }
                }
                f.set(x * p, m, v, y, g);
              }
              return f.toTensor();
            }, e.prototype.cast = function (e, t) {
              return jt(e, t, this);
            }, e.prototype.reshape = function (e, t) {
              return Nt(e, t);
            }, e.prototype.avgPool = function (e, t) {
              return this.assertNotComplex(e, "avgPool"), this.pool(e, t, "avg").toFloat();
            }, e.prototype.resizeBilinear = function (e, t, n, r) {
              this.assertNotComplex(e, "resizeBilinear");
              for (var i = e.shape, o = i[0], a = i[1], s = i[2], l = i[3], u = e.dataSync(), c = new Float32Array(S([o, t, n, l])), d = [r && t > 1 ? a - 1 : a, r && n > 1 ? s - 1 : s], h = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n], f = 0, p = d[0] / h[0], m = d[1] / h[1], g = 0; g < o; g++) for (var v = 0; v < t; v++) for (var y = p * v, b = Math.floor(y), _ = y - b, x = Math.min(a - 1, Math.ceil(y)), w = g * e.strides[0] + b * e.strides[1], A = g * e.strides[0] + x * e.strides[1], E = 0; E < n; E++) for (var T = m * E, M = Math.floor(T), C = T - M, k = Math.min(s - 1, Math.ceil(T)), P = w + M * e.strides[2], O = A + M * e.strides[2], R = w + +k * e.strides[2], I = A + k * e.strides[2], j = 0; j < l; j++) {
                var N = u[P + j],
                  L = u[O + j],
                  D = N + (u[R + j] - N) * C,
                  B = D + (L + (u[I + j] - L) * C - D) * _;
                c[f++] = B;
              }
              return lt(c, [o, t, n, l]);
            }, e.prototype.resizeBilinearBackprop = function (e, t, n) {
              this.assertNotComplex([e, t], "resizeBilinearBackprop");
              for (var r = t.shape, i = r[0], o = r[1], a = r[2], s = r[3], l = e.shape, u = l[1], c = l[2], d = new Float32Array(i * o * a * s), h = [n && u > 1 ? o - 1 : o, n && c > 1 ? a - 1 : a], f = [n && u > 1 ? u - 1 : u, n && c > 1 ? c - 1 : c], p = h[0] / f[0], m = h[1] / f[1], g = e.dataSync(), v = 0, y = 0; y < i; y++) for (var b = y * t.strides[0], _ = 0; _ < u; _++) for (var x = _ * p, w = Math.floor(x), S = Math.min(Math.ceil(x), o - 1), A = b + w * t.strides[1], E = b + S * t.strides[1], T = x - w, M = 1 - T, C = 0; C < c; C++) for (var k = C * m, P = Math.floor(k), O = Math.min(Math.ceil(k), a - 1), R = k - P, I = 1 - R, j = A + P * t.strides[2], N = A + O * t.strides[2], L = E + P * t.strides[2], D = E + O * t.strides[2], B = M * I, F = M * R, z = T * I, U = T * R, G = 0; G < s; G++) {
                var V = g[v++];
                d[j + G] += V * B, d[N + G] += V * F, d[L + G] += V * z, d[D + G] += V * U;
              }
              return ft(d, [i, a, o, s], t.dtype);
            }, e.prototype.resizeNearestNeighbor = function (e, t, n, r) {
              this.assertNotComplex(e, "resizeNearestNeighbor");
              for (var i = e.shape, o = i[0], a = i[1], s = i[2], l = i[3], u = e.dataSync(), c = new Float32Array(o * t * n * l), d = [r && t > 1 ? a - 1 : a, r && n > 1 ? s - 1 : s], h = [r && t > 1 ? t - 1 : t, r && n > 1 ? n - 1 : n], f = d[0] / h[0], p = d[1] / h[1], m = 0, g = 0; g < o; g++) for (var v = g * e.strides[0], y = 0; y < t; y++) for (var b = f * y, _ = v + Math.min(a - 1, r ? Math.round(b) : Math.floor(b)) * e.strides[1], x = 0; x < n; x++) for (var w = p * x, S = _ + Math.min(s - 1, r ? Math.round(w) : Math.floor(w)) * e.strides[2], A = 0; A < l; A++) {
                var E = u[S + A];
                c[m++] = E;
              }
              return lt(c, [o, t, n, l], e.dtype);
            }, e.prototype.resizeNearestNeighborBackprop = function (e, t, n) {
              this.assertNotComplex([e, t], "resizeNearestNeighborBackprop");
              for (var r = t.shape, i = r[0], o = r[1], a = r[2], s = r[3], l = e.shape, u = l[1], c = l[2], d = new Float32Array(i * o * a * s), h = e.dataSync(), f = [n && u > 1 ? o - 1 : o, n && c > 1 ? a - 1 : a], p = [n && u > 1 ? u - 1 : u, n && c > 1 ? c - 1 : c], m = f[0] / p[0], g = f[1] / p[1], v = 1 / m, y = 1 / g, b = 2 * Math.ceil(v) + 2, _ = 2 * Math.ceil(y) + 2, x = 0; x < i; x++) for (var w = x * t.strides[0], S = 0; S < o; S++) for (var A = w + S * t.strides[1], E = Math.floor(S * v), T = Math.floor(E - b / 2), M = 0; M < a; M++) for (var C = A + M * t.strides[2], k = Math.floor(M * y), P = Math.floor(k - _ / 2), O = 0; O < s; O++) {
                for (var R = 0, I = 0; I < b; I++) {
                  var j = I + T;
                  if (!(j < 0 || j >= u)) {
                    var N = w + j * e.strides[1],
                      L = j * m;
                    if (S === Math.min(o - 1, n ? Math.round(L) : Math.floor(L))) for (var D = 0; D < _; D++) {
                      var B = D + P;
                      if (!(B < 0 || B >= c)) {
                        var F = N + B * e.strides[2],
                          z = B * g;
                        M === Math.min(a - 1, n ? Math.round(z) : Math.floor(z)) && (R += h[F + O]);
                      }
                    }
                  }
                }
                d[C + O] = R;
              }
              return ft(d, t.shape, t.dtype);
            }, e.prototype.batchNormalization = function (e, t, n, r, i, o) {
              this.assertNotComplex([e, t, n, i, o], "batchNormalization");
              for (var a = e.dataSync(), s = t.dataSync(), l = n.dataSync(), u = i ? i.dataSync() : new Float32Array([1]), c = o ? o.dataSync() : new Float32Array([0]), d = new Float32Array(a.length), h = c.length, f = u.length, p = l.length, m = s.length, g = 0, v = 0, y = 0, b = 0, _ = 0; _ < a.length; ++_) d[_] = c[g++] + (a[_] - s[v++]) * u[y++] / Math.sqrt(l[b++] + r), g >= h && (g = 0), v >= m && (v = 0), y >= f && (y = 0), b >= p && (b = 0);
              return ft(d, e.shape);
            }, e.prototype.localResponseNormalization4D = function (e, t, n, r, i) {
              this.assertNotComplex(e, "localResponseNormalization4D");
              var o = e.shape[3],
                a = o - 1,
                s = e.dataSync(),
                l = S(e.shape),
                u = new Float32Array(l);
              function c(e) {
                for (var n = e % o, r = e - n + Math.max(0, n - t), i = e - n + Math.min(n + t, a), l = 0; r <= i; r++) {
                  var u = s[r];
                  l += u * u;
                }
                return l;
              }
              for (var d = 0; d < l; d++) {
                var h = c(d),
                  f = s[d] * Math.pow(n + r * h, -i);
                u[d] = f;
              }
              return ft(u, e.shape);
            }, e.prototype.LRNGrad = function (e, t, n, r, i, o, a) {
              this.assertNotComplex(e, "LRNGrad");
              for (var s = e.shape[3], l = e.dataSync(), u = t.dataSync(), c = n.dataSync(), d = new Float32Array(S(e.shape)), h = S(e.shape), f = 0; f < h; f++) {
                for (var p = f % s, m = f - p + Math.max(0, p - r), g = f - p + Math.min(s, p + r + 1), v = 0, y = m; y < g; y++) v += Math.pow(u[y], 2);
                for (v = o * v + i, y = m; y < g; y++) {
                  var b = -2 * o * a * u[y] * c[f] / v;
                  f === y && (b += Math.pow(v, -a)), b *= l[f], d[y] += b;
                }
              }
              return ft(d, e.shape);
            }, e.prototype.multinomial = function (e, t, n, r) {
              this.assertNotComplex(e, "multinomial");
              for (var i = t ? e : rt(e), o = i.shape[0], a = i.shape[1], s = vt([o, n], "int32"), l = s.dataSync(), u = i.dataSync(), c = 0; c < o; ++c) {
                var d = c * a,
                  h = new Float32Array(a - 1);
                h[0] = u[d];
                for (var f = 1; f < h.length; ++f) h[f] = h[f - 1] + u[d + f];
                for (var p = Bi(r.toString()), m = c * n, g = 0; g < n; ++g) {
                  var v = p();
                  l[m + g] = h.length;
                  for (var y = 0; y < h.length; y++) if (v < h[y]) {
                    l[m + g] = y;
                    break;
                  }
                }
              }
              return s;
            }, e.prototype.oneHot = function (e, t, n, r) {
              this.assertNotComplex(e, "oneHot");
              var i = new Float32Array(e.size * t);
              i.fill(r);
              for (var o = 0; o < e.size; ++o) e.get(o) >= 0 && e.get(o) < t && (i[o * t + e.get(o)] = n);
              return dt(i, [e.size, t], "int32");
            }, e.prototype.nonMaxSuppression = function (e, t, n, r, i) {
              return this.assertNotComplex(e, "nonMaxSuppression"), zt(e.dataSync(), t.dataSync(), n, r, i);
            }, e.prototype.fft = function (e) {
              return this.fftBatch(e, !1);
            }, e.prototype.ifft = function (e) {
              return this.fftBatch(e, !0);
            }, e.prototype.fftBatch = function (e, t) {
              for (var n = e.shape[0], r = e.shape[1], i = Ui(e.shape, "float32"), o = Ui(e.shape, "float32"), a = at(e).as2D(n, r), s = st(e).as2D(n, r), l = 0; l < n; l++) for (var u = a.slice([l, 0], [1, r]), c = s.slice([l, 0], [1, r]), d = ot(u, c), h = this.fftImpl(d, t).dataSync(), f = 0; f < r; f++) {
                var p = Dt(h, f);
                i.values[l * r + f] = p.real, o.values[l * r + f] = p.imag;
              }
              return ot(i.toTensor(), o.toTensor()).as2D(n, r);
            }, e.prototype.fftImpl = function (e, t) {
              var n = e.as1D(),
                r = n.size;
              if (this.isExponentOf2(r)) {
                var i = this.fftRadix2(n, r, t).as2D(e.shape[0], e.shape[1]);
                return t && (i = ot(at(i).div(ut(r)), st(i).div(ut(r)))), i;
              }
              var o = e.dataSync(),
                a = function (e) {
                  for (var t = new Float32Array(e.length / 2), n = new Float32Array(e.length / 2), r = 0; r < e.length; r += 2) t[r / 2] = e[r], n[r / 2] = e[r + 1];
                  return {
                    real: t,
                    imag: n
                  };
                }(this.fourierTransformByMatmul(o, r, t));
              return ot(a.real, a.imag).as2D(e.shape[0], e.shape[1]);
            }, e.prototype.isExponentOf2 = function (e) {
              return 0 == (e & e - 1);
            }, e.prototype.fftRadix2 = function (e, t, n) {
              if (1 === t) return e;
              var r = e.dataSync(),
                i = t / 2,
                o = function (e) {
                  for (var t = Math.ceil(e.length / 4), n = new Float32Array(t), r = new Float32Array(t), i = 0; i < e.length; i += 4) n[Math.floor(i / 4)] = e[i], r[Math.floor(i / 4)] = e[i + 1];
                  return {
                    real: n,
                    imag: r
                  };
                }(r),
                a = ot(o.real, o.imag).as1D(),
                s = function (e) {
                  for (var t = Math.floor(e.length / 4), n = new Float32Array(t), r = new Float32Array(t), i = 2; i < e.length; i += 4) n[Math.floor(i / 4)] = e[i], r[Math.floor(i / 4)] = e[i + 1];
                  return {
                    real: n,
                    imag: r
                  };
                }(r),
                l = ot(s.real, s.imag).as1D();
              a = this.fftRadix2(a, i, n), l = this.fftRadix2(l, i, n);
              var u = function (e, t) {
                  for (var n = new Float32Array(e / 2), r = new Float32Array(e / 2), i = 0; i < Math.ceil(e / 2); i++) {
                    var o = (t ? 2 : -2) * Math.PI * (i / e);
                    n[i] = Math.cos(o), r[i] = Math.sin(o);
                  }
                  return {
                    real: n,
                    imag: r
                  };
                }(t, n),
                c = ot(u.real, u.imag).mul(l),
                d = a.add(c),
                h = a.sub(c),
                f = at(d).concat(at(h)),
                p = st(d).concat(st(h));
              return ot(f, p).as1D();
            }, e.prototype.fourierTransformByMatmul = function (e, t, n) {
              for (var r = new Float32Array(2 * t), i = 0; i < t; i++) {
                for (var o = 0, a = 0, s = 0; s < t; s++) {
                  var l = Ft(i * s, t, n),
                    u = Dt(e, s);
                  o += u.real * l.real - u.imag * l.imag, a += u.real * l.imag + u.imag * l.real;
                }
                n && (o /= t, a /= t), Bt(r, o, a, i);
              }
              return r;
            }, e.prototype.depthToSpace = function (e, t, n) {
              b("NHWC" === n, "Only NHWC dataFormat supported on CPU for depthToSpace. Got " + n), b(t > 1, "blockSize should be > 1 for depthToSpace, but was: " + t);
              for (var r = e.shape[0], i = e.shape[1], o = e.shape[2], a = e.shape[3], s = i * t, l = o * t, u = a / (t * t), c = e.dataSync(), d = new Float32Array(r * s * l * u), h = 0, f = 0; f < r; ++f) for (var p = 0; p < s; ++p) for (var m = Math.floor(p / t), g = p % t, v = 0; v < l; ++v) for (var y = Math.floor(v / t), _ = (g * t + v % t) * u, x = 0; x < u; ++x) {
                var w = x + _ + a * (y + o * (m + i * f));
                d[h++] = c[w];
              }
              return ft(d, [r, s, l, u]);
            }, e.prototype.broadcastedBinaryOp = function (e, t, n, r) {
              var i = Xt(e.shape, t.shape),
                o = Ui(i, n),
                a = e.dataSync(),
                s = t.dataSync(),
                l = Wt(e.shape, i),
                u = Wt(t.shape, i),
                c = o.values;
              if (l.length + u.length === 0) for (var d = 0; d < c.length; ++d) c[d] = r(a[d % a.length], s[d % s.length]);else {
                var h = e.buffer(),
                  f = t.buffer(),
                  p = function p(n) {
                    var i = o.indexToLoc(n),
                      d = i.slice(-e.rank);
                    l.forEach(function (e) {
                      return d[e] = 0;
                    });
                    var p = h.locToIndex(d),
                      m = i.slice(-t.rank);
                    u.forEach(function (e) {
                      return m[e] = 0;
                    });
                    var g = f.locToIndex(m);
                    c[n] = r(a[p], s[g]);
                  };
                for (d = 0; d < c.length; ++d) p(d);
              }
              return o.toTensor();
            }, e.prototype.broadcastedBinaryComplexOp = function (e, t, n) {
              var r = Xt(e.shape, t.shape),
                i = Ui(r, "float32"),
                o = Ui(r, "float32"),
                a = e.dataSync(),
                s = t.dataSync(),
                l = Wt(e.shape, r),
                u = Wt(t.shape, r),
                c = i.values,
                d = o.values;
              if (l.length + u.length === 0) for (var h = 0; h < c.length; h++) {
                var f = h % a.length,
                  p = h % s.length,
                  m = n(a[2 * f], a[2 * f + 1], s[2 * p], s[2 * p + 1]);
                c[h] = m.real, d[h] = m.imag;
              } else {
                var g = this.data.get(e.dataId).complexTensors.real.buffer(),
                  v = this.data.get(t.dataId).complexTensors.real.buffer(),
                  y = function y(r) {
                    var o = i.indexToLoc(r),
                      h = o.slice(-e.rank);
                    l.forEach(function (e) {
                      return h[e] = 0;
                    });
                    var f = g.locToIndex(h),
                      p = o.slice(-t.rank);
                    u.forEach(function (e) {
                      return p[e] = 0;
                    });
                    var m = v.locToIndex(p),
                      y = n(a[2 * f], a[2 * f + 1], s[2 * m], s[2 * m + 1]);
                    c[r] = y.real, d[r] = y.imag;
                  };
                for (h = 0; h < c.length; h++) y(h);
              }
              return this.complex(i.toTensor(), o.toTensor());
            }, e.prototype.split = function (e, t, n) {
              return Gt(e, t, n);
            }, e.prototype.dispose = function () {}, e.prototype.floatPrecision = function () {
              return 32;
            }, e.prototype.cropAndResize = function (e, t, n, r, i, o) {
              for (var a = e.shape, s = a[0], l = a[1], u = a[2], c = a[3], d = t.shape[0], h = r[0], f = r[1], p = Ui([d, h, f, c]), m = t.dataSync(), g = n.dataSync(), v = e.dataSync(), y = e.strides, b = p.strides, _ = 0; _ < d; _++) {
                var x = 4 * _,
                  w = m[x],
                  S = m[x + 1],
                  A = m[x + 2],
                  E = m[x + 3],
                  T = g[_];
                if (!(T >= s)) for (var M = h > 1 ? (A - w) * (l - 1) / (h - 1) : 0, C = f > 1 ? (E - S) * (u - 1) / (f - 1) : 0, k = 0; k < h; k++) {
                  var P = h > 1 ? w * (l - 1) + k * M : .5 * (w + A) * (l - 1);
                  if (P < 0 || P > l - 1) for (var O = 0; O < f; O++) for (var R = 0; R < c; R++) {
                    var I = R + O * b[2] + k * b[1] + _ * b[0];
                    p.values[I] = o;
                  } else if ("bilinear" === i) {
                    var j = Math.floor(P),
                      N = Math.ceil(P),
                      L = P - j;
                    for (O = 0; O < f; O++) if ((q = f > 1 ? S * (u - 1) + O * C : .5 * (S + E) * (u - 1)) < 0 || q > u - 1) for (R = 0; R < c; R++) I = R + O * b[2] + k * b[1] + _ * b[0], p.values[I] = o;else {
                      var D = Math.floor(q),
                        B = Math.ceil(q),
                        F = q - D;
                      for (R = 0; R < c; R++) {
                        var z = v[I = R + D * y[2] + j * y[1] + T * y[0]],
                          U = v[I = R + B * y[2] + j * y[1] + T * y[0]],
                          G = v[I = R + D * y[2] + N * y[1] + T * y[0]],
                          V = z + (U - z) * F,
                          H = G + (v[I = R + B * y[2] + N * y[1] + T * y[0]] - G) * F;
                        I = R + O * b[2] + k * b[1] + _ * b[0], p.values[I] = V + (H - V) * L;
                      }
                    }
                  } else for (O = 0; O < f; ++O) {
                    var q;
                    if ((q = f > 1 ? S * (u - 1) + O * C : .5 * (S + E) * (u - 1)) < 0 || q > u - 1) for (R = 0; R < c; R++) I = R + O * b[2] + k * b[1] + _ * b[0], p.values[I] = o;else {
                      var W = Math.round(q),
                        $ = Math.round(P);
                      for (R = 0; R < c; R++) {
                        var X = R + W * y[2] + $ * y[1] + T * y[0],
                          Y = R + O * b[2] + k * b[1] + _ * b[0];
                        p.values[Y] = v[X];
                      }
                    }
                  }
                }
              }
              return p.toTensor();
            }, e.prototype.sparseToDense = function (e, t, n, r) {
              var i = Ye(0, e, n),
                o = i.sliceRank,
                a = i.numUpdates,
                s = i.sliceSize,
                l = i.strides,
                u = i.outputSize;
              return this.scatter(e, t, n, u, s, a, o, l, r, !1);
            }, e.prototype.gatherND = function (e, t) {
              var n = t.shape,
                r = n[n.length - 1],
                i = We(e, t),
                o = i[0],
                a = i[1],
                s = i[2],
                l = i[3];
              if (0 === a) return lt([], o, e.dtype);
              for (var u = new Z([a, s], e.dtype), c = t.dataSync(), d = e.dataSync(), h = 0; h < a; h++) {
                for (var f = [], p = 0, m = 0; m < r; m++) {
                  var g = c[h * r + m];
                  p += g * l[m], f.push(g);
                }
                if (p < 0 || p >= e.size / s) throw new Error("Invalid indices: " + f + " does not index into " + e.shape);
                for (var v = 0; v < s; v++) u.values[h * s + v] = d[p * s + v];
              }
              return u.toTensor().reshape(o);
            }, e.prototype.scatterND = function (e, t, n) {
              var r = Ye(0, e, n),
                i = r.sliceRank,
                o = r.numUpdates,
                a = r.sliceSize,
                s = r.strides,
                l = r.outputSize,
                u = ut(0);
              return this.scatter(e, t, n, l, a, o, i, s, u, !0);
            }, e.prototype.scatter = function (e, t, n, r, i, o, a, s, l, u) {
              var c = [r / i, i],
                d = e.dataSync(),
                h = t.dataSync();
              if (0 === r) return lt([], n, t.dtype);
              var f = new Z(c, t.dtype);
              f.values.fill(l.dataSync()[0]);
              for (var p = 0; p < o; p++) {
                for (var m = [], g = 0, v = 0; v < a; v++) {
                  var y = d[p * a + v];
                  m.push(y), g += y * s[v];
                }
                if (g < 0 || g >= r / i) throw new Error("Invalid indices: " + m + " does not index into " + n);
                for (var b = 0; b < i; b++) u ? f.values[g * i + b] += h[p * i + b] : f.values[g * i + b] = 0 === t.rank ? h[0] : h[p * i + b];
              }
              return f.toTensor().reshape(n);
            }, e;
          }();
        ve.registerBackend("cpu", function () {
          return new Tl();
        }, 1, ee);
        var Ml = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : i;
        function Cl() {
          return new Promise(function (e) {
            return Ml(function () {
              return e();
            });
          });
        }
        var kl = {
          float32: 4,
          int32: 4,
          uint16: 2,
          uint8: 1,
          bool: 1
        };
        function Pl(e, t) {
          for (var n = {}, r = 0, i = function i(t) {
              var i = t.name,
                o = t.dtype,
                a = t.shape,
                s = S(a),
                l = void 0;
              if (("quantization" in t)) {
                var u = t.quantization;
                if ("uint8" !== u.dtype && "uint16" !== u.dtype) throw new Error("Weight " + t.name + " has unknown quantization dtype " + u.dtype + ". Supported quantization dtypes are: 'uint8' and 'uint16'.");
                var c = kl[u.dtype],
                  d = e.slice(r, r + s * c),
                  h = "uint8" === u.dtype ? new Uint8Array(d) : new Uint16Array(d);
                if ("float32" === o) l = Float32Array.from(h, function (e) {
                  return e * u.scale + u.min;
                });else {
                  if ("int32" !== o) throw new Error("Unsupported dtype in weight '" + i + "': " + o);
                  l = Int32Array.from(h, function (e) {
                    return Math.round(e * u.scale + u.min);
                  });
                }
                r += s * c;
              } else {
                var f = kl[o];
                if (d = e.slice(r, r + s * f), "float32" === o) l = new Float32Array(d);else if ("int32" === o) l = new Int32Array(d);else {
                  if ("bool" !== o) throw new Error("Unsupported dtype in weight '" + i + "': " + o);
                  l = new Uint8Array(d);
                }
                r += s * f;
              }
              var p = void 0;
              if ("float32" === o) p = lt(l, a, "float32");else if ("int32" === o) p = lt(l, a, "int32");else {
                if ("bool" !== o) throw new Error("Unsupported dtype in weight '" + i + "': " + o);
                p = lt(l, a, "bool");
              }
              n[i] = p;
            }, o = 0, a = t; o < a.length; o++) i(a[o]);
          return n;
        }
        function Ol(e) {
          if (null === e) throw new Error("Invalid input value: " + JSON.stringify(e));
          var t = 0,
            n = [];
          e.forEach(function (e) {
            if (t += e.byteLength, n.push(e.byteLength === e.buffer.byteLength ? e : new e.constructor(e)), !(e instanceof Float32Array || e instanceof Int32Array || e instanceof Uint8Array)) throw new Error("Unsupported TypedArray subtype: " + e.constructor.name);
          });
          var r = new Uint8Array(t),
            i = 0;
          return n.forEach(function (e) {
            r.set(new Uint8Array(e.buffer), i), i += e.byteLength;
          }), r.buffer;
        }
        var Rl = void 0 !== o && ("undefined" == typeof Blob || "undefined" == typeof atob || "undefined" == typeof btoa);
        function Il(e) {
          return Rl ? o.byteLength(e) : new Blob([e]).size;
        }
        function jl(e) {
          var t = 0;
          e.forEach(function (e) {
            t += e.byteLength;
          });
          var n = new Uint8Array(t),
            r = 0;
          return e.forEach(function (e) {
            n.set(new Uint8Array(e), r), r += e.byteLength;
          }), n.buffer;
        }
        function Nl(e) {
          for (e = e.trim(); e.endsWith("/");) e = e.slice(0, e.length - 1);
          var t = e.split("/");
          return t[t.length - 1];
        }
        function Ll(e) {
          if (e.modelTopology instanceof ArrayBuffer) throw new Error("Expected JSON model topology, received ArrayBuffer.");
          return {
            dateSaved: new Date(),
            modelTopologyType: "JSON",
            modelTopologyBytes: null == e.modelTopology ? 0 : Il(JSON.stringify(e.modelTopology)),
            weightSpecsBytes: null == e.weightSpecs ? 0 : Il(JSON.stringify(e.weightSpecs)),
            weightDataBytes: null == e.weightData ? 0 : e.weightData.byteLength
          };
        }
        var Dl = function () {
            function e() {
              this.saveRouters = [], this.loadRouters = [];
            }
            return e.getInstance = function () {
              return null == e.instance && (e.instance = new e()), e.instance;
            }, e.registerSaveRouter = function (t) {
              e.getInstance().saveRouters.push(t);
            }, e.registerLoadRouter = function (t) {
              e.getInstance().loadRouters.push(t);
            }, e.getSaveHandlers = function (t) {
              return e.getHandlers(t, "save");
            }, e.getLoadHandlers = function (t) {
              return e.getHandlers(t, "load");
            }, e.getHandlers = function (e, t) {
              var n = [];
              return ("load" === t ? this.getInstance().loadRouters : this.getInstance().saveRouters).forEach(function (t) {
                var r = t(e);
                null !== r && n.push(r);
              }), n;
            }, e;
          }(),
          Bl = function () {
            function e() {
              this.managers = {};
            }
            return e.getInstance = function () {
              return null == e.instance && (e.instance = new e()), e.instance;
            }, e.registerManager = function (t, n) {
              b(null != t, "scheme must not be undefined or null."), t.endsWith("://") && (t = t.slice(0, t.indexOf("://"))), b(t.length > 0, "scheme must not be an empty string.");
              var r = e.getInstance();
              b(null == r.managers[t], "A model store manager is already registered for scheme '" + t + "'."), r.managers[t] = n;
            }, e.getManager = function (e) {
              var t = this.getInstance().managers[e];
              if (null == t) throw new Error("Cannot find model manager for scheme '" + e + "'");
              return t;
            }, e.getSchemes = function () {
              return Object.keys(this.getInstance().managers);
            }, e;
          }();
        function Fl(e) {
          if (-1 === e.indexOf("://")) throw new Error("The url string provided does not contain a scheme. Supported schemes are: " + Bl.getSchemes().join(","));
          return {
            scheme: e.split("://")[0],
            path: e.split("://")[1]
          };
        }
        function zl(e, t, n) {
          return void 0 === n && (n = !1), u(this, void 0, void 0, function () {
            var r, i, o, a, s, l, u, d, h;
            return c(this, function (c) {
              switch (c.label) {
                case 0:
                  return b(e !== t, "Old path and new path are the same: '" + e + "'"), b((r = Dl.getLoadHandlers(e)).length > 0, "Copying failed because no load handler is found for source URL " + e + "."), b(r.length < 2, "Copying failed because more than one (" + r.length + ") load handlers for source URL " + e + "."), i = r[0], b((o = Dl.getSaveHandlers(t)).length > 0, "Copying failed because no save handler is found for destination URL " + t + "."), b(o.length < 2, "Copying failed because more than one (" + r.length + ") save handlers for destination URL " + t + "."), a = o[0], s = Fl(e).scheme, l = Fl(e).path, u = s === Fl(e).scheme, [4, i.load()];
                case 1:
                  return d = c.sent(), n && u ? [4, Bl.getManager(s).removeModel(l)] : [3, 3];
                case 2:
                  c.sent(), c.label = 3;
                case 3:
                  return [4, a.save(d)];
                case 4:
                  return h = c.sent(), !n || u ? [3, 6] : [4, Bl.getManager(s).removeModel(l)];
                case 5:
                  c.sent(), c.label = 6;
                case 6:
                  return [2, h.modelArtifactsInfo];
              }
            });
          });
        }
        function Ul() {
          if (!ve.get("IS_BROWSER")) throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
          var e = window,
            t = e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB || e.shimIndexedDB;
          if (null == t) throw new Error("The current browser does not appear to support IndexedDB.");
          return t;
        }
        function Gl(e) {
          var t = e.result;
          t.createObjectStore("models_store", {
            keyPath: "modelPath"
          }), t.createObjectStore("model_info_store", {
            keyPath: "modelPath"
          });
        }
        var Vl = function () {
            function e(e) {
              if (this.indexedDB = Ul(), null == e || !e) throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");
              this.modelPath = e;
            }
            return e.prototype.save = function (e) {
              return u(this, void 0, void 0, function () {
                return c(this, function (t) {
                  if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
                  return [2, this.databaseAction(this.modelPath, e)];
                });
              });
            }, e.prototype.load = function () {
              return u(this, void 0, void 0, function () {
                return c(this, function (e) {
                  return [2, this.databaseAction(this.modelPath)];
                });
              });
            }, e.prototype.databaseAction = function (e, t) {
              var n = this;
              return new Promise(function (e, r) {
                var i = n.indexedDB.open("tensorflowjs", 1);
                i.onupgradeneeded = function () {
                  return Gl(i);
                }, i.onsuccess = function () {
                  var o = i.result;
                  if (null == t) {
                    var a = o.transaction("models_store", "readonly"),
                      s = a.objectStore("models_store").get(n.modelPath);
                    s.onsuccess = function () {
                      if (null == s.result) return o.close(), r(new Error("Cannot find model with path '" + n.modelPath + "' in IndexedDB."));
                      e(s.result.modelArtifacts);
                    }, s.onerror = function (e) {
                      return o.close(), r(s.error);
                    }, a.oncomplete = function () {
                      return o.close();
                    };
                  } else {
                    var l,
                      u = Ll(t),
                      c = o.transaction("model_info_store", "readwrite"),
                      d = c.objectStore("model_info_store"),
                      h = d.put({
                        modelPath: n.modelPath,
                        modelArtifactsInfo: u
                      });
                    h.onsuccess = function () {
                      var i = (l = o.transaction("models_store", "readwrite")).objectStore("models_store").put({
                        modelPath: n.modelPath,
                        modelArtifacts: t,
                        modelArtifactsInfo: u
                      });
                      i.onsuccess = function () {
                        return e({
                          modelArtifactsInfo: u
                        });
                      }, i.onerror = function (e) {
                        var t = (d = c.objectStore("model_info_store")).delete(n.modelPath);
                        t.onsuccess = function () {
                          return o.close(), r(i.error);
                        }, t.onerror = function (e) {
                          return o.close(), r(i.error);
                        };
                      };
                    }, h.onerror = function (e) {
                      return o.close(), r(h.error);
                    }, c.oncomplete = function () {
                      null == l ? o.close() : l.oncomplete = function () {
                        return o.close();
                      };
                    };
                  }
                }, i.onerror = function (e) {
                  return r(i.error);
                };
              });
            }, e.URL_SCHEME = "indexeddb://", e;
          }(),
          Hl = function Hl(e) {
            return ve.get("IS_BROWSER") && !Array.isArray(e) && e.startsWith(Vl.URL_SCHEME) ? function (e) {
              return new Vl(e);
            }(e.slice(Vl.URL_SCHEME.length)) : null;
          };
        Dl.registerSaveRouter(Hl), Dl.registerLoadRouter(Hl);
        var ql = function () {
          function e() {
            this.indexedDB = Ul();
          }
          return e.prototype.listModels = function () {
            return u(this, void 0, void 0, function () {
              var e = this;
              return c(this, function (t) {
                return [2, new Promise(function (t, n) {
                  var r = e.indexedDB.open("tensorflowjs", 1);
                  r.onupgradeneeded = function () {
                    return Gl(r);
                  }, r.onsuccess = function () {
                    var e = r.result,
                      i = e.transaction("model_info_store", "readonly"),
                      o = i.objectStore("model_info_store").getAll();
                    o.onsuccess = function () {
                      for (var e = {}, n = 0, r = o.result; n < r.length; n++) {
                        var i = r[n];
                        e[i.modelPath] = i.modelArtifactsInfo;
                      }
                      t(e);
                    }, o.onerror = function (t) {
                      return e.close(), n(o.error);
                    }, i.oncomplete = function () {
                      return e.close();
                    };
                  }, r.onerror = function (e) {
                    return n(r.error);
                  };
                })];
              });
            });
          }, e.prototype.removeModel = function (e) {
            return u(this, void 0, void 0, function () {
              var t = this;
              return c(this, function (n) {
                return e = function (e) {
                  return e.startsWith(Vl.URL_SCHEME) ? e.slice(Vl.URL_SCHEME.length) : e;
                }(e), [2, new Promise(function (n, r) {
                  var i = t.indexedDB.open("tensorflowjs", 1);
                  i.onupgradeneeded = function () {
                    return Gl(i);
                  }, i.onsuccess = function () {
                    var t,
                      o = i.result,
                      a = o.transaction("model_info_store", "readwrite"),
                      s = a.objectStore("model_info_store"),
                      l = s.get(e);
                    l.onsuccess = function () {
                      if (null == l.result) return o.close(), r(new Error("Cannot find model with path '" + e + "' in IndexedDB."));
                      var i = s.delete(e),
                        a = function a() {
                          var i = (t = o.transaction("models_store", "readwrite")).objectStore("models_store").delete(e);
                          i.onsuccess = function () {
                            return n(l.result.modelArtifactsInfo);
                          }, i.onerror = function (e) {
                            return r(l.error);
                          };
                        };
                      i.onsuccess = a, i.onerror = function (e) {
                        return a(), o.close(), r(l.error);
                      };
                    }, l.onerror = function (e) {
                      return o.close(), r(l.error);
                    }, a.oncomplete = function () {
                      null == t ? o.close() : t.oncomplete = function () {
                        return o.close();
                      };
                    };
                  }, i.onerror = function (e) {
                    return r(i.error);
                  };
                })];
              });
            });
          }, e;
        }();
        if (ve.get("IS_BROWSER")) try {
          Bl.registerManager(Vl.URL_SCHEME, new ql());
        } catch (se) {}
        var Wl = "tensorflowjs_models",
          $l = "info",
          Xl = "model_topology",
          Yl = "weight_specs",
          Kl = "weight_data";
        function Zl(e) {
          return {
            info: [Wl, e, $l].join("/"),
            topology: [Wl, e, Xl].join("/"),
            weightSpecs: [Wl, e, Yl].join("/"),
            weightData: [Wl, e, Kl].join("/")
          };
        }
        function Ql(e) {
          var t = e.split("/");
          if (t.length < 3) throw new Error("Invalid key format: " + e);
          return t.slice(1, t.length - 1).join("/");
        }
        var Jl = function () {
            function e(e) {
              if (!ve.get("IS_BROWSER") || void 0 === window.localStorage) throw new Error("The current environment does not support local storage.");
              if (this.LS = window.localStorage, null == e || !e) throw new Error("For local storage, modelPath must not be null, undefined or empty.");
              this.modelPath = e, this.keys = Zl(this.modelPath);
            }
            return e.prototype.save = function (e) {
              return u(this, void 0, void 0, function () {
                var t, n, r, i;
                return c(this, function (a) {
                  if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
                  t = JSON.stringify(e.modelTopology), n = JSON.stringify(e.weightSpecs), r = Ll(e);
                  try {
                    return this.LS.setItem(this.keys.info, JSON.stringify(r)), this.LS.setItem(this.keys.topology, t), this.LS.setItem(this.keys.weightSpecs, n), this.LS.setItem(this.keys.weightData, function (e) {
                      return Rl ? o.from(e).toString("base64") : btoa(String.fromCharCode.apply(null, new Uint8Array(e)));
                    }(e.weightData)), [2, {
                      modelArtifactsInfo: r
                    }];
                  } catch (e) {
                    for (i in this.keys) this.LS.removeItem(this.keys[i]);
                    throw new Error("Failed to save model '" + this.modelPath + "' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes=" + r.modelTopologyBytes + ", weightSpecsBytes=" + r.weightSpecsBytes + ", weightDataBytes=" + r.weightDataBytes + ".");
                  }
                  return [2];
                });
              });
            }, e.prototype.load = function () {
              return u(this, void 0, void 0, function () {
                var e, t, n, r, i;
                return c(this, function (a) {
                  if (null == (e = JSON.parse(this.LS.getItem(this.keys.info)))) throw new Error("In local storage, there is no model with name '" + this.modelPath + "'");
                  if ("JSON" !== e.modelTopologyType) throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
                  if (t = {}, null == (n = JSON.parse(this.LS.getItem(this.keys.topology)))) throw new Error("In local storage, the topology of model '" + this.modelPath + "' is missing.");
                  if (t.modelTopology = n, null == (r = JSON.parse(this.LS.getItem(this.keys.weightSpecs)))) throw new Error("In local storage, the weight specs of model '" + this.modelPath + "' are missing.");
                  if (t.weightSpecs = r, null == (i = this.LS.getItem(this.keys.weightData))) throw new Error("In local storage, the binary weight values of model '" + this.modelPath + "' are missing.");
                  return t.weightData = function (e) {
                    if (Rl) {
                      var t = o.from(e, "base64");
                      return t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
                    }
                    for (var n = atob(e), r = new Uint8Array(n.length), i = 0; i < n.length; ++i) r.set([n.charCodeAt(i)], i);
                    return r.buffer;
                  }(i), [2, t];
                });
              });
            }, e.URL_SCHEME = "localstorage://", e;
          }(),
          eu = function eu(e) {
            return ve.get("IS_BROWSER") && !Array.isArray(e) && e.startsWith(Jl.URL_SCHEME) ? function (e) {
              return new Jl(e);
            }(e.slice(Jl.URL_SCHEME.length)) : null;
          };
        Dl.registerSaveRouter(eu), Dl.registerLoadRouter(eu);
        var tu = function () {
          function e() {
            b(ve.get("IS_BROWSER"), "Current environment is not a web browser"), b(void 0 !== window.localStorage, "Current browser does not appear to support localStorage"), this.LS = window.localStorage;
          }
          return e.prototype.listModels = function () {
            return u(this, void 0, void 0, function () {
              var e, t, n, r, i, o;
              return c(this, function (a) {
                for (e = {}, t = Wl + "/", n = "/" + $l, r = 0; r < this.LS.length; ++r) (i = this.LS.key(r)).startsWith(t) && i.endsWith(n) && (o = Ql(i), e[o] = JSON.parse(this.LS.getItem(i)));
                return [2, e];
              });
            });
          }, e.prototype.removeModel = function (e) {
            return u(this, void 0, void 0, function () {
              var t, n;
              return c(this, function (r) {
                if (e = function (e) {
                  return e.startsWith(Jl.URL_SCHEME) ? e.slice(Jl.URL_SCHEME.length) : e;
                }(e), t = Zl(e), null == this.LS.getItem(t.info)) throw new Error("Cannot find model at path '" + e + "'");
                return n = JSON.parse(this.LS.getItem(t.info)), this.LS.removeItem(t.info), this.LS.removeItem(t.topology), this.LS.removeItem(t.weightSpecs), this.LS.removeItem(t.weightData), [2, n];
              });
            });
          }, e;
        }();
        if (ve.get("IS_BROWSER")) try {
          Bl.registerManager(Jl.URL_SCHEME, new tu());
        } catch (se) {}
        var nu = function () {
            function e(t) {
              if (!ve.get("IS_BROWSER")) throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
              t.startsWith(e.URL_SCHEME) && (t = t.slice(e.URL_SCHEME.length)), null != t && 0 !== t.length || (t = "model"), this.modelTopologyFileName = t + ".json", this.weightDataFileName = t + ".weights.bin";
            }
            return e.prototype.save = function (e) {
              return u(this, void 0, void 0, function () {
                var t, n, r, i, o, a;
                return c(this, function (s) {
                  if (t = window.URL.createObjectURL(new Blob([e.weightData], {
                    type: "application/octet-stream"
                  })), e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
                  return n = [{
                    paths: ["./" + this.weightDataFileName],
                    weights: e.weightSpecs
                  }], r = {
                    modelTopology: e.modelTopology,
                    weightsManifest: n
                  }, i = window.URL.createObjectURL(new Blob([JSON.stringify(r)], {
                    type: "application/json"
                  })), (o = null == this.jsonAnchor ? document.createElement("a") : this.jsonAnchor).download = this.modelTopologyFileName, o.href = i, o.click(), null != e.weightData && ((a = null == this.weightDataAnchor ? document.createElement("a") : this.weightDataAnchor).download = this.weightDataFileName, a.href = t, a.click()), [2, {
                    modelArtifactsInfo: Ll(e)
                  }];
                });
              });
            }, e.URL_SCHEME = "downloads://", e;
          }(),
          ru = function () {
            function e(e) {
              if (null == e || e.length < 1) throw new Error("When calling browserFiles, at least 1 file is required, but received " + e);
              this.files = e;
            }
            return e.prototype.load = function () {
              return u(this, void 0, void 0, function () {
                var e,
                  t,
                  n = this;
                return c(this, function (r) {
                  return e = this.files[0], t = this.files.slice(1), [2, new Promise(function (r, i) {
                    var o = new FileReader();
                    o.onload = function (o) {
                      var a = JSON.parse(o.target.result),
                        s = a.modelTopology;
                      if (null != s) {
                        0 === t.length && r({
                          modelTopology: s
                        });
                        var l = a.weightsManifest;
                        if (null != l) {
                          var u;
                          try {
                            u = n.checkManifestAndWeightFiles(l, t);
                          } catch (e) {
                            return void i(e);
                          }
                          var c = [],
                            d = [],
                            h = [];
                          l.forEach(function (e) {
                            e.paths.forEach(function (e) {
                              d.push(e), h.push(null);
                            }), c.push.apply(c, e.weights);
                          }), l.forEach(function (e) {
                            e.paths.forEach(function (e) {
                              var t = new FileReader();
                              t.onload = function (t) {
                                var n = t.target.result,
                                  i = d.indexOf(e);
                                h[i] = n, -1 === h.indexOf(null) && r({
                                  modelTopology: s,
                                  weightSpecs: c,
                                  weightData: jl(h)
                                });
                              }, t.onerror = function (t) {
                                return i("Failed to weights data from file of path '" + e + "'.");
                              }, t.readAsArrayBuffer(u[e]);
                            });
                          });
                        } else i(new Error("weightManifest field is missing from file " + e.name));
                      } else i(new Error("modelTopology field is missing from file " + e.name));
                    }, o.onerror = function (t) {
                      return i("Failed to read model topology and weights manifest JSON from file '" + e.name + "'. BrowserFiles supports loading Keras-style tf.Model artifacts only.");
                    }, o.readAsText(e);
                  })];
                });
              });
            }, e.prototype.checkManifestAndWeightFiles = function (e, t) {
              for (var n = [], r = t.map(function (e) {
                  return Nl(e.name);
                }), i = {}, o = 0, a = e; o < a.length; o++) a[o].paths.forEach(function (e) {
                var o = Nl(e);
                if (-1 !== n.indexOf(o)) throw new Error("Duplicate file basename found in weights manifest: '" + o + "'");
                if (n.push(o), -1 === r.indexOf(o)) throw new Error("Weight file with basename '" + o + "' is not provided.");
                i[e] = t[r.indexOf(o)];
              });
              if (n.length !== t.length) throw new Error("Mismatch in the number of files in weights manifest (" + n.length + ") and the number of weight files provided (" + t.length + ").");
              return i;
            }, e;
          }();
        function iu(e, t) {
          return u(this, void 0, void 0, function () {
            var n, r;
            return c(this, function (i) {
              switch (i.label) {
                case 0:
                  return n = e.map(function (e) {
                    return fetch(e, t);
                  }), [4, Promise.all(n)];
                case 1:
                  return r = i.sent(), [4, Promise.all(r.map(function (e) {
                    return e.arrayBuffer();
                  }))];
                case 2:
                  return [2, i.sent()];
              }
            });
          });
        }
        function ou(e) {
          var t = this;
          return function (n, r, i) {
            return void 0 === r && (r = ""), u(t, void 0, void 0, function () {
              var t, o, a, s, l, u, d, h, f, p;
              return c(this, function (c) {
                switch (c.label) {
                  case 0:
                    if (t = n.map(function () {
                      return !1;
                    }), o = {}, a = null != i ? i.map(function () {
                      return !1;
                    }) : [], s = [], n.forEach(function (e, n) {
                      var r = 0;
                      e.weights.forEach(function (e) {
                        var l = "quantization" in e ? e.quantization.dtype : e.dtype,
                          u = kl[l] * S(e.shape),
                          c = function c() {
                            t[n] = !0, null == o[n] && (o[n] = []), o[n].push({
                              manifestEntry: e,
                              groupOffset: r,
                              sizeBytes: u
                            });
                          };
                        null != i ? i.forEach(function (t, n) {
                          t === e.name && (c(), a[n] = !0);
                        }) : c(), s.push(e.name), r += u;
                      });
                    }), !a.every(function (e) {
                      return e;
                    })) throw l = i.filter(function (e, t) {
                      return !a[t];
                    }), new Error("Could not find weights in manifest with names: " + l.join(", ") + ". \nManifest JSON has weights with names: " + s.join(", ") + ".");
                    return u = t.reduce(function (e, t, n) {
                      return t && e.push(n), e;
                    }, []), d = [], u.forEach(function (e) {
                      n[e].paths.forEach(function (e) {
                        var t = r + (r.endsWith("/") ? "" : "/") + e;
                        d.push(t);
                      });
                    }), [4, e(d)];
                  case 1:
                    return h = c.sent(), f = {}, p = 0, u.forEach(function (e) {
                      for (var t = n[e].paths.length, r = 0, i = 0; i < t; i++) r += h[p + i].byteLength;
                      for (var a = new ArrayBuffer(r), s = new Uint8Array(a), l = 0, u = 0; u < t; u++) {
                        var c = new Uint8Array(h[p + u]);
                        s.set(c, l), l += c.byteLength;
                      }
                      o[e].forEach(function (e) {
                        var t = Pl(a.slice(e.groupOffset, e.groupOffset + e.sizeBytes), [e.manifestEntry]);
                        for (var n in t) f[n] = t[n];
                      }), p += t;
                    }), [2, f];
                }
              });
            });
          };
        }
        Dl.registerSaveRouter(function (e) {
          return ve.get("IS_BROWSER") && !Array.isArray(e) && e.startsWith(nu.URL_SCHEME) ? function (e) {
            return void 0 === e && (e = "model"), new nu(e);
          }(e.slice(nu.URL_SCHEME.length)) : null;
        });
        var au = function () {
          function e(e, t, n) {
            if (this.weightPathPrefix = n, this.DEFAULT_METHOD = "POST", "undefined" == typeof fetch) throw new Error("browserHTTPRequest is not supported outside the web browser without a fetch polyfill.");
            if (b(null != e && e.length > 0, "URL path for browserHTTPRequest must not be null, undefined or empty."), Array.isArray(e) && b(2 === e.length, "URL paths for browserHTTPRequest must have a length of 2, (actual length is " + e.length + ")."), this.path = e, null != t && null != t.body) throw new Error("requestInit is expected to have no pre-existing body, but has one.");
            this.requestInit = t || {};
          }
          return e.prototype.save = function (e) {
            return u(this, void 0, void 0, function () {
              var t, n, r, i;
              return c(this, function (o) {
                switch (o.label) {
                  case 0:
                    if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
                    return (t = Object.assign({
                      method: this.DEFAULT_METHOD
                    }, this.requestInit)).body = new FormData(), n = [{
                      paths: ["./model.weights.bin"],
                      weights: e.weightSpecs
                    }], r = {
                      modelTopology: e.modelTopology,
                      weightsManifest: n
                    }, t.body.append("model.json", new Blob([JSON.stringify(r)], {
                      type: "application/json"
                    }), "model.json"), null != e.weightData && t.body.append("model.weights.bin", new Blob([e.weightData], {
                      type: "application/octet-stream"
                    }), "model.weights.bin"), [4, fetch(this.path, t)];
                  case 1:
                    if ((i = o.sent()).ok) return [2, {
                      modelArtifactsInfo: Ll(e),
                      responses: [i]
                    }];
                    throw new Error("BrowserHTTPRequest.save() failed due to HTTP response status " + i.status + ".");
                }
              });
            });
          }, e.prototype.load = function () {
            return u(this, void 0, void 0, function () {
              return c(this, function (e) {
                return [2, Array.isArray(this.path) ? this.loadBinaryModel() : this.loadJSONModel()];
              });
            });
          }, e.prototype.loadBinaryTopology = function () {
            return u(this, void 0, void 0, function () {
              var e, t;
              return c(this, function (n) {
                switch (n.label) {
                  case 0:
                    return n.trys.push([0, 3,, 4]), [4, fetch(this.path[0], this.requestInit)];
                  case 1:
                    if (!(e = n.sent()).ok) throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: " + e.statusText);
                    return [4, e.arrayBuffer()];
                  case 2:
                    return [2, n.sent()];
                  case 3:
                    throw t = n.sent(), new Error(this.path[0] + " not found. " + t);
                  case 4:
                    return [2];
                }
              });
            });
          }, e.prototype.loadBinaryModel = function () {
            return u(this, void 0, void 0, function () {
              var e, t, n, r, i, o, a, s;
              return c(this, function (l) {
                switch (l.label) {
                  case 0:
                    return e = this.loadBinaryTopology(), [4, fetch(this.path[1], this.requestInit)];
                  case 1:
                    if (!(t = l.sent()).ok) throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: " + t.statusText);
                    return [4, Promise.all([e, t])];
                  case 2:
                    return n = l.sent(), r = n[0], [4, n[1].json()];
                  case 3:
                    return null == (i = l.sent()) ? [3, 5] : [4, this.loadWeights(i)];
                  case 4:
                    s = l.sent(), o = s[0], a = s[1], l.label = 5;
                  case 5:
                    return [2, {
                      modelTopology: r,
                      weightSpecs: o,
                      weightData: a
                    }];
                }
              });
            });
          }, e.prototype.loadJSONModel = function () {
            return u(this, void 0, void 0, function () {
              var e, t, n, r, i, o, a, s;
              return c(this, function (l) {
                switch (l.label) {
                  case 0:
                    return [4, fetch(this.path, this.requestInit)];
                  case 1:
                    if (!(e = l.sent()).ok) throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: " + e.statusText);
                    return [4, e.json()];
                  case 2:
                    if (t = l.sent(), n = t.modelTopology, r = t.weightsManifest, null == n && null == r) throw new Error("The JSON from HTTP path " + this.path + " contains neither model topology or manifest for weights.");
                    return null == r ? [3, 4] : (a = t.weightsManifest, [4, this.loadWeights(a)]);
                  case 3:
                    s = l.sent(), i = s[0], o = s[1], l.label = 4;
                  case 4:
                    return [2, {
                      modelTopology: n,
                      weightSpecs: i,
                      weightData: o
                    }];
                }
              });
            });
          }, e.prototype.loadWeights = function (e) {
            return u(this, void 0, void 0, function () {
              var t, n, r, i, o, a, s, l, u, d, h, f;
              return c(this, function (c) {
                switch (c.label) {
                  case 0:
                    for (t = Array.isArray(this.path) ? this.path[1] : this.path, n = function (e) {
                      var t = e.lastIndexOf("/"),
                        n = e.lastIndexOf("?");
                      return [e.substring(0, t) + "/", n > t ? e.substring(n) : ""];
                    }(t), r = n[0], i = n[1], o = this.weightPathPrefix || r, a = [], s = 0, l = e; s < l.length; s++) u = l[s], a.push.apply(a, u.weights);
                    return d = [], e.forEach(function (e) {
                      e.paths.forEach(function (e) {
                        d.push(o + e + i);
                      });
                    }), h = [a], f = jl, [4, iu(d, this.requestInit)];
                  case 1:
                    return [2, h.concat([f.apply(void 0, [c.sent()])])];
                }
              });
            });
          }, e.URL_SCHEME_REGEX = /^https?:\/\//, e;
        }();
        function su(e) {
          return null != e.match(au.URL_SCHEME_REGEX);
        }
        var lu = function lu(e) {
          return "undefined" == typeof fetch ? null : (Array.isArray(e) ? e.every(function (e) {
            return su(e);
          }) : su(e)) ? uu(e) : null;
        };
        function uu(e, t, n) {
          return new au(e, t, n);
        }
        Dl.registerSaveRouter(lu), Dl.registerLoadRouter(lu);
        var cu = function () {
            function e(e, t, n) {
              this.modelTopology = e, this.weightSpecs = t, this.weightData = n;
            }
            return e.prototype.load = function () {
              return u(this, void 0, void 0, function () {
                var e;
                return c(this, function (t) {
                  return e = {}, null != this.modelTopology && (e = l({
                    modelTopology: this.modelTopology
                  }, e)), null != this.weightSpecs && this.weightSpecs.length > 0 && (e = l({
                    weightSpecs: this.weightSpecs
                  }, e)), null != this.weightData && this.weightData.byteLength > 0 && (e = l({
                    weightData: this.weightData
                  }, e)), [2, e];
                });
              });
            }, e;
          }(),
          du = function () {
            function e(e) {
              this.saveHandler = e;
            }
            return e.prototype.save = function (e) {
              return u(this, void 0, void 0, function () {
                return c(this, function (t) {
                  return [2, this.saveHandler(e)];
                });
              });
            }, e;
          }();
        var hu = Dl.registerSaveRouter,
          fu = Dl.registerLoadRouter,
          pu = Dl.getSaveHandlers,
          mu = Dl.getLoadHandlers,
          gu = Object.freeze({
            browserFiles: function browserFiles(e) {
              return new ru(e);
            },
            browserHTTPRequest: uu,
            concatenateArrayBuffers: jl,
            decodeWeights: Pl,
            encodeWeights: function encodeWeights(e) {
              return u(this, void 0, void 0, function () {
                var t, n, r, i;
                return c(this, function (o) {
                  switch (o.label) {
                    case 0:
                      for (r in t = [], n = [], e) {
                        if ("float32" !== (i = e[r]).dtype && "int32" !== i.dtype && "bool" !== i.dtype) throw new Error("Unsupported dtype in weight '" + r + "': " + i.dtype);
                        t.push({
                          name: r,
                          shape: i.shape,
                          dtype: i.dtype
                        }), n.push(i.data());
                      }
                      return [4, Promise.all(n)];
                    case 1:
                      return [2, {
                        data: Ol(o.sent()),
                        specs: t
                      }];
                  }
                });
              });
            },
            fromMemory: function fromMemory(e, t, n) {
              return new cu(e, t, n);
            },
            getLoadHandlers: mu,
            getModelArtifactsInfoForJSON: Ll,
            getSaveHandlers: pu,
            loadWeights: function loadWeights(e, t, n, r) {
              return void 0 === t && (t = ""), u(this, void 0, void 0, function () {
                return c(this, function (i) {
                  return [2, ou(function (e) {
                    return iu(e, r);
                  })(e, t, n)];
                });
              });
            },
            registerLoadRouter: fu,
            registerSaveRouter: hu,
            weightsLoaderFactory: ou,
            withSaveHandler: function withSaveHandler(e) {
              return new du(e);
            },
            copyModel: function copyModel(e, t) {
              return u(this, void 0, void 0, function () {
                return c(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return [4, zl(e, t, !1)];
                    case 1:
                      return [2, n.sent()];
                  }
                });
              });
            },
            listModels: function listModels() {
              return u(this, void 0, void 0, function () {
                var e, t, n, r, i, o, a;
                return c(this, function (s) {
                  switch (s.label) {
                    case 0:
                      e = Bl.getSchemes(), t = {}, n = 0, r = e, s.label = 1;
                    case 1:
                      return n < r.length ? (i = r[n], [4, Bl.getManager(i).listModels()]) : [3, 4];
                    case 2:
                      for (a in o = s.sent()) t[i + "://" + a] = o[a];
                      s.label = 3;
                    case 3:
                      return n++, [3, 1];
                    case 4:
                      return [2, t];
                  }
                });
              });
            },
            moveModel: function moveModel(e, t) {
              return u(this, void 0, void 0, function () {
                return c(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return [4, zl(e, t, !0)];
                    case 1:
                      return [2, n.sent()];
                  }
                });
              });
            },
            removeModel: function removeModel(e) {
              return u(this, void 0, void 0, function () {
                var t;
                return c(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return t = Fl(e), [4, Bl.getManager(t.scheme).removeModel(t.path)];
                    case 1:
                      return [2, n.sent()];
                  }
                });
              });
            }
          });
        var vu = nt({
            confusionMatrix_: function confusionMatrix_(e, t, n) {
              var r = et(e, "label", "confusionMatrix", "int32"),
                i = et(t, "label", "confusionMatrix", "int32");
              b(null == n || n > 0 && Number.isInteger(n), "If provided, numClasses must be a positive integer, but got " + n), b(1 === r.rank, "Expected the rank of labels to be 1, but got " + r.rank), b(1 === i.rank, "Expected the rank of predictions to be 1, but got " + i.rank), b(r.shape[0] === i.shape[0], "Mismatch in the number of examples: " + r.shape[0] + " vs. " + i.shape[0] + ". Labels and predictions should have the same number of elements."), b(n > 0 && Number.isInteger(n), "numClasses is required to be a positive integer, but got " + n);
              var o = Qi(r.asType("int32"), n),
                a = Qi(i.asType("int32"), n);
              return o.transpose().matMul(a).asType("int32");
            }
          }),
          yu = Object.freeze({
            confusionMatrix: vu
          }),
          bu = function () {
            function e() {}
            return e.prototype.getClassName = function () {
              return this.constructor.className;
            }, e.fromConfig = function (e, t) {
              return new e(t);
            }, e;
          }(),
          _u = function () {
            function e() {
              this.classNameMap = {};
            }
            return e.getMap = function () {
              return null == e.instance && (e.instance = new e()), e.instance;
            }, e.register = function (t) {
              e.getMap().classNameMap[t.className] = [t, t.fromConfig];
            }, e;
          }();
        function xu(e) {
          b(null != e.className, "Class being registered does not have the static className property defined."), b("string" == typeof e.className, "className is required to be a string, but got type " + typeof e.className), b(e.className.length > 0, "Class being registered has an empty-string as its className, which is disallowed."), _u.register(e);
        }
        var wu = Object.freeze({
          Serializable: bu,
          SerializationMap: _u,
          registerClass: xu
        });
        function Su(e, t, n) {
          if (null == n && (n = ve.get("TEST_EPSILON")), e instanceof te || t instanceof te) {
            if (e instanceof te && t instanceof te) {
              if (e.dtype !== t.dtype) throw new Error("Arrays are of different type actual: " + e.dtype + " vs expected: " + t.dtype + ".");
              if (!A(e.shape, t.shape)) throw new Error("Arrays are of different shape actual: " + e.shape + " vs expected: " + t.shape + ".");
            }
          } else {
            var r = e.constructor.name,
              i = t.constructor.name;
            if (r !== i) throw new Error("Arrays are of different type actual: " + r + " vs expected: " + i);
          }
          var o, a;
          if (o = e instanceof te ? e.dataSync() : e, a = t instanceof te ? t.dataSync() : t, o.length !== a.length) throw new Error("Arrays have different lengths actual: " + o.length + " vs expected: " + a.length + ".\nActual:   " + o + ".\nExpected: " + a + ".");
          for (var s = 0; s < a.length; ++s) {
            var l = o[s],
              u = a[s];
            if (!Au(l, Number(u), n)) throw new Error("Arrays differ: actual[" + s + "] = " + l + ", expected[" + s + "] = " + u + ".\nActual:   " + o + ".\nExpected: " + a + ".");
          }
        }
        function Au(e, t, n) {
          return !(!isNaN(e) || !isNaN(t)) || !(isNaN(e) || isNaN(t) || Math.abs(e - t) > n);
        }
        var Eu = Object.freeze({
            WEBGL_ENVS: {
              HAS_WEBGL: !0
            },
            NODE_ENVS: {
              IS_NODE: !0
            },
            CHROME_ENVS: {
              IS_CHROME: !0
            },
            BROWSER_ENVS: {
              IS_BROWSER: !0
            },
            CPU_ENVS: {
              HAS_WEBGL: !1
            },
            BROWSER_CPU_ENVS: {
              BACKEND: "test-cpu"
            },
            ALL_ENVS: {},
            expectArraysClose: Su,
            expectPromiseToFail: function expectPromiseToFail(e, t) {
              e().then(function () {
                return t.fail();
              }, function () {
                return t();
              });
            },
            expectArraysEqual: function expectArraysEqual(e, t) {
              return Su(e, t, 0);
            },
            expectNumbersClose: function expectNumbersClose(e, t, n) {
              if (null == n && (n = ve.get("TEST_EPSILON")), !Au(e, t, n)) throw new Error("Numbers differ: actual === " + e + ", expected === " + t);
            },
            expectValuesInRange: function expectValuesInRange(e, t, n) {
              var r;
              r = e instanceof te ? e.dataSync() : e;
              for (var i = 0; i < r.length; i++) if (r[i] < t || r[i] > n) throw new Error("Value out of range:" + r[i] + " low: " + t + ", high: " + n);
            },
            expectArrayBuffersEqual: function expectArrayBuffersEqual(e, t) {
              expect(new Float32Array(e)).toEqual(new Float32Array(t));
            }
          }),
          Tu = "0.13.12",
          Mu = Object.freeze({
            gpgpu_util: Hr,
            webgl_util: Sr,
            MathBackendWebGL: vo,
            GPGPUContext: qr
          }),
          Cu = function (e) {
            function t() {
              return null !== e && e.apply(this, arguments) || this;
            }
            return s(t, e), t.prototype.minimize = function (e, t, n) {
              void 0 === t && (t = !1);
              var r = this.computeGradients(e, n),
                i = r.value,
                o = r.grads;
              return this.applyGradients(o), Object.keys(o).forEach(function (e) {
                return o[e].dispose();
              }), t ? i : (i.dispose(), null);
            }, t.prototype.computeGradients = function (e, t) {
              return Se(e, t);
            }, t;
          }(bu),
          ku = function (e) {
            function t(t, n, r) {
              void 0 === r && (r = null);
              var i = e.call(this) || this;
              return i.learningRate = t, i.rho = n, i.epsilon = r, i.accumulatedGrads = {}, i.accumulatedUpdates = {}, i.c = Me(ut(-t)), i.rhoScalar = Me(ut(n)), i.oneMinusRho = Me(ut(1 - n)), null === r && (r = ve.get("EPSILON")), i.epsilonScalar = Me(ut(r)), i;
            }
            return s(t, e), t.prototype.applyGradients = function (e) {
              var t = this,
                n = function n(_n3) {
                  var i = ve.engine.registeredVariables[_n3];
                  null == r.accumulatedGrads[_n3] && Te(function () {
                    t.accumulatedGrads[_n3] = Ct(i).variable(!1);
                  }), null == r.accumulatedUpdates[_n3] && Te(function () {
                    t.accumulatedUpdates[_n3] = Ct(i).variable(!1);
                  });
                  var o = e[_n3],
                    a = r.accumulatedGrads[_n3],
                    s = r.accumulatedUpdates[_n3];
                  Te(function () {
                    var e = t.rhoScalar.mul(a).add(t.oneMinusRho.mul(o.square())),
                      r = s.add(t.epsilonScalar).sqrt().div(a.add(t.epsilonScalar).sqrt()).mul(o),
                      l = t.rhoScalar.mul(s).add(t.oneMinusRho.mul(r.square()));
                    t.accumulatedGrads[_n3].assign(e), t.accumulatedUpdates[_n3].assign(l);
                    var u = t.c.mul(r).add(i);
                    i.assign(u);
                  });
                },
                r = this;
              for (var i in e) n(i);
            }, t.prototype.dispose = function () {
              var e = this;
              this.c.dispose(), this.epsilonScalar.dispose(), this.rhoScalar.dispose(), this.oneMinusRho.dispose(), null != this.accumulatedUpdates && (Object.keys(this.accumulatedUpdates).forEach(function (t) {
                return e.accumulatedUpdates[t].dispose();
              }), Object.keys(this.accumulatedGrads).forEach(function (t) {
                return e.accumulatedGrads[t].dispose();
              }));
            }, t.prototype.getConfig = function () {
              return {
                learningRate: this.learningRate,
                rho: this.rho,
                epsilon: this.epsilon
              };
            }, t.fromConfig = function (e, t) {
              return new e(t.learningRate, t.rho, t.epsilon);
            }, t.className = "AdadeltaOptimizer", t;
          }(Cu);
        xu(ku);
        var Pu = function (e) {
          function t(t, n) {
            void 0 === n && (n = .1);
            var r = e.call(this) || this;
            return r.learningRate = t, r.initialAccumulatorValue = n, r.accumulatedGrads = {}, r.c = Me(ut(-t)), r.epsilon = Me(ut(ve.get("EPSILON"))), r;
          }
          return s(t, e), t.prototype.applyGradients = function (e) {
            var t = this,
              n = function n(_n4) {
                var i = ve.engine.registeredVariables[_n4];
                null == r.accumulatedGrads[_n4] && Te(function () {
                  t.accumulatedGrads[_n4] = yt(i.shape, t.initialAccumulatorValue).variable(!1);
                });
                var o = e[_n4],
                  a = r.accumulatedGrads[_n4];
                Te(function () {
                  var e = a.add(o.square());
                  t.accumulatedGrads[_n4].assign(e);
                  var r = t.c.mul(o.div(e.add(t.epsilon).sqrt())).add(i);
                  i.assign(r);
                });
              },
              r = this;
            for (var i in e) n(i);
          }, t.prototype.dispose = function () {
            var e = this;
            this.epsilon.dispose(), this.c.dispose(), null != this.accumulatedGrads && Object.keys(this.accumulatedGrads).forEach(function (t) {
              return e.accumulatedGrads[t].dispose();
            });
          }, t.prototype.getConfig = function () {
            return {
              learningRate: this.learningRate,
              initialAccumulatorValue: this.initialAccumulatorValue
            };
          }, t.fromConfig = function (e, t) {
            return new e(t.learningRate, t.initialAccumulatorValue);
          }, t.className = "AdagradOptimizer", t;
        }(Cu);
        xu(Pu);
        var Ou = function (e) {
          function t(t, n, r, i) {
            void 0 === i && (i = null);
            var o = e.call(this) || this;
            return o.learningRate = t, o.beta1 = n, o.beta2 = r, o.epsilon = i, o.accumulatedFirstMoment = {}, o.accumulatedSecondMoment = {}, o.c = Me(ut(-t)), o.beta1Scalar = Me(ut(n)), o.beta2Scalar = Me(ut(r)), Te(function () {
              o.accBeta1 = ut(n).variable(), o.accBeta2 = ut(r).variable();
            }), o.oneMinusBeta1 = Me(ut(1 - n)), o.oneMinusBeta2 = Me(ut(1 - r)), o.one = Me(ut(1)), null === i && (i = ve.get("EPSILON")), o.epsScalar = Me(ut(i)), o;
          }
          return s(t, e), t.prototype.applyGradients = function (e) {
            var t = this;
            Te(function () {
              var n = t.one.sub(t.accBeta1),
                r = t.one.sub(t.accBeta2);
              for (var i in e) {
                var o = ve.engine.registeredVariables[i];
                if (null == t.accumulatedFirstMoment[i]) {
                  var a = !1;
                  t.accumulatedFirstMoment[i] = Ct(o).variable(a);
                }
                null == t.accumulatedSecondMoment[i] && (a = !1, t.accumulatedSecondMoment[i] = Ct(o).variable(a));
                var s = e[i],
                  l = t.accumulatedFirstMoment[i],
                  u = t.accumulatedSecondMoment[i],
                  c = t.beta1Scalar.mul(l).add(t.oneMinusBeta1.mul(s)),
                  d = t.beta2Scalar.mul(u).add(t.oneMinusBeta2.mul(s.square())),
                  h = c.div(n),
                  f = d.div(r);
                t.accumulatedFirstMoment[i].assign(c), t.accumulatedSecondMoment[i].assign(d);
                var p = t.c.mul(h.div(t.epsScalar.add(f.sqrt()))).add(o);
                o.assign(p);
              }
              t.accBeta1.assign(t.accBeta1.mul(t.beta1Scalar)), t.accBeta2.assign(t.accBeta2.mul(t.beta2Scalar));
            });
          }, t.prototype.dispose = function () {
            var e = this;
            this.c.dispose(), this.epsScalar.dispose(), this.beta1Scalar.dispose(), this.beta2Scalar.dispose(), this.accBeta1.dispose(), this.accBeta2.dispose(), this.oneMinusBeta1.dispose(), this.oneMinusBeta2.dispose(), this.one.dispose(), null != this.accumulatedFirstMoment && Object.keys(this.accumulatedFirstMoment).forEach(function (t) {
              return e.accumulatedFirstMoment[t].dispose();
            }), null != this.accumulatedSecondMoment && Object.keys(this.accumulatedSecondMoment).forEach(function (t) {
              return e.accumulatedSecondMoment[t].dispose();
            });
          }, t.prototype.getConfig = function () {
            return {
              learningRate: this.learningRate,
              beta1: this.beta1,
              beta2: this.beta2,
              epsilon: this.epsilon
            };
          }, t.fromConfig = function (e, t) {
            return new e(t.learningRate, t.beta1, t.beta2, t.epsilon);
          }, t.className = "AdamOptimizer", t;
        }(Cu);
        xu(Ou);
        var Ru = function (e) {
          function t(t, n, r, i, o) {
            void 0 === i && (i = null), void 0 === o && (o = 0);
            var a = e.call(this) || this;
            return a.learningRate = t, a.beta1 = n, a.beta2 = r, a.epsilon = i, a.decay = o, a.accumulatedFirstMoment = {}, a.accumulatedWeightedInfNorm = {}, a.c = Me(ut(-t)), a.beta1Scalar = Me(ut(n)), a.beta2Scalar = Me(ut(r)), a.decayScalar = Me(ut(o)), Te(function () {
              a.iteration = ut(0).variable(), a.accBeta1 = ut(n).variable();
            }), a.oneMinusBeta1 = Me(ut(1 - n)), a.one = Me(ut(1)), null === i && (i = ve.get("EPSILON")), a.epsScalar = Me(ut(i)), a;
          }
          return s(t, e), t.prototype.applyGradients = function (e) {
            var t = this;
            Te(function () {
              var n = t.one.sub(t.accBeta1),
                r = t.c.div(t.one.add(t.decayScalar.mul(t.iteration)));
              for (var i in e) {
                var o = ve.engine.registeredVariables[i];
                if (null == t.accumulatedFirstMoment[i]) {
                  var a = !1;
                  t.accumulatedFirstMoment[i] = Ct(o).variable(a);
                }
                null == t.accumulatedWeightedInfNorm[i] && (a = !1, t.accumulatedWeightedInfNorm[i] = Ct(o).variable(a));
                var s = e[i],
                  l = t.accumulatedFirstMoment[i],
                  u = t.accumulatedWeightedInfNorm[i],
                  c = t.beta1Scalar.mul(l).add(t.oneMinusBeta1.mul(s)),
                  d = t.beta2Scalar.mul(u),
                  h = s.abs(),
                  f = d.maximum(h);
                t.accumulatedFirstMoment[i].assign(c), t.accumulatedWeightedInfNorm[i].assign(f);
                var p = r.div(n).mul(c.div(t.epsScalar.add(f))).add(o);
                o.assign(p);
              }
              t.iteration.assign(t.iteration.add(t.one)), t.accBeta1.assign(t.accBeta1.mul(t.beta1Scalar));
            });
          }, t.prototype.dispose = function () {
            var e = this;
            this.c.dispose(), this.epsScalar.dispose(), this.accBeta1.dispose(), this.beta1Scalar.dispose(), this.beta2Scalar.dispose(), this.oneMinusBeta1.dispose(), this.decayScalar.dispose(), this.iteration.dispose(), this.one.dispose(), null != this.accumulatedFirstMoment && Object.keys(this.accumulatedFirstMoment).forEach(function (t) {
              return e.accumulatedFirstMoment[t].dispose();
            }), null != this.accumulatedWeightedInfNorm && Object.keys(this.accumulatedWeightedInfNorm).forEach(function (t) {
              return e.accumulatedWeightedInfNorm[t].dispose();
            });
          }, t.prototype.getConfig = function () {
            return {
              learningRate: this.learningRate,
              beta1: this.beta1,
              beta2: this.beta2,
              epsilon: this.epsilon,
              decay: this.decay
            };
          }, t.fromConfig = function (e, t) {
            return new e(t.learningRate, t.beta1, t.beta2, t.epsilon, t.decay);
          }, t.className = "AdamaxOptimizer", t;
        }(Cu);
        xu(Ru);
        var Iu = function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return n.learningRate = t, n.setLearningRate(t), n;
          }
          return s(t, e), t.prototype.applyGradients = function (e) {
            var t = this;
            Object.keys(e).forEach(function (n) {
              var r = e[n],
                i = ve.engine.registeredVariables[n];
              Te(function () {
                var e = t.c.mul(r).add(i);
                i.assign(e);
              });
            });
          }, t.prototype.setLearningRate = function (e) {
            this.learningRate = e, null != this.c && this.c.dispose(), this.c = Me(ut(-e));
          }, t.prototype.dispose = function () {
            this.c.dispose();
          }, t.prototype.getConfig = function () {
            return {
              learningRate: this.learningRate
            };
          }, t.fromConfig = function (e, t) {
            return new e(t.learningRate);
          }, t.className = "SGDOptimizer", t;
        }(Cu);
        xu(Iu);
        var ju = function (e) {
          function t(t, n, r) {
            void 0 === r && (r = !1);
            var i = e.call(this, t) || this;
            return i.learningRate = t, i.momentum = n, i.useNesterov = r, i.m = ut(i.momentum), i.accumulations = {}, i;
          }
          return s(t, e), t.prototype.applyGradients = function (e) {
            var t = this,
              n = function n(_n5) {
                var i = ve.engine.registeredVariables[_n5];
                null == r.accumulations[_n5] && Te(function () {
                  t.accumulations[_n5] = Ct(i).variable(!1);
                });
                var o = r.accumulations[_n5],
                  a = e[_n5];
                Te(function () {
                  var e,
                    r = t.m.mul(o).add(a);
                  e = t.useNesterov ? t.c.mul(a.add(r.mul(t.m))).add(i) : t.c.mul(r).add(i), t.accumulations[_n5].assign(r), i.assign(e);
                });
              },
              r = this;
            for (var i in e) n(i);
          }, t.prototype.dispose = function () {
            if (e.prototype.dispose.call(this), this.m.dispose(), null != this.accumulations) for (var t in this.accumulations) this.accumulations[t].dispose();
          }, t.prototype.setMomentum = function (e) {
            this.momentum = e;
          }, t.prototype.getConfig = function () {
            return {
              learningRate: this.learningRate,
              momentum: this.momentum,
              useNesterov: this.useNesterov
            };
          }, t.fromConfig = function (e, t) {
            return new e(t.learningRate, t.momentum, t.useNesterov);
          }, t.className = "MomentumOptimizer", t;
        }(Iu);
        xu(ju);
        var Nu = function (e) {
          function t(t, n, r, i, o) {
            void 0 === n && (n = .9), void 0 === r && (r = 0), void 0 === i && (i = null), void 0 === o && (o = !1);
            var a = e.call(this) || this;
            return a.learningRate = t, a.decay = n, a.momentum = r, a.epsilon = i, a.accumulatedMeanSquares = {}, a.accumulatedMeanGrads = {}, a.accumulatedMoments = {}, a.c = Me(ut(t)), a.decayScalar = Me(ut(n)), a.momentumScalar = Me(ut(r)), a.oneMinusDecay = Me(ut(1 - n)), a.centered = o, null === i && (i = ve.get("EPSILON")), a.epsilonScalar = Me(ut(i)), a;
          }
          return s(t, e), t.prototype.applyGradients = function (e) {
            var t = this,
              n = function n(_n6) {
                var i = ve.engine.registeredVariables[_n6];
                null == r.accumulatedMeanSquares[_n6] && Te(function () {
                  t.accumulatedMeanSquares[_n6] = Ct(i).variable(!1);
                }), null == r.accumulatedMeanGrads[_n6] && r.centered && Te(function () {
                  t.accumulatedMeanGrads[_n6] = Ct(i).variable(!1);
                }), null == r.accumulatedMoments[_n6] && Te(function () {
                  t.accumulatedMoments[_n6] = Ct(i).variable(!1);
                });
                var o = r.accumulatedMeanSquares[_n6],
                  a = r.accumulatedMeanGrads[_n6],
                  s = r.accumulatedMoments[_n6],
                  l = e[_n6];
                Te(function () {
                  var e = t.decayScalar.mul(o).add(t.oneMinusDecay.mul(l.square()));
                  if (t.centered) {
                    var r = t.decayScalar.mul(a).add(t.oneMinusDecay.mul(l)),
                      u = t.momentumScalar.mul(s).add(t.c.mul(l).div(e.sub(r.square().add(t.epsilonScalar)).sqrt()));
                    t.accumulatedMeanSquares[_n6].assign(e), t.accumulatedMeanGrads[_n6].assign(r), t.accumulatedMoments[_n6].assign(u);
                    var c = i.sub(u);
                    i.assign(c);
                  } else {
                    var d = t.decayScalar.mul(o).add(t.oneMinusDecay.mul(l.square()));
                    u = t.momentumScalar.mul(s).add(t.c.mul(l).div(d.add(t.epsilonScalar).sqrt())), t.accumulatedMeanSquares[_n6].assign(d), t.accumulatedMoments[_n6].assign(u), c = i.sub(u), i.assign(c);
                  }
                });
              },
              r = this;
            for (var i in e) n(i);
          }, t.prototype.dispose = function () {
            var e = this;
            this.c.dispose(), this.epsilonScalar.dispose(), this.decayScalar.dispose(), this.momentumScalar.dispose(), this.oneMinusDecay.dispose(), null != this.accumulatedMeanSquares && Object.keys(this.accumulatedMeanSquares).forEach(function (t) {
              return e.accumulatedMeanSquares[t].dispose();
            }), null != this.accumulatedMeanGrads && this.centered && Object.keys(this.accumulatedMeanGrads).forEach(function (t) {
              return e.accumulatedMeanGrads[t].dispose();
            }), null != this.accumulatedMoments && Object.keys(this.accumulatedMoments).forEach(function (t) {
              return e.accumulatedMoments[t].dispose();
            });
          }, t.prototype.getConfig = function () {
            return {
              learningRate: this.learningRate,
              decay: this.decay,
              momentum: this.momentum,
              epsilon: this.epsilon,
              centered: this.centered
            };
          }, t.fromConfig = function (e, t) {
            return new e(t.learningRate, t.decay, t.momentum, t.epsilon, t.centered);
          }, t.className = "RMSPropOptimizer", t;
        }(Cu);
        xu(Nu);
        var Lu = function () {
            function e() {}
            return e.sgd = function (e) {
              return new Iu(e);
            }, e.momentum = function (e, t, n) {
              return void 0 === n && (n = !1), new ju(e, t, n);
            }, e.rmsprop = function (e, t, n, r, i) {
              return void 0 === t && (t = .9), void 0 === n && (n = 0), void 0 === r && (r = null), void 0 === i && (i = !1), new Nu(e, t, n, r, i);
            }, e.adam = function (e, t, n, r) {
              return void 0 === e && (e = .001), void 0 === t && (t = .9), void 0 === n && (n = .999), void 0 === r && (r = null), new Ou(e, t, n, r);
            }, e.adadelta = function (e, t, n) {
              return void 0 === e && (e = .001), void 0 === t && (t = .95), void 0 === n && (n = null), new ku(e, t, n);
            }, e.adamax = function (e, t, n, r, i) {
              return void 0 === e && (e = .002), void 0 === t && (t = .9), void 0 === n && (n = .999), void 0 === r && (r = null), void 0 === i && (i = 0), new Ru(e, t, n, r, i);
            }, e.adagrad = function (e, t) {
              return void 0 === t && (t = .1), new Pu(e, t);
            }, e;
          }(),
          Du = {
            sgd: Lu.sgd,
            momentum: Lu.momentum,
            adadelta: Lu.adadelta,
            adagrad: Lu.adagrad,
            rmsprop: Lu.rmsprop,
            adamax: Lu.adamax,
            adam: Lu.adam
          },
          Bu = ge.setBackend,
          Fu = ge.getBackend,
          zu = ge.disposeVariables,
          Uu = ge.memory;
        !function (e) {
          J = e;
        }(El);
      }.call(this, n("./node_modules/process/browser.js"), n("./node_modules/webpack/buildin/global.js"), n("./node_modules/timers-browserify/main.js").setImmediate, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist-es6/index.js": function node_modulesTensorflowTfjsTsneDistEs6IndexJs(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "KNNEstimator", function () {
        return b;
      }), n.d(t, "maximumPerplexity", function () {
        return C;
      }), n.d(t, "tsne", function () {
        return k;
      }), n.d(t, "TSNEOptimizer", function () {
        return E;
      });
      var r = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js");
      function i(e, t, n) {
        var i = r.webgl.webgl_util.createVertexShader(e, t),
          o = r.webgl.webgl_util.createFragmentShader(e, n),
          a = r.webgl.webgl_util.createProgram(e);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.attachShader(a, i);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.attachShader(a, o);
        }), r.webgl.webgl_util.linkProgram(e, a), r.webgl.webgl_util.validateProgram(e, a), a;
      }
      function o(e, t, n, i, o) {
        r.webgl.webgl_util.validateTextureSize(e, t, n);
        var a = r.webgl.webgl_util.createTexture(e),
          c = e.TEXTURE_2D,
          d = s(e, i),
          h = l(e, i);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(c, a);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MIN_FILTER, e.LINEAR);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MAG_FILTER, e.LINEAR);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texImage2D(c, 0, d, t, n, 0, h, u(e), o);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(e.TEXTURE_2D, null);
        }), a;
      }
      function a(e, t, n, i, o) {
        r.webgl.webgl_util.validateTextureSize(e, t, n);
        var a = r.webgl.webgl_util.createTexture(e),
          c = e.TEXTURE_2D,
          d = s(e, i),
          h = l(e, i);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(c, a);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MIN_FILTER, e.NEAREST);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MAG_FILTER, e.NEAREST);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texImage2D(c, 0, d, t, n, 0, h, u(e), o);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(e.TEXTURE_2D, null);
        }), a;
      }
      function s(e, t) {
        return 4 === t ? e.RGBA32F : 3 === t ? e.RGB32F : 2 === t ? e.RG32F : e.R32F;
      }
      function l(e, t) {
        return 4 === t ? e.RGBA : 3 === t ? e.RGB : 2 === t ? e.RG : e.RED;
      }
      function u(e) {
        return e.FLOAT;
      }
      function c(e, t) {
        return "#version 300 es\n    precision highp float;\n    uniform sampler2D data_tex;\n    uniform float num_points;\n    uniform float points_per_row_knn;\n    uniform float num_rows_knn;\n    uniform float num_neighs;\n    uniform float iteration;\n\n    #define NUM_PACKED_NEIGHBORS " + t / 4 + "\n\n    flat in vec4 knn[NUM_PACKED_NEIGHBORS];\n    flat in int point_id;\n    in float neighbor_id;\n\n    const float MAX_DIST = 10e30;\n\n    " + e + "\n\n    out vec4 fragmentColor;\n    void main() {\n      int id = int(neighbor_id/4.);\n      int channel = int(mod(neighbor_id,4.)+0.1);\n\n      if(channel == 0) {\n        fragmentColor = vec4(knn[id].r,0,0,1);\n      }else if(channel == 1) {\n        fragmentColor = vec4(knn[id].g,0,0,1);\n      }else if(channel == 2) {\n        fragmentColor = vec4(knn[id].b,0,0,1);\n      }else if(channel == 3) {\n        fragmentColor = vec4(knn[id].a,0,0,1);\n      }\n\n      //If the neighbor has a valid id i compute the distance squared\n      //otherwise I set it to invalid\n      if(fragmentColor.r >= 0.) {\n        fragmentColor.g = pointDistanceSquared(int(fragmentColor.r),point_id);\n      }else{\n        fragmentColor.g = MAX_DIST;\n      }\n    }\n  ";
      }
      function d(e) {
        return "\n  precision highp float;\n  #define NEIGH_PER_ITER 20\n  #define NUM_NEIGHBORS " + e + "\n  #define NUM_NEIGHBORS_FLOAT " + e + ".\n  #define NUM_PACKED_NEIGHBORS " + e / 4 + "\n  #define MAX_DIST 10e30\n\n  //attributes\n  in float vertex_id;\n  //uniforms\n  uniform sampler2D data_tex;\n  uniform sampler2D starting_knn_tex;\n  uniform float num_points;\n  uniform float points_per_row_knn;\n  uniform float num_rows_knn;\n  uniform float num_neighs;\n  uniform float iteration;\n\n  //output\n  //the indices are packed in varying vectors\n  flat out vec4 knn[NUM_PACKED_NEIGHBORS];\n  //used to recover the neighbor id in the fragment shader\n  out float neighbor_id;\n  //used to recover the point id in the fragment shader\n  //(for recomputing distances)\n  flat out int point_id;\n\n  float distances_heap[NUM_NEIGHBORS];\n  int knn_heap[NUM_NEIGHBORS];\n  ";
      }
      var h = "\n//Random function developed by Inigo Quilez\n//https://www.shadertoy.com/view/llGSzw\nfloat hash1( uint n ) {\n    // integer hash copied from Hugo Elias\n\t  n = (n << 13U) ^ n;\n    n = n * (n * n * 15731U + 789221U) + 1376312589U;\n    return float( n & uvec3(0x7fffffffU))/float(0x7fffffff);\n}\n\nuint hash( uint x ) {\n    x += ( x << 10u );\n    x ^= ( x >>  6u );\n    x += ( x <<  3u );\n    x ^= ( x >> 11u );\n    x += ( x << 15u );\n    return x;\n}\nfloat random( float f ) {\n    const uint mantissaMask = 0x007FFFFFu;\n    const uint one          = 0x3F800000u;\n\n    uint h = hash( floatBitsToUint( f ) );\n    h &= mantissaMask;\n    h |= one;\n\n    float  r2 = uintBitsToFloat( h );\n    return r2 - 1.0;\n}\n\n\n// #define HASHSCALE1 .1031\n// float random(float p) {\n// \tvec3 p3  = fract(vec3(p) * HASHSCALE1);\n//   p3 += dot(p3, p3.yzx + 19.19);\n//   return fract((p3.x + p3.y) * p3.z);\n// }\n\n// const vec2 randomConst = vec2(\n//   23.14069263277926, // e^pi (Gelfond's constant)\n//    2.665144142690225 // 2^sqrt(2) (Gelfond–Schneider constant)\n// );\n// float random(float seed) {\n//     return fract(cos(dot(vec2(seed,seed), randomConst)) * 12345.6789);\n// }\n\n",
        f = "\n//Reads the distances and indices from the knn texture\nvoid initializeDistances(int pnt_id) {\n  //row coordinate in the texture\n  float row = (floor(float(pnt_id)/points_per_row_knn)+0.5)/num_rows_knn;\n  //column of the first neighbor\n  float start_col = mod(float(pnt_id),points_per_row_knn)*NUM_NEIGHBORS_FLOAT;\n  for(int n = 0; n < NUM_NEIGHBORS; n++) {\n    float col = (start_col+float(n)+0.5);\n    //normalized by the width of the texture\n    col /= (points_per_row_knn*NUM_NEIGHBORS_FLOAT);\n    //reads the index in the red channel and the distances in the green one\n    vec4 init = texture(starting_knn_tex,vec2(col,row));\n\n    knn_heap[n] = int(init.r);\n    distances_heap[n] = init.g;\n  }\n}\n",
        p = "\n//Swaps two points in the knn-heap\nvoid swap(int i, int j) {\n  float swap_value = distances_heap[i];\n  distances_heap[i] = distances_heap[j];\n  distances_heap[j] = swap_value;\n  int swap_id = knn_heap[i];\n  knn_heap[i] = knn_heap[j];\n  knn_heap[j] = swap_id;\n}\n\n//I can make use of the heap property but\n//I have to implement a recursive function\nbool inTheHeap(float dist_sq, int id) {\n  for(int i = 0; i < NUM_NEIGHBORS; ++i) {\n    if(knn_heap[i] == id) {\n      return true;\n    }\n  }\n  return false;\n}\n\nvoid insertInKNN(float dist_sq, int j) {\n  //not in the KNN\n  if(dist_sq >= distances_heap[0]) {\n    return;\n  }\n\n  //the point is already in the KNN\n  if(inTheHeap(dist_sq,j)) {\n    return;\n  }\n\n  //Insert in the new point in the root\n  distances_heap[0] = dist_sq;\n  knn_heap[0] = j;\n  //Sink procedure\n  int swap_id = 0;\n  while(swap_id*2+1 < NUM_NEIGHBORS) {\n    int left_id = swap_id*2+1;\n    int right_id = swap_id*2+2;\n    if(distances_heap[left_id] > distances_heap[swap_id] ||\n        (right_id < NUM_NEIGHBORS &&\n                            distances_heap[right_id] > distances_heap[swap_id])\n      ) {\n      if(distances_heap[left_id] > distances_heap[right_id]\n         || right_id >= NUM_NEIGHBORS) {\n        swap(swap_id,left_id);\n        swap_id = left_id;\n      }else{\n        swap(swap_id,right_id);\n        swap_id = right_id;\n      }\n    }else{\n      break;\n    }\n  }\n}\n",
        m = "\n  //Line positions\n  float row = (floor(float(point_id)/points_per_row_knn)+0.5)/num_rows_knn;\n  row = row*2.0-1.0;\n  if(line_id < int(1)) {\n    //for the first vertex only the position is important\n    float col = (mod(float(point_id),points_per_row_knn))/(points_per_row_knn);\n    col = col*2.0-1.0;\n    gl_Position = vec4(col,row,0,1);\n    neighbor_id = 0.;\n    return;\n  }\n  //The computation of the KNN happens only for the second vertex\n  float col = (mod(float(point_id),points_per_row_knn)+1.)/(points_per_row_knn);\n  col = col*2.0-1.0;\n  gl_Position = vec4(col,row,0,1);\n";
      function g(e, t, n, i, o, a, s, l) {
        var u = e.gl,
          c = e.program,
          d = u.getParameter(u.LINE_WIDTH);
        null != l ? e.setOutputMatrixTexture(l, a.numRows, a.pointsPerRow * a.pixelsPerPoint) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), 1 !== d && u.lineWidth(1), e.setProgram(t), u.clearColor(0, 0, 0, 0), u.clear(u.COLOR_BUFFER_BIT), r.webgl.webgl_util.callAndCheck(u, function () {
          return u.bindBuffer(u.ARRAY_BUFFER, s);
        }), r.webgl.webgl_util.bindVertexBufferToProgramAttribute(u, t, "vertex_id", s, 1, 0, 0);
        var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "data_tex");
        e.setInputMatrixTexture(n, h, 0);
        var f = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "starting_knn_tex");
        e.setInputMatrixTexture(i, f, 1);
        var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "iteration");
        u.uniform1f(p, o);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "num_points");
        u.uniform1f(m, a.numPoints);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "points_per_row_knn");
        u.uniform1f(g, a.pointsPerRow);
        var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "num_rows_knn");
        u.uniform1f(v, a.numRows), r.webgl.webgl_util.callAndCheck(u, function () {
          return u.drawArrays(u.LINES, 0, 2 * a.numPoints);
        }), null != c && (e.setProgram(c), r.webgl.gpgpu_util.bindVertexProgramAttributeStreams(e.gl, c, e.vertexBuffer)), 1 !== d && u.lineWidth(d);
      }
      function v(e) {
        return e.createProgram("\n    precision highp float;\n    uniform sampler2D knn_tex;\n    uniform float width;\n    uniform float height;\n\n    void main() {\n      vec2 coordinates = gl_FragCoord.xy / vec2(width,height);\n      float id = texture2D(knn_tex,coordinates).r;\n      gl_FragColor = vec4(id,0,0,1);\n\n      if(id < 0.) {\n        gl_FragColor.b = 1.;\n      }\n    }\n  ");
      }
      function y(e, t, n, i, o) {
        var a = e.gl;
        null != o ? e.setOutputMatrixTexture(o, i.numRows, i.pointsPerRow * i.pixelsPerPoint) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var s = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "knn_tex");
        e.setInputMatrixTexture(n, s, 0);
        var l = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "width");
        a.uniform1f(l, i.pointsPerRow * i.pixelsPerPoint);
        var u = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "height");
        a.uniform1f(u, i.numRows), e.executeProgram();
      }
      var b = function () {
          function e(e, t, n, i, o, a) {
            if (null != a ? this.verbose = a : a = !1, this.backend = r.ENV.findBackend("webgl"), this.gpgpu = this.backend.getGPGPUContext(), this._iteration = 0, this.dataTexture = e, o > 128) throw new Error("kNN size must not be greater than 128");
            if (o % 4 != 0) throw new Error("kNN size must be a multiple of 4");
            this.numNeighs = o;
            var s,
              l,
              u,
              c = Math.ceil(Math.sqrt(o * n) / o);
            if (this.knnDataShape = {
              numPoints: n,
              pixelsPerPoint: o,
              pointsPerRow: c,
              numRows: Math.ceil(n / c)
            }, this.log("knn-pntsPerRow", this.knnDataShape.pointsPerRow), this.log("knn-numRows", this.knnDataShape.numRows), this.log("knn-pixelsPerPoint", this.knnDataShape.pixelsPerPoint), "numPoints" in (u = t) && "pointsPerRow" in u && "pixelsPerPoint" in u && "numRows" in u) s = "\n    #define DATA_NUM_PACKED_DIMENSIONS " + (l = t).pixelsPerPoint + ".\n    #define DATA_POINTS_PER_ROW " + l.pointsPerRow + ".\n    #define DATA_NUM_ROWS " + l.numRows + ".\n    #define TEXTURE_WIDTH " + l.pointsPerRow * l.pixelsPerPoint + ".\n\n    //returns the texture coordinate for point/dimension\n    vec2 dataTexCoordinates(int id, int dimension) {\n      float id_f = float(id);\n      float row = (floor(id_f/DATA_POINTS_PER_ROW)+0.5) / DATA_NUM_ROWS;\n      float col = ((mod(id_f,DATA_POINTS_PER_ROW)*(DATA_NUM_PACKED_DIMENSIONS)\n                  + float(dimension)) + 0.5) / (TEXTURE_WIDTH);\n      return vec2(col,row);\n    }\n\n    //compute the euclidean squared distances between two points i and j\n    float pointDistanceSquared(int i, int j) {\n      vec4 result = vec4(0,0,0,0);\n      int num_iter = int(DATA_NUM_PACKED_DIMENSIONS);\n      for(int d = 0; d < num_iter; ++d) {\n        vec4 vi = texture(data_tex,dataTexCoordinates(i,d));\n        vec4 vj = texture(data_tex,dataTexCoordinates(j,d));\n        result += (vi-vj)*(vi-vj);\n      }\n      return (result.r+result.g+result.b+result.a);\n    }\n\n    //compute the euclidean squared distances between two points i and j\n    vec4 pointDistanceSquaredBatch(int i, int j0, int j1, int j2, int j3) {\n      vec4 result = vec4(0,0,0,0);\n      int num_iter = int(DATA_NUM_PACKED_DIMENSIONS);\n      for(int d = 0; d < num_iter; ++d) {\n        vec4 vi = texture(data_tex,dataTexCoordinates(i,d));\n        vec4 vj0 = texture(data_tex,dataTexCoordinates(j0,d));\n        vec4 vj1 = texture(data_tex,dataTexCoordinates(j1,d));\n        vec4 vj2 = texture(data_tex,dataTexCoordinates(j2,d));\n        vec4 vj3 = texture(data_tex,dataTexCoordinates(j3,d));\n        vj0 = (vi-vj0); vj0 *= vj0;\n        vj1 = (vi-vj1); vj1 *= vj1;\n        vj2 = (vi-vj2); vj2 *= vj2;\n        vj3 = (vi-vj3); vj3 *= vj3;\n        result.r += (vj0.r+vj0.g+vj0.b+vj0.a);\n        result.g += (vj1.r+vj1.g+vj1.b+vj1.a);\n        result.b += (vj2.r+vj2.g+vj2.b+vj2.a);\n        result.a += (vj3.r+vj3.g+vj3.b+vj3.a);\n      }\n      return result;\n    }\n    ";else if (function (e) {
              return "distanceComputationCode" in e;
            }(t)) {
              s = t.distanceComputationCode;
            }
            this.initializeTextures(), this.initilizeCustomWebGLPrograms(s);
          }
          return Object.defineProperty(e.prototype, "knnShape", {
            get: function get() {
              return this.knnDataShape;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "iteration", {
            get: function get() {
              return this._iteration;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "pointsPerIteration", {
            get: function get() {
              return 20;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.log = function (e, t) {
            this.verbose && (null != t ? console.log(e + ": \t" + t) : console.log(e));
          }, e.prototype.initializeTextures = function () {
            for (var e = new Float32Array(this.knnDataShape.pointsPerRow * this.knnDataShape.pixelsPerPoint * 2 * this.knnDataShape.numRows), t = this.knnDataShape.pixelsPerPoint, n = 0; n < this.knnDataShape.numPoints; ++n) for (var r = 0; r < t; ++r) e[2 * (n * t + r)] = -1, e[2 * (n * t + r) + 1] = 1e31;
            this.knnTexture0 = a(this.gpgpu.gl, this.knnDataShape.pointsPerRow * this.knnDataShape.pixelsPerPoint, this.knnDataShape.numRows, 2, e), this.knnTexture1 = a(this.gpgpu.gl, this.knnDataShape.pointsPerRow * this.knnDataShape.pixelsPerPoint, this.knnDataShape.numRows, 2, e);
          }, e.prototype.initilizeCustomWebGLPrograms = function (e) {
            this.copyDistancesProgram = this.gpgpu.createProgram("\n    precision highp float;\n    uniform sampler2D knn_tex;\n    uniform float width;\n    uniform float height;\n\n    void main() {\n      vec2 coordinates = gl_FragCoord.xy / vec2(width,height);\n      float distance = texture2D(knn_tex,coordinates).g;\n      gl_FragColor = vec4(distance,0,0,1);\n    }\n  "), this.copyIndicesProgram = v(this.gpgpu), this.bruteForceKNNProgram = function (e, t, n) {
              var r = "#version 300 es\n    " + d(t) + f + n + p + "\n    void main() {\n      //Getting the id of the point and the line id (0/1)\n      point_id = int((vertex_id / 2.0) + 0.1);\n      int line_id = int(mod(vertex_id + 0.1, 2.));\n      if(float(point_id) >= num_points) {\n        return;\n      }\n\n      " + m + "\n\n      //////////////////////////////////\n      //KNN computation\n      initializeDistances(point_id);\n      for(int i = 0; i < NEIGH_PER_ITER; i += 4) {\n        //TODO make it more readable\n\n        int j = int(mod(\n                    float(point_id + i) //point id + current offset\n                    + iteration * float(NEIGH_PER_ITER) //iteration offset\n                    + 1.25,// +1 for avoid checking the point itself,\n                           // +0.25 for error compensation\n                    num_points\n                  ));\n        vec4 dist_squared = pointDistanceSquaredBatch(point_id,j,j+1,j+2,j+3);\n        insertInKNN(dist_squared.r, j);\n        insertInKNN(dist_squared.g, j+1);\n        insertInKNN(dist_squared.b, j+2);\n        insertInKNN(dist_squared.a, j+3);\n      }\n\n      for(int n = 0; n < NUM_PACKED_NEIGHBORS; n++) {\n        knn[n].r = float(knn_heap[n*4]);\n        knn[n].g = float(knn_heap[n*4+1]);\n        knn[n].b = float(knn_heap[n*4+2]);\n        knn[n].a = float(knn_heap[n*4+3]);\n      }\n\n      neighbor_id = NUM_NEIGHBORS_FLOAT;\n    }\n  ",
                o = c(n, t);
              return i(e.gl, r, o);
            }(this.gpgpu, this.numNeighs, e), this.randomSamplingKNNProgram = function (e, t, n) {
              var r = "#version 300 es\n    " + d(t) + f + h + n + p + "\n    void main() {\n      //Getting the id of the point and the line id (0/1)\n      point_id = int((vertex_id/2.0)+0.1);\n      int line_id = int(mod(vertex_id+0.1,2.));\n      if(float(point_id) >= num_points) {\n        return;\n      }\n\n      " + m + "\n\n      //////////////////////////////////\n      //KNN computation\n\n      initializeDistances(point_id);\n      for(int i = 0; i < NEIGH_PER_ITER; i += 4) {\n        //BAD SEED\n        //uint seed\n        //= uint(float(point_id) + float(NEIGH_PER_ITER)*iteration + float(i));\n        //GOOD SEED\n        //uint seed\n        //= uint(float(point_id) + float(num_points)*iteration + float(i));\n\n        float seed\n            = float(float(point_id) + float(num_points)*iteration + float(i));\n        int j0 = int(random(seed)*num_points);\n        int j1 = int(random(seed+1.)*num_points);\n        int j2 = int(random(seed+2.)*num_points);\n        int j3 = int(random(seed+3.)*num_points);\n\n        vec4 dist_squared = pointDistanceSquaredBatch(point_id,j0,j1,j2,j3);\n        if(j0!=point_id)insertInKNN(dist_squared.r, j0);\n        if(j1!=point_id)insertInKNN(dist_squared.g, j1);\n        if(j2!=point_id)insertInKNN(dist_squared.b, j2);\n        if(j3!=point_id)insertInKNN(dist_squared.a, j3);\n      }\n\n      for(int n = 0; n < NUM_PACKED_NEIGHBORS; n++) {\n        knn[n].r = float(knn_heap[n*4]);\n        knn[n].g = float(knn_heap[n*4+1]);\n        knn[n].b = float(knn_heap[n*4+2]);\n        knn[n].a = float(knn_heap[n*4+3]);\n      }\n      neighbor_id = NUM_NEIGHBORS_FLOAT;\n    }\n  ",
                o = c(n, t);
              return i(e.gl, r, o);
            }(this.gpgpu, this.numNeighs, e), this.kNNDescentProgram = function (e, t, n) {
              var r = "#version 300 es\n    " + d(t) + f + h + n + p + "\n    int fetchNeighborIdFromKNNTexture(int id, int neighbor_id) {\n      //row coordinate in the texture\n      float row = (floor(float(id)/points_per_row_knn)+0.5)/num_rows_knn;\n      //column of the first neighbor\n      float start_col = mod(float(id),points_per_row_knn)*NUM_NEIGHBORS_FLOAT;\n      //column of the neighbor of interest\n      float col = (start_col+float(neighbor_id)+0.5);\n      //normalized by the width of the texture\n      col /= (points_per_row_knn*NUM_NEIGHBORS_FLOAT);\n      //reads the index in the red channel and the distances in the green one\n      vec4 knn_link = texture(starting_knn_tex,vec2(col,row));\n      //return the index\n      return int(knn_link.r);\n    }\n\n    int neighborOfANeighbor(int my_id, uint seed) {\n      //float random0 = hash1(seed);\n      float random0 = random(float(seed));\n      // random0 = random0*random0;\n      // random0 = 1. - random0;\n\n      //float random1 = hash1(seed*1798191U);\n      float random1 = random(float(seed+7U));\n      // random1 = random1*random1;\n      // random1 = 1. - random1;\n\n      //fetch a neighbor from the heap\n      int neighbor = knn_heap[int(random0*NUM_NEIGHBORS_FLOAT)];\n      //if it is not a valid pick a random point\n      if(neighbor < 0) {\n        return int(random(float(seed))*num_points);\n      }\n\n      //if it is valid I fetch from the knn graph texture one of its neighbors\n      int neighbor2ndDegree = fetchNeighborIdFromKNNTexture(\n                                    neighbor,int(random1*NUM_NEIGHBORS_FLOAT));\n      //if it is not a valid pick a random point\n      if(neighbor2ndDegree < 0) {\n        return int(random(float(seed))*num_points);\n      }\n      return neighbor2ndDegree;\n    }\n\n    void main() {\n      //Getting the id of the point and the line id (0/1)\n      point_id = int((vertex_id/2.0)+0.1);\n      int line_id = int(mod(vertex_id+0.1,2.));\n      if(float(point_id) >= num_points) {\n        return;\n      }\n      " + m + "\n\n      //////////////////////////////////\n      //KNN computation\n      initializeDistances(point_id);\n      for(int i = 0; i < NEIGH_PER_ITER; i += 4) {\n        //BAD SEED\n        //uint seed\n        //= uint(float(point_id) + float(NEIGH_PER_ITER)*iteration + float(i));\n        //GOOD SEED\n        uint seed\n              = uint(float(point_id) + float(num_points)*iteration + float(i));\n        int j0 = neighborOfANeighbor(point_id,seed);\n        int j1 = neighborOfANeighbor(point_id,seed+1U);\n        int j2 = neighborOfANeighbor(point_id,seed+2U);\n        int j3 = neighborOfANeighbor(point_id,seed+3U);\n\n        vec4 dist_squared = pointDistanceSquaredBatch(point_id,j0,j1,j2,j3);\n        if(j0!=point_id)insertInKNN(dist_squared.r, j0);\n        if(j1!=point_id)insertInKNN(dist_squared.g, j1);\n        if(j2!=point_id)insertInKNN(dist_squared.b, j2);\n        if(j3!=point_id)insertInKNN(dist_squared.a, j3);\n      }\n\n      for(int n = 0; n < NUM_PACKED_NEIGHBORS; n++) {\n        knn[n].r = float(knn_heap[n*4]);\n        knn[n].g = float(knn_heap[n*4+1]);\n        knn[n].b = float(knn_heap[n*4+2]);\n        knn[n].a = float(knn_heap[n*4+3]);\n      }\n      neighbor_id = NUM_NEIGHBORS_FLOAT;\n    }\n  ",
                o = c(n, t);
              return i(e.gl, r, o);
            }(this.gpgpu, this.numNeighs, e);
            for (var t = new Float32Array(2 * this.knnDataShape.numPoints), n = 0; n < 2 * this.knnDataShape.numPoints; ++n) t[n] = n;
            this.linesVertexIdBuffer = r.webgl.webgl_util.createStaticVertexBuffer(this.gpgpu.gl, t);
          }, e.prototype.iterateBruteForce = function () {
            this._iteration % 2 == 0 ? this.iterateGPU(this.dataTexture, this._iteration, this.knnTexture0, this.knnTexture1) : this.iterateGPU(this.dataTexture, this._iteration, this.knnTexture1, this.knnTexture0), ++this._iteration, this.gpgpu.gl.finish();
          }, e.prototype.iterateRandomSampling = function () {
            this._iteration % 2 == 0 ? this.iterateRandomSamplingGPU(this.dataTexture, this._iteration, this.knnTexture0, this.knnTexture1) : this.iterateRandomSamplingGPU(this.dataTexture, this._iteration, this.knnTexture1, this.knnTexture0), ++this._iteration, this.gpgpu.gl.finish();
          }, e.prototype.iterateKNNDescent = function () {
            this._iteration % 2 == 0 ? this.iterateKNNDescentGPU(this.dataTexture, this._iteration, this.knnTexture0, this.knnTexture1) : this.iterateKNNDescentGPU(this.dataTexture, this._iteration, this.knnTexture1, this.knnTexture0), ++this._iteration, this.gpgpu.gl.finish();
          }, e.prototype.knn = function () {
            return this._iteration % 2 == 0 ? this.knnTexture0 : this.knnTexture1;
          }, e.prototype.distancesTensor = function () {
            var e = this;
            return r.tidy(function () {
              var t = r.zeros([e.knnDataShape.numRows, e.knnDataShape.pointsPerRow * e.knnDataShape.pixelsPerPoint]),
                n = e.knn();
              return function (e, t, n, i, o) {
                var a = e.gl;
                null != o ? e.setOutputMatrixTexture(o, i.numRows, i.pointsPerRow * i.pixelsPerPoint) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
                var s = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "knn_tex");
                e.setInputMatrixTexture(n, s, 0);
                var l = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "width");
                a.uniform1f(l, i.pointsPerRow * i.pixelsPerPoint);
                var u = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "height");
                a.uniform1f(u, i.numRows), e.executeProgram();
              }(e.gpgpu, e.copyDistancesProgram, n, e.knnDataShape, e.backend.getTexture(t.dataId)), t.reshape([e.knnDataShape.numRows * e.knnDataShape.pointsPerRow, e.knnDataShape.pixelsPerPoint]).slice([0, 0], [e.knnDataShape.numPoints, e.knnDataShape.pixelsPerPoint]);
            });
          }, e.prototype.indicesTensor = function () {
            var e = this;
            return r.tidy(function () {
              var t = r.zeros([e.knnDataShape.numRows, e.knnDataShape.pointsPerRow * e.knnDataShape.pixelsPerPoint]),
                n = e.knn();
              return y(e.gpgpu, e.copyIndicesProgram, n, e.knnDataShape, e.backend.getTexture(t.dataId)), t.reshape([e.knnDataShape.numRows * e.knnDataShape.pointsPerRow, e.knnDataShape.pixelsPerPoint]).slice([0, 0], [e.knnDataShape.numPoints, e.knnDataShape.pixelsPerPoint]);
            });
          }, e.prototype.iterateGPU = function (e, t, n, r) {
            g(this.gpgpu, this.bruteForceKNNProgram, e, n, t, this.knnDataShape, this.linesVertexIdBuffer, r);
          }, e.prototype.iterateRandomSamplingGPU = function (e, t, n, r) {
            g(this.gpgpu, this.randomSamplingKNNProgram, e, n, t, this.knnDataShape, this.linesVertexIdBuffer, r);
          }, e.prototype.iterateKNNDescentGPU = function (e, t, n, r) {
            g(this.gpgpu, this.kNNDescentProgram, e, n, t, this.knnDataShape, this.linesVertexIdBuffer, r);
          }, e;
        }(),
        _ = function _(e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        x = function x(e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [0, i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        };
      function w(e) {
        return _(this, void 0, void 0, function () {
          var t, n, i, o, s, l, u, c, d, h, f, p, m, g, v;
          return x(this, function (y) {
            if (2 !== (t = e.shape).length) throw Error("tensorToDataTexture: input tensor must be 2-dimensional");
            if (null === (n = r.ENV.findBackend("webgl"))) throw Error("WebGL backend is not available");
            for (i = n.getGPGPUContext(), o = t[0], s = t[1], 4, l = Math.ceil(s / 4), u = Math.floor(Math.sqrt(o * l) / l), c = Math.ceil(o / u), d = e.dataSync(), h = new Float32Array(u * l * c * 4), f = 0; f < o; ++f) for (p = f * s, m = f * l * 4, g = 0; g < s; ++g) h[m + g] = d[p + g];
            return v = a(i.gl, u * l, c, 4, h), [2, {
              shape: {
                numPoints: o,
                pointsPerRow: u,
                numRows: c,
                pixelsPerPoint: l
              },
              texture: v
            }];
          });
        });
      }
      var S = function S(e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        A = function A(e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [0, i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        },
        E = function () {
          function e(e, t, n, i) {
            if (null != t ? this.verbose = t : t = !1, this.log("Initializing the tSNE gradient descent computation..."), this.numPoints = e, this._iteration = 0, 1 === r.ENV.get("WEBGL_VERSION")) throw Error("WebGL version 1 is not supported by tfjs-tsne");
            if (this.backend = r.ENV.findBackend("webgl"), null === this.backend) throw Error("WebGL backend is not available");
            this.gpgpu = this.backend.getGPGPUContext(), r.webgl.webgl_util.getExtensionOrThrow(this.gpgpu.gl, "OES_texture_float_linear"), this.pointsPerRow = Math.ceil(Math.sqrt(2 * e)), this.pointsPerRow % 2 == 1 && ++this.pointsPerRow, this.pointsPerRow /= 2, this.numRows = Math.ceil(e / this.pointsPerRow), this.log("\t# points per row", this.pointsPerRow), this.log("\t# rows", this.numRows), this._eta = 2500, this._momentum = r.scalar(.8), this.rawExaggeration = [{
              iteration: 200,
              value: 4
            }, {
              iteration: 600,
              value: 1
            }], this.updateExaggeration(), null == n && (n = 5), this.splatTextureDiameter = n, null == i && (i = 50), this.kernelTextureDiameter = 2 * i + 1, this.initializeRepulsiveForceTextures(), this.log("\tSplat texture diameter", this.splatTextureDiameter), this.log("\tKernel texture diameter", this.kernelTextureDiameter), this.initilizeCustomWebGLPrograms(), this.initializeEmbedding(), this.log("\tEmbedding", this.embedding), this.log("\tGradient", this.gradient);
          }
          return Object.defineProperty(e.prototype, "minX", {
            get: function get() {
              return this._minX;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "maxX", {
            get: function get() {
              return this._maxX;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "minY", {
            get: function get() {
              return this._minY;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "maxY", {
            get: function get() {
              return this._maxY;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "iteration", {
            get: function get() {
              return this._iteration;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "numberOfPoints", {
            get: function get() {
              return this.numPoints;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "numberOfPointsPerRow", {
            get: function get() {
              return this.pointsPerRow;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "numberOfRows", {
            get: function get() {
              return this.numRows;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "embeddingCoordinates", {
            get: function get() {
              return this.embedding;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "embedding2D", {
            get: function get() {
              var e = this;
              return r.tidy(function () {
                return e.embedding.reshape([e.numRows * e.pointsPerRow, 2]).slice([0, 0], [e.numPoints, 2]);
              });
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "embeddingTexture", {
            get: function get() {
              return this.backend.getTexture(this.embedding.dataId);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "splatTexture", {
            get: function get() {
              return this._splatTexture;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "normalizationQ", {
            get: function get() {
              return this._normQ;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "exaggerationAtCurrentIteration", {
            get: function get() {
              return this._exaggeration.get();
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "exaggeration", {
            get: function get() {
              return this.rawExaggeration;
            },
            set: function set(e) {
              if (this.rawExaggeration = e, "number" == typeof e) {
                if (e < 1) throw Error("Exaggeration must be greater then or equal to one");
              } else {
                for (var t = 0; t < e.length; ++t) {
                  if (e[t].value < 1) throw Error("Exaggeration must be greater then or equal to one");
                  if (e[t].iteration < 0) throw Error("Piecewise linear exaggeration function                                         must have poistive iteration values");
                }
                for (t = 0; t < e.length - 1; ++t) if (e[t].iteration >= e[t + 1].iteration) throw Error("Piecewise linear exaggeration function                                       must have increasing iteration values");
                1 === e.length && (this.exaggeration = e[0].value);
              }
              this.updateExaggeration();
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "momentum", {
            get: function get() {
              return this._momentum.get();
            },
            set: function set(e) {
              if (e < 0 || e > 1) throw Error("Momentum must be in the [0,1] range");
              this._momentum.dispose(), this._momentum = r.scalar(e);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "eta", {
            get: function get() {
              return this._eta;
            },
            set: function set(e) {
              if (e <= 0) throw Error("ETA must be greater then zero");
              this._eta = e;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.dispose = function () {
            this.embedding.dispose(), this.gradient.dispose(), this._momentum.dispose(), this._exaggeration.dispose(), this.gpgpu.gl.deleteTexture(this._splatTexture), this.gpgpu.gl.deleteTexture(this.kernelTexture), null != this.kernelTexture && this.gpgpu.gl.deleteTexture(this.probOffsetTexture), null != this.kernelTexture && this.gpgpu.gl.deleteTexture(this.probNeighIdTexture), null != this.kernelTexture && this.gpgpu.gl.deleteTexture(this.probTexture), this.gpgpu.gl.deleteBuffer(this.splatVertexIdBuffer), this.gpgpu.gl.deleteProgram(this.embeddingInitializationProgram), this.gpgpu.gl.deleteProgram(this.embeddingSplatterProgram), this.gpgpu.gl.deleteProgram(this.qInterpolatorProgram), this.gpgpu.gl.deleteProgram(this.xyInterpolatorProgram), this.gpgpu.gl.deleteProgram(this.attractiveForcesProgram), this.gpgpu.gl.deleteProgram(this.distributionParameterssComputationProgram), this.gpgpu.gl.deleteProgram(this.gaussiaDistributionsFromDistancesProgram);
          }, e.prototype.initializeEmbedding = function () {
            var e = this;
            null != this.embedding && this.embedding.dispose(), null != this.gradient && this.gradient.dispose(), this.gradient = r.zeros([this.numRows, 2 * this.pointsPerRow]), this.embedding = r.tidy(function () {
              var t = r.randomUniform([e.numRows, 2 * e.pointsPerRow]),
                n = r.zeros([e.numRows, 2 * e.pointsPerRow]);
              return e.initializeEmbeddingPositions(n, t), n;
            });
            this._minX = -3, this._minY = -3, this._maxX = 3, this._maxY = 3, this.log("\tmin X", this._minX), this.log("\tmax X", this._maxX), this.log("\tmin Y", this._minY), this.log("\tmax Y", this._maxY), this._iteration = 0;
          }, e.prototype.initializeNeighbors = function (e, t, n, r) {
            this.numNeighPerRow = e, this.probOffsetTexture = t, this.probTexture = n, this.probNeighIdTexture = r;
          }, e.prototype.initializeNeighborsFromKNNGraph = function (e, t, n, r) {
            return S(this, void 0, void 0, function () {
              var i, o, s, l, u, c, d, h;
              return A(this, function (f) {
                switch (f.label) {
                  case 0:
                    for (i = Math.floor(Math.sqrt(e * t) / t), o = Math.ceil(e / i), s = {
                      numPoints: e,
                      pixelsPerPoint: t,
                      numRows: o,
                      pointsPerRow: i
                    }, l = new Float32Array(i * t * o * 2), u = 0; u < e; ++u) for (c = 0; c < t; ++c) l[2 * (d = u * t + c)] = r[d], l[2 * d + 1] = n[d];
                    return h = a(this.gpgpu.gl, i * t, o, 2, l), [4, this.initializeNeighborsFromKNNTexture(s, h)];
                  case 1:
                    return f.sent(), this.gpgpu.gl.deleteTexture(h), [2];
                }
              });
            });
          }, e.prototype.initializeNeighborsFromKNNTexture = function (e, t) {
            return S(this, void 0, void 0, function () {
              var n, i, o, s, l, u, c, d, h, f, p, m, g, b, _, x, w, S, E, T, M, C, k, P, O, R, I;
              return A(this, function (A) {
                switch (A.label) {
                  case 0:
                    if (this.log("Asymmetric neighborhood initialization..."), e.numPoints !== this.numPoints) throw new Error("KNN size and number of points must agree(" + e.numPoints + "," + this.numPoints + ")");
                    return n = a(this.gpgpu.gl, e.pointsPerRow, e.numRows, 2), i = r.zeros([e.numRows, e.pointsPerRow * e.pixelsPerPoint]), o = e.pixelsPerPoint / 3, this.computeDistributionParameters(n, e, o, t), this.computeGaussianDistributions(i, n, e, t), [4, i.data()];
                  case 1:
                    return s = A.sent(), this.log("Gaussian distributions", i), l = r.zeros([e.numRows, e.pointsPerRow * e.pixelsPerPoint]), u = v(this.gpgpu), y(this.gpgpu, u, t, e, this.backend.getTexture(l.dataId)), [4, l.data()];
                  case 2:
                    for (c = A.sent(), this.log("knn Indices", l), d = new Float32Array(e.numPoints * e.pixelsPerPoint), M = 0; M < this.numPoints; ++M) for (h = 0; h < e.pixelsPerPoint; ++h) k = M * e.pixelsPerPoint + h, d[M * e.pixelsPerPoint + h] = c[k];
                    for (this.log("NeighIds", d), f = new Uint32Array(this.numPoints), p = new Uint32Array(this.numPoints), M = 0; M < e.numPoints * e.pixelsPerPoint; ++M) ++f[d[M]];
                    for (M = 1; M < e.numPoints; ++M) p[M] = p[M - 1] + f[M - 1] + e.pixelsPerPoint;
                    for (this.log("Counter", f), this.log("Linear offset", p), m = 0, g = 0, b = 0, M = 0; M < f.length; ++M) m += f[M], f[M] > g && (g = f[M], b = M);
                    for (this.log("Number of indirect links", m), this.log("Most central point", b), this.log("Number of indirect links for the central point", g), this.numNeighPerRow = Math.ceil(Math.sqrt(e.numPoints * e.pixelsPerPoint * 2)), this.log("numNeighPerRow", this.numNeighPerRow), _ = new Float32Array(this.pointsPerRow * this.numRows * 3), x = 0, M = 0; M < this.numPoints; ++M) w = e.pixelsPerPoint + f[M], _[3 * M + 0] = x % this.numNeighPerRow, _[3 * M + 1] = Math.floor(x / this.numNeighPerRow), _[3 * M + 2] = w, x += w;
                    for (this.log("Offsets", _), this.probOffsetTexture = a(this.gpgpu.gl, this.pointsPerRow, this.numRows, 3, _), S = new Float32Array(this.numNeighPerRow * this.numNeighPerRow), E = new Float32Array(this.numNeighPerRow * this.numNeighPerRow), T = new Uint32Array(this.numPoints), M = 0; M < this.numPoints; ++M) for (C = 0; C < e.pixelsPerPoint; ++C) k = M * e.pixelsPerPoint + C, P = c[k], O = s[k], R = p[M] + C, I = p[P] + e.pixelsPerPoint + T[P], S[R] = O, S[I] = O, E[R] = P, E[I] = M, ++T[P];
                    return this.log("Probabilities", S), this.log("Neighbors", E), this.probTexture = a(this.gpgpu.gl, this.numNeighPerRow, this.numNeighPerRow, 1, S), this.probNeighIdTexture = a(this.gpgpu.gl, this.numNeighPerRow, this.numNeighPerRow, 1, E), i.dispose(), l.dispose(), this.log("...done!"), [2];
                }
              });
            });
          }, e.prototype.initializedNeighborhoods = function () {
            return null != this.probNeighIdTexture;
          }, e.prototype.updateExaggeration = function () {
            if (void 0 !== this._exaggeration && this._exaggeration.dispose(), "number" != typeof this.rawExaggeration) {
              if (this._iteration <= this.rawExaggeration[0].iteration) this._exaggeration = r.scalar(this.rawExaggeration[0].value);else if (this._iteration >= this.rawExaggeration[this.rawExaggeration.length - 1].iteration) this._exaggeration = r.scalar(this.rawExaggeration[this.rawExaggeration.length - 1].value);else {
                for (var e = 0; e < this.rawExaggeration.length && this._iteration < this.rawExaggeration[e].iteration;) ++e;
                var t = this.rawExaggeration[e].iteration,
                  n = this.rawExaggeration[e + 1].iteration,
                  i = this.rawExaggeration[e].value,
                  o = this.rawExaggeration[e + 1].value,
                  a = (n - this._iteration) / (n - t),
                  s = i * a + o * (1 - a);
                this._exaggeration = r.scalar(s);
              }
            } else this._exaggeration = r.scalar(this.rawExaggeration);
          }, e.prototype.iterate = function () {
            return S(this, void 0, void 0, function () {
              var e,
                t,
                n,
                i = this;
              return A(this, function (o) {
                switch (o.label) {
                  case 0:
                    if (!this.initializedNeighborhoods()) throw new Error("No neighborhoods defined. You may want to call                    initializeNeighbors or initializeNeighborsFromKNNGraph");
                    return this.updateSplatTextureDiameter(), this.updateExaggeration(), n = r.tidy(function () {
                      i.splatPoints();
                      var e = r.zeros([i.numRows, i.pointsPerRow]),
                        t = r.zeros([i.numRows, 2 * i.pointsPerRow]);
                      i.computeInterpolatedQ(e), i.computeInterpolatedXY(t);
                      var n = e.sum(),
                        o = t.div(n),
                        a = r.zeros([i.numRows, 2 * i.pointsPerRow]);
                      i.computeAttractiveForces(a);
                      var s = a.mul(i._exaggeration).sub(o),
                        l = i.gradient.mul(i._momentum).sub(s);
                      return i.gradient.dispose(), [l, n];
                    }), this.gradient = n[0], e = n[1], t = this, [4, e.data()];
                  case 1:
                    return t._normQ = o.sent()[0], e.dispose(), this.embedding = r.tidy(function () {
                      var e = i.embedding.add(i.gradient);
                      return i.embedding.dispose(), e;
                    }), [4, this.computeBoundaries()];
                  case 2:
                    return o.sent(), ++this._iteration, [2];
                }
              });
            });
          }, e.prototype.log = function (e, t) {
            this.verbose && (null != t ? console.log(e + ": \t" + t) : console.log(e));
          }, e.prototype.initializeRepulsiveForceTextures = function () {
            this._splatTexture = o(this.gpgpu.gl, this.splatTextureDiameter, this.splatTextureDiameter, 4, null), this.kernelSupport = 2.5;
            var e = new Float32Array(this.kernelTextureDiameter * this.kernelTextureDiameter * 4),
              t = Math.floor(this.kernelTextureDiameter / 2),
              n = 0,
              r = 0;
            for (n = 0; n < this.kernelTextureDiameter; ++n) for (r = 0; r < this.kernelTextureDiameter; ++r) {
              var i = (r - t) / t * this.kernelSupport,
                a = (n - t) / t * this.kernelSupport,
                s = 1 / (1 + (i * i + a * a)),
                l = 4 * (n * this.kernelTextureDiameter + r);
              e[l + 0] = s, e[l + 1] = s * s * i, e[l + 2] = s * s * a, e[l + 3] = 1;
            }
            this.kernelTexture = o(this.gpgpu.gl, this.kernelTextureDiameter, this.kernelTextureDiameter, 4, e);
          }, e.prototype.initilizeCustomWebGLPrograms = function () {
            this.log("\tCreating custom programs..."), this.embeddingInitializationProgram = this.gpgpu.createProgram("\n    precision highp float;\n\n    uniform sampler2D random_tex;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n\n    void main() {\n      //add for nearest pixel interpolation\n      vec2 half_pxl = vec2(0.5,0.5);\n\n      // Dimension of the fragment\n      // 0 -> x :1 -> y\n      float dimension = mod(gl_FragCoord.x - 0.4,2.);\n      vec2 pnt_location = gl_FragCoord.xy - half_pxl;\n      pnt_location.x = floor(pnt_location.x / 2.);\n\n      //just an extra fragment -> return\n      if(pnt_location.y*points_per_row + pnt_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,1);\n        return;\n      }\n\n      float width = (points_per_row * 2.0);\n      float row_coord = (pnt_location.y + 0.5)/num_rows;\n      vec2 rad_coord = vec2((pnt_location.x * 2. + 0.5) / width, row_coord);\n      vec2 ang_coord = vec2((pnt_location.x * 2. + 1.5) / width, row_coord);\n\n      float rad = texture2D(random_tex,rad_coord).r * 3.;\n      float ang = texture2D(random_tex,ang_coord).r * 3.1415 * 2.;\n\n      gl_FragColor = vec4(rad,ang,0,1);\n\n      if(dimension < 0.5) {\n        gl_FragColor = vec4(cos(ang) * rad,0,0,0);\n      }else{\n        gl_FragColor = vec4(sin(ang) * rad,0,0,0);\n      }\n    }\n  "), this.embeddingSplatterProgram = function (e) {
              return i(e.gl, "#version 300 es\n    precision highp float;\n    in float vertex_id;\n\n    uniform sampler2D embedding_tex;\n    uniform vec2 minV;\n    uniform vec2 maxV;\n    uniform float kernel_support;\n    uniform float points_per_row;\n    uniform float num_rows;\n\n    out vec2 kernel_coords;\n\n    void main() {\n      //TODO Clean up and check performance loss due to the conversions\n      uint pnt_id = uint((vertex_id / 4.0) + 0.1);\n      uint quad_id = uint(mod(vertex_id + 0.1,4.));\n\n      uint row    = uint((float(pnt_id) + 0.1)/points_per_row);\n      uint column = uint(float(pnt_id) - float(row) * points_per_row);\n\n      float width = (points_per_row * 2.0);\n      float row_tex = (float(row) + 0.5) / num_rows;\n      vec2 tex_coords_x = vec2((float(column) * 2. + 0.5) / width, row_tex);\n      vec2 tex_coords_y = vec2((float(column) * 2. + 1.5) / width, row_tex);\n\n      float x_pnt = texture(embedding_tex,tex_coords_x).r;\n      float y_pnt = texture(embedding_tex,tex_coords_y).r;\n      vec2 vertex_coords = vec2(x_pnt,y_pnt);\n\n      if(quad_id == uint(0)) {kernel_coords = vec2(-1,-1);}\n      else if(quad_id == uint(1)) {kernel_coords = vec2(1,-1);}\n      else if(quad_id == uint(2)) {kernel_coords = vec2(1,1);}\n      else if(quad_id == uint(3)) {kernel_coords = vec2(-1,1);}\n\n      vertex_coords += kernel_coords * kernel_support;      // embedding space\n      vertex_coords = (vertex_coords - minV) / (maxV-minV); //  0:1 space\n      vertex_coords = vertex_coords * 2.0 - 1.0;            // -1:1 space\n\n      gl_Position = vec4(vertex_coords,0,1);\n    }\n  ", "#version 300 es\n    precision highp float;\n    uniform sampler2D kernel_tex;\n    in vec2 kernel_coords;\n    out vec4 fragmentColor;\n\n    void main() {\n      fragmentColor = texture(kernel_tex,(kernel_coords + 1.) / 2.0);\n    }\n  ");
            }(this.gpgpu);
            var e = new Float32Array(6 * this.numPoints),
              t = 0,
              n = 0;
            for (t = 0; t < this.numPoints; ++t) e[(n = 6 * t) + 0] = 0 + 4 * t, e[n + 1] = 1 + 4 * t, e[n + 2] = 2 + 4 * t, e[n + 3] = 0 + 4 * t, e[n + 4] = 2 + 4 * t, e[n + 5] = 3 + 4 * t;
            this.splatVertexIdBuffer = r.webgl.webgl_util.createStaticVertexBuffer(this.gpgpu.gl, e), this.qInterpolatorProgram = function (e) {
              return e.createProgram("\n    precision highp float;\n    uniform sampler2D embedding_tex;\n    uniform sampler2D splat_tex;\n    uniform vec2 minV;\n    uniform vec2 maxV;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n\n    void main() {\n      vec2 pnt_location = gl_FragCoord.xy - vec2(0.5,0.5);\n\n      if(pnt_location.y * points_per_row + pnt_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n\n      float emb_width = (points_per_row * 2.0);\n      float emb_row_coord = (pnt_location.y + 0.5) / num_rows;\n      vec2 emb_coords_x\n              = vec2((pnt_location.x * 2.+0.5) / emb_width, emb_row_coord);\n      vec2 emb_coords_y\n              = vec2((pnt_location.x * 2. + 1.5) / emb_width, emb_row_coord);\n\n      float x_pnt = texture2D(embedding_tex,emb_coords_x).r;\n      float y_pnt = texture2D(embedding_tex,emb_coords_y).r;\n\n      vec2 splat_coords = vec2(x_pnt,y_pnt);\n      splat_coords = (splat_coords - minV) / (maxV - minV); //  0:1 space\n\n      float q = (texture2D(splat_tex,splat_coords).r - 1.);\n\n      gl_FragColor = vec4(q, 0, 0, 1);\n    }\n  ");
            }(this.gpgpu), this.xyInterpolatorProgram = function (e) {
              return e.createProgram("\n    precision highp float;\n    uniform sampler2D embedding_tex;\n    uniform sampler2D splat_tex;\n    uniform vec2 minV;\n    uniform vec2 maxV;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float eta;\n\n    void main() {\n      vec2 pnt_location = gl_FragCoord.xy - vec2(0.5,0.5);\n      pnt_location.x = floor(pnt_location.x/2.+0.1);\n\n      if(pnt_location.y*points_per_row + pnt_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n\n      float emb_width = (points_per_row * 2.0);\n      float emb_row_coord = (pnt_location.y + 0.5) / num_rows;\n      vec2 emb_coords_x\n              = vec2((pnt_location.x * 2. + 0.5) / emb_width, emb_row_coord);\n      vec2 emb_coords_y\n              = vec2((pnt_location.x * 2. + 1.5) / emb_width, emb_row_coord);\n\n      float x_pnt = texture2D(embedding_tex,emb_coords_x).r;\n      float y_pnt = texture2D(embedding_tex,emb_coords_y).r;\n\n      vec2 splat_coords = vec2(x_pnt,y_pnt);\n      splat_coords = (splat_coords - minV) / (maxV - minV); //  0:1 space\n\n      float q = 0.;\n      if(mod(gl_FragCoord.x - 0.5,2.) < 0.5 ) {\n        q = texture2D(splat_tex,splat_coords).g * eta * 2.;\n      }else{\n        q = texture2D(splat_tex,splat_coords).b * eta * 2.;\n      }\n\n      gl_FragColor = vec4(q,0.0,0.0,1);\n    }\n  ");
            }(this.gpgpu), this.attractiveForcesProgram = function (e) {
              return e.createProgram("\n    precision highp float;\n\n    uniform sampler2D embedding_tex;\n    uniform sampler2D offset_tex;\n    uniform sampler2D neigh_id_tex;\n    uniform sampler2D neigh_prob_tex;\n\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float num_neighs_per_row;\n    uniform float eta;\n\n    void main() {\n      //add for nearest pixel interpolation\n      vec2 half_pxl = vec2(0.5,0.5);\n\n      // Dimension of the fragment\n      // 0 -> x :1 -> y\n      float dimension = mod(gl_FragCoord.x - 0.4,2.);\n\n      //Point location in the [points_per_row,num_rows] space\n      vec2 i_location = gl_FragCoord.xy - half_pxl;\n      i_location.x = floor(i_location.x / 2. + 0.1);\n\n      //just an extra fragment -> return\n      if(i_location.y*points_per_row + i_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n\n      //Offset coordinates for the point\n      vec2 offset_coord = (i_location + half_pxl) /\n                                              vec2(points_per_row,num_rows);\n      //Offset information ...\n      vec4 offset_info  = texture2D(offset_tex,offset_coord);\n      //... contains the number of neighbors for the point ...\n      float num_neighs  = offset_info.z;\n      //... and the coordinates of the firts neigh in the neigh textures\n      vec2 offset_neigh = offset_info.xy;\n\n      //Computing the coordinates of the point in the texture\n      //_i represent the point to move, _j the neighbors\n      float emb_width = (points_per_row * 2.0);\n      float emb_row_i = (i_location.y + 0.5) / num_rows;\n      vec2 x_i_coord = vec2((i_location.x * 2. + 0.5) / emb_width, emb_row_i);\n      vec2 y_i_coord = vec2((i_location.x * 2. + 1.5) / emb_width, emb_row_i);\n      //getting the coordinates in the embedding\n      float x_i = texture2D(embedding_tex,x_i_coord).r;\n      float y_i = texture2D(embedding_tex,y_i_coord).r;\n\n      //Sum of all attractive forces\n      float sum_pos = 0.;\n\n      //Can't be higher than 1000 (perplexity is usually around 30)\n      //and a 'while' can't be used\n      for(int n = 0; n < 2000; ++n) {\n        //Actual check on number of neighbors\n        if(float(n) >= num_neighs) {\n          break;\n        }\n\n        //Get the id and the probability for the neighbor\n        float pij = texture2D(neigh_prob_tex,\n                              (offset_neigh + half_pxl) / num_neighs_per_row\n                             ).r;\n        float neigh_id = texture2D(neigh_id_tex,\n                                  (offset_neigh + half_pxl) / num_neighs_per_row\n                                  ).r;\n\n        //Getting the coordinates of the neighbor\n        vec2 j_location = vec2(mod(neigh_id + 0.1, points_per_row),\n                               floor(neigh_id / points_per_row + 0.1));\n        float emb_row_j = (j_location.y + 0.5) / num_rows;\n        vec2 x_j_coord = vec2((j_location.x * 2. + 0.5) / emb_width, emb_row_j);\n        vec2 y_j_coord = vec2((j_location.x * 2. + 1.5) / emb_width, emb_row_j);\n        float x_j = texture2D(embedding_tex,x_j_coord).r;\n        float y_j = texture2D(embedding_tex,y_j_coord).r;\n\n        //Actual computation of the attractive forces\n        float dist_x    = (x_i - x_j);\n        float dist_y    = (y_i - y_j);\n        float qij       = 1. / (1. + dist_x * dist_x + dist_y * dist_y);\n        //the update depends on the dimension that this fragment represents\n        if(dimension < 0.5) {\n          // * 4 / (num_points*2) -> * 2 / num_points\n          sum_pos += eta * 2. * pij * qij * dist_x / (num_points);\n        }else{\n          sum_pos += eta * 2. * pij * qij * dist_y / (num_points);\n        }\n\n        //Increase the coordinate of the neigh in the neigh_id texture\n        offset_neigh.x += 1.;\n        //check if the new neigh is in the next row\n        if(offset_neigh.x + 0.2 > num_neighs_per_row) {\n          //in that case reset the column and increase the row\n          offset_neigh.x = 0.1;\n          offset_neigh.y += 1.0;\n        }\n      }\n\n      //The output is the sum of the attractive forces\n      gl_FragColor = vec4(sum_pos,0,0,0);\n    }\n  ");
            }(this.gpgpu), this.distributionParameterssComputationProgram = function (e) {
              return e.createProgram("\n    precision highp float;\n\n    #define MAX_NEIGHBORS 128\n    #define MAX_ITERATIONS 500\n    #define FLOAT_MAX 10e30\n    #define TOLERANCE 1e-5\n\n    uniform sampler2D knn_graph_tex;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float num_neighs;\n    uniform float perplexity;\n\n    vec2 half_pixel = vec2(0.5,0.5);\n    float distances_squared[MAX_NEIGHBORS];\n\n    void readDistances(vec2 point_location) {\n      for(int n = 0; n < MAX_NEIGHBORS; ++n ) {\n        if(float(n) >= num_neighs-0.1) {\n          break;\n        }\n        vec2 knn_coordinates = vec2(\n            (point_location.x * num_neighs + float(n) + half_pixel.x)\n                                        /(points_per_row * num_neighs),\n            (point_location.y + half_pixel.y) / num_rows\n        );\n        distances_squared[n] = texture2D(knn_graph_tex,knn_coordinates).g;\n      }\n    }\n\n    void main() {\n      vec2 point_location = gl_FragCoord.xy - half_pixel;\n      //invalid points\n      if(point_location.y*points_per_row + point_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n      readDistances(point_location);\n\n      //Beta computation\n      float beta = 1.;\n      float max_beta = FLOAT_MAX;\n      float min_beta = -FLOAT_MAX;\n      //To avoid computing the log at every iteration\n      float log_perplexity = log(perplexity);\n      float entropy_diff = 0.;\n      float entropy = 0.;\n      float sum_probabilities = 0.;\n\n      //Binary search for a maximum of MAX_ITERATIONS\n      for(int iteration = 0; iteration < MAX_ITERATIONS; ++iteration) {\n        //At every iteration I compute the\n        //entropy enforced by the current beta\n        sum_probabilities = 0.;\n        entropy = 0.;\n        for(int n = 0; n < MAX_NEIGHBORS; ++n ) {\n          if(float(n) >= num_neighs-0.1) {\n            break;\n          }\n          float neigh_probability = exp(-beta * distances_squared[n]);\n          sum_probabilities += neigh_probability;\n          entropy += beta * distances_squared[n] * neigh_probability;\n        }\n\n        entropy = entropy / sum_probabilities + log(sum_probabilities);\n        entropy_diff = entropy - log_perplexity;\n\n        //the current beta is good enough!\n        if(entropy_diff < TOLERANCE && -entropy_diff < TOLERANCE) {\n          break;\n        }\n\n        if(entropy_diff > 0.) {\n          min_beta = beta;\n          if(max_beta == FLOAT_MAX || max_beta == -FLOAT_MAX) {\n            beta *= 2.;\n          }else{\n            beta = (beta + max_beta) / 2.;\n          }\n        }else{\n          max_beta = beta;\n          if(min_beta == -FLOAT_MAX || min_beta == FLOAT_MAX) {\n            beta /= 2.;\n          }else{\n            beta = (beta + min_beta) / 2.;\n          }\n        }\n      }\n      gl_FragColor = vec4(beta,sum_probabilities,0,1);\n    }\n  ");
            }(this.gpgpu), this.gaussiaDistributionsFromDistancesProgram = function (e) {
              return e.createProgram("\n    precision highp float;\n    uniform sampler2D knn_graph_tex;\n    uniform sampler2D parameters_tex;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float num_neighs;\n\n    vec2 half_pixel = vec2(0.5,0.5);\n\n    void main() {\n      vec2 point_location = gl_FragCoord.xy - half_pixel;\n      point_location.x = floor(point_location.x / num_neighs);\n\n      //invalid points\n      if(point_location.y*points_per_row + point_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n      float distance_squared\n            = texture2D(knn_graph_tex,\n                        gl_FragCoord.xy /\n                        vec2(points_per_row*num_neighs,num_rows)\n                      ).g;\n      vec2 parameters\n            = texture2D(parameters_tex,\n                        (point_location.xy + half_pixel)/\n                        vec2(points_per_row,num_rows)\n                      ).rg;\n      float beta = parameters.r;\n      float normalization = parameters.g;\n\n      float probability = exp(-beta * distance_squared) / normalization;\n      //check for NaN for degenerated knn (d = 0 for every point)\n      if (!(probability < 0.0 || 0.0 < probability || probability == 0.0)) {\n        probability = 0.;\n      }\n\n      gl_FragColor = vec4(probability,0,0,1);\n    }\n  ");
            }(this.gpgpu);
          }, e.prototype.computeBoundaries = function () {
            return S(this, void 0, void 0, function () {
              var e,
                t,
                n,
                i,
                o,
                a,
                s,
                l = this;
              return A(this, function (u) {
                switch (u.label) {
                  case 0:
                    return e = r.tidy(function () {
                      var e = l.embedding.reshape([l.numRows * l.pointsPerRow, 2]).slice([0, 0], [l.numPoints, 2]);
                      return [e.min(0), e.max(0)];
                    }), t = e[0], n = e[1], [4, t.data()];
                  case 1:
                    return i = u.sent(), [4, n.data()];
                  case 2:
                    return o = u.sent(), .05, a = .05 * (o[0] - i[0]), this._minX = i[0] - a, this._maxX = o[0] + a, s = .05 * (o[1] - i[1]), this._minY = i[1] - s, this._maxY = o[1] + s, t.dispose(), n.dispose(), [2];
                }
              });
            });
          }, e.prototype.updateSplatTextureDiameter = function () {
            var e = Math.max(this._maxX - this._minX, this._maxY - this._minY),
              t = Math.min(Math.ceil(Math.max(e / .35, 5)), 5e3);
            Math.abs(this.splatTextureDiameter - t) / this.splatTextureDiameter >= .2 && (this.log("Updating splat-texture diameter", t), this.gpgpu.gl.deleteTexture(this._splatTexture), this.splatTextureDiameter = t, this._splatTexture = o(this.gpgpu.gl, this.splatTextureDiameter, this.splatTextureDiameter, 4, null));
          }, e.prototype.initializeEmbeddingPositions = function (e, t) {
            !function (e, t, n, i, o, a, s) {
              var l = e.gl;
              null != s ? e.setOutputMatrixTexture(s, a, 2 * o) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
              var u = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "random_tex");
              e.setInputMatrixTexture(n, u, 3);
              var c = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "num_rows");
              l.uniform1f(c, a);
              var d = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "num_points");
              l.uniform1f(d, i);
              var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "points_per_row");
              l.uniform1f(h, o), e.executeProgram();
            }(this.gpgpu, this.embeddingInitializationProgram, this.backend.getTexture(t.dataId), this.numPoints, this.pointsPerRow, this.numRows, this.backend.getTexture(e.dataId));
          }, e.prototype.splatPoints = function () {
            !function (e, t, n, i, o, a, s, l, u, c, d, h, f, p, m) {
              var g = e.gl,
                v = e.program;
              null != n ? e.setOutputMatrixTexture(n, a, a) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t), g.clearColor(0, 0, 0, 0), g.clear(g.COLOR_BUFFER_BIT), g.enable(g.BLEND), g.blendFunc(g.ONE, g.ONE), r.webgl.webgl_util.callAndCheck(g, function () {
                return g.bindBuffer(g.ARRAY_BUFFER, m);
              }), r.webgl.webgl_util.bindVertexBufferToProgramAttribute(g, t, "vertex_id", m, 1, 0, 0);
              var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "embedding_tex");
              e.setInputMatrixTexture(i, y, 0);
              var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "kernel_tex");
              e.setInputMatrixTexture(o, b, 1);
              var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "kernel_support");
              g.uniform1f(_, h);
              var x = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "points_per_row");
              g.uniform1f(x, f);
              var w = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "num_rows");
              g.uniform1f(w, p);
              var S = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "minV");
              g.uniform2f(S, l, u);
              var A = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "maxV");
              g.uniform2f(A, c, d), r.webgl.webgl_util.callAndCheck(g, function () {
                return g.drawArrays(g.TRIANGLES, 0, 2 * s * 3);
              }), g.disable(g.BLEND), null != v && (e.setProgram(v), r.webgl.gpgpu_util.bindVertexProgramAttributeStreams(e.gl, v, e.vertexBuffer));
            }(this.gpgpu, this.embeddingSplatterProgram, this._splatTexture, this.backend.getTexture(this.embedding.dataId), this.kernelTexture, this.splatTextureDiameter, this.numPoints, this._minX, this._minY, this._maxX, this._maxY, this.kernelSupport, this.pointsPerRow, this.numRows, this.splatVertexIdBuffer);
          }, e.prototype.computeInterpolatedQ = function (e) {
            !function (e, t, n, i, o, a, s, l, u, c, d, h) {
              var f = e.gl;
              null != h ? e.setOutputMatrixTexture(h, d, c) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
              var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "embedding_tex");
              e.setInputMatrixTexture(i, p, 0);
              var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "splat_tex");
              e.setInputMatrixTexture(n, m, 1);
              var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "points_per_row");
              f.uniform1f(g, c);
              var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_rows");
              f.uniform1f(v, d);
              var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_points");
              f.uniform1f(y, o);
              var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "minV");
              f.uniform2f(b, a, s);
              var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "maxV");
              f.uniform2f(_, l, u), e.executeProgram();
            }(this.gpgpu, this.qInterpolatorProgram, this._splatTexture, this.backend.getTexture(this.embedding.dataId), this.numPoints, this._minX, this._minY, this._maxX, this._maxY, this.pointsPerRow, this.numRows, this.backend.getTexture(e.dataId));
          }, e.prototype.computeInterpolatedXY = function (e) {
            !function (e, t, n, i, o, a, s, l, u, c, d, h, f) {
              var p = e.gl;
              null != o ? e.setOutputMatrixTexture(o, h, 2 * d) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
              var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "embedding_tex");
              e.setInputMatrixTexture(i, m, 0);
              var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "splat_tex");
              e.setInputMatrixTexture(n, g, 1);
              var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "points_per_row");
              p.uniform1f(v, d);
              var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "num_rows");
              p.uniform1f(y, h);
              var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "num_points");
              p.uniform1f(b, a);
              var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "eta");
              p.uniform1f(_, f);
              var x = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "minV");
              p.uniform2f(x, s, l);
              var w = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "maxV");
              p.uniform2f(w, u, c), e.executeProgram();
            }(this.gpgpu, this.xyInterpolatorProgram, this._splatTexture, this.backend.getTexture(this.embedding.dataId), this.backend.getTexture(e.dataId), this.numPoints, this._minX, this._minY, this._maxX, this._maxY, this.pointsPerRow, this.numRows, this._eta);
          }, e.prototype.computeAttractiveForces = function (e) {
            !function (e, t, n, i, o, a, s, l, u, c, d, h) {
              var f = e.gl;
              null != h ? e.setOutputMatrixTexture(h, c, 2 * u) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
              var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "embedding_tex");
              e.setInputMatrixTexture(n, p, 3);
              var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "offset_tex");
              e.setInputMatrixTexture(i, m, 2);
              var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "neigh_id_tex");
              e.setInputMatrixTexture(o, g, 1);
              var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "neigh_prob_tex");
              e.setInputMatrixTexture(a, v, 0);
              var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_rows");
              f.uniform1f(y, c);
              var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "eta");
              f.uniform1f(b, d);
              var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_neighs_per_row");
              f.uniform1f(_, l);
              var x = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_points");
              f.uniform1f(x, s);
              var w = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "points_per_row");
              f.uniform1f(w, u), e.executeProgram();
            }(this.gpgpu, this.attractiveForcesProgram, this.backend.getTexture(this.embedding.dataId), this.probOffsetTexture, this.probNeighIdTexture, this.probTexture, this.numPoints, this.numNeighPerRow, this.pointsPerRow, this.numRows, this._eta, this.backend.getTexture(e.dataId));
          }, e.prototype.computeDistributionParameters = function (e, t, n, i) {
            !function (e, t, n, i, o, a, s, l, u) {
              var c = e.gl;
              null != u ? e.setOutputMatrixTexture(u, s, a) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
              var d = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "knn_graph_tex");
              e.setInputMatrixTexture(n, d, 0);
              var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_rows");
              c.uniform1f(h, s);
              var f = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_points");
              c.uniform1f(f, i);
              var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "points_per_row");
              c.uniform1f(p, a);
              var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_neighs");
              c.uniform1f(m, o);
              var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "perplexity");
              c.uniform1f(g, l), e.executeProgram();
            }(this.gpgpu, this.distributionParameterssComputationProgram, i, t.numPoints, t.pixelsPerPoint, t.pointsPerRow, t.numRows, n, e);
          }, e.prototype.computeGaussianDistributions = function (e, t, n, i) {
            !function (e, t, n, i, o, a, s, l, u) {
              var c = e.gl;
              null != u ? e.setOutputMatrixTexture(u, l, s * a) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
              var d = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "knn_graph_tex");
              e.setInputMatrixTexture(n, d, 0);
              var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "parameters_tex");
              e.setInputMatrixTexture(i, h, 1);
              var f = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_rows");
              c.uniform1f(f, l);
              var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_points");
              c.uniform1f(p, o);
              var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "points_per_row");
              c.uniform1f(m, s);
              var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_neighs");
              c.uniform1f(g, a), e.executeProgram();
            }(this.gpgpu, this.gaussiaDistributionsFromDistancesProgram, i, t, n.numPoints, n.pixelsPerPoint, n.pointsPerRow, n.numRows, this.backend.getTexture(e.dataId));
          }, e;
        }(),
        T = function T(e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        M = function M(e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [0, i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        };
      function C() {
        var e = r.ENV.findBackend("webgl");
        if (null === e) throw Error("WebGL backend is not available");
        var t = e.getGPGPUContext().gl,
          n = 4 * (t.getParameter(t.MAX_VARYING_VECTORS) - 1);
        return Math.floor(n / 3);
      }
      function k(e, t) {
        return new P(e, t);
      }
      var P = function () {
        function e(e, t) {
          this.initialized = !1, this.probabilitiesInitialized = !1, this.data = e, this.config = t;
          var n = this.data.shape;
          if (this.numPoints = n[0], this.numDimensions = n[1], 2 !== n.length) throw Error("computeTSNE: input tensor must be 2-dimensional");
          var r = 18;
          void 0 !== this.config && void 0 !== this.config.perplexity && (r = this.config.perplexity);
          var i = C();
          if (r > i) throw Error("computeTSNE: perplexity cannot be greater than" + i + " on this machine");
        }
        return e.prototype.initialize = function () {
          return T(this, void 0, void 0, function () {
            var e, t, n, r, i, o, a;
            return M(this, function (s) {
              switch (s.label) {
                case 0:
                  return e = 18, t = 4, n = 300, r = 200, i = .8, this.verbose = !1, this.knnMode = "auto", void 0 !== this.config && (void 0 !== this.config.perplexity && (e = this.config.perplexity), void 0 !== this.config.exaggeration && (t = this.config.exaggeration), void 0 !== this.config.exaggerationIter && (n = this.config.exaggerationIter), void 0 !== this.config.exaggerationDecayIter && (r = this.config.exaggerationDecayIter), void 0 !== this.config.momentum && (i = this.config.momentum), void 0 !== this.config.verbose && (this.verbose = this.config.verbose), void 0 !== this.config.knnMode && (this.knnMode = this.config.knnMode)), this.numNeighbors = 4 * Math.floor(3 * e / 4), o = this, [4, w(this.data)];
                case 1:
                  return o.packedData = s.sent(), this.verbose && (console.log("Number of points:\t" + this.numPoints), console.log("Number of dimensions:\t " + this.numDimensions), console.log("Number of neighbors:\t" + this.numNeighbors), console.log("kNN mode:\t" + this.knnMode)), this.knnEstimator = new b(this.packedData.texture, this.packedData.shape, this.numPoints, this.numDimensions, this.numNeighbors, !1), this.optimizer = new E(this.numPoints, !1), a = [{
                    iteration: n,
                    value: t
                  }, {
                    iteration: n + r,
                    value: 1
                  }], this.verbose && console.log("Exaggerating for " + a[0].iteration + " iterations with a value of " + a[0].value + ". Exaggeration is removed after " + a[1].iteration + "."), this.optimizer.exaggeration = a, this.optimizer.momentum = i, 2500, 250, 2e3, this.numPoints > 2e3 ? this.optimizer.eta = 2500 : this.optimizer.eta = 250 + this.numPoints / 2e3 * 2250, [2];
              }
            });
          });
        }, e.prototype.compute = function (e) {
          return void 0 === e && (e = 1e3), T(this, void 0, void 0, function () {
            var t;
            return M(this, function (n) {
              switch (n.label) {
                case 0:
                  return t = this.knnIterations(), this.verbose && (console.log("Number of KNN iterations:\t" + t), console.log("Computing the KNN...")), [4, this.iterateKnn(t)];
                case 1:
                  return n.sent(), this.verbose && console.log("Computing the tSNE embedding..."), [4, this.iterate(e)];
                case 2:
                  return n.sent(), this.verbose && console.log("Done!"), [2];
              }
            });
          });
        }, e.prototype.iterateKnn = function (e) {
          return void 0 === e && (e = 1), T(this, void 0, void 0, function () {
            var t;
            return M(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.initialized ? [3, 2] : [4, this.initialize()];
                case 1:
                  n.sent(), n.label = 2;
                case 2:
                  for (this.probabilitiesInitialized = !1, t = 0; t < e; ++t) this.knnEstimator.iterateBruteForce(), this.knnEstimator.iteration % 100 == 0 && this.verbose && console.log("Iteration KNN:\t" + this.knnEstimator.iteration);
                  return [2];
              }
            });
          });
        }, e.prototype.iterate = function (e) {
          return void 0 === e && (e = 1), T(this, void 0, void 0, function () {
            var t;
            return M(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.probabilitiesInitialized ? [3, 2] : [4, this.initializeProbabilities()];
                case 1:
                  n.sent(), n.label = 2;
                case 2:
                  t = 0, n.label = 3;
                case 3:
                  return t < e ? [4, this.optimizer.iterate()] : [3, 6];
                case 4:
                  n.sent(), this.optimizer.iteration % 100 == 0 && this.verbose && console.log("Iteration tSNE:\t" + this.optimizer.iteration), n.label = 5;
                case 5:
                  return ++t, [3, 3];
                case 6:
                  return [2];
              }
            });
          });
        }, e.prototype.knnIterations = function () {
          return Math.ceil(this.numPoints / 20);
        }, e.prototype.coordinates = function (e) {
          var t = this;
          return void 0 === e && (e = !0), e ? r.tidy(function () {
            var e = t.optimizer.maxX - t.optimizer.minX,
              n = t.optimizer.maxY - t.optimizer.minY,
              i = r.tensor2d([t.optimizer.minX, t.optimizer.minY], [1, 2]),
              o = r.tensor2d([t.optimizer.maxX, t.optimizer.maxY], [1, 2]).sub(i),
              a = r.max(o),
              s = r.tidy(function () {
                return e < n ? r.tensor2d([(n - e) / 2, 0], [1, 2]) : r.tensor2d([0, (e - n) / 2], [1, 2]);
              });
            return t.optimizer.embedding2D.sub(i).add(s).div(a);
          }) : this.optimizer.embedding2D;
        }, e.prototype.coordsArray = function (e) {
          return void 0 === e && (e = !0), T(this, void 0, void 0, function () {
            var t, n, r;
            return M(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.coordinates(e).data()];
                case 1:
                  for (t = i.sent(), n = [], r = 0; r < t.length; r += 2) n.push([t[r], t[r + 1]]);
                  return [2, n];
              }
            });
          });
        }, e.prototype.knnTotalDistance = function () {
          return T(this, void 0, void 0, function () {
            var e = this;
            return M(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, r.tidy(function () {
                    return e.knnEstimator.distancesTensor().sum();
                  }).data()];
                case 1:
                  return [2, t.sent()[0]];
              }
            });
          });
        }, e.prototype.initializeProbabilities = function () {
          return T(this, void 0, void 0, function () {
            return M(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.verbose && console.log("Initializing probabilities"), [4, this.optimizer.initializeNeighborsFromKNNTexture(this.knnEstimator.knnShape, this.knnEstimator.knn())];
                case 1:
                  return e.sent(), this.probabilitiesInitialized = !0, [2];
              }
            });
          });
        }, e;
      }();
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/dataset_util.js": function node_modulesTensorflowTfjsTsneDistDataset_utilJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        i = n("./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js");
      t.generateDistanceComputationSource = function (e) {
        return "\n    #define DATA_NUM_PACKED_DIMENSIONS " + e.pixelsPerPoint + ".\n    #define DATA_POINTS_PER_ROW " + e.pointsPerRow + ".\n    #define DATA_NUM_ROWS " + e.numRows + ".\n    #define TEXTURE_WIDTH " + e.pointsPerRow * e.pixelsPerPoint + ".\n\n    //returns the texture coordinate for point/dimension\n    vec2 dataTexCoordinates(int id, int dimension) {\n      float id_f = float(id);\n      float row = (floor(id_f/DATA_POINTS_PER_ROW)+0.5) / DATA_NUM_ROWS;\n      float col = ((mod(id_f,DATA_POINTS_PER_ROW)*(DATA_NUM_PACKED_DIMENSIONS)\n                  + float(dimension)) + 0.5) / (TEXTURE_WIDTH);\n      return vec2(col,row);\n    }\n\n    //compute the euclidean squared distances between two points i and j\n    float pointDistanceSquared(int i, int j) {\n      vec4 result = vec4(0,0,0,0);\n      int num_iter = int(DATA_NUM_PACKED_DIMENSIONS);\n      for(int d = 0; d < num_iter; ++d) {\n        vec4 vi = texture(data_tex,dataTexCoordinates(i,d));\n        vec4 vj = texture(data_tex,dataTexCoordinates(j,d));\n        result += (vi-vj)*(vi-vj);\n      }\n      return (result.r+result.g+result.b+result.a);\n    }\n\n    //compute the euclidean squared distances between two points i and j\n    vec4 pointDistanceSquaredBatch(int i, int j0, int j1, int j2, int j3) {\n      vec4 result = vec4(0,0,0,0);\n      int num_iter = int(DATA_NUM_PACKED_DIMENSIONS);\n      for(int d = 0; d < num_iter; ++d) {\n        vec4 vi = texture(data_tex,dataTexCoordinates(i,d));\n        vec4 vj0 = texture(data_tex,dataTexCoordinates(j0,d));\n        vec4 vj1 = texture(data_tex,dataTexCoordinates(j1,d));\n        vec4 vj2 = texture(data_tex,dataTexCoordinates(j2,d));\n        vec4 vj3 = texture(data_tex,dataTexCoordinates(j3,d));\n        vj0 = (vi-vj0); vj0 *= vj0;\n        vj1 = (vi-vj1); vj1 *= vj1;\n        vj2 = (vi-vj2); vj2 *= vj2;\n        vj3 = (vi-vj3); vj3 *= vj3;\n        result.r += (vj0.r+vj0.g+vj0.b+vj0.a);\n        result.g += (vj1.r+vj1.g+vj1.b+vj1.a);\n        result.b += (vj2.r+vj2.g+vj2.b+vj2.a);\n        result.a += (vj3.r+vj3.g+vj3.b+vj3.a);\n      }\n      return result;\n    }\n    ";
      }, t.generateMNISTDistanceComputationSource = function () {
        return "\n  #define POINTS_PER_ROW 250.\n  #define NUM_ROWS 240.\n  #define TEXTURE_WIDTH 3500.\n  #define TEXTURE_HEIGHT 3360.\n  #define DIGIT_WIDTH 14.\n  #define NUM_PACKED_DIMENSIONS 196\n\n  //returns the texture coordinate for point/dimension\n  vec2 dataTexCoordinates(int id, int dimension) {\n    float id_f = float(id);\n    float dimension_f = float(dimension);\n    float col = ((mod(id_f,POINTS_PER_ROW)*DIGIT_WIDTH));\n    float row = (floor(id_f/POINTS_PER_ROW)*DIGIT_WIDTH);\n\n    return (vec2(col,row)+\n            vec2(mod(dimension_f,DIGIT_WIDTH),floor(dimension_f/DIGIT_WIDTH))+\n            vec2(0.5,0.5)\n            )/\n            vec2(TEXTURE_WIDTH,TEXTURE_HEIGHT);\n  }\n\n  //compute the euclidean squared distances between two points i and j\n  float pointDistanceSquared(int i, int j) {\n    vec4 result = vec4(0,0,0,0);\n    for(int d = 0; d < NUM_PACKED_DIMENSIONS; d+=1) {\n      vec4 vi = texture(data_tex,dataTexCoordinates(i,d));\n      vec4 vj = texture(data_tex,dataTexCoordinates(j,d));\n      result += (vi-vj)*(vi-vj);\n    }\n    return (result.r+result.g+result.b+result.a);\n  }\n\n  //compute the euclidean squared distances between two points i and j\n  vec4 pointDistanceSquaredBatch(int i, int j0, int j1, int j2, int j3) {\n    vec4 result = vec4(0,0,0,0);\n    for(int d = 0; d < NUM_PACKED_DIMENSIONS; d+=1) {\n      vec4 vi = texture(data_tex,dataTexCoordinates(i,d));\n      vec4 vj0 = texture(data_tex,dataTexCoordinates(j0,d));\n      vec4 vj1 = texture(data_tex,dataTexCoordinates(j1,d));\n      vec4 vj2 = texture(data_tex,dataTexCoordinates(j2,d));\n      vec4 vj3 = texture(data_tex,dataTexCoordinates(j3,d));\n      vj0 = (vi-vj0); vj0 *= vj0;\n      vj1 = (vi-vj1); vj1 *= vj1;\n      vj2 = (vi-vj2); vj2 *= vj2;\n      vj3 = (vi-vj3); vj3 *= vj3;\n      result.r += (vj0.r+vj0.g+vj0.b+vj0.a);\n      result.g += (vj1.r+vj1.g+vj1.b+vj1.a);\n      result.b += (vj2.r+vj2.g+vj2.b+vj2.a);\n      result.a += (vj3.r+vj3.g+vj3.b+vj3.a);\n    }\n    return result;\n  }\n  ";
      }, t.generateKNNClusterTexture = function (e, t, n) {
        for (var o = Math.floor(Math.sqrt(e * n) / n), a = Math.ceil(e / o), s = {
            numPoints: e,
            pixelsPerPoint: n,
            numRows: a,
            pointsPerRow: o
          }, l = Math.ceil(e / t), u = new Float32Array(o * n * a * 2), c = 0; c < e; ++c) for (var d = Math.floor(c / l), h = 0; h < n; ++h) {
          var f = 2 * (c * n + h);
          u[f] = Math.floor(Math.random() * l) + d * l, u[f + 1] = Math.random();
        }
        var p = r.ENV.findBackend("webgl");
        if (null === p) throw Error("WebGL backend is not available");
        var m = p.getGPGPUContext();
        return {
          knnGraph: i.createAndConfigureTexture(m.gl, o * n, a, 2, u),
          dataShape: s
        };
      }, t.generateKNNLineTexture = function (e, t) {
        for (var n = Math.floor(Math.sqrt(e * t) / t), o = Math.ceil(e / n), a = {
            numPoints: e,
            pixelsPerPoint: t,
            numRows: o,
            pointsPerRow: n
          }, s = new Float32Array(n * t * o * 2), l = 0; l < e; ++l) for (var u = 0; u < t; ++u) {
          var c = 2 * (l * t + u);
          s[c] = Math.floor(l + u - t / 2 + e) % e, s[c + 1] = 1;
        }
        var d = r.ENV.findBackend("webgl");
        if (null === d) throw Error("WebGL backend is not available");
        var h = d.getGPGPUContext();
        return {
          knnGraph: i.createAndConfigureTexture(h.gl, n * t, o, 2, s),
          dataShape: a
        };
      }, t.generateKNNClusterData = function (e, t, n) {
        for (var r = Math.ceil(e / t), i = new Float32Array(e * n), o = new Uint32Array(e * n), a = 0; a < e; ++a) for (var s = Math.floor(a / r), l = 0; l < n; ++l) {
          var u = a * n + l;
          i[u] = Math.random(), o[u] = Math.floor(Math.random() * r) + s * r;
        }
        return {
          distances: i,
          indices: o
        };
      }, t.generateKNNLineData = function (e, t) {
        for (var n = new Float32Array(e * t), r = new Uint32Array(e * t), i = 0; i < e; ++i) for (var o = 0; o < t; ++o) {
          var a = i * t + o;
          n[a] = 1, r[a] = Math.floor(i + o - t / 2 + e) % e;
        }
        return {
          distances: n,
          indices: r
        };
      };
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js": function node_modulesTensorflowTfjsTsneDistGl_utilJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js");
      function i(e, t) {
        return 4 === t ? e.RGBA32F : 3 === t ? e.RGB32F : 2 === t ? e.RG32F : e.R32F;
      }
      function o(e, t) {
        return 4 === t ? e.RGBA : 3 === t ? e.RGB : 2 === t ? e.RG : e.RED;
      }
      function a(e) {
        return e.FLOAT;
      }
      t.createVertexProgram = function (e, t, n) {
        var i = r.webgl.webgl_util.createVertexShader(e, t),
          o = r.webgl.webgl_util.createFragmentShader(e, n),
          a = r.webgl.webgl_util.createProgram(e);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.attachShader(a, i);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.attachShader(a, o);
        }), r.webgl.webgl_util.linkProgram(e, a), r.webgl.webgl_util.validateProgram(e, a), a;
      }, t.createAndConfigureInterpolatedTexture = function (e, t, n, s, l) {
        r.webgl.webgl_util.validateTextureSize(e, t, n);
        var u = r.webgl.webgl_util.createTexture(e),
          c = e.TEXTURE_2D,
          d = i(e, s),
          h = o(e, s);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(c, u);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MIN_FILTER, e.LINEAR);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MAG_FILTER, e.LINEAR);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texImage2D(c, 0, d, t, n, 0, h, a(e), l);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(e.TEXTURE_2D, null);
        }), u;
      }, t.createAndConfigureTexture = function (e, t, n, s, l) {
        r.webgl.webgl_util.validateTextureSize(e, t, n);
        var u = r.webgl.webgl_util.createTexture(e),
          c = e.TEXTURE_2D,
          d = i(e, s),
          h = o(e, s);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(c, u);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MIN_FILTER, e.NEAREST);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(c, e.TEXTURE_MAG_FILTER, e.NEAREST);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texImage2D(c, 0, d, t, n, 0, h, a(e), l);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(e.TEXTURE_2D, null);
        }), u;
      }, t.createAndConfigureUByteTexture = function (e, t, n, i, a) {
        r.webgl.webgl_util.validateTextureSize(e, t, n);
        var s = r.webgl.webgl_util.createTexture(e),
          l = e.TEXTURE_2D,
          u = function (e, t) {
            if (4 === t) return e.RGBA8;
            if (3 === t) return e.RGB8;
            if (2 === t) return e.RG8;
            return e.R8;
          }(e, i),
          c = o(e, i);
        return r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(l, s);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(l, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(l, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(l, e.TEXTURE_MIN_FILTER, e.NEAREST);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texParameteri(l, e.TEXTURE_MAG_FILTER, e.NEAREST);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.texImage2D(l, 0, u, t, n, 0, c, function (e) {
            return e.UNSIGNED_BYTE;
          }(e), a);
        }), r.webgl.webgl_util.callAndCheck(e, function () {
          return e.bindTexture(e.TEXTURE_2D, null);
        }), s;
      };
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/knn.js": function node_modulesTensorflowTfjsTsneDistKnnJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        i = n("./node_modules/@tensorflow/tfjs-tsne/dist/dataset_util.js"),
        o = n("./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js"),
        a = n("./node_modules/@tensorflow/tfjs-tsne/dist/knn_util.js");
      var s = function () {
        function e(e, t, n, o, a, s) {
          if (null != s ? this.verbose = s : s = !1, this.backend = r.ENV.findBackend("webgl"), this.gpgpu = this.backend.getGPGPUContext(), this._iteration = 0, this.dataTexture = e, a > 128) throw new Error("kNN size must not be greater than 128");
          if (a % 4 != 0) throw new Error("kNN size must be a multiple of 4");
          this.numNeighs = a;
          var l,
            u,
            c = Math.ceil(Math.sqrt(a * n) / a);
          if (this.knnDataShape = {
            numPoints: n,
            pixelsPerPoint: a,
            pointsPerRow: c,
            numRows: Math.ceil(n / c)
          }, this.log("knn-pntsPerRow", this.knnDataShape.pointsPerRow), this.log("knn-numRows", this.knnDataShape.numRows), this.log("knn-pixelsPerPoint", this.knnDataShape.pixelsPerPoint), "numPoints" in (u = t) && "pointsPerRow" in u && "pixelsPerPoint" in u && "numRows" in u) {
            var d = t;
            l = i.generateDistanceComputationSource(d);
          } else if (function (e) {
            return "distanceComputationCode" in e;
          }(t)) {
            l = t.distanceComputationCode;
          }
          this.initializeTextures(), this.initilizeCustomWebGLPrograms(l);
        }
        return Object.defineProperty(e.prototype, "knnShape", {
          get: function get() {
            return this.knnDataShape;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "iteration", {
          get: function get() {
            return this._iteration;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "pointsPerIteration", {
          get: function get() {
            return 20;
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.log = function (e, t) {
          this.verbose && (null != t ? console.log(e + ": \t" + t) : console.log(e));
        }, e.prototype.initializeTextures = function () {
          for (var e = new Float32Array(this.knnDataShape.pointsPerRow * this.knnDataShape.pixelsPerPoint * 2 * this.knnDataShape.numRows), t = this.knnDataShape.pixelsPerPoint, n = 0; n < this.knnDataShape.numPoints; ++n) for (var r = 0; r < t; ++r) e[2 * (n * t + r)] = -1, e[2 * (n * t + r) + 1] = 1e31;
          this.knnTexture0 = o.createAndConfigureTexture(this.gpgpu.gl, this.knnDataShape.pointsPerRow * this.knnDataShape.pixelsPerPoint, this.knnDataShape.numRows, 2, e), this.knnTexture1 = o.createAndConfigureTexture(this.gpgpu.gl, this.knnDataShape.pointsPerRow * this.knnDataShape.pixelsPerPoint, this.knnDataShape.numRows, 2, e);
        }, e.prototype.initilizeCustomWebGLPrograms = function (e) {
          this.copyDistancesProgram = a.createCopyDistancesProgram(this.gpgpu), this.copyIndicesProgram = a.createCopyIndicesProgram(this.gpgpu), this.bruteForceKNNProgram = a.createBruteForceKNNProgram(this.gpgpu, this.numNeighs, e), this.randomSamplingKNNProgram = a.createRandomSamplingKNNProgram(this.gpgpu, this.numNeighs, e), this.kNNDescentProgram = a.createKNNDescentProgram(this.gpgpu, this.numNeighs, e);
          for (var t = new Float32Array(2 * this.knnDataShape.numPoints), n = 0; n < 2 * this.knnDataShape.numPoints; ++n) t[n] = n;
          this.linesVertexIdBuffer = r.webgl.webgl_util.createStaticVertexBuffer(this.gpgpu.gl, t);
        }, e.prototype.iterateBruteForce = function () {
          this._iteration % 2 == 0 ? this.iterateGPU(this.dataTexture, this._iteration, this.knnTexture0, this.knnTexture1) : this.iterateGPU(this.dataTexture, this._iteration, this.knnTexture1, this.knnTexture0), ++this._iteration, this.gpgpu.gl.finish();
        }, e.prototype.iterateRandomSampling = function () {
          this._iteration % 2 == 0 ? this.iterateRandomSamplingGPU(this.dataTexture, this._iteration, this.knnTexture0, this.knnTexture1) : this.iterateRandomSamplingGPU(this.dataTexture, this._iteration, this.knnTexture1, this.knnTexture0), ++this._iteration, this.gpgpu.gl.finish();
        }, e.prototype.iterateKNNDescent = function () {
          this._iteration % 2 == 0 ? this.iterateKNNDescentGPU(this.dataTexture, this._iteration, this.knnTexture0, this.knnTexture1) : this.iterateKNNDescentGPU(this.dataTexture, this._iteration, this.knnTexture1, this.knnTexture0), ++this._iteration, this.gpgpu.gl.finish();
        }, e.prototype.knn = function () {
          return this._iteration % 2 == 0 ? this.knnTexture0 : this.knnTexture1;
        }, e.prototype.distancesTensor = function () {
          var e = this;
          return r.tidy(function () {
            var t = r.zeros([e.knnDataShape.numRows, e.knnDataShape.pointsPerRow * e.knnDataShape.pixelsPerPoint]),
              n = e.knn();
            return a.executeCopyDistancesProgram(e.gpgpu, e.copyDistancesProgram, n, e.knnDataShape, e.backend.getTexture(t.dataId)), t.reshape([e.knnDataShape.numRows * e.knnDataShape.pointsPerRow, e.knnDataShape.pixelsPerPoint]).slice([0, 0], [e.knnDataShape.numPoints, e.knnDataShape.pixelsPerPoint]);
          });
        }, e.prototype.indicesTensor = function () {
          var e = this;
          return r.tidy(function () {
            var t = r.zeros([e.knnDataShape.numRows, e.knnDataShape.pointsPerRow * e.knnDataShape.pixelsPerPoint]),
              n = e.knn();
            return a.executeCopyIndicesProgram(e.gpgpu, e.copyIndicesProgram, n, e.knnDataShape, e.backend.getTexture(t.dataId)), t.reshape([e.knnDataShape.numRows * e.knnDataShape.pointsPerRow, e.knnDataShape.pixelsPerPoint]).slice([0, 0], [e.knnDataShape.numPoints, e.knnDataShape.pixelsPerPoint]);
          });
        }, e.prototype.iterateGPU = function (e, t, n, r) {
          a.executeKNNProgram(this.gpgpu, this.bruteForceKNNProgram, e, n, t, this.knnDataShape, this.linesVertexIdBuffer, r);
        }, e.prototype.iterateRandomSamplingGPU = function (e, t, n, r) {
          a.executeKNNProgram(this.gpgpu, this.randomSamplingKNNProgram, e, n, t, this.knnDataShape, this.linesVertexIdBuffer, r);
        }, e.prototype.iterateKNNDescentGPU = function (e, t, n, r) {
          a.executeKNNProgram(this.gpgpu, this.kNNDescentProgram, e, n, t, this.knnDataShape, this.linesVertexIdBuffer, r);
        }, e;
      }();
      t.KNNEstimator = s;
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/knn_util.js": function node_modulesTensorflowTfjsTsneDistKnn_utilJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        i = n("./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js");
      function o(e, t) {
        return "#version 300 es\n    precision highp float;\n    uniform sampler2D data_tex;\n    uniform float num_points;\n    uniform float points_per_row_knn;\n    uniform float num_rows_knn;\n    uniform float num_neighs;\n    uniform float iteration;\n\n    #define NUM_PACKED_NEIGHBORS " + t / 4 + "\n\n    flat in vec4 knn[NUM_PACKED_NEIGHBORS];\n    flat in int point_id;\n    in float neighbor_id;\n\n    const float MAX_DIST = 10e30;\n\n    " + e + "\n\n    out vec4 fragmentColor;\n    void main() {\n      int id = int(neighbor_id/4.);\n      int channel = int(mod(neighbor_id,4.)+0.1);\n\n      if(channel == 0) {\n        fragmentColor = vec4(knn[id].r,0,0,1);\n      }else if(channel == 1) {\n        fragmentColor = vec4(knn[id].g,0,0,1);\n      }else if(channel == 2) {\n        fragmentColor = vec4(knn[id].b,0,0,1);\n      }else if(channel == 3) {\n        fragmentColor = vec4(knn[id].a,0,0,1);\n      }\n\n      //If the neighbor has a valid id i compute the distance squared\n      //otherwise I set it to invalid\n      if(fragmentColor.r >= 0.) {\n        fragmentColor.g = pointDistanceSquared(int(fragmentColor.r),point_id);\n      }else{\n        fragmentColor.g = MAX_DIST;\n      }\n    }\n  ";
      }
      function a(e) {
        return "\n  precision highp float;\n  #define NEIGH_PER_ITER 20\n  #define NUM_NEIGHBORS " + e + "\n  #define NUM_NEIGHBORS_FLOAT " + e + ".\n  #define NUM_PACKED_NEIGHBORS " + e / 4 + "\n  #define MAX_DIST 10e30\n\n  //attributes\n  in float vertex_id;\n  //uniforms\n  uniform sampler2D data_tex;\n  uniform sampler2D starting_knn_tex;\n  uniform float num_points;\n  uniform float points_per_row_knn;\n  uniform float num_rows_knn;\n  uniform float num_neighs;\n  uniform float iteration;\n\n  //output\n  //the indices are packed in varying vectors\n  flat out vec4 knn[NUM_PACKED_NEIGHBORS];\n  //used to recover the neighbor id in the fragment shader\n  out float neighbor_id;\n  //used to recover the point id in the fragment shader\n  //(for recomputing distances)\n  flat out int point_id;\n\n  float distances_heap[NUM_NEIGHBORS];\n  int knn_heap[NUM_NEIGHBORS];\n  ";
      }
      var s = "\n//Random function developed by Inigo Quilez\n//https://www.shadertoy.com/view/llGSzw\nfloat hash1( uint n ) {\n    // integer hash copied from Hugo Elias\n\t  n = (n << 13U) ^ n;\n    n = n * (n * n * 15731U + 789221U) + 1376312589U;\n    return float( n & uvec3(0x7fffffffU))/float(0x7fffffff);\n}\n\nuint hash( uint x ) {\n    x += ( x << 10u );\n    x ^= ( x >>  6u );\n    x += ( x <<  3u );\n    x ^= ( x >> 11u );\n    x += ( x << 15u );\n    return x;\n}\nfloat random( float f ) {\n    const uint mantissaMask = 0x007FFFFFu;\n    const uint one          = 0x3F800000u;\n\n    uint h = hash( floatBitsToUint( f ) );\n    h &= mantissaMask;\n    h |= one;\n\n    float  r2 = uintBitsToFloat( h );\n    return r2 - 1.0;\n}\n\n\n// #define HASHSCALE1 .1031\n// float random(float p) {\n// \tvec3 p3  = fract(vec3(p) * HASHSCALE1);\n//   p3 += dot(p3, p3.yzx + 19.19);\n//   return fract((p3.x + p3.y) * p3.z);\n// }\n\n// const vec2 randomConst = vec2(\n//   23.14069263277926, // e^pi (Gelfond's constant)\n//    2.665144142690225 // 2^sqrt(2) (Gelfond–Schneider constant)\n// );\n// float random(float seed) {\n//     return fract(cos(dot(vec2(seed,seed), randomConst)) * 12345.6789);\n// }\n\n",
        l = "\n//Reads the distances and indices from the knn texture\nvoid initializeDistances(int pnt_id) {\n  //row coordinate in the texture\n  float row = (floor(float(pnt_id)/points_per_row_knn)+0.5)/num_rows_knn;\n  //column of the first neighbor\n  float start_col = mod(float(pnt_id),points_per_row_knn)*NUM_NEIGHBORS_FLOAT;\n  for(int n = 0; n < NUM_NEIGHBORS; n++) {\n    float col = (start_col+float(n)+0.5);\n    //normalized by the width of the texture\n    col /= (points_per_row_knn*NUM_NEIGHBORS_FLOAT);\n    //reads the index in the red channel and the distances in the green one\n    vec4 init = texture(starting_knn_tex,vec2(col,row));\n\n    knn_heap[n] = int(init.r);\n    distances_heap[n] = init.g;\n  }\n}\n",
        u = "\n//Swaps two points in the knn-heap\nvoid swap(int i, int j) {\n  float swap_value = distances_heap[i];\n  distances_heap[i] = distances_heap[j];\n  distances_heap[j] = swap_value;\n  int swap_id = knn_heap[i];\n  knn_heap[i] = knn_heap[j];\n  knn_heap[j] = swap_id;\n}\n\n//I can make use of the heap property but\n//I have to implement a recursive function\nbool inTheHeap(float dist_sq, int id) {\n  for(int i = 0; i < NUM_NEIGHBORS; ++i) {\n    if(knn_heap[i] == id) {\n      return true;\n    }\n  }\n  return false;\n}\n\nvoid insertInKNN(float dist_sq, int j) {\n  //not in the KNN\n  if(dist_sq >= distances_heap[0]) {\n    return;\n  }\n\n  //the point is already in the KNN\n  if(inTheHeap(dist_sq,j)) {\n    return;\n  }\n\n  //Insert in the new point in the root\n  distances_heap[0] = dist_sq;\n  knn_heap[0] = j;\n  //Sink procedure\n  int swap_id = 0;\n  while(swap_id*2+1 < NUM_NEIGHBORS) {\n    int left_id = swap_id*2+1;\n    int right_id = swap_id*2+2;\n    if(distances_heap[left_id] > distances_heap[swap_id] ||\n        (right_id < NUM_NEIGHBORS &&\n                            distances_heap[right_id] > distances_heap[swap_id])\n      ) {\n      if(distances_heap[left_id] > distances_heap[right_id]\n         || right_id >= NUM_NEIGHBORS) {\n        swap(swap_id,left_id);\n        swap_id = left_id;\n      }else{\n        swap(swap_id,right_id);\n        swap_id = right_id;\n      }\n    }else{\n      break;\n    }\n  }\n}\n",
        c = "\n  //Line positions\n  float row = (floor(float(point_id)/points_per_row_knn)+0.5)/num_rows_knn;\n  row = row*2.0-1.0;\n  if(line_id < int(1)) {\n    //for the first vertex only the position is important\n    float col = (mod(float(point_id),points_per_row_knn))/(points_per_row_knn);\n    col = col*2.0-1.0;\n    gl_Position = vec4(col,row,0,1);\n    neighbor_id = 0.;\n    return;\n  }\n  //The computation of the KNN happens only for the second vertex\n  float col = (mod(float(point_id),points_per_row_knn)+1.)/(points_per_row_knn);\n  col = col*2.0-1.0;\n  gl_Position = vec4(col,row,0,1);\n";
      t.createBruteForceKNNProgram = function (e, t, n) {
        var r = "#version 300 es\n    " + a(t) + l + n + u + "\n    void main() {\n      //Getting the id of the point and the line id (0/1)\n      point_id = int((vertex_id / 2.0) + 0.1);\n      int line_id = int(mod(vertex_id + 0.1, 2.));\n      if(float(point_id) >= num_points) {\n        return;\n      }\n\n      " + c + "\n\n      //////////////////////////////////\n      //KNN computation\n      initializeDistances(point_id);\n      for(int i = 0; i < NEIGH_PER_ITER; i += 4) {\n        //TODO make it more readable\n\n        int j = int(mod(\n                    float(point_id + i) //point id + current offset\n                    + iteration * float(NEIGH_PER_ITER) //iteration offset\n                    + 1.25,// +1 for avoid checking the point itself,\n                           // +0.25 for error compensation\n                    num_points\n                  ));\n        vec4 dist_squared = pointDistanceSquaredBatch(point_id,j,j+1,j+2,j+3);\n        insertInKNN(dist_squared.r, j);\n        insertInKNN(dist_squared.g, j+1);\n        insertInKNN(dist_squared.b, j+2);\n        insertInKNN(dist_squared.a, j+3);\n      }\n\n      for(int n = 0; n < NUM_PACKED_NEIGHBORS; n++) {\n        knn[n].r = float(knn_heap[n*4]);\n        knn[n].g = float(knn_heap[n*4+1]);\n        knn[n].b = float(knn_heap[n*4+2]);\n        knn[n].a = float(knn_heap[n*4+3]);\n      }\n\n      neighbor_id = NUM_NEIGHBORS_FLOAT;\n    }\n  ",
          s = o(n, t);
        return i.createVertexProgram(e.gl, r, s);
      }, t.createRandomSamplingKNNProgram = function (e, t, n) {
        var r = "#version 300 es\n    " + a(t) + l + s + n + u + "\n    void main() {\n      //Getting the id of the point and the line id (0/1)\n      point_id = int((vertex_id/2.0)+0.1);\n      int line_id = int(mod(vertex_id+0.1,2.));\n      if(float(point_id) >= num_points) {\n        return;\n      }\n\n      " + c + "\n\n      //////////////////////////////////\n      //KNN computation\n\n      initializeDistances(point_id);\n      for(int i = 0; i < NEIGH_PER_ITER; i += 4) {\n        //BAD SEED\n        //uint seed\n        //= uint(float(point_id) + float(NEIGH_PER_ITER)*iteration + float(i));\n        //GOOD SEED\n        //uint seed\n        //= uint(float(point_id) + float(num_points)*iteration + float(i));\n\n        float seed\n            = float(float(point_id) + float(num_points)*iteration + float(i));\n        int j0 = int(random(seed)*num_points);\n        int j1 = int(random(seed+1.)*num_points);\n        int j2 = int(random(seed+2.)*num_points);\n        int j3 = int(random(seed+3.)*num_points);\n\n        vec4 dist_squared = pointDistanceSquaredBatch(point_id,j0,j1,j2,j3);\n        if(j0!=point_id)insertInKNN(dist_squared.r, j0);\n        if(j1!=point_id)insertInKNN(dist_squared.g, j1);\n        if(j2!=point_id)insertInKNN(dist_squared.b, j2);\n        if(j3!=point_id)insertInKNN(dist_squared.a, j3);\n      }\n\n      for(int n = 0; n < NUM_PACKED_NEIGHBORS; n++) {\n        knn[n].r = float(knn_heap[n*4]);\n        knn[n].g = float(knn_heap[n*4+1]);\n        knn[n].b = float(knn_heap[n*4+2]);\n        knn[n].a = float(knn_heap[n*4+3]);\n      }\n      neighbor_id = NUM_NEIGHBORS_FLOAT;\n    }\n  ",
          d = o(n, t);
        return i.createVertexProgram(e.gl, r, d);
      }, t.createKNNDescentProgram = function (e, t, n) {
        var r = "#version 300 es\n    " + a(t) + l + s + n + u + "\n    int fetchNeighborIdFromKNNTexture(int id, int neighbor_id) {\n      //row coordinate in the texture\n      float row = (floor(float(id)/points_per_row_knn)+0.5)/num_rows_knn;\n      //column of the first neighbor\n      float start_col = mod(float(id),points_per_row_knn)*NUM_NEIGHBORS_FLOAT;\n      //column of the neighbor of interest\n      float col = (start_col+float(neighbor_id)+0.5);\n      //normalized by the width of the texture\n      col /= (points_per_row_knn*NUM_NEIGHBORS_FLOAT);\n      //reads the index in the red channel and the distances in the green one\n      vec4 knn_link = texture(starting_knn_tex,vec2(col,row));\n      //return the index\n      return int(knn_link.r);\n    }\n\n    int neighborOfANeighbor(int my_id, uint seed) {\n      //float random0 = hash1(seed);\n      float random0 = random(float(seed));\n      // random0 = random0*random0;\n      // random0 = 1. - random0;\n\n      //float random1 = hash1(seed*1798191U);\n      float random1 = random(float(seed+7U));\n      // random1 = random1*random1;\n      // random1 = 1. - random1;\n\n      //fetch a neighbor from the heap\n      int neighbor = knn_heap[int(random0*NUM_NEIGHBORS_FLOAT)];\n      //if it is not a valid pick a random point\n      if(neighbor < 0) {\n        return int(random(float(seed))*num_points);\n      }\n\n      //if it is valid I fetch from the knn graph texture one of its neighbors\n      int neighbor2ndDegree = fetchNeighborIdFromKNNTexture(\n                                    neighbor,int(random1*NUM_NEIGHBORS_FLOAT));\n      //if it is not a valid pick a random point\n      if(neighbor2ndDegree < 0) {\n        return int(random(float(seed))*num_points);\n      }\n      return neighbor2ndDegree;\n    }\n\n    void main() {\n      //Getting the id of the point and the line id (0/1)\n      point_id = int((vertex_id/2.0)+0.1);\n      int line_id = int(mod(vertex_id+0.1,2.));\n      if(float(point_id) >= num_points) {\n        return;\n      }\n      " + c + "\n\n      //////////////////////////////////\n      //KNN computation\n      initializeDistances(point_id);\n      for(int i = 0; i < NEIGH_PER_ITER; i += 4) {\n        //BAD SEED\n        //uint seed\n        //= uint(float(point_id) + float(NEIGH_PER_ITER)*iteration + float(i));\n        //GOOD SEED\n        uint seed\n              = uint(float(point_id) + float(num_points)*iteration + float(i));\n        int j0 = neighborOfANeighbor(point_id,seed);\n        int j1 = neighborOfANeighbor(point_id,seed+1U);\n        int j2 = neighborOfANeighbor(point_id,seed+2U);\n        int j3 = neighborOfANeighbor(point_id,seed+3U);\n\n        vec4 dist_squared = pointDistanceSquaredBatch(point_id,j0,j1,j2,j3);\n        if(j0!=point_id)insertInKNN(dist_squared.r, j0);\n        if(j1!=point_id)insertInKNN(dist_squared.g, j1);\n        if(j2!=point_id)insertInKNN(dist_squared.b, j2);\n        if(j3!=point_id)insertInKNN(dist_squared.a, j3);\n      }\n\n      for(int n = 0; n < NUM_PACKED_NEIGHBORS; n++) {\n        knn[n].r = float(knn_heap[n*4]);\n        knn[n].g = float(knn_heap[n*4+1]);\n        knn[n].b = float(knn_heap[n*4+2]);\n        knn[n].a = float(knn_heap[n*4+3]);\n      }\n      neighbor_id = NUM_NEIGHBORS_FLOAT;\n    }\n  ",
          d = o(n, t);
        return i.createVertexProgram(e.gl, r, d);
      }, t.executeKNNProgram = function (e, t, n, i, o, a, s, l) {
        var u = e.gl,
          c = e.program,
          d = u.getParameter(u.LINE_WIDTH);
        null != l ? e.setOutputMatrixTexture(l, a.numRows, a.pointsPerRow * a.pixelsPerPoint) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), 1 !== d && u.lineWidth(1), e.setProgram(t), u.clearColor(0, 0, 0, 0), u.clear(u.COLOR_BUFFER_BIT), r.webgl.webgl_util.callAndCheck(u, function () {
          return u.bindBuffer(u.ARRAY_BUFFER, s);
        }), r.webgl.webgl_util.bindVertexBufferToProgramAttribute(u, t, "vertex_id", s, 1, 0, 0);
        var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "data_tex");
        e.setInputMatrixTexture(n, h, 0);
        var f = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "starting_knn_tex");
        e.setInputMatrixTexture(i, f, 1);
        var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "iteration");
        u.uniform1f(p, o);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "num_points");
        u.uniform1f(m, a.numPoints);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "points_per_row_knn");
        u.uniform1f(g, a.pointsPerRow);
        var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(u, t, "num_rows_knn");
        u.uniform1f(v, a.numRows), r.webgl.webgl_util.callAndCheck(u, function () {
          return u.drawArrays(u.LINES, 0, 2 * a.numPoints);
        }), null != c && (e.setProgram(c), r.webgl.gpgpu_util.bindVertexProgramAttributeStreams(e.gl, c, e.vertexBuffer)), 1 !== d && u.lineWidth(d);
      }, t.createCopyDistancesProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n    uniform sampler2D knn_tex;\n    uniform float width;\n    uniform float height;\n\n    void main() {\n      vec2 coordinates = gl_FragCoord.xy / vec2(width,height);\n      float distance = texture2D(knn_tex,coordinates).g;\n      gl_FragColor = vec4(distance,0,0,1);\n    }\n  ");
      }, t.executeCopyDistancesProgram = function (e, t, n, i, o) {
        var a = e.gl;
        null != o ? e.setOutputMatrixTexture(o, i.numRows, i.pointsPerRow * i.pixelsPerPoint) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var s = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "knn_tex");
        e.setInputMatrixTexture(n, s, 0);
        var l = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "width");
        a.uniform1f(l, i.pointsPerRow * i.pixelsPerPoint);
        var u = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "height");
        a.uniform1f(u, i.numRows), e.executeProgram();
      }, t.createCopyIndicesProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n    uniform sampler2D knn_tex;\n    uniform float width;\n    uniform float height;\n\n    void main() {\n      vec2 coordinates = gl_FragCoord.xy / vec2(width,height);\n      float id = texture2D(knn_tex,coordinates).r;\n      gl_FragColor = vec4(id,0,0,1);\n\n      if(id < 0.) {\n        gl_FragColor.b = 1.;\n      }\n    }\n  ");
      }, t.executeCopyIndicesProgram = function (e, t, n, i, o) {
        var a = e.gl;
        null != o ? e.setOutputMatrixTexture(o, i.numRows, i.pointsPerRow * i.pixelsPerPoint) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var s = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "knn_tex");
        e.setInputMatrixTexture(n, s, 0);
        var l = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "width");
        a.uniform1f(l, i.pointsPerRow * i.pixelsPerPoint);
        var u = r.webgl.webgl_util.getProgramUniformLocationOrThrow(a, t, "height");
        a.uniform1f(u, i.numRows), e.executeProgram();
      };
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/tensor_to_data_texture.js": function node_modulesTensorflowTfjsTsneDistTensor_to_data_textureJs(e, t, n) {
      "use strict";

      var r = this && this.__awaiter || function (e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        i = this && this.__generator || function (e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [0, i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        a = n("./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js");
      t.tensorToDataTexture = function (e) {
        return r(this, void 0, void 0, function () {
          var t, n, r, s, l, u, c, d, h, f, p, m, g, v, y;
          return i(this, function (i) {
            if (2 !== (t = e.shape).length) throw Error("tensorToDataTexture: input tensor must be 2-dimensional");
            if (null === (n = o.ENV.findBackend("webgl"))) throw Error("WebGL backend is not available");
            for (r = n.getGPGPUContext(), s = t[0], l = t[1], 4, u = Math.ceil(l / 4), c = Math.floor(Math.sqrt(s * u) / u), d = Math.ceil(s / c), h = e.dataSync(), f = new Float32Array(c * u * d * 4), p = 0; p < s; ++p) for (m = p * l, g = p * u * 4, v = 0; v < l; ++v) f[g + v] = h[m + v];
            return y = a.createAndConfigureTexture(r.gl, c * u, d, 4, f), [2, {
              shape: {
                numPoints: s,
                pointsPerRow: c,
                numRows: d,
                pixelsPerPoint: u
              },
              texture: y
            }];
          });
        });
      };
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/tsne.js": function node_modulesTensorflowTfjsTsneDistTsneJs(e, t, n) {
      "use strict";

      var r = this && this.__awaiter || function (e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        i = this && this.__generator || function (e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [0, i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        a = n("./node_modules/@tensorflow/tfjs-tsne/dist/knn.js"),
        s = n("./node_modules/@tensorflow/tfjs-tsne/dist/tensor_to_data_texture.js"),
        l = n("./node_modules/@tensorflow/tfjs-tsne/dist/tsne_optimizer.js");
      function u() {
        var e = o.ENV.findBackend("webgl");
        if (null === e) throw Error("WebGL backend is not available");
        var t = e.getGPGPUContext().gl,
          n = 4 * (t.getParameter(t.MAX_VARYING_VECTORS) - 1);
        return Math.floor(n / 3);
      }
      t.maximumPerplexity = u, t.tsne = function (e, t) {
        return new c(e, t);
      };
      var c = function () {
        function e(e, t) {
          this.initialized = !1, this.probabilitiesInitialized = !1, this.data = e, this.config = t;
          var n = this.data.shape;
          if (this.numPoints = n[0], this.numDimensions = n[1], 2 !== n.length) throw Error("computeTSNE: input tensor must be 2-dimensional");
          var r = 18;
          void 0 !== this.config && void 0 !== this.config.perplexity && (r = this.config.perplexity);
          var i = u();
          if (r > i) throw Error("computeTSNE: perplexity cannot be greater than" + i + " on this machine");
        }
        return e.prototype.initialize = function () {
          return r(this, void 0, void 0, function () {
            var e, t, n, r, o, u, c;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return e = 18, t = 4, n = 300, r = 200, o = .8, this.verbose = !1, this.knnMode = "auto", void 0 !== this.config && (void 0 !== this.config.perplexity && (e = this.config.perplexity), void 0 !== this.config.exaggeration && (t = this.config.exaggeration), void 0 !== this.config.exaggerationIter && (n = this.config.exaggerationIter), void 0 !== this.config.exaggerationDecayIter && (r = this.config.exaggerationDecayIter), void 0 !== this.config.momentum && (o = this.config.momentum), void 0 !== this.config.verbose && (this.verbose = this.config.verbose), void 0 !== this.config.knnMode && (this.knnMode = this.config.knnMode)), this.numNeighbors = 4 * Math.floor(3 * e / 4), u = this, [4, s.tensorToDataTexture(this.data)];
                case 1:
                  return u.packedData = i.sent(), this.verbose && (console.log("Number of points:\t" + this.numPoints), console.log("Number of dimensions:\t " + this.numDimensions), console.log("Number of neighbors:\t" + this.numNeighbors), console.log("kNN mode:\t" + this.knnMode)), this.knnEstimator = new a.KNNEstimator(this.packedData.texture, this.packedData.shape, this.numPoints, this.numDimensions, this.numNeighbors, !1), this.optimizer = new l.TSNEOptimizer(this.numPoints, !1), c = [{
                    iteration: n,
                    value: t
                  }, {
                    iteration: n + r,
                    value: 1
                  }], this.verbose && console.log("Exaggerating for " + c[0].iteration + " iterations with a value of " + c[0].value + ". Exaggeration is removed after " + c[1].iteration + "."), this.optimizer.exaggeration = c, this.optimizer.momentum = o, 2500, 250, 2e3, this.numPoints > 2e3 ? this.optimizer.eta = 2500 : this.optimizer.eta = 250 + this.numPoints / 2e3 * 2250, [2];
              }
            });
          });
        }, e.prototype.compute = function (e) {
          return void 0 === e && (e = 1e3), r(this, void 0, void 0, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return t = this.knnIterations(), this.verbose && (console.log("Number of KNN iterations:\t" + t), console.log("Computing the KNN...")), [4, this.iterateKnn(t)];
                case 1:
                  return n.sent(), this.verbose && console.log("Computing the tSNE embedding..."), [4, this.iterate(e)];
                case 2:
                  return n.sent(), this.verbose && console.log("Done!"), [2];
              }
            });
          });
        }, e.prototype.iterateKnn = function (e) {
          return void 0 === e && (e = 1), r(this, void 0, void 0, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.initialized ? [3, 2] : [4, this.initialize()];
                case 1:
                  n.sent(), n.label = 2;
                case 2:
                  for (this.probabilitiesInitialized = !1, t = 0; t < e; ++t) this.knnEstimator.iterateBruteForce(), this.knnEstimator.iteration % 100 == 0 && this.verbose && console.log("Iteration KNN:\t" + this.knnEstimator.iteration);
                  return [2];
              }
            });
          });
        }, e.prototype.iterate = function (e) {
          return void 0 === e && (e = 1), r(this, void 0, void 0, function () {
            var t;
            return i(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.probabilitiesInitialized ? [3, 2] : [4, this.initializeProbabilities()];
                case 1:
                  n.sent(), n.label = 2;
                case 2:
                  t = 0, n.label = 3;
                case 3:
                  return t < e ? [4, this.optimizer.iterate()] : [3, 6];
                case 4:
                  n.sent(), this.optimizer.iteration % 100 == 0 && this.verbose && console.log("Iteration tSNE:\t" + this.optimizer.iteration), n.label = 5;
                case 5:
                  return ++t, [3, 3];
                case 6:
                  return [2];
              }
            });
          });
        }, e.prototype.knnIterations = function () {
          return Math.ceil(this.numPoints / 20);
        }, e.prototype.coordinates = function (e) {
          var t = this;
          return void 0 === e && (e = !0), e ? o.tidy(function () {
            var e = t.optimizer.maxX - t.optimizer.minX,
              n = t.optimizer.maxY - t.optimizer.minY,
              r = o.tensor2d([t.optimizer.minX, t.optimizer.minY], [1, 2]),
              i = o.tensor2d([t.optimizer.maxX, t.optimizer.maxY], [1, 2]).sub(r),
              a = o.max(i),
              s = o.tidy(function () {
                return e < n ? o.tensor2d([(n - e) / 2, 0], [1, 2]) : o.tensor2d([0, (e - n) / 2], [1, 2]);
              });
            return t.optimizer.embedding2D.sub(r).add(s).div(a);
          }) : this.optimizer.embedding2D;
        }, e.prototype.coordsArray = function (e) {
          return void 0 === e && (e = !0), r(this, void 0, void 0, function () {
            var t, n, r;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.coordinates(e).data()];
                case 1:
                  for (t = i.sent(), n = [], r = 0; r < t.length; r += 2) n.push([t[r], t[r + 1]]);
                  return [2, n];
              }
            });
          });
        }, e.prototype.knnTotalDistance = function () {
          return r(this, void 0, void 0, function () {
            var e = this;
            return i(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, o.tidy(function () {
                    return e.knnEstimator.distancesTensor().sum();
                  }).data()];
                case 1:
                  return [2, t.sent()[0]];
              }
            });
          });
        }, e.prototype.initializeProbabilities = function () {
          return r(this, void 0, void 0, function () {
            return i(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.verbose && console.log("Initializing probabilities"), [4, this.optimizer.initializeNeighborsFromKNNTexture(this.knnEstimator.knnShape, this.knnEstimator.knn())];
                case 1:
                  return e.sent(), this.probabilitiesInitialized = !0, [2];
              }
            });
          });
        }, e;
      }();
      t.TSNE = c;
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/tsne_optimizer.js": function node_modulesTensorflowTfjsTsneDistTsne_optimizerJs(e, t, n) {
      "use strict";

      var r = this && this.__awaiter || function (e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        i = this && this.__generator || function (e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = r[2 & o[0] ? "return" : o[0] ? "throw" : "next"]) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [0, i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        a = n("./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js"),
        s = n("./node_modules/@tensorflow/tfjs-tsne/dist/knn_util.js"),
        l = n("./node_modules/@tensorflow/tfjs-tsne/dist/tsne_optimizer_util.js"),
        u = function () {
          function e(e, t, n, r) {
            if (null != t ? this.verbose = t : t = !1, this.log("Initializing the tSNE gradient descent computation..."), this.numPoints = e, this._iteration = 0, 1 === o.ENV.get("WEBGL_VERSION")) throw Error("WebGL version 1 is not supported by tfjs-tsne");
            if (this.backend = o.ENV.findBackend("webgl"), null === this.backend) throw Error("WebGL backend is not available");
            this.gpgpu = this.backend.getGPGPUContext(), o.webgl.webgl_util.getExtensionOrThrow(this.gpgpu.gl, "OES_texture_float_linear"), this.pointsPerRow = Math.ceil(Math.sqrt(2 * e)), this.pointsPerRow % 2 == 1 && ++this.pointsPerRow, this.pointsPerRow /= 2, this.numRows = Math.ceil(e / this.pointsPerRow), this.log("\t# points per row", this.pointsPerRow), this.log("\t# rows", this.numRows), this._eta = 2500, this._momentum = o.scalar(.8), this.rawExaggeration = [{
              iteration: 200,
              value: 4
            }, {
              iteration: 600,
              value: 1
            }], this.updateExaggeration(), null == n && (n = 5), this.splatTextureDiameter = n, null == r && (r = 50), this.kernelTextureDiameter = 2 * r + 1, this.initializeRepulsiveForceTextures(), this.log("\tSplat texture diameter", this.splatTextureDiameter), this.log("\tKernel texture diameter", this.kernelTextureDiameter), this.initilizeCustomWebGLPrograms(), this.initializeEmbedding(), this.log("\tEmbedding", this.embedding), this.log("\tGradient", this.gradient);
          }
          return Object.defineProperty(e.prototype, "minX", {
            get: function get() {
              return this._minX;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "maxX", {
            get: function get() {
              return this._maxX;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "minY", {
            get: function get() {
              return this._minY;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "maxY", {
            get: function get() {
              return this._maxY;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "iteration", {
            get: function get() {
              return this._iteration;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "numberOfPoints", {
            get: function get() {
              return this.numPoints;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "numberOfPointsPerRow", {
            get: function get() {
              return this.pointsPerRow;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "numberOfRows", {
            get: function get() {
              return this.numRows;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "embeddingCoordinates", {
            get: function get() {
              return this.embedding;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "embedding2D", {
            get: function get() {
              var e = this;
              return o.tidy(function () {
                return e.embedding.reshape([e.numRows * e.pointsPerRow, 2]).slice([0, 0], [e.numPoints, 2]);
              });
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "embeddingTexture", {
            get: function get() {
              return this.backend.getTexture(this.embedding.dataId);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "splatTexture", {
            get: function get() {
              return this._splatTexture;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "normalizationQ", {
            get: function get() {
              return this._normQ;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "exaggerationAtCurrentIteration", {
            get: function get() {
              return this._exaggeration.get();
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "exaggeration", {
            get: function get() {
              return this.rawExaggeration;
            },
            set: function set(e) {
              if (this.rawExaggeration = e, "number" == typeof e) {
                if (e < 1) throw Error("Exaggeration must be greater then or equal to one");
              } else {
                for (var t = 0; t < e.length; ++t) {
                  if (e[t].value < 1) throw Error("Exaggeration must be greater then or equal to one");
                  if (e[t].iteration < 0) throw Error("Piecewise linear exaggeration function                                         must have poistive iteration values");
                }
                for (t = 0; t < e.length - 1; ++t) if (e[t].iteration >= e[t + 1].iteration) throw Error("Piecewise linear exaggeration function                                       must have increasing iteration values");
                1 === e.length && (this.exaggeration = e[0].value);
              }
              this.updateExaggeration();
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "momentum", {
            get: function get() {
              return this._momentum.get();
            },
            set: function set(e) {
              if (e < 0 || e > 1) throw Error("Momentum must be in the [0,1] range");
              this._momentum.dispose(), this._momentum = o.scalar(e);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "eta", {
            get: function get() {
              return this._eta;
            },
            set: function set(e) {
              if (e <= 0) throw Error("ETA must be greater then zero");
              this._eta = e;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.dispose = function () {
            this.embedding.dispose(), this.gradient.dispose(), this._momentum.dispose(), this._exaggeration.dispose(), this.gpgpu.gl.deleteTexture(this._splatTexture), this.gpgpu.gl.deleteTexture(this.kernelTexture), null != this.kernelTexture && this.gpgpu.gl.deleteTexture(this.probOffsetTexture), null != this.kernelTexture && this.gpgpu.gl.deleteTexture(this.probNeighIdTexture), null != this.kernelTexture && this.gpgpu.gl.deleteTexture(this.probTexture), this.gpgpu.gl.deleteBuffer(this.splatVertexIdBuffer), this.gpgpu.gl.deleteProgram(this.embeddingInitializationProgram), this.gpgpu.gl.deleteProgram(this.embeddingSplatterProgram), this.gpgpu.gl.deleteProgram(this.qInterpolatorProgram), this.gpgpu.gl.deleteProgram(this.xyInterpolatorProgram), this.gpgpu.gl.deleteProgram(this.attractiveForcesProgram), this.gpgpu.gl.deleteProgram(this.distributionParameterssComputationProgram), this.gpgpu.gl.deleteProgram(this.gaussiaDistributionsFromDistancesProgram);
          }, e.prototype.initializeEmbedding = function () {
            var e = this;
            null != this.embedding && this.embedding.dispose(), null != this.gradient && this.gradient.dispose(), this.gradient = o.zeros([this.numRows, 2 * this.pointsPerRow]), this.embedding = o.tidy(function () {
              var t = o.randomUniform([e.numRows, 2 * e.pointsPerRow]),
                n = o.zeros([e.numRows, 2 * e.pointsPerRow]);
              return e.initializeEmbeddingPositions(n, t), n;
            });
            this._minX = -3, this._minY = -3, this._maxX = 3, this._maxY = 3, this.log("\tmin X", this._minX), this.log("\tmax X", this._maxX), this.log("\tmin Y", this._minY), this.log("\tmax Y", this._maxY), this._iteration = 0;
          }, e.prototype.initializeNeighbors = function (e, t, n, r) {
            this.numNeighPerRow = e, this.probOffsetTexture = t, this.probTexture = n, this.probNeighIdTexture = r;
          }, e.prototype.initializeNeighborsFromKNNGraph = function (e, t, n, o) {
            return r(this, void 0, void 0, function () {
              var r, s, l, u, c, d, h, f;
              return i(this, function (i) {
                switch (i.label) {
                  case 0:
                    for (r = Math.floor(Math.sqrt(e * t) / t), s = Math.ceil(e / r), l = {
                      numPoints: e,
                      pixelsPerPoint: t,
                      numRows: s,
                      pointsPerRow: r
                    }, u = new Float32Array(r * t * s * 2), c = 0; c < e; ++c) for (d = 0; d < t; ++d) u[2 * (h = c * t + d)] = o[h], u[2 * h + 1] = n[h];
                    return f = a.createAndConfigureTexture(this.gpgpu.gl, r * t, s, 2, u), [4, this.initializeNeighborsFromKNNTexture(l, f)];
                  case 1:
                    return i.sent(), this.gpgpu.gl.deleteTexture(f), [2];
                }
              });
            });
          }, e.prototype.initializeNeighborsFromKNNTexture = function (e, t) {
            return r(this, void 0, void 0, function () {
              var n, r, l, u, c, d, h, f, p, m, g, v, y, b, _, x, w, S, A, E, T, M, C, k, P, O, R;
              return i(this, function (i) {
                switch (i.label) {
                  case 0:
                    if (this.log("Asymmetric neighborhood initialization..."), e.numPoints !== this.numPoints) throw new Error("KNN size and number of points must agree(" + e.numPoints + "," + this.numPoints + ")");
                    return n = a.createAndConfigureTexture(this.gpgpu.gl, e.pointsPerRow, e.numRows, 2), r = o.zeros([e.numRows, e.pointsPerRow * e.pixelsPerPoint]), l = e.pixelsPerPoint / 3, this.computeDistributionParameters(n, e, l, t), this.computeGaussianDistributions(r, n, e, t), [4, r.data()];
                  case 1:
                    return u = i.sent(), this.log("Gaussian distributions", r), c = o.zeros([e.numRows, e.pointsPerRow * e.pixelsPerPoint]), d = s.createCopyIndicesProgram(this.gpgpu), s.executeCopyIndicesProgram(this.gpgpu, d, t, e, this.backend.getTexture(c.dataId)), [4, c.data()];
                  case 2:
                    for (h = i.sent(), this.log("knn Indices", c), f = new Float32Array(e.numPoints * e.pixelsPerPoint), T = 0; T < this.numPoints; ++T) for (p = 0; p < e.pixelsPerPoint; ++p) C = T * e.pixelsPerPoint + p, f[T * e.pixelsPerPoint + p] = h[C];
                    for (this.log("NeighIds", f), m = new Uint32Array(this.numPoints), g = new Uint32Array(this.numPoints), T = 0; T < e.numPoints * e.pixelsPerPoint; ++T) ++m[f[T]];
                    for (T = 1; T < e.numPoints; ++T) g[T] = g[T - 1] + m[T - 1] + e.pixelsPerPoint;
                    for (this.log("Counter", m), this.log("Linear offset", g), v = 0, y = 0, b = 0, T = 0; T < m.length; ++T) v += m[T], m[T] > y && (y = m[T], b = T);
                    for (this.log("Number of indirect links", v), this.log("Most central point", b), this.log("Number of indirect links for the central point", y), this.numNeighPerRow = Math.ceil(Math.sqrt(e.numPoints * e.pixelsPerPoint * 2)), this.log("numNeighPerRow", this.numNeighPerRow), _ = new Float32Array(this.pointsPerRow * this.numRows * 3), x = 0, T = 0; T < this.numPoints; ++T) w = e.pixelsPerPoint + m[T], _[3 * T + 0] = x % this.numNeighPerRow, _[3 * T + 1] = Math.floor(x / this.numNeighPerRow), _[3 * T + 2] = w, x += w;
                    for (this.log("Offsets", _), this.probOffsetTexture = a.createAndConfigureTexture(this.gpgpu.gl, this.pointsPerRow, this.numRows, 3, _), S = new Float32Array(this.numNeighPerRow * this.numNeighPerRow), A = new Float32Array(this.numNeighPerRow * this.numNeighPerRow), E = new Uint32Array(this.numPoints), T = 0; T < this.numPoints; ++T) for (M = 0; M < e.pixelsPerPoint; ++M) C = T * e.pixelsPerPoint + M, k = h[C], P = u[C], O = g[T] + M, R = g[k] + e.pixelsPerPoint + E[k], S[O] = P, S[R] = P, A[O] = k, A[R] = T, ++E[k];
                    return this.log("Probabilities", S), this.log("Neighbors", A), this.probTexture = a.createAndConfigureTexture(this.gpgpu.gl, this.numNeighPerRow, this.numNeighPerRow, 1, S), this.probNeighIdTexture = a.createAndConfigureTexture(this.gpgpu.gl, this.numNeighPerRow, this.numNeighPerRow, 1, A), r.dispose(), c.dispose(), this.log("...done!"), [2];
                }
              });
            });
          }, e.prototype.initializedNeighborhoods = function () {
            return null != this.probNeighIdTexture;
          }, e.prototype.updateExaggeration = function () {
            if (void 0 !== this._exaggeration && this._exaggeration.dispose(), "number" != typeof this.rawExaggeration) {
              if (this._iteration <= this.rawExaggeration[0].iteration) this._exaggeration = o.scalar(this.rawExaggeration[0].value);else if (this._iteration >= this.rawExaggeration[this.rawExaggeration.length - 1].iteration) this._exaggeration = o.scalar(this.rawExaggeration[this.rawExaggeration.length - 1].value);else {
                for (var e = 0; e < this.rawExaggeration.length && this._iteration < this.rawExaggeration[e].iteration;) ++e;
                var t = this.rawExaggeration[e].iteration,
                  n = this.rawExaggeration[e + 1].iteration,
                  r = this.rawExaggeration[e].value,
                  i = this.rawExaggeration[e + 1].value,
                  a = (n - this._iteration) / (n - t),
                  s = r * a + i * (1 - a);
                this._exaggeration = o.scalar(s);
              }
            } else this._exaggeration = o.scalar(this.rawExaggeration);
          }, e.prototype.iterate = function () {
            return r(this, void 0, void 0, function () {
              var e,
                t,
                n,
                r = this;
              return i(this, function (i) {
                switch (i.label) {
                  case 0:
                    if (!this.initializedNeighborhoods()) throw new Error("No neighborhoods defined. You may want to call                    initializeNeighbors or initializeNeighborsFromKNNGraph");
                    return this.updateSplatTextureDiameter(), this.updateExaggeration(), n = o.tidy(function () {
                      r.splatPoints();
                      var e = o.zeros([r.numRows, r.pointsPerRow]),
                        t = o.zeros([r.numRows, 2 * r.pointsPerRow]);
                      r.computeInterpolatedQ(e), r.computeInterpolatedXY(t);
                      var n = e.sum(),
                        i = t.div(n),
                        a = o.zeros([r.numRows, 2 * r.pointsPerRow]);
                      r.computeAttractiveForces(a);
                      var s = a.mul(r._exaggeration).sub(i),
                        l = r.gradient.mul(r._momentum).sub(s);
                      return r.gradient.dispose(), [l, n];
                    }), this.gradient = n[0], e = n[1], t = this, [4, e.data()];
                  case 1:
                    return t._normQ = i.sent()[0], e.dispose(), this.embedding = o.tidy(function () {
                      var e = r.embedding.add(r.gradient);
                      return r.embedding.dispose(), e;
                    }), [4, this.computeBoundaries()];
                  case 2:
                    return i.sent(), ++this._iteration, [2];
                }
              });
            });
          }, e.prototype.log = function (e, t) {
            this.verbose && (null != t ? console.log(e + ": \t" + t) : console.log(e));
          }, e.prototype.initializeRepulsiveForceTextures = function () {
            this._splatTexture = a.createAndConfigureInterpolatedTexture(this.gpgpu.gl, this.splatTextureDiameter, this.splatTextureDiameter, 4, null), this.kernelSupport = 2.5;
            var e = new Float32Array(this.kernelTextureDiameter * this.kernelTextureDiameter * 4),
              t = Math.floor(this.kernelTextureDiameter / 2),
              n = 0,
              r = 0;
            for (n = 0; n < this.kernelTextureDiameter; ++n) for (r = 0; r < this.kernelTextureDiameter; ++r) {
              var i = (r - t) / t * this.kernelSupport,
                o = (n - t) / t * this.kernelSupport,
                s = 1 / (1 + (i * i + o * o)),
                l = 4 * (n * this.kernelTextureDiameter + r);
              e[l + 0] = s, e[l + 1] = s * s * i, e[l + 2] = s * s * o, e[l + 3] = 1;
            }
            this.kernelTexture = a.createAndConfigureInterpolatedTexture(this.gpgpu.gl, this.kernelTextureDiameter, this.kernelTextureDiameter, 4, e);
          }, e.prototype.initilizeCustomWebGLPrograms = function () {
            this.log("\tCreating custom programs..."), this.embeddingInitializationProgram = l.createEmbeddingInitializationProgram(this.gpgpu), this.embeddingSplatterProgram = l.createEmbeddingSplatterProgram(this.gpgpu);
            var e = new Float32Array(6 * this.numPoints),
              t = 0,
              n = 0;
            for (t = 0; t < this.numPoints; ++t) e[(n = 6 * t) + 0] = 0 + 4 * t, e[n + 1] = 1 + 4 * t, e[n + 2] = 2 + 4 * t, e[n + 3] = 0 + 4 * t, e[n + 4] = 2 + 4 * t, e[n + 5] = 3 + 4 * t;
            this.splatVertexIdBuffer = o.webgl.webgl_util.createStaticVertexBuffer(this.gpgpu.gl, e), this.qInterpolatorProgram = l.createQInterpolatorProgram(this.gpgpu), this.xyInterpolatorProgram = l.createXYInterpolatorProgram(this.gpgpu), this.attractiveForcesProgram = l.createAttractiveForcesComputationProgram(this.gpgpu), this.distributionParameterssComputationProgram = l.createDistributionParametersComputationProgram(this.gpgpu), this.gaussiaDistributionsFromDistancesProgram = l.createGaussiaDistributionsFromDistancesProgram(this.gpgpu);
          }, e.prototype.computeBoundaries = function () {
            return r(this, void 0, void 0, function () {
              var e,
                t,
                n,
                r,
                a,
                s,
                l,
                u = this;
              return i(this, function (i) {
                switch (i.label) {
                  case 0:
                    return e = o.tidy(function () {
                      var e = u.embedding.reshape([u.numRows * u.pointsPerRow, 2]).slice([0, 0], [u.numPoints, 2]);
                      return [e.min(0), e.max(0)];
                    }), t = e[0], n = e[1], [4, t.data()];
                  case 1:
                    return r = i.sent(), [4, n.data()];
                  case 2:
                    return a = i.sent(), .05, s = .05 * (a[0] - r[0]), this._minX = r[0] - s, this._maxX = a[0] + s, l = .05 * (a[1] - r[1]), this._minY = r[1] - l, this._maxY = a[1] + l, t.dispose(), n.dispose(), [2];
                }
              });
            });
          }, e.prototype.updateSplatTextureDiameter = function () {
            var e = Math.max(this._maxX - this._minX, this._maxY - this._minY),
              t = Math.min(Math.ceil(Math.max(e / .35, 5)), 5e3);
            Math.abs(this.splatTextureDiameter - t) / this.splatTextureDiameter >= .2 && (this.log("Updating splat-texture diameter", t), this.gpgpu.gl.deleteTexture(this._splatTexture), this.splatTextureDiameter = t, this._splatTexture = a.createAndConfigureInterpolatedTexture(this.gpgpu.gl, this.splatTextureDiameter, this.splatTextureDiameter, 4, null));
          }, e.prototype.initializeEmbeddingPositions = function (e, t) {
            l.executeEmbeddingInitializationProgram(this.gpgpu, this.embeddingInitializationProgram, this.backend.getTexture(t.dataId), this.numPoints, this.pointsPerRow, this.numRows, this.backend.getTexture(e.dataId));
          }, e.prototype.splatPoints = function () {
            l.executeEmbeddingSplatterProgram(this.gpgpu, this.embeddingSplatterProgram, this._splatTexture, this.backend.getTexture(this.embedding.dataId), this.kernelTexture, this.splatTextureDiameter, this.numPoints, this._minX, this._minY, this._maxX, this._maxY, this.kernelSupport, this.pointsPerRow, this.numRows, this.splatVertexIdBuffer);
          }, e.prototype.computeInterpolatedQ = function (e) {
            l.executeQInterpolatorProgram(this.gpgpu, this.qInterpolatorProgram, this._splatTexture, this.backend.getTexture(this.embedding.dataId), this.numPoints, this._minX, this._minY, this._maxX, this._maxY, this.pointsPerRow, this.numRows, this.backend.getTexture(e.dataId));
          }, e.prototype.computeInterpolatedXY = function (e) {
            l.executeXYInterpolatorProgram(this.gpgpu, this.xyInterpolatorProgram, this._splatTexture, this.backend.getTexture(this.embedding.dataId), this.backend.getTexture(e.dataId), this.numPoints, this._minX, this._minY, this._maxX, this._maxY, this.pointsPerRow, this.numRows, this._eta);
          }, e.prototype.computeAttractiveForces = function (e) {
            l.executeAttractiveForcesComputationProgram(this.gpgpu, this.attractiveForcesProgram, this.backend.getTexture(this.embedding.dataId), this.probOffsetTexture, this.probNeighIdTexture, this.probTexture, this.numPoints, this.numNeighPerRow, this.pointsPerRow, this.numRows, this._eta, this.backend.getTexture(e.dataId));
          }, e.prototype.computeDistributionParameters = function (e, t, n, r) {
            l.executeDistributionParametersComputationProgram(this.gpgpu, this.distributionParameterssComputationProgram, r, t.numPoints, t.pixelsPerPoint, t.pointsPerRow, t.numRows, n, e);
          }, e.prototype.computeGaussianDistributions = function (e, t, n, r) {
            l.executeGaussiaDistributionsFromDistancesProgram(this.gpgpu, this.gaussiaDistributionsFromDistancesProgram, r, t, n.numPoints, n.pixelsPerPoint, n.pointsPerRow, n.numRows, this.backend.getTexture(e.dataId));
          }, e;
        }();
      t.TSNEOptimizer = u;
    },
    "./node_modules/@tensorflow/tfjs-tsne/dist/tsne_optimizer_util.js": function node_modulesTensorflowTfjsTsneDistTsne_optimizer_utilJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js"),
        i = n("./node_modules/@tensorflow/tfjs-tsne/dist/gl_util.js");
      t.createEmbeddingSplatterProgram = function (e) {
        return i.createVertexProgram(e.gl, "#version 300 es\n    precision highp float;\n    in float vertex_id;\n\n    uniform sampler2D embedding_tex;\n    uniform vec2 minV;\n    uniform vec2 maxV;\n    uniform float kernel_support;\n    uniform float points_per_row;\n    uniform float num_rows;\n\n    out vec2 kernel_coords;\n\n    void main() {\n      //TODO Clean up and check performance loss due to the conversions\n      uint pnt_id = uint((vertex_id / 4.0) + 0.1);\n      uint quad_id = uint(mod(vertex_id + 0.1,4.));\n\n      uint row    = uint((float(pnt_id) + 0.1)/points_per_row);\n      uint column = uint(float(pnt_id) - float(row) * points_per_row);\n\n      float width = (points_per_row * 2.0);\n      float row_tex = (float(row) + 0.5) / num_rows;\n      vec2 tex_coords_x = vec2((float(column) * 2. + 0.5) / width, row_tex);\n      vec2 tex_coords_y = vec2((float(column) * 2. + 1.5) / width, row_tex);\n\n      float x_pnt = texture(embedding_tex,tex_coords_x).r;\n      float y_pnt = texture(embedding_tex,tex_coords_y).r;\n      vec2 vertex_coords = vec2(x_pnt,y_pnt);\n\n      if(quad_id == uint(0)) {kernel_coords = vec2(-1,-1);}\n      else if(quad_id == uint(1)) {kernel_coords = vec2(1,-1);}\n      else if(quad_id == uint(2)) {kernel_coords = vec2(1,1);}\n      else if(quad_id == uint(3)) {kernel_coords = vec2(-1,1);}\n\n      vertex_coords += kernel_coords * kernel_support;      // embedding space\n      vertex_coords = (vertex_coords - minV) / (maxV-minV); //  0:1 space\n      vertex_coords = vertex_coords * 2.0 - 1.0;            // -1:1 space\n\n      gl_Position = vec4(vertex_coords,0,1);\n    }\n  ", "#version 300 es\n    precision highp float;\n    uniform sampler2D kernel_tex;\n    in vec2 kernel_coords;\n    out vec4 fragmentColor;\n\n    void main() {\n      fragmentColor = texture(kernel_tex,(kernel_coords + 1.) / 2.0);\n    }\n  ");
      }, t.executeEmbeddingSplatterProgram = function (e, t, n, i, o, a, s, l, u, c, d, h, f, p, m) {
        var g = e.gl,
          v = e.program;
        null != n ? e.setOutputMatrixTexture(n, a, a) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t), g.clearColor(0, 0, 0, 0), g.clear(g.COLOR_BUFFER_BIT), g.enable(g.BLEND), g.blendFunc(g.ONE, g.ONE), r.webgl.webgl_util.callAndCheck(g, function () {
          return g.bindBuffer(g.ARRAY_BUFFER, m);
        }), r.webgl.webgl_util.bindVertexBufferToProgramAttribute(g, t, "vertex_id", m, 1, 0, 0);
        var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "embedding_tex");
        e.setInputMatrixTexture(i, y, 0);
        var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "kernel_tex");
        e.setInputMatrixTexture(o, b, 1);
        var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "kernel_support");
        g.uniform1f(_, h);
        var x = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "points_per_row");
        g.uniform1f(x, f);
        var w = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "num_rows");
        g.uniform1f(w, p);
        var S = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "minV");
        g.uniform2f(S, l, u);
        var A = r.webgl.webgl_util.getProgramUniformLocationOrThrow(g, t, "maxV");
        g.uniform2f(A, c, d), r.webgl.webgl_util.callAndCheck(g, function () {
          return g.drawArrays(g.TRIANGLES, 0, 2 * s * 3);
        }), g.disable(g.BLEND), null != v && (e.setProgram(v), r.webgl.gpgpu_util.bindVertexProgramAttributeStreams(e.gl, v, e.vertexBuffer));
      }, t.createQInterpolatorProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n    uniform sampler2D embedding_tex;\n    uniform sampler2D splat_tex;\n    uniform vec2 minV;\n    uniform vec2 maxV;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n\n    void main() {\n      vec2 pnt_location = gl_FragCoord.xy - vec2(0.5,0.5);\n\n      if(pnt_location.y * points_per_row + pnt_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n\n      float emb_width = (points_per_row * 2.0);\n      float emb_row_coord = (pnt_location.y + 0.5) / num_rows;\n      vec2 emb_coords_x\n              = vec2((pnt_location.x * 2.+0.5) / emb_width, emb_row_coord);\n      vec2 emb_coords_y\n              = vec2((pnt_location.x * 2. + 1.5) / emb_width, emb_row_coord);\n\n      float x_pnt = texture2D(embedding_tex,emb_coords_x).r;\n      float y_pnt = texture2D(embedding_tex,emb_coords_y).r;\n\n      vec2 splat_coords = vec2(x_pnt,y_pnt);\n      splat_coords = (splat_coords - minV) / (maxV - minV); //  0:1 space\n\n      float q = (texture2D(splat_tex,splat_coords).r - 1.);\n\n      gl_FragColor = vec4(q, 0, 0, 1);\n    }\n  ");
      }, t.executeQInterpolatorProgram = function (e, t, n, i, o, a, s, l, u, c, d, h) {
        var f = e.gl;
        null != h ? e.setOutputMatrixTexture(h, d, c) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "embedding_tex");
        e.setInputMatrixTexture(i, p, 0);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "splat_tex");
        e.setInputMatrixTexture(n, m, 1);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "points_per_row");
        f.uniform1f(g, c);
        var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_rows");
        f.uniform1f(v, d);
        var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_points");
        f.uniform1f(y, o);
        var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "minV");
        f.uniform2f(b, a, s);
        var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "maxV");
        f.uniform2f(_, l, u), e.executeProgram();
      }, t.createXYInterpolatorProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n    uniform sampler2D embedding_tex;\n    uniform sampler2D splat_tex;\n    uniform vec2 minV;\n    uniform vec2 maxV;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float eta;\n\n    void main() {\n      vec2 pnt_location = gl_FragCoord.xy - vec2(0.5,0.5);\n      pnt_location.x = floor(pnt_location.x/2.+0.1);\n\n      if(pnt_location.y*points_per_row + pnt_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n\n      float emb_width = (points_per_row * 2.0);\n      float emb_row_coord = (pnt_location.y + 0.5) / num_rows;\n      vec2 emb_coords_x\n              = vec2((pnt_location.x * 2. + 0.5) / emb_width, emb_row_coord);\n      vec2 emb_coords_y\n              = vec2((pnt_location.x * 2. + 1.5) / emb_width, emb_row_coord);\n\n      float x_pnt = texture2D(embedding_tex,emb_coords_x).r;\n      float y_pnt = texture2D(embedding_tex,emb_coords_y).r;\n\n      vec2 splat_coords = vec2(x_pnt,y_pnt);\n      splat_coords = (splat_coords - minV) / (maxV - minV); //  0:1 space\n\n      float q = 0.;\n      if(mod(gl_FragCoord.x - 0.5,2.) < 0.5 ) {\n        q = texture2D(splat_tex,splat_coords).g * eta * 2.;\n      }else{\n        q = texture2D(splat_tex,splat_coords).b * eta * 2.;\n      }\n\n      gl_FragColor = vec4(q,0.0,0.0,1);\n    }\n  ");
      }, t.executeXYInterpolatorProgram = function (e, t, n, i, o, a, s, l, u, c, d, h, f) {
        var p = e.gl;
        null != o ? e.setOutputMatrixTexture(o, h, 2 * d) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "embedding_tex");
        e.setInputMatrixTexture(i, m, 0);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "splat_tex");
        e.setInputMatrixTexture(n, g, 1);
        var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "points_per_row");
        p.uniform1f(v, d);
        var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "num_rows");
        p.uniform1f(y, h);
        var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "num_points");
        p.uniform1f(b, a);
        var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "eta");
        p.uniform1f(_, f);
        var x = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "minV");
        p.uniform2f(x, s, l);
        var w = r.webgl.webgl_util.getProgramUniformLocationOrThrow(p, t, "maxV");
        p.uniform2f(w, u, c), e.executeProgram();
      }, t.createAttractiveForcesComputationProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n\n    uniform sampler2D embedding_tex;\n    uniform sampler2D offset_tex;\n    uniform sampler2D neigh_id_tex;\n    uniform sampler2D neigh_prob_tex;\n\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float num_neighs_per_row;\n    uniform float eta;\n\n    void main() {\n      //add for nearest pixel interpolation\n      vec2 half_pxl = vec2(0.5,0.5);\n\n      // Dimension of the fragment\n      // 0 -> x :1 -> y\n      float dimension = mod(gl_FragCoord.x - 0.4,2.);\n\n      //Point location in the [points_per_row,num_rows] space\n      vec2 i_location = gl_FragCoord.xy - half_pxl;\n      i_location.x = floor(i_location.x / 2. + 0.1);\n\n      //just an extra fragment -> return\n      if(i_location.y*points_per_row + i_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n\n      //Offset coordinates for the point\n      vec2 offset_coord = (i_location + half_pxl) /\n                                              vec2(points_per_row,num_rows);\n      //Offset information ...\n      vec4 offset_info  = texture2D(offset_tex,offset_coord);\n      //... contains the number of neighbors for the point ...\n      float num_neighs  = offset_info.z;\n      //... and the coordinates of the firts neigh in the neigh textures\n      vec2 offset_neigh = offset_info.xy;\n\n      //Computing the coordinates of the point in the texture\n      //_i represent the point to move, _j the neighbors\n      float emb_width = (points_per_row * 2.0);\n      float emb_row_i = (i_location.y + 0.5) / num_rows;\n      vec2 x_i_coord = vec2((i_location.x * 2. + 0.5) / emb_width, emb_row_i);\n      vec2 y_i_coord = vec2((i_location.x * 2. + 1.5) / emb_width, emb_row_i);\n      //getting the coordinates in the embedding\n      float x_i = texture2D(embedding_tex,x_i_coord).r;\n      float y_i = texture2D(embedding_tex,y_i_coord).r;\n\n      //Sum of all attractive forces\n      float sum_pos = 0.;\n\n      //Can't be higher than 1000 (perplexity is usually around 30)\n      //and a 'while' can't be used\n      for(int n = 0; n < 2000; ++n) {\n        //Actual check on number of neighbors\n        if(float(n) >= num_neighs) {\n          break;\n        }\n\n        //Get the id and the probability for the neighbor\n        float pij = texture2D(neigh_prob_tex,\n                              (offset_neigh + half_pxl) / num_neighs_per_row\n                             ).r;\n        float neigh_id = texture2D(neigh_id_tex,\n                                  (offset_neigh + half_pxl) / num_neighs_per_row\n                                  ).r;\n\n        //Getting the coordinates of the neighbor\n        vec2 j_location = vec2(mod(neigh_id + 0.1, points_per_row),\n                               floor(neigh_id / points_per_row + 0.1));\n        float emb_row_j = (j_location.y + 0.5) / num_rows;\n        vec2 x_j_coord = vec2((j_location.x * 2. + 0.5) / emb_width, emb_row_j);\n        vec2 y_j_coord = vec2((j_location.x * 2. + 1.5) / emb_width, emb_row_j);\n        float x_j = texture2D(embedding_tex,x_j_coord).r;\n        float y_j = texture2D(embedding_tex,y_j_coord).r;\n\n        //Actual computation of the attractive forces\n        float dist_x    = (x_i - x_j);\n        float dist_y    = (y_i - y_j);\n        float qij       = 1. / (1. + dist_x * dist_x + dist_y * dist_y);\n        //the update depends on the dimension that this fragment represents\n        if(dimension < 0.5) {\n          // * 4 / (num_points*2) -> * 2 / num_points\n          sum_pos += eta * 2. * pij * qij * dist_x / (num_points);\n        }else{\n          sum_pos += eta * 2. * pij * qij * dist_y / (num_points);\n        }\n\n        //Increase the coordinate of the neigh in the neigh_id texture\n        offset_neigh.x += 1.;\n        //check if the new neigh is in the next row\n        if(offset_neigh.x + 0.2 > num_neighs_per_row) {\n          //in that case reset the column and increase the row\n          offset_neigh.x = 0.1;\n          offset_neigh.y += 1.0;\n        }\n      }\n\n      //The output is the sum of the attractive forces\n      gl_FragColor = vec4(sum_pos,0,0,0);\n    }\n  ");
      }, t.executeAttractiveForcesComputationProgram = function (e, t, n, i, o, a, s, l, u, c, d, h) {
        var f = e.gl;
        null != h ? e.setOutputMatrixTexture(h, c, 2 * u) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "embedding_tex");
        e.setInputMatrixTexture(n, p, 3);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "offset_tex");
        e.setInputMatrixTexture(i, m, 2);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "neigh_id_tex");
        e.setInputMatrixTexture(o, g, 1);
        var v = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "neigh_prob_tex");
        e.setInputMatrixTexture(a, v, 0);
        var y = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_rows");
        f.uniform1f(y, c);
        var b = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "eta");
        f.uniform1f(b, d);
        var _ = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_neighs_per_row");
        f.uniform1f(_, l);
        var x = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "num_points");
        f.uniform1f(x, s);
        var w = r.webgl.webgl_util.getProgramUniformLocationOrThrow(f, t, "points_per_row");
        f.uniform1f(w, u), e.executeProgram();
      }, t.createEmbeddingInitializationProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n\n    uniform sampler2D random_tex;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n\n    void main() {\n      //add for nearest pixel interpolation\n      vec2 half_pxl = vec2(0.5,0.5);\n\n      // Dimension of the fragment\n      // 0 -> x :1 -> y\n      float dimension = mod(gl_FragCoord.x - 0.4,2.);\n      vec2 pnt_location = gl_FragCoord.xy - half_pxl;\n      pnt_location.x = floor(pnt_location.x / 2.);\n\n      //just an extra fragment -> return\n      if(pnt_location.y*points_per_row + pnt_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,1);\n        return;\n      }\n\n      float width = (points_per_row * 2.0);\n      float row_coord = (pnt_location.y + 0.5)/num_rows;\n      vec2 rad_coord = vec2((pnt_location.x * 2. + 0.5) / width, row_coord);\n      vec2 ang_coord = vec2((pnt_location.x * 2. + 1.5) / width, row_coord);\n\n      float rad = texture2D(random_tex,rad_coord).r * 3.;\n      float ang = texture2D(random_tex,ang_coord).r * 3.1415 * 2.;\n\n      gl_FragColor = vec4(rad,ang,0,1);\n\n      if(dimension < 0.5) {\n        gl_FragColor = vec4(cos(ang) * rad,0,0,0);\n      }else{\n        gl_FragColor = vec4(sin(ang) * rad,0,0,0);\n      }\n    }\n  ");
      }, t.executeEmbeddingInitializationProgram = function (e, t, n, i, o, a, s) {
        var l = e.gl;
        null != s ? e.setOutputMatrixTexture(s, a, 2 * o) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var u = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "random_tex");
        e.setInputMatrixTexture(n, u, 3);
        var c = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "num_rows");
        l.uniform1f(c, a);
        var d = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "num_points");
        l.uniform1f(d, i);
        var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(l, t, "points_per_row");
        l.uniform1f(h, o), e.executeProgram();
      }, t.createDistributionParametersComputationProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n\n    #define MAX_NEIGHBORS 128\n    #define MAX_ITERATIONS 500\n    #define FLOAT_MAX 10e30\n    #define TOLERANCE 1e-5\n\n    uniform sampler2D knn_graph_tex;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float num_neighs;\n    uniform float perplexity;\n\n    vec2 half_pixel = vec2(0.5,0.5);\n    float distances_squared[MAX_NEIGHBORS];\n\n    void readDistances(vec2 point_location) {\n      for(int n = 0; n < MAX_NEIGHBORS; ++n ) {\n        if(float(n) >= num_neighs-0.1) {\n          break;\n        }\n        vec2 knn_coordinates = vec2(\n            (point_location.x * num_neighs + float(n) + half_pixel.x)\n                                        /(points_per_row * num_neighs),\n            (point_location.y + half_pixel.y) / num_rows\n        );\n        distances_squared[n] = texture2D(knn_graph_tex,knn_coordinates).g;\n      }\n    }\n\n    void main() {\n      vec2 point_location = gl_FragCoord.xy - half_pixel;\n      //invalid points\n      if(point_location.y*points_per_row + point_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n      readDistances(point_location);\n\n      //Beta computation\n      float beta = 1.;\n      float max_beta = FLOAT_MAX;\n      float min_beta = -FLOAT_MAX;\n      //To avoid computing the log at every iteration\n      float log_perplexity = log(perplexity);\n      float entropy_diff = 0.;\n      float entropy = 0.;\n      float sum_probabilities = 0.;\n\n      //Binary search for a maximum of MAX_ITERATIONS\n      for(int iteration = 0; iteration < MAX_ITERATIONS; ++iteration) {\n        //At every iteration I compute the\n        //entropy enforced by the current beta\n        sum_probabilities = 0.;\n        entropy = 0.;\n        for(int n = 0; n < MAX_NEIGHBORS; ++n ) {\n          if(float(n) >= num_neighs-0.1) {\n            break;\n          }\n          float neigh_probability = exp(-beta * distances_squared[n]);\n          sum_probabilities += neigh_probability;\n          entropy += beta * distances_squared[n] * neigh_probability;\n        }\n\n        entropy = entropy / sum_probabilities + log(sum_probabilities);\n        entropy_diff = entropy - log_perplexity;\n\n        //the current beta is good enough!\n        if(entropy_diff < TOLERANCE && -entropy_diff < TOLERANCE) {\n          break;\n        }\n\n        if(entropy_diff > 0.) {\n          min_beta = beta;\n          if(max_beta == FLOAT_MAX || max_beta == -FLOAT_MAX) {\n            beta *= 2.;\n          }else{\n            beta = (beta + max_beta) / 2.;\n          }\n        }else{\n          max_beta = beta;\n          if(min_beta == -FLOAT_MAX || min_beta == FLOAT_MAX) {\n            beta /= 2.;\n          }else{\n            beta = (beta + min_beta) / 2.;\n          }\n        }\n      }\n      gl_FragColor = vec4(beta,sum_probabilities,0,1);\n    }\n  ");
      }, t.executeDistributionParametersComputationProgram = function (e, t, n, i, o, a, s, l, u) {
        var c = e.gl;
        null != u ? e.setOutputMatrixTexture(u, s, a) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var d = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "knn_graph_tex");
        e.setInputMatrixTexture(n, d, 0);
        var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_rows");
        c.uniform1f(h, s);
        var f = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_points");
        c.uniform1f(f, i);
        var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "points_per_row");
        c.uniform1f(p, a);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_neighs");
        c.uniform1f(m, o);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "perplexity");
        c.uniform1f(g, l), e.executeProgram();
      }, t.createGaussiaDistributionsFromDistancesProgram = function (e) {
        return e.createProgram("\n    precision highp float;\n    uniform sampler2D knn_graph_tex;\n    uniform sampler2D parameters_tex;\n    uniform float points_per_row;\n    uniform float num_rows;\n    uniform float num_points;\n    uniform float num_neighs;\n\n    vec2 half_pixel = vec2(0.5,0.5);\n\n    void main() {\n      vec2 point_location = gl_FragCoord.xy - half_pixel;\n      point_location.x = floor(point_location.x / num_neighs);\n\n      //invalid points\n      if(point_location.y*points_per_row + point_location.x >= num_points) {\n        gl_FragColor = vec4(0,0,0,0);\n        return;\n      }\n      float distance_squared\n            = texture2D(knn_graph_tex,\n                        gl_FragCoord.xy /\n                        vec2(points_per_row*num_neighs,num_rows)\n                      ).g;\n      vec2 parameters\n            = texture2D(parameters_tex,\n                        (point_location.xy + half_pixel)/\n                        vec2(points_per_row,num_rows)\n                      ).rg;\n      float beta = parameters.r;\n      float normalization = parameters.g;\n\n      float probability = exp(-beta * distance_squared) / normalization;\n      //check for NaN for degenerated knn (d = 0 for every point)\n      if (!(probability < 0.0 || 0.0 < probability || probability == 0.0)) {\n        probability = 0.;\n      }\n\n      gl_FragColor = vec4(probability,0,0,1);\n    }\n  ");
      }, t.executeGaussiaDistributionsFromDistancesProgram = function (e, t, n, i, o, a, s, l, u) {
        var c = e.gl;
        null != u ? e.setOutputMatrixTexture(u, l, s * a) : r.webgl.webgl_util.bindCanvasToFramebuffer(e.gl), e.setProgram(t);
        var d = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "knn_graph_tex");
        e.setInputMatrixTexture(n, d, 0);
        var h = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "parameters_tex");
        e.setInputMatrixTexture(i, h, 1);
        var f = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_rows");
        c.uniform1f(f, l);
        var p = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_points");
        c.uniform1f(p, o);
        var m = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "points_per_row");
        c.uniform1f(m, s);
        var g = r.webgl.webgl_util.getProgramUniformLocationOrThrow(c, t, "num_neighs");
        c.uniform1f(g, a), e.executeProgram();
      };
    },
    "./node_modules/add-dom-event-listener/lib/EventBaseObject.js": function node_modulesAddDomEventListenerLibEventBaseObjectJs(e, t, n) {
      "use strict";

      function r() {
        return !1;
      }
      function i() {
        return !0;
      }
      function o() {
        this.timeStamp = Date.now(), this.target = void 0, this.currentTarget = void 0;
      }
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), o.prototype = {
        isEventObject: 1,
        constructor: o,
        isDefaultPrevented: r,
        isPropagationStopped: r,
        isImmediatePropagationStopped: r,
        preventDefault: function preventDefault() {
          this.isDefaultPrevented = i;
        },
        stopPropagation: function stopPropagation() {
          this.isPropagationStopped = i;
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
          this.isImmediatePropagationStopped = i, this.stopPropagation();
        },
        halt: function halt(e) {
          e ? this.stopImmediatePropagation() : this.stopPropagation(), this.preventDefault();
        }
      }, t.default = o, e.exports = t.default;
    },
    "./node_modules/add-dom-event-listener/lib/EventObject.js": function node_modulesAddDomEventListenerLibEventObjectJs(e, t, n) {
      "use strict";

      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = r(n("./node_modules/add-dom-event-listener/lib/EventBaseObject.js")),
        o = r(n("./node_modules/object-assign/index.js")),
        a = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];
      function s(e) {
        return null == e;
      }
      var l = [{
        reg: /^key/,
        props: ["char", "charCode", "key", "keyCode", "which"],
        fix: function fix(e, t) {
          s(e.which) && (e.which = s(t.charCode) ? t.keyCode : t.charCode), void 0 === e.metaKey && (e.metaKey = e.ctrlKey);
        }
      }, {
        reg: /^touch/,
        props: ["touches", "changedTouches", "targetTouches"]
      }, {
        reg: /^hashchange$/,
        props: ["newURL", "oldURL"]
      }, {
        reg: /^gesturechange$/i,
        props: ["rotation", "scale"]
      }, {
        reg: /^(mousewheel|DOMMouseScroll)$/,
        props: [],
        fix: function fix(e, t) {
          var n = void 0,
            r = void 0,
            i = void 0,
            o = t.wheelDelta,
            a = t.axis,
            s = t.wheelDeltaY,
            l = t.wheelDeltaX,
            u = t.detail;
          o && (i = o / 120), u && (i = 0 - (u % 3 == 0 ? u / 3 : u)), void 0 !== a && (a === e.HORIZONTAL_AXIS ? (r = 0, n = 0 - i) : a === e.VERTICAL_AXIS && (n = 0, r = i)), void 0 !== s && (r = s / 120), void 0 !== l && (n = -1 * l / 120), n || r || (r = i), void 0 !== n && (e.deltaX = n), void 0 !== r && (e.deltaY = r), void 0 !== i && (e.delta = i);
        }
      }, {
        reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
        props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
        fix: function fix(e, t) {
          var n = void 0,
            r = void 0,
            i = void 0,
            o = e.target,
            a = t.button;
          return o && s(e.pageX) && !s(t.clientX) && (r = (n = o.ownerDocument || document).documentElement, i = n.body, e.pageX = t.clientX + (r && r.scrollLeft || i && i.scrollLeft || 0) - (r && r.clientLeft || i && i.clientLeft || 0), e.pageY = t.clientY + (r && r.scrollTop || i && i.scrollTop || 0) - (r && r.clientTop || i && i.clientTop || 0)), e.which || void 0 === a || (e.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), !e.relatedTarget && e.fromElement && (e.relatedTarget = e.fromElement === o ? e.toElement : e.fromElement), e;
        }
      }];
      function u() {
        return !0;
      }
      function c() {
        return !1;
      }
      function d(e) {
        var t = e.type,
          n = "function" == typeof e.stopPropagation || "boolean" == typeof e.cancelBubble;
        i.default.call(this), this.nativeEvent = e;
        var r = c;
        "defaultPrevented" in e ? r = e.defaultPrevented ? u : c : "getPreventDefault" in e ? r = e.getPreventDefault() ? u : c : "returnValue" in e && (r = !1 === e.returnValue ? u : c), this.isDefaultPrevented = r;
        var o = [],
          s = void 0,
          d = void 0,
          h = a.concat();
        for (l.forEach(function (e) {
          t.match(e.reg) && (h = h.concat(e.props), e.fix && o.push(e.fix));
        }), s = h.length; s;) this[d = h[--s]] = e[d];
        for (!this.target && n && (this.target = e.srcElement || document), this.target && 3 === this.target.nodeType && (this.target = this.target.parentNode), s = o.length; s;) (0, o[--s])(this, e);
        this.timeStamp = e.timeStamp || Date.now();
      }
      var h = i.default.prototype;
      (0, o.default)(d.prototype, h, {
        constructor: d,
        preventDefault: function preventDefault() {
          var e = this.nativeEvent;
          e.preventDefault ? e.preventDefault() : e.returnValue = !1, h.preventDefault.call(this);
        },
        stopPropagation: function stopPropagation() {
          var e = this.nativeEvent;
          e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, h.stopPropagation.call(this);
        }
      }), t.default = d, e.exports = t.default;
    },
    "./node_modules/add-dom-event-listener/lib/index.js": function node_modulesAddDomEventListenerLibIndexJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = function (e, t, n, r) {
        function i(t) {
          var r = new o.default(t);
          n.call(e, r);
        }
        if (e.addEventListener) {
          var a = (s = !1, "object" == typeof r ? s = r.capture || !1 : "boolean" == typeof r && (s = r), e.addEventListener(t, i, r || !1), {
            v: {
              remove: function remove() {
                e.removeEventListener(t, i, s);
              }
            }
          });
          if ("object" == typeof a) return a.v;
        } else if (e.attachEvent) return e.attachEvent("on" + t, i), {
          remove: function remove() {
            e.detachEvent("on" + t, i);
          }
        };
        var s;
      };
      var r,
        i = n("./node_modules/add-dom-event-listener/lib/EventObject.js"),
        o = (r = i) && r.__esModule ? r : {
          default: r
        };
      e.exports = t.default;
    },
    "./node_modules/anatomogram/lib/Anatomogram.js": function node_modulesAnatomogramLibAnatomogramJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = l(n("react")),
        i = l(n("./node_modules/prop-types/index.js")),
        o = l(n("./node_modules/anatomogram/lib/Switcher.js")),
        a = l(n("./node_modules/anatomogram/lib/AnatomogramSvg.js")),
        s = n("./node_modules/anatomogram/lib/Assets.js");
      function l(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      function u(e) {
        return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function c() {
        return (c = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      function d(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function h(e) {
        return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function f(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function p(e, t) {
        return (p = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      var m = function (e) {
        function t(e) {
          var n;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), (n = function (e, t) {
            return !t || "object" !== u(t) && "function" != typeof t ? f(e) : t;
          }(this, h(t).call(this, e))).state = {
            selectedView: (0, s.getDefaultView)(e.species)
          }, n._switchAnatomogramView = n._switchAnatomogramView.bind(f(n)), n;
        }
        var n, i, l;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && p(e, t);
        }(t, e), n = t, l = [{
          key: "getDerivedStateFromProps",
          value: function value(e, t) {
            return e.species !== t.species ? {
              species: e.species,
              selectedView: (0, s.getDefaultView)(e.species)
            } : null;
          }
        }], (i = [{
          key: "_switchAnatomogramView",
          value: function value(e) {
            this.setState({
              selectedView: e
            });
          }
        }, {
          key: "render",
          value: function value() {
            return s.supportedSpecies.includes(this.props.species) && r.default.createElement("div", null, r.default.createElement(o.default, {
              atlasUrl: this.props.atlasUrl,
              species: this.props.species,
              selectedView: this.state.selectedView,
              onChangeView: this._switchAnatomogramView
            }), r.default.createElement(a.default, c({
              atlasUrl: this.props.atlasUrl
            }, this.props, {
              selectedView: this.state.selectedView
            })));
          }
        }]) && d(n.prototype, i), l && d(n, l), t;
      }(r.default.Component);
      m.propTypes = {
        atlasUrl: i.default.string,
        species: i.default.string.isRequired
      }, m.defaultProps = {
        atlasUrl: "https://www.ebi.ac.uk/gxa/"
      };
      var g = m;
      t.default = g;
    },
    "./node_modules/anatomogram/lib/AnatomogramSvg.js": function node_modulesAnatomogramLibAnatomogramSvgJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = u(n("react")),
        i = u(n("./node_modules/prop-types/index.js")),
        o = u(n("./node_modules/urijs/src/URI.js")),
        a = u(n("./node_modules/anatomogram/node_modules/styled-components/dist/styled-components.browser.esm.js")),
        s = u(n("./node_modules/anatomogram/node_modules/react-svg/dist/react-svg.esm.js")),
        l = n("./node_modules/lodash/lodash.js");
      function u(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      function c() {
        var e = function (e, t) {
          t || (t = e.slice(0));
          return Object.freeze(Object.defineProperties(e, {
            raw: {
              value: Object.freeze(t)
            }
          }));
        }(["\n  display: inline-block;\n  vertical-align: top;\n  width: 90%;\n"]);
        return c = function c() {
          return e;
        }, e;
      }
      var d = function d(e, t) {
          return e && t && Object.assign(e.style, t);
        },
        h = function h(e, t, n, r) {
          e && e.addEventListener(t, function () {
            d(e, n), r();
          });
        },
        f = function f(e, t) {
          var n,
            r,
            i = t.idsWithMarkup,
            o = t.onMouseOver,
            a = t.onMouseOut,
            s = t.onClick;
          (n = i.map(function (e) {
            return e.id;
          }).filter(function (e, t, n) {
            return n.indexOf(e) === t;
          }).map(function (t) {
            return [e(t), t];
          }), r = "[0].id", Object.entries((0, l.groupBy)(n, r))).forEach(function (e) {
            var t = e[1][0][0],
              n = e[1].map(function (e) {
                return e[1];
              }),
              r = i.find(function (e) {
                return n.includes(e.id);
              });
            d(t, r.markupNormal), h(t, "mouseover", r.markupUnderFocus, o.bind(void 0, n)), h(t, "mouseout", r.markupNormal, a.bind(void 0, n)), h(t, "click", {}, s.bind(void 0, n));
          });
        },
        p = a.default.div(c()),
        m = function m(e) {
          return r.default.createElement(p, null, r.default.createElement(s.default, {
            onInjected: function onInjected(t, n) {
              t ? console.log("ReactSVG Error: ".concat(t)) : f(function (e) {
                var t = function (e) {
                  for (var t = e.getElementsByTagName("g"), n = 0; n < t.length; n++) if ("LAYER_EFO" === t[n].id) return t[n];
                }(e);
                return function e(n) {
                  if (t) for (var r = 0; r < t.children.length; r++) if (t.children[r].id === n) return t.children[r].attributes["xlink:href"] ? e(t.children[r].attributes["xlink:href"].value.substring(1)) : t.children[r];
                };
              }(n), e), e.onInjected(t, n);
            },
            src: (a = e.species, l = e.selectedView, t = n("./node_modules/anatomogram/lib/svg sync recursive ^\\.\\/.*\\.svg$")("./".concat(a).concat(l ? ".".concat(l) : "", ".svg")), i = e.atlasUrl, (0, o.default)(t).is("absolute") ? (0, o.default)(t) : (0, o.default)(t, i)).toString(),
            svgStyle: {
              width: "100%",
              height: "auto",
              paddingLeft: e.selectedView ? "10px" : ""
            }
          }));
          var t, i, a, l;
        };
      m.propTypes = {
        atlasUrl: i.default.string.isRequired,
        species: i.default.string.isRequired,
        selectedView: i.default.string,
        idsWithMarkup: i.default.arrayOf(i.default.shape({
          id: i.default.string.isRequired,
          markupNormal: i.default.object.isRequired,
          markupUnderFocus: i.default.object.isRequired
        })).isRequired,
        onMouseOver: i.default.func.isRequired,
        onMouseOut: i.default.func.isRequired,
        onClick: i.default.func.isRequired,
        onInjected: i.default.func.isRequired
      }, m.defaultProps = {
        onInjected: function onInjected(e, t) {}
      };
      var g = m;
      t.default = g;
    },
    "./node_modules/anatomogram/lib/Assets.js": function node_modulesAnatomogramLibAssetsJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.supportedSpecies = t.getDefaultView = t.getAnatomogramViews = void 0;
      var r,
        i = (r = n("./node_modules/anatomogram/lib/json/svgsMetadata.json")) && r.__esModule ? r : {
          default: r
        };
      var o = function o(e, t, n) {
          return n.indexOf(e) === t;
        },
        a = function a(e) {
          return "string" == typeof e && "" !== e.trim();
        },
        s = i.default.map(function (e) {
          return e.species;
        }).filter(o);
      t.supportedSpecies = s;
      var l = i.default.filter(function (e) {
          return "" !== e.view;
        }).map(function (e) {
          return e.species;
        }).filter(o).reduce(function (e, t) {
          return e[t] = i.default.filter(function (e) {
            return e.species === t;
          }).map(function (e) {
            return e.view;
          }).filter(a).sort().reverse(), e;
        }, {}),
        u = function u(e) {
          if (s.includes(e)) return l[e] || [];
        };
      t.getAnatomogramViews = u;
      t.getDefaultView = function (e) {
        if (s.includes(e)) return u(e)[0] || null;
      };
    },
    "./node_modules/anatomogram/lib/Main.js": function node_modulesAnatomogramLibMainJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = n("./node_modules/lodash/lodash.js"),
        i = n("./node_modules/anatomogram/node_modules/recompose/dist/Recompose.esm.js"),
        o = s(n("./node_modules/anatomogram/lib/Anatomogram.js")),
        a = s(n("./node_modules/prop-types/index.js"));
      function s(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      function l(e) {
        return function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
            return n;
          }
        }(e) || function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      var u = function u(e, t) {
          return Array.isArray(e) && Array.isArray(t) ? e.filter(function (e) {
            return !t.includes(e);
          }) : e;
        },
        c = function c(e, t) {
          return {
            fill: e,
            opacity: t
          };
        },
        d = (0, i.compose)((0, i.defaultProps)({
          showIds: [],
          highlightIds: [],
          selectIds: [],
          showColour: "grey",
          highlightColour: "red",
          selectColour: "purple",
          showOpacity: .4,
          highlightOpacity: .4,
          selectOpacity: .4
        }), (0, i.withPropsOnChange)((0, r.negate)(r.isEqual), function (e) {
          return {
            idsWithMarkup: (t = e, n = t.showIds, r = t.showColour, i = t.showOpacity, o = t.highlightIds, a = t.highlightColour, s = t.highlightOpacity, d = t.selectIds, h = t.selectColour, f = t.selectOpacity, p = u(n, [].concat(l(o), l(d))), m = u(o, d), [].concat(d.map(function (e) {
              return {
                id: e,
                markupNormal: c(h, f),
                markupUnderFocus: c(h, f + .2)
              };
            }), m.map(function (e) {
              return {
                id: e,
                markupNormal: c(a, s),
                markupUnderFocus: c(a, s + .2)
              };
            }), p.map(function (e) {
              return {
                id: e,
                markupNormal: c(r, i),
                markupUnderFocus: c(a, s + .2)
              };
            })))
          };
          var t, n, r, i, o, a, s, d, h, f, p, m;
        })),
        h = (0, i.mapProps)(function (e) {
          return Object.assign({}, e, {
            species: e.species.toLowerCase().replace(/ +/, "_")
          });
        }),
        f = (0, i.defaultProps)({
          onMouseOver: function onMouseOver() {},
          onMouseOut: function onMouseOut() {},
          onClick: function onClick() {}
        }),
        p = (0, i.setPropTypes)({
          atlasUrl: a.default.string.isRequired,
          species: a.default.string.isRequired,
          idsWithMarkup: a.default.arrayOf(a.default.shape({
            id: a.default.string.isRequired,
            markupNormal: a.default.object.isRequired,
            markupUnderFocus: a.default.object.isRequired
          })).isRequired,
          onMouseOver: a.default.func.isRequired,
          onMouseOut: a.default.func.isRequired,
          onClick: a.default.func.isRequired
        }),
        m = (0, i.defaultProps)({
          atlasUrl: "https://www.ebi.ac.uk/gxa/"
        }),
        g = (0, i.compose)(d, i.onlyUpdateForPropTypes, p, m, f, h)(o.default);
      t.default = g;
    },
    "./node_modules/anatomogram/lib/Switcher.js": function node_modulesAnatomogramLibSwitcherJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = void 0;
      var r = l(n("react")),
        i = l(n("./node_modules/prop-types/index.js")),
        o = l(n("./node_modules/urijs/src/URI.js")),
        a = l(n("./node_modules/anatomogram/node_modules/styled-components/dist/styled-components.browser.esm.js")),
        s = n("./node_modules/anatomogram/lib/Assets.js");
      function l(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      function u() {
        var e = d(["\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  height: auto;\n  padding: 2px;\n\n  &:hover {\n    border: 1px solid orange;\n    background: lightgoldenrodyellow;\n    cursor: pointer;\n  }\n"]);
        return u = function u() {
          return e;
        }, e;
      }
      function c() {
        var e = d(["\n  display: inline-block;\n  vertical-align: top;\n  width: 10%;\n  max-width: 44px;\n  line-height: 0;\n"]);
        return c = function c() {
          return e;
        }, e;
      }
      function d(e, t) {
        return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
          raw: {
            value: Object.freeze(t)
          }
        }));
      }
      var h = function h(e, t) {
          return n("./node_modules/anatomogram/lib/img sync recursive ^\\.\\/.*selected\\.png$")("./".concat(e, ".").concat(e === t ? "" : "un", "selected.png"));
        },
        f = a.default.div(c()),
        p = a.default.img(u()),
        m = function m(e) {
          var t = e.atlasUrl,
            n = e.species,
            i = e.selectedView,
            a = e.onChangeView;
          return r.default.createElement(f, null, (0, s.getAnatomogramViews)(n).map(function (e) {
            return r.default.createElement(p, {
              key: e,
              onClick: function onClick() {
                return a(e);
              },
              src: (n = h(e, i), s = t, (0, o.default)(n).is("absolute") ? (0, o.default)(n) : (0, o.default)(n, s)).toString()
            });
            var n, s;
          }));
        };
      m.propTypes = {
        atlasUrl: i.default.string.isRequired,
        species: i.default.string.isRequired,
        selectedView: i.default.string,
        onChangeView: i.default.func.isRequired
      }, m.defaultProps = {
        atlasUrl: "https://www.ebi.ac.uk/gxa/"
      };
      var g = m;
      t.default = g;
    },
    "./node_modules/anatomogram/lib/img sync recursive ^\\.\\/.*selected\\.png$": function node_modulesAnatomogramLibImgSyncRecursiveSelectedPng$(e, t, n) {
      var r = {
        "./brain.selected.png": "./node_modules/anatomogram/lib/img/brain.selected.png",
        "./brain.unselected.png": "./node_modules/anatomogram/lib/img/brain.unselected.png",
        "./female.selected.png": "./node_modules/anatomogram/lib/img/female.selected.png",
        "./female.unselected.png": "./node_modules/anatomogram/lib/img/female.unselected.png",
        "./flower_parts.selected.png": "./node_modules/anatomogram/lib/img/flower_parts.selected.png",
        "./flower_parts.unselected.png": "./node_modules/anatomogram/lib/img/flower_parts.unselected.png",
        "./male.selected.png": "./node_modules/anatomogram/lib/img/male.selected.png",
        "./male.unselected.png": "./node_modules/anatomogram/lib/img/male.unselected.png",
        "./whole_plant.selected.png": "./node_modules/anatomogram/lib/img/whole_plant.selected.png",
        "./whole_plant.unselected.png": "./node_modules/anatomogram/lib/img/whole_plant.unselected.png"
      };
      function i(e) {
        var t = o(e);
        return n(t);
      }
      function o(e) {
        if (!n.o(r, e)) {
          var t = new Error("Cannot find module '" + e + "'");
          throw t.code = "MODULE_NOT_FOUND", t;
        }
        return r[e];
      }
      i.keys = function () {
        return Object.keys(r);
      }, i.resolve = o, e.exports = i, i.id = "./node_modules/anatomogram/lib/img sync recursive ^\\.\\/.*selected\\.png$";
    },
    "./node_modules/anatomogram/lib/img/brain.selected.png": function node_modulesAnatomogramLibImgBrainSelectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/brain.selected.png";
    },
    "./node_modules/anatomogram/lib/img/brain.unselected.png": function node_modulesAnatomogramLibImgBrainUnselectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/brain.unselected.png";
    },
    "./node_modules/anatomogram/lib/img/female.selected.png": function node_modulesAnatomogramLibImgFemaleSelectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/female.selected.png";
    },
    "./node_modules/anatomogram/lib/img/female.unselected.png": function node_modulesAnatomogramLibImgFemaleUnselectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/female.unselected.png";
    },
    "./node_modules/anatomogram/lib/img/flower_parts.selected.png": function node_modulesAnatomogramLibImgFlower_partsSelectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/flower_parts.selected.png";
    },
    "./node_modules/anatomogram/lib/img/flower_parts.unselected.png": function node_modulesAnatomogramLibImgFlower_partsUnselectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/flower_parts.unselected.png";
    },
    "./node_modules/anatomogram/lib/img/male.selected.png": function node_modulesAnatomogramLibImgMaleSelectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/male.selected.png";
    },
    "./node_modules/anatomogram/lib/img/male.unselected.png": function node_modulesAnatomogramLibImgMaleUnselectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/male.unselected.png";
    },
    "./node_modules/anatomogram/lib/img/whole_plant.selected.png": function node_modulesAnatomogramLibImgWhole_plantSelectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/whole_plant.selected.png";
    },
    "./node_modules/anatomogram/lib/img/whole_plant.unselected.png": function node_modulesAnatomogramLibImgWhole_plantUnselectedPng(e, t, n) {
      e.exports = n.p + "assets/anatomogram/whole_plant.unselected.png";
    },
    "./node_modules/anatomogram/lib/index.js": function node_modulesAnatomogramLibIndexJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), Object.defineProperty(t, "default", {
        enumerable: !0,
        get: function get() {
          return o.default;
        }
      }), Object.defineProperty(t, "anatomogramSpecies", {
        enumerable: !0,
        get: function get() {
          return a.supportedSpecies;
        }
      }), t.render = void 0;
      var r = s(n("react")),
        i = s(n("react-dom")),
        o = s(n("./node_modules/anatomogram/lib/Main.js")),
        a = n("./node_modules/anatomogram/lib/Assets.js");
      function s(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      t.render = function (e, t) {
        i.default.render(r.default.createElement(o.default, e), document.getElementById(t));
      };
    },
    "./node_modules/anatomogram/lib/json/svgsMetadata.json": function node_modulesAnatomogramLibJsonSvgsMetadataJson(e) {
      e.exports = JSON.parse('[{"filename":"anolis_carolinensis.svg","species":"anolis_carolinensis","view":"","ids":["UBERON_0000955","UBERON_0000948","UBERON_0002113","UBERON_0014892"]},{"filename":"arabidopsis_thaliana.svg","species":"arabidopsis_thaliana","view":"","ids":["PO_0025034","PO_0009005","PO_0009046","PO_0009001"]},{"filename":"bos_taurus.svg","species":"bos_taurus","view":"","ids":["UBERON_0001013","UBERON_0014892","UBERON_0002114","UBERON_0000955","UBERON_0002113","UBERON_0002048","UBERON_0001155","UBERON_0000948","UBERON_0002107","UBERON_0002016","UBERON_0001898"]},{"filename":"brachypodium_distachyon.flower_parts.svg","species":"brachypodium_distachyon","view":"flower_parts","ids":["PO_0009066","PO_0009030","PO_0009001","PO_0009009","PO_0009089"]},{"filename":"brachypodium_distachyon.whole_plant.svg","species":"brachypodium_distachyon","view":"whole_plant","ids":["PO_0009010","PO_0009049","PO_0025034"]},{"filename":"gallus_gallus.svg","species":"gallus_gallus","view":"","ids":["UBERON_0000955","UBERON_0000948","UBERON_0002113","UBERON_0002107","UBERON_0001155","UBERON_0002106","UBERON_0002048","UBERON_0014892"]},{"filename":"homo_sapiens.brain.svg","species":"homo_sapiens","view":"brain","ids":["UBERON_0002148","UBERON_0001894","UBERON_0001896","UBERON_0002771","UBERON_0002702","UBERON_0002021","UBERON_0001905","UBERON_0001897","UBERON_0001898","UBERON_0002421","UBERON_0003027","UBERON_0001876","UBERON_0001870","UBERON_0001871","UBERON_0001882","UBERON_0002285","UBERON_0001873","UBERON_0001872","UBERON_0002038","UBERON_0001874","UBERON_0001875","UBERON_0002360","UBERON_0000451","UBERON_0000956","UBERON_0002037","UBERON_0002363","UBERON_0001954","UBERON_0002245"]},{"filename":"homo_sapiens.female.svg","species":"homo_sapiens","view":"female","ids":["UBERON_0001981","UBERON_0000178","UBERON_0001637","CL_0000236","CL_0000084","CL_0000623","CL_0000576","CL_0000233","UBERON_0000966","UBERON_0001831","UBERON_0001013","UBERON_0000948","UBERON_0001135","UBERON_0000955","UBERON_0000310","UBERON_0002369","UBERON_0000029","UBERON_0001134","UBERON_0000992","CL_0000738","UBERON_0001044","UBERON_0003889","UBERON_0000995","UBERON_0000002","UBERON_0001021","UBERON_0006618","UBERON_0012249","UBERON_0002421","UBERON_0000977","UBERON_0002185","UBERON_0003126","UBERON_0002048","UBERON_0002372","UBERON_0000970","UBERON_0001876","UBERON_0001736","UBERON_0001264","UBERON_0002107","UBERON_0001155","UBERON_0002371","UBERON_0001255","UBERON_0000945","UBERON_0002114","UBERON_0001043","UBERON_0002110","UBERON_0002106","UBERON_0002108","UBERON_0001987","UBERON_0001295","UBERON_0000996","UBERON_0000947","UBERON_0000007","UBERON_0007650","UBERON_0001153","UBERON_0001154","UBERON_0002116","UBERON_0002079","UBERON_0002084","UBERON_0002146","UBERON_0002135","UBERON_0001103","UBERON_0002481","UBERON_0007844","UBERON_0000341","UBERON_0001052","UBERON_0001706","UBERON_0001728","UBERON_0002037","UBERON_0002245","UBERON_0000451","UBERON_0001870","UBERON_0000004","UBERON_0001871","UBERON_0000956","UBERON_0002113","UBERON_0001225","UBERON_0001621","UBERON_0002134","UBERON_0002046","UBERON_0000014","UBERON_0000167","UBERON_0001723"]},{"filename":"homo_sapiens.male.svg","species":"homo_sapiens","view":"male","ids":["UBERON_0000956","UBERON_0000977","UBERON_0000955","UBERON_0000948","UBERON_0000310","UBERON_0002369","UBERON_0000029","UBERON_0001013","UBERON_0001134","CL_0000738","UBERON_0001871","UBERON_0006618","UBERON_0001621","UBERON_0002421","UBERON_0001000","UBERON_0000998","UBERON_0000473","UBERON_0001301","UBERON_0000970","UBERON_0002372","UBERON_0002048","UBERON_0001876","UBERON_0003126","UBERON_0002185","UBERON_0001021","UBERON_0002037","UBERON_0002245","UBERON_0002113","UBERON_0001225","UBERON_0002046","UBERON_0002371","UBERON_0001870","UBERON_0000451","UBERON_0000007","UBERON_0000947","UBERON_0007650","UBERON_0002084","UBERON_0001153","UBERON_0002116","UBERON_0001052","UBERON_0000004","UBERON_0001723","UBERON_0002079","UBERON_0002146","UBERON_0002135","UBERON_0000989","UBERON_0001728","UBERON_0002240","UBERON_0000341","UBERON_0002134","UBERON_0001103","UBERON_0002107","UBERON_0000945","UBERON_0002106","UBERON_0002114","UBERON_0002110","UBERON_0001264","UBERON_0001155","UBERON_0002108","UBERON_0001154","UBERON_0001135","UBERON_0001255","UBERON_00024818","UBERON_0007844","UBERON_0001043","UBERON_0001044","UBERON_0001831","UBERON_0001736","UBERON_0000014","UBERON_0000178","UBERON_0001981","UBERON_0001637","CL_0000236","CL_0000084","CL_0000623","CL_0000576","CL_0000233","UBERON_0001954","UBERON_0000966","UBERON_0001706","UBERON_0000167","UBERON_0002367"]},{"filename":"hordeum_vulgare.flower_parts.svg","species":"hordeum_vulgare","view":"flower_parts","ids":["PO_0009001","PO_0009030","PO_0009073","PO_0009072","PO_0009009","PO_0009066"]},{"filename":"hordeum_vulgare.whole_plant.svg","species":"hordeum_vulgare","view":"whole_plant","ids":["PO_0020142","PO_0009005","PO_0009006","PO_0009049","PO_0025034"]},{"filename":"macaca_mulatta.svg","species":"macaca_mulatta","view":"","ids":["UBERON_0000955","UBERON_0000451","UBERON_0002037","UBERON_0000948","UBERON_0002113","UBERON_0002107","UBERON_0000473"]},{"filename":"monodelphis_domestica.svg","species":"monodelphis_domestica","view":"","ids":["UBERON_0000955","UBERON_0002037","UBERON_0000948","UBERON_0002113","UBERON_0002107","UBERON_0000473"]},{"filename":"mus_musculus.brain.svg","species":"mus_musculus","view":"brain","ids":["UBERON_0001896","UBERON_0000956","UBERON_0000369","UBERON_0001894","UBERON_0000007","UBERON_0002037","UBERON_0002298","UBERON_0001891","UBERON_0001897","UBERON_0001898","UBERON_0000004","UBERON_0002259","EFO_0000530"]},{"filename":"mus_musculus.female.svg","species":"mus_musculus","view":"female","ids":["UBERON_0000947","UBERON_0001009","UBERON_0001348","UBERON_0001347","UBERON_0000945","UBERON_0002114","UBERON_0001264","UBERON_0002106","UBERON_0002369","UBERON_0002113","UBERON_0001155","UBERON_0002108","UBERON_0001153","UBERON_0002115","UBERON_0002116","UBERON_0001043","UBERON_0002110","UBERON_0000996","UBERON_0000995","UBERON_0001255","UBERON_0001831","UBERON_0001736","UBERON_0001723","UBERON_0001211","UBERON_0000981","UBERON_0002371","UBERON_0007844","UBERON_0001377","UBERON_0014892","UBERON_0002240","UBERON_0001103","UBERON_0002103","UBERON_0001645","UBERON_0000970","UBERON_0001242","UBERON_0000955","UBERON_0000948","UBERON_0002107","UBERON_0001322","UBERON_0001981","UBERON_0000014","UBERON_0001911","UBERON_0003134","UBERON_0000990","UBERON_0000029","UBERON_0001132","UBERON_0002370","UBERON_0002046","UBERON_0002048","UBERON_0000010","UBERON_0003126"]},{"filename":"mus_musculus.male.svg","species":"mus_musculus","view":"male","ids":["UBERON_0000947","UBERON_0001348","UBERON_0001347","UBERON_0000945","UBERON_0002114","UBERON_0001264","UBERON_0002106","UBERON_0002369","UBERON_0002113","UBERON_0001155","UBERON_0002108","UBERON_0001153","UBERON_0002115","UBERON_0002116","UBERON_0001043","UBERON_0002110","UBERON_0001831","UBERON_0001736","UBERON_0000029","UBERON_0000998","UBERON_0000989","UBERON_0000981","UBERON_0002371","UBERON_0007844","UBERON_0001377","UBERON_0002240","UBERON_0002048","UBERON_0001103","UBERON_0003126","UBERON_0002103","UBERON_0001645","UBERON_0001322","UBERON_0001242","UBERON_0002107","UBERON_0000948","UBERON_0000955","UBERON_0014892","UBERON_0001009","UBERON_0001981","UBERON_0000014","UBERON_0001132","UBERON_0001211","UBERON_0002367","UBERON_0001000","UBERON_0001301","UBERON_0000473","UBERON_0001255","UBERON_0002370","UBERON_0000010","UBERON_0000970","UBERON_0001723"]},{"filename":"oryza_sativa.flower_parts.svg","species":"oryza_sativa","view":"flower_parts","ids":["PO_0009010","PO_0009009","PO_0009089","PO_0009030","PO_0009066"]},{"filename":"oryza_sativa.whole_plant.svg","species":"oryza_sativa","view":"whole_plant","ids":["PO_0025034","PO_0009005","PO_0009049","PO_0009006","PO_0005052"]},{"filename":"papio_anubis.svg","species":"papio_anubis","view":"","ids":["UBERON_0000948","UBERON_0002107","UBERON_0000945","UBERON_0001155","UBERON_0002371","UBERON_0002113","UBERON_0002106","UBERON_0014892","UBERON_0002370","UBERON_0000955","UBERON_0001871","UBERON_0001870","UBERON_0000007","UBERON_0002048","UBERON_0000029","UBERON_0002037"]},{"filename":"rattus_norvegicus.svg","species":"rattus_norvegicus","view":"","ids":["UBERON_0000955","UBERON_0002113","CL_0000336","UBERON_0001388","UBERON_0000948","UBERON_0002107","UBERON_0002048","UBERON_0002106","UBERON_0002370","UBERON_0000995","UBERON_0000473","UBERON_0001155"]},{"filename":"solanum_lycopersicum.flower_parts.svg","species":"solanum_lycopersicum","view":"flower_parts","ids":["PO_0009084","PO_0009030","PO_0009072","PO_0009073","PO_0009074","PO_0009066","PO_0009010"]},{"filename":"solanum_lycopersicum.whole_plant.svg","species":"solanum_lycopersicum","view":"whole_plant","ids":["PO_0025034","PO_0000056","PO_0009046","PO_0009001","PO_0009005"]},{"filename":"solanum_tuberosum.svg","species":"solanum_tuberosum","view":"","ids":[]},{"filename":"sorghum_bicolor.flower_parts.svg","species":"sorghum_bicolor","view":"flower_parts","ids":["PO_0009049","PO_0009051","PO_0009001","PO_0009009","PO_0009089","PO_0009066","PO_0009030"]},{"filename":"sorghum_bicolor.whole_plant.svg","species":"sorghum_bicolor","view":"whole_plant","ids":["PO_0009006","PO_0006079","PO_0009047","PO_0000230","PO_0009049","PO_0025034","PO_0009005"]},{"filename":"tetraodon_nigroviridis.svg","species":"tetraodon_nigroviridis","view":"","ids":["UBERON_0000955","UBERON_0000948","UBERON_0002113","UBERON_0014892"]},{"filename":"triticum_aestivum.flower_parts.svg","species":"triticum_aestivum","view":"flower_parts","ids":["PO_0020033","PO_0020031","PO_0009089","PO_0009085","PO_0009086","PO_0009084","PO_0009009","PO_0009001","PO_0009088","PO_0009030","PO_0009066"]},{"filename":"triticum_aestivum.whole_plant.svg","species":"triticum_aestivum","view":"whole_plant","ids":["PO_0009047","PO_0009005","PO_0009049","PO_0025034"]},{"filename":"xenopus_tropicalis.svg","species":"xenopus_tropicalis","view":"","ids":["UBERON_0000955","UBERON_0002113","UBERON_0014892","UBERON_0000948","UBERON_0002107"]},{"filename":"zea_mays.flower_parts.svg","species":"zea_mays","view":"flower_parts","ids":["PO_0009001","PO_0020033","PO_0020031","PO_0020136","PO_0025597","PO_0009066","PO_0009009","PO_0009089","PO_0009084"]},{"filename":"zea_mays.whole_plant.svg","species":"zea_mays","view":"whole_plant","ids":["PO_0020126","PO_0020136","PO_0020142","PO_0020127","PO_0009005","PO_0009074","PO_0025034"]}]');
    },
    "./node_modules/anatomogram/lib/svg sync recursive ^\\.\\/.*\\.svg$": function node_modulesAnatomogramLibSvgSyncRecursiveSvg$(e, t, n) {
      var r = {
        "./anolis_carolinensis.svg": "./node_modules/anatomogram/lib/svg/anolis_carolinensis.svg",
        "./arabidopsis_thaliana.svg": "./node_modules/anatomogram/lib/svg/arabidopsis_thaliana.svg",
        "./bos_taurus.svg": "./node_modules/anatomogram/lib/svg/bos_taurus.svg",
        "./brachypodium_distachyon.flower_parts.svg": "./node_modules/anatomogram/lib/svg/brachypodium_distachyon.flower_parts.svg",
        "./brachypodium_distachyon.whole_plant.svg": "./node_modules/anatomogram/lib/svg/brachypodium_distachyon.whole_plant.svg",
        "./gallus_gallus.svg": "./node_modules/anatomogram/lib/svg/gallus_gallus.svg",
        "./homo_sapiens.brain.svg": "./node_modules/anatomogram/lib/svg/homo_sapiens.brain.svg",
        "./homo_sapiens.female.svg": "./node_modules/anatomogram/lib/svg/homo_sapiens.female.svg",
        "./homo_sapiens.male.svg": "./node_modules/anatomogram/lib/svg/homo_sapiens.male.svg",
        "./hordeum_vulgare.flower_parts.svg": "./node_modules/anatomogram/lib/svg/hordeum_vulgare.flower_parts.svg",
        "./hordeum_vulgare.whole_plant.svg": "./node_modules/anatomogram/lib/svg/hordeum_vulgare.whole_plant.svg",
        "./macaca_mulatta.svg": "./node_modules/anatomogram/lib/svg/macaca_mulatta.svg",
        "./monodelphis_domestica.svg": "./node_modules/anatomogram/lib/svg/monodelphis_domestica.svg",
        "./mus_musculus.brain.svg": "./node_modules/anatomogram/lib/svg/mus_musculus.brain.svg",
        "./mus_musculus.female.svg": "./node_modules/anatomogram/lib/svg/mus_musculus.female.svg",
        "./mus_musculus.male.svg": "./node_modules/anatomogram/lib/svg/mus_musculus.male.svg",
        "./oryza_sativa.flower_parts.svg": "./node_modules/anatomogram/lib/svg/oryza_sativa.flower_parts.svg",
        "./oryza_sativa.whole_plant.svg": "./node_modules/anatomogram/lib/svg/oryza_sativa.whole_plant.svg",
        "./papio_anubis.svg": "./node_modules/anatomogram/lib/svg/papio_anubis.svg",
        "./rattus_norvegicus.svg": "./node_modules/anatomogram/lib/svg/rattus_norvegicus.svg",
        "./solanum_lycopersicum.flower_parts.svg": "./node_modules/anatomogram/lib/svg/solanum_lycopersicum.flower_parts.svg",
        "./solanum_lycopersicum.whole_plant.svg": "./node_modules/anatomogram/lib/svg/solanum_lycopersicum.whole_plant.svg",
        "./solanum_tuberosum.svg": "./node_modules/anatomogram/lib/svg/solanum_tuberosum.svg",
        "./sorghum_bicolor.flower_parts.svg": "./node_modules/anatomogram/lib/svg/sorghum_bicolor.flower_parts.svg",
        "./sorghum_bicolor.whole_plant.svg": "./node_modules/anatomogram/lib/svg/sorghum_bicolor.whole_plant.svg",
        "./tetraodon_nigroviridis.svg": "./node_modules/anatomogram/lib/svg/tetraodon_nigroviridis.svg",
        "./triticum_aestivum.flower_parts.svg": "./node_modules/anatomogram/lib/svg/triticum_aestivum.flower_parts.svg",
        "./triticum_aestivum.whole_plant.svg": "./node_modules/anatomogram/lib/svg/triticum_aestivum.whole_plant.svg",
        "./xenopus_tropicalis.svg": "./node_modules/anatomogram/lib/svg/xenopus_tropicalis.svg",
        "./zea_mays.flower_parts.svg": "./node_modules/anatomogram/lib/svg/zea_mays.flower_parts.svg",
        "./zea_mays.whole_plant.svg": "./node_modules/anatomogram/lib/svg/zea_mays.whole_plant.svg"
      };
      function i(e) {
        var t = o(e);
        return n(t);
      }
      function o(e) {
        if (!n.o(r, e)) {
          var t = new Error("Cannot find module '" + e + "'");
          throw t.code = "MODULE_NOT_FOUND", t;
        }
        return r[e];
      }
      i.keys = function () {
        return Object.keys(r);
      }, i.resolve = o, e.exports = i, i.id = "./node_modules/anatomogram/lib/svg sync recursive ^\\.\\/.*\\.svg$";
    },
    "./node_modules/anatomogram/lib/svg/anolis_carolinensis.svg": function node_modulesAnatomogramLibSvgAnolis_carolinensisSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/anolis_carolinensis.svg";
    },
    "./node_modules/anatomogram/lib/svg/arabidopsis_thaliana.svg": function node_modulesAnatomogramLibSvgArabidopsis_thalianaSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/arabidopsis_thaliana.svg";
    },
    "./node_modules/anatomogram/lib/svg/bos_taurus.svg": function node_modulesAnatomogramLibSvgBos_taurusSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/bos_taurus.svg";
    },
    "./node_modules/anatomogram/lib/svg/brachypodium_distachyon.flower_parts.svg": function node_modulesAnatomogramLibSvgBrachypodium_distachyonFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/brachypodium_distachyon.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/brachypodium_distachyon.whole_plant.svg": function node_modulesAnatomogramLibSvgBrachypodium_distachyonWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/brachypodium_distachyon.whole_plant.svg";
    },
    "./node_modules/anatomogram/lib/svg/gallus_gallus.svg": function node_modulesAnatomogramLibSvgGallus_gallusSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/gallus_gallus.svg";
    },
    "./node_modules/anatomogram/lib/svg/homo_sapiens.brain.svg": function node_modulesAnatomogramLibSvgHomo_sapiensBrainSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/homo_sapiens.brain.svg";
    },
    "./node_modules/anatomogram/lib/svg/homo_sapiens.female.svg": function node_modulesAnatomogramLibSvgHomo_sapiensFemaleSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/homo_sapiens.female.svg";
    },
    "./node_modules/anatomogram/lib/svg/homo_sapiens.male.svg": function node_modulesAnatomogramLibSvgHomo_sapiensMaleSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/homo_sapiens.male.svg";
    },
    "./node_modules/anatomogram/lib/svg/hordeum_vulgare.flower_parts.svg": function node_modulesAnatomogramLibSvgHordeum_vulgareFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/hordeum_vulgare.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/hordeum_vulgare.whole_plant.svg": function node_modulesAnatomogramLibSvgHordeum_vulgareWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/hordeum_vulgare.whole_plant.svg";
    },
    "./node_modules/anatomogram/lib/svg/macaca_mulatta.svg": function node_modulesAnatomogramLibSvgMacaca_mulattaSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/macaca_mulatta.svg";
    },
    "./node_modules/anatomogram/lib/svg/monodelphis_domestica.svg": function node_modulesAnatomogramLibSvgMonodelphis_domesticaSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/monodelphis_domestica.svg";
    },
    "./node_modules/anatomogram/lib/svg/mus_musculus.brain.svg": function node_modulesAnatomogramLibSvgMus_musculusBrainSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/mus_musculus.brain.svg";
    },
    "./node_modules/anatomogram/lib/svg/mus_musculus.female.svg": function node_modulesAnatomogramLibSvgMus_musculusFemaleSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/mus_musculus.female.svg";
    },
    "./node_modules/anatomogram/lib/svg/mus_musculus.male.svg": function node_modulesAnatomogramLibSvgMus_musculusMaleSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/mus_musculus.male.svg";
    },
    "./node_modules/anatomogram/lib/svg/oryza_sativa.flower_parts.svg": function node_modulesAnatomogramLibSvgOryza_sativaFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/oryza_sativa.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/oryza_sativa.whole_plant.svg": function node_modulesAnatomogramLibSvgOryza_sativaWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/oryza_sativa.whole_plant.svg";
    },
    "./node_modules/anatomogram/lib/svg/papio_anubis.svg": function node_modulesAnatomogramLibSvgPapio_anubisSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/papio_anubis.svg";
    },
    "./node_modules/anatomogram/lib/svg/rattus_norvegicus.svg": function node_modulesAnatomogramLibSvgRattus_norvegicusSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/rattus_norvegicus.svg";
    },
    "./node_modules/anatomogram/lib/svg/solanum_lycopersicum.flower_parts.svg": function node_modulesAnatomogramLibSvgSolanum_lycopersicumFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/solanum_lycopersicum.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/solanum_lycopersicum.whole_plant.svg": function node_modulesAnatomogramLibSvgSolanum_lycopersicumWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/solanum_lycopersicum.whole_plant.svg";
    },
    "./node_modules/anatomogram/lib/svg/solanum_tuberosum.svg": function node_modulesAnatomogramLibSvgSolanum_tuberosumSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/solanum_tuberosum.svg";
    },
    "./node_modules/anatomogram/lib/svg/sorghum_bicolor.flower_parts.svg": function node_modulesAnatomogramLibSvgSorghum_bicolorFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/sorghum_bicolor.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/sorghum_bicolor.whole_plant.svg": function node_modulesAnatomogramLibSvgSorghum_bicolorWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/sorghum_bicolor.whole_plant.svg";
    },
    "./node_modules/anatomogram/lib/svg/tetraodon_nigroviridis.svg": function node_modulesAnatomogramLibSvgTetraodon_nigroviridisSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/tetraodon_nigroviridis.svg";
    },
    "./node_modules/anatomogram/lib/svg/triticum_aestivum.flower_parts.svg": function node_modulesAnatomogramLibSvgTriticum_aestivumFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/triticum_aestivum.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/triticum_aestivum.whole_plant.svg": function node_modulesAnatomogramLibSvgTriticum_aestivumWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/triticum_aestivum.whole_plant.svg";
    },
    "./node_modules/anatomogram/lib/svg/xenopus_tropicalis.svg": function node_modulesAnatomogramLibSvgXenopus_tropicalisSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/xenopus_tropicalis.svg";
    },
    "./node_modules/anatomogram/lib/svg/zea_mays.flower_parts.svg": function node_modulesAnatomogramLibSvgZea_maysFlower_partsSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/zea_mays.flower_parts.svg";
    },
    "./node_modules/anatomogram/lib/svg/zea_mays.whole_plant.svg": function node_modulesAnatomogramLibSvgZea_maysWhole_plantSvg(e, t, n) {
      e.exports = n.p + "assets/anatomogram/zea_mays.whole_plant.svg";
    },
    "./node_modules/anatomogram/node_modules/react-svg/dist/react-svg.esm.js": function node_modulesAnatomogramNode_modulesReactSvgDistReactSvgEsmJs(e, t, n) {
      "use strict";

      n.r(t);
      var r,
        i = n("./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"),
        o = n.n(i),
        a = n("./node_modules/@babel/runtime/helpers/inheritsLoose.js"),
        s = n.n(a),
        l = function l(e) {
          return e.cloneNode(!0);
        },
        u = function u() {
          return "file:" === window.location.protocol;
        },
        c = new Map(),
        d = {},
        h = function h(e, t) {
          d[e] = d[e] || [], d[e].push(t);
        },
        f = function f(e) {
          for (var t = function t(_t2, n) {
              setTimeout(function () {
                if (Array.isArray(d[e])) {
                  var n = c.get(e),
                    r = d[e][_t2];
                  (n instanceof SVGSVGElement || n instanceof HTMLElement) && r(null, l(n)), n instanceof Error && r(n), _t2 === d[e].length - 1 && delete d[e];
                }
              }, 0);
            }, n = 0, r = d[e].length; n < r; n++) t(n);
        },
        p = 0,
        m = [],
        g = {},
        v = "http://www.w3.org/1999/xlink",
        y = function y(e, t, n) {
          var r = n.evalScripts,
            i = n.renumerateIRIElements,
            o = e.getAttribute("data-src") || e.getAttribute("src");
          if (o && /\.svg/i.test(o)) {
            if (-1 !== m.indexOf(e)) return m.splice(m.indexOf(e), 1), void (e = null);
            m.push(e), e.setAttribute("src", ""), function (e, t) {
              if (c.has(e)) {
                var n = c.get(e);
                return n instanceof SVGSVGElement || n instanceof HTMLElement ? void t(null, l(n)) : n instanceof Error ? void t(n) : void h(e, t);
              }
              c.set(e, void 0), h(e, t);
              var r = new XMLHttpRequest();
              r.onreadystatechange = function () {
                try {
                  if (4 === r.readyState) {
                    if (404 === r.status || null === r.responseXML) throw new Error(u() ? "Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver." : "Unable to load SVG file: " + e);
                    if (!(200 === r.status || u() && 0 === r.status)) throw new Error("There was a problem injecting the SVG: " + r.status + " " + r.statusText);
                    r.responseXML instanceof Document && r.responseXML.documentElement && c.set(e, r.responseXML.documentElement), f(e);
                  }
                } catch (t) {
                  c.set(e, t), f(e);
                }
              }, r.open("GET", e), r.overrideMimeType && r.overrideMimeType("text/xml"), r.send();
            }(o, function (n, a) {
              if (!a) return m.splice(m.indexOf(e), 1), e = null, void t(n);
              var s = e.getAttribute("id");
              s && a.setAttribute("id", s);
              var l = e.getAttribute("title");
              l && a.setAttribute("title", l);
              var u = e.getAttribute("width");
              u && a.setAttribute("width", u);
              var c = e.getAttribute("height");
              c && a.setAttribute("height", c);
              var d = Array.from(new Set((a.getAttribute("class") || "").split(" ").concat(["injected-svg"], (e.getAttribute("class") || "").split(" ")))).join(" ").trim();
              a.setAttribute("class", d);
              var h = e.getAttribute("style");
              h && a.setAttribute("style", h), a.setAttribute("data-src", o);
              var f = [].filter.call(e.attributes, function (e) {
                return /^data-\w[\w-]*$/.test(e.name);
              });
              if (Array.prototype.forEach.call(f, function (e) {
                e.name && e.value && a.setAttribute(e.name, e.value);
              }), i) {
                var y,
                  b,
                  _,
                  x,
                  w,
                  S = {
                    clipPath: ["clip-path"],
                    "color-profile": ["color-profile"],
                    cursor: ["cursor"],
                    filter: ["filter"],
                    linearGradient: ["fill", "stroke"],
                    marker: ["marker", "marker-start", "marker-mid", "marker-end"],
                    mask: ["mask"],
                    path: [],
                    pattern: ["fill", "stroke"],
                    radialGradient: ["fill", "stroke"]
                  };
                Object.keys(S).forEach(function (e) {
                  y = e, _ = S[e];
                  for (var t = function t(e, _t3) {
                      var n;
                      x = b[e].id, w = x + "-" + ++p, Array.prototype.forEach.call(_, function (e) {
                        for (var t = 0, r = (n = a.querySelectorAll("[" + e + '*="' + x + '"]')).length; t < r; t++) {
                          var i = n[t].getAttribute(e);
                          i && !i.match(new RegExp("url\\(#" + x + "\\)")) || n[t].setAttribute(e, "url(#" + w + ")");
                        }
                      });
                      for (var r = a.querySelectorAll("[*|href]"), i = [], o = 0, s = r.length; o < s; o++) {
                        var l = r[o].getAttributeNS(v, "href");
                        l && l.toString() === "#" + b[e].id && i.push(r[o]);
                      }
                      for (var u = 0, c = i.length; u < c; u++) i[u].setAttributeNS(v, "href", "#" + w);
                      b[e].id = w;
                    }, n = 0, r = (b = a.querySelectorAll(y + "[id]")).length; n < r; n++) t(n);
                });
              }
              a.removeAttribute("xmlns:a");
              for (var A, E, T = a.querySelectorAll("script"), M = [], C = 0, k = T.length; C < k; C++) (E = T[C].getAttribute("type")) && "application/ecmascript" !== E && "application/javascript" !== E && "text/javascript" !== E || ((A = T[C].innerText || T[C].textContent) && M.push(A), a.removeChild(T[C]));
              if (M.length > 0 && ("always" === r || "once" === r && !g[o])) {
                for (var P = 0, O = M.length; P < O; P++) new Function(M[P])(window);
                g[o] = !0;
              }
              var R = a.querySelectorAll("style");
              Array.prototype.forEach.call(R, function (e) {
                e.textContent += "";
              }), a.setAttribute("xmlns", "http://www.w3.org/2000/svg"), a.setAttribute("xmlns:xlink", v), e.parentNode && e.parentNode.replaceChild(a, e), m.splice(m.indexOf(e), 1), e = null, t(null, a);
            });
          } else t(new Error("Attempted to inject a file with a non-svg extension: " + o));
        };
      !function (e) {
        e.Always = "always", e.Once = "once", e.Never = "never";
      }(r || (r = {}));
      var b = n("./node_modules/prop-types/index.js"),
        _ = n("react"),
        x = n("./node_modules/react-dom/server.browser.js"),
        w = n.n(x),
        S = function (e) {
          function t() {
            var t;
            return (t = e.apply(this, arguments) || this).initialState = {
              hasError: !1,
              isLoading: !0
            }, t.state = t.initialState, t._isMounted = !1, t.refCallback = function (e) {
              t.container = e;
            }, t;
          }
          s()(t, e);
          var n = t.prototype;
          return n.renderSVG = function () {
            var e = this;
            if (this.container instanceof Node) {
              var t = this.props,
                n = t.evalScripts,
                i = t.renumerateIRIElements,
                o = t.src,
                a = t.svgClassName,
                s = t.svgStyle,
                l = this.props.onInjected,
                u = this.props.wrapper,
                c = document.createElement(u);
              c.innerHTML = w.a.renderToStaticMarkup(Object(_.createElement)(u, null, Object(_.createElement)(u, {
                className: a,
                "data-src": o,
                style: s
              }))), this.svgWrapper = this.container.appendChild(c.firstChild);
              !function (e, t) {
                var n = void 0 === t ? {} : t,
                  i = n.done,
                  o = void 0 === i ? function () {} : i,
                  a = n.each,
                  s = void 0 === a ? function () {} : a,
                  l = n.evalScripts,
                  u = void 0 === l ? r.Never : l,
                  c = n.renumerateIRIElements,
                  d = void 0 === c || c;
                if (e && "length" in e) for (var h = 0, f = 0, p = e.length; f < p; f++) y(e[f], function (t, n) {
                  s(t, n), e && "length" in e && e.length === ++h && o(h);
                }, {
                  evalScripts: u,
                  renumerateIRIElements: d
                });else e ? y(e, function (t, n) {
                  s(t, n), o(1), e = null;
                }, {
                  evalScripts: u,
                  renumerateIRIElements: d
                }) : o(0);
              }(this.svgWrapper.firstChild, {
                each: function each(t, n) {
                  t && e.removeSVG(), e._isMounted && e.setState(function () {
                    return {
                      hasError: !!t,
                      isLoading: !1
                    };
                  }, function () {
                    l(t, n);
                  });
                },
                evalScripts: n,
                renumerateIRIElements: i
              });
            }
          }, n.removeSVG = function () {
            this.container instanceof Node && this.svgWrapper instanceof Node && (this.container.removeChild(this.svgWrapper), this.svgWrapper = null);
          }, n.componentDidMount = function () {
            this._isMounted = !0, this.renderSVG();
          }, n.componentDidUpdate = function (e) {
            var t = this;
            (function (e, t) {
              for (var n in e) if (!(n in t)) return !0;
              for (var r in t) if (e[r] !== t[r]) return !0;
              return !1;
            })(e, this.props) && this.setState(function () {
              return t.initialState;
            }, function () {
              t.removeSVG(), t.renderSVG();
            });
          }, n.componentWillUnmount = function () {
            this._isMounted = !1, this.removeSVG();
          }, n.render = function () {
            var e = this.props,
              t = (e.evalScripts, e.fallback),
              n = e.loading,
              r = (e.onInjected, e.renumerateIRIElements, e.src, e.svgClassName, e.svgStyle, e.wrapper),
              i = o()(e, ["evalScripts", "fallback", "loading", "onInjected", "renumerateIRIElements", "src", "svgClassName", "svgStyle", "wrapper"]),
              a = r;
            return Object(_.createElement)(a, Object.assign({}, i, {
              ref: this.refCallback
            }), this.state.isLoading && n && Object(_.createElement)(n, null), this.state.hasError && t && Object(_.createElement)(t, null));
          }, t;
        }(_.Component);
      S.defaultProps = {
        evalScripts: "never",
        fallback: null,
        loading: null,
        onInjected: function onInjected() {},
        renumerateIRIElements: !0,
        svgClassName: null,
        svgStyle: {},
        wrapper: "div"
      }, S.propTypes = {
        evalScripts: Object(b.oneOf)(["always", "once", "never"]),
        fallback: Object(b.oneOfType)([b.func, b.object, b.string]),
        loading: Object(b.oneOfType)([b.func, b.object, b.string]),
        onInjected: b.func,
        renumerateIRIElements: b.bool,
        src: b.string.isRequired,
        svgClassName: b.string,
        svgStyle: b.object,
        wrapper: Object(b.oneOf)(["div", "span"])
      };
      t.default = S;
    },
    "./node_modules/anatomogram/node_modules/recompose/dist/Recompose.esm.js": function node_modulesAnatomogramNode_modulesRecomposeDistRecomposeEsmJs(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "mapProps", function () {
        return b;
      }), n.d(t, "withProps", function () {
        return _;
      }), n.d(t, "withPropsOnChange", function () {
        return w;
      }), n.d(t, "withHandlers", function () {
        return A;
      }), n.d(t, "defaultProps", function () {
        return E;
      }), n.d(t, "renameProp", function () {
        return M;
      }), n.d(t, "renameProps", function () {
        return k;
      }), n.d(t, "flattenProp", function () {
        return P;
      }), n.d(t, "withState", function () {
        return O;
      }), n.d(t, "withStateHandlers", function () {
        return R;
      }), n.d(t, "withReducer", function () {
        return j;
      }), n.d(t, "branch", function () {
        return L;
      }), n.d(t, "renderComponent", function () {
        return D;
      }), n.d(t, "renderNothing", function () {
        return F;
      }), n.d(t, "shouldUpdate", function () {
        return z;
      }), n.d(t, "pure", function () {
        return U;
      }), n.d(t, "onlyUpdateForKeys", function () {
        return G;
      }), n.d(t, "onlyUpdateForPropTypes", function () {
        return V;
      }), n.d(t, "withContext", function () {
        return H;
      }), n.d(t, "getContext", function () {
        return q;
      }), n.d(t, "lifecycle", function () {
        return W;
      }), n.d(t, "toClass", function () {
        return X;
      }), n.d(t, "toRenderProps", function () {
        return Y;
      }), n.d(t, "fromRenderProps", function () {
        return K;
      }), n.d(t, "setStatic", function () {
        return m;
      }), n.d(t, "setPropTypes", function () {
        return Z;
      }), n.d(t, "setDisplayName", function () {
        return g;
      }), n.d(t, "compose", function () {
        return Q;
      }), n.d(t, "getDisplayName", function () {
        return v;
      }), n.d(t, "wrapDisplayName", function () {
        return y;
      }), n.d(t, "shallowEqual", function () {
        return s.a;
      }), n.d(t, "isClassComponent", function () {
        return $;
      }), n.d(t, "createSink", function () {
        return J;
      }), n.d(t, "componentFromProp", function () {
        return ee;
      }), n.d(t, "nest", function () {
        return te;
      }), n.d(t, "hoistStatics", function () {
        return ne;
      }), n.d(t, "componentFromStream", function () {
        return se;
      }), n.d(t, "componentFromStreamWithConfig", function () {
        return ae;
      }), n.d(t, "mapPropsStream", function () {
        return ce;
      }), n.d(t, "mapPropsStreamWithConfig", function () {
        return ue;
      }), n.d(t, "createEventHandler", function () {
        return he;
      }), n.d(t, "createEventHandlerWithConfig", function () {
        return de;
      }), n.d(t, "setObservableConfig", function () {
        return ie;
      });
      var r = n("react"),
        i = n.n(r),
        o = n("./node_modules/@babel/runtime/helpers/esm/extends.js"),
        a = n("./node_modules/fbjs/lib/shallowEqual.js"),
        s = n.n(a);
      function l(e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
      }
      var u = n("./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js"),
        c = n("./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js"),
        d = n("./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"),
        h = n.n(d),
        f = n("./node_modules/change-emitter/lib/index.js"),
        p = n("./node_modules/symbol-observable/es/index.js"),
        m = function m(e, t) {
          return function (n) {
            return n[e] = t, n;
          };
        },
        g = function g(e) {
          return m("displayName", e);
        },
        v = function v(e) {
          return "string" == typeof e ? e : e ? e.displayName || e.name || "Component" : void 0;
        },
        y = function y(e, t) {
          return t + "(" + v(e) + ")";
        },
        b = function b(e) {
          return function (t) {
            var n = Object(r.createFactory)(t);
            return function (t) {
              return n(e(t));
            };
          };
        },
        _ = function _(e) {
          return b(function (t) {
            return Object(o.a)({}, t, "function" == typeof e ? e(t) : e);
          });
        },
        x = function x(e, t) {
          for (var n = {}, r = 0; r < t.length; r++) {
            var i = t[r];
            e.hasOwnProperty(i) && (n[i] = e[i]);
          }
          return n;
        },
        w = function w(e, t) {
          return function (n) {
            var i = Object(r.createFactory)(n),
              a = "function" == typeof e ? e : function (t, n) {
                return !s()(x(t, e), x(n, e));
              },
              c = function (e) {
                function n() {
                  for (var n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                  return (n = e.call.apply(e, [this].concat(i)) || this).state = {
                    computedProps: t(n.props),
                    prevProps: n.props
                  }, n;
                }
                return l(n, e), n.getDerivedStateFromProps = function (e, n) {
                  return a(n.prevProps, e) ? {
                    computedProps: t(e),
                    prevProps: e
                  } : {
                    prevProps: e
                  };
                }, n.prototype.render = function () {
                  return i(Object(o.a)({}, this.props, this.state.computedProps));
                }, n;
              }(r.Component);
            return Object(u.a)(c), c;
          };
        },
        S = function S(e, t) {
          var n = {};
          for (var r in e) e.hasOwnProperty(r) && (n[r] = t(e[r], r));
          return n;
        },
        A = function A(e) {
          return function (t) {
            var n = Object(r.createFactory)(t);
            return function (t) {
              function r() {
                for (var n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                return (n = t.call.apply(t, [this].concat(i)) || this).handlers = S("function" == typeof e ? e(n.props) : e, function (e) {
                  return function () {
                    var t = e(n.props);
                    return t.apply(void 0, arguments);
                  };
                }), n;
              }
              return l(r, t), r.prototype.render = function () {
                return n(Object(o.a)({}, this.props, this.handlers));
              }, r;
            }(r.Component);
          };
        },
        E = function E(e) {
          return function (t) {
            var n = Object(r.createFactory)(t),
              i = function i(e) {
                return n(e);
              };
            return i.defaultProps = e, i;
          };
        },
        T = function T(e, t) {
          for (var n = Object(o.a)({}, e), r = 0; r < t.length; r++) {
            var i = t[r];
            n.hasOwnProperty(i) && delete n[i];
          }
          return n;
        },
        M = function M(e, t) {
          return b(function (n) {
            var r;
            return Object(o.a)({}, T(n, [e]), ((r = {})[t] = n[e], r));
          });
        },
        C = Object.keys,
        k = function k(e) {
          return b(function (t) {
            return Object(o.a)({}, T(t, C(e)), (n = x(t, C(e)), r = function r(t, n) {
              return e[n];
            }, C(n).reduce(function (e, t) {
              var i = n[t];
              return e[r(i, t)] = i, e;
            }, {})));
            var n, r;
          });
        },
        P = function P(e) {
          return function (t) {
            var n = Object(r.createFactory)(t);
            return function (t) {
              return n(Object(o.a)({}, t, t[e]));
            };
          };
        },
        O = function O(e, t, n) {
          return function (i) {
            var a = Object(r.createFactory)(i);
            return function (r) {
              function i() {
                for (var e, t = arguments.length, i = new Array(t), o = 0; o < t; o++) i[o] = arguments[o];
                return (e = r.call.apply(r, [this].concat(i)) || this).state = {
                  stateValue: "function" == typeof n ? n(e.props) : n
                }, e.updateStateValue = function (t, n) {
                  return e.setState(function (e) {
                    var n = e.stateValue;
                    return {
                      stateValue: "function" == typeof t ? t(n) : t
                    };
                  }, n);
                }, e;
              }
              return l(i, r), i.prototype.render = function () {
                var n;
                return a(Object(o.a)({}, this.props, ((n = {})[e] = this.state.stateValue, n[t] = this.updateStateValue, n)));
              }, i;
            }(r.Component);
          };
        },
        R = function R(e, t) {
          return function (n) {
            var i = Object(r.createFactory)(n);
            return function (n) {
              function r() {
                for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++) o[a] = arguments[a];
                return (r = n.call.apply(n, [this].concat(o)) || this).state = "function" == typeof e ? e(r.props) : e, r.stateUpdaters = S(t, function (e) {
                  return function (t) {
                    for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) i[o - 1] = arguments[o];
                    t && "function" == typeof t.persist && t.persist(), r.setState(function (n, r) {
                      return e(n, r).apply(void 0, [t].concat(i));
                    });
                  };
                }), r;
              }
              return l(r, n), r.prototype.render = function () {
                return i(Object(o.a)({}, this.props, this.state, this.stateUpdaters));
              }, r;
            }(r.Component);
          };
        },
        I = function I() {},
        j = function j(e, t, n, i) {
          return function (a) {
            var s = Object(r.createFactory)(a);
            return function (r) {
              function a() {
                for (var e, t = arguments.length, i = new Array(t), o = 0; o < t; o++) i[o] = arguments[o];
                return (e = r.call.apply(r, [this].concat(i)) || this).state = {
                  stateValue: e.initializeStateValue()
                }, e.dispatch = function (t, r) {
                  return void 0 === r && (r = I), e.setState(function (e) {
                    var r = e.stateValue;
                    return {
                      stateValue: n(r, t)
                    };
                  }, function () {
                    return r(e.state.stateValue);
                  });
                }, e;
              }
              l(a, r);
              var u = a.prototype;
              return u.initializeStateValue = function () {
                return void 0 !== i ? "function" == typeof i ? i(this.props) : i : n(void 0, {
                  type: "@@recompose/INIT"
                });
              }, u.render = function () {
                var n;
                return s(Object(o.a)({}, this.props, ((n = {})[e] = this.state.stateValue, n[t] = this.dispatch, n)));
              }, a;
            }(r.Component);
          };
        },
        N = function N(e) {
          return e;
        },
        L = function L(e, t, n) {
          return void 0 === n && (n = N), function (i) {
            var o, a;
            return function (s) {
              return e(s) ? (o = o || Object(r.createFactory)(t(i)))(s) : (a = a || Object(r.createFactory)(n(i)))(s);
            };
          };
        },
        D = function D(e) {
          return function (t) {
            var n = Object(r.createFactory)(e);
            return function (e) {
              return n(e);
            };
          };
        },
        B = function (e) {
          function t() {
            return e.apply(this, arguments) || this;
          }
          return l(t, e), t.prototype.render = function () {
            return null;
          }, t;
        }(r.Component),
        F = function F(e) {
          return B;
        },
        z = function z(e) {
          return function (t) {
            var n = Object(r.createFactory)(t);
            return function (t) {
              function r() {
                return t.apply(this, arguments) || this;
              }
              l(r, t);
              var i = r.prototype;
              return i.shouldComponentUpdate = function (t) {
                return e(this.props, t);
              }, i.render = function () {
                return n(this.props);
              }, r;
            }(r.Component);
          };
        },
        U = function U(e) {
          return z(function (e, t) {
            return !s()(e, t);
          })(e);
        },
        G = function G(e) {
          return z(function (t, n) {
            return !s()(x(n, e), x(t, e));
          });
        },
        V = function V(e) {
          var t = e.propTypes;
          var n = Object.keys(t || {});
          return G(n)(e);
        },
        H = function H(e, t) {
          return function (n) {
            var i = Object(r.createFactory)(n),
              o = function (e) {
                function n() {
                  for (var n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                  return (n = e.call.apply(e, [this].concat(i)) || this).getChildContext = function () {
                    return t(n.props);
                  }, n;
                }
                return l(n, e), n.prototype.render = function () {
                  return i(this.props);
                }, n;
              }(r.Component);
            return o.childContextTypes = e, o;
          };
        },
        q = function q(e) {
          return function (t) {
            var n = Object(r.createFactory)(t),
              i = function i(e, t) {
                return n(Object(o.a)({}, e, t));
              };
            return i.contextTypes = e, i;
          };
        },
        W = function W(e) {
          return function (t) {
            var n = Object(r.createFactory)(t);
            var i = function (e) {
              function t() {
                return e.apply(this, arguments) || this;
              }
              return l(t, e), t.prototype.render = function () {
                return n(Object(o.a)({}, this.props, this.state));
              }, t;
            }(r.Component);
            return Object.keys(e).forEach(function (t) {
              return i.prototype[t] = e[t];
            }), i;
          };
        },
        $ = function $(e) {
          return Boolean(e && e.prototype && "function" == typeof e.prototype.render);
        },
        X = function X(e) {
          var t, n;
          return $(e) ? e : (n = t = function (t) {
            function n() {
              return t.apply(this, arguments) || this;
            }
            return l(n, t), n.prototype.render = function () {
              return "string" == typeof e ? i.a.createElement(e, this.props) : e(this.props, this.context);
            }, n;
          }(r.Component), t.displayName = v(e), t.propTypes = e.propTypes, t.contextTypes = e.contextTypes, t.defaultProps = e.defaultProps, n);
        };
      function Y(e) {
        return e(function (e) {
          return e.children(e);
        });
      }
      var K = function K(e, t, n) {
          return void 0 === n && (n = "children"), function (r) {
            var a = i.a.createFactory(r),
              s = i.a.createFactory(e);
            return function (e) {
              var r;
              return s(((r = {})[n] = function () {
                return a(Object(o.a)({}, e, t.apply(void 0, arguments)));
              }, r));
            };
          };
        },
        Z = function Z(e) {
          return m("propTypes", e);
        },
        Q = function Q() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return t.reduce(function (e, t) {
            return function () {
              return e(t.apply(void 0, arguments));
            };
          }, function (e) {
            return e;
          });
        },
        J = function J(e) {
          var t = function (t) {
            function n() {
              for (var e, n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
              return (e = t.call.apply(t, [this].concat(r)) || this).state = {}, e;
            }
            return l(n, t), n.getDerivedStateFromProps = function (t) {
              return e(t), null;
            }, n.prototype.render = function () {
              return null;
            }, n;
          }(r.Component);
          return Object(u.a)(t), t;
        },
        ee = function ee(e) {
          var t = function t(_t4) {
            return Object(r.createElement)(_t4[e], T(_t4, [e]));
          };
          return t.displayName = "componentFromProp(" + e + ")", t;
        },
        te = function te() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          var i = t.map(r.createFactory),
            o = function o(e) {
              var t = e.children,
                n = Object(c.a)(e, ["children"]);
              return i.reduceRight(function (e, t) {
                return t(n, e);
              }, t);
            };
          return o;
        },
        ne = function ne(e, t) {
          return function (n) {
            var r = e(n);
            return h()(r, n, t), r;
          };
        },
        re = {
          fromESObservable: null,
          toESObservable: null
        },
        ie = function ie(e) {
          re = e;
        },
        oe = {
          fromESObservable: function fromESObservable(e) {
            return "function" == typeof re.fromESObservable ? re.fromESObservable(e) : e;
          },
          toESObservable: function toESObservable(e) {
            return "function" == typeof re.toESObservable ? re.toESObservable(e) : e;
          }
        },
        ae = function ae(e) {
          return function (t) {
            return function (n) {
              function r() {
                for (var r, i, o = arguments.length, a = new Array(o), s = 0; s < o; s++) a[s] = arguments[s];
                return (i = n.call.apply(n, [this].concat(a)) || this).state = {
                  vdom: null
                }, i.propsEmitter = Object(f.createChangeEmitter)(), i.props$ = e.fromESObservable(((r = {
                  subscribe: function subscribe(e) {
                    return {
                      unsubscribe: i.propsEmitter.listen(function (t) {
                        t ? e.next(t) : e.complete();
                      })
                    };
                  }
                })[p.a] = function () {
                  return this;
                }, r)), i.vdom$ = e.toESObservable(t(i.props$)), i;
              }
              l(r, n);
              var i = r.prototype;
              return i.componentWillMount = function () {
                var e = this;
                this.subscription = this.vdom$.subscribe({
                  next: function next(t) {
                    e.setState({
                      vdom: t
                    });
                  }
                }), this.propsEmitter.emit(this.props);
              }, i.componentWillReceiveProps = function (e) {
                this.propsEmitter.emit(e);
              }, i.shouldComponentUpdate = function (e, t) {
                return t.vdom !== this.state.vdom;
              }, i.componentWillUnmount = function () {
                this.propsEmitter.emit(), this.subscription.unsubscribe();
              }, i.render = function () {
                return this.state.vdom;
              }, r;
            }(r.Component);
          };
        },
        se = function se(e) {
          return ae(oe)(e);
        },
        le = function le(e) {
          return e;
        },
        ue = function ue(e) {
          var t = ae({
            fromESObservable: le,
            toESObservable: le
          });
          return function (n) {
            return function (i) {
              var o = Object(r.createFactory)(i),
                a = e.fromESObservable,
                s = e.toESObservable;
              return t(function (e) {
                var t;
                return (t = {
                  subscribe: function subscribe(t) {
                    var r = s(n(a(e))).subscribe({
                      next: function next(e) {
                        return t.next(o(e));
                      }
                    });
                    return {
                      unsubscribe: function unsubscribe() {
                        return r.unsubscribe();
                      }
                    };
                  }
                })[p.a] = function () {
                  return this;
                }, t;
              });
            };
          };
        },
        ce = function ce(e) {
          return ue(oe)(e);
        },
        de = function de(e) {
          return function () {
            var t,
              n = Object(f.createChangeEmitter)(),
              r = e.fromESObservable(((t = {
                subscribe: function subscribe(e) {
                  return {
                    unsubscribe: n.listen(function (t) {
                      return e.next(t);
                    })
                  };
                }
              })[p.a] = function () {
                return this;
              }, t));
            return {
              handler: n.emit,
              stream: r
            };
          };
        },
        he = de(oe);
    },
    "./node_modules/anatomogram/node_modules/styled-components/dist/styled-components.browser.esm.js": function node_modulesAnatomogramNode_modulesStyledComponentsDistStyledComponentsBrowserEsmJs(e, t, n) {
      "use strict";

      n.r(t), function (e) {
        n.d(t, "createGlobalStyle", function () {
          return nt;
        }), n.d(t, "css", function () {
          return be;
        }), n.d(t, "isStyledComponent", function () {
          return T;
        }), n.d(t, "keyframes", function () {
          return it;
        }), n.d(t, "ServerStyleSheet", function () {
          return $e;
        }), n.d(t, "StyleSheetConsumer", function () {
          return Ye;
        }), n.d(t, "StyleSheetContext", function () {
          return Xe;
        }), n.d(t, "StyleSheetManager", function () {
          return Ke;
        }), n.d(t, "ThemeConsumer", function () {
          return qe;
        }), n.d(t, "ThemeContext", function () {
          return He;
        }), n.d(t, "ThemeProvider", function () {
          return We;
        }), n.d(t, "withTheme", function () {
          return ot;
        }), n.d(t, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function () {
          return at;
        });
        var r = n("./node_modules/stylis/stylis.min.js"),
          i = n.n(r),
          o = n("./node_modules/stylis-rule-sheet/index.js"),
          a = n.n(o),
          s = n("react"),
          l = n.n(s),
          u = n("./node_modules/@emotion/unitless/dist/unitless.browser.esm.js"),
          c = n("./node_modules/react-is/index.js"),
          d = n("./node_modules/memoize-one/dist/memoize-one.esm.js"),
          h = (n("./node_modules/prop-types/index.js"), n("./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js")),
          f = n("./node_modules/merge-anything/dist/index.esm.js"),
          p = function p(e, t) {
            for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1]);
            return n;
          },
          m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          },
          g = function g(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          },
          v = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }
            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          }(),
          y = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          },
          b = function b(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          },
          _ = function _(e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          },
          x = function x(e) {
            return "object" === (void 0 === e ? "undefined" : m(e)) && e.constructor === Object;
          },
          w = Object.freeze([]),
          S = Object.freeze({});
        function A(e) {
          return "function" == typeof e;
        }
        function E(e) {
          return e.displayName || e.name || "Component";
        }
        function T(e) {
          return e && "string" == typeof e.styledComponentId;
        }
        var M = void 0 !== e && (e.env.REACT_APP_SC_ATTR || e.env.SC_ATTR) || "data-styled",
          C = "undefined" != typeof window && "HTMLElement" in window,
          k = "boolean" == typeof SC_DISABLE_SPEEDY && SC_DISABLE_SPEEDY || void 0 !== e && (e.env.REACT_APP_SC_DISABLE_SPEEDY || e.env.SC_DISABLE_SPEEDY) || !1,
          P = {};
        var O = function (e) {
            function t(n) {
              g(this, t);
              for (var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];
              var a = _(this, e.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + n + " for more information." + (i.length > 0 ? " Additional arguments: " + i.join(", ") : "")));
              return _(a);
            }
            return b(t, e), t;
          }(Error),
          R = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm,
          I = function I(e) {
            var t = "" + (e || ""),
              n = [];
            return t.replace(R, function (e, t, r) {
              return n.push({
                componentId: t,
                matchIndex: r
              }), e;
            }), n.map(function (e, r) {
              var i = e.componentId,
                o = e.matchIndex,
                a = n[r + 1];
              return {
                componentId: i,
                cssFromDOM: a ? t.slice(o, a.matchIndex) : t.slice(o)
              };
            });
          },
          j = /^\s*\/\/.*$/gm,
          N = new i.a({
            global: !1,
            cascade: !0,
            keyframe: !1,
            prefix: !1,
            compress: !1,
            semicolon: !0
          }),
          L = new i.a({
            global: !1,
            cascade: !0,
            keyframe: !1,
            prefix: !0,
            compress: !1,
            semicolon: !1
          }),
          D = [],
          B = function B(e) {
            if (-2 === e) {
              var t = D;
              return D = [], t;
            }
          },
          F = a()(function (e) {
            D.push(e);
          }),
          z = void 0,
          U = void 0,
          G = void 0,
          V = function V(e, t, n) {
            return t > 0 && -1 !== n.slice(0, t).indexOf(U) && n.slice(t - U.length, t) !== U ? "." + z : e;
          };
        L.use([function (e, t, n) {
          2 === e && n.length && n[0].lastIndexOf(U) > 0 && (n[0] = n[0].replace(G, V));
        }, F, B]), N.use([F, B]);
        var H = function H(e) {
          return N("", e);
        };
        function q(e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "&",
            i = e.join("").replace(j, ""),
            o = t && n ? n + " " + t + " { " + i + " }" : i;
          return z = r, U = t, G = new RegExp("\\" + U + "\\b", "g"), L(n || !t ? "" : t, o);
        }
        var W = function W() {
            return n.nc;
          },
          $ = function $(e, t, n) {
            n && ((e[t] || (e[t] = Object.create(null)))[n] = !0);
          },
          X = function X(e, t) {
            e[t] = Object.create(null);
          },
          Y = function Y(e) {
            return function (t, n) {
              return void 0 !== e[t] && e[t][n];
            };
          },
          K = function K(e) {
            var t = "";
            for (var n in e) t += Object.keys(e[n]).join(" ") + " ";
            return t.trim();
          },
          Z = function Z(e) {
            if (e.sheet) return e.sheet;
            for (var t = document.styleSheets.length, n = 0; n < t; n += 1) {
              var r = document.styleSheets[n];
              if (r.ownerNode === e) return r;
            }
            throw new O(10);
          },
          Q = function Q(e, t, n) {
            if (!t) return !1;
            var r = e.cssRules.length;
            try {
              e.insertRule(t, n <= r ? n : r);
            } catch (e) {
              return !1;
            }
            return !0;
          },
          J = function J(e) {
            return "\n/* sc-component-id: " + e + " */\n";
          },
          ee = function ee(e, t) {
            for (var n = 0, r = 0; r <= t; r += 1) n += e[r];
            return n;
          },
          te = function te(e, t) {
            return function (n) {
              var r = W();
              return "<style " + [r && 'nonce="' + r + '"', M + '="' + K(t) + '"', 'data-styled-version="4.3.2"', n].filter(Boolean).join(" ") + ">" + e() + "</style>";
            };
          },
          ne = function ne(e, t) {
            return function () {
              var n,
                r = ((n = {})[M] = K(t), n["data-styled-version"] = "4.3.2", n),
                i = W();
              return i && (r.nonce = i), l.a.createElement("style", y({}, r, {
                dangerouslySetInnerHTML: {
                  __html: e()
                }
              }));
            };
          },
          re = function re(e) {
            return function () {
              return Object.keys(e);
            };
          },
          ie = function ie(e) {
            return document.createTextNode(J(e));
          },
          oe = function e(t, n) {
            var r = void 0 === t ? Object.create(null) : t,
              i = void 0 === n ? Object.create(null) : n,
              o = function o(e) {
                var t = i[e];
                return void 0 !== t ? t : i[e] = [""];
              },
              a = function a() {
                var e = "";
                for (var t in i) {
                  var n = i[t][0];
                  n && (e += J(t) + n);
                }
                return e;
              };
            return {
              clone: function clone() {
                var t = function (e) {
                    var t = Object.create(null);
                    for (var n in e) t[n] = y({}, e[n]);
                    return t;
                  }(r),
                  n = Object.create(null);
                for (var o in i) n[o] = [i[o][0]];
                return e(t, n);
              },
              css: a,
              getIds: re(i),
              hasNameForId: Y(r),
              insertMarker: o,
              insertRules: function insertRules(e, t, n) {
                o(e)[0] += t.join(" "), $(r, e, n);
              },
              removeRules: function removeRules(e) {
                var t = i[e];
                void 0 !== t && (t[0] = "", X(r, e));
              },
              sealed: !1,
              styleTag: null,
              toElement: ne(a, r),
              toHTML: te(a, r)
            };
          },
          ae = function ae(e, t, n, r, i) {
            if (C && !n) {
              var o = function (e, t, n) {
                var r = document.createElement("style");
                r.setAttribute(M, ""), r.setAttribute("data-styled-version", "4.3.2");
                var i = W();
                if (i && r.setAttribute("nonce", i), r.appendChild(document.createTextNode("")), e && !t) e.appendChild(r);else {
                  if (!t || !e || !t.parentNode) throw new O(6);
                  t.parentNode.insertBefore(r, n ? t : t.nextSibling);
                }
                return r;
              }(e, t, r);
              return k ? function (e, t) {
                var n = Object.create(null),
                  r = Object.create(null),
                  i = void 0 !== t,
                  o = !1,
                  a = function a(t) {
                    var i = r[t];
                    return void 0 !== i ? i : (r[t] = ie(t), e.appendChild(r[t]), n[t] = Object.create(null), r[t]);
                  },
                  s = function s() {
                    var e = "";
                    for (var t in r) e += r[t].data;
                    return e;
                  };
                return {
                  clone: function clone() {
                    throw new O(5);
                  },
                  css: s,
                  getIds: re(r),
                  hasNameForId: Y(n),
                  insertMarker: a,
                  insertRules: function insertRules(e, r, s) {
                    for (var l = a(e), u = [], c = r.length, d = 0; d < c; d += 1) {
                      var h = r[d],
                        f = i;
                      if (f && -1 !== h.indexOf("@import")) u.push(h);else {
                        f = !1;
                        var p = d === c - 1 ? "" : " ";
                        l.appendData("" + h + p);
                      }
                    }
                    $(n, e, s), i && u.length > 0 && (o = !0, t().insertRules(e + "-import", u));
                  },
                  removeRules: function removeRules(a) {
                    var s = r[a];
                    if (void 0 !== s) {
                      var l = ie(a);
                      e.replaceChild(l, s), r[a] = l, X(n, a), i && o && t().removeRules(a + "-import");
                    }
                  },
                  sealed: !1,
                  styleTag: e,
                  toElement: ne(s, n),
                  toHTML: te(s, n)
                };
              }(o, i) : function (e, t) {
                var n = Object.create(null),
                  r = Object.create(null),
                  i = [],
                  o = void 0 !== t,
                  a = !1,
                  s = function s(e) {
                    var t = r[e];
                    return void 0 !== t ? t : (r[e] = i.length, i.push(0), X(n, e), r[e]);
                  },
                  l = function l() {
                    var t = Z(e).cssRules,
                      n = "";
                    for (var o in r) {
                      n += J(o);
                      for (var a = r[o], s = ee(i, a), l = s - i[a]; l < s; l += 1) {
                        var u = t[l];
                        void 0 !== u && (n += u.cssText);
                      }
                    }
                    return n;
                  };
                return {
                  clone: function clone() {
                    throw new O(5);
                  },
                  css: l,
                  getIds: re(r),
                  hasNameForId: Y(n),
                  insertMarker: s,
                  insertRules: function insertRules(r, l, u) {
                    for (var c = s(r), d = Z(e), h = ee(i, c), f = 0, p = [], m = l.length, g = 0; g < m; g += 1) {
                      var v = l[g],
                        y = o;
                      y && -1 !== v.indexOf("@import") ? p.push(v) : Q(d, v, h + f) && (y = !1, f += 1);
                    }
                    o && p.length > 0 && (a = !0, t().insertRules(r + "-import", p)), i[c] += f, $(n, r, u);
                  },
                  removeRules: function removeRules(s) {
                    var l = r[s];
                    if (void 0 !== l) {
                      var u = i[l];
                      !function (e, t, n) {
                        for (var r = t - n, i = t; i > r; i -= 1) e.deleteRule(i);
                      }(Z(e), ee(i, l) - 1, u), i[l] = 0, X(n, s), o && a && t().removeRules(s + "-import");
                    }
                  },
                  sealed: !1,
                  styleTag: e,
                  toElement: ne(l, n),
                  toHTML: te(l, n)
                };
              }(o, i);
            }
            return oe();
          },
          se = /\s+/,
          le = void 0;
        le = C ? k ? 40 : 1e3 : -1;
        var ue = 0,
          ce = void 0,
          de = function () {
            function e() {
              var t = this,
                n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : C ? document.head : null,
                r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              g(this, e), this.getImportRuleTag = function () {
                var e = t.importRuleTag;
                if (void 0 !== e) return e;
                var n = t.tags[0];
                return t.importRuleTag = ae(t.target, n ? n.styleTag : null, t.forceServer, !0);
              }, ue += 1, this.id = ue, this.forceServer = r, this.target = r ? null : n, this.tagMap = {}, this.deferred = {}, this.rehydratedNames = {}, this.ignoreRehydratedNames = {}, this.tags = [], this.capacity = 1, this.clones = [];
            }
            return e.prototype.rehydrate = function () {
              if (!C || this.forceServer) return this;
              var e = [],
                t = [],
                n = !1,
                r = document.querySelectorAll("style[" + M + '][data-styled-version="4.3.2"]'),
                i = r.length;
              if (!i) return this;
              for (var o = 0; o < i; o += 1) {
                var a = r[o];
                n || (n = !!a.getAttribute("data-styled-streamed"));
                for (var s, l = (a.getAttribute(M) || "").trim().split(se), u = l.length, c = 0; c < u; c += 1) s = l[c], this.rehydratedNames[s] = !0;
                t.push.apply(t, I(a.textContent)), e.push(a);
              }
              var d = t.length;
              if (!d) return this;
              var h = this.makeTag(null);
              !function (e, t, n) {
                for (var r = 0, i = n.length; r < i; r += 1) {
                  var o = n[r],
                    a = o.componentId,
                    s = o.cssFromDOM,
                    l = H(s);
                  e.insertRules(a, l);
                }
                for (var u = 0, c = t.length; u < c; u += 1) {
                  var d = t[u];
                  d.parentNode && d.parentNode.removeChild(d);
                }
              }(h, e, t), this.capacity = Math.max(1, le - d), this.tags.push(h);
              for (var f = 0; f < d; f += 1) this.tagMap[t[f].componentId] = h;
              return this;
            }, e.reset = function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              ce = new e(void 0, t).rehydrate();
            }, e.prototype.clone = function () {
              var t = new e(this.target, this.forceServer);
              return this.clones.push(t), t.tags = this.tags.map(function (e) {
                for (var n = e.getIds(), r = e.clone(), i = 0; i < n.length; i += 1) t.tagMap[n[i]] = r;
                return r;
              }), t.rehydratedNames = y({}, this.rehydratedNames), t.deferred = y({}, this.deferred), t;
            }, e.prototype.sealAllTags = function () {
              this.capacity = 1, this.tags.forEach(function (e) {
                e.sealed = !0;
              });
            }, e.prototype.makeTag = function (e) {
              var t = e ? e.styleTag : null;
              return ae(this.target, t, this.forceServer, !1, this.getImportRuleTag);
            }, e.prototype.getTagForId = function (e) {
              var t = this.tagMap[e];
              if (void 0 !== t && !t.sealed) return t;
              var n = this.tags[this.tags.length - 1];
              return this.capacity -= 1, 0 === this.capacity && (this.capacity = le, n = this.makeTag(n), this.tags.push(n)), this.tagMap[e] = n;
            }, e.prototype.hasId = function (e) {
              return void 0 !== this.tagMap[e];
            }, e.prototype.hasNameForId = function (e, t) {
              if (void 0 === this.ignoreRehydratedNames[e] && this.rehydratedNames[t]) return !0;
              var n = this.tagMap[e];
              return void 0 !== n && n.hasNameForId(e, t);
            }, e.prototype.deferredInject = function (e, t) {
              if (void 0 === this.tagMap[e]) {
                for (var n = this.clones, r = 0; r < n.length; r += 1) n[r].deferredInject(e, t);
                this.getTagForId(e).insertMarker(e), this.deferred[e] = t;
              }
            }, e.prototype.inject = function (e, t, n) {
              for (var r = this.clones, i = 0; i < r.length; i += 1) r[i].inject(e, t, n);
              var o = this.getTagForId(e);
              if (void 0 !== this.deferred[e]) {
                var a = this.deferred[e].concat(t);
                o.insertRules(e, a, n), this.deferred[e] = void 0;
              } else o.insertRules(e, t, n);
            }, e.prototype.remove = function (e) {
              var t = this.tagMap[e];
              if (void 0 !== t) {
                for (var n = this.clones, r = 0; r < n.length; r += 1) n[r].remove(e);
                t.removeRules(e), this.ignoreRehydratedNames[e] = !0, this.deferred[e] = void 0;
              }
            }, e.prototype.toHTML = function () {
              return this.tags.map(function (e) {
                return e.toHTML();
              }).join("");
            }, e.prototype.toReactElements = function () {
              var e = this.id;
              return this.tags.map(function (t, n) {
                var r = "sc-" + e + "-" + n;
                return Object(s.cloneElement)(t.toElement(), {
                  key: r
                });
              });
            }, v(e, null, [{
              key: "master",
              get: function get() {
                return ce || (ce = new e().rehydrate());
              }
            }, {
              key: "instance",
              get: function get() {
                return e.master;
              }
            }]), e;
          }(),
          he = function () {
            function e(t, n) {
              var r = this;
              g(this, e), this.inject = function (e) {
                e.hasNameForId(r.id, r.name) || e.inject(r.id, r.rules, r.name);
              }, this.toString = function () {
                throw new O(12, String(r.name));
              }, this.name = t, this.rules = n, this.id = "sc-keyframes-" + t;
            }
            return e.prototype.getName = function () {
              return this.name;
            }, e;
          }(),
          fe = /([A-Z])/g,
          pe = /^ms-/;
        function me(e) {
          return e.replace(fe, "-$1").toLowerCase().replace(pe, "-ms-");
        }
        var ge = function ge(e) {
            return null == e || !1 === e || "" === e;
          },
          ve = function e(t, n) {
            var r = [];
            return Object.keys(t).forEach(function (n) {
              if (!ge(t[n])) {
                if (x(t[n])) return r.push.apply(r, e(t[n], n)), r;
                if (A(t[n])) return r.push(me(n) + ":", t[n], ";"), r;
                r.push(me(n) + ": " + function (e, t) {
                  return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in u.a ? String(t).trim() : t + "px";
                }(n, t[n]) + ";");
              }
              return r;
            }), n ? [n + " {"].concat(r, ["}"]) : r;
          };
        function ye(e, t, n) {
          if (Array.isArray(e)) {
            for (var r, i = [], o = 0, a = e.length; o < a; o += 1) null !== (r = ye(e[o], t, n)) && (Array.isArray(r) ? i.push.apply(i, r) : i.push(r));
            return i;
          }
          return ge(e) ? null : T(e) ? "." + e.styledComponentId : A(e) ? "function" != typeof (s = e) || s.prototype && s.prototype.isReactComponent || !t ? e : ye(e(t), t, n) : e instanceof he ? n ? (e.inject(n), e.getName()) : e : x(e) ? ve(e) : e.toString();
          var s;
        }
        function be(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          return A(e) || x(e) ? ye(p(w, [e].concat(n))) : ye(p(e, n));
        }
        function _e(e) {
          for (var t, n = 0 | e.length, r = 0 | n, i = 0; n >= 4;) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(i) | (255 & e.charCodeAt(++i)) << 8 | (255 & e.charCodeAt(++i)) << 16 | (255 & e.charCodeAt(++i)) << 24)) + ((1540483477 * (t >>> 16) & 65535) << 16), r = 1540483477 * (65535 & r) + ((1540483477 * (r >>> 16) & 65535) << 16) ^ (t = 1540483477 * (65535 & (t ^= t >>> 24)) + ((1540483477 * (t >>> 16) & 65535) << 16)), n -= 4, ++i;
          switch (n) {
            case 3:
              r ^= (255 & e.charCodeAt(i + 2)) << 16;
            case 2:
              r ^= (255 & e.charCodeAt(i + 1)) << 8;
            case 1:
              r = 1540483477 * (65535 & (r ^= 255 & e.charCodeAt(i))) + ((1540483477 * (r >>> 16) & 65535) << 16);
          }
          return ((r = 1540483477 * (65535 & (r ^= r >>> 13)) + ((1540483477 * (r >>> 16) & 65535) << 16)) ^ r >>> 15) >>> 0;
        }
        var xe = function xe(e) {
          return String.fromCharCode(e + (e > 25 ? 39 : 97));
        };
        function we(e) {
          var t = "",
            n = void 0;
          for (n = e; n > 52; n = Math.floor(n / 52)) t = xe(n % 52) + t;
          return xe(n % 52) + t;
        }
        function Se(e, t) {
          for (var n = 0; n < e.length; n += 1) {
            var r = e[n];
            if (Array.isArray(r) && !Se(r, t)) return !1;
            if (A(r) && !T(r)) return !1;
          }
          return !t.some(function (e) {
            return A(e) || function (e) {
              for (var t in e) if (A(e[t])) return !0;
              return !1;
            }(e);
          });
        }
        var Ae,
          Ee = function Ee(e) {
            return we(_e(e));
          },
          Te = function () {
            function e(t, n, r) {
              g(this, e), this.rules = t, this.isStatic = Se(t, n), this.componentId = r, de.master.hasId(r) || de.master.deferredInject(r, []);
            }
            return e.prototype.generateAndInjectStyles = function (e, t) {
              var n = this.isStatic,
                r = this.componentId,
                i = this.lastClassName;
              if (C && n && "string" == typeof i && t.hasNameForId(r, i)) return i;
              var o = ye(this.rules, e, t),
                a = Ee(this.componentId + o.join(""));
              return t.hasNameForId(r, a) || t.inject(this.componentId, q(o, "." + a, void 0, r), a), this.lastClassName = a, a;
            }, e.generateName = function (e) {
              return Ee(e);
            }, e;
          }(),
          Me = function Me(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : S,
              r = !!n && e.theme === n.theme,
              i = e.theme && !r ? e.theme : t || n.theme;
            return i;
          },
          Ce = /[[\].#*$><+~=|^:(),"'`-]+/g,
          ke = /(^-|-$)/g;
        function Pe(e) {
          return e.replace(Ce, "-").replace(ke, "");
        }
        function Oe(e) {
          return "string" == typeof e && !0;
        }
        var Re = {
            childContextTypes: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDerivedStateFromProps: !0,
            propTypes: !0,
            type: !0
          },
          Ie = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0
          },
          je = ((Ae = {})[c.ForwardRef] = {
            $$typeof: !0,
            render: !0
          }, Ae),
          Ne = Object.defineProperty,
          Le = Object.getOwnPropertyNames,
          De = Object.getOwnPropertySymbols,
          Be = void 0 === De ? function () {
            return [];
          } : De,
          Fe = Object.getOwnPropertyDescriptor,
          ze = Object.getPrototypeOf,
          Ue = Object.prototype,
          Ge = Array.prototype;
        function Ve(e, t, n) {
          if ("string" != typeof t) {
            var r = ze(t);
            r && r !== Ue && Ve(e, r, n);
            for (var i = Ge.concat(Le(t), Be(t)), o = je[e.$$typeof] || Re, a = je[t.$$typeof] || Re, s = i.length, l = void 0, u = void 0; s--;) if (u = i[s], !(Ie[u] || n && n[u] || a && a[u] || o && o[u]) && (l = Fe(t, u))) try {
              Ne(e, u, l);
            } catch (e) {}
            return e;
          }
          return e;
        }
        var He = Object(s.createContext)(),
          qe = He.Consumer,
          We = function (e) {
            function t(n) {
              g(this, t);
              var r = _(this, e.call(this, n));
              return r.getContext = Object(d.a)(r.getContext.bind(r)), r.renderInner = r.renderInner.bind(r), r;
            }
            return b(t, e), t.prototype.render = function () {
              return this.props.children ? l.a.createElement(He.Consumer, null, this.renderInner) : null;
            }, t.prototype.renderInner = function (e) {
              var t = this.getContext(this.props.theme, e);
              return l.a.createElement(He.Provider, {
                value: t
              }, l.a.Children.only(this.props.children));
            }, t.prototype.getTheme = function (e, t) {
              if (A(e)) return e(t);
              if (null === e || Array.isArray(e) || "object" !== (void 0 === e ? "undefined" : m(e))) throw new O(8);
              return y({}, t, e);
            }, t.prototype.getContext = function (e, t) {
              return this.getTheme(e, t);
            }, t;
          }(s.Component),
          $e = function () {
            function e() {
              g(this, e), this.masterSheet = de.master, this.instance = this.masterSheet.clone(), this.sealed = !1;
            }
            return e.prototype.seal = function () {
              if (!this.sealed) {
                var e = this.masterSheet.clones.indexOf(this.instance);
                this.masterSheet.clones.splice(e, 1), this.sealed = !0;
              }
            }, e.prototype.collectStyles = function (e) {
              if (this.sealed) throw new O(2);
              return l.a.createElement(Ke, {
                sheet: this.instance
              }, e);
            }, e.prototype.getStyleTags = function () {
              return this.seal(), this.instance.toHTML();
            }, e.prototype.getStyleElement = function () {
              return this.seal(), this.instance.toReactElements();
            }, e.prototype.interleaveWithNodeStream = function (e) {
              throw new O(3);
            }, e;
          }(),
          Xe = Object(s.createContext)(),
          Ye = Xe.Consumer,
          Ke = function (e) {
            function t(n) {
              g(this, t);
              var r = _(this, e.call(this, n));
              return r.getContext = Object(d.a)(r.getContext), r;
            }
            return b(t, e), t.prototype.getContext = function (e, t) {
              if (e) return e;
              if (t) return new de(t);
              throw new O(4);
            }, t.prototype.render = function () {
              var e = this.props,
                t = e.children,
                n = e.sheet,
                r = e.target;
              return l.a.createElement(Xe.Provider, {
                value: this.getContext(n, r)
              }, t);
            }, t;
          }(s.Component),
          Ze = {};
        var Qe = function (e) {
          function t() {
            g(this, t);
            var n = _(this, e.call(this));
            return n.attrs = {}, n.renderOuter = n.renderOuter.bind(n), n.renderInner = n.renderInner.bind(n), n;
          }
          return b(t, e), t.prototype.render = function () {
            return l.a.createElement(Ye, null, this.renderOuter);
          }, t.prototype.renderOuter = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : de.master;
            return this.styleSheet = e, this.props.forwardedComponent.componentStyle.isStatic ? this.renderInner() : l.a.createElement(qe, null, this.renderInner);
          }, t.prototype.renderInner = function (e) {
            var t = this.props.forwardedComponent,
              n = t.componentStyle,
              r = t.defaultProps,
              i = (t.displayName, t.foldedComponentIds),
              o = t.styledComponentId,
              a = t.target,
              l = void 0;
            l = n.isStatic ? this.generateAndInjectStyles(S, this.props) : this.generateAndInjectStyles(Me(this.props, e, r) || S, this.props);
            var u = this.props.as || this.attrs.as || a,
              c = Oe(u),
              d = {},
              f = y({}, this.attrs, this.props),
              p = void 0;
            for (p in f) "forwardedComponent" !== p && "as" !== p && ("forwardedRef" === p ? d.ref = f[p] : "forwardedAs" === p ? d.as = f[p] : c && !Object(h.a)(p) || (d[p] = f[p]));
            return this.props.style && this.attrs.style && (d.style = y({}, this.attrs.style, this.props.style)), d.className = Array.prototype.concat(i, this.props.className, o, this.attrs.className, l).filter(Boolean).join(" "), Object(s.createElement)(u, d);
          }, t.prototype.buildExecutionContext = function (e, t, n) {
            var r = this,
              i = y({}, t, {
                theme: e
              });
            return n.length ? (this.attrs = {}, n.forEach(function (e) {
              var t,
                n = e,
                o = !1,
                a = void 0,
                s = void 0;
              for (s in A(n) && (n = n(i), o = !0), n) a = n[s], o || !A(a) || (t = a) && t.prototype && t.prototype.isReactComponent || T(a) || (a = a(i)), r.attrs[s] = a, i[s] = a;
            }), i) : i;
          }, t.prototype.generateAndInjectStyles = function (e, t) {
            var n = t.forwardedComponent,
              r = n.attrs,
              i = n.componentStyle;
            n.warnTooManyClasses;
            return i.isStatic && !r.length ? i.generateAndInjectStyles(S, this.styleSheet) : i.generateAndInjectStyles(this.buildExecutionContext(e, t, r), this.styleSheet);
          }, t;
        }(s.Component);
        function Je(e, t, n) {
          var r = T(e),
            i = !Oe(e),
            o = t.displayName,
            a = void 0 === o ? function (e) {
              return Oe(e) ? "styled." + e : "Styled(" + E(e) + ")";
            }(e) : o,
            s = t.componentId,
            u = void 0 === s ? function (e, t, n) {
              var r = "string" != typeof t ? "sc" : Pe(t),
                i = (Ze[r] || 0) + 1;
              Ze[r] = i;
              var o = r + "-" + e.generateName(r + i);
              return n ? n + "-" + o : o;
            }(Te, t.displayName, t.parentComponentId) : s,
            c = t.ParentComponent,
            d = void 0 === c ? Qe : c,
            h = t.attrs,
            p = void 0 === h ? w : h,
            m = t.displayName && t.componentId ? Pe(t.displayName) + "-" + t.componentId : t.componentId || u,
            g = r && e.attrs ? Array.prototype.concat(e.attrs, p).filter(Boolean) : p,
            v = new Te(r ? e.componentStyle.rules.concat(n) : n, g, m),
            b = void 0,
            _ = function _(e, t) {
              return l.a.createElement(d, y({}, e, {
                forwardedComponent: b,
                forwardedRef: t
              }));
            };
          return _.displayName = a, (b = l.a.forwardRef(_)).displayName = a, b.attrs = g, b.componentStyle = v, b.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : w, b.styledComponentId = m, b.target = r ? e.target : e, b.withComponent = function (e) {
            var r = t.componentId,
              i = function (e, t) {
                var n = {};
                for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
                return n;
              }(t, ["componentId"]),
              o = r && r + "-" + (Oe(e) ? e : Pe(E(e)));
            return Je(e, y({}, i, {
              attrs: g,
              componentId: o,
              ParentComponent: d
            }), n);
          }, Object.defineProperty(b, "defaultProps", {
            get: function get() {
              return this._foldedDefaultProps;
            },
            set: function set(t) {
              this._foldedDefaultProps = r ? Object(f.a)(e.defaultProps, t) : t;
            }
          }), b.toString = function () {
            return "." + b.styledComponentId;
          }, i && Ve(b, e, {
            attrs: !0,
            componentStyle: !0,
            displayName: !0,
            foldedComponentIds: !0,
            styledComponentId: !0,
            target: !0,
            withComponent: !0
          }), b;
        }
        var et = function et(e) {
          return function e(t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : S;
            if (!Object(c.isValidElementType)(n)) throw new O(1, String(n));
            var i = function i() {
              return t(n, r, be.apply(void 0, arguments));
            };
            return i.withConfig = function (i) {
              return e(t, n, y({}, r, i));
            }, i.attrs = function (i) {
              return e(t, n, y({}, r, {
                attrs: Array.prototype.concat(r.attrs, i).filter(Boolean)
              }));
            }, i;
          }(Je, e);
        };
        ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (e) {
          et[e] = et(e);
        });
        var tt = function () {
          function e(t, n) {
            g(this, e), this.rules = t, this.componentId = n, this.isStatic = Se(t, w), de.master.hasId(n) || de.master.deferredInject(n, []);
          }
          return e.prototype.createStyles = function (e, t) {
            var n = q(ye(this.rules, e, t), "");
            t.inject(this.componentId, n);
          }, e.prototype.removeStyles = function (e) {
            var t = this.componentId;
            e.hasId(t) && e.remove(t);
          }, e.prototype.renderStyles = function (e, t) {
            this.removeStyles(t), this.createStyles(e, t);
          }, e;
        }();
        function nt(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          var i = be.apply(void 0, [e].concat(n)),
            o = "sc-global-" + _e(JSON.stringify(i)),
            a = new tt(i, o),
            s = function (e) {
              function t(n) {
                g(this, t);
                var r = _(this, e.call(this, n)),
                  i = r.constructor,
                  o = i.globalStyle,
                  a = i.styledComponentId;
                return C && (window.scCGSHMRCache[a] = (window.scCGSHMRCache[a] || 0) + 1), r.state = {
                  globalStyle: o,
                  styledComponentId: a
                }, r;
              }
              return b(t, e), t.prototype.componentWillUnmount = function () {
                window.scCGSHMRCache[this.state.styledComponentId] && (window.scCGSHMRCache[this.state.styledComponentId] -= 1), 0 === window.scCGSHMRCache[this.state.styledComponentId] && this.state.globalStyle.removeStyles(this.styleSheet);
              }, t.prototype.render = function () {
                var e = this;
                return l.a.createElement(Ye, null, function (t) {
                  e.styleSheet = t || de.master;
                  var n = e.state.globalStyle;
                  return n.isStatic ? (n.renderStyles(P, e.styleSheet), null) : l.a.createElement(qe, null, function (t) {
                    var r = e.constructor.defaultProps,
                      i = y({}, e.props);
                    return void 0 !== t && (i.theme = Me(e.props, t, r)), n.renderStyles(i, e.styleSheet), null;
                  });
                });
              }, t;
            }(l.a.Component);
          return s.globalStyle = a, s.styledComponentId = o, s;
        }
        C && (window.scCGSHMRCache = {});
        var rt = function rt(e) {
          return e.replace(/\s|\\n/g, "");
        };
        function it(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          var i = be.apply(void 0, [e].concat(n)),
            o = we(_e(rt(JSON.stringify(i))));
          return new he(o, q(i, o, "@keyframes"));
        }
        var ot = function ot(e) {
            var t = l.a.forwardRef(function (t, n) {
              return l.a.createElement(qe, null, function (r) {
                var i = e.defaultProps,
                  o = Me(t, r, i);
                return l.a.createElement(e, y({}, t, {
                  theme: o,
                  ref: n
                }));
              });
            });
            return Ve(t, e), t.displayName = "WithTheme(" + E(e) + ")", t;
          },
          at = {
            StyleSheet: de
          };
        t.default = et;
      }.call(this, n("./node_modules/process/browser.js"));
    },
    "./node_modules/asn1.js/lib/asn1.js": function node_modulesAsn1JsLibAsn1Js(e, t, n) {
      var r = t;
      r.bignum = n("./node_modules/bn.js/lib/bn.js"), r.define = n("./node_modules/asn1.js/lib/asn1/api.js").define, r.base = n("./node_modules/asn1.js/lib/asn1/base/index.js"), r.constants = n("./node_modules/asn1.js/lib/asn1/constants/index.js"), r.decoders = n("./node_modules/asn1.js/lib/asn1/decoders/index.js"), r.encoders = n("./node_modules/asn1.js/lib/asn1/encoders/index.js");
    },
    "./node_modules/asn1.js/lib/asn1/api.js": function node_modulesAsn1JsLibAsn1ApiJs(e, t, n) {
      var r = n("./node_modules/asn1.js/lib/asn1.js"),
        i = n("./node_modules/inherits/inherits_browser.js");
      function o(e, t) {
        this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
      }
      t.define = function (e, t) {
        return new o(e, t);
      }, o.prototype._createNamed = function (e) {
        var t;
        try {
          t = n("./node_modules/vm-browserify/index.js").runInThisContext("(function " + this.name + "(entity) {\n  this._initNamed(entity);\n})");
        } catch (e) {
          t = function t(e) {
            this._initNamed(e);
          };
        }
        return i(t, e), t.prototype._initNamed = function (t) {
          e.call(this, t);
        }, new t(this);
      }, o.prototype._getDecoder = function (e) {
        return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(r.decoders[e])), this.decoders[e];
      }, o.prototype.decode = function (e, t, n) {
        return this._getDecoder(t).decode(e, n);
      }, o.prototype._getEncoder = function (e) {
        return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(r.encoders[e])), this.encoders[e];
      }, o.prototype.encode = function (e, t, n) {
        return this._getEncoder(t).encode(e, n);
      };
    },
    "./node_modules/asn1.js/lib/asn1/base/buffer.js": function node_modulesAsn1JsLibAsn1BaseBufferJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/asn1.js/lib/asn1/base/index.js").Reporter,
        o = n("./node_modules/buffer/index.js").Buffer;
      function a(e, t) {
        i.call(this, t), o.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
      }
      function s(e, t) {
        if (Array.isArray(e)) this.length = 0, this.value = e.map(function (e) {
          return e instanceof s || (e = new s(e, t)), this.length += e.length, e;
        }, this);else if ("number" == typeof e) {
          if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
          this.value = e, this.length = 1;
        } else if ("string" == typeof e) this.value = e, this.length = o.byteLength(e);else {
          if (!o.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
          this.value = e, this.length = e.length;
        }
      }
      r(a, i), t.DecoderBuffer = a, a.prototype.save = function () {
        return {
          offset: this.offset,
          reporter: i.prototype.save.call(this)
        };
      }, a.prototype.restore = function (e) {
        var t = new a(this.base);
        return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
      }, a.prototype.isEmpty = function () {
        return this.offset === this.length;
      }, a.prototype.readUInt8 = function (e) {
        return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
      }, a.prototype.skip = function (e, t) {
        if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
        var n = new a(this.base);
        return n._reporterState = this._reporterState, n.offset = this.offset, n.length = this.offset + e, this.offset += e, n;
      }, a.prototype.raw = function (e) {
        return this.base.slice(e ? e.offset : this.offset, this.length);
      }, t.EncoderBuffer = s, s.prototype.join = function (e, t) {
        return e || (e = new o(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function (n) {
          n.join(e, t), t += n.length;
        }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : o.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
      };
    },
    "./node_modules/asn1.js/lib/asn1/base/index.js": function node_modulesAsn1JsLibAsn1BaseIndexJs(e, t, n) {
      var r = t;
      r.Reporter = n("./node_modules/asn1.js/lib/asn1/base/reporter.js").Reporter, r.DecoderBuffer = n("./node_modules/asn1.js/lib/asn1/base/buffer.js").DecoderBuffer, r.EncoderBuffer = n("./node_modules/asn1.js/lib/asn1/base/buffer.js").EncoderBuffer, r.Node = n("./node_modules/asn1.js/lib/asn1/base/node.js");
    },
    "./node_modules/asn1.js/lib/asn1/base/node.js": function node_modulesAsn1JsLibAsn1BaseNodeJs(e, t, n) {
      var r = n("./node_modules/asn1.js/lib/asn1/base/index.js").Reporter,
        i = n("./node_modules/asn1.js/lib/asn1/base/index.js").EncoderBuffer,
        o = n("./node_modules/asn1.js/lib/asn1/base/index.js").DecoderBuffer,
        a = n("./node_modules/minimalistic-assert/index.js"),
        s = ["seq", "seqof", "set", "setof", "objid", "bool", "gentime", "utctime", "null_", "enum", "int", "objDesc", "bitstr", "bmpstr", "charstr", "genstr", "graphstr", "ia5str", "iso646str", "numstr", "octstr", "printstr", "t61str", "unistr", "utf8str", "videostr"],
        l = ["key", "obj", "use", "optional", "explicit", "implicit", "def", "choice", "any", "contains"].concat(s);
      function u(e, t) {
        var n = {};
        this._baseState = n, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
      }
      e.exports = u;
      var c = ["enc", "parent", "children", "tag", "args", "reverseArgs", "choice", "optional", "any", "obj", "use", "alteredUse", "key", "default", "explicit", "implicit", "contains"];
      u.prototype.clone = function () {
        var e = this._baseState,
          t = {};
        c.forEach(function (n) {
          t[n] = e[n];
        });
        var n = new this.constructor(t.parent);
        return n._baseState = t, n;
      }, u.prototype._wrap = function () {
        var e = this._baseState;
        l.forEach(function (t) {
          this[t] = function () {
            var n = new this.constructor(this);
            return e.children.push(n), n[t].apply(n, arguments);
          };
        }, this);
      }, u.prototype._init = function (e) {
        var t = this._baseState;
        a(null === t.parent), e.call(this), t.children = t.children.filter(function (e) {
          return e._baseState.parent === this;
        }, this), a.equal(t.children.length, 1, "Root node can have only one child");
      }, u.prototype._useArgs = function (e) {
        var t = this._baseState,
          n = e.filter(function (e) {
            return e instanceof this.constructor;
          }, this);
        e = e.filter(function (e) {
          return !(e instanceof this.constructor);
        }, this), 0 !== n.length && (a(null === t.children), t.children = n, n.forEach(function (e) {
          e._baseState.parent = this;
        }, this)), 0 !== e.length && (a(null === t.args), t.args = e, t.reverseArgs = e.map(function (e) {
          if ("object" != typeof e || e.constructor !== Object) return e;
          var t = {};
          return Object.keys(e).forEach(function (n) {
            n == (0 | n) && (n |= 0);
            var r = e[n];
            t[r] = n;
          }), t;
        }));
      }, ["_peekTag", "_decodeTag", "_use", "_decodeStr", "_decodeObjid", "_decodeTime", "_decodeNull", "_decodeInt", "_decodeBool", "_decodeList", "_encodeComposite", "_encodeStr", "_encodeObjid", "_encodeTime", "_encodeNull", "_encodeInt", "_encodeBool"].forEach(function (e) {
        u.prototype[e] = function () {
          var t = this._baseState;
          throw new Error(e + " not implemented for encoding: " + t.enc);
        };
      }), s.forEach(function (e) {
        u.prototype[e] = function () {
          var t = this._baseState,
            n = Array.prototype.slice.call(arguments);
          return a(null === t.tag), t.tag = e, this._useArgs(n), this;
        };
      }), u.prototype.use = function (e) {
        a(e);
        var t = this._baseState;
        return a(null === t.use), t.use = e, this;
      }, u.prototype.optional = function () {
        return this._baseState.optional = !0, this;
      }, u.prototype.def = function (e) {
        var t = this._baseState;
        return a(null === t.default), t.default = e, t.optional = !0, this;
      }, u.prototype.explicit = function (e) {
        var t = this._baseState;
        return a(null === t.explicit && null === t.implicit), t.explicit = e, this;
      }, u.prototype.implicit = function (e) {
        var t = this._baseState;
        return a(null === t.explicit && null === t.implicit), t.implicit = e, this;
      }, u.prototype.obj = function () {
        var e = this._baseState,
          t = Array.prototype.slice.call(arguments);
        return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
      }, u.prototype.key = function (e) {
        var t = this._baseState;
        return a(null === t.key), t.key = e, this;
      }, u.prototype.any = function () {
        return this._baseState.any = !0, this;
      }, u.prototype.choice = function (e) {
        var t = this._baseState;
        return a(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function (t) {
          return e[t];
        })), this;
      }, u.prototype.contains = function (e) {
        var t = this._baseState;
        return a(null === t.use), t.contains = e, this;
      }, u.prototype._decode = function (e, t) {
        var n = this._baseState;
        if (null === n.parent) return e.wrapResult(n.children[0]._decode(e, t));
        var r,
          i = n.default,
          a = !0,
          s = null;
        if (null !== n.key && (s = e.enterKey(n.key)), n.optional) {
          var l = null;
          if (null !== n.explicit ? l = n.explicit : null !== n.implicit ? l = n.implicit : null !== n.tag && (l = n.tag), null !== l || n.any) {
            if (a = this._peekTag(e, l, n.any), e.isError(a)) return a;
          } else {
            var u = e.save();
            try {
              null === n.choice ? this._decodeGeneric(n.tag, e, t) : this._decodeChoice(e, t), a = !0;
            } catch (e) {
              a = !1;
            }
            e.restore(u);
          }
        }
        if (n.obj && a && (r = e.enterObject()), a) {
          if (null !== n.explicit) {
            var c = this._decodeTag(e, n.explicit);
            if (e.isError(c)) return c;
            e = c;
          }
          var d = e.offset;
          if (null === n.use && null === n.choice) {
            if (n.any) u = e.save();
            var h = this._decodeTag(e, null !== n.implicit ? n.implicit : n.tag, n.any);
            if (e.isError(h)) return h;
            n.any ? i = e.raw(u) : e = h;
          }
          if (t && t.track && null !== n.tag && t.track(e.path(), d, e.length, "tagged"), t && t.track && null !== n.tag && t.track(e.path(), e.offset, e.length, "content"), i = n.any ? i : null === n.choice ? this._decodeGeneric(n.tag, e, t) : this._decodeChoice(e, t), e.isError(i)) return i;
          if (n.any || null !== n.choice || null === n.children || n.children.forEach(function (n) {
            n._decode(e, t);
          }), n.contains && ("octstr" === n.tag || "bitstr" === n.tag)) {
            var f = new o(i);
            i = this._getUse(n.contains, e._reporterState.obj)._decode(f, t);
          }
        }
        return n.obj && a && (i = e.leaveObject(r)), null === n.key || null === i && !0 !== a ? null !== s && e.exitKey(s) : e.leaveKey(s, n.key, i), i;
      }, u.prototype._decodeGeneric = function (e, t, n) {
        var r = this._baseState;
        return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, r.args[0], n) : /str$/.test(e) ? this._decodeStr(t, e, n) : "objid" === e && r.args ? this._decodeObjid(t, r.args[0], r.args[1], n) : "objid" === e ? this._decodeObjid(t, null, null, n) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, n) : "null_" === e ? this._decodeNull(t, n) : "bool" === e ? this._decodeBool(t, n) : "objDesc" === e ? this._decodeStr(t, e, n) : "int" === e || "enum" === e ? this._decodeInt(t, r.args && r.args[0], n) : null !== r.use ? this._getUse(r.use, t._reporterState.obj)._decode(t, n) : t.error("unknown tag: " + e);
      }, u.prototype._getUse = function (e, t) {
        var n = this._baseState;
        return n.useDecoder = this._use(e, t), a(null === n.useDecoder._baseState.parent), n.useDecoder = n.useDecoder._baseState.children[0], n.implicit !== n.useDecoder._baseState.implicit && (n.useDecoder = n.useDecoder.clone(), n.useDecoder._baseState.implicit = n.implicit), n.useDecoder;
      }, u.prototype._decodeChoice = function (e, t) {
        var n = this._baseState,
          r = null,
          i = !1;
        return Object.keys(n.choice).some(function (o) {
          var a = e.save(),
            s = n.choice[o];
          try {
            var l = s._decode(e, t);
            if (e.isError(l)) return !1;
            r = {
              type: o,
              value: l
            }, i = !0;
          } catch (t) {
            return e.restore(a), !1;
          }
          return !0;
        }, this), i ? r : e.error("Choice not matched");
      }, u.prototype._createEncoderBuffer = function (e) {
        return new i(e, this.reporter);
      }, u.prototype._encode = function (e, t, n) {
        var r = this._baseState;
        if (null === r.default || r.default !== e) {
          var i = this._encodeValue(e, t, n);
          if (void 0 !== i && !this._skipDefault(i, t, n)) return i;
        }
      }, u.prototype._encodeValue = function (e, t, n) {
        var i = this._baseState;
        if (null === i.parent) return i.children[0]._encode(e, t || new r());
        var o = null;
        if (this.reporter = t, i.optional && void 0 === e) {
          if (null === i.default) return;
          e = i.default;
        }
        var a = null,
          s = !1;
        if (i.any) o = this._createEncoderBuffer(e);else if (i.choice) o = this._encodeChoice(e, t);else if (i.contains) a = this._getUse(i.contains, n)._encode(e, t), s = !0;else if (i.children) a = i.children.map(function (n) {
          if ("null_" === n._baseState.tag) return n._encode(null, t, e);
          if (null === n._baseState.key) return t.error("Child should have a key");
          var r = t.enterKey(n._baseState.key);
          if ("object" != typeof e) return t.error("Child expected, but input is not object");
          var i = n._encode(e[n._baseState.key], t, e);
          return t.leaveKey(r), i;
        }, this).filter(function (e) {
          return e;
        }), a = this._createEncoderBuffer(a);else if ("seqof" === i.tag || "setof" === i.tag) {
          if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
          if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
          var l = this.clone();
          l._baseState.implicit = null, a = this._createEncoderBuffer(e.map(function (n) {
            var r = this._baseState;
            return this._getUse(r.args[0], e)._encode(n, t);
          }, l));
        } else null !== i.use ? o = this._getUse(i.use, n)._encode(e, t) : (a = this._encodePrimitive(i.tag, e), s = !0);
        if (!i.any && null === i.choice) {
          var u = null !== i.implicit ? i.implicit : i.tag,
            c = null === i.implicit ? "universal" : "context";
          null === u ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (o = this._encodeComposite(u, s, c, a));
        }
        return null !== i.explicit && (o = this._encodeComposite(i.explicit, !1, "context", o)), o;
      }, u.prototype._encodeChoice = function (e, t) {
        var n = this._baseState,
          r = n.choice[e.type];
        return r || a(!1, e.type + " not found in " + JSON.stringify(Object.keys(n.choice))), r._encode(e.value, t);
      }, u.prototype._encodePrimitive = function (e, t) {
        var n = this._baseState;
        if (/str$/.test(e)) return this._encodeStr(t, e);
        if ("objid" === e && n.args) return this._encodeObjid(t, n.reverseArgs[0], n.args[1]);
        if ("objid" === e) return this._encodeObjid(t, null, null);
        if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
        if ("null_" === e) return this._encodeNull();
        if ("int" === e || "enum" === e) return this._encodeInt(t, n.args && n.reverseArgs[0]);
        if ("bool" === e) return this._encodeBool(t);
        if ("objDesc" === e) return this._encodeStr(t, e);
        throw new Error("Unsupported tag: " + e);
      }, u.prototype._isNumstr = function (e) {
        return /^[0-9 ]*$/.test(e);
      }, u.prototype._isPrintstr = function (e) {
        return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e);
      };
    },
    "./node_modules/asn1.js/lib/asn1/base/reporter.js": function node_modulesAsn1JsLibAsn1BaseReporterJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js");
      function i(e) {
        this._reporterState = {
          obj: null,
          path: [],
          options: e || {},
          errors: []
        };
      }
      function o(e, t) {
        this.path = e, this.rethrow(t);
      }
      t.Reporter = i, i.prototype.isError = function (e) {
        return e instanceof o;
      }, i.prototype.save = function () {
        var e = this._reporterState;
        return {
          obj: e.obj,
          pathLen: e.path.length
        };
      }, i.prototype.restore = function (e) {
        var t = this._reporterState;
        t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
      }, i.prototype.enterKey = function (e) {
        return this._reporterState.path.push(e);
      }, i.prototype.exitKey = function (e) {
        var t = this._reporterState;
        t.path = t.path.slice(0, e - 1);
      }, i.prototype.leaveKey = function (e, t, n) {
        var r = this._reporterState;
        this.exitKey(e), null !== r.obj && (r.obj[t] = n);
      }, i.prototype.path = function () {
        return this._reporterState.path.join("/");
      }, i.prototype.enterObject = function () {
        var e = this._reporterState,
          t = e.obj;
        return e.obj = {}, t;
      }, i.prototype.leaveObject = function (e) {
        var t = this._reporterState,
          n = t.obj;
        return t.obj = e, n;
      }, i.prototype.error = function (e) {
        var t,
          n = this._reporterState,
          r = e instanceof o;
        if (t = r ? e : new o(n.path.map(function (e) {
          return "[" + JSON.stringify(e) + "]";
        }).join(""), e.message || e, e.stack), !n.options.partial) throw t;
        return r || n.errors.push(t), t;
      }, i.prototype.wrapResult = function (e) {
        var t = this._reporterState;
        return t.options.partial ? {
          result: this.isError(e) ? null : e,
          errors: t.errors
        } : e;
      }, r(o, Error), o.prototype.rethrow = function (e) {
        if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, o), !this.stack) try {
          throw new Error(this.message);
        } catch (e) {
          this.stack = e.stack;
        }
        return this;
      };
    },
    "./node_modules/asn1.js/lib/asn1/constants/der.js": function node_modulesAsn1JsLibAsn1ConstantsDerJs(e, t, n) {
      var r = n("./node_modules/asn1.js/lib/asn1/constants/index.js");
      t.tagClass = {
        0: "universal",
        1: "application",
        2: "context",
        3: "private"
      }, t.tagClassByName = r._reverse(t.tagClass), t.tag = {
        0: "end",
        1: "bool",
        2: "int",
        3: "bitstr",
        4: "octstr",
        5: "null_",
        6: "objid",
        7: "objDesc",
        8: "external",
        9: "real",
        10: "enum",
        11: "embed",
        12: "utf8str",
        13: "relativeOid",
        16: "seq",
        17: "set",
        18: "numstr",
        19: "printstr",
        20: "t61str",
        21: "videostr",
        22: "ia5str",
        23: "utctime",
        24: "gentime",
        25: "graphstr",
        26: "iso646str",
        27: "genstr",
        28: "unistr",
        29: "charstr",
        30: "bmpstr"
      }, t.tagByName = r._reverse(t.tag);
    },
    "./node_modules/asn1.js/lib/asn1/constants/index.js": function node_modulesAsn1JsLibAsn1ConstantsIndexJs(e, t, n) {
      var r = t;
      r._reverse = function (e) {
        var t = {};
        return Object.keys(e).forEach(function (n) {
          (0 | n) == n && (n |= 0);
          var r = e[n];
          t[r] = n;
        }), t;
      }, r.der = n("./node_modules/asn1.js/lib/asn1/constants/der.js");
    },
    "./node_modules/asn1.js/lib/asn1/decoders/der.js": function node_modulesAsn1JsLibAsn1DecodersDerJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/asn1.js/lib/asn1.js"),
        o = i.base,
        a = i.bignum,
        s = i.constants.der;
      function l(e) {
        this.enc = "der", this.name = e.name, this.entity = e, this.tree = new u(), this.tree._init(e.body);
      }
      function u(e) {
        o.Node.call(this, "der", e);
      }
      function c(e, t) {
        var n = e.readUInt8(t);
        if (e.isError(n)) return n;
        var r = s.tagClass[n >> 6],
          i = 0 == (32 & n);
        if (31 == (31 & n)) {
          var o = n;
          for (n = 0; 128 == (128 & o);) {
            if (o = e.readUInt8(t), e.isError(o)) return o;
            n <<= 7, n |= 127 & o;
          }
        } else n &= 31;
        return {
          cls: r,
          primitive: i,
          tag: n,
          tagStr: s.tag[n]
        };
      }
      function d(e, t, n) {
        var r = e.readUInt8(n);
        if (e.isError(r)) return r;
        if (!t && 128 === r) return null;
        if (0 == (128 & r)) return r;
        var i = 127 & r;
        if (i > 4) return e.error("length octect is too long");
        r = 0;
        for (var o = 0; o < i; o++) {
          r <<= 8;
          var a = e.readUInt8(n);
          if (e.isError(a)) return a;
          r |= a;
        }
        return r;
      }
      e.exports = l, l.prototype.decode = function (e, t) {
        return e instanceof o.DecoderBuffer || (e = new o.DecoderBuffer(e, t)), this.tree._decode(e, t);
      }, r(u, o.Node), u.prototype._peekTag = function (e, t, n) {
        if (e.isEmpty()) return !1;
        var r = e.save(),
          i = c(e, 'Failed to peek tag: "' + t + '"');
        return e.isError(i) ? i : (e.restore(r), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || n);
      }, u.prototype._decodeTag = function (e, t, n) {
        var r = c(e, 'Failed to decode tag of "' + t + '"');
        if (e.isError(r)) return r;
        var i = d(e, r.primitive, 'Failed to get length of "' + t + '"');
        if (e.isError(i)) return i;
        if (!n && r.tag !== t && r.tagStr !== t && r.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
        if (r.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
        var o = e.save(),
          a = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
        return e.isError(a) ? a : (i = e.offset - o.offset, e.restore(o), e.skip(i, 'Failed to match body of: "' + t + '"'));
      }, u.prototype._skipUntilEnd = function (e, t) {
        for (;;) {
          var n = c(e, t);
          if (e.isError(n)) return n;
          var r,
            i = d(e, n.primitive, t);
          if (e.isError(i)) return i;
          if (r = n.primitive || null !== i ? e.skip(i) : this._skipUntilEnd(e, t), e.isError(r)) return r;
          if ("end" === n.tagStr) break;
        }
      }, u.prototype._decodeList = function (e, t, n, r) {
        for (var i = []; !e.isEmpty();) {
          var o = this._peekTag(e, "end");
          if (e.isError(o)) return o;
          var a = n.decode(e, "der", r);
          if (e.isError(a) && o) break;
          i.push(a);
        }
        return i;
      }, u.prototype._decodeStr = function (e, t) {
        if ("bitstr" === t) {
          var n = e.readUInt8();
          return e.isError(n) ? n : {
            unused: n,
            data: e.raw()
          };
        }
        if ("bmpstr" === t) {
          var r = e.raw();
          if (r.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
          for (var i = "", o = 0; o < r.length / 2; o++) i += String.fromCharCode(r.readUInt16BE(2 * o));
          return i;
        }
        if ("numstr" === t) {
          var a = e.raw().toString("ascii");
          return this._isNumstr(a) ? a : e.error("Decoding of string type: numstr unsupported characters");
        }
        if ("octstr" === t) return e.raw();
        if ("objDesc" === t) return e.raw();
        if ("printstr" === t) {
          var s = e.raw().toString("ascii");
          return this._isPrintstr(s) ? s : e.error("Decoding of string type: printstr unsupported characters");
        }
        return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
      }, u.prototype._decodeObjid = function (e, t, n) {
        for (var r, i = [], o = 0; !e.isEmpty();) {
          var a = e.readUInt8();
          o <<= 7, o |= 127 & a, 0 == (128 & a) && (i.push(o), o = 0);
        }
        128 & a && i.push(o);
        var s = i[0] / 40 | 0,
          l = i[0] % 40;
        if (r = n ? i : [s, l].concat(i.slice(1)), t) {
          var u = t[r.join(" ")];
          void 0 === u && (u = t[r.join(".")]), void 0 !== u && (r = u);
        }
        return r;
      }, u.prototype._decodeTime = function (e, t) {
        var n = e.raw().toString();
        if ("gentime" === t) var r = 0 | n.slice(0, 4),
          i = 0 | n.slice(4, 6),
          o = 0 | n.slice(6, 8),
          a = 0 | n.slice(8, 10),
          s = 0 | n.slice(10, 12),
          l = 0 | n.slice(12, 14);else {
          if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
          r = 0 | n.slice(0, 2), i = 0 | n.slice(2, 4), o = 0 | n.slice(4, 6), a = 0 | n.slice(6, 8), s = 0 | n.slice(8, 10), l = 0 | n.slice(10, 12);
          r = r < 70 ? 2e3 + r : 1900 + r;
        }
        return Date.UTC(r, i - 1, o, a, s, l, 0);
      }, u.prototype._decodeNull = function (e) {
        return null;
      }, u.prototype._decodeBool = function (e) {
        var t = e.readUInt8();
        return e.isError(t) ? t : 0 !== t;
      }, u.prototype._decodeInt = function (e, t) {
        var n = e.raw(),
          r = new a(n);
        return t && (r = t[r.toString(10)] || r), r;
      }, u.prototype._use = function (e, t) {
        return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
      };
    },
    "./node_modules/asn1.js/lib/asn1/decoders/index.js": function node_modulesAsn1JsLibAsn1DecodersIndexJs(e, t, n) {
      var r = t;
      r.der = n("./node_modules/asn1.js/lib/asn1/decoders/der.js"), r.pem = n("./node_modules/asn1.js/lib/asn1/decoders/pem.js");
    },
    "./node_modules/asn1.js/lib/asn1/decoders/pem.js": function node_modulesAsn1JsLibAsn1DecodersPemJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/buffer/index.js").Buffer,
        o = n("./node_modules/asn1.js/lib/asn1/decoders/der.js");
      function a(e) {
        o.call(this, e), this.enc = "pem";
      }
      r(a, o), e.exports = a, a.prototype.decode = function (e, t) {
        for (var n = e.toString().split(/[\r\n]+/g), r = t.label.toUpperCase(), a = /^-----(BEGIN|END) ([^-]+)-----$/, s = -1, l = -1, u = 0; u < n.length; u++) {
          var c = n[u].match(a);
          if (null !== c && c[2] === r) {
            if (-1 !== s) {
              if ("END" !== c[1]) break;
              l = u;
              break;
            }
            if ("BEGIN" !== c[1]) break;
            s = u;
          }
        }
        if (-1 === s || -1 === l) throw new Error("PEM section not found for: " + r);
        var d = n.slice(s + 1, l).join("");
        d.replace(/[^a-z0-9\+\/=]+/gi, "");
        var h = new i(d, "base64");
        return o.prototype.decode.call(this, h, t);
      };
    },
    "./node_modules/asn1.js/lib/asn1/encoders/der.js": function node_modulesAsn1JsLibAsn1EncodersDerJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/buffer/index.js").Buffer,
        o = n("./node_modules/asn1.js/lib/asn1.js"),
        a = o.base,
        s = o.constants.der;
      function l(e) {
        this.enc = "der", this.name = e.name, this.entity = e, this.tree = new u(), this.tree._init(e.body);
      }
      function u(e) {
        a.Node.call(this, "der", e);
      }
      function c(e) {
        return e < 10 ? "0" + e : e;
      }
      e.exports = l, l.prototype.encode = function (e, t) {
        return this.tree._encode(e, t).join();
      }, r(u, a.Node), u.prototype._encodeComposite = function (e, t, n, r) {
        var o,
          a = function (e, t, n, r) {
            var i;
            "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
            if (s.tagByName.hasOwnProperty(e)) i = s.tagByName[e];else {
              if ("number" != typeof e || (0 | e) !== e) return r.error("Unknown tag: " + e);
              i = e;
            }
            if (i >= 31) return r.error("Multi-octet tag encoding unsupported");
            t || (i |= 32);
            return i |= s.tagClassByName[n || "universal"] << 6;
          }(e, t, n, this.reporter);
        if (r.length < 128) return (o = new i(2))[0] = a, o[1] = r.length, this._createEncoderBuffer([o, r]);
        for (var l = 1, u = r.length; u >= 256; u >>= 8) l++;
        (o = new i(2 + l))[0] = a, o[1] = 128 | l;
        u = 1 + l;
        for (var c = r.length; c > 0; u--, c >>= 8) o[u] = 255 & c;
        return this._createEncoderBuffer([o, r]);
      }, u.prototype._encodeStr = function (e, t) {
        if ("bitstr" === t) return this._createEncoderBuffer([0 | e.unused, e.data]);
        if ("bmpstr" === t) {
          for (var n = new i(2 * e.length), r = 0; r < e.length; r++) n.writeUInt16BE(e.charCodeAt(r), 2 * r);
          return this._createEncoderBuffer(n);
        }
        return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
      }, u.prototype._encodeObjid = function (e, t, n) {
        if ("string" == typeof e) {
          if (!t) return this.reporter.error("string objid given, but no values map found");
          if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
          e = t[e].split(/[\s\.]+/g);
          for (var r = 0; r < e.length; r++) e[r] |= 0;
        } else if (Array.isArray(e)) {
          e = e.slice();
          for (r = 0; r < e.length; r++) e[r] |= 0;
        }
        if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
        if (!n) {
          if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
          e.splice(0, 2, 40 * e[0] + e[1]);
        }
        var o = 0;
        for (r = 0; r < e.length; r++) {
          var a = e[r];
          for (o++; a >= 128; a >>= 7) o++;
        }
        var s = new i(o),
          l = s.length - 1;
        for (r = e.length - 1; r >= 0; r--) {
          a = e[r];
          for (s[l--] = 127 & a; (a >>= 7) > 0;) s[l--] = 128 | 127 & a;
        }
        return this._createEncoderBuffer(s);
      }, u.prototype._encodeTime = function (e, t) {
        var n,
          r = new Date(e);
        return "gentime" === t ? n = [c(r.getFullYear()), c(r.getUTCMonth() + 1), c(r.getUTCDate()), c(r.getUTCHours()), c(r.getUTCMinutes()), c(r.getUTCSeconds()), "Z"].join("") : "utctime" === t ? n = [c(r.getFullYear() % 100), c(r.getUTCMonth() + 1), c(r.getUTCDate()), c(r.getUTCHours()), c(r.getUTCMinutes()), c(r.getUTCSeconds()), "Z"].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(n, "octstr");
      }, u.prototype._encodeNull = function () {
        return this._createEncoderBuffer("");
      }, u.prototype._encodeInt = function (e, t) {
        if ("string" == typeof e) {
          if (!t) return this.reporter.error("String int or enum given, but no values map");
          if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
          e = t[e];
        }
        if ("number" != typeof e && !i.isBuffer(e)) {
          var n = e.toArray();
          !e.sign && 128 & n[0] && n.unshift(0), e = new i(n);
        }
        if (i.isBuffer(e)) {
          var r = e.length;
          0 === e.length && r++;
          var o = new i(r);
          return e.copy(o), 0 === e.length && (o[0] = 0), this._createEncoderBuffer(o);
        }
        if (e < 128) return this._createEncoderBuffer(e);
        if (e < 256) return this._createEncoderBuffer([0, e]);
        r = 1;
        for (var a = e; a >= 256; a >>= 8) r++;
        for (a = (o = new Array(r)).length - 1; a >= 0; a--) o[a] = 255 & e, e >>= 8;
        return 128 & o[0] && o.unshift(0), this._createEncoderBuffer(new i(o));
      }, u.prototype._encodeBool = function (e) {
        return this._createEncoderBuffer(e ? 255 : 0);
      }, u.prototype._use = function (e, t) {
        return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
      }, u.prototype._skipDefault = function (e, t, n) {
        var r,
          i = this._baseState;
        if (null === i.default) return !1;
        var o = e.join();
        if (void 0 === i.defaultBuffer && (i.defaultBuffer = this._encodeValue(i.default, t, n).join()), o.length !== i.defaultBuffer.length) return !1;
        for (r = 0; r < o.length; r++) if (o[r] !== i.defaultBuffer[r]) return !1;
        return !0;
      };
    },
    "./node_modules/asn1.js/lib/asn1/encoders/index.js": function node_modulesAsn1JsLibAsn1EncodersIndexJs(e, t, n) {
      var r = t;
      r.der = n("./node_modules/asn1.js/lib/asn1/encoders/der.js"), r.pem = n("./node_modules/asn1.js/lib/asn1/encoders/pem.js");
    },
    "./node_modules/asn1.js/lib/asn1/encoders/pem.js": function node_modulesAsn1JsLibAsn1EncodersPemJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/asn1.js/lib/asn1/encoders/der.js");
      function o(e) {
        i.call(this, e), this.enc = "pem";
      }
      r(o, i), e.exports = o, o.prototype.encode = function (e, t) {
        for (var n = i.prototype.encode.call(this, e).toString("base64"), r = ["-----BEGIN " + t.label + "-----"], o = 0; o < n.length; o += 64) r.push(n.slice(o, o + 64));
        return r.push("-----END " + t.label + "-----"), r.join("\n");
      };
    },
    "./node_modules/babel-runtime/core-js/array/from.js": function node_modulesBabelRuntimeCoreJsArrayFromJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/array/from.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/object/assign.js": function node_modulesBabelRuntimeCoreJsObjectAssignJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/object/create.js": function node_modulesBabelRuntimeCoreJsObjectCreateJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/create.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/object/define-property.js": function node_modulesBabelRuntimeCoreJsObjectDefinePropertyJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/define-property.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js": function node_modulesBabelRuntimeCoreJsObjectGetOwnPropertyDescriptorJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-own-property-descriptor.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/object/get-prototype-of.js": function node_modulesBabelRuntimeCoreJsObjectGetPrototypeOfJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/object/set-prototype-of.js": function node_modulesBabelRuntimeCoreJsObjectSetPrototypeOfJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/symbol.js": function node_modulesBabelRuntimeCoreJsSymbolJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/index.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/core-js/symbol/iterator.js": function node_modulesBabelRuntimeCoreJsSymbolIteratorJs(e, t, n) {
      e.exports = {
        default: n("./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/iterator.js"),
        __esModule: !0
      };
    },
    "./node_modules/babel-runtime/helpers/classCallCheck.js": function node_modulesBabelRuntimeHelpersClassCallCheckJs(e, t, n) {
      "use strict";

      t.__esModule = !0, t.default = function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      };
    },
    "./node_modules/babel-runtime/helpers/createClass.js": function node_modulesBabelRuntimeHelpersCreateClassJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r,
        i = n("./node_modules/babel-runtime/core-js/object/define-property.js"),
        o = (r = i) && r.__esModule ? r : {
          default: r
        };
      t.default = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, o.default)(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }();
    },
    "./node_modules/babel-runtime/helpers/defineProperty.js": function node_modulesBabelRuntimeHelpersDefinePropertyJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r,
        i = n("./node_modules/babel-runtime/core-js/object/define-property.js"),
        o = (r = i) && r.__esModule ? r : {
          default: r
        };
      t.default = function (e, t, n) {
        return t in e ? (0, o.default)(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      };
    },
    "./node_modules/babel-runtime/helpers/extends.js": function node_modulesBabelRuntimeHelpersExtendsJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r,
        i = n("./node_modules/babel-runtime/core-js/object/assign.js"),
        o = (r = i) && r.__esModule ? r : {
          default: r
        };
      t.default = o.default || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      };
    },
    "./node_modules/babel-runtime/helpers/get.js": function node_modulesBabelRuntimeHelpersGetJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r = o(n("./node_modules/babel-runtime/core-js/object/get-prototype-of.js")),
        i = o(n("./node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js"));
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      t.default = function e(t, n, o) {
        null === t && (t = Function.prototype);
        var a = (0, i.default)(t, n);
        if (void 0 === a) {
          var s = (0, r.default)(t);
          return null === s ? void 0 : e(s, n, o);
        }
        if ("value" in a) return a.value;
        var l = a.get;
        return void 0 !== l ? l.call(o) : void 0;
      };
    },
    "./node_modules/babel-runtime/helpers/inherits.js": function node_modulesBabelRuntimeHelpersInheritsJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r = a(n("./node_modules/babel-runtime/core-js/object/set-prototype-of.js")),
        i = a(n("./node_modules/babel-runtime/core-js/object/create.js")),
        o = a(n("./node_modules/babel-runtime/helpers/typeof.js"));
      function a(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      t.default = function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === t ? "undefined" : (0, o.default)(t)));
        e.prototype = (0, i.default)(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (r.default ? (0, r.default)(e, t) : e.__proto__ = t);
      };
    },
    "./node_modules/babel-runtime/helpers/objectWithoutProperties.js": function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesJs(e, t, n) {
      "use strict";

      t.__esModule = !0, t.default = function (e, t) {
        var n = {};
        for (var r in e) t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
        return n;
      };
    },
    "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js": function node_modulesBabelRuntimeHelpersPossibleConstructorReturnJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r,
        i = n("./node_modules/babel-runtime/helpers/typeof.js"),
        o = (r = i) && r.__esModule ? r : {
          default: r
        };
      t.default = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" !== (void 0 === t ? "undefined" : (0, o.default)(t)) && "function" != typeof t ? e : t;
      };
    },
    "./node_modules/babel-runtime/helpers/toConsumableArray.js": function node_modulesBabelRuntimeHelpersToConsumableArrayJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r,
        i = n("./node_modules/babel-runtime/core-js/array/from.js"),
        o = (r = i) && r.__esModule ? r : {
          default: r
        };
      t.default = function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
        return (0, o.default)(e);
      };
    },
    "./node_modules/babel-runtime/helpers/typeof.js": function node_modulesBabelRuntimeHelpersTypeofJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r = a(n("./node_modules/babel-runtime/core-js/symbol/iterator.js")),
        i = a(n("./node_modules/babel-runtime/core-js/symbol.js")),
        o = "function" == typeof i.default && "symbol" == typeof r.default ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof i.default && e.constructor === i.default && e !== i.default.prototype ? "symbol" : typeof e;
        };
      function a(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      t.default = "function" == typeof i.default && "symbol" === o(r.default) ? function (e) {
        return void 0 === e ? "undefined" : o(e);
      } : function (e) {
        return e && "function" == typeof i.default && e.constructor === i.default && e !== i.default.prototype ? "symbol" : void 0 === e ? "undefined" : o(e);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/array/from.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnArrayFromJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js"), n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.from.js"), e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Array.from;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnObjectAssignJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.assign.js"), e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.assign;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/create.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnObjectCreateJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.create.js");
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
      e.exports = function (e, t) {
        return r.create(e, t);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/define-property.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnObjectDefinePropertyJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.define-property.js");
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
      e.exports = function (e, t, n) {
        return r.defineProperty(e, t, n);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-own-property-descriptor.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnObjectGetOwnPropertyDescriptorJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
      e.exports = function (e, t) {
        return r.getOwnPropertyDescriptor(e, t);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnObjectGetPrototypeOfJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-prototype-of.js"), e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnObjectSetPrototypeOfJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.set-prototype-of.js"), e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/index.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnSymbolIndexJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.symbol.js"), n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.to-string.js"), n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js"), n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js"), e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Symbol;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/iterator.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryFnSymbolIteratorJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js"), n("./node_modules/babel-runtime/node_modules/core-js/library/modules/web.dom.iterable.js"), e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js").f("iterator");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_a-function.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_aFunctionJs(e, t) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(e + " is not a function!");
        return e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_addToUnscopablesJs(e, t) {
      e.exports = function () {};
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_anObjectJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
      e.exports = function (e) {
        if (!r(e)) throw TypeError(e + " is not an object!");
        return e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_array-includes.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_arrayIncludesJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-absolute-index.js");
      e.exports = function (e) {
        return function (t, n, a) {
          var s,
            l = r(t),
            u = i(l.length),
            c = o(a, u);
          if (e && n != n) {
            for (; u > c;) if ((s = l[c++]) != s) return !0;
          } else for (; u > c; c++) if ((e || c in l) && l[c] === n) return e || c || 0;
          return !e && -1;
        };
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_classof.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_classofJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("toStringTag"),
        o = "Arguments" == r(function () {
          return arguments;
        }());
      e.exports = function (e) {
        var t, n, a;
        return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
          try {
            return e[t];
          } catch (e) {}
        }(t = Object(e), i)) ? n : o ? r(t) : "Object" == (a = r(t)) && "function" == typeof t.callee ? "Arguments" : a;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_cofJs(e, t) {
      var n = {}.toString;
      e.exports = function (e) {
        return n.call(e).slice(8, -1);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_coreJs(e, t) {
      var n = e.exports = {
        version: "2.6.11"
      };
      "number" == typeof __e && (__e = n);
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_create-property.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_createPropertyJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
      e.exports = function (e, t, n) {
        t in e ? r.f(e, t, i(0, n)) : e[t] = n;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_ctxJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_a-function.js");
      e.exports = function (e, t, n) {
        if (r(e), void 0 === t) return e;
        switch (n) {
          case 1:
            return function (n) {
              return e.call(t, n);
            };
          case 2:
            return function (n, r) {
              return e.call(t, n, r);
            };
          case 3:
            return function (n, r, i) {
              return e.call(t, n, r, i);
            };
        }
        return function () {
          return e.apply(t, arguments);
        };
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_definedJs(e, t) {
      e.exports = function (e) {
        if (null == e) throw TypeError("Can't call method on  " + e);
        return e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_descriptorsJs(e, t, n) {
      e.exports = !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_domCreateJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").document,
        o = r(i) && r(i.createElement);
      e.exports = function (e) {
        return o ? i.createElement(e) : {};
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_enumBugKeysJs(e, t) {
      e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-keys.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_enumKeysJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
      e.exports = function (e) {
        var t = r(e),
          n = i.f;
        if (n) for (var a, s = n(e), l = o.f, u = 0; s.length > u;) l.call(e, a = s[u++]) && t.push(a);
        return t;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_exportJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        l = function l(e, t, n) {
          var u,
            c,
            d,
            h = e & l.F,
            f = e & l.G,
            p = e & l.S,
            m = e & l.P,
            g = e & l.B,
            v = e & l.W,
            y = f ? i : i[t] || (i[t] = {}),
            b = y.prototype,
            _ = f ? r : p ? r[t] : (r[t] || {}).prototype;
          for (u in f && (n = t), n) (c = !h && _ && void 0 !== _[u]) && s(y, u) || (d = c ? _[u] : n[u], y[u] = f && "function" != typeof _[u] ? n[u] : g && c ? o(d, r) : v && _[u] == d ? function (e) {
            var t = function t(_t5, n, r) {
              if (this instanceof e) {
                switch (arguments.length) {
                  case 0:
                    return new e();
                  case 1:
                    return new e(_t5);
                  case 2:
                    return new e(_t5, n);
                }
                return new e(_t5, n, r);
              }
              return e.apply(this, arguments);
            };
            return t.prototype = e.prototype, t;
          }(d) : m && "function" == typeof d ? o(Function.call, d) : d, m && ((y.virtual || (y.virtual = {}))[u] = d, e & l.R && b && !b[u] && a(b, u, d)));
        };
      l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, e.exports = l;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_failsJs(e, t) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_globalJs(e, t) {
      var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_hasJs(e, t) {
      var n = {}.hasOwnProperty;
      e.exports = function (e, t) {
        return n.call(e, t);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_hideJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
      e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? function (e, t, n) {
        return r.f(e, t, i(1, n));
      } : function (e, t, n) {
        return e[t] = n, e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_htmlJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").document;
      e.exports = r && r.documentElement;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_ie8DomDefineJs(e, t, n) {
      e.exports = !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") && !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
        return 7 != Object.defineProperty(n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js")("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iobjectJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
      e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
        return "String" == r(e) ? e.split("") : Object(e);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array-iter.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_isArrayIterJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("iterator"),
        o = Array.prototype;
      e.exports = function (e) {
        return void 0 !== e && (r.Array === e || o[i] === e);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_isArrayJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
      e.exports = Array.isArray || function (e) {
        return "Array" == r(e);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_isObjectJs(e, t) {
      e.exports = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-call.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iterCallJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
      e.exports = function (e, t, n, i) {
        try {
          return i ? t(r(n)[0], n[1]) : t(n);
        } catch (t) {
          var o = e.return;
          throw void 0 !== o && r(o.call(e)), t;
        }
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-create.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iterCreateJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js"),
        a = {};
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js")(a, n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("iterator"), function () {
        return this;
      }), e.exports = function (e, t, n) {
        e.prototype = r(a, {
          next: i(1, n)
        }), o(e, t + " Iterator");
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iterDefineJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js"),
        l = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-create.js"),
        u = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js"),
        c = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js"),
        d = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("iterator"),
        h = !([].keys && "next" in [].keys()),
        f = function f() {
          return this;
        };
      e.exports = function (e, t, n, p, m, g, v) {
        l(n, t, p);
        var y,
          b,
          _,
          x = function x(e) {
            if (!h && e in E) return E[e];
            switch (e) {
              case "keys":
              case "values":
                return function () {
                  return new n(this, e);
                };
            }
            return function () {
              return new n(this, e);
            };
          },
          w = t + " Iterator",
          S = "values" == m,
          A = !1,
          E = e.prototype,
          T = E[d] || E["@@iterator"] || m && E[m],
          M = T || x(m),
          C = m ? S ? x("entries") : M : void 0,
          k = "Array" == t && E.entries || T;
        if (k && (_ = c(k.call(new e()))) !== Object.prototype && _.next && (u(_, w, !0), r || "function" == typeof _[d] || a(_, d, f)), S && T && "values" !== T.name && (A = !0, M = function M() {
          return T.call(this);
        }), r && !v || !h && !A && E[d] || a(E, d, M), s[t] = M, s[w] = f, m) if (y = {
          values: S ? M : x("values"),
          keys: g ? M : x("keys"),
          entries: C
        }, v) for (b in y) b in E || o(E, b, y[b]);else i(i.P + i.F * (h || A), t, y);
        return y;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-detect.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iterDetectJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("iterator"),
        i = !1;
      try {
        var o = [7][r]();
        o.return = function () {
          i = !0;
        }, Array.from(o, function () {
          throw 2;
        });
      } catch (e) {}
      e.exports = function (e, t) {
        if (!t && !i) return !1;
        var n = !1;
        try {
          var o = [7],
            a = o[r]();
          a.next = function () {
            return {
              done: n = !0
            };
          }, o[r] = function () {
            return a;
          }, e(o);
        } catch (e) {}
        return n;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iterStepJs(e, t) {
      e.exports = function (e, t) {
        return {
          value: t,
          done: !!e
        };
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_iteratorsJs(e, t) {
      e.exports = {};
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_libraryJs(e, t) {
      e.exports = !0;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_meta.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_metaJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js")("meta"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f,
        s = 0,
        l = Object.isExtensible || function () {
          return !0;
        },
        u = !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
          return l(Object.preventExtensions({}));
        }),
        c = function c(e) {
          a(e, r, {
            value: {
              i: "O" + ++s,
              w: {}
            }
          });
        },
        d = e.exports = {
          KEY: r,
          NEED: !1,
          fastKey: function fastKey(e, t) {
            if (!i(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
            if (!o(e, r)) {
              if (!l(e)) return "F";
              if (!t) return "E";
              c(e);
            }
            return e[r].i;
          },
          getWeak: function getWeak(e, t) {
            if (!o(e, r)) {
              if (!l(e)) return !0;
              if (!t) return !1;
              c(e);
            }
            return e[r].w;
          },
          onFreeze: function onFreeze(e) {
            return u && d.NEED && l(e) && !o(e, r) && c(e), e;
          }
        };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-assign.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectAssignJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js"),
        l = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js"),
        u = Object.assign;
      e.exports = !u || n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
        var e = {},
          t = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
        return e[n] = 7, r.split("").forEach(function (e) {
          t[e] = e;
        }), 7 != u({}, e)[n] || Object.keys(u({}, t)).join("") != r;
      }) ? function (e, t) {
        for (var n = s(e), u = arguments.length, c = 1, d = o.f, h = a.f; u > c;) for (var f, p = l(arguments[c++]), m = d ? i(p).concat(d(p)) : i(p), g = m.length, v = 0; g > v;) f = m[v++], r && !h.call(p, f) || (n[f] = p[f]);
        return n;
      } : u;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectCreateJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dps.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")("IE_PROTO"),
        s = function s() {},
        _l2 = function l() {
          var e,
            t = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js")("iframe"),
            r = o.length;
          for (t.style.display = "none", n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js").appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _l2 = e.F; r--;) delete _l2.prototype[o[r]];
          return _l2();
        };
      e.exports = Object.create || function (e, t) {
        var n;
        return null !== e ? (s.prototype = r(e), n = new s(), s.prototype = null, n[a] = e) : n = _l2(), void 0 === t ? n : i(n, t);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectDpJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js"),
        a = Object.defineProperty;
      t.f = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function (e, t, n) {
        if (r(e), t = o(t, !0), r(n), i) try {
          return a(e, t, n);
        } catch (e) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (e[t] = n.value), e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dps.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectDpsJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
      e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function (e, t) {
        i(e);
        for (var n, a = o(t), s = a.length, l = 0; s > l;) r.f(e, n = a[l++], t[n]);
        return e;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectGopdJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        l = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js"),
        u = Object.getOwnPropertyDescriptor;
      t.f = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? u : function (e, t) {
        if (e = o(e), t = a(t, !0), l) try {
          return u(e, t);
        } catch (e) {}
        if (s(e, t)) return i(!r.f.call(e, t), e[t]);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn-ext.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectGopnExtJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js").f,
        o = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      e.exports.f = function (e) {
        return a && "[object Window]" == o.call(e) ? function (e) {
          try {
            return i(e);
          } catch (e) {
            return a.slice();
          }
        }(e) : i(r(e));
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectGopnJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js").concat("length", "prototype");
      t.f = Object.getOwnPropertyNames || function (e) {
        return r(e, i);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectGopsJs(e, t) {
      t.f = Object.getOwnPropertySymbols;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectGpoJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")("IE_PROTO"),
        a = Object.prototype;
      e.exports = Object.getPrototypeOf || function (e) {
        return e = i(e), r(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectKeysInternalJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_array-includes.js")(!1),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")("IE_PROTO");
      e.exports = function (e, t) {
        var n,
          s = i(e),
          l = 0,
          u = [];
        for (n in s) n != a && r(s, n) && u.push(n);
        for (; t.length > l;) r(s, n = t[l++]) && (~o(u, n) || u.push(n));
        return u;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectKeysJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js");
      e.exports = Object.keys || function (e) {
        return r(e, i);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectPieJs(e, t) {
      t.f = {}.propertyIsEnumerable;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_objectSapJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js");
      e.exports = function (e, t) {
        var n = (i.Object || {})[e] || Object[e],
          a = {};
        a[e] = t(n), r(r.S + r.F * o(function () {
          n(1);
        }), "Object", a);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_propertyDescJs(e, t) {
      e.exports = function (e, t) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: t
        };
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_redefineJs(e, t, n) {
      e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-proto.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_setProtoJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js"),
        o = function o(e, t) {
          if (i(e), !r(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
        };
      e.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, r) {
          try {
            (r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js")(Function.call, n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
          } catch (e) {
            t = !0;
          }
          return function (e, n) {
            return o(e, n), t ? e.__proto__ = n : r(e, n), e;
          };
        }({}, !1) : void 0),
        check: o
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_setToStringTagJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f,
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("toStringTag");
      e.exports = function (e, t, n) {
        e && !i(e = n ? e : e.prototype, o) && r(e, o, {
          configurable: !0,
          value: t
        });
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_sharedKeyJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js")("keys"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
      e.exports = function (e) {
        return r[e] || (r[e] = i(e));
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_sharedJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js"),
        o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
      (e.exports = function (e, t) {
        return o[e] || (o[e] = void 0 !== t ? t : {});
      })("versions", []).push({
        version: r.version,
        mode: n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js") ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_string-at.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_stringAtJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
      e.exports = function (e) {
        return function (t, n) {
          var o,
            a,
            s = String(i(t)),
            l = r(n),
            u = s.length;
          return l < 0 || l >= u ? e ? "" : void 0 : (o = s.charCodeAt(l)) < 55296 || o > 56319 || l + 1 === u || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : o : e ? s.slice(l, l + 2) : a - 56320 + (o - 55296 << 10) + 65536;
        };
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-absolute-index.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_toAbsoluteIndexJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js"),
        i = Math.max,
        o = Math.min;
      e.exports = function (e, t) {
        return (e = r(e)) < 0 ? i(e + t, 0) : o(e, t);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_toIntegerJs(e, t) {
      var n = Math.ceil,
        r = Math.floor;
      e.exports = function (e) {
        return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_toIobjectJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
      e.exports = function (e) {
        return r(i(e));
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_toLengthJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js"),
        i = Math.min;
      e.exports = function (e) {
        return e > 0 ? i(r(e), 9007199254740991) : 0;
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_toObjectJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
      e.exports = function (e) {
        return Object(r(e));
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_toPrimitiveJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
      e.exports = function (e, t) {
        if (!r(e)) return e;
        var n, i;
        if (t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;
        if ("function" == typeof (n = e.valueOf) && !r(i = n.call(e))) return i;
        if (!t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_uidJs(e, t) {
      var n = 0,
        r = Math.random();
      e.exports = function (e) {
        return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_wksDefineJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
      e.exports = function (e) {
        var t = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
        "_" == e.charAt(0) || e in t || s(t, e, {
          value: a.f(e)
        });
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_wksExtJs(e, t, n) {
      t.f = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModules_wksJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js")("wks"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").Symbol,
        a = "function" == typeof o;
      (e.exports = function (e) {
        return r[e] || (r[e] = a && o[e] || (a ? o : i)("Symbol." + e));
      }).store = r;
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/core.get-iterator-method.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesCoreGetIteratorMethodJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_classof.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("iterator"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
      e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (e) {
        if (null != e) return e[i] || e["@@iterator"] || o[r(e)];
      };
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.from.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ArrayFromJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-call.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array-iter.js"),
        l = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js"),
        u = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_create-property.js"),
        c = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/core.get-iterator-method.js");
      i(i.S + i.F * !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-detect.js")(function (e) {
        Array.from(e);
      }), "Array", {
        from: function from(e) {
          var t,
            n,
            i,
            d,
            h = o(e),
            f = "function" == typeof this ? this : Array,
            p = arguments.length,
            m = p > 1 ? arguments[1] : void 0,
            g = void 0 !== m,
            v = 0,
            y = c(h);
          if (g && (m = r(m, p > 2 ? arguments[2] : void 0, 2)), null == y || f == Array && s(y)) for (n = new f(t = l(h.length)); t > v; v++) u(n, v, g ? m(h[v], v) : h[v]);else for (d = y.call(h), n = new f(); !(i = d.next()).done; v++) u(n, v, g ? a(d, m, [i.value, v], !0) : i.value);
          return n.length = v, n;
        }
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.iterator.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ArrayIteratorJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
      e.exports = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js")(Array, "Array", function (e, t) {
        this._t = a(e), this._i = 0, this._k = t;
      }, function () {
        var e = this._t,
          t = this._k,
          n = this._i++;
        return !e || n >= e.length ? (this._t = void 0, i(1)) : i(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
      }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.assign.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectAssignJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
      r(r.S + r.F, "Object", {
        assign: n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-assign.js")
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.create.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectCreateJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
      r(r.S, "Object", {
        create: n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js")
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.define-property.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectDefinePropertyJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
      r(r.S + r.F * !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js"), "Object", {
        defineProperty: n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectGetOwnPropertyDescriptorJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js").f;
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js")("getOwnPropertyDescriptor", function () {
        return function (e, t) {
          return i(r(e), t);
        };
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-prototype-of.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectGetPrototypeOfJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js");
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js")("getPrototypeOf", function () {
        return function (e) {
          return i(r(e));
        };
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.set-prototype-of.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectSetPrototypeOfJs(e, t, n) {
      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
      r(r.S, "Object", {
        setPrototypeOf: n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-proto.js").set
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.to-string.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6ObjectToStringJs(e, t) {},
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6StringIteratorJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_string-at.js")(!0);
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js")(String, "String", function (e) {
        this._t = String(e), this._i = 0;
      }, function () {
        var e,
          t = this._t,
          n = this._i;
        return n >= t.length ? {
          value: void 0,
          done: !0
        } : (e = r(t, n), this._i += e.length, {
          value: e,
          done: !1
        });
      });
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.symbol.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs6SymbolJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js"),
        i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js"),
        o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js"),
        a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js"),
        s = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js"),
        l = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_meta.js").KEY,
        u = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js"),
        c = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js"),
        d = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js"),
        h = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js"),
        f = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js"),
        p = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js"),
        m = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js"),
        g = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-keys.js"),
        v = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array.js"),
        y = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js"),
        b = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js"),
        _ = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js"),
        x = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js"),
        w = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js"),
        S = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js"),
        A = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js"),
        E = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn-ext.js"),
        T = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js"),
        M = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js"),
        C = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js"),
        k = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js"),
        P = T.f,
        O = C.f,
        R = E.f,
        _I = r.Symbol,
        j = r.JSON,
        N = j && j.stringify,
        L = f("_hidden"),
        D = f("toPrimitive"),
        B = {}.propertyIsEnumerable,
        F = c("symbol-registry"),
        z = c("symbols"),
        U = c("op-symbols"),
        G = Object.prototype,
        V = "function" == typeof _I && !!M.f,
        H = r.QObject,
        q = !H || !H.prototype || !H.prototype.findChild,
        W = o && u(function () {
          return 7 != A(O({}, "a", {
            get: function get() {
              return O(this, "a", {
                value: 7
              }).a;
            }
          })).a;
        }) ? function (e, t, n) {
          var r = P(G, t);
          r && delete G[t], O(e, t, n), r && e !== G && O(G, t, r);
        } : O,
        $ = function $(e) {
          var t = z[e] = A(_I.prototype);
          return t._k = e, t;
        },
        X = V && "symbol" == typeof _I.iterator ? function (e) {
          return "symbol" == typeof e;
        } : function (e) {
          return e instanceof _I;
        },
        Y = function Y(e, t, n) {
          return e === G && Y(U, t, n), y(e), t = w(t, !0), y(n), i(z, t) ? (n.enumerable ? (i(e, L) && e[L][t] && (e[L][t] = !1), n = A(n, {
            enumerable: S(0, !1)
          })) : (i(e, L) || O(e, L, S(1, {})), e[L][t] = !0), W(e, t, n)) : O(e, t, n);
        },
        K = function K(e, t) {
          y(e);
          for (var n, r = g(t = x(t)), i = 0, o = r.length; o > i;) Y(e, n = r[i++], t[n]);
          return e;
        },
        Z = function Z(e) {
          var t = B.call(this, e = w(e, !0));
          return !(this === G && i(z, e) && !i(U, e)) && (!(t || !i(this, e) || !i(z, e) || i(this, L) && this[L][e]) || t);
        },
        Q = function Q(e, t) {
          if (e = x(e), t = w(t, !0), e !== G || !i(z, t) || i(U, t)) {
            var n = P(e, t);
            return !n || !i(z, t) || i(e, L) && e[L][t] || (n.enumerable = !0), n;
          }
        },
        J = function J(e) {
          for (var t, n = R(x(e)), r = [], o = 0; n.length > o;) i(z, t = n[o++]) || t == L || t == l || r.push(t);
          return r;
        },
        ee = function ee(e) {
          for (var t, n = e === G, r = R(n ? U : x(e)), o = [], a = 0; r.length > a;) !i(z, t = r[a++]) || n && !i(G, t) || o.push(z[t]);
          return o;
        };
      V || (s((_I = function I() {
        if (this instanceof _I) throw TypeError("Symbol is not a constructor!");
        var e = h(arguments.length > 0 ? arguments[0] : void 0),
          t = function t(n) {
            this === G && t.call(U, n), i(this, L) && i(this[L], e) && (this[L][e] = !1), W(this, e, S(1, n));
          };
        return o && q && W(G, e, {
          configurable: !0,
          set: t
        }), $(e);
      }).prototype, "toString", function () {
        return this._k;
      }), T.f = Q, C.f = Y, n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js").f = E.f = J, n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js").f = Z, M.f = ee, o && !n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js") && s(G, "propertyIsEnumerable", Z, !0), p.f = function (e) {
        return $(f(e));
      }), a(a.G + a.W + a.F * !V, {
        Symbol: _I
      });
      for (var te = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ne = 0; te.length > ne;) f(te[ne++]);
      for (var re = k(f.store), ie = 0; re.length > ie;) m(re[ie++]);
      a(a.S + a.F * !V, "Symbol", {
        for: function _for(e) {
          return i(F, e += "") ? F[e] : F[e] = _I(e);
        },
        keyFor: function keyFor(e) {
          if (!X(e)) throw TypeError(e + " is not a symbol!");
          for (var t in F) if (F[t] === e) return t;
        },
        useSetter: function useSetter() {
          q = !0;
        },
        useSimple: function useSimple() {
          q = !1;
        }
      }), a(a.S + a.F * !V, "Object", {
        create: function create(e, t) {
          return void 0 === t ? A(e) : K(A(e), t);
        },
        defineProperty: Y,
        defineProperties: K,
        getOwnPropertyDescriptor: Q,
        getOwnPropertyNames: J,
        getOwnPropertySymbols: ee
      });
      var oe = u(function () {
        M.f(1);
      });
      a(a.S + a.F * oe, "Object", {
        getOwnPropertySymbols: function getOwnPropertySymbols(e) {
          return M.f(_(e));
        }
      }), j && a(a.S + a.F * (!V || u(function () {
        var e = _I();
        return "[null]" != N([e]) || "{}" != N({
          a: e
        }) || "{}" != N(Object(e));
      })), "JSON", {
        stringify: function stringify(e) {
          for (var t, n, r = [e], i = 1; arguments.length > i;) r.push(arguments[i++]);
          if (n = t = r[1], (b(t) || void 0 !== e) && !X(e)) return v(t) || (t = function t(e, _t6) {
            if ("function" == typeof n && (_t6 = n.call(this, e, _t6)), !X(_t6)) return _t6;
          }), r[1] = t, N.apply(j, r);
        }
      }), _I.prototype[D] || n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js")(_I.prototype, D, _I.prototype.valueOf), d(_I, "Symbol"), d(Math, "Math", !0), d(r.JSON, "JSON", !0);
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs7SymbolAsyncIteratorJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js")("asyncIterator");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesEs7SymbolObservableJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js")("observable");
    },
    "./node_modules/babel-runtime/node_modules/core-js/library/modules/web.dom.iterable.js": function node_modulesBabelRuntimeNode_modulesCoreJsLibraryModulesWebDomIterableJs(e, t, n) {
      n("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.iterator.js");
      for (var r = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js"), i = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js"), o = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js"), a = n("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), l = 0; l < s.length; l++) {
        var u = s[l],
          c = r[u],
          d = c && c.prototype;
        d && !d[a] && i(d, a, u), o[u] = o.Array;
      }
    },
    "./node_modules/base64-js/index.js": function node_modulesBase64JsIndexJs(e, t, n) {
      "use strict";

      t.byteLength = function (e) {
        var t = u(e),
          n = t[0],
          r = t[1];
        return 3 * (n + r) / 4 - r;
      }, t.toByteArray = function (e) {
        var t,
          n,
          r = u(e),
          a = r[0],
          s = r[1],
          l = new o(function (e, t, n) {
            return 3 * (t + n) / 4 - n;
          }(0, a, s)),
          c = 0,
          d = s > 0 ? a - 4 : a;
        for (n = 0; n < d; n += 4) t = i[e.charCodeAt(n)] << 18 | i[e.charCodeAt(n + 1)] << 12 | i[e.charCodeAt(n + 2)] << 6 | i[e.charCodeAt(n + 3)], l[c++] = t >> 16 & 255, l[c++] = t >> 8 & 255, l[c++] = 255 & t;
        2 === s && (t = i[e.charCodeAt(n)] << 2 | i[e.charCodeAt(n + 1)] >> 4, l[c++] = 255 & t);
        1 === s && (t = i[e.charCodeAt(n)] << 10 | i[e.charCodeAt(n + 1)] << 4 | i[e.charCodeAt(n + 2)] >> 2, l[c++] = t >> 8 & 255, l[c++] = 255 & t);
        return l;
      }, t.fromByteArray = function (e) {
        for (var t, n = e.length, i = n % 3, o = [], a = 0, s = n - i; a < s; a += 16383) o.push(c(e, a, a + 16383 > s ? s : a + 16383));
        1 === i ? (t = e[n - 1], o.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], o.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
        return o.join("");
      };
      for (var r = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = a.length; s < l; ++s) r[s] = a[s], i[a.charCodeAt(s)] = s;
      function u(e) {
        var t = e.length;
        if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var n = e.indexOf("=");
        return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
      }
      function c(e, t, n) {
        for (var i, o, a = [], s = t; s < n; s += 3) i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
        return a.join("");
      }
      i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
    },
    "./node_modules/bn.js/lib/bn.js": function node_modulesBnJsLibBnJs(e, t, n) {
      (function (e) {
        !function (e, t) {
          "use strict";

          function r(e, t) {
            if (!e) throw new Error(t || "Assertion failed");
          }
          function i(e, t) {
            e.super_ = t;
            var n = function n() {};
            n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
          }
          function o(e, t, n) {
            if (o.isBN(e)) return e;
            this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
          }
          var a;
          "object" == typeof e ? e.exports = o : t.BN = o, o.BN = o, o.wordSize = 26;
          try {
            a = n(2).Buffer;
          } catch (e) {}
          function s(e, t, n) {
            for (var r = 0, i = Math.min(e.length, n), o = t; o < i; o++) {
              var a = e.charCodeAt(o) - 48;
              r <<= 4, r |= a >= 49 && a <= 54 ? a - 49 + 10 : a >= 17 && a <= 22 ? a - 17 + 10 : 15 & a;
            }
            return r;
          }
          function l(e, t, n, r) {
            for (var i = 0, o = Math.min(e.length, n), a = t; a < o; a++) {
              var s = e.charCodeAt(a) - 48;
              i *= r, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
            }
            return i;
          }
          o.isBN = function (e) {
            return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
          }, o.max = function (e, t) {
            return e.cmp(t) > 0 ? e : t;
          }, o.min = function (e, t) {
            return e.cmp(t) < 0 ? e : t;
          }, o.prototype._init = function (e, t, n) {
            if ("number" == typeof e) return this._initNumber(e, t, n);
            if ("object" == typeof e) return this._initArray(e, t, n);
            "hex" === t && (t = 16), r(t === (0 | t) && t >= 2 && t <= 36);
            var i = 0;
            "-" === (e = e.toString().replace(/\s+/g, ""))[0] && i++, 16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i), "-" === e[0] && (this.negative = 1), this.strip(), "le" === n && this._initArray(this.toArray(), t, n);
          }, o.prototype._initNumber = function (e, t, n) {
            e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (r(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === n && this._initArray(this.toArray(), t, n);
          }, o.prototype._initArray = function (e, t, n) {
            if (r("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
            this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
            for (var i = 0; i < this.length; i++) this.words[i] = 0;
            var o,
              a,
              s = 0;
            if ("be" === n) for (i = e.length - 1, o = 0; i >= 0; i -= 3) a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);else if ("le" === n) for (i = 0, o = 0; i < e.length; i += 3) a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
            return this.strip();
          }, o.prototype._parseHex = function (e, t) {
            this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
            for (var n = 0; n < this.length; n++) this.words[n] = 0;
            var r,
              i,
              o = 0;
            for (n = e.length - 6, r = 0; n >= t; n -= 6) i = s(e, n, n + 6), this.words[r] |= i << o & 67108863, this.words[r + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, r++);
            n + 6 !== t && (i = s(e, t, n + 6), this.words[r] |= i << o & 67108863, this.words[r + 1] |= i >>> 26 - o & 4194303), this.strip();
          }, o.prototype._parseBase = function (e, t, n) {
            this.words = [0], this.length = 1;
            for (var r = 0, i = 1; i <= 67108863; i *= t) r++;
            r--, i = i / t | 0;
            for (var o = e.length - n, a = o % r, s = Math.min(o, o - a) + n, u = 0, c = n; c < s; c += r) u = l(e, c, c + r, t), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            if (0 !== a) {
              var d = 1;
              for (u = l(e, c, e.length, t), c = 0; c < a; c++) d *= t;
              this.imuln(d), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
            }
          }, o.prototype.copy = function (e) {
            e.words = new Array(this.length);
            for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
            e.length = this.length, e.negative = this.negative, e.red = this.red;
          }, o.prototype.clone = function () {
            var e = new o(null);
            return this.copy(e), e;
          }, o.prototype._expand = function (e) {
            for (; this.length < e;) this.words[this.length++] = 0;
            return this;
          }, o.prototype.strip = function () {
            for (; this.length > 1 && 0 === this.words[this.length - 1];) this.length--;
            return this._normSign();
          }, o.prototype._normSign = function () {
            return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
          }, o.prototype.inspect = function () {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
          };
          var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
          function h(e, t, n) {
            n.negative = t.negative ^ e.negative;
            var r = e.length + t.length | 0;
            n.length = r, r = r - 1 | 0;
            var i = 0 | e.words[0],
              o = 0 | t.words[0],
              a = i * o,
              s = 67108863 & a,
              l = a / 67108864 | 0;
            n.words[0] = s;
            for (var u = 1; u < r; u++) {
              for (var c = l >>> 26, d = 67108863 & l, h = Math.min(u, t.length - 1), f = Math.max(0, u - e.length + 1); f <= h; f++) {
                var p = u - f | 0;
                c += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[f]) + d) / 67108864 | 0, d = 67108863 & a;
              }
              n.words[u] = 0 | d, l = 0 | c;
            }
            return 0 !== l ? n.words[u] = 0 | l : n.length--, n.strip();
          }
          o.prototype.toString = function (e, t) {
            var n;
            if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
              n = "";
              for (var i = 0, o = 0, a = 0; a < this.length; a++) {
                var s = this.words[a],
                  l = (16777215 & (s << i | o)).toString(16);
                n = 0 !== (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? u[6 - l.length] + l + n : l + n, (i += 2) >= 26 && (i -= 26, a--);
              }
              for (0 !== o && (n = o.toString(16) + n); n.length % t != 0;) n = "0" + n;
              return 0 !== this.negative && (n = "-" + n), n;
            }
            if (e === (0 | e) && e >= 2 && e <= 36) {
              var h = c[e],
                f = d[e];
              n = "";
              var p = this.clone();
              for (p.negative = 0; !p.isZero();) {
                var m = p.modn(f).toString(e);
                n = (p = p.idivn(f)).isZero() ? m + n : u[h - m.length] + m + n;
              }
              for (this.isZero() && (n = "0" + n); n.length % t != 0;) n = "0" + n;
              return 0 !== this.negative && (n = "-" + n), n;
            }
            r(!1, "Base should be between 2 and 36");
          }, o.prototype.toNumber = function () {
            var e = this.words[0];
            return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
          }, o.prototype.toJSON = function () {
            return this.toString(16);
          }, o.prototype.toBuffer = function (e, t) {
            return r(void 0 !== a), this.toArrayLike(a, e, t);
          }, o.prototype.toArray = function (e, t) {
            return this.toArrayLike(Array, e, t);
          }, o.prototype.toArrayLike = function (e, t, n) {
            var i = this.byteLength(),
              o = n || Math.max(1, i);
            r(i <= o, "byte array longer than desired length"), r(o > 0, "Requested array length <= 0"), this.strip();
            var a,
              s,
              l = "le" === t,
              u = new e(o),
              c = this.clone();
            if (l) {
              for (s = 0; !c.isZero(); s++) a = c.andln(255), c.iushrn(8), u[s] = a;
              for (; s < o; s++) u[s] = 0;
            } else {
              for (s = 0; s < o - i; s++) u[s] = 0;
              for (s = 0; !c.isZero(); s++) a = c.andln(255), c.iushrn(8), u[o - s - 1] = a;
            }
            return u;
          }, Math.clz32 ? o.prototype._countBits = function (e) {
            return 32 - Math.clz32(e);
          } : o.prototype._countBits = function (e) {
            var t = e,
              n = 0;
            return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
          }, o.prototype._zeroBits = function (e) {
            if (0 === e) return 26;
            var t = e,
              n = 0;
            return 0 == (8191 & t) && (n += 13, t >>>= 13), 0 == (127 & t) && (n += 7, t >>>= 7), 0 == (15 & t) && (n += 4, t >>>= 4), 0 == (3 & t) && (n += 2, t >>>= 2), 0 == (1 & t) && n++, n;
          }, o.prototype.bitLength = function () {
            var e = this.words[this.length - 1],
              t = this._countBits(e);
            return 26 * (this.length - 1) + t;
          }, o.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var e = 0, t = 0; t < this.length; t++) {
              var n = this._zeroBits(this.words[t]);
              if (e += n, 26 !== n) break;
            }
            return e;
          }, o.prototype.byteLength = function () {
            return Math.ceil(this.bitLength() / 8);
          }, o.prototype.toTwos = function (e) {
            return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
          }, o.prototype.fromTwos = function (e) {
            return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
          }, o.prototype.isNeg = function () {
            return 0 !== this.negative;
          }, o.prototype.neg = function () {
            return this.clone().ineg();
          }, o.prototype.ineg = function () {
            return this.isZero() || (this.negative ^= 1), this;
          }, o.prototype.iuor = function (e) {
            for (; this.length < e.length;) this.words[this.length++] = 0;
            for (var t = 0; t < e.length; t++) this.words[t] = this.words[t] | e.words[t];
            return this.strip();
          }, o.prototype.ior = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuor(e);
          }, o.prototype.or = function (e) {
            return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
          }, o.prototype.uor = function (e) {
            return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
          }, o.prototype.iuand = function (e) {
            var t;
            t = this.length > e.length ? e : this;
            for (var n = 0; n < t.length; n++) this.words[n] = this.words[n] & e.words[n];
            return this.length = t.length, this.strip();
          }, o.prototype.iand = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuand(e);
          }, o.prototype.and = function (e) {
            return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
          }, o.prototype.uand = function (e) {
            return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
          }, o.prototype.iuxor = function (e) {
            var t, n;
            this.length > e.length ? (t = this, n = e) : (t = e, n = this);
            for (var r = 0; r < n.length; r++) this.words[r] = t.words[r] ^ n.words[r];
            if (this !== t) for (; r < t.length; r++) this.words[r] = t.words[r];
            return this.length = t.length, this.strip();
          }, o.prototype.ixor = function (e) {
            return r(0 == (this.negative | e.negative)), this.iuxor(e);
          }, o.prototype.xor = function (e) {
            return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
          }, o.prototype.uxor = function (e) {
            return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
          }, o.prototype.inotn = function (e) {
            r("number" == typeof e && e >= 0);
            var t = 0 | Math.ceil(e / 26),
              n = e % 26;
            this._expand(t), n > 0 && t--;
            for (var i = 0; i < t; i++) this.words[i] = 67108863 & ~this.words[i];
            return n > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - n), this.strip();
          }, o.prototype.notn = function (e) {
            return this.clone().inotn(e);
          }, o.prototype.setn = function (e, t) {
            r("number" == typeof e && e >= 0);
            var n = e / 26 | 0,
              i = e % 26;
            return this._expand(n + 1), this.words[n] = t ? this.words[n] | 1 << i : this.words[n] & ~(1 << i), this.strip();
          }, o.prototype.iadd = function (e) {
            var t, n, r;
            if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
            if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
            this.length > e.length ? (n = this, r = e) : (n = e, r = this);
            for (var i = 0, o = 0; o < r.length; o++) t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
            for (; 0 !== i && o < n.length; o++) t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
            if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;else if (n !== this) for (; o < n.length; o++) this.words[o] = n.words[o];
            return this;
          }, o.prototype.add = function (e) {
            var t;
            return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
          }, o.prototype.isub = function (e) {
            if (0 !== e.negative) {
              e.negative = 0;
              var t = this.iadd(e);
              return e.negative = 1, t._normSign();
            }
            if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
            var n,
              r,
              i = this.cmp(e);
            if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
            i > 0 ? (n = this, r = e) : (n = e, r = this);
            for (var o = 0, a = 0; a < r.length; a++) o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
            for (; 0 !== o && a < n.length; a++) o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
            if (0 === o && a < n.length && n !== this) for (; a < n.length; a++) this.words[a] = n.words[a];
            return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this.strip();
          }, o.prototype.sub = function (e) {
            return this.clone().isub(e);
          };
          var f = function f(e, t, n) {
            var r,
              i,
              o,
              a = e.words,
              s = t.words,
              l = n.words,
              u = 0,
              c = 0 | a[0],
              d = 8191 & c,
              h = c >>> 13,
              f = 0 | a[1],
              p = 8191 & f,
              m = f >>> 13,
              g = 0 | a[2],
              v = 8191 & g,
              y = g >>> 13,
              b = 0 | a[3],
              _ = 8191 & b,
              x = b >>> 13,
              w = 0 | a[4],
              S = 8191 & w,
              A = w >>> 13,
              E = 0 | a[5],
              T = 8191 & E,
              M = E >>> 13,
              C = 0 | a[6],
              k = 8191 & C,
              P = C >>> 13,
              O = 0 | a[7],
              R = 8191 & O,
              I = O >>> 13,
              j = 0 | a[8],
              N = 8191 & j,
              L = j >>> 13,
              D = 0 | a[9],
              B = 8191 & D,
              F = D >>> 13,
              z = 0 | s[0],
              U = 8191 & z,
              G = z >>> 13,
              V = 0 | s[1],
              H = 8191 & V,
              q = V >>> 13,
              W = 0 | s[2],
              $ = 8191 & W,
              X = W >>> 13,
              Y = 0 | s[3],
              K = 8191 & Y,
              Z = Y >>> 13,
              Q = 0 | s[4],
              J = 8191 & Q,
              ee = Q >>> 13,
              te = 0 | s[5],
              ne = 8191 & te,
              re = te >>> 13,
              ie = 0 | s[6],
              oe = 8191 & ie,
              ae = ie >>> 13,
              se = 0 | s[7],
              le = 8191 & se,
              ue = se >>> 13,
              ce = 0 | s[8],
              de = 8191 & ce,
              he = ce >>> 13,
              fe = 0 | s[9],
              pe = 8191 & fe,
              me = fe >>> 13;
            n.negative = e.negative ^ t.negative, n.length = 19;
            var ge = (u + (r = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, G)) + Math.imul(h, U) | 0)) << 13) | 0;
            u = ((o = Math.imul(h, G)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, U), i = (i = Math.imul(p, G)) + Math.imul(m, U) | 0, o = Math.imul(m, G);
            var ve = (u + (r = r + Math.imul(d, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, q) | 0) + Math.imul(h, H) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, q) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(v, U), i = (i = Math.imul(v, G)) + Math.imul(y, U) | 0, o = Math.imul(y, G), r = r + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, q) | 0;
            var ye = (u + (r = r + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, X) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(_, U), i = (i = Math.imul(_, G)) + Math.imul(x, U) | 0, o = Math.imul(x, G), r = r + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, q) | 0) + Math.imul(y, H) | 0, o = o + Math.imul(y, q) | 0, r = r + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, X) | 0;
            var be = (u + (r = r + Math.imul(d, K) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(h, K) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, Z) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(S, U), i = (i = Math.imul(S, G)) + Math.imul(A, U) | 0, o = Math.imul(A, G), r = r + Math.imul(_, H) | 0, i = (i = i + Math.imul(_, q) | 0) + Math.imul(x, H) | 0, o = o + Math.imul(x, q) | 0, r = r + Math.imul(v, $) | 0, i = (i = i + Math.imul(v, X) | 0) + Math.imul(y, $) | 0, o = o + Math.imul(y, X) | 0, r = r + Math.imul(p, K) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(m, K) | 0, o = o + Math.imul(m, Z) | 0;
            var _e = (u + (r = r + Math.imul(d, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, J) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(T, U), i = (i = Math.imul(T, G)) + Math.imul(M, U) | 0, o = Math.imul(M, G), r = r + Math.imul(S, H) | 0, i = (i = i + Math.imul(S, q) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, q) | 0, r = r + Math.imul(_, $) | 0, i = (i = i + Math.imul(_, X) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, X) | 0, r = r + Math.imul(v, K) | 0, i = (i = i + Math.imul(v, Z) | 0) + Math.imul(y, K) | 0, o = o + Math.imul(y, Z) | 0, r = r + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, J) | 0, o = o + Math.imul(m, ee) | 0;
            var xe = (u + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(h, ne) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, re) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(k, U), i = (i = Math.imul(k, G)) + Math.imul(P, U) | 0, o = Math.imul(P, G), r = r + Math.imul(T, H) | 0, i = (i = i + Math.imul(T, q) | 0) + Math.imul(M, H) | 0, o = o + Math.imul(M, q) | 0, r = r + Math.imul(S, $) | 0, i = (i = i + Math.imul(S, X) | 0) + Math.imul(A, $) | 0, o = o + Math.imul(A, X) | 0, r = r + Math.imul(_, K) | 0, i = (i = i + Math.imul(_, Z) | 0) + Math.imul(x, K) | 0, o = o + Math.imul(x, Z) | 0, r = r + Math.imul(v, J) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(y, J) | 0, o = o + Math.imul(y, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
            var we = (u + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(R, U), i = (i = Math.imul(R, G)) + Math.imul(I, U) | 0, o = Math.imul(I, G), r = r + Math.imul(k, H) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(P, H) | 0, o = o + Math.imul(P, q) | 0, r = r + Math.imul(T, $) | 0, i = (i = i + Math.imul(T, X) | 0) + Math.imul(M, $) | 0, o = o + Math.imul(M, X) | 0, r = r + Math.imul(S, K) | 0, i = (i = i + Math.imul(S, Z) | 0) + Math.imul(A, K) | 0, o = o + Math.imul(A, Z) | 0, r = r + Math.imul(_, J) | 0, i = (i = i + Math.imul(_, ee) | 0) + Math.imul(x, J) | 0, o = o + Math.imul(x, ee) | 0, r = r + Math.imul(v, ne) | 0, i = (i = i + Math.imul(v, re) | 0) + Math.imul(y, ne) | 0, o = o + Math.imul(y, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
            var Se = (u + (r = r + Math.imul(d, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ue) | 0) + Math.imul(h, le) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, ue) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(N, U), i = (i = Math.imul(N, G)) + Math.imul(L, U) | 0, o = Math.imul(L, G), r = r + Math.imul(R, H) | 0, i = (i = i + Math.imul(R, q) | 0) + Math.imul(I, H) | 0, o = o + Math.imul(I, q) | 0, r = r + Math.imul(k, $) | 0, i = (i = i + Math.imul(k, X) | 0) + Math.imul(P, $) | 0, o = o + Math.imul(P, X) | 0, r = r + Math.imul(T, K) | 0, i = (i = i + Math.imul(T, Z) | 0) + Math.imul(M, K) | 0, o = o + Math.imul(M, Z) | 0, r = r + Math.imul(S, J) | 0, i = (i = i + Math.imul(S, ee) | 0) + Math.imul(A, J) | 0, o = o + Math.imul(A, ee) | 0, r = r + Math.imul(_, ne) | 0, i = (i = i + Math.imul(_, re) | 0) + Math.imul(x, ne) | 0, o = o + Math.imul(x, re) | 0, r = r + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(y, oe) | 0, o = o + Math.imul(y, ae) | 0, r = r + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ue) | 0) + Math.imul(m, le) | 0, o = o + Math.imul(m, ue) | 0;
            var Ae = (u + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(B, U), i = (i = Math.imul(B, G)) + Math.imul(F, U) | 0, o = Math.imul(F, G), r = r + Math.imul(N, H) | 0, i = (i = i + Math.imul(N, q) | 0) + Math.imul(L, H) | 0, o = o + Math.imul(L, q) | 0, r = r + Math.imul(R, $) | 0, i = (i = i + Math.imul(R, X) | 0) + Math.imul(I, $) | 0, o = o + Math.imul(I, X) | 0, r = r + Math.imul(k, K) | 0, i = (i = i + Math.imul(k, Z) | 0) + Math.imul(P, K) | 0, o = o + Math.imul(P, Z) | 0, r = r + Math.imul(T, J) | 0, i = (i = i + Math.imul(T, ee) | 0) + Math.imul(M, J) | 0, o = o + Math.imul(M, ee) | 0, r = r + Math.imul(S, ne) | 0, i = (i = i + Math.imul(S, re) | 0) + Math.imul(A, ne) | 0, o = o + Math.imul(A, re) | 0, r = r + Math.imul(_, oe) | 0, i = (i = i + Math.imul(_, ae) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, ae) | 0, r = r + Math.imul(v, le) | 0, i = (i = i + Math.imul(v, ue) | 0) + Math.imul(y, le) | 0, o = o + Math.imul(y, ue) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, he) | 0;
            var Ee = (u + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(h, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(B, H), i = (i = Math.imul(B, q)) + Math.imul(F, H) | 0, o = Math.imul(F, q), r = r + Math.imul(N, $) | 0, i = (i = i + Math.imul(N, X) | 0) + Math.imul(L, $) | 0, o = o + Math.imul(L, X) | 0, r = r + Math.imul(R, K) | 0, i = (i = i + Math.imul(R, Z) | 0) + Math.imul(I, K) | 0, o = o + Math.imul(I, Z) | 0, r = r + Math.imul(k, J) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(P, J) | 0, o = o + Math.imul(P, ee) | 0, r = r + Math.imul(T, ne) | 0, i = (i = i + Math.imul(T, re) | 0) + Math.imul(M, ne) | 0, o = o + Math.imul(M, re) | 0, r = r + Math.imul(S, oe) | 0, i = (i = i + Math.imul(S, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, r = r + Math.imul(_, le) | 0, i = (i = i + Math.imul(_, ue) | 0) + Math.imul(x, le) | 0, o = o + Math.imul(x, ue) | 0, r = r + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, he) | 0) + Math.imul(y, de) | 0, o = o + Math.imul(y, he) | 0;
            var Te = (u + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(B, $), i = (i = Math.imul(B, X)) + Math.imul(F, $) | 0, o = Math.imul(F, X), r = r + Math.imul(N, K) | 0, i = (i = i + Math.imul(N, Z) | 0) + Math.imul(L, K) | 0, o = o + Math.imul(L, Z) | 0, r = r + Math.imul(R, J) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(I, J) | 0, o = o + Math.imul(I, ee) | 0, r = r + Math.imul(k, ne) | 0, i = (i = i + Math.imul(k, re) | 0) + Math.imul(P, ne) | 0, o = o + Math.imul(P, re) | 0, r = r + Math.imul(T, oe) | 0, i = (i = i + Math.imul(T, ae) | 0) + Math.imul(M, oe) | 0, o = o + Math.imul(M, ae) | 0, r = r + Math.imul(S, le) | 0, i = (i = i + Math.imul(S, ue) | 0) + Math.imul(A, le) | 0, o = o + Math.imul(A, ue) | 0, r = r + Math.imul(_, de) | 0, i = (i = i + Math.imul(_, he) | 0) + Math.imul(x, de) | 0, o = o + Math.imul(x, he) | 0;
            var Me = (u + (r = r + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(B, K), i = (i = Math.imul(B, Z)) + Math.imul(F, K) | 0, o = Math.imul(F, Z), r = r + Math.imul(N, J) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(L, J) | 0, o = o + Math.imul(L, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(I, ne) | 0, o = o + Math.imul(I, re) | 0, r = r + Math.imul(k, oe) | 0, i = (i = i + Math.imul(k, ae) | 0) + Math.imul(P, oe) | 0, o = o + Math.imul(P, ae) | 0, r = r + Math.imul(T, le) | 0, i = (i = i + Math.imul(T, ue) | 0) + Math.imul(M, le) | 0, o = o + Math.imul(M, ue) | 0, r = r + Math.imul(S, de) | 0, i = (i = i + Math.imul(S, he) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, he) | 0;
            var Ce = (u + (r = r + Math.imul(_, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, me) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(x, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(B, J), i = (i = Math.imul(B, ee)) + Math.imul(F, J) | 0, o = Math.imul(F, ee), r = r + Math.imul(N, ne) | 0, i = (i = i + Math.imul(N, re) | 0) + Math.imul(L, ne) | 0, o = o + Math.imul(L, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, r = r + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ue) | 0) + Math.imul(P, le) | 0, o = o + Math.imul(P, ue) | 0, r = r + Math.imul(T, de) | 0, i = (i = i + Math.imul(T, he) | 0) + Math.imul(M, de) | 0, o = o + Math.imul(M, he) | 0;
            var ke = (u + (r = r + Math.imul(S, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(S, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(B, ne), i = (i = Math.imul(B, re)) + Math.imul(F, ne) | 0, o = Math.imul(F, re), r = r + Math.imul(N, oe) | 0, i = (i = i + Math.imul(N, ae) | 0) + Math.imul(L, oe) | 0, o = o + Math.imul(L, ae) | 0, r = r + Math.imul(R, le) | 0, i = (i = i + Math.imul(R, ue) | 0) + Math.imul(I, le) | 0, o = o + Math.imul(I, ue) | 0, r = r + Math.imul(k, de) | 0, i = (i = i + Math.imul(k, he) | 0) + Math.imul(P, de) | 0, o = o + Math.imul(P, he) | 0;
            var Pe = (u + (r = r + Math.imul(T, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(T, me) | 0) + Math.imul(M, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(M, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, r = Math.imul(B, oe), i = (i = Math.imul(B, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), r = r + Math.imul(N, le) | 0, i = (i = i + Math.imul(N, ue) | 0) + Math.imul(L, le) | 0, o = o + Math.imul(L, ue) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, he) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, he) | 0;
            var Oe = (u + (r = r + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(P, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, r = Math.imul(B, le), i = (i = Math.imul(B, ue)) + Math.imul(F, le) | 0, o = Math.imul(F, ue), r = r + Math.imul(N, de) | 0, i = (i = i + Math.imul(N, he) | 0) + Math.imul(L, de) | 0, o = o + Math.imul(L, he) | 0;
            var Re = (u + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(B, de), i = (i = Math.imul(B, he)) + Math.imul(F, de) | 0, o = Math.imul(F, he);
            var Ie = (u + (r = r + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, me) | 0) + Math.imul(L, pe) | 0)) << 13) | 0;
            u = ((o = o + Math.imul(L, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
            var je = (u + (r = Math.imul(B, pe)) | 0) + ((8191 & (i = (i = Math.imul(B, me)) + Math.imul(F, pe) | 0)) << 13) | 0;
            return u = ((o = Math.imul(F, me)) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, l[0] = ge, l[1] = ve, l[2] = ye, l[3] = be, l[4] = _e, l[5] = xe, l[6] = we, l[7] = Se, l[8] = Ae, l[9] = Ee, l[10] = Te, l[11] = Me, l[12] = Ce, l[13] = ke, l[14] = Pe, l[15] = Oe, l[16] = Re, l[17] = Ie, l[18] = je, 0 !== u && (l[19] = u, n.length++), n;
          };
          function p(e, t, n) {
            return new m().mulp(e, t, n);
          }
          function m(e, t) {
            this.x = e, this.y = t;
          }
          Math.imul || (f = h), o.prototype.mulTo = function (e, t) {
            var n = this.length + e.length;
            return 10 === this.length && 10 === e.length ? f(this, e, t) : n < 63 ? h(this, e, t) : n < 1024 ? function (e, t, n) {
              n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
              for (var r = 0, i = 0, o = 0; o < n.length - 1; o++) {
                var a = i;
                i = 0;
                for (var s = 67108863 & r, l = Math.min(o, t.length - 1), u = Math.max(0, o - e.length + 1); u <= l; u++) {
                  var c = o - u,
                    d = (0 | e.words[c]) * (0 | t.words[u]),
                    h = 67108863 & d;
                  s = 67108863 & (h = h + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
                }
                n.words[o] = s, r = a, a = i;
              }
              return 0 !== r ? n.words[o] = r : n.length--, n.strip();
            }(this, e, t) : p(this, e, t);
          }, m.prototype.makeRBT = function (e) {
            for (var t = new Array(e), n = o.prototype._countBits(e) - 1, r = 0; r < e; r++) t[r] = this.revBin(r, n, e);
            return t;
          }, m.prototype.revBin = function (e, t, n) {
            if (0 === e || e === n - 1) return e;
            for (var r = 0, i = 0; i < t; i++) r |= (1 & e) << t - i - 1, e >>= 1;
            return r;
          }, m.prototype.permute = function (e, t, n, r, i, o) {
            for (var a = 0; a < o; a++) r[a] = t[e[a]], i[a] = n[e[a]];
          }, m.prototype.transform = function (e, t, n, r, i, o) {
            this.permute(o, e, t, n, r, i);
            for (var a = 1; a < i; a <<= 1) for (var s = a << 1, l = Math.cos(2 * Math.PI / s), u = Math.sin(2 * Math.PI / s), c = 0; c < i; c += s) for (var d = l, h = u, f = 0; f < a; f++) {
              var p = n[c + f],
                m = r[c + f],
                g = n[c + f + a],
                v = r[c + f + a],
                y = d * g - h * v;
              v = d * v + h * g, g = y, n[c + f] = p + g, r[c + f] = m + v, n[c + f + a] = p - g, r[c + f + a] = m - v, f !== s && (y = l * d - u * h, h = l * h + u * d, d = y);
            }
          }, m.prototype.guessLen13b = function (e, t) {
            var n = 1 | Math.max(t, e),
              r = 1 & n,
              i = 0;
            for (n = n / 2 | 0; n; n >>>= 1) i++;
            return 1 << i + 1 + r;
          }, m.prototype.conjugate = function (e, t, n) {
            if (!(n <= 1)) for (var r = 0; r < n / 2; r++) {
              var i = e[r];
              e[r] = e[n - r - 1], e[n - r - 1] = i, i = t[r], t[r] = -t[n - r - 1], t[n - r - 1] = -i;
            }
          }, m.prototype.normalize13b = function (e, t) {
            for (var n = 0, r = 0; r < t / 2; r++) {
              var i = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + n;
              e[r] = 67108863 & i, n = i < 67108864 ? 0 : i / 67108864 | 0;
            }
            return e;
          }, m.prototype.convert13b = function (e, t, n, i) {
            for (var o = 0, a = 0; a < t; a++) o += 0 | e[a], n[2 * a] = 8191 & o, o >>>= 13, n[2 * a + 1] = 8191 & o, o >>>= 13;
            for (a = 2 * t; a < i; ++a) n[a] = 0;
            r(0 === o), r(0 == (-8192 & o));
          }, m.prototype.stub = function (e) {
            for (var t = new Array(e), n = 0; n < e; n++) t[n] = 0;
            return t;
          }, m.prototype.mulp = function (e, t, n) {
            var r = 2 * this.guessLen13b(e.length, t.length),
              i = this.makeRBT(r),
              o = this.stub(r),
              a = new Array(r),
              s = new Array(r),
              l = new Array(r),
              u = new Array(r),
              c = new Array(r),
              d = new Array(r),
              h = n.words;
            h.length = r, this.convert13b(e.words, e.length, a, r), this.convert13b(t.words, t.length, u, r), this.transform(a, o, s, l, r, i), this.transform(u, o, c, d, r, i);
            for (var f = 0; f < r; f++) {
              var p = s[f] * c[f] - l[f] * d[f];
              l[f] = s[f] * d[f] + l[f] * c[f], s[f] = p;
            }
            return this.conjugate(s, l, r), this.transform(s, l, h, o, r, i), this.conjugate(h, o, r), this.normalize13b(h, r), n.negative = e.negative ^ t.negative, n.length = e.length + t.length, n.strip();
          }, o.prototype.mul = function (e) {
            var t = new o(null);
            return t.words = new Array(this.length + e.length), this.mulTo(e, t);
          }, o.prototype.mulf = function (e) {
            var t = new o(null);
            return t.words = new Array(this.length + e.length), p(this, e, t);
          }, o.prototype.imul = function (e) {
            return this.clone().mulTo(e, this);
          }, o.prototype.imuln = function (e) {
            r("number" == typeof e), r(e < 67108864);
            for (var t = 0, n = 0; n < this.length; n++) {
              var i = (0 | this.words[n]) * e,
                o = (67108863 & i) + (67108863 & t);
              t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[n] = 67108863 & o;
            }
            return 0 !== t && (this.words[n] = t, this.length++), this;
          }, o.prototype.muln = function (e) {
            return this.clone().imuln(e);
          }, o.prototype.sqr = function () {
            return this.mul(this);
          }, o.prototype.isqr = function () {
            return this.imul(this.clone());
          }, o.prototype.pow = function (e) {
            var t = function (e) {
              for (var t = new Array(e.bitLength()), n = 0; n < t.length; n++) {
                var r = n / 26 | 0,
                  i = n % 26;
                t[n] = (e.words[r] & 1 << i) >>> i;
              }
              return t;
            }(e);
            if (0 === t.length) return new o(1);
            for (var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
            if (++r < t.length) for (var i = n.sqr(); r < t.length; r++, i = i.sqr()) 0 !== t[r] && (n = n.mul(i));
            return n;
          }, o.prototype.iushln = function (e) {
            r("number" == typeof e && e >= 0);
            var t,
              n = e % 26,
              i = (e - n) / 26,
              o = 67108863 >>> 26 - n << 26 - n;
            if (0 !== n) {
              var a = 0;
              for (t = 0; t < this.length; t++) {
                var s = this.words[t] & o,
                  l = (0 | this.words[t]) - s << n;
                this.words[t] = l | a, a = s >>> 26 - n;
              }
              a && (this.words[t] = a, this.length++);
            }
            if (0 !== i) {
              for (t = this.length - 1; t >= 0; t--) this.words[t + i] = this.words[t];
              for (t = 0; t < i; t++) this.words[t] = 0;
              this.length += i;
            }
            return this.strip();
          }, o.prototype.ishln = function (e) {
            return r(0 === this.negative), this.iushln(e);
          }, o.prototype.iushrn = function (e, t, n) {
            var i;
            r("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
            var o = e % 26,
              a = Math.min((e - o) / 26, this.length),
              s = 67108863 ^ 67108863 >>> o << o,
              l = n;
            if (i -= a, i = Math.max(0, i), l) {
              for (var u = 0; u < a; u++) l.words[u] = this.words[u];
              l.length = a;
            }
            if (0 === a) ;else if (this.length > a) for (this.length -= a, u = 0; u < this.length; u++) this.words[u] = this.words[u + a];else this.words[0] = 0, this.length = 1;
            var c = 0;
            for (u = this.length - 1; u >= 0 && (0 !== c || u >= i); u--) {
              var d = 0 | this.words[u];
              this.words[u] = c << 26 - o | d >>> o, c = d & s;
            }
            return l && 0 !== c && (l.words[l.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
          }, o.prototype.ishrn = function (e, t, n) {
            return r(0 === this.negative), this.iushrn(e, t, n);
          }, o.prototype.shln = function (e) {
            return this.clone().ishln(e);
          }, o.prototype.ushln = function (e) {
            return this.clone().iushln(e);
          }, o.prototype.shrn = function (e) {
            return this.clone().ishrn(e);
          }, o.prototype.ushrn = function (e) {
            return this.clone().iushrn(e);
          }, o.prototype.testn = function (e) {
            r("number" == typeof e && e >= 0);
            var t = e % 26,
              n = (e - t) / 26,
              i = 1 << t;
            return !(this.length <= n) && !!(this.words[n] & i);
          }, o.prototype.imaskn = function (e) {
            r("number" == typeof e && e >= 0);
            var t = e % 26,
              n = (e - t) / 26;
            if (r(0 === this.negative, "imaskn works only with positive numbers"), this.length <= n) return this;
            if (0 !== t && n++, this.length = Math.min(n, this.length), 0 !== t) {
              var i = 67108863 ^ 67108863 >>> t << t;
              this.words[this.length - 1] &= i;
            }
            return this.strip();
          }, o.prototype.maskn = function (e) {
            return this.clone().imaskn(e);
          }, o.prototype.iaddn = function (e) {
            return r("number" == typeof e), r(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
          }, o.prototype._iaddn = function (e) {
            this.words[0] += e;
            for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
            return this.length = Math.max(this.length, t + 1), this;
          }, o.prototype.isubn = function (e) {
            if (r("number" == typeof e), r(e < 67108864), e < 0) return this.iaddn(-e);
            if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
            if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) this.words[t] += 67108864, this.words[t + 1] -= 1;
            return this.strip();
          }, o.prototype.addn = function (e) {
            return this.clone().iaddn(e);
          }, o.prototype.subn = function (e) {
            return this.clone().isubn(e);
          }, o.prototype.iabs = function () {
            return this.negative = 0, this;
          }, o.prototype.abs = function () {
            return this.clone().iabs();
          }, o.prototype._ishlnsubmul = function (e, t, n) {
            var i,
              o,
              a = e.length + n;
            this._expand(a);
            var s = 0;
            for (i = 0; i < e.length; i++) {
              o = (0 | this.words[i + n]) + s;
              var l = (0 | e.words[i]) * t;
              s = ((o -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + n] = 67108863 & o;
            }
            for (; i < this.length - n; i++) s = (o = (0 | this.words[i + n]) + s) >> 26, this.words[i + n] = 67108863 & o;
            if (0 === s) return this.strip();
            for (r(-1 === s), s = 0, i = 0; i < this.length; i++) s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
            return this.negative = 1, this.strip();
          }, o.prototype._wordDiv = function (e, t) {
            var n = (this.length, e.length),
              r = this.clone(),
              i = e,
              a = 0 | i.words[i.length - 1];
            0 !== (n = 26 - this._countBits(a)) && (i = i.ushln(n), r.iushln(n), a = 0 | i.words[i.length - 1]);
            var s,
              l = r.length - i.length;
            if ("mod" !== t) {
              (s = new o(null)).length = l + 1, s.words = new Array(s.length);
              for (var u = 0; u < s.length; u++) s.words[u] = 0;
            }
            var c = r.clone()._ishlnsubmul(i, 1, l);
            0 === c.negative && (r = c, s && (s.words[l] = 1));
            for (var d = l - 1; d >= 0; d--) {
              var h = 67108864 * (0 | r.words[i.length + d]) + (0 | r.words[i.length + d - 1]);
              for (h = Math.min(h / a | 0, 67108863), r._ishlnsubmul(i, h, d); 0 !== r.negative;) h--, r.negative = 0, r._ishlnsubmul(i, 1, d), r.isZero() || (r.negative ^= 1);
              s && (s.words[d] = h);
            }
            return s && s.strip(), r.strip(), "div" !== t && 0 !== n && r.iushrn(n), {
              div: s || null,
              mod: r
            };
          }, o.prototype.divmod = function (e, t, n) {
            return r(!e.isZero()), this.isZero() ? {
              div: new o(0),
              mod: new o(0)
            } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (i = s.div.neg()), "div" !== t && (a = s.mod.neg(), n && 0 !== a.negative && a.iadd(e)), {
              div: i,
              mod: a
            }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (i = s.div.neg()), {
              div: i,
              mod: s.mod
            }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), n && 0 !== a.negative && a.isub(e)), {
              div: s.div,
              mod: a
            }) : e.length > this.length || this.cmp(e) < 0 ? {
              div: new o(0),
              mod: this
            } : 1 === e.length ? "div" === t ? {
              div: this.divn(e.words[0]),
              mod: null
            } : "mod" === t ? {
              div: null,
              mod: new o(this.modn(e.words[0]))
            } : {
              div: this.divn(e.words[0]),
              mod: new o(this.modn(e.words[0]))
            } : this._wordDiv(e, t);
            var i, a, s;
          }, o.prototype.div = function (e) {
            return this.divmod(e, "div", !1).div;
          }, o.prototype.mod = function (e) {
            return this.divmod(e, "mod", !1).mod;
          }, o.prototype.umod = function (e) {
            return this.divmod(e, "mod", !0).mod;
          }, o.prototype.divRound = function (e) {
            var t = this.divmod(e);
            if (t.mod.isZero()) return t.div;
            var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
              r = e.ushrn(1),
              i = e.andln(1),
              o = n.cmp(r);
            return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
          }, o.prototype.modn = function (e) {
            r(e <= 67108863);
            for (var t = (1 << 26) % e, n = 0, i = this.length - 1; i >= 0; i--) n = (t * n + (0 | this.words[i])) % e;
            return n;
          }, o.prototype.idivn = function (e) {
            r(e <= 67108863);
            for (var t = 0, n = this.length - 1; n >= 0; n--) {
              var i = (0 | this.words[n]) + 67108864 * t;
              this.words[n] = i / e | 0, t = i % e;
            }
            return this.strip();
          }, o.prototype.divn = function (e) {
            return this.clone().idivn(e);
          }, o.prototype.egcd = function (e) {
            r(0 === e.negative), r(!e.isZero());
            var t = this,
              n = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();
            for (var i = new o(1), a = new o(0), s = new o(0), l = new o(1), u = 0; t.isEven() && n.isEven();) t.iushrn(1), n.iushrn(1), ++u;
            for (var c = n.clone(), d = t.clone(); !t.isZero();) {
              for (var h = 0, f = 1; 0 == (t.words[0] & f) && h < 26; ++h, f <<= 1);
              if (h > 0) for (t.iushrn(h); h-- > 0;) (i.isOdd() || a.isOdd()) && (i.iadd(c), a.isub(d)), i.iushrn(1), a.iushrn(1);
              for (var p = 0, m = 1; 0 == (n.words[0] & m) && p < 26; ++p, m <<= 1);
              if (p > 0) for (n.iushrn(p); p-- > 0;) (s.isOdd() || l.isOdd()) && (s.iadd(c), l.isub(d)), s.iushrn(1), l.iushrn(1);
              t.cmp(n) >= 0 ? (t.isub(n), i.isub(s), a.isub(l)) : (n.isub(t), s.isub(i), l.isub(a));
            }
            return {
              a: s,
              b: l,
              gcd: n.iushln(u)
            };
          }, o.prototype._invmp = function (e) {
            r(0 === e.negative), r(!e.isZero());
            var t = this,
              n = e.clone();
            t = 0 !== t.negative ? t.umod(e) : t.clone();
            for (var i, a = new o(1), s = new o(0), l = n.clone(); t.cmpn(1) > 0 && n.cmpn(1) > 0;) {
              for (var u = 0, c = 1; 0 == (t.words[0] & c) && u < 26; ++u, c <<= 1);
              if (u > 0) for (t.iushrn(u); u-- > 0;) a.isOdd() && a.iadd(l), a.iushrn(1);
              for (var d = 0, h = 1; 0 == (n.words[0] & h) && d < 26; ++d, h <<= 1);
              if (d > 0) for (n.iushrn(d); d-- > 0;) s.isOdd() && s.iadd(l), s.iushrn(1);
              t.cmp(n) >= 0 ? (t.isub(n), a.isub(s)) : (n.isub(t), s.isub(a));
            }
            return (i = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && i.iadd(e), i;
          }, o.prototype.gcd = function (e) {
            if (this.isZero()) return e.abs();
            if (e.isZero()) return this.abs();
            var t = this.clone(),
              n = e.clone();
            t.negative = 0, n.negative = 0;
            for (var r = 0; t.isEven() && n.isEven(); r++) t.iushrn(1), n.iushrn(1);
            for (;;) {
              for (; t.isEven();) t.iushrn(1);
              for (; n.isEven();) n.iushrn(1);
              var i = t.cmp(n);
              if (i < 0) {
                var o = t;
                t = n, n = o;
              } else if (0 === i || 0 === n.cmpn(1)) break;
              t.isub(n);
            }
            return n.iushln(r);
          }, o.prototype.invm = function (e) {
            return this.egcd(e).a.umod(e);
          }, o.prototype.isEven = function () {
            return 0 == (1 & this.words[0]);
          }, o.prototype.isOdd = function () {
            return 1 == (1 & this.words[0]);
          }, o.prototype.andln = function (e) {
            return this.words[0] & e;
          }, o.prototype.bincn = function (e) {
            r("number" == typeof e);
            var t = e % 26,
              n = (e - t) / 26,
              i = 1 << t;
            if (this.length <= n) return this._expand(n + 1), this.words[n] |= i, this;
            for (var o = i, a = n; 0 !== o && a < this.length; a++) {
              var s = 0 | this.words[a];
              o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
            }
            return 0 !== o && (this.words[a] = o, this.length++), this;
          }, o.prototype.isZero = function () {
            return 1 === this.length && 0 === this.words[0];
          }, o.prototype.cmpn = function (e) {
            var t,
              n = e < 0;
            if (0 !== this.negative && !n) return -1;
            if (0 === this.negative && n) return 1;
            if (this.strip(), this.length > 1) t = 1;else {
              n && (e = -e), r(e <= 67108863, "Number is too big");
              var i = 0 | this.words[0];
              t = i === e ? 0 : i < e ? -1 : 1;
            }
            return 0 !== this.negative ? 0 | -t : t;
          }, o.prototype.cmp = function (e) {
            if (0 !== this.negative && 0 === e.negative) return -1;
            if (0 === this.negative && 0 !== e.negative) return 1;
            var t = this.ucmp(e);
            return 0 !== this.negative ? 0 | -t : t;
          }, o.prototype.ucmp = function (e) {
            if (this.length > e.length) return 1;
            if (this.length < e.length) return -1;
            for (var t = 0, n = this.length - 1; n >= 0; n--) {
              var r = 0 | this.words[n],
                i = 0 | e.words[n];
              if (r !== i) {
                r < i ? t = -1 : r > i && (t = 1);
                break;
              }
            }
            return t;
          }, o.prototype.gtn = function (e) {
            return 1 === this.cmpn(e);
          }, o.prototype.gt = function (e) {
            return 1 === this.cmp(e);
          }, o.prototype.gten = function (e) {
            return this.cmpn(e) >= 0;
          }, o.prototype.gte = function (e) {
            return this.cmp(e) >= 0;
          }, o.prototype.ltn = function (e) {
            return -1 === this.cmpn(e);
          }, o.prototype.lt = function (e) {
            return -1 === this.cmp(e);
          }, o.prototype.lten = function (e) {
            return this.cmpn(e) <= 0;
          }, o.prototype.lte = function (e) {
            return this.cmp(e) <= 0;
          }, o.prototype.eqn = function (e) {
            return 0 === this.cmpn(e);
          }, o.prototype.eq = function (e) {
            return 0 === this.cmp(e);
          }, o.red = function (e) {
            return new w(e);
          }, o.prototype.toRed = function (e) {
            return r(!this.red, "Already a number in reduction context"), r(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
          }, o.prototype.fromRed = function () {
            return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
          }, o.prototype._forceRed = function (e) {
            return this.red = e, this;
          }, o.prototype.forceRed = function (e) {
            return r(!this.red, "Already a number in reduction context"), this._forceRed(e);
          }, o.prototype.redAdd = function (e) {
            return r(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
          }, o.prototype.redIAdd = function (e) {
            return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
          }, o.prototype.redSub = function (e) {
            return r(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
          }, o.prototype.redISub = function (e) {
            return r(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
          }, o.prototype.redShl = function (e) {
            return r(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
          }, o.prototype.redMul = function (e) {
            return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
          }, o.prototype.redIMul = function (e) {
            return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
          }, o.prototype.redSqr = function () {
            return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
          }, o.prototype.redISqr = function () {
            return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
          }, o.prototype.redSqrt = function () {
            return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
          }, o.prototype.redInvm = function () {
            return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
          }, o.prototype.redNeg = function () {
            return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
          }, o.prototype.redPow = function (e) {
            return r(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
          };
          var g = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
          };
          function v(e, t) {
            this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
          }
          function y() {
            v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
          }
          function b() {
            v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          function _() {
            v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          function x() {
            v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
          }
          function w(e) {
            if ("string" == typeof e) {
              var t = o._prime(e);
              this.m = t.p, this.prime = t;
            } else r(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
          }
          function S(e) {
            w.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
          }
          v.prototype._tmp = function () {
            var e = new o(null);
            return e.words = new Array(Math.ceil(this.n / 13)), e;
          }, v.prototype.ireduce = function (e) {
            var t,
              n = e;
            do {
              this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
            } while (t > this.n);
            var r = t < this.n ? -1 : n.ucmp(this.p);
            return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : n.strip(), n;
          }, v.prototype.split = function (e, t) {
            e.iushrn(this.n, 0, t);
          }, v.prototype.imulK = function (e) {
            return e.imul(this.k);
          }, i(y, v), y.prototype.split = function (e, t) {
            for (var n = Math.min(e.length, 9), r = 0; r < n; r++) t.words[r] = e.words[r];
            if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
            var i = e.words[9];
            for (t.words[t.length++] = 4194303 & i, r = 10; r < e.length; r++) {
              var o = 0 | e.words[r];
              e.words[r - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
            }
            i >>>= 22, e.words[r - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
          }, y.prototype.imulK = function (e) {
            e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
            for (var t = 0, n = 0; n < e.length; n++) {
              var r = 0 | e.words[n];
              t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
            }
            return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
          }, i(b, v), i(_, v), i(x, v), x.prototype.imulK = function (e) {
            for (var t = 0, n = 0; n < e.length; n++) {
              var r = 19 * (0 | e.words[n]) + t,
                i = 67108863 & r;
              r >>>= 26, e.words[n] = i, t = r;
            }
            return 0 !== t && (e.words[e.length++] = t), e;
          }, o._prime = function (e) {
            if (g[e]) return g[e];
            var t;
            if ("k256" === e) t = new y();else if ("p224" === e) t = new b();else if ("p192" === e) t = new _();else {
              if ("p25519" !== e) throw new Error("Unknown prime " + e);
              t = new x();
            }
            return g[e] = t, t;
          }, w.prototype._verify1 = function (e) {
            r(0 === e.negative, "red works only with positives"), r(e.red, "red works only with red numbers");
          }, w.prototype._verify2 = function (e, t) {
            r(0 == (e.negative | t.negative), "red works only with positives"), r(e.red && e.red === t.red, "red works only with red numbers");
          }, w.prototype.imod = function (e) {
            return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
          }, w.prototype.neg = function (e) {
            return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
          }, w.prototype.add = function (e, t) {
            this._verify2(e, t);
            var n = e.add(t);
            return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
          }, w.prototype.iadd = function (e, t) {
            this._verify2(e, t);
            var n = e.iadd(t);
            return n.cmp(this.m) >= 0 && n.isub(this.m), n;
          }, w.prototype.sub = function (e, t) {
            this._verify2(e, t);
            var n = e.sub(t);
            return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
          }, w.prototype.isub = function (e, t) {
            this._verify2(e, t);
            var n = e.isub(t);
            return n.cmpn(0) < 0 && n.iadd(this.m), n;
          }, w.prototype.shl = function (e, t) {
            return this._verify1(e), this.imod(e.ushln(t));
          }, w.prototype.imul = function (e, t) {
            return this._verify2(e, t), this.imod(e.imul(t));
          }, w.prototype.mul = function (e, t) {
            return this._verify2(e, t), this.imod(e.mul(t));
          }, w.prototype.isqr = function (e) {
            return this.imul(e, e.clone());
          }, w.prototype.sqr = function (e) {
            return this.mul(e, e);
          }, w.prototype.sqrt = function (e) {
            if (e.isZero()) return e.clone();
            var t = this.m.andln(3);
            if (r(t % 2 == 1), 3 === t) {
              var n = this.m.add(new o(1)).iushrn(2);
              return this.pow(e, n);
            }
            for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) a++, i.iushrn(1);
            r(!i.isZero());
            var s = new o(1).toRed(this),
              l = s.redNeg(),
              u = this.m.subn(1).iushrn(1),
              c = this.m.bitLength();
            for (c = new o(2 * c * c).toRed(this); 0 !== this.pow(c, u).cmp(l);) c.redIAdd(l);
            for (var d = this.pow(c, i), h = this.pow(e, i.addn(1).iushrn(1)), f = this.pow(e, i), p = a; 0 !== f.cmp(s);) {
              for (var m = f, g = 0; 0 !== m.cmp(s); g++) m = m.redSqr();
              r(g < p);
              var v = this.pow(d, new o(1).iushln(p - g - 1));
              h = h.redMul(v), d = v.redSqr(), f = f.redMul(d), p = g;
            }
            return h;
          }, w.prototype.invm = function (e) {
            var t = e._invmp(this.m);
            return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
          }, w.prototype.pow = function (e, t) {
            if (t.isZero()) return new o(1).toRed(this);
            if (0 === t.cmpn(1)) return e.clone();
            var n = new Array(16);
            n[0] = new o(1).toRed(this), n[1] = e;
            for (var r = 2; r < n.length; r++) n[r] = this.mul(n[r - 1], e);
            var i = n[0],
              a = 0,
              s = 0,
              l = t.bitLength() % 26;
            for (0 === l && (l = 26), r = t.length - 1; r >= 0; r--) {
              for (var u = t.words[r], c = l - 1; c >= 0; c--) {
                var d = u >> c & 1;
                i !== n[0] && (i = this.sqr(i)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 === ++s || 0 === r && 0 === c) && (i = this.mul(i, n[a]), s = 0, a = 0)) : s = 0;
              }
              l = 26;
            }
            return i;
          }, w.prototype.convertTo = function (e) {
            var t = e.umod(this.m);
            return t === e ? t.clone() : t;
          }, w.prototype.convertFrom = function (e) {
            var t = e.clone();
            return t.red = null, t;
          }, o.mont = function (e) {
            return new S(e);
          }, i(S, w), S.prototype.convertTo = function (e) {
            return this.imod(e.ushln(this.shift));
          }, S.prototype.convertFrom = function (e) {
            var t = this.imod(e.mul(this.rinv));
            return t.red = null, t;
          }, S.prototype.imul = function (e, t) {
            if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
            var n = e.imul(t),
              r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = n.isub(r).iushrn(this.shift),
              o = i;
            return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
          }, S.prototype.mul = function (e, t) {
            if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
            var n = e.mul(t),
              r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = n.isub(r).iushrn(this.shift),
              a = i;
            return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
          }, S.prototype.invm = function (e) {
            return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
          };
        }(e, this);
      }).call(this, n("./node_modules/webpack/buildin/module.js")(e));
    },
    "./node_modules/brorand/index.js": function node_modulesBrorandIndexJs(e, t, n) {
      var r;
      function i(e) {
        this.rand = e;
      }
      if (e.exports = function (e) {
        return r || (r = new i(null)), r.generate(e);
      }, e.exports.Rand = i, i.prototype.generate = function (e) {
        return this._rand(e);
      }, i.prototype._rand = function (e) {
        if (this.rand.getBytes) return this.rand.getBytes(e);
        for (var t = new Uint8Array(e), n = 0; n < t.length; n++) t[n] = this.rand.getByte();
        return t;
      }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (e) {
        var t = new Uint8Array(e);
        return self.crypto.getRandomValues(t), t;
      } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (e) {
        var t = new Uint8Array(e);
        return self.msCrypto.getRandomValues(t), t;
      } : "object" == typeof window && (i.prototype._rand = function () {
        throw new Error("Not implemented yet");
      });else try {
        var o = n(3);
        if ("function" != typeof o.randomBytes) throw new Error("Not supported");
        i.prototype._rand = function (e) {
          return o.randomBytes(e);
        };
      } catch (e) {}
    },
    "./node_modules/browserify-aes/aes.js": function node_modulesBrowserifyAesAesJs(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer;
      function i(e) {
        r.isBuffer(e) || (e = r.from(e));
        for (var t = e.length / 4 | 0, n = new Array(t), i = 0; i < t; i++) n[i] = e.readUInt32BE(4 * i);
        return n;
      }
      function o(e) {
        for (; 0 < e.length; e++) e[0] = 0;
      }
      function a(e, t, n, r, i) {
        for (var o, a, s, l, u = n[0], c = n[1], d = n[2], h = n[3], f = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], g = e[3] ^ t[3], v = 4, y = 1; y < i; y++) o = u[f >>> 24] ^ c[p >>> 16 & 255] ^ d[m >>> 8 & 255] ^ h[255 & g] ^ t[v++], a = u[p >>> 24] ^ c[m >>> 16 & 255] ^ d[g >>> 8 & 255] ^ h[255 & f] ^ t[v++], s = u[m >>> 24] ^ c[g >>> 16 & 255] ^ d[f >>> 8 & 255] ^ h[255 & p] ^ t[v++], l = u[g >>> 24] ^ c[f >>> 16 & 255] ^ d[p >>> 8 & 255] ^ h[255 & m] ^ t[v++], f = o, p = a, m = s, g = l;
        return o = (r[f >>> 24] << 24 | r[p >>> 16 & 255] << 16 | r[m >>> 8 & 255] << 8 | r[255 & g]) ^ t[v++], a = (r[p >>> 24] << 24 | r[m >>> 16 & 255] << 16 | r[g >>> 8 & 255] << 8 | r[255 & f]) ^ t[v++], s = (r[m >>> 24] << 24 | r[g >>> 16 & 255] << 16 | r[f >>> 8 & 255] << 8 | r[255 & p]) ^ t[v++], l = (r[g >>> 24] << 24 | r[f >>> 16 & 255] << 16 | r[p >>> 8 & 255] << 8 | r[255 & m]) ^ t[v++], [o >>>= 0, a >>>= 0, s >>>= 0, l >>>= 0];
      }
      var s = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
        l = function () {
          for (var e = new Array(256), t = 0; t < 256; t++) e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
          for (var n = [], r = [], i = [[], [], [], []], o = [[], [], [], []], a = 0, s = 0, l = 0; l < 256; ++l) {
            var u = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4;
            u = u >>> 8 ^ 255 & u ^ 99, n[a] = u, r[u] = a;
            var c = e[a],
              d = e[c],
              h = e[d],
              f = 257 * e[u] ^ 16843008 * u;
            i[0][a] = f << 24 | f >>> 8, i[1][a] = f << 16 | f >>> 16, i[2][a] = f << 8 | f >>> 24, i[3][a] = f, f = 16843009 * h ^ 65537 * d ^ 257 * c ^ 16843008 * a, o[0][u] = f << 24 | f >>> 8, o[1][u] = f << 16 | f >>> 16, o[2][u] = f << 8 | f >>> 24, o[3][u] = f, 0 === a ? a = s = 1 : (a = c ^ e[e[e[h ^ c]]], s ^= e[e[s]]);
          }
          return {
            SBOX: n,
            INV_SBOX: r,
            SUB_MIX: i,
            INV_SUB_MIX: o
          };
        }();
      function u(e) {
        this._key = i(e), this._reset();
      }
      u.blockSize = 16, u.keySize = 32, u.prototype.blockSize = u.blockSize, u.prototype.keySize = u.keySize, u.prototype._reset = function () {
        for (var e = this._key, t = e.length, n = t + 6, r = 4 * (n + 1), i = [], o = 0; o < t; o++) i[o] = e[o];
        for (o = t; o < r; o++) {
          var a = i[o - 1];
          o % t == 0 ? (a = a << 8 | a >>> 24, a = l.SBOX[a >>> 24] << 24 | l.SBOX[a >>> 16 & 255] << 16 | l.SBOX[a >>> 8 & 255] << 8 | l.SBOX[255 & a], a ^= s[o / t | 0] << 24) : t > 6 && o % t == 4 && (a = l.SBOX[a >>> 24] << 24 | l.SBOX[a >>> 16 & 255] << 16 | l.SBOX[a >>> 8 & 255] << 8 | l.SBOX[255 & a]), i[o] = i[o - t] ^ a;
        }
        for (var u = [], c = 0; c < r; c++) {
          var d = r - c,
            h = i[d - (c % 4 ? 0 : 4)];
          u[c] = c < 4 || d <= 4 ? h : l.INV_SUB_MIX[0][l.SBOX[h >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[h >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[h >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & h]];
        }
        this._nRounds = n, this._keySchedule = i, this._invKeySchedule = u;
      }, u.prototype.encryptBlockRaw = function (e) {
        return a(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
      }, u.prototype.encryptBlock = function (e) {
        var t = this.encryptBlockRaw(e),
          n = r.allocUnsafe(16);
        return n.writeUInt32BE(t[0], 0), n.writeUInt32BE(t[1], 4), n.writeUInt32BE(t[2], 8), n.writeUInt32BE(t[3], 12), n;
      }, u.prototype.decryptBlock = function (e) {
        var t = (e = i(e))[1];
        e[1] = e[3], e[3] = t;
        var n = a(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds),
          o = r.allocUnsafe(16);
        return o.writeUInt32BE(n[0], 0), o.writeUInt32BE(n[3], 4), o.writeUInt32BE(n[2], 8), o.writeUInt32BE(n[1], 12), o;
      }, u.prototype.scrub = function () {
        o(this._keySchedule), o(this._invKeySchedule), o(this._key);
      }, e.exports.AES = u;
    },
    "./node_modules/browserify-aes/authCipher.js": function node_modulesBrowserifyAesAuthCipherJs(e, t, n) {
      var r = n("./node_modules/browserify-aes/aes.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer,
        o = n("./node_modules/cipher-base/index.js"),
        a = n("./node_modules/inherits/inherits_browser.js"),
        s = n("./node_modules/browserify-aes/ghash.js"),
        l = n("./node_modules/buffer-xor/index.js"),
        u = n("./node_modules/browserify-aes/incr32.js");
      function c(e, t, n, a) {
        o.call(this);
        var l = i.alloc(4, 0);
        this._cipher = new r.AES(t);
        var c = this._cipher.encryptBlock(l);
        this._ghash = new s(c), n = function (e, t, n) {
          if (12 === t.length) return e._finID = i.concat([t, i.from([0, 0, 0, 1])]), i.concat([t, i.from([0, 0, 0, 2])]);
          var r = new s(n),
            o = t.length,
            a = o % 16;
          r.update(t), a && (a = 16 - a, r.update(i.alloc(a, 0))), r.update(i.alloc(8, 0));
          var l = 8 * o,
            c = i.alloc(8);
          c.writeUIntBE(l, 0, 8), r.update(c), e._finID = r.state;
          var d = i.from(e._finID);
          return u(d), d;
        }(this, n, c), this._prev = i.from(n), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
      }
      a(c, o), c.prototype._update = function (e) {
        if (!this._called && this._alen) {
          var t = 16 - this._alen % 16;
          t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
        }
        this._called = !0;
        var n = this._mode.encrypt(this, e);
        return this._decrypt ? this._ghash.update(e) : this._ghash.update(n), this._len += e.length, n;
      }, c.prototype._final = function () {
        if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
        var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
        if (this._decrypt && function (e, t) {
          var n = 0;
          e.length !== t.length && n++;
          for (var r = Math.min(e.length, t.length), i = 0; i < r; ++i) n += e[i] ^ t[i];
          return n;
        }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
        this._authTag = e, this._cipher.scrub();
      }, c.prototype.getAuthTag = function () {
        if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
        return this._authTag;
      }, c.prototype.setAuthTag = function (e) {
        if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
        this._authTag = e;
      }, c.prototype.setAAD = function (e) {
        if (this._called) throw new Error("Attempting to set AAD in unsupported state");
        this._ghash.update(e), this._alen += e.length;
      }, e.exports = c;
    },
    "./node_modules/browserify-aes/browser.js": function node_modulesBrowserifyAesBrowserJs(e, t, n) {
      var r = n("./node_modules/browserify-aes/encrypter.js"),
        i = n("./node_modules/browserify-aes/decrypter.js"),
        o = n("./node_modules/browserify-aes/modes/list.json");
      t.createCipher = t.Cipher = r.createCipher, t.createCipheriv = t.Cipheriv = r.createCipheriv, t.createDecipher = t.Decipher = i.createDecipher, t.createDecipheriv = t.Decipheriv = i.createDecipheriv, t.listCiphers = t.getCiphers = function () {
        return Object.keys(o);
      };
    },
    "./node_modules/browserify-aes/decrypter.js": function node_modulesBrowserifyAesDecrypterJs(e, t, n) {
      var r = n("./node_modules/browserify-aes/authCipher.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer,
        o = n("./node_modules/browserify-aes/modes/index.js"),
        a = n("./node_modules/browserify-aes/streamCipher.js"),
        s = n("./node_modules/cipher-base/index.js"),
        l = n("./node_modules/browserify-aes/aes.js"),
        u = n("./node_modules/evp_bytestokey/index.js");
      function c(e, t, n) {
        s.call(this), this._cache = new d(), this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(n), this._mode = e, this._autopadding = !0;
      }
      function d() {
        this.cache = i.allocUnsafe(0);
      }
      function h(e, t, n) {
        var s = o[e.toLowerCase()];
        if (!s) throw new TypeError("invalid suite type");
        if ("string" == typeof n && (n = i.from(n)), "GCM" !== s.mode && n.length !== s.iv) throw new TypeError("invalid iv length " + n.length);
        if ("string" == typeof t && (t = i.from(t)), t.length !== s.key / 8) throw new TypeError("invalid key length " + t.length);
        return "stream" === s.type ? new a(s.module, t, n, !0) : "auth" === s.type ? new r(s.module, t, n, !0) : new c(s.module, t, n);
      }
      n("./node_modules/inherits/inherits_browser.js")(c, s), c.prototype._update = function (e) {
        var t, n;
        this._cache.add(e);
        for (var r = []; t = this._cache.get(this._autopadding);) n = this._mode.decrypt(this, t), r.push(n);
        return i.concat(r);
      }, c.prototype._final = function () {
        var e = this._cache.flush();
        if (this._autopadding) return function (e) {
          var t = e[15];
          if (t < 1 || t > 16) throw new Error("unable to decrypt data");
          var n = -1;
          for (; ++n < t;) if (e[n + (16 - t)] !== t) throw new Error("unable to decrypt data");
          if (16 === t) return;
          return e.slice(0, 16 - t);
        }(this._mode.decrypt(this, e));
        if (e) throw new Error("data not multiple of block length");
      }, c.prototype.setAutoPadding = function (e) {
        return this._autopadding = !!e, this;
      }, d.prototype.add = function (e) {
        this.cache = i.concat([this.cache, e]);
      }, d.prototype.get = function (e) {
        var t;
        if (e) {
          if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
        } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
        return null;
      }, d.prototype.flush = function () {
        if (this.cache.length) return this.cache;
      }, t.createDecipher = function (e, t) {
        var n = o[e.toLowerCase()];
        if (!n) throw new TypeError("invalid suite type");
        var r = u(t, !1, n.key, n.iv);
        return h(e, r.key, r.iv);
      }, t.createDecipheriv = h;
    },
    "./node_modules/browserify-aes/encrypter.js": function node_modulesBrowserifyAesEncrypterJs(e, t, n) {
      var r = n("./node_modules/browserify-aes/modes/index.js"),
        i = n("./node_modules/browserify-aes/authCipher.js"),
        o = n("./node_modules/safe-buffer/index.js").Buffer,
        a = n("./node_modules/browserify-aes/streamCipher.js"),
        s = n("./node_modules/cipher-base/index.js"),
        l = n("./node_modules/browserify-aes/aes.js"),
        u = n("./node_modules/evp_bytestokey/index.js");
      function c(e, t, n) {
        s.call(this), this._cache = new h(), this._cipher = new l.AES(t), this._prev = o.from(n), this._mode = e, this._autopadding = !0;
      }
      n("./node_modules/inherits/inherits_browser.js")(c, s), c.prototype._update = function (e) {
        var t, n;
        this._cache.add(e);
        for (var r = []; t = this._cache.get();) n = this._mode.encrypt(this, t), r.push(n);
        return o.concat(r);
      };
      var d = o.alloc(16, 16);
      function h() {
        this.cache = o.allocUnsafe(0);
      }
      function f(e, t, n) {
        var s = r[e.toLowerCase()];
        if (!s) throw new TypeError("invalid suite type");
        if ("string" == typeof t && (t = o.from(t)), t.length !== s.key / 8) throw new TypeError("invalid key length " + t.length);
        if ("string" == typeof n && (n = o.from(n)), "GCM" !== s.mode && n.length !== s.iv) throw new TypeError("invalid iv length " + n.length);
        return "stream" === s.type ? new a(s.module, t, n) : "auth" === s.type ? new i(s.module, t, n) : new c(s.module, t, n);
      }
      c.prototype._final = function () {
        var e = this._cache.flush();
        if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
        if (!e.equals(d)) throw this._cipher.scrub(), new Error("data not multiple of block length");
      }, c.prototype.setAutoPadding = function (e) {
        return this._autopadding = !!e, this;
      }, h.prototype.add = function (e) {
        this.cache = o.concat([this.cache, e]);
      }, h.prototype.get = function () {
        if (this.cache.length > 15) {
          var e = this.cache.slice(0, 16);
          return this.cache = this.cache.slice(16), e;
        }
        return null;
      }, h.prototype.flush = function () {
        for (var e = 16 - this.cache.length, t = o.allocUnsafe(e), n = -1; ++n < e;) t.writeUInt8(e, n);
        return o.concat([this.cache, t]);
      }, t.createCipheriv = f, t.createCipher = function (e, t) {
        var n = r[e.toLowerCase()];
        if (!n) throw new TypeError("invalid suite type");
        var i = u(t, !1, n.key, n.iv);
        return f(e, i.key, i.iv);
      };
    },
    "./node_modules/browserify-aes/ghash.js": function node_modulesBrowserifyAesGhashJs(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = r.alloc(16, 0);
      function o(e) {
        var t = r.allocUnsafe(16);
        return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
      }
      function a(e) {
        this.h = e, this.state = r.alloc(16, 0), this.cache = r.allocUnsafe(0);
      }
      a.prototype.ghash = function (e) {
        for (var t = -1; ++t < e.length;) this.state[t] ^= e[t];
        this._multiply();
      }, a.prototype._multiply = function () {
        for (var e, t, n, r = [(e = this.h).readUInt32BE(0), e.readUInt32BE(4), e.readUInt32BE(8), e.readUInt32BE(12)], i = [0, 0, 0, 0], a = -1; ++a < 128;) {
          for (0 != (this.state[~~(a / 8)] & 1 << 7 - a % 8) && (i[0] ^= r[0], i[1] ^= r[1], i[2] ^= r[2], i[3] ^= r[3]), n = 0 != (1 & r[3]), t = 3; t > 0; t--) r[t] = r[t] >>> 1 | (1 & r[t - 1]) << 31;
          r[0] = r[0] >>> 1, n && (r[0] = r[0] ^ 225 << 24);
        }
        this.state = o(i);
      }, a.prototype.update = function (e) {
        var t;
        for (this.cache = r.concat([this.cache, e]); this.cache.length >= 16;) t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
      }, a.prototype.final = function (e, t) {
        return this.cache.length && this.ghash(r.concat([this.cache, i], 16)), this.ghash(o([0, e, 0, t])), this.state;
      }, e.exports = a;
    },
    "./node_modules/browserify-aes/incr32.js": function node_modulesBrowserifyAesIncr32Js(e, t) {
      e.exports = function (e) {
        for (var t, n = e.length; n--;) {
          if (255 !== (t = e.readUInt8(n))) {
            t++, e.writeUInt8(t, n);
            break;
          }
          e.writeUInt8(0, n);
        }
      };
    },
    "./node_modules/browserify-aes/modes/cbc.js": function node_modulesBrowserifyAesModesCbcJs(e, t, n) {
      var r = n("./node_modules/buffer-xor/index.js");
      t.encrypt = function (e, t) {
        var n = r(t, e._prev);
        return e._prev = e._cipher.encryptBlock(n), e._prev;
      }, t.decrypt = function (e, t) {
        var n = e._prev;
        e._prev = t;
        var i = e._cipher.decryptBlock(t);
        return r(i, n);
      };
    },
    "./node_modules/browserify-aes/modes/cfb.js": function node_modulesBrowserifyAesModesCfbJs(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = n("./node_modules/buffer-xor/index.js");
      function o(e, t, n) {
        var o = t.length,
          a = i(t, e._cache);
        return e._cache = e._cache.slice(o), e._prev = r.concat([e._prev, n ? t : a]), a;
      }
      t.encrypt = function (e, t, n) {
        for (var i, a = r.allocUnsafe(0); t.length;) {
          if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = r.allocUnsafe(0)), !(e._cache.length <= t.length)) {
            a = r.concat([a, o(e, t, n)]);
            break;
          }
          i = e._cache.length, a = r.concat([a, o(e, t.slice(0, i), n)]), t = t.slice(i);
        }
        return a;
      };
    },
    "./node_modules/browserify-aes/modes/cfb1.js": function node_modulesBrowserifyAesModesCfb1Js(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer;
      function i(e, t, n) {
        for (var r, i, a = -1, s = 0; ++a < 8;) r = t & 1 << 7 - a ? 128 : 0, s += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ r)) >> a % 8, e._prev = o(e._prev, n ? r : i);
        return s;
      }
      function o(e, t) {
        var n = e.length,
          i = -1,
          o = r.allocUnsafe(e.length);
        for (e = r.concat([e, r.from([t])]); ++i < n;) o[i] = e[i] << 1 | e[i + 1] >> 7;
        return o;
      }
      t.encrypt = function (e, t, n) {
        for (var o = t.length, a = r.allocUnsafe(o), s = -1; ++s < o;) a[s] = i(e, t[s], n);
        return a;
      };
    },
    "./node_modules/browserify-aes/modes/cfb8.js": function node_modulesBrowserifyAesModesCfb8Js(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer;
      function i(e, t, n) {
        var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
        return e._prev = r.concat([e._prev.slice(1), r.from([n ? t : i])]), i;
      }
      t.encrypt = function (e, t, n) {
        for (var o = t.length, a = r.allocUnsafe(o), s = -1; ++s < o;) a[s] = i(e, t[s], n);
        return a;
      };
    },
    "./node_modules/browserify-aes/modes/ctr.js": function node_modulesBrowserifyAesModesCtrJs(e, t, n) {
      var r = n("./node_modules/buffer-xor/index.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer,
        o = n("./node_modules/browserify-aes/incr32.js");
      function a(e) {
        var t = e._cipher.encryptBlockRaw(e._prev);
        return o(e._prev), t;
      }
      t.encrypt = function (e, t) {
        var n = Math.ceil(t.length / 16),
          o = e._cache.length;
        e._cache = i.concat([e._cache, i.allocUnsafe(16 * n)]);
        for (var s = 0; s < n; s++) {
          var l = a(e),
            u = o + 16 * s;
          e._cache.writeUInt32BE(l[0], u + 0), e._cache.writeUInt32BE(l[1], u + 4), e._cache.writeUInt32BE(l[2], u + 8), e._cache.writeUInt32BE(l[3], u + 12);
        }
        var c = e._cache.slice(0, t.length);
        return e._cache = e._cache.slice(t.length), r(t, c);
      };
    },
    "./node_modules/browserify-aes/modes/ecb.js": function node_modulesBrowserifyAesModesEcbJs(e, t) {
      t.encrypt = function (e, t) {
        return e._cipher.encryptBlock(t);
      }, t.decrypt = function (e, t) {
        return e._cipher.decryptBlock(t);
      };
    },
    "./node_modules/browserify-aes/modes/index.js": function node_modulesBrowserifyAesModesIndexJs(e, t, n) {
      var r = {
          ECB: n("./node_modules/browserify-aes/modes/ecb.js"),
          CBC: n("./node_modules/browserify-aes/modes/cbc.js"),
          CFB: n("./node_modules/browserify-aes/modes/cfb.js"),
          CFB8: n("./node_modules/browserify-aes/modes/cfb8.js"),
          CFB1: n("./node_modules/browserify-aes/modes/cfb1.js"),
          OFB: n("./node_modules/browserify-aes/modes/ofb.js"),
          CTR: n("./node_modules/browserify-aes/modes/ctr.js"),
          GCM: n("./node_modules/browserify-aes/modes/ctr.js")
        },
        i = n("./node_modules/browserify-aes/modes/list.json");
      for (var o in i) i[o].module = r[i[o].mode];
      e.exports = i;
    },
    "./node_modules/browserify-aes/modes/list.json": function node_modulesBrowserifyAesModesListJson(e) {
      e.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');
    },
    "./node_modules/browserify-aes/modes/ofb.js": function node_modulesBrowserifyAesModesOfbJs(e, t, n) {
      (function (e) {
        var r = n("./node_modules/buffer-xor/index.js");
        function i(e) {
          return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
        }
        t.encrypt = function (t, n) {
          for (; t._cache.length < n.length;) t._cache = e.concat([t._cache, i(t)]);
          var o = t._cache.slice(0, n.length);
          return t._cache = t._cache.slice(n.length), r(n, o);
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/browserify-aes/streamCipher.js": function node_modulesBrowserifyAesStreamCipherJs(e, t, n) {
      var r = n("./node_modules/browserify-aes/aes.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer,
        o = n("./node_modules/cipher-base/index.js");
      function a(e, t, n, a) {
        o.call(this), this._cipher = new r.AES(t), this._prev = i.from(n), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._mode = e;
      }
      n("./node_modules/inherits/inherits_browser.js")(a, o), a.prototype._update = function (e) {
        return this._mode.encrypt(this, e, this._decrypt);
      }, a.prototype._final = function () {
        this._cipher.scrub();
      }, e.exports = a;
    },
    "./node_modules/browserify-cipher/browser.js": function node_modulesBrowserifyCipherBrowserJs(e, t, n) {
      var r = n("./node_modules/browserify-des/index.js"),
        i = n("./node_modules/browserify-aes/browser.js"),
        o = n("./node_modules/browserify-aes/modes/index.js"),
        a = n("./node_modules/browserify-des/modes.js"),
        s = n("./node_modules/evp_bytestokey/index.js");
      function l(e, t, n) {
        if (e = e.toLowerCase(), o[e]) return i.createCipheriv(e, t, n);
        if (a[e]) return new r({
          key: t,
          iv: n,
          mode: e
        });
        throw new TypeError("invalid suite type");
      }
      function u(e, t, n) {
        if (e = e.toLowerCase(), o[e]) return i.createDecipheriv(e, t, n);
        if (a[e]) return new r({
          key: t,
          iv: n,
          mode: e,
          decrypt: !0
        });
        throw new TypeError("invalid suite type");
      }
      t.createCipher = t.Cipher = function (e, t) {
        var n, r;
        if (e = e.toLowerCase(), o[e]) n = o[e].key, r = o[e].iv;else {
          if (!a[e]) throw new TypeError("invalid suite type");
          n = 8 * a[e].key, r = a[e].iv;
        }
        var i = s(t, !1, n, r);
        return l(e, i.key, i.iv);
      }, t.createCipheriv = t.Cipheriv = l, t.createDecipher = t.Decipher = function (e, t) {
        var n, r;
        if (e = e.toLowerCase(), o[e]) n = o[e].key, r = o[e].iv;else {
          if (!a[e]) throw new TypeError("invalid suite type");
          n = 8 * a[e].key, r = a[e].iv;
        }
        var i = s(t, !1, n, r);
        return u(e, i.key, i.iv);
      }, t.createDecipheriv = t.Decipheriv = u, t.listCiphers = t.getCiphers = function () {
        return Object.keys(a).concat(i.getCiphers());
      };
    },
    "./node_modules/browserify-des/index.js": function node_modulesBrowserifyDesIndexJs(e, t, n) {
      var r = n("./node_modules/cipher-base/index.js"),
        i = n("./node_modules/des.js/lib/des.js"),
        o = n("./node_modules/inherits/inherits_browser.js"),
        a = n("./node_modules/safe-buffer/index.js").Buffer,
        s = {
          "des-ede3-cbc": i.CBC.instantiate(i.EDE),
          "des-ede3": i.EDE,
          "des-ede-cbc": i.CBC.instantiate(i.EDE),
          "des-ede": i.EDE,
          "des-cbc": i.CBC.instantiate(i.DES),
          "des-ecb": i.DES
        };
      function l(e) {
        r.call(this);
        var t,
          n = e.mode.toLowerCase(),
          i = s[n];
        t = e.decrypt ? "decrypt" : "encrypt";
        var o = e.key;
        a.isBuffer(o) || (o = a.from(o)), "des-ede" !== n && "des-ede-cbc" !== n || (o = a.concat([o, o.slice(0, 8)]));
        var l = e.iv;
        a.isBuffer(l) || (l = a.from(l)), this._des = i.create({
          key: o,
          iv: l,
          type: t
        });
      }
      s.des = s["des-cbc"], s.des3 = s["des-ede3-cbc"], e.exports = l, o(l, r), l.prototype._update = function (e) {
        return a.from(this._des.update(e));
      }, l.prototype._final = function () {
        return a.from(this._des.final());
      };
    },
    "./node_modules/browserify-des/modes.js": function node_modulesBrowserifyDesModesJs(e, t) {
      t["des-ecb"] = {
        key: 8,
        iv: 0
      }, t["des-cbc"] = t.des = {
        key: 8,
        iv: 8
      }, t["des-ede3-cbc"] = t.des3 = {
        key: 24,
        iv: 8
      }, t["des-ede3"] = {
        key: 24,
        iv: 0
      }, t["des-ede-cbc"] = {
        key: 16,
        iv: 8
      }, t["des-ede"] = {
        key: 16,
        iv: 0
      };
    },
    "./node_modules/browserify-rsa/index.js": function node_modulesBrowserifyRsaIndexJs(e, t, n) {
      (function (t) {
        var r = n("./node_modules/bn.js/lib/bn.js"),
          i = n("./node_modules/randombytes/browser.js");
        function o(e, n) {
          var i = function (e) {
              var t = a(e);
              return {
                blinder: t.toRed(r.mont(e.modulus)).redPow(new r(e.publicExponent)).fromRed(),
                unblinder: t.invm(e.modulus)
              };
            }(n),
            o = n.modulus.byteLength(),
            s = (r.mont(n.modulus), new r(e).mul(i.blinder).umod(n.modulus)),
            l = s.toRed(r.mont(n.prime1)),
            u = s.toRed(r.mont(n.prime2)),
            c = n.coefficient,
            d = n.prime1,
            h = n.prime2,
            f = l.redPow(n.exponent1),
            p = u.redPow(n.exponent2);
          f = f.fromRed(), p = p.fromRed();
          var m = f.isub(p).imul(c).umod(d);
          return m.imul(h), p.iadd(m), new t(p.imul(i.unblinder).umod(n.modulus).toArray(!1, o));
        }
        function a(e) {
          for (var t = e.modulus.byteLength(), n = new r(i(t)); n.cmp(e.modulus) >= 0 || !n.umod(e.prime1) || !n.umod(e.prime2);) n = new r(i(t));
          return n;
        }
        e.exports = o, o.getr = a;
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/browserify-sign/algos.js": function node_modulesBrowserifySignAlgosJs(e, t, n) {
      e.exports = n("./node_modules/browserify-sign/browser/algorithms.json");
    },
    "./node_modules/browserify-sign/browser/algorithms.json": function node_modulesBrowserifySignBrowserAlgorithmsJson(e) {
      e.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');
    },
    "./node_modules/browserify-sign/browser/curves.json": function node_modulesBrowserifySignBrowserCurvesJson(e) {
      e.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');
    },
    "./node_modules/browserify-sign/browser/index.js": function node_modulesBrowserifySignBrowserIndexJs(e, t, n) {
      (function (t) {
        var r = n("./node_modules/create-hash/browser.js"),
          i = n("./node_modules/stream-browserify/index.js"),
          o = n("./node_modules/inherits/inherits_browser.js"),
          a = n("./node_modules/browserify-sign/browser/sign.js"),
          s = n("./node_modules/browserify-sign/browser/verify.js"),
          l = n("./node_modules/browserify-sign/browser/algorithms.json");
        function u(e) {
          i.Writable.call(this);
          var t = l[e];
          if (!t) throw new Error("Unknown message digest");
          this._hashType = t.hash, this._hash = r(t.hash), this._tag = t.id, this._signType = t.sign;
        }
        function c(e) {
          i.Writable.call(this);
          var t = l[e];
          if (!t) throw new Error("Unknown message digest");
          this._hash = r(t.hash), this._tag = t.id, this._signType = t.sign;
        }
        function d(e) {
          return new u(e);
        }
        function h(e) {
          return new c(e);
        }
        Object.keys(l).forEach(function (e) {
          l[e].id = new t(l[e].id, "hex"), l[e.toLowerCase()] = l[e];
        }), o(u, i.Writable), u.prototype._write = function (e, t, n) {
          this._hash.update(e), n();
        }, u.prototype.update = function (e, n) {
          return "string" == typeof e && (e = new t(e, n)), this._hash.update(e), this;
        }, u.prototype.sign = function (e, t) {
          this.end();
          var n = this._hash.digest(),
            r = a(n, e, this._hashType, this._signType, this._tag);
          return t ? r.toString(t) : r;
        }, o(c, i.Writable), c.prototype._write = function (e, t, n) {
          this._hash.update(e), n();
        }, c.prototype.update = function (e, n) {
          return "string" == typeof e && (e = new t(e, n)), this._hash.update(e), this;
        }, c.prototype.verify = function (e, n, r) {
          "string" == typeof n && (n = new t(n, r)), this.end();
          var i = this._hash.digest();
          return s(n, i, e, this._signType, this._tag);
        }, e.exports = {
          Sign: d,
          Verify: h,
          createSign: d,
          createVerify: h
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/browserify-sign/browser/sign.js": function node_modulesBrowserifySignBrowserSignJs(e, t, n) {
      (function (t) {
        var r = n("./node_modules/create-hmac/browser.js"),
          i = n("./node_modules/browserify-rsa/index.js"),
          o = n("./node_modules/elliptic/lib/elliptic.js").ec,
          a = n("./node_modules/bn.js/lib/bn.js"),
          s = n("./node_modules/parse-asn1/index.js"),
          l = n("./node_modules/browserify-sign/browser/curves.json");
        function u(e, n, i, o) {
          if ((e = new t(e.toArray())).length < n.byteLength()) {
            var a = new t(n.byteLength() - e.length);
            a.fill(0), e = t.concat([a, e]);
          }
          var s = i.length,
            l = function (e, n) {
              e = (e = c(e, n)).mod(n);
              var r = new t(e.toArray());
              if (r.length < n.byteLength()) {
                var i = new t(n.byteLength() - r.length);
                i.fill(0), r = t.concat([i, r]);
              }
              return r;
            }(i, n),
            u = new t(s);
          u.fill(1);
          var d = new t(s);
          return d.fill(0), d = r(o, d).update(u).update(new t([0])).update(e).update(l).digest(), u = r(o, d).update(u).digest(), {
            k: d = r(o, d).update(u).update(new t([1])).update(e).update(l).digest(),
            v: u = r(o, d).update(u).digest()
          };
        }
        function c(e, t) {
          var n = new a(e),
            r = (e.length << 3) - t.bitLength();
          return r > 0 && n.ishrn(r), n;
        }
        function d(e, n, i) {
          var o, a;
          do {
            for (o = new t(0); 8 * o.length < e.bitLength();) n.v = r(i, n.k).update(n.v).digest(), o = t.concat([o, n.v]);
            a = c(o, e), n.k = r(i, n.k).update(n.v).update(new t([0])).digest(), n.v = r(i, n.k).update(n.v).digest();
          } while (-1 !== a.cmp(e));
          return a;
        }
        function h(e, t, n, r) {
          return e.toRed(a.mont(n)).redPow(t).fromRed().mod(r);
        }
        e.exports = function (e, n, r, f, p) {
          var m = s(n);
          if (m.curve) {
            if ("ecdsa" !== f && "ecdsa/rsa" !== f) throw new Error("wrong private key type");
            return function (e, n) {
              var r = l[n.curve.join(".")];
              if (!r) throw new Error("unknown curve " + n.curve.join("."));
              var i = new o(r).keyFromPrivate(n.privateKey).sign(e);
              return new t(i.toDER());
            }(e, m);
          }
          if ("dsa" === m.type) {
            if ("dsa" !== f) throw new Error("wrong private key type");
            return function (e, n, r) {
              var i,
                o = n.params.priv_key,
                s = n.params.p,
                l = n.params.q,
                f = n.params.g,
                p = new a(0),
                m = c(e, l).mod(l),
                g = !1,
                v = u(o, l, e, r);
              for (; !1 === g;) i = d(l, v, r), p = h(f, i, s, l), 0 === (g = i.invm(l).imul(m.add(o.mul(p))).mod(l)).cmpn(0) && (g = !1, p = new a(0));
              return function (e, n) {
                e = e.toArray(), n = n.toArray(), 128 & e[0] && (e = [0].concat(e));
                128 & n[0] && (n = [0].concat(n));
                var r = [48, e.length + n.length + 4, 2, e.length];
                return r = r.concat(e, [2, n.length], n), new t(r);
              }(p, g);
            }(e, m, r);
          }
          if ("rsa" !== f && "ecdsa/rsa" !== f) throw new Error("wrong private key type");
          e = t.concat([p, e]);
          for (var g = m.modulus.byteLength(), v = [0, 1]; e.length + v.length + 1 < g;) v.push(255);
          v.push(0);
          for (var y = -1; ++y < e.length;) v.push(e[y]);
          return i(v, m);
        }, e.exports.getKey = u, e.exports.makeKey = d;
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/browserify-sign/browser/verify.js": function node_modulesBrowserifySignBrowserVerifyJs(e, t, n) {
      (function (t) {
        var r = n("./node_modules/bn.js/lib/bn.js"),
          i = n("./node_modules/elliptic/lib/elliptic.js").ec,
          o = n("./node_modules/parse-asn1/index.js"),
          a = n("./node_modules/browserify-sign/browser/curves.json");
        function s(e, t) {
          if (e.cmpn(0) <= 0) throw new Error("invalid sig");
          if (e.cmp(t) >= t) throw new Error("invalid sig");
        }
        e.exports = function (e, n, l, u, c) {
          var d = o(l);
          if ("ec" === d.type) {
            if ("ecdsa" !== u && "ecdsa/rsa" !== u) throw new Error("wrong public key type");
            return function (e, t, n) {
              var r = a[n.data.algorithm.curve.join(".")];
              if (!r) throw new Error("unknown curve " + n.data.algorithm.curve.join("."));
              var o = new i(r),
                s = n.data.subjectPrivateKey.data;
              return o.verify(t, e, s);
            }(e, n, d);
          }
          if ("dsa" === d.type) {
            if ("dsa" !== u) throw new Error("wrong public key type");
            return function (e, t, n) {
              var i = n.data.p,
                a = n.data.q,
                l = n.data.g,
                u = n.data.pub_key,
                c = o.signature.decode(e, "der"),
                d = c.s,
                h = c.r;
              s(d, a), s(h, a);
              var f = r.mont(i),
                p = d.invm(a);
              return 0 === l.toRed(f).redPow(new r(t).mul(p).mod(a)).fromRed().mul(u.toRed(f).redPow(h.mul(p).mod(a)).fromRed()).mod(i).mod(a).cmp(h);
            }(e, n, d);
          }
          if ("rsa" !== u && "ecdsa/rsa" !== u) throw new Error("wrong public key type");
          n = t.concat([c, n]);
          for (var h = d.modulus.byteLength(), f = [1], p = 0; n.length + f.length + 2 < h;) f.push(255), p++;
          f.push(0);
          for (var m = -1; ++m < n.length;) f.push(n[m]);
          f = new t(f);
          var g = r.mont(d.modulus);
          e = (e = new r(e).toRed(g)).redPow(new r(d.publicExponent)), e = new t(e.fromRed().toArray());
          var v = p < 8 ? 1 : 0;
          for (h = Math.min(e.length, f.length), e.length !== f.length && (v = 1), m = -1; ++m < h;) v |= e[m] ^ f[m];
          return 0 === v;
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/buffer-xor/index.js": function node_modulesBufferXorIndexJs(e, t, n) {
      (function (t) {
        e.exports = function (e, n) {
          for (var r = Math.min(e.length, n.length), i = new t(r), o = 0; o < r; ++o) i[o] = e[o] ^ n[o];
          return i;
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/buffer/index.js": function node_modulesBufferIndexJs(e, t, n) {
      "use strict";

      (function (e) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <http://feross.org>
         * @license  MIT
         */
        var r = n("./node_modules/base64-js/index.js"),
          i = n("./node_modules/ieee754/index.js"),
          o = n("./node_modules/isarray/index.js");
        function a() {
          return l.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function s(e, t) {
          if (a() < t) throw new RangeError("Invalid typed array length");
          return l.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = l.prototype : (null === e && (e = new l(t)), e.length = t), e;
        }
        function l(e, t, n) {
          if (!(l.TYPED_ARRAY_SUPPORT || this instanceof l)) return new l(e, t, n);
          if ("number" == typeof e) {
            if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
            return d(this, e);
          }
          return u(this, e, t, n);
        }
        function u(e, t, n, r) {
          if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function (e, t, n, r) {
            if (t.byteLength, n < 0 || t.byteLength < n) throw new RangeError("'offset' is out of bounds");
            if (t.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
            t = void 0 === n && void 0 === r ? new Uint8Array(t) : void 0 === r ? new Uint8Array(t, n) : new Uint8Array(t, n, r);
            l.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = l.prototype : e = h(e, t);
            return e;
          }(e, t, n, r) : "string" == typeof t ? function (e, t, n) {
            "string" == typeof n && "" !== n || (n = "utf8");
            if (!l.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
            var r = 0 | p(t, n),
              i = (e = s(e, r)).write(t, n);
            i !== r && (e = e.slice(0, i));
            return e;
          }(e, t, n) : function (e, t) {
            if (l.isBuffer(t)) {
              var n = 0 | f(t.length);
              return 0 === (e = s(e, n)).length || t.copy(e, 0, 0, n), e;
            }
            if (t) {
              if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (r = t.length) != r ? s(e, 0) : h(e, t);
              if ("Buffer" === t.type && o(t.data)) return h(e, t.data);
            }
            var r;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(e, t);
        }
        function c(e) {
          if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
          if (e < 0) throw new RangeError('"size" argument must not be negative');
        }
        function d(e, t) {
          if (c(t), e = s(e, t < 0 ? 0 : 0 | f(t)), !l.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
          return e;
        }
        function h(e, t) {
          var n = t.length < 0 ? 0 : 0 | f(t.length);
          e = s(e, n);
          for (var r = 0; r < n; r += 1) e[r] = 255 & t[r];
          return e;
        }
        function f(e) {
          if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
          return 0 | e;
        }
        function p(e, t) {
          if (l.isBuffer(e)) return e.length;
          if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
          "string" != typeof e && (e = "" + e);
          var n = e.length;
          if (0 === n) return 0;
          for (var r = !1;;) switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;
            case "utf8":
            case "utf-8":
            case void 0:
              return z(e).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;
            case "hex":
              return n >>> 1;
            case "base64":
              return U(e).length;
            default:
              if (r) return z(e).length;
              t = ("" + t).toLowerCase(), r = !0;
          }
        }
        function m(e, t, n) {
          var r = !1;
          if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
          if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
          if ((n >>>= 0) <= (t >>>= 0)) return "";
          for (e || (e = "utf8");;) switch (e) {
            case "hex":
              return k(this, t, n);
            case "utf8":
            case "utf-8":
              return T(this, t, n);
            case "ascii":
              return M(this, t, n);
            case "latin1":
            case "binary":
              return C(this, t, n);
            case "base64":
              return E(this, t, n);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return P(this, t, n);
            default:
              if (r) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), r = !0;
          }
        }
        function g(e, t, n) {
          var r = e[t];
          e[t] = e[n], e[n] = r;
        }
        function v(e, t, n, r, i) {
          if (0 === e.length) return -1;
          if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
            if (i) return -1;
            n = e.length - 1;
          } else if (n < 0) {
            if (!i) return -1;
            n = 0;
          }
          if ("string" == typeof t && (t = l.from(t, r)), l.isBuffer(t)) return 0 === t.length ? -1 : y(e, t, n, r, i);
          if ("number" == typeof t) return t &= 255, l.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : y(e, [t], n, r, i);
          throw new TypeError("val must be string, number or Buffer");
        }
        function y(e, t, n, r, i) {
          var o,
            a = 1,
            s = e.length,
            l = t.length;
          if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
            if (e.length < 2 || t.length < 2) return -1;
            a = 2, s /= 2, l /= 2, n /= 2;
          }
          function u(e, t) {
            return 1 === a ? e[t] : e.readUInt16BE(t * a);
          }
          if (i) {
            var c = -1;
            for (o = n; o < s; o++) if (u(e, o) === u(t, -1 === c ? 0 : o - c)) {
              if (-1 === c && (c = o), o - c + 1 === l) return c * a;
            } else -1 !== c && (o -= o - c), c = -1;
          } else for (n + l > s && (n = s - l), o = n; o >= 0; o--) {
            for (var d = !0, h = 0; h < l; h++) if (u(e, o + h) !== u(t, h)) {
              d = !1;
              break;
            }
            if (d) return o;
          }
          return -1;
        }
        function b(e, t, n, r) {
          n = Number(n) || 0;
          var i = e.length - n;
          r ? (r = Number(r)) > i && (r = i) : r = i;
          var o = t.length;
          if (o % 2 != 0) throw new TypeError("Invalid hex string");
          r > o / 2 && (r = o / 2);
          for (var a = 0; a < r; ++a) {
            var s = parseInt(t.substr(2 * a, 2), 16);
            if (isNaN(s)) return a;
            e[n + a] = s;
          }
          return a;
        }
        function _(e, t, n, r) {
          return G(z(t, e.length - n), e, n, r);
        }
        function x(e, t, n, r) {
          return G(function (e) {
            for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
            return t;
          }(t), e, n, r);
        }
        function w(e, t, n, r) {
          return x(e, t, n, r);
        }
        function S(e, t, n, r) {
          return G(U(t), e, n, r);
        }
        function A(e, t, n, r) {
          return G(function (e, t) {
            for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) n = e.charCodeAt(a), r = n >> 8, i = n % 256, o.push(i), o.push(r);
            return o;
          }(t, e.length - n), e, n, r);
        }
        function E(e, t, n) {
          return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
        }
        function T(e, t, n) {
          n = Math.min(e.length, n);
          for (var r = [], i = t; i < n;) {
            var o,
              a,
              s,
              l,
              u = e[i],
              c = null,
              d = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
            if (i + d <= n) switch (d) {
              case 1:
                u < 128 && (c = u);
                break;
              case 2:
                128 == (192 & (o = e[i + 1])) && (l = (31 & u) << 6 | 63 & o) > 127 && (c = l);
                break;
              case 3:
                o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (l = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (l < 55296 || l > 57343) && (c = l);
                break;
              case 4:
                o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (l = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && l < 1114112 && (c = l);
            }
            null === c ? (c = 65533, d = 1) : c > 65535 && (c -= 65536, r.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r.push(c), i += d;
          }
          return function (e) {
            var t = e.length;
            if (t <= 4096) return String.fromCharCode.apply(String, e);
            var n = "",
              r = 0;
            for (; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += 4096));
            return n;
          }(r);
        }
        t.Buffer = l, t.SlowBuffer = function (e) {
          +e != e && (e = 0);
          return l.alloc(+e);
        }, t.INSPECT_MAX_BYTES = 50, l.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
          try {
            var e = new Uint8Array(1);
            return e.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
          } catch (e) {
            return !1;
          }
        }(), t.kMaxLength = a(), l.poolSize = 8192, l._augment = function (e) {
          return e.__proto__ = l.prototype, e;
        }, l.from = function (e, t, n) {
          return u(null, e, t, n);
        }, l.TYPED_ARRAY_SUPPORT && (l.prototype.__proto__ = Uint8Array.prototype, l.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && l[Symbol.species] === l && Object.defineProperty(l, Symbol.species, {
          value: null,
          configurable: !0
        })), l.alloc = function (e, t, n) {
          return function (e, t, n, r) {
            return c(t), t <= 0 ? s(e, t) : void 0 !== n ? "string" == typeof r ? s(e, t).fill(n, r) : s(e, t).fill(n) : s(e, t);
          }(null, e, t, n);
        }, l.allocUnsafe = function (e) {
          return d(null, e);
        }, l.allocUnsafeSlow = function (e) {
          return d(null, e);
        }, l.isBuffer = function (e) {
          return !(null == e || !e._isBuffer);
        }, l.compare = function (e, t) {
          if (!l.isBuffer(e) || !l.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
          if (e === t) return 0;
          for (var n = e.length, r = t.length, i = 0, o = Math.min(n, r); i < o; ++i) if (e[i] !== t[i]) {
            n = e[i], r = t[i];
            break;
          }
          return n < r ? -1 : r < n ? 1 : 0;
        }, l.isEncoding = function (e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, l.concat = function (e, t) {
          if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e.length) return l.alloc(0);
          var n;
          if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
          var r = l.allocUnsafe(t),
            i = 0;
          for (n = 0; n < e.length; ++n) {
            var a = e[n];
            if (!l.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
            a.copy(r, i), i += a.length;
          }
          return r;
        }, l.byteLength = p, l.prototype._isBuffer = !0, l.prototype.swap16 = function () {
          var e = this.length;
          if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (var t = 0; t < e; t += 2) g(this, t, t + 1);
          return this;
        }, l.prototype.swap32 = function () {
          var e = this.length;
          if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (var t = 0; t < e; t += 4) g(this, t, t + 3), g(this, t + 1, t + 2);
          return this;
        }, l.prototype.swap64 = function () {
          var e = this.length;
          if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (var t = 0; t < e; t += 8) g(this, t, t + 7), g(this, t + 1, t + 6), g(this, t + 2, t + 5), g(this, t + 3, t + 4);
          return this;
        }, l.prototype.toString = function () {
          var e = 0 | this.length;
          return 0 === e ? "" : 0 === arguments.length ? T(this, 0, e) : m.apply(this, arguments);
        }, l.prototype.equals = function (e) {
          if (!l.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          return this === e || 0 === l.compare(this, e);
        }, l.prototype.inspect = function () {
          var e = "",
            n = t.INSPECT_MAX_BYTES;
          return this.length > 0 && (e = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (e += " ... ")), "<Buffer " + e + ">";
        }, l.prototype.compare = function (e, t, n, r, i) {
          if (!l.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw new RangeError("out of range index");
          if (r >= i && t >= n) return 0;
          if (r >= i) return -1;
          if (t >= n) return 1;
          if (this === e) return 0;
          for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), s = Math.min(o, a), u = this.slice(r, i), c = e.slice(t, n), d = 0; d < s; ++d) if (u[d] !== c[d]) {
            o = u[d], a = c[d];
            break;
          }
          return o < a ? -1 : a < o ? 1 : 0;
        }, l.prototype.includes = function (e, t, n) {
          return -1 !== this.indexOf(e, t, n);
        }, l.prototype.indexOf = function (e, t, n) {
          return v(this, e, t, n, !0);
        }, l.prototype.lastIndexOf = function (e, t, n) {
          return v(this, e, t, n, !1);
        }, l.prototype.write = function (e, t, n, r) {
          if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
          }
          var i = this.length - t;
          if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          r || (r = "utf8");
          for (var o = !1;;) switch (r) {
            case "hex":
              return b(this, e, t, n);
            case "utf8":
            case "utf-8":
              return _(this, e, t, n);
            case "ascii":
              return x(this, e, t, n);
            case "latin1":
            case "binary":
              return w(this, e, t, n);
            case "base64":
              return S(this, e, t, n);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return A(this, e, t, n);
            default:
              if (o) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), o = !0;
          }
        }, l.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        function M(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);
          for (var i = t; i < n; ++i) r += String.fromCharCode(127 & e[i]);
          return r;
        }
        function C(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);
          for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
          return r;
        }
        function k(e, t, n) {
          var r = e.length;
          (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
          for (var i = "", o = t; o < n; ++o) i += F(e[o]);
          return i;
        }
        function P(e, t, n) {
          for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) i += String.fromCharCode(r[o] + 256 * r[o + 1]);
          return i;
        }
        function O(e, t, n) {
          if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
          if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
        }
        function R(e, t, n, r, i, o) {
          if (!l.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
          if (n + r > e.length) throw new RangeError("Index out of range");
        }
        function I(e, t, n, r) {
          t < 0 && (t = 65535 + t + 1);
          for (var i = 0, o = Math.min(e.length - n, 2); i < o; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
        }
        function j(e, t, n, r) {
          t < 0 && (t = 4294967295 + t + 1);
          for (var i = 0, o = Math.min(e.length - n, 4); i < o; ++i) e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
        }
        function N(e, t, n, r, i, o) {
          if (n + r > e.length) throw new RangeError("Index out of range");
          if (n < 0) throw new RangeError("Index out of range");
        }
        function L(e, t, n, r, o) {
          return o || N(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
        }
        function D(e, t, n, r, o) {
          return o || N(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
        }
        l.prototype.slice = function (e, t) {
          var n,
            r = this.length;
          if ((e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e), l.TYPED_ARRAY_SUPPORT) (n = this.subarray(e, t)).__proto__ = l.prototype;else {
            var i = t - e;
            n = new l(i, void 0);
            for (var o = 0; o < i; ++o) n[o] = this[o + e];
          }
          return n;
        }, l.prototype.readUIntLE = function (e, t, n) {
          e |= 0, t |= 0, n || O(e, t, this.length);
          for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
          return r;
        }, l.prototype.readUIntBE = function (e, t, n) {
          e |= 0, t |= 0, n || O(e, t, this.length);
          for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
          return r;
        }, l.prototype.readUInt8 = function (e, t) {
          return t || O(e, 1, this.length), this[e];
        }, l.prototype.readUInt16LE = function (e, t) {
          return t || O(e, 2, this.length), this[e] | this[e + 1] << 8;
        }, l.prototype.readUInt16BE = function (e, t) {
          return t || O(e, 2, this.length), this[e] << 8 | this[e + 1];
        }, l.prototype.readUInt32LE = function (e, t) {
          return t || O(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
        }, l.prototype.readUInt32BE = function (e, t) {
          return t || O(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
        }, l.prototype.readIntLE = function (e, t, n) {
          e |= 0, t |= 0, n || O(e, t, this.length);
          for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
          return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
        }, l.prototype.readIntBE = function (e, t, n) {
          e |= 0, t |= 0, n || O(e, t, this.length);
          for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) o += this[e + --r] * i;
          return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
        }, l.prototype.readInt8 = function (e, t) {
          return t || O(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, l.prototype.readInt16LE = function (e, t) {
          t || O(e, 2, this.length);
          var n = this[e] | this[e + 1] << 8;
          return 32768 & n ? 4294901760 | n : n;
        }, l.prototype.readInt16BE = function (e, t) {
          t || O(e, 2, this.length);
          var n = this[e + 1] | this[e] << 8;
          return 32768 & n ? 4294901760 | n : n;
        }, l.prototype.readInt32LE = function (e, t) {
          return t || O(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
        }, l.prototype.readInt32BE = function (e, t) {
          return t || O(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
        }, l.prototype.readFloatLE = function (e, t) {
          return t || O(e, 4, this.length), i.read(this, e, !0, 23, 4);
        }, l.prototype.readFloatBE = function (e, t) {
          return t || O(e, 4, this.length), i.read(this, e, !1, 23, 4);
        }, l.prototype.readDoubleLE = function (e, t) {
          return t || O(e, 8, this.length), i.read(this, e, !0, 52, 8);
        }, l.prototype.readDoubleBE = function (e, t) {
          return t || O(e, 8, this.length), i.read(this, e, !1, 52, 8);
        }, l.prototype.writeUIntLE = function (e, t, n, r) {
          (e = +e, t |= 0, n |= 0, r) || R(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
          var i = 1,
            o = 0;
          for (this[t] = 255 & e; ++o < n && (i *= 256);) this[t + o] = e / i & 255;
          return t + n;
        }, l.prototype.writeUIntBE = function (e, t, n, r) {
          (e = +e, t |= 0, n |= 0, r) || R(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
          var i = n - 1,
            o = 1;
          for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) this[t + i] = e / o & 255;
          return t + n;
        }, l.prototype.writeUInt8 = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 1, 255, 0), l.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
        }, l.prototype.writeUInt16LE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : I(this, e, t, !0), t + 2;
        }, l.prototype.writeUInt16BE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 2, 65535, 0), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : I(this, e, t, !1), t + 2;
        }, l.prototype.writeUInt32LE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : j(this, e, t, !0), t + 4;
        }, l.prototype.writeUInt32BE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 4, 4294967295, 0), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : j(this, e, t, !1), t + 4;
        }, l.prototype.writeIntLE = function (e, t, n, r) {
          if (e = +e, t |= 0, !r) {
            var i = Math.pow(2, 8 * n - 1);
            R(this, e, t, n, i - 1, -i);
          }
          var o = 0,
            a = 1,
            s = 0;
          for (this[t] = 255 & e; ++o < n && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
          return t + n;
        }, l.prototype.writeIntBE = function (e, t, n, r) {
          if (e = +e, t |= 0, !r) {
            var i = Math.pow(2, 8 * n - 1);
            R(this, e, t, n, i - 1, -i);
          }
          var o = n - 1,
            a = 1,
            s = 0;
          for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
          return t + n;
        }, l.prototype.writeInt8 = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 1, 127, -128), l.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
        }, l.prototype.writeInt16LE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : I(this, e, t, !0), t + 2;
        }, l.prototype.writeInt16BE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 2, 32767, -32768), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : I(this, e, t, !1), t + 2;
        }, l.prototype.writeInt32LE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 4, 2147483647, -2147483648), l.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : j(this, e, t, !0), t + 4;
        }, l.prototype.writeInt32BE = function (e, t, n) {
          return e = +e, t |= 0, n || R(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), l.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : j(this, e, t, !1), t + 4;
        }, l.prototype.writeFloatLE = function (e, t, n) {
          return L(this, e, t, !0, n);
        }, l.prototype.writeFloatBE = function (e, t, n) {
          return L(this, e, t, !1, n);
        }, l.prototype.writeDoubleLE = function (e, t, n) {
          return D(this, e, t, !0, n);
        }, l.prototype.writeDoubleBE = function (e, t, n) {
          return D(this, e, t, !1, n);
        }, l.prototype.copy = function (e, t, n, r) {
          if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
          if (0 === e.length || 0 === this.length) return 0;
          if (t < 0) throw new RangeError("targetStart out of bounds");
          if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
          if (r < 0) throw new RangeError("sourceEnd out of bounds");
          r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
          var i,
            o = r - n;
          if (this === e && n < t && t < r) for (i = o - 1; i >= 0; --i) e[i + t] = this[i + n];else if (o < 1e3 || !l.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) e[i + t] = this[i + n];else Uint8Array.prototype.set.call(e, this.subarray(n, n + o), t);
          return o;
        }, l.prototype.fill = function (e, t, n, r) {
          if ("string" == typeof e) {
            if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === e.length) {
              var i = e.charCodeAt(0);
              i < 256 && (e = i);
            }
            if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
            if ("string" == typeof r && !l.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
          } else "number" == typeof e && (e &= 255);
          if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
          if (n <= t) return this;
          var o;
          if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (o = t; o < n; ++o) this[o] = e;else {
            var a = l.isBuffer(e) ? e : z(new l(e, r).toString()),
              s = a.length;
            for (o = 0; o < n - t; ++o) this[o + t] = a[o % s];
          }
          return this;
        };
        var B = /[^+\/0-9A-Za-z-_]/g;
        function F(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }
        function z(e, t) {
          var n;
          t = t || 1 / 0;
          for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
            if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
              if (!i) {
                if (n > 56319) {
                  (t -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }
                if (a + 1 === r) {
                  (t -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }
                i = n;
                continue;
              }
              if (n < 56320) {
                (t -= 3) > -1 && o.push(239, 191, 189), i = n;
                continue;
              }
              n = 65536 + (i - 55296 << 10 | n - 56320);
            } else i && (t -= 3) > -1 && o.push(239, 191, 189);
            if (i = null, n < 128) {
              if ((t -= 1) < 0) break;
              o.push(n);
            } else if (n < 2048) {
              if ((t -= 2) < 0) break;
              o.push(n >> 6 | 192, 63 & n | 128);
            } else if (n < 65536) {
              if ((t -= 3) < 0) break;
              o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
            } else {
              if (!(n < 1114112)) throw new Error("Invalid code point");
              if ((t -= 4) < 0) break;
              o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
            }
          }
          return o;
        }
        function U(e) {
          return r.toByteArray(function (e) {
            if ((e = function (e) {
              return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
            }(e).replace(B, "")).length < 2) return "";
            for (; e.length % 4 != 0;) e += "=";
            return e;
          }(e));
        }
        function G(e, t, n, r) {
          for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
          return i;
        }
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/change-emitter/lib/index.js": function node_modulesChangeEmitterLibIndexJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      t.createChangeEmitter = function () {
        var e = [],
          t = e;
        function n() {
          t === e && (t = e.slice());
        }
        return {
          listen: function listen(e) {
            if ("function" != typeof e) throw new Error("Expected listener to be a function.");
            var r = !0;
            return n(), t.push(e), function () {
              if (r) {
                r = !1, n();
                var i = t.indexOf(e);
                t.splice(i, 1);
              }
            };
          },
          emit: function emit() {
            for (var n = e = t, r = 0; r < n.length; r++) n[r].apply(n, arguments);
          }
        };
      };
    },
    "./node_modules/cipher-base/index.js": function node_modulesCipherBaseIndexJs(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = n("./node_modules/stream-browserify/index.js").Transform,
        o = n("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
      function a(e) {
        i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
      }
      n("./node_modules/inherits/inherits_browser.js")(a, i), a.prototype.update = function (e, t, n) {
        "string" == typeof e && (e = r.from(e, t));
        var i = this._update(e);
        return this.hashMode ? this : (n && (i = this._toString(i, n)), i);
      }, a.prototype.setAutoPadding = function () {}, a.prototype.getAuthTag = function () {
        throw new Error("trying to get auth tag in unsupported state");
      }, a.prototype.setAuthTag = function () {
        throw new Error("trying to set auth tag in unsupported state");
      }, a.prototype.setAAD = function () {
        throw new Error("trying to set aad in unsupported state");
      }, a.prototype._transform = function (e, t, n) {
        var r;
        try {
          this.hashMode ? this._update(e) : this.push(this._update(e));
        } catch (e) {
          r = e;
        } finally {
          n(r);
        }
      }, a.prototype._flush = function (e) {
        var t;
        try {
          this.push(this.__final());
        } catch (e) {
          t = e;
        }
        e(t);
      }, a.prototype._finalOrDigest = function (e) {
        var t = this.__final() || r.alloc(0);
        return e && (t = this._toString(t, e, !0)), t;
      }, a.prototype._toString = function (e, t, n) {
        if (this._decoder || (this._decoder = new o(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
        var r = this._decoder.write(e);
        return n && (r += this._decoder.end()), r;
      }, e.exports = a;
    },
    "./node_modules/classnames/index.js": function node_modulesClassnamesIndexJs(e, t, n) {
      var r;
      /*!
        Copyright (c) 2017 Jed Watson.
        Licensed under the MIT License (MIT), see
        http://jedwatson.github.io/classnames
      */
      !function () {
        "use strict";

        var n = {}.hasOwnProperty;
        function i() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            var r = arguments[t];
            if (r) {
              var o = typeof r;
              if ("string" === o || "number" === o) e.push(r);else if (Array.isArray(r) && r.length) {
                var a = i.apply(null, r);
                a && e.push(a);
              } else if ("object" === o) for (var s in r) n.call(r, s) && r[s] && e.push(s);
            }
          }
          return e.join(" ");
        }
        e.exports ? (i.default = i, e.exports = i) : void 0 === (r = function () {
          return i;
        }.apply(t, [])) || (e.exports = r);
      }();
    },
    "./node_modules/component-classes/index.js": function node_modulesComponentClassesIndexJs(e, t, n) {
      try {
        var r = n("./node_modules/component-indexof/index.js");
      } catch (e) {
        r = n("./node_modules/component-indexof/index.js");
      }
      var i = /\s+/,
        o = Object.prototype.toString;
      function a(e) {
        if (!e || !e.nodeType) throw new Error("A DOM element reference is required");
        this.el = e, this.list = e.classList;
      }
      e.exports = function (e) {
        return new a(e);
      }, a.prototype.add = function (e) {
        if (this.list) return this.list.add(e), this;
        var t = this.array();
        return ~r(t, e) || t.push(e), this.el.className = t.join(" "), this;
      }, a.prototype.remove = function (e) {
        if ("[object RegExp]" == o.call(e)) return this.removeMatching(e);
        if (this.list) return this.list.remove(e), this;
        var t = this.array(),
          n = r(t, e);
        return ~n && t.splice(n, 1), this.el.className = t.join(" "), this;
      }, a.prototype.removeMatching = function (e) {
        for (var t = this.array(), n = 0; n < t.length; n++) e.test(t[n]) && this.remove(t[n]);
        return this;
      }, a.prototype.toggle = function (e, t) {
        return this.list ? (void 0 !== t ? t !== this.list.toggle(e, t) && this.list.toggle(e) : this.list.toggle(e), this) : (void 0 !== t ? t ? this.add(e) : this.remove(e) : this.has(e) ? this.remove(e) : this.add(e), this);
      }, a.prototype.array = function () {
        var e = (this.el.getAttribute("class") || "").replace(/^\s+|\s+$/g, "").split(i);
        return "" === e[0] && e.shift(), e;
      }, a.prototype.has = a.prototype.contains = function (e) {
        return this.list ? this.list.contains(e) : !!~r(this.array(), e);
      };
    },
    "./node_modules/component-indexof/index.js": function node_modulesComponentIndexofIndexJs(e, t) {
      e.exports = function (e, t) {
        if (e.indexOf) return e.indexOf(t);
        for (var n = 0; n < e.length; ++n) if (e[n] === t) return n;
        return -1;
      };
    },
    "./node_modules/core-util-is/lib/util.js": function node_modulesCoreUtilIsLibUtilJs(e, t, n) {
      (function (e) {
        function n(e) {
          return Object.prototype.toString.call(e);
        }
        t.isArray = function (e) {
          return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
        }, t.isBoolean = function (e) {
          return "boolean" == typeof e;
        }, t.isNull = function (e) {
          return null === e;
        }, t.isNullOrUndefined = function (e) {
          return null == e;
        }, t.isNumber = function (e) {
          return "number" == typeof e;
        }, t.isString = function (e) {
          return "string" == typeof e;
        }, t.isSymbol = function (e) {
          return "symbol" == typeof e;
        }, t.isUndefined = function (e) {
          return void 0 === e;
        }, t.isRegExp = function (e) {
          return "[object RegExp]" === n(e);
        }, t.isObject = function (e) {
          return "object" == typeof e && null !== e;
        }, t.isDate = function (e) {
          return "[object Date]" === n(e);
        }, t.isError = function (e) {
          return "[object Error]" === n(e) || e instanceof Error;
        }, t.isFunction = function (e) {
          return "function" == typeof e;
        }, t.isPrimitive = function (e) {
          return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
        }, t.isBuffer = e.isBuffer;
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/create-ecdh/browser.js": function node_modulesCreateEcdhBrowserJs(e, t, n) {
      (function (t) {
        var r = n("./node_modules/elliptic/lib/elliptic.js"),
          i = n("./node_modules/bn.js/lib/bn.js");
        e.exports = function (e) {
          return new a(e);
        };
        var o = {
          secp256k1: {
            name: "secp256k1",
            byteLength: 32
          },
          secp224r1: {
            name: "p224",
            byteLength: 28
          },
          prime256v1: {
            name: "p256",
            byteLength: 32
          },
          prime192v1: {
            name: "p192",
            byteLength: 24
          },
          ed25519: {
            name: "ed25519",
            byteLength: 32
          },
          secp384r1: {
            name: "p384",
            byteLength: 48
          },
          secp521r1: {
            name: "p521",
            byteLength: 66
          }
        };
        function a(e) {
          this.curveType = o[e], this.curveType || (this.curveType = {
            name: e
          }), this.curve = new r.ec(this.curveType.name), this.keys = void 0;
        }
        function s(e, n, r) {
          Array.isArray(e) || (e = e.toArray());
          var i = new t(e);
          if (r && i.length < r) {
            var o = new t(r - i.length);
            o.fill(0), i = t.concat([o, i]);
          }
          return n ? i.toString(n) : i;
        }
        o.p224 = o.secp224r1, o.p256 = o.secp256r1 = o.prime256v1, o.p192 = o.secp192r1 = o.prime192v1, o.p384 = o.secp384r1, o.p521 = o.secp521r1, a.prototype.generateKeys = function (e, t) {
          return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
        }, a.prototype.computeSecret = function (e, n, r) {
          return n = n || "utf8", t.isBuffer(e) || (e = new t(e, n)), s(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), r, this.curveType.byteLength);
        }, a.prototype.getPublicKey = function (e, t) {
          var n = this.keys.getPublic("compressed" === t, !0);
          return "hybrid" === t && (n[n.length - 1] % 2 ? n[0] = 7 : n[0] = 6), s(n, e);
        }, a.prototype.getPrivateKey = function (e) {
          return s(this.keys.getPrivate(), e);
        }, a.prototype.setPublicKey = function (e, n) {
          return n = n || "utf8", t.isBuffer(e) || (e = new t(e, n)), this.keys._importPublic(e), this;
        }, a.prototype.setPrivateKey = function (e, n) {
          n = n || "utf8", t.isBuffer(e) || (e = new t(e, n));
          var r = new i(e);
          return r = r.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(r), this;
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/create-hash/browser.js": function node_modulesCreateHashBrowserJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/md5.js/index.js"),
        o = n("./node_modules/ripemd160/index.js"),
        a = n("./node_modules/sha.js/index.js"),
        s = n("./node_modules/cipher-base/index.js");
      function l(e) {
        s.call(this, "digest"), this._hash = e;
      }
      r(l, s), l.prototype._update = function (e) {
        this._hash.update(e);
      }, l.prototype._final = function () {
        return this._hash.digest();
      }, e.exports = function (e) {
        return "md5" === (e = e.toLowerCase()) ? new i() : "rmd160" === e || "ripemd160" === e ? new o() : new l(a(e));
      };
    },
    "./node_modules/create-hash/md5.js": function node_modulesCreateHashMd5Js(e, t, n) {
      var r = n("./node_modules/md5.js/index.js");
      e.exports = function (e) {
        return new r().update(e).digest();
      };
    },
    "./node_modules/create-hmac/browser.js": function node_modulesCreateHmacBrowserJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/create-hmac/legacy.js"),
        o = n("./node_modules/cipher-base/index.js"),
        a = n("./node_modules/safe-buffer/index.js").Buffer,
        s = n("./node_modules/create-hash/md5.js"),
        l = n("./node_modules/ripemd160/index.js"),
        u = n("./node_modules/sha.js/index.js"),
        c = a.alloc(128);
      function d(e, t) {
        o.call(this, "digest"), "string" == typeof t && (t = a.from(t));
        var n = "sha512" === e || "sha384" === e ? 128 : 64;
        (this._alg = e, this._key = t, t.length > n) ? t = ("rmd160" === e ? new l() : u(e)).update(t).digest() : t.length < n && (t = a.concat([t, c], n));
        for (var r = this._ipad = a.allocUnsafe(n), i = this._opad = a.allocUnsafe(n), s = 0; s < n; s++) r[s] = 54 ^ t[s], i[s] = 92 ^ t[s];
        this._hash = "rmd160" === e ? new l() : u(e), this._hash.update(r);
      }
      r(d, o), d.prototype._update = function (e) {
        this._hash.update(e);
      }, d.prototype._final = function () {
        var e = this._hash.digest();
        return ("rmd160" === this._alg ? new l() : u(this._alg)).update(this._opad).update(e).digest();
      }, e.exports = function (e, t) {
        return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new d("rmd160", t) : "md5" === e ? new i(s, t) : new d(e, t);
      };
    },
    "./node_modules/create-hmac/legacy.js": function node_modulesCreateHmacLegacyJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer,
        o = n("./node_modules/cipher-base/index.js"),
        a = i.alloc(128);
      function s(e, t) {
        o.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([t, a], 64));
        for (var n = this._ipad = i.allocUnsafe(64), r = this._opad = i.allocUnsafe(64), s = 0; s < 64; s++) n[s] = 54 ^ t[s], r[s] = 92 ^ t[s];
        this._hash = [n];
      }
      r(s, o), s.prototype._update = function (e) {
        this._hash.push(e);
      }, s.prototype._final = function () {
        var e = this._alg(i.concat(this._hash));
        return this._alg(i.concat([this._opad, e]));
      }, e.exports = s;
    },
    "./node_modules/create-react-context/lib/implementation.js": function node_modulesCreateReactContextLibImplementationJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r = n("react"),
        i = (a(r), a(n("./node_modules/prop-types/index.js"))),
        o = a(n("./node_modules/gud/index.js"));
      a(n("./node_modules/warning/warning.js"));
      function a(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function l(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }
      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }
      function c(e) {
        var t = [];
        return {
          on: function on(e) {
            t.push(e);
          },
          off: function off(e) {
            t = t.filter(function (t) {
              return t !== e;
            });
          },
          get: function get() {
            return e;
          },
          set: function set(n, r) {
            e = n, t.forEach(function (t) {
              return t(e, r);
            });
          }
        };
      }
      t.default = function (e, t) {
        var n,
          a,
          d = "__create-react-context-" + (0, o.default)() + "__",
          h = function (e) {
            function n() {
              var t, r;
              s(this, n);
              for (var i = arguments.length, o = Array(i), a = 0; a < i; a++) o[a] = arguments[a];
              return t = r = l(this, e.call.apply(e, [this].concat(o))), r.emitter = c(r.props.value), l(r, t);
            }
            return u(n, e), n.prototype.getChildContext = function () {
              var e;
              return (e = {})[d] = this.emitter, e;
            }, n.prototype.componentWillReceiveProps = function (e) {
              if (this.props.value !== e.value) {
                var n = this.props.value,
                  r = e.value,
                  i = void 0;
                ((o = n) === (a = r) ? 0 !== o || 1 / o == 1 / a : o != o && a != a) ? i = 0 : (i = "function" == typeof t ? t(n, r) : 1073741823, 0 !== (i |= 0) && this.emitter.set(e.value, i));
              }
              var o, a;
            }, n.prototype.render = function () {
              return this.props.children;
            }, n;
          }(r.Component);
        h.childContextTypes = ((n = {})[d] = i.default.object.isRequired, n);
        var f = function (t) {
          function n() {
            var e, r;
            s(this, n);
            for (var i = arguments.length, o = Array(i), a = 0; a < i; a++) o[a] = arguments[a];
            return e = r = l(this, t.call.apply(t, [this].concat(o))), r.state = {
              value: r.getValue()
            }, r.onUpdate = function (e, t) {
              0 != ((0 | r.observedBits) & t) && r.setState({
                value: r.getValue()
              });
            }, l(r, e);
          }
          return u(n, t), n.prototype.componentWillReceiveProps = function (e) {
            var t = e.observedBits;
            this.observedBits = null == t ? 1073741823 : t;
          }, n.prototype.componentDidMount = function () {
            this.context[d] && this.context[d].on(this.onUpdate);
            var e = this.props.observedBits;
            this.observedBits = null == e ? 1073741823 : e;
          }, n.prototype.componentWillUnmount = function () {
            this.context[d] && this.context[d].off(this.onUpdate);
          }, n.prototype.getValue = function () {
            return this.context[d] ? this.context[d].get() : e;
          }, n.prototype.render = function () {
            return (e = this.props.children, Array.isArray(e) ? e[0] : e)(this.state.value);
            var e;
          }, n;
        }(r.Component);
        return f.contextTypes = ((a = {})[d] = i.default.object, a), {
          Provider: h,
          Consumer: f
        };
      }, e.exports = t.default;
    },
    "./node_modules/create-react-context/lib/index.js": function node_modulesCreateReactContextLibIndexJs(e, t, n) {
      "use strict";

      t.__esModule = !0;
      var r = o(n("react")),
        i = o(n("./node_modules/create-react-context/lib/implementation.js"));
      function o(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      t.default = r.default.createContext || i.default, e.exports = t.default;
    },
    "./node_modules/crypto-browserify/index.js": function node_modulesCryptoBrowserifyIndexJs(e, t, n) {
      "use strict";

      t.randomBytes = t.rng = t.pseudoRandomBytes = t.prng = n("./node_modules/randombytes/browser.js"), t.createHash = t.Hash = n("./node_modules/create-hash/browser.js"), t.createHmac = t.Hmac = n("./node_modules/create-hmac/browser.js");
      var r = n("./node_modules/browserify-sign/algos.js"),
        i = Object.keys(r),
        o = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(i);
      t.getHashes = function () {
        return o;
      };
      var a = n("./node_modules/pbkdf2/browser.js");
      t.pbkdf2 = a.pbkdf2, t.pbkdf2Sync = a.pbkdf2Sync;
      var s = n("./node_modules/browserify-cipher/browser.js");
      t.Cipher = s.Cipher, t.createCipher = s.createCipher, t.Cipheriv = s.Cipheriv, t.createCipheriv = s.createCipheriv, t.Decipher = s.Decipher, t.createDecipher = s.createDecipher, t.Decipheriv = s.Decipheriv, t.createDecipheriv = s.createDecipheriv, t.getCiphers = s.getCiphers, t.listCiphers = s.listCiphers;
      var l = n("./node_modules/diffie-hellman/browser.js");
      t.DiffieHellmanGroup = l.DiffieHellmanGroup, t.createDiffieHellmanGroup = l.createDiffieHellmanGroup, t.getDiffieHellman = l.getDiffieHellman, t.createDiffieHellman = l.createDiffieHellman, t.DiffieHellman = l.DiffieHellman;
      var u = n("./node_modules/browserify-sign/browser/index.js");
      t.createSign = u.createSign, t.Sign = u.Sign, t.createVerify = u.createVerify, t.Verify = u.Verify, t.createECDH = n("./node_modules/create-ecdh/browser.js");
      var c = n("./node_modules/public-encrypt/browser.js");
      t.publicEncrypt = c.publicEncrypt, t.privateEncrypt = c.privateEncrypt, t.publicDecrypt = c.publicDecrypt, t.privateDecrypt = c.privateDecrypt;
      var d = n("./node_modules/randomfill/browser.js");
      t.randomFill = d.randomFill, t.randomFillSync = d.randomFillSync, t.createCredentials = function () {
        throw new Error(["sorry, createCredentials is not implemented yet", "we accept pull requests", "https://github.com/crypto-browserify/crypto-browserify"].join("\n"));
      }, t.constants = {
        DH_CHECK_P_NOT_SAFE_PRIME: 2,
        DH_CHECK_P_NOT_PRIME: 1,
        DH_UNABLE_TO_CHECK_GENERATOR: 4,
        DH_NOT_SUITABLE_GENERATOR: 8,
        NPN_ENABLED: 1,
        ALPN_ENABLED: 1,
        RSA_PKCS1_PADDING: 1,
        RSA_SSLV23_PADDING: 2,
        RSA_NO_PADDING: 3,
        RSA_PKCS1_OAEP_PADDING: 4,
        RSA_X931_PADDING: 5,
        RSA_PKCS1_PSS_PADDING: 6,
        POINT_CONVERSION_COMPRESSED: 2,
        POINT_CONVERSION_UNCOMPRESSED: 4,
        POINT_CONVERSION_HYBRID: 6
      };
    },
    "./node_modules/deep-equal/index.js": function node_modulesDeepEqualIndexJs(e, t, n) {
      var r = n("./node_modules/object-keys/index.js"),
        i = n("./node_modules/is-arguments/index.js"),
        o = n("./node_modules/object-is/index.js"),
        a = n("./node_modules/is-regex/index.js"),
        s = n("./node_modules/regexp.prototype.flags/index.js"),
        l = n("./node_modules/is-date-object/index.js"),
        u = Date.prototype.getTime;
      function c(e, t, n) {
        var f = n || {};
        return !!(f.strict ? o(e, t) : e === t) || (!e || !t || "object" != typeof e && "object" != typeof t ? f.strict ? o(e, t) : e == t : function (e, t, n) {
          var o, f;
          if (typeof e != typeof t) return !1;
          if (d(e) || d(t)) return !1;
          if (e.prototype !== t.prototype) return !1;
          if (i(e) !== i(t)) return !1;
          var p = a(e),
            m = a(t);
          if (p !== m) return !1;
          if (p || m) return e.source === t.source && s(e) === s(t);
          if (l(e) && l(t)) return u.call(e) === u.call(t);
          var g = h(e),
            v = h(t);
          if (g !== v) return !1;
          if (g || v) {
            if (e.length !== t.length) return !1;
            for (o = 0; o < e.length; o++) if (e[o] !== t[o]) return !1;
            return !0;
          }
          if (typeof e != typeof t) return !1;
          try {
            var y = r(e),
              b = r(t);
          } catch (e) {
            return !1;
          }
          if (y.length !== b.length) return !1;
          for (y.sort(), b.sort(), o = y.length - 1; o >= 0; o--) if (y[o] != b[o]) return !1;
          for (o = y.length - 1; o >= 0; o--) if (f = y[o], !c(e[f], t[f], n)) return !1;
          return !0;
        }(e, t, f));
      }
      function d(e) {
        return null == e;
      }
      function h(e) {
        return !(!e || "object" != typeof e || "number" != typeof e.length) && "function" == typeof e.copy && "function" == typeof e.slice && !(e.length > 0 && "number" != typeof e[0]);
      }
      e.exports = c;
    },
    "./node_modules/define-properties/index.js": function node_modulesDefinePropertiesIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/object-keys/index.js"),
        i = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
        o = Object.prototype.toString,
        a = Array.prototype.concat,
        s = Object.defineProperty,
        l = s && function () {
          var e = {};
          try {
            for (var t in s(e, "x", {
              enumerable: !1,
              value: e
            }), e) return !1;
            return e.x === e;
          } catch (e) {
            return !1;
          }
        }(),
        u = function u(e, t, n, r) {
          var i;
          (!(t in e) || "function" == typeof (i = r) && "[object Function]" === o.call(i) && r()) && (l ? s(e, t, {
            configurable: !0,
            enumerable: !1,
            value: n,
            writable: !0
          }) : e[t] = n);
        },
        c = function c(e, t) {
          var n = arguments.length > 2 ? arguments[2] : {},
            o = r(t);
          i && (o = a.call(o, Object.getOwnPropertySymbols(t)));
          for (var s = 0; s < o.length; s += 1) u(e, o[s], t[o[s]], n[o[s]]);
        };
      c.supportsDescriptors = !!l, e.exports = c;
    },
    "./node_modules/des.js/lib/des.js": function node_modulesDesJsLibDesJs(e, t, n) {
      "use strict";

      t.utils = n("./node_modules/des.js/lib/des/utils.js"), t.Cipher = n("./node_modules/des.js/lib/des/cipher.js"), t.DES = n("./node_modules/des.js/lib/des/des.js"), t.CBC = n("./node_modules/des.js/lib/des/cbc.js"), t.EDE = n("./node_modules/des.js/lib/des/ede.js");
    },
    "./node_modules/des.js/lib/des/cbc.js": function node_modulesDesJsLibDesCbcJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/minimalistic-assert/index.js"),
        i = n("./node_modules/inherits/inherits_browser.js"),
        o = {};
      function a(e) {
        r.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
        for (var t = 0; t < this.iv.length; t++) this.iv[t] = e[t];
      }
      t.instantiate = function (e) {
        function t(t) {
          e.call(this, t), this._cbcInit();
        }
        i(t, e);
        for (var n = Object.keys(o), r = 0; r < n.length; r++) {
          var a = n[r];
          t.prototype[a] = o[a];
        }
        return t.create = function (e) {
          return new t(e);
        }, t;
      }, o._cbcInit = function () {
        var e = new a(this.options.iv);
        this._cbcState = e;
      }, o._update = function (e, t, n, r) {
        var i = this._cbcState,
          o = this.constructor.super_.prototype,
          a = i.iv;
        if ("encrypt" === this.type) {
          for (var s = 0; s < this.blockSize; s++) a[s] ^= e[t + s];
          o._update.call(this, a, 0, n, r);
          for (s = 0; s < this.blockSize; s++) a[s] = n[r + s];
        } else {
          o._update.call(this, e, t, n, r);
          for (s = 0; s < this.blockSize; s++) n[r + s] ^= a[s];
          for (s = 0; s < this.blockSize; s++) a[s] = e[t + s];
        }
      };
    },
    "./node_modules/des.js/lib/des/cipher.js": function node_modulesDesJsLibDesCipherJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/minimalistic-assert/index.js");
      function i(e) {
        this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0;
      }
      e.exports = i, i.prototype._init = function () {}, i.prototype.update = function (e) {
        return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
      }, i.prototype._buffer = function (e, t) {
        for (var n = Math.min(this.buffer.length - this.bufferOff, e.length - t), r = 0; r < n; r++) this.buffer[this.bufferOff + r] = e[t + r];
        return this.bufferOff += n, n;
      }, i.prototype._flushBuffer = function (e, t) {
        return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
      }, i.prototype._updateEncrypt = function (e) {
        var t = 0,
          n = 0,
          r = (this.bufferOff + e.length) / this.blockSize | 0,
          i = new Array(r * this.blockSize);
        0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (n += this._flushBuffer(i, n)));
        for (var o = e.length - (e.length - t) % this.blockSize; t < o; t += this.blockSize) this._update(e, t, i, n), n += this.blockSize;
        for (; t < e.length; t++, this.bufferOff++) this.buffer[this.bufferOff] = e[t];
        return i;
      }, i.prototype._updateDecrypt = function (e) {
        for (var t = 0, n = 0, r = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(r * this.blockSize); r > 0; r--) t += this._buffer(e, t), n += this._flushBuffer(i, n);
        return t += this._buffer(e, t), i;
      }, i.prototype.final = function (e) {
        var t, n;
        return e && (t = this.update(e)), n = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(n) : n;
      }, i.prototype._pad = function (e, t) {
        if (0 === t) return !1;
        for (; t < e.length;) e[t++] = 0;
        return !0;
      }, i.prototype._finalEncrypt = function () {
        if (!this._pad(this.buffer, this.bufferOff)) return [];
        var e = new Array(this.blockSize);
        return this._update(this.buffer, 0, e, 0), e;
      }, i.prototype._unpad = function (e) {
        return e;
      }, i.prototype._finalDecrypt = function () {
        r.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
        var e = new Array(this.blockSize);
        return this._flushBuffer(e, 0), this._unpad(e);
      };
    },
    "./node_modules/des.js/lib/des/des.js": function node_modulesDesJsLibDesDesJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/minimalistic-assert/index.js"),
        i = n("./node_modules/inherits/inherits_browser.js"),
        o = n("./node_modules/des.js/lib/des/utils.js"),
        a = n("./node_modules/des.js/lib/des/cipher.js");
      function s() {
        this.tmp = new Array(2), this.keys = null;
      }
      function l(e) {
        a.call(this, e);
        var t = new s();
        this._desState = t, this.deriveKeys(t, e.key);
      }
      i(l, a), e.exports = l, l.create = function (e) {
        return new l(e);
      };
      var u = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
      l.prototype.deriveKeys = function (e, t) {
        e.keys = new Array(32), r.equal(t.length, this.blockSize, "Invalid key length");
        var n = o.readUInt32BE(t, 0),
          i = o.readUInt32BE(t, 4);
        o.pc1(n, i, e.tmp, 0), n = e.tmp[0], i = e.tmp[1];
        for (var a = 0; a < e.keys.length; a += 2) {
          var s = u[a >>> 1];
          n = o.r28shl(n, s), i = o.r28shl(i, s), o.pc2(n, i, e.keys, a);
        }
      }, l.prototype._update = function (e, t, n, r) {
        var i = this._desState,
          a = o.readUInt32BE(e, t),
          s = o.readUInt32BE(e, t + 4);
        o.ip(a, s, i.tmp, 0), a = i.tmp[0], s = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, a, s, i.tmp, 0) : this._decrypt(i, a, s, i.tmp, 0), a = i.tmp[0], s = i.tmp[1], o.writeUInt32BE(n, a, r), o.writeUInt32BE(n, s, r + 4);
      }, l.prototype._pad = function (e, t) {
        for (var n = e.length - t, r = t; r < e.length; r++) e[r] = n;
        return !0;
      }, l.prototype._unpad = function (e) {
        for (var t = e[e.length - 1], n = e.length - t; n < e.length; n++) r.equal(e[n], t);
        return e.slice(0, e.length - t);
      }, l.prototype._encrypt = function (e, t, n, r, i) {
        for (var a = t, s = n, l = 0; l < e.keys.length; l += 2) {
          var u = e.keys[l],
            c = e.keys[l + 1];
          o.expand(s, e.tmp, 0), u ^= e.tmp[0], c ^= e.tmp[1];
          var d = o.substitute(u, c),
            h = s;
          s = (a ^ o.permute(d)) >>> 0, a = h;
        }
        o.rip(s, a, r, i);
      }, l.prototype._decrypt = function (e, t, n, r, i) {
        for (var a = n, s = t, l = e.keys.length - 2; l >= 0; l -= 2) {
          var u = e.keys[l],
            c = e.keys[l + 1];
          o.expand(a, e.tmp, 0), u ^= e.tmp[0], c ^= e.tmp[1];
          var d = o.substitute(u, c),
            h = a;
          a = (s ^ o.permute(d)) >>> 0, s = h;
        }
        o.rip(a, s, r, i);
      };
    },
    "./node_modules/des.js/lib/des/ede.js": function node_modulesDesJsLibDesEdeJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/minimalistic-assert/index.js"),
        i = n("./node_modules/inherits/inherits_browser.js"),
        o = n("./node_modules/des.js/lib/des/cipher.js"),
        a = n("./node_modules/des.js/lib/des/des.js");
      function s(e, t) {
        r.equal(t.length, 24, "Invalid key length");
        var n = t.slice(0, 8),
          i = t.slice(8, 16),
          o = t.slice(16, 24);
        this.ciphers = "encrypt" === e ? [a.create({
          type: "encrypt",
          key: n
        }), a.create({
          type: "decrypt",
          key: i
        }), a.create({
          type: "encrypt",
          key: o
        })] : [a.create({
          type: "decrypt",
          key: o
        }), a.create({
          type: "encrypt",
          key: i
        }), a.create({
          type: "decrypt",
          key: n
        })];
      }
      function l(e) {
        o.call(this, e);
        var t = new s(this.type, this.options.key);
        this._edeState = t;
      }
      i(l, o), e.exports = l, l.create = function (e) {
        return new l(e);
      }, l.prototype._update = function (e, t, n, r) {
        var i = this._edeState;
        i.ciphers[0]._update(e, t, n, r), i.ciphers[1]._update(n, r, n, r), i.ciphers[2]._update(n, r, n, r);
      }, l.prototype._pad = a.prototype._pad, l.prototype._unpad = a.prototype._unpad;
    },
    "./node_modules/des.js/lib/des/utils.js": function node_modulesDesJsLibDesUtilsJs(e, t, n) {
      "use strict";

      t.readUInt32BE = function (e, t) {
        return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
      }, t.writeUInt32BE = function (e, t, n) {
        e[0 + n] = t >>> 24, e[1 + n] = t >>> 16 & 255, e[2 + n] = t >>> 8 & 255, e[3 + n] = 255 & t;
      }, t.ip = function (e, t, n, r) {
        for (var i = 0, o = 0, a = 6; a >= 0; a -= 2) {
          for (var s = 0; s <= 24; s += 8) i <<= 1, i |= t >>> s + a & 1;
          for (s = 0; s <= 24; s += 8) i <<= 1, i |= e >>> s + a & 1;
        }
        for (a = 6; a >= 0; a -= 2) {
          for (s = 1; s <= 25; s += 8) o <<= 1, o |= t >>> s + a & 1;
          for (s = 1; s <= 25; s += 8) o <<= 1, o |= e >>> s + a & 1;
        }
        n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
      }, t.rip = function (e, t, n, r) {
        for (var i = 0, o = 0, a = 0; a < 4; a++) for (var s = 24; s >= 0; s -= 8) i <<= 1, i |= t >>> s + a & 1, i <<= 1, i |= e >>> s + a & 1;
        for (a = 4; a < 8; a++) for (s = 24; s >= 0; s -= 8) o <<= 1, o |= t >>> s + a & 1, o <<= 1, o |= e >>> s + a & 1;
        n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
      }, t.pc1 = function (e, t, n, r) {
        for (var i = 0, o = 0, a = 7; a >= 5; a--) {
          for (var s = 0; s <= 24; s += 8) i <<= 1, i |= t >> s + a & 1;
          for (s = 0; s <= 24; s += 8) i <<= 1, i |= e >> s + a & 1;
        }
        for (s = 0; s <= 24; s += 8) i <<= 1, i |= t >> s + a & 1;
        for (a = 1; a <= 3; a++) {
          for (s = 0; s <= 24; s += 8) o <<= 1, o |= t >> s + a & 1;
          for (s = 0; s <= 24; s += 8) o <<= 1, o |= e >> s + a & 1;
        }
        for (s = 0; s <= 24; s += 8) o <<= 1, o |= e >> s + a & 1;
        n[r + 0] = i >>> 0, n[r + 1] = o >>> 0;
      }, t.r28shl = function (e, t) {
        return e << t & 268435455 | e >>> 28 - t;
      };
      var r = [14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26, 15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24];
      t.pc2 = function (e, t, n, i) {
        for (var o = 0, a = 0, s = r.length >>> 1, l = 0; l < s; l++) o <<= 1, o |= e >>> r[l] & 1;
        for (l = s; l < r.length; l++) a <<= 1, a |= t >>> r[l] & 1;
        n[i + 0] = o >>> 0, n[i + 1] = a >>> 0;
      }, t.expand = function (e, t, n) {
        var r = 0,
          i = 0;
        r = (1 & e) << 5 | e >>> 27;
        for (var o = 23; o >= 15; o -= 4) r <<= 6, r |= e >>> o & 63;
        for (o = 11; o >= 3; o -= 4) i |= e >>> o & 63, i <<= 6;
        i |= (31 & e) << 1 | e >>> 31, t[n + 0] = r >>> 0, t[n + 1] = i >>> 0;
      };
      var i = [14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11];
      t.substitute = function (e, t) {
        for (var n = 0, r = 0; r < 4; r++) {
          n <<= 4, n |= i[64 * r + (e >>> 18 - 6 * r & 63)];
        }
        for (r = 0; r < 4; r++) {
          n <<= 4, n |= i[256 + 64 * r + (t >>> 18 - 6 * r & 63)];
        }
        return n >>> 0;
      };
      var o = [16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7];
      t.permute = function (e) {
        for (var t = 0, n = 0; n < o.length; n++) t <<= 1, t |= e >>> o[n] & 1;
        return t >>> 0;
      }, t.padSplit = function (e, t, n) {
        for (var r = e.toString(2); r.length < t;) r = "0" + r;
        for (var i = [], o = 0; o < t; o += n) i.push(r.slice(o, o + n));
        return i.join(" ");
      };
    },
    "./node_modules/diffie-hellman/browser.js": function node_modulesDiffieHellmanBrowserJs(e, t, n) {
      (function (e) {
        var r = n("./node_modules/diffie-hellman/lib/generatePrime.js"),
          i = n("./node_modules/diffie-hellman/lib/primes.json"),
          o = n("./node_modules/diffie-hellman/lib/dh.js");
        var a = {
          binary: !0,
          hex: !0,
          base64: !0
        };
        t.DiffieHellmanGroup = t.createDiffieHellmanGroup = t.getDiffieHellman = function (t) {
          var n = new e(i[t].prime, "hex"),
            r = new e(i[t].gen, "hex");
          return new o(n, r);
        }, t.createDiffieHellman = t.DiffieHellman = function t(n, i, s, l) {
          return e.isBuffer(i) || void 0 === a[i] ? t(n, "binary", i, s) : (i = i || "binary", l = l || "binary", s = s || new e([2]), e.isBuffer(s) || (s = new e(s, l)), "number" == typeof n ? new o(r(n, s), s, !0) : (e.isBuffer(n) || (n = new e(n, i)), new o(n, s, !0)));
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/diffie-hellman/lib/dh.js": function node_modulesDiffieHellmanLibDhJs(e, t, n) {
      (function (t) {
        var r = n("./node_modules/bn.js/lib/bn.js"),
          i = new (n("./node_modules/miller-rabin/lib/mr.js"))(),
          o = new r(24),
          a = new r(11),
          s = new r(10),
          l = new r(3),
          u = new r(7),
          c = n("./node_modules/diffie-hellman/lib/generatePrime.js"),
          d = n("./node_modules/randombytes/browser.js");
        function h(e, n) {
          return n = n || "utf8", t.isBuffer(e) || (e = new t(e, n)), this._pub = new r(e), this;
        }
        function f(e, n) {
          return n = n || "utf8", t.isBuffer(e) || (e = new t(e, n)), this._priv = new r(e), this;
        }
        e.exports = m;
        var p = {};
        function m(e, t, n) {
          this.setGenerator(t), this.__prime = new r(e), this._prime = r.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, n ? (this.setPublicKey = h, this.setPrivateKey = f) : this._primeCode = 8;
        }
        function g(e, n) {
          var r = new t(e.toArray());
          return n ? r.toString(n) : r;
        }
        Object.defineProperty(m.prototype, "verifyError", {
          enumerable: !0,
          get: function get() {
            return "number" != typeof this._primeCode && (this._primeCode = function (e, t) {
              var n = t.toString("hex"),
                r = [n, e.toString(16)].join("_");
              if (r in p) return p[r];
              var d,
                h = 0;
              if (e.isEven() || !c.simpleSieve || !c.fermatTest(e) || !i.test(e)) return h += 1, h += "02" === n || "05" === n ? 8 : 4, p[r] = h, h;
              switch (i.test(e.shrn(1)) || (h += 2), n) {
                case "02":
                  e.mod(o).cmp(a) && (h += 8);
                  break;
                case "05":
                  (d = e.mod(s)).cmp(l) && d.cmp(u) && (h += 8);
                  break;
                default:
                  h += 4;
              }
              return p[r] = h, h;
            }(this.__prime, this.__gen)), this._primeCode;
          }
        }), m.prototype.generateKeys = function () {
          return this._priv || (this._priv = new r(d(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
        }, m.prototype.computeSecret = function (e) {
          var n = (e = (e = new r(e)).toRed(this._prime)).redPow(this._priv).fromRed(),
            i = new t(n.toArray()),
            o = this.getPrime();
          if (i.length < o.length) {
            var a = new t(o.length - i.length);
            a.fill(0), i = t.concat([a, i]);
          }
          return i;
        }, m.prototype.getPublicKey = function (e) {
          return g(this._pub, e);
        }, m.prototype.getPrivateKey = function (e) {
          return g(this._priv, e);
        }, m.prototype.getPrime = function (e) {
          return g(this.__prime, e);
        }, m.prototype.getGenerator = function (e) {
          return g(this._gen, e);
        }, m.prototype.setGenerator = function (e, n) {
          return n = n || "utf8", t.isBuffer(e) || (e = new t(e, n)), this.__gen = e, this._gen = new r(e), this;
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/diffie-hellman/lib/generatePrime.js": function node_modulesDiffieHellmanLibGeneratePrimeJs(e, t, n) {
      var r = n("./node_modules/randombytes/browser.js");
      e.exports = y, y.simpleSieve = g, y.fermatTest = v;
      var i = n("./node_modules/bn.js/lib/bn.js"),
        o = new i(24),
        a = new (n("./node_modules/miller-rabin/lib/mr.js"))(),
        s = new i(1),
        l = new i(2),
        u = new i(5),
        c = (new i(16), new i(8), new i(10)),
        d = new i(3),
        h = (new i(7), new i(11)),
        f = new i(4),
        p = (new i(12), null);
      function m() {
        if (null !== p) return p;
        var e = [];
        e[0] = 2;
        for (var t = 1, n = 3; n < 1048576; n += 2) {
          for (var r = Math.ceil(Math.sqrt(n)), i = 0; i < t && e[i] <= r && n % e[i] != 0; i++);
          t !== i && e[i] <= r || (e[t++] = n);
        }
        return p = e, e;
      }
      function g(e) {
        for (var t = m(), n = 0; n < t.length; n++) if (0 === e.modn(t[n])) return 0 === e.cmpn(t[n]);
        return !0;
      }
      function v(e) {
        var t = i.mont(e);
        return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
      }
      function y(e, t) {
        if (e < 16) return new i(2 === t || 5 === t ? [140, 123] : [140, 39]);
        var n, p;
        for (t = new i(t);;) {
          for (n = new i(r(Math.ceil(e / 8))); n.bitLength() > e;) n.ishrn(1);
          if (n.isEven() && n.iadd(s), n.testn(1) || n.iadd(l), t.cmp(l)) {
            if (!t.cmp(u)) for (; n.mod(c).cmp(d);) n.iadd(f);
          } else for (; n.mod(o).cmp(h);) n.iadd(f);
          if (g(p = n.shrn(1)) && g(n) && v(p) && v(n) && a.test(p) && a.test(n)) return n;
        }
      }
    },
    "./node_modules/diffie-hellman/lib/primes.json": function node_modulesDiffieHellmanLibPrimesJson(e) {
      e.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');
    },
    "./node_modules/elliptic/lib/elliptic.js": function node_modulesEllipticLibEllipticJs(e, t, n) {
      "use strict";

      var r = t;
      r.version = n("./node_modules/elliptic/package.json").version, r.utils = n("./node_modules/elliptic/lib/elliptic/utils.js"), r.rand = n("./node_modules/brorand/index.js"), r.curve = n("./node_modules/elliptic/lib/elliptic/curve/index.js"), r.curves = n("./node_modules/elliptic/lib/elliptic/curves.js"), r.ec = n("./node_modules/elliptic/lib/elliptic/ec/index.js"), r.eddsa = n("./node_modules/elliptic/lib/elliptic/eddsa/index.js");
    },
    "./node_modules/elliptic/lib/elliptic/curve/base.js": function node_modulesEllipticLibEllipticCurveBaseJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        o = i.getNAF,
        a = i.getJSF,
        s = i.assert;
      function l(e, t) {
        this.type = e, this.p = new r(t.p, 16), this.red = t.prime ? r.red(t.prime) : r.mont(this.p), this.zero = new r(0).toRed(this.red), this.one = new r(1).toRed(this.red), this.two = new r(2).toRed(this.red), this.n = t.n && new r(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
        var n = this.n && this.p.div(this.n);
        !n || n.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
      }
      function u(e, t) {
        this.curve = e, this.type = t, this.precomputed = null;
      }
      e.exports = l, l.prototype.point = function () {
        throw new Error("Not implemented");
      }, l.prototype.validate = function () {
        throw new Error("Not implemented");
      }, l.prototype._fixedNafMul = function (e, t) {
        s(e.precomputed);
        var n = e._getDoubles(),
          r = o(t, 1, this._bitLength),
          i = (1 << n.step + 1) - (n.step % 2 == 0 ? 2 : 1);
        i /= 3;
        for (var a = [], l = 0; l < r.length; l += n.step) {
          var u = 0;
          for (t = l + n.step - 1; t >= l; t--) u = (u << 1) + r[t];
          a.push(u);
        }
        for (var c = this.jpoint(null, null, null), d = this.jpoint(null, null, null), h = i; h > 0; h--) {
          for (l = 0; l < a.length; l++) {
            (u = a[l]) === h ? d = d.mixedAdd(n.points[l]) : u === -h && (d = d.mixedAdd(n.points[l].neg()));
          }
          c = c.add(d);
        }
        return c.toP();
      }, l.prototype._wnafMul = function (e, t) {
        var n = 4,
          r = e._getNAFPoints(n);
        n = r.wnd;
        for (var i = r.points, a = o(t, n, this._bitLength), l = this.jpoint(null, null, null), u = a.length - 1; u >= 0; u--) {
          for (t = 0; u >= 0 && 0 === a[u]; u--) t++;
          if (u >= 0 && t++, l = l.dblp(t), u < 0) break;
          var c = a[u];
          s(0 !== c), l = "affine" === e.type ? c > 0 ? l.mixedAdd(i[c - 1 >> 1]) : l.mixedAdd(i[-c - 1 >> 1].neg()) : c > 0 ? l.add(i[c - 1 >> 1]) : l.add(i[-c - 1 >> 1].neg());
        }
        return "affine" === e.type ? l.toP() : l;
      }, l.prototype._wnafMulAdd = function (e, t, n, r, i) {
        for (var s = this._wnafT1, l = this._wnafT2, u = this._wnafT3, c = 0, d = 0; d < r; d++) {
          var h = (E = t[d])._getNAFPoints(e);
          s[d] = h.wnd, l[d] = h.points;
        }
        for (d = r - 1; d >= 1; d -= 2) {
          var f = d - 1,
            p = d;
          if (1 === s[f] && 1 === s[p]) {
            var m = [t[f], null, null, t[p]];
            0 === t[f].y.cmp(t[p].y) ? (m[1] = t[f].add(t[p]), m[2] = t[f].toJ().mixedAdd(t[p].neg())) : 0 === t[f].y.cmp(t[p].y.redNeg()) ? (m[1] = t[f].toJ().mixedAdd(t[p]), m[2] = t[f].add(t[p].neg())) : (m[1] = t[f].toJ().mixedAdd(t[p]), m[2] = t[f].toJ().mixedAdd(t[p].neg()));
            var g = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
              v = a(n[f], n[p]);
            c = Math.max(v[0].length, c), u[f] = new Array(c), u[p] = new Array(c);
            for (var y = 0; y < c; y++) {
              var b = 0 | v[0][y],
                _ = 0 | v[1][y];
              u[f][y] = g[3 * (b + 1) + (_ + 1)], u[p][y] = 0, l[f] = m;
            }
          } else u[f] = o(n[f], s[f], this._bitLength), u[p] = o(n[p], s[p], this._bitLength), c = Math.max(u[f].length, c), c = Math.max(u[p].length, c);
        }
        var x = this.jpoint(null, null, null),
          w = this._wnafT4;
        for (d = c; d >= 0; d--) {
          for (var S = 0; d >= 0;) {
            var A = !0;
            for (y = 0; y < r; y++) w[y] = 0 | u[y][d], 0 !== w[y] && (A = !1);
            if (!A) break;
            S++, d--;
          }
          if (d >= 0 && S++, x = x.dblp(S), d < 0) break;
          for (y = 0; y < r; y++) {
            var E,
              T = w[y];
            0 !== T && (T > 0 ? E = l[y][T - 1 >> 1] : T < 0 && (E = l[y][-T - 1 >> 1].neg()), x = "affine" === E.type ? x.mixedAdd(E) : x.add(E));
          }
        }
        for (d = 0; d < r; d++) l[d] = null;
        return i ? x : x.toP();
      }, l.BasePoint = u, u.prototype.eq = function () {
        throw new Error("Not implemented");
      }, u.prototype.validate = function () {
        return this.curve.validate(this);
      }, l.prototype.decodePoint = function (e, t) {
        e = i.toArray(e, t);
        var n = this.p.byteLength();
        if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * n) return 6 === e[0] ? s(e[e.length - 1] % 2 == 0) : 7 === e[0] && s(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + n), e.slice(1 + n, 1 + 2 * n));
        if ((2 === e[0] || 3 === e[0]) && e.length - 1 === n) return this.pointFromX(e.slice(1, 1 + n), 3 === e[0]);
        throw new Error("Unknown point format");
      }, u.prototype.encodeCompressed = function (e) {
        return this.encode(e, !0);
      }, u.prototype._encode = function (e) {
        var t = this.curve.p.byteLength(),
          n = this.getX().toArray("be", t);
        return e ? [this.getY().isEven() ? 2 : 3].concat(n) : [4].concat(n, this.getY().toArray("be", t));
      }, u.prototype.encode = function (e, t) {
        return i.encode(this._encode(t), e);
      }, u.prototype.precompute = function (e) {
        if (this.precomputed) return this;
        var t = {
          doubles: null,
          naf: null,
          beta: null
        };
        return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
      }, u.prototype._hasDoubles = function (e) {
        if (!this.precomputed) return !1;
        var t = this.precomputed.doubles;
        return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
      }, u.prototype._getDoubles = function (e, t) {
        if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
        for (var n = [this], r = this, i = 0; i < t; i += e) {
          for (var o = 0; o < e; o++) r = r.dbl();
          n.push(r);
        }
        return {
          step: e,
          points: n
        };
      }, u.prototype._getNAFPoints = function (e) {
        if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
        for (var t = [this], n = (1 << e) - 1, r = 1 === n ? null : this.dbl(), i = 1; i < n; i++) t[i] = t[i - 1].add(r);
        return {
          wnd: e,
          points: t
        };
      }, u.prototype._getBeta = function () {
        return null;
      }, u.prototype.dblp = function (e) {
        for (var t = this, n = 0; n < e; n++) t = t.dbl();
        return t;
      };
    },
    "./node_modules/elliptic/lib/elliptic/curve/edwards.js": function node_modulesEllipticLibEllipticCurveEdwardsJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        i = n("./node_modules/bn.js/lib/bn.js"),
        o = n("./node_modules/inherits/inherits_browser.js"),
        a = n("./node_modules/elliptic/lib/elliptic/curve/base.js"),
        s = r.assert;
      function l(e) {
        this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, a.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), s(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
      }
      function u(e, t, n, r, o) {
        a.BasePoint.call(this, e, "projective"), null === t && null === n && null === r ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(n, 16), this.z = r ? new i(r, 16) : this.curve.one, this.t = o && new i(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
      }
      o(l, a), e.exports = l, l.prototype._mulA = function (e) {
        return this.mOneA ? e.redNeg() : this.a.redMul(e);
      }, l.prototype._mulC = function (e) {
        return this.oneC ? e : this.c.redMul(e);
      }, l.prototype.jpoint = function (e, t, n, r) {
        return this.point(e, t, n, r);
      }, l.prototype.pointFromX = function (e, t) {
        (e = new i(e, 16)).red || (e = e.toRed(this.red));
        var n = e.redSqr(),
          r = this.c2.redSub(this.a.redMul(n)),
          o = this.one.redSub(this.c2.redMul(this.d).redMul(n)),
          a = r.redMul(o.redInvm()),
          s = a.redSqrt();
        if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
        var l = s.fromRed().isOdd();
        return (t && !l || !t && l) && (s = s.redNeg()), this.point(e, s);
      }, l.prototype.pointFromY = function (e, t) {
        (e = new i(e, 16)).red || (e = e.toRed(this.red));
        var n = e.redSqr(),
          r = n.redSub(this.c2),
          o = n.redMul(this.d).redMul(this.c2).redSub(this.a),
          a = r.redMul(o.redInvm());
        if (0 === a.cmp(this.zero)) {
          if (t) throw new Error("invalid point");
          return this.point(this.zero, e);
        }
        var s = a.redSqrt();
        if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
        return s.fromRed().isOdd() !== t && (s = s.redNeg()), this.point(s, e);
      }, l.prototype.validate = function (e) {
        if (e.isInfinity()) return !0;
        e.normalize();
        var t = e.x.redSqr(),
          n = e.y.redSqr(),
          r = t.redMul(this.a).redAdd(n),
          i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(n)));
        return 0 === r.cmp(i);
      }, o(u, a.BasePoint), l.prototype.pointFromJSON = function (e) {
        return u.fromJSON(this, e);
      }, l.prototype.point = function (e, t, n, r) {
        return new u(this, e, t, n, r);
      }, u.fromJSON = function (e, t) {
        return new u(e, t[0], t[1], t[2]);
      }, u.prototype.inspect = function () {
        return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
      }, u.prototype.isInfinity = function () {
        return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
      }, u.prototype._extDbl = function () {
        var e = this.x.redSqr(),
          t = this.y.redSqr(),
          n = this.z.redSqr();
        n = n.redIAdd(n);
        var r = this.curve._mulA(e),
          i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),
          o = r.redAdd(t),
          a = o.redSub(n),
          s = r.redSub(t),
          l = i.redMul(a),
          u = o.redMul(s),
          c = i.redMul(s),
          d = a.redMul(o);
        return this.curve.point(l, u, d, c);
      }, u.prototype._projDbl = function () {
        var e,
          t,
          n,
          r = this.x.redAdd(this.y).redSqr(),
          i = this.x.redSqr(),
          o = this.y.redSqr();
        if (this.curve.twisted) {
          var a = (u = this.curve._mulA(i)).redAdd(o);
          if (this.zOne) e = r.redSub(i).redSub(o).redMul(a.redSub(this.curve.two)), t = a.redMul(u.redSub(o)), n = a.redSqr().redSub(a).redSub(a);else {
            var s = this.z.redSqr(),
              l = a.redSub(s).redISub(s);
            e = r.redSub(i).redISub(o).redMul(l), t = a.redMul(u.redSub(o)), n = a.redMul(l);
          }
        } else {
          var u = i.redAdd(o);
          s = this.curve._mulC(this.z).redSqr(), l = u.redSub(s).redSub(s);
          e = this.curve._mulC(r.redISub(u)).redMul(l), t = this.curve._mulC(u).redMul(i.redISub(o)), n = u.redMul(l);
        }
        return this.curve.point(e, t, n);
      }, u.prototype.dbl = function () {
        return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
      }, u.prototype._extAdd = function (e) {
        var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)),
          n = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),
          r = this.t.redMul(this.curve.dd).redMul(e.t),
          i = this.z.redMul(e.z.redAdd(e.z)),
          o = n.redSub(t),
          a = i.redSub(r),
          s = i.redAdd(r),
          l = n.redAdd(t),
          u = o.redMul(a),
          c = s.redMul(l),
          d = o.redMul(l),
          h = a.redMul(s);
        return this.curve.point(u, c, h, d);
      }, u.prototype._projAdd = function (e) {
        var t,
          n,
          r = this.z.redMul(e.z),
          i = r.redSqr(),
          o = this.x.redMul(e.x),
          a = this.y.redMul(e.y),
          s = this.curve.d.redMul(o).redMul(a),
          l = i.redSub(s),
          u = i.redAdd(s),
          c = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),
          d = r.redMul(l).redMul(c);
        return this.curve.twisted ? (t = r.redMul(u).redMul(a.redSub(this.curve._mulA(o))), n = l.redMul(u)) : (t = r.redMul(u).redMul(a.redSub(o)), n = this.curve._mulC(l).redMul(u)), this.curve.point(d, t, n);
      }, u.prototype.add = function (e) {
        return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
      }, u.prototype.mul = function (e) {
        return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
      }, u.prototype.mulAdd = function (e, t, n) {
        return this.curve._wnafMulAdd(1, [this, t], [e, n], 2, !1);
      }, u.prototype.jmulAdd = function (e, t, n) {
        return this.curve._wnafMulAdd(1, [this, t], [e, n], 2, !0);
      }, u.prototype.normalize = function () {
        if (this.zOne) return this;
        var e = this.z.redInvm();
        return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
      }, u.prototype.neg = function () {
        return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
      }, u.prototype.getX = function () {
        return this.normalize(), this.x.fromRed();
      }, u.prototype.getY = function () {
        return this.normalize(), this.y.fromRed();
      }, u.prototype.eq = function (e) {
        return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
      }, u.prototype.eqXToP = function (e) {
        var t = e.toRed(this.curve.red).redMul(this.z);
        if (0 === this.x.cmp(t)) return !0;
        for (var n = e.clone(), r = this.curve.redN.redMul(this.z);;) {
          if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
          if (t.redIAdd(r), 0 === this.x.cmp(t)) return !0;
        }
      }, u.prototype.toP = u.prototype.normalize, u.prototype.mixedAdd = u.prototype.add;
    },
    "./node_modules/elliptic/lib/elliptic/curve/index.js": function node_modulesEllipticLibEllipticCurveIndexJs(e, t, n) {
      "use strict";

      var r = t;
      r.base = n("./node_modules/elliptic/lib/elliptic/curve/base.js"), r.short = n("./node_modules/elliptic/lib/elliptic/curve/short.js"), r.mont = n("./node_modules/elliptic/lib/elliptic/curve/mont.js"), r.edwards = n("./node_modules/elliptic/lib/elliptic/curve/edwards.js");
    },
    "./node_modules/elliptic/lib/elliptic/curve/mont.js": function node_modulesEllipticLibEllipticCurveMontJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/inherits/inherits_browser.js"),
        o = n("./node_modules/elliptic/lib/elliptic/curve/base.js"),
        a = n("./node_modules/elliptic/lib/elliptic/utils.js");
      function s(e) {
        o.call(this, "mont", e), this.a = new r(e.a, 16).toRed(this.red), this.b = new r(e.b, 16).toRed(this.red), this.i4 = new r(4).toRed(this.red).redInvm(), this.two = new r(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
      }
      function l(e, t, n) {
        o.BasePoint.call(this, e, "projective"), null === t && null === n ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new r(t, 16), this.z = new r(n, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
      }
      i(s, o), e.exports = s, s.prototype.validate = function (e) {
        var t = e.normalize().x,
          n = t.redSqr(),
          r = n.redMul(t).redAdd(n.redMul(this.a)).redAdd(t);
        return 0 === r.redSqrt().redSqr().cmp(r);
      }, i(l, o.BasePoint), s.prototype.decodePoint = function (e, t) {
        return this.point(a.toArray(e, t), 1);
      }, s.prototype.point = function (e, t) {
        return new l(this, e, t);
      }, s.prototype.pointFromJSON = function (e) {
        return l.fromJSON(this, e);
      }, l.prototype.precompute = function () {}, l.prototype._encode = function () {
        return this.getX().toArray("be", this.curve.p.byteLength());
      }, l.fromJSON = function (e, t) {
        return new l(e, t[0], t[1] || e.one);
      }, l.prototype.inspect = function () {
        return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
      }, l.prototype.isInfinity = function () {
        return 0 === this.z.cmpn(0);
      }, l.prototype.dbl = function () {
        var e = this.x.redAdd(this.z).redSqr(),
          t = this.x.redSub(this.z).redSqr(),
          n = e.redSub(t),
          r = e.redMul(t),
          i = n.redMul(t.redAdd(this.curve.a24.redMul(n)));
        return this.curve.point(r, i);
      }, l.prototype.add = function () {
        throw new Error("Not supported on Montgomery curve");
      }, l.prototype.diffAdd = function (e, t) {
        var n = this.x.redAdd(this.z),
          r = this.x.redSub(this.z),
          i = e.x.redAdd(e.z),
          o = e.x.redSub(e.z).redMul(n),
          a = i.redMul(r),
          s = t.z.redMul(o.redAdd(a).redSqr()),
          l = t.x.redMul(o.redISub(a).redSqr());
        return this.curve.point(s, l);
      }, l.prototype.mul = function (e) {
        for (var t = e.clone(), n = this, r = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1)) i.push(t.andln(1));
        for (var o = i.length - 1; o >= 0; o--) 0 === i[o] ? (n = n.diffAdd(r, this), r = r.dbl()) : (r = n.diffAdd(r, this), n = n.dbl());
        return r;
      }, l.prototype.mulAdd = function () {
        throw new Error("Not supported on Montgomery curve");
      }, l.prototype.jumlAdd = function () {
        throw new Error("Not supported on Montgomery curve");
      }, l.prototype.eq = function (e) {
        return 0 === this.getX().cmp(e.getX());
      }, l.prototype.normalize = function () {
        return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
      }, l.prototype.getX = function () {
        return this.normalize(), this.x.fromRed();
      };
    },
    "./node_modules/elliptic/lib/elliptic/curve/short.js": function node_modulesEllipticLibEllipticCurveShortJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        i = n("./node_modules/bn.js/lib/bn.js"),
        o = n("./node_modules/inherits/inherits_browser.js"),
        a = n("./node_modules/elliptic/lib/elliptic/curve/base.js"),
        s = r.assert;
      function l(e) {
        a.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
      }
      function u(e, t, n, r) {
        a.BasePoint.call(this, e, "affine"), null === t && null === n ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(n, 16), r && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
      }
      function c(e, t, n, r) {
        a.BasePoint.call(this, e, "jacobian"), null === t && null === n && null === r ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(n, 16), this.z = new i(r, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
      }
      o(l, a), e.exports = l, l.prototype._getEndomorphism = function (e) {
        if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
          var t, n;
          if (e.beta) t = new i(e.beta, 16).toRed(this.red);else {
            var r = this._getEndoRoots(this.p);
            t = (t = r[0].cmp(r[1]) < 0 ? r[0] : r[1]).toRed(this.red);
          }
          if (e.lambda) n = new i(e.lambda, 16);else {
            var o = this._getEndoRoots(this.n);
            0 === this.g.mul(o[0]).x.cmp(this.g.x.redMul(t)) ? n = o[0] : (n = o[1], s(0 === this.g.mul(n).x.cmp(this.g.x.redMul(t))));
          }
          return {
            beta: t,
            lambda: n,
            basis: e.basis ? e.basis.map(function (e) {
              return {
                a: new i(e.a, 16),
                b: new i(e.b, 16)
              };
            }) : this._getEndoBasis(n)
          };
        }
      }, l.prototype._getEndoRoots = function (e) {
        var t = e === this.p ? this.red : i.mont(e),
          n = new i(2).toRed(t).redInvm(),
          r = n.redNeg(),
          o = new i(3).toRed(t).redNeg().redSqrt().redMul(n);
        return [r.redAdd(o).fromRed(), r.redSub(o).fromRed()];
      }, l.prototype._getEndoBasis = function (e) {
        for (var t, n, r, o, a, s, l, u, c, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), h = e, f = this.n.clone(), p = new i(1), m = new i(0), g = new i(0), v = new i(1), y = 0; 0 !== h.cmpn(0);) {
          var b = f.div(h);
          u = f.sub(b.mul(h)), c = g.sub(b.mul(p));
          var _ = v.sub(b.mul(m));
          if (!r && u.cmp(d) < 0) t = l.neg(), n = p, r = u.neg(), o = c;else if (r && 2 == ++y) break;
          l = u, f = h, h = u, g = p, p = c, v = m, m = _;
        }
        a = u.neg(), s = c;
        var x = r.sqr().add(o.sqr());
        return a.sqr().add(s.sqr()).cmp(x) >= 0 && (a = t, s = n), r.negative && (r = r.neg(), o = o.neg()), a.negative && (a = a.neg(), s = s.neg()), [{
          a: r,
          b: o
        }, {
          a: a,
          b: s
        }];
      }, l.prototype._endoSplit = function (e) {
        var t = this.endo.basis,
          n = t[0],
          r = t[1],
          i = r.b.mul(e).divRound(this.n),
          o = n.b.neg().mul(e).divRound(this.n),
          a = i.mul(n.a),
          s = o.mul(r.a),
          l = i.mul(n.b),
          u = o.mul(r.b);
        return {
          k1: e.sub(a).sub(s),
          k2: l.add(u).neg()
        };
      }, l.prototype.pointFromX = function (e, t) {
        (e = new i(e, 16)).red || (e = e.toRed(this.red));
        var n = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),
          r = n.redSqrt();
        if (0 !== r.redSqr().redSub(n).cmp(this.zero)) throw new Error("invalid point");
        var o = r.fromRed().isOdd();
        return (t && !o || !t && o) && (r = r.redNeg()), this.point(e, r);
      }, l.prototype.validate = function (e) {
        if (e.inf) return !0;
        var t = e.x,
          n = e.y,
          r = this.a.redMul(t),
          i = t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);
        return 0 === n.redSqr().redISub(i).cmpn(0);
      }, l.prototype._endoWnafMulAdd = function (e, t, n) {
        for (var r = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++) {
          var a = this._endoSplit(t[o]),
            s = e[o],
            l = s._getBeta();
          a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), l = l.neg(!0)), r[2 * o] = s, r[2 * o + 1] = l, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
        }
        for (var u = this._wnafMulAdd(1, r, i, 2 * o, n), c = 0; c < 2 * o; c++) r[c] = null, i[c] = null;
        return u;
      }, o(u, a.BasePoint), l.prototype.point = function (e, t, n) {
        return new u(this, e, t, n);
      }, l.prototype.pointFromJSON = function (e, t) {
        return u.fromJSON(this, e, t);
      }, u.prototype._getBeta = function () {
        if (this.curve.endo) {
          var e = this.precomputed;
          if (e && e.beta) return e.beta;
          var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
          if (e) {
            var n = this.curve,
              r = function r(e) {
                return n.point(e.x.redMul(n.endo.beta), e.y);
              };
            e.beta = t, t.precomputed = {
              beta: null,
              naf: e.naf && {
                wnd: e.naf.wnd,
                points: e.naf.points.map(r)
              },
              doubles: e.doubles && {
                step: e.doubles.step,
                points: e.doubles.points.map(r)
              }
            };
          }
          return t;
        }
      }, u.prototype.toJSON = function () {
        return this.precomputed ? [this.x, this.y, this.precomputed && {
          doubles: this.precomputed.doubles && {
            step: this.precomputed.doubles.step,
            points: this.precomputed.doubles.points.slice(1)
          },
          naf: this.precomputed.naf && {
            wnd: this.precomputed.naf.wnd,
            points: this.precomputed.naf.points.slice(1)
          }
        }] : [this.x, this.y];
      }, u.fromJSON = function (e, t, n) {
        "string" == typeof t && (t = JSON.parse(t));
        var r = e.point(t[0], t[1], n);
        if (!t[2]) return r;
        function i(t) {
          return e.point(t[0], t[1], n);
        }
        var o = t[2];
        return r.precomputed = {
          beta: null,
          doubles: o.doubles && {
            step: o.doubles.step,
            points: [r].concat(o.doubles.points.map(i))
          },
          naf: o.naf && {
            wnd: o.naf.wnd,
            points: [r].concat(o.naf.points.map(i))
          }
        }, r;
      }, u.prototype.inspect = function () {
        return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
      }, u.prototype.isInfinity = function () {
        return this.inf;
      }, u.prototype.add = function (e) {
        if (this.inf) return e;
        if (e.inf) return this;
        if (this.eq(e)) return this.dbl();
        if (this.neg().eq(e)) return this.curve.point(null, null);
        if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
        var t = this.y.redSub(e.y);
        0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
        var n = t.redSqr().redISub(this.x).redISub(e.x),
          r = t.redMul(this.x.redSub(n)).redISub(this.y);
        return this.curve.point(n, r);
      }, u.prototype.dbl = function () {
        if (this.inf) return this;
        var e = this.y.redAdd(this.y);
        if (0 === e.cmpn(0)) return this.curve.point(null, null);
        var t = this.curve.a,
          n = this.x.redSqr(),
          r = e.redInvm(),
          i = n.redAdd(n).redIAdd(n).redIAdd(t).redMul(r),
          o = i.redSqr().redISub(this.x.redAdd(this.x)),
          a = i.redMul(this.x.redSub(o)).redISub(this.y);
        return this.curve.point(o, a);
      }, u.prototype.getX = function () {
        return this.x.fromRed();
      }, u.prototype.getY = function () {
        return this.y.fromRed();
      }, u.prototype.mul = function (e) {
        return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [e]) : this.curve._wnafMul(this, e);
      }, u.prototype.mulAdd = function (e, t, n) {
        var r = [this, t],
          i = [e, n];
        return this.curve.endo ? this.curve._endoWnafMulAdd(r, i) : this.curve._wnafMulAdd(1, r, i, 2);
      }, u.prototype.jmulAdd = function (e, t, n) {
        var r = [this, t],
          i = [e, n];
        return this.curve.endo ? this.curve._endoWnafMulAdd(r, i, !0) : this.curve._wnafMulAdd(1, r, i, 2, !0);
      }, u.prototype.eq = function (e) {
        return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
      }, u.prototype.neg = function (e) {
        if (this.inf) return this;
        var t = this.curve.point(this.x, this.y.redNeg());
        if (e && this.precomputed) {
          var n = this.precomputed,
            r = function r(e) {
              return e.neg();
            };
          t.precomputed = {
            naf: n.naf && {
              wnd: n.naf.wnd,
              points: n.naf.points.map(r)
            },
            doubles: n.doubles && {
              step: n.doubles.step,
              points: n.doubles.points.map(r)
            }
          };
        }
        return t;
      }, u.prototype.toJ = function () {
        return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
      }, o(c, a.BasePoint), l.prototype.jpoint = function (e, t, n) {
        return new c(this, e, t, n);
      }, c.prototype.toP = function () {
        if (this.isInfinity()) return this.curve.point(null, null);
        var e = this.z.redInvm(),
          t = e.redSqr(),
          n = this.x.redMul(t),
          r = this.y.redMul(t).redMul(e);
        return this.curve.point(n, r);
      }, c.prototype.neg = function () {
        return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
      }, c.prototype.add = function (e) {
        if (this.isInfinity()) return e;
        if (e.isInfinity()) return this;
        var t = e.z.redSqr(),
          n = this.z.redSqr(),
          r = this.x.redMul(t),
          i = e.x.redMul(n),
          o = this.y.redMul(t.redMul(e.z)),
          a = e.y.redMul(n.redMul(this.z)),
          s = r.redSub(i),
          l = o.redSub(a);
        if (0 === s.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
        var u = s.redSqr(),
          c = u.redMul(s),
          d = r.redMul(u),
          h = l.redSqr().redIAdd(c).redISub(d).redISub(d),
          f = l.redMul(d.redISub(h)).redISub(o.redMul(c)),
          p = this.z.redMul(e.z).redMul(s);
        return this.curve.jpoint(h, f, p);
      }, c.prototype.mixedAdd = function (e) {
        if (this.isInfinity()) return e.toJ();
        if (e.isInfinity()) return this;
        var t = this.z.redSqr(),
          n = this.x,
          r = e.x.redMul(t),
          i = this.y,
          o = e.y.redMul(t).redMul(this.z),
          a = n.redSub(r),
          s = i.redSub(o);
        if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
        var l = a.redSqr(),
          u = l.redMul(a),
          c = n.redMul(l),
          d = s.redSqr().redIAdd(u).redISub(c).redISub(c),
          h = s.redMul(c.redISub(d)).redISub(i.redMul(u)),
          f = this.z.redMul(a);
        return this.curve.jpoint(d, h, f);
      }, c.prototype.dblp = function (e) {
        if (0 === e) return this;
        if (this.isInfinity()) return this;
        if (!e) return this.dbl();
        if (this.curve.zeroA || this.curve.threeA) {
          for (var t = this, n = 0; n < e; n++) t = t.dbl();
          return t;
        }
        var r = this.curve.a,
          i = this.curve.tinv,
          o = this.x,
          a = this.y,
          s = this.z,
          l = s.redSqr().redSqr(),
          u = a.redAdd(a);
        for (n = 0; n < e; n++) {
          var c = o.redSqr(),
            d = u.redSqr(),
            h = d.redSqr(),
            f = c.redAdd(c).redIAdd(c).redIAdd(r.redMul(l)),
            p = o.redMul(d),
            m = f.redSqr().redISub(p.redAdd(p)),
            g = p.redISub(m),
            v = f.redMul(g);
          v = v.redIAdd(v).redISub(h);
          var y = u.redMul(s);
          n + 1 < e && (l = l.redMul(h)), o = m, s = y, u = v;
        }
        return this.curve.jpoint(o, u.redMul(i), s);
      }, c.prototype.dbl = function () {
        return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
      }, c.prototype._zeroDbl = function () {
        var e, t, n;
        if (this.zOne) {
          var r = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
          a = a.redIAdd(a);
          var s = r.redAdd(r).redIAdd(r),
            l = s.redSqr().redISub(a).redISub(a),
            u = o.redIAdd(o);
          u = (u = u.redIAdd(u)).redIAdd(u), e = l, t = s.redMul(a.redISub(l)).redISub(u), n = this.y.redAdd(this.y);
        } else {
          var c = this.x.redSqr(),
            d = this.y.redSqr(),
            h = d.redSqr(),
            f = this.x.redAdd(d).redSqr().redISub(c).redISub(h);
          f = f.redIAdd(f);
          var p = c.redAdd(c).redIAdd(c),
            m = p.redSqr(),
            g = h.redIAdd(h);
          g = (g = g.redIAdd(g)).redIAdd(g), e = m.redISub(f).redISub(f), t = p.redMul(f.redISub(e)).redISub(g), n = (n = this.y.redMul(this.z)).redIAdd(n);
        }
        return this.curve.jpoint(e, t, n);
      }, c.prototype._threeDbl = function () {
        var e, t, n;
        if (this.zOne) {
          var r = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            a = this.x.redAdd(i).redSqr().redISub(r).redISub(o);
          a = a.redIAdd(a);
          var s = r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),
            l = s.redSqr().redISub(a).redISub(a);
          e = l;
          var u = o.redIAdd(o);
          u = (u = u.redIAdd(u)).redIAdd(u), t = s.redMul(a.redISub(l)).redISub(u), n = this.y.redAdd(this.y);
        } else {
          var c = this.z.redSqr(),
            d = this.y.redSqr(),
            h = this.x.redMul(d),
            f = this.x.redSub(c).redMul(this.x.redAdd(c));
          f = f.redAdd(f).redIAdd(f);
          var p = h.redIAdd(h),
            m = (p = p.redIAdd(p)).redAdd(p);
          e = f.redSqr().redISub(m), n = this.y.redAdd(this.z).redSqr().redISub(d).redISub(c);
          var g = d.redSqr();
          g = (g = (g = g.redIAdd(g)).redIAdd(g)).redIAdd(g), t = f.redMul(p.redISub(e)).redISub(g);
        }
        return this.curve.jpoint(e, t, n);
      }, c.prototype._dbl = function () {
        var e = this.curve.a,
          t = this.x,
          n = this.y,
          r = this.z,
          i = r.redSqr().redSqr(),
          o = t.redSqr(),
          a = n.redSqr(),
          s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),
          l = t.redAdd(t),
          u = (l = l.redIAdd(l)).redMul(a),
          c = s.redSqr().redISub(u.redAdd(u)),
          d = u.redISub(c),
          h = a.redSqr();
        h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
        var f = s.redMul(d).redISub(h),
          p = n.redAdd(n).redMul(r);
        return this.curve.jpoint(c, f, p);
      }, c.prototype.trpl = function () {
        if (!this.curve.zeroA) return this.dbl().add(this);
        var e = this.x.redSqr(),
          t = this.y.redSqr(),
          n = this.z.redSqr(),
          r = t.redSqr(),
          i = e.redAdd(e).redIAdd(e),
          o = i.redSqr(),
          a = this.x.redAdd(t).redSqr().redISub(e).redISub(r),
          s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
          l = r.redIAdd(r);
        l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
        var u = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(l),
          c = t.redMul(u);
        c = (c = c.redIAdd(c)).redIAdd(c);
        var d = this.x.redMul(s).redISub(c);
        d = (d = d.redIAdd(d)).redIAdd(d);
        var h = this.y.redMul(u.redMul(l.redISub(u)).redISub(a.redMul(s)));
        h = (h = (h = h.redIAdd(h)).redIAdd(h)).redIAdd(h);
        var f = this.z.redAdd(a).redSqr().redISub(n).redISub(s);
        return this.curve.jpoint(d, h, f);
      }, c.prototype.mul = function (e, t) {
        return e = new i(e, t), this.curve._wnafMul(this, e);
      }, c.prototype.eq = function (e) {
        if ("affine" === e.type) return this.eq(e.toJ());
        if (this === e) return !0;
        var t = this.z.redSqr(),
          n = e.z.redSqr();
        if (0 !== this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0)) return !1;
        var r = t.redMul(this.z),
          i = n.redMul(e.z);
        return 0 === this.y.redMul(i).redISub(e.y.redMul(r)).cmpn(0);
      }, c.prototype.eqXToP = function (e) {
        var t = this.z.redSqr(),
          n = e.toRed(this.curve.red).redMul(t);
        if (0 === this.x.cmp(n)) return !0;
        for (var r = e.clone(), i = this.curve.redN.redMul(t);;) {
          if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
          if (n.redIAdd(i), 0 === this.x.cmp(n)) return !0;
        }
      }, c.prototype.inspect = function () {
        return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
      }, c.prototype.isInfinity = function () {
        return 0 === this.z.cmpn(0);
      };
    },
    "./node_modules/elliptic/lib/elliptic/curves.js": function node_modulesEllipticLibEllipticCurvesJs(e, t, n) {
      "use strict";

      var r,
        i = t,
        o = n("./node_modules/hash.js/lib/hash.js"),
        a = n("./node_modules/elliptic/lib/elliptic/curve/index.js"),
        s = n("./node_modules/elliptic/lib/elliptic/utils.js").assert;
      function l(e) {
        "short" === e.type ? this.curve = new a.short(e) : "edwards" === e.type ? this.curve = new a.edwards(e) : this.curve = new a.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
      }
      function u(e, t) {
        Object.defineProperty(i, e, {
          configurable: !0,
          enumerable: !0,
          get: function get() {
            var n = new l(t);
            return Object.defineProperty(i, e, {
              configurable: !0,
              enumerable: !0,
              value: n
            }), n;
          }
        });
      }
      i.PresetCurve = l, u("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: o.sha256,
        gRed: !1,
        g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
      }), u("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: o.sha256,
        gRed: !1,
        g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
      }), u("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: o.sha256,
        gRed: !1,
        g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
      }), u("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: o.sha384,
        gRed: !1,
        g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
      }), u("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: o.sha512,
        gRed: !1,
        g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
      }), u("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: o.sha256,
        gRed: !1,
        g: ["9"]
      }), u("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: o.sha256,
        gRed: !1,
        g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
      });
      try {
        r = n("./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js");
      } catch (e) {
        r = void 0;
      }
      u("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: o.sha256,
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [{
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        }, {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }],
        gRed: !1,
        g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", r]
      });
    },
    "./node_modules/elliptic/lib/elliptic/ec/index.js": function node_modulesEllipticLibEllipticEcIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/hmac-drbg/lib/hmac-drbg.js"),
        o = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        a = n("./node_modules/elliptic/lib/elliptic/curves.js"),
        s = n("./node_modules/brorand/index.js"),
        l = o.assert,
        u = n("./node_modules/elliptic/lib/elliptic/ec/key.js"),
        c = n("./node_modules/elliptic/lib/elliptic/ec/signature.js");
      function d(e) {
        if (!(this instanceof d)) return new d(e);
        "string" == typeof e && (l(a.hasOwnProperty(e), "Unknown curve " + e), e = a[e]), e instanceof a.PresetCurve && (e = {
          curve: e
        }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
      }
      e.exports = d, d.prototype.keyPair = function (e) {
        return new u(this, e);
      }, d.prototype.keyFromPrivate = function (e, t) {
        return u.fromPrivate(this, e, t);
      }, d.prototype.keyFromPublic = function (e, t) {
        return u.fromPublic(this, e, t);
      }, d.prototype.genKeyPair = function (e) {
        e || (e = {});
        for (var t = new i({
            hash: this.hash,
            pers: e.pers,
            persEnc: e.persEnc || "utf8",
            entropy: e.entropy || s(this.hash.hmacStrength),
            entropyEnc: e.entropy && e.entropyEnc || "utf8",
            nonce: this.n.toArray()
          }), n = this.n.byteLength(), o = this.n.sub(new r(2));;) {
          var a = new r(t.generate(n));
          if (!(a.cmp(o) > 0)) return a.iaddn(1), this.keyFromPrivate(a);
        }
      }, d.prototype._truncateToN = function (e, t) {
        var n = 8 * e.byteLength() - this.n.bitLength();
        return n > 0 && (e = e.ushrn(n)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
      }, d.prototype.sign = function (e, t, n, o) {
        "object" == typeof n && (o = n, n = null), o || (o = {}), t = this.keyFromPrivate(t, n), e = this._truncateToN(new r(e, 16));
        for (var a = this.n.byteLength(), s = t.getPrivate().toArray("be", a), l = e.toArray("be", a), u = new i({
            hash: this.hash,
            entropy: s,
            nonce: l,
            pers: o.pers,
            persEnc: o.persEnc || "utf8"
          }), d = this.n.sub(new r(1)), h = 0;; h++) {
          var f = o.k ? o.k(h) : new r(u.generate(this.n.byteLength()));
          if (!((f = this._truncateToN(f, !0)).cmpn(1) <= 0 || f.cmp(d) >= 0)) {
            var p = this.g.mul(f);
            if (!p.isInfinity()) {
              var m = p.getX(),
                g = m.umod(this.n);
              if (0 !== g.cmpn(0)) {
                var v = f.invm(this.n).mul(g.mul(t.getPrivate()).iadd(e));
                if (0 !== (v = v.umod(this.n)).cmpn(0)) {
                  var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(g) ? 2 : 0);
                  return o.canonical && v.cmp(this.nh) > 0 && (v = this.n.sub(v), y ^= 1), new c({
                    r: g,
                    s: v,
                    recoveryParam: y
                  });
                }
              }
            }
          }
        }
      }, d.prototype.verify = function (e, t, n, i) {
        e = this._truncateToN(new r(e, 16)), n = this.keyFromPublic(n, i);
        var o = (t = new c(t, "hex")).r,
          a = t.s;
        if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
        if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
        var s,
          l = a.invm(this.n),
          u = l.mul(e).umod(this.n),
          d = l.mul(o).umod(this.n);
        return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(u, n.getPublic(), d)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(u, n.getPublic(), d)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
      }, d.prototype.recoverPubKey = function (e, t, n, i) {
        l((3 & n) === n, "The recovery param is more than two bits"), t = new c(t, i);
        var o = this.n,
          a = new r(e),
          s = t.r,
          u = t.s,
          d = 1 & n,
          h = n >> 1;
        if (s.cmp(this.curve.p.umod(this.curve.n)) >= 0 && h) throw new Error("Unable to find sencond key candinate");
        s = h ? this.curve.pointFromX(s.add(this.curve.n), d) : this.curve.pointFromX(s, d);
        var f = t.r.invm(o),
          p = o.sub(a).mul(f).umod(o),
          m = u.mul(f).umod(o);
        return this.g.mulAdd(p, s, m);
      }, d.prototype.getKeyRecoveryParam = function (e, t, n, r) {
        if (null !== (t = new c(t, r)).recoveryParam) return t.recoveryParam;
        for (var i = 0; i < 4; i++) {
          var o;
          try {
            o = this.recoverPubKey(e, t, i);
          } catch (e) {
            continue;
          }
          if (o.eq(n)) return i;
        }
        throw new Error("Unable to find valid recovery factor");
      };
    },
    "./node_modules/elliptic/lib/elliptic/ec/key.js": function node_modulesEllipticLibEllipticEcKeyJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/elliptic/lib/elliptic/utils.js").assert;
      function o(e, t) {
        this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
      }
      e.exports = o, o.fromPublic = function (e, t, n) {
        return t instanceof o ? t : new o(e, {
          pub: t,
          pubEnc: n
        });
      }, o.fromPrivate = function (e, t, n) {
        return t instanceof o ? t : new o(e, {
          priv: t,
          privEnc: n
        });
      }, o.prototype.validate = function () {
        var e = this.getPublic();
        return e.isInfinity() ? {
          result: !1,
          reason: "Invalid public key"
        } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
          result: !0,
          reason: null
        } : {
          result: !1,
          reason: "Public key * N != O"
        } : {
          result: !1,
          reason: "Public key is not a point"
        };
      }, o.prototype.getPublic = function (e, t) {
        return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
      }, o.prototype.getPrivate = function (e) {
        return "hex" === e ? this.priv.toString(16, 2) : this.priv;
      }, o.prototype._importPrivate = function (e, t) {
        this.priv = new r(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
      }, o.prototype._importPublic = function (e, t) {
        if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
        this.pub = this.ec.curve.decodePoint(e, t);
      }, o.prototype.derive = function (e) {
        return e.mul(this.priv).getX();
      }, o.prototype.sign = function (e, t, n) {
        return this.ec.sign(e, this, t, n);
      }, o.prototype.verify = function (e, t) {
        return this.ec.verify(e, t, this);
      }, o.prototype.inspect = function () {
        return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
      };
    },
    "./node_modules/elliptic/lib/elliptic/ec/signature.js": function node_modulesEllipticLibEllipticEcSignatureJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        o = i.assert;
      function a(e, t) {
        if (e instanceof a) return e;
        this._importDER(e, t) || (o(e.r && e.s, "Signature without r or s"), this.r = new r(e.r, 16), this.s = new r(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
      }
      function s() {
        this.place = 0;
      }
      function l(e, t) {
        var n = e[t.place++];
        if (!(128 & n)) return n;
        for (var r = 15 & n, i = 0, o = 0, a = t.place; o < r; o++, a++) i <<= 8, i |= e[a];
        return t.place = a, i;
      }
      function u(e) {
        for (var t = 0, n = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < n;) t++;
        return 0 === t ? e : e.slice(t);
      }
      function c(e, t) {
        if (t < 128) e.push(t);else {
          var n = 1 + (Math.log(t) / Math.LN2 >>> 3);
          for (e.push(128 | n); --n;) e.push(t >>> (n << 3) & 255);
          e.push(t);
        }
      }
      e.exports = a, a.prototype._importDER = function (e, t) {
        e = i.toArray(e, t);
        var n = new s();
        if (48 !== e[n.place++]) return !1;
        if (l(e, n) + n.place !== e.length) return !1;
        if (2 !== e[n.place++]) return !1;
        var o = l(e, n),
          a = e.slice(n.place, o + n.place);
        if (n.place += o, 2 !== e[n.place++]) return !1;
        var u = l(e, n);
        if (e.length !== u + n.place) return !1;
        var c = e.slice(n.place, u + n.place);
        return 0 === a[0] && 128 & a[1] && (a = a.slice(1)), 0 === c[0] && 128 & c[1] && (c = c.slice(1)), this.r = new r(a), this.s = new r(c), this.recoveryParam = null, !0;
      }, a.prototype.toDER = function (e) {
        var t = this.r.toArray(),
          n = this.s.toArray();
        for (128 & t[0] && (t = [0].concat(t)), 128 & n[0] && (n = [0].concat(n)), t = u(t), n = u(n); !(n[0] || 128 & n[1]);) n = n.slice(1);
        var r = [2];
        c(r, t.length), (r = r.concat(t)).push(2), c(r, n.length);
        var o = r.concat(n),
          a = [48];
        return c(a, o.length), a = a.concat(o), i.encode(a, e);
      };
    },
    "./node_modules/elliptic/lib/elliptic/eddsa/index.js": function node_modulesEllipticLibEllipticEddsaIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash.js"),
        i = n("./node_modules/elliptic/lib/elliptic/curves.js"),
        o = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        a = o.assert,
        s = o.parseBytes,
        l = n("./node_modules/elliptic/lib/elliptic/eddsa/key.js"),
        u = n("./node_modules/elliptic/lib/elliptic/eddsa/signature.js");
      function c(e) {
        if (a("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof c)) return new c(e);
        e = i[e].curve;
        this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = r.sha512;
      }
      e.exports = c, c.prototype.sign = function (e, t) {
        e = s(e);
        var n = this.keyFromSecret(t),
          r = this.hashInt(n.messagePrefix(), e),
          i = this.g.mul(r),
          o = this.encodePoint(i),
          a = this.hashInt(o, n.pubBytes(), e).mul(n.priv()),
          l = r.add(a).umod(this.curve.n);
        return this.makeSignature({
          R: i,
          S: l,
          Rencoded: o
        });
      }, c.prototype.verify = function (e, t, n) {
        e = s(e), t = this.makeSignature(t);
        var r = this.keyFromPublic(n),
          i = this.hashInt(t.Rencoded(), r.pubBytes(), e),
          o = this.g.mul(t.S());
        return t.R().add(r.pub().mul(i)).eq(o);
      }, c.prototype.hashInt = function () {
        for (var e = this.hash(), t = 0; t < arguments.length; t++) e.update(arguments[t]);
        return o.intFromLE(e.digest()).umod(this.curve.n);
      }, c.prototype.keyFromPublic = function (e) {
        return l.fromPublic(this, e);
      }, c.prototype.keyFromSecret = function (e) {
        return l.fromSecret(this, e);
      }, c.prototype.makeSignature = function (e) {
        return e instanceof u ? e : new u(this, e);
      }, c.prototype.encodePoint = function (e) {
        var t = e.getY().toArray("le", this.encodingLength);
        return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
      }, c.prototype.decodePoint = function (e) {
        var t = (e = o.parseBytes(e)).length - 1,
          n = e.slice(0, t).concat(-129 & e[t]),
          r = 0 != (128 & e[t]),
          i = o.intFromLE(n);
        return this.curve.pointFromY(i, r);
      }, c.prototype.encodeInt = function (e) {
        return e.toArray("le", this.encodingLength);
      }, c.prototype.decodeInt = function (e) {
        return o.intFromLE(e);
      }, c.prototype.isPoint = function (e) {
        return e instanceof this.pointClass;
      };
    },
    "./node_modules/elliptic/lib/elliptic/eddsa/key.js": function node_modulesEllipticLibEllipticEddsaKeyJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        i = r.assert,
        o = r.parseBytes,
        a = r.cachedProperty;
      function s(e, t) {
        this.eddsa = e, this._secret = o(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = o(t.pub);
      }
      s.fromPublic = function (e, t) {
        return t instanceof s ? t : new s(e, {
          pub: t
        });
      }, s.fromSecret = function (e, t) {
        return t instanceof s ? t : new s(e, {
          secret: t
        });
      }, s.prototype.secret = function () {
        return this._secret;
      }, a(s, "pubBytes", function () {
        return this.eddsa.encodePoint(this.pub());
      }), a(s, "pub", function () {
        return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
      }), a(s, "privBytes", function () {
        var e = this.eddsa,
          t = this.hash(),
          n = e.encodingLength - 1,
          r = t.slice(0, e.encodingLength);
        return r[0] &= 248, r[n] &= 127, r[n] |= 64, r;
      }), a(s, "priv", function () {
        return this.eddsa.decodeInt(this.privBytes());
      }), a(s, "hash", function () {
        return this.eddsa.hash().update(this.secret()).digest();
      }), a(s, "messagePrefix", function () {
        return this.hash().slice(this.eddsa.encodingLength);
      }), s.prototype.sign = function (e) {
        return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
      }, s.prototype.verify = function (e, t) {
        return this.eddsa.verify(e, t, this);
      }, s.prototype.getSecret = function (e) {
        return i(this._secret, "KeyPair is public only"), r.encode(this.secret(), e);
      }, s.prototype.getPublic = function (e) {
        return r.encode(this.pubBytes(), e);
      }, e.exports = s;
    },
    "./node_modules/elliptic/lib/elliptic/eddsa/signature.js": function node_modulesEllipticLibEllipticEddsaSignatureJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/elliptic/lib/elliptic/utils.js"),
        o = i.assert,
        a = i.cachedProperty,
        s = i.parseBytes;
      function l(e, t) {
        this.eddsa = e, "object" != typeof t && (t = s(t)), Array.isArray(t) && (t = {
          R: t.slice(0, e.encodingLength),
          S: t.slice(e.encodingLength)
        }), o(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof r && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
      }
      a(l, "S", function () {
        return this.eddsa.decodeInt(this.Sencoded());
      }), a(l, "R", function () {
        return this.eddsa.decodePoint(this.Rencoded());
      }), a(l, "Rencoded", function () {
        return this.eddsa.encodePoint(this.R());
      }), a(l, "Sencoded", function () {
        return this.eddsa.encodeInt(this.S());
      }), l.prototype.toBytes = function () {
        return this.Rencoded().concat(this.Sencoded());
      }, l.prototype.toHex = function () {
        return i.encode(this.toBytes(), "hex").toUpperCase();
      }, e.exports = l;
    },
    "./node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js": function node_modulesEllipticLibEllipticPrecomputedSecp256k1Js(e, t) {
      e.exports = {
        doubles: {
          step: 4,
          points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
        },
        naf: {
          wnd: 7,
          points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
        }
      };
    },
    "./node_modules/elliptic/lib/elliptic/utils.js": function node_modulesEllipticLibEllipticUtilsJs(e, t, n) {
      "use strict";

      var r = t,
        i = n("./node_modules/bn.js/lib/bn.js"),
        o = n("./node_modules/minimalistic-assert/index.js"),
        a = n("./node_modules/minimalistic-crypto-utils/lib/utils.js");
      r.assert = o, r.toArray = a.toArray, r.zero2 = a.zero2, r.toHex = a.toHex, r.encode = a.encode, r.getNAF = function (e, t, n) {
        var r = new Array(Math.max(e.bitLength(), n) + 1);
        r.fill(0);
        for (var i = 1 << t + 1, o = e.clone(), a = 0; a < r.length; a++) {
          var s,
            l = o.andln(i - 1);
          o.isOdd() ? (s = l > (i >> 1) - 1 ? (i >> 1) - l : l, o.isubn(s)) : s = 0, r[a] = s, o.iushrn(1);
        }
        return r;
      }, r.getJSF = function (e, t) {
        var n = [[], []];
        e = e.clone(), t = t.clone();
        for (var r = 0, i = 0; e.cmpn(-r) > 0 || t.cmpn(-i) > 0;) {
          var o,
            a,
            s,
            l = e.andln(3) + r & 3,
            u = t.andln(3) + i & 3;
          if (3 === l && (l = -1), 3 === u && (u = -1), 0 == (1 & l)) o = 0;else o = 3 !== (s = e.andln(7) + r & 7) && 5 !== s || 2 !== u ? l : -l;
          if (n[0].push(o), 0 == (1 & u)) a = 0;else a = 3 !== (s = t.andln(7) + i & 7) && 5 !== s || 2 !== l ? u : -u;
          n[1].push(a), 2 * r === o + 1 && (r = 1 - r), 2 * i === a + 1 && (i = 1 - i), e.iushrn(1), t.iushrn(1);
        }
        return n;
      }, r.cachedProperty = function (e, t, n) {
        var r = "_" + t;
        e.prototype[t] = function () {
          return void 0 !== this[r] ? this[r] : this[r] = n.call(this);
        };
      }, r.parseBytes = function (e) {
        return "string" == typeof e ? r.toArray(e, "hex") : e;
      }, r.intFromLE = function (e) {
        return new i(e, "hex", "le");
      };
    },
    "./node_modules/elliptic/package.json": function node_modulesEllipticPackageJson(e) {
      e.exports = JSON.parse('{"name":"elliptic","version":"6.5.2","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^1.4.3","coveralls":"^3.0.8","grunt":"^1.0.4","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.2","jscs":"^3.0.7","jshint":"^2.10.3","mocha":"^6.2.2"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"}}');
    },
    "./node_modules/es-abstract/GetIntrinsic.js": function node_modulesEsAbstractGetIntrinsicJs(e, t, n) {
      "use strict";

      var r = TypeError,
        i = Object.getOwnPropertyDescriptor;
      if (i) try {
        i({}, "");
      } catch (e) {
        i = null;
      }
      var o = function o() {
          throw new r();
        },
        a = i ? function () {
          try {
            return arguments.callee, o;
          } catch (e) {
            try {
              return i(arguments, "callee").get;
            } catch (e) {
              return o;
            }
          }
        }() : o,
        s = n("./node_modules/has-symbols/index.js")(),
        l = Object.getPrototypeOf || function (e) {
          return e.__proto__;
        },
        u = void 0,
        c = "undefined" == typeof Uint8Array ? void 0 : l(Uint8Array),
        d = {
          "%Array%": Array,
          "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
          "%ArrayBufferPrototype%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer.prototype,
          "%ArrayIteratorPrototype%": s ? l([][Symbol.iterator]()) : void 0,
          "%ArrayPrototype%": Array.prototype,
          "%ArrayProto_entries%": Array.prototype.entries,
          "%ArrayProto_forEach%": Array.prototype.forEach,
          "%ArrayProto_keys%": Array.prototype.keys,
          "%ArrayProto_values%": Array.prototype.values,
          "%AsyncFromSyncIteratorPrototype%": void 0,
          "%AsyncFunction%": void 0,
          "%AsyncFunctionPrototype%": void 0,
          "%AsyncGenerator%": void 0,
          "%AsyncGeneratorFunction%": void 0,
          "%AsyncGeneratorPrototype%": void 0,
          "%AsyncIteratorPrototype%": u && s && Symbol.asyncIterator ? u[Symbol.asyncIterator]() : void 0,
          "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
          "%Boolean%": Boolean,
          "%BooleanPrototype%": Boolean.prototype,
          "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
          "%DataViewPrototype%": "undefined" == typeof DataView ? void 0 : DataView.prototype,
          "%Date%": Date,
          "%DatePrototype%": Date.prototype,
          "%decodeURI%": decodeURI,
          "%decodeURIComponent%": decodeURIComponent,
          "%encodeURI%": encodeURI,
          "%encodeURIComponent%": encodeURIComponent,
          "%Error%": Error,
          "%ErrorPrototype%": Error.prototype,
          "%eval%": eval,
          "%EvalError%": EvalError,
          "%EvalErrorPrototype%": EvalError.prototype,
          "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
          "%Float32ArrayPrototype%": "undefined" == typeof Float32Array ? void 0 : Float32Array.prototype,
          "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
          "%Float64ArrayPrototype%": "undefined" == typeof Float64Array ? void 0 : Float64Array.prototype,
          "%Function%": Function,
          "%FunctionPrototype%": Function.prototype,
          "%Generator%": void 0,
          "%GeneratorFunction%": void 0,
          "%GeneratorPrototype%": void 0,
          "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
          "%Int8ArrayPrototype%": "undefined" == typeof Int8Array ? void 0 : Int8Array.prototype,
          "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
          "%Int16ArrayPrototype%": "undefined" == typeof Int16Array ? void 0 : Int8Array.prototype,
          "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
          "%Int32ArrayPrototype%": "undefined" == typeof Int32Array ? void 0 : Int32Array.prototype,
          "%isFinite%": isFinite,
          "%isNaN%": isNaN,
          "%IteratorPrototype%": s ? l(l([][Symbol.iterator]())) : void 0,
          "%JSON%": "object" == typeof JSON ? JSON : void 0,
          "%JSONParse%": "object" == typeof JSON ? JSON.parse : void 0,
          "%Map%": "undefined" == typeof Map ? void 0 : Map,
          "%MapIteratorPrototype%": "undefined" != typeof Map && s ? l(new Map()[Symbol.iterator]()) : void 0,
          "%MapPrototype%": "undefined" == typeof Map ? void 0 : Map.prototype,
          "%Math%": Math,
          "%Number%": Number,
          "%NumberPrototype%": Number.prototype,
          "%Object%": Object,
          "%ObjectPrototype%": Object.prototype,
          "%ObjProto_toString%": Object.prototype.toString,
          "%ObjProto_valueOf%": Object.prototype.valueOf,
          "%parseFloat%": parseFloat,
          "%parseInt%": parseInt,
          "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
          "%PromisePrototype%": "undefined" == typeof Promise ? void 0 : Promise.prototype,
          "%PromiseProto_then%": "undefined" == typeof Promise ? void 0 : Promise.prototype.then,
          "%Promise_all%": "undefined" == typeof Promise ? void 0 : Promise.all,
          "%Promise_reject%": "undefined" == typeof Promise ? void 0 : Promise.reject,
          "%Promise_resolve%": "undefined" == typeof Promise ? void 0 : Promise.resolve,
          "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
          "%RangeError%": RangeError,
          "%RangeErrorPrototype%": RangeError.prototype,
          "%ReferenceError%": ReferenceError,
          "%ReferenceErrorPrototype%": ReferenceError.prototype,
          "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
          "%RegExp%": RegExp,
          "%RegExpPrototype%": RegExp.prototype,
          "%Set%": "undefined" == typeof Set ? void 0 : Set,
          "%SetIteratorPrototype%": "undefined" != typeof Set && s ? l(new Set()[Symbol.iterator]()) : void 0,
          "%SetPrototype%": "undefined" == typeof Set ? void 0 : Set.prototype,
          "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
          "%SharedArrayBufferPrototype%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer.prototype,
          "%String%": String,
          "%StringIteratorPrototype%": s ? l(""[Symbol.iterator]()) : void 0,
          "%StringPrototype%": String.prototype,
          "%Symbol%": s ? Symbol : void 0,
          "%SymbolPrototype%": s ? Symbol.prototype : void 0,
          "%SyntaxError%": SyntaxError,
          "%SyntaxErrorPrototype%": SyntaxError.prototype,
          "%ThrowTypeError%": a,
          "%TypedArray%": c,
          "%TypedArrayPrototype%": c ? c.prototype : void 0,
          "%TypeError%": r,
          "%TypeErrorPrototype%": r.prototype,
          "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
          "%Uint8ArrayPrototype%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array.prototype,
          "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
          "%Uint8ClampedArrayPrototype%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray.prototype,
          "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
          "%Uint16ArrayPrototype%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array.prototype,
          "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
          "%Uint32ArrayPrototype%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array.prototype,
          "%URIError%": URIError,
          "%URIErrorPrototype%": URIError.prototype,
          "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
          "%WeakMapPrototype%": "undefined" == typeof WeakMap ? void 0 : WeakMap.prototype,
          "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet,
          "%WeakSetPrototype%": "undefined" == typeof WeakSet ? void 0 : WeakSet.prototype
        },
        h = n("./node_modules/function-bind/index.js").call(Function.call, String.prototype.replace),
        f = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
        p = /\\(\\)?/g,
        m = function m(e) {
          var t = [];
          return h(e, f, function (e, n, r, i) {
            t[t.length] = r ? h(i, p, "$1") : n || e;
          }), t;
        },
        g = function g(e, t) {
          if (!(e in d)) throw new SyntaxError("intrinsic " + e + " does not exist!");
          if (void 0 === d[e] && !t) throw new r("intrinsic " + e + " exists, but is not available. Please file an issue!");
          return d[e];
        };
      e.exports = function (e, t) {
        if ("string" != typeof e || 0 === e.length) throw new TypeError("intrinsic name must be a non-empty string");
        if (arguments.length > 1 && "boolean" != typeof t) throw new TypeError('"allowMissing" argument must be a boolean');
        for (var n = m(e), o = g("%" + (n.length > 0 ? n[0] : "") + "%", t), a = 1; a < n.length; a += 1) if (null != o) if (i && a + 1 >= n.length) {
          var s = i(o, n[a]);
          if (!t && !(n[a] in o)) throw new r("base intrinsic for " + e + " exists, but the property is not available.");
          o = s ? s.get || s.value : o[n[a]];
        } else o = o[n[a]];
        return o;
      };
    },
    "./node_modules/es-abstract/helpers/callBind.js": function node_modulesEsAbstractHelpersCallBindJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/function-bind/index.js"),
        i = n("./node_modules/es-abstract/GetIntrinsic.js")("%Function%"),
        o = i.apply,
        a = i.call;
      e.exports = function () {
        return r.apply(a, arguments);
      }, e.exports.apply = function () {
        return r.apply(o, arguments);
      };
    },
    "./node_modules/events/events.js": function node_modulesEventsEventsJs(e, t, n) {
      "use strict";

      var r,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (e, t, n) {
          return Function.prototype.apply.call(e, t, n);
        };
      r = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
      } : function (e) {
        return Object.getOwnPropertyNames(e);
      };
      var a = Number.isNaN || function (e) {
        return e != e;
      };
      function s() {
        s.init.call(this);
      }
      e.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
      var l = 10;
      function u(e) {
        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      }
      function c(e) {
        return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
      }
      function d(e, t, n, r) {
        var i, o, a, s;
        if (u(n), void 0 === (o = e._events) ? (o = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== o.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), a = o[t]), void 0 === a) a = o[t] = n, ++e._eventsCount;else if ("function" == typeof a ? a = o[t] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), (i = c(e)) > 0 && a.length > i && !a.warned) {
          a.warned = !0;
          var l = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, s = l, console && console.warn && console.warn(s);
        }
        return e;
      }
      function h() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }
      function f(e, t, n) {
        var r = {
            fired: !1,
            wrapFn: void 0,
            target: e,
            type: t,
            listener: n
          },
          i = h.bind(r);
        return i.listener = n, r.wrapFn = i, i;
      }
      function p(e, t, n) {
        var r = e._events;
        if (void 0 === r) return [];
        var i = r[t];
        return void 0 === i ? [] : "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (e) {
          for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
          return t;
        }(i) : g(i, i.length);
      }
      function m(e) {
        var t = this._events;
        if (void 0 !== t) {
          var n = t[e];
          if ("function" == typeof n) return 1;
          if (void 0 !== n) return n.length;
        }
        return 0;
      }
      function g(e, t) {
        for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e[r];
        return n;
      }
      Object.defineProperty(s, "defaultMaxListeners", {
        enumerable: !0,
        get: function get() {
          return l;
        },
        set: function set(e) {
          if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
          l = e;
        }
      }), s.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, s.prototype.setMaxListeners = function (e) {
        if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
        return this._maxListeners = e, this;
      }, s.prototype.getMaxListeners = function () {
        return c(this);
      }, s.prototype.emit = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
        var r = "error" === e,
          i = this._events;
        if (void 0 !== i) r = r && void 0 === i.error;else if (!r) return !1;
        if (r) {
          var a;
          if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
          var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
          throw s.context = a, s;
        }
        var l = i[e];
        if (void 0 === l) return !1;
        if ("function" == typeof l) o(l, this, t);else {
          var u = l.length,
            c = g(l, u);
          for (n = 0; n < u; ++n) o(c[n], this, t);
        }
        return !0;
      }, s.prototype.addListener = function (e, t) {
        return d(this, e, t, !1);
      }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (e, t) {
        return d(this, e, t, !0);
      }, s.prototype.once = function (e, t) {
        return u(t), this.on(e, f(this, e, t)), this;
      }, s.prototype.prependOnceListener = function (e, t) {
        return u(t), this.prependListener(e, f(this, e, t)), this;
      }, s.prototype.removeListener = function (e, t) {
        var n, r, i, o, a;
        if (u(t), void 0 === (r = this._events)) return this;
        if (void 0 === (n = r[e])) return this;
        if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
          for (i = -1, o = n.length - 1; o >= 0; o--) if (n[o] === t || n[o].listener === t) {
            a = n[o].listener, i = o;
            break;
          }
          if (i < 0) return this;
          0 === i ? n.shift() : function (e, t) {
            for (; t + 1 < e.length; t++) e[t] = e[t + 1];
            e.pop();
          }(n, i), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, a || t);
        }
        return this;
      }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (e) {
        var t, n, r;
        if (void 0 === (n = this._events)) return this;
        if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
        if (0 === arguments.length) {
          var i,
            o = Object.keys(n);
          for (r = 0; r < o.length; ++r) "removeListener" !== (i = o[r]) && this.removeAllListeners(i);
          return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }
        if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
        return this;
      }, s.prototype.listeners = function (e) {
        return p(this, e, !0);
      }, s.prototype.rawListeners = function (e) {
        return p(this, e, !1);
      }, s.listenerCount = function (e, t) {
        return "function" == typeof e.listenerCount ? e.listenerCount(t) : m.call(e, t);
      }, s.prototype.listenerCount = m, s.prototype.eventNames = function () {
        return this._eventsCount > 0 ? r(this._events) : [];
      };
    },
    "./node_modules/evp_bytestokey/index.js": function node_modulesEvp_bytestokeyIndexJs(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = n("./node_modules/md5.js/index.js");
      e.exports = function (e, t, n, o) {
        if (r.isBuffer(e) || (e = r.from(e, "binary")), t && (r.isBuffer(t) || (t = r.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
        for (var a = n / 8, s = r.alloc(a), l = r.alloc(o || 0), u = r.alloc(0); a > 0 || o > 0;) {
          var c = new i();
          c.update(u), c.update(e), t && c.update(t), u = c.digest();
          var d = 0;
          if (a > 0) {
            var h = s.length - a;
            d = Math.min(a, u.length), u.copy(s, h, 0, d), a -= d;
          }
          if (d < u.length && o > 0) {
            var f = l.length - o,
              p = Math.min(o, u.length - d);
            u.copy(l, f, d, d + p), o -= p;
          }
        }
        return u.fill(0), {
          key: s,
          iv: l
        };
      };
    },
    "./node_modules/exenv/index.js": function node_modulesExenvIndexJs(e, t, n) {
      var r;
      /*!
        Copyright (c) 2015 Jed Watson.
        Based on code that is Copyright 2013-2015, Facebook, Inc.
        All rights reserved.
      */
      !function () {
        "use strict";

        var i = !("undefined" == typeof window || !window.document || !window.document.createElement),
          o = {
            canUseDOM: i,
            canUseWorkers: "undefined" != typeof Worker,
            canUseEventListeners: i && !(!window.addEventListener && !window.attachEvent),
            canUseViewport: i && !!window.screen
          };
        void 0 === (r = function () {
          return o;
        }.call(t, n, t, e)) || (e.exports = r);
      }();
    },
    "./node_modules/fbjs/lib/shallowEqual.js": function node_modulesFbjsLibShallowEqualJs(e, t, n) {
      "use strict";

      var r = Object.prototype.hasOwnProperty;
      function i(e, t) {
        return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
      }
      e.exports = function (e, t) {
        if (i(e, t)) return !0;
        if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
        var n = Object.keys(e),
          o = Object.keys(t);
        if (n.length !== o.length) return !1;
        for (var a = 0; a < n.length; a++) if (!r.call(t, n[a]) || !i(e[n[a]], t[n[a]])) return !1;
        return !0;
      };
    },
    "./node_modules/function-bind/implementation.js": function node_modulesFunctionBindImplementationJs(e, t, n) {
      "use strict";

      var r = "Function.prototype.bind called on incompatible ",
        i = Array.prototype.slice,
        o = Object.prototype.toString;
      e.exports = function (e) {
        var t = this;
        if ("function" != typeof t || "[object Function]" !== o.call(t)) throw new TypeError(r + t);
        for (var n, a = i.call(arguments, 1), s = function s() {
            if (this instanceof n) {
              var r = t.apply(this, a.concat(i.call(arguments)));
              return Object(r) === r ? r : this;
            }
            return t.apply(e, a.concat(i.call(arguments)));
          }, l = Math.max(0, t.length - a.length), u = [], c = 0; c < l; c++) u.push("$" + c);
        if (n = Function("binder", "return function (" + u.join(",") + "){ return binder.apply(this,arguments); }")(s), t.prototype) {
          var d = function d() {};
          d.prototype = t.prototype, n.prototype = new d(), d.prototype = null;
        }
        return n;
      };
    },
    "./node_modules/function-bind/index.js": function node_modulesFunctionBindIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/function-bind/implementation.js");
      e.exports = Function.prototype.bind || r;
    },
    "./node_modules/gud/index.js": function node_modulesGudIndexJs(e, t, n) {
      "use strict";

      (function (t) {
        var n = "__global_unique_id__";
        e.exports = function () {
          return t[n] = (t[n] || 0) + 1;
        };
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/has-symbols/index.js": function node_modulesHasSymbolsIndexJs(e, t, n) {
      "use strict";

      (function (t) {
        var r = t.Symbol,
          i = n("./node_modules/has-symbols/shams.js");
        e.exports = function () {
          return "function" == typeof r && "function" == typeof Symbol && "symbol" == typeof r("foo") && "symbol" == typeof Symbol("bar") && i();
        };
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/has-symbols/shams.js": function node_modulesHasSymbolsShamsJs(e, t, n) {
      "use strict";

      e.exports = function () {
        if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
        if ("symbol" == typeof Symbol.iterator) return !0;
        var e = {},
          t = Symbol("test"),
          n = Object(t);
        if ("string" == typeof t) return !1;
        if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
        if ("[object Symbol]" !== Object.prototype.toString.call(n)) return !1;
        for (t in e[t] = 42, e) return !1;
        if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
        if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
        var r = Object.getOwnPropertySymbols(e);
        if (1 !== r.length || r[0] !== t) return !1;
        if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
        if ("function" == typeof Object.getOwnPropertyDescriptor) {
          var i = Object.getOwnPropertyDescriptor(e, t);
          if (42 !== i.value || !0 !== i.enumerable) return !1;
        }
        return !0;
      };
    },
    "./node_modules/has/src/index.js": function node_modulesHasSrcIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/function-bind/index.js");
      e.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
    },
    "./node_modules/hash-base/index.js": function node_modulesHashBaseIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = n("./node_modules/stream-browserify/index.js").Transform;
      function o(e) {
        i.call(this), this._block = r.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
      }
      n("./node_modules/inherits/inherits_browser.js")(o, i), o.prototype._transform = function (e, t, n) {
        var r = null;
        try {
          this.update(e, t);
        } catch (e) {
          r = e;
        }
        n(r);
      }, o.prototype._flush = function (e) {
        var t = null;
        try {
          this.push(this.digest());
        } catch (e) {
          t = e;
        }
        e(t);
      }, o.prototype.update = function (e, t) {
        if (function (e, t) {
          if (!r.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
        }(e, "Data"), this._finalized) throw new Error("Digest already called");
        r.isBuffer(e) || (e = r.from(e, t));
        for (var n = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;) {
          for (var o = this._blockOffset; o < this._blockSize;) n[o++] = e[i++];
          this._update(), this._blockOffset = 0;
        }
        for (; i < e.length;) n[this._blockOffset++] = e[i++];
        for (var a = 0, s = 8 * e.length; s > 0; ++a) this._length[a] += s, (s = this._length[a] / 4294967296 | 0) > 0 && (this._length[a] -= 4294967296 * s);
        return this;
      }, o.prototype._update = function () {
        throw new Error("_update is not implemented");
      }, o.prototype.digest = function (e) {
        if (this._finalized) throw new Error("Digest already called");
        this._finalized = !0;
        var t = this._digest();
        void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
        for (var n = 0; n < 4; ++n) this._length[n] = 0;
        return t;
      }, o.prototype._digest = function () {
        throw new Error("_digest is not implemented");
      }, e.exports = o;
    },
    "./node_modules/hash.js/lib/hash.js": function node_modulesHashJsLibHashJs(e, t, n) {
      var r = t;
      r.utils = n("./node_modules/hash.js/lib/hash/utils.js"), r.common = n("./node_modules/hash.js/lib/hash/common.js"), r.sha = n("./node_modules/hash.js/lib/hash/sha.js"), r.ripemd = n("./node_modules/hash.js/lib/hash/ripemd.js"), r.hmac = n("./node_modules/hash.js/lib/hash/hmac.js"), r.sha1 = r.sha.sha1, r.sha256 = r.sha.sha256, r.sha224 = r.sha.sha224, r.sha384 = r.sha.sha384, r.sha512 = r.sha.sha512, r.ripemd160 = r.ripemd.ripemd160;
    },
    "./node_modules/hash.js/lib/hash/common.js": function node_modulesHashJsLibHashCommonJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/minimalistic-assert/index.js");
      function o() {
        this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
      }
      t.BlockHash = o, o.prototype.update = function (e, t) {
        if (e = r.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
          var n = (e = this.pending).length % this._delta8;
          this.pending = e.slice(e.length - n, e.length), 0 === this.pending.length && (this.pending = null), e = r.join32(e, 0, e.length - n, this.endian);
          for (var i = 0; i < e.length; i += this._delta32) this._update(e, i, i + this._delta32);
        }
        return this;
      }, o.prototype.digest = function (e) {
        return this.update(this._pad()), i(null === this.pending), this._digest(e);
      }, o.prototype._pad = function () {
        var e = this.pendingTotal,
          t = this._delta8,
          n = t - (e + this.padLength) % t,
          r = new Array(n + this.padLength);
        r[0] = 128;
        for (var i = 1; i < n; i++) r[i] = 0;
        if (e <<= 3, "big" === this.endian) {
          for (var o = 8; o < this.padLength; o++) r[i++] = 0;
          r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = e >>> 24 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 8 & 255, r[i++] = 255 & e;
        } else for (r[i++] = 255 & e, r[i++] = e >>> 8 & 255, r[i++] = e >>> 16 & 255, r[i++] = e >>> 24 & 255, r[i++] = 0, r[i++] = 0, r[i++] = 0, r[i++] = 0, o = 8; o < this.padLength; o++) r[i++] = 0;
        return r;
      };
    },
    "./node_modules/hash.js/lib/hash/hmac.js": function node_modulesHashJsLibHashHmacJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/minimalistic-assert/index.js");
      function o(e, t, n) {
        if (!(this instanceof o)) return new o(e, t, n);
        this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(r.toArray(t, n));
      }
      e.exports = o, o.prototype._init = function (e) {
        e.length > this.blockSize && (e = new this.Hash().update(e).digest()), i(e.length <= this.blockSize);
        for (var t = e.length; t < this.blockSize; t++) e.push(0);
        for (t = 0; t < e.length; t++) e[t] ^= 54;
        for (this.inner = new this.Hash().update(e), t = 0; t < e.length; t++) e[t] ^= 106;
        this.outer = new this.Hash().update(e);
      }, o.prototype.update = function (e, t) {
        return this.inner.update(e, t), this;
      }, o.prototype.digest = function (e) {
        return this.outer.update(this.inner.digest()), this.outer.digest(e);
      };
    },
    "./node_modules/hash.js/lib/hash/ripemd.js": function node_modulesHashJsLibHashRipemdJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/hash.js/lib/hash/common.js"),
        o = r.rotl32,
        a = r.sum32,
        s = r.sum32_3,
        l = r.sum32_4,
        u = i.BlockHash;
      function c() {
        if (!(this instanceof c)) return new c();
        u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
      }
      function d(e, t, n, r) {
        return e <= 15 ? t ^ n ^ r : e <= 31 ? t & n | ~t & r : e <= 47 ? (t | ~n) ^ r : e <= 63 ? t & r | n & ~r : t ^ (n | ~r);
      }
      function h(e) {
        return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
      }
      function f(e) {
        return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
      }
      r.inherits(c, u), t.ripemd160 = c, c.blockSize = 512, c.outSize = 160, c.hmacStrength = 192, c.padLength = 64, c.prototype._update = function (e, t) {
        for (var n = this.h[0], r = this.h[1], i = this.h[2], u = this.h[3], c = this.h[4], y = n, b = r, _ = i, x = u, w = c, S = 0; S < 80; S++) {
          var A = a(o(l(n, d(S, r, i, u), e[p[S] + t], h(S)), g[S]), c);
          n = c, c = u, u = o(i, 10), i = r, r = A, A = a(o(l(y, d(79 - S, b, _, x), e[m[S] + t], f(S)), v[S]), w), y = w, w = x, x = o(_, 10), _ = b, b = A;
        }
        A = s(this.h[1], i, x), this.h[1] = s(this.h[2], u, w), this.h[2] = s(this.h[3], c, y), this.h[3] = s(this.h[4], n, b), this.h[4] = s(this.h[0], r, _), this.h[0] = A;
      }, c.prototype._digest = function (e) {
        return "hex" === e ? r.toHex32(this.h, "little") : r.split32(this.h, "little");
      };
      var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        m = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        g = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        v = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
    },
    "./node_modules/hash.js/lib/hash/sha.js": function node_modulesHashJsLibHashShaJs(e, t, n) {
      "use strict";

      t.sha1 = n("./node_modules/hash.js/lib/hash/sha/1.js"), t.sha224 = n("./node_modules/hash.js/lib/hash/sha/224.js"), t.sha256 = n("./node_modules/hash.js/lib/hash/sha/256.js"), t.sha384 = n("./node_modules/hash.js/lib/hash/sha/384.js"), t.sha512 = n("./node_modules/hash.js/lib/hash/sha/512.js");
    },
    "./node_modules/hash.js/lib/hash/sha/1.js": function node_modulesHashJsLibHashSha1Js(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/hash.js/lib/hash/common.js"),
        o = n("./node_modules/hash.js/lib/hash/sha/common.js"),
        a = r.rotl32,
        s = r.sum32,
        l = r.sum32_5,
        u = o.ft_1,
        c = i.BlockHash,
        d = [1518500249, 1859775393, 2400959708, 3395469782];
      function h() {
        if (!(this instanceof h)) return new h();
        c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
      }
      r.inherits(h, c), e.exports = h, h.blockSize = 512, h.outSize = 160, h.hmacStrength = 80, h.padLength = 64, h.prototype._update = function (e, t) {
        for (var n = this.W, r = 0; r < 16; r++) n[r] = e[t + r];
        for (; r < n.length; r++) n[r] = a(n[r - 3] ^ n[r - 8] ^ n[r - 14] ^ n[r - 16], 1);
        var i = this.h[0],
          o = this.h[1],
          c = this.h[2],
          h = this.h[3],
          f = this.h[4];
        for (r = 0; r < n.length; r++) {
          var p = ~~(r / 20),
            m = l(a(i, 5), u(p, o, c, h), f, n[r], d[p]);
          f = h, h = c, c = a(o, 30), o = i, i = m;
        }
        this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], c), this.h[3] = s(this.h[3], h), this.h[4] = s(this.h[4], f);
      }, h.prototype._digest = function (e) {
        return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
      };
    },
    "./node_modules/hash.js/lib/hash/sha/224.js": function node_modulesHashJsLibHashSha224Js(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/hash.js/lib/hash/sha/256.js");
      function o() {
        if (!(this instanceof o)) return new o();
        i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
      }
      r.inherits(o, i), e.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (e) {
        return "hex" === e ? r.toHex32(this.h.slice(0, 7), "big") : r.split32(this.h.slice(0, 7), "big");
      };
    },
    "./node_modules/hash.js/lib/hash/sha/256.js": function node_modulesHashJsLibHashSha256Js(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/hash.js/lib/hash/common.js"),
        o = n("./node_modules/hash.js/lib/hash/sha/common.js"),
        a = n("./node_modules/minimalistic-assert/index.js"),
        s = r.sum32,
        l = r.sum32_4,
        u = r.sum32_5,
        c = o.ch32,
        d = o.maj32,
        h = o.s0_256,
        f = o.s1_256,
        p = o.g0_256,
        m = o.g1_256,
        g = i.BlockHash,
        v = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
      function y() {
        if (!(this instanceof y)) return new y();
        g.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = v, this.W = new Array(64);
      }
      r.inherits(y, g), e.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function (e, t) {
        for (var n = this.W, r = 0; r < 16; r++) n[r] = e[t + r];
        for (; r < n.length; r++) n[r] = l(m(n[r - 2]), n[r - 7], p(n[r - 15]), n[r - 16]);
        var i = this.h[0],
          o = this.h[1],
          g = this.h[2],
          v = this.h[3],
          y = this.h[4],
          b = this.h[5],
          _ = this.h[6],
          x = this.h[7];
        for (a(this.k.length === n.length), r = 0; r < n.length; r++) {
          var w = u(x, f(y), c(y, b, _), this.k[r], n[r]),
            S = s(h(i), d(i, o, g));
          x = _, _ = b, b = y, y = s(v, w), v = g, g = o, o = i, i = s(w, S);
        }
        this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], g), this.h[3] = s(this.h[3], v), this.h[4] = s(this.h[4], y), this.h[5] = s(this.h[5], b), this.h[6] = s(this.h[6], _), this.h[7] = s(this.h[7], x);
      }, y.prototype._digest = function (e) {
        return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
      };
    },
    "./node_modules/hash.js/lib/hash/sha/384.js": function node_modulesHashJsLibHashSha384Js(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/hash.js/lib/hash/sha/512.js");
      function o() {
        if (!(this instanceof o)) return new o();
        i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
      }
      r.inherits(o, i), e.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (e) {
        return "hex" === e ? r.toHex32(this.h.slice(0, 12), "big") : r.split32(this.h.slice(0, 12), "big");
      };
    },
    "./node_modules/hash.js/lib/hash/sha/512.js": function node_modulesHashJsLibHashSha512Js(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js"),
        i = n("./node_modules/hash.js/lib/hash/common.js"),
        o = n("./node_modules/minimalistic-assert/index.js"),
        a = r.rotr64_hi,
        s = r.rotr64_lo,
        l = r.shr64_hi,
        u = r.shr64_lo,
        c = r.sum64,
        d = r.sum64_hi,
        h = r.sum64_lo,
        f = r.sum64_4_hi,
        p = r.sum64_4_lo,
        m = r.sum64_5_hi,
        g = r.sum64_5_lo,
        v = i.BlockHash,
        y = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
      function b() {
        if (!(this instanceof b)) return new b();
        v.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = y, this.W = new Array(160);
      }
      function _(e, t, n, r, i) {
        var o = e & n ^ ~e & i;
        return o < 0 && (o += 4294967296), o;
      }
      function x(e, t, n, r, i, o) {
        var a = t & r ^ ~t & o;
        return a < 0 && (a += 4294967296), a;
      }
      function w(e, t, n, r, i) {
        var o = e & n ^ e & i ^ n & i;
        return o < 0 && (o += 4294967296), o;
      }
      function S(e, t, n, r, i, o) {
        var a = t & r ^ t & o ^ r & o;
        return a < 0 && (a += 4294967296), a;
      }
      function A(e, t) {
        var n = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
        return n < 0 && (n += 4294967296), n;
      }
      function E(e, t) {
        var n = s(e, t, 28) ^ s(t, e, 2) ^ s(t, e, 7);
        return n < 0 && (n += 4294967296), n;
      }
      function T(e, t) {
        var n = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
        return n < 0 && (n += 4294967296), n;
      }
      function M(e, t) {
        var n = s(e, t, 14) ^ s(e, t, 18) ^ s(t, e, 9);
        return n < 0 && (n += 4294967296), n;
      }
      function C(e, t) {
        var n = a(e, t, 1) ^ a(e, t, 8) ^ l(e, t, 7);
        return n < 0 && (n += 4294967296), n;
      }
      function k(e, t) {
        var n = s(e, t, 1) ^ s(e, t, 8) ^ u(e, t, 7);
        return n < 0 && (n += 4294967296), n;
      }
      function P(e, t) {
        var n = a(e, t, 19) ^ a(t, e, 29) ^ l(e, t, 6);
        return n < 0 && (n += 4294967296), n;
      }
      function O(e, t) {
        var n = s(e, t, 19) ^ s(t, e, 29) ^ u(e, t, 6);
        return n < 0 && (n += 4294967296), n;
      }
      r.inherits(b, v), e.exports = b, b.blockSize = 1024, b.outSize = 512, b.hmacStrength = 192, b.padLength = 128, b.prototype._prepareBlock = function (e, t) {
        for (var n = this.W, r = 0; r < 32; r++) n[r] = e[t + r];
        for (; r < n.length; r += 2) {
          var i = P(n[r - 4], n[r - 3]),
            o = O(n[r - 4], n[r - 3]),
            a = n[r - 14],
            s = n[r - 13],
            l = C(n[r - 30], n[r - 29]),
            u = k(n[r - 30], n[r - 29]),
            c = n[r - 32],
            d = n[r - 31];
          n[r] = f(i, o, a, s, l, u, c, d), n[r + 1] = p(i, o, a, s, l, u, c, d);
        }
      }, b.prototype._update = function (e, t) {
        this._prepareBlock(e, t);
        var n = this.W,
          r = this.h[0],
          i = this.h[1],
          a = this.h[2],
          s = this.h[3],
          l = this.h[4],
          u = this.h[5],
          f = this.h[6],
          p = this.h[7],
          v = this.h[8],
          y = this.h[9],
          b = this.h[10],
          C = this.h[11],
          k = this.h[12],
          P = this.h[13],
          O = this.h[14],
          R = this.h[15];
        o(this.k.length === n.length);
        for (var I = 0; I < n.length; I += 2) {
          var j = O,
            N = R,
            L = T(v, y),
            D = M(v, y),
            B = _(v, y, b, C, k),
            F = x(v, y, b, C, k, P),
            z = this.k[I],
            U = this.k[I + 1],
            G = n[I],
            V = n[I + 1],
            H = m(j, N, L, D, B, F, z, U, G, V),
            q = g(j, N, L, D, B, F, z, U, G, V);
          j = A(r, i), N = E(r, i), L = w(r, i, a, s, l), D = S(r, i, a, s, l, u);
          var W = d(j, N, L, D),
            $ = h(j, N, L, D);
          O = k, R = P, k = b, P = C, b = v, C = y, v = d(f, p, H, q), y = h(p, p, H, q), f = l, p = u, l = a, u = s, a = r, s = i, r = d(H, q, W, $), i = h(H, q, W, $);
        }
        c(this.h, 0, r, i), c(this.h, 2, a, s), c(this.h, 4, l, u), c(this.h, 6, f, p), c(this.h, 8, v, y), c(this.h, 10, b, C), c(this.h, 12, k, P), c(this.h, 14, O, R);
      }, b.prototype._digest = function (e) {
        return "hex" === e ? r.toHex32(this.h, "big") : r.split32(this.h, "big");
      };
    },
    "./node_modules/hash.js/lib/hash/sha/common.js": function node_modulesHashJsLibHashShaCommonJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash/utils.js").rotr32;
      function i(e, t, n) {
        return e & t ^ ~e & n;
      }
      function o(e, t, n) {
        return e & t ^ e & n ^ t & n;
      }
      function a(e, t, n) {
        return e ^ t ^ n;
      }
      t.ft_1 = function (e, t, n, r) {
        return 0 === e ? i(t, n, r) : 1 === e || 3 === e ? a(t, n, r) : 2 === e ? o(t, n, r) : void 0;
      }, t.ch32 = i, t.maj32 = o, t.p32 = a, t.s0_256 = function (e) {
        return r(e, 2) ^ r(e, 13) ^ r(e, 22);
      }, t.s1_256 = function (e) {
        return r(e, 6) ^ r(e, 11) ^ r(e, 25);
      }, t.g0_256 = function (e) {
        return r(e, 7) ^ r(e, 18) ^ e >>> 3;
      }, t.g1_256 = function (e) {
        return r(e, 17) ^ r(e, 19) ^ e >>> 10;
      };
    },
    "./node_modules/hash.js/lib/hash/utils.js": function node_modulesHashJsLibHashUtilsJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/minimalistic-assert/index.js"),
        i = n("./node_modules/inherits/inherits_browser.js");
      function o(e, t) {
        return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
      }
      function a(e) {
        return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
      }
      function s(e) {
        return 1 === e.length ? "0" + e : e;
      }
      function l(e) {
        return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
      }
      t.inherits = i, t.toArray = function (e, t) {
        if (Array.isArray(e)) return e.slice();
        if (!e) return [];
        var n = [];
        if ("string" == typeof e) {
          if (t) {
            if ("hex" === t) for ((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2) n.push(parseInt(e[i] + e[i + 1], 16));
          } else for (var r = 0, i = 0; i < e.length; i++) {
            var a = e.charCodeAt(i);
            a < 128 ? n[r++] = a : a < 2048 ? (n[r++] = a >> 6 | 192, n[r++] = 63 & a | 128) : o(e, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++i)), n[r++] = a >> 18 | 240, n[r++] = a >> 12 & 63 | 128, n[r++] = a >> 6 & 63 | 128, n[r++] = 63 & a | 128) : (n[r++] = a >> 12 | 224, n[r++] = a >> 6 & 63 | 128, n[r++] = 63 & a | 128);
          }
        } else for (i = 0; i < e.length; i++) n[i] = 0 | e[i];
        return n;
      }, t.toHex = function (e) {
        for (var t = "", n = 0; n < e.length; n++) t += s(e[n].toString(16));
        return t;
      }, t.htonl = a, t.toHex32 = function (e, t) {
        for (var n = "", r = 0; r < e.length; r++) {
          var i = e[r];
          "little" === t && (i = a(i)), n += l(i.toString(16));
        }
        return n;
      }, t.zero2 = s, t.zero8 = l, t.join32 = function (e, t, n, i) {
        var o = n - t;
        r(o % 4 == 0);
        for (var a = new Array(o / 4), s = 0, l = t; s < a.length; s++, l += 4) {
          var u;
          u = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], a[s] = u >>> 0;
        }
        return a;
      }, t.split32 = function (e, t) {
        for (var n = new Array(4 * e.length), r = 0, i = 0; r < e.length; r++, i += 4) {
          var o = e[r];
          "big" === t ? (n[i] = o >>> 24, n[i + 1] = o >>> 16 & 255, n[i + 2] = o >>> 8 & 255, n[i + 3] = 255 & o) : (n[i + 3] = o >>> 24, n[i + 2] = o >>> 16 & 255, n[i + 1] = o >>> 8 & 255, n[i] = 255 & o);
        }
        return n;
      }, t.rotr32 = function (e, t) {
        return e >>> t | e << 32 - t;
      }, t.rotl32 = function (e, t) {
        return e << t | e >>> 32 - t;
      }, t.sum32 = function (e, t) {
        return e + t >>> 0;
      }, t.sum32_3 = function (e, t, n) {
        return e + t + n >>> 0;
      }, t.sum32_4 = function (e, t, n, r) {
        return e + t + n + r >>> 0;
      }, t.sum32_5 = function (e, t, n, r, i) {
        return e + t + n + r + i >>> 0;
      }, t.sum64 = function (e, t, n, r) {
        var i = e[t],
          o = r + e[t + 1] >>> 0,
          a = (o < r ? 1 : 0) + n + i;
        e[t] = a >>> 0, e[t + 1] = o;
      }, t.sum64_hi = function (e, t, n, r) {
        return (t + r >>> 0 < t ? 1 : 0) + e + n >>> 0;
      }, t.sum64_lo = function (e, t, n, r) {
        return t + r >>> 0;
      }, t.sum64_4_hi = function (e, t, n, r, i, o, a, s) {
        var l = 0,
          u = t;
        return l += (u = u + r >>> 0) < t ? 1 : 0, l += (u = u + o >>> 0) < o ? 1 : 0, e + n + i + a + (l += (u = u + s >>> 0) < s ? 1 : 0) >>> 0;
      }, t.sum64_4_lo = function (e, t, n, r, i, o, a, s) {
        return t + r + o + s >>> 0;
      }, t.sum64_5_hi = function (e, t, n, r, i, o, a, s, l, u) {
        var c = 0,
          d = t;
        return c += (d = d + r >>> 0) < t ? 1 : 0, c += (d = d + o >>> 0) < o ? 1 : 0, c += (d = d + s >>> 0) < s ? 1 : 0, e + n + i + a + l + (c += (d = d + u >>> 0) < u ? 1 : 0) >>> 0;
      }, t.sum64_5_lo = function (e, t, n, r, i, o, a, s, l, u) {
        return t + r + o + s + u >>> 0;
      }, t.rotr64_hi = function (e, t, n) {
        return (t << 32 - n | e >>> n) >>> 0;
      }, t.rotr64_lo = function (e, t, n) {
        return (e << 32 - n | t >>> n) >>> 0;
      }, t.shr64_hi = function (e, t, n) {
        return e >>> n;
      }, t.shr64_lo = function (e, t, n) {
        return (e << 32 - n | t >>> n) >>> 0;
      };
    },
    "./node_modules/hmac-drbg/lib/hmac-drbg.js": function node_modulesHmacDrbgLibHmacDrbgJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/hash.js/lib/hash.js"),
        i = n("./node_modules/minimalistic-crypto-utils/lib/utils.js"),
        o = n("./node_modules/minimalistic-assert/index.js");
      function a(e) {
        if (!(this instanceof a)) return new a(e);
        this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
        var t = i.toArray(e.entropy, e.entropyEnc || "hex"),
          n = i.toArray(e.nonce, e.nonceEnc || "hex"),
          r = i.toArray(e.pers, e.persEnc || "hex");
        o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, n, r);
      }
      e.exports = a, a.prototype._init = function (e, t, n) {
        var r = e.concat(t).concat(n);
        this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
        for (var i = 0; i < this.V.length; i++) this.K[i] = 0, this.V[i] = 1;
        this._update(r), this._reseed = 1, this.reseedInterval = 281474976710656;
      }, a.prototype._hmac = function () {
        return new r.hmac(this.hash, this.K);
      }, a.prototype._update = function (e) {
        var t = this._hmac().update(this.V).update([0]);
        e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([1]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
      }, a.prototype.reseed = function (e, t, n, r) {
        "string" != typeof t && (r = n, n = t, t = null), e = i.toArray(e, t), n = i.toArray(n, r), o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(n || [])), this._reseed = 1;
      }, a.prototype.generate = function (e, t, n, r) {
        if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
        "string" != typeof t && (r = n, n = t, t = null), n && (n = i.toArray(n, r || "hex"), this._update(n));
        for (var o = []; o.length < e;) this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
        var a = o.slice(0, e);
        return this._update(n), this._reseed++, i.encode(a, t);
      };
    },
    "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js": function node_modulesHoistNonReactStaticsDistHoistNonReactStaticsCjsJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/react-is/index.js"),
        i = {
          childContextTypes: !0,
          contextType: !0,
          contextTypes: !0,
          defaultProps: !0,
          displayName: !0,
          getDefaultProps: !0,
          getDerivedStateFromError: !0,
          getDerivedStateFromProps: !0,
          mixins: !0,
          propTypes: !0,
          type: !0
        },
        o = {
          name: !0,
          length: !0,
          prototype: !0,
          caller: !0,
          callee: !0,
          arguments: !0,
          arity: !0
        },
        a = {
          $$typeof: !0,
          compare: !0,
          defaultProps: !0,
          displayName: !0,
          propTypes: !0,
          type: !0
        },
        s = {};
      function l(e) {
        return r.isMemo(e) ? a : s[e.$$typeof] || i;
      }
      s[r.ForwardRef] = {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
      }, s[r.Memo] = a;
      var u = Object.defineProperty,
        c = Object.getOwnPropertyNames,
        d = Object.getOwnPropertySymbols,
        h = Object.getOwnPropertyDescriptor,
        f = Object.getPrototypeOf,
        p = Object.prototype;
      e.exports = function e(t, n, r) {
        if ("string" != typeof n) {
          if (p) {
            var i = f(n);
            i && i !== p && e(t, i, r);
          }
          var a = c(n);
          d && (a = a.concat(d(n)));
          for (var s = l(t), m = l(n), g = 0; g < a.length; ++g) {
            var v = a[g];
            if (!(o[v] || r && r[v] || m && m[v] || s && s[v])) {
              var y = h(n, v);
              try {
                u(t, v, y);
              } catch (e) {}
            }
          }
        }
        return t;
      };
    },
    "./node_modules/ieee754/index.js": function node_modulesIeee754IndexJs(e, t) {
      t.read = function (e, t, n, r, i) {
        var o,
          a,
          s = 8 * i - r - 1,
          l = (1 << s) - 1,
          u = l >> 1,
          c = -7,
          d = n ? i - 1 : 0,
          h = n ? -1 : 1,
          f = e[t + d];
        for (d += h, o = f & (1 << -c) - 1, f >>= -c, c += s; c > 0; o = 256 * o + e[t + d], d += h, c -= 8);
        for (a = o & (1 << -c) - 1, o >>= -c, c += r; c > 0; a = 256 * a + e[t + d], d += h, c -= 8);
        if (0 === o) o = 1 - u;else {
          if (o === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
          a += Math.pow(2, r), o -= u;
        }
        return (f ? -1 : 1) * a * Math.pow(2, o - r);
      }, t.write = function (e, t, n, r, i, o) {
        var a,
          s,
          l,
          u = 8 * o - i - 1,
          c = (1 << u) - 1,
          d = c >> 1,
          h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          f = r ? 0 : o - 1,
          p = r ? 1 : -1,
          m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
        for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = c) : (a = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (t += a + d >= 1 ? h / l : h * Math.pow(2, 1 - d)) * l >= 2 && (a++, l /= 2), a + d >= c ? (s = 0, a = c) : a + d >= 1 ? (s = (t * l - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + f] = 255 & s, f += p, s /= 256, i -= 8);
        for (a = a << i | s, u += i; u > 0; e[n + f] = 255 & a, f += p, a /= 256, u -= 8);
        e[n + f - p] |= 128 * m;
      };
    },
    "./node_modules/immutable/dist/immutable.js": function node_modulesImmutableDistImmutableJs(e, t, n) {
      e.exports = function () {
        "use strict";

        var e = Array.prototype.slice;
        function t(e, t) {
          t && (e.prototype = Object.create(t.prototype)), e.prototype.constructor = e;
        }
        function n(e) {
          return a(e) ? e : G(e);
        }
        function r(e) {
          return s(e) ? e : V(e);
        }
        function i(e) {
          return l(e) ? e : H(e);
        }
        function o(e) {
          return a(e) && !u(e) ? e : q(e);
        }
        function a(e) {
          return !(!e || !e[d]);
        }
        function s(e) {
          return !(!e || !e[h]);
        }
        function l(e) {
          return !(!e || !e[f]);
        }
        function u(e) {
          return s(e) || l(e);
        }
        function c(e) {
          return !(!e || !e[p]);
        }
        t(r, n), t(i, n), t(o, n), n.isIterable = a, n.isKeyed = s, n.isIndexed = l, n.isAssociative = u, n.isOrdered = c, n.Keyed = r, n.Indexed = i, n.Set = o;
        var d = "@@__IMMUTABLE_ITERABLE__@@",
          h = "@@__IMMUTABLE_KEYED__@@",
          f = "@@__IMMUTABLE_INDEXED__@@",
          p = "@@__IMMUTABLE_ORDERED__@@",
          m = {},
          g = {
            value: !1
          },
          v = {
            value: !1
          };
        function y(e) {
          return e.value = !1, e;
        }
        function b(e) {
          e && (e.value = !0);
        }
        function _() {}
        function x(e, t) {
          t = t || 0;
          for (var n = Math.max(0, e.length - t), r = new Array(n), i = 0; i < n; i++) r[i] = e[i + t];
          return r;
        }
        function w(e) {
          return void 0 === e.size && (e.size = e.__iterate(A)), e.size;
        }
        function S(e, t) {
          if ("number" != typeof t) {
            var n = t >>> 0;
            if ("" + n !== t || 4294967295 === n) return NaN;
            t = n;
          }
          return t < 0 ? w(e) + t : t;
        }
        function A() {
          return !0;
        }
        function E(e, t, n) {
          return (0 === e || void 0 !== n && e <= -n) && (void 0 === t || void 0 !== n && t >= n);
        }
        function T(e, t) {
          return C(e, t, 0);
        }
        function M(e, t) {
          return C(e, t, t);
        }
        function C(e, t, n) {
          return void 0 === e ? n : e < 0 ? Math.max(0, t + e) : void 0 === t ? e : Math.min(t, e);
        }
        var k,
          P,
          O,
          R = "function" == typeof Symbol && Symbol.iterator,
          I = R || "@@iterator";
        function j(e) {
          this.next = e;
        }
        function N(e, t, n, r) {
          var i = 0 === e ? t : 1 === e ? n : [t, n];
          return r ? r.value = i : r = {
            value: i,
            done: !1
          }, r;
        }
        function L() {
          return {
            value: void 0,
            done: !0
          };
        }
        function D(e) {
          return !!z(e);
        }
        function B(e) {
          return e && "function" == typeof e.next;
        }
        function F(e) {
          var t = z(e);
          return t && t.call(e);
        }
        function z(e) {
          var t = e && (R && e[R] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }
        function U(e) {
          return e && "number" == typeof e.length;
        }
        function G(e) {
          return null == e ? Z() : a(e) ? e.toSeq() : function (e) {
            var t = ee(e) || "object" == typeof e && new $(e);
            if (!t) throw new TypeError("Expected Array or iterable object of values, or keyed object: " + e);
            return t;
          }(e);
        }
        function V(e) {
          return null == e ? Z().toKeyedSeq() : a(e) ? s(e) ? e.toSeq() : e.fromEntrySeq() : Q(e);
        }
        function H(e) {
          return null == e ? Z() : a(e) ? s(e) ? e.entrySeq() : e.toIndexedSeq() : J(e);
        }
        function q(e) {
          return (null == e ? Z() : a(e) ? s(e) ? e.entrySeq() : e : J(e)).toSetSeq();
        }
        function W(e) {
          this._array = e, this.size = e.length;
        }
        function $(e) {
          var t = Object.keys(e);
          this._object = e, this._keys = t, this.size = t.length;
        }
        function X(e) {
          this._iterable = e, this.size = e.length || e.size;
        }
        function Y(e) {
          this._iterator = e, this._iteratorCache = [];
        }
        function K(e) {
          return !(!e || !e["@@__IMMUTABLE_SEQ__@@"]);
        }
        function Z() {
          return k || (k = new W([]));
        }
        function Q(e) {
          var t = Array.isArray(e) ? new W(e).fromEntrySeq() : B(e) ? new Y(e).fromEntrySeq() : D(e) ? new X(e).fromEntrySeq() : "object" == typeof e ? new $(e) : void 0;
          if (!t) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + e);
          return t;
        }
        function J(e) {
          var t = ee(e);
          if (!t) throw new TypeError("Expected Array or iterable object of values: " + e);
          return t;
        }
        function ee(e) {
          return U(e) ? new W(e) : B(e) ? new Y(e) : D(e) ? new X(e) : void 0;
        }
        function te(e, t, n, r) {
          var i = e._cache;
          if (i) {
            for (var o = i.length - 1, a = 0; a <= o; a++) {
              var s = i[n ? o - a : a];
              if (!1 === t(s[1], r ? s[0] : a, e)) return a + 1;
            }
            return a;
          }
          return e.__iterateUncached(t, n);
        }
        function ne(e, t, n, r) {
          var i = e._cache;
          if (i) {
            var o = i.length - 1,
              a = 0;
            return new j(function () {
              var e = i[n ? o - a : a];
              return a++ > o ? {
                value: void 0,
                done: !0
              } : N(t, r ? e[0] : a - 1, e[1]);
            });
          }
          return e.__iteratorUncached(t, n);
        }
        function re(e, t) {
          return t ? function e(t, n, r, i) {
            return Array.isArray(n) ? t.call(i, r, H(n).map(function (r, i) {
              return e(t, r, i, n);
            })) : oe(n) ? t.call(i, r, V(n).map(function (r, i) {
              return e(t, r, i, n);
            })) : n;
          }(t, e, "", {
            "": e
          }) : ie(e);
        }
        function ie(e) {
          return Array.isArray(e) ? H(e).map(ie).toList() : oe(e) ? V(e).map(ie).toMap() : e;
        }
        function oe(e) {
          return e && (e.constructor === Object || void 0 === e.constructor);
        }
        function ae(e, t) {
          if (e === t || e != e && t != t) return !0;
          if (!e || !t) return !1;
          if ("function" == typeof e.valueOf && "function" == typeof t.valueOf) {
            if ((e = e.valueOf()) === (t = t.valueOf()) || e != e && t != t) return !0;
            if (!e || !t) return !1;
          }
          return !("function" != typeof e.equals || "function" != typeof t.equals || !e.equals(t));
        }
        function se(e, t) {
          if (e === t) return !0;
          if (!a(t) || void 0 !== e.size && void 0 !== t.size && e.size !== t.size || void 0 !== e.__hash && void 0 !== t.__hash && e.__hash !== t.__hash || s(e) !== s(t) || l(e) !== l(t) || c(e) !== c(t)) return !1;
          if (0 === e.size && 0 === t.size) return !0;
          var n = !u(e);
          if (c(e)) {
            var r = e.entries();
            return t.every(function (e, t) {
              var i = r.next().value;
              return i && ae(i[1], e) && (n || ae(i[0], t));
            }) && r.next().done;
          }
          var i = !1;
          if (void 0 === e.size) if (void 0 === t.size) "function" == typeof e.cacheResult && e.cacheResult();else {
            i = !0;
            var o = e;
            e = t, t = o;
          }
          var d = !0,
            h = t.__iterate(function (t, r) {
              if (n ? !e.has(t) : i ? !ae(t, e.get(r, m)) : !ae(e.get(r, m), t)) return d = !1, !1;
            });
          return d && e.size === h;
        }
        function le(e, t) {
          if (!(this instanceof le)) return new le(e, t);
          if (this._value = e, this.size = void 0 === t ? 1 / 0 : Math.max(0, t), 0 === this.size) {
            if (P) return P;
            P = this;
          }
        }
        function ue(e, t) {
          if (!e) throw new Error(t);
        }
        function ce(e, t, n) {
          if (!(this instanceof ce)) return new ce(e, t, n);
          if (ue(0 !== n, "Cannot step a Range by 0"), e = e || 0, void 0 === t && (t = 1 / 0), n = void 0 === n ? 1 : Math.abs(n), t < e && (n = -n), this._start = e, this._end = t, this._step = n, this.size = Math.max(0, Math.ceil((t - e) / n - 1) + 1), 0 === this.size) {
            if (O) return O;
            O = this;
          }
        }
        function de() {
          throw TypeError("Abstract");
        }
        function he() {}
        function fe() {}
        function pe() {}
        j.prototype.toString = function () {
          return "[Iterator]";
        }, j.KEYS = 0, j.VALUES = 1, j.ENTRIES = 2, j.prototype.inspect = j.prototype.toSource = function () {
          return this.toString();
        }, j.prototype[I] = function () {
          return this;
        }, t(G, n), G.of = function () {
          return G(arguments);
        }, G.prototype.toSeq = function () {
          return this;
        }, G.prototype.toString = function () {
          return this.__toString("Seq {", "}");
        }, G.prototype.cacheResult = function () {
          return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
        }, G.prototype.__iterate = function (e, t) {
          return te(this, e, t, !0);
        }, G.prototype.__iterator = function (e, t) {
          return ne(this, e, t, !0);
        }, t(V, G), V.prototype.toKeyedSeq = function () {
          return this;
        }, t(H, G), H.of = function () {
          return H(arguments);
        }, H.prototype.toIndexedSeq = function () {
          return this;
        }, H.prototype.toString = function () {
          return this.__toString("Seq [", "]");
        }, H.prototype.__iterate = function (e, t) {
          return te(this, e, t, !1);
        }, H.prototype.__iterator = function (e, t) {
          return ne(this, e, t, !1);
        }, t(q, G), q.of = function () {
          return q(arguments);
        }, q.prototype.toSetSeq = function () {
          return this;
        }, G.isSeq = K, G.Keyed = V, G.Set = q, G.Indexed = H, G.prototype["@@__IMMUTABLE_SEQ__@@"] = !0, t(W, H), W.prototype.get = function (e, t) {
          return this.has(e) ? this._array[S(this, e)] : t;
        }, W.prototype.__iterate = function (e, t) {
          for (var n = this._array, r = n.length - 1, i = 0; i <= r; i++) if (!1 === e(n[t ? r - i : i], i, this)) return i + 1;
          return i;
        }, W.prototype.__iterator = function (e, t) {
          var n = this._array,
            r = n.length - 1,
            i = 0;
          return new j(function () {
            return i > r ? {
              value: void 0,
              done: !0
            } : N(e, i, n[t ? r - i++ : i++]);
          });
        }, t($, V), $.prototype.get = function (e, t) {
          return void 0 === t || this.has(e) ? this._object[e] : t;
        }, $.prototype.has = function (e) {
          return this._object.hasOwnProperty(e);
        }, $.prototype.__iterate = function (e, t) {
          for (var n = this._object, r = this._keys, i = r.length - 1, o = 0; o <= i; o++) {
            var a = r[t ? i - o : o];
            if (!1 === e(n[a], a, this)) return o + 1;
          }
          return o;
        }, $.prototype.__iterator = function (e, t) {
          var n = this._object,
            r = this._keys,
            i = r.length - 1,
            o = 0;
          return new j(function () {
            var a = r[t ? i - o : o];
            return o++ > i ? {
              value: void 0,
              done: !0
            } : N(e, a, n[a]);
          });
        }, $.prototype[p] = !0, t(X, H), X.prototype.__iterateUncached = function (e, t) {
          if (t) return this.cacheResult().__iterate(e, t);
          var n = F(this._iterable),
            r = 0;
          if (B(n)) for (var i; !(i = n.next()).done && !1 !== e(i.value, r++, this););
          return r;
        }, X.prototype.__iteratorUncached = function (e, t) {
          if (t) return this.cacheResult().__iterator(e, t);
          var n = F(this._iterable);
          if (!B(n)) return new j(L);
          var r = 0;
          return new j(function () {
            var t = n.next();
            return t.done ? t : N(e, r++, t.value);
          });
        }, t(Y, H), Y.prototype.__iterateUncached = function (e, t) {
          if (t) return this.cacheResult().__iterate(e, t);
          for (var n, r = this._iterator, i = this._iteratorCache, o = 0; o < i.length;) if (!1 === e(i[o], o++, this)) return o;
          for (; !(n = r.next()).done;) {
            var a = n.value;
            if (i[o] = a, !1 === e(a, o++, this)) break;
          }
          return o;
        }, Y.prototype.__iteratorUncached = function (e, t) {
          if (t) return this.cacheResult().__iterator(e, t);
          var n = this._iterator,
            r = this._iteratorCache,
            i = 0;
          return new j(function () {
            if (i >= r.length) {
              var t = n.next();
              if (t.done) return t;
              r[i] = t.value;
            }
            return N(e, i, r[i++]);
          });
        }, t(le, H), le.prototype.toString = function () {
          return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
        }, le.prototype.get = function (e, t) {
          return this.has(e) ? this._value : t;
        }, le.prototype.includes = function (e) {
          return ae(this._value, e);
        }, le.prototype.slice = function (e, t) {
          var n = this.size;
          return E(e, t, n) ? this : new le(this._value, M(t, n) - T(e, n));
        }, le.prototype.reverse = function () {
          return this;
        }, le.prototype.indexOf = function (e) {
          return ae(this._value, e) ? 0 : -1;
        }, le.prototype.lastIndexOf = function (e) {
          return ae(this._value, e) ? this.size : -1;
        }, le.prototype.__iterate = function (e, t) {
          for (var n = 0; n < this.size; n++) if (!1 === e(this._value, n, this)) return n + 1;
          return n;
        }, le.prototype.__iterator = function (e, t) {
          var n = this,
            r = 0;
          return new j(function () {
            return r < n.size ? N(e, r++, n._value) : {
              value: void 0,
              done: !0
            };
          });
        }, le.prototype.equals = function (e) {
          return e instanceof le ? ae(this._value, e._value) : se(e);
        }, t(ce, H), ce.prototype.toString = function () {
          return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (1 !== this._step ? " by " + this._step : "") + " ]";
        }, ce.prototype.get = function (e, t) {
          return this.has(e) ? this._start + S(this, e) * this._step : t;
        }, ce.prototype.includes = function (e) {
          var t = (e - this._start) / this._step;
          return t >= 0 && t < this.size && t === Math.floor(t);
        }, ce.prototype.slice = function (e, t) {
          return E(e, t, this.size) ? this : (e = T(e, this.size), (t = M(t, this.size)) <= e ? new ce(0, 0) : new ce(this.get(e, this._end), this.get(t, this._end), this._step));
        }, ce.prototype.indexOf = function (e) {
          var t = e - this._start;
          if (t % this._step == 0) {
            var n = t / this._step;
            if (n >= 0 && n < this.size) return n;
          }
          return -1;
        }, ce.prototype.lastIndexOf = function (e) {
          return this.indexOf(e);
        }, ce.prototype.__iterate = function (e, t) {
          for (var n = this.size - 1, r = this._step, i = t ? this._start + n * r : this._start, o = 0; o <= n; o++) {
            if (!1 === e(i, o, this)) return o + 1;
            i += t ? -r : r;
          }
          return o;
        }, ce.prototype.__iterator = function (e, t) {
          var n = this.size - 1,
            r = this._step,
            i = t ? this._start + n * r : this._start,
            o = 0;
          return new j(function () {
            var a = i;
            return i += t ? -r : r, o > n ? {
              value: void 0,
              done: !0
            } : N(e, o++, a);
          });
        }, ce.prototype.equals = function (e) {
          return e instanceof ce ? this._start === e._start && this._end === e._end && this._step === e._step : se(this, e);
        }, t(de, n), t(he, de), t(fe, de), t(pe, de), de.Keyed = he, de.Indexed = fe, de.Set = pe;
        var me = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function (e, t) {
          var n = 65535 & (e |= 0),
            r = 65535 & (t |= 0);
          return n * r + ((e >>> 16) * r + n * (t >>> 16) << 16 >>> 0) | 0;
        };
        function ge(e) {
          return e >>> 1 & 1073741824 | 3221225471 & e;
        }
        function ve(e) {
          if (!1 === e || null == e) return 0;
          if ("function" == typeof e.valueOf && (!1 === (e = e.valueOf()) || null == e)) return 0;
          if (!0 === e) return 1;
          var t = typeof e;
          if ("number" === t) {
            if (e != e || e === 1 / 0) return 0;
            var n = 0 | e;
            for (n !== e && (n ^= 4294967295 * e); e > 4294967295;) n ^= e /= 4294967295;
            return ge(n);
          }
          if ("string" === t) return e.length > Ee ? function (e) {
            var t = Ce[e];
            return void 0 === t && (t = ye(e), Me === Te && (Me = 0, Ce = {}), Me++, Ce[e] = t), t;
          }(e) : ye(e);
          if ("function" == typeof e.hashCode) return e.hashCode();
          if ("object" === t) return function (e) {
            var t;
            if (we && void 0 !== (t = be.get(e))) return t;
            if (void 0 !== (t = e[Ae])) return t;
            if (!xe) {
              if (void 0 !== (t = e.propertyIsEnumerable && e.propertyIsEnumerable[Ae])) return t;
              if (void 0 !== (t = function (e) {
                if (e && e.nodeType > 0) switch (e.nodeType) {
                  case 1:
                    return e.uniqueID;
                  case 9:
                    return e.documentElement && e.documentElement.uniqueID;
                }
              }(e))) return t;
            }
            if (t = ++Se, 1073741824 & Se && (Se = 0), we) be.set(e, t);else {
              if (void 0 !== _e && !1 === _e(e)) throw new Error("Non-extensible objects are not allowed as keys.");
              if (xe) Object.defineProperty(e, Ae, {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: t
              });else if (void 0 !== e.propertyIsEnumerable && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable) e.propertyIsEnumerable = function () {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
              }, e.propertyIsEnumerable[Ae] = t;else {
                if (void 0 === e.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
                e[Ae] = t;
              }
            }
            return t;
          }(e);
          if ("function" == typeof e.toString) return ye(e.toString());
          throw new Error("Value type " + t + " cannot be hashed.");
        }
        function ye(e) {
          for (var t = 0, n = 0; n < e.length; n++) t = 31 * t + e.charCodeAt(n) | 0;
          return ge(t);
        }
        var be,
          _e = Object.isExtensible,
          xe = function () {
            try {
              return Object.defineProperty({}, "@", {}), !0;
            } catch (e) {
              return !1;
            }
          }(),
          we = "function" == typeof WeakMap;
        we && (be = new WeakMap());
        var Se = 0,
          Ae = "__immutablehash__";
        "function" == typeof Symbol && (Ae = Symbol(Ae));
        var Ee = 16,
          Te = 255,
          Me = 0,
          Ce = {};
        function ke(e) {
          ue(e !== 1 / 0, "Cannot perform this action with an infinite size.");
        }
        function Pe(e) {
          return null == e ? He() : Oe(e) && !c(e) ? e : He().withMutations(function (t) {
            var n = r(e);
            ke(n.size), n.forEach(function (e, n) {
              return t.set(n, e);
            });
          });
        }
        function Oe(e) {
          return !(!e || !e[Ie]);
        }
        t(Pe, he), Pe.of = function () {
          var t = e.call(arguments, 0);
          return He().withMutations(function (e) {
            for (var n = 0; n < t.length; n += 2) {
              if (n + 1 >= t.length) throw new Error("Missing value for key: " + t[n]);
              e.set(t[n], t[n + 1]);
            }
          });
        }, Pe.prototype.toString = function () {
          return this.__toString("Map {", "}");
        }, Pe.prototype.get = function (e, t) {
          return this._root ? this._root.get(0, void 0, e, t) : t;
        }, Pe.prototype.set = function (e, t) {
          return qe(this, e, t);
        }, Pe.prototype.setIn = function (e, t) {
          return this.updateIn(e, m, function () {
            return t;
          });
        }, Pe.prototype.remove = function (e) {
          return qe(this, e, m);
        }, Pe.prototype.deleteIn = function (e) {
          return this.updateIn(e, function () {
            return m;
          });
        }, Pe.prototype.update = function (e, t, n) {
          return 1 === arguments.length ? e(this) : this.updateIn([e], t, n);
        }, Pe.prototype.updateIn = function (e, t, n) {
          n || (n = t, t = void 0);
          var r = function e(t, n, r, i) {
            var o = t === m,
              a = n.next();
            if (a.done) {
              var s = o ? r : t,
                l = i(s);
              return l === s ? t : l;
            }
            ue(o || t && t.set, "invalid keyPath");
            var u = a.value,
              c = o ? m : t.get(u, m),
              d = e(c, n, r, i);
            return d === c ? t : d === m ? t.remove(u) : (o ? He() : t).set(u, d);
          }(this, Yt(e), t, n);
          return r === m ? void 0 : r;
        }, Pe.prototype.clear = function () {
          return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : He();
        }, Pe.prototype.merge = function () {
          return Ye(this, void 0, arguments);
        }, Pe.prototype.mergeWith = function (t) {
          var n = e.call(arguments, 1);
          return Ye(this, t, n);
        }, Pe.prototype.mergeIn = function (t) {
          var n = e.call(arguments, 1);
          return this.updateIn(t, He(), function (e) {
            return "function" == typeof e.merge ? e.merge.apply(e, n) : n[n.length - 1];
          });
        }, Pe.prototype.mergeDeep = function () {
          return Ye(this, Ke, arguments);
        }, Pe.prototype.mergeDeepWith = function (t) {
          var n = e.call(arguments, 1);
          return Ye(this, Ze(t), n);
        }, Pe.prototype.mergeDeepIn = function (t) {
          var n = e.call(arguments, 1);
          return this.updateIn(t, He(), function (e) {
            return "function" == typeof e.mergeDeep ? e.mergeDeep.apply(e, n) : n[n.length - 1];
          });
        }, Pe.prototype.sort = function (e) {
          return xt(Bt(this, e));
        }, Pe.prototype.sortBy = function (e, t) {
          return xt(Bt(this, t, e));
        }, Pe.prototype.withMutations = function (e) {
          var t = this.asMutable();
          return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
        }, Pe.prototype.asMutable = function () {
          return this.__ownerID ? this : this.__ensureOwner(new _());
        }, Pe.prototype.asImmutable = function () {
          return this.__ensureOwner();
        }, Pe.prototype.wasAltered = function () {
          return this.__altered;
        }, Pe.prototype.__iterator = function (e, t) {
          return new ze(this, e, t);
        }, Pe.prototype.__iterate = function (e, t) {
          var n = this,
            r = 0;
          return this._root && this._root.iterate(function (t) {
            return r++, e(t[1], t[0], n);
          }, t), r;
        }, Pe.prototype.__ensureOwner = function (e) {
          return e === this.__ownerID ? this : e ? Ve(this.size, this._root, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
        }, Pe.isMap = Oe;
        var Re,
          Ie = "@@__IMMUTABLE_MAP__@@",
          je = Pe.prototype;
        function Ne(e, t) {
          this.ownerID = e, this.entries = t;
        }
        function Le(e, t, n) {
          this.ownerID = e, this.bitmap = t, this.nodes = n;
        }
        function De(e, t, n) {
          this.ownerID = e, this.count = t, this.nodes = n;
        }
        function Be(e, t, n) {
          this.ownerID = e, this.keyHash = t, this.entries = n;
        }
        function Fe(e, t, n) {
          this.ownerID = e, this.keyHash = t, this.entry = n;
        }
        function ze(e, t, n) {
          this._type = t, this._reverse = n, this._stack = e._root && Ge(e._root);
        }
        function Ue(e, t) {
          return N(e, t[0], t[1]);
        }
        function Ge(e, t) {
          return {
            node: e,
            index: 0,
            __prev: t
          };
        }
        function Ve(e, t, n, r) {
          var i = Object.create(je);
          return i.size = e, i._root = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
        }
        function He() {
          return Re || (Re = Ve(0));
        }
        function qe(e, t, n) {
          var r, i;
          if (e._root) {
            var o = y(g),
              a = y(v);
            if (r = We(e._root, e.__ownerID, 0, void 0, t, n, o, a), !a.value) return e;
            i = e.size + (o.value ? n === m ? -1 : 1 : 0);
          } else {
            if (n === m) return e;
            i = 1, r = new Ne(e.__ownerID, [[t, n]]);
          }
          return e.__ownerID ? (e.size = i, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? Ve(i, r) : He();
        }
        function We(e, t, n, r, i, o, a, s) {
          return e ? e.update(t, n, r, i, o, a, s) : o === m ? e : (b(s), b(a), new Fe(t, r, [i, o]));
        }
        function $e(e) {
          return e.constructor === Fe || e.constructor === Be;
        }
        function Xe(e, t, n, r, i) {
          if (e.keyHash === r) return new Be(t, r, [e.entry, i]);
          var o,
            a = 31 & (0 === n ? e.keyHash : e.keyHash >>> n),
            s = 31 & (0 === n ? r : r >>> n);
          return new Le(t, 1 << a | 1 << s, a === s ? [Xe(e, t, n + 5, r, i)] : (o = new Fe(t, r, i), a < s ? [e, o] : [o, e]));
        }
        function Ye(e, t, n) {
          for (var i = [], o = 0; o < n.length; o++) {
            var s = n[o],
              l = r(s);
            a(s) || (l = l.map(function (e) {
              return re(e);
            })), i.push(l);
          }
          return Qe(e, t, i);
        }
        function Ke(e, t, n) {
          return e && e.mergeDeep && a(t) ? e.mergeDeep(t) : ae(e, t) ? e : t;
        }
        function Ze(e) {
          return function (t, n, r) {
            if (t && t.mergeDeepWith && a(n)) return t.mergeDeepWith(e, n);
            var i = e(t, n, r);
            return ae(t, i) ? t : i;
          };
        }
        function Qe(e, t, n) {
          return 0 === (n = n.filter(function (e) {
            return 0 !== e.size;
          })).length ? e : 0 !== e.size || e.__ownerID || 1 !== n.length ? e.withMutations(function (e) {
            for (var r = t ? function (n, r) {
                e.update(r, m, function (e) {
                  return e === m ? n : t(e, n, r);
                });
              } : function (t, n) {
                e.set(n, t);
              }, i = 0; i < n.length; i++) n[i].forEach(r);
          }) : e.constructor(n[0]);
        }
        function Je(e) {
          return e = (e = (858993459 & (e -= e >> 1 & 1431655765)) + (e >> 2 & 858993459)) + (e >> 4) & 252645135, e += e >> 8, 127 & (e += e >> 16);
        }
        function et(e, t, n, r) {
          var i = r ? e : x(e);
          return i[t] = n, i;
        }
        je[Ie] = !0, je.delete = je.remove, je.removeIn = je.deleteIn, Ne.prototype.get = function (e, t, n, r) {
          for (var i = this.entries, o = 0, a = i.length; o < a; o++) if (ae(n, i[o][0])) return i[o][1];
          return r;
        }, Ne.prototype.update = function (e, t, n, r, i, o, a) {
          for (var s = i === m, l = this.entries, u = 0, c = l.length; u < c && !ae(r, l[u][0]); u++);
          var d = u < c;
          if (d ? l[u][1] === i : s) return this;
          if (b(a), (s || !d) && b(o), !s || 1 !== l.length) {
            if (!d && !s && l.length >= tt) return function (e, t, n, r) {
              e || (e = new _());
              for (var i = new Fe(e, ve(n), [n, r]), o = 0; o < t.length; o++) {
                var a = t[o];
                i = i.update(e, 0, void 0, a[0], a[1]);
              }
              return i;
            }(e, l, r, i);
            var h = e && e === this.ownerID,
              f = h ? l : x(l);
            return d ? s ? u === c - 1 ? f.pop() : f[u] = f.pop() : f[u] = [r, i] : f.push([r, i]), h ? (this.entries = f, this) : new Ne(e, f);
          }
        }, Le.prototype.get = function (e, t, n, r) {
          void 0 === t && (t = ve(n));
          var i = 1 << (31 & (0 === e ? t : t >>> e)),
            o = this.bitmap;
          return 0 == (o & i) ? r : this.nodes[Je(o & i - 1)].get(e + 5, t, n, r);
        }, Le.prototype.update = function (e, t, n, r, i, o, a) {
          void 0 === n && (n = ve(r));
          var s = 31 & (0 === t ? n : n >>> t),
            l = 1 << s,
            u = this.bitmap,
            c = 0 != (u & l);
          if (!c && i === m) return this;
          var d = Je(u & l - 1),
            h = this.nodes,
            f = c ? h[d] : void 0,
            p = We(f, e, t + 5, n, r, i, o, a);
          if (p === f) return this;
          if (!c && p && h.length >= nt) return function (e, t, n, r, i) {
            for (var o = 0, a = new Array(32), s = 0; 0 !== n; s++, n >>>= 1) a[s] = 1 & n ? t[o++] : void 0;
            return a[r] = i, new De(e, o + 1, a);
          }(e, h, u, s, p);
          if (c && !p && 2 === h.length && $e(h[1 ^ d])) return h[1 ^ d];
          if (c && p && 1 === h.length && $e(p)) return p;
          var g = e && e === this.ownerID,
            v = c ? p ? u : u ^ l : u | l,
            y = c ? p ? et(h, d, p, g) : function (e, t, n) {
              var r = e.length - 1;
              if (n && t === r) return e.pop(), e;
              for (var i = new Array(r), o = 0, a = 0; a < r; a++) a === t && (o = 1), i[a] = e[a + o];
              return i;
            }(h, d, g) : function (e, t, n, r) {
              var i = e.length + 1;
              if (r && t + 1 === i) return e[t] = n, e;
              for (var o = new Array(i), a = 0, s = 0; s < i; s++) s === t ? (o[s] = n, a = -1) : o[s] = e[s + a];
              return o;
            }(h, d, p, g);
          return g ? (this.bitmap = v, this.nodes = y, this) : new Le(e, v, y);
        }, De.prototype.get = function (e, t, n, r) {
          void 0 === t && (t = ve(n));
          var i = 31 & (0 === e ? t : t >>> e),
            o = this.nodes[i];
          return o ? o.get(e + 5, t, n, r) : r;
        }, De.prototype.update = function (e, t, n, r, i, o, a) {
          void 0 === n && (n = ve(r));
          var s = 31 & (0 === t ? n : n >>> t),
            l = i === m,
            u = this.nodes,
            c = u[s];
          if (l && !c) return this;
          var d = We(c, e, t + 5, n, r, i, o, a);
          if (d === c) return this;
          var h = this.count;
          if (c) {
            if (!d && --h < rt) return function (e, t, n, r) {
              for (var i = 0, o = 0, a = new Array(n), s = 0, l = 1, u = t.length; s < u; s++, l <<= 1) {
                var c = t[s];
                void 0 !== c && s !== r && (i |= l, a[o++] = c);
              }
              return new Le(e, i, a);
            }(e, u, h, s);
          } else h++;
          var f = e && e === this.ownerID,
            p = et(u, s, d, f);
          return f ? (this.count = h, this.nodes = p, this) : new De(e, h, p);
        }, Be.prototype.get = function (e, t, n, r) {
          for (var i = this.entries, o = 0, a = i.length; o < a; o++) if (ae(n, i[o][0])) return i[o][1];
          return r;
        }, Be.prototype.update = function (e, t, n, r, i, o, a) {
          void 0 === n && (n = ve(r));
          var s = i === m;
          if (n !== this.keyHash) return s ? this : (b(a), b(o), Xe(this, e, t, n, [r, i]));
          for (var l = this.entries, u = 0, c = l.length; u < c && !ae(r, l[u][0]); u++);
          var d = u < c;
          if (d ? l[u][1] === i : s) return this;
          if (b(a), (s || !d) && b(o), s && 2 === c) return new Fe(e, this.keyHash, l[1 ^ u]);
          var h = e && e === this.ownerID,
            f = h ? l : x(l);
          return d ? s ? u === c - 1 ? f.pop() : f[u] = f.pop() : f[u] = [r, i] : f.push([r, i]), h ? (this.entries = f, this) : new Be(e, this.keyHash, f);
        }, Fe.prototype.get = function (e, t, n, r) {
          return ae(n, this.entry[0]) ? this.entry[1] : r;
        }, Fe.prototype.update = function (e, t, n, r, i, o, a) {
          var s = i === m,
            l = ae(r, this.entry[0]);
          return (l ? i === this.entry[1] : s) ? this : (b(a), s ? void b(o) : l ? e && e === this.ownerID ? (this.entry[1] = i, this) : new Fe(e, this.keyHash, [r, i]) : (b(o), Xe(this, e, t, ve(r), [r, i])));
        }, Ne.prototype.iterate = Be.prototype.iterate = function (e, t) {
          for (var n = this.entries, r = 0, i = n.length - 1; r <= i; r++) if (!1 === e(n[t ? i - r : r])) return !1;
        }, Le.prototype.iterate = De.prototype.iterate = function (e, t) {
          for (var n = this.nodes, r = 0, i = n.length - 1; r <= i; r++) {
            var o = n[t ? i - r : r];
            if (o && !1 === o.iterate(e, t)) return !1;
          }
        }, Fe.prototype.iterate = function (e, t) {
          return e(this.entry);
        }, t(ze, j), ze.prototype.next = function () {
          for (var e = this._type, t = this._stack; t;) {
            var n,
              r = t.node,
              i = t.index++;
            if (r.entry) {
              if (0 === i) return Ue(e, r.entry);
            } else if (r.entries) {
              if (i <= (n = r.entries.length - 1)) return Ue(e, r.entries[this._reverse ? n - i : i]);
            } else if (i <= (n = r.nodes.length - 1)) {
              var o = r.nodes[this._reverse ? n - i : i];
              if (o) {
                if (o.entry) return Ue(e, o.entry);
                t = this._stack = Ge(o, t);
              }
              continue;
            }
            t = this._stack = this._stack.__prev;
          }
          return {
            value: void 0,
            done: !0
          };
        };
        var tt = 8,
          nt = 16,
          rt = 8;
        function it(e) {
          var t = pt();
          if (null == e) return t;
          if (ot(e)) return e;
          var n = i(e),
            r = n.size;
          return 0 === r ? t : (ke(r), r > 0 && r < 32 ? ft(0, r, 5, null, new lt(n.toArray())) : t.withMutations(function (e) {
            e.setSize(r), n.forEach(function (t, n) {
              return e.set(n, t);
            });
          }));
        }
        function ot(e) {
          return !(!e || !e[at]);
        }
        t(it, fe), it.of = function () {
          return this(arguments);
        }, it.prototype.toString = function () {
          return this.__toString("List [", "]");
        }, it.prototype.get = function (e, t) {
          if ((e = S(this, e)) >= 0 && e < this.size) {
            var n = vt(this, e += this._origin);
            return n && n.array[31 & e];
          }
          return t;
        }, it.prototype.set = function (e, t) {
          return function (e, t, n) {
            if ((t = S(e, t)) != t) return e;
            if (t >= e.size || t < 0) return e.withMutations(function (e) {
              t < 0 ? yt(e, t).set(0, n) : yt(e, 0, t + 1).set(t, n);
            });
            t += e._origin;
            var r = e._tail,
              i = e._root,
              o = y(v);
            return t >= _t(e._capacity) ? r = mt(r, e.__ownerID, 0, t, n, o) : i = mt(i, e.__ownerID, e._level, t, n, o), o.value ? e.__ownerID ? (e._root = i, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : ft(e._origin, e._capacity, e._level, i, r) : e;
          }(this, e, t);
        }, it.prototype.remove = function (e) {
          return this.has(e) ? 0 === e ? this.shift() : e === this.size - 1 ? this.pop() : this.splice(e, 1) : this;
        }, it.prototype.insert = function (e, t) {
          return this.splice(e, 0, t);
        }, it.prototype.clear = function () {
          return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = 5, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : pt();
        }, it.prototype.push = function () {
          var e = arguments,
            t = this.size;
          return this.withMutations(function (n) {
            yt(n, 0, t + e.length);
            for (var r = 0; r < e.length; r++) n.set(t + r, e[r]);
          });
        }, it.prototype.pop = function () {
          return yt(this, 0, -1);
        }, it.prototype.unshift = function () {
          var e = arguments;
          return this.withMutations(function (t) {
            yt(t, -e.length);
            for (var n = 0; n < e.length; n++) t.set(n, e[n]);
          });
        }, it.prototype.shift = function () {
          return yt(this, 1);
        }, it.prototype.merge = function () {
          return bt(this, void 0, arguments);
        }, it.prototype.mergeWith = function (t) {
          var n = e.call(arguments, 1);
          return bt(this, t, n);
        }, it.prototype.mergeDeep = function () {
          return bt(this, Ke, arguments);
        }, it.prototype.mergeDeepWith = function (t) {
          var n = e.call(arguments, 1);
          return bt(this, Ze(t), n);
        }, it.prototype.setSize = function (e) {
          return yt(this, 0, e);
        }, it.prototype.slice = function (e, t) {
          var n = this.size;
          return E(e, t, n) ? this : yt(this, T(e, n), M(t, n));
        }, it.prototype.__iterator = function (e, t) {
          var n = 0,
            r = ht(this, t);
          return new j(function () {
            var t = r();
            return t === dt ? {
              value: void 0,
              done: !0
            } : N(e, n++, t);
          });
        }, it.prototype.__iterate = function (e, t) {
          for (var n, r = 0, i = ht(this, t); (n = i()) !== dt && !1 !== e(n, r++, this););
          return r;
        }, it.prototype.__ensureOwner = function (e) {
          return e === this.__ownerID ? this : e ? ft(this._origin, this._capacity, this._level, this._root, this._tail, e, this.__hash) : (this.__ownerID = e, this);
        }, it.isList = ot;
        var at = "@@__IMMUTABLE_LIST__@@",
          st = it.prototype;
        function lt(e, t) {
          this.array = e, this.ownerID = t;
        }
        st[at] = !0, st.delete = st.remove, st.setIn = je.setIn, st.deleteIn = st.removeIn = je.removeIn, st.update = je.update, st.updateIn = je.updateIn, st.mergeIn = je.mergeIn, st.mergeDeepIn = je.mergeDeepIn, st.withMutations = je.withMutations, st.asMutable = je.asMutable, st.asImmutable = je.asImmutable, st.wasAltered = je.wasAltered, lt.prototype.removeBefore = function (e, t, n) {
          if (n === t ? 1 << t : 0 === this.array.length) return this;
          var r = n >>> t & 31;
          if (r >= this.array.length) return new lt([], e);
          var i,
            o = 0 === r;
          if (t > 0) {
            var a = this.array[r];
            if ((i = a && a.removeBefore(e, t - 5, n)) === a && o) return this;
          }
          if (o && !i) return this;
          var s = gt(this, e);
          if (!o) for (var l = 0; l < r; l++) s.array[l] = void 0;
          return i && (s.array[r] = i), s;
        }, lt.prototype.removeAfter = function (e, t, n) {
          if (n === (t ? 1 << t : 0) || 0 === this.array.length) return this;
          var r,
            i = n - 1 >>> t & 31;
          if (i >= this.array.length) return this;
          if (t > 0) {
            var o = this.array[i];
            if ((r = o && o.removeAfter(e, t - 5, n)) === o && i === this.array.length - 1) return this;
          }
          var a = gt(this, e);
          return a.array.splice(i + 1), r && (a.array[i] = r), a;
        };
        var ut,
          ct,
          dt = {};
        function ht(e, t) {
          var n = e._origin,
            r = e._capacity,
            i = _t(r),
            o = e._tail;
          return a(e._root, e._level, 0);
          function a(e, s, l) {
            return 0 === s ? function (e, a) {
              var s = a === i ? o && o.array : e && e.array,
                l = a > n ? 0 : n - a,
                u = r - a;
              return u > 32 && (u = 32), function () {
                if (l === u) return dt;
                var e = t ? --u : l++;
                return s && s[e];
              };
            }(e, l) : function (e, i, o) {
              var s,
                l = e && e.array,
                u = o > n ? 0 : n - o >> i,
                c = 1 + (r - o >> i);
              return c > 32 && (c = 32), function () {
                for (;;) {
                  if (s) {
                    var e = s();
                    if (e !== dt) return e;
                    s = null;
                  }
                  if (u === c) return dt;
                  var n = t ? --c : u++;
                  s = a(l && l[n], i - 5, o + (n << i));
                }
              };
            }(e, s, l);
          }
        }
        function ft(e, t, n, r, i, o, a) {
          var s = Object.create(st);
          return s.size = t - e, s._origin = e, s._capacity = t, s._level = n, s._root = r, s._tail = i, s.__ownerID = o, s.__hash = a, s.__altered = !1, s;
        }
        function pt() {
          return ut || (ut = ft(0, 0, 5));
        }
        function mt(e, t, n, r, i, o) {
          var a,
            s = r >>> n & 31,
            l = e && s < e.array.length;
          if (!l && void 0 === i) return e;
          if (n > 0) {
            var u = e && e.array[s],
              c = mt(u, t, n - 5, r, i, o);
            return c === u ? e : ((a = gt(e, t)).array[s] = c, a);
          }
          return l && e.array[s] === i ? e : (b(o), a = gt(e, t), void 0 === i && s === a.array.length - 1 ? a.array.pop() : a.array[s] = i, a);
        }
        function gt(e, t) {
          return t && e && t === e.ownerID ? e : new lt(e ? e.array.slice() : [], t);
        }
        function vt(e, t) {
          if (t >= _t(e._capacity)) return e._tail;
          if (t < 1 << e._level + 5) {
            for (var n = e._root, r = e._level; n && r > 0;) n = n.array[t >>> r & 31], r -= 5;
            return n;
          }
        }
        function yt(e, t, n) {
          void 0 !== t && (t |= 0), void 0 !== n && (n |= 0);
          var r = e.__ownerID || new _(),
            i = e._origin,
            o = e._capacity,
            a = i + t,
            s = void 0 === n ? o : n < 0 ? o + n : i + n;
          if (a === i && s === o) return e;
          if (a >= s) return e.clear();
          for (var l = e._level, u = e._root, c = 0; a + c < 0;) u = new lt(u && u.array.length ? [void 0, u] : [], r), c += 1 << (l += 5);
          c && (a += c, i += c, s += c, o += c);
          for (var d = _t(o), h = _t(s); h >= 1 << l + 5;) u = new lt(u && u.array.length ? [u] : [], r), l += 5;
          var f = e._tail,
            p = h < d ? vt(e, s - 1) : h > d ? new lt([], r) : f;
          if (f && h > d && a < o && f.array.length) {
            for (var m = u = gt(u, r), g = l; g > 5; g -= 5) {
              var v = d >>> g & 31;
              m = m.array[v] = gt(m.array[v], r);
            }
            m.array[d >>> 5 & 31] = f;
          }
          if (s < o && (p = p && p.removeAfter(r, 0, s)), a >= h) a -= h, s -= h, l = 5, u = null, p = p && p.removeBefore(r, 0, a);else if (a > i || h < d) {
            for (c = 0; u;) {
              var y = a >>> l & 31;
              if (y !== h >>> l & 31) break;
              y && (c += (1 << l) * y), l -= 5, u = u.array[y];
            }
            u && a > i && (u = u.removeBefore(r, l, a - c)), u && h < d && (u = u.removeAfter(r, l, h - c)), c && (a -= c, s -= c);
          }
          return e.__ownerID ? (e.size = s - a, e._origin = a, e._capacity = s, e._level = l, e._root = u, e._tail = p, e.__hash = void 0, e.__altered = !0, e) : ft(a, s, l, u, p);
        }
        function bt(e, t, n) {
          for (var r = [], o = 0, s = 0; s < n.length; s++) {
            var l = n[s],
              u = i(l);
            u.size > o && (o = u.size), a(l) || (u = u.map(function (e) {
              return re(e);
            })), r.push(u);
          }
          return o > e.size && (e = e.setSize(o)), Qe(e, t, r);
        }
        function _t(e) {
          return e < 32 ? 0 : e - 1 >>> 5 << 5;
        }
        function xt(e) {
          return null == e ? At() : wt(e) ? e : At().withMutations(function (t) {
            var n = r(e);
            ke(n.size), n.forEach(function (e, n) {
              return t.set(n, e);
            });
          });
        }
        function wt(e) {
          return Oe(e) && c(e);
        }
        function St(e, t, n, r) {
          var i = Object.create(xt.prototype);
          return i.size = e ? e.size : 0, i._map = e, i._list = t, i.__ownerID = n, i.__hash = r, i;
        }
        function At() {
          return ct || (ct = St(He(), pt()));
        }
        function Et(e, t, n) {
          var r,
            i,
            o = e._map,
            a = e._list,
            s = o.get(t),
            l = void 0 !== s;
          if (n === m) {
            if (!l) return e;
            a.size >= 32 && a.size >= 2 * o.size ? (r = (i = a.filter(function (e, t) {
              return void 0 !== e && s !== t;
            })).toKeyedSeq().map(function (e) {
              return e[0];
            }).flip().toMap(), e.__ownerID && (r.__ownerID = i.__ownerID = e.__ownerID)) : (r = o.remove(t), i = s === a.size - 1 ? a.pop() : a.set(s, void 0));
          } else if (l) {
            if (n === a.get(s)[1]) return e;
            r = o, i = a.set(s, [t, n]);
          } else r = o.set(t, a.size), i = a.set(a.size, [t, n]);
          return e.__ownerID ? (e.size = r.size, e._map = r, e._list = i, e.__hash = void 0, e) : St(r, i);
        }
        function Tt(e, t) {
          this._iter = e, this._useKeys = t, this.size = e.size;
        }
        function Mt(e) {
          this._iter = e, this.size = e.size;
        }
        function Ct(e) {
          this._iter = e, this.size = e.size;
        }
        function kt(e) {
          this._iter = e, this.size = e.size;
        }
        function Pt(e) {
          var t = Wt(e);
          return t._iter = e, t.size = e.size, t.flip = function () {
            return e;
          }, t.reverse = function () {
            var t = e.reverse.apply(this);
            return t.flip = function () {
              return e.reverse();
            }, t;
          }, t.has = function (t) {
            return e.includes(t);
          }, t.includes = function (t) {
            return e.has(t);
          }, t.cacheResult = $t, t.__iterateUncached = function (t, n) {
            var r = this;
            return e.__iterate(function (e, n) {
              return !1 !== t(n, e, r);
            }, n);
          }, t.__iteratorUncached = function (t, n) {
            if (2 === t) {
              var r = e.__iterator(t, n);
              return new j(function () {
                var e = r.next();
                if (!e.done) {
                  var t = e.value[0];
                  e.value[0] = e.value[1], e.value[1] = t;
                }
                return e;
              });
            }
            return e.__iterator(1 === t ? 0 : 1, n);
          }, t;
        }
        function Ot(e, t, n) {
          var r = Wt(e);
          return r.size = e.size, r.has = function (t) {
            return e.has(t);
          }, r.get = function (r, i) {
            var o = e.get(r, m);
            return o === m ? i : t.call(n, o, r, e);
          }, r.__iterateUncached = function (r, i) {
            var o = this;
            return e.__iterate(function (e, i, a) {
              return !1 !== r(t.call(n, e, i, a), i, o);
            }, i);
          }, r.__iteratorUncached = function (r, i) {
            var o = e.__iterator(2, i);
            return new j(function () {
              var i = o.next();
              if (i.done) return i;
              var a = i.value,
                s = a[0];
              return N(r, s, t.call(n, a[1], s, e), i);
            });
          }, r;
        }
        function Rt(e, t) {
          var n = Wt(e);
          return n._iter = e, n.size = e.size, n.reverse = function () {
            return e;
          }, e.flip && (n.flip = function () {
            var t = Pt(e);
            return t.reverse = function () {
              return e.flip();
            }, t;
          }), n.get = function (n, r) {
            return e.get(t ? n : -1 - n, r);
          }, n.has = function (n) {
            return e.has(t ? n : -1 - n);
          }, n.includes = function (t) {
            return e.includes(t);
          }, n.cacheResult = $t, n.__iterate = function (t, n) {
            var r = this;
            return e.__iterate(function (e, n) {
              return t(e, n, r);
            }, !n);
          }, n.__iterator = function (t, n) {
            return e.__iterator(t, !n);
          }, n;
        }
        function It(e, t, n, r) {
          var i = Wt(e);
          return r && (i.has = function (r) {
            var i = e.get(r, m);
            return i !== m && !!t.call(n, i, r, e);
          }, i.get = function (r, i) {
            var o = e.get(r, m);
            return o !== m && t.call(n, o, r, e) ? o : i;
          }), i.__iterateUncached = function (i, o) {
            var a = this,
              s = 0;
            return e.__iterate(function (e, o, l) {
              if (t.call(n, e, o, l)) return s++, i(e, r ? o : s - 1, a);
            }, o), s;
          }, i.__iteratorUncached = function (i, o) {
            var a = e.__iterator(2, o),
              s = 0;
            return new j(function () {
              for (;;) {
                var o = a.next();
                if (o.done) return o;
                var l = o.value,
                  u = l[0],
                  c = l[1];
                if (t.call(n, c, u, e)) return N(i, r ? u : s++, c, o);
              }
            });
          }, i;
        }
        function jt(e, t, n, r) {
          var i = e.size;
          if (void 0 !== t && (t |= 0), void 0 !== n && (n === 1 / 0 ? n = i : n |= 0), E(t, n, i)) return e;
          var o = T(t, i),
            a = M(n, i);
          if (o != o || a != a) return jt(e.toSeq().cacheResult(), t, n, r);
          var s,
            l = a - o;
          l == l && (s = l < 0 ? 0 : l);
          var u = Wt(e);
          return u.size = 0 === s ? s : e.size && s || void 0, !r && K(e) && s >= 0 && (u.get = function (t, n) {
            return (t = S(this, t)) >= 0 && t < s ? e.get(t + o, n) : n;
          }), u.__iterateUncached = function (t, n) {
            var i = this;
            if (0 === s) return 0;
            if (n) return this.cacheResult().__iterate(t, n);
            var a = 0,
              l = !0,
              u = 0;
            return e.__iterate(function (e, n) {
              if (!l || !(l = a++ < o)) return u++, !1 !== t(e, r ? n : u - 1, i) && u !== s;
            }), u;
          }, u.__iteratorUncached = function (t, n) {
            if (0 !== s && n) return this.cacheResult().__iterator(t, n);
            var i = 0 !== s && e.__iterator(t, n),
              a = 0,
              l = 0;
            return new j(function () {
              for (; a++ < o;) i.next();
              if (++l > s) return {
                value: void 0,
                done: !0
              };
              var e = i.next();
              return r || 1 === t ? e : N(t, l - 1, 0 === t ? void 0 : e.value[1], e);
            });
          }, u;
        }
        function Nt(e, t, n, r) {
          var i = Wt(e);
          return i.__iterateUncached = function (i, o) {
            var a = this;
            if (o) return this.cacheResult().__iterate(i, o);
            var s = !0,
              l = 0;
            return e.__iterate(function (e, o, u) {
              if (!s || !(s = t.call(n, e, o, u))) return l++, i(e, r ? o : l - 1, a);
            }), l;
          }, i.__iteratorUncached = function (i, o) {
            var a = this;
            if (o) return this.cacheResult().__iterator(i, o);
            var s = e.__iterator(2, o),
              l = !0,
              u = 0;
            return new j(function () {
              var e, o, c;
              do {
                if ((e = s.next()).done) return r || 1 === i ? e : N(i, u++, 0 === i ? void 0 : e.value[1], e);
                var d = e.value;
                o = d[0], c = d[1], l && (l = t.call(n, c, o, a));
              } while (l);
              return 2 === i ? e : N(i, o, c, e);
            });
          }, i;
        }
        function Lt(e, t) {
          var n = s(e),
            i = [e].concat(t).map(function (e) {
              return a(e) ? n && (e = r(e)) : e = n ? Q(e) : J(Array.isArray(e) ? e : [e]), e;
            }).filter(function (e) {
              return 0 !== e.size;
            });
          if (0 === i.length) return e;
          if (1 === i.length) {
            var o = i[0];
            if (o === e || n && s(o) || l(e) && l(o)) return o;
          }
          var u = new W(i);
          return n ? u = u.toKeyedSeq() : l(e) || (u = u.toSetSeq()), (u = u.flatten(!0)).size = i.reduce(function (e, t) {
            if (void 0 !== e) {
              var n = t.size;
              if (void 0 !== n) return e + n;
            }
          }, 0), u;
        }
        function Dt(e, t, n) {
          var r = Wt(e);
          return r.__iterateUncached = function (r, i) {
            var o = 0,
              s = !1;
            return function e(l, u) {
              var c = this;
              l.__iterate(function (i, l) {
                return (!t || u < t) && a(i) ? e(i, u + 1) : !1 === r(i, n ? l : o++, c) && (s = !0), !s;
              }, i);
            }(e, 0), o;
          }, r.__iteratorUncached = function (r, i) {
            var o = e.__iterator(r, i),
              s = [],
              l = 0;
            return new j(function () {
              for (; o;) {
                var e = o.next();
                if (!1 === e.done) {
                  var u = e.value;
                  if (2 === r && (u = u[1]), t && !(s.length < t) || !a(u)) return n ? e : N(r, l++, u, e);
                  s.push(o), o = u.__iterator(r, i);
                } else o = s.pop();
              }
              return {
                value: void 0,
                done: !0
              };
            });
          }, r;
        }
        function Bt(e, t, n) {
          t || (t = Xt);
          var r = s(e),
            i = 0,
            o = e.toSeq().map(function (t, r) {
              return [r, t, i++, n ? n(t, r, e) : t];
            }).toArray();
          return o.sort(function (e, n) {
            return t(e[3], n[3]) || e[2] - n[2];
          }).forEach(r ? function (e, t) {
            o[t].length = 2;
          } : function (e, t) {
            o[t] = e[1];
          }), r ? V(o) : l(e) ? H(o) : q(o);
        }
        function Ft(e, t, n) {
          if (t || (t = Xt), n) {
            var r = e.toSeq().map(function (t, r) {
              return [t, n(t, r, e)];
            }).reduce(function (e, n) {
              return zt(t, e[1], n[1]) ? n : e;
            });
            return r && r[0];
          }
          return e.reduce(function (e, n) {
            return zt(t, e, n) ? n : e;
          });
        }
        function zt(e, t, n) {
          var r = e(n, t);
          return 0 === r && n !== t && (null == n || n != n) || r > 0;
        }
        function Ut(e, t, r) {
          var i = Wt(e);
          return i.size = new W(r).map(function (e) {
            return e.size;
          }).min(), i.__iterate = function (e, t) {
            for (var n, r = this.__iterator(1, t), i = 0; !(n = r.next()).done && !1 !== e(n.value, i++, this););
            return i;
          }, i.__iteratorUncached = function (e, i) {
            var o = r.map(function (e) {
                return e = n(e), F(i ? e.reverse() : e);
              }),
              a = 0,
              s = !1;
            return new j(function () {
              var n;
              return s || (n = o.map(function (e) {
                return e.next();
              }), s = n.some(function (e) {
                return e.done;
              })), s ? {
                value: void 0,
                done: !0
              } : N(e, a++, t.apply(null, n.map(function (e) {
                return e.value;
              })));
            });
          }, i;
        }
        function Gt(e, t) {
          return K(e) ? t : e.constructor(t);
        }
        function Vt(e) {
          if (e !== Object(e)) throw new TypeError("Expected [K, V] tuple: " + e);
        }
        function Ht(e) {
          return ke(e.size), w(e);
        }
        function qt(e) {
          return s(e) ? r : l(e) ? i : o;
        }
        function Wt(e) {
          return Object.create((s(e) ? V : l(e) ? H : q).prototype);
        }
        function $t() {
          return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : G.prototype.cacheResult.call(this);
        }
        function Xt(e, t) {
          return e > t ? 1 : e < t ? -1 : 0;
        }
        function Yt(e) {
          var t = F(e);
          if (!t) {
            if (!U(e)) throw new TypeError("Expected iterable or array-like: " + e);
            t = F(n(e));
          }
          return t;
        }
        function Kt(e, t) {
          var n,
            r = function r(o) {
              if (o instanceof r) return o;
              if (!(this instanceof r)) return new r(o);
              if (!n) {
                n = !0;
                var a = Object.keys(e);
                !function (e, t) {
                  try {
                    t.forEach(en.bind(void 0, e));
                  } catch (e) {}
                }(i, a), i.size = a.length, i._name = t, i._keys = a, i._defaultValues = e;
              }
              this._map = Pe(o);
            },
            i = r.prototype = Object.create(Zt);
          return i.constructor = r, r;
        }
        t(xt, Pe), xt.of = function () {
          return this(arguments);
        }, xt.prototype.toString = function () {
          return this.__toString("OrderedMap {", "}");
        }, xt.prototype.get = function (e, t) {
          var n = this._map.get(e);
          return void 0 !== n ? this._list.get(n)[1] : t;
        }, xt.prototype.clear = function () {
          return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : At();
        }, xt.prototype.set = function (e, t) {
          return Et(this, e, t);
        }, xt.prototype.remove = function (e) {
          return Et(this, e, m);
        }, xt.prototype.wasAltered = function () {
          return this._map.wasAltered() || this._list.wasAltered();
        }, xt.prototype.__iterate = function (e, t) {
          var n = this;
          return this._list.__iterate(function (t) {
            return t && e(t[1], t[0], n);
          }, t);
        }, xt.prototype.__iterator = function (e, t) {
          return this._list.fromEntrySeq().__iterator(e, t);
        }, xt.prototype.__ensureOwner = function (e) {
          if (e === this.__ownerID) return this;
          var t = this._map.__ensureOwner(e),
            n = this._list.__ensureOwner(e);
          return e ? St(t, n, e, this.__hash) : (this.__ownerID = e, this._map = t, this._list = n, this);
        }, xt.isOrderedMap = wt, xt.prototype[p] = !0, xt.prototype.delete = xt.prototype.remove, t(Tt, V), Tt.prototype.get = function (e, t) {
          return this._iter.get(e, t);
        }, Tt.prototype.has = function (e) {
          return this._iter.has(e);
        }, Tt.prototype.valueSeq = function () {
          return this._iter.valueSeq();
        }, Tt.prototype.reverse = function () {
          var e = this,
            t = Rt(this, !0);
          return this._useKeys || (t.valueSeq = function () {
            return e._iter.toSeq().reverse();
          }), t;
        }, Tt.prototype.map = function (e, t) {
          var n = this,
            r = Ot(this, e, t);
          return this._useKeys || (r.valueSeq = function () {
            return n._iter.toSeq().map(e, t);
          }), r;
        }, Tt.prototype.__iterate = function (e, t) {
          var n,
            r = this;
          return this._iter.__iterate(this._useKeys ? function (t, n) {
            return e(t, n, r);
          } : (n = t ? Ht(this) : 0, function (i) {
            return e(i, t ? --n : n++, r);
          }), t);
        }, Tt.prototype.__iterator = function (e, t) {
          if (this._useKeys) return this._iter.__iterator(e, t);
          var n = this._iter.__iterator(1, t),
            r = t ? Ht(this) : 0;
          return new j(function () {
            var i = n.next();
            return i.done ? i : N(e, t ? --r : r++, i.value, i);
          });
        }, Tt.prototype[p] = !0, t(Mt, H), Mt.prototype.includes = function (e) {
          return this._iter.includes(e);
        }, Mt.prototype.__iterate = function (e, t) {
          var n = this,
            r = 0;
          return this._iter.__iterate(function (t) {
            return e(t, r++, n);
          }, t);
        }, Mt.prototype.__iterator = function (e, t) {
          var n = this._iter.__iterator(1, t),
            r = 0;
          return new j(function () {
            var t = n.next();
            return t.done ? t : N(e, r++, t.value, t);
          });
        }, t(Ct, q), Ct.prototype.has = function (e) {
          return this._iter.includes(e);
        }, Ct.prototype.__iterate = function (e, t) {
          var n = this;
          return this._iter.__iterate(function (t) {
            return e(t, t, n);
          }, t);
        }, Ct.prototype.__iterator = function (e, t) {
          var n = this._iter.__iterator(1, t);
          return new j(function () {
            var t = n.next();
            return t.done ? t : N(e, t.value, t.value, t);
          });
        }, t(kt, V), kt.prototype.entrySeq = function () {
          return this._iter.toSeq();
        }, kt.prototype.__iterate = function (e, t) {
          var n = this;
          return this._iter.__iterate(function (t) {
            if (t) {
              Vt(t);
              var r = a(t);
              return e(r ? t.get(1) : t[1], r ? t.get(0) : t[0], n);
            }
          }, t);
        }, kt.prototype.__iterator = function (e, t) {
          var n = this._iter.__iterator(1, t);
          return new j(function () {
            for (;;) {
              var t = n.next();
              if (t.done) return t;
              var r = t.value;
              if (r) {
                Vt(r);
                var i = a(r);
                return N(e, i ? r.get(0) : r[0], i ? r.get(1) : r[1], t);
              }
            }
          });
        }, Mt.prototype.cacheResult = Tt.prototype.cacheResult = Ct.prototype.cacheResult = kt.prototype.cacheResult = $t, t(Kt, he), Kt.prototype.toString = function () {
          return this.__toString(Jt(this) + " {", "}");
        }, Kt.prototype.has = function (e) {
          return this._defaultValues.hasOwnProperty(e);
        }, Kt.prototype.get = function (e, t) {
          if (!this.has(e)) return t;
          var n = this._defaultValues[e];
          return this._map ? this._map.get(e, n) : n;
        }, Kt.prototype.clear = function () {
          if (this.__ownerID) return this._map && this._map.clear(), this;
          var e = this.constructor;
          return e._empty || (e._empty = Qt(this, He()));
        }, Kt.prototype.set = function (e, t) {
          if (!this.has(e)) throw new Error('Cannot set unknown key "' + e + '" on ' + Jt(this));
          if (this._map && !this._map.has(e) && t === this._defaultValues[e]) return this;
          var n = this._map && this._map.set(e, t);
          return this.__ownerID || n === this._map ? this : Qt(this, n);
        }, Kt.prototype.remove = function (e) {
          if (!this.has(e)) return this;
          var t = this._map && this._map.remove(e);
          return this.__ownerID || t === this._map ? this : Qt(this, t);
        }, Kt.prototype.wasAltered = function () {
          return this._map.wasAltered();
        }, Kt.prototype.__iterator = function (e, t) {
          var n = this;
          return r(this._defaultValues).map(function (e, t) {
            return n.get(t);
          }).__iterator(e, t);
        }, Kt.prototype.__iterate = function (e, t) {
          var n = this;
          return r(this._defaultValues).map(function (e, t) {
            return n.get(t);
          }).__iterate(e, t);
        }, Kt.prototype.__ensureOwner = function (e) {
          if (e === this.__ownerID) return this;
          var t = this._map && this._map.__ensureOwner(e);
          return e ? Qt(this, t, e) : (this.__ownerID = e, this._map = t, this);
        };
        var Zt = Kt.prototype;
        function Qt(e, t, n) {
          var r = Object.create(Object.getPrototypeOf(e));
          return r._map = t, r.__ownerID = n, r;
        }
        function Jt(e) {
          return e._name || e.constructor.name || "Record";
        }
        function en(e, t) {
          Object.defineProperty(e, t, {
            get: function get() {
              return this.get(t);
            },
            set: function set(e) {
              ue(this.__ownerID, "Cannot set on an immutable record."), this.set(t, e);
            }
          });
        }
        function tn(e) {
          return null == e ? un() : nn(e) && !c(e) ? e : un().withMutations(function (t) {
            var n = o(e);
            ke(n.size), n.forEach(function (e) {
              return t.add(e);
            });
          });
        }
        function nn(e) {
          return !(!e || !e[on]);
        }
        Zt.delete = Zt.remove, Zt.deleteIn = Zt.removeIn = je.removeIn, Zt.merge = je.merge, Zt.mergeWith = je.mergeWith, Zt.mergeIn = je.mergeIn, Zt.mergeDeep = je.mergeDeep, Zt.mergeDeepWith = je.mergeDeepWith, Zt.mergeDeepIn = je.mergeDeepIn, Zt.setIn = je.setIn, Zt.update = je.update, Zt.updateIn = je.updateIn, Zt.withMutations = je.withMutations, Zt.asMutable = je.asMutable, Zt.asImmutable = je.asImmutable, t(tn, pe), tn.of = function () {
          return this(arguments);
        }, tn.fromKeys = function (e) {
          return this(r(e).keySeq());
        }, tn.prototype.toString = function () {
          return this.__toString("Set {", "}");
        }, tn.prototype.has = function (e) {
          return this._map.has(e);
        }, tn.prototype.add = function (e) {
          return sn(this, this._map.set(e, !0));
        }, tn.prototype.remove = function (e) {
          return sn(this, this._map.remove(e));
        }, tn.prototype.clear = function () {
          return sn(this, this._map.clear());
        }, tn.prototype.union = function () {
          var t = e.call(arguments, 0);
          return 0 === (t = t.filter(function (e) {
            return 0 !== e.size;
          })).length ? this : 0 !== this.size || this.__ownerID || 1 !== t.length ? this.withMutations(function (e) {
            for (var n = 0; n < t.length; n++) o(t[n]).forEach(function (t) {
              return e.add(t);
            });
          }) : this.constructor(t[0]);
        }, tn.prototype.intersect = function () {
          var t = e.call(arguments, 0);
          if (0 === t.length) return this;
          t = t.map(function (e) {
            return o(e);
          });
          var n = this;
          return this.withMutations(function (e) {
            n.forEach(function (n) {
              t.every(function (e) {
                return e.includes(n);
              }) || e.remove(n);
            });
          });
        }, tn.prototype.subtract = function () {
          var t = e.call(arguments, 0);
          if (0 === t.length) return this;
          t = t.map(function (e) {
            return o(e);
          });
          var n = this;
          return this.withMutations(function (e) {
            n.forEach(function (n) {
              t.some(function (e) {
                return e.includes(n);
              }) && e.remove(n);
            });
          });
        }, tn.prototype.merge = function () {
          return this.union.apply(this, arguments);
        }, tn.prototype.mergeWith = function (t) {
          var n = e.call(arguments, 1);
          return this.union.apply(this, n);
        }, tn.prototype.sort = function (e) {
          return cn(Bt(this, e));
        }, tn.prototype.sortBy = function (e, t) {
          return cn(Bt(this, t, e));
        }, tn.prototype.wasAltered = function () {
          return this._map.wasAltered();
        }, tn.prototype.__iterate = function (e, t) {
          var n = this;
          return this._map.__iterate(function (t, r) {
            return e(r, r, n);
          }, t);
        }, tn.prototype.__iterator = function (e, t) {
          return this._map.map(function (e, t) {
            return t;
          }).__iterator(e, t);
        }, tn.prototype.__ensureOwner = function (e) {
          if (e === this.__ownerID) return this;
          var t = this._map.__ensureOwner(e);
          return e ? this.__make(t, e) : (this.__ownerID = e, this._map = t, this);
        }, tn.isSet = nn;
        var rn,
          on = "@@__IMMUTABLE_SET__@@",
          an = tn.prototype;
        function sn(e, t) {
          return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : 0 === t.size ? e.__empty() : e.__make(t);
        }
        function ln(e, t) {
          var n = Object.create(an);
          return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
        }
        function un() {
          return rn || (rn = ln(He()));
        }
        function cn(e) {
          return null == e ? mn() : dn(e) ? e : mn().withMutations(function (t) {
            var n = o(e);
            ke(n.size), n.forEach(function (e) {
              return t.add(e);
            });
          });
        }
        function dn(e) {
          return nn(e) && c(e);
        }
        an[on] = !0, an.delete = an.remove, an.mergeDeep = an.merge, an.mergeDeepWith = an.mergeWith, an.withMutations = je.withMutations, an.asMutable = je.asMutable, an.asImmutable = je.asImmutable, an.__empty = un, an.__make = ln, t(cn, tn), cn.of = function () {
          return this(arguments);
        }, cn.fromKeys = function (e) {
          return this(r(e).keySeq());
        }, cn.prototype.toString = function () {
          return this.__toString("OrderedSet {", "}");
        }, cn.isOrderedSet = dn;
        var hn,
          fn = cn.prototype;
        function pn(e, t) {
          var n = Object.create(fn);
          return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
        }
        function mn() {
          return hn || (hn = pn(At()));
        }
        function gn(e) {
          return null == e ? wn() : vn(e) ? e : wn().unshiftAll(e);
        }
        function vn(e) {
          return !(!e || !e[bn]);
        }
        fn[p] = !0, fn.__empty = mn, fn.__make = pn, t(gn, fe), gn.of = function () {
          return this(arguments);
        }, gn.prototype.toString = function () {
          return this.__toString("Stack [", "]");
        }, gn.prototype.get = function (e, t) {
          var n = this._head;
          for (e = S(this, e); n && e--;) n = n.next;
          return n ? n.value : t;
        }, gn.prototype.peek = function () {
          return this._head && this._head.value;
        }, gn.prototype.push = function () {
          if (0 === arguments.length) return this;
          for (var e = this.size + arguments.length, t = this._head, n = arguments.length - 1; n >= 0; n--) t = {
            value: arguments[n],
            next: t
          };
          return this.__ownerID ? (this.size = e, this._head = t, this.__hash = void 0, this.__altered = !0, this) : xn(e, t);
        }, gn.prototype.pushAll = function (e) {
          if (0 === (e = i(e)).size) return this;
          ke(e.size);
          var t = this.size,
            n = this._head;
          return e.reverse().forEach(function (e) {
            t++, n = {
              value: e,
              next: n
            };
          }), this.__ownerID ? (this.size = t, this._head = n, this.__hash = void 0, this.__altered = !0, this) : xn(t, n);
        }, gn.prototype.pop = function () {
          return this.slice(1);
        }, gn.prototype.unshift = function () {
          return this.push.apply(this, arguments);
        }, gn.prototype.unshiftAll = function (e) {
          return this.pushAll(e);
        }, gn.prototype.shift = function () {
          return this.pop.apply(this, arguments);
        }, gn.prototype.clear = function () {
          return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : wn();
        }, gn.prototype.slice = function (e, t) {
          if (E(e, t, this.size)) return this;
          var n = T(e, this.size);
          if (M(t, this.size) !== this.size) return fe.prototype.slice.call(this, e, t);
          for (var r = this.size - n, i = this._head; n--;) i = i.next;
          return this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : xn(r, i);
        }, gn.prototype.__ensureOwner = function (e) {
          return e === this.__ownerID ? this : e ? xn(this.size, this._head, e, this.__hash) : (this.__ownerID = e, this.__altered = !1, this);
        }, gn.prototype.__iterate = function (e, t) {
          if (t) return this.reverse().__iterate(e);
          for (var n = 0, r = this._head; r && !1 !== e(r.value, n++, this);) r = r.next;
          return n;
        }, gn.prototype.__iterator = function (e, t) {
          if (t) return this.reverse().__iterator(e);
          var n = 0,
            r = this._head;
          return new j(function () {
            if (r) {
              var t = r.value;
              return r = r.next, N(e, n++, t);
            }
            return {
              value: void 0,
              done: !0
            };
          });
        }, gn.isStack = vn;
        var yn,
          bn = "@@__IMMUTABLE_STACK__@@",
          _n = gn.prototype;
        function xn(e, t, n, r) {
          var i = Object.create(_n);
          return i.size = e, i._head = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
        }
        function wn() {
          return yn || (yn = xn(0));
        }
        function Sn(e, t) {
          var n = function n(_n7) {
            e.prototype[_n7] = t[_n7];
          };
          return Object.keys(t).forEach(n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(n), e;
        }
        _n[bn] = !0, _n.withMutations = je.withMutations, _n.asMutable = je.asMutable, _n.asImmutable = je.asImmutable, _n.wasAltered = je.wasAltered, n.Iterator = j, Sn(n, {
          toArray: function toArray() {
            ke(this.size);
            var e = new Array(this.size || 0);
            return this.valueSeq().__iterate(function (t, n) {
              e[n] = t;
            }), e;
          },
          toIndexedSeq: function toIndexedSeq() {
            return new Mt(this);
          },
          toJS: function toJS() {
            return this.toSeq().map(function (e) {
              return e && "function" == typeof e.toJS ? e.toJS() : e;
            }).__toJS();
          },
          toJSON: function toJSON() {
            return this.toSeq().map(function (e) {
              return e && "function" == typeof e.toJSON ? e.toJSON() : e;
            }).__toJS();
          },
          toKeyedSeq: function toKeyedSeq() {
            return new Tt(this, !0);
          },
          toMap: function toMap() {
            return Pe(this.toKeyedSeq());
          },
          toObject: function toObject() {
            ke(this.size);
            var e = {};
            return this.__iterate(function (t, n) {
              e[n] = t;
            }), e;
          },
          toOrderedMap: function toOrderedMap() {
            return xt(this.toKeyedSeq());
          },
          toOrderedSet: function toOrderedSet() {
            return cn(s(this) ? this.valueSeq() : this);
          },
          toSet: function toSet() {
            return tn(s(this) ? this.valueSeq() : this);
          },
          toSetSeq: function toSetSeq() {
            return new Ct(this);
          },
          toSeq: function toSeq() {
            return l(this) ? this.toIndexedSeq() : s(this) ? this.toKeyedSeq() : this.toSetSeq();
          },
          toStack: function toStack() {
            return gn(s(this) ? this.valueSeq() : this);
          },
          toList: function toList() {
            return it(s(this) ? this.valueSeq() : this);
          },
          toString: function toString() {
            return "[Iterable]";
          },
          __toString: function __toString(e, t) {
            return 0 === this.size ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
          },
          concat: function concat() {
            var t = e.call(arguments, 0);
            return Gt(this, Lt(this, t));
          },
          includes: function includes(e) {
            return this.some(function (t) {
              return ae(t, e);
            });
          },
          entries: function entries() {
            return this.__iterator(2);
          },
          every: function every(e, t) {
            ke(this.size);
            var n = !0;
            return this.__iterate(function (r, i, o) {
              if (!e.call(t, r, i, o)) return n = !1, !1;
            }), n;
          },
          filter: function filter(e, t) {
            return Gt(this, It(this, e, t, !0));
          },
          find: function find(e, t, n) {
            var r = this.findEntry(e, t);
            return r ? r[1] : n;
          },
          forEach: function forEach(e, t) {
            return ke(this.size), this.__iterate(t ? e.bind(t) : e);
          },
          join: function join(e) {
            ke(this.size), e = void 0 !== e ? "" + e : ",";
            var t = "",
              n = !0;
            return this.__iterate(function (r) {
              n ? n = !1 : t += e, t += null != r ? r.toString() : "";
            }), t;
          },
          keys: function keys() {
            return this.__iterator(0);
          },
          map: function map(e, t) {
            return Gt(this, Ot(this, e, t));
          },
          reduce: function reduce(e, t, n) {
            var r, i;
            return ke(this.size), arguments.length < 2 ? i = !0 : r = t, this.__iterate(function (t, o, a) {
              i ? (i = !1, r = t) : r = e.call(n, r, t, o, a);
            }), r;
          },
          reduceRight: function reduceRight(e, t, n) {
            var r = this.toKeyedSeq().reverse();
            return r.reduce.apply(r, arguments);
          },
          reverse: function reverse() {
            return Gt(this, Rt(this, !0));
          },
          slice: function slice(e, t) {
            return Gt(this, jt(this, e, t, !0));
          },
          some: function some(e, t) {
            return !this.every(Cn(e), t);
          },
          sort: function sort(e) {
            return Gt(this, Bt(this, e));
          },
          values: function values() {
            return this.__iterator(1);
          },
          butLast: function butLast() {
            return this.slice(0, -1);
          },
          isEmpty: function isEmpty() {
            return void 0 !== this.size ? 0 === this.size : !this.some(function () {
              return !0;
            });
          },
          count: function count(e, t) {
            return w(e ? this.toSeq().filter(e, t) : this);
          },
          countBy: function countBy(e, t) {
            return function (e, t, n) {
              var r = Pe().asMutable();
              return e.__iterate(function (i, o) {
                r.update(t.call(n, i, o, e), 0, function (e) {
                  return e + 1;
                });
              }), r.asImmutable();
            }(this, e, t);
          },
          equals: function equals(e) {
            return se(this, e);
          },
          entrySeq: function entrySeq() {
            var e = this;
            if (e._cache) return new W(e._cache);
            var t = e.toSeq().map(Mn).toIndexedSeq();
            return t.fromEntrySeq = function () {
              return e.toSeq();
            }, t;
          },
          filterNot: function filterNot(e, t) {
            return this.filter(Cn(e), t);
          },
          findEntry: function findEntry(e, t, n) {
            var r = n;
            return this.__iterate(function (n, i, o) {
              if (e.call(t, n, i, o)) return r = [i, n], !1;
            }), r;
          },
          findKey: function findKey(e, t) {
            var n = this.findEntry(e, t);
            return n && n[0];
          },
          findLast: function findLast(e, t, n) {
            return this.toKeyedSeq().reverse().find(e, t, n);
          },
          findLastEntry: function findLastEntry(e, t, n) {
            return this.toKeyedSeq().reverse().findEntry(e, t, n);
          },
          findLastKey: function findLastKey(e, t) {
            return this.toKeyedSeq().reverse().findKey(e, t);
          },
          first: function first() {
            return this.find(A);
          },
          flatMap: function flatMap(e, t) {
            return Gt(this, function (e, t, n) {
              var r = qt(e);
              return e.toSeq().map(function (i, o) {
                return r(t.call(n, i, o, e));
              }).flatten(!0);
            }(this, e, t));
          },
          flatten: function flatten(e) {
            return Gt(this, Dt(this, e, !0));
          },
          fromEntrySeq: function fromEntrySeq() {
            return new kt(this);
          },
          get: function get(e, t) {
            return this.find(function (t, n) {
              return ae(n, e);
            }, void 0, t);
          },
          getIn: function getIn(e, t) {
            for (var n, r = this, i = Yt(e); !(n = i.next()).done;) {
              var o = n.value;
              if ((r = r && r.get ? r.get(o, m) : m) === m) return t;
            }
            return r;
          },
          groupBy: function groupBy(e, t) {
            return function (e, t, n) {
              var r = s(e),
                i = (c(e) ? xt() : Pe()).asMutable();
              e.__iterate(function (o, a) {
                i.update(t.call(n, o, a, e), function (e) {
                  return (e = e || []).push(r ? [a, o] : o), e;
                });
              });
              var o = qt(e);
              return i.map(function (t) {
                return Gt(e, o(t));
              });
            }(this, e, t);
          },
          has: function has(e) {
            return this.get(e, m) !== m;
          },
          hasIn: function hasIn(e) {
            return this.getIn(e, m) !== m;
          },
          isSubset: function isSubset(e) {
            return e = "function" == typeof e.includes ? e : n(e), this.every(function (t) {
              return e.includes(t);
            });
          },
          isSuperset: function isSuperset(e) {
            return (e = "function" == typeof e.isSubset ? e : n(e)).isSubset(this);
          },
          keyOf: function keyOf(e) {
            return this.findKey(function (t) {
              return ae(t, e);
            });
          },
          keySeq: function keySeq() {
            return this.toSeq().map(Tn).toIndexedSeq();
          },
          last: function last() {
            return this.toSeq().reverse().first();
          },
          lastKeyOf: function lastKeyOf(e) {
            return this.toKeyedSeq().reverse().keyOf(e);
          },
          max: function max(e) {
            return Ft(this, e);
          },
          maxBy: function maxBy(e, t) {
            return Ft(this, t, e);
          },
          min: function min(e) {
            return Ft(this, e ? kn(e) : Rn);
          },
          minBy: function minBy(e, t) {
            return Ft(this, t ? kn(t) : Rn, e);
          },
          rest: function rest() {
            return this.slice(1);
          },
          skip: function skip(e) {
            return this.slice(Math.max(0, e));
          },
          skipLast: function skipLast(e) {
            return Gt(this, this.toSeq().reverse().skip(e).reverse());
          },
          skipWhile: function skipWhile(e, t) {
            return Gt(this, Nt(this, e, t, !0));
          },
          skipUntil: function skipUntil(e, t) {
            return this.skipWhile(Cn(e), t);
          },
          sortBy: function sortBy(e, t) {
            return Gt(this, Bt(this, t, e));
          },
          take: function take(e) {
            return this.slice(0, Math.max(0, e));
          },
          takeLast: function takeLast(e) {
            return Gt(this, this.toSeq().reverse().take(e).reverse());
          },
          takeWhile: function takeWhile(e, t) {
            return Gt(this, function (e, t, n) {
              var r = Wt(e);
              return r.__iterateUncached = function (r, i) {
                var o = this;
                if (i) return this.cacheResult().__iterate(r, i);
                var a = 0;
                return e.__iterate(function (e, i, s) {
                  return t.call(n, e, i, s) && ++a && r(e, i, o);
                }), a;
              }, r.__iteratorUncached = function (r, i) {
                var o = this;
                if (i) return this.cacheResult().__iterator(r, i);
                var a = e.__iterator(2, i),
                  s = !0;
                return new j(function () {
                  if (!s) return {
                    value: void 0,
                    done: !0
                  };
                  var e = a.next();
                  if (e.done) return e;
                  var i = e.value,
                    l = i[0],
                    u = i[1];
                  return t.call(n, u, l, o) ? 2 === r ? e : N(r, l, u, e) : (s = !1, {
                    value: void 0,
                    done: !0
                  });
                });
              }, r;
            }(this, e, t));
          },
          takeUntil: function takeUntil(e, t) {
            return this.takeWhile(Cn(e), t);
          },
          valueSeq: function valueSeq() {
            return this.toIndexedSeq();
          },
          hashCode: function hashCode() {
            return this.__hash || (this.__hash = function (e) {
              if (e.size === 1 / 0) return 0;
              var t = c(e),
                n = s(e),
                r = t ? 1 : 0;
              return function (e, t) {
                return t = me(t, 3432918353), t = me(t << 15 | t >>> -15, 461845907), t = me(t << 13 | t >>> -13, 5), t = me((t = (t + 3864292196 | 0) ^ e) ^ t >>> 16, 2246822507), t = ge((t = me(t ^ t >>> 13, 3266489909)) ^ t >>> 16);
              }(e.__iterate(n ? t ? function (e, t) {
                r = 31 * r + In(ve(e), ve(t)) | 0;
              } : function (e, t) {
                r = r + In(ve(e), ve(t)) | 0;
              } : t ? function (e) {
                r = 31 * r + ve(e) | 0;
              } : function (e) {
                r = r + ve(e) | 0;
              }), r);
            }(this));
          }
        });
        var An = n.prototype;
        An[d] = !0, An[I] = An.values, An.__toJS = An.toArray, An.__toStringMapper = Pn, An.inspect = An.toSource = function () {
          return this.toString();
        }, An.chain = An.flatMap, An.contains = An.includes, Sn(r, {
          flip: function flip() {
            return Gt(this, Pt(this));
          },
          mapEntries: function mapEntries(e, t) {
            var n = this,
              r = 0;
            return Gt(this, this.toSeq().map(function (i, o) {
              return e.call(t, [o, i], r++, n);
            }).fromEntrySeq());
          },
          mapKeys: function mapKeys(e, t) {
            var n = this;
            return Gt(this, this.toSeq().flip().map(function (r, i) {
              return e.call(t, r, i, n);
            }).flip());
          }
        });
        var En = r.prototype;
        function Tn(e, t) {
          return t;
        }
        function Mn(e, t) {
          return [t, e];
        }
        function Cn(e) {
          return function () {
            return !e.apply(this, arguments);
          };
        }
        function kn(e) {
          return function () {
            return -e.apply(this, arguments);
          };
        }
        function Pn(e) {
          return "string" == typeof e ? JSON.stringify(e) : String(e);
        }
        function On() {
          return x(arguments);
        }
        function Rn(e, t) {
          return e < t ? 1 : e > t ? -1 : 0;
        }
        function In(e, t) {
          return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
        }
        return En[h] = !0, En[I] = An.entries, En.__toJS = An.toObject, En.__toStringMapper = function (e, t) {
          return JSON.stringify(t) + ": " + Pn(e);
        }, Sn(i, {
          toKeyedSeq: function toKeyedSeq() {
            return new Tt(this, !1);
          },
          filter: function filter(e, t) {
            return Gt(this, It(this, e, t, !1));
          },
          findIndex: function findIndex(e, t) {
            var n = this.findEntry(e, t);
            return n ? n[0] : -1;
          },
          indexOf: function indexOf(e) {
            var t = this.keyOf(e);
            return void 0 === t ? -1 : t;
          },
          lastIndexOf: function lastIndexOf(e) {
            var t = this.lastKeyOf(e);
            return void 0 === t ? -1 : t;
          },
          reverse: function reverse() {
            return Gt(this, Rt(this, !1));
          },
          slice: function slice(e, t) {
            return Gt(this, jt(this, e, t, !1));
          },
          splice: function splice(e, t) {
            var n = arguments.length;
            if (t = Math.max(0 | t, 0), 0 === n || 2 === n && !t) return this;
            e = T(e, e < 0 ? this.count() : this.size);
            var r = this.slice(0, e);
            return Gt(this, 1 === n ? r : r.concat(x(arguments, 2), this.slice(e + t)));
          },
          findLastIndex: function findLastIndex(e, t) {
            var n = this.findLastEntry(e, t);
            return n ? n[0] : -1;
          },
          first: function first() {
            return this.get(0);
          },
          flatten: function flatten(e) {
            return Gt(this, Dt(this, e, !1));
          },
          get: function get(e, t) {
            return (e = S(this, e)) < 0 || this.size === 1 / 0 || void 0 !== this.size && e > this.size ? t : this.find(function (t, n) {
              return n === e;
            }, void 0, t);
          },
          has: function has(e) {
            return (e = S(this, e)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || e < this.size : -1 !== this.indexOf(e));
          },
          interpose: function interpose(e) {
            return Gt(this, function (e, t) {
              var n = Wt(e);
              return n.size = e.size && 2 * e.size - 1, n.__iterateUncached = function (n, r) {
                var i = this,
                  o = 0;
                return e.__iterate(function (e, r) {
                  return (!o || !1 !== n(t, o++, i)) && !1 !== n(e, o++, i);
                }, r), o;
              }, n.__iteratorUncached = function (n, r) {
                var i,
                  o = e.__iterator(1, r),
                  a = 0;
                return new j(function () {
                  return (!i || a % 2) && (i = o.next()).done ? i : a % 2 ? N(n, a++, t) : N(n, a++, i.value, i);
                });
              }, n;
            }(this, e));
          },
          interleave: function interleave() {
            var e = [this].concat(x(arguments)),
              t = Ut(this.toSeq(), H.of, e),
              n = t.flatten(!0);
            return t.size && (n.size = t.size * e.length), Gt(this, n);
          },
          keySeq: function keySeq() {
            return ce(0, this.size);
          },
          last: function last() {
            return this.get(-1);
          },
          skipWhile: function skipWhile(e, t) {
            return Gt(this, Nt(this, e, t, !1));
          },
          zip: function zip() {
            var e = [this].concat(x(arguments));
            return Gt(this, Ut(this, On, e));
          },
          zipWith: function zipWith(e) {
            var t = x(arguments);
            return t[0] = this, Gt(this, Ut(this, e, t));
          }
        }), i.prototype[f] = !0, i.prototype[p] = !0, Sn(o, {
          get: function get(e, t) {
            return this.has(e) ? e : t;
          },
          includes: function includes(e) {
            return this.has(e);
          },
          keySeq: function keySeq() {
            return this.valueSeq();
          }
        }), o.prototype.has = An.includes, o.prototype.contains = o.prototype.includes, Sn(V, r.prototype), Sn(H, i.prototype), Sn(q, o.prototype), Sn(he, r.prototype), Sn(fe, i.prototype), Sn(pe, o.prototype), {
          Iterable: n,
          Seq: G,
          Collection: de,
          Map: Pe,
          OrderedMap: xt,
          List: it,
          Stack: gn,
          Set: tn,
          OrderedSet: cn,
          Record: Kt,
          Range: ce,
          Repeat: le,
          is: ae,
          fromJS: re
        };
      }();
    },
    "./node_modules/inherits/inherits_browser.js": function node_modulesInheritsInherits_browserJs(e, t) {
      "function" == typeof Object.create ? e.exports = function (e, t) {
        t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }));
      } : e.exports = function (e, t) {
        if (t) {
          e.super_ = t;
          var n = function n() {};
          n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
        }
      };
    },
    "./node_modules/is-any-array/src/index.js": function node_modulesIsAnyArraySrcIndexJs(e, t, n) {
      "use strict";

      var r = Object.prototype.toString;
      e.exports = function (e) {
        return r.call(e).endsWith("Array]");
      };
    },
    "./node_modules/is-arguments/index.js": function node_modulesIsArgumentsIndexJs(e, t, n) {
      "use strict";

      var r = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
        i = Object.prototype.toString,
        o = function o(e) {
          return !(r && e && "object" == typeof e && Symbol.toStringTag in e) && "[object Arguments]" === i.call(e);
        },
        a = function a(e) {
          return !!o(e) || null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== i.call(e) && "[object Function]" === i.call(e.callee);
        },
        s = function () {
          return o(arguments);
        }();
      o.isLegacyArguments = a, e.exports = s ? o : a;
    },
    "./node_modules/is-date-object/index.js": function node_modulesIsDateObjectIndexJs(e, t, n) {
      "use strict";

      var r = Date.prototype.getDay,
        i = Object.prototype.toString,
        o = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;
      e.exports = function (e) {
        return "object" == typeof e && null !== e && (o ? function (e) {
          try {
            return r.call(e), !0;
          } catch (e) {
            return !1;
          }
        }(e) : "[object Date]" === i.call(e));
      };
    },
    "./node_modules/is-regex/index.js": function node_modulesIsRegexIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/has/src/index.js"),
        i = RegExp.prototype.exec,
        o = Object.getOwnPropertyDescriptor,
        a = Object.prototype.toString,
        s = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag;
      e.exports = function (e) {
        if (!e || "object" != typeof e) return !1;
        if (!s) return "[object RegExp]" === a.call(e);
        var t = o(e, "lastIndex");
        return !(!t || !r(t, "value")) && function (e) {
          try {
            var t = e.lastIndex;
            return e.lastIndex = 0, i.call(e), !0;
          } catch (e) {
            return !1;
          } finally {
            e.lastIndex = t;
          }
        }(e);
      };
    },
    "./node_modules/isarray/index.js": function node_modulesIsarrayIndexJs(e, t) {
      var n = {}.toString;
      e.exports = Array.isArray || function (e) {
        return "[object Array]" == n.call(e);
      };
    },
    "./node_modules/keyboard-key/src/keyboardKey.js": function node_modulesKeyboardKeySrcKeyboardKeyJs(e, t, n) {
      "use strict";

      for (var r = function r(e) {
          return null !== e && !Array.isArray(e) && "object" == typeof e;
        }, i = {
          3: "Cancel",
          6: "Help",
          8: "Backspace",
          9: "Tab",
          12: "Clear",
          13: "Enter",
          16: "Shift",
          17: "Control",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Escape",
          28: "Convert",
          29: "NonConvert",
          30: "Accept",
          31: "ModeChange",
          32: " ",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "ArrowLeft",
          38: "ArrowUp",
          39: "ArrowRight",
          40: "ArrowDown",
          41: "Select",
          42: "Print",
          43: "Execute",
          44: "PrintScreen",
          45: "Insert",
          46: "Delete",
          48: ["0", ")"],
          49: ["1", "!"],
          50: ["2", "@"],
          51: ["3", "#"],
          52: ["4", "$"],
          53: ["5", "%"],
          54: ["6", "^"],
          55: ["7", "&"],
          56: ["8", "*"],
          57: ["9", "("],
          91: "OS",
          93: "ContextMenu",
          144: "NumLock",
          145: "ScrollLock",
          181: "VolumeMute",
          182: "VolumeDown",
          183: "VolumeUp",
          186: [";", ":"],
          187: ["=", "+"],
          188: [",", "<"],
          189: ["-", "_"],
          190: [".", ">"],
          191: ["/", "?"],
          192: ["`", "~"],
          219: ["[", "{"],
          220: ["\\", "|"],
          221: ["]", "}"],
          222: ["'", '"'],
          224: "Meta",
          225: "AltGraph",
          246: "Attn",
          247: "CrSel",
          248: "ExSel",
          249: "EraseEof",
          250: "Play",
          251: "ZoomOut"
        }, o = 0; o < 24; o += 1) i[112 + o] = "F" + (o + 1);
      for (var a = 0; a < 26; a += 1) {
        var s = a + 65;
        i[s] = [String.fromCharCode(s + 32), String.fromCharCode(s)];
      }
      var l = {
        codes: i,
        getCode: function getCode(e) {
          return r(e) ? e.keyCode || e.which || this[e.key] : this[e];
        },
        getKey: function getKey(e) {
          var t = r(e);
          if (t && e.key) return e.key;
          var n = i[t ? e.keyCode || e.which : e];
          return Array.isArray(n) && (n = t ? n[e.shiftKey ? 1 : 0] : n[0]), n;
        },
        Cancel: 3,
        Help: 6,
        Backspace: 8,
        Tab: 9,
        Clear: 12,
        Enter: 13,
        Shift: 16,
        Control: 17,
        Alt: 18,
        Pause: 19,
        CapsLock: 20,
        Escape: 27,
        Convert: 28,
        NonConvert: 29,
        Accept: 30,
        ModeChange: 31,
        " ": 32,
        PageUp: 33,
        PageDown: 34,
        End: 35,
        Home: 36,
        ArrowLeft: 37,
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        Select: 41,
        Print: 42,
        Execute: 43,
        PrintScreen: 44,
        Insert: 45,
        Delete: 46,
        0: 48,
        ")": 48,
        1: 49,
        "!": 49,
        2: 50,
        "@": 50,
        3: 51,
        "#": 51,
        4: 52,
        $: 52,
        5: 53,
        "%": 53,
        6: 54,
        "^": 54,
        7: 55,
        "&": 55,
        8: 56,
        "*": 56,
        9: 57,
        "(": 57,
        a: 65,
        A: 65,
        b: 66,
        B: 66,
        c: 67,
        C: 67,
        d: 68,
        D: 68,
        e: 69,
        E: 69,
        f: 70,
        F: 70,
        g: 71,
        G: 71,
        h: 72,
        H: 72,
        i: 73,
        I: 73,
        j: 74,
        J: 74,
        k: 75,
        K: 75,
        l: 76,
        L: 76,
        m: 77,
        M: 77,
        n: 78,
        N: 78,
        o: 79,
        O: 79,
        p: 80,
        P: 80,
        q: 81,
        Q: 81,
        r: 82,
        R: 82,
        s: 83,
        S: 83,
        t: 84,
        T: 84,
        u: 85,
        U: 85,
        v: 86,
        V: 86,
        w: 87,
        W: 87,
        x: 88,
        X: 88,
        y: 89,
        Y: 89,
        z: 90,
        Z: 90,
        OS: 91,
        ContextMenu: 93,
        F1: 112,
        F2: 113,
        F3: 114,
        F4: 115,
        F5: 116,
        F6: 117,
        F7: 118,
        F8: 119,
        F9: 120,
        F10: 121,
        F11: 122,
        F12: 123,
        F13: 124,
        F14: 125,
        F15: 126,
        F16: 127,
        F17: 128,
        F18: 129,
        F19: 130,
        F20: 131,
        F21: 132,
        F22: 133,
        F23: 134,
        F24: 135,
        NumLock: 144,
        ScrollLock: 145,
        VolumeMute: 181,
        VolumeDown: 182,
        VolumeUp: 183,
        ";": 186,
        ":": 186,
        "=": 187,
        "+": 187,
        ",": 188,
        "<": 188,
        "-": 189,
        _: 189,
        ".": 190,
        ">": 190,
        "/": 191,
        "?": 191,
        "`": 192,
        "~": 192,
        "[": 219,
        "{": 219,
        "\\": 220,
        "|": 220,
        "]": 221,
        "}": 221,
        "'": 222,
        '"': 222,
        Meta: 224,
        AltGraph: 225,
        Attn: 246,
        CrSel: 247,
        ExSel: 248,
        EraseEof: 249,
        Play: 250,
        ZoomOut: 251
      };
      l.Spacebar = l[" "], l.Digit0 = l[0], l.Digit1 = l[1], l.Digit2 = l[2], l.Digit3 = l[3], l.Digit4 = l[4], l.Digit5 = l[5], l.Digit6 = l[6], l.Digit7 = l[7], l.Digit8 = l[8], l.Digit9 = l[9], l.Tilde = l["~"], l.GraveAccent = l["`"], l.ExclamationPoint = l["!"], l.AtSign = l["@"], l.PoundSign = l["#"], l.PercentSign = l["%"], l.Caret = l["^"], l.Ampersand = l["&"], l.PlusSign = l["+"], l.MinusSign = l["-"], l.EqualsSign = l["="], l.DivisionSign = l["/"], l.MultiplicationSign = l["*"], l.Comma = l[","], l.Decimal = l["."], l.Colon = l[":"], l.Semicolon = l[";"], l.Pipe = l["|"], l.BackSlash = l["\\"], l.QuestionMark = l["?"], l.SingleQuote = l["'"], l.DoubleQuote = l['"'], l.LeftCurlyBrace = l["{"], l.RightCurlyBrace = l["}"], l.LeftParenthesis = l["("], l.RightParenthesis = l[")"], l.LeftAngleBracket = l["<"], l.RightAngleBracket = l[">"], l.LeftSquareBracket = l["["], l.RightSquareBracket = l["]"], e.exports = l;
    },
    "./node_modules/lodash/_DataView.js": function node_modulesLodash_DataViewJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js")(n("./node_modules/lodash/_root.js"), "DataView");
      e.exports = r;
    },
    "./node_modules/lodash/_Hash.js": function node_modulesLodash_HashJs(e, t, n) {
      var r = n("./node_modules/lodash/_hashClear.js"),
        i = n("./node_modules/lodash/_hashDelete.js"),
        o = n("./node_modules/lodash/_hashGet.js"),
        a = n("./node_modules/lodash/_hashHas.js"),
        s = n("./node_modules/lodash/_hashSet.js");
      function l(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }
      l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = o, l.prototype.has = a, l.prototype.set = s, e.exports = l;
    },
    "./node_modules/lodash/_LazyWrapper.js": function node_modulesLodash_LazyWrapperJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseCreate.js"),
        i = n("./node_modules/lodash/_baseLodash.js");
      function o(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
      }
      o.prototype = r(i.prototype), o.prototype.constructor = o, e.exports = o;
    },
    "./node_modules/lodash/_ListCache.js": function node_modulesLodash_ListCacheJs(e, t, n) {
      var r = n("./node_modules/lodash/_listCacheClear.js"),
        i = n("./node_modules/lodash/_listCacheDelete.js"),
        o = n("./node_modules/lodash/_listCacheGet.js"),
        a = n("./node_modules/lodash/_listCacheHas.js"),
        s = n("./node_modules/lodash/_listCacheSet.js");
      function l(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }
      l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = o, l.prototype.has = a, l.prototype.set = s, e.exports = l;
    },
    "./node_modules/lodash/_LodashWrapper.js": function node_modulesLodash_LodashWrapperJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseCreate.js"),
        i = n("./node_modules/lodash/_baseLodash.js");
      function o(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
      }
      o.prototype = r(i.prototype), o.prototype.constructor = o, e.exports = o;
    },
    "./node_modules/lodash/_Map.js": function node_modulesLodash_MapJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js")(n("./node_modules/lodash/_root.js"), "Map");
      e.exports = r;
    },
    "./node_modules/lodash/_MapCache.js": function node_modulesLodash_MapCacheJs(e, t, n) {
      var r = n("./node_modules/lodash/_mapCacheClear.js"),
        i = n("./node_modules/lodash/_mapCacheDelete.js"),
        o = n("./node_modules/lodash/_mapCacheGet.js"),
        a = n("./node_modules/lodash/_mapCacheHas.js"),
        s = n("./node_modules/lodash/_mapCacheSet.js");
      function l(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }
      l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = o, l.prototype.has = a, l.prototype.set = s, e.exports = l;
    },
    "./node_modules/lodash/_Promise.js": function node_modulesLodash_PromiseJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js")(n("./node_modules/lodash/_root.js"), "Promise");
      e.exports = r;
    },
    "./node_modules/lodash/_Set.js": function node_modulesLodash_SetJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js")(n("./node_modules/lodash/_root.js"), "Set");
      e.exports = r;
    },
    "./node_modules/lodash/_SetCache.js": function node_modulesLodash_SetCacheJs(e, t, n) {
      var r = n("./node_modules/lodash/_MapCache.js"),
        i = n("./node_modules/lodash/_setCacheAdd.js"),
        o = n("./node_modules/lodash/_setCacheHas.js");
      function a(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.__data__ = new r(); ++t < n;) this.add(e[t]);
      }
      a.prototype.add = a.prototype.push = i, a.prototype.has = o, e.exports = a;
    },
    "./node_modules/lodash/_Stack.js": function node_modulesLodash_StackJs(e, t, n) {
      var r = n("./node_modules/lodash/_ListCache.js"),
        i = n("./node_modules/lodash/_stackClear.js"),
        o = n("./node_modules/lodash/_stackDelete.js"),
        a = n("./node_modules/lodash/_stackGet.js"),
        s = n("./node_modules/lodash/_stackHas.js"),
        l = n("./node_modules/lodash/_stackSet.js");
      function u(e) {
        var t = this.__data__ = new r(e);
        this.size = t.size;
      }
      u.prototype.clear = i, u.prototype.delete = o, u.prototype.get = a, u.prototype.has = s, u.prototype.set = l, e.exports = u;
    },
    "./node_modules/lodash/_Symbol.js": function node_modulesLodash_SymbolJs(e, t, n) {
      var r = n("./node_modules/lodash/_root.js").Symbol;
      e.exports = r;
    },
    "./node_modules/lodash/_Uint8Array.js": function node_modulesLodash_Uint8ArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/_root.js").Uint8Array;
      e.exports = r;
    },
    "./node_modules/lodash/_WeakMap.js": function node_modulesLodash_WeakMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js")(n("./node_modules/lodash/_root.js"), "WeakMap");
      e.exports = r;
    },
    "./node_modules/lodash/_apply.js": function node_modulesLodash_applyJs(e, t) {
      e.exports = function (e, t, n) {
        switch (n.length) {
          case 0:
            return e.call(t);
          case 1:
            return e.call(t, n[0]);
          case 2:
            return e.call(t, n[0], n[1]);
          case 3:
            return e.call(t, n[0], n[1], n[2]);
        }
        return e.apply(t, n);
      };
    },
    "./node_modules/lodash/_arrayAggregator.js": function node_modulesLodash_arrayAggregatorJs(e, t) {
      e.exports = function (e, t, n, r) {
        for (var i = -1, o = null == e ? 0 : e.length; ++i < o;) {
          var a = e[i];
          t(r, a, n(a), e);
        }
        return r;
      };
    },
    "./node_modules/lodash/_arrayEach.js": function node_modulesLodash_arrayEachJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e););
        return e;
      };
    },
    "./node_modules/lodash/_arrayEvery.js": function node_modulesLodash_arrayEveryJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
        return !0;
      };
    },
    "./node_modules/lodash/_arrayFilter.js": function node_modulesLodash_arrayFilterJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
          var a = e[n];
          t(a, n, e) && (o[i++] = a);
        }
        return o;
      };
    },
    "./node_modules/lodash/_arrayIncludes.js": function node_modulesLodash_arrayIncludesJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIndexOf.js");
      e.exports = function (e, t) {
        return !!(null == e ? 0 : e.length) && r(e, t, 0) > -1;
      };
    },
    "./node_modules/lodash/_arrayIncludesWith.js": function node_modulesLodash_arrayIncludesWithJs(e, t) {
      e.exports = function (e, t, n) {
        for (var r = -1, i = null == e ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
        return !1;
      };
    },
    "./node_modules/lodash/_arrayLikeKeys.js": function node_modulesLodash_arrayLikeKeysJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseTimes.js"),
        i = n("./node_modules/lodash/isArguments.js"),
        o = n("./node_modules/lodash/isArray.js"),
        a = n("./node_modules/lodash/isBuffer.js"),
        s = n("./node_modules/lodash/_isIndex.js"),
        l = n("./node_modules/lodash/isTypedArray.js"),
        u = Object.prototype.hasOwnProperty;
      e.exports = function (e, t) {
        var n = o(e),
          c = !n && i(e),
          d = !n && !c && a(e),
          h = !n && !c && !d && l(e),
          f = n || c || d || h,
          p = f ? r(e.length, String) : [],
          m = p.length;
        for (var g in e) !t && !u.call(e, g) || f && ("length" == g || d && ("offset" == g || "parent" == g) || h && ("buffer" == g || "byteLength" == g || "byteOffset" == g) || s(g, m)) || p.push(g);
        return p;
      };
    },
    "./node_modules/lodash/_arrayMap.js": function node_modulesLodash_arrayMapJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
        return i;
      };
    },
    "./node_modules/lodash/_arrayPush.js": function node_modulesLodash_arrayPushJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
        return e;
      };
    },
    "./node_modules/lodash/_arrayReduce.js": function node_modulesLodash_arrayReduceJs(e, t) {
      e.exports = function (e, t, n, r) {
        var i = -1,
          o = null == e ? 0 : e.length;
        for (r && o && (n = e[++i]); ++i < o;) n = t(n, e[i], i, e);
        return n;
      };
    },
    "./node_modules/lodash/_arraySome.js": function node_modulesLodash_arraySomeJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
        return !1;
      };
    },
    "./node_modules/lodash/_asciiSize.js": function node_modulesLodash_asciiSizeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseProperty.js")("length");
      e.exports = r;
    },
    "./node_modules/lodash/_asciiToArray.js": function node_modulesLodash_asciiToArrayJs(e, t) {
      e.exports = function (e) {
        return e.split("");
      };
    },
    "./node_modules/lodash/_asciiWords.js": function node_modulesLodash_asciiWordsJs(e, t) {
      var n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      e.exports = function (e) {
        return e.match(n) || [];
      };
    },
    "./node_modules/lodash/_assignMergeValue.js": function node_modulesLodash_assignMergeValueJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseAssignValue.js"),
        i = n("./node_modules/lodash/eq.js");
      e.exports = function (e, t, n) {
        (void 0 !== n && !i(e[t], n) || void 0 === n && !(t in e)) && r(e, t, n);
      };
    },
    "./node_modules/lodash/_assignValue.js": function node_modulesLodash_assignValueJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseAssignValue.js"),
        i = n("./node_modules/lodash/eq.js"),
        o = Object.prototype.hasOwnProperty;
      e.exports = function (e, t, n) {
        var a = e[t];
        o.call(e, t) && i(a, n) && (void 0 !== n || t in e) || r(e, t, n);
      };
    },
    "./node_modules/lodash/_assocIndexOf.js": function node_modulesLodash_assocIndexOfJs(e, t, n) {
      var r = n("./node_modules/lodash/eq.js");
      e.exports = function (e, t) {
        for (var n = e.length; n--;) if (r(e[n][0], t)) return n;
        return -1;
      };
    },
    "./node_modules/lodash/_baseAggregator.js": function node_modulesLodash_baseAggregatorJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseEach.js");
      e.exports = function (e, t, n, i) {
        return r(e, function (e, r, o) {
          t(i, e, n(e), o);
        }), i;
      };
    },
    "./node_modules/lodash/_baseAssign.js": function node_modulesLodash_baseAssignJs(e, t, n) {
      var r = n("./node_modules/lodash/_copyObject.js"),
        i = n("./node_modules/lodash/keys.js");
      e.exports = function (e, t) {
        return e && r(t, i(t), e);
      };
    },
    "./node_modules/lodash/_baseAssignIn.js": function node_modulesLodash_baseAssignInJs(e, t, n) {
      var r = n("./node_modules/lodash/_copyObject.js"),
        i = n("./node_modules/lodash/keysIn.js");
      e.exports = function (e, t) {
        return e && r(t, i(t), e);
      };
    },
    "./node_modules/lodash/_baseAssignValue.js": function node_modulesLodash_baseAssignValueJs(e, t, n) {
      var r = n("./node_modules/lodash/_defineProperty.js");
      e.exports = function (e, t, n) {
        "__proto__" == t && r ? r(e, t, {
          configurable: !0,
          enumerable: !0,
          value: n,
          writable: !0
        }) : e[t] = n;
      };
    },
    "./node_modules/lodash/_baseClamp.js": function node_modulesLodash_baseClampJs(e, t) {
      e.exports = function (e, t, n) {
        return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
      };
    },
    "./node_modules/lodash/_baseClone.js": function node_modulesLodash_baseCloneJs(e, t, n) {
      var r = n("./node_modules/lodash/_Stack.js"),
        i = n("./node_modules/lodash/_arrayEach.js"),
        o = n("./node_modules/lodash/_assignValue.js"),
        a = n("./node_modules/lodash/_baseAssign.js"),
        s = n("./node_modules/lodash/_baseAssignIn.js"),
        l = n("./node_modules/lodash/_cloneBuffer.js"),
        u = n("./node_modules/lodash/_copyArray.js"),
        c = n("./node_modules/lodash/_copySymbols.js"),
        d = n("./node_modules/lodash/_copySymbolsIn.js"),
        h = n("./node_modules/lodash/_getAllKeys.js"),
        f = n("./node_modules/lodash/_getAllKeysIn.js"),
        p = n("./node_modules/lodash/_getTag.js"),
        m = n("./node_modules/lodash/_initCloneArray.js"),
        g = n("./node_modules/lodash/_initCloneByTag.js"),
        v = n("./node_modules/lodash/_initCloneObject.js"),
        y = n("./node_modules/lodash/isArray.js"),
        b = n("./node_modules/lodash/isBuffer.js"),
        _ = n("./node_modules/lodash/isMap.js"),
        x = n("./node_modules/lodash/isObject.js"),
        w = n("./node_modules/lodash/isSet.js"),
        S = n("./node_modules/lodash/keys.js"),
        A = {};
      A["[object Arguments]"] = A["[object Array]"] = A["[object ArrayBuffer]"] = A["[object DataView]"] = A["[object Boolean]"] = A["[object Date]"] = A["[object Float32Array]"] = A["[object Float64Array]"] = A["[object Int8Array]"] = A["[object Int16Array]"] = A["[object Int32Array]"] = A["[object Map]"] = A["[object Number]"] = A["[object Object]"] = A["[object RegExp]"] = A["[object Set]"] = A["[object String]"] = A["[object Symbol]"] = A["[object Uint8Array]"] = A["[object Uint8ClampedArray]"] = A["[object Uint16Array]"] = A["[object Uint32Array]"] = !0, A["[object Error]"] = A["[object Function]"] = A["[object WeakMap]"] = !1, e.exports = function e(t, n, E, T, M, C) {
        var k,
          P = 1 & n,
          O = 2 & n,
          R = 4 & n;
        if (E && (k = M ? E(t, T, M, C) : E(t)), void 0 !== k) return k;
        if (!x(t)) return t;
        var I = y(t);
        if (I) {
          if (k = m(t), !P) return u(t, k);
        } else {
          var j = p(t),
            N = "[object Function]" == j || "[object GeneratorFunction]" == j;
          if (b(t)) return l(t, P);
          if ("[object Object]" == j || "[object Arguments]" == j || N && !M) {
            if (k = O || N ? {} : v(t), !P) return O ? d(t, s(k, t)) : c(t, a(k, t));
          } else {
            if (!A[j]) return M ? t : {};
            k = g(t, j, P);
          }
        }
        C || (C = new r());
        var L = C.get(t);
        if (L) return L;
        C.set(t, k), w(t) ? t.forEach(function (r) {
          k.add(e(r, n, E, r, t, C));
        }) : _(t) && t.forEach(function (r, i) {
          k.set(i, e(r, n, E, i, t, C));
        });
        var D = R ? O ? f : h : O ? keysIn : S,
          B = I ? void 0 : D(t);
        return i(B || t, function (r, i) {
          B && (r = t[i = r]), o(k, i, e(r, n, E, i, t, C));
        }), k;
      };
    },
    "./node_modules/lodash/_baseCreate.js": function node_modulesLodash_baseCreateJs(e, t, n) {
      var r = n("./node_modules/lodash/isObject.js"),
        i = Object.create,
        o = function () {
          function e() {}
          return function (t) {
            if (!r(t)) return {};
            if (i) return i(t);
            e.prototype = t;
            var n = new e();
            return e.prototype = void 0, n;
          };
        }();
      e.exports = o;
    },
    "./node_modules/lodash/_baseDifference.js": function node_modulesLodash_baseDifferenceJs(e, t, n) {
      var r = n("./node_modules/lodash/_SetCache.js"),
        i = n("./node_modules/lodash/_arrayIncludes.js"),
        o = n("./node_modules/lodash/_arrayIncludesWith.js"),
        a = n("./node_modules/lodash/_arrayMap.js"),
        s = n("./node_modules/lodash/_baseUnary.js"),
        l = n("./node_modules/lodash/_cacheHas.js");
      e.exports = function (e, t, n, u) {
        var c = -1,
          d = i,
          h = !0,
          f = e.length,
          p = [],
          m = t.length;
        if (!f) return p;
        n && (t = a(t, s(n))), u ? (d = o, h = !1) : t.length >= 200 && (d = l, h = !1, t = new r(t));
        e: for (; ++c < f;) {
          var g = e[c],
            v = null == n ? g : n(g);
          if (g = u || 0 !== g ? g : 0, h && v == v) {
            for (var y = m; y--;) if (t[y] === v) continue e;
            p.push(g);
          } else d(t, v, u) || p.push(g);
        }
        return p;
      };
    },
    "./node_modules/lodash/_baseEach.js": function node_modulesLodash_baseEachJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseForOwn.js"),
        i = n("./node_modules/lodash/_createBaseEach.js")(r);
      e.exports = i;
    },
    "./node_modules/lodash/_baseEvery.js": function node_modulesLodash_baseEveryJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseEach.js");
      e.exports = function (e, t) {
        var n = !0;
        return r(e, function (e, r, i) {
          return n = !!t(e, r, i);
        }), n;
      };
    },
    "./node_modules/lodash/_baseFilter.js": function node_modulesLodash_baseFilterJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseEach.js");
      e.exports = function (e, t) {
        var n = [];
        return r(e, function (e, r, i) {
          t(e, r, i) && n.push(e);
        }), n;
      };
    },
    "./node_modules/lodash/_baseFindIndex.js": function node_modulesLodash_baseFindIndexJs(e, t) {
      e.exports = function (e, t, n, r) {
        for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) if (t(e[o], o, e)) return o;
        return -1;
      };
    },
    "./node_modules/lodash/_baseFlatten.js": function node_modulesLodash_baseFlattenJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayPush.js"),
        i = n("./node_modules/lodash/_isFlattenable.js");
      e.exports = function e(t, n, o, a, s) {
        var l = -1,
          u = t.length;
        for (o || (o = i), s || (s = []); ++l < u;) {
          var c = t[l];
          n > 0 && o(c) ? n > 1 ? e(c, n - 1, o, a, s) : r(s, c) : a || (s[s.length] = c);
        }
        return s;
      };
    },
    "./node_modules/lodash/_baseFor.js": function node_modulesLodash_baseForJs(e, t, n) {
      var r = n("./node_modules/lodash/_createBaseFor.js")();
      e.exports = r;
    },
    "./node_modules/lodash/_baseForOwn.js": function node_modulesLodash_baseForOwnJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseFor.js"),
        i = n("./node_modules/lodash/keys.js");
      e.exports = function (e, t) {
        return e && r(e, t, i);
      };
    },
    "./node_modules/lodash/_baseGet.js": function node_modulesLodash_baseGetJs(e, t, n) {
      var r = n("./node_modules/lodash/_castPath.js"),
        i = n("./node_modules/lodash/_toKey.js");
      e.exports = function (e, t) {
        for (var n = 0, o = (t = r(t, e)).length; null != e && n < o;) e = e[i(t[n++])];
        return n && n == o ? e : void 0;
      };
    },
    "./node_modules/lodash/_baseGetAllKeys.js": function node_modulesLodash_baseGetAllKeysJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayPush.js"),
        i = n("./node_modules/lodash/isArray.js");
      e.exports = function (e, t, n) {
        var o = t(e);
        return i(e) ? o : r(o, n(e));
      };
    },
    "./node_modules/lodash/_baseGetTag.js": function node_modulesLodash_baseGetTagJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = n("./node_modules/lodash/_getRawTag.js"),
        o = n("./node_modules/lodash/_objectToString.js"),
        a = r ? r.toStringTag : void 0;
      e.exports = function (e) {
        return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : a && a in Object(e) ? i(e) : o(e);
      };
    },
    "./node_modules/lodash/_baseHas.js": function node_modulesLodash_baseHasJs(e, t) {
      var n = Object.prototype.hasOwnProperty;
      e.exports = function (e, t) {
        return null != e && n.call(e, t);
      };
    },
    "./node_modules/lodash/_baseHasIn.js": function node_modulesLodash_baseHasInJs(e, t) {
      e.exports = function (e, t) {
        return null != e && t in Object(e);
      };
    },
    "./node_modules/lodash/_baseInRange.js": function node_modulesLodash_baseInRangeJs(e, t) {
      var n = Math.max,
        r = Math.min;
      e.exports = function (e, t, i) {
        return e >= r(t, i) && e < n(t, i);
      };
    },
    "./node_modules/lodash/_baseIndexOf.js": function node_modulesLodash_baseIndexOfJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseFindIndex.js"),
        i = n("./node_modules/lodash/_baseIsNaN.js"),
        o = n("./node_modules/lodash/_strictIndexOf.js");
      e.exports = function (e, t, n) {
        return t == t ? o(e, t, n) : r(e, i, n);
      };
    },
    "./node_modules/lodash/_baseIntersection.js": function node_modulesLodash_baseIntersectionJs(e, t, n) {
      var r = n("./node_modules/lodash/_SetCache.js"),
        i = n("./node_modules/lodash/_arrayIncludes.js"),
        o = n("./node_modules/lodash/_arrayIncludesWith.js"),
        a = n("./node_modules/lodash/_arrayMap.js"),
        s = n("./node_modules/lodash/_baseUnary.js"),
        l = n("./node_modules/lodash/_cacheHas.js"),
        u = Math.min;
      e.exports = function (e, t, n) {
        for (var c = n ? o : i, d = e[0].length, h = e.length, f = h, p = Array(h), m = 1 / 0, g = []; f--;) {
          var v = e[f];
          f && t && (v = a(v, s(t))), m = u(v.length, m), p[f] = !n && (t || d >= 120 && v.length >= 120) ? new r(f && v) : void 0;
        }
        v = e[0];
        var y = -1,
          b = p[0];
        e: for (; ++y < d && g.length < m;) {
          var _ = v[y],
            x = t ? t(_) : _;
          if (_ = n || 0 !== _ ? _ : 0, !(b ? l(b, x) : c(g, x, n))) {
            for (f = h; --f;) {
              var w = p[f];
              if (!(w ? l(w, x) : c(e[f], x, n))) continue e;
            }
            b && b.push(x), g.push(_);
          }
        }
        return g;
      };
    },
    "./node_modules/lodash/_baseInverter.js": function node_modulesLodash_baseInverterJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseForOwn.js");
      e.exports = function (e, t, n, i) {
        return r(e, function (e, r, o) {
          t(i, n(e), r, o);
        }), i;
      };
    },
    "./node_modules/lodash/_baseInvoke.js": function node_modulesLodash_baseInvokeJs(e, t, n) {
      var r = n("./node_modules/lodash/_apply.js"),
        i = n("./node_modules/lodash/_castPath.js"),
        o = n("./node_modules/lodash/last.js"),
        a = n("./node_modules/lodash/_parent.js"),
        s = n("./node_modules/lodash/_toKey.js");
      e.exports = function (e, t, n) {
        t = i(t, e);
        var l = null == (e = a(e, t)) ? e : e[s(o(t))];
        return null == l ? void 0 : r(l, e, n);
      };
    },
    "./node_modules/lodash/_baseIsArguments.js": function node_modulesLodash_baseIsArgumentsJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return i(e) && "[object Arguments]" == r(e);
      };
    },
    "./node_modules/lodash/_baseIsEqual.js": function node_modulesLodash_baseIsEqualJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsEqualDeep.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function e(t, n, o, a, s) {
        return t === n || (null == t || null == n || !i(t) && !i(n) ? t != t && n != n : r(t, n, o, a, e, s));
      };
    },
    "./node_modules/lodash/_baseIsEqualDeep.js": function node_modulesLodash_baseIsEqualDeepJs(e, t, n) {
      var r = n("./node_modules/lodash/_Stack.js"),
        i = n("./node_modules/lodash/_equalArrays.js"),
        o = n("./node_modules/lodash/_equalByTag.js"),
        a = n("./node_modules/lodash/_equalObjects.js"),
        s = n("./node_modules/lodash/_getTag.js"),
        l = n("./node_modules/lodash/isArray.js"),
        u = n("./node_modules/lodash/isBuffer.js"),
        c = n("./node_modules/lodash/isTypedArray.js"),
        d = "[object Object]",
        h = Object.prototype.hasOwnProperty;
      e.exports = function (e, t, n, f, p, m) {
        var g = l(e),
          v = l(t),
          y = g ? "[object Array]" : s(e),
          b = v ? "[object Array]" : s(t),
          _ = (y = "[object Arguments]" == y ? d : y) == d,
          x = (b = "[object Arguments]" == b ? d : b) == d,
          w = y == b;
        if (w && u(e)) {
          if (!u(t)) return !1;
          g = !0, _ = !1;
        }
        if (w && !_) return m || (m = new r()), g || c(e) ? i(e, t, n, f, p, m) : o(e, t, y, n, f, p, m);
        if (!(1 & n)) {
          var S = _ && h.call(e, "__wrapped__"),
            A = x && h.call(t, "__wrapped__");
          if (S || A) {
            var E = S ? e.value() : e,
              T = A ? t.value() : t;
            return m || (m = new r()), p(E, T, n, f, m);
          }
        }
        return !!w && (m || (m = new r()), a(e, t, n, f, p, m));
      };
    },
    "./node_modules/lodash/_baseIsMap.js": function node_modulesLodash_baseIsMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_getTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return i(e) && "[object Map]" == r(e);
      };
    },
    "./node_modules/lodash/_baseIsMatch.js": function node_modulesLodash_baseIsMatchJs(e, t, n) {
      var r = n("./node_modules/lodash/_Stack.js"),
        i = n("./node_modules/lodash/_baseIsEqual.js");
      e.exports = function (e, t, n, o) {
        var a = n.length,
          s = a,
          l = !o;
        if (null == e) return !s;
        for (e = Object(e); a--;) {
          var u = n[a];
          if (l && u[2] ? u[1] !== e[u[0]] : !(u[0] in e)) return !1;
        }
        for (; ++a < s;) {
          var c = (u = n[a])[0],
            d = e[c],
            h = u[1];
          if (l && u[2]) {
            if (void 0 === d && !(c in e)) return !1;
          } else {
            var f = new r();
            if (o) var p = o(d, h, c, e, t, f);
            if (!(void 0 === p ? i(h, d, 3, o, f) : p)) return !1;
          }
        }
        return !0;
      };
    },
    "./node_modules/lodash/_baseIsNaN.js": function node_modulesLodash_baseIsNaNJs(e, t) {
      e.exports = function (e) {
        return e != e;
      };
    },
    "./node_modules/lodash/_baseIsNative.js": function node_modulesLodash_baseIsNativeJs(e, t, n) {
      var r = n("./node_modules/lodash/isFunction.js"),
        i = n("./node_modules/lodash/_isMasked.js"),
        o = n("./node_modules/lodash/isObject.js"),
        a = n("./node_modules/lodash/_toSource.js"),
        s = /^\[object .+?Constructor\]$/,
        l = Function.prototype,
        u = Object.prototype,
        c = l.toString,
        d = u.hasOwnProperty,
        h = RegExp("^" + c.call(d).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      e.exports = function (e) {
        return !(!o(e) || i(e)) && (r(e) ? h : s).test(a(e));
      };
    },
    "./node_modules/lodash/_baseIsRegExp.js": function node_modulesLodash_baseIsRegExpJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return i(e) && "[object RegExp]" == r(e);
      };
    },
    "./node_modules/lodash/_baseIsSet.js": function node_modulesLodash_baseIsSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_getTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return i(e) && "[object Set]" == r(e);
      };
    },
    "./node_modules/lodash/_baseIsTypedArray.js": function node_modulesLodash_baseIsTypedArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isLength.js"),
        o = n("./node_modules/lodash/isObjectLike.js"),
        a = {};
      a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, e.exports = function (e) {
        return o(e) && i(e.length) && !!a[r(e)];
      };
    },
    "./node_modules/lodash/_baseIteratee.js": function node_modulesLodash_baseIterateeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseMatches.js"),
        i = n("./node_modules/lodash/_baseMatchesProperty.js"),
        o = n("./node_modules/lodash/identity.js"),
        a = n("./node_modules/lodash/isArray.js"),
        s = n("./node_modules/lodash/property.js");
      e.exports = function (e) {
        return "function" == typeof e ? e : null == e ? o : "object" == typeof e ? a(e) ? i(e[0], e[1]) : r(e) : s(e);
      };
    },
    "./node_modules/lodash/_baseKeys.js": function node_modulesLodash_baseKeysJs(e, t, n) {
      var r = n("./node_modules/lodash/_isPrototype.js"),
        i = n("./node_modules/lodash/_nativeKeys.js"),
        o = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        if (!r(e)) return i(e);
        var t = [];
        for (var n in Object(e)) o.call(e, n) && "constructor" != n && t.push(n);
        return t;
      };
    },
    "./node_modules/lodash/_baseKeysIn.js": function node_modulesLodash_baseKeysInJs(e, t, n) {
      var r = n("./node_modules/lodash/isObject.js"),
        i = n("./node_modules/lodash/_isPrototype.js"),
        o = n("./node_modules/lodash/_nativeKeysIn.js"),
        a = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        if (!r(e)) return o(e);
        var t = i(e),
          n = [];
        for (var s in e) ("constructor" != s || !t && a.call(e, s)) && n.push(s);
        return n;
      };
    },
    "./node_modules/lodash/_baseLodash.js": function node_modulesLodash_baseLodashJs(e, t) {
      e.exports = function () {};
    },
    "./node_modules/lodash/_baseMap.js": function node_modulesLodash_baseMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseEach.js"),
        i = n("./node_modules/lodash/isArrayLike.js");
      e.exports = function (e, t) {
        var n = -1,
          o = i(e) ? Array(e.length) : [];
        return r(e, function (e, r, i) {
          o[++n] = t(e, r, i);
        }), o;
      };
    },
    "./node_modules/lodash/_baseMatches.js": function node_modulesLodash_baseMatchesJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsMatch.js"),
        i = n("./node_modules/lodash/_getMatchData.js"),
        o = n("./node_modules/lodash/_matchesStrictComparable.js");
      e.exports = function (e) {
        var t = i(e);
        return 1 == t.length && t[0][2] ? o(t[0][0], t[0][1]) : function (n) {
          return n === e || r(n, e, t);
        };
      };
    },
    "./node_modules/lodash/_baseMatchesProperty.js": function node_modulesLodash_baseMatchesPropertyJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsEqual.js"),
        i = n("./node_modules/lodash/get.js"),
        o = n("./node_modules/lodash/hasIn.js"),
        a = n("./node_modules/lodash/_isKey.js"),
        s = n("./node_modules/lodash/_isStrictComparable.js"),
        l = n("./node_modules/lodash/_matchesStrictComparable.js"),
        u = n("./node_modules/lodash/_toKey.js");
      e.exports = function (e, t) {
        return a(e) && s(t) ? l(u(e), t) : function (n) {
          var a = i(n, e);
          return void 0 === a && a === t ? o(n, e) : r(t, a, 3);
        };
      };
    },
    "./node_modules/lodash/_baseMerge.js": function node_modulesLodash_baseMergeJs(e, t, n) {
      var r = n("./node_modules/lodash/_Stack.js"),
        i = n("./node_modules/lodash/_assignMergeValue.js"),
        o = n("./node_modules/lodash/_baseFor.js"),
        a = n("./node_modules/lodash/_baseMergeDeep.js"),
        s = n("./node_modules/lodash/isObject.js"),
        l = n("./node_modules/lodash/keysIn.js"),
        u = n("./node_modules/lodash/_safeGet.js");
      e.exports = function e(t, n, c, d, h) {
        t !== n && o(n, function (o, l) {
          if (h || (h = new r()), s(o)) a(t, n, l, c, e, d, h);else {
            var f = d ? d(u(t, l), o, l + "", t, n, h) : void 0;
            void 0 === f && (f = o), i(t, l, f);
          }
        }, l);
      };
    },
    "./node_modules/lodash/_baseMergeDeep.js": function node_modulesLodash_baseMergeDeepJs(e, t, n) {
      var r = n("./node_modules/lodash/_assignMergeValue.js"),
        i = n("./node_modules/lodash/_cloneBuffer.js"),
        o = n("./node_modules/lodash/_cloneTypedArray.js"),
        a = n("./node_modules/lodash/_copyArray.js"),
        s = n("./node_modules/lodash/_initCloneObject.js"),
        l = n("./node_modules/lodash/isArguments.js"),
        u = n("./node_modules/lodash/isArray.js"),
        c = n("./node_modules/lodash/isArrayLikeObject.js"),
        d = n("./node_modules/lodash/isBuffer.js"),
        h = n("./node_modules/lodash/isFunction.js"),
        f = n("./node_modules/lodash/isObject.js"),
        p = n("./node_modules/lodash/isPlainObject.js"),
        m = n("./node_modules/lodash/isTypedArray.js"),
        g = n("./node_modules/lodash/_safeGet.js"),
        v = n("./node_modules/lodash/toPlainObject.js");
      e.exports = function (e, t, n, y, b, _, x) {
        var w = g(e, n),
          S = g(t, n),
          A = x.get(S);
        if (A) r(e, n, A);else {
          var E = _ ? _(w, S, n + "", e, t, x) : void 0,
            T = void 0 === E;
          if (T) {
            var M = u(S),
              C = !M && d(S),
              k = !M && !C && m(S);
            E = S, M || C || k ? u(w) ? E = w : c(w) ? E = a(w) : C ? (T = !1, E = i(S, !0)) : k ? (T = !1, E = o(S, !0)) : E = [] : p(S) || l(S) ? (E = w, l(w) ? E = v(w) : f(w) && !h(w) || (E = s(S))) : T = !1;
          }
          T && (x.set(S, E), b(E, S, y, _, x), x.delete(S)), r(e, n, E);
        }
      };
    },
    "./node_modules/lodash/_basePick.js": function node_modulesLodash_basePickJs(e, t, n) {
      var r = n("./node_modules/lodash/_basePickBy.js"),
        i = n("./node_modules/lodash/hasIn.js");
      e.exports = function (e, t) {
        return r(e, t, function (t, n) {
          return i(e, n);
        });
      };
    },
    "./node_modules/lodash/_basePickBy.js": function node_modulesLodash_basePickByJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGet.js"),
        i = n("./node_modules/lodash/_baseSet.js"),
        o = n("./node_modules/lodash/_castPath.js");
      e.exports = function (e, t, n) {
        for (var a = -1, s = t.length, l = {}; ++a < s;) {
          var u = t[a],
            c = r(e, u);
          n(c, u) && i(l, o(u, e), c);
        }
        return l;
      };
    },
    "./node_modules/lodash/_baseProperty.js": function node_modulesLodash_basePropertyJs(e, t) {
      e.exports = function (e) {
        return function (t) {
          return null == t ? void 0 : t[e];
        };
      };
    },
    "./node_modules/lodash/_basePropertyDeep.js": function node_modulesLodash_basePropertyDeepJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGet.js");
      e.exports = function (e) {
        return function (t) {
          return r(t, e);
        };
      };
    },
    "./node_modules/lodash/_basePropertyOf.js": function node_modulesLodash_basePropertyOfJs(e, t) {
      e.exports = function (e) {
        return function (t) {
          return null == e ? void 0 : e[t];
        };
      };
    },
    "./node_modules/lodash/_baseRange.js": function node_modulesLodash_baseRangeJs(e, t) {
      var n = Math.ceil,
        r = Math.max;
      e.exports = function (e, t, i, o) {
        for (var a = -1, s = r(n((t - e) / (i || 1)), 0), l = Array(s); s--;) l[o ? s : ++a] = e, e += i;
        return l;
      };
    },
    "./node_modules/lodash/_baseReduce.js": function node_modulesLodash_baseReduceJs(e, t) {
      e.exports = function (e, t, n, r, i) {
        return i(e, function (e, i, o) {
          n = r ? (r = !1, e) : t(n, e, i, o);
        }), n;
      };
    },
    "./node_modules/lodash/_baseRest.js": function node_modulesLodash_baseRestJs(e, t, n) {
      var r = n("./node_modules/lodash/identity.js"),
        i = n("./node_modules/lodash/_overRest.js"),
        o = n("./node_modules/lodash/_setToString.js");
      e.exports = function (e, t) {
        return o(i(e, t, r), e + "");
      };
    },
    "./node_modules/lodash/_baseSet.js": function node_modulesLodash_baseSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_assignValue.js"),
        i = n("./node_modules/lodash/_castPath.js"),
        o = n("./node_modules/lodash/_isIndex.js"),
        a = n("./node_modules/lodash/isObject.js"),
        s = n("./node_modules/lodash/_toKey.js");
      e.exports = function (e, t, n, l) {
        if (!a(e)) return e;
        for (var u = -1, c = (t = i(t, e)).length, d = c - 1, h = e; null != h && ++u < c;) {
          var f = s(t[u]),
            p = n;
          if (u != d) {
            var m = h[f];
            void 0 === (p = l ? l(m, f, h) : void 0) && (p = a(m) ? m : o(t[u + 1]) ? [] : {});
          }
          r(h, f, p), h = h[f];
        }
        return e;
      };
    },
    "./node_modules/lodash/_baseSetData.js": function node_modulesLodash_baseSetDataJs(e, t, n) {
      var r = n("./node_modules/lodash/identity.js"),
        i = n("./node_modules/lodash/_metaMap.js"),
        o = i ? function (e, t) {
          return i.set(e, t), e;
        } : r;
      e.exports = o;
    },
    "./node_modules/lodash/_baseSetToString.js": function node_modulesLodash_baseSetToStringJs(e, t, n) {
      var r = n("./node_modules/lodash/constant.js"),
        i = n("./node_modules/lodash/_defineProperty.js"),
        o = n("./node_modules/lodash/identity.js"),
        a = i ? function (e, t) {
          return i(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: r(t),
            writable: !0
          });
        } : o;
      e.exports = a;
    },
    "./node_modules/lodash/_baseSlice.js": function node_modulesLodash_baseSliceJs(e, t) {
      e.exports = function (e, t, n) {
        var r = -1,
          i = e.length;
        t < 0 && (t = -t > i ? 0 : i + t), (n = n > i ? i : n) < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
        for (var o = Array(i); ++r < i;) o[r] = e[r + t];
        return o;
      };
    },
    "./node_modules/lodash/_baseSome.js": function node_modulesLodash_baseSomeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseEach.js");
      e.exports = function (e, t) {
        var n;
        return r(e, function (e, r, i) {
          return !(n = t(e, r, i));
        }), !!n;
      };
    },
    "./node_modules/lodash/_baseTimes.js": function node_modulesLodash_baseTimesJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
        return r;
      };
    },
    "./node_modules/lodash/_baseToString.js": function node_modulesLodash_baseToStringJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = n("./node_modules/lodash/_arrayMap.js"),
        o = n("./node_modules/lodash/isArray.js"),
        a = n("./node_modules/lodash/isSymbol.js"),
        s = r ? r.prototype : void 0,
        l = s ? s.toString : void 0;
      e.exports = function e(t) {
        if ("string" == typeof t) return t;
        if (o(t)) return i(t, e) + "";
        if (a(t)) return l ? l.call(t) : "";
        var n = t + "";
        return "0" == n && 1 / t == -1 / 0 ? "-0" : n;
      };
    },
    "./node_modules/lodash/_baseUnary.js": function node_modulesLodash_baseUnaryJs(e, t) {
      e.exports = function (e) {
        return function (t) {
          return e(t);
        };
      };
    },
    "./node_modules/lodash/_baseUniq.js": function node_modulesLodash_baseUniqJs(e, t, n) {
      var r = n("./node_modules/lodash/_SetCache.js"),
        i = n("./node_modules/lodash/_arrayIncludes.js"),
        o = n("./node_modules/lodash/_arrayIncludesWith.js"),
        a = n("./node_modules/lodash/_cacheHas.js"),
        s = n("./node_modules/lodash/_createSet.js"),
        l = n("./node_modules/lodash/_setToArray.js");
      e.exports = function (e, t, n) {
        var u = -1,
          c = i,
          d = e.length,
          h = !0,
          f = [],
          p = f;
        if (n) h = !1, c = o;else if (d >= 200) {
          var m = t ? null : s(e);
          if (m) return l(m);
          h = !1, c = a, p = new r();
        } else p = t ? [] : f;
        e: for (; ++u < d;) {
          var g = e[u],
            v = t ? t(g) : g;
          if (g = n || 0 !== g ? g : 0, h && v == v) {
            for (var y = p.length; y--;) if (p[y] === v) continue e;
            t && p.push(v), f.push(g);
          } else c(p, v, n) || (p !== f && p.push(v), f.push(g));
        }
        return f;
      };
    },
    "./node_modules/lodash/_baseValues.js": function node_modulesLodash_baseValuesJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayMap.js");
      e.exports = function (e, t) {
        return r(t, function (t) {
          return e[t];
        });
      };
    },
    "./node_modules/lodash/_cacheHas.js": function node_modulesLodash_cacheHasJs(e, t) {
      e.exports = function (e, t) {
        return e.has(t);
      };
    },
    "./node_modules/lodash/_castArrayLikeObject.js": function node_modulesLodash_castArrayLikeObjectJs(e, t, n) {
      var r = n("./node_modules/lodash/isArrayLikeObject.js");
      e.exports = function (e) {
        return r(e) ? e : [];
      };
    },
    "./node_modules/lodash/_castFunction.js": function node_modulesLodash_castFunctionJs(e, t, n) {
      var r = n("./node_modules/lodash/identity.js");
      e.exports = function (e) {
        return "function" == typeof e ? e : r;
      };
    },
    "./node_modules/lodash/_castPath.js": function node_modulesLodash_castPathJs(e, t, n) {
      var r = n("./node_modules/lodash/isArray.js"),
        i = n("./node_modules/lodash/_isKey.js"),
        o = n("./node_modules/lodash/_stringToPath.js"),
        a = n("./node_modules/lodash/toString.js");
      e.exports = function (e, t) {
        return r(e) ? e : i(e, t) ? [e] : o(a(e));
      };
    },
    "./node_modules/lodash/_castSlice.js": function node_modulesLodash_castSliceJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseSlice.js");
      e.exports = function (e, t, n) {
        var i = e.length;
        return n = void 0 === n ? i : n, !t && n >= i ? e : r(e, t, n);
      };
    },
    "./node_modules/lodash/_cloneArrayBuffer.js": function node_modulesLodash_cloneArrayBufferJs(e, t, n) {
      var r = n("./node_modules/lodash/_Uint8Array.js");
      e.exports = function (e) {
        var t = new e.constructor(e.byteLength);
        return new r(t).set(new r(e)), t;
      };
    },
    "./node_modules/lodash/_cloneBuffer.js": function node_modulesLodash_cloneBufferJs(e, t, n) {
      (function (e) {
        var r = n("./node_modules/lodash/_root.js"),
          i = t && !t.nodeType && t,
          o = i && "object" == typeof e && e && !e.nodeType && e,
          a = o && o.exports === i ? r.Buffer : void 0,
          s = a ? a.allocUnsafe : void 0;
        e.exports = function (e, t) {
          if (t) return e.slice();
          var n = e.length,
            r = s ? s(n) : new e.constructor(n);
          return e.copy(r), r;
        };
      }).call(this, n("./node_modules/webpack/buildin/module.js")(e));
    },
    "./node_modules/lodash/_cloneDataView.js": function node_modulesLodash_cloneDataViewJs(e, t, n) {
      var r = n("./node_modules/lodash/_cloneArrayBuffer.js");
      e.exports = function (e, t) {
        var n = t ? r(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.byteLength);
      };
    },
    "./node_modules/lodash/_cloneRegExp.js": function node_modulesLodash_cloneRegExpJs(e, t) {
      var n = /\w*$/;
      e.exports = function (e) {
        var t = new e.constructor(e.source, n.exec(e));
        return t.lastIndex = e.lastIndex, t;
      };
    },
    "./node_modules/lodash/_cloneSymbol.js": function node_modulesLodash_cloneSymbolJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = r ? r.prototype : void 0,
        o = i ? i.valueOf : void 0;
      e.exports = function (e) {
        return o ? Object(o.call(e)) : {};
      };
    },
    "./node_modules/lodash/_cloneTypedArray.js": function node_modulesLodash_cloneTypedArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/_cloneArrayBuffer.js");
      e.exports = function (e, t) {
        var n = t ? r(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.length);
      };
    },
    "./node_modules/lodash/_composeArgs.js": function node_modulesLodash_composeArgsJs(e, t) {
      var n = Math.max;
      e.exports = function (e, t, r, i) {
        for (var o = -1, a = e.length, s = r.length, l = -1, u = t.length, c = n(a - s, 0), d = Array(u + c), h = !i; ++l < u;) d[l] = t[l];
        for (; ++o < s;) (h || o < a) && (d[r[o]] = e[o]);
        for (; c--;) d[l++] = e[o++];
        return d;
      };
    },
    "./node_modules/lodash/_composeArgsRight.js": function node_modulesLodash_composeArgsRightJs(e, t) {
      var n = Math.max;
      e.exports = function (e, t, r, i) {
        for (var o = -1, a = e.length, s = -1, l = r.length, u = -1, c = t.length, d = n(a - l, 0), h = Array(d + c), f = !i; ++o < d;) h[o] = e[o];
        for (var p = o; ++u < c;) h[p + u] = t[u];
        for (; ++s < l;) (f || o < a) && (h[p + r[s]] = e[o++]);
        return h;
      };
    },
    "./node_modules/lodash/_copyArray.js": function node_modulesLodash_copyArrayJs(e, t) {
      e.exports = function (e, t) {
        var n = -1,
          r = e.length;
        for (t || (t = Array(r)); ++n < r;) t[n] = e[n];
        return t;
      };
    },
    "./node_modules/lodash/_copyObject.js": function node_modulesLodash_copyObjectJs(e, t, n) {
      var r = n("./node_modules/lodash/_assignValue.js"),
        i = n("./node_modules/lodash/_baseAssignValue.js");
      e.exports = function (e, t, n, o) {
        var a = !n;
        n || (n = {});
        for (var s = -1, l = t.length; ++s < l;) {
          var u = t[s],
            c = o ? o(n[u], e[u], u, n, e) : void 0;
          void 0 === c && (c = e[u]), a ? i(n, u, c) : r(n, u, c);
        }
        return n;
      };
    },
    "./node_modules/lodash/_copySymbols.js": function node_modulesLodash_copySymbolsJs(e, t, n) {
      var r = n("./node_modules/lodash/_copyObject.js"),
        i = n("./node_modules/lodash/_getSymbols.js");
      e.exports = function (e, t) {
        return r(e, i(e), t);
      };
    },
    "./node_modules/lodash/_copySymbolsIn.js": function node_modulesLodash_copySymbolsInJs(e, t, n) {
      var r = n("./node_modules/lodash/_copyObject.js"),
        i = n("./node_modules/lodash/_getSymbolsIn.js");
      e.exports = function (e, t) {
        return r(e, i(e), t);
      };
    },
    "./node_modules/lodash/_coreJsData.js": function node_modulesLodash_coreJsDataJs(e, t, n) {
      var r = n("./node_modules/lodash/_root.js")["__core-js_shared__"];
      e.exports = r;
    },
    "./node_modules/lodash/_countHolders.js": function node_modulesLodash_countHoldersJs(e, t) {
      e.exports = function (e, t) {
        for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
        return r;
      };
    },
    "./node_modules/lodash/_createAggregator.js": function node_modulesLodash_createAggregatorJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayAggregator.js"),
        i = n("./node_modules/lodash/_baseAggregator.js"),
        o = n("./node_modules/lodash/_baseIteratee.js"),
        a = n("./node_modules/lodash/isArray.js");
      e.exports = function (e, t) {
        return function (n, s) {
          var l = a(n) ? r : i,
            u = t ? t() : {};
          return l(n, e, o(s, 2), u);
        };
      };
    },
    "./node_modules/lodash/_createAssigner.js": function node_modulesLodash_createAssignerJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseRest.js"),
        i = n("./node_modules/lodash/_isIterateeCall.js");
      e.exports = function (e) {
        return r(function (t, n) {
          var r = -1,
            o = n.length,
            a = o > 1 ? n[o - 1] : void 0,
            s = o > 2 ? n[2] : void 0;
          for (a = e.length > 3 && "function" == typeof a ? (o--, a) : void 0, s && i(n[0], n[1], s) && (a = o < 3 ? void 0 : a, o = 1), t = Object(t); ++r < o;) {
            var l = n[r];
            l && e(t, l, r, a);
          }
          return t;
        });
      };
    },
    "./node_modules/lodash/_createBaseEach.js": function node_modulesLodash_createBaseEachJs(e, t, n) {
      var r = n("./node_modules/lodash/isArrayLike.js");
      e.exports = function (e, t) {
        return function (n, i) {
          if (null == n) return n;
          if (!r(n)) return e(n, i);
          for (var o = n.length, a = t ? o : -1, s = Object(n); (t ? a-- : ++a < o) && !1 !== i(s[a], a, s););
          return n;
        };
      };
    },
    "./node_modules/lodash/_createBaseFor.js": function node_modulesLodash_createBaseForJs(e, t) {
      e.exports = function (e) {
        return function (t, n, r) {
          for (var i = -1, o = Object(t), a = r(t), s = a.length; s--;) {
            var l = a[e ? s : ++i];
            if (!1 === n(o[l], l, o)) break;
          }
          return t;
        };
      };
    },
    "./node_modules/lodash/_createBind.js": function node_modulesLodash_createBindJs(e, t, n) {
      var r = n("./node_modules/lodash/_createCtor.js"),
        i = n("./node_modules/lodash/_root.js");
      e.exports = function (e, t, n) {
        var o = 1 & t,
          a = r(e);
        return function t() {
          var r = this && this !== i && this instanceof t ? a : e;
          return r.apply(o ? n : this, arguments);
        };
      };
    },
    "./node_modules/lodash/_createCaseFirst.js": function node_modulesLodash_createCaseFirstJs(e, t, n) {
      var r = n("./node_modules/lodash/_castSlice.js"),
        i = n("./node_modules/lodash/_hasUnicode.js"),
        o = n("./node_modules/lodash/_stringToArray.js"),
        a = n("./node_modules/lodash/toString.js");
      e.exports = function (e) {
        return function (t) {
          t = a(t);
          var n = i(t) ? o(t) : void 0,
            s = n ? n[0] : t.charAt(0),
            l = n ? r(n, 1).join("") : t.slice(1);
          return s[e]() + l;
        };
      };
    },
    "./node_modules/lodash/_createCompounder.js": function node_modulesLodash_createCompounderJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayReduce.js"),
        i = n("./node_modules/lodash/deburr.js"),
        o = n("./node_modules/lodash/words.js"),
        a = RegExp("['’]", "g");
      e.exports = function (e) {
        return function (t) {
          return r(o(i(t).replace(a, "")), e, "");
        };
      };
    },
    "./node_modules/lodash/_createCtor.js": function node_modulesLodash_createCtorJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseCreate.js"),
        i = n("./node_modules/lodash/isObject.js");
      e.exports = function (e) {
        return function () {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var n = r(e.prototype),
            o = e.apply(n, t);
          return i(o) ? o : n;
        };
      };
    },
    "./node_modules/lodash/_createCurry.js": function node_modulesLodash_createCurryJs(e, t, n) {
      var r = n("./node_modules/lodash/_apply.js"),
        i = n("./node_modules/lodash/_createCtor.js"),
        o = n("./node_modules/lodash/_createHybrid.js"),
        a = n("./node_modules/lodash/_createRecurry.js"),
        s = n("./node_modules/lodash/_getHolder.js"),
        l = n("./node_modules/lodash/_replaceHolders.js"),
        u = n("./node_modules/lodash/_root.js");
      e.exports = function (e, t, n) {
        var c = i(e);
        return function i() {
          for (var d = arguments.length, h = Array(d), f = d, p = s(i); f--;) h[f] = arguments[f];
          var m = d < 3 && h[0] !== p && h[d - 1] !== p ? [] : l(h, p);
          if ((d -= m.length) < n) return a(e, t, o, i.placeholder, void 0, h, m, void 0, void 0, n - d);
          var g = this && this !== u && this instanceof i ? c : e;
          return r(g, this, h);
        };
      };
    },
    "./node_modules/lodash/_createFind.js": function node_modulesLodash_createFindJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIteratee.js"),
        i = n("./node_modules/lodash/isArrayLike.js"),
        o = n("./node_modules/lodash/keys.js");
      e.exports = function (e) {
        return function (t, n, a) {
          var s = Object(t);
          if (!i(t)) {
            var l = r(n, 3);
            t = o(t), n = function n(e) {
              return l(s[e], e, s);
            };
          }
          var u = e(t, n, a);
          return u > -1 ? s[l ? t[u] : u] : void 0;
        };
      };
    },
    "./node_modules/lodash/_createFlow.js": function node_modulesLodash_createFlowJs(e, t, n) {
      var r = n("./node_modules/lodash/_LodashWrapper.js"),
        i = n("./node_modules/lodash/_flatRest.js"),
        o = n("./node_modules/lodash/_getData.js"),
        a = n("./node_modules/lodash/_getFuncName.js"),
        s = n("./node_modules/lodash/isArray.js"),
        l = n("./node_modules/lodash/_isLaziable.js");
      e.exports = function (e) {
        return i(function (t) {
          var n = t.length,
            i = n,
            u = r.prototype.thru;
          for (e && t.reverse(); i--;) {
            var c = t[i];
            if ("function" != typeof c) throw new TypeError("Expected a function");
            if (u && !d && "wrapper" == a(c)) var d = new r([], !0);
          }
          for (i = d ? i : n; ++i < n;) {
            c = t[i];
            var h = a(c),
              f = "wrapper" == h ? o(c) : void 0;
            d = f && l(f[0]) && 424 == f[1] && !f[4].length && 1 == f[9] ? d[a(f[0])].apply(d, f[3]) : 1 == c.length && l(c) ? d[h]() : d.thru(c);
          }
          return function () {
            var e = arguments,
              r = e[0];
            if (d && 1 == e.length && s(r)) return d.plant(r).value();
            for (var i = 0, o = n ? t[i].apply(this, e) : r; ++i < n;) o = t[i].call(this, o);
            return o;
          };
        });
      };
    },
    "./node_modules/lodash/_createHybrid.js": function node_modulesLodash_createHybridJs(e, t, n) {
      var r = n("./node_modules/lodash/_composeArgs.js"),
        i = n("./node_modules/lodash/_composeArgsRight.js"),
        o = n("./node_modules/lodash/_countHolders.js"),
        a = n("./node_modules/lodash/_createCtor.js"),
        s = n("./node_modules/lodash/_createRecurry.js"),
        l = n("./node_modules/lodash/_getHolder.js"),
        u = n("./node_modules/lodash/_reorder.js"),
        c = n("./node_modules/lodash/_replaceHolders.js"),
        d = n("./node_modules/lodash/_root.js");
      e.exports = function e(t, n, h, f, p, m, g, v, y, b) {
        var _ = 128 & n,
          x = 1 & n,
          w = 2 & n,
          S = 24 & n,
          A = 512 & n,
          E = w ? void 0 : a(t);
        return function T() {
          for (var M = arguments.length, C = Array(M), k = M; k--;) C[k] = arguments[k];
          if (S) var P = l(T),
            O = o(C, P);
          if (f && (C = r(C, f, p, S)), m && (C = i(C, m, g, S)), M -= O, S && M < b) {
            var R = c(C, P);
            return s(t, n, e, T.placeholder, h, C, R, v, y, b - M);
          }
          var I = x ? h : this,
            j = w ? I[t] : t;
          return M = C.length, v ? C = u(C, v) : A && M > 1 && C.reverse(), _ && y < M && (C.length = y), this && this !== d && this instanceof T && (j = E || a(j)), j.apply(I, C);
        };
      };
    },
    "./node_modules/lodash/_createInverter.js": function node_modulesLodash_createInverterJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseInverter.js");
      e.exports = function (e, t) {
        return function (n, i) {
          return r(n, e, t(i), {});
        };
      };
    },
    "./node_modules/lodash/_createPartial.js": function node_modulesLodash_createPartialJs(e, t, n) {
      var r = n("./node_modules/lodash/_apply.js"),
        i = n("./node_modules/lodash/_createCtor.js"),
        o = n("./node_modules/lodash/_root.js");
      e.exports = function (e, t, n, a) {
        var s = 1 & t,
          l = i(e);
        return function t() {
          for (var i = -1, u = arguments.length, c = -1, d = a.length, h = Array(d + u), f = this && this !== o && this instanceof t ? l : e; ++c < d;) h[c] = a[c];
          for (; u--;) h[c++] = arguments[++i];
          return r(f, s ? n : this, h);
        };
      };
    },
    "./node_modules/lodash/_createRange.js": function node_modulesLodash_createRangeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseRange.js"),
        i = n("./node_modules/lodash/_isIterateeCall.js"),
        o = n("./node_modules/lodash/toFinite.js");
      e.exports = function (e) {
        return function (t, n, a) {
          return a && "number" != typeof a && i(t, n, a) && (n = a = void 0), t = o(t), void 0 === n ? (n = t, t = 0) : n = o(n), a = void 0 === a ? t < n ? 1 : -1 : o(a), r(t, n, a, e);
        };
      };
    },
    "./node_modules/lodash/_createRecurry.js": function node_modulesLodash_createRecurryJs(e, t, n) {
      var r = n("./node_modules/lodash/_isLaziable.js"),
        i = n("./node_modules/lodash/_setData.js"),
        o = n("./node_modules/lodash/_setWrapToString.js");
      e.exports = function (e, t, n, a, s, l, u, c, d, h) {
        var f = 8 & t;
        t |= f ? 32 : 64, 4 & (t &= ~(f ? 64 : 32)) || (t &= -4);
        var p = [e, t, s, f ? l : void 0, f ? u : void 0, f ? void 0 : l, f ? void 0 : u, c, d, h],
          m = n.apply(void 0, p);
        return r(e) && i(m, p), m.placeholder = a, o(m, e, t);
      };
    },
    "./node_modules/lodash/_createRound.js": function node_modulesLodash_createRoundJs(e, t, n) {
      var r = n("./node_modules/lodash/_root.js"),
        i = n("./node_modules/lodash/toInteger.js"),
        o = n("./node_modules/lodash/toNumber.js"),
        a = n("./node_modules/lodash/toString.js"),
        s = r.isFinite,
        l = Math.min;
      e.exports = function (e) {
        var t = Math[e];
        return function (e, n) {
          if (e = o(e), (n = null == n ? 0 : l(i(n), 292)) && s(e)) {
            var r = (a(e) + "e").split("e"),
              u = t(r[0] + "e" + (+r[1] + n));
            return +((r = (a(u) + "e").split("e"))[0] + "e" + (+r[1] - n));
          }
          return t(e);
        };
      };
    },
    "./node_modules/lodash/_createSet.js": function node_modulesLodash_createSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_Set.js"),
        i = n("./node_modules/lodash/noop.js"),
        o = n("./node_modules/lodash/_setToArray.js"),
        a = r && 1 / o(new r([, -0]))[1] == 1 / 0 ? function (e) {
          return new r(e);
        } : i;
      e.exports = a;
    },
    "./node_modules/lodash/_createWrap.js": function node_modulesLodash_createWrapJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseSetData.js"),
        i = n("./node_modules/lodash/_createBind.js"),
        o = n("./node_modules/lodash/_createCurry.js"),
        a = n("./node_modules/lodash/_createHybrid.js"),
        s = n("./node_modules/lodash/_createPartial.js"),
        l = n("./node_modules/lodash/_getData.js"),
        u = n("./node_modules/lodash/_mergeData.js"),
        c = n("./node_modules/lodash/_setData.js"),
        d = n("./node_modules/lodash/_setWrapToString.js"),
        h = n("./node_modules/lodash/toInteger.js"),
        f = Math.max;
      e.exports = function (e, t, n, p, m, g, v, y) {
        var b = 2 & t;
        if (!b && "function" != typeof e) throw new TypeError("Expected a function");
        var _ = p ? p.length : 0;
        if (_ || (t &= -97, p = m = void 0), v = void 0 === v ? v : f(h(v), 0), y = void 0 === y ? y : h(y), _ -= m ? m.length : 0, 64 & t) {
          var x = p,
            w = m;
          p = m = void 0;
        }
        var S = b ? void 0 : l(e),
          A = [e, t, n, p, m, x, w, g, v, y];
        if (S && u(A, S), e = A[0], t = A[1], n = A[2], p = A[3], m = A[4], !(y = A[9] = void 0 === A[9] ? b ? 0 : e.length : f(A[9] - _, 0)) && 24 & t && (t &= -25), t && 1 != t) E = 8 == t || 16 == t ? o(e, t, y) : 32 != t && 33 != t || m.length ? a.apply(void 0, A) : s(e, t, n, p);else var E = i(e, t, n);
        return d((S ? r : c)(E, A), e, t);
      };
    },
    "./node_modules/lodash/_deburrLetter.js": function node_modulesLodash_deburrLetterJs(e, t, n) {
      var r = n("./node_modules/lodash/_basePropertyOf.js")({
        "À": "A",
        "Á": "A",
        "Â": "A",
        "Ã": "A",
        "Ä": "A",
        "Å": "A",
        "à": "a",
        "á": "a",
        "â": "a",
        "ã": "a",
        "ä": "a",
        "å": "a",
        "Ç": "C",
        "ç": "c",
        "Ð": "D",
        "ð": "d",
        "È": "E",
        "É": "E",
        "Ê": "E",
        "Ë": "E",
        "è": "e",
        "é": "e",
        "ê": "e",
        "ë": "e",
        "Ì": "I",
        "Í": "I",
        "Î": "I",
        "Ï": "I",
        "ì": "i",
        "í": "i",
        "î": "i",
        "ï": "i",
        "Ñ": "N",
        "ñ": "n",
        "Ò": "O",
        "Ó": "O",
        "Ô": "O",
        "Õ": "O",
        "Ö": "O",
        "Ø": "O",
        "ò": "o",
        "ó": "o",
        "ô": "o",
        "õ": "o",
        "ö": "o",
        "ø": "o",
        "Ù": "U",
        "Ú": "U",
        "Û": "U",
        "Ü": "U",
        "ù": "u",
        "ú": "u",
        "û": "u",
        "ü": "u",
        "Ý": "Y",
        "ý": "y",
        "ÿ": "y",
        "Æ": "Ae",
        "æ": "ae",
        "Þ": "Th",
        "þ": "th",
        "ß": "ss",
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
      });
      e.exports = r;
    },
    "./node_modules/lodash/_defineProperty.js": function node_modulesLodash_definePropertyJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js"),
        i = function () {
          try {
            var e = r(Object, "defineProperty");
            return e({}, "", {}), e;
          } catch (e) {}
        }();
      e.exports = i;
    },
    "./node_modules/lodash/_equalArrays.js": function node_modulesLodash_equalArraysJs(e, t, n) {
      var r = n("./node_modules/lodash/_SetCache.js"),
        i = n("./node_modules/lodash/_arraySome.js"),
        o = n("./node_modules/lodash/_cacheHas.js");
      e.exports = function (e, t, n, a, s, l) {
        var u = 1 & n,
          c = e.length,
          d = t.length;
        if (c != d && !(u && d > c)) return !1;
        var h = l.get(e);
        if (h && l.get(t)) return h == t;
        var f = -1,
          p = !0,
          m = 2 & n ? new r() : void 0;
        for (l.set(e, t), l.set(t, e); ++f < c;) {
          var g = e[f],
            v = t[f];
          if (a) var y = u ? a(v, g, f, t, e, l) : a(g, v, f, e, t, l);
          if (void 0 !== y) {
            if (y) continue;
            p = !1;
            break;
          }
          if (m) {
            if (!i(t, function (e, t) {
              if (!o(m, t) && (g === e || s(g, e, n, a, l))) return m.push(t);
            })) {
              p = !1;
              break;
            }
          } else if (g !== v && !s(g, v, n, a, l)) {
            p = !1;
            break;
          }
        }
        return l.delete(e), l.delete(t), p;
      };
    },
    "./node_modules/lodash/_equalByTag.js": function node_modulesLodash_equalByTagJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = n("./node_modules/lodash/_Uint8Array.js"),
        o = n("./node_modules/lodash/eq.js"),
        a = n("./node_modules/lodash/_equalArrays.js"),
        s = n("./node_modules/lodash/_mapToArray.js"),
        l = n("./node_modules/lodash/_setToArray.js"),
        u = r ? r.prototype : void 0,
        c = u ? u.valueOf : void 0;
      e.exports = function (e, t, n, r, u, d, h) {
        switch (n) {
          case "[object DataView]":
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
            e = e.buffer, t = t.buffer;
          case "[object ArrayBuffer]":
            return !(e.byteLength != t.byteLength || !d(new i(e), new i(t)));
          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return o(+e, +t);
          case "[object Error]":
            return e.name == t.name && e.message == t.message;
          case "[object RegExp]":
          case "[object String]":
            return e == t + "";
          case "[object Map]":
            var f = s;
          case "[object Set]":
            var p = 1 & r;
            if (f || (f = l), e.size != t.size && !p) return !1;
            var m = h.get(e);
            if (m) return m == t;
            r |= 2, h.set(e, t);
            var g = a(f(e), f(t), r, u, d, h);
            return h.delete(e), g;
          case "[object Symbol]":
            if (c) return c.call(e) == c.call(t);
        }
        return !1;
      };
    },
    "./node_modules/lodash/_equalObjects.js": function node_modulesLodash_equalObjectsJs(e, t, n) {
      var r = n("./node_modules/lodash/_getAllKeys.js"),
        i = Object.prototype.hasOwnProperty;
      e.exports = function (e, t, n, o, a, s) {
        var l = 1 & n,
          u = r(e),
          c = u.length;
        if (c != r(t).length && !l) return !1;
        for (var d = c; d--;) {
          var h = u[d];
          if (!(l ? h in t : i.call(t, h))) return !1;
        }
        var f = s.get(e);
        if (f && s.get(t)) return f == t;
        var p = !0;
        s.set(e, t), s.set(t, e);
        for (var m = l; ++d < c;) {
          var g = e[h = u[d]],
            v = t[h];
          if (o) var y = l ? o(v, g, h, t, e, s) : o(g, v, h, e, t, s);
          if (!(void 0 === y ? g === v || a(g, v, n, o, s) : y)) {
            p = !1;
            break;
          }
          m || (m = "constructor" == h);
        }
        if (p && !m) {
          var b = e.constructor,
            _ = t.constructor;
          b == _ || !("constructor" in e) || !("constructor" in t) || "function" == typeof b && b instanceof b && "function" == typeof _ && _ instanceof _ || (p = !1);
        }
        return s.delete(e), s.delete(t), p;
      };
    },
    "./node_modules/lodash/_flatRest.js": function node_modulesLodash_flatRestJs(e, t, n) {
      var r = n("./node_modules/lodash/flatten.js"),
        i = n("./node_modules/lodash/_overRest.js"),
        o = n("./node_modules/lodash/_setToString.js");
      e.exports = function (e) {
        return o(i(e, void 0, r), e + "");
      };
    },
    "./node_modules/lodash/_freeGlobal.js": function node_modulesLodash_freeGlobalJs(e, t, n) {
      (function (t) {
        var n = "object" == typeof t && t && t.Object === Object && t;
        e.exports = n;
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/lodash/_getAllKeys.js": function node_modulesLodash_getAllKeysJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetAllKeys.js"),
        i = n("./node_modules/lodash/_getSymbols.js"),
        o = n("./node_modules/lodash/keys.js");
      e.exports = function (e) {
        return r(e, o, i);
      };
    },
    "./node_modules/lodash/_getAllKeysIn.js": function node_modulesLodash_getAllKeysInJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetAllKeys.js"),
        i = n("./node_modules/lodash/_getSymbolsIn.js"),
        o = n("./node_modules/lodash/keysIn.js");
      e.exports = function (e) {
        return r(e, o, i);
      };
    },
    "./node_modules/lodash/_getData.js": function node_modulesLodash_getDataJs(e, t, n) {
      var r = n("./node_modules/lodash/_metaMap.js"),
        i = n("./node_modules/lodash/noop.js"),
        o = r ? function (e) {
          return r.get(e);
        } : i;
      e.exports = o;
    },
    "./node_modules/lodash/_getFuncName.js": function node_modulesLodash_getFuncNameJs(e, t, n) {
      var r = n("./node_modules/lodash/_realNames.js"),
        i = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        for (var t = e.name + "", n = r[t], o = i.call(r, t) ? n.length : 0; o--;) {
          var a = n[o],
            s = a.func;
          if (null == s || s == e) return a.name;
        }
        return t;
      };
    },
    "./node_modules/lodash/_getHolder.js": function node_modulesLodash_getHolderJs(e, t) {
      e.exports = function (e) {
        return e.placeholder;
      };
    },
    "./node_modules/lodash/_getMapData.js": function node_modulesLodash_getMapDataJs(e, t, n) {
      var r = n("./node_modules/lodash/_isKeyable.js");
      e.exports = function (e, t) {
        var n = e.__data__;
        return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
      };
    },
    "./node_modules/lodash/_getMatchData.js": function node_modulesLodash_getMatchDataJs(e, t, n) {
      var r = n("./node_modules/lodash/_isStrictComparable.js"),
        i = n("./node_modules/lodash/keys.js");
      e.exports = function (e) {
        for (var t = i(e), n = t.length; n--;) {
          var o = t[n],
            a = e[o];
          t[n] = [o, a, r(a)];
        }
        return t;
      };
    },
    "./node_modules/lodash/_getNative.js": function node_modulesLodash_getNativeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsNative.js"),
        i = n("./node_modules/lodash/_getValue.js");
      e.exports = function (e, t) {
        var n = i(e, t);
        return r(n) ? n : void 0;
      };
    },
    "./node_modules/lodash/_getPrototype.js": function node_modulesLodash_getPrototypeJs(e, t, n) {
      var r = n("./node_modules/lodash/_overArg.js")(Object.getPrototypeOf, Object);
      e.exports = r;
    },
    "./node_modules/lodash/_getRawTag.js": function node_modulesLodash_getRawTagJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = Object.prototype,
        o = i.hasOwnProperty,
        a = i.toString,
        s = r ? r.toStringTag : void 0;
      e.exports = function (e) {
        var t = o.call(e, s),
          n = e[s];
        try {
          e[s] = void 0;
          var r = !0;
        } catch (e) {}
        var i = a.call(e);
        return r && (t ? e[s] = n : delete e[s]), i;
      };
    },
    "./node_modules/lodash/_getSymbols.js": function node_modulesLodash_getSymbolsJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayFilter.js"),
        i = n("./node_modules/lodash/stubArray.js"),
        o = Object.prototype.propertyIsEnumerable,
        a = Object.getOwnPropertySymbols,
        s = a ? function (e) {
          return null == e ? [] : (e = Object(e), r(a(e), function (t) {
            return o.call(e, t);
          }));
        } : i;
      e.exports = s;
    },
    "./node_modules/lodash/_getSymbolsIn.js": function node_modulesLodash_getSymbolsInJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayPush.js"),
        i = n("./node_modules/lodash/_getPrototype.js"),
        o = n("./node_modules/lodash/_getSymbols.js"),
        a = n("./node_modules/lodash/stubArray.js"),
        s = Object.getOwnPropertySymbols ? function (e) {
          for (var t = []; e;) r(t, o(e)), e = i(e);
          return t;
        } : a;
      e.exports = s;
    },
    "./node_modules/lodash/_getTag.js": function node_modulesLodash_getTagJs(e, t, n) {
      var r = n("./node_modules/lodash/_DataView.js"),
        i = n("./node_modules/lodash/_Map.js"),
        o = n("./node_modules/lodash/_Promise.js"),
        a = n("./node_modules/lodash/_Set.js"),
        s = n("./node_modules/lodash/_WeakMap.js"),
        l = n("./node_modules/lodash/_baseGetTag.js"),
        u = n("./node_modules/lodash/_toSource.js"),
        c = u(r),
        d = u(i),
        h = u(o),
        f = u(a),
        p = u(s),
        m = l;
      (r && "[object DataView]" != m(new r(new ArrayBuffer(1))) || i && "[object Map]" != m(new i()) || o && "[object Promise]" != m(o.resolve()) || a && "[object Set]" != m(new a()) || s && "[object WeakMap]" != m(new s())) && (m = function m(e) {
        var t = l(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? u(n) : "";
        if (r) switch (r) {
          case c:
            return "[object DataView]";
          case d:
            return "[object Map]";
          case h:
            return "[object Promise]";
          case f:
            return "[object Set]";
          case p:
            return "[object WeakMap]";
        }
        return t;
      }), e.exports = m;
    },
    "./node_modules/lodash/_getValue.js": function node_modulesLodash_getValueJs(e, t) {
      e.exports = function (e, t) {
        return null == e ? void 0 : e[t];
      };
    },
    "./node_modules/lodash/_getWrapDetails.js": function node_modulesLodash_getWrapDetailsJs(e, t) {
      var n = /\{\n\/\* \[wrapped with (.+)\] \*/,
        r = /,? & /;
      e.exports = function (e) {
        var t = e.match(n);
        return t ? t[1].split(r) : [];
      };
    },
    "./node_modules/lodash/_hasPath.js": function node_modulesLodash_hasPathJs(e, t, n) {
      var r = n("./node_modules/lodash/_castPath.js"),
        i = n("./node_modules/lodash/isArguments.js"),
        o = n("./node_modules/lodash/isArray.js"),
        a = n("./node_modules/lodash/_isIndex.js"),
        s = n("./node_modules/lodash/isLength.js"),
        l = n("./node_modules/lodash/_toKey.js");
      e.exports = function (e, t, n) {
        for (var u = -1, c = (t = r(t, e)).length, d = !1; ++u < c;) {
          var h = l(t[u]);
          if (!(d = null != e && n(e, h))) break;
          e = e[h];
        }
        return d || ++u != c ? d : !!(c = null == e ? 0 : e.length) && s(c) && a(h, c) && (o(e) || i(e));
      };
    },
    "./node_modules/lodash/_hasUnicode.js": function node_modulesLodash_hasUnicodeJs(e, t) {
      var n = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
      e.exports = function (e) {
        return n.test(e);
      };
    },
    "./node_modules/lodash/_hasUnicodeWord.js": function node_modulesLodash_hasUnicodeWordJs(e, t) {
      var n = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      e.exports = function (e) {
        return n.test(e);
      };
    },
    "./node_modules/lodash/_hashClear.js": function node_modulesLodash_hashClearJs(e, t, n) {
      var r = n("./node_modules/lodash/_nativeCreate.js");
      e.exports = function () {
        this.__data__ = r ? r(null) : {}, this.size = 0;
      };
    },
    "./node_modules/lodash/_hashDelete.js": function node_modulesLodash_hashDeleteJs(e, t) {
      e.exports = function (e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      };
    },
    "./node_modules/lodash/_hashGet.js": function node_modulesLodash_hashGetJs(e, t, n) {
      var r = n("./node_modules/lodash/_nativeCreate.js"),
        i = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        var t = this.__data__;
        if (r) {
          var n = t[e];
          return "__lodash_hash_undefined__" === n ? void 0 : n;
        }
        return i.call(t, e) ? t[e] : void 0;
      };
    },
    "./node_modules/lodash/_hashHas.js": function node_modulesLodash_hashHasJs(e, t, n) {
      var r = n("./node_modules/lodash/_nativeCreate.js"),
        i = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        var t = this.__data__;
        return r ? void 0 !== t[e] : i.call(t, e);
      };
    },
    "./node_modules/lodash/_hashSet.js": function node_modulesLodash_hashSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_nativeCreate.js");
      e.exports = function (e, t) {
        var n = this.__data__;
        return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? "__lodash_hash_undefined__" : t, this;
      };
    },
    "./node_modules/lodash/_initCloneArray.js": function node_modulesLodash_initCloneArrayJs(e, t) {
      var n = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        var t = e.length,
          r = new e.constructor(t);
        return t && "string" == typeof e[0] && n.call(e, "index") && (r.index = e.index, r.input = e.input), r;
      };
    },
    "./node_modules/lodash/_initCloneByTag.js": function node_modulesLodash_initCloneByTagJs(e, t, n) {
      var r = n("./node_modules/lodash/_cloneArrayBuffer.js"),
        i = n("./node_modules/lodash/_cloneDataView.js"),
        o = n("./node_modules/lodash/_cloneRegExp.js"),
        a = n("./node_modules/lodash/_cloneSymbol.js"),
        s = n("./node_modules/lodash/_cloneTypedArray.js");
      e.exports = function (e, t, n) {
        var l = e.constructor;
        switch (t) {
          case "[object ArrayBuffer]":
            return r(e);
          case "[object Boolean]":
          case "[object Date]":
            return new l(+e);
          case "[object DataView]":
            return i(e, n);
          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return s(e, n);
          case "[object Map]":
            return new l();
          case "[object Number]":
          case "[object String]":
            return new l(e);
          case "[object RegExp]":
            return o(e);
          case "[object Set]":
            return new l();
          case "[object Symbol]":
            return a(e);
        }
      };
    },
    "./node_modules/lodash/_initCloneObject.js": function node_modulesLodash_initCloneObjectJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseCreate.js"),
        i = n("./node_modules/lodash/_getPrototype.js"),
        o = n("./node_modules/lodash/_isPrototype.js");
      e.exports = function (e) {
        return "function" != typeof e.constructor || o(e) ? {} : r(i(e));
      };
    },
    "./node_modules/lodash/_insertWrapDetails.js": function node_modulesLodash_insertWrapDetailsJs(e, t) {
      var n = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
      e.exports = function (e, t) {
        var r = t.length;
        if (!r) return e;
        var i = r - 1;
        return t[i] = (r > 1 ? "& " : "") + t[i], t = t.join(r > 2 ? ", " : " "), e.replace(n, "{\n/* [wrapped with " + t + "] */\n");
      };
    },
    "./node_modules/lodash/_isFlattenable.js": function node_modulesLodash_isFlattenableJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = n("./node_modules/lodash/isArguments.js"),
        o = n("./node_modules/lodash/isArray.js"),
        a = r ? r.isConcatSpreadable : void 0;
      e.exports = function (e) {
        return o(e) || i(e) || !!(a && e && e[a]);
      };
    },
    "./node_modules/lodash/_isIndex.js": function node_modulesLodash_isIndexJs(e, t) {
      var n = /^(?:0|[1-9]\d*)$/;
      e.exports = function (e, t) {
        var r = typeof e;
        return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && n.test(e)) && e > -1 && e % 1 == 0 && e < t;
      };
    },
    "./node_modules/lodash/_isIterateeCall.js": function node_modulesLodash_isIterateeCallJs(e, t, n) {
      var r = n("./node_modules/lodash/eq.js"),
        i = n("./node_modules/lodash/isArrayLike.js"),
        o = n("./node_modules/lodash/_isIndex.js"),
        a = n("./node_modules/lodash/isObject.js");
      e.exports = function (e, t, n) {
        if (!a(n)) return !1;
        var s = typeof t;
        return !!("number" == s ? i(n) && o(t, n.length) : "string" == s && t in n) && r(n[t], e);
      };
    },
    "./node_modules/lodash/_isKey.js": function node_modulesLodash_isKeyJs(e, t, n) {
      var r = n("./node_modules/lodash/isArray.js"),
        i = n("./node_modules/lodash/isSymbol.js"),
        o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        a = /^\w*$/;
      e.exports = function (e, t) {
        if (r(e)) return !1;
        var n = typeof e;
        return !("number" != n && "symbol" != n && "boolean" != n && null != e && !i(e)) || a.test(e) || !o.test(e) || null != t && e in Object(t);
      };
    },
    "./node_modules/lodash/_isKeyable.js": function node_modulesLodash_isKeyableJs(e, t) {
      e.exports = function (e) {
        var t = typeof e;
        return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
      };
    },
    "./node_modules/lodash/_isLaziable.js": function node_modulesLodash_isLaziableJs(e, t, n) {
      var r = n("./node_modules/lodash/_LazyWrapper.js"),
        i = n("./node_modules/lodash/_getData.js"),
        o = n("./node_modules/lodash/_getFuncName.js"),
        a = n("./node_modules/lodash/wrapperLodash.js");
      e.exports = function (e) {
        var t = o(e),
          n = a[t];
        if ("function" != typeof n || !(t in r.prototype)) return !1;
        if (e === n) return !0;
        var s = i(n);
        return !!s && e === s[0];
      };
    },
    "./node_modules/lodash/_isMasked.js": function node_modulesLodash_isMaskedJs(e, t, n) {
      var r,
        i = n("./node_modules/lodash/_coreJsData.js"),
        o = (r = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
      e.exports = function (e) {
        return !!o && o in e;
      };
    },
    "./node_modules/lodash/_isPrototype.js": function node_modulesLodash_isPrototypeJs(e, t) {
      var n = Object.prototype;
      e.exports = function (e) {
        var t = e && e.constructor;
        return e === ("function" == typeof t && t.prototype || n);
      };
    },
    "./node_modules/lodash/_isStrictComparable.js": function node_modulesLodash_isStrictComparableJs(e, t, n) {
      var r = n("./node_modules/lodash/isObject.js");
      e.exports = function (e) {
        return e == e && !r(e);
      };
    },
    "./node_modules/lodash/_iteratorToArray.js": function node_modulesLodash_iteratorToArrayJs(e, t) {
      e.exports = function (e) {
        for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
        return n;
      };
    },
    "./node_modules/lodash/_listCacheClear.js": function node_modulesLodash_listCacheClearJs(e, t) {
      e.exports = function () {
        this.__data__ = [], this.size = 0;
      };
    },
    "./node_modules/lodash/_listCacheDelete.js": function node_modulesLodash_listCacheDeleteJs(e, t, n) {
      var r = n("./node_modules/lodash/_assocIndexOf.js"),
        i = Array.prototype.splice;
      e.exports = function (e) {
        var t = this.__data__,
          n = r(t, e);
        return !(n < 0) && (n == t.length - 1 ? t.pop() : i.call(t, n, 1), --this.size, !0);
      };
    },
    "./node_modules/lodash/_listCacheGet.js": function node_modulesLodash_listCacheGetJs(e, t, n) {
      var r = n("./node_modules/lodash/_assocIndexOf.js");
      e.exports = function (e) {
        var t = this.__data__,
          n = r(t, e);
        return n < 0 ? void 0 : t[n][1];
      };
    },
    "./node_modules/lodash/_listCacheHas.js": function node_modulesLodash_listCacheHasJs(e, t, n) {
      var r = n("./node_modules/lodash/_assocIndexOf.js");
      e.exports = function (e) {
        return r(this.__data__, e) > -1;
      };
    },
    "./node_modules/lodash/_listCacheSet.js": function node_modulesLodash_listCacheSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_assocIndexOf.js");
      e.exports = function (e, t) {
        var n = this.__data__,
          i = r(n, e);
        return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
      };
    },
    "./node_modules/lodash/_mapCacheClear.js": function node_modulesLodash_mapCacheClearJs(e, t, n) {
      var r = n("./node_modules/lodash/_Hash.js"),
        i = n("./node_modules/lodash/_ListCache.js"),
        o = n("./node_modules/lodash/_Map.js");
      e.exports = function () {
        this.size = 0, this.__data__ = {
          hash: new r(),
          map: new (o || i)(),
          string: new r()
        };
      };
    },
    "./node_modules/lodash/_mapCacheDelete.js": function node_modulesLodash_mapCacheDeleteJs(e, t, n) {
      var r = n("./node_modules/lodash/_getMapData.js");
      e.exports = function (e) {
        var t = r(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      };
    },
    "./node_modules/lodash/_mapCacheGet.js": function node_modulesLodash_mapCacheGetJs(e, t, n) {
      var r = n("./node_modules/lodash/_getMapData.js");
      e.exports = function (e) {
        return r(this, e).get(e);
      };
    },
    "./node_modules/lodash/_mapCacheHas.js": function node_modulesLodash_mapCacheHasJs(e, t, n) {
      var r = n("./node_modules/lodash/_getMapData.js");
      e.exports = function (e) {
        return r(this, e).has(e);
      };
    },
    "./node_modules/lodash/_mapCacheSet.js": function node_modulesLodash_mapCacheSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_getMapData.js");
      e.exports = function (e, t) {
        var n = r(this, e),
          i = n.size;
        return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
      };
    },
    "./node_modules/lodash/_mapToArray.js": function node_modulesLodash_mapToArrayJs(e, t) {
      e.exports = function (e) {
        var t = -1,
          n = Array(e.size);
        return e.forEach(function (e, r) {
          n[++t] = [r, e];
        }), n;
      };
    },
    "./node_modules/lodash/_matchesStrictComparable.js": function node_modulesLodash_matchesStrictComparableJs(e, t) {
      e.exports = function (e, t) {
        return function (n) {
          return null != n && n[e] === t && (void 0 !== t || e in Object(n));
        };
      };
    },
    "./node_modules/lodash/_memoizeCapped.js": function node_modulesLodash_memoizeCappedJs(e, t, n) {
      var r = n("./node_modules/lodash/memoize.js");
      e.exports = function (e) {
        var t = r(e, function (e) {
            return 500 === n.size && n.clear(), e;
          }),
          n = t.cache;
        return t;
      };
    },
    "./node_modules/lodash/_mergeData.js": function node_modulesLodash_mergeDataJs(e, t, n) {
      var r = n("./node_modules/lodash/_composeArgs.js"),
        i = n("./node_modules/lodash/_composeArgsRight.js"),
        o = n("./node_modules/lodash/_replaceHolders.js"),
        a = Math.min;
      e.exports = function (e, t) {
        var n = e[1],
          s = t[1],
          l = n | s,
          u = l < 131,
          c = 128 == s && 8 == n || 128 == s && 256 == n && e[7].length <= t[8] || 384 == s && t[7].length <= t[8] && 8 == n;
        if (!u && !c) return e;
        1 & s && (e[2] = t[2], l |= 1 & n ? 0 : 4);
        var d = t[3];
        if (d) {
          var h = e[3];
          e[3] = h ? r(h, d, t[4]) : d, e[4] = h ? o(e[3], "__lodash_placeholder__") : t[4];
        }
        return (d = t[5]) && (h = e[5], e[5] = h ? i(h, d, t[6]) : d, e[6] = h ? o(e[5], "__lodash_placeholder__") : t[6]), (d = t[7]) && (e[7] = d), 128 & s && (e[8] = null == e[8] ? t[8] : a(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = l, e;
      };
    },
    "./node_modules/lodash/_metaMap.js": function node_modulesLodash_metaMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_WeakMap.js"),
        i = r && new r();
      e.exports = i;
    },
    "./node_modules/lodash/_nativeCreate.js": function node_modulesLodash_nativeCreateJs(e, t, n) {
      var r = n("./node_modules/lodash/_getNative.js")(Object, "create");
      e.exports = r;
    },
    "./node_modules/lodash/_nativeKeys.js": function node_modulesLodash_nativeKeysJs(e, t, n) {
      var r = n("./node_modules/lodash/_overArg.js")(Object.keys, Object);
      e.exports = r;
    },
    "./node_modules/lodash/_nativeKeysIn.js": function node_modulesLodash_nativeKeysInJs(e, t) {
      e.exports = function (e) {
        var t = [];
        if (null != e) for (var n in Object(e)) t.push(n);
        return t;
      };
    },
    "./node_modules/lodash/_nodeUtil.js": function node_modulesLodash_nodeUtilJs(e, t, n) {
      (function (e) {
        var r = n("./node_modules/lodash/_freeGlobal.js"),
          i = t && !t.nodeType && t,
          o = i && "object" == typeof e && e && !e.nodeType && e,
          a = o && o.exports === i && r.process,
          s = function () {
            try {
              var e = o && o.require && o.require("util").types;
              return e || a && a.binding && a.binding("util");
            } catch (e) {}
          }();
        e.exports = s;
      }).call(this, n("./node_modules/webpack/buildin/module.js")(e));
    },
    "./node_modules/lodash/_objectToString.js": function node_modulesLodash_objectToStringJs(e, t) {
      var n = Object.prototype.toString;
      e.exports = function (e) {
        return n.call(e);
      };
    },
    "./node_modules/lodash/_overArg.js": function node_modulesLodash_overArgJs(e, t) {
      e.exports = function (e, t) {
        return function (n) {
          return e(t(n));
        };
      };
    },
    "./node_modules/lodash/_overRest.js": function node_modulesLodash_overRestJs(e, t, n) {
      var r = n("./node_modules/lodash/_apply.js"),
        i = Math.max;
      e.exports = function (e, t, n) {
        return t = i(void 0 === t ? e.length - 1 : t, 0), function () {
          for (var o = arguments, a = -1, s = i(o.length - t, 0), l = Array(s); ++a < s;) l[a] = o[t + a];
          a = -1;
          for (var u = Array(t + 1); ++a < t;) u[a] = o[a];
          return u[t] = n(l), r(e, this, u);
        };
      };
    },
    "./node_modules/lodash/_parent.js": function node_modulesLodash_parentJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGet.js"),
        i = n("./node_modules/lodash/_baseSlice.js");
      e.exports = function (e, t) {
        return t.length < 2 ? e : r(e, i(t, 0, -1));
      };
    },
    "./node_modules/lodash/_realNames.js": function node_modulesLodash_realNamesJs(e, t) {
      e.exports = {};
    },
    "./node_modules/lodash/_reorder.js": function node_modulesLodash_reorderJs(e, t, n) {
      var r = n("./node_modules/lodash/_copyArray.js"),
        i = n("./node_modules/lodash/_isIndex.js"),
        o = Math.min;
      e.exports = function (e, t) {
        for (var n = e.length, a = o(t.length, n), s = r(e); a--;) {
          var l = t[a];
          e[a] = i(l, n) ? s[l] : void 0;
        }
        return e;
      };
    },
    "./node_modules/lodash/_replaceHolders.js": function node_modulesLodash_replaceHoldersJs(e, t) {
      e.exports = function (e, t) {
        for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
          var a = e[n];
          a !== t && "__lodash_placeholder__" !== a || (e[n] = "__lodash_placeholder__", o[i++] = n);
        }
        return o;
      };
    },
    "./node_modules/lodash/_root.js": function node_modulesLodash_rootJs(e, t, n) {
      var r = n("./node_modules/lodash/_freeGlobal.js"),
        i = "object" == typeof self && self && self.Object === Object && self,
        o = r || i || Function("return this")();
      e.exports = o;
    },
    "./node_modules/lodash/_safeGet.js": function node_modulesLodash_safeGetJs(e, t) {
      e.exports = function (e, t) {
        if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
      };
    },
    "./node_modules/lodash/_setCacheAdd.js": function node_modulesLodash_setCacheAddJs(e, t) {
      e.exports = function (e) {
        return this.__data__.set(e, "__lodash_hash_undefined__"), this;
      };
    },
    "./node_modules/lodash/_setCacheHas.js": function node_modulesLodash_setCacheHasJs(e, t) {
      e.exports = function (e) {
        return this.__data__.has(e);
      };
    },
    "./node_modules/lodash/_setData.js": function node_modulesLodash_setDataJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseSetData.js"),
        i = n("./node_modules/lodash/_shortOut.js")(r);
      e.exports = i;
    },
    "./node_modules/lodash/_setToArray.js": function node_modulesLodash_setToArrayJs(e, t) {
      e.exports = function (e) {
        var t = -1,
          n = Array(e.size);
        return e.forEach(function (e) {
          n[++t] = e;
        }), n;
      };
    },
    "./node_modules/lodash/_setToString.js": function node_modulesLodash_setToStringJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseSetToString.js"),
        i = n("./node_modules/lodash/_shortOut.js")(r);
      e.exports = i;
    },
    "./node_modules/lodash/_setWrapToString.js": function node_modulesLodash_setWrapToStringJs(e, t, n) {
      var r = n("./node_modules/lodash/_getWrapDetails.js"),
        i = n("./node_modules/lodash/_insertWrapDetails.js"),
        o = n("./node_modules/lodash/_setToString.js"),
        a = n("./node_modules/lodash/_updateWrapDetails.js");
      e.exports = function (e, t, n) {
        var s = t + "";
        return o(e, i(s, a(r(s), n)));
      };
    },
    "./node_modules/lodash/_shortOut.js": function node_modulesLodash_shortOutJs(e, t) {
      var n = Date.now;
      e.exports = function (e) {
        var t = 0,
          r = 0;
        return function () {
          var i = n(),
            o = 16 - (i - r);
          if (r = i, o > 0) {
            if (++t >= 800) return arguments[0];
          } else t = 0;
          return e.apply(void 0, arguments);
        };
      };
    },
    "./node_modules/lodash/_stackClear.js": function node_modulesLodash_stackClearJs(e, t, n) {
      var r = n("./node_modules/lodash/_ListCache.js");
      e.exports = function () {
        this.__data__ = new r(), this.size = 0;
      };
    },
    "./node_modules/lodash/_stackDelete.js": function node_modulesLodash_stackDeleteJs(e, t) {
      e.exports = function (e) {
        var t = this.__data__,
          n = t.delete(e);
        return this.size = t.size, n;
      };
    },
    "./node_modules/lodash/_stackGet.js": function node_modulesLodash_stackGetJs(e, t) {
      e.exports = function (e) {
        return this.__data__.get(e);
      };
    },
    "./node_modules/lodash/_stackHas.js": function node_modulesLodash_stackHasJs(e, t) {
      e.exports = function (e) {
        return this.__data__.has(e);
      };
    },
    "./node_modules/lodash/_stackSet.js": function node_modulesLodash_stackSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_ListCache.js"),
        i = n("./node_modules/lodash/_Map.js"),
        o = n("./node_modules/lodash/_MapCache.js");
      e.exports = function (e, t) {
        var n = this.__data__;
        if (n instanceof r) {
          var a = n.__data__;
          if (!i || a.length < 199) return a.push([e, t]), this.size = ++n.size, this;
          n = this.__data__ = new o(a);
        }
        return n.set(e, t), this.size = n.size, this;
      };
    },
    "./node_modules/lodash/_strictIndexOf.js": function node_modulesLodash_strictIndexOfJs(e, t) {
      e.exports = function (e, t, n) {
        for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
        return -1;
      };
    },
    "./node_modules/lodash/_stringSize.js": function node_modulesLodash_stringSizeJs(e, t, n) {
      var r = n("./node_modules/lodash/_asciiSize.js"),
        i = n("./node_modules/lodash/_hasUnicode.js"),
        o = n("./node_modules/lodash/_unicodeSize.js");
      e.exports = function (e) {
        return i(e) ? o(e) : r(e);
      };
    },
    "./node_modules/lodash/_stringToArray.js": function node_modulesLodash_stringToArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/_asciiToArray.js"),
        i = n("./node_modules/lodash/_hasUnicode.js"),
        o = n("./node_modules/lodash/_unicodeToArray.js");
      e.exports = function (e) {
        return i(e) ? o(e) : r(e);
      };
    },
    "./node_modules/lodash/_stringToPath.js": function node_modulesLodash_stringToPathJs(e, t, n) {
      var r = n("./node_modules/lodash/_memoizeCapped.js"),
        i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        o = /\\(\\)?/g,
        a = r(function (e) {
          var t = [];
          return 46 === e.charCodeAt(0) && t.push(""), e.replace(i, function (e, n, r, i) {
            t.push(r ? i.replace(o, "$1") : n || e);
          }), t;
        });
      e.exports = a;
    },
    "./node_modules/lodash/_toKey.js": function node_modulesLodash_toKeyJs(e, t, n) {
      var r = n("./node_modules/lodash/isSymbol.js");
      e.exports = function (e) {
        if ("string" == typeof e || r(e)) return e;
        var t = e + "";
        return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
      };
    },
    "./node_modules/lodash/_toSource.js": function node_modulesLodash_toSourceJs(e, t) {
      var n = Function.prototype.toString;
      e.exports = function (e) {
        if (null != e) {
          try {
            return n.call(e);
          } catch (e) {}
          try {
            return e + "";
          } catch (e) {}
        }
        return "";
      };
    },
    "./node_modules/lodash/_unicodeSize.js": function node_modulesLodash_unicodeSizeJs(e, t) {
      var n = "[\\ud800-\\udfff]",
        r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        i = "\\ud83c[\\udffb-\\udfff]",
        o = "[^\\ud800-\\udfff]",
        a = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        s = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        l = "(?:" + r + "|" + i + ")" + "?",
        u = "[\\ufe0e\\ufe0f]?" + l + ("(?:\\u200d(?:" + [o, a, s].join("|") + ")[\\ufe0e\\ufe0f]?" + l + ")*"),
        c = "(?:" + [o + r + "?", r, a, s, n].join("|") + ")",
        d = RegExp(i + "(?=" + i + ")|" + c + u, "g");
      e.exports = function (e) {
        for (var t = d.lastIndex = 0; d.test(e);) ++t;
        return t;
      };
    },
    "./node_modules/lodash/_unicodeToArray.js": function node_modulesLodash_unicodeToArrayJs(e, t) {
      var n = "[\\ud800-\\udfff]",
        r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        i = "\\ud83c[\\udffb-\\udfff]",
        o = "[^\\ud800-\\udfff]",
        a = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        s = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        l = "(?:" + r + "|" + i + ")" + "?",
        u = "[\\ufe0e\\ufe0f]?" + l + ("(?:\\u200d(?:" + [o, a, s].join("|") + ")[\\ufe0e\\ufe0f]?" + l + ")*"),
        c = "(?:" + [o + r + "?", r, a, s, n].join("|") + ")",
        d = RegExp(i + "(?=" + i + ")|" + c + u, "g");
      e.exports = function (e) {
        return e.match(d) || [];
      };
    },
    "./node_modules/lodash/_unicodeWords.js": function node_modulesLodash_unicodeWordsJs(e, t) {
      var n = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
        r = "[" + n + "]",
        i = "\\d+",
        o = "[\\u2700-\\u27bf]",
        a = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
        s = "[^\\ud800-\\udfff" + n + i + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
        l = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        c = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
        d = "(?:" + a + "|" + s + ")",
        h = "(?:" + c + "|" + s + ")",
        f = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
        p = "[\\ufe0e\\ufe0f]?" + f + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", l, u].join("|") + ")[\\ufe0e\\ufe0f]?" + f + ")*"),
        m = "(?:" + [o, l, u].join("|") + ")" + p,
        g = RegExp([c + "?" + a + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [r, c, "$"].join("|") + ")", h + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [r, c + d, "$"].join("|") + ")", c + "?" + d + "+(?:['’](?:d|ll|m|re|s|t|ve))?", c + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", i, m].join("|"), "g");
      e.exports = function (e) {
        return e.match(g) || [];
      };
    },
    "./node_modules/lodash/_updateWrapDetails.js": function node_modulesLodash_updateWrapDetailsJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayEach.js"),
        i = n("./node_modules/lodash/_arrayIncludes.js"),
        o = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];
      e.exports = function (e, t) {
        return r(o, function (n) {
          var r = "_." + n[0];
          t & n[1] && !i(e, r) && e.push(r);
        }), e.sort();
      };
    },
    "./node_modules/lodash/_wrapperClone.js": function node_modulesLodash_wrapperCloneJs(e, t, n) {
      var r = n("./node_modules/lodash/_LazyWrapper.js"),
        i = n("./node_modules/lodash/_LodashWrapper.js"),
        o = n("./node_modules/lodash/_copyArray.js");
      e.exports = function (e) {
        if (e instanceof r) return e.clone();
        var t = new i(e.__wrapped__, e.__chain__);
        return t.__actions__ = o(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      };
    },
    "./node_modules/lodash/ary.js": function node_modulesLodashAryJs(e, t, n) {
      var r = n("./node_modules/lodash/_createWrap.js");
      e.exports = function (e, t, n) {
        return t = n ? void 0 : t, t = e && null == t ? e.length : t, r(e, 128, void 0, void 0, void 0, void 0, t);
      };
    },
    "./node_modules/lodash/clamp.js": function node_modulesLodashClampJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseClamp.js"),
        i = n("./node_modules/lodash/toNumber.js");
      e.exports = function (e, t, n) {
        return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = i(n)) == n ? n : 0), void 0 !== t && (t = (t = i(t)) == t ? t : 0), r(i(e), t, n);
      };
    },
    "./node_modules/lodash/clone.js": function node_modulesLodashCloneJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseClone.js");
      e.exports = function (e) {
        return r(e, 4);
      };
    },
    "./node_modules/lodash/compact.js": function node_modulesLodashCompactJs(e, t) {
      e.exports = function (e) {
        for (var t = -1, n = null == e ? 0 : e.length, r = 0, i = []; ++t < n;) {
          var o = e[t];
          o && (i[r++] = o);
        }
        return i;
      };
    },
    "./node_modules/lodash/constant.js": function node_modulesLodashConstantJs(e, t) {
      e.exports = function (e) {
        return function () {
          return e;
        };
      };
    },
    "./node_modules/lodash/curry.js": function node_modulesLodashCurryJs(e, t, n) {
      var r = n("./node_modules/lodash/_createWrap.js");
      function i(e, t, n) {
        var o = r(e, 8, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
        return o.placeholder = i.placeholder, o;
      }
      i.placeholder = {}, e.exports = i;
    },
    "./node_modules/lodash/deburr.js": function node_modulesLodashDeburrJs(e, t, n) {
      var r = n("./node_modules/lodash/_deburrLetter.js"),
        i = n("./node_modules/lodash/toString.js"),
        o = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
        a = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
      e.exports = function (e) {
        return (e = i(e)) && e.replace(o, r).replace(a, "");
      };
    },
    "./node_modules/lodash/difference.js": function node_modulesLodashDifferenceJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseDifference.js"),
        i = n("./node_modules/lodash/_baseFlatten.js"),
        o = n("./node_modules/lodash/_baseRest.js"),
        a = n("./node_modules/lodash/isArrayLikeObject.js"),
        s = o(function (e, t) {
          return a(e) ? r(e, i(t, 1, a, !0)) : [];
        });
      e.exports = s;
    },
    "./node_modules/lodash/dropRight.js": function node_modulesLodashDropRightJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseSlice.js"),
        i = n("./node_modules/lodash/toInteger.js");
      e.exports = function (e, t, n) {
        var o = null == e ? 0 : e.length;
        return o ? (t = n || void 0 === t ? 1 : i(t), r(e, 0, (t = o - t) < 0 ? 0 : t)) : [];
      };
    },
    "./node_modules/lodash/each.js": function node_modulesLodashEachJs(e, t, n) {
      e.exports = n("./node_modules/lodash/forEach.js");
    },
    "./node_modules/lodash/eq.js": function node_modulesLodashEqJs(e, t) {
      e.exports = function (e, t) {
        return e === t || e != e && t != t;
      };
    },
    "./node_modules/lodash/escapeRegExp.js": function node_modulesLodashEscapeRegExpJs(e, t, n) {
      var r = n("./node_modules/lodash/toString.js"),
        i = /[\\^$.*+?()[\]{}|]/g,
        o = RegExp(i.source);
      e.exports = function (e) {
        return (e = r(e)) && o.test(e) ? e.replace(i, "\\$&") : e;
      };
    },
    "./node_modules/lodash/every.js": function node_modulesLodashEveryJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayEvery.js"),
        i = n("./node_modules/lodash/_baseEvery.js"),
        o = n("./node_modules/lodash/_baseIteratee.js"),
        a = n("./node_modules/lodash/isArray.js"),
        s = n("./node_modules/lodash/_isIterateeCall.js");
      e.exports = function (e, t, n) {
        var l = a(e) ? r : i;
        return n && s(e, t, n) && (t = void 0), l(e, o(t, 3));
      };
    },
    "./node_modules/lodash/filter.js": function node_modulesLodashFilterJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayFilter.js"),
        i = n("./node_modules/lodash/_baseFilter.js"),
        o = n("./node_modules/lodash/_baseIteratee.js"),
        a = n("./node_modules/lodash/isArray.js");
      e.exports = function (e, t) {
        return (a(e) ? r : i)(e, o(t, 3));
      };
    },
    "./node_modules/lodash/find.js": function node_modulesLodashFindJs(e, t, n) {
      var r = n("./node_modules/lodash/_createFind.js")(n("./node_modules/lodash/findIndex.js"));
      e.exports = r;
    },
    "./node_modules/lodash/findIndex.js": function node_modulesLodashFindIndexJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseFindIndex.js"),
        i = n("./node_modules/lodash/_baseIteratee.js"),
        o = n("./node_modules/lodash/toInteger.js"),
        a = Math.max;
      e.exports = function (e, t, n) {
        var s = null == e ? 0 : e.length;
        if (!s) return -1;
        var l = null == n ? 0 : o(n);
        return l < 0 && (l = a(s + l, 0)), r(e, i(t, 3), l);
      };
    },
    "./node_modules/lodash/first.js": function node_modulesLodashFirstJs(e, t, n) {
      e.exports = n("./node_modules/lodash/head.js");
    },
    "./node_modules/lodash/flatMap.js": function node_modulesLodashFlatMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseFlatten.js"),
        i = n("./node_modules/lodash/map.js");
      e.exports = function (e, t) {
        return r(i(e, t), 1);
      };
    },
    "./node_modules/lodash/flatten.js": function node_modulesLodashFlattenJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseFlatten.js");
      e.exports = function (e) {
        return (null == e ? 0 : e.length) ? r(e, 1) : [];
      };
    },
    "./node_modules/lodash/flow.js": function node_modulesLodashFlowJs(e, t, n) {
      var r = n("./node_modules/lodash/_createFlow.js")();
      e.exports = r;
    },
    "./node_modules/lodash/forEach.js": function node_modulesLodashForEachJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayEach.js"),
        i = n("./node_modules/lodash/_baseEach.js"),
        o = n("./node_modules/lodash/_castFunction.js"),
        a = n("./node_modules/lodash/isArray.js");
      e.exports = function (e, t) {
        return (a(e) ? r : i)(e, o(t));
      };
    },
    "./node_modules/lodash/fp/_baseConvert.js": function node_modulesLodashFp_baseConvertJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/_mapping.js"),
        i = n("./node_modules/lodash/fp/placeholder.js"),
        o = Array.prototype.push;
      function a(e, t) {
        return 2 == t ? function (t, n) {
          return e(t, n);
        } : function (t) {
          return e(t);
        };
      }
      function s(e) {
        for (var t = e ? e.length : 0, n = Array(t); t--;) n[t] = e[t];
        return n;
      }
      function l(e, t) {
        return function () {
          var n = arguments.length;
          if (n) {
            for (var r = Array(n); n--;) r[n] = arguments[n];
            var i = r[0] = t.apply(void 0, r);
            return e.apply(void 0, r), i;
          }
        };
      }
      e.exports = function e(t, n, u, c) {
        var d = "function" == typeof n,
          h = n === Object(n);
        if (h && (c = u, u = n, n = void 0), null == u) throw new TypeError();
        c || (c = {});
        var f = !("cap" in c) || c.cap,
          p = !("curry" in c) || c.curry,
          m = !("fixed" in c) || c.fixed,
          g = !("immutable" in c) || c.immutable,
          v = !("rearg" in c) || c.rearg,
          y = d ? u : i,
          b = "curry" in c && c.curry,
          _ = "fixed" in c && c.fixed,
          x = "rearg" in c && c.rearg,
          w = d ? u.runInContext() : void 0,
          S = d ? u : {
            ary: t.ary,
            assign: t.assign,
            clone: t.clone,
            curry: t.curry,
            forEach: t.forEach,
            isArray: t.isArray,
            isError: t.isError,
            isFunction: t.isFunction,
            isWeakMap: t.isWeakMap,
            iteratee: t.iteratee,
            keys: t.keys,
            rearg: t.rearg,
            toInteger: t.toInteger,
            toPath: t.toPath
          },
          A = S.ary,
          E = S.assign,
          T = S.clone,
          M = S.curry,
          C = S.forEach,
          k = S.isArray,
          P = S.isError,
          O = S.isFunction,
          R = S.isWeakMap,
          I = S.keys,
          j = S.rearg,
          N = S.toInteger,
          L = S.toPath,
          D = I(r.aryMethod),
          B = {
            castArray: function castArray(e) {
              return function () {
                var t = arguments[0];
                return k(t) ? e(s(t)) : e.apply(void 0, arguments);
              };
            },
            iteratee: function iteratee(e) {
              return function () {
                var t = arguments[0],
                  n = arguments[1],
                  r = e(t, n),
                  i = r.length;
                return f && "number" == typeof n ? (n = n > 2 ? n - 2 : 1, i && i <= n ? r : a(r, n)) : r;
              };
            },
            mixin: function mixin(e) {
              return function (t) {
                var n = this;
                if (!O(n)) return e(n, Object(t));
                var r = [];
                return C(I(t), function (e) {
                  O(t[e]) && r.push([e, n.prototype[e]]);
                }), e(n, Object(t)), C(r, function (e) {
                  var t = e[1];
                  O(t) ? n.prototype[e[0]] = t : delete n.prototype[e[0]];
                }), n;
              };
            },
            nthArg: function nthArg(e) {
              return function (t) {
                var n = t < 0 ? 1 : N(t) + 1;
                return M(e(t), n);
              };
            },
            rearg: function rearg(e) {
              return function (t, n) {
                var r = n ? n.length : 0;
                return M(e(t, n), r);
              };
            },
            runInContext: function runInContext(n) {
              return function (r) {
                return e(t, n(r), c);
              };
            }
          };
        function F(e, t) {
          if (f) {
            var n = r.iterateeRearg[e];
            if (n) return function (e, t) {
              return H(e, function (e) {
                var n = t.length;
                return function (e, t) {
                  return 2 == t ? function (t, n) {
                    return e.apply(void 0, arguments);
                  } : function (t) {
                    return e.apply(void 0, arguments);
                  };
                }(j(a(e, n), t), n);
              });
            }(t, n);
            var i = !d && r.iterateeAry[e];
            if (i) return function (e, t) {
              return H(e, function (e) {
                return "function" == typeof e ? a(e, t) : e;
              });
            }(t, i);
          }
          return t;
        }
        function z(e, t, n) {
          if (m && (_ || !r.skipFixed[e])) {
            var i = r.methodSpread[e],
              a = i && i.start;
            return void 0 === a ? A(t, n) : function (e, t) {
              return function () {
                for (var n = arguments.length, r = n - 1, i = Array(n); n--;) i[n] = arguments[n];
                var a = i[t],
                  s = i.slice(0, t);
                return a && o.apply(s, a), t != r && o.apply(s, i.slice(t + 1)), e.apply(this, s);
              };
            }(t, a);
          }
          return t;
        }
        function U(e, t, n) {
          return v && n > 1 && (x || !r.skipRearg[e]) ? j(t, r.methodRearg[e] || r.aryRearg[n]) : t;
        }
        function G(e, t) {
          for (var n = -1, r = (t = L(t)).length, i = r - 1, o = T(Object(e)), a = o; null != a && ++n < r;) {
            var s = t[n],
              l = a[s];
            null == l || O(l) || P(l) || R(l) || (a[s] = T(n == i ? l : Object(l))), a = a[s];
          }
          return o;
        }
        function V(t, n) {
          var i = r.aliasToReal[t] || t,
            o = r.remap[i] || i,
            a = c;
          return function (t) {
            var r = d ? w : S,
              s = d ? w[o] : n,
              l = E(E({}, a), t);
            return e(r, i, s, l);
          };
        }
        function H(e, t) {
          return function () {
            var n = arguments.length;
            if (!n) return e();
            for (var r = Array(n); n--;) r[n] = arguments[n];
            var i = v ? 0 : n - 1;
            return r[i] = t(r[i]), e.apply(void 0, r);
          };
        }
        function q(e, t, n) {
          var i,
            o = r.aliasToReal[e] || e,
            a = t,
            u = B[o];
          return u ? a = u(t) : g && (r.mutate.array[o] ? a = l(t, s) : r.mutate.object[o] ? a = l(t, function (e) {
            return function (t) {
              return e({}, t);
            };
          }(t)) : r.mutate.set[o] && (a = l(t, G))), C(D, function (e) {
            return C(r.aryMethod[e], function (t) {
              if (o == t) {
                var n = r.methodSpread[o],
                  s = n && n.afterRearg;
                return i = s ? z(o, U(o, a, e), e) : U(o, z(o, a, e), e), i = function (e, t, n) {
                  return b || p && n > 1 ? M(t, n) : t;
                }(0, i = F(o, i), e), !1;
              }
            }), !i;
          }), i || (i = a), i == t && (i = b ? M(i, 1) : function () {
            return t.apply(this, arguments);
          }), i.convert = V(o, t), i.placeholder = t.placeholder = n, i;
        }
        if (!h) return q(n, u, y);
        var W = u,
          $ = [];
        return C(D, function (e) {
          C(r.aryMethod[e], function (e) {
            var t = W[r.remap[e] || e];
            t && $.push([e, q(e, t, W)]);
          });
        }), C(I(W), function (e) {
          var t = W[e];
          if ("function" == typeof t) {
            for (var n = $.length; n--;) if ($[n][0] == e) return;
            t.convert = V(e, t), $.push([e, t]);
          }
        }), C($, function (e) {
          W[e[0]] = e[1];
        }), W.convert = function (e) {
          return W.runInContext.convert(e)(void 0);
        }, W.placeholder = W, C(I(W), function (e) {
          C(r.realToAlias[e] || [], function (t) {
            W[t] = W[e];
          });
        }), W;
      };
    },
    "./node_modules/lodash/fp/_falseOptions.js": function node_modulesLodashFp_falseOptionsJs(e, t) {
      e.exports = {
        cap: !1,
        curry: !1,
        fixed: !1,
        immutable: !1,
        rearg: !1
      };
    },
    "./node_modules/lodash/fp/_mapping.js": function node_modulesLodashFp_mappingJs(e, t) {
      t.aliasToReal = {
        each: "forEach",
        eachRight: "forEachRight",
        entries: "toPairs",
        entriesIn: "toPairsIn",
        extend: "assignIn",
        extendAll: "assignInAll",
        extendAllWith: "assignInAllWith",
        extendWith: "assignInWith",
        first: "head",
        conforms: "conformsTo",
        matches: "isMatch",
        property: "get",
        __: "placeholder",
        F: "stubFalse",
        T: "stubTrue",
        all: "every",
        allPass: "overEvery",
        always: "constant",
        any: "some",
        anyPass: "overSome",
        apply: "spread",
        assoc: "set",
        assocPath: "set",
        complement: "negate",
        compose: "flowRight",
        contains: "includes",
        dissoc: "unset",
        dissocPath: "unset",
        dropLast: "dropRight",
        dropLastWhile: "dropRightWhile",
        equals: "isEqual",
        identical: "eq",
        indexBy: "keyBy",
        init: "initial",
        invertObj: "invert",
        juxt: "over",
        omitAll: "omit",
        nAry: "ary",
        path: "get",
        pathEq: "matchesProperty",
        pathOr: "getOr",
        paths: "at",
        pickAll: "pick",
        pipe: "flow",
        pluck: "map",
        prop: "get",
        propEq: "matchesProperty",
        propOr: "getOr",
        props: "at",
        symmetricDifference: "xor",
        symmetricDifferenceBy: "xorBy",
        symmetricDifferenceWith: "xorWith",
        takeLast: "takeRight",
        takeLastWhile: "takeRightWhile",
        unapply: "rest",
        unnest: "flatten",
        useWith: "overArgs",
        where: "conformsTo",
        whereEq: "isMatch",
        zipObj: "zipObject"
      }, t.aryMethod = {
        1: ["assignAll", "assignInAll", "attempt", "castArray", "ceil", "create", "curry", "curryRight", "defaultsAll", "defaultsDeepAll", "floor", "flow", "flowRight", "fromPairs", "invert", "iteratee", "memoize", "method", "mergeAll", "methodOf", "mixin", "nthArg", "over", "overEvery", "overSome", "rest", "reverse", "round", "runInContext", "spread", "template", "trim", "trimEnd", "trimStart", "uniqueId", "words", "zipAll"],
        2: ["add", "after", "ary", "assign", "assignAllWith", "assignIn", "assignInAllWith", "at", "before", "bind", "bindAll", "bindKey", "chunk", "cloneDeepWith", "cloneWith", "concat", "conformsTo", "countBy", "curryN", "curryRightN", "debounce", "defaults", "defaultsDeep", "defaultTo", "delay", "difference", "divide", "drop", "dropRight", "dropRightWhile", "dropWhile", "endsWith", "eq", "every", "filter", "find", "findIndex", "findKey", "findLast", "findLastIndex", "findLastKey", "flatMap", "flatMapDeep", "flattenDepth", "forEach", "forEachRight", "forIn", "forInRight", "forOwn", "forOwnRight", "get", "groupBy", "gt", "gte", "has", "hasIn", "includes", "indexOf", "intersection", "invertBy", "invoke", "invokeMap", "isEqual", "isMatch", "join", "keyBy", "lastIndexOf", "lt", "lte", "map", "mapKeys", "mapValues", "matchesProperty", "maxBy", "meanBy", "merge", "mergeAllWith", "minBy", "multiply", "nth", "omit", "omitBy", "overArgs", "pad", "padEnd", "padStart", "parseInt", "partial", "partialRight", "partition", "pick", "pickBy", "propertyOf", "pull", "pullAll", "pullAt", "random", "range", "rangeRight", "rearg", "reject", "remove", "repeat", "restFrom", "result", "sampleSize", "some", "sortBy", "sortedIndex", "sortedIndexOf", "sortedLastIndex", "sortedLastIndexOf", "sortedUniqBy", "split", "spreadFrom", "startsWith", "subtract", "sumBy", "take", "takeRight", "takeRightWhile", "takeWhile", "tap", "throttle", "thru", "times", "trimChars", "trimCharsEnd", "trimCharsStart", "truncate", "union", "uniqBy", "uniqWith", "unset", "unzipWith", "without", "wrap", "xor", "zip", "zipObject", "zipObjectDeep"],
        3: ["assignInWith", "assignWith", "clamp", "differenceBy", "differenceWith", "findFrom", "findIndexFrom", "findLastFrom", "findLastIndexFrom", "getOr", "includesFrom", "indexOfFrom", "inRange", "intersectionBy", "intersectionWith", "invokeArgs", "invokeArgsMap", "isEqualWith", "isMatchWith", "flatMapDepth", "lastIndexOfFrom", "mergeWith", "orderBy", "padChars", "padCharsEnd", "padCharsStart", "pullAllBy", "pullAllWith", "rangeStep", "rangeStepRight", "reduce", "reduceRight", "replace", "set", "slice", "sortedIndexBy", "sortedLastIndexBy", "transform", "unionBy", "unionWith", "update", "xorBy", "xorWith", "zipWith"],
        4: ["fill", "setWith", "updateWith"]
      }, t.aryRearg = {
        2: [1, 0],
        3: [2, 0, 1],
        4: [3, 2, 0, 1]
      }, t.iterateeAry = {
        dropRightWhile: 1,
        dropWhile: 1,
        every: 1,
        filter: 1,
        find: 1,
        findFrom: 1,
        findIndex: 1,
        findIndexFrom: 1,
        findKey: 1,
        findLast: 1,
        findLastFrom: 1,
        findLastIndex: 1,
        findLastIndexFrom: 1,
        findLastKey: 1,
        flatMap: 1,
        flatMapDeep: 1,
        flatMapDepth: 1,
        forEach: 1,
        forEachRight: 1,
        forIn: 1,
        forInRight: 1,
        forOwn: 1,
        forOwnRight: 1,
        map: 1,
        mapKeys: 1,
        mapValues: 1,
        partition: 1,
        reduce: 2,
        reduceRight: 2,
        reject: 1,
        remove: 1,
        some: 1,
        takeRightWhile: 1,
        takeWhile: 1,
        times: 1,
        transform: 2
      }, t.iterateeRearg = {
        mapKeys: [1],
        reduceRight: [1, 0]
      }, t.methodRearg = {
        assignInAllWith: [1, 0],
        assignInWith: [1, 2, 0],
        assignAllWith: [1, 0],
        assignWith: [1, 2, 0],
        differenceBy: [1, 2, 0],
        differenceWith: [1, 2, 0],
        getOr: [2, 1, 0],
        intersectionBy: [1, 2, 0],
        intersectionWith: [1, 2, 0],
        isEqualWith: [1, 2, 0],
        isMatchWith: [2, 1, 0],
        mergeAllWith: [1, 0],
        mergeWith: [1, 2, 0],
        padChars: [2, 1, 0],
        padCharsEnd: [2, 1, 0],
        padCharsStart: [2, 1, 0],
        pullAllBy: [2, 1, 0],
        pullAllWith: [2, 1, 0],
        rangeStep: [1, 2, 0],
        rangeStepRight: [1, 2, 0],
        setWith: [3, 1, 2, 0],
        sortedIndexBy: [2, 1, 0],
        sortedLastIndexBy: [2, 1, 0],
        unionBy: [1, 2, 0],
        unionWith: [1, 2, 0],
        updateWith: [3, 1, 2, 0],
        xorBy: [1, 2, 0],
        xorWith: [1, 2, 0],
        zipWith: [1, 2, 0]
      }, t.methodSpread = {
        assignAll: {
          start: 0
        },
        assignAllWith: {
          start: 0
        },
        assignInAll: {
          start: 0
        },
        assignInAllWith: {
          start: 0
        },
        defaultsAll: {
          start: 0
        },
        defaultsDeepAll: {
          start: 0
        },
        invokeArgs: {
          start: 2
        },
        invokeArgsMap: {
          start: 2
        },
        mergeAll: {
          start: 0
        },
        mergeAllWith: {
          start: 0
        },
        partial: {
          start: 1
        },
        partialRight: {
          start: 1
        },
        without: {
          start: 1
        },
        zipAll: {
          start: 0
        }
      }, t.mutate = {
        array: {
          fill: !0,
          pull: !0,
          pullAll: !0,
          pullAllBy: !0,
          pullAllWith: !0,
          pullAt: !0,
          remove: !0,
          reverse: !0
        },
        object: {
          assign: !0,
          assignAll: !0,
          assignAllWith: !0,
          assignIn: !0,
          assignInAll: !0,
          assignInAllWith: !0,
          assignInWith: !0,
          assignWith: !0,
          defaults: !0,
          defaultsAll: !0,
          defaultsDeep: !0,
          defaultsDeepAll: !0,
          merge: !0,
          mergeAll: !0,
          mergeAllWith: !0,
          mergeWith: !0
        },
        set: {
          set: !0,
          setWith: !0,
          unset: !0,
          update: !0,
          updateWith: !0
        }
      }, t.realToAlias = function () {
        var e = Object.prototype.hasOwnProperty,
          n = t.aliasToReal,
          r = {};
        for (var i in n) {
          var o = n[i];
          e.call(r, o) ? r[o].push(i) : r[o] = [i];
        }
        return r;
      }(), t.remap = {
        assignAll: "assign",
        assignAllWith: "assignWith",
        assignInAll: "assignIn",
        assignInAllWith: "assignInWith",
        curryN: "curry",
        curryRightN: "curryRight",
        defaultsAll: "defaults",
        defaultsDeepAll: "defaultsDeep",
        findFrom: "find",
        findIndexFrom: "findIndex",
        findLastFrom: "findLast",
        findLastIndexFrom: "findLastIndex",
        getOr: "get",
        includesFrom: "includes",
        indexOfFrom: "indexOf",
        invokeArgs: "invoke",
        invokeArgsMap: "invokeMap",
        lastIndexOfFrom: "lastIndexOf",
        mergeAll: "merge",
        mergeAllWith: "mergeWith",
        padChars: "pad",
        padCharsEnd: "padEnd",
        padCharsStart: "padStart",
        propertyOf: "get",
        rangeStep: "range",
        rangeStepRight: "rangeRight",
        restFrom: "rest",
        spreadFrom: "spread",
        trimChars: "trim",
        trimCharsEnd: "trimEnd",
        trimCharsStart: "trimStart",
        zipAll: "zip"
      }, t.skipFixed = {
        castArray: !0,
        flow: !0,
        flowRight: !0,
        iteratee: !0,
        mixin: !0,
        rearg: !0,
        runInContext: !0
      }, t.skipRearg = {
        add: !0,
        assign: !0,
        assignIn: !0,
        bind: !0,
        bindKey: !0,
        concat: !0,
        difference: !0,
        divide: !0,
        eq: !0,
        gt: !0,
        gte: !0,
        isEqual: !0,
        lt: !0,
        lte: !0,
        matchesProperty: !0,
        merge: !0,
        multiply: !0,
        overArgs: !0,
        partial: !0,
        partialRight: !0,
        propertyOf: !0,
        random: !0,
        range: !0,
        rangeRight: !0,
        subtract: !0,
        zip: !0,
        zipObject: !0,
        zipObjectDeep: !0
      };
    },
    "./node_modules/lodash/fp/_util.js": function node_modulesLodashFp_utilJs(e, t, n) {
      e.exports = {
        ary: n("./node_modules/lodash/ary.js"),
        assign: n("./node_modules/lodash/_baseAssign.js"),
        clone: n("./node_modules/lodash/clone.js"),
        curry: n("./node_modules/lodash/curry.js"),
        forEach: n("./node_modules/lodash/_arrayEach.js"),
        isArray: n("./node_modules/lodash/isArray.js"),
        isError: n("./node_modules/lodash/isError.js"),
        isFunction: n("./node_modules/lodash/isFunction.js"),
        isWeakMap: n("./node_modules/lodash/isWeakMap.js"),
        iteratee: n("./node_modules/lodash/iteratee.js"),
        keys: n("./node_modules/lodash/_baseKeys.js"),
        rearg: n("./node_modules/lodash/rearg.js"),
        toInteger: n("./node_modules/lodash/toInteger.js"),
        toPath: n("./node_modules/lodash/toPath.js")
      };
    },
    "./node_modules/lodash/fp/convert.js": function node_modulesLodashFpConvertJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/_baseConvert.js"),
        i = n("./node_modules/lodash/fp/_util.js");
      e.exports = function (e, t, n) {
        return r(i, e, t, n);
      };
    },
    "./node_modules/lodash/fp/filter.js": function node_modulesLodashFpFilterJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("filter", n("./node_modules/lodash/filter.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/flatMap.js": function node_modulesLodashFpFlatMapJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("flatMap", n("./node_modules/lodash/flatMap.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/flow.js": function node_modulesLodashFpFlowJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("flow", n("./node_modules/lodash/flow.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/identity.js": function node_modulesLodashFpIdentityJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("identity", n("./node_modules/lodash/identity.js"), n("./node_modules/lodash/fp/_falseOptions.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/map.js": function node_modulesLodashFpMapJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("map", n("./node_modules/lodash/map.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/placeholder.js": function node_modulesLodashFpPlaceholderJs(e, t) {
      e.exports = {};
    },
    "./node_modules/lodash/fp/split.js": function node_modulesLodashFpSplitJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("split", n("./node_modules/lodash/split.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/toArray.js": function node_modulesLodashFpToArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("toArray", n("./node_modules/lodash/toArray.js"), n("./node_modules/lodash/fp/_falseOptions.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/fp/uniq.js": function node_modulesLodashFpUniqJs(e, t, n) {
      var r = n("./node_modules/lodash/fp/convert.js")("uniq", n("./node_modules/lodash/uniq.js"), n("./node_modules/lodash/fp/_falseOptions.js"));
      r.placeholder = n("./node_modules/lodash/fp/placeholder.js"), e.exports = r;
    },
    "./node_modules/lodash/get.js": function node_modulesLodashGetJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGet.js");
      e.exports = function (e, t, n) {
        var i = null == e ? void 0 : r(e, t);
        return void 0 === i ? n : i;
      };
    },
    "./node_modules/lodash/has.js": function node_modulesLodashHasJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseHas.js"),
        i = n("./node_modules/lodash/_hasPath.js");
      e.exports = function (e, t) {
        return null != e && i(e, t, r);
      };
    },
    "./node_modules/lodash/hasIn.js": function node_modulesLodashHasInJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseHasIn.js"),
        i = n("./node_modules/lodash/_hasPath.js");
      e.exports = function (e, t) {
        return null != e && i(e, t, r);
      };
    },
    "./node_modules/lodash/head.js": function node_modulesLodashHeadJs(e, t) {
      e.exports = function (e) {
        return e && e.length ? e[0] : void 0;
      };
    },
    "./node_modules/lodash/identity.js": function node_modulesLodashIdentityJs(e, t) {
      e.exports = function (e) {
        return e;
      };
    },
    "./node_modules/lodash/inRange.js": function node_modulesLodashInRangeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseInRange.js"),
        i = n("./node_modules/lodash/toFinite.js"),
        o = n("./node_modules/lodash/toNumber.js");
      e.exports = function (e, t, n) {
        return t = i(t), void 0 === n ? (n = t, t = 0) : n = i(n), e = o(e), r(e, t, n);
      };
    },
    "./node_modules/lodash/includes.js": function node_modulesLodashIncludesJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIndexOf.js"),
        i = n("./node_modules/lodash/isArrayLike.js"),
        o = n("./node_modules/lodash/isString.js"),
        a = n("./node_modules/lodash/toInteger.js"),
        s = n("./node_modules/lodash/values.js"),
        l = Math.max;
      e.exports = function (e, t, n, u) {
        e = i(e) ? e : s(e), n = n && !u ? a(n) : 0;
        var c = e.length;
        return n < 0 && (n = l(c + n, 0)), o(e) ? n <= c && e.indexOf(t, n) > -1 : !!c && r(e, t, n) > -1;
      };
    },
    "./node_modules/lodash/intersection.js": function node_modulesLodashIntersectionJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayMap.js"),
        i = n("./node_modules/lodash/_baseIntersection.js"),
        o = n("./node_modules/lodash/_baseRest.js"),
        a = n("./node_modules/lodash/_castArrayLikeObject.js"),
        s = o(function (e) {
          var t = r(e, a);
          return t.length && t[0] === e[0] ? i(t) : [];
        });
      e.exports = s;
    },
    "./node_modules/lodash/invert.js": function node_modulesLodashInvertJs(e, t, n) {
      var r = n("./node_modules/lodash/constant.js"),
        i = n("./node_modules/lodash/_createInverter.js"),
        o = n("./node_modules/lodash/identity.js"),
        a = Object.prototype.toString,
        s = i(function (e, t, n) {
          null != t && "function" != typeof t.toString && (t = a.call(t)), e[t] = n;
        }, r(o));
      e.exports = s;
    },
    "./node_modules/lodash/invoke.js": function node_modulesLodashInvokeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseInvoke.js"),
        i = n("./node_modules/lodash/_baseRest.js")(r);
      e.exports = i;
    },
    "./node_modules/lodash/isArguments.js": function node_modulesLodashIsArgumentsJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsArguments.js"),
        i = n("./node_modules/lodash/isObjectLike.js"),
        o = Object.prototype,
        a = o.hasOwnProperty,
        s = o.propertyIsEnumerable,
        l = r(function () {
          return arguments;
        }()) ? r : function (e) {
          return i(e) && a.call(e, "callee") && !s.call(e, "callee");
        };
      e.exports = l;
    },
    "./node_modules/lodash/isArray.js": function node_modulesLodashIsArrayJs(e, t) {
      var n = Array.isArray;
      e.exports = n;
    },
    "./node_modules/lodash/isArrayLike.js": function node_modulesLodashIsArrayLikeJs(e, t, n) {
      var r = n("./node_modules/lodash/isFunction.js"),
        i = n("./node_modules/lodash/isLength.js");
      e.exports = function (e) {
        return null != e && i(e.length) && !r(e);
      };
    },
    "./node_modules/lodash/isArrayLikeObject.js": function node_modulesLodashIsArrayLikeObjectJs(e, t, n) {
      var r = n("./node_modules/lodash/isArrayLike.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return i(e) && r(e);
      };
    },
    "./node_modules/lodash/isBoolean.js": function node_modulesLodashIsBooleanJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return !0 === e || !1 === e || i(e) && "[object Boolean]" == r(e);
      };
    },
    "./node_modules/lodash/isBuffer.js": function node_modulesLodashIsBufferJs(e, t, n) {
      (function (e) {
        var r = n("./node_modules/lodash/_root.js"),
          i = n("./node_modules/lodash/stubFalse.js"),
          o = t && !t.nodeType && t,
          a = o && "object" == typeof e && e && !e.nodeType && e,
          s = a && a.exports === o ? r.Buffer : void 0,
          l = (s ? s.isBuffer : void 0) || i;
        e.exports = l;
      }).call(this, n("./node_modules/webpack/buildin/module.js")(e));
    },
    "./node_modules/lodash/isEmpty.js": function node_modulesLodashIsEmptyJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseKeys.js"),
        i = n("./node_modules/lodash/_getTag.js"),
        o = n("./node_modules/lodash/isArguments.js"),
        a = n("./node_modules/lodash/isArray.js"),
        s = n("./node_modules/lodash/isArrayLike.js"),
        l = n("./node_modules/lodash/isBuffer.js"),
        u = n("./node_modules/lodash/_isPrototype.js"),
        c = n("./node_modules/lodash/isTypedArray.js"),
        d = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        if (null == e) return !0;
        if (s(e) && (a(e) || "string" == typeof e || "function" == typeof e.splice || l(e) || c(e) || o(e))) return !e.length;
        var t = i(e);
        if ("[object Map]" == t || "[object Set]" == t) return !e.size;
        if (u(e)) return !r(e).length;
        for (var n in e) if (d.call(e, n)) return !1;
        return !0;
      };
    },
    "./node_modules/lodash/isEqual.js": function node_modulesLodashIsEqualJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsEqual.js");
      e.exports = function (e, t) {
        return r(e, t);
      };
    },
    "./node_modules/lodash/isError.js": function node_modulesLodashIsErrorJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js"),
        o = n("./node_modules/lodash/isPlainObject.js");
      e.exports = function (e) {
        if (!i(e)) return !1;
        var t = r(e);
        return "[object Error]" == t || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !o(e);
      };
    },
    "./node_modules/lodash/isFunction.js": function node_modulesLodashIsFunctionJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObject.js");
      e.exports = function (e) {
        if (!i(e)) return !1;
        var t = r(e);
        return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
      };
    },
    "./node_modules/lodash/isLength.js": function node_modulesLodashIsLengthJs(e, t) {
      e.exports = function (e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
      };
    },
    "./node_modules/lodash/isMap.js": function node_modulesLodashIsMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsMap.js"),
        i = n("./node_modules/lodash/_baseUnary.js"),
        o = n("./node_modules/lodash/_nodeUtil.js"),
        a = o && o.isMap,
        s = a ? i(a) : r;
      e.exports = s;
    },
    "./node_modules/lodash/isNil.js": function node_modulesLodashIsNilJs(e, t) {
      e.exports = function (e) {
        return null == e;
      };
    },
    "./node_modules/lodash/isNumber.js": function node_modulesLodashIsNumberJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return "number" == typeof e || i(e) && "[object Number]" == r(e);
      };
    },
    "./node_modules/lodash/isObject.js": function node_modulesLodashIsObjectJs(e, t) {
      e.exports = function (e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      };
    },
    "./node_modules/lodash/isObjectLike.js": function node_modulesLodashIsObjectLikeJs(e, t) {
      e.exports = function (e) {
        return null != e && "object" == typeof e;
      };
    },
    "./node_modules/lodash/isPlainObject.js": function node_modulesLodashIsPlainObjectJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/_getPrototype.js"),
        o = n("./node_modules/lodash/isObjectLike.js"),
        a = Function.prototype,
        s = Object.prototype,
        l = a.toString,
        u = s.hasOwnProperty,
        c = l.call(Object);
      e.exports = function (e) {
        if (!o(e) || "[object Object]" != r(e)) return !1;
        var t = i(e);
        if (null === t) return !0;
        var n = u.call(t, "constructor") && t.constructor;
        return "function" == typeof n && n instanceof n && l.call(n) == c;
      };
    },
    "./node_modules/lodash/isRegExp.js": function node_modulesLodashIsRegExpJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsRegExp.js"),
        i = n("./node_modules/lodash/_baseUnary.js"),
        o = n("./node_modules/lodash/_nodeUtil.js"),
        a = o && o.isRegExp,
        s = a ? i(a) : r;
      e.exports = s;
    },
    "./node_modules/lodash/isSet.js": function node_modulesLodashIsSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsSet.js"),
        i = n("./node_modules/lodash/_baseUnary.js"),
        o = n("./node_modules/lodash/_nodeUtil.js"),
        a = o && o.isSet,
        s = a ? i(a) : r;
      e.exports = s;
    },
    "./node_modules/lodash/isString.js": function node_modulesLodashIsStringJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isArray.js"),
        o = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return "string" == typeof e || !i(e) && o(e) && "[object String]" == r(e);
      };
    },
    "./node_modules/lodash/isSymbol.js": function node_modulesLodashIsSymbolJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseGetTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return "symbol" == typeof e || i(e) && "[object Symbol]" == r(e);
      };
    },
    "./node_modules/lodash/isTypedArray.js": function node_modulesLodashIsTypedArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseIsTypedArray.js"),
        i = n("./node_modules/lodash/_baseUnary.js"),
        o = n("./node_modules/lodash/_nodeUtil.js"),
        a = o && o.isTypedArray,
        s = a ? i(a) : r;
      e.exports = s;
    },
    "./node_modules/lodash/isUndefined.js": function node_modulesLodashIsUndefinedJs(e, t) {
      e.exports = function (e) {
        return void 0 === e;
      };
    },
    "./node_modules/lodash/isWeakMap.js": function node_modulesLodashIsWeakMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_getTag.js"),
        i = n("./node_modules/lodash/isObjectLike.js");
      e.exports = function (e) {
        return i(e) && "[object WeakMap]" == r(e);
      };
    },
    "./node_modules/lodash/iteratee.js": function node_modulesLodashIterateeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseClone.js"),
        i = n("./node_modules/lodash/_baseIteratee.js");
      e.exports = function (e) {
        return i("function" == typeof e ? e : r(e, 1));
      };
    },
    "./node_modules/lodash/keyBy.js": function node_modulesLodashKeyByJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseAssignValue.js"),
        i = n("./node_modules/lodash/_createAggregator.js")(function (e, t, n) {
          r(e, n, t);
        });
      e.exports = i;
    },
    "./node_modules/lodash/keys.js": function node_modulesLodashKeysJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayLikeKeys.js"),
        i = n("./node_modules/lodash/_baseKeys.js"),
        o = n("./node_modules/lodash/isArrayLike.js");
      e.exports = function (e) {
        return o(e) ? r(e) : i(e);
      };
    },
    "./node_modules/lodash/keysIn.js": function node_modulesLodashKeysInJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayLikeKeys.js"),
        i = n("./node_modules/lodash/_baseKeysIn.js"),
        o = n("./node_modules/lodash/isArrayLike.js");
      e.exports = function (e) {
        return o(e) ? r(e, !0) : i(e);
      };
    },
    "./node_modules/lodash/last.js": function node_modulesLodashLastJs(e, t) {
      e.exports = function (e) {
        var t = null == e ? 0 : e.length;
        return t ? e[t - 1] : void 0;
      };
    },
    "./node_modules/lodash/lodash.js": function node_modulesLodashLodashJs(e, t, n) {
      (function (e, r) {
        var i;
        /**
         * @license
         * Lodash <https://lodash.com/>
         * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
         * Released under MIT license <https://lodash.com/license>
         * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
         * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
         */
        (function () {
          var o = "Expected a function",
            a = "__lodash_placeholder__",
            s = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
            l = "[object Arguments]",
            u = "[object Array]",
            c = "[object Boolean]",
            d = "[object Date]",
            h = "[object Error]",
            f = "[object Function]",
            p = "[object GeneratorFunction]",
            m = "[object Map]",
            g = "[object Number]",
            v = "[object Object]",
            y = "[object RegExp]",
            b = "[object Set]",
            _ = "[object String]",
            x = "[object Symbol]",
            w = "[object WeakMap]",
            S = "[object ArrayBuffer]",
            A = "[object DataView]",
            E = "[object Float32Array]",
            T = "[object Float64Array]",
            M = "[object Int8Array]",
            C = "[object Int16Array]",
            k = "[object Int32Array]",
            P = "[object Uint8Array]",
            O = "[object Uint16Array]",
            R = "[object Uint32Array]",
            I = /\b__p \+= '';/g,
            j = /\b(__p \+=) '' \+/g,
            N = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            L = /&(?:amp|lt|gt|quot|#39);/g,
            D = /[&<>"']/g,
            B = RegExp(L.source),
            F = RegExp(D.source),
            z = /<%-([\s\S]+?)%>/g,
            U = /<%([\s\S]+?)%>/g,
            G = /<%=([\s\S]+?)%>/g,
            V = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            H = /^\w*$/,
            q = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            W = /[\\^$.*+?()[\]{}|]/g,
            $ = RegExp(W.source),
            X = /^\s+|\s+$/g,
            Y = /^\s+/,
            K = /\s+$/,
            Z = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            Q = /\{\n\/\* \[wrapped with (.+)\] \*/,
            J = /,? & /,
            ee = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            te = /\\(\\)?/g,
            ne = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            re = /\w*$/,
            ie = /^[-+]0x[0-9a-f]+$/i,
            oe = /^0b[01]+$/i,
            ae = /^\[object .+?Constructor\]$/,
            se = /^0o[0-7]+$/i,
            le = /^(?:0|[1-9]\d*)$/,
            ue = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            ce = /($^)/,
            de = /['\n\r\u2028\u2029\\]/g,
            he = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            fe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            pe = "[\\ud800-\\udfff]",
            me = "[" + fe + "]",
            ge = "[" + he + "]",
            ve = "\\d+",
            ye = "[\\u2700-\\u27bf]",
            be = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
            _e = "[^\\ud800-\\udfff" + fe + ve + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
            xe = "\\ud83c[\\udffb-\\udfff]",
            we = "[^\\ud800-\\udfff]",
            Se = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            Ae = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Ee = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
            Te = "(?:" + be + "|" + _e + ")",
            Me = "(?:" + Ee + "|" + _e + ")",
            Ce = "(?:" + ge + "|" + xe + ")" + "?",
            ke = "[\\ufe0e\\ufe0f]?" + Ce + ("(?:\\u200d(?:" + [we, Se, Ae].join("|") + ")[\\ufe0e\\ufe0f]?" + Ce + ")*"),
            Pe = "(?:" + [ye, Se, Ae].join("|") + ")" + ke,
            Oe = "(?:" + [we + ge + "?", ge, Se, Ae, pe].join("|") + ")",
            Re = RegExp("['’]", "g"),
            Ie = RegExp(ge, "g"),
            je = RegExp(xe + "(?=" + xe + ")|" + Oe + ke, "g"),
            Ne = RegExp([Ee + "?" + be + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [me, Ee, "$"].join("|") + ")", Me + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [me, Ee + Te, "$"].join("|") + ")", Ee + "?" + Te + "+(?:['’](?:d|ll|m|re|s|t|ve))?", Ee + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ve, Pe].join("|"), "g"),
            Le = RegExp("[\\u200d\\ud800-\\udfff" + he + "\\ufe0e\\ufe0f]"),
            De = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            Be = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            Fe = -1,
            ze = {};
          ze[E] = ze[T] = ze[M] = ze[C] = ze[k] = ze[P] = ze["[object Uint8ClampedArray]"] = ze[O] = ze[R] = !0, ze[l] = ze[u] = ze[S] = ze[c] = ze[A] = ze[d] = ze[h] = ze[f] = ze[m] = ze[g] = ze[v] = ze[y] = ze[b] = ze[_] = ze[w] = !1;
          var Ue = {};
          Ue[l] = Ue[u] = Ue[S] = Ue[A] = Ue[c] = Ue[d] = Ue[E] = Ue[T] = Ue[M] = Ue[C] = Ue[k] = Ue[m] = Ue[g] = Ue[v] = Ue[y] = Ue[b] = Ue[_] = Ue[x] = Ue[P] = Ue["[object Uint8ClampedArray]"] = Ue[O] = Ue[R] = !0, Ue[h] = Ue[f] = Ue[w] = !1;
          var Ge = {
              "\\": "\\",
              "'": "'",
              "\n": "n",
              "\r": "r",
              "\u2028": "u2028",
              "\u2029": "u2029"
            },
            Ve = parseFloat,
            He = parseInt,
            qe = "object" == typeof e && e && e.Object === Object && e,
            We = "object" == typeof self && self && self.Object === Object && self,
            $e = qe || We || Function("return this")(),
            Xe = t && !t.nodeType && t,
            Ye = Xe && "object" == typeof r && r && !r.nodeType && r,
            Ke = Ye && Ye.exports === Xe,
            Ze = Ke && qe.process,
            Qe = function () {
              try {
                var e = Ye && Ye.require && Ye.require("util").types;
                return e || Ze && Ze.binding && Ze.binding("util");
              } catch (e) {}
            }(),
            Je = Qe && Qe.isArrayBuffer,
            et = Qe && Qe.isDate,
            tt = Qe && Qe.isMap,
            nt = Qe && Qe.isRegExp,
            rt = Qe && Qe.isSet,
            it = Qe && Qe.isTypedArray;
          function ot(e, t, n) {
            switch (n.length) {
              case 0:
                return e.call(t);
              case 1:
                return e.call(t, n[0]);
              case 2:
                return e.call(t, n[0], n[1]);
              case 3:
                return e.call(t, n[0], n[1], n[2]);
            }
            return e.apply(t, n);
          }
          function at(e, t, n, r) {
            for (var i = -1, o = null == e ? 0 : e.length; ++i < o;) {
              var a = e[i];
              t(r, a, n(a), e);
            }
            return r;
          }
          function st(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e););
            return e;
          }
          function lt(e, t) {
            for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e););
            return e;
          }
          function ut(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
            return !0;
          }
          function ct(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
              var a = e[n];
              t(a, n, e) && (o[i++] = a);
            }
            return o;
          }
          function dt(e, t) {
            return !!(null == e ? 0 : e.length) && xt(e, t, 0) > -1;
          }
          function ht(e, t, n) {
            for (var r = -1, i = null == e ? 0 : e.length; ++r < i;) if (n(t, e[r])) return !0;
            return !1;
          }
          function ft(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
            return i;
          }
          function pt(e, t) {
            for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
            return e;
          }
          function mt(e, t, n, r) {
            var i = -1,
              o = null == e ? 0 : e.length;
            for (r && o && (n = e[++i]); ++i < o;) n = t(n, e[i], i, e);
            return n;
          }
          function gt(e, t, n, r) {
            var i = null == e ? 0 : e.length;
            for (r && i && (n = e[--i]); i--;) n = t(n, e[i], i, e);
            return n;
          }
          function vt(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
            return !1;
          }
          var yt = Et("length");
          function bt(e, t, n) {
            var r;
            return n(e, function (e, n, i) {
              if (t(e, n, i)) return r = n, !1;
            }), r;
          }
          function _t(e, t, n, r) {
            for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) if (t(e[o], o, e)) return o;
            return -1;
          }
          function xt(e, t, n) {
            return t == t ? function (e, t, n) {
              var r = n - 1,
                i = e.length;
              for (; ++r < i;) if (e[r] === t) return r;
              return -1;
            }(e, t, n) : _t(e, St, n);
          }
          function wt(e, t, n, r) {
            for (var i = n - 1, o = e.length; ++i < o;) if (r(e[i], t)) return i;
            return -1;
          }
          function St(e) {
            return e != e;
          }
          function At(e, t) {
            var n = null == e ? 0 : e.length;
            return n ? Ct(e, t) / n : NaN;
          }
          function Et(e) {
            return function (t) {
              return null == t ? void 0 : t[e];
            };
          }
          function Tt(e) {
            return function (t) {
              return null == e ? void 0 : e[t];
            };
          }
          function Mt(e, t, n, r, i) {
            return i(e, function (e, i, o) {
              n = r ? (r = !1, e) : t(n, e, i, o);
            }), n;
          }
          function Ct(e, t) {
            for (var n, r = -1, i = e.length; ++r < i;) {
              var o = t(e[r]);
              void 0 !== o && (n = void 0 === n ? o : n + o);
            }
            return n;
          }
          function kt(e, t) {
            for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
            return r;
          }
          function Pt(e) {
            return function (t) {
              return e(t);
            };
          }
          function Ot(e, t) {
            return ft(t, function (t) {
              return e[t];
            });
          }
          function Rt(e, t) {
            return e.has(t);
          }
          function It(e, t) {
            for (var n = -1, r = e.length; ++n < r && xt(t, e[n], 0) > -1;);
            return n;
          }
          function jt(e, t) {
            for (var n = e.length; n-- && xt(t, e[n], 0) > -1;);
            return n;
          }
          function Nt(e, t) {
            for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
            return r;
          }
          var Lt = Tt({
              "À": "A",
              "Á": "A",
              "Â": "A",
              "Ã": "A",
              "Ä": "A",
              "Å": "A",
              "à": "a",
              "á": "a",
              "â": "a",
              "ã": "a",
              "ä": "a",
              "å": "a",
              "Ç": "C",
              "ç": "c",
              "Ð": "D",
              "ð": "d",
              "È": "E",
              "É": "E",
              "Ê": "E",
              "Ë": "E",
              "è": "e",
              "é": "e",
              "ê": "e",
              "ë": "e",
              "Ì": "I",
              "Í": "I",
              "Î": "I",
              "Ï": "I",
              "ì": "i",
              "í": "i",
              "î": "i",
              "ï": "i",
              "Ñ": "N",
              "ñ": "n",
              "Ò": "O",
              "Ó": "O",
              "Ô": "O",
              "Õ": "O",
              "Ö": "O",
              "Ø": "O",
              "ò": "o",
              "ó": "o",
              "ô": "o",
              "õ": "o",
              "ö": "o",
              "ø": "o",
              "Ù": "U",
              "Ú": "U",
              "Û": "U",
              "Ü": "U",
              "ù": "u",
              "ú": "u",
              "û": "u",
              "ü": "u",
              "Ý": "Y",
              "ý": "y",
              "ÿ": "y",
              "Æ": "Ae",
              "æ": "ae",
              "Þ": "Th",
              "þ": "th",
              "ß": "ss",
              "Ā": "A",
              "Ă": "A",
              "Ą": "A",
              "ā": "a",
              "ă": "a",
              "ą": "a",
              "Ć": "C",
              "Ĉ": "C",
              "Ċ": "C",
              "Č": "C",
              "ć": "c",
              "ĉ": "c",
              "ċ": "c",
              "č": "c",
              "Ď": "D",
              "Đ": "D",
              "ď": "d",
              "đ": "d",
              "Ē": "E",
              "Ĕ": "E",
              "Ė": "E",
              "Ę": "E",
              "Ě": "E",
              "ē": "e",
              "ĕ": "e",
              "ė": "e",
              "ę": "e",
              "ě": "e",
              "Ĝ": "G",
              "Ğ": "G",
              "Ġ": "G",
              "Ģ": "G",
              "ĝ": "g",
              "ğ": "g",
              "ġ": "g",
              "ģ": "g",
              "Ĥ": "H",
              "Ħ": "H",
              "ĥ": "h",
              "ħ": "h",
              "Ĩ": "I",
              "Ī": "I",
              "Ĭ": "I",
              "Į": "I",
              "İ": "I",
              "ĩ": "i",
              "ī": "i",
              "ĭ": "i",
              "į": "i",
              "ı": "i",
              "Ĵ": "J",
              "ĵ": "j",
              "Ķ": "K",
              "ķ": "k",
              "ĸ": "k",
              "Ĺ": "L",
              "Ļ": "L",
              "Ľ": "L",
              "Ŀ": "L",
              "Ł": "L",
              "ĺ": "l",
              "ļ": "l",
              "ľ": "l",
              "ŀ": "l",
              "ł": "l",
              "Ń": "N",
              "Ņ": "N",
              "Ň": "N",
              "Ŋ": "N",
              "ń": "n",
              "ņ": "n",
              "ň": "n",
              "ŋ": "n",
              "Ō": "O",
              "Ŏ": "O",
              "Ő": "O",
              "ō": "o",
              "ŏ": "o",
              "ő": "o",
              "Ŕ": "R",
              "Ŗ": "R",
              "Ř": "R",
              "ŕ": "r",
              "ŗ": "r",
              "ř": "r",
              "Ś": "S",
              "Ŝ": "S",
              "Ş": "S",
              "Š": "S",
              "ś": "s",
              "ŝ": "s",
              "ş": "s",
              "š": "s",
              "Ţ": "T",
              "Ť": "T",
              "Ŧ": "T",
              "ţ": "t",
              "ť": "t",
              "ŧ": "t",
              "Ũ": "U",
              "Ū": "U",
              "Ŭ": "U",
              "Ů": "U",
              "Ű": "U",
              "Ų": "U",
              "ũ": "u",
              "ū": "u",
              "ŭ": "u",
              "ů": "u",
              "ű": "u",
              "ų": "u",
              "Ŵ": "W",
              "ŵ": "w",
              "Ŷ": "Y",
              "ŷ": "y",
              "Ÿ": "Y",
              "Ź": "Z",
              "Ż": "Z",
              "Ž": "Z",
              "ź": "z",
              "ż": "z",
              "ž": "z",
              "Ĳ": "IJ",
              "ĳ": "ij",
              "Œ": "Oe",
              "œ": "oe",
              "ŉ": "'n",
              "ſ": "s"
            }),
            Dt = Tt({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;"
            });
          function Bt(e) {
            return "\\" + Ge[e];
          }
          function Ft(e) {
            return Le.test(e);
          }
          function zt(e) {
            var t = -1,
              n = Array(e.size);
            return e.forEach(function (e, r) {
              n[++t] = [r, e];
            }), n;
          }
          function Ut(e, t) {
            return function (n) {
              return e(t(n));
            };
          }
          function Gt(e, t) {
            for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
              var s = e[n];
              s !== t && s !== a || (e[n] = a, o[i++] = n);
            }
            return o;
          }
          function Vt(e) {
            var t = -1,
              n = Array(e.size);
            return e.forEach(function (e) {
              n[++t] = e;
            }), n;
          }
          function Ht(e) {
            var t = -1,
              n = Array(e.size);
            return e.forEach(function (e) {
              n[++t] = [e, e];
            }), n;
          }
          function qt(e) {
            return Ft(e) ? function (e) {
              var t = je.lastIndex = 0;
              for (; je.test(e);) ++t;
              return t;
            }(e) : yt(e);
          }
          function Wt(e) {
            return Ft(e) ? function (e) {
              return e.match(je) || [];
            }(e) : function (e) {
              return e.split("");
            }(e);
          }
          var $t = Tt({
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
          });
          var Xt = function e(t) {
            var n,
              r = (t = null == t ? $e : Xt.defaults($e.Object(), t, Xt.pick($e, Be))).Array,
              i = t.Date,
              he = t.Error,
              fe = t.Function,
              pe = t.Math,
              me = t.Object,
              ge = t.RegExp,
              ve = t.String,
              ye = t.TypeError,
              be = r.prototype,
              _e = fe.prototype,
              xe = me.prototype,
              we = t["__core-js_shared__"],
              Se = _e.toString,
              Ae = xe.hasOwnProperty,
              Ee = 0,
              Te = (n = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "",
              Me = xe.toString,
              Ce = Se.call(me),
              ke = $e._,
              Pe = ge("^" + Se.call(Ae).replace(W, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              Oe = Ke ? t.Buffer : void 0,
              je = t.Symbol,
              Le = t.Uint8Array,
              Ge = Oe ? Oe.allocUnsafe : void 0,
              qe = Ut(me.getPrototypeOf, me),
              We = me.create,
              Xe = xe.propertyIsEnumerable,
              Ye = be.splice,
              Ze = je ? je.isConcatSpreadable : void 0,
              Qe = je ? je.iterator : void 0,
              yt = je ? je.toStringTag : void 0,
              Tt = function () {
                try {
                  var e = Ji(me, "defineProperty");
                  return e({}, "", {}), e;
                } catch (e) {}
              }(),
              Yt = t.clearTimeout !== $e.clearTimeout && t.clearTimeout,
              Kt = i && i.now !== $e.Date.now && i.now,
              Zt = t.setTimeout !== $e.setTimeout && t.setTimeout,
              Qt = pe.ceil,
              Jt = pe.floor,
              en = me.getOwnPropertySymbols,
              tn = Oe ? Oe.isBuffer : void 0,
              nn = t.isFinite,
              rn = be.join,
              on = Ut(me.keys, me),
              an = pe.max,
              sn = pe.min,
              ln = i.now,
              un = t.parseInt,
              cn = pe.random,
              dn = be.reverse,
              hn = Ji(t, "DataView"),
              fn = Ji(t, "Map"),
              pn = Ji(t, "Promise"),
              mn = Ji(t, "Set"),
              gn = Ji(t, "WeakMap"),
              vn = Ji(me, "create"),
              yn = gn && new gn(),
              bn = {},
              _n = Mo(hn),
              xn = Mo(fn),
              wn = Mo(pn),
              Sn = Mo(mn),
              An = Mo(gn),
              En = je ? je.prototype : void 0,
              Tn = En ? En.valueOf : void 0,
              Mn = En ? En.toString : void 0;
            function Cn(e) {
              if (Ha(e) && !Ia(e) && !(e instanceof Rn)) {
                if (e instanceof On) return e;
                if (Ae.call(e, "__wrapped__")) return Co(e);
              }
              return new On(e);
            }
            var kn = function () {
              function e() {}
              return function (t) {
                if (!Va(t)) return {};
                if (We) return We(t);
                e.prototype = t;
                var n = new e();
                return e.prototype = void 0, n;
              };
            }();
            function Pn() {}
            function On(e, t) {
              this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
            }
            function Rn(e) {
              this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
            }
            function In(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.clear(); ++t < n;) {
                var r = e[t];
                this.set(r[0], r[1]);
              }
            }
            function jn(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.clear(); ++t < n;) {
                var r = e[t];
                this.set(r[0], r[1]);
              }
            }
            function Nn(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.clear(); ++t < n;) {
                var r = e[t];
                this.set(r[0], r[1]);
              }
            }
            function Ln(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.__data__ = new Nn(); ++t < n;) this.add(e[t]);
            }
            function Dn(e) {
              var t = this.__data__ = new jn(e);
              this.size = t.size;
            }
            function Bn(e, t) {
              var n = Ia(e),
                r = !n && Ra(e),
                i = !n && !r && Da(e),
                o = !n && !r && !i && Qa(e),
                a = n || r || i || o,
                s = a ? kt(e.length, ve) : [],
                l = s.length;
              for (var u in e) !t && !Ae.call(e, u) || a && ("length" == u || i && ("offset" == u || "parent" == u) || o && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || ao(u, l)) || s.push(u);
              return s;
            }
            function Fn(e) {
              var t = e.length;
              return t ? e[Lr(0, t - 1)] : void 0;
            }
            function zn(e, t) {
              return Ao(vi(e), Yn(t, 0, e.length));
            }
            function Un(e) {
              return Ao(vi(e));
            }
            function Gn(e, t, n) {
              (void 0 !== n && !ka(e[t], n) || void 0 === n && !(t in e)) && $n(e, t, n);
            }
            function Vn(e, t, n) {
              var r = e[t];
              Ae.call(e, t) && ka(r, n) && (void 0 !== n || t in e) || $n(e, t, n);
            }
            function Hn(e, t) {
              for (var n = e.length; n--;) if (ka(e[n][0], t)) return n;
              return -1;
            }
            function qn(e, t, n, r) {
              return er(e, function (e, i, o) {
                t(r, e, n(e), o);
              }), r;
            }
            function Wn(e, t) {
              return e && yi(t, _s(t), e);
            }
            function $n(e, t, n) {
              "__proto__" == t && Tt ? Tt(e, t, {
                configurable: !0,
                enumerable: !0,
                value: n,
                writable: !0
              }) : e[t] = n;
            }
            function Xn(e, t) {
              for (var n = -1, i = t.length, o = r(i), a = null == e; ++n < i;) o[n] = a ? void 0 : ms(e, t[n]);
              return o;
            }
            function Yn(e, t, n) {
              return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
            }
            function Kn(e, t, n, r, i, o) {
              var a,
                s = 1 & t,
                u = 2 & t,
                h = 4 & t;
              if (n && (a = i ? n(e, r, i, o) : n(e)), void 0 !== a) return a;
              if (!Va(e)) return e;
              var w = Ia(e);
              if (w) {
                if (a = function (e) {
                  var t = e.length,
                    n = new e.constructor(t);
                  t && "string" == typeof e[0] && Ae.call(e, "index") && (n.index = e.index, n.input = e.input);
                  return n;
                }(e), !s) return vi(e, a);
              } else {
                var I = no(e),
                  j = I == f || I == p;
                if (Da(e)) return di(e, s);
                if (I == v || I == l || j && !i) {
                  if (a = u || j ? {} : io(e), !s) return u ? function (e, t) {
                    return yi(e, to(e), t);
                  }(e, function (e, t) {
                    return e && yi(t, xs(t), e);
                  }(a, e)) : function (e, t) {
                    return yi(e, eo(e), t);
                  }(e, Wn(a, e));
                } else {
                  if (!Ue[I]) return i ? e : {};
                  a = function (e, t, n) {
                    var r = e.constructor;
                    switch (t) {
                      case S:
                        return hi(e);
                      case c:
                      case d:
                        return new r(+e);
                      case A:
                        return function (e, t) {
                          var n = t ? hi(e.buffer) : e.buffer;
                          return new e.constructor(n, e.byteOffset, e.byteLength);
                        }(e, n);
                      case E:
                      case T:
                      case M:
                      case C:
                      case k:
                      case P:
                      case "[object Uint8ClampedArray]":
                      case O:
                      case R:
                        return fi(e, n);
                      case m:
                        return new r();
                      case g:
                      case _:
                        return new r(e);
                      case y:
                        return function (e) {
                          var t = new e.constructor(e.source, re.exec(e));
                          return t.lastIndex = e.lastIndex, t;
                        }(e);
                      case b:
                        return new r();
                      case x:
                        return i = e, Tn ? me(Tn.call(i)) : {};
                    }
                    var i;
                  }(e, I, s);
                }
              }
              o || (o = new Dn());
              var N = o.get(e);
              if (N) return N;
              o.set(e, a), Ya(e) ? e.forEach(function (r) {
                a.add(Kn(r, t, n, r, e, o));
              }) : qa(e) && e.forEach(function (r, i) {
                a.set(i, Kn(r, t, n, i, e, o));
              });
              var L = w ? void 0 : (h ? u ? Wi : qi : u ? xs : _s)(e);
              return st(L || e, function (r, i) {
                L && (r = e[i = r]), Vn(a, i, Kn(r, t, n, i, e, o));
              }), a;
            }
            function Zn(e, t, n) {
              var r = n.length;
              if (null == e) return !r;
              for (e = me(e); r--;) {
                var i = n[r],
                  o = t[i],
                  a = e[i];
                if (void 0 === a && !(i in e) || !o(a)) return !1;
              }
              return !0;
            }
            function Qn(e, t, n) {
              if ("function" != typeof e) throw new ye(o);
              return _o(function () {
                e.apply(void 0, n);
              }, t);
            }
            function Jn(e, t, n, r) {
              var i = -1,
                o = dt,
                a = !0,
                s = e.length,
                l = [],
                u = t.length;
              if (!s) return l;
              n && (t = ft(t, Pt(n))), r ? (o = ht, a = !1) : t.length >= 200 && (o = Rt, a = !1, t = new Ln(t));
              e: for (; ++i < s;) {
                var c = e[i],
                  d = null == n ? c : n(c);
                if (c = r || 0 !== c ? c : 0, a && d == d) {
                  for (var h = u; h--;) if (t[h] === d) continue e;
                  l.push(c);
                } else o(t, d, r) || l.push(c);
              }
              return l;
            }
            Cn.templateSettings = {
              escape: z,
              evaluate: U,
              interpolate: G,
              variable: "",
              imports: {
                _: Cn
              }
            }, Cn.prototype = Pn.prototype, Cn.prototype.constructor = Cn, On.prototype = kn(Pn.prototype), On.prototype.constructor = On, Rn.prototype = kn(Pn.prototype), Rn.prototype.constructor = Rn, In.prototype.clear = function () {
              this.__data__ = vn ? vn(null) : {}, this.size = 0;
            }, In.prototype.delete = function (e) {
              var t = this.has(e) && delete this.__data__[e];
              return this.size -= t ? 1 : 0, t;
            }, In.prototype.get = function (e) {
              var t = this.__data__;
              if (vn) {
                var n = t[e];
                return "__lodash_hash_undefined__" === n ? void 0 : n;
              }
              return Ae.call(t, e) ? t[e] : void 0;
            }, In.prototype.has = function (e) {
              var t = this.__data__;
              return vn ? void 0 !== t[e] : Ae.call(t, e);
            }, In.prototype.set = function (e, t) {
              var n = this.__data__;
              return this.size += this.has(e) ? 0 : 1, n[e] = vn && void 0 === t ? "__lodash_hash_undefined__" : t, this;
            }, jn.prototype.clear = function () {
              this.__data__ = [], this.size = 0;
            }, jn.prototype.delete = function (e) {
              var t = this.__data__,
                n = Hn(t, e);
              return !(n < 0) && (n == t.length - 1 ? t.pop() : Ye.call(t, n, 1), --this.size, !0);
            }, jn.prototype.get = function (e) {
              var t = this.__data__,
                n = Hn(t, e);
              return n < 0 ? void 0 : t[n][1];
            }, jn.prototype.has = function (e) {
              return Hn(this.__data__, e) > -1;
            }, jn.prototype.set = function (e, t) {
              var n = this.__data__,
                r = Hn(n, e);
              return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
            }, Nn.prototype.clear = function () {
              this.size = 0, this.__data__ = {
                hash: new In(),
                map: new (fn || jn)(),
                string: new In()
              };
            }, Nn.prototype.delete = function (e) {
              var t = Zi(this, e).delete(e);
              return this.size -= t ? 1 : 0, t;
            }, Nn.prototype.get = function (e) {
              return Zi(this, e).get(e);
            }, Nn.prototype.has = function (e) {
              return Zi(this, e).has(e);
            }, Nn.prototype.set = function (e, t) {
              var n = Zi(this, e),
                r = n.size;
              return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
            }, Ln.prototype.add = Ln.prototype.push = function (e) {
              return this.__data__.set(e, "__lodash_hash_undefined__"), this;
            }, Ln.prototype.has = function (e) {
              return this.__data__.has(e);
            }, Dn.prototype.clear = function () {
              this.__data__ = new jn(), this.size = 0;
            }, Dn.prototype.delete = function (e) {
              var t = this.__data__,
                n = t.delete(e);
              return this.size = t.size, n;
            }, Dn.prototype.get = function (e) {
              return this.__data__.get(e);
            }, Dn.prototype.has = function (e) {
              return this.__data__.has(e);
            }, Dn.prototype.set = function (e, t) {
              var n = this.__data__;
              if (n instanceof jn) {
                var r = n.__data__;
                if (!fn || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
                n = this.__data__ = new Nn(r);
              }
              return n.set(e, t), this.size = n.size, this;
            };
            var er = xi(lr),
              tr = xi(ur, !0);
            function nr(e, t) {
              var n = !0;
              return er(e, function (e, r, i) {
                return n = !!t(e, r, i);
              }), n;
            }
            function rr(e, t, n) {
              for (var r = -1, i = e.length; ++r < i;) {
                var o = e[r],
                  a = t(o);
                if (null != a && (void 0 === s ? a == a && !Za(a) : n(a, s))) var s = a,
                  l = o;
              }
              return l;
            }
            function ir(e, t) {
              var n = [];
              return er(e, function (e, r, i) {
                t(e, r, i) && n.push(e);
              }), n;
            }
            function or(e, t, n, r, i) {
              var o = -1,
                a = e.length;
              for (n || (n = oo), i || (i = []); ++o < a;) {
                var s = e[o];
                t > 0 && n(s) ? t > 1 ? or(s, t - 1, n, r, i) : pt(i, s) : r || (i[i.length] = s);
              }
              return i;
            }
            var ar = wi(),
              sr = wi(!0);
            function lr(e, t) {
              return e && ar(e, t, _s);
            }
            function ur(e, t) {
              return e && sr(e, t, _s);
            }
            function cr(e, t) {
              return ct(t, function (t) {
                return za(e[t]);
              });
            }
            function dr(e, t) {
              for (var n = 0, r = (t = si(t, e)).length; null != e && n < r;) e = e[To(t[n++])];
              return n && n == r ? e : void 0;
            }
            function hr(e, t, n) {
              var r = t(e);
              return Ia(e) ? r : pt(r, n(e));
            }
            function fr(e) {
              return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : yt && yt in me(e) ? function (e) {
                var t = Ae.call(e, yt),
                  n = e[yt];
                try {
                  e[yt] = void 0;
                  var r = !0;
                } catch (e) {}
                var i = Me.call(e);
                r && (t ? e[yt] = n : delete e[yt]);
                return i;
              }(e) : function (e) {
                return Me.call(e);
              }(e);
            }
            function pr(e, t) {
              return e > t;
            }
            function mr(e, t) {
              return null != e && Ae.call(e, t);
            }
            function gr(e, t) {
              return null != e && t in me(e);
            }
            function vr(e, t, n) {
              for (var i = n ? ht : dt, o = e[0].length, a = e.length, s = a, l = r(a), u = 1 / 0, c = []; s--;) {
                var d = e[s];
                s && t && (d = ft(d, Pt(t))), u = sn(d.length, u), l[s] = !n && (t || o >= 120 && d.length >= 120) ? new Ln(s && d) : void 0;
              }
              d = e[0];
              var h = -1,
                f = l[0];
              e: for (; ++h < o && c.length < u;) {
                var p = d[h],
                  m = t ? t(p) : p;
                if (p = n || 0 !== p ? p : 0, !(f ? Rt(f, m) : i(c, m, n))) {
                  for (s = a; --s;) {
                    var g = l[s];
                    if (!(g ? Rt(g, m) : i(e[s], m, n))) continue e;
                  }
                  f && f.push(m), c.push(p);
                }
              }
              return c;
            }
            function yr(e, t, n) {
              var r = null == (e = go(e, t = si(t, e))) ? e : e[To(Fo(t))];
              return null == r ? void 0 : ot(r, e, n);
            }
            function br(e) {
              return Ha(e) && fr(e) == l;
            }
            function _r(e, t, n, r, i) {
              return e === t || (null == e || null == t || !Ha(e) && !Ha(t) ? e != e && t != t : function (e, t, n, r, i, o) {
                var a = Ia(e),
                  s = Ia(t),
                  f = a ? u : no(e),
                  p = s ? u : no(t),
                  w = (f = f == l ? v : f) == v,
                  E = (p = p == l ? v : p) == v,
                  T = f == p;
                if (T && Da(e)) {
                  if (!Da(t)) return !1;
                  a = !0, w = !1;
                }
                if (T && !w) return o || (o = new Dn()), a || Qa(e) ? Vi(e, t, n, r, i, o) : function (e, t, n, r, i, o, a) {
                  switch (n) {
                    case A:
                      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                      e = e.buffer, t = t.buffer;
                    case S:
                      return !(e.byteLength != t.byteLength || !o(new Le(e), new Le(t)));
                    case c:
                    case d:
                    case g:
                      return ka(+e, +t);
                    case h:
                      return e.name == t.name && e.message == t.message;
                    case y:
                    case _:
                      return e == t + "";
                    case m:
                      var s = zt;
                    case b:
                      var l = 1 & r;
                      if (s || (s = Vt), e.size != t.size && !l) return !1;
                      var u = a.get(e);
                      if (u) return u == t;
                      r |= 2, a.set(e, t);
                      var f = Vi(s(e), s(t), r, i, o, a);
                      return a.delete(e), f;
                    case x:
                      if (Tn) return Tn.call(e) == Tn.call(t);
                  }
                  return !1;
                }(e, t, f, n, r, i, o);
                if (!(1 & n)) {
                  var M = w && Ae.call(e, "__wrapped__"),
                    C = E && Ae.call(t, "__wrapped__");
                  if (M || C) {
                    var k = M ? e.value() : e,
                      P = C ? t.value() : t;
                    return o || (o = new Dn()), i(k, P, n, r, o);
                  }
                }
                if (!T) return !1;
                return o || (o = new Dn()), function (e, t, n, r, i, o) {
                  var a = 1 & n,
                    s = qi(e),
                    l = s.length,
                    u = qi(t).length;
                  if (l != u && !a) return !1;
                  var c = l;
                  for (; c--;) {
                    var d = s[c];
                    if (!(a ? d in t : Ae.call(t, d))) return !1;
                  }
                  var h = o.get(e);
                  if (h && o.get(t)) return h == t;
                  var f = !0;
                  o.set(e, t), o.set(t, e);
                  var p = a;
                  for (; ++c < l;) {
                    d = s[c];
                    var m = e[d],
                      g = t[d];
                    if (r) var v = a ? r(g, m, d, t, e, o) : r(m, g, d, e, t, o);
                    if (!(void 0 === v ? m === g || i(m, g, n, r, o) : v)) {
                      f = !1;
                      break;
                    }
                    p || (p = "constructor" == d);
                  }
                  if (f && !p) {
                    var y = e.constructor,
                      b = t.constructor;
                    y == b || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof b && b instanceof b || (f = !1);
                  }
                  return o.delete(e), o.delete(t), f;
                }(e, t, n, r, i, o);
              }(e, t, n, r, _r, i));
            }
            function xr(e, t, n, r) {
              var i = n.length,
                o = i,
                a = !r;
              if (null == e) return !o;
              for (e = me(e); i--;) {
                var s = n[i];
                if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
              }
              for (; ++i < o;) {
                var l = (s = n[i])[0],
                  u = e[l],
                  c = s[1];
                if (a && s[2]) {
                  if (void 0 === u && !(l in e)) return !1;
                } else {
                  var d = new Dn();
                  if (r) var h = r(u, c, l, e, t, d);
                  if (!(void 0 === h ? _r(c, u, 3, r, d) : h)) return !1;
                }
              }
              return !0;
            }
            function wr(e) {
              return !(!Va(e) || (t = e, Te && Te in t)) && (za(e) ? Pe : ae).test(Mo(e));
              var t;
            }
            function Sr(e) {
              return "function" == typeof e ? e : null == e ? Ws : "object" == typeof e ? Ia(e) ? kr(e[0], e[1]) : Cr(e) : tl(e);
            }
            function Ar(e) {
              if (!ho(e)) return on(e);
              var t = [];
              for (var n in me(e)) Ae.call(e, n) && "constructor" != n && t.push(n);
              return t;
            }
            function Er(e) {
              if (!Va(e)) return function (e) {
                var t = [];
                if (null != e) for (var n in me(e)) t.push(n);
                return t;
              }(e);
              var t = ho(e),
                n = [];
              for (var r in e) ("constructor" != r || !t && Ae.call(e, r)) && n.push(r);
              return n;
            }
            function Tr(e, t) {
              return e < t;
            }
            function Mr(e, t) {
              var n = -1,
                i = Na(e) ? r(e.length) : [];
              return er(e, function (e, r, o) {
                i[++n] = t(e, r, o);
              }), i;
            }
            function Cr(e) {
              var t = Qi(e);
              return 1 == t.length && t[0][2] ? po(t[0][0], t[0][1]) : function (n) {
                return n === e || xr(n, e, t);
              };
            }
            function kr(e, t) {
              return lo(e) && fo(t) ? po(To(e), t) : function (n) {
                var r = ms(n, e);
                return void 0 === r && r === t ? gs(n, e) : _r(t, r, 3);
              };
            }
            function Pr(e, t, n, r, i) {
              e !== t && ar(t, function (o, a) {
                if (i || (i = new Dn()), Va(o)) !function (e, t, n, r, i, o, a) {
                  var s = yo(e, n),
                    l = yo(t, n),
                    u = a.get(l);
                  if (u) return void Gn(e, n, u);
                  var c = o ? o(s, l, n + "", e, t, a) : void 0,
                    d = void 0 === c;
                  if (d) {
                    var h = Ia(l),
                      f = !h && Da(l),
                      p = !h && !f && Qa(l);
                    c = l, h || f || p ? Ia(s) ? c = s : La(s) ? c = vi(s) : f ? (d = !1, c = di(l, !0)) : p ? (d = !1, c = fi(l, !0)) : c = [] : $a(l) || Ra(l) ? (c = s, Ra(s) ? c = as(s) : Va(s) && !za(s) || (c = io(l))) : d = !1;
                  }
                  d && (a.set(l, c), i(c, l, r, o, a), a.delete(l));
                  Gn(e, n, c);
                }(e, t, a, n, Pr, r, i);else {
                  var s = r ? r(yo(e, a), o, a + "", e, t, i) : void 0;
                  void 0 === s && (s = o), Gn(e, a, s);
                }
              }, xs);
            }
            function Or(e, t) {
              var n = e.length;
              if (n) return ao(t += t < 0 ? n : 0, n) ? e[t] : void 0;
            }
            function Rr(e, t, n) {
              var r = -1;
              return t = ft(t.length ? t : [Ws], Pt(Ki())), function (e, t) {
                var n = e.length;
                for (e.sort(t); n--;) e[n] = e[n].value;
                return e;
              }(Mr(e, function (e, n, i) {
                return {
                  criteria: ft(t, function (t) {
                    return t(e);
                  }),
                  index: ++r,
                  value: e
                };
              }), function (e, t) {
                return function (e, t, n) {
                  var r = -1,
                    i = e.criteria,
                    o = t.criteria,
                    a = i.length,
                    s = n.length;
                  for (; ++r < a;) {
                    var l = pi(i[r], o[r]);
                    if (l) {
                      if (r >= s) return l;
                      var u = n[r];
                      return l * ("desc" == u ? -1 : 1);
                    }
                  }
                  return e.index - t.index;
                }(e, t, n);
              });
            }
            function Ir(e, t, n) {
              for (var r = -1, i = t.length, o = {}; ++r < i;) {
                var a = t[r],
                  s = dr(e, a);
                n(s, a) && Ur(o, si(a, e), s);
              }
              return o;
            }
            function jr(e, t, n, r) {
              var i = r ? wt : xt,
                o = -1,
                a = t.length,
                s = e;
              for (e === t && (t = vi(t)), n && (s = ft(e, Pt(n))); ++o < a;) for (var l = 0, u = t[o], c = n ? n(u) : u; (l = i(s, c, l, r)) > -1;) s !== e && Ye.call(s, l, 1), Ye.call(e, l, 1);
              return e;
            }
            function Nr(e, t) {
              for (var n = e ? t.length : 0, r = n - 1; n--;) {
                var i = t[n];
                if (n == r || i !== o) {
                  var o = i;
                  ao(i) ? Ye.call(e, i, 1) : Jr(e, i);
                }
              }
              return e;
            }
            function Lr(e, t) {
              return e + Jt(cn() * (t - e + 1));
            }
            function Dr(e, t) {
              var n = "";
              if (!e || t < 1 || t > 9007199254740991) return n;
              do {
                t % 2 && (n += e), (t = Jt(t / 2)) && (e += e);
              } while (t);
              return n;
            }
            function Br(e, t) {
              return xo(mo(e, t, Ws), e + "");
            }
            function Fr(e) {
              return Fn(ks(e));
            }
            function zr(e, t) {
              var n = ks(e);
              return Ao(n, Yn(t, 0, n.length));
            }
            function Ur(e, t, n, r) {
              if (!Va(e)) return e;
              for (var i = -1, o = (t = si(t, e)).length, a = o - 1, s = e; null != s && ++i < o;) {
                var l = To(t[i]),
                  u = n;
                if (i != a) {
                  var c = s[l];
                  void 0 === (u = r ? r(c, l, s) : void 0) && (u = Va(c) ? c : ao(t[i + 1]) ? [] : {});
                }
                Vn(s, l, u), s = s[l];
              }
              return e;
            }
            var Gr = yn ? function (e, t) {
                return yn.set(e, t), e;
              } : Ws,
              Vr = Tt ? function (e, t) {
                return Tt(e, "toString", {
                  configurable: !0,
                  enumerable: !1,
                  value: Vs(t),
                  writable: !0
                });
              } : Ws;
            function Hr(e) {
              return Ao(ks(e));
            }
            function qr(e, t, n) {
              var i = -1,
                o = e.length;
              t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
              for (var a = r(o); ++i < o;) a[i] = e[i + t];
              return a;
            }
            function Wr(e, t) {
              var n;
              return er(e, function (e, r, i) {
                return !(n = t(e, r, i));
              }), !!n;
            }
            function $r(e, t, n) {
              var r = 0,
                i = null == e ? r : e.length;
              if ("number" == typeof t && t == t && i <= 2147483647) {
                for (; r < i;) {
                  var o = r + i >>> 1,
                    a = e[o];
                  null !== a && !Za(a) && (n ? a <= t : a < t) ? r = o + 1 : i = o;
                }
                return i;
              }
              return Xr(e, t, Ws, n);
            }
            function Xr(e, t, n, r) {
              t = n(t);
              for (var i = 0, o = null == e ? 0 : e.length, a = t != t, s = null === t, l = Za(t), u = void 0 === t; i < o;) {
                var c = Jt((i + o) / 2),
                  d = n(e[c]),
                  h = void 0 !== d,
                  f = null === d,
                  p = d == d,
                  m = Za(d);
                if (a) var g = r || p;else g = u ? p && (r || h) : s ? p && h && (r || !f) : l ? p && h && !f && (r || !m) : !f && !m && (r ? d <= t : d < t);
                g ? i = c + 1 : o = c;
              }
              return sn(o, 4294967294);
            }
            function Yr(e, t) {
              for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
                var a = e[n],
                  s = t ? t(a) : a;
                if (!n || !ka(s, l)) {
                  var l = s;
                  o[i++] = 0 === a ? 0 : a;
                }
              }
              return o;
            }
            function Kr(e) {
              return "number" == typeof e ? e : Za(e) ? NaN : +e;
            }
            function Zr(e) {
              if ("string" == typeof e) return e;
              if (Ia(e)) return ft(e, Zr) + "";
              if (Za(e)) return Mn ? Mn.call(e) : "";
              var t = e + "";
              return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Qr(e, t, n) {
              var r = -1,
                i = dt,
                o = e.length,
                a = !0,
                s = [],
                l = s;
              if (n) a = !1, i = ht;else if (o >= 200) {
                var u = t ? null : Di(e);
                if (u) return Vt(u);
                a = !1, i = Rt, l = new Ln();
              } else l = t ? [] : s;
              e: for (; ++r < o;) {
                var c = e[r],
                  d = t ? t(c) : c;
                if (c = n || 0 !== c ? c : 0, a && d == d) {
                  for (var h = l.length; h--;) if (l[h] === d) continue e;
                  t && l.push(d), s.push(c);
                } else i(l, d, n) || (l !== s && l.push(d), s.push(c));
              }
              return s;
            }
            function Jr(e, t) {
              return null == (e = go(e, t = si(t, e))) || delete e[To(Fo(t))];
            }
            function ei(e, t, n, r) {
              return Ur(e, t, n(dr(e, t)), r);
            }
            function ti(e, t, n, r) {
              for (var i = e.length, o = r ? i : -1; (r ? o-- : ++o < i) && t(e[o], o, e););
              return n ? qr(e, r ? 0 : o, r ? o + 1 : i) : qr(e, r ? o + 1 : 0, r ? i : o);
            }
            function ni(e, t) {
              var n = e;
              return n instanceof Rn && (n = n.value()), mt(t, function (e, t) {
                return t.func.apply(t.thisArg, pt([e], t.args));
              }, n);
            }
            function ri(e, t, n) {
              var i = e.length;
              if (i < 2) return i ? Qr(e[0]) : [];
              for (var o = -1, a = r(i); ++o < i;) for (var s = e[o], l = -1; ++l < i;) l != o && (a[o] = Jn(a[o] || s, e[l], t, n));
              return Qr(or(a, 1), t, n);
            }
            function ii(e, t, n) {
              for (var r = -1, i = e.length, o = t.length, a = {}; ++r < i;) {
                var s = r < o ? t[r] : void 0;
                n(a, e[r], s);
              }
              return a;
            }
            function oi(e) {
              return La(e) ? e : [];
            }
            function ai(e) {
              return "function" == typeof e ? e : Ws;
            }
            function si(e, t) {
              return Ia(e) ? e : lo(e, t) ? [e] : Eo(ss(e));
            }
            var li = Br;
            function ui(e, t, n) {
              var r = e.length;
              return n = void 0 === n ? r : n, !t && n >= r ? e : qr(e, t, n);
            }
            var ci = Yt || function (e) {
              return $e.clearTimeout(e);
            };
            function di(e, t) {
              if (t) return e.slice();
              var n = e.length,
                r = Ge ? Ge(n) : new e.constructor(n);
              return e.copy(r), r;
            }
            function hi(e) {
              var t = new e.constructor(e.byteLength);
              return new Le(t).set(new Le(e)), t;
            }
            function fi(e, t) {
              var n = t ? hi(e.buffer) : e.buffer;
              return new e.constructor(n, e.byteOffset, e.length);
            }
            function pi(e, t) {
              if (e !== t) {
                var n = void 0 !== e,
                  r = null === e,
                  i = e == e,
                  o = Za(e),
                  a = void 0 !== t,
                  s = null === t,
                  l = t == t,
                  u = Za(t);
                if (!s && !u && !o && e > t || o && a && l && !s && !u || r && a && l || !n && l || !i) return 1;
                if (!r && !o && !u && e < t || u && n && i && !r && !o || s && n && i || !a && i || !l) return -1;
              }
              return 0;
            }
            function mi(e, t, n, i) {
              for (var o = -1, a = e.length, s = n.length, l = -1, u = t.length, c = an(a - s, 0), d = r(u + c), h = !i; ++l < u;) d[l] = t[l];
              for (; ++o < s;) (h || o < a) && (d[n[o]] = e[o]);
              for (; c--;) d[l++] = e[o++];
              return d;
            }
            function gi(e, t, n, i) {
              for (var o = -1, a = e.length, s = -1, l = n.length, u = -1, c = t.length, d = an(a - l, 0), h = r(d + c), f = !i; ++o < d;) h[o] = e[o];
              for (var p = o; ++u < c;) h[p + u] = t[u];
              for (; ++s < l;) (f || o < a) && (h[p + n[s]] = e[o++]);
              return h;
            }
            function vi(e, t) {
              var n = -1,
                i = e.length;
              for (t || (t = r(i)); ++n < i;) t[n] = e[n];
              return t;
            }
            function yi(e, t, n, r) {
              var i = !n;
              n || (n = {});
              for (var o = -1, a = t.length; ++o < a;) {
                var s = t[o],
                  l = r ? r(n[s], e[s], s, n, e) : void 0;
                void 0 === l && (l = e[s]), i ? $n(n, s, l) : Vn(n, s, l);
              }
              return n;
            }
            function bi(e, t) {
              return function (n, r) {
                var i = Ia(n) ? at : qn,
                  o = t ? t() : {};
                return i(n, e, Ki(r, 2), o);
              };
            }
            function _i(e) {
              return Br(function (t, n) {
                var r = -1,
                  i = n.length,
                  o = i > 1 ? n[i - 1] : void 0,
                  a = i > 2 ? n[2] : void 0;
                for (o = e.length > 3 && "function" == typeof o ? (i--, o) : void 0, a && so(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = me(t); ++r < i;) {
                  var s = n[r];
                  s && e(t, s, r, o);
                }
                return t;
              });
            }
            function xi(e, t) {
              return function (n, r) {
                if (null == n) return n;
                if (!Na(n)) return e(n, r);
                for (var i = n.length, o = t ? i : -1, a = me(n); (t ? o-- : ++o < i) && !1 !== r(a[o], o, a););
                return n;
              };
            }
            function wi(e) {
              return function (t, n, r) {
                for (var i = -1, o = me(t), a = r(t), s = a.length; s--;) {
                  var l = a[e ? s : ++i];
                  if (!1 === n(o[l], l, o)) break;
                }
                return t;
              };
            }
            function Si(e) {
              return function (t) {
                var n = Ft(t = ss(t)) ? Wt(t) : void 0,
                  r = n ? n[0] : t.charAt(0),
                  i = n ? ui(n, 1).join("") : t.slice(1);
                return r[e]() + i;
              };
            }
            function Ai(e) {
              return function (t) {
                return mt(zs(Rs(t).replace(Re, "")), e, "");
              };
            }
            function Ei(e) {
              return function () {
                var t = arguments;
                switch (t.length) {
                  case 0:
                    return new e();
                  case 1:
                    return new e(t[0]);
                  case 2:
                    return new e(t[0], t[1]);
                  case 3:
                    return new e(t[0], t[1], t[2]);
                  case 4:
                    return new e(t[0], t[1], t[2], t[3]);
                  case 5:
                    return new e(t[0], t[1], t[2], t[3], t[4]);
                  case 6:
                    return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                  case 7:
                    return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                }
                var n = kn(e.prototype),
                  r = e.apply(n, t);
                return Va(r) ? r : n;
              };
            }
            function Ti(e) {
              return function (t, n, r) {
                var i = me(t);
                if (!Na(t)) {
                  var o = Ki(n, 3);
                  t = _s(t), n = function n(e) {
                    return o(i[e], e, i);
                  };
                }
                var a = e(t, n, r);
                return a > -1 ? i[o ? t[a] : a] : void 0;
              };
            }
            function Mi(e) {
              return Hi(function (t) {
                var n = t.length,
                  r = n,
                  i = On.prototype.thru;
                for (e && t.reverse(); r--;) {
                  var a = t[r];
                  if ("function" != typeof a) throw new ye(o);
                  if (i && !s && "wrapper" == Xi(a)) var s = new On([], !0);
                }
                for (r = s ? r : n; ++r < n;) {
                  var l = Xi(a = t[r]),
                    u = "wrapper" == l ? $i(a) : void 0;
                  s = u && uo(u[0]) && 424 == u[1] && !u[4].length && 1 == u[9] ? s[Xi(u[0])].apply(s, u[3]) : 1 == a.length && uo(a) ? s[l]() : s.thru(a);
                }
                return function () {
                  var e = arguments,
                    r = e[0];
                  if (s && 1 == e.length && Ia(r)) return s.plant(r).value();
                  for (var i = 0, o = n ? t[i].apply(this, e) : r; ++i < n;) o = t[i].call(this, o);
                  return o;
                };
              });
            }
            function Ci(e, t, n, i, o, a, s, l, u, c) {
              var d = 128 & t,
                h = 1 & t,
                f = 2 & t,
                p = 24 & t,
                m = 512 & t,
                g = f ? void 0 : Ei(e);
              return function v() {
                for (var y = arguments.length, b = r(y), _ = y; _--;) b[_] = arguments[_];
                if (p) var x = Yi(v),
                  w = Nt(b, x);
                if (i && (b = mi(b, i, o, p)), a && (b = gi(b, a, s, p)), y -= w, p && y < c) {
                  var S = Gt(b, x);
                  return Ni(e, t, Ci, v.placeholder, n, b, S, l, u, c - y);
                }
                var A = h ? n : this,
                  E = f ? A[e] : e;
                return y = b.length, l ? b = vo(b, l) : m && y > 1 && b.reverse(), d && u < y && (b.length = u), this && this !== $e && this instanceof v && (E = g || Ei(E)), E.apply(A, b);
              };
            }
            function ki(e, t) {
              return function (n, r) {
                return function (e, t, n, r) {
                  return lr(e, function (e, i, o) {
                    t(r, n(e), i, o);
                  }), r;
                }(n, e, t(r), {});
              };
            }
            function Pi(e, t) {
              return function (n, r) {
                var i;
                if (void 0 === n && void 0 === r) return t;
                if (void 0 !== n && (i = n), void 0 !== r) {
                  if (void 0 === i) return r;
                  "string" == typeof n || "string" == typeof r ? (n = Zr(n), r = Zr(r)) : (n = Kr(n), r = Kr(r)), i = e(n, r);
                }
                return i;
              };
            }
            function Oi(e) {
              return Hi(function (t) {
                return t = ft(t, Pt(Ki())), Br(function (n) {
                  var r = this;
                  return e(t, function (e) {
                    return ot(e, r, n);
                  });
                });
              });
            }
            function Ri(e, t) {
              var n = (t = void 0 === t ? " " : Zr(t)).length;
              if (n < 2) return n ? Dr(t, e) : t;
              var r = Dr(t, Qt(e / qt(t)));
              return Ft(t) ? ui(Wt(r), 0, e).join("") : r.slice(0, e);
            }
            function Ii(e) {
              return function (t, n, i) {
                return i && "number" != typeof i && so(t, n, i) && (n = i = void 0), t = ns(t), void 0 === n ? (n = t, t = 0) : n = ns(n), function (e, t, n, i) {
                  for (var o = -1, a = an(Qt((t - e) / (n || 1)), 0), s = r(a); a--;) s[i ? a : ++o] = e, e += n;
                  return s;
                }(t, n, i = void 0 === i ? t < n ? 1 : -1 : ns(i), e);
              };
            }
            function ji(e) {
              return function (t, n) {
                return "string" == typeof t && "string" == typeof n || (t = os(t), n = os(n)), e(t, n);
              };
            }
            function Ni(e, t, n, r, i, o, a, s, l, u) {
              var c = 8 & t;
              t |= c ? 32 : 64, 4 & (t &= ~(c ? 64 : 32)) || (t &= -4);
              var d = [e, t, i, c ? o : void 0, c ? a : void 0, c ? void 0 : o, c ? void 0 : a, s, l, u],
                h = n.apply(void 0, d);
              return uo(e) && bo(h, d), h.placeholder = r, wo(h, e, t);
            }
            function Li(e) {
              var t = pe[e];
              return function (e, n) {
                if (e = os(e), (n = null == n ? 0 : sn(rs(n), 292)) && nn(e)) {
                  var r = (ss(e) + "e").split("e");
                  return +((r = (ss(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
                }
                return t(e);
              };
            }
            var Di = mn && 1 / Vt(new mn([, -0]))[1] == 1 / 0 ? function (e) {
              return new mn(e);
            } : Zs;
            function Bi(e) {
              return function (t) {
                var n = no(t);
                return n == m ? zt(t) : n == b ? Ht(t) : function (e, t) {
                  return ft(t, function (t) {
                    return [t, e[t]];
                  });
                }(t, e(t));
              };
            }
            function Fi(e, t, n, i, s, l, u, c) {
              var d = 2 & t;
              if (!d && "function" != typeof e) throw new ye(o);
              var h = i ? i.length : 0;
              if (h || (t &= -97, i = s = void 0), u = void 0 === u ? u : an(rs(u), 0), c = void 0 === c ? c : rs(c), h -= s ? s.length : 0, 64 & t) {
                var f = i,
                  p = s;
                i = s = void 0;
              }
              var m = d ? void 0 : $i(e),
                g = [e, t, n, i, s, f, p, l, u, c];
              if (m && function (e, t) {
                var n = e[1],
                  r = t[1],
                  i = n | r,
                  o = i < 131,
                  s = 128 == r && 8 == n || 128 == r && 256 == n && e[7].length <= t[8] || 384 == r && t[7].length <= t[8] && 8 == n;
                if (!o && !s) return e;
                1 & r && (e[2] = t[2], i |= 1 & n ? 0 : 4);
                var l = t[3];
                if (l) {
                  var u = e[3];
                  e[3] = u ? mi(u, l, t[4]) : l, e[4] = u ? Gt(e[3], a) : t[4];
                }
                (l = t[5]) && (u = e[5], e[5] = u ? gi(u, l, t[6]) : l, e[6] = u ? Gt(e[5], a) : t[6]);
                (l = t[7]) && (e[7] = l);
                128 & r && (e[8] = null == e[8] ? t[8] : sn(e[8], t[8]));
                null == e[9] && (e[9] = t[9]);
                e[0] = t[0], e[1] = i;
              }(g, m), e = g[0], t = g[1], n = g[2], i = g[3], s = g[4], !(c = g[9] = void 0 === g[9] ? d ? 0 : e.length : an(g[9] - h, 0)) && 24 & t && (t &= -25), t && 1 != t) v = 8 == t || 16 == t ? function (e, t, n) {
                var i = Ei(e);
                return function o() {
                  for (var a = arguments.length, s = r(a), l = a, u = Yi(o); l--;) s[l] = arguments[l];
                  var c = a < 3 && s[0] !== u && s[a - 1] !== u ? [] : Gt(s, u);
                  if ((a -= c.length) < n) return Ni(e, t, Ci, o.placeholder, void 0, s, c, void 0, void 0, n - a);
                  var d = this && this !== $e && this instanceof o ? i : e;
                  return ot(d, this, s);
                };
              }(e, t, c) : 32 != t && 33 != t || s.length ? Ci.apply(void 0, g) : function (e, t, n, i) {
                var o = 1 & t,
                  a = Ei(e);
                return function t() {
                  for (var s = -1, l = arguments.length, u = -1, c = i.length, d = r(c + l), h = this && this !== $e && this instanceof t ? a : e; ++u < c;) d[u] = i[u];
                  for (; l--;) d[u++] = arguments[++s];
                  return ot(h, o ? n : this, d);
                };
              }(e, t, n, i);else var v = function (e, t, n) {
                var r = 1 & t,
                  i = Ei(e);
                return function t() {
                  var o = this && this !== $e && this instanceof t ? i : e;
                  return o.apply(r ? n : this, arguments);
                };
              }(e, t, n);
              return wo((m ? Gr : bo)(v, g), e, t);
            }
            function zi(e, t, n, r) {
              return void 0 === e || ka(e, xe[n]) && !Ae.call(r, n) ? t : e;
            }
            function Ui(e, t, n, r, i, o) {
              return Va(e) && Va(t) && (o.set(t, e), Pr(e, t, void 0, Ui, o), o.delete(t)), e;
            }
            function Gi(e) {
              return $a(e) ? void 0 : e;
            }
            function Vi(e, t, n, r, i, o) {
              var a = 1 & n,
                s = e.length,
                l = t.length;
              if (s != l && !(a && l > s)) return !1;
              var u = o.get(e);
              if (u && o.get(t)) return u == t;
              var c = -1,
                d = !0,
                h = 2 & n ? new Ln() : void 0;
              for (o.set(e, t), o.set(t, e); ++c < s;) {
                var f = e[c],
                  p = t[c];
                if (r) var m = a ? r(p, f, c, t, e, o) : r(f, p, c, e, t, o);
                if (void 0 !== m) {
                  if (m) continue;
                  d = !1;
                  break;
                }
                if (h) {
                  if (!vt(t, function (e, t) {
                    if (!Rt(h, t) && (f === e || i(f, e, n, r, o))) return h.push(t);
                  })) {
                    d = !1;
                    break;
                  }
                } else if (f !== p && !i(f, p, n, r, o)) {
                  d = !1;
                  break;
                }
              }
              return o.delete(e), o.delete(t), d;
            }
            function Hi(e) {
              return xo(mo(e, void 0, jo), e + "");
            }
            function qi(e) {
              return hr(e, _s, eo);
            }
            function Wi(e) {
              return hr(e, xs, to);
            }
            var $i = yn ? function (e) {
              return yn.get(e);
            } : Zs;
            function Xi(e) {
              for (var t = e.name + "", n = bn[t], r = Ae.call(bn, t) ? n.length : 0; r--;) {
                var i = n[r],
                  o = i.func;
                if (null == o || o == e) return i.name;
              }
              return t;
            }
            function Yi(e) {
              return (Ae.call(Cn, "placeholder") ? Cn : e).placeholder;
            }
            function Ki() {
              var e = Cn.iteratee || $s;
              return e = e === $s ? Sr : e, arguments.length ? e(arguments[0], arguments[1]) : e;
            }
            function Zi(e, t) {
              var n,
                r,
                i = e.__data__;
              return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
            }
            function Qi(e) {
              for (var t = _s(e), n = t.length; n--;) {
                var r = t[n],
                  i = e[r];
                t[n] = [r, i, fo(i)];
              }
              return t;
            }
            function Ji(e, t) {
              var n = function (e, t) {
                return null == e ? void 0 : e[t];
              }(e, t);
              return wr(n) ? n : void 0;
            }
            var eo = en ? function (e) {
                return null == e ? [] : (e = me(e), ct(en(e), function (t) {
                  return Xe.call(e, t);
                }));
              } : il,
              to = en ? function (e) {
                for (var t = []; e;) pt(t, eo(e)), e = qe(e);
                return t;
              } : il,
              no = fr;
            function ro(e, t, n) {
              for (var r = -1, i = (t = si(t, e)).length, o = !1; ++r < i;) {
                var a = To(t[r]);
                if (!(o = null != e && n(e, a))) break;
                e = e[a];
              }
              return o || ++r != i ? o : !!(i = null == e ? 0 : e.length) && Ga(i) && ao(a, i) && (Ia(e) || Ra(e));
            }
            function io(e) {
              return "function" != typeof e.constructor || ho(e) ? {} : kn(qe(e));
            }
            function oo(e) {
              return Ia(e) || Ra(e) || !!(Ze && e && e[Ze]);
            }
            function ao(e, t) {
              var n = typeof e;
              return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && le.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function so(e, t, n) {
              if (!Va(n)) return !1;
              var r = typeof t;
              return !!("number" == r ? Na(n) && ao(t, n.length) : "string" == r && t in n) && ka(n[t], e);
            }
            function lo(e, t) {
              if (Ia(e)) return !1;
              var n = typeof e;
              return !("number" != n && "symbol" != n && "boolean" != n && null != e && !Za(e)) || H.test(e) || !V.test(e) || null != t && e in me(t);
            }
            function uo(e) {
              var t = Xi(e),
                n = Cn[t];
              if ("function" != typeof n || !(t in Rn.prototype)) return !1;
              if (e === n) return !0;
              var r = $i(n);
              return !!r && e === r[0];
            }
            (hn && no(new hn(new ArrayBuffer(1))) != A || fn && no(new fn()) != m || pn && "[object Promise]" != no(pn.resolve()) || mn && no(new mn()) != b || gn && no(new gn()) != w) && (no = function no(e) {
              var t = fr(e),
                n = t == v ? e.constructor : void 0,
                r = n ? Mo(n) : "";
              if (r) switch (r) {
                case _n:
                  return A;
                case xn:
                  return m;
                case wn:
                  return "[object Promise]";
                case Sn:
                  return b;
                case An:
                  return w;
              }
              return t;
            });
            var co = we ? za : ol;
            function ho(e) {
              var t = e && e.constructor;
              return e === ("function" == typeof t && t.prototype || xe);
            }
            function fo(e) {
              return e == e && !Va(e);
            }
            function po(e, t) {
              return function (n) {
                return null != n && n[e] === t && (void 0 !== t || e in me(n));
              };
            }
            function mo(e, t, n) {
              return t = an(void 0 === t ? e.length - 1 : t, 0), function () {
                for (var i = arguments, o = -1, a = an(i.length - t, 0), s = r(a); ++o < a;) s[o] = i[t + o];
                o = -1;
                for (var l = r(t + 1); ++o < t;) l[o] = i[o];
                return l[t] = n(s), ot(e, this, l);
              };
            }
            function go(e, t) {
              return t.length < 2 ? e : dr(e, qr(t, 0, -1));
            }
            function vo(e, t) {
              for (var n = e.length, r = sn(t.length, n), i = vi(e); r--;) {
                var o = t[r];
                e[r] = ao(o, n) ? i[o] : void 0;
              }
              return e;
            }
            function yo(e, t) {
              if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
            }
            var bo = So(Gr),
              _o = Zt || function (e, t) {
                return $e.setTimeout(e, t);
              },
              xo = So(Vr);
            function wo(e, t, n) {
              var r = t + "";
              return xo(e, function (e, t) {
                var n = t.length;
                if (!n) return e;
                var r = n - 1;
                return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Z, "{\n/* [wrapped with " + t + "] */\n");
              }(r, function (e, t) {
                return st(s, function (n) {
                  var r = "_." + n[0];
                  t & n[1] && !dt(e, r) && e.push(r);
                }), e.sort();
              }(function (e) {
                var t = e.match(Q);
                return t ? t[1].split(J) : [];
              }(r), n)));
            }
            function So(e) {
              var t = 0,
                n = 0;
              return function () {
                var r = ln(),
                  i = 16 - (r - n);
                if (n = r, i > 0) {
                  if (++t >= 800) return arguments[0];
                } else t = 0;
                return e.apply(void 0, arguments);
              };
            }
            function Ao(e, t) {
              var n = -1,
                r = e.length,
                i = r - 1;
              for (t = void 0 === t ? r : t; ++n < t;) {
                var o = Lr(n, i),
                  a = e[o];
                e[o] = e[n], e[n] = a;
              }
              return e.length = t, e;
            }
            var Eo = function (e) {
              var t = Sa(e, function (e) {
                  return 500 === n.size && n.clear(), e;
                }),
                n = t.cache;
              return t;
            }(function (e) {
              var t = [];
              return 46 === e.charCodeAt(0) && t.push(""), e.replace(q, function (e, n, r, i) {
                t.push(r ? i.replace(te, "$1") : n || e);
              }), t;
            });
            function To(e) {
              if ("string" == typeof e || Za(e)) return e;
              var t = e + "";
              return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Mo(e) {
              if (null != e) {
                try {
                  return Se.call(e);
                } catch (e) {}
                try {
                  return e + "";
                } catch (e) {}
              }
              return "";
            }
            function Co(e) {
              if (e instanceof Rn) return e.clone();
              var t = new On(e.__wrapped__, e.__chain__);
              return t.__actions__ = vi(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
            }
            var ko = Br(function (e, t) {
                return La(e) ? Jn(e, or(t, 1, La, !0)) : [];
              }),
              Po = Br(function (e, t) {
                var n = Fo(t);
                return La(n) && (n = void 0), La(e) ? Jn(e, or(t, 1, La, !0), Ki(n, 2)) : [];
              }),
              Oo = Br(function (e, t) {
                var n = Fo(t);
                return La(n) && (n = void 0), La(e) ? Jn(e, or(t, 1, La, !0), void 0, n) : [];
              });
            function Ro(e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var i = null == n ? 0 : rs(n);
              return i < 0 && (i = an(r + i, 0)), _t(e, Ki(t, 3), i);
            }
            function Io(e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var i = r - 1;
              return void 0 !== n && (i = rs(n), i = n < 0 ? an(r + i, 0) : sn(i, r - 1)), _t(e, Ki(t, 3), i, !0);
            }
            function jo(e) {
              return (null == e ? 0 : e.length) ? or(e, 1) : [];
            }
            function No(e) {
              return e && e.length ? e[0] : void 0;
            }
            var Lo = Br(function (e) {
                var t = ft(e, oi);
                return t.length && t[0] === e[0] ? vr(t) : [];
              }),
              Do = Br(function (e) {
                var t = Fo(e),
                  n = ft(e, oi);
                return t === Fo(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? vr(n, Ki(t, 2)) : [];
              }),
              Bo = Br(function (e) {
                var t = Fo(e),
                  n = ft(e, oi);
                return (t = "function" == typeof t ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? vr(n, void 0, t) : [];
              });
            function Fo(e) {
              var t = null == e ? 0 : e.length;
              return t ? e[t - 1] : void 0;
            }
            var zo = Br(Uo);
            function Uo(e, t) {
              return e && e.length && t && t.length ? jr(e, t) : e;
            }
            var Go = Hi(function (e, t) {
              var n = null == e ? 0 : e.length,
                r = Xn(e, t);
              return Nr(e, ft(t, function (e) {
                return ao(e, n) ? +e : e;
              }).sort(pi)), r;
            });
            function Vo(e) {
              return null == e ? e : dn.call(e);
            }
            var Ho = Br(function (e) {
                return Qr(or(e, 1, La, !0));
              }),
              qo = Br(function (e) {
                var t = Fo(e);
                return La(t) && (t = void 0), Qr(or(e, 1, La, !0), Ki(t, 2));
              }),
              Wo = Br(function (e) {
                var t = Fo(e);
                return t = "function" == typeof t ? t : void 0, Qr(or(e, 1, La, !0), void 0, t);
              });
            function $o(e) {
              if (!e || !e.length) return [];
              var t = 0;
              return e = ct(e, function (e) {
                if (La(e)) return t = an(e.length, t), !0;
              }), kt(t, function (t) {
                return ft(e, Et(t));
              });
            }
            function Xo(e, t) {
              if (!e || !e.length) return [];
              var n = $o(e);
              return null == t ? n : ft(n, function (e) {
                return ot(t, void 0, e);
              });
            }
            var Yo = Br(function (e, t) {
                return La(e) ? Jn(e, t) : [];
              }),
              Ko = Br(function (e) {
                return ri(ct(e, La));
              }),
              Zo = Br(function (e) {
                var t = Fo(e);
                return La(t) && (t = void 0), ri(ct(e, La), Ki(t, 2));
              }),
              Qo = Br(function (e) {
                var t = Fo(e);
                return t = "function" == typeof t ? t : void 0, ri(ct(e, La), void 0, t);
              }),
              Jo = Br($o);
            var ea = Br(function (e) {
              var t = e.length,
                n = t > 1 ? e[t - 1] : void 0;
              return n = "function" == typeof n ? (e.pop(), n) : void 0, Xo(e, n);
            });
            function ta(e) {
              var t = Cn(e);
              return t.__chain__ = !0, t;
            }
            function na(e, t) {
              return t(e);
            }
            var ra = Hi(function (e) {
              var t = e.length,
                n = t ? e[0] : 0,
                r = this.__wrapped__,
                i = function i(t) {
                  return Xn(t, e);
                };
              return !(t > 1 || this.__actions__.length) && r instanceof Rn && ao(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
                func: na,
                args: [i],
                thisArg: void 0
              }), new On(r, this.__chain__).thru(function (e) {
                return t && !e.length && e.push(void 0), e;
              })) : this.thru(i);
            });
            var ia = bi(function (e, t, n) {
              Ae.call(e, n) ? ++e[n] : $n(e, n, 1);
            });
            var oa = Ti(Ro),
              aa = Ti(Io);
            function sa(e, t) {
              return (Ia(e) ? st : er)(e, Ki(t, 3));
            }
            function la(e, t) {
              return (Ia(e) ? lt : tr)(e, Ki(t, 3));
            }
            var ua = bi(function (e, t, n) {
              Ae.call(e, n) ? e[n].push(t) : $n(e, n, [t]);
            });
            var ca = Br(function (e, t, n) {
                var i = -1,
                  o = "function" == typeof t,
                  a = Na(e) ? r(e.length) : [];
                return er(e, function (e) {
                  a[++i] = o ? ot(t, e, n) : yr(e, t, n);
                }), a;
              }),
              da = bi(function (e, t, n) {
                $n(e, n, t);
              });
            function ha(e, t) {
              return (Ia(e) ? ft : Mr)(e, Ki(t, 3));
            }
            var fa = bi(function (e, t, n) {
              e[n ? 0 : 1].push(t);
            }, function () {
              return [[], []];
            });
            var pa = Br(function (e, t) {
                if (null == e) return [];
                var n = t.length;
                return n > 1 && so(e, t[0], t[1]) ? t = [] : n > 2 && so(t[0], t[1], t[2]) && (t = [t[0]]), Rr(e, or(t, 1), []);
              }),
              ma = Kt || function () {
                return $e.Date.now();
              };
            function ga(e, t, n) {
              return t = n ? void 0 : t, Fi(e, 128, void 0, void 0, void 0, void 0, t = e && null == t ? e.length : t);
            }
            function va(e, t) {
              var n;
              if ("function" != typeof t) throw new ye(o);
              return e = rs(e), function () {
                return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
              };
            }
            var ya = Br(function (e, t, n) {
                var r = 1;
                if (n.length) {
                  var i = Gt(n, Yi(ya));
                  r |= 32;
                }
                return Fi(e, r, t, n, i);
              }),
              ba = Br(function (e, t, n) {
                var r = 3;
                if (n.length) {
                  var i = Gt(n, Yi(ba));
                  r |= 32;
                }
                return Fi(t, r, e, n, i);
              });
            function _a(e, t, n) {
              var r,
                i,
                a,
                s,
                l,
                u,
                c = 0,
                d = !1,
                h = !1,
                f = !0;
              if ("function" != typeof e) throw new ye(o);
              function p(t) {
                var n = r,
                  o = i;
                return r = i = void 0, c = t, s = e.apply(o, n);
              }
              function m(e) {
                return c = e, l = _o(v, t), d ? p(e) : s;
              }
              function g(e) {
                var n = e - u;
                return void 0 === u || n >= t || n < 0 || h && e - c >= a;
              }
              function v() {
                var e = ma();
                if (g(e)) return y(e);
                l = _o(v, function (e) {
                  var n = t - (e - u);
                  return h ? sn(n, a - (e - c)) : n;
                }(e));
              }
              function y(e) {
                return l = void 0, f && r ? p(e) : (r = i = void 0, s);
              }
              function b() {
                var e = ma(),
                  n = g(e);
                if (r = arguments, i = this, u = e, n) {
                  if (void 0 === l) return m(u);
                  if (h) return ci(l), l = _o(v, t), p(u);
                }
                return void 0 === l && (l = _o(v, t)), s;
              }
              return t = os(t) || 0, Va(n) && (d = !!n.leading, a = (h = "maxWait" in n) ? an(os(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f), b.cancel = function () {
                void 0 !== l && ci(l), c = 0, r = u = i = l = void 0;
              }, b.flush = function () {
                return void 0 === l ? s : y(ma());
              }, b;
            }
            var xa = Br(function (e, t) {
                return Qn(e, 1, t);
              }),
              wa = Br(function (e, t, n) {
                return Qn(e, os(t) || 0, n);
              });
            function Sa(e, t) {
              if ("function" != typeof e || null != t && "function" != typeof t) throw new ye(o);
              var n = function n() {
                var r = arguments,
                  i = t ? t.apply(this, r) : r[0],
                  o = n.cache;
                if (o.has(i)) return o.get(i);
                var a = e.apply(this, r);
                return n.cache = o.set(i, a) || o, a;
              };
              return n.cache = new (Sa.Cache || Nn)(), n;
            }
            function Aa(e) {
              if ("function" != typeof e) throw new ye(o);
              return function () {
                var t = arguments;
                switch (t.length) {
                  case 0:
                    return !e.call(this);
                  case 1:
                    return !e.call(this, t[0]);
                  case 2:
                    return !e.call(this, t[0], t[1]);
                  case 3:
                    return !e.call(this, t[0], t[1], t[2]);
                }
                return !e.apply(this, t);
              };
            }
            Sa.Cache = Nn;
            var Ea = li(function (e, t) {
                var n = (t = 1 == t.length && Ia(t[0]) ? ft(t[0], Pt(Ki())) : ft(or(t, 1), Pt(Ki()))).length;
                return Br(function (r) {
                  for (var i = -1, o = sn(r.length, n); ++i < o;) r[i] = t[i].call(this, r[i]);
                  return ot(e, this, r);
                });
              }),
              Ta = Br(function (e, t) {
                return Fi(e, 32, void 0, t, Gt(t, Yi(Ta)));
              }),
              Ma = Br(function (e, t) {
                return Fi(e, 64, void 0, t, Gt(t, Yi(Ma)));
              }),
              Ca = Hi(function (e, t) {
                return Fi(e, 256, void 0, void 0, void 0, t);
              });
            function ka(e, t) {
              return e === t || e != e && t != t;
            }
            var Pa = ji(pr),
              Oa = ji(function (e, t) {
                return e >= t;
              }),
              Ra = br(function () {
                return arguments;
              }()) ? br : function (e) {
                return Ha(e) && Ae.call(e, "callee") && !Xe.call(e, "callee");
              },
              Ia = r.isArray,
              ja = Je ? Pt(Je) : function (e) {
                return Ha(e) && fr(e) == S;
              };
            function Na(e) {
              return null != e && Ga(e.length) && !za(e);
            }
            function La(e) {
              return Ha(e) && Na(e);
            }
            var Da = tn || ol,
              Ba = et ? Pt(et) : function (e) {
                return Ha(e) && fr(e) == d;
              };
            function Fa(e) {
              if (!Ha(e)) return !1;
              var t = fr(e);
              return t == h || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !$a(e);
            }
            function za(e) {
              if (!Va(e)) return !1;
              var t = fr(e);
              return t == f || t == p || "[object AsyncFunction]" == t || "[object Proxy]" == t;
            }
            function Ua(e) {
              return "number" == typeof e && e == rs(e);
            }
            function Ga(e) {
              return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
            }
            function Va(e) {
              var t = typeof e;
              return null != e && ("object" == t || "function" == t);
            }
            function Ha(e) {
              return null != e && "object" == typeof e;
            }
            var qa = tt ? Pt(tt) : function (e) {
              return Ha(e) && no(e) == m;
            };
            function Wa(e) {
              return "number" == typeof e || Ha(e) && fr(e) == g;
            }
            function $a(e) {
              if (!Ha(e) || fr(e) != v) return !1;
              var t = qe(e);
              if (null === t) return !0;
              var n = Ae.call(t, "constructor") && t.constructor;
              return "function" == typeof n && n instanceof n && Se.call(n) == Ce;
            }
            var Xa = nt ? Pt(nt) : function (e) {
              return Ha(e) && fr(e) == y;
            };
            var Ya = rt ? Pt(rt) : function (e) {
              return Ha(e) && no(e) == b;
            };
            function Ka(e) {
              return "string" == typeof e || !Ia(e) && Ha(e) && fr(e) == _;
            }
            function Za(e) {
              return "symbol" == typeof e || Ha(e) && fr(e) == x;
            }
            var Qa = it ? Pt(it) : function (e) {
              return Ha(e) && Ga(e.length) && !!ze[fr(e)];
            };
            var Ja = ji(Tr),
              es = ji(function (e, t) {
                return e <= t;
              });
            function ts(e) {
              if (!e) return [];
              if (Na(e)) return Ka(e) ? Wt(e) : vi(e);
              if (Qe && e[Qe]) return function (e) {
                for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
                return n;
              }(e[Qe]());
              var t = no(e);
              return (t == m ? zt : t == b ? Vt : ks)(e);
            }
            function ns(e) {
              return e ? (e = os(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
            }
            function rs(e) {
              var t = ns(e),
                n = t % 1;
              return t == t ? n ? t - n : t : 0;
            }
            function is(e) {
              return e ? Yn(rs(e), 0, 4294967295) : 0;
            }
            function os(e) {
              if ("number" == typeof e) return e;
              if (Za(e)) return NaN;
              if (Va(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = Va(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(X, "");
              var n = oe.test(e);
              return n || se.test(e) ? He(e.slice(2), n ? 2 : 8) : ie.test(e) ? NaN : +e;
            }
            function as(e) {
              return yi(e, xs(e));
            }
            function ss(e) {
              return null == e ? "" : Zr(e);
            }
            var ls = _i(function (e, t) {
                if (ho(t) || Na(t)) yi(t, _s(t), e);else for (var n in t) Ae.call(t, n) && Vn(e, n, t[n]);
              }),
              us = _i(function (e, t) {
                yi(t, xs(t), e);
              }),
              cs = _i(function (e, t, n, r) {
                yi(t, xs(t), e, r);
              }),
              ds = _i(function (e, t, n, r) {
                yi(t, _s(t), e, r);
              }),
              hs = Hi(Xn);
            var fs = Br(function (e, t) {
                e = me(e);
                var n = -1,
                  r = t.length,
                  i = r > 2 ? t[2] : void 0;
                for (i && so(t[0], t[1], i) && (r = 1); ++n < r;) for (var o = t[n], a = xs(o), s = -1, l = a.length; ++s < l;) {
                  var u = a[s],
                    c = e[u];
                  (void 0 === c || ka(c, xe[u]) && !Ae.call(e, u)) && (e[u] = o[u]);
                }
                return e;
              }),
              ps = Br(function (e) {
                return e.push(void 0, Ui), ot(Ss, void 0, e);
              });
            function ms(e, t, n) {
              var r = null == e ? void 0 : dr(e, t);
              return void 0 === r ? n : r;
            }
            function gs(e, t) {
              return null != e && ro(e, t, gr);
            }
            var vs = ki(function (e, t, n) {
                null != t && "function" != typeof t.toString && (t = Me.call(t)), e[t] = n;
              }, Vs(Ws)),
              ys = ki(function (e, t, n) {
                null != t && "function" != typeof t.toString && (t = Me.call(t)), Ae.call(e, t) ? e[t].push(n) : e[t] = [n];
              }, Ki),
              bs = Br(yr);
            function _s(e) {
              return Na(e) ? Bn(e) : Ar(e);
            }
            function xs(e) {
              return Na(e) ? Bn(e, !0) : Er(e);
            }
            var ws = _i(function (e, t, n) {
                Pr(e, t, n);
              }),
              Ss = _i(function (e, t, n, r) {
                Pr(e, t, n, r);
              }),
              As = Hi(function (e, t) {
                var n = {};
                if (null == e) return n;
                var r = !1;
                t = ft(t, function (t) {
                  return t = si(t, e), r || (r = t.length > 1), t;
                }), yi(e, Wi(e), n), r && (n = Kn(n, 7, Gi));
                for (var i = t.length; i--;) Jr(n, t[i]);
                return n;
              });
            var Es = Hi(function (e, t) {
              return null == e ? {} : function (e, t) {
                return Ir(e, t, function (t, n) {
                  return gs(e, n);
                });
              }(e, t);
            });
            function Ts(e, t) {
              if (null == e) return {};
              var n = ft(Wi(e), function (e) {
                return [e];
              });
              return t = Ki(t), Ir(e, n, function (e, n) {
                return t(e, n[0]);
              });
            }
            var Ms = Bi(_s),
              Cs = Bi(xs);
            function ks(e) {
              return null == e ? [] : Ot(e, _s(e));
            }
            var Ps = Ai(function (e, t, n) {
              return t = t.toLowerCase(), e + (n ? Os(t) : t);
            });
            function Os(e) {
              return Fs(ss(e).toLowerCase());
            }
            function Rs(e) {
              return (e = ss(e)) && e.replace(ue, Lt).replace(Ie, "");
            }
            var Is = Ai(function (e, t, n) {
                return e + (n ? "-" : "") + t.toLowerCase();
              }),
              js = Ai(function (e, t, n) {
                return e + (n ? " " : "") + t.toLowerCase();
              }),
              Ns = Si("toLowerCase");
            var Ls = Ai(function (e, t, n) {
              return e + (n ? "_" : "") + t.toLowerCase();
            });
            var Ds = Ai(function (e, t, n) {
              return e + (n ? " " : "") + Fs(t);
            });
            var Bs = Ai(function (e, t, n) {
                return e + (n ? " " : "") + t.toUpperCase();
              }),
              Fs = Si("toUpperCase");
            function zs(e, t, n) {
              return e = ss(e), void 0 === (t = n ? void 0 : t) ? function (e) {
                return De.test(e);
              }(e) ? function (e) {
                return e.match(Ne) || [];
              }(e) : function (e) {
                return e.match(ee) || [];
              }(e) : e.match(t) || [];
            }
            var Us = Br(function (e, t) {
                try {
                  return ot(e, void 0, t);
                } catch (e) {
                  return Fa(e) ? e : new he(e);
                }
              }),
              Gs = Hi(function (e, t) {
                return st(t, function (t) {
                  t = To(t), $n(e, t, ya(e[t], e));
                }), e;
              });
            function Vs(e) {
              return function () {
                return e;
              };
            }
            var Hs = Mi(),
              qs = Mi(!0);
            function Ws(e) {
              return e;
            }
            function $s(e) {
              return Sr("function" == typeof e ? e : Kn(e, 1));
            }
            var Xs = Br(function (e, t) {
                return function (n) {
                  return yr(n, e, t);
                };
              }),
              Ys = Br(function (e, t) {
                return function (n) {
                  return yr(e, n, t);
                };
              });
            function Ks(e, t, n) {
              var r = _s(t),
                i = cr(t, r);
              null != n || Va(t) && (i.length || !r.length) || (n = t, t = e, e = this, i = cr(t, _s(t)));
              var o = !(Va(n) && "chain" in n && !n.chain),
                a = za(e);
              return st(i, function (n) {
                var r = t[n];
                e[n] = r, a && (e.prototype[n] = function () {
                  var t = this.__chain__;
                  if (o || t) {
                    var n = e(this.__wrapped__),
                      i = n.__actions__ = vi(this.__actions__);
                    return i.push({
                      func: r,
                      args: arguments,
                      thisArg: e
                    }), n.__chain__ = t, n;
                  }
                  return r.apply(e, pt([this.value()], arguments));
                });
              }), e;
            }
            function Zs() {}
            var Qs = Oi(ft),
              Js = Oi(ut),
              el = Oi(vt);
            function tl(e) {
              return lo(e) ? Et(To(e)) : function (e) {
                return function (t) {
                  return dr(t, e);
                };
              }(e);
            }
            var nl = Ii(),
              rl = Ii(!0);
            function il() {
              return [];
            }
            function ol() {
              return !1;
            }
            var al = Pi(function (e, t) {
                return e + t;
              }, 0),
              sl = Li("ceil"),
              ll = Pi(function (e, t) {
                return e / t;
              }, 1),
              ul = Li("floor");
            var cl,
              dl = Pi(function (e, t) {
                return e * t;
              }, 1),
              hl = Li("round"),
              fl = Pi(function (e, t) {
                return e - t;
              }, 0);
            return Cn.after = function (e, t) {
              if ("function" != typeof t) throw new ye(o);
              return e = rs(e), function () {
                if (--e < 1) return t.apply(this, arguments);
              };
            }, Cn.ary = ga, Cn.assign = ls, Cn.assignIn = us, Cn.assignInWith = cs, Cn.assignWith = ds, Cn.at = hs, Cn.before = va, Cn.bind = ya, Cn.bindAll = Gs, Cn.bindKey = ba, Cn.castArray = function () {
              if (!arguments.length) return [];
              var e = arguments[0];
              return Ia(e) ? e : [e];
            }, Cn.chain = ta, Cn.chunk = function (e, t, n) {
              t = (n ? so(e, t, n) : void 0 === t) ? 1 : an(rs(t), 0);
              var i = null == e ? 0 : e.length;
              if (!i || t < 1) return [];
              for (var o = 0, a = 0, s = r(Qt(i / t)); o < i;) s[a++] = qr(e, o, o += t);
              return s;
            }, Cn.compact = function (e) {
              for (var t = -1, n = null == e ? 0 : e.length, r = 0, i = []; ++t < n;) {
                var o = e[t];
                o && (i[r++] = o);
              }
              return i;
            }, Cn.concat = function () {
              var e = arguments.length;
              if (!e) return [];
              for (var t = r(e - 1), n = arguments[0], i = e; i--;) t[i - 1] = arguments[i];
              return pt(Ia(n) ? vi(n) : [n], or(t, 1));
            }, Cn.cond = function (e) {
              var t = null == e ? 0 : e.length,
                n = Ki();
              return e = t ? ft(e, function (e) {
                if ("function" != typeof e[1]) throw new ye(o);
                return [n(e[0]), e[1]];
              }) : [], Br(function (n) {
                for (var r = -1; ++r < t;) {
                  var i = e[r];
                  if (ot(i[0], this, n)) return ot(i[1], this, n);
                }
              });
            }, Cn.conforms = function (e) {
              return function (e) {
                var t = _s(e);
                return function (n) {
                  return Zn(n, e, t);
                };
              }(Kn(e, 1));
            }, Cn.constant = Vs, Cn.countBy = ia, Cn.create = function (e, t) {
              var n = kn(e);
              return null == t ? n : Wn(n, t);
            }, Cn.curry = function e(t, n, r) {
              var i = Fi(t, 8, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
              return i.placeholder = e.placeholder, i;
            }, Cn.curryRight = function e(t, n, r) {
              var i = Fi(t, 16, void 0, void 0, void 0, void 0, void 0, n = r ? void 0 : n);
              return i.placeholder = e.placeholder, i;
            }, Cn.debounce = _a, Cn.defaults = fs, Cn.defaultsDeep = ps, Cn.defer = xa, Cn.delay = wa, Cn.difference = ko, Cn.differenceBy = Po, Cn.differenceWith = Oo, Cn.drop = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? qr(e, (t = n || void 0 === t ? 1 : rs(t)) < 0 ? 0 : t, r) : [];
            }, Cn.dropRight = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? qr(e, 0, (t = r - (t = n || void 0 === t ? 1 : rs(t))) < 0 ? 0 : t) : [];
            }, Cn.dropRightWhile = function (e, t) {
              return e && e.length ? ti(e, Ki(t, 3), !0, !0) : [];
            }, Cn.dropWhile = function (e, t) {
              return e && e.length ? ti(e, Ki(t, 3), !0) : [];
            }, Cn.fill = function (e, t, n, r) {
              var i = null == e ? 0 : e.length;
              return i ? (n && "number" != typeof n && so(e, t, n) && (n = 0, r = i), function (e, t, n, r) {
                var i = e.length;
                for ((n = rs(n)) < 0 && (n = -n > i ? 0 : i + n), (r = void 0 === r || r > i ? i : rs(r)) < 0 && (r += i), r = n > r ? 0 : is(r); n < r;) e[n++] = t;
                return e;
              }(e, t, n, r)) : [];
            }, Cn.filter = function (e, t) {
              return (Ia(e) ? ct : ir)(e, Ki(t, 3));
            }, Cn.flatMap = function (e, t) {
              return or(ha(e, t), 1);
            }, Cn.flatMapDeep = function (e, t) {
              return or(ha(e, t), 1 / 0);
            }, Cn.flatMapDepth = function (e, t, n) {
              return n = void 0 === n ? 1 : rs(n), or(ha(e, t), n);
            }, Cn.flatten = jo, Cn.flattenDeep = function (e) {
              return (null == e ? 0 : e.length) ? or(e, 1 / 0) : [];
            }, Cn.flattenDepth = function (e, t) {
              return (null == e ? 0 : e.length) ? or(e, t = void 0 === t ? 1 : rs(t)) : [];
            }, Cn.flip = function (e) {
              return Fi(e, 512);
            }, Cn.flow = Hs, Cn.flowRight = qs, Cn.fromPairs = function (e) {
              for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
                var i = e[t];
                r[i[0]] = i[1];
              }
              return r;
            }, Cn.functions = function (e) {
              return null == e ? [] : cr(e, _s(e));
            }, Cn.functionsIn = function (e) {
              return null == e ? [] : cr(e, xs(e));
            }, Cn.groupBy = ua, Cn.initial = function (e) {
              return (null == e ? 0 : e.length) ? qr(e, 0, -1) : [];
            }, Cn.intersection = Lo, Cn.intersectionBy = Do, Cn.intersectionWith = Bo, Cn.invert = vs, Cn.invertBy = ys, Cn.invokeMap = ca, Cn.iteratee = $s, Cn.keyBy = da, Cn.keys = _s, Cn.keysIn = xs, Cn.map = ha, Cn.mapKeys = function (e, t) {
              var n = {};
              return t = Ki(t, 3), lr(e, function (e, r, i) {
                $n(n, t(e, r, i), e);
              }), n;
            }, Cn.mapValues = function (e, t) {
              var n = {};
              return t = Ki(t, 3), lr(e, function (e, r, i) {
                $n(n, r, t(e, r, i));
              }), n;
            }, Cn.matches = function (e) {
              return Cr(Kn(e, 1));
            }, Cn.matchesProperty = function (e, t) {
              return kr(e, Kn(t, 1));
            }, Cn.memoize = Sa, Cn.merge = ws, Cn.mergeWith = Ss, Cn.method = Xs, Cn.methodOf = Ys, Cn.mixin = Ks, Cn.negate = Aa, Cn.nthArg = function (e) {
              return e = rs(e), Br(function (t) {
                return Or(t, e);
              });
            }, Cn.omit = As, Cn.omitBy = function (e, t) {
              return Ts(e, Aa(Ki(t)));
            }, Cn.once = function (e) {
              return va(2, e);
            }, Cn.orderBy = function (e, t, n, r) {
              return null == e ? [] : (Ia(t) || (t = null == t ? [] : [t]), Ia(n = r ? void 0 : n) || (n = null == n ? [] : [n]), Rr(e, t, n));
            }, Cn.over = Qs, Cn.overArgs = Ea, Cn.overEvery = Js, Cn.overSome = el, Cn.partial = Ta, Cn.partialRight = Ma, Cn.partition = fa, Cn.pick = Es, Cn.pickBy = Ts, Cn.property = tl, Cn.propertyOf = function (e) {
              return function (t) {
                return null == e ? void 0 : dr(e, t);
              };
            }, Cn.pull = zo, Cn.pullAll = Uo, Cn.pullAllBy = function (e, t, n) {
              return e && e.length && t && t.length ? jr(e, t, Ki(n, 2)) : e;
            }, Cn.pullAllWith = function (e, t, n) {
              return e && e.length && t && t.length ? jr(e, t, void 0, n) : e;
            }, Cn.pullAt = Go, Cn.range = nl, Cn.rangeRight = rl, Cn.rearg = Ca, Cn.reject = function (e, t) {
              return (Ia(e) ? ct : ir)(e, Aa(Ki(t, 3)));
            }, Cn.remove = function (e, t) {
              var n = [];
              if (!e || !e.length) return n;
              var r = -1,
                i = [],
                o = e.length;
              for (t = Ki(t, 3); ++r < o;) {
                var a = e[r];
                t(a, r, e) && (n.push(a), i.push(r));
              }
              return Nr(e, i), n;
            }, Cn.rest = function (e, t) {
              if ("function" != typeof e) throw new ye(o);
              return Br(e, t = void 0 === t ? t : rs(t));
            }, Cn.reverse = Vo, Cn.sampleSize = function (e, t, n) {
              return t = (n ? so(e, t, n) : void 0 === t) ? 1 : rs(t), (Ia(e) ? zn : zr)(e, t);
            }, Cn.set = function (e, t, n) {
              return null == e ? e : Ur(e, t, n);
            }, Cn.setWith = function (e, t, n, r) {
              return r = "function" == typeof r ? r : void 0, null == e ? e : Ur(e, t, n, r);
            }, Cn.shuffle = function (e) {
              return (Ia(e) ? Un : Hr)(e);
            }, Cn.slice = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? (n && "number" != typeof n && so(e, t, n) ? (t = 0, n = r) : (t = null == t ? 0 : rs(t), n = void 0 === n ? r : rs(n)), qr(e, t, n)) : [];
            }, Cn.sortBy = pa, Cn.sortedUniq = function (e) {
              return e && e.length ? Yr(e) : [];
            }, Cn.sortedUniqBy = function (e, t) {
              return e && e.length ? Yr(e, Ki(t, 2)) : [];
            }, Cn.split = function (e, t, n) {
              return n && "number" != typeof n && so(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = ss(e)) && ("string" == typeof t || null != t && !Xa(t)) && !(t = Zr(t)) && Ft(e) ? ui(Wt(e), 0, n) : e.split(t, n) : [];
            }, Cn.spread = function (e, t) {
              if ("function" != typeof e) throw new ye(o);
              return t = null == t ? 0 : an(rs(t), 0), Br(function (n) {
                var r = n[t],
                  i = ui(n, 0, t);
                return r && pt(i, r), ot(e, this, i);
              });
            }, Cn.tail = function (e) {
              var t = null == e ? 0 : e.length;
              return t ? qr(e, 1, t) : [];
            }, Cn.take = function (e, t, n) {
              return e && e.length ? qr(e, 0, (t = n || void 0 === t ? 1 : rs(t)) < 0 ? 0 : t) : [];
            }, Cn.takeRight = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? qr(e, (t = r - (t = n || void 0 === t ? 1 : rs(t))) < 0 ? 0 : t, r) : [];
            }, Cn.takeRightWhile = function (e, t) {
              return e && e.length ? ti(e, Ki(t, 3), !1, !0) : [];
            }, Cn.takeWhile = function (e, t) {
              return e && e.length ? ti(e, Ki(t, 3)) : [];
            }, Cn.tap = function (e, t) {
              return t(e), e;
            }, Cn.throttle = function (e, t, n) {
              var r = !0,
                i = !0;
              if ("function" != typeof e) throw new ye(o);
              return Va(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), _a(e, t, {
                leading: r,
                maxWait: t,
                trailing: i
              });
            }, Cn.thru = na, Cn.toArray = ts, Cn.toPairs = Ms, Cn.toPairsIn = Cs, Cn.toPath = function (e) {
              return Ia(e) ? ft(e, To) : Za(e) ? [e] : vi(Eo(ss(e)));
            }, Cn.toPlainObject = as, Cn.transform = function (e, t, n) {
              var r = Ia(e),
                i = r || Da(e) || Qa(e);
              if (t = Ki(t, 4), null == n) {
                var o = e && e.constructor;
                n = i ? r ? new o() : [] : Va(e) && za(o) ? kn(qe(e)) : {};
              }
              return (i ? st : lr)(e, function (e, r, i) {
                return t(n, e, r, i);
              }), n;
            }, Cn.unary = function (e) {
              return ga(e, 1);
            }, Cn.union = Ho, Cn.unionBy = qo, Cn.unionWith = Wo, Cn.uniq = function (e) {
              return e && e.length ? Qr(e) : [];
            }, Cn.uniqBy = function (e, t) {
              return e && e.length ? Qr(e, Ki(t, 2)) : [];
            }, Cn.uniqWith = function (e, t) {
              return t = "function" == typeof t ? t : void 0, e && e.length ? Qr(e, void 0, t) : [];
            }, Cn.unset = function (e, t) {
              return null == e || Jr(e, t);
            }, Cn.unzip = $o, Cn.unzipWith = Xo, Cn.update = function (e, t, n) {
              return null == e ? e : ei(e, t, ai(n));
            }, Cn.updateWith = function (e, t, n, r) {
              return r = "function" == typeof r ? r : void 0, null == e ? e : ei(e, t, ai(n), r);
            }, Cn.values = ks, Cn.valuesIn = function (e) {
              return null == e ? [] : Ot(e, xs(e));
            }, Cn.without = Yo, Cn.words = zs, Cn.wrap = function (e, t) {
              return Ta(ai(t), e);
            }, Cn.xor = Ko, Cn.xorBy = Zo, Cn.xorWith = Qo, Cn.zip = Jo, Cn.zipObject = function (e, t) {
              return ii(e || [], t || [], Vn);
            }, Cn.zipObjectDeep = function (e, t) {
              return ii(e || [], t || [], Ur);
            }, Cn.zipWith = ea, Cn.entries = Ms, Cn.entriesIn = Cs, Cn.extend = us, Cn.extendWith = cs, Ks(Cn, Cn), Cn.add = al, Cn.attempt = Us, Cn.camelCase = Ps, Cn.capitalize = Os, Cn.ceil = sl, Cn.clamp = function (e, t, n) {
              return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = os(n)) == n ? n : 0), void 0 !== t && (t = (t = os(t)) == t ? t : 0), Yn(os(e), t, n);
            }, Cn.clone = function (e) {
              return Kn(e, 4);
            }, Cn.cloneDeep = function (e) {
              return Kn(e, 5);
            }, Cn.cloneDeepWith = function (e, t) {
              return Kn(e, 5, t = "function" == typeof t ? t : void 0);
            }, Cn.cloneWith = function (e, t) {
              return Kn(e, 4, t = "function" == typeof t ? t : void 0);
            }, Cn.conformsTo = function (e, t) {
              return null == t || Zn(e, t, _s(t));
            }, Cn.deburr = Rs, Cn.defaultTo = function (e, t) {
              return null == e || e != e ? t : e;
            }, Cn.divide = ll, Cn.endsWith = function (e, t, n) {
              e = ss(e), t = Zr(t);
              var r = e.length,
                i = n = void 0 === n ? r : Yn(rs(n), 0, r);
              return (n -= t.length) >= 0 && e.slice(n, i) == t;
            }, Cn.eq = ka, Cn.escape = function (e) {
              return (e = ss(e)) && F.test(e) ? e.replace(D, Dt) : e;
            }, Cn.escapeRegExp = function (e) {
              return (e = ss(e)) && $.test(e) ? e.replace(W, "\\$&") : e;
            }, Cn.every = function (e, t, n) {
              var r = Ia(e) ? ut : nr;
              return n && so(e, t, n) && (t = void 0), r(e, Ki(t, 3));
            }, Cn.find = oa, Cn.findIndex = Ro, Cn.findKey = function (e, t) {
              return bt(e, Ki(t, 3), lr);
            }, Cn.findLast = aa, Cn.findLastIndex = Io, Cn.findLastKey = function (e, t) {
              return bt(e, Ki(t, 3), ur);
            }, Cn.floor = ul, Cn.forEach = sa, Cn.forEachRight = la, Cn.forIn = function (e, t) {
              return null == e ? e : ar(e, Ki(t, 3), xs);
            }, Cn.forInRight = function (e, t) {
              return null == e ? e : sr(e, Ki(t, 3), xs);
            }, Cn.forOwn = function (e, t) {
              return e && lr(e, Ki(t, 3));
            }, Cn.forOwnRight = function (e, t) {
              return e && ur(e, Ki(t, 3));
            }, Cn.get = ms, Cn.gt = Pa, Cn.gte = Oa, Cn.has = function (e, t) {
              return null != e && ro(e, t, mr);
            }, Cn.hasIn = gs, Cn.head = No, Cn.identity = Ws, Cn.includes = function (e, t, n, r) {
              e = Na(e) ? e : ks(e), n = n && !r ? rs(n) : 0;
              var i = e.length;
              return n < 0 && (n = an(i + n, 0)), Ka(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && xt(e, t, n) > -1;
            }, Cn.indexOf = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var i = null == n ? 0 : rs(n);
              return i < 0 && (i = an(r + i, 0)), xt(e, t, i);
            }, Cn.inRange = function (e, t, n) {
              return t = ns(t), void 0 === n ? (n = t, t = 0) : n = ns(n), function (e, t, n) {
                return e >= sn(t, n) && e < an(t, n);
              }(e = os(e), t, n);
            }, Cn.invoke = bs, Cn.isArguments = Ra, Cn.isArray = Ia, Cn.isArrayBuffer = ja, Cn.isArrayLike = Na, Cn.isArrayLikeObject = La, Cn.isBoolean = function (e) {
              return !0 === e || !1 === e || Ha(e) && fr(e) == c;
            }, Cn.isBuffer = Da, Cn.isDate = Ba, Cn.isElement = function (e) {
              return Ha(e) && 1 === e.nodeType && !$a(e);
            }, Cn.isEmpty = function (e) {
              if (null == e) return !0;
              if (Na(e) && (Ia(e) || "string" == typeof e || "function" == typeof e.splice || Da(e) || Qa(e) || Ra(e))) return !e.length;
              var t = no(e);
              if (t == m || t == b) return !e.size;
              if (ho(e)) return !Ar(e).length;
              for (var n in e) if (Ae.call(e, n)) return !1;
              return !0;
            }, Cn.isEqual = function (e, t) {
              return _r(e, t);
            }, Cn.isEqualWith = function (e, t, n) {
              var r = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
              return void 0 === r ? _r(e, t, void 0, n) : !!r;
            }, Cn.isError = Fa, Cn.isFinite = function (e) {
              return "number" == typeof e && nn(e);
            }, Cn.isFunction = za, Cn.isInteger = Ua, Cn.isLength = Ga, Cn.isMap = qa, Cn.isMatch = function (e, t) {
              return e === t || xr(e, t, Qi(t));
            }, Cn.isMatchWith = function (e, t, n) {
              return n = "function" == typeof n ? n : void 0, xr(e, t, Qi(t), n);
            }, Cn.isNaN = function (e) {
              return Wa(e) && e != +e;
            }, Cn.isNative = function (e) {
              if (co(e)) throw new he("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
              return wr(e);
            }, Cn.isNil = function (e) {
              return null == e;
            }, Cn.isNull = function (e) {
              return null === e;
            }, Cn.isNumber = Wa, Cn.isObject = Va, Cn.isObjectLike = Ha, Cn.isPlainObject = $a, Cn.isRegExp = Xa, Cn.isSafeInteger = function (e) {
              return Ua(e) && e >= -9007199254740991 && e <= 9007199254740991;
            }, Cn.isSet = Ya, Cn.isString = Ka, Cn.isSymbol = Za, Cn.isTypedArray = Qa, Cn.isUndefined = function (e) {
              return void 0 === e;
            }, Cn.isWeakMap = function (e) {
              return Ha(e) && no(e) == w;
            }, Cn.isWeakSet = function (e) {
              return Ha(e) && "[object WeakSet]" == fr(e);
            }, Cn.join = function (e, t) {
              return null == e ? "" : rn.call(e, t);
            }, Cn.kebabCase = Is, Cn.last = Fo, Cn.lastIndexOf = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var i = r;
              return void 0 !== n && (i = (i = rs(n)) < 0 ? an(r + i, 0) : sn(i, r - 1)), t == t ? function (e, t, n) {
                for (var r = n + 1; r--;) if (e[r] === t) return r;
                return r;
              }(e, t, i) : _t(e, St, i, !0);
            }, Cn.lowerCase = js, Cn.lowerFirst = Ns, Cn.lt = Ja, Cn.lte = es, Cn.max = function (e) {
              return e && e.length ? rr(e, Ws, pr) : void 0;
            }, Cn.maxBy = function (e, t) {
              return e && e.length ? rr(e, Ki(t, 2), pr) : void 0;
            }, Cn.mean = function (e) {
              return At(e, Ws);
            }, Cn.meanBy = function (e, t) {
              return At(e, Ki(t, 2));
            }, Cn.min = function (e) {
              return e && e.length ? rr(e, Ws, Tr) : void 0;
            }, Cn.minBy = function (e, t) {
              return e && e.length ? rr(e, Ki(t, 2), Tr) : void 0;
            }, Cn.stubArray = il, Cn.stubFalse = ol, Cn.stubObject = function () {
              return {};
            }, Cn.stubString = function () {
              return "";
            }, Cn.stubTrue = function () {
              return !0;
            }, Cn.multiply = dl, Cn.nth = function (e, t) {
              return e && e.length ? Or(e, rs(t)) : void 0;
            }, Cn.noConflict = function () {
              return $e._ === this && ($e._ = ke), this;
            }, Cn.noop = Zs, Cn.now = ma, Cn.pad = function (e, t, n) {
              e = ss(e);
              var r = (t = rs(t)) ? qt(e) : 0;
              if (!t || r >= t) return e;
              var i = (t - r) / 2;
              return Ri(Jt(i), n) + e + Ri(Qt(i), n);
            }, Cn.padEnd = function (e, t, n) {
              e = ss(e);
              var r = (t = rs(t)) ? qt(e) : 0;
              return t && r < t ? e + Ri(t - r, n) : e;
            }, Cn.padStart = function (e, t, n) {
              e = ss(e);
              var r = (t = rs(t)) ? qt(e) : 0;
              return t && r < t ? Ri(t - r, n) + e : e;
            }, Cn.parseInt = function (e, t, n) {
              return n || null == t ? t = 0 : t && (t = +t), un(ss(e).replace(Y, ""), t || 0);
            }, Cn.random = function (e, t, n) {
              if (n && "boolean" != typeof n && so(e, t, n) && (t = n = void 0), void 0 === n && ("boolean" == typeof t ? (n = t, t = void 0) : "boolean" == typeof e && (n = e, e = void 0)), void 0 === e && void 0 === t ? (e = 0, t = 1) : (e = ns(e), void 0 === t ? (t = e, e = 0) : t = ns(t)), e > t) {
                var r = e;
                e = t, t = r;
              }
              if (n || e % 1 || t % 1) {
                var i = cn();
                return sn(e + i * (t - e + Ve("1e-" + ((i + "").length - 1))), t);
              }
              return Lr(e, t);
            }, Cn.reduce = function (e, t, n) {
              var r = Ia(e) ? mt : Mt,
                i = arguments.length < 3;
              return r(e, Ki(t, 4), n, i, er);
            }, Cn.reduceRight = function (e, t, n) {
              var r = Ia(e) ? gt : Mt,
                i = arguments.length < 3;
              return r(e, Ki(t, 4), n, i, tr);
            }, Cn.repeat = function (e, t, n) {
              return t = (n ? so(e, t, n) : void 0 === t) ? 1 : rs(t), Dr(ss(e), t);
            }, Cn.replace = function () {
              var e = arguments,
                t = ss(e[0]);
              return e.length < 3 ? t : t.replace(e[1], e[2]);
            }, Cn.result = function (e, t, n) {
              var r = -1,
                i = (t = si(t, e)).length;
              for (i || (i = 1, e = void 0); ++r < i;) {
                var o = null == e ? void 0 : e[To(t[r])];
                void 0 === o && (r = i, o = n), e = za(o) ? o.call(e) : o;
              }
              return e;
            }, Cn.round = hl, Cn.runInContext = e, Cn.sample = function (e) {
              return (Ia(e) ? Fn : Fr)(e);
            }, Cn.size = function (e) {
              if (null == e) return 0;
              if (Na(e)) return Ka(e) ? qt(e) : e.length;
              var t = no(e);
              return t == m || t == b ? e.size : Ar(e).length;
            }, Cn.snakeCase = Ls, Cn.some = function (e, t, n) {
              var r = Ia(e) ? vt : Wr;
              return n && so(e, t, n) && (t = void 0), r(e, Ki(t, 3));
            }, Cn.sortedIndex = function (e, t) {
              return $r(e, t);
            }, Cn.sortedIndexBy = function (e, t, n) {
              return Xr(e, t, Ki(n, 2));
            }, Cn.sortedIndexOf = function (e, t) {
              var n = null == e ? 0 : e.length;
              if (n) {
                var r = $r(e, t);
                if (r < n && ka(e[r], t)) return r;
              }
              return -1;
            }, Cn.sortedLastIndex = function (e, t) {
              return $r(e, t, !0);
            }, Cn.sortedLastIndexBy = function (e, t, n) {
              return Xr(e, t, Ki(n, 2), !0);
            }, Cn.sortedLastIndexOf = function (e, t) {
              if (null == e ? 0 : e.length) {
                var n = $r(e, t, !0) - 1;
                if (ka(e[n], t)) return n;
              }
              return -1;
            }, Cn.startCase = Ds, Cn.startsWith = function (e, t, n) {
              return e = ss(e), n = null == n ? 0 : Yn(rs(n), 0, e.length), t = Zr(t), e.slice(n, n + t.length) == t;
            }, Cn.subtract = fl, Cn.sum = function (e) {
              return e && e.length ? Ct(e, Ws) : 0;
            }, Cn.sumBy = function (e, t) {
              return e && e.length ? Ct(e, Ki(t, 2)) : 0;
            }, Cn.template = function (e, t, n) {
              var r = Cn.templateSettings;
              n && so(e, t, n) && (t = void 0), e = ss(e), t = cs({}, t, r, zi);
              var i,
                o,
                a = cs({}, t.imports, r.imports, zi),
                s = _s(a),
                l = Ot(a, s),
                u = 0,
                c = t.interpolate || ce,
                d = "__p += '",
                h = ge((t.escape || ce).source + "|" + c.source + "|" + (c === G ? ne : ce).source + "|" + (t.evaluate || ce).source + "|$", "g"),
                f = "//# sourceURL=" + (Ae.call(t, "sourceURL") ? (t.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++Fe + "]") + "\n";
              e.replace(h, function (t, n, r, a, s, l) {
                return r || (r = a), d += e.slice(u, l).replace(de, Bt), n && (i = !0, d += "' +\n__e(" + n + ") +\n'"), s && (o = !0, d += "';\n" + s + ";\n__p += '"), r && (d += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), u = l + t.length, t;
              }), d += "';\n";
              var p = Ae.call(t, "variable") && t.variable;
              p || (d = "with (obj) {\n" + d + "\n}\n"), d = (o ? d.replace(I, "") : d).replace(j, "$1").replace(N, "$1;"), d = "function(" + (p || "obj") + ") {\n" + (p ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + d + "return __p\n}";
              var m = Us(function () {
                return fe(s, f + "return " + d).apply(void 0, l);
              });
              if (m.source = d, Fa(m)) throw m;
              return m;
            }, Cn.times = function (e, t) {
              if ((e = rs(e)) < 1 || e > 9007199254740991) return [];
              var n = 4294967295,
                r = sn(e, 4294967295);
              e -= 4294967295;
              for (var i = kt(r, t = Ki(t)); ++n < e;) t(n);
              return i;
            }, Cn.toFinite = ns, Cn.toInteger = rs, Cn.toLength = is, Cn.toLower = function (e) {
              return ss(e).toLowerCase();
            }, Cn.toNumber = os, Cn.toSafeInteger = function (e) {
              return e ? Yn(rs(e), -9007199254740991, 9007199254740991) : 0 === e ? e : 0;
            }, Cn.toString = ss, Cn.toUpper = function (e) {
              return ss(e).toUpperCase();
            }, Cn.trim = function (e, t, n) {
              if ((e = ss(e)) && (n || void 0 === t)) return e.replace(X, "");
              if (!e || !(t = Zr(t))) return e;
              var r = Wt(e),
                i = Wt(t);
              return ui(r, It(r, i), jt(r, i) + 1).join("");
            }, Cn.trimEnd = function (e, t, n) {
              if ((e = ss(e)) && (n || void 0 === t)) return e.replace(K, "");
              if (!e || !(t = Zr(t))) return e;
              var r = Wt(e);
              return ui(r, 0, jt(r, Wt(t)) + 1).join("");
            }, Cn.trimStart = function (e, t, n) {
              if ((e = ss(e)) && (n || void 0 === t)) return e.replace(Y, "");
              if (!e || !(t = Zr(t))) return e;
              var r = Wt(e);
              return ui(r, It(r, Wt(t))).join("");
            }, Cn.truncate = function (e, t) {
              var n = 30,
                r = "...";
              if (Va(t)) {
                var i = "separator" in t ? t.separator : i;
                n = "length" in t ? rs(t.length) : n, r = "omission" in t ? Zr(t.omission) : r;
              }
              var o = (e = ss(e)).length;
              if (Ft(e)) {
                var a = Wt(e);
                o = a.length;
              }
              if (n >= o) return e;
              var s = n - qt(r);
              if (s < 1) return r;
              var l = a ? ui(a, 0, s).join("") : e.slice(0, s);
              if (void 0 === i) return l + r;
              if (a && (s += l.length - s), Xa(i)) {
                if (e.slice(s).search(i)) {
                  var u,
                    c = l;
                  for (i.global || (i = ge(i.source, ss(re.exec(i)) + "g")), i.lastIndex = 0; u = i.exec(c);) var d = u.index;
                  l = l.slice(0, void 0 === d ? s : d);
                }
              } else if (e.indexOf(Zr(i), s) != s) {
                var h = l.lastIndexOf(i);
                h > -1 && (l = l.slice(0, h));
              }
              return l + r;
            }, Cn.unescape = function (e) {
              return (e = ss(e)) && B.test(e) ? e.replace(L, $t) : e;
            }, Cn.uniqueId = function (e) {
              var t = ++Ee;
              return ss(e) + t;
            }, Cn.upperCase = Bs, Cn.upperFirst = Fs, Cn.each = sa, Cn.eachRight = la, Cn.first = No, Ks(Cn, (cl = {}, lr(Cn, function (e, t) {
              Ae.call(Cn.prototype, t) || (cl[t] = e);
            }), cl), {
              chain: !1
            }), Cn.VERSION = "4.17.15", st(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
              Cn[e].placeholder = Cn;
            }), st(["drop", "take"], function (e, t) {
              Rn.prototype[e] = function (n) {
                n = void 0 === n ? 1 : an(rs(n), 0);
                var r = this.__filtered__ && !t ? new Rn(this) : this.clone();
                return r.__filtered__ ? r.__takeCount__ = sn(n, r.__takeCount__) : r.__views__.push({
                  size: sn(n, 4294967295),
                  type: e + (r.__dir__ < 0 ? "Right" : "")
                }), r;
              }, Rn.prototype[e + "Right"] = function (t) {
                return this.reverse()[e](t).reverse();
              };
            }), st(["filter", "map", "takeWhile"], function (e, t) {
              var n = t + 1,
                r = 1 == n || 3 == n;
              Rn.prototype[e] = function (e) {
                var t = this.clone();
                return t.__iteratees__.push({
                  iteratee: Ki(e, 3),
                  type: n
                }), t.__filtered__ = t.__filtered__ || r, t;
              };
            }), st(["head", "last"], function (e, t) {
              var n = "take" + (t ? "Right" : "");
              Rn.prototype[e] = function () {
                return this[n](1).value()[0];
              };
            }), st(["initial", "tail"], function (e, t) {
              var n = "drop" + (t ? "" : "Right");
              Rn.prototype[e] = function () {
                return this.__filtered__ ? new Rn(this) : this[n](1);
              };
            }), Rn.prototype.compact = function () {
              return this.filter(Ws);
            }, Rn.prototype.find = function (e) {
              return this.filter(e).head();
            }, Rn.prototype.findLast = function (e) {
              return this.reverse().find(e);
            }, Rn.prototype.invokeMap = Br(function (e, t) {
              return "function" == typeof e ? new Rn(this) : this.map(function (n) {
                return yr(n, e, t);
              });
            }), Rn.prototype.reject = function (e) {
              return this.filter(Aa(Ki(e)));
            }, Rn.prototype.slice = function (e, t) {
              e = rs(e);
              var n = this;
              return n.__filtered__ && (e > 0 || t < 0) ? new Rn(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), void 0 !== t && (n = (t = rs(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
            }, Rn.prototype.takeRightWhile = function (e) {
              return this.reverse().takeWhile(e).reverse();
            }, Rn.prototype.toArray = function () {
              return this.take(4294967295);
            }, lr(Rn.prototype, function (e, t) {
              var n = /^(?:filter|find|map|reject)|While$/.test(t),
                r = /^(?:head|last)$/.test(t),
                i = Cn[r ? "take" + ("last" == t ? "Right" : "") : t],
                o = r || /^find/.test(t);
              i && (Cn.prototype[t] = function () {
                var t = this.__wrapped__,
                  a = r ? [1] : arguments,
                  s = t instanceof Rn,
                  l = a[0],
                  u = s || Ia(t),
                  c = function c(e) {
                    var t = i.apply(Cn, pt([e], a));
                    return r && d ? t[0] : t;
                  };
                u && n && "function" == typeof l && 1 != l.length && (s = u = !1);
                var d = this.__chain__,
                  h = !!this.__actions__.length,
                  f = o && !d,
                  p = s && !h;
                if (!o && u) {
                  t = p ? t : new Rn(this);
                  var m = e.apply(t, a);
                  return m.__actions__.push({
                    func: na,
                    args: [c],
                    thisArg: void 0
                  }), new On(m, d);
                }
                return f && p ? e.apply(this, a) : (m = this.thru(c), f ? r ? m.value()[0] : m.value() : m);
              });
            }), st(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
              var t = be[e],
                n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                r = /^(?:pop|shift)$/.test(e);
              Cn.prototype[e] = function () {
                var e = arguments;
                if (r && !this.__chain__) {
                  var i = this.value();
                  return t.apply(Ia(i) ? i : [], e);
                }
                return this[n](function (n) {
                  return t.apply(Ia(n) ? n : [], e);
                });
              };
            }), lr(Rn.prototype, function (e, t) {
              var n = Cn[t];
              if (n) {
                var r = n.name + "";
                Ae.call(bn, r) || (bn[r] = []), bn[r].push({
                  name: t,
                  func: n
                });
              }
            }), bn[Ci(void 0, 2).name] = [{
              name: "wrapper",
              func: void 0
            }], Rn.prototype.clone = function () {
              var e = new Rn(this.__wrapped__);
              return e.__actions__ = vi(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = vi(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = vi(this.__views__), e;
            }, Rn.prototype.reverse = function () {
              if (this.__filtered__) {
                var e = new Rn(this);
                e.__dir__ = -1, e.__filtered__ = !0;
              } else (e = this.clone()).__dir__ *= -1;
              return e;
            }, Rn.prototype.value = function () {
              var e = this.__wrapped__.value(),
                t = this.__dir__,
                n = Ia(e),
                r = t < 0,
                i = n ? e.length : 0,
                o = function (e, t, n) {
                  var r = -1,
                    i = n.length;
                  for (; ++r < i;) {
                    var o = n[r],
                      a = o.size;
                    switch (o.type) {
                      case "drop":
                        e += a;
                        break;
                      case "dropRight":
                        t -= a;
                        break;
                      case "take":
                        t = sn(t, e + a);
                        break;
                      case "takeRight":
                        e = an(e, t - a);
                    }
                  }
                  return {
                    start: e,
                    end: t
                  };
                }(0, i, this.__views__),
                a = o.start,
                s = o.end,
                l = s - a,
                u = r ? s : a - 1,
                c = this.__iteratees__,
                d = c.length,
                h = 0,
                f = sn(l, this.__takeCount__);
              if (!n || !r && i == l && f == l) return ni(e, this.__actions__);
              var p = [];
              e: for (; l-- && h < f;) {
                for (var m = -1, g = e[u += t]; ++m < d;) {
                  var v = c[m],
                    y = v.iteratee,
                    b = v.type,
                    _ = y(g);
                  if (2 == b) g = _;else if (!_) {
                    if (1 == b) continue e;
                    break e;
                  }
                }
                p[h++] = g;
              }
              return p;
            }, Cn.prototype.at = ra, Cn.prototype.chain = function () {
              return ta(this);
            }, Cn.prototype.commit = function () {
              return new On(this.value(), this.__chain__);
            }, Cn.prototype.next = function () {
              void 0 === this.__values__ && (this.__values__ = ts(this.value()));
              var e = this.__index__ >= this.__values__.length;
              return {
                done: e,
                value: e ? void 0 : this.__values__[this.__index__++]
              };
            }, Cn.prototype.plant = function (e) {
              for (var t, n = this; n instanceof Pn;) {
                var r = Co(n);
                r.__index__ = 0, r.__values__ = void 0, t ? i.__wrapped__ = r : t = r;
                var i = r;
                n = n.__wrapped__;
              }
              return i.__wrapped__ = e, t;
            }, Cn.prototype.reverse = function () {
              var e = this.__wrapped__;
              if (e instanceof Rn) {
                var t = e;
                return this.__actions__.length && (t = new Rn(this)), (t = t.reverse()).__actions__.push({
                  func: na,
                  args: [Vo],
                  thisArg: void 0
                }), new On(t, this.__chain__);
              }
              return this.thru(Vo);
            }, Cn.prototype.toJSON = Cn.prototype.valueOf = Cn.prototype.value = function () {
              return ni(this.__wrapped__, this.__actions__);
            }, Cn.prototype.first = Cn.prototype.head, Qe && (Cn.prototype[Qe] = function () {
              return this;
            }), Cn;
          }();
          $e._ = Xt, void 0 === (i = function () {
            return Xt;
          }.call(t, n, t, r)) || (r.exports = i);
        }).call(this);
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/webpack/buildin/module.js")(e));
    },
    "./node_modules/lodash/map.js": function node_modulesLodashMapJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayMap.js"),
        i = n("./node_modules/lodash/_baseIteratee.js"),
        o = n("./node_modules/lodash/_baseMap.js"),
        a = n("./node_modules/lodash/isArray.js");
      e.exports = function (e, t) {
        return (a(e) ? r : o)(e, i(t, 3));
      };
    },
    "./node_modules/lodash/mapValues.js": function node_modulesLodashMapValuesJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseAssignValue.js"),
        i = n("./node_modules/lodash/_baseForOwn.js"),
        o = n("./node_modules/lodash/_baseIteratee.js");
      e.exports = function (e, t) {
        var n = {};
        return t = o(t, 3), i(e, function (e, i, o) {
          r(n, i, t(e, i, o));
        }), n;
      };
    },
    "./node_modules/lodash/memoize.js": function node_modulesLodashMemoizeJs(e, t, n) {
      var r = n("./node_modules/lodash/_MapCache.js");
      function i(e, t) {
        if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
        var n = function n() {
          var r = arguments,
            i = t ? t.apply(this, r) : r[0],
            o = n.cache;
          if (o.has(i)) return o.get(i);
          var a = e.apply(this, r);
          return n.cache = o.set(i, a) || o, a;
        };
        return n.cache = new (i.Cache || r)(), n;
      }
      i.Cache = r, e.exports = i;
    },
    "./node_modules/lodash/merge.js": function node_modulesLodashMergeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseMerge.js"),
        i = n("./node_modules/lodash/_createAssigner.js")(function (e, t, n) {
          r(e, t, n);
        });
      e.exports = i;
    },
    "./node_modules/lodash/noop.js": function node_modulesLodashNoopJs(e, t) {
      e.exports = function () {};
    },
    "./node_modules/lodash/partialRight.js": function node_modulesLodashPartialRightJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseRest.js"),
        i = n("./node_modules/lodash/_createWrap.js"),
        o = n("./node_modules/lodash/_getHolder.js"),
        a = n("./node_modules/lodash/_replaceHolders.js"),
        s = r(function (e, t) {
          var n = a(t, o(s));
          return i(e, 64, void 0, t, n);
        });
      s.placeholder = {}, e.exports = s;
    },
    "./node_modules/lodash/pick.js": function node_modulesLodashPickJs(e, t, n) {
      var r = n("./node_modules/lodash/_basePick.js"),
        i = n("./node_modules/lodash/_flatRest.js")(function (e, t) {
          return null == e ? {} : r(e, t);
        });
      e.exports = i;
    },
    "./node_modules/lodash/pickBy.js": function node_modulesLodashPickByJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayMap.js"),
        i = n("./node_modules/lodash/_baseIteratee.js"),
        o = n("./node_modules/lodash/_basePickBy.js"),
        a = n("./node_modules/lodash/_getAllKeysIn.js");
      e.exports = function (e, t) {
        if (null == e) return {};
        var n = r(a(e), function (e) {
          return [e];
        });
        return t = i(t), o(e, n, function (e, n) {
          return t(e, n[0]);
        });
      };
    },
    "./node_modules/lodash/property.js": function node_modulesLodashPropertyJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseProperty.js"),
        i = n("./node_modules/lodash/_basePropertyDeep.js"),
        o = n("./node_modules/lodash/_isKey.js"),
        a = n("./node_modules/lodash/_toKey.js");
      e.exports = function (e) {
        return o(e) ? r(a(e)) : i(e);
      };
    },
    "./node_modules/lodash/range.js": function node_modulesLodashRangeJs(e, t, n) {
      var r = n("./node_modules/lodash/_createRange.js")();
      e.exports = r;
    },
    "./node_modules/lodash/rearg.js": function node_modulesLodashReargJs(e, t, n) {
      var r = n("./node_modules/lodash/_createWrap.js"),
        i = n("./node_modules/lodash/_flatRest.js"),
        o = i(function (e, t) {
          return r(e, 256, void 0, void 0, void 0, t);
        });
      e.exports = o;
    },
    "./node_modules/lodash/reduce.js": function node_modulesLodashReduceJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayReduce.js"),
        i = n("./node_modules/lodash/_baseEach.js"),
        o = n("./node_modules/lodash/_baseIteratee.js"),
        a = n("./node_modules/lodash/_baseReduce.js"),
        s = n("./node_modules/lodash/isArray.js");
      e.exports = function (e, t, n) {
        var l = s(e) ? r : a,
          u = arguments.length < 3;
        return l(e, o(t, 4), n, u, i);
      };
    },
    "./node_modules/lodash/round.js": function node_modulesLodashRoundJs(e, t, n) {
      var r = n("./node_modules/lodash/_createRound.js")("round");
      e.exports = r;
    },
    "./node_modules/lodash/set.js": function node_modulesLodashSetJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseSet.js");
      e.exports = function (e, t, n) {
        return null == e ? e : r(e, t, n);
      };
    },
    "./node_modules/lodash/size.js": function node_modulesLodashSizeJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseKeys.js"),
        i = n("./node_modules/lodash/_getTag.js"),
        o = n("./node_modules/lodash/isArrayLike.js"),
        a = n("./node_modules/lodash/isString.js"),
        s = n("./node_modules/lodash/_stringSize.js");
      e.exports = function (e) {
        if (null == e) return 0;
        if (o(e)) return a(e) ? s(e) : e.length;
        var t = i(e);
        return "[object Map]" == t || "[object Set]" == t ? e.size : r(e).length;
      };
    },
    "./node_modules/lodash/some.js": function node_modulesLodashSomeJs(e, t, n) {
      var r = n("./node_modules/lodash/_arraySome.js"),
        i = n("./node_modules/lodash/_baseIteratee.js"),
        o = n("./node_modules/lodash/_baseSome.js"),
        a = n("./node_modules/lodash/isArray.js"),
        s = n("./node_modules/lodash/_isIterateeCall.js");
      e.exports = function (e, t, n) {
        var l = a(e) ? r : o;
        return n && s(e, t, n) && (t = void 0), l(e, i(t, 3));
      };
    },
    "./node_modules/lodash/split.js": function node_modulesLodashSplitJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseToString.js"),
        i = n("./node_modules/lodash/_castSlice.js"),
        o = n("./node_modules/lodash/_hasUnicode.js"),
        a = n("./node_modules/lodash/_isIterateeCall.js"),
        s = n("./node_modules/lodash/isRegExp.js"),
        l = n("./node_modules/lodash/_stringToArray.js"),
        u = n("./node_modules/lodash/toString.js");
      e.exports = function (e, t, n) {
        return n && "number" != typeof n && a(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = u(e)) && ("string" == typeof t || null != t && !s(t)) && !(t = r(t)) && o(e) ? i(l(e), 0, n) : e.split(t, n) : [];
      };
    },
    "./node_modules/lodash/startCase.js": function node_modulesLodashStartCaseJs(e, t, n) {
      var r = n("./node_modules/lodash/_createCompounder.js"),
        i = n("./node_modules/lodash/upperFirst.js"),
        o = r(function (e, t, n) {
          return e + (n ? " " : "") + i(t);
        });
      e.exports = o;
    },
    "./node_modules/lodash/startsWith.js": function node_modulesLodashStartsWithJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseClamp.js"),
        i = n("./node_modules/lodash/_baseToString.js"),
        o = n("./node_modules/lodash/toInteger.js"),
        a = n("./node_modules/lodash/toString.js");
      e.exports = function (e, t, n) {
        return e = a(e), n = null == n ? 0 : r(o(n), 0, e.length), t = i(t), e.slice(n, n + t.length) == t;
      };
    },
    "./node_modules/lodash/stubArray.js": function node_modulesLodashStubArrayJs(e, t) {
      e.exports = function () {
        return [];
      };
    },
    "./node_modules/lodash/stubFalse.js": function node_modulesLodashStubFalseJs(e, t) {
      e.exports = function () {
        return !1;
      };
    },
    "./node_modules/lodash/times.js": function node_modulesLodashTimesJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseTimes.js"),
        i = n("./node_modules/lodash/_castFunction.js"),
        o = n("./node_modules/lodash/toInteger.js"),
        a = Math.min;
      e.exports = function (e, t) {
        if ((e = o(e)) < 1 || e > 9007199254740991) return [];
        var n = 4294967295,
          s = a(e, 4294967295);
        t = i(t), e -= 4294967295;
        for (var l = r(s, t); ++n < e;) t(n);
        return l;
      };
    },
    "./node_modules/lodash/toArray.js": function node_modulesLodashToArrayJs(e, t, n) {
      var r = n("./node_modules/lodash/_Symbol.js"),
        i = n("./node_modules/lodash/_copyArray.js"),
        o = n("./node_modules/lodash/_getTag.js"),
        a = n("./node_modules/lodash/isArrayLike.js"),
        s = n("./node_modules/lodash/isString.js"),
        l = n("./node_modules/lodash/_iteratorToArray.js"),
        u = n("./node_modules/lodash/_mapToArray.js"),
        c = n("./node_modules/lodash/_setToArray.js"),
        d = n("./node_modules/lodash/_stringToArray.js"),
        h = n("./node_modules/lodash/values.js"),
        f = r ? r.iterator : void 0;
      e.exports = function (e) {
        if (!e) return [];
        if (a(e)) return s(e) ? d(e) : i(e);
        if (f && e[f]) return l(e[f]());
        var t = o(e);
        return ("[object Map]" == t ? u : "[object Set]" == t ? c : h)(e);
      };
    },
    "./node_modules/lodash/toFinite.js": function node_modulesLodashToFiniteJs(e, t, n) {
      var r = n("./node_modules/lodash/toNumber.js");
      e.exports = function (e) {
        return e ? (e = r(e)) === 1 / 0 || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
      };
    },
    "./node_modules/lodash/toInteger.js": function node_modulesLodashToIntegerJs(e, t, n) {
      var r = n("./node_modules/lodash/toFinite.js");
      e.exports = function (e) {
        var t = r(e),
          n = t % 1;
        return t == t ? n ? t - n : t : 0;
      };
    },
    "./node_modules/lodash/toNumber.js": function node_modulesLodashToNumberJs(e, t, n) {
      var r = n("./node_modules/lodash/isObject.js"),
        i = n("./node_modules/lodash/isSymbol.js"),
        o = /^\s+|\s+$/g,
        a = /^[-+]0x[0-9a-f]+$/i,
        s = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        u = parseInt;
      e.exports = function (e) {
        if ("number" == typeof e) return e;
        if (i(e)) return NaN;
        if (r(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = r(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(o, "");
        var n = s.test(e);
        return n || l.test(e) ? u(e.slice(2), n ? 2 : 8) : a.test(e) ? NaN : +e;
      };
    },
    "./node_modules/lodash/toPath.js": function node_modulesLodashToPathJs(e, t, n) {
      var r = n("./node_modules/lodash/_arrayMap.js"),
        i = n("./node_modules/lodash/_copyArray.js"),
        o = n("./node_modules/lodash/isArray.js"),
        a = n("./node_modules/lodash/isSymbol.js"),
        s = n("./node_modules/lodash/_stringToPath.js"),
        l = n("./node_modules/lodash/_toKey.js"),
        u = n("./node_modules/lodash/toString.js");
      e.exports = function (e) {
        return o(e) ? r(e, l) : a(e) ? [e] : i(s(u(e)));
      };
    },
    "./node_modules/lodash/toPlainObject.js": function node_modulesLodashToPlainObjectJs(e, t, n) {
      var r = n("./node_modules/lodash/_copyObject.js"),
        i = n("./node_modules/lodash/keysIn.js");
      e.exports = function (e) {
        return r(e, i(e));
      };
    },
    "./node_modules/lodash/toString.js": function node_modulesLodashToStringJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseToString.js");
      e.exports = function (e) {
        return null == e ? "" : r(e);
      };
    },
    "./node_modules/lodash/union.js": function node_modulesLodashUnionJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseFlatten.js"),
        i = n("./node_modules/lodash/_baseRest.js"),
        o = n("./node_modules/lodash/_baseUniq.js"),
        a = n("./node_modules/lodash/isArrayLikeObject.js"),
        s = i(function (e) {
          return o(r(e, 1, a, !0));
        });
      e.exports = s;
    },
    "./node_modules/lodash/uniq.js": function node_modulesLodashUniqJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseUniq.js");
      e.exports = function (e) {
        return e && e.length ? r(e) : [];
      };
    },
    "./node_modules/lodash/upperFirst.js": function node_modulesLodashUpperFirstJs(e, t, n) {
      var r = n("./node_modules/lodash/_createCaseFirst.js")("toUpperCase");
      e.exports = r;
    },
    "./node_modules/lodash/values.js": function node_modulesLodashValuesJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseValues.js"),
        i = n("./node_modules/lodash/keys.js");
      e.exports = function (e) {
        return null == e ? [] : r(e, i(e));
      };
    },
    "./node_modules/lodash/without.js": function node_modulesLodashWithoutJs(e, t, n) {
      var r = n("./node_modules/lodash/_baseDifference.js"),
        i = n("./node_modules/lodash/_baseRest.js"),
        o = n("./node_modules/lodash/isArrayLikeObject.js"),
        a = i(function (e, t) {
          return o(e) ? r(e, t) : [];
        });
      e.exports = a;
    },
    "./node_modules/lodash/words.js": function node_modulesLodashWordsJs(e, t, n) {
      var r = n("./node_modules/lodash/_asciiWords.js"),
        i = n("./node_modules/lodash/_hasUnicodeWord.js"),
        o = n("./node_modules/lodash/toString.js"),
        a = n("./node_modules/lodash/_unicodeWords.js");
      e.exports = function (e, t, n) {
        return e = o(e), void 0 === (t = n ? void 0 : t) ? i(e) ? a(e) : r(e) : e.match(t) || [];
      };
    },
    "./node_modules/lodash/wrapperLodash.js": function node_modulesLodashWrapperLodashJs(e, t, n) {
      var r = n("./node_modules/lodash/_LazyWrapper.js"),
        i = n("./node_modules/lodash/_LodashWrapper.js"),
        o = n("./node_modules/lodash/_baseLodash.js"),
        a = n("./node_modules/lodash/isArray.js"),
        s = n("./node_modules/lodash/isObjectLike.js"),
        l = n("./node_modules/lodash/_wrapperClone.js"),
        u = Object.prototype.hasOwnProperty;
      function c(e) {
        if (s(e) && !a(e) && !(e instanceof r)) {
          if (e instanceof i) return e;
          if (u.call(e, "__wrapped__")) return l(e);
        }
        return new i(e);
      }
      c.prototype = o.prototype, c.prototype.constructor = c, e.exports = c;
    },
    "./node_modules/md5.js/index.js": function node_modulesMd5JsIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/hash-base/index.js"),
        o = n("./node_modules/safe-buffer/index.js").Buffer,
        a = new Array(16);
      function s() {
        i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
      }
      function l(e, t) {
        return e << t | e >>> 32 - t;
      }
      function u(e, t, n, r, i, o, a) {
        return l(e + (t & n | ~t & r) + i + o | 0, a) + t | 0;
      }
      function c(e, t, n, r, i, o, a) {
        return l(e + (t & r | n & ~r) + i + o | 0, a) + t | 0;
      }
      function d(e, t, n, r, i, o, a) {
        return l(e + (t ^ n ^ r) + i + o | 0, a) + t | 0;
      }
      function h(e, t, n, r, i, o, a) {
        return l(e + (n ^ (t | ~r)) + i + o | 0, a) + t | 0;
      }
      r(s, i), s.prototype._update = function () {
        for (var e = a, t = 0; t < 16; ++t) e[t] = this._block.readInt32LE(4 * t);
        var n = this._a,
          r = this._b,
          i = this._c,
          o = this._d;
        n = u(n, r, i, o, e[0], 3614090360, 7), o = u(o, n, r, i, e[1], 3905402710, 12), i = u(i, o, n, r, e[2], 606105819, 17), r = u(r, i, o, n, e[3], 3250441966, 22), n = u(n, r, i, o, e[4], 4118548399, 7), o = u(o, n, r, i, e[5], 1200080426, 12), i = u(i, o, n, r, e[6], 2821735955, 17), r = u(r, i, o, n, e[7], 4249261313, 22), n = u(n, r, i, o, e[8], 1770035416, 7), o = u(o, n, r, i, e[9], 2336552879, 12), i = u(i, o, n, r, e[10], 4294925233, 17), r = u(r, i, o, n, e[11], 2304563134, 22), n = u(n, r, i, o, e[12], 1804603682, 7), o = u(o, n, r, i, e[13], 4254626195, 12), i = u(i, o, n, r, e[14], 2792965006, 17), n = c(n, r = u(r, i, o, n, e[15], 1236535329, 22), i, o, e[1], 4129170786, 5), o = c(o, n, r, i, e[6], 3225465664, 9), i = c(i, o, n, r, e[11], 643717713, 14), r = c(r, i, o, n, e[0], 3921069994, 20), n = c(n, r, i, o, e[5], 3593408605, 5), o = c(o, n, r, i, e[10], 38016083, 9), i = c(i, o, n, r, e[15], 3634488961, 14), r = c(r, i, o, n, e[4], 3889429448, 20), n = c(n, r, i, o, e[9], 568446438, 5), o = c(o, n, r, i, e[14], 3275163606, 9), i = c(i, o, n, r, e[3], 4107603335, 14), r = c(r, i, o, n, e[8], 1163531501, 20), n = c(n, r, i, o, e[13], 2850285829, 5), o = c(o, n, r, i, e[2], 4243563512, 9), i = c(i, o, n, r, e[7], 1735328473, 14), n = d(n, r = c(r, i, o, n, e[12], 2368359562, 20), i, o, e[5], 4294588738, 4), o = d(o, n, r, i, e[8], 2272392833, 11), i = d(i, o, n, r, e[11], 1839030562, 16), r = d(r, i, o, n, e[14], 4259657740, 23), n = d(n, r, i, o, e[1], 2763975236, 4), o = d(o, n, r, i, e[4], 1272893353, 11), i = d(i, o, n, r, e[7], 4139469664, 16), r = d(r, i, o, n, e[10], 3200236656, 23), n = d(n, r, i, o, e[13], 681279174, 4), o = d(o, n, r, i, e[0], 3936430074, 11), i = d(i, o, n, r, e[3], 3572445317, 16), r = d(r, i, o, n, e[6], 76029189, 23), n = d(n, r, i, o, e[9], 3654602809, 4), o = d(o, n, r, i, e[12], 3873151461, 11), i = d(i, o, n, r, e[15], 530742520, 16), n = h(n, r = d(r, i, o, n, e[2], 3299628645, 23), i, o, e[0], 4096336452, 6), o = h(o, n, r, i, e[7], 1126891415, 10), i = h(i, o, n, r, e[14], 2878612391, 15), r = h(r, i, o, n, e[5], 4237533241, 21), n = h(n, r, i, o, e[12], 1700485571, 6), o = h(o, n, r, i, e[3], 2399980690, 10), i = h(i, o, n, r, e[10], 4293915773, 15), r = h(r, i, o, n, e[1], 2240044497, 21), n = h(n, r, i, o, e[8], 1873313359, 6), o = h(o, n, r, i, e[15], 4264355552, 10), i = h(i, o, n, r, e[6], 2734768916, 15), r = h(r, i, o, n, e[13], 1309151649, 21), n = h(n, r, i, o, e[4], 4149444226, 6), o = h(o, n, r, i, e[11], 3174756917, 10), i = h(i, o, n, r, e[2], 718787259, 15), r = h(r, i, o, n, e[9], 3951481745, 21), this._a = this._a + n | 0, this._b = this._b + r | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
      }, s.prototype._digest = function () {
        this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
        var e = o.allocUnsafe(16);
        return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
      }, e.exports = s;
    },
    "./node_modules/memoize-one/dist/memoize-one.esm.js": function node_modulesMemoizeOneDistMemoizeOneEsmJs(e, t, n) {
      "use strict";

      function r(e, t) {
        if (e.length !== t.length) return !1;
        for (var n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
        return !0;
      }
      t.a = function (e, t) {
        var n;
        void 0 === t && (t = r);
        var i,
          o = [],
          a = !1;
        return function () {
          for (var r = [], s = 0; s < arguments.length; s++) r[s] = arguments[s];
          return a && n === this && t(r, o) || (i = e.apply(this, r), a = !0, n = this, o = r), i;
        };
      };
    },
    "./node_modules/merge-anything/dist/index.esm.js": function node_modulesMergeAnythingDistIndexEsmJs(e, t, n) {
      "use strict";

      function r(e) {
        return Object.prototype.toString.call(e).slice(8, -1);
      }
      function i(e) {
        return "Object" === r(e) && e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
      }
      function o(e) {
        return "Array" === r(e);
      }
      function a(e) {
        return "Symbol" === r(e);
      }
      function s(e, t, n, r) {
        var i = r.propertyIsEnumerable(t) ? "enumerable" : "nonenumerable";
        "enumerable" === i && (e[t] = n), "nonenumerable" === i && Object.defineProperty(e, t, {
          value: n,
          enumerable: !1,
          writable: !0,
          configurable: !0
        });
      }
      function l(e, t, n) {
        if (!i(t)) return n && o(n) && n.forEach(function (n) {
          t = n(e, t);
        }), t;
        var r = {};
        if (i(e)) {
          var u = Object.getOwnPropertyNames(e),
            c = Object.getOwnPropertySymbols(e);
          r = u.concat(c).reduce(function (n, r) {
            var i = e[r];
            return (!a(r) && !Object.getOwnPropertyNames(t).includes(r) || a(r) && !Object.getOwnPropertySymbols(t).includes(r)) && s(n, r, i, e), n;
          }, {});
        }
        var d = Object.getOwnPropertyNames(t),
          h = Object.getOwnPropertySymbols(t);
        return d.concat(h).reduce(function (r, a) {
          var u = t[a],
            c = i(e) ? e[a] : void 0;
          return n && o(n) && n.forEach(function (e) {
            u = e(c, u);
          }), void 0 !== c && i(u) && (u = l(c, u, n)), s(r, a, u, t), r;
        }, r);
      }
      t.a = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        var r = null,
          o = e;
        return i(e) && e.extensions && 1 === Object.keys(e).length && (o = {}, r = e.extensions), t.reduce(function (e, t) {
          return l(e, t, r);
        }, o);
      };
    },
    "./node_modules/miller-rabin/lib/mr.js": function node_modulesMillerRabinLibMrJs(e, t, n) {
      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/brorand/index.js");
      function o(e) {
        this.rand = e || new i.Rand();
      }
      e.exports = o, o.create = function (e) {
        return new o(e);
      }, o.prototype._randbelow = function (e) {
        var t = e.bitLength(),
          n = Math.ceil(t / 8);
        do {
          var i = new r(this.rand.generate(n));
        } while (i.cmp(e) >= 0);
        return i;
      }, o.prototype._randrange = function (e, t) {
        var n = t.sub(e);
        return e.add(this._randbelow(n));
      }, o.prototype.test = function (e, t, n) {
        var i = e.bitLength(),
          o = r.mont(e),
          a = new r(1).toRed(o);
        t || (t = Math.max(1, i / 48 | 0));
        for (var s = e.subn(1), l = 0; !s.testn(l); l++);
        for (var u = e.shrn(l), c = s.toRed(o); t > 0; t--) {
          var d = this._randrange(new r(2), s);
          n && n(d);
          var h = d.toRed(o).redPow(u);
          if (0 !== h.cmp(a) && 0 !== h.cmp(c)) {
            for (var f = 1; f < l; f++) {
              if (0 === (h = h.redSqr()).cmp(a)) return !1;
              if (0 === h.cmp(c)) break;
            }
            if (f === l) return !1;
          }
        }
        return !0;
      }, o.prototype.getDivisor = function (e, t) {
        var n = e.bitLength(),
          i = r.mont(e),
          o = new r(1).toRed(i);
        t || (t = Math.max(1, n / 48 | 0));
        for (var a = e.subn(1), s = 0; !a.testn(s); s++);
        for (var l = e.shrn(s), u = a.toRed(i); t > 0; t--) {
          var c = this._randrange(new r(2), a),
            d = e.gcd(c);
          if (0 !== d.cmpn(1)) return d;
          var h = c.toRed(i).redPow(l);
          if (0 !== h.cmp(o) && 0 !== h.cmp(u)) {
            for (var f = 1; f < s; f++) {
              if (0 === (h = h.redSqr()).cmp(o)) return h.fromRed().subn(1).gcd(e);
              if (0 === h.cmp(u)) break;
            }
            if (f === s) return (h = h.redSqr()).fromRed().subn(1).gcd(e);
          }
        }
        return !1;
      };
    },
    "./node_modules/mini-css-extract-plugin/dist/loader.js?!./node_modules/css-loader/index.js!./node_modules/rc-slider/assets/index.css": function node_modulesMiniCssExtractPluginDistLoaderJsNode_modulesCssLoaderIndexJsNode_modulesRcSliderAssetsIndexCss(e, t, n) {},
    "./node_modules/minimalistic-assert/index.js": function node_modulesMinimalisticAssertIndexJs(e, t) {
      function n(e, t) {
        if (!e) throw new Error(t || "Assertion failed");
      }
      e.exports = n, n.equal = function (e, t, n) {
        if (e != t) throw new Error(n || "Assertion failed: " + e + " != " + t);
      };
    },
    "./node_modules/minimalistic-crypto-utils/lib/utils.js": function node_modulesMinimalisticCryptoUtilsLibUtilsJs(e, t, n) {
      "use strict";

      var r = t;
      function i(e) {
        return 1 === e.length ? "0" + e : e;
      }
      function o(e) {
        for (var t = "", n = 0; n < e.length; n++) t += i(e[n].toString(16));
        return t;
      }
      r.toArray = function (e, t) {
        if (Array.isArray(e)) return e.slice();
        if (!e) return [];
        var n = [];
        if ("string" != typeof e) {
          for (var r = 0; r < e.length; r++) n[r] = 0 | e[r];
          return n;
        }
        if ("hex" === t) {
          (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
          for (r = 0; r < e.length; r += 2) n.push(parseInt(e[r] + e[r + 1], 16));
        } else for (r = 0; r < e.length; r++) {
          var i = e.charCodeAt(r),
            o = i >> 8,
            a = 255 & i;
          o ? n.push(o, a) : n.push(a);
        }
        return n;
      }, r.zero2 = i, r.toHex = o, r.encode = function (e, t) {
        return "hex" === t ? o(e) : e;
      };
    },
    "./node_modules/ml-levenberg-marquardt/src/index.js": function node_modulesMlLevenbergMarquardtSrcIndexJs(e, t, n) {
      "use strict";

      function r(e, t, n) {
        var r = 0;
        var i = n(t);
        for (var o = 0; o < e.x.length; o++) r += Math.abs(e.y[o] - i(e.x[o]));
        return r;
      }
      n.r(t), n.d(t, "default", function () {
        return B;
      });
      var i = n("./node_modules/is-any-array/src/index.js"),
        o = n.n(i);
      var a = function a(e) {
        if (!o()(e)) throw new TypeError("input must be an array");
        if (0 === e.length) throw new TypeError("input must not be empty");
        for (var t = e[0], n = 1; n < e.length; n++) e[n] > t && (t = e[n]);
        return t;
      };
      var s = function s(e) {
        if (!o()(e)) throw new TypeError("input must be an array");
        if (0 === e.length) throw new TypeError("input must not be empty");
        for (var t = e[0], n = 1; n < e.length; n++) e[n] < t && (t = e[n]);
        return t;
      };
      var l = function l(e) {
        var t,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (!o()(e)) throw new TypeError("input must be an array");
        if (0 === e.length) throw new TypeError("input must not be empty");
        if (void 0 !== n.output) {
          if (!o()(n.output)) throw new TypeError("output option must be an array if specified");
          t = n.output;
        } else t = new Array(e.length);
        var r = s(e),
          i = a(e);
        if (r === i) throw new RangeError("minimum and maximum input values are equal. Cannot rescale a constant array");
        var l = n.min,
          u = void 0 === l ? n.autoMinMax ? r : 0 : l,
          c = n.max,
          d = void 0 === c ? n.autoMinMax ? i : 1 : c;
        if (u >= d) throw new RangeError("min option must be smaller than max option");
        for (var h = (d - u) / (i - r), f = 0; f < e.length; f++) t[f] = (e[f] - r) * h + u;
        return t;
      };
      var u = /*#__PURE__*/function () {
        function u(e) {
          _classCallCheck(this, u);
          var t,
            n,
            r,
            i,
            o,
            a,
            s,
            l,
            _u2,
            c = (e = j.checkMatrix(e)).clone(),
            d = c.rows,
            h = c.columns,
            f = new Array(d),
            p = 1;
          for (t = 0; t < d; t++) f[t] = t;
          for (l = new Array(d), n = 0; n < h; n++) {
            for (t = 0; t < d; t++) l[t] = c.get(t, n);
            for (t = 0; t < d; t++) {
              for (_u2 = Math.min(t, n), o = 0, r = 0; r < _u2; r++) o += c.get(t, r) * l[r];
              l[t] -= o, c.set(t, n, l[t]);
            }
            for (i = n, t = n + 1; t < d; t++) Math.abs(l[t]) > Math.abs(l[i]) && (i = t);
            if (i !== n) {
              for (r = 0; r < h; r++) a = c.get(i, r), c.set(i, r, c.get(n, r)), c.set(n, r, a);
              s = f[i], f[i] = f[n], f[n] = s, p = -p;
            }
            if (n < d && 0 !== c.get(n, n)) for (t = n + 1; t < d; t++) c.set(t, n, c.get(t, n) / c.get(n, n));
          }
          this.LU = c, this.pivotVector = f, this.pivotSign = p;
        }
        _createClass(u, [{
          key: "isSingular",
          value: function isSingular() {
            for (var e = this.LU, t = e.columns, n = 0; n < t; n++) if (0 === e[n][n]) return !0;
            return !1;
          }
        }, {
          key: "solve",
          value: function solve(e) {
            e = I.checkMatrix(e);
            var t = this.LU;
            if (t.rows !== e.rows) throw new Error("Invalid matrix dimensions");
            if (this.isSingular()) throw new Error("LU matrix is singular");
            var n,
              r,
              i,
              o = e.columns,
              a = e.subMatrixRow(this.pivotVector, 0, o - 1),
              s = t.columns;
            for (i = 0; i < s; i++) for (n = i + 1; n < s; n++) for (r = 0; r < o; r++) a[n][r] -= a[i][r] * t[n][i];
            for (i = s - 1; i >= 0; i--) {
              for (r = 0; r < o; r++) a[i][r] /= t[i][i];
              for (n = 0; n < i; n++) for (r = 0; r < o; r++) a[n][r] -= a[i][r] * t[n][i];
            }
            return a;
          }
        }, {
          key: "determinant",
          get: function get() {
            var e = this.LU;
            if (!e.isSquare()) throw new Error("Matrix must be square");
            for (var t = this.pivotSign, n = e.columns, r = 0; r < n; r++) t *= e[r][r];
            return t;
          }
        }, {
          key: "lowerTriangularMatrix",
          get: function get() {
            for (var e = this.LU, t = e.rows, n = e.columns, r = new I(t, n), i = 0; i < t; i++) for (var o = 0; o < n; o++) r[i][o] = i > o ? e[i][o] : i === o ? 1 : 0;
            return r;
          }
        }, {
          key: "upperTriangularMatrix",
          get: function get() {
            for (var e = this.LU, t = e.rows, n = e.columns, r = new I(t, n), i = 0; i < t; i++) for (var o = 0; o < n; o++) r[i][o] = i <= o ? e[i][o] : 0;
            return r;
          }
        }, {
          key: "pivotPermutationVector",
          get: function get() {
            return this.pivotVector.slice();
          }
        }]);
        return u;
      }();
      function c(e, t) {
        var n = 0;
        return Math.abs(e) > Math.abs(t) ? (n = t / e, Math.abs(e) * Math.sqrt(1 + n * n)) : 0 !== t ? (n = e / t, Math.abs(t) * Math.sqrt(1 + n * n)) : 0;
      }
      function d(e, t, n) {
        for (var r = new Array(e), i = 0; i < e; i++) {
          r[i] = new Array(t);
          for (var o = 0; o < t; o++) r[i][o] = n;
        }
        return r;
      }
      var h = /*#__PURE__*/function () {
        function h(e) {
          var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          _classCallCheck(this, h);
          var n = (e = j.checkMatrix(e)).rows,
            r = e.columns;
          var _t$computeLeftSingula = t.computeLeftSingularVectors,
            i = _t$computeLeftSingula === void 0 ? !0 : _t$computeLeftSingula,
            _t$computeRightSingul = t.computeRightSingularVectors,
            o = _t$computeRightSingul === void 0 ? !0 : _t$computeRightSingul,
            _t$autoTranspose = t.autoTranspose,
            a = _t$autoTranspose === void 0 ? !1 : _t$autoTranspose;
          var s,
            l = Boolean(i),
            u = Boolean(o),
            _h2 = !1;
          if (n < r) {
            if (a) {
              n = (s = e.transpose()).rows, r = s.columns, _h2 = !0;
              var f = l;
              l = u, u = f;
            } else s = e.clone(), console.warn("Computing SVD on a matrix with more columns than rows. Consider enabling autoTranspose");
          } else s = e.clone();
          var p = Math.min(n, r),
            m = Math.min(n + 1, r),
            g = new Array(m),
            v = d(n, p, 0),
            y = d(r, r, 0),
            b = new Array(r),
            _ = new Array(n),
            x = new Array(m);
          for (var _e2 = 0; _e2 < m; _e2++) x[_e2] = _e2;
          var w = Math.min(n - 1, r),
            S = Math.max(0, Math.min(r - 2, n)),
            A = Math.max(w, S);
          for (var _e3 = 0; _e3 < A; _e3++) {
            if (_e3 < w) {
              g[_e3] = 0;
              for (var _t7 = _e3; _t7 < n; _t7++) g[_e3] = c(g[_e3], s[_t7][_e3]);
              if (0 !== g[_e3]) {
                s[_e3][_e3] < 0 && (g[_e3] = -g[_e3]);
                for (var _t8 = _e3; _t8 < n; _t8++) s[_t8][_e3] /= g[_e3];
                s[_e3][_e3] += 1;
              }
              g[_e3] = -g[_e3];
            }
            for (var _t9 = _e3 + 1; _t9 < r; _t9++) {
              if (_e3 < w && 0 !== g[_e3]) {
                var _r2 = 0;
                for (var _i3 = _e3; _i3 < n; _i3++) _r2 += s[_i3][_e3] * s[_i3][_t9];
                _r2 = -_r2 / s[_e3][_e3];
                for (var _i4 = _e3; _i4 < n; _i4++) s[_i4][_t9] += _r2 * s[_i4][_e3];
              }
              b[_t9] = s[_e3][_t9];
            }
            if (l && _e3 < w) for (var _t10 = _e3; _t10 < n; _t10++) v[_t10][_e3] = s[_t10][_e3];
            if (_e3 < S) {
              b[_e3] = 0;
              for (var _t11 = _e3 + 1; _t11 < r; _t11++) b[_e3] = c(b[_e3], b[_t11]);
              if (0 !== b[_e3]) {
                b[_e3 + 1] < 0 && (b[_e3] = 0 - b[_e3]);
                for (var _t12 = _e3 + 1; _t12 < r; _t12++) b[_t12] /= b[_e3];
                b[_e3 + 1] += 1;
              }
              if (b[_e3] = -b[_e3], _e3 + 1 < n && 0 !== b[_e3]) {
                for (var _t13 = _e3 + 1; _t13 < n; _t13++) _[_t13] = 0;
                for (var _t14 = _e3 + 1; _t14 < n; _t14++) for (var _n8 = _e3 + 1; _n8 < r; _n8++) _[_t14] += b[_n8] * s[_t14][_n8];
                for (var _t15 = _e3 + 1; _t15 < r; _t15++) {
                  var _r3 = -b[_t15] / b[_e3 + 1];
                  for (var _i5 = _e3 + 1; _i5 < n; _i5++) s[_i5][_t15] += _r3 * _[_i5];
                }
              }
              if (u) for (var _t16 = _e3 + 1; _t16 < r; _t16++) y[_t16][_e3] = b[_t16];
            }
          }
          var E = Math.min(r, n + 1);
          if (w < r && (g[w] = s[w][w]), n < E && (g[E - 1] = 0), S + 1 < E && (b[S] = s[S][E - 1]), b[E - 1] = 0, l) {
            for (var _e4 = w; _e4 < p; _e4++) {
              for (var _t17 = 0; _t17 < n; _t17++) v[_t17][_e4] = 0;
              v[_e4][_e4] = 1;
            }
            for (var _e5 = w - 1; _e5 >= 0; _e5--) if (0 !== g[_e5]) {
              for (var _t18 = _e5 + 1; _t18 < p; _t18++) {
                var _r4 = 0;
                for (var _i6 = _e5; _i6 < n; _i6++) _r4 += v[_i6][_e5] * v[_i6][_t18];
                _r4 = -_r4 / v[_e5][_e5];
                for (var _i7 = _e5; _i7 < n; _i7++) v[_i7][_t18] += _r4 * v[_i7][_e5];
              }
              for (var _t19 = _e5; _t19 < n; _t19++) v[_t19][_e5] = -v[_t19][_e5];
              v[_e5][_e5] = 1 + v[_e5][_e5];
              for (var _t20 = 0; _t20 < _e5 - 1; _t20++) v[_t20][_e5] = 0;
            } else {
              for (var _t21 = 0; _t21 < n; _t21++) v[_t21][_e5] = 0;
              v[_e5][_e5] = 1;
            }
          }
          if (u) for (var _e6 = r - 1; _e6 >= 0; _e6--) {
            if (_e6 < S && 0 !== b[_e6]) for (var _t22 = _e6 + 1; _t22 < r; _t22++) {
              var _n9 = 0;
              for (var _i8 = _e6 + 1; _i8 < r; _i8++) _n9 += y[_i8][_e6] * y[_i8][_t22];
              _n9 = -_n9 / y[_e6 + 1][_e6];
              for (var _i9 = _e6 + 1; _i9 < r; _i9++) y[_i9][_t22] += _n9 * y[_i9][_e6];
            }
            for (var _t23 = 0; _t23 < r; _t23++) y[_t23][_e6] = 0;
            y[_e6][_e6] = 1;
          }
          for (var T = E - 1, M = Number.EPSILON; E > 0;) {
            var _e7 = void 0,
              _t24 = void 0;
            for (_e7 = E - 2; _e7 >= -1 && -1 !== _e7; _e7--) {
              var _t25 = Number.MIN_VALUE + M * Math.abs(g[_e7] + Math.abs(g[_e7 + 1]));
              if (Math.abs(b[_e7]) <= _t25 || Number.isNaN(b[_e7])) {
                b[_e7] = 0;
                break;
              }
            }
            if (_e7 === E - 2) _t24 = 4;else {
              var _n10 = void 0;
              for (_n10 = E - 1; _n10 >= _e7 && _n10 !== _e7; _n10--) {
                var _t26 = (_n10 !== E ? Math.abs(b[_n10]) : 0) + (_n10 !== _e7 + 1 ? Math.abs(b[_n10 - 1]) : 0);
                if (Math.abs(g[_n10]) <= M * _t26) {
                  g[_n10] = 0;
                  break;
                }
              }
              _n10 === _e7 ? _t24 = 3 : _n10 === E - 1 ? _t24 = 1 : (_t24 = 2, _e7 = _n10);
            }
            switch (_e7++, _t24) {
              case 1:
                {
                  var _t27 = b[E - 2];
                  b[E - 2] = 0;
                  for (var _n11 = E - 2; _n11 >= _e7; _n11--) {
                    var _i10 = c(g[_n11], _t27),
                      _o2 = g[_n11] / _i10,
                      _a2 = _t27 / _i10;
                    if (g[_n11] = _i10, _n11 !== _e7 && (_t27 = -_a2 * b[_n11 - 1], b[_n11 - 1] = _o2 * b[_n11 - 1]), u) for (var _e8 = 0; _e8 < r; _e8++) _i10 = _o2 * y[_e8][_n11] + _a2 * y[_e8][E - 1], y[_e8][E - 1] = -_a2 * y[_e8][_n11] + _o2 * y[_e8][E - 1], y[_e8][_n11] = _i10;
                  }
                  break;
                }
              case 2:
                {
                  var _t28 = b[_e7 - 1];
                  b[_e7 - 1] = 0;
                  for (var _r5 = _e7; _r5 < E; _r5++) {
                    var _i11 = c(g[_r5], _t28),
                      _o3 = g[_r5] / _i11,
                      _a3 = _t28 / _i11;
                    if (g[_r5] = _i11, _t28 = -_a3 * b[_r5], b[_r5] = _o3 * b[_r5], l) for (var _t29 = 0; _t29 < n; _t29++) _i11 = _o3 * v[_t29][_r5] + _a3 * v[_t29][_e7 - 1], v[_t29][_e7 - 1] = -_a3 * v[_t29][_r5] + _o3 * v[_t29][_e7 - 1], v[_t29][_r5] = _i11;
                  }
                  break;
                }
              case 3:
                {
                  var _t30 = Math.max(Math.abs(g[E - 1]), Math.abs(g[E - 2]), Math.abs(b[E - 2]), Math.abs(g[_e7]), Math.abs(b[_e7])),
                    _i12 = g[E - 1] / _t30,
                    _o4 = g[E - 2] / _t30,
                    _a4 = b[E - 2] / _t30,
                    _s2 = g[_e7] / _t30,
                    _d2 = b[_e7] / _t30,
                    _h3 = ((_o4 + _i12) * (_o4 - _i12) + _a4 * _a4) / 2,
                    _f2 = _i12 * _a4 * (_i12 * _a4);
                  var _p2 = 0;
                  0 === _h3 && 0 === _f2 || (_p2 = _h3 < 0 ? 0 - Math.sqrt(_h3 * _h3 + _f2) : Math.sqrt(_h3 * _h3 + _f2), _p2 = _f2 / (_h3 + _p2));
                  var _m2 = (_s2 + _i12) * (_s2 - _i12) + _p2,
                    _2 = _s2 * _d2;
                  for (var _t31 = _e7; _t31 < E - 1; _t31++) {
                    var _i13 = c(_m2, _2);
                    0 === _i13 && (_i13 = Number.MIN_VALUE);
                    var _o5 = _m2 / _i13,
                      _a5 = _2 / _i13;
                    if (_t31 !== _e7 && (b[_t31 - 1] = _i13), _m2 = _o5 * g[_t31] + _a5 * b[_t31], b[_t31] = _o5 * b[_t31] - _a5 * g[_t31], _2 = _a5 * g[_t31 + 1], g[_t31 + 1] = _o5 * g[_t31 + 1], u) for (var _e9 = 0; _e9 < r; _e9++) _i13 = _o5 * y[_e9][_t31] + _a5 * y[_e9][_t31 + 1], y[_e9][_t31 + 1] = -_a5 * y[_e9][_t31] + _o5 * y[_e9][_t31 + 1], y[_e9][_t31] = _i13;
                    if (_i13 = c(_m2, _2), 0 === _i13 && (_i13 = Number.MIN_VALUE), _o5 = _m2 / _i13, _a5 = _2 / _i13, g[_t31] = _i13, _m2 = _o5 * b[_t31] + _a5 * g[_t31 + 1], g[_t31 + 1] = -_a5 * b[_t31] + _o5 * g[_t31 + 1], _2 = _a5 * b[_t31 + 1], b[_t31 + 1] = _o5 * b[_t31 + 1], l && _t31 < n - 1) for (var _e10 = 0; _e10 < n; _e10++) _i13 = _o5 * v[_e10][_t31] + _a5 * v[_e10][_t31 + 1], v[_e10][_t31 + 1] = -_a5 * v[_e10][_t31] + _o5 * v[_e10][_t31 + 1], v[_e10][_t31] = _i13;
                  }
                  b[E - 2] = _m2, 1;
                  break;
                }
              case 4:
                if (g[_e7] <= 0 && (g[_e7] = g[_e7] < 0 ? -g[_e7] : 0, u)) for (var _t32 = 0; _t32 <= T; _t32++) y[_t32][_e7] = -y[_t32][_e7];
                for (; _e7 < T && !(g[_e7] >= g[_e7 + 1]);) {
                  var _t33 = g[_e7];
                  if (g[_e7] = g[_e7 + 1], g[_e7 + 1] = _t33, u && _e7 < r - 1) for (var _n12 = 0; _n12 < r; _n12++) _t33 = y[_n12][_e7 + 1], y[_n12][_e7 + 1] = y[_n12][_e7], y[_n12][_e7] = _t33;
                  if (l && _e7 < n - 1) for (var _r6 = 0; _r6 < n; _r6++) _t33 = v[_r6][_e7 + 1], v[_r6][_e7 + 1] = v[_r6][_e7], v[_r6][_e7] = _t33;
                  _e7++;
                }
                0, E--;
            }
          }
          if (_h2) {
            var C = y;
            y = v, v = C;
          }
          this.m = n, this.n = r, this.s = g, this.U = v, this.V = y;
        }
        _createClass(h, [{
          key: "solve",
          value: function solve(e) {
            var t = e,
              n = this.threshold,
              r = this.s.length,
              i = I.zeros(r, r);
            for (var _e11 = 0; _e11 < r; _e11++) Math.abs(this.s[_e11]) <= n ? i[_e11][_e11] = 0 : i[_e11][_e11] = 1 / this.s[_e11];
            var o = this.U,
              a = this.rightSingularVectors,
              s = a.mmul(i),
              l = a.rows,
              u = o.length,
              c = I.zeros(l, u);
            for (var _e12 = 0; _e12 < l; _e12++) for (var _t34 = 0; _t34 < u; _t34++) {
              var _n13 = 0;
              for (var _i14 = 0; _i14 < r; _i14++) _n13 += s[_e12][_i14] * o[_t34][_i14];
              c[_e12][_t34] = _n13;
            }
            return c.mmul(t);
          }
        }, {
          key: "solveForDiagonal",
          value: function solveForDiagonal(e) {
            return this.solve(I.diag(e));
          }
        }, {
          key: "inverse",
          value: function inverse() {
            var e = this.V,
              t = this.threshold,
              n = e.length,
              r = e[0].length,
              i = new I(n, this.s.length);
            for (var _o6 = 0; _o6 < n; _o6++) for (var _n14 = 0; _n14 < r; _n14++) Math.abs(this.s[_n14]) > t ? i[_o6][_n14] = e[_o6][_n14] / this.s[_n14] : i[_o6][_n14] = 0;
            var o = this.U,
              a = o.length,
              s = o[0].length,
              l = new I(n, a);
            for (var _e13 = 0; _e13 < n; _e13++) for (var _t35 = 0; _t35 < a; _t35++) {
              var _n15 = 0;
              for (var _r7 = 0; _r7 < s; _r7++) _n15 += i[_e13][_r7] * o[_t35][_r7];
              l[_e13][_t35] = _n15;
            }
            return l;
          }
        }, {
          key: "condition",
          get: function get() {
            return this.s[0] / this.s[Math.min(this.m, this.n) - 1];
          }
        }, {
          key: "norm2",
          get: function get() {
            return this.s[0];
          }
        }, {
          key: "rank",
          get: function get() {
            for (var e = Math.max(this.m, this.n) * this.s[0] * Number.EPSILON, t = 0, n = this.s, r = 0, i = n.length; r < i; r++) n[r] > e && t++;
            return t;
          }
        }, {
          key: "diagonal",
          get: function get() {
            return this.s;
          }
        }, {
          key: "threshold",
          get: function get() {
            return Number.EPSILON / 2 * Math.max(this.m, this.n) * this.s[0];
          }
        }, {
          key: "leftSingularVectors",
          get: function get() {
            return I.isMatrix(this.U) || (this.U = new I(this.U)), this.U;
          }
        }, {
          key: "rightSingularVectors",
          get: function get() {
            return I.isMatrix(this.V) || (this.V = new I(this.V)), this.V;
          }
        }, {
          key: "diagonalMatrix",
          get: function get() {
            return I.diag(this.s);
          }
        }]);
        return h;
      }();
      function f(e, t, n) {
        var r = n ? e.rows : e.rows - 1;
        if (t < 0 || t > r) throw new RangeError("Row index out of range");
      }
      function p(e, t, n) {
        var r = n ? e.columns : e.columns - 1;
        if (t < 0 || t > r) throw new RangeError("Column index out of range");
      }
      function m(e, t) {
        if (t.to1DArray && (t = t.to1DArray()), t.length !== e.columns) throw new RangeError("vector size must be the same as the number of columns");
        return t;
      }
      function g(e, t) {
        if (t.to1DArray && (t = t.to1DArray()), t.length !== e.rows) throw new RangeError("vector size must be the same as the number of rows");
        return t;
      }
      function v(e, t, n) {
        return {
          row: y(e, t),
          column: b(e, n)
        };
      }
      function y(e, t) {
        if ("object" != typeof t) throw new TypeError("unexpected type for row indices");
        if (t.some(function (t) {
          return t < 0 || t >= e.rows;
        })) throw new RangeError("row indices are out of range");
        return Array.isArray(t) || (t = Array.from(t)), t;
      }
      function b(e, t) {
        if ("object" != typeof t) throw new TypeError("unexpected type for column indices");
        if (t.some(function (t) {
          return t < 0 || t >= e.columns;
        })) throw new RangeError("column indices are out of range");
        return Array.isArray(t) || (t = Array.from(t)), t;
      }
      function _(e, t, n, r, i) {
        if (5 !== arguments.length) throw new RangeError("expected 4 arguments");
        if (x("startRow", t), x("endRow", n), x("startColumn", r), x("endColumn", i), t > n || r > i || t < 0 || t >= e.rows || n < 0 || n >= e.rows || r < 0 || r >= e.columns || i < 0 || i >= e.columns) throw new RangeError("Submatrix indices are out of range");
      }
      function x(e, t) {
        if ("number" != typeof t) throw new TypeError("".concat(e, " must be a number"));
      }
      var w = /*#__PURE__*/function (_R) {
        _inherits(w, _R);
        function w(e, t, n) {
          var _this;
          _classCallCheck(this, w);
          _this = _possibleConstructorReturn(this, _getPrototypeOf(w).call(this)), _this.matrix = e, _this.rows = t, _this.columns = n;
          return _this;
        }
        _createClass(w, null, [{
          key: Symbol.species,
          get: function get() {
            return I;
          }
        }]);
        return w;
      }(R());
      var S = /*#__PURE__*/function (_w2) {
        _inherits(S, _w2);
        function S(e) {
          _classCallCheck(this, S);
          return _possibleConstructorReturn(this, _getPrototypeOf(S).call(this, e, e.columns, e.rows));
        }
        _createClass(S, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(t, e, n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(t, e);
          }
        }]);
        return S;
      }(w);
      var A = /*#__PURE__*/function (_w3) {
        _inherits(A, _w3);
        function A(e, t) {
          var _this2;
          _classCallCheck(this, A);
          _this2 = _possibleConstructorReturn(this, _getPrototypeOf(A).call(this, e, 1, e.columns)), _this2.row = t;
          return _this2;
        }
        _createClass(A, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(this.row, t, n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(this.row, t);
          }
        }]);
        return A;
      }(w);
      var E = /*#__PURE__*/function (_w4) {
        _inherits(E, _w4);
        function E(e, t, n, r, i) {
          var _this3;
          _classCallCheck(this, E);
          _(e, t, n, r, i), _this3 = _possibleConstructorReturn(this, _getPrototypeOf(E).call(this, e, n - t + 1, i - r + 1)), _this3.startRow = t, _this3.startColumn = r;
          return _this3;
        }
        _createClass(E, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(this.startRow + e, this.startColumn + t, n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(this.startRow + e, this.startColumn + t);
          }
        }]);
        return E;
      }(w);
      var T = /*#__PURE__*/function (_w5) {
        _inherits(T, _w5);
        function T(e, t, n) {
          var _this4;
          _classCallCheck(this, T);
          var r = v(e, t, n);
          _this4 = _possibleConstructorReturn(this, _getPrototypeOf(T).call(this, e, r.row.length, r.column.length)), _this4.rowIndices = r.row, _this4.columnIndices = r.column;
          return _this4;
        }
        _createClass(T, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(this.rowIndices[e], this.columnIndices[t], n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(this.rowIndices[e], this.columnIndices[t]);
          }
        }]);
        return T;
      }(w);
      var M = /*#__PURE__*/function (_w6) {
        _inherits(M, _w6);
        function M(e, t) {
          var _this5;
          _classCallCheck(this, M);
          _this5 = _possibleConstructorReturn(this, _getPrototypeOf(M).call(this, e, (t = y(e, t)).length, e.columns)), _this5.rowIndices = t;
          return _this5;
        }
        _createClass(M, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(this.rowIndices[e], t, n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(this.rowIndices[e], t);
          }
        }]);
        return M;
      }(w);
      var C = /*#__PURE__*/function (_w7) {
        _inherits(C, _w7);
        function C(e, t) {
          var _this6;
          _classCallCheck(this, C);
          t = b(e, t), _this6 = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, e, e.rows, t.length)), _this6.columnIndices = t;
          return _this6;
        }
        _createClass(C, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(e, this.columnIndices[t], n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(e, this.columnIndices[t]);
          }
        }]);
        return C;
      }(w);
      var k = /*#__PURE__*/function (_w8) {
        _inherits(k, _w8);
        function k(e, t) {
          var _this7;
          _classCallCheck(this, k);
          _this7 = _possibleConstructorReturn(this, _getPrototypeOf(k).call(this, e, e.rows, 1)), _this7.column = t;
          return _this7;
        }
        _createClass(k, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(e, this.column, n), this;
          }
        }, {
          key: "get",
          value: function get(e) {
            return this.matrix.get(e, this.column);
          }
        }]);
        return k;
      }(w);
      var P = /*#__PURE__*/function (_w9) {
        _inherits(P, _w9);
        function P(e) {
          _classCallCheck(this, P);
          return _possibleConstructorReturn(this, _getPrototypeOf(P).call(this, e, e.rows, e.columns));
        }
        _createClass(P, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(this.rows - e - 1, t, n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(this.rows - e - 1, t);
          }
        }]);
        return P;
      }(w);
      var O = /*#__PURE__*/function (_w10) {
        _inherits(O, _w10);
        function O(e) {
          _classCallCheck(this, O);
          return _possibleConstructorReturn(this, _getPrototypeOf(O).call(this, e, e.rows, e.columns));
        }
        _createClass(O, [{
          key: "set",
          value: function set(e, t, n) {
            return this.matrix.set(e, this.columns - t - 1, n), this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.matrix.get(e, this.columns - t - 1);
          }
        }]);
        return O;
      }(w);
      function R(e) {
        void 0 === e && (e = Object);
        var t = /*#__PURE__*/function (_e14) {
          _inherits(t, _e14);
          function t() {
            _classCallCheck(this, t);
            return _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
          }
          _createClass(t, [{
            key: "apply",
            value: function apply(e) {
              if ("function" != typeof e) throw new TypeError("callback must be a function");
              for (var t = this.rows, n = this.columns, r = 0; r < t; r++) for (var i = 0; i < n; i++) e.call(this, r, i);
              return this;
            }
          }, {
            key: "to1DArray",
            value: function to1DArray() {
              for (var e = new Array(this.size), t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) e[t * this.columns + n] = this.get(t, n);
              return e;
            }
          }, {
            key: "to2DArray",
            value: function to2DArray() {
              for (var e = new Array(this.rows), t = 0; t < this.rows; t++) {
                e[t] = new Array(this.columns);
                for (var n = 0; n < this.columns; n++) e[t][n] = this.get(t, n);
              }
              return e;
            }
          }, {
            key: "isRowVector",
            value: function isRowVector() {
              return 1 === this.rows;
            }
          }, {
            key: "isColumnVector",
            value: function isColumnVector() {
              return 1 === this.columns;
            }
          }, {
            key: "isVector",
            value: function isVector() {
              return 1 === this.rows || 1 === this.columns;
            }
          }, {
            key: "isSquare",
            value: function isSquare() {
              return this.rows === this.columns;
            }
          }, {
            key: "isSymmetric",
            value: function isSymmetric() {
              if (this.isSquare()) {
                for (var e = 0; e < this.rows; e++) for (var t = 0; t <= e; t++) if (this.get(e, t) !== this.get(t, e)) return !1;
                return !0;
              }
              return !1;
            }
          }, {
            key: "isEchelonForm",
            value: function isEchelonForm() {
              var e = 0,
                t = 0,
                n = -1,
                r = !0,
                i = !1;
              for (; e < this.rows && r;) {
                for (t = 0, i = !1; t < this.columns && !1 === i;) 0 === this.get(e, t) ? t++ : 1 === this.get(e, t) && t > n ? (i = !0, n = t) : (r = !1, i = !0);
                e++;
              }
              return r;
            }
          }, {
            key: "isReducedEchelonForm",
            value: function isReducedEchelonForm() {
              var e = 0,
                t = 0,
                n = -1,
                r = !0,
                i = !1;
              for (; e < this.rows && r;) {
                for (t = 0, i = !1; t < this.columns && !1 === i;) 0 === this.get(e, t) ? t++ : 1 === this.get(e, t) && t > n ? (i = !0, n = t) : (r = !1, i = !0);
                for (var _n16 = t + 1; _n16 < this.rows; _n16++) 0 !== this.get(e, _n16) && (r = !1);
                e++;
              }
              return r;
            }
          }, {
            key: "set",
            value: function set(e, t, n) {
              throw new Error("set method is unimplemented");
            }
          }, {
            key: "get",
            value: function get(e, t) {
              throw new Error("get method is unimplemented");
            }
          }, {
            key: "repeat",
            value: function repeat(e, t) {
              e = e || 1, t = t || 1;
              for (var n = new this.constructor[Symbol.species](this.rows * e, this.columns * t), r = 0; r < e; r++) for (var i = 0; i < t; i++) n.setSubMatrix(this, this.rows * r, this.columns * i);
              return n;
            }
          }, {
            key: "fill",
            value: function fill(e) {
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, e);
              return this;
            }
          }, {
            key: "neg",
            value: function neg() {
              return this.mulS(-1);
            }
          }, {
            key: "getRow",
            value: function getRow(e) {
              f(this, e);
              for (var t = new Array(this.columns), n = 0; n < this.columns; n++) t[n] = this.get(e, n);
              return t;
            }
          }, {
            key: "getRowVector",
            value: function getRowVector(e) {
              return this.constructor.rowVector(this.getRow(e));
            }
          }, {
            key: "setRow",
            value: function setRow(e, t) {
              f(this, e), t = m(this, t);
              for (var n = 0; n < this.columns; n++) this.set(e, n, t[n]);
              return this;
            }
          }, {
            key: "swapRows",
            value: function swapRows(e, t) {
              f(this, e), f(this, t);
              for (var n = 0; n < this.columns; n++) {
                var r = this.get(e, n);
                this.set(e, n, this.get(t, n)), this.set(t, n, r);
              }
              return this;
            }
          }, {
            key: "getColumn",
            value: function getColumn(e) {
              p(this, e);
              for (var t = new Array(this.rows), n = 0; n < this.rows; n++) t[n] = this.get(n, e);
              return t;
            }
          }, {
            key: "getColumnVector",
            value: function getColumnVector(e) {
              return this.constructor.columnVector(this.getColumn(e));
            }
          }, {
            key: "setColumn",
            value: function setColumn(e, t) {
              p(this, e), t = g(this, t);
              for (var n = 0; n < this.rows; n++) this.set(n, e, t[n]);
              return this;
            }
          }, {
            key: "swapColumns",
            value: function swapColumns(e, t) {
              p(this, e), p(this, t);
              for (var n = 0; n < this.rows; n++) {
                var r = this.get(n, e);
                this.set(n, e, this.get(n, t)), this.set(n, t, r);
              }
              return this;
            }
          }, {
            key: "addRowVector",
            value: function addRowVector(e) {
              e = m(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) + e[n]);
              return this;
            }
          }, {
            key: "subRowVector",
            value: function subRowVector(e) {
              e = m(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) - e[n]);
              return this;
            }
          }, {
            key: "mulRowVector",
            value: function mulRowVector(e) {
              e = m(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) * e[n]);
              return this;
            }
          }, {
            key: "divRowVector",
            value: function divRowVector(e) {
              e = m(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) / e[n]);
              return this;
            }
          }, {
            key: "addColumnVector",
            value: function addColumnVector(e) {
              e = g(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) + e[t]);
              return this;
            }
          }, {
            key: "subColumnVector",
            value: function subColumnVector(e) {
              e = g(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) - e[t]);
              return this;
            }
          }, {
            key: "mulColumnVector",
            value: function mulColumnVector(e) {
              e = g(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) * e[t]);
              return this;
            }
          }, {
            key: "divColumnVector",
            value: function divColumnVector(e) {
              e = g(this, e);
              for (var t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.set(t, n, this.get(t, n) / e[t]);
              return this;
            }
          }, {
            key: "mulRow",
            value: function mulRow(e, t) {
              f(this, e);
              for (var n = 0; n < this.columns; n++) this.set(e, n, this.get(e, n) * t);
              return this;
            }
          }, {
            key: "mulColumn",
            value: function mulColumn(e, t) {
              p(this, e);
              for (var n = 0; n < this.rows; n++) this.set(n, e, this.get(n, e) * t);
              return this;
            }
          }, {
            key: "max",
            value: function max() {
              for (var e = this.get(0, 0), t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.get(t, n) > e && (e = this.get(t, n));
              return e;
            }
          }, {
            key: "maxIndex",
            value: function maxIndex() {
              for (var e = this.get(0, 0), t = [0, 0], n = 0; n < this.rows; n++) for (var r = 0; r < this.columns; r++) this.get(n, r) > e && (e = this.get(n, r), t[0] = n, t[1] = r);
              return t;
            }
          }, {
            key: "min",
            value: function min() {
              for (var e = this.get(0, 0), t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) this.get(t, n) < e && (e = this.get(t, n));
              return e;
            }
          }, {
            key: "minIndex",
            value: function minIndex() {
              for (var e = this.get(0, 0), t = [0, 0], n = 0; n < this.rows; n++) for (var r = 0; r < this.columns; r++) this.get(n, r) < e && (e = this.get(n, r), t[0] = n, t[1] = r);
              return t;
            }
          }, {
            key: "maxRow",
            value: function maxRow(e) {
              f(this, e);
              for (var t = this.get(e, 0), n = 1; n < this.columns; n++) this.get(e, n) > t && (t = this.get(e, n));
              return t;
            }
          }, {
            key: "maxRowIndex",
            value: function maxRowIndex(e) {
              f(this, e);
              for (var t = this.get(e, 0), n = [e, 0], r = 1; r < this.columns; r++) this.get(e, r) > t && (t = this.get(e, r), n[1] = r);
              return n;
            }
          }, {
            key: "minRow",
            value: function minRow(e) {
              f(this, e);
              for (var t = this.get(e, 0), n = 1; n < this.columns; n++) this.get(e, n) < t && (t = this.get(e, n));
              return t;
            }
          }, {
            key: "minRowIndex",
            value: function minRowIndex(e) {
              f(this, e);
              for (var t = this.get(e, 0), n = [e, 0], r = 1; r < this.columns; r++) this.get(e, r) < t && (t = this.get(e, r), n[1] = r);
              return n;
            }
          }, {
            key: "maxColumn",
            value: function maxColumn(e) {
              p(this, e);
              for (var t = this.get(0, e), n = 1; n < this.rows; n++) this.get(n, e) > t && (t = this.get(n, e));
              return t;
            }
          }, {
            key: "maxColumnIndex",
            value: function maxColumnIndex(e) {
              p(this, e);
              for (var t = this.get(0, e), n = [0, e], r = 1; r < this.rows; r++) this.get(r, e) > t && (t = this.get(r, e), n[0] = r);
              return n;
            }
          }, {
            key: "minColumn",
            value: function minColumn(e) {
              p(this, e);
              for (var t = this.get(0, e), n = 1; n < this.rows; n++) this.get(n, e) < t && (t = this.get(n, e));
              return t;
            }
          }, {
            key: "minColumnIndex",
            value: function minColumnIndex(e) {
              p(this, e);
              for (var t = this.get(0, e), n = [0, e], r = 1; r < this.rows; r++) this.get(r, e) < t && (t = this.get(r, e), n[0] = r);
              return n;
            }
          }, {
            key: "diag",
            value: function diag() {
              for (var e = Math.min(this.rows, this.columns), t = new Array(e), n = 0; n < e; n++) t[n] = this.get(n, n);
              return t;
            }
          }, {
            key: "sum",
            value: function sum(e) {
              switch (e) {
                case "row":
                  return function (e) {
                    for (var t = I.zeros(e.rows, 1), n = 0; n < e.rows; ++n) for (var r = 0; r < e.columns; ++r) t.set(n, 0, t.get(n, 0) + e.get(n, r));
                    return t;
                  }(this);
                case "column":
                  return function (e) {
                    for (var t = I.zeros(1, e.columns), n = 0; n < e.rows; ++n) for (var r = 0; r < e.columns; ++r) t.set(0, r, t.get(0, r) + e.get(n, r));
                    return t;
                  }(this);
                default:
                  return function (e) {
                    for (var t = 0, n = 0; n < e.rows; n++) for (var r = 0; r < e.columns; r++) t += e.get(n, r);
                    return t;
                  }(this);
              }
            }
          }, {
            key: "mean",
            value: function mean() {
              return this.sum() / this.size;
            }
          }, {
            key: "prod",
            value: function prod() {
              for (var e = 1, t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) e *= this.get(t, n);
              return e;
            }
          }, {
            key: "norm",
            value: function norm() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "frobenius";
              var t = 0;
              if ("max" === e) return this.max();
              if ("frobenius" === e) {
                for (var n = 0; n < this.rows; n++) for (var r = 0; r < this.columns; r++) t += this.get(n, r) * this.get(n, r);
                return Math.sqrt(t);
              }
              throw new RangeError("unknown norm type: ".concat(e));
            }
          }, {
            key: "cumulativeSum",
            value: function cumulativeSum() {
              for (var e = 0, t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) e += this.get(t, n), this.set(t, n, e);
              return this;
            }
          }, {
            key: "dot",
            value: function dot(e) {
              t.isMatrix(e) && (e = e.to1DArray());
              var n = this.to1DArray();
              if (n.length !== e.length) throw new RangeError("vectors do not have the same size");
              for (var r = 0, i = 0; i < n.length; i++) r += n[i] * e[i];
              return r;
            }
          }, {
            key: "mmul",
            value: function mmul(e) {
              e = this.constructor.checkMatrix(e), this.columns !== e.rows && console.warn("Number of columns of left matrix are not equal to number of rows of right matrix.");
              for (var t = this.rows, n = this.columns, r = e.columns, i = new this.constructor[Symbol.species](t, r), o = new Array(n), a = 0; a < r; a++) {
                for (var s = 0; s < n; s++) o[s] = e.get(s, a);
                for (var l = 0; l < t; l++) {
                  var u = 0;
                  for (s = 0; s < n; s++) u += this.get(l, s) * o[s];
                  i.set(l, a, u);
                }
              }
              return i;
            }
          }, {
            key: "strassen2x2",
            value: function strassen2x2(e) {
              var t = new this.constructor[Symbol.species](2, 2);
              var n = this.get(0, 0),
                r = e.get(0, 0),
                i = this.get(0, 1),
                o = e.get(0, 1),
                a = this.get(1, 0),
                s = e.get(1, 0),
                l = this.get(1, 1),
                u = e.get(1, 1),
                c = (n + l) * (r + u),
                d = (a + l) * r,
                h = n * (o - u),
                f = l * (s - r),
                p = (n + i) * u,
                m = c + f - p + (i - l) * (s + u),
                g = h + p,
                v = d + f,
                y = c - d + h + (a - n) * (r + o);
              return t.set(0, 0, m), t.set(0, 1, g), t.set(1, 0, v), t.set(1, 1, y), t;
            }
          }, {
            key: "strassen3x3",
            value: function strassen3x3(e) {
              var t = new this.constructor[Symbol.species](3, 3);
              var n = this.get(0, 0),
                r = this.get(0, 1),
                i = this.get(0, 2),
                o = this.get(1, 0),
                a = this.get(1, 1),
                s = this.get(1, 2),
                l = this.get(2, 0),
                u = this.get(2, 1),
                c = this.get(2, 2),
                d = e.get(0, 0),
                h = e.get(0, 1),
                f = e.get(0, 2),
                p = e.get(1, 0),
                m = e.get(1, 1),
                g = e.get(1, 2),
                v = e.get(2, 0),
                y = e.get(2, 1),
                b = e.get(2, 2),
                _ = (n - o) * (-h + m),
                x = (-n + o + a) * (d - h + m),
                w = (o + a) * (-d + h),
                S = n * d,
                A = (-n + l + u) * (d - f + g),
                E = (-n + l) * (f - g),
                T = (l + u) * (-d + f),
                M = (-i + u + c) * (m + v - y),
                C = (i - c) * (m - y),
                k = i * v,
                P = (u + c) * (-v + y),
                O = (-i + a + s) * (g + v - b),
                R = (i - s) * (g - b),
                I = (a + s) * (-v + b),
                j = S + k + r * p,
                N = (n + r + i - o - a - u - c) * m + x + w + S + M + k + P,
                L = S + A + T + (n + r + i - a - s - l - u) * g + k + O + I,
                D = _ + a * (-d + h + p - m - g - v + b) + x + S + k + O + R,
                B = _ + x + w + S + s * y,
                F = k + O + R + I + o * f,
                z = S + A + E + u * (-d + f + p - m - g - v + y) + M + C + k,
                U = M + C + k + P + l * h,
                G = S + A + E + T + c * b;
              return t.set(0, 0, j), t.set(0, 1, N), t.set(0, 2, L), t.set(1, 0, D), t.set(1, 1, B), t.set(1, 2, F), t.set(2, 0, z), t.set(2, 1, U), t.set(2, 2, G), t;
            }
          }, {
            key: "mmulStrassen",
            value: function mmulStrassen(e) {
              var n = this.clone(),
                r = n.rows,
                i = n.columns,
                o = e.rows,
                a = e.columns;
              function s(e, n, r) {
                var i = e.rows,
                  o = e.columns;
                if (i === n && o === r) return e;
                var a = t.zeros(n, r);
                return a = a.setSubMatrix(e, 0, 0);
              }
              i !== o && console.warn("Multiplying ".concat(r, " x ").concat(i, " and ").concat(o, " x ").concat(a, " matrix: dimensions do not match."));
              var l = Math.max(r, o),
                u = Math.max(i, a);
              return function e(n, r, i, o) {
                if (i <= 512 || o <= 512) return n.mmul(r);
                i % 2 == 1 && o % 2 == 1 ? (n = s(n, i + 1, o + 1), r = s(r, i + 1, o + 1)) : i % 2 == 1 ? (n = s(n, i + 1, o), r = s(r, i + 1, o)) : o % 2 == 1 && (n = s(n, i, o + 1), r = s(r, i, o + 1));
                var a = parseInt(n.rows / 2, 10),
                  l = parseInt(n.columns / 2, 10),
                  u = n.subMatrix(0, a - 1, 0, l - 1),
                  c = r.subMatrix(0, a - 1, 0, l - 1),
                  d = n.subMatrix(0, a - 1, l, n.columns - 1),
                  h = r.subMatrix(0, a - 1, l, r.columns - 1),
                  f = n.subMatrix(a, n.rows - 1, 0, l - 1),
                  p = r.subMatrix(a, r.rows - 1, 0, l - 1),
                  m = n.subMatrix(a, n.rows - 1, l, n.columns - 1),
                  g = r.subMatrix(a, r.rows - 1, l, r.columns - 1),
                  v = e(t.add(u, m), t.add(c, g), a, l),
                  y = e(t.add(f, m), c, a, l),
                  b = e(u, t.sub(h, g), a, l),
                  _ = e(m, t.sub(p, c), a, l),
                  x = e(t.add(u, d), g, a, l),
                  w = e(t.sub(f, u), t.add(c, h), a, l),
                  S = e(t.sub(d, m), t.add(p, g), a, l),
                  A = t.add(v, _);
                A.sub(x), A.add(S);
                var E = t.add(b, x),
                  T = t.add(y, _),
                  M = t.sub(v, y);
                M.add(b), M.add(w);
                var C = t.zeros(2 * A.rows, 2 * A.columns);
                return (C = (C = (C = (C = C.setSubMatrix(A, 0, 0)).setSubMatrix(E, A.rows, 0)).setSubMatrix(T, 0, A.columns)).setSubMatrix(M, A.rows, A.columns)).subMatrix(0, i - 1, 0, o - 1);
              }(n = s(n, l, u), e = s(e, l, u), l, u);
            }
          }, {
            key: "scaleRows",
            value: function scaleRows(e, t) {
              if ((e = void 0 === e ? 0 : e) >= (t = void 0 === t ? 1 : t)) throw new RangeError("min should be strictly smaller than max");
              for (var n = this.constructor.empty(this.rows, this.columns), r = 0; r < this.rows; r++) {
                var i = l(this.getRow(r), {
                  min: e,
                  max: t
                });
                n.setRow(r, i);
              }
              return n;
            }
          }, {
            key: "scaleColumns",
            value: function scaleColumns(e, t) {
              if ((e = void 0 === e ? 0 : e) >= (t = void 0 === t ? 1 : t)) throw new RangeError("min should be strictly smaller than max");
              for (var n = this.constructor.empty(this.rows, this.columns), r = 0; r < this.columns; r++) {
                var i = l(this.getColumn(r), {
                  min: e,
                  max: t
                });
                n.setColumn(r, i);
              }
              return n;
            }
          }, {
            key: "kroneckerProduct",
            value: function kroneckerProduct(e) {
              e = this.constructor.checkMatrix(e);
              for (var t = this.rows, n = this.columns, r = e.rows, i = e.columns, o = new this.constructor[Symbol.species](t * r, n * i), a = 0; a < t; a++) for (var s = 0; s < n; s++) for (var l = 0; l < r; l++) for (var u = 0; u < i; u++) o[r * a + l][i * s + u] = this.get(a, s) * e.get(l, u);
              return o;
            }
          }, {
            key: "transpose",
            value: function transpose() {
              for (var e = new this.constructor[Symbol.species](this.columns, this.rows), t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) e.set(n, t, this.get(t, n));
              return e;
            }
          }, {
            key: "sortRows",
            value: function sortRows(e) {
              void 0 === e && (e = n);
              for (var t = 0; t < this.rows; t++) this.setRow(t, this.getRow(t).sort(e));
              return this;
            }
          }, {
            key: "sortColumns",
            value: function sortColumns(e) {
              void 0 === e && (e = n);
              for (var t = 0; t < this.columns; t++) this.setColumn(t, this.getColumn(t).sort(e));
              return this;
            }
          }, {
            key: "subMatrix",
            value: function subMatrix(e, t, n, r) {
              _(this, e, t, n, r);
              for (var i = new this.constructor[Symbol.species](t - e + 1, r - n + 1), o = e; o <= t; o++) for (var a = n; a <= r; a++) i[o - e][a - n] = this.get(o, a);
              return i;
            }
          }, {
            key: "subMatrixRow",
            value: function subMatrixRow(e, t, n) {
              if (void 0 === t && (t = 0), void 0 === n && (n = this.columns - 1), t > n || t < 0 || t >= this.columns || n < 0 || n >= this.columns) throw new RangeError("Argument out of range");
              for (var r = new this.constructor[Symbol.species](e.length, n - t + 1), i = 0; i < e.length; i++) for (var o = t; o <= n; o++) {
                if (e[i] < 0 || e[i] >= this.rows) throw new RangeError("Row index out of range: ".concat(e[i]));
                r.set(i, o - t, this.get(e[i], o));
              }
              return r;
            }
          }, {
            key: "subMatrixColumn",
            value: function subMatrixColumn(e, t, n) {
              if (void 0 === t && (t = 0), void 0 === n && (n = this.rows - 1), t > n || t < 0 || t >= this.rows || n < 0 || n >= this.rows) throw new RangeError("Argument out of range");
              for (var r = new this.constructor[Symbol.species](n - t + 1, e.length), i = 0; i < e.length; i++) for (var o = t; o <= n; o++) {
                if (e[i] < 0 || e[i] >= this.columns) throw new RangeError("Column index out of range: ".concat(e[i]));
                r.set(o - t, i, this.get(o, e[i]));
              }
              return r;
            }
          }, {
            key: "setSubMatrix",
            value: function setSubMatrix(e, t, n) {
              _(this, t, t + (e = this.constructor.checkMatrix(e)).rows - 1, n, n + e.columns - 1);
              for (var r = 0; r < e.rows; r++) for (var i = 0; i < e.columns; i++) this[t + r][n + i] = e.get(r, i);
              return this;
            }
          }, {
            key: "selection",
            value: function selection(e, t) {
              for (var n = v(this, e, t), r = new this.constructor[Symbol.species](e.length, t.length), i = 0; i < n.row.length; i++) for (var o = n.row[i], a = 0; a < n.column.length; a++) {
                var s = n.column[a];
                r[i][a] = this.get(o, s);
              }
              return r;
            }
          }, {
            key: "trace",
            value: function trace() {
              for (var e = Math.min(this.rows, this.columns), t = 0, n = 0; n < e; n++) t += this.get(n, n);
              return t;
            }
          }, {
            key: "transposeView",
            value: function transposeView() {
              return new S(this);
            }
          }, {
            key: "rowView",
            value: function rowView(e) {
              return f(this, e), new A(this, e);
            }
          }, {
            key: "columnView",
            value: function columnView(e) {
              return p(this, e), new k(this, e);
            }
          }, {
            key: "flipRowView",
            value: function flipRowView() {
              return new P(this);
            }
          }, {
            key: "flipColumnView",
            value: function flipColumnView() {
              return new O(this);
            }
          }, {
            key: "subMatrixView",
            value: function subMatrixView(e, t, n, r) {
              return new E(this, e, t, n, r);
            }
          }, {
            key: "selectionView",
            value: function selectionView(e, t) {
              return new T(this, e, t);
            }
          }, {
            key: "rowSelectionView",
            value: function rowSelectionView(e) {
              return new M(this, e);
            }
          }, {
            key: "columnSelectionView",
            value: function columnSelectionView(e) {
              return new C(this, e);
            }
          }, {
            key: "det",
            value: function det() {
              var e, t, n, r, i, o;
              if (this.isSquare()) return 2 === this.columns ? (e = this.get(0, 0), t = this.get(0, 1), n = this.get(1, 0), e * this.get(1, 1) - t * n) : 3 === this.columns ? (r = this.selectionView([1, 2], [1, 2]), i = this.selectionView([1, 2], [0, 2]), o = this.selectionView([1, 2], [0, 1]), e = this.get(0, 0), t = this.get(0, 1), n = this.get(0, 2), e * r.det() - t * i.det() + n * o.det()) : new u(this).determinant;
              throw Error("Determinant can only be calculated for a square matrix.");
            }
          }, {
            key: "pseudoInverse",
            value: function pseudoInverse(e) {
              void 0 === e && (e = Number.EPSILON);
              for (var t = new h(this, {
                  autoTranspose: !0
                }), n = t.leftSingularVectors, r = t.rightSingularVectors, i = t.diagonal, o = 0; o < i.length; o++) Math.abs(i[o]) > e ? i[o] = 1 / i[o] : i[o] = 0;
              return i = this.constructor[Symbol.species].diag(i), r.mmul(i.mmul(n.transposeView()));
            }
          }, {
            key: "clone",
            value: function clone() {
              for (var e = new this.constructor[Symbol.species](this.rows, this.columns), t = 0; t < this.rows; t++) for (var n = 0; n < this.columns; n++) e.set(t, n, this.get(t, n));
              return e;
            }
          }, {
            key: "size",
            get: function get() {
              return this.rows * this.columns;
            }
          }], [{
            key: "from1DArray",
            value: function from1DArray(e, t, n) {
              if (e * t !== n.length) throw new RangeError("Data length does not match given dimensions");
              for (var r = new this(e, t), i = 0; i < e; i++) for (var o = 0; o < t; o++) r.set(i, o, n[i * t + o]);
              return r;
            }
          }, {
            key: "rowVector",
            value: function rowVector(e) {
              for (var t = new this(1, e.length), n = 0; n < e.length; n++) t.set(0, n, e[n]);
              return t;
            }
          }, {
            key: "columnVector",
            value: function columnVector(e) {
              for (var t = new this(e.length, 1), n = 0; n < e.length; n++) t.set(n, 0, e[n]);
              return t;
            }
          }, {
            key: "empty",
            value: function empty(e, t) {
              return new this(e, t);
            }
          }, {
            key: "zeros",
            value: function zeros(e, t) {
              return this.empty(e, t).fill(0);
            }
          }, {
            key: "ones",
            value: function ones(e, t) {
              return this.empty(e, t).fill(1);
            }
          }, {
            key: "rand",
            value: function rand(e, t, n) {
              void 0 === n && (n = Math.random);
              for (var r = this.empty(e, t), i = 0; i < e; i++) for (var o = 0; o < t; o++) r.set(i, o, n());
              return r;
            }
          }, {
            key: "randInt",
            value: function randInt(e, t, n, r) {
              void 0 === n && (n = 1e3), void 0 === r && (r = Math.random);
              for (var i = this.empty(e, t), o = 0; o < e; o++) for (var a = 0; a < t; a++) {
                var s = Math.floor(r() * n);
                i.set(o, a, s);
              }
              return i;
            }
          }, {
            key: "eye",
            value: function eye(e, t, n) {
              void 0 === t && (t = e), void 0 === n && (n = 1);
              for (var r = Math.min(e, t), i = this.zeros(e, t), o = 0; o < r; o++) i.set(o, o, n);
              return i;
            }
          }, {
            key: "diag",
            value: function diag(e, t, n) {
              var r = e.length;
              void 0 === t && (t = r), void 0 === n && (n = t);
              for (var i = Math.min(r, t, n), o = this.zeros(t, n), a = 0; a < i; a++) o.set(a, a, e[a]);
              return o;
            }
          }, {
            key: "min",
            value: function min(e, t) {
              e = this.checkMatrix(e), t = this.checkMatrix(t);
              for (var n = e.rows, r = e.columns, i = new this(n, r), o = 0; o < n; o++) for (var a = 0; a < r; a++) i.set(o, a, Math.min(e.get(o, a), t.get(o, a)));
              return i;
            }
          }, {
            key: "max",
            value: function max(e, t) {
              e = this.checkMatrix(e), t = this.checkMatrix(t);
              for (var n = e.rows, r = e.columns, i = new this(n, r), o = 0; o < n; o++) for (var a = 0; a < r; a++) i.set(o, a, Math.max(e.get(o, a), t.get(o, a)));
              return i;
            }
          }, {
            key: "checkMatrix",
            value: function checkMatrix(e) {
              return t.isMatrix(e) ? e : new this(e);
            }
          }, {
            key: "isMatrix",
            value: function isMatrix(e) {
              return null != e && "Matrix" === e.klass;
            }
          }, {
            key: Symbol.species,
            get: function get() {
              return this;
            }
          }]);
          return t;
        }(e);
        function n(e, t) {
          return e - t;
        }
        t.prototype.klass = "Matrix", t.random = t.rand, t.diagonal = t.diag, t.prototype.diagonal = t.prototype.diag, t.identity = t.eye, t.prototype.negate = t.prototype.neg, t.prototype.tensorProduct = t.prototype.kroneckerProduct, t.prototype.determinant = t.prototype.det;
        var r,
          i = "\n(function %name%(matrix, %args%) {\n    var newMatrix = new this[Symbol.species](matrix);\n    return newMatrix.%name%(%args%);\n})\n",
          o = eval;
        for (var _i15 = 0, _arr = [["+", "add"], ["-", "sub", "subtract"], ["*", "mul", "multiply"], ["/", "div", "divide"], ["%", "mod", "modulus"], ["&", "and"], ["|", "or"], ["^", "xor"], ["<<", "leftShift"], [">>", "signPropagatingRightShift"], [">>>", "rightShift", "zeroFillRightShift"]]; _i15 < _arr.length; _i15++) {
          var a = _arr[_i15];
          var s = o(V("\n(function %name%(value) {\n    if (typeof value === 'number') return this.%name%S(value);\n    return this.%name%M(value);\n})\n", {
              name: a[1],
              op: a[0]
            })),
            c = o(V("\n(function %name%S(value) {\n    for (var i = 0; i < this.rows; i++) {\n        for (var j = 0; j < this.columns; j++) {\n            this.set(i, j, this.get(i, j) %op% value);\n        }\n    }\n    return this;\n})\n", {
              name: "".concat(a[1], "S"),
              op: a[0]
            })),
            d = o(V("\n(function %name%M(matrix) {\n    matrix = this.constructor.checkMatrix(matrix);\n    if (this.rows !== matrix.rows ||\n        this.columns !== matrix.columns) {\n        throw new RangeError('Matrices dimensions must be equal');\n    }\n    for (var i = 0; i < this.rows; i++) {\n        for (var j = 0; j < this.columns; j++) {\n            this.set(i, j, this.get(i, j) %op% matrix.get(i, j));\n        }\n    }\n    return this;\n})\n", {
              name: "".concat(a[1], "M"),
              op: a[0]
            })),
            y = o(V("\n(function %name%(matrix, value) {\n    var newMatrix = new this[Symbol.species](matrix);\n    return newMatrix.%name%(value);\n})\n", {
              name: a[1]
            }));
          for (r = 1; r < a.length; r++) t.prototype[a[r]] = s, t.prototype["".concat(a[r], "S")] = c, t.prototype["".concat(a[r], "M")] = d, t[a[r]] = y;
        }
        var b = [["~", "not"]];
        for (var _i16 = 0, _arr2 = (["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "cbrt", "ceil", "clz32", "cos", "cosh", "exp", "expm1", "floor", "fround", "log", "log1p", "log10", "log2", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc"].forEach(function (e) {
            b.push(["Math.".concat(e), e]);
          }), b); _i16 < _arr2.length; _i16++) {
          var x = _arr2[_i16];
          var w = o(V("\n(function %name%() {\n    for (var i = 0; i < this.rows; i++) {\n        for (var j = 0; j < this.columns; j++) {\n            this.set(i, j, %method%(this.get(i, j)));\n        }\n    }\n    return this;\n})\n", {
              name: x[1],
              method: x[0]
            })),
            R = o(V("\n(function %name%(matrix) {\n    var newMatrix = new this[Symbol.species](matrix);\n    return newMatrix.%name%();\n})\n", {
              name: x[1]
            }));
          for (r = 1; r < x.length; r++) t.prototype[x[r]] = w, t[x[r]] = R;
        }
        for (var _i17 = 0, _arr3 = [["Math.pow", 1, "pow"]]; _i17 < _arr3.length; _i17++) {
          var j = _arr3[_i17];
          var N = "arg0";
          for (r = 1; r < j[1]; r++) N += ", arg".concat(r);
          if (1 !== j[1]) {
            var L = o(V("\n(function %name%(%args%) {\n    for (var i = 0; i < this.rows; i++) {\n        for (var j = 0; j < this.columns; j++) {\n            this.set(i, j, %method%(this.get(i, j), %args%));\n        }\n    }\n    return this;\n})\n", {
                name: j[2],
                method: j[0],
                args: N
              })),
              D = o(V(i, {
                name: j[2],
                args: N
              }));
            for (r = 2; r < j.length; r++) t.prototype[j[r]] = L, t[j[r]] = D;
          } else {
            var B = {
                name: j[2],
                args: N,
                method: j[0]
              },
              F = o(V("\n(function %name%(value) {\n    if (typeof value === 'number') return this.%name%S(value);\n    return this.%name%M(value);\n})\n", B)),
              z = o(V("\n(function %name%S(value) {\n    for (var i = 0; i < this.rows; i++) {\n        for (var j = 0; j < this.columns; j++) {\n            this.set(i, j, %method%(this.get(i, j), value));\n        }\n    }\n    return this;\n})\n", B)),
              U = o(V("\n(function %name%M(matrix) {\n    matrix = this.constructor.checkMatrix(matrix);\n    if (this.rows !== matrix.rows ||\n        this.columns !== matrix.columns) {\n        throw new RangeError('Matrices dimensions must be equal');\n    }\n    for (var i = 0; i < this.rows; i++) {\n        for (var j = 0; j < this.columns; j++) {\n            this.set(i, j, %method%(this.get(i, j), matrix.get(i, j)));\n        }\n    }\n    return this;\n})\n", B)),
              G = o(V("\n(function %name%(matrix, %args%) {\n    var newMatrix = new this[Symbol.species](matrix);\n    return newMatrix.%name%(%args%);\n})\n", B));
            for (r = 2; r < j.length; r++) t.prototype[j[r]] = F, t.prototype["".concat(j[r], "M")] = U, t.prototype["".concat(j[r], "S")] = z, t[j[r]] = G;
          }
        }
        function V(e, t) {
          for (var n in t) e = e.replace(new RegExp("%".concat(n, "%"), "g"), t[n]);
          return e;
        }
        return t;
      }
      var I = /*#__PURE__*/function (_R2) {
        _inherits(I, _R2);
        function I(e, t) {
          var _this8;
          _classCallCheck(this, I);
          var n;
          if (1 === arguments.length && "number" == typeof e) return _possibleConstructorReturn(_this8, new Array(e));
          if (I.isMatrix(e)) return _possibleConstructorReturn(_this8, e.clone());
          if (Number.isInteger(e) && e > 0) {
            if (_this8 = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, e)), !(Number.isInteger(t) && t > 0)) throw new TypeError("nColumns must be a positive integer");
            for (n = 0; n < e; n++) _this8[n] = new Array(t);
          } else {
            if (!Array.isArray(e)) throw new TypeError("First argument must be a positive number or an array");
            {
              var _r8 = e;
              if (e = _r8.length, "number" != typeof (t = _r8[0].length) || 0 === t) throw new TypeError("Data must be a 2D array with at least one element");
              for (_this8 = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, e)), n = 0; n < e; n++) {
                if (_r8[n].length !== t) throw new RangeError("Inconsistent array dimensions");
                _this8[n] = [].concat(_r8[n]);
              }
            }
          }
          return _possibleConstructorReturn(_this8, (_this8.rows = e, _this8.columns = t, _assertThisInitialized(_this8)));
        }
        _createClass(I, [{
          key: "set",
          value: function set(e, t, n) {
            return this[e][t] = n, this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this[e][t];
          }
        }, {
          key: "removeRow",
          value: function removeRow(e) {
            if (f(this, e), 1 === this.rows) throw new RangeError("A matrix cannot have less than one row");
            return this.splice(e, 1), this.rows -= 1, this;
          }
        }, {
          key: "addRow",
          value: function addRow(e, t) {
            return void 0 === t && (t = e, e = this.rows), f(this, e, !0), t = m(this, t), this.splice(e, 0, t), this.rows += 1, this;
          }
        }, {
          key: "removeColumn",
          value: function removeColumn(e) {
            if (p(this, e), 1 === this.columns) throw new RangeError("A matrix cannot have less than one column");
            for (var t = 0; t < this.rows; t++) this[t].splice(e, 1);
            return this.columns -= 1, this;
          }
        }, {
          key: "addColumn",
          value: function addColumn(e, t) {
            void 0 === t && (t = e, e = this.columns), p(this, e, !0), t = g(this, t);
            for (var n = 0; n < this.rows; n++) this[n].splice(e, 0, t[n]);
            return this.columns += 1, this;
          }
        }]);
        return I;
      }(R(Array));
      R();
      var j = /*#__PURE__*/function (_R3) {
        _inherits(j, _R3);
        function j(e) {
          var _this9;
          _classCallCheck(this, j);
          _this9 = _possibleConstructorReturn(this, _getPrototypeOf(j).call(this)), _this9.data = e, _this9.rows = e.length, _this9.columns = e[0].length;
          return _this9;
        }
        _createClass(j, [{
          key: "set",
          value: function set(e, t, n) {
            return this.data[e][t] = n, this;
          }
        }, {
          key: "get",
          value: function get(e, t) {
            return this.data[e][t];
          }
        }], [{
          key: Symbol.species,
          get: function get() {
            return I;
          }
        }]);
        return j;
      }(R());
      var N = /*#__PURE__*/function () {
        function N(e) {
          _classCallCheck(this, N);
          var t,
            n,
            r,
            i,
            o = (e = j.checkMatrix(e)).clone(),
            a = e.rows,
            s = e.columns,
            l = new Array(s);
          for (r = 0; r < s; r++) {
            var u = 0;
            for (t = r; t < a; t++) u = c(u, o.get(t, r));
            if (0 !== u) {
              for (o.get(r, r) < 0 && (u = -u), t = r; t < a; t++) o.set(t, r, o.get(t, r) / u);
              for (o.set(r, r, o.get(r, r) + 1), n = r + 1; n < s; n++) {
                for (i = 0, t = r; t < a; t++) i += o.get(t, r) * o.get(t, n);
                for (i = -i / o.get(r, r), t = r; t < a; t++) o.set(t, n, o.get(t, n) + i * o.get(t, r));
              }
            }
            l[r] = -u;
          }
          this.QR = o, this.Rdiag = l;
        }
        _createClass(N, [{
          key: "solve",
          value: function solve(e) {
            e = I.checkMatrix(e);
            var t = this.QR,
              n = t.rows;
            if (e.rows !== n) throw new Error("Matrix row dimensions must agree");
            if (!this.isFullRank()) throw new Error("Matrix is rank deficient");
            var r,
              i,
              o,
              a,
              s = e.columns,
              l = e.clone(),
              u = t.columns;
            for (o = 0; o < u; o++) for (i = 0; i < s; i++) {
              for (a = 0, r = o; r < n; r++) a += t[r][o] * l[r][i];
              for (a = -a / t[o][o], r = o; r < n; r++) l[r][i] += a * t[r][o];
            }
            for (o = u - 1; o >= 0; o--) {
              for (i = 0; i < s; i++) l[o][i] /= this.Rdiag[o];
              for (r = 0; r < o; r++) for (i = 0; i < s; i++) l[r][i] -= l[o][i] * t[r][o];
            }
            return l.subMatrix(0, u - 1, 0, s - 1);
          }
        }, {
          key: "isFullRank",
          value: function isFullRank() {
            for (var e = this.QR.columns, t = 0; t < e; t++) if (0 === this.Rdiag[t]) return !1;
            return !0;
          }
        }, {
          key: "upperTriangularMatrix",
          get: function get() {
            var e,
              t,
              n = this.QR,
              r = n.columns,
              i = new I(r, r);
            for (e = 0; e < r; e++) for (t = 0; t < r; t++) i[e][t] = e < t ? n[e][t] : e === t ? this.Rdiag[e] : 0;
            return i;
          }
        }, {
          key: "orthogonalMatrix",
          get: function get() {
            var e,
              t,
              n,
              r,
              i = this.QR,
              o = i.rows,
              a = i.columns,
              s = new I(o, a);
            for (n = a - 1; n >= 0; n--) {
              for (e = 0; e < o; e++) s[e][n] = 0;
              for (s[n][n] = 1, t = n; t < a; t++) if (0 !== i[n][n]) {
                for (r = 0, e = n; e < o; e++) r += i[e][n] * s[e][t];
                for (r = -r / i[n][n], e = n; e < o; e++) s[e][t] += r * i[e][n];
              }
            }
            return s;
          }
        }]);
        return N;
      }();
      function L(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return e = j.checkMatrix(e), t ? new h(e).inverse() : function (e, t) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          return e = j.checkMatrix(e), t = j.checkMatrix(t), n ? new h(e).solve(t) : e.isSquare() ? new u(e).solve(t) : new N(e).solve(t);
        }(e, I.eye(e.rows));
      }
      function D(e, t, n, r, i) {
        var o = n * r * r,
          a = I.eye(t.length, t.length, o);
        var s = i(t);
        var l = e.x.map(function (e) {
            return s(e);
          }),
          u = function (e, t, n, r, i) {
            var o = n.length,
              a = e.x.length;
            for (var s = new Array(o), l = 0; l < o; l++) {
              s[l] = new Array(a);
              var u = n.concat();
              u[l] += r;
              for (var c = i(u), d = 0; d < a; d++) s[l][d] = t[d] - c(e.x[d]);
            }
            return new I(s);
          }(e, l, t, r, i),
          c = function (e, t) {
            var n = e.x.length;
            for (var r = new Array(n), i = 0; i < n; i++) r[i] = [e.y[i] - t[i]];
            return new I(r);
          }(e, l),
          d = L(a.add(u.mmul(u.transpose())));
        return (t = (t = new I([t])).sub(d.mmul(u).mmul(c).mul(r).transpose())).to1DArray();
      }
      function B(e, t) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _n$maxIterations = n.maxIterations,
          i = _n$maxIterations === void 0 ? 100 : _n$maxIterations,
          _n$gradientDifference = n.gradientDifference,
          o = _n$gradientDifference === void 0 ? .1 : _n$gradientDifference,
          _n$damping = n.damping,
          a = _n$damping === void 0 ? 0 : _n$damping,
          _n$errorTolerance = n.errorTolerance,
          s = _n$errorTolerance === void 0 ? .01 : _n$errorTolerance,
          l = n.minValues,
          u = n.maxValues,
          c = n.initialValues;
        if (a <= 0) throw new Error("The damping option must be a positive number");
        if (!e.x || !e.y) throw new Error("The data parameter must have x and y elements");
        if (!Array.isArray(e.x) || e.x.length < 2 || !Array.isArray(e.y) || e.y.length < 2) throw new Error("The data parameter elements must be an array with more than 2 points");
        if (e.x.length !== e.y.length) throw new Error("The data parameter elements must have the same size");
        var d = c || new Array(t.length).fill(1);
        var h = d.length;
        if (u = u || new Array(h).fill(Number.MAX_SAFE_INTEGER), l = l || new Array(h).fill(Number.MIN_SAFE_INTEGER), u.length !== l.length) throw new Error("minValues and maxValues must be the same size");
        if (!Array.isArray(d)) throw new Error("initialValues must be an array");
        for (var f = r(e, d, t), p = f <= s, m = 0; m < i && !p; m++) {
          d = D(e, d, a, o, t);
          for (var _e15 = 0; _e15 < h; _e15++) d[_e15] = Math.min(Math.max(l[_e15], d[_e15]), u[_e15]);
          if (f = r(e, d, t), isNaN(f)) break;
          p = f <= s;
        }
        return {
          parameterValues: d,
          parameterError: f,
          iterations: m
        };
      }
    },
    "./node_modules/ngl/dist/ngl.js": function node_modulesNglDistNglJs(e, t, n) {
      (function (e, n) {
        !function (t) {
          "use strict";

          var r, i, o, a, s, l, u, c;
          "undefined" != typeof window && function () {
            window.console = window.console || {};
            for (var e, t, n = window.console, r = {}, i = function i() {}, o = "memory".split(","), a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();) n[e] || (n[e] = r);
            for (; t = a.pop();) n[t] || (n[t] = i);
          }(), void 0 === window.HTMLCanvasElement || window.HTMLCanvasElement.prototype.toBlob || Object.defineProperty(window.HTMLCanvasElement.prototype, "toBlob", {
            value: function value(e, t, n) {
              for (var r = window.atob(this.toDataURL(t, n).split(",")[1]), i = r.length, o = i >> 2, a = new Uint8Array(i), s = new Uint32Array(a.buffer, 0, o), l = 0, u = 0; l < o; l++) s[l] = r.charCodeAt(u++) | r.charCodeAt(u++) << 8 | r.charCodeAt(u++) << 16 | r.charCodeAt(u++) << 24;
              for (var c = 3 & i; c--;) a[u] = r.charCodeAt(u++);
              e(new window.Blob([a], {
                type: t || "image/png"
              }));
            }
          }), Math.cbrt = Math.cbrt || function (e) {
            var t = Math.pow(Math.abs(e), 1 / 3);
            return e < 0 ? -t : t;
          }, Math.sign || (Math.sign = function (e) {
            return 0 == (e = +e) || isNaN(e) ? Number(e) : 0 < e ? 1 : -1;
          }), Number.isInteger || (Number.isInteger = function (e) {
            return "number" == typeof e && isFinite(e) && -9007199254740992 < e && e < 9007199254740992 && Math.floor(e) === e;
          }), Number.isNaN || (Number.isNaN = function (e) {
            return e != e;
          }), Object.assign || Object.defineProperty(Object, "assign", {
            enumerable: !1,
            configurable: !0,
            writable: !0,
            value: function value(e) {
              var t = arguments;
              if (null == e) throw new TypeError("Cannot convert first argument to object");
              for (var n, r = Object(e), i = !1, o = 1; o < arguments.length; o++) {
                var a = t[o];
                if (null != a) {
                  for (var s = Object.keys(Object(a)), l = 0, u = s.length; l < u; l++) {
                    var c = s[l];
                    try {
                      var d = Object.getOwnPropertyDescriptor(a, c);
                      void 0 !== d && d.enumerable && (r[c] = a[c]);
                    } catch (e) {
                      i || (i = !0, n = e);
                    }
                  }
                  if (i) throw n;
                }
              }
              return r;
            }
          }), String.prototype.startsWith || (r = function () {
            var e;
            try {
              var t = {},
                n = Object.defineProperty;
              e = n(t, t, t) && n;
            } catch (e) {}
            return e;
          }(), i = {}.toString, o = function o(e) {
            if (null === this) throw TypeError();
            var t = String(this);
            if (e && "[object RegExp]" === i.call(e)) throw TypeError();
            var n = t.length,
              r = String(e),
              o = r.length,
              a = 1 < arguments.length ? arguments[1] : void 0,
              s = a ? Number(a) : 0;
            Number.isNaN(s) && (s = 0);
            var l = Math.min(Math.max(s, 0), n);
            if (n < o + l) return !1;
            for (var u = -1; ++u < o;) if (t.charCodeAt(l + u) !== r.charCodeAt(u)) return !1;
            return !0;
          }, r ? r(String.prototype, "startsWith", {
            value: o,
            configurable: !0,
            writable: !0
          }) : String.prototype.startsWith = o), String.prototype.endsWith || (String.prototype.endsWith = function (e, t) {
            var n = this.toString();
            ("number" != typeof t || !isFinite(t) || Math.floor(t) !== t || t > n.length) && (t = n.length), t -= e.length;
            var r = n.indexOf(e, t);
            return -1 !== r && r === t;
          }), String.prototype.repeat || (String.prototype.repeat = function (e) {
            if (null === this) throw new TypeError("can't convert " + this + " to object");
            var t = "" + this;
            if (e = +e, Number.isNaN(e) && (e = 0), e < 0) throw new RangeError("repeat count must be non-negative");
            if (e === 1 / 0) throw new RangeError("repeat count must be less than infinity");
            if (e = Math.floor(e), 0 === t.length || 0 === e) return "";
            if (t.length * e >= 1 << 28) throw new RangeError("repeat count must not overflow maximum string size");
            for (var n = ""; 1 == (1 & e) && (n += t), 0 != (e >>>= 1);) t += t;
            return n;
          }), String.prototype.includes || (String.prototype.includes = function (e, t) {
            return "number" != typeof t && (t = 0), !(t + e.length > this.length) && -1 !== this.indexOf(e, t);
          }), Array.prototype.includes || (Array.prototype.includes = function (e) {
            if (null == this) throw new TypeError("Array.prototype.includes called on null or undefined");
            var t = Object(this),
              n = parseInt(t.length, 10) || 0;
            if (0 === n) return !1;
            var r,
              i,
              o = parseInt(arguments[1], 10) || 0;
            for (0 <= o ? r = o : (r = n + o) < 0 && (r = 0); r < n;) {
              if (e === (i = t[r]) || Number.isNaN(e) && Number.isNaN(i)) return !0;
              r++;
            }
            return !1;
          }), Array.from || (Array.from = (a = Object.prototype.toString, s = function s(e) {
            return "function" == typeof e || "[object Function]" === a.call(e);
          }, l = Math.pow(2, 53) - 1, u = function u(e) {
            var t,
              n = (t = Number(e), isNaN(t) ? 0 : 0 !== t && isFinite(t) ? (0 < t ? 1 : -1) * Math.floor(Math.abs(t)) : t);
            return Math.min(Math.max(n, 0), l);
          }, function (e) {
            var t = Object(e);
            if (null == e) throw new TypeError("Array.from requires an array-like object - not null or undefined");
            var n,
              r = 1 < arguments.length ? arguments[1] : void 0;
            if (void 0 !== r) {
              if (!s(r)) throw new TypeError("Array.from: when provided, the second argument must be a function");
              2 < arguments.length && (n = arguments[2]);
            }
            for (var i, o = u(t.length), a = s(this) ? Object(new this(o)) : new Array(o), l = 0; l < o;) i = t[l], a[l] = r ? void 0 === n ? r(i, l) : r.call(n, i, l) : i, l += 1;
            return a.length = o, a;
          })), "undefined" != typeof window && function () {
            for (var e = 0, t = ["ms", "moz", "webkit", "o"], n = 0; n < t.length && !window.requestAnimationFrame; ++n) window.requestAnimationFrame = window[t[n] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[t[n] + "CancelAnimationFrame"] || window[t[n] + "CancelRequestAnimationFrame"];
            window.requestAnimationFrame || (window.requestAnimationFrame = function (t) {
              var n = new Date().getTime(),
                r = Math.max(0, 16 - (n - e)),
                i = window.setTimeout(function () {
                  t(n + r);
                }, r);
              return e = n + r, i;
            }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (e) {
              clearTimeout(e);
            });
          }(), void 0 === Function.prototype.name && void 0 !== Object.defineProperty && Object.defineProperty(Function.prototype, "name", {
            get: function get() {
              return this.toString().match(/^\s*function\s*(\S*)\s*\(/)[1];
            }
          }), "undefined" != typeof window && (void 0 === window.performance && (self.performance = {}), void 0 === window.performance.now && (c = Date.now(), window.performance.now = function () {
            return Date.now() - c;
          })), void 0 !== Object.defineProperty && (void 0 === Number.MAX_SAFE_INTEGER && Object.defineProperty(Number, "MAX_SAFE_INTEGER", {
            enumerable: !1,
            configurable: !1,
            writable: !1,
            value: Math.pow(2, 53) - 1
          }), void 0 === Number.MIN_SAFE_INTEGER && Object.defineProperty(Number, "MIN_SAFE_INTEGER", {
            enumerable: !1,
            configurable: !1,
            writable: !1,
            value: -(Math.pow(2, 53) - 1)
          }));
          var d = setTimeout;
          function h() {}
          function f(e) {
            if (!(this instanceof f)) throw new TypeError("Promises must be constructed via new");
            if ("function" != typeof e) throw new TypeError("not a function");
            this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], b(e, this);
          }
          function p(e, t) {
            for (; 3 === e._state;) e = e._value;
            0 !== e._state ? (e._handled = !0, f._immediateFn(function () {
              var n = 1 === e._state ? t.onFulfilled : t.onRejected;
              if (null !== n) {
                var r;
                try {
                  r = n(e._value);
                } catch (n) {
                  return void g(t.promise, n);
                }
                m(t.promise, r);
              } else (1 === e._state ? m : g)(t.promise, e._value);
            })) : e._deferreds.push(t);
          }
          function m(e, t) {
            try {
              if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
              if (t && ("object" == typeof t || "function" == typeof t)) {
                var n = t.then;
                if (t instanceof f) return e._state = 3, e._value = t, void v(e);
                if ("function" == typeof n) return void b((r = n, i = t, function () {
                  r.apply(i, arguments);
                }), e);
              }
              e._state = 1, e._value = t, v(e);
            } catch (t) {
              g(e, t);
            }
            var r, i;
          }
          function g(e, t) {
            e._state = 2, e._value = t, v(e);
          }
          function v(e) {
            2 === e._state && 0 === e._deferreds.length && f._immediateFn(function () {
              e._handled || f._unhandledRejectionFn(e._value);
            });
            for (var t = 0, n = e._deferreds.length; t < n; t++) p(e, e._deferreds[t]);
            e._deferreds = null;
          }
          function y(e, t, n) {
            this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
          }
          function b(e, t) {
            var n = !1;
            try {
              e(function (e) {
                n || (n = !0, m(t, e));
              }, function (e) {
                n || (n = !0, g(t, e));
              });
            } catch (e) {
              if (n) return;
              n = !0, g(t, e);
            }
          }
          function _() {}
          f.prototype.catch = function (e) {
            return this.then(null, e);
          }, f.prototype.then = function (e, t) {
            var n = new this.constructor(h);
            return p(this, new y(e, t, n)), n;
          }, f.prototype.finally = function (e) {
            var t = this.constructor;
            return this.then(function (n) {
              return t.resolve(e()).then(function () {
                return n;
              });
            }, function (n) {
              return t.resolve(e()).then(function () {
                return t.reject(n);
              });
            });
          }, f.all = function (e) {
            return new f(function (t, n) {
              if (!e || void 0 === e.length) throw new TypeError("Promise.all accepts an array");
              var r = Array.prototype.slice.call(e);
              if (0 === r.length) return t([]);
              var i = r.length;
              function o(e, a) {
                try {
                  if (a && ("object" == typeof a || "function" == typeof a)) {
                    var s = a.then;
                    if ("function" == typeof s) return void s.call(a, function (t) {
                      o(e, t);
                    }, n);
                  }
                  r[e] = a, 0 == --i && t(r);
                } catch (a) {
                  n(a);
                }
              }
              for (var a = 0; a < r.length; a++) o(a, r[a]);
            });
          }, f.resolve = function (e) {
            return e && "object" == typeof e && e.constructor === f ? e : new f(function (t) {
              t(e);
            });
          }, f.reject = function (e) {
            return new f(function (t, n) {
              n(e);
            });
          }, f.race = function (e) {
            return new f(function (t, n) {
              for (var r = 0, i = e.length; r < i; r++) e[r].then(t, n);
            });
          }, f._immediateFn = "function" == typeof e && function (t) {
            e(t);
          } || function (e) {
            d(e, 0);
          }, f._unhandledRejectionFn = function (e) {
            "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
          }, void 0 === Number.EPSILON && (Number.EPSILON = Math.pow(2, -52)), void 0 === Number.isInteger && (Number.isInteger = function (e) {
            return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
          }), void 0 === Math.sign && (Math.sign = function (e) {
            return e < 0 ? -1 : 0 < e ? 1 : +e;
          }), "name" in Function.prototype == 0 && Object.defineProperty(Function.prototype, "name", {
            get: function get() {
              return this.toString().match(/^\s*function\s*([^\(\s]*)/)[1];
            }
          }), void 0 === Object.assign && (Object.assign = function (e) {
            var t = arguments;
            if (null == e) throw new TypeError("Cannot convert undefined or null to object");
            for (var n = Object(e), r = 1; r < arguments.length; r++) {
              var i = t[r];
              if (null != i) for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
            }
            return n;
          }), Object.assign(_.prototype, {
            addEventListener: function addEventListener(e, t) {
              void 0 === this._listeners && (this._listeners = {});
              var n = this._listeners;
              void 0 === n[e] && (n[e] = []), -1 === n[e].indexOf(t) && n[e].push(t);
            },
            hasEventListener: function hasEventListener(e, t) {
              if (void 0 === this._listeners) return !1;
              var n = this._listeners;
              return void 0 !== n[e] && -1 !== n[e].indexOf(t);
            },
            removeEventListener: function removeEventListener(e, t) {
              if (void 0 !== this._listeners) {
                var n = this._listeners[e];
                if (void 0 !== n) {
                  var r = n.indexOf(t);
                  -1 !== r && n.splice(r, 1);
                }
              }
            },
            dispatchEvent: function dispatchEvent(e) {
              if (void 0 !== this._listeners) {
                var t = this._listeners[e.type];
                if (void 0 !== t) {
                  e.target = this;
                  for (var n = t.slice(0), r = 0, i = n.length; r < i; r++) n[r].call(this, e);
                }
              }
            }
          });
          var x,
            w,
            S,
            A,
            E,
            T,
            M,
            C,
            k,
            P,
            O,
            R,
            I,
            j,
            N,
            L,
            D,
            B,
            F,
            z,
            U,
            G,
            V = 1e3,
            H = 1001,
            q = 1002,
            W = 1003,
            $ = 1006,
            X = 1009,
            Y = 1015,
            K = 1022,
            Z = 1023,
            Q = 1026,
            J = 1027,
            ee = 2400,
            te = 2401,
            ne = {
              DEG2RAD: Math.PI / 180,
              RAD2DEG: 180 / Math.PI,
              generateUUID: function () {
                for (var e = [], t = 0; t < 256; t++) e[t] = (t < 16 ? "0" : "") + t.toString(16);
                return function () {
                  var t = 4294967295 * Math.random() | 0,
                    n = 4294967295 * Math.random() | 0,
                    r = 4294967295 * Math.random() | 0,
                    i = 4294967295 * Math.random() | 0;
                  return (e[255 & t] + e[t >> 8 & 255] + e[t >> 16 & 255] + e[t >> 24 & 255] + "-" + e[255 & n] + e[n >> 8 & 255] + "-" + e[n >> 16 & 15 | 64] + e[n >> 24 & 255] + "-" + e[63 & r | 128] + e[r >> 8 & 255] + "-" + e[r >> 16 & 255] + e[r >> 24 & 255] + e[255 & i] + e[i >> 8 & 255] + e[i >> 16 & 255] + e[i >> 24 & 255]).toUpperCase();
                };
              }(),
              clamp: function clamp(e, t, n) {
                return Math.max(t, Math.min(n, e));
              },
              euclideanModulo: function euclideanModulo(e, t) {
                return (e % t + t) % t;
              },
              mapLinear: function mapLinear(e, t, n, r, i) {
                return r + (e - t) * (i - r) / (n - t);
              },
              lerp: function lerp(e, t, n) {
                return (1 - n) * e + n * t;
              },
              smoothstep: function smoothstep(e, t, n) {
                return e <= t ? 0 : n <= e ? 1 : (e = (e - t) / (n - t)) * e * (3 - 2 * e);
              },
              smootherstep: function smootherstep(e, t, n) {
                return e <= t ? 0 : n <= e ? 1 : (e = (e - t) / (n - t)) * e * e * (e * (6 * e - 15) + 10);
              },
              randInt: function randInt(e, t) {
                return e + Math.floor(Math.random() * (t - e + 1));
              },
              randFloat: function randFloat(e, t) {
                return e + Math.random() * (t - e);
              },
              randFloatSpread: function randFloatSpread(e) {
                return e * (.5 - Math.random());
              },
              degToRad: function degToRad(e) {
                return e * ne.DEG2RAD;
              },
              radToDeg: function radToDeg(e) {
                return e * ne.RAD2DEG;
              },
              isPowerOfTwo: function isPowerOfTwo(e) {
                return 0 == (e & e - 1) && 0 !== e;
              },
              ceilPowerOfTwo: function ceilPowerOfTwo(e) {
                return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
              },
              floorPowerOfTwo: function floorPowerOfTwo(e) {
                return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
              }
            };
          function re(e, t) {
            this.x = e || 0, this.y = t || 0;
          }
          function ie() {
            this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], 0 < arguments.length && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
          }
          function oe(e, t, n, r) {
            this._x = e || 0, this._y = t || 0, this._z = n || 0, this._w = void 0 !== r ? r : 1;
          }
          function ae(e, t, n) {
            this.x = e || 0, this.y = t || 0, this.z = n || 0;
          }
          function se() {
            this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], 0 < arguments.length && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
          }
          Object.defineProperties(re.prototype, {
            width: {
              get: function get() {
                return this.x;
              },
              set: function set(e) {
                this.x = e;
              }
            },
            height: {
              get: function get() {
                return this.y;
              },
              set: function set(e) {
                this.y = e;
              }
            }
          }), Object.assign(re.prototype, {
            isVector2: !0,
            set: function set(e, t) {
              return this.x = e, this.y = t, this;
            },
            setScalar: function setScalar(e) {
              return this.x = e, this.y = e, this;
            },
            setX: function setX(e) {
              return this.x = e, this;
            },
            setY: function setY(e) {
              return this.y = e, this;
            },
            setComponent: function setComponent(e, t) {
              switch (e) {
                case 0:
                  this.x = t;
                  break;
                case 1:
                  this.y = t;
                  break;
                default:
                  throw new Error("index is out of range: " + e);
              }
              return this;
            },
            getComponent: function getComponent(e) {
              switch (e) {
                case 0:
                  return this.x;
                case 1:
                  return this.y;
                default:
                  throw new Error("index is out of range: " + e);
              }
            },
            clone: function clone() {
              return new this.constructor(this.x, this.y);
            },
            copy: function copy(e) {
              return this.x = e.x, this.y = e.y, this;
            },
            add: function add(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this);
            },
            addScalar: function addScalar(e) {
              return this.x += e, this.y += e, this;
            },
            addVectors: function addVectors(e, t) {
              return this.x = e.x + t.x, this.y = e.y + t.y, this;
            },
            addScaledVector: function addScaledVector(e, t) {
              return this.x += e.x * t, this.y += e.y * t, this;
            },
            sub: function sub(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this);
            },
            subScalar: function subScalar(e) {
              return this.x -= e, this.y -= e, this;
            },
            subVectors: function subVectors(e, t) {
              return this.x = e.x - t.x, this.y = e.y - t.y, this;
            },
            multiply: function multiply(e) {
              return this.x *= e.x, this.y *= e.y, this;
            },
            multiplyScalar: function multiplyScalar(e) {
              return this.x *= e, this.y *= e, this;
            },
            divide: function divide(e) {
              return this.x /= e.x, this.y /= e.y, this;
            },
            divideScalar: function divideScalar(e) {
              return this.multiplyScalar(1 / e);
            },
            applyMatrix3: function applyMatrix3(e) {
              var t = this.x,
                n = this.y,
                r = e.elements;
              return this.x = r[0] * t + r[3] * n + r[6], this.y = r[1] * t + r[4] * n + r[7], this;
            },
            min: function min(e) {
              return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
            },
            max: function max(e) {
              return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
            },
            clamp: function clamp(e, t) {
              return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this;
            },
            clampScalar: (x = new re(), w = new re(), function (e, t) {
              return x.set(e, e), w.set(t, t), this.clamp(x, w);
            }),
            clampLength: function clampLength(e, t) {
              var n = this.length();
              return this.divideScalar(n || 1).multiplyScalar(Math.max(e, Math.min(t, n)));
            },
            floor: function floor() {
              return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            },
            ceil: function ceil() {
              return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            },
            round: function round() {
              return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            roundToZero: function roundToZero() {
              return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
            },
            negate: function negate() {
              return this.x = -this.x, this.y = -this.y, this;
            },
            dot: function dot(e) {
              return this.x * e.x + this.y * e.y;
            },
            cross: function cross(e) {
              return this.x * e.y - this.y * e.x;
            },
            lengthSq: function lengthSq() {
              return this.x * this.x + this.y * this.y;
            },
            length: function length() {
              return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            manhattanLength: function manhattanLength() {
              return Math.abs(this.x) + Math.abs(this.y);
            },
            normalize: function normalize() {
              return this.divideScalar(this.length() || 1);
            },
            angle: function angle() {
              var e = Math.atan2(this.y, this.x);
              return e < 0 && (e += 2 * Math.PI), e;
            },
            distanceTo: function distanceTo(e) {
              return Math.sqrt(this.distanceToSquared(e));
            },
            distanceToSquared: function distanceToSquared(e) {
              var t = this.x - e.x,
                n = this.y - e.y;
              return t * t + n * n;
            },
            manhattanDistanceTo: function manhattanDistanceTo(e) {
              return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
            },
            setLength: function setLength(e) {
              return this.normalize().multiplyScalar(e);
            },
            lerp: function lerp(e, t) {
              return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
            },
            lerpVectors: function lerpVectors(e, t, n) {
              return this.subVectors(t, e).multiplyScalar(n).add(e);
            },
            equals: function equals(e) {
              return e.x === this.x && e.y === this.y;
            },
            fromArray: function fromArray(e, t) {
              return void 0 === t && (t = 0), this.x = e[t], this.y = e[t + 1], this;
            },
            toArray: function toArray(e, t) {
              return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.x, e[t + 1] = this.y, e;
            },
            fromBufferAttribute: function fromBufferAttribute(e, t, n) {
              return void 0 !== n && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this;
            },
            rotateAround: function rotateAround(e, t) {
              var n = Math.cos(t),
                r = Math.sin(t),
                i = this.x - e.x,
                o = this.y - e.y;
              return this.x = i * n - o * r + e.x, this.y = i * r + o * n + e.y, this;
            }
          }), Object.assign(ie.prototype, {
            isMatrix4: !0,
            set: function set(e, t, n, r, i, o, a, s, l, u, c, d, h, f, p, m) {
              var g = this.elements;
              return g[0] = e, g[4] = t, g[8] = n, g[12] = r, g[1] = i, g[5] = o, g[9] = a, g[13] = s, g[2] = l, g[6] = u, g[10] = c, g[14] = d, g[3] = h, g[7] = f, g[11] = p, g[15] = m, this;
            },
            identity: function identity() {
              return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            },
            clone: function clone() {
              return new ie().fromArray(this.elements);
            },
            copy: function copy(e) {
              var t = this.elements,
                n = e.elements;
              return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
            },
            copyPosition: function copyPosition(e) {
              var t = this.elements,
                n = e.elements;
              return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
            },
            extractBasis: function extractBasis(e, t, n) {
              return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
            },
            makeBasis: function makeBasis(e, t, n) {
              return this.set(e.x, t.x, n.x, 0, e.y, t.y, n.y, 0, e.z, t.z, n.z, 0, 0, 0, 0, 1), this;
            },
            extractRotation: (O = new ae(), function (e) {
              var t = this.elements,
                n = e.elements,
                r = 1 / O.setFromMatrixColumn(e, 0).length(),
                i = 1 / O.setFromMatrixColumn(e, 1).length(),
                o = 1 / O.setFromMatrixColumn(e, 2).length();
              return t[0] = n[0] * r, t[1] = n[1] * r, t[2] = n[2] * r, t[3] = 0, t[4] = n[4] * i, t[5] = n[5] * i, t[6] = n[6] * i, t[7] = 0, t[8] = n[8] * o, t[9] = n[9] * o, t[10] = n[10] * o, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }),
            makeRotationFromEuler: function makeRotationFromEuler(e) {
              e && e.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
              var t = this.elements,
                n = e.x,
                r = e.y,
                i = e.z,
                o = Math.cos(n),
                a = Math.sin(n),
                s = Math.cos(r),
                l = Math.sin(r),
                u = Math.cos(i),
                c = Math.sin(i);
              if ("XYZ" === e.order) {
                var d = o * u,
                  h = o * c,
                  f = a * u,
                  p = a * c;
                t[0] = s * u, t[4] = -s * c, t[8] = l, t[1] = h + f * l, t[5] = d - p * l, t[9] = -a * s, t[2] = p - d * l, t[6] = f + h * l, t[10] = o * s;
              } else if ("YXZ" === e.order) {
                var m = s * u,
                  g = s * c,
                  v = l * u,
                  y = l * c;
                t[0] = m + y * a, t[4] = v * a - g, t[8] = o * l, t[1] = o * c, t[5] = o * u, t[9] = -a, t[2] = g * a - v, t[6] = y + m * a, t[10] = o * s;
              } else if ("ZXY" === e.order) m = s * u, g = s * c, v = l * u, y = l * c, t[0] = m - y * a, t[4] = -o * c, t[8] = v + g * a, t[1] = g + v * a, t[5] = o * u, t[9] = y - m * a, t[2] = -o * l, t[6] = a, t[10] = o * s;else if ("ZYX" === e.order) d = o * u, h = o * c, f = a * u, p = a * c, t[0] = s * u, t[4] = f * l - h, t[8] = d * l + p, t[1] = s * c, t[5] = p * l + d, t[9] = h * l - f, t[2] = -l, t[6] = a * s, t[10] = o * s;else if ("YZX" === e.order) {
                var b = o * s,
                  _ = o * l,
                  x = a * s,
                  w = a * l;
                t[0] = s * u, t[4] = w - b * c, t[8] = x * c + _, t[1] = c, t[5] = o * u, t[9] = -a * u, t[2] = -l * u, t[6] = _ * c + x, t[10] = b - w * c;
              } else "XZY" === e.order && (b = o * s, _ = o * l, x = a * s, w = a * l, t[0] = s * u, t[4] = -c, t[8] = l * u, t[1] = b * c + w, t[5] = o * u, t[9] = _ * c - x, t[2] = x * c - _, t[6] = a * u, t[10] = w * c + b);
              return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            },
            makeRotationFromQuaternion: (k = new ae(0, 0, 0), P = new ae(1, 1, 1), function (e) {
              return this.compose(k, e, P);
            }),
            lookAt: (T = new ae(), M = new ae(), C = new ae(), function (e, t, n) {
              var r = this.elements;
              return C.subVectors(e, t), 0 === C.lengthSq() && (C.z = 1), C.normalize(), T.crossVectors(n, C), 0 === T.lengthSq() && (1 === Math.abs(n.z) ? C.x += 1e-4 : C.z += 1e-4, C.normalize(), T.crossVectors(n, C)), T.normalize(), M.crossVectors(C, T), r[0] = T.x, r[4] = M.x, r[8] = C.x, r[1] = T.y, r[5] = M.y, r[9] = C.y, r[2] = T.z, r[6] = M.z, r[10] = C.z, this;
            }),
            multiply: function multiply(e, t) {
              return void 0 !== t ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(e, t)) : this.multiplyMatrices(this, e);
            },
            premultiply: function premultiply(e) {
              return this.multiplyMatrices(e, this);
            },
            multiplyMatrices: function multiplyMatrices(e, t) {
              var n = e.elements,
                r = t.elements,
                i = this.elements,
                o = n[0],
                a = n[4],
                s = n[8],
                l = n[12],
                u = n[1],
                c = n[5],
                d = n[9],
                h = n[13],
                f = n[2],
                p = n[6],
                m = n[10],
                g = n[14],
                v = n[3],
                y = n[7],
                b = n[11],
                _ = n[15],
                x = r[0],
                w = r[4],
                S = r[8],
                A = r[12],
                E = r[1],
                T = r[5],
                M = r[9],
                C = r[13],
                k = r[2],
                P = r[6],
                O = r[10],
                R = r[14],
                I = r[3],
                j = r[7],
                N = r[11],
                L = r[15];
              return i[0] = o * x + a * E + s * k + l * I, i[4] = o * w + a * T + s * P + l * j, i[8] = o * S + a * M + s * O + l * N, i[12] = o * A + a * C + s * R + l * L, i[1] = u * x + c * E + d * k + h * I, i[5] = u * w + c * T + d * P + h * j, i[9] = u * S + c * M + d * O + h * N, i[13] = u * A + c * C + d * R + h * L, i[2] = f * x + p * E + m * k + g * I, i[6] = f * w + p * T + m * P + g * j, i[10] = f * S + p * M + m * O + g * N, i[14] = f * A + p * C + m * R + g * L, i[3] = v * x + y * E + b * k + _ * I, i[7] = v * w + y * T + b * P + _ * j, i[11] = v * S + y * M + b * O + _ * N, i[15] = v * A + y * C + b * R + _ * L, this;
            },
            multiplyScalar: function multiplyScalar(e) {
              var t = this.elements;
              return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
            },
            applyToBufferAttribute: (E = new ae(), function (e) {
              for (var t = 0, n = e.count; t < n; t++) E.x = e.getX(t), E.y = e.getY(t), E.z = e.getZ(t), E.applyMatrix4(this), e.setXYZ(t, E.x, E.y, E.z);
              return e;
            }),
            determinant: function determinant() {
              var e = this.elements,
                t = e[0],
                n = e[4],
                r = e[8],
                i = e[12],
                o = e[1],
                a = e[5],
                s = e[9],
                l = e[13],
                u = e[2],
                c = e[6],
                d = e[10],
                h = e[14];
              return e[3] * (+i * s * c - r * l * c - i * a * d + n * l * d + r * a * h - n * s * h) + e[7] * (+t * s * h - t * l * d + i * o * d - r * o * h + r * l * u - i * s * u) + e[11] * (+t * l * c - t * a * h - i * o * c + n * o * h + i * a * u - n * l * u) + e[15] * (-r * a * u - t * s * c + t * a * d + r * o * c - n * o * d + n * s * u);
            },
            transpose: function transpose() {
              var e,
                t = this.elements;
              return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
            },
            setPosition: function setPosition(e) {
              var t = this.elements;
              return t[12] = e.x, t[13] = e.y, t[14] = e.z, this;
            },
            getInverse: function getInverse(e, t) {
              var n = this.elements,
                r = e.elements,
                i = r[0],
                o = r[1],
                a = r[2],
                s = r[3],
                l = r[4],
                u = r[5],
                c = r[6],
                d = r[7],
                h = r[8],
                f = r[9],
                p = r[10],
                m = r[11],
                g = r[12],
                v = r[13],
                y = r[14],
                b = r[15],
                _ = f * y * d - v * p * d + v * c * m - u * y * m - f * c * b + u * p * b,
                x = g * p * d - h * y * d - g * c * m + l * y * m + h * c * b - l * p * b,
                w = h * v * d - g * f * d + g * u * m - l * v * m - h * u * b + l * f * b,
                S = g * f * c - h * v * c - g * u * p + l * v * p + h * u * y - l * f * y,
                A = i * _ + o * x + a * w + s * S;
              if (0 === A) {
                var E = "THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0";
                if (!0 === t) throw new Error(E);
                return console.warn(E), this.identity();
              }
              var T = 1 / A;
              return n[0] = _ * T, n[1] = (v * p * s - f * y * s - v * a * m + o * y * m + f * a * b - o * p * b) * T, n[2] = (u * y * s - v * c * s + v * a * d - o * y * d - u * a * b + o * c * b) * T, n[3] = (f * c * s - u * p * s - f * a * d + o * p * d + u * a * m - o * c * m) * T, n[4] = x * T, n[5] = (h * y * s - g * p * s + g * a * m - i * y * m - h * a * b + i * p * b) * T, n[6] = (g * c * s - l * y * s - g * a * d + i * y * d + l * a * b - i * c * b) * T, n[7] = (l * p * s - h * c * s + h * a * d - i * p * d - l * a * m + i * c * m) * T, n[8] = w * T, n[9] = (g * f * s - h * v * s - g * o * m + i * v * m + h * o * b - i * f * b) * T, n[10] = (l * v * s - g * u * s + g * o * d - i * v * d - l * o * b + i * u * b) * T, n[11] = (h * u * s - l * f * s - h * o * d + i * f * d + l * o * m - i * u * m) * T, n[12] = S * T, n[13] = (h * v * a - g * f * a + g * o * p - i * v * p - h * o * y + i * f * y) * T, n[14] = (g * u * a - l * v * a - g * o * c + i * v * c + l * o * y - i * u * y) * T, n[15] = (l * f * a - h * u * a + h * o * c - i * f * c - l * o * p + i * u * p) * T, this;
            },
            scale: function scale(e) {
              var t = this.elements,
                n = e.x,
                r = e.y,
                i = e.z;
              return t[0] *= n, t[4] *= r, t[8] *= i, t[1] *= n, t[5] *= r, t[9] *= i, t[2] *= n, t[6] *= r, t[10] *= i, t[3] *= n, t[7] *= r, t[11] *= i, this;
            },
            getMaxScaleOnAxis: function getMaxScaleOnAxis() {
              var e = this.elements,
                t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
                n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
                r = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
              return Math.sqrt(Math.max(t, n, r));
            },
            makeTranslation: function makeTranslation(e, t, n) {
              return this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
            },
            makeRotationX: function makeRotationX(e) {
              var t = Math.cos(e),
                n = Math.sin(e);
              return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
            },
            makeRotationY: function makeRotationY(e) {
              var t = Math.cos(e),
                n = Math.sin(e);
              return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
            },
            makeRotationZ: function makeRotationZ(e) {
              var t = Math.cos(e),
                n = Math.sin(e);
              return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            },
            makeRotationAxis: function makeRotationAxis(e, t) {
              var n = Math.cos(t),
                r = Math.sin(t),
                i = 1 - n,
                o = e.x,
                a = e.y,
                s = e.z,
                l = i * o,
                u = i * a;
              return this.set(l * o + n, l * a - r * s, l * s + r * a, 0, l * a + r * s, u * a + n, u * s - r * o, 0, l * s - r * a, u * s + r * o, i * s * s + n, 0, 0, 0, 0, 1), this;
            },
            makeScale: function makeScale(e, t, n) {
              return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
            },
            makeShear: function makeShear(e, t, n) {
              return this.set(1, t, n, 0, e, 1, n, 0, e, t, 1, 0, 0, 0, 0, 1), this;
            },
            compose: function compose(e, t, n) {
              var r = this.elements,
                i = t._x,
                o = t._y,
                a = t._z,
                s = t._w,
                l = i + i,
                u = o + o,
                c = a + a,
                d = i * l,
                h = i * u,
                f = i * c,
                p = o * u,
                m = o * c,
                g = a * c,
                v = s * l,
                y = s * u,
                b = s * c,
                _ = n.x,
                x = n.y,
                w = n.z;
              return r[0] = (1 - (p + g)) * _, r[1] = (h + b) * _, r[2] = (f - y) * _, r[3] = 0, r[4] = (h - b) * x, r[5] = (1 - (d + g)) * x, r[6] = (m + v) * x, r[7] = 0, r[8] = (f + y) * w, r[9] = (m - v) * w, r[10] = (1 - (d + p)) * w, r[11] = 0, r[12] = e.x, r[13] = e.y, r[14] = e.z, r[15] = 1, this;
            },
            decompose: (S = new ae(), A = new ie(), function (e, t, n) {
              var r = this.elements,
                i = S.set(r[0], r[1], r[2]).length(),
                o = S.set(r[4], r[5], r[6]).length(),
                a = S.set(r[8], r[9], r[10]).length();
              this.determinant() < 0 && (i = -i), e.x = r[12], e.y = r[13], e.z = r[14], A.copy(this);
              var s = 1 / i,
                l = 1 / o,
                u = 1 / a;
              return A.elements[0] *= s, A.elements[1] *= s, A.elements[2] *= s, A.elements[4] *= l, A.elements[5] *= l, A.elements[6] *= l, A.elements[8] *= u, A.elements[9] *= u, A.elements[10] *= u, t.setFromRotationMatrix(A), n.x = i, n.y = o, n.z = a, this;
            }),
            makePerspective: function makePerspective(e, t, n, r, i, o) {
              void 0 === o && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
              var a = this.elements,
                s = 2 * i / (t - e),
                l = 2 * i / (n - r),
                u = (t + e) / (t - e),
                c = (n + r) / (n - r),
                d = -(o + i) / (o - i),
                h = -2 * o * i / (o - i);
              return a[0] = s, a[4] = 0, a[8] = u, a[12] = 0, a[1] = 0, a[5] = l, a[9] = c, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = d, a[14] = h, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
            },
            makeOrthographic: function makeOrthographic(e, t, n, r, i, o) {
              var a = this.elements,
                s = 1 / (t - e),
                l = 1 / (n - r),
                u = 1 / (o - i),
                c = (t + e) * s,
                d = (n + r) * l,
                h = (o + i) * u;
              return a[0] = 2 * s, a[4] = 0, a[8] = 0, a[12] = -c, a[1] = 0, a[5] = 2 * l, a[9] = 0, a[13] = -d, a[2] = 0, a[6] = 0, a[10] = -2 * u, a[14] = -h, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
            },
            equals: function equals(e) {
              for (var t = this.elements, n = e.elements, r = 0; r < 16; r++) if (t[r] !== n[r]) return !1;
              return !0;
            },
            fromArray: function fromArray(e, t) {
              void 0 === t && (t = 0);
              for (var n = 0; n < 16; n++) this.elements[n] = e[n + t];
              return this;
            },
            toArray: function toArray(e, t) {
              void 0 === e && (e = []), void 0 === t && (t = 0);
              var n = this.elements;
              return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e[t + 9] = n[9], e[t + 10] = n[10], e[t + 11] = n[11], e[t + 12] = n[12], e[t + 13] = n[13], e[t + 14] = n[14], e[t + 15] = n[15], e;
            }
          }), Object.assign(oe, {
            slerp: function slerp(e, t, n, r) {
              return n.copy(e).slerp(t, r);
            },
            slerpFlat: function slerpFlat(e, t, n, r, i, o, a) {
              var s = n[r + 0],
                l = n[r + 1],
                u = n[r + 2],
                c = n[r + 3],
                d = i[o + 0],
                h = i[o + 1],
                f = i[o + 2],
                p = i[o + 3];
              if (c !== p || s !== d || l !== h || u !== f) {
                var m = 1 - a,
                  g = s * d + l * h + u * f + c * p,
                  v = 0 <= g ? 1 : -1,
                  y = 1 - g * g;
                if (y > Number.EPSILON) {
                  var b = Math.sqrt(y),
                    _ = Math.atan2(b, g * v);
                  m = Math.sin(m * _) / b, a = Math.sin(a * _) / b;
                }
                var x = a * v;
                if (s = s * m + d * x, l = l * m + h * x, u = u * m + f * x, c = c * m + p * x, m === 1 - a) {
                  var w = 1 / Math.sqrt(s * s + l * l + u * u + c * c);
                  s *= w, l *= w, u *= w, c *= w;
                }
              }
              e[t] = s, e[t + 1] = l, e[t + 2] = u, e[t + 3] = c;
            }
          }), Object.defineProperties(oe.prototype, {
            x: {
              get: function get() {
                return this._x;
              },
              set: function set(e) {
                this._x = e, this.onChangeCallback();
              }
            },
            y: {
              get: function get() {
                return this._y;
              },
              set: function set(e) {
                this._y = e, this.onChangeCallback();
              }
            },
            z: {
              get: function get() {
                return this._z;
              },
              set: function set(e) {
                this._z = e, this.onChangeCallback();
              }
            },
            w: {
              get: function get() {
                return this._w;
              },
              set: function set(e) {
                this._w = e, this.onChangeCallback();
              }
            }
          }), Object.assign(oe.prototype, {
            set: function set(e, t, n, r) {
              return this._x = e, this._y = t, this._z = n, this._w = r, this.onChangeCallback(), this;
            },
            clone: function clone() {
              return new this.constructor(this._x, this._y, this._z, this._w);
            },
            copy: function copy(e) {
              return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this.onChangeCallback(), this;
            },
            setFromEuler: function setFromEuler(e, t) {
              if (!e || !e.isEuler) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
              var n = e._x,
                r = e._y,
                i = e._z,
                o = e.order,
                a = Math.cos,
                s = Math.sin,
                l = a(n / 2),
                u = a(r / 2),
                c = a(i / 2),
                d = s(n / 2),
                h = s(r / 2),
                f = s(i / 2);
              return "XYZ" === o ? (this._x = d * u * c + l * h * f, this._y = l * h * c - d * u * f, this._z = l * u * f + d * h * c, this._w = l * u * c - d * h * f) : "YXZ" === o ? (this._x = d * u * c + l * h * f, this._y = l * h * c - d * u * f, this._z = l * u * f - d * h * c, this._w = l * u * c + d * h * f) : "ZXY" === o ? (this._x = d * u * c - l * h * f, this._y = l * h * c + d * u * f, this._z = l * u * f + d * h * c, this._w = l * u * c - d * h * f) : "ZYX" === o ? (this._x = d * u * c - l * h * f, this._y = l * h * c + d * u * f, this._z = l * u * f - d * h * c, this._w = l * u * c + d * h * f) : "YZX" === o ? (this._x = d * u * c + l * h * f, this._y = l * h * c + d * u * f, this._z = l * u * f - d * h * c, this._w = l * u * c - d * h * f) : "XZY" === o && (this._x = d * u * c - l * h * f, this._y = l * h * c - d * u * f, this._z = l * u * f + d * h * c, this._w = l * u * c + d * h * f), !1 !== t && this.onChangeCallback(), this;
            },
            setFromAxisAngle: function setFromAxisAngle(e, t) {
              var n = t / 2,
                r = Math.sin(n);
              return this._x = e.x * r, this._y = e.y * r, this._z = e.z * r, this._w = Math.cos(n), this.onChangeCallback(), this;
            },
            setFromRotationMatrix: function setFromRotationMatrix(e) {
              var t,
                n = e.elements,
                r = n[0],
                i = n[4],
                o = n[8],
                a = n[1],
                s = n[5],
                l = n[9],
                u = n[2],
                c = n[6],
                d = n[10],
                h = r + s + d;
              return 0 < h ? (t = .5 / Math.sqrt(h + 1), this._w = .25 / t, this._x = (c - l) * t, this._y = (o - u) * t, this._z = (a - i) * t) : s < r && d < r ? (t = 2 * Math.sqrt(1 + r - s - d), this._w = (c - l) / t, this._x = .25 * t, this._y = (i + a) / t, this._z = (o + u) / t) : d < s ? (t = 2 * Math.sqrt(1 + s - r - d), this._w = (o - u) / t, this._x = (i + a) / t, this._y = .25 * t, this._z = (l + c) / t) : (t = 2 * Math.sqrt(1 + d - r - s), this._w = (a - i) / t, this._x = (o + u) / t, this._y = (l + c) / t, this._z = .25 * t), this.onChangeCallback(), this;
            },
            setFromUnitVectors: (I = new ae(), function (e, t) {
              return void 0 === I && (I = new ae()), (R = e.dot(t) + 1) < 1e-6 ? (R = 0, Math.abs(e.x) > Math.abs(e.z) ? I.set(-e.y, e.x, 0) : I.set(0, -e.z, e.y)) : I.crossVectors(e, t), this._x = I.x, this._y = I.y, this._z = I.z, this._w = R, this.normalize();
            }),
            angleTo: function angleTo(e) {
              return 2 * Math.acos(Math.abs(ne.clamp(this.dot(e), -1, 1)));
            },
            rotateTowards: function rotateTowards(e, t) {
              var n = this.angleTo(e);
              if (0 === n) return this;
              var r = Math.min(1, t / n);
              return this.slerp(e, r), this;
            },
            inverse: function inverse() {
              return this.conjugate();
            },
            conjugate: function conjugate() {
              return this._x *= -1, this._y *= -1, this._z *= -1, this.onChangeCallback(), this;
            },
            dot: function dot(e) {
              return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
            },
            lengthSq: function lengthSq() {
              return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            },
            length: function length() {
              return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            },
            normalize: function normalize() {
              var e = this.length();
              return 0 === e ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this.onChangeCallback(), this;
            },
            multiply: function multiply(e, t) {
              return void 0 !== t ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(e, t)) : this.multiplyQuaternions(this, e);
            },
            premultiply: function premultiply(e) {
              return this.multiplyQuaternions(e, this);
            },
            multiplyQuaternions: function multiplyQuaternions(e, t) {
              var n = e._x,
                r = e._y,
                i = e._z,
                o = e._w,
                a = t._x,
                s = t._y,
                l = t._z,
                u = t._w;
              return this._x = n * u + o * a + r * l - i * s, this._y = r * u + o * s + i * a - n * l, this._z = i * u + o * l + n * s - r * a, this._w = o * u - n * a - r * s - i * l, this.onChangeCallback(), this;
            },
            slerp: function slerp(e, t) {
              if (0 === t) return this;
              if (1 === t) return this.copy(e);
              var n = this._x,
                r = this._y,
                i = this._z,
                o = this._w,
                a = o * e._w + n * e._x + r * e._y + i * e._z;
              if (a < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, a = -a) : this.copy(e), 1 <= a) return this._w = o, this._x = n, this._y = r, this._z = i, this;
              var s = 1 - a * a;
              if (s <= Number.EPSILON) {
                var l = 1 - t;
                return this._w = l * o + t * this._w, this._x = l * n + t * this._x, this._y = l * r + t * this._y, this._z = l * i + t * this._z, this.normalize();
              }
              var u = Math.sqrt(s),
                c = Math.atan2(u, a),
                d = Math.sin((1 - t) * c) / u,
                h = Math.sin(t * c) / u;
              return this._w = o * d + this._w * h, this._x = n * d + this._x * h, this._y = r * d + this._y * h, this._z = i * d + this._z * h, this.onChangeCallback(), this;
            },
            equals: function equals(e) {
              return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
            },
            fromArray: function fromArray(e, t) {
              return void 0 === t && (t = 0), this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this.onChangeCallback(), this;
            },
            toArray: function toArray(e, t) {
              return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
            },
            onChange: function onChange(e) {
              return this.onChangeCallback = e, this;
            },
            onChangeCallback: function onChangeCallback() {}
          }), Object.assign(ae.prototype, {
            isVector3: !0,
            set: function set(e, t, n) {
              return this.x = e, this.y = t, this.z = n, this;
            },
            setScalar: function setScalar(e) {
              return this.x = e, this.y = e, this.z = e, this;
            },
            setX: function setX(e) {
              return this.x = e, this;
            },
            setY: function setY(e) {
              return this.y = e, this;
            },
            setZ: function setZ(e) {
              return this.z = e, this;
            },
            setComponent: function setComponent(e, t) {
              switch (e) {
                case 0:
                  this.x = t;
                  break;
                case 1:
                  this.y = t;
                  break;
                case 2:
                  this.z = t;
                  break;
                default:
                  throw new Error("index is out of range: " + e);
              }
              return this;
            },
            getComponent: function getComponent(e) {
              switch (e) {
                case 0:
                  return this.x;
                case 1:
                  return this.y;
                case 2:
                  return this.z;
                default:
                  throw new Error("index is out of range: " + e);
              }
            },
            clone: function clone() {
              return new this.constructor(this.x, this.y, this.z);
            },
            copy: function copy(e) {
              return this.x = e.x, this.y = e.y, this.z = e.z, this;
            },
            add: function add(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this.z += e.z, this);
            },
            addScalar: function addScalar(e) {
              return this.x += e, this.y += e, this.z += e, this;
            },
            addVectors: function addVectors(e, t) {
              return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
            },
            addScaledVector: function addScaledVector(e, t) {
              return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
            },
            sub: function sub(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this.z -= e.z, this);
            },
            subScalar: function subScalar(e) {
              return this.x -= e, this.y -= e, this.z -= e, this;
            },
            subVectors: function subVectors(e, t) {
              return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
            },
            multiply: function multiply(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(e, t)) : (this.x *= e.x, this.y *= e.y, this.z *= e.z, this);
            },
            multiplyScalar: function multiplyScalar(e) {
              return this.x *= e, this.y *= e, this.z *= e, this;
            },
            multiplyVectors: function multiplyVectors(e, t) {
              return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
            },
            applyEuler: (U = new oe(), function (e) {
              return e && e.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion(U.setFromEuler(e));
            }),
            applyAxisAngle: (z = new oe(), function (e, t) {
              return this.applyQuaternion(z.setFromAxisAngle(e, t));
            }),
            applyMatrix3: function applyMatrix3(e) {
              var t = this.x,
                n = this.y,
                r = this.z,
                i = e.elements;
              return this.x = i[0] * t + i[3] * n + i[6] * r, this.y = i[1] * t + i[4] * n + i[7] * r, this.z = i[2] * t + i[5] * n + i[8] * r, this;
            },
            applyMatrix4: function applyMatrix4(e) {
              var t = this.x,
                n = this.y,
                r = this.z,
                i = e.elements,
                o = 1 / (i[3] * t + i[7] * n + i[11] * r + i[15]);
              return this.x = (i[0] * t + i[4] * n + i[8] * r + i[12]) * o, this.y = (i[1] * t + i[5] * n + i[9] * r + i[13]) * o, this.z = (i[2] * t + i[6] * n + i[10] * r + i[14]) * o, this;
            },
            applyQuaternion: function applyQuaternion(e) {
              var t = this.x,
                n = this.y,
                r = this.z,
                i = e.x,
                o = e.y,
                a = e.z,
                s = e.w,
                l = s * t + o * r - a * n,
                u = s * n + a * t - i * r,
                c = s * r + i * n - o * t,
                d = -i * t - o * n - a * r;
              return this.x = l * s + d * -i + u * -a - c * -o, this.y = u * s + d * -o + c * -i - l * -a, this.z = c * s + d * -a + l * -o - u * -i, this;
            },
            project: (F = new ie(), function (e) {
              return F.multiplyMatrices(e.projectionMatrix, F.getInverse(e.matrixWorld)), this.applyMatrix4(F);
            }),
            unproject: (B = new ie(), function (e) {
              return B.multiplyMatrices(e.matrixWorld, B.getInverse(e.projectionMatrix)), this.applyMatrix4(B);
            }),
            transformDirection: function transformDirection(e) {
              var t = this.x,
                n = this.y,
                r = this.z,
                i = e.elements;
              return this.x = i[0] * t + i[4] * n + i[8] * r, this.y = i[1] * t + i[5] * n + i[9] * r, this.z = i[2] * t + i[6] * n + i[10] * r, this.normalize();
            },
            divide: function divide(e) {
              return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
            },
            divideScalar: function divideScalar(e) {
              return this.multiplyScalar(1 / e);
            },
            min: function min(e) {
              return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
            },
            max: function max(e) {
              return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
            },
            clamp: function clamp(e, t) {
              return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this;
            },
            clampScalar: (L = new ae(), D = new ae(), function (e, t) {
              return L.set(e, e, e), D.set(t, t, t), this.clamp(L, D);
            }),
            clampLength: function clampLength(e, t) {
              var n = this.length();
              return this.divideScalar(n || 1).multiplyScalar(Math.max(e, Math.min(t, n)));
            },
            floor: function floor() {
              return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            },
            ceil: function ceil() {
              return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            },
            round: function round() {
              return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            },
            roundToZero: function roundToZero() {
              return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
            },
            negate: function negate() {
              return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            },
            dot: function dot(e) {
              return this.x * e.x + this.y * e.y + this.z * e.z;
            },
            lengthSq: function lengthSq() {
              return this.x * this.x + this.y * this.y + this.z * this.z;
            },
            length: function length() {
              return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            },
            manhattanLength: function manhattanLength() {
              return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            },
            normalize: function normalize() {
              return this.divideScalar(this.length() || 1);
            },
            setLength: function setLength(e) {
              return this.normalize().multiplyScalar(e);
            },
            lerp: function lerp(e, t) {
              return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
            },
            lerpVectors: function lerpVectors(e, t, n) {
              return this.subVectors(t, e).multiplyScalar(n).add(e);
            },
            cross: function cross(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(e, t)) : this.crossVectors(this, e);
            },
            crossVectors: function crossVectors(e, t) {
              var n = e.x,
                r = e.y,
                i = e.z,
                o = t.x,
                a = t.y,
                s = t.z;
              return this.x = r * s - i * a, this.y = i * o - n * s, this.z = n * a - r * o, this;
            },
            projectOnVector: function projectOnVector(e) {
              var t = e.dot(this) / e.lengthSq();
              return this.copy(e).multiplyScalar(t);
            },
            projectOnPlane: (N = new ae(), function (e) {
              return N.copy(this).projectOnVector(e), this.sub(N);
            }),
            reflect: (j = new ae(), function (e) {
              return this.sub(j.copy(e).multiplyScalar(2 * this.dot(e)));
            }),
            angleTo: function angleTo(e) {
              var t = this.dot(e) / Math.sqrt(this.lengthSq() * e.lengthSq());
              return Math.acos(ne.clamp(t, -1, 1));
            },
            distanceTo: function distanceTo(e) {
              return Math.sqrt(this.distanceToSquared(e));
            },
            distanceToSquared: function distanceToSquared(e) {
              var t = this.x - e.x,
                n = this.y - e.y,
                r = this.z - e.z;
              return t * t + n * n + r * r;
            },
            manhattanDistanceTo: function manhattanDistanceTo(e) {
              return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
            },
            setFromSpherical: function setFromSpherical(e) {
              var t = Math.sin(e.phi) * e.radius;
              return this.x = t * Math.sin(e.theta), this.y = Math.cos(e.phi) * e.radius, this.z = t * Math.cos(e.theta), this;
            },
            setFromCylindrical: function setFromCylindrical(e) {
              return this.x = e.radius * Math.sin(e.theta), this.y = e.y, this.z = e.radius * Math.cos(e.theta), this;
            },
            setFromMatrixPosition: function setFromMatrixPosition(e) {
              var t = e.elements;
              return this.x = t[12], this.y = t[13], this.z = t[14], this;
            },
            setFromMatrixScale: function setFromMatrixScale(e) {
              var t = this.setFromMatrixColumn(e, 0).length(),
                n = this.setFromMatrixColumn(e, 1).length(),
                r = this.setFromMatrixColumn(e, 2).length();
              return this.x = t, this.y = n, this.z = r, this;
            },
            setFromMatrixColumn: function setFromMatrixColumn(e, t) {
              return this.fromArray(e.elements, 4 * t);
            },
            equals: function equals(e) {
              return e.x === this.x && e.y === this.y && e.z === this.z;
            },
            fromArray: function fromArray(e, t) {
              return void 0 === t && (t = 0), this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
            },
            toArray: function toArray(e, t) {
              return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
            },
            fromBufferAttribute: function fromBufferAttribute(e, t, n) {
              return void 0 !== n && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
            }
          }), Object.assign(se.prototype, {
            isMatrix3: !0,
            set: function set(e, t, n, r, i, o, a, s, l) {
              var u = this.elements;
              return u[0] = e, u[1] = r, u[2] = a, u[3] = t, u[4] = i, u[5] = s, u[6] = n, u[7] = o, u[8] = l, this;
            },
            identity: function identity() {
              return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            },
            clone: function clone() {
              return new this.constructor().fromArray(this.elements);
            },
            copy: function copy(e) {
              var t = this.elements,
                n = e.elements;
              return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
            },
            setFromMatrix4: function setFromMatrix4(e) {
              var t = e.elements;
              return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
            },
            applyToBufferAttribute: (G = new ae(), function (e) {
              for (var t = 0, n = e.count; t < n; t++) G.x = e.getX(t), G.y = e.getY(t), G.z = e.getZ(t), G.applyMatrix3(this), e.setXYZ(t, G.x, G.y, G.z);
              return e;
            }),
            multiply: function multiply(e) {
              return this.multiplyMatrices(this, e);
            },
            premultiply: function premultiply(e) {
              return this.multiplyMatrices(e, this);
            },
            multiplyMatrices: function multiplyMatrices(e, t) {
              var n = e.elements,
                r = t.elements,
                i = this.elements,
                o = n[0],
                a = n[3],
                s = n[6],
                l = n[1],
                u = n[4],
                c = n[7],
                d = n[2],
                h = n[5],
                f = n[8],
                p = r[0],
                m = r[3],
                g = r[6],
                v = r[1],
                y = r[4],
                b = r[7],
                _ = r[2],
                x = r[5],
                w = r[8];
              return i[0] = o * p + a * v + s * _, i[3] = o * m + a * y + s * x, i[6] = o * g + a * b + s * w, i[1] = l * p + u * v + c * _, i[4] = l * m + u * y + c * x, i[7] = l * g + u * b + c * w, i[2] = d * p + h * v + f * _, i[5] = d * m + h * y + f * x, i[8] = d * g + h * b + f * w, this;
            },
            multiplyScalar: function multiplyScalar(e) {
              var t = this.elements;
              return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
            },
            determinant: function determinant() {
              var e = this.elements,
                t = e[0],
                n = e[1],
                r = e[2],
                i = e[3],
                o = e[4],
                a = e[5],
                s = e[6],
                l = e[7],
                u = e[8];
              return t * o * u - t * a * l - n * i * u + n * a * s + r * i * l - r * o * s;
            },
            getInverse: function getInverse(e, t) {
              e && e.isMatrix4 && console.error("THREE.Matrix3: .getInverse() no longer takes a Matrix4 argument.");
              var n = e.elements,
                r = this.elements,
                i = n[0],
                o = n[1],
                a = n[2],
                s = n[3],
                l = n[4],
                u = n[5],
                c = n[6],
                d = n[7],
                h = n[8],
                f = h * l - u * d,
                p = u * c - h * s,
                m = d * s - l * c,
                g = i * f + o * p + a * m;
              if (0 === g) {
                var v = "THREE.Matrix3: .getInverse() can't invert matrix, determinant is 0";
                if (!0 === t) throw new Error(v);
                return console.warn(v), this.identity();
              }
              var y = 1 / g;
              return r[0] = f * y, r[1] = (a * d - h * o) * y, r[2] = (u * o - a * l) * y, r[3] = p * y, r[4] = (h * i - a * c) * y, r[5] = (a * s - u * i) * y, r[6] = m * y, r[7] = (o * c - d * i) * y, r[8] = (l * i - o * s) * y, this;
            },
            transpose: function transpose() {
              var e,
                t = this.elements;
              return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
            },
            getNormalMatrix: function getNormalMatrix(e) {
              return this.setFromMatrix4(e).getInverse(this).transpose();
            },
            transposeIntoArray: function transposeIntoArray(e) {
              var t = this.elements;
              return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
            },
            setUvTransform: function setUvTransform(e, t, n, r, i, o, a) {
              var s = Math.cos(i),
                l = Math.sin(i);
              this.set(n * s, n * l, -n * (s * o + l * a) + o + e, -r * l, r * s, -r * (-l * o + s * a) + a + t, 0, 0, 1);
            },
            scale: function scale(e, t) {
              var n = this.elements;
              return n[0] *= e, n[3] *= e, n[6] *= e, n[1] *= t, n[4] *= t, n[7] *= t, this;
            },
            rotate: function rotate(e) {
              var t = Math.cos(e),
                n = Math.sin(e),
                r = this.elements,
                i = r[0],
                o = r[3],
                a = r[6],
                s = r[1],
                l = r[4],
                u = r[7];
              return r[0] = t * i + n * s, r[3] = t * o + n * l, r[6] = t * a + n * u, r[1] = -n * i + t * s, r[4] = -n * o + t * l, r[7] = -n * a + t * u, this;
            },
            translate: function translate(e, t) {
              var n = this.elements;
              return n[0] += e * n[2], n[3] += e * n[5], n[6] += e * n[8], n[1] += t * n[2], n[4] += t * n[5], n[7] += t * n[8], this;
            },
            equals: function equals(e) {
              for (var t = this.elements, n = e.elements, r = 0; r < 9; r++) if (t[r] !== n[r]) return !1;
              return !0;
            },
            fromArray: function fromArray(e, t) {
              void 0 === t && (t = 0);
              for (var n = 0; n < 9; n++) this.elements[n] = e[n + t];
              return this;
            },
            toArray: function toArray(e, t) {
              void 0 === e && (e = []), void 0 === t && (t = 0);
              var n = this.elements;
              return e[t] = n[0], e[t + 1] = n[1], e[t + 2] = n[2], e[t + 3] = n[3], e[t + 4] = n[4], e[t + 5] = n[5], e[t + 6] = n[6], e[t + 7] = n[7], e[t + 8] = n[8], e;
            }
          });
          var le,
            ue,
            ce,
            de,
            he,
            fe,
            pe,
            ge,
            ve,
            ye,
            be,
            _e,
            xe,
            we,
            Se,
            Ae = {
              getDataURL: function getDataURL(e) {
                var t;
                if (e instanceof HTMLCanvasElement) t = e;else {
                  "undefined" != typeof OffscreenCanvas ? t = new OffscreenCanvas(e.width, e.height) : ((t = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas")).width = e.width, t.height = e.height);
                  var n = t.getContext("2d");
                  e instanceof ImageData ? n.putImageData(e, 0, 0) : n.drawImage(e, 0, 0, e.width, e.height);
                }
                return 2048 < t.width || 2048 < t.height ? t.toDataURL("image/jpeg", .6) : t.toDataURL("image/png");
              }
            },
            Ee = 0;
          function Te(e, t, n, r, i, o, a, s, l, u) {
            Object.defineProperty(this, "id", {
              value: Ee++
            }), this.uuid = ne.generateUUID(), this.name = "", this.image = void 0 !== e ? e : Te.DEFAULT_IMAGE, this.mipmaps = [], this.mapping = void 0 !== t ? t : Te.DEFAULT_MAPPING, this.wrapS = void 0 !== n ? n : H, this.wrapT = void 0 !== r ? r : H, this.magFilter = void 0 !== i ? i : $, this.minFilter = void 0 !== o ? o : 1008, this.anisotropy = void 0 !== l ? l : 1, this.format = void 0 !== a ? a : Z, this.type = void 0 !== s ? s : X, this.offset = new re(0, 0), this.repeat = new re(1, 1), this.center = new re(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new se(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = void 0 !== u ? u : 3e3, this.version = 0, this.onUpdate = null;
          }
          function Me(e, t, n, r) {
            this.x = e || 0, this.y = t || 0, this.z = n || 0, this.w = void 0 !== r ? r : 1;
          }
          function Ce(e, t, n) {
            this.width = e, this.height = t, this.scissor = new Me(0, 0, e, t), this.scissorTest = !1, this.viewport = new Me(0, 0, e, t), void 0 === (n = n || {}).minFilter && (n.minFilter = $), this.texture = new Te(void 0, void 0, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), this.texture.generateMipmaps = void 0 === n.generateMipmaps || n.generateMipmaps, this.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer, this.stencilBuffer = void 0 === n.stencilBuffer || n.stencilBuffer, this.depthTexture = void 0 !== n.depthTexture ? n.depthTexture : null;
          }
          function ke(e, t, n) {
            Ce.call(this, e, t, n), this.activeCubeFace = 0, this.activeMipMapLevel = 0;
          }
          function Pe(e, t, n, r, i, o, a, s, l, u, c, d) {
            Te.call(this, null, o, a, s, l, u, r, i, c, d), this.image = {
              data: e,
              width: t,
              height: n
            }, this.magFilter = void 0 !== l ? l : W, this.minFilter = void 0 !== u ? u : W, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
          }
          function Oe(e, t) {
            this.min = void 0 !== e ? e : new ae(1 / 0, 1 / 0, 1 / 0), this.max = void 0 !== t ? t : new ae(-1 / 0, -1 / 0, -1 / 0);
          }
          function Re(e, t) {
            this.center = void 0 !== e ? e : new ae(), this.radius = void 0 !== t ? t : 0;
          }
          function Ie(e, t) {
            this.normal = void 0 !== e ? e : new ae(1, 0, 0), this.constant = void 0 !== t ? t : 0;
          }
          function je(e, t, n, r, i, o) {
            this.planes = [void 0 !== e ? e : new Ie(), void 0 !== t ? t : new Ie(), void 0 !== n ? n : new Ie(), void 0 !== r ? r : new Ie(), void 0 !== i ? i : new Ie(), void 0 !== o ? o : new Ie()];
          }
          Te.DEFAULT_IMAGE = void 0, Te.DEFAULT_MAPPING = 300, Te.prototype = Object.assign(Object.create(_.prototype), {
            constructor: Te,
            isTexture: !0,
            updateMatrix: function updateMatrix() {
              this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.name = e.name, this.image = e.image, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.encoding = e.encoding, this;
            },
            toJSON: function toJSON(e) {
              var t = void 0 === e || "string" == typeof e;
              if (!t && void 0 !== e.textures[this.uuid]) return e.textures[this.uuid];
              var n = {
                metadata: {
                  version: 4.5,
                  type: "Texture",
                  generator: "Texture.toJSON"
                },
                uuid: this.uuid,
                name: this.name,
                mapping: this.mapping,
                repeat: [this.repeat.x, this.repeat.y],
                offset: [this.offset.x, this.offset.y],
                center: [this.center.x, this.center.y],
                rotation: this.rotation,
                wrap: [this.wrapS, this.wrapT],
                format: this.format,
                minFilter: this.minFilter,
                magFilter: this.magFilter,
                anisotropy: this.anisotropy,
                flipY: this.flipY
              };
              if (void 0 !== this.image) {
                var r = this.image;
                if (void 0 === r.uuid && (r.uuid = ne.generateUUID()), !t && void 0 === e.images[r.uuid]) {
                  var i;
                  if (Array.isArray(r)) {
                    i = [];
                    for (var o = 0, a = r.length; o < a; o++) i.push(Ae.getDataURL(r[o]));
                  } else i = Ae.getDataURL(r);
                  e.images[r.uuid] = {
                    uuid: r.uuid,
                    url: i
                  };
                }
                n.image = r.uuid;
              }
              return t || (e.textures[this.uuid] = n), n;
            },
            dispose: function dispose() {
              this.dispatchEvent({
                type: "dispose"
              });
            },
            transformUv: function transformUv(e) {
              if (300 === this.mapping) {
                if (e.applyMatrix3(this.matrix), e.x < 0 || 1 < e.x) switch (this.wrapS) {
                  case V:
                    e.x = e.x - Math.floor(e.x);
                    break;
                  case H:
                    e.x = e.x < 0 ? 0 : 1;
                    break;
                  case q:
                    1 === Math.abs(Math.floor(e.x) % 2) ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
                }
                if (e.y < 0 || 1 < e.y) switch (this.wrapT) {
                  case V:
                    e.y = e.y - Math.floor(e.y);
                    break;
                  case H:
                    e.y = e.y < 0 ? 0 : 1;
                    break;
                  case q:
                    1 === Math.abs(Math.floor(e.y) % 2) ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
                }
                this.flipY && (e.y = 1 - e.y);
              }
            }
          }), Object.defineProperty(Te.prototype, "needsUpdate", {
            set: function set(e) {
              !0 === e && this.version++;
            }
          }), Object.assign(Me.prototype, {
            isVector4: !0,
            set: function set(e, t, n, r) {
              return this.x = e, this.y = t, this.z = n, this.w = r, this;
            },
            setScalar: function setScalar(e) {
              return this.x = e, this.y = e, this.z = e, this.w = e, this;
            },
            setX: function setX(e) {
              return this.x = e, this;
            },
            setY: function setY(e) {
              return this.y = e, this;
            },
            setZ: function setZ(e) {
              return this.z = e, this;
            },
            setW: function setW(e) {
              return this.w = e, this;
            },
            setComponent: function setComponent(e, t) {
              switch (e) {
                case 0:
                  this.x = t;
                  break;
                case 1:
                  this.y = t;
                  break;
                case 2:
                  this.z = t;
                  break;
                case 3:
                  this.w = t;
                  break;
                default:
                  throw new Error("index is out of range: " + e);
              }
              return this;
            },
            getComponent: function getComponent(e) {
              switch (e) {
                case 0:
                  return this.x;
                case 1:
                  return this.y;
                case 2:
                  return this.z;
                case 3:
                  return this.w;
                default:
                  throw new Error("index is out of range: " + e);
              }
            },
            clone: function clone() {
              return new this.constructor(this.x, this.y, this.z, this.w);
            },
            copy: function copy(e) {
              return this.x = e.x, this.y = e.y, this.z = e.z, this.w = void 0 !== e.w ? e.w : 1, this;
            },
            add: function add(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this);
            },
            addScalar: function addScalar(e) {
              return this.x += e, this.y += e, this.z += e, this.w += e, this;
            },
            addVectors: function addVectors(e, t) {
              return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
            },
            addScaledVector: function addScaledVector(e, t) {
              return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
            },
            sub: function sub(e, t) {
              return void 0 !== t ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this);
            },
            subScalar: function subScalar(e) {
              return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
            },
            subVectors: function subVectors(e, t) {
              return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
            },
            multiplyScalar: function multiplyScalar(e) {
              return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
            },
            applyMatrix4: function applyMatrix4(e) {
              var t = this.x,
                n = this.y,
                r = this.z,
                i = this.w,
                o = e.elements;
              return this.x = o[0] * t + o[4] * n + o[8] * r + o[12] * i, this.y = o[1] * t + o[5] * n + o[9] * r + o[13] * i, this.z = o[2] * t + o[6] * n + o[10] * r + o[14] * i, this.w = o[3] * t + o[7] * n + o[11] * r + o[15] * i, this;
            },
            divideScalar: function divideScalar(e) {
              return this.multiplyScalar(1 / e);
            },
            setAxisAngleFromQuaternion: function setAxisAngleFromQuaternion(e) {
              this.w = 2 * Math.acos(e.w);
              var t = Math.sqrt(1 - e.w * e.w);
              return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
            },
            setAxisAngleFromRotationMatrix: function setAxisAngleFromRotationMatrix(e) {
              var t,
                n,
                r,
                i,
                o = e.elements,
                a = o[0],
                s = o[4],
                l = o[8],
                u = o[1],
                c = o[5],
                d = o[9],
                h = o[2],
                f = o[6],
                p = o[10];
              if (Math.abs(s - u) < .01 && Math.abs(l - h) < .01 && Math.abs(d - f) < .01) {
                if (Math.abs(s + u) < .1 && Math.abs(l + h) < .1 && Math.abs(d + f) < .1 && Math.abs(a + c + p - 3) < .1) return this.set(1, 0, 0, 0), this;
                t = Math.PI;
                var m = (a + 1) / 2,
                  g = (c + 1) / 2,
                  v = (p + 1) / 2,
                  y = (s + u) / 4,
                  b = (l + h) / 4,
                  _ = (d + f) / 4;
                return g < m && v < m ? m < .01 ? (n = 0, i = r = .707106781) : (r = y / (n = Math.sqrt(m)), i = b / n) : v < g ? g < .01 ? (r = 0, i = n = .707106781) : (n = y / (r = Math.sqrt(g)), i = _ / r) : v < .01 ? (r = n = .707106781, i = 0) : (n = b / (i = Math.sqrt(v)), r = _ / i), this.set(n, r, i, t), this;
              }
              var x = Math.sqrt((f - d) * (f - d) + (l - h) * (l - h) + (u - s) * (u - s));
              return Math.abs(x) < .001 && (x = 1), this.x = (f - d) / x, this.y = (l - h) / x, this.z = (u - s) / x, this.w = Math.acos((a + c + p - 1) / 2), this;
            },
            min: function min(e) {
              return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
            },
            max: function max(e) {
              return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
            },
            clamp: function clamp(e, t) {
              return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this.w = Math.max(e.w, Math.min(t.w, this.w)), this;
            },
            clampScalar: function clampScalar(e, t) {
              return void 0 === le && (le = new Me(), ue = new Me()), le.set(e, e, e, e), ue.set(t, t, t, t), this.clamp(le, ue);
            },
            clampLength: function clampLength(e, t) {
              var n = this.length();
              return this.divideScalar(n || 1).multiplyScalar(Math.max(e, Math.min(t, n)));
            },
            floor: function floor() {
              return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            },
            ceil: function ceil() {
              return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            },
            round: function round() {
              return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            },
            roundToZero: function roundToZero() {
              return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
            },
            negate: function negate() {
              return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            },
            dot: function dot(e) {
              return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
            },
            lengthSq: function lengthSq() {
              return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            },
            length: function length() {
              return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            },
            manhattanLength: function manhattanLength() {
              return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            },
            normalize: function normalize() {
              return this.divideScalar(this.length() || 1);
            },
            setLength: function setLength(e) {
              return this.normalize().multiplyScalar(e);
            },
            lerp: function lerp(e, t) {
              return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
            },
            lerpVectors: function lerpVectors(e, t, n) {
              return this.subVectors(t, e).multiplyScalar(n).add(e);
            },
            equals: function equals(e) {
              return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
            },
            fromArray: function fromArray(e, t) {
              return void 0 === t && (t = 0), this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
            },
            toArray: function toArray(e, t) {
              return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
            },
            fromBufferAttribute: function fromBufferAttribute(e, t, n) {
              return void 0 !== n && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
            }
          }), Ce.prototype = Object.assign(Object.create(_.prototype), {
            constructor: Ce,
            isWebGLRenderTarget: !0,
            setSize: function setSize(e, t) {
              this.width === e && this.height === t || (this.width = e, this.height = t, this.dispose()), this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.width = e.width, this.height = e.height, this.viewport.copy(e.viewport), this.texture = e.texture.clone(), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.depthTexture = e.depthTexture, this;
            },
            dispose: function dispose() {
              this.dispatchEvent({
                type: "dispose"
              });
            }
          }), ((ke.prototype = Object.create(Ce.prototype)).constructor = ke).prototype.isWebGLRenderTargetCube = !0, ((Pe.prototype = Object.create(Te.prototype)).constructor = Pe).prototype.isDataTexture = !0, Object.assign(Oe.prototype, {
            isBox3: !0,
            set: function set(e, t) {
              return this.min.copy(e), this.max.copy(t), this;
            },
            setFromArray: function setFromArray(e) {
              for (var t = 1 / 0, n = 1 / 0, r = 1 / 0, i = -1 / 0, o = -1 / 0, a = -1 / 0, s = 0, l = e.length; s < l; s += 3) {
                var u = e[s],
                  c = e[s + 1],
                  d = e[s + 2];
                u < t && (t = u), c < n && (n = c), d < r && (r = d), i < u && (i = u), o < c && (o = c), a < d && (a = d);
              }
              return this.min.set(t, n, r), this.max.set(i, o, a), this;
            },
            setFromBufferAttribute: function setFromBufferAttribute(e) {
              for (var t = 1 / 0, n = 1 / 0, r = 1 / 0, i = -1 / 0, o = -1 / 0, a = -1 / 0, s = 0, l = e.count; s < l; s++) {
                var u = e.getX(s),
                  c = e.getY(s),
                  d = e.getZ(s);
                u < t && (t = u), c < n && (n = c), d < r && (r = d), i < u && (i = u), o < c && (o = c), a < d && (a = d);
              }
              return this.min.set(t, n, r), this.max.set(i, o, a), this;
            },
            setFromPoints: function setFromPoints(e) {
              this.makeEmpty();
              for (var t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
              return this;
            },
            setFromCenterAndSize: (fe = new ae(), function (e, t) {
              var n = fe.copy(t).multiplyScalar(.5);
              return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
            }),
            setFromObject: function setFromObject(e) {
              return this.makeEmpty(), this.expandByObject(e);
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.min.copy(e.min), this.max.copy(e.max), this;
            },
            makeEmpty: function makeEmpty() {
              return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
            },
            isEmpty: function isEmpty() {
              return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            },
            getCenter: function getCenter(e) {
              return void 0 === e && (console.warn("THREE.Box3: .getCenter() target is now required"), e = new ae()), this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
            },
            getSize: function getSize(e) {
              return void 0 === e && (console.warn("THREE.Box3: .getSize() target is now required"), e = new ae()), this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
            },
            expandByPoint: function expandByPoint(e) {
              return this.min.min(e), this.max.max(e), this;
            },
            expandByVector: function expandByVector(e) {
              return this.min.sub(e), this.max.add(e), this;
            },
            expandByScalar: function expandByScalar(e) {
              return this.min.addScalar(-e), this.max.addScalar(e), this;
            },
            expandByObject: function () {
              var e,
                t,
                n,
                r = new ae();
              function i(i) {
                var o = i.geometry;
                if (void 0 !== o) if (o.isGeometry) {
                  var a = o.vertices;
                  for (t = 0, n = a.length; t < n; t++) r.copy(a[t]), r.applyMatrix4(i.matrixWorld), e.expandByPoint(r);
                } else if (o.isBufferGeometry) {
                  var s = o.attributes.position;
                  if (void 0 !== s) for (t = 0, n = s.count; t < n; t++) r.fromBufferAttribute(s, t).applyMatrix4(i.matrixWorld), e.expandByPoint(r);
                }
              }
              return function (t) {
                return e = this, t.updateMatrixWorld(!0), t.traverse(i), this;
              };
            }(),
            containsPoint: function containsPoint(e) {
              return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
            },
            containsBox: function containsBox(e) {
              return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
            },
            getParameter: function getParameter(e, t) {
              return void 0 === t && (console.warn("THREE.Box3: .getParameter() target is now required"), t = new ae()), t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
            },
            intersectsBox: function intersectsBox(e) {
              return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
            },
            intersectsSphere: (he = new ae(), function (e) {
              return this.clampPoint(e.center, he), he.distanceToSquared(e.center) <= e.radius * e.radius;
            }),
            intersectsPlane: function intersectsPlane(e) {
              var t, n;
              return 0 < e.normal.x ? (t = e.normal.x * this.min.x, n = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, n = e.normal.x * this.min.x), 0 < e.normal.y ? (t += e.normal.y * this.min.y, n += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, n += e.normal.y * this.min.y), 0 < e.normal.z ? (t += e.normal.z * this.min.z, n += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, n += e.normal.z * this.min.z), t <= e.constant && n >= e.constant;
            },
            intersectsTriangle: function () {
              var e = new ae(),
                t = new ae(),
                n = new ae(),
                r = new ae(),
                i = new ae(),
                o = new ae(),
                a = new ae(),
                s = new ae(),
                l = new ae(),
                u = new ae();
              function c(r) {
                var i, o;
                for (i = 0, o = r.length - 3; i <= o; i += 3) {
                  a.fromArray(r, i);
                  var s = l.x * Math.abs(a.x) + l.y * Math.abs(a.y) + l.z * Math.abs(a.z),
                    u = e.dot(a),
                    c = t.dot(a),
                    d = n.dot(a);
                  if (Math.max(-Math.max(u, c, d), Math.min(u, c, d)) > s) return !1;
                }
                return !0;
              }
              return function (a) {
                if (this.isEmpty()) return !1;
                this.getCenter(s), l.subVectors(this.max, s), e.subVectors(a.a, s), t.subVectors(a.b, s), n.subVectors(a.c, s), r.subVectors(t, e), i.subVectors(n, t), o.subVectors(e, n);
                var d = [0, -r.z, r.y, 0, -i.z, i.y, 0, -o.z, o.y, r.z, 0, -r.x, i.z, 0, -i.x, o.z, 0, -o.x, -r.y, r.x, 0, -i.y, i.x, 0, -o.y, o.x, 0];
                return !!c(d) && !!c(d = [1, 0, 0, 0, 1, 0, 0, 0, 1]) && (u.crossVectors(r, i), c(d = [u.x, u.y, u.z]));
              };
            }(),
            clampPoint: function clampPoint(e, t) {
              return void 0 === t && (console.warn("THREE.Box3: .clampPoint() target is now required"), t = new ae()), t.copy(e).clamp(this.min, this.max);
            },
            distanceToPoint: (de = new ae(), function (e) {
              return de.copy(e).clamp(this.min, this.max).sub(e).length();
            }),
            getBoundingSphere: (ce = new ae(), function (e) {
              return void 0 === e && (console.warn("THREE.Box3: .getBoundingSphere() target is now required"), e = new Re()), this.getCenter(e.center), e.radius = .5 * this.getSize(ce).length(), e;
            }),
            intersect: function intersect(e) {
              return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
            },
            union: function union(e) {
              return this.min.min(e.min), this.max.max(e.max), this;
            },
            applyMatrix4: function applyMatrix4(e) {
              if (this.isEmpty()) return this;
              var t = e.elements,
                n = t[0] * this.min.x,
                r = t[1] * this.min.x,
                i = t[2] * this.min.x,
                o = t[0] * this.max.x,
                a = t[1] * this.max.x,
                s = t[2] * this.max.x,
                l = t[4] * this.min.y,
                u = t[5] * this.min.y,
                c = t[6] * this.min.y,
                d = t[4] * this.max.y,
                h = t[5] * this.max.y,
                f = t[6] * this.max.y,
                p = t[8] * this.min.z,
                m = t[9] * this.min.z,
                g = t[10] * this.min.z,
                v = t[8] * this.max.z,
                y = t[9] * this.max.z,
                b = t[10] * this.max.z;
              return this.min.x = Math.min(n, o) + Math.min(l, d) + Math.min(p, v) + t[12], this.min.y = Math.min(r, a) + Math.min(u, h) + Math.min(m, y) + t[13], this.min.z = Math.min(i, s) + Math.min(c, f) + Math.min(g, b) + t[14], this.max.x = Math.max(n, o) + Math.max(l, d) + Math.max(p, v) + t[12], this.max.y = Math.max(r, a) + Math.max(u, h) + Math.max(m, y) + t[13], this.max.z = Math.max(i, s) + Math.max(c, f) + Math.max(g, b) + t[14], this;
            },
            translate: function translate(e) {
              return this.min.add(e), this.max.add(e), this;
            },
            equals: function equals(e) {
              return e.min.equals(this.min) && e.max.equals(this.max);
            }
          }), Object.assign(Re.prototype, {
            set: function set(e, t) {
              return this.center.copy(e), this.radius = t, this;
            },
            setFromPoints: (pe = new Oe(), function (e, t) {
              var n = this.center;
              void 0 !== t ? n.copy(t) : pe.setFromPoints(e).getCenter(n);
              for (var r = 0, i = 0, o = e.length; i < o; i++) r = Math.max(r, n.distanceToSquared(e[i]));
              return this.radius = Math.sqrt(r), this;
            }),
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.center.copy(e.center), this.radius = e.radius, this;
            },
            empty: function empty() {
              return this.radius <= 0;
            },
            containsPoint: function containsPoint(e) {
              return e.distanceToSquared(this.center) <= this.radius * this.radius;
            },
            distanceToPoint: function distanceToPoint(e) {
              return e.distanceTo(this.center) - this.radius;
            },
            intersectsSphere: function intersectsSphere(e) {
              var t = this.radius + e.radius;
              return e.center.distanceToSquared(this.center) <= t * t;
            },
            intersectsBox: function intersectsBox(e) {
              return e.intersectsSphere(this);
            },
            intersectsPlane: function intersectsPlane(e) {
              return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
            },
            clampPoint: function clampPoint(e, t) {
              var n = this.center.distanceToSquared(e);
              return void 0 === t && (console.warn("THREE.Sphere: .clampPoint() target is now required"), t = new ae()), t.copy(e), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
            },
            getBoundingBox: function getBoundingBox(e) {
              return void 0 === e && (console.warn("THREE.Sphere: .getBoundingBox() target is now required"), e = new Oe()), e.set(this.center, this.center), e.expandByScalar(this.radius), e;
            },
            applyMatrix4: function applyMatrix4(e) {
              return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
            },
            translate: function translate(e) {
              return this.center.add(e), this;
            },
            equals: function equals(e) {
              return e.center.equals(this.center) && e.radius === this.radius;
            }
          }), Object.assign(Ie.prototype, {
            set: function set(e, t) {
              return this.normal.copy(e), this.constant = t, this;
            },
            setComponents: function setComponents(e, t, n, r) {
              return this.normal.set(e, t, n), this.constant = r, this;
            },
            setFromNormalAndCoplanarPoint: function setFromNormalAndCoplanarPoint(e, t) {
              return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
            },
            setFromCoplanarPoints: (be = new ae(), _e = new ae(), function (e, t, n) {
              var r = be.subVectors(n, t).cross(_e.subVectors(e, t)).normalize();
              return this.setFromNormalAndCoplanarPoint(r, e), this;
            }),
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.normal.copy(e.normal), this.constant = e.constant, this;
            },
            normalize: function normalize() {
              var e = 1 / this.normal.length();
              return this.normal.multiplyScalar(e), this.constant *= e, this;
            },
            negate: function negate() {
              return this.constant *= -1, this.normal.negate(), this;
            },
            distanceToPoint: function distanceToPoint(e) {
              return this.normal.dot(e) + this.constant;
            },
            distanceToSphere: function distanceToSphere(e) {
              return this.distanceToPoint(e.center) - e.radius;
            },
            projectPoint: function projectPoint(e, t) {
              return void 0 === t && (console.warn("THREE.Plane: .projectPoint() target is now required"), t = new ae()), t.copy(this.normal).multiplyScalar(-this.distanceToPoint(e)).add(e);
            },
            intersectLine: (ye = new ae(), function (e, t) {
              void 0 === t && (console.warn("THREE.Plane: .intersectLine() target is now required"), t = new ae());
              var n = e.delta(ye),
                r = this.normal.dot(n);
              if (0 === r) return 0 === this.distanceToPoint(e.start) ? t.copy(e.start) : void 0;
              var i = -(e.start.dot(this.normal) + this.constant) / r;
              return i < 0 || 1 < i ? void 0 : t.copy(n).multiplyScalar(i).add(e.start);
            }),
            intersectsLine: function intersectsLine(e) {
              var t = this.distanceToPoint(e.start),
                n = this.distanceToPoint(e.end);
              return t < 0 && 0 < n || n < 0 && 0 < t;
            },
            intersectsBox: function intersectsBox(e) {
              return e.intersectsPlane(this);
            },
            intersectsSphere: function intersectsSphere(e) {
              return e.intersectsPlane(this);
            },
            coplanarPoint: function coplanarPoint(e) {
              return void 0 === e && (console.warn("THREE.Plane: .coplanarPoint() target is now required"), e = new ae()), e.copy(this.normal).multiplyScalar(-this.constant);
            },
            applyMatrix4: (ge = new ae(), ve = new se(), function (e, t) {
              var n = t || ve.getNormalMatrix(e),
                r = this.coplanarPoint(ge).applyMatrix4(e),
                i = this.normal.applyMatrix3(n).normalize();
              return this.constant = -r.dot(i), this;
            }),
            translate: function translate(e) {
              return this.constant -= e.dot(this.normal), this;
            },
            equals: function equals(e) {
              return e.normal.equals(this.normal) && e.constant === this.constant;
            }
          }), Object.assign(je.prototype, {
            set: function set(e, t, n, r, i, o) {
              var a = this.planes;
              return a[0].copy(e), a[1].copy(t), a[2].copy(n), a[3].copy(r), a[4].copy(i), a[5].copy(o), this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              for (var t = this.planes, n = 0; n < 6; n++) t[n].copy(e.planes[n]);
              return this;
            },
            setFromMatrix: function setFromMatrix(e) {
              var t = this.planes,
                n = e.elements,
                r = n[0],
                i = n[1],
                o = n[2],
                a = n[3],
                s = n[4],
                l = n[5],
                u = n[6],
                c = n[7],
                d = n[8],
                h = n[9],
                f = n[10],
                p = n[11],
                m = n[12],
                g = n[13],
                v = n[14],
                y = n[15];
              return t[0].setComponents(a - r, c - s, p - d, y - m).normalize(), t[1].setComponents(a + r, c + s, p + d, y + m).normalize(), t[2].setComponents(a + i, c + l, p + h, y + g).normalize(), t[3].setComponents(a - i, c - l, p - h, y - g).normalize(), t[4].setComponents(a - o, c - u, p - f, y - v).normalize(), t[5].setComponents(a + o, c + u, p + f, y + v).normalize(), this;
            },
            intersectsObject: (Se = new Re(), function (e) {
              var t = e.geometry;
              return null === t.boundingSphere && t.computeBoundingSphere(), Se.copy(t.boundingSphere).applyMatrix4(e.matrixWorld), this.intersectsSphere(Se);
            }),
            intersectsSprite: (we = new Re(), function (e) {
              return we.center.set(0, 0, 0), we.radius = .7071067811865476, we.applyMatrix4(e.matrixWorld), this.intersectsSphere(we);
            }),
            intersectsSphere: function intersectsSphere(e) {
              for (var t = this.planes, n = e.center, r = -e.radius, i = 0; i < 6; i++) if (t[i].distanceToPoint(n) < r) return !1;
              return !0;
            },
            intersectsBox: (xe = new ae(), function (e) {
              for (var t = this.planes, n = 0; n < 6; n++) {
                var r = t[n];
                if (xe.x = 0 < r.normal.x ? e.max.x : e.min.x, xe.y = 0 < r.normal.y ? e.max.y : e.min.y, xe.z = 0 < r.normal.z ? e.max.z : e.min.z, r.distanceToPoint(xe) < 0) return !1;
              }
              return !0;
            }),
            containsPoint: function containsPoint(e) {
              for (var t = this.planes, n = 0; n < 6; n++) if (t[n].distanceToPoint(e) < 0) return !1;
              return !0;
            }
          });
          var Ne,
            Le = {
              alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n",
              alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n",
              alphatest_fragment: "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n",
              aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n",
              aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
              begin_vertex: "\nvec3 transformed = vec3( position );\n",
              beginnormal_vertex: "\nvec3 objectNormal = vec3( normal );\n",
              bsdfs: "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n",
              bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tfDet *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n",
              clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t#endif\n#endif\n",
              clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n",
              clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n",
              clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n",
              color_fragment: "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif",
              color_pars_fragment: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n",
              color_pars_vertex: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif",
              color_vertex: "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif",
              common: "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\n",
              cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV( sampler2D envMap, vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n",
              defaultnormal_vertex: "vec3 transformedNormal = normalMatrix * objectNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n",
              displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n",
              displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n",
              emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n",
              emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n",
              encodings_fragment: "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n",
              encodings_pars_fragment: "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n",
              envmap_fragment: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\treflectVec = normalize( reflectVec );\n\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\treflectVec = normalize( reflectVec );\n\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n",
              envmap_pars_fragment: "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n",
              envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n",
              envmap_physical_pars_fragment: "#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent ));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = asin( clamp( reflectVec.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n",
              envmap_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n",
              fog_vertex: "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif",
              fog_pars_vertex: "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n",
              fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n",
              fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n",
              gradientmap_pars_fragment: "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n",
              lightmap_fragment: "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n",
              lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
              lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n",
              lights_pars_begin: "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t\tfloat shadowCameraNear;\n\t\tfloat shadowCameraFar;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n",
              lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n",
              lights_phong_pars_fragment: "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n",
              lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n",
              lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n",
              lights_fragment_begin: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearCoatRadiance = vec3( 0.0 );\n#endif\n",
              lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), maxMipLevel );\n\t#ifndef STANDARD\n\t\tclearCoatRadiance += getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), maxMipLevel );\n\t#endif\n#endif\n",
              lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n",
              logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
              logdepthbuf_pars_fragment: "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n",
              logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif",
              logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\tgl_Position.z *= gl_Position.w;\n\t#endif\n#endif\n",
              map_fragment: "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n",
              map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n",
              map_particle_fragment: "#ifdef USE_MAP\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n",
              map_particle_pars_fragment: "#ifdef USE_MAP\n\tuniform mat3 uvTransform;\n\tuniform sampler2D map;\n#endif\n",
              metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n",
              metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
              morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n",
              morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif",
              morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n",
              normal_fragment_begin: "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n#endif\n",
              normal_fragment_maps: "#ifdef USE_NORMALMAP\n\t#ifdef OBJECTSPACE_NORMALMAP\n\t\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\t#ifdef FLIP_SIDED\n\t\t\tnormal = - normal;\n\t\t#endif\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\t#endif\n\t\tnormal = normalize( normalMatrix * normal );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n",
              normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\t#ifdef OBJECTSPACE_NORMALMAP\n\t\tuniform mat3 normalMatrix;\n\t#else\n\t\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\t\tvec2 st0 = dFdx( vUv.st );\n\t\t\tvec2 st1 = dFdy( vUv.st );\n\t\t\tfloat scale = sign( st1.t * st0.s - st0.t * st1.s );\n\t\t\tvec3 S = normalize( ( q0 * st1.t - q1 * st0.t ) * scale );\n\t\t\tvec3 T = normalize( ( - q0 * st1.s + q1 * st0.s ) * scale );\n\t\t\tvec3 N = normalize( surf_norm );\n\t\t\tmat3 tsn = mat3( S, T, N );\n\t\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\t\tmapN.xy *= normalScale;\n\t\t\tmapN.xy *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\t\treturn normalize( tsn * mapN );\n\t\t}\n\t#endif\n#endif\n",
              packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n",
              premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n",
              project_vertex: "vec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\ngl_Position = projectionMatrix * mvPosition;\n",
              dithering_fragment: "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n",
              dithering_pars_fragment: "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n",
              roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n",
              roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
              shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tshadow = (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n",
              shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n",
              shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n",
              shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\t#pragma unroll_loop\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n",
              skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
              skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n",
              skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif\n",
              skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n",
              specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
              specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
              tonemapping_fragment: "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n",
              tonemapping_pars_fragment: "#ifndef saturate\n\t#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n",
              uv_pars_fragment: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif",
              uv_pars_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\n",
              uv_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
              uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
              uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif",
              uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif",
              worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n#endif\n",
              cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n",
              cube_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}\n",
              depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n",
              depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n",
              distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}\n",
              distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}\n",
              equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n",
              equirect_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n",
              linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
              linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n",
              meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
              meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n",
              meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
              meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
              meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
              meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
              meshphysical_frag: "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
              meshphysical_vert: "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
              normal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || ( defined( USE_NORMALMAP ) && ! defined( OBJECTSPACE_NORMALMAP ) )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n",
              normal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || ( defined( USE_NORMALMAP ) && ! defined( OBJECTSPACE_NORMALMAP ) )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || ( defined( USE_NORMALMAP ) && ! defined( OBJECTSPACE_NORMALMAP ) )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n",
              points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
              points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}\n",
              shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <fog_fragment>\n}\n",
              shadow_vert: "#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
              sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
              sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tvec4 mvPosition;\n\tmvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n"
            },
            De = {
              merge: function merge(e) {
                for (var t = {}, n = 0; n < e.length; n++) {
                  var r = this.clone(e[n]);
                  for (var i in r) t[i] = r[i];
                }
                return t;
              },
              clone: function clone(e) {
                var t = {};
                for (var n in e) for (var r in t[n] = {}, e[n]) {
                  var i = e[n][r];
                  i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture) ? t[n][r] = i.clone() : Array.isArray(i) ? t[n][r] = i.slice() : t[n][r] = i;
                }
                return t;
              }
            },
            Be = {
              aliceblue: 15792383,
              antiquewhite: 16444375,
              aqua: 65535,
              aquamarine: 8388564,
              azure: 15794175,
              beige: 16119260,
              bisque: 16770244,
              black: 0,
              blanchedalmond: 16772045,
              blue: 255,
              blueviolet: 9055202,
              brown: 10824234,
              burlywood: 14596231,
              cadetblue: 6266528,
              chartreuse: 8388352,
              chocolate: 13789470,
              coral: 16744272,
              cornflowerblue: 6591981,
              cornsilk: 16775388,
              crimson: 14423100,
              cyan: 65535,
              darkblue: 139,
              darkcyan: 35723,
              darkgoldenrod: 12092939,
              darkgray: 11119017,
              darkgreen: 25600,
              darkgrey: 11119017,
              darkkhaki: 12433259,
              darkmagenta: 9109643,
              darkolivegreen: 5597999,
              darkorange: 16747520,
              darkorchid: 10040012,
              darkred: 9109504,
              darksalmon: 15308410,
              darkseagreen: 9419919,
              darkslateblue: 4734347,
              darkslategray: 3100495,
              darkslategrey: 3100495,
              darkturquoise: 52945,
              darkviolet: 9699539,
              deeppink: 16716947,
              deepskyblue: 49151,
              dimgray: 6908265,
              dimgrey: 6908265,
              dodgerblue: 2003199,
              firebrick: 11674146,
              floralwhite: 16775920,
              forestgreen: 2263842,
              fuchsia: 16711935,
              gainsboro: 14474460,
              ghostwhite: 16316671,
              gold: 16766720,
              goldenrod: 14329120,
              gray: 8421504,
              green: 32768,
              greenyellow: 11403055,
              grey: 8421504,
              honeydew: 15794160,
              hotpink: 16738740,
              indianred: 13458524,
              indigo: 4915330,
              ivory: 16777200,
              khaki: 15787660,
              lavender: 15132410,
              lavenderblush: 16773365,
              lawngreen: 8190976,
              lemonchiffon: 16775885,
              lightblue: 11393254,
              lightcoral: 15761536,
              lightcyan: 14745599,
              lightgoldenrodyellow: 16448210,
              lightgray: 13882323,
              lightgreen: 9498256,
              lightgrey: 13882323,
              lightpink: 16758465,
              lightsalmon: 16752762,
              lightseagreen: 2142890,
              lightskyblue: 8900346,
              lightslategray: 7833753,
              lightslategrey: 7833753,
              lightsteelblue: 11584734,
              lightyellow: 16777184,
              lime: 65280,
              limegreen: 3329330,
              linen: 16445670,
              magenta: 16711935,
              maroon: 8388608,
              mediumaquamarine: 6737322,
              mediumblue: 205,
              mediumorchid: 12211667,
              mediumpurple: 9662683,
              mediumseagreen: 3978097,
              mediumslateblue: 8087790,
              mediumspringgreen: 64154,
              mediumturquoise: 4772300,
              mediumvioletred: 13047173,
              midnightblue: 1644912,
              mintcream: 16121850,
              mistyrose: 16770273,
              moccasin: 16770229,
              navajowhite: 16768685,
              navy: 128,
              oldlace: 16643558,
              olive: 8421376,
              olivedrab: 7048739,
              orange: 16753920,
              orangered: 16729344,
              orchid: 14315734,
              palegoldenrod: 15657130,
              palegreen: 10025880,
              paleturquoise: 11529966,
              palevioletred: 14381203,
              papayawhip: 16773077,
              peachpuff: 16767673,
              peru: 13468991,
              pink: 16761035,
              plum: 14524637,
              powderblue: 11591910,
              purple: 8388736,
              rebeccapurple: 6697881,
              red: 16711680,
              rosybrown: 12357519,
              royalblue: 4286945,
              saddlebrown: 9127187,
              salmon: 16416882,
              sandybrown: 16032864,
              seagreen: 3050327,
              seashell: 16774638,
              sienna: 10506797,
              silver: 12632256,
              skyblue: 8900331,
              slateblue: 6970061,
              slategray: 7372944,
              slategrey: 7372944,
              snow: 16775930,
              springgreen: 65407,
              steelblue: 4620980,
              tan: 13808780,
              teal: 32896,
              thistle: 14204888,
              tomato: 16737095,
              turquoise: 4251856,
              violet: 15631086,
              wheat: 16113331,
              white: 16777215,
              whitesmoke: 16119285,
              yellow: 16776960,
              yellowgreen: 10145074
            };
          function Fe(e, t, n) {
            return void 0 === t && void 0 === n ? this.set(e) : this.setRGB(e, t, n);
          }
          Object.assign(Fe.prototype, {
            isColor: !0,
            r: 1,
            g: 1,
            b: 1,
            set: function set(e) {
              return e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e), this;
            },
            setScalar: function setScalar(e) {
              return this.r = e, this.g = e, this.b = e, this;
            },
            setHex: function setHex(e) {
              return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (255 & e) / 255, this;
            },
            setRGB: function setRGB(e, t, n) {
              return this.r = e, this.g = t, this.b = n, this;
            },
            setHSL: function () {
              function e(e, t, n) {
                return n < 0 && (n += 1), 1 < n && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + 6 * (t - e) * (2 / 3 - n) : e;
              }
              return function (t, n, r) {
                if (t = ne.euclideanModulo(t, 1), n = ne.clamp(n, 0, 1), r = ne.clamp(r, 0, 1), 0 === n) this.r = this.g = this.b = r;else {
                  var i = r <= .5 ? r * (1 + n) : r + n - r * n,
                    o = 2 * r - i;
                  this.r = e(o, i, t + 1 / 3), this.g = e(o, i, t), this.b = e(o, i, t - 1 / 3);
                }
                return this;
              };
            }(),
            setStyle: function setStyle(e) {
              function t(t) {
                void 0 !== t && parseFloat(t) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
              }
              var n;
              if (n = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec(e)) {
                var r,
                  i = n[1],
                  o = n[2];
                switch (i) {
                  case "rgb":
                  case "rgba":
                    if (r = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(o)) return this.r = Math.min(255, parseInt(r[1], 10)) / 255, this.g = Math.min(255, parseInt(r[2], 10)) / 255, this.b = Math.min(255, parseInt(r[3], 10)) / 255, t(r[5]), this;
                    if (r = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(o)) return this.r = Math.min(100, parseInt(r[1], 10)) / 100, this.g = Math.min(100, parseInt(r[2], 10)) / 100, this.b = Math.min(100, parseInt(r[3], 10)) / 100, t(r[5]), this;
                    break;
                  case "hsl":
                  case "hsla":
                    if (r = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(o)) {
                      var a = parseFloat(r[1]) / 360,
                        s = parseInt(r[2], 10) / 100,
                        l = parseInt(r[3], 10) / 100;
                      return t(r[5]), this.setHSL(a, s, l);
                    }
                }
              } else if (n = /^\#([A-Fa-f0-9]+)$/.exec(e)) {
                var u,
                  c = (u = n[1]).length;
                if (3 === c) return this.r = parseInt(u.charAt(0) + u.charAt(0), 16) / 255, this.g = parseInt(u.charAt(1) + u.charAt(1), 16) / 255, this.b = parseInt(u.charAt(2) + u.charAt(2), 16) / 255, this;
                if (6 === c) return this.r = parseInt(u.charAt(0) + u.charAt(1), 16) / 255, this.g = parseInt(u.charAt(2) + u.charAt(3), 16) / 255, this.b = parseInt(u.charAt(4) + u.charAt(5), 16) / 255, this;
              }
              return e && 0 < e.length && (void 0 !== (u = Be[e]) ? this.setHex(u) : console.warn("THREE.Color: Unknown color " + e)), this;
            },
            clone: function clone() {
              return new this.constructor(this.r, this.g, this.b);
            },
            copy: function copy(e) {
              return this.r = e.r, this.g = e.g, this.b = e.b, this;
            },
            copyGammaToLinear: function copyGammaToLinear(e, t) {
              return void 0 === t && (t = 2), this.r = Math.pow(e.r, t), this.g = Math.pow(e.g, t), this.b = Math.pow(e.b, t), this;
            },
            copyLinearToGamma: function copyLinearToGamma(e, t) {
              void 0 === t && (t = 2);
              var n = 0 < t ? 1 / t : 1;
              return this.r = Math.pow(e.r, n), this.g = Math.pow(e.g, n), this.b = Math.pow(e.b, n), this;
            },
            convertGammaToLinear: function convertGammaToLinear(e) {
              return this.copyGammaToLinear(this, e), this;
            },
            convertLinearToGamma: function convertLinearToGamma(e) {
              return this.copyLinearToGamma(this, e), this;
            },
            copySRGBToLinear: function () {
              function e(e) {
                return e < .04045 ? .0773993808 * e : Math.pow(.9478672986 * e + .0521327014, 2.4);
              }
              return function (t) {
                return this.r = e(t.r), this.g = e(t.g), this.b = e(t.b), this;
              };
            }(),
            copyLinearToSRGB: function () {
              function e(e) {
                return e < .0031308 ? 12.92 * e : 1.055 * Math.pow(e, .41666) - .055;
              }
              return function (t) {
                return this.r = e(t.r), this.g = e(t.g), this.b = e(t.b), this;
              };
            }(),
            convertSRGBToLinear: function convertSRGBToLinear() {
              return this.copySRGBToLinear(this), this;
            },
            convertLinearToSRGB: function convertLinearToSRGB() {
              return this.copyLinearToSRGB(this), this;
            },
            getHex: function getHex() {
              return 255 * this.r << 16 ^ 255 * this.g << 8 ^ 255 * this.b << 0;
            },
            getHexString: function getHexString() {
              return ("000000" + this.getHex().toString(16)).slice(-6);
            },
            getHSL: function getHSL(e) {
              void 0 === e && (console.warn("THREE.Color: .getHSL() target is now required"), e = {
                h: 0,
                s: 0,
                l: 0
              });
              var t,
                n,
                r = this.r,
                i = this.g,
                o = this.b,
                a = Math.max(r, i, o),
                s = Math.min(r, i, o),
                l = (s + a) / 2;
              if (s === a) n = t = 0;else {
                var u = a - s;
                switch (n = l <= .5 ? u / (a + s) : u / (2 - a - s), a) {
                  case r:
                    t = (i - o) / u + (i < o ? 6 : 0);
                    break;
                  case i:
                    t = (o - r) / u + 2;
                    break;
                  case o:
                    t = (r - i) / u + 4;
                }
                t /= 6;
              }
              return e.h = t, e.s = n, e.l = l, e;
            },
            getStyle: function getStyle() {
              return "rgb(" + (255 * this.r | 0) + "," + (255 * this.g | 0) + "," + (255 * this.b | 0) + ")";
            },
            offsetHSL: (Ne = {}, function (e, t, n) {
              return this.getHSL(Ne), Ne.h += e, Ne.s += t, Ne.l += n, this.setHSL(Ne.h, Ne.s, Ne.l), this;
            }),
            add: function add(e) {
              return this.r += e.r, this.g += e.g, this.b += e.b, this;
            },
            addColors: function addColors(e, t) {
              return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
            },
            addScalar: function addScalar(e) {
              return this.r += e, this.g += e, this.b += e, this;
            },
            sub: function sub(e) {
              return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
            },
            multiply: function multiply(e) {
              return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
            },
            multiplyScalar: function multiplyScalar(e) {
              return this.r *= e, this.g *= e, this.b *= e, this;
            },
            lerp: function lerp(e, t) {
              return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
            },
            equals: function equals(e) {
              return e.r === this.r && e.g === this.g && e.b === this.b;
            },
            fromArray: function fromArray(e, t) {
              return void 0 === t && (t = 0), this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
            },
            toArray: function toArray(e, t) {
              return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
            },
            toJSON: function toJSON() {
              return this.getHex();
            }
          });
          var ze,
            Ue,
            Ge = {
              common: {
                diffuse: {
                  value: new Fe(15658734)
                },
                opacity: {
                  value: 1
                },
                map: {
                  value: null
                },
                uvTransform: {
                  value: new se()
                },
                alphaMap: {
                  value: null
                }
              },
              specularmap: {
                specularMap: {
                  value: null
                }
              },
              envmap: {
                envMap: {
                  value: null
                },
                flipEnvMap: {
                  value: -1
                },
                reflectivity: {
                  value: 1
                },
                refractionRatio: {
                  value: .98
                },
                maxMipLevel: {
                  value: 0
                }
              },
              aomap: {
                aoMap: {
                  value: null
                },
                aoMapIntensity: {
                  value: 1
                }
              },
              lightmap: {
                lightMap: {
                  value: null
                },
                lightMapIntensity: {
                  value: 1
                }
              },
              emissivemap: {
                emissiveMap: {
                  value: null
                }
              },
              bumpmap: {
                bumpMap: {
                  value: null
                },
                bumpScale: {
                  value: 1
                }
              },
              normalmap: {
                normalMap: {
                  value: null
                },
                normalScale: {
                  value: new re(1, 1)
                }
              },
              displacementmap: {
                displacementMap: {
                  value: null
                },
                displacementScale: {
                  value: 1
                },
                displacementBias: {
                  value: 0
                }
              },
              roughnessmap: {
                roughnessMap: {
                  value: null
                }
              },
              metalnessmap: {
                metalnessMap: {
                  value: null
                }
              },
              gradientmap: {
                gradientMap: {
                  value: null
                }
              },
              fog: {
                fogDensity: {
                  value: 25e-5
                },
                fogNear: {
                  value: 1
                },
                fogFar: {
                  value: 2e3
                },
                fogColor: {
                  value: new Fe(16777215)
                }
              },
              lights: {
                ambientLightColor: {
                  value: []
                },
                directionalLights: {
                  value: [],
                  properties: {
                    direction: {},
                    color: {},
                    shadow: {},
                    shadowBias: {},
                    shadowRadius: {},
                    shadowMapSize: {}
                  }
                },
                directionalShadowMap: {
                  value: []
                },
                directionalShadowMatrix: {
                  value: []
                },
                spotLights: {
                  value: [],
                  properties: {
                    color: {},
                    position: {},
                    direction: {},
                    distance: {},
                    coneCos: {},
                    penumbraCos: {},
                    decay: {},
                    shadow: {},
                    shadowBias: {},
                    shadowRadius: {},
                    shadowMapSize: {}
                  }
                },
                spotShadowMap: {
                  value: []
                },
                spotShadowMatrix: {
                  value: []
                },
                pointLights: {
                  value: [],
                  properties: {
                    color: {},
                    position: {},
                    decay: {},
                    distance: {},
                    shadow: {},
                    shadowBias: {},
                    shadowRadius: {},
                    shadowMapSize: {},
                    shadowCameraNear: {},
                    shadowCameraFar: {}
                  }
                },
                pointShadowMap: {
                  value: []
                },
                pointShadowMatrix: {
                  value: []
                },
                hemisphereLights: {
                  value: [],
                  properties: {
                    direction: {},
                    skyColor: {},
                    groundColor: {}
                  }
                },
                rectAreaLights: {
                  value: [],
                  properties: {
                    color: {},
                    position: {},
                    width: {},
                    height: {}
                  }
                }
              },
              points: {
                diffuse: {
                  value: new Fe(15658734)
                },
                opacity: {
                  value: 1
                },
                size: {
                  value: 1
                },
                scale: {
                  value: 1
                },
                map: {
                  value: null
                },
                uvTransform: {
                  value: new se()
                }
              },
              sprite: {
                diffuse: {
                  value: new Fe(15658734)
                },
                opacity: {
                  value: 1
                },
                center: {
                  value: new re(.5, .5)
                },
                rotation: {
                  value: 0
                },
                map: {
                  value: null
                },
                uvTransform: {
                  value: new se()
                }
              }
            },
            Ve = {
              basic: {
                uniforms: De.merge([Ge.common, Ge.specularmap, Ge.envmap, Ge.aomap, Ge.lightmap, Ge.fog]),
                vertexShader: Le.meshbasic_vert,
                fragmentShader: Le.meshbasic_frag
              },
              lambert: {
                uniforms: De.merge([Ge.common, Ge.specularmap, Ge.envmap, Ge.aomap, Ge.lightmap, Ge.emissivemap, Ge.fog, Ge.lights, {
                  emissive: {
                    value: new Fe(0)
                  }
                }]),
                vertexShader: Le.meshlambert_vert,
                fragmentShader: Le.meshlambert_frag
              },
              phong: {
                uniforms: De.merge([Ge.common, Ge.specularmap, Ge.envmap, Ge.aomap, Ge.lightmap, Ge.emissivemap, Ge.bumpmap, Ge.normalmap, Ge.displacementmap, Ge.gradientmap, Ge.fog, Ge.lights, {
                  emissive: {
                    value: new Fe(0)
                  },
                  specular: {
                    value: new Fe(1118481)
                  },
                  shininess: {
                    value: 30
                  }
                }]),
                vertexShader: Le.meshphong_vert,
                fragmentShader: Le.meshphong_frag
              },
              standard: {
                uniforms: De.merge([Ge.common, Ge.envmap, Ge.aomap, Ge.lightmap, Ge.emissivemap, Ge.bumpmap, Ge.normalmap, Ge.displacementmap, Ge.roughnessmap, Ge.metalnessmap, Ge.fog, Ge.lights, {
                  emissive: {
                    value: new Fe(0)
                  },
                  roughness: {
                    value: .5
                  },
                  metalness: {
                    value: .5
                  },
                  envMapIntensity: {
                    value: 1
                  }
                }]),
                vertexShader: Le.meshphysical_vert,
                fragmentShader: Le.meshphysical_frag
              },
              points: {
                uniforms: De.merge([Ge.points, Ge.fog]),
                vertexShader: Le.points_vert,
                fragmentShader: Le.points_frag
              },
              dashed: {
                uniforms: De.merge([Ge.common, Ge.fog, {
                  scale: {
                    value: 1
                  },
                  dashSize: {
                    value: 1
                  },
                  totalSize: {
                    value: 2
                  }
                }]),
                vertexShader: Le.linedashed_vert,
                fragmentShader: Le.linedashed_frag
              },
              depth: {
                uniforms: De.merge([Ge.common, Ge.displacementmap]),
                vertexShader: Le.depth_vert,
                fragmentShader: Le.depth_frag
              },
              normal: {
                uniforms: De.merge([Ge.common, Ge.bumpmap, Ge.normalmap, Ge.displacementmap, {
                  opacity: {
                    value: 1
                  }
                }]),
                vertexShader: Le.normal_vert,
                fragmentShader: Le.normal_frag
              },
              sprite: {
                uniforms: De.merge([Ge.sprite, Ge.fog]),
                vertexShader: Le.sprite_vert,
                fragmentShader: Le.sprite_frag
              },
              cube: {
                uniforms: {
                  tCube: {
                    value: null
                  },
                  tFlip: {
                    value: -1
                  },
                  opacity: {
                    value: 1
                  }
                },
                vertexShader: Le.cube_vert,
                fragmentShader: Le.cube_frag
              },
              equirect: {
                uniforms: {
                  tEquirect: {
                    value: null
                  }
                },
                vertexShader: Le.equirect_vert,
                fragmentShader: Le.equirect_frag
              },
              distanceRGBA: {
                uniforms: De.merge([Ge.common, Ge.displacementmap, {
                  referencePosition: {
                    value: new ae()
                  },
                  nearDistance: {
                    value: 1
                  },
                  farDistance: {
                    value: 1e3
                  }
                }]),
                vertexShader: Le.distanceRGBA_vert,
                fragmentShader: Le.distanceRGBA_frag
              },
              shadow: {
                uniforms: De.merge([Ge.lights, Ge.fog, {
                  color: {
                    value: new Fe(0)
                  },
                  opacity: {
                    value: 1
                  }
                }]),
                vertexShader: Le.shadow_vert,
                fragmentShader: Le.shadow_frag
              }
            };
          function He() {
            var e = null,
              t = !1,
              n = null;
            function r(i, o) {
              !1 !== t && (n(i, o), e.requestAnimationFrame(r));
            }
            return {
              start: function start() {
                !0 !== t && null !== n && (e.requestAnimationFrame(r), t = !0);
              },
              stop: function stop() {
                t = !1;
              },
              setAnimationLoop: function setAnimationLoop(e) {
                n = e;
              },
              setContext: function setContext(t) {
                e = t;
              }
            };
          }
          function qe(e) {
            var t = new WeakMap();
            return {
              get: function get(e) {
                return e.isInterleavedBufferAttribute && (e = e.data), t.get(e);
              },
              remove: function remove(n) {
                n.isInterleavedBufferAttribute && (n = n.data);
                var r = t.get(n);
                r && (e.deleteBuffer(r.buffer), t.delete(n));
              },
              update: function update(n, r) {
                n.isInterleavedBufferAttribute && (n = n.data);
                var i,
                  o,
                  a,
                  s,
                  l,
                  u = t.get(n);
                void 0 === u ? t.set(n, function (t, n) {
                  var r = t.array,
                    i = t.dynamic ? e.DYNAMIC_DRAW : e.STATIC_DRAW,
                    o = e.createBuffer();
                  e.bindBuffer(n, o), e.bufferData(n, r, i), t.onUploadCallback();
                  var a = e.FLOAT;
                  return r instanceof Float32Array ? a = e.FLOAT : r instanceof Float64Array ? console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.") : r instanceof Uint16Array ? a = e.UNSIGNED_SHORT : r instanceof Int16Array ? a = e.SHORT : r instanceof Uint32Array ? a = e.UNSIGNED_INT : r instanceof Int32Array ? a = e.INT : r instanceof Int8Array ? a = e.BYTE : r instanceof Uint8Array && (a = e.UNSIGNED_BYTE), {
                    buffer: o,
                    type: a,
                    bytesPerElement: r.BYTES_PER_ELEMENT,
                    version: t.version
                  };
                }(n, r)) : u.version < n.version && (i = u.buffer, a = r, s = (o = n).array, l = o.updateRange, e.bindBuffer(a, i), !1 === o.dynamic ? e.bufferData(a, s, e.STATIC_DRAW) : -1 === l.count ? e.bufferSubData(a, 0, s) : 0 === l.count ? console.error("THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.") : (e.bufferSubData(a, l.offset * s.BYTES_PER_ELEMENT, s.subarray(l.offset, l.offset + l.count)), l.count = -1), u.version = n.version);
              }
            };
          }
          function We(e, t, n, r) {
            this._x = e || 0, this._y = t || 0, this._z = n || 0, this._order = r || We.DefaultOrder;
          }
          function $e() {
            this.mask = 1;
          }
          Ve.physical = {
            uniforms: De.merge([Ve.standard.uniforms, {
              clearCoat: {
                value: 0
              },
              clearCoatRoughness: {
                value: 0
              }
            }]),
            vertexShader: Le.meshphysical_vert,
            fragmentShader: Le.meshphysical_frag
          }, We.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"], We.DefaultOrder = "XYZ", Object.defineProperties(We.prototype, {
            x: {
              get: function get() {
                return this._x;
              },
              set: function set(e) {
                this._x = e, this.onChangeCallback();
              }
            },
            y: {
              get: function get() {
                return this._y;
              },
              set: function set(e) {
                this._y = e, this.onChangeCallback();
              }
            },
            z: {
              get: function get() {
                return this._z;
              },
              set: function set(e) {
                this._z = e, this.onChangeCallback();
              }
            },
            order: {
              get: function get() {
                return this._order;
              },
              set: function set(e) {
                this._order = e, this.onChangeCallback();
              }
            }
          }), Object.assign(We.prototype, {
            isEuler: !0,
            set: function set(e, t, n, r) {
              return this._x = e, this._y = t, this._z = n, this._order = r || this._order, this.onChangeCallback(), this;
            },
            clone: function clone() {
              return new this.constructor(this._x, this._y, this._z, this._order);
            },
            copy: function copy(e) {
              return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this.onChangeCallback(), this;
            },
            setFromRotationMatrix: function setFromRotationMatrix(e, t, n) {
              var r = ne.clamp,
                i = e.elements,
                o = i[0],
                a = i[4],
                s = i[8],
                l = i[1],
                u = i[5],
                c = i[9],
                d = i[2],
                h = i[6],
                f = i[10];
              return "XYZ" === (t = t || this._order) ? (this._y = Math.asin(r(s, -1, 1)), Math.abs(s) < .99999 ? (this._x = Math.atan2(-c, f), this._z = Math.atan2(-a, o)) : (this._x = Math.atan2(h, u), this._z = 0)) : "YXZ" === t ? (this._x = Math.asin(-r(c, -1, 1)), Math.abs(c) < .99999 ? (this._y = Math.atan2(s, f), this._z = Math.atan2(l, u)) : (this._y = Math.atan2(-d, o), this._z = 0)) : "ZXY" === t ? (this._x = Math.asin(r(h, -1, 1)), Math.abs(h) < .99999 ? (this._y = Math.atan2(-d, f), this._z = Math.atan2(-a, u)) : (this._y = 0, this._z = Math.atan2(l, o))) : "ZYX" === t ? (this._y = Math.asin(-r(d, -1, 1)), Math.abs(d) < .99999 ? (this._x = Math.atan2(h, f), this._z = Math.atan2(l, o)) : (this._x = 0, this._z = Math.atan2(-a, u))) : "YZX" === t ? (this._z = Math.asin(r(l, -1, 1)), Math.abs(l) < .99999 ? (this._x = Math.atan2(-c, u), this._y = Math.atan2(-d, o)) : (this._x = 0, this._y = Math.atan2(s, f))) : "XZY" === t ? (this._z = Math.asin(-r(a, -1, 1)), Math.abs(a) < .99999 ? (this._x = Math.atan2(h, u), this._y = Math.atan2(s, o)) : (this._x = Math.atan2(-c, f), this._y = 0)) : console.warn("THREE.Euler: .setFromRotationMatrix() given unsupported order: " + t), this._order = t, !1 !== n && this.onChangeCallback(), this;
            },
            setFromQuaternion: (Ue = new ie(), function (e, t, n) {
              return Ue.makeRotationFromQuaternion(e), this.setFromRotationMatrix(Ue, t, n);
            }),
            setFromVector3: function setFromVector3(e, t) {
              return this.set(e.x, e.y, e.z, t || this._order);
            },
            reorder: (ze = new oe(), function (e) {
              return ze.setFromEuler(this), this.setFromQuaternion(ze, e);
            }),
            equals: function equals(e) {
              return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
            },
            fromArray: function fromArray(e) {
              return this._x = e[0], this._y = e[1], this._z = e[2], void 0 !== e[3] && (this._order = e[3]), this.onChangeCallback(), this;
            },
            toArray: function toArray(e, t) {
              return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
            },
            toVector3: function toVector3(e) {
              return e ? e.set(this._x, this._y, this._z) : new ae(this._x, this._y, this._z);
            },
            onChange: function onChange(e) {
              return this.onChangeCallback = e, this;
            },
            onChangeCallback: function onChangeCallback() {}
          }), Object.assign($e.prototype, {
            set: function set(e) {
              this.mask = 1 << e | 0;
            },
            enable: function enable(e) {
              this.mask |= 1 << e | 0;
            },
            toggle: function toggle(e) {
              this.mask ^= 1 << e | 0;
            },
            disable: function disable(e) {
              this.mask &= ~(1 << e | 0);
            },
            test: function test(e) {
              return 0 != (this.mask & e.mask);
            }
          });
          var Xe,
            Ye,
            Ke,
            Ze,
            Qe,
            Je,
            et,
            tt,
            nt,
            rt,
            it,
            ot,
            at,
            st,
            lt,
            ut,
            ct,
            dt,
            ht = 0;
          function ft() {
            Object.defineProperty(this, "id", {
              value: ht++
            }), this.uuid = ne.generateUUID(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = ft.DefaultUp.clone();
            var e = new ae(),
              t = new We(),
              n = new oe(),
              r = new ae(1, 1, 1);
            t.onChange(function () {
              n.setFromEuler(t, !1);
            }), n.onChange(function () {
              t.setFromQuaternion(n, void 0, !1);
            }), Object.defineProperties(this, {
              position: {
                enumerable: !0,
                value: e
              },
              rotation: {
                enumerable: !0,
                value: t
              },
              quaternion: {
                enumerable: !0,
                value: n
              },
              scale: {
                enumerable: !0,
                value: r
              },
              modelViewMatrix: {
                value: new ie()
              },
              normalMatrix: {
                value: new se()
              }
            }), this.matrix = new ie(), this.matrixWorld = new ie(), this.matrixAutoUpdate = ft.DefaultMatrixAutoUpdate, this.matrixWorldNeedsUpdate = !1, this.layers = new $e(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.userData = {};
          }
          function pt() {
            ft.call(this), this.type = "Camera", this.matrixWorldInverse = new ie(), this.projectionMatrix = new ie();
          }
          function mt(e, t, n, r, i, o) {
            pt.call(this), this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = n, this.bottom = r, this.near = void 0 !== i ? i : .1, this.far = void 0 !== o ? o : 2e3, this.updateProjectionMatrix();
          }
          function gt(e, t, n, r, i, o) {
            this.a = e, this.b = t, this.c = n, this.normal = r && r.isVector3 ? r : new ae(), this.vertexNormals = Array.isArray(r) ? r : [], this.color = i && i.isColor ? i : new Fe(), this.vertexColors = Array.isArray(i) ? i : [], this.materialIndex = void 0 !== o ? o : 0;
          }
          ft.DefaultUp = new ae(0, 1, 0), ft.DefaultMatrixAutoUpdate = !0, ft.prototype = Object.assign(Object.create(_.prototype), {
            constructor: ft,
            isObject3D: !0,
            onBeforeRender: function onBeforeRender() {},
            onAfterRender: function onAfterRender() {},
            applyMatrix: function applyMatrix(e) {
              this.matrix.multiplyMatrices(e, this.matrix), this.matrix.decompose(this.position, this.quaternion, this.scale);
            },
            applyQuaternion: function applyQuaternion(e) {
              return this.quaternion.premultiply(e), this;
            },
            setRotationFromAxisAngle: function setRotationFromAxisAngle(e, t) {
              this.quaternion.setFromAxisAngle(e, t);
            },
            setRotationFromEuler: function setRotationFromEuler(e) {
              this.quaternion.setFromEuler(e, !0);
            },
            setRotationFromMatrix: function setRotationFromMatrix(e) {
              this.quaternion.setFromRotationMatrix(e);
            },
            setRotationFromQuaternion: function setRotationFromQuaternion(e) {
              this.quaternion.copy(e);
            },
            rotateOnAxis: (ct = new oe(), function (e, t) {
              return ct.setFromAxisAngle(e, t), this.quaternion.multiply(ct), this;
            }),
            rotateOnWorldAxis: (ut = new oe(), function (e, t) {
              return ut.setFromAxisAngle(e, t), this.quaternion.premultiply(ut), this;
            }),
            rotateX: (lt = new ae(1, 0, 0), function (e) {
              return this.rotateOnAxis(lt, e);
            }),
            rotateY: (st = new ae(0, 1, 0), function (e) {
              return this.rotateOnAxis(st, e);
            }),
            rotateZ: (at = new ae(0, 0, 1), function (e) {
              return this.rotateOnAxis(at, e);
            }),
            translateOnAxis: (ot = new ae(), function (e, t) {
              return ot.copy(e).applyQuaternion(this.quaternion), this.position.add(ot.multiplyScalar(t)), this;
            }),
            translateX: (it = new ae(1, 0, 0), function (e) {
              return this.translateOnAxis(it, e);
            }),
            translateY: (rt = new ae(0, 1, 0), function (e) {
              return this.translateOnAxis(rt, e);
            }),
            translateZ: (nt = new ae(0, 0, 1), function (e) {
              return this.translateOnAxis(nt, e);
            }),
            localToWorld: function localToWorld(e) {
              return e.applyMatrix4(this.matrixWorld);
            },
            worldToLocal: (tt = new ie(), function (e) {
              return e.applyMatrix4(tt.getInverse(this.matrixWorld));
            }),
            lookAt: (Je = new ie(), et = new ae(), function (e, t, n) {
              e.isVector3 ? et.copy(e) : et.set(e, t, n), this.isCamera ? Je.lookAt(this.position, et, this.up) : Je.lookAt(et, this.position, this.up), this.quaternion.setFromRotationMatrix(Je);
            }),
            add: function add(e) {
              var t = arguments;
              if (1 < arguments.length) {
                for (var n = 0; n < arguments.length; n++) this.add(t[n]);
                return this;
              }
              return e === this ? console.error("THREE.Object3D.add: object can't be added as a child of itself.", e) : e && e.isObject3D ? (null !== e.parent && e.parent.remove(e), e.parent = this, e.dispatchEvent({
                type: "added"
              }), this.children.push(e)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this;
            },
            remove: function remove(e) {
              var t = arguments;
              if (1 < arguments.length) {
                for (var n = 0; n < arguments.length; n++) this.remove(t[n]);
                return this;
              }
              var r = this.children.indexOf(e);
              return -1 !== r && (e.parent = null, e.dispatchEvent({
                type: "removed"
              }), this.children.splice(r, 1)), this;
            },
            getObjectById: function getObjectById(e) {
              return this.getObjectByProperty("id", e);
            },
            getObjectByName: function getObjectByName(e) {
              return this.getObjectByProperty("name", e);
            },
            getObjectByProperty: function getObjectByProperty(e, t) {
              if (this[e] === t) return this;
              for (var n = 0, r = this.children.length; n < r; n++) {
                var i = this.children[n].getObjectByProperty(e, t);
                if (void 0 !== i) return i;
              }
            },
            getWorldPosition: function getWorldPosition(e) {
              return void 0 === e && (console.warn("THREE.Object3D: .getWorldPosition() target is now required"), e = new ae()), this.updateMatrixWorld(!0), e.setFromMatrixPosition(this.matrixWorld);
            },
            getWorldQuaternion: (Ze = new ae(), Qe = new ae(), function (e) {
              return void 0 === e && (console.warn("THREE.Object3D: .getWorldQuaternion() target is now required"), e = new oe()), this.updateMatrixWorld(!0), this.matrixWorld.decompose(Ze, e, Qe), e;
            }),
            getWorldScale: (Ye = new ae(), Ke = new oe(), function (e) {
              return void 0 === e && (console.warn("THREE.Object3D: .getWorldScale() target is now required"), e = new ae()), this.updateMatrixWorld(!0), this.matrixWorld.decompose(Ye, Ke, e), e;
            }),
            getWorldDirection: (Xe = new oe(), function (e) {
              return void 0 === e && (console.warn("THREE.Object3D: .getWorldDirection() target is now required"), e = new ae()), this.getWorldQuaternion(Xe), e.set(0, 0, 1).applyQuaternion(Xe);
            }),
            raycast: function raycast() {},
            traverse: function traverse(e) {
              e(this);
              for (var t = this.children, n = 0, r = t.length; n < r; n++) t[n].traverse(e);
            },
            traverseVisible: function traverseVisible(e) {
              if (!1 !== this.visible) {
                e(this);
                for (var t = this.children, n = 0, r = t.length; n < r; n++) t[n].traverseVisible(e);
              }
            },
            traverseAncestors: function traverseAncestors(e) {
              var t = this.parent;
              null !== t && (e(t), t.traverseAncestors(e));
            },
            updateMatrix: function updateMatrix() {
              this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
            },
            updateMatrixWorld: function updateMatrixWorld(e) {
              this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), e = !(this.matrixWorldNeedsUpdate = !1));
              for (var t = this.children, n = 0, r = t.length; n < r; n++) t[n].updateMatrixWorld(e);
            },
            toJSON: function toJSON(e) {
              var t = void 0 === e || "string" == typeof e,
                n = {};
              t && (e = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {}
              }, n.metadata = {
                version: 4.5,
                type: "Object",
                generator: "Object3D.toJSON"
              });
              var r = {};
              function i(t, n) {
                return void 0 === t[n.uuid] && (t[n.uuid] = n.toJSON(e)), n.uuid;
              }
              if (r.uuid = this.uuid, r.type = this.type, "" !== this.name && (r.name = this.name), !0 === this.castShadow && (r.castShadow = !0), !0 === this.receiveShadow && (r.receiveShadow = !0), !1 === this.visible && (r.visible = !1), !1 === this.frustumCulled && (r.frustumCulled = !1), 0 !== this.renderOrder && (r.renderOrder = this.renderOrder), "{}" !== JSON.stringify(this.userData) && (r.userData = this.userData), r.layers = this.layers.mask, r.matrix = this.matrix.toArray(), !1 === this.matrixAutoUpdate && (r.matrixAutoUpdate = !1), this.isMesh || this.isLine || this.isPoints) {
                r.geometry = i(e.geometries, this.geometry);
                var o = this.geometry.parameters;
                if (void 0 !== o && void 0 !== o.shapes) {
                  var a = o.shapes;
                  if (Array.isArray(a)) for (var s = 0, l = a.length; s < l; s++) {
                    var u = a[s];
                    i(e.shapes, u);
                  } else i(e.shapes, a);
                }
              }
              if (void 0 !== this.material) if (Array.isArray(this.material)) {
                var c = [];
                for (s = 0, l = this.material.length; s < l; s++) c.push(i(e.materials, this.material[s]));
                r.material = c;
              } else r.material = i(e.materials, this.material);
              if (0 < this.children.length) for (r.children = [], s = 0; s < this.children.length; s++) r.children.push(this.children[s].toJSON(e).object);
              if (t) {
                var d = m(e.geometries),
                  h = m(e.materials),
                  f = m(e.textures),
                  p = m(e.images);
                a = m(e.shapes), 0 < d.length && (n.geometries = d), 0 < h.length && (n.materials = h), 0 < f.length && (n.textures = f), 0 < p.length && (n.images = p), 0 < a.length && (n.shapes = a);
              }
              return n.object = r, n;
              function m(e) {
                var t = [];
                for (var n in e) {
                  var r = e[n];
                  delete r.metadata, t.push(r);
                }
                return t;
              }
            },
            clone: function clone(e) {
              return new this.constructor().copy(this, e);
            },
            copy: function copy(e, t) {
              if (void 0 === t && (t = !0), this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.userData = JSON.parse(JSON.stringify(e.userData)), !0 === t) for (var n = 0; n < e.children.length; n++) {
                var r = e.children[n];
                this.add(r.clone());
              }
              return this;
            }
          }), pt.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: pt,
            isCamera: !0,
            copy: function copy(e, t) {
              return ft.prototype.copy.call(this, e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this;
            },
            getWorldDirection: (dt = new oe(), function (e) {
              return void 0 === e && (console.warn("THREE.Camera: .getWorldDirection() target is now required"), e = new ae()), this.getWorldQuaternion(dt), e.set(0, 0, -1).applyQuaternion(dt);
            }),
            updateMatrixWorld: function updateMatrixWorld(e) {
              ft.prototype.updateMatrixWorld.call(this, e), this.matrixWorldInverse.getInverse(this.matrixWorld);
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            }
          }), mt.prototype = Object.assign(Object.create(pt.prototype), {
            constructor: mt,
            isOrthographicCamera: !0,
            copy: function copy(e, t) {
              return pt.prototype.copy.call(this, e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = null === e.view ? null : Object.assign({}, e.view), this;
            },
            setViewOffset: function setViewOffset(e, t, n, r, i, o) {
              null === this.view && (this.view = {
                enabled: !0,
                fullWidth: 1,
                fullHeight: 1,
                offsetX: 0,
                offsetY: 0,
                width: 1,
                height: 1
              }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = r, this.view.width = i, this.view.height = o, this.updateProjectionMatrix();
            },
            clearViewOffset: function clearViewOffset() {
              null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            },
            updateProjectionMatrix: function updateProjectionMatrix() {
              var e = (this.right - this.left) / (2 * this.zoom),
                t = (this.top - this.bottom) / (2 * this.zoom),
                n = (this.right + this.left) / 2,
                r = (this.top + this.bottom) / 2,
                i = n - e,
                o = n + e,
                a = r + t,
                s = r - t;
              if (null !== this.view && this.view.enabled) {
                var l = this.zoom / (this.view.width / this.view.fullWidth),
                  u = this.zoom / (this.view.height / this.view.fullHeight),
                  c = (this.right - this.left) / this.view.width,
                  d = (this.top - this.bottom) / this.view.height;
                o = (i += c * (this.view.offsetX / l)) + c * (this.view.width / l), s = (a -= d * (this.view.offsetY / u)) - d * (this.view.height / u);
              }
              this.projectionMatrix.makeOrthographic(i, o, a, s, this.near, this.far);
            },
            toJSON: function toJSON(e) {
              var t = ft.prototype.toJSON.call(this, e);
              return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, null !== this.view && (t.object.view = Object.assign({}, this.view)), t;
            }
          }), Object.assign(gt.prototype, {
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              this.a = e.a, this.b = e.b, this.c = e.c, this.normal.copy(e.normal), this.color.copy(e.color), this.materialIndex = e.materialIndex;
              for (var t = 0, n = e.vertexNormals.length; t < n; t++) this.vertexNormals[t] = e.vertexNormals[t].clone();
              for (t = 0, n = e.vertexColors.length; t < n; t++) this.vertexColors[t] = e.vertexColors[t].clone();
              return this;
            }
          });
          var vt,
            yt,
            bt,
            _t,
            xt,
            wt,
            St,
            At = 0;
          function Et() {
            Object.defineProperty(this, "id", {
              value: At += 2
            }), this.uuid = ne.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [[]], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
          }
          function Tt(e, t, n) {
            if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
            this.name = "", this.array = e, this.itemSize = t, this.count = void 0 !== e ? e.length / t : 0, this.normalized = !0 === n, this.dynamic = !1, this.updateRange = {
              offset: 0,
              count: -1
            }, this.version = 0;
          }
          function Mt(e, t, n) {
            Tt.call(this, new Int8Array(e), t, n);
          }
          function Ct(e, t, n) {
            Tt.call(this, new Uint8Array(e), t, n);
          }
          function kt(e, t, n) {
            Tt.call(this, new Uint8ClampedArray(e), t, n);
          }
          function Pt(e, t, n) {
            Tt.call(this, new Int16Array(e), t, n);
          }
          function Ot(e, t, n) {
            Tt.call(this, new Uint16Array(e), t, n);
          }
          function Rt(e, t, n) {
            Tt.call(this, new Int32Array(e), t, n);
          }
          function It(e, t, n) {
            Tt.call(this, new Uint32Array(e), t, n);
          }
          function jt(e, t, n) {
            Tt.call(this, new Float32Array(e), t, n);
          }
          function Nt(e, t, n) {
            Tt.call(this, new Float64Array(e), t, n);
          }
          function Lt() {
            this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
          }
          function Dt(e) {
            if (0 === e.length) return -1 / 0;
            for (var t = e[0], n = 1, r = e.length; n < r; ++n) e[n] > t && (t = e[n]);
            return t;
          }
          Et.prototype = Object.assign(Object.create(_.prototype), {
            constructor: Et,
            isGeometry: !0,
            applyMatrix: function applyMatrix(e) {
              for (var t = new se().getNormalMatrix(e), n = 0, r = this.vertices.length; n < r; n++) this.vertices[n].applyMatrix4(e);
              for (n = 0, r = this.faces.length; n < r; n++) {
                var i = this.faces[n];
                i.normal.applyMatrix3(t).normalize();
                for (var o = 0, a = i.vertexNormals.length; o < a; o++) i.vertexNormals[o].applyMatrix3(t).normalize();
              }
              return null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
            },
            rotateX: (St = new ie(), function (e) {
              return St.makeRotationX(e), this.applyMatrix(St), this;
            }),
            rotateY: (wt = new ie(), function (e) {
              return wt.makeRotationY(e), this.applyMatrix(wt), this;
            }),
            rotateZ: (xt = new ie(), function (e) {
              return xt.makeRotationZ(e), this.applyMatrix(xt), this;
            }),
            translate: (_t = new ie(), function (e, t, n) {
              return _t.makeTranslation(e, t, n), this.applyMatrix(_t), this;
            }),
            scale: (bt = new ie(), function (e, t, n) {
              return bt.makeScale(e, t, n), this.applyMatrix(bt), this;
            }),
            lookAt: (yt = new ft(), function (e) {
              yt.lookAt(e), yt.updateMatrix(), this.applyMatrix(yt.matrix);
            }),
            fromBufferGeometry: function fromBufferGeometry(e) {
              var t = this,
                n = null !== e.index ? e.index.array : void 0,
                r = e.attributes,
                i = r.position.array,
                o = void 0 !== r.normal ? r.normal.array : void 0,
                a = void 0 !== r.color ? r.color.array : void 0,
                s = void 0 !== r.uv ? r.uv.array : void 0,
                l = void 0 !== r.uv2 ? r.uv2.array : void 0;
              void 0 !== l && (this.faceVertexUvs[1] = []);
              for (var u = [], c = [], d = [], h = 0, f = 0; h < i.length; h += 3, f += 2) t.vertices.push(new ae(i[h], i[h + 1], i[h + 2])), void 0 !== o && u.push(new ae(o[h], o[h + 1], o[h + 2])), void 0 !== a && t.colors.push(new Fe(a[h], a[h + 1], a[h + 2])), void 0 !== s && c.push(new re(s[f], s[f + 1])), void 0 !== l && d.push(new re(l[f], l[f + 1]));
              function p(e, n, r, i) {
                var h = new gt(e, n, r, void 0 !== o ? [u[e].clone(), u[n].clone(), u[r].clone()] : [], void 0 !== a ? [t.colors[e].clone(), t.colors[n].clone(), t.colors[r].clone()] : [], i);
                t.faces.push(h), void 0 !== s && t.faceVertexUvs[0].push([c[e].clone(), c[n].clone(), c[r].clone()]), void 0 !== l && t.faceVertexUvs[1].push([d[e].clone(), d[n].clone(), d[r].clone()]);
              }
              var m = e.groups;
              if (0 < m.length) for (h = 0; h < m.length; h++) for (var g = m[h], v = g.start, y = (f = v, v + g.count); f < y; f += 3) void 0 !== n ? p(n[f], n[f + 1], n[f + 2], g.materialIndex) : p(f, f + 1, f + 2, g.materialIndex);else if (void 0 !== n) for (h = 0; h < n.length; h += 3) p(n[h], n[h + 1], n[h + 2]);else for (h = 0; h < i.length / 3; h += 3) p(h, h + 1, h + 2);
              return this.computeFaceNormals(), null !== e.boundingBox && (this.boundingBox = e.boundingBox.clone()), null !== e.boundingSphere && (this.boundingSphere = e.boundingSphere.clone()), this;
            },
            center: (vt = new ae(), function () {
              return this.computeBoundingBox(), this.boundingBox.getCenter(vt).negate(), this.translate(vt.x, vt.y, vt.z), this;
            }),
            normalize: function normalize() {
              this.computeBoundingSphere();
              var e = this.boundingSphere.center,
                t = this.boundingSphere.radius,
                n = 0 === t ? 1 : 1 / t,
                r = new ie();
              return r.set(n, 0, 0, -n * e.x, 0, n, 0, -n * e.y, 0, 0, n, -n * e.z, 0, 0, 0, 1), this.applyMatrix(r), this;
            },
            computeFaceNormals: function computeFaceNormals() {
              for (var e = new ae(), t = new ae(), n = 0, r = this.faces.length; n < r; n++) {
                var i = this.faces[n],
                  o = this.vertices[i.a],
                  a = this.vertices[i.b],
                  s = this.vertices[i.c];
                e.subVectors(s, a), t.subVectors(o, a), e.cross(t), e.normalize(), i.normal.copy(e);
              }
            },
            computeVertexNormals: function computeVertexNormals(e) {
              var t, n, r, i, o, a;
              for (void 0 === e && (e = !0), a = new Array(this.vertices.length), t = 0, n = this.vertices.length; t < n; t++) a[t] = new ae();
              if (e) {
                var s,
                  l,
                  u,
                  c = new ae(),
                  d = new ae();
                for (r = 0, i = this.faces.length; r < i; r++) o = this.faces[r], s = this.vertices[o.a], l = this.vertices[o.b], u = this.vertices[o.c], c.subVectors(u, l), d.subVectors(s, l), c.cross(d), a[o.a].add(c), a[o.b].add(c), a[o.c].add(c);
              } else for (this.computeFaceNormals(), r = 0, i = this.faces.length; r < i; r++) a[(o = this.faces[r]).a].add(o.normal), a[o.b].add(o.normal), a[o.c].add(o.normal);
              for (t = 0, n = this.vertices.length; t < n; t++) a[t].normalize();
              for (r = 0, i = this.faces.length; r < i; r++) {
                var h = (o = this.faces[r]).vertexNormals;
                3 === h.length ? (h[0].copy(a[o.a]), h[1].copy(a[o.b]), h[2].copy(a[o.c])) : (h[0] = a[o.a].clone(), h[1] = a[o.b].clone(), h[2] = a[o.c].clone());
              }
              0 < this.faces.length && (this.normalsNeedUpdate = !0);
            },
            computeFlatVertexNormals: function computeFlatVertexNormals() {
              var e, t, n;
              for (this.computeFaceNormals(), e = 0, t = this.faces.length; e < t; e++) {
                var r = (n = this.faces[e]).vertexNormals;
                3 === r.length ? (r[0].copy(n.normal), r[1].copy(n.normal), r[2].copy(n.normal)) : (r[0] = n.normal.clone(), r[1] = n.normal.clone(), r[2] = n.normal.clone());
              }
              0 < this.faces.length && (this.normalsNeedUpdate = !0);
            },
            computeMorphNormals: function computeMorphNormals() {
              var e,
                t,
                n,
                r,
                i,
                o = this;
              for (n = 0, r = this.faces.length; n < r; n++) for ((i = o.faces[n]).__originalFaceNormal ? i.__originalFaceNormal.copy(i.normal) : i.__originalFaceNormal = i.normal.clone(), i.__originalVertexNormals || (i.__originalVertexNormals = []), e = 0, t = i.vertexNormals.length; e < t; e++) i.__originalVertexNormals[e] ? i.__originalVertexNormals[e].copy(i.vertexNormals[e]) : i.__originalVertexNormals[e] = i.vertexNormals[e].clone();
              var a = new Et();
              for (a.faces = this.faces, e = 0, t = this.morphTargets.length; e < t; e++) {
                if (!o.morphNormals[e]) {
                  o.morphNormals[e] = {}, o.morphNormals[e].faceNormals = [], o.morphNormals[e].vertexNormals = [];
                  var s = o.morphNormals[e].faceNormals,
                    l = o.morphNormals[e].vertexNormals;
                  for (n = 0, r = this.faces.length; n < r; n++) u = new ae(), c = {
                    a: new ae(),
                    b: new ae(),
                    c: new ae()
                  }, s.push(u), l.push(c);
                }
                var u,
                  c,
                  d = o.morphNormals[e];
                for (a.vertices = o.morphTargets[e].vertices, a.computeFaceNormals(), a.computeVertexNormals(), n = 0, r = this.faces.length; n < r; n++) i = o.faces[n], u = d.faceNormals[n], c = d.vertexNormals[n], u.copy(i.normal), c.a.copy(i.vertexNormals[0]), c.b.copy(i.vertexNormals[1]), c.c.copy(i.vertexNormals[2]);
              }
              for (n = 0, r = this.faces.length; n < r; n++) (i = o.faces[n]).normal = i.__originalFaceNormal, i.vertexNormals = i.__originalVertexNormals;
            },
            computeBoundingBox: function computeBoundingBox() {
              null === this.boundingBox && (this.boundingBox = new Oe()), this.boundingBox.setFromPoints(this.vertices);
            },
            computeBoundingSphere: function computeBoundingSphere() {
              null === this.boundingSphere && (this.boundingSphere = new Re()), this.boundingSphere.setFromPoints(this.vertices);
            },
            merge: function merge(e, t, n) {
              if (e && e.isGeometry) {
                var r,
                  i = this.vertices.length,
                  o = this.vertices,
                  a = e.vertices,
                  s = this.faces,
                  l = e.faces,
                  u = this.faceVertexUvs[0],
                  c = e.faceVertexUvs[0],
                  d = this.colors,
                  h = e.colors;
                void 0 === n && (n = 0), void 0 !== t && (r = new se().getNormalMatrix(t));
                for (var f = 0, p = a.length; f < p; f++) {
                  var m = a[f].clone();
                  void 0 !== t && m.applyMatrix4(t), o.push(m);
                }
                for (f = 0, p = h.length; f < p; f++) d.push(h[f].clone());
                for (f = 0, p = l.length; f < p; f++) {
                  var g,
                    v,
                    y,
                    b = l[f],
                    _ = b.vertexNormals,
                    x = b.vertexColors;
                  (g = new gt(b.a + i, b.b + i, b.c + i)).normal.copy(b.normal), void 0 !== r && g.normal.applyMatrix3(r).normalize();
                  for (var w = 0, S = _.length; w < S; w++) v = _[w].clone(), void 0 !== r && v.applyMatrix3(r).normalize(), g.vertexNormals.push(v);
                  for (g.color.copy(b.color), w = 0, S = x.length; w < S; w++) y = x[w], g.vertexColors.push(y.clone());
                  g.materialIndex = b.materialIndex + n, s.push(g);
                }
                for (f = 0, p = c.length; f < p; f++) {
                  var A = c[f],
                    E = [];
                  if (void 0 !== A) {
                    for (w = 0, S = A.length; w < S; w++) E.push(A[w].clone());
                    u.push(E);
                  }
                }
              } else console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", e);
            },
            mergeMesh: function mergeMesh(e) {
              e && e.isMesh ? (e.matrixAutoUpdate && e.updateMatrix(), this.merge(e.geometry, e.matrix)) : console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", e);
            },
            mergeVertices: function mergeVertices() {
              var e,
                t,
                n,
                r,
                i,
                o,
                a,
                s,
                l = {},
                u = [],
                c = [],
                d = Math.pow(10, 4);
              for (n = 0, r = this.vertices.length; n < r; n++) e = this.vertices[n], void 0 === l[t = Math.round(e.x * d) + "_" + Math.round(e.y * d) + "_" + Math.round(e.z * d)] ? (l[t] = n, u.push(this.vertices[n]), c[n] = u.length - 1) : c[n] = c[l[t]];
              var h = [];
              for (n = 0, r = this.faces.length; n < r; n++) {
                (i = this.faces[n]).a = c[i.a], i.b = c[i.b], i.c = c[i.c], o = [i.a, i.b, i.c];
                for (var f = 0; f < 3; f++) if (o[f] === o[(f + 1) % 3]) {
                  h.push(n);
                  break;
                }
              }
              for (n = h.length - 1; 0 <= n; n--) {
                var p = h[n];
                for (this.faces.splice(p, 1), a = 0, s = this.faceVertexUvs.length; a < s; a++) this.faceVertexUvs[a].splice(p, 1);
              }
              var m = this.vertices.length - u.length;
              return this.vertices = u, m;
            },
            setFromPoints: function setFromPoints(e) {
              this.vertices = [];
              for (var t = 0, n = e.length; t < n; t++) {
                var r = e[t];
                this.vertices.push(new ae(r.x, r.y, r.z || 0));
              }
              return this;
            },
            sortFacesByMaterialIndex: function sortFacesByMaterialIndex() {
              for (var e = this.faces, t = e.length, n = 0; n < t; n++) e[n]._id = n;
              e.sort(function (e, t) {
                return e.materialIndex - t.materialIndex;
              });
              var r,
                i,
                o = this.faceVertexUvs[0],
                a = this.faceVertexUvs[1];
              for (o && o.length === t && (r = []), a && a.length === t && (i = []), n = 0; n < t; n++) {
                var s = e[n]._id;
                r && r.push(o[s]), i && i.push(a[s]);
              }
              r && (this.faceVertexUvs[0] = r), i && (this.faceVertexUvs[1] = i);
            },
            toJSON: function toJSON() {
              var e = {
                metadata: {
                  version: 4.5,
                  type: "Geometry",
                  generator: "Geometry.toJSON"
                }
              };
              if (e.uuid = this.uuid, e.type = this.type, "" !== this.name && (e.name = this.name), void 0 !== this.parameters) {
                var t = this.parameters;
                for (var n in t) void 0 !== t[n] && (e[n] = t[n]);
                return e;
              }
              for (var r = [], i = 0; i < this.vertices.length; i++) {
                var o = this.vertices[i];
                r.push(o.x, o.y, o.z);
              }
              var a = [],
                s = [],
                l = {},
                u = [],
                c = {},
                d = [],
                h = {};
              for (i = 0; i < this.faces.length; i++) {
                var f = this.faces[i],
                  p = void 0 !== this.faceVertexUvs[0][i],
                  m = 0 < f.normal.length(),
                  g = 0 < f.vertexNormals.length,
                  v = 1 !== f.color.r || 1 !== f.color.g || 1 !== f.color.b,
                  y = 0 < f.vertexColors.length,
                  b = 0;
                if (b = S(b = S(b = S(b = S(b = S(b = S(b = S(b = S(b, 0, 0), 1, !0), 2, !1), 3, p), 4, m), 5, g), 6, v), 7, y), a.push(b), a.push(f.a, f.b, f.c), a.push(f.materialIndex), p) {
                  var _ = this.faceVertexUvs[0][i];
                  a.push(T(_[0]), T(_[1]), T(_[2]));
                }
                if (m && a.push(A(f.normal)), g) {
                  var x = f.vertexNormals;
                  a.push(A(x[0]), A(x[1]), A(x[2]));
                }
                if (v && a.push(E(f.color)), y) {
                  var w = f.vertexColors;
                  a.push(E(w[0]), E(w[1]), E(w[2]));
                }
              }
              function S(e, t, n) {
                return n ? e | 1 << t : e & ~(1 << t);
              }
              function A(e) {
                var t = e.x.toString() + e.y.toString() + e.z.toString();
                return void 0 !== l[t] || (l[t] = s.length / 3, s.push(e.x, e.y, e.z)), l[t];
              }
              function E(e) {
                var t = e.r.toString() + e.g.toString() + e.b.toString();
                return void 0 !== c[t] || (c[t] = u.length, u.push(e.getHex())), c[t];
              }
              function T(e) {
                var t = e.x.toString() + e.y.toString();
                return void 0 !== h[t] || (h[t] = d.length / 2, d.push(e.x, e.y)), h[t];
              }
              return e.data = {}, e.data.vertices = r, e.data.normals = s, 0 < u.length && (e.data.colors = u), 0 < d.length && (e.data.uvs = [d]), e.data.faces = a, e;
            },
            clone: function clone() {
              return new Et().copy(this);
            },
            copy: function copy(e) {
              var t,
                n,
                r,
                i,
                o,
                a,
                s = this;
              this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [[]], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = e.name;
              var l = e.vertices;
              for (t = 0, n = l.length; t < n; t++) s.vertices.push(l[t].clone());
              var u = e.colors;
              for (t = 0, n = u.length; t < n; t++) s.colors.push(u[t].clone());
              var c = e.faces;
              for (t = 0, n = c.length; t < n; t++) s.faces.push(c[t].clone());
              for (t = 0, n = e.faceVertexUvs.length; t < n; t++) {
                var d = e.faceVertexUvs[t];
                for (void 0 === s.faceVertexUvs[t] && (s.faceVertexUvs[t] = []), r = 0, i = d.length; r < i; r++) {
                  var h = d[r],
                    f = [];
                  for (o = 0, a = h.length; o < a; o++) {
                    var p = h[o];
                    f.push(p.clone());
                  }
                  s.faceVertexUvs[t].push(f);
                }
              }
              var m = e.morphTargets;
              for (t = 0, n = m.length; t < n; t++) {
                var g = {};
                if (g.name = m[t].name, void 0 !== m[t].vertices) for (g.vertices = [], r = 0, i = m[t].vertices.length; r < i; r++) g.vertices.push(m[t].vertices[r].clone());
                if (void 0 !== m[t].normals) for (g.normals = [], r = 0, i = m[t].normals.length; r < i; r++) g.normals.push(m[t].normals[r].clone());
                s.morphTargets.push(g);
              }
              var v = e.morphNormals;
              for (t = 0, n = v.length; t < n; t++) {
                var y = {};
                if (void 0 !== v[t].vertexNormals) for (y.vertexNormals = [], r = 0, i = v[t].vertexNormals.length; r < i; r++) {
                  var b = v[t].vertexNormals[r],
                    _ = {};
                  _.a = b.a.clone(), _.b = b.b.clone(), _.c = b.c.clone(), y.vertexNormals.push(_);
                }
                if (void 0 !== v[t].faceNormals) for (y.faceNormals = [], r = 0, i = v[t].faceNormals.length; r < i; r++) y.faceNormals.push(v[t].faceNormals[r].clone());
                s.morphNormals.push(y);
              }
              var x = e.skinWeights;
              for (t = 0, n = x.length; t < n; t++) s.skinWeights.push(x[t].clone());
              var w = e.skinIndices;
              for (t = 0, n = w.length; t < n; t++) s.skinIndices.push(w[t].clone());
              var S = e.lineDistances;
              for (t = 0, n = S.length; t < n; t++) s.lineDistances.push(S[t]);
              var A = e.boundingBox;
              null !== A && (this.boundingBox = A.clone());
              var E = e.boundingSphere;
              return null !== E && (this.boundingSphere = E.clone()), this.elementsNeedUpdate = e.elementsNeedUpdate, this.verticesNeedUpdate = e.verticesNeedUpdate, this.uvsNeedUpdate = e.uvsNeedUpdate, this.normalsNeedUpdate = e.normalsNeedUpdate, this.colorsNeedUpdate = e.colorsNeedUpdate, this.lineDistancesNeedUpdate = e.lineDistancesNeedUpdate, this.groupsNeedUpdate = e.groupsNeedUpdate, this;
            },
            dispose: function dispose() {
              this.dispatchEvent({
                type: "dispose"
              });
            }
          }), Object.defineProperty(Tt.prototype, "needsUpdate", {
            set: function set(e) {
              !0 === e && this.version++;
            }
          }), Object.assign(Tt.prototype, {
            isBufferAttribute: !0,
            onUploadCallback: function onUploadCallback() {},
            setArray: function setArray(e) {
              if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
              return this.count = void 0 !== e ? e.length / this.itemSize : 0, this.array = e, this;
            },
            setDynamic: function setDynamic(e) {
              return this.dynamic = e, this;
            },
            copy: function copy(e) {
              return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.dynamic = e.dynamic, this;
            },
            copyAt: function copyAt(e, t, n) {
              e *= this.itemSize, n *= t.itemSize;
              for (var r = 0, i = this.itemSize; r < i; r++) this.array[e + r] = t.array[n + r];
              return this;
            },
            copyArray: function copyArray(e) {
              return this.array.set(e), this;
            },
            copyColorsArray: function copyColorsArray(e) {
              for (var t = this.array, n = 0, r = 0, i = e.length; r < i; r++) {
                var o = e[r];
                void 0 === o && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", r), o = new Fe()), t[n++] = o.r, t[n++] = o.g, t[n++] = o.b;
              }
              return this;
            },
            copyVector2sArray: function copyVector2sArray(e) {
              for (var t = this.array, n = 0, r = 0, i = e.length; r < i; r++) {
                var o = e[r];
                void 0 === o && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", r), o = new re()), t[n++] = o.x, t[n++] = o.y;
              }
              return this;
            },
            copyVector3sArray: function copyVector3sArray(e) {
              for (var t = this.array, n = 0, r = 0, i = e.length; r < i; r++) {
                var o = e[r];
                void 0 === o && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", r), o = new ae()), t[n++] = o.x, t[n++] = o.y, t[n++] = o.z;
              }
              return this;
            },
            copyVector4sArray: function copyVector4sArray(e) {
              for (var t = this.array, n = 0, r = 0, i = e.length; r < i; r++) {
                var o = e[r];
                void 0 === o && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", r), o = new Me()), t[n++] = o.x, t[n++] = o.y, t[n++] = o.z, t[n++] = o.w;
              }
              return this;
            },
            set: function set(e, t) {
              return void 0 === t && (t = 0), this.array.set(e, t), this;
            },
            getX: function getX(e) {
              return this.array[e * this.itemSize];
            },
            setX: function setX(e, t) {
              return this.array[e * this.itemSize] = t, this;
            },
            getY: function getY(e) {
              return this.array[e * this.itemSize + 1];
            },
            setY: function setY(e, t) {
              return this.array[e * this.itemSize + 1] = t, this;
            },
            getZ: function getZ(e) {
              return this.array[e * this.itemSize + 2];
            },
            setZ: function setZ(e, t) {
              return this.array[e * this.itemSize + 2] = t, this;
            },
            getW: function getW(e) {
              return this.array[e * this.itemSize + 3];
            },
            setW: function setW(e, t) {
              return this.array[e * this.itemSize + 3] = t, this;
            },
            setXY: function setXY(e, t, n) {
              return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = n, this;
            },
            setXYZ: function setXYZ(e, t, n, r) {
              return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = r, this;
            },
            setXYZW: function setXYZW(e, t, n, r, i) {
              return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = n, this.array[e + 2] = r, this.array[e + 3] = i, this;
            },
            onUpload: function onUpload(e) {
              return this.onUploadCallback = e, this;
            },
            clone: function clone() {
              return new this.constructor(this.array, this.itemSize).copy(this);
            }
          }), (Mt.prototype = Object.create(Tt.prototype)).constructor = Mt, (Ct.prototype = Object.create(Tt.prototype)).constructor = Ct, (kt.prototype = Object.create(Tt.prototype)).constructor = kt, (Pt.prototype = Object.create(Tt.prototype)).constructor = Pt, (Ot.prototype = Object.create(Tt.prototype)).constructor = Ot, (Rt.prototype = Object.create(Tt.prototype)).constructor = Rt, (It.prototype = Object.create(Tt.prototype)).constructor = It, (jt.prototype = Object.create(Tt.prototype)).constructor = jt, (Nt.prototype = Object.create(Tt.prototype)).constructor = Nt, Object.assign(Lt.prototype, {
            computeGroups: function computeGroups(e) {
              for (var t, n = [], r = void 0, i = e.faces, o = 0; o < i.length; o++) {
                var a = i[o];
                a.materialIndex !== r && (r = a.materialIndex, void 0 !== t && (t.count = 3 * o - t.start, n.push(t)), t = {
                  start: 3 * o,
                  materialIndex: r
                });
              }
              void 0 !== t && (t.count = 3 * o - t.start, n.push(t)), this.groups = n;
            },
            fromGeometry: function fromGeometry(e) {
              var t,
                n = this,
                r = e.faces,
                i = e.vertices,
                o = e.faceVertexUvs,
                a = o[0] && 0 < o[0].length,
                s = o[1] && 0 < o[1].length,
                l = e.morphTargets,
                u = l.length;
              if (0 < u) {
                t = [];
                for (var c = 0; c < u; c++) t[c] = [];
                this.morphTargets.position = t;
              }
              var d,
                h = e.morphNormals,
                f = h.length;
              if (0 < f) {
                for (d = [], c = 0; c < f; c++) d[c] = [];
                this.morphTargets.normal = d;
              }
              var p = e.skinIndices,
                m = e.skinWeights,
                g = p.length === i.length,
                v = m.length === i.length;
              for (0 < i.length && 0 === r.length && console.error("THREE.DirectGeometry: Faceless geometries are not supported."), c = 0; c < r.length; c++) {
                var y = r[c];
                n.vertices.push(i[y.a], i[y.b], i[y.c]);
                var b = y.vertexNormals;
                if (3 === b.length) n.normals.push(b[0], b[1], b[2]);else {
                  var _ = y.normal;
                  n.normals.push(_, _, _);
                }
                var x,
                  w = y.vertexColors;
                if (3 === w.length) n.colors.push(w[0], w[1], w[2]);else {
                  var S = y.color;
                  n.colors.push(S, S, S);
                }
                !0 === a && (void 0 !== (x = o[0][c]) ? n.uvs.push(x[0], x[1], x[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", c), n.uvs.push(new re(), new re(), new re()))), !0 === s && (void 0 !== (x = o[1][c]) ? n.uvs2.push(x[0], x[1], x[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", c), n.uvs2.push(new re(), new re(), new re())));
                for (var A = 0; A < u; A++) {
                  var E = l[A].vertices;
                  t[A].push(E[y.a], E[y.b], E[y.c]);
                }
                for (A = 0; A < f; A++) {
                  var T = h[A].vertexNormals[c];
                  d[A].push(T.a, T.b, T.c);
                }
                g && n.skinIndices.push(p[y.a], p[y.b], p[y.c]), v && n.skinWeights.push(m[y.a], m[y.b], m[y.c]);
              }
              return this.computeGroups(e), this.verticesNeedUpdate = e.verticesNeedUpdate, this.normalsNeedUpdate = e.normalsNeedUpdate, this.colorsNeedUpdate = e.colorsNeedUpdate, this.uvsNeedUpdate = e.uvsNeedUpdate, this.groupsNeedUpdate = e.groupsNeedUpdate, this;
            }
          });
          var Bt,
            Ft,
            zt,
            Ut,
            Gt,
            Vt,
            Ht,
            qt,
            Wt,
            $t,
            Xt = 1;
          function Yt() {
            Object.defineProperty(this, "id", {
              value: Xt += 2
            }), this.uuid = ne.generateUUID(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
              start: 0,
              count: 1 / 0
            }, this.userData = {};
          }
          function Kt(e, t, n, r, i, o) {
            Et.call(this), this.type = "BoxGeometry", this.parameters = {
              width: e,
              height: t,
              depth: n,
              widthSegments: r,
              heightSegments: i,
              depthSegments: o
            }, this.fromBufferGeometry(new Zt(e, t, n, r, i, o)), this.mergeVertices();
          }
          function Zt(e, t, n, r, i, o) {
            Yt.call(this), this.type = "BoxBufferGeometry", this.parameters = {
              width: e,
              height: t,
              depth: n,
              widthSegments: r,
              heightSegments: i,
              depthSegments: o
            };
            var a = this;
            e = e || 1, t = t || 1, n = n || 1, r = Math.floor(r) || 1, i = Math.floor(i) || 1, o = Math.floor(o) || 1;
            var s = [],
              l = [],
              u = [],
              c = [],
              d = 0,
              h = 0;
            function f(e, t, n, r, i, o, f, p, m, g, v) {
              var y,
                b,
                _ = o / m,
                x = f / g,
                w = o / 2,
                S = f / 2,
                A = p / 2,
                E = m + 1,
                T = g + 1,
                M = 0,
                C = 0,
                k = new ae();
              for (b = 0; b < T; b++) {
                var P = b * x - S;
                for (y = 0; y < E; y++) {
                  var O = y * _ - w;
                  k[e] = O * r, k[t] = P * i, k[n] = A, l.push(k.x, k.y, k.z), k[e] = 0, k[t] = 0, k[n] = 0 < p ? 1 : -1, u.push(k.x, k.y, k.z), c.push(y / m), c.push(1 - b / g), M += 1;
                }
              }
              for (b = 0; b < g; b++) for (y = 0; y < m; y++) {
                var R = d + y + E * b,
                  I = d + y + E * (b + 1),
                  j = d + (y + 1) + E * (b + 1),
                  N = d + (y + 1) + E * b;
                s.push(R, I, N), s.push(I, j, N), C += 6;
              }
              a.addGroup(h, C, v), h += C, d += M;
            }
            f("z", "y", "x", -1, -1, n, t, e, o, i, 0), f("z", "y", "x", 1, -1, n, t, -e, o, i, 1), f("x", "z", "y", 1, 1, e, n, t, r, o, 2), f("x", "z", "y", 1, -1, e, n, -t, r, o, 3), f("x", "y", "z", 1, -1, e, t, n, r, i, 4), f("x", "y", "z", -1, -1, e, t, -n, r, i, 5), this.setIndex(s), this.addAttribute("position", new jt(l, 3)), this.addAttribute("normal", new jt(u, 3)), this.addAttribute("uv", new jt(c, 2));
          }
          function Qt(e, t, n, r) {
            Et.call(this), this.type = "PlaneGeometry", this.parameters = {
              width: e,
              height: t,
              widthSegments: n,
              heightSegments: r
            }, this.fromBufferGeometry(new Jt(e, t, n, r)), this.mergeVertices();
          }
          function Jt(e, t, n, r) {
            Yt.call(this), this.type = "PlaneBufferGeometry", this.parameters = {
              width: e,
              height: t,
              widthSegments: n,
              heightSegments: r
            };
            var i,
              o,
              a = (e = e || 1) / 2,
              s = (t = t || 1) / 2,
              l = Math.floor(n) || 1,
              u = Math.floor(r) || 1,
              c = l + 1,
              d = u + 1,
              h = e / l,
              f = t / u,
              p = [],
              m = [],
              g = [],
              v = [];
            for (o = 0; o < d; o++) {
              var y = o * f - s;
              for (i = 0; i < c; i++) {
                var b = i * h - a;
                m.push(b, -y, 0), g.push(0, 0, 1), v.push(i / l), v.push(1 - o / u);
              }
            }
            for (o = 0; o < u; o++) for (i = 0; i < l; i++) {
              var _ = i + c * o,
                x = i + c * (o + 1),
                w = i + 1 + c * (o + 1),
                S = i + 1 + c * o;
              p.push(_, x, S), p.push(x, w, S);
            }
            this.setIndex(p), this.addAttribute("position", new jt(m, 3)), this.addAttribute("normal", new jt(g, 3)), this.addAttribute("uv", new jt(v, 2));
          }
          Yt.prototype = Object.assign(Object.create(_.prototype), {
            constructor: Yt,
            isBufferGeometry: !0,
            getIndex: function getIndex() {
              return this.index;
            },
            setIndex: function setIndex(e) {
              Array.isArray(e) ? this.index = new (65535 < Dt(e) ? It : Ot)(e, 1) : this.index = e;
            },
            addAttribute: function addAttribute(e, t) {
              return t && t.isBufferAttribute || t && t.isInterleavedBufferAttribute ? ("index" === e ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), this.setIndex(t)) : this.attributes[e] = t, this) : (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), this.addAttribute(e, new Tt(t, arguments[2])));
            },
            getAttribute: function getAttribute(e) {
              return this.attributes[e];
            },
            removeAttribute: function removeAttribute(e) {
              return delete this.attributes[e], this;
            },
            addGroup: function addGroup(e, t, n) {
              this.groups.push({
                start: e,
                count: t,
                materialIndex: void 0 !== n ? n : 0
              });
            },
            clearGroups: function clearGroups() {
              this.groups = [];
            },
            setDrawRange: function setDrawRange(e, t) {
              this.drawRange.start = e, this.drawRange.count = t;
            },
            applyMatrix: function applyMatrix(e) {
              var t = this.attributes.position;
              void 0 !== t && (e.applyToBufferAttribute(t), t.needsUpdate = !0);
              var n = this.attributes.normal;
              return void 0 !== n && (new se().getNormalMatrix(e).applyToBufferAttribute(n), n.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
            },
            rotateX: ($t = new ie(), function (e) {
              return $t.makeRotationX(e), this.applyMatrix($t), this;
            }),
            rotateY: (Wt = new ie(), function (e) {
              return Wt.makeRotationY(e), this.applyMatrix(Wt), this;
            }),
            rotateZ: (qt = new ie(), function (e) {
              return qt.makeRotationZ(e), this.applyMatrix(qt), this;
            }),
            translate: (Ht = new ie(), function (e, t, n) {
              return Ht.makeTranslation(e, t, n), this.applyMatrix(Ht), this;
            }),
            scale: (Vt = new ie(), function (e, t, n) {
              return Vt.makeScale(e, t, n), this.applyMatrix(Vt), this;
            }),
            lookAt: (Gt = new ft(), function (e) {
              Gt.lookAt(e), Gt.updateMatrix(), this.applyMatrix(Gt.matrix);
            }),
            center: (Ut = new ae(), function () {
              return this.computeBoundingBox(), this.boundingBox.getCenter(Ut).negate(), this.translate(Ut.x, Ut.y, Ut.z), this;
            }),
            setFromObject: function setFromObject(e) {
              var t = e.geometry;
              if (e.isPoints || e.isLine) {
                var n = new jt(3 * t.vertices.length, 3),
                  r = new jt(3 * t.colors.length, 3);
                if (this.addAttribute("position", n.copyVector3sArray(t.vertices)), this.addAttribute("color", r.copyColorsArray(t.colors)), t.lineDistances && t.lineDistances.length === t.vertices.length) {
                  var i = new jt(t.lineDistances.length, 1);
                  this.addAttribute("lineDistance", i.copyArray(t.lineDistances));
                }
                null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone()), null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone());
              } else e.isMesh && t && t.isGeometry && this.fromGeometry(t);
              return this;
            },
            setFromPoints: function setFromPoints(e) {
              for (var t = [], n = 0, r = e.length; n < r; n++) {
                var i = e[n];
                t.push(i.x, i.y, i.z || 0);
              }
              return this.addAttribute("position", new jt(t, 3)), this;
            },
            updateFromObject: function updateFromObject(e) {
              var t,
                n = e.geometry;
              if (e.isMesh) {
                var r = n.__directGeometry;
                if (!0 === n.elementsNeedUpdate && (r = void 0, n.elementsNeedUpdate = !1), void 0 === r) return this.fromGeometry(n);
                r.verticesNeedUpdate = n.verticesNeedUpdate, r.normalsNeedUpdate = n.normalsNeedUpdate, r.colorsNeedUpdate = n.colorsNeedUpdate, r.uvsNeedUpdate = n.uvsNeedUpdate, r.groupsNeedUpdate = n.groupsNeedUpdate, n.verticesNeedUpdate = !1, n.normalsNeedUpdate = !1, n.colorsNeedUpdate = !1, n.uvsNeedUpdate = !1, n.groupsNeedUpdate = !1, n = r;
              }
              return !0 === n.verticesNeedUpdate && (void 0 !== (t = this.attributes.position) && (t.copyVector3sArray(n.vertices), t.needsUpdate = !0), n.verticesNeedUpdate = !1), !0 === n.normalsNeedUpdate && (void 0 !== (t = this.attributes.normal) && (t.copyVector3sArray(n.normals), t.needsUpdate = !0), n.normalsNeedUpdate = !1), !0 === n.colorsNeedUpdate && (void 0 !== (t = this.attributes.color) && (t.copyColorsArray(n.colors), t.needsUpdate = !0), n.colorsNeedUpdate = !1), n.uvsNeedUpdate && (void 0 !== (t = this.attributes.uv) && (t.copyVector2sArray(n.uvs), t.needsUpdate = !0), n.uvsNeedUpdate = !1), n.lineDistancesNeedUpdate && (void 0 !== (t = this.attributes.lineDistance) && (t.copyArray(n.lineDistances), t.needsUpdate = !0), n.lineDistancesNeedUpdate = !1), n.groupsNeedUpdate && (n.computeGroups(e.geometry), this.groups = n.groups, n.groupsNeedUpdate = !1), this;
            },
            fromGeometry: function fromGeometry(e) {
              return e.__directGeometry = new Lt().fromGeometry(e), this.fromDirectGeometry(e.__directGeometry);
            },
            fromDirectGeometry: function fromDirectGeometry(e) {
              var t = new Float32Array(3 * e.vertices.length);
              if (this.addAttribute("position", new Tt(t, 3).copyVector3sArray(e.vertices)), 0 < e.normals.length) {
                var n = new Float32Array(3 * e.normals.length);
                this.addAttribute("normal", new Tt(n, 3).copyVector3sArray(e.normals));
              }
              if (0 < e.colors.length) {
                var r = new Float32Array(3 * e.colors.length);
                this.addAttribute("color", new Tt(r, 3).copyColorsArray(e.colors));
              }
              if (0 < e.uvs.length) {
                var i = new Float32Array(2 * e.uvs.length);
                this.addAttribute("uv", new Tt(i, 2).copyVector2sArray(e.uvs));
              }
              if (0 < e.uvs2.length) {
                var o = new Float32Array(2 * e.uvs2.length);
                this.addAttribute("uv2", new Tt(o, 2).copyVector2sArray(e.uvs2));
              }
              for (var a in this.groups = e.groups, e.morphTargets) {
                for (var s = [], l = e.morphTargets[a], u = 0, c = l.length; u < c; u++) {
                  var d = l[u],
                    h = new jt(3 * d.length, 3);
                  s.push(h.copyVector3sArray(d));
                }
                this.morphAttributes[a] = s;
              }
              if (0 < e.skinIndices.length) {
                var f = new jt(4 * e.skinIndices.length, 4);
                this.addAttribute("skinIndex", f.copyVector4sArray(e.skinIndices));
              }
              if (0 < e.skinWeights.length) {
                var p = new jt(4 * e.skinWeights.length, 4);
                this.addAttribute("skinWeight", p.copyVector4sArray(e.skinWeights));
              }
              return null !== e.boundingSphere && (this.boundingSphere = e.boundingSphere.clone()), null !== e.boundingBox && (this.boundingBox = e.boundingBox.clone()), this;
            },
            computeBoundingBox: function computeBoundingBox() {
              null === this.boundingBox && (this.boundingBox = new Oe());
              var e = this.attributes.position;
              void 0 !== e ? this.boundingBox.setFromBufferAttribute(e) : this.boundingBox.makeEmpty(), (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            },
            computeBoundingSphere: (Ft = new Oe(), zt = new ae(), function () {
              null === this.boundingSphere && (this.boundingSphere = new Re());
              var e = this.attributes.position;
              if (e) {
                var t = this.boundingSphere.center;
                Ft.setFromBufferAttribute(e), Ft.getCenter(t);
                for (var n = 0, r = 0, i = e.count; r < i; r++) zt.x = e.getX(r), zt.y = e.getY(r), zt.z = e.getZ(r), n = Math.max(n, t.distanceToSquared(zt));
                this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
              }
            }),
            computeFaceNormals: function computeFaceNormals() {},
            computeVertexNormals: function computeVertexNormals() {
              var e = this.index,
                t = this.attributes,
                n = this.groups;
              if (t.position) {
                var r = t.position.array;
                if (void 0 === t.normal) this.addAttribute("normal", new Tt(new Float32Array(r.length), 3));else for (var i = t.normal.array, o = 0, a = i.length; o < a; o++) i[o] = 0;
                var s,
                  l,
                  u,
                  c = t.normal.array,
                  d = new ae(),
                  h = new ae(),
                  f = new ae(),
                  p = new ae(),
                  m = new ae();
                if (e) {
                  var g = e.array;
                  0 === n.length && this.addGroup(0, g.length);
                  for (var v = 0, y = n.length; v < y; ++v) {
                    var b = n[v],
                      _ = b.start;
                    for (o = _, a = _ + b.count; o < a; o += 3) s = 3 * g[o + 0], l = 3 * g[o + 1], u = 3 * g[o + 2], d.fromArray(r, s), h.fromArray(r, l), f.fromArray(r, u), p.subVectors(f, h), m.subVectors(d, h), p.cross(m), c[s] += p.x, c[s + 1] += p.y, c[s + 2] += p.z, c[l] += p.x, c[l + 1] += p.y, c[l + 2] += p.z, c[u] += p.x, c[u + 1] += p.y, c[u + 2] += p.z;
                  }
                } else for (o = 0, a = r.length; o < a; o += 9) d.fromArray(r, o), h.fromArray(r, o + 3), f.fromArray(r, o + 6), p.subVectors(f, h), m.subVectors(d, h), p.cross(m), c[o] = p.x, c[o + 1] = p.y, c[o + 2] = p.z, c[o + 3] = p.x, c[o + 4] = p.y, c[o + 5] = p.z, c[o + 6] = p.x, c[o + 7] = p.y, c[o + 8] = p.z;
                this.normalizeNormals(), t.normal.needsUpdate = !0;
              }
            },
            merge: function merge(e, t) {
              if (e && e.isBufferGeometry) {
                void 0 === t && (t = 0, console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."));
                var n = this.attributes;
                for (var r in n) if (void 0 !== e.attributes[r]) for (var i = n[r].array, o = e.attributes[r], a = o.array, s = 0, l = o.itemSize * t; s < a.length; s++, l++) i[l] = a[s];
                return this;
              }
              console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", e);
            },
            normalizeNormals: (Bt = new ae(), function () {
              for (var e = this.attributes.normal, t = 0, n = e.count; t < n; t++) Bt.x = e.getX(t), Bt.y = e.getY(t), Bt.z = e.getZ(t), Bt.normalize(), e.setXYZ(t, Bt.x, Bt.y, Bt.z);
            }),
            toNonIndexed: function toNonIndexed() {
              if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed."), this;
              var e = new Yt(),
                t = this.index.array,
                n = this.attributes;
              for (var r in n) {
                for (var i = n[r], o = i.array, a = i.itemSize, s = new o.constructor(t.length * a), l = 0, u = 0, c = 0, d = t.length; c < d; c++) {
                  l = t[c] * a;
                  for (var h = 0; h < a; h++) s[u++] = o[l++];
                }
                e.addAttribute(r, new Tt(s, a));
              }
              var f = this.groups;
              for (c = 0, d = f.length; c < d; c++) {
                var p = f[c];
                e.addGroup(p.start, p.count, p.materialIndex);
              }
              return e;
            },
            toJSON: function toJSON() {
              var e = {
                metadata: {
                  version: 4.5,
                  type: "BufferGeometry",
                  generator: "BufferGeometry.toJSON"
                }
              };
              if (e.uuid = this.uuid, e.type = this.type, "" !== this.name && (e.name = this.name), 0 < Object.keys(this.userData).length && (e.userData = this.userData), void 0 !== this.parameters) {
                var t = this.parameters;
                for (var n in t) void 0 !== t[n] && (e[n] = t[n]);
                return e;
              }
              e.data = {
                attributes: {}
              };
              var r = this.index;
              if (null !== r) {
                var i = Array.prototype.slice.call(r.array);
                e.data.index = {
                  type: r.array.constructor.name,
                  array: i
                };
              }
              var o = this.attributes;
              for (var n in o) {
                var a = o[n];
                i = Array.prototype.slice.call(a.array), e.data.attributes[n] = {
                  itemSize: a.itemSize,
                  type: a.array.constructor.name,
                  array: i,
                  normalized: a.normalized
                };
              }
              var s = this.groups;
              0 < s.length && (e.data.groups = JSON.parse(JSON.stringify(s)));
              var l = this.boundingSphere;
              return null !== l && (e.data.boundingSphere = {
                center: l.center.toArray(),
                radius: l.radius
              }), e;
            },
            clone: function clone() {
              return new Yt().copy(this);
            },
            copy: function copy(e) {
              var t, n, r;
              this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.name = e.name;
              var i = e.index;
              null !== i && this.setIndex(i.clone());
              var o = e.attributes;
              for (t in o) {
                var a = o[t];
                this.addAttribute(t, a.clone());
              }
              var s = e.morphAttributes;
              for (t in s) {
                var l = [],
                  u = s[t];
                for (n = 0, r = u.length; n < r; n++) l.push(u[n].clone());
                this.morphAttributes[t] = l;
              }
              var c = e.groups;
              for (n = 0, r = c.length; n < r; n++) {
                var d = c[n];
                this.addGroup(d.start, d.count, d.materialIndex);
              }
              var h = e.boundingBox;
              null !== h && (this.boundingBox = h.clone());
              var f = e.boundingSphere;
              return null !== f && (this.boundingSphere = f.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, this;
            },
            dispose: function dispose() {
              this.dispatchEvent({
                type: "dispose"
              });
            }
          }), (Kt.prototype = Object.create(Et.prototype)).constructor = Kt, (Zt.prototype = Object.create(Yt.prototype)).constructor = Zt, (Qt.prototype = Object.create(Et.prototype)).constructor = Qt, (Jt.prototype = Object.create(Yt.prototype)).constructor = Jt;
          var en,
            tn,
            nn,
            rn,
            on,
            an,
            sn,
            ln,
            un,
            cn,
            dn,
            hn,
            fn,
            pn,
            mn,
            gn,
            vn,
            yn,
            bn,
            _n,
            xn,
            wn,
            Sn,
            An,
            En = 0;
          function Tn() {
            Object.defineProperty(this, "id", {
              value: En++
            }), this.uuid = ne.generateUUID(), this.name = "", this.type = "Material", this.fog = !0, this.lights = !0, this.blending = 1, this.side = 0, this.flatShading = !1, this.vertexColors = 0, this.opacity = 1, this.transparent = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = 100, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaTest = 0, this.premultipliedAlpha = !1, this.overdraw = 0, this.visible = !0, this.userData = {}, this.needsUpdate = !0;
          }
          function Mn(e) {
            Tn.call(this), this.type = "MeshBasicMaterial", this.color = new Fe(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.lights = !1, this.setValues(e);
          }
          function Cn(e) {
            Tn.call(this), this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.extensions = {
              derivatives: !1,
              fragDepth: !1,
              drawBuffers: !1,
              shaderTextureLOD: !1
            }, this.defaultAttributeValues = {
              color: [1, 1, 1],
              uv: [0, 0],
              uv2: [0, 0]
            }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, void 0 !== e && (void 0 !== e.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), this.setValues(e));
          }
          function kn(e, t) {
            this.origin = void 0 !== e ? e : new ae(), this.direction = void 0 !== t ? t : new ae();
          }
          function Pn(e, t, n) {
            this.a = void 0 !== e ? e : new ae(), this.b = void 0 !== t ? t : new ae(), this.c = void 0 !== n ? n : new ae();
          }
          function On(e, t) {
            ft.call(this), this.type = "Mesh", this.geometry = void 0 !== e ? e : new Yt(), this.material = void 0 !== t ? t : new Mn({
              color: 16777215 * Math.random()
            }), this.drawMode = 0, this.updateMorphTargets();
          }
          function Rn(e, t, n, r) {
            var i,
              o,
              a,
              s = new Fe(0),
              l = 0;
            function u(e, n) {
              t.buffers.color.setClear(e.r, e.g, e.b, n, r);
            }
            return {
              getClearColor: function getClearColor() {
                return s;
              },
              setClearColor: function setClearColor(e, t) {
                s.set(e), u(s, l = void 0 !== t ? t : 1);
              },
              getClearAlpha: function getClearAlpha() {
                return l;
              },
              setClearAlpha: function setClearAlpha(e) {
                u(s, l = e);
              },
              render: function render(t, r, c, d) {
                var h = r.background;
                null === h ? u(s, l) : h && h.isColor && (u(h, 1), d = !0), (e.autoClear || d) && e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil), h && h.isCubeTexture ? (void 0 === a && ((a = new On(new Zt(1, 1, 1), new Cn({
                  uniforms: Ve.cube.uniforms,
                  vertexShader: Ve.cube.vertexShader,
                  fragmentShader: Ve.cube.fragmentShader,
                  side: 1,
                  depthTest: !0,
                  depthWrite: !1,
                  fog: !1
                }))).geometry.removeAttribute("normal"), a.geometry.removeAttribute("uv"), a.onBeforeRender = function (e, t, n) {
                  this.matrixWorld.copyPosition(n.matrixWorld);
                }, n.update(a)), a.material.uniforms.tCube.value = h, t.push(a, a.geometry, a.material, 0, null)) : h && h.isTexture && (void 0 === i && (i = new mt(-1, 1, 1, -1, 0, 1), o = new On(new Jt(2, 2), new Mn({
                  depthTest: !1,
                  depthWrite: !1,
                  fog: !1
                })), n.update(o)), o.material.map = h, e.renderBufferDirect(i, null, o.geometry, o.material, o, null));
              }
            };
          }
          function In(e, t, n, r) {
            var i;
            this.setMode = function (e) {
              i = e;
            }, this.render = function (t, r) {
              e.drawArrays(i, t, r), n.update(r, i);
            }, this.renderInstances = function (o, a, s) {
              var l;
              if (r.isWebGL2) l = e;else if (null === (l = t.get("ANGLE_instanced_arrays"))) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
              l[r.isWebGL2 ? "drawArraysInstanced" : "drawArraysInstancedANGLE"](i, a, s, o.maxInstancedCount), n.update(s, i, o.maxInstancedCount);
            };
          }
          function jn(e, t, n) {
            var r;
            function i(t) {
              if ("highp" === t) {
                if (0 < e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision && 0 < e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision) return "highp";
                t = "mediump";
              }
              return "mediump" === t && 0 < e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision && 0 < e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision ? "mediump" : "lowp";
            }
            var o = "undefined" != typeof WebGL2RenderingContext && e instanceof WebGL2RenderingContext,
              a = void 0 !== n.precision ? n.precision : "highp",
              s = i(a);
            s !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", s, "instead."), a = s);
            var l = !0 === n.logarithmicDepthBuffer,
              u = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),
              c = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
              d = e.getParameter(e.MAX_TEXTURE_SIZE),
              h = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),
              f = e.getParameter(e.MAX_VERTEX_ATTRIBS),
              p = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),
              m = e.getParameter(e.MAX_VARYING_VECTORS),
              g = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),
              v = 0 < c,
              y = o || !!t.get("OES_texture_float");
            return {
              isWebGL2: o,
              getMaxAnisotropy: function getMaxAnisotropy() {
                if (void 0 !== r) return r;
                var n = t.get("EXT_texture_filter_anisotropic");
                return r = null !== n ? e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
              },
              getMaxPrecision: i,
              precision: a,
              logarithmicDepthBuffer: l,
              maxTextures: u,
              maxVertexTextures: c,
              maxTextureSize: d,
              maxCubemapSize: h,
              maxAttributes: f,
              maxVertexUniforms: p,
              maxVaryings: m,
              maxFragmentUniforms: g,
              vertexTextures: v,
              floatFragmentTextures: y,
              floatVertexTextures: v && y
            };
          }
          function Nn() {
            var e = this,
              t = null,
              n = 0,
              r = !1,
              i = !1,
              o = new Ie(),
              a = new se(),
              s = {
                value: null,
                needsUpdate: !1
              };
            function l() {
              s.value !== t && (s.value = t, s.needsUpdate = 0 < n), e.numPlanes = n, e.numIntersection = 0;
            }
            function u(t, n, r, i) {
              var l = null !== t ? t.length : 0,
                u = null;
              if (0 !== l) {
                if (u = s.value, !0 !== i || null === u) {
                  var c = r + 4 * l,
                    d = n.matrixWorldInverse;
                  a.getNormalMatrix(d), (null === u || u.length < c) && (u = new Float32Array(c));
                  for (var h = 0, f = r; h !== l; ++h, f += 4) o.copy(t[h]).applyMatrix4(d, a), o.normal.toArray(u, f), u[f + 3] = o.constant;
                }
                s.value = u, s.needsUpdate = !0;
              }
              return e.numPlanes = l, u;
            }
            this.uniform = s, this.numPlanes = 0, this.numIntersection = 0, this.init = function (e, i, o) {
              var a = 0 !== e.length || i || 0 !== n || r;
              return r = i, t = u(e, o, 0), n = e.length, a;
            }, this.beginShadows = function () {
              i = !0, u(null);
            }, this.endShadows = function () {
              i = !1, l();
            }, this.setState = function (e, o, a, c, d, h) {
              if (!r || null === e || 0 === e.length || i && !a) i ? u(null) : l();else {
                var f = i ? 0 : n,
                  p = 4 * f,
                  m = d.clippingState || null;
                s.value = m, m = u(e, c, p, h);
                for (var g = 0; g !== p; ++g) m[g] = t[g];
                d.clippingState = m, this.numIntersection = o ? this.numPlanes : 0, this.numPlanes += f;
              }
            };
          }
          function Ln(e) {
            var t = {};
            return {
              get: function get(n) {
                if (void 0 !== t[n]) return t[n];
                var r;
                switch (n) {
                  case "WEBGL_depth_texture":
                    r = e.getExtension("WEBGL_depth_texture") || e.getExtension("MOZ_WEBGL_depth_texture") || e.getExtension("WEBKIT_WEBGL_depth_texture");
                    break;
                  case "EXT_texture_filter_anisotropic":
                    r = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                    break;
                  case "WEBGL_compressed_texture_s3tc":
                    r = e.getExtension("WEBGL_compressed_texture_s3tc") || e.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                    break;
                  case "WEBGL_compressed_texture_pvrtc":
                    r = e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                    break;
                  default:
                    r = e.getExtension(n);
                }
                return null === r && console.warn("THREE.WebGLRenderer: " + n + " extension not supported."), t[n] = r;
              }
            };
          }
          function Dn(e, t, n) {
            var r = {},
              i = {};
            function o(e) {
              var a = e.target,
                s = r[a.id];
              for (var l in null !== s.index && t.remove(s.index), s.attributes) t.remove(s.attributes[l]);
              a.removeEventListener("dispose", o), delete r[a.id];
              var u = i[s.id];
              u && (t.remove(u), delete i[s.id]), n.memory.geometries--;
            }
            return {
              get: function get(e, t) {
                var i = r[t.id];
                return i || (t.addEventListener("dispose", o), t.isBufferGeometry ? i = t : t.isGeometry && (void 0 === t._bufferGeometry && (t._bufferGeometry = new Yt().setFromObject(e)), i = t._bufferGeometry), r[t.id] = i, n.memory.geometries++, i);
              },
              update: function update(n) {
                var r = n.index,
                  i = n.attributes;
                for (var o in null !== r && t.update(r, e.ELEMENT_ARRAY_BUFFER), i) t.update(i[o], e.ARRAY_BUFFER);
                var a = n.morphAttributes;
                for (var o in a) for (var s = a[o], l = 0, u = s.length; l < u; l++) t.update(s[l], e.ARRAY_BUFFER);
              },
              getWireframeAttribute: function getWireframeAttribute(n) {
                var r = i[n.id];
                if (r) return r;
                var o,
                  a = [],
                  s = n.index,
                  l = n.attributes;
                if (null !== s) for (var u = 0, c = (o = s.array).length; u < c; u += 3) {
                  var d = o[u + 0],
                    h = o[u + 1],
                    f = o[u + 2];
                  a.push(d, h, h, f, f, d);
                } else for (u = 0, c = (o = l.position.array).length / 3 - 1; u < c; u += 3) d = u + 0, h = u + 1, f = u + 2, a.push(d, h, h, f, f, d);
                return r = new (65535 < Dt(a) ? It : Ot)(a, 1), t.update(r, e.ELEMENT_ARRAY_BUFFER), i[n.id] = r;
              }
            };
          }
          function Bn(e, t, n, r) {
            var i, o, a;
            this.setMode = function (e) {
              i = e;
            }, this.setIndex = function (e) {
              o = e.type, a = e.bytesPerElement;
            }, this.render = function (t, r) {
              e.drawElements(i, r, o, t * a), n.update(r, i);
            }, this.renderInstances = function (s, l, u) {
              var c;
              if (r.isWebGL2) c = e;else if (null === (c = t.get("ANGLE_instanced_arrays"))) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
              c[r.isWebGL2 ? "drawElementsInstanced" : "drawElementsInstancedANGLE"](i, u, o, l * a, s.maxInstancedCount), n.update(u, i, s.maxInstancedCount);
            };
          }
          function Fn(e) {
            var t = {
              frame: 0,
              calls: 0,
              triangles: 0,
              points: 0,
              lines: 0
            };
            return {
              memory: {
                geometries: 0,
                textures: 0
              },
              render: t,
              programs: null,
              autoReset: !0,
              reset: function reset() {
                t.frame++, t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
              },
              update: function update(n, r, i) {
                switch (i = i || 1, t.calls++, r) {
                  case e.TRIANGLES:
                    t.triangles += i * (n / 3);
                    break;
                  case e.TRIANGLE_STRIP:
                  case e.TRIANGLE_FAN:
                    t.triangles += i * (n - 2);
                    break;
                  case e.LINES:
                    t.lines += i * (n / 2);
                    break;
                  case e.LINE_STRIP:
                    t.lines += i * (n - 1);
                    break;
                  case e.LINE_LOOP:
                    t.lines += i * n;
                    break;
                  case e.POINTS:
                    t.points += i * n;
                    break;
                  default:
                    console.error("THREE.WebGLInfo: Unknown draw mode:", r);
                }
              }
            };
          }
          function zn(e, t) {
            return Math.abs(t[1]) - Math.abs(e[1]);
          }
          function Un(e) {
            var t = {},
              n = new Float32Array(8);
            return {
              update: function update(r, i, o, a) {
                var s = r.morphTargetInfluences,
                  l = s.length,
                  u = t[i.id];
                if (void 0 === u) {
                  u = [];
                  for (var c = 0; c < l; c++) u[c] = [c, 0];
                  t[i.id] = u;
                }
                var d = o.morphTargets && i.morphAttributes.position,
                  h = o.morphNormals && i.morphAttributes.normal;
                for (c = 0; c < l; c++) 0 !== (f = u[c])[1] && (d && i.removeAttribute("morphTarget" + c), h && i.removeAttribute("morphNormal" + c));
                for (c = 0; c < l; c++) (f = u[c])[0] = c, f[1] = s[c];
                for (u.sort(zn), c = 0; c < 8; c++) {
                  var f;
                  if (f = u[c]) {
                    var p = f[0],
                      m = f[1];
                    if (m) {
                      d && i.addAttribute("morphTarget" + c, d[p]), h && i.addAttribute("morphNormal" + c, h[p]), n[c] = m;
                      continue;
                    }
                  }
                  n[c] = 0;
                }
                a.getUniforms().setValue(e, "morphTargetInfluences", n);
              }
            };
          }
          function Gn(e, t) {
            var n = {};
            return {
              update: function update(r) {
                var i = t.render.frame,
                  o = r.geometry,
                  a = e.get(r, o);
                return n[a.id] !== i && (o.isGeometry && a.updateFromObject(r), e.update(a), n[a.id] = i), a;
              },
              dispose: function dispose() {
                n = {};
              }
            };
          }
          function Vn(e, t, n, r, i, o, a, s, l, u) {
            Te.call(this, e = void 0 !== e ? e : [], t = void 0 !== t ? t : 301, n, r, i, o, a, s, l, u), this.flipY = !1;
          }
          Tn.prototype = Object.assign(Object.create(_.prototype), {
            constructor: Tn,
            isMaterial: !0,
            onBeforeCompile: function onBeforeCompile() {},
            setValues: function setValues(e) {
              if (void 0 !== e) for (var t in e) {
                var n = e[t];
                if (void 0 !== n) {
                  if ("shading" !== t) {
                    var r = this[t];
                    void 0 !== r ? r && r.isColor ? r.set(n) : r && r.isVector3 && n && n.isVector3 ? r.copy(n) : this[t] = "overdraw" === t ? Number(n) : n : console.warn("THREE." + this.type + ": '" + t + "' is not a property of this material.");
                  } else console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === n;
                } else console.warn("THREE.Material: '" + t + "' parameter is undefined.");
              }
            },
            toJSON: function toJSON(e) {
              var t = void 0 === e || "string" == typeof e;
              t && (e = {
                textures: {},
                images: {}
              });
              var n = {
                metadata: {
                  version: 4.5,
                  type: "Material",
                  generator: "Material.toJSON"
                }
              };
              function r(e) {
                var t = [];
                for (var n in e) {
                  var r = e[n];
                  delete r.metadata, t.push(r);
                }
                return t;
              }
              if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearCoat && (n.clearCoat = this.clearCoat), void 0 !== this.clearCoatRoughness && (n.clearCoatRoughness = this.clearCoatRoughness), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, n.reflectivity = this.reflectivity), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), void 0 !== this.size && (n.size = this.size), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (n.blending = this.blending), !0 === this.flatShading && (n.flatShading = this.flatShading), 0 !== this.side && (n.side = this.side), 0 !== this.vertexColors && (n.vertexColors = this.vertexColors), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, 0 !== this.rotation && (n.rotation = this.rotation), 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), 0 < this.alphaTest && (n.alphaTest = this.alphaTest), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), 1 < this.wireframeLinewidth && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.morphTargets && (n.morphTargets = !0), !0 === this.skinning && (n.skinning = !0), !1 === this.visible && (n.visible = !1), "{}" !== JSON.stringify(this.userData) && (n.userData = this.userData), t) {
                var i = r(e.textures),
                  o = r(e.images);
                0 < i.length && (n.textures = i), 0 < o.length && (n.images = o);
              }
              return n;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              this.name = e.name, this.fog = e.fog, this.lights = e.lights, this.blending = e.blending, this.side = e.side, this.flatShading = e.flatShading, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.premultipliedAlpha = e.premultipliedAlpha, this.overdraw = e.overdraw, this.visible = e.visible, this.userData = JSON.parse(JSON.stringify(e.userData)), this.clipShadows = e.clipShadows, this.clipIntersection = e.clipIntersection;
              var t = e.clippingPlanes,
                n = null;
              if (null !== t) {
                var r = t.length;
                n = new Array(r);
                for (var i = 0; i !== r; ++i) n[i] = t[i].clone();
              }
              return this.clippingPlanes = n, this.shadowSide = e.shadowSide, this;
            },
            dispose: function dispose() {
              this.dispatchEvent({
                type: "dispose"
              });
            }
          }), ((Mn.prototype = Object.create(Tn.prototype)).constructor = Mn).prototype.isMeshBasicMaterial = !0, Mn.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this;
          }, ((Cn.prototype = Object.create(Tn.prototype)).constructor = Cn).prototype.isShaderMaterial = !0, Cn.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = De.clone(e.uniforms), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.lights = e.lights, this.clipping = e.clipping, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this.extensions = e.extensions, this;
          }, Cn.prototype.toJSON = function (e) {
            var t = Tn.prototype.toJSON.call(this, e);
            return t.uniforms = this.uniforms, t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t;
          }, Object.assign(kn.prototype, {
            set: function set(e, t) {
              return this.origin.copy(e), this.direction.copy(t), this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
            },
            at: function at(e, t) {
              return void 0 === t && (console.warn("THREE.Ray: .at() target is now required"), t = new ae()), t.copy(this.direction).multiplyScalar(e).add(this.origin);
            },
            lookAt: function lookAt(e) {
              return this.direction.copy(e).sub(this.origin).normalize(), this;
            },
            recast: (dn = new ae(), function (e) {
              return this.origin.copy(this.at(e, dn)), this;
            }),
            closestPointToPoint: function closestPointToPoint(e, t) {
              void 0 === t && (console.warn("THREE.Ray: .closestPointToPoint() target is now required"), t = new ae()), t.subVectors(e, this.origin);
              var n = t.dot(this.direction);
              return n < 0 ? t.copy(this.origin) : t.copy(this.direction).multiplyScalar(n).add(this.origin);
            },
            distanceToPoint: function distanceToPoint(e) {
              return Math.sqrt(this.distanceSqToPoint(e));
            },
            distanceSqToPoint: (cn = new ae(), function (e) {
              var t = cn.subVectors(e, this.origin).dot(this.direction);
              return t < 0 ? this.origin.distanceToSquared(e) : (cn.copy(this.direction).multiplyScalar(t).add(this.origin), cn.distanceToSquared(e));
            }),
            distanceSqToSegment: (sn = new ae(), ln = new ae(), un = new ae(), function (e, t, n, r) {
              sn.copy(e).add(t).multiplyScalar(.5), ln.copy(t).sub(e).normalize(), un.copy(this.origin).sub(sn);
              var i,
                o,
                a,
                s,
                l = .5 * e.distanceTo(t),
                u = -this.direction.dot(ln),
                c = un.dot(this.direction),
                d = -un.dot(ln),
                h = un.lengthSq(),
                f = Math.abs(1 - u * u);
              if (0 < f) {
                if (o = u * c - d, s = l * f, 0 <= (i = u * d - c)) {
                  if (-s <= o) {
                    if (o <= s) {
                      var p = 1 / f;
                      a = (i *= p) * (i + u * (o *= p) + 2 * c) + o * (u * i + o + 2 * d) + h;
                    } else o = l, a = -(i = Math.max(0, -(u * o + c))) * i + o * (o + 2 * d) + h;
                  } else o = -l, a = -(i = Math.max(0, -(u * o + c))) * i + o * (o + 2 * d) + h;
                } else o <= -s ? a = -(i = Math.max(0, -(-u * l + c))) * i + (o = 0 < i ? -l : Math.min(Math.max(-l, -d), l)) * (o + 2 * d) + h : o <= s ? (i = 0, a = (o = Math.min(Math.max(-l, -d), l)) * (o + 2 * d) + h) : a = -(i = Math.max(0, -(u * l + c))) * i + (o = 0 < i ? l : Math.min(Math.max(-l, -d), l)) * (o + 2 * d) + h;
              } else o = 0 < u ? -l : l, a = -(i = Math.max(0, -(u * o + c))) * i + o * (o + 2 * d) + h;
              return n && n.copy(this.direction).multiplyScalar(i).add(this.origin), r && r.copy(ln).multiplyScalar(o).add(sn), a;
            }),
            intersectSphere: (an = new ae(), function (e, t) {
              an.subVectors(e.center, this.origin);
              var n = an.dot(this.direction),
                r = an.dot(an) - n * n,
                i = e.radius * e.radius;
              if (i < r) return null;
              var o = Math.sqrt(i - r),
                a = n - o,
                s = n + o;
              return a < 0 && s < 0 ? null : a < 0 ? this.at(s, t) : this.at(a, t);
            }),
            intersectsSphere: function intersectsSphere(e) {
              return this.distanceToPoint(e.center) <= e.radius;
            },
            distanceToPlane: function distanceToPlane(e) {
              var t = e.normal.dot(this.direction);
              if (0 === t) return 0 === e.distanceToPoint(this.origin) ? 0 : null;
              var n = -(this.origin.dot(e.normal) + e.constant) / t;
              return 0 <= n ? n : null;
            },
            intersectPlane: function intersectPlane(e, t) {
              var n = this.distanceToPlane(e);
              return null === n ? null : this.at(n, t);
            },
            intersectsPlane: function intersectsPlane(e) {
              var t = e.distanceToPoint(this.origin);
              return 0 === t || e.normal.dot(this.direction) * t < 0;
            },
            intersectBox: function intersectBox(e, t) {
              var n,
                r,
                i,
                o,
                a,
                s,
                l = 1 / this.direction.x,
                u = 1 / this.direction.y,
                c = 1 / this.direction.z,
                d = this.origin;
              return 0 <= l ? (n = (e.min.x - d.x) * l, r = (e.max.x - d.x) * l) : (n = (e.max.x - d.x) * l, r = (e.min.x - d.x) * l), 0 <= u ? (i = (e.min.y - d.y) * u, o = (e.max.y - d.y) * u) : (i = (e.max.y - d.y) * u, o = (e.min.y - d.y) * u), o < n || r < i ? null : ((n < i || n != n) && (n = i), (o < r || r != r) && (r = o), 0 <= c ? (a = (e.min.z - d.z) * c, s = (e.max.z - d.z) * c) : (a = (e.max.z - d.z) * c, s = (e.min.z - d.z) * c), s < n || r < a ? null : ((n < a || n != n) && (n = a), (s < r || r != r) && (r = s), r < 0 ? null : this.at(0 <= n ? n : r, t)));
            },
            intersectsBox: (on = new ae(), function (e) {
              return null !== this.intersectBox(e, on);
            }),
            intersectTriangle: (en = new ae(), tn = new ae(), nn = new ae(), rn = new ae(), function (e, t, n, r, i) {
              tn.subVectors(t, e), nn.subVectors(n, e), rn.crossVectors(tn, nn);
              var o,
                a = this.direction.dot(rn);
              if (0 < a) {
                if (r) return null;
                o = 1;
              } else {
                if (!(a < 0)) return null;
                o = -1, a = -a;
              }
              en.subVectors(this.origin, e);
              var s = o * this.direction.dot(nn.crossVectors(en, nn));
              if (s < 0) return null;
              var l = o * this.direction.dot(tn.cross(en));
              if (l < 0) return null;
              if (a < s + l) return null;
              var u = -o * en.dot(rn);
              return u < 0 ? null : this.at(u / a, i);
            }),
            applyMatrix4: function applyMatrix4(e) {
              return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
            },
            equals: function equals(e) {
              return e.origin.equals(this.origin) && e.direction.equals(this.direction);
            }
          }), Object.assign(Pn, {
            getNormal: (gn = new ae(), function (e, t, n, r) {
              void 0 === r && (console.warn("THREE.Triangle: .getNormal() target is now required"), r = new ae()), r.subVectors(n, t), gn.subVectors(e, t), r.cross(gn);
              var i = r.lengthSq();
              return 0 < i ? r.multiplyScalar(1 / Math.sqrt(i)) : r.set(0, 0, 0);
            }),
            getBarycoord: (fn = new ae(), pn = new ae(), mn = new ae(), function (e, t, n, r, i) {
              fn.subVectors(r, t), pn.subVectors(n, t), mn.subVectors(e, t);
              var o = fn.dot(fn),
                a = fn.dot(pn),
                s = fn.dot(mn),
                l = pn.dot(pn),
                u = pn.dot(mn),
                c = o * l - a * a;
              if (void 0 === i && (console.warn("THREE.Triangle: .getBarycoord() target is now required"), i = new ae()), 0 === c) return i.set(-2, -1, -1);
              var d = 1 / c,
                h = (l * s - a * u) * d,
                f = (o * u - a * s) * d;
              return i.set(1 - h - f, f, h);
            }),
            containsPoint: (hn = new ae(), function (e, t, n, r) {
              return Pn.getBarycoord(e, t, n, r, hn), 0 <= hn.x && 0 <= hn.y && hn.x + hn.y <= 1;
            })
          }), Object.assign(Pn.prototype, {
            set: function set(e, t, n) {
              return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
            },
            setFromPointsAndIndices: function setFromPointsAndIndices(e, t, n, r) {
              return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[r]), this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
            },
            getArea: (Sn = new ae(), An = new ae(), function () {
              return Sn.subVectors(this.c, this.b), An.subVectors(this.a, this.b), .5 * Sn.cross(An).length();
            }),
            getMidpoint: function getMidpoint(e) {
              return void 0 === e && (console.warn("THREE.Triangle: .getMidpoint() target is now required"), e = new ae()), e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            },
            getNormal: function getNormal(e) {
              return Pn.getNormal(this.a, this.b, this.c, e);
            },
            getPlane: function getPlane(e) {
              return void 0 === e && (console.warn("THREE.Triangle: .getPlane() target is now required"), e = new ae()), e.setFromCoplanarPoints(this.a, this.b, this.c);
            },
            getBarycoord: function getBarycoord(e, t) {
              return Pn.getBarycoord(e, this.a, this.b, this.c, t);
            },
            containsPoint: function containsPoint(e) {
              return Pn.containsPoint(e, this.a, this.b, this.c);
            },
            intersectsBox: function intersectsBox(e) {
              return e.intersectsTriangle(this);
            },
            closestPointToPoint: (vn = new ae(), yn = new ae(), bn = new ae(), _n = new ae(), xn = new ae(), wn = new ae(), function (e, t) {
              void 0 === t && (console.warn("THREE.Triangle: .closestPointToPoint() target is now required"), t = new ae());
              var n,
                r,
                i = this.a,
                o = this.b,
                a = this.c;
              vn.subVectors(o, i), yn.subVectors(a, i), _n.subVectors(e, i);
              var s = vn.dot(_n),
                l = yn.dot(_n);
              if (s <= 0 && l <= 0) return t.copy(i);
              xn.subVectors(e, o);
              var u = vn.dot(xn),
                c = yn.dot(xn);
              if (0 <= u && c <= u) return t.copy(o);
              var d = s * c - u * l;
              if (d <= 0 && 0 <= s && u <= 0) return n = s / (s - u), t.copy(i).addScaledVector(vn, n);
              wn.subVectors(e, a);
              var h = vn.dot(wn),
                f = yn.dot(wn);
              if (0 <= f && h <= f) return t.copy(a);
              var p = h * l - s * f;
              if (p <= 0 && 0 <= l && f <= 0) return r = l / (l - f), t.copy(i).addScaledVector(yn, r);
              var m = u * f - h * c;
              if (m <= 0 && 0 <= c - u && 0 <= h - f) return bn.subVectors(a, o), r = (c - u) / (c - u + (h - f)), t.copy(o).addScaledVector(bn, r);
              var g = 1 / (m + p + d);
              return n = p * g, r = d * g, t.copy(i).addScaledVector(vn, n).addScaledVector(yn, r);
            }),
            equals: function equals(e) {
              return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
            }
          }), On.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: On,
            isMesh: !0,
            setDrawMode: function setDrawMode(e) {
              this.drawMode = e;
            },
            copy: function copy(e) {
              return ft.prototype.copy.call(this, e), this.drawMode = e.drawMode, void 0 !== e.morphTargetInfluences && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), void 0 !== e.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this;
            },
            updateMorphTargets: function updateMorphTargets() {
              var e,
                t,
                n,
                r = this.geometry;
              if (r.isBufferGeometry) {
                var i = r.morphAttributes,
                  o = Object.keys(i);
                if (0 < o.length) {
                  var a = i[o[0]];
                  if (void 0 !== a) for (this.morphTargetInfluences = [], this.morphTargetDictionary = {}, e = 0, t = a.length; e < t; e++) n = a[e].name || String(e), this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = e;
                }
              } else {
                var s = r.morphTargets;
                if (void 0 !== s && 0 < s.length) for (this.morphTargetInfluences = [], this.morphTargetDictionary = {}, e = 0, t = s.length; e < t; e++) n = s[e].name || String(e), this.morphTargetInfluences.push(0), this.morphTargetDictionary[n] = e;
              }
            },
            raycast: function () {
              var e = new ie(),
                t = new kn(),
                n = new Re(),
                r = new ae(),
                i = new ae(),
                o = new ae(),
                a = new ae(),
                s = new ae(),
                l = new ae(),
                u = new re(),
                c = new re(),
                d = new re(),
                h = new ae(),
                f = new ae(),
                p = new ae();
              function m(e, t, n, r, i, o, a) {
                return Pn.getBarycoord(e, t, n, r, h), i.multiplyScalar(h.x), o.multiplyScalar(h.y), a.multiplyScalar(h.z), i.add(o).add(a), i.clone();
              }
              function g(e, t, n, r, i, o, a, s) {
                if (null === (1 === t.side ? r.intersectTriangle(a, o, i, !0, s) : r.intersectTriangle(i, o, a, 2 !== t.side, s))) return null;
                p.copy(s), p.applyMatrix4(e.matrixWorld);
                var l = n.ray.origin.distanceTo(p);
                return l < n.near || l > n.far ? null : {
                  distance: l,
                  point: p.clone(),
                  object: e
                };
              }
              function v(e, t, n, a, s, l, h, p, v) {
                r.fromBufferAttribute(s, h), i.fromBufferAttribute(s, p), o.fromBufferAttribute(s, v);
                var y = g(e, t, n, a, r, i, o, f);
                if (y) {
                  l && (u.fromBufferAttribute(l, h), c.fromBufferAttribute(l, p), d.fromBufferAttribute(l, v), y.uv = m(f, r, i, o, u, c, d));
                  var b = new gt(h, p, v);
                  Pn.getNormal(r, i, o, b.normal), y.face = b;
                }
                return y;
              }
              return function (h, p) {
                var y,
                  b = this.geometry,
                  _ = this.material,
                  x = this.matrixWorld;
                if (void 0 !== _ && (null === b.boundingSphere && b.computeBoundingSphere(), n.copy(b.boundingSphere), n.applyMatrix4(x), !1 !== h.ray.intersectsSphere(n) && (e.getInverse(x), t.copy(h.ray).applyMatrix4(e), null === b.boundingBox || !1 !== t.intersectsBox(b.boundingBox)))) if (b.isBufferGeometry) {
                  var w,
                    S,
                    A,
                    E,
                    T,
                    M,
                    C,
                    k,
                    P,
                    O = b.index,
                    R = b.attributes.position,
                    I = b.attributes.uv,
                    j = b.groups,
                    N = b.drawRange;
                  if (null !== O) {
                    if (Array.isArray(_)) for (E = 0, M = j.length; E < M; E++) for (P = _[(k = j[E]).materialIndex], T = Math.max(k.start, N.start), C = Math.min(k.start + k.count, N.start + N.count); T < C; T += 3) w = O.getX(T), S = O.getX(T + 1), A = O.getX(T + 2), (y = v(this, P, h, t, R, I, w, S, A)) && (y.faceIndex = Math.floor(T / 3), p.push(y));else for (E = Math.max(0, N.start), M = Math.min(O.count, N.start + N.count); E < M; E += 3) w = O.getX(E), S = O.getX(E + 1), A = O.getX(E + 2), (y = v(this, _, h, t, R, I, w, S, A)) && (y.faceIndex = Math.floor(E / 3), p.push(y));
                  } else if (void 0 !== R) if (Array.isArray(_)) for (E = 0, M = j.length; E < M; E++) for (P = _[(k = j[E]).materialIndex], T = Math.max(k.start, N.start), C = Math.min(k.start + k.count, N.start + N.count); T < C; T += 3) (y = v(this, P, h, t, R, I, w = T, S = T + 1, A = T + 2)) && (y.faceIndex = Math.floor(T / 3), p.push(y));else for (E = Math.max(0, N.start), M = Math.min(R.count, N.start + N.count); E < M; E += 3) (y = v(this, _, h, t, R, I, w = E, S = E + 1, A = E + 2)) && (y.faceIndex = Math.floor(E / 3), p.push(y));
                } else if (b.isGeometry) {
                  var L,
                    D,
                    B,
                    F,
                    z = Array.isArray(_),
                    U = b.vertices,
                    G = b.faces,
                    V = b.faceVertexUvs[0];
                  0 < V.length && (F = V);
                  for (var H = 0, q = G.length; H < q; H++) {
                    var W = G[H],
                      $ = z ? _[W.materialIndex] : _;
                    if (void 0 !== $) {
                      if (L = U[W.a], D = U[W.b], B = U[W.c], !0 === $.morphTargets) {
                        var X = b.morphTargets,
                          Y = this.morphTargetInfluences;
                        r.set(0, 0, 0), i.set(0, 0, 0), o.set(0, 0, 0);
                        for (var K = 0, Z = X.length; K < Z; K++) {
                          var Q = Y[K];
                          if (0 !== Q) {
                            var J = X[K].vertices;
                            r.addScaledVector(a.subVectors(J[W.a], L), Q), i.addScaledVector(s.subVectors(J[W.b], D), Q), o.addScaledVector(l.subVectors(J[W.c], B), Q);
                          }
                        }
                        r.add(L), i.add(D), o.add(B), L = r, D = i, B = o;
                      }
                      if (y = g(this, $, h, t, L, D, B, f)) {
                        if (F && F[H]) {
                          var ee = F[H];
                          u.copy(ee[0]), c.copy(ee[1]), d.copy(ee[2]), y.uv = m(f, L, D, B, u, c, d);
                        }
                        y.face = W, y.faceIndex = H, p.push(y);
                      }
                    }
                  }
                }
              };
            }(),
            clone: function clone() {
              return new this.constructor(this.geometry, this.material).copy(this);
            }
          }), ((Vn.prototype = Object.create(Te.prototype)).constructor = Vn).prototype.isCubeTexture = !0, Object.defineProperty(Vn.prototype, "images", {
            get: function get() {
              return this.image;
            },
            set: function set(e) {
              this.image = e;
            }
          });
          var Hn = new Te(),
            qn = new Vn();
          function Wn() {
            this.seq = [], this.map = {};
          }
          var $n = [],
            Xn = [],
            Yn = new Float32Array(16),
            Kn = new Float32Array(9),
            Zn = new Float32Array(4);
          function Qn(e, t, n) {
            var r = e[0];
            if (r <= 0 || 0 < r) return e;
            var i = t * n,
              o = $n[i];
            if (void 0 === o && (o = new Float32Array(i), $n[i] = o), 0 !== t) {
              r.toArray(o, 0);
              for (var a = 1, s = 0; a !== t; ++a) s += n, e[a].toArray(o, s);
            }
            return o;
          }
          function Jn(e, t) {
            if (e.length !== t.length) return !1;
            for (var n = 0, r = e.length; n < r; n++) if (e[n] !== t[n]) return !1;
            return !0;
          }
          function er(e, t) {
            for (var n = 0, r = t.length; n < r; n++) e[n] = t[n];
          }
          function tr(e, t) {
            var n = Xn[t];
            void 0 === n && (n = new Int32Array(t), Xn[t] = n);
            for (var r = 0; r !== t; ++r) n[r] = e.allocTextureUnit();
            return n;
          }
          function nr(e, t) {
            var n = this.cache;
            n[0] !== t && (e.uniform1f(this.addr, t), n[0] = t);
          }
          function rr(e, t) {
            var n = this.cache;
            n[0] !== t && (e.uniform1i(this.addr, t), n[0] = t);
          }
          function ir(e, t) {
            var n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e.uniform2f(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);else {
              if (Jn(n, t)) return;
              e.uniform2fv(this.addr, t), er(n, t);
            }
          }
          function or(e, t) {
            var n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e.uniform3f(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);else if (void 0 !== t.r) n[0] === t.r && n[1] === t.g && n[2] === t.b || (e.uniform3f(this.addr, t.r, t.g, t.b), n[0] = t.r, n[1] = t.g, n[2] = t.b);else {
              if (Jn(n, t)) return;
              e.uniform3fv(this.addr, t), er(n, t);
            }
          }
          function ar(e, t) {
            var n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e.uniform4f(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);else {
              if (Jn(n, t)) return;
              e.uniform4fv(this.addr, t), er(n, t);
            }
          }
          function sr(e, t) {
            var n = this.cache,
              r = t.elements;
            if (void 0 === r) {
              if (Jn(n, t)) return;
              e.uniformMatrix2fv(this.addr, !1, t), er(n, t);
            } else {
              if (Jn(n, r)) return;
              Zn.set(r), e.uniformMatrix2fv(this.addr, !1, Zn), er(n, r);
            }
          }
          function lr(e, t) {
            var n = this.cache,
              r = t.elements;
            if (void 0 === r) {
              if (Jn(n, t)) return;
              e.uniformMatrix3fv(this.addr, !1, t), er(n, t);
            } else {
              if (Jn(n, r)) return;
              Kn.set(r), e.uniformMatrix3fv(this.addr, !1, Kn), er(n, r);
            }
          }
          function ur(e, t) {
            var n = this.cache,
              r = t.elements;
            if (void 0 === r) {
              if (Jn(n, t)) return;
              e.uniformMatrix4fv(this.addr, !1, t), er(n, t);
            } else {
              if (Jn(n, r)) return;
              Yn.set(r), e.uniformMatrix4fv(this.addr, !1, Yn), er(n, r);
            }
          }
          function cr(e, t, n) {
            var r = this.cache,
              i = n.allocTextureUnit();
            r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTexture2D(t || Hn, i);
          }
          function dr(e, t, n) {
            var r = this.cache,
              i = n.allocTextureUnit();
            r[0] !== i && (e.uniform1i(this.addr, i), r[0] = i), n.setTextureCube(t || qn, i);
          }
          function hr(e, t) {
            var n = this.cache;
            Jn(n, t) || (e.uniform2iv(this.addr, t), er(n, t));
          }
          function fr(e, t) {
            var n = this.cache;
            Jn(n, t) || (e.uniform3iv(this.addr, t), er(n, t));
          }
          function pr(e, t) {
            var n = this.cache;
            Jn(n, t) || (e.uniform4iv(this.addr, t), er(n, t));
          }
          function mr(e, t) {
            var n = this.cache;
            Jn(n, t) || (e.uniform1fv(this.addr, t), er(n, t));
          }
          function gr(e, t) {
            var n = this.cache;
            Jn(n, t) || (e.uniform1iv(this.addr, t), er(n, t));
          }
          function vr(e, t) {
            var n = this.cache,
              r = Qn(t, this.size, 2);
            Jn(n, r) || (e.uniform2fv(this.addr, r), this.updateCache(r));
          }
          function yr(e, t) {
            var n = this.cache,
              r = Qn(t, this.size, 3);
            Jn(n, r) || (e.uniform3fv(this.addr, r), this.updateCache(r));
          }
          function br(e, t) {
            var n = this.cache,
              r = Qn(t, this.size, 4);
            Jn(n, r) || (e.uniform4fv(this.addr, r), this.updateCache(r));
          }
          function _r(e, t) {
            var n = this.cache,
              r = Qn(t, this.size, 4);
            Jn(n, r) || (e.uniformMatrix2fv(this.addr, !1, r), this.updateCache(r));
          }
          function xr(e, t) {
            var n = this.cache,
              r = Qn(t, this.size, 9);
            Jn(n, r) || (e.uniformMatrix3fv(this.addr, !1, r), this.updateCache(r));
          }
          function wr(e, t) {
            var n = this.cache,
              r = Qn(t, this.size, 16);
            Jn(n, r) || (e.uniformMatrix4fv(this.addr, !1, r), this.updateCache(r));
          }
          function Sr(e, t, n) {
            var r = this.cache,
              i = t.length,
              o = tr(n, i);
            !1 === Jn(r, o) && (e.uniform1iv(this.addr, o), er(r, o));
            for (var a = 0; a !== i; ++a) n.setTexture2D(t[a] || Hn, o[a]);
          }
          function Ar(e, t, n) {
            var r = this.cache,
              i = t.length,
              o = tr(n, i);
            !1 === Jn(r, o) && (e.uniform1iv(this.addr, o), er(r, o));
            for (var a = 0; a !== i; ++a) n.setTextureCube(t[a] || qn, o[a]);
          }
          function Er(e, t, n) {
            this.id = e, this.addr = n, this.cache = [], this.setValue = function (e) {
              switch (e) {
                case 5126:
                  return nr;
                case 35664:
                  return ir;
                case 35665:
                  return or;
                case 35666:
                  return ar;
                case 35674:
                  return sr;
                case 35675:
                  return lr;
                case 35676:
                  return ur;
                case 35678:
                case 36198:
                  return cr;
                case 35680:
                  return dr;
                case 5124:
                case 35670:
                  return rr;
                case 35667:
                case 35671:
                  return hr;
                case 35668:
                case 35672:
                  return fr;
                case 35669:
                case 35673:
                  return pr;
              }
            }(t.type);
          }
          function Tr(e, t, n) {
            this.id = e, this.addr = n, this.cache = [], this.size = t.size, this.setValue = function (e) {
              switch (e) {
                case 5126:
                  return mr;
                case 35664:
                  return vr;
                case 35665:
                  return yr;
                case 35666:
                  return br;
                case 35674:
                  return _r;
                case 35675:
                  return xr;
                case 35676:
                  return wr;
                case 35678:
                  return Sr;
                case 35680:
                  return Ar;
                case 5124:
                case 35670:
                  return gr;
                case 35667:
                case 35671:
                  return hr;
                case 35668:
                case 35672:
                  return fr;
                case 35669:
                case 35673:
                  return pr;
              }
            }(t.type);
          }
          function Mr(e) {
            this.id = e, Wn.call(this);
          }
          Tr.prototype.updateCache = function (e) {
            var t = this.cache;
            e instanceof Float32Array && t.length !== e.length && (this.cache = new Float32Array(e.length)), er(t, e);
          }, Mr.prototype.setValue = function (e, t, n) {
            for (var r = this.seq, i = 0, o = r.length; i !== o; ++i) {
              var a = r[i];
              a.setValue(e, t[a.id], n);
            }
          };
          var Cr = /([\w\d_]+)(\])?(\[|\.)?/g;
          function kr(e, t) {
            e.seq.push(t), e.map[t.id] = t;
          }
          function Pr(e, t, n) {
            var r = e.name,
              i = r.length;
            for (Cr.lastIndex = 0;;) {
              var o = Cr.exec(r),
                a = Cr.lastIndex,
                s = o[1],
                l = "]" === o[2],
                u = o[3];
              if (l && (s |= 0), void 0 === u || "[" === u && a + 2 === i) {
                kr(n, void 0 === u ? new Er(s, e, t) : new Tr(s, e, t));
                break;
              }
              var c = n.map[s];
              void 0 === c && kr(n, c = new Mr(s)), n = c;
            }
          }
          function Or(e, t, n) {
            Wn.call(this), this.renderer = n;
            for (var r = e.getProgramParameter(t, e.ACTIVE_UNIFORMS), i = 0; i < r; ++i) {
              var o = e.getActiveUniform(t, i);
              Pr(o, e.getUniformLocation(t, o.name), this);
            }
          }
          function Rr(e, t, n) {
            var r = e.createShader(t);
            return e.shaderSource(r, n), e.compileShader(r), !1 === e.getShaderParameter(r, e.COMPILE_STATUS) && console.error("THREE.WebGLShader: Shader couldn't compile."), "" !== e.getShaderInfoLog(r) && console.warn("THREE.WebGLShader: gl.getShaderInfoLog()", t === e.VERTEX_SHADER ? "vertex" : "fragment", e.getShaderInfoLog(r), function (e) {
              for (var t = e.split("\n"), n = 0; n < t.length; n++) t[n] = n + 1 + ": " + t[n];
              return t.join("\n");
            }(n)), r;
          }
          Or.prototype.setValue = function (e, t, n) {
            var r = this.map[t];
            void 0 !== r && r.setValue(e, n, this.renderer);
          }, Or.prototype.setOptional = function (e, t, n) {
            var r = t[n];
            void 0 !== r && this.setValue(e, n, r);
          }, Or.upload = function (e, t, n, r) {
            for (var i = 0, o = t.length; i !== o; ++i) {
              var a = t[i],
                s = n[a.id];
              !1 !== s.needsUpdate && a.setValue(e, s.value, r);
            }
          }, Or.seqWithValue = function (e, t) {
            for (var n = [], r = 0, i = e.length; r !== i; ++r) {
              var o = e[r];
              o.id in t && n.push(o);
            }
            return n;
          };
          var Ir = 0;
          function jr(e) {
            switch (e) {
              case 3e3:
                return ["Linear", "( value )"];
              case 3001:
                return ["sRGB", "( value )"];
              case 3002:
                return ["RGBE", "( value )"];
              case 3004:
                return ["RGBM", "( value, 7.0 )"];
              case 3005:
                return ["RGBM", "( value, 16.0 )"];
              case 3006:
                return ["RGBD", "( value, 256.0 )"];
              case 3007:
                return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];
              default:
                throw new Error("unsupported encoding: " + e);
            }
          }
          function Nr(e, t) {
            var n = jr(t);
            return "vec4 " + e + "( vec4 value ) { return " + n[0] + "ToLinear" + n[1] + "; }";
          }
          function Lr(e) {
            return "" !== e;
          }
          function Dr(e, t) {
            return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights);
          }
          function Br(e, t) {
            return e.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
          }
          function Fr(e) {
            return e.replace(/^[ \t]*#include +<([\w\d./]+)>/gm, function (e, t) {
              var n = Le[t];
              if (void 0 === n) throw new Error("Can not resolve #include <" + t + ">");
              return Fr(n);
            });
          }
          function zr(e) {
            return e.replace(/#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g, function (e, t, n, r) {
              for (var i = "", o = parseInt(t); o < parseInt(n); o++) i += r.replace(/\[ i \]/g, "[ " + o + " ]");
              return i;
            });
          }
          function Ur(e, t, n, r, i, o, a) {
            var s = e.context,
              l = r.defines,
              u = i.vertexShader,
              c = i.fragmentShader,
              d = "SHADOWMAP_TYPE_BASIC";
            1 === o.shadowMapType ? d = "SHADOWMAP_TYPE_PCF" : 2 === o.shadowMapType && (d = "SHADOWMAP_TYPE_PCF_SOFT");
            var h = "ENVMAP_TYPE_CUBE",
              f = "ENVMAP_MODE_REFLECTION",
              p = "ENVMAP_BLENDING_MULTIPLY";
            if (o.envMap) {
              switch (r.envMap.mapping) {
                case 301:
                case 302:
                  h = "ENVMAP_TYPE_CUBE";
                  break;
                case 306:
                case 307:
                  h = "ENVMAP_TYPE_CUBE_UV";
                  break;
                case 303:
                case 304:
                  h = "ENVMAP_TYPE_EQUIREC";
                  break;
                case 305:
                  h = "ENVMAP_TYPE_SPHERE";
              }
              switch (r.envMap.mapping) {
                case 302:
                case 304:
                  f = "ENVMAP_MODE_REFRACTION";
              }
              switch (r.combine) {
                case 0:
                  p = "ENVMAP_BLENDING_MULTIPLY";
                  break;
                case 1:
                  p = "ENVMAP_BLENDING_MIX";
                  break;
                case 2:
                  p = "ENVMAP_BLENDING_ADD";
              }
            }
            var m,
              g,
              v,
              y,
              b,
              _,
              x,
              w = 0 < e.gammaFactor ? e.gammaFactor : 1,
              S = a.isWebGL2 ? "" : (g = o, v = t, [(m = (m = r.extensions) || {}).derivatives || g.envMapCubeUV || g.bumpMap || g.normalMap && !g.objectSpaceNormalMap || g.flatShading ? "#extension GL_OES_standard_derivatives : enable" : "", (m.fragDepth || g.logarithmicDepthBuffer) && v.get("EXT_frag_depth") ? "#extension GL_EXT_frag_depth : enable" : "", m.drawBuffers && v.get("WEBGL_draw_buffers") ? "#extension GL_EXT_draw_buffers : require" : "", (m.shaderTextureLOD || g.envMap) && v.get("EXT_shader_texture_lod") ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(Lr).join("\n")),
              A = function (e) {
                var t = [];
                for (var n in e) {
                  var r = e[n];
                  !1 !== r && t.push("#define " + n + " " + r);
                }
                return t.join("\n");
              }(l),
              E = s.createProgram();
            if (r.isRawShaderMaterial ? (0 < (y = [A].filter(Lr).join("\n")).length && (y += "\n"), 0 < (b = [S, A].filter(Lr).join("\n")).length && (b += "\n")) : (y = ["precision " + o.precision + " float;", "precision " + o.precision + " int;", "#define SHADER_NAME " + i.name, A, o.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define GAMMA_FACTOR " + w, "#define MAX_BONES " + o.maxBones, o.useFog && o.fog ? "#define USE_FOG" : "", o.useFog && o.fogExp ? "#define FOG_EXP2" : "", o.map ? "#define USE_MAP" : "", o.envMap ? "#define USE_ENVMAP" : "", o.envMap ? "#define " + f : "", o.lightMap ? "#define USE_LIGHTMAP" : "", o.aoMap ? "#define USE_AOMAP" : "", o.emissiveMap ? "#define USE_EMISSIVEMAP" : "", o.bumpMap ? "#define USE_BUMPMAP" : "", o.normalMap ? "#define USE_NORMALMAP" : "", o.normalMap && o.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", o.displacementMap && o.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", o.specularMap ? "#define USE_SPECULARMAP" : "", o.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", o.metalnessMap ? "#define USE_METALNESSMAP" : "", o.alphaMap ? "#define USE_ALPHAMAP" : "", o.vertexColors ? "#define USE_COLOR" : "", o.flatShading ? "#define FLAT_SHADED" : "", o.skinning ? "#define USE_SKINNING" : "", o.useVertexTexture ? "#define BONE_TEXTURE" : "", o.morphTargets ? "#define USE_MORPHTARGETS" : "", o.morphNormals && !1 === o.flatShading ? "#define USE_MORPHNORMALS" : "", o.doubleSided ? "#define DOUBLE_SIDED" : "", o.flipSided ? "#define FLIP_SIDED" : "", o.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", o.shadowMapEnabled ? "#define " + d : "", o.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", o.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", o.logarithmicDepthBuffer && (a.isWebGL2 || t.get("EXT_frag_depth")) ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_COLOR", "\tattribute vec3 color;", "#endif", "#ifdef USE_MORPHTARGETS", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(Lr).join("\n"), b = [S, "precision " + o.precision + " float;", "precision " + o.precision + " int;", "#define SHADER_NAME " + i.name, A, o.alphaTest ? "#define ALPHATEST " + o.alphaTest + (o.alphaTest % 1 ? "" : ".0") : "", "#define GAMMA_FACTOR " + w, o.useFog && o.fog ? "#define USE_FOG" : "", o.useFog && o.fogExp ? "#define FOG_EXP2" : "", o.map ? "#define USE_MAP" : "", o.envMap ? "#define USE_ENVMAP" : "", o.envMap ? "#define " + h : "", o.envMap ? "#define " + f : "", o.envMap ? "#define " + p : "", o.lightMap ? "#define USE_LIGHTMAP" : "", o.aoMap ? "#define USE_AOMAP" : "", o.emissiveMap ? "#define USE_EMISSIVEMAP" : "", o.bumpMap ? "#define USE_BUMPMAP" : "", o.normalMap ? "#define USE_NORMALMAP" : "", o.normalMap && o.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "", o.specularMap ? "#define USE_SPECULARMAP" : "", o.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", o.metalnessMap ? "#define USE_METALNESSMAP" : "", o.alphaMap ? "#define USE_ALPHAMAP" : "", o.vertexColors ? "#define USE_COLOR" : "", o.gradientMap ? "#define USE_GRADIENTMAP" : "", o.flatShading ? "#define FLAT_SHADED" : "", o.doubleSided ? "#define DOUBLE_SIDED" : "", o.flipSided ? "#define FLIP_SIDED" : "", o.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", o.shadowMapEnabled ? "#define " + d : "", o.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", o.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", o.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", o.logarithmicDepthBuffer && (a.isWebGL2 || t.get("EXT_frag_depth")) ? "#define USE_LOGDEPTHBUF_EXT" : "", o.envMap && (a.isWebGL2 || t.get("EXT_shader_texture_lod")) ? "#define TEXTURE_LOD_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", 0 !== o.toneMapping ? "#define TONE_MAPPING" : "", 0 !== o.toneMapping ? Le.tonemapping_pars_fragment : "", 0 !== o.toneMapping ? function (e, t) {
              var n;
              switch (t) {
                case 1:
                  n = "Linear";
                  break;
                case 2:
                  n = "Reinhard";
                  break;
                case 3:
                  n = "Uncharted2";
                  break;
                case 4:
                  n = "OptimizedCineon";
                  break;
                default:
                  throw new Error("unsupported toneMapping: " + t);
              }
              return "vec3 toneMapping( vec3 color ) { return " + n + "ToneMapping( color ); }";
            }(0, o.toneMapping) : "", o.dithering ? "#define DITHERING" : "", o.outputEncoding || o.mapEncoding || o.envMapEncoding || o.emissiveMapEncoding ? Le.encodings_pars_fragment : "", o.mapEncoding ? Nr("mapTexelToLinear", o.mapEncoding) : "", o.envMapEncoding ? Nr("envMapTexelToLinear", o.envMapEncoding) : "", o.emissiveMapEncoding ? Nr("emissiveMapTexelToLinear", o.emissiveMapEncoding) : "", o.outputEncoding ? (_ = o.outputEncoding, x = jr(_), "vec4 linearToOutputTexel( vec4 value ) { return LinearTo" + x[0] + x[1] + "; }") : "", o.depthPacking ? "#define DEPTH_PACKING " + r.depthPacking : "", "\n"].filter(Lr).join("\n")), u = Br(u = Dr(u = Fr(u), o), o), c = Br(c = Dr(c = Fr(c), o), o), u = zr(u), c = zr(c), a.isWebGL2 && !r.isRawShaderMaterial) {
              var T = !1,
                M = /^\s*#version\s+300\s+es\s*\n/;
              r.isShaderMaterial && null !== u.match(M) && null !== c.match(M) && (T = !0, u = u.replace(M, ""), c = c.replace(M, "")), y = ["#version 300 es\n", "#define attribute in", "#define varying out", "#define texture2D texture"].join("\n") + "\n" + y, b = ["#version 300 es\n", "#define varying in", T ? "" : "out highp vec4 pc_fragColor;", T ? "" : "#define gl_FragColor pc_fragColor", "#define gl_FragDepthEXT gl_FragDepth", "#define texture2D texture", "#define textureCube texture", "#define texture2DProj textureProj", "#define texture2DLodEXT textureLod", "#define texture2DProjLodEXT textureProjLod", "#define textureCubeLodEXT textureLod", "#define texture2DGradEXT textureGrad", "#define texture2DProjGradEXT textureProjGrad", "#define textureCubeGradEXT textureGrad"].join("\n") + "\n" + b;
            }
            var C = y + u,
              k = b + c,
              P = Rr(s, s.VERTEX_SHADER, C),
              O = Rr(s, s.FRAGMENT_SHADER, k);
            s.attachShader(E, P), s.attachShader(E, O), void 0 !== r.index0AttributeName ? s.bindAttribLocation(E, 0, r.index0AttributeName) : !0 === o.morphTargets && s.bindAttribLocation(E, 0, "position"), s.linkProgram(E);
            var R,
              I,
              j = s.getProgramInfoLog(E).trim(),
              N = s.getShaderInfoLog(P).trim(),
              L = s.getShaderInfoLog(O).trim(),
              D = !0,
              B = !0;
            return !1 === s.getProgramParameter(E, s.LINK_STATUS) ? (D = !1, console.error("THREE.WebGLProgram: shader error: ", s.getError(), "gl.VALIDATE_STATUS", s.getProgramParameter(E, s.VALIDATE_STATUS), "gl.getProgramInfoLog", j, N, L)) : "" !== j ? console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", j) : "" !== N && "" !== L || (B = !1), B && (this.diagnostics = {
              runnable: D,
              material: r,
              programLog: j,
              vertexShader: {
                log: N,
                prefix: y
              },
              fragmentShader: {
                log: L,
                prefix: b
              }
            }), s.deleteShader(P), s.deleteShader(O), this.getUniforms = function () {
              return void 0 === R && (R = new Or(s, E, e)), R;
            }, this.getAttributes = function () {
              return void 0 === I && (I = function (e, t) {
                for (var n = {}, r = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES), i = 0; i < r; i++) {
                  var o = e.getActiveAttrib(t, i).name;
                  n[o] = e.getAttribLocation(t, o);
                }
                return n;
              }(s, E)), I;
            }, this.destroy = function () {
              s.deleteProgram(E), this.program = void 0;
            }, Object.defineProperties(this, {
              uniforms: {
                get: function get() {
                  return console.warn("THREE.WebGLProgram: .uniforms is now .getUniforms()."), this.getUniforms();
                }
              },
              attributes: {
                get: function get() {
                  return console.warn("THREE.WebGLProgram: .attributes is now .getAttributes()."), this.getAttributes();
                }
              }
            }), this.name = i.name, this.id = Ir++, this.code = n, this.usedTimes = 1, this.program = E, this.vertexShader = P, this.fragmentShader = O, this;
          }
          function Gr(e, t, n) {
            var r = [],
              i = {
                MeshDepthMaterial: "depth",
                MeshDistanceMaterial: "distanceRGBA",
                MeshNormalMaterial: "normal",
                MeshBasicMaterial: "basic",
                MeshLambertMaterial: "lambert",
                MeshPhongMaterial: "phong",
                MeshToonMaterial: "phong",
                MeshStandardMaterial: "physical",
                MeshPhysicalMaterial: "physical",
                LineBasicMaterial: "basic",
                LineDashedMaterial: "dashed",
                PointsMaterial: "points",
                ShadowMaterial: "shadow",
                SpriteMaterial: "sprite"
              },
              o = ["precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding", "lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "objectSpaceNormalMap", "displacementMap", "specularMap", "roughnessMap", "metalnessMap", "gradientMap", "alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp", "flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning", "maxBones", "useVertexTexture", "morphTargets", "morphNormals", "maxMorphTargets", "maxMorphNormals", "premultipliedAlpha", "numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights", "shadowMapEnabled", "shadowMapType", "toneMapping", "physicallyCorrectLights", "alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"];
            function a(e, t) {
              var n;
              return e ? e.isTexture ? n = e.encoding : e.isWebGLRenderTarget && (console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."), n = e.texture.encoding) : n = 3e3, 3e3 === n && t && (n = 3007), n;
            }
            this.getParameters = function (t, r, o, s, l, u, c) {
              var d = i[t.type],
                h = c.isSkinnedMesh ? function (e) {
                  var t = e.skeleton.bones;
                  if (n.floatVertexTextures) return 1024;
                  var r = n.maxVertexUniforms,
                    i = Math.floor((r - 20) / 4),
                    o = Math.min(i, t.length);
                  return o < t.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + t.length + " bones. This GPU supports " + o + "."), 0) : o;
                }(c) : 0,
                f = n.precision;
              null !== t.precision && (f = n.getMaxPrecision(t.precision)) !== t.precision && console.warn("THREE.WebGLProgram.getParameters:", t.precision, "not supported, using", f, "instead.");
              var p = e.getRenderTarget();
              return {
                shaderID: d,
                precision: f,
                supportsVertexTextures: n.vertexTextures,
                outputEncoding: a(p ? p.texture : null, e.gammaOutput),
                map: !!t.map,
                mapEncoding: a(t.map, e.gammaInput),
                envMap: !!t.envMap,
                envMapMode: t.envMap && t.envMap.mapping,
                envMapEncoding: a(t.envMap, e.gammaInput),
                envMapCubeUV: !!t.envMap && (306 === t.envMap.mapping || 307 === t.envMap.mapping),
                lightMap: !!t.lightMap,
                aoMap: !!t.aoMap,
                emissiveMap: !!t.emissiveMap,
                emissiveMapEncoding: a(t.emissiveMap, e.gammaInput),
                bumpMap: !!t.bumpMap,
                normalMap: !!t.normalMap,
                objectSpaceNormalMap: 1 === t.normalMapType,
                displacementMap: !!t.displacementMap,
                roughnessMap: !!t.roughnessMap,
                metalnessMap: !!t.metalnessMap,
                specularMap: !!t.specularMap,
                alphaMap: !!t.alphaMap,
                gradientMap: !!t.gradientMap,
                combine: t.combine,
                vertexColors: t.vertexColors,
                fog: !!s,
                useFog: t.fog,
                fogExp: s && s.isFogExp2,
                flatShading: t.flatShading,
                sizeAttenuation: t.sizeAttenuation,
                logarithmicDepthBuffer: n.logarithmicDepthBuffer,
                skinning: t.skinning && 0 < h,
                maxBones: h,
                useVertexTexture: n.floatVertexTextures,
                morphTargets: t.morphTargets,
                morphNormals: t.morphNormals,
                maxMorphTargets: e.maxMorphTargets,
                maxMorphNormals: e.maxMorphNormals,
                numDirLights: r.directional.length,
                numPointLights: r.point.length,
                numSpotLights: r.spot.length,
                numRectAreaLights: r.rectArea.length,
                numHemiLights: r.hemi.length,
                numClippingPlanes: l,
                numClipIntersection: u,
                dithering: t.dithering,
                shadowMapEnabled: e.shadowMap.enabled && c.receiveShadow && 0 < o.length,
                shadowMapType: e.shadowMap.type,
                toneMapping: e.toneMapping,
                physicallyCorrectLights: e.physicallyCorrectLights,
                premultipliedAlpha: t.premultipliedAlpha,
                alphaTest: t.alphaTest,
                doubleSided: 2 === t.side,
                flipSided: 1 === t.side,
                depthPacking: void 0 !== t.depthPacking && t.depthPacking
              };
            }, this.getProgramCode = function (t, n) {
              var r = [];
              if (n.shaderID ? r.push(n.shaderID) : (r.push(t.fragmentShader), r.push(t.vertexShader)), void 0 !== t.defines) for (var i in t.defines) r.push(i), r.push(t.defines[i]);
              for (var a = 0; a < o.length; a++) r.push(n[o[a]]);
              return r.push(t.onBeforeCompile.toString()), r.push(e.gammaOutput), r.join();
            }, this.acquireProgram = function (i, o, a, s) {
              for (var l, u = 0, c = r.length; u < c; u++) {
                var d = r[u];
                if (d.code === s) {
                  ++(l = d).usedTimes;
                  break;
                }
              }
              return void 0 === l && (l = new Ur(e, t, s, i, o, a, n), r.push(l)), l;
            }, this.releaseProgram = function (e) {
              if (0 == --e.usedTimes) {
                var t = r.indexOf(e);
                r[t] = r[r.length - 1], r.pop(), e.destroy();
              }
            }, this.programs = r;
          }
          function Vr() {
            var e = new WeakMap();
            return {
              get: function get(t) {
                var n = e.get(t);
                return void 0 === n && (n = {}, e.set(t, n)), n;
              },
              remove: function remove(t) {
                e.delete(t);
              },
              update: function update(t, n, r) {
                e.get(t)[n] = r;
              },
              dispose: function dispose() {
                e = new WeakMap();
              }
            };
          }
          function Hr(e, t) {
            return e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.program && t.program && e.program !== t.program ? e.program.id - t.program.id : e.material.id !== t.material.id ? e.material.id - t.material.id : e.z !== t.z ? e.z - t.z : e.id - t.id;
          }
          function qr(e, t) {
            return e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.z !== t.z ? t.z - e.z : e.id - t.id;
          }
          function Wr() {
            var e = [],
              t = 0,
              n = [],
              r = [];
            return {
              opaque: n,
              transparent: r,
              init: function init() {
                t = 0, n.length = 0, r.length = 0;
              },
              push: function push(i, o, a, s, l) {
                var u = e[t];
                void 0 === u ? (u = {
                  id: i.id,
                  object: i,
                  geometry: o,
                  material: a,
                  program: a.program,
                  renderOrder: i.renderOrder,
                  z: s,
                  group: l
                }, e[t] = u) : (u.id = i.id, u.object = i, u.geometry = o, u.material = a, u.program = a.program, u.renderOrder = i.renderOrder, u.z = s, u.group = l), (!0 === a.transparent ? r : n).push(u), t++;
              },
              sort: function sort() {
                1 < n.length && n.sort(Hr), 1 < r.length && r.sort(qr);
              }
            };
          }
          function $r() {
            var e = {};
            return {
              get: function get(t, n) {
                var r = t.id + "," + n.id,
                  i = e[r];
                return void 0 === i && (i = new Wr(), e[r] = i), i;
              },
              dispose: function dispose() {
                e = {};
              }
            };
          }
          function Xr() {
            var e = {};
            return {
              get: function get(t) {
                if (void 0 !== e[t.id]) return e[t.id];
                var n;
                switch (t.type) {
                  case "DirectionalLight":
                    n = {
                      direction: new ae(),
                      color: new Fe(),
                      shadow: !1,
                      shadowBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new re()
                    };
                    break;
                  case "SpotLight":
                    n = {
                      position: new ae(),
                      direction: new ae(),
                      color: new Fe(),
                      distance: 0,
                      coneCos: 0,
                      penumbraCos: 0,
                      decay: 0,
                      shadow: !1,
                      shadowBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new re()
                    };
                    break;
                  case "PointLight":
                    n = {
                      position: new ae(),
                      color: new Fe(),
                      distance: 0,
                      decay: 0,
                      shadow: !1,
                      shadowBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new re(),
                      shadowCameraNear: 1,
                      shadowCameraFar: 1e3
                    };
                    break;
                  case "HemisphereLight":
                    n = {
                      direction: new ae(),
                      skyColor: new Fe(),
                      groundColor: new Fe()
                    };
                    break;
                  case "RectAreaLight":
                    n = {
                      color: new Fe(),
                      position: new ae(),
                      halfWidth: new ae(),
                      halfHeight: new ae()
                    };
                }
                return e[t.id] = n;
              }
            };
          }
          var Yr,
            Kr,
            Zr,
            Qr,
            Jr,
            ei,
            ti,
            ni,
            ri,
            ii,
            oi,
            ai,
            si,
            li,
            ui,
            ci,
            di = 0;
          function hi() {
            var e = new Xr(),
              t = {
                id: di++,
                hash: {
                  stateID: -1,
                  directionalLength: -1,
                  pointLength: -1,
                  spotLength: -1,
                  rectAreaLength: -1,
                  hemiLength: -1,
                  shadowsLength: -1
                },
                ambient: [0, 0, 0],
                directional: [],
                directionalShadowMap: [],
                directionalShadowMatrix: [],
                spot: [],
                spotShadowMap: [],
                spotShadowMatrix: [],
                rectArea: [],
                point: [],
                pointShadowMap: [],
                pointShadowMatrix: [],
                hemi: []
              },
              n = new ae(),
              r = new ie(),
              i = new ie();
            return {
              setup: function setup(o, a, s) {
                for (var l = 0, u = 0, c = 0, d = 0, h = 0, f = 0, p = 0, m = 0, g = s.matrixWorldInverse, v = 0, y = o.length; v < y; v++) {
                  var b = o[v],
                    _ = b.color,
                    x = b.intensity,
                    w = b.distance,
                    S = b.shadow && b.shadow.map ? b.shadow.map.texture : null;
                  if (b.isAmbientLight) l += _.r * x, u += _.g * x, c += _.b * x;else if (b.isDirectionalLight) {
                    if ((E = e.get(b)).color.copy(b.color).multiplyScalar(b.intensity), E.direction.setFromMatrixPosition(b.matrixWorld), n.setFromMatrixPosition(b.target.matrixWorld), E.direction.sub(n), E.direction.transformDirection(g), E.shadow = b.castShadow, b.castShadow) {
                      var A = b.shadow;
                      E.shadowBias = A.bias, E.shadowRadius = A.radius, E.shadowMapSize = A.mapSize;
                    }
                    t.directionalShadowMap[d] = S, t.directionalShadowMatrix[d] = b.shadow.matrix, t.directional[d] = E, d++;
                  } else if (b.isSpotLight) (E = e.get(b)).position.setFromMatrixPosition(b.matrixWorld), E.position.applyMatrix4(g), E.color.copy(_).multiplyScalar(x), E.distance = w, E.direction.setFromMatrixPosition(b.matrixWorld), n.setFromMatrixPosition(b.target.matrixWorld), E.direction.sub(n), E.direction.transformDirection(g), E.coneCos = Math.cos(b.angle), E.penumbraCos = Math.cos(b.angle * (1 - b.penumbra)), E.decay = 0 === b.distance ? 0 : b.decay, E.shadow = b.castShadow, b.castShadow && (A = b.shadow, E.shadowBias = A.bias, E.shadowRadius = A.radius, E.shadowMapSize = A.mapSize), t.spotShadowMap[f] = S, t.spotShadowMatrix[f] = b.shadow.matrix, t.spot[f] = E, f++;else if (b.isRectAreaLight) (E = e.get(b)).color.copy(_).multiplyScalar(x), E.position.setFromMatrixPosition(b.matrixWorld), E.position.applyMatrix4(g), i.identity(), r.copy(b.matrixWorld), r.premultiply(g), i.extractRotation(r), E.halfWidth.set(.5 * b.width, 0, 0), E.halfHeight.set(0, .5 * b.height, 0), E.halfWidth.applyMatrix4(i), E.halfHeight.applyMatrix4(i), t.rectArea[p] = E, p++;else if (b.isPointLight) (E = e.get(b)).position.setFromMatrixPosition(b.matrixWorld), E.position.applyMatrix4(g), E.color.copy(b.color).multiplyScalar(b.intensity), E.distance = b.distance, E.decay = 0 === b.distance ? 0 : b.decay, E.shadow = b.castShadow, b.castShadow && (A = b.shadow, E.shadowBias = A.bias, E.shadowRadius = A.radius, E.shadowMapSize = A.mapSize, E.shadowCameraNear = A.camera.near, E.shadowCameraFar = A.camera.far), t.pointShadowMap[h] = S, t.pointShadowMatrix[h] = b.shadow.matrix, t.point[h] = E, h++;else if (b.isHemisphereLight) {
                    var E;
                    (E = e.get(b)).direction.setFromMatrixPosition(b.matrixWorld), E.direction.transformDirection(g), E.direction.normalize(), E.skyColor.copy(b.color).multiplyScalar(x), E.groundColor.copy(b.groundColor).multiplyScalar(x), t.hemi[m] = E, m++;
                  }
                }
                t.ambient[0] = l, t.ambient[1] = u, t.ambient[2] = c, t.directional.length = d, t.spot.length = f, t.rectArea.length = p, t.point.length = h, t.hemi.length = m, t.hash.stateID = t.id, t.hash.directionalLength = d, t.hash.pointLength = h, t.hash.spotLength = f, t.hash.rectAreaLength = p, t.hash.hemiLength = m, t.hash.shadowsLength = a.length;
              },
              state: t
            };
          }
          function fi() {
            var e = new hi(),
              t = [],
              n = [];
            return {
              init: function init() {
                t.length = 0, n.length = 0;
              },
              state: {
                lightsArray: t,
                shadowsArray: n,
                lights: e
              },
              setupLights: function setupLights(r) {
                e.setup(t, n, r);
              },
              pushLight: function pushLight(e) {
                t.push(e);
              },
              pushShadow: function pushShadow(e) {
                n.push(e);
              }
            };
          }
          function pi() {
            var e = {};
            return {
              get: function get(t, n) {
                var r;
                return void 0 === e[t.id] ? (r = new fi(), e[t.id] = {}, e[t.id][n.id] = r) : void 0 === e[t.id][n.id] ? (r = new fi(), e[t.id][n.id] = r) : r = e[t.id][n.id], r;
              },
              dispose: function dispose() {
                e = {};
              }
            };
          }
          function mi(e) {
            Tn.call(this), this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.skinning = !1, this.morphTargets = !1, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.setValues(e);
          }
          function gi(e) {
            Tn.call(this), this.type = "MeshDistanceMaterial", this.referencePosition = new ae(), this.nearDistance = 1, this.farDistance = 1e3, this.skinning = !1, this.morphTargets = !1, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.fog = !1, this.lights = !1, this.setValues(e);
          }
          function vi(e, t, n) {
            for (var r = new je(), i = new ie(), o = new re(), a = new re(n, n), s = new ae(), l = new ae(), u = new Array(4), c = new Array(4), d = {}, h = {
                0: 1,
                1: 0,
                2: 2
              }, f = [new ae(1, 0, 0), new ae(-1, 0, 0), new ae(0, 0, 1), new ae(0, 0, -1), new ae(0, 1, 0), new ae(0, -1, 0)], p = [new ae(0, 1, 0), new ae(0, 1, 0), new ae(0, 1, 0), new ae(0, 1, 0), new ae(0, 0, 1), new ae(0, 0, -1)], m = [new Me(), new Me(), new Me(), new Me(), new Me(), new Me()], g = 0; 4 !== g; ++g) {
              var v = 0 != (1 & g),
                y = 0 != (2 & g),
                b = new mi({
                  depthPacking: 3201,
                  morphTargets: v,
                  skinning: y
                });
              u[g] = b;
              var _ = new gi({
                morphTargets: v,
                skinning: y
              });
              c[g] = _;
            }
            var x = this;
            function w(t, n, r, i, o, a) {
              var s = t.geometry,
                l = null,
                f = u,
                p = t.customDepthMaterial;
              if (r && (f = c, p = t.customDistanceMaterial), p) l = p;else {
                var m = !1;
                n.morphTargets && (s && s.isBufferGeometry ? m = s.morphAttributes && s.morphAttributes.position && 0 < s.morphAttributes.position.length : s && s.isGeometry && (m = s.morphTargets && 0 < s.morphTargets.length)), t.isSkinnedMesh && !1 === n.skinning && console.warn("THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:", t);
                var g = 0;
                m && (g |= 1), t.isSkinnedMesh && n.skinning && (g |= 2), l = f[g];
              }
              if (e.localClippingEnabled && !0 === n.clipShadows && 0 !== n.clippingPlanes.length) {
                var v = l.uuid,
                  y = n.uuid,
                  b = d[v];
                void 0 === b && (b = {}, d[v] = b);
                var _ = b[y];
                void 0 === _ && (_ = l.clone(), b[y] = _), l = _;
              }
              return l.visible = n.visible, l.wireframe = n.wireframe, l.side = null != n.shadowSide ? n.shadowSide : h[n.side], l.clipShadows = n.clipShadows, l.clippingPlanes = n.clippingPlanes, l.clipIntersection = n.clipIntersection, l.wireframeLinewidth = n.wireframeLinewidth, l.linewidth = n.linewidth, r && l.isMeshDistanceMaterial && (l.referencePosition.copy(i), l.nearDistance = o, l.farDistance = a), l;
            }
            function S(n, i, o, a) {
              if (!1 !== n.visible) {
                if (n.layers.test(i.layers) && (n.isMesh || n.isLine || n.isPoints) && n.castShadow && (!n.frustumCulled || r.intersectsObject(n))) {
                  n.modelViewMatrix.multiplyMatrices(o.matrixWorldInverse, n.matrixWorld);
                  var s = t.update(n),
                    u = n.material;
                  if (Array.isArray(u)) for (var c = s.groups, d = 0, h = c.length; d < h; d++) {
                    var f = c[d],
                      p = u[f.materialIndex];
                    if (p && p.visible) {
                      var m = w(n, p, a, l, o.near, o.far);
                      e.renderBufferDirect(o, null, s, m, n, f);
                    }
                  } else u.visible && (m = w(n, u, a, l, o.near, o.far), e.renderBufferDirect(o, null, s, m, n, null));
                }
                for (var g = n.children, v = 0, y = g.length; v < y; v++) S(g[v], i, o, a);
              }
            }
            this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1, this.render = function (t, n, u) {
              if (!1 !== x.enabled && (!1 !== x.autoUpdate || !1 !== x.needsUpdate) && 0 !== t.length) {
                var c,
                  d = e.context,
                  h = e.state;
                h.disable(d.BLEND), h.buffers.color.setClear(1, 1, 1, 1), h.buffers.depth.setTest(!0), h.setScissorTest(!1);
                for (var g = 0, v = t.length; g < v; g++) {
                  var y = t[g],
                    b = y.shadow,
                    _ = y && y.isPointLight;
                  if (void 0 !== b) {
                    var w = b.camera;
                    if (o.copy(b.mapSize), o.min(a), _) {
                      var A = o.x,
                        E = o.y;
                      m[0].set(2 * A, E, A, E), m[1].set(0, E, A, E), m[2].set(3 * A, E, A, E), m[3].set(A, E, A, E), m[4].set(3 * A, 0, A, E), m[5].set(A, 0, A, E), o.x *= 4, o.y *= 2;
                    }
                    if (null === b.map) {
                      var T = {
                        minFilter: W,
                        magFilter: W,
                        format: Z
                      };
                      b.map = new Ce(o.x, o.y, T), b.map.texture.name = y.name + ".shadowMap", w.updateProjectionMatrix();
                    }
                    b.isSpotLightShadow && b.update(y);
                    var M = b.map,
                      C = b.matrix;
                    l.setFromMatrixPosition(y.matrixWorld), w.position.copy(l), _ ? (c = 6, C.makeTranslation(-l.x, -l.y, -l.z)) : (c = 1, s.setFromMatrixPosition(y.target.matrixWorld), w.lookAt(s), w.updateMatrixWorld(), C.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), C.multiply(w.projectionMatrix), C.multiply(w.matrixWorldInverse)), e.setRenderTarget(M), e.clear();
                    for (var k = 0; k < c; k++) {
                      if (_) {
                        s.copy(w.position), s.add(f[k]), w.up.copy(p[k]), w.lookAt(s), w.updateMatrixWorld();
                        var P = m[k];
                        h.viewport(P);
                      }
                      i.multiplyMatrices(w.projectionMatrix, w.matrixWorldInverse), r.setFromMatrix(i), S(n, u, w, _);
                    }
                  } else console.warn("THREE.WebGLShadowMap:", y, "has no shadow.");
                }
                x.needsUpdate = !1;
              }
            };
          }
          function yi(e, t, n, r) {
            var i = new function () {
                var t = !1,
                  n = new Me(),
                  r = null,
                  i = new Me(0, 0, 0, 0);
                return {
                  setMask: function setMask(n) {
                    r === n || t || (e.colorMask(n, n, n, n), r = n);
                  },
                  setLocked: function setLocked(e) {
                    t = e;
                  },
                  setClear: function setClear(t, r, o, a, s) {
                    !0 === s && (t *= a, r *= a, o *= a), n.set(t, r, o, a), !1 === i.equals(n) && (e.clearColor(t, r, o, a), i.copy(n));
                  },
                  reset: function reset() {
                    t = !1, r = null, i.set(-1, 0, 0, 0);
                  }
                };
              }(),
              o = new function () {
                var t = !1,
                  n = null,
                  r = null,
                  i = null;
                return {
                  setTest: function setTest(t) {
                    t ? B(e.DEPTH_TEST) : F(e.DEPTH_TEST);
                  },
                  setMask: function setMask(r) {
                    n === r || t || (e.depthMask(r), n = r);
                  },
                  setFunc: function setFunc(t) {
                    if (r !== t) {
                      if (t) switch (t) {
                        case 0:
                          e.depthFunc(e.NEVER);
                          break;
                        case 1:
                          e.depthFunc(e.ALWAYS);
                          break;
                        case 2:
                          e.depthFunc(e.LESS);
                          break;
                        case 3:
                          e.depthFunc(e.LEQUAL);
                          break;
                        case 4:
                          e.depthFunc(e.EQUAL);
                          break;
                        case 5:
                          e.depthFunc(e.GEQUAL);
                          break;
                        case 6:
                          e.depthFunc(e.GREATER);
                          break;
                        case 7:
                          e.depthFunc(e.NOTEQUAL);
                          break;
                        default:
                          e.depthFunc(e.LEQUAL);
                      } else e.depthFunc(e.LEQUAL);
                      r = t;
                    }
                  },
                  setLocked: function setLocked(e) {
                    t = e;
                  },
                  setClear: function setClear(t) {
                    i !== t && (e.clearDepth(t), i = t);
                  },
                  reset: function reset() {
                    t = !1, i = r = n = null;
                  }
                };
              }(),
              a = new function () {
                var t = !1,
                  n = null,
                  r = null,
                  i = null,
                  o = null,
                  a = null,
                  s = null,
                  l = null,
                  u = null;
                return {
                  setTest: function setTest(t) {
                    t ? B(e.STENCIL_TEST) : F(e.STENCIL_TEST);
                  },
                  setMask: function setMask(r) {
                    n === r || t || (e.stencilMask(r), n = r);
                  },
                  setFunc: function setFunc(t, n, a) {
                    r === t && i === n && o === a || (e.stencilFunc(t, n, a), r = t, i = n, o = a);
                  },
                  setOp: function setOp(t, n, r) {
                    a === t && s === n && l === r || (e.stencilOp(t, n, r), a = t, s = n, l = r);
                  },
                  setLocked: function setLocked(e) {
                    t = e;
                  },
                  setClear: function setClear(t) {
                    u !== t && (e.clearStencil(t), u = t);
                  },
                  reset: function reset() {
                    t = !1, u = l = s = a = o = i = r = n = null;
                  }
                };
              }(),
              s = e.getParameter(e.MAX_VERTEX_ATTRIBS),
              l = new Uint8Array(s),
              u = new Uint8Array(s),
              c = new Uint8Array(s),
              d = {},
              h = null,
              f = null,
              p = null,
              m = null,
              g = null,
              v = null,
              y = null,
              b = null,
              _ = null,
              x = !1,
              w = null,
              S = null,
              A = null,
              E = null,
              T = null,
              M = e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
              C = !1,
              k = 0,
              P = e.getParameter(e.VERSION);
            -1 !== P.indexOf("WebGL") ? (k = parseFloat(/^WebGL\ ([0-9])/.exec(P)[1]), C = 1 <= k) : -1 !== P.indexOf("OpenGL ES") && (k = parseFloat(/^OpenGL\ ES\ ([0-9])/.exec(P)[1]), C = 2 <= k);
            var O = null,
              R = {},
              I = new Me(),
              j = new Me();
            function N(t, n, r) {
              var i = new Uint8Array(4),
                o = e.createTexture();
              e.bindTexture(t, o), e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
              for (var a = 0; a < r; a++) e.texImage2D(n + a, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, i);
              return o;
            }
            var L = {};
            function D(n, i) {
              l[n] = 1, 0 === u[n] && (e.enableVertexAttribArray(n), u[n] = 1), c[n] !== i && ((r.isWebGL2 ? e : t.get("ANGLE_instanced_arrays"))[r.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, i), c[n] = i);
            }
            function B(t) {
              !0 !== d[t] && (e.enable(t), d[t] = !0);
            }
            function F(t) {
              !1 !== d[t] && (e.disable(t), d[t] = !1);
            }
            function z(t, r, i, o, a, s, l, u) {
              if (0 !== t ? B(e.BLEND) : F(e.BLEND), 5 !== t) {
                if (t !== p || u !== x) switch (t) {
                  case 2:
                    u ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ONE, e.ONE, e.ONE, e.ONE)) : (e.blendEquation(e.FUNC_ADD), e.blendFunc(e.SRC_ALPHA, e.ONE));
                    break;
                  case 3:
                    u ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ZERO, e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ONE_MINUS_SRC_ALPHA)) : (e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ZERO, e.ONE_MINUS_SRC_COLOR));
                    break;
                  case 4:
                    u ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ZERO, e.SRC_COLOR, e.ZERO, e.SRC_ALPHA)) : (e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ZERO, e.SRC_COLOR));
                    break;
                  default:
                    u ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA)) : (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA));
                }
                _ = b = y = v = g = m = null;
              } else a = a || r, s = s || i, l = l || o, r === m && a === y || (e.blendEquationSeparate(n.convert(r), n.convert(a)), m = r, y = a), i === g && o === v && s === b && l === _ || (e.blendFuncSeparate(n.convert(i), n.convert(o), n.convert(s), n.convert(l)), g = i, v = o, b = s, _ = l);
              p = t, x = u;
            }
            function U(t) {
              w !== t && (t ? e.frontFace(e.CW) : e.frontFace(e.CCW), w = t);
            }
            function G(t) {
              0 !== t ? (B(e.CULL_FACE), t !== S && (1 === t ? e.cullFace(e.BACK) : 2 === t ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))) : F(e.CULL_FACE), S = t;
            }
            function V(t, n, r) {
              t ? (B(e.POLYGON_OFFSET_FILL), E === n && T === r || (e.polygonOffset(n, r), E = n, T = r)) : F(e.POLYGON_OFFSET_FILL);
            }
            function H(t) {
              void 0 === t && (t = e.TEXTURE0 + M - 1), O !== t && (e.activeTexture(t), O = t);
            }
            return L[e.TEXTURE_2D] = N(e.TEXTURE_2D, e.TEXTURE_2D, 1), L[e.TEXTURE_CUBE_MAP] = N(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), i.setClear(0, 0, 0, 1), o.setClear(1), a.setClear(0), B(e.DEPTH_TEST), o.setFunc(3), U(!1), G(1), B(e.CULL_FACE), B(e.BLEND), z(1), {
              buffers: {
                color: i,
                depth: o,
                stencil: a
              },
              initAttributes: function initAttributes() {
                for (var e = 0, t = l.length; e < t; e++) l[e] = 0;
              },
              enableAttribute: function enableAttribute(e) {
                D(e, 0);
              },
              enableAttributeAndDivisor: D,
              disableUnusedAttributes: function disableUnusedAttributes() {
                for (var t = 0, n = u.length; t !== n; ++t) u[t] !== l[t] && (e.disableVertexAttribArray(t), u[t] = 0);
              },
              enable: B,
              disable: F,
              getCompressedTextureFormats: function getCompressedTextureFormats() {
                if (null === h && (h = [], t.get("WEBGL_compressed_texture_pvrtc") || t.get("WEBGL_compressed_texture_s3tc") || t.get("WEBGL_compressed_texture_etc1") || t.get("WEBGL_compressed_texture_astc"))) for (var n = e.getParameter(e.COMPRESSED_TEXTURE_FORMATS), r = 0; r < n.length; r++) h.push(n[r]);
                return h;
              },
              useProgram: function useProgram(t) {
                return f !== t && (e.useProgram(t), f = t, !0);
              },
              setBlending: z,
              setMaterial: function setMaterial(t, n) {
                2 === t.side ? F(e.CULL_FACE) : B(e.CULL_FACE);
                var r = 1 === t.side;
                n && (r = !r), U(r), 1 === t.blending && !1 === t.transparent ? z(0) : z(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.premultipliedAlpha), o.setFunc(t.depthFunc), o.setTest(t.depthTest), o.setMask(t.depthWrite), i.setMask(t.colorWrite), V(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits);
              },
              setFlipSided: U,
              setCullFace: G,
              setLineWidth: function setLineWidth(t) {
                t !== A && (C && e.lineWidth(t), A = t);
              },
              setPolygonOffset: V,
              setScissorTest: function setScissorTest(t) {
                t ? B(e.SCISSOR_TEST) : F(e.SCISSOR_TEST);
              },
              activeTexture: H,
              bindTexture: function bindTexture(t, n) {
                null === O && H();
                var r = R[O];
                void 0 === r && (r = {
                  type: void 0,
                  texture: void 0
                }, R[O] = r), r.type === t && r.texture === n || (e.bindTexture(t, n || L[t]), r.type = t, r.texture = n);
              },
              compressedTexImage2D: function compressedTexImage2D() {
                try {
                  e.compressedTexImage2D.apply(e, arguments);
                } catch (e) {
                  console.error("THREE.WebGLState:", e);
                }
              },
              texImage2D: function texImage2D() {
                try {
                  e.texImage2D.apply(e, arguments);
                } catch (e) {
                  console.error("THREE.WebGLState:", e);
                }
              },
              scissor: function scissor(t) {
                !1 === I.equals(t) && (e.scissor(t.x, t.y, t.z, t.w), I.copy(t));
              },
              viewport: function viewport(t) {
                !1 === j.equals(t) && (e.viewport(t.x, t.y, t.z, t.w), j.copy(t));
              },
              reset: function reset() {
                for (var t = 0; t < u.length; t++) 1 === u[t] && (e.disableVertexAttribArray(t), u[t] = 0);
                d = {}, R = {}, S = w = p = f = O = h = null, i.reset(), o.reset(), a.reset();
              }
            };
          }
          function bi(e, t, n, r, i, o, a) {
            var s,
              l = {};
            function u(e, t) {
              if (e.width > t || e.height > t) {
                if ("data" in e) return void console.warn("THREE.WebGLRenderer: image in DataTexture is too big (" + e.width + "x" + e.height + ").");
                var n = t / Math.max(e.width, e.height),
                  r = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
                return r.width = Math.floor(e.width * n), r.height = Math.floor(e.height * n), r.getContext("2d").drawImage(e, 0, 0, e.width, e.height, 0, 0, r.width, r.height), console.warn("THREE.WebGLRenderer: image is too big (" + e.width + "x" + e.height + "). Resized to " + r.width + "x" + r.height), r;
              }
              return e;
            }
            function c(e) {
              return ne.isPowerOfTwo(e.width) && ne.isPowerOfTwo(e.height);
            }
            function d(e, t) {
              return e.generateMipmaps && t && e.minFilter !== W && e.minFilter !== $;
            }
            function h(t, n, i, o) {
              e.generateMipmap(t), r.get(n).__maxMipLevel = Math.log(Math.max(i, o)) * Math.LOG2E;
            }
            function f(t, n) {
              if (!i.isWebGL2) return t;
              if (t === e.RGB) {
                if (n === e.FLOAT) return e.RGB32F;
                if (n === e.HALF_FLOAT) return e.RGB16F;
                if (n === e.UNSIGNED_BYTE) return e.RGB8;
              }
              if (t === e.RGBA) {
                if (n === e.FLOAT) return e.RGBA32F;
                if (n === e.HALF_FLOAT) return e.RGBA16F;
                if (n === e.UNSIGNED_BYTE) return e.RGBA8;
              }
              return t;
            }
            function p(t) {
              return t === W || 1004 === t || 1005 === t ? e.NEAREST : e.LINEAR;
            }
            function m(t) {
              var n = t.target;
              n.removeEventListener("dispose", m), function (t) {
                var n = r.get(t);
                if (t.image && n.__image__webglTextureCube) e.deleteTexture(n.__image__webglTextureCube);else {
                  if (void 0 === n.__webglInit) return;
                  e.deleteTexture(n.__webglTexture);
                }
                r.remove(t);
              }(n), n.isVideoTexture && delete l[n.id], a.memory.textures--;
            }
            function g(t) {
              var n = t.target;
              n.removeEventListener("dispose", g), function (t) {
                var n = r.get(t),
                  i = r.get(t.texture);
                if (t) {
                  if (void 0 !== i.__webglTexture && e.deleteTexture(i.__webglTexture), t.depthTexture && t.depthTexture.dispose(), t.isWebGLRenderTargetCube) for (var o = 0; o < 6; o++) e.deleteFramebuffer(n.__webglFramebuffer[o]), n.__webglDepthbuffer && e.deleteRenderbuffer(n.__webglDepthbuffer[o]);else e.deleteFramebuffer(n.__webglFramebuffer), n.__webglDepthbuffer && e.deleteRenderbuffer(n.__webglDepthbuffer);
                  r.remove(t.texture), r.remove(t);
                }
              }(n), a.memory.textures--;
            }
            function v(t, p) {
              var g,
                v,
                b,
                _ = r.get(t);
              if (t.isVideoTexture && (v = (g = t).id, b = a.render.frame, l[v] !== b && (l[v] = b, g.update())), 0 < t.version && _.__version !== t.version) {
                var x = t.image;
                if (void 0 === x) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");else {
                  if (!1 !== x.complete) return void function (t, r, l) {
                    void 0 === t.__webglInit && (t.__webglInit = !0, r.addEventListener("dispose", m), t.__webglTexture = e.createTexture(), a.memory.textures++), n.activeTexture(e.TEXTURE0 + l), n.bindTexture(e.TEXTURE_2D, t.__webglTexture), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, r.flipY), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), e.pixelStorei(e.UNPACK_ALIGNMENT, r.unpackAlignment);
                    var p,
                      g,
                      v = u(r.image, i.maxTextureSize);
                    g = r, i.isWebGL2 || g.wrapS === H && g.wrapT === H && (g.minFilter === W || g.minFilter === $) || !1 !== c(v) || (v = (p = v) instanceof HTMLImageElement || p instanceof HTMLCanvasElement || p instanceof ImageBitmap ? (void 0 === s && (s = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas")), s.width = ne.floorPowerOfTwo(p.width), s.height = ne.floorPowerOfTwo(p.height), s.getContext("2d").drawImage(p, 0, 0, s.width, s.height), console.warn("THREE.WebGLRenderer: image is not power of two (" + p.width + "x" + p.height + "). Resized to " + s.width + "x" + s.height), s) : p);
                    var b = c(v),
                      _ = o.convert(r.format),
                      x = o.convert(r.type),
                      w = f(_, x);
                    y(e.TEXTURE_2D, r, b);
                    var S,
                      A = r.mipmaps;
                    if (r.isDepthTexture) {
                      if (w = e.DEPTH_COMPONENT, r.type === Y) {
                        if (!i.isWebGL2) throw new Error("Float Depth Texture only supported in WebGL2.0");
                        w = e.DEPTH_COMPONENT32F;
                      } else i.isWebGL2 && (w = e.DEPTH_COMPONENT16);
                      r.format === Q && w === e.DEPTH_COMPONENT && 1012 !== r.type && 1014 !== r.type && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = 1012, x = o.convert(r.type)), r.format === J && (w = e.DEPTH_STENCIL, 1020 !== r.type && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = 1020, x = o.convert(r.type))), n.texImage2D(e.TEXTURE_2D, 0, w, v.width, v.height, 0, _, x, null);
                    } else if (r.isDataTexture) {
                      if (0 < A.length && b) {
                        for (var E = 0, T = A.length; E < T; E++) S = A[E], n.texImage2D(e.TEXTURE_2D, E, w, S.width, S.height, 0, _, x, S.data);
                        r.generateMipmaps = !1, t.__maxMipLevel = A.length - 1;
                      } else n.texImage2D(e.TEXTURE_2D, 0, w, v.width, v.height, 0, _, x, v.data), t.__maxMipLevel = 0;
                    } else if (r.isCompressedTexture) {
                      for (E = 0, T = A.length; E < T; E++) S = A[E], r.format !== Z && r.format !== K ? -1 < n.getCompressedTextureFormats().indexOf(_) ? n.compressedTexImage2D(e.TEXTURE_2D, E, w, S.width, S.height, 0, S.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : n.texImage2D(e.TEXTURE_2D, E, w, S.width, S.height, 0, _, x, S.data);
                      t.__maxMipLevel = A.length - 1;
                    } else if (0 < A.length && b) {
                      for (E = 0, T = A.length; E < T; E++) S = A[E], n.texImage2D(e.TEXTURE_2D, E, w, _, x, S);
                      r.generateMipmaps = !1, t.__maxMipLevel = A.length - 1;
                    } else n.texImage2D(e.TEXTURE_2D, 0, w, _, x, v), t.__maxMipLevel = 0;
                    d(r, b) && h(e.TEXTURE_2D, r, v.width, v.height), t.__version = r.version, r.onUpdate && r.onUpdate(r);
                  }(_, t, p);
                  console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                }
              }
              n.activeTexture(e.TEXTURE0 + p), n.bindTexture(e.TEXTURE_2D, _.__webglTexture);
            }
            function y(n, a, s) {
              var l;
              if (s ? (e.texParameteri(n, e.TEXTURE_WRAP_S, o.convert(a.wrapS)), e.texParameteri(n, e.TEXTURE_WRAP_T, o.convert(a.wrapT)), e.texParameteri(n, e.TEXTURE_MAG_FILTER, o.convert(a.magFilter)), e.texParameteri(n, e.TEXTURE_MIN_FILTER, o.convert(a.minFilter))) : (e.texParameteri(n, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(n, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), a.wrapS === H && a.wrapT === H || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), e.texParameteri(n, e.TEXTURE_MAG_FILTER, p(a.magFilter)), e.texParameteri(n, e.TEXTURE_MIN_FILTER, p(a.minFilter)), a.minFilter !== W && a.minFilter !== $ && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), l = t.get("EXT_texture_filter_anisotropic")) {
                if (a.type === Y && null === t.get("OES_texture_float_linear")) return;
                if (1016 === a.type && null === (i.isWebGL2 || t.get("OES_texture_half_float_linear"))) return;
                (1 < a.anisotropy || r.get(a).__currentAnisotropy) && (e.texParameterf(n, l.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, i.getMaxAnisotropy())), r.get(a).__currentAnisotropy = a.anisotropy);
              }
            }
            function b(t, i, a, s) {
              var l = o.convert(i.texture.format),
                u = o.convert(i.texture.type),
                c = f(l, u);
              n.texImage2D(s, 0, c, i.width, i.height, 0, l, u, null), e.bindFramebuffer(e.FRAMEBUFFER, t), e.framebufferTexture2D(e.FRAMEBUFFER, a, s, r.get(i.texture).__webglTexture, 0), e.bindFramebuffer(e.FRAMEBUFFER, null);
            }
            function _(t, n) {
              e.bindRenderbuffer(e.RENDERBUFFER, t), n.depthBuffer && !n.stencilBuffer ? (e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_COMPONENT16, n.width, n.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t)) : n.depthBuffer && n.stencilBuffer ? (e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_STENCIL, n.width, n.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.RENDERBUFFER, t)) : e.renderbufferStorage(e.RENDERBUFFER, e.RGBA4, n.width, n.height), e.bindRenderbuffer(e.RENDERBUFFER, null);
            }
            this.setTexture2D = v, this.setTextureCube = function (t, s) {
              var l = r.get(t);
              if (6 === t.image.length) if (0 < t.version && l.__version !== t.version) {
                l.__image__webglTextureCube || (t.addEventListener("dispose", m), l.__image__webglTextureCube = e.createTexture(), a.memory.textures++), n.activeTexture(e.TEXTURE0 + s), n.bindTexture(e.TEXTURE_CUBE_MAP, l.__image__webglTextureCube), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, t.flipY);
                for (var p = t && t.isCompressedTexture, g = t.image[0] && t.image[0].isDataTexture, v = [], b = 0; b < 6; b++) v[b] = p || g ? g ? t.image[b].image : t.image[b] : u(t.image[b], i.maxCubemapSize);
                var _ = v[0],
                  x = c(_),
                  w = o.convert(t.format),
                  S = o.convert(t.type),
                  A = f(w, S);
                for (y(e.TEXTURE_CUBE_MAP, t, x), b = 0; b < 6; b++) if (p) for (var E, T = v[b].mipmaps, M = 0, C = T.length; M < C; M++) E = T[M], t.format !== Z && t.format !== K ? -1 < n.getCompressedTextureFormats().indexOf(w) ? n.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + b, M, A, E.width, E.height, 0, E.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + b, M, A, E.width, E.height, 0, w, S, E.data);else g ? n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + b, 0, A, v[b].width, v[b].height, 0, w, S, v[b].data) : n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + b, 0, A, w, S, v[b]);
                l.__maxMipLevel = p ? T.length - 1 : 0, d(t, x) && h(e.TEXTURE_CUBE_MAP, t, _.width, _.height), l.__version = t.version, t.onUpdate && t.onUpdate(t);
              } else n.activeTexture(e.TEXTURE0 + s), n.bindTexture(e.TEXTURE_CUBE_MAP, l.__image__webglTextureCube);
            }, this.setTextureCubeDynamic = function (t, i) {
              n.activeTexture(e.TEXTURE0 + i), n.bindTexture(e.TEXTURE_CUBE_MAP, r.get(t).__webglTexture);
            }, this.setupRenderTarget = function (t) {
              var i = r.get(t),
                o = r.get(t.texture);
              t.addEventListener("dispose", g), o.__webglTexture = e.createTexture(), a.memory.textures++;
              var s = !0 === t.isWebGLRenderTargetCube,
                l = c(t);
              if (s) {
                i.__webglFramebuffer = [];
                for (var u = 0; u < 6; u++) i.__webglFramebuffer[u] = e.createFramebuffer();
              } else i.__webglFramebuffer = e.createFramebuffer();
              if (s) {
                for (n.bindTexture(e.TEXTURE_CUBE_MAP, o.__webglTexture), y(e.TEXTURE_CUBE_MAP, t.texture, l), u = 0; u < 6; u++) b(i.__webglFramebuffer[u], t, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + u);
                d(t.texture, l) && h(e.TEXTURE_CUBE_MAP, t.texture, t.width, t.height), n.bindTexture(e.TEXTURE_CUBE_MAP, null);
              } else n.bindTexture(e.TEXTURE_2D, o.__webglTexture), y(e.TEXTURE_2D, t.texture, l), b(i.__webglFramebuffer, t, e.COLOR_ATTACHMENT0, e.TEXTURE_2D), d(t.texture, l) && h(e.TEXTURE_2D, t.texture, t.width, t.height), n.bindTexture(e.TEXTURE_2D, null);
              t.depthBuffer && function (t) {
                var n = r.get(t),
                  i = !0 === t.isWebGLRenderTargetCube;
                if (t.depthTexture) {
                  if (i) throw new Error("target.depthTexture not supported in Cube render targets");
                  !function (t, n) {
                    if (n && n.isWebGLRenderTargetCube) throw new Error("Depth Texture with cube render targets is not supported");
                    if (e.bindFramebuffer(e.FRAMEBUFFER, t), !n.depthTexture || !n.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                    r.get(n.depthTexture).__webglTexture && n.depthTexture.image.width === n.width && n.depthTexture.image.height === n.height || (n.depthTexture.image.width = n.width, n.depthTexture.image.height = n.height, n.depthTexture.needsUpdate = !0), v(n.depthTexture, 0);
                    var i = r.get(n.depthTexture).__webglTexture;
                    if (n.depthTexture.format === Q) e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, i, 0);else {
                      if (n.depthTexture.format !== J) throw new Error("Unknown depthTexture format");
                      e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, i, 0);
                    }
                  }(n.__webglFramebuffer, t);
                } else if (i) {
                  n.__webglDepthbuffer = [];
                  for (var o = 0; o < 6; o++) e.bindFramebuffer(e.FRAMEBUFFER, n.__webglFramebuffer[o]), n.__webglDepthbuffer[o] = e.createRenderbuffer(), _(n.__webglDepthbuffer[o], t);
                } else e.bindFramebuffer(e.FRAMEBUFFER, n.__webglFramebuffer), n.__webglDepthbuffer = e.createRenderbuffer(), _(n.__webglDepthbuffer, t);
                e.bindFramebuffer(e.FRAMEBUFFER, null);
              }(t);
            }, this.updateRenderTargetMipmap = function (t) {
              var i = t.texture;
              if (d(i, c(t))) {
                var o = t.isWebGLRenderTargetCube ? e.TEXTURE_CUBE_MAP : e.TEXTURE_2D,
                  a = r.get(i).__webglTexture;
                n.bindTexture(o, a), h(o, i, t.width, t.height), n.bindTexture(o, null);
              }
            };
          }
          function _i(e, t, n) {
            return {
              convert: function convert(r) {
                var i;
                if (r === V) return e.REPEAT;
                if (r === H) return e.CLAMP_TO_EDGE;
                if (r === q) return e.MIRRORED_REPEAT;
                if (r === W) return e.NEAREST;
                if (1004 === r) return e.NEAREST_MIPMAP_NEAREST;
                if (1005 === r) return e.NEAREST_MIPMAP_LINEAR;
                if (r === $) return e.LINEAR;
                if (1007 === r) return e.LINEAR_MIPMAP_NEAREST;
                if (1008 === r) return e.LINEAR_MIPMAP_LINEAR;
                if (r === X) return e.UNSIGNED_BYTE;
                if (1017 === r) return e.UNSIGNED_SHORT_4_4_4_4;
                if (1018 === r) return e.UNSIGNED_SHORT_5_5_5_1;
                if (1019 === r) return e.UNSIGNED_SHORT_5_6_5;
                if (1010 === r) return e.BYTE;
                if (1011 === r) return e.SHORT;
                if (1012 === r) return e.UNSIGNED_SHORT;
                if (1013 === r) return e.INT;
                if (1014 === r) return e.UNSIGNED_INT;
                if (r === Y) return e.FLOAT;
                if (1016 === r) {
                  if (n.isWebGL2) return e.HALF_FLOAT;
                  if (null !== (i = t.get("OES_texture_half_float"))) return i.HALF_FLOAT_OES;
                }
                if (1021 === r) return e.ALPHA;
                if (r === K) return e.RGB;
                if (r === Z) return e.RGBA;
                if (1024 === r) return e.LUMINANCE;
                if (1025 === r) return e.LUMINANCE_ALPHA;
                if (r === Q) return e.DEPTH_COMPONENT;
                if (r === J) return e.DEPTH_STENCIL;
                if (100 === r) return e.FUNC_ADD;
                if (101 === r) return e.FUNC_SUBTRACT;
                if (102 === r) return e.FUNC_REVERSE_SUBTRACT;
                if (200 === r) return e.ZERO;
                if (201 === r) return e.ONE;
                if (202 === r) return e.SRC_COLOR;
                if (203 === r) return e.ONE_MINUS_SRC_COLOR;
                if (204 === r) return e.SRC_ALPHA;
                if (205 === r) return e.ONE_MINUS_SRC_ALPHA;
                if (206 === r) return e.DST_ALPHA;
                if (207 === r) return e.ONE_MINUS_DST_ALPHA;
                if (208 === r) return e.DST_COLOR;
                if (209 === r) return e.ONE_MINUS_DST_COLOR;
                if (210 === r) return e.SRC_ALPHA_SATURATE;
                if ((33776 === r || 33777 === r || 33778 === r || 33779 === r) && null !== (i = t.get("WEBGL_compressed_texture_s3tc"))) {
                  if (33776 === r) return i.COMPRESSED_RGB_S3TC_DXT1_EXT;
                  if (33777 === r) return i.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                  if (33778 === r) return i.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                  if (33779 === r) return i.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                }
                if ((35840 === r || 35841 === r || 35842 === r || 35843 === r) && null !== (i = t.get("WEBGL_compressed_texture_pvrtc"))) {
                  if (35840 === r) return i.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                  if (35841 === r) return i.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                  if (35842 === r) return i.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                  if (35843 === r) return i.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                }
                if (36196 === r && null !== (i = t.get("WEBGL_compressed_texture_etc1"))) return i.COMPRESSED_RGB_ETC1_WEBGL;
                if ((37808 === r || 37809 === r || 37810 === r || 37811 === r || 37812 === r || 37813 === r || 37814 === r || 37815 === r || 37816 === r || 37817 === r || 37818 === r || 37819 === r || 37820 === r || 37821 === r) && null !== (i = t.get("WEBGL_compressed_texture_astc"))) return r;
                if (103 === r || 104 === r) {
                  if (n.isWebGL2) {
                    if (103 === r) return e.MIN;
                    if (104 === r) return e.MAX;
                  }
                  if (null !== (i = t.get("EXT_blend_minmax"))) {
                    if (103 === r) return i.MIN_EXT;
                    if (104 === r) return i.MAX_EXT;
                  }
                }
                if (1020 === r) {
                  if (n.isWebGL2) return e.UNSIGNED_INT_24_8;
                  if (null !== (i = t.get("WEBGL_depth_texture"))) return i.UNSIGNED_INT_24_8_WEBGL;
                }
                return 0;
              }
            };
          }
          function xi() {
            ft.call(this), this.type = "Group";
          }
          function wi(e, t, n, r) {
            pt.call(this), this.type = "PerspectiveCamera", this.fov = void 0 !== e ? e : 50, this.zoom = 1, this.near = void 0 !== n ? n : .1, this.far = void 0 !== r ? r : 2e3, this.focus = 10, this.aspect = void 0 !== t ? t : 1, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
          }
          function Si(e) {
            wi.call(this), this.cameras = e || [];
          }
          function Ai(e) {
            var t = this,
              n = null,
              r = null,
              i = null,
              o = [],
              a = new ie(),
              s = new ie();
            "undefined" != typeof window && "VRFrameData" in window && (r = new window.VRFrameData(), window.addEventListener("vrdisplaypresentchange", v, !1));
            var l = new ie(),
              u = new oe(),
              c = new ae(),
              d = new wi();
            d.bounds = new Me(0, 0, .5, 1), d.layers.enable(1);
            var h = new wi();
            h.bounds = new Me(.5, 0, .5, 1), h.layers.enable(2);
            var f,
              p,
              m = new Si([d, h]);
            function g() {
              return null !== n && !0 === n.isPresenting;
            }
            function v() {
              if (g()) {
                var r = n.getEyeParameters("left"),
                  i = r.renderWidth,
                  o = r.renderHeight;
                p = e.getPixelRatio(), f = e.getSize(), e.setDrawingBufferSize(2 * i, o, 1), _.start();
              } else t.enabled && (e.setDrawingBufferSize(f.width, f.height, p), _.stop());
            }
            m.layers.enable(1), m.layers.enable(2);
            var y = [];
            function b(e) {
              for (var t = navigator.getGamepads && navigator.getGamepads(), n = 0, r = 0, i = t.length; n < i; n++) {
                var o = t[n];
                if (o && ("Daydream Controller" === o.id || "Gear VR Controller" === o.id || "Oculus Go Controller" === o.id || "OpenVR Gamepad" === o.id || o.id.startsWith("Oculus Touch") || o.id.startsWith("Spatial Controller"))) {
                  if (r === e) return o;
                  r++;
                }
              }
            }
            this.enabled = !1, this.userHeight = 1.6, this.getController = function (e) {
              var t = o[e];
              return void 0 === t && ((t = new xi()).matrixAutoUpdate = !1, t.visible = !1, o[e] = t), t;
            }, this.getDevice = function () {
              return n;
            }, this.setDevice = function (e) {
              void 0 !== e && (n = e), _.setContext(e);
            }, this.setPoseTarget = function (e) {
              void 0 !== e && (i = e);
            }, this.getCamera = function (e) {
              if (null === n) return e.position.set(0, t.userHeight, 0), e;
              n.depthNear = e.near, n.depthFar = e.far, n.getFrameData(r);
              var f = n.stageParameters;
              f ? a.fromArray(f.sittingToStandingTransform) : a.makeTranslation(0, t.userHeight, 0);
              var p = r.pose,
                g = null !== i ? i : e;
              if (g.matrix.copy(a), g.matrix.decompose(g.position, g.quaternion, g.scale), null !== p.orientation && (u.fromArray(p.orientation), g.quaternion.multiply(u)), null !== p.position && (u.setFromRotationMatrix(a), c.fromArray(p.position), c.applyQuaternion(u), g.position.add(c)), g.updateMatrixWorld(), !1 === n.isPresenting) return e;
              d.near = e.near, h.near = e.near, d.far = e.far, h.far = e.far, m.matrixWorld.copy(e.matrixWorld), m.matrixWorldInverse.copy(e.matrixWorldInverse), d.matrixWorldInverse.fromArray(r.leftViewMatrix), h.matrixWorldInverse.fromArray(r.rightViewMatrix), s.getInverse(a), d.matrixWorldInverse.multiply(s), h.matrixWorldInverse.multiply(s);
              var v = g.parent;
              null !== v && (l.getInverse(v.matrixWorld), d.matrixWorldInverse.multiply(l), h.matrixWorldInverse.multiply(l)), d.matrixWorld.getInverse(d.matrixWorldInverse), h.matrixWorld.getInverse(h.matrixWorldInverse), d.projectionMatrix.fromArray(r.leftProjectionMatrix), h.projectionMatrix.fromArray(r.rightProjectionMatrix), m.projectionMatrix.copy(d.projectionMatrix);
              var _ = n.getLayers();
              if (_.length) {
                var x = _[0];
                null !== x.leftBounds && 4 === x.leftBounds.length && d.bounds.fromArray(x.leftBounds), null !== x.rightBounds && 4 === x.rightBounds.length && h.bounds.fromArray(x.rightBounds);
              }
              return function () {
                for (var e = 0; e < o.length; e++) {
                  var t = o[e],
                    n = b(e);
                  if (void 0 !== n && void 0 !== n.pose) {
                    if (null === n.pose) return;
                    var r = n.pose;
                    !1 === r.hasPosition && t.position.set(.2, -.6, -.05), null !== r.position && t.position.fromArray(r.position), null !== r.orientation && t.quaternion.fromArray(r.orientation), t.matrix.compose(t.position, t.quaternion, t.scale), t.matrix.premultiply(a), t.matrix.decompose(t.position, t.quaternion, t.scale), t.matrixWorldNeedsUpdate = !0, t.visible = !0;
                    var i = "Daydream Controller" === n.id ? 0 : 1;
                    y[e] !== n.buttons[i].pressed && (y[e] = n.buttons[i].pressed, !0 === y[e] ? t.dispatchEvent({
                      type: "selectstart"
                    }) : (t.dispatchEvent({
                      type: "selectend"
                    }), t.dispatchEvent({
                      type: "select"
                    })));
                  } else t.visible = !1;
                }
              }(), m;
            }, this.getStandingMatrix = function () {
              return a;
            }, this.isPresenting = g;
            var _ = new He();
            this.setAnimationLoop = function (e) {
              _.setAnimationLoop(e);
            }, this.submitFrame = function () {
              g() && n.submitFrame();
            }, this.dispose = function () {
              "undefined" != typeof window && window.removeEventListener("vrdisplaypresentchange", v);
            };
          }
          function Ei(e) {
            var t = e.context,
              n = null,
              r = null,
              i = null,
              o = null,
              a = [],
              s = [];
            function l() {
              return null !== r && null !== i;
            }
            var u = new wi();
            u.layers.enable(1), u.viewport = new Me();
            var c = new wi();
            c.layers.enable(2), c.viewport = new Me();
            var d = new Si([u, c]);
            function h(e) {
              var t = a[s.indexOf(e.inputSource)];
              t && t.dispatchEvent({
                type: e.type
              });
            }
            function f() {
              e.setFramebuffer(null), g.stop();
            }
            function p(e, t) {
              null === t ? e.matrixWorld.copy(e.matrix) : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix), e.matrixWorldInverse.getInverse(e.matrixWorld);
            }
            d.layers.enable(1), d.layers.enable(2), this.enabled = !1, this.getController = function (e) {
              var t = a[e];
              return void 0 === t && ((t = new xi()).matrixAutoUpdate = !1, t.visible = !1, a[e] = t), t;
            }, this.getDevice = function () {
              return n;
            }, this.setDevice = function (e) {
              void 0 !== e && (n = e), e instanceof XRDevice && t.setCompatibleXRDevice(e);
            }, this.setSession = function (n, o) {
              null !== (r = n) && (r.addEventListener("select", h), r.addEventListener("selectstart", h), r.addEventListener("selectend", h), r.addEventListener("end", f), r.baseLayer = new XRWebGLLayer(r, t), r.requestFrameOfReference(o.frameOfReferenceType).then(function (t) {
                i = t, e.setFramebuffer(r.baseLayer.framebuffer), g.setContext(r), g.start();
              }), s = r.getInputSources(), r.addEventListener("inputsourceschange", function () {
                s = r.getInputSources(), console.log(s);
              }));
            }, this.getCamera = function (e) {
              if (l()) {
                var t = e.parent,
                  n = d.cameras;
                p(d, t);
                for (var r = 0; r < n.length; r++) p(n[r], t);
                e.matrixWorld.copy(d.matrixWorld);
                for (var i = e.children, o = (r = 0, i.length); r < o; r++) i[r].updateMatrixWorld(!0);
                return d;
              }
              return e;
            }, this.isPresenting = l;
            var m = null,
              g = new He();
            g.setAnimationLoop(function (e, t) {
              if (null !== (o = t.getDevicePose(i))) for (var n = r.baseLayer, l = t.views, u = 0; u < l.length; u++) {
                var c = l[u],
                  h = n.getViewport(c),
                  f = o.getViewMatrix(c),
                  p = d.cameras[u];
                p.matrix.fromArray(f).getInverse(p.matrix), p.projectionMatrix.fromArray(c.projectionMatrix), p.viewport.set(h.x, h.y, h.width, h.height), 0 === u && (d.matrix.copy(p.matrix), d.projectionMatrix.copy(p.projectionMatrix));
              }
              for (u = 0; u < a.length; u++) {
                var g = a[u],
                  v = s[u];
                if (v) {
                  var y = t.getInputPose(v, i);
                  if (null !== y) {
                    g.matrix.elements = y.pointerMatrix, g.matrix.decompose(g.position, g.rotation, g.scale), g.visible = !0;
                    continue;
                  }
                }
                g.visible = !1;
              }
              m && m(e);
            }), this.setAnimationLoop = function (e) {
              m = e;
            }, this.dispose = function () {}, this.getStandingMatrix = function () {
              return console.warn("THREE.WebXRManager: getStandingMatrix() is no longer needed."), new THREE.Matrix4();
            }, this.submitFrame = function () {};
          }
          function Ti(e) {
            console.log("THREE.WebGLRenderer", "95");
            var t = void 0 !== (e = e || {}).canvas ? e.canvas : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"),
              n = void 0 !== e.context ? e.context : null,
              r = void 0 !== e.alpha && e.alpha,
              i = void 0 === e.depth || e.depth,
              o = void 0 === e.stencil || e.stencil,
              a = void 0 !== e.antialias && e.antialias,
              s = void 0 === e.premultipliedAlpha || e.premultipliedAlpha,
              l = void 0 !== e.preserveDrawingBuffer && e.preserveDrawingBuffer,
              u = void 0 !== e.powerPreference ? e.powerPreference : "default",
              c = null,
              d = null;
            this.domElement = t, this.context = null, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.gammaFactor = 2, this.gammaInput = !1, this.gammaOutput = !1, this.physicallyCorrectLights = !1, this.toneMapping = 1, this.toneMappingExposure = 1, this.toneMappingWhitePoint = 1, this.maxMorphTargets = 8, this.maxMorphNormals = 4;
            var h,
              f,
              p,
              m,
              g,
              v,
              y,
              b,
              _,
              x,
              w,
              S,
              A,
              E,
              T,
              M,
              C,
              k,
              P = this,
              O = !1,
              R = null,
              I = null,
              j = null,
              N = -1,
              L = {
                geometry: null,
                program: null,
                wireframe: !1
              },
              D = null,
              B = null,
              F = new Me(),
              z = new Me(),
              U = null,
              G = 0,
              V = t.width,
              H = t.height,
              q = 1,
              W = new Me(0, 0, V, H),
              $ = new Me(0, 0, V, H),
              K = !1,
              Q = new je(),
              J = new Nn(),
              ee = !1,
              te = !1,
              re = new ie(),
              oe = new ae();
            function se() {
              return null === I ? q : 1;
            }
            try {
              var le = {
                alpha: r,
                depth: i,
                stencil: o,
                antialias: a,
                premultipliedAlpha: s,
                preserveDrawingBuffer: l,
                powerPreference: u
              };
              if (t.addEventListener("webglcontextlost", he, !1), t.addEventListener("webglcontextrestored", fe, !1), null === (h = n || t.getContext("webgl", le) || t.getContext("experimental-webgl", le))) throw null !== t.getContext("webgl") ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
              void 0 === h.getShaderPrecisionFormat && (h.getShaderPrecisionFormat = function () {
                return {
                  rangeMin: 1,
                  rangeMax: 1,
                  precision: 1
                };
              });
            } catch (e) {
              console.error("THREE.WebGLRenderer: " + e.message);
            }
            function ue() {
              f = new Ln(h), (p = new jn(h, f, e)).isWebGL2 || (f.get("WEBGL_depth_texture"), f.get("OES_texture_float"), f.get("OES_texture_half_float"), f.get("OES_texture_half_float_linear"), f.get("OES_standard_derivatives"), f.get("OES_element_index_uint"), f.get("ANGLE_instanced_arrays")), f.get("OES_texture_float_linear"), k = new _i(h, f, p), (m = new yi(h, f, k, p)).scissor(z.copy($).multiplyScalar(q)), m.viewport(F.copy(W).multiplyScalar(q)), g = new Fn(h), v = new Vr(), y = new bi(h, f, m, v, p, k, g), b = new qe(h), _ = new Dn(h, b, g), x = new Gn(_, g), T = new Un(h), w = new Gr(P, f, p), S = new $r(), A = new pi(), E = new Rn(P, m, x, s), M = new In(h, f, g, p), C = new Bn(h, f, g, p), g.programs = w.programs, P.context = h, P.capabilities = p, P.extensions = f, P.properties = v, P.renderLists = S, P.state = m, P.info = g;
            }
            ue();
            var ce = "xr" in navigator ? new Ei(P) : new Ai(P);
            this.vr = ce;
            var de = new vi(P, x, p.maxTextureSize);
            function he(e) {
              e.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), O = !0;
            }
            function fe() {
              console.log("THREE.WebGLRenderer: Context Restored."), O = !1, ue();
            }
            function pe(e) {
              var t,
                n = e.target;
              n.removeEventListener("dispose", pe), me(t = n), v.remove(t);
            }
            function me(e) {
              var t = v.get(e).program;
              (e.program = void 0) !== t && w.releaseProgram(t);
            }
            this.shadowMap = de, this.getContext = function () {
              return h;
            }, this.getContextAttributes = function () {
              return h.getContextAttributes();
            }, this.forceContextLoss = function () {
              var e = f.get("WEBGL_lose_context");
              e && e.loseContext();
            }, this.forceContextRestore = function () {
              var e = f.get("WEBGL_lose_context");
              e && e.restoreContext();
            }, this.getPixelRatio = function () {
              return q;
            }, this.setPixelRatio = function (e) {
              void 0 !== e && (q = e, this.setSize(V, H, !1));
            }, this.getSize = function () {
              return {
                width: V,
                height: H
              };
            }, this.setSize = function (e, n, r) {
              ce.isPresenting() ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (V = e, H = n, t.width = e * q, t.height = n * q, !1 !== r && (t.style.width = e + "px", t.style.height = n + "px"), this.setViewport(0, 0, e, n));
            }, this.getDrawingBufferSize = function () {
              return {
                width: V * q,
                height: H * q
              };
            }, this.setDrawingBufferSize = function (e, n, r) {
              V = e, H = n, q = r, t.width = e * r, t.height = n * r, this.setViewport(0, 0, e, n);
            }, this.getCurrentViewport = function () {
              return F;
            }, this.setViewport = function (e, t, n, r) {
              W.set(e, H - t - r, n, r), m.viewport(F.copy(W).multiplyScalar(q));
            }, this.setScissor = function (e, t, n, r) {
              $.set(e, H - t - r, n, r), m.scissor(z.copy($).multiplyScalar(q));
            }, this.setScissorTest = function (e) {
              m.setScissorTest(K = e);
            }, this.getClearColor = function () {
              return E.getClearColor();
            }, this.setClearColor = function () {
              E.setClearColor.apply(E, arguments);
            }, this.getClearAlpha = function () {
              return E.getClearAlpha();
            }, this.setClearAlpha = function () {
              E.setClearAlpha.apply(E, arguments);
            }, this.clear = function (e, t, n) {
              var r = 0;
              (void 0 === e || e) && (r |= h.COLOR_BUFFER_BIT), (void 0 === t || t) && (r |= h.DEPTH_BUFFER_BIT), (void 0 === n || n) && (r |= h.STENCIL_BUFFER_BIT), h.clear(r);
            }, this.clearColor = function () {
              this.clear(!0, !1, !1);
            }, this.clearDepth = function () {
              this.clear(!1, !0, !1);
            }, this.clearStencil = function () {
              this.clear(!1, !1, !0);
            }, this.clearTarget = function (e, t, n, r) {
              this.setRenderTarget(e), this.clear(t, n, r);
            }, this.dispose = function () {
              t.removeEventListener("webglcontextlost", he, !1), t.removeEventListener("webglcontextrestored", fe, !1), S.dispose(), A.dispose(), v.dispose(), x.dispose(), ce.dispose(), _e.stop();
            }, this.renderBufferImmediate = function (e, t) {
              m.initAttributes();
              var n = v.get(e);
              e.hasPositions && !n.position && (n.position = h.createBuffer()), e.hasNormals && !n.normal && (n.normal = h.createBuffer()), e.hasUvs && !n.uv && (n.uv = h.createBuffer()), e.hasColors && !n.color && (n.color = h.createBuffer());
              var r = t.getAttributes();
              e.hasPositions && (h.bindBuffer(h.ARRAY_BUFFER, n.position), h.bufferData(h.ARRAY_BUFFER, e.positionArray, h.DYNAMIC_DRAW), m.enableAttribute(r.position), h.vertexAttribPointer(r.position, 3, h.FLOAT, !1, 0, 0)), e.hasNormals && (h.bindBuffer(h.ARRAY_BUFFER, n.normal), h.bufferData(h.ARRAY_BUFFER, e.normalArray, h.DYNAMIC_DRAW), m.enableAttribute(r.normal), h.vertexAttribPointer(r.normal, 3, h.FLOAT, !1, 0, 0)), e.hasUvs && (h.bindBuffer(h.ARRAY_BUFFER, n.uv), h.bufferData(h.ARRAY_BUFFER, e.uvArray, h.DYNAMIC_DRAW), m.enableAttribute(r.uv), h.vertexAttribPointer(r.uv, 2, h.FLOAT, !1, 0, 0)), e.hasColors && (h.bindBuffer(h.ARRAY_BUFFER, n.color), h.bufferData(h.ARRAY_BUFFER, e.colorArray, h.DYNAMIC_DRAW), m.enableAttribute(r.color), h.vertexAttribPointer(r.color, 3, h.FLOAT, !1, 0, 0)), m.disableUnusedAttributes(), h.drawArrays(h.TRIANGLES, 0, e.count), e.count = 0;
            }, this.renderBufferDirect = function (e, t, n, r, i, o) {
              var a = i.isMesh && i.normalMatrix.determinant() < 0;
              m.setMaterial(r, a);
              var s = Ae(e, t, r, i),
                l = !1;
              L.geometry === n.id && L.program === s.id && L.wireframe === (!0 === r.wireframe) || (L.geometry = n.id, L.program = s.id, L.wireframe = !0 === r.wireframe, l = !0), i.morphTargetInfluences && (T.update(i, n, r, s), l = !0);
              var u,
                c = n.index,
                d = n.attributes.position,
                g = 1;
              !0 === r.wireframe && (c = _.getWireframeAttribute(n), g = 2);
              var v = M;
              null !== c && (u = b.get(c), (v = C).setIndex(u)), l && (function (e, t, n) {
                if (n && n.isInstancedBufferGeometry & !p.isWebGL2 && null === f.get("ANGLE_instanced_arrays")) return console.error("THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                m.initAttributes();
                var r = n.attributes,
                  i = t.getAttributes(),
                  o = e.defaultAttributeValues;
                for (var a in i) {
                  var s = i[a];
                  if (0 <= s) {
                    var l = r[a];
                    if (void 0 !== l) {
                      var u = l.normalized,
                        c = l.itemSize,
                        d = b.get(l);
                      if (void 0 === d) continue;
                      var g = d.buffer,
                        v = d.type,
                        y = d.bytesPerElement;
                      if (l.isInterleavedBufferAttribute) {
                        var _ = l.data,
                          x = _.stride,
                          w = l.offset;
                        _ && _.isInstancedInterleavedBuffer ? (m.enableAttributeAndDivisor(s, _.meshPerAttribute), void 0 === n.maxInstancedCount && (n.maxInstancedCount = _.meshPerAttribute * _.count)) : m.enableAttribute(s), h.bindBuffer(h.ARRAY_BUFFER, g), h.vertexAttribPointer(s, c, v, u, x * y, w * y);
                      } else l.isInstancedBufferAttribute ? (m.enableAttributeAndDivisor(s, l.meshPerAttribute), void 0 === n.maxInstancedCount && (n.maxInstancedCount = l.meshPerAttribute * l.count)) : m.enableAttribute(s), h.bindBuffer(h.ARRAY_BUFFER, g), h.vertexAttribPointer(s, c, v, u, 0, 0);
                    } else if (void 0 !== o) {
                      var S = o[a];
                      if (void 0 !== S) switch (S.length) {
                        case 2:
                          h.vertexAttrib2fv(s, S);
                          break;
                        case 3:
                          h.vertexAttrib3fv(s, S);
                          break;
                        case 4:
                          h.vertexAttrib4fv(s, S);
                          break;
                        default:
                          h.vertexAttrib1fv(s, S);
                      }
                    }
                  }
                }
                m.disableUnusedAttributes();
              }(r, s, n), null !== c && h.bindBuffer(h.ELEMENT_ARRAY_BUFFER, u.buffer));
              var y = 1 / 0;
              null !== c ? y = c.count : void 0 !== d && (y = d.count);
              var x = n.drawRange.start * g,
                w = n.drawRange.count * g,
                S = null !== o ? o.start * g : 0,
                A = null !== o ? o.count * g : 1 / 0,
                E = Math.max(x, S),
                k = Math.min(y, x + w, S + A) - 1,
                P = Math.max(0, k - E + 1);
              if (0 !== P) {
                if (i.isMesh) {
                  if (!0 === r.wireframe) m.setLineWidth(r.wireframeLinewidth * se()), v.setMode(h.LINES);else switch (i.drawMode) {
                    case 0:
                      v.setMode(h.TRIANGLES);
                      break;
                    case 1:
                      v.setMode(h.TRIANGLE_STRIP);
                      break;
                    case 2:
                      v.setMode(h.TRIANGLE_FAN);
                  }
                } else if (i.isLine) {
                  var O = r.linewidth;
                  void 0 === O && (O = 1), m.setLineWidth(O * se()), i.isLineSegments ? v.setMode(h.LINES) : i.isLineLoop ? v.setMode(h.LINE_LOOP) : v.setMode(h.LINE_STRIP);
                } else i.isPoints ? v.setMode(h.POINTS) : i.isSprite && v.setMode(h.TRIANGLES);
                n && n.isInstancedBufferGeometry ? 0 < n.maxInstancedCount && v.renderInstances(n, E, P) : v.render(E, P);
              }
            }, this.compile = function (e, t) {
              (d = A.get(e, t)).init(), e.traverse(function (e) {
                e.isLight && (d.pushLight(e), e.castShadow && d.pushShadow(e));
              }), d.setupLights(t), e.traverse(function (t) {
                if (t.material) if (Array.isArray(t.material)) for (var n = 0; n < t.material.length; n++) Se(t.material[n], e.fog, t);else Se(t.material, e.fog, t);
              });
            };
            var ge,
              ve,
              ye,
              be = null,
              _e = new He();
            function xe(e, t, n, r) {
              for (var i = 0, o = e.length; i < o; i++) {
                var a = e[i],
                  s = a.object,
                  l = a.geometry,
                  u = void 0 === r ? a.material : r,
                  c = a.group;
                if (n.isArrayCamera) for (var d = (B = n).cameras, h = 0, f = d.length; h < f; h++) {
                  var p = d[h];
                  if (s.layers.test(p.layers)) {
                    if ("viewport" in p) m.viewport(F.copy(p.viewport));else {
                      var g = p.bounds,
                        v = g.x * V,
                        y = g.y * H,
                        b = g.z * V,
                        _ = g.w * H;
                      m.viewport(F.set(v, y, b, _).multiplyScalar(q));
                    }
                    we(s, t, p, l, u, c);
                  }
                } else B = null, we(s, t, n, l, u, c);
              }
            }
            function we(e, t, n, r, i, o) {
              if (e.onBeforeRender(P, t, n, r, i, o), d = A.get(t, B || n), e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e.matrixWorld), e.normalMatrix.getNormalMatrix(e.modelViewMatrix), e.isImmediateRenderObject) {
                m.setMaterial(i);
                var a = Ae(n, t.fog, i, e);
                L.geometry = null, L.program = null, L.wireframe = !1, s = a, e.render(function (e) {
                  P.renderBufferImmediate(e, s);
                });
              } else P.renderBufferDirect(n, t.fog, r, i, e, o);
              var s;
              e.onAfterRender(P, t, n, r, i, o), d = A.get(t, B || n);
            }
            function Se(e, t, n) {
              var r = v.get(e),
                i = d.state.lights,
                o = d.state.shadowsArray,
                a = r.lightsHash,
                s = i.state.hash,
                l = w.getParameters(e, i.state, o, t, J.numPlanes, J.numIntersection, n),
                u = w.getProgramCode(e, l),
                c = r.program,
                h = !0;
              if (void 0 === c) e.addEventListener("dispose", pe);else if (c.code !== u) me(e);else if (a.stateID !== s.stateID || a.directionalLength !== s.directionalLength || a.pointLength !== s.pointLength || a.spotLength !== s.spotLength || a.rectAreaLength !== s.rectAreaLength || a.hemiLength !== s.hemiLength || a.shadowsLength !== s.shadowsLength) a.stateID = s.stateID, a.directionalLength = s.directionalLength, a.pointLength = s.pointLength, a.spotLength = s.spotLength, a.rectAreaLength = s.rectAreaLength, a.hemiLength = s.hemiLength, a.shadowsLength = s.shadowsLength, h = !1;else {
                if (void 0 !== l.shaderID) return;
                h = !1;
              }
              if (h) {
                if (l.shaderID) {
                  var f = Ve[l.shaderID];
                  r.shader = {
                    name: e.type,
                    uniforms: De.clone(f.uniforms),
                    vertexShader: f.vertexShader,
                    fragmentShader: f.fragmentShader
                  };
                } else r.shader = {
                  name: e.type,
                  uniforms: e.uniforms,
                  vertexShader: e.vertexShader,
                  fragmentShader: e.fragmentShader
                };
                e.onBeforeCompile(r.shader, P), u = w.getProgramCode(e, l), c = w.acquireProgram(e, r.shader, l, u), r.program = c, e.program = c;
              }
              var p = c.getAttributes();
              if (e.morphTargets) for (var m = e.numSupportedMorphTargets = 0; m < P.maxMorphTargets; m++) 0 <= p["morphTarget" + m] && e.numSupportedMorphTargets++;
              if (e.morphNormals) for (m = e.numSupportedMorphNormals = 0; m < P.maxMorphNormals; m++) 0 <= p["morphNormal" + m] && e.numSupportedMorphNormals++;
              var g = r.shader.uniforms;
              (e.isShaderMaterial || e.isRawShaderMaterial) && !0 !== e.clipping || (r.numClippingPlanes = J.numPlanes, r.numIntersection = J.numIntersection, g.clippingPlanes = J.uniform), r.fog = t, void 0 === a && (r.lightsHash = a = {}), a.stateID = s.stateID, a.directionalLength = s.directionalLength, a.pointLength = s.pointLength, a.spotLength = s.spotLength, a.rectAreaLength = s.rectAreaLength, a.hemiLength = s.hemiLength, a.shadowsLength = s.shadowsLength, e.lights && (g.ambientLightColor.value = i.state.ambient, g.directionalLights.value = i.state.directional, g.spotLights.value = i.state.spot, g.rectAreaLights.value = i.state.rectArea, g.pointLights.value = i.state.point, g.hemisphereLights.value = i.state.hemi, g.directionalShadowMap.value = i.state.directionalShadowMap, g.directionalShadowMatrix.value = i.state.directionalShadowMatrix, g.spotShadowMap.value = i.state.spotShadowMap, g.spotShadowMatrix.value = i.state.spotShadowMatrix, g.pointShadowMap.value = i.state.pointShadowMap, g.pointShadowMatrix.value = i.state.pointShadowMatrix);
              var y = r.program.getUniforms(),
                b = Or.seqWithValue(y.seq, g);
              r.uniformsList = b;
            }
            function Ae(e, t, n, r) {
              G = 0;
              var i = v.get(n),
                o = d.state.lights,
                a = i.lightsHash,
                s = o.state.hash;
              if (ee && (te || e !== D)) {
                var l = e === D && n.id === N;
                J.setState(n.clippingPlanes, n.clipIntersection, n.clipShadows, e, i, l);
              }
              !1 === n.needsUpdate && (void 0 === i.program || n.fog && i.fog !== t ? n.needsUpdate = !0 : (!n.lights || a.stateID === s.stateID && a.directionalLength === s.directionalLength && a.pointLength === s.pointLength && a.spotLength === s.spotLength && a.rectAreaLength === s.rectAreaLength && a.hemiLength === s.hemiLength && a.shadowsLength === s.shadowsLength) && (void 0 === i.numClippingPlanes || i.numClippingPlanes === J.numPlanes && i.numIntersection === J.numIntersection) || (n.needsUpdate = !0)), n.needsUpdate && (Se(n, t, r), n.needsUpdate = !1);
              var u,
                c,
                f,
                g,
                y,
                b,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M,
                C,
                k,
                O,
                R,
                I,
                j,
                L = !1,
                F = !1,
                z = !1,
                U = i.program,
                V = U.getUniforms(),
                W = i.shader.uniforms;
              if (m.useProgram(U.program) && (z = F = L = !0), n.id !== N && (N = n.id, F = !0), L || e !== D) {
                if (V.setValue(h, "projectionMatrix", e.projectionMatrix), p.logarithmicDepthBuffer && V.setValue(h, "logDepthBufFC", 2 / (Math.log(e.far + 1) / Math.LN2)), D !== (B || e) && (D = B || e, z = F = !0), n.isShaderMaterial || n.isMeshPhongMaterial || n.isMeshStandardMaterial || n.envMap) {
                  var $ = V.map.cameraPosition;
                  void 0 !== $ && $.setValue(h, oe.setFromMatrixPosition(e.matrixWorld));
                }
                (n.isMeshPhongMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial || n.skinning) && V.setValue(h, "viewMatrix", e.matrixWorldInverse);
              }
              if (n.skinning) {
                V.setOptional(h, r, "bindMatrix"), V.setOptional(h, r, "bindMatrixInverse");
                var X = r.skeleton;
                if (X) {
                  var K = X.bones;
                  if (p.floatVertexTextures) {
                    if (void 0 === X.boneTexture) {
                      var Q = Math.sqrt(4 * K.length);
                      Q = ne.ceilPowerOfTwo(Q), Q = Math.max(Q, 4);
                      var re = new Float32Array(Q * Q * 4);
                      re.set(X.boneMatrices);
                      var ie = new Pe(re, Q, Q, Z, Y);
                      ie.needsUpdate = !0, X.boneMatrices = re, X.boneTexture = ie, X.boneTextureSize = Q;
                    }
                    V.setValue(h, "boneTexture", X.boneTexture), V.setValue(h, "boneTextureSize", X.boneTextureSize);
                  } else V.setOptional(h, X, "boneMatrices");
                }
              }
              return F && (V.setValue(h, "toneMappingExposure", P.toneMappingExposure), V.setValue(h, "toneMappingWhitePoint", P.toneMappingWhitePoint), n.lights && (j = z, (I = W).ambientLightColor.needsUpdate = j, I.directionalLights.needsUpdate = j, I.pointLights.needsUpdate = j, I.spotLights.needsUpdate = j, I.rectAreaLights.needsUpdate = j, I.hemisphereLights.needsUpdate = j), t && n.fog && (R = t, (O = W).fogColor.value = R.color, R.isFog ? (O.fogNear.value = R.near, O.fogFar.value = R.far) : R.isFogExp2 && (O.fogDensity.value = R.density)), n.isMeshBasicMaterial ? Ee(W, n) : n.isMeshLambertMaterial ? (Ee(W, n), C = W, (k = n).emissiveMap && (C.emissiveMap.value = k.emissiveMap)) : n.isMeshPhongMaterial ? (Ee(W, n), n.isMeshToonMaterial ? (Te(T = W, M = n), M.gradientMap && (T.gradientMap.value = M.gradientMap)) : Te(W, n)) : n.isMeshStandardMaterial ? (Ee(W, n), n.isMeshPhysicalMaterial ? (Ce(A = W, E = n), A.reflectivity.value = E.reflectivity, A.clearCoat.value = E.clearCoat, A.clearCoatRoughness.value = E.clearCoatRoughness) : Ce(W, n)) : n.isMeshDepthMaterial ? (Ee(W, n), w = W, (S = n).displacementMap && (w.displacementMap.value = S.displacementMap, w.displacementScale.value = S.displacementScale, w.displacementBias.value = S.displacementBias)) : n.isMeshDistanceMaterial ? (Ee(W, n), function (e, t) {
                t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias), e.referencePosition.value.copy(t.referencePosition), e.nearDistance.value = t.nearDistance, e.farDistance.value = t.farDistance;
              }(W, n)) : n.isMeshNormalMaterial ? (Ee(W, n), function (e, t) {
                t.bumpMap && (e.bumpMap.value = t.bumpMap, e.bumpScale.value = t.bumpScale, 1 === t.side && (e.bumpScale.value *= -1)), t.normalMap && (e.normalMap.value = t.normalMap, e.normalScale.value.copy(t.normalScale), 1 === t.side && e.normalScale.value.negate()), t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias);
              }(W, n)) : n.isLineBasicMaterial ? (x = n, (_ = W).diffuse.value = x.color, _.opacity.value = x.opacity, n.isLineDashedMaterial && (b = n, (y = W).dashSize.value = b.dashSize, y.totalSize.value = b.dashSize + b.gapSize, y.scale.value = b.scale)) : n.isPointsMaterial ? (g = n, (f = W).diffuse.value = g.color, f.opacity.value = g.opacity, f.size.value = g.size * q, f.scale.value = .5 * H, f.map.value = g.map, null !== g.map && (!0 === g.map.matrixAutoUpdate && g.map.updateMatrix(), f.uvTransform.value.copy(g.map.matrix))) : n.isSpriteMaterial ? (c = n, (u = W).diffuse.value = c.color, u.opacity.value = c.opacity, u.rotation.value = c.rotation, u.map.value = c.map, null !== c.map && (!0 === c.map.matrixAutoUpdate && c.map.updateMatrix(), u.uvTransform.value.copy(c.map.matrix))) : n.isShadowMaterial && (W.color.value = n.color, W.opacity.value = n.opacity), void 0 !== W.ltc_1 && (W.ltc_1.value = Ge.LTC_1), void 0 !== W.ltc_2 && (W.ltc_2.value = Ge.LTC_2), Or.upload(h, i.uniformsList, W, P)), n.isShaderMaterial && !0 === n.uniformsNeedUpdate && (Or.upload(h, i.uniformsList, W, P), n.uniformsNeedUpdate = !1), n.isSpriteMaterial && V.setValue(h, "center", r.center), V.setValue(h, "modelViewMatrix", r.modelViewMatrix), V.setValue(h, "normalMatrix", r.normalMatrix), V.setValue(h, "modelMatrix", r.matrixWorld), U;
            }
            function Ee(e, t) {
              var n;
              e.opacity.value = t.opacity, t.color && (e.diffuse.value = t.color), t.emissive && e.emissive.value.copy(t.emissive).multiplyScalar(t.emissiveIntensity), t.map && (e.map.value = t.map), t.alphaMap && (e.alphaMap.value = t.alphaMap), t.specularMap && (e.specularMap.value = t.specularMap), t.envMap && (e.envMap.value = t.envMap, e.flipEnvMap.value = t.envMap && t.envMap.isCubeTexture ? -1 : 1, e.reflectivity.value = t.reflectivity, e.refractionRatio.value = t.refractionRatio, e.maxMipLevel.value = v.get(t.envMap).__maxMipLevel), t.lightMap && (e.lightMap.value = t.lightMap, e.lightMapIntensity.value = t.lightMapIntensity), t.aoMap && (e.aoMap.value = t.aoMap, e.aoMapIntensity.value = t.aoMapIntensity), t.map ? n = t.map : t.specularMap ? n = t.specularMap : t.displacementMap ? n = t.displacementMap : t.normalMap ? n = t.normalMap : t.bumpMap ? n = t.bumpMap : t.roughnessMap ? n = t.roughnessMap : t.metalnessMap ? n = t.metalnessMap : t.alphaMap ? n = t.alphaMap : t.emissiveMap && (n = t.emissiveMap), void 0 !== n && (n.isWebGLRenderTarget && (n = n.texture), !0 === n.matrixAutoUpdate && n.updateMatrix(), e.uvTransform.value.copy(n.matrix));
            }
            function Te(e, t) {
              e.specular.value = t.specular, e.shininess.value = Math.max(t.shininess, 1e-4), t.emissiveMap && (e.emissiveMap.value = t.emissiveMap), t.bumpMap && (e.bumpMap.value = t.bumpMap, e.bumpScale.value = t.bumpScale, 1 === t.side && (e.bumpScale.value *= -1)), t.normalMap && (e.normalMap.value = t.normalMap, e.normalScale.value.copy(t.normalScale), 1 === t.side && e.normalScale.value.negate()), t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias);
            }
            function Ce(e, t) {
              e.roughness.value = t.roughness, e.metalness.value = t.metalness, t.roughnessMap && (e.roughnessMap.value = t.roughnessMap), t.metalnessMap && (e.metalnessMap.value = t.metalnessMap), t.emissiveMap && (e.emissiveMap.value = t.emissiveMap), t.bumpMap && (e.bumpMap.value = t.bumpMap, e.bumpScale.value = t.bumpScale, 1 === t.side && (e.bumpScale.value *= -1)), t.normalMap && (e.normalMap.value = t.normalMap, e.normalScale.value.copy(t.normalScale), 1 === t.side && e.normalScale.value.negate()), t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias), t.envMap && (e.envMapIntensity.value = t.envMapIntensity);
            }
            _e.setAnimationLoop(function (e) {
              ce.isPresenting() || be && be(e);
            }), "undefined" != typeof window && _e.setContext(window), this.setAnimationLoop = function (e) {
              be = e, ce.setAnimationLoop(e), _e.start();
            }, this.render = function (e, t, n, r) {
              if (t && t.isCamera) {
                if (!O) {
                  L.geometry = null, L.program = null, L.wireframe = !1, N = -1, !(D = null) === e.autoUpdate && e.updateMatrixWorld(), null === t.parent && t.updateMatrixWorld(), ce.enabled && (t = ce.getCamera(t)), (d = A.get(e, t)).init(), e.onBeforeRender(P, e, t, n), re.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), Q.setFromMatrix(re), te = this.localClippingEnabled, ee = J.init(this.clippingPlanes, te, t), (c = S.get(e, t)).init(), function e(t, n, r) {
                    if (!1 !== t.visible) {
                      if (t.layers.test(n.layers)) if (t.isLight) d.pushLight(t), t.castShadow && d.pushShadow(t);else if (t.isSprite) {
                        if (!t.frustumCulled || Q.intersectsSprite(t)) {
                          r && oe.setFromMatrixPosition(t.matrixWorld).applyMatrix4(re);
                          var i = x.update(t),
                            o = t.material;
                          c.push(t, i, o, oe.z, null);
                        }
                      } else if (t.isImmediateRenderObject) r && oe.setFromMatrixPosition(t.matrixWorld).applyMatrix4(re), c.push(t, null, t.material, oe.z, null);else if ((t.isMesh || t.isLine || t.isPoints) && (t.isSkinnedMesh && t.skeleton.update(), !t.frustumCulled || Q.intersectsObject(t))) if (r && oe.setFromMatrixPosition(t.matrixWorld).applyMatrix4(re), i = x.update(t), o = t.material, Array.isArray(o)) for (var a = i.groups, s = 0, l = a.length; s < l; s++) {
                        var u = a[s],
                          h = o[u.materialIndex];
                        h && h.visible && c.push(t, i, h, oe.z, u);
                      } else o.visible && c.push(t, i, o, oe.z, null);
                      var f = t.children;
                      for (s = 0, l = f.length; s < l; s++) e(f[s], n, r);
                    }
                  }(e, t, P.sortObjects), !0 === P.sortObjects && c.sort(), ee && J.beginShadows();
                  var i = d.state.shadowsArray;
                  de.render(i, e, t), d.setupLights(t), ee && J.endShadows(), this.info.autoReset && this.info.reset(), void 0 === n && (n = null), this.setRenderTarget(n), E.render(c, e, t, r);
                  var o = c.opaque,
                    a = c.transparent;
                  if (e.overrideMaterial) {
                    var s = e.overrideMaterial;
                    o.length && xe(o, e, t, s), a.length && xe(a, e, t, s);
                  } else o.length && xe(o, e, t), a.length && xe(a, e, t);
                  n && y.updateRenderTargetMipmap(n), m.buffers.depth.setTest(!0), m.buffers.depth.setMask(!0), m.buffers.color.setMask(!0), m.setPolygonOffset(!1), e.onAfterRender(P, e, t), ce.enabled && ce.submitFrame(), d = c = null;
                }
              } else console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            }, this.allocTextureUnit = function () {
              var e = G;
              return e >= p.maxTextures && console.warn("THREE.WebGLRenderer: Trying to use " + e + " texture units while this GPU supports only " + p.maxTextures), G += 1, e;
            }, this.setTexture2D = (ge = !1, function (e, t) {
              e && e.isWebGLRenderTarget && (ge || (console.warn("THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead."), ge = !0), e = e.texture), y.setTexture2D(e, t);
            }), this.setTexture = (ve = !1, function (e, t) {
              ve || (console.warn("THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead."), ve = !0), y.setTexture2D(e, t);
            }), this.setTextureCube = (ye = !1, function (e, t) {
              e && e.isWebGLRenderTargetCube && (ye || (console.warn("THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead."), ye = !0), e = e.texture), e && e.isCubeTexture || Array.isArray(e.image) && 6 === e.image.length ? y.setTextureCube(e, t) : y.setTextureCubeDynamic(e, t);
            }), this.setFramebuffer = function (e) {
              R = e;
            }, this.getRenderTarget = function () {
              return I;
            }, this.setRenderTarget = function (e) {
              (I = e) && void 0 === v.get(e).__webglFramebuffer && y.setupRenderTarget(e);
              var t = R,
                n = !1;
              if (e) {
                var r = v.get(e).__webglFramebuffer;
                e.isWebGLRenderTargetCube ? (t = r[e.activeCubeFace], n = !0) : t = r, F.copy(e.viewport), z.copy(e.scissor), U = e.scissorTest;
              } else F.copy(W).multiplyScalar(q), z.copy($).multiplyScalar(q), U = K;
              if (j !== t && (h.bindFramebuffer(h.FRAMEBUFFER, t), j = t), m.viewport(F), m.scissor(z), m.setScissorTest(U), n) {
                var i = v.get(e.texture);
                h.framebufferTexture2D(h.FRAMEBUFFER, h.COLOR_ATTACHMENT0, h.TEXTURE_CUBE_MAP_POSITIVE_X + e.activeCubeFace, i.__webglTexture, e.activeMipMapLevel);
              }
            }, this.readRenderTargetPixels = function (e, t, n, r, i, o) {
              if (e && e.isWebGLRenderTarget) {
                var a = v.get(e).__webglFramebuffer;
                if (a) {
                  var s = !1;
                  a !== j && (h.bindFramebuffer(h.FRAMEBUFFER, a), s = !0);
                  try {
                    var l = e.texture,
                      u = l.format,
                      c = l.type;
                    if (u !== Z && k.convert(u) !== h.getParameter(h.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    if (!(c === X || k.convert(c) === h.getParameter(h.IMPLEMENTATION_COLOR_READ_TYPE) || c === Y && (p.isWebGL2 || f.get("OES_texture_float") || f.get("WEBGL_color_buffer_float")) || 1016 === c && (p.isWebGL2 ? f.get("EXT_color_buffer_float") : f.get("EXT_color_buffer_half_float")))) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    h.checkFramebufferStatus(h.FRAMEBUFFER) === h.FRAMEBUFFER_COMPLETE ? 0 <= t && t <= e.width - r && 0 <= n && n <= e.height - i && h.readPixels(t, n, r, i, k.convert(u), k.convert(c), o) : console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
                  } finally {
                    s && h.bindFramebuffer(h.FRAMEBUFFER, j);
                  }
                }
              } else console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            }, this.copyFramebufferToTexture = function (e, t, n) {
              var r = t.image.width,
                i = t.image.height,
                o = k.convert(t.format);
              this.setTexture2D(t, 0), h.copyTexImage2D(h.TEXTURE_2D, n || 0, o, e.x, e.y, r, i, 0);
            }, this.copyTextureToTexture = function (e, t, n, r) {
              var i = t.image.width,
                o = t.image.height,
                a = k.convert(n.format),
                s = k.convert(n.type);
              this.setTexture2D(n, 0), t.isDataTexture ? h.texSubImage2D(h.TEXTURE_2D, r || 0, e.x, e.y, i, o, a, s, t.image.data) : h.texSubImage2D(h.TEXTURE_2D, r || 0, e.x, e.y, a, s, t.image);
            };
          }
          function Mi(e, t) {
            this.name = "", this.color = new Fe(e), this.density = void 0 !== t ? t : 25e-5;
          }
          function Ci(e, t, n) {
            this.name = "", this.color = new Fe(e), this.near = void 0 !== t ? t : 1, this.far = void 0 !== n ? n : 1e3;
          }
          function ki() {
            ft.call(this), this.type = "Scene", this.background = null, this.fog = null, this.overrideMaterial = null, this.autoUpdate = !0;
          }
          function Pi(e, t) {
            this.array = e, this.stride = t, this.count = void 0 !== e ? e.length / t : 0, this.dynamic = !1, this.updateRange = {
              offset: 0,
              count: -1
            }, this.version = 0;
          }
          function Oi(e, t, n, r) {
            this.data = e, this.itemSize = t, this.offset = n, this.normalized = !0 === r;
          }
          function Ri(e) {
            Tn.call(this), this.type = "SpriteMaterial", this.color = new Fe(16777215), this.map = null, this.rotation = 0, this.lights = !1, this.transparent = !0, this.setValues(e);
          }
          function Ii(e) {
            if (ft.call(this), this.type = "Sprite", void 0 === Yr) {
              Yr = new Yt();
              var t = new Pi(new Float32Array([-.5, -.5, 0, 0, 0, .5, -.5, 0, 1, 0, .5, .5, 0, 1, 1, -.5, .5, 0, 0, 1]), 5);
              Yr.setIndex([0, 1, 2, 0, 2, 3]), Yr.addAttribute("position", new Oi(t, 3, 0, !1)), Yr.addAttribute("uv", new Oi(t, 2, 3, !1));
            }
            this.geometry = Yr, this.material = void 0 !== e ? e : new Ri(), this.center = new re(.5, .5);
          }
          function ji() {
            ft.call(this), this.type = "LOD", Object.defineProperties(this, {
              levels: {
                enumerable: !0,
                value: []
              }
            });
          }
          function Ni(e, t) {
            if (e = e || [], this.bones = e.slice(0), this.boneMatrices = new Float32Array(16 * this.bones.length), void 0 === t) this.calculateInverses();else if (this.bones.length === t.length) this.boneInverses = t.slice(0);else {
              console.warn("THREE.Skeleton boneInverses is the wrong length."), this.boneInverses = [];
              for (var n = 0, r = this.bones.length; n < r; n++) this.boneInverses.push(new ie());
            }
          }
          function Li() {
            ft.call(this), this.type = "Bone";
          }
          function Di(e, t) {
            On.call(this, e, t), this.type = "SkinnedMesh", this.bindMode = "attached", this.bindMatrix = new ie(), this.bindMatrixInverse = new ie();
            var n = new Ni(this.initBones());
            this.bind(n, this.matrixWorld), this.normalizeSkinWeights();
          }
          function Bi(e) {
            Tn.call(this), this.type = "LineBasicMaterial", this.color = new Fe(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.lights = !1, this.setValues(e);
          }
          function Fi(e, t, n) {
            1 === n && console.error("THREE.Line: parameter THREE.LinePieces no longer supported. Use THREE.LineSegments instead."), ft.call(this), this.type = "Line", this.geometry = void 0 !== e ? e : new Yt(), this.material = void 0 !== t ? t : new Bi({
              color: 16777215 * Math.random()
            });
          }
          function zi(e, t) {
            Fi.call(this, e, t), this.type = "LineSegments";
          }
          function Ui(e, t) {
            Fi.call(this, e, t), this.type = "LineLoop";
          }
          function Gi(e) {
            Tn.call(this), this.type = "PointsMaterial", this.color = new Fe(16777215), this.map = null, this.size = 1, this.sizeAttenuation = !0, this.morphTargets = !1, this.lights = !1, this.setValues(e);
          }
          function Vi(e, t) {
            ft.call(this), this.type = "Points", this.geometry = void 0 !== e ? e : new Yt(), this.material = void 0 !== t ? t : new Gi({
              color: 16777215 * Math.random()
            });
          }
          function Hi(e, t, n, r, i, o, a, s, l) {
            Te.call(this, e, t, n, r, i, o, a, s, l), this.generateMipmaps = !1;
          }
          function qi(e, t, n, r, i, o, a, s, l, u, c, d) {
            Te.call(this, null, o, a, s, l, u, r, i, c, d), this.image = {
              width: t,
              height: n
            }, this.mipmaps = e, this.flipY = !1, this.generateMipmaps = !1;
          }
          function Wi(e, t, n, r, i, o, a, s, l) {
            Te.call(this, e, t, n, r, i, o, a, s, l), this.needsUpdate = !0;
          }
          function $i(e, t, n, r, i, o, a, s, l, u) {
            if ((u = void 0 !== u ? u : Q) !== Q && u !== J) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
            void 0 === n && u === Q && (n = 1012), void 0 === n && u === J && (n = 1020), Te.call(this, null, r, i, o, a, s, u, n, l), this.image = {
              width: e,
              height: t
            }, this.magFilter = void 0 !== a ? a : W, this.minFilter = void 0 !== s ? s : W, this.flipY = !1, this.generateMipmaps = !1;
          }
          function Xi(e) {
            Yt.call(this), this.type = "WireframeGeometry";
            var t,
              n,
              r,
              i,
              o,
              a,
              s,
              l,
              u,
              c,
              d = [],
              h = [0, 0],
              f = {},
              p = ["a", "b", "c"];
            if (e && e.isGeometry) {
              var m = e.faces;
              for (t = 0, r = m.length; t < r; t++) {
                var g = m[t];
                for (n = 0; n < 3; n++) s = g[p[n]], l = g[p[(n + 1) % 3]], h[0] = Math.min(s, l), h[1] = Math.max(s, l), void 0 === f[u = h[0] + "," + h[1]] && (f[u] = {
                  index1: h[0],
                  index2: h[1]
                });
              }
              for (u in f) a = f[u], c = e.vertices[a.index1], d.push(c.x, c.y, c.z), c = e.vertices[a.index2], d.push(c.x, c.y, c.z);
            } else if (e && e.isBufferGeometry) {
              var v, y, b, _, x, w;
              if (c = new ae(), null !== e.index) {
                for (v = e.attributes.position, y = e.index, 0 === (b = e.groups).length && (b = [{
                  start: 0,
                  count: y.count,
                  materialIndex: 0
                }]), i = 0, o = b.length; i < o; ++i) for (r = (t = (_ = b[i]).start) + _.count; t < r; t += 3) for (n = 0; n < 3; n++) s = y.getX(t + n), l = y.getX(t + (n + 1) % 3), h[0] = Math.min(s, l), h[1] = Math.max(s, l), void 0 === f[u = h[0] + "," + h[1]] && (f[u] = {
                  index1: h[0],
                  index2: h[1]
                });
                for (u in f) a = f[u], c.fromBufferAttribute(v, a.index1), d.push(c.x, c.y, c.z), c.fromBufferAttribute(v, a.index2), d.push(c.x, c.y, c.z);
              } else for (t = 0, r = (v = e.attributes.position).count / 3; t < r; t++) for (n = 0; n < 3; n++) x = 3 * t + n, c.fromBufferAttribute(v, x), d.push(c.x, c.y, c.z), w = 3 * t + (n + 1) % 3, c.fromBufferAttribute(v, w), d.push(c.x, c.y, c.z);
            }
            this.addAttribute("position", new jt(d, 3));
          }
          function Yi(e, t, n) {
            Et.call(this), this.type = "ParametricGeometry", this.parameters = {
              func: e,
              slices: t,
              stacks: n
            }, this.fromBufferGeometry(new Ki(e, t, n)), this.mergeVertices();
          }
          function Ki(e, t, n) {
            Yt.call(this), this.type = "ParametricBufferGeometry", this.parameters = {
              func: e,
              slices: t,
              stacks: n
            };
            var r,
              i,
              o = [],
              a = [],
              s = [],
              l = [],
              u = new ae(),
              c = new ae(),
              d = new ae(),
              h = new ae(),
              f = new ae();
            e.length < 3 && console.error("THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.");
            var p = t + 1;
            for (r = 0; r <= n; r++) {
              var m = r / n;
              for (i = 0; i <= t; i++) {
                var g = i / t;
                e(g, m, c), a.push(c.x, c.y, c.z), 0 <= g - 1e-5 ? (e(g - 1e-5, m, d), h.subVectors(c, d)) : (e(g + 1e-5, m, d), h.subVectors(d, c)), 0 <= m - 1e-5 ? (e(g, m - 1e-5, d), f.subVectors(c, d)) : (e(g, m + 1e-5, d), f.subVectors(d, c)), u.crossVectors(h, f).normalize(), s.push(u.x, u.y, u.z), l.push(g, m);
              }
            }
            for (r = 0; r < n; r++) for (i = 0; i < t; i++) {
              var v = r * p + i,
                y = r * p + i + 1,
                b = (r + 1) * p + i + 1,
                _ = (r + 1) * p + i;
              o.push(v, y, _), o.push(y, b, _);
            }
            this.setIndex(o), this.addAttribute("position", new jt(a, 3)), this.addAttribute("normal", new jt(s, 3)), this.addAttribute("uv", new jt(l, 2));
          }
          function Zi(e, t, n, r) {
            Et.call(this), this.type = "PolyhedronGeometry", this.parameters = {
              vertices: e,
              indices: t,
              radius: n,
              detail: r
            }, this.fromBufferGeometry(new Qi(e, t, n, r)), this.mergeVertices();
          }
          function Qi(e, t, n, r) {
            Yt.call(this), this.type = "PolyhedronBufferGeometry", this.parameters = {
              vertices: e,
              indices: t,
              radius: n,
              detail: r
            }, n = n || 1;
            var i = [],
              o = [];
            function a(e, t, n, r) {
              var i,
                o,
                a = Math.pow(2, r),
                l = [];
              for (i = 0; i <= a; i++) {
                l[i] = [];
                var u = e.clone().lerp(n, i / a),
                  c = t.clone().lerp(n, i / a),
                  d = a - i;
                for (o = 0; o <= d; o++) l[i][o] = 0 === o && i === a ? u : u.clone().lerp(c, o / d);
              }
              for (i = 0; i < a; i++) for (o = 0; o < 2 * (a - i) - 1; o++) {
                var h = Math.floor(o / 2);
                o % 2 == 0 ? (s(l[i][h + 1]), s(l[i + 1][h]), s(l[i][h])) : (s(l[i][h + 1]), s(l[i + 1][h + 1]), s(l[i + 1][h]));
              }
            }
            function s(e) {
              i.push(e.x, e.y, e.z);
            }
            function l(t, n) {
              var r = 3 * t;
              n.x = e[r + 0], n.y = e[r + 1], n.z = e[r + 2];
            }
            function u(e, t, n, r) {
              r < 0 && 1 === e.x && (o[t] = e.x - 1), 0 === n.x && 0 === n.z && (o[t] = r / 2 / Math.PI + .5);
            }
            function c(e) {
              return Math.atan2(e.z, -e.x);
            }
            !function (e) {
              for (var n = new ae(), r = new ae(), i = new ae(), o = 0; o < t.length; o += 3) l(t[o + 0], n), l(t[o + 1], r), l(t[o + 2], i), a(n, r, i, e);
            }(r = r || 0), function (e) {
              for (var t = new ae(), n = 0; n < i.length; n += 3) t.x = i[n + 0], t.y = i[n + 1], t.z = i[n + 2], t.normalize().multiplyScalar(e), i[n + 0] = t.x, i[n + 1] = t.y, i[n + 2] = t.z;
            }(n), function () {
              for (var e = new ae(), t = 0; t < i.length; t += 3) {
                e.x = i[t + 0], e.y = i[t + 1], e.z = i[t + 2];
                var n = c(e) / 2 / Math.PI + .5,
                  r = (a = e, Math.atan2(-a.y, Math.sqrt(a.x * a.x + a.z * a.z)) / Math.PI + .5);
                o.push(n, 1 - r);
              }
              var a;
              (function () {
                for (var e = new ae(), t = new ae(), n = new ae(), r = new ae(), a = new re(), s = new re(), l = new re(), d = 0, h = 0; d < i.length; d += 9, h += 6) {
                  e.set(i[d + 0], i[d + 1], i[d + 2]), t.set(i[d + 3], i[d + 4], i[d + 5]), n.set(i[d + 6], i[d + 7], i[d + 8]), a.set(o[h + 0], o[h + 1]), s.set(o[h + 2], o[h + 3]), l.set(o[h + 4], o[h + 5]), r.copy(e).add(t).add(n).divideScalar(3);
                  var f = c(r);
                  u(a, h + 0, e, f), u(s, h + 2, t, f), u(l, h + 4, n, f);
                }
              })(), function () {
                for (var e = 0; e < o.length; e += 6) {
                  var t = o[e + 0],
                    n = o[e + 2],
                    r = o[e + 4],
                    i = Math.max(t, n, r),
                    a = Math.min(t, n, r);
                  .9 < i && a < .1 && (t < .2 && (o[e + 0] += 1), n < .2 && (o[e + 2] += 1), r < .2 && (o[e + 4] += 1));
                }
              }();
            }(), this.addAttribute("position", new jt(i, 3)), this.addAttribute("normal", new jt(i.slice(), 3)), this.addAttribute("uv", new jt(o, 2)), 0 === r ? this.computeVertexNormals() : this.normalizeNormals();
          }
          function Ji(e, t) {
            Et.call(this), this.type = "TetrahedronGeometry", this.parameters = {
              radius: e,
              detail: t
            }, this.fromBufferGeometry(new eo(e, t)), this.mergeVertices();
          }
          function eo(e, t) {
            Qi.call(this, [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1], [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1], e, t), this.type = "TetrahedronBufferGeometry", this.parameters = {
              radius: e,
              detail: t
            };
          }
          function to(e, t) {
            Et.call(this), this.type = "OctahedronGeometry", this.parameters = {
              radius: e,
              detail: t
            }, this.fromBufferGeometry(new no(e, t)), this.mergeVertices();
          }
          function no(e, t) {
            Qi.call(this, [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1], [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2], e, t), this.type = "OctahedronBufferGeometry", this.parameters = {
              radius: e,
              detail: t
            };
          }
          function ro(e, t) {
            Et.call(this), this.type = "IcosahedronGeometry", this.parameters = {
              radius: e,
              detail: t
            }, this.fromBufferGeometry(new io(e, t)), this.mergeVertices();
          }
          function io(e, t) {
            var n = (1 + Math.sqrt(5)) / 2;
            Qi.call(this, [-1, n, 0, 1, n, 0, -1, -n, 0, 1, -n, 0, 0, -1, n, 0, 1, n, 0, -1, -n, 0, 1, -n, n, 0, -1, n, 0, 1, -n, 0, -1, -n, 0, 1], [0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1], e, t), this.type = "IcosahedronBufferGeometry", this.parameters = {
              radius: e,
              detail: t
            };
          }
          function oo(e, t) {
            Et.call(this), this.type = "DodecahedronGeometry", this.parameters = {
              radius: e,
              detail: t
            }, this.fromBufferGeometry(new ao(e, t)), this.mergeVertices();
          }
          function ao(e, t) {
            var n = (1 + Math.sqrt(5)) / 2,
              r = 1 / n;
            Qi.call(this, [-1, -1, -1, -1, -1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1, 0, -r, -n, 0, -r, n, 0, r, -n, 0, r, n, -r, -n, 0, -r, n, 0, r, -n, 0, r, n, 0, -n, 0, -r, n, 0, -r, -n, 0, r, n, 0, r], [3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9], e, t), this.type = "DodecahedronBufferGeometry", this.parameters = {
              radius: e,
              detail: t
            };
          }
          function so(e, t, n, r, i, o) {
            Et.call(this), this.type = "TubeGeometry", this.parameters = {
              path: e,
              tubularSegments: t,
              radius: n,
              radialSegments: r,
              closed: i
            }, void 0 !== o && console.warn("THREE.TubeGeometry: taper has been removed.");
            var a = new lo(e, t, n, r, i);
            this.tangents = a.tangents, this.normals = a.normals, this.binormals = a.binormals, this.fromBufferGeometry(a), this.mergeVertices();
          }
          function lo(e, t, n, r, i) {
            Yt.call(this), this.type = "TubeBufferGeometry", this.parameters = {
              path: e,
              tubularSegments: t,
              radius: n,
              radialSegments: r,
              closed: i
            }, t = t || 64, n = n || 1, r = r || 8, i = i || !1;
            var o = e.computeFrenetFrames(t, i);
            this.tangents = o.tangents, this.normals = o.normals, this.binormals = o.binormals;
            var a,
              s,
              l = new ae(),
              u = new ae(),
              c = new re(),
              d = new ae(),
              h = [],
              f = [],
              p = [],
              m = [];
            function g(i) {
              d = e.getPointAt(i / t, d);
              var a = o.normals[i],
                c = o.binormals[i];
              for (s = 0; s <= r; s++) {
                var p = s / r * Math.PI * 2,
                  m = Math.sin(p),
                  g = -Math.cos(p);
                u.x = g * a.x + m * c.x, u.y = g * a.y + m * c.y, u.z = g * a.z + m * c.z, u.normalize(), f.push(u.x, u.y, u.z), l.x = d.x + n * u.x, l.y = d.y + n * u.y, l.z = d.z + n * u.z, h.push(l.x, l.y, l.z);
              }
            }
            !function () {
              for (a = 0; a < t; a++) g(a);
              g(!1 === i ? t : 0), function () {
                for (a = 0; a <= t; a++) for (s = 0; s <= r; s++) c.x = a / t, c.y = s / r, p.push(c.x, c.y);
              }(), function () {
                for (s = 1; s <= t; s++) for (a = 1; a <= r; a++) {
                  var e = (r + 1) * (s - 1) + (a - 1),
                    n = (r + 1) * s + (a - 1),
                    i = (r + 1) * s + a,
                    o = (r + 1) * (s - 1) + a;
                  m.push(e, n, o), m.push(n, i, o);
                }
              }();
            }(), this.setIndex(m), this.addAttribute("position", new jt(h, 3)), this.addAttribute("normal", new jt(f, 3)), this.addAttribute("uv", new jt(p, 2));
          }
          function uo(e, t, n, r, i, o, a) {
            Et.call(this), this.type = "TorusKnotGeometry", this.parameters = {
              radius: e,
              tube: t,
              tubularSegments: n,
              radialSegments: r,
              p: i,
              q: o
            }, void 0 !== a && console.warn("THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead."), this.fromBufferGeometry(new co(e, t, n, r, i, o)), this.mergeVertices();
          }
          function co(e, t, n, r, i, o) {
            Yt.call(this), this.type = "TorusKnotBufferGeometry", this.parameters = {
              radius: e,
              tube: t,
              tubularSegments: n,
              radialSegments: r,
              p: i,
              q: o
            }, e = e || 1, t = t || .4, n = Math.floor(n) || 64, r = Math.floor(r) || 8, i = i || 2, o = o || 3;
            var a,
              s,
              l = [],
              u = [],
              c = [],
              d = [],
              h = new ae(),
              f = new ae(),
              p = new ae(),
              m = new ae(),
              g = new ae(),
              v = new ae(),
              y = new ae();
            for (a = 0; a <= n; ++a) {
              var b = a / n * i * Math.PI * 2;
              for (M(b, i, o, e, p), M(b + .01, i, o, e, m), v.subVectors(m, p), y.addVectors(m, p), g.crossVectors(v, y), y.crossVectors(g, v), g.normalize(), y.normalize(), s = 0; s <= r; ++s) {
                var _ = s / r * Math.PI * 2,
                  x = -t * Math.cos(_),
                  w = t * Math.sin(_);
                h.x = p.x + (x * y.x + w * g.x), h.y = p.y + (x * y.y + w * g.y), h.z = p.z + (x * y.z + w * g.z), u.push(h.x, h.y, h.z), f.subVectors(h, p).normalize(), c.push(f.x, f.y, f.z), d.push(a / n), d.push(s / r);
              }
            }
            for (s = 1; s <= n; s++) for (a = 1; a <= r; a++) {
              var S = (r + 1) * (s - 1) + (a - 1),
                A = (r + 1) * s + (a - 1),
                E = (r + 1) * s + a,
                T = (r + 1) * (s - 1) + a;
              l.push(S, A, T), l.push(A, E, T);
            }
            function M(e, t, n, r, i) {
              var o = Math.cos(e),
                a = Math.sin(e),
                s = n / t * e,
                l = Math.cos(s);
              i.x = r * (2 + l) * .5 * o, i.y = r * (2 + l) * a * .5, i.z = r * Math.sin(s) * .5;
            }
            this.setIndex(l), this.addAttribute("position", new jt(u, 3)), this.addAttribute("normal", new jt(c, 3)), this.addAttribute("uv", new jt(d, 2));
          }
          function ho(e, t, n, r, i) {
            Et.call(this), this.type = "TorusGeometry", this.parameters = {
              radius: e,
              tube: t,
              radialSegments: n,
              tubularSegments: r,
              arc: i
            }, this.fromBufferGeometry(new fo(e, t, n, r, i)), this.mergeVertices();
          }
          function fo(e, t, n, r, i) {
            Yt.call(this), this.type = "TorusBufferGeometry", this.parameters = {
              radius: e,
              tube: t,
              radialSegments: n,
              tubularSegments: r,
              arc: i
            }, e = e || 1, t = t || .4, n = Math.floor(n) || 8, r = Math.floor(r) || 6, i = i || 2 * Math.PI;
            var o,
              a,
              s = [],
              l = [],
              u = [],
              c = [],
              d = new ae(),
              h = new ae(),
              f = new ae();
            for (o = 0; o <= n; o++) for (a = 0; a <= r; a++) {
              var p = a / r * i,
                m = o / n * Math.PI * 2;
              h.x = (e + t * Math.cos(m)) * Math.cos(p), h.y = (e + t * Math.cos(m)) * Math.sin(p), h.z = t * Math.sin(m), l.push(h.x, h.y, h.z), d.x = e * Math.cos(p), d.y = e * Math.sin(p), f.subVectors(h, d).normalize(), u.push(f.x, f.y, f.z), c.push(a / r), c.push(o / n);
            }
            for (o = 1; o <= n; o++) for (a = 1; a <= r; a++) {
              var g = (r + 1) * o + a - 1,
                v = (r + 1) * (o - 1) + a - 1,
                y = (r + 1) * (o - 1) + a,
                b = (r + 1) * o + a;
              s.push(g, v, b), s.push(v, y, b);
            }
            this.setIndex(s), this.addAttribute("position", new jt(l, 3)), this.addAttribute("normal", new jt(u, 3)), this.addAttribute("uv", new jt(c, 2));
          }
          function po(e, t, n, r, i) {
            var o, a;
            if (i === 0 < function (e, t, n, r) {
              for (var i = 0, o = t, a = n - r; o < n; o += r) i += (e[a] - e[o]) * (e[o + 1] + e[a + 1]), a = o;
              return i;
            }(e, t, n, r)) for (o = t; o < n; o += r) a = Oo(o, e[o], e[o + 1], a);else for (o = n - r; t <= o; o -= r) a = Oo(o, e[o], e[o + 1], a);
            return a && Mo(a, a.next) && (Ro(a), a = a.next), a;
          }
          function mo(e, t) {
            if (!e) return e;
            t || (t = e);
            var n,
              r = e;
            do {
              if (n = !1, r.steiner || !Mo(r, r.next) && 0 !== To(r.prev, r, r.next)) r = r.next;else {
                if (Ro(r), (r = t = r.prev) === r.next) break;
                n = !0;
              }
            } while (n || r !== t);
            return t;
          }
          function go(e, t, n, r, i, o, a) {
            if (e) {
              !a && o && function (e, t, n, r) {
                for (var i = e; null === i.z && (i.z = So(i.x, i.y, t, n, r)), i.prevZ = i.prev, i.nextZ = i.next, (i = i.next) !== e;);
                i.prevZ.nextZ = null, i.prevZ = null, function (e) {
                  var t,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    u = 1;
                  do {
                    for (n = e, o = e = null, a = 0; n;) {
                      for (a++, r = n, t = s = 0; t < u && (s++, r = r.nextZ); t++);
                      for (l = u; 0 < s || 0 < l && r;) 0 !== s && (0 === l || !r || n.z <= r.z) ? (n = (i = n).nextZ, s--) : (r = (i = r).nextZ, l--), o ? o.nextZ = i : e = i, i.prevZ = o, o = i;
                      n = r;
                    }
                    o.nextZ = null, u *= 2;
                  } while (1 < a);
                }(i);
              }(e, r, i, o);
              for (var s, l, u = e; e.prev !== e.next;) if (s = e.prev, l = e.next, o ? yo(e, r, i, o) : vo(e)) t.push(s.i / n), t.push(e.i / n), t.push(l.i / n), Ro(e), e = l.next, u = l.next;else if ((e = l) === u) {
                a ? 1 === a ? go(e = bo(e, t, n), t, n, r, i, o, 2) : 2 === a && _o(e, t, n, r, i, o) : go(mo(e), t, n, r, i, o, 1);
                break;
              }
            }
          }
          function vo(e) {
            var t = e.prev,
              n = e,
              r = e.next;
            if (0 <= To(t, n, r)) return !1;
            for (var i = e.next.next; i !== e.prev;) {
              if (Eo(t.x, t.y, n.x, n.y, r.x, r.y, i.x, i.y) && 0 <= To(i.prev, i, i.next)) return !1;
              i = i.next;
            }
            return !0;
          }
          function yo(e, t, n, r) {
            var i = e.prev,
              o = e,
              a = e.next;
            if (0 <= To(i, o, a)) return !1;
            for (var s = i.x < o.x ? i.x < a.x ? i.x : a.x : o.x < a.x ? o.x : a.x, l = i.y < o.y ? i.y < a.y ? i.y : a.y : o.y < a.y ? o.y : a.y, u = i.x > o.x ? i.x > a.x ? i.x : a.x : o.x > a.x ? o.x : a.x, c = i.y > o.y ? i.y > a.y ? i.y : a.y : o.y > a.y ? o.y : a.y, d = So(s, l, t, n, r), h = So(u, c, t, n, r), f = e.nextZ; f && f.z <= h;) {
              if (f !== e.prev && f !== e.next && Eo(i.x, i.y, o.x, o.y, a.x, a.y, f.x, f.y) && 0 <= To(f.prev, f, f.next)) return !1;
              f = f.nextZ;
            }
            for (f = e.prevZ; f && f.z >= d;) {
              if (f !== e.prev && f !== e.next && Eo(i.x, i.y, o.x, o.y, a.x, a.y, f.x, f.y) && 0 <= To(f.prev, f, f.next)) return !1;
              f = f.prevZ;
            }
            return !0;
          }
          function bo(e, t, n) {
            var r = e;
            do {
              var i = r.prev,
                o = r.next.next;
              !Mo(i, o) && Co(i, r, r.next, o) && ko(i, o) && ko(o, i) && (t.push(i.i / n), t.push(r.i / n), t.push(o.i / n), Ro(r), Ro(r.next), r = e = o), r = r.next;
            } while (r !== e);
            return r;
          }
          function _o(e, t, n, r, i, o) {
            var a,
              s,
              l = e;
            do {
              for (var u = l.next.next; u !== l.prev;) {
                if (l.i !== u.i && (s = u, (a = l).next.i !== s.i && a.prev.i !== s.i && !function (e, t) {
                  var n = e;
                  do {
                    if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && Co(n, n.next, e, t)) return !0;
                    n = n.next;
                  } while (n !== e);
                  return !1;
                }(a, s) && ko(a, s) && ko(s, a) && function (e, t) {
                  for (var n = e, r = !1, i = (e.x + t.x) / 2, o = (e.y + t.y) / 2; n.y > o != n.next.y > o && n.next.y !== n.y && i < (n.next.x - n.x) * (o - n.y) / (n.next.y - n.y) + n.x && (r = !r), (n = n.next) !== e;);
                  return r;
                }(a, s))) {
                  var c = Po(l, u);
                  return l = mo(l, l.next), c = mo(c, c.next), go(l, t, n, r, i, o), void go(c, t, n, r, i, o);
                }
                u = u.next;
              }
              l = l.next;
            } while (l !== e);
          }
          function xo(e, t) {
            return e.x - t.x;
          }
          function wo(e, t) {
            if (t = function (e, t) {
              var n,
                r = t,
                i = e.x,
                o = e.y,
                a = -1 / 0;
              do {
                if (o <= r.y && o >= r.next.y && r.next.y !== r.y) {
                  var s = r.x + (o - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                  if (s <= i && a < s) {
                    if ((a = s) === i) {
                      if (o === r.y) return r;
                      if (o === r.next.y) return r.next;
                    }
                    n = r.x < r.next.x ? r : r.next;
                  }
                }
                r = r.next;
              } while (r !== t);
              if (!n) return null;
              if (i === a) return n.prev;
              var l,
                u = n,
                c = n.x,
                d = n.y,
                h = 1 / 0;
              for (r = n.next; r !== u;) i >= r.x && r.x >= c && i !== r.x && Eo(o < d ? i : a, o, c, d, o < d ? a : i, o, r.x, r.y) && ((l = Math.abs(o - r.y) / (i - r.x)) < h || l === h && r.x > n.x) && ko(r, e) && (n = r, h = l), r = r.next;
              return n;
            }(e, t)) {
              var n = Po(t, e);
              mo(n, n.next);
            }
          }
          function So(e, t, n, r, i) {
            return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = 32767 * (e - n) * i) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = 32767 * (t - r) * i) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
          }
          function Ao(e) {
            for (var t = e, n = e; t.x < n.x && (n = t), (t = t.next) !== e;);
            return n;
          }
          function Eo(e, t, n, r, i, o, a, s) {
            return 0 <= (i - a) * (t - s) - (e - a) * (o - s) && 0 <= (e - a) * (r - s) - (n - a) * (t - s) && 0 <= (n - a) * (o - s) - (i - a) * (r - s);
          }
          function To(e, t, n) {
            return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
          }
          function Mo(e, t) {
            return e.x === t.x && e.y === t.y;
          }
          function Co(e, t, n, r) {
            return !!(Mo(e, t) && Mo(n, r) || Mo(e, r) && Mo(n, t)) || 0 < To(e, t, n) != 0 < To(e, t, r) && 0 < To(n, r, e) != 0 < To(n, r, t);
          }
          function ko(e, t) {
            return To(e.prev, e, e.next) < 0 ? 0 <= To(e, t, e.next) && 0 <= To(e, e.prev, t) : To(e, t, e.prev) < 0 || To(e, e.next, t) < 0;
          }
          function Po(e, t) {
            var n = new Io(e.i, e.x, e.y),
              r = new Io(t.i, t.x, t.y),
              i = e.next,
              o = t.prev;
            return (e.next = t).prev = e, (n.next = i).prev = n, (r.next = n).prev = r, (o.next = r).prev = o, r;
          }
          function Oo(e, t, n, r) {
            var i = new Io(e, t, n);
            return r ? (i.next = r.next, (i.prev = r).next.prev = i, r.next = i) : (i.prev = i).next = i, i;
          }
          function Ro(e) {
            e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
          }
          function Io(e, t, n) {
            this.i = e, this.x = t, this.y = n, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
          }
          ((mi.prototype = Object.create(Tn.prototype)).constructor = mi).prototype.isMeshDepthMaterial = !0, mi.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.depthPacking = e.depthPacking, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
          }, ((gi.prototype = Object.create(Tn.prototype)).constructor = gi).prototype.isMeshDistanceMaterial = !0, gi.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.referencePosition.copy(e.referencePosition), this.nearDistance = e.nearDistance, this.farDistance = e.farDistance, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
          }, xi.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: xi,
            isGroup: !0
          }), wi.prototype = Object.assign(Object.create(pt.prototype), {
            constructor: wi,
            isPerspectiveCamera: !0,
            copy: function copy(e, t) {
              return pt.prototype.copy.call(this, e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = null === e.view ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
            },
            setFocalLength: function setFocalLength(e) {
              var t = .5 * this.getFilmHeight() / e;
              this.fov = 2 * ne.RAD2DEG * Math.atan(t), this.updateProjectionMatrix();
            },
            getFocalLength: function getFocalLength() {
              var e = Math.tan(.5 * ne.DEG2RAD * this.fov);
              return .5 * this.getFilmHeight() / e;
            },
            getEffectiveFOV: function getEffectiveFOV() {
              return 2 * ne.RAD2DEG * Math.atan(Math.tan(.5 * ne.DEG2RAD * this.fov) / this.zoom);
            },
            getFilmWidth: function getFilmWidth() {
              return this.filmGauge * Math.min(this.aspect, 1);
            },
            getFilmHeight: function getFilmHeight() {
              return this.filmGauge / Math.max(this.aspect, 1);
            },
            setViewOffset: function setViewOffset(e, t, n, r, i, o) {
              this.aspect = e / t, null === this.view && (this.view = {
                enabled: !0,
                fullWidth: 1,
                fullHeight: 1,
                offsetX: 0,
                offsetY: 0,
                width: 1,
                height: 1
              }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = r, this.view.width = i, this.view.height = o, this.updateProjectionMatrix();
            },
            clearViewOffset: function clearViewOffset() {
              null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            },
            updateProjectionMatrix: function updateProjectionMatrix() {
              var e = this.near,
                t = e * Math.tan(.5 * ne.DEG2RAD * this.fov) / this.zoom,
                n = 2 * t,
                r = this.aspect * n,
                i = -.5 * r,
                o = this.view;
              if (null !== this.view && this.view.enabled) {
                var a = o.fullWidth,
                  s = o.fullHeight;
                i += o.offsetX * r / a, t -= o.offsetY * n / s, r *= o.width / a, n *= o.height / s;
              }
              var l = this.filmOffset;
              0 !== l && (i += e * l / this.getFilmWidth()), this.projectionMatrix.makePerspective(i, i + r, t, t - n, e, this.far);
            },
            toJSON: function toJSON(e) {
              var t = ft.prototype.toJSON.call(this, e);
              return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, null !== this.view && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
            }
          }), Si.prototype = Object.assign(Object.create(wi.prototype), {
            constructor: Si,
            isArrayCamera: !0
          }), Mi.prototype.isFogExp2 = !0, Mi.prototype.clone = function () {
            return new Mi(this.color, this.density);
          }, Mi.prototype.toJSON = function () {
            return {
              type: "FogExp2",
              color: this.color.getHex(),
              density: this.density
            };
          }, Ci.prototype.isFog = !0, Ci.prototype.clone = function () {
            return new Ci(this.color, this.near, this.far);
          }, Ci.prototype.toJSON = function () {
            return {
              type: "Fog",
              color: this.color.getHex(),
              near: this.near,
              far: this.far
            };
          }, ki.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: ki,
            copy: function copy(e, t) {
              return ft.prototype.copy.call(this, e, t), null !== e.background && (this.background = e.background.clone()), null !== e.fog && (this.fog = e.fog.clone()), null !== e.overrideMaterial && (this.overrideMaterial = e.overrideMaterial.clone()), this.autoUpdate = e.autoUpdate, this.matrixAutoUpdate = e.matrixAutoUpdate, this;
            },
            toJSON: function toJSON(e) {
              var t = ft.prototype.toJSON.call(this, e);
              return null !== this.background && (t.object.background = this.background.toJSON(e)), null !== this.fog && (t.object.fog = this.fog.toJSON()), t;
            }
          }), Object.defineProperty(Pi.prototype, "needsUpdate", {
            set: function set(e) {
              !0 === e && this.version++;
            }
          }), Object.assign(Pi.prototype, {
            isInterleavedBuffer: !0,
            onUploadCallback: function onUploadCallback() {},
            setArray: function setArray(e) {
              if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
              return this.count = void 0 !== e ? e.length / this.stride : 0, this.array = e, this;
            },
            setDynamic: function setDynamic(e) {
              return this.dynamic = e, this;
            },
            copy: function copy(e) {
              return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.dynamic = e.dynamic, this;
            },
            copyAt: function copyAt(e, t, n) {
              e *= this.stride, n *= t.stride;
              for (var r = 0, i = this.stride; r < i; r++) this.array[e + r] = t.array[n + r];
              return this;
            },
            set: function set(e, t) {
              return void 0 === t && (t = 0), this.array.set(e, t), this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            onUpload: function onUpload(e) {
              return this.onUploadCallback = e, this;
            }
          }), Object.defineProperties(Oi.prototype, {
            count: {
              get: function get() {
                return this.data.count;
              }
            },
            array: {
              get: function get() {
                return this.data.array;
              }
            }
          }), Object.assign(Oi.prototype, {
            isInterleavedBufferAttribute: !0,
            setX: function setX(e, t) {
              return this.data.array[e * this.data.stride + this.offset] = t, this;
            },
            setY: function setY(e, t) {
              return this.data.array[e * this.data.stride + this.offset + 1] = t, this;
            },
            setZ: function setZ(e, t) {
              return this.data.array[e * this.data.stride + this.offset + 2] = t, this;
            },
            setW: function setW(e, t) {
              return this.data.array[e * this.data.stride + this.offset + 3] = t, this;
            },
            getX: function getX(e) {
              return this.data.array[e * this.data.stride + this.offset];
            },
            getY: function getY(e) {
              return this.data.array[e * this.data.stride + this.offset + 1];
            },
            getZ: function getZ(e) {
              return this.data.array[e * this.data.stride + this.offset + 2];
            },
            getW: function getW(e) {
              return this.data.array[e * this.data.stride + this.offset + 3];
            },
            setXY: function setXY(e, t, n) {
              return e = e * this.data.stride + this.offset, this.data.array[e + 0] = t, this.data.array[e + 1] = n, this;
            },
            setXYZ: function setXYZ(e, t, n, r) {
              return e = e * this.data.stride + this.offset, this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = r, this;
            },
            setXYZW: function setXYZW(e, t, n, r, i) {
              return e = e * this.data.stride + this.offset, this.data.array[e + 0] = t, this.data.array[e + 1] = n, this.data.array[e + 2] = r, this.data.array[e + 3] = i, this;
            }
          }), ((Ri.prototype = Object.create(Tn.prototype)).constructor = Ri).prototype.isSpriteMaterial = !0, Ri.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.rotation = e.rotation, this;
          }, Ii.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: Ii,
            isSprite: !0,
            raycast: function () {
              var e = new ae(),
                t = new ae(),
                n = new ae(),
                r = new re(),
                i = new re(),
                o = new ie(),
                a = new ae(),
                s = new ae(),
                l = new ae();
              function u(e, t, n, a, s, l) {
                r.subVectors(e, n).addScalar(.5).multiply(a), void 0 !== s ? (i.x = l * r.x - s * r.y, i.y = s * r.x + l * r.y) : i.copy(r), e.copy(t), e.x += i.x, e.y += i.y, e.applyMatrix4(o);
              }
              return function (r, i) {
                t.setFromMatrixScale(this.matrixWorld), o.getInverse(this.modelViewMatrix).premultiply(this.matrixWorld), n.setFromMatrixPosition(this.modelViewMatrix);
                var c,
                  d,
                  h = this.material.rotation;
                0 !== h && (d = Math.cos(h), c = Math.sin(h));
                var f = this.center;
                u(a.set(-.5, -.5, 0), n, f, t, c, d), u(s.set(.5, -.5, 0), n, f, t, c, d), u(l.set(.5, .5, 0), n, f, t, c, d);
                var p = r.ray.intersectTriangle(a, s, l, !1, e);
                if (null !== p || (u(s.set(-.5, .5, 0), n, f, t, c, d), null !== (p = r.ray.intersectTriangle(a, l, s, !1, e)))) {
                  var m = r.ray.origin.distanceTo(e);
                  m < r.near || m > r.far || i.push({
                    distance: m,
                    point: e.clone(),
                    face: null,
                    object: this
                  });
                }
              };
            }(),
            clone: function clone() {
              return new this.constructor(this.material).copy(this);
            },
            copy: function copy(e) {
              return ft.prototype.copy.call(this, e), void 0 !== e.center && this.center.copy(e.center), this;
            }
          }), ji.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: ji,
            copy: function copy(e) {
              ft.prototype.copy.call(this, e, !1);
              for (var t = e.levels, n = 0, r = t.length; n < r; n++) {
                var i = t[n];
                this.addLevel(i.object.clone(), i.distance);
              }
              return this;
            },
            addLevel: function addLevel(e, t) {
              void 0 === t && (t = 0), t = Math.abs(t);
              for (var n = this.levels, r = 0; r < n.length && !(t < n[r].distance); r++);
              n.splice(r, 0, {
                distance: t,
                object: e
              }), this.add(e);
            },
            getObjectForDistance: function getObjectForDistance(e) {
              for (var t = this.levels, n = 1, r = t.length; n < r && !(e < t[n].distance); n++);
              return t[n - 1].object;
            },
            raycast: (Qr = new ae(), function (e, t) {
              Qr.setFromMatrixPosition(this.matrixWorld);
              var n = e.ray.origin.distanceTo(Qr);
              this.getObjectForDistance(n).raycast(e, t);
            }),
            update: (Kr = new ae(), Zr = new ae(), function (e) {
              var t = this.levels;
              if (1 < t.length) {
                Kr.setFromMatrixPosition(e.matrixWorld), Zr.setFromMatrixPosition(this.matrixWorld);
                var n = Kr.distanceTo(Zr);
                t[0].object.visible = !0;
                for (var r = 1, i = t.length; r < i && n >= t[r].distance; r++) t[r - 1].object.visible = !1, t[r].object.visible = !0;
                for (; r < i; r++) t[r].object.visible = !1;
              }
            }),
            toJSON: function toJSON(e) {
              var t = ft.prototype.toJSON.call(this, e);
              t.object.levels = [];
              for (var n = this.levels, r = 0, i = n.length; r < i; r++) {
                var o = n[r];
                t.object.levels.push({
                  object: o.object.uuid,
                  distance: o.distance
                });
              }
              return t;
            }
          }), Object.assign(Ni.prototype, {
            calculateInverses: function calculateInverses() {
              this.boneInverses = [];
              for (var e = 0, t = this.bones.length; e < t; e++) {
                var n = new ie();
                this.bones[e] && n.getInverse(this.bones[e].matrixWorld), this.boneInverses.push(n);
              }
            },
            pose: function pose() {
              var e, t, n;
              for (t = 0, n = this.bones.length; t < n; t++) (e = this.bones[t]) && e.matrixWorld.getInverse(this.boneInverses[t]);
              for (t = 0, n = this.bones.length; t < n; t++) (e = this.bones[t]) && (e.parent && e.parent.isBone ? (e.matrix.getInverse(e.parent.matrixWorld), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
            },
            update: (Jr = new ie(), ei = new ie(), function () {
              for (var e = this.bones, t = this.boneInverses, n = this.boneMatrices, r = this.boneTexture, i = 0, o = e.length; i < o; i++) {
                var a = e[i] ? e[i].matrixWorld : ei;
                Jr.multiplyMatrices(a, t[i]), Jr.toArray(n, 16 * i);
              }
              void 0 !== r && (r.needsUpdate = !0);
            }),
            clone: function clone() {
              return new Ni(this.bones, this.boneInverses);
            },
            getBoneByName: function getBoneByName(e) {
              for (var t = 0, n = this.bones.length; t < n; t++) {
                var r = this.bones[t];
                if (r.name === e) return r;
              }
            }
          }), Li.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: Li,
            isBone: !0
          }), Di.prototype = Object.assign(Object.create(On.prototype), {
            constructor: Di,
            isSkinnedMesh: !0,
            initBones: function initBones() {
              var e,
                t,
                n,
                r,
                i = [];
              if (this.geometry && void 0 !== this.geometry.bones) {
                for (n = 0, r = this.geometry.bones.length; n < r; n++) t = this.geometry.bones[n], e = new Li(), i.push(e), e.name = t.name, e.position.fromArray(t.pos), e.quaternion.fromArray(t.rotq), void 0 !== t.scl && e.scale.fromArray(t.scl);
                for (n = 0, r = this.geometry.bones.length; n < r; n++) -1 !== (t = this.geometry.bones[n]).parent && null !== t.parent && void 0 !== i[t.parent] ? i[t.parent].add(i[n]) : this.add(i[n]);
              }
              return this.updateMatrixWorld(!0), i;
            },
            bind: function bind(e, t) {
              this.skeleton = e, void 0 === t && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.getInverse(t);
            },
            pose: function pose() {
              this.skeleton.pose();
            },
            normalizeSkinWeights: function normalizeSkinWeights() {
              var e, t;
              if (this.geometry && this.geometry.isGeometry) for (t = 0; t < this.geometry.skinWeights.length; t++) {
                var n = this.geometry.skinWeights[t];
                (e = 1 / n.manhattanLength()) != 1 / 0 ? n.multiplyScalar(e) : n.set(1, 0, 0, 0);
              } else if (this.geometry && this.geometry.isBufferGeometry) {
                var r = new Me(),
                  i = this.geometry.attributes.skinWeight;
                for (t = 0; t < i.count; t++) r.x = i.getX(t), r.y = i.getY(t), r.z = i.getZ(t), r.w = i.getW(t), (e = 1 / r.manhattanLength()) != 1 / 0 ? r.multiplyScalar(e) : r.set(1, 0, 0, 0), i.setXYZW(t, r.x, r.y, r.z, r.w);
              }
            },
            updateMatrixWorld: function updateMatrixWorld(e) {
              On.prototype.updateMatrixWorld.call(this, e), "attached" === this.bindMode ? this.bindMatrixInverse.getInverse(this.matrixWorld) : "detached" === this.bindMode ? this.bindMatrixInverse.getInverse(this.bindMatrix) : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
            },
            clone: function clone() {
              return new this.constructor(this.geometry, this.material).copy(this);
            }
          }), ((Bi.prototype = Object.create(Tn.prototype)).constructor = Bi).prototype.isLineBasicMaterial = !0, Bi.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this;
          }, Fi.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: Fi,
            isLine: !0,
            computeLineDistances: (ii = new ae(), oi = new ae(), function () {
              var e = this.geometry;
              if (e.isBufferGeometry) {
                if (null === e.index) {
                  for (var t = e.attributes.position, n = [0], r = 1, i = t.count; r < i; r++) ii.fromBufferAttribute(t, r - 1), oi.fromBufferAttribute(t, r), n[r] = n[r - 1], n[r] += ii.distanceTo(oi);
                  e.addAttribute("lineDistance", new jt(n, 1));
                } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
              } else if (e.isGeometry) {
                var o = e.vertices;
                for ((n = e.lineDistances)[0] = 0, r = 1, i = o.length; r < i; r++) n[r] = n[r - 1], n[r] += o[r - 1].distanceTo(o[r]);
              }
              return this;
            }),
            raycast: (ti = new ie(), ni = new kn(), ri = new Re(), function (e, t) {
              var n = e.linePrecision,
                r = n * n,
                i = this.geometry,
                o = this.matrixWorld;
              if (null === i.boundingSphere && i.computeBoundingSphere(), ri.copy(i.boundingSphere), ri.applyMatrix4(o), !1 !== e.ray.intersectsSphere(ri)) {
                ti.getInverse(o), ni.copy(e.ray).applyMatrix4(ti);
                var a = new ae(),
                  s = new ae(),
                  l = new ae(),
                  u = new ae(),
                  c = this && this.isLineSegments ? 2 : 1;
                if (i.isBufferGeometry) {
                  var d = i.index,
                    h = i.attributes.position.array;
                  if (null !== d) for (var f = d.array, p = 0, m = f.length - 1; p < m; p += c) {
                    var g = f[p],
                      v = f[p + 1];
                    a.fromArray(h, 3 * g), s.fromArray(h, 3 * v), r < ni.distanceSqToSegment(a, s, u, l) || (u.applyMatrix4(this.matrixWorld), (_ = e.ray.origin.distanceTo(u)) < e.near || _ > e.far || t.push({
                      distance: _,
                      point: l.clone().applyMatrix4(this.matrixWorld),
                      index: p,
                      face: null,
                      faceIndex: null,
                      object: this
                    }));
                  } else for (p = 0, m = h.length / 3 - 1; p < m; p += c) a.fromArray(h, 3 * p), s.fromArray(h, 3 * p + 3), r < ni.distanceSqToSegment(a, s, u, l) || (u.applyMatrix4(this.matrixWorld), (_ = e.ray.origin.distanceTo(u)) < e.near || _ > e.far || t.push({
                    distance: _,
                    point: l.clone().applyMatrix4(this.matrixWorld),
                    index: p,
                    face: null,
                    faceIndex: null,
                    object: this
                  }));
                } else if (i.isGeometry) {
                  var y = i.vertices,
                    b = y.length;
                  for (p = 0; p < b - 1; p += c) {
                    var _;
                    r < ni.distanceSqToSegment(y[p], y[p + 1], u, l) || (u.applyMatrix4(this.matrixWorld), (_ = e.ray.origin.distanceTo(u)) < e.near || _ > e.far || t.push({
                      distance: _,
                      point: l.clone().applyMatrix4(this.matrixWorld),
                      index: p,
                      face: null,
                      faceIndex: null,
                      object: this
                    }));
                  }
                }
              }
            }),
            clone: function clone() {
              return new this.constructor(this.geometry, this.material).copy(this);
            }
          }), zi.prototype = Object.assign(Object.create(Fi.prototype), {
            constructor: zi,
            isLineSegments: !0,
            computeLineDistances: (ai = new ae(), si = new ae(), function () {
              var e = this.geometry;
              if (e.isBufferGeometry) {
                if (null === e.index) {
                  for (var t = e.attributes.position, n = [], r = 0, i = t.count; r < i; r += 2) ai.fromBufferAttribute(t, r), si.fromBufferAttribute(t, r + 1), n[r] = 0 === r ? 0 : n[r - 1], n[r + 1] = n[r] + ai.distanceTo(si);
                  e.addAttribute("lineDistance", new jt(n, 1));
                } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
              } else if (e.isGeometry) {
                var o = e.vertices;
                for (n = e.lineDistances, r = 0, i = o.length; r < i; r += 2) ai.copy(o[r]), si.copy(o[r + 1]), n[r] = 0 === r ? 0 : n[r - 1], n[r + 1] = n[r] + ai.distanceTo(si);
              }
              return this;
            })
          }), Ui.prototype = Object.assign(Object.create(Fi.prototype), {
            constructor: Ui,
            isLineLoop: !0
          }), ((Gi.prototype = Object.create(Tn.prototype)).constructor = Gi).prototype.isPointsMaterial = !0, Gi.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.morphTargets = e.morphTargets, this;
          }, Vi.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: Vi,
            isPoints: !0,
            raycast: (li = new ie(), ui = new kn(), ci = new Re(), function (e, t) {
              var n = this,
                r = this.geometry,
                i = this.matrixWorld,
                o = e.params.Points.threshold;
              if (null === r.boundingSphere && r.computeBoundingSphere(), ci.copy(r.boundingSphere), ci.applyMatrix4(i), ci.radius += o, !1 !== e.ray.intersectsSphere(ci)) {
                li.getInverse(i), ui.copy(e.ray).applyMatrix4(li);
                var a = o / ((this.scale.x + this.scale.y + this.scale.z) / 3),
                  s = a * a,
                  l = new ae(),
                  u = new ae();
                if (r.isBufferGeometry) {
                  var c = r.index,
                    d = r.attributes.position.array;
                  if (null !== c) for (var h = c.array, f = 0, p = h.length; f < p; f++) {
                    var m = h[f];
                    l.fromArray(d, 3 * m), y(l, m);
                  } else {
                    f = 0;
                    for (var g = d.length / 3; f < g; f++) l.fromArray(d, 3 * f), y(l, f);
                  }
                } else {
                  var v = r.vertices;
                  for (f = 0, g = v.length; f < g; f++) y(v[f], f);
                }
              }
              function y(r, o) {
                var a = ui.distanceSqToPoint(r);
                if (a < s) {
                  ui.closestPointToPoint(r, u), u.applyMatrix4(i);
                  var l = e.ray.origin.distanceTo(u);
                  if (l < e.near || l > e.far) return;
                  t.push({
                    distance: l,
                    distanceToRay: Math.sqrt(a),
                    point: u.clone(),
                    index: o,
                    face: null,
                    object: n
                  });
                }
              }
            }),
            clone: function clone() {
              return new this.constructor(this.geometry, this.material).copy(this);
            }
          }), Hi.prototype = Object.assign(Object.create(Te.prototype), {
            constructor: Hi,
            isVideoTexture: !0,
            update: function update() {
              var e = this.image;
              e.readyState >= e.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
            }
          }), ((qi.prototype = Object.create(Te.prototype)).constructor = qi).prototype.isCompressedTexture = !0, ((Wi.prototype = Object.create(Te.prototype)).constructor = Wi).prototype.isCanvasTexture = !0, (($i.prototype = Object.create(Te.prototype)).constructor = $i).prototype.isDepthTexture = !0, (Xi.prototype = Object.create(Yt.prototype)).constructor = Xi, (Yi.prototype = Object.create(Et.prototype)).constructor = Yi, (Ki.prototype = Object.create(Yt.prototype)).constructor = Ki, (Zi.prototype = Object.create(Et.prototype)).constructor = Zi, (Qi.prototype = Object.create(Yt.prototype)).constructor = Qi, (Ji.prototype = Object.create(Et.prototype)).constructor = Ji, (eo.prototype = Object.create(Qi.prototype)).constructor = eo, (to.prototype = Object.create(Et.prototype)).constructor = to, (no.prototype = Object.create(Qi.prototype)).constructor = no, (ro.prototype = Object.create(Et.prototype)).constructor = ro, (io.prototype = Object.create(Qi.prototype)).constructor = io, (oo.prototype = Object.create(Et.prototype)).constructor = oo, (ao.prototype = Object.create(Qi.prototype)).constructor = ao, (so.prototype = Object.create(Et.prototype)).constructor = so, (lo.prototype = Object.create(Yt.prototype)).constructor = lo, (uo.prototype = Object.create(Et.prototype)).constructor = uo, (co.prototype = Object.create(Yt.prototype)).constructor = co, (ho.prototype = Object.create(Et.prototype)).constructor = ho, (fo.prototype = Object.create(Yt.prototype)).constructor = fo;
          var jo = {
            area: function area(e) {
              for (var t = e.length, n = 0, r = t - 1, i = 0; i < t; r = i++) n += e[r].x * e[i].y - e[i].x * e[r].y;
              return .5 * n;
            },
            isClockWise: function isClockWise(e) {
              return jo.area(e) < 0;
            },
            triangulateShape: function triangulateShape(e, t) {
              var n = [],
                r = [],
                i = [];
              No(e), Lo(n, e);
              var o = e.length;
              t.forEach(No);
              for (var a = 0; a < t.length; a++) r.push(o), o += t[a].length, Lo(n, t[a]);
              var s = function (e, t, n) {
                n = n || 2;
                var r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c = t && t.length,
                  d = c ? t[0] * n : e.length,
                  h = po(e, 0, d, n, !0),
                  f = [];
                if (!h) return f;
                if (c && (h = function (e, t, n, r) {
                  var i,
                    o,
                    a,
                    s = [];
                  for (i = 0, o = t.length; i < o; i++) (a = po(e, t[i] * r, i < o - 1 ? t[i + 1] * r : e.length, r, !1)) === a.next && (a.steiner = !0), s.push(Ao(a));
                  for (s.sort(xo), i = 0; i < s.length; i++) wo(s[i], n), n = mo(n, n.next);
                  return n;
                }(e, t, h, n)), e.length > 80 * n) {
                  r = o = e[0], i = a = e[1];
                  for (var p = n; p < d; p += n) (s = e[p]) < r && (r = s), (l = e[p + 1]) < i && (i = l), o < s && (o = s), a < l && (a = l);
                  u = 0 !== (u = Math.max(o - r, a - i)) ? 1 / u : 0;
                }
                return go(h, f, n, r, i, u), f;
              }(n, r);
              for (a = 0; a < s.length; a += 3) i.push(s.slice(a, a + 3));
              return i;
            }
          };
          function No(e) {
            var t = e.length;
            2 < t && e[t - 1].equals(e[0]) && e.pop();
          }
          function Lo(e, t) {
            for (var n = 0; n < t.length; n++) e.push(t[n].x), e.push(t[n].y);
          }
          function Do(e, t) {
            Et.call(this), this.type = "ExtrudeGeometry", this.parameters = {
              shapes: e,
              options: t
            }, this.fromBufferGeometry(new Bo(e, t)), this.mergeVertices();
          }
          function Bo(e, t) {
            Yt.call(this), this.type = "ExtrudeBufferGeometry", this.parameters = {
              shapes: e,
              options: t
            }, e = Array.isArray(e) ? e : [e];
            for (var n = this, r = [], i = [], o = 0, a = e.length; o < a; o++) s(e[o]);
            function s(e) {
              var o = [],
                a = void 0 !== t.curveSegments ? t.curveSegments : 12,
                s = void 0 !== t.steps ? t.steps : 1,
                l = void 0 !== t.depth ? t.depth : 100,
                u = void 0 === t.bevelEnabled || t.bevelEnabled,
                c = void 0 !== t.bevelThickness ? t.bevelThickness : 6,
                d = void 0 !== t.bevelSize ? t.bevelSize : c - 2,
                h = void 0 !== t.bevelSegments ? t.bevelSegments : 3,
                f = t.extrudePath,
                p = void 0 !== t.UVGenerator ? t.UVGenerator : Fo;
              void 0 !== t.amount && (console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth."), l = t.amount);
              var m,
                g,
                v,
                y,
                b,
                _,
                x,
                w,
                S = !1;
              f && (m = f.getSpacedPoints(s), u = !(S = !0), g = f.computeFrenetFrames(s, !1), v = new ae(), y = new ae(), b = new ae()), u || (d = c = h = 0);
              var A = e.extractPoints(a),
                E = A.shape,
                T = A.holes;
              if (!jo.isClockWise(E)) for (E = E.reverse(), x = 0, w = T.length; x < w; x++) _ = T[x], jo.isClockWise(_) && (T[x] = _.reverse());
              var M = jo.triangulateShape(E, T),
                C = E;
              for (x = 0, w = T.length; x < w; x++) _ = T[x], E = E.concat(_);
              function k(e, t, n) {
                return t || console.error("THREE.ExtrudeGeometry: vec does not exist"), t.clone().multiplyScalar(n).add(e);
              }
              var P,
                O,
                R,
                I,
                j,
                N,
                L = E.length,
                D = M.length;
              function B(e, t, n) {
                var r,
                  i,
                  o,
                  a = e.x - t.x,
                  s = e.y - t.y,
                  l = n.x - e.x,
                  u = n.y - e.y,
                  c = a * a + s * s,
                  d = a * u - s * l;
                if (Math.abs(d) > Number.EPSILON) {
                  var h = Math.sqrt(c),
                    f = Math.sqrt(l * l + u * u),
                    p = t.x - s / h,
                    m = t.y + a / h,
                    g = ((n.x - u / f - p) * u - (n.y + l / f - m) * l) / (a * u - s * l),
                    v = (r = p + a * g - e.x) * r + (i = m + s * g - e.y) * i;
                  if (v <= 2) return new re(r, i);
                  o = Math.sqrt(v / 2);
                } else {
                  var y = !1;
                  a > Number.EPSILON ? l > Number.EPSILON && (y = !0) : a < -Number.EPSILON ? l < -Number.EPSILON && (y = !0) : Math.sign(s) === Math.sign(u) && (y = !0), y ? (r = -s, i = a, o = Math.sqrt(c)) : (r = a, i = s, o = Math.sqrt(c / 2));
                }
                return new re(r / o, i / o);
              }
              for (var F = [], z = 0, U = C.length, G = U - 1, V = z + 1; z < U; z++, G++, V++) G === U && (G = 0), V === U && (V = 0), F[z] = B(C[z], C[G], C[V]);
              var H,
                q,
                W = [],
                $ = F.concat();
              for (x = 0, w = T.length; x < w; x++) {
                for (_ = T[x], H = [], z = 0, G = (U = _.length) - 1, V = z + 1; z < U; z++, G++, V++) G === U && (G = 0), V === U && (V = 0), H[z] = B(_[z], _[G], _[V]);
                W.push(H), $ = $.concat(H);
              }
              for (P = 0; P < h; P++) {
                for (R = P / h, I = c * Math.cos(R * Math.PI / 2), O = d * Math.sin(R * Math.PI / 2), z = 0, U = C.length; z < U; z++) Y((j = k(C[z], F[z], O)).x, j.y, -I);
                for (x = 0, w = T.length; x < w; x++) for (_ = T[x], H = W[x], z = 0, U = _.length; z < U; z++) Y((j = k(_[z], H[z], O)).x, j.y, -I);
              }
              for (O = d, z = 0; z < L; z++) j = u ? k(E[z], $[z], O) : E[z], S ? (y.copy(g.normals[0]).multiplyScalar(j.x), v.copy(g.binormals[0]).multiplyScalar(j.y), b.copy(m[0]).add(y).add(v), Y(b.x, b.y, b.z)) : Y(j.x, j.y, 0);
              for (q = 1; q <= s; q++) for (z = 0; z < L; z++) j = u ? k(E[z], $[z], O) : E[z], S ? (y.copy(g.normals[q]).multiplyScalar(j.x), v.copy(g.binormals[q]).multiplyScalar(j.y), b.copy(m[q]).add(y).add(v), Y(b.x, b.y, b.z)) : Y(j.x, j.y, l / s * q);
              for (P = h - 1; 0 <= P; P--) {
                for (R = P / h, I = c * Math.cos(R * Math.PI / 2), O = d * Math.sin(R * Math.PI / 2), z = 0, U = C.length; z < U; z++) Y((j = k(C[z], F[z], O)).x, j.y, l + I);
                for (x = 0, w = T.length; x < w; x++) for (_ = T[x], H = W[x], z = 0, U = _.length; z < U; z++) j = k(_[z], H[z], O), S ? Y(j.x, j.y + m[s - 1].y, m[s - 1].x + I) : Y(j.x, j.y, l + I);
              }
              function X(e, t) {
                var n, r;
                for (z = e.length; 0 <= --z;) {
                  (r = (n = z) - 1) < 0 && (r = e.length - 1);
                  var i = 0,
                    o = s + 2 * h;
                  for (i = 0; i < o; i++) {
                    var a = L * i,
                      l = L * (i + 1);
                    Z(t + n + a, t + r + a, t + r + l, t + n + l);
                  }
                }
              }
              function Y(e, t, n) {
                o.push(e), o.push(t), o.push(n);
              }
              function K(e, t, i) {
                Q(e), Q(t), Q(i);
                var o = r.length / 3,
                  a = p.generateTopUV(n, r, o - 3, o - 2, o - 1);
                J(a[0]), J(a[1]), J(a[2]);
              }
              function Z(e, t, i, o) {
                Q(e), Q(t), Q(o), Q(t), Q(i), Q(o);
                var a = r.length / 3,
                  s = p.generateSideWallUV(n, r, a - 6, a - 3, a - 2, a - 1);
                J(s[0]), J(s[1]), J(s[3]), J(s[1]), J(s[2]), J(s[3]);
              }
              function Q(e) {
                r.push(o[3 * e + 0]), r.push(o[3 * e + 1]), r.push(o[3 * e + 2]);
              }
              function J(e) {
                i.push(e.x), i.push(e.y);
              }
              !function () {
                var e = r.length / 3;
                if (u) {
                  var t = 0,
                    i = L * t;
                  for (z = 0; z < D; z++) K((N = M[z])[2] + i, N[1] + i, N[0] + i);
                  for (i = L * (t = s + 2 * h), z = 0; z < D; z++) K((N = M[z])[0] + i, N[1] + i, N[2] + i);
                } else {
                  for (z = 0; z < D; z++) K((N = M[z])[2], N[1], N[0]);
                  for (z = 0; z < D; z++) K((N = M[z])[0] + L * s, N[1] + L * s, N[2] + L * s);
                }
                n.addGroup(e, r.length / 3 - e, 0);
              }(), function () {
                var e = r.length / 3,
                  t = 0;
                for (X(C, t), t += C.length, x = 0, w = T.length; x < w; x++) X(_ = T[x], t), t += _.length;
                n.addGroup(e, r.length / 3 - e, 1);
              }();
            }
            this.addAttribute("position", new jt(r, 3)), this.addAttribute("uv", new jt(i, 2)), this.computeVertexNormals();
          }
          ((Do.prototype = Object.create(Et.prototype)).constructor = Do).prototype.toJSON = function () {
            var e = Et.prototype.toJSON.call(this);
            return zo(this.parameters.shapes, this.parameters.options, e);
          }, ((Bo.prototype = Object.create(Yt.prototype)).constructor = Bo).prototype.toJSON = function () {
            var e = Yt.prototype.toJSON.call(this);
            return zo(this.parameters.shapes, this.parameters.options, e);
          };
          var Fo = {
            generateTopUV: function generateTopUV(e, t, n, r, i) {
              var o = t[3 * n],
                a = t[3 * n + 1],
                s = t[3 * r],
                l = t[3 * r + 1],
                u = t[3 * i],
                c = t[3 * i + 1];
              return [new re(o, a), new re(s, l), new re(u, c)];
            },
            generateSideWallUV: function generateSideWallUV(e, t, n, r, i, o) {
              var a = t[3 * n],
                s = t[3 * n + 1],
                l = t[3 * n + 2],
                u = t[3 * r],
                c = t[3 * r + 1],
                d = t[3 * r + 2],
                h = t[3 * i],
                f = t[3 * i + 1],
                p = t[3 * i + 2],
                m = t[3 * o],
                g = t[3 * o + 1],
                v = t[3 * o + 2];
              return Math.abs(s - c) < .01 ? [new re(a, 1 - l), new re(u, 1 - d), new re(h, 1 - p), new re(m, 1 - v)] : [new re(s, 1 - l), new re(c, 1 - d), new re(f, 1 - p), new re(g, 1 - v)];
            }
          };
          function zo(e, t, n) {
            if (n.shapes = [], Array.isArray(e)) for (var r = 0, i = e.length; r < i; r++) {
              var o = e[r];
              n.shapes.push(o.uuid);
            } else n.shapes.push(e.uuid);
            return void 0 !== t.extrudePath && (n.options.extrudePath = t.extrudePath.toJSON()), n;
          }
          function Uo(e, t) {
            Et.call(this), this.type = "TextGeometry", this.parameters = {
              text: e,
              parameters: t
            }, this.fromBufferGeometry(new Go(e, t)), this.mergeVertices();
          }
          function Go(e, t) {
            var n = (t = t || {}).font;
            if (!n || !n.isFont) return console.error("THREE.TextGeometry: font parameter is not an instance of THREE.Font."), new Et();
            var r = n.generateShapes(e, t.size);
            t.depth = void 0 !== t.height ? t.height : 50, void 0 === t.bevelThickness && (t.bevelThickness = 10), void 0 === t.bevelSize && (t.bevelSize = 8), void 0 === t.bevelEnabled && (t.bevelEnabled = !1), Bo.call(this, r, t), this.type = "TextBufferGeometry";
          }
          function Vo(e, t, n, r, i, o, a) {
            Et.call(this), this.type = "SphereGeometry", this.parameters = {
              radius: e,
              widthSegments: t,
              heightSegments: n,
              phiStart: r,
              phiLength: i,
              thetaStart: o,
              thetaLength: a
            }, this.fromBufferGeometry(new Ho(e, t, n, r, i, o, a)), this.mergeVertices();
          }
          function Ho(e, t, n, r, i, o, a) {
            Yt.call(this), this.type = "SphereBufferGeometry", this.parameters = {
              radius: e,
              widthSegments: t,
              heightSegments: n,
              phiStart: r,
              phiLength: i,
              thetaStart: o,
              thetaLength: a
            }, e = e || 1, t = Math.max(3, Math.floor(t) || 8), n = Math.max(2, Math.floor(n) || 6), r = void 0 !== r ? r : 0, i = void 0 !== i ? i : 2 * Math.PI;
            var s,
              l,
              u = (o = void 0 !== o ? o : 0) + (a = void 0 !== a ? a : Math.PI),
              c = 0,
              d = [],
              h = new ae(),
              f = new ae(),
              p = [],
              m = [],
              g = [],
              v = [];
            for (l = 0; l <= n; l++) {
              var y = [],
                b = l / n;
              for (s = 0; s <= t; s++) {
                var _ = s / t;
                h.x = -e * Math.cos(r + _ * i) * Math.sin(o + b * a), h.y = e * Math.cos(o + b * a), h.z = e * Math.sin(r + _ * i) * Math.sin(o + b * a), m.push(h.x, h.y, h.z), f.set(h.x, h.y, h.z).normalize(), g.push(f.x, f.y, f.z), v.push(_, 1 - b), y.push(c++);
              }
              d.push(y);
            }
            for (l = 0; l < n; l++) for (s = 0; s < t; s++) {
              var x = d[l][s + 1],
                w = d[l][s],
                S = d[l + 1][s],
                A = d[l + 1][s + 1];
              (0 !== l || 0 < o) && p.push(x, w, A), (l !== n - 1 || u < Math.PI) && p.push(w, S, A);
            }
            this.setIndex(p), this.addAttribute("position", new jt(m, 3)), this.addAttribute("normal", new jt(g, 3)), this.addAttribute("uv", new jt(v, 2));
          }
          function qo(e, t, n, r, i, o) {
            Et.call(this), this.type = "RingGeometry", this.parameters = {
              innerRadius: e,
              outerRadius: t,
              thetaSegments: n,
              phiSegments: r,
              thetaStart: i,
              thetaLength: o
            }, this.fromBufferGeometry(new Wo(e, t, n, r, i, o)), this.mergeVertices();
          }
          function Wo(e, t, n, r, i, o) {
            Yt.call(this), this.type = "RingBufferGeometry", this.parameters = {
              innerRadius: e,
              outerRadius: t,
              thetaSegments: n,
              phiSegments: r,
              thetaStart: i,
              thetaLength: o
            }, e = e || .5, t = t || 1, i = void 0 !== i ? i : 0, o = void 0 !== o ? o : 2 * Math.PI, n = void 0 !== n ? Math.max(3, n) : 8;
            var a,
              s,
              l,
              u = [],
              c = [],
              d = [],
              h = [],
              f = e,
              p = (t - e) / (r = void 0 !== r ? Math.max(1, r) : 1),
              m = new ae(),
              g = new re();
            for (s = 0; s <= r; s++) {
              for (l = 0; l <= n; l++) a = i + l / n * o, m.x = f * Math.cos(a), m.y = f * Math.sin(a), c.push(m.x, m.y, m.z), d.push(0, 0, 1), g.x = (m.x / t + 1) / 2, g.y = (m.y / t + 1) / 2, h.push(g.x, g.y);
              f += p;
            }
            for (s = 0; s < r; s++) {
              var v = s * (n + 1);
              for (l = 0; l < n; l++) {
                var y = a = l + v,
                  b = a + n + 1,
                  _ = a + n + 2,
                  x = a + 1;
                u.push(y, b, x), u.push(b, _, x);
              }
            }
            this.setIndex(u), this.addAttribute("position", new jt(c, 3)), this.addAttribute("normal", new jt(d, 3)), this.addAttribute("uv", new jt(h, 2));
          }
          function $o(e, t, n, r) {
            Et.call(this), this.type = "LatheGeometry", this.parameters = {
              points: e,
              segments: t,
              phiStart: n,
              phiLength: r
            }, this.fromBufferGeometry(new Xo(e, t, n, r)), this.mergeVertices();
          }
          function Xo(e, t, n, r) {
            Yt.call(this), this.type = "LatheBufferGeometry", this.parameters = {
              points: e,
              segments: t,
              phiStart: n,
              phiLength: r
            }, t = Math.floor(t) || 12, n = n || 0, r = r || 2 * Math.PI, r = ne.clamp(r, 0, 2 * Math.PI);
            var i,
              o,
              a,
              s = [],
              l = [],
              u = [],
              c = 1 / t,
              d = new ae(),
              h = new re();
            for (o = 0; o <= t; o++) {
              var f = n + o * c * r,
                p = Math.sin(f),
                m = Math.cos(f);
              for (a = 0; a <= e.length - 1; a++) d.x = e[a].x * p, d.y = e[a].y, d.z = e[a].x * m, l.push(d.x, d.y, d.z), h.x = o / t, h.y = a / (e.length - 1), u.push(h.x, h.y);
            }
            for (o = 0; o < t; o++) for (a = 0; a < e.length - 1; a++) {
              var g = i = a + o * e.length,
                v = i + e.length,
                y = i + e.length + 1,
                b = i + 1;
              s.push(g, v, b), s.push(v, y, b);
            }
            if (this.setIndex(s), this.addAttribute("position", new jt(l, 3)), this.addAttribute("uv", new jt(u, 2)), this.computeVertexNormals(), r === 2 * Math.PI) {
              var _ = this.attributes.normal.array,
                x = new ae(),
                w = new ae(),
                S = new ae();
              for (i = t * e.length * 3, a = o = 0; o < e.length; o++, a += 3) x.x = _[a + 0], x.y = _[a + 1], x.z = _[a + 2], w.x = _[i + a + 0], w.y = _[i + a + 1], w.z = _[i + a + 2], S.addVectors(x, w).normalize(), _[a + 0] = _[i + a + 0] = S.x, _[a + 1] = _[i + a + 1] = S.y, _[a + 2] = _[i + a + 2] = S.z;
            }
          }
          function Yo(e, t) {
            Et.call(this), this.type = "ShapeGeometry", "object" == typeof t && (console.warn("THREE.ShapeGeometry: Options parameter has been removed."), t = t.curveSegments), this.parameters = {
              shapes: e,
              curveSegments: t
            }, this.fromBufferGeometry(new Ko(e, t)), this.mergeVertices();
          }
          function Ko(e, t) {
            Yt.call(this), this.type = "ShapeBufferGeometry", this.parameters = {
              shapes: e,
              curveSegments: t
            }, t = t || 12;
            var n = [],
              r = [],
              i = [],
              o = [],
              a = 0,
              s = 0;
            if (!1 === Array.isArray(e)) u(e);else for (var l = 0; l < e.length; l++) u(e[l]), this.addGroup(a, s, l), a += s, s = 0;
            function u(e) {
              var a,
                l,
                u,
                c = r.length / 3,
                d = e.extractPoints(t),
                h = d.shape,
                f = d.holes;
              if (!1 === jo.isClockWise(h)) for (h = h.reverse(), a = 0, l = f.length; a < l; a++) u = f[a], !0 === jo.isClockWise(u) && (f[a] = u.reverse());
              var p = jo.triangulateShape(h, f);
              for (a = 0, l = f.length; a < l; a++) u = f[a], h = h.concat(u);
              for (a = 0, l = h.length; a < l; a++) {
                var m = h[a];
                r.push(m.x, m.y, 0), i.push(0, 0, 1), o.push(m.x, m.y);
              }
              for (a = 0, l = p.length; a < l; a++) {
                var g = p[a],
                  v = g[0] + c,
                  y = g[1] + c,
                  b = g[2] + c;
                n.push(v, y, b), s += 3;
              }
            }
            this.setIndex(n), this.addAttribute("position", new jt(r, 3)), this.addAttribute("normal", new jt(i, 3)), this.addAttribute("uv", new jt(o, 2));
          }
          function Zo(e, t) {
            if (t.shapes = [], Array.isArray(e)) for (var n = 0, r = e.length; n < r; n++) {
              var i = e[n];
              t.shapes.push(i.uuid);
            } else t.shapes.push(e.uuid);
            return t;
          }
          function Qo(e, t) {
            Yt.call(this), this.type = "EdgesGeometry", this.parameters = {
              thresholdAngle: t
            }, t = void 0 !== t ? t : 1;
            var n,
              r,
              i,
              o,
              a = [],
              s = Math.cos(ne.DEG2RAD * t),
              l = [0, 0],
              u = {},
              c = ["a", "b", "c"];
            e.isBufferGeometry ? (o = new Et()).fromBufferGeometry(e) : o = e.clone(), o.mergeVertices(), o.computeFaceNormals();
            for (var d = o.vertices, h = o.faces, f = 0, p = h.length; f < p; f++) for (var m = h[f], g = 0; g < 3; g++) n = m[c[g]], r = m[c[(g + 1) % 3]], l[0] = Math.min(n, r), l[1] = Math.max(n, r), void 0 === u[i = l[0] + "," + l[1]] ? u[i] = {
              index1: l[0],
              index2: l[1],
              face1: f,
              face2: void 0
            } : u[i].face2 = f;
            for (i in u) {
              var v = u[i];
              if (void 0 === v.face2 || h[v.face1].normal.dot(h[v.face2].normal) <= s) {
                var y = d[v.index1];
                a.push(y.x, y.y, y.z), y = d[v.index2], a.push(y.x, y.y, y.z);
              }
            }
            this.addAttribute("position", new jt(a, 3));
          }
          function Jo(e, t, n, r, i, o, a, s) {
            Et.call(this), this.type = "CylinderGeometry", this.parameters = {
              radiusTop: e,
              radiusBottom: t,
              height: n,
              radialSegments: r,
              heightSegments: i,
              openEnded: o,
              thetaStart: a,
              thetaLength: s
            }, this.fromBufferGeometry(new ea(e, t, n, r, i, o, a, s)), this.mergeVertices();
          }
          function ea(e, t, n, r, i, o, a, s) {
            Yt.call(this), this.type = "CylinderBufferGeometry", this.parameters = {
              radiusTop: e,
              radiusBottom: t,
              height: n,
              radialSegments: r,
              heightSegments: i,
              openEnded: o,
              thetaStart: a,
              thetaLength: s
            };
            var l = this;
            e = void 0 !== e ? e : 1, t = void 0 !== t ? t : 1, n = n || 1, r = Math.floor(r) || 8, i = Math.floor(i) || 1, o = void 0 !== o && o, a = void 0 !== a ? a : 0, s = void 0 !== s ? s : 2 * Math.PI;
            var u = [],
              c = [],
              d = [],
              h = [],
              f = 0,
              p = [],
              m = n / 2,
              g = 0;
            function v(n) {
              var i,
                o,
                p,
                v = new re(),
                y = new ae(),
                b = 0,
                _ = !0 === n ? e : t,
                x = !0 === n ? 1 : -1;
              for (o = f, i = 1; i <= r; i++) c.push(0, m * x, 0), d.push(0, x, 0), h.push(.5, .5), f++;
              for (p = f, i = 0; i <= r; i++) {
                var w = i / r * s + a,
                  S = Math.cos(w),
                  A = Math.sin(w);
                y.x = _ * A, y.y = m * x, y.z = _ * S, c.push(y.x, y.y, y.z), d.push(0, x, 0), v.x = .5 * S + .5, v.y = .5 * A * x + .5, h.push(v.x, v.y), f++;
              }
              for (i = 0; i < r; i++) {
                var E = o + i,
                  T = p + i;
                !0 === n ? u.push(T, T + 1, E) : u.push(T + 1, T, E), b += 3;
              }
              l.addGroup(g, b, !0 === n ? 1 : 2), g += b;
            }
            !function () {
              var o,
                v,
                y = new ae(),
                b = new ae(),
                _ = 0,
                x = (t - e) / n;
              for (v = 0; v <= i; v++) {
                var w = [],
                  S = v / i,
                  A = S * (t - e) + e;
                for (o = 0; o <= r; o++) {
                  var E = o / r,
                    T = E * s + a,
                    M = Math.sin(T),
                    C = Math.cos(T);
                  b.x = A * M, b.y = -S * n + m, b.z = A * C, c.push(b.x, b.y, b.z), y.set(M, x, C).normalize(), d.push(y.x, y.y, y.z), h.push(E, 1 - S), w.push(f++);
                }
                p.push(w);
              }
              for (o = 0; o < r; o++) for (v = 0; v < i; v++) {
                var k = p[v][o],
                  P = p[v + 1][o],
                  O = p[v + 1][o + 1],
                  R = p[v][o + 1];
                u.push(k, P, R), u.push(P, O, R), _ += 6;
              }
              l.addGroup(g, _, 0), g += _;
            }(), !1 === o && (0 < e && v(!0), 0 < t && v(!1)), this.setIndex(u), this.addAttribute("position", new jt(c, 3)), this.addAttribute("normal", new jt(d, 3)), this.addAttribute("uv", new jt(h, 2));
          }
          function ta(e, t, n, r, i, o, a) {
            Jo.call(this, 0, e, t, n, r, i, o, a), this.type = "ConeGeometry", this.parameters = {
              radius: e,
              height: t,
              radialSegments: n,
              heightSegments: r,
              openEnded: i,
              thetaStart: o,
              thetaLength: a
            };
          }
          function na(e, t, n, r, i, o, a) {
            ea.call(this, 0, e, t, n, r, i, o, a), this.type = "ConeBufferGeometry", this.parameters = {
              radius: e,
              height: t,
              radialSegments: n,
              heightSegments: r,
              openEnded: i,
              thetaStart: o,
              thetaLength: a
            };
          }
          function ra(e, t, n, r) {
            Et.call(this), this.type = "CircleGeometry", this.parameters = {
              radius: e,
              segments: t,
              thetaStart: n,
              thetaLength: r
            }, this.fromBufferGeometry(new ia(e, t, n, r)), this.mergeVertices();
          }
          function ia(e, t, n, r) {
            Yt.call(this), this.type = "CircleBufferGeometry", this.parameters = {
              radius: e,
              segments: t,
              thetaStart: n,
              thetaLength: r
            }, e = e || 1, t = void 0 !== t ? Math.max(3, t) : 8, n = void 0 !== n ? n : 0, r = void 0 !== r ? r : 2 * Math.PI;
            var i,
              o,
              a = [],
              s = [],
              l = [],
              u = [],
              c = new ae(),
              d = new re();
            for (s.push(0, 0, 0), l.push(0, 0, 1), u.push(.5, .5), o = 0, i = 3; o <= t; o++, i += 3) {
              var h = n + o / t * r;
              c.x = e * Math.cos(h), c.y = e * Math.sin(h), s.push(c.x, c.y, c.z), l.push(0, 0, 1), d.x = (s[i] / e + 1) / 2, d.y = (s[i + 1] / e + 1) / 2, u.push(d.x, d.y);
            }
            for (i = 1; i <= t; i++) a.push(i, i + 1, 0);
            this.setIndex(a), this.addAttribute("position", new jt(s, 3)), this.addAttribute("normal", new jt(l, 3)), this.addAttribute("uv", new jt(u, 2));
          }
          (Uo.prototype = Object.create(Et.prototype)).constructor = Uo, (Go.prototype = Object.create(Bo.prototype)).constructor = Go, (Vo.prototype = Object.create(Et.prototype)).constructor = Vo, (Ho.prototype = Object.create(Yt.prototype)).constructor = Ho, (qo.prototype = Object.create(Et.prototype)).constructor = qo, (Wo.prototype = Object.create(Yt.prototype)).constructor = Wo, ($o.prototype = Object.create(Et.prototype)).constructor = $o, (Xo.prototype = Object.create(Yt.prototype)).constructor = Xo, ((Yo.prototype = Object.create(Et.prototype)).constructor = Yo).prototype.toJSON = function () {
            var e = Et.prototype.toJSON.call(this);
            return Zo(this.parameters.shapes, e);
          }, ((Ko.prototype = Object.create(Yt.prototype)).constructor = Ko).prototype.toJSON = function () {
            var e = Yt.prototype.toJSON.call(this);
            return Zo(this.parameters.shapes, e);
          }, (Qo.prototype = Object.create(Yt.prototype)).constructor = Qo, (Jo.prototype = Object.create(Et.prototype)).constructor = Jo, (ea.prototype = Object.create(Yt.prototype)).constructor = ea, (ta.prototype = Object.create(Jo.prototype)).constructor = ta, (na.prototype = Object.create(ea.prototype)).constructor = na, (ra.prototype = Object.create(Et.prototype)).constructor = ra, (ia.prototype = Object.create(Yt.prototype)).constructor = ia;
          var oa = Object.freeze({
            WireframeGeometry: Xi,
            ParametricGeometry: Yi,
            ParametricBufferGeometry: Ki,
            TetrahedronGeometry: Ji,
            TetrahedronBufferGeometry: eo,
            OctahedronGeometry: to,
            OctahedronBufferGeometry: no,
            IcosahedronGeometry: ro,
            IcosahedronBufferGeometry: io,
            DodecahedronGeometry: oo,
            DodecahedronBufferGeometry: ao,
            PolyhedronGeometry: Zi,
            PolyhedronBufferGeometry: Qi,
            TubeGeometry: so,
            TubeBufferGeometry: lo,
            TorusKnotGeometry: uo,
            TorusKnotBufferGeometry: co,
            TorusGeometry: ho,
            TorusBufferGeometry: fo,
            TextGeometry: Uo,
            TextBufferGeometry: Go,
            SphereGeometry: Vo,
            SphereBufferGeometry: Ho,
            RingGeometry: qo,
            RingBufferGeometry: Wo,
            PlaneGeometry: Qt,
            PlaneBufferGeometry: Jt,
            LatheGeometry: $o,
            LatheBufferGeometry: Xo,
            ShapeGeometry: Yo,
            ShapeBufferGeometry: Ko,
            ExtrudeGeometry: Do,
            ExtrudeBufferGeometry: Bo,
            EdgesGeometry: Qo,
            ConeGeometry: ta,
            ConeBufferGeometry: na,
            CylinderGeometry: Jo,
            CylinderBufferGeometry: ea,
            CircleGeometry: ra,
            CircleBufferGeometry: ia,
            BoxGeometry: Kt,
            BoxBufferGeometry: Zt
          });
          function aa(e) {
            Tn.call(this), this.type = "ShadowMaterial", this.color = new Fe(0), this.transparent = !0, this.setValues(e);
          }
          function sa(e) {
            Cn.call(this, e), this.type = "RawShaderMaterial";
          }
          function la(e) {
            Tn.call(this), this.defines = {
              STANDARD: ""
            }, this.type = "MeshStandardMaterial", this.color = new Fe(16777215), this.roughness = .5, this.metalness = .5, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Fe(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
          }
          function ua(e) {
            la.call(this), this.defines = {
              PHYSICAL: ""
            }, this.type = "MeshPhysicalMaterial", this.reflectivity = .5, this.clearCoat = 0, this.clearCoatRoughness = 0, this.setValues(e);
          }
          function ca(e) {
            Tn.call(this), this.type = "MeshPhongMaterial", this.color = new Fe(16777215), this.specular = new Fe(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Fe(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
          }
          function da(e) {
            ca.call(this), this.defines = {
              TOON: ""
            }, this.type = "MeshToonMaterial", this.gradientMap = null, this.setValues(e);
          }
          function ha(e) {
            Tn.call(this), this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = 0, this.normalScale = new re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
          }
          function fa(e) {
            Tn.call(this), this.type = "MeshLambertMaterial", this.color = new Fe(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Fe(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
          }
          function pa(e) {
            Bi.call(this), this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(e);
          }
          ((aa.prototype = Object.create(Tn.prototype)).constructor = aa).prototype.isShadowMaterial = !0, aa.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this;
          }, ((sa.prototype = Object.create(Cn.prototype)).constructor = sa).prototype.isRawShaderMaterial = !0, ((la.prototype = Object.create(Tn.prototype)).constructor = la).prototype.isMeshStandardMaterial = !0, la.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.defines = {
              STANDARD: ""
            }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapIntensity = e.envMapIntensity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
          }, ((ua.prototype = Object.create(la.prototype)).constructor = ua).prototype.isMeshPhysicalMaterial = !0, ua.prototype.copy = function (e) {
            return la.prototype.copy.call(this, e), this.defines = {
              PHYSICAL: ""
            }, this.reflectivity = e.reflectivity, this.clearCoat = e.clearCoat, this.clearCoatRoughness = e.clearCoatRoughness, this;
          }, ((ca.prototype = Object.create(Tn.prototype)).constructor = ca).prototype.isMeshPhongMaterial = !0, ca.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
          }, ((da.prototype = Object.create(ca.prototype)).constructor = da).prototype.isMeshToonMaterial = !0, da.prototype.copy = function (e) {
            return ca.prototype.copy.call(this, e), this.gradientMap = e.gradientMap, this;
          }, ((ha.prototype = Object.create(Tn.prototype)).constructor = ha).prototype.isMeshNormalMaterial = !0, ha.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
          }, ((fa.prototype = Object.create(Tn.prototype)).constructor = fa).prototype.isMeshLambertMaterial = !0, fa.prototype.copy = function (e) {
            return Tn.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
          }, ((pa.prototype = Object.create(Bi.prototype)).constructor = pa).prototype.isLineDashedMaterial = !0, pa.prototype.copy = function (e) {
            return Bi.prototype.copy.call(this, e), this.scale = e.scale, this.dashSize = e.dashSize, this.gapSize = e.gapSize, this;
          };
          var ma = Object.freeze({
              ShadowMaterial: aa,
              SpriteMaterial: Ri,
              RawShaderMaterial: sa,
              ShaderMaterial: Cn,
              PointsMaterial: Gi,
              MeshPhysicalMaterial: ua,
              MeshStandardMaterial: la,
              MeshPhongMaterial: ca,
              MeshToonMaterial: da,
              MeshNormalMaterial: ha,
              MeshLambertMaterial: fa,
              MeshDepthMaterial: mi,
              MeshDistanceMaterial: gi,
              MeshBasicMaterial: Mn,
              LineDashedMaterial: pa,
              LineBasicMaterial: Bi,
              Material: Tn
            }),
            ga = {
              enabled: !1,
              files: {},
              add: function add(e, t) {
                !1 !== this.enabled && (this.files[e] = t);
              },
              get: function get(e) {
                if (!1 !== this.enabled) return this.files[e];
              },
              remove: function remove(e) {
                delete this.files[e];
              },
              clear: function clear() {
                this.files = {};
              }
            };
          function va(e, t, n) {
            var r = this,
              i = !1,
              o = 0,
              a = 0,
              s = void 0;
            this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = n, this.itemStart = function (e) {
              a++, !1 === i && void 0 !== r.onStart && r.onStart(e, o, a), i = !0;
            }, this.itemEnd = function (e) {
              o++, void 0 !== r.onProgress && r.onProgress(e, o, a), o === a && (i = !1, void 0 !== r.onLoad && r.onLoad());
            }, this.itemError = function (e) {
              void 0 !== r.onError && r.onError(e);
            }, this.resolveURL = function (e) {
              return s ? s(e) : e;
            }, this.setURLModifier = function (e) {
              return s = e, this;
            };
          }
          var ya = new va(),
            ba = {};
          function _a(e) {
            this.manager = void 0 !== e ? e : ya;
          }
          function xa(e) {
            this.manager = void 0 !== e ? e : ya;
          }
          function wa(e) {
            this.manager = void 0 !== e ? e : ya;
          }
          function Sa(e) {
            this.manager = void 0 !== e ? e : ya;
          }
          function Aa() {
            this.type = "Curve", this.arcLengthDivisions = 200;
          }
          function Ea(e, t, n, r, i, o, a, s) {
            Aa.call(this), this.type = "EllipseCurve", this.aX = e || 0, this.aY = t || 0, this.xRadius = n || 1, this.yRadius = r || 1, this.aStartAngle = i || 0, this.aEndAngle = o || 2 * Math.PI, this.aClockwise = a || !1, this.aRotation = s || 0;
          }
          function Ta(e, t, n, r, i, o) {
            Ea.call(this, e, t, n, n, r, i, o), this.type = "ArcCurve";
          }
          function Ma() {
            var e = 0,
              t = 0,
              n = 0,
              r = 0;
            function i(i, o, a, s) {
              n = -3 * (e = i) + 3 * o - 2 * (t = a) - s, r = 2 * i - 2 * o + a + s;
            }
            return {
              initCatmullRom: function initCatmullRom(e, t, n, r, o) {
                i(t, n, o * (n - e), o * (r - t));
              },
              initNonuniformCatmullRom: function initNonuniformCatmullRom(e, t, n, r, o, a, s) {
                var l = (t - e) / o - (n - e) / (o + a) + (n - t) / a,
                  u = (n - t) / a - (r - t) / (a + s) + (r - n) / s;
                i(t, n, l *= a, u *= a);
              },
              calc: function calc(i) {
                var o = i * i;
                return e + t * i + n * o + r * (o * i);
              }
            };
          }
          Object.assign(_a.prototype, {
            load: function load(e, t, n, r) {
              void 0 === e && (e = ""), void 0 !== this.path && (e = this.path + e), e = this.manager.resolveURL(e);
              var i = this,
                o = ga.get(e);
              if (void 0 !== o) return i.manager.itemStart(e), setTimeout(function () {
                t && t(o), i.manager.itemEnd(e);
              }, 0), o;
              if (void 0 === ba[e]) {
                var a = e.match(/^data:(.*?)(;base64)?,(.*)$/);
                if (a) {
                  var s = a[1],
                    l = !!a[2],
                    u = a[3];
                  u = window.decodeURIComponent(u), l && (u = window.atob(u));
                  try {
                    var c,
                      d = (this.responseType || "").toLowerCase();
                    switch (d) {
                      case "arraybuffer":
                      case "blob":
                        for (var h = new Uint8Array(u.length), f = 0; f < u.length; f++) h[f] = u.charCodeAt(f);
                        c = "blob" === d ? new Blob([h.buffer], {
                          type: s
                        }) : h.buffer;
                        break;
                      case "document":
                        var p = new DOMParser();
                        c = p.parseFromString(u, s);
                        break;
                      case "json":
                        c = JSON.parse(u);
                        break;
                      default:
                        c = u;
                    }
                    window.setTimeout(function () {
                      t && t(c), i.manager.itemEnd(e);
                    }, 0);
                  } catch (t) {
                    window.setTimeout(function () {
                      r && r(t), i.manager.itemEnd(e), i.manager.itemError(e);
                    }, 0);
                  }
                } else {
                  ba[e] = [], ba[e].push({
                    onLoad: t,
                    onProgress: n,
                    onError: r
                  });
                  var m = new XMLHttpRequest();
                  for (var g in m.open("GET", e, !0), m.addEventListener("load", function (t) {
                    var n = this.response;
                    ga.add(e, n);
                    var r = ba[e];
                    if (delete ba[e], 200 === this.status || 0 === this.status) {
                      0 === this.status && console.warn("THREE.FileLoader: HTTP Status 0 received.");
                      for (var o = 0, a = r.length; o < a; o++) (s = r[o]).onLoad && s.onLoad(n);
                      i.manager.itemEnd(e);
                    } else {
                      for (o = 0, a = r.length; o < a; o++) {
                        var s;
                        (s = r[o]).onError && s.onError(t);
                      }
                      i.manager.itemEnd(e), i.manager.itemError(e);
                    }
                  }, !1), m.addEventListener("progress", function (t) {
                    for (var n = ba[e], r = 0, i = n.length; r < i; r++) {
                      var o = n[r];
                      o.onProgress && o.onProgress(t);
                    }
                  }, !1), m.addEventListener("error", function (t) {
                    var n = ba[e];
                    delete ba[e];
                    for (var r = 0, o = n.length; r < o; r++) {
                      var a = n[r];
                      a.onError && a.onError(t);
                    }
                    i.manager.itemEnd(e), i.manager.itemError(e);
                  }, !1), void 0 !== this.responseType && (m.responseType = this.responseType), void 0 !== this.withCredentials && (m.withCredentials = this.withCredentials), m.overrideMimeType && m.overrideMimeType(void 0 !== this.mimeType ? this.mimeType : "text/plain"), this.requestHeader) m.setRequestHeader(g, this.requestHeader[g]);
                  m.send(null);
                }
                return i.manager.itemStart(e), m;
              }
              ba[e].push({
                onLoad: t,
                onProgress: n,
                onError: r
              });
            },
            setPath: function setPath(e) {
              return this.path = e, this;
            },
            setResponseType: function setResponseType(e) {
              return this.responseType = e, this;
            },
            setWithCredentials: function setWithCredentials(e) {
              return this.withCredentials = e, this;
            },
            setMimeType: function setMimeType(e) {
              return this.mimeType = e, this;
            },
            setRequestHeader: function setRequestHeader(e) {
              return this.requestHeader = e, this;
            }
          }), Object.assign(function (e) {
            this.manager = void 0 !== e ? e : ya, this._parser = null;
          }.prototype, {
            load: function load(e, t, n, r) {
              var i = this,
                o = [],
                a = new qi();
              a.image = o;
              var s = new _a(this.manager);
              function l(l) {
                s.load(e[l], function (e) {
                  var n = i._parser(e, !0);
                  o[l] = {
                    width: n.width,
                    height: n.height,
                    format: n.format,
                    mipmaps: n.mipmaps
                  }, 6 === (u += 1) && (1 === n.mipmapCount && (a.minFilter = $), a.format = n.format, a.needsUpdate = !0, t && t(a));
                }, n, r);
              }
              if (s.setPath(this.path), s.setResponseType("arraybuffer"), Array.isArray(e)) for (var u = 0, c = 0, d = e.length; c < d; ++c) l(c);else s.load(e, function (e) {
                var n = i._parser(e, !0);
                if (n.isCubemap) for (var r = n.mipmaps.length / n.mipmapCount, s = 0; s < r; s++) {
                  o[s] = {
                    mipmaps: []
                  };
                  for (var l = 0; l < n.mipmapCount; l++) o[s].mipmaps.push(n.mipmaps[s * n.mipmapCount + l]), o[s].format = n.format, o[s].width = n.width, o[s].height = n.height;
                } else a.image.width = n.width, a.image.height = n.height, a.mipmaps = n.mipmaps;
                1 === n.mipmapCount && (a.minFilter = $), a.format = n.format, a.needsUpdate = !0, t && t(a);
              }, n, r);
              return a;
            },
            setPath: function setPath(e) {
              return this.path = e, this;
            }
          }), Object.assign(function (e) {
            this.manager = void 0 !== e ? e : ya, this._parser = null;
          }.prototype, {
            load: function load(e, t, n, r) {
              var i = this,
                o = new Pe(),
                a = new _a(this.manager);
              return a.setResponseType("arraybuffer"), a.load(e, function (e) {
                var n = i._parser(e);
                n && (void 0 !== n.image ? o.image = n.image : void 0 !== n.data && (o.image.width = n.width, o.image.height = n.height, o.image.data = n.data), o.wrapS = void 0 !== n.wrapS ? n.wrapS : H, o.wrapT = void 0 !== n.wrapT ? n.wrapT : H, o.magFilter = void 0 !== n.magFilter ? n.magFilter : $, o.minFilter = void 0 !== n.minFilter ? n.minFilter : 1008, o.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.format && (o.format = n.format), void 0 !== n.type && (o.type = n.type), void 0 !== n.mipmaps && (o.mipmaps = n.mipmaps), 1 === n.mipmapCount && (o.minFilter = $), o.needsUpdate = !0, t && t(o, n));
              }, n, r), o;
            }
          }), Object.assign(xa.prototype, {
            crossOrigin: "anonymous",
            load: function load(e, t, n, r) {
              void 0 === e && (e = ""), void 0 !== this.path && (e = this.path + e), e = this.manager.resolveURL(e);
              var i = this,
                o = ga.get(e);
              if (void 0 !== o) return i.manager.itemStart(e), setTimeout(function () {
                t && t(o), i.manager.itemEnd(e);
              }, 0), o;
              var a = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
              function s() {
                a.removeEventListener("load", s, !1), a.removeEventListener("error", l, !1), ga.add(e, this), t && t(this), i.manager.itemEnd(e);
              }
              function l(t) {
                a.removeEventListener("load", s, !1), a.removeEventListener("error", l, !1), r && r(t), i.manager.itemEnd(e), i.manager.itemError(e);
              }
              return a.addEventListener("load", s, !1), a.addEventListener("error", l, !1), "data:" !== e.substr(0, 5) && void 0 !== this.crossOrigin && (a.crossOrigin = this.crossOrigin), i.manager.itemStart(e), a.src = e, a;
            },
            setCrossOrigin: function setCrossOrigin(e) {
              return this.crossOrigin = e, this;
            },
            setPath: function setPath(e) {
              return this.path = e, this;
            }
          }), Object.assign(wa.prototype, {
            crossOrigin: "anonymous",
            load: function load(e, t, n, r) {
              var i = new Vn(),
                o = new xa(this.manager);
              o.setCrossOrigin(this.crossOrigin), o.setPath(this.path);
              var a = 0;
              function s(n) {
                o.load(e[n], function (e) {
                  i.images[n] = e, 6 == ++a && (i.needsUpdate = !0, t && t(i));
                }, void 0, r);
              }
              for (var l = 0; l < e.length; ++l) s(l);
              return i;
            },
            setCrossOrigin: function setCrossOrigin(e) {
              return this.crossOrigin = e, this;
            },
            setPath: function setPath(e) {
              return this.path = e, this;
            }
          }), Object.assign(Sa.prototype, {
            crossOrigin: "anonymous",
            load: function load(e, t, n, r) {
              var i = new Te(),
                o = new xa(this.manager);
              return o.setCrossOrigin(this.crossOrigin), o.setPath(this.path), o.load(e, function (n) {
                i.image = n;
                var r = 0 < e.search(/\.(jpg|jpeg)$/) || 0 === e.search(/^data\:image\/jpeg/);
                i.format = r ? K : Z, i.needsUpdate = !0, void 0 !== t && t(i);
              }, n, r), i;
            },
            setCrossOrigin: function setCrossOrigin(e) {
              return this.crossOrigin = e, this;
            },
            setPath: function setPath(e) {
              return this.path = e, this;
            }
          }), Object.assign(Aa.prototype, {
            getPoint: function getPoint() {
              return console.warn("THREE.Curve: .getPoint() not implemented."), null;
            },
            getPointAt: function getPointAt(e, t) {
              var n = this.getUtoTmapping(e);
              return this.getPoint(n, t);
            },
            getPoints: function getPoints(e) {
              void 0 === e && (e = 5);
              for (var t = [], n = 0; n <= e; n++) t.push(this.getPoint(n / e));
              return t;
            },
            getSpacedPoints: function getSpacedPoints(e) {
              void 0 === e && (e = 5);
              for (var t = [], n = 0; n <= e; n++) t.push(this.getPointAt(n / e));
              return t;
            },
            getLength: function getLength() {
              var e = this.getLengths();
              return e[e.length - 1];
            },
            getLengths: function getLengths(e) {
              if (void 0 === e && (e = this.arcLengthDivisions), this.cacheArcLengths && this.cacheArcLengths.length === e + 1 && !this.needsUpdate) return this.cacheArcLengths;
              this.needsUpdate = !1;
              var t,
                n,
                r = [],
                i = this.getPoint(0),
                o = 0;
              for (r.push(0), n = 1; n <= e; n++) o += (t = this.getPoint(n / e)).distanceTo(i), r.push(o), i = t;
              return this.cacheArcLengths = r;
            },
            updateArcLengths: function updateArcLengths() {
              this.needsUpdate = !0, this.getLengths();
            },
            getUtoTmapping: function getUtoTmapping(e, t) {
              var n,
                r = this.getLengths(),
                i = 0,
                o = r.length;
              n = t || e * r[o - 1];
              for (var a, s = 0, l = o - 1; s <= l;) if ((a = r[i = Math.floor(s + (l - s) / 2)] - n) < 0) s = i + 1;else {
                if (!(0 < a)) {
                  l = i;
                  break;
                }
                l = i - 1;
              }
              if (r[i = l] === n) return i / (o - 1);
              var u = r[i];
              return (i + (n - u) / (r[i + 1] - u)) / (o - 1);
            },
            getTangent: function getTangent(e) {
              var t = e - 1e-4,
                n = e + 1e-4;
              t < 0 && (t = 0), 1 < n && (n = 1);
              var r = this.getPoint(t);
              return this.getPoint(n).clone().sub(r).normalize();
            },
            getTangentAt: function getTangentAt(e) {
              var t = this.getUtoTmapping(e);
              return this.getTangent(t);
            },
            computeFrenetFrames: function computeFrenetFrames(e, t) {
              var n,
                r,
                i,
                o = new ae(),
                a = [],
                s = [],
                l = [],
                u = new ae(),
                c = new ie();
              for (n = 0; n <= e; n++) r = n / e, a[n] = this.getTangentAt(r), a[n].normalize();
              s[0] = new ae(), l[0] = new ae();
              var d = Number.MAX_VALUE,
                h = Math.abs(a[0].x),
                f = Math.abs(a[0].y),
                p = Math.abs(a[0].z);
              for (h <= d && (d = h, o.set(1, 0, 0)), f <= d && (d = f, o.set(0, 1, 0)), p <= d && o.set(0, 0, 1), u.crossVectors(a[0], o).normalize(), s[0].crossVectors(a[0], u), l[0].crossVectors(a[0], s[0]), n = 1; n <= e; n++) s[n] = s[n - 1].clone(), l[n] = l[n - 1].clone(), u.crossVectors(a[n - 1], a[n]), u.length() > Number.EPSILON && (u.normalize(), i = Math.acos(ne.clamp(a[n - 1].dot(a[n]), -1, 1)), s[n].applyMatrix4(c.makeRotationAxis(u, i))), l[n].crossVectors(a[n], s[n]);
              if (!0 === t) for (i = Math.acos(ne.clamp(s[0].dot(s[e]), -1, 1)), i /= e, 0 < a[0].dot(u.crossVectors(s[0], s[e])) && (i = -i), n = 1; n <= e; n++) s[n].applyMatrix4(c.makeRotationAxis(a[n], i * n)), l[n].crossVectors(a[n], s[n]);
              return {
                tangents: a,
                normals: s,
                binormals: l
              };
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.arcLengthDivisions = e.arcLengthDivisions, this;
            },
            toJSON: function toJSON() {
              var e = {
                metadata: {
                  version: 4.5,
                  type: "Curve",
                  generator: "Curve.toJSON"
                }
              };
              return e.arcLengthDivisions = this.arcLengthDivisions, e.type = this.type, e;
            },
            fromJSON: function fromJSON(e) {
              return this.arcLengthDivisions = e.arcLengthDivisions, this;
            }
          }), ((Ea.prototype = Object.create(Aa.prototype)).constructor = Ea).prototype.isEllipseCurve = !0, Ea.prototype.getPoint = function (e, t) {
            for (var n = t || new re(), r = 2 * Math.PI, i = this.aEndAngle - this.aStartAngle, o = Math.abs(i) < Number.EPSILON; i < 0;) i += r;
            for (; r < i;) i -= r;
            i < Number.EPSILON && (i = o ? 0 : r), !0 !== this.aClockwise || o || (i === r ? i = -r : i -= r);
            var a = this.aStartAngle + e * i,
              s = this.aX + this.xRadius * Math.cos(a),
              l = this.aY + this.yRadius * Math.sin(a);
            if (0 !== this.aRotation) {
              var u = Math.cos(this.aRotation),
                c = Math.sin(this.aRotation),
                d = s - this.aX,
                h = l - this.aY;
              s = d * u - h * c + this.aX, l = d * c + h * u + this.aY;
            }
            return n.set(s, l);
          }, Ea.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
          }, Ea.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.aX = this.aX, e.aY = this.aY, e.xRadius = this.xRadius, e.yRadius = this.yRadius, e.aStartAngle = this.aStartAngle, e.aEndAngle = this.aEndAngle, e.aClockwise = this.aClockwise, e.aRotation = this.aRotation, e;
          }, Ea.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.aX = e.aX, this.aY = e.aY, this.xRadius = e.xRadius, this.yRadius = e.yRadius, this.aStartAngle = e.aStartAngle, this.aEndAngle = e.aEndAngle, this.aClockwise = e.aClockwise, this.aRotation = e.aRotation, this;
          }, ((Ta.prototype = Object.create(Ea.prototype)).constructor = Ta).prototype.isArcCurve = !0;
          var Ca = new ae(),
            ka = new Ma(),
            Pa = new Ma(),
            Oa = new Ma();
          function Ra(e, t, n, r) {
            Aa.call(this), this.type = "CatmullRomCurve3", this.points = e || [], this.closed = t || !1, this.curveType = n || "centripetal", this.tension = r || .5;
          }
          function Ia(e, t, n, r, i) {
            var o = .5 * (r - t),
              a = .5 * (i - n),
              s = e * e;
            return (2 * n - 2 * r + o + a) * (e * s) + (-3 * n + 3 * r - 2 * o - a) * s + o * e + n;
          }
          function ja(e, t, n, r) {
            return (a = 1 - e) * a * t + 2 * (1 - (o = e)) * o * n + (i = e) * i * r;
            var i, o, a;
          }
          function Na(e, t, n, r, i) {
            return (u = 1 - e) * u * u * t + 3 * (l = 1 - (s = e)) * l * s * n + 3 * (1 - (a = e)) * a * a * r + (o = e) * o * o * i;
            var o, a, s, l, u;
          }
          function La(e, t, n, r) {
            Aa.call(this), this.type = "CubicBezierCurve", this.v0 = e || new re(), this.v1 = t || new re(), this.v2 = n || new re(), this.v3 = r || new re();
          }
          function Da(e, t, n, r) {
            Aa.call(this), this.type = "CubicBezierCurve3", this.v0 = e || new ae(), this.v1 = t || new ae(), this.v2 = n || new ae(), this.v3 = r || new ae();
          }
          function Ba(e, t) {
            Aa.call(this), this.type = "LineCurve", this.v1 = e || new re(), this.v2 = t || new re();
          }
          function Fa(e, t) {
            Aa.call(this), this.type = "LineCurve3", this.v1 = e || new ae(), this.v2 = t || new ae();
          }
          function za(e, t, n) {
            Aa.call(this), this.type = "QuadraticBezierCurve", this.v0 = e || new re(), this.v1 = t || new re(), this.v2 = n || new re();
          }
          function Ua(e, t, n) {
            Aa.call(this), this.type = "QuadraticBezierCurve3", this.v0 = e || new ae(), this.v1 = t || new ae(), this.v2 = n || new ae();
          }
          function Ga(e) {
            Aa.call(this), this.type = "SplineCurve", this.points = e || [];
          }
          ((Ra.prototype = Object.create(Aa.prototype)).constructor = Ra).prototype.isCatmullRomCurve3 = !0, Ra.prototype.getPoint = function (e, t) {
            var n,
              r,
              i,
              o,
              a = t || new ae(),
              s = this.points,
              l = s.length,
              u = (l - (this.closed ? 0 : 1)) * e,
              c = Math.floor(u),
              d = u - c;
            if (this.closed ? c += 0 < c ? 0 : (Math.floor(Math.abs(c) / l) + 1) * l : 0 === d && c === l - 1 && (c = l - 2, d = 1), this.closed || 0 < c ? n = s[(c - 1) % l] : (Ca.subVectors(s[0], s[1]).add(s[0]), n = Ca), r = s[c % l], i = s[(c + 1) % l], this.closed || c + 2 < l ? o = s[(c + 2) % l] : (Ca.subVectors(s[l - 1], s[l - 2]).add(s[l - 1]), o = Ca), "centripetal" === this.curveType || "chordal" === this.curveType) {
              var h = "chordal" === this.curveType ? .5 : .25,
                f = Math.pow(n.distanceToSquared(r), h),
                p = Math.pow(r.distanceToSquared(i), h),
                m = Math.pow(i.distanceToSquared(o), h);
              p < 1e-4 && (p = 1), f < 1e-4 && (f = p), m < 1e-4 && (m = p), ka.initNonuniformCatmullRom(n.x, r.x, i.x, o.x, f, p, m), Pa.initNonuniformCatmullRom(n.y, r.y, i.y, o.y, f, p, m), Oa.initNonuniformCatmullRom(n.z, r.z, i.z, o.z, f, p, m);
            } else "catmullrom" === this.curveType && (ka.initCatmullRom(n.x, r.x, i.x, o.x, this.tension), Pa.initCatmullRom(n.y, r.y, i.y, o.y, this.tension), Oa.initCatmullRom(n.z, r.z, i.z, o.z, this.tension));
            return a.set(ka.calc(d), Pa.calc(d), Oa.calc(d)), a;
          }, Ra.prototype.copy = function (e) {
            Aa.prototype.copy.call(this, e), this.points = [];
            for (var t = 0, n = e.points.length; t < n; t++) {
              var r = e.points[t];
              this.points.push(r.clone());
            }
            return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
          }, Ra.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            e.points = [];
            for (var t = 0, n = this.points.length; t < n; t++) {
              var r = this.points[t];
              e.points.push(r.toArray());
            }
            return e.closed = this.closed, e.curveType = this.curveType, e.tension = this.tension, e;
          }, Ra.prototype.fromJSON = function (e) {
            Aa.prototype.fromJSON.call(this, e), this.points = [];
            for (var t = 0, n = e.points.length; t < n; t++) {
              var r = e.points[t];
              this.points.push(new ae().fromArray(r));
            }
            return this.closed = e.closed, this.curveType = e.curveType, this.tension = e.tension, this;
          }, ((La.prototype = Object.create(Aa.prototype)).constructor = La).prototype.isCubicBezierCurve = !0, La.prototype.getPoint = function (e, t) {
            var n = t || new re(),
              r = this.v0,
              i = this.v1,
              o = this.v2,
              a = this.v3;
            return n.set(Na(e, r.x, i.x, o.x, a.x), Na(e, r.y, i.y, o.y, a.y)), n;
          }, La.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
          }, La.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
          }, La.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
          }, ((Da.prototype = Object.create(Aa.prototype)).constructor = Da).prototype.isCubicBezierCurve3 = !0, Da.prototype.getPoint = function (e, t) {
            var n = t || new ae(),
              r = this.v0,
              i = this.v1,
              o = this.v2,
              a = this.v3;
            return n.set(Na(e, r.x, i.x, o.x, a.x), Na(e, r.y, i.y, o.y, a.y), Na(e, r.z, i.z, o.z, a.z)), n;
          }, Da.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this.v3.copy(e.v3), this;
          }, Da.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e.v3 = this.v3.toArray(), e;
          }, Da.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this.v3.fromArray(e.v3), this;
          }, ((Ba.prototype = Object.create(Aa.prototype)).constructor = Ba).prototype.isLineCurve = !0, Ba.prototype.getPoint = function (e, t) {
            var n = t || new re();
            return 1 === e ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)), n;
          }, Ba.prototype.getPointAt = function (e, t) {
            return this.getPoint(e, t);
          }, Ba.prototype.getTangent = function () {
            return this.v2.clone().sub(this.v1).normalize();
          }, Ba.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
          }, Ba.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
          }, Ba.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
          }, ((Fa.prototype = Object.create(Aa.prototype)).constructor = Fa).prototype.isLineCurve3 = !0, Fa.prototype.getPoint = function (e, t) {
            var n = t || new ae();
            return 1 === e ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(e).add(this.v1)), n;
          }, Fa.prototype.getPointAt = function (e, t) {
            return this.getPoint(e, t);
          }, Fa.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
          }, Fa.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
          }, Fa.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
          }, ((za.prototype = Object.create(Aa.prototype)).constructor = za).prototype.isQuadraticBezierCurve = !0, za.prototype.getPoint = function (e, t) {
            var n = t || new re(),
              r = this.v0,
              i = this.v1,
              o = this.v2;
            return n.set(ja(e, r.x, i.x, o.x), ja(e, r.y, i.y, o.y)), n;
          }, za.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
          }, za.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
          }, za.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
          }, ((Ua.prototype = Object.create(Aa.prototype)).constructor = Ua).prototype.isQuadraticBezierCurve3 = !0, Ua.prototype.getPoint = function (e, t) {
            var n = t || new ae(),
              r = this.v0,
              i = this.v1,
              o = this.v2;
            return n.set(ja(e, r.x, i.x, o.x), ja(e, r.y, i.y, o.y), ja(e, r.z, i.z, o.z)), n;
          }, Ua.prototype.copy = function (e) {
            return Aa.prototype.copy.call(this, e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
          }, Ua.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            return e.v0 = this.v0.toArray(), e.v1 = this.v1.toArray(), e.v2 = this.v2.toArray(), e;
          }, Ua.prototype.fromJSON = function (e) {
            return Aa.prototype.fromJSON.call(this, e), this.v0.fromArray(e.v0), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this;
          }, ((Ga.prototype = Object.create(Aa.prototype)).constructor = Ga).prototype.isSplineCurve = !0, Ga.prototype.getPoint = function (e, t) {
            var n = t || new re(),
              r = this.points,
              i = (r.length - 1) * e,
              o = Math.floor(i),
              a = i - o,
              s = r[0 === o ? o : o - 1],
              l = r[o],
              u = r[o > r.length - 2 ? r.length - 1 : o + 1],
              c = r[o > r.length - 3 ? r.length - 1 : o + 2];
            return n.set(Ia(a, s.x, l.x, u.x, c.x), Ia(a, s.y, l.y, u.y, c.y)), n;
          }, Ga.prototype.copy = function (e) {
            Aa.prototype.copy.call(this, e), this.points = [];
            for (var t = 0, n = e.points.length; t < n; t++) {
              var r = e.points[t];
              this.points.push(r.clone());
            }
            return this;
          }, Ga.prototype.toJSON = function () {
            var e = Aa.prototype.toJSON.call(this);
            e.points = [];
            for (var t = 0, n = this.points.length; t < n; t++) {
              var r = this.points[t];
              e.points.push(r.toArray());
            }
            return e;
          }, Ga.prototype.fromJSON = function (e) {
            Aa.prototype.fromJSON.call(this, e), this.points = [];
            for (var t = 0, n = e.points.length; t < n; t++) {
              var r = e.points[t];
              this.points.push(new re().fromArray(r));
            }
            return this;
          };
          var Va = Object.freeze({
            ArcCurve: Ta,
            CatmullRomCurve3: Ra,
            CubicBezierCurve: La,
            CubicBezierCurve3: Da,
            EllipseCurve: Ea,
            LineCurve: Ba,
            LineCurve3: Fa,
            QuadraticBezierCurve: za,
            QuadraticBezierCurve3: Ua,
            SplineCurve: Ga
          });
          function Ha() {
            Aa.call(this), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
          }
          function qa(e) {
            Ha.call(this), this.type = "Path", this.currentPoint = new re(), e && this.setFromPoints(e);
          }
          function Wa(e) {
            qa.call(this, e), this.uuid = ne.generateUUID(), this.type = "Shape", this.holes = [];
          }
          function $a(e, t) {
            ft.call(this), this.type = "Light", this.color = new Fe(e), this.intensity = void 0 !== t ? t : 1, this.receiveShadow = void 0;
          }
          function Xa(e, t, n) {
            $a.call(this, e, n), this.type = "HemisphereLight", this.castShadow = void 0, this.position.copy(ft.DefaultUp), this.updateMatrix(), this.groundColor = new Fe(t);
          }
          function Ya(e) {
            this.camera = e, this.bias = 0, this.radius = 1, this.mapSize = new re(512, 512), this.map = null, this.matrix = new ie();
          }
          function Ka() {
            Ya.call(this, new wi(50, 1, .5, 500));
          }
          function Za(e, t, n, r, i, o) {
            $a.call(this, e, t), this.type = "SpotLight", this.position.copy(ft.DefaultUp), this.updateMatrix(), this.target = new ft(), Object.defineProperty(this, "power", {
              get: function get() {
                return this.intensity * Math.PI;
              },
              set: function set(e) {
                this.intensity = e / Math.PI;
              }
            }), this.distance = void 0 !== n ? n : 0, this.angle = void 0 !== r ? r : Math.PI / 3, this.penumbra = void 0 !== i ? i : 0, this.decay = void 0 !== o ? o : 1, this.shadow = new Ka();
          }
          function Qa(e, t, n, r) {
            $a.call(this, e, t), this.type = "PointLight", Object.defineProperty(this, "power", {
              get: function get() {
                return 4 * this.intensity * Math.PI;
              },
              set: function set(e) {
                this.intensity = e / (4 * Math.PI);
              }
            }), this.distance = void 0 !== n ? n : 0, this.decay = void 0 !== r ? r : 1, this.shadow = new Ya(new wi(90, 1, .5, 500));
          }
          function Ja() {
            Ya.call(this, new mt(-5, 5, 5, -5, .5, 500));
          }
          function es(e, t) {
            $a.call(this, e, t), this.type = "DirectionalLight", this.position.copy(ft.DefaultUp), this.updateMatrix(), this.target = new ft(), this.shadow = new Ja();
          }
          function ts(e, t) {
            $a.call(this, e, t), this.type = "AmbientLight", this.castShadow = void 0;
          }
          function ns(e, t, n, r) {
            $a.call(this, e, t), this.type = "RectAreaLight", this.width = void 0 !== n ? n : 10, this.height = void 0 !== r ? r : 10;
          }
          Ha.prototype = Object.assign(Object.create(Aa.prototype), {
            constructor: Ha,
            add: function add(e) {
              this.curves.push(e);
            },
            closePath: function closePath() {
              var e = this.curves[0].getPoint(0),
                t = this.curves[this.curves.length - 1].getPoint(1);
              e.equals(t) || this.curves.push(new Ba(t, e));
            },
            getPoint: function getPoint(e) {
              for (var t = e * this.getLength(), n = this.getCurveLengths(), r = 0; r < n.length;) {
                if (n[r] >= t) {
                  var i = n[r] - t,
                    o = this.curves[r],
                    a = o.getLength(),
                    s = 0 === a ? 0 : 1 - i / a;
                  return o.getPointAt(s);
                }
                r++;
              }
              return null;
            },
            getLength: function getLength() {
              var e = this.getCurveLengths();
              return e[e.length - 1];
            },
            updateArcLengths: function updateArcLengths() {
              this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
            },
            getCurveLengths: function getCurveLengths() {
              if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
              for (var e = [], t = 0, n = 0, r = this.curves.length; n < r; n++) t += this.curves[n].getLength(), e.push(t);
              return this.cacheLengths = e;
            },
            getSpacedPoints: function getSpacedPoints(e) {
              void 0 === e && (e = 40);
              for (var t = [], n = 0; n <= e; n++) t.push(this.getPoint(n / e));
              return this.autoClose && t.push(t[0]), t;
            },
            getPoints: function getPoints(e) {
              e = e || 12;
              for (var t, n = [], r = 0, i = this.curves; r < i.length; r++) for (var o = i[r], a = o && o.isEllipseCurve ? 2 * e : o && (o.isLineCurve || o.isLineCurve3) ? 1 : o && o.isSplineCurve ? e * o.points.length : e, s = o.getPoints(a), l = 0; l < s.length; l++) {
                var u = s[l];
                t && t.equals(u) || (n.push(u), t = u);
              }
              return this.autoClose && 1 < n.length && !n[n.length - 1].equals(n[0]) && n.push(n[0]), n;
            },
            copy: function copy(e) {
              Aa.prototype.copy.call(this, e), this.curves = [];
              for (var t = 0, n = e.curves.length; t < n; t++) {
                var r = e.curves[t];
                this.curves.push(r.clone());
              }
              return this.autoClose = e.autoClose, this;
            },
            toJSON: function toJSON() {
              var e = Aa.prototype.toJSON.call(this);
              e.autoClose = this.autoClose, e.curves = [];
              for (var t = 0, n = this.curves.length; t < n; t++) {
                var r = this.curves[t];
                e.curves.push(r.toJSON());
              }
              return e;
            },
            fromJSON: function fromJSON(e) {
              Aa.prototype.fromJSON.call(this, e), this.autoClose = e.autoClose, this.curves = [];
              for (var t = 0, n = e.curves.length; t < n; t++) {
                var r = e.curves[t];
                this.curves.push(new Va[r.type]().fromJSON(r));
              }
              return this;
            }
          }), qa.prototype = Object.assign(Object.create(Ha.prototype), {
            constructor: qa,
            setFromPoints: function setFromPoints(e) {
              this.moveTo(e[0].x, e[0].y);
              for (var t = 1, n = e.length; t < n; t++) this.lineTo(e[t].x, e[t].y);
            },
            moveTo: function moveTo(e, t) {
              this.currentPoint.set(e, t);
            },
            lineTo: function lineTo(e, t) {
              var n = new Ba(this.currentPoint.clone(), new re(e, t));
              this.curves.push(n), this.currentPoint.set(e, t);
            },
            quadraticCurveTo: function quadraticCurveTo(e, t, n, r) {
              var i = new za(this.currentPoint.clone(), new re(e, t), new re(n, r));
              this.curves.push(i), this.currentPoint.set(n, r);
            },
            bezierCurveTo: function bezierCurveTo(e, t, n, r, i, o) {
              var a = new La(this.currentPoint.clone(), new re(e, t), new re(n, r), new re(i, o));
              this.curves.push(a), this.currentPoint.set(i, o);
            },
            splineThru: function splineThru(e) {
              var t = new Ga([this.currentPoint.clone()].concat(e));
              this.curves.push(t), this.currentPoint.copy(e[e.length - 1]);
            },
            arc: function arc(e, t, n, r, i, o) {
              var a = this.currentPoint.x,
                s = this.currentPoint.y;
              this.absarc(e + a, t + s, n, r, i, o);
            },
            absarc: function absarc(e, t, n, r, i, o) {
              this.absellipse(e, t, n, n, r, i, o);
            },
            ellipse: function ellipse(e, t, n, r, i, o, a, s) {
              var l = this.currentPoint.x,
                u = this.currentPoint.y;
              this.absellipse(e + l, t + u, n, r, i, o, a, s);
            },
            absellipse: function absellipse(e, t, n, r, i, o, a, s) {
              var l = new Ea(e, t, n, r, i, o, a, s);
              if (0 < this.curves.length) {
                var u = l.getPoint(0);
                u.equals(this.currentPoint) || this.lineTo(u.x, u.y);
              }
              this.curves.push(l);
              var c = l.getPoint(1);
              this.currentPoint.copy(c);
            },
            copy: function copy(e) {
              return Ha.prototype.copy.call(this, e), this.currentPoint.copy(e.currentPoint), this;
            },
            toJSON: function toJSON() {
              var e = Ha.prototype.toJSON.call(this);
              return e.currentPoint = this.currentPoint.toArray(), e;
            },
            fromJSON: function fromJSON(e) {
              return Ha.prototype.fromJSON.call(this, e), this.currentPoint.fromArray(e.currentPoint), this;
            }
          }), Wa.prototype = Object.assign(Object.create(qa.prototype), {
            constructor: Wa,
            getPointsHoles: function getPointsHoles(e) {
              for (var t = [], n = 0, r = this.holes.length; n < r; n++) t[n] = this.holes[n].getPoints(e);
              return t;
            },
            extractPoints: function extractPoints(e) {
              return {
                shape: this.getPoints(e),
                holes: this.getPointsHoles(e)
              };
            },
            copy: function copy(e) {
              qa.prototype.copy.call(this, e), this.holes = [];
              for (var t = 0, n = e.holes.length; t < n; t++) {
                var r = e.holes[t];
                this.holes.push(r.clone());
              }
              return this;
            },
            toJSON: function toJSON() {
              var e = qa.prototype.toJSON.call(this);
              e.uuid = this.uuid, e.holes = [];
              for (var t = 0, n = this.holes.length; t < n; t++) {
                var r = this.holes[t];
                e.holes.push(r.toJSON());
              }
              return e;
            },
            fromJSON: function fromJSON(e) {
              qa.prototype.fromJSON.call(this, e), this.uuid = e.uuid, this.holes = [];
              for (var t = 0, n = e.holes.length; t < n; t++) {
                var r = e.holes[t];
                this.holes.push(new qa().fromJSON(r));
              }
              return this;
            }
          }), $a.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: $a,
            isLight: !0,
            copy: function copy(e) {
              return ft.prototype.copy.call(this, e), this.color.copy(e.color), this.intensity = e.intensity, this;
            },
            toJSON: function toJSON(e) {
              var t = ft.prototype.toJSON.call(this, e);
              return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, void 0 !== this.groundColor && (t.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (t.object.distance = this.distance), void 0 !== this.angle && (t.object.angle = this.angle), void 0 !== this.decay && (t.object.decay = this.decay), void 0 !== this.penumbra && (t.object.penumbra = this.penumbra), void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON()), t;
            }
          }), Xa.prototype = Object.assign(Object.create($a.prototype), {
            constructor: Xa,
            isHemisphereLight: !0,
            copy: function copy(e) {
              return $a.prototype.copy.call(this, e), this.groundColor.copy(e.groundColor), this;
            }
          }), Object.assign(Ya.prototype, {
            copy: function copy(e) {
              return this.camera = e.camera.clone(), this.bias = e.bias, this.radius = e.radius, this.mapSize.copy(e.mapSize), this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            toJSON: function toJSON() {
              var e = {};
              return 0 !== this.bias && (e.bias = this.bias), 1 !== this.radius && (e.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
            }
          }), Ka.prototype = Object.assign(Object.create(Ya.prototype), {
            constructor: Ka,
            isSpotLightShadow: !0,
            update: function update(e) {
              var t = this.camera,
                n = 2 * ne.RAD2DEG * e.angle,
                r = this.mapSize.width / this.mapSize.height,
                i = e.distance || t.far;
              n === t.fov && r === t.aspect && i === t.far || (t.fov = n, t.aspect = r, t.far = i, t.updateProjectionMatrix());
            }
          }), Za.prototype = Object.assign(Object.create($a.prototype), {
            constructor: Za,
            isSpotLight: !0,
            copy: function copy(e) {
              return $a.prototype.copy.call(this, e), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
            }
          }), Qa.prototype = Object.assign(Object.create($a.prototype), {
            constructor: Qa,
            isPointLight: !0,
            copy: function copy(e) {
              return $a.prototype.copy.call(this, e), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
            }
          }), Ja.prototype = Object.assign(Object.create(Ya.prototype), {
            constructor: Ja
          }), es.prototype = Object.assign(Object.create($a.prototype), {
            constructor: es,
            isDirectionalLight: !0,
            copy: function copy(e) {
              return $a.prototype.copy.call(this, e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
            }
          }), ts.prototype = Object.assign(Object.create($a.prototype), {
            constructor: ts,
            isAmbientLight: !0
          }), ns.prototype = Object.assign(Object.create($a.prototype), {
            constructor: ns,
            isRectAreaLight: !0,
            copy: function copy(e) {
              return $a.prototype.copy.call(this, e), this.width = e.width, this.height = e.height, this;
            },
            toJSON: function toJSON(e) {
              var t = $a.prototype.toJSON.call(this, e);
              return t.object.width = this.width, t.object.height = this.height, t;
            }
          });
          var rs = {
            arraySlice: function arraySlice(e, t, n) {
              return rs.isTypedArray(e) ? new e.constructor(e.subarray(t, void 0 !== n ? n : e.length)) : e.slice(t, n);
            },
            convertArray: function convertArray(e, t, n) {
              return !e || !n && e.constructor === t ? e : "number" == typeof t.BYTES_PER_ELEMENT ? new t(e) : Array.prototype.slice.call(e);
            },
            isTypedArray: function isTypedArray(e) {
              return ArrayBuffer.isView(e) && !(e instanceof DataView);
            },
            getKeyframeOrder: function getKeyframeOrder(e) {
              for (var t = e.length, n = new Array(t), r = 0; r !== t; ++r) n[r] = r;
              return n.sort(function (t, n) {
                return e[t] - e[n];
              }), n;
            },
            sortedArray: function sortedArray(e, t, n) {
              for (var r = e.length, i = new e.constructor(r), o = 0, a = 0; a !== r; ++o) for (var s = n[o] * t, l = 0; l !== t; ++l) i[a++] = e[s + l];
              return i;
            },
            flattenJSON: function flattenJSON(e, t, n, r) {
              for (var i = 1, o = e[0]; void 0 !== o && void 0 === o[r];) o = e[i++];
              if (void 0 !== o) {
                var a = o[r];
                if (void 0 !== a) if (Array.isArray(a)) for (; void 0 !== (a = o[r]) && (t.push(o.time), n.push.apply(n, a)), void 0 !== (o = e[i++]););else if (void 0 !== a.toArray) for (; void 0 !== (a = o[r]) && (t.push(o.time), a.toArray(n, n.length)), void 0 !== (o = e[i++]););else for (; void 0 !== (a = o[r]) && (t.push(o.time), n.push(a)), void 0 !== (o = e[i++]););
              }
            }
          };
          function is(e, t, n, r) {
            this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = void 0 !== r ? r : new t.constructor(n), this.sampleValues = t, this.valueSize = n;
          }
          function os(e, t, n, r) {
            is.call(this, e, t, n, r), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0;
          }
          function as(e, t, n, r) {
            is.call(this, e, t, n, r);
          }
          function ss(e, t, n, r) {
            is.call(this, e, t, n, r);
          }
          function ls(e, t, n, r) {
            if (void 0 === e) throw new Error("THREE.KeyframeTrack: track name is undefined");
            if (void 0 === t || 0 === t.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e);
            this.name = e, this.times = rs.convertArray(t, this.TimeBufferType), this.values = rs.convertArray(n, this.ValueBufferType), this.setInterpolation(r || this.DefaultInterpolation);
          }
          function us(e, t, n) {
            ls.call(this, e, t, n);
          }
          function cs(e, t, n, r) {
            ls.call(this, e, t, n, r);
          }
          function ds(e, t, n, r) {
            ls.call(this, e, t, n, r);
          }
          function hs(e, t, n, r) {
            is.call(this, e, t, n, r);
          }
          function fs(e, t, n, r) {
            ls.call(this, e, t, n, r);
          }
          function ps(e, t, n, r) {
            ls.call(this, e, t, n, r);
          }
          function ms(e, t, n, r) {
            ls.call(this, e, t, n, r);
          }
          function gs(e, t, n) {
            this.name = e, this.tracks = n, this.duration = void 0 !== t ? t : -1, this.uuid = ne.generateUUID(), this.duration < 0 && this.resetDuration();
          }
          function vs(e) {
            if (void 0 === e.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
            var t = function (e) {
              switch (e.toLowerCase()) {
                case "scalar":
                case "double":
                case "float":
                case "number":
                case "integer":
                  return ds;
                case "vector":
                case "vector2":
                case "vector3":
                case "vector4":
                  return ms;
                case "color":
                  return cs;
                case "quaternion":
                  return fs;
                case "bool":
                case "boolean":
                  return us;
                case "string":
                  return ps;
              }
              throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + e);
            }(e.type);
            if (void 0 === e.times) {
              var n = [],
                r = [];
              rs.flattenJSON(e.keys, n, r, "value"), e.times = n, e.values = r;
            }
            return void 0 !== t.parse ? t.parse(e) : new t(e.name, e.times, e.values, e.interpolation);
          }
          function ys(e) {
            this.manager = void 0 !== e ? e : ya, this.textures = {};
          }
          function bs(e) {
            this.manager = void 0 !== e ? e : ya;
          }
          Object.assign(is.prototype, {
            evaluate: function evaluate(e) {
              var t = this.parameterPositions,
                n = this._cachedIndex,
                r = t[n],
                i = t[n - 1];
              e: {
                t: {
                  var o;
                  n: {
                    r: if (!(e < r)) {
                      for (var a = n + 2;;) {
                        if (void 0 === r) {
                          if (e < i) break r;
                          return n = t.length, this._cachedIndex = n, this.afterEnd_(n - 1, e, i);
                        }
                        if (n === a) break;
                        if (i = r, e < (r = t[++n])) break t;
                      }
                      o = t.length;
                      break n;
                    }
                    if (i <= e) break e;
                    var s = t[1];
                    for (e < s && (n = 2, i = s), a = n - 2;;) {
                      if (void 0 === i) return this._cachedIndex = 0, this.beforeStart_(0, e, r);
                      if (n === a) break;
                      if (r = i, (i = t[--n - 1]) <= e) break t;
                    }
                    o = n, n = 0;
                  }
                  for (; n < o;) {
                    var l = n + o >>> 1;
                    e < t[l] ? o = l : n = l + 1;
                  }
                  if (r = t[n], void 0 === (i = t[n - 1])) return this._cachedIndex = 0, this.beforeStart_(0, e, r);
                  if (void 0 === r) return n = t.length, this._cachedIndex = n, this.afterEnd_(n - 1, i, e);
                }
                this._cachedIndex = n, this.intervalChanged_(n, i, r);
              }
              return this.interpolate_(n, i, e, r);
            },
            settings: null,
            DefaultSettings_: {},
            getSettings_: function getSettings_() {
              return this.settings || this.DefaultSettings_;
            },
            copySampleValue_: function copySampleValue_(e) {
              for (var t = this.resultBuffer, n = this.sampleValues, r = this.valueSize, i = e * r, o = 0; o !== r; ++o) t[o] = n[i + o];
              return t;
            },
            interpolate_: function interpolate_() {
              throw new Error("call to abstract method");
            },
            intervalChanged_: function intervalChanged_() {}
          }), Object.assign(is.prototype, {
            beforeStart_: is.prototype.copySampleValue_,
            afterEnd_: is.prototype.copySampleValue_
          }), os.prototype = Object.assign(Object.create(is.prototype), {
            constructor: os,
            DefaultSettings_: {
              endingStart: ee,
              endingEnd: ee
            },
            intervalChanged_: function intervalChanged_(e, t, n) {
              var r = this.parameterPositions,
                i = e - 2,
                o = e + 1,
                a = r[i],
                s = r[o];
              if (void 0 === a) switch (this.getSettings_().endingStart) {
                case te:
                  i = e, a = 2 * t - n;
                  break;
                case 2402:
                  a = t + r[i = r.length - 2] - r[i + 1];
                  break;
                default:
                  i = e, a = n;
              }
              if (void 0 === s) switch (this.getSettings_().endingEnd) {
                case te:
                  o = e, s = 2 * n - t;
                  break;
                case 2402:
                  s = n + r[o = 1] - r[0];
                  break;
                default:
                  o = e - 1, s = t;
              }
              var l = .5 * (n - t),
                u = this.valueSize;
              this._weightPrev = l / (t - a), this._weightNext = l / (s - n), this._offsetPrev = i * u, this._offsetNext = o * u;
            },
            interpolate_: function interpolate_(e, t, n, r) {
              for (var i = this.resultBuffer, o = this.sampleValues, a = this.valueSize, s = e * a, l = s - a, u = this._offsetPrev, c = this._offsetNext, d = this._weightPrev, h = this._weightNext, f = (n - t) / (r - t), p = f * f, m = p * f, g = -d * m + 2 * d * p - d * f, v = (1 + d) * m + (-1.5 - 2 * d) * p + (-.5 + d) * f + 1, y = (-1 - h) * m + (1.5 + h) * p + .5 * f, b = h * m - h * p, _ = 0; _ !== a; ++_) i[_] = g * o[u + _] + v * o[l + _] + y * o[s + _] + b * o[c + _];
              return i;
            }
          }), as.prototype = Object.assign(Object.create(is.prototype), {
            constructor: as,
            interpolate_: function interpolate_(e, t, n, r) {
              for (var i = this.resultBuffer, o = this.sampleValues, a = this.valueSize, s = e * a, l = s - a, u = (n - t) / (r - t), c = 1 - u, d = 0; d !== a; ++d) i[d] = o[l + d] * c + o[s + d] * u;
              return i;
            }
          }), ss.prototype = Object.assign(Object.create(is.prototype), {
            constructor: ss,
            interpolate_: function interpolate_(e) {
              return this.copySampleValue_(e - 1);
            }
          }), Object.assign(ls, {
            toJSON: function toJSON(e) {
              var t,
                n = e.constructor;
              if (void 0 !== n.toJSON) t = n.toJSON(e);else {
                t = {
                  name: e.name,
                  times: rs.convertArray(e.times, Array),
                  values: rs.convertArray(e.values, Array)
                };
                var r = e.getInterpolation();
                r !== e.DefaultInterpolation && (t.interpolation = r);
              }
              return t.type = e.ValueTypeName, t;
            }
          }), Object.assign(ls.prototype, {
            constructor: ls,
            TimeBufferType: Float32Array,
            ValueBufferType: Float32Array,
            DefaultInterpolation: 2301,
            InterpolantFactoryMethodDiscrete: function InterpolantFactoryMethodDiscrete(e) {
              return new ss(this.times, this.values, this.getValueSize(), e);
            },
            InterpolantFactoryMethodLinear: function InterpolantFactoryMethodLinear(e) {
              return new as(this.times, this.values, this.getValueSize(), e);
            },
            InterpolantFactoryMethodSmooth: function InterpolantFactoryMethodSmooth(e) {
              return new os(this.times, this.values, this.getValueSize(), e);
            },
            setInterpolation: function setInterpolation(e) {
              var t;
              switch (e) {
                case 2300:
                  t = this.InterpolantFactoryMethodDiscrete;
                  break;
                case 2301:
                  t = this.InterpolantFactoryMethodLinear;
                  break;
                case 2302:
                  t = this.InterpolantFactoryMethodSmooth;
              }
              if (void 0 === t) {
                var n = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                if (void 0 === this.createInterpolant) {
                  if (e === this.DefaultInterpolation) throw new Error(n);
                  this.setInterpolation(this.DefaultInterpolation);
                }
                return console.warn("THREE.KeyframeTrack:", n), this;
              }
              return this.createInterpolant = t, this;
            },
            getInterpolation: function getInterpolation() {
              switch (this.createInterpolant) {
                case this.InterpolantFactoryMethodDiscrete:
                  return 2300;
                case this.InterpolantFactoryMethodLinear:
                  return 2301;
                case this.InterpolantFactoryMethodSmooth:
                  return 2302;
              }
            },
            getValueSize: function getValueSize() {
              return this.values.length / this.times.length;
            },
            shift: function shift(e) {
              if (0 !== e) for (var t = this.times, n = 0, r = t.length; n !== r; ++n) t[n] += e;
              return this;
            },
            scale: function scale(e) {
              if (1 !== e) for (var t = this.times, n = 0, r = t.length; n !== r; ++n) t[n] *= e;
              return this;
            },
            trim: function trim(e, t) {
              for (var n = this.times, r = n.length, i = 0, o = r - 1; i !== r && n[i] < e;) ++i;
              for (; -1 !== o && n[o] > t;) --o;
              if (++o, 0 !== i || o !== r) {
                o <= i && (i = (o = Math.max(o, 1)) - 1);
                var a = this.getValueSize();
                this.times = rs.arraySlice(n, i, o), this.values = rs.arraySlice(this.values, i * a, o * a);
              }
              return this;
            },
            validate: function validate() {
              var e = !0,
                t = this.getValueSize();
              t - Math.floor(t) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), e = !1);
              var n = this.times,
                r = this.values,
                i = n.length;
              0 === i && (console.error("THREE.KeyframeTrack: Track is empty.", this), e = !1);
              for (var o = null, a = 0; a !== i; a++) {
                var s = n[a];
                if ("number" == typeof s && isNaN(s)) {
                  console.error("THREE.KeyframeTrack: Time is not a valid number.", this, a, s), e = !1;
                  break;
                }
                if (null !== o && s < o) {
                  console.error("THREE.KeyframeTrack: Out of order keys.", this, a, s, o), e = !1;
                  break;
                }
                o = s;
              }
              if (void 0 !== r && rs.isTypedArray(r)) {
                a = 0;
                for (var l = r.length; a !== l; ++a) {
                  var u = r[a];
                  if (isNaN(u)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, a, u), e = !1;
                    break;
                  }
                }
              }
              return e;
            },
            optimize: function optimize() {
              for (var e = this.times, t = this.values, n = this.getValueSize(), r = 2302 === this.getInterpolation(), i = 1, o = e.length - 1, a = 1; a < o; ++a) {
                var s = !1,
                  l = e[a];
                if (l !== e[a + 1] && (1 !== a || l !== l[0])) if (r) s = !0;else for (var u = a * n, c = u - n, d = u + n, h = 0; h !== n; ++h) {
                  var f = t[u + h];
                  if (f !== t[c + h] || f !== t[d + h]) {
                    s = !0;
                    break;
                  }
                }
                if (s) {
                  if (a !== i) {
                    e[i] = e[a];
                    var p = a * n,
                      m = i * n;
                    for (h = 0; h !== n; ++h) t[m + h] = t[p + h];
                  }
                  ++i;
                }
              }
              if (0 < o) {
                for (e[i] = e[o], p = o * n, m = i * n, h = 0; h !== n; ++h) t[m + h] = t[p + h];
                ++i;
              }
              return i !== e.length && (this.times = rs.arraySlice(e, 0, i), this.values = rs.arraySlice(t, 0, i * n)), this;
            }
          }), us.prototype = Object.assign(Object.create(ls.prototype), {
            constructor: us,
            ValueTypeName: "bool",
            ValueBufferType: Array,
            DefaultInterpolation: 2300,
            InterpolantFactoryMethodLinear: void 0,
            InterpolantFactoryMethodSmooth: void 0
          }), cs.prototype = Object.assign(Object.create(ls.prototype), {
            constructor: cs,
            ValueTypeName: "color"
          }), ds.prototype = Object.assign(Object.create(ls.prototype), {
            constructor: ds,
            ValueTypeName: "number"
          }), hs.prototype = Object.assign(Object.create(is.prototype), {
            constructor: hs,
            interpolate_: function interpolate_(e, t, n, r) {
              for (var i = this.resultBuffer, o = this.sampleValues, a = this.valueSize, s = e * a, l = (n - t) / (r - t), u = s + a; s !== u; s += 4) oe.slerpFlat(i, 0, o, s - a, o, s, l);
              return i;
            }
          }), fs.prototype = Object.assign(Object.create(ls.prototype), {
            constructor: fs,
            ValueTypeName: "quaternion",
            DefaultInterpolation: 2301,
            InterpolantFactoryMethodLinear: function InterpolantFactoryMethodLinear(e) {
              return new hs(this.times, this.values, this.getValueSize(), e);
            },
            InterpolantFactoryMethodSmooth: void 0
          }), ps.prototype = Object.assign(Object.create(ls.prototype), {
            constructor: ps,
            ValueTypeName: "string",
            ValueBufferType: Array,
            DefaultInterpolation: 2300,
            InterpolantFactoryMethodLinear: void 0,
            InterpolantFactoryMethodSmooth: void 0
          }), ms.prototype = Object.assign(Object.create(ls.prototype), {
            constructor: ms,
            ValueTypeName: "vector"
          }), Object.assign(gs, {
            parse: function parse(e) {
              for (var t = [], n = e.tracks, r = 1 / (e.fps || 1), i = 0, o = n.length; i !== o; ++i) t.push(vs(n[i]).scale(r));
              return new gs(e.name, e.duration, t);
            },
            toJSON: function toJSON(e) {
              for (var t = [], n = e.tracks, r = {
                  name: e.name,
                  duration: e.duration,
                  tracks: t,
                  uuid: e.uuid
                }, i = 0, o = n.length; i !== o; ++i) t.push(ls.toJSON(n[i]));
              return r;
            },
            CreateFromMorphTargetSequence: function CreateFromMorphTargetSequence(e, t, n, r) {
              for (var i = t.length, o = [], a = 0; a < i; a++) {
                var s = [],
                  l = [];
                s.push((a + i - 1) % i, a, (a + 1) % i), l.push(0, 1, 0);
                var u = rs.getKeyframeOrder(s);
                s = rs.sortedArray(s, 1, u), l = rs.sortedArray(l, 1, u), r || 0 !== s[0] || (s.push(i), l.push(l[0])), o.push(new ds(".morphTargetInfluences[" + t[a].name + "]", s, l).scale(1 / n));
              }
              return new gs(e, -1, o);
            },
            findByName: function findByName(e, t) {
              var n = e;
              if (!Array.isArray(e)) {
                var r = e;
                n = r.geometry && r.geometry.animations || r.animations;
              }
              for (var i = 0; i < n.length; i++) if (n[i].name === t) return n[i];
              return null;
            },
            CreateClipsFromMorphTargetSequences: function CreateClipsFromMorphTargetSequences(e, t, n) {
              for (var r = {}, i = /^([\w-]*?)([\d]+)$/, o = 0, a = e.length; o < a; o++) {
                var s = e[o],
                  l = s.name.match(i);
                if (l && 1 < l.length) {
                  var u = r[d = l[1]];
                  u || (r[d] = u = []), u.push(s);
                }
              }
              var c = [];
              for (var d in r) c.push(gs.CreateFromMorphTargetSequence(d, r[d], t, n));
              return c;
            },
            parseAnimation: function parseAnimation(e, t) {
              if (!e) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
              for (var n = function n(e, t, _n17, r, i) {
                  if (0 !== _n17.length) {
                    var o = [],
                      a = [];
                    rs.flattenJSON(_n17, o, a, r), 0 !== o.length && i.push(new e(t, o, a));
                  }
                }, r = [], i = e.name || "default", o = e.length || -1, a = e.fps || 30, s = e.hierarchy || [], l = 0; l < s.length; l++) {
                var u = s[l].keys;
                if (u && 0 !== u.length) if (u[0].morphTargets) {
                  for (var c = {}, d = 0; d < u.length; d++) if (u[d].morphTargets) for (var h = 0; h < u[d].morphTargets.length; h++) c[u[d].morphTargets[h]] = -1;
                  for (var f in c) {
                    var p = [],
                      m = [];
                    for (h = 0; h !== u[d].morphTargets.length; ++h) {
                      var g = u[d];
                      p.push(g.time), m.push(g.morphTarget === f ? 1 : 0);
                    }
                    r.push(new ds(".morphTargetInfluence[" + f + "]", p, m));
                  }
                  o = c.length * (a || 1);
                } else {
                  var v = ".bones[" + t[l].name + "]";
                  n(ms, v + ".position", u, "pos", r), n(fs, v + ".quaternion", u, "rot", r), n(ms, v + ".scale", u, "scl", r);
                }
              }
              return 0 === r.length ? null : new gs(i, o, r);
            }
          }), Object.assign(gs.prototype, {
            resetDuration: function resetDuration() {
              for (var e = 0, t = 0, n = this.tracks.length; t !== n; ++t) {
                var r = this.tracks[t];
                e = Math.max(e, r.times[r.times.length - 1]);
              }
              return this.duration = e, this;
            },
            trim: function trim() {
              for (var e = 0; e < this.tracks.length; e++) this.tracks[e].trim(0, this.duration);
              return this;
            },
            validate: function validate() {
              for (var e = !0, t = 0; t < this.tracks.length; t++) e = e && this.tracks[t].validate();
              return e;
            },
            optimize: function optimize() {
              for (var e = 0; e < this.tracks.length; e++) this.tracks[e].optimize();
              return this;
            }
          }), Object.assign(ys.prototype, {
            load: function load(e, t, n, r) {
              var i = this;
              new _a(i.manager).load(e, function (e) {
                t(i.parse(JSON.parse(e)));
              }, n, r);
            },
            setTextures: function setTextures(e) {
              this.textures = e;
            },
            parse: function parse(e) {
              var t = this.textures;
              function n(e) {
                return void 0 === t[e] && console.warn("THREE.MaterialLoader: Undefined texture", e), t[e];
              }
              var r = new ma[e.type]();
              if (void 0 !== e.uuid && (r.uuid = e.uuid), void 0 !== e.name && (r.name = e.name), void 0 !== e.color && r.color.setHex(e.color), void 0 !== e.roughness && (r.roughness = e.roughness), void 0 !== e.metalness && (r.metalness = e.metalness), void 0 !== e.emissive && r.emissive.setHex(e.emissive), void 0 !== e.specular && r.specular.setHex(e.specular), void 0 !== e.shininess && (r.shininess = e.shininess), void 0 !== e.clearCoat && (r.clearCoat = e.clearCoat), void 0 !== e.clearCoatRoughness && (r.clearCoatRoughness = e.clearCoatRoughness), void 0 !== e.uniforms && (r.uniforms = e.uniforms), void 0 !== e.vertexShader && (r.vertexShader = e.vertexShader), void 0 !== e.fragmentShader && (r.fragmentShader = e.fragmentShader), void 0 !== e.vertexColors && (r.vertexColors = e.vertexColors), void 0 !== e.fog && (r.fog = e.fog), void 0 !== e.flatShading && (r.flatShading = e.flatShading), void 0 !== e.blending && (r.blending = e.blending), void 0 !== e.side && (r.side = e.side), void 0 !== e.opacity && (r.opacity = e.opacity), void 0 !== e.transparent && (r.transparent = e.transparent), void 0 !== e.alphaTest && (r.alphaTest = e.alphaTest), void 0 !== e.depthTest && (r.depthTest = e.depthTest), void 0 !== e.depthWrite && (r.depthWrite = e.depthWrite), void 0 !== e.colorWrite && (r.colorWrite = e.colorWrite), void 0 !== e.wireframe && (r.wireframe = e.wireframe), void 0 !== e.wireframeLinewidth && (r.wireframeLinewidth = e.wireframeLinewidth), void 0 !== e.wireframeLinecap && (r.wireframeLinecap = e.wireframeLinecap), void 0 !== e.wireframeLinejoin && (r.wireframeLinejoin = e.wireframeLinejoin), void 0 !== e.rotation && (r.rotation = e.rotation), 1 !== e.linewidth && (r.linewidth = e.linewidth), void 0 !== e.dashSize && (r.dashSize = e.dashSize), void 0 !== e.gapSize && (r.gapSize = e.gapSize), void 0 !== e.scale && (r.scale = e.scale), void 0 !== e.polygonOffset && (r.polygonOffset = e.polygonOffset), void 0 !== e.polygonOffsetFactor && (r.polygonOffsetFactor = e.polygonOffsetFactor), void 0 !== e.polygonOffsetUnits && (r.polygonOffsetUnits = e.polygonOffsetUnits), void 0 !== e.skinning && (r.skinning = e.skinning), void 0 !== e.morphTargets && (r.morphTargets = e.morphTargets), void 0 !== e.dithering && (r.dithering = e.dithering), void 0 !== e.visible && (r.visible = e.visible), void 0 !== e.userData && (r.userData = e.userData), void 0 !== e.shading && (r.flatShading = 1 === e.shading), void 0 !== e.size && (r.size = e.size), void 0 !== e.sizeAttenuation && (r.sizeAttenuation = e.sizeAttenuation), void 0 !== e.map && (r.map = n(e.map)), void 0 !== e.alphaMap && (r.alphaMap = n(e.alphaMap), r.transparent = !0), void 0 !== e.bumpMap && (r.bumpMap = n(e.bumpMap)), void 0 !== e.bumpScale && (r.bumpScale = e.bumpScale), void 0 !== e.normalMap && (r.normalMap = n(e.normalMap)), void 0 !== e.normalMapType && (r.normalMapType = e.normalMapType), void 0 !== e.normalScale) {
                var i = e.normalScale;
                !1 === Array.isArray(i) && (i = [i, i]), r.normalScale = new re().fromArray(i);
              }
              return void 0 !== e.displacementMap && (r.displacementMap = n(e.displacementMap)), void 0 !== e.displacementScale && (r.displacementScale = e.displacementScale), void 0 !== e.displacementBias && (r.displacementBias = e.displacementBias), void 0 !== e.roughnessMap && (r.roughnessMap = n(e.roughnessMap)), void 0 !== e.metalnessMap && (r.metalnessMap = n(e.metalnessMap)), void 0 !== e.emissiveMap && (r.emissiveMap = n(e.emissiveMap)), void 0 !== e.emissiveIntensity && (r.emissiveIntensity = e.emissiveIntensity), void 0 !== e.specularMap && (r.specularMap = n(e.specularMap)), void 0 !== e.envMap && (r.envMap = n(e.envMap)), void 0 !== e.reflectivity && (r.reflectivity = e.reflectivity), void 0 !== e.lightMap && (r.lightMap = n(e.lightMap)), void 0 !== e.lightMapIntensity && (r.lightMapIntensity = e.lightMapIntensity), void 0 !== e.aoMap && (r.aoMap = n(e.aoMap)), void 0 !== e.aoMapIntensity && (r.aoMapIntensity = e.aoMapIntensity), void 0 !== e.gradientMap && (r.gradientMap = n(e.gradientMap)), r;
            }
          }), Object.assign(bs.prototype, {
            load: function load(e, t, n, r) {
              var i = this;
              new _a(i.manager).load(e, function (e) {
                t(i.parse(JSON.parse(e)));
              }, n, r);
            },
            parse: function parse(e) {
              var t = new Yt(),
                n = e.data.index;
              if (void 0 !== n) {
                var r = new As[n.type](n.array);
                t.setIndex(new Tt(r, 1));
              }
              var i = e.data.attributes;
              for (var o in i) {
                var a = i[o];
                r = new As[a.type](a.array), t.addAttribute(o, new Tt(r, a.itemSize, a.normalized));
              }
              var s = e.data.groups || e.data.drawcalls || e.data.offsets;
              if (void 0 !== s) for (var l = 0, u = s.length; l !== u; ++l) {
                var c = s[l];
                t.addGroup(c.start, c.count, c.materialIndex);
              }
              var d = e.data.boundingSphere;
              if (void 0 !== d) {
                var h = new ae();
                void 0 !== d.center && h.fromArray(d.center), t.boundingSphere = new Re(h, d.radius);
              }
              return t;
            }
          });
          var _s,
            xs,
            ws,
            Ss,
            As = {
              Int8Array: Int8Array,
              Uint8Array: Uint8Array,
              Uint8ClampedArray: "undefined" != typeof Uint8ClampedArray ? Uint8ClampedArray : Uint8Array,
              Int16Array: Int16Array,
              Uint16Array: Uint16Array,
              Int32Array: Int32Array,
              Uint32Array: Uint32Array,
              Float32Array: Float32Array,
              Float64Array: Float64Array
            };
          function Es() {}
          Es.Handlers = {
            handlers: [],
            add: function add(e, t) {
              this.handlers.push(e, t);
            },
            get: function get(e) {
              for (var t = this.handlers, n = 0, r = t.length; n < r; n += 2) {
                var i = t[n],
                  o = t[n + 1];
                if (i.test(e)) return o;
              }
              return null;
            }
          }, Object.assign(Es.prototype, {
            crossOrigin: "anonymous",
            onLoadStart: function onLoadStart() {},
            onLoadProgress: function onLoadProgress() {},
            onLoadComplete: function onLoadComplete() {},
            initMaterials: function initMaterials(e, t, n) {
              for (var r = [], i = 0; i < e.length; ++i) r[i] = this.createMaterial(e[i], t, n);
              return r;
            },
            createMaterial: (_s = {
              NoBlending: 0,
              NormalBlending: 1,
              AdditiveBlending: 2,
              SubtractiveBlending: 3,
              MultiplyBlending: 4,
              CustomBlending: 5
            }, xs = new Fe(), ws = new Sa(), Ss = new ys(), function (e, t, n) {
              var r = {};
              function i(e, i, o, a, s) {
                var l,
                  u = t + e,
                  c = Es.Handlers.get(u);
                null !== c ? l = c.load(u) : (ws.setCrossOrigin(n), l = ws.load(u)), void 0 !== i && (l.repeat.fromArray(i), 1 !== i[0] && (l.wrapS = V), 1 !== i[1] && (l.wrapT = V)), void 0 !== o && l.offset.fromArray(o), void 0 !== a && ("repeat" === a[0] && (l.wrapS = V), "mirror" === a[0] && (l.wrapS = q), "repeat" === a[1] && (l.wrapT = V), "mirror" === a[1] && (l.wrapT = q)), void 0 !== s && (l.anisotropy = s);
                var d = ne.generateUUID();
                return r[d] = l, d;
              }
              var o = {
                uuid: ne.generateUUID(),
                type: "MeshLambertMaterial"
              };
              for (var a in e) {
                var s = e[a];
                switch (a) {
                  case "DbgColor":
                  case "DbgIndex":
                  case "opticalDensity":
                  case "illumination":
                    break;
                  case "DbgName":
                    o.name = s;
                    break;
                  case "blending":
                    o.blending = _s[s];
                    break;
                  case "colorAmbient":
                  case "mapAmbient":
                    console.warn("THREE.Loader.createMaterial:", a, "is no longer supported.");
                    break;
                  case "colorDiffuse":
                    o.color = xs.fromArray(s).getHex();
                    break;
                  case "colorSpecular":
                    o.specular = xs.fromArray(s).getHex();
                    break;
                  case "colorEmissive":
                    o.emissive = xs.fromArray(s).getHex();
                    break;
                  case "specularCoef":
                    o.shininess = s;
                    break;
                  case "shading":
                    "basic" === s.toLowerCase() && (o.type = "MeshBasicMaterial"), "phong" === s.toLowerCase() && (o.type = "MeshPhongMaterial"), "standard" === s.toLowerCase() && (o.type = "MeshStandardMaterial");
                    break;
                  case "mapDiffuse":
                    o.map = i(s, e.mapDiffuseRepeat, e.mapDiffuseOffset, e.mapDiffuseWrap, e.mapDiffuseAnisotropy);
                    break;
                  case "mapDiffuseRepeat":
                  case "mapDiffuseOffset":
                  case "mapDiffuseWrap":
                  case "mapDiffuseAnisotropy":
                    break;
                  case "mapEmissive":
                    o.emissiveMap = i(s, e.mapEmissiveRepeat, e.mapEmissiveOffset, e.mapEmissiveWrap, e.mapEmissiveAnisotropy);
                    break;
                  case "mapEmissiveRepeat":
                  case "mapEmissiveOffset":
                  case "mapEmissiveWrap":
                  case "mapEmissiveAnisotropy":
                    break;
                  case "mapLight":
                    o.lightMap = i(s, e.mapLightRepeat, e.mapLightOffset, e.mapLightWrap, e.mapLightAnisotropy);
                    break;
                  case "mapLightRepeat":
                  case "mapLightOffset":
                  case "mapLightWrap":
                  case "mapLightAnisotropy":
                    break;
                  case "mapAO":
                    o.aoMap = i(s, e.mapAORepeat, e.mapAOOffset, e.mapAOWrap, e.mapAOAnisotropy);
                    break;
                  case "mapAORepeat":
                  case "mapAOOffset":
                  case "mapAOWrap":
                  case "mapAOAnisotropy":
                    break;
                  case "mapBump":
                    o.bumpMap = i(s, e.mapBumpRepeat, e.mapBumpOffset, e.mapBumpWrap, e.mapBumpAnisotropy);
                    break;
                  case "mapBumpScale":
                    o.bumpScale = s;
                    break;
                  case "mapBumpRepeat":
                  case "mapBumpOffset":
                  case "mapBumpWrap":
                  case "mapBumpAnisotropy":
                    break;
                  case "mapNormal":
                    o.normalMap = i(s, e.mapNormalRepeat, e.mapNormalOffset, e.mapNormalWrap, e.mapNormalAnisotropy);
                    break;
                  case "mapNormalFactor":
                    o.normalScale = s;
                    break;
                  case "mapNormalRepeat":
                  case "mapNormalOffset":
                  case "mapNormalWrap":
                  case "mapNormalAnisotropy":
                    break;
                  case "mapSpecular":
                    o.specularMap = i(s, e.mapSpecularRepeat, e.mapSpecularOffset, e.mapSpecularWrap, e.mapSpecularAnisotropy);
                    break;
                  case "mapSpecularRepeat":
                  case "mapSpecularOffset":
                  case "mapSpecularWrap":
                  case "mapSpecularAnisotropy":
                    break;
                  case "mapMetalness":
                    o.metalnessMap = i(s, e.mapMetalnessRepeat, e.mapMetalnessOffset, e.mapMetalnessWrap, e.mapMetalnessAnisotropy);
                    break;
                  case "mapMetalnessRepeat":
                  case "mapMetalnessOffset":
                  case "mapMetalnessWrap":
                  case "mapMetalnessAnisotropy":
                    break;
                  case "mapRoughness":
                    o.roughnessMap = i(s, e.mapRoughnessRepeat, e.mapRoughnessOffset, e.mapRoughnessWrap, e.mapRoughnessAnisotropy);
                    break;
                  case "mapRoughnessRepeat":
                  case "mapRoughnessOffset":
                  case "mapRoughnessWrap":
                  case "mapRoughnessAnisotropy":
                    break;
                  case "mapAlpha":
                    o.alphaMap = i(s, e.mapAlphaRepeat, e.mapAlphaOffset, e.mapAlphaWrap, e.mapAlphaAnisotropy);
                    break;
                  case "mapAlphaRepeat":
                  case "mapAlphaOffset":
                  case "mapAlphaWrap":
                  case "mapAlphaAnisotropy":
                    break;
                  case "flipSided":
                    o.side = 1;
                    break;
                  case "doubleSided":
                    o.side = 2;
                    break;
                  case "transparency":
                    console.warn("THREE.Loader.createMaterial: transparency has been renamed to opacity"), o.opacity = s;
                    break;
                  case "depthTest":
                  case "depthWrite":
                  case "colorWrite":
                  case "opacity":
                  case "reflectivity":
                  case "transparent":
                  case "visible":
                  case "wireframe":
                    o[a] = s;
                    break;
                  case "vertexColors":
                    !0 === s && (o.vertexColors = 2), "face" === s && (o.vertexColors = 1);
                    break;
                  default:
                    console.error("THREE.Loader.createMaterial: Unsupported", a, s);
                }
              }
              return "MeshBasicMaterial" === o.type && delete o.emissive, "MeshPhongMaterial" !== o.type && delete o.specular, o.opacity < 1 && (o.transparent = !0), Ss.setTextures(r), Ss.parse(o);
            })
          });
          var Ts = function Ts(e) {
            var t = e.lastIndexOf("/");
            return -1 === t ? "./" : e.substr(0, t + 1);
          };
          function Ms(e) {
            "boolean" == typeof e && (console.warn("THREE.JSONLoader: showStatus parameter has been removed from constructor."), e = void 0), this.manager = void 0 !== e ? e : ya, this.withCredentials = !1;
          }
          Object.assign(Ms.prototype, {
            crossOrigin: "anonymous",
            load: function load(e, t, n, r) {
              var i = this,
                o = this.texturePath && "string" == typeof this.texturePath ? this.texturePath : Ts(e),
                a = new _a(this.manager);
              a.setWithCredentials(this.withCredentials), a.load(e, function (n) {
                var r = JSON.parse(n),
                  a = r.metadata;
                if (void 0 !== a) {
                  var s = a.type;
                  if (void 0 !== s && "object" === s.toLowerCase()) return void console.error("THREE.JSONLoader: " + e + " should be loaded with THREE.ObjectLoader instead.");
                }
                var l = i.parse(r, o);
                t(l.geometry, l.materials);
              }, n, r);
            },
            setCrossOrigin: function setCrossOrigin(e) {
              return this.crossOrigin = e, this;
            },
            setTexturePath: function setTexturePath(e) {
              return this.texturePath = e, this;
            },
            parse: function parse(e, t) {
              void 0 !== e.data && (e = e.data), void 0 !== e.scale ? e.scale = 1 / e.scale : e.scale = 1;
              var n = new Et();
              return function (e, t) {
                function n(e, t) {
                  return e & 1 << t;
                }
                var r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h,
                  f,
                  p,
                  m,
                  g,
                  v,
                  y,
                  b,
                  _,
                  x,
                  w,
                  S,
                  A,
                  E,
                  T,
                  M,
                  C = e.faces,
                  k = e.vertices,
                  P = e.normals,
                  O = e.colors,
                  R = e.scale,
                  I = 0;
                if (void 0 !== e.uvs) {
                  for (r = 0; r < e.uvs.length; r++) e.uvs[r].length && I++;
                  for (r = 0; r < I; r++) t.faceVertexUvs[r] = [];
                }
                for (a = 0, s = k.length; a < s;) (_ = new ae()).x = k[a++] * R, _.y = k[a++] * R, _.z = k[a++] * R, t.vertices.push(_);
                for (a = 0, s = C.length; a < s;) if (f = n(h = C[a++], 0), p = n(h, 1), m = n(h, 3), g = n(h, 4), v = n(h, 5), y = n(h, 6), b = n(h, 7), f) {
                  if ((w = new gt()).a = C[a], w.b = C[a + 1], w.c = C[a + 3], (S = new gt()).a = C[a + 1], S.b = C[a + 2], S.c = C[a + 3], a += 4, p && (d = C[a++], w.materialIndex = d, S.materialIndex = d), o = t.faces.length, m) for (r = 0; r < I; r++) for (T = e.uvs[r], t.faceVertexUvs[r][o] = [], t.faceVertexUvs[r][o + 1] = [], i = 0; i < 4; i++) M = new re(T[2 * (c = C[a++])], T[2 * c + 1]), 2 !== i && t.faceVertexUvs[r][o].push(M), 0 !== i && t.faceVertexUvs[r][o + 1].push(M);
                  if (g && (u = 3 * C[a++], w.normal.set(P[u++], P[u++], P[u]), S.normal.copy(w.normal)), v) for (r = 0; r < 4; r++) u = 3 * C[a++], E = new ae(P[u++], P[u++], P[u]), 2 !== r && w.vertexNormals.push(E), 0 !== r && S.vertexNormals.push(E);
                  if (y && (A = O[l = C[a++]], w.color.setHex(A), S.color.setHex(A)), b) for (r = 0; r < 4; r++) A = O[l = C[a++]], 2 !== r && w.vertexColors.push(new Fe(A)), 0 !== r && S.vertexColors.push(new Fe(A));
                  t.faces.push(w), t.faces.push(S);
                } else {
                  if ((x = new gt()).a = C[a++], x.b = C[a++], x.c = C[a++], p && (d = C[a++], x.materialIndex = d), o = t.faces.length, m) for (r = 0; r < I; r++) for (T = e.uvs[r], t.faceVertexUvs[r][o] = [], i = 0; i < 3; i++) M = new re(T[2 * (c = C[a++])], T[2 * c + 1]), t.faceVertexUvs[r][o].push(M);
                  if (g && (u = 3 * C[a++], x.normal.set(P[u++], P[u++], P[u])), v) for (r = 0; r < 3; r++) u = 3 * C[a++], E = new ae(P[u++], P[u++], P[u]), x.vertexNormals.push(E);
                  if (y && (l = C[a++], x.color.setHex(O[l])), b) for (r = 0; r < 3; r++) l = C[a++], x.vertexColors.push(new Fe(O[l]));
                  t.faces.push(x);
                }
              }(e, n), function (e, t) {
                var n = void 0 !== e.influencesPerVertex ? e.influencesPerVertex : 2;
                if (e.skinWeights) for (var r = 0, i = e.skinWeights.length; r < i; r += n) {
                  var o = e.skinWeights[r],
                    a = 1 < n ? e.skinWeights[r + 1] : 0,
                    s = 2 < n ? e.skinWeights[r + 2] : 0,
                    l = 3 < n ? e.skinWeights[r + 3] : 0;
                  t.skinWeights.push(new Me(o, a, s, l));
                }
                if (e.skinIndices) for (r = 0, i = e.skinIndices.length; r < i; r += n) {
                  var u = e.skinIndices[r],
                    c = 1 < n ? e.skinIndices[r + 1] : 0,
                    d = 2 < n ? e.skinIndices[r + 2] : 0,
                    h = 3 < n ? e.skinIndices[r + 3] : 0;
                  t.skinIndices.push(new Me(u, c, d, h));
                }
                t.bones = e.bones, t.bones && 0 < t.bones.length && (t.skinWeights.length !== t.skinIndices.length || t.skinIndices.length !== t.vertices.length) && console.warn("When skinning, number of vertices (" + t.vertices.length + "), skinIndices (" + t.skinIndices.length + "), and skinWeights (" + t.skinWeights.length + ") should match.");
              }(e, n), function (e, t) {
                var n = e.scale;
                if (void 0 !== e.morphTargets) for (var r = 0, i = e.morphTargets.length; r < i; r++) {
                  t.morphTargets[r] = {}, t.morphTargets[r].name = e.morphTargets[r].name, t.morphTargets[r].vertices = [];
                  for (var o = t.morphTargets[r].vertices, a = e.morphTargets[r].vertices, s = 0, l = a.length; s < l; s += 3) {
                    var u = new ae();
                    u.x = a[s] * n, u.y = a[s + 1] * n, u.z = a[s + 2] * n, o.push(u);
                  }
                }
                if (void 0 !== e.morphColors && 0 < e.morphColors.length) {
                  console.warn('THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.');
                  var c = t.faces,
                    d = e.morphColors[0].colors;
                  for (r = 0, i = c.length; r < i; r++) c[r].color.fromArray(d, 3 * r);
                }
              }(e, n), function (e, t) {
                var n = [],
                  r = [];
                void 0 !== e.animation && r.push(e.animation), void 0 !== e.animations && (e.animations.length ? r = r.concat(e.animations) : r.push(e.animations));
                for (var i = 0; i < r.length; i++) {
                  var o = gs.parseAnimation(r[i], t.bones);
                  o && n.push(o);
                }
                if (t.morphTargets) {
                  var a = gs.CreateClipsFromMorphTargetSequences(t.morphTargets, 10);
                  n = n.concat(a);
                }
                0 < n.length && (t.animations = n);
              }(e, n), n.computeFaceNormals(), n.computeBoundingSphere(), void 0 === e.materials || 0 === e.materials.length ? {
                geometry: n
              } : {
                geometry: n,
                materials: Es.prototype.initMaterials(e.materials, t, this.crossOrigin)
              };
            }
          }), Object.assign(function (e) {
            this.manager = void 0 !== e ? e : ya, this.texturePath = "";
          }.prototype, {
            crossOrigin: "anonymous",
            load: function load(e, t, n, r) {
              "" === this.texturePath && (this.texturePath = e.substring(0, e.lastIndexOf("/") + 1));
              var i = this;
              new _a(i.manager).load(e, function (n) {
                var o = null;
                try {
                  o = JSON.parse(n);
                } catch (n) {
                  return void 0 !== r && r(n), void console.error("THREE:ObjectLoader: Can't parse " + e + ".", n.message);
                }
                var a = o.metadata;
                void 0 !== a && void 0 !== a.type && "geometry" !== a.type.toLowerCase() ? i.parse(o, t) : console.error("THREE.ObjectLoader: Can't load " + e + ". Use THREE.JSONLoader instead.");
              }, n, r);
            },
            setTexturePath: function setTexturePath(e) {
              return this.texturePath = e, this;
            },
            setCrossOrigin: function setCrossOrigin(e) {
              return this.crossOrigin = e, this;
            },
            parse: function parse(e, t) {
              var n = this.parseShape(e.shapes),
                r = this.parseGeometries(e.geometries, n),
                i = this.parseImages(e.images, function () {
                  void 0 !== t && t(s);
                }),
                o = this.parseTextures(e.textures, i),
                a = this.parseMaterials(e.materials, o),
                s = this.parseObject(e.object, r, a);
              return e.animations && (s.animations = this.parseAnimations(e.animations)), void 0 !== e.images && 0 !== e.images.length || void 0 !== t && t(s), s;
            },
            parseShape: function parseShape(e) {
              var t = {};
              if (void 0 !== e) for (var n = 0, r = e.length; n < r; n++) {
                var i = new Wa().fromJSON(e[n]);
                t[i.uuid] = i;
              }
              return t;
            },
            parseGeometries: function parseGeometries(e, t) {
              var n = {};
              if (void 0 !== e) for (var r = new Ms(), i = new bs(), o = 0, a = e.length; o < a; o++) {
                var s,
                  l = e[o];
                switch (l.type) {
                  case "PlaneGeometry":
                  case "PlaneBufferGeometry":
                    s = new oa[l.type](l.width, l.height, l.widthSegments, l.heightSegments);
                    break;
                  case "BoxGeometry":
                  case "BoxBufferGeometry":
                  case "CubeGeometry":
                    s = new oa[l.type](l.width, l.height, l.depth, l.widthSegments, l.heightSegments, l.depthSegments);
                    break;
                  case "CircleGeometry":
                  case "CircleBufferGeometry":
                    s = new oa[l.type](l.radius, l.segments, l.thetaStart, l.thetaLength);
                    break;
                  case "CylinderGeometry":
                  case "CylinderBufferGeometry":
                    s = new oa[l.type](l.radiusTop, l.radiusBottom, l.height, l.radialSegments, l.heightSegments, l.openEnded, l.thetaStart, l.thetaLength);
                    break;
                  case "ConeGeometry":
                  case "ConeBufferGeometry":
                    s = new oa[l.type](l.radius, l.height, l.radialSegments, l.heightSegments, l.openEnded, l.thetaStart, l.thetaLength);
                    break;
                  case "SphereGeometry":
                  case "SphereBufferGeometry":
                    s = new oa[l.type](l.radius, l.widthSegments, l.heightSegments, l.phiStart, l.phiLength, l.thetaStart, l.thetaLength);
                    break;
                  case "DodecahedronGeometry":
                  case "DodecahedronBufferGeometry":
                  case "IcosahedronGeometry":
                  case "IcosahedronBufferGeometry":
                  case "OctahedronGeometry":
                  case "OctahedronBufferGeometry":
                  case "TetrahedronGeometry":
                  case "TetrahedronBufferGeometry":
                    s = new oa[l.type](l.radius, l.detail);
                    break;
                  case "RingGeometry":
                  case "RingBufferGeometry":
                    s = new oa[l.type](l.innerRadius, l.outerRadius, l.thetaSegments, l.phiSegments, l.thetaStart, l.thetaLength);
                    break;
                  case "TorusGeometry":
                  case "TorusBufferGeometry":
                    s = new oa[l.type](l.radius, l.tube, l.radialSegments, l.tubularSegments, l.arc);
                    break;
                  case "TorusKnotGeometry":
                  case "TorusKnotBufferGeometry":
                    s = new oa[l.type](l.radius, l.tube, l.tubularSegments, l.radialSegments, l.p, l.q);
                    break;
                  case "LatheGeometry":
                  case "LatheBufferGeometry":
                    s = new oa[l.type](l.points, l.segments, l.phiStart, l.phiLength);
                    break;
                  case "PolyhedronGeometry":
                  case "PolyhedronBufferGeometry":
                    s = new oa[l.type](l.vertices, l.indices, l.radius, l.details);
                    break;
                  case "ShapeGeometry":
                  case "ShapeBufferGeometry":
                    for (var u = [], c = 0, d = l.shapes.length; c < d; c++) {
                      var h = t[l.shapes[c]];
                      u.push(h);
                    }
                    s = new oa[l.type](u, l.curveSegments);
                    break;
                  case "ExtrudeGeometry":
                  case "ExtrudeBufferGeometry":
                    for (u = [], c = 0, d = l.shapes.length; c < d; c++) h = t[l.shapes[c]], u.push(h);
                    var f = l.options.extrudePath;
                    void 0 !== f && (l.options.extrudePath = new Va[f.type]().fromJSON(f)), s = new oa[l.type](u, l.options);
                    break;
                  case "BufferGeometry":
                    s = i.parse(l);
                    break;
                  case "Geometry":
                    s = r.parse(l, this.texturePath).geometry;
                    break;
                  default:
                    console.warn('THREE.ObjectLoader: Unsupported geometry type "' + l.type + '"');
                    continue;
                }
                s.uuid = l.uuid, void 0 !== l.name && (s.name = l.name), !0 === s.isBufferGeometry && void 0 !== l.userData && (s.userData = l.userData), n[l.uuid] = s;
              }
              return n;
            },
            parseMaterials: function parseMaterials(e, t) {
              var n = {};
              if (void 0 !== e) {
                var r = new ys();
                r.setTextures(t);
                for (var i = 0, o = e.length; i < o; i++) {
                  var a = e[i];
                  if ("MultiMaterial" === a.type) {
                    for (var s = [], l = 0; l < a.materials.length; l++) s.push(r.parse(a.materials[l]));
                    n[a.uuid] = s;
                  } else n[a.uuid] = r.parse(a);
                }
              }
              return n;
            },
            parseAnimations: function parseAnimations(e) {
              for (var t = [], n = 0; n < e.length; n++) {
                var r = e[n],
                  i = gs.parse(r);
                void 0 !== r.uuid && (i.uuid = r.uuid), t.push(i);
              }
              return t;
            },
            parseImages: function parseImages(e, t) {
              var n = this,
                r = {};
              function i(e) {
                return n.manager.itemStart(e), o.load(e, function () {
                  n.manager.itemEnd(e);
                }, void 0, function () {
                  n.manager.itemEnd(e), n.manager.itemError(e);
                });
              }
              if (void 0 !== e && 0 < e.length) {
                var o = new xa(new va(t));
                o.setCrossOrigin(this.crossOrigin);
                for (var a = 0, s = e.length; a < s; a++) {
                  var l = e[a],
                    u = l.url;
                  if (Array.isArray(u)) {
                    r[l.uuid] = [];
                    for (var c = 0, d = u.length; c < d; c++) {
                      var h = u[c],
                        f = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(h) ? h : n.texturePath + h;
                      r[l.uuid].push(i(f));
                    }
                  } else f = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(l.url) ? l.url : n.texturePath + l.url, r[l.uuid] = i(f);
                }
              }
              return r;
            },
            parseTextures: function parseTextures(e, t) {
              function n(e, t) {
                return "number" == typeof e ? e : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", e), t[e]);
              }
              var r = {};
              if (void 0 !== e) for (var i = 0, o = e.length; i < o; i++) {
                var a,
                  s = e[i];
                void 0 === s.image && console.warn('THREE.ObjectLoader: No "image" specified for', s.uuid), void 0 === t[s.image] && console.warn("THREE.ObjectLoader: Undefined image", s.image), (a = Array.isArray(t[s.image]) ? new Vn(t[s.image]) : new Te(t[s.image])).needsUpdate = !0, a.uuid = s.uuid, void 0 !== s.name && (a.name = s.name), void 0 !== s.mapping && (a.mapping = n(s.mapping, ks)), void 0 !== s.offset && a.offset.fromArray(s.offset), void 0 !== s.repeat && a.repeat.fromArray(s.repeat), void 0 !== s.center && a.center.fromArray(s.center), void 0 !== s.rotation && (a.rotation = s.rotation), void 0 !== s.wrap && (a.wrapS = n(s.wrap[0], Ps), a.wrapT = n(s.wrap[1], Ps)), void 0 !== s.format && (a.format = s.format), void 0 !== s.minFilter && (a.minFilter = n(s.minFilter, Os)), void 0 !== s.magFilter && (a.magFilter = n(s.magFilter, Os)), void 0 !== s.anisotropy && (a.anisotropy = s.anisotropy), void 0 !== s.flipY && (a.flipY = s.flipY), r[s.uuid] = a;
              }
              return r;
            },
            parseObject: function parseObject(e, t, n) {
              var r;
              function i(e) {
                return void 0 === t[e] && console.warn("THREE.ObjectLoader: Undefined geometry", e), t[e];
              }
              function o(e) {
                if (void 0 !== e) {
                  if (Array.isArray(e)) {
                    for (var t = [], r = 0, i = e.length; r < i; r++) {
                      var o = e[r];
                      void 0 === n[o] && console.warn("THREE.ObjectLoader: Undefined material", o), t.push(n[o]);
                    }
                    return t;
                  }
                  return void 0 === n[e] && console.warn("THREE.ObjectLoader: Undefined material", e), n[e];
                }
              }
              switch (e.type) {
                case "Scene":
                  r = new ki(), void 0 !== e.background && Number.isInteger(e.background) && (r.background = new Fe(e.background)), void 0 !== e.fog && ("Fog" === e.fog.type ? r.fog = new Ci(e.fog.color, e.fog.near, e.fog.far) : "FogExp2" === e.fog.type && (r.fog = new Mi(e.fog.color, e.fog.density)));
                  break;
                case "PerspectiveCamera":
                  r = new wi(e.fov, e.aspect, e.near, e.far), void 0 !== e.focus && (r.focus = e.focus), void 0 !== e.zoom && (r.zoom = e.zoom), void 0 !== e.filmGauge && (r.filmGauge = e.filmGauge), void 0 !== e.filmOffset && (r.filmOffset = e.filmOffset), void 0 !== e.view && (r.view = Object.assign({}, e.view));
                  break;
                case "OrthographicCamera":
                  r = new mt(e.left, e.right, e.top, e.bottom, e.near, e.far), void 0 !== e.zoom && (r.zoom = e.zoom), void 0 !== e.view && (r.view = Object.assign({}, e.view));
                  break;
                case "AmbientLight":
                  r = new ts(e.color, e.intensity);
                  break;
                case "DirectionalLight":
                  r = new es(e.color, e.intensity);
                  break;
                case "PointLight":
                  r = new Qa(e.color, e.intensity, e.distance, e.decay);
                  break;
                case "RectAreaLight":
                  r = new ns(e.color, e.intensity, e.width, e.height);
                  break;
                case "SpotLight":
                  r = new Za(e.color, e.intensity, e.distance, e.angle, e.penumbra, e.decay);
                  break;
                case "HemisphereLight":
                  r = new Xa(e.color, e.groundColor, e.intensity);
                  break;
                case "SkinnedMesh":
                  console.warn("THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.");
                case "Mesh":
                  var a = i(e.geometry),
                    s = o(e.material);
                  r = a.bones && 0 < a.bones.length ? new Di(a, s) : new On(a, s);
                  break;
                case "LOD":
                  r = new ji();
                  break;
                case "Line":
                  r = new Fi(i(e.geometry), o(e.material), e.mode);
                  break;
                case "LineLoop":
                  r = new Ui(i(e.geometry), o(e.material));
                  break;
                case "LineSegments":
                  r = new zi(i(e.geometry), o(e.material));
                  break;
                case "PointCloud":
                case "Points":
                  r = new Vi(i(e.geometry), o(e.material));
                  break;
                case "Sprite":
                  r = new Ii(o(e.material));
                  break;
                case "Group":
                  r = new xi();
                  break;
                default:
                  r = new ft();
              }
              if (r.uuid = e.uuid, void 0 !== e.name && (r.name = e.name), void 0 !== e.matrix ? (r.matrix.fromArray(e.matrix), void 0 !== e.matrixAutoUpdate && (r.matrixAutoUpdate = e.matrixAutoUpdate), r.matrixAutoUpdate && r.matrix.decompose(r.position, r.quaternion, r.scale)) : (void 0 !== e.position && r.position.fromArray(e.position), void 0 !== e.rotation && r.rotation.fromArray(e.rotation), void 0 !== e.quaternion && r.quaternion.fromArray(e.quaternion), void 0 !== e.scale && r.scale.fromArray(e.scale)), void 0 !== e.castShadow && (r.castShadow = e.castShadow), void 0 !== e.receiveShadow && (r.receiveShadow = e.receiveShadow), e.shadow && (void 0 !== e.shadow.bias && (r.shadow.bias = e.shadow.bias), void 0 !== e.shadow.radius && (r.shadow.radius = e.shadow.radius), void 0 !== e.shadow.mapSize && r.shadow.mapSize.fromArray(e.shadow.mapSize), void 0 !== e.shadow.camera && (r.shadow.camera = this.parseObject(e.shadow.camera))), void 0 !== e.visible && (r.visible = e.visible), void 0 !== e.frustumCulled && (r.frustumCulled = e.frustumCulled), void 0 !== e.renderOrder && (r.renderOrder = e.renderOrder), void 0 !== e.userData && (r.userData = e.userData), void 0 !== e.layers && (r.layers.mask = e.layers), void 0 !== e.children) for (var l = e.children, u = 0; u < l.length; u++) r.add(this.parseObject(l[u], t, n));
              if ("LOD" === e.type) for (var c = e.levels, d = 0; d < c.length; d++) {
                var h = c[d],
                  f = r.getObjectByProperty("uuid", h.object);
                void 0 !== f && r.addLevel(f, h.distance);
              }
              return r;
            }
          });
          var Cs,
            ks = {
              UVMapping: 300,
              CubeReflectionMapping: 301,
              CubeRefractionMapping: 302,
              EquirectangularReflectionMapping: 303,
              EquirectangularRefractionMapping: 304,
              SphericalReflectionMapping: 305,
              CubeUVReflectionMapping: 306,
              CubeUVRefractionMapping: 307
            },
            Ps = {
              RepeatWrapping: V,
              ClampToEdgeWrapping: H,
              MirroredRepeatWrapping: q
            },
            Os = {
              NearestFilter: W,
              NearestMipMapNearestFilter: 1004,
              NearestMipMapLinearFilter: 1005,
              LinearFilter: $,
              LinearMipMapNearestFilter: 1007,
              LinearMipMapLinearFilter: 1008
            };
          function Rs() {
            this.type = "ShapePath", this.color = new Fe(), this.subPaths = [], this.currentPath = null;
          }
          function Is(e) {
            this.type = "Font", this.data = e;
          }
          function js(e, t, n, r, i) {
            var o = i.glyphs[e] || i.glyphs["?"];
            if (o) {
              var a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p = new Rs();
              if (o.o) for (var m = o._cachedOutline || (o._cachedOutline = o.o.split(" ")), g = 0, v = m.length; g < v;) switch (m[g++]) {
                case "m":
                  a = m[g++] * t + n, s = m[g++] * t + r, p.moveTo(a, s);
                  break;
                case "l":
                  a = m[g++] * t + n, s = m[g++] * t + r, p.lineTo(a, s);
                  break;
                case "q":
                  l = m[g++] * t + n, u = m[g++] * t + r, c = m[g++] * t + n, d = m[g++] * t + r, p.quadraticCurveTo(c, d, l, u);
                  break;
                case "b":
                  l = m[g++] * t + n, u = m[g++] * t + r, c = m[g++] * t + n, d = m[g++] * t + r, h = m[g++] * t + n, f = m[g++] * t + r, p.bezierCurveTo(c, d, h, f, l, u);
              }
              return {
                offsetX: o.ha * t,
                path: p
              };
            }
          }
          Object.assign(Rs.prototype, {
            moveTo: function moveTo(e, t) {
              this.currentPath = new qa(), this.subPaths.push(this.currentPath), this.currentPath.moveTo(e, t);
            },
            lineTo: function lineTo(e, t) {
              this.currentPath.lineTo(e, t);
            },
            quadraticCurveTo: function quadraticCurveTo(e, t, n, r) {
              this.currentPath.quadraticCurveTo(e, t, n, r);
            },
            bezierCurveTo: function bezierCurveTo(e, t, n, r, i, o) {
              this.currentPath.bezierCurveTo(e, t, n, r, i, o);
            },
            splineThru: function splineThru(e) {
              this.currentPath.splineThru(e);
            },
            toShapes: function toShapes(e, t) {
              function n(e) {
                for (var t = [], n = 0, r = e.length; n < r; n++) {
                  var i = e[n],
                    o = new Wa();
                  o.curves = i.curves, t.push(o);
                }
                return t;
              }
              function r(e, t) {
                for (var n = t.length, r = !1, i = n - 1, o = 0; o < n; i = o++) {
                  var a = t[i],
                    s = t[o],
                    l = s.x - a.x,
                    u = s.y - a.y;
                  if (Math.abs(u) > Number.EPSILON) {
                    if (u < 0 && (a = t[o], l = -l, s = t[i], u = -u), e.y < a.y || e.y > s.y) continue;
                    if (e.y === a.y) {
                      if (e.x === a.x) return !0;
                    } else {
                      var c = u * (e.x - a.x) - l * (e.y - a.y);
                      if (0 === c) return !0;
                      if (c < 0) continue;
                      r = !r;
                    }
                  } else {
                    if (e.y !== a.y) continue;
                    if (s.x <= e.x && e.x <= a.x || a.x <= e.x && e.x <= s.x) return !0;
                  }
                }
                return r;
              }
              var i = jo.isClockWise,
                o = this.subPaths;
              if (0 === o.length) return [];
              if (!0 === t) return n(o);
              var a,
                s,
                l,
                u = [];
              if (1 === o.length) return s = o[0], (l = new Wa()).curves = s.curves, u.push(l), u;
              var c = !i(o[0].getPoints());
              c = e ? !c : c;
              var d,
                h,
                f = [],
                p = [],
                m = [],
                g = 0;
              p[g] = void 0, m[g] = [];
              for (var v = 0, y = o.length; v < y; v++) a = i(d = (s = o[v]).getPoints()), (a = e ? !a : a) ? (!c && p[g] && g++, p[g] = {
                s: new Wa(),
                p: d
              }, p[g].s.curves = s.curves, c && g++, m[g] = []) : m[g].push({
                h: s,
                p: d[0]
              });
              if (!p[0]) return n(o);
              if (1 < p.length) {
                for (var b = !1, _ = [], x = 0, w = p.length; x < w; x++) f[x] = [];
                for (x = 0, w = p.length; x < w; x++) for (var S = m[x], A = 0; A < S.length; A++) {
                  for (var E = S[A], T = !0, M = 0; M < p.length; M++) r(E.p, p[M].p) && (x !== M && _.push({
                    froms: x,
                    tos: M,
                    hole: A
                  }), T ? (T = !1, f[M].push(E)) : b = !0);
                  T && f[x].push(E);
                }
                0 < _.length && (b || (m = f));
              }
              v = 0;
              for (var C = p.length; v < C; v++) {
                l = p[v].s, u.push(l);
                for (var k = 0, P = (h = m[v]).length; k < P; k++) l.holes.push(h[k].h);
              }
              return u;
            }
          }), Object.assign(Is.prototype, {
            isFont: !0,
            generateShapes: function generateShapes(e, t) {
              void 0 === t && (t = 100);
              for (var n = [], r = function (e, t, n) {
                  for (var r = Array.from ? Array.from(e) : String(e).split(""), i = t / n.resolution, o = (n.boundingBox.yMax - n.boundingBox.yMin + n.underlineThickness) * i, a = [], s = 0, l = 0, u = 0; u < r.length; u++) {
                    var c = r[u];
                    if ("\n" === c) s = 0, l -= o;else {
                      var d = js(c, i, s, l, n);
                      s += d.offsetX, a.push(d.path);
                    }
                  }
                  return a;
                }(e, t, this.data), i = 0, o = r.length; i < o; i++) Array.prototype.push.apply(n, r[i].toShapes());
              return n;
            }
          }), Object.assign(function (e) {
            this.manager = void 0 !== e ? e : ya;
          }.prototype, {
            load: function load(e, t, n, r) {
              var i = this,
                o = new _a(this.manager);
              o.setPath(this.path), o.load(e, function (e) {
                var n;
                try {
                  n = JSON.parse(e);
                } catch (r) {
                  console.warn("THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead."), n = JSON.parse(e.substring(65, e.length - 2));
                }
                var r = i.parse(n);
                t && t(r);
              }, n, r);
            },
            parse: function parse(e) {
              return new Is(e);
            },
            setPath: function setPath(e) {
              return this.path = e, this;
            }
          });
          var Ns,
            Ls,
            Ds,
            Bs,
            Fs,
            zs,
            Us,
            Gs,
            Vs,
            Hs,
            qs,
            Ws,
            $s,
            Xs,
            Ys,
            Ks,
            Zs,
            Qs,
            Js = function Js() {
              return void 0 === Cs && (Cs = new (window.AudioContext || window.webkitAudioContext)()), Cs;
            };
          function el(e) {
            this.manager = void 0 !== e ? e : ya;
          }
          function tl() {
            this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new wi(), this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new wi(), this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1;
          }
          function nl(e, t, n) {
            ft.call(this), this.type = "CubeCamera";
            var r = new wi(90, 1, e, t);
            r.up.set(0, -1, 0), r.lookAt(new ae(1, 0, 0)), this.add(r);
            var i = new wi(90, 1, e, t);
            i.up.set(0, -1, 0), i.lookAt(new ae(-1, 0, 0)), this.add(i);
            var o = new wi(90, 1, e, t);
            o.up.set(0, 0, 1), o.lookAt(new ae(0, 1, 0)), this.add(o);
            var a = new wi(90, 1, e, t);
            a.up.set(0, 0, -1), a.lookAt(new ae(0, -1, 0)), this.add(a);
            var s = new wi(90, 1, e, t);
            s.up.set(0, -1, 0), s.lookAt(new ae(0, 0, 1)), this.add(s);
            var l = new wi(90, 1, e, t);
            l.up.set(0, -1, 0), l.lookAt(new ae(0, 0, -1)), this.add(l);
            var u = {
              format: K,
              magFilter: $,
              minFilter: $
            };
            this.renderTarget = new ke(n, n, u), this.renderTarget.texture.name = "CubeCamera", this.update = function (e, t) {
              null === this.parent && this.updateMatrixWorld();
              var n = this.renderTarget,
                u = n.texture.generateMipmaps;
              n.texture.generateMipmaps = !1, n.activeCubeFace = 0, e.render(t, r, n), n.activeCubeFace = 1, e.render(t, i, n), n.activeCubeFace = 2, e.render(t, o, n), n.activeCubeFace = 3, e.render(t, a, n), n.activeCubeFace = 4, e.render(t, s, n), n.texture.generateMipmaps = u, n.activeCubeFace = 5, e.render(t, l, n), e.setRenderTarget(null);
            }, this.clear = function (e, t, n, r) {
              for (var i = this.renderTarget, o = 0; o < 6; o++) i.activeCubeFace = o, e.setRenderTarget(i), e.clear(t, n, r);
              e.setRenderTarget(null);
            };
          }
          function rl() {
            ft.call(this), this.type = "AudioListener", this.context = Js(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null;
          }
          function il(e) {
            ft.call(this), this.type = "Audio", this.context = e.context, this.gain = this.context.createGain(), this.gain.connect(e.getInput()), this.autoplay = !1, this.buffer = null, this.loop = !1, this.startTime = 0, this.offset = 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.sourceType = "empty", this.filters = [];
          }
          function ol(e) {
            il.call(this, e), this.panner = this.context.createPanner(), this.panner.connect(this.gain);
          }
          function al(e, t) {
            this.analyser = e.context.createAnalyser(), this.analyser.fftSize = void 0 !== t ? t : 2048, this.data = new Uint8Array(this.analyser.frequencyBinCount), e.getOutput().connect(this.analyser);
          }
          function sl(e, t, n) {
            this.binding = e, this.valueSize = n;
            var r,
              i = Float64Array;
            switch (t) {
              case "quaternion":
                r = this._slerp;
                break;
              case "string":
              case "bool":
                i = Array, r = this._select;
                break;
              default:
                r = this._lerp;
            }
            this.buffer = new i(4 * n), this._mixBufferRegion = r, this.cumulativeWeight = 0, this.useCount = 0, this.referenceCount = 0;
          }
          Object.assign(el.prototype, {
            load: function load(e, t, n, r) {
              var i = new _a(this.manager);
              i.setResponseType("arraybuffer"), i.load(e, function (e) {
                var n = e.slice(0);
                Js().decodeAudioData(n, function (e) {
                  t(e);
                });
              }, n, r);
            }
          }), Object.assign(tl.prototype, {
            update: (Vs = new ie(), Hs = new ie(), function (e) {
              if (Ns !== this || Ls !== e.focus || Ds !== e.fov || Bs !== e.aspect * this.aspect || Fs !== e.near || zs !== e.far || Us !== e.zoom || Gs !== this.eyeSep) {
                Ns = this, Ls = e.focus, Ds = e.fov, Bs = e.aspect * this.aspect, Fs = e.near, zs = e.far, Us = e.zoom;
                var t,
                  n,
                  r = e.projectionMatrix.clone(),
                  i = (Gs = this.eyeSep / 2) * Fs / Ls,
                  o = Fs * Math.tan(ne.DEG2RAD * Ds * .5) / Us;
                Hs.elements[12] = -Gs, Vs.elements[12] = Gs, t = -o * Bs + i, n = o * Bs + i, r.elements[0] = 2 * Fs / (n - t), r.elements[8] = (n + t) / (n - t), this.cameraL.projectionMatrix.copy(r), t = -o * Bs - i, n = o * Bs - i, r.elements[0] = 2 * Fs / (n - t), r.elements[8] = (n + t) / (n - t), this.cameraR.projectionMatrix.copy(r);
              }
              this.cameraL.matrixWorld.copy(e.matrixWorld).multiply(Hs), this.cameraR.matrixWorld.copy(e.matrixWorld).multiply(Vs);
            })
          }), (nl.prototype = Object.create(ft.prototype)).constructor = nl, rl.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: rl,
            getInput: function getInput() {
              return this.gain;
            },
            removeFilter: function removeFilter() {
              return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
            },
            getFilter: function getFilter() {
              return this.filter;
            },
            setFilter: function setFilter(e) {
              return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = e, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
            },
            getMasterVolume: function getMasterVolume() {
              return this.gain.gain.value;
            },
            setMasterVolume: function setMasterVolume(e) {
              return this.gain.gain.setTargetAtTime(e, this.context.currentTime, .01), this;
            },
            updateMatrixWorld: (qs = new ae(), Ws = new oe(), $s = new ae(), Xs = new ae(), function (e) {
              ft.prototype.updateMatrixWorld.call(this, e);
              var t = this.context.listener,
                n = this.up;
              this.matrixWorld.decompose(qs, Ws, $s), Xs.set(0, 0, -1).applyQuaternion(Ws), t.positionX ? (t.positionX.setValueAtTime(qs.x, this.context.currentTime), t.positionY.setValueAtTime(qs.y, this.context.currentTime), t.positionZ.setValueAtTime(qs.z, this.context.currentTime), t.forwardX.setValueAtTime(Xs.x, this.context.currentTime), t.forwardY.setValueAtTime(Xs.y, this.context.currentTime), t.forwardZ.setValueAtTime(Xs.z, this.context.currentTime), t.upX.setValueAtTime(n.x, this.context.currentTime), t.upY.setValueAtTime(n.y, this.context.currentTime), t.upZ.setValueAtTime(n.z, this.context.currentTime)) : (t.setPosition(qs.x, qs.y, qs.z), t.setOrientation(Xs.x, Xs.y, Xs.z, n.x, n.y, n.z));
            })
          }), il.prototype = Object.assign(Object.create(ft.prototype), {
            constructor: il,
            getOutput: function getOutput() {
              return this.gain;
            },
            setNodeSource: function setNodeSource(e) {
              return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = e, this.connect(), this;
            },
            setMediaElementSource: function setMediaElementSource(e) {
              return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(e), this.connect(), this;
            },
            setBuffer: function setBuffer(e) {
              return this.buffer = e, this.sourceType = "buffer", this.autoplay && this.play(), this;
            },
            play: function play() {
              if (!0 !== this.isPlaying) {
                if (!1 !== this.hasPlaybackControl) {
                  var e = this.context.createBufferSource();
                  return e.buffer = this.buffer, e.loop = this.loop, e.onended = this.onEnded.bind(this), e.playbackRate.setValueAtTime(this.playbackRate, this.startTime), this.startTime = this.context.currentTime, e.start(this.startTime, this.offset), this.isPlaying = !0, this.source = e, this.connect();
                }
                console.warn("THREE.Audio: this Audio has no playback control.");
              } else console.warn("THREE.Audio: Audio is already playing.");
            },
            pause: function pause() {
              if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this.source.stop(), this.source.onended = null, this.offset += (this.context.currentTime - this.startTime) * this.playbackRate, this.isPlaying = !1), this;
              console.warn("THREE.Audio: this Audio has no playback control.");
            },
            stop: function stop() {
              if (!1 !== this.hasPlaybackControl) return this.source.stop(), this.source.onended = null, this.offset = 0, this.isPlaying = !1, this;
              console.warn("THREE.Audio: this Audio has no playback control.");
            },
            connect: function connect() {
              if (0 < this.filters.length) {
                this.source.connect(this.filters[0]);
                for (var e = 1, t = this.filters.length; e < t; e++) this.filters[e - 1].connect(this.filters[e]);
                this.filters[this.filters.length - 1].connect(this.getOutput());
              } else this.source.connect(this.getOutput());
              return this;
            },
            disconnect: function disconnect() {
              if (0 < this.filters.length) {
                this.source.disconnect(this.filters[0]);
                for (var e = 1, t = this.filters.length; e < t; e++) this.filters[e - 1].disconnect(this.filters[e]);
                this.filters[this.filters.length - 1].disconnect(this.getOutput());
              } else this.source.disconnect(this.getOutput());
              return this;
            },
            getFilters: function getFilters() {
              return this.filters;
            },
            setFilters: function setFilters(e) {
              return e || (e = []), !0 === this.isPlaying ? (this.disconnect(), this.filters = e, this.connect()) : this.filters = e, this;
            },
            getFilter: function getFilter() {
              return this.getFilters()[0];
            },
            setFilter: function setFilter(e) {
              return this.setFilters(e ? [e] : []);
            },
            setPlaybackRate: function setPlaybackRate(e) {
              if (!1 !== this.hasPlaybackControl) return this.playbackRate = e, !0 === this.isPlaying && this.source.playbackRate.setValueAtTime(this.playbackRate, this.context.currentTime), this;
              console.warn("THREE.Audio: this Audio has no playback control.");
            },
            getPlaybackRate: function getPlaybackRate() {
              return this.playbackRate;
            },
            onEnded: function onEnded() {
              this.isPlaying = !1;
            },
            getLoop: function getLoop() {
              return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
            },
            setLoop: function setLoop(e) {
              if (!1 !== this.hasPlaybackControl) return this.loop = e, !0 === this.isPlaying && (this.source.loop = this.loop), this;
              console.warn("THREE.Audio: this Audio has no playback control.");
            },
            getVolume: function getVolume() {
              return this.gain.gain.value;
            },
            setVolume: function setVolume(e) {
              return this.gain.gain.setTargetAtTime(e, this.context.currentTime, .01), this;
            }
          }), ol.prototype = Object.assign(Object.create(il.prototype), {
            constructor: ol,
            getOutput: function getOutput() {
              return this.panner;
            },
            getRefDistance: function getRefDistance() {
              return this.panner.refDistance;
            },
            setRefDistance: function setRefDistance(e) {
              return this.panner.refDistance = e, this;
            },
            getRolloffFactor: function getRolloffFactor() {
              return this.panner.rolloffFactor;
            },
            setRolloffFactor: function setRolloffFactor(e) {
              return this.panner.rolloffFactor = e, this;
            },
            getDistanceModel: function getDistanceModel() {
              return this.panner.distanceModel;
            },
            setDistanceModel: function setDistanceModel(e) {
              return this.panner.distanceModel = e, this;
            },
            getMaxDistance: function getMaxDistance() {
              return this.panner.maxDistance;
            },
            setMaxDistance: function setMaxDistance(e) {
              return this.panner.maxDistance = e, this;
            },
            setDirectionalCone: function setDirectionalCone(e, t, n) {
              return this.panner.coneInnerAngle = e, this.panner.coneOuterAngle = t, this.panner.coneOuterGain = n, this;
            },
            updateMatrixWorld: (Ys = new ae(), Ks = new oe(), Zs = new ae(), Qs = new ae(), function (e) {
              ft.prototype.updateMatrixWorld.call(this, e);
              var t = this.panner;
              this.matrixWorld.decompose(Ys, Ks, Zs), Qs.set(0, 0, 1).applyQuaternion(Ks), t.setPosition(Ys.x, Ys.y, Ys.z), t.setOrientation(Qs.x, Qs.y, Qs.z);
            })
          }), Object.assign(al.prototype, {
            getFrequencyData: function getFrequencyData() {
              return this.analyser.getByteFrequencyData(this.data), this.data;
            },
            getAverageFrequency: function getAverageFrequency() {
              for (var e = 0, t = this.getFrequencyData(), n = 0; n < t.length; n++) e += t[n];
              return e / t.length;
            }
          }), Object.assign(sl.prototype, {
            accumulate: function accumulate(e, t) {
              var n = this.buffer,
                r = this.valueSize,
                i = e * r + r,
                o = this.cumulativeWeight;
              if (0 === o) {
                for (var a = 0; a !== r; ++a) n[i + a] = n[a];
                o = t;
              } else {
                var s = t / (o += t);
                this._mixBufferRegion(n, i, 0, s, r);
              }
              this.cumulativeWeight = o;
            },
            apply: function apply(e) {
              var t = this.valueSize,
                n = this.buffer,
                r = e * t + t,
                i = this.cumulativeWeight,
                o = this.binding;
              if (this.cumulativeWeight = 0, i < 1) {
                var a = 3 * t;
                this._mixBufferRegion(n, r, a, 1 - i, t);
              }
              for (var s = t, l = t + t; s !== l; ++s) if (n[s] !== n[s + t]) {
                o.setValue(n, r);
                break;
              }
            },
            saveOriginalState: function saveOriginalState() {
              var e = this.binding,
                t = this.buffer,
                n = this.valueSize,
                r = 3 * n;
              e.getValue(t, r);
              for (var i = n, o = r; i !== o; ++i) t[i] = t[r + i % n];
              this.cumulativeWeight = 0;
            },
            restoreOriginalState: function restoreOriginalState() {
              var e = 3 * this.valueSize;
              this.binding.setValue(this.buffer, e);
            },
            _select: function _select(e, t, n, r, i) {
              if (.5 <= r) for (var o = 0; o !== i; ++o) e[t + o] = e[n + o];
            },
            _slerp: function _slerp(e, t, n, r) {
              oe.slerpFlat(e, t, e, t, e, n, r);
            },
            _lerp: function _lerp(e, t, n, r, i) {
              for (var o = 1 - r, a = 0; a !== i; ++a) {
                var s = t + a;
                e[s] = e[s] * o + e[n + a] * r;
              }
            }
          });
          var ll,
            ul,
            cl,
            dl,
            hl,
            fl,
            pl,
            ml,
            gl,
            vl,
            yl,
            bl,
            _l,
            xl,
            wl,
            Sl,
            Al,
            El,
            Tl,
            Ml,
            Cl,
            kl,
            Pl,
            Ol,
            Rl,
            Il,
            jl,
            Nl,
            Ll,
            Dl,
            Bl,
            Fl,
            zl,
            Ul,
            Gl,
            Vl,
            Hl = "\\[\\]\\.:\\/";
          function ql(e, t, n) {
            var r = n || Wl.parseTrackName(t);
            this._targetGroup = e, this._bindings = e.subscribe_(t, r);
          }
          function Wl(e, t, n) {
            this.path = t, this.parsedPath = n || Wl.parseTrackName(t), this.node = Wl.findNode(e, this.parsedPath.nodeName) || e, this.rootNode = e;
          }
          function $l(e, t, n) {
            this._mixer = e, this._clip = t, this._localRoot = n || null;
            for (var r = t.tracks, i = r.length, o = new Array(i), a = {
                endingStart: ee,
                endingEnd: ee
              }, s = 0; s !== i; ++s) {
              var l = r[s].createInterpolant(null);
              (o[s] = l).settings = a;
            }
            this._interpolantSettings = a, this._interpolants = o, this._propertyBindings = new Array(i), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = 2201, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
          }
          function Xl(e) {
            this._root = e, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
          }
          function Yl(e) {
            "string" == typeof e && (console.warn("THREE.Uniform: Type parameter is no longer needed."), e = arguments[1]), this.value = e;
          }
          function Kl() {
            Yt.call(this), this.type = "InstancedBufferGeometry", this.maxInstancedCount = void 0;
          }
          function Zl(e, t, n) {
            Pi.call(this, e, t), this.meshPerAttribute = n || 1;
          }
          function Ql(e, t, n) {
            Tt.call(this, e, t), this.meshPerAttribute = n || 1;
          }
          function Jl(e, t) {
            return e.distance - t.distance;
          }
          function eu(e, t, n, r) {
            if (!1 !== e.visible && (e.raycast(t, n), !0 === r)) for (var i = e.children, o = 0, a = i.length; o < a; o++) eu(i[o], t, n, !0);
          }
          function tu(e, t) {
            this.min = void 0 !== e ? e : new re(1 / 0, 1 / 0), this.max = void 0 !== t ? t : new re(-1 / 0, -1 / 0);
          }
          function nu(e, t) {
            this.start = void 0 !== e ? e : new ae(), this.end = void 0 !== t ? t : new ae();
          }
          function ru(e) {
            ft.call(this), this.material = e, this.render = function () {};
          }
          function iu(e, t, n, r) {
            this.object = e, this.size = void 0 !== t ? t : 1;
            var i = void 0 !== n ? n : 16711680,
              o = void 0 !== r ? r : 1,
              a = 0,
              s = this.object.geometry;
            s && s.isGeometry ? a = 3 * s.faces.length : s && s.isBufferGeometry && (a = s.attributes.normal.count);
            var l = new Yt(),
              u = new jt(2 * a * 3, 3);
            l.addAttribute("position", u), zi.call(this, l, new Bi({
              color: i,
              linewidth: o
            })), this.matrixAutoUpdate = !1, this.update();
          }
          function ou(e, t) {
            ft.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.color = t;
            for (var n = new Yt(), r = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1], i = 0, o = 1; i < 32; i++, o++) {
              var a = i / 32 * Math.PI * 2,
                s = o / 32 * Math.PI * 2;
              r.push(Math.cos(a), Math.sin(a), 1, Math.cos(s), Math.sin(s), 1);
            }
            n.addAttribute("position", new jt(r, 3));
            var l = new Bi({
              fog: !1
            });
            this.cone = new zi(n, l), this.add(this.cone), this.update();
          }
          function au(e) {
            for (var t = function e(t) {
                var n = [];
                t && t.isBone && n.push(t);
                for (var r = 0; r < t.children.length; r++) n.push.apply(n, e(t.children[r]));
                return n;
              }(e), n = new Yt(), r = [], i = [], o = new Fe(0, 0, 1), a = new Fe(0, 1, 0), s = 0; s < t.length; s++) {
              var l = t[s];
              l.parent && l.parent.isBone && (r.push(0, 0, 0), r.push(0, 0, 0), i.push(o.r, o.g, o.b), i.push(a.r, a.g, a.b));
            }
            n.addAttribute("position", new jt(r, 3)), n.addAttribute("color", new jt(i, 3));
            var u = new Bi({
              vertexColors: 2,
              depthTest: !1,
              depthWrite: !1,
              transparent: !0
            });
            zi.call(this, n, u), this.root = e, this.bones = t, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1;
          }
          function su(e, t, n) {
            this.light = e, this.light.updateMatrixWorld(), this.color = n;
            var r = new Ho(t, 4, 2),
              i = new Mn({
                wireframe: !0,
                fog: !1
              });
            On.call(this, r, i), this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
          }
          function lu(e, t) {
            ft.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.color = t;
            var n = new Bi({
                fog: !1
              }),
              r = new Yt();
            r.addAttribute("position", new Tt(new Float32Array(15), 3)), this.line = new Fi(r, n), this.add(this.line), this.update();
          }
          function uu(e, t, n) {
            ft.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.color = n;
            var r = new no(t);
            r.rotateY(.5 * Math.PI), this.material = new Mn({
              wireframe: !0,
              fog: !1
            }), void 0 === this.color && (this.material.vertexColors = 2);
            var i = r.getAttribute("position"),
              o = new Float32Array(3 * i.count);
            r.addAttribute("color", new Tt(o, 3)), this.add(new On(r, this.material)), this.update();
          }
          function cu(e, t, n, r) {
            e = e || 10, t = t || 10, n = new Fe(void 0 !== n ? n : 4473924), r = new Fe(void 0 !== r ? r : 8947848);
            for (var i = t / 2, o = e / t, a = e / 2, s = [], l = [], u = 0, c = 0, d = -a; u <= t; u++, d += o) {
              s.push(-a, 0, d, a, 0, d), s.push(d, 0, -a, d, 0, a);
              var h = u === i ? n : r;
              h.toArray(l, c), c += 3, h.toArray(l, c), c += 3, h.toArray(l, c), c += 3, h.toArray(l, c), c += 3;
            }
            var f = new Yt();
            f.addAttribute("position", new jt(s, 3)), f.addAttribute("color", new jt(l, 3));
            var p = new Bi({
              vertexColors: 2
            });
            zi.call(this, f, p);
          }
          function du(e, t, n, r, i, o) {
            e = e || 10, t = t || 16, n = n || 8, r = r || 64, i = new Fe(void 0 !== i ? i : 4473924), o = new Fe(void 0 !== o ? o : 8947848);
            var a,
              s,
              l,
              u,
              c,
              d,
              h,
              f = [],
              p = [];
            for (u = 0; u <= t; u++) l = u / t * (2 * Math.PI), a = Math.sin(l) * e, s = Math.cos(l) * e, f.push(0, 0, 0), f.push(a, 0, s), h = 1 & u ? i : o, p.push(h.r, h.g, h.b), p.push(h.r, h.g, h.b);
            for (u = 0; u <= n; u++) for (h = 1 & u ? i : o, d = e - e / n * u, c = 0; c < r; c++) l = c / r * (2 * Math.PI), a = Math.sin(l) * d, s = Math.cos(l) * d, f.push(a, 0, s), p.push(h.r, h.g, h.b), l = (c + 1) / r * (2 * Math.PI), a = Math.sin(l) * d, s = Math.cos(l) * d, f.push(a, 0, s), p.push(h.r, h.g, h.b);
            var m = new Yt();
            m.addAttribute("position", new jt(f, 3)), m.addAttribute("color", new jt(p, 3));
            var g = new Bi({
              vertexColors: 2
            });
            zi.call(this, m, g);
          }
          function hu(e, t, n, r) {
            this.object = e, this.size = void 0 !== t ? t : 1;
            var i = void 0 !== n ? n : 16776960,
              o = void 0 !== r ? r : 1,
              a = 0,
              s = this.object.geometry;
            s && s.isGeometry ? a = s.faces.length : console.warn("THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.");
            var l = new Yt(),
              u = new jt(2 * a * 3, 3);
            l.addAttribute("position", u), zi.call(this, l, new Bi({
              color: i,
              linewidth: o
            })), this.matrixAutoUpdate = !1, this.update();
          }
          function fu(e, t, n) {
            ft.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, void 0 === t && (t = 1);
            var r = new Yt();
            r.addAttribute("position", new jt([-t, t, 0, t, t, 0, t, -t, 0, -t, -t, 0, -t, t, 0], 3));
            var i = new Bi({
              fog: !1
            });
            this.lightPlane = new Fi(r, i), this.add(this.lightPlane), (r = new Yt()).addAttribute("position", new jt([0, 0, 0, 0, 0, 1], 3)), this.targetLine = new Fi(r, i), this.add(this.targetLine), this.update();
          }
          function pu(e) {
            var t = new Yt(),
              n = new Bi({
                color: 16777215,
                vertexColors: 1
              }),
              r = [],
              i = [],
              o = {},
              a = new Fe(16755200),
              s = new Fe(16711680),
              l = new Fe(43775),
              u = new Fe(16777215),
              c = new Fe(3355443);
            function d(e, t, n) {
              h(e, n), h(t, n);
            }
            function h(e, t) {
              r.push(0, 0, 0), i.push(t.r, t.g, t.b), void 0 === o[e] && (o[e] = []), o[e].push(r.length / 3 - 1);
            }
            d("n1", "n2", a), d("n2", "n4", a), d("n4", "n3", a), d("n3", "n1", a), d("f1", "f2", a), d("f2", "f4", a), d("f4", "f3", a), d("f3", "f1", a), d("n1", "f1", a), d("n2", "f2", a), d("n3", "f3", a), d("n4", "f4", a), d("p", "n1", s), d("p", "n2", s), d("p", "n3", s), d("p", "n4", s), d("u1", "u2", l), d("u2", "u3", l), d("u3", "u1", l), d("c", "t", u), d("p", "c", c), d("cn1", "cn2", c), d("cn3", "cn4", c), d("cf1", "cf2", c), d("cf3", "cf4", c), t.addAttribute("position", new jt(r, 3)), t.addAttribute("color", new jt(i, 3)), zi.call(this, t, n), this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = o, this.update();
          }
          function mu(e, t) {
            this.object = e, void 0 === t && (t = 16776960);
            var n = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
              r = new Float32Array(24),
              i = new Yt();
            i.setIndex(new Tt(n, 1)), i.addAttribute("position", new Tt(r, 3)), zi.call(this, i, new Bi({
              color: t
            })), this.matrixAutoUpdate = !1, this.update();
          }
          function gu(e, t) {
            this.type = "Box3Helper", this.box = e;
            var n = void 0 !== t ? t : 16776960,
              r = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
              i = new Yt();
            i.setIndex(new Tt(r, 1)), i.addAttribute("position", new jt([1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1], 3)), zi.call(this, i, new Bi({
              color: n
            })), this.geometry.computeBoundingSphere();
          }
          function vu(e, t, n) {
            this.type = "PlaneHelper", this.plane = e, this.size = void 0 === t ? 1 : t;
            var r = void 0 !== n ? n : 16776960,
              i = new Yt();
            i.addAttribute("position", new jt([1, -1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0], 3)), i.computeBoundingSphere(), Fi.call(this, i, new Bi({
              color: r
            }));
            var o = new Yt();
            o.addAttribute("position", new jt([1, 1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, 1, -1, 1], 3)), o.computeBoundingSphere(), this.add(new On(o, new Mn({
              color: r,
              opacity: .2,
              transparent: !0,
              depthWrite: !1
            })));
          }
          function yu(e, t, n, r, i, o) {
            ft.call(this), void 0 === r && (r = 16776960), void 0 === n && (n = 1), void 0 === i && (i = .2 * n), void 0 === o && (o = .2 * i), void 0 === Fl && ((Fl = new Yt()).addAttribute("position", new jt([0, 0, 0, 0, 1, 0], 3)), (zl = new ea(0, .5, 1, 5, 1)).translate(0, -.5, 0)), this.position.copy(t), this.line = new Fi(Fl, new Bi({
              color: r
            })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new On(zl, new Mn({
              color: r
            })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(e), this.setLength(n, i, o);
          }
          function bu(e) {
            var t = [0, 0, 0, e = e || 1, 0, 0, 0, 0, 0, 0, e, 0, 0, 0, 0, 0, 0, e],
              n = new Yt();
            n.addAttribute("position", new jt(t, 3)), n.addAttribute("color", new jt([1, 0, 0, 1, .6, 0, 0, 1, 0, .6, 1, 0, 0, 0, 1, 0, .6, 1], 3));
            var r = new Bi({
              vertexColors: 2
            });
            zi.call(this, n, r);
          }
          function _u(e) {
            console.warn("THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead."), Ra.call(this, e), this.type = "catmullrom";
          }
          function xu(e) {
            if ("undefined" != typeof window) {
              var t = new RegExp(e + "=([^&#=]*)").exec(window.location.search);
              return t ? decodeURIComponent(t[1]) : void 0;
            }
          }
          function wu(e, t) {
            return void 0 !== e ? e : t;
          }
          function Su(e, t) {
            var n = Object.assign({}, e);
            for (var r in t) void 0 === e[r] && (n[r] = t[r]);
            return n;
          }
          function Au(e, t) {
            for (var n in t) {
              var r = t[n];
              void 0 !== r && (e[n] = r);
            }
            return e;
          }
          function Eu() {
            var e = window.location.protocol;
            return null === e.match(/http(s)?:/gi) ? "http:" : e;
          }
          function Tu() {
            if ("undefined" == typeof window) return !1;
            var e = window.navigator.userAgent;
            return /Opera|OPR/.test(e) ? "Opera" : /Chrome/i.test(e) ? "Chrome" : /Firefox/i.test(e) ? "Firefox" : /Mobile(\/.*)? Safari/i.test(e) ? "Mobile Safari" : /MSIE/i.test(e) ? "Internet Explorer" : !!/Safari/i.test(e) && "Safari";
          }
          function Mu(e) {
            window.open(e, "_blank") || (window.location.href = e);
          }
          function Cu(e, t) {
            if (void 0 === t && (t = "download"), e) {
              var n = "Safari" === Tu(),
                r = /CriOS\/[\d]+/.test(window.navigator.userAgent),
                i = document.createElement("a");
              if ("undefined" != typeof navigator && navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(e, t);else if ((n || r) && FileReader) {
                if (e instanceof Blob) {
                  var o = new FileReader();
                  o.onloadend = function () {
                    s(o.result);
                  }, o.readAsDataURL(e);
                } else s(e);
              } else {
                var a = !1;
                e instanceof Blob && (e = URL.createObjectURL(e), a = !0), "download" in i ? (i.style.display = "hidden", document.body.appendChild(i), i.href = e, i.download = t, i.target = "_blank", i.click(), document.body.removeChild(i)) : Mu(e), a && window.URL.revokeObjectURL(e);
              }
            }
            function s(e) {
              Mu(r ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"));
            }
          }
          function ku(e, t) {
            return e < t ? -1 : t < e ? 1 : 0;
          }
          function Pu(e, t, n) {
            void 0 === n && (n = ku);
            for (var r = 0, i = e.length - 1; r <= i;) {
              var o = r + i >> 1,
                a = n(t, e[o]);
              if (0 < a) r = o + 1;else {
                if (!(a < 0)) return o;
                i = o - 1;
              }
            }
            return -r - 1;
          }
          function Ou(e, t, n) {
            var r = function (e, t) {
                var n = e.length - 1;
                if (e[n] < t) return -1;
                for (var r = 0; r <= n;) {
                  var i = r + n >> 1;
                  e[i] >= t ? n = i - 1 : r = i + 1;
                }
                return n + 1;
              }(e, t),
              i = function (e, t) {
                if (e[0] > t) return -1;
                for (var n = 0, r = e.length - 1; n <= r;) {
                  var i = n + r >> 1;
                  e[i] > t ? r = i - 1 : n = i + 1;
                }
                return n - 1;
              }(e, n);
            return -1 === r || -1 === i || i < r ? 0 : i - r + 1;
          }
          function Ru(e) {
            return e.sort().filter(function (e, t, n) {
              return 0 === t || e !== n[t - 1];
            });
          }
          function Iu(e) {
            if (28672 < e.length) {
              for (var t = [], n = 0; n < e.length; n += 28672) t.push(String.fromCharCode.apply(null, e.subarray(n, n + 28672)));
              return t.join("");
            }
            return String.fromCharCode.apply(null, e);
          }
          function ju(e, t) {
            switch (e) {
              case "int8":
                return new Int8Array(t);
              case "int16":
                return new Int16Array(t);
              case "int32":
                return new Int32Array(t);
              case "uint8":
                return new Uint8Array(t);
              case "uint16":
                return new Uint16Array(t);
              case "uint32":
                return new Uint32Array(t);
              case "float32":
                return new Float32Array(t);
              default:
                throw new Error("arrayType unknown: " + e);
            }
          }
          function Nu(e, t) {
            return new (65535 < t ? Uint32Array : Uint16Array)(e);
          }
          function Lu(e) {
            return e.buffer && e.buffer instanceof ArrayBuffer ? e.buffer : e;
          }
          function Du(e, t) {
            return void 0 === e ? e = new t() : Array.isArray(e) && (e = new t().fromArray(e)), e;
          }
          function Bu(e) {
            return Du(e, ae);
          }
          function Fu(e) {
            return Du(e, ie);
          }
          function zu(e) {
            return Du(e, oe);
          }
          function Uu(e) {
            return (t = e) instanceof (n = Float32Array) ? t : new n(t);
            var t, n;
          }
          function Gu(e) {
            return wu(e, "").toString().toLowerCase();
          }
          Object.assign(ql.prototype, {
            getValue: function getValue(e, t) {
              this.bind();
              var n = this._targetGroup.nCachedObjects_,
                r = this._bindings[n];
              void 0 !== r && r.getValue(e, t);
            },
            setValue: function setValue(e, t) {
              for (var n = this._bindings, r = this._targetGroup.nCachedObjects_, i = n.length; r !== i; ++r) n[r].setValue(e, t);
            },
            bind: function bind() {
              for (var e = this._bindings, t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) e[t].bind();
            },
            unbind: function unbind() {
              for (var e = this._bindings, t = this._targetGroup.nCachedObjects_, n = e.length; t !== n; ++t) e[t].unbind();
            }
          }), Object.assign(Wl, {
            Composite: ql,
            create: function create(e, t, n) {
              return e && e.isAnimationObjectGroup ? new Wl.Composite(e, t, n) : new Wl(e, t, n);
            },
            sanitizeNodeName: (gl = new RegExp("[" + Hl + "]", "g"), function (e) {
              return e.replace(/\s/g, "_").replace(gl, "");
            }),
            parseTrackName: (ll = "[^" + Hl + "]", ul = "[^" + Hl.replace("\\.", "") + "]", cl = /((?:WC+[\/:])*)/.source.replace("WC", ll), dl = /(WCOD+)?/.source.replace("WCOD", ul), hl = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", ll), fl = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", ll), pl = new RegExp("^" + cl + dl + hl + fl + "$"), ml = ["material", "materials", "bones"], function (e) {
              var t = pl.exec(e);
              if (!t) throw new Error("PropertyBinding: Cannot parse trackName: " + e);
              var n = {
                  nodeName: t[2],
                  objectName: t[3],
                  objectIndex: t[4],
                  propertyName: t[5],
                  propertyIndex: t[6]
                },
                r = n.nodeName && n.nodeName.lastIndexOf(".");
              if (void 0 !== r && -1 !== r) {
                var i = n.nodeName.substring(r + 1);
                -1 !== ml.indexOf(i) && (n.nodeName = n.nodeName.substring(0, r), n.objectName = i);
              }
              if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
              return n;
            }),
            findNode: function findNode(e, t) {
              if (!t || "" === t || "root" === t || "." === t || -1 === t || t === e.name || t === e.uuid) return e;
              if (e.skeleton) {
                var n = e.skeleton.getBoneByName(t);
                if (void 0 !== n) return n;
              }
              if (e.children) {
                var r = function r(e) {
                    for (var n = 0; n < e.length; n++) {
                      var i = e[n];
                      if (i.name === t || i.uuid === t) return i;
                      var o = r(i.children);
                      if (o) return o;
                    }
                    return null;
                  },
                  i = r(e.children);
                if (i) return i;
              }
              return null;
            }
          }), Object.assign(Wl.prototype, {
            _getValue_unavailable: function _getValue_unavailable() {},
            _setValue_unavailable: function _setValue_unavailable() {},
            BindingType: {
              Direct: 0,
              EntireArray: 1,
              ArrayElement: 2,
              HasFromToArray: 3
            },
            Versioning: {
              None: 0,
              NeedsUpdate: 1,
              MatrixWorldNeedsUpdate: 2
            },
            GetterByBindingType: [function (e, t) {
              e[t] = this.node[this.propertyName];
            }, function (e, t) {
              for (var n = this.resolvedProperty, r = 0, i = n.length; r !== i; ++r) e[t++] = n[r];
            }, function (e, t) {
              e[t] = this.resolvedProperty[this.propertyIndex];
            }, function (e, t) {
              this.resolvedProperty.toArray(e, t);
            }],
            SetterByBindingTypeAndVersioning: [[function (e, t) {
              this.targetObject[this.propertyName] = e[t];
            }, function (e, t) {
              this.targetObject[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
            }, function (e, t) {
              this.targetObject[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
            }], [function (e, t) {
              for (var n = this.resolvedProperty, r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
            }, function (e, t) {
              for (var n = this.resolvedProperty, r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
              this.targetObject.needsUpdate = !0;
            }, function (e, t) {
              for (var n = this.resolvedProperty, r = 0, i = n.length; r !== i; ++r) n[r] = e[t++];
              this.targetObject.matrixWorldNeedsUpdate = !0;
            }], [function (e, t) {
              this.resolvedProperty[this.propertyIndex] = e[t];
            }, function (e, t) {
              this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
            }, function (e, t) {
              this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
            }], [function (e, t) {
              this.resolvedProperty.fromArray(e, t);
            }, function (e, t) {
              this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
            }, function (e, t) {
              this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
            }]],
            getValue: function getValue(e, t) {
              this.bind(), this.getValue(e, t);
            },
            setValue: function setValue(e, t) {
              this.bind(), this.setValue(e, t);
            },
            bind: function bind() {
              var e = this.node,
                t = this.parsedPath,
                n = t.objectName,
                r = t.propertyName,
                i = t.propertyIndex;
              if (e || (e = Wl.findNode(this.rootNode, t.nodeName) || this.rootNode, this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, e) {
                if (n) {
                  var o = t.objectIndex;
                  switch (n) {
                    case "materials":
                      if (!e.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                      if (!e.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                      e = e.material.materials;
                      break;
                    case "bones":
                      if (!e.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                      e = e.skeleton.bones;
                      for (var a = 0; a < e.length; a++) if (e[a].name === o) {
                        o = a;
                        break;
                      }
                      break;
                    default:
                      if (void 0 === e[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                      e = e[n];
                  }
                  if (void 0 !== o) {
                    if (void 0 === e[o]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e);
                    e = e[o];
                  }
                }
                var s = e[r];
                if (void 0 !== s) {
                  var l = this.Versioning.None;
                  void 0 !== e.needsUpdate ? (l = this.Versioning.NeedsUpdate, this.targetObject = e) : void 0 !== e.matrixWorldNeedsUpdate && (l = this.Versioning.MatrixWorldNeedsUpdate, this.targetObject = e);
                  var u = this.BindingType.Direct;
                  if (void 0 !== i) {
                    if ("morphTargetInfluences" === r) {
                      if (!e.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                      if (e.geometry.isBufferGeometry) {
                        if (!e.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        for (a = 0; a < this.node.geometry.morphAttributes.position.length; a++) if (e.geometry.morphAttributes.position[a].name === i) {
                          i = a;
                          break;
                        }
                      } else {
                        if (!e.geometry.morphTargets) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphTargets.", this);
                        for (a = 0; a < this.node.geometry.morphTargets.length; a++) if (e.geometry.morphTargets[a].name === i) {
                          i = a;
                          break;
                        }
                      }
                    }
                    u = this.BindingType.ArrayElement, this.resolvedProperty = s, this.propertyIndex = i;
                  } else void 0 !== s.fromArray && void 0 !== s.toArray ? (u = this.BindingType.HasFromToArray, this.resolvedProperty = s) : Array.isArray(s) ? (u = this.BindingType.EntireArray, this.resolvedProperty = s) : this.propertyName = r;
                  this.getValue = this.GetterByBindingType[u], this.setValue = this.SetterByBindingTypeAndVersioning[u][l];
                } else {
                  var c = t.nodeName;
                  console.error("THREE.PropertyBinding: Trying to update property for track: " + c + "." + r + " but it wasn't found.", e);
                }
              } else console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            },
            unbind: function unbind() {
              this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
          }), Object.assign(Wl.prototype, {
            _getValue_unbound: Wl.prototype.getValue,
            _setValue_unbound: Wl.prototype.setValue
          }), Object.assign(function () {
            var e = arguments;
            this.uuid = ne.generateUUID(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
            var t = {};
            this._indicesByUUID = t;
            for (var n = 0, r = arguments.length; n !== r; ++n) t[e[n].uuid] = n;
            this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
            var i = this;
            this.stats = {
              objects: {
                get total() {
                  return i._objects.length;
                },
                get inUse() {
                  return this.total - i.nCachedObjects_;
                }
              },
              get bindingsPerObject() {
                return i._bindings.length;
              }
            };
          }.prototype, {
            isAnimationObjectGroup: !0,
            add: function add() {
              for (var e = arguments, t = this._objects, n = t.length, r = this.nCachedObjects_, i = this._indicesByUUID, o = this._paths, a = this._parsedPaths, s = this._bindings, l = s.length, u = void 0, c = 0, d = arguments.length; c !== d; ++c) {
                var h = e[c],
                  f = h.uuid,
                  p = i[f];
                if (void 0 === p) {
                  p = n++, i[f] = p, t.push(h);
                  for (var m = 0, g = l; m !== g; ++m) s[m].push(new Wl(h, o[m], a[m]));
                } else if (p < r) {
                  u = t[p];
                  var v = --r,
                    y = t[v];
                  for (t[i[y.uuid] = p] = y, t[i[f] = v] = h, m = 0, g = l; m !== g; ++m) {
                    var b = s[m],
                      _ = b[v],
                      x = b[p];
                    b[p] = _, void 0 === x && (x = new Wl(h, o[m], a[m])), b[v] = x;
                  }
                } else t[p] !== u && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
              }
              this.nCachedObjects_ = r;
            },
            remove: function remove() {
              for (var e = arguments, t = this._objects, n = this.nCachedObjects_, r = this._indicesByUUID, i = this._bindings, o = i.length, a = 0, s = arguments.length; a !== s; ++a) {
                var l = e[a],
                  u = l.uuid,
                  c = r[u];
                if (void 0 !== c && n <= c) {
                  var d = n++,
                    h = t[d];
                  t[r[h.uuid] = c] = h, t[r[u] = d] = l;
                  for (var f = 0, p = o; f !== p; ++f) {
                    var m = i[f],
                      g = m[d],
                      v = m[c];
                    m[c] = g, m[d] = v;
                  }
                }
              }
              this.nCachedObjects_ = n;
            },
            uncache: function uncache() {
              for (var e = arguments, t = this._objects, n = t.length, r = this.nCachedObjects_, i = this._indicesByUUID, o = this._bindings, a = o.length, s = 0, l = arguments.length; s !== l; ++s) {
                var u = e[s].uuid,
                  c = i[u];
                if (void 0 !== c) if (delete i[u], c < r) {
                  var d = --r,
                    h = t[d],
                    f = t[y = --n];
                  t[i[h.uuid] = c] = h, t[i[f.uuid] = d] = f, t.pop();
                  for (var p = 0, m = a; p !== m; ++p) {
                    var g = (b = o[p])[d],
                      v = b[y];
                    b[c] = g, b[d] = v, b.pop();
                  }
                } else {
                  var y;
                  for (t[i[(f = t[y = --n]).uuid] = c] = f, t.pop(), p = 0, m = a; p !== m; ++p) {
                    var b;
                    (b = o[p])[c] = b[y], b.pop();
                  }
                }
              }
              this.nCachedObjects_ = r;
            },
            subscribe_: function subscribe_(e, t) {
              var n = this._bindingsIndicesByPath,
                r = n[e],
                i = this._bindings;
              if (void 0 !== r) return i[r];
              var o = this._paths,
                a = this._parsedPaths,
                s = this._objects,
                l = s.length,
                u = this.nCachedObjects_,
                c = new Array(l);
              r = i.length, n[e] = r, o.push(e), a.push(t), i.push(c);
              for (var d = u, h = s.length; d !== h; ++d) {
                var f = s[d];
                c[d] = new Wl(f, e, t);
              }
              return c;
            },
            unsubscribe_: function unsubscribe_(e) {
              var t = this._bindingsIndicesByPath,
                n = t[e];
              if (void 0 !== n) {
                var r = this._paths,
                  i = this._parsedPaths,
                  o = this._bindings,
                  a = o.length - 1,
                  s = o[a];
                o[t[e[a]] = n] = s, o.pop(), i[n] = i[a], i.pop(), r[n] = r[a], r.pop();
              }
            }
          }), Object.assign($l.prototype, {
            play: function play() {
              return this._mixer._activateAction(this), this;
            },
            stop: function stop() {
              return this._mixer._deactivateAction(this), this.reset();
            },
            reset: function reset() {
              return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
            },
            isRunning: function isRunning() {
              return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
            },
            isScheduled: function isScheduled() {
              return this._mixer._isActiveAction(this);
            },
            startAt: function startAt(e) {
              return this._startTime = e, this;
            },
            setLoop: function setLoop(e, t) {
              return this.loop = e, this.repetitions = t, this;
            },
            setEffectiveWeight: function setEffectiveWeight(e) {
              return this.weight = e, this._effectiveWeight = this.enabled ? e : 0, this.stopFading();
            },
            getEffectiveWeight: function getEffectiveWeight() {
              return this._effectiveWeight;
            },
            fadeIn: function fadeIn(e) {
              return this._scheduleFading(e, 0, 1);
            },
            fadeOut: function fadeOut(e) {
              return this._scheduleFading(e, 1, 0);
            },
            crossFadeFrom: function crossFadeFrom(e, t, n) {
              if (e.fadeOut(t), this.fadeIn(t), n) {
                var r = this._clip.duration,
                  i = e._clip.duration,
                  o = i / r,
                  a = r / i;
                e.warp(1, o, t), this.warp(a, 1, t);
              }
              return this;
            },
            crossFadeTo: function crossFadeTo(e, t, n) {
              return e.crossFadeFrom(this, t, n);
            },
            stopFading: function stopFading() {
              var e = this._weightInterpolant;
              return null !== e && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
            },
            setEffectiveTimeScale: function setEffectiveTimeScale(e) {
              return this.timeScale = e, this._effectiveTimeScale = this.paused ? 0 : e, this.stopWarping();
            },
            getEffectiveTimeScale: function getEffectiveTimeScale() {
              return this._effectiveTimeScale;
            },
            setDuration: function setDuration(e) {
              return this.timeScale = this._clip.duration / e, this.stopWarping();
            },
            syncWith: function syncWith(e) {
              return this.time = e.time, this.timeScale = e.timeScale, this.stopWarping();
            },
            halt: function halt(e) {
              return this.warp(this._effectiveTimeScale, 0, e);
            },
            warp: function warp(e, t, n) {
              var r = this._mixer,
                i = r.time,
                o = this._timeScaleInterpolant,
                a = this.timeScale;
              null === o && (o = r._lendControlInterpolant(), this._timeScaleInterpolant = o);
              var s = o.parameterPositions,
                l = o.sampleValues;
              return s[0] = i, s[1] = i + n, l[0] = e / a, l[1] = t / a, this;
            },
            stopWarping: function stopWarping() {
              var e = this._timeScaleInterpolant;
              return null !== e && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
            },
            getMixer: function getMixer() {
              return this._mixer;
            },
            getClip: function getClip() {
              return this._clip;
            },
            getRoot: function getRoot() {
              return this._localRoot || this._mixer._root;
            },
            _update: function _update(e, t, n, r) {
              if (this.enabled) {
                var i = this._startTime;
                if (null !== i) {
                  var o = (e - i) * n;
                  if (o < 0 || 0 === n) return;
                  this._startTime = null, t = n * o;
                }
                t *= this._updateTimeScale(e);
                var a = this._updateTime(t),
                  s = this._updateWeight(e);
                if (0 < s) for (var l = this._interpolants, u = this._propertyBindings, c = 0, d = l.length; c !== d; ++c) l[c].evaluate(a), u[c].accumulate(r, s);
              } else this._updateWeight(e);
            },
            _updateWeight: function _updateWeight(e) {
              var t = 0;
              if (this.enabled) {
                t = this.weight;
                var n = this._weightInterpolant;
                if (null !== n) {
                  var r = n.evaluate(e)[0];
                  t *= r, e > n.parameterPositions[1] && (this.stopFading(), 0 === r && (this.enabled = !1));
                }
              }
              return this._effectiveWeight = t;
            },
            _updateTimeScale: function _updateTimeScale(e) {
              var t = 0;
              if (!this.paused) {
                t = this.timeScale;
                var n = this._timeScaleInterpolant;
                null !== n && (t *= n.evaluate(e)[0], e > n.parameterPositions[1] && (this.stopWarping(), 0 === t ? this.paused = !0 : this.timeScale = t));
              }
              return this._effectiveTimeScale = t;
            },
            _updateTime: function _updateTime(e) {
              var t = this.time + e,
                n = this._clip.duration,
                r = this.loop,
                i = this._loopCount,
                o = 2202 === r;
              if (0 === e) return -1 === i ? t : o && 1 == (1 & i) ? n - t : t;
              if (2200 === r) {
                -1 === i && (this._loopCount = 0, this._setEndings(!0, !0, !1));
                e: {
                  if (n <= t) t = n;else {
                    if (!(t < 0)) break e;
                    t = 0;
                  }
                  this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: e < 0 ? -1 : 1
                  });
                }
              } else {
                if (-1 === i && (0 <= e ? (i = 0, this._setEndings(!0, 0 === this.repetitions, o)) : this._setEndings(0 === this.repetitions, !0, o)), n <= t || t < 0) {
                  var a = Math.floor(t / n);
                  t -= n * a, i += Math.abs(a);
                  var s = this.repetitions - i;
                  if (s <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, t = 0 < e ? n : 0, this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: 0 < e ? 1 : -1
                  });else {
                    if (1 === s) {
                      var l = e < 0;
                      this._setEndings(l, !l, o);
                    } else this._setEndings(!1, !1, o);
                    this._loopCount = i, this._mixer.dispatchEvent({
                      type: "loop",
                      action: this,
                      loopDelta: a
                    });
                  }
                }
                if (o && 1 == (1 & i)) return n - (this.time = t);
              }
              return this.time = t;
            },
            _setEndings: function _setEndings(e, t, n) {
              var r = this._interpolantSettings;
              n ? (r.endingStart = te, r.endingEnd = te) : (r.endingStart = e ? this.zeroSlopeAtStart ? te : ee : 2402, r.endingEnd = t ? this.zeroSlopeAtEnd ? te : ee : 2402);
            },
            _scheduleFading: function _scheduleFading(e, t, n) {
              var r = this._mixer,
                i = r.time,
                o = this._weightInterpolant;
              null === o && (o = r._lendControlInterpolant(), this._weightInterpolant = o);
              var a = o.parameterPositions,
                s = o.sampleValues;
              return a[0] = i, s[0] = t, a[1] = i + e, s[1] = n, this;
            }
          }), Xl.prototype = Object.assign(Object.create(_.prototype), {
            constructor: Xl,
            _bindAction: function _bindAction(e, t) {
              var n = e._localRoot || this._root,
                r = e._clip.tracks,
                i = r.length,
                o = e._propertyBindings,
                a = e._interpolants,
                s = n.uuid,
                l = this._bindingsByRootAndName,
                u = l[s];
              void 0 === u && (u = {}, l[s] = u);
              for (var c = 0; c !== i; ++c) {
                var d = r[c],
                  h = d.name,
                  f = u[h];
                if (void 0 !== f) o[c] = f;else {
                  if (void 0 !== (f = o[c])) {
                    null === f._cacheIndex && (++f.referenceCount, this._addInactiveBinding(f, s, h));
                    continue;
                  }
                  var p = t && t._propertyBindings[c].binding.parsedPath;
                  ++(f = new sl(Wl.create(n, h, p), d.ValueTypeName, d.getValueSize())).referenceCount, this._addInactiveBinding(f, s, h), o[c] = f;
                }
                a[c].resultBuffer = f.buffer;
              }
            },
            _activateAction: function _activateAction(e) {
              if (!this._isActiveAction(e)) {
                if (null === e._cacheIndex) {
                  var t = (e._localRoot || this._root).uuid,
                    n = e._clip.uuid,
                    r = this._actionsByClip[n];
                  this._bindAction(e, r && r.knownActions[0]), this._addInactiveAction(e, n, t);
                }
                for (var i = e._propertyBindings, o = 0, a = i.length; o !== a; ++o) {
                  var s = i[o];
                  0 == s.useCount++ && (this._lendBinding(s), s.saveOriginalState());
                }
                this._lendAction(e);
              }
            },
            _deactivateAction: function _deactivateAction(e) {
              if (this._isActiveAction(e)) {
                for (var t = e._propertyBindings, n = 0, r = t.length; n !== r; ++n) {
                  var i = t[n];
                  0 == --i.useCount && (i.restoreOriginalState(), this._takeBackBinding(i));
                }
                this._takeBackAction(e);
              }
            },
            _initMemoryManager: function _initMemoryManager() {
              this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
              var e = this;
              this.stats = {
                actions: {
                  get total() {
                    return e._actions.length;
                  },
                  get inUse() {
                    return e._nActiveActions;
                  }
                },
                bindings: {
                  get total() {
                    return e._bindings.length;
                  },
                  get inUse() {
                    return e._nActiveBindings;
                  }
                },
                controlInterpolants: {
                  get total() {
                    return e._controlInterpolants.length;
                  },
                  get inUse() {
                    return e._nActiveControlInterpolants;
                  }
                }
              };
            },
            _isActiveAction: function _isActiveAction(e) {
              var t = e._cacheIndex;
              return null !== t && t < this._nActiveActions;
            },
            _addInactiveAction: function _addInactiveAction(e, t, n) {
              var r = this._actions,
                i = this._actionsByClip,
                o = i[t];
              if (void 0 === o) o = {
                knownActions: [e],
                actionByRoot: {}
              }, e._byClipCacheIndex = 0, i[t] = o;else {
                var a = o.knownActions;
                e._byClipCacheIndex = a.length, a.push(e);
              }
              e._cacheIndex = r.length, r.push(e), o.actionByRoot[n] = e;
            },
            _removeInactiveAction: function _removeInactiveAction(e) {
              var t = this._actions,
                n = t[t.length - 1],
                r = e._cacheIndex;
              t[n._cacheIndex = r] = n, t.pop(), e._cacheIndex = null;
              var i = e._clip.uuid,
                o = this._actionsByClip,
                a = o[i],
                s = a.knownActions,
                l = s[s.length - 1],
                u = e._byClipCacheIndex;
              s[l._byClipCacheIndex = u] = l, s.pop(), e._byClipCacheIndex = null, delete a.actionByRoot[(e._localRoot || this._root).uuid], 0 === s.length && delete o[i], this._removeInactiveBindingsForAction(e);
            },
            _removeInactiveBindingsForAction: function _removeInactiveBindingsForAction(e) {
              for (var t = e._propertyBindings, n = 0, r = t.length; n !== r; ++n) {
                var i = t[n];
                0 == --i.referenceCount && this._removeInactiveBinding(i);
              }
            },
            _lendAction: function _lendAction(e) {
              var t = this._actions,
                n = e._cacheIndex,
                r = this._nActiveActions++,
                i = t[r];
              t[e._cacheIndex = r] = e, t[i._cacheIndex = n] = i;
            },
            _takeBackAction: function _takeBackAction(e) {
              var t = this._actions,
                n = e._cacheIndex,
                r = --this._nActiveActions,
                i = t[r];
              t[e._cacheIndex = r] = e, t[i._cacheIndex = n] = i;
            },
            _addInactiveBinding: function _addInactiveBinding(e, t, n) {
              var r = this._bindingsByRootAndName,
                i = r[t],
                o = this._bindings;
              void 0 === i && (i = {}, r[t] = i), (i[n] = e)._cacheIndex = o.length, o.push(e);
            },
            _removeInactiveBinding: function _removeInactiveBinding(e) {
              var t = this._bindings,
                n = e.binding,
                r = n.rootNode.uuid,
                i = n.path,
                o = this._bindingsByRootAndName,
                a = o[r],
                s = t[t.length - 1],
                l = e._cacheIndex;
              t[s._cacheIndex = l] = s, t.pop(), delete a[i];
              e: {
                for (var u in a) break e;
                delete o[r];
              }
            },
            _lendBinding: function _lendBinding(e) {
              var t = this._bindings,
                n = e._cacheIndex,
                r = this._nActiveBindings++,
                i = t[r];
              t[e._cacheIndex = r] = e, t[i._cacheIndex = n] = i;
            },
            _takeBackBinding: function _takeBackBinding(e) {
              var t = this._bindings,
                n = e._cacheIndex,
                r = --this._nActiveBindings,
                i = t[r];
              t[e._cacheIndex = r] = e, t[i._cacheIndex = n] = i;
            },
            _lendControlInterpolant: function _lendControlInterpolant() {
              var e = this._controlInterpolants,
                t = this._nActiveControlInterpolants++,
                n = e[t];
              return void 0 === n && (e[(n = new as(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer)).__cacheIndex = t] = n), n;
            },
            _takeBackControlInterpolant: function _takeBackControlInterpolant(e) {
              var t = this._controlInterpolants,
                n = e.__cacheIndex,
                r = --this._nActiveControlInterpolants,
                i = t[r];
              t[e.__cacheIndex = r] = e, t[i.__cacheIndex = n] = i;
            },
            _controlInterpolantsResultBuffer: new Float32Array(1),
            clipAction: function clipAction(e, t) {
              var n = t || this._root,
                r = n.uuid,
                i = "string" == typeof e ? gs.findByName(n, e) : e,
                o = null !== i ? i.uuid : e,
                a = this._actionsByClip[o],
                s = null;
              if (void 0 !== a) {
                var l = a.actionByRoot[r];
                if (void 0 !== l) return l;
                s = a.knownActions[0], null === i && (i = s._clip);
              }
              if (null === i) return null;
              var u = new $l(this, i, t);
              return this._bindAction(u, s), this._addInactiveAction(u, o, r), u;
            },
            existingAction: function existingAction(e, t) {
              var n = t || this._root,
                r = n.uuid,
                i = "string" == typeof e ? gs.findByName(n, e) : e,
                o = i ? i.uuid : e,
                a = this._actionsByClip[o];
              return void 0 !== a && a.actionByRoot[r] || null;
            },
            stopAllAction: function stopAllAction() {
              var e = this._actions,
                t = this._nActiveActions,
                n = this._bindings,
                r = this._nActiveBindings;
              this._nActiveActions = 0;
              for (var i = this._nActiveBindings = 0; i !== t; ++i) e[i].reset();
              for (i = 0; i !== r; ++i) n[i].useCount = 0;
              return this;
            },
            update: function update(e) {
              e *= this.timeScale;
              for (var t = this._actions, n = this._nActiveActions, r = this.time += e, i = Math.sign(e), o = this._accuIndex ^= 1, a = 0; a !== n; ++a) t[a]._update(r, e, i, o);
              var s = this._bindings,
                l = this._nActiveBindings;
              for (a = 0; a !== l; ++a) s[a].apply(o);
              return this;
            },
            getRoot: function getRoot() {
              return this._root;
            },
            uncacheClip: function uncacheClip(e) {
              var t = this._actions,
                n = e.uuid,
                r = this._actionsByClip,
                i = r[n];
              if (void 0 !== i) {
                for (var o = i.knownActions, a = 0, s = o.length; a !== s; ++a) {
                  var l = o[a];
                  this._deactivateAction(l);
                  var u = l._cacheIndex,
                    c = t[t.length - 1];
                  l._cacheIndex = null, l._byClipCacheIndex = null, t[c._cacheIndex = u] = c, t.pop(), this._removeInactiveBindingsForAction(l);
                }
                delete r[n];
              }
            },
            uncacheRoot: function uncacheRoot(e) {
              var t = e.uuid,
                n = this._actionsByClip;
              for (var r in n) {
                var i = n[r].actionByRoot[t];
                void 0 !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
              }
              var o = this._bindingsByRootAndName[t];
              if (void 0 !== o) for (var a in o) {
                var s = o[a];
                s.restoreOriginalState(), this._removeInactiveBinding(s);
              }
            },
            uncacheAction: function uncacheAction(e, t) {
              var n = this.existingAction(e, t);
              null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
            }
          }), Yl.prototype.clone = function () {
            return new Yl(void 0 === this.value.clone ? this.value : this.value.clone());
          }, Kl.prototype = Object.assign(Object.create(Yt.prototype), {
            constructor: Kl,
            isInstancedBufferGeometry: !0,
            copy: function copy(e) {
              return Yt.prototype.copy.call(this, e), this.maxInstancedCount = e.maxInstancedCount, this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            }
          }), Zl.prototype = Object.assign(Object.create(Pi.prototype), {
            constructor: Zl,
            isInstancedInterleavedBuffer: !0,
            copy: function copy(e) {
              return Pi.prototype.copy.call(this, e), this.meshPerAttribute = e.meshPerAttribute, this;
            }
          }), Ql.prototype = Object.assign(Object.create(Tt.prototype), {
            constructor: Ql,
            isInstancedBufferAttribute: !0,
            copy: function copy(e) {
              return Tt.prototype.copy.call(this, e), this.meshPerAttribute = e.meshPerAttribute, this;
            }
          }), Object.assign(function (e, t, n, r) {
            this.ray = new kn(e, t), this.near = n || 0, this.far = r || 1 / 0, this.params = {
              Mesh: {},
              Line: {},
              LOD: {},
              Points: {
                threshold: 1
              },
              Sprite: {}
            }, Object.defineProperties(this.params, {
              PointCloud: {
                get: function get() {
                  return console.warn("THREE.Raycaster: params.PointCloud has been renamed to params.Points."), this.Points;
                }
              }
            });
          }.prototype, {
            linePrecision: 1,
            set: function set(e, t) {
              this.ray.set(e, t);
            },
            setFromCamera: function setFromCamera(e, t) {
              t && t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e.x, e.y, .5).unproject(t).sub(this.ray.origin).normalize()) : t && t.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, (t.near + t.far) / (t.near - t.far)).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld)) : console.error("THREE.Raycaster: Unsupported camera type.");
            },
            intersectObject: function intersectObject(e, t, n) {
              var r = n || [];
              return eu(e, this, r, t), r.sort(Jl), r;
            },
            intersectObjects: function intersectObjects(e, t, n) {
              var r = n || [];
              if (!1 === Array.isArray(e)) return console.warn("THREE.Raycaster.intersectObjects: objects is not an Array."), r;
              for (var i = 0, o = e.length; i < o; i++) eu(e[i], this, r, t);
              return r.sort(Jl), r;
            }
          }), Object.assign(function (e) {
            this.autoStart = void 0 === e || e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
          }.prototype, {
            start: function start() {
              this.startTime = ("undefined" == typeof performance ? Date : performance).now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
            },
            stop: function stop() {
              this.getElapsedTime(), this.running = !1, this.autoStart = !1;
            },
            getElapsedTime: function getElapsedTime() {
              return this.getDelta(), this.elapsedTime;
            },
            getDelta: function getDelta() {
              var e = 0;
              if (this.autoStart && !this.running) return this.start(), 0;
              if (this.running) {
                var t = ("undefined" == typeof performance ? Date : performance).now();
                e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
              }
              return e;
            }
          }), Object.assign(function (e, t, n) {
            return this.radius = void 0 !== e ? e : 1, this.phi = void 0 !== t ? t : 0, this.theta = void 0 !== n ? n : 0, this;
          }.prototype, {
            set: function set(e, t, n) {
              return this.radius = e, this.phi = t, this.theta = n, this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
            },
            makeSafe: function makeSafe() {
              return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
            },
            setFromVector3: function setFromVector3(e) {
              return this.radius = e.length(), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e.x, e.z), this.phi = Math.acos(ne.clamp(e.y / this.radius, -1, 1))), this;
            }
          }), Object.assign(function (e, t, n) {
            return this.radius = void 0 !== e ? e : 1, this.theta = void 0 !== t ? t : 0, this.y = void 0 !== n ? n : 0, this;
          }.prototype, {
            set: function set(e, t, n) {
              return this.radius = e, this.theta = t, this.y = n, this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.radius = e.radius, this.theta = e.theta, this.y = e.y, this;
            },
            setFromVector3: function setFromVector3(e) {
              return this.radius = Math.sqrt(e.x * e.x + e.z * e.z), this.theta = Math.atan2(e.x, e.z), this.y = e.y, this;
            }
          }), Object.assign(tu.prototype, {
            set: function set(e, t) {
              return this.min.copy(e), this.max.copy(t), this;
            },
            setFromPoints: function setFromPoints(e) {
              this.makeEmpty();
              for (var t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
              return this;
            },
            setFromCenterAndSize: (yl = new re(), function (e, t) {
              var n = yl.copy(t).multiplyScalar(.5);
              return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
            }),
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.min.copy(e.min), this.max.copy(e.max), this;
            },
            makeEmpty: function makeEmpty() {
              return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
            },
            isEmpty: function isEmpty() {
              return this.max.x < this.min.x || this.max.y < this.min.y;
            },
            getCenter: function getCenter(e) {
              return void 0 === e && (console.warn("THREE.Box2: .getCenter() target is now required"), e = new re()), this.isEmpty() ? e.set(0, 0) : e.addVectors(this.min, this.max).multiplyScalar(.5);
            },
            getSize: function getSize(e) {
              return void 0 === e && (console.warn("THREE.Box2: .getSize() target is now required"), e = new re()), this.isEmpty() ? e.set(0, 0) : e.subVectors(this.max, this.min);
            },
            expandByPoint: function expandByPoint(e) {
              return this.min.min(e), this.max.max(e), this;
            },
            expandByVector: function expandByVector(e) {
              return this.min.sub(e), this.max.add(e), this;
            },
            expandByScalar: function expandByScalar(e) {
              return this.min.addScalar(-e), this.max.addScalar(e), this;
            },
            containsPoint: function containsPoint(e) {
              return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y);
            },
            containsBox: function containsBox(e) {
              return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y;
            },
            getParameter: function getParameter(e, t) {
              return void 0 === t && (console.warn("THREE.Box2: .getParameter() target is now required"), t = new re()), t.set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y));
            },
            intersectsBox: function intersectsBox(e) {
              return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y);
            },
            clampPoint: function clampPoint(e, t) {
              return void 0 === t && (console.warn("THREE.Box2: .clampPoint() target is now required"), t = new re()), t.copy(e).clamp(this.min, this.max);
            },
            distanceToPoint: (vl = new re(), function (e) {
              return vl.copy(e).clamp(this.min, this.max).sub(e).length();
            }),
            intersect: function intersect(e) {
              return this.min.max(e.min), this.max.min(e.max), this;
            },
            union: function union(e) {
              return this.min.min(e.min), this.max.max(e.max), this;
            },
            translate: function translate(e) {
              return this.min.add(e), this.max.add(e), this;
            },
            equals: function equals(e) {
              return e.min.equals(this.min) && e.max.equals(this.max);
            }
          }), Object.assign(nu.prototype, {
            set: function set(e, t) {
              return this.start.copy(e), this.end.copy(t), this;
            },
            clone: function clone() {
              return new this.constructor().copy(this);
            },
            copy: function copy(e) {
              return this.start.copy(e.start), this.end.copy(e.end), this;
            },
            getCenter: function getCenter(e) {
              return void 0 === e && (console.warn("THREE.Line3: .getCenter() target is now required"), e = new ae()), e.addVectors(this.start, this.end).multiplyScalar(.5);
            },
            delta: function delta(e) {
              return void 0 === e && (console.warn("THREE.Line3: .delta() target is now required"), e = new ae()), e.subVectors(this.end, this.start);
            },
            distanceSq: function distanceSq() {
              return this.start.distanceToSquared(this.end);
            },
            distance: function distance() {
              return this.start.distanceTo(this.end);
            },
            at: function at(e, t) {
              return void 0 === t && (console.warn("THREE.Line3: .at() target is now required"), t = new ae()), this.delta(t).multiplyScalar(e).add(this.start);
            },
            closestPointToPointParameter: (bl = new ae(), _l = new ae(), function (e, t) {
              bl.subVectors(e, this.start), _l.subVectors(this.end, this.start);
              var n = _l.dot(_l),
                r = _l.dot(bl) / n;
              return t && (r = ne.clamp(r, 0, 1)), r;
            }),
            closestPointToPoint: function closestPointToPoint(e, t, n) {
              var r = this.closestPointToPointParameter(e, t);
              return void 0 === n && (console.warn("THREE.Line3: .closestPointToPoint() target is now required"), n = new ae()), this.delta(n).multiplyScalar(r).add(this.start);
            },
            applyMatrix4: function applyMatrix4(e) {
              return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this;
            },
            equals: function equals(e) {
              return e.start.equals(this.start) && e.end.equals(this.end);
            }
          }), ((ru.prototype = Object.create(ft.prototype)).constructor = ru).prototype.isImmediateRenderObject = !0, ((iu.prototype = Object.create(zi.prototype)).constructor = iu).prototype.update = (xl = new ae(), wl = new ae(), Sl = new se(), function () {
            var e = ["a", "b", "c"];
            this.object.updateMatrixWorld(!0), Sl.getNormalMatrix(this.object.matrixWorld);
            var t = this.object.matrixWorld,
              n = this.geometry.attributes.position,
              r = this.object.geometry;
            if (r && r.isGeometry) for (var i = r.vertices, o = r.faces, a = 0, s = 0, l = o.length; s < l; s++) for (var u = o[s], c = 0, d = u.vertexNormals.length; c < d; c++) {
              var h = i[u[e[c]]],
                f = u.vertexNormals[c];
              xl.copy(h).applyMatrix4(t), wl.copy(f).applyMatrix3(Sl).normalize().multiplyScalar(this.size).add(xl), n.setXYZ(a, xl.x, xl.y, xl.z), a += 1, n.setXYZ(a, wl.x, wl.y, wl.z), a += 1;
            } else if (r && r.isBufferGeometry) {
              var p = r.attributes.position,
                m = r.attributes.normal;
              for (c = a = 0, d = p.count; c < d; c++) xl.set(p.getX(c), p.getY(c), p.getZ(c)).applyMatrix4(t), wl.set(m.getX(c), m.getY(c), m.getZ(c)), wl.applyMatrix3(Sl).normalize().multiplyScalar(this.size).add(xl), n.setXYZ(a, xl.x, xl.y, xl.z), a += 1, n.setXYZ(a, wl.x, wl.y, wl.z), a += 1;
            }
            n.needsUpdate = !0;
          }), ((ou.prototype = Object.create(ft.prototype)).constructor = ou).prototype.dispose = function () {
            this.cone.geometry.dispose(), this.cone.material.dispose();
          }, ou.prototype.update = (Al = new ae(), El = new ae(), function () {
            this.light.updateMatrixWorld();
            var e = this.light.distance ? this.light.distance : 1e3,
              t = e * Math.tan(this.light.angle);
            this.cone.scale.set(t, t, e), Al.setFromMatrixPosition(this.light.matrixWorld), El.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(El.sub(Al)), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
          }), ((au.prototype = Object.create(zi.prototype)).constructor = au).prototype.updateMatrixWorld = (Tl = new ae(), Ml = new ie(), Cl = new ie(), function (e) {
            var t = this.bones,
              n = this.geometry,
              r = n.getAttribute("position");
            Cl.getInverse(this.root.matrixWorld);
            for (var i = 0, o = 0; i < t.length; i++) {
              var a = t[i];
              a.parent && a.parent.isBone && (Ml.multiplyMatrices(Cl, a.matrixWorld), Tl.setFromMatrixPosition(Ml), r.setXYZ(o, Tl.x, Tl.y, Tl.z), Ml.multiplyMatrices(Cl, a.parent.matrixWorld), Tl.setFromMatrixPosition(Ml), r.setXYZ(o + 1, Tl.x, Tl.y, Tl.z), o += 2);
            }
            n.getAttribute("position").needsUpdate = !0, ft.prototype.updateMatrixWorld.call(this, e);
          }), ((su.prototype = Object.create(On.prototype)).constructor = su).prototype.dispose = function () {
            this.geometry.dispose(), this.material.dispose();
          }, su.prototype.update = function () {
            void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
          }, ((lu.prototype = Object.create(ft.prototype)).constructor = lu).prototype.dispose = function () {
            this.children[0].geometry.dispose(), this.children[0].material.dispose();
          }, lu.prototype.update = function () {
            var e = .5 * this.light.width,
              t = .5 * this.light.height,
              n = this.line.geometry.attributes.position,
              r = n.array;
            r[0] = e, r[1] = -t, r[2] = 0, r[3] = e, r[4] = t, r[5] = 0, r[6] = -e, r[7] = t, r[8] = 0, r[9] = -e, r[10] = -t, r[11] = 0, r[12] = e, r[13] = -t, r[14] = 0, n.needsUpdate = !0, void 0 !== this.color ? this.line.material.color.set(this.color) : this.line.material.color.copy(this.light.color);
          }, ((uu.prototype = Object.create(ft.prototype)).constructor = uu).prototype.dispose = function () {
            this.children[0].geometry.dispose(), this.children[0].material.dispose();
          }, uu.prototype.update = (kl = new ae(), Pl = new Fe(), Ol = new Fe(), function () {
            var e = this.children[0];
            if (void 0 !== this.color) this.material.color.set(this.color);else {
              var t = e.geometry.getAttribute("color");
              Pl.copy(this.light.color), Ol.copy(this.light.groundColor);
              for (var n = 0, r = t.count; n < r; n++) {
                var i = n < r / 2 ? Pl : Ol;
                t.setXYZ(n, i.r, i.g, i.b);
              }
              t.needsUpdate = !0;
            }
            e.lookAt(kl.setFromMatrixPosition(this.light.matrixWorld).negate());
          }), (cu.prototype = Object.create(zi.prototype)).constructor = cu, (du.prototype = Object.create(zi.prototype)).constructor = du, ((hu.prototype = Object.create(zi.prototype)).constructor = hu).prototype.update = (Rl = new ae(), Il = new ae(), jl = new se(), function () {
            this.object.updateMatrixWorld(!0), jl.getNormalMatrix(this.object.matrixWorld);
            for (var e = this.object.matrixWorld, t = this.geometry.attributes.position, n = this.object.geometry, r = n.vertices, i = n.faces, o = 0, a = 0, s = i.length; a < s; a++) {
              var l = i[a],
                u = l.normal;
              Rl.copy(r[l.a]).add(r[l.b]).add(r[l.c]).divideScalar(3).applyMatrix4(e), Il.copy(u).applyMatrix3(jl).normalize().multiplyScalar(this.size).add(Rl), t.setXYZ(o, Rl.x, Rl.y, Rl.z), o += 1, t.setXYZ(o, Il.x, Il.y, Il.z), o += 1;
            }
            t.needsUpdate = !0;
          }), ((fu.prototype = Object.create(ft.prototype)).constructor = fu).prototype.dispose = function () {
            this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
          }, fu.prototype.update = (Nl = new ae(), Ll = new ae(), Dl = new ae(), function () {
            Nl.setFromMatrixPosition(this.light.matrixWorld), Ll.setFromMatrixPosition(this.light.target.matrixWorld), Dl.subVectors(Ll, Nl), this.lightPlane.lookAt(Dl), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(Dl), this.targetLine.scale.z = Dl.length();
          }), ((pu.prototype = Object.create(zi.prototype)).constructor = pu).prototype.update = function () {
            var e,
              t,
              n = new ae(),
              r = new pt();
            function i(i, o, a, s) {
              n.set(o, a, s).unproject(r);
              var l = t[i];
              if (void 0 !== l) for (var u = e.getAttribute("position"), c = 0, d = l.length; c < d; c++) u.setXYZ(l[c], n.x, n.y, n.z);
            }
            return function () {
              e = this.geometry, t = this.pointMap, r.projectionMatrix.copy(this.camera.projectionMatrix), i("c", 0, 0, -1), i("t", 0, 0, 1), i("n1", -1, -1, -1), i("n2", 1, -1, -1), i("n3", -1, 1, -1), i("n4", 1, 1, -1), i("f1", -1, -1, 1), i("f2", 1, -1, 1), i("f3", -1, 1, 1), i("f4", 1, 1, 1), i("u1", .7, 1.1, -1), i("u2", -.7, 1.1, -1), i("u3", 0, 2, -1), i("cf1", -1, 0, 1), i("cf2", 1, 0, 1), i("cf3", 0, -1, 1), i("cf4", 0, 1, 1), i("cn1", -1, 0, -1), i("cn2", 1, 0, -1), i("cn3", 0, -1, -1), i("cn4", 0, 1, -1), e.getAttribute("position").needsUpdate = !0;
            };
          }(), ((mu.prototype = Object.create(zi.prototype)).constructor = mu).prototype.update = (Bl = new Oe(), function (e) {
            if (void 0 !== e && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && Bl.setFromObject(this.object), !Bl.isEmpty()) {
              var t = Bl.min,
                n = Bl.max,
                r = this.geometry.attributes.position,
                i = r.array;
              i[0] = n.x, i[1] = n.y, i[2] = n.z, i[3] = t.x, i[4] = n.y, i[5] = n.z, i[6] = t.x, i[7] = t.y, i[8] = n.z, i[9] = n.x, i[10] = t.y, i[11] = n.z, i[12] = n.x, i[13] = n.y, i[14] = t.z, i[15] = t.x, i[16] = n.y, i[17] = t.z, i[18] = t.x, i[19] = t.y, i[20] = t.z, i[21] = n.x, i[22] = t.y, i[23] = t.z, r.needsUpdate = !0, this.geometry.computeBoundingSphere();
            }
          }), mu.prototype.setFromObject = function (e) {
            return this.object = e, this.update(), this;
          }, ((gu.prototype = Object.create(zi.prototype)).constructor = gu).prototype.updateMatrixWorld = function (e) {
            var t = this.box;
            t.isEmpty() || (t.getCenter(this.position), t.getSize(this.scale), this.scale.multiplyScalar(.5), ft.prototype.updateMatrixWorld.call(this, e));
          }, ((vu.prototype = Object.create(Fi.prototype)).constructor = vu).prototype.updateMatrixWorld = function (e) {
            var t = -this.plane.constant;
            Math.abs(t) < 1e-8 && (t = 1e-8), this.scale.set(.5 * this.size, .5 * this.size, t), this.children[0].material.side = t < 0 ? 1 : 0, this.lookAt(this.plane.normal), ft.prototype.updateMatrixWorld.call(this, e);
          }, ((yu.prototype = Object.create(ft.prototype)).constructor = yu).prototype.setDirection = (Gl = new ae(), function (e) {
            .99999 < e.y ? this.quaternion.set(0, 0, 0, 1) : e.y < -.99999 ? this.quaternion.set(1, 0, 0, 0) : (Gl.set(e.z, 0, -e.x).normalize(), Ul = Math.acos(e.y), this.quaternion.setFromAxisAngle(Gl, Ul));
          }), yu.prototype.setLength = function (e, t, n) {
            void 0 === t && (t = .2 * e), void 0 === n && (n = .2 * t), this.line.scale.set(1, Math.max(0, e - t), 1), this.line.updateMatrix(), this.cone.scale.set(n, t, n), this.cone.position.y = e, this.cone.updateMatrix();
          }, yu.prototype.setColor = function (e) {
            this.line.material.color.copy(e), this.cone.material.color.copy(e);
          }, (bu.prototype = Object.create(zi.prototype)).constructor = bu, Aa.create = function (e, t) {
            return console.log("THREE.Curve.create() has been deprecated"), e.prototype = Object.create(Aa.prototype), (e.prototype.constructor = e).prototype.getPoint = t, e;
          }, Object.assign(Ha.prototype, {
            createPointsGeometry: function createPointsGeometry(e) {
              console.warn("THREE.CurvePath: .createPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.");
              var t = this.getPoints(e);
              return this.createGeometry(t);
            },
            createSpacedPointsGeometry: function createSpacedPointsGeometry(e) {
              console.warn("THREE.CurvePath: .createSpacedPointsGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.");
              var t = this.getSpacedPoints(e);
              return this.createGeometry(t);
            },
            createGeometry: function createGeometry(e) {
              console.warn("THREE.CurvePath: .createGeometry() has been removed. Use new THREE.Geometry().setFromPoints( points ) instead.");
              for (var t = new Et(), n = 0, r = e.length; n < r; n++) {
                var i = e[n];
                t.vertices.push(new ae(i.x, i.y, i.z || 0));
              }
              return t;
            }
          }), Object.assign(qa.prototype, {
            fromPoints: function fromPoints(e) {
              console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints()."), this.setFromPoints(e);
            }
          }), _u.prototype = Object.create(Ra.prototype), Object.assign(_u.prototype, {
            initFromArray: function initFromArray() {
              console.error("THREE.Spline: .initFromArray() has been removed.");
            },
            getControlPointsArray: function getControlPointsArray() {
              console.error("THREE.Spline: .getControlPointsArray() has been removed.");
            },
            reparametrizeByArcLength: function reparametrizeByArcLength() {
              console.error("THREE.Spline: .reparametrizeByArcLength() has been removed.");
            }
          }), cu.prototype.setColors = function () {
            console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
          }, au.prototype.update = function () {
            console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
          }, Object.assign(Es.prototype, {
            extractUrlBase: function extractUrlBase(e) {
              return console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead."), Ts(e);
            }
          }), Object.assign(tu.prototype, {
            center: function center(e) {
              return console.warn("THREE.Box2: .center() has been renamed to .getCenter()."), this.getCenter(e);
            },
            empty: function empty() {
              return console.warn("THREE.Box2: .empty() has been renamed to .isEmpty()."), this.isEmpty();
            },
            isIntersectionBox: function isIntersectionBox(e) {
              return console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(e);
            },
            size: function size(e) {
              return console.warn("THREE.Box2: .size() has been renamed to .getSize()."), this.getSize(e);
            }
          }), Object.assign(Oe.prototype, {
            center: function center(e) {
              return console.warn("THREE.Box3: .center() has been renamed to .getCenter()."), this.getCenter(e);
            },
            empty: function empty() {
              return console.warn("THREE.Box3: .empty() has been renamed to .isEmpty()."), this.isEmpty();
            },
            isIntersectionBox: function isIntersectionBox(e) {
              return console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(e);
            },
            isIntersectionSphere: function isIntersectionSphere(e) {
              return console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(e);
            },
            size: function size(e) {
              return console.warn("THREE.Box3: .size() has been renamed to .getSize()."), this.getSize(e);
            }
          }), nu.prototype.center = function (e) {
            return console.warn("THREE.Line3: .center() has been renamed to .getCenter()."), this.getCenter(e);
          }, Object.assign(ne, {
            random16: function random16() {
              return console.warn("THREE.Math: .random16() has been deprecated. Use Math.random() instead."), Math.random();
            },
            nearestPowerOfTwo: function nearestPowerOfTwo(e) {
              return console.warn("THREE.Math: .nearestPowerOfTwo() has been renamed to .floorPowerOfTwo()."), ne.floorPowerOfTwo(e);
            },
            nextPowerOfTwo: function nextPowerOfTwo(e) {
              return console.warn("THREE.Math: .nextPowerOfTwo() has been renamed to .ceilPowerOfTwo()."), ne.ceilPowerOfTwo(e);
            }
          }), Object.assign(se.prototype, {
            flattenToArrayOffset: function flattenToArrayOffset(e, t) {
              return console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(e, t);
            },
            multiplyVector3: function multiplyVector3(e) {
              return console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."), e.applyMatrix3(this);
            },
            multiplyVector3Array: function multiplyVector3Array() {
              console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
            },
            applyToBuffer: function applyToBuffer(e) {
              return console.warn("THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead."), this.applyToBufferAttribute(e);
            },
            applyToVector3Array: function applyToVector3Array() {
              console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
            }
          }), Object.assign(ie.prototype, {
            extractPosition: function extractPosition(e) {
              return console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."), this.copyPosition(e);
            },
            flattenToArrayOffset: function flattenToArrayOffset(e, t) {
              return console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(e, t);
            },
            getPosition: function getPosition() {
              return void 0 === Vl && (Vl = new ae()), console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."), Vl.setFromMatrixColumn(this, 3);
            },
            setRotationFromQuaternion: function setRotationFromQuaternion(e) {
              return console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."), this.makeRotationFromQuaternion(e);
            },
            multiplyToArray: function multiplyToArray() {
              console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
            },
            multiplyVector3: function multiplyVector3(e) {
              return console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."), e.applyMatrix4(this);
            },
            multiplyVector4: function multiplyVector4(e) {
              return console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."), e.applyMatrix4(this);
            },
            multiplyVector3Array: function multiplyVector3Array() {
              console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
            },
            rotateAxis: function rotateAxis(e) {
              console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."), e.transformDirection(this);
            },
            crossVector: function crossVector(e) {
              return console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."), e.applyMatrix4(this);
            },
            translate: function translate() {
              console.error("THREE.Matrix4: .translate() has been removed.");
            },
            rotateX: function rotateX() {
              console.error("THREE.Matrix4: .rotateX() has been removed.");
            },
            rotateY: function rotateY() {
              console.error("THREE.Matrix4: .rotateY() has been removed.");
            },
            rotateZ: function rotateZ() {
              console.error("THREE.Matrix4: .rotateZ() has been removed.");
            },
            rotateByAxis: function rotateByAxis() {
              console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
            },
            applyToBuffer: function applyToBuffer(e) {
              return console.warn("THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead."), this.applyToBufferAttribute(e);
            },
            applyToVector3Array: function applyToVector3Array() {
              console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
            },
            makeFrustum: function makeFrustum(e, t, n, r, i, o) {
              return console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."), this.makePerspective(e, t, r, n, i, o);
            }
          }), Ie.prototype.isIntersectionLine = function (e) {
            return console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."), this.intersectsLine(e);
          }, oe.prototype.multiplyVector3 = function (e) {
            return console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."), e.applyQuaternion(this);
          }, Object.assign(kn.prototype, {
            isIntersectionBox: function isIntersectionBox(e) {
              return console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(e);
            },
            isIntersectionPlane: function isIntersectionPlane(e) {
              return console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."), this.intersectsPlane(e);
            },
            isIntersectionSphere: function isIntersectionSphere(e) {
              return console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(e);
            }
          }), Object.assign(Pn.prototype, {
            area: function area() {
              return console.warn("THREE.Triangle: .area() has been renamed to .getArea()."), this.getArea();
            },
            barycoordFromPoint: function barycoordFromPoint(e, t) {
              return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), this.getBarycoord(e, t);
            },
            midpoint: function midpoint(e) {
              return console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint()."), this.getMidpoint(e);
            },
            normal: function normal(e) {
              return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), this.getNormal(e);
            },
            plane: function plane(e) {
              return console.warn("THREE.Triangle: .plane() has been renamed to .getPlane()."), this.getPlane(e);
            }
          }), Object.assign(Pn, {
            barycoordFromPoint: function barycoordFromPoint(e, t, n, r, i) {
              return console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."), Pn.getBarycoord(e, t, n, r, i);
            },
            normal: function normal(e, t, n, r) {
              return console.warn("THREE.Triangle: .normal() has been renamed to .getNormal()."), Pn.getNormal(e, t, n, r);
            }
          }), Object.assign(Wa.prototype, {
            extractAllPoints: function extractAllPoints(e) {
              return console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead."), this.extractPoints(e);
            },
            extrude: function extrude(e) {
              return console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."), new Do(this, e);
            },
            makeGeometry: function makeGeometry(e) {
              return console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."), new Yo(this, e);
            }
          }), Object.assign(re.prototype, {
            fromAttribute: function fromAttribute(e, t, n) {
              return console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(e, t, n);
            },
            distanceToManhattan: function distanceToManhattan(e) {
              return console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(e);
            },
            lengthManhattan: function lengthManhattan() {
              return console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
            }
          }), Object.assign(ae.prototype, {
            setEulerFromRotationMatrix: function setEulerFromRotationMatrix() {
              console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
            },
            setEulerFromQuaternion: function setEulerFromQuaternion() {
              console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
            },
            getPositionFromMatrix: function getPositionFromMatrix(e) {
              return console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."), this.setFromMatrixPosition(e);
            },
            getScaleFromMatrix: function getScaleFromMatrix(e) {
              return console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."), this.setFromMatrixScale(e);
            },
            getColumnFromMatrix: function getColumnFromMatrix(e, t) {
              return console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."), this.setFromMatrixColumn(t, e);
            },
            applyProjection: function applyProjection(e) {
              return console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."), this.applyMatrix4(e);
            },
            fromAttribute: function fromAttribute(e, t, n) {
              return console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(e, t, n);
            },
            distanceToManhattan: function distanceToManhattan(e) {
              return console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."), this.manhattanDistanceTo(e);
            },
            lengthManhattan: function lengthManhattan() {
              return console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
            }
          }), Object.assign(Me.prototype, {
            fromAttribute: function fromAttribute(e, t, n) {
              return console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(e, t, n);
            },
            lengthManhattan: function lengthManhattan() {
              return console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength()."), this.manhattanLength();
            }
          }), Object.assign(Et.prototype, {
            computeTangents: function computeTangents() {
              console.error("THREE.Geometry: .computeTangents() has been removed.");
            },
            computeLineDistances: function computeLineDistances() {
              console.error("THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.");
            }
          }), Object.assign(ft.prototype, {
            getChildByName: function getChildByName(e) {
              return console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."), this.getObjectByName(e);
            },
            renderDepth: function renderDepth() {
              console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
            },
            translate: function translate(e, t) {
              return console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."), this.translateOnAxis(t, e);
            },
            getWorldRotation: function getWorldRotation() {
              console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
            }
          }), Object.defineProperties(ft.prototype, {
            eulerOrder: {
              get: function get() {
                return console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order;
              },
              set: function set(e) {
                console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order = e;
              }
            },
            useQuaternion: {
              get: function get() {
                console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
              },
              set: function set() {
                console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
              }
            }
          }), Object.defineProperties(ji.prototype, {
            objects: {
              get: function get() {
                return console.warn("THREE.LOD: .objects has been renamed to .levels."), this.levels;
              }
            }
          }), Object.defineProperty(Ni.prototype, "useVertexTexture", {
            get: function get() {
              console.warn("THREE.Skeleton: useVertexTexture has been removed.");
            },
            set: function set() {
              console.warn("THREE.Skeleton: useVertexTexture has been removed.");
            }
          }), Object.defineProperty(Aa.prototype, "__arcLengthDivisions", {
            get: function get() {
              return console.warn("THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions."), this.arcLengthDivisions;
            },
            set: function set(e) {
              console.warn("THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions."), this.arcLengthDivisions = e;
            }
          }), wi.prototype.setLens = function (e, t) {
            console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."), void 0 !== t && (this.filmGauge = t), this.setFocalLength(e);
          }, Object.defineProperties($a.prototype, {
            onlyShadow: {
              set: function set() {
                console.warn("THREE.Light: .onlyShadow has been removed.");
              }
            },
            shadowCameraFov: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov."), this.shadow.camera.fov = e;
              }
            },
            shadowCameraLeft: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left."), this.shadow.camera.left = e;
              }
            },
            shadowCameraRight: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right."), this.shadow.camera.right = e;
              }
            },
            shadowCameraTop: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top."), this.shadow.camera.top = e;
              }
            },
            shadowCameraBottom: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."), this.shadow.camera.bottom = e;
              }
            },
            shadowCameraNear: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near."), this.shadow.camera.near = e;
              }
            },
            shadowCameraFar: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far."), this.shadow.camera.far = e;
              }
            },
            shadowCameraVisible: {
              set: function set() {
                console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
              }
            },
            shadowBias: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowBias is now .shadow.bias."), this.shadow.bias = e;
              }
            },
            shadowDarkness: {
              set: function set() {
                console.warn("THREE.Light: .shadowDarkness has been removed.");
              }
            },
            shadowMapWidth: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."), this.shadow.mapSize.width = e;
              }
            },
            shadowMapHeight: {
              set: function set(e) {
                console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."), this.shadow.mapSize.height = e;
              }
            }
          }), Object.defineProperties(Tt.prototype, {
            length: {
              get: function get() {
                return console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead."), this.array.length;
              }
            },
            copyIndicesArray: function copyIndicesArray() {
              console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
            }
          }), Object.assign(Yt.prototype, {
            addIndex: function addIndex(e) {
              console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."), this.setIndex(e);
            },
            addDrawCall: function addDrawCall(e, t, n) {
              void 0 !== n && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."), console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup()."), this.addGroup(e, t);
            },
            clearDrawCalls: function clearDrawCalls() {
              console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."), this.clearGroups();
            },
            computeTangents: function computeTangents() {
              console.warn("THREE.BufferGeometry: .computeTangents() has been removed.");
            },
            computeOffsets: function computeOffsets() {
              console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
            }
          }), Object.defineProperties(Yt.prototype, {
            drawcalls: {
              get: function get() {
                return console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups."), this.groups;
              }
            },
            offsets: {
              get: function get() {
                return console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups."), this.groups;
              }
            }
          }), Object.assign(Bo.prototype, {
            getArrays: function getArrays() {
              console.error("THREE.ExtrudeBufferGeometry: .getArrays() has been removed.");
            },
            addShapeList: function addShapeList() {
              console.error("THREE.ExtrudeBufferGeometry: .addShapeList() has been removed.");
            },
            addShape: function addShape() {
              console.error("THREE.ExtrudeBufferGeometry: .addShape() has been removed.");
            }
          }), Object.defineProperties(Yl.prototype, {
            dynamic: {
              set: function set() {
                console.warn("THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.");
              }
            },
            onUpdate: {
              value: function value() {
                return console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead."), this;
              }
            }
          }), Object.defineProperties(Tn.prototype, {
            wrapAround: {
              get: function get() {
                console.warn("THREE.Material: .wrapAround has been removed.");
              },
              set: function set() {
                console.warn("THREE.Material: .wrapAround has been removed.");
              }
            },
            wrapRGB: {
              get: function get() {
                return console.warn("THREE.Material: .wrapRGB has been removed."), new Fe();
              }
            },
            shading: {
              get: function get() {
                console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
              },
              set: function set(e) {
                console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = 1 === e;
              }
            }
          }), Object.defineProperties(ca.prototype, {
            metal: {
              get: function get() {
                return console.warn("THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead."), !1;
              },
              set: function set() {
                console.warn("THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead");
              }
            }
          }), Object.defineProperties(Cn.prototype, {
            derivatives: {
              get: function get() {
                return console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives;
              },
              set: function set(e) {
                console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives = e;
              }
            }
          }), Object.assign(Ti.prototype, {
            animate: function animate(e) {
              console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop()."), this.setAnimationLoop(e);
            },
            getCurrentRenderTarget: function getCurrentRenderTarget() {
              return console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."), this.getRenderTarget();
            },
            getMaxAnisotropy: function getMaxAnisotropy() {
              return console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy()."), this.capabilities.getMaxAnisotropy();
            },
            getPrecision: function getPrecision() {
              return console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision."), this.capabilities.precision;
            },
            resetGLState: function resetGLState() {
              return console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset()."), this.state.reset();
            },
            supportsFloatTextures: function supportsFloatTextures() {
              return console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."), this.extensions.get("OES_texture_float");
            },
            supportsHalfFloatTextures: function supportsHalfFloatTextures() {
              return console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."), this.extensions.get("OES_texture_half_float");
            },
            supportsStandardDerivatives: function supportsStandardDerivatives() {
              return console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."), this.extensions.get("OES_standard_derivatives");
            },
            supportsCompressedTextureS3TC: function supportsCompressedTextureS3TC() {
              return console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."), this.extensions.get("WEBGL_compressed_texture_s3tc");
            },
            supportsCompressedTexturePVRTC: function supportsCompressedTexturePVRTC() {
              return console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."), this.extensions.get("WEBGL_compressed_texture_pvrtc");
            },
            supportsBlendMinMax: function supportsBlendMinMax() {
              return console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."), this.extensions.get("EXT_blend_minmax");
            },
            supportsVertexTextures: function supportsVertexTextures() {
              return console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."), this.capabilities.vertexTextures;
            },
            supportsInstancedArrays: function supportsInstancedArrays() {
              return console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."), this.extensions.get("ANGLE_instanced_arrays");
            },
            enableScissorTest: function enableScissorTest(e) {
              console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."), this.setScissorTest(e);
            },
            initMaterial: function initMaterial() {
              console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
            },
            addPrePlugin: function addPrePlugin() {
              console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
            },
            addPostPlugin: function addPostPlugin() {
              console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
            },
            updateShadowMap: function updateShadowMap() {
              console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
            },
            setFaceCulling: function setFaceCulling() {
              console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
            }
          }), Object.defineProperties(Ti.prototype, {
            shadowMapEnabled: {
              get: function get() {
                return this.shadowMap.enabled;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."), this.shadowMap.enabled = e;
              }
            },
            shadowMapType: {
              get: function get() {
                return this.shadowMap.type;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."), this.shadowMap.type = e;
              }
            },
            shadowMapCullFace: {
              get: function get() {
                console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
              },
              set: function set() {
                console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
              }
            }
          }), Object.defineProperties(vi.prototype, {
            cullFace: {
              get: function get() {
                console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
              },
              set: function set() {
                console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
              }
            },
            renderReverseSided: {
              get: function get() {
                console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
              },
              set: function set() {
                console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
              }
            },
            renderSingleSided: {
              get: function get() {
                console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
              },
              set: function set() {
                console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
              }
            }
          }), Object.defineProperties(Ce.prototype, {
            wrapS: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS = e;
              }
            },
            wrapT: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT = e;
              }
            },
            magFilter: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter = e;
              }
            },
            minFilter: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter = e;
              }
            },
            anisotropy: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy = e;
              }
            },
            offset: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset = e;
              }
            },
            repeat: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat = e;
              }
            },
            format: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format = e;
              }
            },
            type: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type = e;
              }
            },
            generateMipmaps: {
              get: function get() {
                return console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps;
              },
              set: function set(e) {
                console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps = e;
              }
            }
          }), Object.defineProperties(Ai.prototype, {
            standing: {
              set: function set() {
                console.warn("THREE.WebVRManager: .standing has been removed.");
              }
            }
          }), il.prototype.load = function (e) {
            console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
            var t = this;
            return new el().load(e, function (e) {
              t.setBuffer(e);
            }), this;
          }, al.prototype.getData = function () {
            return console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData()."), this.getFrequencyData();
          }, nl.prototype.updateCubeMap = function (e, t) {
            return console.warn("THREE.CubeCamera: .updateCubeMap() is now .update()."), this.update(e, t);
          }, Ae.crossOrigin = void 0, Ae.loadTexture = function (e, t, n, r) {
            console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
            var i = new Sa();
            i.setCrossOrigin(this.crossOrigin);
            var o = i.load(e, n, void 0, r);
            return t && (o.mapping = t), o;
          }, Ae.loadTextureCube = function (e, t, n, r) {
            console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
            var i = new wa();
            i.setCrossOrigin(this.crossOrigin);
            var o = i.load(e, n, void 0, r);
            return t && (o.mapping = t), o;
          }, Ae.loadCompressedTexture = function () {
            console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
          }, Ae.loadCompressedTextureCube = function () {
            console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
          };
          var Vu = function Vu(e) {
              this.name = e, this._dict = {};
            },
            Hu = {
              names: {
                configurable: !0
              }
            };
          function qu(e) {
            return .01745 * e;
          }
          Vu.prototype.add = function (e, t) {
            this._dict[Gu(e)] = t;
          }, Vu.prototype.get = function (e) {
            return this._dict[Gu(e)];
          }, Hu.names.get = function () {
            return Object.keys(this._dict);
          }, Object.defineProperties(Vu.prototype, Hu);
          var Wu = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""),
            $u = new Array(36);
          function Xu() {
            for (var e, t = 0, n = 0; n < 36; n++) 8 === n || 13 === n || 18 === n || 23 === n ? $u[n] = "-" : 14 === n ? $u[n] = "4" : (t <= 2 && (t = 33554432 + 16777216 * Math.random() | 0), e = 15 & t, t >>= 4, $u[n] = Wu[19 === n ? 3 & e | 8 : e]);
            return $u.join("");
          }
          function Yu(e, t, n) {
            return Math.max(t, Math.min(n, e));
          }
          function Ku(e) {
            return Yu(e, 0, 100);
          }
          function Zu(e, t, n) {
            return e + (t - e) * n;
          }
          function Qu(e, t, n, r, i, o) {
            var a = (n - e) * o,
              s = (r - t) * o,
              l = i * i;
            return (2 * t - 2 * n + a + s) * (i * l) + (-3 * t + 3 * n - 2 * a - s) * l + a * i + t;
          }
          function Ju(e, t, n) {
            var r;
            return (n = Yu((n - (r = e)) / (t - r), 0, 1)) * n * (3 - 2 * n);
          }
          var ec = "undefined" != typeof window ? window : void 0 !== n ? n : "undefined" != typeof self ? self : {};
          function tc(e, t) {
            return e(t = {
              exports: {}
            }, t.exports), t.exports;
          }
          var nc = tc(function (e, t) {
              (function () {
                var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h,
                  f,
                  p,
                  m,
                  _g2,
                  _v2,
                  y,
                  b,
                  _,
                  x,
                  w,
                  S,
                  A,
                  E,
                  T,
                  M,
                  C,
                  k,
                  P,
                  O,
                  R,
                  I,
                  j,
                  N,
                  L,
                  D,
                  B,
                  F,
                  z,
                  U,
                  G,
                  V,
                  H,
                  q,
                  W,
                  $,
                  X,
                  Y,
                  K,
                  Z,
                  Q,
                  J,
                  ee,
                  te,
                  ne,
                  re,
                  ie,
                  oe,
                  ae,
                  se,
                  le,
                  ue,
                  ce,
                  de,
                  he,
                  fe,
                  pe,
                  ge,
                  ve,
                  ye,
                  be,
                  _e,
                  xe,
                  we,
                  Se,
                  Ae,
                  Ee,
                  Te,
                  Me,
                  Ce,
                  ke = [].slice;
                Ae = function () {
                  var e, t, n, r, i;
                  for (e = {}, r = 0, t = (i = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ")).length; r < t; r++) n = i[r], e["[object " + n + "]"] = n.toLowerCase();
                  return function (t) {
                    var n;
                    return n = Object.prototype.toString.call(t), e[n] || "object";
                  };
                }(), X = function X(e, t, n) {
                  return null == t && (t = 0), null == n && (n = 1), e < t && (e = t), n < e && (e = n), e;
                }, Ee = function Ee(e) {
                  return 3 <= e.length ? Array.prototype.slice.call(e) : e[0];
                }, w = function w(e) {
                  var t, n;
                  for (e._clipped = !1, e._unclipped = e.slice(0), t = n = 0; n < 3; t = ++n) t < 3 ? ((e[t] < 0 || 255 < e[t]) && (e._clipped = !0), e[t] < 0 && (e[t] = 0), 255 < e[t] && (e[t] = 255)) : 3 === t && (e[t] < 0 && (e[t] = 0), 1 < e[t] && (e[t] = 1));
                  return e._clipped || delete e._unclipped, e;
                }, o = Math.PI, be = Math.round, A = Math.cos, k = Math.floor, ne = Math.pow, Y = Math.log, xe = Math.sin, we = Math.sqrt, m = Math.atan2, Q = Math.max, p = Math.abs, l = 2 * o, a = o / 3, r = o / 180, s = 180 / o, (x = function x() {
                  return arguments[0] instanceof n ? arguments[0] : function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, arguments, function () {});
                }).default = x, f = [], null !== e && null != e.exports && (e.exports = x), ((null !== t ? t : this).chroma = x).version = "1.3.7", h = {}, d = !(c = []), n = function () {
                  function e() {
                    var e,
                      t,
                      n,
                      r,
                      i,
                      o,
                      a,
                      s,
                      l = arguments;
                    for (t = [], a = 0, r = arguments.length; a < r; a++) null != (e = l[a]) && t.push(e);
                    if (1 < t.length && (o = t[t.length - 1]), null != h[o]) this._rgb = w(h[o](Ee(t.slice(0, -1))));else {
                      for (d || (c = c.sort(function (e, t) {
                        return t.p - e.p;
                      }), d = !0), s = 0, i = c.length; s < i && !(o = (n = c[s]).test.apply(n, t)); s++);
                      o && (this._rgb = w(h[o].apply(h, t)));
                    }
                    null == this._rgb && console.warn("unknown format: " + t), null == this._rgb && (this._rgb = [0, 0, 0]), 3 === this._rgb.length && this._rgb.push(1);
                  }
                  return e.prototype.toString = function () {
                    return this.hex();
                  }, e.prototype.clone = function () {
                    return x(me._rgb);
                  }, e;
                }(), x._input = h, x.brewer = b = {
                  OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
                  PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
                  BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
                  Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
                  BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
                  YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
                  YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
                  Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
                  RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
                  Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
                  YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
                  Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
                  GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
                  Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
                  YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
                  PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
                  Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
                  PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
                  Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
                  Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
                  RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
                  RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
                  PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
                  PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
                  RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
                  BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
                  RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
                  PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
                  Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
                  Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
                  Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
                  Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
                  Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
                  Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
                  Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
                  Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
                }, function () {
                  var e, t;
                  for (e in t = [], b) t.push(b[e.toLowerCase()] = b[e]);
                }(), x.colors = Te = {
                  aliceblue: "#f0f8ff",
                  antiquewhite: "#faebd7",
                  aqua: "#00ffff",
                  aquamarine: "#7fffd4",
                  azure: "#f0ffff",
                  beige: "#f5f5dc",
                  bisque: "#ffe4c4",
                  black: "#000000",
                  blanchedalmond: "#ffebcd",
                  blue: "#0000ff",
                  blueviolet: "#8a2be2",
                  brown: "#a52a2a",
                  burlywood: "#deb887",
                  cadetblue: "#5f9ea0",
                  chartreuse: "#7fff00",
                  chocolate: "#d2691e",
                  coral: "#ff7f50",
                  cornflower: "#6495ed",
                  cornflowerblue: "#6495ed",
                  cornsilk: "#fff8dc",
                  crimson: "#dc143c",
                  cyan: "#00ffff",
                  darkblue: "#00008b",
                  darkcyan: "#008b8b",
                  darkgoldenrod: "#b8860b",
                  darkgray: "#a9a9a9",
                  darkgreen: "#006400",
                  darkgrey: "#a9a9a9",
                  darkkhaki: "#bdb76b",
                  darkmagenta: "#8b008b",
                  darkolivegreen: "#556b2f",
                  darkorange: "#ff8c00",
                  darkorchid: "#9932cc",
                  darkred: "#8b0000",
                  darksalmon: "#e9967a",
                  darkseagreen: "#8fbc8f",
                  darkslateblue: "#483d8b",
                  darkslategray: "#2f4f4f",
                  darkslategrey: "#2f4f4f",
                  darkturquoise: "#00ced1",
                  darkviolet: "#9400d3",
                  deeppink: "#ff1493",
                  deepskyblue: "#00bfff",
                  dimgray: "#696969",
                  dimgrey: "#696969",
                  dodgerblue: "#1e90ff",
                  firebrick: "#b22222",
                  floralwhite: "#fffaf0",
                  forestgreen: "#228b22",
                  fuchsia: "#ff00ff",
                  gainsboro: "#dcdcdc",
                  ghostwhite: "#f8f8ff",
                  gold: "#ffd700",
                  goldenrod: "#daa520",
                  gray: "#808080",
                  green: "#008000",
                  greenyellow: "#adff2f",
                  grey: "#808080",
                  honeydew: "#f0fff0",
                  hotpink: "#ff69b4",
                  indianred: "#cd5c5c",
                  indigo: "#4b0082",
                  ivory: "#fffff0",
                  khaki: "#f0e68c",
                  laserlemon: "#ffff54",
                  lavender: "#e6e6fa",
                  lavenderblush: "#fff0f5",
                  lawngreen: "#7cfc00",
                  lemonchiffon: "#fffacd",
                  lightblue: "#add8e6",
                  lightcoral: "#f08080",
                  lightcyan: "#e0ffff",
                  lightgoldenrod: "#fafad2",
                  lightgoldenrodyellow: "#fafad2",
                  lightgray: "#d3d3d3",
                  lightgreen: "#90ee90",
                  lightgrey: "#d3d3d3",
                  lightpink: "#ffb6c1",
                  lightsalmon: "#ffa07a",
                  lightseagreen: "#20b2aa",
                  lightskyblue: "#87cefa",
                  lightslategray: "#778899",
                  lightslategrey: "#778899",
                  lightsteelblue: "#b0c4de",
                  lightyellow: "#ffffe0",
                  lime: "#00ff00",
                  limegreen: "#32cd32",
                  linen: "#faf0e6",
                  magenta: "#ff00ff",
                  maroon: "#800000",
                  maroon2: "#7f0000",
                  maroon3: "#b03060",
                  mediumaquamarine: "#66cdaa",
                  mediumblue: "#0000cd",
                  mediumorchid: "#ba55d3",
                  mediumpurple: "#9370db",
                  mediumseagreen: "#3cb371",
                  mediumslateblue: "#7b68ee",
                  mediumspringgreen: "#00fa9a",
                  mediumturquoise: "#48d1cc",
                  mediumvioletred: "#c71585",
                  midnightblue: "#191970",
                  mintcream: "#f5fffa",
                  mistyrose: "#ffe4e1",
                  moccasin: "#ffe4b5",
                  navajowhite: "#ffdead",
                  navy: "#000080",
                  oldlace: "#fdf5e6",
                  olive: "#808000",
                  olivedrab: "#6b8e23",
                  orange: "#ffa500",
                  orangered: "#ff4500",
                  orchid: "#da70d6",
                  palegoldenrod: "#eee8aa",
                  palegreen: "#98fb98",
                  paleturquoise: "#afeeee",
                  palevioletred: "#db7093",
                  papayawhip: "#ffefd5",
                  peachpuff: "#ffdab9",
                  peru: "#cd853f",
                  pink: "#ffc0cb",
                  plum: "#dda0dd",
                  powderblue: "#b0e0e6",
                  purple: "#800080",
                  purple2: "#7f007f",
                  purple3: "#a020f0",
                  rebeccapurple: "#663399",
                  red: "#ff0000",
                  rosybrown: "#bc8f8f",
                  royalblue: "#4169e1",
                  saddlebrown: "#8b4513",
                  salmon: "#fa8072",
                  sandybrown: "#f4a460",
                  seagreen: "#2e8b57",
                  seashell: "#fff5ee",
                  sienna: "#a0522d",
                  silver: "#c0c0c0",
                  skyblue: "#87ceeb",
                  slateblue: "#6a5acd",
                  slategray: "#708090",
                  slategrey: "#708090",
                  snow: "#fffafa",
                  springgreen: "#00ff7f",
                  steelblue: "#4682b4",
                  tan: "#d2b48c",
                  teal: "#008080",
                  thistle: "#d8bfd8",
                  tomato: "#ff6347",
                  turquoise: "#40e0d0",
                  violet: "#ee82ee",
                  wheat: "#f5deb3",
                  white: "#ffffff",
                  whitesmoke: "#f5f5f5",
                  yellow: "#ffff00",
                  yellowgreen: "#9acd32"
                }, V = function V() {
                  var e, t, n, r, o, a, s;
                  return r = (t = Ee(arguments))[0], e = t[1], n = t[2], a = (r + 16) / 116, o = isNaN(e) ? a : a + e / 500, s = isNaN(n) ? a : a - n / 200, a = i.Yn * H(a), o = i.Xn * H(o), s = i.Zn * H(s), [Ce(3.2404542 * o - 1.5371385 * a - .4985314 * s), Ce(-.969266 * o + 1.8760108 * a + .041556 * s), n = Ce(.0556434 * o - .2040259 * a + 1.0572252 * s), 3 < t.length ? t[3] : 1];
                }, Ce = function Ce(e) {
                  return 255 * (e <= .00304 ? 12.92 * e : 1.055 * ne(e, 1 / 2.4) - .055);
                }, H = function H(e) {
                  return e > i.t1 ? e * e * e : i.t2 * (e - i.t0);
                }, i = {
                  Kn: 18,
                  Xn: .95047,
                  Yn: 1,
                  Zn: 1.08883,
                  t0: .137931034,
                  t1: .206896552,
                  t2: .12841855,
                  t3: .008856452
                }, ce = function ce() {
                  var e, t, n, r, i, o, a;
                  return n = (r = Ee(arguments))[0], t = r[1], e = r[2], o = (i = ge(n, t, e))[0], [116 * (a = i[1]) - 16, 500 * (o - a), 200 * (a - i[2])];
                }, ve = function ve(e) {
                  return (e /= 255) <= .04045 ? e / 12.92 : ne((e + .055) / 1.055, 2.4);
                }, Me = function Me(e) {
                  return e > i.t3 ? ne(e, 1 / 3) : e / i.t2 + i.t0;
                }, ge = function ge() {
                  var e, t, n, r;
                  return n = (r = Ee(arguments))[0], t = r[1], e = r[2], n = ve(n), t = ve(t), e = ve(e), [Me((.4124564 * n + .3575761 * t + .1804375 * e) / i.Xn), Me((.2126729 * n + .7151522 * t + .072175 * e) / i.Yn), Me((.0193339 * n + .119192 * t + .9503041 * e) / i.Zn)];
                }, x.lab = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["lab"]), function () {});
                }, h.lab = V, n.prototype.lab = function () {
                  return ce(this._rgb);
                }, _g2 = function g(e) {
                  var t, n, r, i, o, a, s, l, u, c, d;
                  return 2 === (e = function () {
                    var t, n, r;
                    for (r = [], n = 0, t = e.length; n < t; n++) i = e[n], r.push(x(i));
                    return r;
                  }()).length ? (u = function () {
                    var t, n, r;
                    for (r = [], n = 0, t = e.length; n < t; n++) i = e[n], r.push(i.lab());
                    return r;
                  }(), o = u[0], a = u[1], t = function t(e) {
                    var t, n;
                    return n = function () {
                      var n, r;
                      for (r = [], t = n = 0; n <= 2; t = ++n) r.push(o[t] + e * (a[t] - o[t]));
                      return r;
                    }(), x.lab.apply(x, n);
                  }) : 3 === e.length ? (c = function () {
                    var t, n, r;
                    for (r = [], n = 0, t = e.length; n < t; n++) i = e[n], r.push(i.lab());
                    return r;
                  }(), o = c[0], a = c[1], s = c[2], t = function t(e) {
                    var t, n;
                    return n = function () {
                      var n, r;
                      for (r = [], t = n = 0; n <= 2; t = ++n) r.push((1 - e) * (1 - e) * o[t] + 2 * (1 - e) * e * a[t] + e * e * s[t]);
                      return r;
                    }(), x.lab.apply(x, n);
                  }) : 4 === e.length ? (d = function () {
                    var t, n, r;
                    for (r = [], n = 0, t = e.length; n < t; n++) i = e[n], r.push(i.lab());
                    return r;
                  }(), o = d[0], a = d[1], s = d[2], l = d[3], t = function t(e) {
                    var t, n;
                    return n = function () {
                      var n, r;
                      for (r = [], t = n = 0; n <= 2; t = ++n) r.push((1 - e) * (1 - e) * (1 - e) * o[t] + 3 * (1 - e) * (1 - e) * e * a[t] + 3 * (1 - e) * e * e * s[t] + e * e * e * l[t]);
                      return r;
                    }(), x.lab.apply(x, n);
                  }) : 5 === e.length && (n = _g2(e.slice(0, 3)), r = _g2(e.slice(2, 5)), t = function t(e) {
                    return e < .5 ? n(2 * e) : r(2 * (e - .5));
                  }), t;
                }, x.bezier = function (e) {
                  var t;
                  return (t = _g2(e)).scale = function () {
                    return x.scale(t);
                  }, t;
                }, x.cubehelix = function (e, t, n, r, i) {
                  var o, a, s;
                  return null == e && (e = 300), null == t && (t = -1.5), null == n && (n = 1), null == r && (r = 1), null == i && (i = [0, 1]), o = 0, "array" === Ae(i) ? a = i[1] - i[0] : (a = 0, i = [i, i]), (s = function s(_s3) {
                    var u, c, d, h, f;
                    return u = l * ((e + 120) / 360 + t * _s3), h = ne(i[0] + a * _s3, r), c = (0 !== o ? n[0] + _s3 * o : n) * h * (1 - h) / 2, d = A(u), f = xe(u), x(w([255 * (h + c * (-.14861 * d + 1.78277 * f)), 255 * (h + c * (-.29227 * d - .90649 * f)), 255 * (h + c * (1.97294 * d))]));
                  }).start = function (t) {
                    return null == t ? e : (e = t, s);
                  }, s.rotations = function (e) {
                    return null == e ? t : (t = e, s);
                  }, s.gamma = function (e) {
                    return null == e ? r : (r = e, s);
                  }, s.hue = function (e) {
                    return null == e ? n : ("array" === Ae(n = e) ? 0 == (o = n[1] - n[0]) && (n = n[1]) : o = 0, s);
                  }, s.lightness = function (e) {
                    return null == e ? i : ("array" === Ae(e) ? a = (i = e)[1] - e[0] : (i = [e, e], a = 0), s);
                  }, s.scale = function () {
                    return x.scale(s);
                  }, s.hue(n), s;
                }, x.random = function () {
                  var e, t;
                  for (e = "#", t = 0; t < 6; ++t) e += "0123456789abcdef".charAt(k(16 * Math.random()));
                  return new n(e);
                }, f = [], L = function L(e, t, n, r) {
                  var i, o, a, s;
                  for (null == n && (n = .5), null == r && (r = "rgb"), "object" !== Ae(e) && (e = x(e)), "object" !== Ae(t) && (t = x(t)), a = 0, o = f.length; a < o; a++) if (r === (i = f[a])[0]) {
                    s = i[1](e, t, n, r);
                    break;
                  }
                  if (null == s) throw "color mode " + r + " is not supported";
                  return s.alpha(e.alpha() + n * (t.alpha() - e.alpha()));
                }, x.interpolate = L, n.prototype.interpolate = function (e, t, n) {
                  return L(this, e, t, n);
                }, x.mix = L, n.prototype.mix = n.prototype.interpolate, h.rgb = function () {
                  var e, t, n, r;
                  for (e in n = [], t = Ee(arguments)) r = t[e], n.push(r);
                  return n;
                }, x.rgb = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["rgb"]), function () {});
                }, n.prototype.rgb = function (e) {
                  return null == e && (e = !0), e ? this._rgb.map(Math.round).slice(0, 3) : this._rgb.slice(0, 3);
                }, n.prototype.rgba = function (e) {
                  return null == e && (e = !0), e ? [Math.round(this._rgb[0]), Math.round(this._rgb[1]), Math.round(this._rgb[2]), this._rgb[3]] : this._rgb.slice(0);
                }, c.push({
                  p: 3,
                  test: function test(e) {
                    var t;
                    return t = Ee(arguments), "array" === Ae(t) && 3 === t.length || 4 === t.length && "number" === Ae(t[3]) && 0 <= t[3] && t[3] <= 1 ? "rgb" : void 0;
                  }
                }), h.lrgb = h.rgb, F = function F(e, t, r, i) {
                  var o, a;
                  return o = e._rgb, a = t._rgb, new n(we(ne(o[0], 2) * (1 - r) + ne(a[0], 2) * r), we(ne(o[1], 2) * (1 - r) + ne(a[1], 2) * r), we(ne(o[2], 2) * (1 - r) + ne(a[2], 2) * r), i);
                }, u = function u(e) {
                  var t, r, i, o, a;
                  for (t = 1 / e.length, a = [0, 0, 0, 0], i = 0, r = e.length; i < r; i++) o = e[i]._rgb, a[0] += ne(o[0], 2) * t, a[1] += ne(o[1], 2) * t, a[2] += ne(o[2], 2) * t, a[3] += o[3] * t;
                  return a[0] = we(a[0]), a[1] = we(a[1]), a[2] = we(a[2]), new n(a);
                }, f.push(["lrgb", F]), x.average = function (e, t) {
                  var n, r, i, a, s, l, c, d, h, f, p, g, v;
                  if (null == t && (t = "rgb"), h = e.length, c = (e = e.map(function (e) {
                    return x(e);
                  })).splice(0, 1)[0], "lrgb" === t) return u(e);
                  for (d in a = [], l = s = 0, g = c.get(t)) g[d] = g[d] || 0, a.push(isNaN(g[d]) ? 0 : 1), "h" !== t.charAt(d) || isNaN(g[d]) || (n = g[d] / 180 * o, s += A(n), l += xe(n));
                  for (r = c.alpha(), p = 0, f = e.length; p < f; p++) for (d in v = (i = e[p]).get(t), r += i.alpha(), g) isNaN(v[d]) || (a[d] += 1, "h" === t.charAt(d) ? (n = v[d] / 180 * o, s += A(n), l += xe(n)) : g[d] += v[d]);
                  for (d in g) if ("h" === t.charAt(d)) {
                    for (n = m(l / a[d], s / a[d]) / o * 180; n < 0;) n += 360;
                    for (; 360 <= n;) n -= 360;
                    g[d] = n;
                  } else g[d] = g[d] / a[d];
                  return x(g, t).alpha(r / h);
                }, O = function O(e) {
                  var t, n;
                  if (e.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) return 4 !== e.length && 7 !== e.length || (e = e.substr(1)), 3 === e.length && (e = (e = e.split(""))[0] + e[0] + e[1] + e[1] + e[2] + e[2]), [(n = parseInt(e, 16)) >> 16, n >> 8 & 255, 255 & n, 1];
                  if (e.match(/^#?([A-Fa-f0-9]{8})$/)) return 9 === e.length && (e = e.substr(1)), [(n = parseInt(e, 16)) >> 24 & 255, n >> 16 & 255, n >> 8 & 255, be((255 & n) / 255 * 100) / 100];
                  if (null != h.css && (t = h.css(e))) return t;
                  throw "unknown color: " + e;
                }, ae = function ae(e, t) {
                  var n, r, i, o, a, s;
                  return null == t && (t = "rgb"), a = e[0], i = e[1], r = e[2], n = e[3], a = Math.round(a), i = Math.round(i), r = Math.round(r), s = (s = "000000" + (a << 16 | i << 8 | r).toString(16)).substr(s.length - 6), o = (o = "0" + be(255 * n).toString(16)).substr(o.length - 2), "#" + function () {
                    switch (t.toLowerCase()) {
                      case "rgba":
                        return s + o;
                      case "argb":
                        return o + s;
                      default:
                        return s;
                    }
                  }();
                }, h.hex = function (e) {
                  return O(e);
                }, x.hex = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["hex"]), function () {});
                }, n.prototype.hex = function (e) {
                  return null == e && (e = "rgb"), ae(this._rgb, e);
                }, c.push({
                  p: 4,
                  test: function test(e) {
                    if (1 === arguments.length && "string" === Ae(e)) return "hex";
                  }
                }), j = function j() {
                  var e, t, n, r, i, o, a, s, l, u, c, d, h, f;
                  if (i = (e = Ee(arguments))[0], c = e[1], a = e[2], 0 === c) l = r = t = 255 * a;else {
                    for (n = [0, 0, 0], d = 2 * a - (h = a < .5 ? a * (1 + c) : a + c - a * c), (f = [0, 0, 0])[0] = (i /= 360) + 1 / 3, f[1] = i, f[2] = i - 1 / 3, o = s = 0; s <= 2; o = ++s) f[o] < 0 && (f[o] += 1), 1 < f[o] && (f[o] -= 1), 6 * f[o] < 1 ? n[o] = d + 6 * (h - d) * f[o] : 2 * f[o] < 1 ? n[o] = h : 3 * f[o] < 2 ? n[o] = d + (h - d) * (2 / 3 - f[o]) * 6 : n[o] = d;
                    l = (u = [be(255 * n[0]), be(255 * n[1]), be(255 * n[2])])[0], r = u[1], t = u[2];
                  }
                  return 3 < e.length ? [l, r, t, e[3]] : [l, r, t];
                }, le = function le(e, t, n) {
                  var r, i, o, a, s;
                  return void 0 !== e && 3 <= e.length && (e = (a = e)[0], t = a[1], n = a[2]), e /= 255, t /= 255, n /= 255, o = Math.min(e, t, n), i = ((Q = Math.max(e, t, n)) + o) / 2, Q === o ? (s = 0, r = Number.NaN) : s = i < .5 ? (Q - o) / (Q + o) : (Q - o) / (2 - Q - o), e === Q ? r = (t - n) / (Q - o) : t === Q ? r = 2 + (n - e) / (Q - o) : n === Q && (r = 4 + (e - t) / (Q - o)), (r *= 60) < 0 && (r += 360), [r, s, i];
                }, x.hsl = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["hsl"]), function () {});
                }, h.hsl = j, n.prototype.hsl = function () {
                  return le(this._rgb);
                }, N = function N() {
                  var e, t, n, r, i, o, a, s, l, u, c, d, h, f, p, m, g, v;
                  if (i = (e = Ee(arguments))[0], m = e[1], v = e[2], v *= 255, 0 === m) l = r = t = v;else switch (360 === i && (i = 0), 360 < i && (i -= 360), i < 0 && (i += 360), a = v * (1 - m), s = v * (1 - m * (n = (i /= 60) - (o = k(i)))), g = v * (1 - m * (1 - n)), o) {
                    case 0:
                      l = (u = [v, g, a])[0], r = u[1], t = u[2];
                      break;
                    case 1:
                      l = (c = [s, v, a])[0], r = c[1], t = c[2];
                      break;
                    case 2:
                      l = (d = [a, v, g])[0], r = d[1], t = d[2];
                      break;
                    case 3:
                      l = (h = [a, s, v])[0], r = h[1], t = h[2];
                      break;
                    case 4:
                      l = (f = [g, a, v])[0], r = f[1], t = f[2];
                      break;
                    case 5:
                      l = (p = [v, a, s])[0], r = p[1], t = p[2];
                  }
                  return [l, r, t, 3 < e.length ? e[3] : 1];
                }, ue = function ue() {
                  var e, t, n, r, i, o, a, s, l;
                  return o = (a = Ee(arguments))[0], n = a[1], e = a[2], i = Math.min(o, n, e), t = (Q = Math.max(o, n, e)) - i, l = Q / 255, 0 === Q ? (r = Number.NaN, s = 0) : (s = t / Q, o === Q && (r = (n - e) / t), n === Q && (r = 2 + (e - o) / t), e === Q && (r = 4 + (o - n) / t), (r *= 60) < 0 && (r += 360)), [r, s, l];
                }, x.hsv = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["hsv"]), function () {});
                }, h.hsv = N, n.prototype.hsv = function () {
                  return ue(this._rgb);
                }, ee = function ee(e) {
                  return "number" === Ae(e) && 0 <= e && e <= 16777215 ? [e >> 16, e >> 8 & 255, 255 & e, 1] : (console.warn("unknown num color: " + e), [0, 0, 0, 1]);
                }, fe = function fe() {
                  var e;
                  return ((e = Ee(arguments))[0] << 16) + (e[1] << 8) + e[2];
                }, x.num = function (e) {
                  return new n(e, "num");
                }, n.prototype.num = function (e) {
                  return null == e && (e = "rgb"), fe(this._rgb, e);
                }, h.num = ee, c.push({
                  p: 1,
                  test: function test(e) {
                    if (1 === arguments.length && "number" === Ae(e) && 0 <= e && e <= 16777215) return "num";
                  }
                }), P = function P() {
                  var e, t, n, r, i, o, a, s, l, u, c, d, h, f, p, m, g, v, y, b;
                  if (s = (n = Ee(arguments))[0], i = n[1], t = n[2], a = a / 100 * 255, e = 255 * (i /= 100), 0 === i) d = a = r = t;else switch (360 === s && (s = 0), 360 < s && (s -= 360), s < 0 && (s += 360), c = (u = t * (1 - i)) + e * (1 - (o = (s /= 60) - (l = k(s)))), y = u + e * o, b = u + e, l) {
                    case 0:
                      d = (h = [b, y, u])[0], a = h[1], r = h[2];
                      break;
                    case 1:
                      d = (f = [c, b, u])[0], a = f[1], r = f[2];
                      break;
                    case 2:
                      d = (p = [u, b, y])[0], a = p[1], r = p[2];
                      break;
                    case 3:
                      d = (m = [u, c, b])[0], a = m[1], r = m[2];
                      break;
                    case 4:
                      d = (g = [y, u, b])[0], a = g[1], r = g[2];
                      break;
                    case 5:
                      d = (v = [b, u, c])[0], a = v[1], r = v[2];
                  }
                  return [d, a, r, 3 < n.length ? n[3] : 1];
                }, oe = function oe() {
                  var e, t, n, r, i, o, a, s, l;
                  return s = (l = Ee(arguments))[0], i = l[1], t = l[2], a = Math.min(s, i, t), n = 100 * (r = (Q = Math.max(s, i, t)) - a) / 255, e = a / (255 - r) * 100, 0 === r ? o = Number.NaN : (s === Q && (o = (i - t) / r), i === Q && (o = 2 + (t - s) / r), t === Q && (o = 4 + (s - i) / r), (o *= 60) < 0 && (o += 360)), [o, n, e];
                }, x.hcg = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["hcg"]), function () {});
                }, h.hcg = P, n.prototype.hcg = function () {
                  return oe(this._rgb);
                }, E = function E(e) {
                  var t, n, r, i, o, a, s, l;
                  if (e = e.toLowerCase(), null != x.colors && x.colors[e]) return O(x.colors[e]);
                  if (o = e.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
                    for (s = o.slice(1, 4), i = a = 0; a <= 2; i = ++a) s[i] = +s[i];
                    s[3] = 1;
                  } else if (o = e.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) for (s = o.slice(1, 5), i = l = 0; l <= 3; i = ++l) s[i] = +s[i];else if (o = e.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
                    for (s = o.slice(1, 4), i = t = 0; t <= 2; i = ++t) s[i] = be(2.55 * s[i]);
                    s[3] = 1;
                  } else if (o = e.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
                    for (s = o.slice(1, 5), i = n = 0; n <= 2; i = ++n) s[i] = be(2.55 * s[i]);
                    s[3] = +s[3];
                  } else (o = e.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) ? ((r = o.slice(1, 4))[1] *= .01, r[2] *= .01, (s = j(r))[3] = 1) : (o = e.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) && ((r = o.slice(1, 4))[1] *= .01, r[2] *= .01, (s = j(r))[3] = +o[4]);
                  return s;
                }, ie = function ie(e) {
                  var t;
                  return "rgb" == (t = e[3] < 1 ? "rgba" : "rgb") ? t + "(" + e.slice(0, 3).map(be).join(",") + ")" : "rgba" === t ? t + "(" + e.slice(0, 3).map(be).join(",") + "," + e[3] + ")" : void 0;
                }, ye = function ye(e) {
                  return be(100 * e) / 100;
                }, I = function I(e, t) {
                  var n;
                  return n = t < 1 ? "hsla" : "hsl", e[0] = ye(e[0] || 0), e[1] = ye(100 * e[1]) + "%", e[2] = ye(100 * e[2]) + "%", "hsla" === n && (e[3] = t), n + "(" + e.join(",") + ")";
                }, h.css = function (e) {
                  return E(e);
                }, x.css = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["css"]), function () {});
                }, n.prototype.css = function (e) {
                  return null == e && (e = "rgb"), "rgb" === e.slice(0, 3) ? ie(this._rgb) : "hsl" === e.slice(0, 3) ? I(this.hsl(), this.alpha()) : void 0;
                }, h.named = function (e) {
                  return O(Te[e]);
                }, c.push({
                  p: 5,
                  test: function test(e) {
                    if (1 === arguments.length && null != Te[e]) return "named";
                  }
                }), n.prototype.name = function (e) {
                  var t, n;
                  for (n in arguments.length && (Te[e] && (this._rgb = O(Te[e])), this._rgb[3] = 1), t = this.hex(), Te) if (t === Te[n]) return n;
                  return t;
                }, q = function q() {
                  var e, t, n, i;
                  return n = (i = Ee(arguments))[0], e = i[1], t = i[2], [n, A(t *= r) * e, xe(t) * e];
                }, W = function W() {
                  var e, t, n, r, i, o, a, s, l;
                  return a = (n = Ee(arguments))[0], i = n[1], o = n[2], e = (s = q(a, i, o))[0], t = s[1], r = s[2], [(l = V(e, t, r))[0], l[1], r = l[2], 3 < n.length ? n[3] : 1];
                }, G = function G() {
                  var e, t, n, r, i, o;
                  return i = (o = Ee(arguments))[0], e = o[1], t = o[2], n = we(e * e + t * t), r = (m(t, e) * s + 360) % 360, 0 === be(1e4 * n) && (r = Number.NaN), [i, n, r];
                }, de = function de() {
                  var e, t, n, r, i, o, a;
                  return i = (o = Ee(arguments))[0], n = o[1], t = o[2], r = (a = ce(i, n, t))[0], e = a[1], t = a[2], G(r, e, t);
                }, x.lch = function () {
                  var e;
                  return e = Ee(arguments), new n(e, "lch");
                }, x.hcl = function () {
                  var e;
                  return e = Ee(arguments), new n(e, "hcl");
                }, h.lch = W, h.hcl = function () {
                  var e, t, n, r;
                  return t = (r = Ee(arguments))[0], e = r[1], n = r[2], W([n, e, t]);
                }, n.prototype.lch = function () {
                  return de(this._rgb);
                }, n.prototype.hcl = function () {
                  return de(this._rgb).reverse();
                }, re = function re(e) {
                  var t, n, r, i, o, a;
                  return null == e && (e = "rgb"), o = (a = Ee(arguments))[0], r = a[1], t = a[2], r /= 255, t /= 255, [(1 - (o /= 255) - (i = 1 - Math.max(o, Math.max(r, t)))) * (n = i < 1 ? 1 / (1 - i) : 0), (1 - r - i) * n, (1 - t - i) * n, i];
                }, S = function S() {
                  var e, t, n, r, i, o;
                  return n = (t = Ee(arguments))[0], i = t[1], o = t[2], r = t[3], e = 4 < t.length ? t[4] : 1, 1 === r ? [0, 0, 0, e] : [1 <= n ? 0 : 255 * (1 - n) * (1 - r), 1 <= i ? 0 : 255 * (1 - i) * (1 - r), 1 <= o ? 0 : 255 * (1 - o) * (1 - r), e];
                }, h.cmyk = function () {
                  return S(Ee(arguments));
                }, x.cmyk = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["cmyk"]), function () {});
                }, n.prototype.cmyk = function () {
                  return re(this._rgb);
                }, h.gl = function () {
                  var e, t, n, r, i;
                  for (r = function () {
                    var e, n;
                    for (t in n = [], e = Ee(arguments)) i = e[t], n.push(i);
                    return n;
                  }.apply(this, arguments), e = n = 0; n <= 2; e = ++n) r[e] *= 255;
                  return r;
                }, x.gl = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["gl"]), function () {});
                }, n.prototype.gl = function () {
                  var e;
                  return [(e = this._rgb)[0] / 255, e[1] / 255, e[2] / 255, e[3]];
                }, he = function he(e, t, n) {
                  var r;
                  return e = (r = Ee(arguments))[0], t = r[1], n = r[2], .2126 * (e = K(e)) + .7152 * (t = K(t)) + .0722 * K(n);
                }, K = function K(e) {
                  return (e /= 255) <= .03928 ? e / 12.92 : ne((e + .055) / 1.055, 2.4);
                }, U = function U(e, t, r, i) {
                  var o, a;
                  return o = e._rgb, a = t._rgb, new n(o[0] + r * (a[0] - o[0]), o[1] + r * (a[1] - o[1]), o[2] + r * (a[2] - o[2]), i);
                }, f.push(["rgb", U]), n.prototype.luminance = function (e, t) {
                  var n, r, i, _o7;
                  return null == t && (t = "rgb"), arguments.length ? (i = this._rgb, 0 === e ? i = [0, 0, 0, this._rgb[3]] : 1 === e ? i = [255, 255, 255, this[3]] : (n = he(this._rgb), r = 20, _o7 = function o(n, i) {
                    var a, s;
                    return a = (s = n.interpolate(i, .5, t)).luminance(), Math.abs(e - a) < 1e-7 || !r-- ? s : e < a ? _o7(n, s) : _o7(s, i);
                  }, i = e < n ? _o7(x("black"), this).rgba() : _o7(this, x("white")).rgba()), x(i).alpha(this.alpha())) : he(this._rgb);
                }, Se = function Se(e) {
                  var t, n, r, i;
                  return (i = e / 100) < 66 ? (r = 255, n = -155.25485562709179 - .44596950469579133 * (n = i - 2) + 104.49216199393888 * Y(n), t = i < 20 ? 0 : .8274096064007395 * (t = i - 10) - 254.76935184120902 + 115.67994401066147 * Y(t)) : (r = 351.97690566805693 + .114206453784165 * (r = i - 55) - 40.25366309332127 * Y(r), n = 325.4494125711974 + .07943456536662342 * (n = i - 50) - 28.0852963507957 * Y(n), t = 255), [r, n, t];
                }, pe = function pe() {
                  var e, t, n, r, i, o, a;
                  for (r = (i = Ee(arguments))[0], i[1], e = i[2], n = 1e3, t = 4e4; .4 < t - n;) (o = Se(a = .5 * (t + n)))[2] / o[0] >= e / r ? t = a : n = a;
                  return be(a);
                }, x.temperature = x.kelvin = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["temperature"]), function () {});
                }, h.temperature = h.kelvin = h.K = Se, n.prototype.temperature = function () {
                  return pe(this._rgb);
                }, n.prototype.kelvin = n.prototype.temperature, x.contrast = function (e, t) {
                  var r, i, o, a;
                  return "string" !== (o = Ae(e)) && "number" !== o || (e = new n(e)), "string" !== (a = Ae(t)) && "number" !== a || (t = new n(t)), r = e.luminance(), (i = t.luminance()) < r ? (r + .05) / (i + .05) : (i + .05) / (r + .05);
                }, x.distance = function (e, t, r) {
                  var i, o, a, s, l, u, c;
                  for (o in null == r && (r = "lab"), "string" !== (l = Ae(e)) && "number" !== l || (e = new n(e)), "string" !== (u = Ae(t)) && "number" !== u || (t = new n(t)), a = e.get(r), s = t.get(r), c = 0, a) c += (i = (a[o] || 0) - (s[o] || 0)) * i;
                  return Math.sqrt(c);
                }, x.deltaE = function (e, t, r, i) {
                  var a, s, l, u, c, d, h, f, g, v, y, b, _, x, w, S, E, T, M, C, k, P, O, R;
                  for (null == r && (r = 1), null == i && (i = 1), "string" !== (w = Ae(e)) && "number" !== w || (e = new n(e)), "string" !== (S = Ae(t)) && "number" !== S || (t = new n(t)), a = (E = e.lab())[0], l = E[1], c = E[2], s = (T = t.lab())[0], u = T[1], d = T[2], h = we(l * l + c * c), f = we(u * u + d * d), C = a < 16 ? .511 : .040975 * a / (1 + .01765 * a), M = .0638 * h / (1 + .0131 * h) + .638, x = h < 1e-6 ? 0 : 180 * m(c, l) / o; x < 0;) x += 360;
                  for (; 360 <= x;) x -= 360;
                  return k = 164 <= x && x <= 345 ? .56 + p(.2 * A(o * (x + 168) / 180)) : .36 + p(.4 * A(o * (x + 35) / 180)), _ = we((g = h * h * h * h) / (g + 1900)), we((P = (a - s) / (r * C)) * P + (O = (b = h - f) / (i * M)) * O + ((v = l - u) * v + (y = c - d) * y - b * b) / ((R = M * (_ * k + 1 - _)) * R));
                }, n.prototype.get = function (e) {
                  var t, n, r, i, o;
                  return r = (i = e.split("."))[0], t = i[1], o = this[r](), t ? -1 < (n = r.indexOf(t)) ? o[n] : console.warn("unknown channel " + t + " in mode " + r) : o;
                }, n.prototype.set = function (e, t) {
                  var n, r, i, o, a;
                  if (i = (o = e.split("."))[0], n = o[1]) {
                    if (a = this[i](), -1 < (r = i.indexOf(n))) {
                      if ("string" === Ae(t)) switch (t.charAt(0)) {
                        case "+":
                        case "-":
                          a[r] += +t;
                          break;
                        case "*":
                          a[r] *= +t.substr(1);
                          break;
                        case "/":
                          a[r] /= +t.substr(1);
                          break;
                        default:
                          a[r] = +t;
                      } else a[r] = t;
                    } else console.warn("unknown channel " + n + " in mode " + i);
                  } else a = t;
                  return x(a, i).alpha(this.alpha());
                }, n.prototype.clipped = function () {
                  return this._rgb._clipped || !1;
                }, n.prototype.alpha = function (e) {
                  return arguments.length ? x.rgb([this._rgb[0], this._rgb[1], this._rgb[2], e]) : this._rgb[3];
                }, n.prototype.darken = function (e) {
                  var t;
                  return null == e && (e = 1), (t = this.lab())[0] -= i.Kn * e, x.lab(t).alpha(this.alpha());
                }, n.prototype.brighten = function (e) {
                  return null == e && (e = 1), this.darken(-e);
                }, n.prototype.darker = n.prototype.darken, n.prototype.brighter = n.prototype.brighten, n.prototype.saturate = function (e) {
                  var t;
                  return null == e && (e = 1), (t = this.lch())[1] += e * i.Kn, t[1] < 0 && (t[1] = 0), x.lch(t).alpha(this.alpha());
                }, n.prototype.desaturate = function (e) {
                  return null == e && (e = 1), this.saturate(-e);
                }, n.prototype.premultiply = function () {
                  var e, t;
                  return t = this.rgb(), e = this.alpha(), x(t[0] * e, t[1] * e, t[2] * e, e);
                }, J = function J(e, t) {
                  return e * t / 255;
                }, T = function T(e, t) {
                  return t < e ? t : e;
                }, $ = function $(e, t) {
                  return t < e ? e : t;
                }, _e = function _e(e, t) {
                  return 255 * (1 - (1 - e / 255) * (1 - t / 255));
                }, te = function te(e, t) {
                  return t < 128 ? 2 * e * t / 255 : 255 * (1 - 2 * (1 - e / 255) * (1 - t / 255));
                }, _ = function _(e, t) {
                  return 255 * (1 - (1 - t / 255) / (e / 255));
                }, M = function M(e, t) {
                  return 255 === e || 255 < (e = t / 255 * 255 / (1 - e / 255)) ? 255 : e;
                }, (_v2 = function v(e, t, n) {
                  if (!_v2[n]) throw "unknown blend mode " + n;
                  return _v2[n](e, t);
                }).normal = (y = function y(e) {
                  return function (t, n) {
                    var r, i;
                    return r = x(n).rgb(), i = x(t).rgb(), x(e(r, i), "rgb");
                  };
                })((C = function C(e) {
                  return function (t, n) {
                    var r, i, o;
                    for (o = [], r = i = 0; i <= 3; r = ++i) o[r] = e(t[r], n[r]);
                    return o;
                  };
                })(function (e, t) {
                  return e;
                })), _v2.multiply = y(C(J)), _v2.screen = y(C(_e)), _v2.overlay = y(C(te)), _v2.darken = y(C(T)), _v2.lighten = y(C($)), _v2.dodge = y(C(M)), _v2.burn = y(C(_)), x.blend = _v2, x.analyze = function (e) {
                  var t, n, r, i;
                  for (r = {
                    min: Number.MAX_VALUE,
                    max: -1 * Number.MAX_VALUE,
                    sum: 0,
                    values: [],
                    count: 0
                  }, n = 0, t = e.length; n < t; n++) null == (i = e[n]) || isNaN(i) || (r.values.push(i), r.sum += i, i < r.min && (r.min = i), i > r.max && (r.max = i), r.count += 1);
                  return r.domain = [r.min, r.max], r.limits = function (e, t) {
                    return x.limits(r, e, t);
                  }, r;
                }, x.scale = function (e, t) {
                  var n, r, i, o, a, s, l, u, c, d, h, f, p, m, g, v, y, b, _, w, S;
                  return c = "rgb", d = x("#ccc"), a = [m = 0, 1], p = [], n = !(f = [0, 0]), h = !(i = []), u = 0, r = {}, g = !(o = !(l = 1)), s = 1, w = function w(e) {
                    var t, n, r, o, a, s;
                    if (null == e && (e = ["#fff", "#000"]), null != e && "string" === Ae(e) && null != x.brewer && (e = x.brewer[e] || x.brewer[e.toLowerCase()] || e), "array" === Ae(e)) {
                      for (t = r = 0, o = (e = e.slice(0)).length - 1; 0 <= o ? r <= o : o <= r; t = 0 <= o ? ++r : --r) n = e[t], "string" === Ae(n) && (e[t] = x(n));
                      for (t = s = p.length = 0, a = e.length - 1; 0 <= a ? s <= a : a <= s; t = 0 <= a ? ++s : --s) p.push(t / (e.length - 1));
                    }
                    return _(), i = e;
                  }, y = function y(e) {
                    var t, r;
                    if (null != n) {
                      for (r = n.length - 1, t = 0; t < r && e >= n[t];) t++;
                      return t - 1;
                    }
                    return 0;
                  }, S = function S(e) {
                    return e;
                  }, b = function b(e, t) {
                    var o, a, h, m, v, b, _;
                    if (null == t && (t = !1), isNaN(e)) return d;
                    if (_ = t ? e : n && 2 < n.length ? y(e) / (n.length - 2) : l !== u ? (e - u) / (l - u) : 1, t || (_ = S(_)), 1 !== s && (_ = ne(_, s)), _ = f[0] + _ * (1 - f[0] - f[1]), _ = Math.min(1, Math.max(0, _)), h = Math.floor(1e4 * _), g && r[h]) o = r[h];else {
                      if ("array" === Ae(i)) for (a = m = 0, b = p.length - 1; 0 <= b ? m <= b : b <= m; a = 0 <= b ? ++m : --m) {
                        if (_ <= (v = p[a])) {
                          o = i[a];
                          break;
                        }
                        if (v <= _ && a === p.length - 1) {
                          o = i[a];
                          break;
                        }
                        if (v < _ && _ < p[a + 1]) {
                          _ = (_ - v) / (p[a + 1] - v), o = x.interpolate(i[a], i[a + 1], _, c);
                          break;
                        }
                      } else "function" === Ae(i) && (o = i(_));
                      g && (r[h] = o);
                    }
                    return o;
                  }, _ = function _() {
                    return r = {};
                  }, w(e), (v = function v(e) {
                    var t;
                    return t = x(b(e)), h && t[h] ? t[h]() : t;
                  }).classes = function (e) {
                    var t;
                    return null != e ? ("array" === Ae(e) ? a = [(n = e)[0], e[e.length - 1]] : (t = x.analyze(a), n = 0 === e ? [t.min, t.max] : x.limits(t, "e", e)), v) : n;
                  }, v.domain = function (e) {
                    var t, n, r, o, s, c, d;
                    if (!arguments.length) return a;
                    if (u = e[0], l = e[e.length - 1], p = [], r = i.length, e.length === r && u !== l) for (s = 0, o = e.length; s < o; s++) n = e[s], p.push((n - u) / (l - u));else for (t = d = 0, c = r - 1; 0 <= c ? d <= c : c <= d; t = 0 <= c ? ++d : --d) p.push(t / (r - 1));
                    return a = [u, l], v;
                  }, v.mode = function (e) {
                    return arguments.length ? (c = e, _(), v) : c;
                  }, v.range = function (e, t) {
                    return w(e), v;
                  }, v.out = function (e) {
                    return h = e, v;
                  }, v.spread = function (e) {
                    return arguments.length ? (m = e, v) : m;
                  }, v.correctLightness = function (e) {
                    return null == e && (e = !0), o = e, _(), S = o ? function (e) {
                      var t, n, r, i, o, a, s, l;
                      for (t = b(0, !0).lab()[0], a = (n = b(1, !0).lab()[0]) < t, r = b(e, !0).lab()[0] - (i = t + (n - t) * e), s = 0, l = 1, o = 20; .01 < Math.abs(r) && 0 < o--;) a && (r *= -1), e += r < 0 ? .5 * (l - (s = e)) : .5 * (s - (l = e)), r = b(e, !0).lab()[0] - i;
                      return e;
                    } : function (e) {
                      return e;
                    }, v;
                  }, v.padding = function (e) {
                    return null != e ? ("number" === Ae(e) && (e = [e, e]), f = e, v) : f;
                  }, v.colors = function (t, r) {
                    var o, s, l, u, c, d, h, f;
                    if (arguments.length < 2 && (r = "hex"), c = [], 0 === arguments.length) c = i.slice(0);else if (1 === t) c = [v(.5)];else if (1 < t) s = a[0], o = a[1] - s, c = function () {
                      d = [];
                      for (var e = 0; 0 <= t ? e < t : t < e; 0 <= t ? e++ : e--) d.push(e);
                      return d;
                    }.apply(this).map(function (e) {
                      return v(s + e / (t - 1) * o);
                    });else {
                      if (e = [], h = [], n && 2 < n.length) for (l = f = 1, u = n.length; 1 <= u ? f < u : u < f; l = 1 <= u ? ++f : --f) h.push(.5 * (n[l - 1] + n[l]));else h = a;
                      c = h.map(function (e) {
                        return v(e);
                      });
                    }
                    return x[r] && (c = c.map(function (e) {
                      return e[r]();
                    })), c;
                  }, v.cache = function (e) {
                    return null != e ? (g = e, v) : g;
                  }, v.gamma = function (e) {
                    return null != e ? (s = e, v) : s;
                  }, v;
                }, null == x.scales && (x.scales = {}), x.scales.cool = function () {
                  return x.scale([x.hsl(180, 1, .9), x.hsl(250, .7, .4)]);
                }, x.scales.hot = function () {
                  return x.scale(["#000", "#f00", "#ff0", "#fff"], [0, .25, .75, 1]).mode("rgb");
                }, x.analyze = function (e, t, n) {
                  var r, i, o, a, s, l;
                  if (s = {
                    min: Number.MAX_VALUE,
                    max: -1 * Number.MAX_VALUE,
                    sum: 0,
                    values: [],
                    count: 0
                  }, null == n && (n = function n() {
                    return !0;
                  }), r = function r(e) {
                    null == e || isNaN(e) || (s.values.push(e), s.sum += e, e < s.min && (s.min = e), e > s.max && (s.max = e), s.count += 1);
                  }, l = function l(e, i) {
                    if (n(e, i)) return null != t && "function" === Ae(t) ? r(t(e)) : null != t && "string" === Ae(t) || "number" === Ae(t) ? r(e[t]) : r(e);
                  }, "array" === Ae(e)) for (a = 0, o = e.length; a < o; a++) l(e[a]);else for (i in e) l(e[i], i);
                  return s.domain = [s.min, s.max], s.limits = function (e, t) {
                    return x.limits(s, e, t);
                  }, s;
                }, x.limits = function (e, t, n) {
                  var r, i, o, a, s, l, u, c, d, h, f, m, g, v, y, b, _, w, S, A, E, T, M, C, P, O, R, I, j, N, L, D, B, F, z, U, G, V, H, q, W, $, X, K, Z, J, ee, te, re, ie, oe, ae, se, le, ue;
                  if (null == t && (t = "equal"), null == n && (n = 7), "array" === Ae(e) && (e = x.analyze(e)), P = e.min, Q = e.max, e.sum, le = e.values.sort(function (e, t) {
                    return e - t;
                  }), 1 === n) return [P, Q];
                  if (M = [], "c" === t.substr(0, 1) && (M.push(P), M.push(Q)), "e" === t.substr(0, 1)) {
                    for (M.push(P), A = L = 1, z = n - 1; 1 <= z ? L <= z : z <= L; A = 1 <= z ? ++L : --L) M.push(P + A / n * (Q - P));
                    M.push(Q);
                  } else if ("l" === t.substr(0, 1)) {
                    if (P <= 0) throw "Logarithmic scales are only possible for values > 0";
                    for (O = Math.LOG10E * Y(P), C = Math.LOG10E * Y(Q), M.push(P), A = ue = 1, U = n - 1; 1 <= U ? ue <= U : U <= ue; A = 1 <= U ? ++ue : --ue) M.push(ne(10, O + A / n * (C - O)));
                    M.push(Q);
                  } else if ("q" === t.substr(0, 1)) {
                    for (M.push(P), A = r = 1, $ = n - 1; 1 <= $ ? r <= $ : $ <= r; A = 1 <= $ ? ++r : --r) D = (le.length - 1) * A / n, (B = k(D)) === D ? M.push(le[B]) : (F = D - B, M.push(le[B] * (1 - F) + le[B + 1] * F));
                    M.push(Q);
                  } else if ("k" === t.substr(0, 1)) {
                    for (I = le.length, v = new Array(I), w = new Array(n), ie = !0, j = 0, b = null, (b = []).push(P), A = i = 1, X = n - 1; 1 <= X ? i <= X : X <= i; A = 1 <= X ? ++i : --i) b.push(P + A / n * (Q - P));
                    for (b.push(Q); ie;) {
                      for (E = o = 0, K = n - 1; 0 <= K ? o <= K : K <= o; E = 0 <= K ? ++o : --o) w[E] = 0;
                      for (A = a = 0, Z = I - 1; 0 <= Z ? a <= Z : Z <= a; A = 0 <= Z ? ++a : --a) {
                        for (se = le[A], R = Number.MAX_VALUE, E = s = 0, J = n - 1; 0 <= J ? s <= J : J <= s; E = 0 <= J ? ++s : --s) (S = p(b[E] - se)) < R && (R = S, y = E);
                        w[y]++, v[A] = y;
                      }
                      for (N = new Array(n), E = l = 0, ee = n - 1; 0 <= ee ? l <= ee : ee <= l; E = 0 <= ee ? ++l : --l) N[E] = null;
                      for (A = u = 0, te = I - 1; 0 <= te ? u <= te : te <= u; A = 0 <= te ? ++u : --u) null === N[_ = v[A]] ? N[_] = le[A] : N[_] += le[A];
                      for (E = c = 0, re = n - 1; 0 <= re ? c <= re : re <= c; E = 0 <= re ? ++c : --c) N[E] *= 1 / w[E];
                      for (ie = !1, E = d = 0, G = n - 1; 0 <= G ? d <= G : G <= d; E = 0 <= G ? ++d : --d) if (N[E] !== b[A]) {
                        ie = !0;
                        break;
                      }
                      b = N, 200 < ++j && (ie = !1);
                    }
                    for (T = {}, E = h = 0, V = n - 1; 0 <= V ? h <= V : V <= h; E = 0 <= V ? ++h : --h) T[E] = [];
                    for (A = f = 0, H = I - 1; 0 <= H ? f <= H : H <= f; A = 0 <= H ? ++f : --f) T[_ = v[A]].push(le[A]);
                    for (oe = [], E = m = 0, q = n - 1; 0 <= q ? m <= q : q <= m; E = 0 <= q ? ++m : --m) oe.push(T[E][0]), oe.push(T[E][T[E].length - 1]);
                    for (oe = oe.sort(function (e, t) {
                      return e - t;
                    }), M.push(oe[0]), A = g = 1, W = oe.length - 1; g <= W; A = g += 2) ae = oe[A], isNaN(ae) || -1 !== M.indexOf(ae) || M.push(ae);
                  }
                  return M;
                }, R = function R(e, t, n) {
                  var r, i, o, s;
                  return e = (r = Ee(arguments))[0], t = r[1], n = r[2], isNaN(e) && (e = 0), (e /= 360) < 1 / 3 ? o = 1 - ((i = (1 - t) / 3) + (s = (1 + t * A(l * e) / A(a - l * e)) / 3)) : e < 2 / 3 ? i = 1 - ((s = (1 - t) / 3) + (o = (1 + t * A(l * (e -= 1 / 3)) / A(a - l * e)) / 3)) : s = 1 - ((o = (1 - t) / 3) + (i = (1 + t * A(l * (e -= 2 / 3)) / A(a - l * e)) / 3)), [255 * (s = X(n * s * 3)), 255 * (o = X(n * o * 3)), 255 * (i = X(n * i * 3)), 3 < r.length ? r[3] : 1];
                }, se = function se() {
                  var e, t, n, r, i, o, a;
                  return i = (o = Ee(arguments))[0], t = o[1], e = o[2], l = 2 * Math.PI, i /= 255, t /= 255, e /= 255, 0 == (a = 1 - Math.min(i, t, e) / (r = (i + t + e) / 3)) ? n = 0 : (n = (i - t + (i - e)) / 2, n /= Math.sqrt((i - t) * (i - t) + (i - e) * (t - e)), n = Math.acos(n), t < e && (n = l - n), n /= l), [360 * n, a, r];
                }, x.hsi = function () {
                  return function (e, t, n) {
                    n.prototype = e.prototype;
                    var r = new n(),
                      i = e.apply(r, t);
                    return Object(i) === i ? i : r;
                  }(n, ke.call(arguments).concat(["hsi"]), function () {});
                }, h.hsi = R, n.prototype.hsi = function () {
                  return se(this._rgb);
                }, D = function D(e, t, n, r) {
                  var i, o, a, s, l, u, c, d, h, f;
                  return "hsl" === r ? (h = e.hsl(), f = t.hsl()) : "hsv" === r ? (h = e.hsv(), f = t.hsv()) : "hcg" === r ? (h = e.hcg(), f = t.hcg()) : "hsi" === r ? (h = e.hsi(), f = t.hsi()) : "lch" !== r && "hcl" !== r || (r = "hcl", h = e.hcl(), f = t.hcl()), "h" === r.substr(0, 1) && (o = h[0], c = h[1], s = h[2], a = f[0], d = f[1], l = f[2]), isNaN(o) || isNaN(a) ? isNaN(o) ? isNaN(a) ? i = Number.NaN : (i = a, 1 !== s && 0 !== s || "hsv" === r || (u = d)) : (i = o, 1 !== l && 0 !== l || "hsv" === r || (u = c)) : i = o + n * (o < a && 180 < a - o ? a - (o + 360) : a < o && 180 < o - a ? a + 360 - o : a - o), null == u && (u = c + n * (d - c)), x[r](i, u, s + n * (l - s));
                }, z = function z(e, t, n, r) {
                  var i, o;
                  return i = e.num(), o = t.num(), x.num(i + (o - i) * n, "num");
                }, (f = f.concat(function () {
                  var e, t, n, r;
                  for (r = [], t = 0, e = (n = ["hsv", "hsl", "hsi", "hcl", "lch", "hcg"]).length; t < e; t++) Z = n[t], r.push([Z, D]);
                  return r;
                }())).push(["num", z]), B = function B(e, t, r, i) {
                  var o, a;
                  return o = e.lab(), a = t.lab(), new n(o[0] + r * (a[0] - o[0]), o[1] + r * (a[1] - o[1]), o[2] + r * (a[2] - o[2]), i);
                }, f.push(["lab", B]);
              }).call(ec);
            }).scale,
            rc = {
              scale: "uniform",
              mode: "hcl",
              domain: [0, 1],
              value: 16777215,
              reverse: !1
            },
            ic = new Fe(),
            oc = function oc(e) {
              void 0 === e && (e = {}), this.parameters = Su(e, rc), "string" == typeof this.parameters.value && (this.parameters.value = ic.set(this.parameters.value).getHex()), this.parameters.structure && (this.atomProxy = this.parameters.structure.getAtomProxy());
            };
          oc.prototype.getScale = function (e) {
            void 0 === e && (e = {});
            var t = Su(e, this.parameters);
            return "rainbow" === t.scale ? t.scale = ["red", "orange", "yellow", "green", "blue"] : "rwb" === t.scale && (t.scale = ["red", "white", "blue"]), t.reverse && t.domain.reverse(), nc(t.scale).mode(t.mode).domain(t.domain).out("num");
          }, oc.prototype.colorToArray = function (e, t, n) {
            return void 0 === t && (t = []), void 0 === n && (n = 0), t[n] = (e >> 16 & 255) / 255, t[n + 1] = (e >> 8 & 255) / 255, t[n + 2] = (255 & e) / 255, t;
          }, oc.prototype.atomColorToArray = function (e, t, n) {
            return this.colorToArray(this.atomColor ? this.atomColor(e) : 0, t, n);
          }, oc.prototype.bondColor = function (e, t) {
            return this.atomProxy && this.atomColor ? (this.atomProxy.index = t ? e.atomIndex1 : e.atomIndex2, this.atomColor(this.atomProxy)) : 0;
          }, oc.prototype.bondColorToArray = function (e, t, n, r) {
            return this.colorToArray(this.bondColor(e, t), n, r);
          }, oc.prototype.volumeColorToArray = function (e, t, n) {
            return this.colorToArray(this.volumeColor ? this.volumeColor(e) : 0, t, n);
          }, oc.prototype.positionColorToArray = function (e, t, n) {
            return this.colorToArray(this.positionColor ? this.positionColor(e) : 0, t, n);
          };
          var ac,
            sc,
            lc = tc(function (e) {
              !function (t) {
                function n(e, t, n, r, i) {
                  this._listener = t, this._isOnce = n, this.context = r, this._signal = e, this._priority = i || 0;
                }
                function r(e, t) {
                  if ("function" != typeof e) throw new Error("listener is a required param of {fn}() and should be a Function.".replace("{fn}", t));
                }
                function i() {
                  this._bindings = [], this._prevParams = null;
                  var e = this;
                  this.dispatch = function () {
                    i.prototype.dispatch.apply(e, arguments);
                  };
                }
                i.prototype = {
                  VERSION: "1.0.0",
                  memorize: !(n.prototype = {
                    active: !0,
                    params: null,
                    execute: function execute(e) {
                      var t, n;
                      return this.active && this._listener && (n = this.params ? this.params.concat(e) : e, t = this._listener.apply(this.context, n), this._isOnce && this.detach()), t;
                    },
                    detach: function detach() {
                      return this.isBound() ? this._signal.remove(this._listener, this.context) : null;
                    },
                    isBound: function isBound() {
                      return !!this._signal && !!this._listener;
                    },
                    isOnce: function isOnce() {
                      return this._isOnce;
                    },
                    getListener: function getListener() {
                      return this._listener;
                    },
                    getSignal: function getSignal() {
                      return this._signal;
                    },
                    _destroy: function _destroy() {
                      delete this._signal, delete this._listener, delete this.context;
                    },
                    toString: function toString() {
                      return "[SignalBinding isOnce:" + this._isOnce + ", isBound:" + this.isBound() + ", active:" + this.active + "]";
                    }
                  }),
                  _shouldPropagate: !0,
                  active: !0,
                  _registerListener: function _registerListener(e, t, r, i) {
                    var o,
                      a = this._indexOfListener(e, r);
                    if (-1 !== a) {
                      if ((o = this._bindings[a]).isOnce() !== t) throw new Error("You cannot add" + (t ? "" : "Once") + "() then add" + (t ? "Once" : "") + "() the same listener without removing the relationship first.");
                    } else o = new n(this, e, t, r, i), this._addBinding(o);
                    return this.memorize && this._prevParams && o.execute(this._prevParams), o;
                  },
                  _addBinding: function _addBinding(e) {
                    for (var t = this._bindings.length; --t, this._bindings[t] && e._priority <= this._bindings[t]._priority;);
                    this._bindings.splice(t + 1, 0, e);
                  },
                  _indexOfListener: function _indexOfListener(e, t) {
                    for (var n, r = this._bindings.length; r--;) if ((n = this._bindings[r])._listener === e && n.context === t) return r;
                    return -1;
                  },
                  has: function has(e, t) {
                    return -1 !== this._indexOfListener(e, t);
                  },
                  add: function add(e, t, n) {
                    return r(e, "add"), this._registerListener(e, !1, t, n);
                  },
                  addOnce: function addOnce(e, t, n) {
                    return r(e, "addOnce"), this._registerListener(e, !0, t, n);
                  },
                  remove: function remove(e, t) {
                    r(e, "remove");
                    var n = this._indexOfListener(e, t);
                    return -1 !== n && (this._bindings[n]._destroy(), this._bindings.splice(n, 1)), e;
                  },
                  removeAll: function removeAll() {
                    for (var e = this._bindings.length; e--;) this._bindings[e]._destroy();
                    this._bindings.length = 0;
                  },
                  getNumListeners: function getNumListeners() {
                    return this._bindings.length;
                  },
                  halt: function halt() {
                    this._shouldPropagate = !1;
                  },
                  dispatch: function dispatch(e) {
                    if (this.active) {
                      var t,
                        n = Array.prototype.slice.call(arguments),
                        r = this._bindings.length;
                      if (this.memorize && (this._prevParams = n), r) for (t = this._bindings.slice(), this._shouldPropagate = !0; t[--r] && this._shouldPropagate && !1 !== t[r].execute(n););
                    }
                  },
                  forget: function forget() {
                    this._prevParams = null;
                  },
                  dispose: function dispose() {
                    this.removeAll(), delete this._bindings, delete this._prevParams;
                  },
                  toString: function toString() {
                    return "[Signal active:" + this.active + " numListeners:" + this.getNumListeners() + "]";
                  }
                };
                var o = i;
                o.Signal = i, e.exports ? e.exports = o : t.signals = o;
              }(ec);
            }).Signal;
          (sc = ac || (ac = {}))[sc.PROTEIN = 1] = "PROTEIN", sc[sc.NUCLEIC = 2] = "NUCLEIC", sc[sc.RNA = 3] = "RNA", sc[sc.DNA = 4] = "DNA", sc[sc.POLYMER = 5] = "POLYMER", sc[sc.WATER = 6] = "WATER", sc[sc.HELIX = 7] = "HELIX", sc[sc.SHEET = 8] = "SHEET", sc[sc.TURN = 9] = "TURN", sc[sc.BACKBONE = 10] = "BACKBONE", sc[sc.SIDECHAIN = 11] = "SIDECHAIN", sc[sc.ALL = 12] = "ALL", sc[sc.HETERO = 13] = "HETERO", sc[sc.ION = 14] = "ION", sc[sc.SACCHARIDE = 15] = "SACCHARIDE", sc[sc.SUGAR = 15] = "SUGAR", sc[sc.BONDED = 16] = "BONDED", sc[sc.RING = 17] = "RING", sc[sc.AROMATICRING = 18] = "AROMATICRING", sc[sc.METAL = 19] = "METAL", sc[sc.NONE = 20] = "NONE";
          var uc = ["*", "", "ALL"],
            cc = ["NONE"],
            dc = [ac.BACKBONE, ac.SIDECHAIN, ac.BONDED, ac.RING, ac.AROMATICRING, ac.METAL],
            hc = [ac.POLYMER, ac.WATER],
            fc = ["ALA", "GLY", "SER"],
            pc = ["CYS", "SER", "THR"],
            mc = ["ALA", "ILE", "LEU", "MET", "PHE", "PRO", "TRP", "VAL"],
            gc = ["PHE", "TRP", "TYR", "HIS"],
            vc = ["ASN", "GLN"],
            yc = ["ASP", "GLU"],
            bc = ["ARG", "HIS", "LYS"],
            _c = ["ARG", "ASP", "GLU", "HIS", "LYS"],
            xc = ["ASN", "ARG", "ASP", "CYS", "GLY", "GLN", "GLU", "HIS", "LYS", "SER", "THR", "TYR"],
            wc = ["ALA", "ILE", "LEU", "MET", "PHE", "PRO", "TRP", "VAL"],
            Sc = ["HIS", "PHE", "PRO", "TRP", "TYR"],
            Ac = ["ALA", "GLY", "ILE", "LEU", "VAL"];
          function Ec(e, t) {
            if (void 0 === t.atomname && void 0 === t.element && void 0 === t.altloc && void 0 === t.atomindex && void 0 === t.keyword && void 0 === t.inscode && void 0 === t.resname && void 0 === t.sstruc && void 0 === t.resno && void 0 === t.chainname && void 0 === t.model) return -1;
            if (void 0 !== t.keyword) {
              if (t.keyword === ac.BACKBONE && !e.isBackbone()) return !1;
              if (t.keyword === ac.SIDECHAIN && !e.isSidechain()) return !1;
              if (t.keyword === ac.BONDED && !e.isBonded()) return !1;
              if (t.keyword === ac.RING && !e.isRing()) return !1;
              if (t.keyword === ac.AROMATICRING && !e.isAromatic()) return !1;
              if (t.keyword === ac.HETERO && !e.isHetero()) return !1;
              if (t.keyword === ac.PROTEIN && !e.isProtein()) return !1;
              if (t.keyword === ac.NUCLEIC && !e.isNucleic()) return !1;
              if (t.keyword === ac.RNA && !e.isRna()) return !1;
              if (t.keyword === ac.DNA && !e.isDna()) return !1;
              if (t.keyword === ac.POLYMER && !e.isPolymer()) return !1;
              if (t.keyword === ac.WATER && !e.isWater()) return !1;
              if (t.keyword === ac.HELIX && !e.isHelix()) return !1;
              if (t.keyword === ac.SHEET && !e.isSheet()) return !1;
              if (t.keyword === ac.TURN && !e.isTurn()) return !1;
              if (t.keyword === ac.ION && !e.isIon()) return !1;
              if (t.keyword === ac.SACCHARIDE && !e.isSaccharide()) return !1;
              if (t.keyword === ac.METAL && !e.isMetal()) return !1;
            }
            if (void 0 !== t.atomname && t.atomname !== e.atomname) return !1;
            if (void 0 !== t.element && t.element !== e.element) return !1;
            if (void 0 !== t.altloc && t.altloc !== e.altloc) return !1;
            if (void 0 !== t.atomindex && Pu(t.atomindex, e.index) < 0) return !1;
            if (void 0 !== t.resname) if (Array.isArray(t.resname)) {
              if (!t.resname.includes(e.resname)) return !1;
            } else if (t.resname !== e.resname) return !1;
            if (void 0 !== t.sstruc && t.sstruc !== e.sstruc) return !1;
            if (void 0 !== t.resno) if (Array.isArray(t.resno) && 2 === t.resno.length) {
              if (t.resno[0] > e.resno || t.resno[1] < e.resno) return !1;
            } else if (t.resno !== e.resno) return !1;
            return !(void 0 !== t.inscode && t.inscode !== e.inscode || void 0 !== t.chainname && t.chainname !== e.chainname || void 0 !== t.model && t.model !== e.modelIndex);
          }
          function Tc(e, t) {
            if (void 0 === t.resname && void 0 === t.resno && void 0 === t.inscode && void 0 === t.sstruc && void 0 === t.model && void 0 === t.chainname && void 0 === t.atomindex && (void 0 === t.keyword || dc.includes(t.keyword))) return -1;
            if (void 0 !== t.keyword) {
              if (t.keyword === ac.HETERO && !e.isHetero()) return !1;
              if (t.keyword === ac.PROTEIN && !e.isProtein()) return !1;
              if (t.keyword === ac.NUCLEIC && !e.isNucleic()) return !1;
              if (t.keyword === ac.RNA && !e.isRna()) return !1;
              if (t.keyword === ac.DNA && !e.isDna()) return !1;
              if (t.keyword === ac.POLYMER && !e.isPolymer()) return !1;
              if (t.keyword === ac.WATER && !e.isWater()) return !1;
              if (t.keyword === ac.HELIX && !e.isHelix()) return !1;
              if (t.keyword === ac.SHEET && !e.isSheet()) return !1;
              if (t.keyword === ac.TURN && !e.isTurn()) return !1;
              if (t.keyword === ac.ION && !e.isIon()) return !1;
              if (t.keyword === ac.SACCHARIDE && !e.isSaccharide()) return !1;
            }
            if (void 0 !== t.atomindex && 0 === Ou(t.atomindex, e.atomOffset, e.atomEnd)) return !1;
            if (void 0 !== t.resname) if (Array.isArray(t.resname)) {
              if (!t.resname.includes(e.resname)) return !1;
            } else if (t.resname !== e.resname) return !1;
            if (void 0 !== t.sstruc && t.sstruc !== e.sstruc) return !1;
            if (void 0 !== t.resno) if (Array.isArray(t.resno) && 2 === t.resno.length) {
              if (t.resno[0] > e.resno || t.resno[1] < e.resno) return !1;
            } else if (t.resno !== e.resno) return !1;
            return !(void 0 !== t.inscode && t.inscode !== e.inscode || void 0 !== t.chainname && t.chainname !== e.chainname || void 0 !== t.model && t.model !== e.modelIndex);
          }
          function Mc(e, t) {
            if (!(void 0 !== t.chainname || void 0 !== t.model || void 0 !== t.atomindex || void 0 !== t.keyword && hc.includes(t.keyword) && e.entity)) return -1;
            if (void 0 !== t.keyword) {
              if (t.keyword === ac.POLYMER && !e.entity.isPolymer()) return !1;
              if (t.keyword === ac.WATER && !e.entity.isWater()) return !1;
            }
            return !(void 0 !== t.atomindex && 0 === Ou(t.atomindex, e.atomOffset, e.atomEnd) || void 0 !== t.chainname && t.chainname !== e.chainname || void 0 !== t.model && t.model !== e.modelIndex);
          }
          function Cc(e, t) {
            return void 0 === t.model && void 0 === t.atomindex ? -1 : !(void 0 !== t.atomindex && 0 === Ou(t.atomindex, e.atomOffset, e.atomEnd) || void 0 !== t.model && t.model !== e.index);
          }
          function kc(e, t) {
            if (null === e) return !1;
            if (e.error) return !1;
            if (!e.rules || 0 === e.rules.length) return !1;
            for (var n = e.rules.length, r = !e.negate, i = !!e.negate, o = [], a = 0; a < n; ++a) {
              var s = e.rules[a];
              s.hasOwnProperty("operator") && (o[a] = kc(s, t));
            }
            return function (a) {
              for (var s = "AND" === e.operator, l = !1, u = 0; u < n; ++u) {
                var c = e.rules[u],
                  d = void 0;
                if (c.hasOwnProperty("operator")) {
                  var h = o[u];
                  if (-1 === (d = !1 !== h ? h(a) : -1)) {
                    l = !0;
                    continue;
                  }
                  if (!0 === d) {
                    if (s) continue;
                    return r;
                  }
                  if (s) return i;
                } else {
                  if (c.keyword === ac.ALL) {
                    if (s) continue;
                    return r;
                  }
                  if (c.keyword === ac.NONE) {
                    if (s) continue;
                    return i;
                  }
                  if (-1 !== (d = t(a, c))) {
                    if (!0 === d) {
                      if (s) continue;
                      return r;
                    }
                    if (s) return i;
                  } else l = !0;
                }
              }
              return l ? -1 : s ? r : i;
            };
          }
          function Pc(e, t) {
            if (e.error) return e;
            if (!e.rules || 0 === e.rules.length) return e;
            var n = e.rules.length,
              r = {
                operator: e.operator,
                rules: []
              };
            e.hasOwnProperty("negate") && (r.negate = e.negate);
            for (var i = 0; i < n; ++i) {
              var o = e.rules[i];
              if (o.hasOwnProperty("operator")) {
                var a = Pc(o, t);
                null !== a && r.rules.push(a);
              } else t(o) || r.rules.push(o);
            }
            return 0 < r.rules.length ? e : null;
          }
          function Oc(e, t) {
            void 0 === t && (t = !1);
            var n = e;
            return t && (n = Pc(e, function (e) {
              return void 0 !== e.keyword && !dc.includes(e.keyword) || void 0 !== e.model || void 0 !== e.chainname || void 0 !== e.resname || void 0 !== e.resno || void 0 !== e.sstruc;
            })), kc(n, Ec);
          }
          function Rc(e, t) {
            void 0 === t && (t = !1);
            var n = e;
            return t && (n = Pc(e, function (e) {
              return !(void 0 === e.keyword || !dc.includes(e.keyword)) || void 0 !== e.model || void 0 !== e.chainname || void 0 !== e.atomname || void 0 !== e.element || void 0 !== e.altloc;
            })), kc(n, Tc);
          }
          function Ic(e, t) {
            void 0 === t && (t = !1);
            var n = e;
            return t && (n = Pc(e, function (e) {
              return void 0 !== e.keyword && !hc.includes(e.keyword) || void 0 !== e.resname || void 0 !== e.resno || void 0 !== e.atomname || void 0 !== e.element || void 0 !== e.altloc || void 0 !== e.sstruc || void 0 !== e.inscode;
            })), kc(n, Mc);
          }
          function jc(e, t) {
            void 0 === t && (t = !1);
            var n = e;
            return t && (n = Pc(e, function (e) {
              return void 0 !== e.keyword || void 0 !== e.chainname || void 0 !== e.resname || void 0 !== e.resno || void 0 !== e.atomname || void 0 !== e.element || void 0 !== e.altloc || void 0 !== e.sstruc || void 0 !== e.inscode;
            })), kc(n, Cc);
          }
          var Nc = function Nc(e) {
              this.signals = {
                stringChanged: new lc()
              }, this.setString(e);
            },
            Lc = {
              type: {
                configurable: !0
              }
            };
          Lc.type.get = function () {
            return "selection";
          }, Nc.prototype.setString = function (e, t) {
            if (void 0 === e && (e = this.string || ""), e !== this.string) {
              try {
                this.selection = function (e) {
                  var t = {
                    operator: void 0,
                    rules: []
                  };
                  if (!e) return t;
                  var n,
                    r,
                    i = t,
                    o = [];
                  "(" === (e = e.replace(/\(/g, " ( ").replace(/\)/g, " ) ").trim()).charAt(0) && ")" === e.substr(-1) && (e = e.slice(1, -1).trim());
                  for (var a = e.split(/\s+/), s = function s(e) {
                      n = {
                        operator: e,
                        rules: []
                      }, void 0 === i ? t = i = n : (i.rules.push(n), o.push(i), i = n);
                    }, l = function l(e) {
                      r = i, void 0 === (i = o.pop()) && (s(e), u(r));
                    }, u = function u(e) {
                      i.rules.push(e);
                    }, c = !1, d = 0; d < a.length; ++d) {
                    var h = a[d],
                      f = h.toUpperCase();
                    if ("(" !== h) {
                      if (")" !== h) {
                        if (0 < c) if ("NOT" === f) c = 1;else if (1 === c) c = 2;else {
                          if (2 !== c) throw new Error("something went wrong with 'not'");
                          c = !1, l();
                        }
                        if ("AND" !== f) {
                          if ("OR" !== f) {
                            if ("NOT" !== h.toUpperCase()) {
                              if (+f != +f) {
                                var p = ac[f];
                                if (void 0 !== p) {
                                  u({
                                    keyword: p
                                  });
                                  continue;
                                }
                              }
                              if ("HYDROGEN" !== f) {
                                if ("SMALL" !== f) {
                                  if ("NUCLEOPHILIC" !== f) {
                                    if ("HYDROPHOBIC" !== f) {
                                      if ("AROMATIC" !== f) {
                                        if ("AMIDE" !== f) {
                                          if ("ACIDIC" !== f) {
                                            if ("BASIC" !== f) {
                                              if ("CHARGED" !== f) {
                                                if ("POLAR" !== f) {
                                                  if ("NONPOLAR" !== f) {
                                                    if ("CYCLIC" !== f) {
                                                      if ("ALIPHATIC" !== f) {
                                                        if ("SIDECHAINATTACHED" !== f) {
                                                          if ("LIGAND" !== f) {
                                                            if (-1 === uc.indexOf(f)) {
                                                              if ("@" !== h.charAt(0)) {
                                                                if ("#" !== h.charAt(0)) {
                                                                  if ("_" !== h.charAt(0)) {
                                                                    if ("[" !== h[0] || "]" !== h[h.length - 1]) {
                                                                      if (1 <= h.length && h.length <= 4 && "^" !== h[0] && ":" !== h[0] && "." !== h[0] && "%" !== h[0] && "/" !== h[0] && isNaN(parseInt(h))) u({
                                                                        resname: f
                                                                      });else {
                                                                        var m = {
                                                                            operator: "AND",
                                                                            rules: []
                                                                          },
                                                                          g = h.split("/");
                                                                        if (1 < g.length && g[1]) {
                                                                          if (isNaN(parseInt(g[1]))) throw new Error("model must be an integer");
                                                                          m.rules.push({
                                                                            model: parseInt(g[1])
                                                                          });
                                                                        }
                                                                        var v = g[0].split("%");
                                                                        1 < v.length && m.rules.push({
                                                                          altloc: v[1]
                                                                        });
                                                                        var y = v[0].split(".");
                                                                        if (1 < y.length && y[1]) {
                                                                          if (4 < y[1].length) throw new Error("atomname must be one to four characters");
                                                                          m.rules.push({
                                                                            atomname: y[1].substring(0, 4).toUpperCase()
                                                                          });
                                                                        }
                                                                        var b = y[0].split(":");
                                                                        1 < b.length && b[1] && m.rules.push({
                                                                          chainname: b[1]
                                                                        });
                                                                        var _ = b[0].split("^");
                                                                        if (1 < _.length && m.rules.push({
                                                                          inscode: _[1]
                                                                        }), _[0]) {
                                                                          var x = void 0,
                                                                            w = void 0;
                                                                          "-" === _[0][0] && (_[0] = _[0].substr(1), x = !0), _[0].includes("--") && (_[0] = _[0].replace("--", "-"), w = !0);
                                                                          var S = _[0].split("-");
                                                                          if (1 === S.length) {
                                                                            var A = parseInt(S[0]);
                                                                            if (isNaN(A)) throw new Error("resi must be an integer");
                                                                            x && (A *= -1), m.rules.push({
                                                                              resno: A
                                                                            });
                                                                          } else {
                                                                            if (2 !== S.length) throw new Error("resi range must contain one '-'");
                                                                            var E = S.map(function (e) {
                                                                              return parseInt(e);
                                                                            });
                                                                            x && (E[0] *= -1), w && (E[1] *= -1), m.rules.push({
                                                                              resno: [E[0], E[1]]
                                                                            });
                                                                          }
                                                                        }
                                                                        if (1 === m.rules.length) u(m.rules[0]);else {
                                                                          if (!(1 < m.rules.length)) throw new Error("empty selection chunk");
                                                                          u(m);
                                                                        }
                                                                      }
                                                                    } else {
                                                                      var T = f.substr(1, h.length - 2).split(","),
                                                                        M = 1 < T.length ? T : T[0];
                                                                      u({
                                                                        resname: M
                                                                      });
                                                                    }
                                                                  } else u({
                                                                    element: f.substr(1)
                                                                  });
                                                                } else console.error("# for element selection deprecated, use _"), u({
                                                                  element: f.substr(1)
                                                                });
                                                              } else {
                                                                var C = h.substr(1).split(",").map(function (e) {
                                                                  return parseInt(e);
                                                                });
                                                                C.sort(function (e, t) {
                                                                  return e - t;
                                                                }), u({
                                                                  atomindex: C
                                                                });
                                                              }
                                                            } else u({
                                                              keyword: ac.ALL
                                                            });
                                                          } else u({
                                                            operator: "AND",
                                                            rules: [{
                                                              operator: "OR",
                                                              rules: [{
                                                                operator: "AND",
                                                                rules: [{
                                                                  keyword: ac.HETERO
                                                                }, {
                                                                  negate: !0,
                                                                  operator: void 0,
                                                                  rules: [{
                                                                    keyword: ac.POLYMER
                                                                  }]
                                                                }]
                                                              }, {
                                                                negate: !0,
                                                                operator: void 0,
                                                                rules: [{
                                                                  keyword: ac.POLYMER
                                                                }]
                                                              }]
                                                            }, {
                                                              negate: !0,
                                                              operator: void 0,
                                                              rules: [{
                                                                operator: "OR",
                                                                rules: [{
                                                                  keyword: ac.WATER
                                                                }, {
                                                                  keyword: ac.ION
                                                                }]
                                                              }]
                                                            }]
                                                          });
                                                        } else u({
                                                          operator: "OR",
                                                          rules: [{
                                                            keyword: ac.SIDECHAIN
                                                          }, {
                                                            operator: "AND",
                                                            negate: !1,
                                                            rules: [{
                                                              keyword: ac.PROTEIN
                                                            }, {
                                                              operator: "OR",
                                                              negate: !1,
                                                              rules: [{
                                                                atomname: "CA"
                                                              }, {
                                                                atomname: "BB"
                                                              }]
                                                            }]
                                                          }, {
                                                            operator: "AND",
                                                            negate: !1,
                                                            rules: [{
                                                              resname: "PRO"
                                                            }, {
                                                              atomname: "N"
                                                            }]
                                                          }, {
                                                            operator: "AND",
                                                            negate: !1,
                                                            rules: [{
                                                              keyword: ac.NUCLEIC
                                                            }, {
                                                              operator: "OR",
                                                              negate: !0,
                                                              rules: [{
                                                                atomname: "P"
                                                              }, {
                                                                atomname: "OP1"
                                                              }, {
                                                                atomname: "OP2"
                                                              }, {
                                                                atomname: "O3'"
                                                              }, {
                                                                atomname: "O3*"
                                                              }, {
                                                                atomname: "O5'"
                                                              }, {
                                                                atomname: "O5*"
                                                              }, {
                                                                atomname: "C5'"
                                                              }, {
                                                                atomname: "C5*"
                                                              }]
                                                            }]
                                                          }]
                                                        });
                                                      } else u({
                                                        resname: Ac
                                                      });
                                                    } else u({
                                                      resname: Sc
                                                    });
                                                  } else u({
                                                    resname: wc
                                                  });
                                                } else u({
                                                  resname: xc
                                                });
                                              } else u({
                                                resname: _c
                                              });
                                            } else u({
                                              resname: bc
                                            });
                                          } else u({
                                            resname: yc
                                          });
                                        } else u({
                                          resname: vc
                                        });
                                      } else u({
                                        resname: gc
                                      });
                                    } else u({
                                      resname: mc
                                    });
                                  } else u({
                                    resname: pc
                                  });
                                } else u({
                                  resname: fc
                                });
                              } else u({
                                operator: "OR",
                                rules: [{
                                  element: "H"
                                }, {
                                  element: "D"
                                }]
                              });
                            } else c = 1, s(), i.negate = !0;
                          } else "AND" === i.operator ? l("OR") : i.operator = "OR";
                        } else if ("OR" === i.operator) {
                          var k = i.rules.pop();
                          s("AND"), u(k);
                        } else i.operator = "AND";
                      } else l(), i.negate && l();
                    } else c = !1, s();
                  }
                  return void 0 === t.operator && 1 === t.rules.length && t.rules[0].hasOwnProperty("operator") && (t = t.rules[0]), t;
                }(e);
              } catch (e) {
                this.selection = {
                  error: e.message
                };
              }
              var n = this.selection;
              this.string = e, this.test = Oc(n), this.residueTest = Rc(n), this.chainTest = Ic(n), this.modelTest = jc(n), this.atomOnlyTest = Oc(n, !0), this.residueOnlyTest = Rc(n, !0), this.chainOnlyTest = Ic(n, !0), this.modelOnlyTest = jc(n, !0), t || this.signals.stringChanged.dispatch(this.string);
            }
          }, Nc.prototype.isAllSelection = function () {
            return uc.includes(this.string.toUpperCase());
          }, Nc.prototype.isNoneSelection = function () {
            return cc.includes(this.string.toUpperCase());
          }, Object.defineProperties(Nc.prototype, Lc);
          var Dc = function (e) {
              function t(t) {
                var n = this;
                e.call(this, t), this.colormakerList = [], this.selectionList = [], (t.dataList || []).forEach(function (e) {
                  var t = e[0],
                    r = e[1],
                    i = e[2];
                  void 0 === i && (i = {}), td.hasScheme(t) ? Object.assign(i, {
                    scheme: t,
                    structure: n.parameters.structure
                  }) : Object.assign(i, {
                    scheme: "uniform",
                    value: new Fe(t).getHex()
                  }), n.colormakerList.push(td.getScheme(i)), n.selectionList.push(new Nc(r));
                });
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
                for (var t = 0, n = this.selectionList.length; t < n; ++t) {
                  var r = this.selectionList[t].test;
                  if (r && r(e)) return this.colormakerList[t].atomColor(e);
                }
                return 16777215;
              }, t;
            }(oc),
            Bc = {
              "": "",
              OrRd: "[S] Orange-Red",
              PuBu: "[S] Purple-Blue",
              BuPu: "[S] Blue-Purple",
              Oranges: "[S] Oranges",
              BuGn: "[S] Blue-Green",
              YlOrBr: "[S] Yellow-Orange-Brown",
              YlGn: "[S] Yellow-Green",
              Reds: "[S] Reds",
              RdPu: "[S] Red-Purple",
              Greens: "[S] Greens",
              YlGnBu: "[S] Yellow-Green-Blue",
              Purples: "[S] Purples",
              GnBu: "[S] Green-Blue",
              Greys: "[S] Greys",
              YlOrRd: "[S] Yellow-Orange-Red",
              PuRd: "[S] Purple-Red",
              Blues: "[S] Blues",
              PuBuGn: "[S] Purple-Blue-Green",
              Viridis: "[D] Viridis",
              Spectral: "[D] Spectral",
              RdYlGn: "[D] Red-Yellow-Green",
              RdBu: "[D] Red-Blue",
              PiYG: "[D] Pink-Yellowgreen",
              PRGn: "[D] Purplered-Green",
              RdYlBu: "[D] Red-Yellow-Blue",
              BrBG: "[D] Brown-Bluegreen",
              RdGy: "[D] Red-Grey",
              PuOr: "[D] Purple-Orange",
              Set1: "[Q] Set1",
              Set2: "[Q] Set2",
              Set3: "[Q] Set3",
              Dark2: "[Q] Dark2",
              Paired: "[Q] Paired",
              Pastel1: "[Q] Pastel1",
              Pastel2: "[Q] Pastel2",
              Accent: "[Q] Accent",
              rainbow: "[?] Rainbow",
              rwb: "[?] Red-White-Blue"
            },
            Fc = {
              "": "",
              rgb: "Red Green Blue",
              hsv: "Hue Saturation Value",
              hsl: "Hue Saturation Lightness",
              hsi: "Hue Saturation Intensity",
              lab: "CIE L*a*b*",
              hcl: "Hue Chroma Lightness"
            },
            zc = function zc() {
              this.schemes = {}, this.userSchemes = {};
            };
          zc.prototype.getScheme = function (e) {
            var t = ((e || {}).scheme || "").toLowerCase();
            return new (t in this.schemes ? this.schemes[t] : t in this.userSchemes ? this.userSchemes[t] : oc)(e);
          }, zc.prototype.getSchemes = function () {
            var e = {};
            return Object.keys(this.schemes).forEach(function (t) {
              e[t] = t;
            }), Object.keys(this.userSchemes).forEach(function (t) {
              e[t] = t.split("|")[1];
            }), e;
          }, zc.prototype.getScales = function () {
            return Bc;
          }, zc.prototype.getModes = function () {
            return Fc;
          }, zc.prototype.add = function (e, t) {
            e = e.toLowerCase(), this.schemes[e] = t;
          }, zc.prototype.addScheme = function (e, t) {
            return e instanceof oc || (e = this._createScheme(e)), this._addUserScheme(e, t);
          }, zc.prototype._addUserScheme = function (e, t) {
            t = t || "";
            var n = (Xu() + "|" + t).toLowerCase();
            return this.userSchemes[n] = e, n;
          }, zc.prototype.removeScheme = function (e) {
            e = e.toLowerCase(), delete this.userSchemes[e];
          }, zc.prototype._createScheme = function (e) {
            var t = function t(_t36) {
              oc.call(this, _t36), e.call(this, _t36);
            };
            return (t.prototype = oc.prototype).constructor = oc, t;
          }, zc.prototype.addSelectionScheme = function (e, t) {
            var n = function (t) {
              function n(n) {
                t.call(this, Object.assign({
                  dataList: e
                }, n));
              }
              return t && (n.__proto__ = t), (n.prototype = Object.create(t && t.prototype)).constructor = n;
            }(Dc);
            return this._addUserScheme(n, t);
          }, zc.prototype.hasScheme = function (e) {
            return (e = e.toLowerCase()) in this.schemes || e in this.userSchemes;
          };
          var Uc = function (e) {
            function t() {
              e.call(this, "parser");
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.__hasObjName = function (e, t) {
              var n = this.get(e);
              return n && n.prototype.__objName === t;
            }, t.prototype.isTrajectory = function (e) {
              return this.__hasObjName(e, "frames");
            }, t.prototype.isStructure = function (e) {
              return this.__hasObjName(e, "structure");
            }, t.prototype.isVolume = function (e) {
              return this.__hasObjName(e, "volume");
            }, t.prototype.isSurface = function (e) {
              return this.__hasObjName(e, "surface");
            }, t.prototype.isBinary = function (e) {
              var t = this.get(e);
              return t && t.prototype.isBinary;
            }, t.prototype.isXml = function (e) {
              var t = this.get(e);
              return t && t.prototype.isXml;
            }, t.prototype.isJson = function (e) {
              var t = this.get(e);
              return t && t.prototype.isJson;
            }, t.prototype.getTrajectoryExtensions = function () {
              var e = this;
              return this.names.filter(function (t) {
                return e.isTrajectory(t);
              });
            }, t.prototype.getStructureExtensions = function () {
              var e = this;
              return this.names.filter(function (t) {
                return e.isStructure(t);
              });
            }, t.prototype.getVolumeExtensions = function () {
              var e = this;
              return this.names.filter(function (t) {
                return e.isVolume(t);
              });
            }, t.prototype.getSurfaceExtensions = function () {
              var e = this;
              return this.names.filter(function (t) {
                return e.isSurface(t);
              });
            }, t;
          }(Vu);
          function Gc(e, t) {
            var n = "'use strict';\n\n" + function (e) {
              return Ru(function e(t) {
                var n = t;
                return t.forEach(function (t) {
                  t.__deps && Array.prototype.push.apply(n, e(t.__deps));
                }), n;
              }(e)).map(function (e) {
                return e.toString();
              }).join("\n\n\n");
            }(t);
            return n += "\n\n\nself.func = " + e.toString() + ";", n += "\n\n\nself.onmessage = " + function (e) {
              var t = e.data.__name,
                n = e.data.__postId;
              void 0 === t ? console.error("message __name undefined") : void 0 === self.func ? console.error("worker func undefined", t) : self.func(e, function (e, t) {
                e = e || {}, void 0 !== n && (e.__postId = n);
                try {
                  self.postMessage(e, t);
                } catch (t) {
                  console.error("self.postMessage:", t), self.postMessage(e);
                }
              });
            }.toString() + ";", new Blob([n], {
              type: "application/javascript"
            });
          }
          var Vc = function Vc() {
            this.activeWorkerCount = 0, this._funcDict = {}, this._depsDict = {}, this._blobDict = {};
          };
          Vc.prototype.add = function (e, t, n) {
            this._funcDict[e] = t, this._depsDict[e] = n;
          }, Vc.prototype.get = function (e) {
            return this._blobDict[e] || (this._blobDict[e] = Gc(this._funcDict[e], this._depsDict[e])), this._blobDict[e];
          };
          var Hc = Tu(),
            qc = !1;
          try {
            var Wc = Object.defineProperty({}, "passive", {
              get: function get() {
                qc = !0;
              }
            });
            window.addEventListener("test", function (e) {}, Wc);
          } catch (r) {}
          var $c,
            Xc = "undefined" != typeof window && void 0 !== window.orientation,
            Yc = !1,
            Kc = !1,
            Zc = {
              log: Function.prototype.bind.call(console.log, console),
              info: Function.prototype.bind.call(console.info, console),
              warn: Function.prototype.bind.call(console.warn, console),
              error: Function.prototype.bind.call(console.error, console),
              time: Function.prototype.bind.call(console.time, console),
              timeEnd: Function.prototype.bind.call(console.timeEnd, console)
            },
            Qc = {
              color: "green",
              labelColor: "grey",
              labelAttachment: "bottom-center",
              labelSize: .7,
              labelZOffset: .5,
              labelYOffset: .1,
              labelBorder: !0,
              labelBorderColor: "lightgrey",
              labelBorderWidth: .25,
              lineOpacity: .8,
              linewidth: 5,
              opacity: .6,
              labelUnit: "angstrom",
              arcVisible: !0,
              planeVisible: !1
            };
          t.Debug = !!($c = xu("debug")) && ("string" != typeof $c || /^1|true|t|yes|y$/i.test($c));
          var Jc = ["ngl", "js"],
            ed = new Vc(),
            td = new zc(),
            nd = new Vu("datasource"),
            rd = new Vu("representatation"),
            id = new Uc(),
            od = new Vu("shader"),
            ad = new Vu("decompressor"),
            sd = new Vu("component"),
            ld = new Vu("buffer"),
            ud = new Vu("picker"),
            cd = function cd(e, t) {
              void 0 === t && (t = {}), this.chunkSize = 10485760, this.newline = "\n", this.__pointer = 0, this.__partialLine = "", this.compressed = wu(t.compressed, !1), this.binary = wu(t.binary, !1), this.json = wu(t.json, !1), this.xml = wu(t.xml, !1), this.src = e;
            };
          cd.prototype.isBinary = function () {
            return this.binary || this.compressed;
          }, cd.prototype.read = function () {
            var e = this;
            return this._read().then(function (t) {
              var n = e.compressed ? ad.get(e.compressed) : void 0;
              return e.compressed && n ? e.data = n(t) : ((e.binary || e.compressed) && t instanceof ArrayBuffer && (t = new Uint8Array(t)), e.data = t), e.data;
            });
          }, cd.prototype._chunk = function (e, t) {
            return t = Math.min(this.data.length, t), 0 === e && this.data.length === t ? this.data : this.isBinary() ? this.data.subarray(e, t) : this.data.substring(e, t);
          }, cd.prototype.chunk = function (e) {
            var t = e + this.chunkSize;
            return this._chunk(e, t);
          }, cd.prototype.peekLines = function (e) {
            var t,
              n = this.data,
              r = n.length,
              i = this.isBinary() ? this.newline.charCodeAt(0) : this.newline,
              o = 0;
            for (t = 0; t < r && (n[t] === i && ++o, o !== e); ++t);
            var a = this._chunk(0, t + 1);
            return this.chunkToLines(a, "", r < t).lines;
          }, cd.prototype.chunkCount = function () {
            return Math.floor(this.data.length / this.chunkSize) + 1;
          }, cd.prototype.asText = function () {
            return this.isBinary() ? Iu(this.data) : this.data;
          }, cd.prototype.chunkToLines = function (e, t, n) {
            var r = this.newline;
            if (!this.isBinary() && e.length === this.data.length) return {
              lines: e.split(r),
              partialLine: ""
            };
            var i = [],
              o = this.isBinary() ? Iu(e) : e,
              a = o.lastIndexOf(r);
            if (-1 === a) t += o;else {
              var s = t + o.substr(0, a);
              i = i.concat(s.split(r)), t = a === o.length - r.length ? "" : o.substr(a + r.length);
            }
            return n && "" !== t && i.push(t), {
              lines: i,
              partialLine: t
            };
          }, cd.prototype.nextChunk = function () {
            var e = this.__pointer;
            if (!(e > this.data.length)) return this.__pointer += this.chunkSize, this.chunk(e);
          }, cd.prototype.nextChunkOfLines = function () {
            var e = this.nextChunk();
            if (void 0 !== e) {
              var t = this.__pointer > this.data.length,
                n = this.chunkToLines(e, this.__partialLine, t);
              return this.__partialLine = n.partialLine, n.lines;
            }
          }, cd.prototype.eachChunk = function (e) {
            for (var t = this.chunkSize, n = this.data.length, r = this.chunkCount(), i = 0; i < n; i += t) e(this.chunk(i), Math.round(i / t), r);
          }, cd.prototype.eachChunkOfLines = function (e) {
            var t = this;
            this.eachChunk(function (n, r, i) {
              var o = r === i + 1,
                a = t.chunkToLines(n, t.__partialLine, o);
              t.__partialLine = a.partialLine, e(a.lines, r, i);
            });
          }, cd.prototype.dispose = function () {
            delete this.src;
          };
          var dd = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._read = function () {
                var e = this;
                return new Promise(function (t, n) {
                  var r = e.src,
                    i = new FileReader();
                  i.onload = function (e) {
                    e.target && t(e.target.result);
                  }, i.onerror = function (e) {
                    return n(e);
                  }, e.binary || e.compressed ? i.readAsArrayBuffer(r) : i.readAsText(r);
                });
              }, t;
            }(cd),
            hd = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._read = function () {
                var e = this;
                return new Promise(function (t, n) {
                  var r = e.src,
                    i = new XMLHttpRequest();
                  i.open("GET", r, !0), i.addEventListener("load", function () {
                    if (200 === i.status || 304 === i.status || 0 === i.status) try {
                      t(i.response);
                    } catch (e) {
                      n(e);
                    } else n(i.statusText);
                  }, !1), i.addEventListener("error", function (e) {
                    return n("network error");
                  }, !1), e.isBinary() ? i.responseType = "arraybuffer" : e.json ? i.responseType = "json" : e.xml ? i.responseType = "document" : i.responseType = "text", i.send();
                });
              }, t;
            }(cd),
            fd = function fd(e, t) {
              void 0 === t && (t = {}), this.parameters = Su(t, {
                ext: "",
                compressed: !1,
                binary: id.isBinary(t.ext || ""),
                name: "",
                dir: "",
                path: "",
                protocol: ""
              });
              var n = {
                compressed: this.parameters.compressed,
                binary: this.parameters.binary,
                json: id.isJson(this.parameters.ext),
                xml: id.isXml(this.parameters.ext)
              };
              "undefined" != typeof File && e instanceof File || "undefined" != typeof Blob && e instanceof Blob ? this.streamer = new dd(e, n) : this.streamer = new hd(e, n);
            },
            pd = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.parserParams = {
                  voxelSize: n.voxelSize,
                  firstModelOnly: n.firstModelOnly,
                  asTrajectory: n.asTrajectory,
                  cAlphaOnly: n.cAlphaOnly,
                  name: this.parameters.name,
                  path: this.parameters.path
                };
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.load = function () {
                return new (id.get(this.parameters.ext))(this.streamer, this.parserParams).parse();
              }, t;
            }(fd),
            md = function md(e, t, n) {
              this.name = t, this.path = n, this.signals = {
                elementAdded: new lc(),
                elementRemoved: new lc(),
                nameChanged: new lc()
              }, this.type = "Script", this.dir = n.substring(0, n.lastIndexOf("/") + 1);
              try {
                this.fn = new Function("stage", "__name", "__path", "__dir", e);
              } catch (e) {
                Zc.error("Script compilation failed", e), this.fn = function () {};
              }
            };
          md.prototype.run = function (e) {
            var t = this;
            return new Promise(function (n, r) {
              try {
                t.fn.apply(null, [e, t.name, t.path, t.dir]), n();
              } catch (n) {
                Zc.error("Script.fn", n), r(n);
              }
            });
          };
          var gd = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.load = function () {
              var e = this;
              return this.streamer.read().then(function () {
                return new md(e.streamer.asText(), e.parameters.name, e.parameters.path);
              });
            }, t;
          }(fd);
          function vd(e) {
            var t,
              n,
              r = ad.names,
              i = "",
              o = (t = e instanceof File ? e.name : e instanceof Blob ? "" : e).lastIndexOf("?"),
              a = -1 !== o ? t.substring(o) : "",
              s = (t = t.substring(0, -1 === o ? t.length : o)).replace(/^.*[\\/]/, ""),
              l = s.substring(0, s.lastIndexOf(".")),
              u = s.split("."),
              c = 1 < u.length ? (u.pop() || "").toLowerCase() : "",
              d = t.match(/^(.+):\/\/(.+)$/);
            d && (i = d[1].toLowerCase(), t = d[2] || "");
            var h = t.substring(0, t.lastIndexOf("/") + 1);
            if (r.includes(c)) {
              n = c;
              var f = t.length - c.length - 1;
              c = (t.substr(0, f).split(".").pop() || "").toLowerCase();
              var p = l.length - c.length - 1;
              l = l.substr(0, p);
            } else n = !1;
            return {
              path: t,
              name: s,
              ext: c,
              base: l,
              dir: h,
              compressed: n,
              protocol: i,
              query: a,
              src: e
            };
          }
          function yd(e) {
            var t = vd(e),
              n = nd.get(t.protocol);
            return n && !(t = vd(n.getUrl(t.src))).ext && n.getExt && (t.ext = n.getExt(e)), t;
          }
          function bd(e, t) {
            void 0 === t && (t = {});
            var n,
              r = Object.assign(yd(e), t);
            return id.names.includes(r.ext) ? n = new pd(r.src, r) : Jc.includes(r.ext) && (n = new gd(r.src, r)), n ? n.load() : Promise.reject(new Error("autoLoad: ext '" + r.ext + "' unknown"));
          }
          var _d = tc(function (e, t) {
              !function () {
                var e = {
                  not_string: /[^s]/,
                  not_bool: /[^t]/,
                  not_type: /[^T]/,
                  not_primitive: /[^v]/,
                  number: /[diefg]/,
                  numeric_arg: /[bcdiefguxX]/,
                  json: /[j]/,
                  not_json: /[^j]/,
                  text: /^[^\x25]+/,
                  modulo: /^\x25{2}/,
                  placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
                  key: /^([a-z_][a-z_\d]*)/i,
                  key_access: /^\.([a-z_][a-z_\d]*)/i,
                  index_access: /^\[(\d+)\]/,
                  sign: /^[\+\-]/
                };
                function n(t) {
                  return function (t, r) {
                    var i,
                      o,
                      a,
                      s,
                      l,
                      u,
                      c,
                      d,
                      h,
                      f = 1,
                      p = t.length,
                      m = "";
                    for (o = 0; o < p; o++) if ("string" == typeof t[o]) m += t[o];else if ("object" == typeof t[o]) {
                      if ((s = t[o]).keys) for (i = r[f], a = 0; a < s.keys.length; a++) {
                        if (null == i) throw new Error(n('[sprintf] Cannot access property "%s" of undefined value "%s"', s.keys[a], s.keys[a - 1]));
                        i = i[s.keys[a]];
                      } else i = s.param_no ? r[s.param_no] : r[f++];
                      if (e.not_type.test(s.type) && e.not_primitive.test(s.type) && i instanceof Function && (i = i()), e.numeric_arg.test(s.type) && "number" != typeof i && isNaN(i)) throw new TypeError(n("[sprintf] expecting number but found %T", i));
                      switch (e.number.test(s.type) && (d = 0 <= i), s.type) {
                        case "b":
                          i = parseInt(i, 10).toString(2);
                          break;
                        case "c":
                          i = String.fromCharCode(parseInt(i, 10));
                          break;
                        case "d":
                        case "i":
                          i = parseInt(i, 10);
                          break;
                        case "j":
                          i = JSON.stringify(i, null, s.width ? parseInt(s.width) : 0);
                          break;
                        case "e":
                          i = s.precision ? parseFloat(i).toExponential(s.precision) : parseFloat(i).toExponential();
                          break;
                        case "f":
                          i = s.precision ? parseFloat(i).toFixed(s.precision) : parseFloat(i);
                          break;
                        case "g":
                          i = s.precision ? String(Number(i.toPrecision(s.precision))) : parseFloat(i);
                          break;
                        case "o":
                          i = (parseInt(i, 10) >>> 0).toString(8);
                          break;
                        case "s":
                          i = String(i), i = s.precision ? i.substring(0, s.precision) : i;
                          break;
                        case "t":
                          i = String(!!i), i = s.precision ? i.substring(0, s.precision) : i;
                          break;
                        case "T":
                          i = Object.prototype.toString.call(i).slice(8, -1).toLowerCase(), i = s.precision ? i.substring(0, s.precision) : i;
                          break;
                        case "u":
                          i = parseInt(i, 10) >>> 0;
                          break;
                        case "v":
                          i = i.valueOf(), i = s.precision ? i.substring(0, s.precision) : i;
                          break;
                        case "x":
                          i = (parseInt(i, 10) >>> 0).toString(16);
                          break;
                        case "X":
                          i = (parseInt(i, 10) >>> 0).toString(16).toUpperCase();
                      }
                      e.json.test(s.type) ? m += i : (!e.number.test(s.type) || d && !s.sign ? h = "" : (h = d ? "+" : "-", i = i.toString().replace(e.sign, "")), u = s.pad_char ? "0" === s.pad_char ? "0" : s.pad_char.charAt(1) : " ", c = s.width - (h + i).length, l = s.width && 0 < c ? u.repeat(c) : "", m += s.align ? h + i + l : "0" === u ? h + l + i : l + h + i);
                    }
                    return m;
                  }(function (t) {
                    if (i[t]) return i[t];
                    for (var n, r = t, o = [], a = 0; r;) {
                      if (null !== (n = e.text.exec(r))) o.push(n[0]);else if (null !== (n = e.modulo.exec(r))) o.push("%");else {
                        if (null === (n = e.placeholder.exec(r))) throw new SyntaxError("[sprintf] unexpected placeholder");
                        if (n[2]) {
                          a |= 1;
                          var s = [],
                            l = n[2],
                            u = [];
                          if (null === (u = e.key.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                          for (s.push(u[1]); "" !== (l = l.substring(u[0].length));) if (null !== (u = e.key_access.exec(l))) s.push(u[1]);else {
                            if (null === (u = e.index_access.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                            s.push(u[1]);
                          }
                          n[2] = s;
                        } else a |= 2;
                        if (3 === a) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                        o.push({
                          placeholder: n[0],
                          param_no: n[1],
                          keys: n[2],
                          sign: n[3],
                          pad_char: n[4],
                          align: n[5],
                          width: n[6],
                          precision: n[7],
                          type: n[8]
                        });
                      }
                      r = r.substring(n[0].length);
                    }
                    return i[t] = o;
                  }(t), arguments);
                }
                function r(e, t) {
                  return n.apply(null, [e].concat(t || []));
                }
                var i = Object.create(null);
                t.sprintf = n, t.vsprintf = r, "undefined" != typeof window && (window.sprintf = n, window.vsprintf = r);
              }();
            }).sprintf,
            xd = function xd() {};
          xd.prototype.getBlob = function () {
            return new Blob([this.getData()], {
              type: this.mimeType
            });
          }, xd.prototype.download = function (e, t) {
            e = wu(e, this.defaultName), t = wu(t, this.defaultExt), Cu(this.getBlob(), e + "." + t);
          };
          var wd = function (e) {
              function t(t, n) {
                e.call(this), this.mimeType = "text/plain", this.defaultName = "structure", this.defaultExt = "pdb";
                var r,
                  i = Object.assign({}, n);
                this.renumberSerial = wu(i.renumberSerial, !0), this.remarks = (r = wu(i.remarks, []), Array.isArray(r) ? r : [r]), this.structure = t, this._records = [];
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._writeRecords = function () {
                this._records.length = 0, this._writeTitle(), this._writeRemarks(), this._writeAtoms();
              }, t.prototype._writeTitle = function () {
                this._records.push(_d("TITLE %-74s", this.structure.name));
              }, t.prototype._writeRemarks = function () {
                var e = this;
                this.remarks.forEach(function (t) {
                  e._records.push(_d("REMARK %-73s", t));
                }), this.structure.trajectory && (this._records.push(_d("REMARK %-73s", "Trajectory '" + this.structure.trajectory.name + "'")), this._records.push(_d("REMARK %-73s", "Frame " + this.structure.trajectory.frame)));
              }, t.prototype._writeAtoms = function () {
                var e = this,
                  t = 1,
                  n = 1;
                this.structure.eachModel(function (r) {
                  e._records.push(_d("MODEL %-74d", n++)), r.eachAtom(function (n) {
                    var r = n.hetero ? "HETATM%5d %-4s %3s %1s%4d    %8.3f%8.3f%8.3f%6.2f%6.2f      %4s%2s" : "ATOM  %5d %-4s %3s %1s%4d    %8.3f%8.3f%8.3f%6.2f%6.2f      %4s%2s",
                      i = e.renumberSerial ? t : n.serial,
                      o = n.atomname;
                    1 === o.length && (o = " " + o), e._records.push(_d(r, i, o, n.resname, wu(n.chainname, " "), n.resno, n.x, n.y, n.z, wu(n.occupancy, 1), wu(n.bfactor, 0), "", wu(n.element, ""))), t += 1;
                  }), e._records.push(_d("%-80s", "ENDMDL")), n += 1;
                }), this._records.push(_d("%-80s", "END"));
              }, t.prototype.getString = function () {
                return console.warn("PdbWriter.getString() is deprecated, use .getData instead"), this.getData();
              }, t.prototype.getData = function () {
                return this._writeRecords(), this._records.join("\n");
              }, t;
            }(xd),
            Sd = function (e) {
              function t(t) {
                e.call(this), this.mimeType = "text/plain", this.defaultName = "structure", this.defaultExt = "sdf", this.structure = t, this._records = [];
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                idString: {
                  configurable: !0
                },
                titleString: {
                  configurable: !0
                },
                countsString: {
                  configurable: !0
                },
                chargeLines: {
                  configurable: !0
                }
              };
              return n.idString.get = function () {
                return this.structure.id;
              }, n.titleString.get = function () {
                return "  " + this.structure.title;
              }, n.countsString.get = function () {
                return _d("%3i%3i  0  0  0  0  0  0  0  0999 V2000", this.structure.atomCount, this.structure.bondCount);
              }, n.chargeLines.get = function () {
                var e = [];
                this.structure.eachAtom(function (t) {
                  null != t.formalCharge && 0 !== t.formalCharge && e.push([t.index, t.formalCharge]);
                });
                for (var t = [], n = 0; n < e.length; n += 8) {
                  for (var r = Math.min(8, e.length - n), i = _d("M  CHG%3i", r), o = n; o < n + r; o++) i += _d(" %3i %3i", e[o][0] + 1, e[o][1]);
                  t.push(i);
                }
                return t;
              }, t.prototype.formatAtom = function (e) {
                var t = 0;
                null != e.formalCharge && 0 !== e.formalCharge && (t = 4 - e.formalCharge);
                var n = _d("%10.4f%10.4f%10.4f %-3s 0%3i  0  0  0", e.x, e.y, e.z, e.element, t);
                if (48 !== n.length) throw new Error("Incompatible atom for sdf format");
                return n;
              }, t.prototype.formatBond = function (e) {
                return _d("%3i%3i%3i  0  0  0", e.atomIndex1 + 1, e.atomIndex2 + 1, e.bondOrder);
              }, t.prototype._writeRecords = function () {
                this._records.length = 0, this._writeHeader(), this._writeCTab(), this._writeFooter();
              }, t.prototype._writeHeader = function () {
                this._records.push(this.idString, this.titleString, "");
              }, t.prototype._writeCTab = function () {
                var e = this;
                this._records.push(this.countsString), this.structure.eachAtom(function (t) {
                  e._records.push(e.formatAtom(t));
                }), this.structure.eachBond(function (t) {
                  e._records.push(e.formatBond(t));
                }), this.chargeLines.forEach(function (t) {
                  e._records.push(t);
                }), this._records.push("M  END");
              }, t.prototype._writeFooter = function () {
                this._records.push("$$$$");
              }, t.prototype.getData = function () {
                return this._writeRecords(), this._records.join("\n");
              }, Object.defineProperties(t.prototype, n), t;
            }(xd),
            Ad = [],
            Ed = function Ed(e, t) {
              void 0 === t && (t = {}), this._mark = 0, this._marks = [], this.offset = 0;
              var n = !(this.littleEndian = !0);
              void 0 === e && (e = 8192), "number" == typeof e ? e = new ArrayBuffer(e) : n = !0;
              var r = t.offset ? t.offset >>> 0 : 0,
                i = e.byteLength - r,
                o = r;
              e instanceof ArrayBuffer || (e.byteLength !== e.buffer.byteLength && (o = e.byteOffset + r), e = e.buffer), this._lastWrittenByte = n ? i : 0, this.buffer = e, this.length = i, this.byteLength = i, this.byteOffset = o, this._data = new DataView(this.buffer, o, i);
            };
          Ed.prototype.available = function (e) {
            return void 0 === e && (e = 1), this.offset + e <= this.length;
          }, Ed.prototype.isLittleEndian = function () {
            return this.littleEndian;
          }, Ed.prototype.setLittleEndian = function () {
            return this.littleEndian = !0, this;
          }, Ed.prototype.isBigEndian = function () {
            return !this.littleEndian;
          }, Ed.prototype.setBigEndian = function () {
            return this.littleEndian = !1, this;
          }, Ed.prototype.skip = function (e) {
            return void 0 === e && (e = 1), this.offset += e, this;
          }, Ed.prototype.seek = function (e) {
            return this.offset = e, this;
          }, Ed.prototype.mark = function () {
            return this._mark = this.offset, this;
          }, Ed.prototype.reset = function () {
            return this.offset = this._mark, this;
          }, Ed.prototype.pushMark = function () {
            return this._marks.push(this.offset), this;
          }, Ed.prototype.popMark = function () {
            var e = this._marks.pop();
            if (void 0 === e) throw new Error("Mark stack empty");
            return this.seek(e), this;
          }, Ed.prototype.rewind = function () {
            return this.offset = 0, this;
          }, Ed.prototype.ensureAvailable = function (e) {
            if (void 0 === e && (e = 1), !this.available(e)) {
              var t = 2 * (this.offset + e),
                n = new Uint8Array(t);
              n.set(new Uint8Array(this.buffer)), this.buffer = n.buffer, this.length = this.byteLength = t, this._data = new DataView(this.buffer);
            }
            return this;
          }, Ed.prototype.readBoolean = function () {
            return 0 !== this.readUint8();
          }, Ed.prototype.readInt8 = function () {
            return this._data.getInt8(this.offset++);
          }, Ed.prototype.readUint8 = function () {
            return this._data.getUint8(this.offset++);
          }, Ed.prototype.readByte = function () {
            return this.readUint8();
          }, Ed.prototype.readBytes = function (e) {
            void 0 === e && (e = 1);
            for (var t = new Uint8Array(e), n = 0; n < e; n++) t[n] = this.readByte();
            return t;
          }, Ed.prototype.readInt16 = function () {
            var e = this._data.getInt16(this.offset, this.littleEndian);
            return this.offset += 2, e;
          }, Ed.prototype.readUint16 = function () {
            var e = this._data.getUint16(this.offset, this.littleEndian);
            return this.offset += 2, e;
          }, Ed.prototype.readInt32 = function () {
            var e = this._data.getInt32(this.offset, this.littleEndian);
            return this.offset += 4, e;
          }, Ed.prototype.readUint32 = function () {
            var e = this._data.getUint32(this.offset, this.littleEndian);
            return this.offset += 4, e;
          }, Ed.prototype.readFloat32 = function () {
            var e = this._data.getFloat32(this.offset, this.littleEndian);
            return this.offset += 4, e;
          }, Ed.prototype.readFloat64 = function () {
            var e = this._data.getFloat64(this.offset, this.littleEndian);
            return this.offset += 8, e;
          }, Ed.prototype.readChar = function () {
            return String.fromCharCode(this.readInt8());
          }, Ed.prototype.readChars = function (e) {
            void 0 === e && (e = 1), Ad.length = e;
            for (var t = 0; t < e; t++) Ad[t] = this.readChar();
            return Ad.join("");
          }, Ed.prototype.writeBoolean = function (e) {
            return void 0 === e && (e = !1), this.writeUint8(e ? 255 : 0), this;
          }, Ed.prototype.writeInt8 = function (e) {
            return this.ensureAvailable(1), this._data.setInt8(this.offset++, e), this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeUint8 = function (e) {
            return this.ensureAvailable(1), this._data.setUint8(this.offset++, e), this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeByte = function (e) {
            return this.writeUint8(e);
          }, Ed.prototype.writeBytes = function (e) {
            this.ensureAvailable(e.length);
            for (var t = 0; t < e.length; t++) this._data.setUint8(this.offset++, e[t]);
            return this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeInt16 = function (e) {
            return this.ensureAvailable(2), this._data.setInt16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeUint16 = function (e) {
            return this.ensureAvailable(2), this._data.setUint16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeInt32 = function (e) {
            return this.ensureAvailable(4), this._data.setInt32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeUint32 = function (e) {
            return this.ensureAvailable(4), this._data.setUint32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeFloat32 = function (e) {
            return this.ensureAvailable(4), this._data.setFloat32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeFloat64 = function (e) {
            return this.ensureAvailable(8), this._data.setFloat64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
          }, Ed.prototype.writeChar = function (e) {
            return this.writeUint8(e.charCodeAt(0));
          }, Ed.prototype.writeChars = function (e) {
            for (var t = 0; t < e.length; t++) this.writeUint8(e.charCodeAt(t));
            return this;
          }, Ed.prototype.toArray = function () {
            return new Uint8Array(this.buffer, this.byteOffset, this._lastWrittenByte);
          }, Ed.prototype._updateLastWrittenByte = function () {
            this.offset > this._lastWrittenByte && (this._lastWrittenByte = this.offset);
          };
          var Td = function (e) {
              function t(t) {
                e.call(this), this.mimeType = "application/vnd.ms-pki.stl", this.defaultName = "surface", this.defaultExt = "stl", this.surface = t;
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.getData = function () {
                var e = this.surface.index.length / 3,
                  t = new Ed(2 * e + 3 * e * 4 * 4 + 80 + 4);
                t.skip(80), t.writeUint32(e);
                for (var n = new ae(), r = new ae(), i = new ae(), o = new ae(), a = 0; a < e; a++) {
                  var s = [this.surface.index[3 * a], this.surface.index[3 * a + 1], this.surface.index[3 * a + 2]];
                  r.fromArray(this.surface.normal, 3 * s[0]), i.fromArray(this.surface.normal, 3 * s[1]), o.fromArray(this.surface.normal, 3 * s[2]), n.addVectors(r, i).add(o).normalize(), t.writeFloat32(n.x), t.writeFloat32(n.y), t.writeFloat32(n.z);
                  for (var l = 0; l < 3; l++) n.fromArray(this.surface.position, 3 * s[l]), t.writeFloat32(n.x), t.writeFloat32(n.y), t.writeFloat32(n.z);
                  t.writeUint16(0);
                }
                return new DataView(t.buffer);
              }, t;
            }(xd),
            Md = function Md() {
              this.count = 0, this.signals = {
                countChanged: new lc()
              };
            };
          Md.prototype.clear = function () {
            this.change(-this.count);
          }, Md.prototype.change = function (e) {
            this.count += e, this.signals.countChanged.dispatch(e, this.count), this.count < 0 && Zc.warn("Counter.count below zero", this.count);
          }, Md.prototype.increment = function () {
            this.change(1);
          }, Md.prototype.decrement = function () {
            this.change(-1);
          }, Md.prototype.listen = function (e) {
            this.change(e.count), e.signals.countChanged.add(this.change, this);
          }, Md.prototype.unlisten = function (e) {
            var t = e.signals.countChanged;
            t.has(this.change, this) && t.remove(this.change, this);
          }, Md.prototype.onZeroOnce = function (e, t) {
            var n = this;
            if (0 === this.count) e.call(t);else {
              var r = function r() {
                0 === n.count && (n.signals.countChanged.remove(r, n), e.call(t));
              };
              this.signals.countChanged.add(r, this);
            }
          }, Md.prototype.dispose = function () {
            this.clear(), this.signals.countChanged.dispose();
          }, od.add("shader/BasicLine.vert", "void main(){\n#include begin_vertex\n#include project_vertex\n}"), od.add("shader/BasicLine.frag", "uniform vec3 uColor;\n#include common\n#include fog_pars_fragment\nvoid main(){\ngl_FragColor = vec4( uColor, 1.0 );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n}"), od.add("shader/Quad.vert", "varying vec2 vUv;\nvoid main() {\nvUv = uv;\ngl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"), od.add("shader/Quad.frag", "varying vec2 vUv;\nuniform sampler2D tForeground;\nuniform float scale;\nvoid main() {\nvec4 foreground = texture2D( tForeground, vUv );\ngl_FragColor = foreground * scale;\n}");
          var Cd = function Cd() {
            this.signals = {
              updated: new lc()
            }, this.maxDuration = -1 / 0, this.minDuration = 1 / 0, this.avgDuration = 14, this.lastDuration = 1 / 0, this.prevFpsTime = 0, this.lastFps = 1 / 0, this.lastFrames = 1, this.frames = 0, this.count = 0, this.begin();
          };
          Cd.prototype.update = function () {
            this.startTime = this.end(), this.currentTime = this.startTime, this.signals.updated.dispatch();
          }, Cd.prototype.begin = function () {
            this.startTime = window.performance.now(), this.lastFrames = this.frames;
          }, Cd.prototype.end = function () {
            var e = window.performance.now();
            return this.count += 1, this.frames += 1, this.lastDuration = e - this.startTime, this.minDuration = Math.min(this.minDuration, this.lastDuration), this.maxDuration = Math.max(this.maxDuration, this.lastDuration), this.avgDuration -= this.avgDuration / 30, this.avgDuration += this.lastDuration / 30, e > this.prevFpsTime + 1e3 && (this.lastFps = this.frames, this.prevFpsTime = e, this.frames = 0), e;
          }, od.add("shader/chunk/fog_fragment.glsl", "#ifdef USE_FOG\nfloat depth = length( vViewPosition );\n#ifdef FOG_EXP2\nfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * depth * depth * LOG2 ) );\n#else\nfloat fogFactor = smoothstep( fogNear, fogFar, depth );\n#endif\ngl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif"), od.add("shader/chunk/interior_fragment.glsl", "if( gl_FrontFacing == false ){\n#ifdef USE_INTERIOR_COLOR\noutgoingLight.xyz = interiorColor;\n#else\n#ifdef DIFFUSE_INTERIOR\noutgoingLight.xyz = vColor;\n#endif\n#endif\noutgoingLight.xyz *= 1.0 - interiorDarkening;\n}"), od.add("shader/chunk/matrix_scale.glsl", "float matrixScale( in mat4 m ){\nvec4 r = m[ 0 ];\nreturn sqrt( r[ 0 ] * r[ 0 ] + r[ 1 ] * r[ 1 ] + r[ 2 ] * r[ 2 ] );\n}"), od.add("shader/chunk/nearclip_vertex.glsl", "#ifdef NEAR_CLIP\nif( vViewPosition.z < clipNear - 5.0 )\ngl_Position.z = 2.0 * gl_Position.w;\n#endif"), od.add("shader/chunk/nearclip_fragment.glsl", "#ifdef NEAR_CLIP\nif( vViewPosition.z < clipNear )\ndiscard;\n#endif"), od.add("shader/chunk/opaque_back_fragment.glsl", "#ifdef OPAQUE_BACK\n#ifdef FLIP_SIDED\nif( gl_FrontFacing == true ){\ngl_FragColor.a = 1.0;\n}\n#else\nif( gl_FrontFacing == false ){\ngl_FragColor.a = 1.0;\n}\n#endif\n#endif"), od.add("shader/chunk/radiusclip_vertex.glsl", "#ifdef RADIUS_CLIP\nif( distance( vViewPosition, vClipCenter ) > clipRadius + 5.0 )\ngl_Position.z = 2.0 * gl_Position.w;\n#endif"), od.add("shader/chunk/radiusclip_fragment.glsl", "#ifdef RADIUS_CLIP\nif( distance( vViewPosition, vClipCenter ) > clipRadius )\ndiscard;\n#endif"), od.add("shader/chunk/unpack_color.glsl", "vec3 unpackColor(float f) {\nvec3 color;\ncolor.r = floor(f / 256.0 / 256.0);\ncolor.g = floor((f - color.r * 256.0 * 256.0) / 256.0);\ncolor.b = floor(f - color.r * 256.0 * 256.0 - color.g * 256.0);\nreturn color / 255.0;\n}");
          var kd = /^(?!\/\/)\s*#include\s+(\S+)/gim,
            Pd = {};
          function Od(e, t) {
            void 0 === t && (t = {});
            var n = e + "|";
            for (var r in t) n += r + ":" + t[r];
            if (!Pd[n]) {
              var i = function (e) {
                  if (void 0 === e) return "";
                  var t = [];
                  for (var n in e) {
                    var r = e[n];
                    r && t.push("#define " + n + " " + r);
                  }
                  return t.join("\n") + "\n";
                }(t),
                o = od.get("shader/" + e);
              if (!o) throw new Error("empty shader, '" + e + "'");
              o = o.replace(kd, function (e, t) {
                var n = "shader/chunk/" + t + ".glsl",
                  r = od.get(n) || Le[t];
                if (!r) throw new Error("empty chunk, '" + t + "'");
                return r;
              }), Pd[n] = i + o;
            }
            return Pd[n];
          }
          if ("undefined" != typeof WebGLRenderingContext) {
            var Rd = WebGLRenderingContext.prototype,
              Id = Rd.getShaderParameter;
            Rd.getShaderParameter = function () {
              return !t.Debug || Id.apply(this, arguments);
            };
            var jd = Rd.getShaderInfoLog;
            Rd.getShaderInfoLog = function () {
              return t.Debug ? jd.apply(this, arguments) : "";
            };
            var Nd = Rd.getProgramParameter;
            Rd.getProgramParameter = function (e, n) {
              return !t.Debug && n === Rd.LINK_STATUS || Nd.apply(this, arguments);
            };
            var Ld = Rd.getProgramInfoLog;
            Rd.getProgramInfoLog = function () {
              return t.Debug ? Ld.apply(this, arguments) : "";
            };
          }
          var Dd = [[[0, 0]], [[4, 4], [-4, -4]], [[-2, -6], [6, -2], [-6, 2], [2, 6]], [[1, -3], [-1, 3], [5, 1], [-3, -5], [-5, 5], [-7, -1], [3, 7], [7, -7]], [[1, 1], [-1, -3], [-3, 2], [4, -1], [-5, -2], [2, 5], [5, 3], [3, -5], [-2, 6], [0, -7], [-4, -6], [-6, 4], [-8, 0], [7, -4], [6, 7], [-7, -8]], [[-4, -7], [-7, -5], [-3, -5], [-5, -4], [-1, -4], [-2, -2], [-6, -1], [-4, 0], [-7, 1], [-1, 2], [-6, 3], [-3, 3], [-7, 6], [-3, 6], [-5, 7], [-1, 7], [5, -7], [1, -6], [6, -5], [4, -4], [2, -3], [7, -2], [1, -1], [4, -1], [2, 1], [6, 2], [0, 4], [4, 4], [2, 5], [7, 5], [5, 6], [3, 7]]];
          Dd.forEach(function (e) {
            e.forEach(function (e) {
              e[0] *= .0625, e[1] *= .0625;
            });
          });
          var Bd = function Bd(e, t, n, r) {
            this.canvas = document.createElement("canvas"), this._viewer = n, this._factor = wu(r.factor, 2), this._antialias = wu(r.antialias, !1), this._onProgress = r.onProgress, this._onFinish = r.onFinish, this._antialias && (this._factor *= 2), this._n = this._factor * this._factor, this._width = this._viewer.width, this._height = this._viewer.height, this._antialias ? (this.canvas.width = this._width * this._factor / 2, this.canvas.height = this._height * this._factor / 2) : (this.canvas.width = this._width * this._factor, this.canvas.height = this._height * this._factor), this._ctx = this.canvas.getContext("2d"), this._viewerSampleLevel = n.sampleLevel, this._viewer.setSampling(-1);
          };
          Bd.prototype._renderTile = function (e) {
            var t = this._viewer,
              n = this._width,
              r = this._height,
              i = this._factor,
              o = e % i * n,
              a = Math.floor(e / i) * r;
            if (t.camera.setViewOffset(n * i, r * i, o, a, n, r), t.render(), this._antialias) {
              var s = Math.round((o + n) / 2) - Math.round(o / 2),
                l = Math.round((a + r) / 2) - Math.round(a / 2);
              this._ctx.drawImage(t.renderer.domElement, Math.round(o / 2), Math.round(a / 2), s, l);
            } else this._ctx.drawImage(t.renderer.domElement, Math.floor(o), Math.floor(a), Math.ceil(n), Math.ceil(r));
            "function" == typeof this._onProgress && this._onProgress(e + 1, this._n, !1);
          }, Bd.prototype._finalize = function () {
            this._viewer.setSampling(this._viewerSampleLevel), this._viewer.camera.view = null, "function" == typeof this._onFinish && this._onFinish(this._n + 1, this._n, !1);
          }, Bd.prototype.render = function () {
            for (var e = 0; e <= this._n; ++e) e === this._n ? this._finalize() : this._renderTile(e);
          }, Bd.prototype.renderAsync = function () {
            for (var e = this, t = 0, n = this._n, r = function r() {
                t === n ? e._finalize() : e._renderTile(t), t += 1;
              }, i = 0; i <= n; ++i) setTimeout(r, 0);
          };
          var Fd = 2 * Math.PI,
            zd = (Math.PI, 180 / Math.PI);
          function Ud(e, t, n, r, i) {
            void 0 === n && (n = 1), void 0 === r && (r = 0);
            var o = i ? i.length : e.length / n,
              a = 0,
              s = 0;
            if (i) for (var l = 0; l < o; ++l) {
              var u = (e[i[l] * n + r] + t) % t / t * Fd - Math.PI;
              a += Math.cos(u), s += Math.sin(u);
            } else for (var c = r; c < o; c += n) {
              var d = (e[c] + t) % t / t * Fd - Math.PI;
              a += Math.cos(d), s += Math.sin(d);
            }
            return a /= o, s /= o, (Math.atan2(s, a) + Math.PI) / Fd * t;
          }
          function Gd(e, t, n, r) {
            void 0 === r && (r = 0);
            for (var i = e.length, o = n || new Float32Array(i), a = 0; a < i; a += 3) o[r + a + 0] = (e[a + 0] + t[a + 0]) / 2, o[r + a + 1] = (e[a + 1] + t[a + 1]) / 2, o[r + a + 2] = (e[a + 2] + t[a + 2]) / 2;
            return o;
          }
          function Vd(e, t) {
            for (var n = e.length, r = new Float32Array(n), i = 0; i < n; i += 3) r[i + 0] = t[i + 0] - e[i + 0], r[i + 1] = t[i + 1] - e[i + 1], r[i + 2] = t[i + 2] - e[i + 2];
            return r;
          }
          function Hd(e, t, n) {
            for (var r = n || new Float32Array(e), i = 0; i < e; ++i) r[i] = t;
            return r;
          }
          function qd(e, t, n, r, i) {
            for (var o = i || new Float32Array(3 * e), a = 0; a < e; ++a) {
              var s = 3 * a;
              o[s + 0] = t, o[s + 1] = n, o[s + 2] = r;
            }
            return o;
          }
          function Wd(e) {
            for (var t = new Float32Array(e), n = 0; n < e; ++n) t[n] = n;
            return t;
          }
          function $d(e, t, n, r) {
            void 0 === n && (n = 0);
            for (var i = r || new Float32Array(e * t), o = 0; o < e; ++o) for (var a = n + o * t, s = 0; s < t; ++s) i[a + s] = o;
            return i;
          }
          function Xd(e, t) {
            for (var n = e.length, r = new Float32Array(n * t), i = 0; i < n; ++i) for (var o = i * t, a = e[i], s = 0; s < t; ++s) r[o + s] = a;
            return r;
          }
          function Yd(e, t, n, r, i) {
            for (var o = 0; o < i; ++o) t[r + o] = e[n + o];
          }
          function Kd(e, t, n, r) {
            Yd(e, e, t, n, r);
          }
          function Zd(e) {
            for (var t = -1 / 0, n = 0, r = e.length; n < r; ++n) e[n] > t && (t = e[n]);
            return t;
          }
          function Qd(e) {
            for (var t = 1 / 0, n = 0, r = e.length; n < r; ++n) e[n] < t && (t = e[n]);
            return t;
          }
          function Jd(e, t, n) {
            void 0 === t && (t = 1), void 0 === n && (n = 0);
            for (var r = e.length, i = 0, o = n; o < r; o += t) i += e[o];
            return i;
          }
          function eh(e, t, n) {
            return void 0 === t && (t = 1), void 0 === n && (n = 0), Jd(e, t, n) / (e.length / t);
          }
          var th = {
              trim: !1,
              factor: 1,
              antialias: !1,
              transparent: !1,
              onProgress: void 0
            },
            nh = new ae(),
            rh = new ie(),
            ih = new ie(),
            oh = new re(),
            ah = new ie(),
            sh = new ie();
          function lh(e, t) {
            ah.getInverse(t.projectionMatrix), sh.copy(t.projectionMatrix).transpose(), e.traverse(function (e) {
              var t = e.material;
              if (t) {
                var n = t.uniforms;
                n && (n.projectionMatrixInverse && n.projectionMatrixInverse.value.copy(ah), n.projectionMatrixTranspose && n.projectionMatrixTranspose.value.copy(sh));
              }
            });
          }
          function uh(e, t, n) {
            var r = e.createShader(n);
            return e.shaderSource(r, t), e.compileShader(r), e.getShaderParameter(r, e.COMPILE_STATUS) ? r : (console.log("error compiling shader " + r + ": " + e.getShaderInfoLog(r)), e.deleteShader(r), null);
          }
          function ch(e, t) {
            var n = e.getExtension(t);
            return n || console.log("extension '" + t + "' not available"), n;
          }
          var dh = new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]);
          function hh(e) {
            var t = document.createElement("canvas");
            t.width = 16, t.height = 16, t.style.width = "16px", t.style.height = "16px";
            var n = t.getContext("webgl") || t.getContext("experimental-webgl");
            if (!n) return console.log("error creating webgl context for " + e), !1;
            ch(n, "OES_texture_float"), ch(n, "OES_texture_half_float"), ch(n, "WEBGL_color_buffer_float");
            var r = uh(n, "\nattribute vec4 a_position;\n\nvoid main() {\n  gl_Position = a_position;\n}", n.VERTEX_SHADER),
              i = uh(n, "\nprecision mediump float;\nuniform vec4 u_color;\nuniform sampler2D u_texture;\n\nvoid main() {\n  gl_FragColor = texture2D(u_texture, vec2(0.5, 0.5)) * u_color;\n}", n.FRAGMENT_SHADER);
            if (!r || !i) return !1;
            var o,
              a,
              s,
              l = (a = [r, i], s = (o = n).createProgram(), a.forEach(function (e) {
                return o.attachShader(s, e);
              }), o.linkProgram(s), o.getProgramParameter(s, o.LINK_STATUS) ? s : (console.log("error linking program: " + o.getProgramInfoLog(s)), o.deleteProgram(s), null));
            n.useProgram(l);
            var u = n.getAttribLocation(l, "a_position"),
              c = n.getUniformLocation(l, "u_color");
            if (!c) return console.log("error getting 'u_color' uniform location"), !1;
            var d = n.createBuffer();
            n.bindBuffer(n.ARRAY_BUFFER, d), n.bufferData(n.ARRAY_BUFFER, dh, n.STATIC_DRAW), n.enableVertexAttribArray(u), n.vertexAttribPointer(u, 2, n.FLOAT, !1, 0, 0);
            var h = n.createTexture(),
              f = new Uint8Array([255, 255, 255, 255]);
            n.bindTexture(n.TEXTURE_2D, h), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, 1, 1, 0, n.RGBA, n.UNSIGNED_BYTE, f);
            var p = n.createTexture();
            n.bindTexture(n.TEXTURE_2D, p), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, 1, 1, 0, n.RGBA, e, null), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.NEAREST), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.NEAREST);
            var m = n.createFramebuffer();
            if (n.bindFramebuffer(n.FRAMEBUFFER, m), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, p, 0), n.checkFramebufferStatus(n.FRAMEBUFFER) !== n.FRAMEBUFFER_COMPLETE) return console.log("error creating framebuffer for " + e), !1;
            n.bindTexture(n.TEXTURE_2D, h), n.uniform4fv(c, [0, 10, 20, 1]), n.drawArrays(n.TRIANGLES, 0, 6), n.bindTexture(n.TEXTURE_2D, p), n.bindFramebuffer(n.FRAMEBUFFER, null), n.clearColor(1, 0, 0, 1), n.clear(n.COLOR_BUFFER_BIT), n.uniform4fv(c, [0, .1, .05, 1]), n.drawArrays(n.TRIANGLES, 0, 6);
            var g = new Uint8Array(4);
            if (n.readPixels(0, 0, 1, 1, n.RGBA, n.UNSIGNED_BYTE, g), 0 !== g[0] || g[1] < 248 || g[2] < 248 || g[3] < 254) return console.log("not able to actually render to " + e + " texture"), !1;
            if (e === n.FLOAT) {
              n.bindFramebuffer(n.FRAMEBUFFER, m);
              var v = new Float32Array(4);
              n.readPixels(0, 0, 1, 1, n.RGBA, n.FLOAT, v);
              var y = n.getError();
              if (y) return console.log("error reading pixels as float: '" + function (e, t) {
                switch (t) {
                  case e.NO_ERROR:
                    return "no error";
                  case e.INVALID_ENUM:
                    return "invalid enum";
                  case e.INVALID_VALUE:
                    return "invalid value";
                  case e.INVALID_OPERATION:
                    return "invalid operation";
                  case e.INVALID_FRAMEBUFFER_OPERATION:
                    return "invalid framebuffer operation";
                  case e.OUT_OF_MEMORY:
                    return "out of memory";
                  case e.CONTEXT_LOST_WEBGL:
                    return "context lost";
                }
                return "unknown error";
              }(n, y) + "'"), !1;
            }
            return !0;
          }
          var fh = new Float32Array(100),
            ph = new Uint8Array(100),
            mh = [12, 7, 13, 17, 11, 6, 8, 18, 16, 2, 14, 22, 10, 1, 3, 9, 19, 23, 21, 15, 5, 0, 4, 24, 20],
            gh = new ie();
          function vh(e, t, n, r, i) {
            var o = i.uniforms,
              a = [];
            if (o.objectId && (o.objectId.value = Yc ? this.id : this.id / 255, a.push("objectId")), (o.modelViewMatrixInverse || o.modelViewMatrixInverseTranspose || o.modelViewProjectionMatrix || o.modelViewProjectionMatrixInverse) && this.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, this.matrixWorld), o.modelViewMatrixInverse && (o.modelViewMatrixInverse.value.getInverse(this.modelViewMatrix), a.push("modelViewMatrixInverse")), o.modelViewMatrixInverseTranspose && (o.modelViewMatrixInverse ? o.modelViewMatrixInverseTranspose.value.copy(o.modelViewMatrixInverse.value).transpose() : o.modelViewMatrixInverseTranspose.value.getInverse(this.modelViewMatrix).transpose(), a.push("modelViewMatrixInverseTranspose")), o.modelViewProjectionMatrix && (o.modelViewProjectionMatrix.value.multiplyMatrices(n.projectionMatrix, this.modelViewMatrix), a.push("modelViewProjectionMatrix")), o.modelViewProjectionMatrixInverse && (o.modelViewProjectionMatrix ? gh.copy(o.modelViewProjectionMatrix.value) : gh.multiplyMatrices(n.projectionMatrix, this.modelViewMatrix), o.modelViewProjectionMatrixInverse.value.getInverse(gh), a.push("modelViewProjectionMatrixInverse")), a.length) {
              var s = e.properties.get(i);
              if (s.program) {
                var l = e.getContext(),
                  u = s.program;
                l.useProgram(u.program);
                var c = u.getUniforms();
                a.forEach(function (e) {
                  c.setValue(l, e, o[e].value);
                });
              }
            }
          }
          var yh = function yh(e) {
            if (this.boundingBox = new Oe(), this.boundingBoxSize = new ae(), this.boundingBoxLength = 0, this.info = {
              memory: {
                programs: 0,
                geometries: 0,
                textures: 0
              },
              render: {
                calls: 0,
                vertices: 0,
                faces: 0,
                points: 0
              }
            }, this.distVector = new ae(), this.signals = {
              ticked: new lc(),
              rendered: new lc()
            }, "string" == typeof e) {
              var t = document.getElementById(e);
              this.container = null === t ? document.createElement("div") : t;
            } else e instanceof HTMLElement ? this.container = e : this.container = document.createElement("div");
            if (this.container === document.body) this.width = window.innerWidth || 1, this.height = window.innerHeight || 1;else {
              var n = this.container.getBoundingClientRect();
              this.width = n.width || 1, this.height = n.height || 1, this.container.style.overflow = "hidden";
            }
            this.wrapper = document.createElement("div"), this.wrapper.style.position = "relative", this.container.appendChild(this.wrapper), this._initParams(), this._initStats(), this._initCamera(), this._initScene(), !1 !== this._initRenderer() ? (this._initHelper(), this.setBackground(), this.setFog(), this.animate = this.animate.bind(this)) : Zc.error("Viewer: could not initialize renderer");
          };
          function bh(e) {
            var t = e.touches[0].pageX - e.touches[1].pageX,
              n = e.touches[0].pageY - e.touches[1].pageY;
            return Math.sqrt(t * t + n * n);
          }
          yh.prototype._initParams = function () {
            this.parameters = {
              fogColor: new Fe(0),
              fogNear: 50,
              fogFar: 100,
              fogMode: "scene",
              fogScale: "relative",
              backgroundColor: new Fe(0),
              cameraType: "perspective",
              cameraFov: 40,
              cameraEyeSep: .3,
              cameraZ: -80,
              clipNear: 0,
              clipFar: 100,
              clipDist: 10,
              clipMode: "scene",
              clipScale: "relative",
              lightColor: new Fe(14540253),
              lightIntensity: 1,
              ambientColor: new Fe(14540253),
              ambientIntensity: .2,
              sampleLevel: 0
            };
          }, yh.prototype._initCamera = function () {
            var e = new ae(0, 0, 0),
              t = this.width,
              n = this.height;
            this.perspectiveCamera = new wi(this.parameters.cameraFov, t / n), this.perspectiveCamera.position.z = this.parameters.cameraZ, this.perspectiveCamera.lookAt(e), this.orthographicCamera = new mt(t / -2, t / 2, n / 2, n / -2), this.orthographicCamera.position.z = this.parameters.cameraZ, this.orthographicCamera.lookAt(e), this.stereoCamera = new tl(), this.stereoCamera.aspect = .5, this.stereoCamera.eyeSep = this.parameters.cameraEyeSep;
            var r = this.parameters.cameraType;
            if ("orthographic" === r) this.camera = this.orthographicCamera;else {
              if ("perspective" !== r && "stereo" !== r) throw new Error("Unknown cameraType '" + r + "'");
              this.camera = this.perspectiveCamera;
            }
            this.camera.updateProjectionMatrix();
          }, yh.prototype._initStats = function () {
            this.stats = new Cd();
          }, yh.prototype._initScene = function () {
            this.scene || (this.scene = new ki(), this.scene.name = "scene"), this.rotationGroup = new xi(), this.rotationGroup.name = "rotationGroup", this.scene.add(this.rotationGroup), this.translationGroup = new xi(), this.translationGroup.name = "translationGroup", this.rotationGroup.add(this.translationGroup), this.modelGroup = new xi(), this.modelGroup.name = "modelGroup", this.translationGroup.add(this.modelGroup), this.pickingGroup = new xi(), this.pickingGroup.name = "pickingGroup", this.translationGroup.add(this.pickingGroup), this.backgroundGroup = new xi(), this.backgroundGroup.name = "backgroundGroup", this.translationGroup.add(this.backgroundGroup), this.helperGroup = new xi(), this.helperGroup.name = "helperGroup", this.translationGroup.add(this.helperGroup), this.scene.fog = new Ci(this.parameters.fogColor.getHex()), this.spotLight = new Za(this.parameters.lightColor.getHex(), this.parameters.lightIntensity), this.scene.add(this.spotLight), this.ambientLight = new ts(this.parameters.ambientColor.getHex(), this.parameters.ambientIntensity), this.scene.add(this.ambientLight);
          }, yh.prototype._initRenderer = function () {
            var e = window.devicePixelRatio,
              n = this.width,
              r = this.height;
            try {
              this.renderer = new Ti({
                preserveDrawingBuffer: !0,
                alpha: !0,
                antialias: !0
              });
            } catch (e) {
              return !(this.wrapper.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;"><p style="padding:15px;text-align:center;">Your browser/graphics card does not seem to support <a target="_blank" href="https://en.wikipedia.org/wiki/WebGL">WebGL</a>.<br/><br/>Find out how to get it <a target="_blank" href="http://get.webgl.org/">here</a>.</p></div>');
            }
            this.renderer.setPixelRatio(e), this.renderer.setSize(n, r), this.renderer.autoClear = !1, this.renderer.sortObjects = !0;
            var i,
              o,
              a = this.renderer.getContext();
            i = this.renderer.extensions.get("EXT_frag_depth"), Kc = i, this.renderer.extensions.get("OES_element_index_uint"), o = this.renderer.extensions.get("OES_texture_float") && this.renderer.extensions.get("WEBGL_color_buffer_float") || this.renderer.extensions.get("OES_texture_float") && hh(a.FLOAT), Yc = o, this.wrapper.appendChild(this.renderer.domElement);
            var s = n * e,
              l = r * e;
            this.renderer.extensions.get("OES_texture_float"), this.supportsHalfFloat = this.renderer.extensions.get("OES_texture_half_float") && hh(36193), this.renderer.extensions.get("WEBGL_color_buffer_float"), t.Debug && console.log(JSON.stringify({
              Browser: Hc,
              OES_texture_float: !!this.renderer.extensions.get("OES_texture_float"),
              OES_texture_half_float: !!this.renderer.extensions.get("OES_texture_half_float"),
              WEBGL_color_buffer_float: !!this.renderer.extensions.get("WEBGL_color_buffer_float"),
              "testTextureSupport Float": hh(a.FLOAT),
              "testTextureSupport HalfFloat": hh(36193),
              "this.supportsHalfFloat": this.supportsHalfFloat,
              SupportsReadPixelsFloat: Yc
            }, null, 2)), this.pickingTarget = new Ce(s, l, {
              minFilter: W,
              magFilter: W,
              stencilBuffer: !1,
              format: Z,
              type: Yc ? Y : X
            }), this.pickingTarget.texture.generateMipmaps = !1, this.renderer.clearTarget(this.pickingTarget, !0, !0, !0), this.renderer.setRenderTarget(null), this.sampleTarget = new Ce(s, l, {
              minFilter: $,
              magFilter: $,
              format: Z
            }), this.holdTarget = new Ce(s, l, {
              minFilter: W,
              magFilter: W,
              format: Z,
              type: X
            }), this.compositeUniforms = {
              tForeground: new Yl(this.sampleTarget.texture),
              scale: new Yl(1)
            }, this.compositeMaterial = new Cn({
              uniforms: this.compositeUniforms,
              vertexShader: Od("Quad.vert"),
              fragmentShader: Od("Quad.frag"),
              premultipliedAlpha: !0,
              transparent: !0,
              blending: 2,
              depthTest: !1,
              depthWrite: !1
            }), this.compositeCamera = new mt(-1, 1, 1, -1, 0, 1), this.compositeScene = new ki(), this.compositeScene.name = "compositeScene", this.compositeScene.add(new On(new Qt(2, 2), this.compositeMaterial));
          }, yh.prototype._initHelper = function () {
            var e = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
              t = new Float32Array(24),
              n = new Yt();
            n.setIndex(new Tt(e, 1)), n.addAttribute("position", new Tt(t, 3));
            var r = new Cn({
              uniforms: {
                uColor: {
                  value: new Fe("skyblue")
                }
              },
              vertexShader: Od("BasicLine.vert"),
              fragmentShader: Od("BasicLine.frag")
            });
            this.boundingBoxMesh = new zi(n, r), this.helperGroup.add(this.boundingBoxMesh);
          }, yh.prototype.updateHelper = function () {
            var e = this.boundingBoxMesh.geometry.attributes.position,
              t = e.array,
              n = this.boundingBox,
              r = n.min,
              i = n.max;
            t[0] = i.x, t[1] = i.y, t[2] = i.z, t[3] = r.x, t[4] = i.y, t[5] = i.z, t[6] = r.x, t[7] = r.y, t[8] = i.z, t[9] = i.x, t[10] = r.y, t[11] = i.z, t[12] = i.x, t[13] = i.y, t[14] = r.z, t[15] = r.x, t[16] = i.y, t[17] = r.z, t[18] = r.x, t[19] = r.y, t[20] = r.z, t[21] = i.x, t[22] = r.y, t[23] = r.z, e.needsUpdate = !0, this.boundingBox.isEmpty() || this.boundingBoxMesh.geometry.computeBoundingSphere();
          }, yh.prototype.add = function (e, n) {
            var r = this;
            n ? n.forEach(function (t) {
              return r.addBuffer(e, t);
            }) : this.addBuffer(e), e.parameters.background ? (this.backgroundGroup.add(e.group), this.backgroundGroup.add(e.wireframeGroup)) : (this.modelGroup.add(e.group), this.modelGroup.add(e.wireframeGroup)), e.pickable && this.pickingGroup.add(e.pickingGroup), t.Debug && this.updateHelper();
          }, yh.prototype.addBuffer = function (e, t) {
            function n(r) {
              r instanceof xi ? r.children.forEach(n) : (r.userData.buffer = e, r.userData.instance = t, r.onBeforeRender = vh);
            }
            var r = e.getMesh();
            t && r.applyMatrix(t.matrix), n(r), e.group.add(r);
            var i = e.getWireframeMesh();
            if (t && (i.matrix.copy(r.matrix), i.position.copy(r.position), i.quaternion.copy(r.quaternion), i.scale.copy(r.scale)), n(i), e.wireframeGroup.add(i), e.pickable) {
              var o = e.getPickingMesh();
              t && (o.matrix.copy(r.matrix), o.position.copy(r.position), o.quaternion.copy(r.quaternion), o.scale.copy(r.scale)), n(o), e.pickingGroup.add(o);
            }
            t ? this._updateBoundingBox(e.geometry, e.matrix, t.matrix) : this._updateBoundingBox(e.geometry, e.matrix);
          }, yh.prototype.remove = function (e) {
            this.translationGroup.children.forEach(function (t) {
              t.remove(e.group), t.remove(e.wireframeGroup);
            }), e.pickable && this.pickingGroup.remove(e.pickingGroup), this.updateBoundingBox(), t.Debug && this.updateHelper();
          }, yh.prototype._updateBoundingBox = function (e, t, n) {
            var r = this.boundingBox;
            function i(e, t, n) {
              e.boundingBox || e.computeBoundingBox();
              var i = e.boundingBox.clone();
              t && i.applyMatrix4(t), n && i.applyMatrix4(n), i.min.equals(i.max) && i.expandByScalar(5), r.union(i);
            }
            function o(e) {
              var t, n;
              void 0 !== e.geometry && (e.userData.buffer && (t = e.userData.buffer.matrix), e.userData.instance && (n = e.userData.instance.matrix), i(e.geometry, t, n));
            }
            e ? i(e, t, n) : (r.makeEmpty(), this.modelGroup.traverse(o), this.backgroundGroup.traverse(o)), r.getSize(this.boundingBoxSize), this.boundingBoxLength = this.boundingBoxSize.length();
          }, yh.prototype.updateBoundingBox = function () {
            this._updateBoundingBox(), t.Debug && this.updateHelper();
          }, yh.prototype.getPickingPixels = function () {
            var e = this.width,
              t = this.height,
              n = e * t * 4,
              r = Yc ? new Float32Array(n) : new Uint8Array(n);
            return this.render(!0), this.renderer.readRenderTargetPixels(this.pickingTarget, 0, 0, e, t, r), r;
          }, yh.prototype.getImage = function (e) {
            var t = this;
            return new Promise(function (n) {
              if (e) {
                var r = t,
                  i = r.width,
                  o = r.height,
                  a = i * o * 4,
                  s = t.getPickingPixels();
                if (Yc) {
                  for (var l = new Uint8Array(a), u = 0; u < a; ++u) l[u] = Math.round(255 * s[u]);
                  s = l;
                }
                var c = document.createElement("canvas");
                c.width = i, c.height = o;
                var d = c.getContext("2d"),
                  h = d.getImageData(0, 0, i, o);
                h.data.set(s), d.putImageData(h, 0, 0), c.toBlob(n, "image/png");
              } else t.renderer.domElement.toBlob(n, "image/png");
            });
          }, yh.prototype.makeImage = function (e) {
            return void 0 === e && (e = {}), function (e, t) {
              void 0 === t && (t = {});
              var n = Su(t, th),
                r = n.trim,
                i = n.factor,
                o = n.antialias,
                a = n.transparent,
                s = e.renderer,
                l = e.camera,
                u = s.getClearAlpha(),
                c = s.getClearColor();
              function d(t) {
                void 0 === t && (t = !1);
                var n = i;
                o && (n *= 2), t && (n = 1 / n), e.scene.traverse(function (e) {
                  var t = e.material;
                  t && t.linewidth && (t.linewidth *= n), t && t.uniforms && t.uniforms.size && void 0 === t.uniforms.size.__seen && (t.uniforms.size.value *= n, t.uniforms.size.__seen = !0), t && t.uniforms && t.uniforms.linewidth && void 0 === t.uniforms.linewidth.__seen && (t.uniforms.linewidth.value *= n, t.uniforms.linewidth.__seen = !0);
                }), e.scene.traverse(function (e) {
                  var t = e.material;
                  t && t.uniforms && t.uniforms.size && delete t.uniforms.size.__seen, t && t.uniforms && t.uniforms.linewidth && delete t.uniforms.linewidth.__seen;
                });
              }
              function h(e) {
                if (r) {
                  var t = c;
                  return function (e, t, n, r, i) {
                    var o,
                      a,
                      s,
                      l,
                      u = e.height,
                      c = e.width,
                      d = e.getContext("2d").getImageData(0, 0, c, u).data;
                    for (s = !1, a = 0; a < u; a++) {
                      for (o = 0; o < c; o++) if (d[l = 4 * (a * c + o)] !== t || d[l + 1] !== n || d[l + 2] !== r || d[l + 3] !== i) {
                        s = !0;
                        break;
                      }
                      if (s) break;
                    }
                    var h = a;
                    for (s = !1, o = 0; o < c; o++) {
                      for (a = 0; a < u; a++) if (d[l = 4 * (a * c + o)] !== t || d[l + 1] !== n || d[l + 2] !== r || d[l + 3] !== i) {
                        s = !0;
                        break;
                      }
                      if (s) break;
                    }
                    var f = o;
                    for (s = !1, a = u - 1; 0 <= a; a--) {
                      for (o = c - 1; 0 <= o; o--) if (d[l = 4 * (a * c + o)] !== t || d[l + 1] !== n || d[l + 2] !== r || d[l + 3] !== i) {
                        s = !0;
                        break;
                      }
                      if (s) break;
                    }
                    var p = a;
                    for (s = !1, o = c - 1; 0 <= o; o--) {
                      for (a = u - 1; 0 <= a; a--) if (d[l = 4 * (a * c + o)] !== t || d[l + 1] !== n || d[l + 2] !== r || d[l + 3] !== i) {
                        s = !0;
                        break;
                      }
                      if (s) break;
                    }
                    var m = o,
                      g = document.createElement("canvas");
                    return g.width = m - f, g.height = p - h, g.getContext("2d").drawImage(e, f, h, g.width, g.height, 0, 0, g.width, g.height), g;
                  }(e, a ? 0 : 255 * t.r, a ? 0 : 255 * t.g, a ? 0 : 255 * t.b, a ? 0 : 255);
                }
                return e;
              }
              function f(e, n, r) {
                "function" == typeof t.onProgress && t.onProgress(e, n, r);
              }
              return new Promise(function (t, n) {
                var r = new Bd(s, l, e, {
                  factor: i,
                  antialias: o,
                  onProgress: f,
                  onFinish: function onFinish(i, o) {
                    h(r.canvas).toBlob(function (r) {
                      s.setClearAlpha(u), d(!0), e.requestRender(), f(o, o, !0), r ? t(r) : n("error creating image");
                    }, "image/png");
                  }
                });
                s.setClearAlpha(a ? 0 : 1), d(), r.renderAsync();
              });
            }(this, e);
          }, yh.prototype.setLight = function (e, t, n, r) {
            var i = this.parameters;
            void 0 !== e && i.lightColor.set(e), void 0 !== t && (i.lightIntensity = t), void 0 !== n && i.ambientColor.set(n), void 0 !== r && (i.ambientIntensity = r), this.requestRender();
          }, yh.prototype.setFog = function (e, t, n, r, i) {
            var o = this.parameters;
            void 0 !== e && o.fogColor.set(e), void 0 !== t && (o.fogNear = t), void 0 !== n && (o.fogFar = n), void 0 !== r && (o.fogMode = r), void 0 !== i && (o.fogScale = i), this.requestRender();
          }, yh.prototype.setBackground = function (e) {
            var t = this.parameters;
            e && t.backgroundColor.set(e), this.setFog(t.backgroundColor), this.renderer.setClearColor(t.backgroundColor, 0), this.renderer.domElement.style.backgroundColor = t.backgroundColor.getStyle(), this.requestRender();
          }, yh.prototype.setSampling = function (e) {
            void 0 !== e && (this.parameters.sampleLevel = e, this.sampleLevel = e), this.requestRender();
          }, yh.prototype.setCamera = function (e, t, n) {
            var r = this.parameters;
            if (e && (r.cameraType = e), t && (r.cameraFov = t), n && (r.cameraEyeSep = n), "orthographic" === r.cameraType) this.camera !== this.orthographicCamera && (this.camera = this.orthographicCamera, this.camera.position.copy(this.perspectiveCamera.position), this.camera.up.copy(this.perspectiveCamera.up), this.updateZoom());else {
              if ("perspective" !== r.cameraType && "stereo" !== r.cameraType) throw new Error("Unknown cameraType '" + r.cameraType + "'");
              this.camera !== this.perspectiveCamera && (this.camera = this.perspectiveCamera, this.camera.position.copy(this.orthographicCamera.position), this.camera.up.copy(this.orthographicCamera.up));
            }
            this.perspectiveCamera.fov = r.cameraFov, this.stereoCamera.eyeSep = r.cameraEyeSep, this.camera.updateProjectionMatrix(), this.requestRender();
          }, yh.prototype.setClip = function (e, t, n, r, i) {
            var o = this.parameters;
            void 0 !== e && (o.clipNear = e), void 0 !== t && (o.clipFar = t), void 0 !== n && (o.clipDist = n), void 0 !== r && (o.clipMode = r), void 0 !== i && (o.clipScale = i), this.requestRender();
          }, yh.prototype.setSize = function (e, t) {
            this.width = e || 1, this.height = t || 1, this.perspectiveCamera.aspect = this.width / this.height, this.orthographicCamera.left = -this.width / 2, this.orthographicCamera.right = this.width / 2, this.orthographicCamera.top = this.height / 2, this.orthographicCamera.bottom = -this.height / 2, this.camera.updateProjectionMatrix();
            var n = window.devicePixelRatio;
            this.renderer.setPixelRatio(n), this.renderer.setSize(e, t);
            var r = this.width * n,
              i = this.height * n;
            this.pickingTarget.setSize(r, i), this.sampleTarget.setSize(r, i), this.holdTarget.setSize(r, i), this.requestRender();
          }, yh.prototype.handleResize = function () {
            if (this.container === document.body) this.setSize(window.innerWidth, window.innerHeight);else {
              var e = this.container.getBoundingClientRect();
              this.setSize(e.width, e.height);
            }
          }, yh.prototype.updateInfo = function (e) {
            var t = this.info,
              n = t.memory,
              r = t.render;
            if (e) n.programs = 0, n.geometries = 0, n.textures = 0, r.calls = 0, r.vertices = 0, r.points = 0;else {
              var i = this.renderer.info,
                o = i.memory,
                a = i.render;
              n.geometries = o.geometries, n.textures = o.textures, r.calls += a.calls, r.faces += a.triangles, r.points += a.points;
            }
          }, yh.prototype.animate = function () {
            if (this.signals.ticked.dispatch(this.stats), 500 < window.performance.now() - this.stats.startTime && !this.isStill && this.sampleLevel < 3 && -1 !== this.sampleLevel) {
              var e = this.sampleLevel;
              this.sampleLevel = 3, this.renderPending = !0, this.render(), this.isStill = !0, this.sampleLevel = e, t.Debug && Zc.log("rendered still frame");
            }
            window.requestAnimationFrame(this.animate);
          }, yh.prototype.pick = function (e, t) {
            if ("stereo" === this.parameters.cameraType) return {
              pid: 0,
              instance: void 0,
              picker: void 0
            };
            e *= window.devicePixelRatio, t *= window.devicePixelRatio, e = Math.max(e - 2, 0), t = Math.max(t - 2, 0);
            var n,
              r,
              i = 0,
              o = Yc ? fh : ph;
            this.render(!0), this.renderer.readRenderTargetPixels(this.pickingTarget, e, t, 5, 5, o);
            for (var a = 0; a < mh.length; a++) {
              var s = 4 * mh[a],
                l = Math.round(o[s + 3]),
                u = this.pickingGroup.getObjectById(l);
              u && (n = u.userData.instance, r = u.userData.buffer.picking, i = Yc ? Math.round(255 * o[s]) << 16 & 16711680 | Math.round(255 * o[s + 1]) << 8 & 65280 | 255 & Math.round(255 * o[s + 2]) : o[s] << 16 | o[s + 1] << 8 | o[s + 2]);
            }
            return {
              pid: i,
              instance: n,
              picker: r
            };
          }, yh.prototype.requestRender = function () {
            var e = this;
            this.renderPending || (22 < window.performance.now() - this.stats.startTime && (this.stats.begin(), this.isStill = !1), this.renderPending = !0, window.requestAnimationFrame(function () {
              e.render(), e.stats.update();
            }));
          }, yh.prototype.updateZoom = function () {
            var e = qu(this.perspectiveCamera.fov),
              t = 2 * Math.tan(e / 2) * -this.camera.position.z;
            this.orthographicCamera.zoom = this.height / t;
          }, yh.prototype.__updateClipping = function () {
            var e = this.parameters;
            if (this.cDist = this.distVector.copy(this.camera.position).length(), this.cDist || (this.camera.position.set(0, 0, e.cameraZ), this.cDist = Math.abs(e.cameraZ)), "absolute" === e.clipScale && "absolute" === e.fogScale || (this.bRadius = Math.max(10, .5 * this.boundingBoxLength), this.bRadius += this.boundingBox.getCenter(this.distVector).length(), (this.bRadius === 1 / 0 || this.bRadius === -1 / 0 || isNaN(this.bRadius)) && (this.bRadius = 50)), "camera" == e.clipMode) this.camera.near = e.clipNear, this.camera.far = e.clipFar;else if ("absolute" == e.clipScale) this.camera.near = this.cDist - e.clipNear, this.camera.far = this.cDist + e.clipFar;else {
              var t = (50 - e.clipNear) / 50,
                n = -(50 - e.clipFar) / 50;
              this.camera.near = this.cDist - this.bRadius * t, this.camera.far = this.cDist + this.bRadius * n;
            }
            var r = this.scene.fog;
            if (r.color.set(e.fogColor), "camera" == e.fogMode) r.near = e.fogNear, r.far = e.fogFar;else if ("absolute" == e.fogScale) r.near = this.cDist + e.fogNear, r.far = this.cDist + e.fogFar;else {
              var i = (50 - e.fogNear) / 50,
                o = -(50 - e.fogFar) / 50;
              r.near = this.cDist - this.bRadius * i, r.far = this.cDist + this.bRadius * o;
            }
            "PerspectiveCamera" === this.camera.type ? (this.camera.near = Math.max(.1, e.clipDist, this.camera.near), this.camera.far = Math.max(1, this.camera.far), r.near = Math.max(.1, r.near), r.far = Math.max(1, r.far)) : "OrthographicCamera" === this.camera.type && 0 < e.clipDist && (this.camera.near = Math.max(e.clipDist, this.camera.near));
          }, yh.prototype.__updateCamera = function () {
            var e,
              t,
              n,
              r,
              i,
              o,
              a,
              s,
              l,
              u,
              c,
              d,
              h,
              f = this.camera;
            f.updateMatrix(), f.updateMatrixWorld(!0), f.updateProjectionMatrix(), e = this.scene, t = f, n = this.renderer, r = this.cDist, i = this.bRadius, a = (o = n.getSize()).width, s = o.height, l = s, u = n.getPixelRatio(), c = "OrthographicCamera" === t.type, oh.set(a, s), ah.getInverse(t.projectionMatrix), sh.copy(t.projectionMatrix).transpose(), e.traverse(function (e) {
              var t = e.material;
              if (t) {
                var n = t.uniforms;
                if (n) {
                  if (t.clipNear) {
                    var o = (50 - t.clipNear) / 50,
                      a = r - i * o;
                    n.clipNear.value = a;
                  }
                  n.canvasHeight && (n.canvasHeight.value = l), n.resolution && n.resolution.value.copy(oh), n.pixelRatio && (n.pixelRatio.value = u), n.projectionMatrixInverse && n.projectionMatrixInverse.value.copy(ah), n.projectionMatrixTranspose && n.projectionMatrixTranspose.value.copy(sh), n.ortho && (n.ortho.value = c);
                }
              }
            }), d = this.scene, h = f, d.traverseVisible(function (e) {
              if (e instanceof Vi && e.userData.buffer.parameters.sortParticles) {
                var t = e.geometry.attributes,
                  n = t.position.count;
                if (0 !== n) {
                  var r, i, o, a, s, l, u;
                  rh.multiplyMatrices(h.matrixWorldInverse, e.matrixWorld), ih.multiplyMatrices(h.projectionMatrix, rh), e.userData.sortData ? (r = e.userData.sortData, o = r.__zArray, i = r.__sortArray, a = r.__cmpFn) : (o = new Float32Array(n), i = new Uint32Array(n), r = {
                    __zArray: o,
                    __sortArray: i,
                    __cmpFn: a = function a(e, t) {
                      var n = o[e],
                        r = o[t];
                      return r < n ? 1 : n < r ? -1 : 0;
                    }
                  }, e.userData.sortData = r);
                  for (var c = 0; c < n; ++c) nh.fromArray(t.position.array, 3 * c), nh.applyMatrix4(ih), o[c] = -nh.z, i[c] = c;
                  for (var d in function (e, t, n, r) {
                    void 0 === n && (n = 0), t = t || function (e, t) {
                      return t < e ? 1 : e < t ? -1 : 0;
                    };
                    var i,
                      o,
                      a,
                      s = [],
                      l = -1,
                      u = n,
                      c = r = (r || e.length) - 1;
                    function d(t, n) {
                      var r = e[t];
                      e[t] = e[n], e[n] = r;
                    }
                    for (;;) if (c - u <= 25) {
                      for (var h = u + 1; h <= c; ++h) {
                        for (i = e[h], o = h - 1; u <= o && 0 < t(e[o], i);) e[o + 1] = e[o], --o;
                        e[o + 1] = i;
                      }
                      if (-1 === l) break;
                      c = s[l--], u = s[l--];
                    } else {
                      for (d(u + (a = c) >> 1, o = u + 1), 0 < t(e[u], e[c]) && d(u, c), 0 < t(e[o], e[c]) && d(o, c), 0 < t(e[u], e[o]) && d(u, o), i = e[o];;) {
                        for (; t(e[++o], i) < 0;);
                        for (; 0 < t(e[--a], i););
                        if (a < o) break;
                        d(o, a);
                      }
                      e[u + 1] = e[a], e[a] = i, a - u <= c - o + 1 ? (s[++l] = o, s[++l] = c, c = a - 1) : (s[++l] = u, s[++l] = a - 1, u = o);
                    }
                  }(i, a), t) {
                    var f = t[d],
                      p = f.array,
                      m = f.itemSize;
                    r[d] || (r[d] = new Float32Array(m * n)), u = r[d], r[d] = p;
                    for (var g = 0; g < n; ++g) {
                      s = i[g];
                      for (var v = 0; v < m; ++v) l = s * m + v, u[g * m + v] = p[l];
                    }
                    t[d].array = u, t[d].needsUpdate = !0;
                  }
                }
              }
            });
          }, yh.prototype.__setVisibility = function (e, t, n, r) {
            this.modelGroup.visible = e, this.pickingGroup.visible = t, this.backgroundGroup.visible = n, this.helperGroup.visible = r;
          }, yh.prototype.__updateLights = function () {
            this.spotLight.color.set(this.parameters.lightColor), this.spotLight.intensity = this.parameters.lightIntensity, this.distVector.copy(this.camera.position).setLength(100 * this.boundingBoxLength), this.spotLight.position.copy(this.camera.position).add(this.distVector), this.ambientLight.color.set(this.parameters.ambientColor), this.ambientLight.intensity = this.parameters.ambientIntensity;
          }, yh.prototype.__renderPickingGroup = function (e) {
            this.renderer.clearTarget(this.pickingTarget, !0, !0, !0), this.__setVisibility(!1, !0, !1, !1), this.renderer.render(this.scene, e, this.pickingTarget), this.updateInfo(), this.renderer.setRenderTarget(null);
          }, yh.prototype.__renderModelGroup = function (e, n) {
            n ? this.renderer.clearTarget(n, !0, !0, !0) : this.renderer.clear(), this.__setVisibility(!1, !1, !0, !1), this.renderer.render(this.scene, e, n), n ? this.renderer.clearTarget(n, !1, !0, !1) : this.renderer.clearDepth(), this.updateInfo(), this.__setVisibility(!0, !1, !1, t.Debug), this.renderer.render(this.scene, e, n), this.updateInfo();
          }, yh.prototype.__renderSuperSample = function (e) {
            var t = Dd[Math.max(0, Math.min(this.sampleLevel, 5))],
              n = 1 / t.length;
            this.compositeUniforms.tForeground.value = this.sampleTarget.texture;
            var r = this.sampleTarget.width,
              i = this.sampleTarget.height;
            "stereo" === this.parameters.cameraType && (r /= 2);
            for (var o = 0; o < t.length; ++o) {
              var a = t[o];
              e.setViewOffset(r, i, a[0], a[1], r, i), e.updateProjectionMatrix(), lh(this.scene, e);
              var s = n;
              s += 1 / 32 * ((o + .5) / t.length - .5), this.compositeUniforms.scale.value = s, this.__renderModelGroup(e, this.sampleTarget), this.renderer.render(this.compositeScene, this.compositeCamera, this.holdTarget, 0 === o);
            }
            this.compositeUniforms.scale.value = 1, this.compositeUniforms.tForeground.value = this.holdTarget.texture, e.clearViewOffset(), this.renderer.render(this.compositeScene, this.compositeCamera, null, !0);
          }, yh.prototype.__renderStereo = function (e) {
            void 0 === e && (e = !1);
            var t = this.stereoCamera;
            t.update(this.perspectiveCamera);
            var n = this.renderer,
              r = n.getSize();
            n.setScissorTest(!0), n.setScissor(0, 0, r.width / 2, r.height), n.setViewport(0, 0, r.width / 2, r.height), lh(this.scene, t.cameraL), this.__render(e, t.cameraL), n.setScissor(r.width / 2, 0, r.width / 2, r.height), n.setViewport(r.width / 2, 0, r.width / 2, r.height), lh(this.scene, t.cameraR), this.__render(e, t.cameraR), n.setScissorTest(!1), n.setViewport(0, 0, r.width, r.height);
          }, yh.prototype.__render = function (e, t) {
            void 0 === e && (e = !1), e ? this.lastRenderedPicking || this.__renderPickingGroup(t) : 0 < this.sampleLevel && "stereo" !== this.parameters.cameraType ? this.__renderSuperSample(t) : this.__renderModelGroup(t);
          }, yh.prototype.render = function (e) {
            void 0 === e && (e = !1), this.rendering ? Zc.warn("'tried to call 'render' from within 'render'") : (this.rendering = !0, this.__updateClipping(), this.__updateCamera(), this.__updateLights(), this.updateInfo(!0), "stereo" === this.parameters.cameraType ? this.__renderStereo(e) : this.__render(e, this.camera), this.lastRenderedPicking = e, this.rendering = !1, this.renderPending = !1, this.signals.rendered.dispatch());
          }, yh.prototype.clear = function () {
            Zc.log("scene cleared"), this.scene.remove(this.rotationGroup), this._initScene(), this.renderer.clear();
          }, yh.prototype.dispose = function () {
            this.renderer.dispose();
          };
          var _h = function _h(e, t) {
              void 0 === t && (t = {}), this.domElement = e, this.signals = {
                moved: new lc(),
                scrolled: new lc(),
                dragged: new lc(),
                dropped: new lc(),
                clicked: new lc(),
                hovered: new lc(),
                doubleClicked: new lc()
              }, this.position = new re(), this.prevPosition = new re(), this.down = new re(), this.canvasPosition = new re(), this.prevClickCP = new re(), this.moving = !1, this.hovering = !0, this.scrolled = !1, this.lastMoved = 1 / 0, this.which = 0, this.buttons = 0, this.pressed = !1, this.altKey = !1, this.ctrlKey = !1, this.metaKey = !1, this.shiftKey = !1, this.domElement.style.touchAction = "none", this.hoverTimeout = wu(t.hoverTimeout, 50), this.handleScroll = wu(t.handleScroll, !0), this.doubleClickSpeed = wu(t.doubleClickSpeed, 500), this._listen = this._listen.bind(this), this._onMousewheel = this._onMousewheel.bind(this), this._onMousemove = this._onMousemove.bind(this), this._onMousedown = this._onMousedown.bind(this), this._onMouseup = this._onMouseup.bind(this), this._onContextmenu = this._onContextmenu.bind(this), this._onTouchstart = this._onTouchstart.bind(this), this._onTouchend = this._onTouchend.bind(this), this._onTouchmove = this._onTouchmove.bind(this), this._listen();
              var n = {
                passive: !1
              };
              document.addEventListener("mousewheel", this._onMousewheel, n), document.addEventListener("wheel", this._onMousewheel, n), document.addEventListener("MozMousePixelScroll", this._onMousewheel, n), document.addEventListener("mousemove", this._onMousemove, n), document.addEventListener("mousedown", this._onMousedown, n), document.addEventListener("mouseup", this._onMouseup, n), document.addEventListener("contextmenu", this._onContextmenu, n), document.addEventListener("touchstart", this._onTouchstart, n), document.addEventListener("touchend", this._onTouchend, n), document.addEventListener("touchmove", this._onTouchmove, n);
            },
            xh = {
              key: {
                configurable: !0
              }
            };
          xh.key.get = function () {
            var e = 0;
            return this.altKey && (e += 1), this.ctrlKey && (e += 2), this.metaKey && (e += 4), this.shiftKey && (e += 8), e;
          }, _h.prototype.setParameters = function (e) {
            void 0 === e && (e = {}), this.hoverTimeout = wu(e.hoverTimeout, this.hoverTimeout);
          }, _h.prototype._listen = function () {
            var e = window.performance.now(),
              t = this.canvasPosition;
            this.doubleClickPending && e - this.lastClicked > this.doubleClickSpeed && (this.doubleClickPending = !1), e - this.lastMoved > this.hoverTimeout && (this.moving = !1), (this.scrolled || !this.moving && !this.hovering) && (this.scrolled = !1, -1 !== this.hoverTimeout && this.overElement && (this.hovering = !0, this.signals.hovered.dispatch(t.x, t.y))), window.requestAnimationFrame(this._listen);
          }, _h.prototype._onMousewheel = function (e) {
            var t,
              n = this;
            e.target === this.domElement && this.handleScroll && (e.preventDefault(), this._setKeys(e), t = e.wheelDelta ? e.wheelDelta / 40 : e.detail ? -e.detail / 3 : -e.deltaY / (e.deltaMode ? .33 : 30), this.signals.scrolled.dispatch(t), setTimeout(function () {
              n.scrolled = !0;
            }, this.hoverTimeout));
          }, _h.prototype._onMousemove = function (e) {
            e.target === this.domElement ? (e.preventDefault(), this.overElement = !0) : this.overElement = !1, this._setKeys(e), this.moving = !0, this.hovering = !1, this.lastMoved = window.performance.now(), this.prevPosition.copy(this.position), this.position.set(e.clientX, e.clientY), this._setCanvasPosition(e);
            var t = this.prevPosition.x - this.position.x,
              n = this.prevPosition.y - this.position.y;
            this.signals.moved.dispatch(t, n), this.pressed && this.signals.dragged.dispatch(t, n);
          }, _h.prototype._onMousedown = function (e) {
            e.target === this.domElement && (e.preventDefault(), this._setKeys(e), this.moving = !1, this.hovering = !1, this.down.set(e.clientX, e.clientY), this.position.set(e.clientX, e.clientY), this.which = e.which, this.buttons = function (e) {
              if ("object" == typeof e) {
                if ("buttons" in e) return e.buttons;
                if ("which" in e) {
                  var t = e.which;
                  if (2 === t) return 4;
                  if (3 === t) return 2;
                  if (0 < t) return 1 << t - 1;
                } else if ("button" in e) {
                  var n = e.button;
                  if (1 === n) return 4;
                  if (2 === n) return 2;
                  if (0 <= n) return 1 << n;
                }
              }
              return 0;
            }(e), this.pressed = !0, this._setCanvasPosition(e));
          }, _h.prototype._onMouseup = function (e) {
            e.target === this.domElement && e.preventDefault(), this._setKeys(e);
            var t = this.canvasPosition;
            this._distance() < 4 && (this.lastClicked = window.performance.now(), this.doubleClickPending && this.prevClickCP.distanceTo(t) < 4 && (this.signals.doubleClicked.dispatch(t.x, t.y), this.doubleClickPending = !1), this.signals.clicked.dispatch(t.x, t.y), this.doubleClickPending = !0, this.prevClickCP.copy(t)), this.which = void 0, this.buttons = void 0, this.pressed = void 0;
          }, _h.prototype._onContextmenu = function (e) {
            e.target === this.domElement && e.preventDefault();
          }, _h.prototype._onTouchstart = function (e) {
            if (e.target === this.domElement) switch (e.preventDefault(), this.pressed = !0, e.touches.length) {
              case 1:
                this.moving = !1, this.hovering = !1, this.down.set(e.touches[0].pageX, e.touches[0].pageY), this.position.set(e.touches[0].pageX, e.touches[0].pageY), this._setCanvasPosition(e.touches[0]);
                break;
              case 2:
                this.down.set((e.touches[0].pageX + e.touches[1].pageX) / 2, (e.touches[0].pageY + e.touches[1].pageY) / 2), this.position.set((e.touches[0].pageX + e.touches[1].pageX) / 2, (e.touches[0].pageY + e.touches[1].pageY) / 2), this.lastTouchDistance = bh(e);
            }
          }, _h.prototype._onTouchend = function (e) {
            e.target === this.domElement && e.preventDefault(), this.which = void 0, this.buttons = void 0, this.pressed = void 0;
          }, _h.prototype._onTouchmove = function (e) {
            switch (e.target === this.domElement ? (e.preventDefault(), this.overElement = !0) : this.overElement = !1, e.touches.length) {
              case 1:
                this._setKeys(e), this.which = 1, this.buttons = 1, this.moving = !0, this.hovering = !1, this.lastMoved = window.performance.now(), this.prevPosition.copy(this.position), this.position.set(e.touches[0].pageX, e.touches[0].pageY), this._setCanvasPosition(e.touches[0]);
                var t = this.prevPosition.x - this.position.x,
                  n = this.prevPosition.y - this.position.y;
                this.signals.moved.dispatch(t, n), this.pressed && this.signals.dragged.dispatch(t, n);
                break;
              case 2:
                var r = bh(e),
                  i = r - this.lastTouchDistance;
                if (this.lastTouchDistance = r, this.prevPosition.copy(this.position), this.position.set((e.touches[0].pageX + e.touches[1].pageX) / 2, (e.touches[0].pageY + e.touches[1].pageY) / 2), 2 < Math.abs(i) && this.handleScroll && this.position.distanceTo(this.prevPosition) < 2) this.which = 0, this.buttons = 0, this.signals.scrolled.dispatch(i / 2);else {
                  this.which = 3, this.buttons = 2;
                  var o = this.prevPosition.x - this.position.x,
                    a = this.prevPosition.y - this.position.y;
                  this.signals.moved.dispatch(o, a), this.pressed && this.signals.dragged.dispatch(o, a);
                }
            }
          }, _h.prototype._distance = function () {
            return this.position.distanceTo(this.down);
          }, _h.prototype._setCanvasPosition = function (e) {
            var t,
              n,
              r = this.domElement.getBoundingClientRect();
            "offsetX" in e && "offsetY" in e ? (t = e.offsetX, n = e.offsetY) : (t = e.clientX - r.left, n = e.clientY - r.top), this.canvasPosition.set(t, r.height - n);
          }, _h.prototype._setKeys = function (e) {
            this.altKey = e.altKey, this.ctrlKey = e.ctrlKey, this.metaKey = e.metaKey, this.shiftKey = e.shiftKey;
          }, _h.prototype.dispose = function () {
            document.removeEventListener("mousewheel", this._onMousewheel), document.removeEventListener("wheel", this._onMousewheel), document.removeEventListener("MozMousePixelScroll", this._onMousewheel), document.removeEventListener("mousemove", this._onMousemove), document.removeEventListener("mousedown", this._onMousedown), document.removeEventListener("mouseup", this._onMouseup), document.removeEventListener("contextmenu", this._onContextmenu), document.removeEventListener("touchstart", this._onTouchstart), document.removeEventListener("touchend", this._onTouchend), document.removeEventListener("touchmove", this._onTouchmove);
          }, Object.defineProperties(_h.prototype, xh);
          var wh = new ie(),
            Sh = new ie(),
            Ah = new ie(),
            Eh = new ie(),
            Th = new ae(),
            Mh = new oe(),
            Ch = new ie(),
            kh = new ae(),
            Ph = new ae(),
            Oh = function Oh(e, t) {
              void 0 === t && (t = {}), this.stage = e, this.rotateSpeed = wu(t.rotateSpeed, 2), this.zoomSpeed = wu(t.zoomSpeed, 1.2), this.panSpeed = wu(t.panSpeed, 1), this.viewer = e.viewer, this.mouse = e.mouseObserver, this.controls = e.viewerControls;
            },
            Rh = {
              component: {
                configurable: !0
              },
              atom: {
                configurable: !0
              }
            };
          Rh.component.get = function () {
            return this.stage.transformComponent;
          }, Rh.atom.get = function () {
            return this.stage.transformAtom;
          }, Oh.prototype._setPanVector = function (e, t, n) {
            void 0 === n && (n = 0);
            var r = this.controls.getCanvasScaleFactor(n);
            kh.set(e, t, 0), kh.multiplyScalar(this.panSpeed * r);
          }, Oh.prototype._getRotateXY = function (e, t) {
            return [this.rotateSpeed * -e * .01, this.rotateSpeed * t * .01];
          }, Oh.prototype._transformPanVector = function () {
            this.component && (Ch.extractRotation(this.component.transform), Ch.premultiply(this.viewer.rotationGroup.matrix), Ch.getInverse(Ch), kh.applyMatrix4(Ch));
          }, Oh.prototype.zoom = function (e) {
            this.controls.zoom(this.zoomSpeed * e * .02);
          }, Oh.prototype.pan = function (e, t) {
            this._setPanVector(e, t), Ch.getInverse(this.viewer.rotationGroup.matrix), kh.applyMatrix4(Ch), this.controls.translate(kh);
          }, Oh.prototype.panComponent = function (e, t) {
            this.component && (this._setPanVector(e, t), this._transformPanVector(), this.component.position.add(kh), this.component.updateMatrix());
          }, Oh.prototype.panAtom = function (e, t) {
            this.atom && this.component && (this.atom.positionToVector3(Ph), Ph.add(this.viewer.translationGroup.position), Ph.applyMatrix4(this.viewer.rotationGroup.matrix), this._setPanVector(e, t, Ph.z), this._transformPanVector(), this.atom.positionAdd(kh), this.component.updateRepresentations({
              position: !0
            }));
          }, Oh.prototype.rotate = function (e, t) {
            var n = this._getRotateXY(e, t),
              r = n[0],
              i = n[1];
            wh.makeRotationX(i), Sh.makeRotationY(r), wh.multiply(Sh), this.controls.applyMatrix(wh);
          }, Oh.prototype.zRotate = function (e, t) {
            var n = this.rotateSpeed * ((-e + t) / -2) * .01;
            Ah.makeRotationZ(n), this.controls.applyMatrix(Ah);
          }, Oh.prototype.rotateComponent = function (e, t) {
            if (this.component) {
              var n = this._getRotateXY(e, t),
                r = n[0],
                i = n[1];
              Eh.extractRotation(this.component.transform), Eh.premultiply(this.viewer.rotationGroup.matrix), Eh.getInverse(Eh), Th.set(1, 0, 0), Th.applyMatrix4(Eh), wh.makeRotationAxis(Th, i), Th.set(0, 1, 0), Th.applyMatrix4(Eh), Sh.makeRotationAxis(Th, r), wh.multiply(Sh), Mh.setFromRotationMatrix(wh), this.component.quaternion.premultiply(Mh), this.component.updateMatrix();
            }
          }, Object.defineProperties(Oh.prototype, Rh);
          var Ih = new ae(),
            jh = function jh(e, t) {
              this.stage = t, this.pid = e.pid, this.picker = e.picker, this.instance = e.instance, this.stage = t, this.controls = t.viewerControls, this.mouse = t.mouseObserver;
            },
            Nh = {
              type: {
                configurable: !0
              },
              altKey: {
                configurable: !0
              },
              ctrlKey: {
                configurable: !0
              },
              metaKey: {
                configurable: !0
              },
              shiftKey: {
                configurable: !0
              },
              canvasPosition: {
                configurable: !0
              },
              component: {
                configurable: !0
              },
              object: {
                configurable: !0
              },
              position: {
                configurable: !0
              },
              closestBondAtom: {
                configurable: !0
              },
              closeAtom: {
                configurable: !0
              },
              arrow: {
                configurable: !0
              },
              atom: {
                configurable: !0
              },
              axes: {
                configurable: !0
              },
              bond: {
                configurable: !0
              },
              box: {
                configurable: !0
              },
              cone: {
                configurable: !0
              },
              clash: {
                configurable: !0
              },
              contact: {
                configurable: !0
              },
              cylinder: {
                configurable: !0
              },
              distance: {
                configurable: !0
              },
              ellipsoid: {
                configurable: !0
              },
              octahedron: {
                configurable: !0
              },
              point: {
                configurable: !0
              },
              mesh: {
                configurable: !0
              },
              slice: {
                configurable: !0
              },
              sphere: {
                configurable: !0
              },
              tetrahedron: {
                configurable: !0
              },
              torus: {
                configurable: !0
              },
              surface: {
                configurable: !0
              },
              unitcell: {
                configurable: !0
              },
              unknown: {
                configurable: !0
              },
              volume: {
                configurable: !0
              },
              wideline: {
                configurable: !0
              }
            };
          Nh.type.get = function () {
            return this.picker.type;
          }, Nh.altKey.get = function () {
            return this.mouse.altKey;
          }, Nh.ctrlKey.get = function () {
            return this.mouse.ctrlKey;
          }, Nh.metaKey.get = function () {
            return this.mouse.metaKey;
          }, Nh.shiftKey.get = function () {
            return this.mouse.shiftKey;
          }, Nh.canvasPosition.get = function () {
            return this.mouse.canvasPosition;
          }, Nh.component.get = function () {
            return this.stage.getComponentsByObject(this.picker.data).list[0];
          }, Nh.object.get = function () {
            return this.picker.getObject(this.pid);
          }, Nh.position.get = function () {
            return this.picker.getPosition(this.pid, this.instance, this.component);
          }, Nh.closestBondAtom.get = function () {
            if ("bond" === this.type && this.bond) {
              var e,
                t,
                n,
                r = this.bond,
                i = this.controls,
                o = this.canvasPosition;
              return t = i.getPositionOnCanvas(r.atom1), n = i.getPositionOnCanvas(r.atom2), (e = o).distanceTo(t) < e.distanceTo(n) ? r.atom1 : r.atom2;
            }
          }, Nh.closeAtom.get = function () {
            var e = this.canvasPosition,
              t = this.closestBondAtom;
            if (t) {
              var n = this.controls.getPositionOnCanvas(t);
              t.positionToVector3(Ih), this.instance && Ih.applyMatrix4(this.instance.matrix), Ih.applyMatrix4(this.component.matrix);
              var r = this.controls.viewer;
              Ih.add(r.translationGroup.position), Ih.applyMatrix4(r.rotationGroup.matrix);
              var i = this.controls.getCanvasScaleFactor(Ih.z),
                o = this.component.getMaxRepresentationRadius(t.index);
              return e.distanceTo(n) <= o / i ? t : void 0;
            }
          }, Nh.arrow.get = function () {
            return this._objectIfType("arrow");
          }, Nh.atom.get = function () {
            return this._objectIfType("atom");
          }, Nh.axes.get = function () {
            return this._objectIfType("axes");
          }, Nh.bond.get = function () {
            return this._objectIfType("bond");
          }, Nh.box.get = function () {
            return this._objectIfType("box");
          }, Nh.cone.get = function () {
            return this._objectIfType("cone");
          }, Nh.clash.get = function () {
            return this._objectIfType("clash");
          }, Nh.contact.get = function () {
            return this._objectIfType("contact");
          }, Nh.cylinder.get = function () {
            return this._objectIfType("cylinder");
          }, Nh.distance.get = function () {
            return this._objectIfType("distance");
          }, Nh.ellipsoid.get = function () {
            return this._objectIfType("ellipsoid");
          }, Nh.octahedron.get = function () {
            return this._objectIfType("octahedron");
          }, Nh.point.get = function () {
            return this._objectIfType("point");
          }, Nh.mesh.get = function () {
            return this._objectIfType("mesh");
          }, Nh.slice.get = function () {
            return this._objectIfType("slice");
          }, Nh.sphere.get = function () {
            return this._objectIfType("sphere");
          }, Nh.tetrahedron.get = function () {
            return this._objectIfType("tetrahedron");
          }, Nh.torus.get = function () {
            return this._objectIfType("torus");
          }, Nh.surface.get = function () {
            return this._objectIfType("surface");
          }, Nh.unitcell.get = function () {
            return this._objectIfType("unitcell");
          }, Nh.unknown.get = function () {
            return this._objectIfType("unknown");
          }, Nh.volume.get = function () {
            return this._objectIfType("volume");
          }, Nh.wideline.get = function () {
            return this._objectIfType("wideline");
          }, jh.prototype._objectIfType = function (e) {
            return this.type === e ? this.object : void 0;
          }, jh.prototype.getLabel = function () {
            var e = this.atom || this.closeAtom,
              t = "nothing";
            return this.arrow ? t = this.arrow.name : e ? t = "atom: " + e.qualifiedName() + " (" + e.structure.name + ")" : this.axes ? t = "axes" : this.bond ? t = "bond: " + this.bond.atom1.qualifiedName() + " - " + this.bond.atom2.qualifiedName() + " (" + this.bond.structure.name + ")" : this.box ? t = this.box.name : this.cone ? t = this.cone.name : this.clash ? t = "clash: " + this.clash.clash.sele1 + " - " + this.clash.clash.sele2 : this.contact ? t = this.contact.type + ": " + this.contact.atom1.qualifiedName() + " - " + this.contact.atom2.qualifiedName() + " (" + this.contact.atom1.structure.name + ")" : this.cylinder ? t = this.cylinder.name : this.distance ? t = "distance: " + this.distance.atom1.qualifiedName() + " - " + this.distance.atom2.qualifiedName() + " (" + this.distance.structure.name + ")" : this.ellipsoid ? t = this.ellipsoid.name : this.octahedron ? t = this.octahedron.name : this.point ? t = this.point.name : this.mesh ? t = "mesh: " + (this.mesh.name || this.mesh.serial) + " (" + this.mesh.shape.name + ")" : this.slice ? t = "slice: " + this.slice.value.toPrecision(3) + " (" + this.slice.volume.name + ")" : this.sphere ? t = this.sphere.name : this.surface ? t = "surface: " + this.surface.surface.name : this.tetrahedron ? t = this.tetrahedron.name : this.torus ? t = this.torus.name : this.unitcell ? t = "unitcell: " + this.unitcell.unitcell.spacegroup + " (" + this.unitcell.structure.name + ")" : this.unknown ? t = "unknown" : this.volume ? t = "volume: " + this.volume.value.toPrecision(3) + " (" + this.volume.volume.name + ")" : this.wideline && (t = this.wideline.name), t;
          }, Object.defineProperties(jh.prototype, Nh);
          var Lh = function Lh(e) {
            this.stage = e, this.viewer = e.viewer;
          };
          Lh.prototype.pick = function (e, t) {
            var n = this.viewer.pick(e, t);
            if (n.picker && "ignore" !== n.picker.type && void 0 !== n.pid) {
              var r = n.picker.array;
              if (!(r && n.pid >= r.length)) return new jh(n, this.stage);
              console.error("pid >= picker.array.length");
            }
          };
          var Dh = new oe(),
            Bh = new ae(),
            Fh = new ae(),
            zh = new ae(),
            Uh = new ae(),
            Gh = new ie(),
            Vh = new ae(),
            Hh = new ie(),
            qh = function qh(e) {
              this.stage = e, this.signals = {
                changed: new lc()
              }, this.viewer = e.viewer;
            },
            Wh = {
              position: {
                configurable: !0
              },
              rotation: {
                configurable: !0
              }
            };
          Wh.position.get = function () {
            return this.viewer.translationGroup.position;
          }, Wh.rotation.get = function () {
            return this.viewer.rotationGroup.quaternion;
          }, qh.prototype.changed = function () {
            this.viewer.requestRender(), this.signals.changed.dispatch();
          }, qh.prototype.getPositionOnCanvas = function (e, t) {
            var n = Du(t, re),
              r = this.viewer;
            return zh.copy(e).add(r.translationGroup.position).applyMatrix4(r.rotationGroup.matrix).project(r.camera), n.set((zh.x + 1) * r.width / 2, (zh.y + 1) * r.height / 2);
          }, qh.prototype.getCanvasScaleFactor = function (e) {
            void 0 === e && (e = 0);
            var t = this.viewer.camera;
            if (t instanceof mt) return 1 / t.zoom;
            e = -e, e += t.position.z;
            var n = qu(t.fov);
            return -2 * e * Math.tan(n / 2) / this.viewer.height;
          }, qh.prototype.getOrientation = function (e) {
            var t = Fu(e);
            t.copy(this.viewer.rotationGroup.matrix);
            var n = -this.viewer.camera.position.z;
            return t.scale(Uh.set(n, n, n)), t.setPosition(this.viewer.translationGroup.position), t;
          }, qh.prototype.orient = function (e) {
            Fu(e).decompose(Bh, Dh, Fh);
            var t = this.viewer;
            t.rotationGroup.setRotationFromQuaternion(Dh), t.translationGroup.position.copy(Bh), t.camera.position.z = -Fh.z, t.updateZoom(), this.changed();
          }, qh.prototype.translate = function (e) {
            this.viewer.translationGroup.position.add(Bu(e)), this.changed();
          }, qh.prototype.center = function (e) {
            this.viewer.translationGroup.position.copy(Bu(e)).negate(), this.changed();
          }, qh.prototype.zoom = function (e) {
            this.distance(this.viewer.camera.position.z * (1 - e));
          }, qh.prototype.distance = function (e) {
            this.viewer.camera.position.z = Math.min(-1, e), this.viewer.updateZoom(), this.changed();
          }, qh.prototype.spin = function (e, t) {
            Gh.getInverse(this.viewer.rotationGroup.matrix), Vh.copy(Bu(e)).applyMatrix4(Gh), this.viewer.rotationGroup.rotateOnAxis(Vh, t), this.changed();
          }, qh.prototype.rotate = function (e) {
            this.viewer.rotationGroup.setRotationFromQuaternion(zu(e)), this.changed();
          }, qh.prototype.align = function (e) {
            Hh.getInverse(Fu(e)), this.viewer.rotationGroup.setRotationFromMatrix(Hh), this.changed();
          }, qh.prototype.applyMatrix = function (e) {
            this.viewer.rotationGroup.applyMatrix(Fu(e)), this.changed();
          }, Object.defineProperties(qh.prototype, Wh);
          var $h = function $h(e, t) {
              for (var n, r = [], i = arguments.length - 2; 0 < i--;) r[i] = arguments[i + 2];
              this.pausedTime = -1, this.elapsedDuration = 0, this.pausedDuration = 0, this.ignoreGlobalToggle = !1, this._paused = !1, this._resolveList = [], this.duration = wu(e, 1e3), this.controls = t, this.startTime = window.performance.now(), (n = this)._init.apply(n, r);
            },
            Xh = {
              done: {
                configurable: !0
              },
              paused: {
                configurable: !0
              }
            };
          Xh.done.get = function () {
            return 1 === this.alpha;
          }, Xh.paused.get = function () {
            return this._paused;
          }, $h.prototype.tick = function (e) {
            if (!this._paused) return this.elapsedDuration = e.currentTime - this.startTime - this.pausedDuration, 0 === this.duration ? this.alpha = 1 : this.alpha = Ju(0, 1, this.elapsedDuration / this.duration), this._tick(e), this.done && this._resolveList.forEach(function (e) {
              return e();
            }), this.done;
          }, $h.prototype.pause = function (e) {
            e && (this._hold = !0), -1 === this.pausedTime && (this.pausedTime = window.performance.now()), this._paused = !0;
          }, $h.prototype.resume = function (e) {
            !e && this._hold || (this.pausedDuration += window.performance.now() - this.pausedTime, this._paused = !1, this._hold = !1, this.pausedTime = -1);
          }, $h.prototype.toggle = function () {
            this._paused ? this.resume() : this.pause();
          }, $h.prototype.then = function (e) {
            var t = this;
            return (this.done ? Promise.resolve() : new Promise(function (e) {
              return t._resolveList.push(e);
            })).then(e);
          }, Object.defineProperties($h.prototype, Xh);
          var Yh = function (e) {
              function t(t, n) {
                for (var r = [], i = arguments.length - 2; 0 < i--;) r[i] = arguments[i + 2];
                e.apply(this, [wu(t, 1 / 0), n].concat(r));
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e, t) {
                Array.isArray(e) ? this.axis = new ae().fromArray(e) : this.axis = wu(e, new ae(0, 1, 0)), this.angle = wu(t, .01);
              }, t.prototype._tick = function (e) {
                this.axis && this.angle && this.controls.spin(this.axis, this.angle * e.lastDuration / 16);
              }, t;
            }($h),
            Kh = function (e) {
              function t(t, n) {
                for (var r = [], i = arguments.length - 2; 0 < i--;) r[i] = arguments[i + 2];
                e.apply(this, [wu(t, 1 / 0), n].concat(r)), this.angleSum = 0, this.direction = 1;
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e, t, n) {
                Array.isArray(e) ? this.axis = new ae().fromArray(e) : this.axis = wu(e, new ae(0, 1, 0)), this.angleStep = wu(t, .01), this.angleEnd = wu(n, .2);
              }, t.prototype._tick = function (e) {
                if (this.axis && this.angleStep && this.angleEnd) {
                  var t = Ju(0, 1, Math.abs(this.angleSum) / this.angleEnd),
                    n = this.angleStep * this.direction * (1.1 - t);
                  this.controls.spin(this.axis, n * e.lastDuration / 16), this.angleSum += this.angleStep, this.angleSum >= this.angleEnd && (this.direction *= -1, this.angleSum = -this.angleEnd);
                }
              }, t;
            }($h),
            Zh = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e, t) {
                this.moveFrom = Bu(wu(e, new ae())), this.moveTo = Bu(wu(t, new ae()));
              }, t.prototype._tick = function () {
                this.controls.position.lerpVectors(this.moveFrom, this.moveTo, this.alpha).negate(), this.controls.changed();
              }, t;
            }($h),
            Qh = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e, t) {
                this.zoomFrom = e, this.zoomTo = t;
              }, t.prototype._tick = function () {
                this.controls.distance(Zu(this.zoomFrom, this.zoomTo, this.alpha));
              }, t;
            }($h),
            Jh = function (e) {
              function t() {
                e.apply(this, arguments), this._currentRotation = new oe();
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e, t) {
                this.rotateFrom = zu(e), this.rotateTo = zu(t), this._currentRotation = new oe();
              }, t.prototype._tick = function () {
                this._currentRotation.copy(this.rotateFrom).slerp(this.rotateTo, this.alpha), this.controls.rotate(this._currentRotation);
              }, t;
            }($h),
            ef = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e, t, n) {
                this.valueFrom = e, this.valueTo = t, this.callback = n;
              }, t.prototype._tick = function () {
                this.callback(Zu(this.valueFrom, this.valueTo, this.alpha));
              }, t;
            }($h),
            tf = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype._init = function (e) {
                this.callback = e;
              }, t.prototype._tick = function () {
                1 === this.alpha && this.callback();
              }, t;
            }($h),
            nf = function nf(e) {
              void 0 === e && (e = []), this._resolveList = [], this._list = e;
            },
            rf = {
              done: {
                configurable: !0
              }
            };
          rf.done.get = function () {
            return this._list.every(function (e) {
              return e.done;
            });
          }, nf.prototype.then = function (e) {
            var t = this;
            return (this.done ? Promise.resolve() : new Promise(function (e) {
              t._resolveList.push(e), t._list.forEach(function (e) {
                e.then(function () {
                  t._resolveList.forEach(function (e) {
                    e();
                  }), t._resolveList.length = 0;
                });
              });
            })).then(e);
          }, Object.defineProperties(nf.prototype, rf);
          var of = function of(e) {
              this.stage = e, this.animationList = [], this.finishedList = [], this.viewer = e.viewer, this.controls = e.viewerControls;
            },
            af = {
              paused: {
                configurable: !0
              }
            };
          af.paused.get = function () {
            return this.animationList.every(function (e) {
              return e.paused;
            });
          }, of.prototype.add = function (e) {
            return 0 === e.duration ? e.tick(this.viewer.stats) : this.animationList.push(e), e;
          }, of.prototype.remove = function (e) {
            var t = this.animationList,
              n = t.indexOf(e);
            -1 < n && t.splice(n, 1);
          }, of.prototype.run = function (e) {
            for (var t = this.finishedList, n = this.animationList, r = n.length, i = 0; i < r; ++i) {
              var o = n[i];
              o.tick(e) && t.push(o);
            }
            var a = t.length;
            if (a) {
              for (var s = 0; s < a; ++s) this.remove(t[s]);
              t.length = 0;
            }
          }, of.prototype.spin = function (e, t, n) {
            return this.add(new Yh(n, this.controls, e, t));
          }, of.prototype.rock = function (e, t, n, r) {
            return this.add(new Kh(r, this.controls, e, t, n));
          }, of.prototype.rotate = function (e, t) {
            var n = this.viewer.rotationGroup.quaternion.clone();
            return this.add(new Jh(t, this.controls, n, e));
          }, of.prototype.move = function (e, t) {
            var n = this.controls.position.clone().negate();
            return this.add(new Zh(t, this.controls, n, e));
          }, of.prototype.zoom = function (e, t) {
            var n = this.viewer.camera.position.z;
            return this.add(new Qh(t, this.controls, n, e));
          }, of.prototype.zoomMove = function (e, t, n) {
            return new nf([this.move(e, n), this.zoom(t, n)]);
          }, of.prototype.orient = function (e, t) {
            var n = new ae(),
              r = new oe(),
              i = new ae();
            return Fu(e).decompose(n, r, i), new nf([this.move(n.negate(), t), this.rotate(r, t), this.zoom(-i.x, t)]);
          }, of.prototype.value = function (e, t, n, r) {
            return this.add(new ef(r, this.controls, e, t, n));
          }, of.prototype.timeout = function (e, t) {
            return this.add(new tf(t, this.controls, e));
          }, of.prototype.spinComponent = function (e, t, n, r) {
            return this.add(new Yh(r, e.controls, t, n));
          }, of.prototype.rockComponent = function (e, t, n, r, i) {
            return this.add(new Kh(i, e.controls, t, n, r));
          }, of.prototype.moveComponent = function (e, t, n) {
            var r = e.controls.position.clone().negate();
            return this.add(new Zh(n, e.controls, r, t));
          }, of.prototype.pause = function () {
            this.animationList.forEach(function (e) {
              return e.pause();
            });
          }, of.prototype.resume = function () {
            this.animationList.forEach(function (e) {
              return e.resume();
            });
          }, of.prototype.toggle = function () {
            this.paused ? this.resume() : this.pause();
          }, of.prototype.clear = function () {
            this.animationList.length = 0;
          }, of.prototype.dispose = function () {
            this.clear();
          }, Object.defineProperties(of.prototype, af);
          var sf = function sf(e, t) {
            if (this.fn = e, this.queue = [], this.pending = !1, this.next = this.next.bind(this), t) {
              for (var n = 0, r = t.length; n < r; ++n) this.queue.push(t[n]);
              this.next();
            }
          };
          sf.prototype.run = function (e) {
            this.fn(e, this.next);
          }, sf.prototype.next = function () {
            var e = this,
              t = this.queue.shift();
            void 0 !== t ? (this.pending = !0, setTimeout(function () {
              return e.run(t);
            })) : this.pending = !1;
          }, sf.prototype.push = function (e) {
            this.queue.push(e), this.pending || this.next();
          }, sf.prototype.kill = function () {
            this.queue.length = 0;
          }, sf.prototype.length = function () {
            return this.queue.length;
          };
          var lf = function lf(e, t, n) {
            this.type = "", this.parameters = {
              lazy: {
                type: "boolean"
              },
              clipNear: {
                type: "range",
                step: 1,
                max: 100,
                min: 0,
                buffer: !0
              },
              clipRadius: {
                type: "number",
                precision: 1,
                max: 1e3,
                min: 0,
                buffer: !0
              },
              clipCenter: {
                type: "vector3",
                precision: 1,
                buffer: !0
              },
              flatShaded: {
                type: "boolean",
                buffer: !0
              },
              opacity: {
                type: "range",
                step: .01,
                max: 1,
                min: 0,
                buffer: !0
              },
              depthWrite: {
                type: "boolean",
                buffer: !0
              },
              side: {
                type: "select",
                buffer: !0,
                options: {
                  front: "front",
                  back: "back",
                  double: "double"
                }
              },
              wireframe: {
                type: "boolean",
                buffer: !0
              },
              colorScheme: {
                type: "select",
                update: "color",
                options: {}
              },
              colorScale: {
                type: "select",
                update: "color",
                options: td.getScales()
              },
              colorReverse: {
                type: "boolean",
                update: "color"
              },
              colorValue: {
                type: "color",
                update: "color"
              },
              colorDomain: {
                type: "hidden",
                update: "color"
              },
              colorMode: {
                type: "select",
                update: "color",
                options: td.getModes()
              },
              roughness: {
                type: "range",
                step: .01,
                max: 1,
                min: 0,
                buffer: !0
              },
              metalness: {
                type: "range",
                step: .01,
                max: 1,
                min: 0,
                buffer: !0
              },
              diffuse: {
                type: "color",
                buffer: !0
              },
              diffuseInterior: {
                type: "boolean",
                buffer: !0
              },
              useInteriorColor: {
                type: "boolean",
                buffer: !0
              },
              interiorColor: {
                type: "color",
                buffer: !0
              },
              interiorDarkening: {
                type: "range",
                step: .01,
                max: 1,
                min: 0,
                buffer: !0
              },
              matrix: {
                type: "hidden",
                buffer: !0
              },
              disablePicking: {
                type: "boolean",
                rebuild: !0
              }
            }, this.viewer = t, this.tasks = new Md(), this.queue = new sf(this.make.bind(this)), this.bufferList = [], this.parameters.colorScheme && (this.parameters.colorScheme.options = td.getSchemes()), this.toBePrepared = !1;
          };
          lf.prototype.init = function (e) {
            var t = e || {};
            this.clipNear = wu(t.clipNear, 0), this.clipRadius = wu(t.clipRadius, 0), this.clipCenter = wu(t.clipCenter, new ae()), this.flatShaded = wu(t.flatShaded, !1), this.side = wu(t.side, "double"), this.opacity = wu(t.opacity, 1), this.depthWrite = wu(t.depthWrite, !0), this.wireframe = wu(t.wireframe, !1), this.setColor(t.color, t), this.colorScheme = wu(t.colorScheme, "uniform"), this.colorScale = wu(t.colorScale, ""), this.colorReverse = wu(t.colorReverse, !1), this.colorValue = wu(t.colorValue, 9474192), this.colorDomain = wu(t.colorDomain, void 0), this.colorMode = wu(t.colorMode, "hcl"), this.visible = wu(t.visible, !0), this.quality = wu(t.quality, void 0), this.roughness = wu(t.roughness, .4), this.metalness = wu(t.metalness, 0), this.diffuse = wu(t.diffuse, 16777215), this.diffuseInterior = wu(t.diffuseInterior, !1), this.useInteriorColor = wu(t.useInteriorColor, !1), this.interiorColor = wu(t.interiorColor, 2236962), this.interiorDarkening = wu(t.interiorDarkening, 0), this.lazy = wu(t.lazy, !1), this.lazyProps = {
              build: !1,
              bufferParams: {},
              what: {}
            }, this.matrix = wu(t.matrix, new ie()), this.disablePicking = wu(t.disablePicking, !1);
            var n = this.parameters;
            !0 === n.sphereDetail && (n.sphereDetail = {
              type: "integer",
              max: 3,
              min: 0,
              rebuild: "impostor"
            }), !0 === n.radialSegments && (n.radialSegments = {
              type: "integer",
              max: 25,
              min: 5,
              rebuild: "impostor"
            }), !0 === n.openEnded && (n.openEnded = {
              type: "boolean",
              rebuild: "impostor",
              buffer: !0
            }), !0 === n.disableImpostor && (n.disableImpostor = {
              type: "boolean",
              rebuild: !0
            }), "low" === t.quality ? (n.sphereDetail && (this.sphereDetail = 0), n.radialSegments && (this.radialSegments = 5)) : "medium" === t.quality ? (n.sphereDetail && (this.sphereDetail = 1), n.radialSegments && (this.radialSegments = 10)) : "high" === t.quality ? (n.sphereDetail && (this.sphereDetail = 2), n.radialSegments && (this.radialSegments = 20)) : (n.sphereDetail && (this.sphereDetail = wu(t.sphereDetail, 1)), n.radialSegments && (this.radialSegments = wu(t.radialSegments, 10))), n.openEnded && (this.openEnded = wu(t.openEnded, !0)), n.disableImpostor && (this.disableImpostor = wu(t.disableImpostor, !1));
          }, lf.prototype.getColorParams = function (e) {
            return Object.assign({
              scheme: this.colorScheme,
              scale: this.colorScale,
              reverse: this.colorReverse,
              value: this.colorValue,
              domain: this.colorDomain,
              mode: this.colorMode
            }, e);
          }, lf.prototype.getBufferParams = function (e) {
            return void 0 === e && (e = {}), Object.assign({
              clipNear: this.clipNear,
              clipRadius: this.clipRadius,
              clipCenter: this.clipCenter,
              flatShaded: this.flatShaded,
              opacity: this.opacity,
              depthWrite: this.depthWrite,
              side: this.side,
              wireframe: this.wireframe,
              roughness: this.roughness,
              metalness: this.metalness,
              diffuse: this.diffuse,
              diffuseInterior: this.diffuseInterior,
              useInteriorColor: this.useInteriorColor,
              interiorColor: this.interiorColor,
              interiorDarkening: this.interiorDarkening,
              matrix: this.matrix,
              disablePicking: this.disablePicking
            }, e);
          }, lf.prototype.setColor = function (e, t) {
            var n = Object.keys(td.getSchemes());
            if ("string" == typeof e && n.includes(e.toLowerCase())) t ? t.colorScheme = e : this.setParameters({
              colorScheme: e
            });else if (void 0 !== e) {
              var r = new Fe(e).getHex();
              t ? (t.colorScheme = "uniform", t.colorValue = r) : this.setParameters({
                colorScheme: "uniform",
                colorValue: r
              });
            }
            return this;
          }, lf.prototype.prepare = function (e) {}, lf.prototype.create = function () {}, lf.prototype.update = function (e) {
            this.build();
          }, lf.prototype.build = function (e) {
            if (!this.lazy || this.visible && this.opacity) {
              if (!this.toBePrepared) return this.tasks.increment(), void this.make();
              0 < this.queue.length() ? (this.tasks.change(1 - this.queue.length()), this.queue.kill()) : this.tasks.increment(), this.queue.push(e || !1);
            } else this.lazyProps.build = !0;
          }, lf.prototype.make = function (e, n) {
            var r = this;
            t.Debug && Zc.time("Representation.make " + this.type);
            var i = function i() {
              e ? (r.update(e), r.viewer.requestRender(), r.tasks.decrement(), n && n()) : (r.clear(), r.create(), r.manualAttach || r.disposed || (t.Debug && Zc.time("Representation.attach " + r.type), r.attach(function () {
                t.Debug && Zc.timeEnd("Representation.attach " + r.type), r.tasks.decrement(), n && n();
              }))), t.Debug && Zc.timeEnd("Representation.make " + r.type);
            };
            this.toBePrepared ? this.prepare(i) : i();
          }, lf.prototype.attach = function (e) {
            this.setVisibility(this.visible), e();
          }, lf.prototype.setVisibility = function (e, t) {
            if (this.visible = e, this.visible && this.opacity) {
              var n = this.lazyProps,
                r = n.bufferParams,
                i = n.what;
              if (n.build) return n.build = !1, this.build(), this;
              (Object.keys(r).length || Object.keys(i).length) && (n.bufferParams = {}, n.what = {}, this.updateParameters(r, i));
            }
            return this.bufferList.forEach(function (t) {
              t.setVisibility(e);
            }), t || this.viewer.requestRender(), this;
          }, lf.prototype.setParameters = function (e, t, n) {
            var r = this;
            void 0 === t && (t = {}), void 0 === n && (n = !1);
            var i = e || {},
              o = this.parameters,
              a = {};
            for (var s in this.opacity || void 0 === i.opacity || (this.lazyProps.build ? n = !(this.lazyProps.build = !1) : (Object.assign(a, this.lazyProps.bufferParams), Object.assign(t, this.lazyProps.what), this.lazyProps.bufferParams = {}, this.lazyProps.what = {})), this.setColor(i.color, i), i) void 0 !== i[s] && void 0 !== o[s] && (o[s].int && (i[s] = parseInt(i[s])), o[s].float && (i[s] = parseFloat(i[s])), i[s] !== r[s] || i[s].equals && !i[s].equals(r[s])) && (r[s] && r[s].copy && i[s].copy ? r[s].copy(i[s]) : r[s] && r[s].set ? r[s].set(i[s]) : r[s] = i[s], o[s].buffer && (!0 === o[s].buffer ? a[s] = i[s] : a[o[s].buffer] = i[s]), o[s].update && (t[o[s].update] = !0), !o[s].rebuild || "impostor" === o[s].rebuild && Kc && !r.disableImpostor || (n = !0));
            return n ? this.build() : this.updateParameters(a, t), this;
          }, lf.prototype.updateParameters = function (e, t) {
            if (void 0 === e && (e = {}), this.lazy && (!this.visible || !this.opacity) && !1 === e.hasOwnProperty("opacity")) return Object.assign(this.lazyProps.bufferParams, e), void Object.assign(this.lazyProps.what, t);
            this.bufferList.forEach(function (t) {
              t.setParameters(e);
            }), Object.keys(t).length && this.update(t), this.viewer.requestRender();
          }, lf.prototype.getParameters = function () {
            var e = this,
              t = {
                lazy: this.lazy,
                visible: this.visible,
                quality: this.quality
              };
            return Object.keys(this.parameters).forEach(function (n) {
              null !== e.parameters[n] && (t[n] = e[n]);
            }), t;
          }, lf.prototype.clear = function () {
            var e = this;
            this.bufferList.forEach(function (t) {
              e.viewer.remove(t), t.dispose();
            }), this.bufferList.length = 0, this.viewer.requestRender();
          }, lf.prototype.dispose = function () {
            this.disposed = !0, this.queue.kill(), this.tasks.dispose(), this.clear();
          };
          var uf = function uf(e) {
            var n = this;
            this.pending = 0, this.postCount = 0, this.onmessageDict = {}, this.onerrorDict = {}, this.name = e, this.blobUrl = window.URL.createObjectURL(ed.get(e)), this.worker = new Worker(this.blobUrl), ed.activeWorkerCount += 1, this.worker.onmessage = function (r) {
              n.pending -= 1;
              var i = r.data.__postId;
              t.Debug && Zc.timeEnd("Worker.postMessage " + e + " #" + i);
              var o = n.onmessageDict[i];
              o && o.call(n.worker, r), delete n.onmessageDict[i], delete n.onerrorDict[i];
            }, this.worker.onerror = function (t) {
              if (n.pending -= 1, t.data) {
                var r = t.data.__postId,
                  i = n.onerrorDict[r];
                i ? i.call(n.worker, t) : Zc.error("Worker.onerror", r, e, t), delete n.onmessageDict[r], delete n.onerrorDict[r];
              } else Zc.error("Worker.onerror", e, t);
            };
          };
          uf.prototype.post = function (e, n, r, i) {
            void 0 === e && (e = {}), this.onmessageDict[this.postCount] = r, this.onerrorDict[this.postCount] = i, e.__name = this.name, e.__postId = this.postCount, e.__debug = t.Debug, t.Debug && Zc.time("Worker.postMessage " + this.name + " #" + this.postCount);
            try {
              this.worker.postMessage(e, n);
            } catch (n) {
              Zc.error("worker.post:", n), this.worker.postMessage(e);
            }
            return this.pending += 1, this.postCount += 1, this;
          }, uf.prototype.terminate = function () {
            this.worker ? (this.worker.terminate(), window.URL.revokeObjectURL(this.blobUrl), ed.activeWorkerCount -= 1) : Zc.log("no worker to terminate");
          };
          var cf = function cf(e, t) {
            void 0 === t && (t = 2), this.pool = [], this.count = 0, this.maxCount = Math.min(8, t), this.name = e;
          };
          function df(e) {
            for (var t = e.length, n = t / 3, r = 0, i = 0, o = 0, a = 0; a < t; a += 3) r += e[a + 0], i += e[a + 1], o += e[a + 2];
            return new ae(r / n, i / n, o / n);
          }
          function hf(e, t, n) {
            return n ? e.sub(n).projectOnVector(t).add(n) : e.projectOnVector(t), e;
          }
          function ff(e) {
            for (var t = 1 / 0, n = 1 / 0, r = 1 / 0, i = -1 / 0, o = -1 / 0, a = -1 / 0, s = 0, l = e.length; s < l; s += 3) {
              var u = e[s],
                c = e[s + 1],
                d = e[s + 2];
              u < t && (t = u), c < n && (n = c), d < r && (r = d), i < u && (i = u), o < c && (o = c), a < d && (a = d);
            }
            return [vf([t, n, r]), vf([i, o, a])];
          }
          function pf(e, t) {
            for (var n = 0, r = t.length; n < r; n += 3) {
              var i = t[n],
                o = t[n + 1],
                a = t[n + 2];
              t[n] = e[0] * i + e[4] * o + e[8] * a + e[12], t[n + 1] = e[1] * i + e[5] * o + e[9] * a + e[13], t[n + 2] = e[2] * i + e[6] * o + e[10] * a + e[14];
            }
          }
          function mf(e, t) {
            for (var n = 0, r = t.length; n < r; n += 3) {
              var i = t[n],
                o = t[n + 1],
                a = t[n + 2];
              t[n] = e[0] * i + e[3] * o + e[6] * a, t[n + 1] = e[1] * i + e[4] * o + e[7] * a, t[n + 2] = e[2] * i + e[5] * o + e[8] * a;
            }
          }
          function gf(e) {
            for (var t = 0, n = e.length; t < n; t += 3) {
              var r = e[t],
                i = e[t + 1],
                o = e[t + 2],
                a = 1 / Math.sqrt(r * r + i * i + o * o);
              e[t] = r * a, e[t + 1] = i * a, e[t + 2] = o * a;
            }
          }
          function vf(e) {
            return new Float32Array(e || 3);
          }
          function yf(e, t, n) {
            var r = t[0],
              i = t[1],
              o = t[2],
              a = n[0],
              s = n[1],
              l = n[2];
            e[0] = i * l - o * s, e[1] = o * a - r * l, e[2] = r * s - i * a;
          }
          function bf(e, t) {
            return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
          }
          function _f(e, t, n) {
            e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2];
          }
          function xf(e, t, n) {
            e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2];
          }
          function wf(e, t, n) {
            void 0 === n && (n = 0), e[0] = t[n], e[1] = t[n + 1], e[2] = t[n + 2];
          }
          function Sf(e, t, n) {
            void 0 === n && (n = 0), t[n] = e[0], t[n + 1] = e[1], t[n + 2] = e[2];
          }
          function Af(e) {
            return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
          }
          function Ef(e, t, n) {
            Tf(e, t, 1 / n);
          }
          function Tf(e, t, n) {
            e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n;
          }
          function Mf(e, t) {
            Tf(e, t, 1 / Af(t));
          }
          function Cf(e, t, n) {
            e[0] = t[0] - n, e[1] = t[1] - n, e[2] = t[2] - n;
          }
          function kf(e, t, n) {
            e[0] = t[0] + n, e[1] = t[1] + n, e[2] = t[2] + n;
          }
          function Pf(e, t) {
            e[0] = Math.floor(t[0]), e[1] = Math.floor(t[1]), e[2] = Math.floor(t[2]);
          }
          function Of(e, t) {
            e[0] = Math.ceil(t[0]), e[1] = Math.ceil(t[1]), e[2] = Math.ceil(t[2]);
          }
          function Rf(e, t) {
            e[0] = -t[0], e[1] = -t[1], e[2] = -t[2];
          }
          function If(e, t) {
            void 0 === t && (t = 9);
            for (var n = Math.floor(t / 2), r = e.position1.length / 3, i = n * r * 3, o = 1 / t, a = Vd(e.position1, e.position2), s = new Float32Array(i), l = new Float32Array(i), u = new ae(), c = 0; c < r; ++c) {
              var d = 3 * c;
              u.set(a[d], a[d + 1], a[d + 2]);
              for (var h = e.position1[d], f = e.position1[d + 1], p = e.position1[d + 2], m = 0; m < n; ++m) {
                var g = n * d + 3 * m,
                  v = o * (2 * m + 1),
                  y = o * (2 * m + 2);
                s[g] = h + u.x * v, s[g + 1] = f + u.y * v, s[g + 2] = p + u.z * v, l[g] = h + u.x * y, l[g + 1] = f + u.y * y, l[g + 2] = p + u.z * y;
              }
            }
            var b = Gd(s, l),
              _ = function (e, t) {
                for (var n = e.length / 3, r = new Float32Array(n * t * 3), i = 0; i < n; ++i) for (var o = 3 * i, a = i * t * 3, s = e[o + 0], l = e[o + 1], u = e[o + 2], c = 0; c < t; ++c) {
                  var d = a + 3 * c;
                  r[d + 0] = s, r[d + 1] = l, r[d + 2] = u;
                }
                return r;
              }(e.color, n),
              x = {
                position: b,
                position1: s,
                position2: l,
                color: _,
                color2: _
              };
            return e.radius && (x.radius = Xd(e.radius, n)), e.picking && e.picking.array && (e.picking.array = Xd(e.picking.array, n), x.picking = e.picking), e.primitiveId && (x.primitiveId = Xd(e.primitiveId, n)), x;
          }
          function jf(e, t) {
            void 0 === t && (t = .1);
            for (var n = Vd(e.position1, e.position2), r = [], i = [], o = [], a = e.radius ? [] : void 0, s = e.picking ? [] : void 0, l = e.primitiveId ? [] : void 0, u = new ae(), c = e.position1.length / 3, d = 0, h = 0; h < c; ++h) {
              var f = 3 * h;
              u.set(n[f], n[f + 1], n[f + 2]);
              for (var p = u.length() / t, m = Math.floor(p / 2), g = 1 / p, v = e.position1[f], y = e.position1[f + 1], b = e.position1[f + 2], _ = 0; _ < m; ++_) {
                var x = 3 * d + 3 * _,
                  w = g * (2 * _ + 1),
                  S = g * (2 * _ + 2);
                r[x] = v + u.x * w, r[x + 1] = y + u.y * w, r[x + 2] = b + u.z * w, i[x] = v + u.x * S, i[x + 1] = y + u.y * S, i[x + 2] = b + u.z * S, e.color && (o[x] = e.color[f], o[x + 1] = e.color[f + 1], o[x + 2] = e.color[f + 2]), a && (a[d + _] = e.radius[h]), s && (e.picking.array ? s[d + _] = e.picking.array[h] : s[d + _] = h), l && (l[d + _] = e.primitiveId[h]);
              }
              d += m;
            }
            var A = new Float32Array(r),
              E = new Float32Array(i),
              T = Gd(A, E),
              M = new Float32Array(o),
              C = {
                position: T,
                position1: A,
                position2: E,
                color: M,
                color2: M
              };
            return a && (C.radius = new Float32Array(a)), s && e.picking && (e.picking.array = new Float32Array(s), C.picking = e.picking), l && (C.primitiveId = new Float32Array(l)), C;
          }
          function Nf(e, t) {
            void 0 === t && (t = .1);
            for (var n = Vd(e.position1, e.position2), r = [], i = [], o = [], a = e.radius ? [] : void 0, s = e.picking ? [] : void 0, l = e.primitiveId ? [] : void 0, u = new ae(), c = e.position1.length / 3, d = t, h = !0, f = 0, p = 0, m = 0, g = 0; g < c; ++g) {
              var v = 3 * g,
                y = e.position1[v],
                b = e.position1[v + 1],
                _ = e.position1[v + 2];
              u.set(n[v], n[v + 1], n[v + 2]);
              var x = u.length();
              h && (r[p] = y, r[p + 1] = b, r[p + 2] = _);
              for (var w = d, S = 1 / x; w < x;) {
                var A = h ? i : r;
                A[p] = y + u.x * w * S, A[p + 1] = b + u.y * w * S, A[p + 2] = _ + u.z * w * S, h && (p = 3 * ++f), h = !h, w += d = t;
              }
              h && (i[p] = e.position2[v], i[p + 1] = e.position2[v + 1], i[p + 2] = e.position2[v + 2], p = 3 * ++f), d = w - x;
              for (var E = m; E < f; E++) {
                if (e.color) {
                  var T = 3 * E;
                  o[T] = e.color[v], o[T + 1] = e.color[v + 1], o[T + 2] = e.color[v + 2];
                }
                a && (a[E] = e.radius[g]), s && (e.picking.array ? s[E] = e.picking.array[g] : s[E] = g), l && (l[E] = e.primitiveId[g]);
              }
              m = f;
            }
            if (!h && 0 < c) {
              var M = 3 * f;
              i[M] = e.position2[3 * c - 3], i[M + 1] = e.position2[3 * c - 2], i[M + 1] = e.position2[3 * c - 1];
            }
            var C = new Float32Array(r),
              k = new Float32Array(i),
              P = Gd(C, k),
              O = new Float32Array(o),
              R = {
                position: P,
                position1: C,
                position2: k,
                color: O,
                color2: O
              };
            return a && (R.radius = new Float32Array(a)), s && e.picking && (e.picking.array = new Float32Array(s), R.picking = e.picking), l && (R.primitiveId = new Float32Array(l)), R;
          }
          cf.prototype.post = function (e, t, n, r) {
            void 0 === e && (e = {});
            var i = this.getNextWorker();
            return i ? i.post(e, t, n, r) : console.error("unable to get worker from pool"), this;
          }, cf.prototype.terminate = function () {
            this.pool.forEach(function (e) {
              e.terminate();
            });
          }, cf.prototype.getNextWorker = function () {
            for (var e, t = 1 / 0, n = 0; n < this.maxCount; ++n) {
              if (n >= this.count) {
                e = new uf(this.name), this.pool.push(e), this.count += 1;
                break;
              }
              var r = this.pool[n];
              if (0 === r.pending) {
                e = r;
                break;
              }
              r.pending < t && (t = r.pending, e = r);
            }
            return e;
          }, cf.prototype.constructor = cf, ff.__deps = [vf], Ef.__deps = [Tf], Mf.__deps = [Tf, Af];
          var Lf = new ae(),
            Df = function Df() {},
            Bf = {
              Picker: {
                configurable: !0
              },
              Buffer: {
                configurable: !0
              }
            };
          Bf.Picker.get = function () {
            return ud.get(this.type);
          }, Bf.Buffer.get = function () {
            return ld.get(this.type);
          }, Df.getShapeKey = function (e) {
            return this.type + e[0].toUpperCase() + e.substr(1);
          }, Df.expandBoundingBox = function (e, t) {}, Df.valueToShape = function (e, t, n) {
            var r,
              i,
              o = e._primitiveData[this.getShapeKey(t)];
            switch (this.fields[t]) {
              case "v3":
              case "c":
                i = o, void 0 !== (r = n).toArray ? r = r.toArray() : void 0 !== r.x ? r = [r.x, r.y, r.z] : void 0 !== r.r && (r = [r.r, r.g, r.b]), i.push.apply(i, r);
                break;
              default:
                o.push(n);
            }
          }, Df.objectToShape = function (e, t) {
            var n = this;
            Object.keys(this.fields).forEach(function (r) {
              n.valueToShape(e, r, t[r]);
            }), this.valueToShape(e, "name", t.name), this.expandBoundingBox(e.boundingBox, t);
          }, Df.valueFromShape = function (e, t, n) {
            var r = e._primitiveData[this.getShapeKey(n)];
            switch (this.fields[n]) {
              case "v3":
                return new ae().fromArray(r, 3 * t);
              case "c":
                return new Fe().fromArray(r, 3 * t);
              default:
                return r[t];
            }
          }, Df.objectFromShape = function (e, t) {
            var n = this,
              r = this.valueFromShape(e, t, "name");
            void 0 === r && (r = this.type + ": " + t + " (" + e.name + ")");
            var i = {
              shape: e,
              name: r
            };
            return Object.keys(this.fields).forEach(function (r) {
              i[r] = n.valueFromShape(e, t, r);
            }), i;
          }, Df.arrayFromShape = function (e, t) {
            var n = e._primitiveData[this.getShapeKey(t)];
            switch (this.fields[t]) {
              case "s":
                return n;
              default:
                return new Float32Array(n);
            }
          }, Df.dataFromShape = function (e) {
            var t = this,
              n = {};
            return this.Picker && (n.picking = new this.Picker(e)), Object.keys(this.fields).forEach(function (r) {
              n[r] = t.arrayFromShape(e, r);
            }), n;
          }, Df.bufferFromShape = function (e, t) {
            return new this.Buffer(this.dataFromShape(e), t);
          }, Object.defineProperties(Df, Bf), Df.type = "", Df.fields = {};
          var Ff = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).positionFromShape = function (e, t) {
              return this.valueFromShape(e, t, "position");
            }, t.expandBoundingBox = function (e, t) {
              e.expandByPoint(Lf.fromArray(t.position));
            }, t;
          }(Df);
          Ff.type = "sphere", Ff.fields = {
            position: "v3",
            color: "c",
            radius: "f"
          };
          var zf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).positionFromShape = function (e, t) {
              return this.valueFromShape(e, t, "position");
            }, t.expandBoundingBox = function (e, t) {
              e.expandByPoint(Lf.fromArray(t.position));
            }, t;
          }(Df);
          zf.type = "box", zf.fields = {
            position: "v3",
            color: "c",
            size: "f",
            heightAxis: "v3",
            depthAxis: "v3"
          };
          var Uf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
          }(zf);
          Uf.type = "octahedron";
          var Gf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
          }(zf);
          Gf.type = "tetrahedron";
          var Vf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).positionFromShape = function (e, t) {
              var n = this.valueFromShape(e, t, "position1"),
                r = this.valueFromShape(e, t, "position2");
              return n.add(r).multiplyScalar(.5);
            }, t.expandBoundingBox = function (e, t) {
              e.expandByPoint(Lf.fromArray(t.position1)), e.expandByPoint(Lf.fromArray(t.position2));
            }, t.bufferFromShape = function (e, t) {
              void 0 === t && (t = {});
              var n = this.dataFromShape(e);
              return "cylinder" === this.type && t.dashedCylinder && (n = jf(n)), new this.Buffer(n, t);
            }, t;
          }(Df);
          Vf.type = "cylinder", Vf.fields = {
            position1: "v3",
            position2: "v3",
            color: "c",
            radius: "f"
          };
          var Hf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
          }(Vf);
          Hf.type = "arrow";
          var qf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
          }(Vf);
          qf.type = "cone";
          var Wf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
          }(Ff);
          Wf.type = "ellipsoid", Wf.fields = {
            position: "v3",
            color: "c",
            radius: "f",
            majorAxis: "v3",
            minorAxis: "v3"
          };
          var $f = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
          }(Wf);
          $f.type = "torus";
          var Xf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).positionFromShape = function (e, t) {
              return this.valueFromShape(e, t, "position");
            }, t.expandBoundingBox = function (e, t) {
              e.expandByPoint(Lf.fromArray(t.position));
            }, t;
          }(Df);
          Xf.type = "text", Xf.fields = {
            position: "v3",
            color: "c",
            size: "f",
            text: "s"
          };
          var Yf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).positionFromShape = function (e, t) {
              return this.valueFromShape(e, t, "position");
            }, t.expandBoundingBox = function (e, t) {
              e.expandByPoint(Lf.fromArray(t.position));
            }, t;
          }(Df);
          Yf.type = "point", Yf.fields = {
            position: "v3",
            color: "c"
          };
          var Kf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).positionFromShape = function (e, t) {
              var n = this.valueFromShape(e, t, "position1"),
                r = this.valueFromShape(e, t, "position2");
              return n.add(r).multiplyScalar(.5);
            }, t.expandBoundingBox = function (e, t) {
              e.expandByPoint(Lf.fromArray(t.position1)), e.expandByPoint(Lf.fromArray(t.position2));
            }, t;
          }(Df);
          Kf.type = "wideline", Kf.fields = {
            position1: "v3",
            position2: "v3",
            color: "c"
          };
          var Zf = function Zf(e, t) {
            this.exp = 3;
            var n = t || function (e) {
              for (var t = e.x, n = e.y, r = e.z, i = new Oe(), o = t.length, a = i.min, s = i.max, l = 0; l < o; l++) a.x = Math.min(t[l], a.x), a.y = Math.min(n[l], a.y), a.z = Math.min(r[l], a.z), s.x = Math.max(t[l], s.x), s.y = Math.max(n[l], s.y), s.z = Math.max(r[l], s.z);
              return i;
            }(e);
            this.minX = n.min.x, this.minY = n.min.y, this.minZ = n.min.z, this.boundX = 1 + (n.max.x - this.minX >> this.exp), this.boundY = 1 + (n.max.y - this.minY >> this.exp), this.boundZ = 1 + (n.max.z - this.minZ >> this.exp);
            for (var r = this.boundX * this.boundY * this.boundZ, i = void 0 !== e.count ? e.count : e.x.length, o = e.x, a = e.y, s = e.z, l = 0, u = new Uint32Array(r), c = new Int32Array(i), d = 0; d < i; ++d) {
              var h = o[d] - this.minX >> this.exp,
                f = a[d] - this.minY >> this.exp,
                p = s[d] - this.minZ >> this.exp,
                m = (h * this.boundY + f) * this.boundZ + p;
              1 === (u[m] += 1) && (l += 1), c[d] = m;
            }
            for (var g = new Uint16Array(l), v = 0, y = 0; v < r; ++v) {
              var b = u[v];
              0 < b && (u[v] = y + 1, g[y] = b, y += 1);
            }
            for (var _ = new Uint32Array(l), x = 1; x < l; ++x) _[x] += _[x - 1] + g[x - 1];
            for (var w = new Uint16Array(l), S = new Int32Array(i), A = 0; A < i; ++A) {
              var E = u[c[A]];
              if (0 < E) {
                var T = E - 1;
                S[_[T] + w[T]] = A, w[T] += 1;
              }
            }
            this.grid = u, this.bucketCount = g, this.bucketOffset = _, this.bucketArray = S, this.xArray = o, this.yArray = a, this.zArray = s;
          };
          Zf.prototype.within = function (e, t, n, r) {
            var i = [];
            return this.eachWithin(e, t, n, r, function (e) {
              return i.push(e);
            }), i;
          }, Zf.prototype.eachWithin = function (e, t, n, r, i) {
            for (var o = r * r, a = Math.max(0, e - r - this.minX >> this.exp), s = Math.max(0, t - r - this.minY >> this.exp), l = Math.max(0, n - r - this.minZ >> this.exp), u = Math.min(this.boundX, 1 + (e + r - this.minX >> this.exp)), c = Math.min(this.boundY, 1 + (t + r - this.minY >> this.exp)), d = Math.min(this.boundZ, 1 + (n + r - this.minZ >> this.exp)), h = a; h < u; ++h) for (var f = s; f < c; ++f) for (var p = l; p < d; ++p) {
              var m = (h * this.boundY + f) * this.boundZ + p,
                g = this.grid[m];
              if (0 < g) for (var v = g - 1, y = this.bucketOffset[v], b = y + this.bucketCount[v], _ = y; _ < b; ++_) {
                var x = this.bucketArray[_],
                  w = this.xArray[x] - e,
                  S = this.yArray[x] - t,
                  A = this.zArray[x] - n,
                  E = w * w + S * S + A * A;
                E <= o && i(x, E);
              }
            }
          };
          var Qf = function Qf(e) {
            void 0 === e && (e = 0), this._fields = this._defaultFields, this._init(0);
          };
          Qf.prototype._init = function (e) {
            this.length = e;
            for (var t = this.count = 0, n = this._fields.length; t < n; ++t) {
              var r = this._fields[t],
                i = r[0],
                o = r[1],
                a = r[2];
              this._initField(i, o, a);
            }
          }, Qf.prototype._initField = function (e, t, n) {
            this[e] = ju(n, this.length * t);
          }, Qf.prototype.addField = function (e, t, n) {
            this._fields.push([e, t, n]), this._initField(e, t, n);
          }, Qf.prototype.resize = function (e) {
            this.length = Math.round(e || 0), this.count = Math.min(this.count, this.length);
            for (var t = 0, n = this._fields.length; t < n; ++t) {
              var r = this._fields[t][0],
                i = this._fields[t][1],
                o = this.length * i,
                a = new this[r].constructor(o);
              this[r].length > o ? a.set(this[r].subarray(0, o)) : a.set(this[r]), this[r] = a;
            }
          }, Qf.prototype.growIfFull = function () {
            if (this.count >= this.length) {
              var e = Math.round(1.5 * this.length);
              this.resize(Math.max(256, e));
            }
          }, Qf.prototype.copyFrom = function (e, t, n, r) {
            for (var i = 0, o = this._fields.length; i < o; ++i) for (var a = this._fields[i][0], s = this._fields[i][1], l = this[a], u = e[a], c = 0; c < r; ++c) for (var d = s * (t + c), h = s * (n + c), f = 0; f < s; ++f) l[d + f] = u[h + f];
          }, Qf.prototype.copyWithin = function (e, t, n) {
            for (var r = 0, i = this._fields.length; r < i; ++r) for (var o = this._fields[r][0], a = this._fields[r][1], s = this[o], l = 0; l < n; ++l) for (var u = a * (e + l), c = a * (t + l), d = 0; d < a; ++d) s[u + d] = s[c + d];
          }, Qf.prototype.sort = function (e) {
            Zc.time("Store.sort");
            var t = this,
              n = new this.constructor(1);
            !function r(i, o) {
              if (i < o) {
                var a = Math.floor((i + o) / 2),
                  s = i,
                  l = o;
                do {
                  for (; e(s, a) < 0;) s += 1;
                  for (; 0 < e(l, a);) l -= 1;
                  s <= l && (s === a ? a = l : l === a && (a = s), (u = s) !== (c = l) && (n.copyFrom(t, 0, u, 1), t.copyWithin(u, c, 1), t.copyFrom(n, c, 0, 1)), s += 1, l -= 1);
                } while (s <= l);
                r(i, l), r(s, o);
              }
              var u, c;
            }(0, this.count - 1), Zc.timeEnd("Store.sort");
          }, Qf.prototype.clear = function () {
            this.count = 0;
          }, Qf.prototype.dispose = function () {
            delete this.length, delete this.count;
            for (var e = 0, t = this._fields.length; e < t; ++e) delete this[this._fields[e][0]];
          };
          var Jf = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              _defaultFields: {
                configurable: !0
              }
            };
            return n._defaultFields.get = function () {
              return [["index1", 1, "int32"], ["index2", 1, "int32"], ["type", 1, "int8"]];
            }, t.prototype.addContact = function (e, t, n) {
              this.growIfFull();
              var r = this.count;
              e < t ? (this.index1[r] = e, this.index2[r] = t) : (this.index2[r] = e, this.index1[r] = t), n && (this.type[r] = n), this.count += 1;
            }, Object.defineProperties(t.prototype, n), t;
          }(Qf);
          function ep(e) {
            return 16843009 * ((e = (858993459 & (e -= e >>> 1 & 1431655765)) + (e >>> 2 & 858993459)) + (e >>> 4) & 252645135) >>> 24;
          }
          var tp = function tp(e, t) {
            this.length = e, this._words = new Uint32Array(e + 32 >>> 5), !0 === t && this.setAll();
          };
          function np(e) {
            for (var t = e.edgeCount, n = e.nodeCount, r = e.nodeArray1, i = e.nodeArray2, o = new Uint8Array(n), a = new Int32Array(n), s = 0; s < t; ++s) o[r[s]] += 1, o[i[s]] += 1;
            for (var l = 1; l < n; ++l) a[l] += a[l - 1] + o[l - 1];
            for (var u = 2 * t, c = new Int32Array(u), d = 0; d < u; ++d) c[d] = -1;
            for (var h = 0; h < t; ++h) {
              for (var f = r[h], p = i[h], m = a[f]; -1 !== c[m] && m < u;) m += 1;
              c[m] = h;
              for (var g = a[p]; -1 !== c[g] && g < u;) g += 1;
              c[g] = h;
            }
            return {
              countArray: o,
              offsetArray: a,
              indexArray: c
            };
          }
          function rp(e, t) {
            return void 0 === e && (e = 0), void 0 === t && (t = 0), {
              type: e,
              group: t,
              x: 0,
              y: 0,
              z: 0,
              atomSet: []
            };
          }
          function ip(e, t) {
            e.x += t.x, e.y += t.y, e.z += t.z, e.atomSet.push(t.index);
          }
          function op(e, t) {
            var n = t.atomSet.length;
            if (0 < n) {
              var r = e.types,
                i = e.groups,
                o = e.centers,
                a = e.atomSets;
              r.push(t.type), i.push(t.group), o.x.push(t.x / n), o.y.push(t.y / n), o.z.push(t.z / n), a.push(t.atomSet);
            }
          }
          tp.prototype.get = function (e) {
            return 0 != (this._words[e >>> 5] & 1 << e);
          }, tp.prototype.set = function (e) {
            this._words[e >>> 5] |= 1 << e;
          }, tp.prototype.clear = function (e) {
            this._words[e >>> 5] &= ~(1 << e);
          }, tp.prototype.flip = function (e) {
            this._words[e >>> 5] ^= 1 << e;
          }, tp.prototype._assignRange = function (e, t, n) {
            if (!(t < e)) {
              for (var r = this._words, i = !0 === n ? 4294967295 : 0, o = e >>> 5, a = t >>> 5, s = o; s < a; ++s) r[s] = i;
              var l = o << 5,
                u = a << 5;
              if (!0 === n) {
                if (t - e < 32) for (var c = e, d = t + 1; c < d; ++c) r[c >>> 5] |= 1 << c;else {
                  for (var h = e, f = l; h < f; ++h) r[h >>> 5] |= 1 << h;
                  for (var p = u, m = t + 1; p < m; ++p) r[p >>> 5] |= 1 << p;
                }
              } else if (t - e < 32) for (var g = e, v = t + 1; g < v; ++g) r[g >>> 5] &= ~(1 << g);else {
                for (var y = e, b = l; y < b; ++y) r[y >>> 5] &= ~(1 << y);
                for (var _ = u, x = t + 1; _ < x; ++_) r[_ >>> 5] &= ~(1 << _);
              }
              return this;
            }
          }, tp.prototype.setRange = function (e, t) {
            return this._assignRange(e, t, !0);
          }, tp.prototype.clearRange = function (e, t) {
            return this._assignRange(e, t, !1);
          }, tp.prototype.setBits = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            for (var n = this._words, r = e.length, i = 0; i < r; ++i) {
              var o = e[i];
              n[o >>> 5] |= 1 << o;
            }
            return this;
          }, tp.prototype.clearBits = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            for (var n = this._words, r = e.length, i = 0; i < r; ++i) {
              var o = e[i];
              n[o >>> 5] &= ~(1 << o);
            }
            return this;
          }, tp.prototype.setAll = function () {
            return this._assignRange(0, this.length - 1, !0);
          }, tp.prototype.clearAll = function () {
            return this._assignRange(0, this.length - 1, !1);
          }, tp.prototype.flipAll = function () {
            for (var e = this._words.length, t = this._words, n = 32 - this.length % 32, r = 0; r < e - 1; ++r) t[r] = ~t[r];
            return t[e - 1] = ~(t[e - 1] << n) >>> n, this;
          }, tp.prototype._isRangeValue = function (e, t, n) {
            if (!(t < e)) {
              for (var r = this._words, i = !0 === n ? 4294967295 : 0, o = e >>> 5, a = t >>> 5, s = o; s < a; ++s) if (r[s] !== i) return !1;
              if (t - e < 32) {
                for (var l = e, u = t + 1; l < u; ++l) if (!!(r[l >>> 5] & 1 << l) !== n) return !1;
              } else {
                for (var c = a << 5, d = e, h = o << 5 << 5; d < h; ++d) if (!!(r[d >>> 5] & 1 << d) !== n) return !1;
                for (var f = c, p = t + 1; f < p; ++f) if (!!(r[f >>> 5] & 1 << f) !== n) return !1;
              }
              return !0;
            }
          }, tp.prototype.isRangeSet = function (e, t) {
            return this._isRangeValue(e, t, !0);
          }, tp.prototype.isRangeClear = function (e, t) {
            return this._isRangeValue(e, t, !1);
          }, tp.prototype.isAllSet = function () {
            return this._isRangeValue(0, this.length - 1, !0);
          }, tp.prototype.isAllClear = function () {
            return this._isRangeValue(0, this.length - 1, !1);
          }, tp.prototype.isSet = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            for (var n = this._words, r = e.length, i = 0; i < r; ++i) {
              var o = e[i];
              if (0 == (n[o >>> 5] & 1 << o)) return !1;
            }
            return !0;
          }, tp.prototype.isClear = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            for (var n = this._words, r = e.length, i = 0; i < r; ++i) {
              var o = e[i];
              if (0 != (n[o >>> 5] & 1 << o)) return !1;
            }
            return !0;
          }, tp.prototype.isEqualTo = function (e) {
            for (var t = this._words, n = e._words, r = Math.min(t.length, n.length), i = 0; i < r; ++i) if (t[i] !== n[i]) return !1;
            return !0;
          }, tp.prototype.getSize = function () {
            for (var e = this._words.length, t = this._words, n = 0, r = 0; r < e; ++r) n += ep(t[r]);
            return n;
          }, tp.prototype.difference = function (e) {
            for (var t = this._words, n = e._words, r = Math.min(t.length, n.length), i = 0; i < r; ++i) t[i] = t[i] & ~n[i];
            for (var o = t.length; o < r; ++o) t[o] = 0;
            return this;
          }, tp.prototype.union = function (e) {
            for (var t = this._words, n = e._words, r = Math.min(t.length, n.length), i = 0; i < r; ++i) t[i] |= n[i];
            for (var o = t.length; o < r; ++o) t[o] = 0;
            return this;
          }, tp.prototype.intersection = function (e) {
            for (var t = this._words, n = e._words, r = Math.min(t.length, n.length), i = 0; i < r; ++i) t[i] &= n[i];
            for (var o = t.length; o < r; ++o) t[o] = 0;
            return this;
          }, tp.prototype.intersects = function (e) {
            for (var t = this._words, n = e._words, r = Math.min(t.length, n.length), i = 0; i < r; ++i) if (0 != (t[i] & n[i])) return !0;
            return !1;
          }, tp.prototype.getIntersectionSize = function (e) {
            for (var t = this._words, n = e._words, r = Math.min(t.length, n.length), i = 0, o = 0; o < r; ++o) i += ep(t[o] & n[o]);
            return i;
          }, tp.prototype.makeIntersection = function (e) {
            var t = this._words,
              n = e._words,
              r = Math.min(t.length, n.length),
              i = new Uint32Array(r),
              o = Object.create(tp.prototype);
            o._words = i, o.length = Math.min(this.length, e.length);
            for (var a = 0; a < r; ++a) i[a] = t[a] & n[a];
            return o;
          }, tp.prototype.forEach = function (e) {
            for (var t = this._words.length, n = this._words, r = 0, i = 0; i < t; ++i) for (var o = n[i]; 0 !== o;) {
              var a = o & -o;
              e((i << 5) + ep(a - 1), r), o ^= a, ++r;
            }
          }, tp.prototype.toArray = function () {
            for (var e = this._words, t = new Array(this.getSize()), n = this._words.length, r = 0, i = 0; i < n; ++i) for (var o = e[i]; 0 !== o;) {
              var a = o & -o;
              t[r++] = (i << 5) + ep(a - 1), o ^= a;
            }
            return t;
          }, tp.prototype.toString = function () {
            return "{" + this.toArray().join(",") + "}";
          }, tp.prototype.toSeleString = function () {
            var e = this.toArray().join(",");
            return e ? "@" + e : "NONE";
          }, tp.prototype.clone = function () {
            var e = Object.create(tp.prototype);
            return e.length = this.length, e._words = new Uint32Array(this._words), e;
          };
          var ap = ["D-BETA-PEPTIDE, C-GAMMA LINKING", "D-GAMMA-PEPTIDE, C-DELTA LINKING", "D-PEPTIDE COOH CARBOXY TERMINUS", "D-PEPTIDE NH3 AMINO TERMINUS", "D-PEPTIDE LINKING", "L-BETA-PEPTIDE, C-GAMMA LINKING", "L-GAMMA-PEPTIDE, C-DELTA LINKING", "L-PEPTIDE COOH CARBOXY TERMINUS", "L-PEPTIDE NH3 AMINO TERMINUS", "L-PEPTIDE LINKING", "PEPTIDE LINKING", "PEPTIDE-LIKE"],
            sp = ["RNA OH 3 PRIME TERMINUS", "RNA OH 5 PRIME TERMINUS", "RNA LINKING"],
            lp = ["DNA OH 3 PRIME TERMINUS", "DNA OH 5 PRIME TERMINUS", "DNA LINKING", "L-DNA LINKING", "L-RNA LINKING"],
            up = ["D-SACCHARIDE", "D-SACCHARIDE 1,4 AND 1,4 LINKING", "D-SACCHARIDE 1,4 AND 1,6 LINKING", "L-SACCHARIDE", "L-SACCHARIDE 1,4 AND 1,4 LINKING", "L-SACCHARIDE 1,4 AND 1,6 LINKING", "SACCHARIDE"],
            cp = ["NON-POLYMER"].concat(["OTHER"], up),
            dp = ["h", "g", "i"],
            hp = ["e", "b"],
            fp = ["s", "t", "l", ""],
            pp = {
              H: 1,
              D: 1,
              T: 1,
              HE: 2,
              LI: 3,
              BE: 4,
              B: 5,
              C: 6,
              N: 7,
              O: 8,
              F: 9,
              NE: 10,
              NA: 11,
              MG: 12,
              AL: 13,
              SI: 14,
              P: 15,
              S: 16,
              CL: 17,
              AR: 18,
              K: 19,
              CA: 20,
              SC: 21,
              TI: 22,
              V: 23,
              CR: 24,
              MN: 25,
              FE: 26,
              CO: 27,
              NI: 28,
              CU: 29,
              ZN: 30,
              GA: 31,
              GE: 32,
              AS: 33,
              SE: 34,
              BR: 35,
              KR: 36,
              RB: 37,
              SR: 38,
              Y: 39,
              ZR: 40,
              NB: 41,
              MO: 42,
              TC: 43,
              RU: 44,
              RH: 45,
              PD: 46,
              AG: 47,
              CD: 48,
              IN: 49,
              SN: 50,
              SB: 51,
              TE: 52,
              I: 53,
              XE: 54,
              CS: 55,
              BA: 56,
              LA: 57,
              CE: 58,
              PR: 59,
              ND: 60,
              PM: 61,
              SM: 62,
              EU: 63,
              GD: 64,
              TB: 65,
              DY: 66,
              HO: 67,
              ER: 68,
              TM: 69,
              YB: 70,
              LU: 71,
              HF: 72,
              TA: 73,
              W: 74,
              RE: 75,
              OS: 76,
              IR: 77,
              PT: 78,
              AU: 79,
              HG: 80,
              TL: 81,
              PB: 82,
              BI: 83,
              PO: 84,
              AT: 85,
              RN: 86,
              FR: 87,
              RA: 88,
              AC: 89,
              TH: 90,
              PA: 91,
              U: 92,
              NP: 93,
              PU: 94,
              AM: 95,
              CM: 96,
              BK: 97,
              CF: 98,
              ES: 99,
              FM: 100,
              MD: 101,
              NO: 102,
              LR: 103,
              RF: 104,
              DB: 105,
              SG: 106,
              BH: 107,
              HS: 108,
              MT: 109,
              DS: 110,
              RG: 111,
              CN: 112,
              NH: 113,
              FL: 114,
              MC: 115,
              LV: 116,
              TS: 117,
              OG: 118
            },
            mp = {
              1: 1.1,
              2: 1.4,
              3: 1.81,
              4: 1.53,
              5: 1.92,
              6: 1.7,
              7: 1.55,
              8: 1.52,
              9: 1.47,
              10: 1.54,
              11: 2.27,
              12: 1.73,
              13: 1.84,
              14: 2.1,
              15: 1.8,
              16: 1.8,
              17: 1.75,
              18: 1.88,
              19: 2.75,
              20: 2.31,
              21: 2.3,
              22: 2.15,
              23: 2.05,
              24: 2.05,
              25: 2.05,
              26: 2.05,
              27: 2,
              28: 2,
              29: 2,
              30: 2.1,
              31: 1.87,
              32: 2.11,
              33: 1.85,
              34: 1.9,
              35: 1.83,
              36: 2.02,
              37: 3.03,
              38: 2.49,
              39: 2.4,
              40: 2.3,
              41: 2.15,
              42: 2.1,
              43: 2.05,
              44: 2.05,
              45: 2,
              46: 2.05,
              47: 2.1,
              48: 2.2,
              49: 2.2,
              50: 1.93,
              51: 2.17,
              52: 2.06,
              53: 1.98,
              54: 2.16,
              55: 3.43,
              56: 2.68,
              57: 2.5,
              58: 2.48,
              59: 2.47,
              60: 2.45,
              61: 2.43,
              62: 2.42,
              63: 2.4,
              64: 2.38,
              65: 2.37,
              66: 2.35,
              67: 2.33,
              68: 2.32,
              69: 2.3,
              70: 2.28,
              71: 2.27,
              72: 2.25,
              73: 2.2,
              74: 2.1,
              75: 2.05,
              76: 2,
              77: 2,
              78: 2.05,
              79: 2.1,
              80: 2.05,
              81: 1.96,
              82: 2.02,
              83: 2.07,
              84: 1.97,
              85: 2.02,
              86: 2.2,
              87: 3.48,
              88: 2.83,
              89: 2,
              90: 2.4,
              91: 2,
              92: 2.3,
              93: 2,
              94: 2,
              95: 2,
              96: 2,
              97: 2,
              98: 2,
              99: 2,
              100: 2,
              101: 2,
              102: 2,
              103: 2,
              104: 2,
              105: 2,
              106: 2,
              107: 2,
              108: 2,
              109: 2,
              110: 2,
              111: 2,
              112: 2,
              113: 2,
              114: 2,
              115: 2,
              116: 2,
              117: 2,
              118: 2
            },
            gp = {
              1: .31,
              2: .28,
              3: 1.28,
              4: .96,
              5: .84,
              6: .76,
              7: .71,
              8: .66,
              9: .57,
              10: .58,
              11: 1.66,
              12: 1.41,
              13: 1.21,
              14: 1.11,
              15: 1.07,
              16: 1.05,
              17: 1.02,
              18: 1.06,
              19: 2.03,
              20: 1.76,
              21: 1.7,
              22: 1.6,
              23: 1.53,
              24: 1.39,
              25: 1.39,
              26: 1.32,
              27: 1.26,
              28: 1.24,
              29: 1.32,
              30: 1.22,
              31: 1.22,
              32: 1.2,
              33: 1.19,
              34: 1.2,
              35: 1.2,
              36: 1.16,
              37: 2.2,
              38: 1.95,
              39: 1.9,
              40: 1.75,
              41: 1.64,
              42: 1.54,
              43: 1.47,
              44: 1.46,
              45: 1.42,
              46: 1.39,
              47: 1.45,
              48: 1.44,
              49: 1.42,
              50: 1.39,
              51: 1.39,
              52: 1.38,
              53: 1.39,
              54: 1.4,
              55: 2.44,
              56: 2.15,
              57: 2.07,
              58: 2.04,
              59: 2.03,
              60: 2.01,
              61: 1.99,
              62: 1.98,
              63: 1.98,
              64: 1.96,
              65: 1.94,
              66: 1.92,
              67: 1.92,
              68: 1.89,
              69: 1.9,
              70: 1.87,
              71: 1.87,
              72: 1.75,
              73: 1.7,
              74: 1.62,
              75: 1.51,
              76: 1.44,
              77: 1.41,
              78: 1.36,
              79: 1.36,
              80: 1.32,
              81: 1.45,
              82: 1.46,
              83: 1.48,
              84: 1.4,
              85: 1.5,
              86: 1.5,
              87: 2.6,
              88: 2.21,
              89: 2.15,
              90: 2.06,
              91: 2,
              92: 1.96,
              93: 1.9,
              94: 1.87,
              95: 1.8,
              96: 1.69,
              97: 1.6,
              98: 1.6,
              99: 1.6,
              100: 1.6,
              101: 1.6,
              102: 1.6,
              103: 1.6,
              104: 1.6,
              105: 1.6,
              106: 1.6,
              107: 1.6,
              108: 1.6,
              109: 1.6,
              110: 1.6,
              111: 1.6,
              112: 1.6,
              113: 1.6,
              114: 1.6,
              115: 1.6,
              116: 1.6,
              117: 1.6,
              118: 1.6
            },
            vp = {
              1: [1],
              2: [0],
              3: [1],
              4: [2],
              5: [3],
              6: [4],
              7: [3],
              8: [2],
              9: [1],
              10: [0],
              11: [1],
              12: [2],
              13: [6],
              14: [6],
              15: [3, 5, 7],
              16: [2, 4, 6],
              17: [1],
              18: [0],
              19: [1],
              20: [2],
              31: [3],
              32: [4],
              33: [3, 5],
              34: [2, 4, 6],
              35: [1],
              36: [0],
              37: [1],
              38: [2],
              49: [3],
              50: [4],
              51: [3, 5],
              52: [2],
              53: [1, 2, 5],
              54: [0, 2],
              55: [1],
              56: [2],
              81: [3],
              82: [4],
              83: [3],
              84: [2],
              85: [1],
              86: [0],
              87: [1],
              88: [2]
            },
            yp = {
              1: 1,
              2: 2,
              3: 1,
              4: 2,
              5: 3,
              6: 4,
              7: 5,
              8: 6,
              9: 7,
              10: 8,
              11: 1,
              12: 2,
              13: 3,
              14: 4,
              15: 5,
              16: 6,
              17: 7,
              18: 8,
              19: 1,
              20: 2,
              21: 3,
              22: 4,
              23: 5,
              24: 6,
              25: 7,
              26: 8,
              27: 9,
              28: 10,
              29: 11,
              30: 2,
              31: 3,
              32: 4,
              33: 5,
              34: 6,
              35: 7,
              36: 8,
              37: 1,
              38: 2,
              39: 3,
              40: 4,
              41: 5,
              42: 6,
              43: 7,
              44: 8,
              45: 9,
              46: 10,
              47: 11,
              48: 2,
              49: 3,
              50: 4,
              51: 5,
              52: 6,
              53: 7,
              54: 8,
              55: 1,
              56: 2,
              57: 3,
              58: 4,
              59: 3,
              60: 4,
              61: 5,
              62: 6,
              63: 7,
              64: 8,
              65: 9,
              66: 10,
              67: 11,
              68: 12,
              69: 13,
              70: 14,
              71: 15,
              72: 4,
              73: 5,
              74: 6,
              75: 7,
              76: 8,
              77: 9,
              78: 10,
              79: 11,
              80: 2,
              81: 3,
              82: 4,
              83: 5,
              84: 6,
              85: 7,
              86: 8,
              87: 1,
              88: 2,
              89: 3,
              90: 4,
              91: 3,
              92: 4,
              93: 5,
              94: 6,
              95: 7,
              96: 8,
              97: 9,
              98: 10,
              99: 11,
              100: 12,
              101: 13,
              102: 14,
              103: 15,
              104: 2,
              105: 2,
              106: 2,
              107: 2,
              108: 2,
              109: 2,
              110: 2,
              111: 2,
              112: 2,
              113: 3,
              114: 4,
              115: 5,
              116: 6,
              117: 7,
              118: 8
            },
            bp = {
              ALA: [.17, .5, .33],
              ARG: [.81, 1.81, 1],
              ASN: [.42, .85, .43],
              ASP: [1.23, 3.64, 2.41],
              ASH: [-.07, .43, .5],
              CYS: [-.24, -.02, .22],
              GLN: [.58, .77, .19],
              GLU: [2.02, 3.63, 1.61],
              GLH: [-.01, .11, .12],
              GLY: [.01, 1.15, 1.14],
              HIS: [.17, .11, -.06],
              ILE: [-.31, -1.12, -.81],
              LEU: [-.56, -1.25, -.69],
              LYS: [.99, 2.8, 1.81],
              MET: [-.23, -.67, -.44],
              PHE: [-1.13, -1.71, -.58],
              PRO: [.45, .14, -.31],
              SER: [.13, .46, .33],
              THR: [.14, .25, .11],
              TRP: [-1.85, -2.09, -.24],
              TYR: [-.94, -.71, .23],
              VAL: [.07, -.46, -.53]
            },
            _p = [0, 0, 0],
            xp = {
              HIS: "H",
              ARG: "R",
              LYS: "K",
              ILE: "I",
              PHE: "F",
              LEU: "L",
              TRP: "W",
              ALA: "A",
              MET: "M",
              PRO: "P",
              CYS: "C",
              ASN: "N",
              VAL: "V",
              GLY: "G",
              SER: "S",
              GLN: "Q",
              TYR: "Y",
              ASP: "D",
              GLU: "E",
              THR: "T",
              SEC: "U",
              PYL: "O"
            },
            wp = Object.keys(xp),
            Sp = ["A", "C", "T", "G", "U", "I"],
            Ap = ["DA", "DC", "DT", "DG", "DU", "DI"],
            Ep = ["A", "G", "I", "DA", "DG", "DI"],
            Tp = Sp.concat(Ap),
            Mp = ["SOL", "WAT", "HOH", "H2O", "W", "DOD", "D3O", "TIP3", "TIP4", "SPC"],
            Cp = ["118", "119", "1AL", "1CU", "2FK", "2HP", "2OF", "3CO", "3MT", "3NI", "3OF", "3P8", "4MO", "4PU", "543", "6MO", "ACT", "AG", "AL", "ALF", "AM", "ATH", "AU", "AU3", "AUC", "AZI", "BA", "BCT", "BEF", "BF4", "BO4", "BR", "BS3", "BSY", "CA", "CAC", "CD", "CD1", "CD3", "CD5", "CE", "CHT", "CL", "CO", "CO3", "CO5", "CON", "CR", "CS", "CSB", "CU", "CU1", "CU3", "CUA", "CUZ", "CYN", "DME", "DMI", "DSC", "DTI", "DY", "E4N", "EDR", "EMC", "ER3", "EU", "EU3", "F", "FE", "FE2", "FPO", "GA", "GD3", "GEP", "HAI", "HG", "HGC", "IN", "IOD", "IR", "IR3", "IRI", "IUM", "K", "KO4", "LA", "LCO", "LCP", "LI", "LU", "MAC", "MG", "MH2", "MH3", "MLI", "MLT", "MMC", "MN", "MN3", "MN5", "MN6", "MO1", "MO2", "MO3", "MO4", "MO5", "MO6", "MOO", "MOS", "MOW", "MW1", "MW2", "MW3", "NA", "NA2", "NA5", "NA6", "NAO", "NAW", "NCO", "NET", "NH4", "NI", "NI1", "NI2", "NI3", "NO2", "NO3", "NRU", "O4M", "OAA", "OC1", "OC2", "OC3", "OC4", "OC5", "OC6", "OC7", "OC8", "OCL", "OCM", "OCN", "OCO", "OF1", "OF2", "OF3", "OH", "OS", "OS4", "OXL", "PB", "PBM", "PD", "PDV", "PER", "PI", "PO3", "PO4", "PR", "PT", "PT4", "PTN", "RB", "RH3", "RHD", "RU", "SB", "SCN", "SE4", "SEK", "SM", "SMO", "SO3", "SO4", "SR", "T1A", "TB", "TBA", "TCN", "TEA", "TH", "THE", "TL", "TMA", "TRA", "UNX", "V", "VN3", "VO4", "W", "WO5", "Y1", "YB", "YB2", "YH", "YT3", "ZCM", "ZN", "ZN2", "ZN3", "ZNO", "ZO3", "OHX"],
            kp = ["045", "0AT", "0BD", "0MK", "0NZ", "0TS", "0V4", "0XY", "0YT", "10M", "147", "149", "14T", "15L", "16G", "18T", "18Y", "1AR", "1BW", "1GL", "1GN", "1JB", "1LL", "1NA", "1S3", "26M", "26Q", "26R", "26V", "26W", "26Y", "27C", "289", "291", "293", "2DG", "2F8", "2FG", "2FL", "2FP", "2GL", "2M4", "2M5", "32O", "34V", "3CM", "3DO", "3DY", "3FM", "3LR", "3MF", "3MG", "3SA", "3ZW", "46D", "46M", "46Z", "48Z", "4CQ", "4GC", "4NN", "50A", "5DI", "5GF", "5MM", "5RP", "5SA", "5SP", "64K", "6PG", "6SA", "7JZ", "7SA", "A1Q", "A2G", "AAB", "AAL", "AAO", "ABC", "ABD", "ABE", "ABF", "ABL", "ACG", "ACI", "ACR", "ACX", "ADA", "ADG", "ADR", "AF1", "AFD", "AFL", "AFO", "AFP", "AFR", "AGC", "AGH", "AGL", "AHR", "AIG", "ALL", "ALX", "AMU", "AOG", "AOS", "ARA", "ARB", "ARE", "ARI", "ASG", "ASO", "AXP", "AXR", "B0D", "B16", "B2G", "B4G", "B6D", "B8D", "B9D", "BBK", "BCD", "BDG", "BDP", "BDR", "BEM", "BFP", "BGC", "BGL", "BGP", "BGS", "BHG", "BMA", "BMX", "BNG", "BNX", "BOG", "BRI", "BXF", "BXP", "BXX", "BXY", "C3X", "C4X", "C5X", "CAP", "CBI", "CBK", "CBS", "CDR", "CEG", "CGF", "CHO", "CR1", "CR6", "CRA", "CT3", "CTO", "CTR", "CTT", "D6G", "DAF", "DAG", "DDA", "DDB", "DDL", "DEL", "DFR", "DFX", "DG0", "DGC", "DGD", "DGM", "DGS", "DIG", "DLF", "DLG", "DMU", "DNO", "DOM", "DP5", "DQQ", "DQR", "DR2", "DR3", "DR4", "DRI", "DSR", "DT6", "DVC", "E4P", "E5G", "EAG", "EBG", "EBQ", "EGA", "EJT", "EPG", "ERE", "ERI", "F1P", "F1X", "F6P", "FBP", "FCA", "FCB", "FCT", "FDP", "FDQ", "FFC", "FIX", "FMO", "FRU", "FSI", "FU4", "FUB", "FUC", "FUD", "FUL", "FXP", "G16", "G1P", "G2F", "G3I", "G4D", "G4S", "G6D", "G6P", "G6S", "GAC", "GAD", "GAL", "GC1", "GC4", "GCD", "GCN", "GCO", "GCS", "GCT", "GCU", "GCV", "GCW", "GCX", "GE1", "GFG", "GFP", "GIV", "GL0", "GL2", "GL5", "GL6", "GL7", "GL9", "GLA", "GLB", "GLC", "GLD", "GLF", "GLG", "GLO", "GLP", "GLS", "GLT", "GLW", "GMH", "GN1", "GNX", "GP1", "GP4", "GPH", "GPM", "GQ1", "GQ2", "GQ4", "GS1", "GS4", "GSA", "GSD", "GTE", "GTH", "GTK", "GTR", "GTZ", "GU0", "GU1", "GU2", "GU3", "GU4", "GU5", "GU6", "GU8", "GU9", "GUF", "GUP", "GUZ", "GYP", "GYV", "H2P", "HDL", "HMS", "HS2", "HSD", "HSG", "HSH", "HSJ", "HSQ", "HSR", "HSU", "HSX", "HSY", "HSZ", "IAB", "IDG", "IDR", "IDS", "IDT", "IDU", "IDX", "IDY", "IMK", "IN1", "IPT", "ISL", "KBG", "KD2", "KDA", "KDM", "KDO", "KFN", "KO1", "KO2", "KTU", "L6S", "LAG", "LAI", "LAK", "LAO", "LAT", "LB2", "LBT", "LCN", "LDY", "LGC", "LGU", "LM2", "LMT", "LMU", "LOG", "LOX", "LPK", "LSM", "LTM", "LVZ", "LXB", "LXZ", "M1F", "M3M", "M6P", "M8C", "MA1", "MA2", "MA3", "MAB", "MAG", "MAL", "MAN", "MAT", "MAV", "MAW", "MBG", "MCU", "MDA", "MDM", "MDP", "MFA", "MFB", "MFU", "MG5", "MGA", "MGL", "MLB", "MMA", "MMN", "MN0", "MRP", "MTT", "MUG", "MVP", "MXY", "N1L", "N9S", "NAA", "NAG", "NBG", "NDG", "NED", "NG1", "NG6", "NGA", "NGB", "NGC", "NGE", "NGF", "NGL", "NGS", "NGY", "NHF", "NM6", "NM9", "NTF", "NTO", "NTP", "NXD", "NYT", "OPG", "OPM", "ORP", "OX2", "P3M", "P53", "P6P", "PA5", "PNA", "PNG", "PNW", "PRP", "PSJ", "PSV", "PTQ", "QDK", "QPS", "QV4", "R1P", "R1X", "R2B", "R5P", "RAA", "RAE", "RAF", "RAM", "RAO", "RAT", "RB5", "RBL", "RCD", "RDP", "REL", "RER", "RF5", "RG1", "RGG", "RHA", "RIB", "RIP", "RNS", "RNT", "ROB", "ROR", "RPA", "RST", "RUB", "RUU", "RZM", "S6P", "S7P", "SA0", "SCR", "SDD", "SF6", "SF9", "SG4", "SG5", "SG6", "SG7", "SGA", "SGC", "SGD", "SGN", "SGS", "SHB", "SHG", "SI3", "SIO", "SOE", "SOL", "SSG", "SUC", "SUP", "SUS", "T6P", "T6T", "TAG", "TCB", "TDG", "TGK", "TGY", "TH1", "TIA", "TM5", "TM6", "TM9", "TMR", "TMX", "TOA", "TOC", "TRE", "TYV", "UCD", "UDC", "VG1", "X0X", "X1X", "X2F", "X4S", "X5S", "X6X", "XBP", "XDN", "XDP", "XIF", "XIM", "XLF", "XLS", "XMM", "XUL", "XXR", "XYP", "XYS", "YO5", "Z3Q", "Z6J", "Z9M", "ZDC", "ZDM"],
            Pp = ["CA", "C", "N", "O", "O1", "O2", "OC1", "OC2", "OX1", "OXT", "H", "H1", "H2", "H3", "HA", "HN", "BB"],
            Op = ["P", "OP1", "OP2", "HOP2", "HOP3", "O2'", "O3'", "O4'", "O5'", "C1'", "C2'", "C3'", "C4'", "C5'", "H1'", "H2'", "H2''", "HO2'", "H3'", "H4'", "H5'", "H5''", "HO3'", "HO5'", "O2*", "O3*", "O4*", "O5*", "C1*", "C2*", "C3*", "C4*", "C5*"],
            Rp = {};
          function Ip(e) {
            switch (e) {
              case 0:
                return 0;
              case 1:
                return 1;
              case 2:
                return 2;
              case 3:
                return 3;
              case 4:
                return 4;
              default:
                return 8;
            }
          }
          Rp[1] = {
            trace: "CA",
            direction1: "C",
            direction2: ["O", "OC1", "O1", "OX1", "OXT"],
            backboneStart: "N",
            backboneEnd: "C"
          }, Rp[2] = {
            trace: ["C4'", "C4*"],
            direction1: ["C1'", "C1*"],
            direction2: ["C3'", "C3*"],
            backboneStart: "P",
            backboneEnd: ["O3'", "O3*"]
          }, Rp[3] = {
            trace: ["C3'", "C3*"],
            direction1: ["C2'", "C2*"],
            direction2: ["O4'", "O4*"],
            backboneStart: "P",
            backboneEnd: ["O3'", "O3*"]
          }, Rp[4] = {
            trace: ["CA", "BB"],
            backboneStart: ["CA", "BB"],
            backboneEnd: ["CA", "BB"]
          }, Rp[5] = {
            trace: ["C4'", "C4*", "P"],
            backboneStart: ["C4'", "C4*", "P"],
            backboneEnd: ["C4'", "C4*", "P"]
          }, Rp[6] = {
            trace: ["C3'", "C3*", "C2'", "P"],
            backboneStart: ["C3'", "C3*", "C2'", "P"],
            backboneEnd: ["C3'", "C3*", "C2'", "P"]
          }, Rp[0] = {};
          var jp = new Map([[2, qu(180)], [3, qu(120)], [4, qu(109.4721)], [6, qu(90)]]);
          function Np(e, t) {
            var n = [],
              r = new ae(),
              i = new ae();
            return r.subVectors(t, e), e.eachBondedAtom(function (t) {
              1 !== t.number && (i.subVectors(t, e), n.push(r.angleTo(i)));
            }), n;
          }
          function Lp(e, t) {
            var n = e.clone(),
              r = new ae();
            r.subVectors(t, e);
            var i = [new ae(), new ae()],
              o = 0;
            if (e.eachBondedAtom(function (t) {
              1 < o || 1 !== t.number && (n.index = t.index, i[o++].subVectors(t, e));
            }), 1 === o && n.eachBondedAtom(function (t) {
              1 < o || 1 !== t.number && t.index !== e.index && i[o++].subVectors(t, e);
            }), 2 === o) {
              var a = i[0].cross(i[1]);
              return Math.abs(Math.PI / 2 - a.angleTo(r));
            }
          }
          function Dp(e) {
            if (e["@valenceModel"]) return e["@valenceModel"];
            var t = function (e, t) {
              var n = e.structure,
                r = n.atomCount,
                i = new Int8Array(r),
                o = new Int8Array(r),
                a = new Int8Array(r),
                s = new Int8Array(r);
              return n.eachAtom(function (e) {
                var n = e.index,
                  r = function (e, t) {
                    var n,
                      r = e.bondToElementCount(1),
                      i = e.formalCharge || 0,
                      o = "always" === t.assignCharge || "auto" === t.assignCharge && 0 === i,
                      a = "always" === t.assignH || "auto" === t.assignH && 0 === r,
                      s = e.bondCount,
                      l = (n = 0, e.eachBond(function (e) {
                        return n += e.bondOrder;
                      }), n),
                      u = function (e) {
                        var t = e.structure.getBondProxy(),
                          n = e.number,
                          r = 8 === n || 7 === n;
                        if (r && 4 === e.bondCount) return !1;
                        var i = !1;
                        return e.eachBond(function (n) {
                          if (1 < n.bondOrder) i = !0;else if (r) {
                            var o = n.getOtherAtom(e);
                            o.eachBond(function (e) {
                              if (1 < e.bondOrder) {
                                var t = o.number;
                                if ((15 === t || 16 === t) && 8 === e.getOtherAtom(o).number) return;
                                i = !0;
                              }
                            }, t);
                          }
                        }), i;
                      }(e),
                      c = 0 < l - s,
                      d = 0,
                      h = 8;
                    switch (e.number) {
                      case 1:
                        o && (0 === s ? (i = 1, h = 0) : 1 === s && (i = 0, h = 1));
                        break;
                      case 6:
                        o && (i = 0), a && (d = Math.max(0, 4 - l - Math.abs(i))), h = Ip(s + d + Math.max(0, -i));
                        break;
                      case 7:
                        if (o) if (a) {
                          if (u && l < 4) i = s - r == 1 && l - r == 2 ? 1 : 0;else {
                            var f = !1;
                            e.eachBondedAtom(function (e) {
                              (16 === e.number || e.isMetal()) && (f = !0);
                            }), i = f ? 0 : 1;
                          }
                        } else i = l - 3;
                        a && (d = Math.max(0, 3 - l + i)), h = Ip(u && !c ? s + d - i : s + d + 1 - i);
                        break;
                      case 8:
                        o && (a || (i = l - 2), 1 === l && e.eachBondedAtom(function (t) {
                          t.eachBond(function (n) {
                            var r = n.getOtherAtom(t);
                            r.index !== e.index && 8 === r.number && 2 === n.bondOrder && (i = -1);
                          });
                        })), a && (d = Math.max(0, 2 - l + i)), h = Ip(u && !c ? s + d - i + 1 : s + d - i + 2);
                        break;
                      case 16:
                        o && (a || (i = l <= 3 && !e.bondToElementCount(8) ? l - 2 : 0)), a && l < 2 && (d = Math.max(0, 2 - l + i)), l <= 3 && (h = Ip(s + d - i + 2));
                        break;
                      case 9:
                      case 17:
                      case 35:
                      case 53:
                      case 85:
                        o && (i = l - 1);
                        break;
                      case 3:
                      case 11:
                      case 19:
                      case 37:
                      case 55:
                      case 87:
                        o && (i = 1 - l);
                        break;
                      case 4:
                      case 12:
                      case 20:
                      case 38:
                      case 56:
                      case 88:
                        o && (i = 2 - l);
                        break;
                      default:
                        console.warn("Requested charge, protonation for an unhandled element", e.element);
                    }
                    return [i, d, d + r, h];
                  }(e, t),
                  l = r[0],
                  u = r[1],
                  c = r[2],
                  d = r[3];
                i[n] = l, o[n] = u, a[n] = c, s[n] = d;
              }), {
                charge: i,
                implicitH: o,
                totalH: a,
                idealGeometry: s
              };
            }(e, {
              assignCharge: "auto",
              assignH: "auto"
            });
            return e["@valenceModel"] = t;
          }
          function Bp(e) {
            return 15 === e.number && e.bondToElementCount(8) === e.bondCount;
          }
          var Fp = ["ARG", "HIS", "LYS"],
            zp = ["GLU", "ASP"];
          function Up(e) {
            return "HIS" === e.resname && 7 == e.number && e.isRing();
          }
          var Gp = [3, 11, 19, 37, 55, 12, 20, 38, 56, 13, 31, 49, 81, 21, 50, 82, 83, 51, 80],
            Vp = [17, 35, 53, 85],
            Hp = [7, 8, 16],
            qp = [6, 7, 15, 16],
            Wp = qu(180),
            $p = qu(120);
          function Xp(e, t, n) {
            return !Kp(e, t, n) && (e.modelIndex !== t.modelIndex || e.altloc && t.altloc && e.altloc !== t.altloc);
          }
          var Yp = {
            maxHydrophobicDist: 4,
            maxHbondDist: 3.5,
            maxHbondSulfurDist: 4.1,
            maxHbondAccAngle: 45,
            maxHbondDonAngle: 45,
            maxHbondAccPlaneAngle: 90,
            maxHbondDonPlaneAngle: 30,
            maxPiStackingDist: 5.5,
            maxPiStackingOffset: 2,
            maxPiStackingAngle: 30,
            maxCationPiDist: 6,
            maxCationPiOffset: 2,
            maxIonicDist: 5,
            maxHalogenBondDist: 4,
            maxHalogenBondAngle: 30,
            maxMetalDist: 3,
            refineSaltBridges: !0,
            masterModelIndex: -1,
            lineOfSightDistFactor: 1
          };
          function Kp(e, t, n) {
            return e.modelIndex === n && t.modelIndex !== n || t.modelIndex === n && e.modelIndex !== n;
          }
          function Zp(e, t, n) {
            return !Kp(e, t, n) && (e.modelIndex !== t.modelIndex || e.residueIndex === t.residueIndex || e.altloc && t.altloc && e.altloc !== t.altloc);
          }
          function Qp(e, n) {
            void 0 === n && (n = Yp);
            var r,
              i,
              o,
              a = function (e) {
                var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h,
                  f,
                  p,
                  m,
                  g,
                  v,
                  y,
                  b,
                  _,
                  x,
                  w,
                  S,
                  A,
                  E,
                  T,
                  M,
                  C,
                  k,
                  P = {
                    types: [],
                    groups: [],
                    centers: {
                      x: [],
                      y: [],
                      z: []
                    },
                    atomSets: []
                  };
                return t.Debug && Zc.time("calculateFeatures"), r = P, i = Dp((n = e).data).charge, o = {}, n.eachResidue(function (e) {
                  if (Fp.includes(e.resname)) {
                    var t = rp(1);
                    e.eachAtom(function (e) {
                      7 === e.number && e.isSidechain() && ip(t, e);
                    }), op(r, t);
                  } else wp.includes(e.resname) || e.isNucleic() || (e.eachAtom(function (e) {
                    var t,
                      n,
                      i,
                      a,
                      s = !1,
                      l = rp(1);
                    a = 0, 6 === (i = e).number && 3 === i.bondCount && 3 === i.bondToElementCount(7) && i.eachBondedAtom(function (e) {
                      e.bondCount - e.bondToElementCount(1) == 1 && ++a;
                    }), 2 === a ? (l.group = 8, s = !0) : (n = 0, 6 === (t = e).number && 3 === t.bondCount && 2 === t.bondToElementCount(7) && 1 === t.bondToElementCount(6) && t.eachBondedAtom(function (e) {
                      e.bondCount - e.bondToElementCount(1) == 1 && ++n;
                    }), 2 === n && (l.group = 9, s = !0)), s && (e.eachBondedAtom(function (e) {
                      7 === e.number && (o[e.index] = !0, ip(l, e));
                    }), op(r, l));
                  }), e.eachAtom(function (e) {
                    var t = rp(1);
                    0 < i[e.index] && (o[e.index] || (ip(t, e), op(r, t)));
                  }));
                }), s = P, l = Dp((a = e).data).charge, u = {}, a.eachResidue(function (e) {
                  if (zp.includes(e.resname)) {
                    var t = rp(2);
                    e.eachAtom(function (e) {
                      8 === e.number && e.isSidechain() && ip(t, e);
                    }), op(s, t);
                  } else if (Tp.includes(e.resname)) {
                    var n = rp(2);
                    e.eachAtom(function (e) {
                      Bp(e) && (n.group = 6, e.eachBondedAtom(function (e) {
                        8 === e.number && ip(n, e);
                      }), op(s, n));
                    });
                  } else wp.includes(e.resname) || Tp.includes(e.resname) || (e.eachAtom(function (e) {
                    var t,
                      n,
                      r,
                      i,
                      o = !1,
                      a = rp(2);
                    16 === (i = e).number && 3 === i.bondToElementCount(8) ? (a.group = 4, o = !0) : Bp(e) ? (a.group = 6, o = !0) : 16 === (r = e).number && 4 === r.bondToElementCount(8) ? (a.group = 5, o = !0) : (n = 0, 6 === (t = e).number && 2 === t.bondToElementCount(8) && 1 === t.bondToElementCount(6) && t.eachBondedAtom(function (e) {
                      8 === e.number && e.bondCount - e.bondToElementCount(1) == 1 && ++n;
                    }), 2 === n && (a.group = 10, o = !0)), o && (e.eachBondedAtom(function (e) {
                      8 === e.number && (u[e.index] = !0, ip(a, e));
                    }), op(s, a));
                  }), e.eachAtom(function (e) {
                    var t = rp(2);
                    l[e.index] < 0 && (u[e.index] || (ip(t, e), op(s, t)));
                  }));
                }), d = P, h = (c = e).getAtomProxy(), c.eachResidue(function (e) {
                  var t = e.getAromaticRings();
                  if (t) {
                    var n = e.atomOffset;
                    t.forEach(function (e) {
                      var t = rp(3);
                      e.forEach(function (e) {
                        h.index = e + n, ip(t, h);
                      }), op(d, t);
                    });
                  }
                }), p = P, m = Dp((f = e).data), g = m.charge, v = m.implicitH, y = m.idealGeometry, f.eachAtom(function (e) {
                  var t = rp(5),
                    n = e.number;
                  if (8 === n) ip(t, e), op(p, t);else if (7 === n) {
                    if (Up(e)) ip(t, e), op(p, t);else if (g[e.index] < 1) {
                      var r = e.bondCount + v[e.index],
                        i = y[e.index];
                      (4 === i && r < 4 || 3 === i && r < 3 || 2 === i && r < 2) && (ip(t, e), op(p, t));
                    }
                  } else 16 === n && ("CYS" !== e.resname && "MET" !== e.resname && -1 !== e.formalCharge || (ip(t, e), op(p, t)));
                }), _ = P, x = Dp((b = e).data).totalH, b.eachAtom(function (e) {
                  var t = rp(4),
                    n = e.number;
                  (Up(e) || 0 < x[e.index] && (7 === n || 8 === n || 16 === n)) && (ip(t, e), op(_, t));
                }), S = P, A = Dp((w = e).data).totalH, w.eachAtom(function (e) {
                  if (6 === e.number && 0 < A[e.index] && (0 < e.bondToElementCount(7) || 0 < e.bondToElementCount(8) || function (e) {
                    if (!e.isAromatic()) return !1;
                    var t = e.residueType.getRings();
                    if (!t) return !1;
                    var n = !1;
                    return t.rings.forEach(function (t) {
                      n || t.some(function (t) {
                        return e.index - e.residueAtomOffset === t;
                      }) && (n = t.some(function (t) {
                        var n = e.residueType.atomTypeIdList[t],
                          r = e.atomMap.get(n).number;
                        return 7 === r || 8 === r;
                      }));
                    }), n;
                  }(e))) {
                    var t = rp(9);
                    ip(t, e), op(S, t);
                  }
                }), E = P, e.eachAtom(function (e) {
                  var t = !1,
                    n = !1,
                    r = wp.includes(e.resname),
                    i = Tp.includes(e.resname);
                  if (r || i ? r ? 8 === e.number ? (["ASP", "GLU", "SER", "THR", "TYR", "ASN", "GLN"].includes(e.resname) && e.isSidechain() || e.isBackbone()) && (n = t = !0) : 16 === e.number && "CYS" === e.resname ? n = t = !0 : 7 === e.number && "HIS" === e.resname && e.isSidechain() && (t = !0) : i && (8 === e.number && e.isBackbone() ? n = t = !0 : ["N3", "N4", "N7"].includes(e.atomname) ? t = !0 : ["O2", "O4", "O6"].includes(e.atomname) && (n = t = !0)) : e.isHalogen() || 8 === e.number || 16 === e.number ? n = t = !0 : 7 === e.number && (t = !0), t) {
                    var o = rp(11);
                    ip(o, e), op(E, o);
                  }
                  if (n) {
                    var a = rp(10);
                    ip(a, e), op(E, a);
                  }
                }), T = P, e.eachAtom(function (e) {
                  if (e.isTransitionMetal() || 30 === e.number || 48 === e.number) {
                    var t = rp(12);
                    ip(t, e), op(T, t);
                  } else if (Gp.includes(e.number)) {
                    var n = rp(13);
                    ip(n, e), op(T, n);
                  }
                }), M = P, e.eachAtom(function (e) {
                  var t = rp(8),
                    n = !1;
                  6 === e.number ? (n = !0, e.eachBondedAtom(function (e) {
                    var t = e.number;
                    6 !== t && 1 !== t && (n = !1);
                  })) : 9 === e.number && (n = !0), n && (ip(t, e), op(M, t));
                }), C = P, e.eachAtom(function (e) {
                  if (Hp.includes(e.number)) {
                    var t = !1;
                    if (e.eachBondedAtom(function (e) {
                      qp.includes(e.number) && (t = !0);
                    }), t) {
                      var n = rp(7);
                      ip(n, e), op(C, n);
                    }
                  }
                }), k = P, e.eachAtom(function (e) {
                  if (Vp.includes(e.number) && 1 === e.bondToElementCount(6)) {
                    var t = rp(6);
                    ip(t, e), op(k, t);
                  }
                }), t.Debug && Zc.timeEnd("calculateFeatures"), P;
              }(e),
              s = (i = (r = a).types, o = r.centers, {
                features: r,
                spatialHash: new Zf(o),
                contactStore: new Jf(),
                featureSet: new tp(i.length, !1)
              });
            t.Debug && Zc.time("calculateContacts"), function (e, t, n) {
              void 0 === n && (n = {});
              for (var r = wu(n.maxIonicDist, Yp.maxIonicDist), i = wu(n.maxPiStackingDist, Yp.maxPiStackingDist), o = wu(n.maxPiStackingOffset, Yp.maxPiStackingOffset), a = wu(n.maxPiStackingAngle, Yp.maxPiStackingAngle), s = wu(n.maxCationPiDist, Yp.maxCationPiDist), l = wu(n.maxCationPiOffset, Yp.maxCationPiOffset), u = wu(n.masterModelIndex, Yp.masterModelIndex), c = Math.max(r + 2, i, s), d = i * i, h = s * s, f = t.features, p = t.spatialHash, m = t.contactStore, g = t.featureSet, v = f.types, y = f.centers, b = f.atomSets, _ = y.x, x = y.y, w = y.z, S = v.length, A = e.atomStore.x, E = e.atomStore.y, T = e.atomStore.z, M = e.getAtomProxy(), C = e.getAtomProxy(), k = new ae(), P = new ae(), O = new ae(), R = new ae(), I = new ae(), j = new ae(), N = new ae(), L = function L(e, t) {
                  k.set(A[e[0]], E[e[0]], T[e[0]]), P.set(A[e[1]], E[e[1]], T[e[1]]), O.set(A[e[2]], E[e[2]], T[e[2]]), R.subVectors(k, P), I.subVectors(k, O), t.crossVectors(R, I);
                }, D = function D(e, t, n) {
                  return k.set(_[e], x[e], w[e]), P.set(_[t], x[t], w[t]), k.sub(P).projectOnPlane(n).add(P).distanceTo(P);
                }, B = function B(e, t, n) {
                  g.setBits(e, t), m.addContact(e, t, n);
                }, F = function F(e) {
                  p.eachWithin(_[e], x[e], w[e], c, function (t, n) {
                    if (!(t <= e || (M.index = b[e][0], C.index = b[t][0], Zp(M, C, u)))) {
                      var i,
                        s,
                        c,
                        f,
                        p = v[e],
                        m = v[t];
                      if (f = m, 2 === (c = p) && 1 === f || 1 === c && 2 === f) (function (e, t, n) {
                        for (var r = e.length, i = t.length, o = 0; o < r; ++o) {
                          M.index = e[o];
                          for (var a = 0; a < i; ++a) if (C.index = t[a], M.distanceTo(C) <= n) return !0;
                        }
                        return !1;
                      })(b[e], b[t], r) && B(e, t, 1);else if (3 === p && 3 === m) {
                        if (n <= d) {
                          L(b[e], j), L(b[t], N);
                          var g = 57.29578 * j.angleTo(N);
                          Math.min(D(e, t, N), D(t, e, j)) <= o && (g <= a || 180 - a <= g || g <= a + 90 && 90 - a <= g) && B(e, t, 3);
                        }
                      } else if (s = m, (3 === (i = p) && 1 === s || 1 === i && 3 === s) && n <= h) {
                        var y = 3 === p ? [e, t] : [t, e],
                          _ = y[0],
                          x = y[1];
                        L(b[_], j), D(x, _, j) <= l && B(_, x, 2);
                      }
                    }
                  });
                }, z = 0; z < S; ++z) F(z);
            }(e, s, n), function (e, t, n) {
              void 0 === n && (n = {});
              for (var r = wu(n.maxHbondDist, Yp.maxHbondDist), i = wu(n.maxHbondSulfurDist, Yp.maxHbondSulfurDist), o = qu(wu(n.maxHbondAccAngle, Yp.maxHbondAccAngle)), a = qu(wu(n.maxHbondDonAngle, Yp.maxHbondDonAngle)), s = qu(wu(n.maxHbondAccPlaneAngle, Yp.maxHbondAccPlaneAngle)), l = qu(wu(n.maxHbondDonPlaneAngle, Yp.maxHbondDonPlaneAngle)), u = wu(n.masterModelIndex, Yp.masterModelIndex), c = Math.max(r, i), d = r * r, h = t.features, f = t.spatialHash, p = t.contactStore, m = t.featureSet, g = h.types, v = h.centers, y = h.atomSets, b = v.x, _ = v.y, x = v.z, w = g.length, S = Dp(e.data).idealGeometry, A = e.getAtomProxy(), E = e.getAtomProxy(), T = function T(e) {
                  f.eachWithin(b[e], _[e], x[e], c, function (t, n) {
                    if (!(t <= e)) {
                      var r,
                        i,
                        c = g[e],
                        h = g[t],
                        f = (i = h, 9 === (r = c) && 5 === i || 5 === r && 9 === i);
                      if (f || (b = h, 5 === (v = c) && 4 === b || 4 === v && 5 === b)) {
                        var v,
                          b,
                          _ = 5 === h ? [e, t] : [t, e],
                          x = _[0],
                          w = _[1];
                        if (A.index = y[x][0], E.index = y[w][0], E.index !== A.index && !Zp(A, E, u) && !(16 !== A.number && 16 !== E.number && d < n || A.connectedTo(E))) {
                          var T = Np(A, E),
                            M = jp.get(S[A.index]) || qu(120);
                          if (!T.some(function (e) {
                            return Math.abs(M - e) > a;
                          })) {
                            if (3 === S[A.index]) {
                              var C = Lp(A, E);
                              if (void 0 !== C && l < C) return;
                            }
                            var k = Np(E, A),
                              P = jp.get(S[E.index]) || qu(120);
                            if (!k.some(function (e) {
                              return o < P - e;
                            })) {
                              if (3 === S[E.index]) {
                                var O = Lp(E, A);
                                if (void 0 !== O && s < O) return;
                              }
                              m.setBits(x, w);
                              var R,
                                I,
                                j,
                                N,
                                L = f ? 8 : (N = I = E, (R = A).isWater() && N.isWater() ? 9 : (j = I, R.isBackbone() && j.isBackbone() ? 10 : 4));
                              p.addContact(x, w, L);
                            }
                          }
                        }
                      }
                    }
                  });
                }, M = 0; M < w; ++M) T(M);
            }(e, s, n), function (e, t, n) {
              void 0 === n && (n = {});
              for (var r = wu(n.maxMetalDist, Yp.maxMetalDist), i = wu(n.masterModelIndex, Yp.masterModelIndex), o = t.features, a = t.spatialHash, s = t.contactStore, l = t.featureSet, u = o.types, c = o.centers, d = o.atomSets, h = c.x, f = c.y, p = c.z, m = u.length, g = e.getAtomProxy(), v = e.getAtomProxy(), y = function y(e) {
                  a.eachWithin(h[e], f[e], p[e], r, function (t, n) {
                    if (!(t <= e || (g.index = d[e][0], v.index = d[t][0], Zp(g, v, i)))) {
                      var r = g.isMetal(),
                        o = v.isMetal();
                      if (r || o) {
                        var a,
                          c,
                          h = r ? [u[e], u[t]] : [u[t], u[e]];
                        c = h[1], (12 === (a = h[0]) ? 11 === c || 12 === c : 13 === a ? 10 === c : void 0) && (l.setBits(e, t), s.addContact(e, t, 7));
                      }
                    }
                  });
                }, b = 0; b < m; ++b) y(b);
            }(e, s, n), function (e, t, n) {
              void 0 === n && (n = {});
              for (var r = wu(n.maxHydrophobicDist, Yp.maxHydrophobicDist), i = wu(n.masterModelIndex, Yp.masterModelIndex), o = t.features, a = t.spatialHash, s = t.contactStore, l = t.featureSet, u = o.types, c = o.centers, d = o.atomSets, h = c.x, f = c.y, p = c.z, m = u.length, g = e.getAtomProxy(), v = e.getAtomProxy(), y = function y(e) {
                  a.eachWithin(h[e], f[e], p[e], r, function (t, n) {
                    var r, o;
                    t <= e || (g.index = d[e][0], v.index = d[t][0], Zp(g, v, i) || 9 === g.number && 9 === v.number || g.connectedTo(v) || (r = u[e], o = u[t], 8 === r && 8 === o && (l.setBits(e, t), s.addContact(e, t, 6))));
                  });
                }, b = 0; b < m; ++b) y(b);
            }(e, s, n), function (e, t, n) {
              void 0 === n && (n = {});
              for (var r = wu(n.maxHalogenBondDist, Yp.maxHalogenBondDist), i = qu(wu(n.maxHalogenBondAngle, Yp.maxHalogenBondAngle)), o = wu(n.masterModelIndex, Yp.masterModelIndex), a = t.features, s = t.spatialHash, l = t.contactStore, u = t.featureSet, c = a.types, d = a.centers, h = a.atomSets, f = d.x, p = d.y, m = d.z, g = c.length, v = e.getAtomProxy(), y = e.getAtomProxy(), b = function b(e) {
                  s.eachWithin(f[e], p[e], m[e], r, function (t, n) {
                    if (!(t <= e) && (v.index = h[e][0], y.index = h[t][0], !Zp(v, y, o) && (r = c[e], a = c[t], 7 === r && 6 === a || 6 === r && 7 === a))) {
                      var r,
                        a,
                        s = 6 === c[e] ? [v, y] : [y, v],
                        d = s[0],
                        f = s[1],
                        p = Np(d, f);
                      if (1 === p.length && !(Wp - p[0] > i)) {
                        var m = Np(f, d);
                        0 !== m.length && (m.some(function (e) {
                          return i < $p - e;
                        }) || (u.setBits(e, t), l.addContact(e, t, 5)));
                      }
                    }
                  });
                }, _ = 0; _ < g; ++_) b(_);
            }(e, s, n);
            var l,
              u,
              c,
              d,
              h,
              f,
              p,
              m,
              g,
              v,
              y,
              b,
              _,
              x,
              w,
              S,
              A,
              E,
              T,
              M,
              C,
              k,
              P,
              O,
              R,
              I,
              j,
              N,
              L,
              D,
              B,
              F,
              z,
              U,
              G,
              V,
              H,
              q,
              W,
              $,
              X,
              Y,
              K,
              Z,
              Q,
              J,
              ee,
              te = (c = np({
                nodeArray1: (u = (l = s).contactStore).index1,
                nodeArray2: u.index2,
                edgeCount: u.count,
                nodeCount: l.featureSet.length
              }), d = new tp(l.contactStore.count, !0), Object.assign({
                adjacencyList: c,
                contactSet: d
              }, l));
            return function (e, n, r) {
              void 0 === r && (r = {}), t.Debug && Zc.time("refineLineOfSight");
              var i = wu(r.lineOfSightDistFactor, Yp.lineOfSightDistFactor),
                o = wu(r.masterModelIndex, Yp.masterModelIndex),
                a = e.spatialHash,
                s = n.contactSet,
                l = n.contactStore,
                u = n.features,
                c = l.index1,
                d = l.index2,
                h = u.centers,
                f = u.atomSets,
                p = h.x,
                m = h.y,
                g = h.z,
                v = e.getAtomProxy(),
                y = e.getAtomProxy(),
                b = e.getAtomProxy(),
                _ = new ae(),
                x = new ae(),
                w = 3 * i,
                S = i * i;
              s.forEach(function (e) {
                _.set(p[c[e]], m[c[e]], g[c[e]]), x.set(p[d[e]], m[d[e]], g[d[e]]);
                var n = (_.x + x.x) / 2,
                  r = (_.y + x.y) / 2,
                  i = (_.z + x.z) / 2,
                  l = f[c[e]],
                  u = f[d[e]];
                v.index = l[0], y.index = u[0], a.eachWithin(n, r, i, w, function (n, r) {
                  b.index = n, 1 !== b.number && b.vdw * b.vdw * S > r && !Xp(v, b, o) && !Xp(y, b, o) && !l.includes(n) && !u.includes(n) && 1 < _.distanceToSquared(b) && 1 < x.distanceToSquared(b) && (s.clear(e), t.Debug && Zc.log("removing", v.qualifiedName(), y.qualifiedName(), "because", b.qualifiedName()));
                });
              }), t.Debug && Zc.timeEnd("refineLineOfSight");
            }(e, te, n), h = e, p = (f = te).contactSet, m = f.contactStore, g = f.features, v = m.type, y = m.index1, b = m.index2, _ = g.atomSets, x = h.getAtomProxy(), w = h.getAtomProxy(), S = {}, A = function A(e, t, n) {
              var r = S[n] || [1 / 0, -1],
                i = r[0],
                o = r[1];
              e < i ? (-1 !== o && p.clear(o), S[n] = [e, t]) : p.clear(t);
            }, p.forEach(function (e) {
              if (6 === v[e]) {
                x.index = _[y[e]][0], w.index = _[b[e]][0];
                var t = x.distanceTo(w);
                A(t, e, x.index + "|" + w.residueIndex), A(t, e, w.index + "|" + x.residueIndex);
              }
            }), n.refineSaltBridges && (T = (E = te).contactSet, M = E.contactStore, C = E.features, k = M.type, P = M.index1, O = M.index2, R = C.atomSets, I = {}, j = function j(e, t) {
              I[e] || (I[e] = []), I[e].push(t);
            }, T.forEach(function (e) {
              1 === k[e] && (R[P[e]].forEach(function (t) {
                return j(t, e);
              }), R[O[e]].forEach(function (t) {
                return j(t, e);
              }));
            }), T.forEach(function (e) {
              if (4 === (t = k[e]) || 9 === t || 10 === t) {
                var t,
                  n = I[R[P[e]][0]],
                  r = I[R[O[e]][0]];
                if (n && r) for (var i = n.length, o = 0; o < i; ++o) if (r.includes(n[o])) return void T.clear(e);
              }
            })), L = (N = te).contactSet, D = N.contactStore, B = N.features, F = D.type, z = D.index1, U = D.index2, G = B.atomSets, V = {}, H = function H(e, t) {
              V[e] || (V[e] = []), V[e].push(t);
            }, L.forEach(function (e) {
              3 === F[e] && (G[z[e]].forEach(function (t) {
                return H(t, e);
              }), G[U[e]].forEach(function (t) {
                return H(t, e);
              }));
            }), L.forEach(function (e) {
              if (6 === F[e] || 2 === F[e]) {
                var t = V[G[z[e]][0]],
                  n = V[G[U[e]][0]];
                if (t && n) for (var r = t.length, i = 0; i < r; ++i) if (n.includes(t[i])) return void L.clear(e);
              }
            }), W = (q = te).contactSet, $ = q.contactStore, X = q.features, Y = $.type, K = $.index1, Z = $.index2, Q = X.atomSets, J = {}, ee = function ee(e, t) {
              J[e] || (J[e] = []), J[e].push(t);
            }, W.forEach(function (e) {
              1 === Y[e] && (Q[K[e]].forEach(function (t) {
                return ee(t, e);
              }), Q[Z[e]].forEach(function (t) {
                return ee(t, e);
              }));
            }), W.forEach(function (e) {
              if (7 === Y[e]) {
                var t = J[Q[K[e]][0]],
                  n = J[Q[Z[e]][0]];
                if (t && n) for (var r = t.length, i = 0; i < r; ++i) if (n.includes(t[i])) return void W.clear(t[i]);
              }
            }), t.Debug && Zc.timeEnd("calculateContacts"), te;
          }
          var Jp = {
              hydrogenBond: !0,
              hydrophobic: !0,
              halogenBond: !0,
              ionicInteraction: !0,
              metalCoordination: !0,
              cationPi: !0,
              piStacking: !0,
              weakHydrogenBond: !0,
              waterHydrogenBond: !0,
              backboneHydrogenBond: !0,
              radius: 1,
              filterSele: ""
            },
            em = new Fe(),
            tm = function tm(e) {
              this.array = e;
            },
            nm = {
              type: {
                configurable: !0
              },
              data: {
                configurable: !0
              }
            };
          nm.type.get = function () {
            return "";
          }, nm.data.get = function () {
            return {};
          }, tm.prototype.getIndex = function (e) {
            return this.array ? this.array[e] : e;
          }, tm.prototype.getObject = function (e) {
            return {};
          }, tm.prototype._applyTransformations = function (e, t, n) {
            return t && e.applyMatrix4(t.matrix), n && e.applyMatrix4(n.matrix), e;
          }, tm.prototype._getPosition = function (e) {
            return new ae();
          }, tm.prototype.getPosition = function (e, t, n) {
            return this._applyTransformations(this._getPosition(e), t, n);
          }, Object.defineProperties(tm.prototype, nm);
          var rm = function (e) {
              function t(t) {
                e.call(this), this.shape = t;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                },
                type: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {}, n.data.get = function () {
                return this.shape;
              }, n.type.get = function () {
                return this.primitive.type;
              }, t.prototype.getObject = function (e) {
                return this.primitive.objectFromShape(this.shape, this.getIndex(e));
              }, t.prototype._getPosition = function (e) {
                return this.primitive.positionFromShape(this.shape, this.getIndex(e));
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            im = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Vf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            om = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Hf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            am = function (e) {
              function t(t, n) {
                e.call(this, t), this.structure = n;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "atom";
              }, n.data.get = function () {
                return this.structure;
              }, t.prototype.getObject = function (e) {
                return this.structure.getAtomProxy(this.getIndex(e));
              }, t.prototype._getPosition = function (e) {
                return new ae().copy(this.getObject(e));
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            sm = function (e) {
              function t(t) {
                e.call(this), this.axes = t;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "axes";
              }, n.data.get = function () {
                return this.axes;
              }, t.prototype.getObject = function () {
                return {
                  axes: this.axes
                };
              }, t.prototype._getPosition = function () {
                return this.axes.center.clone();
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            lm = function (e) {
              function t(t, n, r) {
                e.call(this, t), this.structure = n, this.bondStore = r || n.bondStore;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "bond";
              }, n.data.get = function () {
                return this.structure;
              }, t.prototype.getObject = function (e) {
                var t = this.structure.getBondProxy(this.getIndex(e));
                return t.bondStore = this.bondStore, t;
              }, t.prototype._getPosition = function (e) {
                var t = this.getObject(e);
                return new ae().copy(t.atom1).add(t.atom2).multiplyScalar(.5);
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            um = function (e) {
              function t(t, n, r) {
                e.call(this, t), this.contacts = n, this.structure = r;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "contact";
              }, n.data.get = function () {
                return this.contacts;
              }, t.prototype.getObject = function (e) {
                var t = this.getIndex(e),
                  n = this.contacts,
                  r = n.features,
                  i = n.contactStore,
                  o = r.centers,
                  a = r.atomSets,
                  s = o.x,
                  l = o.y,
                  u = o.z,
                  c = i.index1,
                  d = i.index2,
                  h = i.type,
                  f = c[t],
                  p = d[t];
                return {
                  center1: new ae(s[f], l[f], u[f]),
                  center2: new ae(s[p], l[p], u[p]),
                  atom1: this.structure.getAtomProxy(a[f][0]),
                  atom2: this.structure.getAtomProxy(a[p][0]),
                  type: function (e) {
                    switch (e) {
                      case 4:
                      case 9:
                      case 10:
                        return "hydrogen bond";
                      case 6:
                        return "hydrophobic contact";
                      case 5:
                        return "halogen bond";
                      case 1:
                        return "ionic interaction";
                      case 7:
                        return "metal coordination";
                      case 2:
                        return "cation-pi interaction";
                      case 3:
                        return "pi-pi stacking";
                      case 8:
                        return "weak hydrogen bond";
                      default:
                        return "unknown contact";
                    }
                  }(h[t])
                };
              }, t.prototype._getPosition = function (e) {
                var t = this.getObject(e),
                  n = t.center1,
                  r = t.center2;
                return new ae().addVectors(n, r).multiplyScalar(.5);
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            cm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return qf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            dm = function (e) {
              function t(t, n, r) {
                e.call(this, t), this.validation = n, this.structure = r;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "clash";
              }, n.data.get = function () {
                return this.validation;
              }, t.prototype.getObject = function (e) {
                var t = this.validation,
                  n = this.getIndex(e);
                return {
                  validation: t,
                  index: n,
                  clash: t.clashArray[n]
                };
              }, t.prototype._getAtomProxyFromSele = function (e) {
                var t = new Nc(e),
                  n = this.structure.getAtomIndices(t)[0];
                return this.structure.getAtomProxy(n);
              }, t.prototype._getPosition = function (e) {
                var t = this.getObject(e).clash,
                  n = this._getAtomProxyFromSele(t.sele1),
                  r = this._getAtomProxyFromSele(t.sele2);
                return new ae().copy(n).add(r).multiplyScalar(.5);
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            hm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "distance";
              }, Object.defineProperties(t.prototype, n), t;
            }(lm),
            fm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Wf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            pm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Uf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            mm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return zf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            gm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "ignore";
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            vm = function (e) {
              function t(t, n) {
                e.call(this, t), this.mesh = n;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "mesh";
              }, t.prototype.getObject = function () {
                var e = this.mesh;
                return {
                  shape: this.shape,
                  name: e.name,
                  serial: e.serial
                };
              }, t.prototype._getPosition = function () {
                return this.__position || (this.__position = df(this.mesh.position)), this.__position;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            ym = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Ff;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            bm = function (e) {
              function t(t, n) {
                e.call(this, t), this.surface = n;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "surface";
              }, n.data.get = function () {
                return this.surface;
              }, t.prototype.getObject = function (e) {
                return {
                  surface: this.surface,
                  index: this.getIndex(e)
                };
              }, t.prototype._getPosition = function () {
                return this.surface.center.clone();
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            _m = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Gf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            xm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return $f;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            wm = function (e) {
              function t(t, n) {
                e.call(this), this.unitcell = t, this.structure = n;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "unitcell";
              }, n.data.get = function () {
                return this.unitcell;
              }, t.prototype.getObject = function () {
                return {
                  unitcell: this.unitcell,
                  structure: this.structure
                };
              }, t.prototype._getPosition = function () {
                return this.unitcell.getCenter(this.structure);
              }, Object.defineProperties(t.prototype, n), t;
            }(tm),
            Sm = (function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              n.type.get = function () {
                return "unknown";
              }, Object.defineProperties(t.prototype, n);
            }(tm), function (e) {
              function t(t, n) {
                e.call(this, t), this.volume = n;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                data: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "volume";
              }, n.data.get = function () {
                return this.volume;
              }, t.prototype.getObject = function (e) {
                var t = this.volume,
                  n = this.getIndex(e);
                return {
                  volume: t,
                  index: n,
                  value: t.data[n]
                };
              }, t.prototype._getPosition = function (e) {
                var t = this.volume.position,
                  n = this.getIndex(e);
                return new ae(t[3 * n], t[3 * n + 1], t[3 * n + 2]);
              }, Object.defineProperties(t.prototype, n), t;
            }(tm)),
            Am = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "slice";
              }, Object.defineProperties(t.prototype, n), t;
            }(Sm),
            Em = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Yf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm),
            Tm = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                primitive: {
                  configurable: !0
                }
              };
              return n.primitive.get = function () {
                return Kf;
              }, Object.defineProperties(t.prototype, n), t;
            }(rm);
          function Mm() {
            return new Uint32Array([0, 265, 515, 778, 1030, 1295, 1541, 1804, 2060, 2309, 2575, 2822, 3082, 3331, 3593, 3840, 400, 153, 915, 666, 1430, 1183, 1941, 1692, 2460, 2197, 2975, 2710, 3482, 3219, 3993, 3728, 560, 825, 51, 314, 1590, 1855, 1077, 1340, 2620, 2869, 2111, 2358, 3642, 3891, 3129, 3376, 928, 681, 419, 170, 1958, 1711, 1445, 1196, 2988, 2725, 2479, 2214, 4010, 3747, 3497, 3232, 1120, 1385, 1635, 1898, 102, 367, 613, 876, 3180, 3429, 3695, 3942, 2154, 2403, 2665, 2912, 1520, 1273, 2035, 1786, 502, 255, 1013, 764, 3580, 3317, 4095, 3830, 2554, 2291, 3065, 2800, 1616, 1881, 1107, 1370, 598, 863, 85, 348, 3676, 3925, 3167, 3414, 2650, 2899, 2137, 2384, 1984, 1737, 1475, 1226, 966, 719, 453, 204, 4044, 3781, 3535, 3270, 3018, 2755, 2505, 2240, 2240, 2505, 2755, 3018, 3270, 3535, 3781, 4044, 204, 453, 719, 966, 1226, 1475, 1737, 1984, 2384, 2137, 2899, 2650, 3414, 3167, 3925, 3676, 348, 85, 863, 598, 1370, 1107, 1881, 1616, 2800, 3065, 2291, 2554, 3830, 4095, 3317, 3580, 764, 1013, 255, 502, 1786, 2035, 1273, 1520, 2912, 2665, 2403, 2154, 3942, 3695, 3429, 3180, 876, 613, 367, 102, 1898, 1635, 1385, 1120, 3232, 3497, 3747, 4010, 2214, 2479, 2725, 2988, 1196, 1445, 1711, 1958, 170, 419, 681, 928, 3376, 3129, 3891, 3642, 2358, 2111, 2869, 2620, 1340, 1077, 1855, 1590, 314, 51, 825, 560, 3728, 3993, 3219, 3482, 2710, 2975, 2197, 2460, 1692, 1941, 1183, 1430, 666, 915, 153, 400, 3840, 3593, 3331, 3082, 2822, 2575, 2309, 2060, 1804, 1541, 1295, 1030, 778, 515, 265, 0]);
          }
          function Cm() {
            return new Int32Array([-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 8, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 1, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 8, 3, 9, 8, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 2, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 8, 3, 1, 2, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 2, 10, 0, 2, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 2, 8, 3, 2, 10, 8, 10, 9, 8, -1, -1, -1, -1, -1, -1, -1, 3, 11, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 11, 2, 8, 11, 0, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 9, 0, 2, 3, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 11, 2, 1, 9, 11, 9, 8, 11, -1, -1, -1, -1, -1, -1, -1, 3, 10, 1, 11, 10, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 10, 1, 0, 8, 10, 8, 11, 10, -1, -1, -1, -1, -1, -1, -1, 3, 9, 0, 3, 11, 9, 11, 10, 9, -1, -1, -1, -1, -1, -1, -1, 9, 8, 10, 10, 8, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 7, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 3, 0, 7, 3, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 1, 9, 8, 4, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 1, 9, 4, 7, 1, 7, 3, 1, -1, -1, -1, -1, -1, -1, -1, 1, 2, 10, 8, 4, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3, 4, 7, 3, 0, 4, 1, 2, 10, -1, -1, -1, -1, -1, -1, -1, 9, 2, 10, 9, 0, 2, 8, 4, 7, -1, -1, -1, -1, -1, -1, -1, 2, 10, 9, 2, 9, 7, 2, 7, 3, 7, 9, 4, -1, -1, -1, -1, 8, 4, 7, 3, 11, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 11, 4, 7, 11, 2, 4, 2, 0, 4, -1, -1, -1, -1, -1, -1, -1, 9, 0, 1, 8, 4, 7, 2, 3, 11, -1, -1, -1, -1, -1, -1, -1, 4, 7, 11, 9, 4, 11, 9, 11, 2, 9, 2, 1, -1, -1, -1, -1, 3, 10, 1, 3, 11, 10, 7, 8, 4, -1, -1, -1, -1, -1, -1, -1, 1, 11, 10, 1, 4, 11, 1, 0, 4, 7, 11, 4, -1, -1, -1, -1, 4, 7, 8, 9, 0, 11, 9, 11, 10, 11, 0, 3, -1, -1, -1, -1, 4, 7, 11, 4, 11, 9, 9, 11, 10, -1, -1, -1, -1, -1, -1, -1, 9, 5, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 5, 4, 0, 8, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 5, 4, 1, 5, 0, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 8, 5, 4, 8, 3, 5, 3, 1, 5, -1, -1, -1, -1, -1, -1, -1, 1, 2, 10, 9, 5, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3, 0, 8, 1, 2, 10, 4, 9, 5, -1, -1, -1, -1, -1, -1, -1, 5, 2, 10, 5, 4, 2, 4, 0, 2, -1, -1, -1, -1, -1, -1, -1, 2, 10, 5, 3, 2, 5, 3, 5, 4, 3, 4, 8, -1, -1, -1, -1, 9, 5, 4, 2, 3, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 11, 2, 0, 8, 11, 4, 9, 5, -1, -1, -1, -1, -1, -1, -1, 0, 5, 4, 0, 1, 5, 2, 3, 11, -1, -1, -1, -1, -1, -1, -1, 2, 1, 5, 2, 5, 8, 2, 8, 11, 4, 8, 5, -1, -1, -1, -1, 10, 3, 11, 10, 1, 3, 9, 5, 4, -1, -1, -1, -1, -1, -1, -1, 4, 9, 5, 0, 8, 1, 8, 10, 1, 8, 11, 10, -1, -1, -1, -1, 5, 4, 0, 5, 0, 11, 5, 11, 10, 11, 0, 3, -1, -1, -1, -1, 5, 4, 8, 5, 8, 10, 10, 8, 11, -1, -1, -1, -1, -1, -1, -1, 9, 7, 8, 5, 7, 9, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 3, 0, 9, 5, 3, 5, 7, 3, -1, -1, -1, -1, -1, -1, -1, 0, 7, 8, 0, 1, 7, 1, 5, 7, -1, -1, -1, -1, -1, -1, -1, 1, 5, 3, 3, 5, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 7, 8, 9, 5, 7, 10, 1, 2, -1, -1, -1, -1, -1, -1, -1, 10, 1, 2, 9, 5, 0, 5, 3, 0, 5, 7, 3, -1, -1, -1, -1, 8, 0, 2, 8, 2, 5, 8, 5, 7, 10, 5, 2, -1, -1, -1, -1, 2, 10, 5, 2, 5, 3, 3, 5, 7, -1, -1, -1, -1, -1, -1, -1, 7, 9, 5, 7, 8, 9, 3, 11, 2, -1, -1, -1, -1, -1, -1, -1, 9, 5, 7, 9, 7, 2, 9, 2, 0, 2, 7, 11, -1, -1, -1, -1, 2, 3, 11, 0, 1, 8, 1, 7, 8, 1, 5, 7, -1, -1, -1, -1, 11, 2, 1, 11, 1, 7, 7, 1, 5, -1, -1, -1, -1, -1, -1, -1, 9, 5, 8, 8, 5, 7, 10, 1, 3, 10, 3, 11, -1, -1, -1, -1, 5, 7, 0, 5, 0, 9, 7, 11, 0, 1, 0, 10, 11, 10, 0, -1, 11, 10, 0, 11, 0, 3, 10, 5, 0, 8, 0, 7, 5, 7, 0, -1, 11, 10, 5, 7, 11, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 10, 6, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 8, 3, 5, 10, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 0, 1, 5, 10, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 8, 3, 1, 9, 8, 5, 10, 6, -1, -1, -1, -1, -1, -1, -1, 1, 6, 5, 2, 6, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 6, 5, 1, 2, 6, 3, 0, 8, -1, -1, -1, -1, -1, -1, -1, 9, 6, 5, 9, 0, 6, 0, 2, 6, -1, -1, -1, -1, -1, -1, -1, 5, 9, 8, 5, 8, 2, 5, 2, 6, 3, 2, 8, -1, -1, -1, -1, 2, 3, 11, 10, 6, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 11, 0, 8, 11, 2, 0, 10, 6, 5, -1, -1, -1, -1, -1, -1, -1, 0, 1, 9, 2, 3, 11, 5, 10, 6, -1, -1, -1, -1, -1, -1, -1, 5, 10, 6, 1, 9, 2, 9, 11, 2, 9, 8, 11, -1, -1, -1, -1, 6, 3, 11, 6, 5, 3, 5, 1, 3, -1, -1, -1, -1, -1, -1, -1, 0, 8, 11, 0, 11, 5, 0, 5, 1, 5, 11, 6, -1, -1, -1, -1, 3, 11, 6, 0, 3, 6, 0, 6, 5, 0, 5, 9, -1, -1, -1, -1, 6, 5, 9, 6, 9, 11, 11, 9, 8, -1, -1, -1, -1, -1, -1, -1, 5, 10, 6, 4, 7, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 3, 0, 4, 7, 3, 6, 5, 10, -1, -1, -1, -1, -1, -1, -1, 1, 9, 0, 5, 10, 6, 8, 4, 7, -1, -1, -1, -1, -1, -1, -1, 10, 6, 5, 1, 9, 7, 1, 7, 3, 7, 9, 4, -1, -1, -1, -1, 6, 1, 2, 6, 5, 1, 4, 7, 8, -1, -1, -1, -1, -1, -1, -1, 1, 2, 5, 5, 2, 6, 3, 0, 4, 3, 4, 7, -1, -1, -1, -1, 8, 4, 7, 9, 0, 5, 0, 6, 5, 0, 2, 6, -1, -1, -1, -1, 7, 3, 9, 7, 9, 4, 3, 2, 9, 5, 9, 6, 2, 6, 9, -1, 3, 11, 2, 7, 8, 4, 10, 6, 5, -1, -1, -1, -1, -1, -1, -1, 5, 10, 6, 4, 7, 2, 4, 2, 0, 2, 7, 11, -1, -1, -1, -1, 0, 1, 9, 4, 7, 8, 2, 3, 11, 5, 10, 6, -1, -1, -1, -1, 9, 2, 1, 9, 11, 2, 9, 4, 11, 7, 11, 4, 5, 10, 6, -1, 8, 4, 7, 3, 11, 5, 3, 5, 1, 5, 11, 6, -1, -1, -1, -1, 5, 1, 11, 5, 11, 6, 1, 0, 11, 7, 11, 4, 0, 4, 11, -1, 0, 5, 9, 0, 6, 5, 0, 3, 6, 11, 6, 3, 8, 4, 7, -1, 6, 5, 9, 6, 9, 11, 4, 7, 9, 7, 11, 9, -1, -1, -1, -1, 10, 4, 9, 6, 4, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 10, 6, 4, 9, 10, 0, 8, 3, -1, -1, -1, -1, -1, -1, -1, 10, 0, 1, 10, 6, 0, 6, 4, 0, -1, -1, -1, -1, -1, -1, -1, 8, 3, 1, 8, 1, 6, 8, 6, 4, 6, 1, 10, -1, -1, -1, -1, 1, 4, 9, 1, 2, 4, 2, 6, 4, -1, -1, -1, -1, -1, -1, -1, 3, 0, 8, 1, 2, 9, 2, 4, 9, 2, 6, 4, -1, -1, -1, -1, 0, 2, 4, 4, 2, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 8, 3, 2, 8, 2, 4, 4, 2, 6, -1, -1, -1, -1, -1, -1, -1, 10, 4, 9, 10, 6, 4, 11, 2, 3, -1, -1, -1, -1, -1, -1, -1, 0, 8, 2, 2, 8, 11, 4, 9, 10, 4, 10, 6, -1, -1, -1, -1, 3, 11, 2, 0, 1, 6, 0, 6, 4, 6, 1, 10, -1, -1, -1, -1, 6, 4, 1, 6, 1, 10, 4, 8, 1, 2, 1, 11, 8, 11, 1, -1, 9, 6, 4, 9, 3, 6, 9, 1, 3, 11, 6, 3, -1, -1, -1, -1, 8, 11, 1, 8, 1, 0, 11, 6, 1, 9, 1, 4, 6, 4, 1, -1, 3, 11, 6, 3, 6, 0, 0, 6, 4, -1, -1, -1, -1, -1, -1, -1, 6, 4, 8, 11, 6, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, 10, 6, 7, 8, 10, 8, 9, 10, -1, -1, -1, -1, -1, -1, -1, 0, 7, 3, 0, 10, 7, 0, 9, 10, 6, 7, 10, -1, -1, -1, -1, 10, 6, 7, 1, 10, 7, 1, 7, 8, 1, 8, 0, -1, -1, -1, -1, 10, 6, 7, 10, 7, 1, 1, 7, 3, -1, -1, -1, -1, -1, -1, -1, 1, 2, 6, 1, 6, 8, 1, 8, 9, 8, 6, 7, -1, -1, -1, -1, 2, 6, 9, 2, 9, 1, 6, 7, 9, 0, 9, 3, 7, 3, 9, -1, 7, 8, 0, 7, 0, 6, 6, 0, 2, -1, -1, -1, -1, -1, -1, -1, 7, 3, 2, 6, 7, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 2, 3, 11, 10, 6, 8, 10, 8, 9, 8, 6, 7, -1, -1, -1, -1, 2, 0, 7, 2, 7, 11, 0, 9, 7, 6, 7, 10, 9, 10, 7, -1, 1, 8, 0, 1, 7, 8, 1, 10, 7, 6, 7, 10, 2, 3, 11, -1, 11, 2, 1, 11, 1, 7, 10, 6, 1, 6, 7, 1, -1, -1, -1, -1, 8, 9, 6, 8, 6, 7, 9, 1, 6, 11, 6, 3, 1, 3, 6, -1, 0, 9, 1, 11, 6, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, 8, 0, 7, 0, 6, 3, 11, 0, 11, 6, 0, -1, -1, -1, -1, 7, 11, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, 6, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3, 0, 8, 11, 7, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 1, 9, 11, 7, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 8, 1, 9, 8, 3, 1, 11, 7, 6, -1, -1, -1, -1, -1, -1, -1, 10, 1, 2, 6, 11, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 2, 10, 3, 0, 8, 6, 11, 7, -1, -1, -1, -1, -1, -1, -1, 2, 9, 0, 2, 10, 9, 6, 11, 7, -1, -1, -1, -1, -1, -1, -1, 6, 11, 7, 2, 10, 3, 10, 8, 3, 10, 9, 8, -1, -1, -1, -1, 7, 2, 3, 6, 2, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 7, 0, 8, 7, 6, 0, 6, 2, 0, -1, -1, -1, -1, -1, -1, -1, 2, 7, 6, 2, 3, 7, 0, 1, 9, -1, -1, -1, -1, -1, -1, -1, 1, 6, 2, 1, 8, 6, 1, 9, 8, 8, 7, 6, -1, -1, -1, -1, 10, 7, 6, 10, 1, 7, 1, 3, 7, -1, -1, -1, -1, -1, -1, -1, 10, 7, 6, 1, 7, 10, 1, 8, 7, 1, 0, 8, -1, -1, -1, -1, 0, 3, 7, 0, 7, 10, 0, 10, 9, 6, 10, 7, -1, -1, -1, -1, 7, 6, 10, 7, 10, 8, 8, 10, 9, -1, -1, -1, -1, -1, -1, -1, 6, 8, 4, 11, 8, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3, 6, 11, 3, 0, 6, 0, 4, 6, -1, -1, -1, -1, -1, -1, -1, 8, 6, 11, 8, 4, 6, 9, 0, 1, -1, -1, -1, -1, -1, -1, -1, 9, 4, 6, 9, 6, 3, 9, 3, 1, 11, 3, 6, -1, -1, -1, -1, 6, 8, 4, 6, 11, 8, 2, 10, 1, -1, -1, -1, -1, -1, -1, -1, 1, 2, 10, 3, 0, 11, 0, 6, 11, 0, 4, 6, -1, -1, -1, -1, 4, 11, 8, 4, 6, 11, 0, 2, 9, 2, 10, 9, -1, -1, -1, -1, 10, 9, 3, 10, 3, 2, 9, 4, 3, 11, 3, 6, 4, 6, 3, -1, 8, 2, 3, 8, 4, 2, 4, 6, 2, -1, -1, -1, -1, -1, -1, -1, 0, 4, 2, 4, 6, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 9, 0, 2, 3, 4, 2, 4, 6, 4, 3, 8, -1, -1, -1, -1, 1, 9, 4, 1, 4, 2, 2, 4, 6, -1, -1, -1, -1, -1, -1, -1, 8, 1, 3, 8, 6, 1, 8, 4, 6, 6, 10, 1, -1, -1, -1, -1, 10, 1, 0, 10, 0, 6, 6, 0, 4, -1, -1, -1, -1, -1, -1, -1, 4, 6, 3, 4, 3, 8, 6, 10, 3, 0, 3, 9, 10, 9, 3, -1, 10, 9, 4, 6, 10, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 9, 5, 7, 6, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 8, 3, 4, 9, 5, 11, 7, 6, -1, -1, -1, -1, -1, -1, -1, 5, 0, 1, 5, 4, 0, 7, 6, 11, -1, -1, -1, -1, -1, -1, -1, 11, 7, 6, 8, 3, 4, 3, 5, 4, 3, 1, 5, -1, -1, -1, -1, 9, 5, 4, 10, 1, 2, 7, 6, 11, -1, -1, -1, -1, -1, -1, -1, 6, 11, 7, 1, 2, 10, 0, 8, 3, 4, 9, 5, -1, -1, -1, -1, 7, 6, 11, 5, 4, 10, 4, 2, 10, 4, 0, 2, -1, -1, -1, -1, 3, 4, 8, 3, 5, 4, 3, 2, 5, 10, 5, 2, 11, 7, 6, -1, 7, 2, 3, 7, 6, 2, 5, 4, 9, -1, -1, -1, -1, -1, -1, -1, 9, 5, 4, 0, 8, 6, 0, 6, 2, 6, 8, 7, -1, -1, -1, -1, 3, 6, 2, 3, 7, 6, 1, 5, 0, 5, 4, 0, -1, -1, -1, -1, 6, 2, 8, 6, 8, 7, 2, 1, 8, 4, 8, 5, 1, 5, 8, -1, 9, 5, 4, 10, 1, 6, 1, 7, 6, 1, 3, 7, -1, -1, -1, -1, 1, 6, 10, 1, 7, 6, 1, 0, 7, 8, 7, 0, 9, 5, 4, -1, 4, 0, 10, 4, 10, 5, 0, 3, 10, 6, 10, 7, 3, 7, 10, -1, 7, 6, 10, 7, 10, 8, 5, 4, 10, 4, 8, 10, -1, -1, -1, -1, 6, 9, 5, 6, 11, 9, 11, 8, 9, -1, -1, -1, -1, -1, -1, -1, 3, 6, 11, 0, 6, 3, 0, 5, 6, 0, 9, 5, -1, -1, -1, -1, 0, 11, 8, 0, 5, 11, 0, 1, 5, 5, 6, 11, -1, -1, -1, -1, 6, 11, 3, 6, 3, 5, 5, 3, 1, -1, -1, -1, -1, -1, -1, -1, 1, 2, 10, 9, 5, 11, 9, 11, 8, 11, 5, 6, -1, -1, -1, -1, 0, 11, 3, 0, 6, 11, 0, 9, 6, 5, 6, 9, 1, 2, 10, -1, 11, 8, 5, 11, 5, 6, 8, 0, 5, 10, 5, 2, 0, 2, 5, -1, 6, 11, 3, 6, 3, 5, 2, 10, 3, 10, 5, 3, -1, -1, -1, -1, 5, 8, 9, 5, 2, 8, 5, 6, 2, 3, 8, 2, -1, -1, -1, -1, 9, 5, 6, 9, 6, 0, 0, 6, 2, -1, -1, -1, -1, -1, -1, -1, 1, 5, 8, 1, 8, 0, 5, 6, 8, 3, 8, 2, 6, 2, 8, -1, 1, 5, 6, 2, 1, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 3, 6, 1, 6, 10, 3, 8, 6, 5, 6, 9, 8, 9, 6, -1, 10, 1, 0, 10, 0, 6, 9, 5, 0, 5, 6, 0, -1, -1, -1, -1, 0, 3, 8, 5, 6, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 10, 5, 6, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 11, 5, 10, 7, 5, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 11, 5, 10, 11, 7, 5, 8, 3, 0, -1, -1, -1, -1, -1, -1, -1, 5, 11, 7, 5, 10, 11, 1, 9, 0, -1, -1, -1, -1, -1, -1, -1, 10, 7, 5, 10, 11, 7, 9, 8, 1, 8, 3, 1, -1, -1, -1, -1, 11, 1, 2, 11, 7, 1, 7, 5, 1, -1, -1, -1, -1, -1, -1, -1, 0, 8, 3, 1, 2, 7, 1, 7, 5, 7, 2, 11, -1, -1, -1, -1, 9, 7, 5, 9, 2, 7, 9, 0, 2, 2, 11, 7, -1, -1, -1, -1, 7, 5, 2, 7, 2, 11, 5, 9, 2, 3, 2, 8, 9, 8, 2, -1, 2, 5, 10, 2, 3, 5, 3, 7, 5, -1, -1, -1, -1, -1, -1, -1, 8, 2, 0, 8, 5, 2, 8, 7, 5, 10, 2, 5, -1, -1, -1, -1, 9, 0, 1, 5, 10, 3, 5, 3, 7, 3, 10, 2, -1, -1, -1, -1, 9, 8, 2, 9, 2, 1, 8, 7, 2, 10, 2, 5, 7, 5, 2, -1, 1, 3, 5, 3, 7, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 8, 7, 0, 7, 1, 1, 7, 5, -1, -1, -1, -1, -1, -1, -1, 9, 0, 3, 9, 3, 5, 5, 3, 7, -1, -1, -1, -1, -1, -1, -1, 9, 8, 7, 5, 9, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 5, 8, 4, 5, 10, 8, 10, 11, 8, -1, -1, -1, -1, -1, -1, -1, 5, 0, 4, 5, 11, 0, 5, 10, 11, 11, 3, 0, -1, -1, -1, -1, 0, 1, 9, 8, 4, 10, 8, 10, 11, 10, 4, 5, -1, -1, -1, -1, 10, 11, 4, 10, 4, 5, 11, 3, 4, 9, 4, 1, 3, 1, 4, -1, 2, 5, 1, 2, 8, 5, 2, 11, 8, 4, 5, 8, -1, -1, -1, -1, 0, 4, 11, 0, 11, 3, 4, 5, 11, 2, 11, 1, 5, 1, 11, -1, 0, 2, 5, 0, 5, 9, 2, 11, 5, 4, 5, 8, 11, 8, 5, -1, 9, 4, 5, 2, 11, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 2, 5, 10, 3, 5, 2, 3, 4, 5, 3, 8, 4, -1, -1, -1, -1, 5, 10, 2, 5, 2, 4, 4, 2, 0, -1, -1, -1, -1, -1, -1, -1, 3, 10, 2, 3, 5, 10, 3, 8, 5, 4, 5, 8, 0, 1, 9, -1, 5, 10, 2, 5, 2, 4, 1, 9, 2, 9, 4, 2, -1, -1, -1, -1, 8, 4, 5, 8, 5, 3, 3, 5, 1, -1, -1, -1, -1, -1, -1, -1, 0, 4, 5, 1, 0, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 8, 4, 5, 8, 5, 3, 9, 0, 5, 0, 3, 5, -1, -1, -1, -1, 9, 4, 5, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 11, 7, 4, 9, 11, 9, 10, 11, -1, -1, -1, -1, -1, -1, -1, 0, 8, 3, 4, 9, 7, 9, 11, 7, 9, 10, 11, -1, -1, -1, -1, 1, 10, 11, 1, 11, 4, 1, 4, 0, 7, 4, 11, -1, -1, -1, -1, 3, 1, 4, 3, 4, 8, 1, 10, 4, 7, 4, 11, 10, 11, 4, -1, 4, 11, 7, 9, 11, 4, 9, 2, 11, 9, 1, 2, -1, -1, -1, -1, 9, 7, 4, 9, 11, 7, 9, 1, 11, 2, 11, 1, 0, 8, 3, -1, 11, 7, 4, 11, 4, 2, 2, 4, 0, -1, -1, -1, -1, -1, -1, -1, 11, 7, 4, 11, 4, 2, 8, 3, 4, 3, 2, 4, -1, -1, -1, -1, 2, 9, 10, 2, 7, 9, 2, 3, 7, 7, 4, 9, -1, -1, -1, -1, 9, 10, 7, 9, 7, 4, 10, 2, 7, 8, 7, 0, 2, 0, 7, -1, 3, 7, 10, 3, 10, 2, 7, 4, 10, 1, 10, 0, 4, 0, 10, -1, 1, 10, 2, 8, 7, 4, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 9, 1, 4, 1, 7, 7, 1, 3, -1, -1, -1, -1, -1, -1, -1, 4, 9, 1, 4, 1, 7, 0, 8, 1, 8, 7, 1, -1, -1, -1, -1, 4, 0, 3, 7, 4, 3, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 4, 8, 7, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 9, 10, 8, 10, 11, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3, 0, 9, 3, 9, 11, 11, 9, 10, -1, -1, -1, -1, -1, -1, -1, 0, 1, 10, 0, 10, 8, 8, 10, 11, -1, -1, -1, -1, -1, -1, -1, 3, 1, 10, 11, 3, 10, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 2, 11, 1, 11, 9, 9, 11, 8, -1, -1, -1, -1, -1, -1, -1, 3, 0, 9, 3, 9, 11, 1, 2, 9, 2, 11, 9, -1, -1, -1, -1, 0, 2, 11, 8, 0, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 3, 2, 11, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 2, 3, 8, 2, 8, 10, 10, 8, 9, -1, -1, -1, -1, -1, -1, -1, 9, 10, 2, 0, 9, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 2, 3, 8, 2, 8, 10, 0, 1, 8, 1, 10, 8, -1, -1, -1, -1, 1, 10, 2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 3, 8, 9, 1, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 9, 1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0, 3, 8, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]);
          }
          function km(e, t, n, r, i) {
            var o,
              a,
              s,
              l,
              u,
              c,
              d,
              h = 0,
              f = !1,
              p = !1,
              m = !1,
              g = t * n * r,
              v = t,
              y = t * n,
              b = new Int32Array(12),
              _ = [],
              x = [],
              w = [],
              S = [],
              A = Mm(),
              E = Cm(),
              T = [[0, 4, 4, 4, 2, 0, 0, 0, 2, 2, 0, 0], [4, 0, 4, 4, 0, 8, 0, 0, 0, 8, 8, 0], [4, 4, 0, 4, 0, 0, 8, 0, 0, 0, 8, 8], [4, 4, 4, 0, 0, 0, 0, 1, 1, 0, 0, 1], [2, 0, 0, 0, 0, 8, 8, 8, 2, 2, 0, 0], [0, 8, 0, 0, 8, 0, 8, 8, 0, 8, 8, 0], [0, 0, 8, 0, 8, 8, 0, 8, 0, 0, 8, 8], [0, 0, 0, 1, 8, 8, 8, 0, 1, 0, 0, 1], [2, 0, 0, 1, 2, 0, 0, 1, 0, 2, 0, 1], [2, 8, 0, 0, 2, 8, 0, 0, 2, 0, 8, 0], [0, 8, 8, 0, 0, 8, 8, 0, 0, 8, 0, 8], [0, 0, 8, 1, 0, 0, 8, 1, 1, 0, 8, 0]];
            function M(e, t, n) {
              return e + (t - e) * n;
            }
            function C(e, i, o) {
              return y * (o = (o + d) % r) + v * (i = (i + c) % n) + (e + u) % t;
            }
            function k(e, t, n, r, l, u, c) {
              var d = 3 * e;
              if (a[d] < 0) {
                var p = (h - u) / (c - u),
                  m = o,
                  g = 3 * s;
                if (_[g + 0] = n + p, _[g + 1] = r, _[g + 2] = l, !f) {
                  var v = 3 * e;
                  x[g] = -M(m[v], m[v + 3], p), x[g + 1] = -M(m[v + 1], m[v + 4], p), x[g + 2] = -M(m[v + 2], m[v + 5], p);
                }
                i && (S[s] = i[e + Math.round(p)]), a[d] = s, b[t] = s, s += 1;
              } else b[t] = a[d];
            }
            function P(e, t, n, r, l, u, c) {
              var d = 3 * e + 1;
              if (a[d] < 0) {
                var p = (h - u) / (c - u),
                  m = o,
                  g = 3 * s;
                if (_[g] = n, _[g + 1] = r + p, _[g + 2] = l, !f) {
                  var y = 3 * e,
                    w = y + 3 * v;
                  x[g] = -M(m[y], m[w], p), x[g + 1] = -M(m[y + 1], m[w + 1], p), x[g + 2] = -M(m[y + 2], m[w + 2], p);
                }
                i && (S[s] = i[e + Math.round(p) * v]), a[d] = s, b[t] = s, s += 1;
              } else b[t] = a[d];
            }
            function O(e, t, n, r, l, u, c) {
              var d = 3 * e + 2;
              if (a[d] < 0) {
                var p = (h - u) / (c - u),
                  m = o,
                  g = 3 * s;
                if (_[g] = n, _[g + 1] = r, _[g + 2] = l + p, !f) {
                  var v = 3 * e,
                    w = v + 3 * y;
                  x[g] = -M(m[v], m[w], p), x[g + 1] = -M(m[v + 1], m[w + 1], p), x[g + 2] = -M(m[v + 2], m[w + 2], p);
                }
                i && (S[s] = i[e + Math.round(p) * y]), a[d] = s, b[t] = s, s += 1;
              } else b[t] = a[d];
            }
            function R(t) {
              var n = 3 * t;
              0 === o[n] && (o[n] = e[(t - 1 + g) % g] - e[(t + 1) % g], o[n + 1] = e[(t - v + g) % g] - e[(t + v) % g], o[n + 2] = e[(t - y + g) % g] - e[(t + y) % g]);
            }
            function I(t, n, r, i, o) {
              var a, s, u, c, d, g, _;
              m ? (i = C(t, n, r), a = C(t + 1, n, r), s = C(t, n + 1, r), u = C(t, n, r + 1), c = C(t + 1, n + 1, r), d = C(t + 1, n, r + 1), g = C(t, n + 1, r + 1), _ = C(t + 1, n + 1, r + 1)) : (a = i + 1, c = (s = i + v) + 1, d = (u = i + y) + 1, _ = (g = s + y) + 1);
              var x = 0,
                S = e[i],
                M = e[a],
                I = e[s],
                j = e[c],
                N = e[u],
                L = e[d],
                D = e[g],
                B = e[_];
              S < h && (x |= 1), M < h && (x |= 2), I < h && (x |= 8), j < h && (x |= 4), N < h && (x |= 16), L < h && (x |= 32), D < h && (x |= 128), B < h && (x |= 64);
              var F = A[x];
              if (0 === F) return 0;
              var z = t + 1,
                U = n + 1,
                G = r + 1;
              1 & F && (f || (R(i), R(a)), k(i, 0, t, n, r, S, M)), 2 & F && (f || (R(a), R(c)), P(a, 1, z, n, r, M, j)), 4 & F && (f || (R(s), R(c)), k(s, 2, t, U, r, I, j)), 8 & F && (f || (R(i), R(s)), P(i, 3, t, n, r, S, I)), 16 & F && (f || (R(u), R(d)), k(u, 4, t, n, G, N, L)), 32 & F && (f || (R(d), R(_)), P(d, 5, z, n, G, L, B)), 64 & F && (f || (R(g), R(_)), k(g, 6, t, U, G, D, B)), 128 & F && (f || (R(u), R(g)), P(u, 7, t, n, G, N, D)), 256 & F && (f || (R(i), R(u)), O(i, 8, t, n, r, S, N)), 512 & F && (f || (R(a), R(d)), O(a, 9, z, n, r, M, L)), 1024 & F && (f || (R(c), R(_)), O(c, 10, z, U, r, j, B)), 2048 & F && (f || (R(s), R(g)), O(s, 11, t, U, r, I, D));
              for (var V, H, q, W = x << 4, $ = 0; -1 !== E[W + $];) V = E[W + $], H = E[W + $ + 1], q = E[W + $ + 2], p ? (T[V][H] & o && (w[l++] = b[V], w[l++] = b[H]), T[H][q] & o && (w[l++] = b[H], w[l++] = b[q]), T[V][q] & o && (w[l++] = b[V], w[l++] = b[q])) : (w[l++] = b[H], w[l++] = b[V], w[l++] = b[q]), $ += 3;
            }
            function j(i, o, s, l, u, c) {
              var d, p, g, b, _, x, w, S, A, E, T, M, k;
              if (i = void 0 !== i ? i : 0, o = void 0 !== o ? o : 0, s = void 0 !== s ? s : 0, l = void 0 !== l ? l : t - 1, u = void 0 !== u ? u : n - 1, c = void 0 !== c ? c : r - 1, m || (f ? (i = Math.max(0, i), o = Math.max(0, o), s = Math.max(0, s), l = Math.min(t - 1, l), u = Math.min(n - 1, u), c = Math.min(r - 1, c)) : (i = Math.max(1, i), o = Math.max(1, o), s = Math.max(1, s), l = Math.min(t - 2, l), u = Math.min(n - 2, u), c = Math.min(r - 2, c))), m) for (S = i - 2, A = o - 2, T = l + 2, M = u + 2, k = c + 2, _ = E = s - 2; _ < k; ++_) for (b = A; b < M; ++b) for (g = S; g < T; ++g) p = 3 * C(g, b, _), a[p] = -1, a[p + 1] = -1, a[p + 2] = -1;else for (S = Math.max(0, i - 2), A = Math.max(0, o - 2), E = Math.max(0, s - 2), T = Math.min(t, l + 2), M = Math.min(n, u + 2), k = Math.min(r, c + 2), _ = E; _ < k; ++_) for (w = y * _, b = A; b < M; ++b) for (x = w + v * b, g = S; g < T; ++g) a[d = 3 * (x + g)] = -1, a[d + 1] = -1, a[d + 2] = -1;
              if (!m) {
                var P,
                  O = i,
                  R = o,
                  j = s,
                  N = l,
                  L = u,
                  D = c;
                for (P = !1, _ = s; _ < c; ++_) {
                  for (b = o; b < u; ++b) {
                    for (g = i; g < l; ++g) if (e[d = t * n * _ + t * b + g] >= h) {
                      j = _, P = !0;
                      break;
                    }
                    if (P) break;
                  }
                  if (P) break;
                }
                for (P = !1, b = o; b < u; ++b) {
                  for (_ = j; _ < c; ++_) {
                    for (g = i; g < l; ++g) if (e[d = t * n * _ + t * b + g] >= h) {
                      R = b, P = !0;
                      break;
                    }
                    if (P) break;
                  }
                  if (P) break;
                }
                for (P = !1, g = i; g < l; ++g) {
                  for (b = R; b < u; ++b) {
                    for (_ = j; _ < c; ++_) if (e[d = t * n * _ + t * b + g] >= h) {
                      O = g, P = !0;
                      break;
                    }
                    if (P) break;
                  }
                  if (P) break;
                }
                for (P = !1, _ = c; s <= _; --_) {
                  for (b = u; o <= b; --b) {
                    for (g = l; i <= g; --g) if (e[d = t * n * _ + t * b + g] >= h) {
                      D = _, P = !0;
                      break;
                    }
                    if (P) break;
                  }
                  if (P) break;
                }
                for (P = !1, b = u; o <= b; --b) {
                  for (_ = D; s <= _; --_) {
                    for (g = l; i <= g; --g) if (e[d = t * n * _ + t * b + g] >= h) {
                      L = b, P = !0;
                      break;
                    }
                    if (P) break;
                  }
                  if (P) break;
                }
                for (P = !1, g = l; i <= g; --g) {
                  for (b = L; o <= b; --b) {
                    for (_ = D; s <= _; --_) if (e[d = t * n * _ + t * b + g] >= h) {
                      N = g, P = !0;
                      break;
                    }
                    if (P) break;
                  }
                  if (P) break;
                }
                f ? (i = Math.max(0, O - 1), o = Math.max(0, R - 1), s = Math.max(0, j - 1), l = Math.min(t - 1, N + 1), u = Math.min(n - 1, L + 1), c = Math.min(r - 1, D + 1)) : (i = Math.max(1, O - 1), o = Math.max(1, R - 1), s = Math.max(1, j - 1), l = Math.min(t - 2, N + 1), u = Math.min(n - 2, L + 1), c = Math.min(r - 2, D + 1));
              }
              var B = 15;
              for (_ = s; _ < c; ++_, B &= -5) for (w = y * _, B |= 2, b = o; b < u; ++b, B &= -3) for (x = w + v * b, B |= 1, g = i; g < l; ++g, B &= -2) I(g, b, _, d = x + g, B);
            }
            this.triangulate = function (e, v, y, b, A) {
              h = e, p = b, m = A, (f = v || p) || o || (o = new Float32Array(3 * g));
              var E = 3 * g;
              if (a && a.length === E || (a = new Int32Array(E)), void (l = s = 0) !== y) {
                var T = y[0].map(Math.round),
                  M = y[1].map(Math.round);
                u = t * Math.ceil(Math.abs(T[0]) / t), c = n * Math.ceil(Math.abs(T[1]) / n), d = r * Math.ceil(Math.abs(T[2]) / r), j(T[0], T[1], T[2], M[0], M[1], M[2]);
              } else u = c = d = 0, j();
              return _.length = 3 * s, f || (x.length = 3 * s), w.length = l, i && (S.length = s), {
                position: new Float32Array(_),
                normal: f ? void 0 : new Float32Array(x),
                index: Nu(w, _.length / 3),
                atomindex: i ? new Int32Array(S) : void 0,
                contour: p
              };
            };
          }
          ud.add("arrow", om), ud.add("box", mm), ud.add("cone", cm), ud.add("cylinder", im), ud.add("ellipsoid", fm), ud.add("octahedron", pm), ud.add("sphere", ym), ud.add("tetrahedron", _m), ud.add("torus", xm), ud.add("point", Em), ud.add("wideline", Tm), Object.assign(km, {
            __deps: [Mm, Cm, function () {
              return [[0, 4, 4, 4, 2, 0, 0, 0, 2, 2, 0, 0], [4, 0, 4, 4, 0, 8, 0, 0, 0, 8, 8, 0], [4, 4, 0, 4, 0, 0, 8, 0, 0, 0, 8, 8], [4, 4, 4, 0, 0, 0, 0, 1, 1, 0, 0, 1], [2, 0, 0, 0, 0, 8, 8, 8, 2, 2, 0, 0], [0, 8, 0, 0, 8, 0, 8, 8, 0, 8, 8, 0], [0, 0, 8, 0, 8, 8, 0, 8, 0, 0, 8, 8], [0, 0, 0, 1, 8, 8, 8, 0, 1, 0, 0, 1], [2, 0, 0, 1, 2, 0, 0, 1, 0, 2, 0, 1], [2, 8, 0, 0, 2, 8, 0, 0, 2, 0, 8, 0], [0, 8, 8, 0, 0, 8, 8, 0, 0, 8, 0, 8], [0, 0, 8, 1, 0, 0, 8, 1, 1, 0, 8, 0]];
            }, Nu]
          });
          var Pm = function Pm(e, t) {
            this.cols = e, this.rows = t, this.size = this.cols * this.rows, this.data = new Float32Array(this.size);
          };
          function Om(e, t) {
            for (var n = 0, r = 0, i = t.rows, o = t.cols, a = 0, s = 0, l = 0, u = t.data, c = e.data; n < i; s += 1, a += o, n++) for (l = s, r = 0; r < o; l += i, r++) c[l] = u[a + r];
          }
          function Rm(e, t, n) {
            for (var r = 0, i = 0, o = 0, a = 0, s = 0, l = 0, u = 0, c = t.cols, d = t.rows, h = n.rows, f = t.data, p = n.data, m = e.data, g = 0; r < d; a += c, r++) for (i = l = 0; i < h; u++, i++) {
              for (s = a, o = g = 0; o < c; s++, l++, o++) g += f[s] * p[l];
              m[u] = g;
            }
          }
          function Im(e, t, n) {
            var r = e.data,
              i = t.data,
              o = n.data,
              a = i[0],
              s = i[1],
              l = i[2],
              u = i[3],
              c = i[4],
              d = i[5],
              h = i[6],
              f = i[7],
              p = i[8],
              m = o[0],
              g = o[1],
              v = o[2],
              y = o[3],
              b = o[4],
              _ = o[5],
              x = o[6],
              w = o[7],
              S = o[8];
            r[0] = a * m + s * y + l * x, r[1] = a * g + s * b + l * w, r[2] = a * v + s * _ + l * S, r[3] = u * m + c * y + d * x, r[4] = u * g + c * b + d * w, r[5] = u * v + c * _ + d * S, r[6] = h * m + f * y + p * x, r[7] = h * g + f * b + p * w, r[8] = h * v + f * _ + p * S;
          }
          function jm(e) {
            for (var t = e.rows, n = e.cols, r = e.data, i = new Array(n), o = 0; o < n; ++o) i[o] = 0;
            for (var a = 0, s = 0; a < t; ++a) for (var l = 0; l < n; ++l, ++s) i[l] += r[s];
            for (var u = 0; u < n; ++u) i[u] /= t;
            return i;
          }
          function Nm(e, t) {
            for (var n = e.rows, r = e.cols, i = e.data, o = 0, a = 0; o < n; ++o) for (var s = 0; s < r; ++s, ++a) i[a] -= t[s];
          }
          function Lm(e, t, n, r) {
            r = e[t], e[t] = e[n], e[n] = r;
          }
          function Dm(e, t, n, r) {
            var i = 0,
              o = 0,
              a = e.rows,
              s = e.cols,
              l = a,
              u = s;
            l < u && (i = 1, o = l, l = u, u = o);
            var c = new Pm(l, l),
              d = new Pm(1, u),
              h = new Pm(u, u);
            if (0 === i) Om(c, e);else {
              for (o = 0; o < s * a; o++) c.data[o] = e.data[o];
              for (; o < u * l; o++) c.data[o] = 0;
            }
            if (function (e, t, n, r, i, o, a, s) {
              for (var l, u, c = 0, d = 0, h = 0, f = 0, p = Math.max(o, 30), m = 0, g = 0, v = 0, y = 0, b = 0, _ = 0, x = 0, w = 0, S = 0, A = 0, E = 0, T = 0, M = 0, C = 0, k = 0, P = 0, O = 0, R = 4660, I = 0, j = 0, N = 0, L = new Float64Array(a << 3); c < a; c++) {
                for (E = h = 0; h < o; h++) E += (w = e[c * t + h]) * w;
                if (L[c] = E, r) {
                  for (h = 0; h < a; h++) r[c * i + h] = 0;
                  r[c * i + c] = 1;
                }
              }
              for (; f < p; f++) {
                for (c = b = 0; c < a - 1; c++) for (d = c + 1; d < a; d++) {
                  for (m = c * t | 0, g = d * t | 0, k = L[c], P = 0, O = L[d], h = 2, P += e[m] * e[g], P += e[m + 1] * e[g + 1]; h < o; h++) P += e[m + h] * e[g + h];
                  if (!(Math.abs(P) <= 2.384185792e-7 * Math.sqrt(k * O))) {
                    for (l = P *= 2, u = T = k - O, l = Math.abs(l), M = (u = Math.abs(u)) < l ? (u /= l, l * Math.sqrt(1 + u * u)) : 0 < u ? (l /= u, u * Math.sqrt(1 + l * l)) : 0, T < 0 ? (C = .5 * (M - T), _ = P / (M * (x = Math.sqrt(C / M)) * 2)) : x = P / (M * (_ = Math.sqrt((M + T) / (2 * M))) * 2), O = k = 0, h = 2, S = _ * e[m] + x * e[g], A = -x * e[m] + _ * e[g], k += (e[m] = S) * S, O += (e[g] = A) * A, S = _ * e[m + 1] + x * e[g + 1], A = -x * e[m + 1] + _ * e[g + 1], k += (e[m + 1] = S) * S, O += (e[g + 1] = A) * A; h < o; h++) S = _ * e[m + h] + x * e[g + h], A = -x * e[m + h] + _ * e[g + h], k += (e[m + h] = S) * S, O += (e[g + h] = A) * A;
                    if (L[c] = k, L[d] = O, b = 1, r) for (y = d * i | 0, h = 2, S = _ * r[v = c * i | 0] + x * r[y], A = -x * r[v] + _ * r[y], r[v] = S, r[y] = A, S = _ * r[v + 1] + x * r[y + 1], A = -x * r[v + 1] + _ * r[y + 1], r[v + 1] = S, r[y + 1] = A; h < a; h++) S = _ * r[v + h] + x * r[y + h], A = -x * r[v + h] + _ * r[y + h], r[v + h] = S, r[y + h] = A;
                  }
                }
                if (0 === b) break;
              }
              for (c = 0; c < a; c++) {
                for (E = h = 0; h < o; h++) E += (w = e[c * t + h]) * w;
                L[c] = Math.sqrt(E);
              }
              for (c = 0; c < a - 1; c++) {
                for (h = (d = c) + 1; h < a; h++) L[d] < L[h] && (d = h);
                if (c !== d && (Lm(L, c, d, E), r)) {
                  for (h = 0; h < o; h++) Lm(e, c * t + h, d * t + h, w);
                  for (h = 0; h < a; h++) Lm(r, c * i + h, d * i + h, w);
                }
              }
              for (c = 0; c < a; c++) n[c] = L[c];
              if (r) for (c = 0; c < s; c++) {
                for (E = c < a ? L[c] : 0; E <= 1e-37;) {
                  for (j = 1 / o, h = 0; h < o; h++) I = 0 != (256 & (R = 214013 * R + 2531011) >> 16) ? j : -j, e[c * t + h] = I;
                  for (f = 0; f < 2; f++) for (d = 0; d < c; d++) {
                    for (h = E = 0; h < o; h++) E += e[c * t + h] * e[d * t + h];
                    for (h = N = 0; h < o; h++) w = e[c * t + h] - E * e[d * t + h], e[c * t + h] = w, N += Math.abs(w);
                    for (N = N ? 1 / N : 0, h = 0; h < o; h++) e[c * t + h] *= N;
                  }
                  for (h = E = 0; h < o; h++) E += (w = e[c * t + h]) * w;
                  E = Math.sqrt(E);
                }
                for (x = 1 / E, h = 0; h < o; h++) e[c * t + h] *= x;
              }
            }(c.data, l, d.data, h.data, u, l, u, l), t) {
              for (o = 0; o < u; o++) t.data[o] = d.data[o];
              for (; o < s; o++) t.data[o] = 0;
            }
            0 === i ? (n && Om(n, c), r && Om(r, h)) : (n && Om(n, h), r && Om(r, c));
          }
          function Bm() {
            return new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
          }
          function Fm(e, t, n, r, i, o, a, s, l, u, c, d, h, f, p, m, g) {
            e[0] = t, e[4] = n, e[8] = r, e[12] = i, e[1] = o, e[5] = a, e[9] = s, e[13] = l, e[2] = u, e[6] = c, e[10] = d, e[14] = h, e[3] = f, e[7] = p, e[11] = m, e[15] = g;
          }
          function zm(e, t, n) {
            var r = t[0],
              i = t[4],
              o = t[8],
              a = t[12],
              s = t[1],
              l = t[5],
              u = t[9],
              c = t[13],
              d = t[2],
              h = t[6],
              f = t[10],
              p = t[14],
              m = t[3],
              g = t[7],
              v = t[11],
              y = t[15],
              b = n[0],
              _ = n[4],
              x = n[8],
              w = n[12],
              S = n[1],
              A = n[5],
              E = n[9],
              T = n[13],
              M = n[2],
              C = n[6],
              k = n[10],
              P = n[14],
              O = n[3],
              R = n[7],
              I = n[11],
              j = n[15];
            e[0] = r * b + i * S + o * M + a * O, e[4] = r * _ + i * A + o * C + a * R, e[8] = r * x + i * E + o * k + a * I, e[12] = r * w + i * T + o * P + a * j, e[1] = s * b + l * S + u * M + c * O, e[5] = s * _ + l * A + u * C + c * R, e[9] = s * x + l * E + u * k + c * I, e[13] = s * w + l * T + u * P + c * j, e[2] = d * b + h * S + f * M + p * O, e[6] = d * _ + h * A + f * C + p * R, e[10] = d * x + h * E + f * k + p * I, e[14] = d * w + h * T + f * P + p * j, e[3] = m * b + g * S + v * M + y * O, e[7] = m * _ + g * A + v * C + y * R, e[11] = m * x + g * E + v * k + y * I, e[15] = m * w + g * T + v * P + y * j;
          }
          function Um(e, t, n, r) {
            Fm(e, t, 0, 0, 0, 0, n, 0, 0, 0, 0, r, 0, 0, 0, 0, 1);
          }
          function Gm(e, t, n, r) {
            Fm(e, 1, 0, 0, t, 0, 1, 0, n, 0, 0, 1, r, 0, 0, 0, 1);
          }
          function Vm(e, t) {
            var n = Math.cos(t),
              r = Math.sin(t);
            Fm(e, n, 0, r, 0, 0, 1, 0, 0, -r, 0, n, 0, 0, 0, 0, 1);
          }
          function Hm() {
            return new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
          }
          function qm(e, t) {
            var n = vf([t[0], t[1], t[2]]),
              r = vf([t[4], t[5], t[6]]),
              i = vf([t[8], t[9], t[10]]),
              o = vf();
            yf(o, r, i), e[0] = o[0], e[1] = o[1], e[2] = o[2], yf(o, i, n), e[3] = o[0], e[4] = o[1], e[5] = o[2], yf(o, n, r), e[6] = o[0], e[7] = o[1], e[8] = o[2];
          }
          function Wm(e, t, n, r) {
            n = n || 1, r = r || !0;
            var i,
              o = e.length / 3,
              a = t.length / 3;
            r && (i = new Float32Array(3 * o));
            var s,
              l,
              u,
              c,
              d = new Float32Array(3 * o),
              h = new Array(20);
            for (s = 0; s < 20; ++s) h[s] = new Uint32Array(o);
            for (s = 0; s < o; ++s) h[0][s] = 0;
            for (s = 0; s < a; ++s) {
              var f = 3 * s,
                p = 3 * s + 1,
                m = 3 * s + 2;
              for (c = !0, u = h[l = 0][t[f]]; l < u; ++l) if (t[p] === h[l + 1][t[f]]) {
                c = !1;
                break;
              }
              for (c && (h[0][t[f]]++, h[h[0][t[f]]][t[f]] = t[p]), c = !0, u = h[l = 0][t[f]]; l < u; ++l) if (t[m] === h[l + 1][t[f]]) {
                c = !1;
                break;
              }
              for (c && (h[0][t[f]]++, h[h[0][t[f]]][t[f]] = t[m]), c = !0, u = h[l = 0][t[p]]; l < u; ++l) if (t[f] === h[l + 1][t[p]]) {
                c = !1;
                break;
              }
              for (c && (h[0][t[p]]++, h[h[0][t[p]]][t[p]] = t[f]), c = !0, u = h[l = 0][t[p]]; l < u; ++l) if (t[m] === h[l + 1][t[p]]) {
                c = !1;
                break;
              }
              for (c && (h[0][t[p]]++, h[h[0][t[p]]][t[p]] = t[m]), c = !0, l = 0; l < h[0][t[m]]; ++l) if (t[f] === h[l + 1][t[m]]) {
                c = !1;
                break;
              }
              for (c && (h[0][t[m]]++, h[h[0][t[m]]][t[m]] = t[f]), c = !0, u = h[l = 0][t[m]]; l < u; ++l) if (t[p] === h[l + 1][t[m]]) {
                c = !1;
                break;
              }
              c && (h[0][t[m]]++, h[h[0][t[m]]][t[m]] = t[p]);
            }
            for (var g, v, y, b, _, x = 0; x < n; ++x) {
              for (s = 0; s < o; ++s) if (g = 3 * s, (y = h[0][s]) < 3) d[g] = e[g], d[g + 1] = e[g + 1], d[g + 2] = e[g + 2];else if (3 === y || 4 === y) {
                for (d[g] = 0, d[g + 1] = 0, l = d[g + 2] = 0; l < y; ++l) v = 3 * h[l + 1][s], d[g] += e[v], d[g + 1] += e[v + 1], d[g + 2] += e[v + 2];
                d[g] += .5 * e[g], d[g + 1] += .5 * e[g + 1], d[g + 2] += .5 * e[g + 2], _ = .5 + y, d[g] /= _, d[g + 1] /= _, d[g + 2] /= _;
              } else {
                for (d[g] = 0, d[g + 1] = 0, l = d[g + 2] = 0; l < y; ++l) v = 3 * h[l + 1][s], d[g] += e[v], d[g + 1] += e[v + 1], d[g + 2] += e[v + 2];
                d[g] += 1 * e[g], d[g + 1] += 1 * e[g + 1], d[g + 2] += 1 * e[g + 2], b = 1 + y, d[g] /= b, d[g + 1] /= b, d[g + 2] /= b;
              }
              if (e.set(d), r) {
                $m(e, t, i);
                var w = 3 * o;
                for (g = 0; g < w; g += 3) e[g] += .75 / 4.5 * -1 * i[g], e[g + 1] += .75 / 4.5 * -1 * i[g + 1], e[g + 2] += .75 / 4.5 * -1 * i[g + 2];
              }
            }
          }
          function $m(e, t, n) {
            var r, i;
            if (void 0 === n) n = new Float32Array(e.length);else for (r = 0, i = n.length; r < i; r++) n[r] = 0;
            var o = new Float32Array(3),
              a = new Float32Array(3),
              s = new Float32Array(3),
              l = new Float32Array(3),
              u = new Float32Array(3);
            if (t) for (r = 0, i = t.length; r < i; r += 3) {
              var c = 3 * t[r],
                d = 3 * t[r + 1],
                h = 3 * t[r + 2];
              wf(o, e, c), wf(a, e, d), wf(s, e, h), _f(l, s, a), _f(u, o, a), yf(l, l, u), n[c] += l[0], n[c + 1] += l[1], n[c + 2] += l[2], n[d] += l[0], n[d + 1] += l[1], n[d + 2] += l[2], n[h] += l[0], n[h + 1] += l[1], n[h + 2] += l[2];
            } else for (r = 0, i = e.length; r < i; r += 9) wf(o, e, r), wf(a, e, r + 3), wf(s, e, r + 6), _f(l, s, a), _f(u, o, a), yf(l, l, u), n[r] = l[0], n[r + 1] = l[1], n[r + 2] = l[2], n[r + 3] = l[0], n[r + 4] = l[1], n[r + 5] = l[2], n[r + 6] = l[0], n[r + 7] = l[1], n[r + 8] = l[2];
            return gf(n), n;
          }
          function Xm(e) {
            for (var t = {}, n = 0, r = e.length; n < r; ++n) t[e[n]] = !0;
            return t;
          }
          function Ym(e, t, n, r, i) {
            var o = 1 / r * 3;
            Cf(e, e, i + (o += n)), kf(t, t, i + o), Tf(e, e, r), Pf(e, e), Ef(e, e, r), Tf(t, t, r), Of(t, t), Ef(t, t, r);
            var a = new Float32Array(3);
            _f(a, t, e), Tf(a, a, r), Of(a, a), kf(a, a, 1);
            var s = 256 * Math.pow(10, 6),
              l = a[0] * a[1] * a[2] * 3;
            s <= l && (Tf(e, e, r *= Math.pow(s / l, 1 / 3)), Pf(e, e), Ef(e, e, r), Tf(t, t, r), Of(t, t), Ef(t, t, r), _f(a, t, e), Tf(a, a, r), Of(a, a), kf(a, a, 1));
            var u = new Float32Array(e);
            Rf(u, u);
            var c = Bm(),
              d = Bm();
            Vm(d, qu(90)), zm(c, c, d);
            var h = Bm();
            Um(h, -1 / r, 1 / r, 1 / r), zm(c, c, h);
            var f = Bm();
            return Gm(f, -r * u[2], -r * u[1], -r * u[0]), zm(c, c, f), {
              dim: a,
              tran: u,
              matrix: c,
              scaleFactor: r
            };
          }
          Pm.prototype.copyTo = function (e) {
            e.data.set(this.data);
          }, Um.__deps = [Fm], Gm.__deps = [Fm], Vm.__deps = [Fm], qm.__deps = [vf, yf], Object.assign(Wm, {
            __deps: [$m]
          }), Object.assign($m, {
            __deps: [_f, yf, wf, gf]
          }), Object.assign(Ym, {
            __deps: [qu, Cf, kf, Ef, Tf, Pf, Of, _f, Rf, Bm, zm, Gm, Um, Vm]
          });
          var Km = function Km(e, t, n) {
              this.name = e || "", this.path = t || "", this.info = {}, this.center = new ae(), this.boundingBox = new Oe(), n instanceof Et || n instanceof Yt || n instanceof xi ? this.fromGeometry(n) : n && (this.set(n.position, n.index, n.normal, n.color, n.atomindex, n.contour), this.boundingBox.setFromArray(n.position), this.boundingBox.getCenter(this.center));
            },
            Zm = {
              type: {
                configurable: !0
              }
            };
          function Qm(e, t, n, r, i) {
            var o = new km(e, t, n, r, i);
            this.getSurface = function (e, t, n, r, i, a) {
              void 0 === a && (a = !1);
              var s = o.triangulate(e, t, n, i, a);
              if (t && !i && (Wm(s.position, s.index, t, !0), s.normal = $m(s.position, s.index)), r && (pf(r, s.position), s.normal)) {
                var l = Hm();
                qm(l, r), mf(l, s.normal);
              }
              return s;
            };
          }
          Zm.type.get = function () {
            return "Surface";
          }, Km.prototype.set = function (e, t, n, r, i, o) {
            void 0 === o && (o = !1), this.position = e, this.index = t, this.normal = n, this.color = r, this.atomindex = i, this.size = e.length / 3, this.contour = o;
          }, Km.prototype.fromGeometry = function (e) {
            var n, r, i, o;
            if (t.Debug && Zc.time("GeometrySurface.fromGeometry"), e instanceof Et ? (e.computeVertexNormals(!0), n = new Yt().fromGeometry(e)) : n = e instanceof Yt ? e : e[0], n.boundingBox || n.computeBoundingBox(), this.boundingBox.copy(n.boundingBox), this.boundingBox.getCenter(this.center), n instanceof Yt) {
              var a = n.attributes,
                s = !!a.normal && a.normal.array;
              (!s || 0 === s[0] && 0 === s[1] && 0 === s[2]) && n.computeVertexNormals(), r = a.position.array, i = a.index ? a.index.array : null, o = a.normal.array;
            }
            this.set(r, i, o, void 0, void 0), t.Debug && Zc.timeEnd("GeometrySurface.setGeometry");
          }, Km.prototype.getPosition = function () {
            return this.position;
          }, Km.prototype.getColor = function (e) {
            var t = e || {},
              n = (t.surface = this).size,
              r = new Float32Array(3 * n),
              i = td.getScheme(t);
            if (i.volumeColor || "random" === t.scheme) for (var o = 0; o < n; ++o) i.volumeColorToArray(o, r, 3 * o);else if (i.positionColor) for (var a = new ae(), s = this.position, l = 0; l < n; ++l) {
              var u = 3 * l;
              a.set(s[u], s[u + 1], s[u + 2]), i.positionColorToArray(a, r, u);
            } else if (i.atomColor && this.atomindex) for (var c = t.structure.getAtomProxy(), d = this.atomindex, h = 0; h < n; ++h) c.index = d[h], i.atomColorToArray(c, r, 3 * h);else {
              var f = new Fe(t.value);
              qd(n, f.r, f.g, f.b, r);
            }
            return r;
          }, Km.prototype.getPicking = function (e) {
            return this.atomindex && e ? new am(this.atomindex, e) : new bm(Wd(this.size), this);
          }, Km.prototype.getNormal = function () {
            return this.normal;
          }, Km.prototype.getSize = function (e, t) {
            return Hd(this.size, e * t);
          }, Km.prototype.getIndex = function () {
            return this.index;
          }, Km.prototype.getFilteredIndex = function (e, t) {
            if (e && this.atomindex) {
              for (var n = new Nc(e), r = t.getAtomSet(n), i = [], o = this.atomindex, a = this.index, s = a.length, l = this.contour ? 2 : 3, u = 0, c = 0; c < s; c += l) {
                for (var d = !0, h = 0; h < l; h++) {
                  var f = o[a[c + h]];
                  if (!r.get(f)) {
                    d = !1;
                    break;
                  }
                }
                if (d) for (var p = 0; p < l; p++, u++) i[u] = a[c + p];
              }
              return Nu(i, this.position.length / 3);
            }
            return this.index;
          }, Km.prototype.getAtomindex = function () {
            return this.atomindex;
          }, Km.prototype.dispose = function () {}, Object.defineProperties(Km.prototype, Zm), Object.assign(Qm, {
            __deps: [Wm, $m, km, pf, mf, Hm, qm]
          }), ed.add("surf", function (e, t) {
            var n = e.data.args,
              r = e.data.params;
            if (n && (self.volsurf = new Qm(n[0], n[1], n[2], n[3], n[4])), r) {
              var i = self.volsurf.getSurface(r.isolevel, r.smooth, r.box, r.matrix, r.contour, r.wrap),
                o = [i.position.buffer, i.index.buffer];
              i.normal && o.push(i.normal.buffer), i.atomindex && o.push(i.atomindex.buffer), t({
                sd: i,
                p: r
              }, o);
            }
          }, [Qm]);
          var Jm = function Jm(e, t, n, r, i, o, a) {
              this.name = e, this.path = t, this.matrix = new ie(), this.normalMatrix = new se(), this.inverseMatrix = new ie(), this.center = new ae(), this.boundingBox = new Oe(), this.setData(n, r, i, o, a);
            },
            eg = {
              type: {
                configurable: !0
              },
              position: {
                configurable: !0
              },
              min: {
                configurable: !0
              },
              max: {
                configurable: !0
              },
              sum: {
                configurable: !0
              },
              mean: {
                configurable: !0
              },
              rms: {
                configurable: !0
              }
            };
          function tg(e) {
            return "front" === e ? 0 : "back" === e ? 1 : 2;
          }
          eg.type.get = function () {
            return "Volume";
          }, Jm.prototype.setData = function (e, t, n, r, i) {
            this.nx = t || 1, this.ny = n || 1, this.nz = r || 1, this.data = e || new Float32Array(1), this.setAtomindex(i), delete this._position, delete this._min, delete this._max, delete this._mean, delete this._rms, this.worker && this.worker.terminate();
          }, Jm.prototype.setStats = function (e, t, n, r) {
            this._min = e, this._max = t, this._mean = n, this._rms = r;
          }, Jm.prototype.setMatrix = function (e) {
            this.matrix.copy(e);
            var t = this.boundingBox,
              n = this.center,
              r = this.nx - 1,
              i = this.ny - 1,
              o = this.nz - 1;
            t.makeEmpty(), t.expandByPoint(n.set(r, i, o)), t.expandByPoint(n.set(r, i, 0)), t.expandByPoint(n.set(r, 0, o)), t.expandByPoint(n.set(r, 0, 0)), t.expandByPoint(n.set(0, i, o)), t.expandByPoint(n.set(0, 0, o)), t.expandByPoint(n.set(0, i, 0)), t.expandByPoint(n.set(0, 0, 0)), t.applyMatrix4(this.matrix), t.getCenter(this.center);
            var a = this.matrix.elements,
              s = new ae(a[0], a[1], a[2]),
              l = new ae(a[4], a[5], a[6]),
              u = new ae(a[8], a[9], a[10]),
              c = new ae(),
              d = this.normalMatrix.elements;
            c.crossVectors(l, u), d[0] = c.x, d[1] = c.y, d[2] = c.z, c.crossVectors(u, s), d[3] = c.x, d[4] = c.y, d[5] = c.z, c.crossVectors(s, l), d[6] = c.x, d[7] = c.y, d[8] = c.z, this.inverseMatrix.getInverse(this.matrix);
          }, Jm.prototype.setAtomindex = function (e) {
            this.atomindex = e;
          }, Jm.prototype.getBox = function (e, t, n) {
            return n || (n = new Oe()), n.set(e, e), n.expandByScalar(t), n.applyMatrix4(this.inverseMatrix), n.min.round(), n.max.round(), n;
          }, Jm.prototype._getBox = function (e, t) {
            if (e && t) {
              this.__box || (this.__box = new Oe());
              var n = this.getBox(e, t, this.__box);
              return [n.min.toArray(), n.max.toArray()];
            }
          }, Jm.prototype._makeSurface = function (e, t, n) {
            var r = this.name + "@" + t.toPrecision(2),
              i = new Km(r, "", e);
            return i.info.isolevel = t, i.info.smooth = n, i.info.volume = this, i;
          }, Jm.prototype.getSurface = function (e, t, n, r, i, o) {
            void 0 === o && (o = !1), e = isNaN(e) ? this.getValueForSigma(2) : e, t = wu(t, 0), void 0 === this.volsurf && (this.volsurf = new Qm(this.data, this.nx, this.ny, this.nz, this.atomindex));
            var a = this._getBox(n, r),
              s = this.volsurf.getSurface(e, t, a, this.matrix.elements, i, o);
            return this._makeSurface(s, e, t);
          }, Jm.prototype.getSurfaceWorker = function (e, t, n, r, i, o, a) {
            var s = this;
            if (e = isNaN(e) ? this.getValueForSigma(2) : e, t = t || 0, window.hasOwnProperty("Worker")) {
              void 0 === this.workerPool && (this.workerPool = new cf("surf", 2));
              var l = {},
                u = this.workerPool.getNextWorker();
              0 === u.postCount && Object.assign(l, {
                args: [this.data, this.nx, this.ny, this.nz, this.atomindex]
              }), Object.assign(l, {
                params: {
                  isolevel: e,
                  smooth: t,
                  box: this._getBox(n, r),
                  matrix: this.matrix.elements,
                  contour: i,
                  wrap: o
                }
              }), u.post(l, void 0, function (e) {
                var t = e.data.sd,
                  n = e.data.p;
                a(s._makeSurface(t, n.isolevel, n.smooth));
              }, function (l) {
                console.warn("Volume.getSurfaceWorker error - trying without worker", l);
                var u = s.getSurface(e, t, n, r, i, o);
                a(u);
              });
            } else {
              var c = this.getSurface(e, t, n, r, i, o);
              a(c);
            }
          }, Jm.prototype.getValueForSigma = function (e) {
            return this.mean + wu(e, 2) * this.rms;
          }, Jm.prototype.getSigmaForValue = function (e) {
            return (wu(e, 0) - this.mean) / this.rms;
          }, eg.position.get = function () {
            if (!this._position) {
              for (var e = this.nz, t = this.ny, n = this.nx, r = new Float32Array(n * t * e * 3), i = 0, o = 0; o < e; ++o) for (var a = 0; a < t; ++a) for (var s = 0; s < n; ++s) r[i + 0] = s, r[i + 1] = a, r[i + 2] = o, i += 3;
              pf(this.matrix.elements, r), this._position = r;
            }
            return this._position;
          }, Jm.prototype.getDataAtomindex = function () {
            return this.atomindex;
          }, Jm.prototype.getDataPosition = function () {
            return this.position;
          }, Jm.prototype.getDataColor = function (e) {
            var t = e || {};
            t.volume = this, t.scale = t.scale || "Spectral", t.domain = t.domain || [this.min, this.max];
            for (var n = td.getScheme(t), r = this.position.length / 3, i = new Float32Array(3 * r), o = 0; o < r; ++o) n.volumeColorToArray(o, i, 3 * o);
            return i;
          }, Jm.prototype.getDataPicking = function () {
            var e = Wd(this.position.length / 3);
            return new Sm(e, this);
          }, Jm.prototype.getDataSize = function (e, t) {
            var n,
              r = this.data,
              i = this.position.length / 3;
            switch (e) {
              case "value":
                n = new Float32Array(r);
                break;
              case "abs-value":
                n = new Float32Array(r);
                for (var o = 0; o < i; ++o) n[o] = Math.abs(n[o]);
                break;
              case "value-min":
                n = new Float32Array(r);
                for (var a = this.min, s = 0; s < i; ++s) n[s] -= a;
                break;
              case "deviation":
                n = new Float32Array(r);
                break;
              default:
                n = Hd(i, e);
            }
            if (1 !== t) for (var l = 0; l < i; ++l) n[l] *= t;
            return n;
          }, eg.min.get = function () {
            return void 0 === this._min && (this._min = Qd(this.data)), this._min;
          }, eg.max.get = function () {
            return void 0 === this._max && (this._max = Zd(this.data)), this._max;
          }, eg.sum.get = function () {
            return void 0 === this._sum && (this._sum = Jd(this.data)), this._sum;
          }, eg.mean.get = function () {
            return void 0 === this._mean && (this._mean = eh(this.data)), this._mean;
          }, eg.rms.get = function () {
            return void 0 === this._rms && (this._rms = function (e) {
              for (var t = e.length, n = 0, r = 0; r < t; ++r) {
                var i = e[r];
                n += i * i;
              }
              return Math.sqrt(n / t);
            }(this.data)), this._rms;
          }, Jm.prototype.clone = function () {
            var e = new Jm(this.name, this.path, this.data, this.nx, this.ny, this.nz, this.atomindex);
            return e.matrix.copy(this.matrix), e.header = Object.assign({}, this.header), e;
          }, Jm.prototype.dispose = function () {
            this.workerPool && this.workerPool.terminate();
          }, Object.defineProperties(Jm.prototype, eg), od.add("shader/Mesh.vert", "#define STANDARD\nuniform float clipNear;\nuniform vec3 clipCenter;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || ( !defined( PICKING ) && !defined( NOLIGHT ) )\nvarying vec3 vViewPosition;\n#endif\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#if defined( PICKING )\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#elif defined( NOLIGHT )\nvarying vec3 vColor;\n#else\n#include color_pars_vertex\n#ifndef FLAT_SHADED\nvarying vec3 vNormal;\n#endif\n#endif\n#include common\nvoid main(){\n#if defined( PICKING )\nvPickingColor = unpackColor( primitiveId );\n#elif defined( NOLIGHT )\nvColor = color;\n#else\n#include color_vertex\n#include beginnormal_vertex\n#include defaultnormal_vertex\n#ifndef FLAT_SHADED\nvNormal = normalize( transformedNormal );\n#endif\n#endif\n#include begin_vertex\n#include project_vertex\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || ( !defined( PICKING ) && !defined( NOLIGHT ) )\nvViewPosition = -mvPosition.xyz;\n#endif\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n#include nearclip_vertex\n}"), od.add("shader/Mesh.frag", "#define STANDARD\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 interiorColor;\nuniform float interiorDarkening;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\nuniform float clipNear;\nuniform float clipRadius;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || ( !defined( PICKING ) && !defined( NOLIGHT ) )\nvarying vec3 vViewPosition;\n#endif\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#if defined( PICKING )\nuniform float objectId;\nvarying vec3 vPickingColor;\n#elif defined( NOLIGHT )\nvarying vec3 vColor;\n#else\n#ifndef FLAT_SHADED\nvarying vec3 vNormal;\n#endif\n#include common\n#include color_pars_fragment\n#include fog_pars_fragment\n#include bsdfs\n#include lights_pars_begin\n#include lights_physical_pars_fragment\n#endif\nvoid main(){\n#include nearclip_fragment\n#include radiusclip_fragment\n#if defined( PICKING )\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#elif defined( NOLIGHT )\ngl_FragColor = vec4( vColor, opacity );\n#else\nvec4 diffuseColor = vec4( diffuse, opacity );\nReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\nvec3 totalEmissiveLight = emissive;\n#include color_fragment\n#include roughnessmap_fragment\n#include metalnessmap_fragment\n#include normal_fragment_begin\n#include lights_physical_fragment\n#include lights_fragment_begin\n#include lights_fragment_end\nvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveLight;\n#include interior_fragment\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#include opaque_back_fragment\n#endif\n}");
          var ng = {
            f: 1,
            v2: 2,
            v3: 3,
            c: 3
          };
          function rg(e, t) {
            e.matrix.copy(t), e.matrix.decompose(e.position, e.quaternion, e.scale), e.matrixWorldNeedsUpdate = !0;
          }
          var ig = {
              opaqueBack: !1,
              side: "double",
              opacity: 1,
              depthWrite: !0,
              clipNear: 0,
              clipRadius: 0,
              clipCenter: new ae(),
              flatShaded: !1,
              wireframe: !1,
              roughness: .4,
              metalness: 0,
              diffuse: 16777215,
              diffuseInterior: !1,
              useInteriorColor: !1,
              interiorColor: 14540253,
              interiorDarkening: 0,
              forceTransparent: !1,
              matrix: new ie(),
              disablePicking: !1,
              sortParticles: !1,
              background: !1
            },
            og = {
              opaqueBack: {
                updateShader: !0
              },
              side: {
                updateShader: !0,
                property: !0
              },
              opacity: {
                uniform: !0
              },
              depthWrite: {
                property: !0
              },
              clipNear: {
                updateShader: !0,
                property: !0
              },
              clipRadius: {
                updateShader: !0,
                uniform: !0
              },
              clipCenter: {
                uniform: !0
              },
              flatShaded: {
                updateShader: !0
              },
              background: {
                updateShader: !0
              },
              wireframe: {
                updateVisibility: !0
              },
              roughness: {
                uniform: !0
              },
              metalness: {
                uniform: !0
              },
              diffuse: {
                uniform: !0
              },
              diffuseInterior: {
                updateShader: !0
              },
              useInteriorColor: {
                updateShader: !0
              },
              interiorColor: {
                uniform: !0
              },
              interiorDarkening: {
                uniform: !0
              },
              matrix: {}
            },
            ag = function ag(e, t) {
              void 0 === t && (t = {}), this.parameterTypes = og, this.geometry = new Yt(), this.indexVersion = 0, this.wireframeIndexVersion = -1, this.group = new xi(), this.wireframeGroup = new xi(), this.pickingGroup = new xi(), this.vertexShader = "", this.fragmentShader = "", this.isImpostor = !1, this.isText = !1, this.isSurface = !1, this.isPoint = !1, this.isLine = !1, this.dynamic = !0, this.visible = !0, this.wireframeIndexCount = 0, this.parameters = Su(t, this.defaultParameters), this.uniforms = De.merge([Ge.common, {
                fogColor: {
                  value: null
                },
                fogNear: {
                  value: 0
                },
                fogFar: {
                  value: 0
                },
                opacity: {
                  value: this.parameters.opacity
                },
                clipNear: {
                  value: 0
                },
                clipRadius: {
                  value: this.parameters.clipRadius
                },
                clipCenter: {
                  value: this.parameters.clipCenter
                }
              }, {
                emissive: {
                  value: new Fe(0)
                },
                roughness: {
                  value: this.parameters.roughness
                },
                metalness: {
                  value: this.parameters.metalness
                },
                interiorColor: {
                  value: new Fe(this.parameters.interiorColor)
                },
                interiorDarkening: {
                  value: this.parameters.interiorDarkening
                }
              }, Ge.lights]), this.uniforms.diffuse.value.set(this.parameters.diffuse), this.pickingUniforms = {
                clipNear: {
                  value: 0
                },
                objectId: {
                  value: 0
                },
                opacity: {
                  value: this.parameters.opacity
                }
              };
              var n = e.position || e.position1;
              this._positionDataSize = n ? n.length / 3 : 0, e.primitiveId || (e.primitiveId = Wd(this._positionDataSize)), this.addAttributes({
                position: {
                  type: "v3",
                  value: e.position
                },
                color: {
                  type: "c",
                  value: e.color
                },
                primitiveId: {
                  type: "f",
                  value: e.primitiveId
                }
              }), t.matrix && (this.matrix = t.matrix), e.index && this.initIndex(e.index), this.picking = e.picking, this.makeWireframeGeometry();
            },
            sg = {
              defaultParameters: {
                configurable: !0
              },
              matrix: {
                configurable: !0
              },
              transparent: {
                configurable: !0
              },
              size: {
                configurable: !0
              },
              attributeSize: {
                configurable: !0
              },
              pickable: {
                configurable: !0
              }
            };
          sg.defaultParameters.get = function () {
            return ig;
          }, sg.matrix.set = function (e) {
            this.setMatrix(e);
          }, sg.matrix.get = function () {
            return this.group.matrix.clone();
          }, sg.transparent.get = function () {
            return this.parameters.opacity < 1 || this.parameters.forceTransparent;
          }, sg.size.get = function () {
            return this._positionDataSize;
          }, sg.attributeSize.get = function () {
            return this.size;
          }, sg.pickable.get = function () {
            return !!this.picking && !this.parameters.disablePicking;
          }, ag.prototype.setMatrix = function (e) {
            rg(this.group, e), rg(this.wireframeGroup, e), rg(this.pickingGroup, e);
          }, ag.prototype.initIndex = function (e) {
            this.geometry.setIndex(new Tt(e, 1)), this.geometry.getIndex().setDynamic(this.dynamic);
          }, ag.prototype.makeMaterial = function () {
            var e = tg(this.parameters.side),
              t = new Cn({
                uniforms: this.uniforms,
                vertexShader: "",
                fragmentShader: "",
                depthTest: !0,
                transparent: this.transparent,
                depthWrite: this.parameters.depthWrite,
                lights: !0,
                fog: !0,
                side: e
              });
            t.vertexColors = 2, t.extensions.derivatives = this.parameters.flatShaded, t.extensions.fragDepth = this.isImpostor;
            var n = new Cn({
              uniforms: this.uniforms,
              vertexShader: "",
              fragmentShader: "",
              depthTest: !0,
              transparent: this.transparent,
              depthWrite: this.parameters.depthWrite,
              lights: !1,
              fog: !0,
              side: e
            });
            n.vertexColors = 2;
            var r = new Cn({
              uniforms: this.pickingUniforms,
              vertexShader: "",
              fragmentShader: "",
              depthTest: !0,
              transparent: !1,
              depthWrite: this.parameters.depthWrite,
              lights: !1,
              fog: !1,
              side: e,
              blending: 0
            });
            r.vertexColors = 2, r.extensions.fragDepth = this.isImpostor, t.clipNear = this.parameters.clipNear, n.clipNear = this.parameters.clipNear, r.clipNear = this.parameters.clipNear, this.material = t, this.wireframeMaterial = n, this.pickingMaterial = r, this.updateShader();
          }, ag.prototype.makeWireframeGeometry = function () {
            this.makeWireframeIndex();
            var e = this.geometry,
              t = this.wireframeIndex,
              n = new Yt();
            n.attributes = e.attributes, t && (n.setIndex(new Tt(t, 1).setDynamic(this.dynamic)), n.setDrawRange(0, this.wireframeIndexCount)), this.wireframeGeometry = n;
          }, ag.prototype.makeWireframeIndex = function () {
            var e = [];
            function t(t, n) {
              if (n < t) {
                var r = t;
                t = n, n = r;
              }
              var i = e[t];
              return void 0 === i ? (e[t] = [n], !0) : !i.includes(n) && (i.push(n), !0);
            }
            var n = this.geometry,
              r = n.index;
            if (this.parameters.wireframe) {
              if (r) {
                var i,
                  o = r.array,
                  a = o.length;
                n.drawRange.count !== 1 / 0 && (a = n.drawRange.count), i = this.wireframeIndex && this.wireframeIndex.length > 2 * a ? this.wireframeIndex : Nu(2 * a, n.attributes.position.count);
                for (var s = 0, l = e.length = 0; l < a; l += 3) {
                  var u = o[l + 0],
                    c = o[l + 1],
                    d = o[l + 2];
                  t(u, c) && (i[s + 0] = u, i[s + 1] = c, s += 2), t(c, d) && (i[s + 0] = c, i[s + 1] = d, s += 2), t(d, u) && (i[s + 0] = d, i[s + 1] = u, s += 2);
                }
                this.wireframeIndex = i, this.wireframeIndexCount = s, this.wireframeIndexVersion = this.indexVersion;
              } else {
                var h,
                  f = n.attributes.position.count;
                h = this.wireframeIndex && this.wireframeIndex.length > 2 * f ? this.wireframeIndex : Nu(2 * f, f);
                for (var p = 0, m = 0; p < f; p += 3) h[m + 0] = p, h[m + 1] = p + 1, h[m + 2] = p + 1, h[m + 3] = p + 2, h[m + 4] = p + 2, h[m + 5] = p, m += 6;
                this.wireframeIndex = h, this.wireframeIndexCount = 2 * f, this.wireframeIndexVersion = this.indexVersion;
              }
            } else this.wireframeIndex = new Uint16Array(0), this.wireframeIndexCount = 0;
          }, ag.prototype.updateWireframeIndex = function () {
            if (this.wireframeGeometry && this.wireframeIndex) {
              if (this.wireframeGeometry.setDrawRange(0, 1 / 0), this.wireframeIndexVersion < this.indexVersion && this.makeWireframeIndex(), this.wireframeIndex.length > this.wireframeGeometry.index.array.length) this.wireframeGeometry.setIndex(new Tt(this.wireframeIndex, 1).setDynamic(this.dynamic));else {
                var e = this.wireframeGeometry.getIndex();
                e.set(this.wireframeIndex), e.needsUpdate = 0 < this.wireframeIndexCount, e.updateRange.count = this.wireframeIndexCount;
              }
              this.wireframeGeometry.setDrawRange(0, this.wireframeIndexCount);
            }
          }, ag.prototype.getRenderOrder = function () {
            var e = 0;
            return this.isText ? e = 1 : this.transparent && (e = this.isSurface ? 3 : 2), e;
          }, ag.prototype._getMesh = function (e) {
            this.material || this.makeMaterial();
            var t,
              n = this.geometry,
              r = this[e];
            return (t = this.isLine ? new zi(n, r) : this.isPoint ? new Vi(n, r) : new On(n, r)).frustumCulled = !1, t.renderOrder = this.getRenderOrder(), t;
          }, ag.prototype.getMesh = function () {
            return this._getMesh("material");
          }, ag.prototype.getWireframeMesh = function () {
            var e;
            return this.material || this.makeMaterial(), this.wireframeGeometry || this.makeWireframeGeometry(), (e = new zi(this.wireframeGeometry, this.wireframeMaterial)).frustumCulled = !1, e.renderOrder = this.getRenderOrder(), e;
          }, ag.prototype.getPickingMesh = function () {
            return this._getMesh("pickingMaterial");
          }, ag.prototype.getShader = function (e, t) {
            return Od(e, this.getDefines(t));
          }, ag.prototype.getVertexShader = function (e) {
            return this.getShader(this.vertexShader, e);
          }, ag.prototype.getFragmentShader = function (e) {
            return this.getShader(this.fragmentShader, e);
          }, ag.prototype.getDefines = function (e) {
            var t = {};
            return this.parameters.clipNear && (t.NEAR_CLIP = 1), this.parameters.clipRadius && (t.RADIUS_CLIP = 1), "picking" === e ? t.PICKING = 1 : (("background" === e || this.parameters.background) && (t.NOLIGHT = 1), this.parameters.flatShaded && (t.FLAT_SHADED = 1), this.parameters.opaqueBack && (t.OPAQUE_BACK = 1), this.parameters.diffuseInterior && (t.DIFFUSE_INTERIOR = 1), this.parameters.useInteriorColor && (t.USE_INTERIOR_COLOR = 1)), t;
          }, ag.prototype.getParameters = function () {
            return this.parameters;
          }, ag.prototype.addUniforms = function (e) {
            this.uniforms = De.merge([this.uniforms, e]), this.pickingUniforms = De.merge([this.pickingUniforms, e]);
          }, ag.prototype.addAttributes = function (e) {
            for (var t in e) {
              var n = void 0,
                r = e[t],
                i = this.attributeSize * ng[r.type];
              r.value ? (i !== r.value.length && Zc.error("attribute value has wrong length", t), n = r.value) : n = ju("float32", i), this.geometry.addAttribute(t, new Tt(n, ng[r.type]).setDynamic(this.dynamic));
            }
          }, ag.prototype.updateRenderOrder = function () {
            var e = this.getRenderOrder();
            function t(t) {
              t.renderOrder = e;
            }
            this.group.children.forEach(t), this.pickingGroup && this.pickingGroup.children.forEach(t);
          }, ag.prototype.updateShader = function () {
            var e = this.material,
              t = this.wireframeMaterial,
              n = this.pickingMaterial;
            e.vertexShader = this.getVertexShader(), e.fragmentShader = this.getFragmentShader(), e.needsUpdate = !0, t.vertexShader = this.getShader("Line.vert"), t.fragmentShader = this.getShader("Line.frag"), t.needsUpdate = !0, n.vertexShader = this.getVertexShader("picking"), n.fragmentShader = this.getFragmentShader("picking"), n.needsUpdate = !0;
          }, ag.prototype.setParameters = function (e) {
            var t = e,
              n = this.parameterTypes,
              r = this.parameters,
              i = {},
              o = {},
              a = !1,
              s = !1;
            for (var l in t) {
              var u = t[l];
              void 0 !== u && (r[l] = u, void 0 !== n[l] && (n[l].property && (!0 !== n[l].property ? i[n[l].property] = u : i[l] = u), n[l].uniform && (!0 !== n[l].uniform ? o[n[l].uniform] = u : o[l] = u), n[l].updateShader && (a = !0), n[l].updateVisibility && (s = !0), this.dynamic && "wireframe" === l && !0 === u && this.updateWireframeIndex(), "flatShaded" === l && (this.material.extensions.derivatives = this.parameters.flatShaded || this.isText), "forceTransparent" === l && (i.transparent = this.transparent), "matrix" === l && (this.matrix = u)));
            }
            this.setProperties(i), this.setUniforms(o), a && this.updateShader(), s && this.setVisibility(this.visible);
          }, ag.prototype.setAttributes = function (e) {
            var t = this.geometry,
              n = t.attributes;
            for (var r in e) if ("picking" !== r) {
              var i = e[r],
                o = i.length;
              if ("index" === r) {
                var a = t.getIndex();
                t.setDrawRange(0, 1 / 0), o > a.array.length ? t.setIndex(new Tt(i, 1).setDynamic(this.dynamic)) : (a.set(i), a.needsUpdate = 0 < o, a.updateRange.count = o, t.setDrawRange(0, o)), this.indexVersion++, this.parameters.wireframe && this.updateWireframeIndex();
              } else {
                var s = n[r];
                o > s.array.length ? t.addAttribute(r, new Tt(i, s.itemSize).setDynamic(this.dynamic)) : (n[r].set(i), n[r].needsUpdate = 0 < o, n[r].updateRange.count = o);
              }
            }
          }, ag.prototype.setUniforms = function (e) {
            if (e) {
              var t = this.material.uniforms,
                n = this.wireframeMaterial.uniforms,
                r = this.pickingMaterial.uniforms;
              for (var i in e) "opacity" === i && this.setProperties({
                transparent: this.transparent
              }), void 0 !== t[i] && (t[i].value.isVector3 ? t[i].value.copy(e[i]) : t[i].value.set ? t[i].value.set(e[i]) : t[i].value = e[i]), void 0 !== n[i] && (n[i].value.isVector3 ? n[i].value.copy(e[i]) : n[i].value.set ? n[i].value.set(e[i]) : n[i].value = e[i]), void 0 !== r[i] && (r[i].value.isVector3 ? r[i].value.copy(e[i]) : r[i].value.set ? r[i].value.set(e[i]) : r[i].value = e[i]);
            }
          }, ag.prototype.setProperties = function (e) {
            if (e) {
              var t = this.material,
                n = this.wireframeMaterial,
                r = this.pickingMaterial;
              for (var i in e) {
                var o = i,
                  a = e[o];
                "transparent" === o ? this.updateRenderOrder() : "side" === o && (a = tg(a)), t[o] = a, n[o] = a, r[o] = a;
              }
              t.needsUpdate = !0, n.needsUpdate = !0, r.needsUpdate = !0;
            }
          }, ag.prototype.setVisibility = function (e) {
            this.visible = e, this.parameters.wireframe ? (this.group.visible = !1, this.wireframeGroup.visible = e, this.pickable && (this.pickingGroup.visible = !1)) : (this.group.visible = e, this.wireframeGroup.visible = !1, this.pickable && (this.pickingGroup.visible = e));
          }, ag.prototype.dispose = function () {
            this.material && this.material.dispose(), this.wireframeMaterial && this.wireframeMaterial.dispose(), this.pickingMaterial && this.pickingMaterial.dispose(), this.geometry.dispose(), this.wireframeGeometry && this.wireframeGeometry.dispose();
          }, ag.prototype.toJSON = function () {
            var e = {};
            for (var t in this) "group" !== t && "wireframeGroup" !== t && "pickingGroup" != t && "picking" !== t && (e[t] = this[t]);
            return e;
          }, Object.defineProperties(ag.prototype, sg);
          var lg = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.vertexShader = "Mesh.vert", this.fragmentShader = "Mesh.frag", this.addAttributes({
                  normal: {
                    type: "v3",
                    value: t.normal
                  }
                }), void 0 === t.normal && this.geometry.computeVertexNormals();
              }
              return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            }(ag),
            ug = function (e) {
              function t() {
                e.apply(this, arguments), this.isSurface = !0;
              }
              return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            }(lg);
          function cg(e) {
            e.visible = !0;
          }
          function dg(e) {
            e.visible = !1;
          }
          var hg = function hg(e) {
              this.group = new xi(), this.wireframeGroup = new xi(), this.pickingGroup = new xi(), this.frontMeshes = [], this.backMeshes = [], this.size = e.size, this.side = e.parameters.side, this.visible = e.visible, this.geometry = e.geometry, this.picking = e.picking, this.group = new xi(), this.wireframeGroup = new xi(), this.pickingGroup = new xi(), this.matrix = e.matrix;
              var t = e,
                n = new e.constructor({
                  position: new Float32Array(0)
                });
              t.makeMaterial(), n.makeMaterial(), n.picking = e.picking, n.geometry = e.geometry, n.wireframeGeometry = e.wireframeGeometry, n.setParameters(e.getParameters()), n.updateShader(), t.setParameters({
                side: "front"
              }), n.setParameters({
                side: "back",
                opacity: n.parameters.opacity
              }), this.buffer = e, this.frontBuffer = t, this.backBuffer = n;
            },
            fg = {
              matrix: {
                configurable: !0
              },
              pickable: {
                configurable: !0
              },
              parameters: {
                configurable: !0
              }
            };
          fg.matrix.set = function (e) {
            ag.prototype.setMatrix.call(this, e);
          }, fg.matrix.get = function () {
            return this.group.matrix.clone();
          }, fg.pickable.get = function () {
            return !!this.picking && !this.parameters.disablePicking;
          }, fg.parameters.get = function () {
            return this.buffer.parameters;
          }, hg.prototype.getParameters = function () {
            var e = Object.assign({}, this.buffer.parameters);
            return e.side = this.side, e;
          }, hg.prototype.getMesh = function (e) {
            var t, n;
            return e ? (n = this.backBuffer.getPickingMesh(), t = this.frontBuffer.getPickingMesh()) : (n = this.backBuffer.getMesh(), t = this.frontBuffer.getMesh()), this.frontMeshes.push(t), this.backMeshes.push(n), this.setParameters({
              side: this.side
            }), new xi().add(n, t);
          }, hg.prototype.getWireframeMesh = function () {
            return this.buffer.getWireframeMesh();
          }, hg.prototype.getPickingMesh = function () {
            return this.getMesh(!0);
          }, hg.prototype.setAttributes = function (e) {
            this.buffer.setAttributes(e);
          }, hg.prototype.setParameters = function (e) {
            "front" === (e = Object.assign({}, e)).side ? (this.frontMeshes.forEach(cg), this.backMeshes.forEach(dg)) : "back" === e.side ? (this.frontMeshes.forEach(dg), this.backMeshes.forEach(cg)) : "double" === e.side && (this.frontMeshes.forEach(cg), this.backMeshes.forEach(cg)), void 0 !== e.side && (this.side = e.side), delete e.side, void 0 !== e.matrix && (this.matrix = e.matrix), delete e.matrix, this.frontBuffer.setParameters(e), void 0 !== e.wireframe && (this.wireframe = e.wireframe, this.setVisibility(this.visible)), delete e.wireframe, this.backBuffer.setParameters(e);
          }, hg.prototype.setVisibility = function (e) {
            this.visible = e, this.parameters.wireframe ? (this.group.visible = !1, this.wireframeGroup.visible = e, this.pickable && (this.pickingGroup.visible = !1)) : (this.group.visible = e, this.wireframeGroup.visible = !1, this.pickable && (this.pickingGroup.visible = e));
          }, hg.prototype.dispose = function () {
            this.frontBuffer.dispose(), this.backBuffer.dispose();
          }, hg.prototype.toJSON = function () {
            var e = {};
            for (var t in this) ["side", "size", "visible", "matrix", "parameters"].includes(t) && (e[t] = this[t]);
            return e;
          }, Object.defineProperties(hg.prototype, fg), od.add("shader/Line.vert", "uniform float clipNear;\nuniform vec3 clipCenter;\nvarying vec3 vViewPosition;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#include color_pars_vertex\nvoid main(){\n#include color_vertex\n#include begin_vertex\n#include project_vertex\nvViewPosition = -mvPosition.xyz;\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n#include nearclip_vertex\n}"), od.add("shader/Line.frag", "uniform float opacity;\nuniform float clipNear;\nuniform float clipRadius;\nvarying vec3 vViewPosition;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#include common\n#include color_pars_fragment\n#include fog_pars_fragment\nvoid main(){\n#include nearclip_fragment\n#include radiusclip_fragment\ngl_FragColor = vec4( vColor, opacity );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n}");
          var pg = function (e) {
              function t() {
                e.apply(this, arguments), this.isLine = !0, this.vertexShader = "Line.vert", this.fragmentShader = "Line.frag";
              }
              return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            }(ag),
            mg = function (e) {
              function t(t, n, r) {
                e.call(this, t, n, r), this.type = "surface", this.parameters = Object.assign({
                  isolevelType: {
                    type: "select",
                    options: {
                      value: "value",
                      sigma: "sigma"
                    }
                  },
                  isolevel: {
                    type: "number",
                    precision: 2,
                    max: 1e3,
                    min: -1e3
                  },
                  negateIsolevel: {
                    type: "boolean"
                  },
                  isolevelScroll: {
                    type: "boolean"
                  },
                  smooth: {
                    type: "integer",
                    precision: 1,
                    max: 10,
                    min: 0
                  },
                  background: {
                    type: "boolean",
                    rebuild: !0
                  },
                  opaqueBack: {
                    type: "boolean",
                    buffer: !0
                  },
                  boxSize: {
                    type: "integer",
                    precision: 1,
                    max: 100,
                    min: 0
                  },
                  colorVolume: {
                    type: "hidden"
                  },
                  contour: {
                    type: "boolean",
                    rebuild: !0
                  },
                  useWorker: {
                    type: "boolean",
                    rebuild: !0
                  },
                  wrap: {
                    type: "boolean",
                    rebuild: !0
                  }
                }, this.parameters), t instanceof Jm ? (this.surface = void 0, this.volume = t) : (this.surface = t, this.volume = void 0), this.boxCenter = new ae(), this.__boxCenter = new ae(), this.box = new Oe(), this.__box = new Oe(), this._position = new ae(), this.setBox = function () {
                  this._position.copy(n.translationGroup.position).negate(), this._position.equals(this.boxCenter) || this.setParameters({
                    boxCenter: this._position
                  });
                }, this.toBePrepared = !0, this.viewer.signals.ticked.add(this.setBox, this), this.init(r);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
                var n = t || {};
                n.colorScheme = wu(n.colorScheme, "uniform"), n.colorValue = wu(n.colorValue, 14540253), this.isolevelType = wu(n.isolevelType, "sigma"), this.isolevel = wu(n.isolevel, 2), this.negateIsolevel = wu(n.negateIsolevel, !1), this.isolevelScroll = wu(n.isolevelScroll, !1), this.smooth = wu(n.smooth, 0), this.background = wu(n.background, !1), this.opaqueBack = wu(n.opaqueBack, !0), this.boxSize = wu(n.boxSize, 0), this.colorVolume = wu(n.colorVolume, void 0), this.contour = wu(n.contour, !1), this.useWorker = wu(n.useWorker, !0), this.wrap = wu(n.wrap, !1), e.prototype.init.call(this, n), this.build();
              }, t.prototype.attach = function (e) {
                var t = this;
                this.bufferList.forEach(function (e) {
                  t.viewer.add(e);
                }), this.setVisibility(this.visible), e();
              }, t.prototype.prepare = function (e) {
                var t,
                  n = this;
                if (this.volume) {
                  if (t = "sigma" === this.isolevelType ? this.volume.getValueForSigma(this.isolevel) : this.isolevel, this.negateIsolevel && (t *= -1), !this.surface || this.__isolevel !== t || this.__smooth !== this.smooth || this.__contour !== this.contour || this.__wrap !== this.wrap || this.__boxSize !== this.boxSize || 0 < this.boxSize && !this.__boxCenter.equals(this.boxCenter)) {
                    this.__isolevel = t, this.__smooth = this.smooth, this.__contour = this.contour, this.__wrap = this.wrap, this.__boxSize = this.boxSize, this.__boxCenter.copy(this.boxCenter), this.__box.copy(this.box);
                    var r = function r(t) {
                      n.surface = t, e();
                    };
                    this.useWorker ? this.volume.getSurfaceWorker(t, this.smooth, this.boxCenter, this.boxSize, this.contour, this.wrap, r) : r(this.volume.getSurface(t, this.smooth, this.boxCenter, this.boxSize, this.contour, this.wrap));
                  } else e();
                } else e();
              }, t.prototype.create = function () {
                var e,
                  t = {
                    position: this.surface.getPosition(),
                    color: this.surface.getColor(this.getColorParams()),
                    index: this.surface.getIndex()
                  };
                if (this.contour) e = new pg(t, this.getBufferParams({
                  wireframe: !1
                }));else {
                  Object.assign(t, {
                    normal: this.surface.getNormal(),
                    picking: this.surface.getPicking()
                  });
                  var n = new ug(t, this.getBufferParams({
                    background: this.background,
                    opaqueBack: this.opaqueBack,
                    dullInterior: !1
                  }));
                  e = new hg(n);
                }
                this.bufferList.push(e);
              }, t.prototype.update = function (e) {
                if (0 !== this.bufferList.length) {
                  var t = {};
                  (e = e || {}).position && (t.position = this.surface.getPosition()), e.color && (t.color = this.surface.getColor(this.getColorParams())), e.index && (t.index = this.surface.getIndex()), e.normal && (t.normal = this.surface.getNormal()), this.bufferList.forEach(function (e) {
                    e.setAttributes(t);
                  });
                }
              }, t.prototype.setParameters = function (t, n, r) {
                return t && void 0 !== t.isolevelType && this.volume && ("value" === this.isolevelType && "sigma" === t.isolevelType ? this.isolevel = this.volume.getSigmaForValue(this.isolevel) : "sigma" === this.isolevelType && "value" === t.isolevelType && (this.isolevel = this.volume.getValueForSigma(this.isolevel)), this.isolevelType = t.isolevelType), t && t.boxCenter && (this.boxCenter.copy(t.boxCenter), delete t.boxCenter), t && t.wireframe && (t.contour || void 0 === t.contour && this.contour) && (t.wireframe = !1), e.prototype.setParameters.call(this, t, n, r), this.volume && this.volume.getBox(this.boxCenter, this.boxSize, this.box), t && void 0 !== t.colorVolume && n && (n.color = !0), this.surface && (void 0 !== t.isolevel || void 0 !== t.negateIsolevel || void 0 !== t.smooth || void 0 !== t.wrap || void 0 !== t.boxSize || 0 < this.boxSize && !this.__box.equals(this.box)) && this.build({
                  position: !0,
                  color: !0,
                  index: !0,
                  normal: !this.contour
                }), this;
              }, t.prototype.getColorParams = function () {
                var t = e.prototype.getColorParams.call(this);
                return t.volume = this.colorVolume, t;
              }, t.prototype.dispose = function () {
                this.viewer.signals.ticked.remove(this.setBox, this), e.prototype.dispose.call(this);
              }, t;
            }(lf),
            gg = function gg() {};
          gg.zoomScroll = function (e, t) {
            e.trackballControls.zoom(t);
          }, gg.clipNearScroll = function (e, t) {
            var n = e.getParameters();
            e.setParameters({
              clipNear: n.clipNear + t / 10
            });
          }, gg.focusScroll = function (e, t) {
            var n = 2 * e.getParameters().clipNear,
              r = Math.sign(t) * function (e, t, n) {
                if (5 < e) return e;
                var r = e / 5;
                return (-4.6 * r + 9.4) * r * r + .2;
              }((100 - n) / 10);
            e.setFocus(n + r);
          }, gg.zoomFocusScroll = function (e, t) {
            e.trackballControls.zoom(t);
            var n = e.viewer.camera.position.z;
            e.setFocus(100 - Math.abs(n / 8));
          }, gg.isolevelScroll = function (e, t) {
            var n = Math.sign(t) / 10;
            e.eachRepresentation(function (e, t) {
              if (e.repr instanceof mg) {
                var r = e.getParameters();
                r.isolevelScroll && e.setParameters({
                  isolevel: r.isolevel + n
                });
              }
            });
          }, gg.panDrag = function (e, t, n) {
            e.trackballControls.pan(t, n);
          }, gg.rotateDrag = function (e, t, n) {
            e.trackballControls.rotate(t, n);
          }, gg.zRotateDrag = function (e, t, n) {
            e.trackballControls.zRotate(t, n);
          }, gg.zoomDrag = function (e, t, n) {
            e.trackballControls.zoom((t + n) / -2);
          }, gg.zoomFocusDrag = function (e, t, n) {
            e.trackballControls.zoom((t + n) / -2);
            var r = e.viewer.camera.position.z;
            e.setFocus(100 - Math.abs(r / 8));
          }, gg.panComponentDrag = function (e, t, n) {
            e.trackballControls.panComponent(t, n);
          }, gg.panAtomDrag = function (e, t, n) {
            e.trackballControls.panAtom(t, n);
          }, gg.rotateComponentDrag = function (e, t, n) {
            e.trackballControls.rotateComponent(t, n);
          }, gg.movePick = function (e, t) {
            t && e.animationControls.move(t.position.clone());
          }, gg.tooltipPick = function (e, t) {
            var n = e.tooltip;
            if (e.getParameters().tooltip && t) {
              var r = t.mouse.position;
              n.innerText = t.getLabel(), n.style.bottom = window.innerHeight - r.y + 3 + "px", n.style.left = r.x + 3 + "px", n.style.display = "block";
            } else n.style.display = "none";
          };
          var vg = {
            default: [["scroll", gg.zoomScroll], ["scroll-shift", gg.focusScroll], ["scroll-ctrl", gg.isolevelScroll], ["scroll-shift-ctrl", gg.zoomFocusScroll], ["drag-left", gg.rotateDrag], ["drag-right", gg.panDrag], ["drag-ctrl-left", gg.panDrag], ["drag-ctrl-right", gg.zRotateDrag], ["drag-shift-left", gg.zoomDrag], ["drag-middle", gg.zoomFocusDrag], ["drag-ctrl-shift-right", gg.panComponentDrag], ["drag-ctrl-shift-left", gg.rotateComponentDrag], ["clickPick-right", gg.measurePick = function (e, t) {
              if (t && (t.atom || t.bond)) {
                var n = t.atom || t.closestBondAtom;
                t.component.measurePick(n);
              } else e.measureClear();
            }], ["clickPick-ctrl-left", gg.measurePick], ["clickPick-middle", gg.movePick], ["clickPick-left", gg.movePick], ["hoverPick", gg.tooltipPick]],
            pymol: [["drag-left", gg.rotateDrag], ["drag-middle", gg.panDrag], ["drag-right", gg.zoomDrag], ["drag-shift-right", gg.focusScroll], ["clickPick-ctrl+shift-middle", gg.movePick], ["hoverPick", gg.tooltipPick]],
            coot: [["scroll", gg.isolevelScroll], ["drag-left", gg.rotateDrag], ["drag-middle", gg.panDrag], ["drag-ctrl-left", gg.panDrag], ["drag-right", gg.zoomFocusDrag], ["drag-ctrl-right", gg.focusScroll], ["clickPick-middle", gg.movePick], ["hoverPick", gg.tooltipPick]],
            astexviewer: [["drag-left", gg.rotateDrag], ["drag-ctrl-left", gg.panDrag], ["drag-shift-left", gg.zoomDrag], ["scroll", gg.focusScroll], ["clickPick-middle", gg.movePick], ["hoverPick", gg.tooltipPick]]
          };
          function yg(e) {
            var t = e.split(/[-+]/),
              n = "";
            t.includes("scroll") && (n = "scroll"), t.includes("drag") && (n = "drag"), t.includes("click") && (n = "click"), t.includes("doubleClick") && (n = "doubleClick"), t.includes("hover") && (n = "hover"), t.includes("clickPick") && (n = "clickPick"), t.includes("hoverPick") && (n = "hoverPick");
            var r = 0;
            t.includes("alt") && (r += 1), t.includes("ctrl") && (r += 2), t.includes("meta") && (r += 4), t.includes("shift") && (r += 8);
            var i = 0;
            return t.includes("left") && (i += 1), t.includes("right") && (i += 2), t.includes("middle") && (i += 4), [n, r, i];
          }
          var bg = function bg(e, t) {
            void 0 === t && (t = {}), this.stage = e, this.actionList = [], this.mouse = e.mouseObserver, this.disabled = t.disabled || !1, this.preset(t.preset || "default");
          };
          bg.prototype.run = function (e) {
            for (var t = this, n = [], r = arguments.length - 1; 0 < r--;) n[r] = arguments[r + 1];
            if (!this.disabled) {
              var i = this.mouse.key || 0,
                o = this.mouse.buttons || 0;
              this.actionList.forEach(function (r) {
                r.type === e && r.key === i && r.button === o && r.callback.apply(r, [t.stage].concat(n));
              });
            }
          }, bg.prototype.add = function (e, t) {
            var n = yg(e),
              r = n[0],
              i = n[1],
              o = n[2];
            this.actionList.push({
              type: r,
              key: i,
              button: o,
              callback: t
            });
          }, bg.prototype.remove = function (e, t) {
            var n = e.includes("*"),
              r = yg(e),
              i = r[0],
              o = r[1],
              a = r[2],
              s = this.actionList.filter(function (e) {
                return !((e.type === i || n && "" === i) && (e.key === o || n && 0 === o) && (e.button === a || n && 0 === a) && (e.callback === t || void 0 === t));
              });
            this.actionList = s;
          }, bg.prototype.preset = function (e) {
            var t = this;
            this.clear(), (vg[e] || []).forEach(function (e) {
              return t.add(e[0], e[1]);
            });
          }, bg.prototype.clear = function () {
            this.actionList.length = 0;
          };
          var _g = function _g() {};
          _g.autoView = function (e) {
            e.autoView(1e3);
          }, _g.toggleAnimations = function (e) {
            e.animationControls.toggle();
          }, _g.toggleRock = function (e) {
            e.toggleRock();
          };
          var xg = {
              default: [["i", _g.toggleSpin = function (e) {
                e.toggleSpin();
              }], ["k", _g.toggleRock], ["p", _g.toggleAnimations], ["a", _g.toggleAntialiasing = function (e) {
                var t = e.getParameters();
                e.setParameters({
                  sampleLevel: -1 === t.sampleLevel ? 0 : -1
                });
              }], ["r", _g.autoView]]
            },
            wg = function wg(e, t) {
              void 0 === t && (t = {}), this.stage = e, this.actionList = [], this.disabled = t.disabled || !1, this.preset(t.preset || "default");
            };
          wg.prototype.run = function (e) {
            var t = this;
            this.disabled || this.actionList.forEach(function (n) {
              n.key === e && n.callback(t.stage);
            });
          }, wg.prototype.add = function (e, t) {
            this.actionList.push({
              key: e,
              callback: t
            });
          }, wg.prototype.remove = function (e, t) {
            var n = this.actionList.filter(function (n) {
              return !(n.key === e && (n.callback === t || void 0 === t));
            });
            this.actionList = n;
          }, wg.prototype.preset = function (e) {
            var t = this;
            this.clear(), (xg[e] || []).forEach(function (e) {
              return t.add(e[0], e[1]);
            });
          }, wg.prototype.clear = function () {
            this.actionList.length = 0;
          };
          var Sg = function Sg(e) {
            this.stage = e, this.stage = e, this.mouse = e.mouseObserver, this.controls = e.mouseControls, this.mouse.signals.clicked.add(this._onClick, this), this.mouse.signals.hovered.add(this._onHover, this);
          };
          Sg.prototype._onClick = function (e, t) {
            var n = this.stage.pickingControls.pick(e, t);
            this.stage.signals.clicked.dispatch(n), this.controls.run("clickPick", n);
          }, Sg.prototype._onHover = function (e, t) {
            var n = this.stage.pickingControls.pick(e, t);
            n && this.mouse.down.equals(this.mouse.position) && (this.stage.transformComponent = n.component, this.stage.transformAtom = n.atom), this.stage.signals.hovered.dispatch(n), this.controls.run("hoverPick", n);
          }, Sg.prototype.dispose = function () {
            this.mouse.signals.clicked.remove(this._onClick, this), this.mouse.signals.hovered.remove(this._onHover, this);
          };
          var Ag = function Ag(e) {
            this.stage = e, this.stage = e, this.mouse = e.mouseObserver, this.controls = e.mouseControls, this.mouse.signals.moved.add(this._onMove, this), this.mouse.signals.scrolled.add(this._onScroll, this), this.mouse.signals.dragged.add(this._onDrag, this), this.mouse.signals.clicked.add(this._onClick, this), this.mouse.signals.hovered.add(this._onHover, this), this.mouse.signals.doubleClicked.add(this._onDblclick, this);
          };
          Ag.prototype._onMove = function () {
            this.stage.tooltip.style.display = "none";
          }, Ag.prototype._onScroll = function (e) {
            this.controls.run("scroll", e);
          }, Ag.prototype._onDrag = function (e, t) {
            this.controls.run("drag", e, t);
          }, Ag.prototype._onClick = function (e, t) {
            this.controls.run("click", e, t);
          }, Ag.prototype._onDblclick = function (e, t) {
            this.controls.run("doubleClick", e, t);
          }, Ag.prototype._onHover = function (e, t) {
            this.controls.run("hover", e, t);
          }, Ag.prototype.dispose = function () {
            this.mouse.signals.moved.remove(this._onMove, this), this.mouse.signals.scrolled.remove(this._onScroll, this), this.mouse.signals.dragged.remove(this._onDrag, this), this.mouse.signals.clicked.remove(this._onClick, this), this.mouse.signals.hovered.remove(this._onHover, this);
          };
          var Eg = function Eg(e) {
            this.stage = e, this.viewer = e.viewer, this.animationControls = e.animationControls, this.viewer.signals.ticked.add(this._onTick, this);
          };
          Eg.prototype._onTick = function (e) {
            this.animationControls.run(e);
          }, Eg.prototype.dispose = function () {
            this.viewer.signals.ticked.remove(this._onTick, this);
          };
          var Tg = !!qc && {
              passive: !0
            },
            Mg = function Mg(e) {
              this.stage = e, this.stage = e, this.controls = e.keyControls, this.domElement = e.viewer.renderer.domElement, this.domElement.setAttribute("tabIndex", "-1"), this.domElement.style.outline = "none", this._focusDomElement = this._focusDomElement.bind(this), this._onKeydown = this._onKeydown.bind(this), this._onKeyup = this._onKeyup.bind(this), this._onKeypress = this._onKeypress.bind(this), this.domElement.addEventListener("mousedown", this._focusDomElement), this.domElement.addEventListener("touchstart", this._focusDomElement, Tg), this.domElement.addEventListener("keydown", this._onKeydown), this.domElement.addEventListener("keyup", this._onKeyup), this.domElement.addEventListener("keypress", this._onKeypress);
            };
          Mg.prototype._onKeydown = function () {}, Mg.prototype._onKeyup = function () {}, Mg.prototype._onKeypress = function (e) {
            var t;
            t = "key" in KeyboardEvent.prototype ? e.key : String.fromCharCode(e.which || e.keyCode), this.controls.run(t);
          }, Mg.prototype._focusDomElement = function () {
            this.domElement.focus();
          }, Mg.prototype.dispose = function () {
            this.domElement.removeEventListener("mousedown", this._focusDomElement), this.domElement.removeEventListener("touchstart", this._focusDomElement, Tg), this.domElement.removeEventListener("keydown", this._onKeypress), this.domElement.removeEventListener("keyup", this._onKeypress), this.domElement.removeEventListener("keypress", this._onKeypress);
          };
          var Cg = function Cg(e, t, n, r) {
            void 0 === r && (r = {}), this.component = e, this.position = t, this.offsetX = wu(r.offsetX, 0), this.offsetY = wu(r.offsetY, 0), this.visible = wu(r.visible, !0), this.stage = e.stage, this.viewer = e.stage.viewer, this._viewerPosition = new ae(), this._updateViewerPosition(), this._canvasPosition = new re(), this._cameraPosition = new ae(), this.element = document.createElement("div"), Object.assign(this.element.style, {
              display: "block",
              position: "absolute",
              pointerEvents: "none",
              whiteSpace: "nowrap",
              left: "-10000px"
            }), this.viewer.wrapper.appendChild(this.element), this.setContent(n), this.updateVisibility(), this.viewer.signals.rendered.add(this._update, this), this.component.signals.matrixChanged.add(this._updateViewerPosition, this);
          };
          Cg.prototype.setContent = function (e) {
            var t = this.element.style.display;
            if ("none" === t && (this.element.style.left = "-10000px", this.element.style.display = "block"), e instanceof HTMLElement) this.element.appendChild(e);else {
              var n = document.createElement("div");
              n.innerText = e, Object.assign(n.style, {
                backgroundColor: "rgba( 0, 0, 0, 0.6 )",
                color: "lightgrey",
                padding: "8px",
                fontFamily: "sans-serif"
              }), this.element.appendChild(n);
            }
            this._clientRect = this.element.getBoundingClientRect(), "none" === t && (this.element.style.display = t);
          }, Cg.prototype.setVisibility = function (e) {
            this.visible = e, this.updateVisibility();
          }, Cg.prototype.getVisibility = function () {
            return this.visible && this.component.parameters.visible;
          }, Cg.prototype.updateVisibility = function () {
            this.element.style.display = this.getVisibility() ? "block" : "none";
          }, Cg.prototype._updateViewerPosition = function () {
            this._viewerPosition.copy(this.position).applyMatrix4(this.component.matrix);
          }, Cg.prototype._update = function () {
            if (this.getVisibility()) {
              var e = this.element.style,
                t = this._canvasPosition,
                n = this._viewerPosition,
                r = this._clientRect;
              if (this._cameraPosition.copy(n).add(this.viewer.translationGroup.position).applyMatrix4(this.viewer.rotationGroup.matrix).sub(this.viewer.camera.position), this._cameraPosition.z < 0) e.display = "none";else {
                e.display = "block";
                var i = this._cameraPosition.length(),
                  o = this.viewer.scene.fog;
                e.opacity = (1 - Ju(o.near, o.far, i)).toString(), e.zIndex = Math.round(100 * (o.far - i)).toString(), this.stage.viewerControls.getPositionOnCanvas(n, t), e.bottom = this.offsetX + t.y + r.height / 2 + "px", e.left = this.offsetY + t.x - r.width / 2 + "px";
              }
            }
          }, Cg.prototype.dispose = function () {
            this.viewer.wrapper.removeChild(this.element), this.viewer.signals.ticked.remove(this._update, this), this.component.signals.matrixChanged.remove(this._updateViewerPosition, this);
          };
          var kg = new ie(),
            Pg = new ae(),
            Og = new oe(),
            Rg = function Rg(e) {
              this.component = e, this.signals = {
                changed: new lc()
              }, this.stage = e.stage, this.viewer = e.stage.viewer;
            },
            Ig = {
              position: {
                configurable: !0
              },
              rotation: {
                configurable: !0
              }
            };
          Ig.position.get = function () {
            return this.component.position;
          }, Ig.rotation.get = function () {
            return this.component.quaternion;
          }, Rg.prototype.changed = function () {
            this.component.updateMatrix(), this.viewer.requestRender(), this.signals.changed.dispatch();
          }, Rg.prototype.spin = function (e, t) {
            kg.getInverse(this.viewer.rotationGroup.matrix), Pg.copy(Bu(e)).applyMatrix4(kg), kg.extractRotation(this.component.transform), kg.premultiply(this.viewer.rotationGroup.matrix), kg.getInverse(kg), Pg.copy(Bu(e)), Pg.applyMatrix4(kg), kg.makeRotationAxis(Pg, t), Og.setFromRotationMatrix(kg), this.component.quaternion.premultiply(Og), this.changed();
          }, Object.defineProperties(Rg.prototype, Ig);
          var jg = {
              "": "",
              vdw: "by vdW radius",
              covalent: "by covalent radius",
              sstruc: "by secondary structure",
              bfactor: "by bfactor",
              size: "size",
              data: "data",
              explicit: "explicit"
            },
            Ng = function Ng(e) {
              void 0 === e && (e = {}), this.max = 10, this.type = wu(e.type, "size"), this.scale = wu(e.scale, 1), this.size = wu(e.size, 1), this.data = wu(e.data, {});
            };
          Ng.prototype.atomRadius = function (e) {
            var t;
            switch (this.type) {
              case "vdw":
                t = e.vdw;
                break;
              case "covalent":
                t = e.covalent;
                break;
              case "bfactor":
                t = e.bfactor || 1;
                break;
              case "sstruc":
                var n = e.sstruc;
                t = "h" === n || "g" === n || "i" === n || "e" === n || "b" === n ? .25 : Op.includes(e.atomname) ? .4 : .1;
                break;
              case "data":
                t = wu(this.data[e.index], 1);
                break;
              case "explicit":
                null === (t = e.radius) && (t = this.size);
                break;
              default:
                t = this.size;
            }
            return Math.min(t * this.scale, this.max);
          }, Ng.types = jg;
          var Lg = new ae(-1, -1, -1),
            Dg = new ie(),
            Bg = function Bg(e) {
              var t = e.rows,
                n = t / 3,
                r = new Pm(t, 3),
                i = new Pm(3, 3),
                o = new Pm(1, 3),
                a = new Pm(3, 3),
                s = new Pm(3, 3),
                l = jm(e);
              Nm(e, l), Om(r, e), Rm(i, r, r), Dm(i, o, a, s);
              var u = new ae(l[0], l[1], l[2]),
                c = new ae(a.data[0], a.data[3], a.data[6]),
                d = new ae(a.data[1], a.data[4], a.data[7]),
                h = new ae(a.data[2], a.data[5], a.data[8]),
                f = c.clone().multiplyScalar(Math.sqrt(o.data[0] / n)),
                p = d.clone().multiplyScalar(Math.sqrt(o.data[1] / n)),
                m = h.clone().multiplyScalar(Math.sqrt(o.data[2] / n));
              this.begA = u.clone().sub(f), this.endA = u.clone().add(f), this.begB = u.clone().sub(p), this.endB = u.clone().add(p), this.begC = u.clone().sub(m), this.endC = u.clone().add(m), this.center = u, this.vecA = f, this.vecB = p, this.vecC = m, this.normVecA = c, this.normVecB = d, this.normVecC = h;
            };
          Bg.prototype.getBasisMatrix = function (e) {
            void 0 === e && (e = new ie());
            var t = e;
            return t.makeBasis(this.normVecB, this.normVecA, this.normVecC), t.determinant() < 0 && t.scale(Lg), t;
          }, Bg.prototype.getRotationQuaternion = function (e) {
            void 0 === e && (e = new oe());
            var t = e;
            return t.setFromRotationMatrix(this.getBasisMatrix(Dg)), t.inverse();
          }, Bg.prototype.getProjectedScaleForAtoms = function (e) {
            var t = -1 / 0,
              n = -1 / 0,
              r = -1 / 0,
              i = -1 / 0,
              o = -1 / 0,
              a = -1 / 0,
              s = new ae(),
              l = new ae(),
              u = this.center,
              c = this.normVecA,
              d = this.normVecB,
              h = this.normVecC;
            return e.eachAtom(function (e) {
              hf(s.copy(e), c, u);
              var f = l.subVectors(s, u).normalize().dot(c),
                p = s.distanceTo(u);
              0 < f ? t < p && (t = p) : n < p && (n = p), hf(s.copy(e), d, u);
              var m = l.subVectors(s, u).normalize().dot(d),
                g = s.distanceTo(u);
              0 < m ? r < g && (r = g) : i < g && (i = g), hf(s.copy(e), h, u);
              var v = l.subVectors(s, u).normalize().dot(h),
                y = s.distanceTo(u);
              0 < v ? o < y && (o = y) : a < y && (a = y);
            }), {
              d1a: t,
              d2a: r,
              d3a: o,
              d1b: -n,
              d2b: -i,
              d3b: -a
            };
          };
          var Fg = function Fg(e, t, n, r) {
              this.volume = e, this.setFilter(t, n, r);
            },
            zg = {
              header: {
                configurable: !0
              },
              matrix: {
                configurable: !0
              },
              normalMatrix: {
                configurable: !0
              },
              inverseMatrix: {
                configurable: !0
              },
              center: {
                configurable: !0
              },
              boundingBox: {
                configurable: !0
              },
              min: {
                configurable: !0
              },
              max: {
                configurable: !0
              },
              mean: {
                configurable: !0
              },
              rms: {
                configurable: !0
              }
            };
          zg.header.get = function () {
            return this.volume.header;
          }, zg.matrix.get = function () {
            return this.volume.matrix;
          }, zg.normalMatrix.get = function () {
            return this.volume.normalMatrix;
          }, zg.inverseMatrix.get = function () {
            return this.volume.inverseMatrix;
          }, zg.center.get = function () {
            return this.volume.center;
          }, zg.boundingBox.get = function () {
            return this.volume.boundingBox;
          }, zg.min.get = function () {
            return this.volume.min;
          }, zg.max.get = function () {
            return this.volume.max;
          }, zg.mean.get = function () {
            return this.volume.mean;
          }, zg.rms.get = function () {
            return this.volume.rms;
          }, Fg.prototype._getFilterHash = function (e, t, n) {
            return JSON.stringify([e, t, n]);
          }, Fg.prototype.setFilter = function (e, t, n) {
            isNaN(e) && this.header && (e = this.header.DMEAN + 2 * this.header.ARMS), e = void 0 === e || isNaN(e) ? -1 / 0 : e, t = wu(t, 1 / 0), n = wu(n, !1);
            var r = this.volume.data,
              i = this.volume.position,
              o = this.volume.atomindex,
              a = this._getFilterHash(e, t, n);
            if (a !== this._filterHash) {
              if (e === -1 / 0 && t === 1 / 0) this.data = r, this.position = i, this.atomindex = o;else {
                var s = r.length;
                this._dataBuffer || (this._dataBuffer = new ArrayBuffer(4 * s), this._positionBuffer = new ArrayBuffer(3 * s * 4), o && (this._atomindexBuffer = new ArrayBuffer(4 * s)));
                var l,
                  u = new Float32Array(this._dataBuffer),
                  c = new Float32Array(this._positionBuffer);
                o && (l = new Uint32Array(this._atomindexBuffer));
                for (var d = 0, h = 0; h < s; ++h) {
                  var f = 3 * h,
                    p = r[h];
                  if (!n && e <= p && p <= t || n && (p < e || t < p)) {
                    var m = 3 * d;
                    u[d] = p, c[m + 0] = i[f + 0], c[m + 1] = i[f + 1], c[m + 2] = i[f + 2], o && l && (l[d] = o[h]), d += 1;
                  }
                }
                this.data = new Float32Array(this._dataBuffer, 0, d), this.position = new Float32Array(this._positionBuffer, 0, 3 * d), o && (this.atomindex = new Int32Array(this._atomindexBuffer, 0, d));
              }
              this._filterHash = a;
            }
          }, Object.defineProperties(Fg.prototype, zg), Fg.prototype.getValueForSigma = Jm.prototype.getValueForSigma, Fg.prototype.getSigmaForValue = Jm.prototype.getSigmaForValue, Fg.prototype.getDataAtomindex = Jm.prototype.getDataAtomindex, Fg.prototype.getDataPosition = Jm.prototype.getDataPosition, Fg.prototype.getDataColor = Jm.prototype.getDataColor, Fg.prototype.getDataPicking = Jm.prototype.getDataPicking, Fg.prototype.getDataSize = Jm.prototype.getDataSize;
          var Ug = function Ug(e, t) {
              var n = np({
                nodeArray1: e.atomIndex1,
                nodeArray2: e.atomIndex2,
                edgeCount: e.count,
                nodeCount: t
              });
              this.countArray = n.countArray, this.offsetArray = n.offsetArray, this.indexArray = n.indexArray;
            },
            Gg = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                _defaultFields: {
                  configurable: !0
                }
              };
              return n._defaultFields.get = function () {
                return [["atomIndex1", 1, "int32"], ["atomIndex2", 1, "int32"], ["bondOrder", 1, "int8"]];
              }, t.prototype.addBond = function (e, t, n) {
                this.growIfFull();
                var r = this.count,
                  i = e.index,
                  o = t.index;
                i < o ? (this.atomIndex1[r] = i, this.atomIndex2[r] = o) : (this.atomIndex2[r] = i, this.atomIndex1[r] = o), n && (this.bondOrder[r] = n), this.count += 1;
              }, t.prototype.addBondIfConnected = function (e, t, n) {
                return !!e.connectedTo(t) && (this.addBond(e, t, n), !0);
              }, Object.defineProperties(t.prototype, n), t;
            }(Qf),
            Vg = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                _defaultFields: {
                  configurable: !0
                }
              };
              return n._defaultFields.get = function () {
                return [["residueIndex", 1, "uint32"], ["atomTypeId", 1, "uint16"], ["x", 1, "float32"], ["y", 1, "float32"], ["z", 1, "float32"], ["serial", 1, "int32"], ["bfactor", 1, "float32"], ["altloc", 1, "uint8"], ["occupancy", 1, "float32"]];
              }, t.prototype.setAltloc = function (e, t) {
                this.altloc[e] = t.charCodeAt(0);
              }, t.prototype.getAltloc = function (e) {
                var t = this.altloc[e];
                return t ? String.fromCharCode(t) : "";
              }, Object.defineProperties(t.prototype, n), t;
            }(Qf),
            Hg = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                _defaultFields: {
                  configurable: !0
                }
              };
              return n._defaultFields.get = function () {
                return [["chainIndex", 1, "uint32"], ["atomOffset", 1, "uint32"], ["atomCount", 1, "uint16"], ["residueTypeId", 1, "uint16"], ["resno", 1, "int32"], ["sstruc", 1, "uint8"], ["inscode", 1, "uint8"]];
              }, t.prototype.setSstruc = function (e, t) {
                this.sstruc[e] = t.charCodeAt(0);
              }, t.prototype.getSstruc = function (e) {
                var t = this.sstruc[e];
                return t ? String.fromCharCode(t) : "";
              }, t.prototype.setInscode = function (e, t) {
                this.inscode[e] = t.charCodeAt(0);
              }, t.prototype.getInscode = function (e) {
                var t = this.inscode[e];
                return t ? String.fromCharCode(t) : "";
              }, Object.defineProperties(t.prototype, n), t;
            }(Qf),
            qg = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                _defaultFields: {
                  configurable: !0
                }
              };
              return n._defaultFields.get = function () {
                return [["entityIndex", 1, "uint16"], ["modelIndex", 1, "uint16"], ["residueOffset", 1, "uint32"], ["residueCount", 1, "uint32"], ["chainname", 4, "uint8"], ["chainid", 4, "uint8"]];
              }, t.prototype.setChainname = function (e, t) {
                var n = 4 * e;
                this.chainname[n] = t.charCodeAt(0), this.chainname[n + 1] = t.charCodeAt(1), this.chainname[n + 2] = t.charCodeAt(2), this.chainname[n + 3] = t.charCodeAt(3);
              }, t.prototype.getChainname = function (e) {
                for (var t = "", n = 0; n < 4; ++n) {
                  var r = this.chainname[4 * e + n];
                  if (!r) break;
                  t += String.fromCharCode(r);
                }
                return t;
              }, t.prototype.setChainid = function (e, t) {
                var n = 4 * e;
                this.chainid[n] = t.charCodeAt(0), this.chainid[n + 1] = t.charCodeAt(1), this.chainid[n + 2] = t.charCodeAt(2), this.chainid[n + 3] = t.charCodeAt(3);
              }, t.prototype.getChainid = function (e) {
                for (var t = "", n = 0; n < 4; ++n) {
                  var r = this.chainid[4 * e + n];
                  if (!r) break;
                  t += String.fromCharCode(r);
                }
                return t;
              }, Object.defineProperties(t.prototype, n), t;
            }(Qf),
            Wg = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                _defaultFields: {
                  configurable: !0
                }
              };
              return n._defaultFields.get = function () {
                return [["chainOffset", 1, "uint32"], ["chainCount", 1, "uint32"]];
              }, Object.defineProperties(t.prototype, n), t;
            }(Qf),
            $g = function $g(e) {
              this.polymer = e, this.size = e.residueCount;
            };
          $g.prototype.getCenterIterator = function (e) {
            void 0 === e && (e = 0);
            var t = this.getPosition().center,
              n = t.length / 3,
              r = 0,
              i = -1,
              o = [new ae(), new ae(), new ae(), new ae()];
            return {
              size: n,
              next: function next() {
                var e = this.get(i);
                return i += 1, e;
              },
              get: function get(i) {
                i = Math.min(n - 1, Math.max(0, i));
                var a = o[r % 4],
                  s = 3 * i;
                if (a.fromArray(t, s), e) {
                  for (var l = Math.min(e, i, n - i - 1), u = 1; u <= l; ++u) {
                    var c = 3 * u,
                      d = (l + 1 - u) / (l + 1);
                    a.x += d * t[s - c + 0] + d * t[s + c + 0], a.y += d * t[s - c + 1] + d * t[s + c + 1], a.z += d * t[s - c + 2] + d * t[s + c + 2];
                  }
                  a.x /= l + 1, a.y /= l + 1, a.z /= l + 1;
                }
                return r += 1, a;
              },
              reset: function reset() {
                r = 0, i = -1;
              }
            };
          }, $g.prototype.getColor = function (e) {
            var t = this.polymer,
              n = t.structure,
              r = t.residueCount,
              i = t.residueIndexStart,
              o = new Float32Array(3 * r),
              a = e || {};
            a.structure = n;
            for (var s = td.getScheme(a), l = n.getResidueProxy(), u = n.getAtomProxy(), c = 0; c < r; ++c) l.index = i + c, u.index = l.traceAtomIndex, s.atomColorToArray(u, o, 3 * c);
            return {
              color: o
            };
          }, $g.prototype.getPicking = function () {
            for (var e = this.polymer, t = e.structure, n = e.residueCount, r = e.residueIndexStart, i = new Float32Array(n), o = t.getResidueProxy(), a = 0; a < n; ++a) o.index = r + a, i[a] = o.traceAtomIndex;
            return {
              picking: new am(i, t)
            };
          }, $g.prototype.getSize = function (e) {
            for (var t = this.polymer, n = t.structure, r = t.residueCount, i = t.residueIndexStart, o = new Float32Array(r), a = new Ng(e), s = n.getResidueProxy(), l = n.getAtomProxy(), u = 0; u < r; ++u) s.index = i + u, l.index = s.traceAtomIndex, o[u] = a.atomRadius(l);
            return {
              size: o
            };
          }, $g.prototype.getPosition = function () {
            for (var e = this.polymer, t = e.structure, n = e.residueCount, r = n - 3, i = new Float32Array(3 * n), o = new Float32Array(3 * n), a = new Float32Array(n), s = new Float32Array(n), l = new Float32Array(n), u = new Float32Array(n), c = new Float32Array(3 * n), d = new ae(), h = new ae(), f = new ae(), p = new ae(), m = new ae(), g = new ae(), v = new ae(), y = new ae(), b = new ae(), _ = new ae(), x = new ae(), w = new ae(0, 0, 0), S = "trace", A = t.getAtomProxy(), E = t.getAtomProxy(e.getAtomIndexByType(0, S)), T = t.getAtomProxy(e.getAtomIndexByType(1, S)), M = t.getAtomProxy(e.getAtomIndexByType(2, S)), C = 0; C < r; ++C) {
              A.index = E.index, E.index = T.index, T.index = M.index, M.index = e.getAtomIndexByType(C + 3, S);
              var k = 3 * C;
              d.subVectors(E, A), h.subVectors(T, E), f.subVectors(M, T), p.subVectors(d, h), m.subVectors(h, f), b.crossVectors(p, m).normalize(), b.toArray(o, k), 0 < C && (a[C] = b.angleTo(_));
              var P = Math.cos(p.angleTo(m));
              u[C] = 180 / Math.PI * Math.acos(P);
              var O = p.length(),
                R = m.length();
              s[C] = Math.sqrt(R * O) / Math.max(2, 2 * (1 - P)), l[C] = Math.abs(h.dot(b)), g.copy(p).multiplyScalar(s[C] / O), v.copy(m).multiplyScalar(s[C] / R), g.subVectors(E, g), v.subVectors(T, v), g.toArray(i, k + 3), v.toArray(i, k + 6), x.subVectors(A, w), x.toArray(c, k), _.copy(b), w.copy(g);
            }
            g.fromArray(i, 3), v.fromArray(i, 6), b.subVectors(g, v).normalize(), A.index = e.getAtomIndexByType(0, S), w.copy(A), y.copy(A), hf(y, b, g), y.toArray(i, 0), x.subVectors(w, g), x.toArray(c, 0), g.fromArray(i, 3 * n - 6), v.fromArray(i, 3 * n - 9), b.subVectors(g, v).normalize(), A.index = e.getAtomIndexByType(n - 1, S), w.copy(A), y.copy(A), hf(y, b, g), y.toArray(i, 3 * n - 3);
            for (var I = n - 3; I < n; ++I) g.fromArray(i, 3 * I), A.index = e.getAtomIndexByType(I, S), w.copy(A), x.subVectors(w, g), x.toArray(c, 3 * I);
            var j = new Float32Array(n),
              N = new Float32Array(n),
              L = new Float32Array(n),
              D = new Float32Array(n);
            j[1] = s[0], N[1] = u[0], L[1] = s[0];
            for (var B = 2; B < n - 2; ++B) j[B] = .5 * (s[B - 2] + s[B - 1]), N[B] = .5 * (u[B - 2] + u[B - 1]), L[B] = .5 * (l[B - 2] + l[B - 1]), g.fromArray(o, 3 * (B - 2)), v.fromArray(o, 3 * (B - 1)), D[B] = 180 / Math.PI * Math.acos(Math.cos(g.angleTo(v)));
            j[n - 2] = s[n - 4], N[n - 2] = u[n - 4], L[n - 2] = l[n - 4];
            var F = new Float32Array(3 * n);
            Yd(o, F, 0, 0, 3), Yd(o, F, 0, 3, 3);
            for (var z = 2; z < n - 2; ++z) g.fromArray(o, 3 * (z - 2)), v.fromArray(o, 3 * (z - 1)), b.addVectors(v, g).multiplyScalar(.5).normalize(), b.toArray(F, 3 * z);
            return Yd(o, F, 3 * n - 12, 3 * n - 6, 3), Yd(o, F, 3 * n - 12, 3 * n - 3, 3), {
              center: i,
              axis: F,
              bending: D,
              radius: j,
              rise: L,
              twist: N,
              resdir: c
            };
          };
          var Xg = function Xg(e) {
            this.polymer = e, this.helixorient = new $g(e), this.position = this.helixorient.getPosition();
          };
          Xg.prototype.getAxis = function (e, t, n, r, i) {
            e = e || 30, t = t || 2.5, n = void 0 !== n && n;
            var o = this.polymer,
              a = o.structure,
              s = o.residueCount,
              l = o.residueIndexStart,
              u = this.position,
              c = r || {};
            c.structure = a;
            for (var d, h, f = td.getScheme(c), p = new Ng(i), m = 0, g = 0, v = [], y = [], b = [], _ = [], x = [], w = [], S = [], A = [], E = [], T = new Float32Array(3 * s), M = new Float32Array(3 * s), C = new ae(), k = new ae(), P = a.getResidueProxy(), O = a.getResidueProxy(), R = a.getAtomProxy(), I = new ae(), j = new ae(), N = !1, L = 0; L < s; ++L) if (P.index = l + L, I.fromArray(u.center, 3 * L), L === s - 1 ? N = !0 : (O.index = l + L + 1, j.fromArray(u.center, 3 * L + 3), (n && P.sstruc !== O.sstruc || I.distanceTo(j) > t || u.bending[L] > e) && (N = !0)), N) {
              if (L - m < 4) {
                m = L, N = !1;
                continue;
              }
              R.index = P.traceAtomIndex, T = u.axis.subarray(3 * m + 3, 3 * L), M = u.center.subarray(3 * m, 3 * L + 3), d = df(T).normalize(), h = df(M), C.fromArray(M), hf(C, d, h), k.fromArray(M, M.length - 3), hf(k, d, h), d.subVectors(k, C), d.toArray(v, g), h.toArray(y, g), C.toArray(b, g), k.toArray(_, g), f.atomColorToArray(R, x, g), w.push(R.index), S.push(p.atomRadius(R)), A.push(l + m), E.push(l + L + 1 - m), g += 3, m = L, N = !1;
            }
            var D = new Float32Array(w);
            return {
              axis: new Float32Array(v),
              center: new Float32Array(y),
              begin: new Float32Array(b),
              end: new Float32Array(_),
              color: new Float32Array(x),
              picking: new am(D, a),
              size: new Float32Array(S),
              residueOffset: A,
              residueCount: E
            };
          };
          var Yg = function Yg(e) {
            this.scoreFunction = e, this.content = [], this.scoreFunction = e;
          };
          Yg.prototype.push = function (e) {
            this.content.push(e), this.bubbleUp(this.content.length - 1);
          }, Yg.prototype.pop = function () {
            var e = this.content[0],
              t = this.content.pop();
            return t && 0 < this.content.length && (this.content[0] = t, this.sinkDown(0)), e;
          }, Yg.prototype.peek = function () {
            return this.content[0];
          }, Yg.prototype.remove = function (e) {
            for (var t = this.content.length, n = 0; n < t; n++) if (this.content[n] === e) {
              var r = this.content.pop();
              return void (r && n !== t - 1 && (this.content[n] = r, this.scoreFunction(r) < this.scoreFunction(e) ? this.bubbleUp(n) : this.sinkDown(n)));
            }
            throw new Error("Node not found.");
          }, Yg.prototype.size = function () {
            return this.content.length;
          }, Yg.prototype.bubbleUp = function (e) {
            for (var t = this.content[e]; 0 < e;) {
              var n = Math.floor((e + 1) / 2) - 1,
                r = this.content[n];
              if (!(this.scoreFunction(t) < this.scoreFunction(r))) break;
              this.content[n] = t, this.content[e] = r, e = n;
            }
          }, Yg.prototype.sinkDown = function (e) {
            for (var t = this.content.length, n = this.content[e], r = this.scoreFunction(n), i = 0;;) {
              var o = 2 * (e + 1),
                a = o - 1,
                s = null;
              if (a < t) {
                var l = this.content[a];
                (i = this.scoreFunction(l)) < r && (s = a);
              }
              if (o < t) {
                var u = this.content[o];
                this.scoreFunction(u) < (null === s ? r : i) && (s = o);
              }
              if (null === s) break;
              this.content[e] = this.content[s], this.content[s] = n, e = s;
            }
          };
          var Kg = function Kg(e, t) {
            this.points = e, this.metric = t, this.maxDepth = 0, this.currentNode = 0;
            for (var n = e.length / 3, r = new Uint32Array(n), i = 0; i < n; ++i) r[i] = i;
            this.indices = r, this.nodes = new Int32Array(4 * n), this.rootIndex = this.buildTree(0, -1, 0, n);
          };
          Kg.prototype.buildTree = function (e, t, n, r) {
            e > this.maxDepth && (this.maxDepth = e);
            var i = r - n;
            if (0 === i) return -1;
            var o = 4 * this.currentNode,
              a = this.nodes;
            if (this.currentNode += 1, 1 === i) return a[o] = n, a[o + 1] = -1, a[o + 2] = -1, a[o + 3] = t, o;
            for (var s, l, u, c, d, h = this.indices, f = this.points, p = n + Math.floor(i / 2), m = e % 3, g = n, v = r - 1; g < v;) {
              for (c = f[3 * h[u = g + v >> 1] + m], l = h[u], h[u] = h[v], h[v] = l, s = d = g; s < v; ++s) f[3 * h[s] + m] < c && (l = h[d], h[d] = h[s], h[s] = l, ++d);
              if (l = h[v], h[v] = h[d], h[d] = l, p === (u = d)) break;
              p < u ? v = u - 1 : g = u + 1;
            }
            return a[o] = p, a[o + 1] = this.buildTree(e + 1, o, n, p), a[o + 2] = this.buildTree(e + 1, o, p + 1, r), a[o + 3] = t, o;
          }, Kg.prototype.getNodeDepth = function (e) {
            var t = this.nodes[e + 3];
            return -1 === t ? 0 : this.getNodeDepth(t) + 1;
          }, Kg.prototype.nearest = function (e, t, n) {
            var r = this,
              i = new Yg(function (e) {
                return -e[1];
              }),
              o = this.nodes,
              a = this.points,
              s = this.indices,
              l = function l(u) {
                var c,
                  d,
                  h = r.getNodeDepth(u) % 3,
                  f = 3 * s[o[u]],
                  p = [a[f + 0], a[f + 1], a[f + 2]],
                  m = r.metric(e, p);
                function g(e, n) {
                  i.push([e, n]), i.size() > t && i.pop();
                }
                var v = o[u + 1],
                  y = o[u + 2];
                if (-1 !== y || -1 !== v) {
                  c = -1 === y ? v : -1 === v ? y : e[h] <= a[f + h] ? v : y, l(c), (i.size() < t || m < i.peek()[1]) && m <= n && g(u, m);
                  for (var b = [], _ = 0; _ < 3; _ += 1) b[_] = _ === h ? e[_] : a[f + _];
                  var x = r.metric(b, p);
                  (i.size() < t || Math.abs(x) < i.peek()[1]) && Math.abs(x) <= n && -1 !== (d = c === v ? y : v) && l(d);
                } else (i.size() < t || m < i.peek()[1]) && m <= n && g(u, m);
              };
            l(this.rootIndex);
            for (var u = [], c = 0, d = Math.min(i.size(), t); c < d; c += 1) u.push(i.content[c]);
            return u;
          }, Kg.prototype.verify = function (e, t) {
            void 0 === t && (t = 0);
            var n = 1;
            if (void 0 === e && (e = this.rootIndex), -1 === e) throw new Error("node is null");
            var r = t % 3,
              i = this.nodes,
              o = this.points,
              a = this.indices,
              s = i[e + 1],
              l = i[e + 2];
            if (-1 !== s) {
              if (o[3 * a[i[s]] + r] > o[3 * a[i[e]] + r]) throw new Error("left child is > parent!");
              n += this.verify(s, t + 1);
            }
            if (-1 !== l) {
              if (o[3 * a[i[l]] + r] < o[3 * a[i[e]] + r]) throw new Error("right child is < parent!");
              n += this.verify(l, t + 1);
            }
            return n;
          };
          var Zg = function Zg(e, t) {
              void 0 === t && (t = 0), this.structure = e, this.index = t, this.chainStore = e.chainStore, this.residueStore = e.residueStore, this.atomStore = e.atomStore, this.residueMap = e.residueMap, this.atomMap = e.atomMap;
            },
            Qg = {
              bondHash: {
                configurable: !0
              },
              entity: {
                configurable: !0
              },
              entityIndex: {
                configurable: !0
              },
              modelIndex: {
                configurable: !0
              },
              chainIndex: {
                configurable: !0
              },
              residue: {
                configurable: !0
              },
              residueIndex: {
                configurable: !0
              },
              sstruc: {
                configurable: !0
              },
              inscode: {
                configurable: !0
              },
              resno: {
                configurable: !0
              },
              chainname: {
                configurable: !0
              },
              chainid: {
                configurable: !0
              },
              residueType: {
                configurable: !0
              },
              atomType: {
                configurable: !0
              },
              residueAtomOffset: {
                configurable: !0
              },
              resname: {
                configurable: !0
              },
              hetero: {
                configurable: !0
              },
              atomname: {
                configurable: !0
              },
              number: {
                configurable: !0
              },
              element: {
                configurable: !0
              },
              vdw: {
                configurable: !0
              },
              covalent: {
                configurable: !0
              },
              x: {
                configurable: !0
              },
              y: {
                configurable: !0
              },
              z: {
                configurable: !0
              },
              serial: {
                configurable: !0
              },
              bfactor: {
                configurable: !0
              },
              occupancy: {
                configurable: !0
              },
              altloc: {
                configurable: !0
              },
              partialCharge: {
                configurable: !0
              },
              radius: {
                configurable: !0
              },
              formalCharge: {
                configurable: !0
              },
              aromatic: {
                configurable: !0
              },
              bondCount: {
                configurable: !0
              }
            };
          function Jg(e, t) {
            var n = e[0] - t[0],
              r = e[1] - t[1],
              i = e[2] - t[2];
            return n * n + r * r + i * i;
          }
          function ev(e, t) {
            return Math.sqrt(Jg(e, t));
          }
          Qg.bondHash.get = function () {
            return this.structure.bondHash;
          }, Qg.entity.get = function () {
            return this.structure.entityList[this.entityIndex];
          }, Qg.entityIndex.get = function () {
            return this.chainStore.entityIndex[this.chainIndex];
          }, Qg.modelIndex.get = function () {
            return this.chainStore.modelIndex[this.chainIndex];
          }, Qg.chainIndex.get = function () {
            return this.residueStore.chainIndex[this.residueIndex];
          }, Qg.residue.get = function () {
            return console.warn("residue - might be expensive"), this.structure.getResidueProxy(this.residueIndex);
          }, Qg.residueIndex.get = function () {
            return this.atomStore.residueIndex[this.index];
          }, Qg.residueIndex.set = function (e) {
            this.atomStore.residueIndex[this.index] = e;
          }, Qg.sstruc.get = function () {
            return this.residueStore.getSstruc(this.residueIndex);
          }, Qg.inscode.get = function () {
            return this.residueStore.getInscode(this.residueIndex);
          }, Qg.resno.get = function () {
            return this.residueStore.resno[this.residueIndex];
          }, Qg.chainname.get = function () {
            return this.chainStore.getChainname(this.chainIndex);
          }, Qg.chainid.get = function () {
            return this.chainStore.getChainid(this.chainIndex);
          }, Qg.residueType.get = function () {
            return this.residueMap.get(this.residueStore.residueTypeId[this.residueIndex]);
          }, Qg.atomType.get = function () {
            return this.atomMap.get(this.atomStore.atomTypeId[this.index]);
          }, Qg.residueAtomOffset.get = function () {
            return this.residueStore.atomOffset[this.residueIndex];
          }, Qg.resname.get = function () {
            return this.residueType.resname;
          }, Qg.hetero.get = function () {
            return this.residueType.hetero;
          }, Qg.atomname.get = function () {
            return this.atomType.atomname;
          }, Qg.number.get = function () {
            return this.atomType.number;
          }, Qg.element.get = function () {
            return this.atomType.element;
          }, Qg.vdw.get = function () {
            return this.atomType.vdw;
          }, Qg.covalent.get = function () {
            return this.atomType.covalent;
          }, Qg.x.get = function () {
            return this.atomStore.x[this.index];
          }, Qg.x.set = function (e) {
            this.atomStore.x[this.index] = e;
          }, Qg.y.get = function () {
            return this.atomStore.y[this.index];
          }, Qg.y.set = function (e) {
            this.atomStore.y[this.index] = e;
          }, Qg.z.get = function () {
            return this.atomStore.z[this.index];
          }, Qg.z.set = function (e) {
            this.atomStore.z[this.index] = e;
          }, Qg.serial.get = function () {
            return this.atomStore.serial[this.index];
          }, Qg.serial.set = function (e) {
            this.atomStore.serial[this.index] = e;
          }, Qg.bfactor.get = function () {
            return this.atomStore.bfactor[this.index];
          }, Qg.bfactor.set = function (e) {
            this.atomStore.bfactor[this.index] = e;
          }, Qg.occupancy.get = function () {
            return this.atomStore.occupancy[this.index];
          }, Qg.occupancy.set = function (e) {
            this.atomStore.occupancy[this.index] = e;
          }, Qg.altloc.get = function () {
            return this.atomStore.getAltloc(this.index);
          }, Qg.altloc.set = function (e) {
            this.atomStore.setAltloc(this.index, e);
          }, Qg.partialCharge.get = function () {
            return this.atomStore.partialCharge ? this.atomStore.partialCharge[this.index] : null;
          }, Qg.partialCharge.set = function (e) {
            this.atomStore.partialCharge && (this.atomStore.partialCharge[this.index] = e);
          }, Qg.radius.get = function () {
            return this.atomStore.radius ? this.atomStore.radius[this.index] : null;
          }, Qg.radius.set = function (e) {
            this.atomStore.radius && (this.atomStore.radius[this.index] = e);
          }, Qg.formalCharge.get = function () {
            return this.atomStore.formalCharge ? this.atomStore.formalCharge[this.index] : null;
          }, Qg.formalCharge.set = function (e) {
            this.atomStore.formalCharge && (this.atomStore.formalCharge[this.index] = e);
          }, Qg.aromatic.get = function () {
            return this.atomStore.aromatic ? this.atomStore.aromatic[this.index] : this.residueType.isAromatic(this) ? 1 : 0;
          }, Qg.aromatic.set = function (e) {
            this.atomStore.aromatic && (this.atomStore.aromatic[this.index] = e);
          }, Qg.bondCount.get = function () {
            return this.bondHash.countArray[this.index];
          }, Zg.prototype.eachBond = function (e, t) {
            t = t || this.structure._bp;
            for (var n = this.index, r = this.bondHash, i = r.indexArray, o = r.countArray[n], a = r.offsetArray[n], s = 0; s < o; ++s) t.index = i[a + s], e(t);
          }, Zg.prototype.eachBondedAtom = function (e, t) {
            var n = t || this.structure._ap,
              r = this.index;
            this.eachBond(function (t) {
              n.index = r !== t.atomIndex1 ? t.atomIndex1 : t.atomIndex2, e(n);
            }), this.index = r;
          }, Zg.prototype.hasBondTo = function (e) {
            var t = !1;
            return this.eachBondedAtom(function (n) {
              e.index === n.index && (t = !0);
            }), t;
          }, Zg.prototype.bondToElementCount = function (e) {
            var t = 0,
              n = this.index;
            return this.eachBondedAtom(function (n) {
              n.number === e && (t += 1);
            }), this.index = n, t;
          }, Zg.prototype.hasBondToElement = function (e) {
            return 0 < this.bondToElementCount(e);
          }, Zg.prototype.isBackbone = function () {
            var e = this.residueType.backboneIndexList;
            return 0 < e.length && e.includes(this.index - this.residueAtomOffset);
          }, Zg.prototype.isPolymer = function () {
            if (0 < this.structure.entityList.length) return this.entity.isPolymer();
            var e = this.residueType.moleculeType;
            return 3 === e || 4 === e || 5 === e;
          }, Zg.prototype.isSidechain = function () {
            return this.isPolymer() && !this.isBackbone();
          }, Zg.prototype.isCg = function () {
            var e = this.residueType.backboneType;
            return 4 === e || 5 === e || 6 === e;
          }, Zg.prototype.isTrace = function () {
            return this.index === this.residueType.traceAtomIndex + this.residueAtomOffset;
          }, Zg.prototype.isHetero = function () {
            return 1 === this.residueType.hetero;
          }, Zg.prototype.isProtein = function () {
            return 3 === this.residueType.moleculeType;
          }, Zg.prototype.isNucleic = function () {
            var e = this.residueType.moleculeType;
            return 4 === e || 5 === e;
          }, Zg.prototype.isRna = function () {
            return 4 === this.residueType.moleculeType;
          }, Zg.prototype.isDna = function () {
            return 5 === this.residueType.moleculeType;
          }, Zg.prototype.isWater = function () {
            return 1 === this.residueType.moleculeType;
          }, Zg.prototype.isIon = function () {
            return 2 === this.residueType.moleculeType;
          }, Zg.prototype.isSaccharide = function () {
            return 6 === this.residueType.moleculeType;
          }, Zg.prototype.isHelix = function () {
            return dp.includes(this.sstruc);
          }, Zg.prototype.isSheet = function () {
            return hp.includes(this.sstruc);
          }, Zg.prototype.isTurn = function () {
            return fp.includes(this.sstruc) && this.isProtein();
          }, Zg.prototype.isBonded = function () {
            return 0 !== this.bondHash.countArray[this.index];
          }, Zg.prototype.isRing = function () {
            return void 0 !== this.residueType.getRings().atomRings[this.index - this.residueAtomOffset];
          }, Zg.prototype.isAromatic = function () {
            return 1 === this.aromatic;
          }, Zg.prototype.isMetal = function () {
            return this.atomType.isMetal();
          }, Zg.prototype.isNonmetal = function () {
            return this.atomType.isNonmetal();
          }, Zg.prototype.isMetalloid = function () {
            return this.atomType.isMetalloid();
          }, Zg.prototype.isHalogen = function () {
            return this.atomType.isHalogen();
          }, Zg.prototype.isDiatomicNonmetal = function () {
            return this.atomType.isDiatomicNonmetal();
          }, Zg.prototype.isPolyatomicNonmetal = function () {
            return this.atomType.isPolyatomicNonmetal();
          }, Zg.prototype.isAlkaliMetal = function () {
            return this.atomType.isAlkaliMetal();
          }, Zg.prototype.isAlkalineEarthMetal = function () {
            return this.atomType.isAlkalineEarthMetal();
          }, Zg.prototype.isNobleGas = function () {
            return this.atomType.isNobleGas();
          }, Zg.prototype.isTransitionMetal = function () {
            return this.atomType.isTransitionMetal();
          }, Zg.prototype.isPostTransitionMetal = function () {
            return this.atomType.isPostTransitionMetal();
          }, Zg.prototype.isLanthanide = function () {
            return this.atomType.isLanthanide();
          }, Zg.prototype.isActinide = function () {
            return this.atomType.isActinide();
          }, Zg.prototype.getDefaultValence = function () {
            return this.atomType.getDefaultValence();
          }, Zg.prototype.getValenceList = function () {
            return this.atomType.getValenceList();
          }, Zg.prototype.getOuterShellElectronCount = function () {
            return this.atomType.getOuterShellElectronCount();
          }, Zg.prototype.distanceTo = function (e) {
            var t = this.atomStore,
              n = e.atomStore,
              r = this.index,
              i = e.index,
              o = t.x[r] - n.x[i],
              a = t.y[r] - n.y[i],
              s = t.z[r] - n.z[i],
              l = o * o + a * a + s * s;
            return Math.sqrt(l);
          }, Zg.prototype.connectedTo = function (e) {
            var t = this.atomStore,
              n = e.atomStore,
              r = this.index,
              i = e.index;
            if (t.altloc && n.altloc) {
              var o = t.altloc[r],
                a = n.altloc[i];
              if (0 !== o && 0 !== a && 32 !== o && 32 !== a && o !== a) return !1;
            }
            var s = t.x[r] - n.x[i],
              l = t.y[r] - n.y[i],
              u = t.z[r] - n.z[i],
              c = s * s + l * l + u * u;
            if (c < 48 && this.isCg()) return !0;
            if (isNaN(c)) return !1;
            var d = this.covalent + e.covalent,
              h = d + .3,
              f = d - .5;
            return c < h * h && f * f < c;
          }, Zg.prototype.positionFromArray = function (e, t) {
            return void 0 === t && (t = 0), this.x = e[t + 0], this.y = e[t + 1], this.z = e[t + 2], this;
          }, Zg.prototype.positionToArray = function (e, t) {
            void 0 === e && (e = []), void 0 === t && (t = 0);
            var n = this.index,
              r = this.atomStore;
            return e[t + 0] = r.x[n], e[t + 1] = r.y[n], e[t + 2] = r.z[n], e;
          }, Zg.prototype.positionToVector3 = function (e) {
            return void 0 === e && (e = new ae()), e.x = this.x, e.y = this.y, e.z = this.z, e;
          }, Zg.prototype.positionFromVector3 = function (e) {
            return this.x = e.x, this.y = e.y, this.z = e.z, this;
          }, Zg.prototype.positionAdd = function (e) {
            return this.x += e.x, this.y += e.y, this.z += e.z, this;
          }, Zg.prototype.positionSub = function (e) {
            return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
          }, Zg.prototype.getResidueBonds = function (e) {
            void 0 === e && (e = !1);
            var t,
              n,
              r,
              i,
              o = this.residueAtomOffset,
              a = this.index - this.residueAtomOffset,
              s = this.residueType.getBonds(),
              l = s.atomIndices1,
              u = s.atomIndices2;
            for (e || (i = []), t = l.indexOf(a); -1 !== t;) {
              if (r = u[t] + o, !i) return r;
              i.push(r), t = l.indexOf(a, t + 1);
            }
            for (n = u.indexOf(a); -1 !== n;) {
              if (r = l[n] + o, !i) return r;
              i.push(r), n = u.indexOf(a, n + 1);
            }
            return i;
          }, Zg.prototype.qualifiedName = function (e) {
            void 0 === e && (e = !1);
            var t = "";
            return this.resname && !e && (t += "[" + this.resname + "]"), void 0 !== this.resno && (t += this.resno), this.inscode && (t += "^" + this.inscode), this.chainname && (t += ":" + this.chainname), this.atomname && (t += "." + this.atomname), this.altloc && (t += "%" + this.altloc), 1 < this.structure.modelStore.count && (t += "/" + this.modelIndex), t;
          }, Zg.prototype.clone = function () {
            return new Zg(this.structure, this.index);
          }, Zg.prototype.toObject = function () {
            return {
              index: this.index,
              residueIndex: this.residueIndex,
              resname: this.resname,
              x: this.x,
              y: this.y,
              z: this.z,
              element: this.element,
              chainname: this.chainname,
              resno: this.resno,
              serial: this.serial,
              vdw: this.vdw,
              covalent: this.covalent,
              hetero: this.hetero,
              bfactor: this.bfactor,
              altloc: this.altloc,
              atomname: this.atomname,
              modelIndex: this.modelIndex
            };
          }, Object.defineProperties(Zg.prototype, Qg);
          var tv = new Float32Array(3),
            nv = function nv(e, n) {
              void 0 === n && (n = !1), t.Debug && Zc.time("Kdtree build");
              var r = n ? Jg : ev,
                i = new Float32Array(3 * e.atomCount),
                o = new Uint32Array(e.atomCount),
                a = 0;
              e.eachAtom(function (e) {
                i[a + 0] = e.x, i[a + 1] = e.y, i[a + 2] = e.z, o[a / 3] = e.index, a += 3;
              }), this.atomIndices = o, this.points = i, this.kdtree = new Kg(i, r), t.Debug && Zc.timeEnd("Kdtree build");
            };
          nv.prototype.nearest = function (e, t, n) {
            e instanceof ae ? e.toArray(tv) : e instanceof Zg && e.positionToArray(tv);
            for (var r = this.kdtree.nearest(tv, t, n), i = this.kdtree.indices, o = this.kdtree.nodes, a = this.atomIndices, s = [], l = 0, u = r.length; l < u; ++l) {
              var c = r[l],
                d = c[0],
                h = c[1];
              s.push({
                index: a[i[o[d]]],
                distance: h
              });
            }
            return s;
          };
          var rv = {
              " ": "X",
              "!": "Y",
              "#": "Z",
              $: "-X",
              "%": "-Y",
              "&": "-Z",
              "'": "Y+1/2",
              "(": "1/2+X",
              ")": "1/2+Y",
              "*": "1/2-X",
              "+": "1/2+Z",
              ",": "1/2-Y",
              "-": "1/2-Z",
              ".": "X+1/2",
              "/": "Z+1/2",
              0: "-X+1/2",
              1: "-Y+1/2",
              2: "-Z+1/2",
              3: "1/4+X",
              4: "1/4-Y",
              5: "1/4+Z",
              6: "1/4-X",
              7: "1/4+Y",
              8: "3/4-Y",
              9: "3/4+Z",
              ":": "3/4+Y",
              ";": "3/4+X",
              "<": "3/4-X",
              "=": "1/4-Z",
              ">": "3/4-Z",
              "?": "X-Y",
              "@": "Y-X",
              A: "Z+1/3",
              B: "Z+2/3",
              C: "X+2/3",
              D: "Y+1/3",
              E: "-Y+2/3",
              F: "X-Y+1/3",
              G: "Y-X+2/3",
              H: "-X+1/3",
              I: "X+1/3",
              J: "Y+2/3",
              K: "-Y+1/3",
              L: "X-Y+2/3",
              M: "Y-X+1/3",
              N: "-X+2/3",
              O: "2/3+X",
              P: "1/3+Y",
              Q: "1/3+Z",
              R: "2/3-Y",
              S: "1/3+X-Y",
              T: "2/3+Y-X",
              U: "1/3-X",
              V: "2/3-X",
              W: "1/3-Y",
              X: "1/3-Z",
              Y: "2/3+Y",
              Z: "1/3+Y-X",
              "[": "2/3+X-Y",
              "]": "1/3+X",
              "^": "2/3+Z",
              _: "2/3-Z",
              "`": "5/6+Z",
              a: "1/6+Z",
              b: "5/6-Z",
              c: "1/6-Z",
              d: "Z+5/6",
              e: "Z+1/6",
              f: "Z+1/4",
              g: "+Y"
            },
            iv = {
              "P 1": " !#",
              "P -1": " !#$%&",
              "P 1 2 1": " !#$!&",
              "P 1 21 1": " !#$'&",
              "C 1 2 1": " !#$!&()#*)&",
              "P 1 m 1": " !# %#",
              "P 1 c 1": " !# %+",
              "C 1 m 1": " !# %#()#(,#",
              "C 1 c 1": " !# %+()#(,+",
              "P 1 2/m 1": " !# %#$!&$%&",
              "P 1 21/m 1": " !#$)&$%& ,#",
              "C 1 2/m 1": " !# %#$!&$%&()#(,#*)&*,&",
              "P 1 2/c 1": " !#$!-$%& %+",
              "P 1 21/c 1": " !#$%&$)- ,+",
              "C 1 2/c 1": " !#$!-$%& %+()#*)-*,&(,+",
              "P 2 2 2": " !#$%#$!& %&",
              "P 2 2 21": " !#$%+$!- %&",
              "P 21 21 2": " !#$%#*)&(,&",
              "P 21 21 21": " !#*%+$)-(,&",
              "C 2 2 21": " !#$%+$!- %&()#*,+*)-(,&",
              "C 2 2 2": " !#$%#$!& %&()#*,#*)&(,&",
              "F 2 2 2": " !#$%#$!& %& )+$,+$)- ,-(!+*%+*!-(%-()#*,#*)&(,&",
              "I 2 2 2": " !#$%# %&$!&.'/01/.120'2",
              "I 21 21 21": " !#*%+$)-(,&()+$,#*!& %-",
              "P m m 2": " !#$%# %#$!#",
              "P m c 21": " !#$%+ %+$!#",
              "P c c 2": " !#$%# %+$!+",
              "P m a 2": " !#$%#(%#*!#",
              "P c a 21": " !#$%+(%#*!+",
              "P n c 2": " !#$%# ,+$)+",
              "P m n 21": " !#*%+(%+$!#",
              "P b a 2": " !#$%#(,#*)#",
              "P n a 21": " !#$%+(,#*)+",
              "P n n 2": " !#$%#(,+*)+",
              "C m m 2": " !#$%# %#$!#()#*,#(,#*)#",
              "C m c 21": " !#$%+ %+$!#()#*,+(,+*)#",
              "C c c 2": " !#$%# %+$!+()#*,#(,+*)+",
              "A m m 2": " !#$%# %#$!# )+$,+ ,+$)+",
              "A b m 2": " !#$%# ,#$)# )+$,+ %+$!+",
              "A m a 2": " !#$%#(%#*!# )+$,+(,+*)+",
              "A b a 2": " !#$%#(,#*)# )+$,+(%+*!+",
              "F m m 2": " !#$%# %#$!# )+$,+ ,+$)+(!+*%+(%+*!+()#*,#(,#*)#",
              "F d d 2": " !#$%#345675 )+$,+3896:9(!+*%+;49<79()#*,#;85<:5",
              "I m m 2": " !#$%# %#$!#()+*,+(,+*)+",
              "I b a 2": " !#$%#(,#*)#()+*,+ %+$!+",
              "I m a 2": " !#$%#(%#*!#()+*,+ ,+$)+",
              "P 2/m 2/m 2/m": " !#$%#$!& %&$%& !& %#$!#",
              "P 2/n 2/n 2/n": " !#$%#$!& %&*,-()-(,+*)+",
              "P 2/c 2/c 2/m": " !#$%#$!- %-$%& !& %+$!+",
              "P 2/b 2/a 2/n": " !#$%#$!& %&*,&()&(,#*)#",
              "P 21/m 2/m 2/a": " !#*%#$!&(%&$%&(!& %#*!#",
              "P 2/n 21/n 2/a": " !#*%#*)- ,-$%&(!&(,+$)+",
              "P 2/m 2/n 21/a": " !#*%+*!- %&$%&(!-(%+$!#",
              "P 21/c 2/c 2/a": " !#*%#$!-(%-$%&(!& %+*!+",
              "P 21/b 21/a 2/m": " !#$%#*)&(,&$%& !&(,#*)#",
              "P 21/c 21/c 2/n": " !#*,#$)-(%-$%&()& ,+*!+",
              "P 2/b 21/c 21/m": " !#$%+$)- ,&$%& !- ,+$)#",
              "P 21/n 21/n 2/m": " !#$%#*)-(,-$%& !&(,+*)+",
              "P 21/m 21/m 2/n": " !#$%#*'&.,&*,&.'& %#$!#",
              "P 21/b 2/c 21/n": " !#*,+$!-(,&$%&()- %+*)#",
              "P 21/b 21/c 21/a": " !#*%+$)-(,&$%&(!- ,+*)#",
              "P 21/n 21/m 21/a": " !#0%/$'&.12$%&.!2 1#0'/",
              "C 2/m 2/c 21/m": " !#$%+$!- %&$%& !- %+$!#()#*,+*)-(,&*,&()-(,+*)#",
              "C 2/m 2/c 21/a": " !#$,+$)- %&$%& )- ,+$!#()#*%+*!-(,&*,&(!-(%+*)#",
              "C 2/m 2/m 2/m": " !#$%#$!& %&$%& !& %#$!#()#*,#*)&(,&*,&()&(,#*)#",
              "C 2/c 2/c 2/m": " !#$%#$!- %-$%& !& %+$!+()#*,#*)-(,-*,&()&(,+*)+",
              "C 2/m 2/m 2/a": " !#$,#$)& %&$%& )& ,#$!#()#*%#*!&(,&*,&(!&(%#*)#",
              "C 2/c 2/c 2/a": " !#*,#$!&(,&$,-(!- ,+*!+()#$%#*)& %&*%- )-(%+$)+",
              "F 2/m 2/m 2/m": " !#$%#$!& %&$%& !& %#$!# )+$,+$)- ,-$,- )- ,+$)+(!+*%+*!-(%-*%-(!-(%+*!+()#*,#*)&(,&*,&()&(,#*)#",
              "F 2/d 2/d 2/d": " !#$%#$!& %&64=37=345675 )+$,+$)- ,-68>3:>3896:9(!+*%+*!-(%-<4>;7>;49<79()#*,#*)&(,&<8=;:=;85<:5",
              "I 2/m 2/m 2/m": " !#$%#$!& %&$%& !& %#$!#()+*,+*)-(,-*,-()-(,+*)+",
              "I 2/b 2/a 2/m": " !#$%#*)&(,&$%& !&(,#*)#()+*,+$!- %-*,-()- %+$!+",
              "I 21/b 21/c 21/a": " !#*%+$)-(,&$%&(!- ,+*)#()+$,#*!& %-*,- )&(%#$!+",
              "I 21/m 21/m 21/a": " !#$,#$)& %&$%& )& ,#$!#()+*%+*!-(,-*,-(!-(%+*)+",
              "P 4": " !#$%#% #!$#",
              "P 41": " !#$%+% 5!$9",
              "P 42": " !#$%#% +!$+",
              "P 43": " !#$%+% 9!$5",
              "I 4": " !#$%#% #!$#()+*,+,(+)*+",
              "I 41": " !#*,+%(5)$9()+$%#, 9!*5",
              "P -4": " !#$%#!$&% &",
              "I -4": " !#$%#!$&% &()+*,+)*-,(-",
              "P 4/m": " !#$%#% #!$#$%& !&!$&% &",
              "P 42/m": " !#$%#% +!$+$%& !&!$-% -",
              "P 4/n": " !#$%#,(#)*#*,&()&!$&% &",
              "P 42/n": " !#$%#,(+)*+*,-()-!$&% &",
              "I 4/m": " !#$%#% #!$#$%& !&!$&% &()+*,+,(+)*+*,-()-)*-,(-",
              "I 41/a": " !#*,+%(5)$9$,=(!>!$&,(-()+$%#, 9!*5*%> )=)*-% &",
              "P 4 2 2": " !#$%#% #!$#$!& %&! &%$&",
              "P 4 21 2": " !#$%#,(#)*#*)&(,&! &%$&",
              "P 41 2 2": " !#$%+% 5!$9$!& %-! >%$=",
              "P 41 21 2": " !#$%+,(5)*9*)=(,>! &%$-",
              "P 42 2 2": " !#$%#% +!$+$!& %&! -%$-",
              "P 42 21 2": " !#$%#,(+)*+*)-(,-! &%$&",
              "P 43 2 2": " !#$%+% 9!$5$!& %-! =%$>",
              "P 43 21 2": " !#$%+,(9)*5*)>(,=! &%$-",
              "I 4 2 2": " !#$%#% #!$#$!& %&! &%$&()+*,+,(+)*+*)-(,-)(-,*-",
              "I 41 2 2": " !#*,+%(5)$9*!> ,=)(-%$&()+$%#, 9!*5$)=(%>! &,*-",
              "P 4 m m": " !#$%#% #!$# %#$!#%$#! #",
              "P 4 b m": " !#$%#% #!$#(,#*)#,*#)(#",
              "P 42 c m": " !#$%#% +!$+ %+$!+%$#! #",
              "P 42 n m": " !#$%#,(+)*+(,+*)+%$#! #",
              "P 4 c c": " !#$%#% #!$# %+$!+%$+! +",
              "P 4 n c": " !#$%#% #!$#(,+*)+,*+)(+",
              "P 42 m c": " !#$%#% +!$+ %#$!#%$+! +",
              "P 42 b c": " !#$%#% +!$+(,#*)#,*+)(+",
              "I 4 m m": " !#$%#% #!$# %#$!#%$#! #()+*,+,(+)*+(,+*)+,*+)(+",
              "I 4 c m": " !#$%#% #!$# %+$!+%$+! +()+*,+,(+)*+(,#*)#,*#)(#",
              "I 41 m d": " !#*,+%(5)$9 %#*)+%*5) 9()+$%#, 9!*5(,+$!#,$9!(5",
              "I 41 c d": " !#*,+%(5)$9 %+*)#%*9) 5()+$%#, 9!*5(,#$!+,$5!(9",
              "P -4 2 m": " !#$%#% &!$&$!& %&%$#! #",
              "P -4 2 c": " !#$%#% &!$&$!- %-%$+! +",
              "P -4 21 m": " !#$%#% &!$&*)&(,&,*#)(#",
              "P -4 21 c": " !#$%#% &!$&*)-(,-,*+)(+",
              "P -4 m 2": " !#$%#!$&% & %#$!#! &%$&",
              "P -4 c 2": " !#$%#% &!$& %+$!+! -%$-",
              "P -4 b 2": " !#$%#% &!$&(,#*)#)(&,*&",
              "P -4 n 2": " !#$%#% &!$&(,+*)+)(-,*-",
              "I -4 m 2": " !#$%#% &!$& %#$!#! &%$&()+*,+,(-)*-(,+*)+)(-,*-",
              "I -4 c 2": " !#$%#% &!$& %+$!+! -%$-()+*,+,(-)*-(,#*)#)(&,*&",
              "I -4 2 m": " !#$%#% &!$&$!& %&%$#! #()+*,+,(-)*-*)-(,-,*+)(+",
              "I -4 2 d": " !#$%#% &!$&*!>(%>,$9) 9()+*,+,(-)*-$)= ,=%*5!(5",
              "P 4/m 2/m 2/m": " !#$%#% #!$#$!& %&! &%$&$%& !&!$&% & %#$!#%$#! #",
              "P 4/m 2/c 2/c": " !#$%#% #!$#$!- %-! -%$-$%& !&!$&% & %+$!+%$+! +",
              "P 4/n 2/b 2/m": " !#$%#% #!$#$!& %&! &%$&*,&()&)*&,(&(,#*)#,*#)(#",
              "P 4/n 2/n 2/c": " !#$%#% #!$#$!& %&! &%$&*,-()-)*-,(-(,+*)+,*+)(+",
              "P 4/m 21/b 2/m": " !#$%#% #!$#*)&(,&)(&,*&$%& !&!$&% &(,#*)#,*#)(#",
              "P 4/m 21/n 2/c": " !#$%#% #!$#*)-(,-)(-,*-$%& !&!$&% &(,+*)+,*+)(+",
              "P 4/n 21/m 2/m": " !#$%#,(#)*#*)&(,&! &%$&*,&()&!$&% & %#$!#,*#)(#",
              "P 4/n 2/c 2/c": " !#$%#,(#)*#*)-(,-! -%$-*,&()&!$&% & %+$!+,*+)(+",
              "P 42/m 2/m 2/c": " !#$%#% +!$+$!& %&! -%$-$%& !&!$-% - %#$!#%$+! +",
              "P 42/m 2/c 2/m": " !#$%#% +!$+$!- %-! &%$&$%& !&!$-% - %+$!+%$#! #",
              "P 42/n 2/b 2/c": " !#$%#,(+)*+$!- %-)(&,*&*,-()-!$&% &(,#*)#%$+! +",
              "P 42/n 2/n 2/m": " !#$%#,(+)*+$!& %&)(-,*-*,-()-!$&% &(,+*)+%$#! #",
              "P 42/m 21/b 2/c": " !#$%#% +!$+*)&(,&)(-,*-$%& !&!$-% -(,#*)#,*+)(+",
              "P 42/m 21/n 2/m": " !#$%#,./'*/*'-.,-! &%$&$%& !&'*-,.-.,/*'/%$#! #",
              "P 42/n 21/m 2/c": " !#$%#,(+)*+*)-(,-! &%$&*,-()-!$&% & %#$!#,*+)(+",
              "P 42/n 21/c 2/m": " !#$%#,(+)*+*)&(,&! -%$-*,-()-!$&% & %+$!+,*#)(#",
              "I 4/m 2/m 2/m": " !#$%#% #!$#$!& %&! &%$&$%& !&!$&% & %#$!#%$#! #()+*,+,(+)*+*)-(,-)(-,*-*,-()-)*-,(-(,+*)+,*+)(+",
              "I 4/m 2/c 2/m": " !#$%#% #!$#$!- %-! -%$-$%& !&!$&% & %+$!+%$+! +()+*,+,(+)*+*)&(,&)(&,*&*,-()-)*-,(-(,#*)#,*#)(#",
              "I 41/a 2/m 2/d": " !#*,+%(5)$9*!> ,=)(-%$&$,=(!>!$&,(-(,+$!#,$9!(5()+$%#, 9!*5$)=(%>! &,*-*%> )=)*-% & %#*)+%*5) 9",
              "I 41/a 2/c 2/d": " !#*,+%(5)$9*!= ,>)(&%$-$,=(!>!$&,(-(,#$!+,$5!(9()+$%#, 9!*5$)>(%=! -,*&*%> )=)*-% & %+*)#%*9) 5",
              "P 3": " !#%?#@$#",
              "P 31": " !#%?A@$B",
              "P 32": " !#%?B@$A",
              "H 3": " !#%?#@$#CDAEFAGHAIJBKLBMNB",
              "R 3": " !## !!# ",
              "P -3": " !#%?#@$#$%&!@&? &",
              "H -3": " !#%?#@$#$%&!@&? &OPQRSQTUQVWXYZX[]X]Y^W[^ZV^UR_PT_SO_",
              "R -3": " !## !!# $%&&$%%&$",
              "P 3 1 2": " !#%?#@$#%$&@!& ?&",
              "P 3 2 1": " !#%?#@$#! &?%&$@&",
              "P 31 1 2": " !#%?Q@$^%$_@!X ?&",
              "P 31 2 1": " !#%?A@$B! &?%_$@X",
              "P 32 1 2": " !#%?^@$Q%$X@!_ ?&",
              "P 32 2 1": " !#%?B@$A! &?%X$@_",
              "H 3 2": " !#%?#@$#! &?%&$@&OPQRSQTUQY]X[WXVZX]Y^W[^ZV^PO_SR_UT_",
              "R 3 2": " !## !!# %$&$&%&%$",
              "P 3 m 1": " !#%?#@$#%$#@!# ?#",
              "P 3 1 m": " !#%?#@$#! #?%#$@#",
              "P 3 c 1": " !#%?#@$#%$+@!+ ?+",
              "P 3 1 c": " !#%?#@$#! +?%+$@+",
              "H 3 m": " !#%?#@$#%$#@!# ?#OPQRSQTUQRUQTPQOSQ]Y^W[^ZV^WV^ZY^][^",
              "R 3 m": " !## !!# ! # #!#! ",
              "H 3 c": " !#%?#@$#%$+@!+ ?+OPQRSQTUQRU`TP`OS`]Y^W[^ZV^WVaZYa][a",
              "R 3 c": " !## !!# '././'/'.",
              "P -3 1 2/m": " !#%?#@$#%$&@!& ?&$%&!@&? &! #?%#$@#",
              "P -3 1 2/c": " !#%?#@$#%$-@!- ?-$%&!@&? &! +?%+$@+",
              "P -3 2/m 1": " !#%?#@$#! &?%&$@&$%&!@&? &%$#@!# ?#",
              "P -3 2/c 1": " !#%?#@$#! -?%-$@-$%&!@&? &%$+@!+ ?+",
              "H -3 2/m": " !#%?#@$#! &?%&$@&$%&!@&? &%$#@!# ?#OPQRSQTUQY]X[WXVZXVWXYZX[]XRUQTPQOSQ]Y^W[^ZV^PO_SR_UT_UR_PT_SO_WV^ZY^][^",
              "R -3 2/m": " !## !!# %$&$&%&%$$%&&$%%&$! # #!#! ",
              "H -3 2/c": " !#%?#@$#! -?%-$@-$%&!@&? &%$+@!+ ?+OPQRSQTUQY]b[WbVZbVWXYZX[]XRU`TP`OS`]Y^W[^ZV^POcSRcUTcUR_PT_SO_WVaZYa][a",
              "R -3 2/c": " !## !!# 102021210$%&&$%%&$'././'/'.",
              "P 6": " !#%?#@$#$%#!@#? #",
              "P 61": " !#%?A@$B$%/!@d? e",
              "P 65": " !#%?B@$A$%/!@e? d",
              "P 62": " !#%?^@$Q$%#!@^? Q",
              "P 64": " !#%?Q@$^$%#!@Q? ^",
              "P 63": " !#%?#@$#$%+!@+? +",
              "P -6": " !#%?#@$# !&%?&@$&",
              "P 6/m": " !#%?#@$#$%#!@#? #$%&!@&? & !&%?&@$&",
              "P 63/m": " !#%?#@$#$%+!@+? +$%&!@&? & !-%?-@$-",
              "P 6 2 2": " !#%?#@$#$%#!@#? #! &?%&$@&%$&@!& ?&",
              "P 61 2 2": " !#%?Q@$^$%+!@`? a! X?%&$@_%$b@!- ?c",
              "P 65 2 2": " !#%?^@$Q$%+!@a? `! _?%&$@X%$c@!- ?b",
              "P 62 2 2": " !#%?^@$Q$%#!@^? Q! _?%&$@X%$_@!& ?X",
              "P 64 2 2": " !#%?Q@$^$%#!@Q? ^! X?%&$@_%$X@!& ?_",
              "P 63 2 2": " !#%?#@$#$%+!@+? +! &?%&$@&%$-@!- ?-",
              "P 6 m m": " !#%?#@$#$%#!@#? #%$#@!# ?#! #?%#$@#",
              "P 6 c c": " !#%?#@$#$%#!@#? #%$+@!+ ?+! +?%+$@+",
              "P 63 c m": " !#%?#@$#$%+!@+? +%$+@!+ ?+! #?%#$@#",
              "P 63 m c": " !#%?#@$#$%+!@+? +%$#@!# ?#! +?%+$@+",
              "P -6 m 2": " !#%?#@$# !&%?&@$&%$#@!# ?#%$&@!& ?&",
              "P -6 c 2": " !#%?#@$# !-%?-@$-%$+@!+ ?+%$&@!& ?&",
              "P -6 2 m": " !#%?#@$# !&%?&@$&! &?%&$@&! #?%#$@#",
              "P -6 2 c": " !#%?#@$# !-%?-@$-! &?%&$@&! +?%+$@+",
              "P 6/m 2/m 2/m": " !#%?#@$#$%#!@#? #! &?%&$@&%$&@!& ?&$%&!@&? & !&@$&%?&%$#@!# ?#! #?%#$@#",
              "P 6/m 2/c 2/c": " !#%?#@$#$%#!@#? #! -?%-$@-%$-@!- ?-$%&!@&? & !&@$&%?&%$+@!+ ?+! +?%+$@+",
              "P 63/m 2/c 2/m": " !#%?#@$#$%+!@+? +! -?%-$@-%$&@!& ?&$%&!@&? & !-@$-%?-%$+@!+ ?+! #?%#$@#",
              "P 63/m 2/m 2/c": " !#%?#@$#$%+!@+? +! &?%&$@&%$-@!- ?-$%&!@&? & !-@$-%?-%$#@!# ?#! +?%+$@+",
              "P 2 3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ",
              "F 2 3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%&  )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-((!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&(()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- ",
              "I 2 3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ()+*,+*)-(,-+()+*,-*)-(,)+(,+*)-*,-(",
              "P 21 3": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(",
              "I 21 3": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(()+$,#*!& %-+()#$,&*!- %)+(,#$!&*%- ",
              "P 2/m -3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& $%& !& %#$!#&$%& !# %#$!%&$!& %# !#$",
              "P 2/n -3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& *,-()-(,+*)+-*,-()+(,+*),-*)-(,+()+*",
              "F 2/m -3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& $%& !& %#$!#&$%& !# %#$!%&$!& %# !#$ )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-($,- )- ,+$)+&*,&()#(,#*)%-*!-(%+(!+*(!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&(*%-(!-(%+*!+-$,- )+ ,+$),&*)&(,#()#*()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- *,&()&(,#*)#-*%-(!+(%+*!,-$)- ,+ )+$",
              "F 2/d -3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& 64=37=345675=64=375345674=67=3453756 )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-(68>3:>3896:9=<8=;:5;85<:4><7>;49;79<(!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&(<4>;7>;49<79>68>3:93896:8=<:=;85;:5<()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- <8=;:=;8f<:f><4>;79;49<78>6:>3893:96",
              "I 2/m -3": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& $%& !& %#$!#&$%& !# %#$!%&$!& %# !#$()+*,+*)-(,-+()+*,-*)-(,)+(,+*)-*,-(*,-()-(,+*)+-*,-()+(,+*),-*)-(,+()+*",
              "P 21/a -3": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&($%&(!- ,+*)#&$%-(!+ ,#*)%&$!-(,+ )#*",
              "I 21/a -3": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&($%&(!- ,+*)#&$%-(!+ ,#*)%&$!-(,+ )#*()+$,#*g& %-+()#$,&*!- %)+(,#$!&*%- *,- )&(%#$!+-*,& )#(%+$!,-*)& %#(!+$",
              "P 4 3 2": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$",
              "P 42 3 2": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& )(-,*-)*+,(+(+,*+)*-,(-)+)*+,(-)(-,*",
              "F 4 3 2": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$ )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-(!(-%*-!*+%(+ +,$+)$-, -)#)*#,(&)(&,*(!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&() -,$-)$+, +(#,*#)*&,(&)+!*+%(-!(-%*()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- )(&,*&)*#,(#(+%*+!*-%(-!+)$+, -) -,$",
              "F 41 3 2": " !#$,+*)&(%-# !+$,&*)-(%!# ,+$)&*%-(:3>46=7<98;5;58<976=43>:97<58;>:3=46 )+$%#*!-(,&#()+*%&$!- ,!+(,#*)-$%& :;=4<>765839;94<5:6>83=79:6543>7;=8<(!+*,#$)- %&+ )#$%-*!&(,)#(%+*!&$,- 73=86>:<54;935469:<=8;>7576983=:;>4<()#*%+$!& ,-+(!#*,-$)& %)+ %#$!-*,&(7;>8<=:69435398657<>4;=:5:<94;=73>86",
              "I 4 3 2": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$()+*,+*)-(,-+()+*,-*)-(,)+(,+*)-*,-()(-,*-)*+,(+(+,*+)*-,(-)+)*+,(-)(-,*",
              "P 43 3 2": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(7;>46=:<5839398<5:6=4;>75:<983>7;=46",
              "P 41 3 2": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(:3=8<>7694;5;54697<>83=:97654;=:3>8<",
              "I 41 3 2": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(:3=8<>7694;5;54697<>83=:97654;=:3>8<()+$,#*!& %-+()#$,&*!- %)+(,#$!&*%- 7;>46=:<5839398<5:6=4;>75:<983>7;=46",
              "P -4 3 m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! #%$#!$&% & #!$#%$&! &%#! #%$&!$&% ",
              "F -4 3 m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! #%$#!$&% & #!$#%$&! &%#! #%$&!$&%  )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-(!(+%*+!*-%(- +)$+,$-) -,#)(#,*&)*&,((!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&() +,$+)$-, -(#)*#,*&)(&,+!(+%*-!*-%(()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- )(#,*#)*&,(&(+!*+%*-!(-%+) +,$-)$-, ",
              "I -4 3 m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! #%$#!$&% & #!$#%$&! &%#! #%$&!$&% ()+*,+*)-(,-+()+*,-*)-(,)+(,+*)-*,-()(+,*+)*-,(-(+)*+,*-)(-,+)(+,*-)*-,(",
              "P -4 3 n": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& )(+,*+)*-,(-(+)*+,*-)(-,+)(+,*-)*-,(",
              "F -4 3 c": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& )(+,*+)*-,(-(+)*+,*-)(-,+)(+,*-)*-,( )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-() #,$#)$&, &(#!*#%*&!(&%+! +%$-!$-% (!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&(!(#%*#!*&%(& +!$+%$-! -%#) #,$&)$&, ()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- ! +%$+!$-% - #)$#,$&) &,#!(#%*&!*&%(",
              "I -4 3 d": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(7354<9:6>8;=357<946>:;=857394<>:6=8;()+$,#*!& %-+()#$,&*!- %)+(,#$!&*%- :;98657<=43>;9:658<=73>49:;586=7<>43",
              "P 4/m -3 2/m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$$%& !& %#$!#&$%& !# %#$!%&$!& %# !#$%$#! #% &!$&$&! &% #!$#%&% &!$#%$#! ",
              "P 4/n -3 2/n": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$*,-()-(,+*)+-*,-()+(,+*),-*)-(,+()+*,*+)(+,(-)*-*-)(-,(+)*+,-,(-)*+,*+)(",
              "P 42/m -3 2/n": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& )(-,*-)*+,(+(+,*+)*-,(-)+)*+,(-)(-,*$%& !& %#$!#&$%& !# %#$!%&$!& %# !#$,*+)(+,(-)*-*-)(-,(+)*+,-,(-)*+,*+)(",
              "P 42/n -3 2/m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& )(-,*-)*+,(+(+,*+)*-,(-)+)*+,(-)(-,**,-()-(,+*)+-*,-()+(,+*),-*)-(,+()+*%$#! #% &!$&$&! &% #!$#%&% &!$#%$#! ",
              "F 4/m -3 2/m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$$%& !& %#$!#&$%& !# %#$!%&$!& %# !#$%$#! #% &!$&$&! &% #!$#%&% &!$#%$#!  )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-(!(-%*-!*+%(+ +,$+)$-, -)#)*#,(&)(&,*$,- )- ,+$)+&*,&()#(,#*)%-*!-(%+(!+*%*+!(+%(-!*-$-) -, +)$+,&,(&)*#,*#)((!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&() -,$-)$+, +(#,*#)*&,(&)+!*+%(-!(-%**%-(!-(%+*!+-$,- )+ ,+$),&*)&(,#()#*,$+) +, -)$-*&)(&,(#)*#,-%(-!*+%*+!(()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- )(&,*&)*#,(#(+%*+!*-%(-!+)$+, -) -,$*,&()&(,#*)#-*%-(!+(%+*!,-$)- ,+ )+$,*#)(#,(&)*&*-!(-%(+!*+%-, -)$+,$+) ",
              "F 4/m -3 2/c": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& )(-,*-)*+,(+(+,*+)*-,(-)+)*+,(-)(-,*$%& !& %#$!#&$%& !# %#$!%&$!& %# !#$,*+)(+,(-)*-*-)(-,(+)*+,-,(-)*+,*+)( )+$,+$)- ,-#()#*,&*)&(,!+(%+*!-*%-() &,$&)$#, #(#%*#!*&%(&!+!$+% -! -%$$,- )- ,+$)+&*,&()#(,#*)%-*!-(%+(!+*,$#) #, &)$&*&!(&%(#!*#%-% -!$+%$+! (!+*%+*!-(%-+ )+$,-$)- ,)#(,#*)&*,&(!(&%*&!*#%(# +%$+!$-% -!#)$#, &) &,$*%-(!-(%+*!+-$,- )+ ,+$),&*)&(,#()#*%*#!(#%(&!*&$-! -% +!$+%&, &)$#,$#) ()#*,#*)&(,&+(!+*%-*!-(%)+ ,+$)-$,- ! -%$-!$+% + #,$#)$&, &)#!*#%(&!(&%**,&()&(,#*)#-*%-(!+(%+*!,-$)- ,+ )+$%$+! +% -!$-$&) &, #)$#,&%(&!*#%*#!(",
              "F 41/d -3 2/m": " !#$,+*)&(%-# !+$,&*)-(%!# ,+$)&*%-(:3>46=7<98;5;58<976=43>:97<58;>:3=4664=3:>;85<79=64>3:5;89<74=6:>385;79<,$+! #%(-)*&*&)(-% #!$+,-%(&)*+,$#!  )+$%#*!-(,&#()+*%&$!- ,!+(,#*)-$%& :;=4<>765839;94<5:6>83=79:6543>7;=8<68>37=;49<:5=<8>;753496:4><:=;893756,*#!(+% &)$-*-!(&, +)$#%-, &!$+%*#)((!+*,#$)- %&+ )#$%-*!&(,)#(%+*!&$,- 73=86>:<54;935469:<=8;>7576983=:;>4<<4>;:=389675>68=379;45<:8=<7>;453:96%$#) +,(&!*-$&! -,(#)*+%&% -)$#,*+!(()#*%+$!& ,-+(!#*,-$)& %)+ %#$!-*,&(7;>8<=:69435398657<>4;=:5:<94;=73>86<8=;7>3456:9><4=;:9385678>67=349;:5<%*+)(#, -!$&$-) &%(+!*#,&,(-!*#%$+) ",
              "F 41/d -3 2/c": " !#$,+*)&(%-# !+$,&*)-(%!# ,+$)&*%-(:3>46=7<98;5;58<976=43>:97<58;>:3=46<8>;7=3496:5><8=;793456:8><7=;493:56%*#)(+, &!$-$-! &,(+)*#%&, -!$#%*+)( )+$%#*!-(,&#()+*%&$!- ,!+(,#*)-$%& :;=4<>765839;94<5:6>83=79:6543>7;=8<<4=;:>385679>64=3:9;85<78=67>345;:9<%$+) #,(-!*&$&) -%(#!*+,&%(-)*#,$+! (!+*,#$)- %&+ )#$%-*!&(,)#(%+*!&$,- 73=86>:<54;935469:<=8;>7576983=:;>4<68=37>;45<:9=<4>;:5389674>6:=389;75<,*+!(#% -)$&*-)(&% +!$#,-,(&!*+%$#) ()#*%+$!& ,-+(!#*,-$)& %)+ %#$!-*,&(7;>8<=:69435398657<>4;=:5:<94;=73>8664>3:=;89<75=68>375;49<:4=<:>;853796,$#! +%(&)*-*&!(-, #)$+%-% &)$+,*#!(",
              "I 4/m -3 2/m": " !#$%#$!& %&# !#$%&$!& %!# %#$!&$%& ! &%$&!$#% # #%$#!$&% &!#!$#% &! &%$$%& !& %#$!#&$%& !# %#$!%&$!& %# !#$%$#! #% &!$&$&! &% #!$#%&% &!$#%$#! ()+*,+*)-(,-+()+*,-*)-(,)+(,+*)-*,-()(-,*-)*+,(+(+,*+)*-,(-)+)*+,(-)(-,**,-()-(,+*)+-*,-()+(,+*),-*)-(,+()+*,*+)(+,(-)*-*-)(-,(+)*+,-,(-)*+,*+)(",
              "I 41/a -3 2/d": " !#*%+$)-(,&# !+*%-$)&(,!# %+*)-$,&(:3=8<>7694;5;54697<>83=:97654;=:3>8<$%&(!- ,+*)#&$%-(!+ ,#*)%&$!-(,+ )#*4<97358;=:6>6>:;=8357<94=8;>:694<573()+$,#*!& %-+()#$,&*!- %)+(,#$!&*%- 7;>46=:<5839398<5:6=4;>75:<983>7;=46*,- )&(%#$!+-*,& )#(%+$!,-*)& %#(!+$865:;943>7<=<=73>4;9:658>43=7<5869:;",
              "P 1 1 2": " !#$%#",
              "P 1 1 21": " !#$%+",
              "B 1 1 2": " !#$%#(g+*%+",
              "A 1 2 1": " !#$!& )+$)-",
              "C 1 21 1": " !#$)&()#*!&",
              "I 1 2 1": " !#$!&.'/0'2",
              "I 1 21 1": " !#$)&.'/0!-",
              "P 1 1 m": " !# !&",
              "P 1 1 b": " !# )&",
              "B 1 1 m": " !# !&(!+(!-",
              "B 1 1 b": " !# )&(!+()-",
              "P 1 1 2/m": " !# !&$%#$%&",
              "P 1 1 21/m": " !#$%+$%& !-",
              "B 1 1 2/m": " !# !&$%#$%&(!+(!-*%+*%-",
              "P 1 1 2/b": " !#$,#$%& )&",
              "P 1 1 21/b": " !#$%&$,+ )-",
              "B 1 1 2/b": " !#$,#$%& )&(!+*,+*%-()-",
              "P 21 2 2": " !#$!&(%&*%#",
              "P 2 21 2": " !# ,&$)&$%#",
              "P 21 21 2 (a)": " !#*,#.%&$'&",
              "P 21 2 21": " !#$!&(%-*%+",
              "P 2 21 21": " !# %&$)-$,+",
              "C 2 2 21a)": " !#*%+(,&$)-()#$,+ %&*!-",
              "C 2 2 2a": " !#*,#.%&$'&()#$%# ,&*!&",
              "F 2 2 2a": " !#*,#.%&$'& '/*%/.12$!2.!/$,/ %20'2.'#$%# 1&0!&",
              "I 2 2 2a": " !#*,#.%&$'&()+$%+*!- ,-",
              "P 21/m 21/m 2/n a": " !#*,#$)&(%&$%&.'& ,#*!#",
              "P 42 21 2a": " !#*,#%.+'$+$'&.%&! -,*-",
              "I 2 3a": " !#*,#.%&$'&!# ,- '&$%/$# !-*!/$%&.%()+$%+ ,-*!-)+(%&(!-*,#*+()&$)#*,- ,"
            },
            ov = /^[1-9]$/;
          function av(e) {
            var t = "";
            return 0 < e.length && (t = ":" + Ru(e).join(" OR :")), new Nc(t);
          }
          var sv = function sv(e) {
              void 0 === e && (e = ""), this.name = e, this.partList = [];
            },
            lv = {
              type: {
                configurable: !0
              }
            };
          lv.type.get = function () {
            return "Assembly";
          }, sv.prototype.addPart = function (e, t) {
            var n = new uv(e, t);
            return this.partList.push(n), n;
          }, sv.prototype.getAtomCount = function (e) {
            return this.partList.reduce(function (t, n) {
              return t + n.getAtomCount(e);
            }, 0);
          }, sv.prototype.getResidueCount = function (e) {
            return this.partList.reduce(function (t, n) {
              return t + n.getResidueCount(e);
            }, 0);
          }, sv.prototype.getInstanceCount = function () {
            var e = 0;
            return this.partList.forEach(function (t) {
              e += t.matrixList.length;
            }), e;
          }, sv.prototype.isIdentity = function (e) {
            if (1 !== this.partList.length) return !1;
            var t = this.partList[0];
            if (1 !== t.matrixList.length) return !1;
            if (!new ie().equals(t.matrixList[0])) return !1;
            var n = [];
            return e.eachChain(function (e) {
              n.push(e.chainname);
            }), n = Ru(n), t.chainList.length === n.length;
          }, sv.prototype.getBoundingBox = function (e) {
            var t = new Oe();
            return this.partList.forEach(function (n) {
              var r = n.getBoundingBox(e);
              t.expandByPoint(r.min), t.expandByPoint(r.max);
            }), t;
          }, sv.prototype.getCenter = function (e) {
            return this.getBoundingBox(e).getCenter(new ae());
          }, sv.prototype.getSelection = function () {
            var e = [];
            return this.partList.forEach(function (t) {
              e = e.concat(t.chainList);
            }), av(e);
          }, Object.defineProperties(sv.prototype, lv);
          var uv = function uv(e, t) {
              void 0 === e && (e = []), void 0 === t && (t = []), this.matrixList = e, this.chainList = t;
            },
            cv = {
              type: {
                configurable: !0
              }
            };
          cv.type.get = function () {
            return "AssemblyPart";
          }, uv.prototype._getCount = function (e, t) {
            var n = this,
              r = 0;
            return e.eachChain(function (e) {
              (0 === n.chainList.length || n.chainList.includes(e.chainname)) && (r += e[t]);
            }), this.matrixList.length * r;
          }, uv.prototype.getAtomCount = function (e) {
            return this._getCount(e, "atomCount");
          }, uv.prototype.getResidueCount = function (e) {
            return this._getCount(e, "residueCount");
          }, uv.prototype.getBoundingBox = function (e) {
            var t = new Oe(),
              n = new Oe(),
              r = this.getSelection(),
              i = e.getBoundingBox(r);
            return this.matrixList.forEach(function (e) {
              n.copy(i).applyMatrix4(e), t.expandByPoint(n.min), t.expandByPoint(n.max);
            }), t;
          }, uv.prototype.getSelection = function () {
            return av(this.chainList);
          }, uv.prototype.getView = function (e) {
            var t = this.getSelection();
            return t ? e.getView(t) : e;
          }, uv.prototype.getInstanceList = function () {
            for (var e = [], t = 0, n = this.matrixList.length; t < n; ++t) e.push({
              id: t + 1,
              name: t,
              matrix: this.matrixList[t]
            });
            return e;
          }, Object.defineProperties(uv.prototype, cv);
          var dv = function dv(e) {
            this.structure = e, this.currentModelindex = null, this.currentChainid = null, this.currentResname = null, this.currentResno = null, this.currentInscode = void 0, this.currentHetero = null, this.previousResname = "", this.previousHetero = null, this.ai = -1, this.ri = -1, this.ci = -1, this.mi = -1;
          };
          function hv(e, n) {
            if (n) {
              t.Debug && Zc.time("assignSecondaryStructure");
              var r = [];
              e.eachModel(function (e) {
                e.eachChain(function (e) {
                  r.push(e.chainname);
                });
              });
              var i = r.slice().sort(),
                o = [];
              i.forEach(function (e) {
                o.push(r.indexOf(e));
              });
              var a = n.helices.filter(function (e) {
                return 0 <= Pu(i, e[0]);
              });
              a.sort(function (e, t) {
                var n = e[0],
                  r = t[0],
                  a = e[1],
                  s = t[1];
                if (n === r) return a === s ? 0 : a < s ? -1 : 1;
                var l = Pu(i, n),
                  u = Pu(i, r);
                return o[l] < o[u] ? -1 : 1;
              });
              var s = e.residueStore;
              e.eachModel(function (e) {
                var t = 0,
                  n = a.length;
                if (0 !== n) {
                  var r = a[t],
                    i = !1,
                    o = !1;
                  e.eachChain(function (e) {
                    var l = !1;
                    if (e.chainname === r[0]) for (var u = e.residueCount, c = e.residueOffset, d = c + u, h = c; h < d; ++h) if (s.resno[h] === r[1] && s.getInscode(h) === r[2] && (i = !0), i && (s.sstruc[h] = r[6], s.resno[h] === r[4] && s.getInscode(h) === r[5] && (i = !1, (t += 1) < n ? (h = c - 1, r = a[t], l = e.chainname !== r[0]) : o = !0)), l || o) return;
                  });
                }
              });
              var l = n.sheets.filter(function (e) {
                return 0 <= Pu(i, e[0]);
              });
              l.sort(function (e, t) {
                var n = e[0],
                  r = t[0];
                if (n === r) return 0;
                var a = Pu(i, n),
                  s = Pu(i, r);
                return o[a] < o[s] ? -1 : 1;
              });
              var u = "e".charCodeAt(0);
              e.eachModel(function (e) {
                var t = 0,
                  n = l.length;
                if (0 !== n) {
                  var r = l[t],
                    i = !1,
                    o = !1;
                  e.eachChain(function (e) {
                    var a = !1;
                    if (e.chainname === r[0]) for (var c = e.residueCount, d = e.residueOffset, h = d + c, f = d; f < h; ++f) if (s.resno[f] === r[1] && s.getInscode(f) === r[2] && (i = !0), i && (s.sstruc[f] = u, s.resno[f] === r[4] && s.getInscode(f) === r[5] && (i = !1, (t += 1) < n ? (f = d - 1, r = l[t], a = e.chainname !== r[0]) : o = !0)), a || o) return;
                  });
                }
              }), t.Debug && Zc.timeEnd("assignSecondaryStructure");
            }
          }
          dv.prototype.addResidueType = function (e) {
            for (var t = this.structure.atomStore, n = this.structure.residueStore, r = this.structure.residueMap, i = n.atomCount[e], o = n.atomOffset[e], a = new Array(i), s = 0; s < i; ++s) a[s] = t.atomTypeId[o + s];
            n.residueTypeId[e] = r.add(this.previousResname, a, this.previousHetero);
          }, dv.prototype.addAtom = function (e, t, n, r, i, o, a, s) {
            var l = this.structure.atomStore,
              u = this.structure.residueStore,
              c = this.structure.chainStore,
              d = this.structure.modelStore,
              h = !1,
              f = !1,
              p = !1;
            this.currentModelindex !== e ? (p = f = h = !0, this.mi += 1, this.ci += 1, this.ri += 1) : this.currentChainid !== n ? (p = f = !0, this.ci += 1, this.ri += 1) : this.currentResno === i && this.currentResname === r && this.currentInscode === s || (p = !0, this.ri += 1), this.ai += 1, h && (d.growIfFull(), d.chainOffset[this.mi] = this.ci, d.chainCount[this.mi] = 0, d.count += 1, c.modelIndex[this.ci] = this.mi), f && (c.growIfFull(), c.setChainname(this.ci, t), c.setChainid(this.ci, n), c.residueOffset[this.ci] = this.ri, c.residueCount[this.ci] = 0, c.count += 1, c.modelIndex[this.ci] = this.mi, d.chainCount[this.mi] += 1, u.chainIndex[this.ri] = this.ci), p && (this.previousResname = this.currentResname, this.previousHetero = this.currentHetero, 0 < this.ri && this.addResidueType(this.ri - 1), u.growIfFull(), u.resno[this.ri] = i, void 0 !== a && (u.sstruc[this.ri] = a.charCodeAt(0)), void 0 !== s && (u.inscode[this.ri] = s.charCodeAt(0)), u.atomOffset[this.ri] = this.ai, u.atomCount[this.ri] = 0, u.count += 1, u.chainIndex[this.ri] = this.ci, c.residueCount[this.ci] += 1), l.count += 1, l.residueIndex[this.ai] = this.ri, u.atomCount[this.ri] += 1, this.currentModelindex = e, this.currentChainid = n, this.currentResname = r, this.currentResno = i, this.currentInscode = s, this.currentHetero = o;
          }, dv.prototype.finalize = function () {
            this.previousResname = this.currentResname, this.previousHetero = this.currentHetero, -1 < this.ri && this.addResidueType(this.ri);
          };
          var fv,
            pv = (fv = function fv(e, t, n, r) {
              for (var i = e.structure, o = e.residueIndexStart, a = i.getResidueProxy(), s = i.getResidueProxy(), l = i.getAtomProxy(), u = i.getAtomProxy(), c = Math.max(0, t - 2); c <= t; ++c) for (var d = 2; d < 5; ++d) if (!(c + d >= e.residueCount)) {
                a.index = o + c, s.index = o + c + d, l.index = a.traceAtomIndex, u.index = s.traceAtomIndex;
                var h = l.distanceTo(u);
                if (Math.abs(h - n[d - 2]) > r) return !1;
              }
              return !0;
            }, function (e) {
              t.Debug && Zc.time("calculateSecondaryStructure"), e.eachPolymer(function (e) {
                if (!(e.residueCount < 4)) {
                  if (e.isCg()) !function (e) {
                    for (var t = e.residueStore, n = e.residueIndexStart, r = new Xg(e).position, i = new ae(), o = new ae(), a = 0, s = e.residueCount; a < s; ++a) {
                      i.fromArray(r.center, 3 * a), o.fromArray(r.center, 3 * a + 3);
                      var l = i.distanceTo(o);
                      l < 2 && 1 < l && r.bending[a] < 20 && (t.sstruc[n + a] = "h".charCodeAt(0), t.sstruc[n + a + 1] = "h".charCodeAt(0));
                    }
                  }(e);else {
                    if (!e.isProtein()) return;
                    !function (e) {
                      for (var t = e.residueStore, n = e.residueIndexStart, r = 0, i = e.residueCount; r < i; ++r) {
                        var o = "c";
                        fv(e, r, [5.45, 5.18, 6.37], 2.1) ? o = "h" : fv(e, r, [6.1, 10.4, 13], 1.42) && (o = "e"), t.sstruc[n + r] = o.charCodeAt(0);
                      }
                    }(e);
                  }
                  var t,
                    n = 0;
                  e.eachResidue(function (e) {
                    e.sstruc === t ? n += 1 : (1 === n && (e.index -= 1, e.sstruc = "c"), n = 1, t = e.sstruc);
                  });
                }
              }), t.Debug && Zc.timeEnd("calculateSecondaryStructure");
            }),
            mv = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          function gv(e) {
            for (var t = mv.length, n = e, r = 0, i = mv[n % t]; t <= n;) n = Math.floor(n / t), i += mv[n % t], r += 1;
            return 5 <= r && Zc.warn("chainname overflow"), i;
          }
          function vv(e, n) {
            void 0 === n && (n = !1), t.Debug && Zc.time("calculateChainnames");
            var r = !0;
            if (e.eachChain(function (e) {
              e.chainname && (r = !1);
            }), r) {
              var i = e.modelStore,
                o = e.chainStore,
                a = e.residueStore,
                s = e.getAtomProxy(),
                l = e.getAtomProxy(),
                u = 0,
                c = 0,
                d = 0,
                h = 0,
                f = [];
              1 === a.count ? f.push({
                mIndex: 0,
                chainname: "A",
                rStart: 0,
                rCount: 1
              }) : e.eachResidueN(2, function (e, t) {
                var r = !1,
                  i = e.backboneType,
                  o = t.backboneType;
                h = e.index, e.modelIndex !== t.modelIndex || e.moleculeType !== t.moleculeType ? r = !0 : 0 !== i && i === o && (s.index = e.backboneEndAtomIndex, l.index = t.backboneStartAtomIndex, r = n ? !s.hasBondTo(l) : !s.connectedTo(l)), r || t.index !== a.count - 1 || (r = !0, h = t.index), r && (f.push({
                  mIndex: c,
                  chainname: gv(u),
                  rStart: d,
                  rCount: h - d + 1
                }), u += 1, e.modelIndex !== t.modelIndex && (u = 0, c += 1), t.index === a.count - 1 && h !== t.index && f.push({
                  mIndex: c,
                  chainname: gv(u),
                  rStart: a.count - 1,
                  rCount: 1
                }), d = t.index, h = t.index);
              }), o.count = 0, f.forEach(function (e) {
                !function (e, t, n, r) {
                  for (var s = o.count, l = 0; l < r; ++l) a.chainIndex[n + l] = s;
                  o.growIfFull(), o.modelIndex[s] = e, o.setChainname(s, t), o.setChainid(s, t), o.residueOffset[s] = n, o.residueCount[s] = r, o.count += 1, i.chainCount[e] += 1;
                }(e.mIndex, e.chainname, e.rStart, e.rCount);
              });
              var p = 0;
              e.eachModel(function (e) {
                i.chainOffset[e.index] = p, i.chainCount[e.index] -= 1, p += i.chainCount[e.index];
              });
            }
            t.Debug && Zc.timeEnd("calculateChainnames");
          }
          function yv(e) {
            t.Debug && Zc.time("calculateBonds"), xv(e), wv(e), t.Debug && Zc.timeEnd("calculateBonds");
          }
          var bv = {
            "HIS|CD2|CG": 2,
            "HIS|CE1|ND1": 2,
            "ARG|CZ|NH2": 2,
            "PHE|CE1|CZ": 2,
            "PHE|CD2|CE2": 2,
            "PHE|CD1|CG": 2,
            "TRP|CD1|CG": 2,
            "TRP|CD2|CE2": 2,
            "TRP|CE3|CZ3": 2,
            "TRP|CH2|CZ2": 2,
            "ASN|CG|OD1": 2,
            "GLN|CD|OE1": 2,
            "TYR|CD1|CG": 2,
            "TYR|CD2|CE2": 2,
            "TYR|CE1|CZ": 2,
            "ASP|CG|OD1": 2,
            "GLU|CD|OE1": 2,
            "G|C8|N7": 2,
            "G|C4|C5": 2,
            "G|C2|N3": 2,
            "G|C6|O6": 2,
            "C|C4|N3": 2,
            "C|C5|C6": 2,
            "C|C2|O2": 2,
            "A|C2|N3": 2,
            "A|C6|N1": 2,
            "A|C4|C5": 2,
            "A|C8|N7": 2,
            "U|C5|C6": 2,
            "U|C2|O2": 2,
            "U|C4|O4": 2,
            "DG|C8|N7": 2,
            "DG|C4|C5": 2,
            "DG|C2|N3": 2,
            "DG|C6|O6": 2,
            "DC|C4|N3": 2,
            "DC|C5|C6": 2,
            "DC|C2|O2": 2,
            "DA|C2|N3": 2,
            "DA|C6|N1": 2,
            "DA|C4|C5": 2,
            "DA|C8|N7": 2,
            "DT|C5|C6": 2,
            "DT|C2|O2": 2,
            "DT|C4|O4": 2
          };
          function _v(e, t, n) {
            var r;
            return t = (r = t < n ? [t, n] : [n, t])[0], n = r[1], wp.includes(e) && "C" === t && "O" === n || Tp.includes(e) && "OP1" === t && "P" === n ? 2 : bv[e + "|" + t + "|" + n] || 1;
          }
          function xv(e, n) {
            void 0 === n && (n = !1), t.Debug && Zc.time("calculateBondsWithin");
            var r = e.bondStore,
              i = e.rungBondStore,
              o = e.getAtomSet(!1),
              a = e.getAtomProxy(),
              s = e.getAtomProxy(),
              l = e.getBondProxy(),
              u = n ? null : function (e) {
                t.Debug && Zc.time("calculateAtomBondMap");
                var n = [];
                return e.eachBond(function (e) {
                  var t = e.atomIndex1,
                    r = e.atomIndex2;
                  void 0 === n[t] && (n[t] = []), n[t][r] = e.index;
                }), t.Debug && Zc.timeEnd("calculateAtomBondMap"), n;
              }(e);
            e.eachResidue(function (e) {
              if (!n && u) {
                var t = e.atomCount,
                  c = e.atomOffset;
                if (500 < t) return void Zc.warn("more than 500 atoms, skip residue for auto-bonding", e.qualifiedName());
                for (var d = e.getBonds(), h = d.atomIndices1, f = d.atomIndices2, p = d.bondOrders, m = h.length, g = 0; g < m; ++g) {
                  var v = h[g],
                    y = f[g],
                    b = v + c,
                    _ = y + c,
                    x = u[b];
                  void 0 !== x && void 0 !== x[_] ? (l.index = x[_], p[e.residueType.getBondIndex(v, y)] = l.bondOrder) : (a.index = b, s.index = _, r.addBond(a, s, p[g]));
                }
              }
              var w = e.residueType.traceAtomIndex,
                S = e.residueType.rungEndAtomIndex;
              -1 !== w && -1 !== S && (a.index = e.traceAtomIndex, s.index = e.rungEndAtomIndex, i.addBond(a, s), o.set(a.index), o.set(s.index));
            }), e.atomSetDict.rung = o, t.Debug && Zc.timeEnd("calculateBondsWithin");
          }
          function wv(e, n, r) {
            void 0 === n && (n = !1), void 0 === r && (r = !1), t.Debug && Zc.time("calculateBondsBetween");
            var i = e.bondStore,
              o = e.backboneBondStore,
              a = e.getAtomSet(!1),
              s = e.getAtomProxy(),
              l = e.getAtomProxy();
            function u(e, t) {
              var u = e.backboneType,
                c = t.backboneType;
              0 !== u && u === c && (s.index = e.backboneEndAtomIndex, l.index = t.backboneStartAtomIndex, (r && s.hasBondTo(l) || s.connectedTo(l)) && (n || i.addBond(s, l, 1), s.index = e.traceAtomIndex, l.index = t.traceAtomIndex, o.addBond(s, l), a.set(s.index), a.set(l.index)));
            }
            0 === o.count && o.resize(e.residueStore.count), e.eachResidueN(2, u);
            var c = e.getResidueProxy(),
              d = e.getResidueProxy();
            if (e.eachChain(function (e) {
              0 !== e.residueCount && (c.index = e.residueOffset, d.index = e.residueOffset + e.residueCount - 1, u(d, c));
            }), e.atomSetDict.backbone = a, !n) {
              t.Debug && Zc.time("calculateBondsBetween inter");
              var h = e.spatialHash;
              e.eachResidue(function (e) {
                0 !== e.backboneType || e.isWater() || e.eachAtom(function (e) {
                  e.isMetal() || h.eachWithin(e.x, e.y, e.z, 4, function (t) {
                    l.index = t, e.modelIndex !== l.modelIndex || e.residueIndex === l.residueIndex || l.isMetal() || i.addBondIfConnected(e, l, 1);
                  });
                });
              }), t.Debug && Zc.timeEnd("calculateBondsBetween inter");
            }
            t.Debug && Zc.timeEnd("calculateBondsBetween");
          }
          function Sv(e) {
            if (e.unitcell) {
              t.Debug && Zc.time("buildUnitcellAssembly");
              var n = e.unitcell,
                r = e.center.clone().applyMatrix4(n.cartToFrac),
                i = r.clone().floor(),
                o = function (e) {
                  var t = iv[e],
                    n = {};
                  if (void 0 === t) return console.warn("spacegroup '" + e + "' not found in symop library"), n;
                  for (var r = [], i = 0, o = t.length; i < o; i += 3) {
                    for (var a = [], s = 0; s < 3; ++s) a.push(rv[t[i + s]]);
                    r.push(a);
                  }
                  return r.forEach(function (e) {
                    var t = 0,
                      r = new ie().set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1),
                      i = r.elements;
                    n[e.toString()] = r, e.forEach(function (e) {
                      for (var n = !1, r = !1, o = 0, a = e.length; o < a; ++o) {
                        var s = e[o];
                        if ("-" === s) n = !0;else if ("+" === s) n = !1;else if ("/" === s) r = !0;else if ("X" === s) i[0 + t] = n ? -1 : 1;else if ("Y" === s) i[4 + t] = n ? -1 : 1;else if ("Z" === s) i[8 + t] = n ? -1 : 1;else if (ov.test(s)) {
                          var l = parseInt(s);
                          r ? i[12 + t] /= l : i[12 + t] = l;
                        } else Zc.warn("getSymmetryOperations: unknown token '" + s + "'");
                      }
                      t += 1;
                    });
                  }), n;
                }(n.spacegroup),
                a = new ae(),
                s = new ae(),
                l = new sv("UNITCELL"),
                u = g(),
                c = [];
              if (e.biomolDict.NCS) {
                c.push.apply(c, [new ie()].concat(e.biomolDict.NCS.partList[0].matrixList));
                var d = [];
                u.forEach(function (e) {
                  c.forEach(function (t) {
                    d.push(e.clone().multiply(t));
                  });
                }), l.addPart(d);
              } else l.addPart(u);
              var h = new ae(),
                f = new sv("SUPERCELL"),
                p = Array.prototype.concat.call(g(h.set(1, 0, 0)), g(h.set(0, 1, 0)), g(h.set(0, 0, 1)), g(h.set(-1, 0, 0)), g(h.set(0, -1, 0)), g(h.set(0, 0, -1)), g(h.set(1, 1, 0)), g(h.set(1, 0, 1)), g(h.set(0, 1, 1)), g(h.set(-1, -1, 0)), g(h.set(-1, 0, -1)), g(h.set(0, -1, -1)), g(h.set(1, -1, -1)), g(h.set(1, 1, -1)), g(h.set(1, -1, 1)), g(h.set(-1, 1, 1)), g(h.set(-1, -1, 1)), g(h.set(-1, 1, -1)), g(h.set(0, 1, -1)), g(h.set(0, -1, 1)), g(h.set(1, 0, -1)), g(h.set(-1, 0, 1)), g(h.set(1, -1, 0)), g(h.set(-1, 1, 0)), g(), g(h.set(1, 1, 1)), g(h.set(-1, -1, -1)));
              if (e.biomolDict.NCS) {
                var m = [];
                p.forEach(function (e) {
                  c.forEach(function (t) {
                    m.push(e.clone().multiply(t));
                  });
                }), f.addPart(m);
              } else f.addPart(p);
              e.biomolDict.UNITCELL = l, e.biomolDict.SUPERCELL = f, t.Debug && Zc.timeEnd("buildUnitcellAssembly");
            }
            function g(e) {
              var t = [];
              return Object.keys(o).forEach(function (l) {
                var u = o[l].clone();
                a.copy(r).applyMatrix4(u).floor(), s.setFromMatrixPosition(u), s.sub(a), s.add(i), e && s.add(e), u.setPosition(s), u.multiplyMatrices(n.fracToCart, u), u.multiply(n.cartToFrac), t.push(u);
              }), t;
            }
          }
          var Av = ["H", "C", "O", "N", "S", "P"],
            Ev = ["NA", "CL", "FE"];
          function Tv(e) {
            var t = e.trim().toUpperCase();
            parseInt(t.charAt(0)) && (t = t.substr(1)), parseInt(t.charAt(0)) && (t = t.substr(1));
            var n = t.length;
            if (0 === n) return "";
            if (1 === n) return t;
            if (2 === n) {
              if (-1 !== Ev.indexOf(t)) return t;
              if (-1 !== Av.indexOf(t[0])) return t[0];
            }
            return 3 <= n && -1 !== Av.indexOf(t[0]) ? t[0] : "";
          }
          function Mv(e) {
            var t = e.bondHash,
              n = t.countArray,
              r = t.offsetArray,
              i = t.indexArray,
              o = e.getBondProxy();
            e.eachResidue(function (e) {
              var t = e.residueType;
              if (void 0 === t.bonds) {
                var a = e.atomOffset,
                  s = [],
                  l = [],
                  u = [],
                  c = {},
                  d = a + e.atomCount;
                e.eachAtom(function (e) {
                  for (var t = e.index, h = r[t], f = 0, p = n[t]; f < p; ++f) {
                    o.index = i[h + f];
                    var m = o.atomIndex1;
                    if (!(m < a || d <= m)) {
                      var g = o.atomIndex2;
                      if (!(g < a || d <= g)) {
                        if (g < m) {
                          var v = g;
                          g = m, m = v;
                        }
                        var y = m + "|" + g;
                        void 0 === c[y] && (c[y] = !0, s.push(m - a), l.push(g - a), u.push(o.bondOrder));
                      }
                    }
                  }
                }), t.bonds = {
                  atomIndices1: s,
                  atomIndices2: l,
                  bondOrders: u
                };
              }
            });
          }
          var Cv = [3, 11, 19, 37, 55, 87],
            kv = [4, 12, 20, 38, 56, 88],
            Pv = [6, 15, 16, 34],
            Ov = [1, 7, 8, 9, 17, 35, 53],
            Rv = [2, 10, 18, 36, 54, 86],
            Iv = [13, 30, 31, 48, 49, 50, 80, 81, 82, 83, 84, 85, 112],
            jv = [5, 14, 32, 33, 51, 52, 85],
            Nv = [9, 17, 35, 53, 85],
            Lv = function Lv(e, t, n) {
              this.structure = e, this.atomname = t, n = n || Tv(t), this.element = n, this.number = pp[n] || 0, this.vdw = mp[this.number] || 2, this.covalent = gp[this.number] || 1.6;
            };
          Lv.prototype.getDefaultValence = function () {
            var e = vp[this.number];
            return e ? e[0] : -1;
          }, Lv.prototype.getValenceList = function () {
            return vp[this.number] || [];
          }, Lv.prototype.getOuterShellElectronCount = function () {
            return yp[this.number] || 2;
          }, Lv.prototype.isMetal = function () {
            return this.isAlkaliMetal() || this.isAlkalineEarthMetal() || this.isLanthanide() || this.isActinide() || this.isTransitionMetal() || this.isPostTransitionMetal();
          }, Lv.prototype.isNonmetal = function () {
            return this.isDiatomicNonmetal() || this.isPolyatomicNonmetal() || this.isNobleGas();
          }, Lv.prototype.isMetalloid = function () {
            return jv.includes(this.number);
          }, Lv.prototype.isHalogen = function () {
            return Nv.includes(this.number);
          }, Lv.prototype.isDiatomicNonmetal = function () {
            return Ov.includes(this.number);
          }, Lv.prototype.isPolyatomicNonmetal = function () {
            return Pv.includes(this.number);
          }, Lv.prototype.isAlkaliMetal = function () {
            return Cv.includes(this.number);
          }, Lv.prototype.isAlkalineEarthMetal = function () {
            return kv.includes(this.number);
          }, Lv.prototype.isNobleGas = function () {
            return Rv.includes(this.number);
          }, Lv.prototype.isTransitionMetal = function () {
            var e = this.number;
            return 21 <= e && e <= 29 || 39 <= e && e <= 47 || 72 <= e && e <= 79 || 104 <= e && e <= 108;
          }, Lv.prototype.isPostTransitionMetal = function () {
            return Iv.includes(this.number);
          }, Lv.prototype.isLanthanide = function () {
            return 57 <= this.number && this.number <= 71;
          }, Lv.prototype.isActinide = function () {
            return 89 <= this.number && this.number <= 103;
          };
          var Dv = function Dv(e) {
            this.structure = e, this.dict = {}, this.list = [], this.structure = e;
          };
          Dv.prototype.add = function (e, t) {
            var n = (e = e.toUpperCase()) + "|" + (t = t ? t.toUpperCase() : Tv(e)),
              r = this.dict[n];
            if (void 0 === r) {
              var i = new Lv(this.structure, e, t);
              r = this.list.length, this.dict[n] = r, this.list.push(i);
            }
            return r;
          }, Dv.prototype.get = function (e) {
            return this.list[e];
          };
          var Bv = function Bv(e, t, n, r, i, o) {
            this.structure = e, this.bondReferenceAtomIndices = [], this.resname = t, this.atomTypeIdList = n, this.hetero = r ? 1 : 0, this.chemCompType = i, this.bonds = o, this.atomCount = n.length, this.moleculeType = this.getMoleculeType(), this.backboneType = this.getBackboneType(0), this.backboneEndType = this.getBackboneType(-1), this.backboneStartType = this.getBackboneType(1), this.backboneIndexList = this.getBackboneIndexList();
            var a = Rp[this.backboneType],
              s = Rp[this.backboneStartType],
              l = Rp[this.backboneEndType],
              u = this.getAtomIndexByName(a.trace);
            this.traceAtomIndex = wu(u, -1);
            var c = this.getAtomIndexByName(a.direction1);
            this.direction1AtomIndex = wu(c, -1);
            var d = this.getAtomIndexByName(a.direction2);
            this.direction2AtomIndex = wu(d, -1);
            var h = this.getAtomIndexByName(s.backboneStart);
            this.backboneStartAtomIndex = wu(h, -1);
            var f,
              p = this.getAtomIndexByName(l.backboneEnd);
            this.backboneEndAtomIndex = wu(p, -1), f = Ep.includes(t) ? this.getAtomIndexByName("N1") : this.getAtomIndexByName("N3"), this.rungEndAtomIndex = wu(f, -1);
          };
          Bv.prototype.getBackboneIndexList = function () {
            var e,
              t = [];
            switch (this.moleculeType) {
              case 3:
                e = Pp;
                break;
              case 4:
              case 5:
                e = Op;
                break;
              default:
                return t;
            }
            for (var n = this.structure.atomMap, r = this.atomTypeIdList, i = 0, o = this.atomCount; i < o; ++i) {
              var a = n.get(r[i]);
              e.includes(a.atomname) && t.push(i);
            }
            return t;
          }, Bv.prototype.getMoleculeType = function () {
            return this.isProtein() ? 3 : this.isRna() ? 4 : this.isDna() ? 5 : this.isWater() ? 1 : this.isIon() ? 2 : this.isSaccharide() ? 6 : 0;
          }, Bv.prototype.getBackboneType = function (e) {
            return this.hasProteinBackbone(e) ? 1 : this.hasRnaBackbone(e) ? 2 : this.hasDnaBackbone(e) ? 3 : this.hasCgProteinBackbone(e) ? 4 : this.hasCgRnaBackbone(e) ? 5 : this.hasCgDnaBackbone(e) ? 6 : 0;
          }, Bv.prototype.isProtein = function () {
            return this.chemCompType ? ap.includes(this.chemCompType) : this.hasAtomWithName("CA", "C", "N") || wp.includes(this.resname);
          }, Bv.prototype.isCg = function () {
            var e = this.backboneType;
            return 4 === e || 5 === e || 6 === e;
          }, Bv.prototype.isNucleic = function () {
            return this.isRna() || this.isDna();
          }, Bv.prototype.isRna = function () {
            return this.chemCompType ? sp.includes(this.chemCompType) : 1 !== this.hetero && (this.hasAtomWithName(["P", "O3'", "O3*"], ["C4'", "C4*"], ["O2'", "O2*", "F2'", "F2*"]) || Sp.includes(this.resname) && this.hasAtomWithName(["O2'", "O2*", "F2'", "F2*"]));
          }, Bv.prototype.isDna = function () {
            return this.chemCompType ? lp.includes(this.chemCompType) : 1 !== this.hetero && (this.hasAtomWithName(["P", "O3'", "O3*"], ["C3'", "C3*"]) && !this.hasAtomWithName(["O2'", "O2*", "F2'", "F2*"]) || Ap.includes(this.resname));
          }, Bv.prototype.isHetero = function () {
            return 1 === this.hetero;
          }, Bv.prototype.isIon = function () {
            return Cp.includes(this.resname);
          }, Bv.prototype.isWater = function () {
            return Mp.includes(this.resname);
          }, Bv.prototype.isSaccharide = function () {
            return this.chemCompType ? up.includes(this.chemCompType) : kp.includes(this.resname);
          }, Bv.prototype.isStandardAminoacid = function () {
            return wp.includes(this.resname);
          }, Bv.prototype.isStandardBase = function () {
            return Tp.includes(this.resname);
          }, Bv.prototype.hasBackboneAtoms = function (e, t) {
            var n = Rp[t];
            return -1 === e ? this.hasAtomWithName(n.trace, n.backboneEnd, n.direction1, n.direction2) : 0 === e ? this.hasAtomWithName(n.trace, n.direction1, n.direction2) : 1 === e ? this.hasAtomWithName(n.trace, n.backboneStart, n.direction1, n.direction2) : this.hasAtomWithName(n.trace, n.backboneStart, n.backboneEnd, n.direction1, n.direction2);
          }, Bv.prototype.hasProteinBackbone = function (e) {
            return this.isProtein() && this.hasBackboneAtoms(e, 1);
          }, Bv.prototype.hasRnaBackbone = function (e) {
            return this.isRna() && this.hasBackboneAtoms(e, 2);
          }, Bv.prototype.hasDnaBackbone = function (e) {
            return this.isDna() && this.hasBackboneAtoms(e, 3);
          }, Bv.prototype.hasCgProteinBackbone = function (e) {
            return this.atomCount < 7 && this.isProtein() && this.hasBackboneAtoms(e, 4);
          }, Bv.prototype.hasCgRnaBackbone = function (e) {
            return this.atomCount < 11 && this.isRna() && this.hasBackboneAtoms(e, 5);
          }, Bv.prototype.hasCgDnaBackbone = function (e) {
            return this.atomCount < 11 && this.isDna() && this.hasBackboneAtoms(e, 6);
          }, Bv.prototype.hasBackbone = function (e) {
            return this.hasProteinBackbone(e) || this.hasRnaBackbone(e) || this.hasDnaBackbone(e) || this.hasCgProteinBackbone(e) || this.hasCgRnaBackbone(e) || this.hasCgDnaBackbone(e);
          }, Bv.prototype.getAtomIndexByName = function (e) {
            var t = this.atomCount,
              n = this.structure.atomMap,
              r = this.atomTypeIdList;
            if (Array.isArray(e)) for (var i = 0; i < t; ++i) {
              var o = r[i];
              if (e.includes(n.get(o).atomname)) return i;
            } else for (var a = 0; a < t; ++a) {
              var s = r[a];
              if (e === n.get(s).atomname) return a;
            }
          }, Bv.prototype.hasAtomWithName = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            for (var n = e.length, r = 0; r < n; ++r) if (void 0 !== e[r] && void 0 === this.getAtomIndexByName(e[r])) return !1;
            return !0;
          }, Bv.prototype.getBonds = function (e) {
            return void 0 === this.bonds && (this.bonds = function (e) {
              var n = e.structure,
                r = n.getAtomProxy(),
                i = n.getAtomProxy(),
                o = e.atomCount,
                a = e.atomOffset,
                s = a + o - 1,
                l = [],
                u = [],
                c = [];
              if (500 < o) t.Debug && Zc.warn("more than 500 atoms, skip residue for auto-bonding", e.qualifiedName());else if (50 < o) for (var d = new nv(e, !0), h = e.isCg() ? 1.2 : 2.3, f = a; f < s; ++f) {
                r.index = f;
                for (var p = r.covalent + h + .3, m = d.nearest(r, 1 / 0, p * p), g = m.length, v = 0; v < g; ++v) i.index = m[v].index, r.index < i.index && r.connectedTo(i) && (l.push(r.index - a), u.push(i.index - a), c.push(_v(r.resname, r.atomname, i.atomname)));
              } else for (var y = a; y < s; ++y) for (var b = (r.index = y) + 1; b <= s; ++b) i.index = b, r.connectedTo(i) && (l.push(y - a), u.push(b - a), c.push(_v(r.resname, r.atomname, i.atomname)));
              return {
                atomIndices1: l,
                atomIndices2: u,
                bondOrders: c
              };
            }(e)), this.bonds;
          }, Bv.prototype.getRings = function () {
            return void 0 === this.rings && this.calculateRings(), this.rings;
          }, Bv.prototype.getBondGraph = function () {
            return void 0 === this.bondGraph && this.calculateBondGraph(), this.bondGraph;
          }, Bv.prototype.getAromatic = function (e) {
            return void 0 === this.aromaticAtoms && this.calculateAromatic(this.structure.getResidueProxy(e.residueIndex)), this.aromaticAtoms;
          }, Bv.prototype.getAromaticRings = function (e) {
            return void 0 === this.aromaticRings && this.calculateAromatic(e), this.aromaticRings;
          }, Bv.prototype.calculateBondGraph = function () {
            for (var e = this.bondGraph = {}, t = this.getBonds(), n = t.atomIndices1.length, r = t.atomIndices1, i = t.atomIndices2, o = 0; o < n; ++o) {
              var a = r[o],
                s = i[o];
              (e[a] = e[a] || []).push(s), (e[s] = e[s] || []).push(a);
            }
          }, Bv.prototype.calculateRings = function () {
            for (var e = function (e, t) {
                for (var n = {
                    count: t,
                    visited: new Int32Array(t),
                    queue: new Int32Array(t),
                    pred: new Int32Array(t),
                    left: new Int32Array(Vv),
                    right: new Int32Array(Vv),
                    color: new Int32Array(t),
                    currentColor: 0,
                    rings: [],
                    atomRings: [],
                    bonds: e
                  }, r = 0; r < t; r++) n.visited[r] = -1, n.pred[r] = -1;
                return n;
              }(this.getBondGraph(), this.atomCount), t = 0; t < e.count; t++) 0 <= e.visited[t] || Gv(e, t);
            this.rings = {
              atomRings: e.atomRings,
              rings: e.rings
            };
          }, Bv.prototype.isAromatic = function (e) {
            return this.aromaticAtoms = this.getAromatic(e), 1 === this.aromaticAtoms[e.index - e.residueAtomOffset];
          }, Bv.prototype.calculateAromatic = function (e) {
            var t = this,
              n = this.aromaticAtoms = new Uint8Array(this.atomCount),
              r = this.getRings().rings,
              i = r.map(function (n) {
                return function (e) {
                  if (e.some(function (e) {
                    return !Fv.includes(e.number);
                  })) return !1;
                  var t = 0,
                    n = new Pm(3, e.length),
                    r = n.data;
                  return e.forEach(function (e) {
                    r[t + 0] = e.x, r[t + 1] = e.y, r[t + 2] = e.z, t += 3;
                  }), new Bg(n).vecC.length() < zv;
                }(n.map(function (n) {
                  return t.structure.getAtomProxy(n + e.atomOffset);
                }));
              }),
              o = this.aromaticRings = [];
            r.forEach(function (e, t) {
              i[t] && (o.push(e), e.forEach(function (e) {
                return n[e] = 1;
              }));
            });
          }, Bv.prototype.assignBondReferenceAtomIndices = function () {
            for (var e = this.getBondGraph(), t = this.getRings(), n = t.atomRings, r = t.rings, i = this.bonds, o = i.atomIndices1, a = i.atomIndices2, s = i.bondOrders, l = this.bondReferenceAtomIndices, u = i.atomIndices1.length, c = l.length = 0; c < u; ++c) if (!(s[c] <= 1)) {
              var d = void 0,
                h = o[c],
                f = a[c],
                p = n[h],
                m = n[f];
              if (p && m) for (var g = 0; g < p.length; g++) if (-1 !== m.indexOf(p[g])) {
                d = r[p[g]];
                break;
              }
              if (1 < e[h].length) for (var v = 0; v < e[h].length; ++v) {
                var y = e[h][v];
                if (y !== f && (void 0 === d || -1 !== d.indexOf(y))) {
                  l[c] = y;
                  break;
                }
              } else if (1 < e[f].length) for (var b = 0; b < e[f].length; ++b) {
                var _ = e[f][b];
                if (_ !== h && (void 0 === d || -1 !== d.indexOf(_))) {
                  l[c] = _;
                  break;
                }
              }
            }
          }, Bv.prototype.getBondIndex = function (e, t) {
            for (var n = this.bonds, r = n.atomIndices1, i = n.atomIndices2, o = r.indexOf(e), a = i.indexOf(t), s = a; -1 !== o;) {
              for (; -1 !== a;) {
                if (o === a) return o;
                a = i.indexOf(t, a + 1);
              }
              o = r.indexOf(e, o + 1), a = s;
            }
          }, Bv.prototype.getBondReferenceAtomIndex = function (e, t) {
            var n = this.getBondIndex(e, t);
            if (void 0 !== n) return 0 === this.bondReferenceAtomIndices.length && this.assignBondReferenceAtomIndices(), this.bondReferenceAtomIndices[n];
          };
          var Fv = [5, 6, 7, 8, 14, 15, 16, 32, 33, 50, 51, 83],
            zv = .05;
          function Uv(e, t, n) {
            if (!(n < t)) {
              for (var r = e.pred, i = e.color, o = e.left, a = e.right, s = ++e.currentColor, l = t, u = 0; u < Vv && (i[l] = s, !((l = r[l]) < 0)); u++);
              var c = 0,
                d = 0,
                h = !1,
                f = 0;
              l = n;
              for (var p = 0; p < Vv; p++) {
                if (i[l] === s) {
                  f = l, h = !0;
                  break;
                }
                if ((l = r[a[d++] = l]) < 0) break;
              }
              if (h) {
                l = t;
                for (var m = 0; m < Vv && f !== (o[c++] = l) && !((l = r[l]) < 0); m++);
                for (var g = c + d, v = new Array(g), y = 0, b = 0; b < c; b++) v[y++] = o[b];
                for (var _ = d - 1; 0 <= _; _--) v[y++] = a[_];
                for (var x = e.rings.length, w = 0; w < g; ++w) {
                  var S = v[w];
                  e.atomRings[S] ? e.atomRings[S].push(x) : e.atomRings[S] = [x];
                }
                e.rings.push(v);
              }
            }
          }
          function Gv(e, t) {
            var n = e.bonds,
              r = e.visited,
              i = e.queue,
              o = e.pred;
            r[t] = 1, i[0] = t;
            for (var a = 0, s = 1; a < s;) {
              var l = i[a++];
              if (void 0 !== n[l]) for (var u = n[l].length, c = 0; c < u; c++) {
                var d = n[l][c];
                0 < r[d] ? o[d] !== l && o[l] !== d && Uv(e, l, d) : (r[d] = 1, o[i[s++] = d] = l);
              }
            }
          }
          var Vv = 4,
            Hv = function Hv(e) {
              this.structure = e, this.dict = {}, this.list = [];
            };
          Hv.prototype.add = function (e, t, n, r, i) {
            void 0 === r && (r = "");
            var o,
              a,
              s = (o = n, void 0 === (a = r) && (a = ""), (e = e.toUpperCase()) + "|" + t.join(",") + "|" + (o ? 1 : 0) + "|" + a),
              l = this.dict[s];
            if (void 0 === l) {
              var u = new Bv(this.structure, e, t, n, r, i);
              l = this.list.length, this.dict[s] = l, this.list.push(u);
            }
            return l;
          }, Hv.prototype.get = function (e) {
            return this.list[e];
          };
          var qv = function qv(e, t) {
              void 0 === t && (t = 0), this.structure = e, this.index = t, this.bondStore = e.bondStore, this._v12 = new ae(), this._v13 = new ae(), this._ap1 = this.structure.getAtomProxy(), this._ap2 = this.structure.getAtomProxy(), this._ap3 = this.structure.getAtomProxy();
            },
            Wv = {
              atom1: {
                configurable: !0
              },
              atom2: {
                configurable: !0
              },
              atomIndex1: {
                configurable: !0
              },
              atomIndex2: {
                configurable: !0
              },
              bondOrder: {
                configurable: !0
              }
            };
          Wv.atom1.get = function () {
            return this.structure.getAtomProxy(this.atomIndex1);
          }, Wv.atom2.get = function () {
            return this.structure.getAtomProxy(this.atomIndex2);
          }, Wv.atomIndex1.get = function () {
            return this.bondStore.atomIndex1[this.index];
          }, Wv.atomIndex1.set = function (e) {
            this.bondStore.atomIndex1[this.index] = e;
          }, Wv.atomIndex2.get = function () {
            return this.bondStore.atomIndex2[this.index];
          }, Wv.atomIndex2.set = function (e) {
            this.bondStore.atomIndex2[this.index] = e;
          }, Wv.bondOrder.get = function () {
            return this.bondStore.bondOrder[this.index];
          }, Wv.bondOrder.set = function (e) {
            this.bondStore.bondOrder[this.index] = e;
          }, qv.prototype.getOtherAtomIndex = function (e) {
            return e === this.atomIndex1 ? this.atomIndex2 : this.atomIndex1;
          }, qv.prototype.getOtherAtom = function (e) {
            return this.structure.getAtomProxy(this.getOtherAtomIndex(e.index));
          }, qv.prototype.getReferenceAtomIndex = function () {
            var e = this._ap1,
              t = this._ap2;
            if (e.index = this.atomIndex1, t.index = this.atomIndex2, e.residueIndex === t.residueIndex) {
              var n = e.index - e.residueAtomOffset,
                r = t.index - t.residueAtomOffset,
                i = e.residueType.getBondReferenceAtomIndex(n, r);
              if (void 0 !== i) return i + e.residueAtomOffset;
              console.warn("No reference atom found", e.index, t.index);
            }
          }, qv.prototype.calculateShiftDir = function (e) {
            void 0 === e && (e = new ae());
            var t = this._ap1,
              n = this._ap2,
              r = this._ap3,
              i = this._v12,
              o = this._v13;
            t.index = this.atomIndex1, n.index = this.atomIndex2;
            var a = this.getReferenceAtomIndex();
            i.subVectors(t, n).normalize(), void 0 !== a ? (r.index = a, o.subVectors(t, r)) : o.copy(t), o.normalize();
            var s = i.dot(o);
            return 1 - Math.abs(s) < 1e-5 && (o.set(1, 0, 0), s = i.dot(o), 1 - Math.abs(s) < 1e-5 && (o.set(0, 1, 0), s = i.dot(o))), e.copy(o.sub(i.multiplyScalar(s))).normalize();
          }, qv.prototype.qualifiedName = function () {
            return this.atomIndex1 + "=" + this.atomIndex2;
          }, qv.prototype.clone = function () {
            return new qv(this.structure, this.index);
          }, qv.prototype.toObject = function () {
            return {
              atomIndex1: this.atomIndex1,
              atomIndex2: this.atomIndex2,
              bondOrder: this.bondOrder
            };
          }, Object.defineProperties(qv.prototype, Wv);
          var $v = function $v(e, t) {
              void 0 === t && (t = 0), this.structure = e, this.index = t, this.chainStore = e.chainStore, this.residueStore = e.residueStore, this.atomStore = e.atomStore, this.residueMap = e.residueMap, this.atomMap = e.atomMap;
            },
            Xv = {
              entity: {
                configurable: !0
              },
              entityIndex: {
                configurable: !0
              },
              chain: {
                configurable: !0
              },
              chainIndex: {
                configurable: !0
              },
              atomOffset: {
                configurable: !0
              },
              atomCount: {
                configurable: !0
              },
              atomEnd: {
                configurable: !0
              },
              modelIndex: {
                configurable: !0
              },
              chainname: {
                configurable: !0
              },
              chainid: {
                configurable: !0
              },
              resno: {
                configurable: !0
              },
              sstruc: {
                configurable: !0
              },
              inscode: {
                configurable: !0
              },
              residueType: {
                configurable: !0
              },
              resname: {
                configurable: !0
              },
              hetero: {
                configurable: !0
              },
              moleculeType: {
                configurable: !0
              },
              backboneType: {
                configurable: !0
              },
              backboneStartType: {
                configurable: !0
              },
              backboneEndType: {
                configurable: !0
              },
              traceAtomIndex: {
                configurable: !0
              },
              direction1AtomIndex: {
                configurable: !0
              },
              direction2AtomIndex: {
                configurable: !0
              },
              backboneStartAtomIndex: {
                configurable: !0
              },
              backboneEndAtomIndex: {
                configurable: !0
              },
              rungEndAtomIndex: {
                configurable: !0
              },
              x: {
                configurable: !0
              },
              y: {
                configurable: !0
              },
              z: {
                configurable: !0
              }
            };
          Xv.entity.get = function () {
            return this.structure.entityList[this.entityIndex];
          }, Xv.entityIndex.get = function () {
            return this.chainStore.entityIndex[this.chainIndex];
          }, Xv.chain.get = function () {
            return this.structure.getChainProxy(this.chainIndex);
          }, Xv.chainIndex.get = function () {
            return this.residueStore.chainIndex[this.index];
          }, Xv.chainIndex.set = function (e) {
            this.residueStore.chainIndex[this.index] = e;
          }, Xv.atomOffset.get = function () {
            return this.residueStore.atomOffset[this.index];
          }, Xv.atomOffset.set = function (e) {
            this.residueStore.atomOffset[this.index] = e;
          }, Xv.atomCount.get = function () {
            return this.residueStore.atomCount[this.index];
          }, Xv.atomCount.set = function (e) {
            this.residueStore.atomCount[this.index] = e;
          }, Xv.atomEnd.get = function () {
            return this.atomOffset + this.atomCount - 1;
          }, Xv.modelIndex.get = function () {
            return this.chainStore.modelIndex[this.chainIndex];
          }, Xv.chainname.get = function () {
            return this.chainStore.getChainname(this.chainIndex);
          }, Xv.chainid.get = function () {
            return this.chainStore.getChainid(this.chainIndex);
          }, Xv.resno.get = function () {
            return this.residueStore.resno[this.index];
          }, Xv.resno.set = function (e) {
            this.residueStore.resno[this.index] = e;
          }, Xv.sstruc.get = function () {
            return this.residueStore.getSstruc(this.index);
          }, Xv.sstruc.set = function (e) {
            this.residueStore.setSstruc(this.index, e);
          }, Xv.inscode.get = function () {
            return this.residueStore.getInscode(this.index);
          }, Xv.inscode.set = function (e) {
            this.residueStore.setInscode(this.index, e);
          }, Xv.residueType.get = function () {
            return this.residueMap.get(this.residueStore.residueTypeId[this.index]);
          }, Xv.resname.get = function () {
            return this.residueType.resname;
          }, Xv.hetero.get = function () {
            return this.residueType.hetero;
          }, Xv.moleculeType.get = function () {
            return this.residueType.moleculeType;
          }, Xv.backboneType.get = function () {
            return this.residueType.backboneType;
          }, Xv.backboneStartType.get = function () {
            return this.residueType.backboneStartType;
          }, Xv.backboneEndType.get = function () {
            return this.residueType.backboneEndType;
          }, Xv.traceAtomIndex.get = function () {
            return this.residueType.traceAtomIndex + this.atomOffset;
          }, Xv.direction1AtomIndex.get = function () {
            return this.residueType.direction1AtomIndex + this.atomOffset;
          }, Xv.direction2AtomIndex.get = function () {
            return this.residueType.direction2AtomIndex + this.atomOffset;
          }, Xv.backboneStartAtomIndex.get = function () {
            return this.residueType.backboneStartAtomIndex + this.atomOffset;
          }, Xv.backboneEndAtomIndex.get = function () {
            return this.residueType.backboneEndAtomIndex + this.atomOffset;
          }, Xv.rungEndAtomIndex.get = function () {
            return this.residueType.rungEndAtomIndex + this.atomOffset;
          }, Xv.x.get = function () {
            for (var e = 0, t = this.atomOffset; t <= this.atomEnd; ++t) e += this.atomStore.x[t];
            return e / this.atomCount;
          }, Xv.y.get = function () {
            for (var e = 0, t = this.atomOffset; t <= this.atomEnd; ++t) e += this.atomStore.y[t];
            return e / this.atomCount;
          }, Xv.z.get = function () {
            for (var e = 0, t = this.atomOffset; t <= this.atomEnd; ++t) e += this.atomStore.z[t];
            return e / this.atomCount;
          }, $v.prototype.eachAtom = function (e, t) {
            var n = this.atomCount,
              r = this.atomOffset,
              i = this.structure._ap,
              o = r + n;
            if (t && t.atomOnlyTest) for (var a = t.atomOnlyTest, s = r; s < o; ++s) i.index = s, a(i) && e(i);else for (var l = r; l < o; ++l) i.index = l, e(i);
          }, $v.prototype.positionToArray = function (e, t) {
            return void 0 === e && (e = []), void 0 === t && (t = 0), e[t + 0] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
          }, $v.prototype.isProtein = function () {
            return 3 === this.residueType.moleculeType;
          }, $v.prototype.isNucleic = function () {
            var e = this.residueType.moleculeType;
            return 4 === e || 5 === e;
          }, $v.prototype.isRna = function () {
            return 4 === this.residueType.moleculeType;
          }, $v.prototype.isDna = function () {
            return 5 === this.residueType.moleculeType;
          }, $v.prototype.isCg = function () {
            var e = this.residueType.backboneType;
            return 4 === e || 5 === e || 6 === e;
          }, $v.prototype.isPolymer = function () {
            if (0 < this.structure.entityList.length) return this.entity.isPolymer();
            var e = this.residueType.moleculeType;
            return 3 === e || 4 === e || 5 === e;
          }, $v.prototype.isHetero = function () {
            return 1 === this.residueType.hetero;
          }, $v.prototype.isWater = function () {
            return 1 === this.residueType.moleculeType;
          }, $v.prototype.isIon = function () {
            return 2 === this.residueType.moleculeType;
          }, $v.prototype.isSaccharide = function () {
            return 6 === this.residueType.moleculeType;
          }, $v.prototype.isStandardAminoacid = function () {
            return this.residueType.isStandardAminoacid();
          }, $v.prototype.isStandardBase = function () {
            return this.residueType.isStandardBase();
          }, $v.prototype.isHelix = function () {
            return dp.includes(this.sstruc);
          }, $v.prototype.isSheet = function () {
            return hp.includes(this.sstruc);
          }, $v.prototype.isTurn = function () {
            return fp.includes(this.sstruc) && this.isProtein();
          }, $v.prototype.getAtomType = function (e) {
            return this.atomMap.get(this.atomStore.atomTypeId[e]);
          }, $v.prototype.getResname1 = function () {
            return xp[this.resname.toUpperCase()] || "X";
          }, $v.prototype.getBackboneType = function (e) {
            switch (e) {
              case -1:
                return this.residueType.backboneStartType;
              case 1:
                return this.residueType.backboneEndType;
              default:
                return this.residueType.backboneType;
            }
          }, $v.prototype.getAtomIndexByName = function (e) {
            var t = this.residueType.getAtomIndexByName(e);
            return void 0 !== t && (t += this.atomOffset), t;
          }, $v.prototype.hasAtomWithName = function (e) {
            return this.residueType.hasAtomWithName(e);
          }, $v.prototype.getAtomnameList = function () {
            console.warn("getAtomnameList - might be expensive");
            for (var e = this.atomCount, t = this.atomOffset, n = new Array(e), r = 0; r < e; ++r) n[r] = this.getAtomType(t + r).atomname;
            return n;
          }, $v.prototype.connectedTo = function (e) {
            var t = this.structure.getAtomProxy(this.backboneEndAtomIndex),
              n = this.structure.getAtomProxy(e.backboneStartAtomIndex);
            return !(!t || !n) && t.connectedTo(n);
          }, $v.prototype.getNextConnectedResidue = function () {
            var e = this.chainStore.residueOffset[this.chainIndex],
              t = this.chainStore.residueCount[this.chainIndex],
              n = this.index + 1;
            if (n < e + t) {
              var r = this.structure.getResidueProxy(n);
              if (this.connectedTo(r)) return r;
            } else if (n === e + t) {
              var i = this.structure.getResidueProxy(e);
              if (this.connectedTo(i)) return i;
            }
          }, $v.prototype.getPreviousConnectedResidue = function (e) {
            var t = this.chainStore.residueOffset[this.chainIndex],
              n = this.index - 1;
            if (t <= n) {
              var r = wu(e, this.structure.getResidueProxy());
              if (r.index = n, r.connectedTo(this)) return r;
            } else if (n === t - 1) {
              var i = this.chainStore.residueCount[this.chainIndex],
                o = wu(e, this.structure.getResidueProxy());
              if (o.index = t + i - 1, o.connectedTo(this)) return o;
            }
          }, $v.prototype.getBonds = function () {
            return this.residueType.getBonds(this);
          }, $v.prototype.getRings = function () {
            return this.residueType.getRings();
          }, $v.prototype.getAromaticRings = function () {
            return this.residueType.getAromaticRings(this);
          }, $v.prototype.qualifiedName = function (e) {
            void 0 === e && (e = !1);
            var t = "";
            return this.resname && !e && (t += "[" + this.resname + "]"), void 0 !== this.resno && (t += this.resno), this.inscode && (t += "^" + this.inscode), this.chain && (t += ":" + this.chainname), t + "/" + this.modelIndex;
          }, $v.prototype.clone = function () {
            return new $v(this.structure, this.index);
          }, $v.prototype.toObject = function () {
            return {
              index: this.index,
              chainIndex: this.chainIndex,
              atomOffset: this.atomOffset,
              atomCount: this.atomCount,
              resno: this.resno,
              resname: this.resname,
              sstruc: this.sstruc
            };
          }, Object.defineProperties($v.prototype, Xv);
          var Yv = function Yv(e, t, n) {
              this.structure = e, this.residueIndexStart = t, this.residueIndexEnd = n, this.chainStore = e.chainStore, this.residueStore = e.residueStore, this.atomStore = e.atomStore, this.residueCount = n - t + 1;
              var r = this.structure.getResidueProxy(this.residueIndexStart),
                i = this.structure.getResidueProxy(this.residueIndexEnd);
              this.isPrevConnected = void 0 !== r.getPreviousConnectedResidue();
              var o = i.getNextConnectedResidue();
              this.isNextConnected = void 0 !== o, this.isNextNextConnected = void 0 !== o && void 0 !== o.getNextConnectedResidue(), this.isCyclic = i.connectedTo(r), this.__residueProxy = this.structure.getResidueProxy();
            },
            Kv = {
              chainIndex: {
                configurable: !0
              },
              modelIndex: {
                configurable: !0
              },
              chainname: {
                configurable: !0
              }
            };
          Kv.chainIndex.get = function () {
            return this.residueStore.chainIndex[this.residueIndexStart];
          }, Kv.modelIndex.get = function () {
            return this.chainStore.modelIndex[this.chainIndex];
          }, Kv.chainname.get = function () {
            return this.chainStore.getChainname(this.chainIndex);
          }, Yv.prototype.isProtein = function () {
            return this.__residueProxy.index = this.residueIndexStart, this.__residueProxy.isProtein();
          }, Yv.prototype.isCg = function () {
            return this.__residueProxy.index = this.residueIndexStart, this.__residueProxy.isCg();
          }, Yv.prototype.isNucleic = function () {
            return this.__residueProxy.index = this.residueIndexStart, this.__residueProxy.isNucleic();
          }, Yv.prototype.getMoleculeType = function () {
            return this.__residueProxy.index = this.residueIndexStart, this.__residueProxy.moleculeType;
          }, Yv.prototype.getBackboneType = function (e) {
            return this.__residueProxy.index = this.residueIndexStart, this.__residueProxy.getBackboneType(e);
          }, Yv.prototype.getAtomIndexByType = function (e, t) {
            this.isCyclic ? -1 === e ? e = this.residueCount - 1 : e === this.residueCount && (e = 0) : (-1 !== e || this.isPrevConnected || (e += 1), e !== this.residueCount || this.isNextNextConnected || (e -= 1));
            var n,
              r = this.__residueProxy;
            switch (r.index = this.residueIndexStart + e, t) {
              case "trace":
                n = r.traceAtomIndex;
                break;
              case "direction1":
                n = r.direction1AtomIndex;
                break;
              case "direction2":
                n = r.direction2AtomIndex;
                break;
              default:
                n = r.getAtomIndexByName(t);
            }
            return n;
          }, Yv.prototype.eachAtom = function (e, t) {
            this.eachResidue(function (n) {
              n.eachAtom(e, t);
            });
          }, Yv.prototype.eachAtomN = function (e, t, n) {
            for (var r = this.residueCount, i = new Array(e), o = 0; o < e; ++o) i[o] = this.structure.getAtomProxy(this.getAtomIndexByType(o, n));
            t.apply(this, i);
            for (var a = e; a < r; ++a) {
              for (var s = 1; s < e; ++s) i[s - 1].index = i[s].index;
              i[e - 1].index = this.getAtomIndexByType(a, n), t.apply(this, i);
            }
          }, Yv.prototype.eachResidue = function (e) {
            for (var t = this.structure.getResidueProxy(), n = this.residueCount, r = this.residueIndexStart, i = 0; i < n; ++i) t.index = r + i, e(t);
          }, Yv.prototype.qualifiedName = function () {
            var e = this.structure.getResidueProxy(this.residueIndexStart),
              t = this.structure.getResidueProxy(this.residueIndexEnd);
            return e.qualifiedName() + " - " + t.qualifiedName();
          }, Object.defineProperties(Yv.prototype, Kv);
          var Zv = function Zv(e, t) {
              void 0 === t && (t = 0), this.structure = e, this.index = t, this.chainStore = e.chainStore, this.residueStore = e.residueStore;
            },
            Qv = {
              entity: {
                configurable: !0
              },
              model: {
                configurable: !0
              },
              entityIndex: {
                configurable: !0
              },
              modelIndex: {
                configurable: !0
              },
              residueOffset: {
                configurable: !0
              },
              residueCount: {
                configurable: !0
              },
              residueEnd: {
                configurable: !0
              },
              atomOffset: {
                configurable: !0
              },
              atomEnd: {
                configurable: !0
              },
              atomCount: {
                configurable: !0
              },
              chainname: {
                configurable: !0
              },
              chainid: {
                configurable: !0
              }
            };
          Qv.entity.get = function () {
            return this.structure.entityList[this.entityIndex];
          }, Qv.model.get = function () {
            return this.structure.getModelProxy(this.modelIndex);
          }, Qv.entityIndex.get = function () {
            return this.chainStore.entityIndex[this.index];
          }, Qv.entityIndex.set = function (e) {
            this.chainStore.entityIndex[this.index] = e;
          }, Qv.modelIndex.get = function () {
            return this.chainStore.modelIndex[this.index];
          }, Qv.modelIndex.set = function (e) {
            this.chainStore.modelIndex[this.index] = e;
          }, Qv.residueOffset.get = function () {
            return this.chainStore.residueOffset[this.index];
          }, Qv.residueOffset.set = function (e) {
            this.chainStore.residueOffset[this.index] = e;
          }, Qv.residueCount.get = function () {
            return this.chainStore.residueCount[this.index];
          }, Qv.residueCount.set = function (e) {
            this.chainStore.residueCount[this.index] = e;
          }, Qv.residueEnd.get = function () {
            return this.residueOffset + this.residueCount - 1;
          }, Qv.atomOffset.get = function () {
            return this.residueStore.atomOffset[this.residueOffset];
          }, Qv.atomEnd.get = function () {
            return this.residueStore.atomOffset[this.residueEnd] + this.residueStore.atomCount[this.residueEnd] - 1;
          }, Qv.atomCount.get = function () {
            return 0 === this.residueCount ? 0 : this.atomEnd - this.atomOffset + 1;
          }, Qv.chainname.get = function () {
            return this.chainStore.getChainname(this.index);
          }, Qv.chainname.set = function (e) {
            this.chainStore.setChainname(this.index, e);
          }, Qv.chainid.get = function () {
            return this.chainStore.getChainid(this.index);
          }, Qv.chainid.set = function (e) {
            this.chainStore.setChainid(this.index, e);
          }, Zv.prototype.eachAtom = function (e, t) {
            this.eachResidue(function (n) {
              n.eachAtom(e, t);
            }, t);
          }, Zv.prototype.eachResidue = function (e, t) {
            var n = this.residueCount,
              r = this.residueOffset,
              i = this.structure._rp,
              o = r + n;
            if (t && t.test) {
              var a = t.residueOnlyTest;
              if (a) for (var s = r; s < o; ++s) i.index = s, a(i) && e(i);else for (var l = r; l < o; ++l) i.index = l, e(i);
            } else for (var u = r; u < o; ++u) i.index = u, e(i);
          }, Zv.prototype.eachResidueN = function (e, t) {
            var n = this.residueCount,
              r = this.residueOffset,
              i = r + n;
            if (!(n < e)) {
              for (var o = new Array(e), a = 0; a < e; ++a) o[a] = this.structure.getResidueProxy(r + a);
              t.apply(this, o);
              for (var s = r + e; s < i; ++s) {
                for (var l = 0; l < e; ++l) o[l].index += 1;
                t.apply(this, o);
              }
            }
          }, Zv.prototype.eachPolymer = function (e, t) {
            for (var n = 0, r = 0, i = t ? t.residueOnlyTest : void 0, o = this.model.structure, a = this.residueCount, s = this.residueOffset, l = s + a, u = this.structure.getResidueProxy(), c = this.structure.getResidueProxy(s), d = this.structure.getAtomProxy(), h = this.structure.getAtomProxy(), f = !0, p = s + 1; p < l; ++p) {
              u.index = c.index, c.index = p;
              var m = f ? u.backboneEndType : u.backboneType,
                g = c.backboneType;
              f && (n = u.index, f = !1), r = c.index, 0 !== m && m === g ? (d.index = u.backboneEndAtomIndex, h.index = c.backboneStartAtomIndex, d && h && d.connectedTo(h) && (!i || i(u) && i(c)) || (1 < u.index - n && e(new Yv(o, n, u.index)), n = r)) : (0 !== m && 1 < u.index - n && e(new Yv(o, n, u.index)), n = r);
            }
            1 < r - n && this.structure.getResidueProxy(n).backboneEndType && e(new Yv(o, n, r));
          }, Zv.prototype.qualifiedName = function () {
            return ":" + this.chainname + "/" + this.modelIndex;
          }, Zv.prototype.clone = function () {
            return new Zv(this.structure, this.index);
          }, Zv.prototype.toObject = function () {
            return {
              index: this.index,
              residueOffset: this.residueOffset,
              residueCount: this.residueCount,
              chainname: this.chainname
            };
          }, Object.defineProperties(Zv.prototype, Qv);
          var Jv = function Jv(e, t) {
              void 0 === t && (t = 0), this.structure = e, this.index = t, this.modelStore = e.modelStore, this.chainStore = e.chainStore, this.residueStore = e.residueStore;
            },
            ey = {
              chainOffset: {
                configurable: !0
              },
              chainCount: {
                configurable: !0
              },
              residueOffset: {
                configurable: !0
              },
              atomOffset: {
                configurable: !0
              },
              chainEnd: {
                configurable: !0
              },
              residueEnd: {
                configurable: !0
              },
              atomEnd: {
                configurable: !0
              },
              residueCount: {
                configurable: !0
              },
              atomCount: {
                configurable: !0
              }
            };
          ey.chainOffset.get = function () {
            return this.modelStore.chainOffset[this.index];
          }, ey.chainOffset.set = function (e) {
            this.modelStore.chainOffset[this.index] = e;
          }, ey.chainCount.get = function () {
            return this.modelStore.chainCount[this.index];
          }, ey.chainCount.set = function (e) {
            this.modelStore.chainCount[this.index] = e;
          }, ey.residueOffset.get = function () {
            return this.chainStore.residueOffset[this.chainOffset];
          }, ey.atomOffset.get = function () {
            return this.residueStore.atomOffset[this.residueOffset];
          }, ey.chainEnd.get = function () {
            return this.chainOffset + this.chainCount - 1;
          }, ey.residueEnd.get = function () {
            return this.chainStore.residueOffset[this.chainEnd] + this.chainStore.residueCount[this.chainEnd] - 1;
          }, ey.atomEnd.get = function () {
            return this.residueStore.atomOffset[this.residueEnd] + this.residueStore.atomCount[this.residueEnd] - 1;
          }, ey.residueCount.get = function () {
            return 0 === this.chainCount ? 0 : this.residueEnd - this.residueOffset + 1;
          }, ey.atomCount.get = function () {
            return 0 === this.residueCount ? 0 : this.atomEnd - this.atomOffset + 1;
          }, Jv.prototype.eachAtom = function (e, t) {
            this.eachChain(function (n) {
              n.eachAtom(e, t);
            }, t);
          }, Jv.prototype.eachResidue = function (e, t) {
            this.eachChain(function (n) {
              n.eachResidue(e, t);
            }, t);
          }, Jv.prototype.eachPolymer = function (e, t) {
            if (t && t.chainOnlyTest) {
              var n = t.chainOnlyTest;
              this.eachChain(function (r) {
                n(r) && r.eachPolymer(e, t);
              });
            } else this.eachChain(function (n) {
              n.eachPolymer(e, t);
            });
          }, Jv.prototype.eachChain = function (e, t) {
            var n = this.chainCount,
              r = this.chainOffset,
              i = this.structure._cp,
              o = r + n;
            if (t && t.test) {
              var a = t.chainOnlyTest;
              if (a) for (var s = r; s < o; ++s) i.index = s, a(i) && e(i);else for (var l = r; l < o; ++l) i.index = l, e(i);
            } else for (var u = r; u < o; ++u) i.index = u, e(i);
          }, Jv.prototype.qualifiedName = function () {
            return "/" + this.index;
          }, Jv.prototype.clone = function () {
            return new Jv(this.structure, this.index);
          }, Jv.prototype.toObject = function () {
            return {
              index: this.index,
              chainOffset: this.chainOffset,
              chainCount: this.chainCount
            };
          }, Object.defineProperties(Jv.prototype, ey);
          var ty = function ty(e, t) {
              void 0 === e && (e = ""), void 0 === t && (t = ""), this.signals = {
                refreshed: new lc()
              }, this.init(e, t);
            },
            ny = {
              type: {
                configurable: !0
              }
            };
          ty.prototype.init = function (e, t) {
            this.name = e, this.path = t, this.title = "", this.id = "", this.data = {
              structure: this,
              "@spatialLookup": void 0,
              "@valenceModel": void 0
            }, this.header = {}, this.extraData = {}, this.atomSetCache = {}, this.atomSetDict = {}, this.biomolDict = {}, this.entityList = [], this.unitcell = void 0, this.frames = [], this.boxes = [], this.validation = void 0, this.bondStore = new Gg(0), this.backboneBondStore = new Gg(0), this.rungBondStore = new Gg(0), this.atomStore = new Vg(0), this.residueStore = new Hg(0), this.chainStore = new qg(0), this.modelStore = new Wg(0), this.atomMap = new Dv(this), this.residueMap = new Hv(this), this.bondHash = void 0, this.spatialHash = void 0, this.atomSet = void 0, this.bondSet = void 0, this.center = new ae(), this.boundingBox = new Oe(), this._bp = this.getBondProxy(), this._ap = this.getAtomProxy(), this._rp = this.getResidueProxy(), this._cp = this.getChainProxy();
          }, ny.type.get = function () {
            return "Structure";
          }, ty.prototype.finalizeAtoms = function () {
            this.atomSet = this.getAtomSet(), this.atomCount = this.atomStore.count, this.boundingBox = this.getBoundingBox(void 0, this.boundingBox), this.center = this.boundingBox.getCenter(new ae()), this.spatialHash = new Zf(this.atomStore, this.boundingBox);
          }, ty.prototype.finalizeBonds = function () {
            for (var e in this.bondSet = this.getBondSet(), this.bondCount = this.bondStore.count, this.bondHash = new Ug(this.bondStore, this.atomStore.count), this.atomSetCache = {}, this.atomSetDict.rung || (this.atomSetDict.rung = this.getAtomSet(!1)), this.atomSetDict) this.atomSetCache["__" + e] = this.atomSetDict[e].clone();
          }, ty.prototype.getBondProxy = function (e) {
            return new qv(this, e);
          }, ty.prototype.getAtomProxy = function (e) {
            return new Zg(this, e);
          }, ty.prototype.getResidueProxy = function (e) {
            return new $v(this, e);
          }, ty.prototype.getChainProxy = function (e) {
            return new Zv(this, e);
          }, ty.prototype.getModelProxy = function (e) {
            return new Jv(this, e);
          }, ty.prototype.getBondSet = function () {
            var e = this.bondStore.count,
              t = new tp(e),
              n = this.atomSet;
            if (n) {
              if (n.isAllSet()) t.setAll();else if (n.isAllClear()) t.clearAll();else for (var r = this.getBondProxy(), i = 0; i < e; ++i) r.index = i, n.isSet(r.atomIndex1, r.atomIndex2) && t.set(r.index);
            } else t.setAll();
            return t;
          }, ty.prototype.getBackboneBondSet = function () {
            var e = this.backboneBondStore.count,
              t = new tp(e),
              n = this.atomSetCache.__backbone;
            if (n) {
              var r = this.getBondProxy();
              r.bondStore = this.backboneBondStore;
              for (var i = 0; i < e; ++i) r.index = i, n.isSet(r.atomIndex1, r.atomIndex2) && t.set(r.index);
            } else t.setAll();
            return t;
          }, ty.prototype.getRungBondSet = function () {
            var e = this.rungBondStore.count,
              t = new tp(e),
              n = this.atomSetCache.__rung;
            if (n) {
              var r = this.getBondProxy();
              r.bondStore = this.rungBondStore;
              for (var i = 0; i < e; ++i) r.index = i, n.isSet(r.atomIndex1, r.atomIndex2) && t.set(r.index);
            } else t.setAll();
            return t;
          }, ty.prototype.getAtomSet = function (e) {
            var t = this.atomStore.count;
            if (void 0 === e) return new tp(t, !0);
            if (e instanceof tp) return e;
            if (!0 === e) return new tp(t, !0);
            if (e && e.test) {
              var n = e.string;
              if (n in this.atomSetCache) return this.atomSetCache[n];
              if ("" === n) return new tp(t, !0);
              var r = new tp(t);
              return this.eachAtom(function (e) {
                r.set(e.index);
              }, e), this.atomSetCache[n] = r;
            }
            return !1 === e ? new tp(t) : new tp(t, !0);
          }, ty.prototype.getAtomSetWithinSelection = function (e, t) {
            var n = this.spatialHash,
              r = this.getAtomSet(!1),
              i = this.getAtomProxy();
            return n && this.getAtomSet(e).forEach(function (e) {
              i.index = e, n.within(i.x, i.y, i.z, t).forEach(function (e) {
                r.set(e);
              });
            }), r;
          }, ty.prototype.getAtomSetWithinPoint = function (e, t) {
            var n = e,
              r = this.getAtomSet(!1);
            return this.spatialHash && this.spatialHash.within(n.x, n.y, n.z, t).forEach(function (e) {
              r.set(e);
            }), r;
          }, ty.prototype.getAtomSetWithinVolume = function (e, t, n, r, i) {
            var o = new Fg(e, n, r, i),
              a = o.getDataPosition(),
              s = a.length,
              l = o.matrix.getMaxScaleOnAxis(),
              u = this.getAtomSet(!1);
            if (!this.spatialHash) return u;
            for (var c = 0; c < s; c += 3) this.spatialHash.within(a[c], a[c + 1], a[c + 2], l).forEach(function (e) {
              u.set(e);
            });
            return u;
          }, ty.prototype.getAtomSetWithinGroup = function (e) {
            var t = this.atomStore.residueIndex,
              n = this.getAtomSet(!1),
              r = this.getResidueProxy();
            return this.getAtomSet(e).forEach(function (e) {
              r.index = t[e];
              for (var i = r.atomOffset; i <= r.atomEnd; ++i) n.set(i);
            }), n;
          }, ty.prototype.getSelection = function () {
            return !1;
          }, ty.prototype.getStructure = function () {
            return this;
          }, ty.prototype.eachEntity = function (e, t) {
            this.entityList.forEach(function (n) {
              void 0 !== t && n.getEntityType() !== t || e(n);
            });
          }, ty.prototype.eachBond = function (e, t) {
            var n,
              r = this.getBondProxy();
            if (t && t.test && (n = this.getBondSet(), this.bondSet && n.intersection(this.bondSet)), n) n.forEach(function (t) {
              r.index = t, e(r);
            });else for (var i = this.bondStore.count, o = 0; o < i; ++o) r.index = o, e(r);
          }, ty.prototype.eachAtom = function (e, t) {
            if (t && t.test) this.eachModel(function (n) {
              n.eachAtom(e, t);
            }, t);else for (var n = this.atomStore.count, r = this.getAtomProxy(), i = 0; i < n; ++i) r.index = i, e(r);
          }, ty.prototype.eachResidue = function (e, t) {
            if (t && t.test) {
              var n = this.modelStore.count,
                r = this.getModelProxy(),
                i = t.modelOnlyTest;
              if (i) for (var o = 0; o < n; ++o) r.index = o, i(r) && r.eachResidue(e, t);else for (var a = 0; a < n; ++a) r.index = a, r.eachResidue(e, t);
            } else for (var s = this.residueStore.count, l = this.getResidueProxy(), u = 0; u < s; ++u) l.index = u, e(l);
          }, ty.prototype.eachResidueN = function (e, t) {
            var n = this.residueStore.count;
            if (!(n < e)) {
              for (var r = new Array(e), i = 0; i < e; ++i) r[i] = this.getResidueProxy(i);
              t.apply(this, r);
              for (var o = e; o < n; ++o) {
                for (var a = 0; a < e; ++a) r[a].index += 1;
                t.apply(this, r);
              }
            }
          }, ty.prototype.eachPolymer = function (e, t) {
            if (t && t.modelOnlyTest) {
              var n = t.modelOnlyTest;
              this.eachModel(function (r) {
                n(r) && r.eachPolymer(e, t);
              });
            } else this.eachModel(function (n) {
              n.eachPolymer(e, t);
            });
          }, ty.prototype.eachChain = function (e, t) {
            if (t && t.test) this.eachModel(function (n) {
              n.eachChain(e, t);
            });else for (var n = this.chainStore.count, r = this.getChainProxy(), i = 0; i < n; ++i) r.index = i, e(r);
          }, ty.prototype.eachModel = function (e, t) {
            var n = this.modelStore.count,
              r = this.getModelProxy();
            if (t && t.test) {
              var i = t.modelOnlyTest;
              if (i) for (var o = 0; o < n; ++o) r.index = o, i(r) && e(r);else for (var a = 0; a < n; ++a) r.index = a, e(r);
            } else for (var s = 0; s < n; ++s) r.index = s, e(r);
          }, ty.prototype.getAtomData = function (e) {
            var t = Object.assign({}, e);
            t.colorParams && (t.colorParams.structure = this.getStructure());
            var n,
              r,
              i = t.what,
              o = wu(t.atomSet, this.atomSet),
              a = {},
              s = this.getAtomProxy(),
              l = o.getSize();
            i && !i.position || (a.position = new Float32Array(3 * l)), i && !i.color || !t.colorParams || (a.color = new Float32Array(3 * l), r = td.getScheme(t.colorParams)), i && !i.picking || (a.picking = new am(new Float32Array(l), this.getStructure())), i && !i.radius || (a.radius = new Float32Array(l), n = new Ng(t.radiusParams)), i && !i.index || (a.index = new Uint32Array(l));
            var u = a.position,
              c = a.color,
              d = a.picking,
              h = a.radius,
              f = a.index;
            return o.forEach(function (e, t) {
              var i = 3 * t;
              s.index = e, u && s.positionToArray(u, i), c && r.atomColorToArray(s, c, i), d && (d.array[t] = e), h && (h[t] = n.atomRadius(s)), f && (f[t] = e);
            }), a;
          }, ty.prototype.getBondData = function (e) {
            var t = Object.assign({}, e);
            t.colorParams && (t.colorParams.structure = this.getStructure());
            var n,
              r,
              i = t.what,
              o = wu(t.bondSet, this.bondSet),
              a = wu(t.multipleBond, "off"),
              s = "off" !== a,
              l = "offset" === a,
              u = wu(t.bondScale, .4),
              c = wu(t.bondSpacing, 1),
              d = {},
              h = this.getBondProxy();
            t.bondStore && (h.bondStore = t.bondStore);
            var f,
              p = this.getAtomProxy(),
              m = this.getAtomProxy();
            if (s) {
              var g = h.bondStore.bondOrder;
              f = 0, o.forEach(function (e) {
                f += g[e];
              });
            } else f = o.getSize();
            i && !i.position || (d.position1 = new Float32Array(3 * f), d.position2 = new Float32Array(3 * f)), i && !i.color || !t.colorParams || (d.color = new Float32Array(3 * f), d.color2 = new Float32Array(3 * f), r = td.getScheme(t.colorParams)), i && !i.picking || (d.picking = new lm(new Float32Array(f), this.getStructure(), t.bondStore)), (!i || i.radius || s && i.position) && (n = new Ng(t.radiusParams)), i && !i.radius || (d.radius = new Float32Array(f), t.radius2 && (d.radius2 = new Float32Array(f)));
            var v,
              y,
              b,
              _,
              x,
              w,
              S = d.position1,
              A = d.position2,
              E = d.color,
              T = d.color2,
              M = d.picking,
              C = d.radius,
              k = d.radius2,
              P = 0,
              O = new ae(),
              R = new ae(),
              I = new ae();
            return o.forEach(function (e) {
              if (y = 3 * P, h.index = e, p.index = h.atomIndex1, m.index = h.atomIndex2, _ = h.bondOrder, S) if (s && 1 < _) {
                var t = n.atomRadius(p);
                w = t * u / (.5 * _), h.calculateShiftDir(I), l ? (x = 2 * c * t, I.multiplyScalar(x), I.negate(), R.subVectors(m, p).multiplyScalar(Math.max(.1, x / 1.88)), p.positionToArray(S, y), m.positionToArray(A, y), 2 <= _ && (O.addVectors(p, I).add(R).toArray(S, y + 3), O.addVectors(m, I).sub(R).toArray(A, y + 3), 3 <= _ && (O.subVectors(p, I).add(R).toArray(S, y + 6), O.subVectors(m, I).sub(R).toArray(A, y + 6)))) : (x = (c - u) * t, I.multiplyScalar(x), 2 === _ ? (O.addVectors(p, I).toArray(S, y), O.subVectors(p, I).toArray(S, y + 3), O.addVectors(m, I).toArray(A, y), O.subVectors(m, I).toArray(A, y + 3)) : 3 === _ ? (p.positionToArray(S, y), O.addVectors(p, I).toArray(S, y + 3), O.subVectors(p, I).toArray(S, y + 6), m.positionToArray(A, y), O.addVectors(m, I).toArray(A, y + 3), O.subVectors(m, I).toArray(A, y + 6)) : (p.positionToArray(S, y), m.positionToArray(A, y)));
              } else p.positionToArray(S, y), m.positionToArray(A, y);
              if (E && T && (r.bondColorToArray(h, 1, E, y), r.bondColorToArray(h, 0, T, y), s && 1 < _)) for (v = 1; v < _; ++v) Kd(E, y, b = 3 * v + y, 3), Kd(T, y, b, 3);
              if (M && M.array && (M.array[P] = e, s && 1 < _)) for (v = 1; v < _; ++v) M.array[P + v] = e;
              if (C && (C[P] = n.atomRadius(p), s && 1 < _)) for (w = C[P] * u / (l ? 1 : .5 * _), v = l ? 1 : 0; v < _; ++v) C[P + v] = w;
              if (k && (k[P] = n.atomRadius(m), s && 1 < _)) for (w = k[P] * u / (l ? 1 : .5 * _), v = l ? 1 : 0; v < _; ++v) k[P + v] = w;
              P += s ? _ : 1;
            }), d;
          }, ty.prototype.getBackboneAtomData = function (e) {
            return e = Object.assign({
              atomSet: this.atomSetCache.__backbone
            }, e), this.getAtomData(e);
          }, ty.prototype.getBackboneBondData = function (e) {
            return e = Object.assign({
              bondSet: this.getBackboneBondSet(),
              bondStore: this.backboneBondStore
            }, e), this.getBondData(e);
          }, ty.prototype.getRungAtomData = function (e) {
            return e = Object.assign({
              atomSet: this.atomSetCache.__rung
            }, e), this.getAtomData(e);
          }, ty.prototype.getRungBondData = function (e) {
            return e = Object.assign({
              bondSet: this.getRungBondSet(),
              bondStore: this.rungBondStore
            }, e), this.getBondData(e);
          }, ty.prototype.getBoundingBox = function (e, n) {
            t.Debug && Zc.time("getBoundingBox"), n = n || new Oe();
            var r = 1 / 0,
              i = 1 / 0,
              o = 1 / 0,
              a = -1 / 0,
              s = -1 / 0,
              l = -1 / 0;
            return this.eachAtom(function (e) {
              var t = e.x,
                n = e.y,
                u = e.z;
              t < r && (r = t), n < i && (i = n), u < o && (o = u), a < t && (a = t), s < n && (s = n), l < u && (l = u);
            }, e), n.min.set(r, i, o), n.max.set(a, s, l), t.Debug && Zc.timeEnd("getBoundingBox"), n;
          }, ty.prototype.getPrincipalAxes = function (e) {
            t.Debug && Zc.time("getPrincipalAxes");
            var n = 0,
              r = new Pm(3, this.atomCount),
              i = r.data;
            return this.eachAtom(function (e) {
              i[n + 0] = e.x, i[n + 1] = e.y, i[n + 2] = e.z, n += 3;
            }, e), t.Debug && Zc.timeEnd("getPrincipalAxes"), new Bg(r);
          }, ty.prototype.atomCenter = function (e) {
            return e ? this.getBoundingBox(e).getCenter(new ae()) : this.center.clone();
          }, ty.prototype.hasCoords = function () {
            if (void 0 === this._hasCoords) {
              var e = this.atomStore;
              this._hasCoords = 0 !== Qd(e.x) || 0 !== Zd(e.x) || 0 !== Qd(e.y) || 0 !== Zd(e.y) || 0 !== Qd(e.z) || 0 !== Zd(e.z) || e.count / this.modelStore.count == 1;
            }
            return this._hasCoords;
          }, ty.prototype.getSequence = function (e) {
            var t = [],
              n = this.getResidueProxy();
            return this.eachAtom(function (e) {
              n.index = e.residueIndex, e.index === n.traceAtomIndex && t.push(n.getResname1());
            }, e), t;
          }, ty.prototype.getAtomIndices = function (e) {
            if (e && e.string) {
              var t = [];
              return this.eachAtom(function (e) {
                t.push(e.index);
              }, e), new Uint32Array(t);
            }
            return this.getAtomData({
              what: {
                index: !0
              }
            }).index;
          }, ty.prototype.getChainnameCount = function (e) {
            var t = new Set();
            return this.eachChain(function (e) {
              e.residueCount && t.add(e.chainname);
            }, e), t.size;
          }, ty.prototype.updatePosition = function (e) {
            var t = 0;
            this.eachAtom(function (n) {
              n.positionFromArray(e, t), t += 3;
            }, void 0), this._hasCoords = void 0;
          }, ty.prototype.refreshPosition = function () {
            this.getBoundingBox(void 0, this.boundingBox), this.boundingBox.getCenter(this.center), this.spatialHash = new Zf(this.atomStore, this.boundingBox);
          }, ty.prototype.dispose = function () {
            this.frames && (this.frames.length = 0), this.boxes && (this.boxes.length = 0), this.bondStore.dispose(), this.backboneBondStore.dispose(), this.rungBondStore.dispose(), this.atomStore.dispose(), this.residueStore.dispose(), this.chainStore.dispose(), this.modelStore.dispose(), delete this.bondStore, delete this.atomStore, delete this.residueStore, delete this.chainStore, delete this.modelStore, delete this.frames, delete this.boxes, delete this.bondSet, delete this.atomSet;
          }, Object.defineProperties(ty.prototype, ny);
          var ry = new Oe(),
            iy = [Hf, zf, qf, Vf, Wf, Uf, Ff, Gf, Xf, $f, Yf, Kf],
            oy = {
              aspectRatio: 1.5,
              sphereDetail: 2,
              radialSegments: 50,
              disableImpostor: !1,
              openEnded: !1,
              dashedCylinder: !1,
              labelParams: {},
              pointSize: 2,
              sizeAttenuation: !1,
              useTexture: !0,
              lineWidth: 2
            },
            ay = function ay(e, t) {
              var n = this;
              void 0 === e && (e = "shape"), void 0 === t && (t = {}), this.boundingBox = new Oe(), this.bufferList = [], this.meshCount = 0, this._primitiveData = {}, this.name = e, this.parameters = Su(t, oy), iy.forEach(function (e) {
                Object.keys(e.fields).forEach(function (t) {
                  n._primitiveData[e.getShapeKey(t)] = [];
                }), n._primitiveData[e.getShapeKey("name")] = [];
              });
            },
            sy = {
              center: {
                configurable: !0
              },
              type: {
                configurable: !0
              }
            };
          ay.prototype.addBuffer = function (e) {
            this.bufferList.push(e);
            var t = e.geometry;
            return t.boundingBox || t.computeBoundingBox(), this.boundingBox.union(t.boundingBox), this;
          }, ay.prototype.addMesh = function (e, t, n, r, i) {
            e = Uu(e), t = Uu(t), Array.isArray(n) && (n = Nu(n, e.length)), r && (r = Uu(r));
            var o = {
                position: e,
                color: t,
                index: n,
                normal: r
              },
              a = new vm(this, Object.assign({
                serial: this.meshCount,
                name: i
              }, o)),
              s = new lg(Object.assign({
                picking: a
              }, o));
            return this.bufferList.push(s), ry.setFromArray(e), this.boundingBox.union(ry), this.meshCount += 1, this;
          }, ay.prototype.addSphere = function (e, t, n, r) {
            return Ff.objectToShape(this, {
              position: e,
              color: t,
              radius: n,
              name: r
            }), this;
          }, ay.prototype.addEllipsoid = function (e, t, n, r, i, o) {
            return Wf.objectToShape(this, {
              position: e,
              color: t,
              radius: n,
              majorAxis: r,
              minorAxis: i,
              name: o
            }), this;
          }, ay.prototype.addTorus = function (e, t, n, r, i, o) {
            return $f.objectToShape(this, {
              position: e,
              color: t,
              radius: n,
              majorAxis: r,
              minorAxis: i,
              name: o
            }), this;
          }, ay.prototype.addCylinder = function (e, t, n, r, i) {
            return Vf.objectToShape(this, {
              position1: e,
              position2: t,
              color: n,
              radius: r,
              name: i
            }), this;
          }, ay.prototype.addCone = function (e, t, n, r, i) {
            return qf.objectToShape(this, {
              position1: e,
              position2: t,
              color: n,
              radius: r,
              name: i
            }), this;
          }, ay.prototype.addArrow = function (e, t, n, r, i) {
            return Hf.objectToShape(this, {
              position1: e,
              position2: t,
              color: n,
              radius: r,
              name: i
            }), this;
          }, ay.prototype.addBox = function (e, t, n, r, i, o) {
            return zf.objectToShape(this, {
              position: e,
              color: t,
              size: n,
              heightAxis: r,
              depthAxis: i,
              name: o
            }), this;
          }, ay.prototype.addOctahedron = function (e, t, n, r, i, o) {
            return Uf.objectToShape(this, {
              position: e,
              color: t,
              size: n,
              heightAxis: r,
              depthAxis: i,
              name: o
            }), this;
          }, ay.prototype.addTetrahedron = function (e, t, n, r, i, o) {
            return Gf.objectToShape(this, {
              position: e,
              color: t,
              size: n,
              heightAxis: r,
              depthAxis: i,
              name: o
            }), this;
          }, ay.prototype.addText = function (e, t, n, r) {
            return Xf.objectToShape(this, {
              position: e,
              color: t,
              size: n,
              text: r
            }), this;
          }, ay.prototype.addPoint = function (e, t, n) {
            return Yf.objectToShape(this, {
              position: e,
              color: t,
              name: n
            }), this;
          }, ay.prototype.addWideline = function (e, t, n, r) {
            return Kf.objectToShape(this, {
              position1: e,
              position2: t,
              color: n,
              name: r
            }), this;
          }, ay.prototype.addLabel = function (e, t, n, r) {
            return console.warn("Shape.addLabel is deprecated, use .addText instead"), this.addText(e, t, n, r);
          }, ay.prototype.getBufferList = function () {
            var e = this,
              t = [];
            return iy.forEach(function (n) {
              e._primitiveData[n.getShapeKey("color")].length && t.push(n.bufferFromShape(e, e.parameters));
            }), this.bufferList.concat(t);
          }, ay.prototype.dispose = function () {
            var e = this;
            this.bufferList.forEach(function (e) {
              e.dispose();
            }), this.bufferList.length = 0, iy.forEach(function (t) {
              Object.keys(t.fields).forEach(function (n) {
                e._primitiveData[t.getShapeKey(n)].length = 0;
              }), e._primitiveData[t.getShapeKey("name")].length = 0;
            });
          }, sy.center.get = function () {
            return this._center || (this._center = this.boundingBox.getCenter(new ae())), this._center;
          }, sy.type.get = function () {
            return "Shape";
          }, Object.defineProperties(ay.prototype, sy);
          var ly = function (e) {
              function t(t, n, r) {
                Array.isArray(t) || (t = [t]), e.call(this, t, n, r), this.type = "buffer", this.parameters = Object.assign({}, this.parameters, {
                  colorScheme: null,
                  colorScale: null,
                  colorValue: null,
                  colorDomain: null,
                  colorMode: null
                }), this.buffer = t, this.init(r);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
                e.prototype.init.call(this, t), this.build();
              }, t.prototype.create = function () {
                this.bufferList.push.apply(this.bufferList, this.buffer);
              }, t.prototype.attach = function (e) {
                var t = this;
                this.bufferList.forEach(function (e) {
                  t.viewer.add(e), e.setParameters(t.getBufferParams());
                }), this.setVisibility(this.visible), e();
              }, t;
            }(lf),
            uy = new ie(),
            cy = new se(),
            dy = function (e) {
              function t(t, n, r) {
                var i, o, a, s, l, u, c, d, h, f, p;
                void 0 === n && (n = {}), e.call(this, (i = t, s = (o = r).attributes.position.array, l = o.index ? o.index.array : void 0, d = (u = i.position.length / 3) * (c = s.length / 3), h = new Float32Array(3 * d), f = new Float32Array(3 * d), p = new Float32Array(3 * d), l && (a = Nu(u * l.length, d)), {
                  position: h,
                  color: p,
                  index: a,
                  normal: f,
                  primitiveId: i.primitiveId || $d(u, c),
                  picking: i.picking
                }), n), this.updateNormals = !1;
                var m = r.attributes.position.array,
                  g = r.attributes.normal.array,
                  v = r.index ? r.index.array : void 0;
                this.geoPosition = m, this.geoNormal = g, this.geoIndex = v, this.positionCount = t.position.length / 3, this.geoPositionCount = m.length / 3, this.transformedGeoPosition = new Float32Array(3 * this.geoPositionCount), this.transformedGeoNormal = new Float32Array(3 * this.geoPositionCount);
                var y = this.geometry.attributes;
                this.meshPosition = y.position.array, this.meshColor = y.color.array, this.meshNormal = y.normal.array, this.setAttributes(t), v && (this.meshIndex = this.geometry.getIndex().array, this.makeIndex());
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.setAttributes = function (e, t) {
                void 0 === e && (e = {}), void 0 === t && (t = !1);
                var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d = this.geometry.attributes,
                  h = this.updateNormals;
                e.position && (n = e.position, i = this.geoPosition, l = this.meshPosition, a = this.transformedGeoPosition, d.position.needsUpdate = !0, (h || t) && (o = this.geoNormal, c = this.meshNormal, s = this.transformedGeoNormal, d.normal.needsUpdate = !0)), e.color && (r = e.color, u = this.meshColor, d.color.needsUpdate = !0);
                for (var f = this.positionCount, p = this.geoPositionCount, m = 0; m < f; ++m) {
                  var g = void 0,
                    v = void 0,
                    y = m * p * 3,
                    b = 3 * m;
                  if (n && a && l && c && i && o && (a.set(i), uy.makeTranslation(n[b], n[b + 1], n[b + 2]), this.applyPositionTransform(uy, m, b), pf(uy.elements, a), l.set(a, y), h && s ? (s.set(o), cy.getNormalMatrix(uy), mf(cy.elements, s), c.set(s, y)) : t && c.set(o, y)), r && u) for (g = 0; g < p; ++g) u[v = y + 3 * g] = r[b], u[v + 1] = r[b + 1], u[v + 2] = r[b + 2];
                }
              }, t.prototype.makeIndex = function () {
                var e = this.geoIndex,
                  t = this.meshIndex;
                if (e) for (var n = this.positionCount, r = this.geoPositionCount, i = e.length / 3 * 3, o = 0; o < n; ++o) {
                  var a = o * i,
                    s = a + i;
                  t.set(e, a);
                  for (var l = a; l < s; ++l) t[l] += o * r;
                }
              }, t;
            }(lg),
            hy = new ae(),
            fy = Object.assign({
              sphereDetail: 1
            }, ig),
            py = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n, new io(1, wu(n.sphereDetail, 1))), this.setAttributes(t, !0);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return fy;
              }, t.prototype.applyPositionTransform = function (e, t) {
                var n = this._radius[t];
                hy.set(n, n, n), e.scale(hy);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.radius && (this._radius = t.radius), e.prototype.setAttributes.call(this, t, n);
              }, Object.defineProperties(t.prototype, n), t;
            }(dy);
          od.add("shader/SphereImpostor.vert", "uniform mat4 projectionMatrixInverse;\nuniform float clipNear;\nvarying float vRadius;\nvarying float vRadiusSq;\nvarying vec3 vPoint;\nvarying vec3 vPointViewPosition;\nattribute vec2 mapping;\nattribute float radius;\n#ifdef PICKING\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\n#include color_pars_vertex\n#endif\n#include matrix_scale\nconst mat4 D = mat4(\n1.0, 0.0, 0.0, 0.0,\n0.0, 1.0, 0.0, 0.0,\n0.0, 0.0, 1.0, 0.0,\n0.0, 0.0, 0.0, -1.0\n);\nmat4 transpose( in mat4 inMatrix ) {\nvec4 i0 = inMatrix[0];\nvec4 i1 = inMatrix[1];\nvec4 i2 = inMatrix[2];\nvec4 i3 = inMatrix[3];\nmat4 outMatrix = mat4(\nvec4(i0.x, i1.x, i2.x, i3.x),\nvec4(i0.y, i1.y, i2.y, i3.y),\nvec4(i0.z, i1.z, i2.z, i3.z),\nvec4(i0.w, i1.w, i2.w, i3.w)\n);\nreturn outMatrix;\n}\nvoid ComputePointSizeAndPositionInClipCoordSphere(){\nvec2 xbc;\nvec2 ybc;\nmat4 T = mat4(\nradius, 0.0, 0.0, 0.0,\n0.0, radius, 0.0, 0.0,\n0.0, 0.0, radius, 0.0,\nposition.x, position.y, position.z, 1.0\n);\nmat4 R = transpose( projectionMatrix * modelViewMatrix * T );\nfloat A = dot( R[ 3 ], D * R[ 3 ] );\nfloat B = -2.0 * dot( R[ 0 ], D * R[ 3 ] );\nfloat C = dot( R[ 0 ], D * R[ 0 ] );\nxbc[ 0 ] = ( -B - sqrt( B * B - 4.0 * A * C ) ) / ( 2.0 * A );\nxbc[ 1 ] = ( -B + sqrt( B * B - 4.0 * A * C ) ) / ( 2.0 * A );\nfloat sx = abs( xbc[ 0 ] - xbc[ 1 ] ) * 0.5;\nA = dot( R[ 3 ], D * R[ 3 ] );\nB = -2.0 * dot( R[ 1 ], D * R[ 3 ] );\nC = dot( R[ 1 ], D * R[ 1 ] );\nybc[ 0 ] = ( -B - sqrt( B * B - 4.0 * A * C ) ) / ( 2.0 * A );\nybc[ 1 ] = ( -B + sqrt( B * B - 4.0 * A * C ) ) / ( 2.0 * A );\nfloat sy = abs( ybc[ 0 ] - ybc[ 1 ] ) * 0.5;\ngl_Position.xy = vec2( 0.5 * ( xbc.x + xbc.y ), 0.5 * ( ybc.x + ybc.y ) );\ngl_Position.xy -= mapping * vec2( sx, sy );\ngl_Position.xy *= gl_Position.w;\n}\nvoid main(void){\n#ifdef PICKING\nvPickingColor = unpackColor( primitiveId );\n#else\n#include color_vertex\n#endif\nvRadius = radius * matrixScale( modelViewMatrix );\nvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\nmvPosition.z -= vRadius;\ngl_Position = projectionMatrix * vec4( mvPosition.xyz, 1.0 );\nComputePointSizeAndPositionInClipCoordSphere();\nvRadiusSq = vRadius * vRadius;\nvec4 vPoint4 = projectionMatrixInverse * gl_Position;\nvPoint = vPoint4.xyz / vPoint4.w;\nvPointViewPosition = -mvPosition.xyz / mvPosition.w;\n}"), od.add("shader/SphereImpostor.frag", "#define STANDARD\n#define IMPOSTOR\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 interiorColor;\nuniform float interiorDarkening;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\nuniform float clipNear;\nuniform mat4 projectionMatrix;\nuniform float ortho;\nvarying float vRadius;\nvarying float vRadiusSq;\nvarying vec3 vPoint;\nvarying vec3 vPointViewPosition;\n#ifdef PICKING\nuniform float objectId;\nvarying vec3 vPickingColor;\n#else\n#include common\n#include color_pars_fragment\n#include fog_pars_fragment\n#include bsdfs\n#include lights_pars_begin\n#include lights_physical_pars_fragment\n#endif\nbool flag2 = false;\nbool interior = false;\nvec3 cameraPos;\nvec3 cameraNormal;\nfloat calcDepth( in vec3 cameraPos ){\nvec2 clipZW = cameraPos.z * projectionMatrix[2].zw + projectionMatrix[3].zw;\nreturn 0.5 + 0.5 * clipZW.x / clipZW.y;\n}\nfloat calcClip( vec3 cameraPos ){\nreturn dot( vec4( cameraPos, 1.0 ), vec4( 0.0, 0.0, 1.0, clipNear - 0.5 ) );\n}\nbool Impostor( out vec3 cameraPos, out vec3 cameraNormal ){\nvec3 cameraSpherePos = -vPointViewPosition;\ncameraSpherePos.z += vRadius;\nvec3 rayOrigin = mix( vec3( 0.0, 0.0, 0.0 ), vPoint, ortho );\nvec3 rayDirection = mix( normalize( vPoint ), vec3( 0.0, 0.0, 1.0 ), ortho );\nvec3 cameraSphereDir = mix( cameraSpherePos, rayOrigin - cameraSpherePos, ortho );\nfloat B = dot( rayDirection, cameraSphereDir );\nfloat det = B * B + vRadiusSq - dot( cameraSphereDir, cameraSphereDir );\nif( det < 0.0 ){\ndiscard;\nreturn false;\n}\nfloat sqrtDet = sqrt( det );\nfloat posT = mix( B + sqrtDet, B + sqrtDet, ortho );\nfloat negT = mix( B - sqrtDet, sqrtDet - B, ortho );\ncameraPos = rayDirection * negT + rayOrigin;\n#ifdef NEAR_CLIP\nif( calcDepth( cameraPos ) <= 0.0 ){\ncameraPos = rayDirection * posT + rayOrigin;\ninterior = true;\n}else if( calcClip( cameraPos ) > 0.0 ){\ncameraPos = rayDirection * posT + rayOrigin;\ninterior = true;\nflag2 = true;\n}\n#else\nif( calcDepth( cameraPos ) <= 0.0 ){\ncameraPos = rayDirection * posT + rayOrigin;\ninterior = true;\n}\n#endif\ncameraNormal = normalize( cameraPos - cameraSpherePos );\ncameraNormal *= float(!interior) * 2.0 - 1.0;\nreturn !interior;\n}\nvoid main(void){\nbool flag = Impostor( cameraPos, cameraNormal );\n#ifdef NEAR_CLIP\nif( calcClip( cameraPos ) > 0.0 )\ndiscard;\n#endif\ngl_FragDepthEXT = calcDepth( cameraPos );\nif( !flag ){\n#ifdef NEAR_CLIP\nif( flag2 ){\ngl_FragDepthEXT = max( 0.0, calcDepth( vec3( - ( clipNear - 0.5 ) ) ) + ( 0.0000001 / vRadius ) );\n}else if( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = 0.0 + ( 0.0000001 / vRadius );\n}\n#else\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = 0.0 + ( 0.0000001 / vRadius );\n}\n#endif\n}\nif (gl_FragDepthEXT < 0.0)\ndiscard;\nif (gl_FragDepthEXT > 1.0)\ndiscard;\n#ifdef PICKING\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#else\nvec3 vNormal = cameraNormal;\nvec3 vViewPosition = -cameraPos;\nvec4 diffuseColor = vec4( diffuse, opacity );\nReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\nvec3 totalEmissiveLight = emissive;\n#include color_fragment\n#include roughnessmap_fragment\n#include metalnessmap_fragment\n#include normal_fragment_begin\n#include lights_physical_fragment\n#include lights_fragment_begin\n#include lights_fragment_end\nvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveLight;\nif( interior ){\n#ifdef USE_INTERIOR_COLOR\noutgoingLight.xyz = interiorColor;\n#else\n#ifdef DIFFUSE_INTERIOR\noutgoingLight.xyz = vColor;\n#endif\n#endif\noutgoingLight.xyz *= 1.0 - interiorDarkening;\n}\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#endif\n}");
          var my = function (e) {
              function t(t, n, r) {
                void 0 === r && (r = {}), e.call(this, n, r), this.index = Nu(this.indexSize, this.attributeSize), this.makeIndex(), this.initIndex(this.index), this.addAttributes({
                  mapping: {
                    type: t,
                    value: null
                  }
                }), this.setAttributes({
                  primitiveId: Wd(this.size)
                });
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                attributeSize: {
                  configurable: !0
                },
                indexSize: {
                  configurable: !0
                }
              };
              return n.attributeSize.get = function () {
                return this.size * this.mappingSize;
              }, n.indexSize.get = function () {
                return this.size * this.mappingIndicesSize;
              }, t.prototype.addAttributes = function (t) {
                var n = {};
                for (var r in t) {
                  var i = t[r];
                  n[r] = {
                    type: i.type,
                    value: null
                  };
                }
                e.prototype.addAttributes.call(this, n);
              }, t.prototype.getAttributeIndex = function (e) {
                return 3 * e * this.mappingSize;
              }, t.prototype.setAttributes = function (e) {
                e && !e.position && e.position1 && e.position2 && (e.position = Gd(e.position1, e.position2));
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l = this.size,
                  u = this.mappingSize,
                  c = this.geometry.attributes;
                for (var d in e) if ("index" !== d && "picking" !== d) {
                  n = e[d], r = (t = c[d]).itemSize, i = t.array;
                  for (var h = 0; h < l; ++h) {
                    a = (o = h * r) * u;
                    for (var f = 0; f < u; ++f) {
                      s = a + r * f;
                      for (var p = 0; p < r; ++p) i[s + p] = n[o + p];
                    }
                  }
                  t.needsUpdate = !0;
                }
              }, t.prototype.makeMapping = function () {
                for (var e = this.size, t = this.mapping, n = this.mappingSize, r = this.mappingItemSize, i = this.geometry.attributes.mapping.array, o = 0; o < e; o++) i.set(t, o * r * n);
              }, t.prototype.makeIndex = function () {
                for (var e = this.size, t = this.mappingSize, n = this.mappingIndices, r = this.mappingIndicesSize, i = this.index, o = 0; o < e; o++) {
                  var a = o * r,
                    s = o * t;
                  i.set(n, a);
                  for (var l = 0; l < r; ++l) i[a + l] += s;
                }
              }, Object.defineProperties(t.prototype, n), t;
            }(ag),
            gy = new Float32Array([-1, 1, -1, -1, 1, 1, 1, -1]),
            vy = new Uint16Array([0, 1, 2, 1, 3, 2]),
            yy = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, "v2", t, n);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                mapping: {
                  configurable: !0
                },
                mappingIndices: {
                  configurable: !0
                },
                mappingIndicesSize: {
                  configurable: !0
                },
                mappingSize: {
                  configurable: !0
                },
                mappingItemSize: {
                  configurable: !0
                }
              };
              return n.mapping.get = function () {
                return gy;
              }, n.mappingIndices.get = function () {
                return vy;
              }, n.mappingIndicesSize.get = function () {
                return 6;
              }, n.mappingSize.get = function () {
                return 4;
              }, n.mappingItemSize.get = function () {
                return 2;
              }, Object.defineProperties(t.prototype, n), t;
            }(my),
            by = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.isImpostor = !0, this.vertexShader = "SphereImpostor.vert", this.fragmentShader = "SphereImpostor.frag", this.addUniforms({
                  projectionMatrixInverse: {
                    value: new ie()
                  },
                  ortho: {
                    value: 0
                  }
                }), this.addAttributes({
                  radius: {
                    type: "f",
                    value: null
                  }
                }), this.setAttributes(t), this.makeMapping();
              }
              return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            }(yy),
            _y = (Object.assign({
              disableImpostor: !1
            }, fy), function (e, t) {
              return !Kc || t && t.disableImpostor ? new py(e, t) : new by(e, t);
            });
          ld.add("sphere", _y), od.add("shader/Point.vert", "uniform float clipNear;\nuniform float clipRadius;\nuniform vec3 clipCenter;\nuniform float size;\nuniform float canvasHeight;\nuniform float pixelRatio;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#if defined( PICKING )\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\n#include color_pars_vertex\nvarying vec3 vViewPosition;\n#endif\n#include common\nvoid main(){\n#if defined( PICKING )\nvPickingColor = unpackColor( primitiveId );\n#else\n#include color_vertex\n#endif\n#include begin_vertex\n#include project_vertex\n#ifdef USE_SIZEATTENUATION\ngl_PointSize = size * pixelRatio * ( ( canvasHeight / 2.0 ) / -mvPosition.z );\n#else\ngl_PointSize = size * pixelRatio;\n#endif\n#ifndef PICKING\nvViewPosition = -mvPosition.xyz;\n#endif\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n#include nearclip_vertex\n#include radiusclip_vertex\n}"), od.add("shader/Point.frag", "uniform vec3 diffuse;\nuniform float opacity;\nuniform float clipNear;\nuniform float clipRadius;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#ifdef USE_MAP\nuniform sampler2D map;\n#endif\n#if defined( PICKING )\nuniform float objectId;\nvarying vec3 vPickingColor;\n#else\n#include common\n#include color_pars_fragment\n#include fog_pars_fragment\nvarying vec3 vViewPosition;\n#endif\nvoid main(){\n#include nearclip_fragment\n#include radiusclip_fragment\n#if defined( PICKING )\n#ifdef USE_MAP\nif( texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) ).a < 0.5 )\ndiscard;\n#endif\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#else\nvec3 outgoingLight = vec3( 0.0 );\nvec4 diffuseColor = vec4( diffuse, 1.0 );\n#ifdef USE_MAP\ndiffuseColor *= texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) );\n#endif\n#include color_fragment\n#include alphatest_fragment\noutgoingLight = diffuseColor.rgb;\ngl_FragColor = vec4( outgoingLight, diffuseColor.a * opacity );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#endif\n}");
          var xy = Object.assign({
              pointSize: 1,
              sizeAttenuation: !0,
              sortParticles: !1,
              alphaTest: .5,
              useTexture: !1,
              forceTransparent: !1,
              edgeBleach: 0
            }, ig),
            wy = Object.assign({
              pointSize: {
                uniform: "size"
              },
              sizeAttenuation: {
                updateShader: !0
              },
              sortParticles: {},
              alphaTest: {
                updateShader: !0
              },
              useTexture: {
                updateShader: !0
              },
              forceTransparent: {},
              edgeBleach: {
                uniform: !0
              }
            }, og),
            Sy = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.parameterTypes = wy, this.vertexShader = "Point.vert", this.fragmentShader = "Point.frag", this.isPoint = !0, this.addUniforms({
                  size: {
                    value: this.parameters.pointSize
                  },
                  canvasHeight: {
                    value: 1
                  },
                  pixelRatio: {
                    value: 1
                  },
                  map: {
                    value: null
                  }
                });
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return xy;
              }, t.prototype.makeMaterial = function () {
                e.prototype.makeMaterial.call(this), this.makeTexture();
                var t = this.material,
                  n = this.wireframeMaterial,
                  r = this.pickingMaterial;
                t.uniforms.map.value = this.tex, t.needsUpdate = !0, n.uniforms.map.value = this.tex, n.needsUpdate = !0, r.uniforms.map.value = this.tex, r.needsUpdate = !0;
              }, t.prototype.makeTexture = function () {
                this.tex && this.tex.dispose(), this.tex = function (e) {
                  for (var t, n, r = e || {}, i = wu(r.width, 256), o = wu(r.height, 256), a = [i / 2, o / 2], s = Math.min(i / 2, o / 2), l = wu(r.delta, 1 / (s + 1)) * s, u = 0, c = 0, d = new Uint8Array(i * o * 4), h = 0, f = d.length; h < f; h += 4) {
                    var p = 1 - Ju(s - l, s, (t = a[0] - u, n = a[1] - c, Math.sqrt(t * t + n * n)));
                    d[h] = 255 * p, d[h + 1] = 255 * p, d[h + 2] = 255 * p, d[h + 3] = 255 * p, ++u === i && (u = 0, c++);
                  }
                  var m = new Pe(d, i, o);
                  return m.needsUpdate = !0, m;
                }({
                  delta: this.parameters.edgeBleach
                });
              }, t.prototype.getDefines = function (t) {
                var n = e.prototype.getDefines.call(this, t);
                return this.parameters.sizeAttenuation && (n.USE_SIZEATTENUATION = 1), this.parameters.useTexture && (n.USE_MAP = 1), 0 < this.parameters.alphaTest && this.parameters.alphaTest <= 1 && (n.ALPHATEST = this.parameters.alphaTest.toPrecision(2)), n;
              }, t.prototype.setUniforms = function (t) {
                t && void 0 !== t.edgeBleach && (this.makeTexture(), t.map = this.tex), e.prototype.setUniforms.call(this, t);
              }, t.prototype.dispose = function () {
                e.prototype.dispose.call(this), this.tex && this.tex.dispose();
              }, Object.defineProperties(t.prototype, n), t;
            }(ag);
          ld.add("point", Sy);
          var Ay = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "dot", this.parameters = Object.assign({
                thresholdType: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    value: "value",
                    sigma: "sigma"
                  }
                },
                thresholdMin: {
                  type: "number",
                  precision: 3,
                  max: 1 / 0,
                  min: -1 / 0,
                  rebuild: !0
                },
                thresholdMax: {
                  type: "number",
                  precision: 3,
                  max: 1 / 0,
                  min: -1 / 0,
                  rebuild: !0
                },
                thresholdOut: {
                  type: "boolean",
                  rebuild: !0
                },
                dotType: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    "": "",
                    sphere: "sphere",
                    point: "point"
                  }
                },
                radiusType: {
                  type: "select",
                  options: {
                    "": "",
                    value: "value",
                    "abs-value": "abs-value",
                    "value-min": "value-min",
                    deviation: "deviation",
                    size: "size"
                  }
                },
                radius: {
                  type: "number",
                  precision: 3,
                  max: 10,
                  min: .001,
                  property: "size"
                },
                scale: {
                  type: "number",
                  precision: 3,
                  max: 10,
                  min: .001
                },
                sphereDetail: !0,
                disableImpostor: !0,
                pointSize: {
                  type: "number",
                  precision: 1,
                  max: 100,
                  min: 0,
                  buffer: !0
                },
                sizeAttenuation: {
                  type: "boolean",
                  buffer: !0
                },
                sortParticles: {
                  type: "boolean",
                  rebuild: !0
                },
                useTexture: {
                  type: "boolean",
                  buffer: !0
                },
                alphaTest: {
                  type: "range",
                  step: .001,
                  max: 1,
                  min: 0,
                  buffer: !0
                },
                forceTransparent: {
                  type: "boolean",
                  buffer: !0
                },
                edgeBleach: {
                  type: "range",
                  step: .001,
                  max: 1,
                  min: 0,
                  buffer: !0
                }
              }, this.parameters, {
                colorScheme: {
                  type: "select",
                  update: "color",
                  options: {
                    "": "",
                    value: "value",
                    uniform: "uniform",
                    random: "random"
                  }
                }
              }), t instanceof Jm ? (this.surface = void 0, this.volume = new Fg(t)) : (this.surface = t, this.volume = void 0), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.colorScheme = wu(n.colorScheme, "uniform"), n.colorValue = wu(n.colorValue, 14540253), this.thresholdType = wu(n.thresholdType, "sigma"), this.thresholdMin = wu(n.thresholdMin, 2), this.thresholdMax = wu(n.thresholdMax, 1 / 0), this.thresholdOut = wu(n.thresholdOut, !1), this.dotType = wu(n.dotType, "point"), this.radius = wu(n.radius, .1), this.scale = wu(n.scale, 1), this.pointSize = wu(n.pointSize, 1), this.sizeAttenuation = wu(n.sizeAttenuation, !0), this.sortParticles = wu(n.sortParticles, !1), this.useTexture = wu(n.useTexture, !1), this.alphaTest = wu(n.alphaTest, .5), this.forceTransparent = wu(n.forceTransparent, !1), this.edgeBleach = wu(n.edgeBleach, 0), e.prototype.init.call(this, n), this.build();
            }, t.prototype.attach = function (e) {
              var t = this;
              this.bufferList.forEach(function (e) {
                t.viewer.add(e);
              }), this.setVisibility(this.visible), e();
            }, t.prototype.create = function () {
              var e = {};
              if (this.volume) {
                var t,
                  n,
                  r = this.volume;
                "sigma" === this.thresholdType ? (t = r.getValueForSigma(this.thresholdMin), n = r.getValueForSigma(this.thresholdMax)) : (t = this.thresholdMin, n = this.thresholdMax), r.setFilter(t, n, this.thresholdOut), Object.assign(e, {
                  position: r.getDataPosition(),
                  color: r.getDataColor(this.getColorParams())
                }), "sphere" === this.dotType && Object.assign(e, {
                  radius: r.getDataSize(this.radius, this.scale),
                  picking: r.getDataPicking()
                });
              } else {
                var i = this.surface;
                Object.assign(e, {
                  position: i.getPosition(),
                  color: i.getColor(this.getColorParams())
                }), "sphere" === this.dotType && Object.assign(e, {
                  radius: i.getSize(this.radius, this.scale),
                  picking: i.getPicking()
                });
              }
              "sphere" === this.dotType ? this.dotBuffer = new _y(e, this.getBufferParams({
                sphereDetail: this.sphereDetail,
                disableImpostor: this.disableImpostor,
                dullInterior: !1
              })) : this.dotBuffer = new Sy(e, this.getBufferParams({
                pointSize: this.pointSize,
                sizeAttenuation: this.sizeAttenuation,
                sortParticles: this.sortParticles,
                useTexture: this.useTexture,
                alphaTest: this.alphaTest,
                forceTransparent: this.forceTransparent,
                edgeBleach: this.edgeBleach
              })), this.bufferList.push(this.dotBuffer);
            }, t.prototype.update = function (e) {
              if (void 0 === e && (e = {}), 0 !== this.bufferList.length) {
                var t = {};
                e.color && (this.volume ? Object.assign(t, {
                  color: this.volume.getDataColor(this.getColorParams())
                }) : Object.assign(t, {
                  color: this.surface.getColor(this.getColorParams())
                })), "sphere" === this.dotType && (e.radius || e.scale) && (this.volume ? Object.assign(t, {
                  radius: this.volume.getDataSize(this.radius, this.scale)
                }) : Object.assign(t, {
                  radius: this.surface.getSize(this.radius, this.scale)
                })), this.dotBuffer.setAttributes(t);
              }
            }, t.prototype.setParameters = function (t, n, r) {
              return void 0 === n && (n = {}), t && void 0 !== t.thresholdType && this.volume instanceof Jm && ("value" === this.thresholdType && "sigma" === t.thresholdType ? (this.thresholdMin = this.volume.getSigmaForValue(this.thresholdMin), this.thresholdMax = this.volume.getSigmaForValue(this.thresholdMax)) : "sigma" === this.thresholdType && "value" === t.thresholdType && (this.thresholdMin = this.volume.getValueForSigma(this.thresholdMin), this.thresholdMax = this.volume.getValueForSigma(this.thresholdMax)), this.thresholdType = t.thresholdType), t && void 0 !== t.radiusType && ("radius" === t.radiusType ? this.radius = .1 : this.radius = parseFloat(t.radiusType), n.radius = !0, "sphere" !== this.dotType || Kc && !this.disableImpostor || (r = !0)), t && void 0 !== t.radius && (n.radius = !0, "sphere" !== this.dotType || Kc && !this.disableImpostor || (r = !0)), t && void 0 !== t.scale && (n.scale = !0, "sphere" !== this.dotType || Kc && !this.disableImpostor || (r = !0)), e.prototype.setParameters.call(this, t, n, r), this;
            }, t;
          }(lf);
          od.add("shader/Image.vert", "uniform float clipRadius;\nuniform vec3 clipCenter;\nvarying vec2 vUv;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || !defined( PICKING )\nvarying vec3 vViewPosition;\n#endif\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\nvoid main() {\n#include begin_vertex\n#include project_vertex\nvUv = uv;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || !defined( PICKING )\nvViewPosition = -mvPosition.xyz;\n#endif\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n}"), od.add("shader/Image.frag", "uniform sampler2D map;\nuniform float opacity;\nuniform vec2 mapSize;\nuniform float clipNear;\nuniform float clipRadius;\nvarying vec2 vUv;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || !defined( PICKING )\nvarying vec3 vViewPosition;\n#endif\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#if defined( PICKING )\nuniform sampler2D pickingMap;\nuniform float objectId;\n#else\n#include fog_pars_fragment\n#endif\n#if defined( CUBIC_INTERPOLATION )\n#if defined( CATMULROM_FILTER ) || defined( MITCHELL_FILTER )\n#if defined( CATMULROM_FILTER )\nconst float B = 0.0;\nconst float C = 0.5;\n#elif defined( MITCHELL_FILTER )\nconst float B = 0.333;\nconst float C = 0.333;\n#endif\nfloat filter( float x ){\nfloat f = x;\nif( f < 0.0 ){\nf = -f;\n}\nif( f < 1.0 ){\nreturn ( ( 12.0 - 9.0 * B - 6.0 * C ) * ( f * f * f ) +\n( -18.0 + 12.0 * B + 6.0 *C ) * ( f * f ) +\n( 6.0 - 2.0 * B ) ) / 6.0;\n}else if( f >= 1.0 && f < 2.0 ){\nreturn ( ( -B - 6.0 * C ) * ( f * f * f )\n+ ( 6.0 * B + 30.0 * C ) * ( f *f ) +\n( - ( 12.0 * B ) - 48.0 * C ) * f +\n8.0 * B + 24.0 * C ) / 6.0;\n}else{\nreturn 0.0;\n}\n}\n#elif defined( BSPLINE_FILTER )\nfloat filter( float x ){\nfloat f = x;\nif( f < 0.0 ){\nf = -f;\n}\nif( f >= 0.0 && f <= 1.0 ){\nreturn ( 2.0 / 3.0 ) + ( 0.5 ) * ( f * f * f ) - ( f * f );\n}else if( f > 1.0 && f <= 2.0 ){\nreturn 1.0 / 6.0 * pow( ( 2.0 - f ), 3.0 );\n}\nreturn 1.0;\n}\n#else\nfloat filter( float x ){\nreturn 1.0;\n}\n#endif\nvec4 biCubic( sampler2D tex, vec2 texCoord ){\nvec2 texelSize = 1.0 / mapSize;\ntexCoord -= texelSize / 2.0;\nvec4 nSum = vec4( 0.0 );\nfloat nDenom = 0.0;\nvec2 cell = fract( texCoord * mapSize );\nfor( float m = -1.0; m <= 2.0; ++m ){\nfor( float n = -1.0; n <= 2.0; ++n ){\nvec4 vecData = texture2D(\ntex, texCoord + texelSize * vec2( m, n )\n);\nfloat c = filter( m - cell.x ) * filter( -n + cell.y );\nnSum += vecData * c;\nnDenom += c;\n}\n}\nreturn nSum / nDenom;\n}\n#endif\nvoid main(){\n#include nearclip_fragment\n#include radiusclip_fragment\n#if defined( CUBIC_INTERPOLATION )\ngl_FragColor = biCubic( map, vUv );\n#else\ngl_FragColor = texture2D( map, vUv );\n#endif\n#if defined( PICKING )\nif( gl_FragColor.a < 0.3 )\ndiscard;\ngl_FragColor = vec4( texture2D( pickingMap, vUv ).xyz, objectId );\n#else\nif( gl_FragColor.a < 0.01 )\ndiscard;\ngl_FragColor.a *= opacity;\n#include fog_fragment\n#endif\n}");
          var Ey = new Uint16Array([0, 1, 2, 1, 3, 2]),
            Ty = new Float32Array([0, 1, 0, 0, 1, 1, 1, 0]),
            My = Object.assign({
              filter: "nearest",
              forceTransparent: !0
            }, ig),
            Cy = Object.assign({
              filter: {
                updateShader: !0,
                uniform: !0
              }
            }, og),
            ky = function (e) {
              function t(t, n) {
                e.call(this, {
                  position: t.position,
                  index: Ey,
                  picking: t.picking
                }, n), this.parameterTypes = Cy, this.alwaysTransparent = !0, this.hasWireframe = !1, this.vertexShader = "Image.vert", this.fragmentShader = "Image.frag";
                var r = t.imageData,
                  i = t.width,
                  o = t.height,
                  a = new Pe(r, i, o);
                a.flipY = !0, this.tex = a;
                for (var s = r.length, l = new Uint8Array(s), u = 0; u < s; u += 4) {
                  var c = u / 4;
                  l[u] = c >> 16 & 255, l[u + 1] = c >> 8 & 255, l[u + 2] = 255 & c;
                }
                var d = new Pe(l, i, o);
                d.flipY = !0, d.minFilter = W, d.magFilter = W, this.pickingTex = d, this.addUniforms({
                  map: {
                    value: a
                  },
                  pickingMap: {
                    value: d
                  },
                  mapSize: {
                    value: new re(i, o)
                  }
                }), this.geometry.addAttribute("uv", new Tt(Ty, 2));
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return My;
              }, t.prototype.getDefines = function (t) {
                var n = e.prototype.getDefines.call(this, t),
                  r = this.parameters.filter;
                return r.startsWith("cubic") && (n.CUBIC_INTERPOLATION = 1, r.endsWith("bspline") ? n.BSPLINE_FILTER = 1 : r.endsWith("catmulrom") ? n.CATMULROM_FILTER = 1 : r.endsWith("mitchell") && (n.MITCHELL_FILTER = 1)), n;
              }, t.prototype.updateTexture = function () {
                var e = this.tex,
                  t = this.parameters.filter;
                t.startsWith("cubic") ? (e.minFilter = W, e.magFilter = W) : "linear" === t ? (e.minFilter = $, e.magFilter = $) : (e.minFilter = W, e.magFilter = W), e.needsUpdate = !0, this.pickingTex.needsUpdate = !0;
              }, t.prototype.makeMaterial = function () {
                e.prototype.makeMaterial.call(this), this.updateTexture();
                var t = this.material;
                t.uniforms.map.value = this.tex, t.blending = 1, t.needsUpdate = !0;
                var n = this.wireframeMaterial;
                n.uniforms.map.value = this.tex, n.blending = 1, n.needsUpdate = !0;
                var r = this.pickingMaterial;
                r.uniforms.map.value = this.tex, r.uniforms.pickingMap.value = this.pickingTex, r.blending = 1, r.needsUpdate = !0;
              }, t.prototype.setUniforms = function (t) {
                t && void 0 !== t.filter && (this.updateTexture(), t.map = this.tex), e.prototype.setUniforms.call(this, t);
              }, Object.defineProperties(t.prototype, n), t;
            }(ag),
            Py = function Py(e, t) {
              var n = t || {};
              this.dimension = wu(n.dimension, "x"), this.positionType = wu(n.positionType, "percent"), this.position = wu(n.position, 30), this.thresholdType = wu(n.thresholdType, "sigma"), this.thresholdMin = wu(n.thresholdMin, -1 / 0), this.thresholdMax = wu(n.thresholdMax, 1 / 0), this.normalize = wu(n.normalize, !1), this.volume = e;
            };
          Py.prototype.getPositionFromCoordinate = function (e) {
            var t,
              n = this.dimension,
              r = this.volume,
              i = r.matrix,
              o = new ae().setFromMatrixPosition(i)[n],
              a = new ae().setFromMatrixScale(i)[n];
            return t = "x" === n ? r.nx : "y" === n ? r.ny : r.nz, Math.round(((e - o) / (t / 100) + 1) / a);
          }, Py.prototype.getData = function (e) {
            e = e || {};
            var t,
              n = this.volume,
              r = n.data,
              i = n.matrix;
            function o(e) {
              return Math.round(e / 100 * (t - 1));
            }
            function a(e, t, r, i) {
              return 3 * (r * n.ny * n.nx + t * n.nx + e) + i;
            }
            t = "coordinate" === this.positionType ? this.getPositionFromCoordinate(this.position) : this.position;
            var s,
              l,
              u,
              c,
              d,
              h = new Float32Array(12),
              f = new ae(),
              p = 0,
              m = 0,
              g = 0,
              v = n.nx,
              y = n.ny,
              b = n.nz;
            function _(e, t, n, r) {
              f.set(e, t, n).applyMatrix4(i).toArray(h, r);
            }
            "x" === this.dimension ? (u = o(n.nx), c = n.ny - 1, d = n.nz - 1, s = n.nz, l = n.ny, v = (p = u) + 1, _(u, 0, 0, 0), _(u, c, 0, 3), _(u, 0, d, 6), _(u, c, d, 9)) : "y" === this.dimension ? (u = n.nx - 1, c = o(n.ny), d = n.nz - 1, s = n.nz, l = n.nx, y = (m = c) + 1, _(0, c, 0, 0), _(u, c, 0, 3), _(0, c, d, 6), _(u, c, d, 9)) : "z" === this.dimension && (u = n.nx - 1, c = n.ny - 1, d = o(n.nz), s = n.nx, l = n.ny, b = (g = d) + 1, _(0, 0, d, 0), _(0, c, d, 3), _(u, 0, d, 6), _(u, c, d, 9));
            var x,
              w,
              S = 0,
              A = 0,
              E = new Uint8Array(s * l * 4),
              T = new Float32Array(s * l);
            "sigma" === this.thresholdType ? (x = n.getValueForSigma(this.thresholdMin), w = n.getValueForSigma(this.thresholdMax)) : (x = this.thresholdMin, w = this.thresholdMax);
            var M = Object.assign({}, e.colorParams, {
              volume: n
            });
            this.normalize && (M.domain = [0, 1]);
            var C,
              k = td.getScheme(M),
              P = new Float32Array(3),
              O = k.getScale(),
              R = 0,
              I = 0;
            if (this.normalize) {
              R = 1 / 0, C = -1 / 0;
              for (var j = m; j < y; ++j) for (var N = p; N < v; ++N) for (var L = g; L < b; ++L) {
                var D = r[a(N, j, L, 0) / 3];
                D < R && (R = D), C < D && (C = D);
              }
              I = C - R;
            }
            for (var B = m; B < y; ++B) for (var F = p; F < v; ++F) for (var z = g; z < b; ++z) {
              var U = a(F, B, z, 0) / 3,
                G = r[U];
              this.normalize && (G = (G - R) / I), k.colorToArray(O(G), P), E[S] = Math.round(255 * P[0]), E[S + 1] = Math.round(255 * P[1]), E[S + 2] = Math.round(255 * P[2]), E[S + 3] = x < G && G < w ? 255 : 0, T[A] = U, ++A, S += 4;
            }
            var V = new Am(T, n);
            return {
              position: h,
              imageData: E,
              width: s,
              height: l,
              picking: V
            };
          };
          var Oy = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "slice", this.parameters = Object.assign({
                filter: {
                  type: "select",
                  buffer: !0,
                  options: {
                    nearest: "nearest",
                    linear: "linear",
                    "cubic-bspline": "cubic-bspline",
                    "cubic-catmulrom": "cubic-catmulrom",
                    "cubic-mitchell": "cubic-mitchell"
                  }
                },
                positionType: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    percent: "percent",
                    coordinate: "coordinate"
                  }
                },
                position: {
                  type: "range",
                  step: .1,
                  max: 100,
                  min: 1,
                  rebuild: !0
                },
                dimension: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    x: "x",
                    y: "y",
                    z: "z"
                  }
                },
                thresholdType: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    value: "value",
                    sigma: "sigma"
                  }
                },
                thresholdMin: {
                  type: "number",
                  precision: 3,
                  max: 1 / 0,
                  min: -1 / 0,
                  rebuild: !0
                },
                thresholdMax: {
                  type: "number",
                  precision: 3,
                  max: 1 / 0,
                  min: -1 / 0,
                  rebuild: !0
                },
                normalize: {
                  type: "boolean",
                  rebuild: !0
                }
              }, this.parameters, {
                flatShaded: null,
                side: null,
                wireframe: null,
                linewidth: null,
                colorScheme: null,
                roughness: null,
                metalness: null,
                diffuse: null
              }), this.volume = t, this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = this.volume,
                r = t || {};
              r.colorDomain = wu(r.colorDomain, [n.min, n.max]), r.colorScheme = wu(r.colorScheme, "value"), r.colorScale = wu(r.colorScale, "Spectral"), this.colorScheme = "value", this.dimension = wu(r.dimension, "x"), this.filter = wu(r.filter, "cubic-bspline"), this.positionType = wu(r.positionType, "percent"), this.position = wu(r.position, 30), this.thresholdType = wu(r.thresholdType, "sigma"), this.thresholdMin = wu(r.thresholdMin, -1 / 0), this.thresholdMax = wu(r.thresholdMax, 1 / 0), this.normalize = wu(r.normalize, !1), e.prototype.init.call(this, r), this.build();
            }, t.prototype.attach = function (e) {
              var t = this;
              this.bufferList.forEach(function (e) {
                t.viewer.add(e);
              }), this.setVisibility(this.visible), e();
            }, t.prototype.create = function () {
              var e = new Py(this.volume, {
                  positionType: this.positionType,
                  position: this.position,
                  dimension: this.dimension,
                  thresholdType: this.thresholdType,
                  thresholdMin: this.thresholdMin,
                  thresholdMax: this.thresholdMax,
                  normalize: this.normalize
                }),
                t = new ky(e.getData({
                  colorParams: this.getColorParams()
                }), this.getBufferParams({
                  filter: this.filter
                }));
              this.bufferList.push(t);
            }, t;
          }(lf);
          function Ry(e) {
            Zc.error("makeRepresentation: representation type " + e + " unknown");
          }
          var Iy = {
              name: "some element",
              status: ""
            },
            jy = function jy(e, t) {
              void 0 === t && (t = {}), this.stage = e, this.signals = {
                statusChanged: new lc(),
                nameChanged: new lc(),
                disposed: new lc()
              }, this.parameters = Su(t, this.defaultParameters), this.uuid = Xu();
            },
            Ny = {
              defaultParameters: {
                configurable: !0
              },
              name: {
                configurable: !0
              }
            };
          Ny.defaultParameters.get = function () {
            return Iy;
          }, Ny.name.get = function () {
            return this.parameters.name;
          }, jy.prototype.setStatus = function (e) {
            return this.parameters.status = e, this.signals.statusChanged.dispatch(e), this;
          }, jy.prototype.setName = function (e) {
            return this.parameters.name = e, this.signals.nameChanged.dispatch(e), this;
          }, jy.prototype.dispose = function () {
            this.signals.disposed.dispatch();
          }, Object.defineProperties(jy.prototype, Ny);
          var Ly = Object.assign({
              visible: !0
            }, Iy),
            Dy = function (e) {
              function t(t, n, r, i) {
                void 0 === r && (r = {}), e.call(this, t, Object.assign({
                  name: n.type
                }, r)), this.parent = i, this.signals = Object.assign({
                  visibilityChanged: new lc(),
                  parametersChanged: new lc()
                }, this.signals), this.setRepresentation(n);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                },
                visible: {
                  configurable: !0
                },
                type: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return Ly;
              }, n.visible.get = function () {
                return this.parameters.visible;
              }, n.type.get = function () {
                return "representation";
              }, t.prototype.getType = function () {
                return this.repr.type;
              }, t.prototype.setRepresentation = function (e) {
                this._disposeRepresentation(), this.repr = e, this.stage.tasks.listen(this.repr.tasks), this.updateVisibility();
              }, t.prototype._disposeRepresentation = function () {
                this.repr && (this.stage.tasks.unlisten(this.repr.tasks), this.repr.dispose());
              }, t.prototype.dispose = function () {
                this.parent && this.parent.hasRepresentation(this) ? this.parent.removeRepresentation(this) : (this._disposeRepresentation(), this.signals.disposed.dispatch());
              }, t.prototype.setVisibility = function (e) {
                return this.parameters.visible = e, this.updateVisibility(), this.signals.visibilityChanged.dispatch(this.parameters.visible), this;
              }, t.prototype.getVisibility = function () {
                return this.parent ? this.parent.parameters.visible && this.parameters.visible : this.parameters.visible;
              }, t.prototype.toggleVisibility = function () {
                return this.setVisibility(!this.parameters.visible);
              }, t.prototype.updateVisibility = function () {
                this.repr.setVisibility(this.getVisibility());
              }, t.prototype.update = function (e) {
                return this.repr.update(e), this;
              }, t.prototype.build = function (e) {
                return this.repr.build(e), this;
              }, t.prototype.setSelection = function (e) {
                var t = this.repr;
                return t.setSelection && t.setSelection(e), this;
              }, t.prototype.setParameters = function (e) {
                return this.repr.setParameters(e), this.signals.parametersChanged.dispatch(this.repr.getParameters()), this;
              }, t.prototype.getParameters = function () {
                return this.repr.getParameters();
              }, t.prototype.setColor = function (e) {
                return this.repr.setColor(e), this;
              }, Object.defineProperties(t.prototype, n), t;
            }(jy),
            By = new ie(),
            Fy = new ae(),
            zy = {
              name: "",
              status: "",
              visible: !0
            },
            Uy = function Uy(e, t, n) {
              void 0 === n && (n = {}), this.stage = e, this.object = t, this.signals = {
                representationAdded: new lc(),
                representationRemoved: new lc(),
                visibilityChanged: new lc(),
                matrixChanged: new lc(),
                statusChanged: new lc(),
                nameChanged: new lc(),
                disposed: new lc()
              }, this.reprList = [], this.annotationList = [], this.matrix = new ie(), this.position = new ae(), this.quaternion = new oe(), this.scale = new ae(1, 1, 1), this.transform = new ie(), this.parameters = Su(n, this.defaultParameters), this.uuid = Xu(), this.viewer = e.viewer, this.controls = new Rg(this);
            },
            Gy = {
              defaultParameters: {
                configurable: !0
              },
              name: {
                configurable: !0
              },
              status: {
                configurable: !0
              },
              visible: {
                configurable: !0
              }
            };
          Gy.defaultParameters.get = function () {
            return zy;
          }, Gy.name.get = function () {
            return this.parameters.name;
          }, Gy.status.get = function () {
            return this.parameters.status;
          }, Gy.visible.get = function () {
            return this.parameters.visible;
          }, Uy.prototype.setPosition = function (e) {
            return Array.isArray(e) ? this.position.fromArray(e) : this.position.copy(e), this.updateMatrix(), this;
          }, Uy.prototype.setRotation = function (e) {
            if (Array.isArray(e)) {
              if (3 === e.length) {
                var t = new We().fromArray(e);
                this.quaternion.setFromEuler(t);
              } else this.quaternion.fromArray(e);
            } else e instanceof We ? this.quaternion.setFromEuler(e) : this.quaternion.copy(e);
            return this.updateMatrix(), this;
          }, Uy.prototype.setScale = function (e) {
            return this.scale.set(e, e, e), this.updateMatrix(), this;
          }, Uy.prototype.setTransform = function (e) {
            return this.transform.copy(e), this.updateMatrix(), this;
          }, Uy.prototype.updateMatrix = function () {
            var e = this,
              t = this.getCenterUntransformed(Fy);
            this.matrix.makeTranslation(-t.x, -t.y, -t.z), By.makeRotationFromQuaternion(this.quaternion), this.matrix.premultiply(By), By.makeScale(this.scale.x, this.scale.y, this.scale.z), this.matrix.premultiply(By);
            var n = this.position;
            By.makeTranslation(n.x + t.x, n.y + t.y, n.z + t.z), this.matrix.premultiply(By), this.matrix.premultiply(this.transform), this.reprList.forEach(function (t) {
              t.setParameters({
                matrix: e.matrix
              });
            }), this.stage.viewer.updateBoundingBox(), this.signals.matrixChanged.dispatch(this.matrix);
          }, Uy.prototype.addAnnotation = function (e, t, n) {
            var r = new Cg(this, e, t, n);
            return this.annotationList.push(r), r;
          }, Uy.prototype.eachAnnotation = function (e) {
            this.annotationList.slice().forEach(e);
          }, Uy.prototype.removeAnnotation = function (e) {
            var t = this.annotationList.indexOf(e);
            -1 !== t && (this.annotationList.splice(t, 1), e.dispose());
          }, Uy.prototype.removeAllAnnotations = function () {
            this.eachAnnotation(function (e) {
              return e.dispose();
            }), this.annotationList.length = 0;
          }, Uy.prototype._addRepresentation = function (e, n, r, i) {
            void 0 === i && (i = !1);
            var o = r || {},
              a = this.stage.getParameters();
            o.matrix = this.matrix.clone(), o.quality = o.quality || a.quality, o.disableImpostor = wu(o.disableImpostor, !a.impostor), o.useWorker = wu(o.useWorker, a.workerDefault), o.visible = wu(o.visible, !0);
            var s = Object.assign({}, o, {
                visible: this.parameters.visible && o.visible
              }),
              l = function (e, n, r, i) {
                var o;
                if (t.Debug && Zc.time("makeRepresentation " + e), n instanceof ty) {
                  if (!(o = rd.get(e))) return void Ry(e);
                } else if (n instanceof Km) {
                  if ("surface" === e) o = mg;else {
                    if ("dot" !== e) return void Ry(e);
                    o = Ay;
                  }
                } else if (n instanceof Jm) {
                  if ("surface" === e) o = mg;else if ("dot" === e) o = Ay;else {
                    if ("slice" !== e) return void Ry(e);
                    o = Oy;
                  }
                } else if (n instanceof ay) o = ly, n = n.getBufferList();else {
                  if ("buffer" !== e) return void Zc.error("makeRepresentation: object " + n + " unknown");
                  o = ly;
                }
                var a = new o(n, r, i);
                return t.Debug && Zc.timeEnd("makeRepresentation " + e), a;
              }(e, n, this.viewer, s),
              u = new Dy(this.stage, l, o, this);
            return i || (this.reprList.push(u), this.signals.representationAdded.dispatch(u)), u;
          }, Uy.prototype.addBufferRepresentation = function (e, t) {
            return this._addRepresentation.call(this, "buffer", e, t);
          }, Uy.prototype.hasRepresentation = function (e) {
            return -1 !== this.reprList.indexOf(e);
          }, Uy.prototype.eachRepresentation = function (e) {
            this.reprList.slice().forEach(e);
          }, Uy.prototype.removeRepresentation = function (e) {
            var t = this.reprList.indexOf(e);
            -1 !== t && (this.reprList.splice(t, 1), e.dispose(), this.signals.representationRemoved.dispatch(e));
          }, Uy.prototype.updateRepresentations = function (e) {
            this.reprList.forEach(function (t) {
              return t.update(e);
            }), this.stage.viewer.requestRender();
          }, Uy.prototype.removeAllRepresentations = function () {
            this.eachRepresentation(function (e) {
              return e.dispose();
            });
          }, Uy.prototype.dispose = function () {
            this.removeAllAnnotations(), this.removeAllRepresentations(), delete this.annotationList, delete this.reprList, this.signals.disposed.dispatch();
          }, Uy.prototype.setVisibility = function (e) {
            return this.parameters.visible = e, this.eachRepresentation(function (e) {
              return e.updateVisibility();
            }), this.eachAnnotation(function (e) {
              return e.updateVisibility();
            }), this.signals.visibilityChanged.dispatch(e), this;
          }, Uy.prototype.setStatus = function (e) {
            return this.parameters.status = e, this.signals.statusChanged.dispatch(e), this;
          }, Uy.prototype.setName = function (e) {
            return this.parameters.name = e, this.signals.nameChanged.dispatch(e), this;
          }, Uy.prototype.getBox = function () {
            for (var e, t = [], n = arguments.length; n--;) t[n] = arguments[n];
            return (e = this).getBoxUntransformed.apply(e, t).clone().applyMatrix4(this.matrix);
          }, Uy.prototype.getCenter = function () {
            for (var e, t = [], n = arguments.length; n--;) t[n] = arguments[n];
            return (e = this).getCenterUntransformed.apply(e, t).clone().applyMatrix4(this.matrix);
          }, Uy.prototype.getZoom = function () {
            for (var e, t = [], n = arguments.length; n--;) t[n] = arguments[n];
            return this.stage.getZoomForBox((e = this).getBox.apply(e, t));
          }, Uy.prototype.getBoxUntransformed = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            return new Oe();
          }, Uy.prototype.getCenterUntransformed = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            return this.getBoxUntransformed().getCenter(new ae());
          }, Uy.prototype.autoView = function (e) {
            this.stage.animationControls.zoomMove(this.getCenter(), this.getZoom(), wu(e, 0));
          }, Object.defineProperties(Uy.prototype, Gy);
          var Vy = function Vy(e) {
              void 0 === e && (e = []);
              for (var t = (this.list = e).length, n = 0; n < t; ++n) e[n].signals.disposed.add(this._remove, this);
            },
            Hy = {
              first: {
                configurable: !0
              }
            };
          Vy.prototype._remove = function (e) {
            var t = this.list.indexOf(e);
            -1 !== t && this.list.splice(t, 1);
          }, Hy.first.get = function () {
            return 0 < this.list.length ? this.list[0] : void 0;
          }, Vy.prototype.forEach = function (e) {
            return this.list.forEach(e), this;
          }, Vy.prototype.dispose = function () {
            return this.forEach(function (e) {
              return e.dispose();
            });
          }, Object.defineProperties(Vy.prototype, Hy);
          var qy = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.setParameters = function (e) {
                return this.forEach(function (t) {
                  return t.setParameters(e);
                });
              }, t.prototype.setVisibility = function (e) {
                return this.forEach(function (t) {
                  return t.setVisibility(e);
                });
              }, t.prototype.setSelection = function (e) {
                return this.forEach(function (t) {
                  return t.setSelection(e);
                });
              }, t.prototype.setColor = function (e) {
                return this.forEach(function (t) {
                  return t.setColor(e);
                });
              }, t.prototype.update = function (e) {
                return this.forEach(function (t) {
                  return t.update(e);
                });
              }, t.prototype.build = function (e) {
                return this.forEach(function (t) {
                  return t.build(e);
                });
              }, t.prototype.dispose = function (e) {
                return this.forEach(function (e) {
                  return e.dispose();
                });
              }, t;
            }(Vy),
            Wy = Object.assign({
              defaultStep: 1,
              defaultTimeout: 50,
              defaultInterpolateType: "",
              defaultInterpolateStep: 5,
              defaultMode: "loop",
              defaultDirection: "forward",
              initialFrame: 0
            }, Iy),
            $y = function (e) {
              function t(t, n, r) {
                var i = this;
                void 0 === r && (r = {}), e.call(this, t, Object.assign({
                  name: n.name
                }, r)), this.trajectory = n, this.signals = Object.assign(this.signals, {
                  frameChanged: new lc(),
                  playerChanged: new lc(),
                  countChanged: new lc(),
                  parametersChanged: new lc()
                }), n.signals.frameChanged.add(function (e) {
                  i.signals.frameChanged.dispatch(e);
                }), n.signals.playerChanged.add(function (e) {
                  i.signals.playerChanged.dispatch(e);
                }), n.signals.countChanged.add(function (e) {
                  i.signals.countChanged.dispatch(e);
                }), void 0 !== r.initialFrame && this.setFrame(r.initialFrame);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                },
                type: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return Wy;
              }, n.type.get = function () {
                return "trajectory";
              }, t.prototype.setFrame = function (e) {
                this.trajectory.setFrame(e);
              }, t.prototype.setParameters = function (e) {
                void 0 === e && (e = {}), this.trajectory.setParameters(e), this.signals.parametersChanged.dispatch(e);
              }, t.prototype.dispose = function () {
                this.trajectory.dispose(), e.prototype.dispose.call(this);
              }, Object.defineProperties(t.prototype, n), t;
            }(jy),
            Xy = function Xy(e, t) {
              this.name = e, this.path = t, this.coordinates = [], this.boxes = [], this.times = [], this.timeOffset = 0, this.deltaTime = 1;
            },
            Yy = {
              type: {
                configurable: !0
              }
            };
          Yy.type.get = function () {
            return "Frames";
          }, Object.defineProperties(Xy.prototype, Yy);
          var Ky = function Ky(e, t) {
            var n, r;
            if (this.A = new Pm(3, 3), this.W = new Pm(1, 3), this.U = new Pm(3, 3), this.V = new Pm(3, 3), this.VH = new Pm(3, 3), this.R = new Pm(3, 3), this.tmp = new Pm(3, 3), this.c = new Pm(3, 3), e instanceof ty) n = e.atomCount;else {
              if (!(e instanceof Float32Array)) return;
              n = e.length / 3;
            }
            if (t instanceof ty) r = t.atomCount;else {
              if (!(t instanceof Float32Array)) return;
              r = t.length / 3;
            }
            var i = Math.min(n, r),
              o = new Pm(3, i),
              a = new Pm(3, i);
            this.coords1t = new Pm(i, 3), this.coords2t = new Pm(i, 3), this.transformationMatrix = new ie(), this.c.data.set([1, 0, 0, 0, 1, 0, 0, 0, -1]), this.prepCoords(e, o, i, !1), this.prepCoords(t, a, i, !1), this._superpose(o, a);
          };
          Ky.prototype._superpose = function (e, n) {
            var r, i, o, a, s, l, u, c, d, h, f, p, m, g, v, y, b, _, x, w, S;
            this.mean1 = jm(e), this.mean2 = jm(n), Nm(e, this.mean1), Nm(n, this.mean2), Om(this.coords1t, e), Om(this.coords2t, n), Rm(this.A, this.coords2t, this.coords1t), Dm(this.A, this.W, this.U, this.V), r = this.V, i = this.VH, o = r.data, a = i.data, s = o[4], l = o[8], u = o[5], c = o[7], w = 1 / ((h = (d = o[0]) * s) * l - (f = d * u) * c - (g = (p = o[3]) * (m = o[1])) * l + (y = p * (v = o[2])) * c + (_ = (b = o[6]) * m) * u - (x = b * v) * s), a[0] = (s * l - u * c) * w, a[1] = -(m * l - v * c) * w, a[2] = -(-m * u + v * s) * w, a[3] = -(p * l - u * b) * w, a[4] = (d * l - x) * w, a[5] = -(f - y) * w, a[6] = -(-p * c + s * b) * w, a[7] = -(d * c - _) * w, a[8] = (h - g) * w, Im(this.R, this.U, this.VH), (S = this.R.data)[0] * S[4] * S[8] - S[0] * S[5] * S[7] - S[3] * S[1] * S[8] + S[3] * S[2] * S[7] + S[6] * S[1] * S[5] - S[6] * S[2] * S[4] < 0 && (t.Debug && Zc.log("R not a right handed system"), Im(this.tmp, this.c, this.VH), Im(this.R, this.U, this.tmp));
            var A = new Pm(4, 4),
              E = new Pm(4, 4),
              T = new Pm(4, 4),
              M = new Pm(4, 4),
              C = new Pm(4, 4),
              k = new Pm(4, 4),
              P = this.R.data,
              O = this.mean1,
              R = this.mean2;
            M.data.set([1, 0, 0, -O[0], 0, 1, 0, -O[1], 0, 0, 1, -O[2], 0, 0, 0, 1]), C.data.set([P[0], P[1], P[2], 0, P[3], P[4], P[5], 0, P[6], P[7], P[8], 0, 0, 0, 0, 1]), k.data.set([1, 0, 0, R[0], 0, 1, 0, R[1], 0, 0, 1, R[2], 0, 0, 0, 1]), Om(E, M), Rm(A, C, E), Om(T, A), Rm(E, k, T), Om(A, E), this.transformationMatrix.elements = A.data;
          }, Ky.prototype.prepCoords = function (e, t, n, r) {
            var i = 0,
              o = t.data,
              a = 3,
              s = 3 * n;
            if (r && (s = 4 * n, a = 4), e instanceof ty) e.eachAtom(function (e) {
              i < s && (o[i + 0] = e.x, o[i + 1] = e.y, o[i + 2] = e.z, r && (o[i + 3] = 1), i += a);
            });else if (e instanceof Float32Array) for (; i < s; i += a) i < s && (o[i] = e[i], o[i + 1] = e[i + 1], o[i + 2] = e[i + 2], r && (o[i + 3] = 1));else Zc.warn("prepCoords: input type unknown");
          }, Ky.prototype.transform = function (e) {
            var t;
            if (e instanceof ty) t = e.atomCount;else {
              if (!(e instanceof Float32Array)) return;
              t = e.length / 3;
            }
            var n = new Pm(4, t),
              r = new Pm(t, 4);
            this.prepCoords(e, n, t, !0);
            var i = this.transformationMatrix,
              o = i.determinant();
            if (!o) return o;
            var a = new Pm(4, 4);
            a.data = i.elements, function (e, t, n) {
              for (var r = 0, i = 0, o = 0, a = 0, s = 0, l = 0, u = 0, c = 0, d = t.cols, h = t.rows, f = n.cols, p = t.data, m = n.data, g = e.data, v = 0; r < h; a += d, r++) for (i = u = 0; i < f; c++, u++, i++) {
                for (l = u, s = a, o = v = 0; o < d; s++, l += f, o++) v += p[s] * m[l];
                g[c] = v;
              }
            }(r, n, a);
            var s = 0,
              l = r.data;
            if (e instanceof ty) {
              e.eachAtom(function (e) {
                e.x = l[s], e.y = l[s + 1], e.z = l[s + 2], s += 4;
              });
              var u = new ie();
              u.getInverse(i);
              var c = e.biomolDict;
              for (var d in c) c.hasOwnProperty(d) && c[d].partList.forEach(function (e) {
                e.matrixList.forEach(function (e) {
                  e.premultiply(i), e.multiply(u);
                });
              });
            } else if (e instanceof Float32Array) for (var h = 4 * t; s < h; s += 4) e[s] = l[s], e[s + 1] = l[s + 1], e[s + 2] = l[s + 2];else Zc.warn("transform: input type unknown");
            return this.transformationMatrix;
          };
          var Zy = {
              step: 1,
              timeout: 50,
              start: 0,
              end: 0,
              interpolateType: "",
              interpolateStep: 5,
              mode: "loop",
              direction: "forward"
            },
            Qy = function Qy(e, t) {
              var n = this;
              void 0 === t && (t = {}), this.signals = {
                startedRunning: new lc(),
                haltedRunning: new lc()
              }, this._run = !1, this._previousTime = 0, this._currentTime = 0, this._currentStep = 1, e.signals.playerChanged.add(function (e) {
                e !== n && n.pause();
              }, this);
              var r = wu(e.frameCount, 1);
              this.traj = e, this.parameters = Su(t, Zy), this.parameters.end = Math.min(wu(t.end, r - 1), r - 1), this.parameters.step = wu(t.step, Math.ceil((r + 1) / 100)), this._currentFrame = this.parameters.start, this._direction = "bounce" === this.parameters.direction ? "forward" : this.parameters.direction, e.signals.countChanged.add(function (e) {
                n.parameters.end = Math.min(wu(n.parameters.end, e - 1), e - 1);
              }, this), this._animate = this._animate.bind(this);
            },
            Jy = {
              isRunning: {
                configurable: !0
              }
            };
          Jy.isRunning.get = function () {
            return this._run;
          }, Qy.prototype.setParameters = function (e) {
            void 0 === e && (e = {}), Au(this.parameters, e), void 0 !== e.direction && "bounce" !== this.parameters.direction && (this._direction = this.parameters.direction);
          }, Qy.prototype._animate = function () {
            if (this._run) {
              this._currentTime = window.performance.now();
              var e = this._currentTime - this._previousTime,
                t = this.parameters.interpolateType ? this.parameters.interpolateStep : 1,
                n = this.parameters.timeout / t,
                r = this.traj;
              if (r && r.frameCount && !r.inProgress && n <= e) if (this.parameters.interpolateType) {
                if (this._currentStep > this.parameters.interpolateStep && (this._currentStep = 1), 1 === this._currentStep && (this._currentFrame = this._nextInterpolated()), r.hasFrame(this._currentFrame)) {
                  this._currentStep += 1;
                  var i = this._currentStep / (this.parameters.interpolateStep + 1),
                    o = this._currentFrame,
                    a = o[0],
                    s = o[1],
                    l = o[2],
                    u = o[3];
                  r.setFrameInterpolated(a, s, l, u, i, this.parameters.interpolateType), this._previousTime = this._currentTime;
                } else r.loadFrame(this._currentFrame);
              } else {
                var c = this._next();
                r.hasFrame(c) ? (r.setFrame(c), this._previousTime = this._currentTime) : r.loadFrame(c);
              }
              window.requestAnimationFrame(this._animate);
            }
          }, Qy.prototype._next = function () {
            var e,
              t = this.parameters;
            return ((e = "forward" === this._direction ? this.traj.currentFrame + t.step : this.traj.currentFrame - t.step) > t.end || e < t.start) && ("bounce" === t.direction && ("forward" === this._direction ? this._direction = "backward" : this._direction = "forward"), "once" === t.mode ? (this.pause(), e = "forward" === t.direction ? t.end : "backward" === t.direction || "forward" === this._direction ? t.start : t.end) : "forward" === this._direction ? (e = t.start, t.interpolateType && (e = Math.min(t.end, e + t.step))) : (e = t.end, t.interpolateType && (e = Math.max(t.start, e - t.step)))), e;
          }, Qy.prototype._nextInterpolated = function () {
            var e,
              t,
              n,
              r = this.parameters,
              i = this._next();
            return "forward" === this._direction ? (e = Math.max(r.start, i - r.step), t = Math.max(r.start, i - 2 * r.step), n = Math.max(r.start, i - 3 * r.step)) : (e = Math.min(r.end, i + r.step), t = Math.min(r.end, i + 2 * r.step), n = Math.min(r.end, i + 3 * r.step)), [i, e, t, n];
          }, Qy.prototype.toggle = function () {
            this._run ? this.pause() : this.play();
          }, Qy.prototype.play = function () {
            if (!this._run) {
              this.traj.player !== this && this.traj.setPlayer(this), this._currentStep = 1;
              var e = this.parameters,
                t = this.traj.currentFrame,
                n = Math.ceil(t / e.step) * e.step;
              "forward" === e.direction && t >= e.end ? n = e.start : "backward" === e.direction && t <= e.start && (n = e.end), this.traj.setFrame(n), this._run = !0, this._animate(), this.signals.startedRunning.dispatch();
            }
          }, Qy.prototype.pause = function () {
            this._run = !1, this.signals.haltedRunning.dispatch();
          }, Qy.prototype.stop = function () {
            this.pause(), this.traj.setFrame(this.parameters.start);
          }, Object.defineProperties(Qy.prototype, Jy);
          var eb = function eb(e, t, n) {
              var r = this;
              void 0 === n && (n = {}), this.signals = {
                countChanged: new lc(),
                frameChanged: new lc(),
                playerChanged: new lc()
              }, this.frameCache = {}, this.loadQueue = {}, this.boxCache = {}, this.pathCache = {}, this.frameCacheSize = 0, this._frameCount = 0, this._currentFrame = -1, this._disposed = !1, this.deltaTime = wu(n.deltaTime, 0), this.timeOffset = wu(n.timeOffset, 0), this.centerPbc = wu(n.centerPbc, !1), this.removePbc = wu(n.removePbc, !1), this.removePeriodicity = wu(n.removePeriodicity, !1), this.superpose = wu(n.superpose, !1), this.name = e.replace(/^.*[\\/]/, ""), this.trajPath = e, this.selection = new Nc(wu(n.sele, "backbone and not hydrogen")), this.selection.signals.stringChanged.add(function () {
                r.selectionIndices = r.structure.getAtomIndices(r.selection), r._resetCache(), r._saveInitialCoords(), r.setFrame(r._currentFrame);
              });
            },
            tb = {
              frameCount: {
                configurable: !0
              },
              currentFrame: {
                configurable: !0
              }
            };
          tb.frameCount.get = function () {
            return this._frameCount;
          }, tb.currentFrame.get = function () {
            return this._currentFrame;
          }, eb.prototype._init = function (e) {
            this.setStructure(e), this._loadFrameCount(), this.setPlayer(new Qy(this));
          }, eb.prototype._loadFrameCount = function () {}, eb.prototype.setStructure = function (e) {
            this.structure = e, this.atomCount = e.atomCount, this.backboneIndices = this._getIndices(new Nc("backbone and not hydrogen")), this._makeAtomIndices(), this._saveStructureCoords(), this.selectionIndices = this._getIndices(this.selection), this._resetCache(), this._saveInitialCoords(), this.setFrame(this._currentFrame);
          }, eb.prototype._saveInitialCoords = function () {
            var e = this;
            this.structure.hasCoords() ? (this.initialCoords = new Float32Array(this.structureCoords), this._makeSuperposeCoords()) : this.frameCache[0] ? (this.initialCoords = new Float32Array(this.frameCache[0]), this._makeSuperposeCoords()) : this.loadFrame(0, function () {
              return e._saveInitialCoords();
            });
          }, eb.prototype._saveStructureCoords = function () {
            this.structureCoords = this.structure.getAtomData({
              what: {
                position: !0
              }
            }).position;
          }, eb.prototype.setSelection = function (e) {
            return this.selection.setString(e), this;
          }, eb.prototype._getIndices = function (e) {
            var t = 0,
              n = e.test,
              r = [];
            return n && this.structure.eachAtom(function (e) {
              n(e) && r.push(t), t += 1;
            }), r;
          }, eb.prototype._makeSuperposeCoords = function () {
            var e = 3 * this.selectionIndices.length;
            this.coords1 = new Float32Array(e), this.coords2 = new Float32Array(e);
            for (var t = this.initialCoords, n = this.coords2, r = 0; r < e; r += 3) {
              var i = 3 * this.selectionIndices[r / 3];
              n[r + 0] = t[i + 0], n[r + 1] = t[i + 1], n[r + 2] = t[i + 2];
            }
          }, eb.prototype._makeAtomIndices = function () {
            Zc.error("Trajectory._makeAtomIndices not implemented");
          }, eb.prototype._resetCache = function () {
            this.frameCache = {}, this.loadQueue = {}, this.boxCache = {}, this.pathCache = {}, this.frameCacheSize = 0, this.initialCoords = new Float32Array(0);
          }, eb.prototype.setParameters = function (e) {
            void 0 === e && (e = {});
            var t = !1;
            void 0 !== e.centerPbc && e.centerPbc !== this.centerPbc && (this.centerPbc = e.centerPbc, t = !0), void 0 !== e.removePeriodicity && e.removePeriodicity !== this.removePeriodicity && (this.removePeriodicity = e.removePeriodicity, t = !0), void 0 !== e.removePbc && e.removePbc !== this.removePbc && (this.removePbc = e.removePbc, t = !0), void 0 !== e.superpose && e.superpose !== this.superpose && (this.superpose = e.superpose, t = !0), this.deltaTime = wu(e.deltaTime, this.deltaTime), this.timeOffset = wu(e.timeOffset, this.timeOffset), t && (this._resetCache(), this.setFrame(this._currentFrame));
          }, eb.prototype.hasFrame = function (e) {
            var t = this;
            return Array.isArray(e) ? e.every(function (e) {
              return !!t.frameCache[e];
            }) : !!this.frameCache[e];
          }, eb.prototype.setFrame = function (e, t) {
            var n = this;
            return void 0 === e || (this.inProgress = !0, -1 === e || this.frameCache[e] ? (this._updateStructure(e), t && t()) : this.loadFrame(e, function () {
              n._updateStructure(e), t && t();
            })), this;
          }, eb.prototype._interpolate = function (e, t, n, r, i, o) {
            var a,
              s = this.frameCache;
            a = "spline" === o ? function (e, t, n, r, i) {
              for (var o = e.length, a = new Float32Array(o), s = 0; s < o; s += 3) {
                var l = s + 1,
                  u = s + 2;
                a[s] = Qu(r[s], n[s], t[s], e[s], i, 1), a[l] = Qu(r[l], n[l], t[l], e[l], i, 1), a[u] = Qu(r[u], n[u], t[u], e[u], i, 1);
              }
              return a;
            }(s[e], s[t], s[n], s[r], i) : function (e, t, n) {
              for (var r = e.length, i = new Float32Array(r), o = 0; o < r; o += 3) {
                var a = o + 1,
                  s = o + 2;
                i[o] = Zu(t[o], e[o], n), i[a] = Zu(t[a], e[a], n), i[s] = Zu(t[s], e[s], n);
              }
              return i;
            }(s[e], s[t], i), this.structure.updatePosition(a), this._currentFrame = e, this.signals.frameChanged.dispatch(e);
          }, eb.prototype.setFrameInterpolated = function (e, t, n, r, i, o, a) {
            var s = this;
            if (void 0 === e) return this;
            var l = this.frameCache,
              u = [];
            return l[r] || u.push(r), l[n] || u.push(n), l[t] || u.push(t), l[e] || u.push(e), u.length ? this.loadFrame(u, function () {
              s._interpolate(e, t, n, r, i, o), a && a();
            }) : (this._interpolate(e, t, n, r, i, o), a && a()), this;
          }, eb.prototype.loadFrame = function (e, t) {
            var n = this;
            Array.isArray(e) ? e.forEach(function (e) {
              n.loadQueue[e] || n.frameCache[e] || (n.loadQueue[e] = !0, n._loadFrame(e, function () {
                delete n.loadQueue[e];
              }));
            }) : this.loadQueue[e] || this.frameCache[e] || (this.loadQueue[e] = !0, this._loadFrame(e, function () {
              delete n.loadQueue[e], t && t();
            }));
          }, eb.prototype._loadFrame = function (e, t) {
            Zc.error("Trajectory._loadFrame not implemented", e, t);
          }, eb.prototype._updateStructure = function (e) {
            this._disposed ? console.error("updateStructure: traj disposed") : (-1 === e ? this.structureCoords && this.structure.updatePosition(this.structureCoords) : this.structure.updatePosition(this.frameCache[e]), this.structure.trajectory = {
              name: this.trajPath,
              frame: e
            }, this._currentFrame = e, this.inProgress = !1, this.signals.frameChanged.dispatch(e));
          }, eb.prototype._doSuperpose = function (e) {
            for (var t = 3 * this.selectionIndices.length, n = this.coords1, r = this.coords2, i = 0; i < t; i += 3) {
              var o = 3 * this.selectionIndices[i / 3];
              n[i + 0] = e[o + 0], n[i + 1] = e[o + 1], n[i + 2] = e[o + 2];
            }
            new Ky(n, r).transform(e);
          }, eb.prototype._process = function (e, t, n, r) {
            if (this._setFrameCount(r), t) {
              if (0 < this.backboneIndices.length && this.centerPbc) {
                var i = [t[0], t[4], t[8]];
                !function (e, t, n) {
                  if (0 !== n[0] && 0 !== n[8] && 0 !== n[4]) for (var r = e.length, i = n[0], o = n[1], a = n[2], s = -t[0] + i + i / 2, l = -t[1] + o + o / 2, u = -t[2] + a + a / 2, c = 0; c < r; c += 3) e[c + 0] = (e[c + 0] + s) % i, e[c + 1] = (e[c + 1] + l) % o, e[c + 2] = (e[c + 2] + u) % a;
                }(n, (a = this.backboneIndices, [Ud(s = n, (l = i)[0], 3, 0, a), Ud(s, l[1], 3, 1, a), Ud(s, l[2], 3, 2, a)]), i);
              }
              this.removePeriodicity && function (e, t, n) {
                if (0 !== t[0] && 0 !== t[8] && 0 !== t[4]) for (var r = e.length, i = 3; i < r; i += 3) for (var o = 0; o < 3; ++o) {
                  var a = (e[i + o] - n[o]) / t[3 * o + o];
                  .5 < Math.abs(a) && (e[i + o] -= t[3 * o + o] * Math.round(a));
                }
              }(n, t, [eh(o = n, 3, 0), eh(o, 3, 1), eh(o, 3, 2)]), this.removePbc && function (e, t) {
                if (0 !== t[0] && 0 !== t[8] && 0 !== t[4]) for (var n = e.length, r = 3; r < n; r += 3) for (var i = 0; i < 3; ++i) {
                  var o = e[r + i] - e[r - 3 + i];
                  if (Math.abs(o) > .9 * t[3 * i + i]) if (0 < o) for (var a = 0; a < 3; ++a) e[r + a] -= t[3 * i + a];else for (var s = 0; s < 3; ++s) e[r + s] += t[3 * i + s];
                }
              }(n, t);
            }
            var o, a, s, l;
            0 < this.selectionIndices.length && this.coords1 && this.superpose && this._doSuperpose(n), this.frameCache[e] = n, this.boxCache[e] = t, this.frameCacheSize += 1;
          }, eb.prototype._setFrameCount = function (e) {
            e !== this._frameCount && (this._frameCount = e, this.signals.countChanged.dispatch(e));
          }, eb.prototype.dispose = function () {
            this._resetCache(), this._disposed = !0, this.player && this.player.stop();
          }, eb.prototype.setPlayer = function (e) {
            this.player = e, this.signals.playerChanged.dispatch(e);
          }, eb.prototype.getFrameTime = function (e) {
            return this.timeOffset + e * this.deltaTime;
          }, Object.defineProperties(eb.prototype, tb);
          var nb = function (e) {
              function t(t, n, r) {
                var i = r || {};
                i.timeOffset = wu(i.timeOffset, t.timeOffset), i.deltaTime = wu(i.deltaTime, t.deltaTime), e.call(this, "", n, i), this.name = t.name, this.path = t.path, this.frames = t.coordinates, this.boxes = t.boxes, this._init(n);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "frames";
              }, t.prototype._makeAtomIndices = function () {
                "StructureView" === this.structure.type ? this.atomIndices = this.structure.getAtomIndices() : this.atomIndices = void 0;
              }, t.prototype._loadFrame = function (e, t) {
                var n,
                  r = this.frames[e];
                if (this.atomIndices) {
                  var i = this.atomIndices,
                    o = i.length;
                  n = new Float32Array(3 * o);
                  for (var a = 0; a < o; ++a) {
                    var s = 3 * a,
                      l = 3 * i[a];
                    n[s + 0] = r[l + 0], n[s + 1] = r[l + 1], n[s + 2] = r[l + 2];
                  }
                } else n = new Float32Array(r);
                var u = this.boxes[e],
                  c = this.frames.length;
                this._process(e, u, n, c), "function" == typeof t && t();
              }, t.prototype._loadFrameCount = function () {
                this.frames && this._setFrameCount(this.frames.length);
              }, Object.defineProperties(t.prototype, n), t;
            }(eb),
            rb = function (e) {
              function t(t, n, r) {
                e.call(this, "", n, r), this._init(n);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "structure";
              }, t.prototype._makeAtomIndices = function () {
                this.structure.atomSet && this.structure.atomSet.getSize() < this.structure.atomStore.count ? this.atomIndices = this.structure.getAtomIndices() : this.atomIndices = void 0;
              }, t.prototype._loadFrame = function (e, t) {
                var n,
                  r = this.structure,
                  i = r.frames[e];
                if (this.atomIndices) {
                  var o = this.atomIndices,
                    a = o.length;
                  n = new Float32Array(3 * a);
                  for (var s = 0; s < a; ++s) {
                    var l = 3 * s,
                      u = 3 * o[s];
                    n[l + 0] = i[u + 0], n[l + 1] = i[u + 1], n[l + 2] = i[u + 2];
                  }
                } else n = new Float32Array(i);
                var c = r.boxes[e],
                  d = r.frames.length;
                this._process(e, c, n, d), "function" == typeof t && t();
              }, t.prototype._loadFrameCount = function () {
                this._setFrameCount(this.structure.frames.length);
              }, Object.defineProperties(t.prototype, n), t;
            }(eb),
            ib = function (e) {
              function n(t, n, r) {
                e.call(this, t, n, r), this._init(n);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "remote";
              }, n.prototype._makeAtomIndices = function () {
                var e = [];
                if ("StructureView" === this.structure.type) {
                  for (var t = this.structure.getAtomIndices(), n = t.length, r = t[0], i = t[0], o = 1; o < n; ++o) {
                    var a = t[o];
                    i + 1 < a && (e.push([r, i + 1]), r = a), i = a;
                  }
                  e.push([r, i + 1]);
                } else e.push([0, this.atomCount]);
                this.atomIndices = e;
              }, n.prototype._loadFrame = function (e, n) {
                var r = this,
                  i = new XMLHttpRequest(),
                  o = t.TrajectoryDatasource.getFrameUrl(this.trajPath, e),
                  a = t.TrajectoryDatasource.getFrameParams(this.trajPath, this.atomIndices);
                i.open("POST", o, !0), i.responseType = "arraybuffer", i.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), i.addEventListener("load", function () {
                  var t = i.response;
                  if (t) {
                    var a = new Int32Array(t, 0, 1)[0],
                      s = new Float32Array(t, 8, 9),
                      l = new Float32Array(t, 44);
                    r._process(e, s, l, a), "function" == typeof n && n();
                  } else Zc.error("empty arrayBuffer for '" + o + "'");
                }, !1), i.send(a);
              }, n.prototype._loadFrameCount = function () {
                var e = this,
                  n = new XMLHttpRequest(),
                  r = t.TrajectoryDatasource.getCountUrl(this.trajPath);
                n.open("GET", r, !0), n.addEventListener("load", function () {
                  e._setFrameCount(parseInt(n.response));
                }, !1), n.send();
              }, Object.defineProperties(n.prototype, r), n;
            }(eb);
          ty.prototype.getView = function (e) {
            return new ob(this, e);
          };
          var ob = function (e) {
            function n(t, n) {
              e.call(this), this.structure = t, this.selection = n, this.center = new ae(), this.boundingBox = new Oe(), this._bp = this.getBondProxy(), this._ap = this.getAtomProxy(), this._rp = this.getResidueProxy(), this._cp = this.getChainProxy(), this.selection && this.selection.signals.stringChanged.add(this.refresh, this), this.structure.signals.refreshed.add(this.refresh, this), this.refresh();
            }
            e && (n.__proto__ = e);
            var r = {
              type: {
                configurable: !0
              },
              name: {
                configurable: !0
              },
              path: {
                configurable: !0
              },
              title: {
                configurable: !0
              },
              id: {
                configurable: !0
              },
              data: {
                configurable: !0
              },
              atomSetDict: {
                configurable: !0
              },
              biomolDict: {
                configurable: !0
              },
              entityList: {
                configurable: !0
              },
              unitcell: {
                configurable: !0
              },
              frames: {
                configurable: !0
              },
              boxes: {
                configurable: !0
              },
              validation: {
                configurable: !0
              },
              bondStore: {
                configurable: !0
              },
              backboneBondStore: {
                configurable: !0
              },
              rungBondStore: {
                configurable: !0
              },
              atomStore: {
                configurable: !0
              },
              residueStore: {
                configurable: !0
              },
              chainStore: {
                configurable: !0
              },
              modelStore: {
                configurable: !0
              },
              atomMap: {
                configurable: !0
              },
              residueMap: {
                configurable: !0
              },
              bondHash: {
                configurable: !0
              },
              spatialHash: {
                configurable: !0
              },
              _hasCoords: {
                configurable: !0
              }
            };
            return ((n.prototype = Object.create(e && e.prototype)).constructor = n).prototype.init = function () {}, r.type.get = function () {
              return "StructureView";
            }, r.name.get = function () {
              return this.structure.name;
            }, r.path.get = function () {
              return this.structure.path;
            }, r.title.get = function () {
              return this.structure.title;
            }, r.id.get = function () {
              return this.structure.id;
            }, r.data.get = function () {
              return this.structure.data;
            }, r.atomSetDict.get = function () {
              return this.structure.atomSetDict;
            }, r.biomolDict.get = function () {
              return this.structure.biomolDict;
            }, r.entityList.get = function () {
              return this.structure.entityList;
            }, r.unitcell.get = function () {
              return this.structure.unitcell;
            }, r.frames.get = function () {
              return this.structure.frames;
            }, r.boxes.get = function () {
              return this.structure.boxes;
            }, r.validation.get = function () {
              return this.structure.validation;
            }, r.bondStore.get = function () {
              return this.structure.bondStore;
            }, r.backboneBondStore.get = function () {
              return this.structure.backboneBondStore;
            }, r.rungBondStore.get = function () {
              return this.structure.rungBondStore;
            }, r.atomStore.get = function () {
              return this.structure.atomStore;
            }, r.residueStore.get = function () {
              return this.structure.residueStore;
            }, r.chainStore.get = function () {
              return this.structure.chainStore;
            }, r.modelStore.get = function () {
              return this.structure.modelStore;
            }, r.atomMap.get = function () {
              return this.structure.atomMap;
            }, r.residueMap.get = function () {
              return this.structure.residueMap;
            }, r.bondHash.get = function () {
              return this.structure.bondHash;
            }, r.spatialHash.get = function () {
              return this.structure.spatialHash;
            }, r._hasCoords.get = function () {
              return this.structure._hasCoords;
            }, r._hasCoords.set = function (e) {
              this.structure._hasCoords = e;
            }, n.prototype.refresh = function () {
              t.Debug && Zc.time("StructureView.refresh"), this.atomSetCache = {};
              var e = this.structure;
              if (this.selection.isAllSelection() && e !== this && e.atomSet && e.bondSet) {
                for (var n in this.atomSet = e.atomSet.clone(), this.bondSet = e.bondSet.clone(), this.atomSetDict) {
                  var r = this.atomSetDict[n];
                  this.atomSetCache["__" + n] = r.clone();
                }
                this.atomCount = e.atomCount, this.bondCount = e.bondCount, this.boundingBox.copy(e.boundingBox), this.center.copy(e.center);
              } else if (this.selection.isNoneSelection() && e !== this && e.atomSet && e.bondSet) {
                for (var i in this.atomSet = new tp(e.atomCount), this.bondSet = new tp(e.bondCount), this.atomSetDict) this.atomSetCache["__" + i] = new tp(e.atomCount);
                this.atomCount = 0, this.bondCount = 0, this.boundingBox.makeEmpty(), this.center.set(0, 0, 0);
              } else {
                for (var o in this.atomSet = this.getAtomSet(this.selection, !0), e.atomSet && (this.atomSet = this.atomSet.intersection(e.atomSet)), this.bondSet = this.getBondSet(), this.atomSetDict) {
                  var a = this.atomSetDict[o];
                  this.atomSetCache["__" + o] = a.makeIntersection(this.atomSet);
                }
                this.atomCount = this.atomSet.getSize(), this.bondCount = this.bondSet.getSize(), this.boundingBox = this.getBoundingBox(), this.center = this.boundingBox.getCenter(new ae());
              }
              t.Debug && Zc.timeEnd("StructureView.refresh"), this.signals.refreshed.dispatch();
            }, n.prototype.setSelection = function (e) {
              this.selection = e, this.refresh();
            }, n.prototype.getSelection = function (e) {
              var t = [];
              e && e.string && t.push(e.string);
              var n = this.structure.getSelection();
              n && n.string && t.push(n.string), this.selection && this.selection.string && t.push(this.selection.string);
              var r = "";
              return 0 < t.length && (r = "( " + t.join(" ) AND ( ") + " )"), new Nc(r);
            }, n.prototype.getStructure = function () {
              return this.structure.getStructure();
            }, n.prototype.eachBond = function (e, t) {
              this.structure.eachBond(e, this.getSelection(t));
            }, n.prototype.eachAtom = function (e, t) {
              var n = this.getAtomProxy(),
                r = this.getAtomSet(t),
                i = this.atomStore.count;
              if (r.getSize() < i) r.forEach(function (t) {
                n.index = t, e(n);
              });else for (var o = 0; o < i; ++o) n.index = o, e(n);
            }, n.prototype.eachResidue = function (e, t) {
              this.structure.eachResidue(e, this.getSelection(t));
            }, n.prototype.eachResidueN = function (e, t) {
              console.error("StructureView.eachResidueN() not implemented");
            }, n.prototype.eachChain = function (e, t) {
              this.structure.eachChain(e, this.getSelection(t));
            }, n.prototype.eachModel = function (e, t) {
              this.structure.eachModel(e, this.getSelection(t));
            }, n.prototype.getAtomSet = function (e, t) {
              void 0 === t && (t = !1);
              var n = this.structure.getAtomSet(e);
              return !t && this.atomSet && (n = n.makeIntersection(this.atomSet)), n;
            }, n.prototype.getAtomIndices = function (e) {
              return this.structure.getAtomIndices(this.getSelection(e));
            }, n.prototype.refreshPosition = function () {
              return this.structure.refreshPosition();
            }, n.prototype.dispose = function () {
              this.selection && this.selection.signals.stringChanged.remove(this.refresh, this), this.structure.signals.refreshed.remove(this.refresh, this), delete this.structure, delete this.atomSet, delete this.bondSet, delete this.atomCount, delete this.bondCount;
            }, Object.defineProperties(n.prototype, r), n;
          }(ty);
          function ab(e, t) {
            var n,
              r = 0,
              i = {};
            return t.forEach(function (t) {
              n = 0;
              var o = {};
              t.forEach(function (t) {
                o[e[n++]] = t;
              }), i[e[r++]] = o;
            }), i;
          }
          var sb = {
              blosum62: ab("ARNDCQEGHILKMFPSTWYVBZ?", [[4, -1, -2, -2, 0, -1, -1, 0, -2, -1, -1, -1, -1, -2, -1, 1, 0, -3, -2, 0, -2, -1, 0], [-1, 5, 0, -2, -3, 1, 0, -2, 0, -3, -2, 2, -1, -3, -2, -1, -1, -3, -2, -3, -1, 0, -1], [-2, 0, 6, 1, -3, 0, 0, 0, 1, -3, -3, 0, -2, -3, -2, 1, 0, -4, -2, -3, 3, 0, -1], [-2, -2, 1, 6, -3, 0, 2, -1, -1, -3, -4, -1, -3, -3, -1, 0, -1, -4, -3, -3, 4, 1, -1], [0, -3, -3, -3, 9, -3, -4, -3, -3, -1, -1, -3, -1, -2, -3, -1, -1, -2, -2, -1, -3, -3, -2], [-1, 1, 0, 0, -3, 5, 2, -2, 0, -3, -2, 1, 0, -3, -1, 0, -1, -2, -1, -2, 0, 3, -1], [-1, 0, 0, 2, -4, 2, 5, -2, 0, -3, -3, 1, -2, -3, -1, 0, -1, -3, -2, -2, 1, 4, -1], [0, -2, 0, -1, -3, -2, -2, 6, -2, -4, -4, -2, -3, -3, -2, 0, -2, -2, -3, -3, -1, -2, -1], [-2, 0, 1, -1, -3, 0, 0, -2, 8, -3, -3, -1, -2, -1, -2, -1, -2, -2, 2, -3, 0, 0, -1], [-1, -3, -3, -3, -1, -3, -3, -4, -3, 4, 2, -3, 1, 0, -3, -2, -1, -3, -1, 3, -3, -3, -1], [-1, -2, -3, -4, -1, -2, -3, -4, -3, 2, 4, -2, 2, 0, -3, -2, -1, -2, -1, 1, -4, -3, -1], [-1, 2, 0, -1, -3, 1, 1, -2, -1, -3, -2, 5, -1, -3, -1, 0, -1, -3, -2, -2, 0, 1, -1], [-1, -1, -2, -3, -1, 0, -2, -3, -2, 1, 2, -1, 5, 0, -2, -1, -1, -1, -1, 1, -3, -1, -1], [-2, -3, -3, -3, -2, -3, -3, -3, -1, 0, 0, -3, 0, 6, -4, -2, -2, 1, 3, -1, -3, -3, -1], [-1, -2, -2, -1, -3, -1, -1, -2, -2, -3, -3, -1, -2, -4, 7, -1, -1, -4, -3, -2, -2, -1, -2], [1, -1, 1, 0, -1, 0, 0, 0, -1, -2, -2, 0, -1, -2, -1, 4, 1, -3, -2, -2, 0, 0, 0], [0, -1, 0, -1, -1, -1, -1, -2, -2, -1, -1, -1, -1, -2, -1, 1, 5, -2, -2, 0, -1, -1, 0], [-3, -3, -4, -4, -2, -2, -3, -2, -2, -3, -2, -3, -1, 1, -4, -3, -2, 11, 2, -3, -4, -3, -2], [-2, -2, -2, -3, -2, -1, -2, -3, 2, -1, -1, -2, -1, 3, -3, -2, -2, 2, 7, -1, -3, -2, -1], [0, -3, -3, -3, -1, -2, -2, -3, -3, 3, 1, -2, 1, -1, -2, -2, 0, -3, -1, 4, -3, -2, -1], [-2, -1, 3, 4, -3, 0, 1, -1, 0, -3, -4, 0, -3, -3, -2, 0, -1, -4, -3, -3, 4, 1, -1], [-1, 0, 0, 1, -3, 3, 4, -2, 0, -3, -3, 1, -1, -3, -1, 0, -1, -3, -2, -2, 1, 4, -1], [0, -1, -1, -1, -2, -1, -1, -1, -1, -1, -1, -1, -1, -1, -2, 0, 0, -2, -1, -1, -1, -1, -1]]),
              blosum62x: ab("ACDEFGHIKLMNPQRSTVWY", [[4, 0, -2, -1, -2, 0, -2, -1, -1, -1, -1, -2, -1, -1, -1, 1, 0, 0, -3, -2], [0, 9, -3, -4, -2, -3, -3, -1, -3, -1, -1, -3, -3, -3, -3, -1, -1, -1, -2, -2], [-2, -3, 6, 2, -3, -1, -1, -3, -1, -4, -3, 1, -1, 0, -2, 0, -1, -3, -4, -3], [-1, -4, 2, 5, -3, -2, 0, -3, 1, -3, -2, 0, -1, 2, 0, 0, -1, -2, -3, -2], [-2, -2, -3, -3, 6, -3, -1, 0, -3, 0, 0, -3, -4, -3, -3, -2, -2, -1, 1, 3], [0, -3, -1, -2, -3, 6, -2, -4, -2, -4, -3, 0, -2, -2, -2, 0, -2, -3, -2, -3], [-2, -3, -1, 0, -1, -2, 8, -3, -1, -3, -2, 1, -2, 0, 0, -1, -2, -3, -2, 2], [-1, -1, -3, -3, 0, -4, -3, 4, -3, 2, 1, -3, -3, -3, -3, -2, -1, 3, -3, -1], [-1, -3, -1, 1, -3, -2, -1, -3, 5, -2, -1, 0, -1, 1, 2, 0, -1, -2, -3, -2], [-1, -1, -4, -3, 0, -4, -3, 2, -2, 4, 2, -3, -3, -2, -2, -2, -1, 1, -2, -1], [-1, -1, -3, -2, 0, -3, -2, 1, -1, 2, 5, -2, -2, 0, -1, -1, -1, 1, -1, -1], [-2, -3, 1, 0, -3, 0, 1, -3, 0, -3, -2, 6, -2, 0, 0, 1, 0, -3, -4, -2], [-1, -3, -1, -1, -4, -2, -2, -3, -1, -3, -2, -2, 7, -1, -2, -1, -1, -2, -4, -3], [-1, -3, 0, 2, -3, -2, 0, -3, 1, -2, 0, 0, -1, 5, 1, 0, -1, -2, -2, -1], [-1, -3, -2, 0, -3, -2, 0, -3, 2, -2, -1, 0, -2, 1, 5, -1, -1, -3, -3, -2], [1, -1, 0, 0, -2, 0, -1, -2, 0, -2, -1, 1, -1, 0, -1, 4, 1, -2, -3, -2], [0, -1, -1, -1, -2, -2, -2, -1, -1, -1, -1, 0, -1, -1, -1, 1, 5, 0, -2, -2], [0, -1, -3, -2, -1, -3, -3, 3, -2, 1, 1, -3, -2, -2, -3, -2, 0, 4, -3, -1], [-3, -2, -4, -3, 1, -2, -2, -3, -3, -2, -1, -4, -4, -2, -3, -3, -2, -3, 11, 2], [-2, -2, -3, -2, 3, -3, 2, -1, -2, -1, -1, -2, -3, -1, -2, -2, -2, -1, 2, 7]])
            },
            lb = function lb(e, t, n, r, i) {
              void 0 === n && (n = -10), void 0 === r && (r = -1), void 0 === i && (i = "blosum62"), this.seq1 = e, this.seq2 = t, this.gapPenalty = n, this.gapExtensionPenalty = r, i && (this.substMatrix = sb[i]);
            };
          function ub(e, t, n, r, i) {
            var o, a, s, l, u;
            if (void 0 === n && (n = !1), void 0 === r && (r = ""), void 0 === i && (i = ""), n) {
              var c = e,
                d = t;
              r && i && (c = e.getView(new Nc(r)), d = t.getView(new Nc(i)));
              var h,
                f,
                p = c.getSequence(),
                m = d.getSequence(),
                g = new lb(p.join(""), m.join(""));
              g.calc(), g.trace(), a = o = 0, s = g.ali1.length;
              for (var v = [], y = [], b = 0; b < s; ++b) {
                var _ = g.ali1[b],
                  x = g.ali2[b];
                f = h = 0, "-" === _ ? y[a] = !1 : (y[a] = !0, h = 1), "-" === x ? v[o] = !1 : (v[o] = !0, f = 1), o += h, a += f;
              }
              var w = [],
                S = [],
                A = c.getAtomProxy(),
                E = d.getAtomProxy();
              o = 0, c.eachResidue(function (e) {
                void 0 !== e.traceAtomIndex && e.traceAtomIndex === e.getAtomIndexByName("CA") && (v[o] && (A.index = e.getAtomIndexByName("CA"), w.push(A.x, A.y, A.z)), o += 1);
              }), o = 0, d.eachResidue(function (e) {
                void 0 !== e.traceAtomIndex && e.traceAtomIndex === e.getAtomIndexByName("CA") && (y[o] && (E.index = e.getAtomIndexByName("CA"), S.push(E.x, E.y, E.z)), o += 1);
              }), l = new Float32Array(w), u = new Float32Array(S);
            } else l = e.getView(new Nc(r + " and .CA")), u = t.getView(new Nc(i + " and .CA"));
            var T = new Ky(l, u).transform(e);
            return e.refreshPosition(), T;
          }
          lb.prototype.initMatrices = function () {
            var e = this;
            this.n = this.seq1.length, this.m = this.seq2.length, this.score = void 0, this.ali = "", this.S = [], this.V = [], this.H = [];
            for (var t = 0; t <= this.n; ++t) {
              e.S[t] = [], e.V[t] = [], e.H[t] = [];
              for (var n = 0; n <= this.m; ++n) e.S[t][n] = 0, e.V[t][n] = 0, e.H[t][n] = 0;
            }
            for (var r = 0; r <= this.n; ++r) e.S[r][0] = e.gap(0), e.H[r][0] = -1 / 0;
            for (var i = 0; i <= this.m; ++i) e.S[0][i] = e.gap(0), e.V[0][i] = -1 / 0;
            this.S[0][0] = 0;
          }, lb.prototype.gap = function (e) {
            return this.gapPenalty + e * this.gapExtensionPenalty;
          }, lb.prototype.makeScoreFn = function () {
            var e = this.seq1,
              t = this.seq2,
              n = this.substMatrix;
            return n ? function (r, i) {
              var o = e[r],
                a = t[i];
              try {
                return n[o][a];
              } catch (r) {
                return -4;
              }
            } : (Zc.warn("Alignment: no subst matrix"), function (n, r) {
              return e[n] === t[r] ? 5 : -3;
            });
          }, lb.prototype.calc = function () {
            t.Debug && Zc.time("Alignment.calc"), this.initMatrices();
            for (var e, n, r, i, o, a = this.gap(0), s = this.makeScoreFn(), l = this.gapExtensionPenalty, u = this.V, c = this.H, d = this.S, h = this.n, f = this.m, p = 1; p <= h; ++p) {
              n = d[p - 1], e = u[p - 1], r = u[p], i = c[p], o = d[p];
              for (var m = 1; m <= f; ++m) r[m] = Math.max(n[m] + a, e[m] + l), i[m] = Math.max(o[m - 1] + a, i[m - 1] + l), o[m] = Math.max(n[m - 1] + s(p - 1, m - 1), r[m], i[m]);
            }
            t.Debug && Zc.timeEnd("Alignment.calc"), t.Debug && Zc.log(this.S, this.V, this.H);
          }, lb.prototype.trace = function () {
            var e = this;
            t.Debug && Zc.time("Alignment.trace"), this.ali1 = "", this.ali2 = "";
            var n,
              r = this.makeScoreFn(),
              i = this.n,
              o = this.m;
            for (this.S[i][o] >= this.V[i][o] ? (n = "S", this.score = this.S[i][o]) : this.V[i][o] >= this.H[i][o] ? (n = "V", this.score = this.V[i][o]) : (n = "H", this.score = this.H[i][o]), t.Debug && Zc.log("Alignment: SCORE", this.score), t.Debug && Zc.log("Alignment: S, V, H", this.S[i][o], this.V[i][o], this.H[i][o]); 0 < i && 0 < o;) "S" === n ? e.S[i][o] === e.S[i - 1][o - 1] + r(i - 1, o - 1) ? (e.ali1 = e.seq1[i - 1] + e.ali1, e.ali2 = e.seq2[o - 1] + e.ali2, --i, --o, n = "S") : e.S[i][o] === e.V[i][o] ? n = "V" : e.S[i][o] === e.H[i][o] ? n = "H" : (--i, --o) : "V" === n ? e.V[i][o] === e.V[i - 1][o] + e.gapExtensionPenalty ? (e.ali1 = e.seq1[i - 1] + e.ali1, e.ali2 = "-" + e.ali2, --i, n = "V") : e.V[i][o] === e.S[i - 1][o] + e.gap(0) ? (e.ali1 = e.seq1[i - 1] + e.ali1, e.ali2 = "-" + e.ali2, --i, n = "S") : --i : "H" === n ? e.H[i][o] === e.H[i][o - 1] + e.gapExtensionPenalty ? (e.ali1 = "-" + e.ali1, e.ali2 = e.seq2[o - 1] + e.ali2, --o, n = "H") : e.H[i][o] === e.S[i][o - 1] + e.gap(0) ? (e.ali1 = "-" + e.ali1, e.ali2 = e.seq2[o - 1] + e.ali2, --o, n = "S") : --o : Zc.error("Alignment: no matrix");
            for (; 0 < i;) e.ali1 = e.seq1[i - 1] + e.ali1, e.ali2 = "-" + e.ali2, --i;
            for (; 0 < o;) e.ali1 = "-" + e.ali1, e.ali2 = e.seq2[o - 1] + e.ali2, --o;
            t.Debug && Zc.timeEnd("Alignment.trace"), t.Debug && Zc.log([this.ali1, this.ali2]);
          };
          var cb = Object.assign({
              sele: "",
              defaultAssembly: ""
            }, zy),
            db = function (e) {
              function t(t, n, r) {
                var i, o, a, s;
                void 0 === r && (r = {}), e.call(this, t, n, Object.assign({
                  name: n.name
                }, r)), this.structure = n, this.trajList = [], this.signals = Object.assign(this.signals, {
                  trajectoryAdded: new lc(),
                  trajectoryRemoved: new lc(),
                  defaultAssemblyChanged: new lc()
                }), this.initSelection(this.parameters.sele), this.pickBuffer = (o = i = 0, a = [], {
                  has: function has(e) {
                    return -1 !== a.indexOf(e);
                  },
                  get: function get(e) {
                    return a[e];
                  },
                  push: function push(e) {
                    a[i] = e, i = (4 + i + 1) % 4, ++o;
                  },
                  get count() {
                    return o;
                  },
                  get data() {
                    return a.slice(0, Math.min(o, 4));
                  },
                  clear: function clear() {
                    i = o = 0, a.length = 0;
                  }
                }), this.pickDict = (s = {}, {
                  has: function has(e) {
                    return void 0 !== s[JSON.stringify(e)];
                  },
                  add: function add(e, t) {
                    s[JSON.stringify(e)] = t;
                  },
                  del: function del(e) {
                    delete s[JSON.stringify(e)];
                  },
                  get values() {
                    return Object.keys(s).map(function (e) {
                      return s[e];
                    });
                  }
                }), this.spacefillRepresentation = this.addRepresentation("spacefill", {
                  sele: "none",
                  opacity: Qc.opacity,
                  color: Qc.color,
                  disablePicking: !0,
                  radiusType: "data"
                }, !0), this.distanceRepresentation = this.addRepresentation("distance", Qc, !0), this.angleRepresentation = this.addRepresentation("angle", Qc, !0), this.dihedralRepresentation = this.addRepresentation("dihedral", Qc, !0), this.measureRepresentations = new qy([this.spacefillRepresentation, this.distanceRepresentation, this.angleRepresentation, this.dihedralRepresentation]), this.setDefaultAssembly(this.parameters.defaultAssembly);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                },
                type: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return cb;
              }, n.type.get = function () {
                return "structure";
              }, t.prototype.initSelection = function (e) {
                var t = this;
                this.selection = new Nc(e), this.structureView = new ob(this.structure, this.selection), this.selection.signals.stringChanged.add(function () {
                  t.structureView.setSelection(t.selection), t.rebuildRepresentations(), t.rebuildTrajectories();
                });
              }, t.prototype.setSelection = function (e) {
                return this.parameters.sele = e, this.selection.setString(e), this;
              }, t.prototype.setDefaultAssembly = function (e) {
                if (void 0 === this.structure.biomolDict[e] && (e = ""), this.parameters.defaultAssembly !== e) {
                  var t = {
                    defaultAssembly: e
                  };
                  this.reprList.forEach(function (e) {
                    return e.setParameters(t);
                  }), this.measureRepresentations.setParameters(t), this.parameters.defaultAssembly = e, this.signals.defaultAssemblyChanged.dispatch(e);
                }
                return this;
              }, t.prototype.rebuildRepresentations = function () {
                this.reprList.forEach(function (e) {
                  e.build();
                }), this.measureRepresentations.build();
              }, t.prototype.rebuildTrajectories = function () {
                var e = this;
                this.trajList.forEach(function (t) {
                  t.trajectory.setStructure(e.structureView);
                });
              }, t.prototype.updateRepresentations = function (t) {
                e.prototype.updateRepresentations.call(this, t), this.measureRepresentations.update(t);
              }, t.prototype.addRepresentation = function (e, t, n) {
                var r = this;
                void 0 === t && (t = {}), void 0 === n && (n = !1), t.defaultAssembly = this.parameters.defaultAssembly;
                var i = this._addRepresentation(e, this.structureView, t, n);
                return n || i.signals.parametersChanged.add(function () {
                  return r.measureUpdate();
                }), i;
              }, t.prototype.addTrajectory = function (e, t) {
                var n = this;
                void 0 === e && (e = ""), void 0 === t && (t = {});
                var r,
                  i,
                  o,
                  a = (r = e, i = this.structureView, o = t, r && r instanceof Xy ? new nb(r, i, o) : !r && i.frames ? new rb(r, i, o) : new ib(r, i, o));
                a.signals.frameChanged.add(function () {
                  n.updateRepresentations({
                    position: !0
                  });
                });
                var s = new $y(this.stage, a, t);
                return this.trajList.push(s), this.signals.trajectoryAdded.dispatch(s), s;
              }, t.prototype.removeTrajectory = function (e) {
                var t = this.trajList.indexOf(e);
                -1 !== t && this.trajList.splice(t, 1), e.dispose(), this.signals.trajectoryRemoved.dispatch(e);
              }, t.prototype.dispose = function () {
                this.trajList.slice().forEach(function (e) {
                  return e.dispose();
                }), this.trajList.length = 0, this.structure.dispose(), this.measureRepresentations.dispose(), e.prototype.dispose.call(this);
              }, t.prototype.autoView = function (e, t) {
                "number" == typeof e && (t = e, e = ""), this.stage.animationControls.zoomMove(this.getCenter(e), this.getZoom(e), wu(t, 0));
              }, t.prototype.getBoxUntransformed = function (e) {
                return e ? this.structureView.getBoundingBox(new Nc(e)) : this.structureView.boundingBox;
              }, t.prototype.getCenterUntransformed = function (e) {
                return e && "string" == typeof e ? this.structure.atomCenter(new Nc(e)) : this.structure.center;
              }, t.prototype.superpose = function (e, t, n, r) {
                return ub(this.structureView, e.structureView, t, n, r), this.updateRepresentations({
                  position: !0
                }), this;
              }, t.prototype.getMaxRepresentationRadius = function (e) {
                var t = 0,
                  n = this.structure.getAtomProxy(e);
                return this.eachRepresentation(function (e) {
                  if (e.getVisibility()) {
                    var r = e.repr;
                    t = Math.max(r.getAtomRadius(n), t);
                  }
                }), t;
              }, t.prototype.measurePick = function (e) {
                var t = this.pickBuffer.count;
                if (this.lastPick === e.index && 1 <= t) {
                  if (1 < t) {
                    var n = this.pickBuffer.data,
                      r = this.pickBuffer.data.sort();
                    this.pickDict.has(r) ? this.pickDict.del(r) : this.pickDict.add(r, n), 2 === t ? this.distanceRepresentation.setParameters({
                      atomPair: this.pickDict.values.filter(function (e) {
                        return 2 === e.length;
                      })
                    }) : 3 === t ? this.angleRepresentation.setParameters({
                      atomTriple: this.pickDict.values.filter(function (e) {
                        return 3 === e.length;
                      })
                    }) : 4 === t && this.dihedralRepresentation.setParameters({
                      atomQuad: this.pickDict.values.filter(function (e) {
                        return 4 === e.length;
                      })
                    });
                  }
                  this.pickBuffer.clear(), this.lastPick = void 0;
                } else this.pickBuffer.has(e.index) || this.pickBuffer.push(e.index), this.lastPick = e.index;
                this.measureUpdate();
              }, t.prototype.measureClear = function () {
                this.pickBuffer.clear(), this.lastPick = void 0, this.spacefillRepresentation.setSelection("none");
              }, t.prototype.measureBuild = function () {
                var e = this.measureData();
                this.distanceRepresentation.setParameters({
                  atomPair: e.distance
                }), this.angleRepresentation.setParameters({
                  atomTriple: e.angle
                }), this.dihedralRepresentation.setParameters({
                  atomQuad: e.dihedral
                });
              }, t.prototype.measureUpdate = function () {
                var e = this,
                  t = this.pickBuffer.data,
                  n = {};
                t.forEach(function (t) {
                  var r = Math.max(.1, e.getMaxRepresentationRadius(t));
                  n[t] = r * (2.3 - Ju(.1, 2, r));
                }), this.spacefillRepresentation.setSelection(t.length ? "@" + t.join(",") : "none"), this.spacefillRepresentation.setParameters({
                  radiusData: n
                });
              }, t.prototype.measureData = function () {
                var e = this.pickDict.values;
                return {
                  distance: e.filter(function (e) {
                    return 2 === e.length;
                  }),
                  angle: e.filter(function (e) {
                    return 3 === e.length;
                  }),
                  dihedral: e.filter(function (e) {
                    return 4 === e.length;
                  })
                };
              }, t.prototype.removeAllMeasurements = function (e) {
                var t = this.pickDict,
                  n = t.values,
                  r = function r(e) {
                    n.filter(function (t) {
                      return t.length === e;
                    }).forEach(function (e) {
                      return t.del(e.slice().sort());
                    });
                  };
                (!e || 1 & e) && r(2), (!e || 2 & e) && r(3), (!e || 4 & e) && r(4), this.measureBuild();
              }, t.prototype.removeMeasurement = function (e) {
                this.pickDict.del(e.slice().sort()), this.measureBuild();
              }, t.prototype.addMeasurement = function (e) {
                if (!(e.length < 2 || 4 < e.length)) {
                  var t = e.slice().sort();
                  this.pickDict.has(t) || this.pickDict.add(t, e), this.measureBuild();
                }
              }, Object.defineProperties(t.prototype, n), t;
            }(Uy);
          sd.add("structure", db), sd.add("structureview", db);
          var hb = function (e) {
            function t(t, n, r) {
              void 0 === r && (r = {}), e.call(this, t, n, Object.assign({
                name: n.name
              }, r)), this.surface = n;
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "surface";
            }, t.prototype.addRepresentation = function (e, t) {
              return void 0 === t && (t = {}), this._addRepresentation(e, this.surface, t);
            }, t.prototype.getBoxUntransformed = function () {
              return this.surface.boundingBox;
            }, t.prototype.getCenterUntransformed = function () {
              return this.surface.center;
            }, t.prototype.dispose = function () {
              this.surface.dispose(), e.prototype.dispose.call(this);
            }, Object.defineProperties(t.prototype, n), t;
          }(Uy);
          sd.add("surface", hb);
          var fb = function (e) {
            function t(t, n, r) {
              void 0 === r && (r = {}), e.call(this, t, n, Object.assign({
                name: n.name
              }, r)), this.volume = n;
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "volume";
            }, t.prototype.addRepresentation = function (e, t) {
              return void 0 === t && (t = {}), this._addRepresentation(e, this.volume, t);
            }, t.prototype.getBoxUntransformed = function () {
              return this.volume.boundingBox;
            }, t.prototype.getCenterUntransformed = function () {
              return this.volume.center;
            }, t.prototype.dispose = function () {
              this.volume.dispose(), e.prototype.dispose.call(this);
            }, Object.defineProperties(t.prototype, n), t;
          }(Uy);
          sd.add("volume", fb);
          var pb = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.addRepresentation = function (e, t) {
              return this.forEach(function (n) {
                return n.addRepresentation(e, t);
              });
            }, t.prototype.autoView = function (e) {
              return this.forEach(function (t) {
                return t.autoView(e);
              });
            }, t;
          }(Vy);
          function mb(e, t) {
            return e instanceof RegExp ? null !== t.name.match(e) : t.name === e;
          }
          var gb = new ae(),
            vb = {
              impostor: !0,
              quality: "medium",
              workerDefault: !0,
              sampleLevel: 0,
              backgroundColor: "black",
              rotateSpeed: 2,
              zoomSpeed: 1.2,
              panSpeed: 1,
              clipNear: 0,
              clipFar: 100,
              clipDist: 10,
              clipMode: "scene",
              clipScale: "relative",
              fogNear: 50,
              fogFar: 100,
              fogMode: "scene",
              fogScale: "relative",
              cameraFov: 40,
              cameraEyeSep: .3,
              cameraType: "perspective",
              lightColor: 14540253,
              lightIntensity: 1,
              ambientColor: 14540253,
              ambientIntensity: .2,
              hoverTimeout: 0,
              tooltip: !0,
              mousePreset: "default"
            },
            yb = function yb(e, t) {
              void 0 === t && (t = {}), this.signals = {
                parametersChanged: new lc(),
                fullscreenChanged: new lc(),
                componentAdded: new lc(),
                componentRemoved: new lc(),
                clicked: new lc(),
                hovered: new lc()
              }, this.tasks = new Md(), this.compList = [], this.defaultFileParams = {}, this.logList = [], this.viewer = new yh(e), this.viewer.renderer && (this.tooltip = document.createElement("div"), Object.assign(this.tooltip.style, {
                display: "none",
                position: "fixed",
                zIndex: "1000000",
                pointerEvents: "none",
                backgroundColor: "rgba( 0, 0, 0, 0.6 )",
                color: "lightgrey",
                padding: "8px",
                fontFamily: "sans-serif"
              }), this.viewer.container.appendChild(this.tooltip), this.mouseObserver = new _h(this.viewer.renderer.domElement), this.viewerControls = new qh(this), this.trackballControls = new Oh(this), this.pickingControls = new Lh(this), this.animationControls = new of(this), this.mouseControls = new bg(this), this.keyControls = new wg(this), this.pickingBehavior = new Sg(this), this.mouseBehavior = new Ag(this), this.animationBehavior = new Eg(this), this.keyBehavior = new Mg(this), this.spinAnimation = this.animationControls.spin([0, 1, 0], .005), this.spinAnimation.pause(!0), this.rockAnimation = this.animationControls.rock([0, 1, 0], .005), this.rockAnimation.pause(!0), this.parameters = Su(t, vb), this.setParameters(this.parameters), this.viewer.animate());
            };
          yb.prototype.setParameters = function (e) {
            void 0 === e && (e = {}), Au(this.parameters, e);
            var t = e,
              n = this.parameters,
              r = this.viewer,
              i = this.trackballControls;
            return void 0 !== t.quality && this.setQuality(n.quality), void 0 !== t.impostor && this.setImpostor(n.impostor), void 0 !== t.rotateSpeed && (i.rotateSpeed = n.rotateSpeed), void 0 !== t.zoomSpeed && (i.zoomSpeed = n.zoomSpeed), void 0 !== t.panSpeed && (i.panSpeed = n.panSpeed), void 0 !== t.mousePreset && this.mouseControls.preset(n.mousePreset), this.mouseObserver.setParameters({
              hoverTimeout: n.hoverTimeout
            }), r.setClip(n.clipNear, n.clipFar, n.clipDist, n.clipMode, n.clipScale), r.setFog(void 0, n.fogNear, n.fogFar, n.fogMode, n.fogScale), r.setCamera(n.cameraType, n.cameraFov, n.cameraEyeSep), r.setSampling(n.sampleLevel), r.setBackground(n.backgroundColor), r.setLight(n.lightColor, n.lightIntensity, n.ambientColor, n.ambientIntensity), this.signals.parametersChanged.dispatch(this.getParameters()), this;
          }, yb.prototype.log = function (e) {
            console.log("STAGE LOG", e), this.logList.push(e);
          }, yb.prototype.getParameters = function () {
            return Object.assign({}, this.parameters);
          }, yb.prototype.defaultFileRepresentation = function (e) {
            if (e instanceof db) {
              var n, r, i;
              e.setSelection("/0");
              var o = e.structure;
              if (o.biomolDict.BU1) {
                var a = o.biomolDict.BU1;
                n = a.getAtomCount(o), r = a.getResidueCount(o), i = a.getInstanceCount(), e.setDefaultAssembly("BU1");
              } else n = o.getModelProxy(0).atomCount, r = o.getModelProxy(0).residueCount, i = 1;
              var s = n;
              Xc && (s *= 4);
              var l = o.atomStore.count / o.residueStore.count < 2;
              l && (s *= 10);
              var u = "chainname",
                c = "RdYlBu",
                d = !1;
              if (1 === o.getChainnameCount(new Nc("polymer and /0")) && (u = "residueindex", c = "spectral", d = !0), t.Debug && console.log(s, n, i, l), r / i < 4) e.addRepresentation("ball+stick", {
                colorScheme: "element",
                radiusScale: 2,
                aspectRatio: 1.5,
                bondScale: .3,
                bondSpacing: .75,
                quality: "auto"
              });else if (5 < i && 15e3 < s || 7e5 < s) {
                var h = Math.min(1.5, Math.max(.1, 2e3 / (s / i)));
                l && (h = Math.min(h, .15)), e.addRepresentation("surface", {
                  colorScheme: u,
                  colorScale: c,
                  colorReverse: d,
                  sele: "polymer",
                  surfaceType: "sas",
                  probeRadius: 1.4,
                  scaleFactor: h,
                  useWorker: !1
                });
              } else 25e4 < s ? e.addRepresentation("backbone", {
                colorScheme: u,
                colorScale: c,
                colorReverse: d,
                lineOnly: !0
              }) : 1e5 < s ? e.addRepresentation("backbone", {
                colorScheme: u,
                colorScale: c,
                colorReverse: d,
                quality: "low",
                disableImpostor: !0,
                radiusScale: 2
              }) : 8e4 < s ? e.addRepresentation("backbone", {
                colorScheme: u,
                colorScale: c,
                colorReverse: d,
                radiusScale: 2
              }) : (e.addRepresentation("cartoon", {
                colorScheme: u,
                colorScale: c,
                colorReverse: d,
                radiusScale: .7,
                aspectRatio: 5,
                quality: "auto"
              }), s < 5e4 && e.addRepresentation("base", {
                colorScheme: u,
                colorScale: c,
                colorReverse: d,
                quality: "auto"
              }), e.addRepresentation("ball+stick", {
                sele: "ligand",
                colorScheme: "element",
                radiusScale: 2,
                aspectRatio: 1.5,
                bondScale: .3,
                bondSpacing: .75,
                quality: "auto"
              }));
              e.structure.frames.length && e.addTrajectory();
            } else (e instanceof hb || e instanceof fb) && e.addRepresentation("surface");
            this.tasks.onZeroOnce(this.autoView, this);
          }, yb.prototype.loadFile = function (e, t) {
            var n = this;
            void 0 === t && (t = {});
            var r = Object.assign({}, this.defaultFileParams, t),
              i = vd(e).name;
            this.tasks.increment(), this.log("loading file '" + i + "'");
            var o = wu(r.ext, vd(e).ext);
            return (id.isTrajectory(o) ? Promise.reject(new Error("loadFile: ext '" + o + "' is a trajectory and must be loaded into a structure component")) : bd(e, r)).then(function (e) {
              n.log("loaded '" + i + "'");
              var t = n.addComponentFromObject(e, r);
              return r.defaultRepresentation && n.defaultFileRepresentation(t), n.tasks.decrement(), t;
            }, function (e) {
              n.tasks.decrement();
              var t = "error loading file: '" + e + "'";
              throw n.log(t), t;
            });
          }, yb.prototype.loadScript = function (e) {
            var t = this,
              n = vd(e).name;
            return this.log("loading script '" + n + "'"), bd(e).then(function (e) {
              t.tasks.increment(), t.log("running script '" + n + "'"), e.run(t).then(function () {
                t.tasks.decrement(), t.log("finished script '" + n + "'");
              }), t.log("called script '" + n + "'");
            }, function (e) {
              t.tasks.decrement();
              var r = "errored script '" + n + "' \"" + e + '"';
              throw t.log(r), r;
            });
          }, yb.prototype.addComponent = function (e) {
            e ? (this.compList.push(e), this.signals.componentAdded.dispatch(e)) : Zc.warn("Stage.addComponent: no component given");
          }, yb.prototype.addComponentFromObject = function (e, t) {
            void 0 === t && (t = {});
            var n = sd.get(e.type);
            if (n) {
              var r = new n(this, e, t);
              return this.addComponent(r), r;
            }
            Zc.warn("no component for object type", e.type);
          }, yb.prototype.removeComponent = function (e) {
            var t = this.compList.indexOf(e);
            -1 !== t && (this.compList.splice(t, 1), e.dispose(), this.signals.componentRemoved.dispatch(e));
          }, yb.prototype.removeAllComponents = function () {
            var e = this;
            this.compList.slice().forEach(function (t) {
              return e.removeComponent(t);
            });
          }, yb.prototype.handleResize = function () {
            this.viewer.handleResize();
          }, yb.prototype.setSize = function (e, t) {
            var n = this.viewer.container;
            n !== document.body && (void 0 !== e && (n.style.width = e), void 0 !== t && (n.style.height = t), this.handleResize());
          }, yb.prototype.toggleFullscreen = function (e) {
            if (document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled) {
              var t = this;
              e = e || this.viewer.container, this.lastFullscreenElement = e, n() ? document.exitFullscreen ? document.exitFullscreen() : document.msExitFullscreen ? document.msExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen() : (e.dataset.normalWidth = e.style.width || "", e.dataset.normalHeight = e.style.height || "", e.style.width = window.screen.width + "px", e.style.height = window.screen.height + "px", e.requestFullscreen ? e.requestFullscreen() : e.msRequestFullscreen ? e.msRequestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen && e.webkitRequestFullscreen(), document.addEventListener("fullscreenchange", r), document.addEventListener("mozfullscreenchange", r), document.addEventListener("webkitfullscreenchange", r), document.addEventListener("MSFullscreenChange", r), this.handleResize(), this.signals.fullscreenChanged.dispatch(!0), setTimeout(function () {
                t.handleResize();
              }, 100));
            } else Zc.log("fullscreen mode (currently) not possible");
            function n() {
              return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
            }
            function r() {
              if (!n() && t.lastFullscreenElement) {
                var e = t.lastFullscreenElement;
                e.style.width = e.dataset.normalWidth || "", e.style.height = e.dataset.normalHeight || "", document.removeEventListener("fullscreenchange", r), document.removeEventListener("mozfullscreenchange", r), document.removeEventListener("webkitfullscreenchange", r), document.removeEventListener("MSFullscreenChange", r), t.handleResize(), t.signals.fullscreenChanged.dispatch(!1);
              }
            }
          }, yb.prototype.setSpin = function (e) {
            e ? (this.spinAnimation.resume(!0), this.rockAnimation.pause(!0)) : this.spinAnimation.pause(!0);
          }, yb.prototype.setRock = function (e) {
            e ? (this.rockAnimation.resume(!0), this.spinAnimation.pause(!0)) : this.rockAnimation.pause(!0);
          }, yb.prototype.toggleSpin = function () {
            this.setSpin(this.spinAnimation.paused);
          }, yb.prototype.toggleRock = function () {
            this.setRock(this.rockAnimation.paused);
          }, yb.prototype.setFocus = function (e) {
            var t = Yu(e / 2, 0, 49.9),
              n = 100 - t,
              r = (n - t) / 2;
            "scene" == this.parameters.clipMode && this.setParameters({
              clipNear: t,
              clipFar: n
            }), "scene" == this.parameters.fogMode && this.setParameters({
              fogNear: Ku(n - r),
              fogFar: Ku(n + r)
            });
          }, yb.prototype.getZoomForBox = function (e) {
            var t = e.getSize(gb),
              n = Math.max(t.x, t.y, t.z),
              r = Math.min(t.x, t.y, t.z),
              i = n + Math.sqrt(r),
              o = qu(this.viewer.perspectiveCamera.fov),
              a = this.viewer.width,
              s = this.viewer.height,
              l = s < a ? 1 : a / s;
            return i = Math.abs(.5 * i / l / Math.sin(o / 2)), -(i += this.parameters.clipDist);
          }, yb.prototype.getBox = function () {
            return this.viewer.boundingBox;
          }, yb.prototype.getZoom = function () {
            return this.getZoomForBox(this.getBox());
          }, yb.prototype.getCenter = function (e) {
            return this.getBox().getCenter(e || new ae());
          }, yb.prototype.autoView = function (e) {
            this.animationControls.zoomMove(this.getCenter(), this.getZoom(), wu(e, 0));
          }, yb.prototype.makeImage = function (e) {
            var t = this;
            return void 0 === e && (e = {}), new Promise(function (n, r) {
              t.tasks.onZeroOnce(function () {
                t.tasks.increment(), t.viewer.makeImage(e).then(function (e) {
                  t.tasks.decrement(), n(e);
                }).catch(function (e) {
                  t.tasks.decrement(), r(e);
                });
              });
            });
          }, yb.prototype.setImpostor = function (e) {
            this.parameters.impostor = e;
            var t = ["spacefill", "ball+stick", "licorice", "hyperball", "backbone", "rocket", "helixorient", "contact", "distance", "dot"];
            this.eachRepresentation(function (n) {
              if (t.includes(n.getType())) {
                var r = n.getParameters();
                r.disableImpostor = !e, n.build(r);
              }
            });
          }, yb.prototype.setQuality = function (e) {
            this.parameters.quality = e;
            var t = ["tube", "cartoon", "ribbon", "trace", "rope"],
              n = ["spacefill", "ball+stick", "licorice", "hyperball", "backbone", "rocket", "helixorient", "contact", "distance", "dot"];
            this.eachRepresentation(function (r) {
              var i = r.getParameters();
              if (!t.includes(r.getType())) {
                if (!n.includes(r.getType())) return;
                if (!i.disableImpostor) return void (r.repr.quality = e);
              }
              i.quality = e, r.build(i);
            });
          }, yb.prototype.eachComponent = function (e, t) {
            this.compList.slice().forEach(function (n) {
              void 0 !== t && t !== n.type || e(n);
            });
          }, yb.prototype.eachRepresentation = function (e, t) {
            this.eachComponent(function (n) {
              n.reprList.slice().forEach(function (r) {
                void 0 !== t && t !== r.getType() || e(r, n);
              });
            });
          }, yb.prototype.getComponentsByName = function (e) {
            var t = [];
            return this.eachComponent(function (n) {
              (void 0 === e || mb(e, n)) && t.push(n);
            }), new pb(t);
          }, yb.prototype.getComponentsByObject = function (e) {
            var t = [];
            return this.eachComponent(function (n) {
              n.object === e && t.push(n);
            }), new pb(t);
          }, yb.prototype.getRepresentationsByName = function (e) {
            var t = [];
            return this.eachRepresentation(function (n, r) {
              (void 0 === e || mb(e, n)) && t.push(n);
            }), new qy(t);
          }, yb.prototype.measureClear = function () {
            this.eachComponent(function (e) {
              return e.measureClear();
            }, "structure");
          }, yb.prototype.measureUpdate = function () {
            this.eachComponent(function (e) {
              return e.measureUpdate();
            }, "structure");
          }, yb.prototype.dispose = function () {
            this.tasks.dispose(), this.viewer.dispose();
          };
          var bb = function (e) {
            function t(t, n, r) {
              void 0 === r && (r = {}), e.call(this, t, n, Object.assign({
                name: n.name
              }, r)), this.shape = n;
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "shape";
            }, t.prototype.addRepresentation = function (e, t) {
              return void 0 === t && (t = {}), this._addRepresentation(e, this.shape, t);
            }, t.prototype.getBoxUntransformed = function () {
              return this.shape.boundingBox;
            }, t.prototype.getCenterUntransformed = function () {
              return this.shape.center;
            }, t.prototype.dispose = function () {
              this.shape.dispose(), e.prototype.dispose.call(this);
            }, Object.defineProperties(t.prototype, n), t;
          }(Uy);
          sd.add("shape", bb);
          var _b = function (e) {
            function t(t) {
              var n = this;
              e.call(this, t), t.scale || (this.parameters.scale = "rainbow", this.parameters.reverse = wu(t.reverse, !0)), this.scalePerModel = {}, t.structure.eachModel(function (e) {
                n.parameters.domain = [e.atomOffset, e.atomEnd], n.scalePerModel[e.index] = n.getScale();
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.scalePerModel[e.modelIndex](e.index);
            }, t;
          }(oc);
          td.add("atomindex", _b);
          var xb = function (e) {
            function t(t) {
              if (e.call(this, t), t.scale || (this.parameters.scale = "OrRd"), !t.domain) {
                var n,
                  r = 1 / 0,
                  i = -1 / 0;
                t.sele && (n = new Nc(t.sele)), t.structure.eachAtom(function (e) {
                  var t = e.bfactor;
                  r = Math.min(r, t), i = Math.max(i, t);
                }, n), this.parameters.domain = [r, i];
              }
              this.bfactorScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.bfactorScale(e.bfactor);
            }, t;
          }(oc);
          td.add("bfactor", xb);
          var wb = function (e) {
            function t(t) {
              var n = this;
              e.call(this, t), this.chainidDictPerModel = {}, this.scalePerModel = {}, t.scale || (this.parameters.scale = "Spectral"), t.structure.eachModel(function (e) {
                var t = 0,
                  r = {};
                e.eachChain(function (e) {
                  void 0 === r[e.chainid] && (r[e.chainid] = t, t += 1);
                }), n.parameters.domain = [0, t - 1], n.chainidDictPerModel[e.index] = r, n.scalePerModel[e.index] = n.getScale();
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t = this.chainidDictPerModel[e.modelIndex];
              return this.scalePerModel[e.modelIndex](t[e.chainid]);
            }, t;
          }(oc);
          td.add("chainid", wb);
          var Sb = function (e) {
            function t(t) {
              var n = this;
              e.call(this, t), this.scalePerModel = {}, t.scale || (this.parameters.scale = "Spectral"), t.structure.eachModel(function (e) {
                n.parameters.domain = [e.chainOffset, e.chainEnd], n.scalePerModel[e.index] = n.getScale();
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.scalePerModel[e.modelIndex](e.chainIndex);
            }, t;
          }(oc);
          td.add("chainindex", Sb);
          var Ab = function (e) {
            function t(t) {
              var n = this;
              e.call(this, t), this.chainnameDictPerModel = {}, this.scalePerModel = {}, t.scale || (this.parameters.scale = "Spectral"), t.structure.eachModel(function (e) {
                var t = 0,
                  r = {};
                e.eachChain(function (e) {
                  void 0 === r[e.chainname] && (r[e.chainname] = t, t += 1);
                }), n.parameters.domain = [0, t - 1], n.chainnameDictPerModel[e.index] = r, n.scalePerModel[e.index] = n.getScale();
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t = this.chainnameDictPerModel[e.modelIndex];
              return this.scalePerModel[e.modelIndex](t[e.chainname]);
            }, t;
          }(oc);
          td.add("chainname", Ab);
          var Eb = function (e) {
            function t(t) {
              e.call(this, t), this.rsrzDict = {}, this.rsccDict = {}, t.scale || (this.parameters.scale = "RdYlBu"), this.rsrzScale = this.getScale({
                domain: [2, 0]
              }), this.rsccScale = this.getScale({
                domain: [.678, 1]
              });
              var n = t.structure.validation;
              n && (this.rsrzDict = n.rsrzDict, this.rsccDict = n.rsccDict);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t = e.resno + "";
              e.inscode && (t += "^" + e.inscode), e.chainname && (t += ":" + e.chainname), t += "/" + e.modelIndex;
              var n = this.rsrzDict[t];
              if (void 0 !== n) return this.rsrzScale(n);
              var r = this.rsccDict[t];
              return void 0 !== r ? this.rsccScale(r) : 9474192;
            }, t;
          }(oc);
          td.add("densityfit", Eb);
          var Tb = {
              ARG: {
                CD: .1,
                CZ: .5,
                NE: -.1
              },
              ASN: {
                CG: .55,
                OD1: -.55
              },
              ASP: {
                CB: -.16,
                CG: .36,
                OD1: -.6,
                OD2: -.6
              },
              CYS: {
                CB: .19,
                SG: -.19
              },
              GLN: {
                CD: .55,
                OE1: -.55
              },
              GLU: {
                CD: .36,
                CG: -.16,
                OE1: -.6,
                OE2: -.6
              },
              HIS: {
                CB: .1,
                CD2: .2,
                CE1: .45,
                CG: .15,
                ND1: .05,
                NE2: .05
              },
              LYS: {
                CE: .25,
                NZ: .75
              },
              MET: {
                CE: .06,
                CG: .06,
                SD: -.12
              },
              PTR: {
                C: .55,
                CA: .1,
                CZ: .25,
                N: -.35,
                O: -.55,
                O1P: -.85,
                O2P: -.85,
                O3P: -.85,
                OG1: -1.1,
                P: 1.4
              },
              SEP: {
                C: .55,
                CA: .1,
                CB: .25,
                N: -.35,
                O: -.55,
                O1P: -.85,
                O2P: -.85,
                O3P: -.85,
                OG1: -1.1,
                P: 1.4
              },
              SER: {
                CB: .25,
                OG: -.25
              },
              THR: {
                CB: .25,
                OG1: -.25
              },
              TPO: {
                C: .55,
                CA: .1,
                CB: .25,
                N: -.35,
                O: -.55,
                OG1: -1.1,
                O1P: -.85,
                O2P: -.85,
                O3P: -.85,
                P: 1.4
              },
              TRP: {
                CD1: .06,
                CD2: .1,
                CE2: -.04,
                CE3: -.03,
                CG: -.03,
                NE1: -.06
              },
              TYR: {
                CZ: .25,
                OH: -.25
              },
              backbone: {
                C: .55,
                O: -.55,
                N: -.35,
                CA: .1
              }
            },
            Mb = function (e) {
              function t(t) {
                var n = this;
                e.call(this, t), this.delta = new ae(), this.hCharges = [], t.scale || (this.parameters.scale = "rwb"), t.domain || (this.parameters.domain = [-50, 50]), this.scale = this.getScale(), this.charges = new Float32Array(t.structure.atomCount);
                var r = [];
                t.structure.eachAtom(function (e) {
                  var t;
                  if (n.charges[e.index] = (null !== (t = e).partialCharge ? t.partialCharge : t.isProtein() && (Tb[t.resname] && Tb[t.resname][t.atomname] || Tb.backbone[t.atomname]) || 0) * e.occupancy, "N" === e.atomname) {
                    if (3 <= e.bondCount) return;
                    if (e.bondToElementCount(1)) return;
                    var i = function (e, t) {
                      void 0 === t && (t = new ae());
                      var n = !1,
                        r = !1,
                        i = !1;
                      return t.set(2 * e.x, 2 * e.y, 2 * e.z), e.eachBondedAtom(function (e) {
                        if (!n) return "H" === e.atomname ? (t.set(e.x, e.y, e.z), void (n = !0)) : void (r || "CA" !== e.atomname ? i || "C" !== e.atomname || (i = !0, t.sub(e)) : (t.sub(e), r = !0));
                      }), n ? t : r && i ? (t.normalize(), t.multiplyScalar(1.04), t.add(e), t) : void 0;
                    }(e);
                    void 0 !== i && (r.push(i), n.hCharges.push(.25 * e.occupancy));
                  }
                });
                var i = t.structure.getBoundingBox();
                i.expandByScalar(1.04), this.hStore = function (e) {
                  for (var t = e.length, n = new Float32Array(t), r = new Float32Array(t), i = new Float32Array(t), o = 0; o < e.length; o++) {
                    var a = e[o];
                    n[o] = a.x, r[o] = a.y, i[o] = a.z;
                  }
                  return {
                    x: n,
                    y: r,
                    z: i,
                    count: t
                  };
                }(r), this.hHash = new Zf(this.hStore, i), this.hash = new Zf(t.structure.atomStore, i);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.positionColor = function (e) {
                var t = this.charges,
                  n = this.hCharges,
                  r = 0;
                return this.hash.eachWithin(e.x, e.y, e.z, 12, function (e, n) {
                  var i = t[e];
                  0 !== i && (r += i / n);
                }), this.hHash.eachWithin(e.x, e.y, e.z, 12, function (e, t) {
                  var i = n[e];
                  0 !== i && (r += i / t);
                }), this.scale(332 * r);
              }, t;
            }(oc);
          td.add("electrostatic", Mb);
          var Cb = {
              H: 16777215,
              HE: 14286847,
              LI: 13402367,
              BE: 12779264,
              B: 16758197,
              C: 9474192,
              N: 3166456,
              O: 16715021,
              F: 9494608,
              NE: 11789301,
              NA: 11230450,
              MG: 9109248,
              AL: 12560038,
              SI: 1578e4,
              P: 16744448,
              S: 16777008,
              CL: 2093087,
              AR: 8442339,
              K: 9388244,
              CA: 4062976,
              SC: 15132390,
              TI: 12567239,
              V: 10921643,
              CR: 9083335,
              MN: 10255047,
              FE: 14706227,
              CO: 15765664,
              NI: 5296208,
              CU: 13140019,
              ZN: 8224944,
              GA: 12750735,
              GE: 6721423,
              AS: 12419299,
              SE: 16752896,
              BR: 10889513,
              KR: 6076625,
              RB: 7351984,
              SR: 65280,
              Y: 9764863,
              ZR: 9756896,
              NB: 7586505,
              MO: 5551541,
              TC: 3907230,
              RU: 2396047,
              RH: 687500,
              PD: 27013,
              AG: 12632256,
              CD: 16767375,
              IN: 10909043,
              SN: 6717568,
              SB: 10380213,
              TE: 13924864,
              I: 9699476,
              XE: 9699476,
              CS: 5707663,
              BA: 51456,
              LA: 7394559,
              CE: 16777159,
              PR: 14286791,
              ND: 13107143,
              PM: 10747847,
              SM: 9437127,
              EU: 6422471,
              GD: 4587463,
              TB: 3211207,
              DY: 2097095,
              HO: 65436,
              ER: 58997,
              TM: 54354,
              YB: 48952,
              LU: 43812,
              HF: 5096191,
              TA: 5089023,
              W: 2200790,
              RE: 2522539,
              OS: 2516630,
              IR: 1528967,
              PT: 13684960,
              AU: 16765219,
              HG: 12105936,
              TL: 10900557,
              PB: 5724513,
              BI: 10375093,
              PO: 11230208,
              AT: 7688005,
              RN: 4358806,
              FR: 4325478,
              RA: 32e3,
              AC: 7384058,
              TH: 47871,
              PA: 41471,
              U: 36863,
              NP: 33023,
              PU: 27647,
              AM: 5528818,
              CM: 7888099,
              BK: 9064419,
              CF: 10565332,
              ES: 11739092,
              FM: 11739066,
              MD: 11734438,
              NO: 12389767,
              LR: 13041766,
              RF: 13369433,
              DB: 13697103,
              SG: 14221381,
              BH: 14680120,
              HS: 15073326,
              MT: 15400998,
              DS: 16777215,
              RG: 16777215,
              CN: 16777215,
              UUT: 16777215,
              FL: 16777215,
              UUP: 16777215,
              LV: 16777215,
              UUH: 16777215,
              D: 16777152,
              T: 16777120
            },
            kb = function (e) {
              function t(t) {
                t.value = wu(t.value, Cb.C), e.call(this, t);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
                var t = e.element;
                return "C" === t ? this.parameters.value : Cb[t] || 16777215;
              }, t;
            }(oc);
          td.add("element", kb);
          var Pb = function (e) {
            function t(t) {
              e.call(this, t), t.scale || (this.parameters.scale = "Spectral"), t.domain || (this.parameters.domain = [0, t.structure.entityList.length - 1]), this.entityindexScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.entityindexScale(e.entityIndex);
            }, t;
          }(oc);
          td.add("entityindex", Pb);
          var Ob = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t = e.entity;
              switch (t ? t.entityType : void 0) {
                case 1:
                  return 8374655;
                case 2:
                  return 16629894;
                case 3:
                  return 12496596;
                case 4:
                  return 3697840;
                default:
                  return 16777113;
              }
            }, t;
          }(oc);
          td.add("entitytype", Ob);
          var Rb = function (e) {
            function t(t) {
              e.call(this, t), this.geoAtomDict = {}, this.geoDict = {};
              var n = t.structure.validation;
              n && (this.geoAtomDict = n.geoAtomDict, this.geoDict = n.geoDict);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t,
                n = e.resno + "";
              e.inscode && (n += "^" + e.inscode), e.chainname && (n += ":" + e.chainname), n += "/" + e.modelIndex;
              var r,
                i = this.geoAtomDict[n];
              return void 0 !== i ? (r = i[e.atomname] || 0, t = 16843009 * ((r = (858993459 & (r -= r >> 1 & 1431655765)) + (r >> 2 & 858993459)) + (r >> 4) & 252645135) >> 24) : t = this.geoDict[n] || 0, 0 === t ? 2188972 : 1 === t ? 16703627 : 2 === t ? 16018755 : 3 <= t ? 10813478 : 9474192;
            }, t;
          }(oc);
          td.add("geoquality", Rb);
          var Ib = function (e) {
            function t(t) {
              for (var n in e.call(this, t), this.resHF = {}, t.scale || (this.parameters.scale = "RdYlGn"), bp) this.resHF[n] = bp[n][0];
              if (this.defaultResidueHydrophobicity = _p[0], !t.domain) {
                var r = 1 / 0,
                  i = -1 / 0;
                for (var o in this.resHF) {
                  var a = this.resHF[o];
                  r = Math.min(r, a), i = Math.max(i, a);
                }
                this.parameters.domain = [r, 0, i];
              }
              this.hfScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.hfScale(this.resHF[e.resname] || this.defaultResidueHydrophobicity);
            }, t;
          }(oc);
          td.add("hydrophobicity", Ib);
          var jb = function (e) {
            function t(t) {
              e.call(this, t), t.scale || (this.parameters.scale = "rainbow"), t.domain || (this.parameters.domain = [0, t.structure.modelStore.count]), this.modelindexScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.modelindexScale(e.modelIndex);
            }, t;
          }(oc);
          td.add("modelindex", jb);
          var Nb = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              switch (e.residueType.moleculeType) {
                case 1:
                  return 3697840;
                case 2:
                  return 15729279;
                case 3:
                  return 12496596;
                case 4:
                  return 16629894;
                case 5:
                  return 12540695;
                case 6:
                  return 8374655;
                default:
                  return 16777113;
              }
            }, t;
          }(oc);
          td.add("moleculetype", Nb);
          var Lb = function (e) {
            function t(t) {
              e.call(this, t), t.scale || (this.parameters.scale = "PuBu"), t.domain || (this.parameters.domain = [0, 1]), this.occupancyScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.occupancyScale(e.occupancy);
            }, t;
          }(oc);
          td.add("occupancy", Lb);
          var Db = function (e) {
            function t(t) {
              e.call(this, t), t.scale || (this.parameters.scale = "rwb"), t.domain || (this.parameters.domain = [-1, 1]), this.partialchargeScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.partialchargeScale(e.partialCharge || 0);
            }, t;
          }(oc);
          function Bb() {
            return 16777215 * Math.random();
          }
          td.add("partialcharge", Db);
          var Fb = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function () {
              return Bb();
            }, t.prototype.volumeColor = function () {
              return Bb();
            }, t.prototype.positionColor = function () {
              return Bb();
            }, t;
          }(oc);
          td.add("random", Fb);
          var zb = function (e) {
            function t(t) {
              e.call(this, t), this.rciDict = {}, t.scale || (this.parameters.scale = "RdYlBu"), this.rciScale = this.getScale({
                domain: [.6, 0]
              });
              var n = t.structure.validation;
              n && (this.rciDict = n.rciDict);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t = "[" + e.resname + "]" + e.resno;
              e.chainname && (t += ":" + e.chainname);
              var n = this.rciDict[t];
              return void 0 !== n ? this.rciScale(n) : 9474192;
            }, t;
          }(oc);
          td.add("randomcoilindex", zb);
          var Ub = function (e) {
            function t(t) {
              var n = this;
              e.call(this, t), this.scalePerChain = {}, t.scale || (this.parameters.scale = "rainbow", this.parameters.reverse = wu(t.reverse, !0)), t.structure.eachChain(function (e) {
                n.parameters.domain = [e.residueOffset, e.residueEnd], n.scalePerChain[e.index] = n.getScale();
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              return this.scalePerChain[e.chainIndex](e.residueIndex);
            }, t;
          }(oc);
          td.add("residueindex", Ub);
          var Gb = {
              ALA: 9240460,
              ARG: 124,
              ASN: 16743536,
              ASP: 10485826,
              CYS: 16777072,
              GLN: 16731212,
              GLU: 6684672,
              GLY: 16777215,
              HIS: 7368959,
              ILE: 19456,
              LEU: 4546117,
              LYS: 4671416,
              MET: 12099650,
              PHE: 5459026,
              PRO: 5395026,
              SER: 16740418,
              THR: 12078080,
              TRP: 5195264,
              TYR: 9203788,
              VAL: 16747775,
              ASX: 16711935,
              GLX: 16711935,
              ASH: 16711935,
              GLH: 16711935,
              A: 14423100,
              G: 3329330,
              I: 10145074,
              X: 8190976,
              C: 16766720,
              T: 4286945,
              U: 4251856,
              D: 35723,
              DA: 14423100,
              DG: 3329330,
              DI: 10145074,
              DX: 8190976,
              DC: 16766720,
              DT: 4286945,
              DU: 4251856,
              DD: 35723
            },
            Vb = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
                return Gb[e.resname] || 16711935;
              }, t;
            }(oc);
          td.add("resname", Vb);
          var Hb = function (e) {
            function t(t) {
              e.call(this, t), this.residueProxy = t.structure.getResidueProxy();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function (e) {
              var t = e.sstruc,
                n = this.residueProxy;
              return "h" === t ? 16711808 : "g" === t ? 10485888 : "i" === t ? 6291584 : "e" === t || "b" === t ? 16762880 : "t" === t ? 6324479 : (n.index = e.residueIndex, n.isDna() ? 11403518 : n.isRna() ? 16580962 : n.isSaccharide() ? 10921722 : n.isProtein() || "s" === t || "l" === t ? 16777215 : 8421504);
            }, t;
          }(oc);
          td.add("sstruc", Hb);
          var qb = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.atomColor = function () {
              return this.parameters.value;
            }, t.prototype.bondColor = function () {
              return this.parameters.value;
            }, t.prototype.valueColor = function () {
              return this.parameters.value;
            }, t.prototype.volumeColor = function () {
              return this.parameters.value;
            }, t;
          }(oc);
          td.add("uniform", qb);
          var Wb = function (e) {
            function t(t) {
              e.call(this, t), this.valueScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.volumeColor = function (e) {
              return this.valueScale(this.parameters.volume.data[e]);
            }, t;
          }(oc);
          td.add("value", Wb);
          var $b = function (e) {
            function t(t) {
              e.call(this, t), this.vec = new ae(), this.valueScale = this.getScale();
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.positionColor = function (e) {
              var t = this.parameters.volume;
              if (!t || !t.inverseMatrix) return this.parameters.value;
              var n = this.vec,
                r = t.data,
                i = t.nx,
                o = t.ny,
                a = i * o;
              n.copy(e), n.applyMatrix4(t.inverseMatrix);
              var s = Math.floor(n.x),
                l = Math.floor(n.y),
                u = Math.floor(n.z),
                c = (u * o + l) * i + s,
                d = c + 1,
                h = c + i,
                f = c + a,
                p = h + 1,
                m = f + 1,
                g = h + a,
                v = g + 1,
                y = r[c],
                b = r[d],
                _ = r[h],
                x = r[f],
                w = r[p],
                S = r[m],
                A = r[g],
                E = r[v],
                T = n.x - s,
                M = n.y - l,
                C = n.z - u,
                k = Zu(y, b, T),
                P = Zu(x, S, T),
                O = Zu(_, w, T),
                R = Zu(A, E, T),
                I = Zu(Zu(k, O, M), Zu(P, R, M), C);
              return this.valueScale(I);
            }, t;
          }(oc);
          td.add("volume", $b);
          var Xb = function (e) {
              function t(t, n, r) {
                var i = r || {};
                if (e.call(this, t, n, i), this.type = "structure", this.parameters = Object.assign({
                  radiusType: {
                    type: "select",
                    options: Ng.types
                  },
                  radiusData: {
                    type: "hidden"
                  },
                  radiusSize: {
                    type: "number",
                    precision: 3,
                    max: 10,
                    min: .001
                  },
                  radiusScale: {
                    type: "number",
                    precision: 3,
                    max: 10,
                    min: .001
                  },
                  assembly: null,
                  defaultAssembly: {
                    type: "hidden"
                  }
                }, this.parameters), this.selection = new Nc(i.sele), this.dataList = [], this.structure = t, this.structureView = this.structure.getView(this.selection), t.biomolDict) {
                  var o = {
                    default: "default",
                    "": t.unitcell ? "AU" : "FULL"
                  };
                  Object.keys(t.biomolDict).forEach(function (e) {
                    o[e] = e;
                  }), this.parameters.assembly = {
                    type: "select",
                    options: o,
                    rebuild: !0
                  };
                } else this.parameters.assembly = null;
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultScale: {
                  configurable: !0
                }
              };
              return n.defaultScale.get = function () {
                return {
                  vdw: 1,
                  covalent: 1,
                  bfactor: .01,
                  sstruc: 1
                };
              }, t.prototype.init = function (t) {
                var n = this,
                  r = t || {};
                r.colorScheme = wu(r.colorScheme, "element"), this.setRadius(r.radius, r), this.radiusType = wu(r.radiusType, "vdw"), this.radiusData = wu(r.radiusData, {}), this.radiusSize = wu(r.radiusSize, 1), this.radiusScale = wu(r.radiusScale, 1), this.assembly = wu(r.assembly, "default"), this.defaultAssembly = wu(r.defaultAssembly, ""), "auto" === r.quality && (r.quality = this.getQuality()), e.prototype.init.call(this, r), this.selection.signals.stringChanged.add(function () {
                  n.build();
                }), this.build();
              }, t.prototype.setRadius = function (e, t) {
                var n = Object.keys(jg);
                return "string" == typeof e && n.includes(e.toLowerCase()) ? t.radiusType = e : void 0 !== e && (t.radiusType = "size", t.radiusSize = e), this;
              }, t.prototype.getAssembly = function () {
                var e = "default" === this.assembly ? this.defaultAssembly : this.assembly;
                return this.structure.biomolDict[e];
              }, t.prototype.getQuality = function () {
                var e,
                  t = this.structureView,
                  n = this.getAssembly();
                return e = n ? n.getAtomCount(t) : t.atomCount, Xc && (e *= 4), t.atomStore.count / t.residueStore.count < 2 && (e *= 10), e < 15e3 ? "high" : e < 8e4 ? "medium" : "low";
              }, t.prototype.create = function () {
                var e = this;
                if (0 !== this.structureView.atomCount) if (this.structureView.hasCoords()) {
                  this.needsBuild = !1;
                  var t = this.getAssembly();
                  if (t) t.partList.forEach(function (t, n) {
                    var r = t.getView(e.structureView);
                    if (0 !== r.atomCount) {
                      var i = e.createData(r, n);
                      i && (i.sview = r, i.instanceList = t.getInstanceList(), e.dataList.push(i));
                    }
                  });else {
                    var n = this.createData(this.structureView, 0);
                    n && (n.sview = this.structureView, this.dataList.push(n));
                  }
                } else this.needsBuild = !0;
              }, t.prototype.update = function (e) {
                var t = this;
                !this.lazy || this.visible ? this.needsBuild ? this.build() : this.dataList.forEach(function (n) {
                  0 < n.bufferList.length && t.updateData(e, n);
                }, this) : Object.assign(this.lazyProps.what, e);
              }, t.prototype.updateData = function (e, t) {
                this.build();
              }, t.prototype.getColorParams = function () {
                return Object.assign({}, e.prototype.getColorParams.call(this), {
                  structure: this.structure
                });
              }, t.prototype.getRadiusParams = function (e) {
                return {
                  type: this.radiusType,
                  scale: this.radiusScale,
                  size: this.radiusSize,
                  data: this.radiusData
                };
              }, t.prototype.getAtomParams = function (e, t) {
                return Object.assign({
                  what: e,
                  colorParams: this.getColorParams(),
                  radiusParams: this.getRadiusParams()
                }, t);
              }, t.prototype.getBondParams = function (e, t) {
                return Object.assign({
                  what: e,
                  colorParams: this.getColorParams(),
                  radiusParams: this.getRadiusParams()
                }, t);
              }, t.prototype.getAtomRadius = function (e) {
                return this.structureView.atomSet.isSet(e.index) ? new Ng(this.getRadiusParams()).atomRadius(e) : 0;
              }, t.prototype.setSelection = function (e, t) {
                return this.selection.setString(e, t), this;
              }, t.prototype.setParameters = function (t, n, r) {
                void 0 === n && (n = {}), void 0 === r && (r = !1);
                var i = t || {};
                return this.setRadius(i.radius, i), void 0 === i.radiusType && void 0 === i.radiusData && void 0 === i.radiusSize && void 0 === i.radiusScale || (n.radius = !0, Kc && !this.disableImpostor || (r = !0)), void 0 !== i.defaultAssembly && i.defaultAssembly !== this.defaultAssembly && ("default" === this.assembly && void 0 === i.assembly || "default" === i.assembly) && (r = !0), e.prototype.setParameters.call(this, i, n, r), this;
              }, t.prototype.getParameters = function () {
                return Object.assign(e.prototype.getParameters.call(this), {
                  sele: this.selection ? this.selection.string : void 0,
                  defaultAssembly: this.defaultAssembly
                });
              }, t.prototype.attach = function (e) {
                var t = this.viewer,
                  n = this.bufferList;
                this.dataList.forEach(function (e) {
                  e.bufferList.forEach(function (r) {
                    n.push(r), t.add(r, e.instanceList);
                  });
                }), this.setVisibility(this.visible), e();
              }, t.prototype.clear = function () {
                this.dataList.length = 0, e.prototype.clear.call(this);
              }, t.prototype.dispose = function () {
                this.structureView.dispose(), delete this.structure, delete this.structureView, e.prototype.dispose.call(this);
              }, Object.defineProperties(t.prototype, n), t;
            }(lf),
            Yb = function (e) {
              function t(t, n, r) {
                e.call(this, t, n, r), this.n = 0, this.parameters = Object.assign({
                  labelVisible: {
                    type: "boolean"
                  },
                  labelSize: {
                    type: "number",
                    precision: 3,
                    max: 10,
                    min: .001
                  },
                  labelColor: {
                    type: "color"
                  },
                  labelFontFamily: {
                    type: "select",
                    options: {
                      "sans-serif": "sans-serif",
                      monospace: "monospace",
                      serif: "serif"
                    },
                    buffer: "fontFamily"
                  },
                  labelFontStyle: {
                    type: "select",
                    options: {
                      normal: "normal",
                      italic: "italic"
                    },
                    buffer: "fontStyle"
                  },
                  labelFontWeight: {
                    type: "select",
                    options: {
                      normal: "normal",
                      bold: "bold"
                    },
                    buffer: "fontWeight"
                  },
                  labelsdf: {
                    type: "boolean",
                    buffer: "sdf"
                  },
                  labelXOffset: {
                    type: "number",
                    precision: 1,
                    max: 20,
                    min: -20,
                    buffer: "xOffset"
                  },
                  labelYOffset: {
                    type: "number",
                    precision: 1,
                    max: 20,
                    min: -20,
                    buffer: "yOffset"
                  },
                  labelZOffset: {
                    type: "number",
                    precision: 1,
                    max: 20,
                    min: -20,
                    buffer: "zOffset"
                  },
                  labelAttachment: {
                    type: "select",
                    options: {
                      "bottom-left": "bottom-left",
                      "bottom-center": "bottom-center",
                      "bottom-right": "bottom-right",
                      "middle-left": "middle-left",
                      "middle-center": "middle-center",
                      "middle-right": "middle-right",
                      "top-left": "top-left",
                      "top-center": "top-center",
                      "top-right": "top-right"
                    },
                    rebuild: !0
                  },
                  labelBorder: {
                    type: "boolean",
                    buffer: "showBorder"
                  },
                  labelBorderColor: {
                    type: "color",
                    buffer: "borderColor"
                  },
                  labelBorderWidth: {
                    type: "number",
                    precision: 2,
                    max: .3,
                    min: 0,
                    buffer: "borderWidth"
                  },
                  labelBackground: {
                    type: "boolean",
                    rebuild: !0
                  },
                  labelBackgroundColor: {
                    type: "color",
                    buffer: "backgroundColor"
                  },
                  labelBackgroundMargin: {
                    type: "number",
                    precision: 2,
                    max: 2,
                    min: 0,
                    rebuild: !0
                  },
                  labelBackgroundOpacity: {
                    type: "range",
                    step: .01,
                    max: 1,
                    min: 0,
                    buffer: "backgroundOpacity"
                  },
                  labelFixedSize: {
                    type: "boolean",
                    buffer: "fixedSize"
                  },
                  lineOpacity: {
                    type: "range",
                    min: 0,
                    max: 1,
                    step: .01
                  },
                  linewidth: {
                    type: "integer",
                    max: 50,
                    min: 1,
                    buffer: !0
                  }
                }, this.parameters, {
                  flatShaded: null
                });
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
                var n = t || {};
                this.labelVisible = wu(n.labelVisible, !0), this.labelSize = wu(n.labelSize, 2), this.labelColor = wu(n.labelColor, 16777215), this.labelFontFamily = wu(n.labelFontFamily, "sans-serif"), this.labelFontStyle = wu(n.labelFontstyle, "normal"), this.labelFontWeight = wu(n.labelFontWeight, "bold"), this.labelsdf = wu(n.labelsdf, "Chrome" === Hc), this.labelXOffset = wu(n.labelXOffset, 0), this.labelYOffset = wu(n.labelYOffset, 0), this.labelZOffset = wu(n.labelZOffset, .5), this.labelAttachment = wu(n.labelAttachment, "bottom-left"), this.labelBorder = wu(n.labelBorder, !1), this.labelBorderColor = wu(n.labelBorderColor, "lightgrey"), this.labelBorderWidth = wu(n.labelBorderWidth, .15), this.labelBackground = wu(n.labelBackground, !1), this.labelBackgroundColor = wu(n.labelBackgroundColor, "lightgrey"), this.labelBackgroundMargin = wu(n.labelBackgroundMargin, .5), this.labelBackgroundOpacity = wu(n.labelBackgroundOpacity, 1), this.labelFixedSize = wu(n.labelFixedSize, !1), this.lineOpacity = wu(n.lineOpacity, 1), this.linewidth = wu(n.linewidth, 2), e.prototype.init.call(this, n);
              }, t.prototype.update = function (t) {
                t.position ? this.build() : e.prototype.update.call(this, t);
              }, t.prototype.updateData = function (e, t) {
                var n = {};
                if (e && !e.labelSize || Object.assign(n, {
                  size: Hd(this.n, this.labelSize)
                }), !e || e.labelColor) {
                  var r = new Fe(this.labelColor);
                  Object.assign(n, {
                    color: qd(this.n, r.r, r.g, r.b)
                  });
                }
                this.textBuffer.setAttributes(n);
              }, t.prototype.setParameters = function (t, n, r) {
                return void 0 === n && (n = {}), void 0 === r && (r = !1), t && t.labelSize && (n.labelSize = !0), t && (t.labelColor || 0 === t.labelColor) && (n.labelColor = !0), e.prototype.setParameters.call(this, t, n, r), t && void 0 !== t.opacity && this.textBuffer.setParameters({
                  opacity: 1
                }), t && void 0 !== t.labelVisible && this.setVisibility(this.visible), this;
              }, t.prototype.setVisibility = function (t, n) {
                return e.prototype.setVisibility.call(this, t, !0), this.textBuffer && this.textBuffer.setVisibility(this.labelVisible && this.visible), n || this.viewer.requestRender(), this;
              }, t.prototype.getLabelBufferParams = function (t) {
                return void 0 === t && (t = {}), e.prototype.getBufferParams.call(this, Object.assign({
                  fontFamily: this.labelFontFamily,
                  fontStyle: this.labelFontStyle,
                  fontWeight: this.labelFontWeight,
                  sdf: this.labelsdf,
                  xOffset: this.labelXOffset,
                  yOffset: this.labelYOffset,
                  zOffset: this.labelZOffset,
                  attachment: this.labelAttachment,
                  showBorder: this.labelBorder,
                  borderColor: this.labelBorderColor,
                  borderWidth: this.labelBorderWidth,
                  showBackground: this.labelBackground,
                  backgroundColor: this.labelBackgroundColor,
                  backgroundMargin: this.labelBackgroundMargin,
                  backgroundOpacity: this.labelBackgroundOpacity,
                  fixedSize: this.labelFixedSize,
                  disablePicking: !0,
                  visible: this.labelVisible
                }, t, {
                  opacity: 1
                }));
              }, t.prototype.getAtomRadius = function () {
                return 0;
              }, t;
            }(Xb);
          function Kb(e, t) {
            var n = e.getAtomProxy(),
              r = new Nc(),
              i = t.length;
            if (0 === i) return new Float32Array(0);
            var o = t[0].length,
              a = e.getAtomSet(),
              s = new Float32Array(i * o * 3),
              l = 0;
            return t.forEach(function (t) {
              for (var i = !1, u = 0; u < o; u++) {
                var c = t[u];
                if ("number" == typeof c && Number.isInteger(c)) {
                  if (!a.get(c)) {
                    i = !0;
                    break;
                  }
                  n.index = c;
                } else {
                  r.setString(c);
                  var d = e.getAtomIndices(r);
                  if (!d.length) {
                    i = !0;
                    break;
                  }
                  n.index = d[0];
                }
                var h = l + 3 * u;
                s[h++] = n.x, s[h++] = n.y, s[h++] = n.z;
              }
              i || (l += 3 * o);
            }), s.subarray(0, l);
          }
          function Zb(e, t, n, r, i) {
            var o = Math.cos(i),
              a = Math.sin(i);
            e[0] = t[0] + n[0] * o + r[0] * a, e[1] = t[1] + n[1] * o + r[1] * a, e[2] = t[2] + n[2] * o + r[2] * a;
          }
          function Qb(e, t, n, r, i, o, a) {
            for (var s = 0; s < t; s++) {
              for (var l = 0; l < n; l++) r[l] = e[l * t + s];
              Jb(r, i, o, a, n);
              for (var u = 0; u < n; u++) e[u * t + s] = i[u];
            }
            for (var c = 0; c < n; c++) {
              for (var d = 0; d < t; d++) r[d] = e[c * t + d];
              Jb(r, i, o, a, t);
              for (var h = 0; h < t; h++) e[c * t + h] = Math.sqrt(i[h]);
            }
          }
          function Jb(e, t, n, r, i) {
            r[n[0] = 0] = Number.MIN_SAFE_INTEGER, r[1] = Number.MAX_SAFE_INTEGER;
            for (var o = 1, a = 0; o < i; o++) {
              for (var s = (e[o] + o * o - (e[n[a]] + n[a] * n[a])) / (2 * o - 2 * n[a]); s <= r[a];) a--, s = (e[o] + o * o - (e[n[a]] + n[a] * n[a])) / (2 * o - 2 * n[a]);
              n[++a] = o, r[a] = s, r[a + 1] = Number.MAX_SAFE_INTEGER;
            }
            for (var l = 0, u = 0; l < i; l++) {
              for (; r[u + 1] < l;) u++;
              t[l] = (l - n[u]) * (l - n[u]) + e[n[u]];
            }
          }
          od.add("shader/SDFFont.vert", "uniform float clipNear;\nuniform float clipRadius;\nuniform vec3 clipCenter;\nuniform float xOffset;\nuniform float yOffset;\nuniform float zOffset;\nuniform bool ortho;\nuniform float canvasHeight;\nuniform float pixelRatio;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || ( !defined( PICKING ) && !defined( NOLIGHT ) )\nvarying vec3 vViewPosition;\n#endif\nvarying vec2 texCoord;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#if defined( PICKING )\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\n#include color_pars_vertex\n#endif\nattribute vec2 mapping;\nattribute vec2 inputTexCoord;\nattribute float inputSize;\n#include matrix_scale\n#include common\nvoid main(void){\n#if defined( PICKING )\nvPickingColor = unpackColor( primitiveId );\n#else\n#include color_vertex\n#endif\ntexCoord = inputTexCoord;\nfloat scale = matrixScale( modelViewMatrix );\nfloat _xOffset = xOffset * scale;\nfloat _yOffset = yOffset * scale;\nfloat _zOffset = zOffset * scale;\nif( texCoord.x == 10.0 ){\n_zOffset -= 0.001;\n}\nvec4 cameraPos = modelViewMatrix * vec4( position, 1.0 );\n#ifdef FIXED_SIZE\nif ( ortho ) {\nscale /= pixelRatio * (( canvasHeight / 2.0 ) / -cameraPosition.z) * 0.1;\n} else {\nscale /= pixelRatio * (( canvasHeight / 2.0 ) / -cameraPos.z) * 0.1;\n}\n#endif\nvec4 cameraCornerPos = vec4( cameraPos.xyz, 1.0 );\ncameraCornerPos.xy += mapping * inputSize * 0.01 * scale;\ncameraCornerPos.x += _xOffset;\ncameraCornerPos.y += _yOffset;\nif( ortho ){\ncameraCornerPos.xyz += normalize( -cameraPosition ) * _zOffset;\n} else {\ncameraCornerPos.xyz += normalize( -cameraCornerPos.xyz ) * _zOffset;\n}\ngl_Position = projectionMatrix * cameraCornerPos;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || ( !defined( PICKING ) && !defined( NOLIGHT ) )\nvViewPosition = -cameraCornerPos.xyz;\n#endif\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n#include nearclip_vertex\n#include radiusclip_vertex\n}"), od.add("shader/SDFFont.frag", "uniform sampler2D fontTexture;\nuniform float opacity;\nuniform bool showBorder;\nuniform vec3 borderColor;\nuniform float borderWidth;\nuniform vec3 backgroundColor;\nuniform float backgroundOpacity;\nuniform float clipNear;\nuniform float clipRadius;\nvarying vec3 vViewPosition;\nvarying vec2 texCoord;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#if defined( PICKING )\nuniform float objectId;\nvarying vec3 vPickingColor;\nconst vec3 vColor = vec3( 0.0 );\n#else\n#include common\n#include color_pars_fragment\n#include fog_pars_fragment\n#endif\nconst float gamma = 2.2 * 1.4142 / 128.0;\nconst float padding = 0.75;\nvoid main(){\n#include nearclip_fragment\n#include radiusclip_fragment\nif( texCoord.x > 1.0 ){\ngl_FragColor = vec4( backgroundColor, backgroundOpacity );\n}else{\nfloat sdf = texture2D( fontTexture, texCoord ).a;\nif( showBorder ) sdf += borderWidth;\nfloat a = smoothstep(padding - gamma, padding + gamma, sdf);\nif( a < 0.2 ) discard;\na *= opacity;\nvec3 outgoingLight = vColor;\nif( showBorder && sdf < ( padding + borderWidth ) ){\noutgoingLight = borderColor;\n}\ngl_FragColor = vec4( outgoingLight, a );\n}\n#if defined( PICKING )\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#else\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#endif\n}");
          var e_ = {},
            t_ = {
              font: "sans-serif",
              size: 36,
              style: "normal",
              variant: "normal",
              weight: "normal",
              outline: 3,
              width: 1024,
              height: 1024
            },
            n_ = function n_(e) {
              void 0 === e && (e = {}), this.gamma = 1, this.mapped = {}, this.scratchW = 0, this.scratchH = 0, this.currentX = 0, this.currentY = 0, this.cutoff = .25, this.parameters = Su(e, t_);
              var t = this.parameters;
              this.radius = t.size / 8, this.padding = t.size / 3;
              var n = this.lineHeight = t.size + 2 * t.outline + Math.round(t.size / 4),
                r = this.maxWidth = t.width / 4,
                i = this.canvas = document.createElement("canvas");
              i.width = r, i.height = n;
              var o = this.context = this.canvas.getContext("2d");
              o.font = t.style + " " + t.variant + " " + t.weight + " " + t.size + "px " + t.font, o.fillStyle = "black", o.textAlign = "left", o.textBaseline = "bottom", o.lineJoin = "round", this.gridOuter = new Float64Array(n * r), this.gridInner = new Float64Array(n * r), this.f = new Float64Array(Math.max(n, r)), this.d = new Float64Array(Math.max(n, r)), this.z = new Float64Array(Math.max(n, r) + 1), this.v = new Int16Array(Math.max(n, r)), this.data = new Uint8Array(t.width * t.height * 4), this.canvas2 = document.createElement("canvas"), this.canvas2.width = t.width, this.canvas2.height = t.height, this.context2 = this.canvas2.getContext("2d"), this.placeholder = this.map(String.fromCharCode(65533));
              for (var a = 32; a <= 126; ++a) this.map(String.fromCharCode(a));
              this.map(String.fromCharCode(176)), this.map(String.fromCharCode(8491)), this.texture = new Wi(this.canvas2), this.texture.flipY = !1, this.texture.needsUpdate = !0;
            };
          n_.prototype.map = function (e) {
            var t = this.parameters;
            return void 0 === this.mapped[e] && (this.draw(e), this.currentX + this.scratchW > t.width && (this.currentX = 0, this.currentY += this.scratchH), this.currentY + this.scratchH > t.height && console.warn("canvas to small"), this.mapped[e] = {
              x: this.currentX,
              y: this.currentY,
              w: this.scratchW,
              h: this.scratchH
            }, this.context2.drawImage(this.canvas, 0, 0, this.scratchW, this.scratchH, this.currentX, this.currentY, this.scratchW, this.scratchH), this.currentX += this.scratchW), this.mapped[e];
          }, n_.prototype.get = function (e) {
            return this.mapped[e] || this.placeholder;
          }, n_.prototype.draw = function (e) {
            var t = this.parameters,
              n = this.lineHeight,
              r = t.outline,
              i = this.context,
              o = this.maxWidth,
              a = r,
              s = n - t.outline,
              l = i.measureText(e),
              u = Math.min(o, Math.ceil(l.width + 2 * a + 1)),
              c = u * n;
            i.clearRect(0, 0, u, n), i.fillText(e, a, s);
            for (var d = i.getImageData(0, 0, u, n), h = d.data, f = 0; f < c; f++) {
              var p = d.data[4 * f + 3] / 255;
              this.gridOuter[f] = 1 === p ? 0 : 0 === p ? Number.MAX_SAFE_INTEGER : Math.pow(Math.max(0, .5 - p), 2), this.gridInner[f] = 1 === p ? Number.MAX_SAFE_INTEGER : 0 === p ? 0 : Math.pow(Math.max(0, p - .5), 2);
            }
            Qb(this.gridOuter, u, n, this.f, this.d, this.v, this.z), Qb(this.gridInner, u, n, this.f, this.d, this.v, this.z);
            for (var m = 0; m < c; m++) {
              var g = this.gridOuter[m] - this.gridInner[m];
              h[4 * m + 3] = Math.max(0, Math.min(255, Math.round(255 - 255 * (g / this.radius + this.cutoff))));
            }
            i.putImageData(d, 0, 0), this.scratchW = u, this.scratchH = n;
          };
          var r_ = Object.assign({
              fontFamily: "sans-serif",
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: 36,
              xOffset: 0,
              yOffset: 0,
              zOffset: .5,
              attachment: "bottom-left",
              showBorder: !1,
              borderColor: "lightgrey",
              borderWidth: .15,
              showBackground: !1,
              backgroundColor: "lightgrey",
              backgroundMargin: .5,
              backgroundOpacity: 1,
              forceTransparent: !0,
              fixedSize: !1
            }, ig),
            i_ = Object.assign({
              fontFamily: {
                uniform: !0
              },
              fontStyle: {
                uniform: !0
              },
              fontWeight: {
                uniform: !0
              },
              fontSize: {
                uniform: !0
              },
              xOffset: {
                uniform: !0
              },
              yOffset: {
                uniform: !0
              },
              zOffset: {
                uniform: !0
              },
              showBorder: {
                uniform: !0
              },
              borderColor: {
                uniform: !0
              },
              borderWidth: {
                uniform: !0
              },
              backgroundColor: {
                uniform: !0
              },
              backgroundOpacity: {
                uniform: !0
              },
              fixedSize: {
                updateShader: !0
              }
            }, og);
          function o_(e, t) {
            for (var n = e.position.length / 3, r = 0, i = 0; i < n; ++i) r += e.text[i].length;
            return t.showBackground && (r += n), r;
          }
          var a_ = function (e) {
            function t(t, n) {
              void 0 === n && (n = {}), e.call(this, {
                position: new Float32Array(3 * o_(t, n)),
                color: new Float32Array(3 * o_(t, n)),
                picking: new gm()
              }, n), this.parameterTypes = i_, this.alwaysTransparent = !0, this.hasWireframe = !1, this.isText = !0, this.vertexShader = "SDFFont.vert", this.fragmentShader = "SDFFont.frag", this.text = t.text, this.positionCount = t.position.length / 3, this.addUniforms({
                fontTexture: {
                  value: null
                },
                xOffset: {
                  value: this.parameters.xOffset
                },
                yOffset: {
                  value: this.parameters.yOffset
                },
                zOffset: {
                  value: this.parameters.zOffset
                },
                ortho: {
                  value: !1
                },
                showBorder: {
                  value: this.parameters.showBorder
                },
                borderColor: {
                  value: new Fe(this.parameters.borderColor)
                },
                borderWidth: {
                  value: this.parameters.borderWidth
                },
                backgroundColor: {
                  value: new Fe(this.parameters.backgroundColor)
                },
                backgroundOpacity: {
                  value: this.parameters.backgroundOpacity
                },
                canvasHeight: {
                  value: 1
                },
                pixelRatio: {
                  value: 1
                }
              }), this.addAttributes({
                inputTexCoord: {
                  type: "v2",
                  value: null
                },
                inputSize: {
                  type: "f",
                  value: null
                }
              }), this.setAttributes(t), this.makeTexture(), this.makeMapping();
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              defaultParameters: {
                configurable: !0
              }
            };
            return n.defaultParameters.get = function () {
              return r_;
            }, t.prototype.makeMaterial = function () {
              e.prototype.makeMaterial.call(this);
              var t = this.texture,
                n = this.material;
              n.transparent = !0, n.extensions.derivatives = !0, n.lights = !1, n.uniforms.fontTexture.value = t, n.needsUpdate = !0;
              var r = this.wireframeMaterial;
              r.transparent = !0, r.extensions.derivatives = !0, r.lights = !1, r.uniforms.fontTexture.value = t, r.needsUpdate = !0;
              var i = this.pickingMaterial;
              i.extensions.derivatives = !0, i.lights = !1, i.uniforms.fontTexture.value = t, i.needsUpdate = !0;
            }, t.prototype.setAttributes = function (e) {
              var t, n, r, i, o, a;
              void 0 === e && (e = {});
              var s = this.text,
                l = this.geometry.attributes;
              e.position && (t = e.position, i = l.position.array, l.position.needsUpdate = !0), e.size && (n = e.size, o = l.inputSize.array, l.inputSize.needsUpdate = !0), e.color && (r = e.color, a = l.color.array, l.color.needsUpdate = !0);
              for (var u, c, d, h, f = this.positionCount, p = 0, m = 0; m < f; ++m) for (c = 3 * m, h = s[m].length, this.parameters.showBackground && (h += 1), d = 0; d < h; ++d, ++p) for (var g = 0; g < 4; g++) u = 4 * p * 3 + 3 * g, t && (i[u] = t[c], i[u + 1] = t[c + 1], i[u + 2] = t[c + 2]), n && (o[4 * p + g] = n[m]), r && (a[u] = r[c], a[u + 1] = r[c + 1], a[u + 2] = r[c + 2]);
            }, t.prototype.makeTexture = function () {
              var e, t;
              this.textAtlas = (e = {
                font: this.parameters.fontFamily,
                style: this.parameters.fontStyle,
                weight: this.parameters.fontWeight,
                size: this.parameters.fontSize
              }, t = JSON.stringify(e), void 0 === e_[t] && (e_[t] = new n_(e)), e_[t]), this.texture = this.textAtlas.texture;
            }, t.prototype.makeMapping = function () {
              for (var e, t, n, r, i, o, a, s, l = this.textAtlas, u = this.text, c = this.parameters.attachment, d = l.lineHeight * this.parameters.backgroundMargin * .1 - 10, h = this.geometry.attributes, f = h.inputTexCoord.array, p = h.mapping.array, m = this.positionCount, g = 0, v = 0; v < m; ++v) {
                for (r = 0, o = (n = u[v]).length, i = 0; i < o; ++i) r += (e = l.get(n[i])).w - 2 * l.parameters.outline;
                for (s = c.startsWith("top") ? l.lineHeight / 1.25 : c.startsWith("middle") ? l.lineHeight / 2.5 : 0, a = c.endsWith("right") ? r : c.endsWith("center") ? r / 2 : 0, a += l.parameters.outline, s += l.parameters.outline, this.parameters.showBackground && (p[0 + (t = 2 * g * 4)] = -l.lineHeight / 6 - a - d, p[t + 1] = l.lineHeight - s + d, p[t + 2] = -l.lineHeight / 6 - a - d, p[t + 3] = 0 - s - d, p[t + 4] = r + l.lineHeight / 6 - a + 2 * l.parameters.outline + d, p[t + 5] = l.lineHeight - s + d, p[t + 6] = r + l.lineHeight / 6 - a + 2 * l.parameters.outline + d, p[t + 7] = 0 - s - d, f[t + 0] = 10, f[t + 2] = 10, f[t + 4] = 10, f[t + 6] = 10, g += 1), i = r = 0; i < o; ++i, ++g) {
                  e = l.get(n[i]), p[0 + (t = 2 * g * 4)] = r - a, p[t + 1] = e.h - s, p[t + 2] = r - a, p[t + 3] = 0 - s, p[t + 4] = r + e.w - a, p[t + 5] = e.h - s, p[t + 6] = r + e.w - a, p[t + 7] = 0 - s;
                  var y = l.parameters.width,
                    b = l.parameters.height,
                    _ = [e.x / y, e.y / b, e.x / y, (e.y + e.h) / b, (e.x + e.w) / y, e.y / b, (e.x + e.w) / y, (e.y + e.h) / b];
                  f.set(_, t), r += e.w - 2 * l.parameters.outline;
                }
              }
              h.inputTexCoord.needsUpdate = !0, h.mapping.needsUpdate = !0;
            }, t.prototype.getDefines = function (t) {
              var n = e.prototype.getDefines.call(this, t);
              return this.parameters.fixedSize && (n.FIXED_SIZE = 1), n;
            }, t.prototype.setUniforms = function (t) {
              !t || void 0 === t.fontFamily && void 0 === t.fontStyle && void 0 === t.fontWeight && void 0 === t.fontSize || (this.makeTexture(), this.makeMapping(), this.texture.needsUpdate = !0, t.fontTexture = this.texture), e.prototype.setUniforms.call(this, t);
            }, Object.defineProperties(t.prototype, n), t;
          }(yy);
          ld.add("text", a_), od.add("shader/WideLine.vert", "\nuniform float clipNear;\nuniform vec3 clipCenter;\nuniform float linewidth;\nuniform vec2 resolution;\nuniform mat4 projectionMatrixInverse;\nattribute vec2 mapping;\nattribute vec3 position1;\nattribute vec3 position2;\n#ifdef PICKING\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\nattribute vec3 color2;\nvarying vec3 vColor;\nvarying vec3 vColor2;\nvarying float flag;\nvarying vec3 vViewPosition;\n#endif\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\nvoid trimSegment( const in vec4 start, inout vec4 end ) {\nfloat a = projectionMatrix[ 2 ][ 2 ]; float b = projectionMatrix[ 3 ][ 2 ]; float nearEstimate = - 0.5 * b / a;\nfloat alpha = ( nearEstimate - start.z ) / ( end.z - start.z );\nend.xyz = mix( start.xyz, end.xyz, alpha );\n}\nvoid main() {\nfloat aspect = resolution.x / resolution.y;\n#ifdef PICKING\nvPickingColor = unpackColor( primitiveId );\n#else\nflag = mapping.y;\nvColor = color;\nvColor2 = color2;\n#endif\nvec4 start = modelViewMatrix * vec4( position1, 1.0 );\nvec4 end = modelViewMatrix * vec4( position2, 1.0 );\nbool perspective = ( projectionMatrix[ 2 ][ 3 ] == -1.0 ); if ( perspective ) {\nif ( start.z < 0.0 && end.z >= 0.0 ) {\ntrimSegment( start, end );\n} else if ( end.z < 0.0 && start.z >= 0.0 ) {\ntrimSegment( end, start );\n}\n}\nvec4 clipStart = projectionMatrix * start;\nvec4 clipEnd = projectionMatrix * end;\nvec2 ndcStart = clipStart.xy / clipStart.w;\nvec2 ndcEnd = clipEnd.xy / clipEnd.w;\nvec2 dir = ndcEnd - ndcStart;\ndir.x *= aspect;\ndir = normalize( dir );\nvec2 offset = vec2( dir.y, - dir.x );\ndir.x /= aspect;\noffset.x /= aspect;\nif ( mapping.x < 0.0 ) offset *= - 1.0;\noffset *= linewidth;\noffset /= resolution.y;\nvec4 clip = ( mapping.y < 0.5 ) ? clipStart : clipEnd;\noffset *= clip.w;\nclip.xy += offset;\ngl_Position = clip;\n#ifndef PICKING\nvViewPosition = ( projectionMatrixInverse * clip ).xyz;\n#endif\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n#include nearclip_vertex\n}"), od.add("shader/WideLine.frag", "uniform vec3 diffuse;\nuniform float opacity;\nuniform float clipNear;\nuniform float clipRadius;\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\n#ifdef PICKING\nuniform float objectId;\nvarying vec3 vPickingColor;\n#else\n#include common\n#include fog_pars_fragment\nvarying vec3 vViewPosition;\nvarying vec3 vColor;\nvarying vec3 vColor2;\nvarying float flag;\n#endif\nvoid main() {\n#include nearclip_fragment\n#include radiusclip_fragment\n#if defined( PICKING )\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#else\nvec3 outgoingLight = vec3( 0.0 );\nvec4 diffuseColor = vec4( diffuse, 1.0 );\nif ( flag < 0.0 ) {\ndiffuseColor.rgb *= vColor;\n} else {\ndiffuseColor.rgb *= vColor2;\n}\n#include alphatest_fragment\noutgoingLight = diffuseColor.rgb;\ngl_FragColor = vec4( outgoingLight, diffuseColor.a * opacity );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#endif\n}");
          var s_ = Object.assign({
              linewidth: 2
            }, ig),
            l_ = Object.assign({
              linewidth: {
                uniform: !0
              }
            }, og),
            u_ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.parameterTypes = l_, this.vertexShader = "WideLine.vert", this.fragmentShader = "WideLine.frag", !t.color2 && t.color && (t.color2 = t.color), this.addUniforms({
                  linewidth: {
                    value: this.parameters.linewidth
                  },
                  resolution: {
                    value: new re()
                  },
                  projectionMatrixInverse: {
                    value: new ie()
                  }
                }), this.addAttributes({
                  position1: {
                    type: "v3",
                    value: null
                  },
                  position2: {
                    type: "v3",
                    value: null
                  },
                  color2: {
                    type: "c",
                    value: null
                  }
                }), this.setAttributes(t), this.makeMapping();
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return s_;
              }, t.prototype.setParameters = function (t) {
                e.prototype.setParameters.call(this, t);
              }, Object.defineProperties(t.prototype, n), t;
            }(yy);
          ld.add("wideline", u_);
          var c_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "angle", this.parameters = Object.assign({
                atomTriple: {
                  type: "hidden",
                  rebuild: !0
                },
                vectorVisible: {
                  type: "boolean",
                  default: !0
                },
                arcVisible: {
                  type: "boolean",
                  default: !0
                },
                sectorVisible: {
                  type: "boolean",
                  default: !0
                }
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.side = wu(n.side, "double"), n.opacity = wu(n.opacity, .5), this.atomTriple = wu(n.atomTriple, []), this.arcVisible = wu(n.arcVisible, !0), this.sectorVisible = wu(n.sectorVisible, !0), this.vectorVisible = wu(n.vectorVisible, !0), e.prototype.init.call(this, n);
            }, t.prototype.createData = function (e) {
              if (e.atomCount && this.atomTriple.length) {
                var t = function (e, t) {
                    void 0 === t && (t = {});
                    for (var n = wu(t.angleStep, Math.PI / 90), r = e.length / 9, i = new Float32Array(r), o = new Float32Array(3 * r), a = new Array(r), s = new Float32Array(6 * r), l = new Float32Array(6 * r), u = new Array(r), c = new Array(r), d = new Array(r), h = 0, f = vf(), p = vf(), m = vf(), g = vf(), v = vf(), y = vf(), b = vf(), _ = vf(), x = vf(), w = function w(t) {
                        var r = 9 * t;
                        wf(f, e, r), wf(p, e, r + 3), wf(m, e, r + 6);
                        var w = 6 * t;
                        Sf(f, s, w), Sf(p, l, w), Sf(p, s, w + 3), Sf(m, l, w + 3), _f(g, f, p), _f(v, m, p), Mf(g, g), Mf(v, v), yf(y, g, v);
                        var S = Af(y),
                          A = bf(g, v),
                          E = i[t] = Math.atan2(S, A);
                        a[t] = (zd * E).toFixed(1) + String.fromCharCode(176), 0 === Af(y) && (y[0] = 1, y[1] = 0, y[2] = 0), yf(b, y, g), Mf(b, b), Zb(_, p, g, b, E / 2), Sf(_, o, 3 * t);
                        var T = Math.ceil(E / n),
                          M = new Float32Array(9 * T);
                        d[t] = M;
                        var C = new Float32Array(3 * T),
                          k = new Float32Array(3 * T);
                        u[t] = C, c[t] = k, xf(x, p, g);
                        for (var P = function P(e, t) {
                            var n = 9 * t,
                              r = 3 * t;
                            Sf(p, M, n), Sf(x, M, n + 3), Sf(x, C, r), Zb(x, p, g, b, e), Sf(x, M, n + 6), Sf(x, k, r);
                          }, O = 0, R = n; R < E; R += n) P(R, O), O++;
                        P(E, O), h += T;
                      }, S = 0; S < r; S++) w(S);
                    for (var A = 3 * h, E = 9 * h, T = new Float32Array(A), M = new Float32Array(A), C = new Float32Array(E), k = 0, P = 0, O = 0; O < r; O++) {
                      var R = u[O],
                        I = c[O];
                      Yd(R, T, 0, P, R.length), Yd(I, M, 0, P, I.length), P += R.length;
                      var j = d[O];
                      Yd(j, C, 0, k, j.length), k += j.length;
                    }
                    return {
                      labelPosition: o,
                      labelText: a,
                      vectorPosition1: s,
                      vectorPosition2: l,
                      arcPosition1: T,
                      arcPosition2: M,
                      sectorPosition: C
                    };
                  }(function (e) {
                    for (var t = [], n = e.length / 9, r = 0; r < n; r++) {
                      for (var i = !0, o = r; o < r + 3; o += 3) e[o] === e[o + 3] && e[o + 1] === e[o + 4] && e[o + 2] === e[o + 5] && (i = !1);
                      i && t.push(r);
                    }
                    var a = new Float32Array(9 * t.length),
                      s = 0;
                    return t.forEach(function (t) {
                      Yd(e, a, 9 * t, 9 * s, 9), s++;
                    }), a;
                  }(Kb(e, this.atomTriple))),
                  n = this.n = t.labelPosition.length / 3,
                  r = new Fe(this.labelColor);
                this.textBuffer = new a_({
                  position: t.labelPosition,
                  size: Hd(n, this.labelSize),
                  color: qd(n, r.r, r.g, r.b),
                  text: t.labelText
                }, this.getLabelBufferParams());
                var i = new Fe(this.colorValue);
                return this.vectorBuffer = new u_(Nf({
                  position1: t.vectorPosition1,
                  position2: t.vectorPosition2,
                  color: qd(2 * n, i.r, i.g, i.b),
                  color2: qd(2 * n, i.r, i.g, i.b)
                }), this.getBufferParams({
                  linewidth: this.linewidth,
                  visible: this.vectorVisible,
                  opacity: this.lineOpacity
                })), this.arcLength = t.arcPosition1.length / 3, this.arcBuffer = new u_(Nf({
                  position1: t.arcPosition1,
                  position2: t.arcPosition2,
                  color: qd(this.arcLength, i.r, i.g, i.b),
                  color2: qd(this.arcLength, i.r, i.g, i.b)
                }), this.getBufferParams({
                  linewidth: this.linewidth,
                  visible: this.arcVisible,
                  opacity: this.lineOpacity
                })), this.sectorLength = t.sectorPosition.length / 3, this.sectorBuffer = new lg({
                  position: t.sectorPosition,
                  color: qd(this.sectorLength, i.r, i.g, i.b)
                }, this.getBufferParams({
                  visible: this.sectorVisible
                })), {
                  bufferList: [this.textBuffer, this.vectorBuffer, this.arcBuffer, this.sectorBuffer]
                };
              }
            }, t.prototype.updateData = function (t, n) {
              e.prototype.updateData.call(this, t, n);
              var r = {},
                i = {},
                o = {};
              if (t.color) {
                var a = new Fe(this.colorValue);
                Object.assign(r, {
                  color: qd(2 * this.n, a.r, a.g, a.b),
                  color2: qd(2 * this.n, a.r, a.g, a.b)
                }), Object.assign(i, {
                  color: qd(this.arcLength, a.r, a.g, a.b),
                  color2: qd(this.arcLength, a.r, a.g, a.b)
                }), Object.assign(o, {
                  color: qd(this.sectorLength, a.r, a.g, a.b)
                });
              }
              this.vectorBuffer.setAttributes(r), this.arcBuffer.setAttributes(i), this.sectorBuffer.setAttributes(o);
            }, t.prototype.setParameters = function (t) {
              return e.prototype.setParameters.call(this, t, {}, !1), !t || void 0 === t.vectorVisible && void 0 === t.arcVisible && void 0 === t.sectorVisible || this.setVisibility(this.visible), t && t.lineOpacity && (this.vectorBuffer.setParameters({
                opacity: t.lineOpacity
              }), this.arcBuffer.setParameters({
                opacity: t.lineOpacity
              })), t && void 0 !== t.opacity && (this.vectorBuffer.setParameters({
                opacity: this.lineOpacity
              }), this.arcBuffer.setParameters({
                opacity: this.lineOpacity
              })), t && t.linewidth && (this.vectorBuffer.setParameters({
                linewidth: t.linewidth
              }), this.arcBuffer.setParameters({
                linewidth: t.linewidth
              })), this;
            }, t.prototype.setVisibility = function (t, n) {
              return e.prototype.setVisibility.call(this, t, !0), this.vectorBuffer && this.vectorBuffer.setVisibility(this.vectorVisible && this.visible), this.arcBuffer && this.arcBuffer.setVisibility(this.arcVisible && this.visible), this.sectorBuffer && this.sectorBuffer.setVisibility(this.sectorVisible && this.visible), n || this.viewer.requestRender(), this;
            }, t;
          }(Yb);
          rd.add("angle", c_);
          var d_ = new ae(),
            h_ = new ae(),
            f_ = new ae(),
            p_ = new ae(0, 1, 0),
            m_ = Object.assign({
              radialSegments: 1,
              openEnded: !0
            }, ig);
          function g_(e) {
            void 0 === e && (e = {});
            var t = wu(e.radialSegments, 10),
              n = wu(e.openEnded, !0),
              r = new ie().makeRotationX(Math.PI / 2),
              i = new ea(1, 1, 1, t, 1, n);
            return i.applyMatrix(r), i;
          }
          var v_ = function (e) {
            function t(t, n) {
              void 0 === n && (n = {}), e.call(this, function (e, t) {
                void 0 === t && (t = {});
                var n = g_(t),
                  r = e.position1.length,
                  i = n.attributes.position.array.length / 3,
                  o = r / 3,
                  a = new Float32Array(2 * o * i);
                return $d(o, i, 0, a), $d(o, i, o * i, a), {
                  position: new Float32Array(2 * r),
                  color: new Float32Array(2 * r),
                  primitiveId: a,
                  picking: e.picking
                };
              }(t, n), n, g_(n)), this.updateNormals = !0;
              var r = t.position1.length,
                i = t.radius.length;
              this.__center = new Float32Array(r), this._position = new Float32Array(2 * r), this._color = new Float32Array(2 * r), this._from = new Float32Array(2 * r), this._to = new Float32Array(2 * r), this._radius = new Float32Array(2 * i), this.setAttributes(t, !0);
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              defaultParameters: {
                configurable: !0
              }
            };
            return n.defaultParameters.get = function () {
              return m_;
            }, t.prototype.applyPositionTransform = function (e, t, n) {
              h_.fromArray(this._from, n), f_.fromArray(this._to, n), e.lookAt(h_, f_, p_);
              var r = this._radius[t];
              d_.set(r, r, h_.distanceTo(f_)), e.scale(d_);
            }, t.prototype.setAttributes = function (t, n) {
              void 0 === t && (t = {});
              var r = {};
              t.position1 && t.position2 && (Gd(t.position1, t.position2, this.__center), Gd(t.position1, this.__center, this._position), Gd(this.__center, t.position2, this._position, t.position1.length), this._from.set(t.position1), this._from.set(this.__center, t.position1.length), this._to.set(this.__center), this._to.set(t.position2, this.__center.length), r.position = this._position), t.color && t.color2 && (this._color.set(t.color), this._color.set(t.color2, t.color.length), r.color = this._color), t.radius && (this._radius.set(t.radius), this._radius.set(t.radius, t.radius.length), r.radius = this._radius), e.prototype.setAttributes.call(this, r, n);
            }, Object.defineProperties(t.prototype, n), t;
          }(dy);
          od.add("shader/CylinderImpostor.vert", "\nattribute vec3 mapping;\nattribute vec3 position1;\nattribute vec3 position2;\nattribute float radius;\nvarying vec3 axis;\nvarying vec4 base_radius;\nvarying vec4 end_b;\nvarying vec3 U;\nvarying vec3 V;\nvarying vec4 w;\n#ifdef PICKING\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\nattribute vec3 color2;\nvarying vec3 vColor1;\nvarying vec3 vColor2;\n#endif\nuniform mat4 modelViewMatrixInverse;\nuniform float ortho;\n#include matrix_scale\nvoid main(){\n#ifdef PICKING\nvPickingColor = unpackColor( primitiveId );\n#else\nvColor1 = color;\nvColor2 = color2;\n#endif\nbase_radius.w = radius * matrixScale( modelViewMatrix );\nvec3 center = position;\nvec3 dir = normalize( position2 - position1 );\nfloat ext = length( position2 - position1 ) / 2.0;\nvec3 cam_dir;\nif( ortho == 0.0 ){\ncam_dir = ( modelViewMatrixInverse * vec4( 0, 0, 0, 1 ) ).xyz - center;\n}else{\ncam_dir = ( modelViewMatrixInverse * vec4( 0, 0, 1, 0 ) ).xyz;\n}\ncam_dir = normalize( cam_dir );\nvec3 ldir;\nfloat b = dot( cam_dir, dir );\nend_b.w = b;\nif( b < 0.0 )\nldir = -ext * dir;\nelse\nldir = ext * dir;\nvec3 left = normalize( cross( cam_dir, ldir ) );\nleft = radius * left;\nvec3 up = radius * normalize( cross( left, ldir ) );\naxis = normalize( normalMatrix * ldir );\nU = normalize( normalMatrix * up );\nV = normalize( normalMatrix * left );\nvec4 base4 = modelViewMatrix * vec4( center - ldir, 1.0 );\nbase_radius.xyz = base4.xyz / base4.w;\nvec4 top_position = modelViewMatrix * vec4( center + ldir, 1.0 );\nvec4 end4 = top_position;\nend_b.xyz = end4.xyz / end4.w;\nw = modelViewMatrix * vec4(\ncenter + mapping.x*ldir + mapping.y*left + mapping.z*up, 1.0\n);\ngl_Position = projectionMatrix * w;\ngl_Position.z = 0.99;\n}"), od.add("shader/CylinderImpostor.frag", "#define STANDARD\n#define IMPOSTOR\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 interiorColor;\nuniform float interiorDarkening;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\nuniform float clipNear;\nuniform mat4 projectionMatrix;\nuniform float ortho;\nvarying vec3 axis;\nvarying vec4 base_radius;\nvarying vec4 end_b;\nvarying vec3 U;\nvarying vec3 V;\nvarying vec4 w;\n#ifdef PICKING\nuniform float objectId;\nvarying vec3 vPickingColor;\n#else\nvarying vec3 vColor1;\nvarying vec3 vColor2;\n#include common\n#include fog_pars_fragment\n#include bsdfs\n#include lights_pars_begin\n#include lights_physical_pars_fragment\n#endif\nbool interior = false;\nfloat distSq3( vec3 v3a, vec3 v3b ){\nreturn (\n( v3a.x - v3b.x ) * ( v3a.x - v3b.x ) +\n( v3a.y - v3b.y ) * ( v3a.y - v3b.y ) +\n( v3a.z - v3b.z ) * ( v3a.z - v3b.z )\n);\n}\nfloat calcDepth( in vec3 cameraPos ){\nvec2 clipZW = cameraPos.z * projectionMatrix[2].zw + projectionMatrix[3].zw;\nreturn 0.5 + 0.5 * clipZW.x / clipZW.y;\n}\nfloat calcClip( vec3 cameraPos ){\nreturn dot( vec4( cameraPos, 1.0 ), vec4( 0.0, 0.0, 1.0, clipNear - 0.5 ) );\n}\nvoid main(){\nvec3 point = w.xyz / w.w;\nvec3 base = base_radius.xyz;\nfloat vRadius = base_radius.w;\nvec3 end = end_b.xyz;\nfloat b = end_b.w;\nvec3 end_cyl = end;\nvec3 surface_point = point;\nvec3 ray_target = surface_point;\nvec3 ray_origin = vec3(0.0);\nvec3 ray_direction = mix(normalize(ray_origin - ray_target), vec3(0.0, 0.0, 1.0), ortho);\nmat3 basis = mat3( U, V, axis );\nvec3 diff = ray_target - 0.5 * (base + end_cyl);\nvec3 P = diff * basis;\nfloat dz = dot( axis, ray_direction );\nfloat radius2 = vRadius*vRadius;\nvec3 D = vec3(dot(U, ray_direction),\ndot(V, ray_direction),\ndz);\nfloat a0 = P.x*P.x + P.y*P.y - radius2;\nfloat a1 = P.x*D.x + P.y*D.y;\nfloat a2 = D.x*D.x + D.y*D.y;\nfloat d = a1*a1 - a0*a2;\nif (d < 0.0)\ndiscard;\nfloat dist = (-a1 + sqrt(d)) / a2;\nvec3 new_point = ray_target + dist * ray_direction;\nvec3 tmp_point = new_point - base;\nvec3 _normal = normalize( tmp_point - axis * dot(tmp_point, axis) );\nray_origin = mix( ray_origin, surface_point, ortho );\nfloat front_cap_test = dot( tmp_point, axis );\nfloat end_cap_test = dot((new_point - end_cyl), axis);\n#ifndef CAP\nvec3 new_point2 = ray_target + ( (-a1 - sqrt(d)) / a2 ) * ray_direction;\nvec3 tmp_point2 = new_point2 - base;\n#endif\nif (front_cap_test < 0.0)\n{\nfloat dNV = dot(-axis, ray_direction);\nif (dNV < 0.0)\ndiscard;\nfloat near = dot(-axis, (base)) / dNV;\nvec3 front_point = ray_direction * near + ray_origin;\nif (dot(front_point - base, front_point-base) > radius2)\ndiscard;\n#ifdef CAP\nnew_point = front_point;\n_normal = axis;\n#else\nnew_point = ray_target + ( (-a1 - sqrt(d)) / a2 ) * ray_direction;\ndNV = dot(-axis, ray_direction);\nnear = dot(axis, end_cyl) / dNV;\nnew_point2 = ray_direction * near + ray_origin;\nif (dot(new_point2 - end_cyl, new_point2-base) < radius2)\ndiscard;\ninterior = true;\n#endif\n}\nif( end_cap_test > 0.0 )\n{\nfloat dNV = dot(axis, ray_direction);\nif (dNV < 0.0)\ndiscard;\nfloat near = dot(axis, end_cyl) / dNV;\nvec3 end_point = ray_direction * near + ray_origin;\nif( dot(end_point - end_cyl, end_point-base) > radius2 )\ndiscard;\n#ifdef CAP\nnew_point = end_point;\n_normal = axis;\n#else\nnew_point = ray_target + ( (-a1 - sqrt(d)) / a2 ) * ray_direction;\ndNV = dot(-axis, ray_direction);\nnear = dot(-axis, (base)) / dNV;\nnew_point2 = ray_direction * near + ray_origin;\nif (dot(new_point2 - base, new_point2-base) < radius2)\ndiscard;\ninterior = true;\n#endif\n}\ngl_FragDepthEXT = calcDepth( new_point );\n#ifdef NEAR_CLIP\nif( calcClip( new_point ) > 0.0 ){\ndist = (-a1 - sqrt(d)) / a2;\nnew_point = ray_target + dist * ray_direction;\nif( calcClip( new_point ) > 0.0 )\ndiscard;\ninterior = true;\ngl_FragDepthEXT = calcDepth( new_point );\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = max( 0.0, calcDepth( vec3( - ( clipNear - 0.5 ) ) ) + ( 0.0000001 / vRadius ) );\n}\n}else if( gl_FragDepthEXT <= 0.0 ){\ndist = (-a1 - sqrt(d)) / a2;\nnew_point = ray_target + dist * ray_direction;\ninterior = true;\ngl_FragDepthEXT = calcDepth( new_point );\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = 0.0 + ( 0.0000001 / vRadius );\n}\n}\n#else\nif( gl_FragDepthEXT <= 0.0 ){\ndist = (-a1 - sqrt(d)) / a2;\nnew_point = ray_target + dist * ray_direction;\ninterior = true;\ngl_FragDepthEXT = calcDepth( new_point );\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = 0.0 + ( 0.0000001 / vRadius );\n}\n}\n#endif\nif (gl_FragDepthEXT < 0.0)\ndiscard;\nif (gl_FragDepthEXT > 1.0)\ndiscard;\n#ifdef PICKING\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#else\nvec3 vViewPosition = -new_point;\nvec3 vNormal = _normal;\nvec3 vColor;\nif( distSq3( new_point, end_cyl ) < distSq3( new_point, base ) ){\nif( b < 0.0 ){\nvColor = vColor1;\n}else{\nvColor = vColor2;\n}\n}else{\nif( b > 0.0 ){\nvColor = vColor1;\n}else{\nvColor = vColor2;\n}\n}\nvec4 diffuseColor = vec4( diffuse, opacity );\nReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\nvec3 totalEmissiveLight = emissive;\n#include color_fragment\n#include roughnessmap_fragment\n#include metalnessmap_fragment\nvec3 normal = normalize( vNormal );\n#include lights_physical_fragment\n#include lights_fragment_begin\n#include lights_fragment_end\nvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveLight;\nif( interior ){\n#ifdef USE_INTERIOR_COLOR\noutgoingLight.xyz = interiorColor;\n#else\n#ifdef DIFFUSE_INTERIOR\noutgoingLight.xyz = vColor;\n#endif\n#endif\noutgoingLight.xyz *= 1.0 - interiorDarkening;\n}\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#endif\n}");
          var y_ = new Float32Array([-1, 1, -1, -1, -1, -1, 1, 1, -1, 1, 1, 1, 1, -1, -1, 1, -1, 1]),
            b_ = new Uint16Array([0, 1, 2, 1, 4, 2, 2, 4, 3, 4, 5, 3]),
            __ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, "v3", t, n);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                mapping: {
                  configurable: !0
                },
                mappingIndices: {
                  configurable: !0
                },
                mappingIndicesSize: {
                  configurable: !0
                },
                mappingSize: {
                  configurable: !0
                },
                mappingItemSize: {
                  configurable: !0
                }
              };
              return n.mapping.get = function () {
                return y_;
              }, n.mappingIndices.get = function () {
                return b_;
              }, n.mappingIndicesSize.get = function () {
                return 12;
              }, n.mappingSize.get = function () {
                return 6;
              }, n.mappingItemSize.get = function () {
                return 3;
              }, Object.defineProperties(t.prototype, n), t;
            }(my),
            x_ = Object.assign({
              openEnded: !1
            }, ig),
            w_ = Object.assign({
              openEnded: {
                updateShader: !0
              }
            }, og),
            S_ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.parameterTypes = w_, this.isImpostor = !0, this.vertexShader = "CylinderImpostor.vert", this.fragmentShader = "CylinderImpostor.frag", this.addUniforms({
                  modelViewMatrixInverse: {
                    value: new ie()
                  },
                  ortho: {
                    value: 0
                  }
                }), this.addAttributes({
                  position1: {
                    type: "v3",
                    value: null
                  },
                  position2: {
                    type: "v3",
                    value: null
                  },
                  color2: {
                    type: "c",
                    value: null
                  },
                  radius: {
                    type: "f",
                    value: null
                  }
                }), this.setAttributes(t), this.makeMapping();
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return x_;
              }, t.prototype.getDefines = function (t) {
                var n = e.prototype.getDefines.call(this, t);
                return this.parameters.openEnded || (n.CAP = 1), n;
              }, Object.defineProperties(t.prototype, n), t;
            }(__),
            A_ = (Object.assign({
              disableImpostor: !1
            }, m_, x_), function (e, t) {
              return void 0 === t && (t = {}), !e.color2 && e.color && (e.color2 = e.color), !Kc || t && t.disableImpostor ? new v_(e, t) : new S_(e, t);
            });
          ld.add("cylinder", A_);
          var E_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "axes", this.parameters = Object.assign({
                radiusSize: {
                  type: "number",
                  precision: 3,
                  max: 10,
                  min: .001
                },
                sphereDetail: !0,
                radialSegments: !0,
                disableImpostor: !0,
                showAxes: {
                  type: "boolean",
                  rebuild: !0
                },
                showBox: {
                  type: "boolean",
                  rebuild: !0
                }
              }, this.parameters, {
                assembly: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.radiusSize = wu(n.radiusSize, .5), n.colorValue = wu(n.colorValue, "lightgreen"), n.useInteriorColor = wu(n.useInteriorColor, !0), this.showAxes = wu(n.showAxes, !0), this.showBox = wu(n.showBox, !1), e.prototype.init.call(this, n);
            }, t.prototype.getPrincipalAxes = function () {
              var e,
                t = this.getAssembly();
              return t && (e = t.partList[0].getSelection()), this.structureView.getPrincipalAxes(e);
            }, t.prototype.getAxesData = function (e) {
              var t = this.getPrincipalAxes(),
                n = new Fe(this.colorValue),
                r = 0,
                i = 0;
              this.showAxes && (r += 6, i += 3), this.showBox && (r += 8, i += 12);
              var o = new Float32Array(3 * r),
                a = qd(r, n.r, n.g, n.b),
                s = Hd(r, this.radiusSize),
                l = new Float32Array(3 * i),
                u = new Float32Array(3 * i),
                c = qd(i, n.r, n.g, n.b),
                d = Hd(i, this.radiusSize),
                h = 0;
              if (this.showAxes) {
                var f = function f(e, t) {
                  e.toArray(o, 2 * h), t.toArray(o, 2 * h + 3), e.toArray(l, h), t.toArray(u, h), h += 3;
                };
                f(t.begA, t.endA), f(t.begB, t.endB), f(t.begC, t.endC);
              }
              if (this.showBox) {
                var p = new ae(),
                  m = t.getProjectedScaleForAtoms(e),
                  g = m.d1a,
                  v = m.d2a,
                  y = m.d3a,
                  b = m.d1b,
                  _ = m.d2b,
                  x = m.d3b,
                  w = 2 * h,
                  S = function S(e, n, r) {
                    p.copy(t.center).addScaledVector(t.normVecA, e).addScaledVector(t.normVecB, n).addScaledVector(t.normVecC, r), p.toArray(o, w), w += 3;
                  };
                S(g, v, y), S(g, v, x), S(g, _, x), S(g, _, y), S(b, _, x), S(b, _, y), S(b, v, y), S(b, v, x);
                var A = h,
                  E = function E(e, t) {
                    p.fromArray(o, 2 * h + 3 * e).toArray(l, A), p.fromArray(o, 2 * h + 3 * t).toArray(u, A), A += 3;
                  };
                E(0, 1), E(0, 3), E(0, 6), E(1, 2), E(1, 7), E(2, 3), E(2, 4), E(3, 5), E(4, 5), E(4, 7), E(5, 6), E(6, 7);
              }
              var T = new sm(t);
              return {
                vertex: {
                  position: o,
                  color: a,
                  radius: s,
                  picking: T
                },
                edge: {
                  position1: l,
                  position2: u,
                  color: c,
                  color2: c,
                  radius: d,
                  picking: T
                }
              };
            }, t.prototype.create = function () {
              var e = this.getAxesData(this.structureView);
              this.sphereBuffer = new _y(e.vertex, this.getBufferParams({
                sphereDetail: this.sphereDetail,
                disableImpostor: this.disableImpostor,
                dullInterior: !0
              })), this.cylinderBuffer = new A_(e.edge, this.getBufferParams({
                openEnded: !0,
                radialSegments: this.radialSegments,
                disableImpostor: this.disableImpostor,
                dullInterior: !0
              })), this.dataList.push({
                sview: this.structureView,
                bufferList: [this.sphereBuffer, this.cylinderBuffer]
              });
            }, t.prototype.createData = function (e) {}, t.prototype.updateData = function (e, t) {
              var n = this.getAxesData(t.sview),
                r = {},
                i = {};
              e && !e.position || (Object.assign(r, {
                position: n.vertex.position
              }), Object.assign(i, {
                position1: n.edge.position1,
                position2: n.edge.position2
              })), e && !e.color || (Object.assign(r, {
                color: n.vertex.color
              }), Object.assign(i, {
                color: n.edge.color,
                color2: n.edge.color
              })), e && !e.radius || (Object.assign(r, {
                radius: n.vertex.radius
              }), Object.assign(i, {
                radius: n.edge.radius
              })), this.sphereBuffer.setAttributes(r), this.cylinderBuffer.setAttributes(i);
            }, t;
          }(Xb);
          rd.add("axes", E_);
          var T_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "ball+stick", this.parameters = Object.assign({
                sphereDetail: !0,
                radialSegments: !0,
                openEnded: !0,
                disableImpostor: !0,
                aspectRatio: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: 1
                },
                lineOnly: {
                  type: "boolean",
                  rebuild: !0
                },
                cylinderOnly: {
                  type: "boolean",
                  rebuild: !0
                },
                multipleBond: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    off: "off",
                    symmetric: "symmetric",
                    offset: "offset"
                  }
                },
                bondScale: {
                  type: "number",
                  precision: 2,
                  max: 1,
                  min: .01
                },
                bondSpacing: {
                  type: "number",
                  precision: 2,
                  max: 2,
                  min: .5
                },
                linewidth: {
                  type: "integer",
                  max: 50,
                  min: 1,
                  buffer: !0
                }
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.radiusType = wu(n.radiusType, "size"), n.radiusSize = wu(n.radiusSize, .15), n.useInteriorColor = wu(n.useInteriorColor, !0), this.aspectRatio = wu(n.aspectRatio, 2), this.lineOnly = wu(n.lineOnly, !1), this.cylinderOnly = wu(n.cylinderOnly, !1), this.multipleBond = wu(n.multipleBond, "off"), this.bondSpacing = wu(n.bondSpacing, 1), this.bondScale = wu(n.bondScale, .4), this.linewidth = wu(n.linewidth, 2), e.prototype.init.call(this, n);
            }, t.prototype.getAtomRadius = function (t) {
              return this.aspectRatio * e.prototype.getAtomRadius.call(this, t);
            }, t.prototype.getAtomParams = function (t, n) {
              var r = e.prototype.getAtomParams.call(this, t, n);
              return r.radiusParams.scale *= this.aspectRatio, r;
            }, t.prototype.getAtomData = function (e, t, n) {
              return e.getAtomData(this.getAtomParams(t, n));
            }, t.prototype.getBondParams = function (t, n) {
              return n = Object.assign({
                multipleBond: this.multipleBond,
                bondSpacing: this.bondSpacing,
                bondScale: this.bondScale
              }, n), e.prototype.getBondParams.call(this, t, n);
            }, t.prototype.getBondData = function (e, t, n) {
              return e.getBondData(this.getBondParams(t, n));
            }, t.prototype.createData = function (e) {
              var t = [];
              if (this.lineOnly) this.lineBuffer = new u_(this.getBondData(e, {
                position: !0,
                color: !0,
                picking: !0
              }), this.getBufferParams({
                linewidth: this.linewidth
              })), t.push(this.lineBuffer);else {
                var n = new A_(this.getBondData(e), this.getBufferParams({
                  openEnded: this.openEnded,
                  radialSegments: this.radialSegments,
                  disableImpostor: this.disableImpostor,
                  dullInterior: !0
                }));
                if (t.push(n), !this.cylinderOnly) {
                  var r = new _y(this.getAtomData(e), this.getBufferParams({
                    sphereDetail: this.sphereDetail,
                    disableImpostor: this.disableImpostor,
                    dullInterior: !0
                  }));
                  t.push(r);
                }
              }
              return {
                bufferList: t
              };
            }, t.prototype.updateData = function (e, t) {
              "off" !== this.multipleBond && e && e.radius && (e.position = !0);
              var n = this.getBondData(t.sview, e);
              if (this.lineOnly) {
                var r = {};
                e && !e.position || Object.assign(r, {
                  position1: n.position1,
                  position2: n.position2
                }), e && !e.color || Object.assign(r, {
                  color: n.color,
                  color2: n.color2
                }), t.bufferList[0].setAttributes(r);
              } else {
                var i = {};
                if (e && !e.position || Object.assign(i, {
                  position1: n.position1,
                  position2: n.position2
                }), e && !e.color || Object.assign(i, {
                  color: n.color,
                  color2: n.color2
                }), e && !e.radius || Object.assign(i, {
                  radius: n.radius
                }), t.bufferList[0].setAttributes(i), !this.cylinderOnly) {
                  var o = this.getAtomData(t.sview, e),
                    a = {};
                  e && !e.position || Object.assign(a, {
                    position: o.position
                  }), e && !e.color || Object.assign(a, {
                    color: o.color
                  }), e && !e.radius || Object.assign(a, {
                    radius: o.radius
                  }), t.bufferList[1].setAttributes(a);
                }
              }
            }, t.prototype.setParameters = function (t) {
              void 0 === t && (t = {});
              var n = !1,
                r = {};
              return (t.aspectRatio || t.bondSpacing || t.bondScale) && (Object.assign(r, {
                radius: !0
              }), Kc && !this.disableImpostor || (n = !0)), e.prototype.setParameters.call(this, t, r, n), this;
            }, t;
          }(Xb);
          rd.add("ball+stick", T_);
          var M_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "backbone", this.parameters = Object.assign({}, this.parameters, {
                multipleBond: null,
                bondSpacing: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.aspectRatio = wu(n.aspectRatio, 1), n.radiusSize = wu(n.radiusSize, .25), e.prototype.init.call(this, n);
            }, t.prototype.getAtomRadius = function (t) {
              return t.isTrace() ? e.prototype.getAtomRadius.call(this, t) : 0;
            }, t.prototype.getAtomData = function (e, t, n) {
              return e.getBackboneAtomData(this.getAtomParams(t, n));
            }, t.prototype.getBondData = function (e, t, n) {
              return e.getBackboneBondData(this.getBondParams(t, n));
            }, t;
          }(T_);
          rd.add("backbone", M_);
          var C_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "base", this.parameters = Object.assign({}, this.parameters, {
                multipleBond: null,
                bondSpacing: null
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.aspectRatio = wu(n.aspectRatio, 1), n.radiusSize = wu(n.radiusSize, .3), e.prototype.init.call(this, n);
            }, t.prototype.getAtomData = function (e, t, n) {
              return e.getRungAtomData(this.getAtomParams(t, n));
            }, t.prototype.getBondData = function (e, t, n) {
              var r = this.getBondParams(t, n);
              return Object.assign(r.colorParams, {
                rung: !0
              }), e.getRungBondData(r);
            }, t;
          }(T_);
          rd.add("base", C_);
          var k_ = function k_(e, t) {
            this.m = e, this.tension = t, this.dt = 1 / this.m, this.delta = 1e-4, this.vec1 = new ae(), this.vec2 = new ae(), this.vDir = new ae(), this.vTan = new ae(), this.vNorm = new ae(), this.vBin = new ae(), this.m2 = Math.ceil(this.m / 2);
          };
          k_.prototype.interpolateToArr = function (e, t, n, r, i, o, a) {
            o[a + 0] = Qu(e.x, t.x, n.x, r.x, i, this.tension), o[a + 1] = Qu(e.y, t.y, n.y, r.y, i, this.tension), o[a + 2] = Qu(e.z, t.z, n.z, r.z, i, this.tension);
          }, k_.prototype.interpolateToVec = function (e, t, n, r, i, o) {
            o.x = Qu(e.x, t.x, n.x, r.x, i, this.tension), o.y = Qu(e.y, t.y, n.y, r.y, i, this.tension), o.z = Qu(e.z, t.z, n.z, r.z, i, this.tension);
          }, k_.prototype.interpolatePosition = function (e, t, n, r, i, o) {
            for (var a = 0; a < this.m; ++a) {
              var s = o + 3 * a,
                l = this.dt * a;
              this.interpolateToArr(e, t, n, r, l, i, s);
            }
          }, k_.prototype.interpolateTangent = function (e, t, n, r, i, o) {
            for (var a = this, s = 0; s < this.m; ++s) {
              var l = a.dt * s,
                u = l - a.delta,
                c = l + a.delta,
                d = o + 3 * s;
              u < 0 && (u = 0), 1 < c && (c = 1), a.interpolateToVec(e, t, n, r, u, a.vec1), a.interpolateToVec(e, t, n, r, c, a.vec2), a.vec2.sub(a.vec1).normalize(), a.vec2.toArray(i, d);
            }
          }, k_.prototype.vectorSubdivide = function (e, t, n, r, i) {
            for (var o, a = t.next(), s = t.next(), l = t.next(), u = t.size, c = u - 1, d = r || 0, h = 0; h < c; ++h) o = a, a = s, s = l, l = t.next(), e.apply(this, [o, a, s, l, n, d]), d += 3 * this.m;
            i && (o = t.get(u - 2), a = t.get(u - 1), s = t.get(0), l = t.get(1), e.apply(this, [o, a, s, l, n, d]), d += 3 * this.m);
          }, k_.prototype.getPosition = function (e, t, n, r) {
            e.reset(), this.vectorSubdivide(this.interpolatePosition, e, t, n, r);
            var i = e.size - 1,
              o = i * this.m * 3;
            r && (o += 3 * this.m);
            var a = e.get(r ? 0 : i);
            t[o] = a.x, t[o + 1] = a.y, t[o + 2] = a.z;
          }, k_.prototype.getTangent = function (e, t, n, r) {
            e.reset(), this.vectorSubdivide(this.interpolateTangent, e, t, n, r);
            var i = (e.size - 1) * this.m * 3;
            r && (i += 3 * this.m), Yd(t, t, i - 3, i, 3);
          }, k_.prototype.interpolateNormalDir = function (e, t, n, r, i, o, a, s, l, u, c, d, h) {
            for (var f = this, p = 0; p < this.m; ++p) {
              var m = d + 3 * p;
              h && (m += 3 * f.m2);
              var g = f.dt * p;
              f.interpolateToVec(e, t, n, r, g, f.vec1), f.interpolateToVec(i, o, a, s, g, f.vec2), f.vDir.subVectors(f.vec2, f.vec1).normalize(), f.vTan.fromArray(l, m), f.vBin.crossVectors(f.vDir, f.vTan).normalize(), f.vBin.toArray(c, m), f.vNorm.crossVectors(f.vTan, f.vBin).normalize(), f.vNorm.toArray(u, m);
            }
          }, k_.prototype.interpolateNormal = function (e, t, n, r, i) {
            for (var o = 0; o < this.m; ++o) {
              var a = i + 3 * o;
              e.copy(this.vNorm), this.vTan.fromArray(t, a), this.vBin.crossVectors(e, this.vTan).normalize(), this.vBin.toArray(r, a), this.vNorm.crossVectors(this.vTan, this.vBin).normalize(), this.vNorm.toArray(n, a);
            }
          }, k_.prototype.getNormal = function (e, t, n, r, i, o) {
            this.vNorm.set(0, 0, 1);
            for (var a = e - 1, s = i || 0, l = 0; l < a; ++l) this.interpolateNormal(this.vDir, t, n, r, s), s += 3 * this.m;
            o && (this.interpolateNormal(this.vDir, t, n, r, s), s += 3 * this.m), this.vBin.toArray(r, s), this.vNorm.toArray(n, s);
          }, k_.prototype.getNormalDir = function (e, t, n, r, i, o, a, s) {
            e.reset(), t.reset();
            var l = new ae(),
              u = new ae(),
              c = new ae(),
              d = new ae(),
              h = new ae(),
              f = new ae().copy(e.next()),
              p = new ae().copy(e.next()),
              m = new ae().copy(e.next()),
              g = new ae(),
              v = new ae().copy(t.next()),
              y = new ae().copy(t.next()),
              b = new ae().copy(t.next());
            this.vNorm.set(0, 0, 1);
            for (var _ = e.size, x = _ - 1, w = o || 0, S = 0; S < x; ++S) h.copy(f), f.copy(p), p.copy(m), m.copy(e.next()), g.copy(v), v.copy(y), y.copy(b), b.copy(t.next()), 0 === S ? (l.subVectors(g, h), u.subVectors(v, f), l.dot(u) < 0 && (u.multiplyScalar(-1), v.addVectors(f, u)), c.subVectors(y, p), u.dot(c) < 0 && (c.multiplyScalar(-1), y.addVectors(p, c))) : c.copy(d), d.subVectors(b, m), c.dot(d) < 0 && (d.multiplyScalar(-1), b.addVectors(m, d)), this.interpolateNormalDir(h, f, p, m, g, v, y, b, n, r, i, w, s), w += 3 * this.m;
            if (a && (h.copy(e.get(_ - 2)), f.copy(e.get(_ - 1)), p.copy(e.get(0)), m.copy(e.get(1)), g.copy(t.get(_ - 2)), v.copy(t.get(_ - 1)), y.copy(t.get(0)), b.copy(t.get(1)), c.copy(d), d.subVectors(b, m), c.dot(d) < 0 && (d.multiplyScalar(-1), b.addVectors(m, d)), this.interpolateNormalDir(h, f, p, m, g, v, y, b, n, r, i, w, s), w += 3 * this.m), s) {
              this.vBin.fromArray(i, 3 * this.m2), this.vNorm.fromArray(r, 3 * this.m2);
              for (var A = 0; A < this.m2; ++A) this.vBin.toArray(i, 3 * A), this.vNorm.toArray(r, 3 * A);
            } else this.vBin.toArray(i, w), this.vNorm.toArray(r, w);
          }, k_.prototype.interpolateColor = function (e, t, n, r, i) {
            var o, a;
            for (o = 0; o < this.m2; ++o) a = i + 3 * o, n.apply(this, [e, r, a]);
            for (o = this.m2; o < this.m; ++o) a = i + 3 * o, n.apply(this, [t, r, a]);
          }, k_.prototype.getColor = function (e, t, n, r, i) {
            var o;
            e.reset(), e.next();
            for (var a = e.next(), s = e.size, l = s - 1, u = r || 0, c = 0; c < l; ++c) o = a, a = e.next(), this.interpolateColor(o, a, t, n, u), u += 3 * this.m;
            i && (o = e.get(s - 1), a = e.get(0), this.interpolateColor(o, a, t, n, u), u += 3 * this.m), n[u] = n[u - 3], n[u + 1] = n[u - 2], n[u + 2] = n[u - 1];
          }, k_.prototype.interpolatePicking = function (e, t, n, r, i) {
            var o;
            for (o = 0; o < this.m2; ++o) r[i + o] = n.apply(this, [e]);
            for (o = this.m2; o < this.m; ++o) r[i + o] = n.apply(this, [t]);
          }, k_.prototype.getPicking = function (e, t, n, r, i) {
            var o;
            e.reset(), e.next();
            for (var a = e.next(), s = e.size, l = s - 1, u = r || 0, c = 0; c < l; ++c) o = a, a = e.next(), this.interpolatePicking(o, a, t, n, u), u += this.m;
            i && (o = e.get(s - 1), a = e.get(0), this.interpolatePicking(o, a, t, n, u), u += this.m), n[u] = n[u - 1];
          }, k_.prototype.interpolateSize = function (e, t, n, r, i) {
            for (var o = n.apply(this, [e]), a = n.apply(this, [t]), s = 0; s < this.m; ++s) {
              var l = s / this.m;
              r[i + s] = (1 - l) * o + l * a;
            }
          }, k_.prototype.getSize = function (e, t, n, r, i) {
            var o;
            e.reset(), e.next();
            for (var a = e.next(), s = e.size, l = s - 1, u = r || 0, c = 0; c < l; ++c) o = a, a = e.next(), this.interpolateSize(o, a, t, n, u), u += this.m;
            i && (o = e.get(s - 1), a = e.get(0), this.interpolateSize(o, a, t, n, u), u += this.m), n[u] = n[u - 1];
          };
          var P_ = function P_(e, t) {
            this.polymer = e, this.size = e.residueCount;
            var n = t || {};
            this.directional = n.directional || !1, this.positionIterator = n.positionIterator || !1, this.subdiv = n.subdiv || 1, this.smoothSheet = n.smoothSheet || !1, n.tension ? this.tension = n.tension : this.tension = this.polymer.isNucleic() ? .5 : .9, this.interpolator = new k_(this.subdiv, this.tension);
          };
          P_.prototype.getAtomIterator = function (e, t) {
            var n = this.polymer,
              r = n.structure,
              i = n.residueCount,
              o = 0,
              a = -1,
              s = [r.getAtomProxy(), r.getAtomProxy(), r.getAtomProxy(), r.getAtomProxy()],
              l = [new ae(), new ae(), new ae(), new ae()],
              u = r.getAtomProxy(),
              c = r.getAtomProxy();
            function d(r) {
              var a = s[o % 4];
              if (a.index = n.getAtomIndexByType(r, e), t && 0 < r && r < i && "e" === a.sstruc) {
                var d = l[o % 4];
                return u.index = n.getAtomIndexByType(r + 1, e), c.index = n.getAtomIndexByType(r - 1, e), d.addVectors(u, c).add(a).add(a).multiplyScalar(.25), o += 1, d;
              }
              return o += 1, a;
            }
            return {
              size: i,
              next: function next() {
                var e = d(a);
                return a += 1, e;
              },
              get: d,
              reset: function reset() {
                o = 0, a = -1;
              }
            };
          }, P_.prototype.getSubdividedColor = function (e) {
            var t = this.subdiv,
              n = this.polymer,
              r = (n.residueCount - 1) * t * 3 + 3;
            n.isCyclic && (r += 3 * t);
            var i = new Float32Array(r),
              o = this.getAtomIterator("trace"),
              a = e || {};
            a.structure = n.structure;
            var s = td.getScheme(a);
            return this.interpolator.getColor(o, function (e, t, n) {
              s.atomColorToArray(e, t, n);
            }, i, 0, n.isCyclic), {
              color: i
            };
          }, P_.prototype.getSubdividedPicking = function () {
            var e = this.subdiv,
              t = this.polymer,
              n = (t.residueCount - 1) * e + 1;
            t.isCyclic && (n += e);
            var r = t.structure,
              i = this.getAtomIterator("trace"),
              o = new Float32Array(n);
            return this.interpolator.getPicking(i, function (e) {
              return e.index;
            }, o, 0, t.isCyclic), {
              picking: new am(o, r)
            };
          }, P_.prototype.getSubdividedPosition = function () {
            return {
              position: this.getPosition()
            };
          }, P_.prototype.getSubdividedOrientation = function () {
            var e = this.getTangent(),
              t = this.getNormals(e);
            return {
              tangent: e,
              normal: t.normal,
              binormal: t.binormal
            };
          }, P_.prototype.getSubdividedSize = function (e) {
            var t = this.subdiv,
              n = this.polymer,
              r = (n.residueCount - 1) * t + 1;
            n.isCyclic && (r += t);
            var i = new Float32Array(r),
              o = this.getAtomIterator("trace"),
              a = new Ng(e);
            return this.interpolator.getSize(o, function (e) {
              return a.atomRadius(e);
            }, i, 0, n.isCyclic), {
              size: i
            };
          }, P_.prototype.getPosition = function () {
            var e = this.subdiv,
              t = this.polymer,
              n = (t.residueCount - 1) * e * 3 + 3;
            t.isCyclic && (n += 3 * e);
            var r = new Float32Array(n),
              i = this.positionIterator || this.getAtomIterator("trace", this.smoothSheet);
            return this.interpolator.getPosition(i, r, 0, t.isCyclic), r;
          }, P_.prototype.getTangent = function () {
            var e = this.subdiv,
              t = this.polymer,
              n = (this.size - 1) * e * 3 + 3;
            t.isCyclic && (n += 3 * e);
            var r = new Float32Array(n),
              i = this.positionIterator || this.getAtomIterator("trace", this.smoothSheet);
            return this.interpolator.getTangent(i, r, 0, t.isCyclic), r;
          }, P_.prototype.getNormals = function (e) {
            var t = this.subdiv,
              n = this.polymer,
              r = n.isProtein(),
              i = this.size,
              o = (i - 1) * t * 3 + 3;
            n.isCyclic && (o += 3 * t);
            var a = new Float32Array(o),
              s = new Float32Array(o);
            if (this.directional && !this.polymer.isCg()) {
              var l = this.getAtomIterator("direction1"),
                u = this.getAtomIterator("direction2");
              this.interpolator.getNormalDir(l, u, e, a, s, 0, n.isCyclic, r);
            } else this.interpolator.getNormal(i, e, a, s, 0, n.isCyclic);
            return {
              normal: a,
              binormal: s
            };
          };
          var O_ = new ae(),
            R_ = new ae(),
            I_ = Object.assign({
              radialSegments: 4,
              capped: !1,
              aspectRatio: 1
            }, ig),
            j_ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, function (e, t) {
                  void 0 === t && (t = {});
                  var n = wu(t.radialSegments, 4),
                    r = wu(t.capped, !1),
                    i = r ? n : 0,
                    o = r ? n - 2 : 0,
                    a = e.position.length / 3,
                    s = a * n * 3 + 2 * i * 3,
                    l = 2 * (a - 1) * n * 3 + 2 * o * 3;
                  return {
                    position: new Float32Array(s),
                    color: new Float32Array(s),
                    index: Nu(l, s / 3),
                    normal: new Float32Array(s),
                    picking: e.picking
                  };
                }(t, n), n), this.capVertices = this.parameters.capped ? this.parameters.radialSegments : 0, this.capTriangles = this.parameters.capped ? this.parameters.radialSegments - 2 : 0, this.size2 = t.position.length / 3, t.primitiveId = Wd(this.size2), this.setAttributes(t), this.makeIndex();
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return I_;
              }, t.prototype.setAttributes = function (e) {
                void 0 === e && (e = {});
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h,
                  f,
                  p = this.parameters.aspectRatio,
                  m = this.size2,
                  g = m - 1,
                  v = this.parameters.radialSegments,
                  y = this.geometry.attributes;
                e.position && (t = e.position, n = e.normal, r = e.binormal, i = e.tangent, a = e.size, l = y.position.array, c = y.normal.array, y.position.needsUpdate = !0, y.normal.needsUpdate = !0), e.color && (o = e.color, u = y.color.array, y.color.needsUpdate = !0), e.primitiveId && (s = e.primitiveId, d = y.primitiveId.array, y.primitiveId.needsUpdate = !0);
                var b = 0,
                  _ = 0,
                  x = 0,
                  w = 0,
                  S = 0,
                  A = 0,
                  E = 0,
                  T = 0,
                  M = 0,
                  C = 0,
                  k = [],
                  P = [],
                  O = [],
                  R = [],
                  I = [],
                  j = [];
                if (t) for (var N = 0; N < v; ++N) {
                  var L = N / v * 2 * Math.PI;
                  k[N] = p * Math.cos(L), P[N] = Math.sin(L), O[N] = p * Math.cos(L - .01), R[N] = Math.sin(L - .01), I[N] = p * Math.cos(L + .01), j[N] = Math.sin(L + .01);
                }
                for (var D = 0; D < m; ++D) {
                  f = (h = 3 * D) * v, t && i && n && r && a && (O_.set(i[h], i[h + 1], i[h + 2]), _ = n[h], x = n[h + 1], w = n[h + 2], S = r[h], A = r[h + 1], E = r[h + 2], T = t[h], M = t[h + 1], C = t[h + 2], b = a[D]);
                  for (var B = 0; B < v; ++B) {
                    var F = f + 3 * B;
                    if (t) {
                      var z = -b * k[B],
                        U = b * P[B],
                        G = -b * O[B],
                        V = b * R[B],
                        H = -b * I[B],
                        q = b * j[B];
                      l[F] = T + z * _ + U * S, l[F + 1] = M + z * x + U * A, l[F + 2] = C + z * w + U * E, R_.set(H * _ + q * S - (G * _ + V * S), H * x + q * A - (G * x + V * A), H * w + q * E - (G * w + V * E)).cross(O_), c[F] = R_.x, c[F + 1] = R_.y, c[F + 2] = R_.z;
                    }
                    o && (u[F] = o[h], u[F + 1] = o[h + 1], u[F + 2] = o[h + 2]), s && (d[D * v + B] = s[D]);
                  }
                }
                f = 3 * m * v;
                for (var W = h = 0; W < v; ++W) {
                  var $ = h + 3 * W,
                    X = f + 3 * W;
                  t && i && (l[X] = l[$], l[X + 1] = l[$ + 1], l[X + 2] = l[$ + 2], c[X] = i[h], c[X + 1] = i[h + 1], c[X + 2] = i[h + 2]), o && (u[X] = u[$], u[X + 1] = u[$ + 1], u[X + 2] = u[$ + 2]), s && (d[m * v + W] = d[0 + W]);
                }
                h = 3 * (m - 1) * v, f = 3 * (m + 1) * v;
                for (var Y = 0; Y < v; ++Y) {
                  var K = h + 3 * Y,
                    Z = f + 3 * Y;
                  t && i && (l[Z] = l[K], l[Z + 1] = l[K + 1], l[Z + 2] = l[K + 2], c[Z] = i[3 * g], c[Z + 1] = i[3 * g + 1], c[Z + 2] = i[3 * g + 2]), o && (u[Z] = u[K], u[Z + 1] = u[K + 1], u[Z + 2] = u[K + 2]), s && (d[(m + 1) * v + Y] = d[(m - 1) * v + Y]);
                }
              }, t.prototype.makeIndex = function () {
                for (var e, t, n = this.geometry.getIndex().array, r = this.size2, i = r - 1, o = this.capTriangles, a = this.parameters.radialSegments, s = this.parameters.radialSegments + 1, l = 0; l < i; ++l) for (var u = l * a * 3 * 2, c = l * a, d = (l + 1) * a, h = 0; h < a; ++h) n[t = u + 3 * h * 2] = c + h, n[t + 1] = c + (h + 1) % a, n[t + 2] = d + h, n[t + 3] = d + h, n[t + 4] = c + (h + 1) % a, n[t + 5] = d + (h + 1) % a;
                for (var f = [0], p = 1; p < s / 2; ++p) f.push(p), a - p !== p && f.push(a - p);
                t = i * a * 3 * 2, e = r * a;
                for (var m = 0; m < f.length - 2; ++m) m % 2 == 0 ? (n[t + 3 * m + 0] = e + f[m + 0], n[t + 3 * m + 1] = e + f[m + 1], n[t + 3 * m + 2] = e + f[m + 2]) : (n[t + 3 * m + 0] = e + f[m + 2], n[t + 3 * m + 1] = e + f[m + 1], n[t + 3 * m + 2] = e + f[m + 0]);
                t = i * a * 3 * 2 + 3 * o, e = r * a + a;
                for (var g = 0; g < f.length - 2; ++g) g % 2 == 0 ? (n[t + 3 * g + 0] = e + f[g + 0], n[t + 3 * g + 1] = e + f[g + 1], n[t + 3 * g + 2] = e + f[g + 2]) : (n[t + 3 * g + 0] = e + f[g + 2], n[t + 3 * g + 1] = e + f[g + 1], n[t + 3 * g + 2] = e + f[g + 0]);
              }, Object.defineProperties(t.prototype, n), t;
            }(lg),
            N_ = function (e) {
              function n(t, n, r) {
                e.call(this, t, n, r), this.type = "cartoon", this.parameters = Object.assign({
                  aspectRatio: {
                    type: "number",
                    precision: 1,
                    max: 10,
                    min: 1,
                    rebuild: !0
                  },
                  subdiv: {
                    type: "integer",
                    max: 50,
                    min: 1,
                    rebuild: !0
                  },
                  radialSegments: {
                    type: "integer",
                    max: 50,
                    min: 1,
                    rebuild: !0
                  },
                  tension: {
                    type: "number",
                    precision: 1,
                    max: 1,
                    min: .1
                  },
                  capped: {
                    type: "boolean",
                    rebuild: !0
                  },
                  smoothSheet: {
                    type: "boolean",
                    rebuild: !0
                  }
                }, this.parameters), this.init(r);
              }
              return e && (n.__proto__ = e), ((n.prototype = Object.create(e && e.prototype)).constructor = n).prototype.init = function (t) {
                var n = t || {};
                n.colorScheme = wu(n.colorScheme, "chainname"), n.colorScale = wu(n.colorScale, "RdYlBu"), n.radiusType = wu(n.radiusType, "sstruc"), n.radiusScale = wu(n.radiusScale, .7), n.useInteriorColor = wu(n.useInteriorColor, !0), this.aspectRatio = wu(n.aspectRatio, 5), this.tension = wu(n.tension, NaN), this.capped = wu(n.capped, !0), this.smoothSheet = wu(n.smoothSheet, !1), "low" === n.quality ? (this.subdiv = 3, this.radialSegments = 6) : "medium" === n.quality ? this.subdiv = 6 : "high" === n.quality ? this.subdiv = 12 : this.subdiv = wu(n.subdiv, 6), e.prototype.init.call(this, n);
              }, n.prototype.getSplineParams = function (e) {
                return Object.assign({
                  subdiv: this.subdiv,
                  tension: this.tension,
                  directional: 1 !== this.aspectRatio,
                  smoothSheet: this.smoothSheet
                }, e);
              }, n.prototype.getSpline = function (e) {
                return new P_(e, this.getSplineParams());
              }, n.prototype.getAspectRatio = function (e) {
                return e.isCg() ? 1 : this.aspectRatio;
              }, n.prototype.getAtomRadius = function (t) {
                return t.isTrace() ? e.prototype.getAtomRadius.call(this, t) : 0;
              }, n.prototype.createData = function (e) {
                var t = this,
                  n = [],
                  r = [];
                return this.structure.eachPolymer(function (e) {
                  if (!(e.residueCount < 4)) {
                    r.push(e);
                    var i = t.getSpline(e),
                      o = t.getAspectRatio(e),
                      a = i.getSubdividedPosition(),
                      s = i.getSubdividedOrientation(),
                      l = i.getSubdividedColor(t.getColorParams()),
                      u = i.getSubdividedPicking(),
                      c = i.getSubdividedSize(t.getRadiusParams());
                    n.push(new j_(Object.assign({}, a, s, l, u, c), t.getBufferParams({
                      radialSegments: t.radialSegments,
                      aspectRatio: o,
                      capped: t.capped
                    })));
                  }
                }, e.getSelection()), {
                  bufferList: n,
                  polymerList: r
                };
              }, n.prototype.updateData = function (e, n) {
                t.Debug && Zc.time(this.type + " repr update"), e = e || {};
                for (var r = 0, i = n.polymerList.length; r < i; ++r) {
                  var o = {},
                    a = n.polymerList[r],
                    s = this.getSpline(a),
                    l = this.getAspectRatio(a);
                  if (Object.assign(n.bufferList[r], {
                    aspectRatio: l
                  }), e.position || e.radius) {
                    var u = s.getSubdividedPosition(),
                      c = s.getSubdividedOrientation(),
                      d = s.getSubdividedSize(this.getRadiusParams(l));
                    o.position = u.position, o.normal = c.normal, o.binormal = c.binormal, o.tangent = c.tangent, o.size = d.size;
                  }
                  if (e.color) {
                    var h = s.getSubdividedColor(this.getColorParams());
                    o.color = h.color;
                  }
                  if (e.picking) {
                    var f = s.getSubdividedPicking();
                    o.picking = f.picking;
                  }
                  n.bufferList[r].setAttributes(o);
                }
                t.Debug && Zc.timeEnd(this.type + " repr update");
              }, n.prototype.setParameters = function (t) {
                var n = {};
                return t && t.aspectRatio && (n.radius = !0), t && t.tension && (n.position = !0), e.prototype.setParameters.call(this, t, n, !1), this;
              }, n;
            }(Xb);
          rd.add("cartoon", N_);
          var L_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "contact", this.parameters = Object.assign({
                hydrogenBond: {
                  type: "boolean",
                  rebuild: !0
                },
                weakHydrogenBond: {
                  type: "boolean",
                  rebuild: !0
                },
                waterHydrogenBond: {
                  type: "boolean",
                  rebuild: !0
                },
                backboneHydrogenBond: {
                  type: "boolean",
                  rebuild: !0
                },
                hydrophobic: {
                  type: "boolean",
                  rebuild: !0
                },
                halogenBond: {
                  type: "boolean",
                  rebuild: !0
                },
                ionicInteraction: {
                  type: "boolean",
                  rebuild: !0
                },
                metalCoordination: {
                  type: "boolean",
                  rebuild: !0
                },
                cationPi: {
                  type: "boolean",
                  rebuild: !0
                },
                piStacking: {
                  type: "boolean",
                  rebuild: !0
                },
                filterSele: {
                  type: "text",
                  rebuild: !0
                },
                labelVisible: {
                  type: "boolean",
                  rebuild: !0
                },
                labelFixedSize: {
                  type: "boolean",
                  buffer: "fixedSize"
                },
                labelSize: {
                  type: "number",
                  precision: 3,
                  max: 10,
                  min: .001,
                  rebuild: !0
                },
                labelUnit: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    "": "",
                    angstrom: "angstrom",
                    nm: "nm"
                  }
                },
                maxHydrophobicDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxHbondDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxHbondSulfurDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxHbondAccAngle: {
                  type: "integer",
                  max: 180,
                  min: 0,
                  rebuild: !0
                },
                maxHbondDonAngle: {
                  type: "integer",
                  max: 180,
                  min: 0,
                  rebuild: !0
                },
                maxHbondAccPlaneAngle: {
                  type: "integer",
                  max: 90,
                  min: 0,
                  rebuild: !0
                },
                maxHbondDonPlaneAngle: {
                  type: "integer",
                  max: 90,
                  min: 0,
                  rebuild: !0
                },
                maxPiStackingDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxPiStackingOffset: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxPiStackingAngle: {
                  type: "integer",
                  max: 180,
                  min: 0,
                  rebuild: !0
                },
                maxCationPiDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxCationPiOffset: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxIonicDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxHalogenBondDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                maxHalogenBondAngle: {
                  type: "integer",
                  max: 180,
                  min: 0,
                  rebuild: !0
                },
                maxMetalDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: .1,
                  rebuild: !0
                },
                refineSaltBridges: {
                  type: "boolean",
                  rebuild: !0
                },
                masterModelIndex: {
                  type: "integer",
                  max: 1e3,
                  min: -1,
                  rebuild: !0
                },
                lineOfSightDistFactor: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: 0,
                  rebuild: !0
                },
                radialSegments: !0,
                disableImpostor: !0
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.radiusSize = wu(n.radiusSize, .05), n.useInteriorColor = wu(n.useInteriorColor, !0), this.hydrogenBond = wu(n.hydrogenBond, !0), this.weakHydrogenBond = wu(n.weakHydrogenBond, !1), this.waterHydrogenBond = wu(n.waterHydrogenBond, !1), this.backboneHydrogenBond = wu(n.backboneHydrogenBond, !1), this.hydrophobic = wu(n.hydrophobic, !1), this.halogenBond = wu(n.halogenBond, !0), this.ionicInteraction = wu(n.ionicInteraction, !0), this.metalCoordination = wu(n.metalCoordination, !0), this.cationPi = wu(n.cationPi, !0), this.piStacking = wu(n.piStacking, !0), this.filterSele = wu(n.filterSele, ""), this.labelVisible = wu(n.labelVisible, !1), this.labelFixedSize = wu(n.labelFixedSize, !1), this.labelSize = wu(n.labelSize, 2), this.labelUnit = wu(n.labelUnit, ""), this.maxHydrophobicDist = wu(n.maxHydrophobicDist, 4), this.maxHbondDist = wu(n.maxHbondDist, 3.5), this.maxHbondSulfurDist = wu(n.maxHbondSulfurDist, 4.1), this.maxHbondAccAngle = wu(n.maxHbondAccAngle, 45), this.maxHbondDonAngle = wu(n.maxHbondDonAngle, 45), this.maxHbondAccPlaneAngle = wu(n.maxHbondAccPlaneAngle, 90), this.maxHbondDonPlaneAngle = wu(n.maxHbondDonPlaneAngle, 30), this.maxPiStackingDist = wu(n.maxPiStackingDist, 5.5), this.maxPiStackingOffset = wu(n.maxPiStackingOffset, 2), this.maxPiStackingAngle = wu(n.maxPiStackingAngle, 30), this.maxCationPiDist = wu(n.maxCationPiDist, 6), this.maxCationPiOffset = wu(n.maxCationPiOffset, 2), this.maxIonicDist = wu(n.maxIonicDist, 5), this.maxHalogenBondDist = wu(n.maxHalogenBondDist, 3.5), this.maxHalogenBondAngle = wu(n.maxHalogenBondAngle, 30), this.maxMetalDist = wu(n.maxMetalDist, 3), this.refineSaltBridges = wu(n.refineSaltBridges, !0), this.masterModelIndex = wu(n.masterModelIndex, -1), this.lineOfSightDistFactor = wu(n.lineOfSightDistFactor, 1), e.prototype.init.call(this, n);
            }, t.prototype.getAtomRadius = function () {
              return 0;
            }, t.prototype.getContactData = function (e) {
              var t = {
                  maxHydrophobicDist: this.maxHydrophobicDist,
                  maxHbondDist: this.maxHbondDist,
                  maxHbondSulfurDist: this.maxHbondSulfurDist,
                  maxHbondAccAngle: this.maxHbondAccAngle,
                  maxHbondDonAngle: this.maxHbondDonAngle,
                  maxHbondAccPlaneAngle: this.maxHbondAccPlaneAngle,
                  maxHbondDonPlaneAngle: this.maxHbondDonPlaneAngle,
                  maxPiStackingDist: this.maxPiStackingDist,
                  maxPiStackingOffset: this.maxPiStackingOffset,
                  maxPiStackingAngle: this.maxPiStackingAngle,
                  maxCationPiDist: this.maxCationPiDist,
                  maxCationPiOffset: this.maxCationPiOffset,
                  maxIonicDist: this.maxIonicDist,
                  maxHalogenBondDist: this.maxHalogenBondDist,
                  maxHalogenBondAngle: this.maxHalogenBondAngle,
                  maxMetalDist: this.maxMetalDist,
                  refineSaltBridges: this.refineSaltBridges,
                  masterModelIndex: this.masterModelIndex,
                  lineOfSightDistFactor: this.lineOfSightDistFactor
                },
                n = {
                  hydrogenBond: this.hydrogenBond,
                  weakHydrogenBond: this.weakHydrogenBond,
                  waterHydrogenBond: this.waterHydrogenBond,
                  backboneHydrogenBond: this.backboneHydrogenBond,
                  hydrophobic: this.hydrophobic,
                  halogenBond: this.halogenBond,
                  ionicInteraction: this.ionicInteraction,
                  metalCoordination: this.metalCoordination,
                  cationPi: this.cationPi,
                  piStacking: this.piStacking,
                  radius: this.radiusSize * this.radiusScale,
                  filterSele: this.filterSele
                };
              return function (e, t, n) {
                var r = Su(n, Jp),
                  i = [];
                r.hydrogenBond && i.push(4), r.hydrophobic && i.push(6), r.halogenBond && i.push(5), r.ionicInteraction && i.push(1), r.metalCoordination && i.push(7), r.cationPi && i.push(2), r.piStacking && i.push(3), r.weakHydrogenBond && i.push(8), r.waterHydrogenBond && i.push(9), r.backboneHydrogenBond && i.push(10);
                var o,
                  a = e.features,
                  s = e.contactSet,
                  l = e.contactStore,
                  u = a.centers,
                  c = a.atomSets,
                  d = u.x,
                  h = u.y,
                  f = u.z,
                  p = l.index1,
                  m = l.index2,
                  g = l.type,
                  v = [],
                  y = [],
                  b = [],
                  _ = [],
                  x = [];
                return r.filterSele && (o = Array.isArray(r.filterSele) ? r.filterSele.map(function (e) {
                  return t.getAtomSet(new Nc(e));
                }) : t.getAtomSet(new Nc(r.filterSele))), s.forEach(function (e) {
                  var t = g[e];
                  if (i.includes(t)) {
                    if (o) {
                      var n = c[p[e]][0],
                        a = c[m[e]][0];
                      if (Array.isArray(o)) {
                        if (!(o[0].isSet(n) && o[1].isSet(a) || o[1].isSet(n) && o[0].isSet(a))) return;
                      } else if (!o.isSet(n) && !o.isSet(a)) return;
                    }
                    var s = p[e],
                      l = m[e];
                    v.push(d[s], h[s], f[s]), y.push(d[l], h[l], f[l]), b.push.apply(b, function (e) {
                      switch (e) {
                        case 4:
                        case 9:
                        case 10:
                          return em.setHex(2851770).toArray();
                        case 6:
                          return em.setHex(8421504).toArray();
                        case 5:
                          return em.setHex(4259775).toArray();
                        case 1:
                          return em.setHex(15779860).toArray();
                        case 7:
                          return em.setHex(9191577).toArray();
                        case 2:
                          return em.setHex(16744448).toArray();
                        case 3:
                          return em.setHex(9220966).toArray();
                        case 8:
                          return em.setHex(12967404).toArray();
                        default:
                          return em.setHex(13421772).toArray();
                      }
                    }(t)), _.push(r.radius), x.push(e);
                  }
                }), {
                  position1: new Float32Array(v),
                  position2: new Float32Array(y),
                  color: new Float32Array(b),
                  color2: new Float32Array(b),
                  radius: new Float32Array(_),
                  picking: new um(x, e, t)
                };
              }(Qp(e, t), e, n);
            }, t.prototype.createData = function (e) {
              var t = this.getContactData(e),
                n = [new A_(If(t), this.getBufferParams({
                  sphereDetail: 1,
                  dullInterior: !0,
                  disableImpostor: this.disableImpostor
                }))];
              if (this.labelVisible) {
                var r = {
                  size: this.labelSize,
                  unit: this.labelUnit
                };
                n.push(new a_(function (e, t) {
                  for (var n = Gd(e.position1, e.position2), r = [], i = Vd(e.position1, e.position2), o = i.length / 3, a = 0; a < o; a++) {
                    var s = 3 * a,
                      l = Math.sqrt(Math.pow(i[s], 2) + Math.pow(i[s + 1], 2) + Math.pow(i[s + 2], 2));
                    switch (t.unit) {
                      case "angstrom":
                        r[a] = l.toFixed(2) + " " + String.fromCharCode(8491);
                        break;
                      case "nm":
                        r[a] = (l / 10).toFixed(2) + " nm";
                        break;
                      default:
                        r[a] = l.toFixed(2);
                    }
                  }
                  return {
                    position: n,
                    size: Hd(n.length / 3, t.size),
                    color: e.color,
                    text: r
                  };
                }(t, r), {
                  fixedSize: this.labelFixedSize
                }));
              }
              return {
                bufferList: n
              };
            }, t;
          }(Xb);
          rd.add("contact", L_);
          var D_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "dihedral", this.parameters = Object.assign({
                atomQuad: {
                  type: "hidden",
                  rebuild: !0
                },
                extendLine: {
                  type: "boolean",
                  rebuild: !0,
                  default: !0
                },
                lineVisible: {
                  type: "boolean",
                  default: !0
                },
                planeVisible: {
                  type: "boolean",
                  default: !0
                },
                sectorVisible: {
                  type: "boolean",
                  default: !0
                }
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.side = wu(n.side, "double"), n.opacity = wu(n.opacity, .5), this.atomQuad = wu(n.atomQuad, []), this.extendLine = wu(n.extendLine, !0), this.lineVisible = wu(n.lineVisible, !0), this.planeVisible = wu(n.planeVisible, !0), this.sectorVisible = wu(n.sectorVisible, !0), e.prototype.init.call(this, n);
            }, t.prototype.createData = function (e) {
              if (e.atomCount && this.atomQuad.length) {
                var t = function (e, t) {
                    void 0 === t && (t = {});
                    for (var n = wu(t.angleStep, Math.PI / 90), r = e.length, i = e.length / 12, o = new Float32Array(i), a = new Float32Array(3 * i), s = new Array(i), l = new Array(i), u = new Array(i), c = new Array(i), d = new Array(i), h = 0, f = 0, p = 0, m = vf(), g = vf(), v = vf(), y = vf(), b = vf(), _ = vf(), x = vf(), w = vf(), S = vf(), A = vf(), E = vf(), T = vf(), M = vf(), C = vf(), k = vf(), P = 0, O = function O(r) {
                        if (wf(m, e, r), wf(g, e, r + 3), wf(v, e, r + 6), wf(y, e, r + 9), _f(b, m, g), _f(_, v, g), 0 !== Af(_)) {
                          _f(x, y, v), Tf(w, _, .5), xf(S, g, w), Mf(b, b), Mf(_, _), Mf(x, x), _f(w, m, S);
                          var i = 0 < bf(w, _);
                          _f(w, y, S);
                          var O = bf(w, _) < 0;
                          if (Tf(w, _, bf(_, b)), _f(A, b, w), Tf(w, _, bf(_, x)), _f(E, x, w), 0 !== Af(A) && 0 !== Af(E)) {
                            Mf(A, A), Mf(E, E);
                            var R = o[P] = Math.acos(bf(A, E));
                            s[P] = (zd * R).toFixed(1) + String.fromCharCode(176), yf(C, A, _), Mf(C, C), bf(C, E) < 0 && Rf(C, C), Zb(w, S, A, C, R / 2), Sf(w, a, 3 * P);
                            var I = Math.ceil(R / n),
                              j = I + (t.extendLine ? 4 : 2),
                              N = t.extendLine ? 36 : 0,
                              L = new Float32Array(3 * j),
                              D = new Float32Array(3 * j),
                              B = new Float32Array(9 * I),
                              F = new Float32Array(N);
                            l[P] = L, u[P] = D, c[P] = B, d[P] = F, t.extendLine && (i ? (_f(w, m, v), Mf(w, w), Tf(T, w, 1 / bf(A, w)), xf(T, T, v)) : (Tf(T, b, 1 / bf(A, b)), xf(T, T, g)), O ? (_f(w, y, g), Mf(w, w), Tf(M, w, 1 / bf(E, w)), xf(M, M, g)) : (Tf(M, x, 1 / bf(E, x)), xf(M, M, v))), xf(k, S, A);
                            var z = 0;
                            t.extendLine ? (Sf(m, L, z), Sf(T, D, z), Sf(T, L, z += 3), Sf(k, D, z), z += 3, Sf(T, F, 0), Sf(k, F, 3), Sf(i ? v : g, F, 6), Sf(i ? v : g, F, 9), Sf(k, F, 12), Sf(S, F, 15)) : (Sf(S, L, z), Sf(k, D, z), z += 3);
                            for (var U = function U(e, t) {
                                var n = 9 * t;
                                Sf(S, B, n), Sf(k, B, n + 3), Sf(k, L, z), Zb(k, S, A, C, e), Sf(k, B, n + 6), Sf(k, D, z), z += 3;
                              }, G = 0, V = n; V < R; V += n) U(V, G++);
                            U(R, G++), t.extendLine ? (Sf(k, L, 3 * (j - 2)), Sf(M, D, 3 * (j - 2)), Sf(M, L, 3 * (j - 1)), Sf(y, D, 3 * (j - 1)), Sf(M, F, 18), Sf(k, F, 21), Sf(O ? g : v, F, 24), Sf(O ? g : v, F, 27), Sf(k, F, 30), Sf(S, F, 33)) : (Sf(k, L, z), Sf(S, D, z), z += 3), h += 3 * j, f += 9 * I, p += N, P += 1;
                          }
                        }
                      }, R = 0; R < r; R += 12) O(R);
                    for (var I = P, j = new Float32Array(h), N = new Float32Array(h), L = new Float32Array(f), D = new Float32Array(p), B = 0, F = 0, z = 0, U = 0; U < I; U++) {
                      var G = l[U],
                        V = u[U],
                        H = c[U],
                        q = d[U];
                      Yd(G, j, 0, B, G.length), Yd(V, N, 0, B, V.length), Yd(H, L, 0, F, H.length), Yd(q, D, 0, z, q.length), B += G.length, F += H.length, z += q.length;
                    }
                    return {
                      labelPosition: a.subarray(0, 3 * I),
                      labelText: s.slice(0, I),
                      linePosition1: j,
                      linePosition2: N,
                      planePosition: D,
                      sectorPosition: L
                    };
                  }(Kb(e, this.atomQuad), {
                    extendLine: this.extendLine
                  }),
                  n = this.n = t.labelText.length,
                  r = new Fe(this.labelColor);
                this.textBuffer = new a_({
                  position: t.labelPosition,
                  size: Hd(n, this.labelSize),
                  color: qd(n, r.r, r.g, r.b),
                  text: t.labelText
                }, this.getLabelBufferParams());
                var i = new Fe(this.colorValue);
                this.lineLength = t.linePosition1.length / 3;
                var o = qd(this.lineLength, i.r, i.g, i.b);
                return this.lineBuffer = new u_(Nf({
                  position1: t.linePosition1,
                  position2: t.linePosition2,
                  color: o,
                  color2: o
                }), this.getBufferParams({
                  linewidth: this.linewidth,
                  visible: this.lineVisible,
                  opacity: this.lineOpacity
                })), this.planeLength = t.planePosition.length / 3, this.planeBuffer = new lg({
                  position: t.planePosition,
                  color: qd(this.planeLength, i.r, i.g, i.b)
                }, this.getBufferParams({
                  visible: this.planeVisible
                })), this.sectorLength = t.sectorPosition.length / 3, this.sectorBuffer = new lg({
                  position: t.sectorPosition,
                  color: qd(this.sectorLength, i.r, i.g, i.b)
                }, this.getBufferParams({
                  visible: this.sectorVisible
                })), {
                  bufferList: [this.textBuffer, this.lineBuffer, this.planeBuffer, this.sectorBuffer]
                };
              }
            }, t.prototype.updateData = function (t, n) {
              e.prototype.updateData.call(this, t, n);
              var r = {},
                i = {},
                o = {};
              if (t.color) {
                var a = new Fe(this.colorValue);
                Object.assign(r, {
                  color: qd(this.lineLength, a.r, a.g, a.b),
                  color2: qd(this.lineLength, a.r, a.g, a.b)
                }), Object.assign(i, {
                  color: qd(this.planeLength, a.r, a.g, a.b)
                }), Object.assign(o, {
                  color: qd(this.sectorLength, a.r, a.g, a.b)
                });
              }
              this.lineBuffer.setAttributes(r), this.planeBuffer.setAttributes(i), this.sectorBuffer.setAttributes(o);
            }, t.prototype.setParameters = function (t) {
              return e.prototype.setParameters.call(this, t, {}, !1), !t || void 0 === t.lineVisible && void 0 === t.sectorVisible && void 0 === t.planeVisible || this.setVisibility(this.visible), t && t.lineOpacity && this.lineBuffer.setParameters({
                opacity: t.lineOpacity
              }), t && void 0 !== t.opacity && this.lineBuffer.setParameters({
                opacity: this.lineOpacity
              }), t && t.linewidth && this.lineBuffer.setParameters({
                linewidth: t.linewidth
              }), this;
            }, t.prototype.setVisibility = function (t, n) {
              return e.prototype.setVisibility.call(this, t, !0), this.lineBuffer && this.lineBuffer.setVisibility(this.lineVisible && this.visible), this.planeBuffer && this.planeBuffer.setVisibility(this.planeVisible && this.visible), this.sectorBuffer && this.sectorBuffer.setVisibility(this.sectorVisible && this.visible), n || this.viewer.requestRender(), this;
            }, t;
          }(Yb);
          rd.add("dihedral", D_);
          var B_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "distance", this.parameters = Object.assign({
                radialSegments: !0,
                openEnded: !0,
                disableImpostor: !0,
                labelUnit: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    "": "",
                    angstrom: "angstrom",
                    nm: "nm"
                  }
                },
                useCylinder: {
                  type: "boolean",
                  rebuild: !0
                },
                atomPair: {
                  type: "hidden",
                  rebuild: !0
                }
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.linewidth = wu(n.linewidth, 5), n.radiusType = wu(n.radiusType, "size"), n.radiusSize = wu(n.radiusSize, .2), this.labelUnit = wu(n.labelUnit, ""), this.useCylinder = wu(n.useCylinder, !1), this.atomPair = wu(n.atomPair, []), e.prototype.init.call(this, n);
            }, t.prototype.getDistanceData = function (e, t) {
              var n = this,
                r = t.length,
                i = new Array(r),
                o = new Float32Array(3 * r),
                a = new Nc(),
                s = new Nc(),
                l = new Gg(),
                u = e.getAtomProxy(),
                c = e.getAtomProxy(),
                d = 0,
                h = e.getAtomSet();
              t.forEach(function (t, r) {
                var f = t[0],
                  p = t[1];
                if ("number" == typeof f && Number.isInteger(f) && "number" == typeof p && Number.isInteger(p)) {
                  if (!h.get(f) || !h.get(p)) return void (d += 1);
                  u.index = f, c.index = p;
                } else {
                  a.setString(f), s.setString(p);
                  var m = e.getAtomIndices(a),
                    g = e.getAtomIndices(s);
                  if (!m.length || !g.length) return void (d += 1);
                  u.index = m[0], c.index = g[0];
                }
                l.addBond(u, c, 1), r -= d;
                var v = u.distanceTo(c);
                switch (n.labelUnit) {
                  case "angstrom":
                    i[r] = v.toFixed(2) + " " + String.fromCharCode(8491);
                    break;
                  case "nm":
                    i[r] = (v / 10).toFixed(2) + " nm";
                    break;
                  default:
                    i[r] = v.toFixed(2);
                }
                var y = 3 * r;
                o[y + 0] = (u.x + c.x) / 2, o[y + 1] = (u.y + c.y) / 2, o[y + 2] = (u.z + c.z) / 2;
              }), 0 < d && (r -= d, o = o.subarray(0, 3 * r));
              var f = new tp(l.count, !0);
              return {
                text: i,
                position: o,
                bondSet: f,
                bondStore: l
              };
            }, t.prototype.getBondData = function (e, t, n) {
              var r = e.getBondData(this.getBondParams(t, n));
              return r.picking && (r.picking = new hm(r.picking.array, r.picking.structure, n.bondStore)), r;
            }, t.prototype.createData = function (e) {
              if (e.atomCount && this.atomPair.length) {
                var t = this.atomPair.length,
                  n = new Fe(this.labelColor),
                  r = this.getDistanceData(e, this.atomPair);
                this.textBuffer = new a_({
                  position: r.position,
                  size: Hd(t, this.labelSize),
                  color: qd(t, n.r, n.g, n.b),
                  text: r.text
                }, this.getLabelBufferParams());
                var i = {
                    bondSet: r.bondSet,
                    bondStore: r.bondStore
                  },
                  o = this.getBondData(e, {
                    position: !0,
                    color: !0,
                    picking: !0,
                    radius: this.useCylinder
                  }, i);
                return this.useCylinder ? this.distanceBuffer = new A_(o, this.getBufferParams({
                  openEnded: this.openEnded,
                  radialSegments: this.radialSegments,
                  disableImpostor: this.disableImpostor,
                  dullInterior: !0
                })) : this.distanceBuffer = new u_(jf(o), this.getBufferParams({
                  linewidth: this.linewidth,
                  visible: this.lineVisible,
                  opacity: this.lineOpacity
                })), {
                  bondSet: r.bondSet,
                  bondStore: r.bondStore,
                  position: r.position,
                  bufferList: [this.textBuffer, this.distanceBuffer]
                };
              }
            }, t.prototype.updateData = function (t, n) {
              e.prototype.updateData.call(this, t, n);
              var r = {
                  bondSet: n.bondSet,
                  bondStore: n.bondStore
                },
                i = this.getBondData(n.sview, t, r),
                o = {};
              t && !t.color || Object.assign(o, {
                color: i.color,
                color2: i.color2
              }), t && !t.radius || Object.assign(o, {
                radius: i.radius
              }), this.distanceBuffer.setAttributes(o);
            }, t.prototype.setParameters = function (t) {
              return e.prototype.setParameters.call(this, t, {}, !1), this.useCylinder || (t && t.lineOpacity && this.distanceBuffer.setParameters({
                opacity: t.lineOpacity
              }), t && void 0 !== t.opacity && this.distanceBuffer.setParameters({
                opacity: this.lineOpacity
              }), t && t.linewidth && this.distanceBuffer.setParameters({
                linewidth: t.linewidth
              })), this;
            }, t;
          }(Yb);
          function F_(e) {
            return e.position.length / 3 * 2 * 3;
          }
          rd.add("distance", B_);
          var z_ = Object.assign({
              scale: 1,
              color: "grey"
            }, ig),
            U_ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, {
                  position: new Float32Array(F_(t)),
                  color: new Float32Array(F_(t))
                }, n), this.isLine = !0, this.vertexShader = "Line.vert", this.fragmentShader = "Line.frag";
                var r = new Fe(this.parameters.color),
                  i = this.geometry.attributes;
                qd(F_(t) / 3, r.r, r.g, r.b, i.color.array), this.setAttributes(t);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return z_;
              }, t.prototype.setAttributes = function (e) {
                void 0 === e && (e = {});
                var t,
                  n,
                  r,
                  i = this.geometry.attributes;
                e.position && e.vector && (t = e.position, n = e.vector, r = i.position.array, i.position.needsUpdate = !0);
                var o = this.size / 2,
                  a = this.parameters.scale;
                if (t && n) for (var s = 0; s < o; s++) {
                  var l = 2 * s * 3,
                    u = 3 * s;
                  r[l + 0] = t[u + 0], r[l + 1] = t[u + 1], r[l + 2] = t[u + 2], r[l + 3] = t[u + 0] + n[u + 0] * a, r[l + 4] = t[u + 1] + n[u + 1] * a, r[l + 5] = t[u + 2] + n[u + 2] * a;
                }
              }, Object.defineProperties(t.prototype, n), t;
            }(ag),
            G_ = function (e) {
              function n(t, n, r) {
                e.call(this, t, n, r), this.type = "helixorient", this.parameters = Object.assign({
                  sphereDetail: !0,
                  disableImpostor: !0
                }, this.parameters), this.init(r);
              }
              return e && (n.__proto__ = e), ((n.prototype = Object.create(e && e.prototype)).constructor = n).prototype.init = function (t) {
                var n = t || {};
                n.colorScheme = wu(n.colorScheme, "sstruc"), n.radiusType = wu(n.radiusType, "size"), n.radiusSize = wu(n.radiusSize, .15), n.radiusScale = wu(n.radiusScale, 1), n.useInteriorColor = wu(n.useInteriorColor, !0), e.prototype.init.call(this, n);
              }, n.prototype.createData = function (e) {
                var t = this,
                  n = [],
                  r = [];
                return this.structure.eachPolymer(function (e) {
                  if (!(e.residueCount < 4)) {
                    r.push(e);
                    var i = new $g(e),
                      o = i.getPosition(),
                      a = i.getColor(t.getColorParams()),
                      s = i.getSize(t.getRadiusParams()),
                      l = i.getPicking();
                    n.push(new _y({
                      position: o.center,
                      color: a.color,
                      radius: s.size,
                      picking: l.picking
                    }, t.getBufferParams({
                      sphereDetail: t.sphereDetail,
                      disableImpostor: t.disableImpostor,
                      dullInterior: !0
                    })), new U_({
                      position: o.center,
                      vector: o.axis
                    }, t.getBufferParams({
                      color: "skyblue",
                      scale: 1
                    })), new U_({
                      position: o.center,
                      vector: o.resdir
                    }, t.getBufferParams({
                      color: "lightgreen",
                      scale: 1
                    })));
                  }
                }, e.getSelection()), {
                  bufferList: n,
                  polymerList: r
                };
              }, n.prototype.updateData = function (e, n) {
                t.Debug && Zc.time(this.type + " repr update"), e = e || {};
                for (var r = 0, i = n.polymerList.length; r < i; ++r) {
                  var o = 3 * r,
                    a = {},
                    s = n.polymerList[r],
                    l = new $g(s);
                  if (e.position) {
                    var u = l.getPosition();
                    Object.assign(a, {
                      position: u.center
                    }), n.bufferList[o + 1].setAttributes({
                      position: u.center,
                      vector: u.axis
                    }), n.bufferList[o + 2].setAttributes({
                      position: u.center,
                      vector: u.resdir
                    });
                  }
                  n.bufferList[o].setAttributes(a);
                }
                t.Debug && Zc.timeEnd(this.type + " repr update");
              }, n;
            }(Xb);
          rd.add("helixorient", G_);
          var V_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "licorice", this.parameters = Object.assign({}, this.parameters, {
                aspectRatio: null
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.aspectRatio = 1, e.prototype.init.call(this, n);
            }, t;
          }(T_);
          rd.add("licorice", V_), od.add("shader/HyperballStickImpostor.vert", "\nattribute vec3 mapping;\nattribute float radius;\nattribute float radius2;\nattribute vec3 position1;\nattribute vec3 position2;\nvarying mat4 matrix_near;\nvarying vec4 prime1;\nvarying vec4 prime2;\nvarying float vRadius;\nvarying float vRadius2;\n#ifdef PICKING\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\nattribute vec3 color2;\nvarying vec3 vColor1;\nvarying vec3 vColor2;\n#endif\nuniform float shrink;\nuniform mat4 modelViewProjectionMatrix;\nuniform mat4 modelViewProjectionMatrixInverse;\nvoid main(){\nvRadius = radius;\nvRadius2 = radius2;\nvec4 spaceposition;\nvec3 position_atom1;\nvec3 position_atom2;\nvec4 vertex_position;\n#ifdef PICKING\nvPickingColor = unpackColor( primitiveId );\n#else\nvColor1 = color;\nvColor2 = color2;\n#endif\nfloat radius1 = radius;\nposition_atom1 = position1;\nposition_atom2 = position2;\nfloat distance = distance( position_atom1, position_atom2 );\nspaceposition.z = mapping.z * distance;\nif (radius1 > radius2) {\nspaceposition.y = mapping.y * 1.5 * radius1;\nspaceposition.x = mapping.x * 1.5 * radius1;\n} else {\nspaceposition.y = mapping.y * 1.5 * radius2;\nspaceposition.x = mapping.x * 1.5 * radius2;\n}\nspaceposition.w = 1.0;\nvec4 e3 = vec4( 1.0 );\nvec3 e1, e1_temp, e2, e2_temp;\ne3.xyz = normalize(position_atom1-position_atom2);\nif (e3.z == 0.0) { e3.z = 0.0000000000001;}\nif ( (position_atom1.x - position_atom2.x) == 0.0) { position_atom1.x += 0.001;}\nif ( (position_atom1.y - position_atom2.y) == 0.0) { position_atom1.y += 0.001;}\nif ( (position_atom1.z - position_atom2.z) == 0.0) { position_atom1.z += 0.001;}\nvec4 focus = vec4( 1.0 );\nfocus.x = ( position_atom1.x*position_atom1.x - position_atom2.x*position_atom2.x +\n( radius2*radius2 - radius1*radius1 )*e3.x*e3.x/shrink )/(2.0*(position_atom1.x - position_atom2.x));\nfocus.y = ( position_atom1.y*position_atom1.y - position_atom2.y*position_atom2.y +\n( radius2*radius2 - radius1*radius1 )*e3.y*e3.y/shrink )/(2.0*(position_atom1.y - position_atom2.y));\nfocus.z = ( position_atom1.z*position_atom1.z - position_atom2.z*position_atom2.z +\n( radius2*radius2 - radius1*radius1 )*e3.z*e3.z/shrink )/(2.0*(position_atom1.z - position_atom2.z));\ne1.x = 1.0;\ne1.y = 1.0;\ne1.z = ( (e3.x*focus.x + e3.y*focus.y + e3.z*focus.z) - e1.x*e3.x - e1.y*e3.y)/e3.z;\ne1_temp = e1 - focus.xyz;\ne1 = normalize(e1_temp);\ne2_temp = e1.yzx * e3.zxy - e1.zxy * e3.yzx;\ne2 = normalize(e2_temp);\nmat3 R= mat3( e1.xyz, e2.xyz, e3.xyz );\nvertex_position.xyz = R * spaceposition.xyz;\nvertex_position.w = 1.0;\nvertex_position.x += (position_atom1.x+position_atom2.x) / 2.0;\nvertex_position.y += (position_atom1.y+position_atom2.y) / 2.0;\nvertex_position.z += (position_atom1.z+position_atom2.z) / 2.0;\ngl_Position = modelViewProjectionMatrix * vertex_position;\nvec4 i_near, i_far;\nvec4 near = gl_Position;\nnear.z = 0.0 ;\nnear = modelViewProjectionMatrixInverse * near;\ni_near = near;\nvec4 far = gl_Position;\nfar.z = far.w ;\ni_far = modelViewProjectionMatrixInverse * far;\nprime1 = vec4( position_atom1 - (position_atom1 - focus.xyz)*shrink, 1.0 );\nprime2 = vec4( position_atom2 - (position_atom2 - focus.xyz)*shrink, 1.0 );\nfloat Rsquare = (radius1*radius1/shrink) - (\n(position_atom1.x - focus.x)*(position_atom1.x - focus.x) +\n(position_atom1.y - focus.y)*(position_atom1.y - focus.y) +\n(position_atom1.z - focus.z)*(position_atom1.z - focus.z)\n);\nfocus.w = Rsquare;\nmatrix_near = mat4( i_near, i_far, focus, e3 );\ngl_Position.z = 1.0;\n}"), od.add("shader/HyperballStickImpostor.frag", "#define STANDARD\n#define IMPOSTOR\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 interiorColor;\nuniform float interiorDarkening;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\nuniform float clipNear;\nuniform float shrink;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelViewProjectionMatrix;\nuniform mat4 modelViewMatrixInverseTranspose;\nuniform mat4 projectionMatrix;\nvarying mat4 matrix_near;\nvarying vec4 prime1;\nvarying vec4 prime2;\nvarying float vRadius;\nvarying float vRadius2;\n#ifdef PICKING\nuniform float objectId;\nvarying vec3 vPickingColor;\n#else\nvarying vec3 vColor1;\nvarying vec3 vColor2;\n#include common\n#include fog_pars_fragment\n#include bsdfs\n#include lights_pars_begin\n#include lights_physical_pars_fragment\n#endif\nbool interior = false;\nfloat calcClip( vec4 cameraPos ){\nreturn dot( cameraPos, vec4( 0.0, 0.0, 1.0, clipNear - 0.5 ) );\n}\nfloat calcClip( vec3 cameraPos ){\nreturn calcClip( vec4( cameraPos, 1.0 ) );\n}\nfloat calcDepth( in vec3 cameraPos ){\nvec2 clipZW = cameraPos.z * projectionMatrix[2].zw + projectionMatrix[3].zw;\nreturn 0.5 + 0.5 * clipZW.x / clipZW.y;\n}\nstruct Ray {\nvec3 origin ;\nvec3 direction ;\n};\nbool cutoff_plane (vec3 M, vec3 cutoff, vec3 x3){\nfloat a = x3.x;\nfloat b = x3.y;\nfloat c = x3.z;\nfloat d = -x3.x*cutoff.x-x3.y*cutoff.y-x3.z*cutoff.z;\nfloat l = a*M.x+b*M.y+c*M.z+d;\nif (l<0.0) {return true;}\nelse{return false;}\n}\nvec3 isect_surf(Ray r, mat4 matrix_coef){\nvec4 direction = vec4(r.direction, 0.0);\nvec4 origin = vec4(r.origin, 1.0);\nfloat a = dot(direction,(matrix_coef*direction));\nfloat b = dot(origin,(matrix_coef*direction));\nfloat c = dot(origin,(matrix_coef*origin));\nfloat delta =b*b-a*c;\ngl_FragColor.a = 1.0;\nif (delta<0.0){\ndiscard;\n}\nfloat t1 =(-b-sqrt(delta))/a;\nreturn r.origin+t1*r.direction;\n}\nvec3 isect_surf2(Ray r, mat4 matrix_coef){\nvec4 direction = vec4(r.direction, 0.0);\nvec4 origin = vec4(r.origin, 1.0);\nfloat a = dot(direction,(matrix_coef*direction));\nfloat b = dot(origin,(matrix_coef*direction));\nfloat c = dot(origin,(matrix_coef*origin));\nfloat delta =b*b-a*c;\ngl_FragColor.a = 1.0;\nif (delta<0.0){\ndiscard;\n}\nfloat t2 =(-b+sqrt(delta))/a;\nreturn r.origin+t2*r.direction;\n}\nRay primary_ray(vec4 near1, vec4 far1){\nvec3 near=near1.xyz/near1.w;\nvec3 far=far1.xyz/far1.w;\nreturn Ray(near,far-near);\n}\nfloat update_z_buffer(vec3 M, mat4 ModelViewP){\nfloat depth1;\nvec4 Ms=(ModelViewP*vec4(M,1.0));\nreturn depth1=(1.0+Ms.z/Ms.w)/2.0;\n}\nvoid main(){\nfloat radius = max( vRadius, vRadius2 );\nvec4 i_near, i_far, focus;\nvec3 e3, e1, e1_temp, e2;\ni_near = vec4(matrix_near[0][0],matrix_near[0][1],matrix_near[0][2],matrix_near[0][3]);\ni_far = vec4(matrix_near[1][0],matrix_near[1][1],matrix_near[1][2],matrix_near[1][3]);\nfocus = vec4(matrix_near[2][0],matrix_near[2][1],matrix_near[2][2],matrix_near[2][3]);\ne3 = vec3(matrix_near[3][0],matrix_near[3][1],matrix_near[3][2]);\ne1.x = 1.0;\ne1.y = 1.0;\ne1.z = ( (e3.x*focus.x + e3.y*focus.y + e3.z*focus.z) - e1.x*e3.x - e1.y*e3.y)/e3.z;\ne1_temp = e1 - focus.xyz;\ne1 = normalize(e1_temp);\ne2 = normalize(cross(e1,e3));\nvec4 equation = focus;\nfloat shrinkfactor = shrink;\nfloat t1 = -1.0/(1.0-shrinkfactor);\nfloat t2 = 1.0/(shrinkfactor);\nvec4 colonne1, colonne2, colonne3, colonne4;\nmat4 mat;\nvec3 equation1 = vec3(t2,t2,t1);\nfloat A1 = - e1.x*equation.x - e1.y*equation.y - e1.z*equation.z;\nfloat A2 = - e2.x*equation.x - e2.y*equation.y - e2.z*equation.z;\nfloat A3 = - e3.x*equation.x - e3.y*equation.y - e3.z*equation.z;\nfloat A11 = equation1.x*e1.x*e1.x + equation1.y*e2.x*e2.x + equation1.z*e3.x*e3.x;\nfloat A21 = equation1.x*e1.x*e1.y + equation1.y*e2.x*e2.y + equation1.z*e3.x*e3.y;\nfloat A31 = equation1.x*e1.x*e1.z + equation1.y*e2.x*e2.z + equation1.z*e3.x*e3.z;\nfloat A41 = equation1.x*e1.x*A1 + equation1.y*e2.x*A2 + equation1.z*e3.x*A3;\nfloat A22 = equation1.x*e1.y*e1.y + equation1.y*e2.y*e2.y + equation1.z*e3.y*e3.y;\nfloat A32 = equation1.x*e1.y*e1.z + equation1.y*e2.y*e2.z + equation1.z*e3.y*e3.z;\nfloat A42 = equation1.x*e1.y*A1 + equation1.y*e2.y*A2 + equation1.z*e3.y*A3;\nfloat A33 = equation1.x*e1.z*e1.z + equation1.y*e2.z*e2.z + equation1.z*e3.z*e3.z;\nfloat A43 = equation1.x*e1.z*A1 + equation1.y*e2.z*A2 + equation1.z*e3.z*A3;\nfloat A44 = equation1.x*A1*A1 + equation1.y*A2*A2 + equation1.z*A3*A3 - equation.w;\ncolonne1 = vec4(A11,A21,A31,A41);\ncolonne2 = vec4(A21,A22,A32,A42);\ncolonne3 = vec4(A31,A32,A33,A43);\ncolonne4 = vec4(A41,A42,A43,A44);\nmat = mat4(colonne1,colonne2,colonne3,colonne4);\nRay ray = primary_ray(i_near,i_far) ;\nvec3 M;\nM = isect_surf(ray, mat);\nif (cutoff_plane(M, prime1.xyz, -e3) || cutoff_plane(M, prime2.xyz, e3)){ discard; }\nvec4 M1 = vec4(M,1.0);\nvec4 M2 = mat*M1;\nvec3 _normal = ( modelViewMatrixInverseTranspose * M2 ).xyz;\ngl_FragDepthEXT = update_z_buffer(M, modelViewProjectionMatrix) ;\n#ifdef NEAR_CLIP\nif( calcClip( modelViewMatrix * vec4( M, 1.0 ) ) > 0.0 ){\nM = isect_surf2(ray, mat);\nif( calcClip( modelViewMatrix * vec4( M, 1.0 ) ) > 0.0 )\ndiscard;\ninterior = true;\ngl_FragDepthEXT = update_z_buffer(M, modelViewProjectionMatrix) ;\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = max( 0.0, calcDepth( vec3( - ( clipNear - 0.5 ) ) ) + ( 0.0000001 / radius ) );\n}\n}else if( gl_FragDepthEXT <= 0.0 ){\nM = isect_surf2(ray, mat);\ninterior = true;\ngl_FragDepthEXT = update_z_buffer(M, modelViewProjectionMatrix);\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = 0.0 + ( 0.0000001 / radius );\n}\n}\n#else\nif( gl_FragDepthEXT <= 0.0 ){\nM = isect_surf2(ray, mat);\ninterior = true;\ngl_FragDepthEXT = update_z_buffer(M, modelViewProjectionMatrix) ;\nif( gl_FragDepthEXT >= 0.0 ){\ngl_FragDepthEXT = 0.0 + ( 0.0000001 / radius );\n}\n}\n#endif\nif (cutoff_plane(M, prime1.xyz, -e3) || cutoff_plane(M, prime2.xyz, e3)){ discard; }\nif (gl_FragDepthEXT < 0.0)\ndiscard;\nif (gl_FragDepthEXT > 1.0)\ndiscard;\nfloat distance_ratio = ((M.x-prime2.x)*e3.x + (M.y-prime2.y)*e3.y +(M.z-prime2.z)*e3.z) /\ndistance(prime2.xyz,prime1.xyz);\n#ifdef PICKING\nif( opacity < 0.3 )\ndiscard;\ngl_FragColor = vec4( vPickingColor, objectId );\n#else\nvec3 vViewPosition = -( modelViewMatrix * vec4( M, 1.0 ) ).xyz;\nvec3 vNormal = _normal;\nvec3 vColor;\nif( distance_ratio>0.5 ){\nvColor = vColor1;\n}else{\nvColor = vColor2;\n}\nvec4 diffuseColor = vec4( diffuse, opacity );\nReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\nvec3 totalEmissiveLight = emissive;\n#include color_fragment\n#include roughnessmap_fragment\n#include metalnessmap_fragment\nvec3 normal = normalize( vNormal );\n#include lights_physical_fragment\n#include lights_fragment_begin\n#include lights_fragment_end\nvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveLight;\nif( interior ){\n#ifdef USE_INTERIOR_COLOR\noutgoingLight.xyz = interiorColor;\n#else\n#ifdef DIFFUSE_INTERIOR\noutgoingLight.xyz = vColor;\n#endif\n#endif\noutgoingLight.xyz *= 1.0 - interiorDarkening;\n}\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );\n#include premultiplied_alpha_fragment\n#include tonemapping_fragment\n#include encodings_fragment\n#include fog_fragment\n#endif\n}");
          var H_ = new Float32Array([-1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, -1, 1, -1, 1, 1, -1, 1, 1, 1, -1, 1, 1]),
            q_ = new Uint16Array([0, 1, 2, 0, 2, 3, 1, 5, 6, 1, 6, 2, 4, 6, 5, 4, 7, 6, 0, 7, 4, 0, 3, 7, 0, 5, 1, 0, 4, 5, 3, 2, 6, 3, 6, 7]),
            W_ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, "v3", t, n);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                mapping: {
                  configurable: !0
                },
                mappingIndices: {
                  configurable: !0
                },
                mappingIndicesSize: {
                  configurable: !0
                },
                mappingSize: {
                  configurable: !0
                },
                mappingItemSize: {
                  configurable: !0
                }
              };
              return n.mapping.get = function () {
                return H_;
              }, n.mappingIndices.get = function () {
                return q_;
              }, n.mappingIndicesSize.get = function () {
                return 36;
              }, n.mappingSize.get = function () {
                return 8;
              }, n.mappingItemSize.get = function () {
                return 3;
              }, Object.defineProperties(t.prototype, n), t;
            }(my),
            $_ = Object.assign({
              shrink: .14
            }, ig),
            X_ = Object.assign({
              shrink: {
                uniform: !0
              }
            }, og),
            Y_ = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n), this.parameterTypes = X_, this.isImpostor = !0, this.vertexShader = "HyperballStickImpostor.vert", this.fragmentShader = "HyperballStickImpostor.frag", this.addUniforms({
                  modelViewProjectionMatrix: {
                    value: new ie()
                  },
                  modelViewProjectionMatrixInverse: {
                    value: new ie()
                  },
                  modelViewMatrixInverseTranspose: {
                    value: new ie()
                  },
                  shrink: {
                    value: this.parameters.shrink
                  }
                }), this.addAttributes({
                  position1: {
                    type: "v3",
                    value: null
                  },
                  position2: {
                    type: "v3",
                    value: null
                  },
                  color2: {
                    type: "c",
                    value: null
                  },
                  radius: {
                    type: "f",
                    value: null
                  },
                  radius2: {
                    type: "f",
                    value: null
                  }
                }), this.setAttributes(t), this.makeMapping();
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return $_;
              }, Object.defineProperties(t.prototype, n), t;
            }(W_),
            K_ = (Object.assign({
              disableImpostor: !1
            }, m_, $_), function (e, t) {
              return void 0 === t && (t = {}), !Kc || t && t.disableImpostor ? (e.radius = function (e, t) {
                for (var n = e.length, r = new Float32Array(n), i = 0; i < n; i++) r[i] = Math.min(e[i], t[i]);
                return r;
              }(e.radius, e.radius2), new v_(e, t)) : new Y_(e, t);
            }),
            Z_ = function (e) {
              function t(t, n, r) {
                e.call(this, t, n, r), this.type = "hyperball", this.parameters = Object.assign({
                  shrink: {
                    type: "number",
                    precision: 3,
                    max: 1,
                    min: .001,
                    buffer: !0
                  }
                }, this.parameters, {
                  multipleBond: null,
                  bondSpacing: null
                });
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
                var n = t || {};
                n.radiusScale = wu(n.radiusScale, .2), n.radiusType = wu(n.radiusType, "vdw"), n.useInteriorColor = wu(n.useInteriorColor, !0), this.shrink = wu(n.shrink, .12), e.prototype.init.call(this, n);
              }, t.prototype.getBondParams = function (t, n) {
                return t && !t.radius || (n = Object.assign({
                  radius2: !0
                }, n)), e.prototype.getBondParams.call(this, t, n);
              }, t.prototype.createData = function (e) {
                var t = new _y(e.getAtomData(this.getAtomParams()), this.getBufferParams({
                  sphereDetail: this.sphereDetail,
                  disableImpostor: this.disableImpostor,
                  dullInterior: !0
                }));
                return this.__center = new Float32Array(3 * e.bondCount), {
                  bufferList: [t, new K_(e.getBondData(this.getBondParams()), this.getBufferParams({
                    shrink: this.shrink,
                    radialSegments: this.radialSegments,
                    disableImpostor: this.disableImpostor,
                    dullInterior: !0
                  }))]
                };
              }, t.prototype.updateData = function (e, t) {
                var n = t.sview.getAtomData(this.getAtomParams()),
                  r = t.sview.getBondData(this.getBondParams()),
                  i = {},
                  o = {};
                if (!e || e.position) {
                  Object.assign(i, {
                    position: n.position
                  });
                  var a = r.position1,
                    s = r.position2;
                  Object.assign(o, {
                    position: Gd(a, s, this.__center),
                    position1: a,
                    position2: s
                  });
                }
                e && !e.color || (Object.assign(i, {
                  color: n.color
                }), Object.assign(o, {
                  color: r.color,
                  color2: r.color2
                })), e && !e.radius || (Object.assign(i, {
                  radius: n.radius
                }), Object.assign(o, {
                  radius: r.radius,
                  radius2: r.radius2
                })), t.bufferList[0].setAttributes(i), t.bufferList[1].setAttributes(o);
              }, t;
            }(V_);
          rd.add("hyperball", Z_);
          var Q_ = function Q_(e, t, n) {
            void 0 === t && (t = {}), void 0 === n && (n = ""), this.type = e, this.text = t, this.format = n;
          };
          Q_.prototype.atomLabel = function (e) {
            var t;
            switch (this.type) {
              case "atomname":
                t = e.atomname;
                break;
              case "atomindex":
                t = "" + e.index;
                break;
              case "occupancy":
                t = e.occupancy.toFixed(2);
                break;
              case "bfactor":
                t = e.bfactor.toFixed(2);
                break;
              case "serial":
                t = "" + e.serial;
                break;
              case "element":
                t = e.element;
                break;
              case "atom":
                t = e.atomname + "|" + e.index;
                break;
              case "resname":
                t = e.resname;
                break;
              case "resno":
                t = "" + e.resno;
                break;
              case "res":
                t = "" + (xp[e.resname.toUpperCase()] || e.resname) + e.resno;
                break;
              case "residue":
                var n = xp[e.resname.toUpperCase()];
                t = n && !e.inscode ? "" + n + e.resno : "[" + e.resname + "]" + e.resno + e.inscode;
                break;
              case "text":
                t = this.text[e.index];
                break;
              case "format":
                t = _d(this.format, e);
                break;
              default:
                t = e.qualifiedName();
            }
            return void 0 === t ? "" : t;
          }, Q_.types = {
            "": "",
            atomname: "atom name",
            atomindex: "atom index",
            occupancy: "occupancy",
            bfactor: "b-factor",
            serial: "serial",
            element: "element",
            atom: "atom name + index",
            resname: "residue name",
            resno: "residue no",
            res: "one letter code + no",
            residue: "[residue name] + no + inscode",
            text: "text",
            format: "format",
            qualified: "qualified name"
          };
          var J_ = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "label", this.parameters = Object.assign({
                labelType: {
                  type: "select",
                  options: Q_.types,
                  rebuild: !0
                },
                labelText: {
                  type: "hidden",
                  rebuild: !0
                },
                labelFormat: {
                  type: "text",
                  rebuild: !0
                },
                labelGrouping: {
                  type: "select",
                  options: {
                    atom: "atom",
                    residue: "residue"
                  },
                  rebuild: !0
                },
                fontFamily: {
                  type: "select",
                  options: {
                    "sans-serif": "sans-serif",
                    monospace: "monospace",
                    serif: "serif"
                  },
                  buffer: !0
                },
                fontStyle: {
                  type: "select",
                  options: {
                    normal: "normal",
                    italic: "italic"
                  },
                  buffer: !0
                },
                fontWeight: {
                  type: "select",
                  options: {
                    normal: "normal",
                    bold: "bold"
                  },
                  buffer: !0
                },
                xOffset: {
                  type: "number",
                  precision: 1,
                  max: 20,
                  min: -20,
                  buffer: !0
                },
                yOffset: {
                  type: "number",
                  precision: 1,
                  max: 20,
                  min: -20,
                  buffer: !0
                },
                zOffset: {
                  type: "number",
                  precision: 1,
                  max: 20,
                  min: -20,
                  buffer: !0
                },
                attachment: {
                  type: "select",
                  options: {
                    "bottom-left": "bottom-left",
                    "bottom-center": "bottom-center",
                    "bottom-right": "bottom-right",
                    "middle-left": "middle-left",
                    "middle-center": "middle-center",
                    "middle-right": "middle-right",
                    "top-left": "top-left",
                    "top-center": "top-center",
                    "top-right": "top-right"
                  },
                  rebuild: !0
                },
                showBorder: {
                  type: "boolean",
                  buffer: !0
                },
                borderColor: {
                  type: "color",
                  buffer: !0
                },
                borderWidth: {
                  type: "number",
                  precision: 2,
                  max: .3,
                  min: 0,
                  buffer: !0
                },
                showBackground: {
                  type: "boolean",
                  rebuild: !0
                },
                backgroundColor: {
                  type: "color",
                  buffer: !0
                },
                backgroundMargin: {
                  type: "number",
                  precision: 2,
                  max: 2,
                  min: 0,
                  rebuild: !0
                },
                backgroundOpacity: {
                  type: "range",
                  step: .01,
                  max: 1,
                  min: 0,
                  buffer: !0
                },
                fixedSize: {
                  type: "boolean",
                  buffer: !0
                }
              }, this.parameters, {
                side: null,
                flatShaded: null,
                wireframe: null,
                linewidth: null,
                roughness: null,
                metalness: null,
                diffuse: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              this.labelType = wu(n.labelType, "res"), this.labelText = wu(n.labelText, {}), this.labelFormat = wu(n.labelFormat, ""), this.labelGrouping = wu(n.labelGrouping, "atom"), this.fontFamily = wu(n.fontFamily, "sans-serif"), this.fontStyle = wu(n.fontStyle, "normal"), this.fontWeight = wu(n.fontWeight, "bold"), this.xOffset = wu(n.xOffset, 0), this.yOffset = wu(n.yOffset, 0), this.zOffset = wu(n.zOffset, .5), this.attachment = wu(n.attachment, "bottom-left"), this.showBorder = wu(n.showBorder, !1), this.borderColor = wu(n.borderColor, "lightgrey"), this.borderWidth = wu(n.borderWidth, .15), this.showBackground = wu(n.showBackground, !1), this.backgroundColor = wu(n.backgroundColor, "lightgrey"), this.backgroundMargin = wu(n.backgroundMargin, .5), this.backgroundOpacity = wu(n.backgroundOpacity, 1), this.fixedSize = wu(n.fixedSize, !1), e.prototype.init.call(this, n);
            }, t.prototype.getTextData = function (e, t) {
              var n,
                r,
                i,
                o,
                a,
                s,
                l,
                u = this.getAtomParams(t),
                c = new Q_(this.labelType, this.labelText, this.labelFormat);
              if ("atom" === this.labelGrouping) {
                var d = e.getAtomData(u);
                n = d.position, r = d.radius, i = d.color, t && !t.text || (o = [], e.eachAtom(function (e) {
                  return o.push(c.atomLabel(e));
                }));
              } else if ("residue" === this.labelGrouping) {
                t && !t.position || (a = []), t && !t.color || (l = []), t && !t.radius || (s = []), t && !t.text || (o = []), u.colorParams && (u.colorParams.structure = e.getStructure());
                var h = td.getScheme(u.colorParams),
                  f = new Ng(u.radiusParams),
                  p = e.getAtomProxy(),
                  m = 0;
                e.eachResidue(function (e) {
                  var n = 3 * m;
                  e.isProtein() || e.isNucleic() ? (p.index = e.traceAtomIndex, t && !t.position || p.positionToArray(a, n)) : (p.index = e.atomOffset, t && !t.position || e.positionToArray(a, n)), t && !t.color || h.atomColorToArray(p, l, n), t && !t.radius || (s[m] = f.atomRadius(p)), t && !t.text || o.push(c.atomLabel(p)), ++m;
                }), t && !t.position || (n = new Float32Array(a)), t && !t.color || (i = new Float32Array(l)), t && !t.radius || (r = new Float32Array(s));
              }
              return {
                position: n,
                size: r,
                color: i,
                text: o
              };
            }, t.prototype.createData = function (e) {
              return {
                bufferList: [new a_(this.getTextData(e, {
                  position: !0,
                  color: !0,
                  radius: !0,
                  text: !0
                }), this.getBufferParams({
                  fontFamily: this.fontFamily,
                  fontStyle: this.fontStyle,
                  fontWeight: this.fontWeight,
                  xOffset: this.xOffset,
                  yOffset: this.yOffset,
                  zOffset: this.zOffset,
                  attachment: this.attachment,
                  showBorder: this.showBorder,
                  borderColor: this.borderColor,
                  borderWidth: this.borderWidth,
                  showBackground: this.showBackground,
                  backgroundColor: this.backgroundColor,
                  backgroundMargin: this.backgroundMargin,
                  backgroundOpacity: this.backgroundOpacity,
                  fixedSize: this.fixedSize
                }))]
              };
            }, t.prototype.updateData = function (e, t) {
              t.bufferList[0].setAttributes(this.getTextData(t.sview, e));
            }, t.prototype.getAtomRadius = function () {
              return 0;
            }, t;
          }(Xb);
          rd.add("label", J_);
          var ex = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "line", this.parameters = Object.assign({
                multipleBond: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    off: "off",
                    symmetric: "symmetric",
                    offset: "offset"
                  }
                },
                bondSpacing: {
                  type: "number",
                  precision: 2,
                  max: 2,
                  min: .5
                },
                linewidth: {
                  type: "integer",
                  max: 50,
                  min: 1,
                  buffer: !0
                },
                lines: {
                  type: "boolean",
                  rebuild: !0
                },
                crosses: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    off: "off",
                    lone: "lone",
                    all: "all"
                  }
                },
                crossSize: {
                  type: "number",
                  precision: 2,
                  max: 2,
                  min: .1
                }
              }, this.parameters, {
                flatShaded: null,
                side: null,
                wireframe: null,
                roughness: null,
                metalness: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              this.multipleBond = wu(n.multipleBond, "off"), this.bondSpacing = wu(n.bondSpacing, 1), this.linewidth = wu(n.linewidth, 2), this.lines = wu(n.lines, !0), this.crosses = wu(n.crosses, "lone"), this.crossSize = wu(n.crossSize, .4), e.prototype.init.call(this, n);
            }, t.prototype.getAtomRadius = function (e) {
              return .1;
            }, t.prototype.getBondParams = function (t, n) {
              return n = Object.assign({
                multipleBond: this.multipleBond,
                bondSpacing: this.bondSpacing,
                radiusParams: {
                  type: "size",
                  size: .1,
                  scale: 1
                }
              }, n), e.prototype.getBondParams.call(this, t, n);
            }, t.prototype._crossData = function (e, t) {
              if (!e || e.position || e.color) {
                var n,
                  r,
                  i,
                  o,
                  a = {};
                "lone" === this.crosses && Object.assign(a, {
                  atomSet: (n = t, r = n.getAtomSet(), i = n.getBondSet(), o = n.getBondProxy(), i.forEach(function (e) {
                    o.index = e, r.clear(o.atomIndex1), r.clear(o.atomIndex2);
                  }), r)
                });
                var s,
                  l = t.getAtomData(this.getAtomParams(e, a)),
                  u = {},
                  c = l.position,
                  d = l.color,
                  h = l.picking,
                  f = (c || d).length,
                  p = 3 * f,
                  m = new Float32Array(0),
                  g = new Float32Array(0),
                  v = new Float32Array(0),
                  y = new Float32Array(0),
                  b = new Float32Array(0);
                e && !e.position || (m = u.position1 = new Float32Array(p), g = u.position2 = new Float32Array(p), s = this.crossSize / 2), e && !e.color || (v = u.color = new Float32Array(p), y = u.color2 = new Float32Array(p)), e && !e.picking || (b = new Float32Array(3 * l.picking.array.length));
                for (var _ = 0; _ < f; _++) {
                  var x = 3 * _,
                    w = 3 * x;
                  if (!e || e.position) {
                    var S = c[x],
                      A = c[x + 1],
                      E = c[x + 2];
                    m[w] = S - s, m[w + 1] = A, m[w + 2] = E, g[w] = S + s, g[w + 1] = A, g[w + 2] = E, m[w + 3] = S, m[w + 4] = A - s, m[w + 5] = E, g[w + 3] = S, g[w + 4] = A + s, g[w + 5] = E, m[w + 6] = S, m[w + 7] = A, m[w + 8] = E - s, g[w + 6] = S, g[w + 7] = A, g[w + 8] = E + s;
                  }
                  if (!e || e.color) for (var T = w + 9, M = w; M < T; M += 3) v[M] = y[M] = d[x], v[M + 1] = y[M + 1] = d[x + 1], v[M + 2] = y[M + 2] = d[x + 2];
                  e && !e.picking || (b[x] = b[x + 1] = b[x + 2] = h.array[_]);
                }
                return e && !e.picking || (u.picking = new am(b, h.structure)), u;
              }
            }, t.prototype.createData = function (e) {
              var t = {
                  position: !0,
                  color: !0,
                  picking: !0
                },
                n = [];
              if (this.lines) {
                var r = e.getBondData(this.getBondParams(t)),
                  i = new u_(r, this.getBufferParams({
                    linewidth: this.linewidth
                  }));
                n.push(i);
              }
              if ("off" !== this.crosses) {
                var o = new u_(this._crossData(t, e), this.getBufferParams({
                  linewidth: this.linewidth
                }));
                n.push(o);
              }
              return {
                bufferList: n
              };
            }, t.prototype.updateData = function (e, t) {
              var n = 0;
              if (this.lines) {
                var r = t.sview.getBondData(this.getBondParams(e)),
                  i = {};
                e && !e.position || Object.assign(i, {
                  position1: r.position1,
                  position2: r.position2
                }), e && !e.color || Object.assign(i, {
                  color: r.color,
                  color2: r.color2
                }), t.bufferList[n++].setAttributes(i);
              }
              if ("off" !== this.crosses) {
                var o = this._crossData(e, t.sview),
                  a = {};
                e && !e.position || Object.assign(a, {
                  position1: o.position1,
                  position2: o.position2
                }), e && !e.color || Object.assign(a, {
                  color: o.color,
                  color2: o.color2
                }), t.bufferList[n++].setAttributes(a);
              }
            }, t.prototype.setParameters = function (t) {
              var n = {};
              return t && (t.bondSpacing || t.crossSize) && Object.assign(n, {
                position: !0
              }), e.prototype.setParameters.call(this, t, n, !1), this;
            }, t;
          }(Xb);
          function tx(e, t, n, r, i) {
            var o = new (r = r || Int32Array)(e * t * n * (i = i || 1));
            function a(e, r, o) {
              return ((e * t + r) * n + o) * i;
            }
            return {
              data: o,
              index: a,
              set: function set(e, t, n) {
                for (var r = [], s = arguments.length - 3; 0 < s--;) r[s] = arguments[s + 3];
                for (var l = a(e, t, n), u = 0; u < i; ++u) o[l + u] = r[u];
              },
              toArray: function toArray(e, t, n, r, s) {
                void 0 === r && (r = []), void 0 === s && (s = 0);
                for (var l = a(e, t, n), u = 0; u < i; ++u) r[s + u] = o[l + u];
              },
              fromArray: function fromArray(e, t, n, r, s) {
                void 0 === s && (s = 0);
                for (var l = a(e, t, n), u = 0; u < i; ++u) o[l + u] = r[s + u];
              },
              copy: function copy(e) {
                o.set(e.data);
              }
            };
          }
          function nx(e, t, n) {
            var r = Xm(t),
              i = ff(e);
            0 === e.length && (i[0].set([0, 0, 0]), i[1].set([0, 0, 0]));
            var o,
              a,
              s,
              l,
              u,
              c,
              d,
              h,
              f,
              p,
              m,
              g,
              v,
              y,
              b,
              _ = i[0],
              x = i[1],
              w = [new Int32Array([1, 0, 0]), new Int32Array([-1, 0, 0]), new Int32Array([0, 1, 0]), new Int32Array([0, -1, 0]), new Int32Array([0, 0, 1]), new Int32Array([0, 0, -1]), new Int32Array([1, 1, 0]), new Int32Array([1, -1, 0]), new Int32Array([-1, 1, 0]), new Int32Array([-1, -1, 0]), new Int32Array([1, 0, 1]), new Int32Array([1, 0, -1]), new Int32Array([-1, 0, 1]), new Int32Array([-1, 0, -1]), new Int32Array([0, 1, 1]), new Int32Array([0, 1, -1]), new Int32Array([0, -1, 1]), new Int32Array([0, -1, -1]), new Int32Array([1, 1, 1]), new Int32Array([1, 1, -1]), new Int32Array([1, -1, 1]), new Int32Array([-1, 1, 1]), new Int32Array([1, -1, -1]), new Int32Array([-1, -1, 1]), new Int32Array([-1, 1, -1]), new Int32Array([-1, -1, -1])];
            function S(e) {
              var t, n, i, s, l, u, c, d, h, m;
              for (var g in r) if (t = parseFloat(g), !f[g]) {
                for (u = (c = e ? (t + o) * a + .5 : t * a + .5) * c, d = Math.floor(c) + 1, h = new Int32Array(d * d), n = m = 0; n < d; ++n) for (i = 0; i < d; ++i) u < (s = n * n + i * i) ? h[m] = -1 : (l = Math.sqrt(u - s), h[m] = Math.floor(l)), ++m;
                p[g] = d, f[g] = h;
              }
            }
            function A(n) {
              var r,
                i,
                o,
                s,
                d,
                m,
                y,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M,
                C,
                k,
                P,
                O = 3 * n,
                R = n;
              r = Math.floor(.5 + a * (e[O] + h[0])), i = Math.floor(.5 + a * (e[O + 1] + h[1])), o = Math.floor(.5 + a * (e[O + 2] + h[2]));
              var I,
                j = t[R],
                N = f[j],
                L = 0,
                D = u * c,
                B = p[j];
              for (w = 0; w < B; ++w) for (S = 0; S < B; ++S) {
                if (-1 !== (I = N[L])) for (C = -1; C < 2; ++C) for (k = -1; k < 2; ++k) for (P = -1; P < 2; ++P) if (0 !== C && 0 !== k && 0 !== P) for (y = C * w, x = P * S, A = 0; A <= I; ++A) if (T = i + (_ = A * k), M = o + x, !((E = r + y) < 0 || T < 0 || M < 0 || l <= E || u <= T || c <= M)) {
                  var F = E * D + T * c + M;
                  if (g) {
                    if (1 & v[F]) {
                      if (1 & v[F]) {
                        var z = b[F];
                        z !== O && y * y + _ * _ + x * x < (s = r + y - Math.floor(.5 + a * (e[z] + h[0]))) * s + (d = i + _ - Math.floor(.5 + a * (e[z + 1] + h[1]))) * d + (m = o + x - Math.floor(.5 + a * (e[z + 2] + h[2]))) * m && (b[F] = n);
                      }
                    } else v[F] |= 1, b[F] = n;
                  } else v[F] |= 1;
                }
                L++;
              }
            }
            function E(n) {
              var r,
                i,
                o,
                s,
                d,
                m,
                y,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M,
                C,
                k,
                P,
                O,
                R = 3 * n,
                I = n,
                j = 0;
              r = Math.floor(.5 + a * (e[R] + h[0])), i = Math.floor(.5 + a * (e[R + 1] + h[1])), o = Math.floor(.5 + a * (e[R + 2] + h[2]));
              var N = t[I],
                L = u * c;
              for (E = 0, O = p[N]; E < O; ++E) for (T = 0; T < O; ++T) {
                if (-1 !== f[N][j]) for (C = -1; C < 2; ++C) for (k = -1; k < 2; ++k) for (P = -1; P < 2; ++P) if (0 !== C && 0 !== k && 0 !== P) for (y = C * E, x = P * T, M = 0; M <= f[N][j]; ++M) if (S = i + (_ = M * k), A = o + x, !((w = r + y) < 0 || S < 0 || A < 0 || l <= w || u <= S || c <= A)) {
                  var D = w * L + S * c + A;
                  if (2 & v[D]) {
                    if (g) {
                      var B = b[D];
                      y * y + _ * _ + x * x < (s = Math.floor(.5 + a * (e[B] + h[0]))) * s + (d = Math.floor(.5 + a * (e[B + 1] + h[1]))) * d + (m = Math.floor(.5 + a * (e[B + 2] + h[2]))) * m && (b[D] = n);
                    }
                  } else v[D] |= 2, g && (b[D] = n);
                }
                j++;
              }
            }
            function T(e, t, n, r) {
              var i,
                o,
                a,
                s,
                d,
                h,
                f,
                p,
                m,
                g,
                b,
                _,
                x = new Uint16Array(3),
                S = 0;
              if (0 === n) return S;
              var A = -1,
                E = -1,
                T = -1,
                M = u * c;
              for (f = 0, m = n; f < m; f += 3) for (i = e[f], o = e[f + 1], a = e[f + 2], t.toArray(i, o, a, x), p = 0; p < 6; ++p) A = i + (_ = w[p])[0], E = o + _[1], T = a + _[2], A < l && -1 < A && E < u && -1 < E && T < c && -1 < T && (1 & v[b = A * M + c * E + T] && !(2 & v[b]) ? (t.fromArray(A, E, T, x), g = (s = A - x[0]) * s + (d = E - x[1]) * d + (h = T - x[2]) * h, y[b] = g, v[b] |= 2, v[b] |= 4, r[S] = A, r[S + 1] = E, r[S + 2] = T, S += 3) : 1 & v[b] && 2 & v[b] && (g = (s = A - x[0]) * s + (d = E - x[1]) * d + (h = T - x[2]) * h) < y[b] && (t.fromArray(A, E, T, x), y[b] = g, 4 & v[b] || (v[b] |= 4, r[S] = A, r[S + 1] = E, r[S + 2] = T, S += 3)));
              for (f = 0, m = n; f < m; f += 3) for (i = e[f], o = e[f + 1], a = e[f + 2], t.toArray(i, o, a, x), p = 6; p < 18; p++) A = i + (_ = w[p])[0], E = o + _[1], T = a + _[2], A < l && -1 < A && E < u && -1 < E && T < c && -1 < T && (1 & v[b = A * M + c * E + T] && !(2 & v[b]) ? (t.fromArray(A, E, T, x), g = (s = A - x[0]) * s + (d = E - x[1]) * d + (h = T - x[2]) * h, y[b] = g, v[b] |= 2, v[b] |= 4, r[S] = A, r[S + 1] = E, r[S + 2] = T, S += 3) : 1 & v[b] && 2 & v[b] && (g = (s = A - x[0]) * s + (d = E - x[1]) * d + (h = T - x[2]) * h) < y[b] && (t.fromArray(A, E, T, x), y[b] = g, 4 & v[b] || (v[b] |= 4, r[S] = A, r[S + 1] = E, r[S + 2] = T, S += 3)));
              for (f = 0, m = n; f < m; f += 3) for (i = e[f], o = e[f + 1], a = e[f + 2], t.toArray(i, o, a, x), p = 18; p < 26; p++) A = i + (_ = w[p])[0], E = o + _[1], T = a + _[2], A < l && -1 < A && E < u && -1 < E && T < c && -1 < T && (1 & v[b = A * M + c * E + T] && !(2 & v[b]) ? (t.fromArray(A, E, T, x), g = (s = A - x[0]) * s + (d = E - x[1]) * d + (h = T - x[2]) * h, y[b] = g, v[b] |= 2, v[b] |= 4, r[S] = A, r[S + 1] = E, r[S + 2] = T, S += 3) : 1 & v[b] && 2 & v[b] && (g = (s = A - x[0]) * s + (d = E - x[1]) * d + (h = T - x[2]) * h) < y[b] && (t.fromArray(A, E, T, x), y[b] = g, 4 & v[b] || (v[b] |= 4, r[S] = A, r[S + 1] = E, r[S + 2] = T, S += 3)));
              return S;
            }
            this.getVolume = function (t, i, M, C, k) {
              console.time("EDTSurface.getVolume");
              var P = "vws" !== t;
              !function (e, t, n, i, w) {
                o = t || 1.4, a = n || 2, g = w || !0;
                var A = 0;
                for (var E in r) A = Math.max(A, E);
                var T = Ym(_, x, A, a, e ? o : 0);
                l = T.dim[0], u = T.dim[1], c = T.dim[2], d = T.matrix, h = T.tran, a = T.scaleFactor, f = {}, p = {}, S(e), m = o * a, s = i || o / a, v = new Uint8Array(l * u * c), e && (y = new Float64Array(l * u * c)), g && (b = new Int32Array(l * u * c));
              }(P, i, M, C, k), function (t) {
                var n, r;
                for (console.time("EDTSurface fillvoxels"), n = 0, r = v.length; n < r; ++n) v[n] = 0, t && (y[n] = -1), g && (b[n] = -1);
                for (n = 0, r = e.length / 3; n < r; ++n) A(n);
                for (n = 0, r = v.length; n < r; ++n) 1 & v[n] && (v[n] |= 2);
                console.timeEnd("EDTSurface fillvoxels");
              }(P), function () {
                var e,
                  t,
                  n,
                  r = u * c;
                for (e = 0; e < l; ++e) for (t = 0; t < c; ++t) for (n = 0; n < u; ++n) {
                  var i = e * r + n * c + t;
                  if (1 & v[i]) for (var o = 0; o < 26;) {
                    var a = e + w[o][0],
                      s = t + w[o][2],
                      d = n + w[o][1];
                    if (-1 < a && a < l && -1 < d && d < u && -1 < s && s < c && !(1 & v[a * r + d * c + s])) {
                      v[i] |= 4;
                      break;
                    }
                    o++;
                  }
                }
              }(), "ms" !== t && "ses" !== t || function () {
                var e, t, n, r;
                console.time("EDTSurface fastdistancemap");
                var i,
                  o = tx(l, u, c, Uint16Array, 3),
                  a = u * c,
                  d = m * m,
                  h = 0;
                for (e = 0; e < l; ++e) for (t = 0; t < u; ++t) for (n = 0; n < c; ++n) v[i = e * a + t * c + n] &= -3, 1 & v[i] && 4 & v[i] && (o.set(e, t, n, e, t, n), y[i] = 0, v[i] |= 2, h += 1);
                var f = new Int32Array(3 * h),
                  p = 0,
                  _ = new Int32Array(3 * h),
                  x = 0;
                for (e = 0; e < l; ++e) for (t = 0; t < u; ++t) for (n = 0; n < c; ++n) 4 & v[i = e * a + t * c + n] && (f[p] = e, f[p + 1] = t, f[p + 2] = n, p += 3, v[i] &= -5);
                do {
                  for (x = T(f, o, p, _), e = p = 0, r = x; e < r; e += 3) i = a * _[e] + c * _[e + 1] + _[e + 2], v[i] &= -5, y[i] <= 1.0404 * d && (f[p] = _[e], f[p + 1] = _[e + 1], f[p + 2] = _[e + 2], p += 3);
                } while (0 < p);
                var w,
                  S = s * s,
                  A = new Uint16Array(3);
                for (e = 0; e < l; ++e) for (t = 0; t < u; ++t) for (n = 0; n < c; ++n) v[i = e * a + t * c + n] &= -5, 1 & v[i] && (2 & v[i] && !(2 & v[i] && y[i] >= S) || (v[i] |= 4, g && 2 & v[i] && (o.toArray(e, t, n, A), w = A[0] * a + A[1] * c + A[2], b[i] = b[w])));
                console.timeEnd("EDTSurface fastdistancemap");
              }(), "ses" === t && (S(!1), function () {
                var t, n;
                for (t = 0, n = v.length; t < n; ++t) v[t] &= -3;
                for (t = 0, n = e.length / 3; t < n; ++t) E(t);
              }()), function (e) {
                var t,
                  n = v.length;
                if ("vws" === e) for (t = 0; t < n; ++t) v[t] &= -5, v[t] = 2 & v[t] ? 1 : 0;else if ("ms" === e) for (t = 0; t < n; ++t) v[t] &= -3, 4 & v[t] && (v[t] |= 2), v[t] &= -5, v[t] = 2 & v[t] ? 1 : 0;else if ("ses" === e) for (t = 0; t < n; ++t) 4 & v[t] && 2 & v[t] ? v[t] &= -5 : 4 & v[t] && !(2 & v[t]) && (v[t] |= 2), v[t] = 2 & v[t] ? 1 : 0;else if ("sas" === e) for (t = 0; t < n; ++t) v[t] &= -5, v[t] = 2 & v[t] ? 1 : 0;
              }(t);
              for (var O = 0, R = b.length; O < R; ++O) b[O] = n[b[O]];
              return console.timeEnd("EDTSurface.getVolume"), {
                data: v,
                nx: c,
                ny: u,
                nz: l,
                atomindex: b
              };
            }, this.getSurface = function (e, t, n, r, i, o, a) {
              var s = this.getVolume(e, t, n, r, i);
              return new Qm(s.data, s.nx, s.ny, s.nz, s.atomindex).getSurface(1, o, void 0, d, a);
            };
          }
          function rx(e, t, n, r, i, o, a) {
            var s = e.length,
              l = i[0],
              u = i[1],
              c = i[2],
              d = o[0],
              h = o[1],
              f = o[2];
            function p(e, t) {
              return Math.floor((e - t) / a);
            }
            for (var m, g, v, y = p(d, l) + 1, b = p(h, u) + 1, _ = p(f, c) + 1, x = y * b * _, w = b * _, S = [], A = 0; A < s; A++) {
              var E = (m = e[A], g = t[A], v = n[A], (p(m, l) * b + p(g, u)) * _ + p(v, c));
              void 0 === S[E] ? S[E] = [A] : S[E].push(A);
            }
            var T = new Uint32Array(x),
              M = new Uint16Array(x),
              C = new Uint32Array(s),
              k = 0,
              P = 0;
            for (A = 0; A < x; A++) {
              var O = T[A] = k,
                R = S[A];
              if (void 0 !== R) for (var I = 0; I < R.length; I++) C[k] = R[I], k++;
              var j = k - O;
              P < (M[A] = j) && (P = j);
            }
            return {
              neighbourListLength: 27 * P + 1,
              withinRadii: function withinRadii(i, o, a, s, d) {
                for (var h = 0, f = p(i, l), m = p(o, u), g = p(a, c), v = Math.max(0, f - 1), x = Math.max(0, m - 1), S = Math.max(0, g - 1), A = Math.min(y, f + 2), E = Math.min(b, m + 2), k = Math.min(_, g + 2), P = v; P < A; ++P) for (var O = P * w, R = x; R < E; ++R) for (var I = R * _, j = S; j < k; ++j) for (var N = O + I + j, L = T[N], D = L + M[N], B = L; B < D; B++) {
                  var F = C[B],
                    z = e[F] - i,
                    U = t[F] - o,
                    G = n[F] - a,
                    V = r[F] + s;
                  z * z + U * U + G * G <= V * V && (d[h++] = C[B]);
                }
                d[h] = -1;
              }
            };
          }
          function ix(e, t, n) {
            for (var r = t.length, i = new Float32Array(r), o = new Float32Array(r), a = new Float32Array(r), s = 0; s < r; s++) {
              var l = 3 * s;
              i[s] = e[l], o[s] = e[l + 1], a[s] = e[l + 2];
            }
            var u = ff(e);
            0 === e.length && (u[0].set([0, 0, 0]), u[1].set([0, 0, 0]));
            var c,
              d,
              h,
              f,
              p,
              m,
              g,
              v,
              y,
              b,
              _,
              x,
              w,
              S,
              A,
              E,
              T,
              M,
              C,
              k = u[0],
              P = u[1],
              O = -1,
              R = new Float32Array([0, 0, 0]),
              I = new Float32Array([0, 0, 0]),
              j = new Float32Array([0, 0, 0]),
              N = new Float32Array([0, 0, 0]);
            function L(e, t, n) {
              for (var r = 0; r < e.length; r++) e[r] = t + n * r;
            }
            function D(e, t, n, r, i) {
              var o;
              if (-1 !== O) {
                if ((o = O) !== r && o !== i && B(o, e, t, n)) return o;
                O = -1;
              }
              var a = 0;
              for (o = M[a]; 0 <= o;) {
                if (o !== r && o !== i && B(o, e, t, n)) return O = o;
                o = M[++a];
              }
              return O = -1;
            }
            function B(t, n, r, i) {
              var o = 3 * t,
                a = d[t],
                s = e[o] - n,
                l = e[o + 1] - r,
                u = e[o + 2] - i;
              return s * s + l * l + u * u < a;
            }
            function F(e, t) {
              var n,
                r,
                s = c[e],
                l = c[t],
                u = R[0] = i[t] - i[e],
                d = R[1] = o[t] - o[e],
                h = R[2] = a[t] - a[e],
                f = u * u + d * d + h * h,
                y = Math.sqrt(f),
                T = s * ((s * s + y * y - l * l) / (2 * s * y));
              Mf(R, R), r = R, (n = j)[0] = n[1] = n[2] = 1, 0 !== r[0] ? n[0] = (r[1] + r[2]) / -r[0] : 0 !== r[1] ? n[1] = (r[0] + r[2]) / -r[1] : 0 !== r[2] && (n[2] = (r[0] + r[1]) / -r[2]), Mf(j, j), yf(N, R, j), Mf(N, N);
              var M = Math.sqrt(s * s - T * T);
              Tf(j, j, M), Tf(N, N, M), Tf(R, R, T), I[0] = R[0] + i[e], I[1] = R[1] + o[e], I[2] = R[2] + a[e], O = -1;
              for (var P = C, L = 0; L < g; L++) {
                var B = E[L],
                  F = A[L],
                  z = I[0] + B * j[0] + F * N[0],
                  U = I[1] + B * j[1] + F * N[1],
                  G = I[2] + B * j[2] + F * N[2];
                if (-1 === D(z, U, G, e, t)) for (var V = Math.floor(p * (z - k[0])), H = Math.floor(p * (U - k[1])), q = Math.floor(p * (G - k[2])), W = Math.max(0, V - P), $ = Math.max(0, H - P), X = Math.max(0, q - P), Y = Math.min(v[0], V + P + 2), K = Math.min(v[1], H + P + 2), Z = Math.min(v[2], q + P + 2), Q = W; Q < Y; Q++) {
                  u = z - x[Q];
                  for (var J = v[1] * v[2] * Q, ee = $; ee < K; ee++) for (var te = u * u + (d = U - w[ee]) * d, ne = J + v[2] * ee, re = X; re < Z; re++) {
                    f = te + (h = G - S[re]) * h;
                    var ie = re + ne,
                      oe = b[ie];
                    if (0 < oe && f < oe * oe && (b[ie] = Math.sqrt(f), m)) {
                      var ae = u * R[0] + d * R[1] + h * R[2];
                      _[ie] = ae < 0 ? t : e;
                    }
                  }
                }
              }
            }
            function z(e, s, l) {
              console.time("AVSurface.getVolume"), console.time("AVSurface.init"), function (e, n, s, l) {
                f = wu(e, 1.4), p = wu(n, 2), m = wu(s, !0), g = wu(l, 30), c = new Float32Array(r), d = new Float32Array(r);
                for (var u = 0; u < c.length; ++u) {
                  var R = t[u] + f;
                  c[u] = R, d[u] = R * R;
                }
                for (var I = h = 0; I < c.length; ++I) c[I] > h && (h = c[I]);
                var j;
                j = Ym(k, P, h, p, 0), p = j.scaleFactor, v = j.dim, y = j.matrix, C = Math.max(5, 2 + Math.floor(f * p)), b = Hd(v[0] * v[1] * v[2], -1001), _ = new Int32Array(b.length), x = new Float32Array(v[0]), w = new Float32Array(v[1]), S = new Float32Array(v[2]), L(x, k[0], 1 / p), L(w, k[1], 1 / p), L(S, k[2], 1 / p), function () {
                  var e = 0,
                    t = 2 * Math.PI / g;
                  E = new Float32Array(g), A = new Float32Array(g);
                  for (var n = 0; n < g; n++) E[n] = Math.cos(e), A[n] = Math.sin(e), e += t;
                }(), T = rx(i, o, a, c, k, P, 2.01 * h), M = new Int32Array(T.neighbourListLength), O = -1;
              }(e, s, l), console.timeEnd("AVSurface.init"), console.time("AVSurface.projectPoints"), function () {
                for (var e = 0; e < r; e++) {
                  var t = i[e],
                    n = o[e],
                    s = a[e],
                    l = c[e],
                    u = d[e];
                  T.withinRadii(t, n, s, l, M);
                  for (var h = Math.ceil(l * p), f = Math.floor(p * (t - k[0])), g = Math.floor(p * (n - k[1])), y = Math.floor(p * (s - k[2])), A = Math.max(0, f - h), E = Math.max(0, g - h), C = Math.max(0, y - h), P = Math.min(v[0], f + h + 2), O = Math.min(v[1], g + h + 2), R = Math.min(v[2], y + h + 2), I = A; I < P; I++) for (var j = x[I] - t, N = v[1] * v[2] * I, L = E; L < O; L++) for (var B = w[L] - n, F = j * j + B * B, z = N + v[2] * L, U = C; U < R; U++) {
                    var G = S[U] - s,
                      V = F + G * G;
                    if (V < u) {
                      var H = U + z;
                      b[H] < 0 && (b[H] = -b[H]);
                      var q = Math.sqrt(V),
                        W = l / q,
                        $ = j * W,
                        X = B * W,
                        Y = G * W;
                      if (-1 === D($ += t, X += n, Y += s, e, -1)) {
                        var K = l - q;
                        K < b[H] && (b[H] = K, m && (_[H] = e));
                      }
                    }
                  }
                }
              }(), console.timeEnd("AVSurface.projectPoints"), console.time("AVSurface.projectTorii"), function () {
                for (var e = 0; e < r; e++) {
                  T.withinRadii(i[e], o[e], a[e], c[e], M);
                  for (var t = 0, n = M[t]; 0 <= n;) e < n && F(e, n), n = M[++t];
                }
              }(), console.timeEnd("AVSurface.projectTorii"), function () {
                for (var e = 0; e < b.length; e++) b[e] < 0 && (b[e] = 0);
              }(), function () {
                for (var e = 0; e < _.length; e++) _[e] = n[_[e]];
              }(), console.timeEnd("AVSurface.getVolume");
            }
            this.getSurface = function (e, t, n, r, i, o, a) {
              return z(t, n, i), new Qm(b, v[2], v[1], v[0], _).getSurface(t, !1, void 0, y, a);
            };
          }
          rd.add("line", ex), Object.assign(nx, {
            __deps: [Ym, Xm, Qm, ff, tx]
          }), Object.assign(ix, {
            __deps: [Ym, Qm, Hd, ff, Tf, yf, Mf, rx, wu]
          }), ed.add("molsurf", function (e, t) {
            var n = e.data.args,
              r = e.data.params;
            if (n && r) {
              var i = new ("av" === r.type ? ix : nx)(n.coordList, n.radiusList, n.indexList).getSurface(r.type, r.probeRadius, r.scaleFactor, r.cutoff, !0, r.smooth, r.contour),
                o = [i.position.buffer, i.index.buffer];
              i.normal && o.push(i.normal.buffer), i.atomindex && o.push(i.atomindex.buffer), t({
                sd: i,
                p: r
              }, o);
            }
          }, [nx, ix]);
          var ox = function ox(e) {
            this.structure = e;
          };
          ox.prototype._getAtomData = function (e) {
            return this.structure.getAtomData({
              what: {
                position: !0,
                radius: !0,
                index: !0
              },
              radiusParams: wu(e.radiusParams, {
                type: "vdw",
                scale: 1
              })
            });
          }, ox.prototype._makeSurface = function (e, t) {
            var n = new Km(t.name, "", e);
            return n.info.type = t.type, n.info.probeRadius = t.probeRadius, n.info.scaleFactor = t.scaleFactor, n.info.smooth = t.smooth, n.info.cutoff = t.cutoff, n;
          }, ox.prototype.getSurface = function (e) {
            var t = e || {},
              n = this._getAtomData(e),
              r = n.position,
              i = n.radius,
              o = n.index,
              a = new ("av" === t.type ? ix : nx)(r, i, o).getSurface(t.type, t.probeRadius, t.scaleFactor, t.cutoff, !0, t.smooth, t.contour);
            return this._makeSurface(a, t);
          }, ox.prototype.getSurfaceWorker = function (e, t) {
            var n = this,
              r = Object.assign({}, e);
            if (window.hasOwnProperty("Worker")) {
              void 0 === this.worker && (this.worker = new uf("molsurf"));
              var i = this._getAtomData(e),
                o = i.position,
                a = i.radius,
                s = i.index,
                l = {
                  args: {
                    coordList: o,
                    radiusList: a,
                    indexList: s
                  },
                  params: r
                },
                u = [o.buffer, a.buffer, s.buffer];
              this.worker.post(l, u, function (e) {
                t(n._makeSurface(e.data.sd, r));
              }, function (e) {
                console.warn("MolecularSurface.getSurfaceWorker error - trying without worker", e), n.worker.terminate(), n.worker = void 0;
                var i = n.getSurface(r);
                t(i);
              });
            } else {
              var c = this.getSurface(r);
              t(c);
            }
          }, ox.prototype.dispose = function () {
            this.worker && this.worker.terminate();
          };
          var ax = function (e) {
            function t(t, n, r) {
              var i = this;
              e.call(this, t, n, r), this.type = "surface", this.parameters = Object.assign({
                surfaceType: {
                  type: "select",
                  rebuild: !0,
                  options: {
                    vws: "vws",
                    sas: "sas",
                    ms: "ms",
                    ses: "ses",
                    av: "av"
                  }
                },
                probeRadius: {
                  type: "number",
                  precision: 1,
                  max: 20,
                  min: 0,
                  rebuild: !0
                },
                smooth: {
                  type: "integer",
                  precision: 1,
                  max: 10,
                  min: 0,
                  rebuild: !0
                },
                scaleFactor: {
                  type: "number",
                  precision: 1,
                  max: 5,
                  min: 0,
                  rebuild: !0
                },
                cutoff: {
                  type: "number",
                  precision: 2,
                  max: 50,
                  min: 0,
                  rebuild: !0
                },
                contour: {
                  type: "boolean",
                  rebuild: !0
                },
                background: {
                  type: "boolean",
                  rebuild: !0
                },
                opaqueBack: {
                  type: "boolean",
                  buffer: !0
                },
                filterSele: {
                  type: "text",
                  rebuild: !0
                },
                colorVolume: {
                  type: "hidden"
                },
                useWorker: {
                  type: "boolean",
                  rebuild: !0
                }
              }, this.parameters, {
                radius: null,
                scale: null
              }), this.__infoList = [], this.structure.signals.refreshed.add(function () {
                i.__forceNewMolsurf = !0;
              }), this.toBePrepared = !0, this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.colorScheme = wu(n.colorScheme, "uniform"), n.colorValue = wu(n.colorValue, 14540253), n.disablePicking = wu(n.disablePicking, !0), this.surfaceType = wu(n.surfaceType, "ms"), this.probeRadius = wu(n.probeRadius, 1.4), this.smooth = wu(n.smooth, 2), this.scaleFactor = wu(n.scaleFactor, 2), this.cutoff = wu(n.cutoff, 0), this.contour = wu(n.contour, !1), this.background = wu(n.background, !1), this.opaqueBack = wu(n.opaqueBack, !0), this.filterSele = wu(n.filterSele, ""), this.colorVolume = wu(n.colorVolume, void 0), this.useWorker = wu(n.useWorker, !0), e.prototype.init.call(this, t);
            }, t.prototype.prepareData = function (e, t, n) {
              var r = this.__infoList[t];
              if (r || (r = {}, this.__infoList[t] = r), r.molsurf && r.sele === e.selection.string) n(t);else {
                if (this.filterSele) {
                  var i = e.structure.getView(new Nc(this.filterSele)),
                    o = i.boundingBox.getSize(new ae()),
                    a = Math.max(o.x, o.y, o.z),
                    s = e.getAtomSetWithinPoint(i.center, a / 2 + 6);
                  e = e.getView(new Nc(e.getAtomSetWithinSelection(s, 3).toSeleString()));
                }
                r.sele = e.selection.string, r.molsurf = new ox(e);
                var l = this.getSurfaceParams(),
                  u = function u(e) {
                    r.surface = e, n(t);
                  };
                this.useWorker ? r.molsurf.getSurfaceWorker(l, u) : u(r.molsurf.getSurface(l));
              }
            }, t.prototype.prepare = function (e) {
              var t = this;
              if ((this.__forceNewMolsurf || this.__sele !== this.selection.string || this.__surfaceParams !== JSON.stringify(this.getSurfaceParams())) && (this.__infoList.forEach(function (e) {
                e.molsurf.dispose();
              }), this.__infoList.length = 0), 0 !== this.structureView.atomCount) {
                var n = function n() {
                    t.__sele = t.selection.string, t.__surfaceParams = JSON.stringify(t.getSurfaceParams()), t.__forceNewMolsurf = !1, e();
                  },
                  r = "default" === this.assembly ? this.defaultAssembly : this.assembly,
                  i = this.structure.biomolDict[r];
                i ? i.partList.forEach(function (e, r) {
                  var o = e.getView(t.structureView);
                  t.prepareData(o, r, function (e) {
                    e === i.partList.length - 1 && n();
                  });
                }) : this.prepareData(this.structureView, 0, n);
              } else e();
            }, t.prototype.createData = function (e, t) {
              var n = this.__infoList[t],
                r = n.surface,
                i = {
                  position: r.getPosition(),
                  color: r.getColor(this.getColorParams()),
                  index: r.getFilteredIndex(this.filterSele, e)
                },
                o = [];
              if (r.contour) {
                var a = new pg(i, this.getBufferParams({
                  wireframe: !1
                }));
                o.push(a);
              } else {
                Object.assign(i, {
                  normal: r.getNormal(),
                  picking: r.getPicking(e.getStructure())
                });
                var s = new ug(i, this.getBufferParams({
                    background: this.background,
                    opaqueBack: this.opaqueBack,
                    dullInterior: !1
                  })),
                  l = new hg(s);
                o.push(l);
              }
              return {
                bufferList: o,
                info: n
              };
            }, t.prototype.updateData = function (e, t) {
              var n = {};
              if (e.position || e.radius) return this.__forceNewMolsurf = !0, void this.build();
              e.color && (n.color = t.info.surface.getColor(this.getColorParams())), e.index && (n.index = t.info.surface.getFilteredIndex(this.filterSele, t.sview)), t.bufferList[0].setAttributes(n);
            }, t.prototype.setParameters = function (t, n, r) {
              return void 0 === n && (n = {}), t && t.filterSele && (n.index = !0), t && void 0 !== t.colorVolume && (n.color = !0), t && t.wireframe && (t.contour || void 0 === t.contour && this.contour) && (t.wireframe = !1), e.prototype.setParameters.call(this, t, n, r), this;
            }, t.prototype.getSurfaceParams = function (e) {
              return void 0 === e && (e = {}), Object.assign({
                type: this.surfaceType,
                probeRadius: this.probeRadius,
                scaleFactor: this.scaleFactor,
                smooth: this.smooth && !this.contour,
                cutoff: this.cutoff,
                contour: this.contour,
                useWorker: this.useWorker,
                radiusParams: this.getRadiusParams()
              }, e);
            }, t.prototype.getColorParams = function () {
              var t = e.prototype.getColorParams.call(this);
              return t.volume = this.colorVolume, t;
            }, t.prototype.getAtomRadius = function () {
              return 0;
            }, t.prototype.clear = function () {
              e.prototype.clear.call(this);
            }, t.prototype.dispose = function () {
              this.__infoList.forEach(function (e) {
                e.molsurf.dispose();
              }), this.__infoList.length = 0, e.prototype.dispose.call(this);
            }, t;
          }(Xb);
          rd.add("surface", ax);
          var sx = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "point", this.parameters = Object.assign({
                pointSize: {
                  type: "number",
                  precision: 1,
                  max: 100,
                  min: 0,
                  buffer: !0
                },
                sizeAttenuation: {
                  type: "boolean",
                  buffer: !0
                },
                sortParticles: {
                  type: "boolean",
                  rebuild: !0
                },
                useTexture: {
                  type: "boolean",
                  buffer: !0
                },
                alphaTest: {
                  type: "range",
                  step: .001,
                  max: 1,
                  min: 0,
                  buffer: !0
                },
                forceTransparent: {
                  type: "boolean",
                  buffer: !0
                },
                edgeBleach: {
                  type: "range",
                  step: .001,
                  max: 1,
                  min: 0,
                  buffer: !0
                }
              }, this.parameters, {
                flatShaded: null,
                wireframe: null,
                linewidth: null,
                side: null,
                roughness: null,
                metalness: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              this.pointSize = wu(n.pointSize, 1), this.sizeAttenuation = wu(n.sizeAttenuation, !0), this.sortParticles = wu(n.sortParticles, !1), this.useTexture = wu(n.useTexture, !1), this.alphaTest = wu(n.alphaTest, .5), this.forceTransparent = wu(n.forceTransparent, !1), this.edgeBleach = wu(n.edgeBleach, 0), e.prototype.init.call(this, n);
            }, t.prototype.createData = function (e) {
              var t = e.getAtomData(this.getAtomParams({
                position: !0,
                color: !0,
                picking: !0
              }));
              return {
                bufferList: [new Sy(t, this.getBufferParams({
                  pointSize: this.pointSize,
                  sizeAttenuation: this.sizeAttenuation,
                  sortParticles: this.sortParticles,
                  useTexture: this.useTexture,
                  alphaTest: this.alphaTest,
                  forceTransparent: this.forceTransparent,
                  edgeBleach: this.edgeBleach
                }))]
              };
            }, t.prototype.updateData = function (e, t) {
              var n = t.sview.getAtomData(this.getAtomParams(e)),
                r = {};
              e && !e.position || Object.assign(r, {
                position: n.position
              }), e && !e.color || Object.assign(r, {
                color: n.color
              }), t.bufferList[0].setAttributes(r);
            }, t.prototype.getAtomRadius = function () {
              return .1;
            }, t;
          }(Xb);
          rd.add("point", sx), od.add("shader/Ribbon.vert", "#define STANDARD\nuniform float clipNear;\nuniform vec3 clipCenter;\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || !defined( PICKING )\nvarying vec3 vViewPosition;\n#endif\n#if defined( RADIUS_CLIP )\nvarying vec3 vClipCenter;\n#endif\nattribute vec3 dir;\nattribute float size;\n#ifdef PICKING\n#include unpack_color\nattribute float primitiveId;\nvarying vec3 vPickingColor;\n#else\n#include color_pars_vertex\n#ifndef FLAT_SHADED\nvarying vec3 vNormal;\n#endif\n#endif\n#include common\nvoid main(void){\n#ifdef PICKING\nvPickingColor = unpackColor( primitiveId );\n#else\n#include color_vertex\n#include beginnormal_vertex\n#include defaultnormal_vertex\n#ifndef FLAT_SHADED\nvNormal = normalize( transformedNormal );\n#endif\n#endif\n#include begin_vertex\ntransformed += normalize( dir ) * size;\n#include project_vertex\n#if defined( NEAR_CLIP ) || defined( RADIUS_CLIP ) || !defined( PICKING )\nvViewPosition = -mvPosition.xyz;\n#endif\n#if defined( RADIUS_CLIP )\nvClipCenter = -( modelViewMatrix * vec4( clipCenter, 1.0 ) ).xyz;\n#endif\n#include nearclip_vertex\n}");
          var lx = new Uint16Array([0, 1, 2, 1, 3, 2]);
          function ux(e) {
            return 4 * (e.position.length / 3 - 1) * 3;
          }
          var cx = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, {
                  position: new Float32Array(ux(t)),
                  color: new Float32Array(ux(t)),
                  index: Nu(ux(t), ux(t) / 3),
                  normal: new Float32Array(ux(t)),
                  picking: t.picking
                }, n), this.vertexShader = "Ribbon.vert";
                var r = t.position.length / 3 - 1,
                  i = 4 * r,
                  o = 3 * i;
                this.addAttributes({
                  dir: {
                    type: "v3",
                    value: new Float32Array(o)
                  }
                }), this.addAttributes({
                  size: {
                    type: "f",
                    value: new Float32Array(i)
                  }
                }), t.primitiveId = Wd(r), this.setAttributes(t), this.makeIndex();
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.setAttributes = function (e) {
                void 0 === e && (e = {});
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h,
                  f,
                  p,
                  m,
                  g,
                  v,
                  y,
                  b,
                  _ = this.size / 4,
                  x = this.geometry.attributes;
                e.position && (t = e.position, s = x.position.array, x.position.needsUpdate = !0), e.normal && (n = e.normal, l = x.normal.array, x.normal.needsUpdate = !0), e.size && (r = e.size, u = x.size.array, x.size.needsUpdate = !0), e.dir && (i = e.dir, c = x.dir.array, x.dir.needsUpdate = !0), e.color && (o = e.color, d = x.color.array, x.color.needsUpdate = !0), e.primitiveId && (a = e.primitiveId, h = x.primitiveId.array, x.primitiveId.needsUpdate = !0);
                var w = r ? r[0] : null;
                for (f = 0; f < _; ++f) {
                  for (m = 4 * (y = 3 * f), v = 4 * f, t && (s[m] = s[m + 3] = t[y], s[m + 1] = s[m + 4] = t[y + 1], s[m + 2] = s[m + 5] = t[y + 2], s[m + 6] = s[m + 9] = t[y + 3], s[m + 7] = s[m + 10] = t[y + 4], s[m + 8] = s[m + 11] = t[y + 5]), n && (l[m] = l[m + 3] = -n[y], l[m + 1] = l[m + 4] = -n[y + 1], l[m + 2] = l[m + 5] = -n[y + 2], l[m + 6] = l[m + 9] = -n[y + 3], l[m + 7] = l[m + 10] = -n[y + 4], l[m + 8] = l[m + 11] = -n[y + 5]), p = 0; p < 4; ++p) g = m + 3 * p, o && (d[g] = o[y], d[g + 1] = o[y + 1], d[g + 2] = o[y + 2]), a && (h[v + p] = a[f]);
                  r && (b = r[f], w !== r[f] ? (u[v] = w, u[v + 1] = w) : (u[v] = b, u[v + 1] = b), u[v + 2] = b, w = u[v + 3] = b), i && (c[m] = i[y], c[m + 1] = i[y + 1], c[m + 2] = i[y + 2], c[m + 3] = -i[y], c[m + 4] = -i[y + 1], c[m + 5] = -i[y + 2], c[m + 6] = i[y + 3], c[m + 7] = i[y + 4], c[m + 8] = i[y + 5], c[m + 9] = -i[y + 3], c[m + 10] = -i[y + 4], c[m + 11] = -i[y + 5]);
                }
              }, t.prototype.makeIndex = function () {
                for (var e = this.geometry.getIndex().array, t = e.length / 4 / 3, n = 0; n < t; ++n) {
                  var r = 6 * n,
                    i = 4 * n;
                  e.set(lx, r);
                  for (var o = 0; o < 6; ++o) e[r + o] += i;
                }
              }, t;
            }(lg),
            dx = function (e) {
              function t(t, n, r) {
                e.call(this, t, n, r), this.type = "ribbon", this.parameters = Object.assign({
                  subdiv: {
                    type: "integer",
                    max: 50,
                    min: 1,
                    rebuild: !0
                  },
                  tension: {
                    type: "number",
                    precision: 1,
                    max: 1,
                    min: .1
                  },
                  smoothSheet: {
                    type: "boolean",
                    rebuild: !0
                  }
                }, this.parameters, {
                  side: null,
                  wireframe: null,
                  linewidth: null
                }), this.init(r);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
                var n = t || {};
                n.colorScheme = wu(n.colorScheme, "chainname"), n.colorScale = wu(n.colorScale, "RdYlBu"), n.radiusType = wu(n.radiusType, "sstruc"), n.radiusScale = wu(n.radiusScale, 4), "low" === n.quality ? this.subdiv = 3 : "medium" === n.quality ? this.subdiv = 6 : "high" === n.quality ? this.subdiv = 12 : this.subdiv = wu(n.subdiv, 6), this.tension = wu(n.tension, NaN), this.smoothSheet = wu(n.smoothSheet, !1), e.prototype.init.call(this, n);
              }, t.prototype.getSplineParams = function (e) {
                return Object.assign({
                  subdiv: this.subdiv,
                  tension: this.tension,
                  directional: !0,
                  smoothSheet: this.smoothSheet
                }, e);
              }, t.prototype.getAtomRadius = function (t) {
                return t.isTrace() ? e.prototype.getAtomRadius.call(this, t) : 0;
              }, t.prototype.createData = function (e) {
                var t = this,
                  n = [],
                  r = [];
                return this.structure.eachPolymer(function (e) {
                  if (!(e.residueCount < 4)) {
                    r.push(e);
                    var i = new P_(e, t.getSplineParams()),
                      o = i.getSubdividedPosition(),
                      a = i.getSubdividedOrientation(),
                      s = i.getSubdividedColor(t.getColorParams()),
                      l = i.getSubdividedPicking(),
                      u = i.getSubdividedSize(t.getRadiusParams());
                    n.push(new cx({
                      position: o.position,
                      normal: a.binormal,
                      dir: a.normal,
                      color: s.color,
                      size: u.size,
                      picking: l.picking
                    }, t.getBufferParams()));
                  }
                }, e.getSelection()), {
                  bufferList: n,
                  polymerList: r
                };
              }, t.prototype.updateData = function (e, t) {
                e = e || {};
                var n = 0,
                  r = t.polymerList.length;
                for (n = 0; n < r; ++n) {
                  var i = {},
                    o = new P_(t.polymerList[n], this.getSplineParams());
                  if (e.position) {
                    var a = o.getSubdividedPosition(),
                      s = o.getSubdividedOrientation();
                    Object.assign(i, {
                      position: a.position,
                      normal: s.binormal,
                      dir: s.normal
                    });
                  }
                  if (e.radius || e.scale) {
                    var l = o.getSubdividedSize(this.getRadiusParams());
                    Object.assign(i, {
                      size: l.size
                    });
                  }
                  if (e.color) {
                    var u = o.getSubdividedColor(this.getColorParams());
                    Object.assign(i, {
                      color: u.color
                    });
                  }
                  t.bufferList[n].setAttributes(i);
                }
              }, t.prototype.setParameters = function (t) {
                var n = {};
                return t && t.tension && Object.assign(n, {
                  position: !0
                }), e.prototype.setParameters.call(this, t, n, !1), this;
              }, t;
            }(Xb);
          rd.add("ribbon", dx);
          var hx = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "rocket", this.parameters = Object.assign({
                localAngle: {
                  type: "integer",
                  max: 180,
                  min: 0,
                  rebuild: !0
                },
                centerDist: {
                  type: "number",
                  precision: 1,
                  max: 10,
                  min: 0,
                  rebuild: !0
                },
                ssBorder: {
                  type: "boolean",
                  rebuild: !0
                },
                radialSegments: !0,
                openEnded: !0,
                disableImpostor: !0
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.colorScheme = wu(n.colorScheme, "sstruc"), n.radiusSize = wu(n.radiusSize, 1.5), n.radiusScale = wu(n.radiusScale, 1), n.openEnded = wu(n.openEnded, !1), n.useInteriorColor = wu(n.useInteriorColor, !0), this.localAngle = wu(n.localAngle, 30), this.centerDist = wu(n.centerDist, 2.5), this.ssBorder = wu(n.ssBorder, !1), e.prototype.init.call(this, n);
            }, t.prototype.createData = function (e) {
              var t = this,
                n = 0,
                r = [],
                i = [];
              this.structure.eachPolymer(function (e) {
                if (!(e.residueCount < 4 || e.isNucleic())) {
                  var o = new Xg(e),
                    a = o.getAxis(t.localAngle, t.centerDist, t.ssBorder, t.getColorParams(), t.getRadiusParams());
                  n += a.size.length, r.push(a), i.push(o);
                }
              }, e.getSelection());
              var o = {
                  begin: new Float32Array(3 * n),
                  end: new Float32Array(3 * n),
                  size: new Float32Array(n),
                  color: new Float32Array(3 * n),
                  picking: {}
                },
                a = new Float32Array(n),
                s = 0;
              return r.forEach(function (e) {
                o.begin.set(e.begin, 3 * s), o.end.set(e.end, 3 * s), o.size.set(e.size, s), o.color.set(e.color, 3 * s), a.set(e.picking.array, s), s += e.size.length;
              }), n && (o.picking = new am(a, e.getStructure())), {
                bufferList: [new A_({
                  position1: o.begin,
                  position2: o.end,
                  color: o.color,
                  color2: o.color,
                  radius: o.size,
                  picking: o.picking
                }, this.getBufferParams({
                  openEnded: this.openEnded,
                  radialSegments: this.radialSegments,
                  disableImpostor: this.disableImpostor,
                  dullInterior: !0
                }))],
                axisList: r,
                helixbundleList: i,
                axisData: o
              };
            }, t.prototype.updateData = function (e, t) {
              var n = this;
              if ((e = e || {}).position) this.build();else {
                var r = {};
                if (e.color || e.radius) {
                  var i = 0;
                  t.helixbundleList.forEach(function (r) {
                    var o = r.getAxis(n.localAngle, n.centerDist, n.ssBorder, n.getColorParams(), n.getRadiusParams());
                    e.color && t.axisData.color.set(o.color, 3 * i), (e.radius || e.scale) && t.axisData.size.set(o.size, i), i += o.size.length;
                  }), e.color && Object.assign(r, {
                    color: t.axisData.color,
                    color2: t.axisData.color
                  }), (e.radius || e.scale) && Object.assign(r, {
                    radius: t.axisData.size
                  });
                }
                t.bufferList[0].setAttributes(r);
              }
            }, t;
          }(Xb);
          rd.add("rocket", hx);
          var fx = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "rope", this.parameters = Object.assign({
                smooth: {
                  type: "integer",
                  max: 15,
                  min: 0,
                  rebuild: !0
                }
              }, this.parameters, {
                aspectRatio: null,
                smoothSheet: null
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.aspectRatio = 1, n.tension = wu(n.tension, .5), n.radiusScale = wu(n.radiusScale, 5), n.smoothSheet = !1, this.smooth = wu(n.smooth, 2), e.prototype.init.call(this, n);
            }, t.prototype.getSpline = function (e) {
              var t = new $g(e);
              return new P_(e, this.getSplineParams({
                directional: !1,
                positionIterator: t.getCenterIterator(this.smooth)
              }));
            }, t;
          }(N_);
          rd.add("rope", fx);
          var px = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "spacefill", this.parameters = Object.assign({
                sphereDetail: !0,
                disableImpostor: !0
              }, this.parameters), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.useInteriorColor = wu(n.useInteriorColor, !0), e.prototype.init.call(this, n);
            }, t.prototype.createData = function (e) {
              return {
                bufferList: [new _y(e.getAtomData(this.getAtomParams()), this.getBufferParams({
                  sphereDetail: this.sphereDetail,
                  dullInterior: !0,
                  disableImpostor: this.disableImpostor
                }))]
              };
            }, t.prototype.updateData = function (e, t) {
              var n = t.sview.getAtomData(this.getAtomParams(e)),
                r = {};
              e && !e.position || Object.assign(r, {
                position: n.position
              }), e && !e.color || Object.assign(r, {
                color: n.color
              }), e && !e.radius || Object.assign(r, {
                radius: n.radius
              }), t.bufferList[0].setAttributes(r);
            }, t;
          }(Xb);
          function mx(e) {
            return 3 * (e.position.length / 3 - 1) * 2;
          }
          rd.add("spacefill", px);
          var gx = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, {
                  position: new Float32Array(mx(t)),
                  color: new Float32Array(mx(t))
                }, n), this.isLine = !0, this.vertexShader = "Line.vert", this.fragmentShader = "Line.frag", this.setAttributes(t);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.setAttributes = function (e) {
                var t,
                  n,
                  r,
                  i,
                  o = this.geometry.attributes;
                if (e.position && (t = e.position, r = o.position.array, o.position.needsUpdate = !0), e.color && (n = e.color, i = o.color.array, o.color.needsUpdate = !0), t || n) for (var a, s, l = this.size - 1, u = 0; u < l; ++u) s = 2 * (a = 3 * u), t && (r[s] = t[a], r[s + 1] = t[a + 1], r[s + 2] = t[a + 2], r[s + 3] = t[a + 3], r[s + 4] = t[a + 4], r[s + 5] = t[a + 5]), n && (i[s] = n[a], i[s + 1] = n[a + 1], i[s + 2] = n[a + 2], i[s + 3] = n[a + 3], i[s + 4] = n[a + 4], i[s + 5] = n[a + 5]);else Zc.warn("TraceBuffer.prototype.setAttributes no data");
              }, t;
            }(ag),
            vx = function (e) {
              function t(t, n, r) {
                e.call(this, t, n, r), this.type = "trace", this.parameters = Object.assign({
                  subdiv: {
                    type: "integer",
                    max: 50,
                    min: 1,
                    rebuild: !0
                  },
                  tension: {
                    type: "number",
                    precision: 1,
                    max: 1,
                    min: .1
                  },
                  smoothSheet: {
                    type: "boolean",
                    rebuild: !0
                  }
                }, this.parameters, {
                  flatShaded: null,
                  side: null,
                  wireframe: null
                }), this.init(r);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
                var n = t || {};
                n.colorScheme = wu(n.colorScheme, "chainname"), n.colorScale = wu(n.colorScale, "RdYlBu"), "low" === n.quality ? this.subdiv = 3 : "medium" === n.quality ? this.subdiv = 6 : "high" === n.quality ? this.subdiv = 12 : this.subdiv = wu(n.subdiv, 6), this.tension = wu(n.tension, NaN), this.smoothSheet = wu(n.smoothSheet, !1), e.prototype.init.call(this, n);
              }, t.prototype.getSplineParams = function (e) {
                return Object.assign({
                  subdiv: this.subdiv,
                  tension: this.tension,
                  directional: !1,
                  smoothSheet: this.smoothSheet
                }, e);
              }, t.prototype.getAtomRadius = function (e) {
                return e.isTrace() ? .1 : 0;
              }, t.prototype.createData = function (e) {
                var t = this,
                  n = [],
                  r = [];
                return this.structure.eachPolymer(function (e) {
                  if (!(e.residueCount < 4)) {
                    r.push(e);
                    var i = new P_(e, t.getSplineParams()),
                      o = i.getSubdividedPosition(),
                      a = i.getSubdividedColor(t.getColorParams());
                    n.push(new gx(Object.assign({}, o, a), t.getBufferParams()));
                  }
                }, e.getSelection()), {
                  bufferList: n,
                  polymerList: r
                };
              }, t.prototype.updateData = function (e, t) {
                e = e || {};
                var n = 0,
                  r = t.polymerList.length;
                for (n = 0; n < r; ++n) {
                  var i = {},
                    o = new P_(t.polymerList[n], this.getSplineParams());
                  if (e.position) {
                    var a = o.getSubdividedPosition();
                    Object.assign(i, {
                      position: a.position
                    });
                  }
                  if (e.color) {
                    var s = o.getSubdividedColor(this.getColorParams());
                    Object.assign(i, {
                      color: s.color
                    });
                  }
                  t.bufferList[n].setAttributes(i);
                }
              }, t.prototype.setParameters = function (t) {
                var n = {};
                return t && t.tension && Object.assign(n, {
                  position: !0
                }), e.prototype.setParameters.call(this, t, n, !1), this;
              }, t;
            }(Xb);
          rd.add("trace", vx);
          var yx = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "tube", this.parameters = Object.assign({}, this.parameters, {
                aspectRatio: null
              });
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.aspectRatio = 1, n.radiusScale = wu(n.radiusScale, 2), "low" === n.quality && (this.radialSegments = 5), e.prototype.init.call(this, n);
            }, t.prototype.getSplineParams = function () {
              return e.prototype.getSplineParams.call(this, {
                directional: !1
              });
            }, t;
          }(N_);
          rd.add("tube", yx);
          var bx = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "unitcell", this.parameters = Object.assign({
                radiusSize: {
                  type: "number",
                  precision: 3,
                  max: 10,
                  min: .001
                },
                sphereDetail: !0,
                radialSegments: !0,
                disableImpostor: !0
              }, this.parameters, {
                assembly: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {},
                r = .5;
              this.structure.unitcell && (r = Math.cbrt(this.structure.unitcell.volume) / 200), n.radiusSize = wu(n.radiusSize, r), n.colorValue = wu(n.colorValue, "orange"), n.useInteriorColor = wu(n.useInteriorColor, !0), e.prototype.init.call(this, n);
            }, t.prototype.getUnitcellData = function (e) {
              return e.unitcell.getData(e);
            }, t.prototype.create = function () {
              var e = this.structureView.getStructure();
              if (e.unitcell) {
                var t = this.getUnitcellData(e);
                this.sphereBuffer = new _y(t.vertex, this.getBufferParams({
                  sphereDetail: this.sphereDetail,
                  disableImpostor: this.disableImpostor,
                  dullInterior: !0
                })), this.cylinderBuffer = new A_(t.edge, this.getBufferParams({
                  openEnded: !0,
                  radialSegments: this.radialSegments,
                  disableImpostor: this.disableImpostor,
                  dullInterior: !0
                })), this.dataList.push({
                  sview: this.structureView,
                  bufferList: [this.sphereBuffer, this.cylinderBuffer]
                });
              }
            }, t.prototype.createData = function (e) {}, t.prototype.updateData = function (e, t) {
              var n = t.sview.getStructure();
              if (n.unitcell) {
                var r = this.getUnitcellData(n),
                  i = {},
                  o = {};
                e && !e.position || (Object.assign(i, {
                  position: r.vertex.position
                }), Object.assign(o, {
                  position1: r.edge.position1,
                  position2: r.edge.position2
                })), e && !e.color || (Object.assign(i, {
                  color: r.vertex.color
                }), Object.assign(o, {
                  color: r.edge.color,
                  color2: r.edge.color2
                })), e && !e.radius || (Object.assign(i, {
                  radius: r.vertex.radius
                }), Object.assign(o, {
                  radius: r.edge.radius
                })), this.sphereBuffer.setAttributes(i), this.cylinderBuffer.setAttributes(o);
              }
            }, t;
          }(Xb);
          rd.add("unitcell", bx);
          var _x = function (e) {
            function t(t, n, r) {
              e.call(this, t, n, r), this.type = "validation", this.parameters = Object.assign({}, this.parameters, {
                radiusType: null,
                radiusSize: null,
                radiusScale: null
              }), this.init(r);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.init = function (t) {
              var n = t || {};
              n.colorValue = wu(n.colorValue, "#f0027f"), n.useInteriorColor = wu(n.useInteriorColor, !0), e.prototype.init.call(this, n);
            }, t.prototype.createData = function (e) {
              if (e.validation) {
                var t = e.validation.getClashData({
                  structure: e,
                  color: this.colorValue
                });
                return {
                  bufferList: [new A_(t, this.getBufferParams({
                    openEnded: !1
                  }))]
                };
              }
            }, t;
          }(Xb);
          rd.add("validation", _x);
          var xx = new ae(),
            wx = new ae(),
            Sx = new ae(),
            Ax = new ae(0, 1, 0),
            Ex = Object.assign({
              radialSegments: 60,
              openEnded: !1
            }, ig),
            Tx = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, {
                  position: new Float32Array(t.position1.length),
                  color: t.color,
                  picking: t.picking
                }, n, function (e) {
                  void 0 === e && (e = {});
                  var t = new na(1, 1, wu(e.radialSegments, 60), 1, wu(e.openEnded, !1));
                  return t.applyMatrix(new ie().makeRotationX(-Math.PI / 2)), t;
                }(n)), this.updateNormals = !0, this._position = new Float32Array(t.position1.length), this.setAttributes(t, !0);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return Ex;
              }, t.prototype.applyPositionTransform = function (e, t, n) {
                wx.fromArray(this._position1, n), Sx.fromArray(this._position2, n), e.lookAt(wx, Sx, Ax);
                var r = this._radius[t];
                xx.set(r, r, wx.distanceTo(Sx)), e.scale(xx);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.position1 && t.position2 && (Gd(t.position1, t.position2, this._position), this._position1 = t.position1, this._position2 = t.position2, t.position = this._position), t.radius && (this._radius = t.radius), e.prototype.setAttributes.call(this, t, n);
              }, Object.defineProperties(t.prototype, n), t;
            }(dy);
          ld.add("cone", Tx);
          var Mx = function Mx(e) {
            void 0 === e && (e = []), this.geometryList = e;
          };
          Mx.prototype.computeBoundingBox = function () {
            var e = this;
            this.boundingBox ? this.boundingBox.empty() : this.boundingBox = new Oe(), this.geometryList.forEach(function (t) {
              t.boundingBox || t.computeBoundingBox(), e.boundingBox.union(t.boundingBox);
            });
          };
          var Cx = Object.assign({
              aspectRatio: 1.5,
              radialSegments: 50,
              openEnded: !1,
              disableImpostor: !1
            }, ig),
            kx = function kx(e, t) {
              void 0 === t && (t = {}), this.group = new xi(), this.wireframeGroup = new xi(), this.pickingGroup = new xi(), this.visible = !0, this.parameters = Su(t, this.defaultParameters), this.splitPosition = new Float32Array(e.position1.length), this.cylinderRadius = new Float32Array(e.radius.length);
              var n = this.makeAttributes(e),
                r = {
                  radialSegments: this.parameters.radialSegments,
                  openEnded: this.parameters.openEnded,
                  disableImpostor: this.parameters.disableImpostor
                };
              this.cylinderBuffer = new A_(n.cylinder, r), this.coneBuffer = new Tx(n.cone, r), this.geometry = new Mx([this.cylinderBuffer.geometry, this.coneBuffer.geometry]), this.matrix = wu(t.matrix, new ie()), this.picking = e.picking;
            },
            Px = {
              defaultParameters: {
                configurable: !0
              },
              matrix: {
                configurable: !0
              },
              pickable: {
                configurable: !0
              }
            };
          Px.defaultParameters.get = function () {
            return Cx;
          }, Px.matrix.set = function (e) {
            ag.prototype.setMatrix.call(this, e);
          }, Px.matrix.get = function () {
            return this.group.matrix.clone();
          }, Px.pickable.get = function () {
            return !!this.picking;
          }, kx.prototype.makeAttributes = function (e) {
            void 0 === e && (e = {});
            var t,
              n,
              r = this.splitPosition,
              i = this.cylinderRadius,
              o = this.parameters.aspectRatio,
              a = {},
              s = {};
            if (e.radius) {
              for (t = 0, n = i.length; t < n; ++t) i[t] = e.radius[t] / o;
              a.radius = i, s.radius = e.radius;
            }
            if (e.position1 && e.position2) {
              var l = new ae(),
                u = new ae(),
                c = new ae(),
                d = new ae();
              for (t = 0, n = r.length; t < n; t += 3) {
                l.fromArray(e.position1, t), u.fromArray(e.position2, t), c.subVectors(l, u);
                var h = c.length(),
                  f = i[t / 3] * o * 2,
                  p = Math.min(h, f);
                c.setLength(p), d.copy(u).add(c), d.toArray(r, t);
              }
              a.position1 = e.position1, a.position2 = r, s.position1 = r, s.position2 = e.position2;
            }
            return e.color && (a.color = e.color, a.color2 = e.color, s.color = e.color), {
              cylinder: a,
              cone: s
            };
          }, kx.prototype.getMesh = function () {
            return new xi().add(this.cylinderBuffer.getMesh(), this.coneBuffer.getMesh());
          }, kx.prototype.getWireframeMesh = function () {
            return new xi().add(this.cylinderBuffer.getWireframeMesh(), this.coneBuffer.getWireframeMesh());
          }, kx.prototype.getPickingMesh = function () {
            return new xi().add(this.cylinderBuffer.getPickingMesh(), this.coneBuffer.getPickingMesh());
          }, kx.prototype.setAttributes = function (e) {
            void 0 === e && (e = {});
            var t = this.makeAttributes(e);
            this.cylinderBuffer.setAttributes(t.cylinder), this.coneBuffer.setAttributes(t.cone);
          }, kx.prototype.setParameters = function (e) {
            void 0 === e && (e = {}), (e = Object.assign({}, e)) && void 0 !== e.matrix && (this.matrix = e.matrix), delete e.matrix, e && void 0 !== e.wireframe && (this.parameters.wireframe = e.wireframe, this.setVisibility(this.visible)), this.cylinderBuffer.setParameters(e), this.coneBuffer.setParameters(e);
          }, kx.prototype.setVisibility = function (e) {
            ag.prototype.setVisibility.call(this, e);
          }, kx.prototype.dispose = function () {
            this.cylinderBuffer.dispose(), this.coneBuffer.dispose();
          }, Object.defineProperties(kx.prototype, Px), ld.add("arrow", kx);
          var Ox = new ae(),
            Rx = new ae(),
            Ix = new ae(),
            jx = new ae(0, 0, 0),
            Nx = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n, new Zt(1, 1, 1)), this.updateNormals = !0, this.setAttributes(t, !0);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.applyPositionTransform = function (e, t, n) {
                Rx.fromArray(this._heightAxis, n), Ix.fromArray(this._depthAxis, n), e.lookAt(jx, Rx, Ix), Ox.set(this._size[t], Ix.length(), Rx.length()), e.scale(Ox);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.size && (this._size = t.size), t.heightAxis && (this._heightAxis = t.heightAxis), t.depthAxis && (this._depthAxis = t.depthAxis), e.prototype.setAttributes.call(this, t, n);
              }, t;
            }(dy);
          ld.add("box", Nx);
          var Lx = new ae(),
            Dx = new ae(),
            Bx = new ae(),
            Fx = new ae(0, 0, 0),
            zx = Object.assign({
              sphereDetail: 2
            }, ig),
            Ux = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n, new io(1, wu(n.sphereDetail, 2))), this.updateNormals = !0, this.setAttributes(t, !0);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return zx;
              }, t.prototype.applyPositionTransform = function (e, t, n) {
                Dx.fromArray(this._majorAxis, n), Bx.fromArray(this._minorAxis, n), e.lookAt(Fx, Dx, Bx), Lx.set(this._radius[t], Bx.length(), Dx.length()), e.scale(Lx);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.radius && (this._radius = t.radius), t.majorAxis && (this._majorAxis = t.majorAxis), t.minorAxis && (this._minorAxis = t.minorAxis), e.prototype.setAttributes.call(this, t, n);
              }, Object.defineProperties(t.prototype, n), t;
            }(dy);
          ld.add("ellipsoid", Ux);
          var Gx = new ae(),
            Vx = new ae(),
            Hx = new ae(),
            qx = new ae(0, 0, 0),
            Wx = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n, new no(1, 0)), this.updateNormals = !0, this.setAttributes(t, !0);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.applyPositionTransform = function (e, t, n) {
                Vx.fromArray(this._heightAxis, n), Hx.fromArray(this._depthAxis, n), e.lookAt(qx, Vx, Hx), Gx.set(this._size[t], Hx.length(), Vx.length()), e.scale(Gx);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.size && (this._size = t.size), t.heightAxis && (this._heightAxis = t.heightAxis), t.depthAxis && (this._depthAxis = t.depthAxis), e.prototype.setAttributes.call(this, t, n);
              }, t;
            }(dy);
          ld.add("octahedron", Wx);
          var $x = new ae(),
            Xx = new ae(),
            Yx = new ae(),
            Kx = new ae(0, 0, 0),
            Zx = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n, new eo(1, 0)), this.updateNormals = !0, this.setAttributes(t, !0);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.applyPositionTransform = function (e, t, n) {
                Xx.fromArray(this._heightAxis, n), Yx.fromArray(this._depthAxis, n), e.lookAt(Kx, Xx, Yx), $x.set(this._size[t], Yx.length(), Xx.length()), e.scale($x);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.size && (this._size = t.size), t.heightAxis && (this._heightAxis = t.heightAxis), t.depthAxis && (this._depthAxis = t.depthAxis), e.prototype.setAttributes.call(this, t, n);
              }, t;
            }(dy);
          ld.add("tetrahedron", Zx);
          var Qx = new ae(),
            Jx = new ae(),
            ew = new ae(),
            tw = new ae(0, 0, 0),
            nw = Object.assign({
              radiusRatio: .2,
              radialSegments: 16,
              tubularSegments: 32
            }, ig),
            rw = function (e) {
              function t(t, n) {
                void 0 === n && (n = {}), e.call(this, t, n, new fo(1, wu(n.radiusRatio, .2), wu(n.radialSegments, 16), wu(n.tubularSegments, 32))), this.updateNormals = !0, this.setAttributes(t, !0);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                defaultParameters: {
                  configurable: !0
                }
              };
              return n.defaultParameters.get = function () {
                return nw;
              }, t.prototype.applyPositionTransform = function (e, t, n) {
                Jx.fromArray(this._majorAxis, n), ew.fromArray(this._minorAxis, n), e.lookAt(tw, Jx, ew);
                var r = this._radius[t];
                Qx.set(r, r, r), e.scale(Qx);
              }, t.prototype.setAttributes = function (t, n) {
                void 0 === t && (t = {}), t.radius && (this._radius = t.radius), t.majorAxis && (this._majorAxis = t.majorAxis), t.minorAxis && (this._minorAxis = t.minorAxis), e.prototype.setAttributes.call(this, t, n);
              }, Object.defineProperties(t.prototype, n), t;
            }(dy);
          ld.add("torus", rw);
          var iw = function iw(e, t) {
              var n = t || {};
              this.streamer = e, this.name = wu(n.name, ""), this.path = wu(n.path, "");
            },
            ow = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              },
              isJson: {
                configurable: !0
              },
              isXml: {
                configurable: !0
              }
            };
          ow.type.get = function () {
            return "";
          }, ow.__objName.get = function () {
            return "";
          }, ow.isBinary.get = function () {
            return !1;
          }, ow.isJson.get = function () {
            return !1;
          }, ow.isXml.get = function () {
            return !1;
          }, iw.prototype.parse = function () {
            var e = this;
            return this.streamer.read().then(function () {
              return e._beforeParse(), e._parse(), e._afterParse(), e[e.__objName];
            });
          }, iw.prototype._parse = function () {}, iw.prototype._beforeParse = function () {}, iw.prototype._afterParse = function () {
            t.Debug && Zc.log(this[this.__objName]);
          }, Object.defineProperties(iw.prototype, ow);
          var aw = function (e) {
              function t(t, n) {
                var r = n || {};
                e.call(this, t, r), this.firstModelOnly = wu(r.firstModelOnly, !1), this.asTrajectory = wu(r.asTrajectory, !1), this.cAlphaOnly = wu(r.cAlphaOnly, !1), this.structure = new ty(this.name, this.path), this.structureBuilder = new dv(this.structure);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                __objName: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "structure";
              }, n.__objName.get = function () {
                return "structure";
              }, Object.defineProperties(t.prototype, n), t;
            }(iw),
            sw = function sw(e, t, n, r, i) {
              void 0 === n && (n = ""), void 0 === i && (i = []), this.structure = e, this.index = t, this.description = n, this.entityType = function (e) {
                switch (e = e.toLowerCase()) {
                  case "polymer":
                    return 1;
                  case "non-polymer":
                    return 2;
                  case "macrolide":
                    return 3;
                  case "water":
                    return 4;
                  default:
                    return 0;
                }
              }(r || ""), (this.chainIndexList = i).forEach(function (n) {
                e.chainStore.entityIndex[n] = t;
              });
            },
            lw = {
              type: {
                configurable: !0
              }
            };
          lw.type.get = function () {
            return function (e) {
              switch (e) {
                case 1:
                  return "polymer";
                case 2:
                  return "non-polymer";
                case 3:
                  return "macrolide";
                case 4:
                  return "water";
                default:
                  return;
              }
            }(this.entityType);
          }, sw.prototype.getEntityType = function () {
            return this.entityType;
          }, sw.prototype.isPolymer = function () {
            return 1 === this.entityType;
          }, sw.prototype.isNonPolymer = function () {
            return 2 === this.entityType;
          }, sw.prototype.isMacrolide = function () {
            return 3 === this.entityType;
          }, sw.prototype.isWater = function () {
            return 4 === this.entityType;
          }, sw.prototype.eachChain = function (e) {
            var t = this.structure.getChainProxy();
            this.chainIndexList.forEach(function (n) {
              t.index = n, e(t);
            });
          }, Object.defineProperties(sw.prototype, lw);
          var uw = {
              a: 1,
              b: 1,
              c: 1,
              alpha: 90,
              beta: 90,
              gamma: 90,
              spacegroup: "P 1"
            },
            cw = function cw(e) {
              void 0 === e && (e = uw), this.cartToFrac = new ie(), this.fracToCart = new ie(), this.a = e.a, this.b = e.b, this.c = e.c, this.alpha = e.alpha, this.beta = e.beta, this.gamma = e.gamma, this.spacegroup = e.spacegroup;
              var t = qu(this.alpha),
                n = qu(this.beta),
                r = qu(this.gamma),
                i = Math.cos(t),
                o = Math.cos(n),
                a = Math.cos(r),
                s = Math.sin(n),
                l = Math.sin(r);
              if (this.volume = this.a * this.b * this.c * Math.sqrt(1 - i * i - o * o - a * a + 2 * i * o * a), void 0 === e.cartToFrac) {
                var u = this.a * this.b * l / this.volume,
                  c = (o * a - i) / (s * l);
                this.fracToCart.set(this.a, 0, 0, 0, this.b * a, this.b * l, 0, 0, this.c * o, -this.c * s * c, 1 / u, 0, 0, 0, 0, 1).transpose(), this.cartToFrac.getInverse(this.fracToCart);
              } else this.cartToFrac.copy(e.cartToFrac), this.fracToCart.getInverse(this.cartToFrac);
            };
          cw.prototype.getPosition = function (e) {
            var t = new Float32Array(24);
            if (e.unitcell) {
              var n = e.unitcell,
                r = e.center.clone().applyMatrix4(n.cartToFrac).floor(),
                i = new ae(),
                o = 0,
                a = function a(e, _a6, s) {
                  i.set(e, _a6, s).add(r).applyMatrix4(n.fracToCart).toArray(t, o), o += 3;
                };
              a(0, 0, 0), a(1, 0, 0), a(0, 1, 0), a(0, 0, 1), a(1, 1, 0), a(1, 0, 1), a(0, 1, 1), a(1, 1, 1);
            }
            return t;
          }, cw.prototype.getCenter = function (e) {
            return function (e, t) {
              void 0 === t && (t = new ae());
              for (var n = e.length, r = 0; r < n; r += 3) t.x += e[r], t.y += e[r + 1], t.z += e[r + 2];
              return t.divideScalar(n / 3), t;
            }(this.getPosition(e));
          }, cw.prototype.getData = function (e, t) {
            void 0 === t && (t = {});
            var n = wu(t.colorValue, "orange"),
              r = wu(t.radius, Math.cbrt(this.volume) / 200),
              i = new Fe(n),
              o = new ae(),
              a = this.getPosition(e),
              s = qd(8, i.r, i.g, i.b),
              l = Hd(8, r),
              u = new Float32Array(36),
              c = new Float32Array(36),
              d = qd(12, i.r, i.g, i.b),
              h = Hd(12, r),
              f = 0;
            function p(e, t) {
              o.fromArray(a, 3 * e).toArray(u, f), o.fromArray(a, 3 * t).toArray(c, f), f += 3;
            }
            p(0, 1), p(0, 2), p(0, 3), p(1, 4), p(1, 5), p(2, 6), p(3, 5), p(4, 7), p(5, 7), p(2, 4), p(7, 6), p(3, 6);
            var m = new wm(this, e);
            return {
              vertex: {
                position: a,
                color: s,
                radius: l,
                picking: m
              },
              edge: {
                position1: u,
                position2: c,
                color: d,
                color2: d,
                radius: h,
                picking: m
              }
            };
          };
          var dw = {
              1: "h",
              2: "h",
              3: "i",
              4: "h",
              5: "g",
              6: "h",
              7: "h",
              8: "h",
              9: "h",
              10: "h",
              0: "h"
            },
            hw = ["DAL", "DAR", "DSG", "DAS", "DCY", "DGL", "DGN", "DHI", "DIL", "DLE", "DLY", "MED", "DPN", "DPR", "DSN", "DTH", "DTR", "DTY", "DVA", "DNE"],
            fw = ["MOL_ID", "MOLECULE", "CHAIN", "FRAGMENT", "SYNONYM", "EC", "ENGINEERED", "MUTATION", "OTHER_DETAILS"],
            pw = /\s+/;
          function mw(e, t, n) {
            var r = "" + e;
            return t && (r += ":" + t), n && (r += "^" + n), r;
          }
          var gw = function (e) {
            function n(t, n) {
              var r = n || {};
              e.call(this, t, r), this.hex = wu(r.hex, !1);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "pdb";
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("PdbParser._parse " + this.name);
              var e = !1,
                n = this.streamer.peekLines(1)[0],
                r = n.substr(62, 4),
                i = n.substr(72, 4);
              r === i && i.trim() && (e = !0);
              var o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g,
                v,
                y,
                b,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M,
                C,
                k,
                P,
                O,
                R,
                I,
                j,
                N,
                L,
                D,
                B = "pqr" === this.type,
                F = "pdbqt" === this.type,
                z = this.structure,
                U = this.structureBuilder,
                G = this.hex,
                V = 10,
                H = 10,
                q = this.firstModelOnly,
                W = this.asTrajectory,
                $ = this.cAlphaOnly,
                X = z.frames,
                Y = z.boxes,
                K = !1,
                Z = z.biomolDict,
                Q = {},
                J = {},
                ee = {},
                te = [],
                ne = {},
                re = {},
                oe = {},
                ae = {},
                se = {
                  helices: [],
                  sheets: []
                },
                le = se.helices,
                ue = se.sheets,
                ce = z.atomMap,
                de = z.atomStore;
              de.resize(Math.round(this.streamer.data.length / 80)), (B || F) && de.addField("partialCharge", 1, "float32"), B && de.addField("radius", 1, "float32");
              var he = z.getAtomProxy(),
                fe = z.getAtomProxy(),
                pe = 0,
                me = 0,
                ge = !0;
              this.streamer.eachChunkOfLines(function (t) {
                !function (t, n, r) {
                  for (var i, se = 0; se < n; ++se) if (c = r[se], "ATOM  " === (d = c.substr(0, 6)) || "HETATM" === d) {
                    if (ge && (W ? (K ? (o = new Float32Array(3 * de.count), X.push(o)) : o = [], a = 0) : q || (Q = {}), O = (P = 1).toString(), ge = !(R = !0)), q && 0 < me) continue;
                    var ve = void 0,
                      ye = void 0,
                      be = void 0,
                      _e = void 0,
                      xe = void 0;
                    if (B) {
                      if (xe = 10 === (_e = c.split(pw)).length ? 1 : 0, y = _e[2], $ && "CA" !== y) continue;
                      ve = parseFloat(_e[6 - xe]), ye = parseFloat(_e[7 - xe]), be = parseFloat(_e[8 - xe]);
                    } else {
                      if (y = c.substr(12, 4).trim(), $ && "CA" !== y) continue;
                      ve = parseFloat(c.substr(30, 8)), ye = parseFloat(c.substr(38, 8)), be = parseFloat(c.substr(46, 8));
                    }
                    if (W) {
                      var we = 3 * a;
                      if (o[we + 0] = ve, o[we + 1] = ye, o[we + 2] = be, a += 1, K) continue;
                    }
                    var Se = void 0;
                    B ? (h = parseInt(_e[1]), Se = "", b = "H" === c[0] ? 1 : 0, f = xe ? "" : _e[4], p = parseInt(_e[5 - xe]), v = "", m = _e[3], x = "", g = 1) : (h = parseInt(c.substr(6, 5), V), G && 99999 === h && (V = 16), b = "H" === c[0] ? 1 : 0, f = c[21].trim(), p = parseInt(c.substr(22, 4), H), G && 9999 === p && (H = 16), v = c[26].trim(), m = c.substr(17, 4).trim() || "MOL", _ = parseFloat(c.substr(60, 6)), x = c[16].trim(), g = parseFloat(c.substr(54, 6)), e || (F ? Se = c.substr(12, 2).trim() : (Se = c.substr(76, 2).trim(), f || (f = c.substr(72, 4).trim())))), de.growIfFull(), de.atomTypeId[pe] = ce.add(y, Se), de.x[pe] = ve, de.y[pe] = ye, de.z[pe] = be, de.serial[pe] = h, de.altloc[pe] = x.charCodeAt(0), de.occupancy[pe] = isNaN(g) ? 0 : g, B ? (de.partialCharge[pe] = parseFloat(_e[9 - xe]), de.radius[pe] = parseFloat(_e[10 - xe])) : (de.bfactor[pe] = isNaN(_) ? 0 : _, F && (de.partialCharge[pe] = parseFloat(c.substr(70, 6))));
                    var Ae = mw(p, f, v);
                    !b || re[Ae] || hw.includes(m) ? R || I === f || (O = (P += 1).toString()) : I === f && N === m && (Mp.includes(m) || j === p && L === v) || (O = (P += 1).toString(), j = p, N = m, L = v), U.addAtom(me, f, O, m, p, b, void 0, v), Q[h] = pe, pe += 1, R = !1, I = f;
                  } else if ("CONECT" === d) {
                    var Ee = Q[parseInt(c.substr(6, 5))],
                      Te = [11, 16, 21, 26],
                      Me = {};
                    if (void 0 === Ee) continue;
                    for (var Ce = 0; Ce < 4; ++Ce) {
                      var ke = parseInt(c.substr(Te[Ce], 5));
                      if (!Number.isNaN(ke) && void 0 !== (ke = Q[ke])) if (Ee < ke ? (he.index = Ee, fe.index = ke) : (he.index = ke, fe.index = Ee), void 0 !== Me[ke]) z.bondStore.bondOrder[Me[ke]] += 1;else {
                        var Pe = he.index + "|" + fe.index;
                        void 0 === ee[Pe] && (ee[Pe] = !0, Me[ke] = z.bondStore.count, z.bondStore.addBond(he, fe, 1));
                      }
                    }
                  } else if ("HELIX " === d) {
                    w = c[19].trim(), S = parseInt(c.substr(21, 4)), A = c[25].trim(), E = c[31].trim(), T = parseInt(c.substr(33, 4)), M = c[37].trim();
                    var Oe = parseInt(c.substr(39, 1));
                    Oe = (dw[Oe] || dw[0]).charCodeAt(0), le.push([w, S, A, E, T, M, Oe]);
                  } else if ("SHEET " === d) w = c[21].trim(), S = parseInt(c.substr(22, 4)), A = c[26].trim(), E = c[32].trim(), T = parseInt(c.substr(33, 4)), M = c[37].trim(), ue.push([w, S, A, E, T, M]);else if ("HETNAM" === d) ne[c.substr(11, 3)] = c.substr(15).trim();else if ("SEQRES" === d) {
                    var Re = c[11].trim();
                    Re !== D && (ae[Re] = [], D = Re), (i = ae[Re]).push.apply(i, c.substr(19).trim().split(pw));
                  } else if ("MODRES" === d) {
                    var Ie = c.substr(12, 3).trim(),
                      je = c[16].trim(),
                      Ne = c[22].trim(),
                      Le = parseInt(c.substr(18, 4).trim()),
                      De = mw(Le, je, Ne);
                    re[De] = {
                      resname: Ie,
                      chainname: je,
                      inscode: Ne,
                      resno: Le
                    };
                  } else if ("COMPND" === d) {
                    var Be = c.substr(10, 70).trim(),
                      Fe = Be.indexOf(":"),
                      ze = Be.substring(0, Fe),
                      Ue = void 0;
                    fw.includes(ze) ? (k = ze, Ue = Be.substring(Fe + 2)) : Ue = Be, Ue = Ue.replace(/;$/, ""), "MOL_ID" === k ? (C = {
                      chainList: [],
                      name: ""
                    }, te.push(C)) : "MOLECULE" === k ? (C.name && (C.name += " "), C.name += Ue) : "CHAIN" === k && Array.prototype.push.apply(C.chainList, Ue.split(/\s*,\s*/));
                  } else if (c.startsWith("TER")) {
                    var Ge = z.getChainProxy(z.chainStore.count - 1);
                    oe[Ge.chainname] = Ge.index, O = (P += 1).toString(), R = !0;
                  } else if ("REMARK" === d && "350" === c.substr(7, 3)) {
                    if ("BIOMOLECULE:" === c.substr(11, 12)) {
                      var Ve = c.substr(23).trim();
                      /^(0|[1-9][0-9]*)$/.test(Ve) && (Ve = "BU" + Ve), s = new sv(Ve), Z[Ve] = s;
                    } else if ("BIOMT" === c.substr(13, 5)) {
                      var He = c.split(/\s+/),
                        qe = parseInt(c[18]) - 1;
                      0 === qe && (u = new ie(), l.matrixList.push(u));
                      var We = u.elements;
                      We[0 + qe] = parseFloat(He[4]), We[4 + qe] = parseFloat(He[5]), We[8 + qe] = parseFloat(He[6]), We[12 + qe] = parseFloat(He[7]);
                    } else if ("APPLY THE FOLLOWING TO CHAINS:" === c.substr(11, 30) || "                   AND CHAINS:" === c.substr(11, 30)) {
                      "APPLY" === c.substr(11, 5) && (l = s.addPart());
                      for (var $e = c.substr(41, 30).split(","), Xe = 0, Ye = $e.length; Xe < Ye; ++Xe) {
                        var Ke = $e[Xe].trim();
                        Ke && l.chainList.push(Ke);
                      }
                    }
                  } else if ("HEADER" === d) z.id = c.substr(62, 4);else if ("TITLE " === d) z.title += (z.title ? " " : "") + c.substr(10, 70).trim();else if ("MODEL " === d) ge = !0;else if ("ENDMDL" === d || "END" === c.trim()) {
                    if (ge) continue;
                    W && !K && (X.push(new Float32Array(o)), K = !0), me += 1, ge = !0;
                  } else if ("MTRIX" === c.substr(0, 5)) {
                    if ("1" === c[59]) continue;
                    s && "NCS" === s.name || (s = new sv("NCS"), Z.NCS = s, l = s.addPart());
                    var Ze = c.split(/\s+/),
                      Qe = parseInt(c[5]) - 1;
                    0 === Qe && (u = new ie(), l.matrixList.push(u));
                    var Je = u.elements;
                    Je[0 + Qe] = parseFloat(Ze[2]), Je[4 + Qe] = parseFloat(Ze[3]), Je[8 + Qe] = parseFloat(Ze[4]), Je[12 + Qe] = parseFloat(Ze[5]);
                  } else if ("ORIGX" === c.substr(0, 5)) {
                    J.origx || (J.origx = new ie());
                    var et = c.split(/\s+/),
                      tt = parseInt(c[5]) - 1,
                      nt = J.origx.elements;
                    nt[0 + tt] = parseFloat(et[1]), nt[4 + tt] = parseFloat(et[2]), nt[8 + tt] = parseFloat(et[3]), nt[12 + tt] = parseFloat(et[4]);
                  } else if ("SCALE" === c.substr(0, 5)) {
                    J.scale || (J.scale = new ie());
                    var rt = c.split(/\s+/),
                      it = parseInt(c[5]) - 1,
                      ot = J.scale.elements;
                    ot[0 + it] = parseFloat(rt[1]), ot[4 + it] = parseFloat(rt[2]), ot[8 + it] = parseFloat(rt[3]), ot[12 + it] = parseFloat(rt[4]);
                  } else if ("CRYST1" === d) {
                    var at = parseFloat(c.substr(6, 9)),
                      st = parseFloat(c.substr(15, 9)),
                      lt = parseFloat(c.substr(24, 9)),
                      ut = parseFloat(c.substr(33, 7)),
                      ct = parseFloat(c.substr(40, 7)),
                      dt = parseFloat(c.substr(47, 7)),
                      ht = c.substr(55, 11).trim(),
                      ft = new Float32Array(9);
                    ft[0] = at, ft[4] = st, ft[8] = lt, Y.push(ft), 0 === me && (J.a = at, J.b = st, J.c = lt, J.alpha = ut, J.beta = ct, J.gamma = dt, J.spacegroup = ht);
                  }
                }(0, t.length, t);
              }), U.finalize();
              var ve = te.length;
              if (ve) {
                z.eachChain(function (e) {
                  e.entityIndex = ve;
                }), te.forEach(function (e, t) {
                  var n = e.chainList.map(function (e) {
                    return oe[e];
                  });
                  z.entityList.push(new sw(z, t, e.name, "polymer", n));
                });
                var ye = te.length,
                  be = z.getResidueProxy(),
                  _e = {};
                z.eachChain(function (e) {
                  e.entityIndex === ve && (be.index = e.residueOffset, _e[be.resname] || (_e[be.resname] = []), _e[be.resname].push(e.index));
                }), Object.keys(_e).forEach(function (e) {
                  var t = _e[e],
                    n = "non-polymer",
                    r = ne[e] || e;
                  Mp.includes(e) && (n = r = "water"), z.entityList.push(new sw(z, ye, r, n, t)), ye += 1;
                });
              }
              void 0 !== J.a ? z.unitcell = new cw(J) : z.unitcell = void 0, (le.length || ue.length) && hv(z, se), z.finalizeAtoms(), e || vv(z), yv(z), z.finalizeBonds(), le.length || ue.length || pv(z), Sv(z), t.Debug && Zc.timeEnd("PdbParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(aw);
          id.add("pdb", gw), id.add("pdb1", gw), id.add("ent", gw);
          var vw = /\s+/,
            yw = /'((?:(?!'\s).)*)'|"((?:(?!"\s).)*)"|(\S+)/g,
            bw = /"/g,
            _w = /^['"]+|['"]+$/g;
          function xw(e) {
            return !e || e[0] !== e[e.length - 1] || "'" !== e[0] && '"' !== e[0] ? e : e.substring(1, e.length - 1);
          }
          function ww(e, t) {
            Array.isArray(e[t]) || Object.keys(e).forEach(function (t) {
              e[t] = [e[t]];
            });
          }
          function Sw(e) {
            return "?" !== e;
          }
          function Aw(e, t) {
            return Sw(e) ? e : t;
          }
          function Ew(e) {
            switch (e.toLowerCase()) {
              case "?":
              case "sing":
                return 1;
              case "doub":
                return 2;
              case "trip":
                return 3;
              case "quad":
                return 4;
            }
            return 0;
          }
          var Tw = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "cif";
            }, n.prototype._parse = function () {
              Zc.time("CifParser._parse " + this.name);
              var e,
                n,
                r,
                i,
                o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g,
                v,
                y,
                b,
                _,
                x,
                w = this.structure,
                S = this.structureBuilder,
                A = this.firstModelOnly,
                E = this.asTrajectory,
                T = this.cAlphaOnly,
                M = w.frames,
                C = {},
                k = {},
                P = {},
                O = !1,
                R = null,
                I = !1,
                j = !1,
                N = !1,
                L = [],
                D = null,
                B = null,
                F = null,
                z = null,
                U = [],
                G = w.atomMap,
                V = w.atomStore;
              V.resize(this.streamer.data.length / 100);
              var H,
                q = 0,
                W = 0;
              if (this.streamer.eachChunkOfLines(function ($) {
                !function ($, X, Y) {
                  for (var K = 0; K < X; ++K) if (r = Y[K], ((i = r.trim()) || O || j) && "#" !== i[0]) {
                    if ("data_" === i.substring(0, 5)) C.data = i.substring(5).trim();else if (";" === i[0]) O ? (j ? (D === L.length && (D = 0), L[D].push(R), D += 1) : !1 === F ? C[B] = R : C[B][F] = R, O = !1, R = null) : (O = !0, R = i.substring(1));else if ("loop_" === i) N = j = !0, L.length = 0, U.length = 0, D = 0;else if ("_" === i[0]) {
                      var Z, Q, J;
                      if (j && !N && (j = !1), j) Q = (Z = i.split("."))[0].substring(1), J = Z[1], 1 === Z.length ? (J = !1, C[Q] || (C[Q] = []), L.push(C[Q])) : (C[Q] || (C[Q] = {}), C[Q][J] ? t.Debug && Zc.warn(Q, J, "already exists") : (C[Q][J] = [], L.push(C[Q][J]), U.push(J))), B = Q, F = J, z = !0;else {
                        var ee = i.match(yw),
                          te = ee[0],
                          ne = ee[1];
                        Q = (Z = te.split("."))[0].substring(1), J = Z[1], 1 === Z.length ? (J = !1, C[Q] = ne) : (C[Q] || (C[Q] = {}), C[Q][J] ? t.Debug && Zc.warn(Q, J, "already exists") : C[Q][J] = ne), ne || (I = !0), B = Q, F = J;
                      }
                    } else if (O) R += r;else if (j) {
                      if (!i) continue;
                      if ("atom_site" === B) {
                        var re = i.split(vw);
                        z && (o = U.indexOf("auth_asym_id"), a = U.indexOf("auth_seq_id"), s = U.indexOf("label_atom_id"), l = U.indexOf("label_comp_id"), u = U.indexOf("label_asym_id"), c = U.indexOf("label_entity_id"), d = U.indexOf("label_alt_id"), v = U.indexOf("Cartn_x"), y = U.indexOf("Cartn_y"), b = U.indexOf("Cartn_z"), f = U.indexOf("id"), p = U.indexOf("type_symbol"), h = U.indexOf("group_PDB"), _ = U.indexOf("B_iso_or_equiv"), m = U.indexOf("pdbx_PDB_model_num"), g = U.indexOf("pdbx_PDB_ins_code"), x = U.indexOf("occupancy"), z = !1, H = parseInt(re[m]), E && (e = [], n = 0));
                        var ie = parseInt(re[m]);
                        if (H !== ie && (E && (0 === W && M.push(new Float32Array(e)), e = new Float32Array(3 * V.count), M.push(e), n = 0), W += 1), H = ie, A && 0 < W) continue;
                        var oe = re[s].replace(bw, "");
                        if (T && "CA" !== oe) continue;
                        var ae = parseFloat(re[v]),
                          se = parseFloat(re[y]),
                          le = parseFloat(re[b]);
                        if (E) {
                          var ue = 3 * n;
                          if (e[ue + 0] = ae, e[ue + 1] = se, e[ue + 2] = le, n += 1, 0 < W) continue;
                        }
                        var ce = re[l],
                          de = parseInt(re[a]),
                          he = re[g];
                        he = "?" === he ? "" : he;
                        var fe = re[o],
                          pe = re[u],
                          me = "H" === re[h][0] ? 1 : 0,
                          ge = re[p],
                          ve = parseFloat(re[_]),
                          ye = parseFloat(re[x]),
                          be = re[d];
                        if (be = "." === be ? "" : be, V.growIfFull(), V.atomTypeId[q] = G.add(oe, ge), V.x[q] = ae, V.y[q] = se, V.z[q] = le, V.serial[q] = parseInt(re[f]), V.bfactor[q] = isNaN(ve) ? 0 : ve, V.occupancy[q] = isNaN(ye) ? 0 : ye, V.altloc[q] = be.charCodeAt(0), S.addAtom(W, fe, pe, ce, de, me, void 0, he), t.Debug) {
                          var _e = k[pe];
                          void 0 !== _e && _e !== fe && t.Debug && Zc.warn(_e, fe);
                        }
                        k[pe] = fe;
                        var xe = re[c];
                        P[xe] || (P[xe] = new Set()), P[xe].add(w.chainStore.count - 1), q += 1;
                      } else {
                        var we = i.match(yw),
                          Se = we.length;
                        D === L.length && (D = 0);
                        for (var Ae = 0; Ae < Se; ++Ae) L[D + Ae].push(we[Ae]);
                        D += Se;
                      }
                      N = !1;
                    } else if ("'" === i[0] && "'" === i[i.length - 1]) {
                      var Ee = i.substring(1, i.length - 1);
                      !1 === F ? C[B] = Ee : C[B][F] = Ee;
                    } else I ? !1 === F ? C[B] = i : C[B][F] = i : t.Debug && Zc.log("CifParser._parse: unknown state", i);
                  } else I = j = O = !1, L.length = 0, z = F = B = D = null, U.length = 0;
                }(0, $.length, $);
              }), C.chem_comp && C.chem_comp_atom) !function (e, t, n) {
                var r,
                  i,
                  o = t.atomStore,
                  a = t.atomMap,
                  s = e.chem_comp,
                  l = e.chem_comp_atom,
                  u = e.chem_comp_bond;
                s && (s.name && (t.title = s.name.trim().replace(_w, "")), s.id && (t.id = s.id.trim().replace(_w, "")));
                var c = {};
                if (l) {
                  var d, h, f, p;
                  for (ww(l, "comp_id"), i = l.comp_id.length, r = 0; r < i; ++r) o.growIfFull(), d = l.atom_id[r].replace(bw, ""), h = l.type_symbol[r], c[d] = r, o.atomTypeId[r] = a.add(d, h), o.x[r] = l.model_Cartn_x[r], o.y[r] = l.model_Cartn_y[r], o.z[r] = l.model_Cartn_z[r], o.serial[r] = r, f = l.pdbx_component_comp_id[r], p = l.pdbx_residue_numbering ? l.pdbx_residue_numbering[r] : 1, n.addAtom(0, "", "", f, p, !0);
                  for (r = 0; r < i; ++r) {
                    var m = r + i;
                    o.growIfFull(), d = l.atom_id[r].replace(bw, ""), h = l.type_symbol[r], o.atomTypeId[m] = a.add(d, h), o.x[m] = l.pdbx_model_Cartn_x_ideal[r], o.y[m] = l.pdbx_model_Cartn_y_ideal[r], o.z[m] = l.pdbx_model_Cartn_z_ideal[r], o.serial[m] = m, f = l.pdbx_component_comp_id[r], p = l.pdbx_residue_numbering ? l.pdbx_residue_numbering[r] : 1, n.addAtom(1, "", "", f, p, !0);
                  }
                }
                if (l && u) {
                  var g, v, y;
                  ww(u, "comp_id"), i = u.comp_id.length;
                  var b = l.comp_id.length,
                    _ = t.getAtomProxy(),
                    x = t.getAtomProxy();
                  for (r = 0; r < i; ++r) g = u.atom_id_1[r].replace(bw, ""), v = u.atom_id_2[r].replace(bw, ""), y = Ew(u.value_order[r]), _.index = c[g], x.index = c[v], t.bondStore.growIfFull(), t.bondStore.addBond(_, x, y), _.index += b, x.index += b, t.bondStore.growIfFull(), t.bondStore.addBond(_, x, y);
                }
              }(C, w, S), S.finalize(), w.finalizeAtoms(), w.finalizeBonds(), Mv(w);else if (C.atom_site_type_symbol && C.atom_site_label && C.atom_site_fract_x) !function (e, t, n) {
                var r = t.atomStore,
                  i = t.atomMap;
                e.data && (t.id = e.data, t.name = e.data), t.unitcell = new cw({
                  a: parseFloat(e.cell_length_a),
                  b: parseFloat(e.cell_length_b),
                  c: parseFloat(e.cell_length_c),
                  alpha: parseFloat(e.cell_angle_alpha),
                  beta: parseFloat(e.cell_angle_beta),
                  gamma: parseFloat(e.cell_angle_gamma),
                  spacegroup: xw(e["symmetry_space_group_name_H-M"])
                });
                for (var o = new ae(), a = new ae(), s = e.atom_site_type_symbol.length, l = 0; l < s; ++l) {
                  r.growIfFull();
                  var u = e.atom_site_label[l],
                    c = e.atom_site_type_symbol[l];
                  r.atomTypeId[l] = i.add(u, c), o.set(e.atom_site_fract_x[l], e.atom_site_fract_y[l], e.atom_site_fract_z[l]), o.applyMatrix4(t.unitcell.fracToCart), a.add(o), r.x[l] = o.x, r.y[l] = o.y, r.z[l] = o.z, e.atom_site_occupancy && (r.occupancy[l] = parseFloat(e.atom_site_occupancy[l])), r.serial[l] = l, n.addAtom(0, "", "", "HET", 1, !0);
                }
                a.divideScalar(s), t.center = a, Sv(t);
                var d = new ae(),
                  h = new ae(),
                  f = t.biomolDict.SUPERCELL.partList[0].matrixList,
                  p = s;
                function m(e) {
                  return i.get(r.atomTypeId[e]).covalent;
                }
                for (var g = new ie(), v = function v(e) {
                    var t = m(e);
                    o.set(r.x[e], r.y[e], r.z[e]), f.forEach(function (i) {
                      if (!g.equals(i)) {
                        d.copy(o), d.applyMatrix4(i);
                        for (var a = 0; a < s; ++a) {
                          h.set(r.x[a], r.y[a], r.z[a]);
                          var l = d.distanceToSquared(h),
                            u = m(a) + t,
                            c = u + .3,
                            f = u - .5;
                          if (l < c * c && f * f < l) return r.growIfFull(), r.atomTypeId[p] = r.atomTypeId[e], r.x[p] = d.x, r.y[p] = d.y, r.z[p] = d.z, r.occupancy[p] = r.occupancy[e], r.serial[p] = p, r.altloc[p] = "A".charCodeAt(0), n.addAtom(0, "", "", "HET", 1, !0), void (p += 1);
                        }
                      }
                    });
                  }, y = 0; y < s; ++y) v(y);
              }(C, w, S), S.finalize(), w.finalizeAtoms(), yv(w), w.finalizeBonds();else {
                var $ = function (e, t, n) {
                  var r,
                    i,
                    o,
                    a,
                    s = [],
                    l = [],
                    u = e.struct_conf;
                  if (u) for (ww(u, "id"), r = 0, i = u.beg_auth_seq_id.length; r < i; ++r) {
                    var c = parseInt(u.pdbx_PDB_helix_class[r]);
                    Number.isNaN(c) || (o = u.pdbx_beg_PDB_ins_code[r], a = u.pdbx_end_PDB_ins_code[r], s.push([n[u.beg_label_asym_id[r]], parseInt(u.beg_auth_seq_id[r]), Aw(o, ""), n[u.end_label_asym_id[r]], parseInt(u.end_auth_seq_id[r]), Aw(a, ""), (dw[c] || dw[0]).charCodeAt(0)]));
                  }
                  var d = e.struct_sheet_range;
                  if (d) for (ww(d, "id"), r = 0, i = d.beg_auth_seq_id.length; r < i; ++r) o = d.pdbx_beg_PDB_ins_code[r], a = d.pdbx_end_PDB_ins_code[r], l.push([n[d.beg_label_asym_id[r]], parseInt(d.beg_auth_seq_id[r]), Aw(o, ""), n[d.end_label_asym_id[r]], parseInt(d.end_auth_seq_id[r]), Aw(a, "")]);
                  return !(!u && !d) && {
                    helices: s,
                    sheets: l
                  };
                }(C, 0, k);
                if (function (e, t, n) {
                  var r = {},
                    i = t.biomolDict;
                  if (e.pdbx_struct_oper_list) {
                    var o = e.pdbx_struct_oper_list;
                    ww(o, "id"), o.id.forEach(function (e, t) {
                      var n = new ie(),
                        i = n.elements;
                      i[0] = parseFloat(o["matrix[1][1]"][t]), i[1] = parseFloat(o["matrix[1][2]"][t]), i[2] = parseFloat(o["matrix[1][3]"][t]), i[4] = parseFloat(o["matrix[2][1]"][t]), i[5] = parseFloat(o["matrix[2][2]"][t]), i[6] = parseFloat(o["matrix[2][3]"][t]), i[8] = parseFloat(o["matrix[3][1]"][t]), i[9] = parseFloat(o["matrix[3][2]"][t]), i[10] = parseFloat(o["matrix[3][3]"][t]), i[3] = parseFloat(o["vector[1]"][t]), i[7] = parseFloat(o["vector[2]"][t]), i[11] = parseFloat(o["vector[3]"][t]), n.transpose(), r[e] = n;
                    });
                  }
                  if (e.pdbx_struct_assembly_gen) {
                    var a = e.pdbx_struct_assembly_gen;
                    ww(a, "assembly_id");
                    var s = function s(e) {
                      var t = {};
                      return e.replace(/[()']/g, "").split(",").forEach(function (e) {
                        if (e.includes("-")) for (var n = e.split("-"), i = parseInt(n[0]), o = parseInt(n[1]); i <= o; ++i) t[i] = r[i];else t[e] = r[e];
                      }), t;
                    };
                    a.assembly_id.forEach(function (e, t) {
                      var r = {},
                        o = a.oper_expression[t].replace(/['"]\(|['"]/g, "");
                      if (o.includes(")(") || 0 < o.indexOf("(")) {
                        o = o.split("(");
                        var l = s(o[0]),
                          u = s(o[1]);
                        Object.keys(l).forEach(function (e) {
                          Object.keys(u).forEach(function (t) {
                            var n = new ie();
                            n.multiplyMatrices(l[e], u[t]), r[e + "x" + t] = n;
                          });
                        });
                      } else r = s(o);
                      var c = [];
                      for (var d in r) c.push(r[d]);
                      var h = e;
                      /^(0|[1-9][0-9]*)$/.test(h) && (h = "BU" + h);
                      for (var f = a.asym_id_list[t].split(","), p = 0, m = f.length; p < m; ++p) f[p] = n[f[p]];
                      void 0 === i[h] && (i[h] = new sv(h)), i[h].addPart(c, f);
                    });
                  }
                  if (e.struct_ncs_oper) {
                    var l = e.struct_ncs_oper;
                    ww(l, "id"), i.NCS = new sv("NCS");
                    var u = i.NCS.addPart();
                    l.id.forEach(function (e, t) {
                      if ("given" !== l.code[t]) {
                        var n = new ie(),
                          r = n.elements;
                        r[0] = parseFloat(l["matrix[1][1]"][t]), r[1] = parseFloat(l["matrix[1][2]"][t]), r[2] = parseFloat(l["matrix[1][3]"][t]), r[4] = parseFloat(l["matrix[2][1]"][t]), r[5] = parseFloat(l["matrix[2][2]"][t]), r[6] = parseFloat(l["matrix[2][3]"][t]), r[8] = parseFloat(l["matrix[3][1]"][t]), r[9] = parseFloat(l["matrix[3][2]"][t]), r[10] = parseFloat(l["matrix[3][3]"][t]), r[3] = parseFloat(l["vector[1]"][t]), r[7] = parseFloat(l["vector[2]"][t]), r[11] = parseFloat(l["vector[3]"][t]), n.transpose(), u.matrixList.push(n);
                      }
                    }), 0 === u.matrixList.length && delete i.NCS;
                  }
                  var c = {};
                  if (e.cell) {
                    var d = e.cell,
                      h = parseFloat(d.length_a),
                      f = parseFloat(d.length_b),
                      p = parseFloat(d.length_c),
                      m = new Float32Array(9);
                    m[0] = h, m[4] = f, m[8] = p, t.boxes.push(m), c.a = h, c.b = f, c.c = p, c.alpha = parseFloat(d.angle_alpha), c.beta = parseFloat(d.angle_beta), c.gamma = parseFloat(d.angle_gamma);
                  }
                  e.symmetry && (c.spacegroup = xw(e.symmetry["space_group_name_H-M"]));
                  var g = new ie();
                  if (e.database_PDB_matrix) {
                    var v = e.database_PDB_matrix,
                      y = g.elements;
                    y[0] = parseFloat(v["origx[1][1]"]), y[1] = parseFloat(v["origx[1][2]"]), y[2] = parseFloat(v["origx[1][3]"]), y[4] = parseFloat(v["origx[2][1]"]), y[5] = parseFloat(v["origx[2][2]"]), y[6] = parseFloat(v["origx[2][3]"]), y[8] = parseFloat(v["origx[3][1]"]), y[9] = parseFloat(v["origx[3][2]"]), y[10] = parseFloat(v["origx[3][3]"]), y[3] = parseFloat(v["origx_vector[1]"]), y[7] = parseFloat(v["origx_vector[2]"]), y[11] = parseFloat(v["origx_vector[3]"]), g.transpose(), c.origx = g;
                  }
                  var b = new ie();
                  if (e.atom_sites) {
                    var _ = e.atom_sites,
                      x = b.elements;
                    x[0] = parseFloat(_["fract_transf_matrix[1][1]"]), x[1] = parseFloat(_["fract_transf_matrix[1][2]"]), x[2] = parseFloat(_["fract_transf_matrix[1][3]"]), x[4] = parseFloat(_["fract_transf_matrix[2][1]"]), x[5] = parseFloat(_["fract_transf_matrix[2][2]"]), x[6] = parseFloat(_["fract_transf_matrix[2][3]"]), x[8] = parseFloat(_["fract_transf_matrix[3][1]"]), x[9] = parseFloat(_["fract_transf_matrix[3][2]"]), x[10] = parseFloat(_["fract_transf_matrix[3][3]"]), x[3] = parseFloat(_["fract_transf_vector[1]"]), x[7] = parseFloat(_["fract_transf_vector[2]"]), x[11] = parseFloat(_["fract_transf_vector[3]"]), b.transpose(), c.scale = b;
                  }
                  void 0 !== c.a ? t.unitcell = new cw(c) : t.unitcell = void 0;
                }(C, w, k), function (e, n, r) {
                  var i = e.struct_conn;
                  if (i) {
                    ww(i, "id");
                    for (var o = /"/g, a = n.getAtomProxy(), s = n.getAtomProxy(), l = {}, u = 0, c = i.id.length; u < c; ++u) {
                      var d = i.conn_type_id[u];
                      if ("hydrog" !== d && "mismat" !== d && "saltbr" !== d && "1_555" === i.ptnr1_symmetry[u] && "1_555" === i.ptnr2_symmetry[u]) {
                        var h = i.pdbx_ptnr1_PDB_ins_code[u],
                          f = i.pdbx_ptnr1_label_alt_id[u],
                          p = i.ptnr1_auth_seq_id[u] + (Sw(h) ? "^" + h : "") + ":" + r[i.ptnr1_label_asym_id[u]] + "." + i.ptnr1_label_atom_id[u].replace(o, "") + (Sw(f) ? "%" + f : ""),
                          m = l[p];
                        if (!m) {
                          var g = new Nc(p);
                          if (g.selection.error) {
                            t.Debug && Zc.warn("invalid selection for connection", p);
                            continue;
                          }
                          m = n.getAtomIndices(g), l[p] = m;
                        }
                        var v = i.pdbx_ptnr2_PDB_ins_code[u],
                          y = i.pdbx_ptnr2_label_alt_id[u],
                          b = i.ptnr2_auth_seq_id[u] + (Sw(v) ? "^" + v : "") + ":" + r[i.ptnr2_label_asym_id[u]] + "." + i.ptnr2_label_atom_id[u].replace(o, "") + (Sw(y) ? "%" + y : ""),
                          _ = l[b];
                        if (!_) {
                          var x = new Nc(b);
                          if (x.selection.error) {
                            t.Debug && Zc.warn("invalid selection for connection", b);
                            continue;
                          }
                          _ = n.getAtomIndices(x), l[b] = _;
                        }
                        var w = m.length,
                          S = _.length;
                        if (S < w) {
                          var A = w;
                          w = S, S = A;
                          var E = m;
                          m = _, _ = E;
                        }
                        if (0 !== w && 0 !== S) for (var T = 0; T < S; ++T) a.index = m[T % w], s.index = _[T], a && s ? n.bondStore.addBond(a, s, Ew(i.pdbx_value_order[u])) : Zc.log("atoms for connection not found");else t.Debug && Zc.warn("no atoms found for", p, b);
                      }
                    }
                  }
                }(C, w, k), function (e, t, n) {
                  if (e.entity) {
                    ww(e.entity, "id");
                    for (var r = e.entity, i = r.id.length, o = 0; o < i; ++o) {
                      var a = r.pdbx_description[o],
                        s = r.type[o],
                        l = Array.from(n[r.id[o]]);
                      t.entityList[o] = new sw(t, o, a, s, l);
                    }
                  }
                }(C, w, P), C.struct && C.struct.title && (w.title = C.struct.title.trim().replace(_w, "")), C.entry && C.entry.id && (w.id = C.entry.id.trim().replace(_w, "")), C.pdbx_audit_revision_history) {
                  if (C.pdbx_audit_revision_history.revision_date) {
                    ww(C.pdbx_audit_revision_history, "revision_date");
                    var X = C.pdbx_audit_revision_history.revision_date.filter(Sw);
                    X.length && (w.header.releaseDate = X[0]);
                  }
                  if (C.pdbx_database_status.recvd_initial_deposition_date) {
                    ww(C.pdbx_database_status, "recvd_initial_deposition_date");
                    var Y = C.pdbx_database_status.recvd_initial_deposition_date.filter(Sw);
                    Y.length && (w.header.depositionDate = Y[0]);
                  }
                } else if (C.database_PDB_rev) {
                  if (C.database_PDB_rev.date) {
                    ww(C.database_PDB_rev, "date");
                    var K = C.database_PDB_rev.date.filter(Sw);
                    K.length && (w.header.releaseDate = K[0]);
                  }
                  if (C.database_PDB_rev.date_original) {
                    ww(C.database_PDB_rev, "date_original");
                    var Z = C.database_PDB_rev.date_original.filter(Sw);
                    Z.length && (w.header.depositionDate = Z[0]);
                  }
                }
                C.reflns && C.reflns.d_resolution_high ? Sw(C.reflns.d_resolution_high) && (w.header.resolution = parseFloat(C.reflns.d_resolution_high)) : C.refine && C.refine.ls_d_res_high && Sw(C.refine.ls_d_res_high) && (w.header.resolution = parseFloat(C.refine.ls_d_res_high)), C.refine && C.refine.ls_R_factor_R_free && Sw(C.refine.ls_R_factor_R_free) && (w.header.rFree = parseFloat(C.refine.ls_R_factor_R_free)), C.refine && C.refine.ls_R_factor_R_work && Sw(C.refine.ls_R_factor_R_work) && (w.header.rWork = parseFloat(C.refine.ls_R_factor_R_work)), C.exptl && C.exptl.method && (ww(C.exptl, "method"), w.header.experimentalMethods = C.exptl.method.map(function (e) {
                  return e.replace(_w, "");
                })), S.finalize(), w.finalizeAtoms(), yv(w), w.finalizeBonds(), $ ? hv(w, $) : pv(w), Sv(w), w.extraData.cif = C;
              }
              t.Debug && Zc.timeEnd("CifParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(aw);
          id.add("cif", Tw), id.add("mcif", Tw), id.add("mmcif", Tw);
          var Mw = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "gro";
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("GroParser._parse " + this.name);
              var e,
                n,
                r = this.structure,
                i = this.structureBuilder,
                o = this.firstModelOnly,
                a = this.asTrajectory,
                s = this.cAlphaOnly,
                l = r.frames,
                u = r.boxes,
                c = this.streamer.peekLines(3);
              r.title = c[0].trim();
              var d,
                h,
                f,
                p,
                m = c[2].length - c[2].lastIndexOf(".") - 1 + 5,
                g = 20 + m,
                v = 20 + 2 * m,
                y = parseInt(c[1]),
                b = y + 3,
                _ = r.atomMap,
                x = r.atomStore;
              x.resize(y);
              var w = 0,
                S = 0,
                A = 0;
              this.streamer.eachChunkOfLines(function (t) {
                !function (t, r, c) {
                  for (var E = 0; E < r; ++E) {
                    var T = ++A - 1,
                      M = c[E];
                    if (M) if (T % b == 0) a && (e = new Float32Array(3 * y), l.push(e), n = 0);else if (T % b == 1) ;else if (T % b == b - 1) {
                      var C = M.trim().split(/\s+/),
                        k = new Float32Array(9);
                      if (k[0] = 10 * parseFloat(C[0]), k[4] = 10 * parseFloat(C[1]), k[8] = 10 * parseFloat(C[2]), u.push(k), o) return;
                      S += 1;
                    } else {
                      if (d = M.substr(10, 5).trim(), s && "CA" !== d) continue;
                      var P = 10 * parseFloat(M.substr(20, m)),
                        O = 10 * parseFloat(M.substr(g, m)),
                        R = 10 * parseFloat(M.substr(v, m));
                      if (a) {
                        var I = 3 * n;
                        if (e[I + 0] = P, e[I + 1] = O, e[I + 2] = R, n += 1, b < T) continue;
                      }
                      h = M.substr(5, 5).trim(), f = parseInt(M.substr(0, 5)), p = parseInt(M.substr(15, 5)), x.growIfFull(), x.atomTypeId[w] = _.add(d), x.x[w] = P, x.y[w] = O, x.z[w] = R, x.serial[w] = p, i.addAtom(S, "", "", h, f, 0, "l"), w += 1;
                    }
                  }
                }(0, t.length, t);
              }), i.finalize(), r.finalizeAtoms(), vv(r), yv(r), r.finalizeBonds(), pv(r), t.Debug && Zc.timeEnd("GroParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(aw);
          id.add("gro", Mw);
          var Cw = ["mmtfVersion", "mmtfProducer", "unitCell", "spaceGroup", "structureId", "title", "depositionDate", "releaseDate", "experimentalMethods", "resolution", "rFree", "rWork", "bioAssemblyList", "ncsOperatorList", "entityList", "groupList", "numBonds", "numAtoms", "numGroups", "numChains", "numModels", "groupsPerChain", "chainsPerModel"].concat(["xCoordList", "yCoordList", "zCoordList", "groupIdList", "groupTypeList", "chainIdList", "bFactorList", "atomIdList", "altLocList", "occupancyList", "secStructList", "insCodeList", "sequenceIndexList", "chainNameList", "bondAtomList", "bondOrderList"]);
          function kw(e, t, n) {
            return t ? new e(t.buffer, t.byteOffset, t.byteLength / (n || 1)) : void 0;
          }
          function Pw(e) {
            return kw(DataView, e);
          }
          function Ow(e) {
            return kw(Int8Array, e);
          }
          function Rw(e) {
            return kw(Int32Array, e, 4);
          }
          function Iw(e, t) {
            var n = e.length / 2;
            t || (t = new Int16Array(n));
            for (var r = 0, i = 0; r < n; ++r, i += 2) t[r] = e[i] << 8 ^ e[i + 1] << 0;
            return t;
          }
          function jw(e, t) {
            var n = e.length / 4;
            t || (t = new Int32Array(n));
            for (var r = 0, i = 0; r < n; ++r, i += 4) t[r] = e[i] << 24 ^ e[i + 1] << 16 ^ e[i + 2] << 8 ^ e[i + 3] << 0;
            return t;
          }
          function Nw(e, t, n) {
            var r = e.length,
              i = 1 / t;
            n || (n = new Float32Array(r));
            for (var o = 0; o < r; ++o) n[o] = e[o] * i;
            return n;
          }
          function Lw(e, t) {
            var n, r;
            if (!t) {
              var i = 0;
              for (n = 0, r = e.length; n < r; n += 2) i += e[n + 1];
              t = new e.constructor(i);
            }
            var o = 0;
            for (n = 0, r = e.length; n < r; n += 2) for (var a = e[n], s = e[n + 1], l = 0; l < s; ++l) t[o] = a, ++o;
            return t;
          }
          function Dw(e, t) {
            var n = e.length;
            t || (t = new e.constructor(n)), n && (t[0] = e[0]);
            for (var r = 1; r < n; ++r) t[r] = e[r] + t[r - 1];
            return t;
          }
          function Bw(e, t) {
            var n,
              r,
              i = e instanceof Int8Array ? 127 : 32767,
              o = -i - 1,
              a = e.length;
            if (!t) {
              var s = 0;
              for (n = 0; n < a; ++n) e[n] < i && e[n] > o && ++s;
              t = new Int32Array(s);
            }
            for (r = n = 0; n < a;) {
              for (var l = 0; e[n] === i || e[n] === o;) l += e[n], ++n;
              l += e[n], ++n, t[r] = l, ++r;
            }
            return t;
          }
          function Fw(e, t, n) {
            return Nw(Bw(e, Rw(n)), t, n);
          }
          function zw(e) {
            var t = 0,
              n = new DataView(e.buffer);
            function r(e) {
              for (var t = {}, n = 0; n < e; n++) t[s()] = s();
              return t;
            }
            function i(n) {
              var r = e.subarray(t, t + n);
              return t += n, r;
            }
            function o(n) {
              var r = e.subarray(t, t + n);
              if (t += n, 65535 < n) {
                for (var i = [], o = 0; o < r.length; o += 65535) i.push(String.fromCharCode.apply(null, r.subarray(o, o + 65535)));
                return i.join("");
              }
              return String.fromCharCode.apply(null, r);
            }
            function a(e) {
              for (var t = new Array(e), n = 0; n < e; n++) t[n] = s();
              return t;
            }
            function s() {
              var s,
                l,
                u = e[t];
              if (0 == (128 & u)) return t++, u;
              if (128 == (240 & u)) return t++, r(l = 15 & u);
              if (144 == (240 & u)) return t++, a(l = 15 & u);
              if (160 == (224 & u)) return t++, o(l = 31 & u);
              if (224 == (224 & u)) return s = n.getInt8(t), t++, s;
              switch (u) {
                case 192:
                  return t++, null;
                case 194:
                  return t++, !1;
                case 195:
                  return t++, !0;
                case 196:
                  return l = n.getUint8(t + 1), t += 2, i(l);
                case 197:
                  return l = n.getUint16(t + 1), t += 3, i(l);
                case 198:
                  return l = n.getUint32(t + 1), t += 5, i(l);
                case 202:
                  return s = n.getFloat32(t + 1), t += 5, s;
                case 203:
                  return s = n.getFloat64(t + 1), t += 9, s;
                case 204:
                  return s = e[t + 1], t += 2, s;
                case 205:
                  return s = n.getUint16(t + 1), t += 3, s;
                case 206:
                  return s = n.getUint32(t + 1), t += 5, s;
                case 208:
                  return s = n.getInt8(t + 1), t += 2, s;
                case 209:
                  return s = n.getInt16(t + 1), t += 3, s;
                case 210:
                  return s = n.getInt32(t + 1), t += 5, s;
                case 217:
                  return l = n.getUint8(t + 1), t += 2, o(l);
                case 218:
                  return l = n.getUint16(t + 1), t += 3, o(l);
                case 219:
                  return l = n.getUint32(t + 1), t += 5, o(l);
                case 220:
                  return l = n.getUint16(t + 1), t += 3, a(l);
                case 221:
                  return l = n.getUint32(t + 1), t += 5, a(l);
                case 222:
                  return l = n.getUint16(t + 1), t += 3, r(l);
                case 223:
                  return l = n.getUint32(t + 1), t += 5, r(l);
              }
              throw new Error("Unknown type 0x" + u.toString(16));
            }
            return s();
          }
          function Uw(e, t, n, r) {
            switch (e) {
              case 1:
                return function (e, t) {
                  var n = e.length;
                  t || (t = new Float32Array(n / 4));
                  for (var r = Pw(t), i = Pw(e), o = 0, a = 0, s = n / 4; o < s; ++o, a += 4) r.setFloat32(a, i.getFloat32(a), !0);
                  return t;
                }(t);
              case 2:
                return Ow(t);
              case 3:
                return Iw(t);
              case 4:
                return jw(t);
              case 5:
                return kw(Uint8Array, t);
              case 6:
                return Lw(jw(t), new Uint8Array(n));
              case 7:
                return Lw(jw(t));
              case 8:
                return Dw(Lw(jw(t)), void 0);
              case 9:
                return i = jw(t), o = jw(r)[0], Nw(Lw(i, Rw(a)), o, a);
              case 10:
                return function (e, t, n) {
                  var r,
                    i,
                    o,
                    a = Bw(e, Rw(n));
                  return i = t, o = kw(Float32Array, r = a, 4), Nw(Dw(r, Rw(o)), i, o);
                }(Iw(t), jw(r)[0]);
              case 11:
                return Nw(Iw(t), jw(r)[0]);
              case 12:
                return Fw(Iw(t), jw(r)[0]);
              case 13:
                return Fw(Ow(t), jw(r)[0]);
              case 14:
                return Bw(Iw(t));
              case 15:
                return Bw(Ow(t));
            }
            var i, o, a;
          }
          var Gw = {
              0: "i".charCodeAt(0),
              1: "s".charCodeAt(0),
              2: "h".charCodeAt(0),
              3: "e".charCodeAt(0),
              4: "g".charCodeAt(0),
              5: "b".charCodeAt(0),
              6: "t".charCodeAt(0),
              7: "l".charCodeAt(0),
              "-1": "".charCodeAt(0)
            },
            Vw = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                },
                isBinary: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "mmtf";
              }, r.isBinary.get = function () {
                return !0;
              }, n.prototype._parse = function () {
                var e, n, r, i, o;
                t.Debug && Zc.time("MmtfParser._parse " + this.name);
                var a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h = this.structure,
                  f = function (e, t) {
                    var n = (t = t || {}).ignoreFields,
                      r = {};
                    return Cw.forEach(function (t) {
                      var i,
                        o,
                        a,
                        s,
                        l,
                        u = !!n && -1 !== n.indexOf(t),
                        c = e[t];
                      u || void 0 === c || (c instanceof Uint8Array ? r[t] = Uw.apply(null, (a = (o = Pw(i = c)).getInt32(0), s = o.getInt32(4), l = i.subarray(8, 12), [a, i = i.subarray(12), s, l])) : r[t] = c);
                    }), r;
                  }(zw(this.streamer.data));
                if (["depositionDate", "releaseDate", "resolution", "rFree", "rWork", "experimentalMethods"].forEach(function (e) {
                  void 0 !== f[e] && (h.header[e] = f[e]);
                }), h.id = f.structureId, h.title = f.title, h.atomStore.addField("formalCharge", 1, "int8"), this.firstModelOnly || this.asTrajectory) {
                  for (c = 1, e = l = 0, n = u = f.chainsPerModel[0]; e < n; ++e) l += f.groupsPerChain[e];
                  for (e = s = 0, n = l; e < n; ++e) s += (o = f.groupList[f.groupTypeList[e]]).atomNameList.length;
                  a = f.numBonds, d = [u];
                } else a = f.numBonds, s = f.numAtoms, l = f.numGroups, u = f.numChains, c = f.numModels, d = f.chainsPerModel;
                if (a += l, this.asTrajectory) for (e = 0, n = f.numModels; e < n; ++e) {
                  var p = new Float32Array(3 * s),
                    m = s * e;
                  for (r = 0; r < s; ++r) {
                    var g = 3 * r,
                      v = r + m;
                    p[g] = f.xCoordList[v], p[g + 1] = f.yCoordList[v], p[g + 2] = f.zCoordList[v];
                  }
                  h.frames.push(p);
                }
                var y = new Uint32Array(a),
                  b = new Uint32Array(a),
                  _ = new Uint8Array(a),
                  x = new Uint32Array(s),
                  w = new Int8Array(s),
                  S = new Uint32Array(l),
                  A = new Uint32Array(l),
                  E = new Uint16Array(l),
                  T = new Uint16Array(u),
                  M = new Uint32Array(u),
                  C = new Uint32Array(u),
                  k = new Uint32Array(c),
                  P = new Uint32Array(c),
                  O = 0;
                for (e = 0, n = c; e < n; ++e) {
                  var R = d[e];
                  for (k[e] = O, P[e] = R, r = 0; r < R; ++r) T[r + O] = e;
                  O += R;
                }
                var I = f.groupsPerChain,
                  j = 0;
                for (e = 0, n = u; e < n; ++e) {
                  var N = I[e];
                  for (M[e] = j, C[e] = N, r = 0; r < N; ++r) S[r + j] = e;
                  j += N;
                }
                var L = 0,
                  D = 0;
                for (e = 0, n = l; e < n; ++e) {
                  var B = (o = f.groupList[f.groupTypeList[e]]).atomNameList.length,
                    F = o.formalChargeList,
                    z = o.bondAtomList,
                    U = o.bondOrderList;
                  for (r = 0, i = U.length; r < i; ++r) y[D] = L + z[2 * r], b[D] = L + z[2 * r + 1], _[D] = U[r], D += 1;
                  for (A[e] = L, E[e] = B, r = 0; r < B; ++r) x[L] = e, w[L] = F[r], L += 1;
                }
                var G = f.bondAtomList;
                if (G) for (f.bondOrderList && _.set(f.bondOrderList, D), e = 0, n = G.length; e < n; e += 2) {
                  var V = G[e],
                    H = G[e + 1];
                  V < s && H < s && (y[D] = V, b[D] = H, D += 1);
                }
                h.bondStore.length = _.length, h.bondStore.count = D, h.bondStore.atomIndex1 = y, h.bondStore.atomIndex2 = b, h.bondStore.bondOrder = _, h.atomStore.length = s, h.atomStore.count = s, h.atomStore.residueIndex = x, h.atomStore.atomTypeId = new Uint16Array(s), h.atomStore.x = f.xCoordList.subarray(0, s), h.atomStore.y = f.yCoordList.subarray(0, s), h.atomStore.z = f.zCoordList.subarray(0, s), h.atomStore.serial = f.atomIdList.subarray(0, s), h.atomStore.bfactor = f.bFactorList.subarray(0, s), h.atomStore.altloc = f.altLocList.subarray(0, s), h.atomStore.occupancy = f.occupancyList.subarray(0, s), h.atomStore.formalCharge = w, h.residueStore.length = l, h.residueStore.count = l, h.residueStore.chainIndex = S, h.residueStore.residueTypeId = f.groupTypeList, h.residueStore.atomOffset = A, h.residueStore.atomCount = E, h.residueStore.resno = f.groupIdList.subarray(0, l), h.residueStore.sstruc = f.secStructList.subarray(0, l), h.residueStore.inscode = f.insCodeList.subarray(0, l), h.chainStore.length = u, h.chainStore.count = u, h.chainStore.entityIndex = new Uint16Array(u), h.chainStore.modelIndex = T, h.chainStore.residueOffset = M, h.chainStore.residueCount = C, h.chainStore.chainname = f.chainNameList.subarray(0, 4 * u), h.chainStore.chainid = f.chainIdList.subarray(0, 4 * u), h.modelStore.length = c, h.modelStore.count = c, h.modelStore.chainOffset = k, h.modelStore.chainCount = P;
                var q = {};
                for (e = 0, n = f.groupList.length; e < n; ++e) {
                  var W = f.groupList[e],
                    $ = [];
                  for (r = 0, i = W.atomNameList.length; r < i; ++r) {
                    var X = W.elementList[r].toUpperCase(),
                      Y = W.atomNameList[r];
                    $.push(h.atomMap.add(Y, X));
                  }
                  var K = W.chemCompType.toUpperCase(),
                    Z = cp.includes(K),
                    Q = W.bondOrderList.length,
                    J = new Array(Q),
                    ee = new Array(Q);
                  for (r = 0; r < Q; ++r) J[r] = W.bondAtomList[2 * r], ee[r] = W.bondAtomList[2 * r + 1];
                  var te = {
                    atomIndices1: J,
                    atomIndices2: ee,
                    bondOrders: W.bondOrderList
                  };
                  q[e] = h.residueMap.add(W.groupName, $, Z, K, te);
                }
                for (e = 0, n = l; e < n; ++e) h.residueStore.residueTypeId[e] = q[h.residueStore.residueTypeId[e]];
                for (e = 0, n = h.atomStore.count; e < n; ++e) {
                  var ne = h.atomStore.residueIndex[e],
                    re = h.residueMap.list[h.residueStore.residueTypeId[ne]],
                    oe = h.residueStore.atomOffset[ne];
                  h.atomStore.atomTypeId[e] = re.atomTypeIdList[e - oe];
                }
                if (f.secStructList) {
                  var ae = f.secStructList.length;
                  for (e = 0, n = h.residueStore.count; e < n; ++e) {
                    var se = Gw[h.residueStore.sstruc[e % ae]];
                    void 0 !== se && (h.residueStore.sstruc[e] = se);
                  }
                }
                if (f.entityList && f.entityList.forEach(function (e, t) {
                  h.entityList[t] = new sw(h, t, e.description, e.type, e.chainIndexList);
                }), f.bioAssemblyList && f.bioAssemblyList.forEach(function (e, t) {
                  var n = t + 1,
                    r = new sv("" + n);
                  h.biomolDict["BU" + n] = r;
                  var i = {};
                  e.transformList.forEach(function (e) {
                    var t = new ie().fromArray(e.matrix).transpose(),
                      n = e.chainIndexList.map(function (e) {
                        for (var t = "", n = 0; n < 4; ++n) {
                          var r = f.chainNameList[4 * e + n];
                          if (!r) break;
                          t += String.fromCharCode(r);
                        }
                        return t;
                      }),
                      o = i[n.toString()];
                    o ? o.matrixList.push(t) : i[n.toString()] = r.addPart([t], n);
                  });
                }), f.ncsOperatorList) {
                  var le = new sv("NCS"),
                    ue = le.addPart();
                  f.ncsOperatorList.forEach(function (e) {
                    var t = new ie().fromArray(e).transpose();
                    ue.matrixList.push(t);
                  }), 0 < ue.matrixList.length && (h.biomolDict.NCS = le);
                }
                var ce = f.unitCell;
                ce && Array.isArray(ce) && ce[0] ? h.unitcell = new cw({
                  a: ce[0],
                  b: ce[1],
                  c: ce[2],
                  alpha: ce[3],
                  beta: ce[4],
                  gamma: ce[5],
                  spacegroup: f.spaceGroup
                }) : h.unitcell = void 0, wv(h, !0), xv(h, !0), h.finalizeAtoms(), h.finalizeBonds(), Sv(h), t.Debug && Zc.timeEnd("MmtfParser._parse " + this.name);
              }, Object.defineProperties(n.prototype, r), n;
            }(aw);
          id.add("mmtf", Vw);
          var Hw = /\s+/,
            qw = {
              1: 1,
              2: 2,
              3: 3,
              am: 1,
              ar: 1,
              du: 1,
              un: 1,
              nc: 0
            },
            Ww = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "mol2";
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("Mol2Parser._parse " + this.name);
                var e,
                  n,
                  r = this.structure,
                  i = this.structureBuilder,
                  o = this.firstModelOnly,
                  a = this.asTrajectory,
                  s = r.frames,
                  l = !1,
                  u = r.atomMap,
                  c = r.atomStore;
                c.resize(Math.round(this.streamer.data.length / 60)), c.addField("partialCharge", 1, "float32");
                var d = 0,
                  h = 0,
                  f = 0,
                  p = -1,
                  m = 0,
                  g = 0,
                  v = r.getAtomProxy(),
                  y = r.getAtomProxy();
                this.streamer.eachChunkOfLines(function (t) {
                  !function (t, b, _) {
                    for (var x = 0; x < b; ++x) {
                      var w = _[x].trim();
                      if ("" !== w && "#" !== w[0]) if ("@" === w[0]) "@<TRIPOS>MOLECULE" === w ? (g = 1, h = 0, ++p) : "@<TRIPOS>ATOM" === w ? (g = 2, f = c.count, a && (n = 0, e = new Float32Array(3 * m), s.push(e), 0 < p && (l = !0))) : g = "@<TRIPOS>BOND" === w ? 3 : 0;else if (1 === g) {
                        if (0 === h) r.title = w, r.id = w;else if (1 === h) {
                          var S = w.split(Hw);
                          m = parseInt(S[0]);
                        }
                        ++h;
                      } else if (2 === g) {
                        var A = w.split(Hw);
                        if (o && 0 < p) continue;
                        var E = parseFloat(A[2]),
                          T = parseFloat(A[3]),
                          M = parseFloat(A[4]);
                        if (a) {
                          var C = 3 * n;
                          if (e[C + 0] = E, e[C + 1] = T, e[C + 2] = M, n += 1, l) continue;
                        }
                        var k = A[0],
                          P = A[1],
                          O = A[5].split(".")[0],
                          R = A[6] ? parseInt(A[6]) : 1,
                          I = A[7] ? A[7] : "",
                          j = A[8] ? parseFloat(A[8]) : 0;
                        c.growIfFull(), c.atomTypeId[d] = u.add(P, O), c.x[d] = E, c.y[d] = T, c.z[d] = M, c.serial[d] = k, c.partialCharge[d] = j, i.addAtom(p, "", "", I, R, 1), d += 1;
                      } else if (3 === g) {
                        if (o && 0 < p) continue;
                        if (a && 0 < p) continue;
                        var N = w.split(Hw);
                        v.index = parseInt(N[1]) - 1 + f, y.index = parseInt(N[2]) - 1 + f;
                        var L = qw[N[3]];
                        r.bondStore.addBond(v, y, L);
                      }
                    }
                  }(0, t.length, t);
                }), i.finalize(), r.finalizeAtoms(), vv(r), xv(r, !0), wv(r, !0), r.finalizeBonds(), Mv(r), pv(r), t.Debug && Zc.timeEnd("Mol2Parser._parse " + this.name);
              }, Object.defineProperties(n.prototype, r), n;
            }(aw);
          id.add("mol2", Ww);
          var $w = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "pdbqt";
            }, Object.defineProperties(t.prototype, n), t;
          }(gw);
          id.add("pdbqt", $w);
          var Xw = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "pqr";
            }, Object.defineProperties(t.prototype, n), t;
          }(gw);
          id.add("pqr", Xw);
          var Yw = /> <(.+)>/,
            Kw = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "sdf";
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("SdfParser._parse " + this.name);
                var e = this.structure,
                  n = this.structureBuilder,
                  r = this.firstModelOnly,
                  i = this.asTrajectory,
                  o = this.streamer.peekLines(2);
                e.id = o[0].trim(), e.title = o[1].trim();
                var a,
                  s,
                  l = e.frames,
                  u = !1,
                  c = e.atomMap,
                  d = e.atomStore;
                d.resize(Math.round(this.streamer.data.length / 50)), d.addField("formalCharge", 1, "int8");
                var h,
                  f,
                  p,
                  m,
                  g,
                  v,
                  y,
                  b = e.getAtomProxy(),
                  _ = e.getAtomProxy(),
                  x = 0,
                  w = 0,
                  S = 0,
                  A = 0,
                  E = [],
                  T = !1,
                  M = {};
                e.extraData.sdf = E, this.streamer.eachChunkOfLines(function (t) {
                  !function (t, o, C) {
                    for (var k = 0; k < o; ++k) {
                      var P = C[k];
                      if ("$$$$" === P.substr(0, 4)) w = -1, ++S, A = d.count, E.push(M), T = !(M = {});else if (3 === w) f = parseInt(P.substr(0, 3)), p = parseInt(P.substr(3, 3)), y = (v = g = (m = 4) + f) + p, i && (s = 0, a = new Float32Array(3 * f), l.push(a), 0 < S && (u = !0));else if (m <= w && w < g) {
                        if (r && 0 < S) continue;
                        var O = parseFloat(P.substr(0, 10)),
                          R = parseFloat(P.substr(10, 10)),
                          I = parseFloat(P.substr(20, 10));
                        if (i) {
                          var j = 3 * s;
                          if (a[j + 0] = O, a[j + 1] = R, a[j + 2] = I, s += 1, u) continue;
                        }
                        var N = P.substr(31, 3).trim(),
                          L = N + (x + 1);
                        d.growIfFull(), d.atomTypeId[x] = c.add(L, N), d.x[x] = O, d.y[x] = R, d.z[x] = I, d.serial[x] = x, d.formalCharge[x] = 0, n.addAtom(S, "", "", "HET", 1, 1), x += 1;
                      } else if (v <= w && w < y) {
                        if (r && 0 < S) continue;
                        if (i && 0 < S) continue;
                        b.index = parseInt(P.substr(0, 3)) - 1 + A, _.index = parseInt(P.substr(3, 3)) - 1 + A;
                        var D = parseInt(P.substr(6, 3));
                        e.bondStore.addBond(b, _, D);
                      } else if (P.match(/M {2}CHG/)) for (var B = parseInt(P.substr(6, 3)), F = 0, z = 10; F < B; ++F, z += 8) {
                        var U = parseInt(P.substr(z, 3)) - 1 + A,
                          G = parseInt(P.substr(z + 4, 3));
                        d.formalCharge[U] = G;
                      } else (h = P.match(Yw)) ? (T = h[1], M[T] = []) : !1 !== T && P && M[T].push(P);
                      ++w;
                    }
                  }(0, t.length, t);
                }), n.finalize(), e.finalizeAtoms(), e.finalizeBonds(), Mv(e), t.Debug && Zc.timeEnd("SdfParser._parse " + this.name);
              }, n.prototype._postProcess = function () {
                Mv(this.structure);
              }, Object.defineProperties(n.prototype, r), n;
            }(aw);
          function Zw(e, t, n) {
            return parseInt(e.substr(t, n).trim());
          }
          id.add("sdf", Kw), id.add("sd", Kw), id.add("mol", Kw);
          var Qw = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "prmtop";
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("PrmtopParser._parse " + this.name);
              var e = this.structure,
                n = this.structureBuilder,
                r = e.atomMap,
                i = e.atomStore;
              i.addField("partialCharge", 1, "float32"), i.addField("radius", 1, "float32");
              var o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g = [],
                v = {},
                y = ["NATOM", "NTYPES", "NBONH", "MBONA", "NTHETH", "MTHETA", "NPHIH", "MPHIA", "NHPARM", "NPARM", "NNB", "NRES", "NBONA", "NTHETA", "NPHIA", "NUMBND", "NUMANG", "NPTRA", "NATYP", "NPHB", "IFPERT", "NBPER", "NGPER", "NDPER", "MBPER", "MGPER", "MDPER", "IFBOX", "NMXRS", "IFCAP", "NUMEXTRA", "NCOPY"];
              y.forEach(function (e) {
                v[e] = 0;
              }), this.streamer.eachChunkOfLines(function (e) {
                !function (e, t, n) {
                  for (var r = 0; r < t; ++r) {
                    var b = n[r],
                      _ = b.trim();
                    if (_) if (b.startsWith("%FORMAT")) ;else if (b.startsWith("%FLAG")) {
                      var x = b.substr(5).trim();
                      p = 0, "TITLE" === x ? f = 0 : "POINTERS" === x ? f = 1 : "ATOM_NAME" === x ? f = 2 : "CHARGE" === x ? f = 3 : "MASS" === x ? f = 4 : "RESIDUE_LABEL" === x ? f = 5 : "RESIDUE_POINTER" === x ? f = 6 : "BONDS_INC_HYDROGEN" === x ? (m = 0, f = 7) : "BONDS_WITHOUT_HYDROGEN" === x ? (m = v.NBONH, f = 8) : f = "RADII" === x ? 9 : void 0;
                    } else if (0 === f) g.push(_);else if (1 === f) {
                      for (var w = Math.min(p + 10, 32), S = 0; p < w; ++S, ++p) v[y[p]] = parseInt(b.substr(8 * S, 8).trim());
                      o = new Array(v.NATOM), a = new Float32Array(v.NATOM), s = new Float32Array(v.NATOM), i.resize(v.NATOM);
                      var A = v.NBONH + v.MBONA;
                      l = new Uint32Array(A), u = new Uint32Array(A), c = new Uint8Array(A), d = new Array(v.NRES), h = new Uint32Array(v.NRES);
                    } else if (2 === f) for (var E = Math.min(p + 20, v.NATOM), T = 0; p < E; ++T, ++p) o[p] = b.substr(4 * T, 4).trim();else if (3 === f) for (var M = Math.min(p + 5, v.NATOM), C = 0; p < M; ++C, ++p) a[p] = parseFloat(b.substr(16 * C, 16)) / 18.2223;else if (4 === f) ;else if (5 === f) for (var k = Math.min(p + 20, v.NRES), P = 0; p < k; ++P, ++p) d[p] = b.substr(4 * P, 4).trim();else if (6 === f) for (var O = Math.min(p + 10, v.NRES), R = 0; p < O; ++R, ++p) h[p] = Zw(b, 8 * R, 8);else if (7 === f) for (var I = Math.min(p + 10, 3 * v.NBONH), j = 0; p < I; ++j, ++p) {
                      var N = p % 3;
                      0 === N && (l[m] = Zw(b, 8 * j, 8) / 3), 1 === N && (u[m] = Zw(b, 8 * j, 8) / 3, c[m] = 1, ++m);
                    } else if (8 === f) for (var L = Math.min(p + 10, 3 * v.MBONA), D = 0; p < L; ++D, ++p) {
                      var B = p % 3;
                      0 === B && (l[m] = Zw(b, 8 * D, 8) / 3), 1 === B && (u[m] = Zw(b, 8 * D, 8) / 3, c[m] = 1, ++m);
                    } else if (9 === f) for (var F = Math.min(p + 5, v.NATOM), z = 0; p < F; ++z, ++p) s[p] = parseFloat(b.substr(16 * z, 16));
                  }
                }(0, e.length, e);
              }), e.title = g.join(" ");
              for (var b = v.NATOM, _ = 0, x = d[0], w = 1, S = 0; S < b; ++S) S + 1 === h[_ + 1] && (x = d[++_], w = _ + 1), i.atomTypeId[S] = r.add(o[S]), i.serial[S] = S + 1, n.addAtom(0, "", "", x, w);
              i.partialCharge.set(a), i.radius.set(s), e.bondStore.length = c.length, e.bondStore.count = c.length, e.bondStore.atomIndex1 = l, e.bondStore.atomIndex2 = u, e.bondStore.bondOrder = c, n.finalize(), e.finalizeAtoms(), e.finalizeBonds(), xv(e, !0), wv(e, !0, !0), vv(e, !0), Mv(e), t.Debug && Zc.timeEnd("PrmtopParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(aw);
          id.add("prmtop", Qw), id.add("parm7", Qw);
          var Jw = /\s+/,
            eS = /(^\*|REMARK)*/,
            tS = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "psf";
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("PsfParser._parse " + this.name);
                var e = this.structure,
                  n = this.structureBuilder,
                  r = e.atomMap,
                  i = e.atomStore;
                i.addField("partialCharge", 1, "float32");
                var o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d = [],
                  h = 0,
                  f = 0,
                  p = 0;
                this.streamer.eachChunkOfLines(function (e) {
                  !function (e, t, m) {
                    for (var g = 0; g < t; ++g) {
                      var v = m[g].trim();
                      if (v) {
                        if (2 === o) {
                          var y = v.split(Jw),
                            b = parseInt(y[0]),
                            _ = y[1],
                            x = parseInt(y[2]),
                            w = y[3],
                            S = y[4],
                            A = parseFloat(y[6]);
                          _ !== s && (a = gv(f), ++f), i.growIfFull(), i.atomTypeId[h] = r.add(S), i.serial[h] = b, i.partialCharge[h] = A, n.addAtom(0, a, a, w, x), h += 1, s = _;
                        } else if (3 === o) for (var E = v.split(Jw), T = 0, M = E.length; T < M; T += 2) l[p] = parseInt(E[T]) - 1, u[p] = parseInt(E[T + 1]) - 1, c[p] = 1, p += 1;else if (1 === o) d.push(v.replace(eS, "").trim());else if (4 === o) ;else if (5 === o) ;else if (6 === o) ;else if (v.includes("!NATOM")) {
                          o = 2;
                          var C = parseInt(v.split(Jw)[0]);
                          i.resize(C);
                        } else if (v.includes("!NBOND")) {
                          o = 3;
                          var k = parseInt(v.split(Jw)[0]);
                          l = new Uint32Array(k), u = new Uint32Array(k), c = new Uint8Array(k);
                        } else v.includes("!NTITLE") ? o = 1 : v.includes("!NTHETA") ? o = 4 : v.includes("!NPHI") ? o = 5 : v.includes("!NIMPHI") && (o = 6);
                      } else o = void 0;
                    }
                  }(0, e.length, e);
                }), e.title = d.join(" "), e.bondStore.length = c.length, e.bondStore.count = p, e.bondStore.atomIndex1 = l, e.bondStore.atomIndex2 = u, e.bondStore.bondOrder = c, n.finalize(), e.finalizeAtoms(), e.finalizeBonds(), xv(e, !0), wv(e, !0, !0), Mv(e), t.Debug && Zc.timeEnd("PsfParser._parse " + this.name);
              }, Object.defineProperties(n.prototype, r), n;
            }(aw);
          id.add("psf", tS);
          var nS = /\[ (.+) \]/,
            rS = /\s+/,
            iS = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "top";
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("TopParser._parse " + this.name);
                var e = this.structure,
                  n = this.structureBuilder,
                  r = e.atomMap,
                  i = e.bondStore,
                  o = e.atomStore;
                o.addField("partialCharge", 1, "float32");
                var a,
                  s,
                  l = [],
                  u = {};
                this.streamer.eachChunkOfLines(function (t) {
                  !function (t, n, r) {
                    for (var i = 0; i < n; ++i) {
                      var o = r[i],
                        c = o.trim();
                      if (c && "*" !== c[0] && ";" !== c[0]) {
                        if (c.startsWith("#include")) throw new Error("TopParser: #include statements not allowed");
                        var d = o.match(nS);
                        if (null === d) {
                          var h = c.indexOf(";");
                          if (-1 !== h && (c = c.substring(0, h).trim()), 2 === s) {
                            var f = c.split(rS)[0];
                            u[f] = a;
                          } else if (3 === s) {
                            var p = c.split(rS);
                            a.atoms.push([parseInt(p[2]), p[3], p[4], parseFloat(p[6])]);
                          } else if (4 === s) {
                            var m = c.split(rS);
                            a.bonds.push([parseInt(m[0]), parseInt(m[1])]);
                          } else if (0 === s) e.title = c;else if (1 === s) {
                            var g = c.split(rS);
                            l.push([g[0], parseInt(g[1])]);
                          }
                        } else {
                          var v = d[1];
                          "moleculetype" === v ? (s = 2, a = {
                            atoms: [],
                            bonds: []
                          }) : s = "atoms" === v ? 3 : "bonds" === v ? 4 : "system" === v ? 0 : "molecules" === v ? 1 : void 0;
                        }
                      }
                    }
                  }(0, t.length, t);
                });
                var c = 0,
                  d = 0;
                l.forEach(function (e) {
                  var t = e[0],
                    n = e[1],
                    r = u[t];
                  c += n * r.atoms.length, d += n * r.bonds.length;
                }), o.resize(c), i.resize(d);
                var h,
                  f = 0,
                  p = 0,
                  m = 0,
                  g = 0,
                  v = 0,
                  y = 0;
                l.forEach(function (e) {
                  for (var t = e[0], a = e[1], s = u[t], l = gv(g), c = function c(e) {
                      h = -1;
                      var a = Mp.includes(t) ? l : gv(m);
                      s.atoms.forEach(function (e) {
                        var t = e[0],
                          i = e[1],
                          s = e[2],
                          u = e[3];
                        t !== h && ++p, o.atomTypeId[f] = r.add(s), o.serial[f] = f + 1, o.partialCharge[f] = u, n.addAtom(0, l, a, i, p + 1), ++f, h = t;
                      }), s.bonds.forEach(function (e) {
                        i.atomIndex1[v] = y + e[0] - 1, i.atomIndex2[v] = y + e[1] - 1, ++v;
                      }), ++m, y += s.atoms.length;
                    }, d = 0; d < a; ++d) c();
                  ++g;
                }), i.count = d, n.finalize(), e.finalizeAtoms(), e.finalizeBonds(), xv(e, !0), wv(e, !0, !0), Mv(e), t.Debug && Zc.timeEnd("TopParser._parse " + this.name);
              }, Object.defineProperties(n.prototype, r), n;
            }(aw);
          id.add("top", iS);
          var oS = function (e) {
              function t(t, n) {
                e.call(this, t, n), this.frames = new Xy(this.name, this.path);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                __objName: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "trajectory";
              }, n.__objName.get = function () {
                return "frames";
              }, Object.defineProperties(t.prototype, n), t;
            }(iw),
            aS = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                },
                isBinary: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "dcd";
              }, r.isBinary.get = function () {
                return !0;
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("DcdParser._parse " + this.name);
                var e = Lu(this.streamer.data),
                  n = new DataView(e),
                  r = this.frames,
                  i = r.coordinates,
                  o = r.boxes,
                  a = {},
                  s = 0,
                  l = new Int32Array(e, 0, 23),
                  u = l[0] !== n.getInt32(0);
                if (84 !== l[0]) for (var c = e.byteLength, d = 0; d < c; d += 4) n.setFloat32(d, n.getFloat32(d), !0);
                84 !== l[0] && Zc.error("dcd bad format, header block start"), "CORD" !== String.fromCharCode(n.getUint8(4), n.getUint8(5), n.getUint8(6), n.getUint8(7)) && Zc.error("dcd bad format, format string");
                var h = !1,
                  f = !1,
                  p = !1;
                0 !== l[22] && (h = !0, 0 !== l[12] && (f = !0), 1 === l[13] && (p = !0)), a.NSET = l[2], a.ISTART = l[3], a.NSAVC = l[4], a.NAMNF = l[10], a.DELTA = h ? n.getFloat32(44, u) : n.getFloat64(44, u), 84 !== l[22] && Zc.error("dcd bad format, header block end"), s = s + 84 + 8;
                var m = n.getInt32(s, u),
                  g = s + 1;
                if ((m - 4) % 80 != 0 && Zc.error("dcd bad format, title block start"), a.TITLE = Iu(new Uint8Array(e, g, m)), n.getInt32(g + m + 4 - 1, u) !== m && Zc.error("dcd bad format, title block end"), s = s + m + 8, 4 !== n.getInt32(s, u) && Zc.error("dcd bad format, natom block start"), a.NATOM = n.getInt32(s + 4, u), 4 !== n.getInt32(s + 8, u) && Zc.error("dcd bad format, natom block end"), s = s + 4 + 8, 0 < a.NAMNF) Zc.error("dcd format with fixed atoms unsupported, aborting");else {
                  for (var v = a.NATOM, y = 4 * v, b = 0, _ = a.NSET; b < _; ++b) {
                    if (f) {
                      s += 4;
                      var x = new Float32Array(9);
                      x[0] = n.getFloat64(s, u), x[4] = n.getFloat64(s + 16, u), x[8] = n.getFloat64(s + 40, u), o.push(x), s += 48, s += 4;
                    }
                    for (var w = new Float32Array(3 * v), S = 0; S < 3; ++S) {
                      n.getInt32(s, u) !== y && Zc.error("dcd bad format, coord block start", b, S), s += 4;
                      for (var A = new Float32Array(e, s, v), E = 0; E < v; ++E) w[3 * E + S] = A[E];
                      s += y, n.getInt32(s, u) !== y && Zc.error("dcd bad format, coord block end", b, S), s += 4;
                    }
                    i.push(w), p && (s += 4 + n.getInt32(s, u) + 4);
                  }
                  a.DELTA && (r.deltaTime = 20.45482949774598 * a.DELTA), 1 <= a.ISTART && (r.timeOffset = (a.ISTART - 1) * r.deltaTime), t.Debug && Zc.timeEnd("DcdParser._parse " + this.name);
                }
              }, Object.defineProperties(n.prototype, r), n;
            }(oS);
          function sS(e, t) {
            if (e) throw new TypeError("Not a valid NetCDF v3.x file: " + t);
          }
          function lS(e) {
            e.offset % 4 != 0 && e.skip(4 - e.offset % 4);
          }
          function uS(e) {
            var t = e.readUint32(),
              n = e.readChars(t);
            return lS(e), n;
          }
          id.add("dcd", aS);
          var cS = 1,
            dS = 2,
            hS = 3,
            fS = 4,
            pS = 5,
            mS = 6;
          function gS(e) {
            switch (Number(e)) {
              case cS:
                return "byte";
              case dS:
                return "char";
              case hS:
                return "short";
              case fS:
                return "int";
              case pS:
                return "float";
              case mS:
                return "double";
              default:
                return "undefined";
            }
          }
          function vS(e) {
            switch (Number(e)) {
              case cS:
              case dS:
                return 1;
              case hS:
                return 2;
              case fS:
              case pS:
                return 4;
              case mS:
                return 8;
              default:
                return -1;
            }
          }
          function yS(e) {
            switch (String(e)) {
              case "byte":
                return cS;
              case "char":
                return dS;
              case "short":
                return hS;
              case "int":
                return fS;
              case "float":
                return pS;
              case "double":
                return mS;
              default:
                return -1;
            }
          }
          function bS(e, t) {
            if (1 !== e) {
              for (var n = new Array(e), r = 0; r < e; r++) n[r] = t();
              return n;
            }
            return t();
          }
          function _S(e, t, n) {
            switch (t) {
              case cS:
                return e.readBytes(n);
              case dS:
                return function (e) {
                  return 0 === e.charCodeAt(e.length - 1) ? e.substring(0, e.length - 1) : e;
                }(e.readChars(n));
              case hS:
                return bS(n, e.readInt16.bind(e));
              case fS:
                return bS(n, e.readInt32.bind(e));
              case pS:
                return bS(n, e.readFloat32.bind(e));
              case mS:
                return bS(n, e.readFloat64.bind(e));
              default:
                return void sS(!0, "non valid type " + t);
            }
          }
          function xS(e) {
            var t,
              n = e.readUint32();
            if (0 === n) return sS(0 !== e.readUint32(), "wrong empty tag for list of attributes"), [];
            sS(12 !== n, "wrong tag for list of attributes");
            var r = e.readUint32();
            t = new Array(r);
            for (var i = 0; i < r; i++) {
              var o = uS(e),
                a = e.readUint32();
              sS(a < 1 || 6 < a, "non valid type " + a);
              var s = _S(e, a, e.readUint32());
              lS(e), t[i] = {
                name: o,
                type: gS(a),
                value: s
              };
            }
            return t;
          }
          var wS = function wS(e) {
              var t = new Ed(e);
              t.setBigEndian(), sS("CDF" !== t.readChars(3), "should start with CDF");
              var n = t.readByte();
              sS(2 < n, "unknown version"), this.header = function (e, t) {
                var n = {
                  recordDimension: {
                    length: e.readUint32()
                  }
                };
                n.version = t;
                var r = function (e) {
                  var t,
                    n,
                    r,
                    i = e.readUint32();
                  if (0 === i) return sS(0 !== e.readUint32(), "wrong empty tag for list of dimensions"), [];
                  sS(10 !== i, "wrong tag for list of dimensions");
                  var o = e.readUint32();
                  t = new Array(o);
                  for (var a = 0; a < o; a++) {
                    var s = uS(e),
                      l = e.readUint32();
                    0 === l && (n = a, r = s), t[a] = {
                      name: s,
                      size: l
                    };
                  }
                  return {
                    dimensions: t,
                    recordId: n,
                    recordName: r
                  };
                }(e);
                n.recordDimension.id = r.recordId, n.recordDimension.name = r.recordName, n.dimensions = r.dimensions, n.globalAttributes = xS(e);
                var i = function (e, t, n) {
                  var r,
                    i = e.readUint32(),
                    o = 0;
                  if (0 === i) return sS(0 !== e.readUint32(), "wrong empty tag for list of variables"), [];
                  sS(11 !== i, "wrong tag for list of variables");
                  var a = e.readUint32();
                  r = new Array(a);
                  for (var s = 0; s < a; s++) {
                    for (var l = uS(e), u = e.readUint32(), c = new Array(u), d = 0; d < u; d++) c[d] = e.readUint32();
                    var h = xS(e),
                      f = e.readUint32();
                    sS(f < 1 && 6 < f, "non valid type " + f);
                    var p = e.readUint32(),
                      m = e.readUint32();
                    2 === n && (sS(0 < m, "offsets larger than 4GB not supported"), m = e.readUint32()), c[0] === t && (o += p), r[s] = {
                      name: l,
                      dimensions: c,
                      attributes: h,
                      type: gS(f),
                      size: p,
                      offset: m,
                      record: c[0] === t
                    };
                  }
                  return {
                    variables: r,
                    recordStep: o
                  };
                }(e, r.recordId, t);
                return n.variables = i.variables, n.recordDimension.recordStep = i.recordStep, n;
              }(t, n), this.buffer = t;
            },
            SS = {
              version: {
                configurable: !0
              },
              recordDimension: {
                configurable: !0
              },
              dimensions: {
                configurable: !0
              },
              globalAttributes: {
                configurable: !0
              },
              variables: {
                configurable: !0
              }
            };
          SS.version.get = function () {
            return 1 === this.header.version ? "classic format" : "64-bit offset format";
          }, SS.recordDimension.get = function () {
            return this.header.recordDimension;
          }, SS.dimensions.get = function () {
            return this.header.dimensions;
          }, SS.globalAttributes.get = function () {
            return this.header.globalAttributes;
          }, SS.variables.get = function () {
            return this.header.variables;
          }, wS.prototype.hasDataVariable = function (e) {
            return -1 !== this.header.variables.findIndex(function (t) {
              return t.name === e;
            });
          }, wS.prototype.getDataVariable = function (e) {
            var t;
            return sS(void 0 === (t = "string" == typeof e ? this.header.variables.find(function (t) {
              return t.name === e;
            }) : e), "variable not found"), this.buffer.seek(t.offset), t.record ? function (e, t, n) {
              for (var r = yS(t.type), i = t.size ? t.size / vS(r) : 1, o = n.length, a = new Array(o), s = n.recordStep, l = 0; l < o; l++) {
                var u = e.offset;
                a[l] = _S(e, r, i), e.seek(u + s);
              }
              return a;
            }(this.buffer, t, this.header.recordDimension) : function (e, t) {
              for (var n = yS(t.type), r = t.size / vS(n), i = new Array(r), o = 0; o < r; o++) i[o] = _S(e, n, 1);
              return i;
            }(this.buffer, t);
          }, Object.defineProperties(wS.prototype, SS);
          var AS = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "nctraj";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("NctrajParser._parse " + this.name);
              var e = new wS(this.streamer.data),
                n = this.frames,
                r = n.coordinates,
                i = n.boxes,
                o = n.times;
              e.getDataVariable("coordinates").forEach(function (e) {
                r.push(new Float32Array(e));
              }), e.hasDataVariable("cell_lengths") && e.getDataVariable("cell_lengths").forEach(function (e) {
                i.push(new Float32Array(e));
              }), e.hasDataVariable("time") && e.getDataVariable("time").forEach(function (e) {
                o.push(e);
              }), 1 <= o.length && (n.timeOffset = o[0]), 2 <= o.length && (n.deltaTime = o[1] - o[0]), t.Debug && Zc.timeEnd("NctrajParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(oS);
          id.add("nctraj", AS), id.add("ncdf", AS), id.add("nc", AS);
          var ES = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "trr";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("TrrParser._parse " + this.name);
              for (var e = Lu(this.streamer.data), n = new DataView(e), r = this.frames, i = r.coordinates, o = r.boxes, a = r.times, s = 0;;) {
                s += 8;
                var l = n.getInt32(s);
                s += 4, s += l;
                var u = n.getInt32(s + 8),
                  c = n.getInt32(s + 12),
                  d = n.getInt32(s + 16),
                  h = n.getInt32(s + 28),
                  f = n.getInt32(s + 32),
                  p = n.getInt32(s + 36),
                  m = n.getInt32(s + 40);
                s += 52;
                var g = u / 9,
                  v = 3 * m;
                if (8 === g ? a.push(n.getFloat64(s)) : a.push(n.getFloat32(s)), s += 2 * g, u) {
                  var y = new Float32Array(9);
                  if (8 === g) for (var b = 0; b < 9; ++b) y[b] = 10 * n.getFloat64(s), s += 8;else for (var _ = 0; _ < 9; ++_) y[_] = 10 * n.getFloat32(s), s += 4;
                  o.push(y);
                }
                if (s += c, s += d, h) {
                  var x = void 0;
                  if (8 === g) {
                    x = new Float32Array(v);
                    for (var w = 0; w < v; ++w) x[w] = 10 * n.getFloat64(s), s += 8;
                  } else {
                    for (var S = new Uint32Array(e, s, v), A = 0; A < v; ++A) {
                      var E = S[A];
                      S[A] = (255 & E) << 24 | (65280 & E) << 8 | E >> 8 & 65280 | E >> 24 & 255;
                    }
                    x = new Float32Array(e, s, v);
                    for (var T = 0; T < v; ++T) x[T] *= 10, s += 4;
                  }
                  i.push(x);
                }
                if (s += f, (s += p) >= e.byteLength) break;
              }
              1 <= a.length && (r.timeOffset = a[0]), 2 <= a.length && (r.deltaTime = a[1] - a[0]), t.Debug && Zc.timeEnd("TrrParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(oS);
          id.add("trr", ES);
          var TS = new Uint32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 10, 12, 16, 20, 25, 32, 40, 50, 64, 80, 101, 128, 161, 203, 256, 322, 406, 512, 645, 812, 1024, 1290, 1625, 2048, 2580, 3250, 4096, 5060, 6501, 8192, 10321, 13003, 16384, 20642, 26007, 32768, 41285, 52015, 65536, 82570, 104031, 131072, 165140, 208063, 262144, 330280, 416127, 524287, 660561, 832255, 1048576, 1321122, 1664510, 2097152, 2642245, 3329021, 4194304, 5284491, 6658042, 8388607, 10568983, 13316085, 16777216]);
          function MS(e) {
            for (var t = 1, n = 0; t <= e && n < 32;) n++, t <<= 1;
            return n;
          }
          var CS = new Uint8Array(32);
          function kS(e, t) {
            var n = 1,
              r = 0;
            CS[0] = 1;
            for (var i = 0; i < e; i++) {
              var o = void 0,
                a = 0;
              for (o = 0; o < n; o++) a += CS[o] * t[i], CS[o] = 255 & a, a >>= 8;
              for (; 0 !== a;) CS[o++] = 255 & a, a >>= 8;
              n = o;
            }
            var s = 1;
            for (n--; CS[n] >= s;) r++, s *= 2;
            return r + 8 * n;
          }
          function PS(e, t, n, r) {
            for (var i = (1 << n) - 1, o = r[1], a = r[2], s = e[0], l = 0; 8 <= n;) l |= (a = a << 8 | t[s++]) >> o << n - 8, n -= 8;
            return 0 < n && (o < n && (o += 8, a = a << 8 | t[s++]), l |= a >> (o -= n) & (1 << n) - 1), l &= i, e[0] = s, e[1] = o, e[2] = a, l;
          }
          var OS = new Int32Array(32);
          function RS(e, t, n, r, i, o, a) {
            var s = 0;
            for (OS[1] = 0, OS[2] = 0, OS[3] = 0; 8 < r;) OS[s++] = PS(e, t, 8, a), r -= 8;
            0 < r && (OS[s++] = PS(e, t, r, a));
            for (var l = n - 1; 0 < l; l--) {
              for (var u = 0, c = s - 1; 0 <= c; c--) {
                var d = (u = u << 8 | OS[c]) / i[l] | 0;
                u -= (OS[c] = d) * i[l];
              }
              o[l] = u;
            }
            o[0] = OS[0] | OS[1] << 8 | OS[2] << 16 | OS[3] << 24;
          }
          var IS = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "xtc";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("XtcParser._parse " + this.name);
              for (var e = Lu(this.streamer.data), n = new DataView(e), r = this.frames, i = r.coordinates, o = r.boxes, a = r.times, s = new Int32Array(6), l = new Int32Array(3), u = new Int32Array(3), c = new Uint32Array(3), d = new Float32Array(3), h = new Float32Array(3), f = 0, p = new Int32Array(3), m = new Uint32Array(p.buffer);;) {
                var g = void 0,
                  v = n.getInt32(f + 4);
                f += 12;
                var y = 3 * v;
                a.push(n.getFloat32(f)), f += 4;
                for (var b = new Float32Array(9), _ = 0; _ < 9; ++_) b[_] = 10 * n.getFloat32(f), f += 4;
                if (o.push(b), v <= 9) {
                  g = new Float32Array(v);
                  for (var x = 0; x < v; ++x) g[x] = n.getFloat32(f), f += 4;
                } else {
                  p[0] = p[1] = p[2] = 0, l[0] = l[1] = l[2] = 0, c[0] = c[1] = c[2] = 0, u[0] = u[1] = u[2] = 0, d[0] = d[1] = d[2] = 0, h[0] = h[1] = h[2] = 0, g = new Float32Array(y);
                  var w = 0,
                    S = n.getInt32(f);
                  f += 4;
                  var A = n.getFloat32(f);
                  f += 4, s[0] = n.getInt32(f), s[1] = n.getInt32(f + 4), s[2] = n.getInt32(f + 8), s[3] = n.getInt32(f + 12), s[4] = n.getInt32(f + 16), s[5] = n.getInt32(f + 20), l[0] = s[3] - s[0] + 1, l[1] = s[4] - s[1] + 1, l[2] = s[5] - s[2] + 1, f += 24;
                  var E = void 0;
                  16777215 < (l[0] | l[1] | l[2]) ? (u[0] = MS(l[0]), u[1] = MS(l[1]), u[2] = MS(l[2]), E = 0) : E = kS(3, l);
                  var T = n.getInt32(f);
                  f += 4;
                  var M = T - 1,
                    C = TS[M = M < 9 ? 9 : M] / 2 | 0,
                    k = TS[T] / 2 | 0;
                  c[0] = c[1] = c[2] = TS[T];
                  var P = 4 * Math.ceil(n.getInt32(f) / 4);
                  f += 4;
                  var O = 1 / A,
                    R = 0,
                    I = 0,
                    j = new Uint8Array(e, f);
                  for (d[0] = d[1] = d[2] = 0; I < S;) {
                    0 === E ? (d[0] = PS(p, j, u[0], m), d[1] = PS(p, j, u[1], m), d[2] = PS(p, j, u[2], m)) : RS(p, j, 3, E, l, d, m), I++, d[0] += s[0], d[1] += s[1], d[2] += s[2], h[0] = d[0], h[1] = d[1], h[2] = d[2];
                    var N = 0;
                    if (1 === PS(p, j, 1, m) && (R = PS(p, j, 5, m), R -= N = R % 3, N--), 0 < R) {
                      d[0] = d[1] = d[2] = 0;
                      for (var L = 0; L < R; L += 3) {
                        if (RS(p, j, 3, T, c, d, m), I++, d[0] += h[0] - k, d[1] += h[1] - k, d[2] += h[2] - k, 0 === L) {
                          var D = d[0];
                          d[0] = h[0], h[0] = D, D = d[1], d[1] = h[1], h[1] = D, D = d[2], d[2] = h[2], h[2] = D, g[w++] = h[0] * O, g[w++] = h[1] * O, g[w++] = h[2] * O;
                        } else h[0] = d[0], h[1] = d[1], h[2] = d[2];
                        g[w++] = d[0] * O, g[w++] = d[1] * O, g[w++] = d[2] * O;
                      }
                    } else g[w++] = d[0] * O, g[w++] = d[1] * O, g[w++] = d[2] * O;
                    if (T += N, N < 0 ? (k = C, C = 9 < T ? TS[T - 1] / 2 | 0 : 0) : 0 < N && (C = k, k = TS[T] / 2 | 0), c[0] = c[1] = c[2] = TS[T], 0 === c[0] || 0 === c[1] || 0 === c[2]) return void console.error("(xdrfile error) Undefined error.");
                  }
                  f += P;
                }
                for (var B = 0; B < y; B++) g[B] *= 10;
                if (i.push(g), f >= e.byteLength) break;
              }
              1 <= a.length && (r.timeOffset = a[0]), 2 <= a.length && (r.deltaTime = a[1] - a[0]), t.Debug && Zc.timeEnd("XtcParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(oS);
          id.add("xtc", IS);
          var jS = function (e) {
              function t(t, n) {
                var r = n || {};
                e.call(this, t, r), this.volume = new Jm(this.name, this.path), this.voxelSize = wu(r.voxelSize, 1);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                __objName: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "volume";
              }, n.__objName.get = function () {
                return "volume";
              }, t.prototype._afterParse = function () {
                this.volume.setMatrix(this.getMatrix()), e.prototype._afterParse.call(this);
              }, t.prototype.getMatrix = function () {
                return new ie();
              }, Object.defineProperties(t.prototype, n), t;
            }(iw),
            NS = /\s+/,
            LS = /-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g,
            DS = .529177210859,
            BS = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "cube";
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("CubeParser._parse " + this.name);
                var e = this.volume,
                  n = this.streamer.peekLines(6),
                  r = {},
                  i = DS * this.voxelSize;
                function o(e, t) {
                  var r = n[e].trim().split(NS)[t];
                  return parseFloat(r);
                }
                r.atomCount = Math.abs(o(2, 0)), r.originX = o(2, 1) * DS, r.originY = o(2, 2) * DS, r.originZ = o(2, 3) * DS, r.NVX = o(3, 0), r.NVY = o(4, 0), r.NVZ = o(5, 0), r.basisX = new ae(o(3, 1), o(3, 2), o(3, 3)).multiplyScalar(i), r.basisY = new ae(o(4, 1), o(4, 2), o(4, 3)).multiplyScalar(i), r.basisZ = new ae(o(5, 1), o(5, 2), o(5, 3)).multiplyScalar(i);
                var a = new Float32Array(r.NVX * r.NVY * r.NVZ),
                  s = 0,
                  l = 0,
                  u = 0 < o(2, 0) ? 0 : 1;
                this.streamer.eachChunkOfLines(function (e) {
                  !function (e, t, n) {
                    for (var i = 0; i < t; ++i) {
                      var o = n[i].trim();
                      if ("" !== o && l >= r.atomCount + 6 + u) for (var c = o.match(LS), d = 0, h = c.length; d < h; ++d) a[s] = parseFloat(c[d]), ++s;
                      ++l;
                    }
                  }(0, e.length, e);
                }), e.header = r, e.setData(a, r.NVZ, r.NVY, r.NVX), t.Debug && Zc.timeEnd("CubeParser._parse " + this.name);
              }, n.prototype.getMatrix = function () {
                var e = this.volume.header,
                  t = new ie();
                return t.multiply(new ie().makeTranslation(e.originX, e.originY, e.originZ)), t.multiply(new ie().makeBasis(e.basisZ, e.basisY, e.basisX)), t;
              }, Object.defineProperties(n.prototype, r), n;
            }(jS);
          id.add("cub", BS), id.add("cube", BS);
          var FS = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "dsn6";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("Dsn6Parser._parse " + this.name);
              var e,
                n,
                r = this.volume,
                i = {},
                o = Lu(this.streamer.data),
                a = new Int16Array(o),
                s = new Uint8Array(o),
                l = String.fromCharCode.apply(null, s.subarray(0, 512));
              if (l.startsWith(":-)")) i.xStart = parseInt(l.substr(10, 5)), i.yStart = parseInt(l.substr(15, 5)), i.zStart = parseInt(l.substr(20, 5)), i.xExtent = parseInt(l.substr(32, 5)), i.yExtent = parseInt(l.substr(38, 5)), i.zExtent = parseInt(l.substr(42, 5)), i.xRate = parseInt(l.substr(52, 5)), i.yRate = parseInt(l.substr(58, 5)), i.zRate = parseInt(l.substr(62, 5)), i.xlen = parseFloat(l.substr(73, 10)) * this.voxelSize, i.ylen = parseFloat(l.substr(83, 10)) * this.voxelSize, i.zlen = parseFloat(l.substr(93, 10)) * this.voxelSize, i.alpha = parseFloat(l.substr(103, 10)), i.beta = parseFloat(l.substr(113, 10)), i.gamma = parseFloat(l.substr(123, 10)), e = parseFloat(l.substr(138, 12)) / 100, n = parseInt(l.substr(155, 8)), i.sigma = 100 * parseFloat(l.substr(170, 12));else {
                if (100 !== a[18]) for (var u = 0, c = a.length; u < c; ++u) {
                  var d = a[u];
                  a[u] = (255 & d) << 8 | d >> 8 & 255;
                }
                i.xStart = a[0], i.yStart = a[1], i.zStart = a[2], i.xExtent = a[3], i.yExtent = a[4], i.zExtent = a[5], i.xRate = a[6], i.yRate = a[7], i.zRate = a[8];
                var h = 1 / a[17],
                  f = h * this.voxelSize;
                i.xlen = a[9] * f, i.ylen = a[10] * f, i.zlen = a[11] * f, i.alpha = a[12] * h, i.beta = a[13] * h, i.gamma = a[14] * h, e = a[15] / 100, n = a[16], i.gamma = a[14] * h;
              }
              r.header = i, t.Debug && Zc.log(i, e, n);
              for (var p = new Float32Array(i.xExtent * i.yExtent * i.zExtent), m = 512, g = Math.ceil(i.xExtent / 8), v = Math.ceil(i.yExtent / 8), y = Math.ceil(i.zExtent / 8), b = 0; b < y; ++b) for (var _ = 0; _ < v; ++_) for (var x = 0; x < g; ++x) for (var w = 0; w < 8; ++w) for (var S = 8 * b + w, A = 0; A < 8; ++A) for (var E = 8 * _ + A, T = 0; T < 8; ++T) {
                var M = 8 * x + T;
                if (!(M < i.xExtent && E < i.yExtent && S < i.zExtent)) {
                  m += 8 - T;
                  break;
                }
                p[(M * i.yExtent + E) * i.zExtent + S] = (s[m] - n) / e, ++m;
              }
              r.setData(p, i.zExtent, i.yExtent, i.xExtent), i.sigma && r.setStats(void 0, void 0, void 0, i.sigma), t.Debug && Zc.timeEnd("Dsn6Parser._parse " + this.name);
            }, n.prototype.getMatrix = function () {
              var e = this.volume.header,
                t = [e.xlen, 0, 0],
                n = [e.ylen * Math.cos(Math.PI / 180 * e.gamma), e.ylen * Math.sin(Math.PI / 180 * e.gamma), 0],
                r = [e.zlen * Math.cos(Math.PI / 180 * e.beta), e.zlen * (Math.cos(Math.PI / 180 * e.alpha) - Math.cos(Math.PI / 180 * e.gamma) * Math.cos(Math.PI / 180 * e.beta)) / Math.sin(Math.PI / 180 * e.gamma), 0];
              r[2] = Math.sqrt(e.zlen * e.zlen * Math.sin(Math.PI / 180 * e.beta) * Math.sin(Math.PI / 180 * e.beta) - r[1] * r[1]);
              var i = [[], t, n, r],
                o = [0, e.xRate, e.yRate, e.zRate],
                a = [0, 1, 2, 3],
                s = new ie();
              return s.set(i[a[1]][0] / o[a[1]], i[a[2]][0] / o[a[2]], i[a[3]][0] / o[a[3]], 0, i[a[1]][1] / o[a[1]], i[a[2]][1] / o[a[2]], i[a[3]][1] / o[a[3]], 0, i[a[1]][2] / o[a[1]], i[a[2]][2] / o[a[2]], i[a[3]][2] / o[a[3]], 0, 0, 0, 0, 1), s.multiply(new ie().makeRotationY(qu(90))), s.multiply(new ie().makeTranslation(-e.zStart, e.yStart, e.xStart)), s.multiply(new ie().makeScale(-1, 1, 1)), s;
            }, Object.defineProperties(n.prototype, r), n;
          }(jS);
          id.add("dsn6", FS), id.add("brix", FS);
          var zS = /\s+/,
            US = function (e) {
              function n() {
                e.apply(this, arguments);
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "dx";
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("DxParser._parse " + this.name);
                var e = this.volume,
                  n = this.streamer.peekLines(30),
                  r = this.parseHeaderLines(n),
                  i = this.volume.header,
                  o = r.dataLineStart,
                  a = i.nx * i.ny * i.nz,
                  s = new Float32Array(a),
                  l = 0,
                  u = 0;
                this.streamer.eachChunkOfLines(function (e) {
                  !function (e, t, n) {
                    for (var r = 0; r < t; ++r) {
                      if (l < a && o < u) {
                        var i = n[r].trim();
                        if ("" !== i) for (var c = i.split(zS), d = 0, h = c.length; d < h; ++d) s[l] = parseFloat(c[d]), ++l;
                      }
                      ++u;
                    }
                  }(0, e.length, e);
                }), e.setData(s, i.nz, i.ny, i.nx), t.Debug && Zc.timeEnd("DxParser._parse " + this.name);
              }, n.prototype.parseHeaderLines = function (e) {
                for (var t = {}, n = e.length, r = 0, i = 0, o = 0, a = 0; a < n; ++a) {
                  var s = void 0,
                    l = e[a];
                  if (l.startsWith("object 1")) s = l.split(zS), t.nx = parseInt(s[5]), t.ny = parseInt(s[6]), t.nz = parseInt(s[7]);else if (l.startsWith("origin")) s = l.split(zS), t.xmin = parseFloat(s[1]), t.ymin = parseFloat(s[2]), t.zmin = parseFloat(s[3]);else if (l.startsWith("delta")) s = l.split(zS), 0 === o ? t.hx = parseFloat(s[1]) * this.voxelSize : 1 === o ? t.hy = parseFloat(s[2]) * this.voxelSize : 2 === o && (t.hz = parseFloat(s[3]) * this.voxelSize), o += 1;else if (l.startsWith("object 3")) {
                    r = a, i += l.length + 1;
                    break;
                  }
                  i += l.length + 1;
                }
                return this.volume.header = t, {
                  dataLineStart: r,
                  headerByteCount: i
                };
              }, n.prototype.getMatrix = function () {
                var e = this.volume.header,
                  t = new ie();
                return t.multiply(new ie().makeRotationY(qu(90))), t.multiply(new ie().makeTranslation(-e.zmin, e.ymin, e.xmin)), t.multiply(new ie().makeScale(-e.hz, e.hy, e.hx)), t;
              }, Object.defineProperties(n.prototype, r), n;
            }(jS);
          id.add("dx", US);
          var GS = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "dxbin";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("DxbinParser._parse " + this.name);
              for (var e = Lu(this.streamer.data), n = function (e, t, n) {
                  void 0 === t && (t = 10485760), void 0 === n && (n = "\n");
                  for (var r = "", i = [], o = 0; o < e.length; o += t) {
                    var a = Iu(e.subarray(o, o + t)),
                      s = a.lastIndexOf(n);
                    if (-1 === s) r += a;else {
                      var l = r + a.substr(0, s);
                      i = i.concat(l.split(n)), r = s === a.length - n.length ? "" : a.substr(s + n.length);
                    }
                  }
                  return "" !== r && i.push(r), i;
                }(new Uint8Array(e, 0, 1e3)), r = this.parseHeaderLines(n), i = this.volume.header, o = r.headerByteCount, a = i.nx * i.ny * i.nz, s = new DataView(e), l = new Float32Array(a), u = 0; u < a; ++u) l[u] = s.getFloat64(8 * u + o, !0);
              this.volume.setData(l, i.nz, i.ny, i.nx), t.Debug && Zc.timeEnd("DxbinParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(US);
          id.add("dxbin", GS);
          var VS = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "mrc";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("MrcParser._parse " + this.name);
              var e,
                n = this.volume,
                r = {},
                i = Lu(this.streamer.data),
                o = new Int32Array(i, 0, 56),
                a = new Float32Array(i, 0, 56),
                s = new DataView(i);
              if (r.MAP = String.fromCharCode(s.getUint8(208), s.getUint8(209), s.getUint8(210), s.getUint8(211)), r.MACHST = [s.getUint8(212), s.getUint8(213)], 17 === r.MACHST[0] && 17 === r.MACHST[1]) for (var l = i.byteLength, u = 0; u < l; u += 4) s.setFloat32(u, s.getFloat32(u), !0);
              if (r.NX = o[0], r.NY = o[1], r.NZ = o[2], r.MODE = o[3], r.NXSTART = o[4], r.NYSTART = o[5], r.NZSTART = o[6], r.MX = o[7], r.MY = o[8], r.MZ = o[9], r.xlen = a[10] * this.voxelSize, r.ylen = a[11] * this.voxelSize, r.zlen = a[12] * this.voxelSize, r.alpha = a[13], r.beta = a[14], r.gamma = a[15], r.MAPC = o[16], r.MAPR = o[17], r.MAPS = o[18], r.DMIN = a[19], r.DMAX = a[20], r.DMEAN = a[21], r.ISPG = o[22], r.NSYMBT = o[23], r.LSKFLG = o[24], r.originX = a[49], r.originY = a[50], r.originZ = a[51], r.ARMS = a[54], 2 === (n.header = r).MODE) e = new Float32Array(i, 1024 + r.NSYMBT, r.NX * r.NY * r.NZ);else if (0 === r.MODE) {
                if (e = new Float32Array(new Int8Array(i, 1024 + r.NSYMBT, r.NX * r.NY * r.NZ)), -128 === o[39] && 127 === o[40]) for (var c = (r.DMAX - r.DMIN) / 255, d = .5 * (r.DMIN + r.DMAX + c), h = 0, f = e.length; h < f; ++h) e[h] = c * e[h] + d;
              } else Zc.error("MrcParser unknown mode", r.MODE);
              n.setData(e, r.NX, r.NY, r.NZ), 0 !== r.ARMS && n.setStats(r.DMIN, r.DMAX, r.DMEAN, r.ARMS), t.Debug && Zc.timeEnd("MrcParser._parse " + this.name);
            }, n.prototype.getMatrix = function () {
              var e = this.volume.header,
                t = [e.xlen, 0, 0],
                n = [e.ylen * Math.cos(Math.PI / 180 * e.gamma), e.ylen * Math.sin(Math.PI / 180 * e.gamma), 0],
                r = [e.zlen * Math.cos(Math.PI / 180 * e.beta), e.zlen * (Math.cos(Math.PI / 180 * e.alpha) - Math.cos(Math.PI / 180 * e.gamma) * Math.cos(Math.PI / 180 * e.beta)) / Math.sin(Math.PI / 180 * e.gamma), 0];
              r[2] = Math.sqrt(e.zlen * e.zlen * Math.sin(Math.PI / 180 * e.beta) * Math.sin(Math.PI / 180 * e.beta) - r[1] * r[1]);
              var i = [[], t, n, r],
                o = [0, e.MX, e.MY, e.MZ],
                a = [0, e.MAPC, e.MAPR, e.MAPS],
                s = new ie();
              return s.set(i[a[1]][0] / o[a[1]], i[a[2]][0] / o[a[2]], i[a[3]][0] / o[a[3]], 0, i[a[1]][1] / o[a[1]], i[a[2]][1] / o[a[2]], i[a[3]][1] / o[a[3]], 0, i[a[1]][2] / o[a[1]], i[a[2]][2] / o[a[2]], i[a[3]][2] / o[a[3]], 0, 0, 0, 0, 1), s.setPosition(new ae(e.originX, e.originY, e.originZ)), s.multiply(new ie().makeTranslation(e.NXSTART, e.NYSTART, e.NZSTART)), s;
            }, Object.defineProperties(n.prototype, r), n;
          }(jS);
          id.add("mrc", VS), id.add("ccp4", VS), id.add("map", VS);
          var HS = /\s+/;
          function qS(e) {
            return e.trim().split(HS).map(parseFloat);
          }
          var WS = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "xplor";
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("XplorParser._parse " + this.name);
              var e,
                n = this.volume,
                r = this.streamer.peekLines(8),
                i = {},
                o = (e = r[2].startsWith("REMARKS") ? parseInt(r[1].substring(0, 8)) + 2 : 5) + 3,
                a = qS(r[e]);
              i.NA = a[0], i.AMIN = a[1], i.AMAX = a[2], i.NB = a[3], i.BMIN = a[4], i.BMAX = a[5], i.NC = a[6], i.CMIN = a[7], i.CMAX = a[8];
              var s = qS(r[e + 1]);
              i.a = s[0] * this.voxelSize, i.b = s[1] * this.voxelSize, i.c = s[2] * this.voxelSize, i.alpha = s[3], i.beta = s[4], i.gamma = s[5];
              var l = i.AMAX - i.AMIN + 1,
                u = i.BMAX - i.BMIN + 1,
                c = i.CMAX - i.CMIN + 1,
                d = l * u * c,
                h = new Float32Array(d),
                f = Math.ceil(1 + l * u / 6),
                p = 0,
                m = 0;
              this.streamer.eachChunkOfLines(function (e) {
                !function (e, t, n) {
                  for (var r = 0; r < t; ++r) {
                    var a = n[r];
                    if (o <= m && (m - o) % f != 0 && p < d) for (var s = 0; s < 6; ++s) {
                      var l = parseFloat(a.substr(12 * s, 12));
                      if (isNaN(l)) break;
                      h[p++] = l;
                    } else if (p === d) {
                      var u = a.trim();
                      if (u && "-9999" !== u) {
                        var c = qS(a);
                        i.RAVE = c[0], i.RSIGMA = c[1];
                      }
                    }
                    ++m;
                  }
                }(0, e.length, e);
              }), n.header = i, n.setData(h, l, u, c), 0 !== i.RAVE && 1 !== i.RSIGMA && n.setStats(void 0, void 0, i.RAVE, i.RSIGMA), t.Debug && Zc.timeEnd("XplorParser._parse " + this.name);
            }, n.prototype.getMatrix = function () {
              var e = this.volume.header,
                t = [e.a, 0, 0],
                n = [e.b * Math.cos(Math.PI / 180 * e.gamma), e.b * Math.sin(Math.PI / 180 * e.gamma), 0],
                r = [e.c * Math.cos(Math.PI / 180 * e.beta), e.c * (Math.cos(Math.PI / 180 * e.alpha) - Math.cos(Math.PI / 180 * e.gamma) * Math.cos(Math.PI / 180 * e.beta)) / Math.sin(Math.PI / 180 * e.gamma), 0];
              r[2] = Math.sqrt(e.c * e.c * Math.sin(Math.PI / 180 * e.beta) * Math.sin(Math.PI / 180 * e.beta) - r[1] * r[1]);
              var i = [[], t, n, r],
                o = [0, e.NA, e.NB, e.NC],
                a = [0, 1, 2, 3],
                s = new ie();
              return s.set(i[a[1]][0] / o[a[1]], i[a[2]][0] / o[a[2]], i[a[3]][0] / o[a[3]], 0, i[a[1]][1] / o[a[1]], i[a[2]][1] / o[a[2]], i[a[3]][1] / o[a[3]], 0, i[a[1]][2] / o[a[1]], i[a[2]][2] / o[a[2]], i[a[3]][2] / o[a[3]], 0, 0, 0, 0, 1), s.multiply(new ie().makeTranslation(e.AMIN, e.BMIN, e.CMIN)), s;
            }, Object.defineProperties(n.prototype, r), n;
          }(jS);
          function $S(e, t, n) {
            var r, i, o;
            e /= 360, t /= 100, n /= 100;
            var a = Math.floor(6 * e),
              s = 6 * e - a,
              l = n * (1 - t),
              u = n * (1 - s * t),
              c = n * (1 - (1 - s) * t);
            switch (a % 6) {
              case 0:
                r = n, i = c, o = l;
                break;
              case 1:
                r = u, i = n, o = l;
                break;
              case 2:
                r = l, i = n, o = c;
                break;
              case 3:
                r = l, i = u, o = n;
                break;
              case 4:
                r = c, i = l, o = n;
                break;
              case 5:
                r = n, i = l, o = u;
            }
            return [r, i, o];
          }
          id.add("xplor", WS), id.add("cns", WS);
          var XS = {
              red: $S(0, 100, 100),
              orange: $S(20, 100, 100),
              gold: $S(40, 100, 100),
              yellow: $S(60, 100, 100),
              lime: $S(80, 100, 100),
              green: $S(120, 80, 100),
              sea: $S(150, 100, 100),
              cyan: $S(180, 100, 85),
              sky: $S(210, 75, 95),
              blue: $S(240, 70, 100),
              purple: $S(275, 75, 100),
              magenta: $S(300, 95, 100),
              hotpink: $S(335, 100, 100),
              pink: $S(350, 55, 100),
              peach: $S(25, 75, 100),
              lilac: $S(275, 55, 100),
              pinktint: $S(340, 30, 100),
              peachtint: $S(25, 50, 100),
              yellowtint: $S(60, 50, 100),
              greentint: $S(135, 40, 100),
              bluetint: $S(220, 40, 100),
              lilactint: $S(275, 35, 100),
              white: $S(0, 0, 100),
              gray: $S(0, 0, 50),
              brown: $S(20, 45, 75),
              deadwhite: [1, 1, 1],
              deadblack: [0, 0, 0],
              invisible: [0, 0, 0]
            },
            YS = /[\s,]+/,
            KS = /[^{}\s]*{[^{}]+}|[^{}\s]+/g,
            ZS = /^{+|}+$/g,
            QS = /^['"]+|['"]+$/g,
            JS = /\s*=\s*/g;
          function eA(e) {
            for (var t, n, r, i = [], o = (e = e.replace(JS, "=")).match(KS), a = 1; a < o.length; ++a) {
              var s = o[a];
              if ("{" === s[0]) t = s.substring(1, s.length - 1);else {
                var l = s.split("=");
                2 === l.length && ("color" === l[0] ? n = XS[l[1]] : "width" === l[0] ? r = parseInt(l[1]) : "master" === l[0] && i.push(l[1].replace(ZS, "")));
              }
            }
            return {
              listName: t,
              listColor: n,
              listMasters: i,
              listWidth: r
            };
          }
          function tA(e) {
            for (var t, n, r, i = (e = e.trim()).indexOf("{"), o = e.indexOf("}"), a = e.substr(o + 1).split(YS), s = e.substr(i + 1, o - 1), l = [parseFloat(a[a.length - 3]), parseFloat(a[a.length - 2]), parseFloat(a[a.length - 1])], u = 4; u <= a.length; u++) {
              var c = a[a.length - u];
              c in XS && (t = XS[a[a.length - u]]), c.startsWith("width") && (n = parseInt(c.substring(5))), c.startsWith("r=") && (r = parseFloat(c.split("=")[1]));
            }
            return {
              label: s,
              position: l,
              color: t,
              radius: r,
              width: n
            };
          }
          function nA(e) {
            var t = e.indexOf("{"),
              n = e.indexOf("}");
            return e.substring(-1 !== t ? t + 1 : 0, -1 !== n ? n : void 0).trim();
          }
          function rA(e) {
            for (var t, n = {}, r = (e = e.replace(JS, "=")).match(KS), i = 1; i < r.length; ++i) {
              var o = r[i];
              if ("{" === o[0]) t = o.substring(1, o.length - 1);else {
                var a = o.split("=");
                2 === a.length ? n[a[0]] = a[1].replace(ZS, "") : n[a[0]] = !0;
              }
            }
            return [t, n];
          }
          var iA = function (e) {
            function n() {
              e.apply(this, arguments);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "kin";
            }, r.__objName.get = function () {
              return "kinemage";
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("KinParser._parse " + this.name);
              var e = {
                kinemage: void 0,
                onewidth: void 0,
                "1viewid": void 0,
                pdbfile: void 0,
                texts: [],
                text: "",
                captions: [],
                caption: "",
                groupDict: {},
                subgroupDict: {},
                masterDict: {},
                pointmasterDict: {},
                dotLists: [],
                vectorLists: [],
                ballLists: [],
                ribbonLists: []
              };
              this.kinemage = e;
              var n,
                r,
                i,
                o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g,
                v,
                y,
                b,
                _,
                x,
                w,
                S,
                A,
                E = !1,
                T = "",
                M = !1,
                C = "",
                k = !1,
                P = "",
                O = !1,
                R = "",
                I = !1,
                j = !1;
              if (this.streamer.eachChunkOfLines(function (t) {
                !function (t, N, L) {
                  for (var D = 0; D < N; ++D) {
                    var B = L[D];
                    if ("@" === B[0] && (j = I = O = k = M = E = !1), B) {
                      if (B.startsWith("@dotlist")) {
                        var F = eA(B),
                          z = F.listColor,
                          U = F.listName,
                          G = F.listMasters;
                        E = !0, T = "", r = [], i = [], o = [], n = z, e.dotLists.push({
                          name: U,
                          masterArray: G,
                          labelArray: r,
                          positionArray: i,
                          colorArray: o
                        });
                      } else if (B.startsWith("@vectorlist")) {
                        var V = eA(B),
                          H = V.listMasters,
                          q = V.listName,
                          W = V.listWidth,
                          $ = V.listColor;
                        H && H.forEach(function (t) {
                          e.masterDict[t] || (e.masterDict[t] = {
                            indent: !1,
                            visible: !1
                          });
                        }), M = !0, C = "", s = a = null, c = [], d = [], h = [], f = [], p = [], m = [], l = $, u = [], W && u.push(W), e.vectorLists.push({
                          name: q,
                          masterArray: H,
                          label1Array: c,
                          label2Array: d,
                          position1Array: h,
                          position2Array: f,
                          color1Array: p,
                          color2Array: m,
                          width: u
                        });
                      } else if (B.startsWith("@balllist")) {
                        var X = eA(B),
                          Y = X.listName,
                          K = X.listColor,
                          Z = X.listMasters;
                        Z && Z.forEach(function (t) {
                          e.masterDict[t] || (e.masterDict[t] = {
                            indent: !1,
                            visible: !1
                          });
                        }), k = !0, P = "", y = [], g = [], b = [], _ = [], v = K, e.ballLists.push({
                          name: Y,
                          masterArray: Z,
                          labelArray: y,
                          radiusArray: g,
                          positionArray: b,
                          colorArray: _
                        });
                      } else if (B.startsWith("@ribbonlist")) {
                        var Q = eA(B),
                          J = Q.listMasters,
                          ee = Q.listName,
                          te = Q.listColor;
                        J && J.forEach(function (t) {
                          e.masterDict[t] || (e.masterDict[t] = {
                            indent: !1,
                            visible: !1
                          });
                        }), O = !0, R = "", w = [], S = [], A = [], x = te, e.ribbonLists.push({
                          name: ee,
                          masterArray: J,
                          labelArray: w,
                          positionArray: S,
                          colorArray: A
                        });
                      } else if (B.startsWith("@text")) I = !0, e.texts.push(B.substr(5));else if (B.startsWith("@caption")) j = !0, e.captions.push(B.substr(8));else if (E) {
                        var ne = tA(B),
                          re = ne.label,
                          ie = ne.color,
                          oe = ne.position;
                        '"' === re ? re = T : T = re, void 0 === ie && (ie = n), r.push(re), i.push.apply(i, oe), o.push.apply(o, ie);
                      } else if (M) {
                        var ae = B.indexOf("{"),
                          se = B.indexOf("{", ae + 1),
                          le = void 0,
                          ue = void 0;
                        -1 === se ? ue = le = B : (le = B.substr(0, se), ue = B.substr(se));
                        var ce = tA(le),
                          de = ce.label,
                          he = ce.color,
                          fe = ce.width,
                          pe = ce.position;
                        if ('"' === de ? de = C : C = de, void 0 === he && (he = l), fe && u.push(fe), c.push(de), h.push.apply(h, pe), p.push.apply(p, he), -1 === se && a) d.push(C), f.push.apply(f, a), m.push.apply(m, s), C = de, a = pe, s = he;else {
                          var me = tA(ue),
                            ge = me.label,
                            ve = me.color,
                            ye = me.position;
                          '"' === ge ? ge = C : C = ge, void 0 === ve && (ve = l), d.push(ge), f.push.apply(f, ye), m.push.apply(m, ve), a = ye, s = ve;
                        }
                      } else if (k) {
                        var be = tA(B),
                          _e = be.label,
                          xe = be.radius,
                          we = be.color,
                          Se = be.position;
                        '"' === _e ? _e = P : P = _e, void 0 === xe && (xe = 1), void 0 === we && (we = v), y.push(_e), g.push(xe), b.push.apply(b, Se), _.push.apply(_, we);
                      } else if (O) {
                        var Ae = tA(B),
                          Ee = Ae.label,
                          Te = Ae.color,
                          Me = Ae.position;
                        '"' === Ee ? Ee = R : R = Ee, void 0 === Te && (Te = x), w.push(Ee), S.push.apply(S, Me), A.push.apply(A, Te);
                      } else if (I) e.texts.push(B);else if (j) e.captions.push(B);else if (B.startsWith("@kinemage")) e.kinemage = parseInt(B.substr(9).trim());else if (B.startsWith("@onewidth")) e.onewidth = !0;else if (B.startsWith("@1viewid")) e["1viewid"] = nA(B);else if (B.startsWith("@pdbfile")) e.pdbfile = nA(B);else if (B.startsWith("@group")) {
                        var Ce = rA(B),
                          ke = Ce[0],
                          Pe = Ce[1];
                        for (var Oe in e.groupDict[ke] || (e.groupDict[ke] = {
                          dominant: !1,
                          animate: !1
                        }), Pe) e.groupDict[ke][Oe] = Pe[Oe];
                      } else if (B.startsWith("@subgroup")) {
                        var Re = rA(B),
                          Ie = Re[0],
                          je = Re[1];
                        for (var Ne in e.subgroupDict[Ie] || (e.subgroupDict[Ie] = {
                          dominant: !1,
                          animate: !1,
                          master: void 0
                        }), je) e.subgroupDict[Ie][Ne] = je[Ne];
                      } else if (B.startsWith("@master")) {
                        var Le = nA(B),
                          De = -1 === (Ge = (Ue = B).indexOf("}")) ? void 0 : Ue.substr(Ge + 1).trim();
                        e.masterDict[Le] || (e.masterDict[Le] = {
                          indent: !1,
                          visible: !1
                        }), "on" === De ? e.masterDict[Le].visible = !0 : "off" === De ? e.masterDict[Le].visible = !1 : "indent" === De && (e.masterDict[Le].indent = !0);
                      } else if (B.startsWith("@pointmaster")) {
                        var Be = rA(B),
                          Fe = Be[0],
                          ze = Be[1];
                        e.pointmasterDict[Fe] = {
                          id: Object.keys(ze)[0].replace(QS, "")
                        };
                      } else console.log(B);
                    } else O = k = M = E = !1;
                  }
                  var Ue, Ge;
                }(0, t.length, t);
              }), e.text = e.texts.join("\n").trim(), e.caption = e.captions.join("\n").trim(), e.ribbonLists) {
                var N = [];
                e.ribbonLists.forEach(function (e) {
                  N.push(function (e) {
                    for (var t = e.labelArray, n = e.positionArray, r = e.colorArray, i = [], o = 0; o < 3 * (t.length - 2); ++o) i[o] = t[o - 2 * Math.floor(o / 3)];
                    for (var a = [], s = 0; s < 9 * (n.length / 3 - 2); ++s) a[s] = n[s - 6 * Math.floor(s / 9)];
                    for (var l = [], u = 0; u < 9 * (r.length / 3 - 2); ++u) l[u] = r[u - 6 * Math.floor(u / 9)];
                    return {
                      name: e.name,
                      masterArray: e.masterArray,
                      labelArray: i,
                      positionArray: a,
                      colorArray: l
                    };
                  }(e));
                }), e.ribbonLists = N;
              }
              t.Debug && Zc.timeEnd("KinParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(iw);
          id.add("kin", iA);
          var oA = function (e) {
              function t(t, n) {
                e.call(this, t, n), this.loader = this.getLoader(), this.surface = new Km(this.name, this.path);
              }
              e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
              var n = {
                type: {
                  configurable: !0
                },
                __objName: {
                  configurable: !0
                }
              };
              return n.type.get = function () {
                return "surface";
              }, n.__objName.get = function () {
                return "surface";
              }, t.prototype._parse = function () {
                var e = this.loader.parse(this.streamer.asText());
                this.surface.fromGeometry(e);
              }, Object.defineProperties(t.prototype, n), t;
            }(iw),
            aA = function aA() {
              this.regexp = {
                vertex_pattern: /^v\s+([\d.+\-eE]+)\s+([\d.+\-eE]+)\s+([\d.+\-eE]+)/,
                normal_pattern: /^vn\s+([\d.+\-eE]+)\s+([\d.+\-eE]+)\s+([\d.+\-eE]+)/,
                uv_pattern: /^vt\s+([\d.+\-eE]+)\s+([\d.+\-eE]+)/,
                face_vertex: /^f\s+(-?\d+)\s+(-?\d+)\s+(-?\d+)(?:\s+(-?\d+))?/,
                face_vertex_uv: /^f\s+(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)(?:\s+(-?\d+)\/(-?\d+))?/,
                face_vertex_uv_normal: /^f\s+(-?\d+)\/(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\/(-?\d+)\s+(-?\d+)\/(-?\d+)\/(-?\d+)(?:\s+(-?\d+)\/(-?\d+)\/(-?\d+))?/,
                face_vertex_normal: /^f\s+(-?\d+)\/\/(-?\d+)\s+(-?\d+)\/\/(-?\d+)\s+(-?\d+)\/\/(-?\d+)(?:\s+(-?\d+)\/\/(-?\d+))?/,
                object_pattern: /^[og]\s*(.+)?/,
                smoothing_pattern: /^s\s+(\d+|on|off)/,
                material_library_pattern: /^mtllib /,
                material_use_pattern: /^usemtl /
              };
            };
          aA.prototype = {
            constructor: aA,
            setPath: function setPath(e) {
              this.path = e;
            },
            _createParserState: function _createParserState() {
              var e = {
                objects: [],
                object: {},
                vertices: [],
                normals: [],
                startObject: function startObject(e, t) {
                  if (this.object && !1 === this.object.fromDeclaration) return this.object.name = e, void (this.object.fromDeclaration = !1 !== t);
                  this.object = {
                    name: e || "",
                    geometry: {
                      vertices: [],
                      normals: []
                    },
                    fromDeclaration: !1 !== t
                  }, this.objects.push(this.object);
                },
                parseVertexIndex: function parseVertexIndex(e, t) {
                  var n = parseInt(e, 10);
                  return 3 * (0 <= n ? n - 1 : n + t / 3);
                },
                parseNormalIndex: function parseNormalIndex(e, t) {
                  var n = parseInt(e, 10);
                  return 3 * (0 <= n ? n - 1 : n + t / 3);
                },
                addVertex: function addVertex(e, t, n) {
                  var r = this.vertices,
                    i = this.object.geometry.vertices;
                  i.push(r[e + 0]), i.push(r[e + 1]), i.push(r[e + 2]), i.push(r[t + 0]), i.push(r[t + 1]), i.push(r[t + 2]), i.push(r[n + 0]), i.push(r[n + 1]), i.push(r[n + 2]);
                },
                addVertexLine: function addVertexLine(e) {
                  var t = this.vertices,
                    n = this.object.geometry.vertices;
                  n.push(t[e + 0]), n.push(t[e + 1]), n.push(t[e + 2]);
                },
                addNormal: function addNormal(e, t, n) {
                  var r = this.normals,
                    i = this.object.geometry.normals;
                  i.push(r[e + 0]), i.push(r[e + 1]), i.push(r[e + 2]), i.push(r[t + 0]), i.push(r[t + 1]), i.push(r[t + 2]), i.push(r[n + 0]), i.push(r[n + 1]), i.push(r[n + 2]);
                },
                addFace: function addFace(e, t, n, r, i, o, a, s) {
                  var l,
                    u = this.vertices.length,
                    c = this.parseVertexIndex(e, u),
                    d = this.parseVertexIndex(t, u),
                    h = this.parseVertexIndex(n, u);
                  if (void 0 === r ? this.addVertex(c, d, h) : (l = this.parseVertexIndex(r, u), this.addVertex(c, d, l), this.addVertex(d, h, l)), void 0 !== i) {
                    var f = this.normals.length;
                    c = this.parseNormalIndex(i, f), d = i === o ? c : this.parseNormalIndex(o, f), h = i === a ? c : this.parseNormalIndex(a, f), void 0 === r ? this.addNormal(c, d, h) : (l = this.parseNormalIndex(s, f), this.addNormal(c, d, l), this.addNormal(d, h, l));
                  }
                },
                addLineGeometry: function addLineGeometry(e) {
                  this.object.geometry.type = "Line";
                  for (var t = this.vertices.length, n = 0, r = e.length; n < r; n++) this.addVertexLine(this.parseVertexIndex(e[n], t));
                }
              };
              return e.startObject("", !1), e;
            },
            parse: function parse(e) {
              var t,
                n,
                r = this,
                i = this._createParserState();
              -1 !== e.indexOf("\r\n") && (e = e.replace(/\r\n/g, "\n")), -1 !== e.indexOf("\\\n") && (e = e.replace(/\\\n/g, ""));
              var o = e.split("\n"),
                a = "",
                s = "",
                l = "",
                u = [],
                c = "function" == typeof "".trimLeft;
              for (t = 0, n = o.length; t < n; t++) if (a = o[t], 0 !== (a = c ? a.trimLeft() : a.trim()).length && "#" !== (s = a.charAt(0))) if ("v" === s) {
                if (" " === (l = a.charAt(1)) && null !== (u = r.regexp.vertex_pattern.exec(a))) i.vertices.push(parseFloat(u[1]), parseFloat(u[2]), parseFloat(u[3]));else if ("n" === l && null !== (u = r.regexp.normal_pattern.exec(a))) i.normals.push(parseFloat(u[1]), parseFloat(u[2]), parseFloat(u[3]));else if ("t" !== l || null === r.regexp.uv_pattern.exec(a)) throw new Error("Unexpected vertex/normal/uv line: '" + a + "'");
              } else if ("f" === s) {
                if (null !== (u = r.regexp.face_vertex_uv_normal.exec(a))) i.addFace(u[1], u[4], u[7], u[10], u[3], u[6], u[9], u[12]);else if (null !== r.regexp.face_vertex_uv.exec(a)) ;else if (null !== (u = r.regexp.face_vertex_normal.exec(a))) i.addFace(u[1], u[3], u[5], u[7], u[2], u[4], u[6], u[8]);else {
                  if (null === (u = r.regexp.face_vertex.exec(a))) throw new Error("Unexpected face line: '" + a + "'");
                  i.addFace(u[1], u[2], u[3], u[4]);
                }
              } else if ("l" === s) {
                var d = a.substring(1).trim().split(" "),
                  h = [],
                  f = [];
                if (-1 === a.indexOf("/")) h = d;else for (var p = 0, m = d.length; p < m; p++) {
                  var g = d[p].split("/");
                  "" !== g[0] && h.push(g[0]), "" !== g[1] && f.push(g[1]);
                }
                i.addLineGeometry(h, f);
              } else if (null !== (u = r.regexp.object_pattern.exec(a))) {
                var v = u[0].substr(1).trim();
                i.startObject(v);
              } else if (r.regexp.material_use_pattern.test(a)) ;else if (r.regexp.material_library_pattern.test(a)) ;else if (null === r.regexp.smoothing_pattern.exec(a)) {
                if ("\0" === a) continue;
                throw new Error("Unexpected line: '" + a + "'");
              }
              var y = [];
              for (t = 0, n = i.objects.length; t < n; t++) {
                var b = i.objects[t].geometry;
                if (0 !== b.vertices.length) {
                  var _ = new Yt();
                  _.addAttribute("position", new Tt(new Float32Array(b.vertices), 3)), 0 < b.normals.length ? _.addAttribute("normal", new Tt(new Float32Array(b.normals), 3)) : _.computeVertexNormals(), y.push(_);
                }
              }
              return y;
            }
          };
          var sA = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "obj";
            }, t.prototype.getLoader = function () {
              return new aA();
            }, Object.defineProperties(t.prototype, n), t;
          }(oA);
          id.add("obj", sA);
          var lA = function lA() {
            this.propertyNameMapping = {};
          };
          lA.prototype = {
            constructor: lA,
            setPropertyNameMapping: function setPropertyNameMapping(e) {
              this.propertyNameMapping = e;
            },
            bin2str: function bin2str(e) {
              for (var t = new Uint8Array(e), n = "", r = 0; r < e.byteLength; r++) n += String.fromCharCode(t[r]);
              return n;
            },
            isASCII: function isASCII(e) {
              return "ascii" === this.parseHeader(this.bin2str(e)).format;
            },
            parse: function parse(e) {
              return e instanceof ArrayBuffer ? this.isASCII(e) ? this.parseASCII(this.bin2str(e)) : this.parseBinary(e) : this.parseASCII(e);
            },
            parseHeader: function parseHeader(e) {
              var t = "",
                n = 0,
                r = /ply([\s\S]*)end_header\s/.exec(e);
              null !== r && (t = r[1], n = r[0].length);
              for (var i, o, a, s, l, u, c = {
                  comments: [],
                  elements: [],
                  headerLength: n
                }, d = t.split("\n"), h = 0; h < d.length; h++) {
                var f = d[h];
                if ("" !== (f = f.trim())) switch (o = (a = f.split(/\s+/)).shift(), f = a.join(" "), o) {
                  case "format":
                    c.format = a[0], c.version = a[1];
                    break;
                  case "comment":
                    c.comments.push(f);
                    break;
                  case "element":
                    void 0 !== i && c.elements.push(i), (i = {}).name = a[0], i.count = parseInt(a[1]), i.properties = [];
                    break;
                  case "property":
                    i.properties.push((s = a, l = this.propertyNameMapping, u = void 0, "list" === (u = {
                      type: s[0]
                    }).type ? (u.name = s[3], u.countType = s[1], u.itemType = s[2]) : u.name = s[1], u.name in l && (u.name = l[u.name]), u));
                    break;
                  default:
                    console.log("unhandled", o, a);
                }
              }
              return void 0 !== i && c.elements.push(i), c;
            },
            parseASCIINumber: function parseASCIINumber(e, t) {
              switch (t) {
                case "char":
                case "uchar":
                case "short":
                case "ushort":
                case "int":
                case "uint":
                case "int8":
                case "uint8":
                case "int16":
                case "uint16":
                case "int32":
                case "uint32":
                  return parseInt(e);
                case "float":
                case "double":
                case "float32":
                case "float64":
                  return parseFloat(e);
              }
            },
            parseASCIIElement: function parseASCIIElement(e, t) {
              for (var n = t.split(/\s+/), r = {}, i = 0; i < e.length; i++) if ("list" === e[i].type) {
                for (var o = [], a = this.parseASCIINumber(n.shift(), e[i].countType), s = 0; s < a; s++) o.push(this.parseASCIINumber(n.shift(), e[i].itemType));
                r[e[i].name] = o;
              } else r[e[i].name] = this.parseASCIINumber(n.shift(), e[i].type);
              return r;
            },
            parseASCII: function parseASCII(e) {
              var t,
                n = new Et(),
                r = this.parseHeader(e),
                i = "";
              null !== (t = /end_header\s([\s\S]*)$/.exec(e)) && (i = t[1]);
              var o = i.split("\n"),
                a = 0,
                s = 0;
              n.useColor = !1;
              for (var l = 0; l < o.length; l++) {
                var u = o[l];
                if ("" !== (u = u.trim())) {
                  s >= r.elements[a].count && (a++, s = 0);
                  var c = this.parseASCIIElement(r.elements[a].properties, u);
                  this.handleElement(n, r.elements[a].name, c), s++;
                }
              }
              return this.postProcess(n);
            },
            postProcess: function postProcess(e) {
              if (e.useColor) {
                for (var t = 0; t < e.faces.length; t++) e.faces[t].vertexColors = [e.colors[e.faces[t].a], e.colors[e.faces[t].b], e.colors[e.faces[t].c]];
                e.elementsNeedUpdate = !0;
              }
              return e.computeBoundingSphere(), e;
            },
            handleElement: function handleElement(e, t, n) {
              if ("vertex" === t) {
                if (e.vertices.push(new ae(n.x, n.y, n.z)), "red" in n && "green" in n && "blue" in n) {
                  e.useColor = !0;
                  var r = new Fe();
                  r.setRGB(n.red / 255, n.green / 255, n.blue / 255), e.colors.push(r);
                }
              } else if ("face" === t) {
                var i = n.vertex_indices;
                3 === i.length ? e.faces.push(new gt(i[0], i[1], i[2])) : 4 === i.length && e.faces.push(new gt(i[0], i[1], i[3]), new gt(i[1], i[2], i[3]));
              }
            },
            binaryRead: function binaryRead(e, t, n, r) {
              switch (n) {
                case "int8":
                case "char":
                  return [e.getInt8(t), 1];
                case "uint8":
                case "uchar":
                  return [e.getUint8(t), 1];
                case "int16":
                case "short":
                  return [e.getInt16(t, r), 2];
                case "uint16":
                case "ushort":
                  return [e.getUint16(t, r), 2];
                case "int32":
                case "int":
                  return [e.getInt32(t, r), 4];
                case "uint32":
                case "uint":
                  return [e.getUint32(t, r), 4];
                case "float32":
                case "float":
                  return [e.getFloat32(t, r), 4];
                case "float64":
                case "double":
                  return [e.getFloat64(t, r), 8];
              }
            },
            binaryReadElement: function binaryReadElement(e, t, n, r) {
              for (var i, o = {}, a = 0, s = 0; s < n.length; s++) if ("list" === n[s].type) {
                var l = [],
                  u = (i = this.binaryRead(e, t + a, n[s].countType, r))[0];
                a += i[1];
                for (var c = 0; c < u; c++) i = this.binaryRead(e, t + a, n[s].itemType, r), l.push(i[0]), a += i[1];
                o[n[s].name] = l;
              } else i = this.binaryRead(e, t + a, n[s].type, r), o[n[s].name] = i[0], a += i[1];
              return [o, a];
            },
            parseBinary: function parseBinary(e) {
              for (var t, n = new Et(), r = this.parseHeader(this.bin2str(e)), i = "binary_little_endian" === r.format, o = new DataView(e, r.headerLength), a = 0, s = 0; s < r.elements.length; s++) for (var l = 0; l < r.elements[s].count; l++) {
                a += (t = this.binaryReadElement(o, a, r.elements[s].properties, i))[1];
                var u = t[0];
                this.handleElement(n, r.elements[s].name, u);
              }
              return this.postProcess(n);
            }
          };
          var uA = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "ply";
            }, t.prototype.getLoader = function () {
              return new lA();
            }, Object.defineProperties(t.prototype, n), t;
          }(oA);
          id.add("ply", uA);
          var cA = function (e) {
            function t(t, n) {
              var r = n || {};
              e.call(this, t, r), this.delimiter = wu(r.delimiter, ","), this.comment = wu(r.comment, "#"), this.columnNames = wu(r.columnNames, !1), this.table = {
                name: this.name,
                path: this.path,
                columnNames: [],
                data: []
              };
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "csv";
            }, n.__objName.get = function () {
              return "table";
            }, t.prototype._parse = function () {
              var e = this,
                t = this.table.data,
                n = new RegExp("\\s*" + this.delimiter + "\\s*"),
                r = 0;
              this.streamer.eachChunkOfLines(function (i) {
                for (var o = i.length, a = 0; a < o; ++a) {
                  var s = i[a].trim();
                  if (!s.startsWith(e.comment)) {
                    var l = s.split(n);
                    0 === r ? e.table.columnNames = l : s && t.push(l), ++r;
                  }
                }
              });
            }, Object.defineProperties(t.prototype, n), t;
          }(iw);
          id.add("csv", cA);
          var dA = function (e) {
            function t(t, n) {
              var r = n || {};
              e.call(this, t, r), this.string = wu(r.string, !1), this.json = {
                name: this.name,
                path: this.path,
                data: {}
              };
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              },
              isJson: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "json";
            }, n.__objName.get = function () {
              return "json";
            }, n.isJson.get = function () {
              return !0;
            }, t.prototype._parse = function () {
              this.streamer.isBinary() || this.string ? this.json.data = JSON.parse(this.streamer.asText()) : this.json.data = this.streamer.data;
            }, Object.defineProperties(t.prototype, n), t;
          }(iw);
          id.add("json", dA);
          var hA = function (e) {
            function n(t, n) {
              var r = n || {};
              e.call(this, t, r), this.msgpack = {
                name: this.name,
                path: this.path,
                data: void 0
              };
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "msgpack";
            }, r.__objName.get = function () {
              return "msgpack";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("MsgpackParser._parse " + this.name), this.msgpack.data = zw(this.streamer.data), t.Debug && Zc.timeEnd("MsgpackParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(iw);
          id.add("msgpack", hA);
          var fA = function (e) {
            function n(t, n) {
              var r = n || {};
              e.call(this, t, r), this.netcdf = {
                name: this.name,
                path: this.path,
                data: void 0
              };
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              },
              isBinary: {
                configurable: !0
              }
            };
            return r.type.get = function () {
              return "netcdf";
            }, r.__objName.get = function () {
              return "netcdf";
            }, r.isBinary.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              t.Debug && Zc.time("NetcdfParser._parse " + this.name), this.netcdf.data = new wS(this.streamer.data), t.Debug && Zc.timeEnd("NetcdfParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(iw);
          id.add("netcdf", fA);
          var pA = function (e) {
            function t(t, n) {
              e.call(this, t, n), this.text = {
                name: this.name,
                path: this.path,
                data: ""
              };
            }
            e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t;
            var n = {
              type: {
                configurable: !0
              },
              __objName: {
                configurable: !0
              }
            };
            return n.type.get = function () {
              return "text";
            }, n.__objName.get = function () {
              return "text";
            }, t.prototype._parse = function () {
              this.text.data = this.streamer.asText();
            }, Object.defineProperties(t.prototype, n), t;
          }(iw);
          id.add("txt", pA), id.add("text", pA);
          var mA = /^['"]|['"]$/g,
            gA = /^<([\w-:.]+)\s*/,
            vA = /^([^<]*)/,
            yA = /([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/,
            bA = function (e) {
              function n(t, n) {
                var r = n || {};
                e.call(this, t, r), this.useDomParser = wu(r.useDomParser, !1), this.xml = {
                  name: this.name,
                  path: this.path,
                  data: {}
                };
              }
              e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
              var r = {
                type: {
                  configurable: !0
                },
                __objName: {
                  configurable: !0
                },
                isXml: {
                  configurable: !0
                }
              };
              return r.type.get = function () {
                return "xml";
              }, r.__objName.get = function () {
                return "xml";
              }, r.isXml.get = function () {
                return !0;
              }, n.prototype.__xmlParser = function (e) {
                return function (e) {
                  return e = e.trim().replace(/<!--[\s\S]*?-->/g, ""), {
                    declaration: function () {
                      if (n(/^<\?xml\s*/)) {
                        for (var e = {
                          attributes: {}
                        }; !r() && !i("?>");) {
                          var o = t();
                          if (!o) return e;
                          e.attributes[o.name] = o.value;
                        }
                        return n(/\?>\s*/), e;
                      }
                    }(),
                    root: function e() {
                      var o = n(gA);
                      if (o) {
                        for (var a, s, l = {
                            name: o[1],
                            attributes: {},
                            children: []
                          }; !(r() || i(">") || i("?>") || i("/>"));) {
                          var u = t();
                          if (!u) return l;
                          l.attributes[u.name] = u.value;
                        }
                        if (n(/^\s*\/>\s*/)) return l;
                        for (n(/\??>\s*/), l.content = (a = n(vA)) ? a[1] : ""; s = e();) l.children.push(s);
                        return n(/^<\/[\w-:.]+>\s*/), l;
                      }
                    }()
                  };
                  function t() {
                    var e,
                      t = n(yA);
                    if (t) return {
                      name: t[1],
                      value: (e = t[2], e.replace(mA, ""))
                    };
                  }
                  function n(t) {
                    var n = e.match(t);
                    if (n) return e = e.slice(n[0].length), n;
                  }
                  function r() {
                    return 0 === e.length;
                  }
                  function i(t) {
                    return 0 === e.indexOf(t);
                  }
                }(e);
              }, n.prototype.__domParser = function (e) {
                return new window.DOMParser().parseFromString(e, "text/xml");
              }, n.prototype._parse = function () {
                t.Debug && Zc.time("XmlParser._parse " + this.name), this.useDomParser ? this.streamer.data instanceof Document ? this.xml.data = this.streamer.data : this.xml.data = this.__domParser(this.streamer.asText()) : this.xml.data = this.__xmlParser(this.streamer.asText()), t.Debug && Zc.timeEnd("XmlParser._parse " + this.name);
              }, Object.defineProperties(n.prototype, r), n;
            }(iw);
          function _A(e, t) {
            var n = e.getNamedItem(t);
            return null !== n ? n.value : "";
          }
          function xA(e, t, n) {
            void 0 === n && (n = !1);
            var r = _A(e, "icode").trim(),
              i = _A(e, "chain").trim(),
              o = _A(e, "altcode"),
              a = _A(e, "resnum");
            return r && (a += "^" + r), i && (a += ":" + i), t && (a += "." + t), n && o.trim() && (a += "%" + o), a + "/" + (parseInt(_A(e, "model")) - 1);
          }
          function wA(e, t, n) {
            void 0 === e[t] ? e[t] = n : e[t] |= n;
          }
          function SA(e, t) {
            return null !== e && e.value === t;
          }
          function AA(e, t, n) {
            for (var r = 0, i = t.getElementsByTagName("clash"), o = 0, a = i.length; o < a; ++o) if (e[_A(i[o].attributes, "cid")]) {
              r += 1;
              break;
            }
            return 0 < t.getElementsByTagName("angle-outlier").length && (r += 1), 0 < t.getElementsByTagName("bond-outlier").length && (r += 1), 0 < t.getElementsByTagName("plane-outlier").length && (r += 1), SA(n.getNamedItem("rota"), "OUTLIER") && (r += 1), SA(n.getNamedItem("rama"), "OUTLIER") && (r += 1), SA(n.getNamedItem("RNApucker"), "outlier") && (r += 1), r;
          }
          id.add("xml", bA);
          var EA = function EA(e, t) {
              this.name = e, this.path = t, this.rsrzDict = {}, this.rsccDict = {}, this.rciDict = {}, this.clashDict = {}, this.clashArray = [], this.geoDict = {}, this.geoAtomDict = {}, this.atomDict = {}, this.clashSele = "NONE";
            },
            TA = {
              type: {
                configurable: !0
              }
            };
          TA.type.get = function () {
            return "validation";
          }, EA.prototype.fromXml = function (e) {
            t.Debug && Zc.time("Validation.fromXml");
            var n,
              r,
              i,
              o = this.rsrzDict,
              a = this.rsccDict,
              s = this.rciDict,
              l = this.clashDict,
              u = this.clashArray,
              c = this.geoDict,
              d = this.geoAtomDict,
              h = this.atomDict,
              f = e.getElementsByTagName("Entry");
            if (1 === f.length) {
              var p = f[0].getElementsByTagName("chemical_shift_list");
              if (1 === p.length) for (var m = p[0].getElementsByTagName("random_coil_index"), g = 0, v = m.length; g < v; ++g) {
                var y = m[g].attributes;
                s[(i = void 0, r = _A(n = y, "chain").trim(), i = "[" + _A(n, "rescode") + "]" + _A(n, "resnum"), r && (i += ":" + r), i)] = parseFloat(_A(y, "value"));
              }
            }
            var b = e.getElementsByTagName("ModelledSubgroup"),
              _ = {},
              x = [];
            t.Debug && Zc.time("Validation.fromXml#clashDict");
            for (var w = 0, S = b.length; w < S; ++w) {
              var A = b[w],
                E = A.attributes,
                T = xA(E);
              null !== E.getNamedItem("rsrz") && (o[T] = parseFloat(_A(E, "rsrz"))), null !== E.getNamedItem("rscc") && (a[T] = parseFloat(_A(E, "rscc")));
              var M = e.createAttribute("sele");
              M.value = T, E.setNamedItem(M);
              for (var C = A.getElementsByTagName("clash"), k = 0, P = C.length; k < P; ++k) {
                var O = C[k].attributes,
                  R = _A(O, "atom");
                if ("H" !== Tv(R)) {
                  var I = _A(O, "cid"),
                    j = xA(E, R, !0);
                  if (h[j] = !0, void 0 === _[I]) _[I] = {
                    sele1: j,
                    res1: T
                  };else {
                    var N = _[I];
                    N.res1 !== T && (N.sele2 = j, N.res2 = T, x.push(N.res1, T), l[I] = N, u.push(N));
                  }
                }
              }
            }
            t.Debug && Zc.timeEnd("Validation.fromXml#clashDict");
            for (var L = 0, D = b.length; L < D; ++L) {
              var B = b[L],
                F = B.attributes,
                z = _A(F, "sele");
              if ("." !== _A(F, "seq")) {
                var U = AA(l, B, F);
                0 < U && (c[z] = U);
              } else {
                var G = B.getElementsByTagName("clash"),
                  V = B.getElementsByTagName("mog-bond-outlier"),
                  H = B.getElementsByTagName("mog-angle-outlier");
                if (0 < V.length || 0 < H.length || 0 < G.length) {
                  var q = {};
                  d[z] = q;
                  for (var W = 0, $ = G.length; W < $; ++W) {
                    var X = G[W].attributes;
                    l[_A(X, "cid")] && wA(q, _A(X, "atom"), 1);
                  }
                  for (var Y = 0, K = V.length; Y < K; ++Y) _A(V[Y].attributes, "atoms").split(",").forEach(function (e) {
                    wA(q, e, 2);
                  });
                  for (var Z = 0, Q = H.length; Z < Q; ++Z) _A(H[Z].attributes, "atoms").split(",").forEach(function (e) {
                    wA(q, e, 4);
                  });
                }
              }
            }
            this.clashSele = x.length ? x.join(" OR ") : "NONE", t.Debug && Zc.timeEnd("Validation.fromXml");
          }, EA.prototype.getClashData = function (e) {
            t.Debug && Zc.time("Validation.getClashData");
            var n = e || {},
              r = n.structure,
              i = r.atomSet,
              o = new Fe(wu(n.color, "#f0027f")),
              a = r.getAtomProxy(),
              s = r.getAtomProxy(),
              l = new ae(),
              u = new ae(),
              c = new ae(),
              d = this.clashArray,
              h = d.length,
              f = new Float32Array(3 * h),
              p = new Float32Array(3 * h),
              m = qd(h, o.r, o.g, o.b),
              g = new Float32Array(h),
              v = new Float32Array(h);
            t.Debug && Zc.time("Validation.getClashData#atomDict");
            var y = this.atomDict;
            r.eachAtom(function (e) {
              var t,
                n,
                r,
                i,
                o,
                a,
                s = (n = (t = e).inscode, r = t.chainname, i = t.atomname, o = t.altloc, a = t.resno + "", n && (a += "^" + n), r && (a += ":" + r), i && (a += "." + i), o && (a += "%" + o), a += "/" + t.modelIndex);
              !0 === y[s] && (y[s] = e.index);
            }), t.Debug && Zc.timeEnd("Validation.getClashData#atomDict");
            var b = 0;
            return d.forEach(function (e, t) {
              if (a.index = y[e.sele1], s.index = y[e.sele2], void 0 !== a.index && void 0 !== s.index && i.isSet(a.index, s.index)) {
                l.subVectors(s, a).setLength(a.vdw), u.copy(a).add(l), l.subVectors(a, s).setLength(s.vdw), c.copy(s).add(l);
                var n = a.distanceTo(s) / 2,
                  r = Math.sqrt(a.vdw * a.vdw - n * n),
                  o = Math.sqrt(s.vdw * s.vdw - n * n);
                u.toArray(f, 3 * b), c.toArray(p, 3 * b), g[b] = (r + o) / 2, v[b] = t, ++b;
              }
            }), t.Debug && Zc.timeEnd("Validation.getClashData"), {
              position1: f.subarray(0, 3 * b),
              position2: p.subarray(0, 3 * b),
              color: m.subarray(0, 3 * b),
              color2: m.subarray(0, 3 * b),
              radius: g.subarray(0, b),
              picking: new dm(v.subarray(0, b), this, r)
            };
          }, Object.defineProperties(EA.prototype, TA);
          var MA = function (e) {
            function n(t, n) {
              var r = n || {};
              e.call(this, t, r), this.useDomParser = !0, this.validation = new EA(this.name, this.path);
            }
            e && (n.__proto__ = e), (n.prototype = Object.create(e && e.prototype)).constructor = n;
            var r = {
              __objName: {
                configurable: !0
              },
              isXml: {
                configurable: !0
              }
            };
            return r.__objName.get = function () {
              return "validation";
            }, r.isXml.get = function () {
              return !0;
            }, n.prototype._parse = function () {
              e.prototype._parse.call(this), t.Debug && Zc.time("ValidationParser._parse " + this.name), this.validation.fromXml(this.xml.data), t.Debug && Zc.timeEnd("ValidationParser._parse " + this.name);
            }, Object.defineProperties(n.prototype, r), n;
          }(bA);
          function CA(e, t) {
            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
          }
          function kA(e, t, n, r, i) {
            if (t.subarray && e.subarray) e.set(t.subarray(n, n + r), i);else for (var o = 0; o < r; o++) e[i + o] = t[n + o];
          }
          function PA(e, t, n, r) {
            for (var i = 65535 & e | 0, o = e >>> 16 & 65535 | 0, a = 0; 0 !== n;) {
              for (n -= a = 2e3 < n ? 2e3 : n; o = o + (i = i + t[r++] | 0) | 0, --a;);
              i %= 65521, o %= 65521;
            }
            return i | o << 16 | 0;
          }
          id.add("validation", MA);
          var OA = function () {
            for (var e, t = [], n = 0; n < 256; n++) {
              e = n;
              for (var r = 0; r < 8; r++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
              t[n] = e;
            }
            return t;
          }();
          function RA(e, t, n, r) {
            var i = OA,
              o = r + n;
            e ^= -1;
            for (var a = r; a < o; a++) e = e >>> 8 ^ i[255 & (e ^ t[a])];
            return -1 ^ e;
          }
          function IA(e, t) {
            var n, r, i, o, a, s, l, u, c, d, h, f, p, m, g, v, y, b, _, x, w, S, A, E, T;
            n = e.state, r = e.next_in, E = e.input, i = r + (e.avail_in - 5), o = e.next_out, T = e.output, a = o - (t - e.avail_out), s = o + (e.avail_out - 257), l = n.dmax, u = n.wsize, c = n.whave, d = n.wnext, h = n.window, f = n.hold, p = n.bits, m = n.lencode, g = n.distcode, v = (1 << n.lenbits) - 1, y = (1 << n.distbits) - 1;
            e: do {
              p < 15 && (f += E[r++] << p, p += 8, f += E[r++] << p, p += 8), b = m[f & v];
              t: for (;;) {
                if (f >>>= _ = b >>> 24, p -= _, 0 == (_ = b >>> 16 & 255)) T[o++] = 65535 & b;else {
                  if (!(16 & _)) {
                    if (0 == (64 & _)) {
                      b = m[(65535 & b) + (f & (1 << _) - 1)];
                      continue t;
                    }
                    if (32 & _) {
                      n.mode = 12;
                      break e;
                    }
                    e.msg = "invalid literal/length code", n.mode = 30;
                    break e;
                  }
                  x = 65535 & b, (_ &= 15) && (p < _ && (f += E[r++] << p, p += 8), x += f & (1 << _) - 1, f >>>= _, p -= _), p < 15 && (f += E[r++] << p, p += 8, f += E[r++] << p, p += 8), b = g[f & y];
                  n: for (;;) {
                    if (f >>>= _ = b >>> 24, p -= _, !(16 & (_ = b >>> 16 & 255))) {
                      if (0 == (64 & _)) {
                        b = g[(65535 & b) + (f & (1 << _) - 1)];
                        continue n;
                      }
                      e.msg = "invalid distance code", n.mode = 30;
                      break e;
                    }
                    if (w = 65535 & b, p < (_ &= 15) && (f += E[r++] << p, (p += 8) < _ && (f += E[r++] << p, p += 8)), l < (w += f & (1 << _) - 1)) {
                      e.msg = "invalid distance too far back", n.mode = 30;
                      break e;
                    }
                    if (f >>>= _, p -= _, (_ = o - a) < w) {
                      if (c < (_ = w - _) && n.sane) {
                        e.msg = "invalid distance too far back", n.mode = 30;
                        break e;
                      }
                      if (A = h, (S = 0) === d) {
                        if (S += u - _, _ < x) {
                          for (x -= _; T[o++] = h[S++], --_;);
                          S = o - w, A = T;
                        }
                      } else if (d < _) {
                        if (S += u + d - _, (_ -= d) < x) {
                          for (x -= _; T[o++] = h[S++], --_;);
                          if (S = 0, d < x) {
                            for (x -= _ = d; T[o++] = h[S++], --_;);
                            S = o - w, A = T;
                          }
                        }
                      } else if (S += d - _, _ < x) {
                        for (x -= _; T[o++] = h[S++], --_;);
                        S = o - w, A = T;
                      }
                      for (; 2 < x;) T[o++] = A[S++], T[o++] = A[S++], T[o++] = A[S++], x -= 3;
                      x && (T[o++] = A[S++], 1 < x && (T[o++] = A[S++]));
                    } else {
                      for (S = o - w; T[o++] = T[S++], T[o++] = T[S++], T[o++] = T[S++], 2 < (x -= 3););
                      x && (T[o++] = T[S++], 1 < x && (T[o++] = T[S++]));
                    }
                    break;
                  }
                }
                break;
              }
            } while (r < i && o < s);
            r -= x = p >> 3, f &= (1 << (p -= x << 3)) - 1, e.next_in = r, e.next_out = o, e.avail_in = r < i ? i - r + 5 : 5 - (r - i), e.avail_out = o < s ? s - o + 257 : 257 - (o - s), n.hold = f, n.bits = p;
          }
          var jA = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
            NA = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
            LA = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
            DA = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
          function BA(e, t, n, r, i, o, a, s) {
            var l,
              u,
              c,
              d,
              h,
              f,
              p,
              m,
              g,
              v = s.bits,
              y = 0,
              b = 0,
              _ = 0,
              x = 0,
              w = 0,
              S = 0,
              A = 0,
              E = 0,
              T = 0,
              M = 0,
              C = null,
              k = 0,
              P = new Uint16Array(16),
              O = new Uint16Array(16),
              R = null,
              I = 0;
            for (y = 0; y <= 15; y++) P[y] = 0;
            for (b = 0; b < r; b++) P[t[n + b]]++;
            for (w = v, x = 15; 1 <= x && 0 === P[x]; x--);
            if (x < w && (w = x), 0 === x) return i[o++] = 20971520, i[o++] = 20971520, s.bits = 1, 0;
            for (_ = 1; _ < x && 0 === P[_]; _++);
            for (w < _ && (w = _), y = E = 1; y <= 15; y++) if (E <<= 1, (E -= P[y]) < 0) return -1;
            if (0 < E && (0 === e || 1 !== x)) return -1;
            for (O[1] = 0, y = 1; y < 15; y++) O[y + 1] = O[y] + P[y];
            for (b = 0; b < r; b++) 0 !== t[n + b] && (a[O[t[n + b]]++] = b);
            if (0 === e ? (C = R = a, f = 19) : 1 === e ? (C = jA, k -= 257, R = NA, I -= 257, f = 256) : (C = LA, R = DA, f = -1), y = _, h = o, A = b = M = 0, c = -1, d = (T = 1 << (S = w)) - 1, 1 === e && 852 < T || 2 === e && 592 < T) return 1;
            for (;;) {
              for (p = y - A, a[b] < f ? (m = 0, g = a[b]) : a[b] > f ? (m = R[I + a[b]], g = C[k + a[b]]) : (m = 96, g = 0), l = 1 << y - A, _ = u = 1 << S; i[h + (M >> A) + (u -= l)] = p << 24 | m << 16 | g | 0, 0 !== u;);
              for (l = 1 << y - 1; M & l;) l >>= 1;
              if (0 !== l ? (M &= l - 1, M += l) : M = 0, b++, 0 == --P[y]) {
                if (y === x) break;
                y = t[n + a[b]];
              }
              if (w < y && (M & d) !== c) {
                for (0 === A && (A = w), h += _, E = 1 << (S = y - A); S + A < x && !((E -= P[S + A]) <= 0);) S++, E <<= 1;
                if (T += 1 << S, 1 === e && 852 < T || 2 === e && 592 < T) return 1;
                i[c = M & d] = w << 24 | S << 16 | h - o | 0;
              }
            }
            return 0 !== M && (i[h + M] = y - A << 24 | 64 << 16 | 0), s.bits = w, 0;
          }
          function FA(e) {
            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
          }
          function zA() {
            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
          }
          function UA(e, t) {
            var n, r, i, o, a, s;
            return e ? (r = new zA(), (e.state = r).window = null, o = t, 0 !== (n = (i = e) && i.state ? (s = i.state, o < 0 ? (a = 0, o = -o) : (a = 1 + (o >> 4), o < 48 && (o &= 15)), o && (o < 8 || 15 < o) ? -2 : (null !== s.window && s.wbits !== o && (s.window = null), s.wrap = a, s.wbits = o, function (e) {
              var t, n, r;
              return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, (n = e) && n.state ? (r = n.state, n.total_in = n.total_out = r.total = 0, n.msg = "", r.wrap && (n.adler = 1 & r.wrap), r.mode = 1, r.last = 0, r.havedict = 0, r.dmax = 32768, r.head = null, r.hold = 0, r.bits = 0, r.lencode = r.lendyn = new Int32Array(852), r.distcode = r.distdyn = new Int32Array(592), r.sane = 1, r.back = -1, 0) : -2) : -2;
            }(i))) : -2) && (e.state = null), n) : -2;
          }
          var GA,
            VA,
            HA = !0;
          function qA(e) {
            if (HA) {
              var t;
              for (GA = new Int32Array(512), VA = new Int32Array(32), t = 0; t < 144;) e.lens[t++] = 8;
              for (; t < 256;) e.lens[t++] = 9;
              for (; t < 280;) e.lens[t++] = 7;
              for (; t < 288;) e.lens[t++] = 8;
              for (BA(1, e.lens, 0, 288, GA, 0, e.work, {
                bits: 9
              }), t = 0; t < 32;) e.lens[t++] = 5;
              BA(2, e.lens, 0, 32, VA, 0, e.work, {
                bits: 5
              }), HA = !1;
            }
            e.lencode = GA, e.lenbits = 9, e.distcode = VA, e.distbits = 5;
          }
          function WA(e, t, n, r) {
            var i,
              o = e.state;
            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new Uint8Array(o.wsize)), r >= o.wsize ? (kA(o.window, t, n - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (r < (i = o.wsize - o.wnext) && (i = r), kA(o.window, t, n - r, i, o.wnext), (r -= i) ? (kA(o.window, t, n - r, r, 0), o.wnext = r, o.whave = o.wsize) : (o.wnext += i, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += i))), 0;
          }
          function $A(e, t) {
            var n,
              r,
              i,
              o,
              a,
              s,
              l,
              u,
              c,
              d,
              h,
              f,
              p,
              m,
              g,
              v,
              y,
              b,
              _,
              x,
              w,
              S,
              A,
              E,
              T = 0,
              M = new Uint8Array(4),
              C = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return -2;
            12 === (n = e.state).mode && (n.mode = 13), a = e.next_out, i = e.output, l = e.avail_out, o = e.next_in, r = e.input, s = e.avail_in, u = n.hold, c = n.bits, d = s, h = l, S = 0;
            e: for (;;) switch (n.mode) {
              case 1:
                if (0 === n.wrap) {
                  n.mode = 13;
                  break;
                }
                for (; c < 16;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                if (2 & n.wrap && 35615 === u) {
                  M[n.check = 0] = 255 & u, M[1] = u >>> 8 & 255, n.check = RA(n.check, M, 2, 0), c = u = 0, n.mode = 2;
                  break;
                }
                if (n.flags = 0, n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                  e.msg = "incorrect header check", n.mode = 30;
                  break;
                }
                if (8 != (15 & u)) {
                  e.msg = "unknown compression method", n.mode = 30;
                  break;
                }
                if (c -= 4, w = 8 + (15 & (u >>>= 4)), 0 === n.wbits) n.wbits = w;else if (w > n.wbits) {
                  e.msg = "invalid window size", n.mode = 30;
                  break;
                }
                n.dmax = 1 << w, e.adler = n.check = 1, n.mode = 512 & u ? 10 : 12, c = u = 0;
                break;
              case 2:
                for (; c < 16;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                if (n.flags = u, 8 != (255 & n.flags)) {
                  e.msg = "unknown compression method", n.mode = 30;
                  break;
                }
                if (57344 & n.flags) {
                  e.msg = "unknown header flags set", n.mode = 30;
                  break;
                }
                n.head && (n.head.text = u >> 8 & 1), 512 & n.flags && (M[0] = 255 & u, M[1] = u >>> 8 & 255, n.check = RA(n.check, M, 2, 0)), c = u = 0, n.mode = 3;
              case 3:
                for (; c < 32;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                n.head && (n.head.time = u), 512 & n.flags && (M[0] = 255 & u, M[1] = u >>> 8 & 255, M[2] = u >>> 16 & 255, M[3] = u >>> 24 & 255, n.check = RA(n.check, M, 4, 0)), c = u = 0, n.mode = 4;
              case 4:
                for (; c < 16;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                n.head && (n.head.xflags = 255 & u, n.head.os = u >> 8), 512 & n.flags && (M[0] = 255 & u, M[1] = u >>> 8 & 255, n.check = RA(n.check, M, 2, 0)), c = u = 0, n.mode = 5;
              case 5:
                if (1024 & n.flags) {
                  for (; c < 16;) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  n.length = u, n.head && (n.head.extra_len = u), 512 & n.flags && (M[0] = 255 & u, M[1] = u >>> 8 & 255, n.check = RA(n.check, M, 2, 0)), c = u = 0;
                } else n.head && (n.head.extra = null);
                n.mode = 6;
              case 6:
                if (1024 & n.flags && (s < (f = n.length) && (f = s), f && (n.head && (w = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Array(n.head.extra_len)), kA(n.head.extra, r, o, f, w)), 512 & n.flags && (n.check = RA(n.check, r, f, o)), s -= f, o += f, n.length -= f), n.length)) break e;
                n.length = 0, n.mode = 7;
              case 7:
                if (2048 & n.flags) {
                  if (0 === s) break e;
                  for (f = 0; w = r[o + f++], n.head && w && n.length < 65536 && (n.head.name += String.fromCharCode(w)), w && f < s;);
                  if (512 & n.flags && (n.check = RA(n.check, r, f, o)), s -= f, o += f, w) break e;
                } else n.head && (n.head.name = null);
                n.length = 0, n.mode = 8;
              case 8:
                if (4096 & n.flags) {
                  if (0 === s) break e;
                  for (f = 0; w = r[o + f++], n.head && w && n.length < 65536 && (n.head.comment += String.fromCharCode(w)), w && f < s;);
                  if (512 & n.flags && (n.check = RA(n.check, r, f, o)), s -= f, o += f, w) break e;
                } else n.head && (n.head.comment = null);
                n.mode = 9;
              case 9:
                if (512 & n.flags) {
                  for (; c < 16;) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  if (u !== (65535 & n.check)) {
                    e.msg = "header crc mismatch", n.mode = 30;
                    break;
                  }
                  c = u = 0;
                }
                n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = 12;
                break;
              case 10:
                for (; c < 32;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                e.adler = n.check = FA(u), c = u = 0, n.mode = 11;
              case 11:
                if (0 === n.havedict) return e.next_out = a, e.avail_out = l, e.next_in = o, e.avail_in = s, n.hold = u, n.bits = c, 2;
                e.adler = n.check = 1, n.mode = 12;
              case 12:
                if (5 === t || 6 === t) break e;
              case 13:
                if (n.last) {
                  u >>>= 7 & c, c -= 7 & c, n.mode = 27;
                  break;
                }
                for (; c < 3;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                switch (n.last = 1 & u, c -= 1, 3 & (u >>>= 1)) {
                  case 0:
                    n.mode = 14;
                    break;
                  case 1:
                    if (qA(n), n.mode = 20, 6 === t) {
                      u >>>= 2, c -= 2;
                      break e;
                    }
                    break;
                  case 2:
                    n.mode = 17;
                    break;
                  case 3:
                    e.msg = "invalid block type", n.mode = 30;
                }
                u >>>= 2, c -= 2;
                break;
              case 14:
                for (u >>>= 7 & c, c -= 7 & c; c < 32;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                if ((65535 & u) != (u >>> 16 ^ 65535)) {
                  e.msg = "invalid stored block lengths", n.mode = 30;
                  break;
                }
                if (n.length = 65535 & u, c = u = 0, n.mode = 15, 6 === t) break e;
              case 15:
                n.mode = 16;
              case 16:
                if (f = n.length) {
                  if (s < f && (f = s), l < f && (f = l), 0 === f) break e;
                  kA(i, r, o, f, a), s -= f, o += f, l -= f, a += f, n.length -= f;
                  break;
                }
                n.mode = 12;
                break;
              case 17:
                for (; c < 14;) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                if (n.nlen = 257 + (31 & u), u >>>= 5, c -= 5, n.ndist = 1 + (31 & u), u >>>= 5, c -= 5, n.ncode = 4 + (15 & u), u >>>= 4, c -= 4, 286 < n.nlen || 30 < n.ndist) {
                  e.msg = "too many length or distance symbols", n.mode = 30;
                  break;
                }
                n.have = 0, n.mode = 18;
              case 18:
                for (; n.have < n.ncode;) {
                  for (; c < 3;) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  n.lens[C[n.have++]] = 7 & u, u >>>= 3, c -= 3;
                }
                for (; n.have < 19;) n.lens[C[n.have++]] = 0;
                if (n.lencode = n.lendyn, n.lenbits = 7, A = {
                  bits: n.lenbits
                }, S = BA(0, n.lens, 0, 19, n.lencode, 0, n.work, A), n.lenbits = A.bits, S) {
                  e.msg = "invalid code lengths set", n.mode = 30;
                  break;
                }
                n.have = 0, n.mode = 19;
              case 19:
                for (; n.have < n.nlen + n.ndist;) {
                  for (; v = (T = n.lencode[u & (1 << n.lenbits) - 1]) >>> 16 & 255, y = 65535 & T, !((g = T >>> 24) <= c);) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  if (y < 16) u >>>= g, c -= g, n.lens[n.have++] = y;else {
                    if (16 === y) {
                      for (E = g + 2; c < E;) {
                        if (0 === s) break e;
                        s--, u += r[o++] << c, c += 8;
                      }
                      if (u >>>= g, c -= g, 0 === n.have) {
                        e.msg = "invalid bit length repeat", n.mode = 30;
                        break;
                      }
                      w = n.lens[n.have - 1], f = 3 + (3 & u), u >>>= 2, c -= 2;
                    } else if (17 === y) {
                      for (E = g + 3; c < E;) {
                        if (0 === s) break e;
                        s--, u += r[o++] << c, c += 8;
                      }
                      c -= g, w = 0, f = 3 + (7 & (u >>>= g)), u >>>= 3, c -= 3;
                    } else {
                      for (E = g + 7; c < E;) {
                        if (0 === s) break e;
                        s--, u += r[o++] << c, c += 8;
                      }
                      c -= g, w = 0, f = 11 + (127 & (u >>>= g)), u >>>= 7, c -= 7;
                    }
                    if (n.have + f > n.nlen + n.ndist) {
                      e.msg = "invalid bit length repeat", n.mode = 30;
                      break;
                    }
                    for (; f--;) n.lens[n.have++] = w;
                  }
                }
                if (30 === n.mode) break;
                if (0 === n.lens[256]) {
                  e.msg = "invalid code -- missing end-of-block", n.mode = 30;
                  break;
                }
                if (n.lenbits = 9, A = {
                  bits: n.lenbits
                }, S = BA(1, n.lens, 0, n.nlen, n.lencode, 0, n.work, A), n.lenbits = A.bits, S) {
                  e.msg = "invalid literal/lengths set", n.mode = 30;
                  break;
                }
                if (n.distbits = 6, n.distcode = n.distdyn, A = {
                  bits: n.distbits
                }, S = BA(2, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, A), n.distbits = A.bits, S) {
                  e.msg = "invalid distances set", n.mode = 30;
                  break;
                }
                if (n.mode = 20, 6 === t) break e;
              case 20:
                n.mode = 21;
              case 21:
                if (6 <= s && 258 <= l) {
                  e.next_out = a, e.avail_out = l, e.next_in = o, e.avail_in = s, n.hold = u, n.bits = c, IA(e, h), a = e.next_out, i = e.output, l = e.avail_out, o = e.next_in, r = e.input, s = e.avail_in, u = n.hold, c = n.bits, 12 === n.mode && (n.back = -1);
                  break;
                }
                for (n.back = 0; v = (T = n.lencode[u & (1 << n.lenbits) - 1]) >>> 16 & 255, y = 65535 & T, !((g = T >>> 24) <= c);) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                if (v && 0 == (240 & v)) {
                  for (b = g, _ = v, x = y; v = (T = n.lencode[x + ((u & (1 << b + _) - 1) >> b)]) >>> 16 & 255, y = 65535 & T, !(b + (g = T >>> 24) <= c);) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  u >>>= b, c -= b, n.back += b;
                }
                if (u >>>= g, c -= g, n.back += g, n.length = y, 0 === v) {
                  n.mode = 26;
                  break;
                }
                if (32 & v) {
                  n.back = -1, n.mode = 12;
                  break;
                }
                if (64 & v) {
                  e.msg = "invalid literal/length code", n.mode = 30;
                  break;
                }
                n.extra = 15 & v, n.mode = 22;
              case 22:
                if (n.extra) {
                  for (E = n.extra; c < E;) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  n.length += u & (1 << n.extra) - 1, u >>>= n.extra, c -= n.extra, n.back += n.extra;
                }
                n.was = n.length, n.mode = 23;
              case 23:
                for (; v = (T = n.distcode[u & (1 << n.distbits) - 1]) >>> 16 & 255, y = 65535 & T, !((g = T >>> 24) <= c);) {
                  if (0 === s) break e;
                  s--, u += r[o++] << c, c += 8;
                }
                if (0 == (240 & v)) {
                  for (b = g, _ = v, x = y; v = (T = n.distcode[x + ((u & (1 << b + _) - 1) >> b)]) >>> 16 & 255, y = 65535 & T, !(b + (g = T >>> 24) <= c);) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  u >>>= b, c -= b, n.back += b;
                }
                if (u >>>= g, c -= g, n.back += g, 64 & v) {
                  e.msg = "invalid distance code", n.mode = 30;
                  break;
                }
                n.offset = y, n.extra = 15 & v, n.mode = 24;
              case 24:
                if (n.extra) {
                  for (E = n.extra; c < E;) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  n.offset += u & (1 << n.extra) - 1, u >>>= n.extra, c -= n.extra, n.back += n.extra;
                }
                if (n.offset > n.dmax) {
                  e.msg = "invalid distance too far back", n.mode = 30;
                  break;
                }
                n.mode = 25;
              case 25:
                if (0 === l) break e;
                if (f = h - l, n.offset > f) {
                  if ((f = n.offset - f) > n.whave && n.sane) {
                    e.msg = "invalid distance too far back", n.mode = 30;
                    break;
                  }
                  f > n.wnext ? (f -= n.wnext, p = n.wsize - f) : p = n.wnext - f, f > n.length && (f = n.length), m = n.window;
                } else m = i, p = a - n.offset, f = n.length;
                for (l < f && (f = l), l -= f, n.length -= f; i[a++] = m[p++], --f;);
                0 === n.length && (n.mode = 21);
                break;
              case 26:
                if (0 === l) break e;
                i[a++] = n.length, l--, n.mode = 21;
                break;
              case 27:
                if (n.wrap) {
                  for (; c < 32;) {
                    if (0 === s) break e;
                    s--, u |= r[o++] << c, c += 8;
                  }
                  if (h -= l, e.total_out += h, n.total += h, h && (e.adler = n.check = n.flags ? RA(n.check, i, h, a - h) : PA(n.check, i, h, a - h)), h = l, (n.flags ? u : FA(u)) !== n.check) {
                    e.msg = "incorrect data check", n.mode = 30;
                    break;
                  }
                  c = u = 0;
                }
                n.mode = 28;
              case 28:
                if (n.wrap && n.flags) {
                  for (; c < 32;) {
                    if (0 === s) break e;
                    s--, u += r[o++] << c, c += 8;
                  }
                  if (u !== (4294967295 & n.total)) {
                    e.msg = "incorrect length check", n.mode = 30;
                    break;
                  }
                  c = u = 0;
                }
                n.mode = 29;
              case 29:
                S = 1;
                break e;
              case 30:
                S = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return -2;
            }
            return e.next_out = a, e.avail_out = l, e.next_in = o, e.avail_in = s, n.hold = u, n.bits = c, (n.wsize || h !== e.avail_out && n.mode < 30 && (n.mode < 27 || 4 !== t)) && WA(e, e.output, e.next_out, h - e.avail_out), d -= e.avail_in, h -= e.avail_out, e.total_in += d, e.total_out += h, n.total += h, n.wrap && h && (e.adler = n.check = n.flags ? RA(n.check, i, h, e.next_out - h) : PA(n.check, i, h, e.next_out - h)), e.data_type = n.bits + (n.last ? 64 : 0) + (12 === n.mode ? 128 : 0) + (20 === n.mode || 15 === n.mode ? 256 : 0), (0 === d && 0 === h || 4 === t) && 0 === S && (S = -5), S;
          }
          var XA = !0,
            YA = !0;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch (r) {
            XA = !1;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch (r) {
            YA = !1;
          }
          for (var KA = new Uint8Array(256), ZA = 0; ZA < 256; ZA++) KA[ZA] = 252 <= ZA ? 6 : 248 <= ZA ? 5 : 240 <= ZA ? 4 : 224 <= ZA ? 3 : 192 <= ZA ? 2 : 1;
          function QA(e) {
            var t,
              n,
              r,
              i,
              o,
              a = e.length,
              s = 0;
            for (i = 0; i < a; i++) 55296 == (64512 & (n = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (r = e.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++), s += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
            for (t = new Uint8Array(s), i = o = 0; o < s; i++) 55296 == (64512 & (n = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (r = e.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++), n < 128 ? t[o++] = n : (n < 2048 ? t[o++] = 192 | n >>> 6 : (n < 65536 ? t[o++] = 224 | n >>> 12 : (t[o++] = 240 | n >>> 18, t[o++] = 128 | n >>> 12 & 63), t[o++] = 128 | n >>> 6 & 63), t[o++] = 128 | 63 & n);
            return t;
          }
          function JA(e, t) {
            var n,
              r,
              i,
              o,
              a = t || e.length,
              s = new Array(2 * a);
            for (n = r = 0; n < a;) if ((i = e[n++]) < 128) s[r++] = i;else if (4 < (o = KA[i])) s[r++] = 65533, n += o - 1;else {
              for (i &= 2 === o ? 31 : 3 === o ? 15 : 7; 1 < o && n < a;) i = i << 6 | 63 & e[n++], o--;
              1 < o ? s[r++] = 65533 : i < 65536 ? s[r++] = i : (i -= 65536, s[r++] = 55296 | i >> 10 & 1023, s[r++] = 56320 | 1023 & i);
            }
            return function (e, t) {
              if (t < 65537 && (e.subarray && YA || !e.subarray && XA)) return String.fromCharCode.apply(null, CA(e, t));
              for (var n = "", r = 0; r < t; r++) n += String.fromCharCode(e[r]);
              return n;
            }(s, r);
          }
          function eE(e, t) {
            var n;
            for ((t = t || e.length) > e.length && (t = e.length), n = t - 1; 0 <= n && 128 == (192 & e[n]);) n--;
            return n < 0 || 0 === n ? t : n + KA[e[n]] > t ? n : t;
          }
          KA[254] = KA[254] = 1;
          var tE = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version"
          };
          function nE() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          }
          function rE() {
            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
          }
          var iE = Object.prototype.toString;
          function oE(e) {
            if (!(this instanceof oE)) return new oE(e);
            this.options = function (e) {
              for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
                var n = t.shift();
                if (n) {
                  if ("object" != typeof n) throw new TypeError(n + "must be non-object");
                  for (var r in n) n.hasOwnProperty(r) && (e[r] = n[r]);
                }
              }
              return e;
            }({
              chunkSize: 16384,
              windowBits: 0,
              to: ""
            }, e || {});
            var t = this.options;
            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new nE(), this.strm.avail_out = 0;
            var n,
              r,
              i,
              o = UA(this.strm, t.windowBits);
            if (0 !== o) throw new Error(tE[o]);
            this.header = new rE(), n = this.strm, r = this.header, n && n.state && (0 == (2 & (i = n.state).wrap) || ((i.head = r).done = !1));
          }
          oE.prototype.push = function (e, t) {
            var n,
              r,
              i,
              o,
              a,
              s,
              l,
              u,
              c,
              d,
              h = this.strm,
              f = this.options.chunkSize,
              p = this.options.dictionary,
              m = !1;
            if (this.ended) return !1;
            r = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? h.input = function (e) {
              for (var t = new Uint8Array(e.length), n = 0, r = t.length; n < r; n++) t[n] = e.charCodeAt(n);
              return t;
            }(e) : "[object ArrayBuffer]" === iE.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
            do {
              if (0 === h.avail_out && (h.output = new Uint8Array(f), h.next_out = 0, h.avail_out = f), 2 === (n = $A(h, 0)) && p && (s = "string" == typeof p ? QA(p) : "[object ArrayBuffer]" === iE.call(p) ? new Uint8Array(p) : p, l = this.strm, c = void 0, d = (u = s).length, n = l && l.state ? 0 !== (c = l.state).wrap && 11 !== c.mode ? -2 : 11 === c.mode && PA(1, u, d, 0) !== c.check ? -3 : WA(l, u, d, d) ? (c.mode = 31, -4) : (c.havedict = 1, 0) : -2), -5 === n && !0 === m && (n = 0, m = !1), 1 !== n && 0 !== n) return this.onEnd(n), !(this.ended = !0);
              h.next_out && (0 !== h.avail_out && 1 !== n && (0 !== h.avail_in || 4 !== r && 2 !== r) || ("string" === this.options.to ? (i = eE(h.output, h.next_out), o = h.next_out - i, a = JA(h.output, i), h.next_out = o, h.avail_out = f - o, o && kA(h.output, h.output, i, o, 0), this.onData(a)) : this.onData(CA(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (m = !0);
            } while ((0 < h.avail_in || 0 === h.avail_out) && 1 !== n);
            return 1 === n && (r = 4), 4 === r ? (n = function (e) {
              if (!e || !e.state) return -2;
              var t = e.state;
              return t.window && (t.window = null), e.state = null, 0;
            }(this.strm), this.onEnd(n), this.ended = !0, 0 === n) : 2 !== r || (this.onEnd(0), !(h.avail_out = 0));
          }, oE.prototype.onData = function (e) {
            this.chunks.push(e);
          }, oE.prototype.onEnd = function (e) {
            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = function (e) {
              var t, n, r, i, o, a;
              for (t = r = 0, n = e.length; t < n; t++) r += e[t].length;
              for (a = new Uint8Array(r), t = i = 0, n = e.length; t < n; t++) o = e[t], a.set(o, i), i += o.length;
              return a;
            }(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
          }, ad.add("gz", function (e) {
            var t;
            e instanceof ArrayBuffer && (e = new Uint8Array(e));
            try {
              t = function (e, t) {
                var n = new oE(void 0);
                if (n.push(e, !0), n.err) throw n.msg;
                return n.result;
              }(e);
            } catch (n) {
              t = e;
            }
            return t;
          });
          var aE = function aE() {},
            sE = "//mmtf.rcsb.org/v1.0/full/",
            lE = function (e) {
              function t() {
                e.apply(this, arguments);
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.getUrl = function (e) {
                var t,
                  n = vd(e),
                  r = n.name.substr(0, 4);
                return !["pdb", "cif"].includes(n.ext) || !1 !== n.compressed && "gz" !== n.compressed ? "mmtf" === n.ext ? t = n.base.endsWith(".bb") ? "//mmtf.rcsb.org/v1.0/reduced/" + r : sE + r : (n.ext && Zc.warn("unsupported ext", n.ext), t = sE + r) : t = "//files.rcsb.org/download/" + n.path, Eu() + t;
              }, t.prototype.getExt = function (e) {
                return vd(e).ext || "mmtf";
              }, t;
            }(aE);
          nd.add("rcsb", new lE());
          var uE = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.getUrl = function (e) {
              var t,
                n = vd(e),
                r = n.name;
              return n.ext && "sdf" !== n.ext && Zc.warn("unsupported ext", n.ext), t = "//pubchem.ncbi.nlm.nih.gov/rest/pug/compound/cid/" + r + "/SDF?record_type=3d", Eu() + t;
            }, t.prototype.getExt = function (e) {
              return vd(e).ext || "sdf";
            }, t;
          }(aE);
          nd.add("pubchem", new uE());
          var cE = function (e) {
            function t() {
              e.apply(this, arguments);
            }
            return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.getUrl = function (e) {
              return e;
            }, t.prototype.getExt = function (e) {
              return vd(e).ext;
            }, t;
          }(aE);
          nd.add("ftp", new cE()), nd.add("http", new cE()), nd.add("https", new cE());
          var dE = /^((http|https|ftp):)*\/\//,
            hE = function (e) {
              function t(t) {
                void 0 === t && (t = ""), e.call(this), this.baseUrl = t;
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.getUrl = function (e) {
                var t,
                  n,
                  r,
                  i,
                  o = vd(e),
                  a = this.baseUrl + o.path;
                return dE.test(this.baseUrl) || (t = a, i = (r = (n = window.location).pathname).substring(0, r.lastIndexOf("/") + 1), a = n.origin + i + t), a;
              }, t.prototype.getExt = function (e) {
                return vd(e).ext;
              }, t;
            }(aE),
            fE = function (e) {
              function t(t) {
                void 0 === t && (t = ""), e.call(this), this.baseUrl = t;
              }
              return e && (t.__proto__ = e), ((t.prototype = Object.create(e && e.prototype)).constructor = t).prototype.getListing = function (e) {
                void 0 === e && (e = "");
                var t = this.baseUrl + "dir/" + e;
                return "/" !== t[t.length - 1] && (t += "/"), bd(t, {
                  ext: "json"
                }).then(function (t) {
                  return {
                    path: e,
                    data: t.data
                  };
                });
              }, t.prototype.getUrl = function (e) {
                var t = vd(e);
                return this.baseUrl + "file/" + t.path + t.query;
              }, t.prototype.getCountUrl = function (e) {
                var t = vd(e);
                return this.baseUrl + "traj/numframes/" + t.path + t.query;
              }, t.prototype.getFrameUrl = function (e, t) {
                var n = vd(e);
                return this.baseUrl + "traj/frame/" + t + "/" + n.path + n.query;
              }, t.prototype.getFrameParams = function (e, t) {
                return "atomIndices=" + t.join(";");
              }, t.prototype.getPathUrl = function (e, t) {
                var n = vd(e);
                return this.baseUrl + "traj/path/" + t + "/" + n.path + n.query;
              }, t.prototype.getExt = function (e) {
                return vd(e).ext;
              }, t;
            }(aE);
          function pE(e, t) {
            return {
              type: "integer",
              max: e,
              min: t
            };
          }
          function mE(e, t, n) {
            return {
              type: "number",
              precision: e,
              max: t,
              min: n
            };
          }
          function gE(e, t, n) {
            return {
              type: "range",
              step: e,
              max: t,
              min: n
            };
          }
          function vE() {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            return {
              type: "select",
              options: e.reduce(function (e, t) {
                var n;
                return Object.assign({}, e, ((n = {})[t] = t, n));
              }, {})
            };
          }
          var yE = {
            backgroundColor: {
              type: "color"
            },
            quality: vE("auto", "low", "medium", "high"),
            sampleLevel: gE(1, 5, -1),
            impostor: {
              type: "boolean"
            },
            workerDefault: {
              type: "boolean"
            },
            rotateSpeed: mE(1, 10, 0),
            zoomSpeed: mE(1, 10, 0),
            panSpeed: mE(1, 10, 0),
            clipNear: gE(1, 100, 0),
            clipFar: gE(1, 100, 0),
            clipDist: pE(200, 0),
            clipMode: vE("scene", "camera"),
            clipScale: vE("relative", "absolute"),
            fogNear: gE(1, 100, 0),
            fogFar: gE(1, 100, 0),
            fogMode: vE("scene", "camera"),
            fogScale: vE("relative", "absolute"),
            cameraType: vE("perspective", "orthographic", "stereo"),
            cameraEyeSep: mE(3, 1, .01),
            cameraFov: gE(1, 120, 15),
            lightColor: {
              type: "color"
            },
            lightIntensity: mE(2, 10, 0),
            ambientColor: {
              type: "color"
            },
            ambientIntensity: mE(2, 10, 0),
            hoverTimeout: pE(1e4, -1),
            tooltip: {
              type: "boolean"
            },
            mousePreset: vE.apply(void 0, Object.keys(vg))
          };
          window.Promise || (window.Promise = f), t.Version = "2.0.0-dev.37", t.StaticDatasource = hE, t.MdsrvDatasource = fE, t.Colormaker = oc, t.Selection = Nc, t.PdbWriter = wd, t.SdfWriter = Sd, t.StlWriter = Td, t.Stage = yb, t.Collection = Vy, t.ComponentCollection = pb, t.RepresentationCollection = qy, t.Component = Uy, t.ShapeComponent = bb, t.StructureComponent = db, t.SurfaceComponent = hb, t.VolumeComponent = fb, t.Assembly = sv, t.TrajectoryPlayer = Qy, t.Superposition = Ky, t.Frames = Xy, t.Queue = sf, t.Counter = Md, t.BufferRepresentation = ly, t.ArrowBuffer = kx, t.BoxBuffer = Nx, t.ConeBuffer = Tx, t.CylinderBuffer = A_, t.EllipsoidBuffer = Ux, t.MeshBuffer = lg, t.OctahedronBuffer = Wx, t.PointBuffer = Sy, t.SphereBuffer = _y, t.TetrahedronBuffer = Zx, t.TextBuffer = a_, t.TorusBuffer = rw, t.WidelineBuffer = u_, t.Shape = ay, t.Structure = ty, t.Kdtree = nv, t.SpatialHash = Zf, t.MolecularSurface = ox, t.Volume = Jm, t.MouseActions = gg, t.KeyActions = _g, t.setDebug = function (e) {
            t.Debug = e;
          }, t.MeasurementDefaultParams = Qc, t.setMeasurementDefaultParams = function (e) {
            void 0 === e && (e = {}), Object.assign(Qc, e);
          }, t.ScriptExtensions = Jc, t.ColormakerRegistry = td, t.DatasourceRegistry = nd, t.DecompressorRegistry = ad, t.ParserRegistry = id, t.RepresentationRegistry = rd, t.setListingDatasource = function (e) {
            t.ListingDatasource = e;
          }, t.setTrajectoryDatasource = function (e) {
            t.TrajectoryDatasource = e;
          }, t.autoLoad = bd, t.getDataInfo = yd, t.getFileInfo = vd, t.superpose = ub, t.guessElement = Tv, t.concatStructures = function (e) {
            for (var n = [], r = arguments.length - 1; 0 < r--;) n[r] = arguments[r + 1];
            t.Debug && Zc.time("concatStructures");
            var i = new ty(e, ""),
              o = new dv(i),
              a = i.atomStore,
              s = i.atomMap;
            a.addField("formalCharge", 1, "int8"), a.addField("partialCharge", 1, "float32");
            var l = {},
              u = 0,
              c = 0,
              d = 0;
            n.forEach(function (e) {
              e.eachAtom(function (e) {
                a.growIfFull(), a.atomTypeId[u] = s.add(e.atomname, e.element), a.x[u] = e.x, a.y[u] = e.y, a.z[u] = e.z, a.serial[u] = e.serial, a.formalCharge[u] = e.formalCharge, a.partialCharge[u] = e.partialCharge, a.altloc[u] = e.altloc, a.occupancy[u] = e.occupancy, a.bfactor[u] = e.bfactor, o.addAtom(e.modelIndex + d, e.chainname, e.chainid, e.resname, e.resno, 1 === e.hetero, e.sstruc, e.inscode), l[e.index + c] = u, u += 1;
              }), c += e.atomStore.count, d += e.modelStore.count;
            });
            var h = i.bondStore,
              f = i.getAtomProxy(),
              p = i.getAtomProxy();
            return c = 0, n.forEach(function (e) {
              e.eachBond(function (e) {
                f.index = l[e.atomIndex1 + c], p.index = l[e.atomIndex2 + c], h.addBond(f, p, e.bondOrder);
              }), c += e.atomStore.count;
            }), o.finalize(), wv(i, !0), xv(i, !0), i.finalizeAtoms(), i.finalizeBonds(), Mv(i), t.Debug && Zc.timeEnd("concatStructures"), i;
          }, t.flatten = function e(t, n) {
            n = wu(n, []);
            for (var r = 0; r < t.length; r++) Array.isArray(t[r]) ? e(t[r], n) : n.push(t[r]);
            return n;
          }, t.throttle = function (e, t, n) {
            var r,
              i,
              o,
              a = null,
              s = 0;
            function l() {
              s = !1 === n.leading ? 0 : Date.now(), a = null, o = e.apply(r, i), a || (r = i = null);
            }
            return n || (n = {}), function () {
              var u = Date.now();
              s || !1 !== n.leading || (s = u);
              var c = t - (u - s);
              return r = this, i = arguments, c <= 0 || t < c ? (a && (clearTimeout(a), a = null), s = u, o = e.apply(r, i), a || (r = i = null)) : a || !1 === n.trailing || (a = setTimeout(l, c)), o;
            };
          }, t.download = Cu, t.getQuery = xu, t.uniqueArray = Ru, t.LeftMouseButton = 1, t.MiddleMouseButton = 2, t.RightMouseButton = 3, t.Signal = lc, t.Matrix3 = se, t.Matrix4 = ie, t.Vector2 = re, t.Vector3 = ae, t.Box3 = Oe, t.Quaternion = oe, t.Euler = We, t.Plane = Ie, t.Color = Fe, t.UIStageParameters = yE, Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }(t);
      }).call(this, n("./node_modules/timers-browserify/main.js").setImmediate, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/object-assign/index.js": function node_modulesObjectAssignIndexJs(e, t, n) {
      "use strict";

      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
      var r = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable;
      function a(e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }
      e.exports = function () {
        try {
          if (!Object.assign) return !1;
          var e = new String("abc");
          if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
          for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
          if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
            return t[e];
          }).join("")) return !1;
          var r = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (e) {
            r[e] = e;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
        } catch (e) {
          return !1;
        }
      }() ? Object.assign : function (e, t) {
        for (var n, s, l = a(e), u = 1; u < arguments.length; u++) {
          for (var c in n = Object(arguments[u])) i.call(n, c) && (l[c] = n[c]);
          if (r) {
            s = r(n);
            for (var d = 0; d < s.length; d++) o.call(n, s[d]) && (l[s[d]] = n[s[d]]);
          }
        }
        return l;
      };
    },
    "./node_modules/object-is/index.js": function node_modulesObjectIsIndexJs(e, t, n) {
      "use strict";

      var r = function r(e) {
        return e != e;
      };
      e.exports = function (e, t) {
        return 0 === e && 0 === t ? 1 / e == 1 / t : e === t || !(!r(e) || !r(t));
      };
    },
    "./node_modules/object-keys/implementation.js": function node_modulesObjectKeysImplementationJs(e, t, n) {
      "use strict";

      var r;
      if (!Object.keys) {
        var i = Object.prototype.hasOwnProperty,
          o = Object.prototype.toString,
          a = n("./node_modules/object-keys/isArguments.js"),
          s = Object.prototype.propertyIsEnumerable,
          l = !s.call({
            toString: null
          }, "toString"),
          u = s.call(function () {}, "prototype"),
          c = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
          d = function d(e) {
            var t = e.constructor;
            return t && t.prototype === e;
          },
          h = {
            $applicationCache: !0,
            $console: !0,
            $external: !0,
            $frame: !0,
            $frameElement: !0,
            $frames: !0,
            $innerHeight: !0,
            $innerWidth: !0,
            $onmozfullscreenchange: !0,
            $onmozfullscreenerror: !0,
            $outerHeight: !0,
            $outerWidth: !0,
            $pageXOffset: !0,
            $pageYOffset: !0,
            $parent: !0,
            $scrollLeft: !0,
            $scrollTop: !0,
            $scrollX: !0,
            $scrollY: !0,
            $self: !0,
            $webkitIndexedDB: !0,
            $webkitStorageInfo: !0,
            $window: !0
          },
          f = function () {
            if ("undefined" == typeof window) return !1;
            for (var e in window) try {
              if (!h["$" + e] && i.call(window, e) && null !== window[e] && "object" == typeof window[e]) try {
                d(window[e]);
              } catch (e) {
                return !0;
              }
            } catch (e) {
              return !0;
            }
            return !1;
          }();
        r = function r(e) {
          var t = null !== e && "object" == typeof e,
            n = "[object Function]" === o.call(e),
            r = a(e),
            s = t && "[object String]" === o.call(e),
            h = [];
          if (!t && !n && !r) throw new TypeError("Object.keys called on a non-object");
          var p = u && n;
          if (s && e.length > 0 && !i.call(e, 0)) for (var m = 0; m < e.length; ++m) h.push(String(m));
          if (r && e.length > 0) for (var g = 0; g < e.length; ++g) h.push(String(g));else for (var v in e) p && "prototype" === v || !i.call(e, v) || h.push(String(v));
          if (l) for (var y = function (e) {
              if ("undefined" == typeof window || !f) return d(e);
              try {
                return d(e);
              } catch (e) {
                return !1;
              }
            }(e), b = 0; b < c.length; ++b) y && "constructor" === c[b] || !i.call(e, c[b]) || h.push(c[b]);
          return h;
        };
      }
      e.exports = r;
    },
    "./node_modules/object-keys/index.js": function node_modulesObjectKeysIndexJs(e, t, n) {
      "use strict";

      var r = Array.prototype.slice,
        i = n("./node_modules/object-keys/isArguments.js"),
        o = Object.keys,
        a = o ? function (e) {
          return o(e);
        } : n("./node_modules/object-keys/implementation.js"),
        s = Object.keys;
      a.shim = function () {
        Object.keys ? function () {
          var e = Object.keys(arguments);
          return e && e.length === arguments.length;
        }(1, 2) || (Object.keys = function (e) {
          return i(e) ? s(r.call(e)) : s(e);
        }) : Object.keys = a;
        return Object.keys || a;
      }, e.exports = a;
    },
    "./node_modules/object-keys/isArguments.js": function node_modulesObjectKeysIsArgumentsJs(e, t, n) {
      "use strict";

      var r = Object.prototype.toString;
      e.exports = function (e) {
        var t = r.call(e),
          n = "[object Arguments]" === t;
        return n || (n = "[object Array]" !== t && null !== e && "object" == typeof e && "number" == typeof e.length && e.length >= 0 && "[object Function]" === r.call(e.callee)), n;
      };
    },
    "./node_modules/papaparse/papaparse.min.js": function node_modulesPapaparsePapaparseMinJs(e, t, n) {
      var r, i, o;
      /* @license
      Papa Parse
      v5.1.1
      https://github.com/mholt/PapaParse
      License: MIT
      */
      i = [], void 0 === (o = "function" == typeof (r = function e() {
        "use strict";

        var t = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== t ? t : {},
          n = !t.document && !!t.postMessage,
          r = n && /blob:/i.test((t.location || {}).protocol),
          i = {},
          o = 0,
          a = {
            parse: function parse(n, r) {
              var s = (r = r || {}).dynamicTyping || !1;
              if (x(s) && (r.dynamicTypingFunction = s, s = {}), r.dynamicTyping = s, r.transform = !!x(r.transform) && r.transform, r.worker && a.WORKERS_SUPPORTED) {
                var l = function () {
                  if (!a.WORKERS_SUPPORTED) return !1;
                  var n,
                    r,
                    s = (n = t.URL || t.webkitURL || null, r = e.toString(), a.BLOB_URL || (a.BLOB_URL = n.createObjectURL(new Blob(["(", r, ")();"], {
                      type: "text/javascript"
                    })))),
                    l = new t.Worker(s);
                  return l.onmessage = g, l.id = o++, i[l.id] = l;
                }();
                return l.userStep = r.step, l.userChunk = r.chunk, l.userComplete = r.complete, l.userError = r.error, r.step = x(r.step), r.chunk = x(r.chunk), r.complete = x(r.complete), r.error = x(r.error), delete r.worker, void l.postMessage({
                  input: n,
                  config: r,
                  workerId: l.id
                });
              }
              var f = null;
              return a.NODE_STREAM_INPUT, "string" == typeof n ? f = r.download ? new u(r) : new d(r) : !0 === n.readable && x(n.read) && x(n.on) ? f = new h(r) : (t.File && n instanceof File || n instanceof Object) && (f = new c(r)), f.stream(n);
            },
            unparse: function unparse(e, t) {
              var n = !1,
                r = !0,
                i = ",",
                o = "\r\n",
                s = '"',
                l = s + s,
                u = !1,
                c = null;
              !function () {
                if ("object" == typeof t) {
                  if ("string" != typeof t.delimiter || a.BAD_DELIMITERS.filter(function (e) {
                    return -1 !== t.delimiter.indexOf(e);
                  }).length || (i = t.delimiter), ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (u = t.skipEmptyLines), "string" == typeof t.newline && (o = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (r = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    c = t.columns;
                  }
                  void 0 !== t.escapeChar && (l = t.escapeChar + s);
                }
              }();
              var d = new RegExp(p(s), "g");
              if ("string" == typeof e && (e = JSON.parse(e)), Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return f(null, e, u);
                if ("object" == typeof e[0]) return f(c || h(e[0]), e, u);
              } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : h(e.data[0])), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [e.data])), f(e.fields || [], e.data || [], u);
              throw new Error("Unable to serialize unrecognized input");
              function h(e) {
                if ("object" != typeof e) return [];
                var t = [];
                for (var n in e) t.push(n);
                return t;
              }
              function f(e, t, n) {
                var a = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var s = Array.isArray(e) && 0 < e.length,
                  l = !Array.isArray(t[0]);
                if (s && r) {
                  for (var u = 0; u < e.length; u++) 0 < u && (a += i), a += m(e[u], u);
                  0 < t.length && (a += o);
                }
                for (var c = 0; c < t.length; c++) {
                  var d = s ? e.length : t[c].length,
                    h = !1,
                    f = s ? 0 === Object.keys(t[c]).length : 0 === t[c].length;
                  if (n && !s && (h = "greedy" === n ? "" === t[c].join("").trim() : 1 === t[c].length && 0 === t[c][0].length), "greedy" === n && s) {
                    for (var p = [], g = 0; g < d; g++) {
                      var v = l ? e[g] : g;
                      p.push(t[c][v]);
                    }
                    h = "" === p.join("").trim();
                  }
                  if (!h) {
                    for (var y = 0; y < d; y++) {
                      0 < y && !f && (a += i);
                      var b = s && l ? e[y] : y;
                      a += m(t[c][b], y);
                    }
                    c < t.length - 1 && (!n || 0 < d && !f) && (a += o);
                  }
                }
                return a;
              }
              function m(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = e.toString().replace(d, l);
                return "boolean" == typeof n && n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function (e, t) {
                  for (var n = 0; n < t.length; n++) if (-1 < e.indexOf(t[n])) return !0;
                  return !1;
                }(r, a.BAD_DELIMITERS) || -1 < r.indexOf(i) || " " === r.charAt(0) || " " === r.charAt(r.length - 1) ? s + r + s : r;
              }
            }
          };
        if (a.RECORD_SEP = String.fromCharCode(30), a.UNIT_SEP = String.fromCharCode(31), a.BYTE_ORDER_MARK = "\uFEFF", a.BAD_DELIMITERS = ["\r", "\n", '"', a.BYTE_ORDER_MARK], a.WORKERS_SUPPORTED = !n && !!t.Worker, a.NODE_STREAM_INPUT = 1, a.LocalChunkSize = 10485760, a.RemoteChunkSize = 5242880, a.DefaultDelimiter = ",", a.Parser = m, a.ParserHandle = f, a.NetworkStreamer = u, a.FileStreamer = c, a.StringStreamer = d, a.ReadableStreamStreamer = h, t.jQuery) {
          var s = t.jQuery;
          s.fn.parse = function (e) {
            var n = e.config || {},
              r = [];
            return this.each(function (e) {
              if ("INPUT" !== s(this).prop("tagName").toUpperCase() || "file" !== s(this).attr("type").toLowerCase() || !t.FileReader || !this.files || 0 === this.files.length) return !0;
              for (var i = 0; i < this.files.length; i++) r.push({
                file: this.files[i],
                inputElem: this,
                instanceConfig: s.extend({}, n)
              });
            }), i(), this;
            function i() {
              if (0 !== r.length) {
                var t,
                  n,
                  i,
                  l = r[0];
                if (x(e.before)) {
                  var u = e.before(l.file, l.inputElem);
                  if ("object" == typeof u) {
                    if ("abort" === u.action) return t = l.file, n = l.inputElem, i = u.reason, void (x(e.error) && e.error({
                      name: "AbortError"
                    }, t, n, i));
                    if ("skip" === u.action) return void o();
                    "object" == typeof u.config && (l.instanceConfig = s.extend(l.instanceConfig, u.config));
                  } else if ("skip" === u) return void o();
                }
                var c = l.instanceConfig.complete;
                l.instanceConfig.complete = function (e) {
                  x(c) && c(e, l.file, l.inputElem), o();
                }, a.parse(l.file, l.instanceConfig);
              } else x(e.complete) && e.complete();
            }
            function o() {
              r.splice(0, 1), i();
            }
          };
        }
        function l(e) {
          this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
          }, function (e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null), this._handle = new f(t), (this._handle.streamer = this)._config = t;
          }.call(this, e), this.parseChunk = function (e, n) {
            if (this.isFirstChunk && x(this._config.beforeFirstChunk)) {
              var i = this._config.beforeFirstChunk(e);
              void 0 !== i && (e = i);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var o = this._partialLine + e;
            this._partialLine = "";
            var s = this._handle.parse(o, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
              var l = s.meta.cursor;
              this._finished || (this._partialLine = o.substring(l - this._baseIndex), this._baseIndex = l), s && s.data && (this._rowCount += s.data.length);
              var u = this._finished || this._config.preview && this._rowCount >= this._config.preview;
              if (r) t.postMessage({
                results: s,
                workerId: a.WORKER_ID,
                finished: u
              });else if (x(this._config.chunk) && !n) {
                if (this._config.chunk(s, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                s = void 0, this._completeResults = void 0;
              }
              return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(s.data), this._completeResults.errors = this._completeResults.errors.concat(s.errors), this._completeResults.meta = s.meta), this._completed || !u || !x(this._config.complete) || s && s.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), u || s && s.meta.paused || this._nextChunk(), s;
            }
            this._halted = !0;
          }, this._sendError = function (e) {
            x(this._config.error) ? this._config.error(e) : r && this._config.error && t.postMessage({
              workerId: a.WORKER_ID,
              error: e,
              finished: !1
            });
          };
        }
        function u(e) {
          var t;
          (e = e || {}).chunkSize || (e.chunkSize = a.RemoteChunkSize), l.call(this, e), this._nextChunk = n ? function () {
            this._readChunk(), this._chunkLoaded();
          } : function () {
            this._readChunk();
          }, this.stream = function (e) {
            this._input = e, this._nextChunk();
          }, this._readChunk = function () {
            if (this._finished) this._chunkLoaded();else {
              if (t = new XMLHttpRequest(), this._config.withCredentials && (t.withCredentials = this._config.withCredentials), n || (t.onload = _(this._chunkLoaded, this), t.onerror = _(this._chunkError, this)), t.open("GET", this._input, !n), this._config.downloadRequestHeaders) {
                var e = this._config.downloadRequestHeaders;
                for (var r in e) t.setRequestHeader(r, e[r]);
              }
              if (this._config.chunkSize) {
                var i = this._start + this._config.chunkSize - 1;
                t.setRequestHeader("Range", "bytes=" + this._start + "-" + i);
              }
              try {
                t.send();
              } catch (e) {
                this._chunkError(e.message);
              }
              n && 0 === t.status && this._chunkError();
            }
          }, this._chunkLoaded = function () {
            4 === t.readyState && (t.status < 200 || 400 <= t.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : t.responseText.length, this._finished = !this._config.chunkSize || this._start >= function (e) {
              var t = e.getResponseHeader("Content-Range");
              return null === t ? -1 : parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(t), this.parseChunk(t.responseText)));
          }, this._chunkError = function (e) {
            var n = t.statusText || e;
            this._sendError(new Error(n));
          };
        }
        function c(e) {
          var t, n;
          (e = e || {}).chunkSize || (e.chunkSize = a.LocalChunkSize), l.call(this, e);
          var r = "undefined" != typeof FileReader;
          this.stream = function (e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, r ? ((t = new FileReader()).onload = _(this._chunkLoaded, this), t.onerror = _(this._chunkError, this)) : t = new FileReaderSync(), this._nextChunk();
          }, this._nextChunk = function () {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
          }, this._readChunk = function () {
            var e = this._input;
            if (this._config.chunkSize) {
              var i = Math.min(this._start + this._config.chunkSize, this._input.size);
              e = n.call(e, this._start, i);
            }
            var o = t.readAsText(e, this._config.encoding);
            r || this._chunkLoaded({
              target: {
                result: o
              }
            });
          }, this._chunkLoaded = function (e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
          }, this._chunkError = function () {
            this._sendError(t.error);
          };
        }
        function d(e) {
          var t;
          l.call(this, e = e || {}), this.stream = function (e) {
            return t = e, this._nextChunk();
          }, this._nextChunk = function () {
            if (!this._finished) {
              var e,
                n = this._config.chunkSize;
              return n ? (e = t.substring(0, n), t = t.substring(n)) : (e = t, t = ""), this._finished = !t, this.parseChunk(e);
            }
          };
        }
        function h(e) {
          l.call(this, e = e || {});
          var t = [],
            n = !0,
            r = !1;
          this.pause = function () {
            l.prototype.pause.apply(this, arguments), this._input.pause();
          }, this.resume = function () {
            l.prototype.resume.apply(this, arguments), this._input.resume();
          }, this.stream = function (e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
          }, this._checkIsFinished = function () {
            r && 1 === t.length && (this._finished = !0);
          }, this._nextChunk = function () {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : n = !0;
          }, this._streamData = _(function (e) {
            try {
              t.push("string" == typeof e ? e : e.toString(this._config.encoding)), n && (n = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
              this._streamError(e);
            }
          }, this), this._streamError = _(function (e) {
            this._streamCleanUp(), this._sendError(e);
          }, this), this._streamEnd = _(function () {
            this._streamCleanUp(), r = !0, this._streamData("");
          }, this), this._streamCleanUp = _(function () {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
          }, this);
        }
        function f(e) {
          var t,
            n,
            r,
            i = Math.pow(2, 53),
            o = -i,
            s = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,
            l = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,
            u = this,
            c = 0,
            d = 0,
            h = !1,
            f = !1,
            g = [],
            v = {
              data: [],
              errors: [],
              meta: {}
            };
          if (x(e.step)) {
            var y = e.step;
            e.step = function (t) {
              if (v = t, S()) w();else {
                if (w(), 0 === v.data.length) return;
                c += t.data.length, e.preview && c > e.preview ? n.abort() : (v.data = v.data[0], y(v, u));
              }
            };
          }
          function _(t) {
            return "greedy" === e.skipEmptyLines ? "" === t.join("").trim() : 1 === t.length && 0 === t[0].length;
          }
          function w() {
            if (v && r && (E("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + a.DefaultDelimiter + "'"), r = !1), e.skipEmptyLines) for (var t = 0; t < v.data.length; t++) _(v.data[t]) && v.data.splice(t--, 1);
            return S() && function () {
              if (v) if (Array.isArray(v.data[0])) {
                for (var t = 0; S() && t < v.data.length; t++) v.data[t].forEach(n);
                v.data.splice(0, 1);
              } else v.data.forEach(n);
              function n(t) {
                x(e.transformHeader) && (t = e.transformHeader(t)), g.push(t);
              }
            }(), function () {
              if (!v || !e.header && !e.dynamicTyping && !e.transform) return v;
              function t(t, n) {
                var r,
                  i = e.header ? {} : [];
                for (r = 0; r < t.length; r++) {
                  var o = r,
                    a = t[r];
                  e.header && (o = r >= g.length ? "__parsed_extra" : g[r]), e.transform && (a = e.transform(a, o)), a = A(o, a), "__parsed_extra" === o ? (i[o] = i[o] || [], i[o].push(a)) : i[o] = a;
                }
                return e.header && (r > g.length ? E("FieldMismatch", "TooManyFields", "Too many fields: expected " + g.length + " fields but parsed " + r, d + n) : r < g.length && E("FieldMismatch", "TooFewFields", "Too few fields: expected " + g.length + " fields but parsed " + r, d + n)), i;
              }
              var n = 1;
              return !v.data.length || Array.isArray(v.data[0]) ? (v.data = v.data.map(t), n = v.data.length) : v.data = t(v.data, 0), e.header && v.meta && (v.meta.fields = g), d += n, v;
            }();
          }
          function S() {
            return e.header && 0 === g.length;
          }
          function A(t, n) {
            return r = t, e.dynamicTypingFunction && void 0 === e.dynamicTyping[r] && (e.dynamicTyping[r] = e.dynamicTypingFunction(r)), !0 === (e.dynamicTyping[r] || e.dynamicTyping) ? "true" === n || "TRUE" === n || "false" !== n && "FALSE" !== n && (function (e) {
              if (s.test(e)) {
                var t = parseFloat(e);
                if (o < t && t < i) return !0;
              }
              return !1;
            }(n) ? parseFloat(n) : l.test(n) ? new Date(n) : "" === n ? null : n) : n;
            var r;
          }
          function E(e, t, n, r) {
            var i = {
              type: e,
              code: t,
              message: n
            };
            void 0 !== r && (i.row = r), v.errors.push(i);
          }
          this.parse = function (i, o, s) {
            var l = e.quoteChar || '"';
            if (e.newline || (e.newline = function (e, t) {
              e = e.substring(0, 1048576);
              var n = new RegExp(p(t) + "([^]*?)" + p(t), "gm"),
                r = (e = e.replace(n, "")).split("\r"),
                i = e.split("\n"),
                o = 1 < i.length && i[0].length < r[0].length;
              if (1 === r.length || o) return "\n";
              for (var a = 0, s = 0; s < r.length; s++) "\n" === r[s][0] && a++;
              return a >= r.length / 2 ? "\r\n" : "\r";
            }(i, l)), r = !1, e.delimiter) x(e.delimiter) && (e.delimiter = e.delimiter(i), v.meta.delimiter = e.delimiter);else {
              var u = function (t, n, r, i, o) {
                var s, l, u, c;
                o = o || [",", "\t", "|", ";", a.RECORD_SEP, a.UNIT_SEP];
                for (var d = 0; d < o.length; d++) {
                  var h = o[d],
                    f = 0,
                    p = 0,
                    g = 0;
                  u = void 0;
                  for (var v = new m({
                      comments: i,
                      delimiter: h,
                      newline: n,
                      preview: 10
                    }).parse(t), y = 0; y < v.data.length; y++) if (r && _(v.data[y])) g++;else {
                    var b = v.data[y].length;
                    p += b, void 0 !== u ? 0 < b && (f += Math.abs(b - u), u = b) : u = b;
                  }
                  0 < v.data.length && (p /= v.data.length - g), (void 0 === l || f <= l) && (void 0 === c || c < p) && 1.99 < p && (l = f, s = h, c = p);
                }
                return {
                  successful: !!(e.delimiter = s),
                  bestDelimiter: s
                };
              }(i, e.newline, e.skipEmptyLines, e.comments, e.delimitersToGuess);
              u.successful ? e.delimiter = u.bestDelimiter : (r = !0, e.delimiter = a.DefaultDelimiter), v.meta.delimiter = e.delimiter;
            }
            var c = b(e);
            return e.preview && e.header && c.preview++, t = i, n = new m(c), v = n.parse(t, o, s), w(), h ? {
              meta: {
                paused: !0
              }
            } : v || {
              meta: {
                paused: !1
              }
            };
          }, this.paused = function () {
            return h;
          }, this.pause = function () {
            h = !0, n.abort(), t = x(e.chunk) ? "" : t.substring(n.getCharIndex());
          }, this.resume = function () {
            u.streamer._halted ? (h = !1, u.streamer.parseChunk(t, !0)) : setTimeout(this.resume, 3);
          }, this.aborted = function () {
            return f;
          }, this.abort = function () {
            f = !0, n.abort(), v.meta.aborted = !0, x(e.complete) && e.complete(v), t = "";
          };
        }
        function p(e) {
          return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        function m(e) {
          var t,
            n = (e = e || {}).delimiter,
            r = e.newline,
            i = e.comments,
            o = e.step,
            s = e.preview,
            l = e.fastMode,
            u = t = void 0 === e.quoteChar ? '"' : e.quoteChar;
          if (void 0 !== e.escapeChar && (u = e.escapeChar), ("string" != typeof n || -1 < a.BAD_DELIMITERS.indexOf(n)) && (n = ","), i === n) throw new Error("Comment character same as delimiter");
          !0 === i ? i = "#" : ("string" != typeof i || -1 < a.BAD_DELIMITERS.indexOf(i)) && (i = !1), "\n" !== r && "\r" !== r && "\r\n" !== r && (r = "\n");
          var c = 0,
            d = !1;
          this.parse = function (e, a, h) {
            if ("string" != typeof e) throw new Error("Input must be a string");
            var f = e.length,
              m = n.length,
              g = r.length,
              v = i.length,
              y = x(o),
              b = [],
              _ = [],
              w = [],
              S = c = 0;
            if (!e) return D();
            if (l || !1 !== l && -1 === e.indexOf(t)) {
              for (var A = e.split(r), E = 0; E < A.length; E++) {
                if (w = A[E], c += w.length, E !== A.length - 1) c += r.length;else if (h) return D();
                if (!i || w.substring(0, v) !== i) {
                  if (y) {
                    if (b = [], I(w.split(n)), B(), d) return D();
                  } else I(w.split(n));
                  if (s && s <= E) return b = b.slice(0, s), D(!0);
                }
              }
              return D();
            }
            for (var T = e.indexOf(n, c), M = e.indexOf(r, c), C = new RegExp(p(u) + p(t), "g"), k = e.indexOf(t, c);;) if (e[c] !== t) {
              if (i && 0 === w.length && e.substring(c, c + v) === i) {
                if (-1 === M) return D();
                c = M + g, M = e.indexOf(r, c), T = e.indexOf(n, c);
              } else {
                if (-1 !== T && (T < M || -1 === M)) {
                  if (!(T < k)) {
                    w.push(e.substring(c, T)), c = T + m, T = e.indexOf(n, c);
                    continue;
                  }
                  var P = F(T, k, M);
                  if (P && void 0 !== P.nextDelim) {
                    T = P.nextDelim, k = P.quoteSearch, w.push(e.substring(c, T)), c = T + m, T = e.indexOf(n, c);
                    continue;
                  }
                }
                if (-1 === M) break;
                if (w.push(e.substring(c, M)), L(M + g), y && (B(), d)) return D();
                if (s && b.length >= s) return D(!0);
              }
            } else for (k = c, c++;;) {
              if (-1 === (k = e.indexOf(t, k + 1))) return h || _.push({
                type: "Quotes",
                code: "MissingQuotes",
                message: "Quoted field unterminated",
                row: b.length,
                index: c
              }), N();
              if (k === f - 1) return N(e.substring(c, k).replace(C, t));
              if (t !== u || e[k + 1] !== u) {
                if (t === u || 0 === k || e[k - 1] !== u) {
                  -1 !== T && T < k + 1 && (T = e.indexOf(n, k + 1)), -1 !== M && M < k + 1 && (M = e.indexOf(r, k + 1));
                  var O = j(-1 === M ? T : Math.min(T, M));
                  if (e[k + 1 + O] === n) {
                    w.push(e.substring(c, k).replace(C, t)), e[c = k + 1 + O + m] !== t && (k = e.indexOf(t, c)), T = e.indexOf(n, c), M = e.indexOf(r, c);
                    break;
                  }
                  var R = j(M);
                  if (e.substring(k + 1 + R, k + 1 + R + g) === r) {
                    if (w.push(e.substring(c, k).replace(C, t)), L(k + 1 + R + g), T = e.indexOf(n, c), k = e.indexOf(t, c), y && (B(), d)) return D();
                    if (s && b.length >= s) return D(!0);
                    break;
                  }
                  _.push({
                    type: "Quotes",
                    code: "InvalidQuotes",
                    message: "Trailing quote on quoted field is malformed",
                    row: b.length,
                    index: c
                  }), k++;
                }
              } else k++;
            }
            return N();
            function I(e) {
              b.push(e), S = c;
            }
            function j(t) {
              var n = 0;
              if (-1 !== t) {
                var r = e.substring(k + 1, t);
                r && "" === r.trim() && (n = r.length);
              }
              return n;
            }
            function N(t) {
              return h || (void 0 === t && (t = e.substring(c)), w.push(t), c = f, I(w), y && B()), D();
            }
            function L(t) {
              c = t, I(w), w = [], M = e.indexOf(r, c);
            }
            function D(e) {
              return {
                data: b,
                errors: _,
                meta: {
                  delimiter: n,
                  linebreak: r,
                  aborted: d,
                  truncated: !!e,
                  cursor: S + (a || 0)
                }
              };
            }
            function B() {
              o(D()), b = [], _ = [];
            }
            function F(r, i, o) {
              var a = {
                  nextDelim: void 0,
                  quoteSearch: void 0
                },
                s = e.indexOf(t, i + 1);
              if (i < r && r < s && (s < o || -1 === o)) {
                var l = e.indexOf(n, s);
                if (-1 === l) return a;
                s < l && (s = e.indexOf(t, s + 1)), a = F(l, s, o);
              } else a = {
                nextDelim: r,
                quoteSearch: i
              };
              return a;
            }
          }, this.abort = function () {
            d = !0;
          }, this.getCharIndex = function () {
            return c;
          };
        }
        function g(e) {
          var t = e.data,
            n = i[t.workerId],
            r = !1;
          if (t.error) n.userError(t.error, t.file);else if (t.results && t.results.data) {
            var o = {
              abort: function abort() {
                r = !0, v(t.workerId, {
                  data: [],
                  errors: [],
                  meta: {
                    aborted: !0
                  }
                });
              },
              pause: y,
              resume: y
            };
            if (x(n.userStep)) {
              for (var a = 0; a < t.results.data.length && (n.userStep({
                data: t.results.data[a],
                errors: t.results.errors,
                meta: t.results.meta
              }, o), !r); a++);
              delete t.results;
            } else x(n.userChunk) && (n.userChunk(t.results, o, t.file), delete t.results);
          }
          t.finished && !r && v(t.workerId, t.results);
        }
        function v(e, t) {
          var n = i[e];
          x(n.userComplete) && n.userComplete(t), n.terminate(), delete i[e];
        }
        function y() {
          throw new Error("Not implemented.");
        }
        function b(e) {
          if ("object" != typeof e || null === e) return e;
          var t = Array.isArray(e) ? [] : {};
          for (var n in e) t[n] = b(e[n]);
          return t;
        }
        function _(e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }
        function x(e) {
          return "function" == typeof e;
        }
        return r && (t.onmessage = function (e) {
          var n = e.data;
          if (void 0 === a.WORKER_ID && n && (a.WORKER_ID = n.workerId), "string" == typeof n.input) t.postMessage({
            workerId: a.WORKER_ID,
            results: a.parse(n.input, n.config),
            finished: !0
          });else if (t.File && n.input instanceof File || n.input instanceof Object) {
            var r = a.parse(n.input, n.config);
            r && t.postMessage({
              workerId: a.WORKER_ID,
              results: r,
              finished: !0
            });
          }
        }), (u.prototype = Object.create(l.prototype)).constructor = u, (c.prototype = Object.create(l.prototype)).constructor = c, (d.prototype = Object.create(d.prototype)).constructor = d, (h.prototype = Object.create(l.prototype)).constructor = h, a;
      }) ? r.apply(t, i) : r) || (e.exports = o);
    },
    "./node_modules/parse-asn1/aesid.json": function node_modulesParseAsn1AesidJson(e) {
      e.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');
    },
    "./node_modules/parse-asn1/asn1.js": function node_modulesParseAsn1Asn1Js(e, t, n) {
      "use strict";

      var r = n("./node_modules/asn1.js/lib/asn1.js");
      t.certificate = n("./node_modules/parse-asn1/certificate.js");
      var i = r.define("RSAPrivateKey", function () {
        this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
      });
      t.RSAPrivateKey = i;
      var o = r.define("RSAPublicKey", function () {
        this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
      });
      t.RSAPublicKey = o;
      var a = r.define("SubjectPublicKeyInfo", function () {
        this.seq().obj(this.key("algorithm").use(s), this.key("subjectPublicKey").bitstr());
      });
      t.PublicKey = a;
      var s = r.define("AlgorithmIdentifier", function () {
          this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
        }),
        l = r.define("PrivateKeyInfo", function () {
          this.seq().obj(this.key("version").int(), this.key("algorithm").use(s), this.key("subjectPrivateKey").octstr());
        });
      t.PrivateKey = l;
      var u = r.define("EncryptedPrivateKeyInfo", function () {
        this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
      });
      t.EncryptedPrivateKey = u;
      var c = r.define("DSAPrivateKey", function () {
        this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
      });
      t.DSAPrivateKey = c, t.DSAparam = r.define("DSAparam", function () {
        this.int();
      });
      var d = r.define("ECPrivateKey", function () {
        this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(h), this.key("publicKey").optional().explicit(1).bitstr());
      });
      t.ECPrivateKey = d;
      var h = r.define("ECParameters", function () {
        this.choice({
          namedCurve: this.objid()
        });
      });
      t.signature = r.define("signature", function () {
        this.seq().obj(this.key("r").int(), this.key("s").int());
      });
    },
    "./node_modules/parse-asn1/certificate.js": function node_modulesParseAsn1CertificateJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/asn1.js/lib/asn1.js"),
        i = r.define("Time", function () {
          this.choice({
            utcTime: this.utctime(),
            generalTime: this.gentime()
          });
        }),
        o = r.define("AttributeTypeValue", function () {
          this.seq().obj(this.key("type").objid(), this.key("value").any());
        }),
        a = r.define("AlgorithmIdentifier", function () {
          this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
        }),
        s = r.define("SubjectPublicKeyInfo", function () {
          this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
        }),
        l = r.define("RelativeDistinguishedName", function () {
          this.setof(o);
        }),
        u = r.define("RDNSequence", function () {
          this.seqof(l);
        }),
        c = r.define("Name", function () {
          this.choice({
            rdnSequence: this.use(u)
          });
        }),
        d = r.define("Validity", function () {
          this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
        }),
        h = r.define("Extension", function () {
          this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
        }),
        f = r.define("TBSCertificate", function () {
          this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(a), this.key("issuer").use(c), this.key("validity").use(d), this.key("subject").use(c), this.key("subjectPublicKeyInfo").use(s), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(h).optional());
        }),
        p = r.define("X509Certificate", function () {
          this.seq().obj(this.key("tbsCertificate").use(f), this.key("signatureAlgorithm").use(a), this.key("signatureValue").bitstr());
        });
      e.exports = p;
    },
    "./node_modules/parse-asn1/fixProc.js": function node_modulesParseAsn1FixProcJs(e, t, n) {
      var r = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m,
        i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
        o = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m,
        a = n("./node_modules/evp_bytestokey/index.js"),
        s = n("./node_modules/browserify-aes/browser.js"),
        l = n("./node_modules/safe-buffer/index.js").Buffer;
      e.exports = function (e, t) {
        var n,
          u = e.toString(),
          c = u.match(r);
        if (c) {
          var d = "aes" + c[1],
            h = l.from(c[2], "hex"),
            f = l.from(c[3].replace(/[\r\n]/g, ""), "base64"),
            p = a(t, h.slice(0, 8), parseInt(c[1], 10)).key,
            m = [],
            g = s.createDecipheriv(d, p, h);
          m.push(g.update(f)), m.push(g.final()), n = l.concat(m);
        } else {
          var v = u.match(o);
          n = new l(v[2].replace(/[\r\n]/g, ""), "base64");
        }
        return {
          tag: u.match(i)[1],
          data: n
        };
      };
    },
    "./node_modules/parse-asn1/index.js": function node_modulesParseAsn1IndexJs(e, t, n) {
      var r = n("./node_modules/parse-asn1/asn1.js"),
        i = n("./node_modules/parse-asn1/aesid.json"),
        o = n("./node_modules/parse-asn1/fixProc.js"),
        a = n("./node_modules/browserify-aes/browser.js"),
        s = n("./node_modules/pbkdf2/browser.js"),
        l = n("./node_modules/safe-buffer/index.js").Buffer;
      function u(e) {
        var t;
        "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
        var n,
          u,
          c = o(e, t),
          d = c.tag,
          h = c.data;
        switch (d) {
          case "CERTIFICATE":
            u = r.certificate.decode(h, "der").tbsCertificate.subjectPublicKeyInfo;
          case "PUBLIC KEY":
            switch (u || (u = r.PublicKey.decode(h, "der")), n = u.algorithm.algorithm.join(".")) {
              case "1.2.840.113549.1.1.1":
                return r.RSAPublicKey.decode(u.subjectPublicKey.data, "der");
              case "1.2.840.10045.2.1":
                return u.subjectPrivateKey = u.subjectPublicKey, {
                  type: "ec",
                  data: u
                };
              case "1.2.840.10040.4.1":
                return u.algorithm.params.pub_key = r.DSAparam.decode(u.subjectPublicKey.data, "der"), {
                  type: "dsa",
                  data: u.algorithm.params
                };
              default:
                throw new Error("unknown key id " + n);
            }
            throw new Error("unknown key type " + d);
          case "ENCRYPTED PRIVATE KEY":
            h = function (e, t) {
              var n = e.algorithm.decrypt.kde.kdeparams.salt,
                r = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10),
                o = i[e.algorithm.decrypt.cipher.algo.join(".")],
                u = e.algorithm.decrypt.cipher.iv,
                c = e.subjectPrivateKey,
                d = parseInt(o.split("-")[1], 10) / 8,
                h = s.pbkdf2Sync(t, n, r, d, "sha1"),
                f = a.createDecipheriv(o, h, u),
                p = [];
              return p.push(f.update(c)), p.push(f.final()), l.concat(p);
            }(h = r.EncryptedPrivateKey.decode(h, "der"), t);
          case "PRIVATE KEY":
            switch (n = (u = r.PrivateKey.decode(h, "der")).algorithm.algorithm.join(".")) {
              case "1.2.840.113549.1.1.1":
                return r.RSAPrivateKey.decode(u.subjectPrivateKey, "der");
              case "1.2.840.10045.2.1":
                return {
                  curve: u.algorithm.curve,
                  privateKey: r.ECPrivateKey.decode(u.subjectPrivateKey, "der").privateKey
                };
              case "1.2.840.10040.4.1":
                return u.algorithm.params.priv_key = r.DSAparam.decode(u.subjectPrivateKey, "der"), {
                  type: "dsa",
                  params: u.algorithm.params
                };
              default:
                throw new Error("unknown key id " + n);
            }
            throw new Error("unknown key type " + d);
          case "RSA PUBLIC KEY":
            return r.RSAPublicKey.decode(h, "der");
          case "RSA PRIVATE KEY":
            return r.RSAPrivateKey.decode(h, "der");
          case "DSA PRIVATE KEY":
            return {
              type: "dsa",
              params: r.DSAPrivateKey.decode(h, "der")
            };
          case "EC PRIVATE KEY":
            return {
              curve: (h = r.ECPrivateKey.decode(h, "der")).parameters.value,
              privateKey: h.privateKey
            };
          default:
            throw new Error("unknown key type " + d);
        }
      }
      e.exports = u, u.signature = r.signature;
    },
    "./node_modules/pbkdf2/browser.js": function node_modulesPbkdf2BrowserJs(e, t, n) {
      t.pbkdf2 = n("./node_modules/pbkdf2/lib/async.js"), t.pbkdf2Sync = n("./node_modules/pbkdf2/lib/sync-browser.js");
    },
    "./node_modules/pbkdf2/lib/async.js": function node_modulesPbkdf2LibAsyncJs(e, t, n) {
      (function (t, r) {
        var i,
          o = n("./node_modules/pbkdf2/lib/precondition.js"),
          a = n("./node_modules/pbkdf2/lib/default-encoding.js"),
          s = n("./node_modules/pbkdf2/lib/sync-browser.js"),
          l = n("./node_modules/safe-buffer/index.js").Buffer,
          u = t.crypto && t.crypto.subtle,
          c = {
            sha: "SHA-1",
            "sha-1": "SHA-1",
            sha1: "SHA-1",
            sha256: "SHA-256",
            "sha-256": "SHA-256",
            sha384: "SHA-384",
            "sha-384": "SHA-384",
            "sha-512": "SHA-512",
            sha512: "SHA-512"
          },
          d = [];
        function h(e, t, n, r, i) {
          return u.importKey("raw", e, {
            name: "PBKDF2"
          }, !1, ["deriveBits"]).then(function (e) {
            return u.deriveBits({
              name: "PBKDF2",
              salt: t,
              iterations: n,
              hash: {
                name: i
              }
            }, e, r << 3);
          }).then(function (e) {
            return l.from(e);
          });
        }
        e.exports = function (e, n, f, p, m, g) {
          "function" == typeof m && (g = m, m = void 0);
          var v = c[(m = m || "sha1").toLowerCase()];
          if (!v || "function" != typeof t.Promise) return r.nextTick(function () {
            var t;
            try {
              t = s(e, n, f, p, m);
            } catch (e) {
              return g(e);
            }
            g(null, t);
          });
          if (o(e, n, f, p), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
          l.isBuffer(e) || (e = l.from(e, a)), l.isBuffer(n) || (n = l.from(n, a)), function (e, t) {
            e.then(function (e) {
              r.nextTick(function () {
                t(null, e);
              });
            }, function (e) {
              r.nextTick(function () {
                t(e);
              });
            });
          }(function (e) {
            if (t.process && !t.process.browser) return Promise.resolve(!1);
            if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
            if (void 0 !== d[e]) return d[e];
            var n = h(i = i || l.alloc(8), i, 10, 128, e).then(function () {
              return !0;
            }).catch(function () {
              return !1;
            });
            return d[e] = n, n;
          }(v).then(function (t) {
            return t ? h(e, n, f, p, v) : s(e, n, f, p, m);
          }), g);
        };
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
    },
    "./node_modules/pbkdf2/lib/default-encoding.js": function node_modulesPbkdf2LibDefaultEncodingJs(e, t, n) {
      (function (t) {
        var n;
        t.browser ? n = "utf-8" : n = parseInt(t.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
        e.exports = n;
      }).call(this, n("./node_modules/process/browser.js"));
    },
    "./node_modules/pbkdf2/lib/precondition.js": function node_modulesPbkdf2LibPreconditionJs(e, t, n) {
      (function (t) {
        var n = Math.pow(2, 30) - 1;
        function r(e, n) {
          if ("string" != typeof e && !t.isBuffer(e)) throw new TypeError(n + " must be a buffer or string");
        }
        e.exports = function (e, t, i, o) {
          if (r(e, "Password"), r(t, "Salt"), "number" != typeof i) throw new TypeError("Iterations not a number");
          if (i < 0) throw new TypeError("Bad iterations");
          if ("number" != typeof o) throw new TypeError("Key length not a number");
          if (o < 0 || o > n || o != o) throw new TypeError("Bad key length");
        };
      }).call(this, n("./node_modules/buffer/index.js").Buffer);
    },
    "./node_modules/pbkdf2/lib/sync-browser.js": function node_modulesPbkdf2LibSyncBrowserJs(e, t, n) {
      var r = n("./node_modules/create-hash/md5.js"),
        i = n("./node_modules/ripemd160/index.js"),
        o = n("./node_modules/sha.js/index.js"),
        a = n("./node_modules/pbkdf2/lib/precondition.js"),
        s = n("./node_modules/pbkdf2/lib/default-encoding.js"),
        l = n("./node_modules/safe-buffer/index.js").Buffer,
        u = l.alloc(128),
        c = {
          md5: 16,
          sha1: 20,
          sha224: 28,
          sha256: 32,
          sha384: 48,
          sha512: 64,
          rmd160: 20,
          ripemd160: 20
        };
      function d(e, t, n) {
        var a = function (e) {
            function t(t) {
              return o(e).update(t).digest();
            }
            return "rmd160" === e || "ripemd160" === e ? function (e) {
              return new i().update(e).digest();
            } : "md5" === e ? r : t;
          }(e),
          s = "sha512" === e || "sha384" === e ? 128 : 64;
        t.length > s ? t = a(t) : t.length < s && (t = l.concat([t, u], s));
        for (var d = l.allocUnsafe(s + c[e]), h = l.allocUnsafe(s + c[e]), f = 0; f < s; f++) d[f] = 54 ^ t[f], h[f] = 92 ^ t[f];
        var p = l.allocUnsafe(s + n + 4);
        d.copy(p, 0, 0, s), this.ipad1 = p, this.ipad2 = d, this.opad = h, this.alg = e, this.blocksize = s, this.hash = a, this.size = c[e];
      }
      d.prototype.run = function (e, t) {
        return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
      }, e.exports = function (e, t, n, r, i) {
        a(e, t, n, r), l.isBuffer(e) || (e = l.from(e, s)), l.isBuffer(t) || (t = l.from(t, s));
        var o = new d(i = i || "sha1", e, t.length),
          u = l.allocUnsafe(r),
          h = l.allocUnsafe(t.length + 4);
        t.copy(h, 0, 0, t.length);
        for (var f = 0, p = c[i], m = Math.ceil(r / p), g = 1; g <= m; g++) {
          h.writeUInt32BE(g, t.length);
          for (var v = o.run(h, o.ipad1), y = v, b = 1; b < n; b++) {
            y = o.run(y, o.ipad2);
            for (var _ = 0; _ < p; _++) v[_] ^= y[_];
          }
          v.copy(u, f), f += p;
        }
        return u;
      };
    },
    "./node_modules/plotly.js-gl3d-dist-min/plotly-gl3d.min.js": function node_modulesPlotlyJsGl3dDistMinPlotlyGl3dMinJs(e, t, n) {
      (function (t) {
        e.exports = function e(t, n, r) {
          function i(a, s) {
            if (!n[a]) {
              if (!t[a]) {
                if (o) return o(a, !0);
                var l = new Error("Cannot find module '" + a + "'");
                throw l.code = "MODULE_NOT_FOUND", l;
              }
              var u = n[a] = {
                exports: {}
              };
              t[a][0].call(u.exports, function (e) {
                return i(t[a][1][e] || e);
              }, u, u.exports, e, t, n, r);
            }
            return n[a].exports;
          }
          for (var o = !1, a = 0; a < r.length; a++) i(r[a]);
          return i;
        }({
          1: [function (e, t, n) {
            "use strict";

            var r = e("../src/lib"),
              i = {
                "X,X div": "direction:ltr;font-family:'Open Sans', verdana, arial, sans-serif;margin:0;padding:0;",
                "X input,X button": "font-family:'Open Sans', verdana, arial, sans-serif;",
                "X input:focus,X button:focus": "outline:none;",
                "X a": "text-decoration:none;",
                "X a:hover": "text-decoration:none;",
                "X .crisp": "shape-rendering:crispEdges;",
                "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
                "X svg": "overflow:hidden;",
                "X svg a": "fill:#447adb;",
                "X svg a:hover": "fill:#3c6dc5;",
                "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
                "X .main-svg .draglayer": "pointer-events:all;",
                "X .cursor-default": "cursor:default;",
                "X .cursor-pointer": "cursor:pointer;",
                "X .cursor-crosshair": "cursor:crosshair;",
                "X .cursor-move": "cursor:move;",
                "X .cursor-col-resize": "cursor:col-resize;",
                "X .cursor-row-resize": "cursor:row-resize;",
                "X .cursor-ns-resize": "cursor:ns-resize;",
                "X .cursor-ew-resize": "cursor:ew-resize;",
                "X .cursor-sw-resize": "cursor:sw-resize;",
                "X .cursor-s-resize": "cursor:s-resize;",
                "X .cursor-se-resize": "cursor:se-resize;",
                "X .cursor-w-resize": "cursor:w-resize;",
                "X .cursor-e-resize": "cursor:e-resize;",
                "X .cursor-nw-resize": "cursor:nw-resize;",
                "X .cursor-n-resize": "cursor:n-resize;",
                "X .cursor-ne-resize": "cursor:ne-resize;",
                "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
                "X .modebar": "position:absolute;top:2px;right:2px;",
                "X .ease-bg": "-webkit-transition:background-color 0.3s ease 0s;-moz-transition:background-color 0.3s ease 0s;-ms-transition:background-color 0.3s ease 0s;-o-transition:background-color 0.3s ease 0s;transition:background-color 0.3s ease 0s;",
                "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity 0.3s ease 0s;-moz-transition:opacity 0.3s ease 0s;-ms-transition:opacity 0.3s ease 0s;-o-transition:opacity 0.3s ease 0s;transition:opacity 0.3s ease 0s;",
                "X:hover .modebar--hover .modebar-group": "opacity:1;",
                "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
                "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
                "X .modebar-btn svg": "position:relative;top:2px;",
                "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
                "X .modebar.vertical svg": "top:-1px;",
                "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
                "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
                "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
                "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
                "X [data-title]:before": "content:'';position:absolute;background:transparent;border:6px solid transparent;z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;",
                "X [data-title]:after": "content:attr(data-title);background:#69738a;color:white;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
                "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
                "X .vertical [data-title]:before": "border:6px solid transparent;border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
                "X .select-outline": "fill:none;stroke-width:1;shape-rendering:crispEdges;",
                "X .select-outline-1": "stroke:white;",
                "X .select-outline-2": "stroke:black;stroke-dasharray:2px 2px;",
                Y: "font-family:'Open Sans';position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;",
                "Y p": "margin:0;",
                "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,0.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
                "Y .notifier-close": "color:#fff;opacity:0.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
                "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
              };
            for (var o in i) {
              var a = o.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier");
              r.addStyleRule(a, i[o]);
            }
          }, {
            "../src/lib": 495
          }],
          2: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/cone");
          }, {
            "../src/traces/cone": 606
          }],
          3: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/core");
          }, {
            "../src/core": 476
          }],
          4: [function (e, t, n) {
            "use strict";

            var r = e("./core");
            r.register([e("./scatter3d"), e("./surface"), e("./mesh3d"), e("./isosurface"), e("./volume"), e("./cone"), e("./streamtube")]), t.exports = r;
          }, {
            "./cone": 2,
            "./core": 3,
            "./isosurface": 5,
            "./mesh3d": 6,
            "./scatter3d": 7,
            "./streamtube": 8,
            "./surface": 9,
            "./volume": 10
          }],
          5: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/isosurface");
          }, {
            "../src/traces/isosurface": 613
          }],
          6: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/mesh3d");
          }, {
            "../src/traces/mesh3d": 618
          }],
          7: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/scatter3d");
          }, {
            "../src/traces/scatter3d": 654
          }],
          8: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/streamtube");
          }, {
            "../src/traces/streamtube": 659
          }],
          9: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/surface");
          }, {
            "../src/traces/surface": 664
          }],
          10: [function (e, t, n) {
            "use strict";

            t.exports = e("../src/traces/volume");
          }, {
            "../src/traces/volume": 668
          }],
          11: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = (e = e || {}).eye || [0, 0, 1],
                n = e.center || [0, 0, 0],
                s = e.up || [0, 1, 0],
                l = e.distanceLimits || [0, 1 / 0],
                u = e.mode || "turntable",
                c = r(),
                d = i(),
                h = o();
              return c.setDistanceLimits(l[0], l[1]), c.lookAt(0, t, n, s), d.setDistanceLimits(l[0], l[1]), d.lookAt(0, t, n, s), h.setDistanceLimits(l[0], l[1]), h.lookAt(0, t, n, s), new a({
                turntable: c,
                orbit: d,
                matrix: h
              }, u);
            };
            var r = e("turntable-camera-controller"),
              i = e("orbit-camera-controller"),
              o = e("matrix-camera-controller");
            function a(e, t) {
              this._controllerNames = Object.keys(e), this._controllerList = this._controllerNames.map(function (t) {
                return e[t];
              }), this._mode = t, this._active = e[t], this._active || (this._mode = "turntable", this._active = e.turntable), this.modes = this._controllerNames, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
            }
            var s = a.prototype;
            [["flush", 1], ["idle", 1], ["lookAt", 4], ["rotate", 4], ["pan", 4], ["translate", 4], ["setMatrix", 2], ["setDistanceLimits", 2], ["setDistance", 2]].forEach(function (e) {
              for (var t = e[0], n = [], r = 0; r < e[1]; ++r) n.push("a" + r);
              var i = "var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i]." + e[0] + "(" + n.join() + ")}";
              s[t] = Function.apply(null, n.concat(i));
            }), s.recalcMatrix = function (e) {
              this._active.recalcMatrix(e);
            }, s.getDistance = function (e) {
              return this._active.getDistance(e);
            }, s.getDistanceLimits = function (e) {
              return this._active.getDistanceLimits(e);
            }, s.lastT = function () {
              return this._active.lastT();
            }, s.setMode = function (e) {
              if (e !== this._mode) {
                var t = this._controllerNames.indexOf(e);
                if (!(t < 0)) {
                  var n = this._active,
                    r = this._controllerList[t],
                    i = Math.max(n.lastT(), r.lastT());
                  n.recalcMatrix(i), r.setMatrix(i, n.computedMatrix), this._active = r, this._mode = e, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                }
              }
            }, s.getMode = function () {
              return this._mode;
            };
          }, {
            "matrix-camera-controller": 268,
            "orbit-camera-controller": 289,
            "turntable-camera-controller": 344
          }],
          12: [function (e, t, n) {
            "use strict";

            var r = "undefined" == typeof WeakMap ? e("weak-map") : WeakMap,
              i = e("gl-buffer"),
              o = e("gl-vao"),
              a = new r();
            t.exports = function (e) {
              var t = a.get(e),
                n = t && (t._triangleBuffer.handle || t._triangleBuffer.buffer);
              if (!n || !e.isBuffer(n)) {
                var r = i(e, new Float32Array([-1, -1, -1, 4, 4, -1]));
                (t = o(e, [{
                  buffer: r,
                  type: e.FLOAT,
                  size: 2
                }]))._triangleBuffer = r, a.set(e, t);
              }
              t.bind(), e.drawArrays(e.TRIANGLES, 0, 3), t.unbind();
            };
          }, {
            "gl-buffer": 104,
            "gl-vao": 168,
            "weak-map": 352
          }],
          13: [function (e, t, n) {
            var r = e("pad-left");
            t.exports = function (e, t, n) {
              t = "number" == typeof t ? t : 1, n = n || ": ";
              var i = e.split(/\r?\n/),
                o = String(i.length + t - 1).length;
              return i.map(function (e, i) {
                var a = i + t,
                  s = String(a).length;
                return r(a, o - s) + n + e;
              }).join("\n");
            };
          }, {
            "pad-left": 290
          }],
          14: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.length;
              if (0 === t) return [];
              if (1 === t) return [0];
              for (var n = e[0].length, r = [e[0]], o = [0], a = 1; a < t; ++a) if (r.push(e[a]), i(r, n)) {
                if (o.push(a), o.length === n + 1) return o;
              } else r.pop();
              return o;
            };
            var r = e("robust-orientation");
            function i(e, t) {
              for (var n = new Array(t + 1), i = 0; i < e.length; ++i) n[i] = e[i];
              for (i = 0; i <= e.length; ++i) {
                for (var o = e.length; o <= t; ++o) {
                  for (var a = new Array(t), s = 0; s < t; ++s) a[s] = Math.pow(o + 1 - i, s);
                  n[o] = a;
                }
                if (r.apply(void 0, n)) return !0;
              }
              return !1;
            }
          }, {
            "robust-orientation": 321
          }],
          15: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              return r(t).filter(function (n) {
                for (var r = new Array(n.length), o = 0; o < n.length; ++o) r[o] = t[n[o]];
                return i(r) * e < 1;
              });
            };
            var r = e("delaunay-triangulate"),
              i = e("circumradius");
          }, {
            circumradius: 58,
            "delaunay-triangulate": 84
          }],
          16: [function (e, t, n) {
            t.exports = function (e, t) {
              return i(r(e, t));
            };
            var r = e("alpha-complex"),
              i = e("simplicial-complex-boundary");
          }, {
            "alpha-complex": 15,
            "simplicial-complex-boundary": 328
          }],
          17: [function (e, t, n) {
            t.exports = function (e) {
              return atob(e);
            };
          }, {}],
          18: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              for (var n = t.length, o = new Array(n + 1), a = 0; a < n; ++a) {
                for (var s = new Array(n + 1), l = 0; l <= n; ++l) s[l] = e[l][a];
                o[a] = s;
              }
              for (o[n] = new Array(n + 1), a = 0; a <= n; ++a) o[n][a] = 1;
              var u = new Array(n + 1);
              for (a = 0; a < n; ++a) u[a] = t[a];
              u[n] = 1;
              var c = r(o, u),
                d = i(c[n + 1]);
              0 === d && (d = 1);
              var h = new Array(n + 1);
              for (a = 0; a <= n; ++a) h[a] = i(c[a]) / d;
              return h;
            };
            var r = e("robust-linear-solve");
            function i(e) {
              for (var t = 0, n = 0; n < e.length; ++n) t += e[n];
              return t;
            }
          }, {
            "robust-linear-solve": 320
          }],
          19: [function (e, t, n) {
            "use strict";

            n.byteLength = function (e) {
              var t = u(e),
                n = t[0],
                r = t[1];
              return 3 * (n + r) / 4 - r;
            }, n.toByteArray = function (e) {
              var t,
                n,
                r = u(e),
                a = r[0],
                s = r[1],
                l = new o(function (e, t, n) {
                  return 3 * (t + n) / 4 - n;
                }(0, a, s)),
                c = 0,
                d = s > 0 ? a - 4 : a;
              for (n = 0; n < d; n += 4) t = i[e.charCodeAt(n)] << 18 | i[e.charCodeAt(n + 1)] << 12 | i[e.charCodeAt(n + 2)] << 6 | i[e.charCodeAt(n + 3)], l[c++] = t >> 16 & 255, l[c++] = t >> 8 & 255, l[c++] = 255 & t;
              return 2 === s && (t = i[e.charCodeAt(n)] << 2 | i[e.charCodeAt(n + 1)] >> 4, l[c++] = 255 & t), 1 === s && (t = i[e.charCodeAt(n)] << 10 | i[e.charCodeAt(n + 1)] << 4 | i[e.charCodeAt(n + 2)] >> 2, l[c++] = t >> 8 & 255, l[c++] = 255 & t), l;
            }, n.fromByteArray = function (e) {
              for (var t, n = e.length, i = n % 3, o = [], a = 0, s = n - i; a < s; a += 16383) o.push(c(e, a, a + 16383 > s ? s : a + 16383));
              return 1 === i ? (t = e[n - 1], o.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], o.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "=")), o.join("");
            };
            for (var r = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, l = a.length; s < l; ++s) r[s] = a[s], i[a.charCodeAt(s)] = s;
            function u(e) {
              var t = e.length;
              if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
              var n = e.indexOf("=");
              return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
            }
            function c(e, t, n) {
              for (var i, o, a = [], s = t; s < n; s += 3) i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
              return a.join("");
            }
            i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
          }, {}],
          20: [function (e, t, n) {
            "use strict";

            var r = e("./lib/rationalize");
            t.exports = function (e, t) {
              return r(e[0].mul(t[1]).add(t[0].mul(e[1])), e[1].mul(t[1]));
            };
          }, {
            "./lib/rationalize": 30
          }],
          21: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              return e[0].mul(t[1]).cmp(t[0].mul(e[1]));
            };
          }, {}],
          22: [function (e, t, n) {
            "use strict";

            var r = e("./lib/rationalize");
            t.exports = function (e, t) {
              return r(e[0].mul(t[1]), e[1].mul(t[0]));
            };
          }, {
            "./lib/rationalize": 30
          }],
          23: [function (e, t, n) {
            "use strict";

            var r = e("./is-rat"),
              i = e("./lib/is-bn"),
              o = e("./lib/num-to-bn"),
              a = e("./lib/str-to-bn"),
              s = e("./lib/rationalize"),
              l = e("./div");
            t.exports = function e(t, n) {
              if (r(t)) return n ? l(t, e(n)) : [t[0].clone(), t[1].clone()];
              var u,
                c,
                d = 0;
              if (i(t)) u = t.clone();else if ("string" == typeof t) u = a(t);else {
                if (0 === t) return [o(0), o(1)];
                if (t === Math.floor(t)) u = o(t);else {
                  for (; t !== Math.floor(t);) t *= Math.pow(2, 256), d -= 256;
                  u = o(t);
                }
              }
              if (r(n)) u.mul(n[1]), c = n[0].clone();else if (i(n)) c = n.clone();else if ("string" == typeof n) c = a(n);else if (n) {
                if (n === Math.floor(n)) c = o(n);else {
                  for (; n !== Math.floor(n);) n *= Math.pow(2, 256), d += 256;
                  c = o(n);
                }
              } else c = o(1);
              return d > 0 ? u = u.ushln(d) : d < 0 && (c = c.ushln(-d)), s(u, c);
            };
          }, {
            "./div": 22,
            "./is-rat": 24,
            "./lib/is-bn": 28,
            "./lib/num-to-bn": 29,
            "./lib/rationalize": 30,
            "./lib/str-to-bn": 31
          }],
          24: [function (e, t, n) {
            "use strict";

            var r = e("./lib/is-bn");
            t.exports = function (e) {
              return Array.isArray(e) && 2 === e.length && r(e[0]) && r(e[1]);
            };
          }, {
            "./lib/is-bn": 28
          }],
          25: [function (e, t, n) {
            "use strict";

            var r = e("bn.js");
            t.exports = function (e) {
              return e.cmp(new r(0));
            };
          }, {
            "bn.js": 38
          }],
          26: [function (e, t, n) {
            "use strict";

            var r = e("./bn-sign");
            t.exports = function (e) {
              var t = e.length,
                n = e.words,
                i = 0;
              if (1 === t) i = n[0];else if (2 === t) i = n[0] + 67108864 * n[1];else for (var o = 0; o < t; o++) i += n[o] * Math.pow(67108864, o);
              return r(e) * i;
            };
          }, {
            "./bn-sign": 25
          }],
          27: [function (e, t, n) {
            "use strict";

            var r = e("double-bits"),
              i = e("bit-twiddle").countTrailingZeros;
            t.exports = function (e) {
              var t = i(r.lo(e));
              if (t < 32) return t;
              var n = i(r.hi(e));
              return n > 20 ? 52 : n + 32;
            };
          }, {
            "bit-twiddle": 37,
            "double-bits": 85
          }],
          28: [function (e, t, n) {
            "use strict";

            e("bn.js"), t.exports = function (e) {
              return e && "object" == typeof e && Boolean(e.words);
            };
          }, {
            "bn.js": 38
          }],
          29: [function (e, t, n) {
            "use strict";

            var r = e("bn.js"),
              i = e("double-bits");
            t.exports = function (e) {
              var t = i.exponent(e);
              return t < 52 ? new r(e) : new r(e * Math.pow(2, 52 - t)).ushln(t - 52);
            };
          }, {
            "bn.js": 38,
            "double-bits": 85
          }],
          30: [function (e, t, n) {
            "use strict";

            var r = e("./num-to-bn"),
              i = e("./bn-sign");
            t.exports = function (e, t) {
              var n = i(e),
                o = i(t);
              if (0 === n) return [r(0), r(1)];
              if (0 === o) return [r(0), r(0)];
              o < 0 && (e = e.neg(), t = t.neg());
              var a = e.gcd(t);
              return a.cmpn(1) ? [e.div(a), t.div(a)] : [e, t];
            };
          }, {
            "./bn-sign": 25,
            "./num-to-bn": 29
          }],
          31: [function (e, t, n) {
            "use strict";

            var r = e("bn.js");
            t.exports = function (e) {
              return new r(e);
            };
          }, {
            "bn.js": 38
          }],
          32: [function (e, t, n) {
            "use strict";

            var r = e("./lib/rationalize");
            t.exports = function (e, t) {
              return r(e[0].mul(t[0]), e[1].mul(t[1]));
            };
          }, {
            "./lib/rationalize": 30
          }],
          33: [function (e, t, n) {
            "use strict";

            var r = e("./lib/bn-sign");
            t.exports = function (e) {
              return r(e[0]) * r(e[1]);
            };
          }, {
            "./lib/bn-sign": 25
          }],
          34: [function (e, t, n) {
            "use strict";

            var r = e("./lib/rationalize");
            t.exports = function (e, t) {
              return r(e[0].mul(t[1]).sub(e[1].mul(t[0])), e[1].mul(t[1]));
            };
          }, {
            "./lib/rationalize": 30
          }],
          35: [function (e, t, n) {
            "use strict";

            var r = e("./lib/bn-to-num"),
              i = e("./lib/ctz");
            t.exports = function (e) {
              var t = e[0],
                n = e[1];
              if (0 === t.cmpn(0)) return 0;
              var o = t.abs().divmod(n.abs()),
                a = o.div,
                s = r(a),
                l = o.mod,
                u = t.negative !== n.negative ? -1 : 1;
              if (0 === l.cmpn(0)) return u * s;
              if (s) {
                var c = i(s) + 4;
                return u * (s + (h = r(l.ushln(c).divRound(n))) * Math.pow(2, -c));
              }
              var d = n.bitLength() - l.bitLength() + 53,
                h = r(l.ushln(d).divRound(n));
              return d < 1023 ? u * h * Math.pow(2, -d) : u * (h *= Math.pow(2, -1023)) * Math.pow(2, 1023 - d);
            };
          }, {
            "./lib/bn-to-num": 26,
            "./lib/ctz": 27
          }],
          36: [function (e, t, n) {
            "use strict";

            function r(e, t, n, r, i, o) {
              var a = ["function ", e, "(a,l,h,", r.join(","), "){", o ? "" : "var i=", n ? "l-1" : "h+1", ";while(l<=h){var m=(l+h)>>>1,x=a", i ? ".get(m)" : "[m]"];
              return o ? t.indexOf("c") < 0 ? a.push(";if(x===y){return m}else if(x<=y){") : a.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){") : a.push(";if(", t, "){i=m;"), n ? a.push("l=m+1}else{h=m-1}") : a.push("h=m-1}else{l=m+1}"), a.push("}"), o ? a.push("return -1};") : a.push("return i};"), a.join("");
            }
            function i(e, t, n, i) {
              return new Function([r("A", "x" + e + "y", t, ["y"], !1, i), r("B", "x" + e + "y", t, ["y"], !0, i), r("P", "c(x,y)" + e + "0", t, ["y", "c"], !1, i), r("Q", "c(x,y)" + e + "0", t, ["y", "c"], !0, i), "function dispatchBsearch", n, "(a,y,c,l,h){if(a.shape){if(typeof(c)==='function'){return Q(a,(l===undefined)?0:l|0,(h===undefined)?a.shape[0]-1:h|0,y,c)}else{return B(a,(c===undefined)?0:c|0,(l===undefined)?a.shape[0]-1:l|0,y)}}else{if(typeof(c)==='function'){return P(a,(l===undefined)?0:l|0,(h===undefined)?a.length-1:h|0,y,c)}else{return A(a,(c===undefined)?0:c|0,(l===undefined)?a.length-1:l|0,y)}}}return dispatchBsearch", n].join(""))();
            }
            t.exports = {
              ge: i(">=", !1, "GE"),
              gt: i(">", !1, "GT"),
              lt: i("<", !0, "LT"),
              le: i("<=", !0, "LE"),
              eq: i("-", !0, "EQ", !0)
            };
          }, {}],
          37: [function (e, t, n) {
            "use strict";

            function r(e) {
              var t = 32;
              return (e &= -e) && t--, 65535 & e && (t -= 16), 16711935 & e && (t -= 8), 252645135 & e && (t -= 4), 858993459 & e && (t -= 2), 1431655765 & e && (t -= 1), t;
            }
            n.INT_BITS = 32, n.INT_MAX = 2147483647, n.INT_MIN = -1 << 31, n.sign = function (e) {
              return (e > 0) - (e < 0);
            }, n.abs = function (e) {
              var t = e >> 31;
              return (e ^ t) - t;
            }, n.min = function (e, t) {
              return t ^ (e ^ t) & -(e < t);
            }, n.max = function (e, t) {
              return e ^ (e ^ t) & -(e < t);
            }, n.isPow2 = function (e) {
              return !(e & e - 1 || !e);
            }, n.log2 = function (e) {
              var t, n;
              return t = (e > 65535) << 4, t |= n = ((e >>>= t) > 255) << 3, t |= n = ((e >>>= n) > 15) << 2, (t |= n = ((e >>>= n) > 3) << 1) | (e >>>= n) >> 1;
            }, n.log10 = function (e) {
              return e >= 1e9 ? 9 : e >= 1e8 ? 8 : e >= 1e7 ? 7 : e >= 1e6 ? 6 : e >= 1e5 ? 5 : e >= 1e4 ? 4 : e >= 1e3 ? 3 : e >= 100 ? 2 : e >= 10 ? 1 : 0;
            }, n.popCount = function (e) {
              return 16843009 * ((e = (858993459 & (e -= e >>> 1 & 1431655765)) + (e >>> 2 & 858993459)) + (e >>> 4) & 252645135) >>> 24;
            }, n.countTrailingZeros = r, n.nextPow2 = function (e) {
              return e += 0 === e, --e, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, 1 + (e |= e >>> 16);
            }, n.prevPow2 = function (e) {
              return e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, (e |= e >>> 16) - (e >>> 1);
            }, n.parity = function (e) {
              return e ^= e >>> 16, e ^= e >>> 8, e ^= e >>> 4, 27030 >>> (e &= 15) & 1;
            };
            var i = new Array(256);
            !function (e) {
              for (var t = 0; t < 256; ++t) {
                var n = t,
                  r = t,
                  i = 7;
                for (n >>>= 1; n; n >>>= 1) r <<= 1, r |= 1 & n, --i;
                e[t] = r << i & 255;
              }
            }(i), n.reverse = function (e) {
              return i[255 & e] << 24 | i[e >>> 8 & 255] << 16 | i[e >>> 16 & 255] << 8 | i[e >>> 24 & 255];
            }, n.interleave2 = function (e, t) {
              return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e &= 65535) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t &= 65535) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
            }, n.deinterleave2 = function (e, t) {
              return (e = 65535 & ((e = 16711935 & ((e = 252645135 & ((e = 858993459 & ((e = e >>> t & 1431655765) | e >>> 1)) | e >>> 2)) | e >>> 4)) | e >>> 16)) << 16 >> 16;
            }, n.interleave3 = function (e, t, n) {
              return e = 1227133513 & ((e = 3272356035 & ((e = 251719695 & ((e = 4278190335 & ((e &= 1023) | e << 16)) | e << 8)) | e << 4)) | e << 2), (e |= (t = 1227133513 & ((t = 3272356035 & ((t = 251719695 & ((t = 4278190335 & ((t &= 1023) | t << 16)) | t << 8)) | t << 4)) | t << 2)) << 1) | (n = 1227133513 & ((n = 3272356035 & ((n = 251719695 & ((n = 4278190335 & ((n &= 1023) | n << 16)) | n << 8)) | n << 4)) | n << 2)) << 2;
            }, n.deinterleave3 = function (e, t) {
              return (e = 1023 & ((e = 4278190335 & ((e = 251719695 & ((e = 3272356035 & ((e = e >>> t & 1227133513) | e >>> 2)) | e >>> 4)) | e >>> 8)) | e >>> 16)) << 22 >> 22;
            }, n.nextCombination = function (e) {
              var t = e | e - 1;
              return t + 1 | (~t & -~t) - 1 >>> r(e) + 1;
            };
          }, {}],
          38: [function (e, t, n) {
            !function (t, n) {
              "use strict";

              function r(e, t) {
                if (!e) throw new Error(t || "Assertion failed");
              }
              function i(e, t) {
                e.super_ = t;
                var n = function n() {};
                n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
              }
              function o(e, t, n) {
                if (o.isBN(e)) return e;
                this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (n = t, t = 10), this._init(e || 0, t || 10, n || "be"));
              }
              var a;
              "object" == typeof t ? t.exports = o : n.BN = o, o.BN = o, o.wordSize = 26;
              try {
                a = e("buffer").Buffer;
              } catch (e) {}
              function s(e, t, n) {
                for (var r = 0, i = Math.min(e.length, n), o = t; o < i; o++) {
                  var a = e.charCodeAt(o) - 48;
                  r <<= 4, r |= a >= 49 && a <= 54 ? a - 49 + 10 : a >= 17 && a <= 22 ? a - 17 + 10 : 15 & a;
                }
                return r;
              }
              function l(e, t, n, r) {
                for (var i = 0, o = Math.min(e.length, n), a = t; a < o; a++) {
                  var s = e.charCodeAt(a) - 48;
                  i *= r, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
                }
                return i;
              }
              o.isBN = function (e) {
                return e instanceof o || null !== e && "object" == typeof e && e.constructor.wordSize === o.wordSize && Array.isArray(e.words);
              }, o.max = function (e, t) {
                return e.cmp(t) > 0 ? e : t;
              }, o.min = function (e, t) {
                return e.cmp(t) < 0 ? e : t;
              }, o.prototype._init = function (e, t, n) {
                if ("number" == typeof e) return this._initNumber(e, t, n);
                if ("object" == typeof e) return this._initArray(e, t, n);
                "hex" === t && (t = 16), r(t === (0 | t) && t >= 2 && t <= 36);
                var i = 0;
                "-" === (e = e.toString().replace(/\s+/g, ""))[0] && i++, 16 === t ? this._parseHex(e, i) : this._parseBase(e, t, i), "-" === e[0] && (this.negative = 1), this.strip(), "le" === n && this._initArray(this.toArray(), t, n);
              }, o.prototype._initNumber = function (e, t, n) {
                e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [67108863 & e], this.length = 1) : e < 4503599627370496 ? (this.words = [67108863 & e, e / 67108864 & 67108863], this.length = 2) : (r(e < 9007199254740992), this.words = [67108863 & e, e / 67108864 & 67108863, 1], this.length = 3), "le" === n && this._initArray(this.toArray(), t, n);
              }, o.prototype._initArray = function (e, t, n) {
                if (r("number" == typeof e.length), e.length <= 0) return this.words = [0], this.length = 1, this;
                this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                for (var i = 0; i < this.length; i++) this.words[i] = 0;
                var o,
                  a,
                  s = 0;
                if ("be" === n) for (i = e.length - 1, o = 0; i >= 0; i -= 3) a = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);else if ("le" === n) for (i = 0, o = 0; i < e.length; i += 3) a = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
                return this.strip();
              }, o.prototype._parseHex = function (e, t) {
                this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                for (var n = 0; n < this.length; n++) this.words[n] = 0;
                var r,
                  i,
                  o = 0;
                for (n = e.length - 6, r = 0; n >= t; n -= 6) i = s(e, n, n + 6), this.words[r] |= i << o & 67108863, this.words[r + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, r++);
                n + 6 !== t && (i = s(e, t, n + 6), this.words[r] |= i << o & 67108863, this.words[r + 1] |= i >>> 26 - o & 4194303), this.strip();
              }, o.prototype._parseBase = function (e, t, n) {
                this.words = [0], this.length = 1;
                for (var r = 0, i = 1; i <= 67108863; i *= t) r++;
                r--, i = i / t | 0;
                for (var o = e.length - n, a = o % r, s = Math.min(o, o - a) + n, u = 0, c = n; c < s; c += r) u = l(e, c, c + r, t), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                if (0 !== a) {
                  var d = 1;
                  for (u = l(e, c, e.length, t), c = 0; c < a; c++) d *= t;
                  this.imuln(d), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                }
              }, o.prototype.copy = function (e) {
                e.words = new Array(this.length);
                for (var t = 0; t < this.length; t++) e.words[t] = this.words[t];
                e.length = this.length, e.negative = this.negative, e.red = this.red;
              }, o.prototype.clone = function () {
                var e = new o(null);
                return this.copy(e), e;
              }, o.prototype._expand = function (e) {
                for (; this.length < e;) this.words[this.length++] = 0;
                return this;
              }, o.prototype.strip = function () {
                for (; this.length > 1 && 0 === this.words[this.length - 1];) this.length--;
                return this._normSign();
              }, o.prototype._normSign = function () {
                return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
              }, o.prototype.inspect = function () {
                return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
              };
              var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
                c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
                d = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];
              function h(e, t, n) {
                n.negative = t.negative ^ e.negative;
                var r = e.length + t.length | 0;
                n.length = r, r = r - 1 | 0;
                var i = 0 | e.words[0],
                  o = 0 | t.words[0],
                  a = i * o,
                  s = 67108863 & a,
                  l = a / 67108864 | 0;
                n.words[0] = s;
                for (var u = 1; u < r; u++) {
                  for (var c = l >>> 26, d = 67108863 & l, h = Math.min(u, t.length - 1), f = Math.max(0, u - e.length + 1); f <= h; f++) {
                    var p = u - f | 0;
                    c += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[f]) + d) / 67108864 | 0, d = 67108863 & a;
                  }
                  n.words[u] = 0 | d, l = 0 | c;
                }
                return 0 !== l ? n.words[u] = 0 | l : n.length--, n.strip();
              }
              o.prototype.toString = function (e, t) {
                var n;
                if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                  n = "";
                  for (var i = 0, o = 0, a = 0; a < this.length; a++) {
                    var s = this.words[a],
                      l = (16777215 & (s << i | o)).toString(16);
                    n = 0 != (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? u[6 - l.length] + l + n : l + n, (i += 2) >= 26 && (i -= 26, a--);
                  }
                  for (0 !== o && (n = o.toString(16) + n); n.length % t != 0;) n = "0" + n;
                  return 0 !== this.negative && (n = "-" + n), n;
                }
                if (e === (0 | e) && e >= 2 && e <= 36) {
                  var h = c[e],
                    f = d[e];
                  n = "";
                  var p = this.clone();
                  for (p.negative = 0; !p.isZero();) {
                    var m = p.modn(f).toString(e);
                    n = (p = p.idivn(f)).isZero() ? m + n : u[h - m.length] + m + n;
                  }
                  for (this.isZero() && (n = "0" + n); n.length % t != 0;) n = "0" + n;
                  return 0 !== this.negative && (n = "-" + n), n;
                }
                r(!1, "Base should be between 2 and 36");
              }, o.prototype.toNumber = function () {
                var e = this.words[0];
                return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
              }, o.prototype.toJSON = function () {
                return this.toString(16);
              }, o.prototype.toBuffer = function (e, t) {
                return r(void 0 !== a), this.toArrayLike(a, e, t);
              }, o.prototype.toArray = function (e, t) {
                return this.toArrayLike(Array, e, t);
              }, o.prototype.toArrayLike = function (e, t, n) {
                var i = this.byteLength(),
                  o = n || Math.max(1, i);
                r(i <= o, "byte array longer than desired length"), r(o > 0, "Requested array length <= 0"), this.strip();
                var a,
                  s,
                  l = "le" === t,
                  u = new e(o),
                  c = this.clone();
                if (l) {
                  for (s = 0; !c.isZero(); s++) a = c.andln(255), c.iushrn(8), u[s] = a;
                  for (; s < o; s++) u[s] = 0;
                } else {
                  for (s = 0; s < o - i; s++) u[s] = 0;
                  for (s = 0; !c.isZero(); s++) a = c.andln(255), c.iushrn(8), u[o - s - 1] = a;
                }
                return u;
              }, Math.clz32 ? o.prototype._countBits = function (e) {
                return 32 - Math.clz32(e);
              } : o.prototype._countBits = function (e) {
                var t = e,
                  n = 0;
                return t >= 4096 && (n += 13, t >>>= 13), t >= 64 && (n += 7, t >>>= 7), t >= 8 && (n += 4, t >>>= 4), t >= 2 && (n += 2, t >>>= 2), n + t;
              }, o.prototype._zeroBits = function (e) {
                if (0 === e) return 26;
                var t = e,
                  n = 0;
                return 0 == (8191 & t) && (n += 13, t >>>= 13), 0 == (127 & t) && (n += 7, t >>>= 7), 0 == (15 & t) && (n += 4, t >>>= 4), 0 == (3 & t) && (n += 2, t >>>= 2), 0 == (1 & t) && n++, n;
              }, o.prototype.bitLength = function () {
                var e = this.words[this.length - 1],
                  t = this._countBits(e);
                return 26 * (this.length - 1) + t;
              }, o.prototype.zeroBits = function () {
                if (this.isZero()) return 0;
                for (var e = 0, t = 0; t < this.length; t++) {
                  var n = this._zeroBits(this.words[t]);
                  if (e += n, 26 !== n) break;
                }
                return e;
              }, o.prototype.byteLength = function () {
                return Math.ceil(this.bitLength() / 8);
              }, o.prototype.toTwos = function (e) {
                return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
              }, o.prototype.fromTwos = function (e) {
                return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
              }, o.prototype.isNeg = function () {
                return 0 !== this.negative;
              }, o.prototype.neg = function () {
                return this.clone().ineg();
              }, o.prototype.ineg = function () {
                return this.isZero() || (this.negative ^= 1), this;
              }, o.prototype.iuor = function (e) {
                for (; this.length < e.length;) this.words[this.length++] = 0;
                for (var t = 0; t < e.length; t++) this.words[t] = this.words[t] | e.words[t];
                return this.strip();
              }, o.prototype.ior = function (e) {
                return r(0 == (this.negative | e.negative)), this.iuor(e);
              }, o.prototype.or = function (e) {
                return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
              }, o.prototype.uor = function (e) {
                return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
              }, o.prototype.iuand = function (e) {
                var t;
                t = this.length > e.length ? e : this;
                for (var n = 0; n < t.length; n++) this.words[n] = this.words[n] & e.words[n];
                return this.length = t.length, this.strip();
              }, o.prototype.iand = function (e) {
                return r(0 == (this.negative | e.negative)), this.iuand(e);
              }, o.prototype.and = function (e) {
                return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
              }, o.prototype.uand = function (e) {
                return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
              }, o.prototype.iuxor = function (e) {
                var t, n;
                this.length > e.length ? (t = this, n = e) : (t = e, n = this);
                for (var r = 0; r < n.length; r++) this.words[r] = t.words[r] ^ n.words[r];
                if (this !== t) for (; r < t.length; r++) this.words[r] = t.words[r];
                return this.length = t.length, this.strip();
              }, o.prototype.ixor = function (e) {
                return r(0 == (this.negative | e.negative)), this.iuxor(e);
              }, o.prototype.xor = function (e) {
                return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
              }, o.prototype.uxor = function (e) {
                return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
              }, o.prototype.inotn = function (e) {
                r("number" == typeof e && e >= 0);
                var t = 0 | Math.ceil(e / 26),
                  n = e % 26;
                this._expand(t), n > 0 && t--;
                for (var i = 0; i < t; i++) this.words[i] = 67108863 & ~this.words[i];
                return n > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - n), this.strip();
              }, o.prototype.notn = function (e) {
                return this.clone().inotn(e);
              }, o.prototype.setn = function (e, t) {
                r("number" == typeof e && e >= 0);
                var n = e / 26 | 0,
                  i = e % 26;
                return this._expand(n + 1), this.words[n] = t ? this.words[n] | 1 << i : this.words[n] & ~(1 << i), this.strip();
              }, o.prototype.iadd = function (e) {
                var t, n, r;
                if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                this.length > e.length ? (n = this, r = e) : (n = e, r = this);
                for (var i = 0, o = 0; o < r.length; o++) t = (0 | n.words[o]) + (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                for (; 0 !== i && o < n.length; o++) t = (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                if (this.length = n.length, 0 !== i) this.words[this.length] = i, this.length++;else if (n !== this) for (; o < n.length; o++) this.words[o] = n.words[o];
                return this;
              }, o.prototype.add = function (e) {
                var t;
                return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
              }, o.prototype.isub = function (e) {
                if (0 !== e.negative) {
                  e.negative = 0;
                  var t = this.iadd(e);
                  return e.negative = 1, t._normSign();
                }
                if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                var n,
                  r,
                  i = this.cmp(e);
                if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                i > 0 ? (n = this, r = e) : (n = e, r = this);
                for (var o = 0, a = 0; a < r.length; a++) o = (t = (0 | n.words[a]) - (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
                for (; 0 !== o && a < n.length; a++) o = (t = (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
                if (0 === o && a < n.length && n !== this) for (; a < n.length; a++) this.words[a] = n.words[a];
                return this.length = Math.max(this.length, a), n !== this && (this.negative = 1), this.strip();
              }, o.prototype.sub = function (e) {
                return this.clone().isub(e);
              };
              var f = function f(e, t, n) {
                var r,
                  i,
                  o,
                  a = e.words,
                  s = t.words,
                  l = n.words,
                  u = 0,
                  c = 0 | a[0],
                  d = 8191 & c,
                  h = c >>> 13,
                  f = 0 | a[1],
                  p = 8191 & f,
                  m = f >>> 13,
                  g = 0 | a[2],
                  v = 8191 & g,
                  y = g >>> 13,
                  b = 0 | a[3],
                  _ = 8191 & b,
                  x = b >>> 13,
                  w = 0 | a[4],
                  S = 8191 & w,
                  A = w >>> 13,
                  E = 0 | a[5],
                  T = 8191 & E,
                  M = E >>> 13,
                  C = 0 | a[6],
                  k = 8191 & C,
                  P = C >>> 13,
                  O = 0 | a[7],
                  R = 8191 & O,
                  I = O >>> 13,
                  j = 0 | a[8],
                  N = 8191 & j,
                  L = j >>> 13,
                  D = 0 | a[9],
                  B = 8191 & D,
                  F = D >>> 13,
                  z = 0 | s[0],
                  U = 8191 & z,
                  G = z >>> 13,
                  V = 0 | s[1],
                  H = 8191 & V,
                  q = V >>> 13,
                  W = 0 | s[2],
                  $ = 8191 & W,
                  X = W >>> 13,
                  Y = 0 | s[3],
                  K = 8191 & Y,
                  Z = Y >>> 13,
                  Q = 0 | s[4],
                  J = 8191 & Q,
                  ee = Q >>> 13,
                  te = 0 | s[5],
                  ne = 8191 & te,
                  re = te >>> 13,
                  ie = 0 | s[6],
                  oe = 8191 & ie,
                  ae = ie >>> 13,
                  se = 0 | s[7],
                  le = 8191 & se,
                  ue = se >>> 13,
                  ce = 0 | s[8],
                  de = 8191 & ce,
                  he = ce >>> 13,
                  fe = 0 | s[9],
                  pe = 8191 & fe,
                  me = fe >>> 13;
                n.negative = e.negative ^ t.negative, n.length = 19;
                var ge = (u + (r = Math.imul(d, U)) | 0) + ((8191 & (i = (i = Math.imul(d, G)) + Math.imul(h, U) | 0)) << 13) | 0;
                u = ((o = Math.imul(h, G)) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, r = Math.imul(p, U), i = (i = Math.imul(p, G)) + Math.imul(m, U) | 0, o = Math.imul(m, G);
                var ve = (u + (r = r + Math.imul(d, H) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, q) | 0) + Math.imul(h, H) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, q) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, r = Math.imul(v, U), i = (i = Math.imul(v, G)) + Math.imul(y, U) | 0, o = Math.imul(y, G), r = r + Math.imul(p, H) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, H) | 0, o = o + Math.imul(m, q) | 0;
                var ye = (u + (r = r + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, X) | 0) + Math.imul(h, $) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, X) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, r = Math.imul(_, U), i = (i = Math.imul(_, G)) + Math.imul(x, U) | 0, o = Math.imul(x, G), r = r + Math.imul(v, H) | 0, i = (i = i + Math.imul(v, q) | 0) + Math.imul(y, H) | 0, o = o + Math.imul(y, q) | 0, r = r + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, X) | 0;
                var be = (u + (r = r + Math.imul(d, K) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, Z) | 0) + Math.imul(h, K) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, Z) | 0) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, r = Math.imul(S, U), i = (i = Math.imul(S, G)) + Math.imul(A, U) | 0, o = Math.imul(A, G), r = r + Math.imul(_, H) | 0, i = (i = i + Math.imul(_, q) | 0) + Math.imul(x, H) | 0, o = o + Math.imul(x, q) | 0, r = r + Math.imul(v, $) | 0, i = (i = i + Math.imul(v, X) | 0) + Math.imul(y, $) | 0, o = o + Math.imul(y, X) | 0, r = r + Math.imul(p, K) | 0, i = (i = i + Math.imul(p, Z) | 0) + Math.imul(m, K) | 0, o = o + Math.imul(m, Z) | 0;
                var _e = (u + (r = r + Math.imul(d, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(h, J) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, ee) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, r = Math.imul(T, U), i = (i = Math.imul(T, G)) + Math.imul(M, U) | 0, o = Math.imul(M, G), r = r + Math.imul(S, H) | 0, i = (i = i + Math.imul(S, q) | 0) + Math.imul(A, H) | 0, o = o + Math.imul(A, q) | 0, r = r + Math.imul(_, $) | 0, i = (i = i + Math.imul(_, X) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, X) | 0, r = r + Math.imul(v, K) | 0, i = (i = i + Math.imul(v, Z) | 0) + Math.imul(y, K) | 0, o = o + Math.imul(y, Z) | 0, r = r + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, J) | 0, o = o + Math.imul(m, ee) | 0;
                var xe = (u + (r = r + Math.imul(d, ne) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, re) | 0) + Math.imul(h, ne) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, re) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, r = Math.imul(k, U), i = (i = Math.imul(k, G)) + Math.imul(P, U) | 0, o = Math.imul(P, G), r = r + Math.imul(T, H) | 0, i = (i = i + Math.imul(T, q) | 0) + Math.imul(M, H) | 0, o = o + Math.imul(M, q) | 0, r = r + Math.imul(S, $) | 0, i = (i = i + Math.imul(S, X) | 0) + Math.imul(A, $) | 0, o = o + Math.imul(A, X) | 0, r = r + Math.imul(_, K) | 0, i = (i = i + Math.imul(_, Z) | 0) + Math.imul(x, K) | 0, o = o + Math.imul(x, Z) | 0, r = r + Math.imul(v, J) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(y, J) | 0, o = o + Math.imul(y, ee) | 0, r = r + Math.imul(p, ne) | 0, i = (i = i + Math.imul(p, re) | 0) + Math.imul(m, ne) | 0, o = o + Math.imul(m, re) | 0;
                var we = (u + (r = r + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(h, oe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, ae) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, r = Math.imul(R, U), i = (i = Math.imul(R, G)) + Math.imul(I, U) | 0, o = Math.imul(I, G), r = r + Math.imul(k, H) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(P, H) | 0, o = o + Math.imul(P, q) | 0, r = r + Math.imul(T, $) | 0, i = (i = i + Math.imul(T, X) | 0) + Math.imul(M, $) | 0, o = o + Math.imul(M, X) | 0, r = r + Math.imul(S, K) | 0, i = (i = i + Math.imul(S, Z) | 0) + Math.imul(A, K) | 0, o = o + Math.imul(A, Z) | 0, r = r + Math.imul(_, J) | 0, i = (i = i + Math.imul(_, ee) | 0) + Math.imul(x, J) | 0, o = o + Math.imul(x, ee) | 0, r = r + Math.imul(v, ne) | 0, i = (i = i + Math.imul(v, re) | 0) + Math.imul(y, ne) | 0, o = o + Math.imul(y, re) | 0, r = r + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0;
                var Se = (u + (r = r + Math.imul(d, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ue) | 0) + Math.imul(h, le) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, ue) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, r = Math.imul(N, U), i = (i = Math.imul(N, G)) + Math.imul(L, U) | 0, o = Math.imul(L, G), r = r + Math.imul(R, H) | 0, i = (i = i + Math.imul(R, q) | 0) + Math.imul(I, H) | 0, o = o + Math.imul(I, q) | 0, r = r + Math.imul(k, $) | 0, i = (i = i + Math.imul(k, X) | 0) + Math.imul(P, $) | 0, o = o + Math.imul(P, X) | 0, r = r + Math.imul(T, K) | 0, i = (i = i + Math.imul(T, Z) | 0) + Math.imul(M, K) | 0, o = o + Math.imul(M, Z) | 0, r = r + Math.imul(S, J) | 0, i = (i = i + Math.imul(S, ee) | 0) + Math.imul(A, J) | 0, o = o + Math.imul(A, ee) | 0, r = r + Math.imul(_, ne) | 0, i = (i = i + Math.imul(_, re) | 0) + Math.imul(x, ne) | 0, o = o + Math.imul(x, re) | 0, r = r + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(y, oe) | 0, o = o + Math.imul(y, ae) | 0, r = r + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ue) | 0) + Math.imul(m, le) | 0, o = o + Math.imul(m, ue) | 0;
                var Ae = (u + (r = r + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, he) | 0) + Math.imul(h, de) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, he) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, r = Math.imul(B, U), i = (i = Math.imul(B, G)) + Math.imul(F, U) | 0, o = Math.imul(F, G), r = r + Math.imul(N, H) | 0, i = (i = i + Math.imul(N, q) | 0) + Math.imul(L, H) | 0, o = o + Math.imul(L, q) | 0, r = r + Math.imul(R, $) | 0, i = (i = i + Math.imul(R, X) | 0) + Math.imul(I, $) | 0, o = o + Math.imul(I, X) | 0, r = r + Math.imul(k, K) | 0, i = (i = i + Math.imul(k, Z) | 0) + Math.imul(P, K) | 0, o = o + Math.imul(P, Z) | 0, r = r + Math.imul(T, J) | 0, i = (i = i + Math.imul(T, ee) | 0) + Math.imul(M, J) | 0, o = o + Math.imul(M, ee) | 0, r = r + Math.imul(S, ne) | 0, i = (i = i + Math.imul(S, re) | 0) + Math.imul(A, ne) | 0, o = o + Math.imul(A, re) | 0, r = r + Math.imul(_, oe) | 0, i = (i = i + Math.imul(_, ae) | 0) + Math.imul(x, oe) | 0, o = o + Math.imul(x, ae) | 0, r = r + Math.imul(v, le) | 0, i = (i = i + Math.imul(v, ue) | 0) + Math.imul(y, le) | 0, o = o + Math.imul(y, ue) | 0, r = r + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, he) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, he) | 0;
                var Ee = (u + (r = r + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, me) | 0) + Math.imul(h, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(h, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, r = Math.imul(B, H), i = (i = Math.imul(B, q)) + Math.imul(F, H) | 0, o = Math.imul(F, q), r = r + Math.imul(N, $) | 0, i = (i = i + Math.imul(N, X) | 0) + Math.imul(L, $) | 0, o = o + Math.imul(L, X) | 0, r = r + Math.imul(R, K) | 0, i = (i = i + Math.imul(R, Z) | 0) + Math.imul(I, K) | 0, o = o + Math.imul(I, Z) | 0, r = r + Math.imul(k, J) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(P, J) | 0, o = o + Math.imul(P, ee) | 0, r = r + Math.imul(T, ne) | 0, i = (i = i + Math.imul(T, re) | 0) + Math.imul(M, ne) | 0, o = o + Math.imul(M, re) | 0, r = r + Math.imul(S, oe) | 0, i = (i = i + Math.imul(S, ae) | 0) + Math.imul(A, oe) | 0, o = o + Math.imul(A, ae) | 0, r = r + Math.imul(_, le) | 0, i = (i = i + Math.imul(_, ue) | 0) + Math.imul(x, le) | 0, o = o + Math.imul(x, ue) | 0, r = r + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, he) | 0) + Math.imul(y, de) | 0, o = o + Math.imul(y, he) | 0;
                var Te = (u + (r = r + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, r = Math.imul(B, $), i = (i = Math.imul(B, X)) + Math.imul(F, $) | 0, o = Math.imul(F, X), r = r + Math.imul(N, K) | 0, i = (i = i + Math.imul(N, Z) | 0) + Math.imul(L, K) | 0, o = o + Math.imul(L, Z) | 0, r = r + Math.imul(R, J) | 0, i = (i = i + Math.imul(R, ee) | 0) + Math.imul(I, J) | 0, o = o + Math.imul(I, ee) | 0, r = r + Math.imul(k, ne) | 0, i = (i = i + Math.imul(k, re) | 0) + Math.imul(P, ne) | 0, o = o + Math.imul(P, re) | 0, r = r + Math.imul(T, oe) | 0, i = (i = i + Math.imul(T, ae) | 0) + Math.imul(M, oe) | 0, o = o + Math.imul(M, ae) | 0, r = r + Math.imul(S, le) | 0, i = (i = i + Math.imul(S, ue) | 0) + Math.imul(A, le) | 0, o = o + Math.imul(A, ue) | 0, r = r + Math.imul(_, de) | 0, i = (i = i + Math.imul(_, he) | 0) + Math.imul(x, de) | 0, o = o + Math.imul(x, he) | 0;
                var Me = (u + (r = r + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, r = Math.imul(B, K), i = (i = Math.imul(B, Z)) + Math.imul(F, K) | 0, o = Math.imul(F, Z), r = r + Math.imul(N, J) | 0, i = (i = i + Math.imul(N, ee) | 0) + Math.imul(L, J) | 0, o = o + Math.imul(L, ee) | 0, r = r + Math.imul(R, ne) | 0, i = (i = i + Math.imul(R, re) | 0) + Math.imul(I, ne) | 0, o = o + Math.imul(I, re) | 0, r = r + Math.imul(k, oe) | 0, i = (i = i + Math.imul(k, ae) | 0) + Math.imul(P, oe) | 0, o = o + Math.imul(P, ae) | 0, r = r + Math.imul(T, le) | 0, i = (i = i + Math.imul(T, ue) | 0) + Math.imul(M, le) | 0, o = o + Math.imul(M, ue) | 0, r = r + Math.imul(S, de) | 0, i = (i = i + Math.imul(S, he) | 0) + Math.imul(A, de) | 0, o = o + Math.imul(A, he) | 0;
                var Ce = (u + (r = r + Math.imul(_, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(_, me) | 0) + Math.imul(x, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(x, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, r = Math.imul(B, J), i = (i = Math.imul(B, ee)) + Math.imul(F, J) | 0, o = Math.imul(F, ee), r = r + Math.imul(N, ne) | 0, i = (i = i + Math.imul(N, re) | 0) + Math.imul(L, ne) | 0, o = o + Math.imul(L, re) | 0, r = r + Math.imul(R, oe) | 0, i = (i = i + Math.imul(R, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, r = r + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ue) | 0) + Math.imul(P, le) | 0, o = o + Math.imul(P, ue) | 0, r = r + Math.imul(T, de) | 0, i = (i = i + Math.imul(T, he) | 0) + Math.imul(M, de) | 0, o = o + Math.imul(M, he) | 0;
                var ke = (u + (r = r + Math.imul(S, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(S, me) | 0) + Math.imul(A, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(A, me) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, r = Math.imul(B, ne), i = (i = Math.imul(B, re)) + Math.imul(F, ne) | 0, o = Math.imul(F, re), r = r + Math.imul(N, oe) | 0, i = (i = i + Math.imul(N, ae) | 0) + Math.imul(L, oe) | 0, o = o + Math.imul(L, ae) | 0, r = r + Math.imul(R, le) | 0, i = (i = i + Math.imul(R, ue) | 0) + Math.imul(I, le) | 0, o = o + Math.imul(I, ue) | 0, r = r + Math.imul(k, de) | 0, i = (i = i + Math.imul(k, he) | 0) + Math.imul(P, de) | 0, o = o + Math.imul(P, he) | 0;
                var Pe = (u + (r = r + Math.imul(T, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(T, me) | 0) + Math.imul(M, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(M, me) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, r = Math.imul(B, oe), i = (i = Math.imul(B, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), r = r + Math.imul(N, le) | 0, i = (i = i + Math.imul(N, ue) | 0) + Math.imul(L, le) | 0, o = o + Math.imul(L, ue) | 0, r = r + Math.imul(R, de) | 0, i = (i = i + Math.imul(R, he) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, he) | 0;
                var Oe = (u + (r = r + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(P, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(P, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, r = Math.imul(B, le), i = (i = Math.imul(B, ue)) + Math.imul(F, le) | 0, o = Math.imul(F, ue), r = r + Math.imul(N, de) | 0, i = (i = i + Math.imul(N, he) | 0) + Math.imul(L, de) | 0, o = o + Math.imul(L, he) | 0;
                var Re = (u + (r = r + Math.imul(R, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, r = Math.imul(B, de), i = (i = Math.imul(B, he)) + Math.imul(F, de) | 0, o = Math.imul(F, he);
                var Ie = (u + (r = r + Math.imul(N, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(N, me) | 0) + Math.imul(L, pe) | 0)) << 13) | 0;
                u = ((o = o + Math.imul(L, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                var je = (u + (r = Math.imul(B, pe)) | 0) + ((8191 & (i = (i = Math.imul(B, me)) + Math.imul(F, pe) | 0)) << 13) | 0;
                return u = ((o = Math.imul(F, me)) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, l[0] = ge, l[1] = ve, l[2] = ye, l[3] = be, l[4] = _e, l[5] = xe, l[6] = we, l[7] = Se, l[8] = Ae, l[9] = Ee, l[10] = Te, l[11] = Me, l[12] = Ce, l[13] = ke, l[14] = Pe, l[15] = Oe, l[16] = Re, l[17] = Ie, l[18] = je, 0 !== u && (l[19] = u, n.length++), n;
              };
              function p(e, t, n) {
                return new m().mulp(e, t, n);
              }
              function m(e, t) {
                this.x = e, this.y = t;
              }
              Math.imul || (f = h), o.prototype.mulTo = function (e, t) {
                var n = this.length + e.length;
                return 10 === this.length && 10 === e.length ? f(this, e, t) : n < 63 ? h(this, e, t) : n < 1024 ? function (e, t, n) {
                  n.negative = t.negative ^ e.negative, n.length = e.length + t.length;
                  for (var r = 0, i = 0, o = 0; o < n.length - 1; o++) {
                    var a = i;
                    i = 0;
                    for (var s = 67108863 & r, l = Math.min(o, t.length - 1), u = Math.max(0, o - e.length + 1); u <= l; u++) {
                      var c = o - u,
                        d = (0 | e.words[c]) * (0 | t.words[u]),
                        h = 67108863 & d;
                      s = 67108863 & (h = h + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (h >>> 26) | 0) >>> 26, a &= 67108863;
                    }
                    n.words[o] = s, r = a, a = i;
                  }
                  return 0 !== r ? n.words[o] = r : n.length--, n.strip();
                }(this, e, t) : p(this, e, t);
              }, m.prototype.makeRBT = function (e) {
                for (var t = new Array(e), n = o.prototype._countBits(e) - 1, r = 0; r < e; r++) t[r] = this.revBin(r, n, e);
                return t;
              }, m.prototype.revBin = function (e, t, n) {
                if (0 === e || e === n - 1) return e;
                for (var r = 0, i = 0; i < t; i++) r |= (1 & e) << t - i - 1, e >>= 1;
                return r;
              }, m.prototype.permute = function (e, t, n, r, i, o) {
                for (var a = 0; a < o; a++) r[a] = t[e[a]], i[a] = n[e[a]];
              }, m.prototype.transform = function (e, t, n, r, i, o) {
                this.permute(o, e, t, n, r, i);
                for (var a = 1; a < i; a <<= 1) for (var s = a << 1, l = Math.cos(2 * Math.PI / s), u = Math.sin(2 * Math.PI / s), c = 0; c < i; c += s) for (var d = l, h = u, f = 0; f < a; f++) {
                  var p = n[c + f],
                    m = r[c + f],
                    g = n[c + f + a],
                    v = r[c + f + a],
                    y = d * g - h * v;
                  v = d * v + h * g, g = y, n[c + f] = p + g, r[c + f] = m + v, n[c + f + a] = p - g, r[c + f + a] = m - v, f !== s && (y = l * d - u * h, h = l * h + u * d, d = y);
                }
              }, m.prototype.guessLen13b = function (e, t) {
                var n = 1 | Math.max(t, e),
                  r = 1 & n,
                  i = 0;
                for (n = n / 2 | 0; n; n >>>= 1) i++;
                return 1 << i + 1 + r;
              }, m.prototype.conjugate = function (e, t, n) {
                if (!(n <= 1)) for (var r = 0; r < n / 2; r++) {
                  var i = e[r];
                  e[r] = e[n - r - 1], e[n - r - 1] = i, i = t[r], t[r] = -t[n - r - 1], t[n - r - 1] = -i;
                }
              }, m.prototype.normalize13b = function (e, t) {
                for (var n = 0, r = 0; r < t / 2; r++) {
                  var i = 8192 * Math.round(e[2 * r + 1] / t) + Math.round(e[2 * r] / t) + n;
                  e[r] = 67108863 & i, n = i < 67108864 ? 0 : i / 67108864 | 0;
                }
                return e;
              }, m.prototype.convert13b = function (e, t, n, i) {
                for (var o = 0, a = 0; a < t; a++) o += 0 | e[a], n[2 * a] = 8191 & o, o >>>= 13, n[2 * a + 1] = 8191 & o, o >>>= 13;
                for (a = 2 * t; a < i; ++a) n[a] = 0;
                r(0 === o), r(0 == (-8192 & o));
              }, m.prototype.stub = function (e) {
                for (var t = new Array(e), n = 0; n < e; n++) t[n] = 0;
                return t;
              }, m.prototype.mulp = function (e, t, n) {
                var r = 2 * this.guessLen13b(e.length, t.length),
                  i = this.makeRBT(r),
                  o = this.stub(r),
                  a = new Array(r),
                  s = new Array(r),
                  l = new Array(r),
                  u = new Array(r),
                  c = new Array(r),
                  d = new Array(r),
                  h = n.words;
                h.length = r, this.convert13b(e.words, e.length, a, r), this.convert13b(t.words, t.length, u, r), this.transform(a, o, s, l, r, i), this.transform(u, o, c, d, r, i);
                for (var f = 0; f < r; f++) {
                  var p = s[f] * c[f] - l[f] * d[f];
                  l[f] = s[f] * d[f] + l[f] * c[f], s[f] = p;
                }
                return this.conjugate(s, l, r), this.transform(s, l, h, o, r, i), this.conjugate(h, o, r), this.normalize13b(h, r), n.negative = e.negative ^ t.negative, n.length = e.length + t.length, n.strip();
              }, o.prototype.mul = function (e) {
                var t = new o(null);
                return t.words = new Array(this.length + e.length), this.mulTo(e, t);
              }, o.prototype.mulf = function (e) {
                var t = new o(null);
                return t.words = new Array(this.length + e.length), p(this, e, t);
              }, o.prototype.imul = function (e) {
                return this.clone().mulTo(e, this);
              }, o.prototype.imuln = function (e) {
                r("number" == typeof e), r(e < 67108864);
                for (var t = 0, n = 0; n < this.length; n++) {
                  var i = (0 | this.words[n]) * e,
                    o = (67108863 & i) + (67108863 & t);
                  t >>= 26, t += i / 67108864 | 0, t += o >>> 26, this.words[n] = 67108863 & o;
                }
                return 0 !== t && (this.words[n] = t, this.length++), this;
              }, o.prototype.muln = function (e) {
                return this.clone().imuln(e);
              }, o.prototype.sqr = function () {
                return this.mul(this);
              }, o.prototype.isqr = function () {
                return this.imul(this.clone());
              }, o.prototype.pow = function (e) {
                var t = function (e) {
                  for (var t = new Array(e.bitLength()), n = 0; n < t.length; n++) {
                    var r = n / 26 | 0,
                      i = n % 26;
                    t[n] = (e.words[r] & 1 << i) >>> i;
                  }
                  return t;
                }(e);
                if (0 === t.length) return new o(1);
                for (var n = this, r = 0; r < t.length && 0 === t[r]; r++, n = n.sqr());
                if (++r < t.length) for (var i = n.sqr(); r < t.length; r++, i = i.sqr()) 0 !== t[r] && (n = n.mul(i));
                return n;
              }, o.prototype.iushln = function (e) {
                r("number" == typeof e && e >= 0);
                var t,
                  n = e % 26,
                  i = (e - n) / 26,
                  o = 67108863 >>> 26 - n << 26 - n;
                if (0 !== n) {
                  var a = 0;
                  for (t = 0; t < this.length; t++) {
                    var s = this.words[t] & o,
                      l = (0 | this.words[t]) - s << n;
                    this.words[t] = l | a, a = s >>> 26 - n;
                  }
                  a && (this.words[t] = a, this.length++);
                }
                if (0 !== i) {
                  for (t = this.length - 1; t >= 0; t--) this.words[t + i] = this.words[t];
                  for (t = 0; t < i; t++) this.words[t] = 0;
                  this.length += i;
                }
                return this.strip();
              }, o.prototype.ishln = function (e) {
                return r(0 === this.negative), this.iushln(e);
              }, o.prototype.iushrn = function (e, t, n) {
                var i;
                r("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                var o = e % 26,
                  a = Math.min((e - o) / 26, this.length),
                  s = 67108863 ^ 67108863 >>> o << o,
                  l = n;
                if (i -= a, i = Math.max(0, i), l) {
                  for (var u = 0; u < a; u++) l.words[u] = this.words[u];
                  l.length = a;
                }
                if (0 === a) ;else if (this.length > a) for (this.length -= a, u = 0; u < this.length; u++) this.words[u] = this.words[u + a];else this.words[0] = 0, this.length = 1;
                var c = 0;
                for (u = this.length - 1; u >= 0 && (0 !== c || u >= i); u--) {
                  var d = 0 | this.words[u];
                  this.words[u] = c << 26 - o | d >>> o, c = d & s;
                }
                return l && 0 !== c && (l.words[l.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
              }, o.prototype.ishrn = function (e, t, n) {
                return r(0 === this.negative), this.iushrn(e, t, n);
              }, o.prototype.shln = function (e) {
                return this.clone().ishln(e);
              }, o.prototype.ushln = function (e) {
                return this.clone().iushln(e);
              }, o.prototype.shrn = function (e) {
                return this.clone().ishrn(e);
              }, o.prototype.ushrn = function (e) {
                return this.clone().iushrn(e);
              }, o.prototype.testn = function (e) {
                r("number" == typeof e && e >= 0);
                var t = e % 26,
                  n = (e - t) / 26,
                  i = 1 << t;
                return !(this.length <= n || !(this.words[n] & i));
              }, o.prototype.imaskn = function (e) {
                r("number" == typeof e && e >= 0);
                var t = e % 26,
                  n = (e - t) / 26;
                if (r(0 === this.negative, "imaskn works only with positive numbers"), this.length <= n) return this;
                if (0 !== t && n++, this.length = Math.min(n, this.length), 0 !== t) {
                  var i = 67108863 ^ 67108863 >>> t << t;
                  this.words[this.length - 1] &= i;
                }
                return this.strip();
              }, o.prototype.maskn = function (e) {
                return this.clone().imaskn(e);
              }, o.prototype.iaddn = function (e) {
                return r("number" == typeof e), r(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
              }, o.prototype._iaddn = function (e) {
                this.words[0] += e;
                for (var t = 0; t < this.length && this.words[t] >= 67108864; t++) this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                return this.length = Math.max(this.length, t + 1), this;
              }, o.prototype.isubn = function (e) {
                if (r("number" == typeof e), r(e < 67108864), e < 0) return this.iaddn(-e);
                if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var t = 0; t < this.length && this.words[t] < 0; t++) this.words[t] += 67108864, this.words[t + 1] -= 1;
                return this.strip();
              }, o.prototype.addn = function (e) {
                return this.clone().iaddn(e);
              }, o.prototype.subn = function (e) {
                return this.clone().isubn(e);
              }, o.prototype.iabs = function () {
                return this.negative = 0, this;
              }, o.prototype.abs = function () {
                return this.clone().iabs();
              }, o.prototype._ishlnsubmul = function (e, t, n) {
                var i,
                  o,
                  a = e.length + n;
                this._expand(a);
                var s = 0;
                for (i = 0; i < e.length; i++) {
                  o = (0 | this.words[i + n]) + s;
                  var l = (0 | e.words[i]) * t;
                  s = ((o -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + n] = 67108863 & o;
                }
                for (; i < this.length - n; i++) s = (o = (0 | this.words[i + n]) + s) >> 26, this.words[i + n] = 67108863 & o;
                if (0 === s) return this.strip();
                for (r(-1 === s), s = 0, i = 0; i < this.length; i++) s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
                return this.negative = 1, this.strip();
              }, o.prototype._wordDiv = function (e, t) {
                var n = (this.length, e.length),
                  r = this.clone(),
                  i = e,
                  a = 0 | i.words[i.length - 1];
                0 != (n = 26 - this._countBits(a)) && (i = i.ushln(n), r.iushln(n), a = 0 | i.words[i.length - 1]);
                var s,
                  l = r.length - i.length;
                if ("mod" !== t) {
                  (s = new o(null)).length = l + 1, s.words = new Array(s.length);
                  for (var u = 0; u < s.length; u++) s.words[u] = 0;
                }
                var c = r.clone()._ishlnsubmul(i, 1, l);
                0 === c.negative && (r = c, s && (s.words[l] = 1));
                for (var d = l - 1; d >= 0; d--) {
                  var h = 67108864 * (0 | r.words[i.length + d]) + (0 | r.words[i.length + d - 1]);
                  for (h = Math.min(h / a | 0, 67108863), r._ishlnsubmul(i, h, d); 0 !== r.negative;) h--, r.negative = 0, r._ishlnsubmul(i, 1, d), r.isZero() || (r.negative ^= 1);
                  s && (s.words[d] = h);
                }
                return s && s.strip(), r.strip(), "div" !== t && 0 !== n && r.iushrn(n), {
                  div: s || null,
                  mod: r
                };
              }, o.prototype.divmod = function (e, t, n) {
                return r(!e.isZero()), this.isZero() ? {
                  div: new o(0),
                  mod: new o(0)
                } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (i = s.div.neg()), "div" !== t && (a = s.mod.neg(), n && 0 !== a.negative && a.iadd(e)), {
                  div: i,
                  mod: a
                }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (i = s.div.neg()), {
                  div: i,
                  mod: s.mod
                }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (a = s.mod.neg(), n && 0 !== a.negative && a.isub(e)), {
                  div: s.div,
                  mod: a
                }) : e.length > this.length || this.cmp(e) < 0 ? {
                  div: new o(0),
                  mod: this
                } : 1 === e.length ? "div" === t ? {
                  div: this.divn(e.words[0]),
                  mod: null
                } : "mod" === t ? {
                  div: null,
                  mod: new o(this.modn(e.words[0]))
                } : {
                  div: this.divn(e.words[0]),
                  mod: new o(this.modn(e.words[0]))
                } : this._wordDiv(e, t);
                var i, a, s;
              }, o.prototype.div = function (e) {
                return this.divmod(e, "div", !1).div;
              }, o.prototype.mod = function (e) {
                return this.divmod(e, "mod", !1).mod;
              }, o.prototype.umod = function (e) {
                return this.divmod(e, "mod", !0).mod;
              }, o.prototype.divRound = function (e) {
                var t = this.divmod(e);
                if (t.mod.isZero()) return t.div;
                var n = 0 !== t.div.negative ? t.mod.isub(e) : t.mod,
                  r = e.ushrn(1),
                  i = e.andln(1),
                  o = n.cmp(r);
                return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
              }, o.prototype.modn = function (e) {
                r(e <= 67108863);
                for (var t = (1 << 26) % e, n = 0, i = this.length - 1; i >= 0; i--) n = (t * n + (0 | this.words[i])) % e;
                return n;
              }, o.prototype.idivn = function (e) {
                r(e <= 67108863);
                for (var t = 0, n = this.length - 1; n >= 0; n--) {
                  var i = (0 | this.words[n]) + 67108864 * t;
                  this.words[n] = i / e | 0, t = i % e;
                }
                return this.strip();
              }, o.prototype.divn = function (e) {
                return this.clone().idivn(e);
              }, o.prototype.egcd = function (e) {
                r(0 === e.negative), r(!e.isZero());
                var t = this,
                  n = e.clone();
                t = 0 !== t.negative ? t.umod(e) : t.clone();
                for (var i = new o(1), a = new o(0), s = new o(0), l = new o(1), u = 0; t.isEven() && n.isEven();) t.iushrn(1), n.iushrn(1), ++u;
                for (var c = n.clone(), d = t.clone(); !t.isZero();) {
                  for (var h = 0, f = 1; 0 == (t.words[0] & f) && h < 26; ++h, f <<= 1);
                  if (h > 0) for (t.iushrn(h); h-- > 0;) (i.isOdd() || a.isOdd()) && (i.iadd(c), a.isub(d)), i.iushrn(1), a.iushrn(1);
                  for (var p = 0, m = 1; 0 == (n.words[0] & m) && p < 26; ++p, m <<= 1);
                  if (p > 0) for (n.iushrn(p); p-- > 0;) (s.isOdd() || l.isOdd()) && (s.iadd(c), l.isub(d)), s.iushrn(1), l.iushrn(1);
                  t.cmp(n) >= 0 ? (t.isub(n), i.isub(s), a.isub(l)) : (n.isub(t), s.isub(i), l.isub(a));
                }
                return {
                  a: s,
                  b: l,
                  gcd: n.iushln(u)
                };
              }, o.prototype._invmp = function (e) {
                r(0 === e.negative), r(!e.isZero());
                var t = this,
                  n = e.clone();
                t = 0 !== t.negative ? t.umod(e) : t.clone();
                for (var i, a = new o(1), s = new o(0), l = n.clone(); t.cmpn(1) > 0 && n.cmpn(1) > 0;) {
                  for (var u = 0, c = 1; 0 == (t.words[0] & c) && u < 26; ++u, c <<= 1);
                  if (u > 0) for (t.iushrn(u); u-- > 0;) a.isOdd() && a.iadd(l), a.iushrn(1);
                  for (var d = 0, h = 1; 0 == (n.words[0] & h) && d < 26; ++d, h <<= 1);
                  if (d > 0) for (n.iushrn(d); d-- > 0;) s.isOdd() && s.iadd(l), s.iushrn(1);
                  t.cmp(n) >= 0 ? (t.isub(n), a.isub(s)) : (n.isub(t), s.isub(a));
                }
                return (i = 0 === t.cmpn(1) ? a : s).cmpn(0) < 0 && i.iadd(e), i;
              }, o.prototype.gcd = function (e) {
                if (this.isZero()) return e.abs();
                if (e.isZero()) return this.abs();
                var t = this.clone(),
                  n = e.clone();
                t.negative = 0, n.negative = 0;
                for (var r = 0; t.isEven() && n.isEven(); r++) t.iushrn(1), n.iushrn(1);
                for (;;) {
                  for (; t.isEven();) t.iushrn(1);
                  for (; n.isEven();) n.iushrn(1);
                  var i = t.cmp(n);
                  if (i < 0) {
                    var o = t;
                    t = n, n = o;
                  } else if (0 === i || 0 === n.cmpn(1)) break;
                  t.isub(n);
                }
                return n.iushln(r);
              }, o.prototype.invm = function (e) {
                return this.egcd(e).a.umod(e);
              }, o.prototype.isEven = function () {
                return 0 == (1 & this.words[0]);
              }, o.prototype.isOdd = function () {
                return 1 == (1 & this.words[0]);
              }, o.prototype.andln = function (e) {
                return this.words[0] & e;
              }, o.prototype.bincn = function (e) {
                r("number" == typeof e);
                var t = e % 26,
                  n = (e - t) / 26,
                  i = 1 << t;
                if (this.length <= n) return this._expand(n + 1), this.words[n] |= i, this;
                for (var o = i, a = n; 0 !== o && a < this.length; a++) {
                  var s = 0 | this.words[a];
                  o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
                }
                return 0 !== o && (this.words[a] = o, this.length++), this;
              }, o.prototype.isZero = function () {
                return 1 === this.length && 0 === this.words[0];
              }, o.prototype.cmpn = function (e) {
                var t,
                  n = e < 0;
                if (0 !== this.negative && !n) return -1;
                if (0 === this.negative && n) return 1;
                if (this.strip(), this.length > 1) t = 1;else {
                  n && (e = -e), r(e <= 67108863, "Number is too big");
                  var i = 0 | this.words[0];
                  t = i === e ? 0 : i < e ? -1 : 1;
                }
                return 0 !== this.negative ? 0 | -t : t;
              }, o.prototype.cmp = function (e) {
                if (0 !== this.negative && 0 === e.negative) return -1;
                if (0 === this.negative && 0 !== e.negative) return 1;
                var t = this.ucmp(e);
                return 0 !== this.negative ? 0 | -t : t;
              }, o.prototype.ucmp = function (e) {
                if (this.length > e.length) return 1;
                if (this.length < e.length) return -1;
                for (var t = 0, n = this.length - 1; n >= 0; n--) {
                  var r = 0 | this.words[n],
                    i = 0 | e.words[n];
                  if (r !== i) {
                    r < i ? t = -1 : r > i && (t = 1);
                    break;
                  }
                }
                return t;
              }, o.prototype.gtn = function (e) {
                return 1 === this.cmpn(e);
              }, o.prototype.gt = function (e) {
                return 1 === this.cmp(e);
              }, o.prototype.gten = function (e) {
                return this.cmpn(e) >= 0;
              }, o.prototype.gte = function (e) {
                return this.cmp(e) >= 0;
              }, o.prototype.ltn = function (e) {
                return -1 === this.cmpn(e);
              }, o.prototype.lt = function (e) {
                return -1 === this.cmp(e);
              }, o.prototype.lten = function (e) {
                return this.cmpn(e) <= 0;
              }, o.prototype.lte = function (e) {
                return this.cmp(e) <= 0;
              }, o.prototype.eqn = function (e) {
                return 0 === this.cmpn(e);
              }, o.prototype.eq = function (e) {
                return 0 === this.cmp(e);
              }, o.red = function (e) {
                return new w(e);
              }, o.prototype.toRed = function (e) {
                return r(!this.red, "Already a number in reduction context"), r(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
              }, o.prototype.fromRed = function () {
                return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
              }, o.prototype._forceRed = function (e) {
                return this.red = e, this;
              }, o.prototype.forceRed = function (e) {
                return r(!this.red, "Already a number in reduction context"), this._forceRed(e);
              }, o.prototype.redAdd = function (e) {
                return r(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
              }, o.prototype.redIAdd = function (e) {
                return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
              }, o.prototype.redSub = function (e) {
                return r(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
              }, o.prototype.redISub = function (e) {
                return r(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
              }, o.prototype.redShl = function (e) {
                return r(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
              }, o.prototype.redMul = function (e) {
                return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
              }, o.prototype.redIMul = function (e) {
                return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
              }, o.prototype.redSqr = function () {
                return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
              }, o.prototype.redISqr = function () {
                return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
              }, o.prototype.redSqrt = function () {
                return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
              }, o.prototype.redInvm = function () {
                return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
              }, o.prototype.redNeg = function () {
                return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
              }, o.prototype.redPow = function (e) {
                return r(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
              };
              var g = {
                k256: null,
                p224: null,
                p192: null,
                p25519: null
              };
              function v(e, t) {
                this.name = e, this.p = new o(t, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
              }
              function y() {
                v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
              }
              function b() {
                v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
              }
              function _() {
                v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
              }
              function x() {
                v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
              }
              function w(e) {
                if ("string" == typeof e) {
                  var t = o._prime(e);
                  this.m = t.p, this.prime = t;
                } else r(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
              }
              function S(e) {
                w.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
              }
              v.prototype._tmp = function () {
                var e = new o(null);
                return e.words = new Array(Math.ceil(this.n / 13)), e;
              }, v.prototype.ireduce = function (e) {
                var t,
                  n = e;
                do {
                  this.split(n, this.tmp), t = (n = (n = this.imulK(n)).iadd(this.tmp)).bitLength();
                } while (t > this.n);
                var r = t < this.n ? -1 : n.ucmp(this.p);
                return 0 === r ? (n.words[0] = 0, n.length = 1) : r > 0 ? n.isub(this.p) : n.strip(), n;
              }, v.prototype.split = function (e, t) {
                e.iushrn(this.n, 0, t);
              }, v.prototype.imulK = function (e) {
                return e.imul(this.k);
              }, i(y, v), y.prototype.split = function (e, t) {
                for (var n = Math.min(e.length, 9), r = 0; r < n; r++) t.words[r] = e.words[r];
                if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                var i = e.words[9];
                for (t.words[t.length++] = 4194303 & i, r = 10; r < e.length; r++) {
                  var o = 0 | e.words[r];
                  e.words[r - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
                }
                i >>>= 22, e.words[r - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
              }, y.prototype.imulK = function (e) {
                e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                for (var t = 0, n = 0; n < e.length; n++) {
                  var r = 0 | e.words[n];
                  t += 977 * r, e.words[n] = 67108863 & t, t = 64 * r + (t / 67108864 | 0);
                }
                return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
              }, i(b, v), i(_, v), i(x, v), x.prototype.imulK = function (e) {
                for (var t = 0, n = 0; n < e.length; n++) {
                  var r = 19 * (0 | e.words[n]) + t,
                    i = 67108863 & r;
                  r >>>= 26, e.words[n] = i, t = r;
                }
                return 0 !== t && (e.words[e.length++] = t), e;
              }, o._prime = function (e) {
                if (g[e]) return g[e];
                var t;
                if ("k256" === e) t = new y();else if ("p224" === e) t = new b();else if ("p192" === e) t = new _();else {
                  if ("p25519" !== e) throw new Error("Unknown prime " + e);
                  t = new x();
                }
                return g[e] = t, t;
              }, w.prototype._verify1 = function (e) {
                r(0 === e.negative, "red works only with positives"), r(e.red, "red works only with red numbers");
              }, w.prototype._verify2 = function (e, t) {
                r(0 == (e.negative | t.negative), "red works only with positives"), r(e.red && e.red === t.red, "red works only with red numbers");
              }, w.prototype.imod = function (e) {
                return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
              }, w.prototype.neg = function (e) {
                return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
              }, w.prototype.add = function (e, t) {
                this._verify2(e, t);
                var n = e.add(t);
                return n.cmp(this.m) >= 0 && n.isub(this.m), n._forceRed(this);
              }, w.prototype.iadd = function (e, t) {
                this._verify2(e, t);
                var n = e.iadd(t);
                return n.cmp(this.m) >= 0 && n.isub(this.m), n;
              }, w.prototype.sub = function (e, t) {
                this._verify2(e, t);
                var n = e.sub(t);
                return n.cmpn(0) < 0 && n.iadd(this.m), n._forceRed(this);
              }, w.prototype.isub = function (e, t) {
                this._verify2(e, t);
                var n = e.isub(t);
                return n.cmpn(0) < 0 && n.iadd(this.m), n;
              }, w.prototype.shl = function (e, t) {
                return this._verify1(e), this.imod(e.ushln(t));
              }, w.prototype.imul = function (e, t) {
                return this._verify2(e, t), this.imod(e.imul(t));
              }, w.prototype.mul = function (e, t) {
                return this._verify2(e, t), this.imod(e.mul(t));
              }, w.prototype.isqr = function (e) {
                return this.imul(e, e.clone());
              }, w.prototype.sqr = function (e) {
                return this.mul(e, e);
              }, w.prototype.sqrt = function (e) {
                if (e.isZero()) return e.clone();
                var t = this.m.andln(3);
                if (r(t % 2 == 1), 3 === t) {
                  var n = this.m.add(new o(1)).iushrn(2);
                  return this.pow(e, n);
                }
                for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) a++, i.iushrn(1);
                r(!i.isZero());
                var s = new o(1).toRed(this),
                  l = s.redNeg(),
                  u = this.m.subn(1).iushrn(1),
                  c = this.m.bitLength();
                for (c = new o(2 * c * c).toRed(this); 0 !== this.pow(c, u).cmp(l);) c.redIAdd(l);
                for (var d = this.pow(c, i), h = this.pow(e, i.addn(1).iushrn(1)), f = this.pow(e, i), p = a; 0 !== f.cmp(s);) {
                  for (var m = f, g = 0; 0 !== m.cmp(s); g++) m = m.redSqr();
                  r(g < p);
                  var v = this.pow(d, new o(1).iushln(p - g - 1));
                  h = h.redMul(v), d = v.redSqr(), f = f.redMul(d), p = g;
                }
                return h;
              }, w.prototype.invm = function (e) {
                var t = e._invmp(this.m);
                return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
              }, w.prototype.pow = function (e, t) {
                if (t.isZero()) return new o(1).toRed(this);
                if (0 === t.cmpn(1)) return e.clone();
                var n = new Array(16);
                n[0] = new o(1).toRed(this), n[1] = e;
                for (var r = 2; r < n.length; r++) n[r] = this.mul(n[r - 1], e);
                var i = n[0],
                  a = 0,
                  s = 0,
                  l = t.bitLength() % 26;
                for (0 === l && (l = 26), r = t.length - 1; r >= 0; r--) {
                  for (var u = t.words[r], c = l - 1; c >= 0; c--) {
                    var d = u >> c & 1;
                    i !== n[0] && (i = this.sqr(i)), 0 !== d || 0 !== a ? (a <<= 1, a |= d, (4 == ++s || 0 === r && 0 === c) && (i = this.mul(i, n[a]), s = 0, a = 0)) : s = 0;
                  }
                  l = 26;
                }
                return i;
              }, w.prototype.convertTo = function (e) {
                var t = e.umod(this.m);
                return t === e ? t.clone() : t;
              }, w.prototype.convertFrom = function (e) {
                var t = e.clone();
                return t.red = null, t;
              }, o.mont = function (e) {
                return new S(e);
              }, i(S, w), S.prototype.convertTo = function (e) {
                return this.imod(e.ushln(this.shift));
              }, S.prototype.convertFrom = function (e) {
                var t = this.imod(e.mul(this.rinv));
                return t.red = null, t;
              }, S.prototype.imul = function (e, t) {
                if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                var n = e.imul(t),
                  r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                  i = n.isub(r).iushrn(this.shift),
                  o = i;
                return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
              }, S.prototype.mul = function (e, t) {
                if (e.isZero() || t.isZero()) return new o(0)._forceRed(this);
                var n = e.mul(t),
                  r = n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                  i = n.isub(r).iushrn(this.shift),
                  a = i;
                return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
              }, S.prototype.invm = function (e) {
                return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
              };
            }(void 0 === t || t, this);
          }, {
            buffer: 47
          }],
          39: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t,
                n,
                r,
                i = e.length,
                o = 0;
              for (t = 0; t < i; ++t) o += e[t].length;
              var a = new Array(o),
                s = 0;
              for (t = 0; t < i; ++t) {
                var l = e[t],
                  u = l.length;
                for (n = 0; n < u; ++n) {
                  var c = a[s++] = new Array(u - 1),
                    d = 0;
                  for (r = 0; r < u; ++r) r !== n && (c[d++] = l[r]);
                  if (1 & n) {
                    var h = c[1];
                    c[1] = c[0], c[0] = h;
                  }
                }
              }
              return a;
            };
          }, {}],
          40: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              switch (arguments.length) {
                case 1:
                  return r = [], u(i = e, i, c, !0), r;
                case 2:
                  return "function" == typeof t ? u(e, e, t, !0) : function (e, t) {
                    return r = [], u(e, t, c, !1), r;
                  }(e, t);
                case 3:
                  return u(e, t, n, !1);
                default:
                  throw new Error("box-intersect: Invalid arguments");
              }
              var i;
            };
            var r,
              i = e("typedarray-pool"),
              o = e("./lib/sweep"),
              a = e("./lib/intersect");
            function s(e, t) {
              for (var n = 0; n < e; ++n) if (!(t[n] <= t[n + e])) return !0;
              return !1;
            }
            function l(e, t, n, r) {
              for (var i = 0, o = 0, a = 0, l = e.length; a < l; ++a) {
                var u = e[a];
                if (!s(t, u)) {
                  for (var c = 0; c < 2 * t; ++c) n[i++] = u[c];
                  r[o++] = a;
                }
              }
              return o;
            }
            function u(e, t, n, r) {
              var s = e.length,
                u = t.length;
              if (!(s <= 0 || u <= 0)) {
                var c = e[0].length >>> 1;
                if (!(c <= 0)) {
                  var d,
                    h = i.mallocDouble(2 * c * s),
                    f = i.mallocInt32(s);
                  if ((s = l(e, c, h, f)) > 0) {
                    if (1 === c && r) o.init(s), d = o.sweepComplete(c, n, 0, s, h, f, 0, s, h, f);else {
                      var p = i.mallocDouble(2 * c * u),
                        m = i.mallocInt32(u);
                      (u = l(t, c, p, m)) > 0 && (o.init(s + u), d = 1 === c ? o.sweepBipartite(c, n, 0, s, h, f, 0, u, p, m) : a(c, n, r, s, h, f, u, p, m), i.free(p), i.free(m));
                    }
                    i.free(h), i.free(f);
                  }
                  return d;
                }
              }
            }
            function c(e, t) {
              r.push([e, t]);
            }
          }, {
            "./lib/intersect": 42,
            "./lib/sweep": 46,
            "typedarray-pool": 347
          }],
          41: [function (e, t, n) {
            "use strict";

            var r = "d",
              i = "ax",
              o = "fp",
              a = "es",
              s = "rs",
              l = "re",
              u = "rb",
              c = "bs",
              d = "be",
              h = "bb",
              f = [r, i, "vv", s, l, u, "ri", c, d, h, "bi"];
            function p(e) {
              var t = "bruteForce" + (e ? "Full" : "Partial"),
                n = [],
                i = f.slice();
              e || i.splice(3, 0, o);
              var s = ["function " + t + "(" + i.join() + "){"];
              function l(t, i) {
                var o = function (e, t, n) {
                  var i = "bruteForce" + (e ? "Red" : "Blue") + (t ? "Flip" : "") + (n ? "Full" : ""),
                    o = ["function ", i, "(", f.join(), "){", "var ", a, "=2*", r, ";"],
                    s = "for(var i=rs,rp=es*rs;i<re;++i,rp+=es){var x0=rb[ax+rp],x1=rb[ax+rp+d],xi=ri[i];",
                    l = "for(var j=bs,bp=es*bs;j<be;++j,bp+=es){var y0=bb[ax+bp]," + (n ? "y1=bb[ax+bp+d]," : "") + "yi=bi[j];";
                  return e ? o.push(s, "Q", ":", l) : o.push(l, "Q", ":", s), n ? o.push("if(y1<x0||x1<y0)continue;") : t ? o.push("if(y0<=x0||x1<y0)continue;") : o.push("if(y0<x0||x1<y0)continue;"), o.push("for(var k=ax+1;k<d;++k){var r0=rb[k+rp],r1=rb[k+d+rp],b0=bb[k+bp],b1=bb[k+d+bp];if(r1<b0||b1<r0)continue Q;}var rv=vv("), t ? o.push("yi,xi") : o.push("xi,yi"), o.push(");if(rv!==void 0)return rv;}}}"), {
                    name: i,
                    code: o.join("")
                  };
                }(t, i, e);
                n.push(o.code), s.push("return " + o.name + "(" + f.join() + ");");
              }
              s.push("if(re-rs>be-bs){"), e ? (l(!0, !1), s.push("}else{"), l(!1, !1)) : (s.push("if(fp){"), l(!0, !0), s.push("}else{"), l(!0, !1), s.push("}}else{if(fp){"), l(!1, !0), s.push("}else{"), l(!1, !1), s.push("}")), s.push("}}return " + t);
              var u = n.join("") + s.join("");
              return new Function(u)();
            }
            n.partial = p(!1), n.full = p(!0);
          }, {}],
          42: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, o, c, M, C, k, P) {
              !function (e, t) {
                var n = 8 * i.log2(t + 1) * (e + 1) | 0,
                  o = i.nextPow2(_ * n);
                w.length < o && (r.free(w), w = r.mallocInt32(o));
                var a = i.nextPow2(x * n);
                S < a && (r.free(S), S = r.mallocDouble(a));
              }(e, o + C);
              var O,
                R = 0,
                I = 2 * e;
              for (A(R++, 0, 0, o, 0, C, n ? 16 : 0, -1 / 0, 1 / 0), n || A(R++, 0, 0, C, 0, o, 1, -1 / 0, 1 / 0); R > 0;) {
                var j = (R -= 1) * _,
                  N = w[j],
                  L = w[j + 1],
                  D = w[j + 2],
                  B = w[j + 3],
                  F = w[j + 4],
                  z = w[j + 5],
                  U = R * x,
                  G = S[U],
                  V = S[U + 1],
                  H = 1 & z,
                  q = !!(16 & z),
                  W = c,
                  $ = M,
                  X = k,
                  Y = P;
                if (H && (W = k, $ = P, X = c, Y = M), !(2 & z && (D = g(e, N, L, D, W, $, V), L >= D) || 4 & z && (L = v(e, N, L, D, W, $, G)) >= D)) {
                  var K = D - L,
                    Z = F - B;
                  if (q) {
                    if (e * K * (K + Z) < f) {
                      if (void 0 !== (O = l.scanComplete(e, N, t, L, D, W, $, B, F, X, Y))) return O;
                      continue;
                    }
                  } else {
                    if (e * Math.min(K, Z) < d) {
                      if (void 0 !== (O = a(e, N, t, H, L, D, W, $, B, F, X, Y))) return O;
                      continue;
                    }
                    if (e * K * Z < h) {
                      if (void 0 !== (O = l.scanBipartite(e, N, t, H, L, D, W, $, B, F, X, Y))) return O;
                      continue;
                    }
                  }
                  var Q = p(e, N, L, D, W, $, G, V);
                  if (L < Q) if (e * (Q - L) < d) {
                    if (void 0 !== (O = s(e, N + 1, t, L, Q, W, $, B, F, X, Y))) return O;
                  } else if (N === e - 2) {
                    if (void 0 !== (O = H ? l.sweepBipartite(e, t, B, F, X, Y, L, Q, W, $) : l.sweepBipartite(e, t, L, Q, W, $, B, F, X, Y))) return O;
                  } else A(R++, N + 1, L, Q, B, F, H, -1 / 0, 1 / 0), A(R++, N + 1, B, F, L, Q, 1 ^ H, -1 / 0, 1 / 0);
                  if (Q < D) {
                    var J = u(e, N, B, F, X, Y),
                      ee = X[I * J + N],
                      te = m(e, N, J, F, X, Y, ee);
                    if (te < F && A(R++, N, Q, D, te, F, (4 | H) + (q ? 16 : 0), ee, V), B < J && A(R++, N, Q, D, B, J, (2 | H) + (q ? 16 : 0), G, ee), J + 1 === te) {
                      if (void 0 !== (O = q ? T(e, N, t, Q, D, W, $, J, X, Y[J]) : E(e, N, t, H, Q, D, W, $, J, X, Y[J]))) return O;
                    } else if (J < te) {
                      var ne;
                      if (q) {
                        if (Q < (ne = y(e, N, Q, D, W, $, ee))) {
                          var re = m(e, N, Q, ne, W, $, ee);
                          if (N === e - 2) {
                            if (Q < re && void 0 !== (O = l.sweepComplete(e, t, Q, re, W, $, J, te, X, Y))) return O;
                            if (re < ne && void 0 !== (O = l.sweepBipartite(e, t, re, ne, W, $, J, te, X, Y))) return O;
                          } else Q < re && A(R++, N + 1, Q, re, J, te, 16, -1 / 0, 1 / 0), re < ne && (A(R++, N + 1, re, ne, J, te, 0, -1 / 0, 1 / 0), A(R++, N + 1, J, te, re, ne, 1, -1 / 0, 1 / 0));
                        }
                      } else Q < (ne = H ? b(e, N, Q, D, W, $, ee) : y(e, N, Q, D, W, $, ee)) && (N === e - 2 ? O = H ? l.sweepBipartite(e, t, J, te, X, Y, Q, ne, W, $) : l.sweepBipartite(e, t, Q, ne, W, $, J, te, X, Y) : (A(R++, N + 1, Q, ne, J, te, H, -1 / 0, 1 / 0), A(R++, N + 1, J, te, Q, ne, 1 ^ H, -1 / 0, 1 / 0)));
                    }
                  }
                }
              }
            };
            var r = e("typedarray-pool"),
              i = e("bit-twiddle"),
              o = e("./brute"),
              a = o.partial,
              s = o.full,
              l = e("./sweep"),
              u = e("./median"),
              c = e("./partition"),
              d = 128,
              h = 1 << 22,
              f = 1 << 22,
              p = c("!(lo>=p0)&&!(p1>=hi)", ["p0", "p1"]),
              m = c("lo===p0", ["p0"]),
              g = c("lo<p0", ["p0"]),
              v = c("hi<=p0", ["p0"]),
              y = c("lo<=p0&&p0<=hi", ["p0"]),
              b = c("lo<p0&&p0<=hi", ["p0"]),
              _ = 6,
              x = 2,
              w = r.mallocInt32(1024),
              S = r.mallocDouble(1024);
            function A(e, t, n, r, i, o, a, s, l) {
              var u = _ * e;
              w[u] = t, w[u + 1] = n, w[u + 2] = r, w[u + 3] = i, w[u + 4] = o, w[u + 5] = a;
              var c = x * e;
              S[c] = s, S[c + 1] = l;
            }
            function E(e, t, n, r, i, o, a, s, l, u, c) {
              var d = 2 * e,
                h = l * d,
                f = u[h + t];
              e: for (var p = i, m = i * d; p < o; ++p, m += d) {
                var g = a[m + t],
                  v = a[m + t + e];
                if (!(f < g || v < f || r && f === g)) {
                  for (var y, b = s[p], _ = t + 1; _ < e; ++_) {
                    g = a[m + _], v = a[m + _ + e];
                    var x = u[h + _],
                      w = u[h + _ + e];
                    if (v < x || w < g) continue e;
                  }
                  if (void 0 !== (y = r ? n(c, b) : n(b, c))) return y;
                }
              }
            }
            function T(e, t, n, r, i, o, a, s, l, u) {
              var c = 2 * e,
                d = s * c,
                h = l[d + t];
              e: for (var f = r, p = r * c; f < i; ++f, p += c) {
                var m = a[f];
                if (m !== u) {
                  var g = o[p + t],
                    v = o[p + t + e];
                  if (!(h < g || v < h)) {
                    for (var y = t + 1; y < e; ++y) {
                      g = o[p + y], v = o[p + y + e];
                      var b = l[d + y],
                        _ = l[d + y + e];
                      if (v < b || _ < g) continue e;
                    }
                    var x = n(m, u);
                    if (void 0 !== x) return x;
                  }
                }
              }
            }
          }, {
            "./brute": 41,
            "./median": 43,
            "./partition": 44,
            "./sweep": 46,
            "bit-twiddle": 37,
            "typedarray-pool": 347
          }],
          43: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, a, s, l) {
              if (a <= n + 1) return n;
              for (var u = n, c = a, d = a + n >>> 1, h = 2 * e, f = d, p = s[h * d + t]; u < c;) {
                if (c - u < i) {
                  o(e, t, u, c, s, l), p = s[h * d + t];
                  break;
                }
                var m = c - u,
                  g = Math.random() * m + u | 0,
                  v = s[h * g + t],
                  y = Math.random() * m + u | 0,
                  b = s[h * y + t],
                  _ = Math.random() * m + u | 0,
                  x = s[h * _ + t];
                v <= b ? x >= b ? (f = y, p = b) : v >= x ? (f = g, p = v) : (f = _, p = x) : b >= x ? (f = y, p = b) : x >= v ? (f = g, p = v) : (f = _, p = x);
                for (var w = h * (c - 1), S = h * f, A = 0; A < h; ++A, ++w, ++S) {
                  var E = s[w];
                  s[w] = s[S], s[S] = E;
                }
                var T = l[c - 1];
                for (l[c - 1] = l[f], l[f] = T, w = h * (c - 1), S = h * (f = r(e, t, u, c - 1, s, l, p)), A = 0; A < h; ++A, ++w, ++S) E = s[w], s[w] = s[S], s[S] = E;
                if (T = l[c - 1], l[c - 1] = l[f], l[f] = T, d < f) {
                  for (c = f - 1; u < c && s[h * (c - 1) + t] === p;) c -= 1;
                  c += 1;
                } else {
                  if (!(f < d)) break;
                  for (u = f + 1; u < c && s[h * u + t] === p;) u += 1;
                }
              }
              return r(e, t, n, d, s, l, s[h * d + t]);
            };
            var r = e("./partition")("lo<p0", ["p0"]),
              i = 8;
            function o(e, t, n, r, i, o) {
              for (var a = 2 * e, s = a * (n + 1) + t, l = n + 1; l < r; ++l, s += a) for (var u = i[s], c = l, d = a * (l - 1); c > n && i[d + t] > u; --c, d -= a) {
                for (var h = d, f = d + a, p = 0; p < a; ++p, ++h, ++f) {
                  var m = i[h];
                  i[h] = i[f], i[f] = m;
                }
                var g = o[c];
                o[c] = o[c - 1], o[c - 1] = g;
              }
            }
          }, {
            "./partition": 44
          }],
          44: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = "abcdef".split("").concat(t),
                i = [];
              return e.indexOf("lo") >= 0 && i.push("lo=e[k+n]"), e.indexOf("hi") >= 0 && i.push("hi=e[k+o]"), n.push(r.replace("_", i.join()).replace("$", e)), Function.apply(void 0, n);
            };
            var r = "for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m";
          }, {}],
          45: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              t <= 4 * r ? i(0, t - 1, e) : function e(t, n, d) {
                var h = (n - t + 1) / 6 | 0,
                  f = t + h,
                  p = n - h,
                  m = t + n >> 1,
                  g = m - h,
                  v = m + h,
                  y = f,
                  b = g,
                  _ = m,
                  x = v,
                  w = p,
                  S = t + 1,
                  A = n - 1,
                  E = 0;
                u(y, b, d) && (E = y, y = b, b = E), u(x, w, d) && (E = x, x = w, w = E), u(y, _, d) && (E = y, y = _, _ = E), u(b, _, d) && (E = b, b = _, _ = E), u(y, x, d) && (E = y, y = x, x = E), u(_, x, d) && (E = _, _ = x, x = E), u(b, w, d) && (E = b, b = w, w = E), u(b, _, d) && (E = b, b = _, _ = E), u(x, w, d) && (E = x, x = w, w = E);
                for (var T = d[2 * b], M = d[2 * b + 1], C = d[2 * x], k = d[2 * x + 1], P = 2 * y, O = 2 * _, R = 2 * w, I = 2 * f, j = 2 * m, N = 2 * p, L = 0; L < 2; ++L) {
                  var D = d[P + L],
                    B = d[O + L],
                    F = d[R + L];
                  d[I + L] = D, d[j + L] = B, d[N + L] = F;
                }
                a(g, t, d), a(v, n, d);
                for (var z = S; z <= A; ++z) if (c(z, T, M, d)) z !== S && o(z, S, d), ++S;else if (!c(z, C, k, d)) for (;;) {
                  if (c(A, C, k, d)) {
                    c(A, T, M, d) ? (s(z, S, A, d), ++S, --A) : (o(z, A, d), --A);
                    break;
                  }
                  if (--A < z) break;
                }
                l(t, S - 1, T, M, d), l(n, A + 1, C, k, d), S - 2 - t <= r ? i(t, S - 2, d) : e(t, S - 2, d), n - (A + 2) <= r ? i(A + 2, n, d) : e(A + 2, n, d), A - S <= r ? i(S, A, d) : e(S, A, d);
              }(0, t - 1, e);
            };
            var r = 32;
            function i(e, t, n) {
              for (var r = 2 * (e + 1), i = e + 1; i <= t; ++i) {
                for (var o = n[r++], a = n[r++], s = i, l = r - 2; s-- > e;) {
                  var u = n[l - 2],
                    c = n[l - 1];
                  if (u < o) break;
                  if (u === o && c < a) break;
                  n[l] = u, n[l + 1] = c, l -= 2;
                }
                n[l] = o, n[l + 1] = a;
              }
            }
            function o(e, t, n) {
              t *= 2;
              var r = n[e *= 2],
                i = n[e + 1];
              n[e] = n[t], n[e + 1] = n[t + 1], n[t] = r, n[t + 1] = i;
            }
            function a(e, t, n) {
              t *= 2, n[e *= 2] = n[t], n[e + 1] = n[t + 1];
            }
            function s(e, t, n, r) {
              t *= 2, n *= 2;
              var i = r[e *= 2],
                o = r[e + 1];
              r[e] = r[t], r[e + 1] = r[t + 1], r[t] = r[n], r[t + 1] = r[n + 1], r[n] = i, r[n + 1] = o;
            }
            function l(e, t, n, r, i) {
              t *= 2, i[e *= 2] = i[t], i[t] = n, i[e + 1] = i[t + 1], i[t + 1] = r;
            }
            function u(e, t, n) {
              t *= 2;
              var r = n[e *= 2],
                i = n[t];
              return !(r < i) && (r !== i || n[e + 1] > n[t + 1]);
            }
            function c(e, t, n, r) {
              var i = r[e *= 2];
              return i < t || i === t && r[e + 1] < n;
            }
          }, {}],
          46: [function (e, t, n) {
            "use strict";

            t.exports = {
              init: function init(e) {
                var t = i.nextPow2(e);
                s.length < t && (r.free(s), s = r.mallocInt32(t)), l.length < t && (r.free(l), l = r.mallocInt32(t)), u.length < t && (r.free(u), u = r.mallocInt32(t)), c.length < t && (r.free(c), c = r.mallocInt32(t)), d.length < t && (r.free(d), d = r.mallocInt32(t)), h.length < t && (r.free(h), h = r.mallocInt32(t));
                var n = 8 * t;
                f.length < n && (r.free(f), f = r.mallocDouble(n));
              },
              sweepBipartite: function sweepBipartite(e, t, n, r, i, d, h, g, v, y) {
                for (var b = 0, _ = 2 * e, x = e - 1, w = _ - 1, S = n; S < r; ++S) {
                  var A = d[S],
                    E = _ * S;
                  f[b++] = i[E + x], f[b++] = -(A + 1), f[b++] = i[E + w], f[b++] = A;
                }
                for (S = h; S < g; ++S) {
                  A = y[S] + a;
                  var T = _ * S;
                  f[b++] = v[T + x], f[b++] = -A, f[b++] = v[T + w], f[b++] = A;
                }
                var M = b >>> 1;
                o(f, M);
                var C = 0,
                  k = 0;
                for (S = 0; S < M; ++S) {
                  var P = 0 | f[2 * S + 1];
                  if (P >= a) p(u, c, k--, P = P - a | 0);else if (P >= 0) p(s, l, C--, P);else if (P <= -a) {
                    P = -P - a | 0;
                    for (var O = 0; O < C; ++O) if (void 0 !== (R = t(s[O], P))) return R;
                    m(u, c, k++, P);
                  } else {
                    for (P = -P - 1 | 0, O = 0; O < k; ++O) {
                      var R;
                      if (void 0 !== (R = t(P, u[O]))) return R;
                    }
                    m(s, l, C++, P);
                  }
                }
              },
              sweepComplete: function sweepComplete(e, t, n, r, i, a, g, v, y, b) {
                for (var _ = 0, x = 2 * e, w = e - 1, S = x - 1, A = n; A < r; ++A) {
                  var E = a[A] + 1 << 1,
                    T = x * A;
                  f[_++] = i[T + w], f[_++] = -E, f[_++] = i[T + S], f[_++] = E;
                }
                for (A = g; A < v; ++A) {
                  E = b[A] + 1 << 1;
                  var M = x * A;
                  f[_++] = y[M + w], f[_++] = 1 | -E, f[_++] = y[M + S], f[_++] = 1 | E;
                }
                var C = _ >>> 1;
                o(f, C);
                var k = 0,
                  P = 0,
                  O = 0;
                for (A = 0; A < C; ++A) {
                  var R = 0 | f[2 * A + 1],
                    I = 1 & R;
                  if (A < C - 1 && R >> 1 == f[2 * A + 3] >> 1 && (I = 2, A += 1), R < 0) {
                    for (var j = -(R >> 1) - 1, N = 0; N < O; ++N) if (void 0 !== (L = t(d[N], j))) return L;
                    if (0 !== I) for (N = 0; N < k; ++N) if (void 0 !== (L = t(s[N], j))) return L;
                    if (1 !== I) for (N = 0; N < P; ++N) {
                      var L;
                      if (void 0 !== (L = t(u[N], j))) return L;
                    }
                    0 === I ? m(s, l, k++, j) : 1 === I ? m(u, c, P++, j) : 2 === I && m(d, h, O++, j);
                  } else j = (R >> 1) - 1, 0 === I ? p(s, l, k--, j) : 1 === I ? p(u, c, P--, j) : 2 === I && p(d, h, O--, j);
                }
              },
              scanBipartite: function scanBipartite(e, t, n, r, i, u, c, d, h, g, v, y) {
                var b = 0,
                  _ = 2 * e,
                  x = t,
                  w = t + e,
                  S = 1,
                  A = 1;
                r ? A = a : S = a;
                for (var E = i; E < u; ++E) {
                  var T = E + S,
                    M = _ * E;
                  f[b++] = c[M + x], f[b++] = -T, f[b++] = c[M + w], f[b++] = T;
                }
                for (E = h; E < g; ++E) {
                  T = E + A;
                  var C = _ * E;
                  f[b++] = v[C + x], f[b++] = -T;
                }
                var k = b >>> 1;
                o(f, k);
                var P = 0;
                for (E = 0; E < k; ++E) {
                  var O = 0 | f[2 * E + 1];
                  if (O < 0) {
                    var R = !1;
                    if ((T = -O) >= a ? (R = !r, T -= a) : (R = !!r, T -= 1), R) m(s, l, P++, T);else {
                      var I = y[T],
                        j = _ * T,
                        N = v[j + t + 1],
                        L = v[j + t + 1 + e];
                      e: for (var D = 0; D < P; ++D) {
                        var B = s[D],
                          F = _ * B;
                        if (!(L < c[F + t + 1] || c[F + t + 1 + e] < N)) {
                          for (var z = t + 2; z < e; ++z) if (v[j + z + e] < c[F + z] || c[F + z + e] < v[j + z]) continue e;
                          var U,
                            G = d[B];
                          if (void 0 !== (U = r ? n(I, G) : n(G, I))) return U;
                        }
                      }
                    }
                  } else p(s, l, P--, O - S);
                }
              },
              scanComplete: function scanComplete(e, t, n, r, i, l, u, c, d, h, p) {
                for (var m = 0, g = 2 * e, v = t, y = t + e, b = r; b < i; ++b) {
                  var _ = b + a,
                    x = g * b;
                  f[m++] = l[x + v], f[m++] = -_, f[m++] = l[x + y], f[m++] = _;
                }
                for (b = c; b < d; ++b) {
                  _ = b + 1;
                  var w = g * b;
                  f[m++] = h[w + v], f[m++] = -_;
                }
                var S = m >>> 1;
                o(f, S);
                var A = 0;
                for (b = 0; b < S; ++b) {
                  var E = 0 | f[2 * b + 1];
                  if (E < 0) {
                    if ((_ = -E) >= a) s[A++] = _ - a;else {
                      var T = p[_ -= 1],
                        M = g * _,
                        C = h[M + t + 1],
                        k = h[M + t + 1 + e];
                      e: for (var P = 0; P < A; ++P) {
                        var O = s[P],
                          R = u[O];
                        if (R === T) break;
                        var I = g * O;
                        if (!(k < l[I + t + 1] || l[I + t + 1 + e] < C)) {
                          for (var j = t + 2; j < e; ++j) if (h[M + j + e] < l[I + j] || l[I + j + e] < h[M + j]) continue e;
                          var N = n(R, T);
                          if (void 0 !== N) return N;
                        }
                      }
                    }
                  } else {
                    for (_ = E - a, P = A - 1; P >= 0; --P) if (s[P] === _) {
                      for (j = P + 1; j < A; ++j) s[j - 1] = s[j];
                      break;
                    }
                    --A;
                  }
                }
              }
            };
            var r = e("typedarray-pool"),
              i = e("bit-twiddle"),
              o = e("./sort"),
              a = 1 << 28,
              s = r.mallocInt32(1024),
              l = r.mallocInt32(1024),
              u = r.mallocInt32(1024),
              c = r.mallocInt32(1024),
              d = r.mallocInt32(1024),
              h = r.mallocInt32(1024),
              f = r.mallocDouble(8192);
            function p(e, t, n, r) {
              var i = t[r],
                o = e[n - 1];
              e[i] = o, t[o] = i;
            }
            function m(e, t, n, r) {
              e[n] = r, t[r] = n;
            }
          }, {
            "./sort": 45,
            "bit-twiddle": 37,
            "typedarray-pool": 347
          }],
          47: [function (e, t, n) {}, {}],
          48: [function (e, t, n) {
            var r = Object.create || function (e) {
                var t = function t() {};
                return t.prototype = e, new t();
              },
              i = Object.keys || function (e) {
                var t = [];
                for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
                return n;
              },
              o = Function.prototype.bind || function (e) {
                var t = this;
                return function () {
                  return t.apply(e, arguments);
                };
              };
            function a() {
              this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = r(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }
            t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._maxListeners = void 0;
            var s,
              l = 10;
            try {
              var u = {};
              Object.defineProperty && Object.defineProperty(u, "x", {
                value: 0
              }), s = 0 === u.x;
            } catch (e) {
              s = !1;
            }
            function c(e) {
              return void 0 === e._maxListeners ? a.defaultMaxListeners : e._maxListeners;
            }
            function d(e, t, n, i) {
              var o, a, s;
              if ("function" != typeof n) throw new TypeError('"listener" argument must be a function');
              if ((a = e._events) ? (a.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), a = e._events), s = a[t]) : (a = e._events = r(null), e._eventsCount = 0), s) {
                if ("function" == typeof s ? s = a[t] = i ? [n, s] : [s, n] : i ? s.unshift(n) : s.push(n), !s.warned && (o = c(e)) && o > 0 && s.length > o) {
                  s.warned = !0;
                  var l = new Error("Possible EventEmitter memory leak detected. " + s.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                  l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = s.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                }
              } else s = a[t] = n, ++e._eventsCount;
              return e;
            }
            function h() {
              if (!this.fired) switch (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length) {
                case 0:
                  return this.listener.call(this.target);
                case 1:
                  return this.listener.call(this.target, arguments[0]);
                case 2:
                  return this.listener.call(this.target, arguments[0], arguments[1]);
                case 3:
                  return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                default:
                  for (var e = new Array(arguments.length), t = 0; t < e.length; ++t) e[t] = arguments[t];
                  this.listener.apply(this.target, e);
              }
            }
            function f(e, t, n) {
              var r = {
                  fired: !1,
                  wrapFn: void 0,
                  target: e,
                  type: t,
                  listener: n
                },
                i = o.call(h, r);
              return i.listener = n, r.wrapFn = i, i;
            }
            function p(e, t, n) {
              var r = e._events;
              if (!r) return [];
              var i = r[t];
              return i ? "function" == typeof i ? n ? [i.listener || i] : [i] : n ? function (e) {
                for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
                return t;
              }(i) : g(i, i.length) : [];
            }
            function m(e) {
              var t = this._events;
              if (t) {
                var n = t[e];
                if ("function" == typeof n) return 1;
                if (n) return n.length;
              }
              return 0;
            }
            function g(e, t) {
              for (var n = new Array(t), r = 0; r < t; ++r) n[r] = e[r];
              return n;
            }
            s ? Object.defineProperty(a, "defaultMaxListeners", {
              enumerable: !0,
              get: function get() {
                return l;
              },
              set: function set(e) {
                if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                l = e;
              }
            }) : a.defaultMaxListeners = l, a.prototype.setMaxListeners = function (e) {
              if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
              return this._maxListeners = e, this;
            }, a.prototype.getMaxListeners = function () {
              return c(this);
            }, a.prototype.emit = function (e) {
              var t,
                n,
                r,
                i,
                o,
                a,
                s = "error" === e;
              if (a = this._events) s = s && null == a.error;else if (!s) return !1;
              if (s) {
                if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                var l = new Error('Unhandled "error" event. (' + t + ")");
                throw l.context = t, l;
              }
              if (!(n = a[e])) return !1;
              var u = "function" == typeof n;
              switch (r = arguments.length) {
                case 1:
                  !function (e, t, n) {
                    if (t) e.call(n);else for (var r = e.length, i = g(e, r), o = 0; o < r; ++o) i[o].call(n);
                  }(n, u, this);
                  break;
                case 2:
                  !function (e, t, n, r) {
                    if (t) e.call(n, r);else for (var i = e.length, o = g(e, i), a = 0; a < i; ++a) o[a].call(n, r);
                  }(n, u, this, arguments[1]);
                  break;
                case 3:
                  !function (e, t, n, r, i) {
                    if (t) e.call(n, r, i);else for (var o = e.length, a = g(e, o), s = 0; s < o; ++s) a[s].call(n, r, i);
                  }(n, u, this, arguments[1], arguments[2]);
                  break;
                case 4:
                  !function (e, t, n, r, i, o) {
                    if (t) e.call(n, r, i, o);else for (var a = e.length, s = g(e, a), l = 0; l < a; ++l) s[l].call(n, r, i, o);
                  }(n, u, this, arguments[1], arguments[2], arguments[3]);
                  break;
                default:
                  for (i = new Array(r - 1), o = 1; o < r; o++) i[o - 1] = arguments[o];
                  !function (e, t, n, r) {
                    if (t) e.apply(n, r);else for (var i = e.length, o = g(e, i), a = 0; a < i; ++a) o[a].apply(n, r);
                  }(n, u, this, i);
              }
              return !0;
            }, a.prototype.addListener = function (e, t) {
              return d(this, e, t, !1);
            }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (e, t) {
              return d(this, e, t, !0);
            }, a.prototype.once = function (e, t) {
              if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
              return this.on(e, f(this, e, t)), this;
            }, a.prototype.prependOnceListener = function (e, t) {
              if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
              return this.prependListener(e, f(this, e, t)), this;
            }, a.prototype.removeListener = function (e, t) {
              var n, i, o, a, s;
              if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
              if (!(i = this._events)) return this;
              if (!(n = i[e])) return this;
              if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = r(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
                for (o = -1, a = n.length - 1; a >= 0; a--) if (n[a] === t || n[a].listener === t) {
                  s = n[a].listener, o = a;
                  break;
                }
                if (o < 0) return this;
                0 === o ? n.shift() : function (e, t) {
                  for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) e[n] = e[r];
                  e.pop();
                }(n, o), 1 === n.length && (i[e] = n[0]), i.removeListener && this.emit("removeListener", e, s || t);
              }
              return this;
            }, a.prototype.removeAllListeners = function (e) {
              var t, n, o;
              if (!(n = this._events)) return this;
              if (!n.removeListener) return 0 === arguments.length ? (this._events = r(null), this._eventsCount = 0) : n[e] && (0 == --this._eventsCount ? this._events = r(null) : delete n[e]), this;
              if (0 === arguments.length) {
                var a,
                  s = i(n);
                for (o = 0; o < s.length; ++o) "removeListener" !== (a = s[o]) && this.removeAllListeners(a);
                return this.removeAllListeners("removeListener"), this._events = r(null), this._eventsCount = 0, this;
              }
              if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (t) for (o = t.length - 1; o >= 0; o--) this.removeListener(e, t[o]);
              return this;
            }, a.prototype.listeners = function (e) {
              return p(this, e, !0);
            }, a.prototype.rawListeners = function (e) {
              return p(this, e, !1);
            }, a.listenerCount = function (e, t) {
              return "function" == typeof e.listenerCount ? e.listenerCount(t) : m.call(e, t);
            }, a.prototype.listenerCount = m, a.prototype.eventNames = function () {
              return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
            };
          }, {}],
          49: [function (e, t, n) {
            (function (t) {
              "use strict";

              var r = e("base64-js"),
                i = e("ieee754"),
                o = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null;
              n.Buffer = t, n.SlowBuffer = function (e) {
                return +e != e && (e = 0), t.alloc(+e);
              }, n.INSPECT_MAX_BYTES = 50;
              var a = 2147483647;
              function s(e) {
                if (e > a) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                var n = new Uint8Array(e);
                return Object.setPrototypeOf(n, t.prototype), n;
              }
              function t(e, t, n) {
                if ("number" == typeof e) {
                  if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                  return c(e);
                }
                return l(e, t, n);
              }
              function l(e, n, r) {
                if ("string" == typeof e) return function (e, n) {
                  if ("string" == typeof n && "" !== n || (n = "utf8"), !t.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                  var r = 0 | f(e, n),
                    i = s(r),
                    o = i.write(e, n);
                  return o !== r && (i = i.slice(0, o)), i;
                }(e, n);
                if (ArrayBuffer.isView(e)) return d(e);
                if (null == e) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                if (z(e, ArrayBuffer) || e && z(e.buffer, ArrayBuffer)) return function (e, n, r) {
                  if (n < 0 || e.byteLength < n) throw new RangeError('"offset" is outside of buffer bounds');
                  if (e.byteLength < n + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                  var i;
                  return i = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r), Object.setPrototypeOf(i, t.prototype), i;
                }(e, n, r);
                if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                var i = e.valueOf && e.valueOf();
                if (null != i && i !== e) return t.from(i, n, r);
                var o = function (e) {
                  if (t.isBuffer(e)) {
                    var n = 0 | h(e.length),
                      r = s(n);
                    return 0 === r.length || e.copy(r, 0, 0, n), r;
                  }
                  return void 0 !== e.length ? "number" != typeof e.length || U(e.length) ? s(0) : d(e) : "Buffer" === e.type && Array.isArray(e.data) ? d(e.data) : void 0;
                }(e);
                if (o) return o;
                if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return t.from(e[Symbol.toPrimitive]("string"), n, r);
                throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
              }
              function u(e) {
                if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
              }
              function c(e) {
                return u(e), s(e < 0 ? 0 : 0 | h(e));
              }
              function d(e) {
                for (var t = e.length < 0 ? 0 : 0 | h(e.length), n = s(t), r = 0; r < t; r += 1) n[r] = 255 & e[r];
                return n;
              }
              function h(e) {
                if (e >= a) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
                return 0 | e;
              }
              function f(e, n) {
                if (t.isBuffer(e)) return e.length;
                if (ArrayBuffer.isView(e) || z(e, ArrayBuffer)) return e.byteLength;
                if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                var r = e.length,
                  i = arguments.length > 2 && !0 === arguments[2];
                if (!i && 0 === r) return 0;
                for (var o = !1;;) switch (n) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return r;
                  case "utf8":
                  case "utf-8":
                    return D(e).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return 2 * r;
                  case "hex":
                    return r >>> 1;
                  case "base64":
                    return B(e).length;
                  default:
                    if (o) return i ? -1 : D(e).length;
                    n = ("" + n).toLowerCase(), o = !0;
                }
              }
              function p(e, t, n) {
                var r = e[t];
                e[t] = e[n], e[n] = r;
              }
              function m(e, n, r, i, o) {
                if (0 === e.length) return -1;
                if ("string" == typeof r ? (i = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), U(r = +r) && (r = o ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                  if (o) return -1;
                  r = e.length - 1;
                } else if (r < 0) {
                  if (!o) return -1;
                  r = 0;
                }
                if ("string" == typeof n && (n = t.from(n, i)), t.isBuffer(n)) return 0 === n.length ? -1 : g(e, n, r, i, o);
                if ("number" == typeof n) return n &= 255, "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(e, n, r) : Uint8Array.prototype.lastIndexOf.call(e, n, r) : g(e, [n], r, i, o);
                throw new TypeError("val must be string, number or Buffer");
              }
              function g(e, t, n, r, i) {
                var o,
                  a = 1,
                  s = e.length,
                  l = t.length;
                if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
                  if (e.length < 2 || t.length < 2) return -1;
                  a = 2, s /= 2, l /= 2, n /= 2;
                }
                function u(e, t) {
                  return 1 === a ? e[t] : e.readUInt16BE(t * a);
                }
                if (i) {
                  var c = -1;
                  for (o = n; o < s; o++) if (u(e, o) === u(t, -1 === c ? 0 : o - c)) {
                    if (-1 === c && (c = o), o - c + 1 === l) return c * a;
                  } else -1 !== c && (o -= o - c), c = -1;
                } else for (n + l > s && (n = s - l), o = n; o >= 0; o--) {
                  for (var d = !0, h = 0; h < l; h++) if (u(e, o + h) !== u(t, h)) {
                    d = !1;
                    break;
                  }
                  if (d) return o;
                }
                return -1;
              }
              function v(e, t, n, r) {
                n = Number(n) || 0;
                var i = e.length - n;
                r ? (r = Number(r)) > i && (r = i) : r = i;
                var o = t.length;
                r > o / 2 && (r = o / 2);
                for (var a = 0; a < r; ++a) {
                  var s = parseInt(t.substr(2 * a, 2), 16);
                  if (U(s)) return a;
                  e[n + a] = s;
                }
                return a;
              }
              function y(e, t, n, r) {
                return F(D(t, e.length - n), e, n, r);
              }
              function b(e, t, n, r) {
                return F(function (e) {
                  for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
                  return t;
                }(t), e, n, r);
              }
              function _(e, t, n, r) {
                return b(e, t, n, r);
              }
              function x(e, t, n, r) {
                return F(B(t), e, n, r);
              }
              function w(e, t, n, r) {
                return F(function (e, t) {
                  for (var n, r, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a) r = (n = e.charCodeAt(a)) >> 8, i = n % 256, o.push(i), o.push(r);
                  return o;
                }(t, e.length - n), e, n, r);
              }
              function S(e, t, n) {
                return 0 === t && n === e.length ? r.fromByteArray(e) : r.fromByteArray(e.slice(t, n));
              }
              function A(e, t, n) {
                n = Math.min(e.length, n);
                for (var r = [], i = t; i < n;) {
                  var o,
                    a,
                    s,
                    l,
                    u = e[i],
                    c = null,
                    d = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
                  if (i + d <= n) switch (d) {
                    case 1:
                      u < 128 && (c = u);
                      break;
                    case 2:
                      128 == (192 & (o = e[i + 1])) && (l = (31 & u) << 6 | 63 & o) > 127 && (c = l);
                      break;
                    case 3:
                      o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (l = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (l < 55296 || l > 57343) && (c = l);
                      break;
                    case 4:
                      o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (l = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && l < 1114112 && (c = l);
                  }
                  null === c ? (c = 65533, d = 1) : c > 65535 && (c -= 65536, r.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r.push(c), i += d;
                }
                return function (e) {
                  var t = e.length;
                  if (t <= E) return String.fromCharCode.apply(String, e);
                  for (var n = "", r = 0; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += E));
                  return n;
                }(r);
              }
              n.kMaxLength = a, t.TYPED_ARRAY_SUPPORT = function () {
                try {
                  var e = new Uint8Array(1),
                    t = {
                      foo: function foo() {
                        return 42;
                      }
                    };
                  return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e, t), 42 === e.foo();
                } catch (e) {
                  return !1;
                }
              }(), t.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(t.prototype, "parent", {
                enumerable: !0,
                get: function get() {
                  if (t.isBuffer(this)) return this.buffer;
                }
              }), Object.defineProperty(t.prototype, "offset", {
                enumerable: !0,
                get: function get() {
                  if (t.isBuffer(this)) return this.byteOffset;
                }
              }), "undefined" != typeof Symbol && null != Symbol.species && t[Symbol.species] === t && Object.defineProperty(t, Symbol.species, {
                value: null,
                configurable: !0,
                enumerable: !1,
                writable: !1
              }), t.poolSize = 8192, t.from = function (e, t, n) {
                return l(e, t, n);
              }, Object.setPrototypeOf(t.prototype, Uint8Array.prototype), Object.setPrototypeOf(t, Uint8Array), t.alloc = function (e, t, n) {
                return function (e, t, n) {
                  return u(e), e <= 0 ? s(e) : void 0 !== t ? "string" == typeof n ? s(e).fill(t, n) : s(e).fill(t) : s(e);
                }(e, t, n);
              }, t.allocUnsafe = function (e) {
                return c(e);
              }, t.allocUnsafeSlow = function (e) {
                return c(e);
              }, t.isBuffer = function (e) {
                return null != e && !0 === e._isBuffer && e !== t.prototype;
              }, t.compare = function (e, n) {
                if (z(e, Uint8Array) && (e = t.from(e, e.offset, e.byteLength)), z(n, Uint8Array) && (n = t.from(n, n.offset, n.byteLength)), !t.isBuffer(e) || !t.isBuffer(n)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                if (e === n) return 0;
                for (var r = e.length, i = n.length, o = 0, a = Math.min(r, i); o < a; ++o) if (e[o] !== n[o]) {
                  r = e[o], i = n[o];
                  break;
                }
                return r < i ? -1 : i < r ? 1 : 0;
              }, t.isEncoding = function (e) {
                switch (String(e).toLowerCase()) {
                  case "hex":
                  case "utf8":
                  case "utf-8":
                  case "ascii":
                  case "latin1":
                  case "binary":
                  case "base64":
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return !0;
                  default:
                    return !1;
                }
              }, t.concat = function (e, n) {
                if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                if (0 === e.length) return t.alloc(0);
                var r;
                if (void 0 === n) for (n = 0, r = 0; r < e.length; ++r) n += e[r].length;
                var i = t.allocUnsafe(n),
                  o = 0;
                for (r = 0; r < e.length; ++r) {
                  var a = e[r];
                  if (z(a, Uint8Array) && (a = t.from(a)), !t.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                  a.copy(i, o), o += a.length;
                }
                return i;
              }, t.byteLength = f, t.prototype._isBuffer = !0, t.prototype.swap16 = function () {
                var e = this.length;
                if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                for (var t = 0; t < e; t += 2) p(this, t, t + 1);
                return this;
              }, t.prototype.swap32 = function () {
                var e = this.length;
                if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                for (var t = 0; t < e; t += 4) p(this, t, t + 3), p(this, t + 1, t + 2);
                return this;
              }, t.prototype.swap64 = function () {
                var e = this.length;
                if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                for (var t = 0; t < e; t += 8) p(this, t, t + 7), p(this, t + 1, t + 6), p(this, t + 2, t + 5), p(this, t + 3, t + 4);
                return this;
              }, t.prototype.toString = function () {
                var e = this.length;
                return 0 === e ? "" : 0 === arguments.length ? A(this, 0, e) : function (e, t, n) {
                  var r = !1;
                  if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                  if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
                  if ((n >>>= 0) <= (t >>>= 0)) return "";
                  for (e || (e = "utf8");;) switch (e) {
                    case "hex":
                      return C(this, t, n);
                    case "utf8":
                    case "utf-8":
                      return A(this, t, n);
                    case "ascii":
                      return T(this, t, n);
                    case "latin1":
                    case "binary":
                      return M(this, t, n);
                    case "base64":
                      return S(this, t, n);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return k(this, t, n);
                    default:
                      if (r) throw new TypeError("Unknown encoding: " + e);
                      e = (e + "").toLowerCase(), r = !0;
                  }
                }.apply(this, arguments);
              }, t.prototype.toLocaleString = t.prototype.toString, t.prototype.equals = function (e) {
                if (!t.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                return this === e || 0 === t.compare(this, e);
              }, t.prototype.inspect = function () {
                var e = "",
                  t = n.INSPECT_MAX_BYTES;
                return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
              }, o && (t.prototype[o] = t.prototype.inspect), t.prototype.compare = function (e, n, r, i, o) {
                if (z(e, Uint8Array) && (e = t.from(e, e.offset, e.byteLength)), !t.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                if (void 0 === n && (n = 0), void 0 === r && (r = e ? e.length : 0), void 0 === i && (i = 0), void 0 === o && (o = this.length), n < 0 || r > e.length || i < 0 || o > this.length) throw new RangeError("out of range index");
                if (i >= o && n >= r) return 0;
                if (i >= o) return -1;
                if (n >= r) return 1;
                if (this === e) return 0;
                for (var a = (o >>>= 0) - (i >>>= 0), s = (r >>>= 0) - (n >>>= 0), l = Math.min(a, s), u = this.slice(i, o), c = e.slice(n, r), d = 0; d < l; ++d) if (u[d] !== c[d]) {
                  a = u[d], s = c[d];
                  break;
                }
                return a < s ? -1 : s < a ? 1 : 0;
              }, t.prototype.includes = function (e, t, n) {
                return -1 !== this.indexOf(e, t, n);
              }, t.prototype.indexOf = function (e, t, n) {
                return m(this, e, t, n, !0);
              }, t.prototype.lastIndexOf = function (e, t, n) {
                return m(this, e, t, n, !1);
              }, t.prototype.write = function (e, t, n, r) {
                if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
                  if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                  t >>>= 0, isFinite(n) ? (n >>>= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
                }
                var i = this.length - t;
                if ((void 0 === n || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                r || (r = "utf8");
                for (var o = !1;;) switch (r) {
                  case "hex":
                    return v(this, e, t, n);
                  case "utf8":
                  case "utf-8":
                    return y(this, e, t, n);
                  case "ascii":
                    return b(this, e, t, n);
                  case "latin1":
                  case "binary":
                    return _(this, e, t, n);
                  case "base64":
                    return x(this, e, t, n);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return w(this, e, t, n);
                  default:
                    if (o) throw new TypeError("Unknown encoding: " + r);
                    r = ("" + r).toLowerCase(), o = !0;
                }
              }, t.prototype.toJSON = function () {
                return {
                  type: "Buffer",
                  data: Array.prototype.slice.call(this._arr || this, 0)
                };
              };
              var E = 4096;
              function T(e, t, n) {
                var r = "";
                n = Math.min(e.length, n);
                for (var i = t; i < n; ++i) r += String.fromCharCode(127 & e[i]);
                return r;
              }
              function M(e, t, n) {
                var r = "";
                n = Math.min(e.length, n);
                for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
                return r;
              }
              function C(e, t, n) {
                var r = e.length;
                (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
                for (var i = "", o = t; o < n; ++o) i += L(e[o]);
                return i;
              }
              function k(e, t, n) {
                for (var r = e.slice(t, n), i = "", o = 0; o < r.length; o += 2) i += String.fromCharCode(r[o] + 256 * r[o + 1]);
                return i;
              }
              function P(e, t, n) {
                if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
              }
              function O(e, n, r, i, o, a) {
                if (!t.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                if (n > o || n < a) throw new RangeError('"value" argument is out of bounds');
                if (r + i > e.length) throw new RangeError("Index out of range");
              }
              function R(e, t, n, r, i, o) {
                if (n + r > e.length) throw new RangeError("Index out of range");
                if (n < 0) throw new RangeError("Index out of range");
              }
              function I(e, t, n, r, o) {
                return t = +t, n >>>= 0, o || R(e, 0, n, 4), i.write(e, t, n, r, 23, 4), n + 4;
              }
              function j(e, t, n, r, o) {
                return t = +t, n >>>= 0, o || R(e, 0, n, 8), i.write(e, t, n, r, 52, 8), n + 8;
              }
              t.prototype.slice = function (e, n) {
                var r = this.length;
                (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (n = void 0 === n ? r : ~~n) < 0 ? (n += r) < 0 && (n = 0) : n > r && (n = r), n < e && (n = e);
                var i = this.subarray(e, n);
                return Object.setPrototypeOf(i, t.prototype), i;
              }, t.prototype.readUIntLE = function (e, t, n) {
                e >>>= 0, t >>>= 0, n || P(e, t, this.length);
                for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
                return r;
              }, t.prototype.readUIntBE = function (e, t, n) {
                e >>>= 0, t >>>= 0, n || P(e, t, this.length);
                for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
                return r;
              }, t.prototype.readUInt8 = function (e, t) {
                return e >>>= 0, t || P(e, 1, this.length), this[e];
              }, t.prototype.readUInt16LE = function (e, t) {
                return e >>>= 0, t || P(e, 2, this.length), this[e] | this[e + 1] << 8;
              }, t.prototype.readUInt16BE = function (e, t) {
                return e >>>= 0, t || P(e, 2, this.length), this[e] << 8 | this[e + 1];
              }, t.prototype.readUInt32LE = function (e, t) {
                return e >>>= 0, t || P(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
              }, t.prototype.readUInt32BE = function (e, t) {
                return e >>>= 0, t || P(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
              }, t.prototype.readIntLE = function (e, t, n) {
                e >>>= 0, t >>>= 0, n || P(e, t, this.length);
                for (var r = this[e], i = 1, o = 0; ++o < t && (i *= 256);) r += this[e + o] * i;
                return r >= (i *= 128) && (r -= Math.pow(2, 8 * t)), r;
              }, t.prototype.readIntBE = function (e, t, n) {
                e >>>= 0, t >>>= 0, n || P(e, t, this.length);
                for (var r = t, i = 1, o = this[e + --r]; r > 0 && (i *= 256);) o += this[e + --r] * i;
                return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
              }, t.prototype.readInt8 = function (e, t) {
                return e >>>= 0, t || P(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
              }, t.prototype.readInt16LE = function (e, t) {
                e >>>= 0, t || P(e, 2, this.length);
                var n = this[e] | this[e + 1] << 8;
                return 32768 & n ? 4294901760 | n : n;
              }, t.prototype.readInt16BE = function (e, t) {
                e >>>= 0, t || P(e, 2, this.length);
                var n = this[e + 1] | this[e] << 8;
                return 32768 & n ? 4294901760 | n : n;
              }, t.prototype.readInt32LE = function (e, t) {
                return e >>>= 0, t || P(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
              }, t.prototype.readInt32BE = function (e, t) {
                return e >>>= 0, t || P(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
              }, t.prototype.readFloatLE = function (e, t) {
                return e >>>= 0, t || P(e, 4, this.length), i.read(this, e, !0, 23, 4);
              }, t.prototype.readFloatBE = function (e, t) {
                return e >>>= 0, t || P(e, 4, this.length), i.read(this, e, !1, 23, 4);
              }, t.prototype.readDoubleLE = function (e, t) {
                return e >>>= 0, t || P(e, 8, this.length), i.read(this, e, !0, 52, 8);
              }, t.prototype.readDoubleBE = function (e, t) {
                return e >>>= 0, t || P(e, 8, this.length), i.read(this, e, !1, 52, 8);
              }, t.prototype.writeUIntLE = function (e, t, n, r) {
                e = +e, t >>>= 0, n >>>= 0, r || O(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
                var i = 1,
                  o = 0;
                for (this[t] = 255 & e; ++o < n && (i *= 256);) this[t + o] = e / i & 255;
                return t + n;
              }, t.prototype.writeUIntBE = function (e, t, n, r) {
                e = +e, t >>>= 0, n >>>= 0, r || O(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
                var i = n - 1,
                  o = 1;
                for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) this[t + i] = e / o & 255;
                return t + n;
              }, t.prototype.writeUInt8 = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
              }, t.prototype.writeUInt16LE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
              }, t.prototype.writeUInt16BE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
              }, t.prototype.writeUInt32LE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
              }, t.prototype.writeUInt32BE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
              }, t.prototype.writeIntLE = function (e, t, n, r) {
                if (e = +e, t >>>= 0, !r) {
                  var i = Math.pow(2, 8 * n - 1);
                  O(this, e, t, n, i - 1, -i);
                }
                var o = 0,
                  a = 1,
                  s = 0;
                for (this[t] = 255 & e; ++o < n && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
                return t + n;
              }, t.prototype.writeIntBE = function (e, t, n, r) {
                if (e = +e, t >>>= 0, !r) {
                  var i = Math.pow(2, 8 * n - 1);
                  O(this, e, t, n, i - 1, -i);
                }
                var o = n - 1,
                  a = 1,
                  s = 0;
                for (this[t + o] = 255 & e; --o >= 0 && (a *= 256);) e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
                return t + n;
              }, t.prototype.writeInt8 = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
              }, t.prototype.writeInt16LE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
              }, t.prototype.writeInt16BE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
              }, t.prototype.writeInt32LE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
              }, t.prototype.writeInt32BE = function (e, t, n) {
                return e = +e, t >>>= 0, n || O(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
              }, t.prototype.writeFloatLE = function (e, t, n) {
                return I(this, e, t, !0, n);
              }, t.prototype.writeFloatBE = function (e, t, n) {
                return I(this, e, t, !1, n);
              }, t.prototype.writeDoubleLE = function (e, t, n) {
                return j(this, e, t, !0, n);
              }, t.prototype.writeDoubleBE = function (e, t, n) {
                return j(this, e, t, !1, n);
              }, t.prototype.copy = function (e, n, r, i) {
                if (!t.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                if (r || (r = 0), i || 0 === i || (i = this.length), n >= e.length && (n = e.length), n || (n = 0), i > 0 && i < r && (i = r), i === r) return 0;
                if (0 === e.length || 0 === this.length) return 0;
                if (n < 0) throw new RangeError("targetStart out of bounds");
                if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                if (i < 0) throw new RangeError("sourceEnd out of bounds");
                i > this.length && (i = this.length), e.length - n < i - r && (i = e.length - n + r);
                var o = i - r;
                if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(n, r, i);else if (this === e && r < n && n < i) for (var a = o - 1; a >= 0; --a) e[a + n] = this[a + r];else Uint8Array.prototype.set.call(e, this.subarray(r, i), n);
                return o;
              }, t.prototype.fill = function (e, n, r, i) {
                if ("string" == typeof e) {
                  if ("string" == typeof n ? (i = n, n = 0, r = this.length) : "string" == typeof r && (i = r, r = this.length), void 0 !== i && "string" != typeof i) throw new TypeError("encoding must be a string");
                  if ("string" == typeof i && !t.isEncoding(i)) throw new TypeError("Unknown encoding: " + i);
                  if (1 === e.length) {
                    var o = e.charCodeAt(0);
                    ("utf8" === i && o < 128 || "latin1" === i) && (e = o);
                  }
                } else "number" == typeof e ? e &= 255 : "boolean" == typeof e && (e = Number(e));
                if (n < 0 || this.length < n || this.length < r) throw new RangeError("Out of range index");
                if (r <= n) return this;
                var a;
                if (n >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for (a = n; a < r; ++a) this[a] = e;else {
                  var s = t.isBuffer(e) ? e : t.from(e, i),
                    l = s.length;
                  if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                  for (a = 0; a < r - n; ++a) this[a + n] = s[a % l];
                }
                return this;
              };
              var N = /[^+/0-9A-Za-z-_]/g;
              function L(e) {
                return e < 16 ? "0" + e.toString(16) : e.toString(16);
              }
              function D(e, t) {
                var n;
                t = t || 1 / 0;
                for (var r = e.length, i = null, o = [], a = 0; a < r; ++a) {
                  if ((n = e.charCodeAt(a)) > 55295 && n < 57344) {
                    if (!i) {
                      if (n > 56319) {
                        (t -= 3) > -1 && o.push(239, 191, 189);
                        continue;
                      }
                      if (a + 1 === r) {
                        (t -= 3) > -1 && o.push(239, 191, 189);
                        continue;
                      }
                      i = n;
                      continue;
                    }
                    if (n < 56320) {
                      (t -= 3) > -1 && o.push(239, 191, 189), i = n;
                      continue;
                    }
                    n = 65536 + (i - 55296 << 10 | n - 56320);
                  } else i && (t -= 3) > -1 && o.push(239, 191, 189);
                  if (i = null, n < 128) {
                    if ((t -= 1) < 0) break;
                    o.push(n);
                  } else if (n < 2048) {
                    if ((t -= 2) < 0) break;
                    o.push(n >> 6 | 192, 63 & n | 128);
                  } else if (n < 65536) {
                    if ((t -= 3) < 0) break;
                    o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
                  } else {
                    if (!(n < 1114112)) throw new Error("Invalid code point");
                    if ((t -= 4) < 0) break;
                    o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
                  }
                }
                return o;
              }
              function B(e) {
                return r.toByteArray(function (e) {
                  if ((e = (e = e.split("=")[0]).trim().replace(N, "")).length < 2) return "";
                  for (; e.length % 4 != 0;) e += "=";
                  return e;
                }(e));
              }
              function F(e, t, n, r) {
                for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
                return i;
              }
              function z(e, t) {
                return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
              }
              function U(e) {
                return e != e;
              }
            }).call(this, e("buffer").Buffer);
          }, {
            "base64-js": 19,
            buffer: 49,
            ieee754: 252
          }],
          50: [function (e, t, n) {
            "use strict";

            var r = e("./lib/monotone"),
              i = e("./lib/triangulation"),
              o = e("./lib/delaunay"),
              a = e("./lib/filter");
            function s(e) {
              return [Math.min(e[0], e[1]), Math.max(e[0], e[1])];
            }
            function l(e, t) {
              return e[0] - t[0] || e[1] - t[1];
            }
            function u(e, t, n) {
              return t in e ? e[t] : n;
            }
            t.exports = function (e, t, n) {
              Array.isArray(t) ? (n = n || {}, t = t || []) : (n = t || {}, t = []);
              var c = !!u(n, "delaunay", !0),
                d = !!u(n, "interior", !0),
                h = !!u(n, "exterior", !0),
                f = !!u(n, "infinity", !1);
              if (!d && !h || 0 === e.length) return [];
              var p = r(e, t);
              if (c || d !== h || f) {
                for (var m = i(e.length, function (e) {
                    return e.map(s).sort(l);
                  }(t)), g = 0; g < p.length; ++g) {
                  var v = p[g];
                  m.addTriangle(v[0], v[1], v[2]);
                }
                return c && o(e, m), h ? d ? f ? a(m, 0, f) : m.cells() : a(m, 1, f) : a(m, -1);
              }
              return p;
            };
          }, {
            "./lib/delaunay": 51,
            "./lib/filter": 52,
            "./lib/monotone": 53,
            "./lib/triangulation": 54
          }],
          51: [function (e, t, n) {
            "use strict";

            var r = e("robust-in-sphere")[4];
            function i(e, t, n, i, o, a) {
              var s = t.opposite(i, o);
              if (!(s < 0)) {
                if (o < i) {
                  var l = i;
                  i = o, o = l, l = a, a = s, s = l;
                }
                t.isConstraint(i, o) || r(e[i], e[o], e[a], e[s]) < 0 && n.push(i, o);
              }
            }
            e("binary-search-bounds"), t.exports = function (e, t) {
              for (var n = [], o = e.length, a = t.stars, s = 0; s < o; ++s) for (var l = a[s], u = 1; u < l.length; u += 2) if (!((f = l[u]) < s || t.isConstraint(s, f))) {
                for (var c = l[u - 1], d = -1, h = 1; h < l.length; h += 2) if (l[h - 1] === f) {
                  d = l[h];
                  break;
                }
                d < 0 || r(e[s], e[f], e[c], e[d]) < 0 && n.push(s, f);
              }
              for (; n.length > 0;) {
                for (var f = n.pop(), p = (c = -1, d = -1, l = a[s = n.pop()], 1); p < l.length; p += 2) {
                  var m = l[p - 1],
                    g = l[p];
                  m === f ? d = g : g === f && (c = m);
                }
                c < 0 || d < 0 || r(e[s], e[f], e[c], e[d]) >= 0 || (t.flip(s, f), i(e, t, n, c, s, d), i(e, t, n, s, d, c), i(e, t, n, d, f, c), i(e, t, n, f, c, d));
              }
            };
          }, {
            "binary-search-bounds": 55,
            "robust-in-sphere": 319
          }],
          52: [function (e, t, n) {
            "use strict";

            var r,
              i = e("binary-search-bounds");
            function o(e, t, n, r, i, o, a) {
              this.cells = e, this.neighbor = t, this.flags = r, this.constraint = n, this.active = i, this.next = o, this.boundary = a;
            }
            function a(e, t) {
              return e[0] - t[0] || e[1] - t[1] || e[2] - t[2];
            }
            t.exports = function (e, t, n) {
              var r = function (e, t) {
                for (var n = e.cells(), r = n.length, i = 0; i < r; ++i) {
                  var s = (v = n[i])[0],
                    l = v[1],
                    u = v[2];
                  l < u ? l < s && (v[0] = l, v[1] = u, v[2] = s) : u < s && (v[0] = u, v[1] = s, v[2] = l);
                }
                n.sort(a);
                var c = new Array(r);
                for (i = 0; i < c.length; ++i) c[i] = 0;
                var d = [],
                  h = [],
                  f = new Array(3 * r),
                  p = new Array(3 * r),
                  m = null;
                t && (m = []);
                var g = new o(n, f, p, c, d, h, m);
                for (i = 0; i < r; ++i) for (var v = n[i], y = 0; y < 3; ++y) {
                  s = v[y], l = v[(y + 1) % 3];
                  var b = f[3 * i + y] = g.locate(l, s, e.opposite(l, s)),
                    _ = p[3 * i + y] = e.isConstraint(s, l);
                  b < 0 && (_ ? h.push(i) : (d.push(i), c[i] = 1), t && m.push([l, s, -1]));
                }
                return g;
              }(e, n);
              if (0 === t) return n ? r.cells.concat(r.boundary) : r.cells;
              for (var i = 1, s = r.active, l = r.next, u = r.flags, c = r.cells, d = r.constraint, h = r.neighbor; s.length > 0 || l.length > 0;) {
                for (; s.length > 0;) {
                  var f = s.pop();
                  if (u[f] !== -i) {
                    u[f] = i, c[f];
                    for (var p = 0; p < 3; ++p) {
                      var m = h[3 * f + p];
                      m >= 0 && 0 === u[m] && (d[3 * f + p] ? l.push(m) : (s.push(m), u[m] = i));
                    }
                  }
                }
                var g = l;
                l = s, s = g, l.length = 0, i = -i;
              }
              var v = function (e, t, n) {
                for (var r = 0, i = 0; i < e.length; ++i) t[i] === n && (e[r++] = e[i]);
                return e.length = r, e;
              }(c, u, t);
              return n ? v.concat(r.boundary) : v;
            }, o.prototype.locate = (r = [0, 0, 0], function (e, t, n) {
              var o = e,
                s = t,
                l = n;
              return t < n ? t < e && (o = t, s = n, l = e) : n < e && (o = n, s = e, l = t), o < 0 ? -1 : (r[0] = o, r[1] = s, r[2] = l, i.eq(this.cells, r, a));
            });
          }, {
            "binary-search-bounds": 55
          }],
          53: [function (e, t, n) {
            "use strict";

            var r = e("binary-search-bounds"),
              i = e("robust-orientation")[3];
            function o(e, t, n, r, i) {
              this.a = e, this.b = t, this.idx = n, this.lowerIds = r, this.upperIds = i;
            }
            function a(e, t, n, r) {
              this.a = e, this.b = t, this.type = n, this.idx = r;
            }
            function s(e, t) {
              var n = e.a[0] - t.a[0] || e.a[1] - t.a[1] || e.type - t.type;
              return n || (0 !== e.type && (n = i(e.a, e.b, t.b)) ? n : e.idx - t.idx);
            }
            function l(e, t) {
              return i(e.a, e.b, t);
            }
            function u(e, t, n, o, a) {
              for (var s = r.lt(t, o, l), u = r.gt(t, o, l), c = s; c < u; ++c) {
                for (var d = t[c], h = d.lowerIds, f = h.length; f > 1 && i(n[h[f - 2]], n[h[f - 1]], o) > 0;) e.push([h[f - 1], h[f - 2], a]), f -= 1;
                h.length = f, h.push(a);
                var p = d.upperIds;
                for (f = p.length; f > 1 && i(n[p[f - 2]], n[p[f - 1]], o) < 0;) e.push([p[f - 2], p[f - 1], a]), f -= 1;
                p.length = f, p.push(a);
              }
            }
            function c(e, t) {
              var n;
              return (n = e.a[0] < t.a[0] ? i(e.a, e.b, t.a) : i(t.b, t.a, e.a)) ? n : (n = t.b[0] < e.b[0] ? i(e.a, e.b, t.b) : i(t.b, t.a, e.b)) || e.idx - t.idx;
            }
            function d(e, t, n) {
              var i = r.le(e, n, c),
                a = e[i],
                s = a.upperIds,
                l = s[s.length - 1];
              a.upperIds = [l], e.splice(i + 1, 0, new o(n.a, n.b, n.idx, [l], s));
            }
            function h(e, t, n) {
              var i = n.a;
              n.a = n.b, n.b = i;
              var o = r.eq(e, n, c),
                a = e[o];
              e[o - 1].upperIds = a.upperIds, e.splice(o, 1);
            }
            t.exports = function (e, t) {
              for (var n = e.length, r = t.length, i = [], l = 0; l < n; ++l) i.push(new a(e[l], null, 0, l));
              for (l = 0; l < r; ++l) {
                var c = t[l],
                  f = e[c[0]],
                  p = e[c[1]];
                f[0] < p[0] ? i.push(new a(f, p, 2, l), new a(p, f, 1, l)) : f[0] > p[0] && i.push(new a(p, f, 2, l), new a(f, p, 1, l));
              }
              i.sort(s);
              for (var m = i[0].a[0] - (1 + Math.abs(i[0].a[0])) * Math.pow(2, -52), g = [new o([m, 1], [m, 0], -1, [], [], [], [])], v = [], y = (l = 0, i.length); l < y; ++l) {
                var b = i[l],
                  _ = b.type;
                0 === _ ? u(v, g, e, b.a, b.idx) : 2 === _ ? d(g, 0, b) : h(g, 0, b);
              }
              return v;
            };
          }, {
            "binary-search-bounds": 55,
            "robust-orientation": 321
          }],
          54: [function (e, t, n) {
            "use strict";

            var r = e("binary-search-bounds");
            function i(e, t) {
              this.stars = e, this.edges = t;
            }
            t.exports = function (e, t) {
              for (var n = new Array(e), r = 0; r < e; ++r) n[r] = [];
              return new i(n, t);
            };
            var o = i.prototype;
            function a(e, t, n) {
              for (var r = 1, i = e.length; r < i; r += 2) if (e[r - 1] === t && e[r] === n) return e[r - 1] = e[i - 2], e[r] = e[i - 1], void (e.length = i - 2);
            }
            o.isConstraint = function () {
              var e = [0, 0];
              function t(e, t) {
                return e[0] - t[0] || e[1] - t[1];
              }
              return function (n, i) {
                return e[0] = Math.min(n, i), e[1] = Math.max(n, i), r.eq(this.edges, e, t) >= 0;
              };
            }(), o.removeTriangle = function (e, t, n) {
              var r = this.stars;
              a(r[e], t, n), a(r[t], n, e), a(r[n], e, t);
            }, o.addTriangle = function (e, t, n) {
              var r = this.stars;
              r[e].push(t, n), r[t].push(n, e), r[n].push(e, t);
            }, o.opposite = function (e, t) {
              for (var n = this.stars[t], r = 1, i = n.length; r < i; r += 2) if (n[r] === e) return n[r - 1];
              return -1;
            }, o.flip = function (e, t) {
              var n = this.opposite(e, t),
                r = this.opposite(t, e);
              this.removeTriangle(e, t, n), this.removeTriangle(t, e, r), this.addTriangle(e, r, n), this.addTriangle(t, n, r);
            }, o.edges = function () {
              for (var e = this.stars, t = [], n = 0, r = e.length; n < r; ++n) for (var i = e[n], o = 0, a = i.length; o < a; o += 2) t.push([i[o], i[o + 1]]);
              return t;
            }, o.cells = function () {
              for (var e = this.stars, t = [], n = 0, r = e.length; n < r; ++n) for (var i = e[n], o = 0, a = i.length; o < a; o += 2) {
                var s = i[o],
                  l = i[o + 1];
                n < Math.min(s, l) && t.push([n, s, l]);
              }
              return t;
            };
          }, {
            "binary-search-bounds": 55
          }],
          55: [function (e, t, n) {
            "use strict";

            function r(e, t, n, r, i) {
              var o = ["function ", e, "(a,l,h,", r.join(","), "){", i ? "" : "var i=", n ? "l-1" : "h+1", ";while(l<=h){var m=(l+h)>>>1,x=a[m]"];
              return i ? t.indexOf("c") < 0 ? o.push(";if(x===y){return m}else if(x<=y){") : o.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){") : o.push(";if(", t, "){i=m;"), n ? o.push("l=m+1}else{h=m-1}") : o.push("h=m-1}else{l=m+1}"), o.push("}"), i ? o.push("return -1};") : o.push("return i};"), o.join("");
            }
            function i(e, t, n, i) {
              return new Function([r("A", "x" + e + "y", t, ["y"], i), r("P", "c(x,y)" + e + "0", t, ["y", "c"], i), "function dispatchBsearch", n, "(a,y,c,l,h){if(typeof(c)==='function'){return P(a,(l===void 0)?0:l|0,(h===void 0)?a.length-1:h|0,y,c)}else{return A(a,(c===void 0)?0:c|0,(l===void 0)?a.length-1:l|0,y)}}return dispatchBsearch", n].join(""))();
            }
            t.exports = {
              ge: i(">=", !1, "GE"),
              gt: i(">", !1, "GT"),
              lt: i("<", !0, "LT"),
              le: i("<=", !0, "LE"),
              eq: i("-", !0, "EQ", !0)
            };
          }, {}],
          56: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = 1, n = 1; n < e.length; ++n) for (var r = 0; r < n; ++r) if (e[n] < e[r]) t = -t;else if (e[r] === e[n]) return 0;
              return t;
            };
          }, {}],
          57: [function (e, t, n) {
            "use strict";

            var r = e("dup"),
              i = e("robust-linear-solve");
            function o(e, t) {
              for (var n = 0, r = e.length, i = 0; i < r; ++i) n += e[i] * t[i];
              return n;
            }
            function a(e) {
              var t = e.length;
              if (0 === t) return [];
              e[0].length;
              var n = r([e.length + 1, e.length + 1], 1),
                a = r([e.length + 1], 1);
              n[t][t] = 0;
              for (var s = 0; s < t; ++s) {
                for (var l = 0; l <= s; ++l) n[l][s] = n[s][l] = 2 * o(e[s], e[l]);
                a[s] = o(e[s], e[s]);
              }
              var u = i(n, a),
                c = 0,
                d = u[t + 1];
              for (s = 0; s < d.length; ++s) c += d[s];
              var h = new Array(t);
              for (s = 0; s < t; ++s) {
                d = u[s];
                var f = 0;
                for (l = 0; l < d.length; ++l) f += d[l];
                h[s] = f / c;
              }
              return h;
            }
            function s(e) {
              if (0 === e.length) return [];
              for (var t = e[0].length, n = r([t]), i = a(e), o = 0; o < e.length; ++o) for (var s = 0; s < t; ++s) n[s] += e[o][s] * i[o];
              return n;
            }
            s.barycenetric = a, t.exports = s;
          }, {
            dup: 87,
            "robust-linear-solve": 320
          }],
          58: [function (e, t, n) {
            t.exports = function (e) {
              for (var t = r(e), n = 0, i = 0; i < e.length; ++i) for (var o = e[i], a = 0; a < t.length; ++a) n += Math.pow(o[a] - t[a], 2);
              return Math.sqrt(n / e.length);
            };
            var r = e("circumcenter");
          }, {
            circumcenter: 57
          }],
          59: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return t < n ? e < t ? t : e > n ? n : e : e < n ? n : e > t ? t : e;
            };
          }, {}],
          60: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              var r;
              if (n) {
                r = t;
                for (var i = new Array(t.length), o = 0; o < t.length; ++o) {
                  var a = t[o];
                  i[o] = [a[0], a[1], n[o]];
                }
                t = i;
              }
              for (var s = function (e, t, n) {
                var r = p(e, [], f(e));
                return v(t, r, n), !!r;
              }(e, t, !!n); y(e, t, !!n);) s = !0;
              if (n && s) for (r.length = 0, n.length = 0, o = 0; o < t.length; ++o) a = t[o], r.push([a[0], a[1]]), n.push(a[2]);
              return s;
            };
            var r = e("union-find"),
              i = e("box-intersect"),
              o = e("robust-segment-intersect"),
              a = e("big-rat"),
              s = e("big-rat/cmp"),
              l = e("big-rat/to-float"),
              u = e("rat-vec"),
              c = e("nextafter"),
              d = e("./lib/rat-seg-intersect");
            function h(e) {
              var t = l(e);
              return [c(t, -1 / 0), c(t, 1 / 0)];
            }
            function f(e) {
              for (var t = new Array(e.length), n = 0; n < e.length; ++n) {
                var r = e[n];
                t[n] = [c(r[0], -1 / 0), c(r[1], -1 / 0), c(r[0], 1 / 0), c(r[1], 1 / 0)];
              }
              return t;
            }
            function p(e, t, n) {
              for (var o = t.length, a = new r(o), s = [], l = 0; l < t.length; ++l) {
                var u = t[l],
                  d = h(u[0]),
                  f = h(u[1]);
                s.push([c(d[0], -1 / 0), c(f[0], -1 / 0), c(d[1], 1 / 0), c(f[1], 1 / 0)]);
              }
              i(s, function (e, t) {
                a.link(e, t);
              });
              var p = !0,
                m = new Array(o);
              for (l = 0; l < o; ++l) (v = a.find(l)) !== l && (p = !1, e[v] = [Math.min(e[l][0], e[v][0]), Math.min(e[l][1], e[v][1])]);
              if (p) return null;
              var g = 0;
              for (l = 0; l < o; ++l) {
                var v;
                (v = a.find(l)) === l ? (m[l] = g, e[g++] = e[l]) : m[l] = -1;
              }
              for (e.length = g, l = 0; l < o; ++l) m[l] < 0 && (m[l] = m[a.find(l)]);
              return m;
            }
            function m(e, t) {
              return e[0] - t[0] || e[1] - t[1];
            }
            function g(e, t) {
              return e[0] - t[0] || e[1] - t[1] || (e[2] < t[2] ? -1 : e[2] > t[2] ? 1 : 0);
            }
            function v(e, t, n) {
              if (0 !== e.length) {
                if (t) for (var r = 0; r < e.length; ++r) {
                  var i = t[(a = e[r])[0]],
                    o = t[a[1]];
                  a[0] = Math.min(i, o), a[1] = Math.max(i, o);
                } else for (r = 0; r < e.length; ++r) {
                  var a;
                  i = (a = e[r])[0], o = a[1], a[0] = Math.min(i, o), a[1] = Math.max(i, o);
                }
                n ? e.sort(g) : e.sort(m);
                var s = 1;
                for (r = 1; r < e.length; ++r) {
                  var l = e[r - 1],
                    u = e[r];
                  (u[0] !== l[0] || u[1] !== l[1] || n && u[2] !== l[2]) && (e[s++] = u);
                }
                e.length = s;
              }
            }
            function y(e, t, n) {
              var r = function (e, t) {
                  for (var n = new Array(t.length), r = 0; r < t.length; ++r) {
                    var i = t[r],
                      o = e[i[0]],
                      a = e[i[1]];
                    n[r] = [c(Math.min(o[0], a[0]), -1 / 0), c(Math.min(o[1], a[1]), -1 / 0), c(Math.max(o[0], a[0]), 1 / 0), c(Math.max(o[1], a[1]), 1 / 0)];
                  }
                  return n;
                }(e, t),
                h = function (e, t, n) {
                  var r = [];
                  return i(n, function (n, i) {
                    var a = t[n],
                      s = t[i];
                    if (a[0] !== s[0] && a[0] !== s[1] && a[1] !== s[0] && a[1] !== s[1]) {
                      var l = e[a[0]],
                        u = e[a[1]],
                        c = e[s[0]],
                        d = e[s[1]];
                      o(l, u, c, d) && r.push([n, i]);
                    }
                  }), r;
                }(e, t, r),
                m = function (e, t, n, r) {
                  var a = [];
                  return i(n, r, function (n, r) {
                    var i = t[n];
                    if (i[0] !== r && i[1] !== r) {
                      var s = e[r],
                        l = e[i[0]],
                        u = e[i[1]];
                      o(l, u, s, s) && a.push([n, r]);
                    }
                  }), a;
                }(e, t, r, f(e)),
                g = p(e, function (e, t, n, r, i) {
                  var o,
                    c,
                    h = e.map(function (e) {
                      return [a(e[0]), a(e[1])];
                    });
                  for (o = 0; o < n.length; ++o) {
                    var f = n[o];
                    c = f[0];
                    var p = f[1],
                      m = t[c],
                      g = t[p],
                      v = d(u(e[m[0]]), u(e[m[1]]), u(e[g[0]]), u(e[g[1]]));
                    if (v) {
                      var y = e.length;
                      e.push([l(v[0]), l(v[1])]), h.push(v), r.push([c, y], [p, y]);
                    }
                  }
                  for (r.sort(function (e, t) {
                    if (e[0] !== t[0]) return e[0] - t[0];
                    var n = h[e[1]],
                      r = h[t[1]];
                    return s(n[0], r[0]) || s(n[1], r[1]);
                  }), o = r.length - 1; o >= 0; --o) {
                    var b = t[c = (M = r[o])[0]],
                      _ = b[0],
                      x = b[1],
                      w = e[_],
                      S = e[x];
                    if ((w[0] - S[0] || w[1] - S[1]) < 0) {
                      var A = _;
                      _ = x, x = A;
                    }
                    b[0] = _;
                    var E,
                      T = b[1] = M[1];
                    for (i && (E = b[2]); o > 0 && r[o - 1][0] === c;) {
                      var M,
                        C = (M = r[--o])[1];
                      i ? t.push([T, C, E]) : t.push([T, C]), T = C;
                    }
                    i ? t.push([T, x, E]) : t.push([T, x]);
                  }
                  return h;
                }(e, t, h, m, n));
              return v(t, g, n), !!g || h.length > 0 || m.length > 0;
            }
          }, {
            "./lib/rat-seg-intersect": 61,
            "big-rat": 23,
            "big-rat/cmp": 21,
            "big-rat/to-float": 35,
            "box-intersect": 40,
            nextafter: 286,
            "rat-vec": 310,
            "robust-segment-intersect": 324,
            "union-find": 348
          }],
          61: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, r) {
              var o = s(t, e),
                d = s(r, n),
                h = c(o, d);
              if (0 === a(h)) return null;
              var f = c(d, s(e, n)),
                p = i(f, h),
                m = u(o, p);
              return l(e, m);
            };
            var r = e("big-rat/mul"),
              i = e("big-rat/div"),
              o = e("big-rat/sub"),
              a = e("big-rat/sign"),
              s = e("rat-vec/sub"),
              l = e("rat-vec/add"),
              u = e("rat-vec/muls");
            function c(e, t) {
              return o(r(e[0], t[1]), r(e[1], t[0]));
            }
          }, {
            "big-rat/div": 22,
            "big-rat/mul": 32,
            "big-rat/sign": 33,
            "big-rat/sub": 34,
            "rat-vec/add": 309,
            "rat-vec/muls": 311,
            "rat-vec/sub": 312
          }],
          62: [function (e, t, n) {
            "use strict";

            t.exports = {
              aliceblue: [240, 248, 255],
              antiquewhite: [250, 235, 215],
              aqua: [0, 255, 255],
              aquamarine: [127, 255, 212],
              azure: [240, 255, 255],
              beige: [245, 245, 220],
              bisque: [255, 228, 196],
              black: [0, 0, 0],
              blanchedalmond: [255, 235, 205],
              blue: [0, 0, 255],
              blueviolet: [138, 43, 226],
              brown: [165, 42, 42],
              burlywood: [222, 184, 135],
              cadetblue: [95, 158, 160],
              chartreuse: [127, 255, 0],
              chocolate: [210, 105, 30],
              coral: [255, 127, 80],
              cornflowerblue: [100, 149, 237],
              cornsilk: [255, 248, 220],
              crimson: [220, 20, 60],
              cyan: [0, 255, 255],
              darkblue: [0, 0, 139],
              darkcyan: [0, 139, 139],
              darkgoldenrod: [184, 134, 11],
              darkgray: [169, 169, 169],
              darkgreen: [0, 100, 0],
              darkgrey: [169, 169, 169],
              darkkhaki: [189, 183, 107],
              darkmagenta: [139, 0, 139],
              darkolivegreen: [85, 107, 47],
              darkorange: [255, 140, 0],
              darkorchid: [153, 50, 204],
              darkred: [139, 0, 0],
              darksalmon: [233, 150, 122],
              darkseagreen: [143, 188, 143],
              darkslateblue: [72, 61, 139],
              darkslategray: [47, 79, 79],
              darkslategrey: [47, 79, 79],
              darkturquoise: [0, 206, 209],
              darkviolet: [148, 0, 211],
              deeppink: [255, 20, 147],
              deepskyblue: [0, 191, 255],
              dimgray: [105, 105, 105],
              dimgrey: [105, 105, 105],
              dodgerblue: [30, 144, 255],
              firebrick: [178, 34, 34],
              floralwhite: [255, 250, 240],
              forestgreen: [34, 139, 34],
              fuchsia: [255, 0, 255],
              gainsboro: [220, 220, 220],
              ghostwhite: [248, 248, 255],
              gold: [255, 215, 0],
              goldenrod: [218, 165, 32],
              gray: [128, 128, 128],
              green: [0, 128, 0],
              greenyellow: [173, 255, 47],
              grey: [128, 128, 128],
              honeydew: [240, 255, 240],
              hotpink: [255, 105, 180],
              indianred: [205, 92, 92],
              indigo: [75, 0, 130],
              ivory: [255, 255, 240],
              khaki: [240, 230, 140],
              lavender: [230, 230, 250],
              lavenderblush: [255, 240, 245],
              lawngreen: [124, 252, 0],
              lemonchiffon: [255, 250, 205],
              lightblue: [173, 216, 230],
              lightcoral: [240, 128, 128],
              lightcyan: [224, 255, 255],
              lightgoldenrodyellow: [250, 250, 210],
              lightgray: [211, 211, 211],
              lightgreen: [144, 238, 144],
              lightgrey: [211, 211, 211],
              lightpink: [255, 182, 193],
              lightsalmon: [255, 160, 122],
              lightseagreen: [32, 178, 170],
              lightskyblue: [135, 206, 250],
              lightslategray: [119, 136, 153],
              lightslategrey: [119, 136, 153],
              lightsteelblue: [176, 196, 222],
              lightyellow: [255, 255, 224],
              lime: [0, 255, 0],
              limegreen: [50, 205, 50],
              linen: [250, 240, 230],
              magenta: [255, 0, 255],
              maroon: [128, 0, 0],
              mediumaquamarine: [102, 205, 170],
              mediumblue: [0, 0, 205],
              mediumorchid: [186, 85, 211],
              mediumpurple: [147, 112, 219],
              mediumseagreen: [60, 179, 113],
              mediumslateblue: [123, 104, 238],
              mediumspringgreen: [0, 250, 154],
              mediumturquoise: [72, 209, 204],
              mediumvioletred: [199, 21, 133],
              midnightblue: [25, 25, 112],
              mintcream: [245, 255, 250],
              mistyrose: [255, 228, 225],
              moccasin: [255, 228, 181],
              navajowhite: [255, 222, 173],
              navy: [0, 0, 128],
              oldlace: [253, 245, 230],
              olive: [128, 128, 0],
              olivedrab: [107, 142, 35],
              orange: [255, 165, 0],
              orangered: [255, 69, 0],
              orchid: [218, 112, 214],
              palegoldenrod: [238, 232, 170],
              palegreen: [152, 251, 152],
              paleturquoise: [175, 238, 238],
              palevioletred: [219, 112, 147],
              papayawhip: [255, 239, 213],
              peachpuff: [255, 218, 185],
              peru: [205, 133, 63],
              pink: [255, 192, 203],
              plum: [221, 160, 221],
              powderblue: [176, 224, 230],
              purple: [128, 0, 128],
              rebeccapurple: [102, 51, 153],
              red: [255, 0, 0],
              rosybrown: [188, 143, 143],
              royalblue: [65, 105, 225],
              saddlebrown: [139, 69, 19],
              salmon: [250, 128, 114],
              sandybrown: [244, 164, 96],
              seagreen: [46, 139, 87],
              seashell: [255, 245, 238],
              sienna: [160, 82, 45],
              silver: [192, 192, 192],
              skyblue: [135, 206, 235],
              slateblue: [106, 90, 205],
              slategray: [112, 128, 144],
              slategrey: [112, 128, 144],
              snow: [255, 250, 250],
              springgreen: [0, 255, 127],
              steelblue: [70, 130, 180],
              tan: [210, 180, 140],
              teal: [0, 128, 128],
              thistle: [216, 191, 216],
              tomato: [255, 99, 71],
              turquoise: [64, 224, 208],
              violet: [238, 130, 238],
              wheat: [245, 222, 179],
              white: [255, 255, 255],
              whitesmoke: [245, 245, 245],
              yellow: [255, 255, 0],
              yellowgreen: [154, 205, 50]
            };
          }, {}],
          63: [function (e, t, n) {
            "use strict";

            var r = e("color-rgba"),
              i = e("clamp"),
              o = e("dtype");
            t.exports = function (e, t) {
              "float" !== t && t || (t = "array"), "uint" === t && (t = "uint8"), "uint_clamped" === t && (t = "uint8_clamped");
              var n = new (o(t))(4),
                a = "uint8" !== t && "uint8_clamped" !== t;
              return e.length && "string" != typeof e || ((e = r(e))[0] /= 255, e[1] /= 255, e[2] /= 255), function (e) {
                return e instanceof Uint8Array || e instanceof Uint8ClampedArray || !!(Array.isArray(e) && (e[0] > 1 || 0 === e[0]) && (e[1] > 1 || 0 === e[1]) && (e[2] > 1 || 0 === e[2]) && (!e[3] || e[3] > 1));
              }(e) ? (n[0] = e[0], n[1] = e[1], n[2] = e[2], n[3] = null != e[3] ? e[3] : 255, a && (n[0] /= 255, n[1] /= 255, n[2] /= 255, n[3] /= 255), n) : (a ? (n[0] = e[0], n[1] = e[1], n[2] = e[2], n[3] = null != e[3] ? e[3] : 1) : (n[0] = i(Math.floor(255 * e[0]), 0, 255), n[1] = i(Math.floor(255 * e[1]), 0, 255), n[2] = i(Math.floor(255 * e[2]), 0, 255), n[3] = null == e[3] ? 255 : i(Math.floor(255 * e[3]), 0, 255)), n);
            };
          }, {
            clamp: 59,
            "color-rgba": 65,
            dtype: 86
          }],
          64: [function (e, n, r) {
            (function (t) {
              "use strict";

              var r = e("color-name"),
                i = e("is-plain-obj"),
                o = e("defined");
              n.exports = function (e) {
                var n,
                  s,
                  l = [],
                  u = 1;
                if ("string" == typeof e) {
                  if (r[e]) l = r[e].slice(), s = "rgb";else if ("transparent" === e) u = 0, s = "rgb", l = [0, 0, 0];else if (/^#[A-Fa-f0-9]+$/.test(e)) {
                    var c = e.slice(1);
                    u = 1, (f = c.length) <= 4 ? (l = [parseInt(c[0] + c[0], 16), parseInt(c[1] + c[1], 16), parseInt(c[2] + c[2], 16)], 4 === f && (u = parseInt(c[3] + c[3], 16) / 255)) : (l = [parseInt(c[0] + c[1], 16), parseInt(c[2] + c[3], 16), parseInt(c[4] + c[5], 16)], 8 === f && (u = parseInt(c[6] + c[7], 16) / 255)), l[0] || (l[0] = 0), l[1] || (l[1] = 0), l[2] || (l[2] = 0), s = "rgb";
                  } else if (n = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(e)) {
                    var d = n[1],
                      h = "rgb" === d;
                    s = c = d.replace(/a$/, "");
                    var f = "cmyk" === c ? 4 : "gray" === c ? 1 : 3;
                    l = n[2].trim().split(/\s*,\s*/).map(function (e, t) {
                      if (/%$/.test(e)) return t === f ? parseFloat(e) / 100 : "rgb" === c ? 255 * parseFloat(e) / 100 : parseFloat(e);
                      if ("h" === c[t]) {
                        if (/deg$/.test(e)) return parseFloat(e);
                        if (void 0 !== a[e]) return a[e];
                      }
                      return parseFloat(e);
                    }), d === c && l.push(1), u = h || void 0 === l[f] ? 1 : l[f], l = l.slice(0, f);
                  } else e.length > 10 && /[0-9](?:\s|\/)/.test(e) && (l = e.match(/([0-9]+)/g).map(function (e) {
                    return parseFloat(e);
                  }), s = e.match(/([a-z])/gi).join("").toLowerCase());
                } else if (isNaN(e)) {
                  if (i(e)) {
                    var p = o(e.r, e.red, e.R, null);
                    null !== p ? (s = "rgb", l = [p, o(e.g, e.green, e.G), o(e.b, e.blue, e.B)]) : (s = "hsl", l = [o(e.h, e.hue, e.H), o(e.s, e.saturation, e.S), o(e.l, e.lightness, e.L, e.b, e.brightness)]), u = o(e.a, e.alpha, e.opacity, 1), null != e.opacity && (u /= 100);
                  } else (Array.isArray(e) || t.ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(e)) && (l = [e[0], e[1], e[2]], s = "rgb", u = 4 === e.length ? e[3] : 1);
                } else s = "rgb", l = [e >>> 16, (65280 & e) >>> 8, 255 & e];
                return {
                  space: s,
                  values: l,
                  alpha: u
                };
              };
              var a = {
                red: 0,
                orange: 60,
                yellow: 120,
                green: 180,
                blue: 240,
                purple: 300
              };
            }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {
            "color-name": 62,
            defined: 83,
            "is-plain-obj": 260
          }],
          65: [function (e, t, n) {
            "use strict";

            var r = e("color-parse"),
              i = e("color-space/hsl"),
              o = e("clamp");
            t.exports = function (e) {
              var t,
                n = r(e);
              return n.space ? ((t = Array(3))[0] = o(n.values[0], 0, 255), t[1] = o(n.values[1], 0, 255), t[2] = o(n.values[2], 0, 255), "h" === n.space[0] && (t = i.rgb(t)), t.push(o(n.alpha, 0, 1)), t) : [];
            };
          }, {
            clamp: 59,
            "color-parse": 64,
            "color-space/hsl": 66
          }],
          66: [function (e, t, n) {
            "use strict";

            var r = e("./rgb");
            t.exports = {
              name: "hsl",
              min: [0, 0, 0],
              max: [360, 100, 100],
              channel: ["hue", "saturation", "lightness"],
              alias: ["HSL"],
              rgb: function rgb(e) {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a = e[0] / 360,
                  s = e[1] / 100,
                  l = e[2] / 100;
                if (0 === s) return [o = 255 * l, o, o];
                t = 2 * l - (n = l < .5 ? l * (1 + s) : l + s - l * s), i = [0, 0, 0];
                for (var u = 0; u < 3; u++) (r = a + 1 / 3 * -(u - 1)) < 0 ? r++ : r > 1 && r--, o = 6 * r < 1 ? t + 6 * (n - t) * r : 2 * r < 1 ? n : 3 * r < 2 ? t + (n - t) * (2 / 3 - r) * 6 : t, i[u] = 255 * o;
                return i;
              }
            }, r.hsl = function (e) {
              var t,
                n,
                r = e[0] / 255,
                i = e[1] / 255,
                o = e[2] / 255,
                a = Math.min(r, i, o),
                s = Math.max(r, i, o),
                l = s - a;
              return s === a ? t = 0 : r === s ? t = (i - o) / l : i === s ? t = 2 + (o - r) / l : o === s && (t = 4 + (r - i) / l), (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (a + s) / 2, [t, 100 * (s === a ? 0 : n <= .5 ? l / (s + a) : l / (2 - s - a)), 100 * n];
            };
          }, {
            "./rgb": 67
          }],
          67: [function (e, t, n) {
            "use strict";

            t.exports = {
              name: "rgb",
              min: [0, 0, 0],
              max: [255, 255, 255],
              channel: ["red", "green", "blue"],
              alias: ["RGB"]
            };
          }, {}],
          68: [function (e, t, n) {
            var _t$exports;
            t.exports = (_t$exports = {
              jet: [{
                index: 0,
                rgb: [0, 0, 131]
              }, {
                index: .125,
                rgb: [0, 60, 170]
              }, {
                index: .375,
                rgb: [5, 255, 255]
              }, {
                index: .625,
                rgb: [255, 255, 0]
              }, {
                index: .875,
                rgb: [250, 0, 0]
              }, {
                index: 1,
                rgb: [128, 0, 0]
              }],
              hsv: [{
                index: 0,
                rgb: [255, 0, 0]
              }, {
                index: .169,
                rgb: [253, 255, 2]
              }, {
                index: .173,
                rgb: [247, 255, 2]
              }, {
                index: .337,
                rgb: [0, 252, 4]
              }, {
                index: .341,
                rgb: [0, 252, 10]
              }, {
                index: .506,
                rgb: [1, 249, 255]
              }, {
                index: .671,
                rgb: [2, 0, 253]
              }, {
                index: .675,
                rgb: [8, 0, 253]
              }, {
                index: .839,
                rgb: [255, 0, 251]
              }, {
                index: .843,
                rgb: [255, 0, 245]
              }, {
                index: 1,
                rgb: [255, 0, 6]
              }],
              hot: [{
                index: 0,
                rgb: [0, 0, 0]
              }, {
                index: .3,
                rgb: [230, 0, 0]
              }, {
                index: .6,
                rgb: [255, 210, 0]
              }, {
                index: 1,
                rgb: [255, 255, 255]
              }],
              cool: [{
                index: 0,
                rgb: [0, 255, 255]
              }, {
                index: 1,
                rgb: [255, 0, 255]
              }],
              spring: [{
                index: 0,
                rgb: [255, 0, 255]
              }, {
                index: 1,
                rgb: [255, 255, 0]
              }],
              summer: [{
                index: 0,
                rgb: [0, 128, 102]
              }, {
                index: 1,
                rgb: [255, 255, 102]
              }],
              autumn: [{
                index: 0,
                rgb: [255, 0, 0]
              }, {
                index: 1,
                rgb: [255, 255, 0]
              }],
              winter: [{
                index: 0,
                rgb: [0, 0, 255]
              }, {
                index: 1,
                rgb: [0, 255, 128]
              }],
              bone: [{
                index: 0,
                rgb: [0, 0, 0]
              }, {
                index: .376,
                rgb: [84, 84, 116]
              }, {
                index: .753,
                rgb: [169, 200, 200]
              }, {
                index: 1,
                rgb: [255, 255, 255]
              }],
              copper: [{
                index: 0,
                rgb: [0, 0, 0]
              }, {
                index: .804,
                rgb: [255, 160, 102]
              }, {
                index: 1,
                rgb: [255, 199, 127]
              }],
              greys: [{
                index: 0,
                rgb: [0, 0, 0]
              }, {
                index: 1,
                rgb: [255, 255, 255]
              }],
              yignbu: [{
                index: 0,
                rgb: [8, 29, 88]
              }, {
                index: .125,
                rgb: [37, 52, 148]
              }, {
                index: .25,
                rgb: [34, 94, 168]
              }, {
                index: .375,
                rgb: [29, 145, 192]
              }, {
                index: .5,
                rgb: [65, 182, 196]
              }, {
                index: .625,
                rgb: [127, 205, 187]
              }, {
                index: .75,
                rgb: [199, 233, 180]
              }, {
                index: .875,
                rgb: [237, 248, 217]
              }, {
                index: 1,
                rgb: [255, 255, 217]
              }],
              greens: [{
                index: 0,
                rgb: [0, 68, 27]
              }, {
                index: .125,
                rgb: [0, 109, 44]
              }, {
                index: .25,
                rgb: [35, 139, 69]
              }, {
                index: .375,
                rgb: [65, 171, 93]
              }, {
                index: .5,
                rgb: [116, 196, 118]
              }, {
                index: .625,
                rgb: [161, 217, 155]
              }, {
                index: .75,
                rgb: [199, 233, 192]
              }, {
                index: .875,
                rgb: [229, 245, 224]
              }, {
                index: 1,
                rgb: [247, 252, 245]
              }],
              yiorrd: [{
                index: 0,
                rgb: [128, 0, 38]
              }, {
                index: .125,
                rgb: [189, 0, 38]
              }, {
                index: .25,
                rgb: [227, 26, 28]
              }, {
                index: .375,
                rgb: [252, 78, 42]
              }, {
                index: .5,
                rgb: [253, 141, 60]
              }, {
                index: .625,
                rgb: [254, 178, 76]
              }, {
                index: .75,
                rgb: [254, 217, 118]
              }, {
                index: .875,
                rgb: [255, 237, 160]
              }, {
                index: 1,
                rgb: [255, 255, 204]
              }],
              bluered: [{
                index: 0,
                rgb: [0, 0, 255]
              }, {
                index: 1,
                rgb: [255, 0, 0]
              }],
              rdbu: [{
                index: 0,
                rgb: [5, 10, 172]
              }, {
                index: .35,
                rgb: [106, 137, 247]
              }, {
                index: .5,
                rgb: [190, 190, 190]
              }, {
                index: .6,
                rgb: [220, 170, 132]
              }, {
                index: .7,
                rgb: [230, 145, 90]
              }, {
                index: 1,
                rgb: [178, 10, 28]
              }],
              picnic: [{
                index: 0,
                rgb: [0, 0, 255]
              }, {
                index: .1,
                rgb: [51, 153, 255]
              }, {
                index: .2,
                rgb: [102, 204, 255]
              }, {
                index: .3,
                rgb: [153, 204, 255]
              }, {
                index: .4,
                rgb: [204, 204, 255]
              }, {
                index: .5,
                rgb: [255, 255, 255]
              }, {
                index: .6,
                rgb: [255, 204, 255]
              }, {
                index: .7,
                rgb: [255, 153, 255]
              }, {
                index: .8,
                rgb: [255, 102, 204]
              }, {
                index: .9,
                rgb: [255, 102, 102]
              }, {
                index: 1,
                rgb: [255, 0, 0]
              }],
              rainbow: [{
                index: 0,
                rgb: [150, 0, 90]
              }, {
                index: .125,
                rgb: [0, 0, 200]
              }, {
                index: .25,
                rgb: [0, 25, 255]
              }, {
                index: .375,
                rgb: [0, 152, 255]
              }, {
                index: .5,
                rgb: [44, 255, 150]
              }, {
                index: .625,
                rgb: [151, 255, 0]
              }, {
                index: .75,
                rgb: [255, 234, 0]
              }, {
                index: .875,
                rgb: [255, 111, 0]
              }, {
                index: 1,
                rgb: [255, 0, 0]
              }],
              portland: [{
                index: 0,
                rgb: [12, 51, 131]
              }, {
                index: .25,
                rgb: [10, 136, 186]
              }, {
                index: .5,
                rgb: [242, 211, 56]
              }, {
                index: .75,
                rgb: [242, 143, 56]
              }, {
                index: 1,
                rgb: [217, 30, 30]
              }],
              blackbody: [{
                index: 0,
                rgb: [0, 0, 0]
              }, {
                index: .2,
                rgb: [230, 0, 0]
              }, {
                index: .4,
                rgb: [230, 210, 0]
              }, {
                index: .7,
                rgb: [255, 255, 255]
              }, {
                index: 1,
                rgb: [160, 200, 255]
              }],
              earth: [{
                index: 0,
                rgb: [0, 0, 130]
              }, {
                index: .1,
                rgb: [0, 180, 180]
              }, {
                index: .2,
                rgb: [40, 210, 40]
              }, {
                index: .4,
                rgb: [230, 230, 50]
              }, {
                index: .6,
                rgb: [120, 70, 20]
              }, {
                index: 1,
                rgb: [255, 255, 255]
              }],
              electric: [{
                index: 0,
                rgb: [0, 0, 0]
              }, {
                index: .15,
                rgb: [30, 0, 100]
              }, {
                index: .4,
                rgb: [120, 0, 100]
              }, {
                index: .6,
                rgb: [160, 90, 0]
              }, {
                index: .8,
                rgb: [230, 200, 0]
              }, {
                index: 1,
                rgb: [255, 250, 220]
              }],
              alpha: [{
                index: 0,
                rgb: [255, 255, 255, 0]
              }, {
                index: 1,
                rgb: [255, 255, 255, 1]
              }],
              viridis: [{
                index: 0,
                rgb: [68, 1, 84]
              }, {
                index: .13,
                rgb: [71, 44, 122]
              }, {
                index: .25,
                rgb: [59, 81, 139]
              }, {
                index: .38,
                rgb: [44, 113, 142]
              }, {
                index: .5,
                rgb: [33, 144, 141]
              }, {
                index: .63,
                rgb: [39, 173, 129]
              }, {
                index: .75,
                rgb: [92, 200, 99]
              }, {
                index: .88,
                rgb: [170, 220, 50]
              }, {
                index: 1,
                rgb: [253, 231, 37]
              }],
              inferno: [{
                index: 0,
                rgb: [0, 0, 4]
              }, {
                index: .13,
                rgb: [31, 12, 72]
              }, {
                index: .25,
                rgb: [85, 15, 109]
              }, {
                index: .38,
                rgb: [136, 34, 106]
              }, {
                index: .5,
                rgb: [186, 54, 85]
              }, {
                index: .63,
                rgb: [227, 89, 51]
              }, {
                index: .75,
                rgb: [249, 140, 10]
              }, {
                index: .88,
                rgb: [249, 201, 50]
              }, {
                index: 1,
                rgb: [252, 255, 164]
              }],
              magma: [{
                index: 0,
                rgb: [0, 0, 4]
              }, {
                index: .13,
                rgb: [28, 16, 68]
              }, {
                index: .25,
                rgb: [79, 18, 123]
              }, {
                index: .38,
                rgb: [129, 37, 129]
              }, {
                index: .5,
                rgb: [181, 54, 122]
              }, {
                index: .63,
                rgb: [229, 80, 100]
              }, {
                index: .75,
                rgb: [251, 135, 97]
              }, {
                index: .88,
                rgb: [254, 194, 135]
              }, {
                index: 1,
                rgb: [252, 253, 191]
              }],
              plasma: [{
                index: 0,
                rgb: [13, 8, 135]
              }, {
                index: .13,
                rgb: [75, 3, 161]
              }, {
                index: .25,
                rgb: [125, 3, 168]
              }, {
                index: .38,
                rgb: [168, 34, 150]
              }, {
                index: .5,
                rgb: [203, 70, 121]
              }, {
                index: .63,
                rgb: [229, 107, 93]
              }, {
                index: .75,
                rgb: [248, 148, 65]
              }, {
                index: .88,
                rgb: [253, 195, 40]
              }, {
                index: 1,
                rgb: [240, 249, 33]
              }],
              warm: [{
                index: 0,
                rgb: [125, 0, 179]
              }, {
                index: .13,
                rgb: [172, 0, 187]
              }, {
                index: .25,
                rgb: [219, 0, 170]
              }, {
                index: .38,
                rgb: [255, 0, 130]
              }, {
                index: .5,
                rgb: [255, 63, 74]
              }, {
                index: .63,
                rgb: [255, 123, 0]
              }, {
                index: .75,
                rgb: [234, 176, 0]
              }, {
                index: .88,
                rgb: [190, 228, 0]
              }, {
                index: 1,
                rgb: [147, 255, 0]
              }]
            }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_t$exports, "cool", [{
              index: 0,
              rgb: [125, 0, 179]
            }, {
              index: .13,
              rgb: [116, 0, 218]
            }, {
              index: .25,
              rgb: [98, 74, 237]
            }, {
              index: .38,
              rgb: [68, 146, 231]
            }, {
              index: .5,
              rgb: [0, 204, 197]
            }, {
              index: .63,
              rgb: [0, 247, 146]
            }, {
              index: .75,
              rgb: [0, 255, 88]
            }, {
              index: .88,
              rgb: [40, 255, 8]
            }, {
              index: 1,
              rgb: [147, 255, 0]
            }]), "rainbow-soft", [{
              index: 0,
              rgb: [125, 0, 179]
            }, {
              index: .1,
              rgb: [199, 0, 180]
            }, {
              index: .2,
              rgb: [255, 0, 121]
            }, {
              index: .3,
              rgb: [255, 108, 0]
            }, {
              index: .4,
              rgb: [222, 194, 0]
            }, {
              index: .5,
              rgb: [150, 255, 0]
            }, {
              index: .6,
              rgb: [0, 255, 55]
            }, {
              index: .7,
              rgb: [0, 246, 150]
            }, {
              index: .8,
              rgb: [50, 167, 222]
            }, {
              index: .9,
              rgb: [103, 51, 235]
            }, {
              index: 1,
              rgb: [124, 0, 186]
            }]), "bathymetry", [{
              index: 0,
              rgb: [40, 26, 44]
            }, {
              index: .13,
              rgb: [59, 49, 90]
            }, {
              index: .25,
              rgb: [64, 76, 139]
            }, {
              index: .38,
              rgb: [63, 110, 151]
            }, {
              index: .5,
              rgb: [72, 142, 158]
            }, {
              index: .63,
              rgb: [85, 174, 163]
            }, {
              index: .75,
              rgb: [120, 206, 163]
            }, {
              index: .88,
              rgb: [187, 230, 172]
            }, {
              index: 1,
              rgb: [253, 254, 204]
            }]), "cdom", [{
              index: 0,
              rgb: [47, 15, 62]
            }, {
              index: .13,
              rgb: [87, 23, 86]
            }, {
              index: .25,
              rgb: [130, 28, 99]
            }, {
              index: .38,
              rgb: [171, 41, 96]
            }, {
              index: .5,
              rgb: [206, 67, 86]
            }, {
              index: .63,
              rgb: [230, 106, 84]
            }, {
              index: .75,
              rgb: [242, 149, 103]
            }, {
              index: .88,
              rgb: [249, 193, 135]
            }, {
              index: 1,
              rgb: [254, 237, 176]
            }]), "chlorophyll", [{
              index: 0,
              rgb: [18, 36, 20]
            }, {
              index: .13,
              rgb: [25, 63, 41]
            }, {
              index: .25,
              rgb: [24, 91, 59]
            }, {
              index: .38,
              rgb: [13, 119, 72]
            }, {
              index: .5,
              rgb: [18, 148, 80]
            }, {
              index: .63,
              rgb: [80, 173, 89]
            }, {
              index: .75,
              rgb: [132, 196, 122]
            }, {
              index: .88,
              rgb: [175, 221, 162]
            }, {
              index: 1,
              rgb: [215, 249, 208]
            }]), "density", [{
              index: 0,
              rgb: [54, 14, 36]
            }, {
              index: .13,
              rgb: [89, 23, 80]
            }, {
              index: .25,
              rgb: [110, 45, 132]
            }, {
              index: .38,
              rgb: [120, 77, 178]
            }, {
              index: .5,
              rgb: [120, 113, 213]
            }, {
              index: .63,
              rgb: [115, 151, 228]
            }, {
              index: .75,
              rgb: [134, 185, 227]
            }, {
              index: .88,
              rgb: [177, 214, 227]
            }, {
              index: 1,
              rgb: [230, 241, 241]
            }]), "freesurface-blue", [{
              index: 0,
              rgb: [30, 4, 110]
            }, {
              index: .13,
              rgb: [47, 14, 176]
            }, {
              index: .25,
              rgb: [41, 45, 236]
            }, {
              index: .38,
              rgb: [25, 99, 212]
            }, {
              index: .5,
              rgb: [68, 131, 200]
            }, {
              index: .63,
              rgb: [114, 156, 197]
            }, {
              index: .75,
              rgb: [157, 181, 203]
            }, {
              index: .88,
              rgb: [200, 208, 216]
            }, {
              index: 1,
              rgb: [241, 237, 236]
            }]), "freesurface-red", [{
              index: 0,
              rgb: [60, 9, 18]
            }, {
              index: .13,
              rgb: [100, 17, 27]
            }, {
              index: .25,
              rgb: [142, 20, 29]
            }, {
              index: .38,
              rgb: [177, 43, 27]
            }, {
              index: .5,
              rgb: [192, 87, 63]
            }, {
              index: .63,
              rgb: [205, 125, 105]
            }, {
              index: .75,
              rgb: [216, 162, 148]
            }, {
              index: .88,
              rgb: [227, 199, 193]
            }, {
              index: 1,
              rgb: [241, 237, 236]
            }]), "oxygen", [{
              index: 0,
              rgb: [64, 5, 5]
            }, {
              index: .13,
              rgb: [106, 6, 15]
            }, {
              index: .25,
              rgb: [144, 26, 7]
            }, {
              index: .38,
              rgb: [168, 64, 3]
            }, {
              index: .5,
              rgb: [188, 100, 4]
            }, {
              index: .63,
              rgb: [206, 136, 11]
            }, {
              index: .75,
              rgb: [220, 174, 25]
            }, {
              index: .88,
              rgb: [231, 215, 44]
            }, {
              index: 1,
              rgb: [248, 254, 105]
            }]), "par", [{
              index: 0,
              rgb: [51, 20, 24]
            }, {
              index: .13,
              rgb: [90, 32, 35]
            }, {
              index: .25,
              rgb: [129, 44, 34]
            }, {
              index: .38,
              rgb: [159, 68, 25]
            }, {
              index: .5,
              rgb: [182, 99, 19]
            }, {
              index: .63,
              rgb: [199, 134, 22]
            }, {
              index: .75,
              rgb: [212, 171, 35]
            }, {
              index: .88,
              rgb: [221, 210, 54]
            }, {
              index: 1,
              rgb: [225, 253, 75]
            }]), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_t$exports, "phase", [{
              index: 0,
              rgb: [145, 105, 18]
            }, {
              index: .13,
              rgb: [184, 71, 38]
            }, {
              index: .25,
              rgb: [186, 58, 115]
            }, {
              index: .38,
              rgb: [160, 71, 185]
            }, {
              index: .5,
              rgb: [110, 97, 218]
            }, {
              index: .63,
              rgb: [50, 123, 164]
            }, {
              index: .75,
              rgb: [31, 131, 110]
            }, {
              index: .88,
              rgb: [77, 129, 34]
            }, {
              index: 1,
              rgb: [145, 105, 18]
            }]), "salinity", [{
              index: 0,
              rgb: [42, 24, 108]
            }, {
              index: .13,
              rgb: [33, 50, 162]
            }, {
              index: .25,
              rgb: [15, 90, 145]
            }, {
              index: .38,
              rgb: [40, 118, 137]
            }, {
              index: .5,
              rgb: [59, 146, 135]
            }, {
              index: .63,
              rgb: [79, 175, 126]
            }, {
              index: .75,
              rgb: [120, 203, 104]
            }, {
              index: .88,
              rgb: [193, 221, 100]
            }, {
              index: 1,
              rgb: [253, 239, 154]
            }]), "temperature", [{
              index: 0,
              rgb: [4, 35, 51]
            }, {
              index: .13,
              rgb: [23, 51, 122]
            }, {
              index: .25,
              rgb: [85, 59, 157]
            }, {
              index: .38,
              rgb: [129, 79, 143]
            }, {
              index: .5,
              rgb: [175, 95, 130]
            }, {
              index: .63,
              rgb: [222, 112, 101]
            }, {
              index: .75,
              rgb: [249, 146, 66]
            }, {
              index: .88,
              rgb: [249, 196, 65]
            }, {
              index: 1,
              rgb: [232, 250, 91]
            }]), "turbidity", [{
              index: 0,
              rgb: [34, 31, 27]
            }, {
              index: .13,
              rgb: [65, 50, 41]
            }, {
              index: .25,
              rgb: [98, 69, 52]
            }, {
              index: .38,
              rgb: [131, 89, 57]
            }, {
              index: .5,
              rgb: [161, 112, 59]
            }, {
              index: .63,
              rgb: [185, 140, 66]
            }, {
              index: .75,
              rgb: [202, 174, 88]
            }, {
              index: .88,
              rgb: [216, 209, 126]
            }, {
              index: 1,
              rgb: [233, 246, 171]
            }]), "velocity-blue", [{
              index: 0,
              rgb: [17, 32, 64]
            }, {
              index: .13,
              rgb: [35, 52, 116]
            }, {
              index: .25,
              rgb: [29, 81, 156]
            }, {
              index: .38,
              rgb: [31, 113, 162]
            }, {
              index: .5,
              rgb: [50, 144, 169]
            }, {
              index: .63,
              rgb: [87, 173, 176]
            }, {
              index: .75,
              rgb: [149, 196, 189]
            }, {
              index: .88,
              rgb: [203, 221, 211]
            }, {
              index: 1,
              rgb: [254, 251, 230]
            }]), "velocity-green", [{
              index: 0,
              rgb: [23, 35, 19]
            }, {
              index: .13,
              rgb: [24, 64, 38]
            }, {
              index: .25,
              rgb: [11, 95, 45]
            }, {
              index: .38,
              rgb: [39, 123, 35]
            }, {
              index: .5,
              rgb: [95, 146, 12]
            }, {
              index: .63,
              rgb: [152, 165, 18]
            }, {
              index: .75,
              rgb: [201, 186, 69]
            }, {
              index: .88,
              rgb: [233, 216, 137]
            }, {
              index: 1,
              rgb: [255, 253, 205]
            }]), "cubehelix", [{
              index: 0,
              rgb: [0, 0, 0]
            }, {
              index: .07,
              rgb: [22, 5, 59]
            }, {
              index: .13,
              rgb: [60, 4, 105]
            }, {
              index: .2,
              rgb: [109, 1, 135]
            }, {
              index: .27,
              rgb: [161, 0, 147]
            }, {
              index: .33,
              rgb: [210, 2, 142]
            }, {
              index: .4,
              rgb: [251, 11, 123]
            }, {
              index: .47,
              rgb: [255, 29, 97]
            }, {
              index: .53,
              rgb: [255, 54, 69]
            }, {
              index: .6,
              rgb: [255, 85, 46]
            }, {
              index: .67,
              rgb: [255, 120, 34]
            }, {
              index: .73,
              rgb: [255, 157, 37]
            }, {
              index: .8,
              rgb: [241, 191, 57]
            }, {
              index: .87,
              rgb: [224, 220, 93]
            }, {
              index: .93,
              rgb: [218, 241, 142]
            }, {
              index: 1,
              rgb: [227, 253, 198]
            }]));
          }, {}],
          69: [function (e, t, n) {
            "use strict";

            var r = e("./colorScale"),
              i = e("lerp");
            function o(e) {
              return [e[0] / 255, e[1] / 255, e[2] / 255, e[3]];
            }
            function a(e) {
              for (var t, n = "#", r = 0; r < 3; ++r) n += ("00" + (t = (t = e[r]).toString(16))).substr(t.length);
              return n;
            }
            function s(e) {
              return "rgba(" + e.join(",") + ")";
            }
            t.exports = function (e) {
              var t, n, l, u, c, d, h, f, p, m;
              if (e || (e = {}), f = (e.nshades || 72) - 1, h = e.format || "hex", (d = e.colormap) || (d = "jet"), "string" == typeof d) {
                if (d = d.toLowerCase(), !r[d]) throw Error(d + " not a supported colorscale");
                c = r[d];
              } else {
                if (!Array.isArray(d)) throw Error("unsupported colormap option", d);
                c = d.slice();
              }
              if (c.length > f + 1) throw new Error(d + " map requires nshades to be at least size " + c.length);
              p = Array.isArray(e.alpha) ? 2 !== e.alpha.length ? [1, 1] : e.alpha.slice() : "number" == typeof e.alpha ? [e.alpha, e.alpha] : [1, 1], t = c.map(function (e) {
                return Math.round(e.index * f);
              }), p[0] = Math.min(Math.max(p[0], 0), 1), p[1] = Math.min(Math.max(p[1], 0), 1);
              var g = c.map(function (e, t) {
                  var n = c[t].index,
                    r = c[t].rgb.slice();
                  return 4 === r.length && r[3] >= 0 && r[3] <= 1 || (r[3] = p[0] + (p[1] - p[0]) * n), r;
                }),
                v = [];
              for (m = 0; m < t.length - 1; ++m) {
                u = t[m + 1] - t[m], n = g[m], l = g[m + 1];
                for (var y = 0; y < u; y++) {
                  var b = y / u;
                  v.push([Math.round(i(n[0], l[0], b)), Math.round(i(n[1], l[1], b)), Math.round(i(n[2], l[2], b)), i(n[3], l[3], b)]);
                }
              }
              return v.push(c[c.length - 1].rgb.concat(p[1])), "hex" === h ? v = v.map(a) : "rgbaString" === h ? v = v.map(s) : "float" === h && (v = v.map(o)), v;
            };
          }, {
            "./colorScale": 68,
            lerp: 262
          }],
          70: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, o) {
              var a = r(t, n, o);
              if (0 === a) {
                var s = i(r(e, t, n)),
                  u = i(r(e, t, o));
                if (s === u) {
                  if (0 === s) {
                    var c = l(e, t, n);
                    return c === l(e, t, o) ? 0 : c ? 1 : -1;
                  }
                  return 0;
                }
                return 0 === u ? s > 0 || l(e, t, o) ? -1 : 1 : 0 === s ? u > 0 || l(e, t, n) ? 1 : -1 : i(u - s);
              }
              var d = r(e, t, n);
              return d > 0 ? a > 0 && r(e, t, o) > 0 ? 1 : -1 : d < 0 ? a > 0 || r(e, t, o) > 0 ? 1 : -1 : r(e, t, o) > 0 || l(e, t, n) ? 1 : -1;
            };
            var r = e("robust-orientation"),
              i = e("signum"),
              o = e("two-sum"),
              a = e("robust-product"),
              s = e("robust-sum");
            function l(e, t, n) {
              var r = o(e[0], -t[0]),
                i = o(e[1], -t[1]),
                l = o(n[0], -t[0]),
                u = o(n[1], -t[1]),
                c = s(a(r, l), a(i, u));
              return c[c.length - 1] >= 0;
            }
          }, {
            "robust-orientation": 321,
            "robust-product": 322,
            "robust-sum": 326,
            signum: 327,
            "two-sum": 346
          }],
          71: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = e.length,
                o = e.length - t.length;
              if (o) return o;
              switch (n) {
                case 0:
                  return 0;
                case 1:
                  return e[0] - t[0];
                case 2:
                  return e[0] + e[1] - t[0] - t[1] || r(e[0], e[1]) - r(t[0], t[1]);
                case 3:
                  var a = e[0] + e[1],
                    s = t[0] + t[1];
                  if (o = a + e[2] - (s + t[2])) return o;
                  var l = r(e[0], e[1]),
                    u = r(t[0], t[1]);
                  return r(l, e[2]) - r(u, t[2]) || r(l + e[2], a) - r(u + t[2], s);
                case 4:
                  var c = e[0],
                    d = e[1],
                    h = e[2],
                    f = e[3],
                    p = t[0],
                    m = t[1],
                    g = t[2],
                    v = t[3];
                  return c + d + h + f - (p + m + g + v) || r(c, d, h, f) - r(p, m, g, v, p) || r(c + d, c + h, c + f, d + h, d + f, h + f) - r(p + m, p + g, p + v, m + g, m + v, g + v) || r(c + d + h, c + d + f, c + h + f, d + h + f) - r(p + m + g, p + m + v, p + g + v, m + g + v);
                default:
                  for (var y = e.slice().sort(i), b = t.slice().sort(i), _ = 0; _ < n; ++_) if (o = y[_] - b[_]) return o;
                  return 0;
              }
            };
            var r = Math.min;
            function i(e, t) {
              return e - t;
            }
          }, {}],
          72: [function (e, t, n) {
            "use strict";

            var r = e("compare-cell"),
              i = e("cell-orientation");
            t.exports = function (e, t) {
              return r(e, t) || i(e) - i(t);
            };
          }, {
            "cell-orientation": 56,
            "compare-cell": 71
          }],
          73: [function (e, t, n) {
            "use strict";

            var r = e("./lib/ch1d"),
              i = e("./lib/ch2d"),
              o = e("./lib/chnd");
            t.exports = function (e) {
              var t = e.length;
              if (0 === t) return [];
              if (1 === t) return [[0]];
              var n = e[0].length;
              return 0 === n ? [] : 1 === n ? r(e) : 2 === n ? i(e) : o(e, n);
            };
          }, {
            "./lib/ch1d": 74,
            "./lib/ch2d": 75,
            "./lib/chnd": 76
          }],
          74: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = 0, n = 0, r = 1; r < e.length; ++r) e[r][0] < e[t][0] && (t = r), e[r][0] > e[n][0] && (n = r);
              return t < n ? [[t], [n]] : t > n ? [[n], [t]] : [[t]];
            };
          }, {}],
          75: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = r(e),
                n = t.length;
              if (n <= 2) return [];
              for (var i = new Array(n), o = t[n - 1], a = 0; a < n; ++a) {
                var s = t[a];
                i[a] = [o, s], o = s;
              }
              return i;
            };
            var r = e("monotone-convex-hull-2d");
          }, {
            "monotone-convex-hull-2d": 269
          }],
          76: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              try {
                return r(e, !0);
              } catch (a) {
                var n = i(e);
                if (n.length <= t) return [];
                var o = function (e, t) {
                  for (var n = e.length, r = new Array(n), i = 0; i < t.length; ++i) r[i] = e[t[i]];
                  var o = t.length;
                  for (i = 0; i < n; ++i) t.indexOf(i) < 0 && (r[o++] = e[i]);
                  return r;
                }(e, n);
                return function (e, t) {
                  for (var n = e.length, r = t.length, i = 0; i < n; ++i) for (var o = e[i], a = 0; a < o.length; ++a) {
                    var s = o[a];
                    if (s < r) o[a] = t[s];else {
                      s -= r;
                      for (var l = 0; l < r; ++l) s >= t[l] && (s += 1);
                      o[a] = s;
                    }
                  }
                  return e;
                }(r(o, !0), n);
              }
            };
            var r = e("incremental-convex-hull"),
              i = e("affine-hull");
          }, {
            "affine-hull": 14,
            "incremental-convex-hull": 253
          }],
          77: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, r, i, o) {
              var a = i - 1,
                s = i * i,
                l = a * a,
                u = (1 + 2 * i) * l,
                c = i * l,
                d = s * (3 - 2 * i),
                h = s * a;
              if (e.length) {
                o || (o = new Array(e.length));
                for (var f = e.length - 1; f >= 0; --f) o[f] = u * e[f] + c * t[f] + d * n[f] + h * r[f];
                return o;
              }
              return u * e + c * t + d * n + h * r;
            }, t.exports.derivative = function (e, t, n, r, i, o) {
              var a = 6 * i * i - 6 * i,
                s = 3 * i * i - 4 * i + 1,
                l = -6 * i * i + 6 * i,
                u = 3 * i * i - 2 * i;
              if (e.length) {
                o || (o = new Array(e.length));
                for (var c = e.length - 1; c >= 0; --c) o[c] = a * e[c] + s * t[c] + l * n[c] + u * r[c];
                return o;
              }
              return a * e + s * t + l * n[c] + u * r;
            };
          }, {}],
          78: [function (e, t, n) {
            "use strict";

            var r = e("./lib/thunk.js");
            function i() {
              this.argTypes = [], this.shimArgs = [], this.arrayArgs = [], this.arrayBlockIndices = [], this.scalarArgs = [], this.offsetArgs = [], this.offsetArgIndex = [], this.indexArgs = [], this.shapeArgs = [], this.funcName = "", this.pre = null, this.body = null, this.post = null, this.debug = !1;
            }
            t.exports = function (e) {
              var t = new i();
              t.pre = e.pre, t.body = e.body, t.post = e.post;
              var n = e.args.slice(0);
              t.argTypes = n;
              for (var o = 0; o < n.length; ++o) {
                var a = n[o];
                if ("array" === a || "object" == typeof a && a.blockIndices) {
                  if (t.argTypes[o] = "array", t.arrayArgs.push(o), t.arrayBlockIndices.push(a.blockIndices ? a.blockIndices : 0), t.shimArgs.push("array" + o), o < t.pre.args.length && t.pre.args[o].count > 0) throw new Error("cwise: pre() block may not reference array args");
                  if (o < t.post.args.length && t.post.args[o].count > 0) throw new Error("cwise: post() block may not reference array args");
                } else if ("scalar" === a) t.scalarArgs.push(o), t.shimArgs.push("scalar" + o);else if ("index" === a) {
                  if (t.indexArgs.push(o), o < t.pre.args.length && t.pre.args[o].count > 0) throw new Error("cwise: pre() block may not reference array index");
                  if (o < t.body.args.length && t.body.args[o].lvalue) throw new Error("cwise: body() block may not write to array index");
                  if (o < t.post.args.length && t.post.args[o].count > 0) throw new Error("cwise: post() block may not reference array index");
                } else if ("shape" === a) {
                  if (t.shapeArgs.push(o), o < t.pre.args.length && t.pre.args[o].lvalue) throw new Error("cwise: pre() block may not write to array shape");
                  if (o < t.body.args.length && t.body.args[o].lvalue) throw new Error("cwise: body() block may not write to array shape");
                  if (o < t.post.args.length && t.post.args[o].lvalue) throw new Error("cwise: post() block may not write to array shape");
                } else {
                  if ("object" != typeof a || !a.offset) throw new Error("cwise: Unknown argument type " + n[o]);
                  t.argTypes[o] = "offset", t.offsetArgs.push({
                    array: a.array,
                    offset: a.offset
                  }), t.offsetArgIndex.push(o);
                }
              }
              if (t.arrayArgs.length <= 0) throw new Error("cwise: No array arguments specified");
              if (t.pre.args.length > n.length) throw new Error("cwise: Too many arguments in pre() block");
              if (t.body.args.length > n.length) throw new Error("cwise: Too many arguments in body() block");
              if (t.post.args.length > n.length) throw new Error("cwise: Too many arguments in post() block");
              return t.debug = !!e.printCode || !!e.debug, t.funcName = e.funcName || "cwise", t.blockSize = e.blockSize || 64, r(t);
            };
          }, {
            "./lib/thunk.js": 80
          }],
          79: [function (e, t, n) {
            "use strict";

            var r = e("uniq");
            function i(e, t, n) {
              var r,
                i,
                o = e.length,
                a = t.arrayArgs.length,
                s = t.indexArgs.length > 0,
                l = [],
                u = [],
                c = 0,
                d = 0;
              for (r = 0; r < o; ++r) u.push(["i", r, "=0"].join(""));
              for (i = 0; i < a; ++i) for (r = 0; r < o; ++r) d = c, c = e[r], 0 === r ? u.push(["d", i, "s", r, "=t", i, "p", c].join("")) : u.push(["d", i, "s", r, "=(t", i, "p", c, "-s", d, "*t", i, "p", d, ")"].join(""));
              for (u.length > 0 && l.push("var " + u.join(",")), r = o - 1; r >= 0; --r) c = e[r], l.push(["for(i", r, "=0;i", r, "<s", c, ";++i", r, "){"].join(""));
              for (l.push(n), r = 0; r < o; ++r) {
                for (d = c, c = e[r], i = 0; i < a; ++i) l.push(["p", i, "+=d", i, "s", r].join(""));
                s && (r > 0 && l.push(["index[", d, "]-=s", d].join("")), l.push(["++index[", c, "]"].join(""))), l.push("}");
              }
              return l.join("\n");
            }
            function o(e, t, n) {
              for (var r = e.body, i = [], o = [], a = 0; a < e.args.length; ++a) {
                var s = e.args[a];
                if (!(s.count <= 0)) {
                  var l = new RegExp(s.name, "g"),
                    u = "",
                    c = t.arrayArgs.indexOf(a);
                  switch (t.argTypes[a]) {
                    case "offset":
                      var d = t.offsetArgIndex.indexOf(a);
                      c = t.offsetArgs[d].array, u = "+q" + d;
                    case "array":
                      u = "p" + c + u;
                      var h = "l" + a,
                        f = "a" + c;
                      if (0 === t.arrayBlockIndices[c]) 1 === s.count ? "generic" === n[c] ? s.lvalue ? (i.push(["var ", h, "=", f, ".get(", u, ")"].join("")), r = r.replace(l, h), o.push([f, ".set(", u, ",", h, ")"].join(""))) : r = r.replace(l, [f, ".get(", u, ")"].join("")) : r = r.replace(l, [f, "[", u, "]"].join("")) : "generic" === n[c] ? (i.push(["var ", h, "=", f, ".get(", u, ")"].join("")), r = r.replace(l, h), s.lvalue && o.push([f, ".set(", u, ",", h, ")"].join(""))) : (i.push(["var ", h, "=", f, "[", u, "]"].join("")), r = r.replace(l, h), s.lvalue && o.push([f, "[", u, "]=", h].join("")));else {
                        for (var p = [s.name], m = [u], g = 0; g < Math.abs(t.arrayBlockIndices[c]); g++) p.push("\\s*\\[([^\\]]+)\\]"), m.push("$" + (g + 1) + "*t" + c + "b" + g);
                        if (l = new RegExp(p.join(""), "g"), u = m.join("+"), "generic" === n[c]) throw new Error("cwise: Generic arrays not supported in combination with blocks!");
                        r = r.replace(l, [f, "[", u, "]"].join(""));
                      }
                      break;
                    case "scalar":
                      r = r.replace(l, "Y" + t.scalarArgs.indexOf(a));
                      break;
                    case "index":
                      r = r.replace(l, "index");
                      break;
                    case "shape":
                      r = r.replace(l, "shape");
                  }
                }
              }
              return [i.join("\n"), r, o.join("\n")].join("\n").trim();
            }
            function a(e) {
              for (var t = new Array(e.length), n = !0, r = 0; r < e.length; ++r) {
                var i = e[r],
                  o = i.match(/\d+/);
                o = o ? o[0] : "", 0 === i.charAt(0) ? t[r] = "u" + i.charAt(1) + o : t[r] = i.charAt(0) + o, r > 0 && (n = n && t[r] === t[r - 1]);
              }
              return n ? t[0] : t.join("");
            }
            t.exports = function (e, t) {
              for (var n = t[1].length - Math.abs(e.arrayBlockIndices[0]) | 0, s = new Array(e.arrayArgs.length), l = new Array(e.arrayArgs.length), u = 0; u < e.arrayArgs.length; ++u) l[u] = t[2 * u], s[u] = t[2 * u + 1];
              var c = [],
                d = [],
                h = [],
                f = [],
                p = [];
              for (u = 0; u < e.arrayArgs.length; ++u) {
                e.arrayBlockIndices[u] < 0 ? (h.push(0), f.push(n), c.push(n), d.push(n + e.arrayBlockIndices[u])) : (h.push(e.arrayBlockIndices[u]), f.push(e.arrayBlockIndices[u] + n), c.push(0), d.push(e.arrayBlockIndices[u]));
                for (var m = [], g = 0; g < s[u].length; g++) h[u] <= s[u][g] && s[u][g] < f[u] && m.push(s[u][g] - h[u]);
                p.push(m);
              }
              var v = ["SS"],
                y = ["'use strict'"],
                b = [];
              for (g = 0; g < n; ++g) b.push(["s", g, "=SS[", g, "]"].join(""));
              for (u = 0; u < e.arrayArgs.length; ++u) {
                for (v.push("a" + u), v.push("t" + u), v.push("p" + u), g = 0; g < n; ++g) b.push(["t", u, "p", g, "=t", u, "[", h[u] + g, "]"].join(""));
                for (g = 0; g < Math.abs(e.arrayBlockIndices[u]); ++g) b.push(["t", u, "b", g, "=t", u, "[", c[u] + g, "]"].join(""));
              }
              for (u = 0; u < e.scalarArgs.length; ++u) v.push("Y" + u);
              if (e.shapeArgs.length > 0 && b.push("shape=SS.slice(0)"), e.indexArgs.length > 0) {
                var _ = new Array(n);
                for (u = 0; u < n; ++u) _[u] = "0";
                b.push(["index=[", _.join(","), "]"].join(""));
              }
              for (u = 0; u < e.offsetArgs.length; ++u) {
                var x = e.offsetArgs[u],
                  w = [];
                for (g = 0; g < x.offset.length; ++g) 0 !== x.offset[g] && (1 === x.offset[g] ? w.push(["t", x.array, "p", g].join("")) : w.push([x.offset[g], "*t", x.array, "p", g].join("")));
                0 === w.length ? b.push("q" + u + "=0") : b.push(["q", u, "=", w.join("+")].join(""));
              }
              var S = r([].concat(e.pre.thisVars).concat(e.body.thisVars).concat(e.post.thisVars));
              for ((b = b.concat(S)).length > 0 && y.push("var " + b.join(",")), u = 0; u < e.arrayArgs.length; ++u) y.push("p" + u + "|=0");
              e.pre.body.length > 3 && y.push(o(e.pre, e, l));
              var A = o(e.body, e, l),
                E = function (e) {
                  for (var t = 0, n = e[0].length; t < n;) {
                    for (var r = 1; r < e.length; ++r) if (e[r][t] !== e[0][t]) return t;
                    ++t;
                  }
                  return t;
                }(p);
              E < n ? y.push(function (e, t, n, r) {
                for (var o = t.length, a = n.arrayArgs.length, s = n.blockSize, l = n.indexArgs.length > 0, u = [], c = 0; c < a; ++c) u.push(["var offset", c, "=p", c].join(""));
                for (c = e; c < o; ++c) u.push(["for(var j" + c + "=SS[", t[c], "]|0;j", c, ">0;){"].join("")), u.push(["if(j", c, "<", s, "){"].join("")), u.push(["s", t[c], "=j", c].join("")), u.push(["j", c, "=0"].join("")), u.push(["}else{s", t[c], "=", s].join("")), u.push(["j", c, "-=", s, "}"].join("")), l && u.push(["index[", t[c], "]=j", c].join(""));
                for (c = 0; c < a; ++c) {
                  for (var d = ["offset" + c], h = e; h < o; ++h) d.push(["j", h, "*t", c, "p", t[h]].join(""));
                  u.push(["p", c, "=(", d.join("+"), ")"].join(""));
                }
                for (u.push(i(t, n, r)), c = e; c < o; ++c) u.push("}");
                return u.join("\n");
              }(E, p[0], e, A)) : y.push(i(p[0], e, A)), e.post.body.length > 3 && y.push(o(e.post, e, l)), e.debug && console.log("-----Generated cwise routine for ", t, ":\n" + y.join("\n") + "\n----------");
              var T = [e.funcName || "unnamed", "_cwise_loop_", s[0].join("s"), "m", E, a(l)].join("");
              return new Function(["function ", T, "(", v.join(","), "){", y.join("\n"), "} return ", T].join(""))();
            };
          }, {
            uniq: 349
          }],
          80: [function (e, t, n) {
            "use strict";

            var r = e("./compile.js");
            t.exports = function (e) {
              var t = ["'use strict'", "var CACHED={}"],
                n = [],
                i = e.funcName + "_cwise_thunk";
              t.push(["return function ", i, "(", e.shimArgs.join(","), "){"].join(""));
              for (var o = [], a = [], s = [["array", e.arrayArgs[0], ".shape.slice(", Math.max(0, e.arrayBlockIndices[0]), e.arrayBlockIndices[0] < 0 ? "," + e.arrayBlockIndices[0] + ")" : ")"].join("")], l = [], u = [], c = 0; c < e.arrayArgs.length; ++c) {
                var d = e.arrayArgs[c];
                n.push(["t", d, "=array", d, ".dtype,", "r", d, "=array", d, ".order"].join("")), o.push("t" + d), o.push("r" + d), a.push("t" + d), a.push("r" + d + ".join()"), s.push("array" + d + ".data"), s.push("array" + d + ".stride"), s.push("array" + d + ".offset|0"), c > 0 && (l.push("array" + e.arrayArgs[0] + ".shape.length===array" + d + ".shape.length+" + (Math.abs(e.arrayBlockIndices[0]) - Math.abs(e.arrayBlockIndices[c]))), u.push("array" + e.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0, e.arrayBlockIndices[0]) + "]===array" + d + ".shape[shapeIndex+" + Math.max(0, e.arrayBlockIndices[c]) + "]"));
              }
              for (e.arrayArgs.length > 1 && (t.push("if (!(" + l.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')"), t.push("for(var shapeIndex=array" + e.arrayArgs[0] + ".shape.length-" + Math.abs(e.arrayBlockIndices[0]) + "; shapeIndex--\x3e0;) {"), t.push("if (!(" + u.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')"), t.push("}")), c = 0; c < e.scalarArgs.length; ++c) s.push("scalar" + e.scalarArgs[c]);
              return n.push(["type=[", a.join(","), "].join()"].join("")), n.push("proc=CACHED[type]"), t.push("var " + n.join(",")), t.push(["if(!proc){", "CACHED[type]=proc=compile([", o.join(","), "])}", "return proc(", s.join(","), ")}"].join("")), e.debug && console.log("-----Generated thunk:\n" + t.join("\n") + "\n----------"), new Function("compile", t.join("\n"))(r.bind(void 0, e));
            };
          }, {
            "./compile.js": 79
          }],
          81: [function (e, t, n) {
            t.exports = e("cwise-compiler");
          }, {
            "cwise-compiler": 78
          }],
          82: [function (e, t, n) {
            !function () {
              var e = {
                  version: "3.5.17"
                },
                n = [].slice,
                r = function r(e) {
                  return n.call(e);
                },
                i = this.document;
              function o(e) {
                return e && (e.ownerDocument || e.document || e).documentElement;
              }
              function a(e) {
                return e && (e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView);
              }
              if (i) try {
                r(i.documentElement.childNodes)[0].nodeType;
              } catch (e) {
                r = function r(e) {
                  for (var t = e.length, n = new Array(t); t--;) n[t] = e[t];
                  return n;
                };
              }
              if (Date.now || (Date.now = function () {
                return +new Date();
              }), i) try {
                i.createElement("DIV").style.setProperty("opacity", 0, "");
              } catch (e) {
                var s = this.Element.prototype,
                  l = s.setAttribute,
                  u = s.setAttributeNS,
                  c = this.CSSStyleDeclaration.prototype,
                  d = c.setProperty;
                s.setAttribute = function (e, t) {
                  l.call(this, e, t + "");
                }, s.setAttributeNS = function (e, t, n) {
                  u.call(this, e, t, n + "");
                }, c.setProperty = function (e, t, n) {
                  d.call(this, e, t + "", n);
                };
              }
              function h(e, t) {
                return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
              }
              function f(e) {
                return null === e ? NaN : +e;
              }
              function p(e) {
                return !isNaN(e);
              }
              function m(e) {
                return {
                  left: function left(t, n, r, i) {
                    for (arguments.length < 3 && (r = 0), arguments.length < 4 && (i = t.length); r < i;) {
                      var o = r + i >>> 1;
                      e(t[o], n) < 0 ? r = o + 1 : i = o;
                    }
                    return r;
                  },
                  right: function right(t, n, r, i) {
                    for (arguments.length < 3 && (r = 0), arguments.length < 4 && (i = t.length); r < i;) {
                      var o = r + i >>> 1;
                      e(t[o], n) > 0 ? i = o : r = o + 1;
                    }
                    return r;
                  }
                };
              }
              e.ascending = h, e.descending = function (e, t) {
                return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
              }, e.min = function (e, t) {
                var n,
                  r,
                  i = -1,
                  o = e.length;
                if (1 === arguments.length) {
                  for (; ++i < o;) if (null != (r = e[i]) && r >= r) {
                    n = r;
                    break;
                  }
                  for (; ++i < o;) null != (r = e[i]) && n > r && (n = r);
                } else {
                  for (; ++i < o;) if (null != (r = t.call(e, e[i], i)) && r >= r) {
                    n = r;
                    break;
                  }
                  for (; ++i < o;) null != (r = t.call(e, e[i], i)) && n > r && (n = r);
                }
                return n;
              }, e.max = function (e, t) {
                var n,
                  r,
                  i = -1,
                  o = e.length;
                if (1 === arguments.length) {
                  for (; ++i < o;) if (null != (r = e[i]) && r >= r) {
                    n = r;
                    break;
                  }
                  for (; ++i < o;) null != (r = e[i]) && r > n && (n = r);
                } else {
                  for (; ++i < o;) if (null != (r = t.call(e, e[i], i)) && r >= r) {
                    n = r;
                    break;
                  }
                  for (; ++i < o;) null != (r = t.call(e, e[i], i)) && r > n && (n = r);
                }
                return n;
              }, e.extent = function (e, t) {
                var n,
                  r,
                  i,
                  o = -1,
                  a = e.length;
                if (1 === arguments.length) {
                  for (; ++o < a;) if (null != (r = e[o]) && r >= r) {
                    n = i = r;
                    break;
                  }
                  for (; ++o < a;) null != (r = e[o]) && (n > r && (n = r), i < r && (i = r));
                } else {
                  for (; ++o < a;) if (null != (r = t.call(e, e[o], o)) && r >= r) {
                    n = i = r;
                    break;
                  }
                  for (; ++o < a;) null != (r = t.call(e, e[o], o)) && (n > r && (n = r), i < r && (i = r));
                }
                return [n, i];
              }, e.sum = function (e, t) {
                var n,
                  r = 0,
                  i = e.length,
                  o = -1;
                if (1 === arguments.length) for (; ++o < i;) p(n = +e[o]) && (r += n);else for (; ++o < i;) p(n = +t.call(e, e[o], o)) && (r += n);
                return r;
              }, e.mean = function (e, t) {
                var n,
                  r = 0,
                  i = e.length,
                  o = -1,
                  a = i;
                if (1 === arguments.length) for (; ++o < i;) p(n = f(e[o])) ? r += n : --a;else for (; ++o < i;) p(n = f(t.call(e, e[o], o))) ? r += n : --a;
                if (a) return r / a;
              }, e.quantile = function (e, t) {
                var n = (e.length - 1) * t + 1,
                  r = Math.floor(n),
                  i = +e[r - 1],
                  o = n - r;
                return o ? i + o * (e[r] - i) : i;
              }, e.median = function (t, n) {
                var r,
                  i = [],
                  o = t.length,
                  a = -1;
                if (1 === arguments.length) for (; ++a < o;) p(r = f(t[a])) && i.push(r);else for (; ++a < o;) p(r = f(n.call(t, t[a], a))) && i.push(r);
                if (i.length) return e.quantile(i.sort(h), .5);
              }, e.variance = function (e, t) {
                var n,
                  r,
                  i = e.length,
                  o = 0,
                  a = 0,
                  s = -1,
                  l = 0;
                if (1 === arguments.length) for (; ++s < i;) p(n = f(e[s])) && (a += (r = n - o) * (n - (o += r / ++l)));else for (; ++s < i;) p(n = f(t.call(e, e[s], s))) && (a += (r = n - o) * (n - (o += r / ++l)));
                if (l > 1) return a / (l - 1);
              }, e.deviation = function () {
                var t = e.variance.apply(this, arguments);
                return t ? Math.sqrt(t) : t;
              };
              var g = m(h);
              function v(e) {
                return e.length;
              }
              e.bisectLeft = g.left, e.bisect = e.bisectRight = g.right, e.bisector = function (e) {
                return m(1 === e.length ? function (t, n) {
                  return h(e(t), n);
                } : e);
              }, e.shuffle = function (e, t, n) {
                (o = arguments.length) < 3 && (n = e.length, o < 2 && (t = 0));
                for (var r, i, o = n - t; o;) i = Math.random() * o-- | 0, r = e[o + t], e[o + t] = e[i + t], e[i + t] = r;
                return e;
              }, e.permute = function (e, t) {
                for (var n = t.length, r = new Array(n); n--;) r[n] = e[t[n]];
                return r;
              }, e.pairs = function (e) {
                for (var t = 0, n = e.length - 1, r = e[0], i = new Array(n < 0 ? 0 : n); t < n;) i[t] = [r, r = e[++t]];
                return i;
              }, e.transpose = function (t) {
                if (!(o = t.length)) return [];
                for (var n = -1, r = e.min(t, v), i = new Array(r); ++n < r;) for (var o, a = -1, s = i[n] = new Array(o); ++a < o;) s[a] = t[a][n];
                return i;
              }, e.zip = function () {
                return e.transpose(arguments);
              }, e.keys = function (e) {
                var t = [];
                for (var n in e) t.push(n);
                return t;
              }, e.values = function (e) {
                var t = [];
                for (var n in e) t.push(e[n]);
                return t;
              }, e.entries = function (e) {
                var t = [];
                for (var n in e) t.push({
                  key: n,
                  value: e[n]
                });
                return t;
              }, e.merge = function (e) {
                for (var t, n, r, i = e.length, o = -1, a = 0; ++o < i;) a += e[o].length;
                for (n = new Array(a); --i >= 0;) for (t = (r = e[i]).length; --t >= 0;) n[--a] = r[t];
                return n;
              };
              var y = Math.abs;
              function b(e, t) {
                for (var n in t) Object.defineProperty(e.prototype, n, {
                  value: t[n],
                  enumerable: !1
                });
              }
              function _() {
                this._ = Object.create(null);
              }
              function x(e) {
                return "__proto__" == (e += "") || "\0" === e[0] ? "\0" + e : e;
              }
              function w(e) {
                return "\0" === (e += "")[0] ? e.slice(1) : e;
              }
              function S(e) {
                return x(e) in this._;
              }
              function A(e) {
                return (e = x(e)) in this._ && delete this._[e];
              }
              function E() {
                var e = [];
                for (var t in this._) e.push(w(t));
                return e;
              }
              function T() {
                var e = 0;
                for (var t in this._) ++e;
                return e;
              }
              function M() {
                for (var e in this._) return !1;
                return !0;
              }
              function C() {
                this._ = Object.create(null);
              }
              function k(e) {
                return e;
              }
              function P(e, t, n) {
                return function () {
                  var r = n.apply(t, arguments);
                  return r === t ? e : r;
                };
              }
              function O(e, t) {
                if (t in e) return t;
                t = t.charAt(0).toUpperCase() + t.slice(1);
                for (var n = 0, r = R.length; n < r; ++n) {
                  var i = R[n] + t;
                  if (i in e) return i;
                }
              }
              e.range = function (e, t, n) {
                if (arguments.length < 3 && (n = 1, arguments.length < 2 && (t = e, e = 0)), (t - e) / n == 1 / 0) throw new Error("infinite range");
                var r,
                  i = [],
                  o = function (e) {
                    for (var t = 1; e * t % 1;) t *= 10;
                    return t;
                  }(y(n)),
                  a = -1;
                if (e *= o, t *= o, (n *= o) < 0) for (; (r = e + n * ++a) > t;) i.push(r / o);else for (; (r = e + n * ++a) < t;) i.push(r / o);
                return i;
              }, e.map = function (e, t) {
                var n = new _();
                if (e instanceof _) e.forEach(function (e, t) {
                  n.set(e, t);
                });else if (Array.isArray(e)) {
                  var r,
                    i = -1,
                    o = e.length;
                  if (1 === arguments.length) for (; ++i < o;) n.set(i, e[i]);else for (; ++i < o;) n.set(t.call(e, r = e[i], i), r);
                } else for (var a in e) n.set(a, e[a]);
                return n;
              }, b(_, {
                has: S,
                get: function get(e) {
                  return this._[x(e)];
                },
                set: function set(e, t) {
                  return this._[x(e)] = t;
                },
                remove: A,
                keys: E,
                values: function values() {
                  var e = [];
                  for (var t in this._) e.push(this._[t]);
                  return e;
                },
                entries: function entries() {
                  var e = [];
                  for (var t in this._) e.push({
                    key: w(t),
                    value: this._[t]
                  });
                  return e;
                },
                size: T,
                empty: M,
                forEach: function forEach(e) {
                  for (var t in this._) e.call(this, w(t), this._[t]);
                }
              }), e.nest = function () {
                var t,
                  n,
                  r = {},
                  i = [],
                  o = [];
                function a(e, o, s) {
                  if (s >= i.length) return n ? n.call(r, o) : t ? o.sort(t) : o;
                  for (var l, u, c, d, h = -1, f = o.length, p = i[s++], m = new _(); ++h < f;) (d = m.get(l = p(u = o[h]))) ? d.push(u) : m.set(l, [u]);
                  return e ? (u = e(), c = function c(t, n) {
                    u.set(t, a(e, n, s));
                  }) : (u = {}, c = function c(t, n) {
                    u[t] = a(e, n, s);
                  }), m.forEach(c), u;
                }
                return r.map = function (e, t) {
                  return a(t, e, 0);
                }, r.entries = function (t) {
                  return function e(t, n) {
                    if (n >= i.length) return t;
                    var r = [],
                      a = o[n++];
                    return t.forEach(function (t, i) {
                      r.push({
                        key: t,
                        values: e(i, n)
                      });
                    }), a ? r.sort(function (e, t) {
                      return a(e.key, t.key);
                    }) : r;
                  }(a(e.map, t, 0), 0);
                }, r.key = function (e) {
                  return i.push(e), r;
                }, r.sortKeys = function (e) {
                  return o[i.length - 1] = e, r;
                }, r.sortValues = function (e) {
                  return t = e, r;
                }, r.rollup = function (e) {
                  return n = e, r;
                }, r;
              }, e.set = function (e) {
                var t = new C();
                if (e) for (var n = 0, r = e.length; n < r; ++n) t.add(e[n]);
                return t;
              }, b(C, {
                has: S,
                add: function add(e) {
                  return this._[x(e += "")] = !0, e;
                },
                remove: A,
                values: E,
                size: T,
                empty: M,
                forEach: function forEach(e) {
                  for (var t in this._) e.call(this, w(t));
                }
              }), e.behavior = {}, e.rebind = function (e, t) {
                for (var n, r = 1, i = arguments.length; ++r < i;) e[n = arguments[r]] = P(e, t, t[n]);
                return e;
              };
              var R = ["webkit", "ms", "moz", "Moz", "o", "O"];
              function I() {}
              function j() {}
              function N(e) {
                var t = [],
                  n = new _();
                function r() {
                  for (var n, r = t, i = -1, o = r.length; ++i < o;) (n = r[i].on) && n.apply(this, arguments);
                  return e;
                }
                return r.on = function (r, i) {
                  var o,
                    a = n.get(r);
                  return arguments.length < 2 ? a && a.on : (a && (a.on = null, t = t.slice(0, o = t.indexOf(a)).concat(t.slice(o + 1)), n.remove(r)), i && t.push(n.set(r, {
                    on: i
                  })), e);
                }, r;
              }
              function L() {
                e.event.preventDefault();
              }
              function D() {
                for (var t, n = e.event; t = n.sourceEvent;) n = t;
                return n;
              }
              function B(t) {
                for (var n = new j(), r = 0, i = arguments.length; ++r < i;) n[arguments[r]] = N(n);
                return n.of = function (r, i) {
                  return function (o) {
                    try {
                      var a = o.sourceEvent = e.event;
                      o.target = t, e.event = o, n[o.type].apply(r, i);
                    } finally {
                      e.event = a;
                    }
                  };
                }, n;
              }
              e.dispatch = function () {
                for (var e = new j(), t = -1, n = arguments.length; ++t < n;) e[arguments[t]] = N(e);
                return e;
              }, j.prototype.on = function (e, t) {
                var n = e.indexOf("."),
                  r = "";
                if (n >= 0 && (r = e.slice(n + 1), e = e.slice(0, n)), e) return arguments.length < 2 ? this[e].on(r) : this[e].on(r, t);
                if (2 === arguments.length) {
                  if (null == t) for (e in this) this.hasOwnProperty(e) && this[e].on(r, null);
                  return this;
                }
              }, e.event = null, e.requote = function (e) {
                return e.replace(F, "\\$&");
              };
              var F = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
                z = {}.__proto__ ? function (e, t) {
                  e.__proto__ = t;
                } : function (e, t) {
                  for (var n in t) e[n] = t[n];
                };
              function U(e) {
                return z(e, q), e;
              }
              var G = function G(e, t) {
                  return t.querySelector(e);
                },
                V = function V(e, t) {
                  return t.querySelectorAll(e);
                },
                _H = function H(e, t) {
                  var n = e.matches || e[O(e, "matchesSelector")];
                  return (_H = function H(e, t) {
                    return n.call(e, t);
                  })(e, t);
                };
              "function" == typeof Sizzle && (G = function G(e, t) {
                return Sizzle(e, t)[0] || null;
              }, V = Sizzle, _H = Sizzle.matchesSelector), e.selection = function () {
                return e.select(i.documentElement);
              };
              var q = e.selection.prototype = [];
              function W(e) {
                return "function" == typeof e ? e : function () {
                  return G(e, this);
                };
              }
              function $(e) {
                return "function" == typeof e ? e : function () {
                  return V(e, this);
                };
              }
              q.select = function (e) {
                var t,
                  n,
                  r,
                  i,
                  o = [];
                e = W(e);
                for (var a = -1, s = this.length; ++a < s;) {
                  o.push(t = []), t.parentNode = (r = this[a]).parentNode;
                  for (var l = -1, u = r.length; ++l < u;) (i = r[l]) ? (t.push(n = e.call(i, i.__data__, l, a)), n && "__data__" in i && (n.__data__ = i.__data__)) : t.push(null);
                }
                return U(o);
              }, q.selectAll = function (e) {
                var t,
                  n,
                  i = [];
                e = $(e);
                for (var o = -1, a = this.length; ++o < a;) for (var s = this[o], l = -1, u = s.length; ++l < u;) (n = s[l]) && (i.push(t = r(e.call(n, n.__data__, l, o))), t.parentNode = n);
                return U(i);
              };
              var X = "http://www.w3.org/1999/xhtml",
                Y = {
                  svg: "http://www.w3.org/2000/svg",
                  xhtml: X,
                  xlink: "http://www.w3.org/1999/xlink",
                  xml: "http://www.w3.org/XML/1998/namespace",
                  xmlns: "http://www.w3.org/2000/xmlns/"
                };
              function K(t, n) {
                return t = e.ns.qualify(t), null == n ? t.local ? function () {
                  this.removeAttributeNS(t.space, t.local);
                } : function () {
                  this.removeAttribute(t);
                } : "function" == typeof n ? t.local ? function () {
                  var e = n.apply(this, arguments);
                  null == e ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, e);
                } : function () {
                  var e = n.apply(this, arguments);
                  null == e ? this.removeAttribute(t) : this.setAttribute(t, e);
                } : t.local ? function () {
                  this.setAttributeNS(t.space, t.local, n);
                } : function () {
                  this.setAttribute(t, n);
                };
              }
              function Z(e) {
                return e.trim().replace(/\s+/g, " ");
              }
              function Q(t) {
                return new RegExp("(?:^|\\s+)" + e.requote(t) + "(?:\\s+|$)", "g");
              }
              function J(e) {
                return (e + "").trim().split(/^|\s+/);
              }
              function ee(e, t) {
                var n = (e = J(e).map(te)).length;
                return "function" == typeof t ? function () {
                  for (var r = -1, i = t.apply(this, arguments); ++r < n;) e[r](this, i);
                } : function () {
                  for (var r = -1; ++r < n;) e[r](this, t);
                };
              }
              function te(e) {
                var t = Q(e);
                return function (n, r) {
                  if (i = n.classList) return r ? i.add(e) : i.remove(e);
                  var i = n.getAttribute("class") || "";
                  r ? (t.lastIndex = 0, t.test(i) || n.setAttribute("class", Z(i + " " + e))) : n.setAttribute("class", Z(i.replace(t, " ")));
                };
              }
              function ne(e, t, n) {
                return null == t ? function () {
                  this.style.removeProperty(e);
                } : "function" == typeof t ? function () {
                  var r = t.apply(this, arguments);
                  null == r ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
                } : function () {
                  this.style.setProperty(e, t, n);
                };
              }
              function re(e, t) {
                return null == t ? function () {
                  delete this[e];
                } : "function" == typeof t ? function () {
                  var n = t.apply(this, arguments);
                  null == n ? delete this[e] : this[e] = n;
                } : function () {
                  this[e] = t;
                };
              }
              function ie(t) {
                return "function" == typeof t ? t : (t = e.ns.qualify(t)).local ? function () {
                  return this.ownerDocument.createElementNS(t.space, t.local);
                } : function () {
                  var e = this.ownerDocument,
                    n = this.namespaceURI;
                  return n === X && e.documentElement.namespaceURI === X ? e.createElement(t) : e.createElementNS(n, t);
                };
              }
              function oe() {
                var e = this.parentNode;
                e && e.removeChild(this);
              }
              function ae(e) {
                return {
                  __data__: e
                };
              }
              function se(e) {
                return function () {
                  return _H(this, e);
                };
              }
              function le(e, t) {
                for (var n = 0, r = e.length; n < r; n++) for (var i, o = e[n], a = 0, s = o.length; a < s; a++) (i = o[a]) && t(i, a, n);
                return e;
              }
              function ue(e) {
                return z(e, ce), e;
              }
              e.ns = {
                prefix: Y,
                qualify: function qualify(e) {
                  var t = e.indexOf(":"),
                    n = e;
                  return t >= 0 && "xmlns" !== (n = e.slice(0, t)) && (e = e.slice(t + 1)), Y.hasOwnProperty(n) ? {
                    space: Y[n],
                    local: e
                  } : e;
                }
              }, q.attr = function (t, n) {
                if (arguments.length < 2) {
                  if ("string" == typeof t) {
                    var r = this.node();
                    return (t = e.ns.qualify(t)).local ? r.getAttributeNS(t.space, t.local) : r.getAttribute(t);
                  }
                  for (n in t) this.each(K(n, t[n]));
                  return this;
                }
                return this.each(K(t, n));
              }, q.classed = function (e, t) {
                if (arguments.length < 2) {
                  if ("string" == typeof e) {
                    var n = this.node(),
                      r = (e = J(e)).length,
                      i = -1;
                    if (t = n.classList) {
                      for (; ++i < r;) if (!t.contains(e[i])) return !1;
                    } else for (t = n.getAttribute("class"); ++i < r;) if (!Q(e[i]).test(t)) return !1;
                    return !0;
                  }
                  for (t in e) this.each(ee(t, e[t]));
                  return this;
                }
                return this.each(ee(e, t));
              }, q.style = function (e, t, n) {
                var r = arguments.length;
                if (r < 3) {
                  if ("string" != typeof e) {
                    for (n in r < 2 && (t = ""), e) this.each(ne(n, e[n], t));
                    return this;
                  }
                  if (r < 2) {
                    var i = this.node();
                    return a(i).getComputedStyle(i, null).getPropertyValue(e);
                  }
                  n = "";
                }
                return this.each(ne(e, t, n));
              }, q.property = function (e, t) {
                if (arguments.length < 2) {
                  if ("string" == typeof e) return this.node()[e];
                  for (t in e) this.each(re(t, e[t]));
                  return this;
                }
                return this.each(re(e, t));
              }, q.text = function (e) {
                return arguments.length ? this.each("function" == typeof e ? function () {
                  var t = e.apply(this, arguments);
                  this.textContent = null == t ? "" : t;
                } : null == e ? function () {
                  this.textContent = "";
                } : function () {
                  this.textContent = e;
                }) : this.node().textContent;
              }, q.html = function (e) {
                return arguments.length ? this.each("function" == typeof e ? function () {
                  var t = e.apply(this, arguments);
                  this.innerHTML = null == t ? "" : t;
                } : null == e ? function () {
                  this.innerHTML = "";
                } : function () {
                  this.innerHTML = e;
                }) : this.node().innerHTML;
              }, q.append = function (e) {
                return e = ie(e), this.select(function () {
                  return this.appendChild(e.apply(this, arguments));
                });
              }, q.insert = function (e, t) {
                return e = ie(e), t = W(t), this.select(function () {
                  return this.insertBefore(e.apply(this, arguments), t.apply(this, arguments) || null);
                });
              }, q.remove = function () {
                return this.each(oe);
              }, q.data = function (e, t) {
                var n,
                  r,
                  i = -1,
                  o = this.length;
                if (!arguments.length) {
                  for (e = new Array(o = (n = this[0]).length); ++i < o;) (r = n[i]) && (e[i] = r.__data__);
                  return e;
                }
                function a(e, n) {
                  var r,
                    i,
                    o,
                    a = e.length,
                    c = n.length,
                    d = Math.min(a, c),
                    h = new Array(c),
                    f = new Array(c),
                    p = new Array(a);
                  if (t) {
                    var m,
                      g = new _(),
                      v = new Array(a);
                    for (r = -1; ++r < a;) (i = e[r]) && (g.has(m = t.call(i, i.__data__, r)) ? p[r] = i : g.set(m, i), v[r] = m);
                    for (r = -1; ++r < c;) (i = g.get(m = t.call(n, o = n[r], r))) ? !0 !== i && (h[r] = i, i.__data__ = o) : f[r] = ae(o), g.set(m, !0);
                    for (r = -1; ++r < a;) r in v && !0 !== g.get(v[r]) && (p[r] = e[r]);
                  } else {
                    for (r = -1; ++r < d;) i = e[r], o = n[r], i ? (i.__data__ = o, h[r] = i) : f[r] = ae(o);
                    for (; r < c; ++r) f[r] = ae(n[r]);
                    for (; r < a; ++r) p[r] = e[r];
                  }
                  f.update = h, f.parentNode = h.parentNode = p.parentNode = e.parentNode, s.push(f), l.push(h), u.push(p);
                }
                var s = ue([]),
                  l = U([]),
                  u = U([]);
                if ("function" == typeof e) for (; ++i < o;) a(n = this[i], e.call(n, n.parentNode.__data__, i));else for (; ++i < o;) a(n = this[i], e);
                return l.enter = function () {
                  return s;
                }, l.exit = function () {
                  return u;
                }, l;
              }, q.datum = function (e) {
                return arguments.length ? this.property("__data__", e) : this.property("__data__");
              }, q.filter = function (e) {
                var t,
                  n,
                  r,
                  i = [];
                "function" != typeof e && (e = se(e));
                for (var o = 0, a = this.length; o < a; o++) {
                  i.push(t = []), t.parentNode = (n = this[o]).parentNode;
                  for (var s = 0, l = n.length; s < l; s++) (r = n[s]) && e.call(r, r.__data__, s, o) && t.push(r);
                }
                return U(i);
              }, q.order = function () {
                for (var e = -1, t = this.length; ++e < t;) for (var n, r = this[e], i = r.length - 1, o = r[i]; --i >= 0;) (n = r[i]) && (o && o !== n.nextSibling && o.parentNode.insertBefore(n, o), o = n);
                return this;
              }, q.sort = function (e) {
                e = function (e) {
                  return arguments.length || (e = h), function (t, n) {
                    return t && n ? e(t.__data__, n.__data__) : !t - !n;
                  };
                }.apply(this, arguments);
                for (var t = -1, n = this.length; ++t < n;) this[t].sort(e);
                return this.order();
              }, q.each = function (e) {
                return le(this, function (t, n, r) {
                  e.call(t, t.__data__, n, r);
                });
              }, q.call = function (e) {
                var t = r(arguments);
                return e.apply(t[0] = this, t), this;
              }, q.empty = function () {
                return !this.node();
              }, q.node = function () {
                for (var e = 0, t = this.length; e < t; e++) for (var n = this[e], r = 0, i = n.length; r < i; r++) {
                  var o = n[r];
                  if (o) return o;
                }
                return null;
              }, q.size = function () {
                var e = 0;
                return le(this, function () {
                  ++e;
                }), e;
              };
              var ce = [];
              function de(t, n, i) {
                var o = "__on" + t,
                  a = t.indexOf("."),
                  s = fe;
                a > 0 && (t = t.slice(0, a));
                var l = he.get(t);
                function u() {
                  var e = this[o];
                  e && (this.removeEventListener(t, e, e.$), delete this[o]);
                }
                return l && (t = l, s = pe), a ? n ? function () {
                  var e = s(n, r(arguments));
                  u.call(this), this.addEventListener(t, this[o] = e, e.$ = i), e._ = n;
                } : u : n ? I : function () {
                  var n,
                    r = new RegExp("^__on([^.]+)" + e.requote(t) + "$");
                  for (var i in this) if (n = i.match(r)) {
                    var o = this[i];
                    this.removeEventListener(n[1], o, o.$), delete this[i];
                  }
                };
              }
              e.selection.enter = ue, e.selection.enter.prototype = ce, ce.append = q.append, ce.empty = q.empty, ce.node = q.node, ce.call = q.call, ce.size = q.size, ce.select = function (e) {
                for (var t, n, r, i, o, a = [], s = -1, l = this.length; ++s < l;) {
                  r = (i = this[s]).update, a.push(t = []), t.parentNode = i.parentNode;
                  for (var u = -1, c = i.length; ++u < c;) (o = i[u]) ? (t.push(r[u] = n = e.call(i.parentNode, o.__data__, u, s)), n.__data__ = o.__data__) : t.push(null);
                }
                return U(a);
              }, ce.insert = function (e, t) {
                var n, r, i;
                return arguments.length < 2 && (n = this, t = function t(e, _t37, o) {
                  var a,
                    s = n[o].update,
                    l = s.length;
                  for (o != i && (i = o, r = 0), _t37 >= r && (r = _t37 + 1); !(a = s[r]) && ++r < l;);
                  return a;
                }), q.insert.call(this, e, t);
              }, e.select = function (e) {
                var t;
                return "string" == typeof e ? (t = [G(e, i)]).parentNode = i.documentElement : (t = [e]).parentNode = o(e), U([t]);
              }, e.selectAll = function (e) {
                var t;
                return "string" == typeof e ? (t = r(V(e, i))).parentNode = i.documentElement : (t = r(e)).parentNode = null, U([t]);
              }, q.on = function (e, t, n) {
                var r = arguments.length;
                if (r < 3) {
                  if ("string" != typeof e) {
                    for (n in r < 2 && (t = !1), e) this.each(de(n, e[n], t));
                    return this;
                  }
                  if (r < 2) return (r = this.node()["__on" + e]) && r._;
                  n = !1;
                }
                return this.each(de(e, t, n));
              };
              var he = e.map({
                mouseenter: "mouseover",
                mouseleave: "mouseout"
              });
              function fe(t, n) {
                return function (r) {
                  var i = e.event;
                  e.event = r, n[0] = this.__data__;
                  try {
                    t.apply(this, n);
                  } finally {
                    e.event = i;
                  }
                };
              }
              function pe(e, t) {
                var n = fe(e, t);
                return function (e) {
                  var t = e.relatedTarget;
                  t && (t === this || 8 & t.compareDocumentPosition(this)) || n.call(this, e);
                };
              }
              i && he.forEach(function (e) {
                "on" + e in i && he.remove(e);
              });
              var me,
                ge = 0;
              function ve(t) {
                var n = ".dragsuppress-" + ++ge,
                  r = "click" + n,
                  i = e.select(a(t)).on("touchmove" + n, L).on("dragstart" + n, L).on("selectstart" + n, L);
                if (null == me && (me = !("onselectstart" in t) && O(t.style, "userSelect")), me) {
                  var s = o(t).style,
                    l = s[me];
                  s[me] = "none";
                }
                return function (e) {
                  if (i.on(n, null), me && (s[me] = l), e) {
                    var t = function t() {
                      i.on(r, null);
                    };
                    i.on(r, function () {
                      L(), t();
                    }, !0), setTimeout(t, 0);
                  }
                };
              }
              e.mouse = function (e) {
                return be(e, D());
              };
              var ye = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
              function be(t, n) {
                n.changedTouches && (n = n.changedTouches[0]);
                var r = t.ownerSVGElement || t;
                if (r.createSVGPoint) {
                  var i = r.createSVGPoint();
                  if (ye < 0) {
                    var o = a(t);
                    if (o.scrollX || o.scrollY) {
                      var s = (r = e.select("body").append("svg").style({
                        position: "absolute",
                        top: 0,
                        left: 0,
                        margin: 0,
                        padding: 0,
                        border: "none"
                      }, "important"))[0][0].getScreenCTM();
                      ye = !(s.f || s.e), r.remove();
                    }
                  }
                  return ye ? (i.x = n.pageX, i.y = n.pageY) : (i.x = n.clientX, i.y = n.clientY), [(i = i.matrixTransform(t.getScreenCTM().inverse())).x, i.y];
                }
                var l = t.getBoundingClientRect();
                return [n.clientX - l.left - t.clientLeft, n.clientY - l.top - t.clientTop];
              }
              function _e() {
                return e.event.changedTouches[0].identifier;
              }
              e.touch = function (e, t, n) {
                if (arguments.length < 3 && (n = t, t = D().changedTouches), t) for (var r, i = 0, o = t.length; i < o; ++i) if ((r = t[i]).identifier === n) return be(e, r);
              }, e.behavior.drag = function () {
                var t = B(o, "drag", "dragstart", "dragend"),
                  n = null,
                  r = s(I, e.mouse, a, "mousemove", "mouseup"),
                  i = s(_e, e.touch, k, "touchmove", "touchend");
                function o() {
                  this.on("mousedown.drag", r).on("touchstart.drag", i);
                }
                function s(r, i, o, a, s) {
                  return function () {
                    var l,
                      u = e.event.target.correspondingElement || e.event.target,
                      c = this.parentNode,
                      d = t.of(this, arguments),
                      h = 0,
                      f = r(),
                      p = ".drag" + (null == f ? "" : "-" + f),
                      m = e.select(o(u)).on(a + p, function () {
                        var e,
                          t,
                          n = i(c, f);
                        n && (e = n[0] - v[0], t = n[1] - v[1], h |= e | t, v = n, d({
                          type: "drag",
                          x: n[0] + l[0],
                          y: n[1] + l[1],
                          dx: e,
                          dy: t
                        }));
                      }).on(s + p, function () {
                        i(c, f) && (m.on(a + p, null).on(s + p, null), g(h), d({
                          type: "dragend"
                        }));
                      }),
                      g = ve(u),
                      v = i(c, f);
                    l = n ? [(l = n.apply(this, arguments)).x - v[0], l.y - v[1]] : [0, 0], d({
                      type: "dragstart"
                    });
                  };
                }
                return o.origin = function (e) {
                  return arguments.length ? (n = e, o) : n;
                }, e.rebind(o, t, "on");
              }, e.touches = function (e, t) {
                return arguments.length < 2 && (t = D().touches), t ? r(t).map(function (t) {
                  var n = be(e, t);
                  return n.identifier = t.identifier, n;
                }) : [];
              };
              var xe = 1e-6,
                we = 1e-12,
                Se = Math.PI,
                Ae = 2 * Se,
                Ee = Ae - xe,
                Te = Se / 2,
                Me = Se / 180,
                Ce = 180 / Se;
              function ke(e) {
                return e > 0 ? 1 : e < 0 ? -1 : 0;
              }
              function Pe(e, t, n) {
                return (t[0] - e[0]) * (n[1] - e[1]) - (t[1] - e[1]) * (n[0] - e[0]);
              }
              function Oe(e) {
                return e > 1 ? 0 : e < -1 ? Se : Math.acos(e);
              }
              function Re(e) {
                return e > 1 ? Te : e < -1 ? -Te : Math.asin(e);
              }
              function Ie(e) {
                return ((e = Math.exp(e)) + 1 / e) / 2;
              }
              function je(e) {
                return (e = Math.sin(e / 2)) * e;
              }
              var Ne = Math.SQRT2;
              e.interpolateZoom = function (e, t) {
                var n,
                  r,
                  i = e[0],
                  o = e[1],
                  a = e[2],
                  s = t[0],
                  l = t[1],
                  u = t[2],
                  c = s - i,
                  d = l - o,
                  h = c * c + d * d;
                if (h < we) r = Math.log(u / a) / Ne, n = function n(e) {
                  return [i + e * c, o + e * d, a * Math.exp(Ne * e * r)];
                };else {
                  var f = Math.sqrt(h),
                    p = (u * u - a * a + 4 * h) / (2 * a * 2 * f),
                    m = (u * u - a * a - 4 * h) / (2 * u * 2 * f),
                    g = Math.log(Math.sqrt(p * p + 1) - p),
                    v = Math.log(Math.sqrt(m * m + 1) - m);
                  r = (v - g) / Ne, n = function n(e) {
                    var t,
                      n = e * r,
                      s = Ie(g),
                      l = a / (2 * f) * (s * (t = Ne * n + g, ((t = Math.exp(2 * t)) - 1) / (t + 1)) - function (e) {
                        return ((e = Math.exp(e)) - 1 / e) / 2;
                      }(g));
                    return [i + l * c, o + l * d, a * s / Ie(Ne * n + g)];
                  };
                }
                return n.duration = 1e3 * r, n;
              }, e.behavior.zoom = function () {
                var t,
                  n,
                  r,
                  o,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h = {
                    x: 0,
                    y: 0,
                    k: 1
                  },
                  f = [960, 500],
                  p = Be,
                  m = 250,
                  g = 0,
                  v = "mousedown.zoom",
                  y = "mousemove.zoom",
                  b = "mouseup.zoom",
                  _ = "touchstart.zoom",
                  x = B(w, "zoomstart", "zoom", "zoomend");
                function w(e) {
                  e.on(v, O).on(De + ".zoom", I).on("dblclick.zoom", j).on(_, R);
                }
                function S(e) {
                  return [(e[0] - h.x) / h.k, (e[1] - h.y) / h.k];
                }
                function A(e) {
                  h.k = Math.max(p[0], Math.min(p[1], e));
                }
                function E(e, t) {
                  t = function (e) {
                    return [e[0] * h.k + h.x, e[1] * h.k + h.y];
                  }(t), h.x += e[0] - t[0], h.y += e[1] - t[1];
                }
                function T(t, r, i, o) {
                  t.__chart__ = {
                    x: h.x,
                    y: h.y,
                    k: h.k
                  }, A(Math.pow(2, o)), E(n = r, i), t = e.select(t), m > 0 && (t = t.transition().duration(m)), t.call(w.event);
                }
                function M() {
                  u && u.domain(l.range().map(function (e) {
                    return (e - h.x) / h.k;
                  }).map(l.invert)), d && d.domain(c.range().map(function (e) {
                    return (e - h.y) / h.k;
                  }).map(c.invert));
                }
                function C(e) {
                  g++ || e({
                    type: "zoomstart"
                  });
                }
                function k(e) {
                  M(), e({
                    type: "zoom",
                    scale: h.k,
                    translate: [h.x, h.y]
                  });
                }
                function P(e) {
                  --g || (e({
                    type: "zoomend"
                  }), n = null);
                }
                function O() {
                  var t = this,
                    n = x.of(t, arguments),
                    r = 0,
                    i = e.select(a(t)).on(y, function () {
                      r = 1, E(e.mouse(t), o), k(n);
                    }).on(b, function () {
                      i.on(y, null).on(b, null), s(r), P(n);
                    }),
                    o = S(e.mouse(t)),
                    s = ve(t);
                  ls.call(t), C(n);
                }
                function R() {
                  var t,
                    n = this,
                    r = x.of(n, arguments),
                    i = {},
                    o = 0,
                    a = ".zoom-" + e.event.changedTouches[0].identifier,
                    l = "touchmove" + a,
                    u = "touchend" + a,
                    c = [],
                    d = e.select(n),
                    f = ve(n);
                  function p() {
                    var r = e.touches(n);
                    return t = h.k, r.forEach(function (e) {
                      e.identifier in i && (i[e.identifier] = S(e));
                    }), r;
                  }
                  function m() {
                    var t = e.event.target;
                    e.select(t).on(l, g).on(u, y), c.push(t);
                    for (var r = e.event.changedTouches, a = 0, d = r.length; a < d; ++a) i[r[a].identifier] = null;
                    var f = p(),
                      m = Date.now();
                    if (1 === f.length) {
                      if (m - s < 500) {
                        var v = f[0];
                        T(n, v, i[v.identifier], Math.floor(Math.log(h.k) / Math.LN2) + 1), L();
                      }
                      s = m;
                    } else if (f.length > 1) {
                      v = f[0];
                      var b = f[1],
                        _ = v[0] - b[0],
                        x = v[1] - b[1];
                      o = _ * _ + x * x;
                    }
                  }
                  function g() {
                    var a,
                      l,
                      u,
                      c,
                      d = e.touches(n);
                    ls.call(n);
                    for (var h = 0, f = d.length; h < f; ++h, c = null) if (u = d[h], c = i[u.identifier]) {
                      if (l) break;
                      a = u, l = c;
                    }
                    if (c) {
                      var p = (p = u[0] - a[0]) * p + (p = u[1] - a[1]) * p,
                        m = o && Math.sqrt(p / o);
                      a = [(a[0] + u[0]) / 2, (a[1] + u[1]) / 2], l = [(l[0] + c[0]) / 2, (l[1] + c[1]) / 2], A(m * t);
                    }
                    s = null, E(a, l), k(r);
                  }
                  function y() {
                    if (e.event.touches.length) {
                      for (var t = e.event.changedTouches, n = 0, o = t.length; n < o; ++n) delete i[t[n].identifier];
                      for (var s in i) return void p();
                    }
                    e.selectAll(c).on(a, null), d.on(v, O).on(_, R), f(), P(r);
                  }
                  m(), C(r), d.on(v, null).on(_, m);
                }
                function I() {
                  var i = x.of(this, arguments);
                  o ? clearTimeout(o) : (ls.call(this), t = S(n = r || e.mouse(this)), C(i)), o = setTimeout(function () {
                    o = null, P(i);
                  }, 50), L(), A(Math.pow(2, .002 * Le()) * h.k), E(n, t), k(i);
                }
                function j() {
                  var t = e.mouse(this),
                    n = Math.log(h.k) / Math.LN2;
                  T(this, t, S(t), e.event.shiftKey ? Math.ceil(n) - 1 : Math.floor(n) + 1);
                }
                return De || (De = "onwheel" in i ? (Le = function Le() {
                  return -e.event.deltaY * (e.event.deltaMode ? 120 : 1);
                }, "wheel") : "onmousewheel" in i ? (Le = function Le() {
                  return e.event.wheelDelta;
                }, "mousewheel") : (Le = function Le() {
                  return -e.event.detail;
                }, "MozMousePixelScroll")), w.event = function (t) {
                  t.each(function () {
                    var t = x.of(this, arguments),
                      r = h;
                    ds ? e.select(this).transition().each("start.zoom", function () {
                      h = this.__chart__ || {
                        x: 0,
                        y: 0,
                        k: 1
                      }, C(t);
                    }).tween("zoom:zoom", function () {
                      var i = f[0],
                        o = f[1],
                        a = n ? n[0] : i / 2,
                        s = n ? n[1] : o / 2,
                        l = e.interpolateZoom([(a - h.x) / h.k, (s - h.y) / h.k, i / h.k], [(a - r.x) / r.k, (s - r.y) / r.k, i / r.k]);
                      return function (e) {
                        var n = l(e),
                          r = i / n[2];
                        this.__chart__ = h = {
                          x: a - n[0] * r,
                          y: s - n[1] * r,
                          k: r
                        }, k(t);
                      };
                    }).each("interrupt.zoom", function () {
                      P(t);
                    }).each("end.zoom", function () {
                      P(t);
                    }) : (this.__chart__ = h, C(t), k(t), P(t));
                  });
                }, w.translate = function (e) {
                  return arguments.length ? (h = {
                    x: +e[0],
                    y: +e[1],
                    k: h.k
                  }, M(), w) : [h.x, h.y];
                }, w.scale = function (e) {
                  return arguments.length ? (h = {
                    x: h.x,
                    y: h.y,
                    k: null
                  }, A(+e), M(), w) : h.k;
                }, w.scaleExtent = function (e) {
                  return arguments.length ? (p = null == e ? Be : [+e[0], +e[1]], w) : p;
                }, w.center = function (e) {
                  return arguments.length ? (r = e && [+e[0], +e[1]], w) : r;
                }, w.size = function (e) {
                  return arguments.length ? (f = e && [+e[0], +e[1]], w) : f;
                }, w.duration = function (e) {
                  return arguments.length ? (m = +e, w) : m;
                }, w.x = function (e) {
                  return arguments.length ? (u = e, l = e.copy(), h = {
                    x: 0,
                    y: 0,
                    k: 1
                  }, w) : u;
                }, w.y = function (e) {
                  return arguments.length ? (d = e, c = e.copy(), h = {
                    x: 0,
                    y: 0,
                    k: 1
                  }, w) : d;
                }, e.rebind(w, x, "on");
              };
              var Le,
                De,
                Be = [0, 1 / 0];
              function Fe() {}
              function ze(e, t, n) {
                return this instanceof ze ? (this.h = +e, this.s = +t, void (this.l = +n)) : arguments.length < 2 ? e instanceof ze ? new ze(e.h, e.s, e.l) : ot("" + e, at, ze) : new ze(e, t, n);
              }
              e.color = Fe, Fe.prototype.toString = function () {
                return this.rgb() + "";
              }, e.hsl = ze;
              var Ue = ze.prototype = new Fe();
              function Ge(e, t, n) {
                var r, i;
                function o(e) {
                  return Math.round(255 * function (e) {
                    return e > 360 ? e -= 360 : e < 0 && (e += 360), e < 60 ? r + (i - r) * e / 60 : e < 180 ? i : e < 240 ? r + (i - r) * (240 - e) / 60 : r;
                  }(e));
                }
                return e = isNaN(e) ? 0 : (e %= 360) < 0 ? e + 360 : e, t = isNaN(t) || t < 0 ? 0 : t > 1 ? 1 : t, r = 2 * (n = n < 0 ? 0 : n > 1 ? 1 : n) - (i = n <= .5 ? n * (1 + t) : n + t - n * t), new et(o(e + 120), o(e), o(e - 120));
              }
              function Ve(t, n, r) {
                return this instanceof Ve ? (this.h = +t, this.c = +n, void (this.l = +r)) : arguments.length < 2 ? t instanceof Ve ? new Ve(t.h, t.c, t.l) : Ke(t instanceof We ? t.l : (t = st((t = e.rgb(t)).r, t.g, t.b)).l, t.a, t.b) : new Ve(t, n, r);
              }
              Ue.brighter = function (e) {
                return e = Math.pow(.7, arguments.length ? e : 1), new ze(this.h, this.s, this.l / e);
              }, Ue.darker = function (e) {
                return e = Math.pow(.7, arguments.length ? e : 1), new ze(this.h, this.s, e * this.l);
              }, Ue.rgb = function () {
                return Ge(this.h, this.s, this.l);
              }, e.hcl = Ve;
              var He = Ve.prototype = new Fe();
              function qe(e, t, n) {
                return isNaN(e) && (e = 0), isNaN(t) && (t = 0), new We(n, Math.cos(e *= Me) * t, Math.sin(e) * t);
              }
              function We(e, t, n) {
                return this instanceof We ? (this.l = +e, this.a = +t, void (this.b = +n)) : arguments.length < 2 ? e instanceof We ? new We(e.l, e.a, e.b) : e instanceof Ve ? qe(e.h, e.c, e.l) : st((e = et(e)).r, e.g, e.b) : new We(e, t, n);
              }
              He.brighter = function (e) {
                return new Ve(this.h, this.c, Math.min(100, this.l + $e * (arguments.length ? e : 1)));
              }, He.darker = function (e) {
                return new Ve(this.h, this.c, Math.max(0, this.l - $e * (arguments.length ? e : 1)));
              }, He.rgb = function () {
                return qe(this.h, this.c, this.l).rgb();
              }, e.lab = We;
              var $e = 18,
                Xe = We.prototype = new Fe();
              function Ye(e, t, n) {
                var r = (e + 16) / 116,
                  i = r + t / 500,
                  o = r - n / 200;
                return new et(Je(3.2404542 * (i = .95047 * Ze(i)) - 1.5371385 * (r = 1 * Ze(r)) - .4985314 * (o = 1.08883 * Ze(o))), Je(-.969266 * i + 1.8760108 * r + .041556 * o), Je(.0556434 * i - .2040259 * r + 1.0572252 * o));
              }
              function Ke(e, t, n) {
                return e > 0 ? new Ve(Math.atan2(n, t) * Ce, Math.sqrt(t * t + n * n), e) : new Ve(NaN, NaN, e);
              }
              function Ze(e) {
                return e > .206893034 ? e * e * e : (e - 4 / 29) / 7.787037;
              }
              function Qe(e) {
                return e > .008856 ? Math.pow(e, 1 / 3) : 7.787037 * e + 4 / 29;
              }
              function Je(e) {
                return Math.round(255 * (e <= .00304 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055));
              }
              function et(e, t, n) {
                return this instanceof et ? (this.r = ~~e, this.g = ~~t, void (this.b = ~~n)) : arguments.length < 2 ? e instanceof et ? new et(e.r, e.g, e.b) : ot("" + e, et, Ge) : new et(e, t, n);
              }
              function tt(e) {
                return new et(e >> 16, e >> 8 & 255, 255 & e);
              }
              function nt(e) {
                return tt(e) + "";
              }
              Xe.brighter = function (e) {
                return new We(Math.min(100, this.l + $e * (arguments.length ? e : 1)), this.a, this.b);
              }, Xe.darker = function (e) {
                return new We(Math.max(0, this.l - $e * (arguments.length ? e : 1)), this.a, this.b);
              }, Xe.rgb = function () {
                return Ye(this.l, this.a, this.b);
              }, e.rgb = et;
              var rt = et.prototype = new Fe();
              function it(e) {
                return e < 16 ? "0" + Math.max(0, e).toString(16) : Math.min(255, e).toString(16);
              }
              function ot(e, t, n) {
                var r,
                  i,
                  o,
                  a = 0,
                  s = 0,
                  l = 0;
                if (r = /([a-z]+)\((.*)\)/.exec(e = e.toLowerCase())) switch (i = r[2].split(","), r[1]) {
                  case "hsl":
                    return n(parseFloat(i[0]), parseFloat(i[1]) / 100, parseFloat(i[2]) / 100);
                  case "rgb":
                    return t(ut(i[0]), ut(i[1]), ut(i[2]));
                }
                return (o = ct.get(e)) ? t(o.r, o.g, o.b) : (null == e || "#" !== e.charAt(0) || isNaN(o = parseInt(e.slice(1), 16)) || (4 === e.length ? (a = (3840 & o) >> 4, a |= a >> 4, s = 240 & o, s |= s >> 4, l = 15 & o, l |= l << 4) : 7 === e.length && (a = (16711680 & o) >> 16, s = (65280 & o) >> 8, l = 255 & o)), t(a, s, l));
              }
              function at(e, t, n) {
                var r,
                  i,
                  o = Math.min(e /= 255, t /= 255, n /= 255),
                  a = Math.max(e, t, n),
                  s = a - o,
                  l = (a + o) / 2;
                return s ? (i = l < .5 ? s / (a + o) : s / (2 - a - o), r = e == a ? (t - n) / s + (t < n ? 6 : 0) : t == a ? (n - e) / s + 2 : (e - t) / s + 4, r *= 60) : (r = NaN, i = l > 0 && l < 1 ? 0 : r), new ze(r, i, l);
              }
              function st(e, t, n) {
                var r = Qe((.4124564 * (e = lt(e)) + .3575761 * (t = lt(t)) + .1804375 * (n = lt(n))) / .95047),
                  i = Qe((.2126729 * e + .7151522 * t + .072175 * n) / 1);
                return We(116 * i - 16, 500 * (r - i), 200 * (i - Qe((.0193339 * e + .119192 * t + .9503041 * n) / 1.08883)));
              }
              function lt(e) {
                return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
              }
              function ut(e) {
                var t = parseFloat(e);
                return "%" === e.charAt(e.length - 1) ? Math.round(2.55 * t) : t;
              }
              rt.brighter = function (e) {
                e = Math.pow(.7, arguments.length ? e : 1);
                var t = this.r,
                  n = this.g,
                  r = this.b,
                  i = 30;
                return t || n || r ? (t && t < i && (t = i), n && n < i && (n = i), r && r < i && (r = i), new et(Math.min(255, t / e), Math.min(255, n / e), Math.min(255, r / e))) : new et(i, i, i);
              }, rt.darker = function (e) {
                return new et((e = Math.pow(.7, arguments.length ? e : 1)) * this.r, e * this.g, e * this.b);
              }, rt.hsl = function () {
                return at(this.r, this.g, this.b);
              }, rt.toString = function () {
                return "#" + it(this.r) + it(this.g) + it(this.b);
              };
              var ct = e.map({
                aliceblue: 15792383,
                antiquewhite: 16444375,
                aqua: 65535,
                aquamarine: 8388564,
                azure: 15794175,
                beige: 16119260,
                bisque: 16770244,
                black: 0,
                blanchedalmond: 16772045,
                blue: 255,
                blueviolet: 9055202,
                brown: 10824234,
                burlywood: 14596231,
                cadetblue: 6266528,
                chartreuse: 8388352,
                chocolate: 13789470,
                coral: 16744272,
                cornflowerblue: 6591981,
                cornsilk: 16775388,
                crimson: 14423100,
                cyan: 65535,
                darkblue: 139,
                darkcyan: 35723,
                darkgoldenrod: 12092939,
                darkgray: 11119017,
                darkgreen: 25600,
                darkgrey: 11119017,
                darkkhaki: 12433259,
                darkmagenta: 9109643,
                darkolivegreen: 5597999,
                darkorange: 16747520,
                darkorchid: 10040012,
                darkred: 9109504,
                darksalmon: 15308410,
                darkseagreen: 9419919,
                darkslateblue: 4734347,
                darkslategray: 3100495,
                darkslategrey: 3100495,
                darkturquoise: 52945,
                darkviolet: 9699539,
                deeppink: 16716947,
                deepskyblue: 49151,
                dimgray: 6908265,
                dimgrey: 6908265,
                dodgerblue: 2003199,
                firebrick: 11674146,
                floralwhite: 16775920,
                forestgreen: 2263842,
                fuchsia: 16711935,
                gainsboro: 14474460,
                ghostwhite: 16316671,
                gold: 16766720,
                goldenrod: 14329120,
                gray: 8421504,
                green: 32768,
                greenyellow: 11403055,
                grey: 8421504,
                honeydew: 15794160,
                hotpink: 16738740,
                indianred: 13458524,
                indigo: 4915330,
                ivory: 16777200,
                khaki: 15787660,
                lavender: 15132410,
                lavenderblush: 16773365,
                lawngreen: 8190976,
                lemonchiffon: 16775885,
                lightblue: 11393254,
                lightcoral: 15761536,
                lightcyan: 14745599,
                lightgoldenrodyellow: 16448210,
                lightgray: 13882323,
                lightgreen: 9498256,
                lightgrey: 13882323,
                lightpink: 16758465,
                lightsalmon: 16752762,
                lightseagreen: 2142890,
                lightskyblue: 8900346,
                lightslategray: 7833753,
                lightslategrey: 7833753,
                lightsteelblue: 11584734,
                lightyellow: 16777184,
                lime: 65280,
                limegreen: 3329330,
                linen: 16445670,
                magenta: 16711935,
                maroon: 8388608,
                mediumaquamarine: 6737322,
                mediumblue: 205,
                mediumorchid: 12211667,
                mediumpurple: 9662683,
                mediumseagreen: 3978097,
                mediumslateblue: 8087790,
                mediumspringgreen: 64154,
                mediumturquoise: 4772300,
                mediumvioletred: 13047173,
                midnightblue: 1644912,
                mintcream: 16121850,
                mistyrose: 16770273,
                moccasin: 16770229,
                navajowhite: 16768685,
                navy: 128,
                oldlace: 16643558,
                olive: 8421376,
                olivedrab: 7048739,
                orange: 16753920,
                orangered: 16729344,
                orchid: 14315734,
                palegoldenrod: 15657130,
                palegreen: 10025880,
                paleturquoise: 11529966,
                palevioletred: 14381203,
                papayawhip: 16773077,
                peachpuff: 16767673,
                peru: 13468991,
                pink: 16761035,
                plum: 14524637,
                powderblue: 11591910,
                purple: 8388736,
                rebeccapurple: 6697881,
                red: 16711680,
                rosybrown: 12357519,
                royalblue: 4286945,
                saddlebrown: 9127187,
                salmon: 16416882,
                sandybrown: 16032864,
                seagreen: 3050327,
                seashell: 16774638,
                sienna: 10506797,
                silver: 12632256,
                skyblue: 8900331,
                slateblue: 6970061,
                slategray: 7372944,
                slategrey: 7372944,
                snow: 16775930,
                springgreen: 65407,
                steelblue: 4620980,
                tan: 13808780,
                teal: 32896,
                thistle: 14204888,
                tomato: 16737095,
                turquoise: 4251856,
                violet: 15631086,
                wheat: 16113331,
                white: 16777215,
                whitesmoke: 16119285,
                yellow: 16776960,
                yellowgreen: 10145074
              });
              function dt(e) {
                return "function" == typeof e ? e : function () {
                  return e;
                };
              }
              function ht(e) {
                return function (t, n, r) {
                  return 2 === arguments.length && "function" == typeof n && (r = n, n = null), ft(t, n, e, r);
                };
              }
              function ft(t, n, i, o) {
                var a = {},
                  s = e.dispatch("beforesend", "progress", "load", "error"),
                  l = {},
                  u = new XMLHttpRequest(),
                  c = null;
                function d() {
                  var e,
                    t = u.status;
                  if (!t && function (e) {
                    var t = e.responseType;
                    return t && "text" !== t ? e.response : e.responseText;
                  }(u) || t >= 200 && t < 300 || 304 === t) {
                    try {
                      e = i.call(a, u);
                    } catch (e) {
                      return void s.error.call(a, e);
                    }
                    s.load.call(a, e);
                  } else s.error.call(a, u);
                }
                return !this.XDomainRequest || "withCredentials" in u || !/^(http(s)?:)?\/\//.test(t) || (u = new XDomainRequest()), "onload" in u ? u.onload = u.onerror = d : u.onreadystatechange = function () {
                  u.readyState > 3 && d();
                }, u.onprogress = function (t) {
                  var n = e.event;
                  e.event = t;
                  try {
                    s.progress.call(a, u);
                  } finally {
                    e.event = n;
                  }
                }, a.header = function (e, t) {
                  return e = (e + "").toLowerCase(), arguments.length < 2 ? l[e] : (null == t ? delete l[e] : l[e] = t + "", a);
                }, a.mimeType = function (e) {
                  return arguments.length ? (n = null == e ? null : e + "", a) : n;
                }, a.responseType = function (e) {
                  return arguments.length ? (c = e, a) : c;
                }, a.response = function (e) {
                  return i = e, a;
                }, ["get", "post"].forEach(function (e) {
                  a[e] = function () {
                    return a.send.apply(a, [e].concat(r(arguments)));
                  };
                }), a.send = function (e, r, i) {
                  if (2 === arguments.length && "function" == typeof r && (i = r, r = null), u.open(e, t, !0), null == n || "accept" in l || (l.accept = n + ",*/*"), u.setRequestHeader) for (var o in l) u.setRequestHeader(o, l[o]);
                  return null != n && u.overrideMimeType && u.overrideMimeType(n), null != c && (u.responseType = c), null != i && a.on("error", i).on("load", function (e) {
                    i(null, e);
                  }), s.beforesend.call(a, u), u.send(null == r ? null : r), a;
                }, a.abort = function () {
                  return u.abort(), a;
                }, e.rebind(a, s, "on"), null == o ? a : a.get(function (e) {
                  return 1 === e.length ? function (t, n) {
                    e(null == t ? n : null);
                  } : e;
                }(o));
              }
              ct.forEach(function (e, t) {
                ct.set(e, tt(t));
              }), e.functor = dt, e.xhr = ht(k), e.dsv = function (e, t) {
                var n = new RegExp('["' + e + "\n]"),
                  r = e.charCodeAt(0);
                function i(e, n, r) {
                  arguments.length < 3 && (r = n, n = null);
                  var i = ft(e, t, null == n ? o : a(n), r);
                  return i.row = function (e) {
                    return arguments.length ? i.response(null == (n = e) ? o : a(e)) : n;
                  }, i;
                }
                function o(e) {
                  return i.parse(e.responseText);
                }
                function a(e) {
                  return function (t) {
                    return i.parse(t.responseText, e);
                  };
                }
                function s(t) {
                  return t.map(l).join(e);
                }
                function l(e) {
                  return n.test(e) ? '"' + e.replace(/\"/g, '""') + '"' : e;
                }
                return i.parse = function (e, t) {
                  var n;
                  return i.parseRows(e, function (e, r) {
                    if (n) return n(e, r - 1);
                    var i = new Function("d", "return {" + e.map(function (e, t) {
                      return JSON.stringify(e) + ": d[" + t + "]";
                    }).join(",") + "}");
                    n = t ? function (e, n) {
                      return t(i(e), n);
                    } : i;
                  });
                }, i.parseRows = function (e, t) {
                  var n,
                    i,
                    o = {},
                    a = {},
                    s = [],
                    l = e.length,
                    u = 0,
                    c = 0;
                  function d() {
                    if (u >= l) return a;
                    if (i) return i = !1, o;
                    var t = u;
                    if (34 === e.charCodeAt(t)) {
                      for (var n = t; n++ < l;) if (34 === e.charCodeAt(n)) {
                        if (34 !== e.charCodeAt(n + 1)) break;
                        ++n;
                      }
                      return u = n + 2, 13 === (s = e.charCodeAt(n + 1)) ? (i = !0, 10 === e.charCodeAt(n + 2) && ++u) : 10 === s && (i = !0), e.slice(t + 1, n).replace(/""/g, '"');
                    }
                    for (; u < l;) {
                      var s,
                        c = 1;
                      if (10 === (s = e.charCodeAt(u++))) i = !0;else if (13 === s) i = !0, 10 === e.charCodeAt(u) && (++u, ++c);else if (s !== r) continue;
                      return e.slice(t, u - c);
                    }
                    return e.slice(t);
                  }
                  for (; (n = d()) !== a;) {
                    for (var h = []; n !== o && n !== a;) h.push(n), n = d();
                    t && null == (h = t(h, c++)) || s.push(h);
                  }
                  return s;
                }, i.format = function (t) {
                  if (Array.isArray(t[0])) return i.formatRows(t);
                  var n = new C(),
                    r = [];
                  return t.forEach(function (e) {
                    for (var t in e) n.has(t) || r.push(n.add(t));
                  }), [r.map(l).join(e)].concat(t.map(function (t) {
                    return r.map(function (e) {
                      return l(t[e]);
                    }).join(e);
                  })).join("\n");
                }, i.formatRows = function (e) {
                  return e.map(s).join("\n");
                }, i;
              }, e.csv = e.dsv(",", "text/csv"), e.tsv = e.dsv("\t", "text/tab-separated-values");
              var pt,
                mt,
                gt,
                vt,
                yt = this[O(this, "requestAnimationFrame")] || function (e) {
                  setTimeout(e, 17);
                };
              function bt(e, t, n) {
                var r = arguments.length;
                r < 2 && (t = 0), r < 3 && (n = Date.now());
                var i = {
                  c: e,
                  t: n + t,
                  n: null
                };
                return mt ? mt.n = i : pt = i, mt = i, gt || (vt = clearTimeout(vt), gt = 1, yt(_t)), i;
              }
              function _t() {
                var e = xt(),
                  t = wt() - e;
                t > 24 ? (isFinite(t) && (clearTimeout(vt), vt = setTimeout(_t, t)), gt = 0) : (gt = 1, yt(_t));
              }
              function xt() {
                for (var e = Date.now(), t = pt; t;) e >= t.t && t.c(e - t.t) && (t.c = null), t = t.n;
                return e;
              }
              function wt() {
                for (var e, t = pt, n = 1 / 0; t;) t.c ? (t.t < n && (n = t.t), t = (e = t).n) : t = e ? e.n = t.n : pt = t.n;
                return mt = e, n;
              }
              function St(e, t) {
                return t - (e ? Math.ceil(Math.log(e) / Math.LN10) : 1);
              }
              e.timer = function () {
                bt.apply(this, arguments);
              }, e.timer.flush = function () {
                xt(), wt();
              }, e.round = function (e, t) {
                return t ? Math.round(e * (t = Math.pow(10, t))) / t : Math.round(e);
              };
              var At = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(function (e, t) {
                var n = Math.pow(10, 3 * y(8 - t));
                return {
                  scale: t > 8 ? function (e) {
                    return e / n;
                  } : function (e) {
                    return e * n;
                  },
                  symbol: e
                };
              });
              function Et(t) {
                var n = t.decimal,
                  r = t.thousands,
                  i = t.grouping,
                  o = t.currency,
                  a = i && r ? function (e, t) {
                    for (var n = e.length, o = [], a = 0, s = i[0], l = 0; n > 0 && s > 0 && (l + s + 1 > t && (s = Math.max(1, t - l)), o.push(e.substring(n -= s, n + s)), !((l += s + 1) > t));) s = i[a = (a + 1) % i.length];
                    return o.reverse().join(r);
                  } : k;
                return function (t) {
                  var r = Tt.exec(t),
                    i = r[1] || " ",
                    s = r[2] || ">",
                    l = r[3] || "-",
                    u = r[4] || "",
                    c = r[5],
                    d = +r[6],
                    h = r[7],
                    f = r[8],
                    p = r[9],
                    m = 1,
                    g = "",
                    v = "",
                    y = !1,
                    b = !0;
                  switch (f && (f = +f.substring(1)), (c || "0" === i && "=" === s) && (c = i = "0", s = "="), p) {
                    case "n":
                      h = !0, p = "g";
                      break;
                    case "%":
                      m = 100, v = "%", p = "f";
                      break;
                    case "p":
                      m = 100, v = "%", p = "r";
                      break;
                    case "b":
                    case "o":
                    case "x":
                    case "X":
                      "#" === u && (g = "0" + p.toLowerCase());
                    case "c":
                      b = !1;
                    case "d":
                      y = !0, f = 0;
                      break;
                    case "s":
                      m = -1, p = "r";
                  }
                  "$" === u && (g = o[0], v = o[1]), "r" != p || f || (p = "g"), null != f && ("g" == p ? f = Math.max(1, Math.min(21, f)) : "e" != p && "f" != p || (f = Math.max(0, Math.min(20, f)))), p = Mt.get(p) || Ct;
                  var _ = c && h;
                  return function (t) {
                    var r = v;
                    if (y && t % 1) return "";
                    var o = t < 0 || 0 === t && 1 / t < 0 ? (t = -t, "-") : "-" === l ? "" : l;
                    if (m < 0) {
                      var u = e.formatPrefix(t, f);
                      t = u.scale(t), r = u.symbol + v;
                    } else t *= m;
                    var x,
                      w,
                      S = (t = p(t, f)).lastIndexOf(".");
                    if (S < 0) {
                      var A = b ? t.lastIndexOf("e") : -1;
                      A < 0 ? (x = t, w = "") : (x = t.substring(0, A), w = t.substring(A));
                    } else x = t.substring(0, S), w = n + t.substring(S + 1);
                    !c && h && (x = a(x, 1 / 0));
                    var E = g.length + x.length + w.length + (_ ? 0 : o.length),
                      T = E < d ? new Array(E = d - E + 1).join(i) : "";
                    return _ && (x = a(T + x, T.length ? d - w.length : 1 / 0)), o += g, t = x + w, ("<" === s ? o + t + T : ">" === s ? T + o + t : "^" === s ? T.substring(0, E >>= 1) + o + t + T.substring(E) : o + (_ ? t : T + t)) + r;
                  };
                };
              }
              e.formatPrefix = function (t, n) {
                var r = 0;
                return (t = +t) && (t < 0 && (t *= -1), n && (t = e.round(t, St(t, n))), r = 1 + Math.floor(1e-12 + Math.log(t) / Math.LN10), r = Math.max(-24, Math.min(24, 3 * Math.floor((r - 1) / 3)))), At[8 + r / 3];
              };
              var Tt = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i,
                Mt = e.map({
                  b: function b(e) {
                    return e.toString(2);
                  },
                  c: function c(e) {
                    return String.fromCharCode(e);
                  },
                  o: function o(e) {
                    return e.toString(8);
                  },
                  x: function x(e) {
                    return e.toString(16);
                  },
                  X: function X(e) {
                    return e.toString(16).toUpperCase();
                  },
                  g: function g(e, t) {
                    return e.toPrecision(t);
                  },
                  e: function e(_e16, t) {
                    return _e16.toExponential(t);
                  },
                  f: function f(e, t) {
                    return e.toFixed(t);
                  },
                  r: function r(t, n) {
                    return (t = e.round(t, St(t, n))).toFixed(Math.max(0, Math.min(20, St(t * (1 + 1e-15), n))));
                  }
                });
              function Ct(e) {
                return e + "";
              }
              var kt = e.time = {},
                Pt = Date;
              function Ot() {
                this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
              }
              Ot.prototype = {
                getDate: function getDate() {
                  return this._.getUTCDate();
                },
                getDay: function getDay() {
                  return this._.getUTCDay();
                },
                getFullYear: function getFullYear() {
                  return this._.getUTCFullYear();
                },
                getHours: function getHours() {
                  return this._.getUTCHours();
                },
                getMilliseconds: function getMilliseconds() {
                  return this._.getUTCMilliseconds();
                },
                getMinutes: function getMinutes() {
                  return this._.getUTCMinutes();
                },
                getMonth: function getMonth() {
                  return this._.getUTCMonth();
                },
                getSeconds: function getSeconds() {
                  return this._.getUTCSeconds();
                },
                getTime: function getTime() {
                  return this._.getTime();
                },
                getTimezoneOffset: function getTimezoneOffset() {
                  return 0;
                },
                valueOf: function valueOf() {
                  return this._.valueOf();
                },
                setDate: function setDate() {
                  Rt.setUTCDate.apply(this._, arguments);
                },
                setDay: function setDay() {
                  Rt.setUTCDay.apply(this._, arguments);
                },
                setFullYear: function setFullYear() {
                  Rt.setUTCFullYear.apply(this._, arguments);
                },
                setHours: function setHours() {
                  Rt.setUTCHours.apply(this._, arguments);
                },
                setMilliseconds: function setMilliseconds() {
                  Rt.setUTCMilliseconds.apply(this._, arguments);
                },
                setMinutes: function setMinutes() {
                  Rt.setUTCMinutes.apply(this._, arguments);
                },
                setMonth: function setMonth() {
                  Rt.setUTCMonth.apply(this._, arguments);
                },
                setSeconds: function setSeconds() {
                  Rt.setUTCSeconds.apply(this._, arguments);
                },
                setTime: function setTime() {
                  Rt.setTime.apply(this._, arguments);
                }
              };
              var Rt = Date.prototype;
              function It(e, t, n) {
                function r(t) {
                  var n = e(t),
                    r = o(n, 1);
                  return t - n < r - t ? n : r;
                }
                function i(n) {
                  return t(n = e(new Pt(n - 1)), 1), n;
                }
                function o(e, n) {
                  return t(e = new Pt(+e), n), e;
                }
                function a(e, r, o) {
                  var a = i(e),
                    s = [];
                  if (o > 1) for (; a < r;) n(a) % o || s.push(new Date(+a)), t(a, 1);else for (; a < r;) s.push(new Date(+a)), t(a, 1);
                  return s;
                }
                e.floor = e, e.round = r, e.ceil = i, e.offset = o, e.range = a;
                var s = e.utc = jt(e);
                return s.floor = s, s.round = jt(r), s.ceil = jt(i), s.offset = jt(o), s.range = function (e, t, n) {
                  try {
                    Pt = Ot;
                    var r = new Ot();
                    return r._ = e, a(r, t, n);
                  } finally {
                    Pt = Date;
                  }
                }, e;
              }
              function jt(e) {
                return function (t, n) {
                  try {
                    Pt = Ot;
                    var r = new Ot();
                    return r._ = t, e(r, n)._;
                  } finally {
                    Pt = Date;
                  }
                };
              }
              function Nt(t) {
                var n = t.dateTime,
                  r = t.date,
                  i = t.time,
                  o = t.periods,
                  a = t.days,
                  s = t.shortDays,
                  l = t.months,
                  u = t.shortMonths;
                function c(e) {
                  var t = e.length;
                  function n(n) {
                    for (var r, i, o, a = [], s = -1, l = 0; ++s < t;) 37 === e.charCodeAt(s) && (a.push(e.slice(l, s)), null != (i = Lt[r = e.charAt(++s)]) && (r = e.charAt(++s)), (o = _x2[r]) && (r = o(n, null == i ? "e" === r ? " " : "0" : i)), a.push(r), l = s + 1);
                    return a.push(e.slice(l, s)), a.join("");
                  }
                  return n.parse = function (t) {
                    var n = {
                      y: 1900,
                      m: 0,
                      d: 1,
                      H: 0,
                      M: 0,
                      S: 0,
                      L: 0,
                      Z: null
                    };
                    if (d(n, e, t, 0) != t.length) return null;
                    "p" in n && (n.H = n.H % 12 + 12 * n.p);
                    var r = null != n.Z && Pt !== Ot,
                      i = new (r ? Ot : Pt)();
                    return "j" in n ? i.setFullYear(n.y, 0, n.j) : "W" in n || "U" in n ? ("w" in n || (n.w = "W" in n ? 1 : 0), i.setFullYear(n.y, 0, 1), i.setFullYear(n.y, 0, "W" in n ? (n.w + 6) % 7 + 7 * n.W - (i.getDay() + 5) % 7 : n.w + 7 * n.U - (i.getDay() + 6) % 7)) : i.setFullYear(n.y, n.m, n.d), i.setHours(n.H + (n.Z / 100 | 0), n.M + n.Z % 100, n.S, n.L), r ? i._ : i;
                  }, n.toString = function () {
                    return e;
                  }, n;
                }
                function d(e, t, n, r) {
                  for (var i, o, a, s = 0, l = t.length, u = n.length; s < l;) {
                    if (r >= u) return -1;
                    if (37 === (i = t.charCodeAt(s++))) {
                      if (a = t.charAt(s++), !(o = w[a in Lt ? t.charAt(s++) : a]) || (r = o(e, n, r)) < 0) return -1;
                    } else if (i != n.charCodeAt(r++)) return -1;
                  }
                  return r;
                }
                c.utc = function (e) {
                  var t = c(e);
                  function n(e) {
                    try {
                      var n = new (Pt = Ot)();
                      return n._ = e, t(n);
                    } finally {
                      Pt = Date;
                    }
                  }
                  return n.parse = function (e) {
                    try {
                      Pt = Ot;
                      var n = t.parse(e);
                      return n && n._;
                    } finally {
                      Pt = Date;
                    }
                  }, n.toString = t.toString, n;
                }, c.multi = c.utc.multi = rn;
                var h = e.map(),
                  f = zt(a),
                  p = Ut(a),
                  m = zt(s),
                  g = Ut(s),
                  v = zt(l),
                  y = Ut(l),
                  _b2 = zt(u),
                  _ = Ut(u);
                o.forEach(function (e, t) {
                  h.set(e.toLowerCase(), t);
                });
                var _x2 = {
                    a: function a(e) {
                      return s[e.getDay()];
                    },
                    A: function A(e) {
                      return a[e.getDay()];
                    },
                    b: function b(e) {
                      return u[e.getMonth()];
                    },
                    B: function B(e) {
                      return l[e.getMonth()];
                    },
                    c: c(n),
                    d: function d(e, t) {
                      return Ft(e.getDate(), t, 2);
                    },
                    e: function e(_e17, t) {
                      return Ft(_e17.getDate(), t, 2);
                    },
                    H: function H(e, t) {
                      return Ft(e.getHours(), t, 2);
                    },
                    I: function I(e, t) {
                      return Ft(e.getHours() % 12 || 12, t, 2);
                    },
                    j: function j(e, t) {
                      return Ft(1 + kt.dayOfYear(e), t, 3);
                    },
                    L: function L(e, t) {
                      return Ft(e.getMilliseconds(), t, 3);
                    },
                    m: function m(e, t) {
                      return Ft(e.getMonth() + 1, t, 2);
                    },
                    M: function M(e, t) {
                      return Ft(e.getMinutes(), t, 2);
                    },
                    p: function p(e) {
                      return o[+(e.getHours() >= 12)];
                    },
                    S: function S(e, t) {
                      return Ft(e.getSeconds(), t, 2);
                    },
                    U: function U(e, t) {
                      return Ft(kt.sundayOfYear(e), t, 2);
                    },
                    w: function w(e) {
                      return e.getDay();
                    },
                    W: function W(e, t) {
                      return Ft(kt.mondayOfYear(e), t, 2);
                    },
                    x: c(r),
                    X: c(i),
                    y: function y(e, t) {
                      return Ft(e.getFullYear() % 100, t, 2);
                    },
                    Y: function Y(e, t) {
                      return Ft(e.getFullYear() % 1e4, t, 4);
                    },
                    Z: tn,
                    "%": function _() {
                      return "%";
                    }
                  },
                  w = {
                    a: function a(e, t, n) {
                      m.lastIndex = 0;
                      var r = m.exec(t.slice(n));
                      return r ? (e.w = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
                    },
                    A: function A(e, t, n) {
                      f.lastIndex = 0;
                      var r = f.exec(t.slice(n));
                      return r ? (e.w = p.get(r[0].toLowerCase()), n + r[0].length) : -1;
                    },
                    b: function b(e, t, n) {
                      _b2.lastIndex = 0;
                      var r = _b2.exec(t.slice(n));
                      return r ? (e.m = _.get(r[0].toLowerCase()), n + r[0].length) : -1;
                    },
                    B: function B(e, t, n) {
                      v.lastIndex = 0;
                      var r = v.exec(t.slice(n));
                      return r ? (e.m = y.get(r[0].toLowerCase()), n + r[0].length) : -1;
                    },
                    c: function c(e, t, n) {
                      return d(e, _x2.c.toString(), t, n);
                    },
                    d: Yt,
                    e: Yt,
                    H: Zt,
                    I: Zt,
                    j: Kt,
                    L: en,
                    m: Xt,
                    M: Qt,
                    p: function p(e, t, n) {
                      var r = h.get(t.slice(n, n += 2).toLowerCase());
                      return null == r ? -1 : (e.p = r, n);
                    },
                    S: Jt,
                    U: Vt,
                    w: Gt,
                    W: Ht,
                    x: function x(e, t, n) {
                      return d(e, _x2.x.toString(), t, n);
                    },
                    X: function X(e, t, n) {
                      return d(e, _x2.X.toString(), t, n);
                    },
                    y: Wt,
                    Y: qt,
                    Z: $t,
                    "%": nn
                  };
                return c;
              }
              kt.year = It(function (e) {
                return (e = kt.day(e)).setMonth(0, 1), e;
              }, function (e, t) {
                e.setFullYear(e.getFullYear() + t);
              }, function (e) {
                return e.getFullYear();
              }), kt.years = kt.year.range, kt.years.utc = kt.year.utc.range, kt.day = It(function (e) {
                var t = new Pt(2e3, 0);
                return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t;
              }, function (e, t) {
                e.setDate(e.getDate() + t);
              }, function (e) {
                return e.getDate() - 1;
              }), kt.days = kt.day.range, kt.days.utc = kt.day.utc.range, kt.dayOfYear = function (e) {
                var t = kt.year(e);
                return Math.floor((e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 864e5);
              }, ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function (e, t) {
                t = 7 - t;
                var n = kt[e] = It(function (e) {
                  return (e = kt.day(e)).setDate(e.getDate() - (e.getDay() + t) % 7), e;
                }, function (e, t) {
                  e.setDate(e.getDate() + 7 * Math.floor(t));
                }, function (e) {
                  var n = kt.year(e).getDay();
                  return Math.floor((kt.dayOfYear(e) + (n + t) % 7) / 7) - (n !== t);
                });
                kt[e + "s"] = n.range, kt[e + "s"].utc = n.utc.range, kt[e + "OfYear"] = function (e) {
                  var n = kt.year(e).getDay();
                  return Math.floor((kt.dayOfYear(e) + (n + t) % 7) / 7);
                };
              }), kt.week = kt.sunday, kt.weeks = kt.sunday.range, kt.weeks.utc = kt.sunday.utc.range, kt.weekOfYear = kt.sundayOfYear;
              var Lt = {
                  "-": "",
                  _: " ",
                  0: "0"
                },
                Dt = /^\s*\d+/,
                Bt = /^%/;
              function Ft(e, t, n) {
                var r = e < 0 ? "-" : "",
                  i = (r ? -e : e) + "",
                  o = i.length;
                return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
              }
              function zt(t) {
                return new RegExp("^(?:" + t.map(e.requote).join("|") + ")", "i");
              }
              function Ut(e) {
                for (var t = new _(), n = -1, r = e.length; ++n < r;) t.set(e[n].toLowerCase(), n);
                return t;
              }
              function Gt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 1));
                return r ? (e.w = +r[0], n + r[0].length) : -1;
              }
              function Vt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n));
                return r ? (e.U = +r[0], n + r[0].length) : -1;
              }
              function Ht(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n));
                return r ? (e.W = +r[0], n + r[0].length) : -1;
              }
              function qt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 4));
                return r ? (e.y = +r[0], n + r[0].length) : -1;
              }
              function Wt(e, t, n) {
                Dt.lastIndex = 0;
                var r,
                  i = Dt.exec(t.slice(n, n + 2));
                return i ? (e.y = (r = +i[0]) + (r > 68 ? 1900 : 2e3), n + i[0].length) : -1;
              }
              function $t(e, t, n) {
                return /^[+-]\d{4}$/.test(t = t.slice(n, n + 5)) ? (e.Z = -t, n + 5) : -1;
              }
              function Xt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 2));
                return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
              }
              function Yt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 2));
                return r ? (e.d = +r[0], n + r[0].length) : -1;
              }
              function Kt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 3));
                return r ? (e.j = +r[0], n + r[0].length) : -1;
              }
              function Zt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 2));
                return r ? (e.H = +r[0], n + r[0].length) : -1;
              }
              function Qt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 2));
                return r ? (e.M = +r[0], n + r[0].length) : -1;
              }
              function Jt(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 2));
                return r ? (e.S = +r[0], n + r[0].length) : -1;
              }
              function en(e, t, n) {
                Dt.lastIndex = 0;
                var r = Dt.exec(t.slice(n, n + 3));
                return r ? (e.L = +r[0], n + r[0].length) : -1;
              }
              function tn(e) {
                var t = e.getTimezoneOffset(),
                  n = t > 0 ? "-" : "+",
                  r = y(t) / 60 | 0,
                  i = y(t) % 60;
                return n + Ft(r, "0", 2) + Ft(i, "0", 2);
              }
              function nn(e, t, n) {
                Bt.lastIndex = 0;
                var r = Bt.exec(t.slice(n, n + 1));
                return r ? n + r[0].length : -1;
              }
              function rn(e) {
                for (var t = e.length, n = -1; ++n < t;) e[n][0] = this(e[n][0]);
                return function (t) {
                  for (var n = 0, r = e[n]; !r[1](t);) r = e[++n];
                  return r[0](t);
                };
              }
              e.locale = function (e) {
                return {
                  numberFormat: Et(e),
                  timeFormat: Nt(e)
                };
              };
              var on = e.locale({
                decimal: ".",
                thousands: ",",
                grouping: [3],
                currency: ["$", ""],
                dateTime: "%a %b %e %X %Y",
                date: "%m/%d/%Y",
                time: "%H:%M:%S",
                periods: ["AM", "PM"],
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
              });
              function an() {}
              e.format = on.numberFormat, e.geo = {}, an.prototype = {
                s: 0,
                t: 0,
                add: function add(e) {
                  ln(e, this.t, sn), ln(sn.s, this.s, this), this.s ? this.t += sn.t : this.s = sn.t;
                },
                reset: function reset() {
                  this.s = this.t = 0;
                },
                valueOf: function valueOf() {
                  return this.s;
                }
              };
              var sn = new an();
              function ln(e, t, n) {
                var r = n.s = e + t,
                  i = r - e,
                  o = r - i;
                n.t = e - o + (t - i);
              }
              function un(e, t) {
                e && dn.hasOwnProperty(e.type) && dn[e.type](e, t);
              }
              e.geo.stream = function (e, t) {
                e && cn.hasOwnProperty(e.type) ? cn[e.type](e, t) : un(e, t);
              };
              var cn = {
                  Feature: function Feature(e, t) {
                    un(e.geometry, t);
                  },
                  FeatureCollection: function FeatureCollection(e, t) {
                    for (var n = e.features, r = -1, i = n.length; ++r < i;) un(n[r].geometry, t);
                  }
                },
                dn = {
                  Sphere: function Sphere(e, t) {
                    t.sphere();
                  },
                  Point: function Point(e, t) {
                    e = e.coordinates, t.point(e[0], e[1], e[2]);
                  },
                  MultiPoint: function MultiPoint(e, t) {
                    for (var n = e.coordinates, r = -1, i = n.length; ++r < i;) e = n[r], t.point(e[0], e[1], e[2]);
                  },
                  LineString: function LineString(e, t) {
                    hn(e.coordinates, t, 0);
                  },
                  MultiLineString: function MultiLineString(e, t) {
                    for (var n = e.coordinates, r = -1, i = n.length; ++r < i;) hn(n[r], t, 0);
                  },
                  Polygon: function Polygon(e, t) {
                    fn(e.coordinates, t);
                  },
                  MultiPolygon: function MultiPolygon(e, t) {
                    for (var n = e.coordinates, r = -1, i = n.length; ++r < i;) fn(n[r], t);
                  },
                  GeometryCollection: function GeometryCollection(e, t) {
                    for (var n = e.geometries, r = -1, i = n.length; ++r < i;) un(n[r], t);
                  }
                };
              function hn(e, t, n) {
                var r,
                  i = -1,
                  o = e.length - n;
                for (t.lineStart(); ++i < o;) r = e[i], t.point(r[0], r[1], r[2]);
                t.lineEnd();
              }
              function fn(e, t) {
                var n = -1,
                  r = e.length;
                for (t.polygonStart(); ++n < r;) hn(e[n], t, 1);
                t.polygonEnd();
              }
              e.geo.area = function (t) {
                return pn = 0, e.geo.stream(t, Mn), pn;
              };
              var pn,
                mn,
                gn,
                vn,
                yn,
                bn,
                _n,
                xn,
                wn,
                Sn,
                An,
                En,
                Tn = new an(),
                Mn = {
                  sphere: function sphere() {
                    pn += 4 * Se;
                  },
                  point: I,
                  lineStart: I,
                  lineEnd: I,
                  polygonStart: function polygonStart() {
                    Tn.reset(), Mn.lineStart = Cn;
                  },
                  polygonEnd: function polygonEnd() {
                    var e = 2 * Tn;
                    pn += e < 0 ? 4 * Se + e : e, Mn.lineStart = Mn.lineEnd = Mn.point = I;
                  }
                };
              function Cn() {
                var e, t, n, r, i;
                function o(e, t) {
                  t = t * Me / 2 + Se / 4;
                  var o = (e *= Me) - n,
                    a = o >= 0 ? 1 : -1,
                    s = a * o,
                    l = Math.cos(t),
                    u = Math.sin(t),
                    c = i * u,
                    d = r * l + c * Math.cos(s),
                    h = c * a * Math.sin(s);
                  Tn.add(Math.atan2(h, d)), n = e, r = l, i = u;
                }
                Mn.point = function (a, s) {
                  Mn.point = o, n = (e = a) * Me, r = Math.cos(s = (t = s) * Me / 2 + Se / 4), i = Math.sin(s);
                }, Mn.lineEnd = function () {
                  o(e, t);
                };
              }
              function kn(e) {
                var t = e[0],
                  n = e[1],
                  r = Math.cos(n);
                return [r * Math.cos(t), r * Math.sin(t), Math.sin(n)];
              }
              function Pn(e, t) {
                return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
              }
              function On(e, t) {
                return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
              }
              function Rn(e, t) {
                e[0] += t[0], e[1] += t[1], e[2] += t[2];
              }
              function In(e, t) {
                return [e[0] * t, e[1] * t, e[2] * t];
              }
              function jn(e) {
                var t = Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
                e[0] /= t, e[1] /= t, e[2] /= t;
              }
              function Nn(e) {
                return [Math.atan2(e[1], e[0]), Re(e[2])];
              }
              function Ln(e, t) {
                return y(e[0] - t[0]) < xe && y(e[1] - t[1]) < xe;
              }
              e.geo.bounds = function () {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h = {
                    point: f,
                    lineStart: m,
                    lineEnd: g,
                    polygonStart: function polygonStart() {
                      h.point = v, h.lineStart = b, h.lineEnd = _, u = 0, Mn.polygonStart();
                    },
                    polygonEnd: function polygonEnd() {
                      Mn.polygonEnd(), h.point = f, h.lineStart = m, h.lineEnd = g, Tn < 0 ? (t = -(r = 180), n = -(i = 90)) : u > xe ? i = 90 : u < -xe && (n = -90), d[0] = t, d[1] = r;
                    }
                  };
                function f(e, o) {
                  c.push(d = [t = e, r = e]), o < n && (n = o), o > i && (i = o);
                }
                function p(e, a) {
                  var s = kn([e * Me, a * Me]);
                  if (l) {
                    var u = On(l, s),
                      c = On([u[1], -u[0], 0], u);
                    jn(c), c = Nn(c);
                    var d = e - o,
                      h = d > 0 ? 1 : -1,
                      p = c[0] * Ce * h,
                      m = y(d) > 180;
                    if (m ^ (h * o < p && p < h * e)) (g = c[1] * Ce) > i && (i = g);else if (m ^ (h * o < (p = (p + 360) % 360 - 180) && p < h * e)) {
                      var g;
                      (g = -c[1] * Ce) < n && (n = g);
                    } else a < n && (n = a), a > i && (i = a);
                    m ? e < o ? x(t, e) > x(t, r) && (r = e) : x(e, r) > x(t, r) && (t = e) : r >= t ? (e < t && (t = e), e > r && (r = e)) : e > o ? x(t, e) > x(t, r) && (r = e) : x(e, r) > x(t, r) && (t = e);
                  } else f(e, a);
                  l = s, o = e;
                }
                function m() {
                  h.point = p;
                }
                function g() {
                  d[0] = t, d[1] = r, h.point = f, l = null;
                }
                function v(e, t) {
                  if (l) {
                    var n = e - o;
                    u += y(n) > 180 ? n + (n > 0 ? 360 : -360) : n;
                  } else a = e, s = t;
                  Mn.point(e, t), p(e, t);
                }
                function b() {
                  Mn.lineStart();
                }
                function _() {
                  v(a, s), Mn.lineEnd(), y(u) > xe && (t = -(r = 180)), d[0] = t, d[1] = r, l = null;
                }
                function x(e, t) {
                  return (t -= e) < 0 ? t + 360 : t;
                }
                function w(e, t) {
                  return e[0] - t[0];
                }
                function S(e, t) {
                  return t[0] <= t[1] ? t[0] <= e && e <= t[1] : e < t[0] || t[1] < e;
                }
                return function (o) {
                  if (i = r = -(t = n = 1 / 0), c = [], e.geo.stream(o, h), u = c.length) {
                    c.sort(w);
                    for (var a = 1, s = [m = c[0]]; a < u; ++a) S((f = c[a])[0], m) || S(f[1], m) ? (x(m[0], f[1]) > x(m[0], m[1]) && (m[1] = f[1]), x(f[0], m[1]) > x(m[0], m[1]) && (m[0] = f[0])) : s.push(m = f);
                    for (var l, u, f, p = -1 / 0, m = (a = 0, s[u = s.length - 1]); a <= u; m = f, ++a) f = s[a], (l = x(m[1], f[0])) > p && (p = l, t = f[0], r = m[1]);
                  }
                  return c = d = null, t === 1 / 0 || n === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[t, n], [r, i]];
                };
              }(), e.geo.centroid = function (t) {
                mn = gn = vn = yn = bn = _n = xn = wn = Sn = An = En = 0, e.geo.stream(t, Dn);
                var n = Sn,
                  r = An,
                  i = En,
                  o = n * n + r * r + i * i;
                return o < we && (n = _n, r = xn, i = wn, gn < xe && (n = vn, r = yn, i = bn), (o = n * n + r * r + i * i) < we) ? [NaN, NaN] : [Math.atan2(r, n) * Ce, Re(i / Math.sqrt(o)) * Ce];
              };
              var Dn = {
                sphere: I,
                point: Bn,
                lineStart: zn,
                lineEnd: Un,
                polygonStart: function polygonStart() {
                  Dn.lineStart = Gn;
                },
                polygonEnd: function polygonEnd() {
                  Dn.lineStart = zn;
                }
              };
              function Bn(e, t) {
                e *= Me;
                var n = Math.cos(t *= Me);
                Fn(n * Math.cos(e), n * Math.sin(e), Math.sin(t));
              }
              function Fn(e, t, n) {
                vn += (e - vn) / ++mn, yn += (t - yn) / mn, bn += (n - bn) / mn;
              }
              function zn() {
                var e, t, n;
                function r(r, i) {
                  r *= Me;
                  var o = Math.cos(i *= Me),
                    a = o * Math.cos(r),
                    s = o * Math.sin(r),
                    l = Math.sin(i),
                    u = Math.atan2(Math.sqrt((u = t * l - n * s) * u + (u = n * a - e * l) * u + (u = e * s - t * a) * u), e * a + t * s + n * l);
                  gn += u, _n += u * (e + (e = a)), xn += u * (t + (t = s)), wn += u * (n + (n = l)), Fn(e, t, n);
                }
                Dn.point = function (i, o) {
                  i *= Me;
                  var a = Math.cos(o *= Me);
                  e = a * Math.cos(i), t = a * Math.sin(i), n = Math.sin(o), Dn.point = r, Fn(e, t, n);
                };
              }
              function Un() {
                Dn.point = Bn;
              }
              function Gn() {
                var e, t, n, r, i;
                function o(e, t) {
                  e *= Me;
                  var o = Math.cos(t *= Me),
                    a = o * Math.cos(e),
                    s = o * Math.sin(e),
                    l = Math.sin(t),
                    u = r * l - i * s,
                    c = i * a - n * l,
                    d = n * s - r * a,
                    h = Math.sqrt(u * u + c * c + d * d),
                    f = n * a + r * s + i * l,
                    p = h && -Oe(f) / h,
                    m = Math.atan2(h, f);
                  Sn += p * u, An += p * c, En += p * d, gn += m, _n += m * (n + (n = a)), xn += m * (r + (r = s)), wn += m * (i + (i = l)), Fn(n, r, i);
                }
                Dn.point = function (a, s) {
                  e = a, t = s, Dn.point = o, a *= Me;
                  var l = Math.cos(s *= Me);
                  n = l * Math.cos(a), r = l * Math.sin(a), i = Math.sin(s), Fn(n, r, i);
                }, Dn.lineEnd = function () {
                  o(e, t), Dn.lineEnd = Un, Dn.point = Bn;
                };
              }
              function Vn(e, t) {
                function n(n, r) {
                  return n = e(n, r), t(n[0], n[1]);
                }
                return e.invert && t.invert && (n.invert = function (n, r) {
                  return (n = t.invert(n, r)) && e.invert(n[0], n[1]);
                }), n;
              }
              function Hn() {
                return !0;
              }
              function qn(e, t, n, r, i) {
                var o = [],
                  a = [];
                if (e.forEach(function (e) {
                  if (!((t = e.length - 1) <= 0)) {
                    var t,
                      n = e[0],
                      r = e[t];
                    if (Ln(n, r)) {
                      i.lineStart();
                      for (var s = 0; s < t; ++s) i.point((n = e[s])[0], n[1]);
                      i.lineEnd();
                    } else {
                      var l = new $n(n, e, null, !0),
                        u = new $n(n, null, l, !1);
                      l.o = u, o.push(l), a.push(u), l = new $n(r, e, null, !1), u = new $n(r, null, l, !0), l.o = u, o.push(l), a.push(u);
                    }
                  }
                }), a.sort(t), Wn(o), Wn(a), o.length) {
                  for (var s = 0, l = n, u = a.length; s < u; ++s) a[s].e = l = !l;
                  for (var c, d, h = o[0];;) {
                    for (var f = h, p = !0; f.v;) if ((f = f.n) === h) return;
                    c = f.z, i.lineStart();
                    do {
                      if (f.v = f.o.v = !0, f.e) {
                        if (p) for (s = 0, u = c.length; s < u; ++s) i.point((d = c[s])[0], d[1]);else r(f.x, f.n.x, 1, i);
                        f = f.n;
                      } else {
                        if (p) for (s = (c = f.p.z).length - 1; s >= 0; --s) i.point((d = c[s])[0], d[1]);else r(f.x, f.p.x, -1, i);
                        f = f.p;
                      }
                      c = (f = f.o).z, p = !p;
                    } while (!f.v);
                    i.lineEnd();
                  }
                }
              }
              function Wn(e) {
                if (t = e.length) {
                  for (var t, n, r = 0, i = e[0]; ++r < t;) i.n = n = e[r], n.p = i, i = n;
                  i.n = n = e[0], n.p = i;
                }
              }
              function $n(e, t, n, r) {
                this.x = e, this.z = t, this.o = n, this.e = r, this.v = !1, this.n = this.p = null;
              }
              function Xn(t, n, r, i) {
                return function (o, a) {
                  var s,
                    l = n(a),
                    u = o.invert(i[0], i[1]),
                    c = {
                      point: d,
                      lineStart: f,
                      lineEnd: p,
                      polygonStart: function polygonStart() {
                        c.point = _, c.lineStart = x, c.lineEnd = w, s = [], m = [];
                      },
                      polygonEnd: function polygonEnd() {
                        c.point = d, c.lineStart = f, c.lineEnd = p, s = e.merge(s);
                        var t = function (e, t) {
                          var n = e[0],
                            r = e[1],
                            i = [Math.sin(n), -Math.cos(n), 0],
                            o = 0,
                            a = 0;
                          Tn.reset();
                          for (var s = 0, l = t.length; s < l; ++s) {
                            var u = t[s],
                              c = u.length;
                            if (c) for (var d = u[0], h = d[0], f = d[1] / 2 + Se / 4, p = Math.sin(f), m = Math.cos(f), g = 1;;) {
                              g === c && (g = 0);
                              var v = (e = u[g])[0],
                                y = e[1] / 2 + Se / 4,
                                b = Math.sin(y),
                                _ = Math.cos(y),
                                x = v - h,
                                w = x >= 0 ? 1 : -1,
                                S = w * x,
                                A = S > Se,
                                E = p * b;
                              if (Tn.add(Math.atan2(E * w * Math.sin(S), m * _ + E * Math.cos(S))), o += A ? x + w * Ae : x, A ^ h >= n ^ v >= n) {
                                var T = On(kn(d), kn(e));
                                jn(T);
                                var M = On(i, T);
                                jn(M);
                                var C = (A ^ x >= 0 ? -1 : 1) * Re(M[2]);
                                (r > C || r === C && (T[0] || T[1])) && (a += A ^ x >= 0 ? 1 : -1);
                              }
                              if (!g++) break;
                              h = v, p = b, m = _, d = e;
                            }
                          }
                          return (o < -xe || o < xe && Tn < -xe) ^ 1 & a;
                        }(u, m);
                        s.length ? (b || (a.polygonStart(), b = !0), qn(s, Zn, t, r, a)) : t && (b || (a.polygonStart(), b = !0), a.lineStart(), r(null, null, 1, a), a.lineEnd()), b && (a.polygonEnd(), b = !1), s = m = null;
                      },
                      sphere: function sphere() {
                        a.polygonStart(), a.lineStart(), r(null, null, 1, a), a.lineEnd(), a.polygonEnd();
                      }
                    };
                  function d(e, n) {
                    var r = o(e, n);
                    t(e = r[0], n = r[1]) && a.point(e, n);
                  }
                  function h(e, t) {
                    var n = o(e, t);
                    l.point(n[0], n[1]);
                  }
                  function f() {
                    c.point = h, l.lineStart();
                  }
                  function p() {
                    c.point = d, l.lineEnd();
                  }
                  var m,
                    g,
                    v = Kn(),
                    y = n(v),
                    b = !1;
                  function _(e, t) {
                    g.push([e, t]);
                    var n = o(e, t);
                    y.point(n[0], n[1]);
                  }
                  function x() {
                    y.lineStart(), g = [];
                  }
                  function w() {
                    _(g[0][0], g[0][1]), y.lineEnd();
                    var e,
                      t = y.clean(),
                      n = v.buffer(),
                      r = n.length;
                    if (g.pop(), m.push(g), g = null, r) if (1 & t) {
                      var i,
                        o = -1;
                      if ((r = (e = n[0]).length - 1) > 0) {
                        for (b || (a.polygonStart(), b = !0), a.lineStart(); ++o < r;) a.point((i = e[o])[0], i[1]);
                        a.lineEnd();
                      }
                    } else r > 1 && 2 & t && n.push(n.pop().concat(n.shift())), s.push(n.filter(Yn));
                  }
                  return c;
                };
              }
              function Yn(e) {
                return e.length > 1;
              }
              function Kn() {
                var e,
                  t = [];
                return {
                  lineStart: function lineStart() {
                    t.push(e = []);
                  },
                  point: function point(t, n) {
                    e.push([t, n]);
                  },
                  lineEnd: I,
                  buffer: function buffer() {
                    var n = t;
                    return t = [], e = null, n;
                  },
                  rejoin: function rejoin() {
                    t.length > 1 && t.push(t.pop().concat(t.shift()));
                  }
                };
              }
              function Zn(e, t) {
                return ((e = e.x)[0] < 0 ? e[1] - Te - xe : Te - e[1]) - ((t = t.x)[0] < 0 ? t[1] - Te - xe : Te - t[1]);
              }
              var Qn = Xn(Hn, function (e) {
                var t,
                  n = NaN,
                  r = NaN,
                  i = NaN;
                return {
                  lineStart: function lineStart() {
                    e.lineStart(), t = 1;
                  },
                  point: function point(o, a) {
                    var s = o > 0 ? Se : -Se,
                      l = y(o - n);
                    y(l - Se) < xe ? (e.point(n, r = (r + a) / 2 > 0 ? Te : -Te), e.point(i, r), e.lineEnd(), e.lineStart(), e.point(s, r), e.point(o, r), t = 0) : i !== s && l >= Se && (y(n - i) < xe && (n -= i * xe), y(o - s) < xe && (o -= s * xe), r = function (e, t, n, r) {
                      var i,
                        o,
                        a = Math.sin(e - n);
                      return y(a) > xe ? Math.atan((Math.sin(t) * (o = Math.cos(r)) * Math.sin(n) - Math.sin(r) * (i = Math.cos(t)) * Math.sin(e)) / (i * o * a)) : (t + r) / 2;
                    }(n, r, o, a), e.point(i, r), e.lineEnd(), e.lineStart(), e.point(s, r), t = 0), e.point(n = o, r = a), i = s;
                  },
                  lineEnd: function lineEnd() {
                    e.lineEnd(), n = r = NaN;
                  },
                  clean: function clean() {
                    return 2 - t;
                  }
                };
              }, function (e, t, n, r) {
                var i;
                if (null == e) i = n * Te, r.point(-Se, i), r.point(0, i), r.point(Se, i), r.point(Se, 0), r.point(Se, -i), r.point(0, -i), r.point(-Se, -i), r.point(-Se, 0), r.point(-Se, i);else if (y(e[0] - t[0]) > xe) {
                  var o = e[0] < t[0] ? Se : -Se;
                  i = n * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
                } else r.point(t[0], t[1]);
              }, [-Se, -Se / 2]);
              function Jn(e, t, n, r) {
                return function (i) {
                  var o,
                    a = i.a,
                    s = i.b,
                    l = a.x,
                    u = a.y,
                    c = 0,
                    d = 1,
                    h = s.x - l,
                    f = s.y - u;
                  if (o = e - l, h || !(o > 0)) {
                    if (o /= h, h < 0) {
                      if (o < c) return;
                      o < d && (d = o);
                    } else if (h > 0) {
                      if (o > d) return;
                      o > c && (c = o);
                    }
                    if (o = n - l, h || !(o < 0)) {
                      if (o /= h, h < 0) {
                        if (o > d) return;
                        o > c && (c = o);
                      } else if (h > 0) {
                        if (o < c) return;
                        o < d && (d = o);
                      }
                      if (o = t - u, f || !(o > 0)) {
                        if (o /= f, f < 0) {
                          if (o < c) return;
                          o < d && (d = o);
                        } else if (f > 0) {
                          if (o > d) return;
                          o > c && (c = o);
                        }
                        if (o = r - u, f || !(o < 0)) {
                          if (o /= f, f < 0) {
                            if (o > d) return;
                            o > c && (c = o);
                          } else if (f > 0) {
                            if (o < c) return;
                            o < d && (d = o);
                          }
                          return c > 0 && (i.a = {
                            x: l + c * h,
                            y: u + c * f
                          }), d < 1 && (i.b = {
                            x: l + d * h,
                            y: u + d * f
                          }), i;
                        }
                      }
                    }
                  }
                };
              }
              var er = 1e9;
              function tr(t, n, r, i) {
                return function (l) {
                  var u,
                    c,
                    d,
                    h,
                    f,
                    p,
                    m,
                    g,
                    v,
                    y,
                    b,
                    _ = l,
                    x = Kn(),
                    w = Jn(t, n, r, i),
                    S = {
                      point: T,
                      lineStart: function lineStart() {
                        S.point = M, c && c.push(d = []), y = !0, v = !1, m = g = NaN;
                      },
                      lineEnd: function lineEnd() {
                        u && (M(h, f), p && v && x.rejoin(), u.push(x.buffer())), S.point = T, v && l.lineEnd();
                      },
                      polygonStart: function polygonStart() {
                        l = x, u = [], c = [], b = !0;
                      },
                      polygonEnd: function polygonEnd() {
                        l = _, u = e.merge(u);
                        var n = function (e) {
                            for (var t = 0, n = c.length, r = e[1], i = 0; i < n; ++i) for (var o, a = 1, s = c[i], l = s.length, u = s[0]; a < l; ++a) o = s[a], u[1] <= r ? o[1] > r && Pe(u, o, e) > 0 && ++t : o[1] <= r && Pe(u, o, e) < 0 && --t, u = o;
                            return 0 !== t;
                          }([t, i]),
                          r = b && n,
                          o = u.length;
                        (r || o) && (l.polygonStart(), r && (l.lineStart(), A(null, null, 1, l), l.lineEnd()), o && qn(u, a, n, A, l), l.polygonEnd()), u = c = d = null;
                      }
                    };
                  function A(e, a, l, u) {
                    var c = 0,
                      d = 0;
                    if (null == e || (c = o(e, l)) !== (d = o(a, l)) || s(e, a) < 0 ^ l > 0) do {
                      u.point(0 === c || 3 === c ? t : r, c > 1 ? i : n);
                    } while ((c = (c + l + 4) % 4) !== d);else u.point(a[0], a[1]);
                  }
                  function E(e, o) {
                    return t <= e && e <= r && n <= o && o <= i;
                  }
                  function T(e, t) {
                    E(e, t) && l.point(e, t);
                  }
                  function M(e, t) {
                    var n = E(e = Math.max(-er, Math.min(er, e)), t = Math.max(-er, Math.min(er, t)));
                    if (c && d.push([e, t]), y) h = e, f = t, p = n, y = !1, n && (l.lineStart(), l.point(e, t));else if (n && v) l.point(e, t);else {
                      var r = {
                        a: {
                          x: m,
                          y: g
                        },
                        b: {
                          x: e,
                          y: t
                        }
                      };
                      w(r) ? (v || (l.lineStart(), l.point(r.a.x, r.a.y)), l.point(r.b.x, r.b.y), n || l.lineEnd(), b = !1) : n && (l.lineStart(), l.point(e, t), b = !1);
                    }
                    m = e, g = t, v = n;
                  }
                  return S;
                };
                function o(e, i) {
                  return y(e[0] - t) < xe ? i > 0 ? 0 : 3 : y(e[0] - r) < xe ? i > 0 ? 2 : 1 : y(e[1] - n) < xe ? i > 0 ? 1 : 0 : i > 0 ? 3 : 2;
                }
                function a(e, t) {
                  return s(e.x, t.x);
                }
                function s(e, t) {
                  var n = o(e, 1),
                    r = o(t, 1);
                  return n !== r ? n - r : 0 === n ? t[1] - e[1] : 1 === n ? e[0] - t[0] : 2 === n ? e[1] - t[1] : t[0] - e[0];
                }
              }
              function nr(e) {
                var t = 0,
                  n = Se / 3,
                  r = Tr(e),
                  i = r(t, n);
                return i.parallels = function (e) {
                  return arguments.length ? r(t = e[0] * Se / 180, n = e[1] * Se / 180) : [t / Se * 180, n / Se * 180];
                }, i;
              }
              function rr(e, t) {
                var n = Math.sin(e),
                  r = (n + Math.sin(t)) / 2,
                  i = 1 + n * (2 * r - n),
                  o = Math.sqrt(i) / r;
                function a(e, t) {
                  var n = Math.sqrt(i - 2 * r * Math.sin(t)) / r;
                  return [n * Math.sin(e *= r), o - n * Math.cos(e)];
                }
                return a.invert = function (e, t) {
                  var n = o - t;
                  return [Math.atan2(e, n) / r, Re((i - (e * e + n * n) * r * r) / (2 * r))];
                }, a;
              }
              e.geo.clipExtent = function () {
                var e,
                  t,
                  n,
                  r,
                  i,
                  o,
                  a = {
                    stream: function stream(e) {
                      return i && (i.valid = !1), (i = o(e)).valid = !0, i;
                    },
                    extent: function extent(s) {
                      return arguments.length ? (o = tr(e = +s[0][0], t = +s[0][1], n = +s[1][0], r = +s[1][1]), i && (i.valid = !1, i = null), a) : [[e, t], [n, r]];
                    }
                  };
                return a.extent([[0, 0], [960, 500]]);
              }, (e.geo.conicEqualArea = function () {
                return nr(rr);
              }).raw = rr, e.geo.albers = function () {
                return e.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070);
              }, e.geo.albersUsa = function () {
                var t,
                  n,
                  r,
                  i,
                  o = e.geo.albers(),
                  a = e.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
                  s = e.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
                  l = {
                    point: function point(e, n) {
                      t = [e, n];
                    }
                  };
                function u(e) {
                  var o = e[0],
                    a = e[1];
                  return t = null, n(o, a), t || (r(o, a), t) || i(o, a), t;
                }
                return u.invert = function (e) {
                  var t = o.scale(),
                    n = o.translate(),
                    r = (e[0] - n[0]) / t,
                    i = (e[1] - n[1]) / t;
                  return (i >= .12 && i < .234 && r >= -.425 && r < -.214 ? a : i >= .166 && i < .234 && r >= -.214 && r < -.115 ? s : o).invert(e);
                }, u.stream = function (e) {
                  var t = o.stream(e),
                    n = a.stream(e),
                    r = s.stream(e);
                  return {
                    point: function point(e, i) {
                      t.point(e, i), n.point(e, i), r.point(e, i);
                    },
                    sphere: function sphere() {
                      t.sphere(), n.sphere(), r.sphere();
                    },
                    lineStart: function lineStart() {
                      t.lineStart(), n.lineStart(), r.lineStart();
                    },
                    lineEnd: function lineEnd() {
                      t.lineEnd(), n.lineEnd(), r.lineEnd();
                    },
                    polygonStart: function polygonStart() {
                      t.polygonStart(), n.polygonStart(), r.polygonStart();
                    },
                    polygonEnd: function polygonEnd() {
                      t.polygonEnd(), n.polygonEnd(), r.polygonEnd();
                    }
                  };
                }, u.precision = function (e) {
                  return arguments.length ? (o.precision(e), a.precision(e), s.precision(e), u) : o.precision();
                }, u.scale = function (e) {
                  return arguments.length ? (o.scale(e), a.scale(.35 * e), s.scale(e), u.translate(o.translate())) : o.scale();
                }, u.translate = function (e) {
                  if (!arguments.length) return o.translate();
                  var t = o.scale(),
                    c = +e[0],
                    d = +e[1];
                  return n = o.translate(e).clipExtent([[c - .455 * t, d - .238 * t], [c + .455 * t, d + .238 * t]]).stream(l).point, r = a.translate([c - .307 * t, d + .201 * t]).clipExtent([[c - .425 * t + xe, d + .12 * t + xe], [c - .214 * t - xe, d + .234 * t - xe]]).stream(l).point, i = s.translate([c - .205 * t, d + .212 * t]).clipExtent([[c - .214 * t + xe, d + .166 * t + xe], [c - .115 * t - xe, d + .234 * t - xe]]).stream(l).point, u;
                }, u.scale(1070);
              };
              var ir,
                or,
                ar,
                sr,
                lr,
                ur,
                cr = {
                  point: I,
                  lineStart: I,
                  lineEnd: I,
                  polygonStart: function polygonStart() {
                    or = 0, cr.lineStart = dr;
                  },
                  polygonEnd: function polygonEnd() {
                    cr.lineStart = cr.lineEnd = cr.point = I, ir += y(or / 2);
                  }
                };
              function dr() {
                var e, t, n, r;
                function i(e, t) {
                  or += r * e - n * t, n = e, r = t;
                }
                cr.point = function (o, a) {
                  cr.point = i, e = n = o, t = r = a;
                }, cr.lineEnd = function () {
                  i(e, t);
                };
              }
              var hr = {
                point: function point(e, t) {
                  e < ar && (ar = e), e > lr && (lr = e), t < sr && (sr = t), t > ur && (ur = t);
                },
                lineStart: I,
                lineEnd: I,
                polygonStart: I,
                polygonEnd: I
              };
              function fr() {
                var e = pr(4.5),
                  t = [],
                  n = {
                    point: r,
                    lineStart: function lineStart() {
                      n.point = i;
                    },
                    lineEnd: a,
                    polygonStart: function polygonStart() {
                      n.lineEnd = s;
                    },
                    polygonEnd: function polygonEnd() {
                      n.lineEnd = a, n.point = r;
                    },
                    pointRadius: function pointRadius(t) {
                      return e = pr(t), n;
                    },
                    result: function result() {
                      if (t.length) {
                        var e = t.join("");
                        return t = [], e;
                      }
                    }
                  };
                function r(n, r) {
                  t.push("M", n, ",", r, e);
                }
                function i(e, r) {
                  t.push("M", e, ",", r), n.point = o;
                }
                function o(e, n) {
                  t.push("L", e, ",", n);
                }
                function a() {
                  n.point = r;
                }
                function s() {
                  t.push("Z");
                }
                return n;
              }
              function pr(e) {
                return "m0," + e + "a" + e + "," + e + " 0 1,1 0," + -2 * e + "a" + e + "," + e + " 0 1,1 0," + 2 * e + "z";
              }
              var mr,
                gr = {
                  point: vr,
                  lineStart: yr,
                  lineEnd: br,
                  polygonStart: function polygonStart() {
                    gr.lineStart = _r;
                  },
                  polygonEnd: function polygonEnd() {
                    gr.point = vr, gr.lineStart = yr, gr.lineEnd = br;
                  }
                };
              function vr(e, t) {
                vn += e, yn += t, ++bn;
              }
              function yr() {
                var e, t;
                function n(n, r) {
                  var i = n - e,
                    o = r - t,
                    a = Math.sqrt(i * i + o * o);
                  _n += a * (e + n) / 2, xn += a * (t + r) / 2, wn += a, vr(e = n, t = r);
                }
                gr.point = function (r, i) {
                  gr.point = n, vr(e = r, t = i);
                };
              }
              function br() {
                gr.point = vr;
              }
              function _r() {
                var e, t, n, r;
                function i(e, t) {
                  var i = e - n,
                    o = t - r,
                    a = Math.sqrt(i * i + o * o);
                  _n += a * (n + e) / 2, xn += a * (r + t) / 2, wn += a, Sn += (a = r * e - n * t) * (n + e), An += a * (r + t), En += 3 * a, vr(n = e, r = t);
                }
                gr.point = function (o, a) {
                  gr.point = i, vr(e = n = o, t = r = a);
                }, gr.lineEnd = function () {
                  i(e, t);
                };
              }
              function xr(e) {
                var t = 4.5,
                  n = {
                    point: r,
                    lineStart: function lineStart() {
                      n.point = i;
                    },
                    lineEnd: a,
                    polygonStart: function polygonStart() {
                      n.lineEnd = s;
                    },
                    polygonEnd: function polygonEnd() {
                      n.lineEnd = a, n.point = r;
                    },
                    pointRadius: function pointRadius(e) {
                      return t = e, n;
                    },
                    result: I
                  };
                function r(n, r) {
                  e.moveTo(n + t, r), e.arc(n, r, t, 0, Ae);
                }
                function i(t, r) {
                  e.moveTo(t, r), n.point = o;
                }
                function o(t, n) {
                  e.lineTo(t, n);
                }
                function a() {
                  n.point = r;
                }
                function s() {
                  e.closePath();
                }
                return n;
              }
              function wr(e) {
                var t = .5,
                  n = Math.cos(30 * Me),
                  r = 16;
                function i(t) {
                  return (r ? function (t) {
                    var n,
                      i,
                      a,
                      s,
                      l,
                      u,
                      c,
                      d,
                      h,
                      f,
                      p,
                      m,
                      g = {
                        point: v,
                        lineStart: y,
                        lineEnd: _,
                        polygonStart: function polygonStart() {
                          t.polygonStart(), g.lineStart = x;
                        },
                        polygonEnd: function polygonEnd() {
                          t.polygonEnd(), g.lineStart = y;
                        }
                      };
                    function v(n, r) {
                      n = e(n, r), t.point(n[0], n[1]);
                    }
                    function y() {
                      d = NaN, g.point = b, t.lineStart();
                    }
                    function b(n, i) {
                      var a = kn([n, i]),
                        s = e(n, i);
                      o(d, h, c, f, p, m, d = s[0], h = s[1], c = n, f = a[0], p = a[1], m = a[2], r, t), t.point(d, h);
                    }
                    function _() {
                      g.point = v, t.lineEnd();
                    }
                    function x() {
                      y(), g.point = w, g.lineEnd = S;
                    }
                    function w(e, t) {
                      b(n = e, t), i = d, a = h, s = f, l = p, u = m, g.point = b;
                    }
                    function S() {
                      o(d, h, c, f, p, m, i, a, n, s, l, u, r, t), g.lineEnd = _, _();
                    }
                    return g;
                  } : function (t) {
                    return Ar(t, function (n, r) {
                      n = e(n, r), t.point(n[0], n[1]);
                    });
                  })(t);
                }
                function o(r, i, a, s, l, u, c, d, h, f, p, m, g, v) {
                  var b = c - r,
                    _ = d - i,
                    x = b * b + _ * _;
                  if (x > 4 * t && g--) {
                    var w = s + f,
                      S = l + p,
                      A = u + m,
                      E = Math.sqrt(w * w + S * S + A * A),
                      T = Math.asin(A /= E),
                      M = y(y(A) - 1) < xe || y(a - h) < xe ? (a + h) / 2 : Math.atan2(S, w),
                      C = e(M, T),
                      k = C[0],
                      P = C[1],
                      O = k - r,
                      R = P - i,
                      I = _ * O - b * R;
                    (I * I / x > t || y((b * O + _ * R) / x - .5) > .3 || s * f + l * p + u * m < n) && (o(r, i, a, s, l, u, k, P, M, w /= E, S /= E, A, g, v), v.point(k, P), o(k, P, M, w, S, A, c, d, h, f, p, m, g, v));
                  }
                }
                return i.precision = function (e) {
                  return arguments.length ? (r = (t = e * e) > 0 && 16, i) : Math.sqrt(t);
                }, i;
              }
              function Sr(e) {
                this.stream = e;
              }
              function Ar(e, t) {
                return {
                  point: t,
                  sphere: function sphere() {
                    e.sphere();
                  },
                  lineStart: function lineStart() {
                    e.lineStart();
                  },
                  lineEnd: function lineEnd() {
                    e.lineEnd();
                  },
                  polygonStart: function polygonStart() {
                    e.polygonStart();
                  },
                  polygonEnd: function polygonEnd() {
                    e.polygonEnd();
                  }
                };
              }
              function Er(e) {
                return Tr(function () {
                  return e;
                })();
              }
              function Tr(t) {
                var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l = wr(function (e, t) {
                    return [(e = n(e, t))[0] * u + o, a - e[1] * u];
                  }),
                  u = 150,
                  c = 480,
                  d = 250,
                  h = 0,
                  f = 0,
                  p = 0,
                  m = 0,
                  g = 0,
                  v = Qn,
                  b = k,
                  _ = null,
                  x = null;
                function w(e) {
                  return [(e = i(e[0] * Me, e[1] * Me))[0] * u + o, a - e[1] * u];
                }
                function S(e) {
                  return (e = i.invert((e[0] - o) / u, (a - e[1]) / u)) && [e[0] * Ce, e[1] * Ce];
                }
                function A() {
                  i = Vn(r = Pr(p, m, g), n);
                  var e = n(h, f);
                  return o = c - e[0] * u, a = d + e[1] * u, E();
                }
                function E() {
                  return s && (s.valid = !1, s = null), w;
                }
                return w.stream = function (e) {
                  return s && (s.valid = !1), (s = Mr(v(r, l(b(e))))).valid = !0, s;
                }, w.clipAngle = function (e) {
                  return arguments.length ? (v = null == e ? (_ = e, Qn) : function (e) {
                    var t = Math.cos(e),
                      n = t > 0,
                      r = y(t) > xe;
                    return Xn(i, function (e) {
                      var t, s, l, u, c;
                      return {
                        lineStart: function lineStart() {
                          u = l = !1, c = 1;
                        },
                        point: function point(d, h) {
                          var f,
                            p = [d, h],
                            m = i(d, h),
                            g = n ? m ? 0 : a(d, h) : m ? a(d + (d < 0 ? Se : -Se), h) : 0;
                          if (!t && (u = l = m) && e.lineStart(), m !== l && (f = o(t, p), (Ln(t, f) || Ln(p, f)) && (p[0] += xe, p[1] += xe, m = i(p[0], p[1]))), m !== l) c = 0, m ? (e.lineStart(), f = o(p, t), e.point(f[0], f[1])) : (f = o(t, p), e.point(f[0], f[1]), e.lineEnd()), t = f;else if (r && t && n ^ m) {
                            var v;
                            g & s || !(v = o(p, t, !0)) || (c = 0, n ? (e.lineStart(), e.point(v[0][0], v[0][1]), e.point(v[1][0], v[1][1]), e.lineEnd()) : (e.point(v[1][0], v[1][1]), e.lineEnd(), e.lineStart(), e.point(v[0][0], v[0][1])));
                          }
                          !m || t && Ln(t, p) || e.point(p[0], p[1]), t = p, l = m, s = g;
                        },
                        lineEnd: function lineEnd() {
                          l && e.lineEnd(), t = null;
                        },
                        clean: function clean() {
                          return c | (u && l) << 1;
                        }
                      };
                    }, jr(e, 6 * Me), n ? [0, -e] : [-Se, e - Se]);
                    function i(e, n) {
                      return Math.cos(e) * Math.cos(n) > t;
                    }
                    function o(e, n, r) {
                      var i = [1, 0, 0],
                        o = On(kn(e), kn(n)),
                        a = Pn(o, o),
                        s = o[0],
                        l = a - s * s;
                      if (!l) return !r && e;
                      var u = t * a / l,
                        c = -t * s / l,
                        d = On(i, o),
                        h = In(i, u);
                      Rn(h, In(o, c));
                      var f = d,
                        p = Pn(h, f),
                        m = Pn(f, f),
                        g = p * p - m * (Pn(h, h) - 1);
                      if (!(g < 0)) {
                        var v = Math.sqrt(g),
                          b = In(f, (-p - v) / m);
                        if (Rn(b, h), b = Nn(b), !r) return b;
                        var _,
                          x = e[0],
                          w = n[0],
                          S = e[1],
                          A = n[1];
                        w < x && (_ = x, x = w, w = _);
                        var E = w - x,
                          T = y(E - Se) < xe;
                        if (!T && A < S && (_ = S, S = A, A = _), T || E < xe ? T ? S + A > 0 ^ b[1] < (y(b[0] - x) < xe ? S : A) : S <= b[1] && b[1] <= A : E > Se ^ (x <= b[0] && b[0] <= w)) {
                          var M = In(f, (-p + v) / m);
                          return Rn(M, h), [b, Nn(M)];
                        }
                      }
                    }
                    function a(t, r) {
                      var i = n ? e : Se - e,
                        o = 0;
                      return t < -i ? o |= 1 : t > i && (o |= 2), r < -i ? o |= 4 : r > i && (o |= 8), o;
                    }
                  }((_ = +e) * Me), E()) : _;
                }, w.clipExtent = function (e) {
                  return arguments.length ? (x = e, b = e ? tr(e[0][0], e[0][1], e[1][0], e[1][1]) : k, E()) : x;
                }, w.scale = function (e) {
                  return arguments.length ? (u = +e, A()) : u;
                }, w.translate = function (e) {
                  return arguments.length ? (c = +e[0], d = +e[1], A()) : [c, d];
                }, w.center = function (e) {
                  return arguments.length ? (h = e[0] % 360 * Me, f = e[1] % 360 * Me, A()) : [h * Ce, f * Ce];
                }, w.rotate = function (e) {
                  return arguments.length ? (p = e[0] % 360 * Me, m = e[1] % 360 * Me, g = e.length > 2 ? e[2] % 360 * Me : 0, A()) : [p * Ce, m * Ce, g * Ce];
                }, e.rebind(w, l, "precision"), function () {
                  return n = t.apply(this, arguments), w.invert = n.invert && S, A();
                };
              }
              function Mr(e) {
                return Ar(e, function (t, n) {
                  e.point(t * Me, n * Me);
                });
              }
              function Cr(e, t) {
                return [e, t];
              }
              function kr(e, t) {
                return [e > Se ? e - Ae : e < -Se ? e + Ae : e, t];
              }
              function Pr(e, t, n) {
                return e ? t || n ? Vn(Rr(e), Ir(t, n)) : Rr(e) : t || n ? Ir(t, n) : kr;
              }
              function Or(e) {
                return function (t, n) {
                  return [(t += e) > Se ? t - Ae : t < -Se ? t + Ae : t, n];
                };
              }
              function Rr(e) {
                var t = Or(e);
                return t.invert = Or(-e), t;
              }
              function Ir(e, t) {
                var n = Math.cos(e),
                  r = Math.sin(e),
                  i = Math.cos(t),
                  o = Math.sin(t);
                function a(e, t) {
                  var a = Math.cos(t),
                    s = Math.cos(e) * a,
                    l = Math.sin(e) * a,
                    u = Math.sin(t),
                    c = u * n + s * r;
                  return [Math.atan2(l * i - c * o, s * n - u * r), Re(c * i + l * o)];
                }
                return a.invert = function (e, t) {
                  var a = Math.cos(t),
                    s = Math.cos(e) * a,
                    l = Math.sin(e) * a,
                    u = Math.sin(t),
                    c = u * i - l * o;
                  return [Math.atan2(l * i + u * o, s * n + c * r), Re(c * n - s * r)];
                }, a;
              }
              function jr(e, t) {
                var n = Math.cos(e),
                  r = Math.sin(e);
                return function (i, o, a, s) {
                  var l = a * t;
                  null != i ? (i = Nr(n, i), o = Nr(n, o), (a > 0 ? i < o : i > o) && (i += a * Ae)) : (i = e + a * Ae, o = e - .5 * l);
                  for (var u, c = i; a > 0 ? c > o : c < o; c -= l) s.point((u = Nn([n, -r * Math.cos(c), -r * Math.sin(c)]))[0], u[1]);
                };
              }
              function Nr(e, t) {
                var n = kn(t);
                n[0] -= e, jn(n);
                var r = Oe(-n[1]);
                return ((-n[2] < 0 ? -r : r) + 2 * Math.PI - xe) % (2 * Math.PI);
              }
              function Lr(t, n, r) {
                var i = e.range(t, n - xe, r).concat(n);
                return function (e) {
                  return i.map(function (t) {
                    return [e, t];
                  });
                };
              }
              function Dr(t, n, r) {
                var i = e.range(t, n - xe, r).concat(n);
                return function (e) {
                  return i.map(function (t) {
                    return [t, e];
                  });
                };
              }
              function Br(e) {
                return e.source;
              }
              function Fr(e) {
                return e.target;
              }
              e.geo.path = function () {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a = 4.5;
                function s(t) {
                  return t && ("function" == typeof a && i.pointRadius(+a.apply(this, arguments)), o && o.valid || (o = r(i)), e.geo.stream(t, o)), i.result();
                }
                function l() {
                  return o = null, s;
                }
                return s.area = function (t) {
                  return ir = 0, e.geo.stream(t, r(cr)), ir;
                }, s.centroid = function (t) {
                  return vn = yn = bn = _n = xn = wn = Sn = An = En = 0, e.geo.stream(t, r(gr)), En ? [Sn / En, An / En] : wn ? [_n / wn, xn / wn] : bn ? [vn / bn, yn / bn] : [NaN, NaN];
                }, s.bounds = function (t) {
                  return lr = ur = -(ar = sr = 1 / 0), e.geo.stream(t, r(hr)), [[ar, sr], [lr, ur]];
                }, s.projection = function (e) {
                  return arguments.length ? (r = (t = e) ? e.stream || (n = e, i = wr(function (e, t) {
                    return n([e * Ce, t * Ce]);
                  }), function (e) {
                    return Mr(i(e));
                  }) : k, l()) : t;
                  var n, i;
                }, s.context = function (e) {
                  return arguments.length ? (i = null == (n = e) ? new fr() : new xr(e), "function" != typeof a && i.pointRadius(a), l()) : n;
                }, s.pointRadius = function (e) {
                  return arguments.length ? (a = "function" == typeof e ? e : (i.pointRadius(+e), +e), s) : a;
                }, s.projection(e.geo.albersUsa()).context(null);
              }, e.geo.transform = function (e) {
                return {
                  stream: function stream(t) {
                    var n = new Sr(t);
                    for (var r in e) n[r] = e[r];
                    return n;
                  }
                };
              }, Sr.prototype = {
                point: function point(e, t) {
                  this.stream.point(e, t);
                },
                sphere: function sphere() {
                  this.stream.sphere();
                },
                lineStart: function lineStart() {
                  this.stream.lineStart();
                },
                lineEnd: function lineEnd() {
                  this.stream.lineEnd();
                },
                polygonStart: function polygonStart() {
                  this.stream.polygonStart();
                },
                polygonEnd: function polygonEnd() {
                  this.stream.polygonEnd();
                }
              }, e.geo.projection = Er, e.geo.projectionMutator = Tr, (e.geo.equirectangular = function () {
                return Er(Cr);
              }).raw = Cr.invert = Cr, e.geo.rotation = function (e) {
                function t(t) {
                  return (t = e(t[0] * Me, t[1] * Me))[0] *= Ce, t[1] *= Ce, t;
                }
                return e = Pr(e[0] % 360 * Me, e[1] * Me, e.length > 2 ? e[2] * Me : 0), t.invert = function (t) {
                  return (t = e.invert(t[0] * Me, t[1] * Me))[0] *= Ce, t[1] *= Ce, t;
                }, t;
              }, kr.invert = Cr, e.geo.circle = function () {
                var e,
                  t,
                  n = [0, 0],
                  r = 6;
                function i() {
                  var e = "function" == typeof n ? n.apply(this, arguments) : n,
                    r = Pr(-e[0] * Me, -e[1] * Me, 0).invert,
                    i = [];
                  return t(null, null, 1, {
                    point: function point(e, t) {
                      i.push(e = r(e, t)), e[0] *= Ce, e[1] *= Ce;
                    }
                  }), {
                    type: "Polygon",
                    coordinates: [i]
                  };
                }
                return i.origin = function (e) {
                  return arguments.length ? (n = e, i) : n;
                }, i.angle = function (n) {
                  return arguments.length ? (t = jr((e = +n) * Me, r * Me), i) : e;
                }, i.precision = function (n) {
                  return arguments.length ? (t = jr(e * Me, (r = +n) * Me), i) : r;
                }, i.angle(90);
              }, e.geo.distance = function (e, t) {
                var n,
                  r = (t[0] - e[0]) * Me,
                  i = e[1] * Me,
                  o = t[1] * Me,
                  a = Math.sin(r),
                  s = Math.cos(r),
                  l = Math.sin(i),
                  u = Math.cos(i),
                  c = Math.sin(o),
                  d = Math.cos(o);
                return Math.atan2(Math.sqrt((n = d * a) * n + (n = u * c - l * d * s) * n), l * c + u * d * s);
              }, e.geo.graticule = function () {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u,
                  c,
                  d,
                  h,
                  f = 10,
                  p = f,
                  m = 90,
                  g = 360,
                  v = 2.5;
                function b() {
                  return {
                    type: "MultiLineString",
                    coordinates: _()
                  };
                }
                function _() {
                  return e.range(Math.ceil(i / m) * m, r, m).map(d).concat(e.range(Math.ceil(l / g) * g, s, g).map(h)).concat(e.range(Math.ceil(n / f) * f, t, f).filter(function (e) {
                    return y(e % m) > xe;
                  }).map(u)).concat(e.range(Math.ceil(a / p) * p, o, p).filter(function (e) {
                    return y(e % g) > xe;
                  }).map(c));
                }
                return b.lines = function () {
                  return _().map(function (e) {
                    return {
                      type: "LineString",
                      coordinates: e
                    };
                  });
                }, b.outline = function () {
                  return {
                    type: "Polygon",
                    coordinates: [d(i).concat(h(s).slice(1), d(r).reverse().slice(1), h(l).reverse().slice(1))]
                  };
                }, b.extent = function (e) {
                  return arguments.length ? b.majorExtent(e).minorExtent(e) : b.minorExtent();
                }, b.majorExtent = function (e) {
                  return arguments.length ? (i = +e[0][0], r = +e[1][0], l = +e[0][1], s = +e[1][1], i > r && (e = i, i = r, r = e), l > s && (e = l, l = s, s = e), b.precision(v)) : [[i, l], [r, s]];
                }, b.minorExtent = function (e) {
                  return arguments.length ? (n = +e[0][0], t = +e[1][0], a = +e[0][1], o = +e[1][1], n > t && (e = n, n = t, t = e), a > o && (e = a, a = o, o = e), b.precision(v)) : [[n, a], [t, o]];
                }, b.step = function (e) {
                  return arguments.length ? b.majorStep(e).minorStep(e) : b.minorStep();
                }, b.majorStep = function (e) {
                  return arguments.length ? (m = +e[0], g = +e[1], b) : [m, g];
                }, b.minorStep = function (e) {
                  return arguments.length ? (f = +e[0], p = +e[1], b) : [f, p];
                }, b.precision = function (e) {
                  return arguments.length ? (v = +e, u = Lr(a, o, 90), c = Dr(n, t, v), d = Lr(l, s, 90), h = Dr(i, r, v), b) : v;
                }, b.majorExtent([[-180, -90 + xe], [180, 90 - xe]]).minorExtent([[-180, -80 - xe], [180, 80 + xe]]);
              }, e.geo.greatArc = function () {
                var t,
                  n,
                  r = Br,
                  i = Fr;
                function o() {
                  return {
                    type: "LineString",
                    coordinates: [t || r.apply(this, arguments), n || i.apply(this, arguments)]
                  };
                }
                return o.distance = function () {
                  return e.geo.distance(t || r.apply(this, arguments), n || i.apply(this, arguments));
                }, o.source = function (e) {
                  return arguments.length ? (r = e, t = "function" == typeof e ? null : e, o) : r;
                }, o.target = function (e) {
                  return arguments.length ? (i = e, n = "function" == typeof e ? null : e, o) : i;
                }, o.precision = function () {
                  return arguments.length ? o : 0;
                }, o;
              }, e.geo.interpolate = function (e, t) {
                return n = e[0] * Me, r = e[1] * Me, i = t[0] * Me, o = t[1] * Me, a = Math.cos(r), s = Math.sin(r), l = Math.cos(o), u = Math.sin(o), c = a * Math.cos(n), d = a * Math.sin(n), h = l * Math.cos(i), f = l * Math.sin(i), p = 2 * Math.asin(Math.sqrt(je(o - r) + a * l * je(i - n))), m = 1 / Math.sin(p), (g = p ? function (e) {
                  var t = Math.sin(e *= p) * m,
                    n = Math.sin(p - e) * m,
                    r = n * c + t * h,
                    i = n * d + t * f,
                    o = n * s + t * u;
                  return [Math.atan2(i, r) * Ce, Math.atan2(o, Math.sqrt(r * r + i * i)) * Ce];
                } : function () {
                  return [n * Ce, r * Ce];
                }).distance = p, g;
                var n, r, i, o, a, s, l, u, c, d, h, f, p, m, g;
              }, e.geo.length = function (t) {
                return mr = 0, e.geo.stream(t, zr), mr;
              };
              var zr = {
                sphere: I,
                point: I,
                lineStart: function lineStart() {
                  var e, t, n;
                  function r(r, i) {
                    var o = Math.sin(i *= Me),
                      a = Math.cos(i),
                      s = y((r *= Me) - e),
                      l = Math.cos(s);
                    mr += Math.atan2(Math.sqrt((s = a * Math.sin(s)) * s + (s = n * o - t * a * l) * s), t * o + n * a * l), e = r, t = o, n = a;
                  }
                  zr.point = function (i, o) {
                    e = i * Me, t = Math.sin(o *= Me), n = Math.cos(o), zr.point = r;
                  }, zr.lineEnd = function () {
                    zr.point = zr.lineEnd = I;
                  };
                },
                lineEnd: I,
                polygonStart: I,
                polygonEnd: I
              };
              function Ur(e, t) {
                function n(t, n) {
                  var r = Math.cos(t),
                    i = Math.cos(n),
                    o = e(r * i);
                  return [o * i * Math.sin(t), o * Math.sin(n)];
                }
                return n.invert = function (e, n) {
                  var r = Math.sqrt(e * e + n * n),
                    i = t(r),
                    o = Math.sin(i),
                    a = Math.cos(i);
                  return [Math.atan2(e * o, r * a), Math.asin(r && n * o / r)];
                }, n;
              }
              var Gr = Ur(function (e) {
                return Math.sqrt(2 / (1 + e));
              }, function (e) {
                return 2 * Math.asin(e / 2);
              });
              (e.geo.azimuthalEqualArea = function () {
                return Er(Gr);
              }).raw = Gr;
              var Vr = Ur(function (e) {
                var t = Math.acos(e);
                return t && t / Math.sin(t);
              }, k);
              function Hr(e, t) {
                var n = Math.cos(e),
                  r = function r(e) {
                    return Math.tan(Se / 4 + e / 2);
                  },
                  i = e === t ? Math.sin(e) : Math.log(n / Math.cos(t)) / Math.log(r(t) / r(e)),
                  o = n * Math.pow(r(e), i) / i;
                if (!i) return $r;
                function a(e, t) {
                  o > 0 ? t < -Te + xe && (t = -Te + xe) : t > Te - xe && (t = Te - xe);
                  var n = o / Math.pow(r(t), i);
                  return [n * Math.sin(i * e), o - n * Math.cos(i * e)];
                }
                return a.invert = function (e, t) {
                  var n = o - t,
                    r = ke(i) * Math.sqrt(e * e + n * n);
                  return [Math.atan2(e, n) / i, 2 * Math.atan(Math.pow(o / r, 1 / i)) - Te];
                }, a;
              }
              function qr(e, t) {
                var n = Math.cos(e),
                  r = e === t ? Math.sin(e) : (n - Math.cos(t)) / (t - e),
                  i = n / r + e;
                if (y(r) < xe) return Cr;
                function o(e, t) {
                  var n = i - t;
                  return [n * Math.sin(r * e), i - n * Math.cos(r * e)];
                }
                return o.invert = function (e, t) {
                  var n = i - t;
                  return [Math.atan2(e, n) / r, i - ke(r) * Math.sqrt(e * e + n * n)];
                }, o;
              }
              (e.geo.azimuthalEquidistant = function () {
                return Er(Vr);
              }).raw = Vr, (e.geo.conicConformal = function () {
                return nr(Hr);
              }).raw = Hr, (e.geo.conicEquidistant = function () {
                return nr(qr);
              }).raw = qr;
              var Wr = Ur(function (e) {
                return 1 / e;
              }, Math.atan);
              function $r(e, t) {
                return [e, Math.log(Math.tan(Se / 4 + t / 2))];
              }
              function Xr(e) {
                var t,
                  n = Er(e),
                  r = n.scale,
                  i = n.translate,
                  o = n.clipExtent;
                return n.scale = function () {
                  var e = r.apply(n, arguments);
                  return e === n ? t ? n.clipExtent(null) : n : e;
                }, n.translate = function () {
                  var e = i.apply(n, arguments);
                  return e === n ? t ? n.clipExtent(null) : n : e;
                }, n.clipExtent = function (e) {
                  var a = o.apply(n, arguments);
                  if (a === n) {
                    if (t = null == e) {
                      var s = Se * r(),
                        l = i();
                      o([[l[0] - s, l[1] - s], [l[0] + s, l[1] + s]]);
                    }
                  } else t && (a = null);
                  return a;
                }, n.clipExtent(null);
              }
              (e.geo.gnomonic = function () {
                return Er(Wr);
              }).raw = Wr, $r.invert = function (e, t) {
                return [e, 2 * Math.atan(Math.exp(t)) - Te];
              }, (e.geo.mercator = function () {
                return Xr($r);
              }).raw = $r;
              var Yr = Ur(function () {
                return 1;
              }, Math.asin);
              (e.geo.orthographic = function () {
                return Er(Yr);
              }).raw = Yr;
              var Kr = Ur(function (e) {
                return 1 / (1 + e);
              }, function (e) {
                return 2 * Math.atan(e);
              });
              function Zr(e, t) {
                return [Math.log(Math.tan(Se / 4 + t / 2)), -e];
              }
              function Qr(e) {
                return e[0];
              }
              function Jr(e) {
                return e[1];
              }
              function ei(e) {
                for (var t = e.length, n = [0, 1], r = 2, i = 2; i < t; i++) {
                  for (; r > 1 && Pe(e[n[r - 2]], e[n[r - 1]], e[i]) <= 0;) --r;
                  n[r++] = i;
                }
                return n.slice(0, r);
              }
              function ti(e, t) {
                return e[0] - t[0] || e[1] - t[1];
              }
              (e.geo.stereographic = function () {
                return Er(Kr);
              }).raw = Kr, Zr.invert = function (e, t) {
                return [-t, 2 * Math.atan(Math.exp(e)) - Te];
              }, (e.geo.transverseMercator = function () {
                var e = Xr(Zr),
                  t = e.center,
                  n = e.rotate;
                return e.center = function (e) {
                  return e ? t([-e[1], e[0]]) : [(e = t())[1], -e[0]];
                }, e.rotate = function (e) {
                  return e ? n([e[0], e[1], e.length > 2 ? e[2] + 90 : 90]) : [(e = n())[0], e[1], e[2] - 90];
                }, n([0, 0, 90]);
              }).raw = Zr, e.geom = {}, e.geom.hull = function (e) {
                var t = Qr,
                  n = Jr;
                if (arguments.length) return r(e);
                function r(e) {
                  if (e.length < 3) return [];
                  var r,
                    i = dt(t),
                    o = dt(n),
                    a = e.length,
                    s = [],
                    l = [];
                  for (r = 0; r < a; r++) s.push([+i.call(this, e[r], r), +o.call(this, e[r], r), r]);
                  for (s.sort(ti), r = 0; r < a; r++) l.push([s[r][0], -s[r][1]]);
                  var u = ei(s),
                    c = ei(l),
                    d = c[0] === u[0],
                    h = c[c.length - 1] === u[u.length - 1],
                    f = [];
                  for (r = u.length - 1; r >= 0; --r) f.push(e[s[u[r]][2]]);
                  for (r = +d; r < c.length - h; ++r) f.push(e[s[c[r]][2]]);
                  return f;
                }
                return r.x = function (e) {
                  return arguments.length ? (t = e, r) : t;
                }, r.y = function (e) {
                  return arguments.length ? (n = e, r) : n;
                }, r;
              }, e.geom.polygon = function (e) {
                return z(e, ni), e;
              };
              var ni = e.geom.polygon.prototype = [];
              function ri(e, t, n) {
                return (n[0] - t[0]) * (e[1] - t[1]) < (n[1] - t[1]) * (e[0] - t[0]);
              }
              function ii(e, t, n, r) {
                var i = e[0],
                  o = n[0],
                  a = t[0] - i,
                  s = r[0] - o,
                  l = e[1],
                  u = n[1],
                  c = t[1] - l,
                  d = r[1] - u,
                  h = (s * (l - u) - d * (i - o)) / (d * a - s * c);
                return [i + h * a, l + h * c];
              }
              function oi(e) {
                var t = e[0],
                  n = e[e.length - 1];
                return !(t[0] - n[0] || t[1] - n[1]);
              }
              ni.area = function () {
                for (var e, t = -1, n = this.length, r = this[n - 1], i = 0; ++t < n;) e = r, r = this[t], i += e[1] * r[0] - e[0] * r[1];
                return .5 * i;
              }, ni.centroid = function (e) {
                var t,
                  n,
                  r = -1,
                  i = this.length,
                  o = 0,
                  a = 0,
                  s = this[i - 1];
                for (arguments.length || (e = -1 / (6 * this.area())); ++r < i;) t = s, s = this[r], n = t[0] * s[1] - s[0] * t[1], o += (t[0] + s[0]) * n, a += (t[1] + s[1]) * n;
                return [o * e, a * e];
              }, ni.clip = function (e) {
                for (var t, n, r, i, o, a, s = oi(e), l = -1, u = this.length - oi(this), c = this[u - 1]; ++l < u;) {
                  for (t = e.slice(), e.length = 0, i = this[l], o = t[(r = t.length - s) - 1], n = -1; ++n < r;) ri(a = t[n], c, i) ? (ri(o, c, i) || e.push(ii(o, a, c, i)), e.push(a)) : ri(o, c, i) && e.push(ii(o, a, c, i)), o = a;
                  s && e.push(e[0]), c = i;
                }
                return e;
              };
              var ai,
                si,
                li,
                ui,
                ci,
                di = [],
                hi = [];
              function fi() {
                Oi(this), this.edge = this.site = this.circle = null;
              }
              function pi(e) {
                var t = di.pop() || new fi();
                return t.site = e, t;
              }
              function mi(e) {
                Ai(e), li.remove(e), di.push(e), Oi(e);
              }
              function gi(e) {
                var t = e.circle,
                  n = t.x,
                  r = t.cy,
                  i = {
                    x: n,
                    y: r
                  },
                  o = e.P,
                  a = e.N,
                  s = [e];
                mi(e);
                for (var l = o; l.circle && y(n - l.circle.x) < xe && y(r - l.circle.cy) < xe;) o = l.P, s.unshift(l), mi(l), l = o;
                s.unshift(l), Ai(l);
                for (var u = a; u.circle && y(n - u.circle.x) < xe && y(r - u.circle.cy) < xe;) a = u.N, s.push(u), mi(u), u = a;
                s.push(u), Ai(u);
                var c,
                  d = s.length;
                for (c = 1; c < d; ++c) u = s[c], l = s[c - 1], Ci(u.edge, l.site, u.site, i);
                l = s[0], (u = s[d - 1]).edge = Mi(l.site, u.site, null, i), Si(l), Si(u);
              }
              function vi(e) {
                for (var t, n, r, i, o = e.x, a = e.y, s = li._; s;) if ((r = yi(s, a) - o) > xe) s = s.L;else {
                  if (!((i = o - bi(s, a)) > xe)) {
                    r > -xe ? (t = s.P, n = s) : i > -xe ? (t = s, n = s.N) : t = n = s;
                    break;
                  }
                  if (!s.R) {
                    t = s;
                    break;
                  }
                  s = s.R;
                }
                var l = pi(e);
                if (li.insert(t, l), t || n) {
                  if (t === n) return Ai(t), n = pi(t.site), li.insert(l, n), l.edge = n.edge = Mi(t.site, l.site), Si(t), void Si(n);
                  if (n) {
                    Ai(t), Ai(n);
                    var u = t.site,
                      c = u.x,
                      d = u.y,
                      h = e.x - c,
                      f = e.y - d,
                      p = n.site,
                      m = p.x - c,
                      g = p.y - d,
                      v = 2 * (h * g - f * m),
                      y = h * h + f * f,
                      b = m * m + g * g,
                      _ = {
                        x: (g * y - f * b) / v + c,
                        y: (h * b - m * y) / v + d
                      };
                    Ci(n.edge, u, p, _), l.edge = Mi(u, e, null, _), n.edge = Mi(e, p, null, _), Si(t), Si(n);
                  } else l.edge = Mi(t.site, l.site);
                }
              }
              function yi(e, t) {
                var n = e.site,
                  r = n.x,
                  i = n.y,
                  o = i - t;
                if (!o) return r;
                var a = e.P;
                if (!a) return -1 / 0;
                var s = (n = a.site).x,
                  l = n.y,
                  u = l - t;
                if (!u) return s;
                var c = s - r,
                  d = 1 / o - 1 / u,
                  h = c / u;
                return d ? (-h + Math.sqrt(h * h - 2 * d * (c * c / (-2 * u) - l + u / 2 + i - o / 2))) / d + r : (r + s) / 2;
              }
              function bi(e, t) {
                var n = e.N;
                if (n) return yi(n, t);
                var r = e.site;
                return r.y === t ? r.x : 1 / 0;
              }
              function _i(e) {
                this.site = e, this.edges = [];
              }
              function xi(e, t) {
                return t.angle - e.angle;
              }
              function wi() {
                Oi(this), this.x = this.y = this.arc = this.site = this.cy = null;
              }
              function Si(e) {
                var t = e.P,
                  n = e.N;
                if (t && n) {
                  var r = t.site,
                    i = e.site,
                    o = n.site;
                  if (r !== o) {
                    var a = i.x,
                      s = i.y,
                      l = r.x - a,
                      u = r.y - s,
                      c = o.x - a,
                      d = 2 * (l * (g = o.y - s) - u * c);
                    if (!(d >= -we)) {
                      var h = l * l + u * u,
                        f = c * c + g * g,
                        p = (g * h - u * f) / d,
                        m = (l * f - c * h) / d,
                        g = m + s,
                        v = hi.pop() || new wi();
                      v.arc = e, v.site = i, v.x = p + a, v.y = g + Math.sqrt(p * p + m * m), v.cy = g, e.circle = v;
                      for (var y = null, b = ci._; b;) if (v.y < b.y || v.y === b.y && v.x <= b.x) {
                        if (!b.L) {
                          y = b.P;
                          break;
                        }
                        b = b.L;
                      } else {
                        if (!b.R) {
                          y = b;
                          break;
                        }
                        b = b.R;
                      }
                      ci.insert(y, v), y || (ui = v);
                    }
                  }
                }
              }
              function Ai(e) {
                var t = e.circle;
                t && (t.P || (ui = t.N), ci.remove(t), hi.push(t), Oi(t), e.circle = null);
              }
              function Ei(e, t) {
                var n = e.b;
                if (n) return !0;
                var r,
                  i,
                  o = e.a,
                  a = t[0][0],
                  s = t[1][0],
                  l = t[0][1],
                  u = t[1][1],
                  c = e.l,
                  d = e.r,
                  h = c.x,
                  f = c.y,
                  p = d.x,
                  m = d.y,
                  g = (h + p) / 2,
                  v = (f + m) / 2;
                if (m === f) {
                  if (g < a || g >= s) return;
                  if (h > p) {
                    if (o) {
                      if (o.y >= u) return;
                    } else o = {
                      x: g,
                      y: l
                    };
                    n = {
                      x: g,
                      y: u
                    };
                  } else {
                    if (o) {
                      if (o.y < l) return;
                    } else o = {
                      x: g,
                      y: u
                    };
                    n = {
                      x: g,
                      y: l
                    };
                  }
                } else if (i = v - (r = (h - p) / (m - f)) * g, r < -1 || r > 1) {
                  if (h > p) {
                    if (o) {
                      if (o.y >= u) return;
                    } else o = {
                      x: (l - i) / r,
                      y: l
                    };
                    n = {
                      x: (u - i) / r,
                      y: u
                    };
                  } else {
                    if (o) {
                      if (o.y < l) return;
                    } else o = {
                      x: (u - i) / r,
                      y: u
                    };
                    n = {
                      x: (l - i) / r,
                      y: l
                    };
                  }
                } else if (f < m) {
                  if (o) {
                    if (o.x >= s) return;
                  } else o = {
                    x: a,
                    y: r * a + i
                  };
                  n = {
                    x: s,
                    y: r * s + i
                  };
                } else {
                  if (o) {
                    if (o.x < a) return;
                  } else o = {
                    x: s,
                    y: r * s + i
                  };
                  n = {
                    x: a,
                    y: r * a + i
                  };
                }
                return e.a = o, e.b = n, !0;
              }
              function Ti(e, t) {
                this.l = e, this.r = t, this.a = this.b = null;
              }
              function Mi(e, t, n, r) {
                var i = new Ti(e, t);
                return ai.push(i), n && Ci(i, e, t, n), r && Ci(i, t, e, r), si[e.i].edges.push(new ki(i, e, t)), si[t.i].edges.push(new ki(i, t, e)), i;
              }
              function Ci(e, t, n, r) {
                e.a || e.b ? e.l === n ? e.b = r : e.a = r : (e.a = r, e.l = t, e.r = n);
              }
              function ki(e, t, n) {
                var r = e.a,
                  i = e.b;
                this.edge = e, this.site = t, this.angle = n ? Math.atan2(n.y - t.y, n.x - t.x) : e.l === t ? Math.atan2(i.x - r.x, r.y - i.y) : Math.atan2(r.x - i.x, i.y - r.y);
              }
              function Pi() {
                this._ = null;
              }
              function Oi(e) {
                e.U = e.C = e.L = e.R = e.P = e.N = null;
              }
              function Ri(e, t) {
                var n = t,
                  r = t.R,
                  i = n.U;
                i ? i.L === n ? i.L = r : i.R = r : e._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
              }
              function Ii(e, t) {
                var n = t,
                  r = t.L,
                  i = n.U;
                i ? i.L === n ? i.L = r : i.R = r : e._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
              }
              function ji(e) {
                for (; e.L;) e = e.L;
                return e;
              }
              function Ni(e, t) {
                var n,
                  r,
                  i,
                  o = e.sort(Li).pop();
                for (ai = [], si = new Array(e.length), li = new Pi(), ci = new Pi();;) if (i = ui, o && (!i || o.y < i.y || o.y === i.y && o.x < i.x)) o.x === n && o.y === r || (si[o.i] = new _i(o), vi(o), n = o.x, r = o.y), o = e.pop();else {
                  if (!i) break;
                  gi(i.arc);
                }
                t && (function (e) {
                  for (var t, n = ai, r = Jn(e[0][0], e[0][1], e[1][0], e[1][1]), i = n.length; i--;) (!Ei(t = n[i], e) || !r(t) || y(t.a.x - t.b.x) < xe && y(t.a.y - t.b.y) < xe) && (t.a = t.b = null, n.splice(i, 1));
                }(t), function (e) {
                  for (var t, n, r, i, o, a, s, l, u, c, d = e[0][0], h = e[1][0], f = e[0][1], p = e[1][1], m = si, g = m.length; g--;) if ((o = m[g]) && o.prepare()) for (l = (s = o.edges).length, a = 0; a < l;) r = (c = s[a].end()).x, i = c.y, t = (u = s[++a % l].start()).x, n = u.y, (y(r - t) > xe || y(i - n) > xe) && (s.splice(a, 0, new ki((v = o.site, b = c, _ = y(r - d) < xe && p - i > xe ? {
                    x: d,
                    y: y(t - d) < xe ? n : p
                  } : y(i - p) < xe && h - r > xe ? {
                    x: y(n - p) < xe ? t : h,
                    y: p
                  } : y(r - h) < xe && i - f > xe ? {
                    x: h,
                    y: y(t - h) < xe ? n : f
                  } : y(i - f) < xe && r - d > xe ? {
                    x: y(n - f) < xe ? t : d,
                    y: f
                  } : null, x = void 0, (x = new Ti(v, null)).a = b, x.b = _, ai.push(x), x), o.site, null)), ++l);
                  var v, b, _, x;
                }(t));
                var a = {
                  cells: si,
                  edges: ai
                };
                return li = ci = ai = si = null, a;
              }
              function Li(e, t) {
                return t.y - e.y || t.x - e.x;
              }
              _i.prototype.prepare = function () {
                for (var e, t = this.edges, n = t.length; n--;) (e = t[n].edge).b && e.a || t.splice(n, 1);
                return t.sort(xi), t.length;
              }, ki.prototype = {
                start: function start() {
                  return this.edge.l === this.site ? this.edge.a : this.edge.b;
                },
                end: function end() {
                  return this.edge.l === this.site ? this.edge.b : this.edge.a;
                }
              }, Pi.prototype = {
                insert: function insert(e, t) {
                  var n, r, i;
                  if (e) {
                    if (t.P = e, t.N = e.N, e.N && (e.N.P = t), e.N = t, e.R) {
                      for (e = e.R; e.L;) e = e.L;
                      e.L = t;
                    } else e.R = t;
                    n = e;
                  } else this._ ? (e = ji(this._), t.P = null, t.N = e, e.P = e.L = t, n = e) : (t.P = t.N = null, this._ = t, n = null);
                  for (t.L = t.R = null, t.U = n, t.C = !0, e = t; n && n.C;) n === (r = n.U).L ? (i = r.R) && i.C ? (n.C = i.C = !1, r.C = !0, e = r) : (e === n.R && (Ri(this, n), n = (e = n).U), n.C = !1, r.C = !0, Ii(this, r)) : (i = r.L) && i.C ? (n.C = i.C = !1, r.C = !0, e = r) : (e === n.L && (Ii(this, n), n = (e = n).U), n.C = !1, r.C = !0, Ri(this, r)), n = e.U;
                  this._.C = !1;
                },
                remove: function remove(e) {
                  e.N && (e.N.P = e.P), e.P && (e.P.N = e.N), e.N = e.P = null;
                  var t,
                    n,
                    r,
                    i = e.U,
                    o = e.L,
                    a = e.R;
                  if (n = o ? a ? ji(a) : o : a, i ? i.L === e ? i.L = n : i.R = n : this._ = n, o && a ? (r = n.C, n.C = e.C, n.L = o, o.U = n, n !== a ? (i = n.U, n.U = e.U, e = n.R, i.L = e, n.R = a, a.U = n) : (n.U = i, i = n, e = n.R)) : (r = e.C, e = n), e && (e.U = i), !r) if (e && e.C) e.C = !1;else {
                    do {
                      if (e === this._) break;
                      if (e === i.L) {
                        if ((t = i.R).C && (t.C = !1, i.C = !0, Ri(this, i), t = i.R), t.L && t.L.C || t.R && t.R.C) {
                          t.R && t.R.C || (t.L.C = !1, t.C = !0, Ii(this, t), t = i.R), t.C = i.C, i.C = t.R.C = !1, Ri(this, i), e = this._;
                          break;
                        }
                      } else if ((t = i.L).C && (t.C = !1, i.C = !0, Ii(this, i), t = i.L), t.L && t.L.C || t.R && t.R.C) {
                        t.L && t.L.C || (t.R.C = !1, t.C = !0, Ri(this, t), t = i.L), t.C = i.C, i.C = t.L.C = !1, Ii(this, i), e = this._;
                        break;
                      }
                      t.C = !0, e = i, i = i.U;
                    } while (!e.C);
                    e && (e.C = !1);
                  }
                }
              }, e.geom.voronoi = function (e) {
                var t = Qr,
                  n = Jr,
                  r = t,
                  i = n,
                  o = Di;
                if (e) return a(e);
                function a(e) {
                  var t = new Array(e.length),
                    n = o[0][0],
                    r = o[0][1],
                    i = o[1][0],
                    a = o[1][1];
                  return Ni(s(e), o).cells.forEach(function (o, s) {
                    var l = o.edges,
                      u = o.site;
                    (t[s] = l.length ? l.map(function (e) {
                      var t = e.start();
                      return [t.x, t.y];
                    }) : u.x >= n && u.x <= i && u.y >= r && u.y <= a ? [[n, a], [i, a], [i, r], [n, r]] : []).point = e[s];
                  }), t;
                }
                function s(e) {
                  return e.map(function (e, t) {
                    return {
                      x: Math.round(r(e, t) / xe) * xe,
                      y: Math.round(i(e, t) / xe) * xe,
                      i: t
                    };
                  });
                }
                return a.links = function (e) {
                  return Ni(s(e)).edges.filter(function (e) {
                    return e.l && e.r;
                  }).map(function (t) {
                    return {
                      source: e[t.l.i],
                      target: e[t.r.i]
                    };
                  });
                }, a.triangles = function (e) {
                  var t = [];
                  return Ni(s(e)).cells.forEach(function (n, r) {
                    for (var i, o, a, s, l = n.site, u = n.edges.sort(xi), c = -1, d = u.length, h = u[d - 1].edge, f = h.l === l ? h.r : h.l; ++c < d;) i = f, f = (h = u[c].edge).l === l ? h.r : h.l, r < i.i && r < f.i && (a = i, s = f, ((o = l).x - s.x) * (a.y - o.y) - (o.x - a.x) * (s.y - o.y) < 0) && t.push([e[r], e[i.i], e[f.i]]);
                  }), t;
                }, a.x = function (e) {
                  return arguments.length ? (r = dt(t = e), a) : t;
                }, a.y = function (e) {
                  return arguments.length ? (i = dt(n = e), a) : n;
                }, a.clipExtent = function (e) {
                  return arguments.length ? (o = null == e ? Di : e, a) : o === Di ? null : o;
                }, a.size = function (e) {
                  return arguments.length ? a.clipExtent(e && [[0, 0], e]) : o === Di ? null : o && o[1];
                }, a;
              };
              var Di = [[-1e6, -1e6], [1e6, 1e6]];
              function Bi(e) {
                return e.x;
              }
              function Fi(e) {
                return e.y;
              }
              function zi(t, n) {
                t = e.rgb(t), n = e.rgb(n);
                var r = t.r,
                  i = t.g,
                  o = t.b,
                  a = n.r - r,
                  s = n.g - i,
                  l = n.b - o;
                return function (e) {
                  return "#" + it(Math.round(r + a * e)) + it(Math.round(i + s * e)) + it(Math.round(o + l * e));
                };
              }
              function Ui(e, t) {
                var n,
                  r = {},
                  i = {};
                for (n in e) n in t ? r[n] = Wi(e[n], t[n]) : i[n] = e[n];
                for (n in t) n in e || (i[n] = t[n]);
                return function (e) {
                  for (n in r) i[n] = r[n](e);
                  return i;
                };
              }
              function Gi(e, t) {
                return e = +e, t = +t, function (n) {
                  return e * (1 - n) + t * n;
                };
              }
              function Vi(e, t) {
                var n,
                  r,
                  i,
                  o = Hi.lastIndex = qi.lastIndex = 0,
                  a = -1,
                  s = [],
                  l = [];
                for (e += "", t += ""; (n = Hi.exec(e)) && (r = qi.exec(t));) (i = r.index) > o && (i = t.slice(o, i), s[a] ? s[a] += i : s[++a] = i), (n = n[0]) === (r = r[0]) ? s[a] ? s[a] += r : s[++a] = r : (s[++a] = null, l.push({
                  i: a,
                  x: Gi(n, r)
                })), o = qi.lastIndex;
                return o < t.length && (i = t.slice(o), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? l[0] ? (t = l[0].x, function (e) {
                  return t(e) + "";
                }) : function () {
                  return t;
                } : (t = l.length, function (e) {
                  for (var n, r = 0; r < t; ++r) s[(n = l[r]).i] = n.x(e);
                  return s.join("");
                });
              }
              e.geom.delaunay = function (t) {
                return e.geom.voronoi().triangles(t);
              }, e.geom.quadtree = function (e, t, n, r, i) {
                var o,
                  a = Qr,
                  s = Jr;
                if (o = arguments.length) return a = Bi, s = Fi, 3 === o && (i = n, r = t, n = t = 0), l(e);
                function l(e) {
                  var l,
                    u,
                    c,
                    d,
                    h,
                    f,
                    p,
                    m,
                    g,
                    v = dt(a),
                    b = dt(s);
                  if (null != t) f = t, p = n, m = r, g = i;else if (m = g = -(f = p = 1 / 0), u = [], c = [], h = e.length, o) for (d = 0; d < h; ++d) (l = e[d]).x < f && (f = l.x), l.y < p && (p = l.y), l.x > m && (m = l.x), l.y > g && (g = l.y), u.push(l.x), c.push(l.y);else for (d = 0; d < h; ++d) {
                    var _ = +v(l = e[d], d),
                      x = +b(l, d);
                    _ < f && (f = _), x < p && (p = x), _ > m && (m = _), x > g && (g = x), u.push(_), c.push(x);
                  }
                  var w = m - f,
                    S = g - p;
                  function A(e, t, n, r, i, o, a, s) {
                    if (!isNaN(n) && !isNaN(r)) if (e.leaf) {
                      var l = e.x,
                        u = e.y;
                      if (null != l) {
                        if (y(l - n) + y(u - r) < .01) E(e, t, n, r, i, o, a, s);else {
                          var c = e.point;
                          e.x = e.y = e.point = null, E(e, c, l, u, i, o, a, s), E(e, t, n, r, i, o, a, s);
                        }
                      } else e.x = n, e.y = r, e.point = t;
                    } else E(e, t, n, r, i, o, a, s);
                  }
                  function E(e, t, n, r, i, o, a, s) {
                    var l = .5 * (i + a),
                      u = .5 * (o + s),
                      c = n >= l,
                      d = r >= u,
                      h = d << 1 | c;
                    e.leaf = !1, c ? i = l : a = l, d ? o = u : s = u, A(e = e.nodes[h] || (e.nodes[h] = {
                      leaf: !0,
                      nodes: [],
                      point: null,
                      x: null,
                      y: null
                    }), t, n, r, i, o, a, s);
                  }
                  w > S ? g = p + w : m = f + S;
                  var T = {
                    leaf: !0,
                    nodes: [],
                    point: null,
                    x: null,
                    y: null,
                    add: function add(e) {
                      A(T, e, +v(e, ++d), +b(e, d), f, p, m, g);
                    },
                    visit: function visit(e) {
                      !function e(t, n, r, i, o, a) {
                        if (!t(n, r, i, o, a)) {
                          var s = .5 * (r + o),
                            l = .5 * (i + a),
                            u = n.nodes;
                          u[0] && e(t, u[0], r, i, s, l), u[1] && e(t, u[1], s, i, o, l), u[2] && e(t, u[2], r, l, s, a), u[3] && e(t, u[3], s, l, o, a);
                        }
                      }(e, T, f, p, m, g);
                    },
                    find: function find(e) {
                      return function (e, t, n, r, i, o, a) {
                        var s,
                          l = 1 / 0;
                        return function e(u, c, d, h, f) {
                          if (!(c > o || d > a || h < r || f < i)) {
                            if (p = u.point) {
                              var p,
                                m = t - u.x,
                                g = n - u.y,
                                v = m * m + g * g;
                              if (v < l) {
                                var y = Math.sqrt(l = v);
                                r = t - y, i = n - y, o = t + y, a = n + y, s = p;
                              }
                            }
                            for (var b = u.nodes, _ = .5 * (c + h), x = .5 * (d + f), w = (n >= x) << 1 | t >= _, S = w + 4; w < S; ++w) if (u = b[3 & w]) switch (3 & w) {
                              case 0:
                                e(u, c, d, _, x);
                                break;
                              case 1:
                                e(u, _, d, h, x);
                                break;
                              case 2:
                                e(u, c, x, _, f);
                                break;
                              case 3:
                                e(u, _, x, h, f);
                            }
                          }
                        }(e, r, i, o, a), s;
                      }(T, e[0], e[1], f, p, m, g);
                    }
                  };
                  if (d = -1, null == t) {
                    for (; ++d < h;) A(T, e[d], u[d], c[d], f, p, m, g);
                    --d;
                  } else e.forEach(T.add);
                  return u = c = e = l = null, T;
                }
                return l.x = function (e) {
                  return arguments.length ? (a = e, l) : a;
                }, l.y = function (e) {
                  return arguments.length ? (s = e, l) : s;
                }, l.extent = function (e) {
                  return arguments.length ? (null == e ? t = n = r = i = null : (t = +e[0][0], n = +e[0][1], r = +e[1][0], i = +e[1][1]), l) : null == t ? null : [[t, n], [r, i]];
                }, l.size = function (e) {
                  return arguments.length ? (null == e ? t = n = r = i = null : (t = n = 0, r = +e[0], i = +e[1]), l) : null == t ? null : [r - t, i - n];
                }, l;
              }, e.interpolateRgb = zi, e.interpolateObject = Ui, e.interpolateNumber = Gi, e.interpolateString = Vi;
              var Hi = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
                qi = new RegExp(Hi.source, "g");
              function Wi(t, n) {
                for (var r, i = e.interpolators.length; --i >= 0 && !(r = e.interpolators[i](t, n)););
                return r;
              }
              function $i(e, t) {
                var n,
                  r = [],
                  i = [],
                  o = e.length,
                  a = t.length,
                  s = Math.min(e.length, t.length);
                for (n = 0; n < s; ++n) r.push(Wi(e[n], t[n]));
                for (; n < o; ++n) i[n] = e[n];
                for (; n < a; ++n) i[n] = t[n];
                return function (e) {
                  for (n = 0; n < s; ++n) i[n] = r[n](e);
                  return i;
                };
              }
              e.interpolate = Wi, e.interpolators = [function (e, t) {
                var n = typeof t;
                return ("string" === n ? ct.has(t.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(t) ? zi : Vi : t instanceof Fe ? zi : Array.isArray(t) ? $i : "object" === n && isNaN(t) ? Ui : Gi)(e, t);
              }], e.interpolateArray = $i;
              var Xi = function Xi() {
                  return k;
                },
                Yi = e.map({
                  linear: Xi,
                  poly: function poly(e) {
                    return function (t) {
                      return Math.pow(t, e);
                    };
                  },
                  quad: function quad() {
                    return Ji;
                  },
                  cubic: function cubic() {
                    return eo;
                  },
                  sin: function sin() {
                    return no;
                  },
                  exp: function exp() {
                    return ro;
                  },
                  circle: function circle() {
                    return io;
                  },
                  elastic: function elastic(e, t) {
                    var n;
                    return arguments.length < 2 && (t = .45), arguments.length ? n = t / Ae * Math.asin(1 / e) : (e = 1, n = t / 4), function (r) {
                      return 1 + e * Math.pow(2, -10 * r) * Math.sin((r - n) * Ae / t);
                    };
                  },
                  back: function back(e) {
                    return e || (e = 1.70158), function (t) {
                      return t * t * ((e + 1) * t - e);
                    };
                  },
                  bounce: function bounce() {
                    return oo;
                  }
                }),
                Ki = e.map({
                  in: k,
                  out: Zi,
                  "in-out": Qi,
                  "out-in": function outIn(e) {
                    return Qi(Zi(e));
                  }
                });
              function Zi(e) {
                return function (t) {
                  return 1 - e(1 - t);
                };
              }
              function Qi(e) {
                return function (t) {
                  return .5 * (t < .5 ? e(2 * t) : 2 - e(2 - 2 * t));
                };
              }
              function Ji(e) {
                return e * e;
              }
              function eo(e) {
                return e * e * e;
              }
              function to(e) {
                if (e <= 0) return 0;
                if (e >= 1) return 1;
                var t = e * e,
                  n = t * e;
                return 4 * (e < .5 ? n : 3 * (e - t) + n - .75);
              }
              function no(e) {
                return 1 - Math.cos(e * Te);
              }
              function ro(e) {
                return Math.pow(2, 10 * (e - 1));
              }
              function io(e) {
                return 1 - Math.sqrt(1 - e * e);
              }
              function oo(e) {
                return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + .75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + .9375 : 7.5625 * (e -= 2.625 / 2.75) * e + .984375;
              }
              function ao(e, t) {
                return t -= e, function (n) {
                  return Math.round(e + t * n);
                };
              }
              function so(e) {
                var t,
                  n,
                  r,
                  i = [e.a, e.b],
                  o = [e.c, e.d],
                  a = uo(i),
                  s = lo(i, o),
                  l = uo(((t = o)[0] += (r = -s) * (n = i)[0], t[1] += r * n[1], t)) || 0;
                i[0] * o[1] < o[0] * i[1] && (i[0] *= -1, i[1] *= -1, a *= -1, s *= -1), this.rotate = (a ? Math.atan2(i[1], i[0]) : Math.atan2(-o[0], o[1])) * Ce, this.translate = [e.e, e.f], this.scale = [a, l], this.skew = l ? Math.atan2(s, l) * Ce : 0;
              }
              function lo(e, t) {
                return e[0] * t[0] + e[1] * t[1];
              }
              function uo(e) {
                var t = Math.sqrt(lo(e, e));
                return t && (e[0] /= t, e[1] /= t), t;
              }
              e.ease = function (e) {
                var t,
                  r = e.indexOf("-"),
                  i = r >= 0 ? e.slice(0, r) : e,
                  o = r >= 0 ? e.slice(r + 1) : "in";
                return i = Yi.get(i) || Xi, o = Ki.get(o) || k, t = o(i.apply(null, n.call(arguments, 1))), function (e) {
                  return e <= 0 ? 0 : e >= 1 ? 1 : t(e);
                };
              }, e.interpolateHcl = function (t, n) {
                t = e.hcl(t), n = e.hcl(n);
                var r = t.h,
                  i = t.c,
                  o = t.l,
                  a = n.h - r,
                  s = n.c - i,
                  l = n.l - o;
                return isNaN(s) && (s = 0, i = isNaN(i) ? n.c : i), isNaN(a) ? (a = 0, r = isNaN(r) ? n.h : r) : a > 180 ? a -= 360 : a < -180 && (a += 360), function (e) {
                  return qe(r + a * e, i + s * e, o + l * e) + "";
                };
              }, e.interpolateHsl = function (t, n) {
                t = e.hsl(t), n = e.hsl(n);
                var r = t.h,
                  i = t.s,
                  o = t.l,
                  a = n.h - r,
                  s = n.s - i,
                  l = n.l - o;
                return isNaN(s) && (s = 0, i = isNaN(i) ? n.s : i), isNaN(a) ? (a = 0, r = isNaN(r) ? n.h : r) : a > 180 ? a -= 360 : a < -180 && (a += 360), function (e) {
                  return Ge(r + a * e, i + s * e, o + l * e) + "";
                };
              }, e.interpolateLab = function (t, n) {
                t = e.lab(t), n = e.lab(n);
                var r = t.l,
                  i = t.a,
                  o = t.b,
                  a = n.l - r,
                  s = n.a - i,
                  l = n.b - o;
                return function (e) {
                  return Ye(r + a * e, i + s * e, o + l * e) + "";
                };
              }, e.interpolateRound = ao, e.transform = function (t) {
                var n = i.createElementNS(e.ns.prefix.svg, "g");
                return (e.transform = function (e) {
                  if (null != e) {
                    n.setAttribute("transform", e);
                    var t = n.transform.baseVal.consolidate();
                  }
                  return new so(t ? t.matrix : co);
                })(t);
              }, so.prototype.toString = function () {
                return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
              };
              var co = {
                a: 1,
                b: 0,
                c: 0,
                d: 1,
                e: 0,
                f: 0
              };
              function ho(e) {
                return e.length ? e.pop() + "," : "";
              }
              function fo(t, n) {
                var r = [],
                  i = [];
                return t = e.transform(t), n = e.transform(n), function (e, t, n, r) {
                  if (e[0] !== t[0] || e[1] !== t[1]) {
                    var i = n.push("translate(", null, ",", null, ")");
                    r.push({
                      i: i - 4,
                      x: Gi(e[0], t[0])
                    }, {
                      i: i - 2,
                      x: Gi(e[1], t[1])
                    });
                  } else (t[0] || t[1]) && n.push("translate(" + t + ")");
                }(t.translate, n.translate, r, i), function (e, t, n, r) {
                  e !== t ? (e - t > 180 ? t += 360 : t - e > 180 && (e += 360), r.push({
                    i: n.push(ho(n) + "rotate(", null, ")") - 2,
                    x: Gi(e, t)
                  })) : t && n.push(ho(n) + "rotate(" + t + ")");
                }(t.rotate, n.rotate, r, i), function (e, t, n, r) {
                  e !== t ? r.push({
                    i: n.push(ho(n) + "skewX(", null, ")") - 2,
                    x: Gi(e, t)
                  }) : t && n.push(ho(n) + "skewX(" + t + ")");
                }(t.skew, n.skew, r, i), function (e, t, n, r) {
                  if (e[0] !== t[0] || e[1] !== t[1]) {
                    var i = n.push(ho(n) + "scale(", null, ",", null, ")");
                    r.push({
                      i: i - 4,
                      x: Gi(e[0], t[0])
                    }, {
                      i: i - 2,
                      x: Gi(e[1], t[1])
                    });
                  } else 1 === t[0] && 1 === t[1] || n.push(ho(n) + "scale(" + t + ")");
                }(t.scale, n.scale, r, i), t = n = null, function (e) {
                  for (var t, n = -1, o = i.length; ++n < o;) r[(t = i[n]).i] = t.x(e);
                  return r.join("");
                };
              }
              function po(e, t) {
                return t = (t -= e = +e) || 1 / t, function (n) {
                  return (n - e) / t;
                };
              }
              function mo(e, t) {
                return t = (t -= e = +e) || 1 / t, function (n) {
                  return Math.max(0, Math.min(1, (n - e) / t));
                };
              }
              function go(e) {
                for (var t = e.source, n = e.target, r = function (e, t) {
                    if (e === t) return e;
                    for (var n = vo(e), r = vo(t), i = n.pop(), o = r.pop(), a = null; i === o;) a = i, i = n.pop(), o = r.pop();
                    return a;
                  }(t, n), i = [t]; t !== r;) t = t.parent, i.push(t);
                for (var o = i.length; n !== r;) i.splice(o, 0, n), n = n.parent;
                return i;
              }
              function vo(e) {
                for (var t = [], n = e.parent; null != n;) t.push(e), e = n, n = n.parent;
                return t.push(e), t;
              }
              function yo(e) {
                e.fixed |= 2;
              }
              function bo(e) {
                e.fixed &= -7;
              }
              function _o(e) {
                e.fixed |= 4, e.px = e.x, e.py = e.y;
              }
              function xo(e) {
                e.fixed &= -5;
              }
              e.interpolateTransform = fo, e.layout = {}, e.layout.bundle = function () {
                return function (e) {
                  for (var t = [], n = -1, r = e.length; ++n < r;) t.push(go(e[n]));
                  return t;
                };
              }, e.layout.chord = function () {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  l = {},
                  u = 0;
                function c() {
                  var l,
                    c,
                    h,
                    f,
                    p,
                    m = {},
                    g = [],
                    v = e.range(i),
                    y = [];
                  for (t = [], n = [], l = 0, f = -1; ++f < i;) {
                    for (c = 0, p = -1; ++p < i;) c += r[f][p];
                    g.push(c), y.push(e.range(i)), l += c;
                  }
                  for (o && v.sort(function (e, t) {
                    return o(g[e], g[t]);
                  }), a && y.forEach(function (e, t) {
                    e.sort(function (e, n) {
                      return a(r[t][e], r[t][n]);
                    });
                  }), l = (Ae - u * i) / l, c = 0, f = -1; ++f < i;) {
                    for (h = c, p = -1; ++p < i;) {
                      var b = v[f],
                        _ = y[b][p],
                        x = r[b][_],
                        w = c,
                        S = c += x * l;
                      m[b + "-" + _] = {
                        index: b,
                        subindex: _,
                        startAngle: w,
                        endAngle: S,
                        value: x
                      };
                    }
                    n[b] = {
                      index: b,
                      startAngle: h,
                      endAngle: c,
                      value: g[b]
                    }, c += u;
                  }
                  for (f = -1; ++f < i;) for (p = f - 1; ++p < i;) {
                    var A = m[f + "-" + p],
                      E = m[p + "-" + f];
                    (A.value || E.value) && t.push(A.value < E.value ? {
                      source: E,
                      target: A
                    } : {
                      source: A,
                      target: E
                    });
                  }
                  s && d();
                }
                function d() {
                  t.sort(function (e, t) {
                    return s((e.source.value + e.target.value) / 2, (t.source.value + t.target.value) / 2);
                  });
                }
                return l.matrix = function (e) {
                  return arguments.length ? (i = (r = e) && r.length, t = n = null, l) : r;
                }, l.padding = function (e) {
                  return arguments.length ? (u = e, t = n = null, l) : u;
                }, l.sortGroups = function (e) {
                  return arguments.length ? (o = e, t = n = null, l) : o;
                }, l.sortSubgroups = function (e) {
                  return arguments.length ? (a = e, t = null, l) : a;
                }, l.sortChords = function (e) {
                  return arguments.length ? (s = e, t && d(), l) : s;
                }, l.chords = function () {
                  return t || c(), t;
                }, l.groups = function () {
                  return n || c(), n;
                }, l;
              }, e.layout.force = function () {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a,
                  s = {},
                  l = e.dispatch("start", "tick", "end"),
                  u = [1, 1],
                  c = .9,
                  d = wo,
                  h = So,
                  f = -30,
                  p = Ao,
                  m = .1,
                  g = .64,
                  v = [],
                  y = [];
                function b(e) {
                  return function (t, n, r, i) {
                    if (t.point !== e) {
                      var o = t.cx - e.x,
                        a = t.cy - e.y,
                        s = i - n,
                        l = o * o + a * a;
                      if (s * s / g < l) {
                        if (l < p) {
                          var u = t.charge / l;
                          e.px -= o * u, e.py -= a * u;
                        }
                        return !0;
                      }
                      t.point && l && l < p && (u = t.pointCharge / l, e.px -= o * u, e.py -= a * u);
                    }
                    return !t.charge;
                  };
                }
                function _(t) {
                  t.px = e.event.x, t.py = e.event.y, s.resume();
                }
                return s.tick = function () {
                  if ((r *= .99) < .005) return t = null, l.end({
                    type: "end",
                    alpha: r = 0
                  }), !0;
                  var n,
                    s,
                    d,
                    h,
                    p,
                    g,
                    _,
                    x,
                    w,
                    S = v.length,
                    A = y.length;
                  for (s = 0; s < A; ++s) h = (d = y[s]).source, (g = (x = (p = d.target).x - h.x) * x + (w = p.y - h.y) * w) && (x *= g = r * o[s] * ((g = Math.sqrt(g)) - i[s]) / g, w *= g, p.x -= x * (_ = h.weight + p.weight ? h.weight / (h.weight + p.weight) : .5), p.y -= w * _, h.x += x * (_ = 1 - _), h.y += w * _);
                  if ((_ = r * m) && (x = u[0] / 2, w = u[1] / 2, s = -1, _)) for (; ++s < S;) (d = v[s]).x += (x - d.x) * _, d.y += (w - d.y) * _;
                  if (f) for (function e(t, n, r) {
                    var i = 0,
                      o = 0;
                    if (t.charge = 0, !t.leaf) for (var a, s = t.nodes, l = s.length, u = -1; ++u < l;) null != (a = s[u]) && (e(a, n, r), t.charge += a.charge, i += a.charge * a.cx, o += a.charge * a.cy);
                    if (t.point) {
                      t.leaf || (t.point.x += Math.random() - .5, t.point.y += Math.random() - .5);
                      var c = n * r[t.point.index];
                      t.charge += t.pointCharge = c, i += c * t.point.x, o += c * t.point.y;
                    }
                    t.cx = i / t.charge, t.cy = o / t.charge;
                  }(n = e.geom.quadtree(v), r, a), s = -1; ++s < S;) (d = v[s]).fixed || n.visit(b(d));
                  for (s = -1; ++s < S;) (d = v[s]).fixed ? (d.x = d.px, d.y = d.py) : (d.x -= (d.px - (d.px = d.x)) * c, d.y -= (d.py - (d.py = d.y)) * c);
                  l.tick({
                    type: "tick",
                    alpha: r
                  });
                }, s.nodes = function (e) {
                  return arguments.length ? (v = e, s) : v;
                }, s.links = function (e) {
                  return arguments.length ? (y = e, s) : y;
                }, s.size = function (e) {
                  return arguments.length ? (u = e, s) : u;
                }, s.linkDistance = function (e) {
                  return arguments.length ? (d = "function" == typeof e ? e : +e, s) : d;
                }, s.distance = s.linkDistance, s.linkStrength = function (e) {
                  return arguments.length ? (h = "function" == typeof e ? e : +e, s) : h;
                }, s.friction = function (e) {
                  return arguments.length ? (c = +e, s) : c;
                }, s.charge = function (e) {
                  return arguments.length ? (f = "function" == typeof e ? e : +e, s) : f;
                }, s.chargeDistance = function (e) {
                  return arguments.length ? (p = e * e, s) : Math.sqrt(p);
                }, s.gravity = function (e) {
                  return arguments.length ? (m = +e, s) : m;
                }, s.theta = function (e) {
                  return arguments.length ? (g = e * e, s) : Math.sqrt(g);
                }, s.alpha = function (e) {
                  return arguments.length ? (e = +e, r ? e > 0 ? r = e : (t.c = null, t.t = NaN, t = null, l.end({
                    type: "end",
                    alpha: r = 0
                  })) : e > 0 && (l.start({
                    type: "start",
                    alpha: r = e
                  }), t = bt(s.tick)), s) : r;
                }, s.start = function () {
                  var e,
                    t,
                    n,
                    r = v.length,
                    l = y.length,
                    c = u[0],
                    p = u[1];
                  for (e = 0; e < r; ++e) (n = v[e]).index = e, n.weight = 0;
                  for (e = 0; e < l; ++e) "number" == typeof (n = y[e]).source && (n.source = v[n.source]), "number" == typeof n.target && (n.target = v[n.target]), ++n.source.weight, ++n.target.weight;
                  for (e = 0; e < r; ++e) n = v[e], isNaN(n.x) && (n.x = m("x", c)), isNaN(n.y) && (n.y = m("y", p)), isNaN(n.px) && (n.px = n.x), isNaN(n.py) && (n.py = n.y);
                  if (i = [], "function" == typeof d) for (e = 0; e < l; ++e) i[e] = +d.call(this, y[e], e);else for (e = 0; e < l; ++e) i[e] = d;
                  if (o = [], "function" == typeof h) for (e = 0; e < l; ++e) o[e] = +h.call(this, y[e], e);else for (e = 0; e < l; ++e) o[e] = h;
                  if (a = [], "function" == typeof f) for (e = 0; e < r; ++e) a[e] = +f.call(this, v[e], e);else for (e = 0; e < r; ++e) a[e] = f;
                  function m(n, i) {
                    if (!t) {
                      for (t = new Array(r), u = 0; u < r; ++u) t[u] = [];
                      for (u = 0; u < l; ++u) {
                        var o = y[u];
                        t[o.source.index].push(o.target), t[o.target.index].push(o.source);
                      }
                    }
                    for (var a, s = t[e], u = -1, c = s.length; ++u < c;) if (!isNaN(a = s[u][n])) return a;
                    return Math.random() * i;
                  }
                  return s.resume();
                }, s.resume = function () {
                  return s.alpha(.1);
                }, s.stop = function () {
                  return s.alpha(0);
                }, s.drag = function () {
                  if (n || (n = e.behavior.drag().origin(k).on("dragstart.force", yo).on("drag.force", _).on("dragend.force", bo)), !arguments.length) return n;
                  this.on("mouseover.force", _o).on("mouseout.force", xo).call(n);
                }, e.rebind(s, l, "on");
              };
              var wo = 20,
                So = 1,
                Ao = 1 / 0;
              function Eo(t, n) {
                return e.rebind(t, n, "sort", "children", "value"), t.nodes = t, t.links = Oo, t;
              }
              function To(e, t) {
                for (var n = [e]; null != (e = n.pop());) if (t(e), (i = e.children) && (r = i.length)) for (var r, i; --r >= 0;) n.push(i[r]);
              }
              function Mo(e, t) {
                for (var n = [e], r = []; null != (e = n.pop());) if (r.push(e), (o = e.children) && (i = o.length)) for (var i, o, a = -1; ++a < i;) n.push(o[a]);
                for (; null != (e = r.pop());) t(e);
              }
              function Co(e) {
                return e.children;
              }
              function ko(e) {
                return e.value;
              }
              function Po(e, t) {
                return t.value - e.value;
              }
              function Oo(t) {
                return e.merge(t.map(function (e) {
                  return (e.children || []).map(function (t) {
                    return {
                      source: e,
                      target: t
                    };
                  });
                }));
              }
              e.layout.hierarchy = function () {
                var e = Po,
                  t = Co,
                  n = ko;
                function r(i) {
                  var o,
                    a = [i],
                    s = [];
                  for (i.depth = 0; null != (o = a.pop());) if (s.push(o), (u = t.call(r, o, o.depth)) && (l = u.length)) {
                    for (var l, u, c; --l >= 0;) a.push(c = u[l]), c.parent = o, c.depth = o.depth + 1;
                    n && (o.value = 0), o.children = u;
                  } else n && (o.value = +n.call(r, o, o.depth) || 0), delete o.children;
                  return Mo(i, function (t) {
                    var r, i;
                    e && (r = t.children) && r.sort(e), n && (i = t.parent) && (i.value += t.value);
                  }), s;
                }
                return r.sort = function (t) {
                  return arguments.length ? (e = t, r) : e;
                }, r.children = function (e) {
                  return arguments.length ? (t = e, r) : t;
                }, r.value = function (e) {
                  return arguments.length ? (n = e, r) : n;
                }, r.revalue = function (e) {
                  return n && (To(e, function (e) {
                    e.children && (e.value = 0);
                  }), Mo(e, function (e) {
                    var t;
                    e.children || (e.value = +n.call(r, e, e.depth) || 0), (t = e.parent) && (t.value += e.value);
                  })), e;
                }, r;
              }, e.layout.partition = function () {
                var t = e.layout.hierarchy(),
                  n = [1, 1];
                function r(e, r) {
                  var i = t.call(this, e, r);
                  return function e(t, n, r, i) {
                    var o = t.children;
                    if (t.x = n, t.y = t.depth * i, t.dx = r, t.dy = i, o && (a = o.length)) {
                      var a,
                        s,
                        l,
                        u = -1;
                      for (r = t.value ? r / t.value : 0; ++u < a;) e(s = o[u], n, l = s.value * r, i), n += l;
                    }
                  }(i[0], 0, n[0], n[1] / function e(t) {
                    var n = t.children,
                      r = 0;
                    if (n && (i = n.length)) for (var i, o = -1; ++o < i;) r = Math.max(r, e(n[o]));
                    return 1 + r;
                  }(i[0])), i;
                }
                return r.size = function (e) {
                  return arguments.length ? (n = e, r) : n;
                }, Eo(r, t);
              }, e.layout.pie = function () {
                var t = Number,
                  n = Ro,
                  r = 0,
                  i = Ae,
                  o = 0;
                function a(s) {
                  var l,
                    u = s.length,
                    c = s.map(function (e, n) {
                      return +t.call(a, e, n);
                    }),
                    d = +("function" == typeof r ? r.apply(this, arguments) : r),
                    h = ("function" == typeof i ? i.apply(this, arguments) : i) - d,
                    f = Math.min(Math.abs(h) / u, +("function" == typeof o ? o.apply(this, arguments) : o)),
                    p = f * (h < 0 ? -1 : 1),
                    m = e.sum(c),
                    g = m ? (h - u * p) / m : 0,
                    v = e.range(u),
                    y = [];
                  return null != n && v.sort(n === Ro ? function (e, t) {
                    return c[t] - c[e];
                  } : function (e, t) {
                    return n(s[e], s[t]);
                  }), v.forEach(function (e) {
                    y[e] = {
                      data: s[e],
                      value: l = c[e],
                      startAngle: d,
                      endAngle: d += l * g + p,
                      padAngle: f
                    };
                  }), y;
                }
                return a.value = function (e) {
                  return arguments.length ? (t = e, a) : t;
                }, a.sort = function (e) {
                  return arguments.length ? (n = e, a) : n;
                }, a.startAngle = function (e) {
                  return arguments.length ? (r = e, a) : r;
                }, a.endAngle = function (e) {
                  return arguments.length ? (i = e, a) : i;
                }, a.padAngle = function (e) {
                  return arguments.length ? (o = e, a) : o;
                }, a;
              };
              var Ro = {};
              function Io(e) {
                return e.x;
              }
              function jo(e) {
                return e.y;
              }
              function No(e, t, n) {
                e.y0 = t, e.y = n;
              }
              e.layout.stack = function () {
                var t = k,
                  n = Bo,
                  r = Fo,
                  i = No,
                  o = Io,
                  a = jo;
                function s(l, u) {
                  if (!(f = l.length)) return l;
                  var c = l.map(function (e, n) {
                      return t.call(s, e, n);
                    }),
                    d = c.map(function (e) {
                      return e.map(function (e, t) {
                        return [o.call(s, e, t), a.call(s, e, t)];
                      });
                    }),
                    h = n.call(s, d, u);
                  c = e.permute(c, h), d = e.permute(d, h);
                  var f,
                    p,
                    m,
                    g,
                    v = r.call(s, d, u),
                    y = c[0].length;
                  for (m = 0; m < y; ++m) for (i.call(s, c[0][m], g = v[m], d[0][m][1]), p = 1; p < f; ++p) i.call(s, c[p][m], g += d[p - 1][m][1], d[p][m][1]);
                  return l;
                }
                return s.values = function (e) {
                  return arguments.length ? (t = e, s) : t;
                }, s.order = function (e) {
                  return arguments.length ? (n = "function" == typeof e ? e : Lo.get(e) || Bo, s) : n;
                }, s.offset = function (e) {
                  return arguments.length ? (r = "function" == typeof e ? e : Do.get(e) || Fo, s) : r;
                }, s.x = function (e) {
                  return arguments.length ? (o = e, s) : o;
                }, s.y = function (e) {
                  return arguments.length ? (a = e, s) : a;
                }, s.out = function (e) {
                  return arguments.length ? (i = e, s) : i;
                }, s;
              };
              var Lo = e.map({
                  "inside-out": function insideOut(t) {
                    var n,
                      r,
                      i = t.length,
                      o = t.map(zo),
                      a = t.map(Uo),
                      s = e.range(i).sort(function (e, t) {
                        return o[e] - o[t];
                      }),
                      l = 0,
                      u = 0,
                      c = [],
                      d = [];
                    for (n = 0; n < i; ++n) r = s[n], l < u ? (l += a[r], c.push(r)) : (u += a[r], d.push(r));
                    return d.reverse().concat(c);
                  },
                  reverse: function reverse(t) {
                    return e.range(t.length).reverse();
                  },
                  default: Bo
                }),
                Do = e.map({
                  silhouette: function silhouette(e) {
                    var t,
                      n,
                      r,
                      i = e.length,
                      o = e[0].length,
                      a = [],
                      s = 0,
                      l = [];
                    for (n = 0; n < o; ++n) {
                      for (t = 0, r = 0; t < i; t++) r += e[t][n][1];
                      r > s && (s = r), a.push(r);
                    }
                    for (n = 0; n < o; ++n) l[n] = (s - a[n]) / 2;
                    return l;
                  },
                  wiggle: function wiggle(e) {
                    var t,
                      n,
                      r,
                      i,
                      o,
                      a,
                      s,
                      l,
                      u,
                      c = e.length,
                      d = e[0],
                      h = d.length,
                      f = [];
                    for (f[0] = l = u = 0, n = 1; n < h; ++n) {
                      for (t = 0, i = 0; t < c; ++t) i += e[t][n][1];
                      for (t = 0, o = 0, s = d[n][0] - d[n - 1][0]; t < c; ++t) {
                        for (r = 0, a = (e[t][n][1] - e[t][n - 1][1]) / (2 * s); r < t; ++r) a += (e[r][n][1] - e[r][n - 1][1]) / s;
                        o += a * e[t][n][1];
                      }
                      f[n] = l -= i ? o / i * s : 0, l < u && (u = l);
                    }
                    for (n = 0; n < h; ++n) f[n] -= u;
                    return f;
                  },
                  expand: function expand(e) {
                    var t,
                      n,
                      r,
                      i = e.length,
                      o = e[0].length,
                      a = 1 / i,
                      s = [];
                    for (n = 0; n < o; ++n) {
                      for (t = 0, r = 0; t < i; t++) r += e[t][n][1];
                      if (r) for (t = 0; t < i; t++) e[t][n][1] /= r;else for (t = 0; t < i; t++) e[t][n][1] = a;
                    }
                    for (n = 0; n < o; ++n) s[n] = 0;
                    return s;
                  },
                  zero: Fo
                });
              function Bo(t) {
                return e.range(t.length);
              }
              function Fo(e) {
                for (var t = -1, n = e[0].length, r = []; ++t < n;) r[t] = 0;
                return r;
              }
              function zo(e) {
                for (var t, n = 1, r = 0, i = e[0][1], o = e.length; n < o; ++n) (t = e[n][1]) > i && (r = n, i = t);
                return r;
              }
              function Uo(e) {
                return e.reduce(Go, 0);
              }
              function Go(e, t) {
                return e + t[1];
              }
              function Vo(e, t) {
                return Ho(e, Math.ceil(Math.log(t.length) / Math.LN2 + 1));
              }
              function Ho(e, t) {
                for (var n = -1, r = +e[0], i = (e[1] - r) / t, o = []; ++n <= t;) o[n] = i * n + r;
                return o;
              }
              function qo(t) {
                return [e.min(t), e.max(t)];
              }
              function Wo(e, t) {
                return e.value - t.value;
              }
              function $o(e, t) {
                var n = e._pack_next;
                e._pack_next = t, t._pack_prev = e, t._pack_next = n, n._pack_prev = t;
              }
              function Xo(e, t) {
                e._pack_next = t, t._pack_prev = e;
              }
              function Yo(e, t) {
                var n = t.x - e.x,
                  r = t.y - e.y,
                  i = e.r + t.r;
                return .999 * i * i > n * n + r * r;
              }
              function Ko(e) {
                if ((t = e.children) && (l = t.length)) {
                  var t,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    u = 1 / 0,
                    c = -1 / 0,
                    d = 1 / 0,
                    h = -1 / 0;
                  if (t.forEach(Zo), (n = t[0]).x = -n.r, n.y = 0, b(n), l > 1 && ((r = t[1]).x = r.r, r.y = 0, b(r), l > 2)) for (Jo(n, r, i = t[2]), b(i), $o(n, i), n._pack_prev = i, $o(i, r), r = n._pack_next, o = 3; o < l; o++) {
                    Jo(n, r, i = t[o]);
                    var f = 0,
                      p = 1,
                      m = 1;
                    for (a = r._pack_next; a !== r; a = a._pack_next, p++) if (Yo(a, i)) {
                      f = 1;
                      break;
                    }
                    if (1 == f) for (s = n._pack_prev; s !== a._pack_prev && !Yo(s, i); s = s._pack_prev, m++);
                    f ? (p < m || p == m && r.r < n.r ? Xo(n, r = a) : Xo(n = s, r), o--) : ($o(n, i), r = i, b(i));
                  }
                  var g = (u + c) / 2,
                    v = (d + h) / 2,
                    y = 0;
                  for (o = 0; o < l; o++) (i = t[o]).x -= g, i.y -= v, y = Math.max(y, i.r + Math.sqrt(i.x * i.x + i.y * i.y));
                  e.r = y, t.forEach(Qo);
                }
                function b(e) {
                  u = Math.min(e.x - e.r, u), c = Math.max(e.x + e.r, c), d = Math.min(e.y - e.r, d), h = Math.max(e.y + e.r, h);
                }
              }
              function Zo(e) {
                e._pack_next = e._pack_prev = e;
              }
              function Qo(e) {
                delete e._pack_next, delete e._pack_prev;
              }
              function Jo(e, t, n) {
                var r = e.r + n.r,
                  i = t.x - e.x,
                  o = t.y - e.y;
                if (r && (i || o)) {
                  var a = t.r + n.r,
                    s = i * i + o * o,
                    l = .5 + ((r *= r) - (a *= a)) / (2 * s),
                    u = Math.sqrt(Math.max(0, 2 * a * (r + s) - (r -= s) * r - a * a)) / (2 * s);
                  n.x = e.x + l * i + u * o, n.y = e.y + l * o - u * i;
                } else n.x = e.x + r, n.y = e.y;
              }
              function ea(e, t) {
                return e.parent == t.parent ? 1 : 2;
              }
              function ta(e) {
                var t = e.children;
                return t.length ? t[0] : e.t;
              }
              function na(e) {
                var t,
                  n = e.children;
                return (t = n.length) ? n[t - 1] : e.t;
              }
              function ra(e, t, n) {
                var r = n / (t.i - e.i);
                t.c -= r, t.s += n, e.c += r, t.z += n, t.m += n;
              }
              function ia(e, t, n) {
                return e.a.parent === t.parent ? e.a : n;
              }
              function oa(e) {
                return {
                  x: e.x,
                  y: e.y,
                  dx: e.dx,
                  dy: e.dy
                };
              }
              function aa(e, t) {
                var n = e.x + t[3],
                  r = e.y + t[0],
                  i = e.dx - t[1] - t[3],
                  o = e.dy - t[0] - t[2];
                return i < 0 && (n += i / 2, i = 0), o < 0 && (r += o / 2, o = 0), {
                  x: n,
                  y: r,
                  dx: i,
                  dy: o
                };
              }
              function sa(e) {
                var t = e[0],
                  n = e[e.length - 1];
                return t < n ? [t, n] : [n, t];
              }
              function la(e) {
                return e.rangeExtent ? e.rangeExtent() : sa(e.range());
              }
              function ua(e, t, n, r) {
                var i = n(e[0], e[1]),
                  o = r(t[0], t[1]);
                return function (e) {
                  return o(i(e));
                };
              }
              function ca(e, t) {
                var n,
                  r = 0,
                  i = e.length - 1,
                  o = e[r],
                  a = e[i];
                return a < o && (n = r, r = i, i = n, n = o, o = a, a = n), e[r] = t.floor(o), e[i] = t.ceil(a), e;
              }
              function da(e) {
                return e ? {
                  floor: function floor(t) {
                    return Math.floor(t / e) * e;
                  },
                  ceil: function ceil(t) {
                    return Math.ceil(t / e) * e;
                  }
                } : ha;
              }
              e.layout.histogram = function () {
                var t = !0,
                  n = Number,
                  r = qo,
                  i = Vo;
                function o(o, a) {
                  for (var s, l, u = [], c = o.map(n, this), d = r.call(this, c, a), h = i.call(this, d, c, a), f = (a = -1, c.length), p = h.length - 1, m = t ? 1 : 1 / f; ++a < p;) (s = u[a] = []).dx = h[a + 1] - (s.x = h[a]), s.y = 0;
                  if (p > 0) for (a = -1; ++a < f;) (l = c[a]) >= d[0] && l <= d[1] && ((s = u[e.bisect(h, l, 1, p) - 1]).y += m, s.push(o[a]));
                  return u;
                }
                return o.value = function (e) {
                  return arguments.length ? (n = e, o) : n;
                }, o.range = function (e) {
                  return arguments.length ? (r = dt(e), o) : r;
                }, o.bins = function (e) {
                  return arguments.length ? (i = "number" == typeof e ? function (t) {
                    return Ho(t, e);
                  } : dt(e), o) : i;
                }, o.frequency = function (e) {
                  return arguments.length ? (t = !!e, o) : t;
                }, o;
              }, e.layout.pack = function () {
                var t,
                  n = e.layout.hierarchy().sort(Wo),
                  r = 0,
                  i = [1, 1];
                function o(e, o) {
                  var a = n.call(this, e, o),
                    s = a[0],
                    l = i[0],
                    u = i[1],
                    c = null == t ? Math.sqrt : "function" == typeof t ? t : function () {
                      return t;
                    };
                  if (s.x = s.y = 0, Mo(s, function (e) {
                    e.r = +c(e.value);
                  }), Mo(s, Ko), r) {
                    var d = r * (t ? 1 : Math.max(2 * s.r / l, 2 * s.r / u)) / 2;
                    Mo(s, function (e) {
                      e.r += d;
                    }), Mo(s, Ko), Mo(s, function (e) {
                      e.r -= d;
                    });
                  }
                  return function e(t, n, r, i) {
                    var o = t.children;
                    if (t.x = n += i * t.x, t.y = r += i * t.y, t.r *= i, o) for (var a = -1, s = o.length; ++a < s;) e(o[a], n, r, i);
                  }(s, l / 2, u / 2, t ? 1 : 1 / Math.max(2 * s.r / l, 2 * s.r / u)), a;
                }
                return o.size = function (e) {
                  return arguments.length ? (i = e, o) : i;
                }, o.radius = function (e) {
                  return arguments.length ? (t = null == e || "function" == typeof e ? e : +e, o) : t;
                }, o.padding = function (e) {
                  return arguments.length ? (r = +e, o) : r;
                }, Eo(o, n);
              }, e.layout.tree = function () {
                var t = e.layout.hierarchy().sort(null).value(null),
                  n = ea,
                  r = [1, 1],
                  i = null;
                function o(e, o) {
                  var u = t.call(this, e, o),
                    c = u[0],
                    d = function (e) {
                      for (var t, n = {
                          A: null,
                          children: [e]
                        }, r = [n]; null != (t = r.pop());) for (var i, o = t.children, a = 0, s = o.length; a < s; ++a) r.push((o[a] = i = {
                        _: o[a],
                        parent: t,
                        children: (i = o[a].children) && i.slice() || [],
                        A: null,
                        a: null,
                        z: 0,
                        m: 0,
                        c: 0,
                        s: 0,
                        t: null,
                        i: a
                      }).a = i);
                      return n.children[0];
                    }(c);
                  if (Mo(d, a), d.parent.m = -d.z, To(d, s), i) To(c, l);else {
                    var h = c,
                      f = c,
                      p = c;
                    To(c, function (e) {
                      e.x < h.x && (h = e), e.x > f.x && (f = e), e.depth > p.depth && (p = e);
                    });
                    var m = n(h, f) / 2 - h.x,
                      g = r[0] / (f.x + n(f, h) / 2 + m),
                      v = r[1] / (p.depth || 1);
                    To(c, function (e) {
                      e.x = (e.x + m) * g, e.y = e.depth * v;
                    });
                  }
                  return u;
                }
                function a(e) {
                  var t = e.children,
                    r = e.parent.children,
                    i = e.i ? r[e.i - 1] : null;
                  if (t.length) {
                    !function (e) {
                      for (var t, n = 0, r = 0, i = e.children, o = i.length; --o >= 0;) (t = i[o]).z += n, t.m += n, n += t.s + (r += t.c);
                    }(e);
                    var o = (t[0].z + t[t.length - 1].z) / 2;
                    i ? (e.z = i.z + n(e._, i._), e.m = e.z - o) : e.z = o;
                  } else i && (e.z = i.z + n(e._, i._));
                  e.parent.A = function (e, t, r) {
                    if (t) {
                      for (var i, o = e, a = e, s = t, l = o.parent.children[0], u = o.m, c = a.m, d = s.m, h = l.m; s = na(s), o = ta(o), s && o;) l = ta(l), (a = na(a)).a = e, (i = s.z + d - o.z - u + n(s._, o._)) > 0 && (ra(ia(s, e, r), e, i), u += i, c += i), d += s.m, u += o.m, h += l.m, c += a.m;
                      s && !na(a) && (a.t = s, a.m += d - c), o && !ta(l) && (l.t = o, l.m += u - h, r = e);
                    }
                    return r;
                  }(e, i, e.parent.A || r[0]);
                }
                function s(e) {
                  e._.x = e.z + e.parent.m, e.m += e.parent.m;
                }
                function l(e) {
                  e.x *= r[0], e.y = e.depth * r[1];
                }
                return o.separation = function (e) {
                  return arguments.length ? (n = e, o) : n;
                }, o.size = function (e) {
                  return arguments.length ? (i = null == (r = e) ? l : null, o) : i ? null : r;
                }, o.nodeSize = function (e) {
                  return arguments.length ? (i = null == (r = e) ? null : l, o) : i ? r : null;
                }, Eo(o, t);
              }, e.layout.cluster = function () {
                var t = e.layout.hierarchy().sort(null).value(null),
                  n = ea,
                  r = [1, 1],
                  i = !1;
                function o(o, a) {
                  var s,
                    l = t.call(this, o, a),
                    u = l[0],
                    c = 0;
                  Mo(u, function (t) {
                    var r = t.children;
                    r && r.length ? (t.x = function (e) {
                      return e.reduce(function (e, t) {
                        return e + t.x;
                      }, 0) / e.length;
                    }(r), t.y = function (t) {
                      return 1 + e.max(t, function (e) {
                        return e.y;
                      });
                    }(r)) : (t.x = s ? c += n(t, s) : 0, t.y = 0, s = t);
                  });
                  var d = function e(t) {
                      var n = t.children;
                      return n && n.length ? e(n[0]) : t;
                    }(u),
                    h = function e(t) {
                      var n,
                        r = t.children;
                      return r && (n = r.length) ? e(r[n - 1]) : t;
                    }(u),
                    f = d.x - n(d, h) / 2,
                    p = h.x + n(h, d) / 2;
                  return Mo(u, i ? function (e) {
                    e.x = (e.x - u.x) * r[0], e.y = (u.y - e.y) * r[1];
                  } : function (e) {
                    e.x = (e.x - f) / (p - f) * r[0], e.y = (1 - (u.y ? e.y / u.y : 1)) * r[1];
                  }), l;
                }
                return o.separation = function (e) {
                  return arguments.length ? (n = e, o) : n;
                }, o.size = function (e) {
                  return arguments.length ? (i = null == (r = e), o) : i ? null : r;
                }, o.nodeSize = function (e) {
                  return arguments.length ? (i = null != (r = e), o) : i ? r : null;
                }, Eo(o, t);
              }, e.layout.treemap = function () {
                var t,
                  n = e.layout.hierarchy(),
                  r = Math.round,
                  i = [1, 1],
                  o = null,
                  a = oa,
                  s = !1,
                  l = "squarify",
                  u = .5 * (1 + Math.sqrt(5));
                function c(e, t) {
                  for (var n, r, i = -1, o = e.length; ++i < o;) r = (n = e[i]).value * (t < 0 ? 0 : t), n.area = isNaN(r) || r <= 0 ? 0 : r;
                }
                function d(e) {
                  var t = e.children;
                  if (t && t.length) {
                    var n,
                      r,
                      i,
                      o = a(e),
                      s = [],
                      u = t.slice(),
                      h = 1 / 0,
                      m = "slice" === l ? o.dx : "dice" === l ? o.dy : "slice-dice" === l ? 1 & e.depth ? o.dy : o.dx : Math.min(o.dx, o.dy);
                    for (c(u, o.dx * o.dy / e.value), s.area = 0; (i = u.length) > 0;) s.push(n = u[i - 1]), s.area += n.area, "squarify" !== l || (r = f(s, m)) <= h ? (u.pop(), h = r) : (s.area -= s.pop().area, p(s, m, o, !1), m = Math.min(o.dx, o.dy), s.length = s.area = 0, h = 1 / 0);
                    s.length && (p(s, m, o, !0), s.length = s.area = 0), t.forEach(d);
                  }
                }
                function h(e) {
                  var t = e.children;
                  if (t && t.length) {
                    var n,
                      r = a(e),
                      i = t.slice(),
                      o = [];
                    for (c(i, r.dx * r.dy / e.value), o.area = 0; n = i.pop();) o.push(n), o.area += n.area, null != n.z && (p(o, n.z ? r.dx : r.dy, r, !i.length), o.length = o.area = 0);
                    t.forEach(h);
                  }
                }
                function f(e, t) {
                  for (var n, r = e.area, i = 0, o = 1 / 0, a = -1, s = e.length; ++a < s;) (n = e[a].area) && (n < o && (o = n), n > i && (i = n));
                  return t *= t, (r *= r) ? Math.max(t * i * u / r, r / (t * o * u)) : 1 / 0;
                }
                function p(e, t, n, i) {
                  var o,
                    a = -1,
                    s = e.length,
                    l = n.x,
                    u = n.y,
                    c = t ? r(e.area / t) : 0;
                  if (t == n.dx) {
                    for ((i || c > n.dy) && (c = n.dy); ++a < s;) (o = e[a]).x = l, o.y = u, o.dy = c, l += o.dx = Math.min(n.x + n.dx - l, c ? r(o.area / c) : 0);
                    o.z = !0, o.dx += n.x + n.dx - l, n.y += c, n.dy -= c;
                  } else {
                    for ((i || c > n.dx) && (c = n.dx); ++a < s;) (o = e[a]).x = l, o.y = u, o.dx = c, u += o.dy = Math.min(n.y + n.dy - u, c ? r(o.area / c) : 0);
                    o.z = !1, o.dy += n.y + n.dy - u, n.x += c, n.dx -= c;
                  }
                }
                function m(e) {
                  var r = t || n(e),
                    o = r[0];
                  return o.x = o.y = 0, o.value ? (o.dx = i[0], o.dy = i[1]) : o.dx = o.dy = 0, t && n.revalue(o), c([o], o.dx * o.dy / o.value), (t ? h : d)(o), s && (t = r), r;
                }
                return m.size = function (e) {
                  return arguments.length ? (i = e, m) : i;
                }, m.padding = function (e) {
                  if (!arguments.length) return o;
                  function t(t) {
                    return aa(t, e);
                  }
                  var n;
                  return a = null == (o = e) ? oa : "function" == (n = typeof e) ? function (t) {
                    var n = e.call(m, t, t.depth);
                    return null == n ? oa(t) : aa(t, "number" == typeof n ? [n, n, n, n] : n);
                  } : "number" === n ? (e = [e, e, e, e], t) : t, m;
                }, m.round = function (e) {
                  return arguments.length ? (r = e ? Math.round : Number, m) : r != Number;
                }, m.sticky = function (e) {
                  return arguments.length ? (s = e, t = null, m) : s;
                }, m.ratio = function (e) {
                  return arguments.length ? (u = e, m) : u;
                }, m.mode = function (e) {
                  return arguments.length ? (l = e + "", m) : l;
                }, Eo(m, n);
              }, e.random = {
                normal: function normal(e, t) {
                  var n = arguments.length;
                  return n < 2 && (t = 1), n < 1 && (e = 0), function () {
                    var n, r, i;
                    do {
                      i = (n = 2 * Math.random() - 1) * n + (r = 2 * Math.random() - 1) * r;
                    } while (!i || i > 1);
                    return e + t * n * Math.sqrt(-2 * Math.log(i) / i);
                  };
                },
                logNormal: function logNormal() {
                  var t = e.random.normal.apply(e, arguments);
                  return function () {
                    return Math.exp(t());
                  };
                },
                bates: function bates(t) {
                  var n = e.random.irwinHall(t);
                  return function () {
                    return n() / t;
                  };
                },
                irwinHall: function irwinHall(e) {
                  return function () {
                    for (var t = 0, n = 0; n < e; n++) t += Math.random();
                    return t;
                  };
                }
              }, e.scale = {};
              var ha = {
                floor: k,
                ceil: k
              };
              function fa(t, n, r, i) {
                var o = [],
                  a = [],
                  s = 0,
                  l = Math.min(t.length, n.length) - 1;
                for (t[l] < t[0] && (t = t.slice().reverse(), n = n.slice().reverse()); ++s <= l;) o.push(r(t[s - 1], t[s])), a.push(i(n[s - 1], n[s]));
                return function (n) {
                  var r = e.bisect(t, n, 1, l) - 1;
                  return a[r](o[r](n));
                };
              }
              function pa(t, n) {
                return e.rebind(t, n, "range", "rangeRound", "interpolate", "clamp");
              }
              function ma(e, t) {
                return ca(e, da(ga(e, t)[2])), ca(e, da(ga(e, t)[2])), e;
              }
              function ga(e, t) {
                null == t && (t = 10);
                var n = sa(e),
                  r = n[1] - n[0],
                  i = Math.pow(10, Math.floor(Math.log(r / t) / Math.LN10)),
                  o = t / r * i;
                return o <= .15 ? i *= 10 : o <= .35 ? i *= 5 : o <= .75 && (i *= 2), n[0] = Math.ceil(n[0] / i) * i, n[1] = Math.floor(n[1] / i) * i + .5 * i, n[2] = i, n;
              }
              function va(t, n) {
                return e.range.apply(e, ga(t, n));
              }
              function ya(t, n, r) {
                var i = ga(t, n);
                if (r) {
                  var o = Tt.exec(r);
                  if (o.shift(), "s" === o[8]) {
                    var a = e.formatPrefix(Math.max(y(i[0]), y(i[1])));
                    return o[7] || (o[7] = "." + _a(a.scale(i[2]))), o[8] = "f", r = e.format(o.join("")), function (e) {
                      return r(a.scale(e)) + a.symbol;
                    };
                  }
                  o[7] || (o[7] = "." + function (e, t) {
                    var n = _a(t[2]);
                    return e in ba ? Math.abs(n - _a(Math.max(y(t[0]), y(t[1])))) + +("e" !== e) : n - 2 * ("%" === e);
                  }(o[8], i)), r = o.join("");
                } else r = ",." + _a(i[2]) + "f";
                return e.format(r);
              }
              e.scale.linear = function () {
                return function e(t, n, r, i) {
                  var o, a;
                  function s() {
                    var e = Math.min(t.length, n.length) > 2 ? fa : ua,
                      s = i ? mo : po;
                    return o = e(t, n, s, r), a = e(n, t, s, Wi), l;
                  }
                  function l(e) {
                    return o(e);
                  }
                  return l.invert = function (e) {
                    return a(e);
                  }, l.domain = function (e) {
                    return arguments.length ? (t = e.map(Number), s()) : t;
                  }, l.range = function (e) {
                    return arguments.length ? (n = e, s()) : n;
                  }, l.rangeRound = function (e) {
                    return l.range(e).interpolate(ao);
                  }, l.clamp = function (e) {
                    return arguments.length ? (i = e, s()) : i;
                  }, l.interpolate = function (e) {
                    return arguments.length ? (r = e, s()) : r;
                  }, l.ticks = function (e) {
                    return va(t, e);
                  }, l.tickFormat = function (e, n) {
                    return ya(t, e, n);
                  }, l.nice = function (e) {
                    return ma(t, e), s();
                  }, l.copy = function () {
                    return e(t, n, r, i);
                  }, s();
                }([0, 1], [0, 1], Wi, !1);
              };
              var ba = {
                s: 1,
                g: 1,
                p: 1,
                r: 1,
                e: 1
              };
              function _a(e) {
                return -Math.floor(Math.log(e) / Math.LN10 + .01);
              }
              e.scale.log = function () {
                return function t(n, r, i, o) {
                  function a(e) {
                    return (i ? Math.log(e < 0 ? 0 : e) : -Math.log(e > 0 ? 0 : -e)) / Math.log(r);
                  }
                  function s(e) {
                    return i ? Math.pow(r, e) : -Math.pow(r, -e);
                  }
                  function l(e) {
                    return n(a(e));
                  }
                  return l.invert = function (e) {
                    return s(n.invert(e));
                  }, l.domain = function (e) {
                    return arguments.length ? (i = e[0] >= 0, n.domain((o = e.map(Number)).map(a)), l) : o;
                  }, l.base = function (e) {
                    return arguments.length ? (r = +e, n.domain(o.map(a)), l) : r;
                  }, l.nice = function () {
                    var e = ca(o.map(a), i ? Math : wa);
                    return n.domain(e), o = e.map(s), l;
                  }, l.ticks = function () {
                    var e = sa(o),
                      t = [],
                      n = e[0],
                      l = e[1],
                      u = Math.floor(a(n)),
                      c = Math.ceil(a(l)),
                      d = r % 1 ? 2 : r;
                    if (isFinite(c - u)) {
                      if (i) {
                        for (; u < c; u++) for (var h = 1; h < d; h++) t.push(s(u) * h);
                        t.push(s(u));
                      } else for (t.push(s(u)); u++ < c;) for (h = d - 1; h > 0; h--) t.push(s(u) * h);
                      for (u = 0; t[u] < n; u++);
                      for (c = t.length; t[c - 1] > l; c--);
                      t = t.slice(u, c);
                    }
                    return t;
                  }, l.tickFormat = function (t, n) {
                    if (!arguments.length) return xa;
                    arguments.length < 2 ? n = xa : "function" != typeof n && (n = e.format(n));
                    var i = Math.max(1, r * t / l.ticks().length);
                    return function (e) {
                      var t = e / s(Math.round(a(e)));
                      return t * r < r - .5 && (t *= r), t <= i ? n(e) : "";
                    };
                  }, l.copy = function () {
                    return t(n.copy(), r, i, o);
                  }, pa(l, n);
                }(e.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
              };
              var xa = e.format(".0e"),
                wa = {
                  floor: function floor(e) {
                    return -Math.ceil(-e);
                  },
                  ceil: function ceil(e) {
                    return -Math.floor(-e);
                  }
                };
              function Sa(e) {
                return function (t) {
                  return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
                };
              }
              e.scale.pow = function () {
                return function e(t, n, r) {
                  var i = Sa(n),
                    o = Sa(1 / n);
                  function a(e) {
                    return t(i(e));
                  }
                  return a.invert = function (e) {
                    return o(t.invert(e));
                  }, a.domain = function (e) {
                    return arguments.length ? (t.domain((r = e.map(Number)).map(i)), a) : r;
                  }, a.ticks = function (e) {
                    return va(r, e);
                  }, a.tickFormat = function (e, t) {
                    return ya(r, e, t);
                  }, a.nice = function (e) {
                    return a.domain(ma(r, e));
                  }, a.exponent = function (e) {
                    return arguments.length ? (i = Sa(n = e), o = Sa(1 / n), t.domain(r.map(i)), a) : n;
                  }, a.copy = function () {
                    return e(t.copy(), n, r);
                  }, pa(a, t);
                }(e.scale.linear(), 1, [0, 1]);
              }, e.scale.sqrt = function () {
                return e.scale.pow().exponent(.5);
              }, e.scale.ordinal = function () {
                return function t(n, r) {
                  var i, o, a;
                  function s(e) {
                    return o[((i.get(e) || ("range" === r.t ? i.set(e, n.push(e)) : NaN)) - 1) % o.length];
                  }
                  function l(t, r) {
                    return e.range(n.length).map(function (e) {
                      return t + r * e;
                    });
                  }
                  return s.domain = function (e) {
                    if (!arguments.length) return n;
                    n = [], i = new _();
                    for (var t, o = -1, a = e.length; ++o < a;) i.has(t = e[o]) || i.set(t, n.push(t));
                    return s[r.t].apply(s, r.a);
                  }, s.range = function (e) {
                    return arguments.length ? (o = e, a = 0, r = {
                      t: "range",
                      a: arguments
                    }, s) : o;
                  }, s.rangePoints = function (e, t) {
                    arguments.length < 2 && (t = 0);
                    var i = e[0],
                      u = e[1],
                      c = n.length < 2 ? (i = (i + u) / 2, 0) : (u - i) / (n.length - 1 + t);
                    return o = l(i + c * t / 2, c), a = 0, r = {
                      t: "rangePoints",
                      a: arguments
                    }, s;
                  }, s.rangeRoundPoints = function (e, t) {
                    arguments.length < 2 && (t = 0);
                    var i = e[0],
                      u = e[1],
                      c = n.length < 2 ? (i = u = Math.round((i + u) / 2), 0) : (u - i) / (n.length - 1 + t) | 0;
                    return o = l(i + Math.round(c * t / 2 + (u - i - (n.length - 1 + t) * c) / 2), c), a = 0, r = {
                      t: "rangeRoundPoints",
                      a: arguments
                    }, s;
                  }, s.rangeBands = function (e, t, i) {
                    arguments.length < 2 && (t = 0), arguments.length < 3 && (i = t);
                    var u = e[1] < e[0],
                      c = e[u - 0],
                      d = e[1 - u],
                      h = (d - c) / (n.length - t + 2 * i);
                    return o = l(c + h * i, h), u && o.reverse(), a = h * (1 - t), r = {
                      t: "rangeBands",
                      a: arguments
                    }, s;
                  }, s.rangeRoundBands = function (e, t, i) {
                    arguments.length < 2 && (t = 0), arguments.length < 3 && (i = t);
                    var u = e[1] < e[0],
                      c = e[u - 0],
                      d = e[1 - u],
                      h = Math.floor((d - c) / (n.length - t + 2 * i));
                    return o = l(c + Math.round((d - c - (n.length - t) * h) / 2), h), u && o.reverse(), a = Math.round(h * (1 - t)), r = {
                      t: "rangeRoundBands",
                      a: arguments
                    }, s;
                  }, s.rangeBand = function () {
                    return a;
                  }, s.rangeExtent = function () {
                    return sa(r.a[0]);
                  }, s.copy = function () {
                    return t(n, r);
                  }, s.domain(n);
                }([], {
                  t: "range",
                  a: [[]]
                });
              }, e.scale.category10 = function () {
                return e.scale.ordinal().range(Aa);
              }, e.scale.category20 = function () {
                return e.scale.ordinal().range(Ea);
              }, e.scale.category20b = function () {
                return e.scale.ordinal().range(Ta);
              }, e.scale.category20c = function () {
                return e.scale.ordinal().range(Ma);
              };
              var Aa = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(nt),
                Ea = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(nt),
                Ta = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(nt),
                Ma = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(nt);
              function Ca() {
                return 0;
              }
              e.scale.quantile = function () {
                return function t(n, r) {
                  var i;
                  function o() {
                    var t = 0,
                      o = r.length;
                    for (i = []; ++t < o;) i[t - 1] = e.quantile(n, t / o);
                    return a;
                  }
                  function a(t) {
                    if (!isNaN(t = +t)) return r[e.bisect(i, t)];
                  }
                  return a.domain = function (e) {
                    return arguments.length ? (n = e.map(f).filter(p).sort(h), o()) : n;
                  }, a.range = function (e) {
                    return arguments.length ? (r = e, o()) : r;
                  }, a.quantiles = function () {
                    return i;
                  }, a.invertExtent = function (e) {
                    return (e = r.indexOf(e)) < 0 ? [NaN, NaN] : [e > 0 ? i[e - 1] : n[0], e < i.length ? i[e] : n[n.length - 1]];
                  }, a.copy = function () {
                    return t(n, r);
                  }, o();
                }([], []);
              }, e.scale.quantize = function () {
                return function e(t, n, r) {
                  var i, o;
                  function a(e) {
                    return r[Math.max(0, Math.min(o, Math.floor(i * (e - t))))];
                  }
                  function s() {
                    return i = r.length / (n - t), o = r.length - 1, a;
                  }
                  return a.domain = function (e) {
                    return arguments.length ? (t = +e[0], n = +e[e.length - 1], s()) : [t, n];
                  }, a.range = function (e) {
                    return arguments.length ? (r = e, s()) : r;
                  }, a.invertExtent = function (e) {
                    return [e = (e = r.indexOf(e)) < 0 ? NaN : e / i + t, e + 1 / i];
                  }, a.copy = function () {
                    return e(t, n, r);
                  }, s();
                }(0, 1, [0, 1]);
              }, e.scale.threshold = function () {
                return function t(n, r) {
                  function i(t) {
                    if (t <= t) return r[e.bisect(n, t)];
                  }
                  return i.domain = function (e) {
                    return arguments.length ? (n = e, i) : n;
                  }, i.range = function (e) {
                    return arguments.length ? (r = e, i) : r;
                  }, i.invertExtent = function (e) {
                    return e = r.indexOf(e), [n[e - 1], n[e]];
                  }, i.copy = function () {
                    return t(n, r);
                  }, i;
                }([.5], [0, 1]);
              }, e.scale.identity = function () {
                return function e(t) {
                  function n(e) {
                    return +e;
                  }
                  return n.invert = n, n.domain = n.range = function (e) {
                    return arguments.length ? (t = e.map(n), n) : t;
                  }, n.ticks = function (e) {
                    return va(t, e);
                  }, n.tickFormat = function (e, n) {
                    return ya(t, e, n);
                  }, n.copy = function () {
                    return e(t);
                  }, n;
                }([0, 1]);
              }, e.svg = {}, e.svg.arc = function () {
                var e = Pa,
                  t = Oa,
                  n = Ca,
                  r = ka,
                  i = Ra,
                  o = Ia,
                  a = ja;
                function s() {
                  var s = Math.max(0, +e.apply(this, arguments)),
                    u = Math.max(0, +t.apply(this, arguments)),
                    c = i.apply(this, arguments) - Te,
                    d = o.apply(this, arguments) - Te,
                    h = Math.abs(d - c),
                    f = c > d ? 0 : 1;
                  if (u < s && (p = u, u = s, s = p), h >= Ee) return l(u, f) + (s ? l(s, 1 - f) : "") + "Z";
                  var p,
                    m,
                    g,
                    v,
                    y,
                    b,
                    _,
                    x,
                    w,
                    S,
                    A,
                    E,
                    T = 0,
                    M = 0,
                    C = [];
                  if ((v = (+a.apply(this, arguments) || 0) / 2) && (g = r === ka ? Math.sqrt(s * s + u * u) : +r.apply(this, arguments), f || (M *= -1), u && (M = Re(g / u * Math.sin(v))), s && (T = Re(g / s * Math.sin(v)))), u) {
                    y = u * Math.cos(c + M), b = u * Math.sin(c + M), _ = u * Math.cos(d - M), x = u * Math.sin(d - M);
                    var k = Math.abs(d - c - 2 * M) <= Se ? 0 : 1;
                    if (M && Na(y, b, _, x) === f ^ k) {
                      var P = (c + d) / 2;
                      y = u * Math.cos(P), b = u * Math.sin(P), _ = x = null;
                    }
                  } else y = b = 0;
                  if (s) {
                    w = s * Math.cos(d - T), S = s * Math.sin(d - T), A = s * Math.cos(c + T), E = s * Math.sin(c + T);
                    var O = Math.abs(c - d + 2 * T) <= Se ? 0 : 1;
                    if (T && Na(w, S, A, E) === 1 - f ^ O) {
                      var R = (c + d) / 2;
                      w = s * Math.cos(R), S = s * Math.sin(R), A = E = null;
                    }
                  } else w = S = 0;
                  if (h > xe && (p = Math.min(Math.abs(u - s) / 2, +n.apply(this, arguments))) > .001) {
                    m = s < u ^ f ? 0 : 1;
                    var I = p,
                      j = p;
                    if (h < Se) {
                      var N = null == A ? [w, S] : null == _ ? [y, b] : ii([y, b], [A, E], [_, x], [w, S]),
                        L = y - N[0],
                        D = b - N[1],
                        B = _ - N[0],
                        F = x - N[1],
                        z = 1 / Math.sin(Math.acos((L * B + D * F) / (Math.sqrt(L * L + D * D) * Math.sqrt(B * B + F * F))) / 2),
                        U = Math.sqrt(N[0] * N[0] + N[1] * N[1]);
                      j = Math.min(p, (s - U) / (z - 1)), I = Math.min(p, (u - U) / (z + 1));
                    }
                    if (null != _) {
                      var G = La(null == A ? [w, S] : [A, E], [y, b], u, I, f),
                        V = La([_, x], [w, S], u, I, f);
                      p === I ? C.push("M", G[0], "A", I, ",", I, " 0 0,", m, " ", G[1], "A", u, ",", u, " 0 ", 1 - f ^ Na(G[1][0], G[1][1], V[1][0], V[1][1]), ",", f, " ", V[1], "A", I, ",", I, " 0 0,", m, " ", V[0]) : C.push("M", G[0], "A", I, ",", I, " 0 1,", m, " ", V[0]);
                    } else C.push("M", y, ",", b);
                    if (null != A) {
                      var H = La([y, b], [A, E], s, -j, f),
                        q = La([w, S], null == _ ? [y, b] : [_, x], s, -j, f);
                      p === j ? C.push("L", q[0], "A", j, ",", j, " 0 0,", m, " ", q[1], "A", s, ",", s, " 0 ", f ^ Na(q[1][0], q[1][1], H[1][0], H[1][1]), ",", 1 - f, " ", H[1], "A", j, ",", j, " 0 0,", m, " ", H[0]) : C.push("L", q[0], "A", j, ",", j, " 0 0,", m, " ", H[0]);
                    } else C.push("L", w, ",", S);
                  } else C.push("M", y, ",", b), null != _ && C.push("A", u, ",", u, " 0 ", k, ",", f, " ", _, ",", x), C.push("L", w, ",", S), null != A && C.push("A", s, ",", s, " 0 ", O, ",", 1 - f, " ", A, ",", E);
                  return C.push("Z"), C.join("");
                }
                function l(e, t) {
                  return "M0," + e + "A" + e + "," + e + " 0 1," + t + " 0," + -e + "A" + e + "," + e + " 0 1," + t + " 0," + e;
                }
                return s.innerRadius = function (t) {
                  return arguments.length ? (e = dt(t), s) : e;
                }, s.outerRadius = function (e) {
                  return arguments.length ? (t = dt(e), s) : t;
                }, s.cornerRadius = function (e) {
                  return arguments.length ? (n = dt(e), s) : n;
                }, s.padRadius = function (e) {
                  return arguments.length ? (r = e == ka ? ka : dt(e), s) : r;
                }, s.startAngle = function (e) {
                  return arguments.length ? (i = dt(e), s) : i;
                }, s.endAngle = function (e) {
                  return arguments.length ? (o = dt(e), s) : o;
                }, s.padAngle = function (e) {
                  return arguments.length ? (a = dt(e), s) : a;
                }, s.centroid = function () {
                  var n = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2,
                    r = (+i.apply(this, arguments) + +o.apply(this, arguments)) / 2 - Te;
                  return [Math.cos(r) * n, Math.sin(r) * n];
                }, s;
              };
              var ka = "auto";
              function Pa(e) {
                return e.innerRadius;
              }
              function Oa(e) {
                return e.outerRadius;
              }
              function Ra(e) {
                return e.startAngle;
              }
              function Ia(e) {
                return e.endAngle;
              }
              function ja(e) {
                return e && e.padAngle;
              }
              function Na(e, t, n, r) {
                return (e - n) * t - (t - r) * e > 0 ? 0 : 1;
              }
              function La(e, t, n, r, i) {
                var o = e[0] - t[0],
                  a = e[1] - t[1],
                  s = (i ? r : -r) / Math.sqrt(o * o + a * a),
                  l = s * a,
                  u = -s * o,
                  c = e[0] + l,
                  d = e[1] + u,
                  h = t[0] + l,
                  f = t[1] + u,
                  p = (c + h) / 2,
                  m = (d + f) / 2,
                  g = h - c,
                  v = f - d,
                  y = g * g + v * v,
                  b = n - r,
                  _ = c * f - h * d,
                  x = (v < 0 ? -1 : 1) * Math.sqrt(Math.max(0, b * b * y - _ * _)),
                  w = (_ * v - g * x) / y,
                  S = (-_ * g - v * x) / y,
                  A = (_ * v + g * x) / y,
                  E = (-_ * g + v * x) / y,
                  T = w - p,
                  M = S - m,
                  C = A - p,
                  k = E - m;
                return T * T + M * M > C * C + k * k && (w = A, S = E), [[w - l, S - u], [w * n / b, S * n / b]];
              }
              function Da(e) {
                var t = Qr,
                  n = Jr,
                  r = Hn,
                  i = Fa,
                  o = i.key,
                  a = .7;
                function s(o) {
                  var s,
                    l = [],
                    u = [],
                    c = -1,
                    d = o.length,
                    h = dt(t),
                    f = dt(n);
                  function p() {
                    l.push("M", i(e(u), a));
                  }
                  for (; ++c < d;) r.call(this, s = o[c], c) ? u.push([+h.call(this, s, c), +f.call(this, s, c)]) : u.length && (p(), u = []);
                  return u.length && p(), l.length ? l.join("") : null;
                }
                return s.x = function (e) {
                  return arguments.length ? (t = e, s) : t;
                }, s.y = function (e) {
                  return arguments.length ? (n = e, s) : n;
                }, s.defined = function (e) {
                  return arguments.length ? (r = e, s) : r;
                }, s.interpolate = function (e) {
                  return arguments.length ? (o = "function" == typeof e ? i = e : (i = Ba.get(e) || Fa).key, s) : o;
                }, s.tension = function (e) {
                  return arguments.length ? (a = e, s) : a;
                }, s;
              }
              e.svg.line = function () {
                return Da(k);
              };
              var Ba = e.map({
                linear: Fa,
                "linear-closed": za,
                step: function step(e) {
                  for (var t = 0, n = e.length, r = e[0], i = [r[0], ",", r[1]]; ++t < n;) i.push("H", (r[0] + (r = e[t])[0]) / 2, "V", r[1]);
                  return n > 1 && i.push("H", r[0]), i.join("");
                },
                "step-before": Ua,
                "step-after": Ga,
                basis: qa,
                "basis-open": function basisOpen(e) {
                  if (e.length < 4) return Fa(e);
                  for (var t, n = [], r = -1, i = e.length, o = [0], a = [0]; ++r < 3;) t = e[r], o.push(t[0]), a.push(t[1]);
                  for (n.push(Wa(Ya, o) + "," + Wa(Ya, a)), --r; ++r < i;) t = e[r], o.shift(), o.push(t[0]), a.shift(), a.push(t[1]), Ka(n, o, a);
                  return n.join("");
                },
                "basis-closed": function basisClosed(e) {
                  for (var t, n, r = -1, i = e.length, o = i + 4, a = [], s = []; ++r < 4;) n = e[r % i], a.push(n[0]), s.push(n[1]);
                  for (t = [Wa(Ya, a), ",", Wa(Ya, s)], --r; ++r < o;) n = e[r % i], a.shift(), a.push(n[0]), s.shift(), s.push(n[1]), Ka(t, a, s);
                  return t.join("");
                },
                bundle: function bundle(e, t) {
                  var n = e.length - 1;
                  if (n) for (var r, i, o = e[0][0], a = e[0][1], s = e[n][0] - o, l = e[n][1] - a, u = -1; ++u <= n;) i = u / n, (r = e[u])[0] = t * r[0] + (1 - t) * (o + i * s), r[1] = t * r[1] + (1 - t) * (a + i * l);
                  return qa(e);
                },
                cardinal: function cardinal(e, t) {
                  return e.length < 3 ? Fa(e) : e[0] + Va(e, Ha(e, t));
                },
                "cardinal-open": function cardinalOpen(e, t) {
                  return e.length < 4 ? Fa(e) : e[1] + Va(e.slice(1, -1), Ha(e, t));
                },
                "cardinal-closed": function cardinalClosed(e, t) {
                  return e.length < 3 ? za(e) : e[0] + Va((e.push(e[0]), e), Ha([e[e.length - 2]].concat(e, [e[1]]), t));
                },
                monotone: function monotone(e) {
                  return e.length < 3 ? Fa(e) : e[0] + Va(e, function (e) {
                    for (var t, n, r, i, o = [], a = function (e) {
                        for (var t = 0, n = e.length - 1, r = [], i = e[0], o = e[1], a = r[0] = Za(i, o); ++t < n;) r[t] = (a + (a = Za(i = o, o = e[t + 1]))) / 2;
                        return r[t] = a, r;
                      }(e), s = -1, l = e.length - 1; ++s < l;) t = Za(e[s], e[s + 1]), y(t) < xe ? a[s] = a[s + 1] = 0 : (i = (n = a[s] / t) * n + (r = a[s + 1] / t) * r) > 9 && (i = 3 * t / Math.sqrt(i), a[s] = i * n, a[s + 1] = i * r);
                    for (s = -1; ++s <= l;) i = (e[Math.min(l, s + 1)][0] - e[Math.max(0, s - 1)][0]) / (6 * (1 + a[s] * a[s])), o.push([i || 0, a[s] * i || 0]);
                    return o;
                  }(e));
                }
              });
              function Fa(e) {
                return e.length > 1 ? e.join("L") : e + "Z";
              }
              function za(e) {
                return e.join("L") + "Z";
              }
              function Ua(e) {
                for (var t = 0, n = e.length, r = e[0], i = [r[0], ",", r[1]]; ++t < n;) i.push("V", (r = e[t])[1], "H", r[0]);
                return i.join("");
              }
              function Ga(e) {
                for (var t = 0, n = e.length, r = e[0], i = [r[0], ",", r[1]]; ++t < n;) i.push("H", (r = e[t])[0], "V", r[1]);
                return i.join("");
              }
              function Va(e, t) {
                if (t.length < 1 || e.length != t.length && e.length != t.length + 2) return Fa(e);
                var n = e.length != t.length,
                  r = "",
                  i = e[0],
                  o = e[1],
                  a = t[0],
                  s = a,
                  l = 1;
                if (n && (r += "Q" + (o[0] - 2 * a[0] / 3) + "," + (o[1] - 2 * a[1] / 3) + "," + o[0] + "," + o[1], i = e[1], l = 2), t.length > 1) {
                  s = t[1], o = e[l], l++, r += "C" + (i[0] + a[0]) + "," + (i[1] + a[1]) + "," + (o[0] - s[0]) + "," + (o[1] - s[1]) + "," + o[0] + "," + o[1];
                  for (var u = 2; u < t.length; u++, l++) o = e[l], s = t[u], r += "S" + (o[0] - s[0]) + "," + (o[1] - s[1]) + "," + o[0] + "," + o[1];
                }
                if (n) {
                  var c = e[l];
                  r += "Q" + (o[0] + 2 * s[0] / 3) + "," + (o[1] + 2 * s[1] / 3) + "," + c[0] + "," + c[1];
                }
                return r;
              }
              function Ha(e, t) {
                for (var n, r = [], i = (1 - t) / 2, o = e[0], a = e[1], s = 1, l = e.length; ++s < l;) n = o, o = a, a = e[s], r.push([i * (a[0] - n[0]), i * (a[1] - n[1])]);
                return r;
              }
              function qa(e) {
                if (e.length < 3) return Fa(e);
                var t = 1,
                  n = e.length,
                  r = e[0],
                  i = r[0],
                  o = r[1],
                  a = [i, i, i, (r = e[1])[0]],
                  s = [o, o, o, r[1]],
                  l = [i, ",", o, "L", Wa(Ya, a), ",", Wa(Ya, s)];
                for (e.push(e[n - 1]); ++t <= n;) r = e[t], a.shift(), a.push(r[0]), s.shift(), s.push(r[1]), Ka(l, a, s);
                return e.pop(), l.push("L", r), l.join("");
              }
              function Wa(e, t) {
                return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
              }
              Ba.forEach(function (e, t) {
                t.key = e, t.closed = /-closed$/.test(e);
              });
              var $a = [0, 2 / 3, 1 / 3, 0],
                Xa = [0, 1 / 3, 2 / 3, 0],
                Ya = [0, 1 / 6, 2 / 3, 1 / 6];
              function Ka(e, t, n) {
                e.push("C", Wa($a, t), ",", Wa($a, n), ",", Wa(Xa, t), ",", Wa(Xa, n), ",", Wa(Ya, t), ",", Wa(Ya, n));
              }
              function Za(e, t) {
                return (t[1] - e[1]) / (t[0] - e[0]);
              }
              function Qa(e) {
                for (var t, n, r, i = -1, o = e.length; ++i < o;) n = (t = e[i])[0], r = t[1] - Te, t[0] = n * Math.cos(r), t[1] = n * Math.sin(r);
                return e;
              }
              function Ja(e) {
                var t = Qr,
                  n = Qr,
                  r = 0,
                  i = Jr,
                  o = Hn,
                  a = Fa,
                  s = a.key,
                  l = a,
                  u = "L",
                  c = .7;
                function d(s) {
                  var d,
                    h,
                    f,
                    p = [],
                    m = [],
                    g = [],
                    v = -1,
                    y = s.length,
                    b = dt(t),
                    _ = dt(r),
                    x = t === n ? function () {
                      return h;
                    } : dt(n),
                    w = r === i ? function () {
                      return f;
                    } : dt(i);
                  function S() {
                    p.push("M", a(e(g), c), u, l(e(m.reverse()), c), "Z");
                  }
                  for (; ++v < y;) o.call(this, d = s[v], v) ? (m.push([h = +b.call(this, d, v), f = +_.call(this, d, v)]), g.push([+x.call(this, d, v), +w.call(this, d, v)])) : m.length && (S(), m = [], g = []);
                  return m.length && S(), p.length ? p.join("") : null;
                }
                return d.x = function (e) {
                  return arguments.length ? (t = n = e, d) : n;
                }, d.x0 = function (e) {
                  return arguments.length ? (t = e, d) : t;
                }, d.x1 = function (e) {
                  return arguments.length ? (n = e, d) : n;
                }, d.y = function (e) {
                  return arguments.length ? (r = i = e, d) : i;
                }, d.y0 = function (e) {
                  return arguments.length ? (r = e, d) : r;
                }, d.y1 = function (e) {
                  return arguments.length ? (i = e, d) : i;
                }, d.defined = function (e) {
                  return arguments.length ? (o = e, d) : o;
                }, d.interpolate = function (e) {
                  return arguments.length ? (s = "function" == typeof e ? a = e : (a = Ba.get(e) || Fa).key, l = a.reverse || a, u = a.closed ? "M" : "L", d) : s;
                }, d.tension = function (e) {
                  return arguments.length ? (c = e, d) : c;
                }, d;
              }
              function es(e) {
                return e.radius;
              }
              function ts(e) {
                return [e.x, e.y];
              }
              function ns() {
                return 64;
              }
              function rs() {
                return "circle";
              }
              function is(e) {
                var t = Math.sqrt(e / Se);
                return "M0," + t + "A" + t + "," + t + " 0 1,1 0," + -t + "A" + t + "," + t + " 0 1,1 0," + t + "Z";
              }
              e.svg.line.radial = function () {
                var e = Da(Qa);
                return e.radius = e.x, delete e.x, e.angle = e.y, delete e.y, e;
              }, Ua.reverse = Ga, Ga.reverse = Ua, e.svg.area = function () {
                return Ja(k);
              }, e.svg.area.radial = function () {
                var e = Ja(Qa);
                return e.radius = e.x, delete e.x, e.innerRadius = e.x0, delete e.x0, e.outerRadius = e.x1, delete e.x1, e.angle = e.y, delete e.y, e.startAngle = e.y0, delete e.y0, e.endAngle = e.y1, delete e.y1, e;
              }, e.svg.chord = function () {
                var e = Br,
                  t = Fr,
                  n = es,
                  r = Ra,
                  i = Ia;
                function o(n, r) {
                  var i,
                    o,
                    u = a(this, e, n, r),
                    c = a(this, t, n, r);
                  return "M" + u.p0 + s(u.r, u.p1, u.a1 - u.a0) + (o = c, (i = u).a0 == o.a0 && i.a1 == o.a1 ? l(u.r, u.p1, u.r, u.p0) : l(u.r, u.p1, c.r, c.p0) + s(c.r, c.p1, c.a1 - c.a0) + l(c.r, c.p1, u.r, u.p0)) + "Z";
                }
                function a(e, t, o, a) {
                  var s = t.call(e, o, a),
                    l = n.call(e, s, a),
                    u = r.call(e, s, a) - Te,
                    c = i.call(e, s, a) - Te;
                  return {
                    r: l,
                    a0: u,
                    a1: c,
                    p0: [l * Math.cos(u), l * Math.sin(u)],
                    p1: [l * Math.cos(c), l * Math.sin(c)]
                  };
                }
                function s(e, t, n) {
                  return "A" + e + "," + e + " 0 " + +(n > Se) + ",1 " + t;
                }
                function l(e, t, n, r) {
                  return "Q 0,0 " + r;
                }
                return o.radius = function (e) {
                  return arguments.length ? (n = dt(e), o) : n;
                }, o.source = function (t) {
                  return arguments.length ? (e = dt(t), o) : e;
                }, o.target = function (e) {
                  return arguments.length ? (t = dt(e), o) : t;
                }, o.startAngle = function (e) {
                  return arguments.length ? (r = dt(e), o) : r;
                }, o.endAngle = function (e) {
                  return arguments.length ? (i = dt(e), o) : i;
                }, o;
              }, e.svg.diagonal = function () {
                var e = Br,
                  t = Fr,
                  n = ts;
                function r(r, i) {
                  var o = e.call(this, r, i),
                    a = t.call(this, r, i),
                    s = (o.y + a.y) / 2,
                    l = [o, {
                      x: o.x,
                      y: s
                    }, {
                      x: a.x,
                      y: s
                    }, a];
                  return "M" + (l = l.map(n))[0] + "C" + l[1] + " " + l[2] + " " + l[3];
                }
                return r.source = function (t) {
                  return arguments.length ? (e = dt(t), r) : e;
                }, r.target = function (e) {
                  return arguments.length ? (t = dt(e), r) : t;
                }, r.projection = function (e) {
                  return arguments.length ? (n = e, r) : n;
                }, r;
              }, e.svg.diagonal.radial = function () {
                var t = e.svg.diagonal(),
                  n = ts,
                  r = t.projection;
                return t.projection = function (e) {
                  return arguments.length ? r(function (e) {
                    return function () {
                      var t = e.apply(this, arguments),
                        n = t[0],
                        r = t[1] - Te;
                      return [n * Math.cos(r), n * Math.sin(r)];
                    };
                  }(n = e)) : n;
                }, t;
              }, e.svg.symbol = function () {
                var e = rs,
                  t = ns;
                function n(n, r) {
                  return (os.get(e.call(this, n, r)) || is)(t.call(this, n, r));
                }
                return n.type = function (t) {
                  return arguments.length ? (e = dt(t), n) : e;
                }, n.size = function (e) {
                  return arguments.length ? (t = dt(e), n) : t;
                }, n;
              };
              var os = e.map({
                circle: is,
                cross: function cross(e) {
                  var t = Math.sqrt(e / 5) / 2;
                  return "M" + -3 * t + "," + -t + "H" + -t + "V" + -3 * t + "H" + t + "V" + -t + "H" + 3 * t + "V" + t + "H" + t + "V" + 3 * t + "H" + -t + "V" + t + "H" + -3 * t + "Z";
                },
                diamond: function diamond(e) {
                  var t = Math.sqrt(e / (2 * ss)),
                    n = t * ss;
                  return "M0," + -t + "L" + n + ",0 0," + t + " " + -n + ",0Z";
                },
                square: function square(e) {
                  var t = Math.sqrt(e) / 2;
                  return "M" + -t + "," + -t + "L" + t + "," + -t + " " + t + "," + t + " " + -t + "," + t + "Z";
                },
                "triangle-down": function triangleDown(e) {
                  var t = Math.sqrt(e / as),
                    n = t * as / 2;
                  return "M0," + n + "L" + t + "," + -n + " " + -t + "," + -n + "Z";
                },
                "triangle-up": function triangleUp(e) {
                  var t = Math.sqrt(e / as),
                    n = t * as / 2;
                  return "M0," + -n + "L" + t + "," + n + " " + -t + "," + n + "Z";
                }
              });
              e.svg.symbolTypes = os.keys();
              var as = Math.sqrt(3),
                ss = Math.tan(30 * Me);
              q.transition = function (e) {
                for (var t, n, r = ds || ++ps, i = vs(e), o = [], a = hs || {
                    time: Date.now(),
                    ease: to,
                    delay: 0,
                    duration: 250
                  }, s = -1, l = this.length; ++s < l;) {
                  o.push(t = []);
                  for (var u = this[s], c = -1, d = u.length; ++c < d;) (n = u[c]) && ys(n, c, i, r, a), t.push(n);
                }
                return cs(o, i, r);
              }, q.interrupt = function (e) {
                return this.each(null == e ? ls : us(vs(e)));
              };
              var ls = us(vs());
              function us(e) {
                return function () {
                  var t, n, r;
                  (t = this[e]) && (r = t[n = t.active]) && (r.timer.c = null, r.timer.t = NaN, --t.count ? delete t[n] : delete this[e], t.active += .5, r.event && r.event.interrupt.call(this, this.__data__, r.index));
                };
              }
              function cs(e, t, n) {
                return z(e, fs), e.namespace = t, e.id = n, e;
              }
              var ds,
                hs,
                fs = [],
                ps = 0;
              function ms(e, t, n, r) {
                var i = e.id,
                  o = e.namespace;
                return le(e, "function" == typeof n ? function (e, a, s) {
                  e[o][i].tween.set(t, r(n.call(e, e.__data__, a, s)));
                } : (n = r(n), function (e) {
                  e[o][i].tween.set(t, n);
                }));
              }
              function gs(e) {
                return null == e && (e = ""), function () {
                  this.textContent = e;
                };
              }
              function vs(e) {
                return null == e ? "__transition__" : "__transition_" + e + "__";
              }
              function ys(e, t, n, r, i) {
                var o,
                  a,
                  s,
                  l,
                  u,
                  c = e[n] || (e[n] = {
                    active: 0,
                    count: 0
                  }),
                  d = c[r];
                function h(n) {
                  var i = c.active,
                    h = c[i];
                  for (var p in h && (h.timer.c = null, h.timer.t = NaN, --c.count, delete c[i], h.event && h.event.interrupt.call(e, e.__data__, h.index)), c) if (+p < r) {
                    var m = c[p];
                    m.timer.c = null, m.timer.t = NaN, --c.count, delete c[p];
                  }
                  a.c = f, bt(function () {
                    return a.c && f(n || 1) && (a.c = null, a.t = NaN), 1;
                  }, 0, o), c.active = r, d.event && d.event.start.call(e, e.__data__, t), u = [], d.tween.forEach(function (n, r) {
                    (r = r.call(e, e.__data__, t)) && u.push(r);
                  }), l = d.ease, s = d.duration;
                }
                function f(i) {
                  for (var o = i / s, a = l(o), h = u.length; h > 0;) u[--h].call(e, a);
                  if (o >= 1) return d.event && d.event.end.call(e, e.__data__, t), --c.count ? delete c[r] : delete e[n], 1;
                }
                d || (o = i.time, a = bt(function (e) {
                  var t = d.delay;
                  if (a.t = t + o, t <= e) return h(e - t);
                  a.c = h;
                }, 0, o), d = c[r] = {
                  tween: new _(),
                  time: o,
                  timer: a,
                  delay: i.delay,
                  duration: i.duration,
                  ease: i.ease,
                  index: t
                }, i = null, ++c.count);
              }
              fs.call = q.call, fs.empty = q.empty, fs.node = q.node, fs.size = q.size, e.transition = function (t, n) {
                return t && t.transition ? ds ? t.transition(n) : t : e.selection().transition(t);
              }, e.transition.prototype = fs, fs.select = function (e) {
                var t,
                  n,
                  r,
                  i = this.id,
                  o = this.namespace,
                  a = [];
                e = W(e);
                for (var s = -1, l = this.length; ++s < l;) {
                  a.push(t = []);
                  for (var u = this[s], c = -1, d = u.length; ++c < d;) (r = u[c]) && (n = e.call(r, r.__data__, c, s)) ? ("__data__" in r && (n.__data__ = r.__data__), ys(n, c, o, i, r[o][i]), t.push(n)) : t.push(null);
                }
                return cs(a, o, i);
              }, fs.selectAll = function (e) {
                var t,
                  n,
                  r,
                  i,
                  o,
                  a = this.id,
                  s = this.namespace,
                  l = [];
                e = $(e);
                for (var u = -1, c = this.length; ++u < c;) for (var d = this[u], h = -1, f = d.length; ++h < f;) if (r = d[h]) {
                  o = r[s][a], n = e.call(r, r.__data__, h, u), l.push(t = []);
                  for (var p = -1, m = n.length; ++p < m;) (i = n[p]) && ys(i, p, s, a, o), t.push(i);
                }
                return cs(l, s, a);
              }, fs.filter = function (e) {
                var t,
                  n,
                  r = [];
                "function" != typeof e && (e = se(e));
                for (var i = 0, o = this.length; i < o; i++) {
                  r.push(t = []);
                  for (var a, s = 0, l = (a = this[i]).length; s < l; s++) (n = a[s]) && e.call(n, n.__data__, s, i) && t.push(n);
                }
                return cs(r, this.namespace, this.id);
              }, fs.tween = function (e, t) {
                var n = this.id,
                  r = this.namespace;
                return arguments.length < 2 ? this.node()[r][n].tween.get(e) : le(this, null == t ? function (t) {
                  t[r][n].tween.remove(e);
                } : function (i) {
                  i[r][n].tween.set(e, t);
                });
              }, fs.attr = function (t, n) {
                if (arguments.length < 2) {
                  for (n in t) this.attr(n, t[n]);
                  return this;
                }
                var r = "transform" == t ? fo : Wi,
                  i = e.ns.qualify(t);
                function o() {
                  this.removeAttribute(i);
                }
                function a() {
                  this.removeAttributeNS(i.space, i.local);
                }
                return ms(this, "attr." + t, n, i.local ? function (e) {
                  return null == e ? a : (e += "", function () {
                    var t,
                      n = this.getAttributeNS(i.space, i.local);
                    return n !== e && (t = r(n, e), function (e) {
                      this.setAttributeNS(i.space, i.local, t(e));
                    });
                  });
                } : function (e) {
                  return null == e ? o : (e += "", function () {
                    var t,
                      n = this.getAttribute(i);
                    return n !== e && (t = r(n, e), function (e) {
                      this.setAttribute(i, t(e));
                    });
                  });
                });
              }, fs.attrTween = function (t, n) {
                var r = e.ns.qualify(t);
                return this.tween("attr." + t, r.local ? function (e, t) {
                  var i = n.call(this, e, t, this.getAttributeNS(r.space, r.local));
                  return i && function (e) {
                    this.setAttributeNS(r.space, r.local, i(e));
                  };
                } : function (e, t) {
                  var i = n.call(this, e, t, this.getAttribute(r));
                  return i && function (e) {
                    this.setAttribute(r, i(e));
                  };
                });
              }, fs.style = function (e, t, n) {
                var r = arguments.length;
                if (r < 3) {
                  if ("string" != typeof e) {
                    for (n in r < 2 && (t = ""), e) this.style(n, e[n], t);
                    return this;
                  }
                  n = "";
                }
                function i() {
                  this.style.removeProperty(e);
                }
                return ms(this, "style." + e, t, function (t) {
                  return null == t ? i : (t += "", function () {
                    var r,
                      i = a(this).getComputedStyle(this, null).getPropertyValue(e);
                    return i !== t && (r = Wi(i, t), function (t) {
                      this.style.setProperty(e, r(t), n);
                    });
                  });
                });
              }, fs.styleTween = function (e, t, n) {
                return arguments.length < 3 && (n = ""), this.tween("style." + e, function (r, i) {
                  var o = t.call(this, r, i, a(this).getComputedStyle(this, null).getPropertyValue(e));
                  return o && function (t) {
                    this.style.setProperty(e, o(t), n);
                  };
                });
              }, fs.text = function (e) {
                return ms(this, "text", e, gs);
              }, fs.remove = function () {
                var e = this.namespace;
                return this.each("end.transition", function () {
                  var t;
                  this[e].count < 2 && (t = this.parentNode) && t.removeChild(this);
                });
              }, fs.ease = function (t) {
                var n = this.id,
                  r = this.namespace;
                return arguments.length < 1 ? this.node()[r][n].ease : ("function" != typeof t && (t = e.ease.apply(e, arguments)), le(this, function (e) {
                  e[r][n].ease = t;
                }));
              }, fs.delay = function (e) {
                var t = this.id,
                  n = this.namespace;
                return arguments.length < 1 ? this.node()[n][t].delay : le(this, "function" == typeof e ? function (r, i, o) {
                  r[n][t].delay = +e.call(r, r.__data__, i, o);
                } : (e = +e, function (r) {
                  r[n][t].delay = e;
                }));
              }, fs.duration = function (e) {
                var t = this.id,
                  n = this.namespace;
                return arguments.length < 1 ? this.node()[n][t].duration : le(this, "function" == typeof e ? function (r, i, o) {
                  r[n][t].duration = Math.max(1, e.call(r, r.__data__, i, o));
                } : (e = Math.max(1, e), function (r) {
                  r[n][t].duration = e;
                }));
              }, fs.each = function (t, n) {
                var r = this.id,
                  i = this.namespace;
                if (arguments.length < 2) {
                  var o = hs,
                    a = ds;
                  try {
                    ds = r, le(this, function (e, n, o) {
                      hs = e[i][r], t.call(e, e.__data__, n, o);
                    });
                  } finally {
                    hs = o, ds = a;
                  }
                } else le(this, function (o) {
                  var a = o[i][r];
                  (a.event || (a.event = e.dispatch("start", "end", "interrupt"))).on(t, n);
                });
                return this;
              }, fs.transition = function () {
                for (var e, t, n, r = this.id, i = ++ps, o = this.namespace, a = [], s = 0, l = this.length; s < l; s++) {
                  a.push(e = []);
                  for (var u, c = 0, d = (u = this[s]).length; c < d; c++) (t = u[c]) && ys(t, c, o, i, {
                    time: (n = t[o][r]).time,
                    ease: n.ease,
                    delay: n.delay + n.duration,
                    duration: n.duration
                  }), e.push(t);
                }
                return cs(a, o, i);
              }, e.svg.axis = function () {
                var t,
                  n = e.scale.linear(),
                  i = bs,
                  o = 6,
                  a = 6,
                  s = 3,
                  l = [10],
                  u = null;
                function c(r) {
                  r.each(function () {
                    var r,
                      c = e.select(this),
                      d = this.__chart__ || n,
                      h = this.__chart__ = n.copy(),
                      f = null == u ? h.ticks ? h.ticks.apply(h, l) : h.domain() : u,
                      p = null == t ? h.tickFormat ? h.tickFormat.apply(h, l) : k : t,
                      m = c.selectAll(".tick").data(f, h),
                      g = m.enter().insert("g", ".domain").attr("class", "tick").style("opacity", xe),
                      v = e.transition(m.exit()).style("opacity", xe).remove(),
                      y = e.transition(m.order()).style("opacity", 1),
                      b = Math.max(o, 0) + s,
                      _ = la(h),
                      x = c.selectAll(".domain").data([0]),
                      w = (x.enter().append("path").attr("class", "domain"), e.transition(x));
                    g.append("line"), g.append("text");
                    var S,
                      A,
                      E,
                      T,
                      M = g.select("line"),
                      C = y.select("line"),
                      P = m.select("text").text(p),
                      O = g.select("text"),
                      R = y.select("text"),
                      I = "top" === i || "left" === i ? -1 : 1;
                    if ("bottom" === i || "top" === i ? (r = xs, S = "x", E = "y", A = "x2", T = "y2", P.attr("dy", I < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + _[0] + "," + I * a + "V0H" + _[1] + "V" + I * a)) : (r = ws, S = "y", E = "x", A = "y2", T = "x2", P.attr("dy", ".32em").style("text-anchor", I < 0 ? "end" : "start"), w.attr("d", "M" + I * a + "," + _[0] + "H0V" + _[1] + "H" + I * a)), M.attr(T, I * o), O.attr(E, I * b), C.attr(A, 0).attr(T, I * o), R.attr(S, 0).attr(E, I * b), h.rangeBand) {
                      var j = h,
                        N = j.rangeBand() / 2;
                      d = h = function h(e) {
                        return j(e) + N;
                      };
                    } else d.rangeBand ? d = h : v.call(r, h, d);
                    g.call(r, d, h), y.call(r, h, h);
                  });
                }
                return c.scale = function (e) {
                  return arguments.length ? (n = e, c) : n;
                }, c.orient = function (e) {
                  return arguments.length ? (i = e in _s ? e + "" : bs, c) : i;
                }, c.ticks = function () {
                  return arguments.length ? (l = r(arguments), c) : l;
                }, c.tickValues = function (e) {
                  return arguments.length ? (u = e, c) : u;
                }, c.tickFormat = function (e) {
                  return arguments.length ? (t = e, c) : t;
                }, c.tickSize = function (e) {
                  var t = arguments.length;
                  return t ? (o = +e, a = +arguments[t - 1], c) : o;
                }, c.innerTickSize = function (e) {
                  return arguments.length ? (o = +e, c) : o;
                }, c.outerTickSize = function (e) {
                  return arguments.length ? (a = +e, c) : a;
                }, c.tickPadding = function (e) {
                  return arguments.length ? (s = +e, c) : s;
                }, c.tickSubdivide = function () {
                  return arguments.length && c;
                }, c;
              };
              var bs = "bottom",
                _s = {
                  top: 1,
                  right: 1,
                  bottom: 1,
                  left: 1
                };
              function xs(e, t, n) {
                e.attr("transform", function (e) {
                  var r = t(e);
                  return "translate(" + (isFinite(r) ? r : n(e)) + ",0)";
                });
              }
              function ws(e, t, n) {
                e.attr("transform", function (e) {
                  var r = t(e);
                  return "translate(0," + (isFinite(r) ? r : n(e)) + ")";
                });
              }
              e.svg.brush = function () {
                var t,
                  n,
                  r = B(h, "brushstart", "brush", "brushend"),
                  i = null,
                  o = null,
                  s = [0, 0],
                  l = [0, 0],
                  u = !0,
                  c = !0,
                  d = As[0];
                function h(t) {
                  t.each(function () {
                    var t = e.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", g).on("touchstart.brush", g),
                      n = t.selectAll(".background").data([0]);
                    n.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), t.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                    var r = t.selectAll(".resize").data(d, k);
                    r.exit().remove(), r.enter().append("g").attr("class", function (e) {
                      return "resize " + e;
                    }).style("cursor", function (e) {
                      return Ss[e];
                    }).append("rect").attr("x", function (e) {
                      return /[ew]$/.test(e) ? -3 : null;
                    }).attr("y", function (e) {
                      return /^[ns]/.test(e) ? -3 : null;
                    }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), r.style("display", h.empty() ? "none" : null);
                    var a,
                      s = e.transition(t),
                      l = e.transition(n);
                    i && (a = la(i), l.attr("x", a[0]).attr("width", a[1] - a[0]), p(s)), o && (a = la(o), l.attr("y", a[0]).attr("height", a[1] - a[0]), m(s)), f(s);
                  });
                }
                function f(e) {
                  e.selectAll(".resize").attr("transform", function (e) {
                    return "translate(" + s[+/e$/.test(e)] + "," + l[+/^s/.test(e)] + ")";
                  });
                }
                function p(e) {
                  e.select(".extent").attr("x", s[0]), e.selectAll(".extent,.n>rect,.s>rect").attr("width", s[1] - s[0]);
                }
                function m(e) {
                  e.select(".extent").attr("y", l[0]), e.selectAll(".extent,.e>rect,.w>rect").attr("height", l[1] - l[0]);
                }
                function g() {
                  var d,
                    g,
                    v = this,
                    y = e.select(e.event.target),
                    b = r.of(v, arguments),
                    _ = e.select(v),
                    x = y.datum(),
                    w = !/^(n|s)$/.test(x) && i,
                    S = !/^(e|w)$/.test(x) && o,
                    A = y.classed("extent"),
                    E = ve(v),
                    T = e.mouse(v),
                    M = e.select(a(v)).on("keydown.brush", function () {
                      32 == e.event.keyCode && (A || (d = null, T[0] -= s[1], T[1] -= l[1], A = 2), L());
                    }).on("keyup.brush", function () {
                      32 == e.event.keyCode && 2 == A && (T[0] += s[1], T[1] += l[1], A = 0, L());
                    });
                  if (e.event.changedTouches ? M.on("touchmove.brush", P).on("touchend.brush", R) : M.on("mousemove.brush", P).on("mouseup.brush", R), _.interrupt().selectAll("*").interrupt(), A) T[0] = s[0] - T[0], T[1] = l[0] - T[1];else if (x) {
                    var C = +/w$/.test(x),
                      k = +/^n/.test(x);
                    g = [s[1 - C] - T[0], l[1 - k] - T[1]], T[0] = s[C], T[1] = l[k];
                  } else e.event.altKey && (d = T.slice());
                  function P() {
                    var t = e.mouse(v),
                      n = !1;
                    g && (t[0] += g[0], t[1] += g[1]), A || (e.event.altKey ? (d || (d = [(s[0] + s[1]) / 2, (l[0] + l[1]) / 2]), T[0] = s[+(t[0] < d[0])], T[1] = l[+(t[1] < d[1])]) : d = null), w && O(t, i, 0) && (p(_), n = !0), S && O(t, o, 1) && (m(_), n = !0), n && (f(_), b({
                      type: "brush",
                      mode: A ? "move" : "resize"
                    }));
                  }
                  function O(e, r, i) {
                    var o,
                      a,
                      h = la(r),
                      f = h[0],
                      p = h[1],
                      m = T[i],
                      g = i ? l : s,
                      v = g[1] - g[0];
                    if (A && (f -= m, p -= v + m), o = (i ? c : u) ? Math.max(f, Math.min(p, e[i])) : e[i], A ? a = (o += m) + v : (d && (m = Math.max(f, Math.min(p, 2 * d[i] - o))), m < o ? (a = o, o = m) : a = m), g[0] != o || g[1] != a) return i ? n = null : t = null, g[0] = o, g[1] = a, !0;
                  }
                  function R() {
                    P(), _.style("pointer-events", "all").selectAll(".resize").style("display", h.empty() ? "none" : null), e.select("body").style("cursor", null), M.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), E(), b({
                      type: "brushend"
                    });
                  }
                  _.style("pointer-events", "none").selectAll(".resize").style("display", null), e.select("body").style("cursor", y.style("cursor")), b({
                    type: "brushstart"
                  }), P();
                }
                return h.event = function (i) {
                  i.each(function () {
                    var i = r.of(this, arguments),
                      o = {
                        x: s,
                        y: l,
                        i: t,
                        j: n
                      },
                      a = this.__chart__ || o;
                    this.__chart__ = o, ds ? e.select(this).transition().each("start.brush", function () {
                      t = a.i, n = a.j, s = a.x, l = a.y, i({
                        type: "brushstart"
                      });
                    }).tween("brush:brush", function () {
                      var e = $i(s, o.x),
                        r = $i(l, o.y);
                      return t = n = null, function (t) {
                        s = o.x = e(t), l = o.y = r(t), i({
                          type: "brush",
                          mode: "resize"
                        });
                      };
                    }).each("end.brush", function () {
                      t = o.i, n = o.j, i({
                        type: "brush",
                        mode: "resize"
                      }), i({
                        type: "brushend"
                      });
                    }) : (i({
                      type: "brushstart"
                    }), i({
                      type: "brush",
                      mode: "resize"
                    }), i({
                      type: "brushend"
                    }));
                  });
                }, h.x = function (e) {
                  return arguments.length ? (d = As[!(i = e) << 1 | !o], h) : i;
                }, h.y = function (e) {
                  return arguments.length ? (d = As[!i << 1 | !(o = e)], h) : o;
                }, h.clamp = function (e) {
                  return arguments.length ? (i && o ? (u = !!e[0], c = !!e[1]) : i ? u = !!e : o && (c = !!e), h) : i && o ? [u, c] : i ? u : o ? c : null;
                }, h.extent = function (e) {
                  var r, a, u, c, d;
                  return arguments.length ? (i && (r = e[0], a = e[1], o && (r = r[0], a = a[0]), t = [r, a], i.invert && (r = i(r), a = i(a)), a < r && (d = r, r = a, a = d), r == s[0] && a == s[1] || (s = [r, a])), o && (u = e[0], c = e[1], i && (u = u[1], c = c[1]), n = [u, c], o.invert && (u = o(u), c = o(c)), c < u && (d = u, u = c, c = d), u == l[0] && c == l[1] || (l = [u, c])), h) : (i && (t ? (r = t[0], a = t[1]) : (r = s[0], a = s[1], i.invert && (r = i.invert(r), a = i.invert(a)), a < r && (d = r, r = a, a = d))), o && (n ? (u = n[0], c = n[1]) : (u = l[0], c = l[1], o.invert && (u = o.invert(u), c = o.invert(c)), c < u && (d = u, u = c, c = d))), i && o ? [[r, u], [a, c]] : i ? [r, a] : o && [u, c]);
                }, h.clear = function () {
                  return h.empty() || (s = [0, 0], l = [0, 0], t = n = null), h;
                }, h.empty = function () {
                  return !!i && s[0] == s[1] || !!o && l[0] == l[1];
                }, e.rebind(h, r, "on");
              };
              var Ss = {
                  n: "ns-resize",
                  e: "ew-resize",
                  s: "ns-resize",
                  w: "ew-resize",
                  nw: "nwse-resize",
                  ne: "nesw-resize",
                  se: "nwse-resize",
                  sw: "nesw-resize"
                },
                As = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []],
                Es = kt.format = on.timeFormat,
                Ts = Es.utc,
                Ms = Ts("%Y-%m-%dT%H:%M:%S.%LZ");
              function Cs(e) {
                return e.toISOString();
              }
              function ks(t, n, r) {
                function i(e) {
                  return t(e);
                }
                function o(t, r) {
                  var i = (t[1] - t[0]) / r,
                    o = e.bisect(Os, i);
                  return o == Os.length ? [n.year, ga(t.map(function (e) {
                    return e / 31536e6;
                  }), r)[2]] : o ? n[i / Os[o - 1] < Os[o] / i ? o - 1 : o] : [js, ga(t, r)[2]];
                }
                return i.invert = function (e) {
                  return Ps(t.invert(e));
                }, i.domain = function (e) {
                  return arguments.length ? (t.domain(e), i) : t.domain().map(Ps);
                }, i.nice = function (e, t) {
                  var n = i.domain(),
                    r = sa(n),
                    a = null == e ? o(r, 10) : "number" == typeof e && o(r, e);
                  function s(n) {
                    return !isNaN(n) && !e.range(n, Ps(+n + 1), t).length;
                  }
                  return a && (e = a[0], t = a[1]), i.domain(ca(n, t > 1 ? {
                    floor: function floor(t) {
                      for (; s(t = e.floor(t));) t = Ps(t - 1);
                      return t;
                    },
                    ceil: function ceil(t) {
                      for (; s(t = e.ceil(t));) t = Ps(+t + 1);
                      return t;
                    }
                  } : e));
                }, i.ticks = function (e, t) {
                  var n = sa(i.domain()),
                    r = null == e ? o(n, 10) : "number" == typeof e ? o(n, e) : !e.range && [{
                      range: e
                    }, t];
                  return r && (e = r[0], t = r[1]), e.range(n[0], Ps(+n[1] + 1), t < 1 ? 1 : t);
                }, i.tickFormat = function () {
                  return r;
                }, i.copy = function () {
                  return ks(t.copy(), n, r);
                }, pa(i, t);
              }
              function Ps(e) {
                return new Date(e);
              }
              Es.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? Cs : Ms, Cs.parse = function (e) {
                var t = new Date(e);
                return isNaN(t) ? null : t;
              }, Cs.toString = Ms.toString, kt.second = It(function (e) {
                return new Pt(1e3 * Math.floor(e / 1e3));
              }, function (e, t) {
                e.setTime(e.getTime() + 1e3 * Math.floor(t));
              }, function (e) {
                return e.getSeconds();
              }), kt.seconds = kt.second.range, kt.seconds.utc = kt.second.utc.range, kt.minute = It(function (e) {
                return new Pt(6e4 * Math.floor(e / 6e4));
              }, function (e, t) {
                e.setTime(e.getTime() + 6e4 * Math.floor(t));
              }, function (e) {
                return e.getMinutes();
              }), kt.minutes = kt.minute.range, kt.minutes.utc = kt.minute.utc.range, kt.hour = It(function (e) {
                var t = e.getTimezoneOffset() / 60;
                return new Pt(36e5 * (Math.floor(e / 36e5 - t) + t));
              }, function (e, t) {
                e.setTime(e.getTime() + 36e5 * Math.floor(t));
              }, function (e) {
                return e.getHours();
              }), kt.hours = kt.hour.range, kt.hours.utc = kt.hour.utc.range, kt.month = It(function (e) {
                return (e = kt.day(e)).setDate(1), e;
              }, function (e, t) {
                e.setMonth(e.getMonth() + t);
              }, function (e) {
                return e.getMonth();
              }), kt.months = kt.month.range, kt.months.utc = kt.month.utc.range;
              var Os = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6],
                Rs = [[kt.second, 1], [kt.second, 5], [kt.second, 15], [kt.second, 30], [kt.minute, 1], [kt.minute, 5], [kt.minute, 15], [kt.minute, 30], [kt.hour, 1], [kt.hour, 3], [kt.hour, 6], [kt.hour, 12], [kt.day, 1], [kt.day, 2], [kt.week, 1], [kt.month, 1], [kt.month, 3], [kt.year, 1]],
                Is = Es.multi([[".%L", function (e) {
                  return e.getMilliseconds();
                }], [":%S", function (e) {
                  return e.getSeconds();
                }], ["%I:%M", function (e) {
                  return e.getMinutes();
                }], ["%I %p", function (e) {
                  return e.getHours();
                }], ["%a %d", function (e) {
                  return e.getDay() && 1 != e.getDate();
                }], ["%b %d", function (e) {
                  return 1 != e.getDate();
                }], ["%B", function (e) {
                  return e.getMonth();
                }], ["%Y", Hn]]),
                js = {
                  range: function range(t, n, r) {
                    return e.range(Math.ceil(t / r) * r, +n, r).map(Ps);
                  },
                  floor: k,
                  ceil: k
                };
              Rs.year = kt.year, kt.scale = function () {
                return ks(e.scale.linear(), Rs, Is);
              };
              var Ns = Rs.map(function (e) {
                  return [e[0].utc, e[1]];
                }),
                Ls = Ts.multi([[".%L", function (e) {
                  return e.getUTCMilliseconds();
                }], [":%S", function (e) {
                  return e.getUTCSeconds();
                }], ["%I:%M", function (e) {
                  return e.getUTCMinutes();
                }], ["%I %p", function (e) {
                  return e.getUTCHours();
                }], ["%a %d", function (e) {
                  return e.getUTCDay() && 1 != e.getUTCDate();
                }], ["%b %d", function (e) {
                  return 1 != e.getUTCDate();
                }], ["%B", function (e) {
                  return e.getUTCMonth();
                }], ["%Y", Hn]]);
              function Ds(e) {
                return JSON.parse(e.responseText);
              }
              function Bs(e) {
                var t = i.createRange();
                return t.selectNode(i.body), t.createContextualFragment(e.responseText);
              }
              Ns.year = kt.year.utc, kt.scale.utc = function () {
                return ks(e.scale.linear(), Ns, Ls);
              }, e.text = ht(function (e) {
                return e.responseText;
              }), e.json = function (e, t) {
                return ft(e, "application/json", Ds, t);
              }, e.html = function (e, t) {
                return ft(e, "text/html", Bs, t);
              }, e.xml = ht(function (e) {
                return e.responseXML;
              }), "object" == typeof t && t.exports ? t.exports = e : this.d3 = e;
            }();
          }, {}],
          83: [function (e, t, n) {
            t.exports = function () {
              for (var e = 0; e < arguments.length; e++) if (void 0 !== arguments[e]) return arguments[e];
            };
          }, {}],
          84: [function (e, t, n) {
            "use strict";

            var r = e("incremental-convex-hull"),
              i = e("uniq");
            function o(e, t) {
              this.point = e, this.index = t;
            }
            function a(e, t) {
              for (var n = e.point, r = t.point, i = n.length, o = 0; o < i; ++o) {
                var a = r[o] - n[o];
                if (a) return a;
              }
              return 0;
            }
            t.exports = function (e, t) {
              var n = e.length;
              if (0 === n) return [];
              var s = e[0].length;
              if (s < 1) return [];
              if (1 === s) return function (e, t, n) {
                if (1 === e) return n ? [[-1, 0]] : [];
                var r = t.map(function (e, t) {
                  return [e[0], t];
                });
                r.sort(function (e, t) {
                  return e[0] - t[0];
                });
                for (var i = new Array(e - 1), o = 1; o < e; ++o) {
                  var a = r[o - 1],
                    s = r[o];
                  i[o - 1] = [a[1], s[1]];
                }
                return n && i.push([-1, i[0][1]], [i[e - 1][1], -1]), i;
              }(n, e, t);
              for (var l = new Array(n), u = 1, c = 0; c < n; ++c) {
                for (var d = e[c], h = new Array(s + 1), f = 0, p = 0; p < s; ++p) {
                  var m = d[p];
                  h[p] = m, f += m * m;
                }
                h[s] = f, l[c] = new o(h, c), u = Math.max(f, u);
              }
              i(l, a), n = l.length;
              var g = new Array(n + s + 1),
                v = new Array(n + s + 1),
                y = (s + 1) * (s + 1) * u,
                b = new Array(s + 1);
              for (c = 0; c <= s; ++c) b[c] = 0;
              for (b[s] = y, g[0] = b.slice(), v[0] = -1, c = 0; c <= s; ++c) (h = b.slice())[c] = 1, g[c + 1] = h, v[c + 1] = -1;
              for (c = 0; c < n; ++c) {
                var _ = l[c];
                g[c + s + 1] = _.point, v[c + s + 1] = _.index;
              }
              var x = r(g, !1);
              if (x = t ? x.filter(function (e) {
                for (var t = 0, n = 0; n <= s; ++n) {
                  var r = v[e[n]];
                  if (r < 0 && ++t >= 2) return !1;
                  e[n] = r;
                }
                return !0;
              }) : x.filter(function (e) {
                for (var t = 0; t <= s; ++t) {
                  var n = v[e[t]];
                  if (n < 0) return !1;
                  e[t] = n;
                }
                return !0;
              }), 1 & s) for (c = 0; c < x.length; ++c) h = (_ = x[c])[0], _[0] = _[1], _[1] = h;
              return x;
            };
          }, {
            "incremental-convex-hull": 253,
            uniq: 349
          }],
          85: [function (e, t, n) {
            (function (e) {
              var n = !1;
              if ("undefined" != typeof Float64Array) {
                var r = new Float64Array(1),
                  i = new Uint32Array(r.buffer);
                r[0] = 1, n = !0, 1072693248 === i[1] ? (t.exports = function (e) {
                  return r[0] = e, [i[0], i[1]];
                }, t.exports.pack = function (e, t) {
                  return i[0] = e, i[1] = t, r[0];
                }, t.exports.lo = function (e) {
                  return r[0] = e, i[0];
                }, t.exports.hi = function (e) {
                  return r[0] = e, i[1];
                }) : 1072693248 === i[0] ? (t.exports = function (e) {
                  return r[0] = e, [i[1], i[0]];
                }, t.exports.pack = function (e, t) {
                  return i[1] = e, i[0] = t, r[0];
                }, t.exports.lo = function (e) {
                  return r[0] = e, i[1];
                }, t.exports.hi = function (e) {
                  return r[0] = e, i[0];
                }) : n = !1;
              }
              if (!n) {
                var o = new e(8);
                t.exports = function (e) {
                  return o.writeDoubleLE(e, 0, !0), [o.readUInt32LE(0, !0), o.readUInt32LE(4, !0)];
                }, t.exports.pack = function (e, t) {
                  return o.writeUInt32LE(e, 0, !0), o.writeUInt32LE(t, 4, !0), o.readDoubleLE(0, !0);
                }, t.exports.lo = function (e) {
                  return o.writeDoubleLE(e, 0, !0), o.readUInt32LE(0, !0);
                }, t.exports.hi = function (e) {
                  return o.writeDoubleLE(e, 0, !0), o.readUInt32LE(4, !0);
                };
              }
              t.exports.sign = function (e) {
                return t.exports.hi(e) >>> 31;
              }, t.exports.exponent = function (e) {
                return (t.exports.hi(e) << 1 >>> 21) - 1023;
              }, t.exports.fraction = function (e) {
                var n = t.exports.lo(e),
                  r = t.exports.hi(e),
                  i = 1048575 & r;
                return 2146435072 & r && (i += 1 << 20), [n, i];
              }, t.exports.denormalized = function (e) {
                return !(2146435072 & t.exports.hi(e));
              };
            }).call(this, e("buffer").Buffer);
          }, {
            buffer: 49
          }],
          86: [function (e, t, n) {
            t.exports = function (e) {
              switch (e) {
                case "int8":
                  return Int8Array;
                case "int16":
                  return Int16Array;
                case "int32":
                  return Int32Array;
                case "uint8":
                  return Uint8Array;
                case "uint16":
                  return Uint16Array;
                case "uint32":
                  return Uint32Array;
                case "float32":
                  return Float32Array;
                case "float64":
                  return Float64Array;
                case "array":
                  return Array;
                case "uint8_clamped":
                  return Uint8ClampedArray;
              }
            };
          }, {}],
          87: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              switch (void 0 === t && (t = 0), typeof e) {
                case "number":
                  if (e > 0) return function (e, t) {
                    var n, r;
                    for (n = new Array(e), r = 0; r < e; ++r) n[r] = t;
                    return n;
                  }(0 | e, t);
                  break;
                case "object":
                  if ("number" == typeof e.length) return function e(t, n, r) {
                    var i = 0 | t[r];
                    if (i <= 0) return [];
                    var o,
                      a = new Array(i);
                    if (r === t.length - 1) for (o = 0; o < i; ++o) a[o] = n;else for (o = 0; o < i; ++o) a[o] = e(t, n, r + 1);
                    return a;
                  }(e, t, 0);
              }
              return [];
            };
          }, {}],
          88: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = e.length;
              if ("number" != typeof t) {
                t = 0;
                for (var i = 0; i < n; ++i) {
                  var o = e[i];
                  t = Math.max(t, o[0], o[1]);
                }
                t = 1 + (0 | t);
              }
              t |= 0;
              var a = new Array(t);
              for (i = 0; i < t; ++i) a[i] = [];
              for (i = 0; i < n; ++i) a[(o = e[i])[0]].push(o[1]), a[o[1]].push(o[0]);
              for (var s = 0; s < t; ++s) r(a[s], function (e, t) {
                return e - t;
              });
              return a;
            };
            var r = e("uniq");
          }, {
            uniq: 349
          }],
          89: [function (e, n, r) {
            (function (t, i) {
              !function (e, t) {
                "object" == typeof r && void 0 !== n ? n.exports = t() : e.ES6Promise = t();
              }(this, function () {
                "use strict";

                function n(e) {
                  return "function" == typeof e;
                }
                var r = Array.isArray ? Array.isArray : function (e) {
                    return "[object Array]" === Object.prototype.toString.call(e);
                  },
                  o = 0,
                  a = void 0,
                  s = void 0,
                  l = function l(e, t) {
                    m[o] = e, m[o + 1] = t, 2 === (o += 2) && (s ? s(g) : x());
                  },
                  u = "undefined" != typeof window ? window : void 0,
                  c = u || {},
                  d = c.MutationObserver || c.WebKitMutationObserver,
                  h = "undefined" == typeof self && void 0 !== t && "[object process]" === {}.toString.call(t),
                  f = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                function p() {
                  var e = setTimeout;
                  return function () {
                    return e(g, 1);
                  };
                }
                var m = new Array(1e3);
                function g() {
                  for (var e = 0; e < o; e += 2) (0, m[e])(m[e + 1]), m[e] = void 0, m[e + 1] = void 0;
                  o = 0;
                }
                var v,
                  y,
                  b,
                  _,
                  x = void 0;
                function w(e, t) {
                  var n = arguments,
                    r = this,
                    i = new this.constructor(E);
                  void 0 === i[A] && z(i);
                  var o,
                    a = r._state;
                  return a ? (o = n[a - 1], l(function () {
                    return B(a, i, o, r._result);
                  })) : j(r, i, e, t), i;
                }
                function S(e) {
                  if (e && "object" == typeof e && e.constructor === this) return e;
                  var t = new this(E);
                  return P(t, e), t;
                }
                h ? x = function x() {
                  return t.nextTick(g);
                } : d ? (y = 0, b = new d(g), _ = document.createTextNode(""), b.observe(_, {
                  characterData: !0
                }), x = function x() {
                  _.data = y = ++y % 2;
                }) : f ? ((v = new MessageChannel()).port1.onmessage = g, x = function x() {
                  return v.port2.postMessage(0);
                }) : x = void 0 === u && "function" == typeof e ? function () {
                  try {
                    var t = e("vertx");
                    return a = t.runOnLoop || t.runOnContext, function () {
                      a(g);
                    };
                  } catch (e) {
                    return p();
                  }
                }() : p();
                var A = Math.random().toString(36).substring(16);
                function E() {}
                var T = void 0,
                  M = new L();
                function C(e) {
                  try {
                    return e.then;
                  } catch (e) {
                    return M.error = e, M;
                  }
                }
                function k(e, t, r) {
                  t.constructor === e.constructor && r === w && t.constructor.resolve === S ? function (e, t) {
                    1 === t._state ? R(e, t._result) : 2 === t._state ? I(e, t._result) : j(t, void 0, function (t) {
                      return P(e, t);
                    }, function (t) {
                      return I(e, t);
                    });
                  }(e, t) : r === M ? I(e, M.error) : void 0 === r ? R(e, t) : n(r) ? function (e, t, n) {
                    l(function (e) {
                      var r = !1,
                        i = function (e, t, n, r) {
                          try {
                            e.call(t, n, r);
                          } catch (e) {
                            return e;
                          }
                        }(n, t, function (n) {
                          r || (r = !0, t !== n ? P(e, n) : R(e, n));
                        }, function (t) {
                          r || (r = !0, I(e, t));
                        }, e._label);
                      !r && i && (r = !0, I(e, i));
                    }, e);
                  }(e, t, r) : R(e, t);
                }
                function P(e, t) {
                  var n;
                  e === t ? I(e, new TypeError("You cannot resolve a promise with itself")) : "function" == typeof (n = t) || "object" == typeof n && null !== n ? k(e, t, C(t)) : R(e, t);
                }
                function O(e) {
                  e._onerror && e._onerror(e._result), N(e);
                }
                function R(e, t) {
                  e._state === T && (e._result = t, e._state = 1, 0 !== e._subscribers.length && l(N, e));
                }
                function I(e, t) {
                  e._state === T && (e._state = 2, e._result = t, l(O, e));
                }
                function j(e, t, n, r) {
                  var i = e._subscribers,
                    o = i.length;
                  e._onerror = null, i[o] = t, i[o + 1] = n, i[o + 2] = r, 0 === o && e._state && l(N, e);
                }
                function N(e) {
                  var t = e._subscribers,
                    n = e._state;
                  if (0 !== t.length) {
                    for (var r = void 0, i = void 0, o = e._result, a = 0; a < t.length; a += 3) r = t[a], i = t[a + n], r ? B(n, r, i, o) : i(o);
                    e._subscribers.length = 0;
                  }
                }
                function L() {
                  this.error = null;
                }
                var D = new L();
                function B(e, t, r, i) {
                  var o = n(r),
                    a = void 0,
                    s = void 0,
                    l = void 0,
                    u = void 0;
                  if (o) {
                    if ((a = function (e, t) {
                      try {
                        return e(t);
                      } catch (e) {
                        return D.error = e, D;
                      }
                    }(r, i)) === D ? (u = !0, s = a.error, a = null) : l = !0, t === a) return void I(t, new TypeError("A promises callback cannot return that same promise."));
                  } else a = i, l = !0;
                  t._state !== T || (o && l ? P(t, a) : u ? I(t, s) : 1 === e ? R(t, a) : 2 === e && I(t, a));
                }
                var F = 0;
                function z(e) {
                  e[A] = F++, e._state = void 0, e._result = void 0, e._subscribers = [];
                }
                function U(e, t) {
                  this._instanceConstructor = e, this.promise = new e(E), this.promise[A] || z(this.promise), r(t) ? (this._input = t, this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 === this.length ? R(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(), 0 === this._remaining && R(this.promise, this._result))) : I(this.promise, new Error("Array Methods must be provided an Array"));
                }
                function G(e) {
                  this[A] = F++, this._result = this._state = void 0, this._subscribers = [], E !== e && ("function" != typeof e && function () {
                    throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                  }(), this instanceof G ? function (e, t) {
                    try {
                      t(function (t) {
                        P(e, t);
                      }, function (t) {
                        I(e, t);
                      });
                    } catch (t) {
                      I(e, t);
                    }
                  }(this, e) : function () {
                    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                  }());
                }
                function V() {
                  var e = void 0;
                  if (void 0 !== i) e = i;else if ("undefined" != typeof self) e = self;else try {
                    e = Function("return this")();
                  } catch (e) {
                    throw new Error("polyfill failed because global object is unavailable in this environment");
                  }
                  var t = e.Promise;
                  if (t) {
                    var n = null;
                    try {
                      n = Object.prototype.toString.call(t.resolve());
                    } catch (e) {}
                    if ("[object Promise]" === n && !t.cast) return;
                  }
                  e.Promise = G;
                }
                return U.prototype._enumerate = function () {
                  for (var e = this.length, t = this._input, n = 0; this._state === T && n < e; n++) this._eachEntry(t[n], n);
                }, U.prototype._eachEntry = function (e, t) {
                  var n = this._instanceConstructor,
                    r = n.resolve;
                  if (r === S) {
                    var i = C(e);
                    if (i === w && e._state !== T) this._settledAt(e._state, t, e._result);else if ("function" != typeof i) this._remaining--, this._result[t] = e;else if (n === G) {
                      var o = new n(E);
                      k(o, e, i), this._willSettleAt(o, t);
                    } else this._willSettleAt(new n(function (t) {
                      return t(e);
                    }), t);
                  } else this._willSettleAt(r(e), t);
                }, U.prototype._settledAt = function (e, t, n) {
                  var r = this.promise;
                  r._state === T && (this._remaining--, 2 === e ? I(r, n) : this._result[t] = n), 0 === this._remaining && R(r, this._result);
                }, U.prototype._willSettleAt = function (e, t) {
                  var n = this;
                  j(e, void 0, function (e) {
                    return n._settledAt(1, t, e);
                  }, function (e) {
                    return n._settledAt(2, t, e);
                  });
                }, G.all = function (e) {
                  return new U(this, e).promise;
                }, G.race = function (e) {
                  var t = this;
                  return r(e) ? new t(function (n, r) {
                    for (var i = e.length, o = 0; o < i; o++) t.resolve(e[o]).then(n, r);
                  }) : new t(function (e, t) {
                    return t(new TypeError("You must pass an array to race."));
                  });
                }, G.resolve = S, G.reject = function (e) {
                  var t = new this(E);
                  return I(t, e), t;
                }, G._setScheduler = function (e) {
                  s = e;
                }, G._setAsap = function (e) {
                  l = e;
                }, G._asap = l, G.prototype = {
                  constructor: G,
                  then: w,
                  catch: function _catch(e) {
                    return this.then(null, e);
                  }
                }, V(), G.polyfill = V, G.Promise = G, G;
              });
            }).call(this, e("_process"), void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {
            _process: 307
          }],
          90: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              var r = t || 0,
                i = n || 1;
              return [[e[12] + e[0], e[13] + e[1], e[14] + e[2], e[15] + e[3]], [e[12] - e[0], e[13] - e[1], e[14] - e[2], e[15] - e[3]], [e[12] + e[4], e[13] + e[5], e[14] + e[6], e[15] + e[7]], [e[12] - e[4], e[13] - e[5], e[14] - e[6], e[15] - e[7]], [r * e[12] + e[8], r * e[13] + e[9], r * e[14] + e[10], r * e[15] + e[11]], [i * e[12] - e[8], i * e[13] - e[9], i * e[14] - e[10], i * e[15] - e[11]]];
            };
          }, {}],
          91: [function (e, t, n) {
            "use strict";

            var r = e("is-string-blank");
            t.exports = function (e) {
              var t = typeof e;
              if ("string" === t) {
                var n = e;
                if (0 == (e = +e) && r(n)) return !1;
              } else if ("number" !== t) return !1;
              return e - e < 1;
            };
          }, {
            "is-string-blank": 261
          }],
          92: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              switch (arguments.length) {
                case 0:
                  return new a([0], [0], 0);
                case 1:
                  return "number" == typeof e ? new a(r = l(e), r, 0) : new a(e, l(e.length), 0);
                case 2:
                  var r;
                  if ("number" == typeof t) return new a(e, r = l(e.length), +t);
                  n = 0;
                case 3:
                  if (e.length !== t.length) throw new Error("state and velocity lengths must match");
                  return new a(e, t, n);
              }
            };
            var r = e("cubic-hermite"),
              i = e("binary-search-bounds");
            function o(e, t, n) {
              return Math.min(t, Math.max(e, n));
            }
            function a(e, t, n) {
              this.dimension = e.length, this.bounds = [new Array(this.dimension), new Array(this.dimension)];
              for (var r = 0; r < this.dimension; ++r) this.bounds[0][r] = -1 / 0, this.bounds[1][r] = 1 / 0;
              this._state = e.slice().reverse(), this._velocity = t.slice().reverse(), this._time = [n], this._scratch = [e.slice(), e.slice(), e.slice(), e.slice(), e.slice()];
            }
            var s = a.prototype;
            function l(e) {
              for (var t = new Array(e), n = 0; n < e; ++n) t[n] = 0;
              return t;
            }
            s.flush = function (e) {
              var t = i.gt(this._time, e) - 1;
              t <= 0 || (this._time.splice(0, t), this._state.splice(0, t * this.dimension), this._velocity.splice(0, t * this.dimension));
            }, s.curve = function (e) {
              var t = this._time,
                n = t.length,
                a = i.le(t, e),
                s = this._scratch[0],
                l = this._state,
                u = this._velocity,
                c = this.dimension,
                d = this.bounds;
              if (a < 0) for (var h = c - 1, f = 0; f < c; ++f, --h) s[f] = l[h];else if (a >= n - 1) {
                h = l.length - 1;
                var p = e - t[n - 1];
                for (f = 0; f < c; ++f, --h) s[f] = l[h] + p * u[h];
              } else {
                h = c * (a + 1) - 1;
                var m = t[a],
                  g = t[a + 1] - m || 1,
                  v = this._scratch[1],
                  y = this._scratch[2],
                  b = this._scratch[3],
                  _ = this._scratch[4],
                  x = !0;
                for (f = 0; f < c; ++f, --h) v[f] = l[h], b[f] = u[h] * g, y[f] = l[h + c], _[f] = u[h + c] * g, x = x && v[f] === y[f] && b[f] === _[f] && 0 === b[f];
                if (x) for (f = 0; f < c; ++f) s[f] = v[f];else r(v, b, y, _, (e - m) / g, s);
              }
              var w = d[0],
                S = d[1];
              for (f = 0; f < c; ++f) s[f] = o(w[f], S[f], s[f]);
              return s;
            }, s.dcurve = function (e) {
              var t = this._time,
                n = t.length,
                o = i.le(t, e),
                a = this._scratch[0],
                s = this._state,
                l = this._velocity,
                u = this.dimension;
              if (o >= n - 1) for (var c = s.length - 1, d = (t[n - 1], 0); d < u; ++d, --c) a[d] = l[c];else {
                c = u * (o + 1) - 1;
                var h = t[o],
                  f = t[o + 1] - h || 1,
                  p = this._scratch[1],
                  m = this._scratch[2],
                  g = this._scratch[3],
                  v = this._scratch[4],
                  y = !0;
                for (d = 0; d < u; ++d, --c) p[d] = s[c], g[d] = l[c] * f, m[d] = s[c + u], v[d] = l[c + u] * f, y = y && p[d] === m[d] && g[d] === v[d] && 0 === g[d];
                if (y) for (d = 0; d < u; ++d) a[d] = 0;else for (r.derivative(p, g, m, v, (e - h) / f, a), d = 0; d < u; ++d) a[d] /= f;
              }
              return a;
            }, s.lastT = function () {
              var e = this._time;
              return e[e.length - 1];
            }, s.stable = function () {
              for (var e = this._velocity, t = e.length, n = this.dimension - 1; n >= 0; --n) if (e[--t]) return !1;
              return !0;
            }, s.jump = function (e) {
              var t = this.lastT(),
                n = this.dimension;
              if (!(e < t || arguments.length !== n + 1)) {
                var r = this._state,
                  i = this._velocity,
                  a = r.length - this.dimension,
                  s = this.bounds,
                  l = s[0],
                  u = s[1];
                this._time.push(t, e);
                for (var c = 0; c < 2; ++c) for (var d = 0; d < n; ++d) r.push(r[a++]), i.push(0);
                for (this._time.push(e), d = n; d > 0; --d) r.push(o(l[d - 1], u[d - 1], arguments[d])), i.push(0);
              }
            }, s.push = function (e) {
              var t = this.lastT(),
                n = this.dimension;
              if (!(e < t || arguments.length !== n + 1)) {
                var r = this._state,
                  i = this._velocity,
                  a = r.length - this.dimension,
                  s = e - t,
                  l = this.bounds,
                  u = l[0],
                  c = l[1],
                  d = s > 1e-6 ? 1 / s : 0;
                this._time.push(e);
                for (var h = n; h > 0; --h) {
                  var f = o(u[h - 1], c[h - 1], arguments[h]);
                  r.push(f), i.push((f - r[a++]) * d);
                }
              }
            }, s.set = function (e) {
              var t = this.dimension;
              if (!(e < this.lastT() || arguments.length !== t + 1)) {
                var n = this._state,
                  r = this._velocity,
                  i = this.bounds,
                  a = i[0],
                  s = i[1];
                this._time.push(e);
                for (var l = t; l > 0; --l) n.push(o(a[l - 1], s[l - 1], arguments[l])), r.push(0);
              }
            }, s.move = function (e) {
              var t = this.lastT(),
                n = this.dimension;
              if (!(e <= t || arguments.length !== n + 1)) {
                var r = this._state,
                  i = this._velocity,
                  a = r.length - this.dimension,
                  s = this.bounds,
                  l = s[0],
                  u = s[1],
                  c = e - t,
                  d = c > 1e-6 ? 1 / c : 0;
                this._time.push(e);
                for (var h = n; h > 0; --h) {
                  var f = arguments[h];
                  r.push(o(l[h - 1], u[h - 1], r[a++] + f)), i.push(f * d);
                }
              }
            }, s.idle = function (e) {
              var t = this.lastT();
              if (!(e < t)) {
                var n = this.dimension,
                  r = this._state,
                  i = this._velocity,
                  a = r.length - n,
                  s = this.bounds,
                  l = s[0],
                  u = s[1],
                  c = e - t;
                this._time.push(e);
                for (var d = n - 1; d >= 0; --d) r.push(o(l[d], u[d], r[a] + c * i[a])), i.push(0), a += 1;
              }
            };
          }, {
            "binary-search-bounds": 36,
            "cubic-hermite": 77
          }],
          93: [function (e, t, n) {
            "use strict";

            function r(e, t, n, r, i, o) {
              this._color = e, this.key = t, this.value = n, this.left = r, this.right = i, this._count = o;
            }
            function i(e) {
              return new r(e._color, e.key, e.value, e.left, e.right, e._count);
            }
            function o(e, t) {
              return new r(e, t.key, t.value, t.left, t.right, t._count);
            }
            function a(e) {
              e._count = 1 + (e.left ? e.left._count : 0) + (e.right ? e.right._count : 0);
            }
            function s(e, t) {
              this._compare = e, this.root = t;
            }
            t.exports = function (e) {
              return new s(e || h, null);
            };
            var l = s.prototype;
            function u(e, t) {
              this.tree = e, this._stack = t;
            }
            Object.defineProperty(l, "keys", {
              get: function get() {
                var e = [];
                return this.forEach(function (t, n) {
                  e.push(t);
                }), e;
              }
            }), Object.defineProperty(l, "values", {
              get: function get() {
                var e = [];
                return this.forEach(function (t, n) {
                  e.push(n);
                }), e;
              }
            }), Object.defineProperty(l, "length", {
              get: function get() {
                return this.root ? this.root._count : 0;
              }
            }), l.insert = function (e, t) {
              for (var n = this._compare, i = this.root, l = [], u = []; i;) {
                var c = n(e, i.key);
                l.push(i), u.push(c), i = c <= 0 ? i.left : i.right;
              }
              l.push(new r(0, e, t, null, null, 1));
              for (var d = l.length - 2; d >= 0; --d) i = l[d], u[d] <= 0 ? l[d] = new r(i._color, i.key, i.value, l[d + 1], i.right, i._count + 1) : l[d] = new r(i._color, i.key, i.value, i.left, l[d + 1], i._count + 1);
              for (d = l.length - 1; d > 1; --d) {
                var h = l[d - 1];
                if (i = l[d], 1 === h._color || 1 === i._color) break;
                var f = l[d - 2];
                if (f.left === h) {
                  if (h.left === i) {
                    if (!(p = f.right) || 0 !== p._color) {
                      f._color = 0, f.left = h.right, h._color = 1, h.right = f, l[d - 2] = h, l[d - 1] = i, a(f), a(h), d >= 3 && ((m = l[d - 3]).left === f ? m.left = h : m.right = h);
                      break;
                    }
                    h._color = 1, f.right = o(1, p), f._color = 0, d -= 1;
                  } else {
                    if (!(p = f.right) || 0 !== p._color) {
                      h.right = i.left, f._color = 0, f.left = i.right, i._color = 1, i.left = h, i.right = f, l[d - 2] = i, l[d - 1] = h, a(f), a(h), a(i), d >= 3 && ((m = l[d - 3]).left === f ? m.left = i : m.right = i);
                      break;
                    }
                    h._color = 1, f.right = o(1, p), f._color = 0, d -= 1;
                  }
                } else if (h.right === i) {
                  if (!(p = f.left) || 0 !== p._color) {
                    f._color = 0, f.right = h.left, h._color = 1, h.left = f, l[d - 2] = h, l[d - 1] = i, a(f), a(h), d >= 3 && ((m = l[d - 3]).right === f ? m.right = h : m.left = h);
                    break;
                  }
                  h._color = 1, f.left = o(1, p), f._color = 0, d -= 1;
                } else {
                  var p;
                  if (!(p = f.left) || 0 !== p._color) {
                    var m;
                    h.left = i.right, f._color = 0, f.right = i.left, i._color = 1, i.right = h, i.left = f, l[d - 2] = i, l[d - 1] = h, a(f), a(h), a(i), d >= 3 && ((m = l[d - 3]).right === f ? m.right = i : m.left = i);
                    break;
                  }
                  h._color = 1, f.left = o(1, p), f._color = 0, d -= 1;
                }
              }
              return l[0]._color = 1, new s(n, l[0]);
            }, l.forEach = function (e, t, n) {
              if (this.root) switch (arguments.length) {
                case 1:
                  return function e(t, n) {
                    var r;
                    return n.left && (r = e(t, n.left)) ? r : (r = t(n.key, n.value)) || (n.right ? e(t, n.right) : void 0);
                  }(e, this.root);
                case 2:
                  return function e(t, n, r, i) {
                    if (n(t, i.key) <= 0) {
                      var o;
                      if (i.left && (o = e(t, n, r, i.left))) return o;
                      if (o = r(i.key, i.value)) return o;
                    }
                    if (i.right) return e(t, n, r, i.right);
                  }(t, this._compare, e, this.root);
                case 3:
                  if (this._compare(t, n) >= 0) return;
                  return function e(t, n, r, i, o) {
                    var a,
                      s = r(t, o.key),
                      l = r(n, o.key);
                    if (s <= 0) {
                      if (o.left && (a = e(t, n, r, i, o.left))) return a;
                      if (l > 0 && (a = i(o.key, o.value))) return a;
                    }
                    if (l > 0 && o.right) return e(t, n, r, i, o.right);
                  }(t, n, this._compare, e, this.root);
              }
            }, Object.defineProperty(l, "begin", {
              get: function get() {
                for (var e = [], t = this.root; t;) e.push(t), t = t.left;
                return new u(this, e);
              }
            }), Object.defineProperty(l, "end", {
              get: function get() {
                for (var e = [], t = this.root; t;) e.push(t), t = t.right;
                return new u(this, e);
              }
            }), l.at = function (e) {
              if (e < 0) return new u(this, []);
              for (var t = this.root, n = [];;) {
                if (n.push(t), t.left) {
                  if (e < t.left._count) {
                    t = t.left;
                    continue;
                  }
                  e -= t.left._count;
                }
                if (!e) return new u(this, n);
                if (e -= 1, !t.right) break;
                if (e >= t.right._count) break;
                t = t.right;
              }
              return new u(this, []);
            }, l.ge = function (e) {
              for (var t = this._compare, n = this.root, r = [], i = 0; n;) {
                var o = t(e, n.key);
                r.push(n), o <= 0 && (i = r.length), n = o <= 0 ? n.left : n.right;
              }
              return r.length = i, new u(this, r);
            }, l.gt = function (e) {
              for (var t = this._compare, n = this.root, r = [], i = 0; n;) {
                var o = t(e, n.key);
                r.push(n), o < 0 && (i = r.length), n = o < 0 ? n.left : n.right;
              }
              return r.length = i, new u(this, r);
            }, l.lt = function (e) {
              for (var t = this._compare, n = this.root, r = [], i = 0; n;) {
                var o = t(e, n.key);
                r.push(n), o > 0 && (i = r.length), n = o <= 0 ? n.left : n.right;
              }
              return r.length = i, new u(this, r);
            }, l.le = function (e) {
              for (var t = this._compare, n = this.root, r = [], i = 0; n;) {
                var o = t(e, n.key);
                r.push(n), o >= 0 && (i = r.length), n = o < 0 ? n.left : n.right;
              }
              return r.length = i, new u(this, r);
            }, l.find = function (e) {
              for (var t = this._compare, n = this.root, r = []; n;) {
                var i = t(e, n.key);
                if (r.push(n), 0 === i) return new u(this, r);
                n = i <= 0 ? n.left : n.right;
              }
              return new u(this, []);
            }, l.remove = function (e) {
              var t = this.find(e);
              return t ? t.remove() : this;
            }, l.get = function (e) {
              for (var t = this._compare, n = this.root; n;) {
                var r = t(e, n.key);
                if (0 === r) return n.value;
                n = r <= 0 ? n.left : n.right;
              }
            };
            var c = u.prototype;
            function d(e, t) {
              e.key = t.key, e.value = t.value, e.left = t.left, e.right = t.right, e._color = t._color, e._count = t._count;
            }
            function h(e, t) {
              return e < t ? -1 : e > t ? 1 : 0;
            }
            Object.defineProperty(c, "valid", {
              get: function get() {
                return this._stack.length > 0;
              }
            }), Object.defineProperty(c, "node", {
              get: function get() {
                return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
              },
              enumerable: !0
            }), c.clone = function () {
              return new u(this.tree, this._stack.slice());
            }, c.remove = function () {
              var e = this._stack;
              if (0 === e.length) return this.tree;
              var t = new Array(e.length),
                n = e[e.length - 1];
              t[t.length - 1] = new r(n._color, n.key, n.value, n.left, n.right, n._count);
              for (var l = e.length - 2; l >= 0; --l) (n = e[l]).left === e[l + 1] ? t[l] = new r(n._color, n.key, n.value, t[l + 1], n.right, n._count) : t[l] = new r(n._color, n.key, n.value, n.left, t[l + 1], n._count);
              if ((n = t[t.length - 1]).left && n.right) {
                var u = t.length;
                for (n = n.left; n.right;) t.push(n), n = n.right;
                var c = t[u - 1];
                for (t.push(new r(n._color, c.key, c.value, n.left, n.right, n._count)), t[u - 1].key = n.key, t[u - 1].value = n.value, l = t.length - 2; l >= u; --l) n = t[l], t[l] = new r(n._color, n.key, n.value, n.left, t[l + 1], n._count);
                t[u - 1].left = t[u];
              }
              if (0 === (n = t[t.length - 1])._color) {
                var h = t[t.length - 2];
                for (h.left === n ? h.left = null : h.right === n && (h.right = null), t.pop(), l = 0; l < t.length; ++l) t[l]._count--;
                return new s(this.tree._compare, t[0]);
              }
              if (n.left || n.right) {
                for (n.left ? d(n, n.left) : n.right && d(n, n.right), n._color = 1, l = 0; l < t.length - 1; ++l) t[l]._count--;
                return new s(this.tree._compare, t[0]);
              }
              if (1 === t.length) return new s(this.tree._compare, null);
              for (l = 0; l < t.length; ++l) t[l]._count--;
              var f = t[t.length - 2];
              return function (e) {
                for (var t, n, r, s, l = e.length - 1; l >= 0; --l) {
                  if (t = e[l], 0 === l) return void (t._color = 1);
                  if ((n = e[l - 1]).left === t) {
                    if ((r = n.right).right && 0 === r.right._color) return s = (r = n.right = i(r)).right = i(r.right), n.right = r.left, r.left = n, r.right = s, r._color = n._color, t._color = 1, n._color = 1, s._color = 1, a(n), a(r), l > 1 && ((u = e[l - 2]).left === n ? u.left = r : u.right = r), void (e[l - 1] = r);
                    if (r.left && 0 === r.left._color) return s = (r = n.right = i(r)).left = i(r.left), n.right = s.left, r.left = s.right, s.left = n, s.right = r, s._color = n._color, n._color = 1, r._color = 1, t._color = 1, a(n), a(r), a(s), l > 1 && ((u = e[l - 2]).left === n ? u.left = s : u.right = s), void (e[l - 1] = s);
                    if (1 === r._color) {
                      if (0 === n._color) return n._color = 1, void (n.right = o(0, r));
                      n.right = o(0, r);
                      continue;
                    }
                    r = i(r), n.right = r.left, r.left = n, r._color = n._color, n._color = 0, a(n), a(r), l > 1 && ((u = e[l - 2]).left === n ? u.left = r : u.right = r), e[l - 1] = r, e[l] = n, l + 1 < e.length ? e[l + 1] = t : e.push(t), l += 2;
                  } else {
                    if ((r = n.left).left && 0 === r.left._color) return s = (r = n.left = i(r)).left = i(r.left), n.left = r.right, r.right = n, r.left = s, r._color = n._color, t._color = 1, n._color = 1, s._color = 1, a(n), a(r), l > 1 && ((u = e[l - 2]).right === n ? u.right = r : u.left = r), void (e[l - 1] = r);
                    if (r.right && 0 === r.right._color) return s = (r = n.left = i(r)).right = i(r.right), n.left = s.right, r.right = s.left, s.right = n, s.left = r, s._color = n._color, n._color = 1, r._color = 1, t._color = 1, a(n), a(r), a(s), l > 1 && ((u = e[l - 2]).right === n ? u.right = s : u.left = s), void (e[l - 1] = s);
                    if (1 === r._color) {
                      if (0 === n._color) return n._color = 1, void (n.left = o(0, r));
                      n.left = o(0, r);
                      continue;
                    }
                    var u;
                    r = i(r), n.left = r.right, r.right = n, r._color = n._color, n._color = 0, a(n), a(r), l > 1 && ((u = e[l - 2]).right === n ? u.right = r : u.left = r), e[l - 1] = r, e[l] = n, l + 1 < e.length ? e[l + 1] = t : e.push(t), l += 2;
                  }
                }
              }(t), f.left === n ? f.left = null : f.right = null, new s(this.tree._compare, t[0]);
            }, Object.defineProperty(c, "key", {
              get: function get() {
                if (this._stack.length > 0) return this._stack[this._stack.length - 1].key;
              },
              enumerable: !0
            }), Object.defineProperty(c, "value", {
              get: function get() {
                if (this._stack.length > 0) return this._stack[this._stack.length - 1].value;
              },
              enumerable: !0
            }), Object.defineProperty(c, "index", {
              get: function get() {
                var e = 0,
                  t = this._stack;
                if (0 === t.length) {
                  var n = this.tree.root;
                  return n ? n._count : 0;
                }
                t[t.length - 1].left && (e = t[t.length - 1].left._count);
                for (var r = t.length - 2; r >= 0; --r) t[r + 1] === t[r].right && (++e, t[r].left && (e += t[r].left._count));
                return e;
              },
              enumerable: !0
            }), c.next = function () {
              var e = this._stack;
              if (0 !== e.length) {
                var t = e[e.length - 1];
                if (t.right) for (t = t.right; t;) e.push(t), t = t.left;else for (e.pop(); e.length > 0 && e[e.length - 1].right === t;) t = e[e.length - 1], e.pop();
              }
            }, Object.defineProperty(c, "hasNext", {
              get: function get() {
                var e = this._stack;
                if (0 === e.length) return !1;
                if (e[e.length - 1].right) return !0;
                for (var t = e.length - 1; t > 0; --t) if (e[t - 1].left === e[t]) return !0;
                return !1;
              }
            }), c.update = function (e) {
              var t = this._stack;
              if (0 === t.length) throw new Error("Can't update empty node!");
              var n = new Array(t.length),
                i = t[t.length - 1];
              n[n.length - 1] = new r(i._color, i.key, e, i.left, i.right, i._count);
              for (var o = t.length - 2; o >= 0; --o) (i = t[o]).left === t[o + 1] ? n[o] = new r(i._color, i.key, i.value, n[o + 1], i.right, i._count) : n[o] = new r(i._color, i.key, i.value, i.left, n[o + 1], i._count);
              return new s(this.tree._compare, n[0]);
            }, c.prev = function () {
              var e = this._stack;
              if (0 !== e.length) {
                var t = e[e.length - 1];
                if (t.left) for (t = t.left; t;) e.push(t), t = t.right;else for (e.pop(); e.length > 0 && e[e.length - 1].left === t;) t = e[e.length - 1], e.pop();
              }
            }, Object.defineProperty(c, "hasPrev", {
              get: function get() {
                var e = this._stack;
                if (0 === e.length) return !1;
                if (e[e.length - 1].left) return !0;
                for (var t = e.length - 1; t > 0; --t) if (e[t - 1].right === e[t]) return !0;
                return !1;
              }
            });
          }, {}],
          94: [function (e, t, n) {
            var r = [.9999999999998099, 676.5203681218851, -1259.1392167224028, 771.3234287776531, -176.6150291621406, 12.507343278686905, -.13857109526572012, 9984369578019572e-21, 1.5056327351493116e-7],
              i = [.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, .0001580887032249125, -.00021026444172410488, .00021743961811521265, -.0001643181065367639, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22];
            function o(e) {
              if (e < 0) return Number("0/0");
              for (var t = i[0], n = i.length - 1; n > 0; --n) t += i[n] / (e + n);
              var r = e + 607 / 128 + .5;
              return .5 * Math.log(2 * Math.PI) + (e + .5) * Math.log(r) - r + Math.log(t) - Math.log(e);
            }
            t.exports = function e(t) {
              if (t < .5) return Math.PI / (Math.sin(Math.PI * t) * e(1 - t));
              if (t > 100) return Math.exp(o(t));
              t -= 1;
              for (var n = r[0], i = 1; i < 9; i++) n += r[i] / (t + i);
              var a = t + 7 + .5;
              return Math.sqrt(2 * Math.PI) * Math.pow(a, t + .5) * Math.exp(-a) * n;
            }, t.exports.log = o;
          }, {}],
          95: [function (e, t, n) {
            t.exports = function (e, t) {
              if ("string" != typeof e) throw new TypeError("must specify type string");
              if (t = t || {}, "undefined" == typeof document && !t.canvas) return null;
              var n = t.canvas || document.createElement("canvas");
              "number" == typeof t.width && (n.width = t.width), "number" == typeof t.height && (n.height = t.height);
              var r,
                i = t;
              try {
                var o = [e];
                0 === e.indexOf("webgl") && o.push("experimental-" + e);
                for (var a = 0; a < o.length; a++) if (r = n.getContext(o[a], i)) return r;
              } catch (e) {
                r = null;
              }
              return r || null;
            };
          }, {}],
          96: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = new c(e);
              return n.update(t), n;
            };
            var r = e("./lib/text.js"),
              i = e("./lib/lines.js"),
              o = e("./lib/background.js"),
              a = e("./lib/cube.js"),
              s = e("./lib/ticks.js"),
              l = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
            function u(e, t) {
              return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
            }
            function c(e) {
              this.gl = e, this.pixelRatio = 1, this.bounds = [[-10, -10, -10], [10, 10, 10]], this.ticks = [[], [], []], this.autoTicks = !0, this.tickSpacing = [1, 1, 1], this.tickEnable = [!0, !0, !0], this.tickFont = ["sans-serif", "sans-serif", "sans-serif"], this.tickSize = [12, 12, 12], this.tickAngle = [0, 0, 0], this.tickAlign = ["auto", "auto", "auto"], this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.tickPad = [10, 10, 10], this.lastCubeProps = {
                cubeEdges: [0, 0, 0],
                axis: [0, 0, 0]
              }, this.labels = ["x", "y", "z"], this.labelEnable = [!0, !0, !0], this.labelFont = "sans-serif", this.labelSize = [20, 20, 20], this.labelAngle = [0, 0, 0], this.labelAlign = ["auto", "auto", "auto"], this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.labelPad = [10, 10, 10], this.lineEnable = [!0, !0, !0], this.lineMirror = [!1, !1, !1], this.lineWidth = [1, 1, 1], this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.lineTickEnable = [!0, !0, !0], this.lineTickMirror = [!1, !1, !1], this.lineTickLength = [0, 0, 0], this.lineTickWidth = [1, 1, 1], this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.gridEnable = [!0, !0, !0], this.gridWidth = [1, 1, 1], this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroEnable = [!0, !0, !0], this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroLineWidth = [2, 2, 2], this.backgroundEnable = [!1, !1, !1], this.backgroundColor = [[.8, .8, .8, .5], [.8, .8, .8, .5], [.8, .8, .8, .5]], this._firstInit = !0, this._text = null, this._lines = null, this._background = o(e);
            }
            var d = c.prototype;
            function h() {
              this.primalOffset = [0, 0, 0], this.primalMinor = [0, 0, 0], this.mirrorOffset = [0, 0, 0], this.mirrorMinor = [0, 0, 0];
            }
            d.update = function (e) {
              function t(t, n, r) {
                if (r in e) {
                  var i,
                    o = e[r],
                    a = this[r];
                  (t ? Array.isArray(o) && Array.isArray(o[0]) : Array.isArray(o)) ? this[r] = i = [n(o[0]), n(o[1]), n(o[2])] : this[r] = i = [n(o), n(o), n(o)];
                  for (var s = 0; s < 3; ++s) if (i[s] !== a[s]) return !0;
                }
                return !1;
              }
              e = e || {};
              var n,
                o = t.bind(this, !1, Number),
                a = t.bind(this, !1, Boolean),
                l = t.bind(this, !1, String),
                u = t.bind(this, !0, function (e) {
                  if (Array.isArray(e)) {
                    if (3 === e.length) return [+e[0], +e[1], +e[2], 1];
                    if (4 === e.length) return [+e[0], +e[1], +e[2], +e[3]];
                  }
                  return [0, 0, 0, 1];
                }),
                c = !1,
                d = !1;
              if ("bounds" in e) for (var h = e.bounds, f = 0; f < 2; ++f) for (var p = 0; p < 3; ++p) h[f][p] !== this.bounds[f][p] && (d = !0), this.bounds[f][p] = h[f][p];
              if ("ticks" in e) for (n = e.ticks, c = !0, this.autoTicks = !1, f = 0; f < 3; ++f) this.tickSpacing[f] = 0;else o("tickSpacing") && (this.autoTicks = !0, d = !0);
              if (this._firstInit && ("ticks" in e || "tickSpacing" in e || (this.autoTicks = !0), d = !0, c = !0, this._firstInit = !1), d && this.autoTicks && (n = s.create(this.bounds, this.tickSpacing), c = !0), c) {
                for (f = 0; f < 3; ++f) n[f].sort(function (e, t) {
                  return e.x - t.x;
                });
                s.equal(n, this.ticks) ? c = !1 : this.ticks = n;
              }
              a("tickEnable"), l("tickFont") && (c = !0), o("tickSize"), o("tickAngle"), o("tickPad"), u("tickColor");
              var m = l("labels");
              l("labelFont") && (m = !0), a("labelEnable"), o("labelSize"), o("labelPad"), u("labelColor"), a("lineEnable"), a("lineMirror"), o("lineWidth"), u("lineColor"), a("lineTickEnable"), a("lineTickMirror"), o("lineTickLength"), o("lineTickWidth"), u("lineTickColor"), a("gridEnable"), o("gridWidth"), u("gridColor"), a("zeroEnable"), u("zeroLineColor"), o("zeroLineWidth"), a("backgroundEnable"), u("backgroundColor"), this._text ? this._text && (m || c) && this._text.update(this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont) : this._text = r(this.gl, this.bounds, this.labels, this.labelFont, this.ticks, this.tickFont), this._lines && c && (this._lines.dispose(), this._lines = null), this._lines || (this._lines = i(this.gl, this.bounds, this.ticks));
            };
            var f = [new h(), new h(), new h()];
            function p(e, t, n, r, i) {
              for (var o = e.primalOffset, a = e.primalMinor, s = e.mirrorOffset, l = e.mirrorMinor, u = r[t], c = 0; c < 3; ++c) if (t !== c) {
                var d = o,
                  h = s,
                  f = a,
                  p = l;
                u & 1 << c && (d = s, h = o, f = l, p = a), d[c] = n[0][c], h[c] = n[1][c], i[c] > 0 ? (f[c] = -1, p[c] = 0) : (f[c] = 0, p[c] = 1);
              }
            }
            var m = [0, 0, 0],
              g = {
                model: l,
                view: l,
                projection: l,
                _ortho: !1
              };
            d.isOpaque = function () {
              return !0;
            }, d.isTransparent = function () {
              return !1;
            }, d.drawTransparent = function (e) {};
            var v = [0, 0, 0],
              y = [0, 0, 0],
              b = [0, 0, 0];
            d.draw = function (e) {
              e = e || g;
              for (var t = this.gl, n = e.model || l, r = e.view || l, i = e.projection || l, o = this.bounds, s = e._ortho || !1, c = a(n, r, i, o, s), d = c.cubeEdges, h = c.axis, _ = r[12], x = r[13], w = r[14], S = r[15], A = (s ? 2 : 1) * this.pixelRatio * (i[3] * _ + i[7] * x + i[11] * w + i[15] * S) / t.drawingBufferHeight, E = 0; E < 3; ++E) this.lastCubeProps.cubeEdges[E] = d[E], this.lastCubeProps.axis[E] = h[E];
              var T = f;
              for (E = 0; E < 3; ++E) p(f[E], E, this.bounds, d, h);
              t = this.gl;
              var M,
                C,
                k,
                P = m;
              for (E = 0; E < 3; ++E) this.backgroundEnable[E] ? P[E] = h[E] : P[E] = 0;
              for (this._background.draw(n, r, i, o, P, this.backgroundColor), this._lines.bind(n, r, i, this), E = 0; E < 3; ++E) {
                var O = [0, 0, 0];
                h[E] > 0 ? O[E] = o[1][E] : O[E] = o[0][E];
                for (var R = 0; R < 2; ++R) {
                  var I = (E + 1 + R) % 3,
                    j = (E + 1 + (1 ^ R)) % 3;
                  this.gridEnable[I] && this._lines.drawGrid(I, j, this.bounds, O, this.gridColor[I], this.gridWidth[I] * this.pixelRatio);
                }
                for (R = 0; R < 2; ++R) I = (E + 1 + R) % 3, j = (E + 1 + (1 ^ R)) % 3, this.zeroEnable[j] && Math.min(o[0][j], o[1][j]) <= 0 && Math.max(o[0][j], o[1][j]) >= 0 && this._lines.drawZero(I, j, this.bounds, O, this.zeroLineColor[j], this.zeroLineWidth[j] * this.pixelRatio);
              }
              for (E = 0; E < 3; ++E) {
                this.lineEnable[E] && this._lines.drawAxisLine(E, this.bounds, T[E].primalOffset, this.lineColor[E], this.lineWidth[E] * this.pixelRatio), this.lineMirror[E] && this._lines.drawAxisLine(E, this.bounds, T[E].mirrorOffset, this.lineColor[E], this.lineWidth[E] * this.pixelRatio);
                var N = u(v, T[E].primalMinor),
                  L = u(y, T[E].mirrorMinor),
                  D = this.lineTickLength;
                for (R = 0; R < 3; ++R) {
                  var B = A / n[5 * R];
                  N[R] *= D[R] * B, L[R] *= D[R] * B;
                }
                this.lineTickEnable[E] && this._lines.drawAxisTicks(E, T[E].primalOffset, N, this.lineTickColor[E], this.lineTickWidth[E] * this.pixelRatio), this.lineTickMirror[E] && this._lines.drawAxisTicks(E, T[E].mirrorOffset, L, this.lineTickColor[E], this.lineTickWidth[E] * this.pixelRatio);
              }
              function F(e) {
                (k = [0, 0, 0])[e] = 1;
              }
              function z(e, t, n) {
                var r = (e + 1) % 3,
                  i = (e + 2) % 3,
                  o = t[r],
                  a = t[i],
                  s = n[r],
                  l = n[i];
                o > 0 && l > 0 || o > 0 && l < 0 || o < 0 && l > 0 || o < 0 && l < 0 ? F(r) : (a > 0 && s > 0 || a > 0 && s < 0 || a < 0 && s > 0 || a < 0 && s < 0) && F(i);
              }
              for (this._lines.unbind(), this._text.bind(n, r, i, this.pixelRatio), E = 0; E < 3; ++E) {
                var U = T[E].primalMinor,
                  G = T[E].mirrorMinor,
                  V = u(b, T[E].primalOffset);
                for (R = 0; R < 3; ++R) this.lineTickEnable[E] && (V[R] += A * U[R] * Math.max(this.lineTickLength[R], 0) / n[5 * R]);
                var H = [0, 0, 0];
                if (H[E] = 1, this.tickEnable[E]) {
                  for (-3600 === this.tickAngle[E] ? (this.tickAngle[E] = 0, this.tickAlign[E] = "auto") : this.tickAlign[E] = -1, C = 1, "auto" === (M = [this.tickAlign[E], .5, C])[0] ? M[0] = 0 : M[0] = parseInt("" + M[0]), k = [0, 0, 0], z(E, U, G), R = 0; R < 3; ++R) V[R] += A * U[R] * this.tickPad[R] / n[5 * R];
                  this._text.drawTicks(E, this.tickSize[E], this.tickAngle[E], V, this.tickColor[E], H, k, M);
                }
                if (this.labelEnable[E]) {
                  for (C = 0, k = [0, 0, 0], this.labels[E].length > 4 && (F(E), C = 1), "auto" === (M = [this.labelAlign[E], .5, C])[0] ? M[0] = 0 : M[0] = parseInt("" + M[0]), R = 0; R < 3; ++R) V[R] += A * U[R] * this.labelPad[R] / n[5 * R];
                  V[E] += .5 * (o[0][E] + o[1][E]), this._text.drawLabel(E, this.labelSize[E], this.labelAngle[E], V, this.labelColor[E], [0, 0, 0], k, M);
                }
              }
              this._text.unbind();
            }, d.dispose = function () {
              this._text.dispose(), this._lines.dispose(), this._background.dispose(), this._lines = null, this._text = null, this._background = null, this.gl = null;
            };
          }, {
            "./lib/background.js": 97,
            "./lib/cube.js": 98,
            "./lib/lines.js": 99,
            "./lib/text.js": 101,
            "./lib/ticks.js": 102
          }],
          97: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = [], n = [], s = 0, l = 0; l < 3; ++l) for (var u = (l + 1) % 3, c = (l + 2) % 3, d = [0, 0, 0], h = [0, 0, 0], f = -1; f <= 1; f += 2) {
                n.push(s, s + 2, s + 1, s + 1, s + 2, s + 3), d[l] = f, h[l] = f;
                for (var p = -1; p <= 1; p += 2) {
                  d[u] = p;
                  for (var m = -1; m <= 1; m += 2) d[c] = m, t.push(d[0], d[1], d[2], h[0], h[1], h[2]), s += 1;
                }
                var g = u;
                u = c, c = g;
              }
              var v = r(e, new Float32Array(t)),
                y = r(e, new Uint16Array(n), e.ELEMENT_ARRAY_BUFFER),
                b = i(e, [{
                  buffer: v,
                  type: e.FLOAT,
                  size: 3,
                  offset: 0,
                  stride: 24
                }, {
                  buffer: v,
                  type: e.FLOAT,
                  size: 3,
                  offset: 12,
                  stride: 24
                }], y),
                _ = o(e);
              return _.attributes.position.location = 0, _.attributes.normal.location = 1, new a(e, v, b, _);
            };
            var r = e("gl-buffer"),
              i = e("gl-vao"),
              o = e("./shaders").bg;
            function a(e, t, n, r) {
              this.gl = e, this.buffer = t, this.vao = n, this.shader = r;
            }
            var s = a.prototype;
            s.draw = function (e, t, n, r, i, o) {
              for (var a = !1, s = 0; s < 3; ++s) a = a || i[s];
              if (a) {
                var l = this.gl;
                l.enable(l.POLYGON_OFFSET_FILL), l.polygonOffset(1, 2), this.shader.bind(), this.shader.uniforms = {
                  model: e,
                  view: t,
                  projection: n,
                  bounds: r,
                  enable: i,
                  colors: o
                }, this.vao.bind(), this.vao.draw(this.gl.TRIANGLES, 36), this.vao.unbind(), l.disable(l.POLYGON_OFFSET_FILL);
              }
            }, s.dispose = function () {
              this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
            };
          }, {
            "./shaders": 100,
            "gl-buffer": 104,
            "gl-vao": 168
          }],
          98: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, o, f) {
              i(s, t, e), i(s, n, s);
              for (var y = 0, b = 0; b < 2; ++b) {
                c[2] = o[b][2];
                for (var _ = 0; _ < 2; ++_) {
                  c[1] = o[_][1];
                  for (var x = 0; x < 2; ++x) c[0] = o[x][0], h(l[y], c, s), y += 1;
                }
              }
              var w = -1;
              for (b = 0; b < 8; ++b) {
                for (var S = l[b][3], A = 0; A < 3; ++A) u[b][A] = l[b][A] / S;
                f && (u[b][2] *= -1), S < 0 && (w < 0 || u[b][2] < u[w][2]) && (w = b);
              }
              if (w < 0) {
                w = 0;
                for (var E = 0; E < 3; ++E) {
                  for (var T = (E + 2) % 3, M = (E + 1) % 3, C = -1, k = -1, P = 0; P < 2; ++P) {
                    var O = (I = P << E) + (P << T) + (1 - P << M),
                      R = I + (1 - P << T) + (P << M);
                    a(u[I], u[O], u[R], d) < 0 || (P ? C = 1 : k = 1);
                  }
                  if (C < 0 || k < 0) k > C && (w |= 1 << E);else {
                    for (P = 0; P < 2; ++P) {
                      O = (I = P << E) + (P << T) + (1 - P << M), R = I + (1 - P << T) + (P << M);
                      var I,
                        j = p([l[I], l[O], l[R], l[I + (1 << T) + (1 << M)]]);
                      P ? C = j : k = j;
                    }
                    k > C && (w |= 1 << E);
                  }
                }
              }
              var N = 7 ^ w,
                L = -1;
              for (b = 0; b < 8; ++b) b !== w && b !== N && (L < 0 || u[L][1] > u[b][1]) && (L = b);
              var D = -1;
              for (b = 0; b < 3; ++b) (F = L ^ 1 << b) !== w && F !== N && (D < 0 && (D = F), (M = u[F])[0] < u[D][0] && (D = F));
              var B = -1;
              for (b = 0; b < 3; ++b) {
                var F;
                (F = L ^ 1 << b) !== w && F !== N && F !== D && (B < 0 && (B = F), (M = u[F])[0] > u[B][0] && (B = F));
              }
              var z = m;
              z[0] = z[1] = z[2] = 0, z[r.log2(D ^ L)] = L & D, z[r.log2(L ^ B)] = L & B;
              var U = 7 ^ B;
              U === w || U === N ? (U = 7 ^ D, z[r.log2(B ^ U)] = U & B) : z[r.log2(D ^ U)] = U & D;
              var G = g,
                V = w;
              for (E = 0; E < 3; ++E) G[E] = V & 1 << E ? -1 : 1;
              return v;
            };
            var r = e("bit-twiddle"),
              i = e("gl-mat4/multiply"),
              o = e("split-polygon"),
              a = e("robust-orientation"),
              s = new Array(16),
              l = new Array(8),
              u = new Array(8),
              c = new Array(3),
              d = [0, 0, 0];
            function h(e, t, n) {
              for (var r = 0; r < 4; ++r) {
                e[r] = n[12 + r];
                for (var i = 0; i < 3; ++i) e[r] += t[i] * n[4 * i + r];
              }
            }
            !function () {
              for (var e = 0; e < 8; ++e) l[e] = [1, 1, 1, 1], u[e] = [1, 1, 1];
            }();
            var f = [[0, 0, 1, 0, 0], [0, 0, -1, 1, 0], [0, -1, 0, 1, 0], [0, 1, 0, 1, 0], [-1, 0, 0, 1, 0], [1, 0, 0, 1, 0]];
            function p(e) {
              for (var t = 0; t < f.length; ++t) if ((e = o.positive(e, f[t])).length < 3) return 0;
              var n = e[0],
                r = n[0] / n[3],
                i = n[1] / n[3],
                a = 0;
              for (t = 1; t + 1 < e.length; ++t) {
                var s = e[t],
                  l = e[t + 1],
                  u = s[0] / s[3] - r,
                  c = s[1] / s[3] - i,
                  d = l[0] / l[3] - r,
                  h = l[1] / l[3] - i;
                a += Math.abs(u * h - c * d);
              }
              return a;
            }
            var m = [1, 1, 1],
              g = [0, 0, 0],
              v = {
                cubeEdges: m,
                axis: g
              };
          }, {
            "bit-twiddle": 37,
            "gl-mat4/multiply": 127,
            "robust-orientation": 321,
            "split-polygon": 338
          }],
          99: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              var a = [],
                s = [0, 0, 0],
                l = [0, 0, 0],
                u = [0, 0, 0],
                c = [0, 0, 0];
              a.push(0, 0, 1, 0, 1, 1, 0, 0, -1, 0, 0, -1, 0, 1, 1, 0, 1, -1);
              for (var d = 0; d < 3; ++d) {
                for (var h = a.length / 3 | 0, p = 0; p < n[d].length; ++p) {
                  var m = +n[d][p].x;
                  a.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
                }
                var g = a.length / 3 | 0;
                s[d] = h, l[d] = g - h, h = a.length / 3 | 0;
                for (var v = 0; v < n[d].length; ++v) m = +n[d][v].x, a.push(m, 0, 1, m, 1, 1, m, 0, -1, m, 0, -1, m, 1, 1, m, 1, -1);
                g = a.length / 3 | 0, u[d] = h, c[d] = g - h;
              }
              var y = r(e, new Float32Array(a)),
                b = i(e, [{
                  buffer: y,
                  type: e.FLOAT,
                  size: 3,
                  stride: 0,
                  offset: 0
                }]),
                _ = o(e);
              return _.attributes.position.location = 0, new f(e, y, b, _, l, s, c, u);
            };
            var r = e("gl-buffer"),
              i = e("gl-vao"),
              o = e("./shaders").line,
              a = [0, 0, 0],
              s = [0, 0, 0],
              l = [0, 0, 0],
              u = [0, 0, 0],
              c = [1, 1];
            function d(e) {
              return e[0] = e[1] = e[2] = 0, e;
            }
            function h(e, t) {
              return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
            }
            function f(e, t, n, r, i, o, a, s) {
              this.gl = e, this.vertBuffer = t, this.vao = n, this.shader = r, this.tickCount = i, this.tickOffset = o, this.gridCount = a, this.gridOffset = s;
            }
            var p = f.prototype;
            p.bind = function (e, t, n) {
              this.shader.bind(), this.shader.uniforms.model = e, this.shader.uniforms.view = t, this.shader.uniforms.projection = n, c[0] = this.gl.drawingBufferWidth, c[1] = this.gl.drawingBufferHeight, this.shader.uniforms.screenShape = c, this.vao.bind();
            }, p.unbind = function () {
              this.vao.unbind();
            }, p.drawAxisLine = function (e, t, n, r, i) {
              var o = d(s);
              this.shader.uniforms.majorAxis = s, o[e] = t[1][e] - t[0][e], this.shader.uniforms.minorAxis = o;
              var a,
                c = h(u, n);
              c[e] += t[0][e], this.shader.uniforms.offset = c, this.shader.uniforms.lineWidth = i, this.shader.uniforms.color = r, (a = d(l))[(e + 2) % 3] = 1, this.shader.uniforms.screenAxis = a, this.vao.draw(this.gl.TRIANGLES, 6), (a = d(l))[(e + 1) % 3] = 1, this.shader.uniforms.screenAxis = a, this.vao.draw(this.gl.TRIANGLES, 6);
            }, p.drawAxisTicks = function (e, t, n, r, i) {
              if (this.tickCount[e]) {
                var o = d(a);
                o[e] = 1, this.shader.uniforms.majorAxis = o, this.shader.uniforms.offset = t, this.shader.uniforms.minorAxis = n, this.shader.uniforms.color = r, this.shader.uniforms.lineWidth = i;
                var s = d(l);
                s[e] = 1, this.shader.uniforms.screenAxis = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[e], this.tickOffset[e]);
              }
            }, p.drawGrid = function (e, t, n, r, i, o) {
              if (this.gridCount[e]) {
                var c = d(s);
                c[t] = n[1][t] - n[0][t], this.shader.uniforms.minorAxis = c;
                var f = h(u, r);
                f[t] += n[0][t], this.shader.uniforms.offset = f;
                var p = d(a);
                p[e] = 1, this.shader.uniforms.majorAxis = p;
                var m = d(l);
                m[e] = 1, this.shader.uniforms.screenAxis = m, this.shader.uniforms.lineWidth = o, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, this.gridCount[e], this.gridOffset[e]);
              }
            }, p.drawZero = function (e, t, n, r, i, o) {
              var a = d(s);
              this.shader.uniforms.majorAxis = a, a[e] = n[1][e] - n[0][e], this.shader.uniforms.minorAxis = a;
              var c = h(u, r);
              c[e] += n[0][e], this.shader.uniforms.offset = c;
              var f = d(l);
              f[t] = 1, this.shader.uniforms.screenAxis = f, this.shader.uniforms.lineWidth = o, this.shader.uniforms.color = i, this.vao.draw(this.gl.TRIANGLES, 6);
            }, p.dispose = function () {
              this.vao.dispose(), this.vertBuffer.dispose(), this.shader.dispose();
            };
          }, {
            "./shaders": 100,
            "gl-buffer": 104,
            "gl-vao": 168
          }],
          100: [function (e, t, n) {
            "use strict";

            var r = e("glslify"),
              i = e("gl-shader"),
              o = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"]),
              a = r(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);
            n.line = function (e) {
              return i(e, o, a, null, [{
                name: "position",
                type: "vec3"
              }]);
            };
            var s = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}"]),
              l = r(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"]);
            n.text = function (e) {
              return i(e, s, l, null, [{
                name: "position",
                type: "vec3"
              }]);
            };
            var u = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * view * model * vec4(nPosition, 1.0);\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}"]),
              c = r(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"]);
            n.bg = function (e) {
              return i(e, u, c, null, [{
                name: "position",
                type: "vec3"
              }, {
                name: "normal",
                type: "vec3"
              }]);
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          101: [function (e, t, n) {
            (function (n) {
              "use strict";

              t.exports = function (e, t, n, o, s, l) {
                var c = r(e),
                  d = i(e, [{
                    buffer: c,
                    size: 3
                  }]),
                  h = a(e);
                h.attributes.position.location = 0;
                var f = new u(e, h, c, d);
                return f.update(t, n, o, s, l), f;
              };
              var r = e("gl-buffer"),
                i = e("gl-vao"),
                o = e("vectorize-text"),
                a = e("./shaders").text,
                s = window || n.global || {},
                l = s.__TEXT_CACHE || {};
              function u(e, t, n, r) {
                this.gl = e, this.shader = t, this.buffer = n, this.vao = r, this.tickOffset = this.tickCount = this.labelOffset = this.labelCount = null;
              }
              s.__TEXT_CACHE = {};
              var c = u.prototype,
                d = [0, 0];
              c.bind = function (e, t, n, r) {
                this.vao.bind(), this.shader.bind();
                var i = this.shader.uniforms;
                i.model = e, i.view = t, i.projection = n, i.pixelScale = r, d[0] = this.gl.drawingBufferWidth, d[1] = this.gl.drawingBufferHeight, this.shader.uniforms.resolution = d;
              }, c.unbind = function () {
                this.vao.unbind();
              }, c.update = function (e, t, n, r, i) {
                var a = [];
                function s(e, t, n, r, i, s) {
                  var u = l[n];
                  u || (u = l[n] = {});
                  var c = u[t];
                  c || (c = u[t] = function (e, t) {
                    try {
                      return o(e, t);
                    } catch (t) {
                      return console.warn('error vectorizing text:"' + e + '" error:', t), {
                        cells: [],
                        positions: []
                      };
                    }
                  }(t, {
                    triangles: !0,
                    font: n,
                    textAlign: "center",
                    textBaseline: "middle",
                    lineSpacing: i,
                    styletags: s
                  }));
                  for (var d = (r || 12) / 12, h = c.positions, f = c.cells, p = 0, m = f.length; p < m; ++p) for (var g = f[p], v = 2; v >= 0; --v) {
                    var y = h[g[v]];
                    a.push(d * y[0], -d * y[1], e);
                  }
                }
                for (var u = [0, 0, 0], c = [0, 0, 0], d = [0, 0, 0], h = [0, 0, 0], f = {
                    breaklines: !0,
                    bolds: !0,
                    italics: !0,
                    subscripts: !0,
                    superscripts: !0
                  }, p = 0; p < 3; ++p) {
                  d[p] = a.length / 3 | 0, s(.5 * (e[0][p] + e[1][p]), t[p], n[p], 12, 1.25, f), h[p] = (a.length / 3 | 0) - d[p], u[p] = a.length / 3 | 0;
                  for (var m = 0; m < r[p].length; ++m) r[p][m].text && s(r[p][m].x, r[p][m].text, r[p][m].font || i, r[p][m].fontSize || 12, 1.25, f);
                  c[p] = (a.length / 3 | 0) - u[p];
                }
                this.buffer.update(a), this.tickOffset = u, this.tickCount = c, this.labelOffset = d, this.labelCount = h;
              }, c.drawTicks = function (e, t, n, r, i, o, a, s) {
                this.tickCount[e] && (this.shader.uniforms.axis = o, this.shader.uniforms.color = i, this.shader.uniforms.angle = n, this.shader.uniforms.scale = t, this.shader.uniforms.offset = r, this.shader.uniforms.alignDir = a, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.tickCount[e], this.tickOffset[e]));
              }, c.drawLabel = function (e, t, n, r, i, o, a, s) {
                this.labelCount[e] && (this.shader.uniforms.axis = o, this.shader.uniforms.color = i, this.shader.uniforms.angle = n, this.shader.uniforms.scale = t, this.shader.uniforms.offset = r, this.shader.uniforms.alignDir = a, this.shader.uniforms.alignOpt = s, this.vao.draw(this.gl.TRIANGLES, this.labelCount[e], this.labelOffset[e]));
              }, c.dispose = function () {
                this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
              };
            }).call(this, e("_process"));
          }, {
            "./shaders": 100,
            _process: 307,
            "gl-buffer": 104,
            "gl-vao": 168,
            "vectorize-text": 350
          }],
          102: [function (e, t, n) {
            "use strict";

            function r(e, t) {
              var n = e + "",
                r = n.indexOf("."),
                i = 0;
              r >= 0 && (i = n.length - r - 1);
              var o = Math.pow(10, i),
                a = Math.round(e * t * o),
                s = a + "";
              if (s.indexOf("e") >= 0) return s;
              var l = a / o,
                u = a % o;
              a < 0 ? (l = 0 | -Math.ceil(l), u = 0 | -u) : (l = 0 | Math.floor(l), u |= 0);
              var c = "" + l;
              if (a < 0 && (c = "-" + c), i) {
                for (var d = "" + u; d.length < i;) d = "0" + d;
                return c + "." + d;
              }
              return c;
            }
            n.create = function (e, t) {
              for (var n = [], i = 0; i < 3; ++i) {
                for (var o = [], a = (e[0][i], e[1][i], 0); a * t[i] <= e[1][i]; ++a) o.push({
                  x: a * t[i],
                  text: r(t[i], a)
                });
                for (a = -1; a * t[i] >= e[0][i]; --a) o.push({
                  x: a * t[i],
                  text: r(t[i], a)
                });
                n.push(o);
              }
              return n;
            }, n.equal = function (e, t) {
              for (var n = 0; n < 3; ++n) {
                if (e[n].length !== t[n].length) return !1;
                for (var r = 0; r < e[n].length; ++r) {
                  var i = e[n][r],
                    o = t[n][r];
                  if (i.x !== o.x || i.text !== o.text || i.font !== o.font || i.fontColor !== o.fontColor || i.fontSize !== o.fontSize || i.dx !== o.dx || i.dy !== o.dy) return !1;
                }
              }
              return !0;
            };
          }, {}],
          103: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, l, d) {
              var h = t.model || u,
                f = t.view || u,
                v = t.projection || u,
                y = t._ortho || !1,
                b = e.bounds,
                _ = (d = d || o(h, f, v, b, y)).axis;
              a(c, f, h), a(c, v, c);
              for (var x = m, w = 0; w < 3; ++w) x[w].lo = 1 / 0, x[w].hi = -1 / 0, x[w].pixelsPerDataUnit = 1 / 0;
              var S = r(s(c, c));
              s(c, c);
              for (var A = 0; A < 3; ++A) {
                var E = (A + 1) % 3,
                  T = (A + 2) % 3,
                  M = g;
                e: for (w = 0; w < 2; ++w) {
                  var C = [];
                  if (_[A] < 0 != !!w) {
                    M[A] = b[w][A];
                    for (var k = 0; k < 2; ++k) {
                      M[E] = b[k ^ w][E];
                      for (var P = 0; P < 2; ++P) M[T] = b[P ^ k ^ w][T], C.push(M.slice());
                    }
                    var O = y ? 5 : 4;
                    for (k = O; k === O; ++k) {
                      if (0 === C.length) continue e;
                      C = i.positive(C, S[k]);
                    }
                    for (k = 0; k < C.length; ++k) {
                      T = C[k];
                      var R = p(g, c, T, n, l);
                      for (P = 0; P < 3; ++P) x[P].lo = Math.min(x[P].lo, T[P]), x[P].hi = Math.max(x[P].hi, T[P]), P !== A && (x[P].pixelsPerDataUnit = Math.min(x[P].pixelsPerDataUnit, Math.abs(R[P])));
                    }
                  }
                }
              }
              return x;
            };
            var r = e("extract-frustum-planes"),
              i = e("split-polygon"),
              o = e("./lib/cube.js"),
              a = e("gl-mat4/multiply"),
              s = e("gl-mat4/transpose"),
              l = e("gl-vec4/transformMat4"),
              u = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
              c = new Float32Array(16);
            function d(e, t, n) {
              this.lo = e, this.hi = t, this.pixelsPerDataUnit = n;
            }
            var h = [0, 0, 0, 1],
              f = [0, 0, 0, 1];
            function p(e, t, n, r, i) {
              for (var o = 0; o < 3; ++o) {
                for (var a = h, s = f, u = 0; u < 3; ++u) s[u] = a[u] = n[u];
                s[3] = a[3] = 1, s[o] += 1, l(s, s, t), s[3] < 0 && (e[o] = 1 / 0), a[o] -= 1, l(a, a, t), a[3] < 0 && (e[o] = 1 / 0);
                var c = (a[0] / a[3] - s[0] / s[3]) * r,
                  d = (a[1] / a[3] - s[1] / s[3]) * i;
                e[o] = .25 * Math.sqrt(c * c + d * d);
              }
              return e;
            }
            var m = [new d(1 / 0, -1 / 0, 1 / 0), new d(1 / 0, -1 / 0, 1 / 0), new d(1 / 0, -1 / 0, 1 / 0)],
              g = [0, 0, 0];
          }, {
            "./lib/cube.js": 98,
            "extract-frustum-planes": 90,
            "gl-mat4/multiply": 127,
            "gl-mat4/transpose": 136,
            "gl-vec4/transformMat4": 239,
            "split-polygon": 338
          }],
          104: [function (e, t, n) {
            "use strict";

            var r = e("typedarray-pool"),
              i = e("ndarray-ops"),
              o = e("ndarray"),
              a = ["uint8", "uint8_clamped", "uint16", "uint32", "int8", "int16", "int32", "float32"];
            function s(e, t, n, r, i) {
              this.gl = e, this.type = t, this.handle = n, this.length = r, this.usage = i;
            }
            var l = s.prototype;
            function u(e, t, n, r, i, o) {
              var a = i.length * i.BYTES_PER_ELEMENT;
              if (o < 0) return e.bufferData(t, i, r), a;
              if (a + o > n) throw new Error("gl-buffer: If resizing buffer, must not specify offset");
              return e.bufferSubData(t, o, i), n;
            }
            function c(e, t) {
              for (var n = r.malloc(e.length, t), i = e.length, o = 0; o < i; ++o) n[o] = e[o];
              return n;
            }
            l.bind = function () {
              this.gl.bindBuffer(this.type, this.handle);
            }, l.unbind = function () {
              this.gl.bindBuffer(this.type, null);
            }, l.dispose = function () {
              this.gl.deleteBuffer(this.handle);
            }, l.update = function (e, t) {
              if ("number" != typeof t && (t = -1), this.bind(), "object" == typeof e && void 0 !== e.shape) {
                var n = e.dtype;
                if (a.indexOf(n) < 0 && (n = "float32"), this.type === this.gl.ELEMENT_ARRAY_BUFFER && (n = gl.getExtension("OES_element_index_uint") && "uint16" !== n ? "uint32" : "uint16"), n === e.dtype && function (e, t) {
                  for (var n = 1, r = t.length - 1; r >= 0; --r) {
                    if (t[r] !== n) return !1;
                    n *= e[r];
                  }
                  return !0;
                }(e.shape, e.stride)) 0 === e.offset && e.data.length === e.shape[0] ? this.length = u(this.gl, this.type, this.length, this.usage, e.data, t) : this.length = u(this.gl, this.type, this.length, this.usage, e.data.subarray(e.offset, e.shape[0]), t);else {
                  var s = r.malloc(e.size, n),
                    l = o(s, e.shape);
                  i.assign(l, e), this.length = u(this.gl, this.type, this.length, this.usage, t < 0 ? s : s.subarray(0, e.size), t), r.free(s);
                }
              } else if (Array.isArray(e)) {
                var d;
                d = this.type === this.gl.ELEMENT_ARRAY_BUFFER ? c(e, "uint16") : c(e, "float32"), this.length = u(this.gl, this.type, this.length, this.usage, t < 0 ? d : d.subarray(0, e.length), t), r.free(d);
              } else if ("object" == typeof e && "number" == typeof e.length) this.length = u(this.gl, this.type, this.length, this.usage, e, t);else {
                if ("number" != typeof e && void 0 !== e) throw new Error("gl-buffer: Invalid data type");
                if (t >= 0) throw new Error("gl-buffer: Cannot specify offset when resizing buffer");
                (e |= 0) <= 0 && (e = 1), this.gl.bufferData(this.type, 0 | e, this.usage), this.length = e;
              }
            }, t.exports = function (e, t, n, r) {
              if (n = n || e.ARRAY_BUFFER, r = r || e.DYNAMIC_DRAW, n !== e.ARRAY_BUFFER && n !== e.ELEMENT_ARRAY_BUFFER) throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");
              if (r !== e.DYNAMIC_DRAW && r !== e.STATIC_DRAW && r !== e.STREAM_DRAW) throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");
              var i = e.createBuffer(),
                o = new s(e, n, i, 0, r);
              return o.update(t), o;
            };
          }, {
            ndarray: 285,
            "ndarray-ops": 279,
            "typedarray-pool": 347
          }],
          105: [function (e, t, n) {
            "use strict";

            var r = e("gl-vec3");
            t.exports = function (e, t) {
              var n = e.positions,
                i = e.vectors,
                o = {
                  positions: [],
                  vertexIntensity: [],
                  vertexIntensityBounds: e.vertexIntensityBounds,
                  vectors: [],
                  cells: [],
                  coneOffset: e.coneOffset,
                  colormap: e.colormap
                };
              if (0 === e.positions.length) return t && (t[0] = [0, 0, 0], t[1] = [0, 0, 0]), o;
              for (var a = 0, s = 1 / 0, l = -1 / 0, u = 1 / 0, c = -1 / 0, d = 1 / 0, h = -1 / 0, f = null, p = null, m = [], g = 1 / 0, v = !1, y = 0; y < n.length; y++) {
                var b = n[y];
                s = Math.min(b[0], s), l = Math.max(b[0], l), u = Math.min(b[1], u), c = Math.max(b[1], c), d = Math.min(b[2], d), h = Math.max(b[2], h);
                var _ = i[y];
                if (r.length(_) > a && (a = r.length(_)), y) {
                  var x = 2 * r.distance(f, b) / (r.length(p) + r.length(_));
                  x ? (g = Math.min(g, x), v = !1) : v = !0;
                }
                v || (f = b, p = _), m.push(_);
              }
              var w = [s, u, d],
                S = [l, c, h];
              t && (t[0] = w, t[1] = S), 0 === a && (a = 1);
              var A = 1 / a;
              isFinite(g) || (g = 1), o.vectorScale = g;
              var E = e.coneSize || .5;
              e.absoluteConeSize && (E = e.absoluteConeSize * A), o.coneScale = E, y = 0;
              for (var T = 0; y < n.length; y++) for (var M = (b = n[y])[0], C = b[1], k = b[2], P = m[y], O = r.length(P) * A, R = 0; R < 8; R++) {
                o.positions.push([M, C, k, T++]), o.positions.push([M, C, k, T++]), o.positions.push([M, C, k, T++]), o.positions.push([M, C, k, T++]), o.positions.push([M, C, k, T++]), o.positions.push([M, C, k, T++]), o.vectors.push(P), o.vectors.push(P), o.vectors.push(P), o.vectors.push(P), o.vectors.push(P), o.vectors.push(P), o.vertexIntensity.push(O, O, O), o.vertexIntensity.push(O, O, O);
                var I = o.positions.length;
                o.cells.push([I - 6, I - 5, I - 4], [I - 3, I - 2, I - 1]);
              }
              return o;
            };
            var i = e("./lib/shaders");
            t.exports.createMesh = e("./create_mesh"), t.exports.createConeMesh = function (e, n) {
              return t.exports.createMesh(e, n, {
                shaders: i,
                traceType: "cone"
              });
            };
          }, {
            "./create_mesh": 106,
            "./lib/shaders": 107,
            "gl-vec3": 187
          }],
          106: [function (e, t, n) {
            "use strict";

            var r = e("gl-shader"),
              i = e("gl-buffer"),
              o = e("gl-vao"),
              a = e("gl-texture2d"),
              s = e("gl-mat4/multiply"),
              l = e("gl-mat4/invert"),
              u = e("ndarray"),
              c = e("colormap"),
              d = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            function h(e, t, n, r, i, o, a, s, l, u, c) {
              this.gl = e, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = t, this.dirty = !0, this.triShader = n, this.pickShader = r, this.trianglePositions = i, this.triangleVectors = o, this.triangleColors = s, this.triangleUVs = l, this.triangleIds = a, this.triangleVAO = u, this.triangleCount = 0, this.pickId = 1, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.lightPosition = [1e5, 1e5, 0], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.traceType = c, this.tubeScale = 1, this.coneScale = 2, this.vectorScale = 1, this.coneOffset = .25, this._model = d, this._view = d, this._projection = d, this._resolution = [1, 1];
            }
            var f = h.prototype;
            f.isOpaque = function () {
              return this.opacity >= 1;
            }, f.isTransparent = function () {
              return this.opacity < 1;
            }, f.pickSlots = 1, f.setPickBase = function (e) {
              this.pickId = e;
            }, f.update = function (e) {
              e = e || {};
              var t = this.gl;
              this.dirty = !0, "lightPosition" in e && (this.lightPosition = e.lightPosition), "opacity" in e && (this.opacity = e.opacity), "ambient" in e && (this.ambientLight = e.ambient), "diffuse" in e && (this.diffuseLight = e.diffuse), "specular" in e && (this.specularLight = e.specular), "roughness" in e && (this.roughness = e.roughness), "fresnel" in e && (this.fresnel = e.fresnel), void 0 !== e.tubeScale && (this.tubeScale = e.tubeScale), void 0 !== e.vectorScale && (this.vectorScale = e.vectorScale), void 0 !== e.coneScale && (this.coneScale = e.coneScale), void 0 !== e.coneOffset && (this.coneOffset = e.coneOffset), e.colormap && (this.texture.shape = [256, 256], this.texture.minFilter = t.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = t.LINEAR, this.texture.setPixels(function (e) {
                for (var t = c({
                    colormap: e,
                    nshades: 256,
                    format: "rgba"
                  }), n = new Uint8Array(1024), r = 0; r < 256; ++r) {
                  for (var i = t[r], o = 0; o < 3; ++o) n[4 * r + o] = i[o];
                  n[4 * r + 3] = 255 * i[3];
                }
                return u(n, [256, 256, 4], [4, 0, 1]);
              }(e.colormap)), this.texture.generateMipmap());
              var n = e.cells,
                r = e.positions,
                i = e.vectors;
              if (r && n && i) {
                var o = [],
                  a = [],
                  s = [],
                  l = [],
                  d = [];
                this.cells = n, this.positions = r, this.vectors = i;
                var h = e.meshColor || [1, 1, 1, 1],
                  f = e.vertexIntensity,
                  p = 1 / 0,
                  m = -1 / 0;
                if (f) {
                  if (e.vertexIntensityBounds) p = +e.vertexIntensityBounds[0], m = +e.vertexIntensityBounds[1];else for (var g = 0; g < f.length; ++g) {
                    var v = f[g];
                    p = Math.min(p, v), m = Math.max(m, v);
                  }
                } else for (g = 0; g < r.length; ++g) v = r[g][2], p = Math.min(p, v), m = Math.max(m, v);
                for (this.intensity = f || function (e) {
                  for (var t = e.length, n = new Array(t), r = 0; r < t; ++r) n[r] = e[r][2];
                  return n;
                }(r), this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], g = 0; g < r.length; ++g) for (var y = r[g], b = 0; b < 3; ++b) !isNaN(y[b]) && isFinite(y[b]) && (this.bounds[0][b] = Math.min(this.bounds[0][b], y[b]), this.bounds[1][b] = Math.max(this.bounds[1][b], y[b]));
                var _ = 0;
                e: for (g = 0; g < n.length; ++g) {
                  var x = n[g];
                  switch (x.length) {
                    case 3:
                      for (b = 0; b < 3; ++b) {
                        y = r[S = x[b]];
                        for (var w = 0; w < 3; ++w) if (isNaN(y[w]) || !isFinite(y[w])) continue e;
                      }
                      for (b = 0; b < 3; ++b) {
                        var S;
                        y = r[S = x[2 - b]], o.push(y[0], y[1], y[2], y[3]);
                        var A = i[S];
                        a.push(A[0], A[1], A[2], A[3] || 0);
                        var E,
                          T = h;
                        3 === T.length ? s.push(T[0], T[1], T[2], 1) : s.push(T[0], T[1], T[2], T[3]), E = f ? [(f[S] - p) / (m - p), 0] : [(y[2] - p) / (m - p), 0], l.push(E[0], E[1]), d.push(g);
                      }
                      _ += 1;
                  }
                }
                this.triangleCount = _, this.trianglePositions.update(o), this.triangleVectors.update(a), this.triangleColors.update(s), this.triangleUVs.update(l), this.triangleIds.update(new Uint32Array(d));
              }
            }, f.drawTransparent = f.draw = function (e) {
              e = e || {};
              for (var t = this.gl, n = e.model || d, r = e.view || d, i = e.projection || d, o = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], a = 0; a < 3; ++a) o[0][a] = Math.max(o[0][a], this.clipBounds[0][a]), o[1][a] = Math.min(o[1][a], this.clipBounds[1][a]);
              var u = {
                model: n,
                view: r,
                projection: i,
                inverseModel: d.slice(),
                clipBounds: o,
                kambient: this.ambientLight,
                kdiffuse: this.diffuseLight,
                kspecular: this.specularLight,
                roughness: this.roughness,
                fresnel: this.fresnel,
                eyePosition: [0, 0, 0],
                lightPosition: [0, 0, 0],
                opacity: this.opacity,
                tubeScale: this.tubeScale,
                vectorScale: this.vectorScale,
                coneScale: this.coneScale,
                coneOffset: this.coneOffset,
                texture: 0
              };
              u.inverseModel = l(u.inverseModel, u.model), t.disable(t.CULL_FACE), this.texture.bind(0);
              var c = new Array(16);
              for (s(c, u.view, u.model), s(c, u.projection, c), l(c, c), a = 0; a < 3; ++a) u.eyePosition[a] = c[12 + a] / c[15];
              var h = c[15];
              for (a = 0; a < 3; ++a) h += this.lightPosition[a] * c[4 * a + 3];
              for (a = 0; a < 3; ++a) {
                for (var f = c[12 + a], p = 0; p < 3; ++p) f += c[4 * p + a] * this.lightPosition[p];
                u.lightPosition[a] = f / h;
              }
              if (this.triangleCount > 0) {
                var m = this.triShader;
                m.bind(), m.uniforms = u, this.triangleVAO.bind(), t.drawArrays(t.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind();
              }
            }, f.drawPick = function (e) {
              e = e || {};
              for (var t = this.gl, n = e.model || d, r = e.view || d, i = e.projection || d, o = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], a = 0; a < 3; ++a) o[0][a] = Math.max(o[0][a], this.clipBounds[0][a]), o[1][a] = Math.min(o[1][a], this.clipBounds[1][a]);
              this._model = [].slice.call(n), this._view = [].slice.call(r), this._projection = [].slice.call(i), this._resolution = [t.drawingBufferWidth, t.drawingBufferHeight];
              var s = {
                  model: n,
                  view: r,
                  projection: i,
                  clipBounds: o,
                  tubeScale: this.tubeScale,
                  vectorScale: this.vectorScale,
                  coneScale: this.coneScale,
                  coneOffset: this.coneOffset,
                  pickId: this.pickId / 255
                },
                l = this.pickShader;
              l.bind(), l.uniforms = s, this.triangleCount > 0 && (this.triangleVAO.bind(), t.drawArrays(t.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind());
            }, f.pick = function (e) {
              if (!e) return null;
              if (e.id !== this.pickId) return null;
              var t = e.value[0] + 256 * e.value[1] + 65536 * e.value[2],
                n = this.cells[t],
                r = this.positions[n[1]].slice(0, 3),
                i = {
                  position: r,
                  dataCoordinate: r,
                  index: Math.floor(n[1] / 48)
                };
              return "cone" === this.traceType ? i.index = Math.floor(n[1] / 48) : "streamtube" === this.traceType && (i.intensity = this.intensity[n[1]], i.velocity = this.vectors[n[1]].slice(0, 3), i.divergence = this.vectors[n[1]][3], i.index = t), i;
            }, f.dispose = function () {
              this.texture.dispose(), this.triShader.dispose(), this.pickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleVectors.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleIds.dispose();
            }, t.exports = function (e, t, n) {
              var s = n.shaders;
              1 === arguments.length && (e = (t = e).gl);
              var l = function (e, t) {
                  var n = r(e, t.meshShader.vertex, t.meshShader.fragment, null, t.meshShader.attributes);
                  return n.attributes.position.location = 0, n.attributes.color.location = 2, n.attributes.uv.location = 3, n.attributes.vector.location = 4, n;
                }(e, s),
                c = function (e, t) {
                  var n = r(e, t.pickShader.vertex, t.pickShader.fragment, null, t.pickShader.attributes);
                  return n.attributes.position.location = 0, n.attributes.id.location = 1, n.attributes.vector.location = 4, n;
                }(e, s),
                d = a(e, u(new Uint8Array([255, 255, 255, 255]), [1, 1, 4]));
              d.generateMipmap(), d.minFilter = e.LINEAR_MIPMAP_LINEAR, d.magFilter = e.LINEAR;
              var f = i(e),
                p = i(e),
                m = i(e),
                g = i(e),
                v = i(e),
                y = new h(e, d, l, c, f, p, v, m, g, o(e, [{
                  buffer: f,
                  type: e.FLOAT,
                  size: 4
                }, {
                  buffer: v,
                  type: e.UNSIGNED_BYTE,
                  size: 4,
                  normalized: !0
                }, {
                  buffer: m,
                  type: e.FLOAT,
                  size: 4
                }, {
                  buffer: g,
                  type: e.FLOAT,
                  size: 2
                }, {
                  buffer: p,
                  type: e.FLOAT,
                  size: 4
                }]), n.traceType || "cone");
              return y.update(t), y;
            };
          }, {
            colormap: 69,
            "gl-buffer": 104,
            "gl-mat4/invert": 125,
            "gl-mat4/multiply": 127,
            "gl-shader": 150,
            "gl-texture2d": 164,
            "gl-vao": 168,
            ndarray: 285
          }],
          107: [function (e, t, n) {
            var r = e("glslify"),
              i = r(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]),
              o = r(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]),
              a = r(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * view * conePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]),
              s = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
            n.meshShader = {
              vertex: i,
              fragment: o,
              attributes: [{
                name: "position",
                type: "vec4"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "uv",
                type: "vec2"
              }, {
                name: "vector",
                type: "vec3"
              }]
            }, n.pickShader = {
              vertex: a,
              fragment: s,
              attributes: [{
                name: "position",
                type: "vec4"
              }, {
                name: "id",
                type: "vec4"
              }, {
                name: "vector",
                type: "vec3"
              }]
            };
          }, {
            glslify: 249
          }],
          108: [function (e, t, n) {
            t.exports = {
              0: "NONE",
              1: "ONE",
              2: "LINE_LOOP",
              3: "LINE_STRIP",
              4: "TRIANGLES",
              5: "TRIANGLE_STRIP",
              6: "TRIANGLE_FAN",
              256: "DEPTH_BUFFER_BIT",
              512: "NEVER",
              513: "LESS",
              514: "EQUAL",
              515: "LEQUAL",
              516: "GREATER",
              517: "NOTEQUAL",
              518: "GEQUAL",
              519: "ALWAYS",
              768: "SRC_COLOR",
              769: "ONE_MINUS_SRC_COLOR",
              770: "SRC_ALPHA",
              771: "ONE_MINUS_SRC_ALPHA",
              772: "DST_ALPHA",
              773: "ONE_MINUS_DST_ALPHA",
              774: "DST_COLOR",
              775: "ONE_MINUS_DST_COLOR",
              776: "SRC_ALPHA_SATURATE",
              1024: "STENCIL_BUFFER_BIT",
              1028: "FRONT",
              1029: "BACK",
              1032: "FRONT_AND_BACK",
              1280: "INVALID_ENUM",
              1281: "INVALID_VALUE",
              1282: "INVALID_OPERATION",
              1285: "OUT_OF_MEMORY",
              1286: "INVALID_FRAMEBUFFER_OPERATION",
              2304: "CW",
              2305: "CCW",
              2849: "LINE_WIDTH",
              2884: "CULL_FACE",
              2885: "CULL_FACE_MODE",
              2886: "FRONT_FACE",
              2928: "DEPTH_RANGE",
              2929: "DEPTH_TEST",
              2930: "DEPTH_WRITEMASK",
              2931: "DEPTH_CLEAR_VALUE",
              2932: "DEPTH_FUNC",
              2960: "STENCIL_TEST",
              2961: "STENCIL_CLEAR_VALUE",
              2962: "STENCIL_FUNC",
              2963: "STENCIL_VALUE_MASK",
              2964: "STENCIL_FAIL",
              2965: "STENCIL_PASS_DEPTH_FAIL",
              2966: "STENCIL_PASS_DEPTH_PASS",
              2967: "STENCIL_REF",
              2968: "STENCIL_WRITEMASK",
              2978: "VIEWPORT",
              3024: "DITHER",
              3042: "BLEND",
              3088: "SCISSOR_BOX",
              3089: "SCISSOR_TEST",
              3106: "COLOR_CLEAR_VALUE",
              3107: "COLOR_WRITEMASK",
              3317: "UNPACK_ALIGNMENT",
              3333: "PACK_ALIGNMENT",
              3379: "MAX_TEXTURE_SIZE",
              3386: "MAX_VIEWPORT_DIMS",
              3408: "SUBPIXEL_BITS",
              3410: "RED_BITS",
              3411: "GREEN_BITS",
              3412: "BLUE_BITS",
              3413: "ALPHA_BITS",
              3414: "DEPTH_BITS",
              3415: "STENCIL_BITS",
              3553: "TEXTURE_2D",
              4352: "DONT_CARE",
              4353: "FASTEST",
              4354: "NICEST",
              5120: "BYTE",
              5121: "UNSIGNED_BYTE",
              5122: "SHORT",
              5123: "UNSIGNED_SHORT",
              5124: "INT",
              5125: "UNSIGNED_INT",
              5126: "FLOAT",
              5386: "INVERT",
              5890: "TEXTURE",
              6401: "STENCIL_INDEX",
              6402: "DEPTH_COMPONENT",
              6406: "ALPHA",
              6407: "RGB",
              6408: "RGBA",
              6409: "LUMINANCE",
              6410: "LUMINANCE_ALPHA",
              7680: "KEEP",
              7681: "REPLACE",
              7682: "INCR",
              7683: "DECR",
              7936: "VENDOR",
              7937: "RENDERER",
              7938: "VERSION",
              9728: "NEAREST",
              9729: "LINEAR",
              9984: "NEAREST_MIPMAP_NEAREST",
              9985: "LINEAR_MIPMAP_NEAREST",
              9986: "NEAREST_MIPMAP_LINEAR",
              9987: "LINEAR_MIPMAP_LINEAR",
              10240: "TEXTURE_MAG_FILTER",
              10241: "TEXTURE_MIN_FILTER",
              10242: "TEXTURE_WRAP_S",
              10243: "TEXTURE_WRAP_T",
              10497: "REPEAT",
              10752: "POLYGON_OFFSET_UNITS",
              16384: "COLOR_BUFFER_BIT",
              32769: "CONSTANT_COLOR",
              32770: "ONE_MINUS_CONSTANT_COLOR",
              32771: "CONSTANT_ALPHA",
              32772: "ONE_MINUS_CONSTANT_ALPHA",
              32773: "BLEND_COLOR",
              32774: "FUNC_ADD",
              32777: "BLEND_EQUATION_RGB",
              32778: "FUNC_SUBTRACT",
              32779: "FUNC_REVERSE_SUBTRACT",
              32819: "UNSIGNED_SHORT_4_4_4_4",
              32820: "UNSIGNED_SHORT_5_5_5_1",
              32823: "POLYGON_OFFSET_FILL",
              32824: "POLYGON_OFFSET_FACTOR",
              32854: "RGBA4",
              32855: "RGB5_A1",
              32873: "TEXTURE_BINDING_2D",
              32926: "SAMPLE_ALPHA_TO_COVERAGE",
              32928: "SAMPLE_COVERAGE",
              32936: "SAMPLE_BUFFERS",
              32937: "SAMPLES",
              32938: "SAMPLE_COVERAGE_VALUE",
              32939: "SAMPLE_COVERAGE_INVERT",
              32968: "BLEND_DST_RGB",
              32969: "BLEND_SRC_RGB",
              32970: "BLEND_DST_ALPHA",
              32971: "BLEND_SRC_ALPHA",
              33071: "CLAMP_TO_EDGE",
              33170: "GENERATE_MIPMAP_HINT",
              33189: "DEPTH_COMPONENT16",
              33306: "DEPTH_STENCIL_ATTACHMENT",
              33635: "UNSIGNED_SHORT_5_6_5",
              33648: "MIRRORED_REPEAT",
              33901: "ALIASED_POINT_SIZE_RANGE",
              33902: "ALIASED_LINE_WIDTH_RANGE",
              33984: "TEXTURE0",
              33985: "TEXTURE1",
              33986: "TEXTURE2",
              33987: "TEXTURE3",
              33988: "TEXTURE4",
              33989: "TEXTURE5",
              33990: "TEXTURE6",
              33991: "TEXTURE7",
              33992: "TEXTURE8",
              33993: "TEXTURE9",
              33994: "TEXTURE10",
              33995: "TEXTURE11",
              33996: "TEXTURE12",
              33997: "TEXTURE13",
              33998: "TEXTURE14",
              33999: "TEXTURE15",
              34e3: "TEXTURE16",
              34001: "TEXTURE17",
              34002: "TEXTURE18",
              34003: "TEXTURE19",
              34004: "TEXTURE20",
              34005: "TEXTURE21",
              34006: "TEXTURE22",
              34007: "TEXTURE23",
              34008: "TEXTURE24",
              34009: "TEXTURE25",
              34010: "TEXTURE26",
              34011: "TEXTURE27",
              34012: "TEXTURE28",
              34013: "TEXTURE29",
              34014: "TEXTURE30",
              34015: "TEXTURE31",
              34016: "ACTIVE_TEXTURE",
              34024: "MAX_RENDERBUFFER_SIZE",
              34041: "DEPTH_STENCIL",
              34055: "INCR_WRAP",
              34056: "DECR_WRAP",
              34067: "TEXTURE_CUBE_MAP",
              34068: "TEXTURE_BINDING_CUBE_MAP",
              34069: "TEXTURE_CUBE_MAP_POSITIVE_X",
              34070: "TEXTURE_CUBE_MAP_NEGATIVE_X",
              34071: "TEXTURE_CUBE_MAP_POSITIVE_Y",
              34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y",
              34073: "TEXTURE_CUBE_MAP_POSITIVE_Z",
              34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z",
              34076: "MAX_CUBE_MAP_TEXTURE_SIZE",
              34338: "VERTEX_ATTRIB_ARRAY_ENABLED",
              34339: "VERTEX_ATTRIB_ARRAY_SIZE",
              34340: "VERTEX_ATTRIB_ARRAY_STRIDE",
              34341: "VERTEX_ATTRIB_ARRAY_TYPE",
              34342: "CURRENT_VERTEX_ATTRIB",
              34373: "VERTEX_ATTRIB_ARRAY_POINTER",
              34466: "NUM_COMPRESSED_TEXTURE_FORMATS",
              34467: "COMPRESSED_TEXTURE_FORMATS",
              34660: "BUFFER_SIZE",
              34661: "BUFFER_USAGE",
              34816: "STENCIL_BACK_FUNC",
              34817: "STENCIL_BACK_FAIL",
              34818: "STENCIL_BACK_PASS_DEPTH_FAIL",
              34819: "STENCIL_BACK_PASS_DEPTH_PASS",
              34877: "BLEND_EQUATION_ALPHA",
              34921: "MAX_VERTEX_ATTRIBS",
              34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED",
              34930: "MAX_TEXTURE_IMAGE_UNITS",
              34962: "ARRAY_BUFFER",
              34963: "ELEMENT_ARRAY_BUFFER",
              34964: "ARRAY_BUFFER_BINDING",
              34965: "ELEMENT_ARRAY_BUFFER_BINDING",
              34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
              35040: "STREAM_DRAW",
              35044: "STATIC_DRAW",
              35048: "DYNAMIC_DRAW",
              35632: "FRAGMENT_SHADER",
              35633: "VERTEX_SHADER",
              35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
              35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
              35663: "SHADER_TYPE",
              35664: "FLOAT_VEC2",
              35665: "FLOAT_VEC3",
              35666: "FLOAT_VEC4",
              35667: "INT_VEC2",
              35668: "INT_VEC3",
              35669: "INT_VEC4",
              35670: "BOOL",
              35671: "BOOL_VEC2",
              35672: "BOOL_VEC3",
              35673: "BOOL_VEC4",
              35674: "FLOAT_MAT2",
              35675: "FLOAT_MAT3",
              35676: "FLOAT_MAT4",
              35678: "SAMPLER_2D",
              35680: "SAMPLER_CUBE",
              35712: "DELETE_STATUS",
              35713: "COMPILE_STATUS",
              35714: "LINK_STATUS",
              35715: "VALIDATE_STATUS",
              35716: "INFO_LOG_LENGTH",
              35717: "ATTACHED_SHADERS",
              35718: "ACTIVE_UNIFORMS",
              35719: "ACTIVE_UNIFORM_MAX_LENGTH",
              35720: "SHADER_SOURCE_LENGTH",
              35721: "ACTIVE_ATTRIBUTES",
              35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH",
              35724: "SHADING_LANGUAGE_VERSION",
              35725: "CURRENT_PROGRAM",
              36003: "STENCIL_BACK_REF",
              36004: "STENCIL_BACK_VALUE_MASK",
              36005: "STENCIL_BACK_WRITEMASK",
              36006: "FRAMEBUFFER_BINDING",
              36007: "RENDERBUFFER_BINDING",
              36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
              36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
              36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
              36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
              36053: "FRAMEBUFFER_COMPLETE",
              36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
              36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
              36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
              36061: "FRAMEBUFFER_UNSUPPORTED",
              36064: "COLOR_ATTACHMENT0",
              36096: "DEPTH_ATTACHMENT",
              36128: "STENCIL_ATTACHMENT",
              36160: "FRAMEBUFFER",
              36161: "RENDERBUFFER",
              36162: "RENDERBUFFER_WIDTH",
              36163: "RENDERBUFFER_HEIGHT",
              36164: "RENDERBUFFER_INTERNAL_FORMAT",
              36168: "STENCIL_INDEX8",
              36176: "RENDERBUFFER_RED_SIZE",
              36177: "RENDERBUFFER_GREEN_SIZE",
              36178: "RENDERBUFFER_BLUE_SIZE",
              36179: "RENDERBUFFER_ALPHA_SIZE",
              36180: "RENDERBUFFER_DEPTH_SIZE",
              36181: "RENDERBUFFER_STENCIL_SIZE",
              36194: "RGB565",
              36336: "LOW_FLOAT",
              36337: "MEDIUM_FLOAT",
              36338: "HIGH_FLOAT",
              36339: "LOW_INT",
              36340: "MEDIUM_INT",
              36341: "HIGH_INT",
              36346: "SHADER_COMPILER",
              36347: "MAX_VERTEX_UNIFORM_VECTORS",
              36348: "MAX_VARYING_VECTORS",
              36349: "MAX_FRAGMENT_UNIFORM_VECTORS",
              37440: "UNPACK_FLIP_Y_WEBGL",
              37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
              37442: "CONTEXT_LOST_WEBGL",
              37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL",
              37444: "BROWSER_DEFAULT_WEBGL"
            };
          }, {}],
          109: [function (e, t, n) {
            var r = e("./1.0/numbers");
            t.exports = function (e) {
              return r[e];
            };
          }, {
            "./1.0/numbers": 108
          }],
          110: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.gl,
                n = r(t),
                a = i(t, [{
                  buffer: n,
                  type: t.FLOAT,
                  size: 3,
                  offset: 0,
                  stride: 40
                }, {
                  buffer: n,
                  type: t.FLOAT,
                  size: 4,
                  offset: 12,
                  stride: 40
                }, {
                  buffer: n,
                  type: t.FLOAT,
                  size: 3,
                  offset: 28,
                  stride: 40
                }]),
                l = o(t);
              l.attributes.position.location = 0, l.attributes.color.location = 1, l.attributes.offset.location = 2;
              var u = new s(t, n, a, l);
              return u.update(e), u;
            };
            var r = e("gl-buffer"),
              i = e("gl-vao"),
              o = e("./shaders/index"),
              a = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            function s(e, t, n, r) {
              this.gl = e, this.shader = r, this.buffer = t, this.vao = n, this.pixelRatio = 1, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.lineWidth = [1, 1, 1], this.capSize = [10, 10, 10], this.lineCount = [0, 0, 0], this.lineOffset = [0, 0, 0], this.opacity = 1, this.hasAlpha = !1;
            }
            var l = s.prototype;
            function u(e, t) {
              for (var n = 0; n < 3; ++n) e[0][n] = Math.min(e[0][n], t[n]), e[1][n] = Math.max(e[1][n], t[n]);
            }
            l.isOpaque = function () {
              return !this.hasAlpha;
            }, l.isTransparent = function () {
              return this.hasAlpha;
            }, l.drawTransparent = l.draw = function (e) {
              var t = this.gl,
                n = this.shader.uniforms;
              this.shader.bind();
              var r = n.view = e.view || a,
                i = n.projection = e.projection || a;
              n.model = e.model || a, n.clipBounds = this.clipBounds, n.opacity = this.opacity;
              var o = r[12],
                s = r[13],
                l = r[14],
                u = r[15],
                c = (e._ortho ? 2 : 1) * this.pixelRatio * (i[3] * o + i[7] * s + i[11] * l + i[15] * u) / t.drawingBufferHeight;
              this.vao.bind();
              for (var d = 0; d < 3; ++d) t.lineWidth(this.lineWidth[d] * this.pixelRatio), n.capSize = this.capSize[d] * c, this.lineCount[d] && t.drawArrays(t.LINES, this.lineOffset[d], this.lineCount[d]);
              this.vao.unbind();
            };
            var c = function () {
              for (var e = new Array(3), t = 0; t < 3; ++t) {
                for (var n = [], r = 1; r <= 2; ++r) for (var i = -1; i <= 1; i += 2) {
                  var o = [0, 0, 0];
                  o[(r + t) % 3] = i, n.push(o);
                }
                e[t] = n;
              }
              return e;
            }();
            function d(e, t, n, r) {
              for (var i = c[r], o = 0; o < i.length; ++o) {
                var a = i[o];
                e.push(t[0], t[1], t[2], n[0], n[1], n[2], n[3], a[0], a[1], a[2]);
              }
              return i.length;
            }
            l.update = function (e) {
              "lineWidth" in (e = e || {}) && (this.lineWidth = e.lineWidth, Array.isArray(this.lineWidth) || (this.lineWidth = [this.lineWidth, this.lineWidth, this.lineWidth])), "capSize" in e && (this.capSize = e.capSize, Array.isArray(this.capSize) || (this.capSize = [this.capSize, this.capSize, this.capSize])), this.hasAlpha = !1, "opacity" in e && (this.opacity = +e.opacity, this.opacity < 1 && (this.hasAlpha = !0));
              var t = e.color || [[0, 0, 0], [0, 0, 0], [0, 0, 0]],
                n = e.position,
                r = e.error;
              if (Array.isArray(t[0]) || (t = [t, t, t]), n && r) {
                var i = [],
                  o = n.length,
                  a = 0;
                this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.lineCount = [0, 0, 0];
                for (var s = 0; s < 3; ++s) {
                  this.lineOffset[s] = a;
                  e: for (var l = 0; l < o; ++l) {
                    for (var c = n[l], h = 0; h < 3; ++h) if (isNaN(c[h]) || !isFinite(c[h])) continue e;
                    var f,
                      p = r[l],
                      m = t[s];
                    Array.isArray(m[0]) && (m = t[l]), 3 === m.length ? m = [m[0], m[1], m[2], 1] : 4 === m.length && (m = [m[0], m[1], m[2], m[3]], !this.hasAlpha && m[3] < 1 && (this.hasAlpha = !0)), isNaN(p[0][s]) || isNaN(p[1][s]) || (p[0][s] < 0 && ((f = c.slice())[s] += p[0][s], i.push(c[0], c[1], c[2], m[0], m[1], m[2], m[3], 0, 0, 0, f[0], f[1], f[2], m[0], m[1], m[2], m[3], 0, 0, 0), u(this.bounds, f), a += 2 + d(i, f, m, s)), p[1][s] > 0 && ((f = c.slice())[s] += p[1][s], i.push(c[0], c[1], c[2], m[0], m[1], m[2], m[3], 0, 0, 0, f[0], f[1], f[2], m[0], m[1], m[2], m[3], 0, 0, 0), u(this.bounds, f), a += 2 + d(i, f, m, s)));
                  }
                  this.lineCount[s] = a - this.lineOffset[s];
                }
                this.buffer.update(i);
              }
            }, l.dispose = function () {
              this.shader.dispose(), this.buffer.dispose(), this.vao.dispose();
            };
          }, {
            "./shaders/index": 111,
            "gl-buffer": 104,
            "gl-vao": 168
          }],
          111: [function (e, t, n) {
            "use strict";

            var r = e("glslify"),
              i = e("gl-shader"),
              o = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * view * worldPosition;\n  fragColor           = color;\n  fragPosition        = position;\n}"]),
              a = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"]);
            t.exports = function (e) {
              return i(e, o, a, null, [{
                name: "position",
                type: "vec3"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "offset",
                type: "vec3"
              }]);
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          112: [function (e, t, n) {
            "use strict";

            var r = e("gl-texture2d");
            t.exports = function (e, t, n, r) {
              i || (i = e.FRAMEBUFFER_UNSUPPORTED, o = e.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, a = e.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, s = e.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT);
              var u = e.getExtension("WEBGL_draw_buffers");
              if (!l && u && function (e, t) {
                var n = e.getParameter(t.MAX_COLOR_ATTACHMENTS_WEBGL);
                l = new Array(n + 1);
                for (var r = 0; r <= n; ++r) {
                  for (var i = new Array(n), o = 0; o < r; ++o) i[o] = e.COLOR_ATTACHMENT0 + o;
                  for (o = r; o < n; ++o) i[o] = e.NONE;
                  l[r] = i;
                }
              }(e, u), Array.isArray(t) && (r = n, n = 0 | t[1], t = 0 | t[0]), "number" != typeof t) throw new Error("gl-fbo: Missing shape parameter");
              var c = e.getParameter(e.MAX_RENDERBUFFER_SIZE);
              if (t < 0 || t > c || n < 0 || n > c) throw new Error("gl-fbo: Parameters are too large for FBO");
              var d = 1;
              if ("color" in (r = r || {})) {
                if ((d = Math.max(0 | r.color, 0)) < 0) throw new Error("gl-fbo: Must specify a nonnegative number of colors");
                if (d > 1) {
                  if (!u) throw new Error("gl-fbo: Multiple draw buffer extension not supported");
                  if (d > e.getParameter(u.MAX_COLOR_ATTACHMENTS_WEBGL)) throw new Error("gl-fbo: Context does not support " + d + " draw buffers");
                }
              }
              var h = e.UNSIGNED_BYTE,
                f = e.getExtension("OES_texture_float");
              if (r.float && d > 0) {
                if (!f) throw new Error("gl-fbo: Context does not support floating point textures");
                h = e.FLOAT;
              } else r.preferFloat && d > 0 && f && (h = e.FLOAT);
              var m = !0;
              "depth" in r && (m = !!r.depth);
              var g = !1;
              return "stencil" in r && (g = !!r.stencil), new p(e, t, n, h, d, m, g, u);
            };
            var i,
              o,
              a,
              s,
              l = null;
            function u(e) {
              return [e.getParameter(e.FRAMEBUFFER_BINDING), e.getParameter(e.RENDERBUFFER_BINDING), e.getParameter(e.TEXTURE_BINDING_2D)];
            }
            function c(e, t) {
              e.bindFramebuffer(e.FRAMEBUFFER, t[0]), e.bindRenderbuffer(e.RENDERBUFFER, t[1]), e.bindTexture(e.TEXTURE_2D, t[2]);
            }
            function d(e) {
              switch (e) {
                case i:
                  throw new Error("gl-fbo: Framebuffer unsupported");
                case o:
                  throw new Error("gl-fbo: Framebuffer incomplete attachment");
                case a:
                  throw new Error("gl-fbo: Framebuffer incomplete dimensions");
                case s:
                  throw new Error("gl-fbo: Framebuffer incomplete missing attachment");
                default:
                  throw new Error("gl-fbo: Framebuffer failed for unspecified reason");
              }
            }
            function h(e, t, n, i, o, a) {
              if (!i) return null;
              var s = r(e, t, n, o, i);
              return s.magFilter = e.NEAREST, s.minFilter = e.NEAREST, s.mipSamples = 1, s.bind(), e.framebufferTexture2D(e.FRAMEBUFFER, a, e.TEXTURE_2D, s.handle, 0), s;
            }
            function f(e, t, n, r, i) {
              var o = e.createRenderbuffer();
              return e.bindRenderbuffer(e.RENDERBUFFER, o), e.renderbufferStorage(e.RENDERBUFFER, r, t, n), e.framebufferRenderbuffer(e.FRAMEBUFFER, i, e.RENDERBUFFER, o), o;
            }
            function p(e, t, n, r, i, o, a, s) {
              this.gl = e, this._shape = [0 | t, 0 | n], this._destroyed = !1, this._ext = s, this.color = new Array(i);
              for (var p = 0; p < i; ++p) this.color[p] = null;
              this._color_rb = null, this.depth = null, this._depth_rb = null, this._colorType = r, this._useDepth = o, this._useStencil = a;
              var m = this,
                g = [0 | t, 0 | n];
              Object.defineProperties(g, {
                0: {
                  get: function get() {
                    return m._shape[0];
                  },
                  set: function set(e) {
                    return m.width = e;
                  }
                },
                1: {
                  get: function get() {
                    return m._shape[1];
                  },
                  set: function set(e) {
                    return m.height = e;
                  }
                }
              }), this._shapeVector = g, function (e) {
                var t = u(e.gl),
                  n = e.gl,
                  r = e.handle = n.createFramebuffer(),
                  i = e._shape[0],
                  o = e._shape[1],
                  a = e.color.length,
                  s = e._ext,
                  p = e._useStencil,
                  m = e._useDepth,
                  g = e._colorType;
                n.bindFramebuffer(n.FRAMEBUFFER, r);
                for (var v = 0; v < a; ++v) e.color[v] = h(n, i, o, g, n.RGBA, n.COLOR_ATTACHMENT0 + v);
                0 === a ? (e._color_rb = f(n, i, o, n.RGBA4, n.COLOR_ATTACHMENT0), s && s.drawBuffersWEBGL(l[0])) : a > 1 && s.drawBuffersWEBGL(l[a]);
                var y = n.getExtension("WEBGL_depth_texture");
                y ? p ? e.depth = h(n, i, o, y.UNSIGNED_INT_24_8_WEBGL, n.DEPTH_STENCIL, n.DEPTH_STENCIL_ATTACHMENT) : m && (e.depth = h(n, i, o, n.UNSIGNED_SHORT, n.DEPTH_COMPONENT, n.DEPTH_ATTACHMENT)) : m && p ? e._depth_rb = f(n, i, o, n.DEPTH_STENCIL, n.DEPTH_STENCIL_ATTACHMENT) : m ? e._depth_rb = f(n, i, o, n.DEPTH_COMPONENT16, n.DEPTH_ATTACHMENT) : p && (e._depth_rb = f(n, i, o, n.STENCIL_INDEX, n.STENCIL_ATTACHMENT));
                var b = n.checkFramebufferStatus(n.FRAMEBUFFER);
                if (b !== n.FRAMEBUFFER_COMPLETE) {
                  for (e._destroyed = !0, n.bindFramebuffer(n.FRAMEBUFFER, null), n.deleteFramebuffer(e.handle), e.handle = null, e.depth && (e.depth.dispose(), e.depth = null), e._depth_rb && (n.deleteRenderbuffer(e._depth_rb), e._depth_rb = null), v = 0; v < e.color.length; ++v) e.color[v].dispose(), e.color[v] = null;
                  e._color_rb && (n.deleteRenderbuffer(e._color_rb), e._color_rb = null), c(n, t), d(b);
                }
                c(n, t);
              }(this);
            }
            var m = p.prototype;
            function g(e, t, n) {
              if (e._destroyed) throw new Error("gl-fbo: Can't resize destroyed FBO");
              if (e._shape[0] !== t || e._shape[1] !== n) {
                var r = e.gl,
                  i = r.getParameter(r.MAX_RENDERBUFFER_SIZE);
                if (t < 0 || t > i || n < 0 || n > i) throw new Error("gl-fbo: Can't resize FBO, invalid dimensions");
                e._shape[0] = t, e._shape[1] = n;
                for (var o = u(r), a = 0; a < e.color.length; ++a) e.color[a].shape = e._shape;
                e._color_rb && (r.bindRenderbuffer(r.RENDERBUFFER, e._color_rb), r.renderbufferStorage(r.RENDERBUFFER, r.RGBA4, e._shape[0], e._shape[1])), e.depth && (e.depth.shape = e._shape), e._depth_rb && (r.bindRenderbuffer(r.RENDERBUFFER, e._depth_rb), e._useDepth && e._useStencil ? r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_STENCIL, e._shape[0], e._shape[1]) : e._useDepth ? r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_COMPONENT16, e._shape[0], e._shape[1]) : e._useStencil && r.renderbufferStorage(r.RENDERBUFFER, r.STENCIL_INDEX, e._shape[0], e._shape[1])), r.bindFramebuffer(r.FRAMEBUFFER, e.handle);
                var s = r.checkFramebufferStatus(r.FRAMEBUFFER);
                s !== r.FRAMEBUFFER_COMPLETE && (e.dispose(), c(r, o), d(s)), c(r, o);
              }
            }
            Object.defineProperties(m, {
              shape: {
                get: function get() {
                  return this._destroyed ? [0, 0] : this._shapeVector;
                },
                set: function set(e) {
                  if (Array.isArray(e) || (e = [0 | e, 0 | e]), 2 !== e.length) throw new Error("gl-fbo: Shape vector must be length 2");
                  var t = 0 | e[0],
                    n = 0 | e[1];
                  return g(this, t, n), [t, n];
                },
                enumerable: !1
              },
              width: {
                get: function get() {
                  return this._destroyed ? 0 : this._shape[0];
                },
                set: function set(e) {
                  return g(this, e |= 0, this._shape[1]), e;
                },
                enumerable: !1
              },
              height: {
                get: function get() {
                  return this._destroyed ? 0 : this._shape[1];
                },
                set: function set(e) {
                  return e |= 0, g(this, this._shape[0], e), e;
                },
                enumerable: !1
              }
            }), m.bind = function () {
              if (!this._destroyed) {
                var e = this.gl;
                e.bindFramebuffer(e.FRAMEBUFFER, this.handle), e.viewport(0, 0, this._shape[0], this._shape[1]);
              }
            }, m.dispose = function () {
              if (!this._destroyed) {
                this._destroyed = !0;
                var e = this.gl;
                e.deleteFramebuffer(this.handle), this.handle = null, this.depth && (this.depth.dispose(), this.depth = null), this._depth_rb && (e.deleteRenderbuffer(this._depth_rb), this._depth_rb = null);
                for (var t = 0; t < this.color.length; ++t) this.color[t].dispose(), this.color[t] = null;
                this._color_rb && (e.deleteRenderbuffer(this._color_rb), this._color_rb = null);
              }
            };
          }, {
            "gl-texture2d": 164
          }],
          113: [function (e, t, n) {
            var r = e("sprintf-js").sprintf,
              i = e("gl-constants/lookup"),
              o = e("glsl-shader-name"),
              a = e("add-line-numbers");
            t.exports = function (e, t, n) {
              "use strict";

              var s = o(t) || "of unknown name (see npm glsl-shader-name)",
                l = "unknown type";
              void 0 !== n && (l = n === i.FRAGMENT_SHADER ? "fragment" : "vertex");
              for (var u = r("Error compiling %s shader %s:\n", l, s), c = r("%s%s", u, e), d = e.split("\n"), h = {}, f = 0; f < d.length; f++) {
                var p = d[f];
                if ("" !== p && "\0" !== p) {
                  var m = parseInt(p.split(":")[2]);
                  if (isNaN(m)) throw new Error(r("Could not parse error: %s", p));
                  h[m] = p;
                }
              }
              var g = a(t).split("\n");
              for (f = 0; f < g.length; f++) if ((h[f + 3] || h[f + 2] || h[f + 1]) && (u += g[f] + "\n", h[f + 1])) {
                var v = h[f + 1];
                v = v.substr(v.split(":", 3).join(":").length + 1).trim(), u += r("^^^ %s\n\n", v);
              }
              return {
                long: u.trim(),
                short: c.trim()
              };
            };
          }, {
            "add-line-numbers": 13,
            "gl-constants/lookup": 109,
            "glsl-shader-name": 241,
            "sprintf-js": 339
          }],
          114: [function (e, t, n) {
            var r = e("glslify"),
              i = e("gl-shader"),
              o = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"]),
              a = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"]),
              s = r(["precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"]),
              l = [{
                name: "position",
                type: "vec3"
              }, {
                name: "nextPosition",
                type: "vec3"
              }, {
                name: "arcLength",
                type: "float"
              }, {
                name: "lineWidth",
                type: "float"
              }, {
                name: "color",
                type: "vec4"
              }];
            n.createShader = function (e) {
              return i(e, o, a, null, l);
            }, n.createPickShader = function (e) {
              return i(e, o, s, null, l);
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          115: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.gl || e.scene && e.scene.gl,
                n = d(t);
              n.attributes.position.location = 0, n.attributes.nextPosition.location = 1, n.attributes.arcLength.location = 2, n.attributes.lineWidth.location = 3, n.attributes.color.location = 4;
              var a = h(t);
              a.attributes.position.location = 0, a.attributes.nextPosition.location = 1, a.attributes.arcLength.location = 2, a.attributes.lineWidth.location = 3, a.attributes.color.location = 4;
              for (var s = r(t), l = i(t, [{
                  buffer: s,
                  size: 3,
                  offset: 0,
                  stride: 48
                }, {
                  buffer: s,
                  size: 3,
                  offset: 12,
                  stride: 48
                }, {
                  buffer: s,
                  size: 1,
                  offset: 24,
                  stride: 48
                }, {
                  buffer: s,
                  size: 1,
                  offset: 28,
                  stride: 48
                }, {
                  buffer: s,
                  size: 4,
                  offset: 32,
                  stride: 48
                }]), c = u(new Array(1024), [256, 1, 4]), f = 0; f < 1024; ++f) c.data[f] = 255;
              var p = o(t, c);
              p.wrap = t.REPEAT;
              var m = new v(t, n, a, s, l, p);
              return m.update(e), m;
            };
            var r = e("gl-buffer"),
              i = e("gl-vao"),
              o = e("gl-texture2d"),
              a = new Uint8Array(4),
              s = new Float32Array(a.buffer),
              l = e("binary-search-bounds"),
              u = e("ndarray"),
              c = e("./lib/shaders"),
              d = c.createShader,
              h = c.createPickShader,
              f = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            function p(e, t) {
              for (var n = 0, r = 0; r < 3; ++r) {
                var i = e[r] - t[r];
                n += i * i;
              }
              return Math.sqrt(n);
            }
            function m(e) {
              for (var t = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], n = 0; n < 3; ++n) t[0][n] = Math.max(e[0][n], t[0][n]), t[1][n] = Math.min(e[1][n], t[1][n]);
              return t;
            }
            function g(e, t, n, r) {
              this.arcLength = e, this.position = t, this.index = n, this.dataCoordinate = r;
            }
            function v(e, t, n, r, i, o) {
              this.gl = e, this.shader = t, this.pickShader = n, this.buffer = r, this.vao = i, this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.points = [], this.arcLength = [], this.vertexCount = 0, this.bounds = [[0, 0, 0], [0, 0, 0]], this.pickId = 0, this.lineWidth = 1, this.texture = o, this.dashScale = 1, this.opacity = 1, this.hasAlpha = !1, this.dirty = !0, this.pixelRatio = 1;
            }
            var y = v.prototype;
            y.isTransparent = function () {
              return this.hasAlpha;
            }, y.isOpaque = function () {
              return !this.hasAlpha;
            }, y.pickSlots = 1, y.setPickBase = function (e) {
              this.pickId = e;
            }, y.drawTransparent = y.draw = function (e) {
              if (this.vertexCount) {
                var t = this.gl,
                  n = this.shader,
                  r = this.vao;
                n.bind(), n.uniforms = {
                  model: e.model || f,
                  view: e.view || f,
                  projection: e.projection || f,
                  clipBounds: m(this.clipBounds),
                  dashTexture: this.texture.bind(),
                  dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
                  opacity: this.opacity,
                  screenShape: [t.drawingBufferWidth, t.drawingBufferHeight],
                  pixelRatio: this.pixelRatio
                }, r.bind(), r.draw(t.TRIANGLE_STRIP, this.vertexCount), r.unbind();
              }
            }, y.drawPick = function (e) {
              if (this.vertexCount) {
                var t = this.gl,
                  n = this.pickShader,
                  r = this.vao;
                n.bind(), n.uniforms = {
                  model: e.model || f,
                  view: e.view || f,
                  projection: e.projection || f,
                  pickId: this.pickId,
                  clipBounds: m(this.clipBounds),
                  screenShape: [t.drawingBufferWidth, t.drawingBufferHeight],
                  pixelRatio: this.pixelRatio
                }, r.bind(), r.draw(t.TRIANGLE_STRIP, this.vertexCount), r.unbind();
              }
            }, y.update = function (e) {
              var t, n;
              this.dirty = !0;
              var r = !!e.connectGaps;
              "dashScale" in e && (this.dashScale = e.dashScale), this.hasAlpha = !1, "opacity" in e && (this.opacity = +e.opacity, this.opacity < 1 && (this.hasAlpha = !0));
              var i = [],
                o = [],
                a = [],
                s = 0,
                c = 0,
                d = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]],
                h = e.position || e.positions;
              if (h) {
                var f = e.color || e.colors || [0, 0, 0, 1],
                  m = e.lineWidth || 1,
                  g = !1;
                e: for (t = 1; t < h.length; ++t) {
                  var v,
                    y,
                    b,
                    _ = h[t - 1],
                    x = h[t];
                  for (o.push(s), a.push(_.slice()), n = 0; n < 3; ++n) {
                    if (isNaN(_[n]) || isNaN(x[n]) || !isFinite(_[n]) || !isFinite(x[n])) {
                      if (!r && i.length > 0) {
                        for (var w = 0; w < 24; ++w) i.push(i[i.length - 12]);
                        c += 2, g = !0;
                      }
                      continue e;
                    }
                    d[0][n] = Math.min(d[0][n], _[n], x[n]), d[1][n] = Math.max(d[1][n], _[n], x[n]);
                  }
                  Array.isArray(f[0]) ? (v = f.length > t - 1 ? f[t - 1] : f.length > 0 ? f[f.length - 1] : [0, 0, 0, 1], y = f.length > t ? f[t] : f.length > 0 ? f[f.length - 1] : [0, 0, 0, 1]) : v = y = f, 3 === v.length && (v = [v[0], v[1], v[2], 1]), 3 === y.length && (y = [y[0], y[1], y[2], 1]), !this.hasAlpha && v[3] < 1 && (this.hasAlpha = !0), b = Array.isArray(m) ? m.length > t - 1 ? m[t - 1] : m.length > 0 ? m[m.length - 1] : [0, 0, 0, 1] : m;
                  var S = s;
                  if (s += p(_, x), g) {
                    for (n = 0; n < 2; ++n) i.push(_[0], _[1], _[2], x[0], x[1], x[2], S, b, v[0], v[1], v[2], v[3]);
                    c += 2, g = !1;
                  }
                  i.push(_[0], _[1], _[2], x[0], x[1], x[2], S, b, v[0], v[1], v[2], v[3], _[0], _[1], _[2], x[0], x[1], x[2], S, -b, v[0], v[1], v[2], v[3], x[0], x[1], x[2], _[0], _[1], _[2], s, -b, y[0], y[1], y[2], y[3], x[0], x[1], x[2], _[0], _[1], _[2], s, b, y[0], y[1], y[2], y[3]), c += 4;
                }
              }
              if (this.buffer.update(i), o.push(s), a.push(h[h.length - 1].slice()), this.bounds = d, this.vertexCount = c, this.points = a, this.arcLength = o, "dashes" in e) {
                var A = e.dashes.slice();
                for (A.unshift(0), t = 1; t < A.length; ++t) A[t] = A[t - 1] + A[t];
                var E = u(new Array(1024), [256, 1, 4]);
                for (t = 0; t < 256; ++t) {
                  for (n = 0; n < 4; ++n) E.set(t, 0, n, 0);
                  1 & l.le(A, A[A.length - 1] * t / 255) ? E.set(t, 0, 0, 0) : E.set(t, 0, 0, 255);
                }
                this.texture.setPixels(E);
              }
            }, y.dispose = function () {
              this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
            }, y.pick = function (e) {
              if (!e) return null;
              if (e.id !== this.pickId) return null;
              var t = function (e, t, n, r) {
                  return a[0] = 0, a[1] = n, a[2] = t, a[3] = e, s[0];
                }(e.value[0], e.value[1], e.value[2]),
                n = l.le(this.arcLength, t);
              if (n < 0) return null;
              if (n === this.arcLength.length - 1) return new g(this.arcLength[this.arcLength.length - 1], this.points[this.points.length - 1].slice(), n);
              for (var r = this.points[n], i = this.points[Math.min(n + 1, this.points.length - 1)], o = (t - this.arcLength[n]) / (this.arcLength[n + 1] - this.arcLength[n]), u = 1 - o, c = [0, 0, 0], d = 0; d < 3; ++d) c[d] = u * r[d] + o * i[d];
              var h = Math.min(o < .5 ? n : n + 1, this.points.length - 1);
              return new g(t, c, h, this.points[h]);
            };
          }, {
            "./lib/shaders": 114,
            "binary-search-bounds": 116,
            "gl-buffer": 104,
            "gl-texture2d": 164,
            "gl-vao": 168,
            ndarray: 285
          }],
          116: [function (e, t, n) {
            arguments[4][55][0].apply(n, arguments);
          }, {
            dup: 55
          }],
          117: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = t[3],
                a = n * o - i * r;
              return a ? (a = 1 / a, e[0] = o * a, e[1] = -r * a, e[2] = -i * a, e[3] = n * a, e) : null;
            };
          }, {}],
          118: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = t[3],
                a = t[4],
                s = t[5],
                l = t[6],
                u = t[7],
                c = t[8],
                d = c * a - s * u,
                h = -c * o + s * l,
                f = u * o - a * l,
                p = n * d + r * h + i * f;
              return p ? (p = 1 / p, e[0] = d * p, e[1] = (-c * r + i * u) * p, e[2] = (s * r - i * a) * p, e[3] = h * p, e[4] = (c * n - i * l) * p, e[5] = (-s * n + i * o) * p, e[6] = f * p, e[7] = (-u * n + r * l) * p, e[8] = (a * n - r * o) * p, e) : null;
            };
          }, {}],
          119: [function (e, t, n) {
            t.exports = function (e) {
              var t = new Float32Array(16);
              return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
            };
          }, {}],
          120: [function (e, t, n) {
            t.exports = function () {
              var e = new Float32Array(16);
              return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            };
          }, {}],
          121: [function (e, t, n) {
            t.exports = function (e) {
              var t = e[0],
                n = e[1],
                r = e[2],
                i = e[3],
                o = e[4],
                a = e[5],
                s = e[6],
                l = e[7],
                u = e[8],
                c = e[9],
                d = e[10],
                h = e[11],
                f = e[12],
                p = e[13],
                m = e[14],
                g = e[15];
              return (t * a - n * o) * (d * g - h * m) - (t * s - r * o) * (c * g - h * p) + (t * l - i * o) * (c * m - d * p) + (n * s - r * a) * (u * g - h * f) - (n * l - i * a) * (u * m - d * f) + (r * l - i * s) * (u * p - c * f);
            };
          }, {}],
          122: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = t[3],
                a = n + n,
                s = r + r,
                l = i + i,
                u = n * a,
                c = r * a,
                d = r * s,
                h = i * a,
                f = i * s,
                p = i * l,
                m = o * a,
                g = o * s,
                v = o * l;
              return e[0] = 1 - d - p, e[1] = c + v, e[2] = h - g, e[3] = 0, e[4] = c - v, e[5] = 1 - u - p, e[6] = f + m, e[7] = 0, e[8] = h + g, e[9] = f - m, e[10] = 1 - u - d, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            };
          }, {}],
          123: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = t[3],
                s = r + r,
                l = i + i,
                u = o + o,
                c = r * s,
                d = r * l,
                h = r * u,
                f = i * l,
                p = i * u,
                m = o * u,
                g = a * s,
                v = a * l,
                y = a * u;
              return e[0] = 1 - (f + m), e[1] = d + y, e[2] = h - v, e[3] = 0, e[4] = d - y, e[5] = 1 - (c + m), e[6] = p + g, e[7] = 0, e[8] = h + v, e[9] = p - g, e[10] = 1 - (c + f), e[11] = 0, e[12] = n[0], e[13] = n[1], e[14] = n[2], e[15] = 1, e;
            };
          }, {}],
          124: [function (e, t, n) {
            t.exports = function (e) {
              return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            };
          }, {}],
          125: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = t[3],
                a = t[4],
                s = t[5],
                l = t[6],
                u = t[7],
                c = t[8],
                d = t[9],
                h = t[10],
                f = t[11],
                p = t[12],
                m = t[13],
                g = t[14],
                v = t[15],
                y = n * s - r * a,
                b = n * l - i * a,
                _ = n * u - o * a,
                x = r * l - i * s,
                w = r * u - o * s,
                S = i * u - o * l,
                A = c * m - d * p,
                E = c * g - h * p,
                T = c * v - f * p,
                M = d * g - h * m,
                C = d * v - f * m,
                k = h * v - f * g,
                P = y * k - b * C + _ * M + x * T - w * E + S * A;
              return P ? (P = 1 / P, e[0] = (s * k - l * C + u * M) * P, e[1] = (i * C - r * k - o * M) * P, e[2] = (m * S - g * w + v * x) * P, e[3] = (h * w - d * S - f * x) * P, e[4] = (l * T - a * k - u * E) * P, e[5] = (n * k - i * T + o * E) * P, e[6] = (g * _ - p * S - v * b) * P, e[7] = (c * S - h * _ + f * b) * P, e[8] = (a * C - s * T + u * A) * P, e[9] = (r * T - n * C - o * A) * P, e[10] = (p * w - m * _ + v * y) * P, e[11] = (d * _ - c * w - f * y) * P, e[12] = (s * E - a * M - l * A) * P, e[13] = (n * M - r * E + i * A) * P, e[14] = (m * b - p * x - g * y) * P, e[15] = (c * x - d * b + h * y) * P, e) : null;
            };
          }, {}],
          126: [function (e, t, n) {
            var r = e("./identity");
            t.exports = function (e, t, n, i) {
              var o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m = t[0],
                g = t[1],
                v = t[2],
                y = i[0],
                b = i[1],
                _ = i[2],
                x = n[0],
                w = n[1],
                S = n[2];
              return Math.abs(m - x) < 1e-6 && Math.abs(g - w) < 1e-6 && Math.abs(v - S) < 1e-6 ? r(e) : (d = m - x, h = g - w, f = v - S, o = b * (f *= p = 1 / Math.sqrt(d * d + h * h + f * f)) - _ * (h *= p), a = _ * (d *= p) - y * f, s = y * h - b * d, (p = Math.sqrt(o * o + a * a + s * s)) ? (o *= p = 1 / p, a *= p, s *= p) : (o = 0, a = 0, s = 0), l = h * s - f * a, u = f * o - d * s, c = d * a - h * o, (p = Math.sqrt(l * l + u * u + c * c)) ? (l *= p = 1 / p, u *= p, c *= p) : (l = 0, u = 0, c = 0), e[0] = o, e[1] = l, e[2] = d, e[3] = 0, e[4] = a, e[5] = u, e[6] = h, e[7] = 0, e[8] = s, e[9] = c, e[10] = f, e[11] = 0, e[12] = -(o * m + a * g + s * v), e[13] = -(l * m + u * g + c * v), e[14] = -(d * m + h * g + f * v), e[15] = 1, e);
            };
          }, {
            "./identity": 124
          }],
          127: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = t[3],
                s = t[4],
                l = t[5],
                u = t[6],
                c = t[7],
                d = t[8],
                h = t[9],
                f = t[10],
                p = t[11],
                m = t[12],
                g = t[13],
                v = t[14],
                y = t[15],
                b = n[0],
                _ = n[1],
                x = n[2],
                w = n[3];
              return e[0] = b * r + _ * s + x * d + w * m, e[1] = b * i + _ * l + x * h + w * g, e[2] = b * o + _ * u + x * f + w * v, e[3] = b * a + _ * c + x * p + w * y, b = n[4], _ = n[5], x = n[6], w = n[7], e[4] = b * r + _ * s + x * d + w * m, e[5] = b * i + _ * l + x * h + w * g, e[6] = b * o + _ * u + x * f + w * v, e[7] = b * a + _ * c + x * p + w * y, b = n[8], _ = n[9], x = n[10], w = n[11], e[8] = b * r + _ * s + x * d + w * m, e[9] = b * i + _ * l + x * h + w * g, e[10] = b * o + _ * u + x * f + w * v, e[11] = b * a + _ * c + x * p + w * y, b = n[12], _ = n[13], x = n[14], w = n[15], e[12] = b * r + _ * s + x * d + w * m, e[13] = b * i + _ * l + x * h + w * g, e[14] = b * o + _ * u + x * f + w * v, e[15] = b * a + _ * c + x * p + w * y, e;
            };
          }, {}],
          128: [function (e, t, n) {
            t.exports = function (e, t, n, r, i, o, a) {
              var s = 1 / (t - n),
                l = 1 / (r - i),
                u = 1 / (o - a);
              return e[0] = -2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * l, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * u, e[11] = 0, e[12] = (t + n) * s, e[13] = (i + r) * l, e[14] = (a + o) * u, e[15] = 1, e;
            };
          }, {}],
          129: [function (e, t, n) {
            t.exports = function (e, t, n, r, i) {
              var o = 1 / Math.tan(t / 2),
                a = 1 / (r - i);
              return e[0] = o / n, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = o, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (i + r) * a, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * i * r * a, e[15] = 0, e;
            };
          }, {}],
          130: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i,
                o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g,
                v,
                y,
                b,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M,
                C = r[0],
                k = r[1],
                P = r[2],
                O = Math.sqrt(C * C + k * k + P * P);
              return Math.abs(O) < 1e-6 ? null : (C *= O = 1 / O, k *= O, P *= O, i = Math.sin(n), a = 1 - (o = Math.cos(n)), s = t[0], l = t[1], u = t[2], c = t[3], d = t[4], h = t[5], f = t[6], p = t[7], m = t[8], g = t[9], v = t[10], y = t[11], b = C * C * a + o, _ = k * C * a + P * i, x = P * C * a - k * i, w = C * k * a - P * i, S = k * k * a + o, A = P * k * a + C * i, E = C * P * a + k * i, T = k * P * a - C * i, M = P * P * a + o, e[0] = s * b + d * _ + m * x, e[1] = l * b + h * _ + g * x, e[2] = u * b + f * _ + v * x, e[3] = c * b + p * _ + y * x, e[4] = s * w + d * S + m * A, e[5] = l * w + h * S + g * A, e[6] = u * w + f * S + v * A, e[7] = c * w + p * S + y * A, e[8] = s * E + d * T + m * M, e[9] = l * E + h * T + g * M, e[10] = u * E + f * T + v * M, e[11] = c * E + p * T + y * M, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
            };
          }, {}],
          131: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = Math.sin(n),
                i = Math.cos(n),
                o = t[4],
                a = t[5],
                s = t[6],
                l = t[7],
                u = t[8],
                c = t[9],
                d = t[10],
                h = t[11];
              return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = o * i + u * r, e[5] = a * i + c * r, e[6] = s * i + d * r, e[7] = l * i + h * r, e[8] = u * i - o * r, e[9] = c * i - a * r, e[10] = d * i - s * r, e[11] = h * i - l * r, e;
            };
          }, {}],
          132: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = Math.sin(n),
                i = Math.cos(n),
                o = t[0],
                a = t[1],
                s = t[2],
                l = t[3],
                u = t[8],
                c = t[9],
                d = t[10],
                h = t[11];
              return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = o * i - u * r, e[1] = a * i - c * r, e[2] = s * i - d * r, e[3] = l * i - h * r, e[8] = o * r + u * i, e[9] = a * r + c * i, e[10] = s * r + d * i, e[11] = l * r + h * i, e;
            };
          }, {}],
          133: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = Math.sin(n),
                i = Math.cos(n),
                o = t[0],
                a = t[1],
                s = t[2],
                l = t[3],
                u = t[4],
                c = t[5],
                d = t[6],
                h = t[7];
              return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = o * i + u * r, e[1] = a * i + c * r, e[2] = s * i + d * r, e[3] = l * i + h * r, e[4] = u * i - o * r, e[5] = c * i - a * r, e[6] = d * i - s * r, e[7] = h * i - l * r, e;
            };
          }, {}],
          134: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = n[0],
                i = n[1],
                o = n[2];
              return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e[3] = t[3] * r, e[4] = t[4] * i, e[5] = t[5] * i, e[6] = t[6] * i, e[7] = t[7] * i, e[8] = t[8] * o, e[9] = t[9] * o, e[10] = t[10] * o, e[11] = t[11] * o, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
            };
          }, {}],
          135: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r,
                i,
                o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m = n[0],
                g = n[1],
                v = n[2];
              return t === e ? (e[12] = t[0] * m + t[4] * g + t[8] * v + t[12], e[13] = t[1] * m + t[5] * g + t[9] * v + t[13], e[14] = t[2] * m + t[6] * g + t[10] * v + t[14], e[15] = t[3] * m + t[7] * g + t[11] * v + t[15]) : (r = t[0], i = t[1], o = t[2], a = t[3], s = t[4], l = t[5], u = t[6], c = t[7], d = t[8], h = t[9], f = t[10], p = t[11], e[0] = r, e[1] = i, e[2] = o, e[3] = a, e[4] = s, e[5] = l, e[6] = u, e[7] = c, e[8] = d, e[9] = h, e[10] = f, e[11] = p, e[12] = r * m + s * g + d * v + t[12], e[13] = i * m + l * g + h * v + t[13], e[14] = o * m + u * g + f * v + t[14], e[15] = a * m + c * g + p * v + t[15]), e;
            };
          }, {}],
          136: [function (e, t, n) {
            t.exports = function (e, t) {
              if (e === t) {
                var n = t[1],
                  r = t[2],
                  i = t[3],
                  o = t[6],
                  a = t[7],
                  s = t[11];
                e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = n, e[6] = t[9], e[7] = t[13], e[8] = r, e[9] = o, e[11] = t[14], e[12] = i, e[13] = a, e[14] = s;
              } else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
              return e;
            };
          }, {}],
          137: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              switch (t.length) {
                case 0:
                  break;
                case 1:
                  e[0] = 1 / t[0];
                  break;
                case 4:
                  r(e, t);
                  break;
                case 9:
                  i(e, t);
                  break;
                case 16:
                  o(e, t);
                  break;
                default:
                  throw new Error("currently supports matrices up to 4x4");
              }
              return e;
            };
            var r = e("gl-mat2/invert"),
              i = e("gl-mat3/invert"),
              o = e("gl-mat4/invert");
          }, {
            "gl-mat2/invert": 117,
            "gl-mat3/invert": 118,
            "gl-mat4/invert": 125
          }],
          138: [function (e, t, n) {
            "use strict";

            var r = e("barycentric"),
              i = e("polytope-closest-point/lib/closest_point_2d.js");
            function o(e, t) {
              for (var n = [0, 0, 0, 0], r = 0; r < 4; ++r) for (var i = 0; i < 4; ++i) n[i] += e[4 * r + i] * t[r];
              return n;
            }
            function a(e, t, n, r, i) {
              for (var a = o(r, o(n, o(t, [e[0], e[1], e[2], 1]))), s = 0; s < 3; ++s) a[s] /= a[3];
              return [.5 * i[0] * (1 + a[0]), .5 * i[1] * (1 - a[1])];
            }
            function s(e, t) {
              for (var n = [0, 0, 0], r = 0; r < e.length; ++r) for (var i = e[r], o = t[r], a = 0; a < 3; ++a) n[a] += o * i[a];
              return n;
            }
            t.exports = function (e, t, n, o, l, u) {
              if (1 === e.length) return [0, e[0].slice()];
              for (var c = new Array(e.length), d = 0; d < e.length; ++d) c[d] = a(e[d], n, o, l, u);
              var h = 0,
                f = 1 / 0;
              for (d = 0; d < c.length; ++d) {
                for (var p = 0, m = 0; m < 2; ++m) p += Math.pow(c[d][m] - t[m], 2);
                p < f && (f = p, h = d);
              }
              var g = function (e, t) {
                  if (2 === e.length) {
                    for (var n = 0, o = 0, a = 0; a < 2; ++a) n += Math.pow(t[a] - e[0][a], 2), o += Math.pow(t[a] - e[1][a], 2);
                    return (n = Math.sqrt(n)) + (o = Math.sqrt(o)) < 1e-6 ? [1, 0] : [o / (n + o), n / (o + n)];
                  }
                  if (3 === e.length) {
                    var s = [0, 0];
                    return i(e[0], e[1], e[2], t, s), r(e, s);
                  }
                  return [];
                }(c, t),
                v = 0;
              for (d = 0; d < 3; ++d) {
                if (g[d] < -.001 || g[d] > 1.0001) return null;
                v += g[d];
              }
              return Math.abs(v - 1) > .001 ? null : [h, s(e, g), g];
            };
          }, {
            barycentric: 18,
            "polytope-closest-point/lib/closest_point_2d.js": 306
          }],
          139: [function (e, t, n) {
            var r = e("glslify"),
              i = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"]),
              o = r(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"]),
              a = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"]),
              s = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]),
              l = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * view * model * vec4(position, 1.0);\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"]),
              u = r(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"]),
              c = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_id        = id;\n  f_position  = position;\n}"]),
              d = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]),
              h = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * view * model * vec4(position, 1.0);\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"]),
              f = r(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n}"]),
              p = r(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"]);
            n.meshShader = {
              vertex: i,
              fragment: o,
              attributes: [{
                name: "position",
                type: "vec3"
              }, {
                name: "normal",
                type: "vec3"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "uv",
                type: "vec2"
              }]
            }, n.wireShader = {
              vertex: a,
              fragment: s,
              attributes: [{
                name: "position",
                type: "vec3"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "uv",
                type: "vec2"
              }]
            }, n.pointShader = {
              vertex: l,
              fragment: u,
              attributes: [{
                name: "position",
                type: "vec3"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "uv",
                type: "vec2"
              }, {
                name: "pointSize",
                type: "float"
              }]
            }, n.pickShader = {
              vertex: c,
              fragment: d,
              attributes: [{
                name: "position",
                type: "vec3"
              }, {
                name: "id",
                type: "vec4"
              }]
            }, n.pointPickShader = {
              vertex: h,
              fragment: d,
              attributes: [{
                name: "position",
                type: "vec3"
              }, {
                name: "pointSize",
                type: "float"
              }, {
                name: "id",
                type: "vec4"
              }]
            }, n.contourShader = {
              vertex: f,
              fragment: p,
              attributes: [{
                name: "position",
                type: "vec3"
              }]
            };
          }, {
            glslify: 249
          }],
          140: [function (e, t, n) {
            "use strict";

            var r = e("gl-shader"),
              i = e("gl-buffer"),
              o = e("gl-vao"),
              a = e("gl-texture2d"),
              s = e("normals"),
              l = e("gl-mat4/multiply"),
              u = e("gl-mat4/invert"),
              c = e("ndarray"),
              d = e("colormap"),
              h = e("simplicial-complex-contour"),
              f = e("typedarray-pool"),
              p = e("./lib/shaders"),
              m = e("./lib/closest-point"),
              g = p.meshShader,
              v = p.wireShader,
              y = p.pointShader,
              b = p.pickShader,
              _ = p.pointPickShader,
              x = p.contourShader,
              w = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            function S(e, t, n, r, i, o, a, s, l, u, c, d, h, f, p, m, g, v, y, b, _, x, S, A, E, T, M) {
              this.gl = e, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = t, this.dirty = !0, this.triShader = n, this.lineShader = r, this.pointShader = i, this.pickShader = o, this.pointPickShader = a, this.contourShader = s, this.trianglePositions = l, this.triangleColors = c, this.triangleNormals = h, this.triangleUVs = d, this.triangleIds = u, this.triangleVAO = f, this.triangleCount = 0, this.lineWidth = 1, this.edgePositions = p, this.edgeColors = g, this.edgeUVs = v, this.edgeIds = m, this.edgeVAO = y, this.edgeCount = 0, this.pointPositions = b, this.pointColors = x, this.pointUVs = S, this.pointSizes = A, this.pointIds = _, this.pointVAO = E, this.pointCount = 0, this.contourLineWidth = 1, this.contourPositions = T, this.contourVAO = M, this.contourCount = 0, this.contourColor = [0, 0, 0], this.contourEnable = !0, this.pickVertex = !0, this.pickId = 1, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.lightPosition = [1e5, 1e5, 0], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.hasAlpha = !1, this.opacityscale = !1, this._model = w, this._view = w, this._projection = w, this._resolution = [1, 1];
            }
            var A = S.prototype;
            function E(e, t) {
              if (!t) return 1;
              if (!t.length) return 1;
              for (var n = 0; n < t.length; ++n) {
                if (t.length < 2) return 1;
                if (t[n][0] === e) return t[n][1];
                if (t[n][0] > e && n > 0) {
                  var r = (t[n][0] - e) / (t[n][0] - t[n - 1][0]);
                  return t[n][1] * (1 - r) + r * t[n - 1][1];
                }
              }
              return 1;
            }
            function T(e) {
              var t = r(e, y.vertex, y.fragment);
              return t.attributes.position.location = 0, t.attributes.color.location = 2, t.attributes.uv.location = 3, t.attributes.pointSize.location = 4, t;
            }
            function M(e) {
              var t = r(e, b.vertex, b.fragment);
              return t.attributes.position.location = 0, t.attributes.id.location = 1, t;
            }
            function C(e) {
              var t = r(e, _.vertex, _.fragment);
              return t.attributes.position.location = 0, t.attributes.id.location = 1, t.attributes.pointSize.location = 4, t;
            }
            function k(e) {
              var t = r(e, x.vertex, x.fragment);
              return t.attributes.position.location = 0, t;
            }
            A.isOpaque = function () {
              return !this.hasAlpha;
            }, A.isTransparent = function () {
              return this.hasAlpha;
            }, A.pickSlots = 1, A.setPickBase = function (e) {
              this.pickId = e;
            }, A.highlight = function (e) {
              if (e && this.contourEnable) {
                for (var t = h(this.cells, this.intensity, e.intensity), n = t.cells, r = t.vertexIds, i = t.vertexWeights, o = n.length, a = f.mallocFloat32(6 * o), s = 0, l = 0; l < o; ++l) for (var u = n[l], c = 0; c < 2; ++c) {
                  var d = u[0];
                  2 === u.length && (d = u[c]);
                  for (var p = r[d][0], m = r[d][1], g = i[d], v = 1 - g, y = this.positions[p], b = this.positions[m], _ = 0; _ < 3; ++_) a[s++] = g * y[_] + v * b[_];
                }
                this.contourCount = s / 3 | 0, this.contourPositions.update(a.subarray(0, s)), f.free(a);
              } else this.contourCount = 0;
            }, A.update = function (e) {
              e = e || {};
              var t = this.gl;
              this.dirty = !0, "contourEnable" in e && (this.contourEnable = e.contourEnable), "contourColor" in e && (this.contourColor = e.contourColor), "lineWidth" in e && (this.lineWidth = e.lineWidth), "lightPosition" in e && (this.lightPosition = e.lightPosition), this.hasAlpha = !1, "opacity" in e && (this.opacity = e.opacity, this.opacity < 1 && (this.hasAlpha = !0)), "opacityscale" in e && (this.opacityscale = e.opacityscale, this.hasAlpha = !0), "ambient" in e && (this.ambientLight = e.ambient), "diffuse" in e && (this.diffuseLight = e.diffuse), "specular" in e && (this.specularLight = e.specular), "roughness" in e && (this.roughness = e.roughness), "fresnel" in e && (this.fresnel = e.fresnel), e.texture ? (this.texture.dispose(), this.texture = a(t, e.texture)) : e.colormap && (this.texture.shape = [256, 256], this.texture.minFilter = t.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = t.LINEAR, this.texture.setPixels(function (e, t) {
                for (var n = d({
                    colormap: e,
                    nshades: 256,
                    format: "rgba"
                  }), r = new Uint8Array(1024), i = 0; i < 256; ++i) {
                  for (var o = n[i], a = 0; a < 3; ++a) r[4 * i + a] = o[a];
                  r[4 * i + 3] = t ? 255 * E(i / 255, t) : 255 * o[3];
                }
                return c(r, [256, 256, 4], [4, 0, 1]);
              }(e.colormap, this.opacityscale)), this.texture.generateMipmap());
              var n = e.cells,
                r = e.positions;
              if (r && n) {
                var i = [],
                  o = [],
                  l = [],
                  u = [],
                  h = [],
                  f = [],
                  p = [],
                  m = [],
                  g = [],
                  v = [],
                  y = [],
                  b = [],
                  _ = [],
                  x = [];
                this.cells = n, this.positions = r;
                var w = e.vertexNormals,
                  S = e.cellNormals,
                  A = void 0 === e.vertexNormalsEpsilon ? 1e-6 : e.vertexNormalsEpsilon,
                  T = void 0 === e.faceNormalsEpsilon ? 1e-6 : e.faceNormalsEpsilon;
                e.useFacetNormals && !S && (S = s.faceNormals(n, r, T)), S || w || (w = s.vertexNormals(n, r, A));
                var M = e.vertexColors,
                  C = e.cellColors,
                  k = e.meshColor || [1, 1, 1, 1],
                  P = e.vertexUVs,
                  O = e.vertexIntensity,
                  R = e.cellUVs,
                  I = e.cellIntensity,
                  j = 1 / 0,
                  N = -1 / 0;
                if (!P && !R) if (O) {
                  if (e.vertexIntensityBounds) j = +e.vertexIntensityBounds[0], N = +e.vertexIntensityBounds[1];else for (var L = 0; L < O.length; ++L) {
                    var D = O[L];
                    j = Math.min(j, D), N = Math.max(N, D);
                  }
                } else if (I) {
                  if (e.cellIntensityBounds) j = +e.cellIntensityBounds[0], N = +e.cellIntensityBounds[1];else for (L = 0; L < I.length; ++L) D = I[L], j = Math.min(j, D), N = Math.max(N, D);
                } else for (L = 0; L < r.length; ++L) D = r[L][2], j = Math.min(j, D), N = Math.max(N, D);
                this.intensity = O || I || function (e) {
                  for (var t = e.length, n = new Array(t), r = 0; r < t; ++r) n[r] = e[r][2];
                  return n;
                }(r), this.pickVertex = !(I || C);
                var B = e.pointSizes,
                  F = e.pointSize || 1;
                for (this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], L = 0; L < r.length; ++L) for (var z = r[L], U = 0; U < 3; ++U) !isNaN(z[U]) && isFinite(z[U]) && (this.bounds[0][U] = Math.min(this.bounds[0][U], z[U]), this.bounds[1][U] = Math.max(this.bounds[1][U], z[U]));
                var G = 0,
                  V = 0,
                  H = 0;
                e: for (L = 0; L < n.length; ++L) {
                  var q = n[L];
                  switch (q.length) {
                    case 1:
                      for (z = r[$ = q[0]], U = 0; U < 3; ++U) if (isNaN(z[U]) || !isFinite(z[U])) continue e;
                      v.push(z[0], z[1], z[2]), X = M ? M[$] : C ? C[L] : k, this.opacityscale && O ? o.push(X[0], X[1], X[2], this.opacity * E((O[$] - j) / (N - j), this.opacityscale)) : 3 === X.length ? y.push(X[0], X[1], X[2], this.opacity) : (y.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)), Y = P ? P[$] : O ? [(O[$] - j) / (N - j), 0] : R ? R[L] : I ? [(I[L] - j) / (N - j), 0] : [(z[2] - j) / (N - j), 0], b.push(Y[0], Y[1]), B ? _.push(B[$]) : _.push(F), x.push(L), H += 1;
                      break;
                    case 2:
                      for (U = 0; U < 2; ++U) {
                        z = r[$ = q[U]];
                        for (var W = 0; W < 3; ++W) if (isNaN(z[W]) || !isFinite(z[W])) continue e;
                      }
                      for (U = 0; U < 2; ++U) z = r[$ = q[U]], f.push(z[0], z[1], z[2]), X = M ? M[$] : C ? C[L] : k, this.opacityscale && O ? o.push(X[0], X[1], X[2], this.opacity * E((O[$] - j) / (N - j), this.opacityscale)) : 3 === X.length ? p.push(X[0], X[1], X[2], this.opacity) : (p.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)), Y = P ? P[$] : O ? [(O[$] - j) / (N - j), 0] : R ? R[L] : I ? [(I[L] - j) / (N - j), 0] : [(z[2] - j) / (N - j), 0], m.push(Y[0], Y[1]), g.push(L);
                      V += 1;
                      break;
                    case 3:
                      for (U = 0; U < 3; ++U) for (z = r[$ = q[U]], W = 0; W < 3; ++W) if (isNaN(z[W]) || !isFinite(z[W])) continue e;
                      for (U = 0; U < 3; ++U) {
                        var $, X, Y, K;
                        z = r[$ = q[2 - U]], i.push(z[0], z[1], z[2]), (X = M ? M[$] : C ? C[L] : k) ? this.opacityscale && O ? o.push(X[0], X[1], X[2], this.opacity * E((O[$] - j) / (N - j), this.opacityscale)) : 3 === X.length ? o.push(X[0], X[1], X[2], this.opacity) : (o.push(X[0], X[1], X[2], X[3] * this.opacity), X[3] < 1 && (this.hasAlpha = !0)) : o.push(.5, .5, .5, 1), Y = P ? P[$] : O ? [(O[$] - j) / (N - j), 0] : R ? R[L] : I ? [(I[L] - j) / (N - j), 0] : [(z[2] - j) / (N - j), 0], u.push(Y[0], Y[1]), K = w ? w[$] : S[L], l.push(K[0], K[1], K[2]), h.push(L);
                      }
                      G += 1;
                  }
                }
                this.pointCount = H, this.edgeCount = V, this.triangleCount = G, this.pointPositions.update(v), this.pointColors.update(y), this.pointUVs.update(b), this.pointSizes.update(_), this.pointIds.update(new Uint32Array(x)), this.edgePositions.update(f), this.edgeColors.update(p), this.edgeUVs.update(m), this.edgeIds.update(new Uint32Array(g)), this.trianglePositions.update(i), this.triangleColors.update(o), this.triangleUVs.update(u), this.triangleNormals.update(l), this.triangleIds.update(new Uint32Array(h));
              }
            }, A.drawTransparent = A.draw = function (e) {
              e = e || {};
              for (var t = this.gl, n = e.model || w, r = e.view || w, i = e.projection || w, o = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], a = 0; a < 3; ++a) o[0][a] = Math.max(o[0][a], this.clipBounds[0][a]), o[1][a] = Math.min(o[1][a], this.clipBounds[1][a]);
              var s = {
                model: n,
                view: r,
                projection: i,
                inverseModel: w.slice(),
                clipBounds: o,
                kambient: this.ambientLight,
                kdiffuse: this.diffuseLight,
                kspecular: this.specularLight,
                roughness: this.roughness,
                fresnel: this.fresnel,
                eyePosition: [0, 0, 0],
                lightPosition: [0, 0, 0],
                contourColor: this.contourColor,
                texture: 0
              };
              s.inverseModel = u(s.inverseModel, s.model), t.disable(t.CULL_FACE), this.texture.bind(0);
              var c = new Array(16);
              for (l(c, s.view, s.model), l(c, s.projection, c), u(c, c), a = 0; a < 3; ++a) s.eyePosition[a] = c[12 + a] / c[15];
              var d,
                h = c[15];
              for (a = 0; a < 3; ++a) h += this.lightPosition[a] * c[4 * a + 3];
              for (a = 0; a < 3; ++a) {
                for (var f = c[12 + a], p = 0; p < 3; ++p) f += c[4 * p + a] * this.lightPosition[p];
                s.lightPosition[a] = f / h;
              }
              this.triangleCount > 0 && ((d = this.triShader).bind(), d.uniforms = s, this.triangleVAO.bind(), t.drawArrays(t.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind()), this.edgeCount > 0 && this.lineWidth > 0 && ((d = this.lineShader).bind(), d.uniforms = s, this.edgeVAO.bind(), t.lineWidth(this.lineWidth * this.pixelRatio), t.drawArrays(t.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind()), this.pointCount > 0 && ((d = this.pointShader).bind(), d.uniforms = s, this.pointVAO.bind(), t.drawArrays(t.POINTS, 0, this.pointCount), this.pointVAO.unbind()), this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0 && ((d = this.contourShader).bind(), d.uniforms = s, this.contourVAO.bind(), t.drawArrays(t.LINES, 0, this.contourCount), this.contourVAO.unbind());
            }, A.drawPick = function (e) {
              e = e || {};
              for (var t = this.gl, n = e.model || w, r = e.view || w, i = e.projection || w, o = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]], a = 0; a < 3; ++a) o[0][a] = Math.max(o[0][a], this.clipBounds[0][a]), o[1][a] = Math.min(o[1][a], this.clipBounds[1][a]);
              this._model = [].slice.call(n), this._view = [].slice.call(r), this._projection = [].slice.call(i), this._resolution = [t.drawingBufferWidth, t.drawingBufferHeight];
              var s,
                l = {
                  model: n,
                  view: r,
                  projection: i,
                  clipBounds: o,
                  pickId: this.pickId / 255
                };
              (s = this.pickShader).bind(), s.uniforms = l, this.triangleCount > 0 && (this.triangleVAO.bind(), t.drawArrays(t.TRIANGLES, 0, 3 * this.triangleCount), this.triangleVAO.unbind()), this.edgeCount > 0 && (this.edgeVAO.bind(), t.lineWidth(this.lineWidth * this.pixelRatio), t.drawArrays(t.LINES, 0, 2 * this.edgeCount), this.edgeVAO.unbind()), this.pointCount > 0 && ((s = this.pointPickShader).bind(), s.uniforms = l, this.pointVAO.bind(), t.drawArrays(t.POINTS, 0, this.pointCount), this.pointVAO.unbind());
            }, A.pick = function (e) {
              if (!e) return null;
              if (e.id !== this.pickId) return null;
              for (var t = e.value[0] + 256 * e.value[1] + 65536 * e.value[2], n = this.cells[t], r = this.positions, i = new Array(n.length), o = 0; o < n.length; ++o) i[o] = r[n[o]];
              var a = e.coord[0],
                s = e.coord[1];
              if (!this.pickVertex) {
                var l = this.positions[n[0]],
                  u = this.positions[n[1]],
                  c = this.positions[n[2]],
                  d = [(l[0] + u[0] + c[0]) / 3, (l[1] + u[1] + c[1]) / 3, (l[2] + u[2] + c[2]) / 3];
                return {
                  _cellCenter: !0,
                  position: [a, s],
                  index: t,
                  cell: n,
                  cellId: t,
                  intensity: this.intensity[t],
                  dataCoordinate: d
                };
              }
              var h = m(i, [a * this.pixelRatio, this._resolution[1] - s * this.pixelRatio], this._model, this._view, this._projection, this._resolution);
              if (!h) return null;
              var f = h[2],
                p = 0;
              for (o = 0; o < n.length; ++o) p += f[o] * this.intensity[n[o]];
              return {
                position: h[1],
                index: n[h[0]],
                cell: n,
                cellId: t,
                intensity: p,
                dataCoordinate: this.positions[n[h[0]]]
              };
            }, A.dispose = function () {
              this.texture.dispose(), this.triShader.dispose(), this.lineShader.dispose(), this.pointShader.dispose(), this.pickShader.dispose(), this.pointPickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleNormals.dispose(), this.triangleIds.dispose(), this.edgeVAO.dispose(), this.edgePositions.dispose(), this.edgeColors.dispose(), this.edgeUVs.dispose(), this.edgeIds.dispose(), this.pointVAO.dispose(), this.pointPositions.dispose(), this.pointColors.dispose(), this.pointUVs.dispose(), this.pointSizes.dispose(), this.pointIds.dispose(), this.contourVAO.dispose(), this.contourPositions.dispose(), this.contourShader.dispose();
            }, t.exports = function (e, t) {
              if (1 === arguments.length && (e = (t = e).gl), !(e.getExtension("OES_standard_derivatives") || e.getExtension("MOZ_OES_standard_derivatives") || e.getExtension("WEBKIT_OES_standard_derivatives"))) throw new Error("derivatives not supported");
              var n = function (e) {
                  var t = r(e, g.vertex, g.fragment);
                  return t.attributes.position.location = 0, t.attributes.color.location = 2, t.attributes.uv.location = 3, t.attributes.normal.location = 4, t;
                }(e),
                s = function (e) {
                  var t = r(e, v.vertex, v.fragment);
                  return t.attributes.position.location = 0, t.attributes.color.location = 2, t.attributes.uv.location = 3, t;
                }(e),
                l = T(e),
                u = M(e),
                d = C(e),
                h = k(e),
                f = a(e, c(new Uint8Array([255, 255, 255, 255]), [1, 1, 4]));
              f.generateMipmap(), f.minFilter = e.LINEAR_MIPMAP_LINEAR, f.magFilter = e.LINEAR;
              var p = i(e),
                m = i(e),
                y = i(e),
                b = i(e),
                _ = i(e),
                x = o(e, [{
                  buffer: p,
                  type: e.FLOAT,
                  size: 3
                }, {
                  buffer: _,
                  type: e.UNSIGNED_BYTE,
                  size: 4,
                  normalized: !0
                }, {
                  buffer: m,
                  type: e.FLOAT,
                  size: 4
                }, {
                  buffer: y,
                  type: e.FLOAT,
                  size: 2
                }, {
                  buffer: b,
                  type: e.FLOAT,
                  size: 3
                }]),
                w = i(e),
                A = i(e),
                E = i(e),
                P = i(e),
                O = o(e, [{
                  buffer: w,
                  type: e.FLOAT,
                  size: 3
                }, {
                  buffer: P,
                  type: e.UNSIGNED_BYTE,
                  size: 4,
                  normalized: !0
                }, {
                  buffer: A,
                  type: e.FLOAT,
                  size: 4
                }, {
                  buffer: E,
                  type: e.FLOAT,
                  size: 2
                }]),
                R = i(e),
                I = i(e),
                j = i(e),
                N = i(e),
                L = i(e),
                D = o(e, [{
                  buffer: R,
                  type: e.FLOAT,
                  size: 3
                }, {
                  buffer: L,
                  type: e.UNSIGNED_BYTE,
                  size: 4,
                  normalized: !0
                }, {
                  buffer: I,
                  type: e.FLOAT,
                  size: 4
                }, {
                  buffer: j,
                  type: e.FLOAT,
                  size: 2
                }, {
                  buffer: N,
                  type: e.FLOAT,
                  size: 1
                }]),
                B = i(e),
                F = new S(e, f, n, s, l, u, d, h, p, _, m, y, b, x, w, P, A, E, O, R, L, I, j, N, D, B, o(e, [{
                  buffer: B,
                  type: e.FLOAT,
                  size: 3
                }]));
              return F.update(t), F;
            };
          }, {
            "./lib/closest-point": 138,
            "./lib/shaders": 139,
            colormap: 69,
            "gl-buffer": 104,
            "gl-mat4/invert": 125,
            "gl-mat4/multiply": 127,
            "gl-shader": 150,
            "gl-texture2d": 164,
            "gl-vao": 168,
            ndarray: 285,
            normals: 287,
            "simplicial-complex-contour": 329,
            "typedarray-pool": 347
          }],
          141: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              e = e || document.body;
              var n = [.01, 1 / 0];
              "distanceLimits" in (t = t || {}) && (n[0] = t.distanceLimits[0], n[1] = t.distanceLimits[1]), "zoomMin" in t && (n[0] = t.zoomMin), "zoomMax" in t && (n[1] = t.zoomMax);
              var u = i({
                  center: t.center || [0, 0, 0],
                  up: t.up || [0, 1, 0],
                  eye: t.eye || [0, 0, 10],
                  mode: t.mode || "orbit",
                  distanceLimits: n
                }),
                c = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                d = 0,
                h = e.clientWidth,
                f = e.clientHeight,
                p = {
                  keyBindingMode: "rotate",
                  enableWheel: !0,
                  view: u,
                  element: e,
                  delay: t.delay || 16,
                  rotateSpeed: t.rotateSpeed || 1,
                  zoomSpeed: t.zoomSpeed || 1,
                  translateSpeed: t.translateSpeed || 1,
                  flipX: !!t.flipX,
                  flipY: !!t.flipY,
                  modes: u.modes,
                  _ortho: t._ortho || t.projection && "orthographic" === t.projection.type || !1,
                  tick: function tick() {
                    var t = r(),
                      n = this.delay,
                      i = t - 2 * n;
                    u.idle(t - n), u.recalcMatrix(i), u.flush(t - (100 + 2 * n));
                    for (var o = !0, a = u.computedMatrix, s = 0; s < 16; ++s) o = o && c[s] === a[s], c[s] = a[s];
                    var l = e.clientWidth === h && e.clientHeight === f;
                    return h = e.clientWidth, f = e.clientHeight, o ? !l : (d = Math.exp(u.computedRadius[0]), !0);
                  },
                  lookAt: function lookAt(e, t, n) {
                    u.lookAt(u.lastT(), e, t, n);
                  },
                  rotate: function rotate(e, t, n) {
                    u.rotate(u.lastT(), e, t, n);
                  },
                  pan: function pan(e, t, n) {
                    u.pan(u.lastT(), e, t, n);
                  },
                  translate: function translate(e, t, n) {
                    u.translate(u.lastT(), e, t, n);
                  }
                };
              return Object.defineProperties(p, {
                matrix: {
                  get: function get() {
                    return u.computedMatrix;
                  },
                  set: function set(e) {
                    return u.setMatrix(u.lastT(), e), u.computedMatrix;
                  },
                  enumerable: !0
                },
                mode: {
                  get: function get() {
                    return u.getMode();
                  },
                  set: function set(e) {
                    var t = u.computedUp.slice(),
                      n = u.computedEye.slice(),
                      i = u.computedCenter.slice();
                    if (u.setMode(e), "turntable" === e) {
                      var o = r();
                      u._active.lookAt(o, n, i, t), u._active.lookAt(o + 500, n, i, [0, 0, 1]), u._active.flush(o);
                    }
                    return u.getMode();
                  },
                  enumerable: !0
                },
                center: {
                  get: function get() {
                    return u.computedCenter;
                  },
                  set: function set(e) {
                    return u.lookAt(u.lastT(), null, e), u.computedCenter;
                  },
                  enumerable: !0
                },
                eye: {
                  get: function get() {
                    return u.computedEye;
                  },
                  set: function set(e) {
                    return u.lookAt(u.lastT(), e), u.computedEye;
                  },
                  enumerable: !0
                },
                up: {
                  get: function get() {
                    return u.computedUp;
                  },
                  set: function set(e) {
                    return u.lookAt(u.lastT(), null, null, e), u.computedUp;
                  },
                  enumerable: !0
                },
                distance: {
                  get: function get() {
                    return d;
                  },
                  set: function set(e) {
                    return u.setDistance(u.lastT(), e), e;
                  },
                  enumerable: !0
                },
                distanceLimits: {
                  get: function get() {
                    return u.getDistanceLimits(n);
                  },
                  set: function set(e) {
                    return u.setDistanceLimits(e), e;
                  },
                  enumerable: !0
                }
              }), e.addEventListener("contextmenu", function (e) {
                return e.preventDefault(), !1;
              }), p._lastX = -1, p._lastY = -1, p._lastMods = {
                shift: !1,
                control: !1,
                alt: !1,
                meta: !1
              }, p.enableMouseListeners = function () {
                function t(t, n, i, o) {
                  var a = p.keyBindingMode;
                  if (!1 !== a) {
                    var s = "rotate" === a,
                      l = "pan" === a,
                      c = "zoom" === a,
                      h = !!o.control,
                      f = !!o.alt,
                      m = !!o.shift,
                      g = !!(1 & t),
                      v = !!(2 & t),
                      y = !!(4 & t),
                      b = 1 / e.clientHeight,
                      _ = b * (n - p._lastX),
                      x = b * (i - p._lastY),
                      w = p.flipX ? 1 : -1,
                      S = p.flipY ? 1 : -1,
                      A = Math.PI * p.rotateSpeed,
                      E = r();
                    if (-1 !== p._lastX && -1 !== p._lastY && ((s && g && !h && !f && !m || g && !h && !f && m) && u.rotate(E, w * A * _, -S * A * x, 0), (l && g && !h && !f && !m || v || g && h && !f && !m) && u.pan(E, -p.translateSpeed * _ * d, p.translateSpeed * x * d, 0), c && g && !h && !f && !m || y || g && !h && f && !m)) {
                      var T = -p.zoomSpeed * x / window.innerHeight * (E - u.lastT()) * 100;
                      u.pan(E, 0, 0, d * (Math.exp(T) - 1));
                    }
                    return p._lastX = n, p._lastY = i, p._lastMods = o, !0;
                  }
                }
                p.mouseListener = o(e, t), e.addEventListener("touchstart", function (n) {
                  var r = s(n.changedTouches[0], e);
                  t(0, r[0], r[1], p._lastMods), t(1, r[0], r[1], p._lastMods), n.preventDefault();
                }, !!l && {
                  passive: !1
                }), e.addEventListener("touchmove", function (n) {
                  var r = s(n.changedTouches[0], e);
                  t(1, r[0], r[1], p._lastMods), n.preventDefault();
                }, !!l && {
                  passive: !1
                }), e.addEventListener("touchend", function (e) {
                  t(0, p._lastX, p._lastY, p._lastMods), e.preventDefault();
                }, !!l && {
                  passive: !1
                }), p.wheelListener = a(e, function (e, t) {
                  if (!1 !== p.keyBindingMode && p.enableWheel) {
                    var n = p.flipX ? 1 : -1,
                      i = p.flipY ? 1 : -1,
                      o = r();
                    if (Math.abs(e) > Math.abs(t)) u.rotate(o, 0, 0, -e * n * Math.PI * p.rotateSpeed / window.innerWidth);else if (!p._ortho) {
                      var a = -p.zoomSpeed * i * t / window.innerHeight * (o - u.lastT()) / 20;
                      u.pan(o, 0, 0, d * (Math.exp(a) - 1));
                    }
                  }
                }, !0);
              }, p.enableMouseListeners(), p;
            };
            var r = e("right-now"),
              i = e("3d-view"),
              o = e("mouse-change"),
              a = e("mouse-wheel"),
              s = e("mouse-event-offset"),
              l = e("has-passive-events");
          }, {
            "3d-view": 11,
            "has-passive-events": 251,
            "mouse-change": 270,
            "mouse-event-offset": 271,
            "mouse-wheel": 273,
            "right-now": 315
          }],
          142: [function (e, t, n) {
            var r = e("glslify"),
              i = e("gl-shader"),
              o = r(["precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"]),
              a = r(["precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"]);
            t.exports = function (e) {
              return i(e, o, a, null, [{
                name: "position",
                type: "vec2"
              }]);
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          143: [function (e, t, n) {
            "use strict";

            var r = e("./camera.js"),
              i = e("gl-axes3d"),
              o = e("gl-axes3d/properties"),
              a = e("gl-spikes3d"),
              s = e("gl-select-static"),
              l = e("gl-fbo"),
              u = e("a-big-triangle"),
              c = e("mouse-change"),
              d = e("gl-mat4/perspective"),
              h = e("gl-mat4/ortho"),
              f = e("./lib/shader"),
              p = e("is-mobile")({
                tablet: !0,
                featureDetect: !0
              });
            function m() {
              this.mouse = [-1, -1], this.screen = null, this.distance = 1 / 0, this.index = null, this.dataCoordinate = null, this.dataPosition = null, this.object = null, this.data = null;
            }
            function g(e) {
              var t = Math.round(Math.log(Math.abs(e)) / Math.log(10));
              if (t < 0) {
                var n = Math.round(Math.pow(10, -t));
                return Math.ceil(e * n) / n;
              }
              return t > 0 ? (n = Math.round(Math.pow(10, t)), Math.ceil(e / n) * n) : Math.ceil(e);
            }
            function v(e) {
              return "boolean" != typeof e || e;
            }
            t.exports = {
              createScene: function createScene(e) {
                (e = e || {}).camera = e.camera || {};
                var t = e.canvas;
                t || (t = document.createElement("canvas"), e.container ? e.container.appendChild(t) : document.body.appendChild(t));
                var n = e.gl;
                if (n || (e.glOptions && (p = !!e.glOptions.preserveDrawingBuffer), n = function (e, t) {
                  var n = null;
                  try {
                    (n = e.getContext("webgl", t)) || (n = e.getContext("experimental-webgl", t));
                  } catch (e) {
                    return null;
                  }
                  return n;
                }(t, e.glOptions || {
                  premultipliedAlpha: !0,
                  antialias: !0,
                  preserveDrawingBuffer: p
                })), !n) throw new Error("webgl not supported");
                var y = e.bounds || [[-10, -10, -10], [10, 10, 10]],
                  b = new m(),
                  _ = l(n, n.drawingBufferWidth, n.drawingBufferHeight, {
                    preferFloat: !p
                  }),
                  x = f(n),
                  w = e.cameraObject && !0 === e.cameraObject._ortho || e.camera.projection && "orthographic" === e.camera.projection.type || !1,
                  S = {
                    eye: e.camera.eye || [2, 0, 0],
                    center: e.camera.center || [0, 0, 0],
                    up: e.camera.up || [0, 1, 0],
                    zoomMin: e.camera.zoomMax || .1,
                    zoomMax: e.camera.zoomMin || 100,
                    mode: e.camera.mode || "turntable",
                    _ortho: w
                  },
                  A = e.axes || {},
                  E = i(n, A);
                E.enable = !A.disable;
                var T = e.spikes || {},
                  M = a(n, T),
                  C = [],
                  k = [],
                  P = [],
                  O = [],
                  R = !0,
                  I = !0,
                  j = {
                    view: null,
                    projection: new Array(16),
                    model: new Array(16),
                    _ortho: !1
                  },
                  N = (I = !0, [n.drawingBufferWidth, n.drawingBufferHeight]),
                  L = e.cameraObject || r(t, S),
                  D = {
                    gl: n,
                    contextLost: !1,
                    pixelRatio: e.pixelRatio || 1,
                    canvas: t,
                    selection: b,
                    camera: L,
                    axes: E,
                    axesPixels: null,
                    spikes: M,
                    bounds: y,
                    objects: C,
                    shape: N,
                    aspect: e.aspectRatio || [1, 1, 1],
                    pickRadius: e.pickRadius || 10,
                    zNear: e.zNear || .01,
                    zFar: e.zFar || 1e3,
                    fovy: e.fovy || Math.PI / 4,
                    clearColor: e.clearColor || [0, 0, 0, 0],
                    autoResize: v(e.autoResize),
                    autoBounds: v(e.autoBounds),
                    autoScale: !!e.autoScale,
                    autoCenter: v(e.autoCenter),
                    clipToBounds: v(e.clipToBounds),
                    snapToData: !!e.snapToData,
                    onselect: e.onselect || null,
                    onrender: e.onrender || null,
                    onclick: e.onclick || null,
                    cameraParams: j,
                    oncontextloss: null,
                    mouseListener: null,
                    _stopped: !1,
                    getAspectratio: function getAspectratio() {
                      return {
                        x: this.aspect[0],
                        y: this.aspect[1],
                        z: this.aspect[2]
                      };
                    },
                    setAspectratio: function setAspectratio(e) {
                      this.aspect[0] = e.x, this.aspect[1] = e.y, this.aspect[2] = e.z, I = !0;
                    },
                    setBounds: function setBounds(e, t) {
                      this.bounds[0][e] = t.min, this.bounds[1][e] = t.max;
                    },
                    setClearColor: function setClearColor(e) {
                      this.clearColor = e;
                    },
                    clearRGBA: function clearRGBA() {
                      this.gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]), this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
                    }
                  },
                  B = [n.drawingBufferWidth / D.pixelRatio | 0, n.drawingBufferHeight / D.pixelRatio | 0];
                function F() {
                  if (!D._stopped && D.autoResize) {
                    var e = t.parentNode,
                      n = 1,
                      r = 1;
                    e && e !== document.body ? (n = e.clientWidth, r = e.clientHeight) : (n = window.innerWidth, r = window.innerHeight);
                    var i = 0 | Math.ceil(n * D.pixelRatio),
                      o = 0 | Math.ceil(r * D.pixelRatio);
                    if (i !== t.width || o !== t.height) {
                      t.width = i, t.height = o;
                      var a = t.style;
                      a.position = a.position || "absolute", a.left = "0px", a.top = "0px", a.width = n + "px", a.height = r + "px", R = !0;
                    }
                  }
                }
                function z() {
                  for (var e = C.length, t = O.length, r = 0; r < t; ++r) P[r] = 0;
                  e: for (r = 0; r < e; ++r) {
                    var i = C[r],
                      o = i.pickSlots;
                    if (o) {
                      for (var a = 0; a < t; ++a) if (P[a] + o < 255) {
                        k[r] = a, i.setPickBase(P[a] + 1), P[a] += o;
                        continue e;
                      }
                      var l = s(n, N);
                      k[r] = t, O.push(l), P.push(o), i.setPickBase(1), t += 1;
                    } else k[r] = -1;
                  }
                  for (; t > 0 && 0 === P[t - 1];) P.pop(), O.pop().dispose();
                }
                function U() {
                  if (D.contextLost) return !0;
                  n.isContextLost() && (D.contextLost = !0, D.mouseListener.enabled = !1, D.selection.object = null, D.oncontextloss && D.oncontextloss());
                }
                D.autoResize && F(), window.addEventListener("resize", F), D.update = function (e) {
                  D._stopped || (e = e || {}, R = !0, I = !0);
                }, D.add = function (e) {
                  D._stopped || (e.axes = E, C.push(e), k.push(-1), R = !0, I = !0, z());
                }, D.remove = function (e) {
                  if (!D._stopped) {
                    var t = C.indexOf(e);
                    t < 0 || (C.splice(t, 1), k.pop(), R = !0, I = !0, z());
                  }
                }, D.dispose = function () {
                  if (!D._stopped && (D._stopped = !0, window.removeEventListener("resize", F), t.removeEventListener("webglcontextlost", U), D.mouseListener.enabled = !1, !D.contextLost)) {
                    E.dispose(), M.dispose();
                    for (var e = 0; e < C.length; ++e) C[e].dispose();
                    for (_.dispose(), e = 0; e < O.length; ++e) O[e].dispose();
                    x.dispose(), n = null, E = null, M = null, C = [];
                  }
                }, D._mouseRotating = !1, D._prevButtons = 0, D.enableMouseListeners = function () {
                  D.mouseListener = c(t, function (e, t, n) {
                    if (!D._stopped) {
                      var r = O.length,
                        i = C.length,
                        o = b.object;
                      b.distance = 1 / 0, b.mouse[0] = t, b.mouse[1] = n, b.object = null, b.screen = null, b.dataCoordinate = b.dataPosition = null;
                      var a = !1;
                      if (e && D._prevButtons) D._mouseRotating = !0;else {
                        D._mouseRotating && (I = !0), D._mouseRotating = !1;
                        for (var s = 0; s < r; ++s) {
                          var l = O[s].query(t, B[1] - n - 1, D.pickRadius);
                          if (l) {
                            if (l.distance > b.distance) continue;
                            for (var u = 0; u < i; ++u) {
                              var c = C[u];
                              if (k[u] === s) {
                                var d = c.pick(l);
                                d && (b.buttons = e, b.screen = l.coord, b.distance = l.distance, b.object = c, b.index = d.distance, b.dataPosition = d.position, b.dataCoordinate = d.dataCoordinate, b.data = d, a = !0);
                              }
                            }
                          }
                        }
                      }
                      o && o !== b.object && (o.highlight && o.highlight(null), R = !0), b.object && (b.object.highlight && b.object.highlight(b.data), R = !0), (a = a || b.object !== o) && D.onselect && D.onselect(b), 1 & e && !(1 & D._prevButtons) && D.onclick && D.onclick(b), D._prevButtons = e;
                    }
                  });
                }, t.addEventListener("webglcontextlost", U);
                var G = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]],
                  V = [G[0].slice(), G[1].slice()];
                function H() {
                  if (!U()) {
                    F();
                    var e = D.camera.tick();
                    j.view = D.camera.matrix, R = R || e, I = I || e, E.pixelRatio = D.pixelRatio, M.pixelRatio = D.pixelRatio;
                    var t = C.length,
                      r = G[0],
                      i = G[1];
                    r[0] = r[1] = r[2] = 1 / 0, i[0] = i[1] = i[2] = -1 / 0;
                    for (var a = 0; a < t; ++a) {
                      (P = C[a]).pixelRatio = D.pixelRatio, P.axes = D.axes, R = R || !!P.dirty, I = I || !!P.dirty;
                      var s = P.bounds;
                      if (s) for (var l = s[0], c = s[1], f = 0; f < 3; ++f) r[f] = Math.min(r[f], l[f]), i[f] = Math.max(i[f], c[f]);
                    }
                    var p = D.bounds;
                    if (D.autoBounds) for (f = 0; f < 3; ++f) {
                      if (i[f] < r[f]) r[f] = -1, i[f] = 1;else {
                        r[f] === i[f] && (r[f] -= 1, i[f] += 1);
                        var m = .05 * (i[f] - r[f]);
                        r[f] = r[f] - m, i[f] = i[f] + m;
                      }
                      p[0][f] = r[f], p[1][f] = i[f];
                    }
                    var v = !1;
                    for (f = 0; f < 3; ++f) v = v || V[0][f] !== p[0][f] || V[1][f] !== p[1][f], V[0][f] = p[0][f], V[1][f] = p[1][f];
                    if (I = I || v, R = R || v) {
                      if (v) {
                        var y = [0, 0, 0];
                        for (a = 0; a < 3; ++a) y[a] = g((p[1][a] - p[0][a]) / 10);
                        E.autoTicks ? E.update({
                          bounds: p,
                          tickSpacing: y
                        }) : E.update({
                          bounds: p
                        });
                      }
                      var S = n.drawingBufferWidth,
                        A = n.drawingBufferHeight;
                      for (N[0] = S, N[1] = A, B[0] = 0 | Math.max(S / D.pixelRatio, 1), B[1] = 0 | Math.max(A / D.pixelRatio, 1), function (e, t) {
                        var n = e.bounds,
                          r = e.cameraParams,
                          i = r.projection,
                          o = r.model,
                          a = e.gl.drawingBufferWidth,
                          s = e.gl.drawingBufferHeight,
                          l = e.zNear,
                          u = e.zFar,
                          c = e.fovy,
                          f = a / s;
                        t ? (h(i, -f, f, -1, 1, l, u), r._ortho = !0) : (d(i, c, f, l, u), r._ortho = !1);
                        for (var p = 0; p < 16; ++p) o[p] = 0;
                        o[15] = 1;
                        var m = 0;
                        for (p = 0; p < 3; ++p) m = Math.max(m, n[1][p] - n[0][p]);
                        for (p = 0; p < 3; ++p) e.autoScale ? o[5 * p] = e.aspect[p] / (n[1][p] - n[0][p]) : o[5 * p] = 1 / m, e.autoCenter && (o[12 + p] = .5 * -o[5 * p] * (n[0][p] + n[1][p]));
                      }(D, w), a = 0; a < t; ++a) (P = C[a]).axesBounds = p, D.clipToBounds && (P.clipBounds = p);
                      b.object && (D.snapToData ? M.position = b.dataCoordinate : M.position = b.dataPosition, M.bounds = p), I && (I = !1, function () {
                        if (!U()) {
                          n.colorMask(!0, !0, !0, !0), n.depthMask(!0), n.disable(n.BLEND), n.enable(n.DEPTH_TEST), n.depthFunc(n.LEQUAL);
                          for (var e = C.length, t = O.length, r = 0; r < t; ++r) {
                            var i = O[r];
                            i.shape = B, i.begin();
                            for (var o = 0; o < e; ++o) if (k[o] === r) {
                              var a = C[o];
                              a.drawPick && (a.pixelRatio = 1, a.drawPick(j));
                            }
                            i.end();
                          }
                        }
                      }()), D.axesPixels = o(D.axes, j, S, A), D.onrender && D.onrender(), n.bindFramebuffer(n.FRAMEBUFFER, null), n.viewport(0, 0, S, A), D.clearRGBA(), n.depthMask(!0), n.colorMask(!0, !0, !0, !0), n.enable(n.DEPTH_TEST), n.depthFunc(n.LEQUAL), n.disable(n.BLEND), n.disable(n.CULL_FACE);
                      var T = !1;
                      for (E.enable && (T = T || E.isTransparent(), E.draw(j)), M.axes = E, b.object && M.draw(j), n.disable(n.CULL_FACE), a = 0; a < t; ++a) (P = C[a]).axes = E, P.pixelRatio = D.pixelRatio, P.isOpaque && P.isOpaque() && P.draw(j), P.isTransparent && P.isTransparent() && (T = !0);
                      if (T) {
                        for (_.shape = N, _.bind(), n.clear(n.DEPTH_BUFFER_BIT), n.colorMask(!1, !1, !1, !1), n.depthMask(!0), n.depthFunc(n.LESS), E.enable && E.isTransparent() && E.drawTransparent(j), a = 0; a < t; ++a) (P = C[a]).isOpaque && P.isOpaque() && P.draw(j);
                        for (n.enable(n.BLEND), n.blendEquation(n.FUNC_ADD), n.blendFunc(n.ONE, n.ONE_MINUS_SRC_ALPHA), n.colorMask(!0, !0, !0, !0), n.depthMask(!1), n.clearColor(0, 0, 0, 0), n.clear(n.COLOR_BUFFER_BIT), E.isTransparent() && E.drawTransparent(j), a = 0; a < t; ++a) {
                          var P;
                          (P = C[a]).isTransparent && P.isTransparent() && P.drawTransparent(j);
                        }
                        n.bindFramebuffer(n.FRAMEBUFFER, null), n.blendFunc(n.ONE, n.ONE_MINUS_SRC_ALPHA), n.disable(n.DEPTH_TEST), x.bind(), _.color[0].bind(0), x.uniforms.accumBuffer = 0, u(n), n.disable(n.BLEND);
                      }
                      for (R = !1, a = 0; a < t; ++a) C[a].dirty = !1;
                    }
                  }
                }
                return D.enableMouseListeners(), function e() {
                  D._stopped || D.contextLost || (H(), requestAnimationFrame(e));
                }(), D.redraw = function () {
                  D._stopped || (R = !0, H());
                }, D;
              },
              createCamera: r
            };
          }, {
            "./camera.js": 141,
            "./lib/shader": 142,
            "a-big-triangle": 12,
            "gl-axes3d": 96,
            "gl-axes3d/properties": 103,
            "gl-fbo": 112,
            "gl-mat4/ortho": 128,
            "gl-mat4/perspective": 129,
            "gl-select-static": 149,
            "gl-spikes3d": 158,
            "is-mobile": 259,
            "mouse-change": 270
          }],
          144: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i,
                o,
                a,
                s,
                l,
                u = t[0],
                c = t[1],
                d = t[2],
                h = t[3],
                f = n[0],
                p = n[1],
                m = n[2],
                g = n[3];
              return (o = u * f + c * p + d * m + h * g) < 0 && (o = -o, f = -f, p = -p, m = -m, g = -g), 1 - o > 1e-6 ? (i = Math.acos(o), a = Math.sin(i), s = Math.sin((1 - r) * i) / a, l = Math.sin(r * i) / a) : (s = 1 - r, l = r), e[0] = s * u + l * f, e[1] = s * c + l * p, e[2] = s * d + l * m, e[3] = s * h + l * g, e;
            };
          }, {}],
          145: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              return e || 0 === e ? e.toString() : "";
            };
          }, {}],
          146: [function (e, t, n) {
            "use strict";

            var r = e("vectorize-text");
            t.exports = function (e, t, n) {
              var o = i[t];
              if (o || (o = i[t] = {}), e in o) return o[e];
              var a = {
                  textAlign: "center",
                  textBaseline: "middle",
                  lineHeight: 1,
                  font: t,
                  lineSpacing: 1.25,
                  styletags: {
                    breaklines: !0,
                    bolds: !0,
                    italics: !0,
                    subscripts: !0,
                    superscripts: !0
                  },
                  triangles: !0
                },
                s = r(e, a);
              a.triangles = !1;
              var l,
                u,
                c = r(e, a);
              if (n && 1 !== n) {
                for (l = 0; l < s.positions.length; ++l) for (u = 0; u < s.positions[l].length; ++u) s.positions[l][u] /= n;
                for (l = 0; l < c.positions.length; ++l) for (u = 0; u < c.positions[l].length; ++u) c.positions[l][u] /= n;
              }
              var d = [[1 / 0, 1 / 0], [-1 / 0, -1 / 0]],
                h = c.positions.length;
              for (l = 0; l < h; ++l) {
                var f = c.positions[l];
                for (u = 0; u < 2; ++u) d[0][u] = Math.min(d[0][u], f[u]), d[1][u] = Math.max(d[1][u], f[u]);
              }
              return o[e] = [s, c, d];
            };
            var i = {};
          }, {
            "vectorize-text": 350
          }],
          147: [function (e, t, n) {
            var r = e("gl-shader"),
              i = e("glslify"),
              o = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]),
              a = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"]),
              s = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * view * model * vec4(position, 1);\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * view * model * vec4(dataPosition, 1);\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"]),
              l = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"]),
              u = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"]),
              c = [{
                name: "position",
                type: "vec3"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "glyph",
                type: "vec2"
              }, {
                name: "id",
                type: "vec4"
              }],
              d = {
                vertex: o,
                fragment: l,
                attributes: c
              },
              h = {
                vertex: a,
                fragment: l,
                attributes: c
              },
              f = {
                vertex: s,
                fragment: l,
                attributes: c
              },
              p = {
                vertex: o,
                fragment: u,
                attributes: c
              },
              m = {
                vertex: a,
                fragment: u,
                attributes: c
              },
              g = {
                vertex: s,
                fragment: u,
                attributes: c
              };
            function v(e, t) {
              var n = r(e, t),
                i = n.attributes;
              return i.position.location = 0, i.color.location = 1, i.glyph.location = 2, i.id.location = 3, n;
            }
            n.createPerspective = function (e) {
              return v(e, d);
            }, n.createOrtho = function (e) {
              return v(e, h);
            }, n.createProject = function (e) {
              return v(e, f);
            }, n.createPickPerspective = function (e) {
              return v(e, p);
            }, n.createPickOrtho = function (e) {
              return v(e, m);
            }, n.createPickProject = function (e) {
              return v(e, g);
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          148: [function (e, t, n) {
            "use strict";

            var r = e("is-string-blank"),
              i = e("gl-buffer"),
              o = e("gl-vao"),
              a = e("typedarray-pool"),
              s = e("gl-mat4/multiply"),
              l = e("./lib/shaders"),
              u = e("./lib/glyphs"),
              c = e("./lib/get-simple-string"),
              d = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            function h(e, t) {
              var n = e[0],
                r = e[1],
                i = e[2],
                o = e[3];
              return e[0] = t[0] * n + t[4] * r + t[8] * i + t[12] * o, e[1] = t[1] * n + t[5] * r + t[9] * i + t[13] * o, e[2] = t[2] * n + t[6] * r + t[10] * i + t[14] * o, e[3] = t[3] * n + t[7] * r + t[11] * i + t[15] * o, e;
            }
            function f(e, t, n, r) {
              return h(r, r), h(r, r), h(r, r);
            }
            function p(e, t) {
              this.index = e, this.dataCoordinate = this.position = t;
            }
            function m(e) {
              return !0 === e || e > 1 ? 1 : e;
            }
            function g(e, t, n, r, i, o, a, s, l, u, c, d) {
              this.gl = e, this.pixelRatio = 1, this.shader = t, this.orthoShader = n, this.projectShader = r, this.pointBuffer = i, this.colorBuffer = o, this.glyphBuffer = a, this.idBuffer = s, this.vao = l, this.vertexCount = 0, this.lineVertexCount = 0, this.opacity = 1, this.hasAlpha = !1, this.lineWidth = 0, this.projectScale = [2 / 3, 2 / 3, 2 / 3], this.projectOpacity = [1, 1, 1], this.projectHasAlpha = !1, this.pickId = 0, this.pickPerspectiveShader = u, this.pickOrthoShader = c, this.pickProjectShader = d, this.points = [], this._selectResult = new p(0, [0, 0, 0]), this.useOrtho = !0, this.bounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.axesProject = [!0, !0, !0], this.axesBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.highlightId = [1, 1, 1, 1], this.highlightScale = 2, this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.dirty = !0;
            }
            t.exports = function (e) {
              var t = e.gl,
                n = l.createPerspective(t),
                r = l.createOrtho(t),
                a = l.createProject(t),
                s = l.createPickPerspective(t),
                u = l.createPickOrtho(t),
                c = l.createPickProject(t),
                d = i(t),
                h = i(t),
                f = i(t),
                p = i(t),
                m = new g(t, n, r, a, d, h, f, p, o(t, [{
                  buffer: d,
                  size: 3,
                  type: t.FLOAT
                }, {
                  buffer: h,
                  size: 4,
                  type: t.FLOAT
                }, {
                  buffer: f,
                  size: 2,
                  type: t.FLOAT
                }, {
                  buffer: p,
                  size: 4,
                  type: t.UNSIGNED_BYTE,
                  normalized: !0
                }]), s, u, c);
              return m.update(e), m;
            };
            var v = g.prototype;
            v.pickSlots = 1, v.setPickBase = function (e) {
              this.pickId = e;
            }, v.isTransparent = function () {
              if (this.hasAlpha) return !0;
              for (var e = 0; e < 3; ++e) if (this.axesProject[e] && this.projectHasAlpha) return !0;
              return !1;
            }, v.isOpaque = function () {
              if (!this.hasAlpha) return !0;
              for (var e = 0; e < 3; ++e) if (this.axesProject[e] && !this.projectHasAlpha) return !0;
              return !1;
            };
            var y = [0, 0],
              b = [0, 0, 0],
              _ = [0, 0, 0],
              x = [0, 0, 0, 1],
              w = [0, 0, 0, 1],
              S = d.slice(),
              A = [0, 0, 0],
              E = [[0, 0, 0], [0, 0, 0]];
            function T(e) {
              return e[0] = e[1] = e[2] = 0, e;
            }
            function M(e, t) {
              return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = 1, e;
            }
            function C(e, t, n, r) {
              return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[n] = r, e;
            }
            function k(e, t, n, r) {
              var i,
                o = t.axesProject,
                a = t.gl,
                l = e.uniforms,
                u = n.model || d,
                c = n.view || d,
                h = n.projection || d,
                p = t.axesBounds,
                m = function (e) {
                  for (var t = E, n = 0; n < 2; ++n) for (var r = 0; r < 3; ++r) t[n][r] = Math.max(Math.min(e[n][r], 1e8), -1e8);
                  return t;
                }(t.clipBounds);
              i = t.axes && t.axes.lastCubeProps ? t.axes.lastCubeProps.axis : [1, 1, 1], y[0] = 2 / a.drawingBufferWidth, y[1] = 2 / a.drawingBufferHeight, e.bind(), l.view = c, l.projection = h, l.screenSize = y, l.highlightId = t.highlightId, l.highlightScale = t.highlightScale, l.clipBounds = m, l.pickGroup = t.pickId / 255, l.pixelRatio = r;
              for (var g = 0; g < 3; ++g) if (o[g]) {
                l.scale = t.projectScale[g], l.opacity = t.projectOpacity[g];
                for (var v = S, k = 0; k < 16; ++k) v[k] = 0;
                for (k = 0; k < 4; ++k) v[5 * k] = 1;
                v[5 * g] = 0, i[g] < 0 ? v[12 + g] = p[0][g] : v[12 + g] = p[1][g], s(v, u, v), l.model = v;
                var P = (g + 1) % 3,
                  O = (g + 2) % 3,
                  R = T(b),
                  I = T(_);
                R[P] = 1, I[O] = 1;
                var j = f(0, 0, 0, M(x, R)),
                  N = f(0, 0, 0, M(w, I));
                if (Math.abs(j[1]) > Math.abs(N[1])) {
                  var L = j;
                  j = N, N = L, L = R, R = I, I = L;
                  var D = P;
                  P = O, O = D;
                }
                j[0] < 0 && (R[P] = -1), N[1] > 0 && (I[O] = -1);
                var B = 0,
                  F = 0;
                for (k = 0; k < 4; ++k) B += Math.pow(u[4 * P + k], 2), F += Math.pow(u[4 * O + k], 2);
                R[P] /= Math.sqrt(B), I[O] /= Math.sqrt(F), l.axes[0] = R, l.axes[1] = I, l.fragClipBounds[0] = C(A, m[0], g, -1e8), l.fragClipBounds[1] = C(A, m[1], g, 1e8), t.vao.bind(), t.vao.draw(a.TRIANGLES, t.vertexCount), t.lineWidth > 0 && (a.lineWidth(t.lineWidth * r), t.vao.draw(a.LINES, t.lineVertexCount, t.vertexCount)), t.vao.unbind();
              }
            }
            var P = [[-1e8, -1e8, -1e8], [1e8, 1e8, 1e8]];
            function O(e, t, n, r, i, o, a) {
              var s = n.gl;
              if ((o === n.projectHasAlpha || a) && k(t, n, r, i), o === n.hasAlpha || a) {
                e.bind();
                var l = e.uniforms;
                l.model = r.model || d, l.view = r.view || d, l.projection = r.projection || d, y[0] = 2 / s.drawingBufferWidth, y[1] = 2 / s.drawingBufferHeight, l.screenSize = y, l.highlightId = n.highlightId, l.highlightScale = n.highlightScale, l.fragClipBounds = P, l.clipBounds = n.axes.bounds, l.opacity = n.opacity, l.pickGroup = n.pickId / 255, l.pixelRatio = i, n.vao.bind(), n.vao.draw(s.TRIANGLES, n.vertexCount), n.lineWidth > 0 && (s.lineWidth(n.lineWidth * i), n.vao.draw(s.LINES, n.lineVertexCount, n.vertexCount)), n.vao.unbind();
              }
            }
            function R(e, t, n, i) {
              var o;
              o = Array.isArray(e) ? t < e.length ? e[t] : void 0 : e, o = c(o);
              var a = !0;
              r(o) && (o = "▼", a = !1);
              var s = u(o, n, i);
              return {
                mesh: s[0],
                lines: s[1],
                bounds: s[2],
                visible: a
              };
            }
            v.draw = function (e) {
              O(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, e, this.pixelRatio, !1, !1);
            }, v.drawTransparent = function (e) {
              O(this.useOrtho ? this.orthoShader : this.shader, this.projectShader, this, e, this.pixelRatio, !0, !1);
            }, v.drawPick = function (e) {
              O(this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader, this.pickProjectShader, this, e, 1, !0, !0);
            }, v.pick = function (e) {
              if (!e) return null;
              if (e.id !== this.pickId) return null;
              var t = e.value[2] + (e.value[1] << 8) + (e.value[0] << 16);
              if (t >= this.pointCount || t < 0) return null;
              var n = this.points[t],
                r = this._selectResult;
              r.index = t;
              for (var i = 0; i < 3; ++i) r.position[i] = r.dataCoordinate[i] = n[i];
              return r;
            }, v.highlight = function (e) {
              if (e) {
                var t = e.index,
                  n = 255 & t,
                  r = t >> 8 & 255,
                  i = t >> 16 & 255;
                this.highlightId = [n / 255, r / 255, i / 255, 0];
              } else this.highlightId = [1, 1, 1, 1];
            }, v.update = function (e) {
              if ("perspective" in (e = e || {}) && (this.useOrtho = !e.perspective), "orthographic" in e && (this.useOrtho = !!e.orthographic), "lineWidth" in e && (this.lineWidth = e.lineWidth), "project" in e) if (Array.isArray(e.project)) this.axesProject = e.project;else {
                var t = !!e.project;
                this.axesProject = [t, t, t];
              }
              if ("projectScale" in e) if (Array.isArray(e.projectScale)) this.projectScale = e.projectScale.slice();else {
                var n = +e.projectScale;
                this.projectScale = [n, n, n];
              }
              if (this.projectHasAlpha = !1, "projectOpacity" in e) {
                Array.isArray(e.projectOpacity) ? this.projectOpacity = e.projectOpacity.slice() : (n = +e.projectOpacity, this.projectOpacity = [n, n, n]);
                for (var r = 0; r < 3; ++r) this.projectOpacity[r] = m(this.projectOpacity[r]), this.projectOpacity[r] < 1 && (this.projectHasAlpha = !0);
              }
              this.hasAlpha = !1, "opacity" in e && (this.opacity = m(e.opacity), this.opacity < 1 && (this.hasAlpha = !0)), this.dirty = !0;
              var i,
                o,
                s = e.position,
                l = e.font || "normal",
                u = e.alignment || [0, 0];
              if (2 === u.length) i = u[0], o = u[1];else for (i = [], o = [], r = 0; r < u.length; ++r) i[r] = u[r][0], o[r] = u[r][1];
              var c = [1 / 0, 1 / 0, 1 / 0],
                d = [-1 / 0, -1 / 0, -1 / 0],
                h = e.glyph,
                f = e.color,
                p = e.size,
                g = e.angle,
                v = e.lineColor,
                y = -1,
                b = 0,
                _ = 0,
                x = 0;
              if (s.length) {
                x = s.length;
                e: for (r = 0; r < x; ++r) {
                  for (var w = s[r], S = 0; S < 3; ++S) if (isNaN(w[S]) || !isFinite(w[S])) continue e;
                  var A = (F = R(h, r, l, this.pixelRatio)).mesh,
                    E = F.lines,
                    T = F.bounds;
                  b += 3 * A.cells.length, _ += 2 * E.edges.length;
                }
              }
              var M = b + _,
                C = a.mallocFloat(3 * M),
                k = a.mallocFloat(4 * M),
                P = a.mallocFloat(2 * M),
                O = a.mallocUint32(M);
              if (M > 0) {
                var I = 0,
                  j = b,
                  N = [0, 0, 0, 1],
                  L = [0, 0, 0, 1],
                  D = Array.isArray(f) && Array.isArray(f[0]),
                  B = Array.isArray(v) && Array.isArray(v[0]);
                e: for (r = 0; r < x; ++r) {
                  for (y += 1, w = s[r], S = 0; S < 3; ++S) {
                    if (isNaN(w[S]) || !isFinite(w[S])) continue e;
                    d[S] = Math.max(d[S], w[S]), c[S] = Math.min(c[S], w[S]);
                  }
                  A = (F = R(h, r, l, this.pixelRatio)).mesh, E = F.lines, T = F.bounds;
                  var F,
                    z = F.visible;
                  if (z) {
                    if (Array.isArray(f)) {
                      if (3 === (U = D ? r < f.length ? f[r] : [0, 0, 0, 0] : f).length) {
                        for (S = 0; S < 3; ++S) N[S] = U[S];
                        N[3] = 1;
                      } else if (4 === U.length) {
                        for (S = 0; S < 4; ++S) N[S] = U[S];
                        !this.hasAlpha && U[3] < 1 && (this.hasAlpha = !0);
                      }
                    } else N[0] = N[1] = N[2] = 0, N[3] = 1;
                  } else N = [1, 1, 1, 0];
                  if (z) {
                    if (Array.isArray(v)) {
                      var U;
                      if (3 === (U = B ? r < v.length ? v[r] : [0, 0, 0, 0] : v).length) {
                        for (S = 0; S < 3; ++S) L[S] = U[S];
                        L[S] = 1;
                      } else if (4 === U.length) {
                        for (S = 0; S < 4; ++S) L[S] = U[S];
                        !this.hasAlpha && U[3] < 1 && (this.hasAlpha = !0);
                      }
                    } else L[0] = L[1] = L[2] = 0, L[3] = 1;
                  } else L = [1, 1, 1, 0];
                  var G = .5;
                  z ? Array.isArray(p) ? G = r < p.length ? +p[r] : 12 : p ? G = +p : this.useOrtho && (G = 12) : G = 0;
                  var V = 0;
                  Array.isArray(g) ? V = r < g.length ? +g[r] : 0 : g && (V = +g);
                  var H = Math.cos(V),
                    q = Math.sin(V);
                  for (w = s[r], S = 0; S < 3; ++S) d[S] = Math.max(d[S], w[S]), c[S] = Math.min(c[S], w[S]);
                  var W = i,
                    $ = o;
                  W = 0, Array.isArray(i) ? W = r < i.length ? i[r] : 0 : i && (W = i), $ = 0, Array.isArray(o) ? $ = r < o.length ? o[r] : 0 : o && ($ = o);
                  var X = [W *= W > 0 ? 1 - T[0][0] : W < 0 ? 1 + T[1][0] : 1, $ *= $ > 0 ? 1 - T[0][1] : $ < 0 ? 1 + T[1][1] : 1],
                    Y = A.cells || [],
                    K = A.positions || [];
                  for (S = 0; S < Y.length; ++S) for (var Z = Y[S], Q = 0; Q < 3; ++Q) {
                    for (var J = 0; J < 3; ++J) C[3 * I + J] = w[J];
                    for (J = 0; J < 4; ++J) k[4 * I + J] = N[J];
                    O[I] = y;
                    var ee = K[Z[Q]];
                    P[2 * I] = G * (H * ee[0] - q * ee[1] + X[0]), P[2 * I + 1] = G * (q * ee[0] + H * ee[1] + X[1]), I += 1;
                  }
                  for (Y = E.edges, K = E.positions, S = 0; S < Y.length; ++S) for (Z = Y[S], Q = 0; Q < 2; ++Q) {
                    for (J = 0; J < 3; ++J) C[3 * j + J] = w[J];
                    for (J = 0; J < 4; ++J) k[4 * j + J] = L[J];
                    O[j] = y, ee = K[Z[Q]], P[2 * j] = G * (H * ee[0] - q * ee[1] + X[0]), P[2 * j + 1] = G * (q * ee[0] + H * ee[1] + X[1]), j += 1;
                  }
                }
              }
              this.bounds = [c, d], this.points = s, this.pointCount = s.length, this.vertexCount = b, this.lineVertexCount = _, this.pointBuffer.update(C), this.colorBuffer.update(k), this.glyphBuffer.update(P), this.idBuffer.update(O), a.free(C), a.free(k), a.free(P), a.free(O);
            }, v.dispose = function () {
              this.shader.dispose(), this.orthoShader.dispose(), this.pickPerspectiveShader.dispose(), this.pickOrthoShader.dispose(), this.vao.dispose(), this.pointBuffer.dispose(), this.colorBuffer.dispose(), this.glyphBuffer.dispose(), this.idBuffer.dispose();
            };
          }, {
            "./lib/get-simple-string": 145,
            "./lib/glyphs": 146,
            "./lib/shaders": 147,
            "gl-buffer": 104,
            "gl-mat4/multiply": 127,
            "gl-vao": 168,
            "is-string-blank": 261,
            "typedarray-pool": 347
          }],
          149: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = t[0],
                o = t[1];
              return new u(e, r(e, n, o, {}), i.mallocUint8(n * o * 4));
            };
            var r = e("gl-fbo"),
              i = e("typedarray-pool"),
              o = e("ndarray"),
              a = e("bit-twiddle").nextPow2,
              s = e("cwise/lib/wrapper")({
                args: ["array", {
                  offset: [0, 0, 1],
                  array: 0
                }, {
                  offset: [0, 0, 2],
                  array: 0
                }, {
                  offset: [0, 0, 3],
                  array: 0
                }, "scalar", "scalar", "index"],
                pre: {
                  body: "{this_closestD2=1e8,this_closestX=-1,this_closestY=-1}",
                  args: [],
                  thisVars: ["this_closestD2", "this_closestX", "this_closestY"],
                  localVars: []
                },
                body: {
                  body: "{if(_inline_52_arg0_<255||_inline_52_arg1_<255||_inline_52_arg2_<255||_inline_52_arg3_<255){var _inline_52_l=_inline_52_arg4_-_inline_52_arg6_[0],_inline_52_a=_inline_52_arg5_-_inline_52_arg6_[1],_inline_52_f=_inline_52_l*_inline_52_l+_inline_52_a*_inline_52_a;_inline_52_f<this_closestD2&&(this_closestD2=_inline_52_f,this_closestX=_inline_52_arg6_[0],this_closestY=_inline_52_arg6_[1])}}",
                  args: [{
                    name: "_inline_52_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_52_arg1_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_52_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_52_arg3_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_52_arg4_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_52_arg5_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_52_arg6_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 4
                  }],
                  thisVars: ["this_closestD2", "this_closestX", "this_closestY"],
                  localVars: ["_inline_52_a", "_inline_52_f", "_inline_52_l"]
                },
                post: {
                  body: "{return[this_closestX,this_closestY,this_closestD2]}",
                  args: [],
                  thisVars: ["this_closestD2", "this_closestX", "this_closestY"],
                  localVars: []
                },
                debug: !1,
                funcName: "cwise",
                blockSize: 64
              });
            function l(e, t, n, r, i) {
              this.coord = [e, t], this.id = n, this.value = r, this.distance = i;
            }
            function u(e, t, n) {
              this.gl = e, this.fbo = t, this.buffer = n, this._readTimeout = null;
              var r = this;
              this._readCallback = function () {
                r.gl && (t.bind(), e.readPixels(0, 0, t.shape[0], t.shape[1], e.RGBA, e.UNSIGNED_BYTE, r.buffer), r._readTimeout = null);
              };
            }
            var c = u.prototype;
            Object.defineProperty(c, "shape", {
              get: function get() {
                return this.gl ? this.fbo.shape.slice() : [0, 0];
              },
              set: function set(e) {
                if (this.gl) {
                  this.fbo.shape = e;
                  var t = this.fbo.shape[0],
                    n = this.fbo.shape[1];
                  if (n * t * 4 > this.buffer.length) {
                    i.free(this.buffer);
                    for (var r = this.buffer = i.mallocUint8(a(n * t * 4)), o = 0; o < n * t * 4; ++o) r[o] = 255;
                  }
                  return e;
                }
              }
            }), c.begin = function () {
              var e = this.gl;
              this.shape, e && (this.fbo.bind(), e.clearColor(1, 1, 1, 1), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT));
            }, c.end = function () {
              var e = this.gl;
              e && (e.bindFramebuffer(e.FRAMEBUFFER, null), this._readTimeout || clearTimeout(this._readTimeout), this._readTimeout = setTimeout(this._readCallback, 1));
            }, c.query = function (e, t, n) {
              if (!this.gl) return null;
              var r = this.fbo.shape.slice();
              e |= 0, t |= 0, "number" != typeof n && (n = 1);
              var i = 0 | Math.min(Math.max(e - n, 0), r[0]),
                a = 0 | Math.min(Math.max(e + n, 0), r[0]),
                u = 0 | Math.min(Math.max(t - n, 0), r[1]),
                c = 0 | Math.min(Math.max(t + n, 0), r[1]);
              if (a <= i || c <= u) return null;
              var d = [a - i, c - u],
                h = o(this.buffer, [d[0], d[1], 4], [4, 4 * r[0], 1], 4 * (i + r[0] * u)),
                f = s(h.hi(d[0], d[1], 1), n, n),
                p = f[0],
                m = f[1];
              return p < 0 || Math.pow(this.radius, 2) < f[2] ? null : new l(p + i | 0, m + u | 0, h.get(p, m, 0), [h.get(p, m, 1), h.get(p, m, 2), h.get(p, m, 3)], Math.sqrt(f[2]));
            }, c.dispose = function () {
              this.gl && (this.fbo.dispose(), i.free(this.buffer), this.gl = null, this._readTimeout && clearTimeout(this._readTimeout));
            };
          }, {
            "bit-twiddle": 37,
            "cwise/lib/wrapper": 81,
            "gl-fbo": 112,
            ndarray: 285,
            "typedarray-pool": 347
          }],
          150: [function (e, t, n) {
            "use strict";

            var r = e("./lib/create-uniforms"),
              i = e("./lib/create-attributes"),
              o = e("./lib/reflect"),
              a = e("./lib/shader-cache"),
              s = e("./lib/runtime-reflect"),
              l = e("./lib/GLError");
            function u(e) {
              this.gl = e, this.gl.lastAttribCount = 0, this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
            }
            var c = u.prototype;
            function d(e, t) {
              return e.name < t.name ? -1 : 1;
            }
            c.bind = function () {
              var e;
              this.program || this._relink();
              var t = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES),
                n = this.gl.lastAttribCount;
              if (t > n) for (e = n; e < t; e++) this.gl.enableVertexAttribArray(e);else if (n > t) for (e = t; e < n; e++) this.gl.disableVertexAttribArray(e);
              this.gl.lastAttribCount = t, this.gl.useProgram(this.program);
            }, c.dispose = function () {
              for (var e = this.gl.lastAttribCount, t = 0; t < e; t++) this.gl.disableVertexAttribArray(t);
              this.gl.lastAttribCount = 0, this._fref && this._fref.dispose(), this._vref && this._vref.dispose(), this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
            }, c.update = function (e, t, n, u) {
              if (!t || 1 === arguments.length) {
                var c = e;
                e = c.vertex, t = c.fragment, n = c.uniforms, u = c.attributes;
              }
              var h = this,
                f = h.gl,
                p = h._vref;
              h._vref = a.shader(f, f.VERTEX_SHADER, e), p && p.dispose(), h.vertShader = h._vref.shader;
              var m = this._fref;
              if (h._fref = a.shader(f, f.FRAGMENT_SHADER, t), m && m.dispose(), h.fragShader = h._fref.shader, !n || !u) {
                var g = f.createProgram();
                if (f.attachShader(g, h.fragShader), f.attachShader(g, h.vertShader), f.linkProgram(g), !f.getProgramParameter(g, f.LINK_STATUS)) {
                  var v = f.getProgramInfoLog(g);
                  throw new l(v, "Error linking program:" + v);
                }
                n = n || s.uniforms(f, g), u = u || s.attributes(f, g), f.deleteProgram(g);
              }
              (u = u.slice()).sort(d);
              var y,
                b = [],
                _ = [],
                x = [];
              for (y = 0; y < u.length; ++y) {
                var w = u[y];
                if (w.type.indexOf("mat") >= 0) {
                  for (var S = 0 | w.type.charAt(w.type.length - 1), A = new Array(S), E = 0; E < S; ++E) A[E] = x.length, _.push(w.name + "[" + E + "]"), "number" == typeof w.location ? x.push(w.location + E) : Array.isArray(w.location) && w.location.length === S && "number" == typeof w.location[E] ? x.push(0 | w.location[E]) : x.push(-1);
                  b.push({
                    name: w.name,
                    type: w.type,
                    locations: A
                  });
                } else b.push({
                  name: w.name,
                  type: w.type,
                  locations: [x.length]
                }), _.push(w.name), "number" == typeof w.location ? x.push(0 | w.location) : x.push(-1);
              }
              var T = 0;
              for (y = 0; y < x.length; ++y) if (x[y] < 0) {
                for (; x.indexOf(T) >= 0;) T += 1;
                x[y] = T;
              }
              var M = new Array(n.length);
              function C() {
                h.program = a.program(f, h._vref, h._fref, _, x);
                for (var e = 0; e < n.length; ++e) M[e] = f.getUniformLocation(h.program, n[e].name);
              }
              C(), h._relink = C, h.types = {
                uniforms: o(n),
                attributes: o(u)
              }, h.attributes = i(f, h, b, x), Object.defineProperty(h, "uniforms", r(f, h, n, M));
            }, t.exports = function (e, t, n, r, i) {
              var o = new u(e);
              return o.update(t, n, r, i), o;
            };
          }, {
            "./lib/GLError": 151,
            "./lib/create-attributes": 152,
            "./lib/create-uniforms": 153,
            "./lib/reflect": 154,
            "./lib/runtime-reflect": 155,
            "./lib/shader-cache": 156
          }],
          151: [function (e, t, n) {
            function r(e, t, n) {
              this.shortMessage = t || "", this.longMessage = n || "", this.rawError = e || "", this.message = "gl-shader: " + (t || e || "") + (n ? "\n" + n : ""), this.stack = new Error().stack;
            }
            r.prototype = new Error(), r.prototype.name = "GLError", r.prototype.constructor = r, t.exports = r;
          }, {}],
          152: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, i) {
              for (var o = {}, l = 0, u = n.length; l < u; ++l) {
                var c = n[l],
                  d = c.name,
                  h = c.type,
                  f = c.locations;
                switch (h) {
                  case "bool":
                  case "int":
                  case "float":
                    a(e, t, f[0], i, 1, o, d);
                    break;
                  default:
                    if (h.indexOf("vec") >= 0) {
                      if ((p = h.charCodeAt(h.length - 1) - 48) < 2 || p > 4) throw new r("", "Invalid data type for attribute " + d + ": " + h);
                      a(e, t, f[0], i, p, o, d);
                    } else {
                      if (!(h.indexOf("mat") >= 0)) throw new r("", "Unknown data type for attribute " + d + ": " + h);
                      var p;
                      if ((p = h.charCodeAt(h.length - 1) - 48) < 2 || p > 4) throw new r("", "Invalid data type for attribute " + d + ": " + h);
                      s(e, t, f, i, p, o, d);
                    }
                }
              }
              return o;
            };
            var r = e("./GLError");
            function i(e, t, n, r, i, o) {
              this._gl = e, this._wrapper = t, this._index = n, this._locations = r, this._dimension = i, this._constFunc = o;
            }
            var o = i.prototype;
            function a(e, t, n, r, o, a, s) {
              for (var l = ["gl", "v"], u = [], c = 0; c < o; ++c) l.push("x" + c), u.push("x" + c);
              l.push("if(x0.length===void 0){return gl.vertexAttrib" + o + "f(v," + u.join() + ")}else{return gl.vertexAttrib" + o + "fv(v,x0)}");
              var d = Function.apply(null, l),
                h = new i(e, t, n, r, o, d);
              Object.defineProperty(a, s, {
                set: function set(t) {
                  return e.disableVertexAttribArray(r[n]), d(e, r[n], t), t;
                },
                get: function get() {
                  return h;
                },
                enumerable: !0
              });
            }
            function s(e, t, n, r, i, o, s) {
              for (var l = new Array(i), u = new Array(i), c = 0; c < i; ++c) a(e, t, n[c], r, i, l, c), u[c] = l[c];
              Object.defineProperty(l, "location", {
                set: function set(e) {
                  if (Array.isArray(e)) for (var t = 0; t < i; ++t) u[t].location = e[t];else for (t = 0; t < i; ++t) u[t].location = e + t;
                  return e;
                },
                get: function get() {
                  for (var e = new Array(i), t = 0; t < i; ++t) e[t] = r[n[t]];
                  return e;
                },
                enumerable: !0
              }), l.pointer = function (t, o, a, s) {
                t = t || e.FLOAT, o = !!o, a = a || i * i, s = s || 0;
                for (var l = 0; l < i; ++l) {
                  var u = r[n[l]];
                  e.vertexAttribPointer(u, i, t, o, a, s + l * i), e.enableVertexAttribArray(u);
                }
              };
              var d = new Array(i),
                h = e["vertexAttrib" + i + "fv"];
              Object.defineProperty(o, s, {
                set: function set(t) {
                  for (var o = 0; o < i; ++o) {
                    var a = r[n[o]];
                    if (e.disableVertexAttribArray(a), Array.isArray(t[0])) h.call(e, a, t[o]);else {
                      for (var s = 0; s < i; ++s) d[s] = t[i * o + s];
                      h.call(e, a, d);
                    }
                  }
                  return t;
                },
                get: function get() {
                  return l;
                },
                enumerable: !0
              });
            }
            o.pointer = function (e, t, n, r) {
              var i = this._gl,
                o = this._locations[this._index];
              i.vertexAttribPointer(o, this._dimension, e || i.FLOAT, !!t, n || 0, r || 0), i.enableVertexAttribArray(o);
            }, o.set = function (e, t, n, r) {
              return this._constFunc(this._locations[this._index], e, t, n, r);
            }, Object.defineProperty(o, "location", {
              get: function get() {
                return this._locations[this._index];
              },
              set: function set(e) {
                return e !== this._locations[this._index] && (this._locations[this._index] = 0 | e, this._wrapper.program = null), 0 | e;
              }
            });
          }, {
            "./GLError": 151
          }],
          153: [function (e, t, n) {
            "use strict";

            var r = e("./reflect"),
              i = e("./GLError");
            function o(e) {
              return new Function("y", "return function(){return y}")(e);
            }
            function a(e, t) {
              for (var n = new Array(e), r = 0; r < e; ++r) n[r] = t;
              return n;
            }
            t.exports = function (e, t, n, s) {
              function l(e, t, n) {
                switch (n) {
                  case "bool":
                  case "int":
                  case "sampler2D":
                  case "samplerCube":
                    return "gl.uniform1i(locations[" + t + "],obj" + e + ")";
                  case "float":
                    return "gl.uniform1f(locations[" + t + "],obj" + e + ")";
                  default:
                    var r = n.indexOf("vec");
                    if (!(0 <= r && r <= 1 && n.length === 4 + r)) {
                      if (0 === n.indexOf("mat") && 4 === n.length) {
                        var o;
                        if ((o = n.charCodeAt(n.length - 1) - 48) < 2 || o > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + n);
                        return "gl.uniformMatrix" + o + "fv(locations[" + t + "],false,obj" + e + ")";
                      }
                      throw new i("", "Unknown uniform data type for " + name + ": " + n);
                    }
                    if ((o = n.charCodeAt(n.length - 1) - 48) < 2 || o > 4) throw new i("", "Invalid data type");
                    switch (n.charAt(0)) {
                      case "b":
                      case "i":
                        return "gl.uniform" + o + "iv(locations[" + t + "],obj" + e + ")";
                      case "v":
                        return "gl.uniform" + o + "fv(locations[" + t + "],obj" + e + ")";
                      default:
                        throw new i("", "Unrecognized data type for vector " + name + ": " + n);
                    }
                }
              }
              function u(t) {
                for (var r = ["return function updateProperty(obj){"], i = function e(t, n) {
                    if ("object" != typeof n) return [[t, n]];
                    var r = [];
                    for (var i in n) {
                      var o = n[i],
                        a = t;
                      parseInt(i) + "" === i ? a += "[" + i + "]" : a += "." + i, "object" == typeof o ? r.push.apply(r, e(a, o)) : r.push([a, o]);
                    }
                    return r;
                  }("", t), o = 0; o < i.length; ++o) {
                  var a = i[o],
                    u = a[0],
                    c = a[1];
                  s[c] && r.push(l(u, c, n[c].type));
                }
                return r.push("return obj}"), new Function("gl", "locations", r.join("\n"))(e, s);
              }
              function c(r, l, c) {
                if ("object" == typeof c) {
                  var h = d(c);
                  Object.defineProperty(r, l, {
                    get: o(h),
                    set: u(c),
                    enumerable: !0,
                    configurable: !1
                  });
                } else s[c] ? Object.defineProperty(r, l, {
                  get: (f = c, p = new Function("gl", "wrapper", "locations", "return function(){return gl.getUniform(wrapper.program,locations[" + f + "])}"), p(e, t, s)),
                  set: u(c),
                  enumerable: !0,
                  configurable: !1
                }) : r[l] = function (e) {
                  switch (e) {
                    case "bool":
                      return !1;
                    case "int":
                    case "sampler2D":
                    case "samplerCube":
                    case "float":
                      return 0;
                    default:
                      var t = e.indexOf("vec");
                      if (0 <= t && t <= 1 && e.length === 4 + t) {
                        if ((n = e.charCodeAt(e.length - 1) - 48) < 2 || n > 4) throw new i("", "Invalid data type");
                        return "b" === e.charAt(0) ? a(n, !1) : a(n, 0);
                      }
                      if (0 === e.indexOf("mat") && 4 === e.length) {
                        var n;
                        if ((n = e.charCodeAt(e.length - 1) - 48) < 2 || n > 4) throw new i("", "Invalid uniform dimension type for matrix " + name + ": " + e);
                        return a(n * n, 0);
                      }
                      throw new i("", "Unknown uniform data type for " + name + ": " + e);
                  }
                }(n[c].type);
                var f, p;
              }
              function d(e) {
                var t;
                if (Array.isArray(e)) {
                  t = new Array(e.length);
                  for (var n = 0; n < e.length; ++n) c(t, n, e[n]);
                } else for (var r in t = {}, e) c(t, r, e[r]);
                return t;
              }
              var h = r(n, !0);
              return {
                get: o(d(h)),
                set: u(h),
                enumerable: !0,
                configurable: !0
              };
            };
          }, {
            "./GLError": 151,
            "./reflect": 154
          }],
          154: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              for (var n = {}, r = 0; r < e.length; ++r) for (var i = e[r].name.split("."), o = n, a = 0; a < i.length; ++a) {
                var s = i[a].split("[");
                if (s.length > 1) {
                  s[0] in o || (o[s[0]] = []), o = o[s[0]];
                  for (var l = 1; l < s.length; ++l) {
                    var u = parseInt(s[l]);
                    l < s.length - 1 || a < i.length - 1 ? (u in o || (l < s.length - 1 ? o[u] = [] : o[u] = {}), o = o[u]) : o[u] = t ? r : e[r].type;
                  }
                } else a < i.length - 1 ? (s[0] in o || (o[s[0]] = {}), o = o[s[0]]) : o[s[0]] = t ? r : e[r].type;
              }
              return n;
            };
          }, {}],
          155: [function (e, t, n) {
            "use strict";

            n.uniforms = function (e, t) {
              for (var n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS), r = [], i = 0; i < n; ++i) {
                var a = e.getActiveUniform(t, i);
                if (a) {
                  var s = o(e, a.type);
                  if (a.size > 1) for (var l = 0; l < a.size; ++l) r.push({
                    name: a.name.replace("[0]", "[" + l + "]"),
                    type: s
                  });else r.push({
                    name: a.name,
                    type: s
                  });
                }
              }
              return r;
            }, n.attributes = function (e, t) {
              for (var n = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES), r = [], i = 0; i < n; ++i) {
                var a = e.getActiveAttrib(t, i);
                a && r.push({
                  name: a.name,
                  type: o(e, a.type)
                });
              }
              return r;
            };
            var r = {
                FLOAT: "float",
                FLOAT_VEC2: "vec2",
                FLOAT_VEC3: "vec3",
                FLOAT_VEC4: "vec4",
                INT: "int",
                INT_VEC2: "ivec2",
                INT_VEC3: "ivec3",
                INT_VEC4: "ivec4",
                BOOL: "bool",
                BOOL_VEC2: "bvec2",
                BOOL_VEC3: "bvec3",
                BOOL_VEC4: "bvec4",
                FLOAT_MAT2: "mat2",
                FLOAT_MAT3: "mat3",
                FLOAT_MAT4: "mat4",
                SAMPLER_2D: "sampler2D",
                SAMPLER_CUBE: "samplerCube"
              },
              i = null;
            function o(e, t) {
              if (!i) {
                var n = Object.keys(r);
                i = {};
                for (var o = 0; o < n.length; ++o) {
                  var a = n[o];
                  i[e[a]] = r[a];
                }
              }
              return i[t];
            }
          }, {}],
          156: [function (e, t, n) {
            "use strict";

            n.shader = function (e, t, n) {
              return c(e).getShaderReference(t, n);
            }, n.program = function (e, t, n, r, i) {
              return c(e).getProgram(t, n, r, i);
            };
            var r = e("./GLError"),
              i = e("gl-format-compiler-error"),
              o = new ("undefined" == typeof WeakMap ? e("weakmap-shim") : WeakMap)(),
              a = 0;
            function s(e, t, n, r, i, o, a) {
              this.id = e, this.src = t, this.type = n, this.shader = r, this.count = o, this.programs = [], this.cache = a;
            }
            function l(e) {
              this.gl = e, this.shaders = [{}, {}], this.programs = {};
            }
            s.prototype.dispose = function () {
              if (0 == --this.count) {
                for (var e = this.cache, t = e.gl, n = this.programs, r = 0, i = n.length; r < i; ++r) {
                  var o = e.programs[n[r]];
                  o && (delete e.programs[r], t.deleteProgram(o));
                }
                t.deleteShader(this.shader), delete e.shaders[this.type === t.FRAGMENT_SHADER | 0][this.src];
              }
            };
            var u = l.prototype;
            function c(e) {
              var t = o.get(e);
              return t || (t = new l(e), o.set(e, t)), t;
            }
            u.getShaderReference = function (e, t) {
              var n = this.gl,
                o = this.shaders[e === n.FRAGMENT_SHADER | 0],
                l = o[t];
              if (l && n.isShader(l.shader)) l.count += 1;else {
                var u = function (e, t, n) {
                  var o = e.createShader(t);
                  if (e.shaderSource(o, n), e.compileShader(o), !e.getShaderParameter(o, e.COMPILE_STATUS)) {
                    var a = e.getShaderInfoLog(o);
                    try {
                      var s = i(a, n, t);
                    } catch (e) {
                      throw console.warn("Failed to format compiler error: " + e), new r(a, "Error compiling shader:\n" + a);
                    }
                    throw new r(a, s.short, s.long);
                  }
                  return o;
                }(n, e, t);
                l = o[t] = new s(a++, t, e, u, [], 1, this);
              }
              return l;
            }, u.getProgram = function (e, t, n, i) {
              var o = [e.id, t.id, n.join(":"), i.join(":")].join("@"),
                a = this.programs[o];
              return a && this.gl.isProgram(a) || (this.programs[o] = a = function (e, t, n, i, o) {
                var a = e.createProgram();
                e.attachShader(a, t), e.attachShader(a, n);
                for (var s = 0; s < i.length; ++s) e.bindAttribLocation(a, o[s], i[s]);
                if (e.linkProgram(a), !e.getProgramParameter(a, e.LINK_STATUS)) {
                  var l = e.getProgramInfoLog(a);
                  throw new r(l, "Error linking program: " + l);
                }
                return a;
              }(this.gl, e.shader, t.shader, n, i), e.programs.push(o), t.programs.push(o)), a;
            };
          }, {
            "./GLError": 151,
            "gl-format-compiler-error": 113,
            "weakmap-shim": 355
          }],
          157: [function (e, t, n) {
            "use strict";

            var r = e("glslify"),
              i = e("gl-shader"),
              o = r(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * view * model * vec4(vertexPosition, 1.0);\n  vec2 clipOffset = (projection * view * model * vec4(color, 0.0)).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"]),
              a = r(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"]);
            t.exports = function (e) {
              return i(e, o, a, null, [{
                name: "position",
                type: "vec3"
              }, {
                name: "color",
                type: "vec3"
              }, {
                name: "weight",
                type: "float"
              }]);
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          158: [function (e, t, n) {
            "use strict";

            var r = e("gl-buffer"),
              i = e("gl-vao"),
              o = e("./shaders/index");
            t.exports = function (e, t) {
              var n = [];
              function a(e, t, r, i, o, a) {
                var s = [e, t, r, 0, 0, 0, 1];
                s[i + 3] = 1, s[i] = o, n.push.apply(n, s), s[6] = -1, n.push.apply(n, s), s[i] = a, n.push.apply(n, s), n.push.apply(n, s), s[6] = 1, n.push.apply(n, s), s[i] = o, n.push.apply(n, s);
              }
              a(0, 0, 0, 0, 0, 1), a(0, 0, 0, 1, 0, 1), a(0, 0, 0, 2, 0, 1), a(1, 0, 0, 1, -1, 1), a(1, 0, 0, 2, -1, 1), a(0, 1, 0, 0, -1, 1), a(0, 1, 0, 2, -1, 1), a(0, 0, 1, 0, -1, 1), a(0, 0, 1, 1, -1, 1);
              var l = r(e, n),
                u = i(e, [{
                  type: e.FLOAT,
                  buffer: l,
                  size: 3,
                  offset: 0,
                  stride: 28
                }, {
                  type: e.FLOAT,
                  buffer: l,
                  size: 3,
                  offset: 12,
                  stride: 28
                }, {
                  type: e.FLOAT,
                  buffer: l,
                  size: 1,
                  offset: 24,
                  stride: 28
                }]),
                c = o(e);
              c.attributes.position.location = 0, c.attributes.color.location = 1, c.attributes.weight.location = 2;
              var d = new s(e, l, u, c);
              return d.update(t), d;
            };
            var a = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
            function s(e, t, n, r) {
              this.gl = e, this.buffer = t, this.vao = n, this.shader = r, this.pixelRatio = 1, this.bounds = [[-1e3, -1e3, -1e3], [1e3, 1e3, 1e3]], this.position = [0, 0, 0], this.lineWidth = [2, 2, 2], this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.enabled = [!0, !0, !0], this.drawSides = [!0, !0, !0], this.axes = null;
            }
            var l = s.prototype,
              u = [0, 0, 0],
              c = [0, 0, 0],
              d = [0, 0];
            l.isTransparent = function () {
              return !1;
            }, l.drawTransparent = function (e) {}, l.draw = function (e) {
              var t = this.gl,
                n = this.vao,
                r = this.shader;
              n.bind(), r.bind();
              var i,
                o = e.model || a,
                s = e.view || a,
                l = e.projection || a;
              this.axes && (i = this.axes.lastCubeProps.axis);
              for (var h = u, f = c, p = 0; p < 3; ++p) i && i[p] < 0 ? (h[p] = this.bounds[0][p], f[p] = this.bounds[1][p]) : (h[p] = this.bounds[1][p], f[p] = this.bounds[0][p]);
              for (d[0] = t.drawingBufferWidth, d[1] = t.drawingBufferHeight, r.uniforms.model = o, r.uniforms.view = s, r.uniforms.projection = l, r.uniforms.coordinates = [this.position, h, f], r.uniforms.colors = this.colors, r.uniforms.screenShape = d, p = 0; p < 3; ++p) r.uniforms.lineWidth = this.lineWidth[p] * this.pixelRatio, this.enabled[p] && (n.draw(t.TRIANGLES, 6, 6 * p), this.drawSides[p] && n.draw(t.TRIANGLES, 12, 18 + 12 * p));
              n.unbind();
            }, l.update = function (e) {
              e && ("bounds" in e && (this.bounds = e.bounds), "position" in e && (this.position = e.position), "lineWidth" in e && (this.lineWidth = e.lineWidth), "colors" in e && (this.colors = e.colors), "enabled" in e && (this.enabled = e.enabled), "drawSides" in e && (this.drawSides = e.drawSides));
            }, l.dispose = function () {
              this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
            };
          }, {
            "./shaders/index": 157,
            "gl-buffer": 104,
            "gl-vao": 168
          }],
          159: [function (e, t, n) {
            var r = e("glslify"),
              i = r(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"]),
              o = r(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"]),
              a = r(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * view * tubePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"]),
              s = r(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"]);
            n.meshShader = {
              vertex: i,
              fragment: o,
              attributes: [{
                name: "position",
                type: "vec4"
              }, {
                name: "color",
                type: "vec4"
              }, {
                name: "uv",
                type: "vec2"
              }, {
                name: "vector",
                type: "vec4"
              }]
            }, n.pickShader = {
              vertex: a,
              fragment: s,
              attributes: [{
                name: "position",
                type: "vec4"
              }, {
                name: "id",
                type: "vec4"
              }, {
                name: "vector",
                type: "vec4"
              }]
            };
          }, {
            glslify: 249
          }],
          160: [function (e, t, n) {
            "use strict";

            var r = e("gl-vec3"),
              i = e("gl-vec4"),
              o = ["xyz", "xzy", "yxz", "yzx", "zxy", "zyx"],
              a = function a(e, t, n, o) {
                for (var a = 0, s = 0; s < e.length; s++) for (var l = e[s].velocities, u = 0; u < l.length; u++) a = Math.max(a, r.length(l[u]));
                var c = e.map(function (e) {
                    return function (e, t, n, o) {
                      for (var a = e.points, s = e.velocities, l = e.divergences, u = [], c = [], d = [], h = [], f = [], p = [], m = 0, g = 0, v = i.create(), y = i.create(), b = 0; b < a.length; b++) {
                        var _ = a[b],
                          x = s[b],
                          w = l[b];
                        0 === t && (w = .05 * n), g = r.length(x) / o, v = i.create(), r.copy(v, x), v[3] = w;
                        for (var S = 0; S < 8; S++) f[S] = [_[0], _[1], _[2], S];
                        if (h.length > 0) for (S = 0; S < 8; S++) {
                          var A = (S + 1) % 8;
                          u.push(h[S], f[S], f[A], f[A], h[A], h[S]), d.push(y, v, v, v, y, y), p.push(m, g, g, g, m, m);
                          var E = u.length;
                          c.push([E - 6, E - 5, E - 4], [E - 3, E - 2, E - 1]);
                        }
                        var T = h;
                        h = f, f = T;
                        var M = y;
                        y = v, v = M;
                        var C = m;
                        m = g, g = C;
                      }
                      return {
                        positions: u,
                        cells: c,
                        vectors: d,
                        vertexIntensity: p
                      };
                    }(e, n, o, a);
                  }),
                  d = [],
                  h = [],
                  f = [],
                  p = [];
                for (s = 0; s < c.length; s++) {
                  var m = c[s],
                    g = d.length;
                  for (d = d.concat(m.positions), f = f.concat(m.vectors), p = p.concat(m.vertexIntensity), u = 0; u < m.cells.length; u++) {
                    var v = m.cells[u],
                      y = [];
                    h.push(y);
                    for (var b = 0; b < v.length; b++) y.push(v[b] + g);
                  }
                }
                return {
                  positions: d,
                  cells: h,
                  vectors: f,
                  vertexIntensity: p,
                  colormap: t
                };
              },
              s = function s(e, t) {
                var n,
                  r = e.length;
                for (n = 0; n < r; n++) {
                  var i = e[n];
                  if (i === t) return n;
                  if (i > t) return n - 1;
                }
                return n;
              },
              l = function l(e, t, n) {
                return e < t ? t : e > n ? n : e;
              },
              u = function u(e) {
                var t = 1 / 0;
                e.sort(function (e, t) {
                  return e - t;
                });
                for (var n = e.length, r = 1; r < n; r++) {
                  var i = Math.abs(e[r] - e[r - 1]);
                  i < t && (t = i);
                }
                return t;
              };
            t.exports = function (e, t) {
              var n = e.startingPositions,
                i = e.maxLength || 1e3,
                c = e.tubeSize || 1,
                d = e.absoluteTubeSize,
                h = e.gridFill || "+x+y+z",
                f = {};
              -1 !== h.indexOf("-x") && (f.reversedX = !0), -1 !== h.indexOf("-y") && (f.reversedY = !0), -1 !== h.indexOf("-z") && (f.reversedZ = !0), f.filled = o.indexOf(h.replace(/-/g, "").replace(/\+/g, ""));
              var p = e.getVelocity || function (t) {
                  return function (e, t, n) {
                    var i = t.vectors,
                      o = t.meshgrid,
                      a = e[0],
                      u = e[1],
                      c = e[2],
                      d = o[0].length,
                      h = o[1].length,
                      f = o[2].length,
                      p = s(o[0], a),
                      m = s(o[1], u),
                      g = s(o[2], c),
                      v = p + 1,
                      y = m + 1,
                      b = g + 1;
                    if (p = l(p, 0, d - 1), v = l(v, 0, d - 1), m = l(m, 0, h - 1), y = l(y, 0, h - 1), g = l(g, 0, f - 1), b = l(b, 0, f - 1), p < 0 || m < 0 || g < 0 || v > d - 1 || y > h - 1 || b > f - 1) return r.create();
                    var _,
                      x,
                      w,
                      S,
                      A,
                      E,
                      T = o[0][p],
                      M = o[0][v],
                      C = o[1][m],
                      k = o[1][y],
                      P = o[2][g],
                      O = (a - T) / (M - T),
                      R = (u - C) / (k - C),
                      I = (c - P) / (o[2][b] - P);
                    switch (isFinite(O) || (O = .5), isFinite(R) || (R = .5), isFinite(I) || (I = .5), n.reversedX && (p = d - 1 - p, v = d - 1 - v), n.reversedY && (m = h - 1 - m, y = h - 1 - y), n.reversedZ && (g = f - 1 - g, b = f - 1 - b), n.filled) {
                      case 5:
                        A = g, E = b, w = m * f, S = y * f, _ = p * f * h, x = v * f * h;
                        break;
                      case 4:
                        A = g, E = b, _ = p * f, x = v * f, w = m * f * d, S = y * f * d;
                        break;
                      case 3:
                        w = m, S = y, A = g * h, E = b * h, _ = p * h * f, x = v * h * f;
                        break;
                      case 2:
                        w = m, S = y, _ = p * h, x = v * h, A = g * h * d, E = b * h * d;
                        break;
                      case 1:
                        _ = p, x = v, A = g * d, E = b * d, w = m * d * f, S = y * d * f;
                        break;
                      default:
                        _ = p, x = v, w = m * d, S = y * d, A = g * d * h, E = b * d * h;
                    }
                    var j = i[_ + w + A],
                      N = i[_ + w + E],
                      L = i[_ + S + A],
                      D = i[_ + S + E],
                      B = i[x + w + A],
                      F = i[x + w + E],
                      z = i[x + S + A],
                      U = i[x + S + E],
                      G = r.create(),
                      V = r.create(),
                      H = r.create(),
                      q = r.create();
                    r.lerp(G, j, B, O), r.lerp(V, N, F, O), r.lerp(H, L, z, O), r.lerp(q, D, U, O);
                    var W = r.create(),
                      $ = r.create();
                    r.lerp(W, G, H, R), r.lerp($, V, q, R);
                    var X = r.create();
                    return r.lerp(X, W, $, I), X;
                  }(t, e, f);
                },
                m = e.getDivergence || function (e, t) {
                  var n = r.create(),
                    i = 1e-4;
                  r.add(n, e, [i, 0, 0]);
                  var o = p(n);
                  r.subtract(o, o, t), r.scale(o, o, 1e4), r.add(n, e, [0, i, 0]);
                  var a = p(n);
                  r.subtract(a, a, t), r.scale(a, a, 1e4), r.add(n, e, [0, 0, i]);
                  var s = p(n);
                  return r.subtract(s, s, t), r.scale(s, s, 1e4), r.add(n, o, a), r.add(n, n, s), n;
                },
                g = [],
                v = t[0][0],
                y = t[0][1],
                b = t[0][2],
                _ = t[1][0],
                x = t[1][1],
                w = t[1][2],
                S = function S(e) {
                  var t = e[0],
                    n = e[1],
                    r = e[2];
                  return !(t < v || t > _ || n < y || n > x || r < b || r > w);
                },
                A = 10 * r.distance(t[0], t[1]) / i,
                E = A * A,
                T = 1,
                M = 0,
                C = n.length;
              C > 1 && (T = function (e) {
                for (var t = [], n = [], r = [], i = {}, o = {}, a = {}, s = e.length, l = 0; l < s; l++) {
                  var c = e[l],
                    d = c[0],
                    h = c[1],
                    f = c[2];
                  i[d] || (t.push(d), i[d] = !0), o[h] || (n.push(h), o[h] = !0), a[f] || (r.push(f), a[f] = !0);
                }
                var p = u(t),
                  m = u(n),
                  g = u(r),
                  v = Math.min(p, m, g);
                return isFinite(v) ? v : 1;
              }(n));
              for (var k = 0; k < C; k++) {
                var P = r.create();
                r.copy(P, n[k]);
                var O = [P],
                  R = [],
                  I = p(P),
                  j = P;
                R.push(I);
                var N = [],
                  L = m(P, I),
                  D = r.length(L);
                isFinite(D) && D > M && (M = D), N.push(D), g.push({
                  points: O,
                  velocities: R,
                  divergences: N
                });
                for (var B = 0; B < 100 * i && O.length < i && S(P);) {
                  B++;
                  var F = r.clone(I),
                    z = r.squaredLength(F);
                  if (0 === z) break;
                  z > E && r.scale(F, F, A / Math.sqrt(z)), r.add(F, F, P), I = p(F), r.squaredDistance(j, F) - E > -1e-4 * E && (O.push(F), j = F, R.push(I), L = m(F, I), D = r.length(L), isFinite(D) && D > M && (M = D), N.push(D)), P = F;
                }
              }
              var U = a(g, e.colormap, M, T);
              return d ? U.tubeScale = d : (0 === M && (M = 1), U.tubeScale = .5 * c * T / M), U;
            };
            var c = e("./lib/shaders"),
              d = e("gl-cone3d").createMesh;
            t.exports.createTubeMesh = function (e, t) {
              return d(e, t, {
                shaders: c,
                traceType: "streamtube"
              });
            };
          }, {
            "./lib/shaders": 159,
            "gl-cone3d": 105,
            "gl-vec3": 187,
            "gl-vec4": 223
          }],
          161: [function (e, t, n) {
            var r = e("gl-shader"),
              i = e("glslify"),
              o = i(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n  vec4 clipPosition = projection * view * worldPosition;\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"]),
              a = i(["precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color — in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"]),
              s = i(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n\n  vec4 clipPosition = projection * view * worldPosition;\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"]),
              l = i(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"]);
            n.createShader = function (e) {
              var t = r(e, o, a, null, [{
                name: "uv",
                type: "vec4"
              }, {
                name: "f",
                type: "vec3"
              }, {
                name: "normal",
                type: "vec3"
              }]);
              return t.attributes.uv.location = 0, t.attributes.f.location = 1, t.attributes.normal.location = 2, t;
            }, n.createPickShader = function (e) {
              var t = r(e, o, l, null, [{
                name: "uv",
                type: "vec4"
              }, {
                name: "f",
                type: "vec3"
              }, {
                name: "normal",
                type: "vec3"
              }]);
              return t.attributes.uv.location = 0, t.attributes.f.location = 1, t.attributes.normal.location = 2, t;
            }, n.createContourShader = function (e) {
              var t = r(e, s, a, null, [{
                name: "uv",
                type: "vec4"
              }, {
                name: "f",
                type: "float"
              }]);
              return t.attributes.uv.location = 0, t.attributes.f.location = 1, t;
            }, n.createPickContourShader = function (e) {
              var t = r(e, s, l, null, [{
                name: "uv",
                type: "vec4"
              }, {
                name: "f",
                type: "float"
              }]);
              return t.attributes.uv.location = 0, t.attributes.f.location = 1, t;
            };
          }, {
            "gl-shader": 150,
            glslify: 249
          }],
          162: [function (e, t, n) {
            arguments[4][55][0].apply(n, arguments);
          }, {
            dup: 55
          }],
          163: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.gl,
                n = y(t),
                r = _(t),
                s = b(t),
                l = x(t),
                u = i(t),
                c = o(t, [{
                  buffer: u,
                  size: 4,
                  stride: w,
                  offset: 0
                }, {
                  buffer: u,
                  size: 3,
                  stride: w,
                  offset: 16
                }, {
                  buffer: u,
                  size: 3,
                  stride: w,
                  offset: 28
                }]),
                d = i(t),
                h = o(t, [{
                  buffer: d,
                  size: 4,
                  stride: 20,
                  offset: 0
                }, {
                  buffer: d,
                  size: 1,
                  stride: 20,
                  offset: 16
                }]),
                f = i(t),
                p = o(t, [{
                  buffer: f,
                  size: 2,
                  type: t.FLOAT
                }]),
                m = a(t, 1, M, t.RGBA, t.UNSIGNED_BYTE);
              m.minFilter = t.LINEAR, m.magFilter = t.LINEAR;
              var g = new C(t, [0, 0], [[0, 0, 0], [0, 0, 0]], n, r, u, c, m, s, l, d, h, f, p, [0, 0, 0]),
                v = {
                  levels: [[], [], []]
                };
              for (var S in e) v[S] = e[S];
              return v.colormap = v.colormap || "jet", g.update(v), g;
            };
            var r = e("bit-twiddle"),
              i = e("gl-buffer"),
              o = e("gl-vao"),
              a = e("gl-texture2d"),
              s = e("typedarray-pool"),
              l = e("colormap"),
              u = e("ndarray-ops"),
              c = e("ndarray-pack"),
              d = e("ndarray"),
              h = e("surface-nets"),
              f = e("gl-mat4/multiply"),
              p = e("gl-mat4/invert"),
              m = e("binary-search-bounds"),
              g = e("ndarray-gradient"),
              v = e("./lib/shaders"),
              y = v.createShader,
              b = v.createContourShader,
              _ = v.createPickShader,
              x = v.createPickContourShader,
              w = 40,
              S = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
              A = [[0, 0], [0, 1], [1, 0], [1, 1], [1, 0], [0, 1]],
              E = [[0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0]];
            function T(e, t, n, r, i) {
              this.position = e, this.index = t, this.uv = n, this.level = r, this.dataCoordinate = i;
            }
            !function () {
              for (var e = 0; e < 3; ++e) {
                var t = E[e],
                  n = (e + 2) % 3;
                t[(e + 1) % 3 + 0] = 1, t[n + 3] = 1, t[e + 6] = 1;
              }
            }();
            var M = 256;
            function C(e, t, n, r, i, o, a, l, u, c, h, f, p, m, g) {
              this.gl = e, this.shape = t, this.bounds = n, this.objectOffset = g, this.intensityBounds = [], this._shader = r, this._pickShader = i, this._coordinateBuffer = o, this._vao = a, this._colorMap = l, this._contourShader = u, this._contourPickShader = c, this._contourBuffer = h, this._contourVAO = f, this._contourOffsets = [[], [], []], this._contourCounts = [[], [], []], this._vertexCount = 0, this._pickResult = new T([0, 0, 0], [0, 0], [0, 0], [0, 0, 0], [0, 0, 0]), this._dynamicBuffer = p, this._dynamicVAO = m, this._dynamicOffsets = [0, 0, 0], this._dynamicCounts = [0, 0, 0], this.contourWidth = [1, 1, 1], this.contourLevels = [[1], [1], [1]], this.contourTint = [0, 0, 0], this.contourColor = [[.5, .5, .5, 1], [.5, .5, .5, 1], [.5, .5, .5, 1]], this.showContour = !0, this.showSurface = !0, this.enableHighlight = [!0, !0, !0], this.highlightColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.highlightTint = [1, 1, 1], this.highlightLevel = [-1, -1, -1], this.enableDynamic = [!0, !0, !0], this.dynamicLevel = [NaN, NaN, NaN], this.dynamicColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.dynamicTint = [1, 1, 1], this.dynamicWidth = [1, 1, 1], this.axesBounds = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]], this.surfaceProject = [!1, !1, !1], this.contourProject = [[!1, !1, !1], [!1, !1, !1], [!1, !1, !1]], this.colorBounds = [!1, !1], this._field = [d(s.mallocFloat(1024), [0, 0]), d(s.mallocFloat(1024), [0, 0]), d(s.mallocFloat(1024), [0, 0])], this.pickId = 1, this.clipBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.snapToData = !1, this.pixelRatio = 1, this.opacity = 1, this.lightPosition = [10, 1e4, 0], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.vertexColor = 0, this.dirty = !0;
            }
            var k = C.prototype;
            k.isTransparent = function () {
              return this.opacity < 1;
            }, k.isOpaque = function () {
              if (this.opacity >= 1) return !0;
              for (var e = 0; e < 3; ++e) if (this._contourCounts[e].length > 0 || this._dynamicCounts[e] > 0) return !0;
              return !1;
            }, k.pickSlots = 1, k.setPickBase = function (e) {
              this.pickId = e;
            };
            var P = [0, 0, 0],
              O = {
                showSurface: !1,
                showContour: !1,
                projections: [S.slice(), S.slice(), S.slice()],
                clipBounds: [[[0, 0, 0], [0, 0, 0]], [[0, 0, 0], [0, 0, 0]], [[0, 0, 0], [0, 0, 0]]]
              };
            function R(e, t) {
              var n,
                r,
                i,
                o = t.axes && t.axes.lastCubeProps.axis || P,
                a = t.showSurface,
                s = t.showContour;
              for (n = 0; n < 3; ++n) for (a = a || t.surfaceProject[n], r = 0; r < 3; ++r) s = s || t.contourProject[n][r];
              for (n = 0; n < 3; ++n) {
                var l = O.projections[n];
                for (r = 0; r < 16; ++r) l[r] = 0;
                for (r = 0; r < 4; ++r) l[5 * r] = 1;
                l[5 * n] = 0, l[12 + n] = t.axesBounds[+(o[n] > 0)][n], f(l, e.model, l);
                var u = O.clipBounds[n];
                for (i = 0; i < 2; ++i) for (r = 0; r < 3; ++r) u[i][r] = e.clipBounds[i][r];
                u[0][n] = -1e8, u[1][n] = 1e8;
              }
              return O.showSurface = a, O.showContour = s, O;
            }
            var I = {
                model: S,
                view: S,
                projection: S,
                inverseModel: S.slice(),
                lowerBound: [0, 0, 0],
                upperBound: [0, 0, 0],
                colorMap: 0,
                clipBounds: [[0, 0, 0], [0, 0, 0]],
                height: 0,
                contourTint: 0,
                contourColor: [0, 0, 0, 1],
                permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
                zOffset: -1e-4,
                objectOffset: [0, 0, 0],
                kambient: 1,
                kdiffuse: 1,
                kspecular: 1,
                lightPosition: [1e3, 1e3, 1e3],
                eyePosition: [0, 0, 0],
                roughness: 1,
                fresnel: 1,
                opacity: 1,
                vertexColor: 0
              },
              j = S.slice(),
              N = [1, 0, 0, 0, 1, 0, 0, 0, 1];
            function L(e, t) {
              e = e || {};
              var n = this.gl;
              n.disable(n.CULL_FACE), this._colorMap.bind(0);
              var r = I;
              r.model = e.model || S, r.view = e.view || S, r.projection = e.projection || S, r.lowerBound = [this.bounds[0][0], this.bounds[0][1], this.colorBounds[0] || this.bounds[0][2]], r.upperBound = [this.bounds[1][0], this.bounds[1][1], this.colorBounds[1] || this.bounds[1][2]], r.objectOffset = this.objectOffset, r.contourColor = this.contourColor[0], r.inverseModel = p(r.inverseModel, r.model);
              for (var i = 0; i < 2; ++i) for (var o = r.clipBounds[i], a = 0; a < 3; ++a) o[a] = Math.min(Math.max(this.clipBounds[i][a], -1e8), 1e8);
              r.kambient = this.ambientLight, r.kdiffuse = this.diffuseLight, r.kspecular = this.specularLight, r.roughness = this.roughness, r.fresnel = this.fresnel, r.opacity = this.opacity, r.height = 0, r.permutation = N, r.vertexColor = this.vertexColor;
              var s = j;
              for (f(s, r.view, r.model), f(s, r.projection, s), p(s, s), i = 0; i < 3; ++i) r.eyePosition[i] = s[12 + i] / s[15];
              var l = s[15];
              for (i = 0; i < 3; ++i) l += this.lightPosition[i] * s[4 * i + 3];
              for (i = 0; i < 3; ++i) {
                var u = s[12 + i];
                for (a = 0; a < 3; ++a) u += s[4 * a + i] * this.lightPosition[a];
                r.lightPosition[i] = u / l;
              }
              var c = R(r, this);
              if (c.showSurface && t === this.opacity < 1) {
                for (this._shader.bind(), this._shader.uniforms = r, this._vao.bind(), this.showSurface && this._vertexCount && this._vao.draw(n.TRIANGLES, this._vertexCount), i = 0; i < 3; ++i) this.surfaceProject[i] && this.vertexCount && (this._shader.uniforms.model = c.projections[i], this._shader.uniforms.clipBounds = c.clipBounds[i], this._vao.draw(n.TRIANGLES, this._vertexCount));
                this._vao.unbind();
              }
              if (c.showContour && !t) {
                var d = this._contourShader;
                r.kambient = 1, r.kdiffuse = 0, r.kspecular = 0, r.opacity = 1, d.bind(), d.uniforms = r;
                var h = this._contourVAO;
                for (h.bind(), i = 0; i < 3; ++i) for (d.uniforms.permutation = E[i], n.lineWidth(this.contourWidth[i] * this.pixelRatio), a = 0; a < this.contourLevels[i].length; ++a) a === this.highlightLevel[i] ? (d.uniforms.contourColor = this.highlightColor[i], d.uniforms.contourTint = this.highlightTint[i]) : 0 !== a && a - 1 !== this.highlightLevel[i] || (d.uniforms.contourColor = this.contourColor[i], d.uniforms.contourTint = this.contourTint[i]), this._contourCounts[i][a] && (d.uniforms.height = this.contourLevels[i][a], h.draw(n.LINES, this._contourCounts[i][a], this._contourOffsets[i][a]));
                for (i = 0; i < 3; ++i) for (d.uniforms.model = c.projections[i], d.uniforms.clipBounds = c.clipBounds[i], a = 0; a < 3; ++a) if (this.contourProject[i][a]) {
                  d.uniforms.permutation = E[a], n.lineWidth(this.contourWidth[a] * this.pixelRatio);
                  for (var m = 0; m < this.contourLevels[a].length; ++m) m === this.highlightLevel[a] ? (d.uniforms.contourColor = this.highlightColor[a], d.uniforms.contourTint = this.highlightTint[a]) : 0 !== m && m - 1 !== this.highlightLevel[a] || (d.uniforms.contourColor = this.contourColor[a], d.uniforms.contourTint = this.contourTint[a]), this._contourCounts[a][m] && (d.uniforms.height = this.contourLevels[a][m], h.draw(n.LINES, this._contourCounts[a][m], this._contourOffsets[a][m]));
                }
                for (h.unbind(), (h = this._dynamicVAO).bind(), i = 0; i < 3; ++i) if (0 !== this._dynamicCounts[i]) for (d.uniforms.model = r.model, d.uniforms.clipBounds = r.clipBounds, d.uniforms.permutation = E[i], n.lineWidth(this.dynamicWidth[i] * this.pixelRatio), d.uniforms.contourColor = this.dynamicColor[i], d.uniforms.contourTint = this.dynamicTint[i], d.uniforms.height = this.dynamicLevel[i], h.draw(n.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]), a = 0; a < 3; ++a) this.contourProject[a][i] && (d.uniforms.model = c.projections[a], d.uniforms.clipBounds = c.clipBounds[a], h.draw(n.LINES, this._dynamicCounts[i], this._dynamicOffsets[i]));
                h.unbind();
              }
            }
            k.draw = function (e) {
              return L.call(this, e, !1);
            }, k.drawTransparent = function (e) {
              return L.call(this, e, !0);
            };
            var D = {
              model: S,
              view: S,
              projection: S,
              inverseModel: S,
              clipBounds: [[0, 0, 0], [0, 0, 0]],
              height: 0,
              shape: [0, 0],
              pickId: 0,
              lowerBound: [0, 0, 0],
              upperBound: [0, 0, 0],
              zOffset: 0,
              objectOffset: [0, 0, 0],
              permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
              lightPosition: [0, 0, 0],
              eyePosition: [0, 0, 0]
            };
            function B(e, t) {
              return Array.isArray(e) ? [t(e[0]), t(e[1]), t(e[2])] : [t(e), t(e), t(e)];
            }
            function F(e) {
              return Array.isArray(e) ? 3 === e.length ? [e[0], e[1], e[2], 1] : [e[0], e[1], e[2], e[3]] : [0, 0, 0, 1];
            }
            function z(e) {
              if (Array.isArray(e)) {
                if (Array.isArray(e)) return [F(e[0]), F(e[1]), F(e[2])];
                var t = F(e);
                return [t.slice(), t.slice(), t.slice()];
              }
            }
            k.drawPick = function (e) {
              e = e || {};
              var t = this.gl;
              t.disable(t.CULL_FACE);
              var n = D;
              n.model = e.model || S, n.view = e.view || S, n.projection = e.projection || S, n.shape = this._field[2].shape, n.pickId = this.pickId / 255, n.lowerBound = this.bounds[0], n.upperBound = this.bounds[1], n.objectOffset = this.objectOffset, n.permutation = N;
              for (var r = 0; r < 2; ++r) for (var i = n.clipBounds[r], o = 0; o < 3; ++o) i[o] = Math.min(Math.max(this.clipBounds[r][o], -1e8), 1e8);
              var a = R(n, this);
              if (a.showSurface) {
                for (this._pickShader.bind(), this._pickShader.uniforms = n, this._vao.bind(), this._vao.draw(t.TRIANGLES, this._vertexCount), r = 0; r < 3; ++r) this.surfaceProject[r] && (this._pickShader.uniforms.model = a.projections[r], this._pickShader.uniforms.clipBounds = a.clipBounds[r], this._vao.draw(t.TRIANGLES, this._vertexCount));
                this._vao.unbind();
              }
              if (a.showContour) {
                var s = this._contourPickShader;
                s.bind(), s.uniforms = n;
                var l = this._contourVAO;
                for (l.bind(), o = 0; o < 3; ++o) for (t.lineWidth(this.contourWidth[o] * this.pixelRatio), s.uniforms.permutation = E[o], r = 0; r < this.contourLevels[o].length; ++r) this._contourCounts[o][r] && (s.uniforms.height = this.contourLevels[o][r], l.draw(t.LINES, this._contourCounts[o][r], this._contourOffsets[o][r]));
                for (r = 0; r < 3; ++r) for (s.uniforms.model = a.projections[r], s.uniforms.clipBounds = a.clipBounds[r], o = 0; o < 3; ++o) if (this.contourProject[r][o]) {
                  s.uniforms.permutation = E[o], t.lineWidth(this.contourWidth[o] * this.pixelRatio);
                  for (var u = 0; u < this.contourLevels[o].length; ++u) this._contourCounts[o][u] && (s.uniforms.height = this.contourLevels[o][u], l.draw(t.LINES, this._contourCounts[o][u], this._contourOffsets[o][u]));
                }
                l.unbind();
              }
            }, k.pick = function (e) {
              if (!e) return null;
              if (e.id !== this.pickId) return null;
              var t = this._field[2].shape,
                n = this._pickResult,
                r = t[0] * (e.value[0] + (e.value[2] >> 4) / 16) / 255,
                i = Math.floor(r),
                o = r - i,
                a = t[1] * (e.value[1] + (15 & e.value[2]) / 16) / 255,
                s = Math.floor(a),
                l = a - s;
              i += 1, s += 1;
              var u = n.position;
              u[0] = u[1] = u[2] = 0;
              for (var c = 0; c < 2; ++c) for (var d = c ? o : 1 - o, h = 0; h < 2; ++h) for (var f = i + c, p = s + h, g = d * (h ? l : 1 - l), v = 0; v < 3; ++v) u[v] += this._field[v].get(f, p) * g;
              for (var y = this._pickResult.level, b = 0; b < 3; ++b) if (y[b] = m.le(this.contourLevels[b], u[b]), y[b] < 0) this.contourLevels[b].length > 0 && (y[b] = 0);else if (y[b] < this.contourLevels[b].length - 1) {
                var _ = this.contourLevels[b][y[b]],
                  x = this.contourLevels[b][y[b] + 1];
                Math.abs(_ - u[b]) > Math.abs(x - u[b]) && (y[b] += 1);
              }
              for (n.index[0] = o < .5 ? i : i + 1, n.index[1] = l < .5 ? s : s + 1, n.uv[0] = r / t[0], n.uv[1] = a / t[1], v = 0; v < 3; ++v) n.dataCoordinate[v] = this._field[v].get(n.index[0], n.index[1]);
              return n;
            }, k.padField = function (e, t) {
              var n = t.shape.slice(),
                r = e.shape.slice();
              u.assign(e.lo(1, 1).hi(n[0], n[1]), t), u.assign(e.lo(1).hi(n[0], 1), t.hi(n[0], 1)), u.assign(e.lo(1, r[1] - 1).hi(n[0], 1), t.lo(0, n[1] - 1).hi(n[0], 1)), u.assign(e.lo(0, 1).hi(1, n[1]), t.hi(1)), u.assign(e.lo(r[0] - 1, 1).hi(1, n[1]), t.lo(n[0] - 1)), e.set(0, 0, t.get(0, 0)), e.set(0, r[1] - 1, t.get(0, n[1] - 1)), e.set(r[0] - 1, 0, t.get(n[0] - 1, 0)), e.set(r[0] - 1, r[1] - 1, t.get(n[0] - 1, n[1] - 1));
            }, k.update = function (e) {
              e = e || {}, this.objectOffset = e.objectOffset || this.objectOffset, this.dirty = !0, "contourWidth" in e && (this.contourWidth = B(e.contourWidth, Number)), "showContour" in e && (this.showContour = B(e.showContour, Boolean)), "showSurface" in e && (this.showSurface = !!e.showSurface), "contourTint" in e && (this.contourTint = B(e.contourTint, Boolean)), "contourColor" in e && (this.contourColor = z(e.contourColor)), "contourProject" in e && (this.contourProject = B(e.contourProject, function (e) {
                return B(e, Boolean);
              })), "surfaceProject" in e && (this.surfaceProject = e.surfaceProject), "dynamicColor" in e && (this.dynamicColor = z(e.dynamicColor)), "dynamicTint" in e && (this.dynamicTint = B(e.dynamicTint, Number)), "dynamicWidth" in e && (this.dynamicWidth = B(e.dynamicWidth, Number)), "opacity" in e && (this.opacity = e.opacity), "colorBounds" in e && (this.colorBounds = e.colorBounds), "vertexColor" in e && (this.vertexColor = e.vertexColor ? 1 : 0);
              var t = e.field || e.coords && e.coords[2] || null,
                n = !1;
              if (t || (t = this._field[2].shape[0] || this._field[2].shape[2] ? this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2) : this._field[2].hi(0, 0)), "field" in e || "coords" in e) {
                var i = (t.shape[0] + 2) * (t.shape[1] + 2);
                i > this._field[2].data.length && (s.freeFloat(this._field[2].data), this._field[2].data = s.mallocFloat(r.nextPow2(i))), this._field[2] = d(this._field[2].data, [t.shape[0] + 2, t.shape[1] + 2]), this.padField(this._field[2], t), this.shape = t.shape.slice();
                for (var o = this.shape, a = 0; a < 2; ++a) this._field[2].size > this._field[a].data.length && (s.freeFloat(this._field[a].data), this._field[a].data = s.mallocFloat(this._field[2].size)), this._field[a] = d(this._field[a].data, [o[0] + 2, o[1] + 2]);
                if (e.coords) {
                  var f = e.coords;
                  if (!Array.isArray(f) || 3 !== f.length) throw new Error("gl-surface: invalid coordinates for x/y");
                  for (a = 0; a < 2; ++a) {
                    var p = f[a];
                    for (_ = 0; _ < 2; ++_) if (p.shape[_] !== o[_]) throw new Error("gl-surface: coords have incorrect shape");
                    this.padField(this._field[a], p);
                  }
                } else if (e.ticks) {
                  var m = e.ticks;
                  if (!Array.isArray(m) || 2 !== m.length) throw new Error("gl-surface: invalid ticks");
                  for (a = 0; a < 2; ++a) {
                    var v = m[a];
                    if ((Array.isArray(v) || v.length) && (v = d(v)), v.shape[0] !== o[a]) throw new Error("gl-surface: invalid tick length");
                    var y = d(v.data, o);
                    y.stride[a] = v.stride[0], y.stride[1 ^ a] = 0, this.padField(this._field[a], y);
                  }
                } else {
                  for (a = 0; a < 2; ++a) {
                    var b = [0, 0];
                    b[a] = 1, this._field[a] = d(this._field[a].data, [o[0] + 2, o[1] + 2], b, 0);
                  }
                  this._field[0].set(0, 0, 0);
                  for (var _ = 0; _ < o[0]; ++_) this._field[0].set(_ + 1, 0, _);
                  for (this._field[0].set(o[0] + 1, 0, o[0] - 1), this._field[1].set(0, 0, 0), _ = 0; _ < o[1]; ++_) this._field[1].set(0, _ + 1, _);
                  this._field[1].set(0, o[1] + 1, o[1] - 1);
                }
                var x = this._field,
                  w = d(s.mallocFloat(3 * x[2].size * 2), [3, o[0] + 2, o[1] + 2, 2]);
                for (a = 0; a < 3; ++a) g(w.pick(a), x[a], "mirror");
                var S = d(s.mallocFloat(3 * x[2].size), [o[0] + 2, o[1] + 2, 3]);
                for (a = 0; a < o[0] + 2; ++a) for (_ = 0; _ < o[1] + 2; ++_) {
                  var E = w.get(0, a, _, 0),
                    T = w.get(0, a, _, 1),
                    C = w.get(1, a, _, 0),
                    k = w.get(1, a, _, 1),
                    P = w.get(2, a, _, 0),
                    O = w.get(2, a, _, 1),
                    R = C * O - k * P,
                    I = P * T - O * E,
                    j = E * k - T * C,
                    N = Math.sqrt(R * R + I * I + j * j);
                  N < 1e-8 ? (N = Math.max(Math.abs(R), Math.abs(I), Math.abs(j))) < 1e-8 ? (j = 1, I = R = 0, N = 1) : N = 1 / N : N = 1 / Math.sqrt(N), S.set(a, _, 0, R * N), S.set(a, _, 1, I * N), S.set(a, _, 2, j * N);
                }
                s.free(w.data);
                var L = [1 / 0, 1 / 0, 1 / 0],
                  D = [-1 / 0, -1 / 0, -1 / 0],
                  F = 1 / 0,
                  U = -1 / 0,
                  G = (o[0] - 1) * (o[1] - 1) * 6,
                  V = s.mallocFloat(r.nextPow2(10 * G)),
                  H = 0,
                  q = 0;
                for (a = 0; a < o[0] - 1; ++a) e: for (_ = 0; _ < o[1] - 1; ++_) {
                  for (var W = 0; W < 2; ++W) for (var $ = 0; $ < 2; ++$) for (var X = 0; X < 3; ++X) {
                    var Y = this._field[X].get(1 + a + W, 1 + _ + $);
                    if (isNaN(Y) || !isFinite(Y)) continue e;
                  }
                  for (X = 0; X < 6; ++X) {
                    var K = a + A[X][0],
                      Z = _ + A[X][1],
                      Q = this._field[0].get(K + 1, Z + 1),
                      J = this._field[1].get(K + 1, Z + 1);
                    Y = this._field[2].get(K + 1, Z + 1), R = S.get(K + 1, Z + 1, 0), I = S.get(K + 1, Z + 1, 1), j = S.get(K + 1, Z + 1, 2), e.intensity && (ee = e.intensity.get(K, Z));
                    var ee = e.intensity ? e.intensity.get(K, Z) : Y + this.objectOffset[2];
                    V[H++] = K, V[H++] = Z, V[H++] = Q, V[H++] = J, V[H++] = Y, V[H++] = 0, V[H++] = ee, V[H++] = R, V[H++] = I, V[H++] = j, L[0] = Math.min(L[0], Q + this.objectOffset[0]), L[1] = Math.min(L[1], J + this.objectOffset[1]), L[2] = Math.min(L[2], Y + this.objectOffset[2]), F = Math.min(F, ee), D[0] = Math.max(D[0], Q + this.objectOffset[0]), D[1] = Math.max(D[1], J + this.objectOffset[1]), D[2] = Math.max(D[2], Y + this.objectOffset[2]), U = Math.max(U, ee), q += 1;
                  }
                }
                for (e.intensityBounds && (F = +e.intensityBounds[0], U = +e.intensityBounds[1]), a = 6; a < H; a += 10) V[a] = (V[a] - F) / (U - F);
                this._vertexCount = q, this._coordinateBuffer.update(V.subarray(0, H)), s.freeFloat(V), s.free(S.data), this.bounds = [L, D], this.intensity = e.intensity || this._field[2], this.intensityBounds[0] === F && this.intensityBounds[1] === U || (n = !0), this.intensityBounds = [F, U];
              }
              if ("levels" in e) {
                var te = e.levels;
                for (te = Array.isArray(te[0]) ? te.slice() : [[], [], te], a = 0; a < 3; ++a) te[a] = te[a].slice(), te[a].sort(function (e, t) {
                  return e - t;
                });
                for (a = 0; a < 3; ++a) for (_ = 0; _ < te[a].length; ++_) te[a][_] -= this.objectOffset[a];
                e: for (a = 0; a < 3; ++a) {
                  if (te[a].length !== this.contourLevels[a].length) {
                    n = !0;
                    break;
                  }
                  for (_ = 0; _ < te[a].length; ++_) if (te[a][_] !== this.contourLevels[a][_]) {
                    n = !0;
                    break e;
                  }
                }
                this.contourLevels = te;
              }
              if (n) {
                x = this._field, o = this.shape;
                for (var ne = [], re = 0; re < 3; ++re) {
                  var ie = this.contourLevels[re],
                    oe = [],
                    ae = [],
                    se = [0, 0, 0];
                  for (a = 0; a < ie.length; ++a) {
                    var le = h(this._field[re], ie[a]);
                    oe.push(ne.length / 5 | 0), q = 0;
                    e: for (_ = 0; _ < le.cells.length; ++_) {
                      var ue = le.cells[_];
                      for (X = 0; X < 2; ++X) {
                        var ce = le.positions[ue[X]],
                          de = ce[0],
                          he = 0 | Math.floor(de),
                          fe = de - he,
                          pe = ce[1],
                          me = 0 | Math.floor(pe),
                          ge = pe - me,
                          ve = !1;
                        t: for (var ye = 0; ye < 3; ++ye) {
                          se[ye] = 0;
                          var be = (re + ye + 1) % 3;
                          for (W = 0; W < 2; ++W) {
                            var _e = W ? fe : 1 - fe;
                            for (K = 0 | Math.min(Math.max(he + W, 0), o[0]), $ = 0; $ < 2; ++$) {
                              var xe = $ ? ge : 1 - ge;
                              if (Z = 0 | Math.min(Math.max(me + $, 0), o[1]), Y = ye < 2 ? this._field[be].get(K, Z) : (this.intensity.get(K, Z) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0]), !isFinite(Y) || isNaN(Y)) {
                                ve = !0;
                                break t;
                              }
                              var we = _e * xe;
                              se[ye] += we * Y;
                            }
                          }
                        }
                        if (ve) {
                          if (X > 0) {
                            for (var Se = 0; Se < 5; ++Se) ne.pop();
                            q -= 1;
                          }
                          continue e;
                        }
                        ne.push(se[0], se[1], ce[0], ce[1], se[2]), q += 1;
                      }
                    }
                    ae.push(q);
                  }
                  this._contourOffsets[re] = oe, this._contourCounts[re] = ae;
                }
                var Ae = s.mallocFloat(ne.length);
                for (a = 0; a < ne.length; ++a) Ae[a] = ne[a];
                this._contourBuffer.update(Ae), s.freeFloat(Ae);
              }
              e.colormap && this._colorMap.setPixels(function (e) {
                var t = c([l({
                  colormap: e,
                  nshades: M,
                  format: "rgba"
                }).map(function (e) {
                  return [e[0], e[1], e[2], 255 * e[3]];
                })]);
                return u.divseq(t, 255), t;
              }(e.colormap));
            }, k.dispose = function () {
              this._shader.dispose(), this._vao.dispose(), this._coordinateBuffer.dispose(), this._colorMap.dispose(), this._contourBuffer.dispose(), this._contourVAO.dispose(), this._contourShader.dispose(), this._contourPickShader.dispose(), this._dynamicBuffer.dispose(), this._dynamicVAO.dispose();
              for (var e = 0; e < 3; ++e) s.freeFloat(this._field[e].data);
            }, k.highlight = function (e) {
              var t, n;
              if (!e) return this._dynamicCounts = [0, 0, 0], this.dyanamicLevel = [NaN, NaN, NaN], void (this.highlightLevel = [-1, -1, -1]);
              for (t = 0; t < 3; ++t) this.enableHighlight[t] ? this.highlightLevel[t] = e.level[t] : this.highlightLevel[t] = -1;
              for (n = this.snapToData ? e.dataCoordinate : e.position, t = 0; t < 3; ++t) n[t] -= this.objectOffset[t];
              if (this.enableDynamic[0] && n[0] !== this.dynamicLevel[0] || this.enableDynamic[1] && n[1] !== this.dynamicLevel[1] || this.enableDynamic[2] && n[2] !== this.dynamicLevel[2]) {
                for (var r = 0, i = this.shape, o = s.mallocFloat(12 * i[0] * i[1]), a = 0; a < 3; ++a) if (this.enableDynamic[a]) {
                  this.dynamicLevel[a] = n[a];
                  var l = (a + 1) % 3,
                    u = (a + 2) % 3,
                    c = this._field[a],
                    d = this._field[l],
                    f = this._field[u],
                    p = h(c, n[a]),
                    m = p.cells,
                    g = p.positions;
                  for (this._dynamicOffsets[a] = r, t = 0; t < m.length; ++t) for (var v = m[t], y = 0; y < 2; ++y) {
                    var b = g[v[y]],
                      _ = +b[0],
                      x = 0 | _,
                      w = 0 | Math.min(x + 1, i[0]),
                      S = _ - x,
                      A = 1 - S,
                      E = +b[1],
                      T = 0 | E,
                      M = 0 | Math.min(T + 1, i[1]),
                      C = E - T,
                      k = 1 - C,
                      P = A * k,
                      O = A * C,
                      R = S * k,
                      I = S * C,
                      j = P * d.get(x, T) + O * d.get(x, M) + R * d.get(w, T) + I * d.get(w, M),
                      N = P * f.get(x, T) + O * f.get(x, M) + R * f.get(w, T) + I * f.get(w, M);
                    if (isNaN(j) || isNaN(N)) {
                      y && (r -= 1);
                      break;
                    }
                    o[2 * r + 0] = j, o[2 * r + 1] = N, r += 1;
                  }
                  this._dynamicCounts[a] = r - this._dynamicOffsets[a];
                } else this.dynamicLevel[a] = NaN, this._dynamicCounts[a] = 0;
                this._dynamicBuffer.update(o.subarray(0, 2 * r)), s.freeFloat(o);
              }
            };
          }, {
            "./lib/shaders": 161,
            "binary-search-bounds": 162,
            "bit-twiddle": 37,
            colormap: 69,
            "gl-buffer": 104,
            "gl-mat4/invert": 125,
            "gl-mat4/multiply": 127,
            "gl-texture2d": 164,
            "gl-vao": 168,
            ndarray: 285,
            "ndarray-gradient": 276,
            "ndarray-ops": 279,
            "ndarray-pack": 280,
            "surface-nets": 340,
            "typedarray-pool": 347
          }],
          164: [function (e, t, n) {
            "use strict";

            var r = e("ndarray"),
              i = e("ndarray-ops"),
              o = e("typedarray-pool");
            t.exports = function (e) {
              if (arguments.length <= 1) throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
              if (a || function (e) {
                a = [e.LINEAR, e.NEAREST_MIPMAP_LINEAR, e.LINEAR_MIPMAP_NEAREST, e.LINEAR_MIPMAP_NEAREST], s = [e.NEAREST, e.LINEAR, e.NEAREST_MIPMAP_NEAREST, e.NEAREST_MIPMAP_LINEAR, e.LINEAR_MIPMAP_NEAREST, e.LINEAR_MIPMAP_LINEAR], l = [e.REPEAT, e.CLAMP_TO_EDGE, e.MIRRORED_REPEAT];
              }(e), "number" == typeof arguments[1]) return g(e, arguments[1], arguments[2], arguments[3] || e.RGBA, arguments[4] || e.UNSIGNED_BYTE);
              if (Array.isArray(arguments[1])) return g(e, 0 | arguments[1][0], 0 | arguments[1][1], arguments[2] || e.RGBA, arguments[3] || e.UNSIGNED_BYTE);
              if ("object" == typeof arguments[1]) {
                var t = arguments[1],
                  n = u(t) ? t : t.raw;
                if (n) return function (e, t, n, r, i, o) {
                  var a = m(e);
                  return e.texImage2D(e.TEXTURE_2D, 0, i, i, o, t), new h(e, a, n, r, i, o);
                }(e, n, 0 | t.width, 0 | t.height, arguments[2] || e.RGBA, arguments[3] || e.UNSIGNED_BYTE);
                if (t.shape && t.data && t.stride) return function (e, t) {
                  var n = t.dtype,
                    a = t.shape.slice(),
                    s = e.getParameter(e.MAX_TEXTURE_SIZE);
                  if (a[0] < 0 || a[0] > s || a[1] < 0 || a[1] > s) throw new Error("gl-texture2d: Invalid texture size");
                  var l = p(a, t.stride.slice()),
                    u = 0;
                  "float32" === n ? u = e.FLOAT : "float64" === n ? (u = e.FLOAT, l = !1, n = "float32") : "uint8" === n ? u = e.UNSIGNED_BYTE : (u = e.UNSIGNED_BYTE, l = !1, n = "uint8");
                  var d,
                    f,
                    g = 0;
                  if (2 === a.length) g = e.LUMINANCE, a = [a[0], a[1], 1], t = r(t.data, a, [t.stride[0], t.stride[1], 1], t.offset);else {
                    if (3 !== a.length) throw new Error("gl-texture2d: Invalid shape for texture");
                    if (1 === a[2]) g = e.ALPHA;else if (2 === a[2]) g = e.LUMINANCE_ALPHA;else if (3 === a[2]) g = e.RGB;else {
                      if (4 !== a[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                      g = e.RGBA;
                    }
                  }
                  u !== e.FLOAT || e.getExtension("OES_texture_float") || (u = e.UNSIGNED_BYTE, l = !1);
                  var v = t.size;
                  if (l) d = 0 === t.offset && t.data.length === v ? t.data : t.data.subarray(t.offset, t.offset + v);else {
                    var y = [a[2], a[2] * a[0], 1];
                    f = o.malloc(v, n);
                    var b = r(f, a, y, 0);
                    "float32" !== n && "float64" !== n || u !== e.UNSIGNED_BYTE ? i.assign(b, t) : c(b, t), d = f.subarray(0, v);
                  }
                  var _ = m(e);
                  return e.texImage2D(e.TEXTURE_2D, 0, g, a[0], a[1], 0, g, u, d), l || o.free(f), new h(e, _, a[0], a[1], g, u);
                }(e, t);
              }
              throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
            };
            var a = null,
              s = null,
              l = null;
            function u(e) {
              return "undefined" != typeof HTMLCanvasElement && e instanceof HTMLCanvasElement || "undefined" != typeof HTMLImageElement && e instanceof HTMLImageElement || "undefined" != typeof HTMLVideoElement && e instanceof HTMLVideoElement || "undefined" != typeof ImageData && e instanceof ImageData;
            }
            var c = function c(e, t) {
              i.muls(e, t, 255);
            };
            function d(e, t, n) {
              var r = e.gl,
                i = r.getParameter(r.MAX_TEXTURE_SIZE);
              if (t < 0 || t > i || n < 0 || n > i) throw new Error("gl-texture2d: Invalid texture size");
              return e._shape = [t, n], e.bind(), r.texImage2D(r.TEXTURE_2D, 0, e.format, t, n, 0, e.format, e.type, null), e._mipLevels = [0], e;
            }
            function h(e, t, n, r, i, o) {
              this.gl = e, this.handle = t, this.format = i, this.type = o, this._shape = [n, r], this._mipLevels = [0], this._magFilter = e.NEAREST, this._minFilter = e.NEAREST, this._wrapS = e.CLAMP_TO_EDGE, this._wrapT = e.CLAMP_TO_EDGE, this._anisoSamples = 1;
              var a = this,
                s = [this._wrapS, this._wrapT];
              Object.defineProperties(s, [{
                get: function get() {
                  return a._wrapS;
                },
                set: function set(e) {
                  return a.wrapS = e;
                }
              }, {
                get: function get() {
                  return a._wrapT;
                },
                set: function set(e) {
                  return a.wrapT = e;
                }
              }]), this._wrapVector = s;
              var l = [this._shape[0], this._shape[1]];
              Object.defineProperties(l, [{
                get: function get() {
                  return a._shape[0];
                },
                set: function set(e) {
                  return a.width = e;
                }
              }, {
                get: function get() {
                  return a._shape[1];
                },
                set: function set(e) {
                  return a.height = e;
                }
              }]), this._shapeVector = l;
            }
            var f = h.prototype;
            function p(e, t) {
              return 3 === e.length ? 1 === t[2] && t[1] === e[0] * e[2] && t[0] === e[2] : 1 === t[0] && t[1] === e[0];
            }
            function m(e) {
              var t = e.createTexture();
              return e.bindTexture(e.TEXTURE_2D, t), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), t;
            }
            function g(e, t, n, r, i) {
              var o = e.getParameter(e.MAX_TEXTURE_SIZE);
              if (t < 0 || t > o || n < 0 || n > o) throw new Error("gl-texture2d: Invalid texture shape");
              if (i === e.FLOAT && !e.getExtension("OES_texture_float")) throw new Error("gl-texture2d: Floating point textures not supported on this platform");
              var a = m(e);
              return e.texImage2D(e.TEXTURE_2D, 0, r, t, n, 0, r, i, null), new h(e, a, t, n, r, i);
            }
            Object.defineProperties(f, {
              minFilter: {
                get: function get() {
                  return this._minFilter;
                },
                set: function set(e) {
                  this.bind();
                  var t = this.gl;
                  if (this.type === t.FLOAT && a.indexOf(e) >= 0 && (t.getExtension("OES_texture_float_linear") || (e = t.NEAREST)), s.indexOf(e) < 0) throw new Error("gl-texture2d: Unknown filter mode " + e);
                  return t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, e), this._minFilter = e;
                }
              },
              magFilter: {
                get: function get() {
                  return this._magFilter;
                },
                set: function set(e) {
                  this.bind();
                  var t = this.gl;
                  if (this.type === t.FLOAT && a.indexOf(e) >= 0 && (t.getExtension("OES_texture_float_linear") || (e = t.NEAREST)), s.indexOf(e) < 0) throw new Error("gl-texture2d: Unknown filter mode " + e);
                  return t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, e), this._magFilter = e;
                }
              },
              mipSamples: {
                get: function get() {
                  return this._anisoSamples;
                },
                set: function set(e) {
                  var t = this._anisoSamples;
                  if (this._anisoSamples = 0 | Math.max(e, 1), t !== this._anisoSamples) {
                    var n = this.gl.getExtension("EXT_texture_filter_anisotropic");
                    n && this.gl.texParameterf(this.gl.TEXTURE_2D, n.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
                  }
                  return this._anisoSamples;
                }
              },
              wrapS: {
                get: function get() {
                  return this._wrapS;
                },
                set: function set(e) {
                  if (this.bind(), l.indexOf(e) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + e);
                  return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, e), this._wrapS = e;
                }
              },
              wrapT: {
                get: function get() {
                  return this._wrapT;
                },
                set: function set(e) {
                  if (this.bind(), l.indexOf(e) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + e);
                  return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, e), this._wrapT = e;
                }
              },
              wrap: {
                get: function get() {
                  return this._wrapVector;
                },
                set: function set(e) {
                  if (Array.isArray(e) || (e = [e, e]), 2 !== e.length) throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");
                  for (var t = 0; t < 2; ++t) if (l.indexOf(e[t]) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + e);
                  this._wrapS = e[0], this._wrapT = e[1];
                  var n = this.gl;
                  return this.bind(), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, this._wrapS), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, this._wrapT), e;
                }
              },
              shape: {
                get: function get() {
                  return this._shapeVector;
                },
                set: function set(e) {
                  if (Array.isArray(e)) {
                    if (2 !== e.length) throw new Error("gl-texture2d: Invalid texture shape");
                  } else e = [0 | e, 0 | e];
                  return d(this, 0 | e[0], 0 | e[1]), [0 | e[0], 0 | e[1]];
                }
              },
              width: {
                get: function get() {
                  return this._shape[0];
                },
                set: function set(e) {
                  return d(this, e |= 0, this._shape[1]), e;
                }
              },
              height: {
                get: function get() {
                  return this._shape[1];
                },
                set: function set(e) {
                  return e |= 0, d(this, this._shape[0], e), e;
                }
              }
            }), f.bind = function (e) {
              var t = this.gl;
              return void 0 !== e && t.activeTexture(t.TEXTURE0 + (0 | e)), t.bindTexture(t.TEXTURE_2D, this.handle), void 0 !== e ? 0 | e : t.getParameter(t.ACTIVE_TEXTURE) - t.TEXTURE0;
            }, f.dispose = function () {
              this.gl.deleteTexture(this.handle);
            }, f.generateMipmap = function () {
              this.bind(), this.gl.generateMipmap(this.gl.TEXTURE_2D);
              for (var e = Math.min(this._shape[0], this._shape[1]), t = 0; e > 0; ++t, e >>>= 1) this._mipLevels.indexOf(t) < 0 && this._mipLevels.push(t);
            }, f.setPixels = function (e, t, n, a) {
              var s = this.gl;
              this.bind(), Array.isArray(t) ? (a = n, n = 0 | t[1], t = 0 | t[0]) : (t = t || 0, n = n || 0), a = a || 0;
              var l = u(e) ? e : e.raw;
              if (l) this._mipLevels.indexOf(a) < 0 ? (s.texImage2D(s.TEXTURE_2D, 0, this.format, this.format, this.type, l), this._mipLevels.push(a)) : s.texSubImage2D(s.TEXTURE_2D, a, t, n, this.format, this.type, l);else {
                if (!(e.shape && e.stride && e.data)) throw new Error("gl-texture2d: Unsupported data type");
                if (e.shape.length < 2 || t + e.shape[1] > this._shape[1] >>> a || n + e.shape[0] > this._shape[0] >>> a || t < 0 || n < 0) throw new Error("gl-texture2d: Texture dimensions are out of bounds");
                !function (e, t, n, a, s, l, u, d) {
                  var h = d.dtype,
                    f = d.shape.slice();
                  if (f.length < 2 || f.length > 3) throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
                  var m = 0,
                    g = 0,
                    v = p(f, d.stride.slice());
                  if ("float32" === h ? m = e.FLOAT : "float64" === h ? (m = e.FLOAT, v = !1, h = "float32") : "uint8" === h ? m = e.UNSIGNED_BYTE : (m = e.UNSIGNED_BYTE, v = !1, h = "uint8"), 2 === f.length) g = e.LUMINANCE, f = [f[0], f[1], 1], d = r(d.data, f, [d.stride[0], d.stride[1], 1], d.offset);else {
                    if (3 !== f.length) throw new Error("gl-texture2d: Invalid shape for texture");
                    if (1 === f[2]) g = e.ALPHA;else if (2 === f[2]) g = e.LUMINANCE_ALPHA;else if (3 === f[2]) g = e.RGB;else {
                      if (4 !== f[2]) throw new Error("gl-texture2d: Invalid shape for pixel coords");
                      g = e.RGBA;
                    }
                    f[2];
                  }
                  if (g !== e.LUMINANCE && g !== e.ALPHA || s !== e.LUMINANCE && s !== e.ALPHA || (g = s), g !== s) throw new Error("gl-texture2d: Incompatible texture format for setPixels");
                  var y = d.size,
                    b = u.indexOf(a) < 0;
                  if (b && u.push(a), m === l && v) 0 === d.offset && d.data.length === y ? b ? e.texImage2D(e.TEXTURE_2D, a, s, f[0], f[1], 0, s, l, d.data) : e.texSubImage2D(e.TEXTURE_2D, a, t, n, f[0], f[1], s, l, d.data) : b ? e.texImage2D(e.TEXTURE_2D, a, s, f[0], f[1], 0, s, l, d.data.subarray(d.offset, d.offset + y)) : e.texSubImage2D(e.TEXTURE_2D, a, t, n, f[0], f[1], s, l, d.data.subarray(d.offset, d.offset + y));else {
                    var _;
                    _ = l === e.FLOAT ? o.mallocFloat32(y) : o.mallocUint8(y);
                    var x = r(_, f, [f[2], f[2] * f[0], 1]);
                    m === e.FLOAT && l === e.UNSIGNED_BYTE ? c(x, d) : i.assign(x, d), b ? e.texImage2D(e.TEXTURE_2D, a, s, f[0], f[1], 0, s, l, _.subarray(0, y)) : e.texSubImage2D(e.TEXTURE_2D, a, t, n, f[0], f[1], s, l, _.subarray(0, y)), l === e.FLOAT ? o.freeFloat32(_) : o.freeUint8(_);
                  }
                }(s, t, n, a, this.format, this.type, this._mipLevels, e);
              }
            };
          }, {
            ndarray: 285,
            "ndarray-ops": 279,
            "typedarray-pool": 347
          }],
          165: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              t ? t.bind() : e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, null);
              var r = 0 | e.getParameter(e.MAX_VERTEX_ATTRIBS);
              if (n) {
                if (n.length > r) throw new Error("gl-vao: Too many vertex attributes");
                for (var i = 0; i < n.length; ++i) {
                  var o = n[i];
                  if (o.buffer) {
                    var a = o.buffer,
                      s = o.size || 4,
                      l = o.type || e.FLOAT,
                      u = !!o.normalized,
                      c = o.stride || 0,
                      d = o.offset || 0;
                    a.bind(), e.enableVertexAttribArray(i), e.vertexAttribPointer(i, s, l, u, c, d);
                  } else {
                    if ("number" == typeof o) e.vertexAttrib1f(i, o);else if (1 === o.length) e.vertexAttrib1f(i, o[0]);else if (2 === o.length) e.vertexAttrib2f(i, o[0], o[1]);else if (3 === o.length) e.vertexAttrib3f(i, o[0], o[1], o[2]);else {
                      if (4 !== o.length) throw new Error("gl-vao: Invalid vertex attribute");
                      e.vertexAttrib4f(i, o[0], o[1], o[2], o[3]);
                    }
                    e.disableVertexAttribArray(i);
                  }
                }
                for (; i < r; ++i) e.disableVertexAttribArray(i);
              } else for (e.bindBuffer(e.ARRAY_BUFFER, null), i = 0; i < r; ++i) e.disableVertexAttribArray(i);
            };
          }, {}],
          166: [function (e, t, n) {
            "use strict";

            var r = e("./do-bind.js");
            function i(e) {
              this.gl = e, this._elements = null, this._attributes = null, this._elementsType = e.UNSIGNED_SHORT;
            }
            i.prototype.bind = function () {
              r(this.gl, this._elements, this._attributes);
            }, i.prototype.update = function (e, t, n) {
              this._elements = t, this._attributes = e, this._elementsType = n || this.gl.UNSIGNED_SHORT;
            }, i.prototype.dispose = function () {}, i.prototype.unbind = function () {}, i.prototype.draw = function (e, t, n) {
              n = n || 0;
              var r = this.gl;
              this._elements ? r.drawElements(e, t, this._elementsType, n) : r.drawArrays(e, n, t);
            }, t.exports = function (e) {
              return new i(e);
            };
          }, {
            "./do-bind.js": 165
          }],
          167: [function (e, t, n) {
            "use strict";

            var r = e("./do-bind.js");
            function i(e, t, n, r, i, o) {
              this.location = e, this.dimension = t, this.a = n, this.b = r, this.c = i, this.d = o;
            }
            function o(e, t, n) {
              this.gl = e, this._ext = t, this.handle = n, this._attribs = [], this._useElements = !1, this._elementsType = e.UNSIGNED_SHORT;
            }
            i.prototype.bind = function (e) {
              switch (this.dimension) {
                case 1:
                  e.vertexAttrib1f(this.location, this.a);
                  break;
                case 2:
                  e.vertexAttrib2f(this.location, this.a, this.b);
                  break;
                case 3:
                  e.vertexAttrib3f(this.location, this.a, this.b, this.c);
                  break;
                case 4:
                  e.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d);
              }
            }, o.prototype.bind = function () {
              this._ext.bindVertexArrayOES(this.handle);
              for (var e = 0; e < this._attribs.length; ++e) this._attribs[e].bind(this.gl);
            }, o.prototype.unbind = function () {
              this._ext.bindVertexArrayOES(null);
            }, o.prototype.dispose = function () {
              this._ext.deleteVertexArrayOES(this.handle);
            }, o.prototype.update = function (e, t, n) {
              if (this.bind(), r(this.gl, t, e), this.unbind(), this._attribs.length = 0, e) for (var o = 0; o < e.length; ++o) {
                var a = e[o];
                "number" == typeof a ? this._attribs.push(new i(o, 1, a)) : Array.isArray(a) && this._attribs.push(new i(o, a.length, a[0], a[1], a[2], a[3]));
              }
              this._useElements = !!t, this._elementsType = n || this.gl.UNSIGNED_SHORT;
            }, o.prototype.draw = function (e, t, n) {
              n = n || 0;
              var r = this.gl;
              this._useElements ? r.drawElements(e, t, this._elementsType, n) : r.drawArrays(e, n, t);
            }, t.exports = function (e, t) {
              return new o(e, t, t.createVertexArrayOES());
            };
          }, {
            "./do-bind.js": 165
          }],
          168: [function (e, t, n) {
            "use strict";

            var r = e("./lib/vao-native.js"),
              i = e("./lib/vao-emulated.js");
            function o(e) {
              this.bindVertexArrayOES = e.bindVertexArray.bind(e), this.createVertexArrayOES = e.createVertexArray.bind(e), this.deleteVertexArrayOES = e.deleteVertexArray.bind(e);
            }
            t.exports = function (e, t, n, a) {
              var s,
                l = e.createVertexArray ? new o(e) : e.getExtension("OES_vertex_array_object");
              return (s = l ? r(e, l) : i(e)).update(t, n, a), s;
            };
          }, {
            "./lib/vao-emulated.js": 166,
            "./lib/vao-native.js": 167
          }],
          169: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e;
            };
          }, {}],
          170: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = r(e[0], e[1], e[2]),
                a = r(t[0], t[1], t[2]);
              i(n, n), i(a, a);
              var s = o(n, a);
              return s > 1 ? 0 : Math.acos(s);
            };
            var r = e("./fromValues"),
              i = e("./normalize"),
              o = e("./dot");
          }, {
            "./dot": 180,
            "./fromValues": 186,
            "./normalize": 197
          }],
          171: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = Math.ceil(t[0]), e[1] = Math.ceil(t[1]), e[2] = Math.ceil(t[2]), e;
            };
          }, {}],
          172: [function (e, t, n) {
            t.exports = function (e) {
              var t = new Float32Array(3);
              return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
            };
          }, {}],
          173: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
            };
          }, {}],
          174: [function (e, t, n) {
            t.exports = function () {
              var e = new Float32Array(3);
              return e[0] = 0, e[1] = 0, e[2] = 0, e;
            };
          }, {}],
          175: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = n[0],
                s = n[1],
                l = n[2];
              return e[0] = i * l - o * s, e[1] = o * a - r * l, e[2] = r * s - i * a, e;
            };
          }, {}],
          176: [function (e, t, n) {
            t.exports = e("./distance");
          }, {
            "./distance": 177
          }],
          177: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0] - e[0],
                r = t[1] - e[1],
                i = t[2] - e[2];
              return Math.sqrt(n * n + r * r + i * i);
            };
          }, {}],
          178: [function (e, t, n) {
            t.exports = e("./divide");
          }, {
            "./divide": 179
          }],
          179: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] / n[0], e[1] = t[1] / n[1], e[2] = t[2] / n[2], e;
            };
          }, {}],
          180: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
            };
          }, {}],
          181: [function (e, t, n) {
            t.exports = 1e-6;
          }, {}],
          182: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = e[0],
                i = e[1],
                o = e[2],
                a = t[0],
                s = t[1],
                l = t[2];
              return Math.abs(n - a) <= r * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - s) <= r * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(o - l) <= r * Math.max(1, Math.abs(o), Math.abs(l));
            };
            var r = e("./epsilon");
          }, {
            "./epsilon": 181
          }],
          183: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] === t[0] && e[1] === t[1] && e[2] === t[2];
            };
          }, {}],
          184: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = Math.floor(t[0]), e[1] = Math.floor(t[1]), e[2] = Math.floor(t[2]), e;
            };
          }, {}],
          185: [function (e, t, n) {
            t.exports = function (e, t, n, i, o, a) {
              var s, l;
              for (t || (t = 3), n || (n = 0), l = i ? Math.min(i * t + n, e.length) : e.length, s = n; s < l; s += t) r[0] = e[s], r[1] = e[s + 1], r[2] = e[s + 2], o(r, r, a), e[s] = r[0], e[s + 1] = r[1], e[s + 2] = r[2];
              return e;
            };
            var r = e("./create")();
          }, {
            "./create": 174
          }],
          186: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = new Float32Array(3);
              return r[0] = e, r[1] = t, r[2] = n, r;
            };
          }, {}],
          187: [function (e, t, n) {
            t.exports = {
              EPSILON: e("./epsilon"),
              create: e("./create"),
              clone: e("./clone"),
              angle: e("./angle"),
              fromValues: e("./fromValues"),
              copy: e("./copy"),
              set: e("./set"),
              equals: e("./equals"),
              exactEquals: e("./exactEquals"),
              add: e("./add"),
              subtract: e("./subtract"),
              sub: e("./sub"),
              multiply: e("./multiply"),
              mul: e("./mul"),
              divide: e("./divide"),
              div: e("./div"),
              min: e("./min"),
              max: e("./max"),
              floor: e("./floor"),
              ceil: e("./ceil"),
              round: e("./round"),
              scale: e("./scale"),
              scaleAndAdd: e("./scaleAndAdd"),
              distance: e("./distance"),
              dist: e("./dist"),
              squaredDistance: e("./squaredDistance"),
              sqrDist: e("./sqrDist"),
              length: e("./length"),
              len: e("./len"),
              squaredLength: e("./squaredLength"),
              sqrLen: e("./sqrLen"),
              negate: e("./negate"),
              inverse: e("./inverse"),
              normalize: e("./normalize"),
              dot: e("./dot"),
              cross: e("./cross"),
              lerp: e("./lerp"),
              random: e("./random"),
              transformMat4: e("./transformMat4"),
              transformMat3: e("./transformMat3"),
              transformQuat: e("./transformQuat"),
              rotateX: e("./rotateX"),
              rotateY: e("./rotateY"),
              rotateZ: e("./rotateZ"),
              forEach: e("./forEach")
            };
          }, {
            "./add": 169,
            "./angle": 170,
            "./ceil": 171,
            "./clone": 172,
            "./copy": 173,
            "./create": 174,
            "./cross": 175,
            "./dist": 176,
            "./distance": 177,
            "./div": 178,
            "./divide": 179,
            "./dot": 180,
            "./epsilon": 181,
            "./equals": 182,
            "./exactEquals": 183,
            "./floor": 184,
            "./forEach": 185,
            "./fromValues": 186,
            "./inverse": 188,
            "./len": 189,
            "./length": 190,
            "./lerp": 191,
            "./max": 192,
            "./min": 193,
            "./mul": 194,
            "./multiply": 195,
            "./negate": 196,
            "./normalize": 197,
            "./random": 198,
            "./rotateX": 199,
            "./rotateY": 200,
            "./rotateZ": 201,
            "./round": 202,
            "./scale": 203,
            "./scaleAndAdd": 204,
            "./set": 205,
            "./sqrDist": 206,
            "./sqrLen": 207,
            "./squaredDistance": 208,
            "./squaredLength": 209,
            "./sub": 210,
            "./subtract": 211,
            "./transformMat3": 212,
            "./transformMat4": 213,
            "./transformQuat": 214
          }],
          188: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = 1 / t[0], e[1] = 1 / t[1], e[2] = 1 / t[2], e;
            };
          }, {}],
          189: [function (e, t, n) {
            t.exports = e("./length");
          }, {
            "./length": 190
          }],
          190: [function (e, t, n) {
            t.exports = function (e) {
              var t = e[0],
                n = e[1],
                r = e[2];
              return Math.sqrt(t * t + n * n + r * r);
            };
          }, {}],
          191: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i = t[0],
                o = t[1],
                a = t[2];
              return e[0] = i + r * (n[0] - i), e[1] = o + r * (n[1] - o), e[2] = a + r * (n[2] - a), e;
            };
          }, {}],
          192: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = Math.max(t[0], n[0]), e[1] = Math.max(t[1], n[1]), e[2] = Math.max(t[2], n[2]), e;
            };
          }, {}],
          193: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = Math.min(t[0], n[0]), e[1] = Math.min(t[1], n[1]), e[2] = Math.min(t[2], n[2]), e;
            };
          }, {}],
          194: [function (e, t, n) {
            t.exports = e("./multiply");
          }, {
            "./multiply": 195
          }],
          195: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e[2] = t[2] * n[2], e;
            };
          }, {}],
          196: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e;
            };
          }, {}],
          197: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = n * n + r * r + i * i;
              return o > 0 && (o = 1 / Math.sqrt(o), e[0] = t[0] * o, e[1] = t[1] * o, e[2] = t[2] * o), e;
            };
          }, {}],
          198: [function (e, t, n) {
            t.exports = function (e, t) {
              t = t || 1;
              var n = 2 * Math.random() * Math.PI,
                r = 2 * Math.random() - 1,
                i = Math.sqrt(1 - r * r) * t;
              return e[0] = Math.cos(n) * i, e[1] = Math.sin(n) * i, e[2] = r * t, e;
            };
          }, {}],
          199: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i = n[1],
                o = n[2],
                a = t[1] - i,
                s = t[2] - o,
                l = Math.sin(r),
                u = Math.cos(r);
              return e[0] = t[0], e[1] = i + a * u - s * l, e[2] = o + a * l + s * u, e;
            };
          }, {}],
          200: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i = n[0],
                o = n[2],
                a = t[0] - i,
                s = t[2] - o,
                l = Math.sin(r),
                u = Math.cos(r);
              return e[0] = i + s * l + a * u, e[1] = t[1], e[2] = o + s * u - a * l, e;
            };
          }, {}],
          201: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i = n[0],
                o = n[1],
                a = t[0] - i,
                s = t[1] - o,
                l = Math.sin(r),
                u = Math.cos(r);
              return e[0] = i + a * u - s * l, e[1] = o + a * l + s * u, e[2] = t[2], e;
            };
          }, {}],
          202: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = Math.round(t[0]), e[1] = Math.round(t[1]), e[2] = Math.round(t[2]), e;
            };
          }, {}],
          203: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e;
            };
          }, {}],
          204: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e;
            };
          }, {}],
          205: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              return e[0] = t, e[1] = n, e[2] = r, e;
            };
          }, {}],
          206: [function (e, t, n) {
            t.exports = e("./squaredDistance");
          }, {
            "./squaredDistance": 208
          }],
          207: [function (e, t, n) {
            t.exports = e("./squaredLength");
          }, {
            "./squaredLength": 209
          }],
          208: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0] - e[0],
                r = t[1] - e[1],
                i = t[2] - e[2];
              return n * n + r * r + i * i;
            };
          }, {}],
          209: [function (e, t, n) {
            t.exports = function (e) {
              var t = e[0],
                n = e[1],
                r = e[2];
              return t * t + n * n + r * r;
            };
          }, {}],
          210: [function (e, t, n) {
            t.exports = e("./subtract");
          }, {
            "./subtract": 211
          }],
          211: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e;
            };
          }, {}],
          212: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2];
              return e[0] = r * n[0] + i * n[3] + o * n[6], e[1] = r * n[1] + i * n[4] + o * n[7], e[2] = r * n[2] + i * n[5] + o * n[8], e;
            };
          }, {}],
          213: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = n[3] * r + n[7] * i + n[11] * o + n[15];
              return a = a || 1, e[0] = (n[0] * r + n[4] * i + n[8] * o + n[12]) / a, e[1] = (n[1] * r + n[5] * i + n[9] * o + n[13]) / a, e[2] = (n[2] * r + n[6] * i + n[10] * o + n[14]) / a, e;
            };
          }, {}],
          214: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = n[0],
                s = n[1],
                l = n[2],
                u = n[3],
                c = u * r + s * o - l * i,
                d = u * i + l * r - a * o,
                h = u * o + a * i - s * r,
                f = -a * r - s * i - l * o;
              return e[0] = c * u + f * -a + d * -l - h * -s, e[1] = d * u + f * -s + h * -a - c * -l, e[2] = h * u + f * -l + c * -s - d * -a, e;
            };
          }, {}],
          215: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e;
            };
          }, {}],
          216: [function (e, t, n) {
            t.exports = function (e) {
              var t = new Float32Array(4);
              return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
            };
          }, {}],
          217: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
            };
          }, {}],
          218: [function (e, t, n) {
            t.exports = function () {
              var e = new Float32Array(4);
              return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0, e;
            };
          }, {}],
          219: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0] - e[0],
                r = t[1] - e[1],
                i = t[2] - e[2],
                o = t[3] - e[3];
              return Math.sqrt(n * n + r * r + i * i + o * o);
            };
          }, {}],
          220: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] / n[0], e[1] = t[1] / n[1], e[2] = t[2] / n[2], e[3] = t[3] / n[3], e;
            };
          }, {}],
          221: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
            };
          }, {}],
          222: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i = new Float32Array(4);
              return i[0] = e, i[1] = t, i[2] = n, i[3] = r, i;
            };
          }, {}],
          223: [function (e, t, n) {
            t.exports = {
              create: e("./create"),
              clone: e("./clone"),
              fromValues: e("./fromValues"),
              copy: e("./copy"),
              set: e("./set"),
              add: e("./add"),
              subtract: e("./subtract"),
              multiply: e("./multiply"),
              divide: e("./divide"),
              min: e("./min"),
              max: e("./max"),
              scale: e("./scale"),
              scaleAndAdd: e("./scaleAndAdd"),
              distance: e("./distance"),
              squaredDistance: e("./squaredDistance"),
              length: e("./length"),
              squaredLength: e("./squaredLength"),
              negate: e("./negate"),
              inverse: e("./inverse"),
              normalize: e("./normalize"),
              dot: e("./dot"),
              lerp: e("./lerp"),
              random: e("./random"),
              transformMat4: e("./transformMat4"),
              transformQuat: e("./transformQuat")
            };
          }, {
            "./add": 215,
            "./clone": 216,
            "./copy": 217,
            "./create": 218,
            "./distance": 219,
            "./divide": 220,
            "./dot": 221,
            "./fromValues": 222,
            "./inverse": 224,
            "./length": 225,
            "./lerp": 226,
            "./max": 227,
            "./min": 228,
            "./multiply": 229,
            "./negate": 230,
            "./normalize": 231,
            "./random": 232,
            "./scale": 233,
            "./scaleAndAdd": 234,
            "./set": 235,
            "./squaredDistance": 236,
            "./squaredLength": 237,
            "./subtract": 238,
            "./transformMat4": 239,
            "./transformQuat": 240
          }],
          224: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = 1 / t[0], e[1] = 1 / t[1], e[2] = 1 / t[2], e[3] = 1 / t[3], e;
            };
          }, {}],
          225: [function (e, t, n) {
            t.exports = function (e) {
              var t = e[0],
                n = e[1],
                r = e[2],
                i = e[3];
              return Math.sqrt(t * t + n * n + r * r + i * i);
            };
          }, {}],
          226: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var i = t[0],
                o = t[1],
                a = t[2],
                s = t[3];
              return e[0] = i + r * (n[0] - i), e[1] = o + r * (n[1] - o), e[2] = a + r * (n[2] - a), e[3] = s + r * (n[3] - s), e;
            };
          }, {}],
          227: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = Math.max(t[0], n[0]), e[1] = Math.max(t[1], n[1]), e[2] = Math.max(t[2], n[2]), e[3] = Math.max(t[3], n[3]), e;
            };
          }, {}],
          228: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = Math.min(t[0], n[0]), e[1] = Math.min(t[1], n[1]), e[2] = Math.min(t[2], n[2]), e[3] = Math.min(t[3], n[3]), e;
            };
          }, {}],
          229: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] * n[0], e[1] = t[1] * n[1], e[2] = t[2] * n[2], e[3] = t[3] * n[3], e;
            };
          }, {}],
          230: [function (e, t, n) {
            t.exports = function (e, t) {
              return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = -t[3], e;
            };
          }, {}],
          231: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = t[3],
                a = n * n + r * r + i * i + o * o;
              return a > 0 && (a = 1 / Math.sqrt(a), e[0] = n * a, e[1] = r * a, e[2] = i * a, e[3] = o * a), e;
            };
          }, {}],
          232: [function (e, t, n) {
            var r = e("./normalize"),
              i = e("./scale");
            t.exports = function (e, t) {
              return t = t || 1, e[0] = Math.random(), e[1] = Math.random(), e[2] = Math.random(), e[3] = Math.random(), r(e, e), i(e, e, t), e;
            };
          }, {
            "./normalize": 231,
            "./scale": 233
          }],
          233: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
            };
          }, {}],
          234: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              return e[0] = t[0] + n[0] * r, e[1] = t[1] + n[1] * r, e[2] = t[2] + n[2] * r, e[3] = t[3] + n[3] * r, e;
            };
          }, {}],
          235: [function (e, t, n) {
            t.exports = function (e, t, n, r, i) {
              return e[0] = t, e[1] = n, e[2] = r, e[3] = i, e;
            };
          }, {}],
          236: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[0] - e[0],
                r = t[1] - e[1],
                i = t[2] - e[2],
                o = t[3] - e[3];
              return n * n + r * r + i * i + o * o;
            };
          }, {}],
          237: [function (e, t, n) {
            t.exports = function (e) {
              var t = e[0],
                n = e[1],
                r = e[2],
                i = e[3];
              return t * t + n * n + r * r + i * i;
            };
          }, {}],
          238: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e[3] = t[3] - n[3], e;
            };
          }, {}],
          239: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = t[3];
              return e[0] = n[0] * r + n[4] * i + n[8] * o + n[12] * a, e[1] = n[1] * r + n[5] * i + n[9] * o + n[13] * a, e[2] = n[2] * r + n[6] * i + n[10] * o + n[14] * a, e[3] = n[3] * r + n[7] * i + n[11] * o + n[15] * a, e;
            };
          }, {}],
          240: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = t[0],
                i = t[1],
                o = t[2],
                a = n[0],
                s = n[1],
                l = n[2],
                u = n[3],
                c = u * r + s * o - l * i,
                d = u * i + l * r - a * o,
                h = u * o + a * i - s * r,
                f = -a * r - s * i - l * o;
              return e[0] = c * u + f * -a + d * -l - h * -s, e[1] = d * u + f * -s + h * -a - c * -l, e[2] = h * u + f * -l + c * -s - d * -a, e[3] = t[3], e;
            };
          }, {}],
          241: [function (e, t, n) {
            var r = e("glsl-tokenizer"),
              i = e("atob-lite");
            t.exports = function (e) {
              for (var t = Array.isArray(e) ? e : r(e), n = 0; n < t.length; n++) {
                var o = t[n];
                if ("preprocessor" === o.type) {
                  var a = o.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);
                  if (a && a[2]) {
                    var s = a[1],
                      l = a[2];
                    return (s ? i(l) : l).trim();
                  }
                }
              }
            };
          }, {
            "atob-lite": 17,
            "glsl-tokenizer": 248
          }],
          242: [function (e, t, n) {
            t.exports = function (e) {
              var t,
                n,
                S,
                A = 0,
                E = 0,
                T = l,
                M = [],
                C = [],
                k = 1,
                P = 0,
                O = 0,
                R = !1,
                I = !1,
                j = "",
                N = o,
                L = r;
              return "300 es" === (e = e || {}).version && (N = s, L = a), function (e) {
                return C = [], null !== e ? function (e) {
                  var n;
                  for (A = 0, S = (j += e).length; t = j[A], A < S;) {
                    switch (n = A, T) {
                      case c:
                        A = U();
                        break;
                      case d:
                      case h:
                        A = z();
                        break;
                      case f:
                        A = G();
                        break;
                      case p:
                        A = q();
                        break;
                      case x:
                        A = H();
                        break;
                      case m:
                        A = W();
                        break;
                      case u:
                        A = $();
                        break;
                      case b:
                        A = F();
                        break;
                      case l:
                        A = B();
                    }
                    if (n !== A) switch (j[n]) {
                      case "\n":
                        P = 0, ++k;
                        break;
                      default:
                        ++P;
                    }
                  }
                  return E += A, j = j.slice(A), C;
                }(e.replace ? e.replace(/\r\n/g, "\n") : e) : (M.length && D(M.join("")), T = _, D("(eof)"), C);
              };
              function D(e) {
                e.length && C.push({
                  type: w[T],
                  data: e,
                  position: O,
                  line: k,
                  column: P
                });
              }
              function B() {
                return M = M.length ? [] : M, "/" === n && "*" === t ? (O = E + A - 1, T = c, n = t, A + 1) : "/" === n && "/" === t ? (O = E + A - 1, T = d, n = t, A + 1) : "#" === t ? (T = h, O = E + A, A) : /\s/.test(t) ? (T = b, O = E + A, A) : (R = /\d/.test(t), I = /[^\w_]/.test(t), O = E + A, T = R ? p : I ? f : u, A);
              }
              function F() {
                return /[^\s]/g.test(t) ? (D(M.join("")), T = l, A) : (M.push(t), n = t, A + 1);
              }
              function z() {
                return "\r" !== t && "\n" !== t || "\\" === n ? (M.push(t), n = t, A + 1) : (D(M.join("")), T = l, A);
              }
              function U() {
                return "/" === t && "*" === n ? (M.push(t), D(M.join("")), T = l, A + 1) : (M.push(t), n = t, A + 1);
              }
              function G() {
                if ("." === n && /\d/.test(t)) return T = m, A;
                if ("/" === n && "*" === t) return T = c, A;
                if ("/" === n && "/" === t) return T = d, A;
                if ("." === t && M.length) {
                  for (; V(M););
                  return T = m, A;
                }
                if (";" === t || ")" === t || "(" === t) {
                  if (M.length) for (; V(M););
                  return D(t), T = l, A + 1;
                }
                var e = 2 === M.length && "=" !== t;
                if (/[\w_\d\s]/.test(t) || e) {
                  for (; V(M););
                  return T = l, A;
                }
                return M.push(t), n = t, A + 1;
              }
              function V(e) {
                for (var t, n, r = 0;;) {
                  if (t = i.indexOf(e.slice(0, e.length + r).join("")), n = i[t], -1 === t) {
                    if (r-- + e.length > 0) continue;
                    n = e.slice(0, 1).join("");
                  }
                  return D(n), O += n.length, (M = M.slice(n.length)).length;
                }
              }
              function H() {
                return /[^a-fA-F0-9]/.test(t) ? (D(M.join("")), T = l, A) : (M.push(t), n = t, A + 1);
              }
              function q() {
                return "." === t || /[eE]/.test(t) ? (M.push(t), T = m, n = t, A + 1) : "x" === t && 1 === M.length && "0" === M[0] ? (T = x, M.push(t), n = t, A + 1) : /[^\d]/.test(t) ? (D(M.join("")), T = l, A) : (M.push(t), n = t, A + 1);
              }
              function W() {
                return "f" === t && (M.push(t), n = t, A += 1), /[eE]/.test(t) || "-" === t && /[eE]/.test(n) ? (M.push(t), n = t, A + 1) : /[^\d]/.test(t) ? (D(M.join("")), T = l, A) : (M.push(t), n = t, A + 1);
              }
              function $() {
                if (/[^\d\w_]/.test(t)) {
                  var e = M.join("");
                  return T = L.indexOf(e) > -1 ? y : N.indexOf(e) > -1 ? v : g, D(M.join("")), T = l, A;
                }
                return M.push(t), n = t, A + 1;
              }
            };
            var r = e("./lib/literals"),
              i = e("./lib/operators"),
              o = e("./lib/builtins"),
              a = e("./lib/literals-300es"),
              s = e("./lib/builtins-300es"),
              l = 999,
              u = 9999,
              c = 0,
              d = 1,
              h = 2,
              f = 3,
              p = 4,
              m = 5,
              g = 6,
              v = 7,
              y = 8,
              b = 9,
              _ = 10,
              x = 11,
              w = ["block-comment", "line-comment", "preprocessor", "operator", "integer", "float", "ident", "builtin", "keyword", "whitespace", "eof", "integer"];
          }, {
            "./lib/builtins": 244,
            "./lib/builtins-300es": 243,
            "./lib/literals": 246,
            "./lib/literals-300es": 245,
            "./lib/operators": 247
          }],
          243: [function (e, t, n) {
            var r = e("./builtins");
            r = r.slice().filter(function (e) {
              return !/^(gl\_|texture)/.test(e);
            }), t.exports = r.concat(["gl_VertexID", "gl_InstanceID", "gl_Position", "gl_PointSize", "gl_FragCoord", "gl_FrontFacing", "gl_FragDepth", "gl_PointCoord", "gl_MaxVertexAttribs", "gl_MaxVertexUniformVectors", "gl_MaxVertexOutputVectors", "gl_MaxFragmentInputVectors", "gl_MaxVertexTextureImageUnits", "gl_MaxCombinedTextureImageUnits", "gl_MaxTextureImageUnits", "gl_MaxFragmentUniformVectors", "gl_MaxDrawBuffers", "gl_MinProgramTexelOffset", "gl_MaxProgramTexelOffset", "gl_DepthRangeParameters", "gl_DepthRange", "trunc", "round", "roundEven", "isnan", "isinf", "floatBitsToInt", "floatBitsToUint", "intBitsToFloat", "uintBitsToFloat", "packSnorm2x16", "unpackSnorm2x16", "packUnorm2x16", "unpackUnorm2x16", "packHalf2x16", "unpackHalf2x16", "outerProduct", "transpose", "determinant", "inverse", "texture", "textureSize", "textureProj", "textureLod", "textureOffset", "texelFetch", "texelFetchOffset", "textureProjOffset", "textureLodOffset", "textureProjLod", "textureProjLodOffset", "textureGrad", "textureGradOffset", "textureProjGrad", "textureProjGradOffset"]);
          }, {
            "./builtins": 244
          }],
          244: [function (e, t, n) {
            t.exports = ["abs", "acos", "all", "any", "asin", "atan", "ceil", "clamp", "cos", "cross", "dFdx", "dFdy", "degrees", "distance", "dot", "equal", "exp", "exp2", "faceforward", "floor", "fract", "gl_BackColor", "gl_BackLightModelProduct", "gl_BackLightProduct", "gl_BackMaterial", "gl_BackSecondaryColor", "gl_ClipPlane", "gl_ClipVertex", "gl_Color", "gl_DepthRange", "gl_DepthRangeParameters", "gl_EyePlaneQ", "gl_EyePlaneR", "gl_EyePlaneS", "gl_EyePlaneT", "gl_Fog", "gl_FogCoord", "gl_FogFragCoord", "gl_FogParameters", "gl_FragColor", "gl_FragCoord", "gl_FragData", "gl_FragDepth", "gl_FragDepthEXT", "gl_FrontColor", "gl_FrontFacing", "gl_FrontLightModelProduct", "gl_FrontLightProduct", "gl_FrontMaterial", "gl_FrontSecondaryColor", "gl_LightModel", "gl_LightModelParameters", "gl_LightModelProducts", "gl_LightProducts", "gl_LightSource", "gl_LightSourceParameters", "gl_MaterialParameters", "gl_MaxClipPlanes", "gl_MaxCombinedTextureImageUnits", "gl_MaxDrawBuffers", "gl_MaxFragmentUniformComponents", "gl_MaxLights", "gl_MaxTextureCoords", "gl_MaxTextureImageUnits", "gl_MaxTextureUnits", "gl_MaxVaryingFloats", "gl_MaxVertexAttribs", "gl_MaxVertexTextureImageUnits", "gl_MaxVertexUniformComponents", "gl_ModelViewMatrix", "gl_ModelViewMatrixInverse", "gl_ModelViewMatrixInverseTranspose", "gl_ModelViewMatrixTranspose", "gl_ModelViewProjectionMatrix", "gl_ModelViewProjectionMatrixInverse", "gl_ModelViewProjectionMatrixInverseTranspose", "gl_ModelViewProjectionMatrixTranspose", "gl_MultiTexCoord0", "gl_MultiTexCoord1", "gl_MultiTexCoord2", "gl_MultiTexCoord3", "gl_MultiTexCoord4", "gl_MultiTexCoord5", "gl_MultiTexCoord6", "gl_MultiTexCoord7", "gl_Normal", "gl_NormalMatrix", "gl_NormalScale", "gl_ObjectPlaneQ", "gl_ObjectPlaneR", "gl_ObjectPlaneS", "gl_ObjectPlaneT", "gl_Point", "gl_PointCoord", "gl_PointParameters", "gl_PointSize", "gl_Position", "gl_ProjectionMatrix", "gl_ProjectionMatrixInverse", "gl_ProjectionMatrixInverseTranspose", "gl_ProjectionMatrixTranspose", "gl_SecondaryColor", "gl_TexCoord", "gl_TextureEnvColor", "gl_TextureMatrix", "gl_TextureMatrixInverse", "gl_TextureMatrixInverseTranspose", "gl_TextureMatrixTranspose", "gl_Vertex", "greaterThan", "greaterThanEqual", "inversesqrt", "length", "lessThan", "lessThanEqual", "log", "log2", "matrixCompMult", "max", "min", "mix", "mod", "normalize", "not", "notEqual", "pow", "radians", "reflect", "refract", "sign", "sin", "smoothstep", "sqrt", "step", "tan", "texture2D", "texture2DLod", "texture2DProj", "texture2DProjLod", "textureCube", "textureCubeLod", "texture2DLodEXT", "texture2DProjLodEXT", "textureCubeLodEXT", "texture2DGradEXT", "texture2DProjGradEXT", "textureCubeGradEXT"];
          }, {}],
          245: [function (e, t, n) {
            var r = e("./literals");
            t.exports = r.slice().concat(["layout", "centroid", "smooth", "case", "mat2x2", "mat2x3", "mat2x4", "mat3x2", "mat3x3", "mat3x4", "mat4x2", "mat4x3", "mat4x4", "uint", "uvec2", "uvec3", "uvec4", "samplerCubeShadow", "sampler2DArray", "sampler2DArrayShadow", "isampler2D", "isampler3D", "isamplerCube", "isampler2DArray", "usampler2D", "usampler3D", "usamplerCube", "usampler2DArray", "coherent", "restrict", "readonly", "writeonly", "resource", "atomic_uint", "noperspective", "patch", "sample", "subroutine", "common", "partition", "active", "filter", "image1D", "image2D", "image3D", "imageCube", "iimage1D", "iimage2D", "iimage3D", "iimageCube", "uimage1D", "uimage2D", "uimage3D", "uimageCube", "image1DArray", "image2DArray", "iimage1DArray", "iimage2DArray", "uimage1DArray", "uimage2DArray", "image1DShadow", "image2DShadow", "image1DArrayShadow", "image2DArrayShadow", "imageBuffer", "iimageBuffer", "uimageBuffer", "sampler1DArray", "sampler1DArrayShadow", "isampler1D", "isampler1DArray", "usampler1D", "usampler1DArray", "isampler2DRect", "usampler2DRect", "samplerBuffer", "isamplerBuffer", "usamplerBuffer", "sampler2DMS", "isampler2DMS", "usampler2DMS", "sampler2DMSArray", "isampler2DMSArray", "usampler2DMSArray"]);
          }, {
            "./literals": 246
          }],
          246: [function (e, t, n) {
            t.exports = ["precision", "highp", "mediump", "lowp", "attribute", "const", "uniform", "varying", "break", "continue", "do", "for", "while", "if", "else", "in", "out", "inout", "float", "int", "void", "bool", "true", "false", "discard", "return", "mat2", "mat3", "mat4", "vec2", "vec3", "vec4", "ivec2", "ivec3", "ivec4", "bvec2", "bvec3", "bvec4", "sampler1D", "sampler2D", "sampler3D", "samplerCube", "sampler1DShadow", "sampler2DShadow", "struct", "asm", "class", "union", "enum", "typedef", "template", "this", "packed", "goto", "switch", "default", "inline", "noinline", "volatile", "public", "static", "extern", "external", "interface", "long", "short", "double", "half", "fixed", "unsigned", "input", "output", "hvec2", "hvec3", "hvec4", "dvec2", "dvec3", "dvec4", "fvec2", "fvec3", "fvec4", "sampler2DRect", "sampler3DRect", "sampler2DRectShadow", "sizeof", "cast", "namespace", "using"];
          }, {}],
          247: [function (e, t, n) {
            t.exports = ["<<=", ">>=", "++", "--", "<<", ">>", "<=", ">=", "==", "!=", "&&", "||", "+=", "-=", "*=", "/=", "%=", "&=", "^^", "^=", "|=", "(", ")", "[", "]", ".", "!", "~", "*", "/", "%", "+", "-", "<", ">", "&", "^", "|", "?", ":", "=", ",", ";", "{", "}"];
          }, {}],
          248: [function (e, t, n) {
            var r = e("./index");
            t.exports = function (e, t) {
              var n = r(t),
                i = [];
              return (i = i.concat(n(e))).concat(n(null));
            };
          }, {
            "./index": 242
          }],
          249: [function (e, t, n) {
            t.exports = function (e) {
              "string" == typeof e && (e = [e]);
              for (var t = [].slice.call(arguments, 1), n = [], r = 0; r < e.length - 1; r++) n.push(e[r], t[r] || "");
              return n.push(e[r]), n.join("");
            };
          }, {}],
          250: [function (e, n, r) {
            (function (t) {
              "use strict";

              var r,
                i = e("is-browser");
              r = "function" == typeof t.matchMedia ? !t.matchMedia("(hover: none)").matches : i, n.exports = r;
            }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {
            "is-browser": 257
          }],
          251: [function (e, t, n) {
            "use strict";

            var r = e("is-browser");
            t.exports = r && function () {
              var e = !1;
              try {
                var t = Object.defineProperty({}, "passive", {
                  get: function get() {
                    e = !0;
                  }
                });
                window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
              } catch (t) {
                e = !1;
              }
              return e;
            }();
          }, {
            "is-browser": 257
          }],
          252: [function (e, t, n) {
            n.read = function (e, t, n, r, i) {
              var o,
                a,
                s = 8 * i - r - 1,
                l = (1 << s) - 1,
                u = l >> 1,
                c = -7,
                d = n ? i - 1 : 0,
                h = n ? -1 : 1,
                f = e[t + d];
              for (d += h, o = f & (1 << -c) - 1, f >>= -c, c += s; c > 0; o = 256 * o + e[t + d], d += h, c -= 8);
              for (a = o & (1 << -c) - 1, o >>= -c, c += r; c > 0; a = 256 * a + e[t + d], d += h, c -= 8);
              if (0 === o) o = 1 - u;else {
                if (o === l) return a ? NaN : 1 / 0 * (f ? -1 : 1);
                a += Math.pow(2, r), o -= u;
              }
              return (f ? -1 : 1) * a * Math.pow(2, o - r);
            }, n.write = function (e, t, n, r, i, o) {
              var a,
                s,
                l,
                u = 8 * o - i - 1,
                c = (1 << u) - 1,
                d = c >> 1,
                h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                f = r ? 0 : o - 1,
                p = r ? 1 : -1,
                m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
              for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = c) : (a = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -a)) < 1 && (a--, l *= 2), (t += a + d >= 1 ? h / l : h * Math.pow(2, 1 - d)) * l >= 2 && (a++, l /= 2), a + d >= c ? (s = 0, a = c) : a + d >= 1 ? (s = (t * l - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[n + f] = 255 & s, f += p, s /= 256, i -= 8);
              for (a = a << i | s, u += i; u > 0; e[n + f] = 255 & a, f += p, a /= 256, u -= 8);
              e[n + f - p] |= 128 * m;
            };
          }, {}],
          253: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = e.length;
              if (0 === n) throw new Error("Must have at least d+1 points");
              var i = e[0].length;
              if (n <= i) throw new Error("Must input at least d+1 points");
              var a = e.slice(0, i + 1),
                s = r.apply(void 0, a);
              if (0 === s) throw new Error("Input not in general position");
              for (var l = new Array(i + 1), c = 0; c <= i; ++c) l[c] = c;
              s < 0 && (l[0] = 1, l[1] = 0);
              var d = new o(l, new Array(i + 1), !1),
                h = d.adjacent,
                f = new Array(i + 2);
              for (c = 0; c <= i; ++c) {
                for (var p = l.slice(), m = 0; m <= i; ++m) m === c && (p[m] = -1);
                var g = p[0];
                p[0] = p[1], p[1] = g;
                var v = new o(p, new Array(i + 1), !0);
                h[c] = v, f[c] = v;
              }
              for (f[i + 1] = d, c = 0; c <= i; ++c) {
                p = h[c].vertices;
                var y = h[c].adjacent;
                for (m = 0; m <= i; ++m) {
                  var b = p[m];
                  if (b < 0) y[m] = d;else for (var _ = 0; _ <= i; ++_) h[_].vertices.indexOf(b) < 0 && (y[m] = h[_]);
                }
              }
              var x = new u(i, a, f),
                w = !!t;
              for (c = i + 1; c < n; ++c) x.insert(e[c], w);
              return x.boundary();
            };
            var r = e("robust-orientation"),
              i = e("simplicial-complex").compareCells;
            function o(e, t, n) {
              this.vertices = e, this.adjacent = t, this.boundary = n, this.lastVisited = -1;
            }
            function a(e, t, n) {
              this.vertices = e, this.cell = t, this.index = n;
            }
            function s(e, t) {
              return i(e.vertices, t.vertices);
            }
            o.prototype.flip = function () {
              var e = this.vertices[0];
              this.vertices[0] = this.vertices[1], this.vertices[1] = e;
              var t = this.adjacent[0];
              this.adjacent[0] = this.adjacent[1], this.adjacent[1] = t;
            };
            var l = [];
            function u(e, t, n) {
              this.dimension = e, this.vertices = t, this.simplices = n, this.interior = n.filter(function (e) {
                return !e.boundary;
              }), this.tuple = new Array(e + 1);
              for (var i = 0; i <= e; ++i) this.tuple[i] = this.vertices[i];
              var o = l[e];
              o || (o = l[e] = function (e) {
                for (var t = ["function orient(){var tuple=this.tuple;return test("], n = 0; n <= e; ++n) n > 0 && t.push(","), t.push("tuple[", n, "]");
                t.push(")}return orient");
                var i = new Function("test", t.join("")),
                  o = r[e + 1];
                return o || (o = r), i(o);
              }(e)), this.orient = o;
            }
            var c = u.prototype;
            c.handleBoundaryDegeneracy = function (e, t) {
              var n = this.dimension,
                r = this.vertices.length - 1,
                i = this.tuple,
                o = this.vertices,
                a = [e];
              for (e.lastVisited = -r; a.length > 0;) {
                (e = a.pop()).vertices;
                for (var s = e.adjacent, l = 0; l <= n; ++l) {
                  var u = s[l];
                  if (u.boundary && !(u.lastVisited <= -r)) {
                    for (var c = u.vertices, d = 0; d <= n; ++d) {
                      var h = c[d];
                      i[d] = h < 0 ? t : o[h];
                    }
                    var f = this.orient();
                    if (f > 0) return u;
                    u.lastVisited = -r, 0 === f && a.push(u);
                  }
                }
              }
              return null;
            }, c.walk = function (e, t) {
              var n = this.vertices.length - 1,
                r = this.dimension,
                i = this.vertices,
                o = this.tuple,
                a = t ? this.interior.length * Math.random() | 0 : this.interior.length - 1,
                s = this.interior[a];
              e: for (; !s.boundary;) {
                for (var l = s.vertices, u = s.adjacent, c = 0; c <= r; ++c) o[c] = i[l[c]];
                for (s.lastVisited = n, c = 0; c <= r; ++c) {
                  var d = u[c];
                  if (!(d.lastVisited >= n)) {
                    var h = o[c];
                    o[c] = e;
                    var f = this.orient();
                    if (o[c] = h, f < 0) {
                      s = d;
                      continue e;
                    }
                    d.boundary ? d.lastVisited = -n : d.lastVisited = n;
                  }
                }
                return;
              }
              return s;
            }, c.addPeaks = function (e, t) {
              var n = this.vertices.length - 1,
                r = this.dimension,
                i = this.vertices,
                l = this.tuple,
                u = this.interior,
                c = this.simplices,
                d = [t];
              t.lastVisited = n, t.vertices[t.vertices.indexOf(-1)] = n, t.boundary = !1, u.push(t);
              for (var h = []; d.length > 0;) {
                var f = (t = d.pop()).vertices,
                  p = t.adjacent,
                  m = f.indexOf(n);
                if (!(m < 0)) for (var g = 0; g <= r; ++g) if (g !== m) {
                  var v = p[g];
                  if (v.boundary && !(v.lastVisited >= n)) {
                    var y = v.vertices;
                    if (v.lastVisited !== -n) {
                      for (var b = 0, _ = 0; _ <= r; ++_) y[_] < 0 ? (b = _, l[_] = e) : l[_] = i[y[_]];
                      if (this.orient() > 0) {
                        y[b] = n, v.boundary = !1, u.push(v), d.push(v), v.lastVisited = n;
                        continue;
                      }
                      v.lastVisited = -n;
                    }
                    var x = v.adjacent,
                      w = f.slice(),
                      S = p.slice(),
                      A = new o(w, S, !0);
                    c.push(A);
                    var E = x.indexOf(t);
                    if (!(E < 0)) for (x[E] = A, S[m] = v, w[g] = -1, S[g] = t, p[g] = A, A.flip(), _ = 0; _ <= r; ++_) {
                      var T = w[_];
                      if (!(T < 0 || T === n)) {
                        for (var M = new Array(r - 1), C = 0, k = 0; k <= r; ++k) {
                          var P = w[k];
                          P < 0 || k === _ || (M[C++] = P);
                        }
                        h.push(new a(M, A, _));
                      }
                    }
                  }
                }
              }
              for (h.sort(s), g = 0; g + 1 < h.length; g += 2) {
                var O = h[g],
                  R = h[g + 1],
                  I = O.index,
                  j = R.index;
                I < 0 || j < 0 || (O.cell.adjacent[O.index] = R.cell, R.cell.adjacent[R.index] = O.cell);
              }
            }, c.insert = function (e, t) {
              var n = this.vertices;
              n.push(e);
              var r = this.walk(e, t);
              if (r) {
                for (var i = this.dimension, o = this.tuple, a = 0; a <= i; ++a) {
                  var s = r.vertices[a];
                  o[a] = s < 0 ? e : n[s];
                }
                var l = this.orient(o);
                l < 0 || (0 !== l || (r = this.handleBoundaryDegeneracy(r, e))) && this.addPeaks(e, r);
              }
            }, c.boundary = function () {
              for (var e = this.dimension, t = [], n = this.simplices, r = n.length, i = 0; i < r; ++i) {
                var o = n[i];
                if (o.boundary) {
                  for (var a = new Array(e), s = o.vertices, l = 0, u = 0, c = 0; c <= e; ++c) s[c] >= 0 ? a[l++] = s[c] : u = 1 & c;
                  if (u === (1 & e)) {
                    var d = a[0];
                    a[0] = a[1], a[1] = d;
                  }
                  t.push(a);
                }
              }
              return t;
            };
          }, {
            "robust-orientation": 321,
            "simplicial-complex": 331
          }],
          254: [function (e, t, n) {
            "use strict";

            var r = e("binary-search-bounds");
            function i(e, t, n, r, i) {
              this.mid = e, this.left = t, this.right = n, this.leftPoints = r, this.rightPoints = i, this.count = (t ? t.count : 0) + (n ? n.count : 0) + r.length;
            }
            t.exports = function (e) {
              return e && 0 !== e.length ? new v(g(e)) : new v(null);
            };
            var o = i.prototype;
            function a(e, t) {
              e.mid = t.mid, e.left = t.left, e.right = t.right, e.leftPoints = t.leftPoints, e.rightPoints = t.rightPoints, e.count = t.count;
            }
            function s(e, t) {
              var n = g(t);
              e.mid = n.mid, e.left = n.left, e.right = n.right, e.leftPoints = n.leftPoints, e.rightPoints = n.rightPoints, e.count = n.count;
            }
            function l(e, t) {
              var n = e.intervals([]);
              n.push(t), s(e, n);
            }
            function u(e, t) {
              var n = e.intervals([]),
                r = n.indexOf(t);
              return r < 0 ? 0 : (n.splice(r, 1), s(e, n), 1);
            }
            function c(e, t, n) {
              for (var r = 0; r < e.length && e[r][0] <= t; ++r) {
                var i = n(e[r]);
                if (i) return i;
              }
            }
            function d(e, t, n) {
              for (var r = e.length - 1; r >= 0 && e[r][1] >= t; --r) {
                var i = n(e[r]);
                if (i) return i;
              }
            }
            function h(e, t) {
              for (var n = 0; n < e.length; ++n) {
                var r = t(e[n]);
                if (r) return r;
              }
            }
            function f(e, t) {
              return e - t;
            }
            function p(e, t) {
              return e[0] - t[0] || e[1] - t[1];
            }
            function m(e, t) {
              return e[1] - t[1] || e[0] - t[0];
            }
            function g(e) {
              if (0 === e.length) return null;
              for (var t = [], n = 0; n < e.length; ++n) t.push(e[n][0], e[n][1]);
              t.sort(f);
              var r = t[t.length >> 1],
                o = [],
                a = [],
                s = [];
              for (n = 0; n < e.length; ++n) {
                var l = e[n];
                l[1] < r ? o.push(l) : r < l[0] ? a.push(l) : s.push(l);
              }
              var u = s,
                c = s.slice();
              return u.sort(p), c.sort(m), new i(r, g(o), g(a), u, c);
            }
            function v(e) {
              this.root = e;
            }
            o.intervals = function (e) {
              return e.push.apply(e, this.leftPoints), this.left && this.left.intervals(e), this.right && this.right.intervals(e), e;
            }, o.insert = function (e) {
              var t = this.count - this.leftPoints.length;
              if (this.count += 1, e[1] < this.mid) this.left ? 4 * (this.left.count + 1) > 3 * (t + 1) ? l(this, e) : this.left.insert(e) : this.left = g([e]);else if (e[0] > this.mid) this.right ? 4 * (this.right.count + 1) > 3 * (t + 1) ? l(this, e) : this.right.insert(e) : this.right = g([e]);else {
                var n = r.ge(this.leftPoints, e, p),
                  i = r.ge(this.rightPoints, e, m);
                this.leftPoints.splice(n, 0, e), this.rightPoints.splice(i, 0, e);
              }
            }, o.remove = function (e) {
              var t = this.count - this.leftPoints;
              if (e[1] < this.mid) return this.left ? 4 * (this.right ? this.right.count : 0) > 3 * (t - 1) ? u(this, e) : 2 === (s = this.left.remove(e)) ? (this.left = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
              if (e[0] > this.mid) return this.right ? 4 * (this.left ? this.left.count : 0) > 3 * (t - 1) ? u(this, e) : 2 === (s = this.right.remove(e)) ? (this.right = null, this.count -= 1, 1) : (1 === s && (this.count -= 1), s) : 0;
              if (1 === this.count) return this.leftPoints[0] === e ? 2 : 0;
              if (1 === this.leftPoints.length && this.leftPoints[0] === e) {
                if (this.left && this.right) {
                  for (var n = this, i = this.left; i.right;) n = i, i = i.right;
                  if (n === this) i.right = this.right;else {
                    var o = this.left,
                      s = this.right;
                    n.count -= i.count, n.right = i.left, i.left = o, i.right = s;
                  }
                  a(this, i), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
                } else this.left ? a(this, this.left) : a(this, this.right);
                return 1;
              }
              for (o = r.ge(this.leftPoints, e, p); o < this.leftPoints.length && this.leftPoints[o][0] === e[0]; ++o) if (this.leftPoints[o] === e) for (this.count -= 1, this.leftPoints.splice(o, 1), s = r.ge(this.rightPoints, e, m); s < this.rightPoints.length && this.rightPoints[s][1] === e[1]; ++s) if (this.rightPoints[s] === e) return this.rightPoints.splice(s, 1), 1;
              return 0;
            }, o.queryPoint = function (e, t) {
              return e < this.mid ? this.left && (n = this.left.queryPoint(e, t)) ? n : c(this.leftPoints, e, t) : e > this.mid ? this.right && (n = this.right.queryPoint(e, t)) ? n : d(this.rightPoints, e, t) : h(this.leftPoints, t);
              var n;
            }, o.queryInterval = function (e, t, n) {
              var r;
              return e < this.mid && this.left && (r = this.left.queryInterval(e, t, n)) || t > this.mid && this.right && (r = this.right.queryInterval(e, t, n)) ? r : t < this.mid ? c(this.leftPoints, t, n) : e > this.mid ? d(this.rightPoints, e, n) : h(this.leftPoints, n);
            };
            var y = v.prototype;
            y.insert = function (e) {
              this.root ? this.root.insert(e) : this.root = new i(e[0], null, null, [e], [e]);
            }, y.remove = function (e) {
              if (this.root) {
                var t = this.root.remove(e);
                return 2 === t && (this.root = null), 0 !== t;
              }
              return !1;
            }, y.queryPoint = function (e, t) {
              if (this.root) return this.root.queryPoint(e, t);
            }, y.queryInterval = function (e, t, n) {
              if (e <= t && this.root) return this.root.queryInterval(e, t, n);
            }, Object.defineProperty(y, "count", {
              get: function get() {
                return this.root ? this.root.count : 0;
              }
            }), Object.defineProperty(y, "intervals", {
              get: function get() {
                return this.root ? this.root.intervals([]) : [];
              }
            });
          }, {
            "binary-search-bounds": 36
          }],
          255: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              t = t || new Array(e.length);
              for (var n = 0; n < e.length; ++n) t[e[n]] = n;
              return t;
            };
          }, {}],
          256: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = new Array(e), n = 0; n < e; ++n) t[n] = n;
              return t;
            };
          }, {}],
          257: [function (e, t, n) {
            t.exports = !0;
          }, {}],
          258: [function (e, t, n) {
            function r(e) {
              return !!e.constructor && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
            }
            t.exports = function (e) {
              return null != e && (r(e) || function (e) {
                return "function" == typeof e.readFloatLE && "function" == typeof e.slice && r(e.slice(0, 0));
              }(e) || !!e._isBuffer);
            };
          }, {}],
          259: [function (e, t, n) {
            "use strict";

            t.exports = o, t.exports.isMobile = o, t.exports.default = o;
            var r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
              i = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
            function o(e) {
              e || (e = {});
              var t = e.ua;
              if (t || "undefined" == typeof navigator || (t = navigator.userAgent), t && t.headers && "string" == typeof t.headers["user-agent"] && (t = t.headers["user-agent"]), "string" != typeof t) return !1;
              var n = e.tablet ? i.test(t) : r.test(t);
              return !n && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && -1 !== t.indexOf("Macintosh") && -1 !== t.indexOf("Safari") && (n = !0), n;
            }
          }, {}],
          260: [function (e, t, n) {
            "use strict";

            var r = Object.prototype.toString;
            t.exports = function (e) {
              var t;
              return "[object Object]" === r.call(e) && (null === (t = Object.getPrototypeOf(e)) || t === Object.getPrototypeOf({}));
            };
          }, {}],
          261: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t, n = e.length, r = 0; r < n; r++) if (((t = e.charCodeAt(r)) < 9 || t > 13) && 32 !== t && 133 !== t && 160 !== t && 5760 !== t && 6158 !== t && (t < 8192 || t > 8205) && 8232 !== t && 8233 !== t && 8239 !== t && 8287 !== t && 8288 !== t && 12288 !== t && 65279 !== t) return !1;
              return !0;
            };
          }, {}],
          262: [function (e, t, n) {
            t.exports = function (e, t, n) {
              return e * (1 - n) + t * n;
            };
          }, {}],
          263: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = 1 << e + 1, n = new Array(t), r = 0; r < t; ++r) n[r] = o(e, r);
              return n;
            };
            var r = e("convex-hull");
            function i(e, t, n) {
              for (var r = new Array(e), i = 0; i < e; ++i) r[i] = 0, i === t && (r[i] += .5), i === n && (r[i] += .5);
              return r;
            }
            function o(e, t) {
              if (0 === t || t === (1 << e + 1) - 1) return [];
              for (var n = [], o = [], a = 0; a <= e; ++a) if (t & 1 << a) {
                n.push(i(e, a - 1, a - 1)), o.push(null);
                for (var s = 0; s <= e; ++s) ~t & 1 << s && (n.push(i(e, a - 1, s - 1)), o.push([a, s]));
              }
              var l = r(n),
                u = [];
              e: for (a = 0; a < l.length; ++a) {
                var c = l[a],
                  d = [];
                for (s = 0; s < c.length; ++s) {
                  if (!o[c[s]]) continue e;
                  d.push(o[c[s]].slice());
                }
                u.push(d);
              }
              return u;
            }
          }, {
            "convex-hull": 73
          }],
          264: [function (e, t, n) {
            var r = e("./normalize"),
              i = e("gl-mat4/create"),
              o = e("gl-mat4/clone"),
              a = e("gl-mat4/determinant"),
              s = e("gl-mat4/invert"),
              l = e("gl-mat4/transpose"),
              u = {
                length: e("gl-vec3/length"),
                normalize: e("gl-vec3/normalize"),
                dot: e("gl-vec3/dot"),
                cross: e("gl-vec3/cross")
              },
              c = i(),
              d = i(),
              h = [0, 0, 0, 0],
              f = [[0, 0, 0], [0, 0, 0], [0, 0, 0]],
              p = [0, 0, 0];
            function m(e, t, n, r, i) {
              e[0] = t[0] * r + n[0] * i, e[1] = t[1] * r + n[1] * i, e[2] = t[2] * r + n[2] * i;
            }
            t.exports = function (e, t, n, i, g, v) {
              if (t || (t = [0, 0, 0]), n || (n = [0, 0, 0]), i || (i = [0, 0, 0]), g || (g = [0, 0, 0, 1]), v || (v = [0, 0, 0, 1]), !r(c, e)) return !1;
              if (o(d, c), d[3] = 0, d[7] = 0, d[11] = 0, d[15] = 1, Math.abs(a(d) < 1e-8)) return !1;
              var y,
                b,
                _,
                x,
                w,
                S,
                A,
                E = c[3],
                T = c[7],
                M = c[11],
                C = c[12],
                k = c[13],
                P = c[14],
                O = c[15];
              if (0 !== E || 0 !== T || 0 !== M) {
                if (h[0] = E, h[1] = T, h[2] = M, h[3] = O, !s(d, d)) return !1;
                l(d, d), y = g, _ = d, x = (b = h)[0], w = b[1], S = b[2], A = b[3], y[0] = _[0] * x + _[4] * w + _[8] * S + _[12] * A, y[1] = _[1] * x + _[5] * w + _[9] * S + _[13] * A, y[2] = _[2] * x + _[6] * w + _[10] * S + _[14] * A, y[3] = _[3] * x + _[7] * w + _[11] * S + _[15] * A;
              } else g[0] = g[1] = g[2] = 0, g[3] = 1;
              if (t[0] = C, t[1] = k, t[2] = P, function (e, t) {
                e[0][0] = t[0], e[0][1] = t[1], e[0][2] = t[2], e[1][0] = t[4], e[1][1] = t[5], e[1][2] = t[6], e[2][0] = t[8], e[2][1] = t[9], e[2][2] = t[10];
              }(f, c), n[0] = u.length(f[0]), u.normalize(f[0], f[0]), i[0] = u.dot(f[0], f[1]), m(f[1], f[1], f[0], 1, -i[0]), n[1] = u.length(f[1]), u.normalize(f[1], f[1]), i[0] /= n[1], i[1] = u.dot(f[0], f[2]), m(f[2], f[2], f[0], 1, -i[1]), i[2] = u.dot(f[1], f[2]), m(f[2], f[2], f[1], 1, -i[2]), n[2] = u.length(f[2]), u.normalize(f[2], f[2]), i[1] /= n[2], i[2] /= n[2], u.cross(p, f[1], f[2]), u.dot(f[0], p) < 0) for (var R = 0; R < 3; R++) n[R] *= -1, f[R][0] *= -1, f[R][1] *= -1, f[R][2] *= -1;
              return v[0] = .5 * Math.sqrt(Math.max(1 + f[0][0] - f[1][1] - f[2][2], 0)), v[1] = .5 * Math.sqrt(Math.max(1 - f[0][0] + f[1][1] - f[2][2], 0)), v[2] = .5 * Math.sqrt(Math.max(1 - f[0][0] - f[1][1] + f[2][2], 0)), v[3] = .5 * Math.sqrt(Math.max(1 + f[0][0] + f[1][1] + f[2][2], 0)), f[2][1] > f[1][2] && (v[0] = -v[0]), f[0][2] > f[2][0] && (v[1] = -v[1]), f[1][0] > f[0][1] && (v[2] = -v[2]), !0;
            };
          }, {
            "./normalize": 265,
            "gl-mat4/clone": 119,
            "gl-mat4/create": 120,
            "gl-mat4/determinant": 121,
            "gl-mat4/invert": 125,
            "gl-mat4/transpose": 136,
            "gl-vec3/cross": 175,
            "gl-vec3/dot": 180,
            "gl-vec3/length": 190,
            "gl-vec3/normalize": 197
          }],
          265: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = t[15];
              if (0 === n) return !1;
              for (var r = 1 / n, i = 0; i < 16; i++) e[i] = t[i] * r;
              return !0;
            };
          }, {}],
          266: [function (e, t, n) {
            var r = e("gl-vec3/lerp"),
              i = e("mat4-recompose"),
              o = e("mat4-decompose"),
              a = e("gl-mat4/determinant"),
              s = e("quat-slerp"),
              l = d(),
              u = d(),
              c = d();
            function d() {
              return {
                translate: h(),
                scale: h(1),
                skew: h(),
                perspective: [0, 0, 0, 1],
                quaternion: [0, 0, 0, 1]
              };
            }
            function h(e) {
              return [e || 0, e || 0, e || 0];
            }
            t.exports = function (e, t, n, d) {
              if (0 === a(t) || 0 === a(n)) return !1;
              var h = o(t, l.translate, l.scale, l.skew, l.perspective, l.quaternion),
                f = o(n, u.translate, u.scale, u.skew, u.perspective, u.quaternion);
              return !(!h || !f || (r(c.translate, l.translate, u.translate, d), r(c.skew, l.skew, u.skew, d), r(c.scale, l.scale, u.scale, d), r(c.perspective, l.perspective, u.perspective, d), s(c.quaternion, l.quaternion, u.quaternion, d), i(e, c.translate, c.scale, c.skew, c.perspective, c.quaternion), 0));
            };
          }, {
            "gl-mat4/determinant": 121,
            "gl-vec3/lerp": 191,
            "mat4-decompose": 264,
            "mat4-recompose": 267,
            "quat-slerp": 308
          }],
          267: [function (e, t, n) {
            var r = {
                identity: e("gl-mat4/identity"),
                translate: e("gl-mat4/translate"),
                multiply: e("gl-mat4/multiply"),
                create: e("gl-mat4/create"),
                scale: e("gl-mat4/scale"),
                fromRotationTranslation: e("gl-mat4/fromRotationTranslation")
              },
              i = (r.create(), r.create());
            t.exports = function (e, t, n, o, a, s) {
              return r.identity(e), r.fromRotationTranslation(e, s, t), e[3] = a[0], e[7] = a[1], e[11] = a[2], e[15] = a[3], r.identity(i), 0 !== o[2] && (i[9] = o[2], r.multiply(e, e, i)), 0 !== o[1] && (i[9] = 0, i[8] = o[1], r.multiply(e, e, i)), 0 !== o[0] && (i[8] = 0, i[4] = o[0], r.multiply(e, e, i)), r.scale(e, e, n), e;
            };
          }, {
            "gl-mat4/create": 120,
            "gl-mat4/fromRotationTranslation": 123,
            "gl-mat4/identity": 124,
            "gl-mat4/multiply": 127,
            "gl-mat4/scale": 134,
            "gl-mat4/translate": 135
          }],
          268: [function (e, t, n) {
            "use strict";

            var r = e("binary-search-bounds"),
              i = e("mat4-interpolate"),
              o = e("gl-mat4/invert"),
              a = e("gl-mat4/rotateX"),
              s = e("gl-mat4/rotateY"),
              l = e("gl-mat4/rotateZ"),
              u = e("gl-mat4/lookAt"),
              c = e("gl-mat4/translate"),
              d = (e("gl-mat4/scale"), e("gl-vec3/normalize")),
              h = [0, 0, 0];
            function f(e) {
              this._components = e.slice(), this._time = [0], this.prevMatrix = e.slice(), this.nextMatrix = e.slice(), this.computedMatrix = e.slice(), this.computedInverse = e.slice(), this.computedEye = [0, 0, 0], this.computedUp = [0, 0, 0], this.computedCenter = [0, 0, 0], this.computedRadius = [0], this._limits = [-1 / 0, 1 / 0];
            }
            t.exports = function (e) {
              return new f((e = e || {}).matrix || [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
            };
            var p = f.prototype;
            p.recalcMatrix = function (e) {
              var t = this._time,
                n = r.le(t, e),
                a = this.computedMatrix;
              if (!(n < 0)) {
                var s = this._components;
                if (n === t.length - 1) for (var l = 16 * n, u = 0; u < 16; ++u) a[u] = s[l++];else {
                  var c = t[n + 1] - t[n],
                    h = (l = 16 * n, this.prevMatrix),
                    f = !0;
                  for (u = 0; u < 16; ++u) h[u] = s[l++];
                  var p = this.nextMatrix;
                  for (u = 0; u < 16; ++u) p[u] = s[l++], f = f && h[u] === p[u];
                  if (c < 1e-6 || f) for (u = 0; u < 16; ++u) a[u] = h[u];else i(a, h, p, (e - t[n]) / c);
                }
                var m = this.computedUp;
                m[0] = a[1], m[1] = a[5], m[2] = a[9], d(m, m);
                var g = this.computedInverse;
                o(g, a);
                var v = this.computedEye,
                  y = g[15];
                v[0] = g[12] / y, v[1] = g[13] / y, v[2] = g[14] / y;
                var b = this.computedCenter,
                  _ = Math.exp(this.computedRadius[0]);
                for (u = 0; u < 3; ++u) b[u] = v[u] - a[2 + 4 * u] * _;
              }
            }, p.idle = function (e) {
              if (!(e < this.lastT())) {
                for (var t = this._components, n = t.length - 16, r = 0; r < 16; ++r) t.push(t[n++]);
                this._time.push(e);
              }
            }, p.flush = function (e) {
              var t = r.gt(this._time, e) - 2;
              t < 0 || (this._time.splice(0, t), this._components.splice(0, 16 * t));
            }, p.lastT = function () {
              return this._time[this._time.length - 1];
            }, p.lookAt = function (e, t, n, r) {
              this.recalcMatrix(e), t = t || this.computedEye, n = n || h, r = r || this.computedUp, this.setMatrix(e, u(this.computedMatrix, t, n, r));
              for (var i = 0, o = 0; o < 3; ++o) i += Math.pow(n[o] - t[o], 2);
              i = Math.log(Math.sqrt(i)), this.computedRadius[0] = i;
            }, p.rotate = function (e, t, n, r) {
              this.recalcMatrix(e);
              var i = this.computedInverse;
              t && s(i, i, t), n && a(i, i, n), r && l(i, i, r), this.setMatrix(e, o(this.computedMatrix, i));
            };
            var m = [0, 0, 0];
            p.pan = function (e, t, n, r) {
              m[0] = -(t || 0), m[1] = -(n || 0), m[2] = -(r || 0), this.recalcMatrix(e);
              var i = this.computedInverse;
              c(i, i, m), this.setMatrix(e, o(i, i));
            }, p.translate = function (e, t, n, r) {
              m[0] = t || 0, m[1] = n || 0, m[2] = r || 0, this.recalcMatrix(e);
              var i = this.computedMatrix;
              c(i, i, m), this.setMatrix(e, i);
            }, p.setMatrix = function (e, t) {
              if (!(e < this.lastT())) {
                this._time.push(e);
                for (var n = 0; n < 16; ++n) this._components.push(t[n]);
              }
            }, p.setDistance = function (e, t) {
              this.computedRadius[0] = t;
            }, p.setDistanceLimits = function (e, t) {
              var n = this._limits;
              n[0] = e, n[1] = t;
            }, p.getDistanceLimits = function (e) {
              var t = this._limits;
              return e ? (e[0] = t[0], e[1] = t[1], e) : t;
            };
          }, {
            "binary-search-bounds": 36,
            "gl-mat4/invert": 125,
            "gl-mat4/lookAt": 126,
            "gl-mat4/rotateX": 131,
            "gl-mat4/rotateY": 132,
            "gl-mat4/rotateZ": 133,
            "gl-mat4/scale": 134,
            "gl-mat4/translate": 135,
            "gl-vec3/normalize": 197,
            "mat4-interpolate": 266
          }],
          269: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.length;
              if (t < 3) {
                for (var n = new Array(t), i = 0; i < t; ++i) n[i] = i;
                return 2 === t && e[0][0] === e[1][0] && e[0][1] === e[1][1] ? [0] : n;
              }
              var o = new Array(t);
              for (i = 0; i < t; ++i) o[i] = i;
              o.sort(function (t, n) {
                return e[t][0] - e[n][0] || e[t][1] - e[n][1];
              });
              var a = [o[0], o[1]],
                s = [o[0], o[1]];
              for (i = 2; i < t; ++i) {
                for (var l = o[i], u = e[l], c = a.length; c > 1 && r(e[a[c - 2]], e[a[c - 1]], u) <= 0;) c -= 1, a.pop();
                for (a.push(l), c = s.length; c > 1 && r(e[s[c - 2]], e[s[c - 1]], u) >= 0;) c -= 1, s.pop();
                s.push(l);
              }
              n = new Array(s.length + a.length - 2);
              for (var d = 0, h = (i = 0, a.length); i < h; ++i) n[d++] = a[i];
              for (var f = s.length - 2; f > 0; --f) n[d++] = s[f];
              return n;
            };
            var r = e("robust-orientation")[3];
          }, {
            "robust-orientation": 321
          }],
          270: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              t || (t = e, e = window);
              var n = 0,
                i = 0,
                o = 0,
                a = {
                  shift: !1,
                  alt: !1,
                  control: !1,
                  meta: !1
                },
                s = !1;
              function l(e) {
                var t = !1;
                return "altKey" in e && (t = t || e.altKey !== a.alt, a.alt = !!e.altKey), "shiftKey" in e && (t = t || e.shiftKey !== a.shift, a.shift = !!e.shiftKey), "ctrlKey" in e && (t = t || e.ctrlKey !== a.control, a.control = !!e.ctrlKey), "metaKey" in e && (t = t || e.metaKey !== a.meta, a.meta = !!e.metaKey), t;
              }
              function u(e, s) {
                var u = r.x(s),
                  c = r.y(s);
                "buttons" in s && (e = 0 | s.buttons), (e !== n || u !== i || c !== o || l(s)) && (n = 0 | e, i = u || 0, o = c || 0, t && t(n, i, o, a));
              }
              function c(e) {
                u(0, e);
              }
              function d() {
                (n || i || o || a.shift || a.alt || a.meta || a.control) && (i = o = 0, n = 0, a.shift = a.alt = a.control = a.meta = !1, t && t(0, 0, 0, a));
              }
              function h(e) {
                l(e) && t && t(n, i, o, a);
              }
              function f(e) {
                0 === r.buttons(e) ? u(0, e) : u(n, e);
              }
              function p(e) {
                u(n | r.buttons(e), e);
              }
              function m(e) {
                u(n & ~r.buttons(e), e);
              }
              function g() {
                s || (s = !0, e.addEventListener("mousemove", f), e.addEventListener("mousedown", p), e.addEventListener("mouseup", m), e.addEventListener("mouseleave", c), e.addEventListener("mouseenter", c), e.addEventListener("mouseout", c), e.addEventListener("mouseover", c), e.addEventListener("blur", d), e.addEventListener("keyup", h), e.addEventListener("keydown", h), e.addEventListener("keypress", h), e !== window && (window.addEventListener("blur", d), window.addEventListener("keyup", h), window.addEventListener("keydown", h), window.addEventListener("keypress", h)));
              }
              g();
              var v = {
                element: e
              };
              return Object.defineProperties(v, {
                enabled: {
                  get: function get() {
                    return s;
                  },
                  set: function set(t) {
                    t ? g() : s && (s = !1, e.removeEventListener("mousemove", f), e.removeEventListener("mousedown", p), e.removeEventListener("mouseup", m), e.removeEventListener("mouseleave", c), e.removeEventListener("mouseenter", c), e.removeEventListener("mouseout", c), e.removeEventListener("mouseover", c), e.removeEventListener("blur", d), e.removeEventListener("keyup", h), e.removeEventListener("keydown", h), e.removeEventListener("keypress", h), e !== window && (window.removeEventListener("blur", d), window.removeEventListener("keyup", h), window.removeEventListener("keydown", h), window.removeEventListener("keypress", h)));
                  },
                  enumerable: !0
                },
                buttons: {
                  get: function get() {
                    return n;
                  },
                  enumerable: !0
                },
                x: {
                  get: function get() {
                    return i;
                  },
                  enumerable: !0
                },
                y: {
                  get: function get() {
                    return o;
                  },
                  enumerable: !0
                },
                mods: {
                  get: function get() {
                    return a;
                  },
                  enumerable: !0
                }
              }), v;
            };
            var r = e("mouse-event");
          }, {
            "mouse-event": 272
          }],
          271: [function (e, t, n) {
            var r = {
              left: 0,
              top: 0
            };
            t.exports = function (e, t, n) {
              t = t || e.currentTarget || e.srcElement, Array.isArray(n) || (n = [0, 0]);
              var i,
                o = e.clientX || 0,
                a = e.clientY || 0,
                s = (i = t) === window || i === document || i === document.body ? r : i.getBoundingClientRect();
              return n[0] = o - s.left, n[1] = a - s.top, n;
            };
          }, {}],
          272: [function (e, t, n) {
            "use strict";

            function r(e) {
              return e.target || e.srcElement || window;
            }
            n.buttons = function (e) {
              if ("object" == typeof e) {
                if ("buttons" in e) return e.buttons;
                if ("which" in e) {
                  if (2 === (t = e.which)) return 4;
                  if (3 === t) return 2;
                  if (t > 0) return 1 << t - 1;
                } else if ("button" in e) {
                  var t;
                  if (1 === (t = e.button)) return 4;
                  if (2 === t) return 2;
                  if (t >= 0) return 1 << t;
                }
              }
              return 0;
            }, n.element = r, n.x = function (e) {
              if ("object" == typeof e) {
                if ("offsetX" in e) return e.offsetX;
                var t = r(e).getBoundingClientRect();
                return e.clientX - t.left;
              }
              return 0;
            }, n.y = function (e) {
              if ("object" == typeof e) {
                if ("offsetY" in e) return e.offsetY;
                var t = r(e).getBoundingClientRect();
                return e.clientY - t.top;
              }
              return 0;
            };
          }, {}],
          273: [function (e, t, n) {
            "use strict";

            var r = e("to-px");
            t.exports = function (e, t, n) {
              "function" == typeof e && (n = !!t, t = e, e = window);
              var i = r("ex", e),
                o = function o(e) {
                  n && e.preventDefault();
                  var r = e.deltaX || 0,
                    o = e.deltaY || 0,
                    a = e.deltaZ || 0,
                    s = 1;
                  switch (e.deltaMode) {
                    case 1:
                      s = i;
                      break;
                    case 2:
                      s = window.innerHeight;
                  }
                  if (o *= s, a *= s, (r *= s) || o || a) return t(r, o, a, e);
                };
              return e.addEventListener("wheel", o), o;
            };
          }, {
            "to-px": 342
          }],
          274: [function (e, t, n) {
            "use strict";

            var r = e("typedarray-pool");
            function i(e) {
              return "a" + e;
            }
            function o(e) {
              return "d" + e;
            }
            function a(e, t) {
              return "c" + e + "_" + t;
            }
            function s(e) {
              return "s" + e;
            }
            function l(e, t) {
              return "t" + e + "_" + t;
            }
            function u(e) {
              return "o" + e;
            }
            function c(e) {
              return "x" + e;
            }
            function d(e) {
              return "p" + e;
            }
            function h(e, t) {
              return "d" + e + "_" + t;
            }
            function f(e) {
              return "i" + e;
            }
            function p(e, t) {
              return "u" + e + "_" + t;
            }
            function m(e) {
              return "b" + e;
            }
            function g(e) {
              return "y" + e;
            }
            function v(e) {
              return "e" + e;
            }
            function y(e) {
              return "v" + e;
            }
            t.exports = function (e) {
              function t(e) {
                throw new Error("ndarray-extract-contour: " + e);
              }
              "object" != typeof e && t("Must specify arguments");
              var n = e.order;
              Array.isArray(n) || t("Must specify order");
              var T = e.arrayArguments || 1;
              T < 1 && t("Must have at least one array argument");
              var M = e.scalarArguments || 0;
              M < 0 && t("Scalar arg count must be > 0"), "function" != typeof e.vertex && t("Must specify vertex creation function"), "function" != typeof e.cell && t("Must specify cell creation function"), "function" != typeof e.phase && t("Must specify phase function");
              for (var C = e.getters || [], k = new Array(T), P = 0; P < T; ++P) C.indexOf(P) >= 0 ? k[P] = !0 : k[P] = !1;
              return function (e, t, n, T, M, C) {
                var k = C.length,
                  P = M.length;
                if (P < 2) throw new Error("ndarray-extract-contour: Dimension must be at least 2");
                for (var O = "extractContour" + M.join("_"), R = [], I = [], j = [], N = 0; N < k; ++N) j.push(i(N));
                for (N = 0; N < T; ++N) j.push(c(N));
                for (N = 0; N < P; ++N) I.push(s(N) + "=" + i(0) + ".shape[" + N + "]|0");
                for (N = 0; N < k; ++N) {
                  I.push(o(N) + "=" + i(N) + ".data", u(N) + "=" + i(N) + ".offset|0");
                  for (var L = 0; L < P; ++L) I.push(l(N, L) + "=" + i(N) + ".stride[" + L + "]|0");
                }
                for (N = 0; N < k; ++N) for (I.push(d(N) + "=" + u(N)), I.push(a(N, 0)), L = 1; L < 1 << P; ++L) {
                  for (var D = [], B = 0; B < P; ++B) L & 1 << B && D.push("-" + l(N, B));
                  I.push(h(N, L) + "=(" + D.join("") + ")|0"), I.push(a(N, L) + "=0");
                }
                for (N = 0; N < k; ++N) for (L = 0; L < P; ++L) {
                  var F = [l(N, M[L])];
                  L > 0 && F.push(l(N, M[L - 1]) + "*" + s(M[L - 1])), I.push(p(N, M[L]) + "=(" + F.join("-") + ")|0");
                }
                for (N = 0; N < P; ++N) I.push(f(N) + "=0");
                I.push(x + "=0");
                var z = ["2"];
                for (N = P - 2; N >= 0; --N) z.push(s(M[N]));
                for (I.push(w + "=(" + z.join("*") + ")|0", _ + "=mallocUint32(" + w + ")", b + "=mallocUint32(" + w + ")", S + "=0"), I.push(m(0) + "=0"), L = 1; L < 1 << P; ++L) {
                  var U = [],
                    G = [];
                  for (B = 0; B < P; ++B) L & 1 << B && (0 === G.length ? U.push("1") : U.unshift(G.join("*"))), G.push(s(M[B]));
                  var V = "";
                  U[0].indexOf(s(M[P - 2])) < 0 && (V = "-");
                  var H = E(P, L, M);
                  I.push(v(H) + "=(-" + U.join("-") + ")|0", g(H) + "=(" + V + U.join("-") + ")|0", m(H) + "=0");
                }
                function q(e, t) {
                  R.push("for(", f(M[e]), "=", t, ";", f(M[e]), "<", s(M[e]), ";", "++", f(M[e]), "){");
                }
                function W(e) {
                  for (var t = 0; t < k; ++t) R.push(d(t), "+=", p(t, M[e]), ";");
                  R.push("}");
                }
                function $() {
                  for (var e = 1; e < 1 << P; ++e) R.push(A, "=", v(e), ";", v(e), "=", g(e), ";", g(e), "=", A, ";");
                }
                I.push(y(0) + "=0", A + "=0"), function e(t, n) {
                  if (t < 0) !function (e) {
                    for (var t = 0; t < k; ++t) C[t] ? R.push(a(t, 0), "=", o(t), ".get(", d(t), ");") : R.push(a(t, 0), "=", o(t), "[", d(t), "];");
                    var n = [];
                    for (t = 0; t < k; ++t) n.push(a(t, 0));
                    for (t = 0; t < T; ++t) n.push(c(t));
                    R.push(m(0), "=", _, "[", S, "]=phase(", n.join(), ");");
                    for (var r = 1; r < 1 << P; ++r) R.push(m(r), "=", _, "[", S, "+", v(r), "];");
                    var i = [];
                    for (r = 1; r < 1 << P; ++r) i.push("(" + m(0) + "!==" + m(r) + ")");
                    R.push("if(", i.join("||"), "){");
                    var s = [];
                    for (t = 0; t < P; ++t) s.push(f(t));
                    for (t = 0; t < k; ++t) for (s.push(a(t, 0)), r = 1; r < 1 << P; ++r) C[t] ? R.push(a(t, r), "=", o(t), ".get(", d(t), "+", h(t, r), ");") : R.push(a(t, r), "=", o(t), "[", d(t), "+", h(t, r), "];"), s.push(a(t, r));
                    for (t = 0; t < 1 << P; ++t) s.push(m(t));
                    for (t = 0; t < T; ++t) s.push(c(t));
                    R.push("vertex(", s.join(), ");", y(0), "=", b, "[", S, "]=", x, "++;");
                    var l = (1 << P) - 1,
                      u = m(l);
                    for (r = 0; r < P; ++r) if (0 == (e & ~(1 << r))) {
                      for (var p = l ^ 1 << r, g = m(p), w = [], A = p; A > 0; A = A - 1 & p) w.push(b + "[" + S + "+" + v(A) + "]");
                      for (w.push(y(0)), A = 0; A < k; ++A) 1 & r ? w.push(a(A, l), a(A, p)) : w.push(a(A, p), a(A, l));
                      for (1 & r ? w.push(u, g) : w.push(g, u), A = 0; A < T; ++A) w.push(c(A));
                      R.push("if(", u, "!==", g, "){", "face(", w.join(), ")}");
                    }
                    R.push("}", S, "+=1;");
                  }(n);else {
                    !function (e) {
                      for (var t = e - 1; t >= 0; --t) q(t, 0);
                      var n = [];
                      for (t = 0; t < k; ++t) C[t] ? n.push(o(t) + ".get(" + d(t) + ")") : n.push(o(t) + "[" + d(t) + "]");
                      for (t = 0; t < T; ++t) n.push(c(t));
                      for (R.push(_, "[", S, "++]=phase(", n.join(), ");"), t = 0; t < e; ++t) W(t);
                      for (var r = 0; r < k; ++r) R.push(d(r), "+=", p(r, M[e]), ";");
                    }(t), R.push("if(", s(M[t]), ">0){", f(M[t]), "=1;"), e(t - 1, n | 1 << M[t]);
                    for (var r = 0; r < k; ++r) R.push(d(r), "+=", p(r, M[t]), ";");
                    t === P - 1 && (R.push(S, "=0;"), $()), q(t, 2), e(t - 1, n), t === P - 1 && (R.push("if(", f(M[P - 1]), "&1){", S, "=0;}"), $()), W(t), R.push("}");
                  }
                }(P - 1, 0), R.push("freeUint32(", b, ");freeUint32(", _, ");");
                var X = ["'use strict';", "function ", O, "(", j.join(), "){", "var ", I.join(), ";", R.join(""), "}", "return ", O].join("");
                return new Function("vertex", "face", "phase", "mallocUint32", "freeUint32", X)(e, t, n, r.mallocUint32, r.freeUint32);
              }(e.vertex, e.cell, e.phase, M, n, k);
            };
            var b = "V",
              _ = "P",
              x = "N",
              w = "Q",
              S = "X",
              A = "T";
            function E(e, t, n) {
              for (var r = 0, i = 0; i < e; ++i) t & 1 << i && (r |= 1 << n[i]);
              return r;
            }
          }, {
            "typedarray-pool": 347
          }],
          275: [function (e, t, n) {
            "use strict";

            var r = e("cwise/lib/wrapper")({
              args: ["index", "array", "scalar"],
              pre: {
                body: "{}",
                args: [],
                thisVars: [],
                localVars: []
              },
              body: {
                body: "{_inline_37_arg1_=_inline_37_arg2_.apply(void 0,_inline_37_arg0_)}",
                args: [{
                  name: "_inline_37_arg0_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }, {
                  name: "_inline_37_arg1_",
                  lvalue: !0,
                  rvalue: !1,
                  count: 1
                }, {
                  name: "_inline_37_arg2_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                thisVars: [],
                localVars: []
              },
              post: {
                body: "{}",
                args: [],
                thisVars: [],
                localVars: []
              },
              debug: !1,
              funcName: "cwise",
              blockSize: 64
            });
            t.exports = function (e, t) {
              return r(e, t), e;
            };
          }, {
            "cwise/lib/wrapper": 81
          }],
          276: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              if (Array.isArray(n)) {
                if (n.length !== t.dimension) throw new Error("ndarray-gradient: invalid boundary conditions");
              } else n = r(t.dimension, "string" == typeof n ? n : "clamp");
              if (e.dimension !== t.dimension + 1) throw new Error("ndarray-gradient: output dimension must be +1 input dimension");
              if (e.shape[t.dimension] !== t.dimension) throw new Error("ndarray-gradient: output shape must match input shape");
              for (var i = 0; i < t.dimension; ++i) if (e.shape[i] !== t.shape[i]) throw new Error("ndarray-gradient: shape mismatch");
              return 0 === t.size ? e : t.dimension <= 0 ? (e.set(0), e) : function (e) {
                var t = e.join();
                if (v = a[t]) return v;
                var n = e.length,
                  r = ["function gradient(dst,src){var s=src.shape.slice();"];
                function i(t) {
                  for (var i = n - t.length, o = [], a = [], s = [], l = 0; l < n; ++l) t.indexOf(l + 1) >= 0 ? s.push("0") : t.indexOf(-(l + 1)) >= 0 ? s.push("s[" + l + "]-1") : (s.push("-1"), o.push("1"), a.push("s[" + l + "]-2"));
                  var u = ".lo(" + o.join() + ").hi(" + a.join() + ")";
                  if (0 === o.length && (u = ""), i > 0) {
                    for (r.push("if(1"), l = 0; l < n; ++l) t.indexOf(l + 1) >= 0 || t.indexOf(-(l + 1)) >= 0 || r.push("&&s[", l, "]>2");
                    for (r.push("){grad", i, "(src.pick(", s.join(), ")", u), l = 0; l < n; ++l) t.indexOf(l + 1) >= 0 || t.indexOf(-(l + 1)) >= 0 || r.push(",dst.pick(", s.join(), ",", l, ")", u);
                    r.push(");");
                  }
                  for (l = 0; l < t.length; ++l) {
                    var c = Math.abs(t[l]) - 1,
                      d = "dst.pick(" + s.join() + "," + c + ")" + u;
                    switch (e[c]) {
                      case "clamp":
                        var h = s.slice(),
                          f = s.slice();
                        t[l] < 0 ? h[c] = "s[" + c + "]-2" : f[c] = "1", 0 === i ? r.push("if(s[", c, "]>1){dst.set(", s.join(), ",", c, ",0.5*(src.get(", h.join(), ")-src.get(", f.join(), ")))}else{dst.set(", s.join(), ",", c, ",0)};") : r.push("if(s[", c, "]>1){diff(", d, ",src.pick(", h.join(), ")", u, ",src.pick(", f.join(), ")", u, ");}else{zero(", d, ");};");
                        break;
                      case "mirror":
                        0 === i ? r.push("dst.set(", s.join(), ",", c, ",0);") : r.push("zero(", d, ");");
                        break;
                      case "wrap":
                        var p = s.slice(),
                          m = s.slice();
                        t[l] < 0 ? (p[c] = "s[" + c + "]-2", m[c] = "0") : (p[c] = "s[" + c + "]-1", m[c] = "1"), 0 === i ? r.push("if(s[", c, "]>2){dst.set(", s.join(), ",", c, ",0.5*(src.get(", p.join(), ")-src.get(", m.join(), ")))}else{dst.set(", s.join(), ",", c, ",0)};") : r.push("if(s[", c, "]>2){diff(", d, ",src.pick(", p.join(), ")", u, ",src.pick(", m.join(), ")", u, ");}else{zero(", d, ");};");
                        break;
                      default:
                        throw new Error("ndarray-gradient: Invalid boundary condition");
                    }
                  }
                  i > 0 && r.push("};");
                }
                for (var s = 0; s < 1 << n; ++s) {
                  for (var d = [], h = 0; h < n; ++h) s & 1 << h && d.push(h + 1);
                  for (var f = 0; f < 1 << d.length; ++f) {
                    var p = d.slice();
                    for (h = 0; h < d.length; ++h) f & 1 << h && (p[h] = -p[h]);
                    i(p);
                  }
                }
                r.push("return dst;};return gradient");
                var m = ["diff", "zero"],
                  g = [l, u];
                for (s = 1; s <= n; ++s) m.push("grad" + s), g.push(c(s));
                m.push(r.join(""));
                var v = Function.apply(void 0, m).apply(void 0, g);
                return o[t] = v, v;
              }(n)(e, t);
            };
            var r = e("dup"),
              i = e("cwise-compiler"),
              o = {},
              a = {},
              s = {
                body: "",
                args: [],
                thisVars: [],
                localVars: []
              },
              l = i({
                args: ["array", "array", "array"],
                pre: s,
                post: s,
                body: {
                  args: [{
                    name: "out",
                    lvalue: !0,
                    rvalue: !1,
                    count: 1
                  }, {
                    name: "left",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "right",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }],
                  body: "out=0.5*(left-right)",
                  thisVars: [],
                  localVars: []
                },
                funcName: "cdiff"
              }),
              u = i({
                args: ["array"],
                pre: s,
                post: s,
                body: {
                  args: [{
                    name: "out",
                    lvalue: !0,
                    rvalue: !1,
                    count: 1
                  }],
                  body: "out=0",
                  thisVars: [],
                  localVars: []
                },
                funcName: "zero"
              });
            function c(e) {
              if (e in o) return o[e];
              for (var t = [], n = 0; n < e; ++n) t.push("out", n, "s=0.5*(inp", n, "l-inp", n, "r);");
              var a = ["array"],
                l = ["junk"];
              for (n = 0; n < e; ++n) {
                a.push("array"), l.push("out" + n + "s");
                var u = r(e);
                u[n] = -1, a.push({
                  array: 0,
                  offset: u.slice()
                }), u[n] = 1, a.push({
                  array: 0,
                  offset: u.slice()
                }), l.push("inp" + n + "l", "inp" + n + "r");
              }
              return o[e] = i({
                args: a,
                pre: s,
                post: s,
                body: {
                  body: t.join(""),
                  args: l.map(function (e) {
                    return {
                      name: e,
                      lvalue: 0 === e.indexOf("out"),
                      rvalue: 0 === e.indexOf("inp"),
                      count: "junk" !== e | 0
                    };
                  }),
                  thisVars: [],
                  localVars: []
                },
                funcName: "fdTemplate" + e
              });
            }
          }, {
            "cwise-compiler": 78,
            dup: 87
          }],
          277: [function (e, t, n) {
            "use strict";

            var r = e("ndarray-warp"),
              i = e("gl-matrix-invert");
            t.exports = function (e, t, n) {
              var o = t.dimension,
                a = i([], n);
              return r(e, t, function (e, t) {
                for (var n = 0; n < o; ++n) {
                  e[n] = a[(o + 1) * o + n];
                  for (var r = 0; r < o; ++r) e[n] += a[(o + 1) * r + n] * t[r];
                }
                var i = a[(o + 1) * (o + 1) - 1];
                for (r = 0; r < o; ++r) i += a[(o + 1) * r + o] * t[r];
                var s = 1 / i;
                for (n = 0; n < o; ++n) e[n] *= s;
                return e;
              }), e;
            };
          }, {
            "gl-matrix-invert": 137,
            "ndarray-warp": 284
          }],
          278: [function (e, t, n) {
            "use strict";

            function r(e, t) {
              var n = Math.floor(t),
                r = t - n,
                i = 0 <= n && n < e.shape[0],
                o = 0 <= n + 1 && n + 1 < e.shape[0];
              return (1 - r) * (i ? +e.get(n) : 0) + r * (o ? +e.get(n + 1) : 0);
            }
            function i(e, t, n) {
              var r = Math.floor(t),
                i = t - r,
                o = 0 <= r && r < e.shape[0],
                a = 0 <= r + 1 && r + 1 < e.shape[0],
                s = Math.floor(n),
                l = n - s,
                u = 0 <= s && s < e.shape[1],
                c = 0 <= s + 1 && s + 1 < e.shape[1],
                d = o && u ? e.get(r, s) : 0,
                h = o && c ? e.get(r, s + 1) : 0;
              return (1 - l) * ((1 - i) * d + i * (a && u ? e.get(r + 1, s) : 0)) + l * ((1 - i) * h + i * (a && c ? e.get(r + 1, s + 1) : 0));
            }
            function o(e, t, n, r) {
              var i = Math.floor(t),
                o = t - i,
                a = 0 <= i && i < e.shape[0],
                s = 0 <= i + 1 && i + 1 < e.shape[0],
                l = Math.floor(n),
                u = n - l,
                c = 0 <= l && l < e.shape[1],
                d = 0 <= l + 1 && l + 1 < e.shape[1],
                h = Math.floor(r),
                f = r - h,
                p = 0 <= h && h < e.shape[2],
                m = 0 <= h + 1 && h + 1 < e.shape[2],
                g = a && c && p ? e.get(i, l, h) : 0,
                v = a && d && p ? e.get(i, l + 1, h) : 0,
                y = s && c && p ? e.get(i + 1, l, h) : 0,
                b = s && d && p ? e.get(i + 1, l + 1, h) : 0,
                _ = a && c && m ? e.get(i, l, h + 1) : 0,
                x = a && d && m ? e.get(i, l + 1, h + 1) : 0;
              return (1 - f) * ((1 - u) * ((1 - o) * g + o * y) + u * ((1 - o) * v + o * b)) + f * ((1 - u) * ((1 - o) * _ + o * (s && c && m ? e.get(i + 1, l, h + 1) : 0)) + u * ((1 - o) * x + o * (s && d && m ? e.get(i + 1, l + 1, h + 1) : 0)));
            }
            t.exports = function (e, t, n, a) {
              switch (e.shape.length) {
                case 0:
                  return 0;
                case 1:
                  return r(e, t);
                case 2:
                  return i(e, t, n);
                case 3:
                  return o(e, t, n, a);
                default:
                  return function (e) {
                    var t,
                      n,
                      r = 0 | e.shape.length,
                      i = new Array(r),
                      o = new Array(r),
                      a = new Array(r),
                      s = new Array(r);
                    for (t = 0; t < r; ++t) n = +arguments[t + 1], i[t] = Math.floor(n), o[t] = n - i[t], a[t] = 0 <= i[t] && i[t] < e.shape[t], s[t] = 0 <= i[t] + 1 && i[t] + 1 < e.shape[t];
                    var l,
                      u,
                      c,
                      d = 0;
                    e: for (t = 0; t < 1 << r; ++t) {
                      for (u = 1, c = e.offset, l = 0; l < r; ++l) if (t & 1 << l) {
                        if (!s[l]) continue e;
                        u *= o[l], c += e.stride[l] * (i[l] + 1);
                      } else {
                        if (!a[l]) continue e;
                        u *= 1 - o[l], c += e.stride[l] * i[l];
                      }
                      d += u * e.data[c];
                    }
                    return d;
                  }.apply(void 0, arguments);
              }
            }, t.exports.d1 = r, t.exports.d2 = i, t.exports.d3 = o;
          }, {}],
          279: [function (e, t, n) {
            "use strict";

            var r = e("cwise-compiler"),
              i = {
                body: "",
                args: [],
                thisVars: [],
                localVars: []
              };
            function o(e) {
              if (!e) return i;
              for (var t = 0; t < e.args.length; ++t) {
                var n = e.args[t];
                e.args[t] = 0 === t ? {
                  name: n,
                  lvalue: !0,
                  rvalue: !!e.rvalue,
                  count: e.count || 1
                } : {
                  name: n,
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                };
              }
              return e.thisVars || (e.thisVars = []), e.localVars || (e.localVars = []), e;
            }
            function a(e) {
              for (var t = [], n = 0; n < e.args.length; ++n) t.push("a" + n);
              return new Function("P", ["return function ", e.funcName, "_ndarrayops(", t.join(","), ") {P(", t.join(","), ");return a0}"].join(""))(function (e) {
                return r({
                  args: e.args,
                  pre: o(e.pre),
                  body: o(e.body),
                  post: o(e.proc),
                  funcName: e.funcName
                });
              }(e));
            }
            var s = {
              add: "+",
              sub: "-",
              mul: "*",
              div: "/",
              mod: "%",
              band: "&",
              bor: "|",
              bxor: "^",
              lshift: "<<",
              rshift: ">>",
              rrshift: ">>>"
            };
            !function () {
              for (var e in s) {
                var t = s[e];
                n[e] = a({
                  args: ["array", "array", "array"],
                  body: {
                    args: ["a", "b", "c"],
                    body: "a=b" + t + "c"
                  },
                  funcName: e
                }), n[e + "eq"] = a({
                  args: ["array", "array"],
                  body: {
                    args: ["a", "b"],
                    body: "a" + t + "=b"
                  },
                  rvalue: !0,
                  funcName: e + "eq"
                }), n[e + "s"] = a({
                  args: ["array", "array", "scalar"],
                  body: {
                    args: ["a", "b", "s"],
                    body: "a=b" + t + "s"
                  },
                  funcName: e + "s"
                }), n[e + "seq"] = a({
                  args: ["array", "scalar"],
                  body: {
                    args: ["a", "s"],
                    body: "a" + t + "=s"
                  },
                  rvalue: !0,
                  funcName: e + "seq"
                });
              }
            }();
            var l = {
              not: "!",
              bnot: "~",
              neg: "-",
              recip: "1.0/"
            };
            !function () {
              for (var e in l) {
                var t = l[e];
                n[e] = a({
                  args: ["array", "array"],
                  body: {
                    args: ["a", "b"],
                    body: "a=" + t + "b"
                  },
                  funcName: e
                }), n[e + "eq"] = a({
                  args: ["array"],
                  body: {
                    args: ["a"],
                    body: "a=" + t + "a"
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: e + "eq"
                });
              }
            }();
            var u = {
              and: "&&",
              or: "||",
              eq: "===",
              neq: "!==",
              lt: "<",
              gt: ">",
              leq: "<=",
              geq: ">="
            };
            !function () {
              for (var e in u) {
                var t = u[e];
                n[e] = a({
                  args: ["array", "array", "array"],
                  body: {
                    args: ["a", "b", "c"],
                    body: "a=b" + t + "c"
                  },
                  funcName: e
                }), n[e + "s"] = a({
                  args: ["array", "array", "scalar"],
                  body: {
                    args: ["a", "b", "s"],
                    body: "a=b" + t + "s"
                  },
                  funcName: e + "s"
                }), n[e + "eq"] = a({
                  args: ["array", "array"],
                  body: {
                    args: ["a", "b"],
                    body: "a=a" + t + "b"
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: e + "eq"
                }), n[e + "seq"] = a({
                  args: ["array", "scalar"],
                  body: {
                    args: ["a", "s"],
                    body: "a=a" + t + "s"
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: e + "seq"
                });
              }
            }();
            var c = ["abs", "acos", "asin", "atan", "ceil", "cos", "exp", "floor", "log", "round", "sin", "sqrt", "tan"];
            !function () {
              for (var e = 0; e < c.length; ++e) {
                var t = c[e];
                n[t] = a({
                  args: ["array", "array"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b"],
                    body: "a=this_f(b)",
                    thisVars: ["this_f"]
                  },
                  funcName: t
                }), n[t + "eq"] = a({
                  args: ["array"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a"],
                    body: "a=this_f(a)",
                    thisVars: ["this_f"]
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: t + "eq"
                });
              }
            }();
            var d = ["max", "min", "atan2", "pow"];
            !function () {
              for (var e = 0; e < d.length; ++e) {
                var t = d[e];
                n[t] = a({
                  args: ["array", "array", "array"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b", "c"],
                    body: "a=this_f(b,c)",
                    thisVars: ["this_f"]
                  },
                  funcName: t
                }), n[t + "s"] = a({
                  args: ["array", "array", "scalar"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b", "c"],
                    body: "a=this_f(b,c)",
                    thisVars: ["this_f"]
                  },
                  funcName: t + "s"
                }), n[t + "eq"] = a({
                  args: ["array", "array"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b"],
                    body: "a=this_f(a,b)",
                    thisVars: ["this_f"]
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: t + "eq"
                }), n[t + "seq"] = a({
                  args: ["array", "scalar"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b"],
                    body: "a=this_f(a,b)",
                    thisVars: ["this_f"]
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: t + "seq"
                });
              }
            }();
            var h = ["atan2", "pow"];
            !function () {
              for (var e = 0; e < h.length; ++e) {
                var t = h[e];
                n[t + "op"] = a({
                  args: ["array", "array", "array"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b", "c"],
                    body: "a=this_f(c,b)",
                    thisVars: ["this_f"]
                  },
                  funcName: t + "op"
                }), n[t + "ops"] = a({
                  args: ["array", "array", "scalar"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b", "c"],
                    body: "a=this_f(c,b)",
                    thisVars: ["this_f"]
                  },
                  funcName: t + "ops"
                }), n[t + "opeq"] = a({
                  args: ["array", "array"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b"],
                    body: "a=this_f(b,a)",
                    thisVars: ["this_f"]
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: t + "opeq"
                }), n[t + "opseq"] = a({
                  args: ["array", "scalar"],
                  pre: {
                    args: [],
                    body: "this_f=Math." + t,
                    thisVars: ["this_f"]
                  },
                  body: {
                    args: ["a", "b"],
                    body: "a=this_f(b,a)",
                    thisVars: ["this_f"]
                  },
                  rvalue: !0,
                  count: 2,
                  funcName: t + "opseq"
                });
              }
            }(), n.any = r({
              args: ["array"],
              pre: i,
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                body: "if(a){return true}",
                localVars: [],
                thisVars: []
              },
              post: {
                args: [],
                localVars: [],
                thisVars: [],
                body: "return false"
              },
              funcName: "any"
            }), n.all = r({
              args: ["array"],
              pre: i,
              body: {
                args: [{
                  name: "x",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                body: "if(!x){return false}",
                localVars: [],
                thisVars: []
              },
              post: {
                args: [],
                localVars: [],
                thisVars: [],
                body: "return true"
              },
              funcName: "all"
            }), n.sum = r({
              args: ["array"],
              pre: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "this_s=0"
              },
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                body: "this_s+=a",
                localVars: [],
                thisVars: ["this_s"]
              },
              post: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "return this_s"
              },
              funcName: "sum"
            }), n.prod = r({
              args: ["array"],
              pre: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "this_s=1"
              },
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                body: "this_s*=a",
                localVars: [],
                thisVars: ["this_s"]
              },
              post: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "return this_s"
              },
              funcName: "prod"
            }), n.norm2squared = r({
              args: ["array"],
              pre: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "this_s=0"
              },
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }],
                body: "this_s+=a*a",
                localVars: [],
                thisVars: ["this_s"]
              },
              post: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "return this_s"
              },
              funcName: "norm2squared"
            }), n.norm2 = r({
              args: ["array"],
              pre: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "this_s=0"
              },
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }],
                body: "this_s+=a*a",
                localVars: [],
                thisVars: ["this_s"]
              },
              post: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "return Math.sqrt(this_s)"
              },
              funcName: "norm2"
            }), n.norminf = r({
              args: ["array"],
              pre: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "this_s=0"
              },
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 4
                }],
                body: "if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}",
                localVars: [],
                thisVars: ["this_s"]
              },
              post: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "return this_s"
              },
              funcName: "norminf"
            }), n.norm1 = r({
              args: ["array"],
              pre: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "this_s=0"
              },
              body: {
                args: [{
                  name: "a",
                  lvalue: !1,
                  rvalue: !0,
                  count: 3
                }],
                body: "this_s+=a<0?-a:a",
                localVars: [],
                thisVars: ["this_s"]
              },
              post: {
                args: [],
                localVars: [],
                thisVars: ["this_s"],
                body: "return this_s"
              },
              funcName: "norm1"
            }), n.sup = r({
              args: ["array"],
              pre: {
                body: "this_h=-Infinity",
                args: [],
                thisVars: ["this_h"],
                localVars: []
              },
              body: {
                body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
                args: [{
                  name: "_inline_1_arg0_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }],
                thisVars: ["this_h"],
                localVars: []
              },
              post: {
                body: "return this_h",
                args: [],
                thisVars: ["this_h"],
                localVars: []
              }
            }), n.inf = r({
              args: ["array"],
              pre: {
                body: "this_h=Infinity",
                args: [],
                thisVars: ["this_h"],
                localVars: []
              },
              body: {
                body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
                args: [{
                  name: "_inline_1_arg0_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }],
                thisVars: ["this_h"],
                localVars: []
              },
              post: {
                body: "return this_h",
                args: [],
                thisVars: ["this_h"],
                localVars: []
              }
            }), n.argmin = r({
              args: ["index", "array", "shape"],
              pre: {
                body: "{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
                args: [{
                  name: "_inline_0_arg0_",
                  lvalue: !1,
                  rvalue: !1,
                  count: 0
                }, {
                  name: "_inline_0_arg1_",
                  lvalue: !1,
                  rvalue: !1,
                  count: 0
                }, {
                  name: "_inline_0_arg2_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                thisVars: ["this_i", "this_v"],
                localVars: []
              },
              body: {
                body: "{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
                args: [{
                  name: "_inline_1_arg0_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }, {
                  name: "_inline_1_arg1_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }],
                thisVars: ["this_i", "this_v"],
                localVars: ["_inline_1_k"]
              },
              post: {
                body: "{return this_i}",
                args: [],
                thisVars: ["this_i"],
                localVars: []
              }
            }), n.argmax = r({
              args: ["index", "array", "shape"],
              pre: {
                body: "{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
                args: [{
                  name: "_inline_0_arg0_",
                  lvalue: !1,
                  rvalue: !1,
                  count: 0
                }, {
                  name: "_inline_0_arg1_",
                  lvalue: !1,
                  rvalue: !1,
                  count: 0
                }, {
                  name: "_inline_0_arg2_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                thisVars: ["this_i", "this_v"],
                localVars: []
              },
              body: {
                body: "{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
                args: [{
                  name: "_inline_1_arg0_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }, {
                  name: "_inline_1_arg1_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }],
                thisVars: ["this_i", "this_v"],
                localVars: ["_inline_1_k"]
              },
              post: {
                body: "{return this_i}",
                args: [],
                thisVars: ["this_i"],
                localVars: []
              }
            }), n.random = a({
              args: ["array"],
              pre: {
                args: [],
                body: "this_f=Math.random",
                thisVars: ["this_f"]
              },
              body: {
                args: ["a"],
                body: "a=this_f()",
                thisVars: ["this_f"]
              },
              funcName: "random"
            }), n.assign = a({
              args: ["array", "array"],
              body: {
                args: ["a", "b"],
                body: "a=b"
              },
              funcName: "assign"
            }), n.assigns = a({
              args: ["array", "scalar"],
              body: {
                args: ["a", "b"],
                body: "a=b"
              },
              funcName: "assigns"
            }), n.equals = r({
              args: ["array", "array"],
              pre: i,
              body: {
                args: [{
                  name: "x",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }, {
                  name: "y",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                body: "if(x!==y){return false}",
                localVars: [],
                thisVars: []
              },
              post: {
                args: [],
                localVars: [],
                thisVars: [],
                body: "return true"
              },
              funcName: "equals"
            });
          }, {
            "cwise-compiler": 78
          }],
          280: [function (e, t, n) {
            "use strict";

            var r = e("ndarray"),
              i = e("./doConvert.js");
            t.exports = function (e, t) {
              for (var n = [], o = e, a = 1; Array.isArray(o);) n.push(o.length), a *= o.length, o = o[0];
              return 0 === n.length ? r() : (t || (t = r(new Float64Array(a), n)), i(t, e), t);
            };
          }, {
            "./doConvert.js": 281,
            ndarray: 285
          }],
          281: [function (e, t, n) {
            t.exports = e("cwise-compiler")({
              args: ["array", "scalar", "index"],
              pre: {
                body: "{}",
                args: [],
                thisVars: [],
                localVars: []
              },
              body: {
                body: "{\nvar _inline_1_v=_inline_1_arg1_,_inline_1_i\nfor(_inline_1_i=0;_inline_1_i<_inline_1_arg2_.length-1;++_inline_1_i) {\n_inline_1_v=_inline_1_v[_inline_1_arg2_[_inline_1_i]]\n}\n_inline_1_arg0_=_inline_1_v[_inline_1_arg2_[_inline_1_arg2_.length-1]]\n}",
                args: [{
                  name: "_inline_1_arg0_",
                  lvalue: !0,
                  rvalue: !1,
                  count: 1
                }, {
                  name: "_inline_1_arg1_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }, {
                  name: "_inline_1_arg2_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 4
                }],
                thisVars: [],
                localVars: ["_inline_1_i", "_inline_1_v"]
              },
              post: {
                body: "{}",
                args: [],
                thisVars: [],
                localVars: []
              },
              funcName: "convert",
              blockSize: 64
            });
          }, {
            "cwise-compiler": 78
          }],
          282: [function (e, t, n) {
            "use strict";

            var r = e("typedarray-pool"),
              i = 32;
            function o(e) {
              switch (e) {
                case "uint8":
                  return [r.mallocUint8, r.freeUint8];
                case "uint16":
                  return [r.mallocUint16, r.freeUint16];
                case "uint32":
                  return [r.mallocUint32, r.freeUint32];
                case "int8":
                  return [r.mallocInt8, r.freeInt8];
                case "int16":
                  return [r.mallocInt16, r.freeInt16];
                case "int32":
                  return [r.mallocInt32, r.freeInt32];
                case "float32":
                  return [r.mallocFloat, r.freeFloat];
                case "float64":
                  return [r.mallocDouble, r.freeDouble];
                default:
                  return null;
              }
            }
            function a(e) {
              for (var t = [], n = 0; n < e; ++n) t.push("s" + n);
              for (n = 0; n < e; ++n) t.push("n" + n);
              for (n = 1; n < e; ++n) t.push("d" + n);
              for (n = 1; n < e; ++n) t.push("e" + n);
              for (n = 1; n < e; ++n) t.push("f" + n);
              return t;
            }
            t.exports = function (e, t) {
              var n = ["'use strict'"],
                r = ["ndarraySortWrapper", e.join("d"), t].join("");
              n.push(["function ", r, "(", ["array"].join(","), "){"].join(""));
              for (var s = ["data=array.data,offset=array.offset|0,shape=array.shape,stride=array.stride"], l = 0; l < e.length; ++l) s.push(["s", l, "=stride[", l, "]|0,n", l, "=shape[", l, "]|0"].join(""));
              var u = new Array(e.length),
                c = [];
              for (l = 0; l < e.length; ++l) 0 !== (f = e[l]) && (0 === c.length ? u[f] = "1" : u[f] = c.join("*"), c.push("n" + f));
              var d = -1,
                h = -1;
              for (l = 0; l < e.length; ++l) {
                var f,
                  p = e[l];
                0 !== p && (d > 0 ? s.push(["d", p, "=s", p, "-d", d, "*n", d].join("")) : s.push(["d", p, "=s", p].join("")), d = p), 0 != (f = e.length - 1 - l) && (h > 0 ? s.push(["e", f, "=s", f, "-e", h, "*n", h, ",f", f, "=", u[f], "-f", h, "*n", h].join("")) : s.push(["e", f, "=s", f, ",f", f, "=", u[f]].join("")), h = f);
              }
              n.push("var " + s.join(","));
              var m = ["0", "n0-1", "data", "offset"].concat(a(e.length));
              n.push(["if(n0<=", i, "){", "insertionSort(", m.join(","), ")}else{", "quickSort(", m.join(","), ")}"].join("")), n.push("}return " + r);
              var g = new Function("insertionSort", "quickSort", n.join("\n")),
                v = function (e, t) {
                  var n = ["'use strict'"],
                    r = ["ndarrayInsertionSort", e.join("d"), t].join(""),
                    i = ["left", "right", "data", "offset"].concat(a(e.length)),
                    s = o(t),
                    l = ["i,j,cptr,ptr=left*s0+offset"];
                  if (e.length > 1) {
                    for (var u = [], c = 1; c < e.length; ++c) l.push("i" + c), u.push("n" + c);
                    s ? l.push("scratch=malloc(" + u.join("*") + ")") : l.push("scratch=new Array(" + u.join("*") + ")"), l.push("dptr", "sptr", "a", "b");
                  } else l.push("scratch");
                  function d(e) {
                    return "generic" === t ? ["data.get(", e, ")"].join("") : ["data[", e, "]"].join("");
                  }
                  function h(e, n) {
                    return "generic" === t ? ["data.set(", e, ",", n, ")"].join("") : ["data[", e, "]=", n].join("");
                  }
                  if (n.push(["function ", r, "(", i.join(","), "){var ", l.join(",")].join(""), "for(i=left+1;i<=right;++i){", "j=i;ptr+=s0", "cptr=ptr"), e.length > 1) {
                    for (n.push("dptr=0;sptr=ptr"), c = e.length - 1; c >= 0; --c) 0 !== (f = e[c]) && n.push(["for(i", f, "=0;i", f, "<n", f, ";++i", f, "){"].join(""));
                    for (n.push("scratch[dptr++]=", d("sptr")), c = 0; c < e.length; ++c) 0 !== (f = e[c]) && n.push("sptr+=d" + f, "}");
                    for (n.push("__g:while(j--\x3eleft){", "dptr=0", "sptr=cptr-s0"), c = 1; c < e.length; ++c) 1 === c && n.push("__l:"), n.push(["for(i", c, "=0;i", c, "<n", c, ";++i", c, "){"].join(""));
                    for (n.push(["a=", d("sptr"), "\nb=scratch[dptr]\nif(a<b){break __g}\nif(a>b){break __l}"].join("")), c = e.length - 1; c >= 1; --c) n.push("sptr+=e" + c, "dptr+=f" + c, "}");
                    for (n.push("dptr=cptr;sptr=cptr-s0"), c = e.length - 1; c >= 0; --c) 0 !== (f = e[c]) && n.push(["for(i", f, "=0;i", f, "<n", f, ";++i", f, "){"].join(""));
                    for (n.push(h("dptr", d("sptr"))), c = 0; c < e.length; ++c) 0 !== (f = e[c]) && n.push(["dptr+=d", f, ";sptr+=d", f].join(""), "}");
                    for (n.push("cptr-=s0\n}"), n.push("dptr=cptr;sptr=0"), c = e.length - 1; c >= 0; --c) 0 !== (f = e[c]) && n.push(["for(i", f, "=0;i", f, "<n", f, ";++i", f, "){"].join(""));
                    for (n.push(h("dptr", "scratch[sptr++]")), c = 0; c < e.length; ++c) {
                      var f;
                      0 !== (f = e[c]) && n.push("dptr+=d" + f, "}");
                    }
                  } else n.push("scratch=" + d("ptr"), "while((j--\x3eleft)&&(" + d("cptr-s0") + ">scratch)){", h("cptr", d("cptr-s0")), "cptr-=s0", "}", h("cptr", "scratch"));
                  return n.push("}"), e.length > 1 && s && n.push("free(scratch)"), n.push("} return " + r), s ? new Function("malloc", "free", n.join("\n"))(s[0], s[1]) : new Function(n.join("\n"))();
                }(e, t),
                y = function (e, t, n) {
                  var r = ["'use strict'"],
                    s = ["ndarrayQuickSort", e.join("d"), t].join(""),
                    l = ["left", "right", "data", "offset"].concat(a(e.length)),
                    u = o(t),
                    c = 0;
                  r.push(["function ", s, "(", l.join(","), "){"].join(""));
                  var d = ["sixth=((right-left+1)/6)|0", "index1=left+sixth", "index5=right-sixth", "index3=(left+right)>>1", "index2=index3-sixth", "index4=index3+sixth", "el1=index1", "el2=index2", "el3=index3", "el4=index4", "el5=index5", "less=left+1", "great=right-1", "pivots_are_equal=true", "tmp", "tmp0", "x", "y", "z", "k", "ptr0", "ptr1", "ptr2", "comp_pivot1=0", "comp_pivot2=0", "comp=0"];
                  if (e.length > 1) {
                    for (var h = [], f = 1; f < e.length; ++f) h.push("n" + f), d.push("i" + f);
                    for (f = 0; f < 8; ++f) d.push("b_ptr" + f);
                    d.push("ptr3", "ptr4", "ptr5", "ptr6", "ptr7", "pivot_ptr", "ptr_shift", "elementSize=" + h.join("*")), u ? d.push("pivot1=malloc(elementSize)", "pivot2=malloc(elementSize)") : d.push("pivot1=new Array(elementSize),pivot2=new Array(elementSize)");
                  } else d.push("pivot1", "pivot2");
                  function p(e) {
                    return ["(offset+", e, "*s0)"].join("");
                  }
                  function m(e) {
                    return "generic" === t ? ["data.get(", e, ")"].join("") : ["data[", e, "]"].join("");
                  }
                  function g(e, n) {
                    return "generic" === t ? ["data.set(", e, ",", n, ")"].join("") : ["data[", e, "]=", n].join("");
                  }
                  function v(t, n, i) {
                    if (1 === t.length) r.push("ptr0=" + p(t[0]));else for (var o = 0; o < t.length; ++o) r.push(["b_ptr", o, "=s0*", t[o]].join(""));
                    for (n && r.push("pivot_ptr=0"), r.push("ptr_shift=offset"), o = e.length - 1; o >= 0; --o) 0 !== (a = e[o]) && r.push(["for(i", a, "=0;i", a, "<n", a, ";++i", a, "){"].join(""));
                    if (t.length > 1) for (o = 0; o < t.length; ++o) r.push(["ptr", o, "=b_ptr", o, "+ptr_shift"].join(""));
                    for (r.push(i), n && r.push("++pivot_ptr"), o = 0; o < e.length; ++o) {
                      var a;
                      0 !== (a = e[o]) && (t.length > 1 ? r.push("ptr_shift+=d" + a) : r.push("ptr0+=d" + a), r.push("}"));
                    }
                  }
                  function y(t, n, i, o) {
                    if (1 === n.length) r.push("ptr0=" + p(n[0]));else {
                      for (var a = 0; a < n.length; ++a) r.push(["b_ptr", a, "=s0*", n[a]].join(""));
                      r.push("ptr_shift=offset");
                    }
                    for (i && r.push("pivot_ptr=0"), t && r.push(t + ":"), a = 1; a < e.length; ++a) r.push(["for(i", a, "=0;i", a, "<n", a, ";++i", a, "){"].join(""));
                    if (n.length > 1) for (a = 0; a < n.length; ++a) r.push(["ptr", a, "=b_ptr", a, "+ptr_shift"].join(""));
                    for (r.push(o), a = e.length - 1; a >= 1; --a) i && r.push("pivot_ptr+=f" + a), n.length > 1 ? r.push("ptr_shift+=e" + a) : r.push("ptr0+=e" + a), r.push("}");
                  }
                  function b() {
                    e.length > 1 && u && r.push("free(pivot1)", "free(pivot2)");
                  }
                  function _(t, n) {
                    var i = "el" + t,
                      o = "el" + n;
                    if (e.length > 1) {
                      var a = "__l" + ++c;
                      y(a, [i, o], !1, ["comp=", m("ptr0"), "-", m("ptr1"), "\n", "if(comp>0){tmp0=", i, ";", i, "=", o, ";", o, "=tmp0;break ", a, "}\n", "if(comp<0){break ", a, "}"].join(""));
                    } else r.push(["if(", m(p(i)), ">", m(p(o)), "){tmp0=", i, ";", i, "=", o, ";", o, "=tmp0}"].join(""));
                  }
                  function x(t, n) {
                    e.length > 1 ? v([t, n], !1, g("ptr0", m("ptr1"))) : r.push(g(p(t), m(p(n))));
                  }
                  function w(t, n, i) {
                    if (e.length > 1) {
                      var o = "__l" + ++c;
                      y(o, [n], !0, [t, "=", m("ptr0"), "-pivot", i, "[pivot_ptr]\n", "if(", t, "!==0){break ", o, "}"].join(""));
                    } else r.push([t, "=", m(p(n)), "-pivot", i].join(""));
                  }
                  function S(t, n) {
                    e.length > 1 ? v([t, n], !1, ["tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", "tmp")].join("")) : r.push(["ptr0=", p(t), "\n", "ptr1=", p(n), "\n", "tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", "tmp")].join(""));
                  }
                  function A(t, n, i) {
                    e.length > 1 ? (v([t, n, i], !1, ["tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", m("ptr2")), "\n", g("ptr2", "tmp")].join("")), r.push("++" + n, "--" + i)) : r.push(["ptr0=", p(t), "\n", "ptr1=", p(n), "\n", "ptr2=", p(i), "\n", "++", n, "\n", "--", i, "\n", "tmp=", m("ptr0"), "\n", g("ptr0", m("ptr1")), "\n", g("ptr1", m("ptr2")), "\n", g("ptr2", "tmp")].join(""));
                  }
                  function E(e, t) {
                    S(e, t), r.push("--" + t);
                  }
                  function T(t, n, i) {
                    e.length > 1 ? v([t, n], !0, [g("ptr0", m("ptr1")), "\n", g("ptr1", ["pivot", i, "[pivot_ptr]"].join(""))].join("")) : r.push(g(p(t), m(p(n))), g(p(n), "pivot" + i));
                  }
                  function M(t, n) {
                    r.push(["if((", n, "-", t, ")<=", i, "){\n", "insertionSort(", t, ",", n, ",data,offset,", a(e.length).join(","), ")\n", "}else{\n", s, "(", t, ",", n, ",data,offset,", a(e.length).join(","), ")\n", "}"].join(""));
                  }
                  function C(t, n, i) {
                    e.length > 1 ? (r.push(["__l", ++c, ":while(true){"].join("")), v([t], !0, ["if(", m("ptr0"), "!==pivot", n, "[pivot_ptr]){break __l", c, "}"].join("")), r.push(i, "}")) : r.push(["while(", m(p(t)), "===pivot", n, "){", i, "}"].join(""));
                  }
                  return r.push("var " + d.join(",")), _(1, 2), _(4, 5), _(1, 3), _(2, 3), _(1, 4), _(3, 4), _(2, 5), _(2, 3), _(4, 5), e.length > 1 ? v(["el1", "el2", "el3", "el4", "el5", "index1", "index3", "index5"], !0, ["pivot1[pivot_ptr]=", m("ptr1"), "\n", "pivot2[pivot_ptr]=", m("ptr3"), "\n", "pivots_are_equal=pivots_are_equal&&(pivot1[pivot_ptr]===pivot2[pivot_ptr])\n", "x=", m("ptr0"), "\n", "y=", m("ptr2"), "\n", "z=", m("ptr4"), "\n", g("ptr5", "x"), "\n", g("ptr6", "y"), "\n", g("ptr7", "z")].join("")) : r.push(["pivot1=", m(p("el2")), "\n", "pivot2=", m(p("el4")), "\n", "pivots_are_equal=pivot1===pivot2\n", "x=", m(p("el1")), "\n", "y=", m(p("el3")), "\n", "z=", m(p("el5")), "\n", g(p("index1"), "x"), "\n", g(p("index3"), "y"), "\n", g(p("index5"), "z")].join("")), x("index2", "left"), x("index4", "right"), r.push("if(pivots_are_equal){"), r.push("for(k=less;k<=great;++k){"), w("comp", "k", 1), r.push("if(comp===0){continue}"), r.push("if(comp<0){"), r.push("if(k!==less){"), S("k", "less"), r.push("}"), r.push("++less"), r.push("}else{"), r.push("while(true){"), w("comp", "great", 1), r.push("if(comp>0){"), r.push("great--"), r.push("}else if(comp<0){"), A("k", "less", "great"), r.push("break"), r.push("}else{"), E("k", "great"), r.push("break"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), r.push("}else{"), r.push("for(k=less;k<=great;++k){"), w("comp_pivot1", "k", 1), r.push("if(comp_pivot1<0){"), r.push("if(k!==less){"), S("k", "less"), r.push("}"), r.push("++less"), r.push("}else{"), w("comp_pivot2", "k", 2), r.push("if(comp_pivot2>0){"), r.push("while(true){"), w("comp", "great", 2), r.push("if(comp>0){"), r.push("if(--great<k){break}"), r.push("continue"), r.push("}else{"), w("comp", "great", 1), r.push("if(comp<0){"), A("k", "less", "great"), r.push("}else{"), E("k", "great"), r.push("}"), r.push("break"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), T("left", "(less-1)", 1), T("right", "(great+1)", 2), M("left", "(less-2)"), M("(great+2)", "right"), r.push("if(pivots_are_equal){"), b(), r.push("return"), r.push("}"), r.push("if(less<index1&&great>index5){"), C("less", 1, "++less"), C("great", 2, "--great"), r.push("for(k=less;k<=great;++k){"), w("comp_pivot1", "k", 1), r.push("if(comp_pivot1===0){"), r.push("if(k!==less){"), S("k", "less"), r.push("}"), r.push("++less"), r.push("}else{"), w("comp_pivot2", "k", 2), r.push("if(comp_pivot2===0){"), r.push("while(true){"), w("comp", "great", 2), r.push("if(comp===0){"), r.push("if(--great<k){break}"), r.push("continue"), r.push("}else{"), w("comp", "great", 1), r.push("if(comp<0){"), A("k", "less", "great"), r.push("}else{"), E("k", "great"), r.push("}"), r.push("break"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), r.push("}"), b(), M("less", "great"), r.push("}return " + s), e.length > 1 && u ? new Function("insertionSort", "malloc", "free", r.join("\n"))(n, u[0], u[1]) : new Function("insertionSort", r.join("\n"))(n);
                }(e, t, v);
              return g(v, y);
            };
          }, {
            "typedarray-pool": 347
          }],
          283: [function (e, t, n) {
            "use strict";

            var r = e("./lib/compile_sort.js"),
              i = {};
            t.exports = function (e) {
              var t = e.order,
                n = e.dtype,
                o = [t, n].join(":"),
                a = i[o];
              return a || (i[o] = a = r(t, n)), a(e), e;
            };
          }, {
            "./lib/compile_sort.js": 282
          }],
          284: [function (e, t, n) {
            "use strict";

            var r = e("ndarray-linear-interpolate"),
              i = e("cwise/lib/wrapper")({
                args: ["index", "array", "scalar", "scalar", "scalar"],
                pre: {
                  body: "{this_warped=new Array(_inline_39_arg4_)}",
                  args: [{
                    name: "_inline_39_arg0_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                  }, {
                    name: "_inline_39_arg1_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                  }, {
                    name: "_inline_39_arg2_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                  }, {
                    name: "_inline_39_arg3_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                  }, {
                    name: "_inline_39_arg4_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                body: {
                  body: "{_inline_40_arg2_(this_warped,_inline_40_arg0_),_inline_40_arg1_=_inline_40_arg3_.apply(void 0,this_warped)}",
                  args: [{
                    name: "_inline_40_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_40_arg1_",
                    lvalue: !0,
                    rvalue: !1,
                    count: 1
                  }, {
                    name: "_inline_40_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_40_arg3_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_40_arg4_",
                    lvalue: !1,
                    rvalue: !1,
                    count: 0
                  }],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                post: {
                  body: "{}",
                  args: [],
                  thisVars: [],
                  localVars: []
                },
                debug: !1,
                funcName: "warpND",
                blockSize: 64
              }),
              o = e("cwise/lib/wrapper")({
                args: ["index", "array", "scalar", "scalar", "scalar"],
                pre: {
                  body: "{this_warped=[0]}",
                  args: [],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                body: {
                  body: "{_inline_43_arg2_(this_warped,_inline_43_arg0_),_inline_43_arg1_=_inline_43_arg3_(_inline_43_arg4_,this_warped[0])}",
                  args: [{
                    name: "_inline_43_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_43_arg1_",
                    lvalue: !0,
                    rvalue: !1,
                    count: 1
                  }, {
                    name: "_inline_43_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_43_arg3_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_43_arg4_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                post: {
                  body: "{}",
                  args: [],
                  thisVars: [],
                  localVars: []
                },
                debug: !1,
                funcName: "warp1D",
                blockSize: 64
              }),
              a = e("cwise/lib/wrapper")({
                args: ["index", "array", "scalar", "scalar", "scalar"],
                pre: {
                  body: "{this_warped=[0,0]}",
                  args: [],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                body: {
                  body: "{_inline_46_arg2_(this_warped,_inline_46_arg0_),_inline_46_arg1_=_inline_46_arg3_(_inline_46_arg4_,this_warped[0],this_warped[1])}",
                  args: [{
                    name: "_inline_46_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_46_arg1_",
                    lvalue: !0,
                    rvalue: !1,
                    count: 1
                  }, {
                    name: "_inline_46_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_46_arg3_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_46_arg4_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                post: {
                  body: "{}",
                  args: [],
                  thisVars: [],
                  localVars: []
                },
                debug: !1,
                funcName: "warp2D",
                blockSize: 64
              }),
              s = e("cwise/lib/wrapper")({
                args: ["index", "array", "scalar", "scalar", "scalar"],
                pre: {
                  body: "{this_warped=[0,0,0]}",
                  args: [],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                body: {
                  body: "{_inline_49_arg2_(this_warped,_inline_49_arg0_),_inline_49_arg1_=_inline_49_arg3_(_inline_49_arg4_,this_warped[0],this_warped[1],this_warped[2])}",
                  args: [{
                    name: "_inline_49_arg0_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_49_arg1_",
                    lvalue: !0,
                    rvalue: !1,
                    count: 1
                  }, {
                    name: "_inline_49_arg2_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_49_arg3_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }, {
                    name: "_inline_49_arg4_",
                    lvalue: !1,
                    rvalue: !0,
                    count: 1
                  }],
                  thisVars: ["this_warped"],
                  localVars: []
                },
                post: {
                  body: "{}",
                  args: [],
                  thisVars: [],
                  localVars: []
                },
                debug: !1,
                funcName: "warp3D",
                blockSize: 64
              });
            t.exports = function (e, t, n) {
              switch (t.shape.length) {
                case 1:
                  o(e, n, r.d1, t);
                  break;
                case 2:
                  a(e, n, r.d2, t);
                  break;
                case 3:
                  s(e, n, r.d3, t);
                  break;
                default:
                  i(e, n, r.bind(void 0, t), t.shape.length);
              }
              return e;
            };
          }, {
            "cwise/lib/wrapper": 81,
            "ndarray-linear-interpolate": 278
          }],
          285: [function (e, t, n) {
            var r = e("iota-array"),
              i = e("is-buffer"),
              o = "undefined" != typeof Float64Array;
            function a(e, t) {
              return e[0] - t[0];
            }
            function s() {
              var e,
                t = this.stride,
                n = new Array(t.length);
              for (e = 0; e < n.length; ++e) n[e] = [Math.abs(t[e]), e];
              n.sort(a);
              var r = new Array(n.length);
              for (e = 0; e < r.length; ++e) r[e] = n[e][1];
              return r;
            }
            function l(e, t) {
              var n = ["View", t, "d", e].join("");
              t < 0 && (n = "View_Nil" + e);
              var i = "generic" === e;
              if (-1 === t) {
                var o = "function " + n + "(a){this.data=a;};var proto=" + n + ".prototype;proto.dtype='" + e + "';proto.index=function(){return -1};proto.size=0;proto.dimension=-1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function(){return new " + n + "(this.data);};proto.get=proto.set=function(){};proto.pick=function(){return null};return function construct_" + n + "(a){return new " + n + "(a);}";
                return new Function(o)();
              }
              if (0 === t) return o = "function " + n + "(a,d) {this.data = a;this.offset = d};var proto=" + n + ".prototype;proto.dtype='" + e + "';proto.index=function(){return this.offset};proto.dimension=0;proto.size=1;proto.shape=proto.stride=proto.order=[];proto.lo=proto.hi=proto.transpose=proto.step=function " + n + "_copy() {return new " + n + "(this.data,this.offset)};proto.pick=function " + n + "_pick(){return TrivialArray(this.data);};proto.valueOf=proto.get=function " + n + "_get(){return " + (i ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};proto.set=function " + n + "_set(v){return " + (i ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "};return function construct_" + n + "(a,b,c,d){return new " + n + "(a,d)}", new Function("TrivialArray", o)(u[e][0]);
              o = ["'use strict'"];
              var a = r(t),
                l = a.map(function (e) {
                  return "i" + e;
                }),
                c = "this.offset+" + a.map(function (e) {
                  return "this.stride[" + e + "]*i" + e;
                }).join("+"),
                d = a.map(function (e) {
                  return "b" + e;
                }).join(","),
                h = a.map(function (e) {
                  return "c" + e;
                }).join(",");
              o.push("function " + n + "(a," + d + "," + h + ",d){this.data=a", "this.shape=[" + d + "]", "this.stride=[" + h + "]", "this.offset=d|0}", "var proto=" + n + ".prototype", "proto.dtype='" + e + "'", "proto.dimension=" + t), o.push("Object.defineProperty(proto,'size',{get:function " + n + "_size(){return " + a.map(function (e) {
                return "this.shape[" + e + "]";
              }).join("*"), "}})"), 1 === t ? o.push("proto.order=[0]") : (o.push("Object.defineProperty(proto,'order',{get:"), t < 4 ? (o.push("function " + n + "_order(){"), 2 === t ? o.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})") : 3 === t && o.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);if(s0>s1){if(s1>s2){return [2,1,0];}else if(s0>s2){return [1,2,0];}else{return [1,0,2];}}else if(s0>s2){return [2,0,1];}else if(s2>s1){return [0,1,2];}else{return [0,2,1];}}})")) : o.push("ORDER})")), o.push("proto.set=function " + n + "_set(" + l.join(",") + ",v){"), i ? o.push("return this.data.set(" + c + ",v)}") : o.push("return this.data[" + c + "]=v}"), o.push("proto.get=function " + n + "_get(" + l.join(",") + "){"), i ? o.push("return this.data.get(" + c + ")}") : o.push("return this.data[" + c + "]}"), o.push("proto.index=function " + n + "_index(", l.join(), "){return " + c + "}"), o.push("proto.hi=function " + n + "_hi(" + l.join(",") + "){return new " + n + "(this.data," + a.map(function (e) {
                return ["(typeof i", e, "!=='number'||i", e, "<0)?this.shape[", e, "]:i", e, "|0"].join("");
              }).join(",") + "," + a.map(function (e) {
                return "this.stride[" + e + "]";
              }).join(",") + ",this.offset)}");
              var f = a.map(function (e) {
                  return "a" + e + "=this.shape[" + e + "]";
                }),
                p = a.map(function (e) {
                  return "c" + e + "=this.stride[" + e + "]";
                });
              o.push("proto.lo=function " + n + "_lo(" + l.join(",") + "){var b=this.offset,d=0," + f.join(",") + "," + p.join(","));
              for (var m = 0; m < t; ++m) o.push("if(typeof i" + m + "==='number'&&i" + m + ">=0){d=i" + m + "|0;b+=c" + m + "*d;a" + m + "-=d}");
              for (o.push("return new " + n + "(this.data," + a.map(function (e) {
                return "a" + e;
              }).join(",") + "," + a.map(function (e) {
                return "c" + e;
              }).join(",") + ",b)}"), o.push("proto.step=function " + n + "_step(" + l.join(",") + "){var " + a.map(function (e) {
                return "a" + e + "=this.shape[" + e + "]";
              }).join(",") + "," + a.map(function (e) {
                return "b" + e + "=this.stride[" + e + "]";
              }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil"), m = 0; m < t; ++m) o.push("if(typeof i" + m + "==='number'){d=i" + m + "|0;if(d<0){c+=b" + m + "*(a" + m + "-1);a" + m + "=ceil(-a" + m + "/d)}else{a" + m + "=ceil(a" + m + "/d)}b" + m + "*=d}");
              o.push("return new " + n + "(this.data," + a.map(function (e) {
                return "a" + e;
              }).join(",") + "," + a.map(function (e) {
                return "b" + e;
              }).join(",") + ",c)}");
              var g = new Array(t),
                v = new Array(t);
              for (m = 0; m < t; ++m) g[m] = "a[i" + m + "]", v[m] = "b[i" + m + "]";
              for (o.push("proto.transpose=function " + n + "_transpose(" + l + "){" + l.map(function (e, t) {
                return e + "=(" + e + "===undefined?" + t + ":" + e + "|0)";
              }).join(";"), "var a=this.shape,b=this.stride;return new " + n + "(this.data," + g.join(",") + "," + v.join(",") + ",this.offset)}"), o.push("proto.pick=function " + n + "_pick(" + l + "){var a=[],b=[],c=this.offset"), m = 0; m < t; ++m) o.push("if(typeof i" + m + "==='number'&&i" + m + ">=0){c=(c+this.stride[" + m + "]*i" + m + ")|0}else{a.push(this.shape[" + m + "]);b.push(this.stride[" + m + "])}");
              return o.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}"), o.push("return function construct_" + n + "(data,shape,stride,offset){return new " + n + "(data," + a.map(function (e) {
                return "shape[" + e + "]";
              }).join(",") + "," + a.map(function (e) {
                return "stride[" + e + "]";
              }).join(",") + ",offset)}"), new Function("CTOR_LIST", "ORDER", o.join("\n"))(u[e], s);
            }
            var u = {
              float32: [],
              float64: [],
              int8: [],
              int16: [],
              int32: [],
              uint8: [],
              uint16: [],
              uint32: [],
              array: [],
              uint8_clamped: [],
              buffer: [],
              generic: []
            };
            t.exports = function (e, t, n, r) {
              if (void 0 === e) return (0, u.array[0])([]);
              "number" == typeof e && (e = [e]), void 0 === t && (t = [e.length]);
              var a = t.length;
              if (void 0 === n) {
                n = new Array(a);
                for (var s = a - 1, c = 1; s >= 0; --s) n[s] = c, c *= t[s];
              }
              if (void 0 === r) for (r = 0, s = 0; s < a; ++s) n[s] < 0 && (r -= (t[s] - 1) * n[s]);
              for (var d = function (e) {
                  if (i(e)) return "buffer";
                  if (o) switch (Object.prototype.toString.call(e)) {
                    case "[object Float64Array]":
                      return "float64";
                    case "[object Float32Array]":
                      return "float32";
                    case "[object Int8Array]":
                      return "int8";
                    case "[object Int16Array]":
                      return "int16";
                    case "[object Int32Array]":
                      return "int32";
                    case "[object Uint8Array]":
                      return "uint8";
                    case "[object Uint16Array]":
                      return "uint16";
                    case "[object Uint32Array]":
                      return "uint32";
                    case "[object Uint8ClampedArray]":
                      return "uint8_clamped";
                  }
                  return Array.isArray(e) ? "array" : "generic";
                }(e), h = u[d]; h.length <= a + 1;) h.push(l(d, h.length - 1));
              return (0, h[a + 1])(e, t, n, r);
            };
          }, {
            "iota-array": 256,
            "is-buffer": 258
          }],
          286: [function (e, t, n) {
            "use strict";

            var r = e("double-bits"),
              i = Math.pow(2, -1074),
              o = -1 >>> 0;
            t.exports = function (e, t) {
              if (isNaN(e) || isNaN(t)) return NaN;
              if (e === t) return e;
              if (0 === e) return t < 0 ? -i : i;
              var n = r.hi(e),
                a = r.lo(e);
              return t > e == e > 0 ? a === o ? (n += 1, a = 0) : a += 1 : 0 === a ? (a = o, n -= 1) : a -= 1, r.pack(a, n);
            };
          }, {
            "double-bits": 85
          }],
          287: [function (e, t, n) {
            n.vertexNormals = function (e, t, n) {
              for (var r = t.length, i = new Array(r), o = void 0 === n ? 1e-6 : n, a = 0; a < r; ++a) i[a] = [0, 0, 0];
              for (a = 0; a < e.length; ++a) for (var s = e[a], l = 0, u = s[s.length - 1], c = s[0], d = 0; d < s.length; ++d) {
                l = u, u = c, c = s[(d + 1) % s.length];
                for (var h = t[l], f = t[u], p = t[c], m = new Array(3), g = 0, v = new Array(3), y = 0, b = 0; b < 3; ++b) m[b] = h[b] - f[b], g += m[b] * m[b], v[b] = p[b] - f[b], y += v[b] * v[b];
                if (g * y > o) {
                  var _ = i[u],
                    x = 1 / Math.sqrt(g * y);
                  for (b = 0; b < 3; ++b) {
                    var w = (b + 1) % 3,
                      S = (b + 2) % 3;
                    _[b] += x * (v[w] * m[S] - v[S] * m[w]);
                  }
                }
              }
              for (a = 0; a < r; ++a) {
                _ = i[a];
                var A = 0;
                for (b = 0; b < 3; ++b) A += _[b] * _[b];
                if (A > o) for (x = 1 / Math.sqrt(A), b = 0; b < 3; ++b) _[b] *= x;else for (b = 0; b < 3; ++b) _[b] = 0;
              }
              return i;
            }, n.faceNormals = function (e, t, n) {
              for (var r = e.length, i = new Array(r), o = void 0 === n ? 1e-6 : n, a = 0; a < r; ++a) {
                for (var s = e[a], l = new Array(3), u = 0; u < 3; ++u) l[u] = t[s[u]];
                var c = new Array(3),
                  d = new Array(3);
                for (u = 0; u < 3; ++u) c[u] = l[1][u] - l[0][u], d[u] = l[2][u] - l[0][u];
                var h = new Array(3),
                  f = 0;
                for (u = 0; u < 3; ++u) {
                  var p = (u + 1) % 3,
                    m = (u + 2) % 3;
                  h[u] = c[p] * d[m] - c[m] * d[p], f += h[u] * h[u];
                }
                for (f = f > o ? 1 / Math.sqrt(f) : 0, u = 0; u < 3; ++u) h[u] *= f;
                i[a] = h;
              }
              return i;
            };
          }, {}],
          288: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, r, i, o, a, s, l, u) {
              var c = t + o + u;
              if (d > 0) {
                var d = Math.sqrt(c + 1);
                e[0] = .5 * (a - l) / d, e[1] = .5 * (s - r) / d, e[2] = .5 * (n - o) / d, e[3] = .5 * d;
              } else {
                var h = Math.max(t, o, u);
                d = Math.sqrt(2 * h - c + 1), t >= h ? (e[0] = .5 * d, e[1] = .5 * (i + n) / d, e[2] = .5 * (s + r) / d, e[3] = .5 * (a - l) / d) : o >= h ? (e[0] = .5 * (n + i) / d, e[1] = .5 * d, e[2] = .5 * (l + a) / d, e[3] = .5 * (s - r) / d) : (e[0] = .5 * (r + s) / d, e[1] = .5 * (a + l) / d, e[2] = .5 * d, e[3] = .5 * (n - i) / d);
              }
              return e;
            };
          }, {}],
          289: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = (e = e || {}).center || [0, 0, 0],
                n = e.rotation || [0, 0, 0, 1],
                r = e.radius || 1;
              t = [].slice.call(t, 0, 3), c(n = [].slice.call(n, 0, 4), n);
              var i = new d(n, t, Math.log(r));
              return i.setDistanceLimits(e.zoomMin, e.zoomMax), ("eye" in e || "up" in e) && i.lookAt(0, e.eye, e.center, e.up), i;
            };
            var r = e("filtered-vector"),
              i = e("gl-mat4/lookAt"),
              o = e("gl-mat4/fromQuat"),
              a = e("gl-mat4/invert"),
              s = e("./lib/quatFromFrame");
            function l(e, t, n) {
              return Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2) + Math.pow(n, 2));
            }
            function u(e, t, n, r) {
              return Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2) + Math.pow(n, 2) + Math.pow(r, 2));
            }
            function c(e, t) {
              var n = t[0],
                r = t[1],
                i = t[2],
                o = t[3],
                a = u(n, r, i, o);
              a > 1e-6 ? (e[0] = n / a, e[1] = r / a, e[2] = i / a, e[3] = o / a) : (e[0] = e[1] = e[2] = 0, e[3] = 1);
            }
            function d(e, t, n) {
              this.radius = r([n]), this.center = r(t), this.rotation = r(e), this.computedRadius = this.radius.curve(0), this.computedCenter = this.center.curve(0), this.computedRotation = this.rotation.curve(0), this.computedUp = [.1, 0, 0], this.computedEye = [.1, 0, 0], this.computedMatrix = [.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.recalcMatrix(0);
            }
            var h = d.prototype;
            h.lastT = function () {
              return Math.max(this.radius.lastT(), this.center.lastT(), this.rotation.lastT());
            }, h.recalcMatrix = function (e) {
              this.radius.curve(e), this.center.curve(e), this.rotation.curve(e);
              var t = this.computedRotation;
              c(t, t);
              var n = this.computedMatrix;
              o(n, t);
              var r = this.computedCenter,
                i = this.computedEye,
                a = this.computedUp,
                s = Math.exp(this.computedRadius[0]);
              i[0] = r[0] + s * n[2], i[1] = r[1] + s * n[6], i[2] = r[2] + s * n[10], a[0] = n[1], a[1] = n[5], a[2] = n[9];
              for (var l = 0; l < 3; ++l) {
                for (var u = 0, d = 0; d < 3; ++d) u += n[l + 4 * d] * i[d];
                n[12 + l] = -u;
              }
            }, h.getMatrix = function (e, t) {
              this.recalcMatrix(e);
              var n = this.computedMatrix;
              if (t) {
                for (var r = 0; r < 16; ++r) t[r] = n[r];
                return t;
              }
              return n;
            }, h.idle = function (e) {
              this.center.idle(e), this.radius.idle(e), this.rotation.idle(e);
            }, h.flush = function (e) {
              this.center.flush(e), this.radius.flush(e), this.rotation.flush(e);
            }, h.pan = function (e, t, n, r) {
              t = t || 0, n = n || 0, r = r || 0, this.recalcMatrix(e);
              var i = this.computedMatrix,
                o = i[1],
                a = i[5],
                s = i[9],
                u = l(o, a, s);
              o /= u, a /= u, s /= u;
              var c = i[0],
                d = i[4],
                h = i[8],
                f = c * o + d * a + h * s,
                p = l(c -= o * f, d -= a * f, h -= s * f);
              c /= p, d /= p, h /= p;
              var m = i[2],
                g = i[6],
                v = i[10],
                y = m * o + g * a + v * s,
                b = m * c + g * d + v * h,
                _ = l(m -= y * o + b * c, g -= y * a + b * d, v -= y * s + b * h);
              m /= _, g /= _, v /= _;
              var x = c * t + o * n,
                w = d * t + a * n,
                S = h * t + s * n;
              this.center.move(e, x, w, S);
              var A = Math.exp(this.computedRadius[0]);
              A = Math.max(1e-4, A + r), this.radius.set(e, Math.log(A));
            }, h.rotate = function (e, t, n, r) {
              this.recalcMatrix(e), t = t || 0, n = n || 0;
              var i = this.computedMatrix,
                o = i[0],
                a = i[4],
                s = i[8],
                c = i[1],
                d = i[5],
                h = i[9],
                f = i[2],
                p = i[6],
                m = i[10],
                g = t * o + n * c,
                v = t * a + n * d,
                y = t * s + n * h,
                b = -(p * y - m * v),
                _ = -(m * g - f * y),
                x = -(f * v - p * g),
                w = Math.sqrt(Math.max(0, 1 - Math.pow(b, 2) - Math.pow(_, 2) - Math.pow(x, 2))),
                S = u(b, _, x, w);
              S > 1e-6 ? (b /= S, _ /= S, x /= S, w /= S) : (b = _ = x = 0, w = 1);
              var A = this.computedRotation,
                E = A[0],
                T = A[1],
                M = A[2],
                C = A[3],
                k = E * w + C * b + T * x - M * _,
                P = T * w + C * _ + M * b - E * x,
                O = M * w + C * x + E * _ - T * b,
                R = C * w - E * b - T * _ - M * x;
              if (r) {
                b = f, _ = p, x = m;
                var I = Math.sin(r) / l(b, _, x);
                b *= I, _ *= I, x *= I, R = R * (w = Math.cos(t)) - (k = k * w + R * b + P * x - O * _) * b - (P = P * w + R * _ + O * b - k * x) * _ - (O = O * w + R * x + k * _ - P * b) * x;
              }
              var j = u(k, P, O, R);
              j > 1e-6 ? (k /= j, P /= j, O /= j, R /= j) : (k = P = O = 0, R = 1), this.rotation.set(e, k, P, O, R);
            }, h.lookAt = function (e, t, n, r) {
              this.recalcMatrix(e), n = n || this.computedCenter, t = t || this.computedEye, r = r || this.computedUp;
              var o = this.computedMatrix;
              i(o, t, n, r);
              var a = this.computedRotation;
              s(a, o[0], o[1], o[2], o[4], o[5], o[6], o[8], o[9], o[10]), c(a, a), this.rotation.set(e, a[0], a[1], a[2], a[3]);
              for (var l = 0, u = 0; u < 3; ++u) l += Math.pow(n[u] - t[u], 2);
              this.radius.set(e, .5 * Math.log(Math.max(l, 1e-6))), this.center.set(e, n[0], n[1], n[2]);
            }, h.translate = function (e, t, n, r) {
              this.center.move(e, t || 0, n || 0, r || 0);
            }, h.setMatrix = function (e, t) {
              var n = this.computedRotation;
              s(n, t[0], t[1], t[2], t[4], t[5], t[6], t[8], t[9], t[10]), c(n, n), this.rotation.set(e, n[0], n[1], n[2], n[3]);
              var r = this.computedMatrix;
              a(r, t);
              var i = r[15];
              if (Math.abs(i) > 1e-6) {
                var o = r[12] / i,
                  l = r[13] / i,
                  u = r[14] / i;
                this.recalcMatrix(e);
                var d = Math.exp(this.computedRadius[0]);
                this.center.set(e, o - r[2] * d, l - r[6] * d, u - r[10] * d), this.radius.idle(e);
              } else this.center.idle(e), this.radius.idle(e);
            }, h.setDistance = function (e, t) {
              t > 0 && this.radius.set(e, Math.log(t));
            }, h.setDistanceLimits = function (e, t) {
              e = e > 0 ? Math.log(e) : -1 / 0, t = t > 0 ? Math.log(t) : 1 / 0, t = Math.max(t, e), this.radius.bounds[0][0] = e, this.radius.bounds[1][0] = t;
            }, h.getDistanceLimits = function (e) {
              var t = this.radius.bounds;
              return e ? (e[0] = Math.exp(t[0][0]), e[1] = Math.exp(t[1][0]), e) : [Math.exp(t[0][0]), Math.exp(t[1][0])];
            }, h.toJSON = function () {
              return this.recalcMatrix(this.lastT()), {
                center: this.computedCenter.slice(),
                rotation: this.computedRotation.slice(),
                distance: Math.log(this.computedRadius[0]),
                zoomMin: this.radius.bounds[0][0],
                zoomMax: this.radius.bounds[1][0]
              };
            }, h.fromJSON = function (e) {
              var t = this.lastT(),
                n = e.center;
              n && this.center.set(t, n[0], n[1], n[2]);
              var r = e.rotation;
              r && this.rotation.set(t, r[0], r[1], r[2], r[3]);
              var i = e.distance;
              i && i > 0 && this.radius.set(t, Math.log(i)), this.setDistanceLimits(e.zoomMin, e.zoomMax);
            };
          }, {
            "./lib/quatFromFrame": 288,
            "filtered-vector": 92,
            "gl-mat4/fromQuat": 122,
            "gl-mat4/invert": 125,
            "gl-mat4/lookAt": 126
          }],
          290: [function (e, t, n) {
            "use strict";

            var r = e("repeat-string");
            t.exports = function (e, t, n) {
              return r(n = void 0 !== n ? n + "" : " ", t) + e;
            };
          }, {
            "repeat-string": 314
          }],
          291: [function (e, t, n) {
            t.exports = function (e, t) {
              t || (t = [0, ""]), e = String(e);
              var n = parseFloat(e, 10);
              return t[0] = n, t[1] = e.match(/[\d.\-\+]*\s*(.*)/)[1] || "", t;
            };
          }, {}],
          292: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.length;
              if (t < r) {
                for (var n = 1, o = 0; o < t; ++o) for (var a = 0; a < o; ++a) if (e[o] < e[a]) n = -n;else if (e[o] === e[a]) return 0;
                return n;
              }
              var s = i.mallocUint8(t);
              for (o = 0; o < t; ++o) s[o] = 0;
              for (n = 1, o = 0; o < t; ++o) if (!s[o]) {
                var l = 1;
                for (s[o] = 1, a = e[o]; a !== o; a = e[a]) {
                  if (s[a]) return i.freeUint8(s), 0;
                  l += 1, s[a] = 1;
                }
                1 & l || (n = -n);
              }
              return i.freeUint8(s), n;
            };
            var r = 32,
              i = e("typedarray-pool");
          }, {
            "typedarray-pool": 347
          }],
          293: [function (e, t, n) {
            "use strict";

            var r = e("typedarray-pool"),
              i = e("invert-permutation");
            n.rank = function (e) {
              var t = e.length;
              switch (t) {
                case 0:
                case 1:
                  return 0;
                case 2:
                  return e[1];
              }
              var n,
                o,
                a,
                s = r.mallocUint32(t),
                l = r.mallocUint32(t),
                u = 0;
              for (i(e, l), a = 0; a < t; ++a) s[a] = e[a];
              for (a = t - 1; a > 0; --a) o = l[a], n = s[a], s[a] = s[o], s[o] = n, l[a] = l[n], l[n] = o, u = (u + n) * a;
              return r.freeUint32(l), r.freeUint32(s), u;
            }, n.unrank = function (e, t, n) {
              switch (e) {
                case 0:
                  return n || [];
                case 1:
                  return n ? (n[0] = 0, n) : [0];
                case 2:
                  return n ? (t ? (n[0] = 0, n[1] = 1) : (n[0] = 1, n[1] = 0), n) : t ? [0, 1] : [1, 0];
              }
              var r,
                i,
                o,
                a = 1;
              for ((n = n || new Array(e))[0] = 0, o = 1; o < e; ++o) n[o] = o, a = a * o | 0;
              for (o = e - 1; o > 0; --o) t = t - (r = t / a | 0) * a | 0, a = a / o | 0, i = 0 | n[o], n[o] = 0 | n[r], n[r] = 0 | i;
              return n;
            };
          }, {
            "invert-permutation": 255,
            "typedarray-pool": 347
          }],
          294: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              for (var n = 0 | t.length, i = e.length, o = [new Array(n), new Array(n)], a = 0; a < n; ++a) o[0][a] = [], o[1][a] = [];
              for (a = 0; a < i; ++a) {
                var s = e[a];
                o[0][s[0]].push(s), o[1][s[1]].push(s);
              }
              var l = [];
              for (a = 0; a < n; ++a) o[0][a].length + o[1][a].length === 0 && l.push([a]);
              function u(e, t) {
                var n = o[t][e[t]];
                n.splice(n.indexOf(e), 1);
              }
              function c(e, n, i) {
                for (var a, s, l, c = 0; c < 2; ++c) if (o[c][n].length > 0) {
                  a = o[c][n][0], l = c;
                  break;
                }
                s = a[1 ^ l];
                for (var d = 0; d < 2; ++d) for (var h = o[d][n], f = 0; f < h.length; ++f) {
                  var p = h[f],
                    m = p[1 ^ d];
                  r(t[e], t[n], t[s], t[m]) > 0 && (a = p, s = m, l = d);
                }
                return i || a && u(a, l), s;
              }
              function d(e, n) {
                var i = o[n][e][0],
                  a = [e];
                u(i, n);
                for (var s = i[1 ^ n];;) {
                  for (; s !== e;) a.push(s), s = c(a[a.length - 2], s, !1);
                  if (o[0][e].length + o[1][e].length === 0) break;
                  var l = a[a.length - 1],
                    d = e,
                    h = a[1],
                    f = c(l, d, !0);
                  if (r(t[l], t[d], t[h], t[f]) < 0) break;
                  a.push(e), s = c(l, d);
                }
                return a;
              }
              function h(e, t) {
                return t[1] === t[t.length - 1];
              }
              for (a = 0; a < n; ++a) for (var f = 0; f < 2; ++f) {
                for (var p = []; o[f][a].length > 0;) {
                  o[0][a].length;
                  var m = d(a, f);
                  h(0, m) ? p.push.apply(p, m) : (p.length > 0 && l.push(p), p = m);
                }
                p.length > 0 && l.push(p);
              }
              return l;
            };
            var r = e("compare-angle");
          }, {
            "compare-angle": 70
          }],
          295: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              for (var n = r(e, t.length), i = new Array(t.length), o = new Array(t.length), a = [], s = 0; s < t.length; ++s) {
                var l = n[s].length;
                o[s] = l, i[s] = !0, l <= 1 && a.push(s);
              }
              for (; a.length > 0;) {
                i[f = a.pop()] = !1;
                var u = n[f];
                for (s = 0; s < u.length; ++s) {
                  var c = u[s];
                  0 == --o[c] && a.push(c);
                }
              }
              var d = new Array(t.length),
                h = [];
              for (s = 0; s < t.length; ++s) if (i[s]) {
                var f = h.length;
                d[s] = f, h.push(t[s]);
              } else d[s] = -1;
              var p = [];
              for (s = 0; s < e.length; ++s) {
                var m = e[s];
                i[m[0]] && i[m[1]] && p.push([d[m[0]], d[m[1]]]);
              }
              return [p, h];
            };
            var r = e("edges-to-adjacency-list");
          }, {
            "edges-to-adjacency-list": 88
          }],
          296: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              e = (D = u(e, t))[0];
              for (var n = (t = D[1]).length, d = (e.length, r(e, t.length)), h = 0; h < n; ++h) if (d[h].length % 2 == 1) throw new Error("planar-graph-to-polyline: graph must be manifold");
              var f = i(e, t),
                p = (f = f.filter(function (e) {
                  for (var n = e.length, r = [0], i = 0; i < n; ++i) {
                    var o = t[e[i]],
                      l = t[e[(i + 1) % n]],
                      u = a(-o[0], o[1]),
                      c = a(-o[0], l[1]),
                      d = a(l[0], o[1]),
                      h = a(l[0], l[1]);
                    r = s(r, s(s(u, c), s(d, h)));
                  }
                  return r[r.length - 1] > 0;
                })).length,
                m = new Array(p),
                g = new Array(p);
              for (h = 0; h < p; ++h) {
                m[h] = h;
                var v = new Array(p),
                  y = f[h].map(function (e) {
                    return t[e];
                  }),
                  b = o([y]),
                  _ = 0;
                e: for (var x = 0; x < p; ++x) if (v[x] = 0, h !== x) {
                  for (var w = (V = f[x]).length, S = 0; S < w; ++S) {
                    var A = b(t[V[S]]);
                    if (0 !== A) {
                      A < 0 && (v[x] = 1, _ += 1);
                      continue e;
                    }
                  }
                  v[x] = 1, _ += 1;
                }
                g[h] = [_, h, v];
              }
              for (g.sort(function (e, t) {
                return t[0] - e[0];
              }), h = 0; h < p; ++h) {
                var E = (v = g[h])[1],
                  T = v[2];
                for (x = 0; x < p; ++x) T[x] && (m[x] = E);
              }
              var M = function (e) {
                for (var t = new Array(e), n = 0; n < e; ++n) t[n] = [];
                return t;
              }(p);
              for (h = 0; h < p; ++h) M[h].push(m[h]), M[m[h]].push(h);
              var C = {},
                k = c(n, !1);
              for (h = 0; h < p; ++h) for (w = (V = f[h]).length, x = 0; x < w; ++x) {
                var P = V[x],
                  O = V[(x + 1) % w],
                  R = Math.min(P, O) + ":" + Math.max(P, O);
                if (R in C) {
                  var I = C[R];
                  M[I].push(h), M[h].push(I), k[P] = k[O] = !0;
                } else C[R] = h;
              }
              function j(e) {
                for (var t = e.length, n = 0; n < t; ++n) if (!k[e[n]]) return !1;
                return !0;
              }
              var N = [],
                L = c(p, -1);
              for (h = 0; h < p; ++h) m[h] !== h || j(f[h]) ? L[h] = -1 : (N.push(h), L[h] = 0);
              for (var D = []; N.length > 0;) {
                var B = N.pop(),
                  F = M[B];
                l(F, function (e, t) {
                  return e - t;
                });
                var z,
                  U = F.length,
                  G = L[B];
                for (0 === G && (z = [V = f[B]]), h = 0; h < U; ++h) {
                  var V,
                    H = F[h];
                  L[H] >= 0 || (L[H] = 1 ^ G, N.push(H), 0 !== G) || j(V = f[H]) || (V.reverse(), z.push(V));
                }
                0 === G && D.push(z);
              }
              return D;
            };
            var r = e("edges-to-adjacency-list"),
              i = e("planar-dual"),
              o = e("point-in-big-polygon"),
              a = e("two-product"),
              s = e("robust-sum"),
              l = e("uniq"),
              u = e("./lib/trim-leaves");
            function c(e, t) {
              for (var n = new Array(e), r = 0; r < e; ++r) n[r] = t;
              return n;
            }
          }, {
            "./lib/trim-leaves": 295,
            "edges-to-adjacency-list": 88,
            "planar-dual": 294,
            "point-in-big-polygon": 297,
            "robust-sum": 326,
            "two-product": 345,
            uniq: 349
          }],
          297: [function (e, t, n) {
            t.exports = function (e) {
              for (var t = e.length, n = [], o = [], s = 0; s < t; ++s) for (var c = e[s], d = c.length, h = d - 1, f = 0; f < d; h = f++) {
                var p = c[h],
                  m = c[f];
                p[0] === m[0] ? o.push([p, m]) : n.push([p, m]);
              }
              if (0 === n.length) return 0 === o.length ? u : (g = l(o), function (e) {
                return g(e[0], e[1]) ? 0 : 1;
              });
              var g,
                v = i(n),
                y = function (e, t) {
                  return function (n) {
                    var i = a.le(t, n[0]);
                    if (i < 0) return 1;
                    var o = e[i];
                    if (!o) {
                      if (!(i > 0 && t[i] === n[0])) return 1;
                      o = e[i - 1];
                    }
                    for (var s = 1; o;) {
                      var l = o.key,
                        u = r(n, l[0], l[1]);
                      if (l[0][0] < l[1][0]) {
                        if (u < 0) o = o.left;else {
                          if (!(u > 0)) return 0;
                          s = -1, o = o.right;
                        }
                      } else if (u > 0) o = o.left;else {
                        if (!(u < 0)) return 0;
                        s = 1, o = o.right;
                      }
                    }
                    return s;
                  };
                }(v.slabs, v.coordinates);
              return 0 === o.length ? y : function (e, t) {
                return function (n) {
                  return e(n[0], n[1]) ? 0 : t(n);
                };
              }(l(o), y);
            };
            var r = e("robust-orientation")[3],
              i = e("slab-decomposition"),
              o = e("interval-tree-1d"),
              a = e("binary-search-bounds");
            function s() {
              return !0;
            }
            function l(e) {
              for (var t = {}, n = 0; n < e.length; ++n) {
                var r = e[n],
                  i = r[0][0],
                  a = r[0][1],
                  l = r[1][1],
                  u = [Math.min(a, l), Math.max(a, l)];
                i in t ? t[i].push(u) : t[i] = [u];
              }
              var c = {},
                d = Object.keys(t);
              for (n = 0; n < d.length; ++n) {
                var h = t[d[n]];
                c[d[n]] = o(h);
              }
              return function (e) {
                return function (t, n) {
                  var r = e[t];
                  return !!r && !!r.queryPoint(n, s);
                };
              }(c);
            }
            function u(e) {
              return 1;
            }
          }, {
            "binary-search-bounds": 36,
            "interval-tree-1d": 254,
            "robust-orientation": 321,
            "slab-decomposition": 337
          }],
          298: [function (e, t, n) {
            var r,
              i = e("./lib/build-log"),
              o = e("./lib/epsilon"),
              a = e("./lib/intersecter"),
              s = e("./lib/segment-chainer"),
              l = e("./lib/segment-selector"),
              u = e("./lib/geojson"),
              c = !1,
              d = o();
            function h(e, t, n) {
              var i = r.segments(e),
                o = r.segments(t),
                a = n(r.combine(i, o));
              return r.polygon(a);
            }
            r = {
              buildLog: function buildLog(e) {
                return !0 === e ? c = i() : !1 === e && (c = !1), !1 !== c && c.list;
              },
              epsilon: function epsilon(e) {
                return d.epsilon(e);
              },
              segments: function segments(e) {
                var t = a(!0, d, c);
                return e.regions.forEach(t.addRegion), {
                  segments: t.calculate(e.inverted),
                  inverted: e.inverted
                };
              },
              combine: function combine(e, t) {
                return {
                  combined: a(!1, d, c).calculate(e.segments, e.inverted, t.segments, t.inverted),
                  inverted1: e.inverted,
                  inverted2: t.inverted
                };
              },
              selectUnion: function selectUnion(e) {
                return {
                  segments: l.union(e.combined, c),
                  inverted: e.inverted1 || e.inverted2
                };
              },
              selectIntersect: function selectIntersect(e) {
                return {
                  segments: l.intersect(e.combined, c),
                  inverted: e.inverted1 && e.inverted2
                };
              },
              selectDifference: function selectDifference(e) {
                return {
                  segments: l.difference(e.combined, c),
                  inverted: e.inverted1 && !e.inverted2
                };
              },
              selectDifferenceRev: function selectDifferenceRev(e) {
                return {
                  segments: l.differenceRev(e.combined, c),
                  inverted: !e.inverted1 && e.inverted2
                };
              },
              selectXor: function selectXor(e) {
                return {
                  segments: l.xor(e.combined, c),
                  inverted: e.inverted1 !== e.inverted2
                };
              },
              polygon: function polygon(e) {
                return {
                  regions: s(e.segments, d, c),
                  inverted: e.inverted
                };
              },
              polygonFromGeoJSON: function polygonFromGeoJSON(e) {
                return u.toPolygon(r, e);
              },
              polygonToGeoJSON: function polygonToGeoJSON(e) {
                return u.fromPolygon(r, d, e);
              },
              union: function union(e, t) {
                return h(e, t, r.selectUnion);
              },
              intersect: function intersect(e, t) {
                return h(e, t, r.selectIntersect);
              },
              difference: function difference(e, t) {
                return h(e, t, r.selectDifference);
              },
              differenceRev: function differenceRev(e, t) {
                return h(e, t, r.selectDifferenceRev);
              },
              xor: function xor(e, t) {
                return h(e, t, r.selectXor);
              }
            }, "object" == typeof window && (window.PolyBool = r), t.exports = r;
          }, {
            "./lib/build-log": 299,
            "./lib/epsilon": 300,
            "./lib/geojson": 301,
            "./lib/intersecter": 302,
            "./lib/segment-chainer": 304,
            "./lib/segment-selector": 305
          }],
          299: [function (e, t, n) {
            t.exports = function () {
              var e,
                t = 0,
                n = !1;
              function r(t, n) {
                return e.list.push({
                  type: t,
                  data: n ? JSON.parse(JSON.stringify(n)) : void 0
                }), e;
              }
              return e = {
                list: [],
                segmentId: function segmentId() {
                  return t++;
                },
                checkIntersection: function checkIntersection(e, t) {
                  return r("check", {
                    seg1: e,
                    seg2: t
                  });
                },
                segmentChop: function segmentChop(e, t) {
                  return r("div_seg", {
                    seg: e,
                    pt: t
                  }), r("chop", {
                    seg: e,
                    pt: t
                  });
                },
                statusRemove: function statusRemove(e) {
                  return r("pop_seg", {
                    seg: e
                  });
                },
                segmentUpdate: function segmentUpdate(e) {
                  return r("seg_update", {
                    seg: e
                  });
                },
                segmentNew: function segmentNew(e, t) {
                  return r("new_seg", {
                    seg: e,
                    primary: t
                  });
                },
                segmentRemove: function segmentRemove(e) {
                  return r("rem_seg", {
                    seg: e
                  });
                },
                tempStatus: function tempStatus(e, t, n) {
                  return r("temp_status", {
                    seg: e,
                    above: t,
                    below: n
                  });
                },
                rewind: function rewind(e) {
                  return r("rewind", {
                    seg: e
                  });
                },
                status: function status(e, t, n) {
                  return r("status", {
                    seg: e,
                    above: t,
                    below: n
                  });
                },
                vert: function vert(t) {
                  return t === n ? e : (n = t, r("vert", {
                    x: t
                  }));
                },
                log: function log(e) {
                  return "string" != typeof e && (e = JSON.stringify(e, !1, "  ")), r("log", {
                    txt: e
                  });
                },
                reset: function reset() {
                  return r("reset");
                },
                selected: function selected(e) {
                  return r("selected", {
                    segs: e
                  });
                },
                chainStart: function chainStart(e) {
                  return r("chain_start", {
                    seg: e
                  });
                },
                chainRemoveHead: function chainRemoveHead(e, t) {
                  return r("chain_rem_head", {
                    index: e,
                    pt: t
                  });
                },
                chainRemoveTail: function chainRemoveTail(e, t) {
                  return r("chain_rem_tail", {
                    index: e,
                    pt: t
                  });
                },
                chainNew: function chainNew(e, t) {
                  return r("chain_new", {
                    pt1: e,
                    pt2: t
                  });
                },
                chainMatch: function chainMatch(e) {
                  return r("chain_match", {
                    index: e
                  });
                },
                chainClose: function chainClose(e) {
                  return r("chain_close", {
                    index: e
                  });
                },
                chainAddHead: function chainAddHead(e, t) {
                  return r("chain_add_head", {
                    index: e,
                    pt: t
                  });
                },
                chainAddTail: function chainAddTail(e, t) {
                  return r("chain_add_tail", {
                    index: e,
                    pt: t
                  });
                },
                chainConnect: function chainConnect(e, t) {
                  return r("chain_con", {
                    index1: e,
                    index2: t
                  });
                },
                chainReverse: function chainReverse(e) {
                  return r("chain_rev", {
                    index: e
                  });
                },
                chainJoin: function chainJoin(e, t) {
                  return r("chain_join", {
                    index1: e,
                    index2: t
                  });
                },
                done: function done() {
                  return r("done");
                }
              };
            };
          }, {}],
          300: [function (e, t, n) {
            t.exports = function (e) {
              "number" != typeof e && (e = 1e-10);
              var t = {
                epsilon: function epsilon(t) {
                  return "number" == typeof t && (e = t), e;
                },
                pointAboveOrOnLine: function pointAboveOrOnLine(t, n, r) {
                  var i = n[0],
                    o = n[1],
                    a = r[0],
                    s = r[1],
                    l = t[0];
                  return (a - i) * (t[1] - o) - (s - o) * (l - i) >= -e;
                },
                pointBetween: function pointBetween(t, n, r) {
                  var i = t[1] - n[1],
                    o = r[0] - n[0],
                    a = t[0] - n[0],
                    s = r[1] - n[1],
                    l = a * o + i * s;
                  return !(l < e || l - (o * o + s * s) > -e);
                },
                pointsSameX: function pointsSameX(t, n) {
                  return Math.abs(t[0] - n[0]) < e;
                },
                pointsSameY: function pointsSameY(t, n) {
                  return Math.abs(t[1] - n[1]) < e;
                },
                pointsSame: function pointsSame(e, n) {
                  return t.pointsSameX(e, n) && t.pointsSameY(e, n);
                },
                pointsCompare: function pointsCompare(e, n) {
                  return t.pointsSameX(e, n) ? t.pointsSameY(e, n) ? 0 : e[1] < n[1] ? -1 : 1 : e[0] < n[0] ? -1 : 1;
                },
                pointsCollinear: function pointsCollinear(t, n, r) {
                  var i = t[0] - n[0],
                    o = t[1] - n[1],
                    a = n[0] - r[0],
                    s = n[1] - r[1];
                  return Math.abs(i * s - a * o) < e;
                },
                linesIntersect: function linesIntersect(t, n, r, i) {
                  var o = n[0] - t[0],
                    a = n[1] - t[1],
                    s = i[0] - r[0],
                    l = i[1] - r[1],
                    u = o * l - a * s;
                  if (Math.abs(u) < e) return !1;
                  var c = t[0] - r[0],
                    d = t[1] - r[1],
                    h = (s * d - l * c) / u,
                    f = (o * d - a * c) / u,
                    p = {
                      alongA: 0,
                      alongB: 0,
                      pt: [t[0] + h * o, t[1] + h * a]
                    };
                  return p.alongA = h <= -e ? -2 : h < e ? -1 : h - 1 <= -e ? 0 : h - 1 < e ? 1 : 2, p.alongB = f <= -e ? -2 : f < e ? -1 : f - 1 <= -e ? 0 : f - 1 < e ? 1 : 2, p;
                },
                pointInsideRegion: function pointInsideRegion(t, n) {
                  for (var r = t[0], i = t[1], o = n[n.length - 1][0], a = n[n.length - 1][1], s = !1, l = 0; l < n.length; l++) {
                    var u = n[l][0],
                      c = n[l][1];
                    c - i > e != a - i > e && (o - u) * (i - c) / (a - c) + u - r > e && (s = !s), o = u, a = c;
                  }
                  return s;
                }
              };
              return t;
            };
          }, {}],
          301: [function (e, t, n) {
            var r = {
              toPolygon: function toPolygon(e, t) {
                function n(t) {
                  if (t.length <= 0) return e.segments({
                    inverted: !1,
                    regions: []
                  });
                  function n(t) {
                    var n = t.slice(0, t.length - 1);
                    return e.segments({
                      inverted: !1,
                      regions: [n]
                    });
                  }
                  for (var r = n(t[0]), i = 1; i < t.length; i++) r = e.selectDifference(e.combine(r, n(t[i])));
                  return r;
                }
                if ("Polygon" === t.type) return e.polygon(n(t.coordinates));
                if ("MultiPolygon" === t.type) {
                  for (var r = e.segments({
                      inverted: !1,
                      regions: []
                    }), i = 0; i < t.coordinates.length; i++) r = e.selectUnion(e.combine(r, n(t.coordinates[i])));
                  return e.polygon(r);
                }
                throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
              },
              fromPolygon: function fromPolygon(e, t, n) {
                function r(e, n) {
                  return t.pointInsideRegion([.5 * (e[0][0] + e[1][0]), .5 * (e[0][1] + e[1][1])], n);
                }
                function i(e) {
                  return {
                    region: e,
                    children: []
                  };
                }
                n = e.polygon(e.segments(n));
                var o = i(null);
                function a(e, t) {
                  for (var n = 0; n < e.children.length; n++) if (r(t, (s = e.children[n]).region)) return void a(s, t);
                  var o = i(t);
                  for (n = 0; n < e.children.length; n++) {
                    var s;
                    r((s = e.children[n]).region, t) && (o.children.push(s), e.children.splice(n, 1), n--);
                  }
                  e.children.push(o);
                }
                for (var s = 0; s < n.regions.length; s++) {
                  var l = n.regions[s];
                  l.length < 3 || a(o, l);
                }
                function u(e, t) {
                  for (var n = 0, r = e[e.length - 1][0], i = e[e.length - 1][1], o = [], a = 0; a < e.length; a++) {
                    var s = e[a][0],
                      l = e[a][1];
                    o.push([s, l]), n += l * r - s * i, r = s, i = l;
                  }
                  return n < 0 !== t && o.reverse(), o.push([o[0][0], o[0][1]]), o;
                }
                var c = [];
                function d(e) {
                  var t = [u(e.region, !1)];
                  c.push(t);
                  for (var n = 0; n < e.children.length; n++) t.push(h(e.children[n]));
                }
                function h(e) {
                  for (var t = 0; t < e.children.length; t++) d(e.children[t]);
                  return u(e.region, !0);
                }
                for (s = 0; s < o.children.length; s++) d(o.children[s]);
                return c.length <= 0 ? {
                  type: "Polygon",
                  coordinates: []
                } : 1 == c.length ? {
                  type: "Polygon",
                  coordinates: c[0]
                } : {
                  type: "MultiPolygon",
                  coordinates: c
                };
              }
            };
            t.exports = r;
          }, {}],
          302: [function (e, t, n) {
            var r = e("./linked-list");
            t.exports = function (e, t, n) {
              function i(e, t, r) {
                return {
                  id: n ? n.segmentId() : -1,
                  start: e,
                  end: t,
                  myFill: {
                    above: r.myFill.above,
                    below: r.myFill.below
                  },
                  otherFill: null
                };
              }
              var o = r.create();
              function a(e, n) {
                o.insertBefore(e, function (r) {
                  return function (e, n, r, i, o, a) {
                    var s = t.pointsCompare(n, o);
                    return 0 !== s ? s : t.pointsSame(r, a) ? 0 : e !== i ? e ? 1 : -1 : t.pointAboveOrOnLine(r, i ? o : a, i ? a : o) ? 1 : -1;
                  }(e.isStart, e.pt, n, r.isStart, r.pt, r.other.pt) < 0;
                });
              }
              function s(e, t) {
                var n = function (e, t) {
                  var n = r.node({
                    isStart: !0,
                    pt: e.start,
                    seg: e,
                    primary: t,
                    other: null,
                    status: null
                  });
                  return a(n, e.end), n;
                }(e, t);
                return function (e, t, n) {
                  var i = r.node({
                    isStart: !1,
                    pt: t.end,
                    seg: t,
                    primary: n,
                    other: e,
                    status: null
                  });
                  e.other = i, a(i, e.pt);
                }(n, e, t), n;
              }
              function l(e, t) {
                var r = i(t, e.seg.end, e.seg);
                return function (e, t) {
                  n && n.segmentChop(e.seg, t), e.other.remove(), e.seg.end = t, e.other.pt = t, a(e.other, e.pt);
                }(e, t), s(r, e.primary);
              }
              function u(i, a) {
                var s = r.create();
                function u(e) {
                  return s.findTransition(function (n) {
                    var r, i, o, a, s, l;
                    return r = e, i = n.ev, o = r.seg.start, a = r.seg.end, s = i.seg.start, l = i.seg.end, (t.pointsCollinear(o, s, l) ? t.pointsCollinear(a, s, l) || t.pointAboveOrOnLine(a, s, l) ? 1 : -1 : t.pointAboveOrOnLine(o, s, l) ? 1 : -1) > 0;
                  });
                }
                function c(e, r) {
                  var i = e.seg,
                    o = r.seg,
                    a = i.start,
                    s = i.end,
                    u = o.start,
                    c = o.end;
                  n && n.checkIntersection(i, o);
                  var d = t.linesIntersect(a, s, u, c);
                  if (!1 === d) {
                    if (!t.pointsCollinear(a, s, u)) return !1;
                    if (t.pointsSame(a, c) || t.pointsSame(s, u)) return !1;
                    var h = t.pointsSame(a, u),
                      f = t.pointsSame(s, c);
                    if (h && f) return r;
                    var p = !h && t.pointBetween(a, u, c),
                      m = !f && t.pointBetween(s, u, c);
                    if (h) return m ? l(r, s) : l(e, c), r;
                    p && (f || (m ? l(r, s) : l(e, c)), l(r, a));
                  } else 0 === d.alongA && (-1 === d.alongB ? l(e, u) : 0 === d.alongB ? l(e, d.pt) : 1 === d.alongB && l(e, c)), 0 === d.alongB && (-1 === d.alongA ? l(r, a) : 0 === d.alongA ? l(r, d.pt) : 1 === d.alongA && l(r, s));
                  return !1;
                }
                var _loop = function _loop() {
                    h = o.getHead();
                    if (n && n.vert(h.pt[0]), h.isStart) {
                      var g = function g() {
                        if (p) {
                          var e = c(h, p);
                          if (e) return e;
                        }
                        return !!m && c(h, m);
                      };
                      n && n.segmentNew(h.seg, h.primary);
                      f = u(h), p = f.before ? f.before.ev : null, m = f.after ? f.after.ev : null;
                      n && n.tempStatus(h.seg, !!p && p.seg, !!m && m.seg);
                      b = g();
                      if (b && (e ? (y = null === h.seg.myFill.below || h.seg.myFill.above !== h.seg.myFill.below) && (b.seg.myFill.above = !b.seg.myFill.above) : b.seg.otherFill = h.seg.myFill, n && n.segmentUpdate(b.seg), h.other.remove(), h.remove()), o.getHead() !== h) {
                        n && n.rewind(h.seg);
                        return 1; // continue
                      }
                      e ? (y = null === h.seg.myFill.below || h.seg.myFill.above !== h.seg.myFill.below, h.seg.myFill.below = m ? m.seg.myFill.above : i, h.seg.myFill.above = y ? !h.seg.myFill.below : h.seg.myFill.below) : null === h.seg.otherFill && (v = m ? h.primary === m.primary ? m.seg.otherFill.above : m.seg.myFill.above : h.primary ? a : i, h.seg.otherFill = {
                        above: v,
                        below: v
                      }), n && n.status(h.seg, !!p && p.seg, !!m && m.seg), h.other.status = f.insert(r.node({
                        ev: h
                      }));
                    } else {
                      _ = h.status;
                      if (null === _) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                      if (s.exists(_.prev) && s.exists(_.next) && c(_.prev.ev, _.next.ev), n && n.statusRemove(_.ev.seg), _.remove(), !h.primary) {
                        x = h.seg.myFill;
                        h.seg.myFill = h.seg.otherFill, h.seg.otherFill = x;
                      }
                      d.push(h.seg);
                    }
                    o.getHead().remove();
                  },
                  h,
                  f,
                  p,
                  m,
                  v,
                  y,
                  b,
                  _,
                  x;
                for (var d = []; !o.isEmpty();) {
                  if (_loop()) continue;
                }
                return n && n.done(), d;
              }
              return e ? {
                addRegion: function addRegion(e) {
                  for (var r, i, o, a = e[e.length - 1], l = 0; l < e.length; l++) {
                    r = a, a = e[l];
                    var u = t.pointsCompare(r, a);
                    0 !== u && s((i = u < 0 ? r : a, o = u < 0 ? a : r, {
                      id: n ? n.segmentId() : -1,
                      start: i,
                      end: o,
                      myFill: {
                        above: null,
                        below: null
                      },
                      otherFill: null
                    }), !0);
                  }
                },
                calculate: function calculate(e) {
                  return u(e, !1);
                }
              } : {
                calculate: function calculate(e, t, n, r) {
                  return e.forEach(function (e) {
                    s(i(e.start, e.end, e), !0);
                  }), n.forEach(function (e) {
                    s(i(e.start, e.end, e), !1);
                  }), u(t, r);
                }
              };
            };
          }, {
            "./linked-list": 303
          }],
          303: [function (e, t, n) {
            t.exports = {
              create: function create() {
                var e = {
                  root: {
                    root: !0,
                    next: null
                  },
                  exists: function exists(t) {
                    return null !== t && t !== e.root;
                  },
                  isEmpty: function isEmpty() {
                    return null === e.root.next;
                  },
                  getHead: function getHead() {
                    return e.root.next;
                  },
                  insertBefore: function insertBefore(t, n) {
                    for (var r = e.root, i = e.root.next; null !== i;) {
                      if (n(i)) return t.prev = i.prev, t.next = i, i.prev.next = t, void (i.prev = t);
                      r = i, i = i.next;
                    }
                    r.next = t, t.prev = r, t.next = null;
                  },
                  findTransition: function findTransition(t) {
                    for (var n = e.root, r = e.root.next; null !== r && !t(r);) n = r, r = r.next;
                    return {
                      before: n === e.root ? null : n,
                      after: r,
                      insert: function insert(e) {
                        return e.prev = n, e.next = r, n.next = e, null !== r && (r.prev = e), e;
                      }
                    };
                  }
                };
                return e;
              },
              node: function node(e) {
                return e.prev = null, e.next = null, e.remove = function () {
                  e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
                }, e;
              }
            };
          }, {}],
          304: [function (e, t, n) {
            t.exports = function (e, t, n) {
              var r = [],
                i = [];
              return e.forEach(function (e) {
                var o = e.start,
                  a = e.end;
                if (t.pointsSame(o, a)) console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");else {
                  n && n.chainStart(e);
                  for (var s = {
                      index: 0,
                      matches_head: !1,
                      matches_pt1: !1
                    }, l = {
                      index: 0,
                      matches_head: !1,
                      matches_pt1: !1
                    }, u = s, c = 0; c < r.length; c++) {
                    var d = (g = r[c])[0],
                      h = (g[1], g[g.length - 1]);
                    if (g[g.length - 2], t.pointsSame(d, o)) {
                      if (A(c, !0, !0)) break;
                    } else if (t.pointsSame(d, a)) {
                      if (A(c, !0, !1)) break;
                    } else if (t.pointsSame(h, o)) {
                      if (A(c, !1, !0)) break;
                    } else if (t.pointsSame(h, a) && A(c, !1, !1)) break;
                  }
                  if (u === s) return r.push([o, a]), void (n && n.chainNew(o, a));
                  if (u === l) {
                    n && n.chainMatch(s.index);
                    var f = s.index,
                      p = s.matches_pt1 ? a : o,
                      m = s.matches_head,
                      g = r[f],
                      v = m ? g[0] : g[g.length - 1],
                      y = m ? g[1] : g[g.length - 2],
                      b = m ? g[g.length - 1] : g[0],
                      _ = m ? g[g.length - 2] : g[1];
                    return t.pointsCollinear(y, v, p) && (m ? (n && n.chainRemoveHead(s.index, p), g.shift()) : (n && n.chainRemoveTail(s.index, p), g.pop()), v = y), t.pointsSame(b, p) ? (r.splice(f, 1), t.pointsCollinear(_, b, v) && (m ? (n && n.chainRemoveTail(s.index, v), g.pop()) : (n && n.chainRemoveHead(s.index, v), g.shift())), n && n.chainClose(s.index), void i.push(g)) : void (m ? (n && n.chainAddHead(s.index, p), g.unshift(p)) : (n && n.chainAddTail(s.index, p), g.push(p)));
                  }
                  var x = s.index,
                    w = l.index;
                  n && n.chainConnect(x, w);
                  var S = r[x].length < r[w].length;
                  s.matches_head ? l.matches_head ? S ? (E(x), T(x, w)) : (E(w), T(w, x)) : T(w, x) : l.matches_head ? T(x, w) : S ? (E(x), T(w, x)) : (E(w), T(x, w));
                }
                function A(e, t, n) {
                  return u.index = e, u.matches_head = t, u.matches_pt1 = n, u === s ? (u = l, !1) : (u = null, !0);
                }
                function E(e) {
                  n && n.chainReverse(e), r[e].reverse();
                }
                function T(e, i) {
                  var o = r[e],
                    a = r[i],
                    s = o[o.length - 1],
                    l = o[o.length - 2],
                    u = a[0],
                    c = a[1];
                  t.pointsCollinear(l, s, u) && (n && n.chainRemoveTail(e, s), o.pop(), s = l), t.pointsCollinear(s, u, c) && (n && n.chainRemoveHead(i, u), a.shift()), n && n.chainJoin(e, i), r[e] = o.concat(a), r.splice(i, 1);
                }
              }), i;
            };
          }, {}],
          305: [function (e, t, n) {
            function r(e, t, n) {
              var r = [];
              return e.forEach(function (e) {
                var i = (e.myFill.above ? 8 : 0) + (e.myFill.below ? 4 : 0) + (e.otherFill && e.otherFill.above ? 2 : 0) + (e.otherFill && e.otherFill.below ? 1 : 0);
                0 !== t[i] && r.push({
                  id: n ? n.segmentId() : -1,
                  start: e.start,
                  end: e.end,
                  myFill: {
                    above: 1 === t[i],
                    below: 2 === t[i]
                  },
                  otherFill: null
                });
              }), n && n.selected(r), r;
            }
            var i = {
              union: function union(e, t) {
                return r(e, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], t);
              },
              intersect: function intersect(e, t) {
                return r(e, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], t);
              },
              difference: function difference(e, t) {
                return r(e, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], t);
              },
              differenceRev: function differenceRev(e, t) {
                return r(e, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], t);
              },
              xor: function xor(e, t) {
                return r(e, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], t);
              }
            };
            t.exports = i;
          }, {}],
          306: [function (e, t, n) {
            "use strict";

            var r = new Float64Array(4),
              i = new Float64Array(4),
              o = new Float64Array(4);
            t.exports = function (e, t, n, a, s) {
              r.length < a.length && (r = new Float64Array(a.length), i = new Float64Array(a.length), o = new Float64Array(a.length));
              for (var l = 0; l < a.length; ++l) r[l] = e[l] - a[l], i[l] = t[l] - e[l], o[l] = n[l] - e[l];
              var u = 0,
                c = 0,
                d = 0,
                h = 0,
                f = 0,
                p = 0;
              for (l = 0; l < a.length; ++l) {
                var m = i[l],
                  g = o[l],
                  v = r[l];
                u += m * m, c += m * g, d += g * g, h += v * m, f += v * g, p += v * v;
              }
              var y,
                b,
                _,
                x,
                w,
                S = Math.abs(u * d - c * c),
                A = c * f - d * h,
                E = c * h - u * f;
              if (A + E <= S) {
                if (A < 0) E < 0 && h < 0 ? (E = 0, -h >= u ? (A = 1, y = u + 2 * h + p) : y = h * (A = -h / u) + p) : (A = 0, f >= 0 ? (E = 0, y = p) : -f >= d ? (E = 1, y = d + 2 * f + p) : y = f * (E = -f / d) + p);else if (E < 0) E = 0, h >= 0 ? (A = 0, y = p) : -h >= u ? (A = 1, y = u + 2 * h + p) : y = h * (A = -h / u) + p;else {
                  var T = 1 / S;
                  y = (A *= T) * (u * A + c * (E *= T) + 2 * h) + E * (c * A + d * E + 2 * f) + p;
                }
              } else A < 0 ? (_ = d + f) > (b = c + h) ? (x = _ - b) >= (w = u - 2 * c + d) ? (A = 1, E = 0, y = u + 2 * h + p) : y = (A = x / w) * (u * A + c * (E = 1 - A) + 2 * h) + E * (c * A + d * E + 2 * f) + p : (A = 0, _ <= 0 ? (E = 1, y = d + 2 * f + p) : f >= 0 ? (E = 0, y = p) : y = f * (E = -f / d) + p) : E < 0 ? (_ = u + h) > (b = c + f) ? (x = _ - b) >= (w = u - 2 * c + d) ? (E = 1, A = 0, y = d + 2 * f + p) : y = (A = 1 - (E = x / w)) * (u * A + c * E + 2 * h) + E * (c * A + d * E + 2 * f) + p : (E = 0, _ <= 0 ? (A = 1, y = u + 2 * h + p) : h >= 0 ? (A = 0, y = p) : y = h * (A = -h / u) + p) : (x = d + f - c - h) <= 0 ? (A = 0, E = 1, y = d + 2 * f + p) : x >= (w = u - 2 * c + d) ? (A = 1, E = 0, y = u + 2 * h + p) : y = (A = x / w) * (u * A + c * (E = 1 - A) + 2 * h) + E * (c * A + d * E + 2 * f) + p;
              var M = 1 - A - E;
              for (l = 0; l < a.length; ++l) s[l] = M * e[l] + A * t[l] + E * n[l];
              return y < 0 ? 0 : y;
            };
          }, {}],
          307: [function (e, t, n) {
            var r,
              i,
              o = t.exports = {};
            function a() {
              throw new Error("setTimeout has not been defined");
            }
            function s() {
              throw new Error("clearTimeout has not been defined");
            }
            function l(e) {
              if (r === setTimeout) return setTimeout(e, 0);
              if ((r === a || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);
              try {
                return r(e, 0);
              } catch (t) {
                try {
                  return r.call(null, e, 0);
                } catch (t) {
                  return r.call(this, e, 0);
                }
              }
            }
            !function () {
              try {
                r = "function" == typeof setTimeout ? setTimeout : a;
              } catch (e) {
                r = a;
              }
              try {
                i = "function" == typeof clearTimeout ? clearTimeout : s;
              } catch (e) {
                i = s;
              }
            }();
            var u,
              c = [],
              d = !1,
              h = -1;
            function f() {
              d && u && (d = !1, u.length ? c = u.concat(c) : h = -1, c.length && p());
            }
            function p() {
              if (!d) {
                var e = l(f);
                d = !0;
                for (var t = c.length; t;) {
                  for (u = c, c = []; ++h < t;) u && u[h].run();
                  h = -1, t = c.length;
                }
                u = null, d = !1, function (e) {
                  if (i === clearTimeout) return clearTimeout(e);
                  if ((i === s || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                  try {
                    i(e);
                  } catch (t) {
                    try {
                      return i.call(null, e);
                    } catch (t) {
                      return i.call(this, e);
                    }
                  }
                }(e);
              }
            }
            function m(e, t) {
              this.fun = e, this.array = t;
            }
            function g() {}
            o.nextTick = function (e) {
              var t = new Array(arguments.length - 1);
              if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
              c.push(new m(e, t)), 1 !== c.length || d || l(p);
            }, m.prototype.run = function () {
              this.fun.apply(null, this.array);
            }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = g, o.addListener = g, o.once = g, o.off = g, o.removeListener = g, o.removeAllListeners = g, o.emit = g, o.prependListener = g, o.prependOnceListener = g, o.listeners = function (e) {
              return [];
            }, o.binding = function (e) {
              throw new Error("process.binding is not supported");
            }, o.cwd = function () {
              return "/";
            }, o.chdir = function (e) {
              throw new Error("process.chdir is not supported");
            }, o.umask = function () {
              return 0;
            };
          }, {}],
          308: [function (e, t, n) {
            t.exports = e("gl-quat/slerp");
          }, {
            "gl-quat/slerp": 144
          }],
          309: [function (e, t, n) {
            "use strict";

            var r = e("big-rat/add");
            t.exports = function (e, t) {
              for (var n = e.length, i = new Array(n), o = 0; o < n; ++o) i[o] = r(e[o], t[o]);
              return i;
            };
          }, {
            "big-rat/add": 20
          }],
          310: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = new Array(e.length), n = 0; n < e.length; ++n) t[n] = r(e[n]);
              return t;
            };
            var r = e("big-rat");
          }, {
            "big-rat": 23
          }],
          311: [function (e, t, n) {
            "use strict";

            var r = e("big-rat"),
              i = e("big-rat/mul");
            t.exports = function (e, t) {
              for (var n = r(t), o = e.length, a = new Array(o), s = 0; s < o; ++s) a[s] = i(e[s], n);
              return a;
            };
          }, {
            "big-rat": 23,
            "big-rat/mul": 32
          }],
          312: [function (e, t, n) {
            "use strict";

            var r = e("big-rat/sub");
            t.exports = function (e, t) {
              for (var n = e.length, i = new Array(n), o = 0; o < n; ++o) i[o] = r(e[o], t[o]);
              return i;
            };
          }, {
            "big-rat/sub": 34
          }],
          313: [function (e, t, n) {
            "use strict";

            var r = e("compare-cell"),
              i = e("compare-oriented-cell"),
              o = e("cell-orientation");
            t.exports = function (e) {
              e.sort(i);
              for (var t = e.length, n = 0, a = 0; a < t; ++a) {
                var s = e[a],
                  l = o(s);
                if (0 !== l) {
                  if (n > 0) {
                    var u = e[n - 1];
                    if (0 === r(s, u) && o(u) !== l) {
                      n -= 1;
                      continue;
                    }
                  }
                  e[n++] = s;
                }
              }
              return e.length = n, e;
            };
          }, {
            "cell-orientation": 56,
            "compare-cell": 71,
            "compare-oriented-cell": 72
          }],
          314: [function (e, t, n) {
            "use strict";

            var r,
              i = "";
            t.exports = function (e, t) {
              if ("string" != typeof e) throw new TypeError("expected a string");
              if (1 === t) return e;
              if (2 === t) return e + e;
              var n = e.length * t;
              if (r !== e || void 0 === r) r = e, i = "";else if (i.length >= n) return i.substr(0, n);
              for (; n > i.length && t > 1;) 1 & t && (i += e), t >>= 1, e += e;
              return i = (i += e).substr(0, n);
            };
          }, {}],
          315: [function (e, n, r) {
            (function (e) {
              n.exports = e.performance && e.performance.now ? function () {
                return performance.now();
              } : Date.now || function () {
                return +new Date();
              };
            }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {}],
          316: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = e.length, n = e[e.length - 1], r = t, i = t - 2; i >= 0; --i) {
                var o = n;
                (l = (s = e[i]) - ((n = o + s) - o)) && (e[--r] = n, n = l);
              }
              var a = 0;
              for (i = r; i < t; ++i) {
                var s, l;
                (l = (s = n) - ((n = (o = e[i]) + s) - o)) && (e[a++] = l);
              }
              return e[a++] = n, e.length = a, e;
            };
          }, {}],
          317: [function (e, t, n) {
            "use strict";

            var r = e("two-product"),
              i = e("robust-sum"),
              o = e("robust-scale"),
              a = e("robust-compress");
            function s(e, t) {
              for (var n = new Array(e.length - 1), r = 1; r < e.length; ++r) for (var i = n[r - 1] = new Array(e.length - 1), o = 0, a = 0; o < e.length; ++o) o !== t && (i[a++] = e[r][o]);
              return n;
            }
            function l(e) {
              for (var t = new Array(e), n = 0; n < e; ++n) {
                t[n] = new Array(e);
                for (var r = 0; r < e; ++r) t[n][r] = ["m[", n, "][", r, "]"].join("");
              }
              return t;
            }
            function u(e) {
              if (2 === e.length) return ["sum(prod(", e[0][0], ",", e[1][1], "),prod(-", e[0][1], ",", e[1][0], "))"].join("");
              for (var t = [], n = 0; n < e.length; ++n) t.push(["scale(", u(s(e, n)), ",", (r = n, 1 & r ? "-" : ""), e[0][n], ")"].join(""));
              return function e(t) {
                if (1 === t.length) return t[0];
                if (2 === t.length) return ["sum(", t[0], ",", t[1], ")"].join("");
                var n = t.length >> 1;
                return ["sum(", e(t.slice(0, n)), ",", e(t.slice(n)), ")"].join("");
              }(t);
              var r;
            }
            function c(e) {
              return new Function("sum", "scale", "prod", "compress", ["function robustDeterminant", e, "(m){return compress(", u(l(e)), ")};return robustDeterminant", e].join(""))(i, o, r, a);
            }
            var d = [function () {
              return [0];
            }, function (e) {
              return [e[0][0]];
            }];
            !function () {
              for (; d.length < 6;) d.push(c(d.length));
              for (var e = [], n = ["function robustDeterminant(m){switch(m.length){"], r = 0; r < 6; ++r) e.push("det" + r), n.push("case ", r, ":return det", r, "(m);");
              n.push("}var det=CACHE[m.length];if(!det)det=CACHE[m.length]=gen(m.length);return det(m);}return robustDeterminant"), e.push("CACHE", "gen", n.join(""));
              var i = Function.apply(void 0, e);
              for (t.exports = i.apply(void 0, d.concat([d, c])), r = 0; r < d.length; ++r) t.exports[r] = d[r];
            }();
          }, {
            "robust-compress": 316,
            "robust-scale": 323,
            "robust-sum": 326,
            "two-product": 345
          }],
          318: [function (e, t, n) {
            "use strict";

            var r = e("two-product"),
              i = e("robust-sum");
            t.exports = function (e, t) {
              for (var n = r(e[0], t[0]), o = 1; o < e.length; ++o) n = i(n, r(e[o], t[o]));
              return n;
            };
          }, {
            "robust-sum": 326,
            "two-product": 345
          }],
          319: [function (e, t, n) {
            "use strict";

            var r = e("two-product"),
              i = e("robust-sum"),
              o = e("robust-subtract"),
              a = e("robust-scale");
            function s(e, t) {
              for (var n = new Array(e.length - 1), r = 1; r < e.length; ++r) for (var i = n[r - 1] = new Array(e.length - 1), o = 0, a = 0; o < e.length; ++o) o !== t && (i[a++] = e[r][o]);
              return n;
            }
            function l(e) {
              if (1 === e.length) return e[0];
              if (2 === e.length) return ["sum(", e[0], ",", e[1], ")"].join("");
              var t = e.length >> 1;
              return ["sum(", l(e.slice(0, t)), ",", l(e.slice(t)), ")"].join("");
            }
            function u(e, t) {
              if ("m" === e.charAt(0)) {
                if ("w" === t.charAt(0)) {
                  var n = e.split("[");
                  return ["w", t.substr(1), "m", n[0].substr(1)].join("");
                }
                return ["prod(", e, ",", t, ")"].join("");
              }
              return u(t, e);
            }
            function c(e) {
              if (2 === e.length) return [["diff(", u(e[0][0], e[1][1]), ",", u(e[1][0], e[0][1]), ")"].join("")];
              for (var t = [], n = 0; n < e.length; ++n) t.push(["scale(", l(c(s(e, n))), ",", (r = n, !0 & r ? "-" : ""), e[0][n], ")"].join(""));
              return t;
              var r;
            }
            function d(e, t) {
              for (var n = [], r = 0; r < t - 2; ++r) n.push(["prod(m", e, "[", r, "],m", e, "[", r, "])"].join(""));
              return l(n);
            }
            function h(e) {
              for (var t = [], n = [], u = function (e) {
                  for (var t = new Array(e), n = 0; n < e; ++n) {
                    t[n] = new Array(e);
                    for (var r = 0; r < e; ++r) t[n][r] = ["m", r, "[", e - n - 2, "]"].join("");
                  }
                  return t;
                }(e), h = 0; h < e; ++h) u[0][h] = "1", u[e - 1][h] = "w" + h;
              for (h = 0; h < e; ++h) 0 == (1 & h) ? t.push.apply(t, c(s(u, h))) : n.push.apply(n, c(s(u, h)));
              var f = l(t),
                p = l(n),
                m = "exactInSphere" + e,
                g = [];
              for (h = 0; h < e; ++h) g.push("m" + h);
              var v = ["function ", m, "(", g.join(), "){"];
              for (h = 0; h < e; ++h) {
                v.push("var w", h, "=", d(h, e), ";");
                for (var y = 0; y < e; ++y) y !== h && v.push("var w", h, "m", y, "=scale(w", h, ",m", y, "[0]);");
              }
              return v.push("var p=", f, ",n=", p, ",d=diff(p,n);return d[d.length-1];}return ", m), new Function("sum", "diff", "prod", "scale", v.join(""))(i, o, r, a);
            }
            var f = [function () {
              return 0;
            }, function () {
              return 0;
            }, function () {
              return 0;
            }];
            function p(e) {
              var t = f[e.length];
              return t || (t = f[e.length] = h(e.length)), t.apply(void 0, e);
            }
            !function () {
              for (; f.length <= 6;) f.push(h(f.length));
              for (var e = [], n = ["slow"], r = 0; r <= 6; ++r) e.push("a" + r), n.push("o" + r);
              var i = ["function testInSphere(", e.join(), "){switch(arguments.length){case 0:case 1:return 0;"];
              for (r = 2; r <= 6; ++r) i.push("case ", r, ":return o", r, "(", e.slice(0, r).join(), ");");
              i.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return testInSphere"), n.push(i.join(""));
              var o = Function.apply(void 0, n);
              for (t.exports = o.apply(void 0, [p].concat(f)), r = 0; r <= 6; ++r) t.exports[r] = f[r];
            }();
          }, {
            "robust-scale": 323,
            "robust-subtract": 325,
            "robust-sum": 326,
            "two-product": 345
          }],
          320: [function (e, t, n) {
            "use strict";

            var r = e("robust-determinant");
            function i(e) {
              for (var t = "robustLinearSolve" + e + "d", n = ["function ", t, "(A,b){return ["], i = 0; i < e; ++i) {
                n.push("det([");
                for (var o = 0; o < e; ++o) {
                  o > 0 && n.push(","), n.push("[");
                  for (var a = 0; a < e; ++a) a > 0 && n.push(","), a === i ? n.push("+b[", o, "]") : n.push("+A[", o, "][", a, "]");
                  n.push("]");
                }
                n.push("]),");
              }
              return n.push("det(A)]}return ", t), new Function("det", n.join(""))(e < 6 ? r[e] : r);
            }
            var o = [function () {
              return [0];
            }, function (e, t) {
              return [[t[0]], [e[0][0]]];
            }];
            !function () {
              for (; o.length < 6;) o.push(i(o.length));
              for (var e = [], n = ["function dispatchLinearSolve(A,b){switch(A.length){"], r = 0; r < 6; ++r) e.push("s" + r), n.push("case ", r, ":return s", r, "(A,b);");
              n.push("}var s=CACHE[A.length];if(!s)s=CACHE[A.length]=g(A.length);return s(A,b)}return dispatchLinearSolve"), e.push("CACHE", "g", n.join(""));
              var a = Function.apply(void 0, e);
              for (t.exports = a.apply(void 0, o.concat([o, i])), r = 0; r < 6; ++r) t.exports[r] = o[r];
            }();
          }, {
            "robust-determinant": 317
          }],
          321: [function (e, t, n) {
            "use strict";

            var r = e("two-product"),
              i = e("robust-sum"),
              o = e("robust-scale"),
              a = e("robust-subtract");
            function s(e, t) {
              for (var n = new Array(e.length - 1), r = 1; r < e.length; ++r) for (var i = n[r - 1] = new Array(e.length - 1), o = 0, a = 0; o < e.length; ++o) o !== t && (i[a++] = e[r][o]);
              return n;
            }
            function l(e) {
              if (1 === e.length) return e[0];
              if (2 === e.length) return ["sum(", e[0], ",", e[1], ")"].join("");
              var t = e.length >> 1;
              return ["sum(", l(e.slice(0, t)), ",", l(e.slice(t)), ")"].join("");
            }
            function u(e) {
              if (2 === e.length) return [["sum(prod(", e[0][0], ",", e[1][1], "),prod(-", e[0][1], ",", e[1][0], "))"].join("")];
              for (var t = [], n = 0; n < e.length; ++n) t.push(["scale(", l(u(s(e, n))), ",", (r = n, 1 & r ? "-" : ""), e[0][n], ")"].join(""));
              return t;
              var r;
            }
            function c(e) {
              for (var t = [], n = [], c = function (e) {
                  for (var t = new Array(e), n = 0; n < e; ++n) {
                    t[n] = new Array(e);
                    for (var r = 0; r < e; ++r) t[n][r] = ["m", r, "[", e - n - 1, "]"].join("");
                  }
                  return t;
                }(e), d = [], h = 0; h < e; ++h) 0 == (1 & h) ? t.push.apply(t, u(s(c, h))) : n.push.apply(n, u(s(c, h))), d.push("m" + h);
              var f = l(t),
                p = l(n),
                m = "orientation" + e + "Exact",
                g = ["function ", m, "(", d.join(), "){var p=", f, ",n=", p, ",d=sub(p,n);return d[d.length-1];};return ", m].join("");
              return new Function("sum", "prod", "scale", "sub", g)(i, r, o, a);
            }
            var d = c(3),
              h = c(4),
              f = [function () {
                return 0;
              }, function () {
                return 0;
              }, function (e, t) {
                return t[0] - e[0];
              }, function (e, t, n) {
                var r,
                  i = (e[1] - n[1]) * (t[0] - n[0]),
                  o = (e[0] - n[0]) * (t[1] - n[1]),
                  a = i - o;
                if (i > 0) {
                  if (o <= 0) return a;
                  r = i + o;
                } else {
                  if (!(i < 0)) return a;
                  if (o >= 0) return a;
                  r = -(i + o);
                }
                var s = 33306690738754716e-32 * r;
                return a >= s || a <= -s ? a : d(e, t, n);
              }, function (e, t, n, r) {
                var i = e[0] - r[0],
                  o = t[0] - r[0],
                  a = n[0] - r[0],
                  s = e[1] - r[1],
                  l = t[1] - r[1],
                  u = n[1] - r[1],
                  c = e[2] - r[2],
                  d = t[2] - r[2],
                  f = n[2] - r[2],
                  p = o * u,
                  m = a * l,
                  g = a * s,
                  v = i * u,
                  y = i * l,
                  b = o * s,
                  _ = c * (p - m) + d * (g - v) + f * (y - b),
                  x = 7771561172376103e-31 * ((Math.abs(p) + Math.abs(m)) * Math.abs(c) + (Math.abs(g) + Math.abs(v)) * Math.abs(d) + (Math.abs(y) + Math.abs(b)) * Math.abs(f));
                return _ > x || -_ > x ? _ : h(e, t, n, r);
              }];
            function p(e) {
              var t = f[e.length];
              return t || (t = f[e.length] = c(e.length)), t.apply(void 0, e);
            }
            !function () {
              for (; f.length <= 5;) f.push(c(f.length));
              for (var e = [], n = ["slow"], r = 0; r <= 5; ++r) e.push("a" + r), n.push("o" + r);
              var i = ["function getOrientation(", e.join(), "){switch(arguments.length){case 0:case 1:return 0;"];
              for (r = 2; r <= 5; ++r) i.push("case ", r, ":return o", r, "(", e.slice(0, r).join(), ");");
              i.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation"), n.push(i.join(""));
              var o = Function.apply(void 0, n);
              for (t.exports = o.apply(void 0, [p].concat(f)), r = 0; r <= 5; ++r) t.exports[r] = f[r];
            }();
          }, {
            "robust-scale": 323,
            "robust-subtract": 325,
            "robust-sum": 326,
            "two-product": 345
          }],
          322: [function (e, t, n) {
            "use strict";

            var r = e("robust-sum"),
              i = e("robust-scale");
            t.exports = function (e, t) {
              if (1 === e.length) return i(t, e[0]);
              if (1 === t.length) return i(e, t[0]);
              if (0 === e.length || 0 === t.length) return [0];
              var n = [0];
              if (e.length < t.length) for (var o = 0; o < e.length; ++o) n = r(n, i(t, e[o]));else for (o = 0; o < t.length; ++o) n = r(n, i(e, t[o]));
              return n;
            };
          }, {
            "robust-scale": 323,
            "robust-sum": 326
          }],
          323: [function (e, t, n) {
            "use strict";

            var r = e("two-product"),
              i = e("two-sum");
            t.exports = function (e, t) {
              var n = e.length;
              if (1 === n) {
                var o = r(e[0], t);
                return o[0] ? o : [o[1]];
              }
              var a = new Array(2 * n),
                s = [.1, .1],
                l = [.1, .1],
                u = 0;
              r(e[0], t, s), s[0] && (a[u++] = s[0]);
              for (var c = 1; c < n; ++c) {
                r(e[c], t, l);
                var d = s[1];
                i(d, l[0], s), s[0] && (a[u++] = s[0]);
                var h = l[1],
                  f = s[1],
                  p = h + f,
                  m = f - (p - h);
                s[1] = p, m && (a[u++] = m);
              }
              return s[1] && (a[u++] = s[1]), 0 === u && (a[u++] = 0), a.length = u, a;
            };
          }, {
            "two-product": 345,
            "two-sum": 346
          }],
          324: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, i) {
              var o = r(e, n, i),
                a = r(t, n, i);
              if (o > 0 && a > 0 || o < 0 && a < 0) return !1;
              var s = r(n, e, t),
                l = r(i, e, t);
              return !(s > 0 && l > 0 || s < 0 && l < 0) && (0 !== o || 0 !== a || 0 !== s || 0 !== l || function (e, t, n, r) {
                for (var i = 0; i < 2; ++i) {
                  var o = e[i],
                    a = t[i],
                    s = Math.min(o, a),
                    l = Math.max(o, a),
                    u = n[i],
                    c = r[i],
                    d = Math.min(u, c);
                  if (Math.max(u, c) < s || l < d) return !1;
                }
                return !0;
              }(e, t, n, i));
            };
            var r = e("robust-orientation")[3];
          }, {
            "robust-orientation": 321
          }],
          325: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = 0 | e.length,
                r = 0 | t.length;
              if (1 === n && 1 === r) return function (e, t) {
                var n = e + t,
                  r = n - e,
                  i = e - (n - r) + (t - r);
                return i ? [i, n] : [n];
              }(e[0], -t[0]);
              var i,
                o,
                a = new Array(n + r),
                s = 0,
                l = 0,
                u = 0,
                c = Math.abs,
                d = e[l],
                h = c(d),
                f = -t[u],
                p = c(f);
              h < p ? (o = d, (l += 1) < n && (h = c(d = e[l]))) : (o = f, (u += 1) < r && (p = c(f = -t[u]))), l < n && h < p || u >= r ? (i = d, (l += 1) < n && (h = c(d = e[l]))) : (i = f, (u += 1) < r && (p = c(f = -t[u])));
              for (var m, g, v = i + o, y = v - i, b = o - y, _ = b, x = v; l < n && u < r;) h < p ? (i = d, (l += 1) < n && (h = c(d = e[l]))) : (i = f, (u += 1) < r && (p = c(f = -t[u]))), (b = (o = _) - (y = (v = i + o) - i)) && (a[s++] = b), _ = x - ((m = x + v) - (g = m - x)) + (v - g), x = m;
              for (; l < n;) (b = (o = _) - (y = (v = (i = d) + o) - i)) && (a[s++] = b), _ = x - ((m = x + v) - (g = m - x)) + (v - g), x = m, (l += 1) < n && (d = e[l]);
              for (; u < r;) (b = (o = _) - (y = (v = (i = f) + o) - i)) && (a[s++] = b), _ = x - ((m = x + v) - (g = m - x)) + (v - g), x = m, (u += 1) < r && (f = -t[u]);
              return _ && (a[s++] = _), x && (a[s++] = x), s || (a[s++] = 0), a.length = s, a;
            };
          }, {}],
          326: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = 0 | e.length,
                r = 0 | t.length;
              if (1 === n && 1 === r) return function (e, t) {
                var n = e + t,
                  r = n - e,
                  i = e - (n - r) + (t - r);
                return i ? [i, n] : [n];
              }(e[0], t[0]);
              var i,
                o,
                a = new Array(n + r),
                s = 0,
                l = 0,
                u = 0,
                c = Math.abs,
                d = e[l],
                h = c(d),
                f = t[u],
                p = c(f);
              h < p ? (o = d, (l += 1) < n && (h = c(d = e[l]))) : (o = f, (u += 1) < r && (p = c(f = t[u]))), l < n && h < p || u >= r ? (i = d, (l += 1) < n && (h = c(d = e[l]))) : (i = f, (u += 1) < r && (p = c(f = t[u])));
              for (var m, g, v = i + o, y = v - i, b = o - y, _ = b, x = v; l < n && u < r;) h < p ? (i = d, (l += 1) < n && (h = c(d = e[l]))) : (i = f, (u += 1) < r && (p = c(f = t[u]))), (b = (o = _) - (y = (v = i + o) - i)) && (a[s++] = b), _ = x - ((m = x + v) - (g = m - x)) + (v - g), x = m;
              for (; l < n;) (b = (o = _) - (y = (v = (i = d) + o) - i)) && (a[s++] = b), _ = x - ((m = x + v) - (g = m - x)) + (v - g), x = m, (l += 1) < n && (d = e[l]);
              for (; u < r;) (b = (o = _) - (y = (v = (i = f) + o) - i)) && (a[s++] = b), _ = x - ((m = x + v) - (g = m - x)) + (v - g), x = m, (u += 1) < r && (f = t[u]);
              return _ && (a[s++] = _), x && (a[s++] = x), s || (a[s++] = 0), a.length = s, a;
            };
          }, {}],
          327: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              return e < 0 ? -1 : e > 0 ? 1 : 0;
            };
          }, {}],
          328: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              return i(r(e));
            };
            var r = e("boundary-cells"),
              i = e("reduce-simplicial-complex");
          }, {
            "boundary-cells": 39,
            "reduce-simplicial-complex": 313
          }],
          329: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, s) {
              if (n = n || 0, void 0 === s && (s = function (e) {
                for (var t = e.length, n = 0, r = 0; r < t; ++r) n = 0 | Math.max(n, e[r].length);
                return n - 1;
              }(e)), 0 === e.length || s < 1) return {
                cells: [],
                vertexIds: [],
                vertexWeights: []
              };
              var l = function (e, t) {
                  for (var n = e.length, r = i.mallocUint8(n), o = 0; o < n; ++o) r[o] = e[o] < t | 0;
                  return r;
                }(t, +n),
                u = function (e, t) {
                  for (var n = e.length, a = t * (t + 1) / 2 * n | 0, s = i.mallocUint32(2 * a), l = 0, u = 0; u < n; ++u) for (var c = e[u], d = (t = c.length, 0); d < t; ++d) for (var h = 0; h < d; ++h) {
                    var f = c[h],
                      p = c[d];
                    s[l++] = 0 | Math.min(f, p), s[l++] = 0 | Math.max(f, p);
                  }
                  o(r(s, [l / 2 | 0, 2]));
                  var m = 2;
                  for (u = 2; u < l; u += 2) s[u - 2] === s[u] && s[u - 1] === s[u + 1] || (s[m++] = s[u], s[m++] = s[u + 1]);
                  return r(s, [m / 2 | 0, 2]);
                }(e, s),
                c = function (e, t, n, o) {
                  for (var a = e.data, s = e.shape[0], l = i.mallocDouble(s), u = 0, c = 0; c < s; ++c) {
                    var d = a[2 * c],
                      h = a[2 * c + 1];
                    if (n[d] !== n[h]) {
                      var f = t[d],
                        p = t[h];
                      a[2 * u] = d, a[2 * u + 1] = h, l[u++] = (p - o) / (p - f);
                    }
                  }
                  return e.shape[0] = u, r(l, [u]);
                }(u, t, l, +n),
                d = function (e, t) {
                  var n = i.mallocInt32(2 * t),
                    r = e.shape[0],
                    o = e.data;
                  n[0] = 0;
                  for (var a = 0, s = 0; s < r; ++s) {
                    var l = o[2 * s];
                    if (l !== a) {
                      for (n[2 * a + 1] = s; ++a < l;) n[2 * a] = s, n[2 * a + 1] = s;
                      n[2 * a] = s;
                    }
                  }
                  for (n[2 * a + 1] = r; ++a < t;) n[2 * a] = n[2 * a + 1] = r;
                  return n;
                }(u, 0 | t.length),
                h = a(s)(e, u.data, d, l),
                f = function (e) {
                  for (var t = 0 | e.shape[0], n = e.data, r = new Array(t), i = 0; i < t; ++i) r[i] = [n[2 * i], n[2 * i + 1]];
                  return r;
                }(u),
                p = [].slice.call(c.data, 0, c.shape[0]);
              return i.free(l), i.free(u.data), i.free(c.data), i.free(d), {
                cells: h,
                vertexIds: f,
                vertexWeights: p
              };
            };
            var r = e("ndarray"),
              i = e("typedarray-pool"),
              o = e("ndarray-sort"),
              a = e("./lib/codegen");
          }, {
            "./lib/codegen": 330,
            ndarray: 285,
            "ndarray-sort": 283,
            "typedarray-pool": 347
          }],
          330: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = o[e];
              return t || (t = o[e] = function (e) {
                var t = 0,
                  n = new Array(e + 1);
                n[0] = [[]];
                for (var o = 1; o <= e; ++o) for (var a = n[o] = i(o), s = 0; s < a.length; ++s) t = Math.max(t, a[o].length);
                var l = ["function B(C,E,i,j){", "var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];", "while(l<h){", "var m=(l+h)>>1,v=E[2*m+1];", "if(v===b){return m}", "if(b<v){h=m}else{l=m+1}", "}", "return l;", "};", "function getContour", e, "d(F,E,C,S){", "var n=F.length,R=[];", "for(var i=0;i<n;++i){var c=F[i],l=c.length;"];
                function u(e) {
                  if (!(e.length <= 0)) {
                    l.push("R.push(");
                    for (var t = 0; t < e.length; ++t) {
                      var n = e[t];
                      t > 0 && l.push(","), l.push("[");
                      for (var r = 0; r < n.length; ++r) {
                        var i = n[r];
                        r > 0 && l.push(","), l.push("B(C,E,c[", i[0], "],c[", i[1], "])");
                      }
                      l.push("]");
                    }
                    l.push(");");
                  }
                }
                for (o = e + 1; o > 1; --o) {
                  o < e + 1 && l.push("else "), l.push("if(l===", o, "){");
                  var c = [];
                  for (s = 0; s < o; ++s) c.push("(S[c[" + s + "]]<<" + s + ")");
                  for (l.push("var M=", c.join("+"), ";if(M===0||M===", (1 << o) - 1, "){continue}switch(M){"), a = n[o - 1], s = 0; s < a.length; ++s) l.push("case ", s, ":"), u(a[s]), l.push("break;");
                  l.push("}}");
                }
                return l.push("}return R;};return getContour", e, "d"), new Function("pool", l.join(""))(r);
              }(e)), t;
            };
            var r = e("typedarray-pool"),
              i = e("marching-simplex-table"),
              o = {};
          }, {
            "marching-simplex-table": 263,
            "typedarray-pool": 347
          }],
          331: [function (e, t, n) {
            "use strict";

            var r = e("bit-twiddle"),
              i = e("union-find");
            function o(e, t) {
              var n = e.length,
                r = e.length - t.length,
                i = Math.min;
              if (r) return r;
              switch (n) {
                case 0:
                  return 0;
                case 1:
                  return e[0] - t[0];
                case 2:
                  return (s = e[0] + e[1] - t[0] - t[1]) || i(e[0], e[1]) - i(t[0], t[1]);
                case 3:
                  var o = e[0] + e[1],
                    a = t[0] + t[1];
                  if (s = o + e[2] - (a + t[2])) return s;
                  var s,
                    l = i(e[0], e[1]),
                    u = i(t[0], t[1]);
                  return (s = i(l, e[2]) - i(u, t[2])) || i(l + e[2], o) - i(u + t[2], a);
                default:
                  var c = e.slice(0);
                  c.sort();
                  var d = t.slice(0);
                  d.sort();
                  for (var h = 0; h < n; ++h) if (r = c[h] - d[h]) return r;
                  return 0;
              }
            }
            function a(e, t) {
              return o(e[0], t[0]);
            }
            function s(e, t) {
              if (t) {
                for (var n = e.length, r = new Array(n), i = 0; i < n; ++i) r[i] = [e[i], t[i]];
                for (r.sort(a), i = 0; i < n; ++i) e[i] = r[i][0], t[i] = r[i][1];
                return e;
              }
              return e.sort(o), e;
            }
            function l(e) {
              if (0 === e.length) return [];
              for (var t = 1, n = e.length, r = 1; r < n; ++r) {
                var i = e[r];
                if (o(i, e[r - 1])) {
                  if (r === t) {
                    t++;
                    continue;
                  }
                  e[t++] = i;
                }
              }
              return e.length = t, e;
            }
            function u(e, t) {
              for (var n = 0, r = e.length - 1, i = -1; n <= r;) {
                var a = n + r >> 1,
                  s = o(e[a], t);
                s <= 0 ? (0 === s && (i = a), n = a + 1) : s > 0 && (r = a - 1);
              }
              return i;
            }
            function c(e, t) {
              for (var n = new Array(e.length), i = 0, a = n.length; i < a; ++i) n[i] = [];
              for (var s = [], l = (i = 0, t.length); i < l; ++i) for (var c = t[i], d = c.length, h = 1, f = 1 << d; h < f; ++h) {
                s.length = r.popCount(h);
                for (var p = 0, m = 0; m < d; ++m) h & 1 << m && (s[p++] = c[m]);
                var g = u(e, s);
                if (!(g < 0)) for (; n[g++].push(i), !(g >= e.length || 0 !== o(e[g], s)););
              }
              return n;
            }
            function d(e, t) {
              if (t < 0) return [];
              for (var n = [], i = (1 << t + 1) - 1, o = 0; o < e.length; ++o) for (var a = e[o], l = i; l < 1 << a.length; l = r.nextCombination(l)) {
                for (var u = new Array(t + 1), c = 0, d = 0; d < a.length; ++d) l & 1 << d && (u[c++] = a[d]);
                n.push(u);
              }
              return s(n);
            }
            n.dimension = function (e) {
              for (var t = 0, n = Math.max, r = 0, i = e.length; r < i; ++r) t = n(t, e[r].length);
              return t - 1;
            }, n.countVertices = function (e) {
              for (var t = -1, n = Math.max, r = 0, i = e.length; r < i; ++r) for (var o = e[r], a = 0, s = o.length; a < s; ++a) t = n(t, o[a]);
              return t + 1;
            }, n.cloneCells = function (e) {
              for (var t = new Array(e.length), n = 0, r = e.length; n < r; ++n) t[n] = e[n].slice(0);
              return t;
            }, n.compareCells = o, n.normalize = s, n.unique = l, n.findCell = u, n.incidence = c, n.dual = function (e, t) {
              if (!t) return c(l(d(e, 0)), e);
              for (var n = new Array(t), r = 0; r < t; ++r) n[r] = [];
              r = 0;
              for (var i = e.length; r < i; ++r) for (var o = e[r], a = 0, s = o.length; a < s; ++a) n[o[a]].push(r);
              return n;
            }, n.explode = function (e) {
              for (var t = [], n = 0, r = e.length; n < r; ++n) for (var i = e[n], o = 0 | i.length, a = 1, l = 1 << o; a < l; ++a) {
                for (var u = [], c = 0; c < o; ++c) a >>> c & 1 && u.push(i[c]);
                t.push(u);
              }
              return s(t);
            }, n.skeleton = d, n.boundary = function (e) {
              for (var t = [], n = 0, r = e.length; n < r; ++n) for (var i = e[n], o = 0, a = i.length; o < a; ++o) {
                for (var l = new Array(i.length - 1), u = 0, c = 0; u < a; ++u) u !== o && (l[c++] = i[u]);
                t.push(l);
              }
              return s(t);
            }, n.connectedComponents = function (e, t) {
              return t ? function (e, t) {
                for (var n = new i(t), r = 0; r < e.length; ++r) for (var o = e[r], a = 0; a < o.length; ++a) for (var s = a + 1; s < o.length; ++s) n.link(o[a], o[s]);
                var l = [],
                  u = n.ranks;
                for (r = 0; r < u.length; ++r) u[r] = -1;
                for (r = 0; r < e.length; ++r) {
                  var c = n.find(e[r][0]);
                  u[c] < 0 ? (u[c] = l.length, l.push([e[r].slice(0)])) : l[u[c]].push(e[r].slice(0));
                }
                return l;
              }(e, t) : function (e) {
                for (var t = l(s(d(e, 0))), n = new i(t.length), r = 0; r < e.length; ++r) for (var o = e[r], a = 0; a < o.length; ++a) for (var c = u(t, [o[a]]), h = a + 1; h < o.length; ++h) n.link(c, u(t, [o[h]]));
                var f = [],
                  p = n.ranks;
                for (r = 0; r < p.length; ++r) p[r] = -1;
                for (r = 0; r < e.length; ++r) {
                  var m = n.find(u(t, [e[r][0]]));
                  p[m] < 0 ? (p[m] = f.length, f.push([e[r].slice(0)])) : f[p[m]].push(e[r].slice(0));
                }
                return f;
              }(e);
            };
          }, {
            "bit-twiddle": 37,
            "union-find": 348
          }],
          332: [function (e, t, n) {
            arguments[4][37][0].apply(n, arguments);
          }, {
            dup: 37
          }],
          333: [function (e, t, n) {
            arguments[4][331][0].apply(n, arguments);
          }, {
            "bit-twiddle": 332,
            dup: 331,
            "union-find": 334
          }],
          334: [function (e, t, n) {
            "use strict";

            function r(e) {
              this.roots = new Array(e), this.ranks = new Array(e);
              for (var t = 0; t < e; ++t) this.roots[t] = t, this.ranks[t] = 0;
            }
            t.exports = r, r.prototype.length = function () {
              return this.roots.length;
            }, r.prototype.makeSet = function () {
              var e = this.roots.length;
              return this.roots.push(e), this.ranks.push(0), e;
            }, r.prototype.find = function (e) {
              for (var t = this.roots; t[e] !== e;) {
                var n = t[e];
                t[e] = t[n], e = n;
              }
              return e;
            }, r.prototype.link = function (e, t) {
              var n = this.find(e),
                r = this.find(t);
              if (n !== r) {
                var i = this.ranks,
                  o = this.roots,
                  a = i[n],
                  s = i[r];
                a < s ? o[n] = r : s < a ? o[r] = n : (o[r] = n, ++i[n]);
              }
            };
          }, {}],
          335: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              for (var o = t.length, a = e.length, s = new Array(o), l = new Array(o), u = new Array(o), c = new Array(o), d = 0; d < o; ++d) s[d] = l[d] = -1, u[d] = 1 / 0, c[d] = !1;
              for (d = 0; d < a; ++d) {
                var h = e[d];
                if (2 !== h.length) throw new Error("Input must be a graph");
                var f = h[1],
                  p = h[0];
                -1 !== l[p] ? l[p] = -2 : l[p] = f, -1 !== s[f] ? s[f] = -2 : s[f] = p;
              }
              function m(e) {
                if (c[e]) return 1 / 0;
                var n,
                  i,
                  o,
                  a = s[e],
                  u = l[e];
                return a < 0 || u < 0 ? 1 / 0 : (n = t[e], i = t[a], o = t[u], Math.abs(r(n, i, o)) / Math.sqrt(Math.pow(i[0] - o[0], 2) + Math.pow(i[1] - o[1], 2)));
              }
              function g(e, t) {
                var n = A[e],
                  r = A[t];
                A[e] = r, A[t] = n, E[n] = t, E[r] = e;
              }
              function v(e) {
                return u[A[e]];
              }
              function y(e) {
                return 1 & e ? e - 1 >> 1 : (e >> 1) - 1;
              }
              function b(e) {
                for (var t = v(e);;) {
                  var n = t,
                    r = 2 * e + 1,
                    i = 2 * (e + 1),
                    o = e;
                  if (r < T) {
                    var a = v(r);
                    a < n && (o = r, n = a);
                  }
                  if (i < T && v(i) < n && (o = i), o === e) return e;
                  g(e, o), e = o;
                }
              }
              function _(e) {
                for (var t = v(e); e > 0;) {
                  var n = y(e);
                  if (!(n >= 0 && t < v(n))) return e;
                  g(e, n), e = n;
                }
              }
              function x() {
                if (T > 0) {
                  var e = A[0];
                  return g(0, T - 1), T -= 1, b(0), e;
                }
                return -1;
              }
              function w(e, t) {
                var n = A[e];
                return u[n] === t ? e : (u[n] = -1 / 0, _(e), x(), u[n] = t, _((T += 1) - 1));
              }
              function S(e) {
                if (!c[e]) {
                  c[e] = !0;
                  var t = s[e],
                    n = l[e];
                  s[n] >= 0 && (s[n] = t), l[t] >= 0 && (l[t] = n), E[t] >= 0 && w(E[t], m(t)), E[n] >= 0 && w(E[n], m(n));
                }
              }
              var A = [],
                E = new Array(o);
              for (d = 0; d < o; ++d) (u[d] = m(d)) < 1 / 0 ? (E[d] = A.length, A.push(d)) : E[d] = -1;
              var T = A.length;
              for (d = T >> 1; d >= 0; --d) b(d);
              for (;;) {
                var M = x();
                if (M < 0 || u[M] > n) break;
                S(M);
              }
              var C = [];
              for (d = 0; d < o; ++d) c[d] || (E[d] = C.length, C.push(t[d].slice()));
              function k(e, t) {
                if (e[t] < 0) return t;
                var n = t,
                  r = t;
                do {
                  var i = e[r];
                  if (!c[r] || i < 0 || i === r) break;
                  if (i = e[r = i], !c[r] || i < 0 || i === r) break;
                  r = i, n = e[n];
                } while (n !== r);
                for (var o = t; o !== r; o = e[o]) e[o] = r;
                return r;
              }
              C.length;
              var P = [];
              return e.forEach(function (e) {
                var t = k(s, e[0]),
                  n = k(l, e[1]);
                if (t >= 0 && n >= 0 && t !== n) {
                  var r = E[t],
                    i = E[n];
                  r !== i && P.push([r, i]);
                }
              }), i.unique(i.normalize(P)), {
                positions: C,
                edges: P
              };
            };
            var r = e("robust-orientation"),
              i = e("simplicial-complex");
          }, {
            "robust-orientation": 321,
            "simplicial-complex": 333
          }],
          336: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n, o, a, s;
              if (t[0][0] < t[1][0]) n = t[0], o = t[1];else {
                if (!(t[0][0] > t[1][0])) return i(t, e);
                n = t[1], o = t[0];
              }
              if (e[0][0] < e[1][0]) a = e[0], s = e[1];else {
                if (!(e[0][0] > e[1][0])) return -i(e, t);
                a = e[1], s = e[0];
              }
              var l = r(n, o, s),
                u = r(n, o, a);
              if (l < 0) {
                if (u <= 0) return l;
              } else if (l > 0) {
                if (u >= 0) return l;
              } else if (u) return u;
              if (l = r(s, a, o), u = r(s, a, n), l < 0) {
                if (u <= 0) return l;
              } else if (l > 0) {
                if (u >= 0) return l;
              } else if (u) return u;
              return o[0] - s[0];
            };
            var r = e("robust-orientation");
            function i(e, t) {
              var n, i, o, a;
              if (t[0][0] < t[1][0]) n = t[0], i = t[1];else {
                if (!(t[0][0] > t[1][0])) {
                  var s = Math.min(e[0][1], e[1][1]),
                    l = Math.max(e[0][1], e[1][1]),
                    u = Math.min(t[0][1], t[1][1]),
                    c = Math.max(t[0][1], t[1][1]);
                  return l < u ? l - u : s > c ? s - c : l - c;
                }
                n = t[1], i = t[0];
              }
              e[0][1] < e[1][1] ? (o = e[0], a = e[1]) : (o = e[1], a = e[0]);
              var d = r(i, n, o);
              return d || (d = r(i, n, a)) || a - i;
            }
          }, {
            "robust-orientation": 321
          }],
          337: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = e.length, n = 2 * t, r = new Array(n), o = 0; o < t; ++o) {
                var l = e[o],
                  u = l[0][0] < l[1][0];
                r[2 * o] = new d(l[0][0], l, u, o), r[2 * o + 1] = new d(l[1][0], l, !u, o);
              }
              r.sort(function (e, t) {
                var n = e.x - t.x;
                return n || (n = e.create - t.create) || Math.min(e.segment[0][1], e.segment[1][1]) - Math.min(t.segment[0][1], t.segment[1][1]);
              });
              var h = i(a),
                f = [],
                p = [],
                m = [];
              for (o = 0; o < n;) {
                for (var g = r[o].x, v = []; o < n;) {
                  var y = r[o];
                  if (y.x !== g) break;
                  o += 1, y.segment[0][0] === y.x && y.segment[1][0] === y.x ? y.create && (y.segment[0][1] < y.segment[1][1] ? (v.push(new c(y.segment[0][1], y.index, !0, !0)), v.push(new c(y.segment[1][1], y.index, !1, !1))) : (v.push(new c(y.segment[1][1], y.index, !0, !1)), v.push(new c(y.segment[0][1], y.index, !1, !0)))) : h = y.create ? h.insert(y.segment, y.index) : h.remove(y.segment);
                }
                f.push(h.root), p.push(g), m.push(v);
              }
              return new s(f, p, m);
            };
            var r = e("binary-search-bounds"),
              i = e("functional-red-black-tree"),
              o = e("robust-orientation"),
              a = e("./lib/order-segments");
            function s(e, t, n) {
              this.slabs = e, this.coordinates = t, this.horizontal = n;
            }
            function l(e, t) {
              return e.y - t;
            }
            function u(e, t) {
              for (var n = null; e;) {
                var r,
                  i,
                  a = e.key;
                a[0][0] < a[1][0] ? (r = a[0], i = a[1]) : (r = a[1], i = a[0]);
                var s = o(r, i, t);
                if (s < 0) e = e.left;else if (s > 0) {
                  if (t[0] !== a[1][0]) n = e, e = e.right;else {
                    if (l = u(e.right, t)) return l;
                    e = e.left;
                  }
                } else {
                  if (t[0] !== a[1][0]) return e;
                  var l;
                  if (l = u(e.right, t)) return l;
                  e = e.left;
                }
              }
              return n;
            }
            function c(e, t, n, r) {
              this.y = e, this.index = t, this.start = n, this.closed = r;
            }
            function d(e, t, n, r) {
              this.x = e, this.segment = t, this.create = n, this.index = r;
            }
            s.prototype.castUp = function (e) {
              var t = r.le(this.coordinates, e[0]);
              if (t < 0) return -1;
              this.slabs[t];
              var n = u(this.slabs[t], e),
                i = -1;
              if (n && (i = n.value), this.coordinates[t] === e[0]) {
                var s = null;
                if (n && (s = n.key), t > 0) {
                  var c = u(this.slabs[t - 1], e);
                  c && (s ? a(c.key, s) > 0 && (s = c.key, i = c.value) : (i = c.value, s = c.key));
                }
                var d = this.horizontal[t];
                if (d.length > 0) {
                  var h = r.ge(d, e[1], l);
                  if (h < d.length) {
                    var f = d[h];
                    if (e[1] === f.y) {
                      if (f.closed) return f.index;
                      for (; h < d.length - 1 && d[h + 1].y === e[1];) if ((f = d[h += 1]).closed) return f.index;
                      if (f.y === e[1] && !f.start) {
                        if ((h += 1) >= d.length) return i;
                        f = d[h];
                      }
                    }
                    if (f.start) {
                      if (s) {
                        var p = o(s[0], s[1], [e[0], f.y]);
                        s[0][0] > s[1][0] && (p = -p), p > 0 && (i = f.index);
                      } else i = f.index;
                    } else f.y !== e[1] && (i = f.index);
                  }
                }
              }
              return i;
            };
          }, {
            "./lib/order-segments": 336,
            "binary-search-bounds": 36,
            "functional-red-black-tree": 93,
            "robust-orientation": 321
          }],
          338: [function (e, t, n) {
            "use strict";

            var r = e("robust-dot-product"),
              i = e("robust-sum");
            function o(e, t) {
              var n = i(r(e, t), [t[t.length - 1]]);
              return n[n.length - 1];
            }
            function a(e, t, n, r) {
              var i = -t / (r - t);
              i < 0 ? i = 0 : i > 1 && (i = 1);
              for (var o = 1 - i, a = e.length, s = new Array(a), l = 0; l < a; ++l) s[l] = i * e[l] + o * n[l];
              return s;
            }
            t.exports = function (e, t) {
              for (var n = [], r = [], i = o(e[e.length - 1], t), s = e[e.length - 1], l = e[0], u = 0; u < e.length; ++u, s = l) {
                var c = o(l = e[u], t);
                if (i < 0 && c > 0 || i > 0 && c < 0) {
                  var d = a(s, c, l, i);
                  n.push(d), r.push(d.slice());
                }
                c < 0 ? r.push(l.slice()) : c > 0 ? n.push(l.slice()) : (n.push(l.slice()), r.push(l.slice())), i = c;
              }
              return {
                positive: n,
                negative: r
              };
            }, t.exports.positive = function (e, t) {
              for (var n = [], r = o(e[e.length - 1], t), i = e[e.length - 1], s = e[0], l = 0; l < e.length; ++l, i = s) {
                var u = o(s = e[l], t);
                (r < 0 && u > 0 || r > 0 && u < 0) && n.push(a(i, u, s, r)), u >= 0 && n.push(s.slice()), r = u;
              }
              return n;
            }, t.exports.negative = function (e, t) {
              for (var n = [], r = o(e[e.length - 1], t), i = e[e.length - 1], s = e[0], l = 0; l < e.length; ++l, i = s) {
                var u = o(s = e[l], t);
                (r < 0 && u > 0 || r > 0 && u < 0) && n.push(a(i, u, s, r)), u <= 0 && n.push(s.slice()), r = u;
              }
              return n;
            };
          }, {
            "robust-dot-product": 318,
            "robust-sum": 326
          }],
          339: [function (e, t, n) {
            !function () {
              "use strict";

              var e = {
                not_string: /[^s]/,
                not_bool: /[^t]/,
                not_type: /[^T]/,
                not_primitive: /[^v]/,
                number: /[diefg]/,
                numeric_arg: /[bcdiefguxX]/,
                json: /[j]/,
                not_json: /[^j]/,
                text: /^[^\x25]+/,
                modulo: /^\x25{2}/,
                placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
                key: /^([a-z_][a-z_\d]*)/i,
                key_access: /^\.([a-z_][a-z_\d]*)/i,
                index_access: /^\[(\d+)\]/,
                sign: /^[+-]/
              };
              function t(n) {
                return function (n, r) {
                  var i,
                    o,
                    a,
                    s,
                    l,
                    u,
                    c,
                    d,
                    h,
                    f = 1,
                    p = n.length,
                    m = "";
                  for (o = 0; o < p; o++) if ("string" == typeof n[o]) m += n[o];else if ("object" == typeof n[o]) {
                    if ((s = n[o]).keys) for (i = r[f], a = 0; a < s.keys.length; a++) {
                      if (null == i) throw new Error(t('[sprintf] Cannot access property "%s" of undefined value "%s"', s.keys[a], s.keys[a - 1]));
                      i = i[s.keys[a]];
                    } else i = s.param_no ? r[s.param_no] : r[f++];
                    if (e.not_type.test(s.type) && e.not_primitive.test(s.type) && i instanceof Function && (i = i()), e.numeric_arg.test(s.type) && "number" != typeof i && isNaN(i)) throw new TypeError(t("[sprintf] expecting number but found %T", i));
                    switch (e.number.test(s.type) && (d = i >= 0), s.type) {
                      case "b":
                        i = parseInt(i, 10).toString(2);
                        break;
                      case "c":
                        i = String.fromCharCode(parseInt(i, 10));
                        break;
                      case "d":
                      case "i":
                        i = parseInt(i, 10);
                        break;
                      case "j":
                        i = JSON.stringify(i, null, s.width ? parseInt(s.width) : 0);
                        break;
                      case "e":
                        i = s.precision ? parseFloat(i).toExponential(s.precision) : parseFloat(i).toExponential();
                        break;
                      case "f":
                        i = s.precision ? parseFloat(i).toFixed(s.precision) : parseFloat(i);
                        break;
                      case "g":
                        i = s.precision ? String(Number(i.toPrecision(s.precision))) : parseFloat(i);
                        break;
                      case "o":
                        i = (parseInt(i, 10) >>> 0).toString(8);
                        break;
                      case "s":
                        i = String(i), i = s.precision ? i.substring(0, s.precision) : i;
                        break;
                      case "t":
                        i = String(!!i), i = s.precision ? i.substring(0, s.precision) : i;
                        break;
                      case "T":
                        i = Object.prototype.toString.call(i).slice(8, -1).toLowerCase(), i = s.precision ? i.substring(0, s.precision) : i;
                        break;
                      case "u":
                        i = parseInt(i, 10) >>> 0;
                        break;
                      case "v":
                        i = i.valueOf(), i = s.precision ? i.substring(0, s.precision) : i;
                        break;
                      case "x":
                        i = (parseInt(i, 10) >>> 0).toString(16);
                        break;
                      case "X":
                        i = (parseInt(i, 10) >>> 0).toString(16).toUpperCase();
                    }
                    e.json.test(s.type) ? m += i : (!e.number.test(s.type) || d && !s.sign ? h = "" : (h = d ? "+" : "-", i = i.toString().replace(e.sign, "")), u = s.pad_char ? "0" === s.pad_char ? "0" : s.pad_char.charAt(1) : " ", c = s.width - (h + i).length, l = s.width && c > 0 ? u.repeat(c) : "", m += s.align ? h + i + l : "0" === u ? h + l + i : l + h + i);
                  }
                  return m;
                }(function (t) {
                  if (i[t]) return i[t];
                  for (var n, r = t, o = [], a = 0; r;) {
                    if (null !== (n = e.text.exec(r))) o.push(n[0]);else if (null !== (n = e.modulo.exec(r))) o.push("%");else {
                      if (null === (n = e.placeholder.exec(r))) throw new SyntaxError("[sprintf] unexpected placeholder");
                      if (n[2]) {
                        a |= 1;
                        var s = [],
                          l = n[2],
                          u = [];
                        if (null === (u = e.key.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                        for (s.push(u[1]); "" !== (l = l.substring(u[0].length));) if (null !== (u = e.key_access.exec(l))) s.push(u[1]);else {
                          if (null === (u = e.index_access.exec(l))) throw new SyntaxError("[sprintf] failed to parse named argument key");
                          s.push(u[1]);
                        }
                        n[2] = s;
                      } else a |= 2;
                      if (3 === a) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                      o.push({
                        placeholder: n[0],
                        param_no: n[1],
                        keys: n[2],
                        sign: n[3],
                        pad_char: n[4],
                        align: n[5],
                        width: n[6],
                        precision: n[7],
                        type: n[8]
                      });
                    }
                    r = r.substring(n[0].length);
                  }
                  return i[t] = o;
                }(n), arguments);
              }
              function r(e, n) {
                return t.apply(null, [e].concat(n || []));
              }
              var i = Object.create(null);
              void 0 !== n && (n.sprintf = t, n.vsprintf = r), "undefined" != typeof window && (window.sprintf = t, window.vsprintf = r);
            }();
          }, {}],
          340: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              if (e.dimension <= 0) return {
                positions: [],
                cells: []
              };
              if (1 === e.dimension) return function (e, t) {
                for (var n = o(e, t), r = n.length, i = new Array(r), a = new Array(r), s = 0; s < r; ++s) i[s] = [n[s]], a[s] = [s];
                return {
                  positions: i,
                  cells: a
                };
              }(e, t);
              var n = e.order.join() + "-" + e.dtype,
                s = a[n];
              return t = +t || 0, s || (s = a[n] = function (e, t) {
                var n = e.length,
                  o = ["'use strict';"],
                  a = "surfaceNets" + e.join("_") + "d" + t;
                o.push("var contour=genContour({", "order:[", e.join(), "],", "scalarArguments: 3,", "phase:function phaseFunc(p,a,b,c) { return (p > c)|0 },"), "generic" === t && o.push("getters:[0],");
                for (var s = [], l = [], u = 0; u < n; ++u) s.push("d" + u), l.push("d" + u);
                for (u = 0; u < 1 << n; ++u) s.push("v" + u), l.push("v" + u);
                for (u = 0; u < 1 << n; ++u) s.push("p" + u), l.push("p" + u);
                s.push("a", "b", "c"), l.push("a", "c"), o.push("vertex:function vertexFunc(", s.join(), "){");
                var c = [];
                for (u = 0; u < 1 << n; ++u) c.push("(p" + u + "<<" + u + ")");
                o.push("var m=(", c.join("+"), ")|0;if(m===0||m===", (1 << (1 << n)) - 1, "){return}");
                var d = [],
                  h = [];
                for (1 << (1 << n) <= 128 ? (o.push("switch(m){"), h = o) : o.push("switch(m>>>7){"), u = 0; u < 1 << (1 << n); ++u) {
                  if (1 << (1 << n) > 128 && u % 128 == 0) {
                    d.length > 0 && h.push("}}");
                    var f = "vExtra" + d.length;
                    o.push("case ", u >>> 7, ":", f, "(m&0x7f,", l.join(), ");break;"), h = ["function ", f, "(m,", l.join(), "){switch(m){"], d.push(h);
                  }
                  h.push("case ", 127 & u, ":");
                  for (var p = new Array(n), m = new Array(n), g = new Array(n), v = new Array(n), y = 0, b = 0; b < n; ++b) p[b] = [], m[b] = [], g[b] = 0, v[b] = 0;
                  for (b = 0; b < 1 << n; ++b) for (var _ = 0; _ < n; ++_) {
                    var x = b ^ 1 << _;
                    if (!(x > b) && !(u & 1 << x) != !(u & 1 << b)) {
                      var w = 1;
                      u & 1 << x ? m[_].push("v" + x + "-v" + b) : (m[_].push("v" + b + "-v" + x), w = -w), w < 0 ? (p[_].push("-v" + b + "-v" + x), g[_] += 2) : (p[_].push("v" + b + "+v" + x), g[_] -= 2), y += 1;
                      for (var S = 0; S < n; ++S) S !== _ && (x & 1 << S ? v[S] += 1 : v[S] -= 1);
                    }
                  }
                  var A = [];
                  for (_ = 0; _ < n; ++_) if (0 === p[_].length) A.push("d" + _ + "-0.5");else {
                    var E = "";
                    g[_] < 0 ? E = g[_] + "*c" : g[_] > 0 && (E = "+" + g[_] + "*c");
                    var T = p[_].length / y * .5,
                      M = .5 + v[_] / y * .5;
                    A.push("d" + _ + "-" + M + "-" + T + "*(" + p[_].join("+") + E + ")/(" + m[_].join("+") + ")");
                  }
                  h.push("a.push([", A.join(), "]);", "break;");
                }
                o.push("}},"), d.length > 0 && h.push("}}");
                var C = [];
                for (u = 0; u < 1 << n - 1; ++u) C.push("v" + u);
                C.push("c0", "c1", "p0", "p1", "a", "b", "c"), o.push("cell:function cellFunc(", C.join(), "){");
                var k = i(n - 1);
                for (o.push("if(p0){b.push(", k.map(function (e) {
                  return "[" + e.map(function (e) {
                    return "v" + e;
                  }) + "]";
                }).join(), ")}else{b.push(", k.map(function (e) {
                  var t = e.slice();
                  return t.reverse(), "[" + t.map(function (e) {
                    return "v" + e;
                  }) + "]";
                }).join(), ")}}});function ", a, "(array,level){var verts=[],cells=[];contour(array,verts,cells,level);return {positions:verts,cells:cells};} return ", a, ";"), u = 0; u < d.length; ++u) o.push(d[u].join(""));
                return new Function("genContour", o.join(""))(r);
              }(e.order, e.dtype)), s(e, t);
            };
            var r = e("ndarray-extract-contour"),
              i = e("triangulate-hypercube"),
              o = e("zero-crossings"),
              a = {};
          }, {
            "ndarray-extract-contour": 274,
            "triangulate-hypercube": 343,
            "zero-crossings": 358
          }],
          341: [function (e, t, n) {
            !function (e) {
              var n = /^\s+/,
                r = /\s+$/,
                i = 0,
                o = e.round,
                a = e.min,
                s = e.max,
                l = e.random;
              function u(t, l) {
                if (l = l || {}, (t = t || "") instanceof u) return t;
                if (!(this instanceof u)) return new u(t, l);
                var c = function (t) {
                  var i,
                    o,
                    l,
                    u = {
                      r: 0,
                      g: 0,
                      b: 0
                    },
                    c = 1,
                    d = null,
                    h = null,
                    f = null,
                    p = !1,
                    m = !1;
                  return "string" == typeof t && (t = function (e) {
                    e = e.replace(n, "").replace(r, "").toLowerCase();
                    var t,
                      i = !1;
                    if (M[e]) e = M[e], i = !0;else if ("transparent" == e) return {
                      r: 0,
                      g: 0,
                      b: 0,
                      a: 0,
                      format: "name"
                    };
                    return (t = z.rgb.exec(e)) ? {
                      r: t[1],
                      g: t[2],
                      b: t[3]
                    } : (t = z.rgba.exec(e)) ? {
                      r: t[1],
                      g: t[2],
                      b: t[3],
                      a: t[4]
                    } : (t = z.hsl.exec(e)) ? {
                      h: t[1],
                      s: t[2],
                      l: t[3]
                    } : (t = z.hsla.exec(e)) ? {
                      h: t[1],
                      s: t[2],
                      l: t[3],
                      a: t[4]
                    } : (t = z.hsv.exec(e)) ? {
                      h: t[1],
                      s: t[2],
                      v: t[3]
                    } : (t = z.hsva.exec(e)) ? {
                      h: t[1],
                      s: t[2],
                      v: t[3],
                      a: t[4]
                    } : (t = z.hex8.exec(e)) ? {
                      r: R(t[1]),
                      g: R(t[2]),
                      b: R(t[3]),
                      a: L(t[4]),
                      format: i ? "name" : "hex8"
                    } : (t = z.hex6.exec(e)) ? {
                      r: R(t[1]),
                      g: R(t[2]),
                      b: R(t[3]),
                      format: i ? "name" : "hex"
                    } : (t = z.hex4.exec(e)) ? {
                      r: R(t[1] + "" + t[1]),
                      g: R(t[2] + "" + t[2]),
                      b: R(t[3] + "" + t[3]),
                      a: L(t[4] + "" + t[4]),
                      format: i ? "name" : "hex8"
                    } : !!(t = z.hex3.exec(e)) && {
                      r: R(t[1] + "" + t[1]),
                      g: R(t[2] + "" + t[2]),
                      b: R(t[3] + "" + t[3]),
                      format: i ? "name" : "hex"
                    };
                  }(t)), "object" == typeof t && (U(t.r) && U(t.g) && U(t.b) ? (i = t.r, o = t.g, l = t.b, u = {
                    r: 255 * P(i, 255),
                    g: 255 * P(o, 255),
                    b: 255 * P(l, 255)
                  }, p = !0, m = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : U(t.h) && U(t.s) && U(t.v) ? (d = j(t.s), h = j(t.v), u = function (t, n, r) {
                    t = 6 * P(t, 360), n = P(n, 100), r = P(r, 100);
                    var i = e.floor(t),
                      o = t - i,
                      a = r * (1 - n),
                      s = r * (1 - o * n),
                      l = r * (1 - (1 - o) * n),
                      u = i % 6;
                    return {
                      r: 255 * [r, s, a, a, l, r][u],
                      g: 255 * [l, r, r, s, a, a][u],
                      b: 255 * [a, a, l, r, r, s][u]
                    };
                  }(t.h, d, h), p = !0, m = "hsv") : U(t.h) && U(t.s) && U(t.l) && (d = j(t.s), f = j(t.l), u = function (e, t, n) {
                    var r, i, o;
                    function a(e, t, n) {
                      return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
                    }
                    if (e = P(e, 360), t = P(t, 100), n = P(n, 100), 0 === t) r = i = o = n;else {
                      var s = n < .5 ? n * (1 + t) : n + t - n * t,
                        l = 2 * n - s;
                      r = a(l, s, e + 1 / 3), i = a(l, s, e), o = a(l, s, e - 1 / 3);
                    }
                    return {
                      r: 255 * r,
                      g: 255 * i,
                      b: 255 * o
                    };
                  }(t.h, d, f), p = !0, m = "hsl"), t.hasOwnProperty("a") && (c = t.a)), c = k(c), {
                    ok: p,
                    format: t.format || m,
                    r: a(255, s(u.r, 0)),
                    g: a(255, s(u.g, 0)),
                    b: a(255, s(u.b, 0)),
                    a: c
                  };
                }(t);
                this._originalInput = t, this._r = c.r, this._g = c.g, this._b = c.b, this._a = c.a, this._roundA = o(100 * this._a) / 100, this._format = l.format || c.format, this._gradientType = l.gradientType, this._r < 1 && (this._r = o(this._r)), this._g < 1 && (this._g = o(this._g)), this._b < 1 && (this._b = o(this._b)), this._ok = c.ok, this._tc_id = i++;
              }
              function c(e, t, n) {
                e = P(e, 255), t = P(t, 255), n = P(n, 255);
                var r,
                  i,
                  o = s(e, t, n),
                  l = a(e, t, n),
                  u = (o + l) / 2;
                if (o == l) r = i = 0;else {
                  var c = o - l;
                  switch (i = u > .5 ? c / (2 - o - l) : c / (o + l), o) {
                    case e:
                      r = (t - n) / c + (t < n ? 6 : 0);
                      break;
                    case t:
                      r = (n - e) / c + 2;
                      break;
                    case n:
                      r = (e - t) / c + 4;
                  }
                  r /= 6;
                }
                return {
                  h: r,
                  s: i,
                  l: u
                };
              }
              function d(e, t, n) {
                e = P(e, 255), t = P(t, 255), n = P(n, 255);
                var r,
                  i,
                  o = s(e, t, n),
                  l = a(e, t, n),
                  u = o,
                  c = o - l;
                if (i = 0 === o ? 0 : c / o, o == l) r = 0;else {
                  switch (o) {
                    case e:
                      r = (t - n) / c + (t < n ? 6 : 0);
                      break;
                    case t:
                      r = (n - e) / c + 2;
                      break;
                    case n:
                      r = (e - t) / c + 4;
                  }
                  r /= 6;
                }
                return {
                  h: r,
                  s: i,
                  v: u
                };
              }
              function h(e, t, n, r) {
                var i = [I(o(e).toString(16)), I(o(t).toString(16)), I(o(n).toString(16))];
                return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
              }
              function f(e, t, n, r) {
                return [I(N(r)), I(o(e).toString(16)), I(o(t).toString(16)), I(o(n).toString(16))].join("");
              }
              function p(e, t) {
                t = 0 === t ? 0 : t || 10;
                var n = u(e).toHsl();
                return n.s -= t / 100, n.s = O(n.s), u(n);
              }
              function m(e, t) {
                t = 0 === t ? 0 : t || 10;
                var n = u(e).toHsl();
                return n.s += t / 100, n.s = O(n.s), u(n);
              }
              function g(e) {
                return u(e).desaturate(100);
              }
              function v(e, t) {
                t = 0 === t ? 0 : t || 10;
                var n = u(e).toHsl();
                return n.l += t / 100, n.l = O(n.l), u(n);
              }
              function y(e, t) {
                t = 0 === t ? 0 : t || 10;
                var n = u(e).toRgb();
                return n.r = s(0, a(255, n.r - o(-t / 100 * 255))), n.g = s(0, a(255, n.g - o(-t / 100 * 255))), n.b = s(0, a(255, n.b - o(-t / 100 * 255))), u(n);
              }
              function b(e, t) {
                t = 0 === t ? 0 : t || 10;
                var n = u(e).toHsl();
                return n.l -= t / 100, n.l = O(n.l), u(n);
              }
              function _(e, t) {
                var n = u(e).toHsl(),
                  r = (n.h + t) % 360;
                return n.h = r < 0 ? 360 + r : r, u(n);
              }
              function x(e) {
                var t = u(e).toHsl();
                return t.h = (t.h + 180) % 360, u(t);
              }
              function w(e) {
                var t = u(e).toHsl(),
                  n = t.h;
                return [u(e), u({
                  h: (n + 120) % 360,
                  s: t.s,
                  l: t.l
                }), u({
                  h: (n + 240) % 360,
                  s: t.s,
                  l: t.l
                })];
              }
              function S(e) {
                var t = u(e).toHsl(),
                  n = t.h;
                return [u(e), u({
                  h: (n + 90) % 360,
                  s: t.s,
                  l: t.l
                }), u({
                  h: (n + 180) % 360,
                  s: t.s,
                  l: t.l
                }), u({
                  h: (n + 270) % 360,
                  s: t.s,
                  l: t.l
                })];
              }
              function A(e) {
                var t = u(e).toHsl(),
                  n = t.h;
                return [u(e), u({
                  h: (n + 72) % 360,
                  s: t.s,
                  l: t.l
                }), u({
                  h: (n + 216) % 360,
                  s: t.s,
                  l: t.l
                })];
              }
              function E(e, t, n) {
                t = t || 6, n = n || 30;
                var r = u(e).toHsl(),
                  i = 360 / n,
                  o = [u(e)];
                for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t;) r.h = (r.h + i) % 360, o.push(u(r));
                return o;
              }
              function T(e, t) {
                t = t || 6;
                for (var n = u(e).toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / t; t--;) a.push(u({
                  h: r,
                  s: i,
                  v: o
                })), o = (o + s) % 1;
                return a;
              }
              u.prototype = {
                isDark: function isDark() {
                  return this.getBrightness() < 128;
                },
                isLight: function isLight() {
                  return !this.isDark();
                },
                isValid: function isValid() {
                  return this._ok;
                },
                getOriginalInput: function getOriginalInput() {
                  return this._originalInput;
                },
                getFormat: function getFormat() {
                  return this._format;
                },
                getAlpha: function getAlpha() {
                  return this._a;
                },
                getBrightness: function getBrightness() {
                  var e = this.toRgb();
                  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3;
                },
                getLuminance: function getLuminance() {
                  var t,
                    n,
                    r,
                    i = this.toRgb();
                  return t = i.r / 255, n = i.g / 255, r = i.b / 255, .2126 * (t <= .03928 ? t / 12.92 : e.pow((t + .055) / 1.055, 2.4)) + .7152 * (n <= .03928 ? n / 12.92 : e.pow((n + .055) / 1.055, 2.4)) + .0722 * (r <= .03928 ? r / 12.92 : e.pow((r + .055) / 1.055, 2.4));
                },
                setAlpha: function setAlpha(e) {
                  return this._a = k(e), this._roundA = o(100 * this._a) / 100, this;
                },
                toHsv: function toHsv() {
                  var e = d(this._r, this._g, this._b);
                  return {
                    h: 360 * e.h,
                    s: e.s,
                    v: e.v,
                    a: this._a
                  };
                },
                toHsvString: function toHsvString() {
                  var e = d(this._r, this._g, this._b),
                    t = o(360 * e.h),
                    n = o(100 * e.s),
                    r = o(100 * e.v);
                  return 1 == this._a ? "hsv(" + t + ", " + n + "%, " + r + "%)" : "hsva(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
                },
                toHsl: function toHsl() {
                  var e = c(this._r, this._g, this._b);
                  return {
                    h: 360 * e.h,
                    s: e.s,
                    l: e.l,
                    a: this._a
                  };
                },
                toHslString: function toHslString() {
                  var e = c(this._r, this._g, this._b),
                    t = o(360 * e.h),
                    n = o(100 * e.s),
                    r = o(100 * e.l);
                  return 1 == this._a ? "hsl(" + t + ", " + n + "%, " + r + "%)" : "hsla(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
                },
                toHex: function toHex(e) {
                  return h(this._r, this._g, this._b, e);
                },
                toHexString: function toHexString(e) {
                  return "#" + this.toHex(e);
                },
                toHex8: function toHex8(e) {
                  return function (e, t, n, r, i) {
                    var a = [I(o(e).toString(16)), I(o(t).toString(16)), I(o(n).toString(16)), I(N(r))];
                    return i && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
                  }(this._r, this._g, this._b, this._a, e);
                },
                toHex8String: function toHex8String(e) {
                  return "#" + this.toHex8(e);
                },
                toRgb: function toRgb() {
                  return {
                    r: o(this._r),
                    g: o(this._g),
                    b: o(this._b),
                    a: this._a
                  };
                },
                toRgbString: function toRgbString() {
                  return 1 == this._a ? "rgb(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ")" : "rgba(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ", " + this._roundA + ")";
                },
                toPercentageRgb: function toPercentageRgb() {
                  return {
                    r: o(100 * P(this._r, 255)) + "%",
                    g: o(100 * P(this._g, 255)) + "%",
                    b: o(100 * P(this._b, 255)) + "%",
                    a: this._a
                  };
                },
                toPercentageRgbString: function toPercentageRgbString() {
                  return 1 == this._a ? "rgb(" + o(100 * P(this._r, 255)) + "%, " + o(100 * P(this._g, 255)) + "%, " + o(100 * P(this._b, 255)) + "%)" : "rgba(" + o(100 * P(this._r, 255)) + "%, " + o(100 * P(this._g, 255)) + "%, " + o(100 * P(this._b, 255)) + "%, " + this._roundA + ")";
                },
                toName: function toName() {
                  return 0 === this._a ? "transparent" : !(this._a < 1) && (C[h(this._r, this._g, this._b, !0)] || !1);
                },
                toFilter: function toFilter(e) {
                  var t = "#" + f(this._r, this._g, this._b, this._a),
                    n = t,
                    r = this._gradientType ? "GradientType = 1, " : "";
                  if (e) {
                    var i = u(e);
                    n = "#" + f(i._r, i._g, i._b, i._a);
                  }
                  return "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + t + ",endColorstr=" + n + ")";
                },
                toString: function toString(e) {
                  var t = !!e;
                  e = e || this._format;
                  var n = !1,
                    r = this._a < 1 && this._a >= 0;
                  return t || !r || "hex" !== e && "hex6" !== e && "hex3" !== e && "hex4" !== e && "hex8" !== e && "name" !== e ? ("rgb" === e && (n = this.toRgbString()), "prgb" === e && (n = this.toPercentageRgbString()), "hex" !== e && "hex6" !== e || (n = this.toHexString()), "hex3" === e && (n = this.toHexString(!0)), "hex4" === e && (n = this.toHex8String(!0)), "hex8" === e && (n = this.toHex8String()), "name" === e && (n = this.toName()), "hsl" === e && (n = this.toHslString()), "hsv" === e && (n = this.toHsvString()), n || this.toHexString()) : "name" === e && 0 === this._a ? this.toName() : this.toRgbString();
                },
                clone: function clone() {
                  return u(this.toString());
                },
                _applyModification: function _applyModification(e, t) {
                  var n = e.apply(null, [this].concat([].slice.call(t)));
                  return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
                },
                lighten: function lighten() {
                  return this._applyModification(v, arguments);
                },
                brighten: function brighten() {
                  return this._applyModification(y, arguments);
                },
                darken: function darken() {
                  return this._applyModification(b, arguments);
                },
                desaturate: function desaturate() {
                  return this._applyModification(p, arguments);
                },
                saturate: function saturate() {
                  return this._applyModification(m, arguments);
                },
                greyscale: function greyscale() {
                  return this._applyModification(g, arguments);
                },
                spin: function spin() {
                  return this._applyModification(_, arguments);
                },
                _applyCombination: function _applyCombination(e, t) {
                  return e.apply(null, [this].concat([].slice.call(t)));
                },
                analogous: function analogous() {
                  return this._applyCombination(E, arguments);
                },
                complement: function complement() {
                  return this._applyCombination(x, arguments);
                },
                monochromatic: function monochromatic() {
                  return this._applyCombination(T, arguments);
                },
                splitcomplement: function splitcomplement() {
                  return this._applyCombination(A, arguments);
                },
                triad: function triad() {
                  return this._applyCombination(w, arguments);
                },
                tetrad: function tetrad() {
                  return this._applyCombination(S, arguments);
                }
              }, u.fromRatio = function (e, t) {
                if ("object" == typeof e) {
                  var n = {};
                  for (var r in e) e.hasOwnProperty(r) && (n[r] = "a" === r ? e[r] : j(e[r]));
                  e = n;
                }
                return u(e, t);
              }, u.equals = function (e, t) {
                return !(!e || !t) && u(e).toRgbString() == u(t).toRgbString();
              }, u.random = function () {
                return u.fromRatio({
                  r: l(),
                  g: l(),
                  b: l()
                });
              }, u.mix = function (e, t, n) {
                n = 0 === n ? 0 : n || 50;
                var r = u(e).toRgb(),
                  i = u(t).toRgb(),
                  o = n / 100;
                return u({
                  r: (i.r - r.r) * o + r.r,
                  g: (i.g - r.g) * o + r.g,
                  b: (i.b - r.b) * o + r.b,
                  a: (i.a - r.a) * o + r.a
                });
              }, u.readability = function (t, n) {
                var r = u(t),
                  i = u(n);
                return (e.max(r.getLuminance(), i.getLuminance()) + .05) / (e.min(r.getLuminance(), i.getLuminance()) + .05);
              }, u.isReadable = function (e, t, n) {
                var r,
                  i,
                  o = u.readability(e, t);
                switch (i = !1, (r = function (e) {
                  var t, n;
                  return "AA" !== (t = ((e = e || {
                    level: "AA",
                    size: "small"
                  }).level || "AA").toUpperCase()) && "AAA" !== t && (t = "AA"), "small" !== (n = (e.size || "small").toLowerCase()) && "large" !== n && (n = "small"), {
                    level: t,
                    size: n
                  };
                }(n)).level + r.size) {
                  case "AAsmall":
                  case "AAAlarge":
                    i = o >= 4.5;
                    break;
                  case "AAlarge":
                    i = o >= 3;
                    break;
                  case "AAAsmall":
                    i = o >= 7;
                }
                return i;
              }, u.mostReadable = function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s = null,
                  l = 0;
                i = (n = n || {}).includeFallbackColors, o = n.level, a = n.size;
                for (var c = 0; c < t.length; c++) (r = u.readability(e, t[c])) > l && (l = r, s = u(t[c]));
                return u.isReadable(e, s, {
                  level: o,
                  size: a
                }) || !i ? s : (n.includeFallbackColors = !1, u.mostReadable(e, ["#fff", "#000"], n));
              };
              var M = u.names = {
                  aliceblue: "f0f8ff",
                  antiquewhite: "faebd7",
                  aqua: "0ff",
                  aquamarine: "7fffd4",
                  azure: "f0ffff",
                  beige: "f5f5dc",
                  bisque: "ffe4c4",
                  black: "000",
                  blanchedalmond: "ffebcd",
                  blue: "00f",
                  blueviolet: "8a2be2",
                  brown: "a52a2a",
                  burlywood: "deb887",
                  burntsienna: "ea7e5d",
                  cadetblue: "5f9ea0",
                  chartreuse: "7fff00",
                  chocolate: "d2691e",
                  coral: "ff7f50",
                  cornflowerblue: "6495ed",
                  cornsilk: "fff8dc",
                  crimson: "dc143c",
                  cyan: "0ff",
                  darkblue: "00008b",
                  darkcyan: "008b8b",
                  darkgoldenrod: "b8860b",
                  darkgray: "a9a9a9",
                  darkgreen: "006400",
                  darkgrey: "a9a9a9",
                  darkkhaki: "bdb76b",
                  darkmagenta: "8b008b",
                  darkolivegreen: "556b2f",
                  darkorange: "ff8c00",
                  darkorchid: "9932cc",
                  darkred: "8b0000",
                  darksalmon: "e9967a",
                  darkseagreen: "8fbc8f",
                  darkslateblue: "483d8b",
                  darkslategray: "2f4f4f",
                  darkslategrey: "2f4f4f",
                  darkturquoise: "00ced1",
                  darkviolet: "9400d3",
                  deeppink: "ff1493",
                  deepskyblue: "00bfff",
                  dimgray: "696969",
                  dimgrey: "696969",
                  dodgerblue: "1e90ff",
                  firebrick: "b22222",
                  floralwhite: "fffaf0",
                  forestgreen: "228b22",
                  fuchsia: "f0f",
                  gainsboro: "dcdcdc",
                  ghostwhite: "f8f8ff",
                  gold: "ffd700",
                  goldenrod: "daa520",
                  gray: "808080",
                  green: "008000",
                  greenyellow: "adff2f",
                  grey: "808080",
                  honeydew: "f0fff0",
                  hotpink: "ff69b4",
                  indianred: "cd5c5c",
                  indigo: "4b0082",
                  ivory: "fffff0",
                  khaki: "f0e68c",
                  lavender: "e6e6fa",
                  lavenderblush: "fff0f5",
                  lawngreen: "7cfc00",
                  lemonchiffon: "fffacd",
                  lightblue: "add8e6",
                  lightcoral: "f08080",
                  lightcyan: "e0ffff",
                  lightgoldenrodyellow: "fafad2",
                  lightgray: "d3d3d3",
                  lightgreen: "90ee90",
                  lightgrey: "d3d3d3",
                  lightpink: "ffb6c1",
                  lightsalmon: "ffa07a",
                  lightseagreen: "20b2aa",
                  lightskyblue: "87cefa",
                  lightslategray: "789",
                  lightslategrey: "789",
                  lightsteelblue: "b0c4de",
                  lightyellow: "ffffe0",
                  lime: "0f0",
                  limegreen: "32cd32",
                  linen: "faf0e6",
                  magenta: "f0f",
                  maroon: "800000",
                  mediumaquamarine: "66cdaa",
                  mediumblue: "0000cd",
                  mediumorchid: "ba55d3",
                  mediumpurple: "9370db",
                  mediumseagreen: "3cb371",
                  mediumslateblue: "7b68ee",
                  mediumspringgreen: "00fa9a",
                  mediumturquoise: "48d1cc",
                  mediumvioletred: "c71585",
                  midnightblue: "191970",
                  mintcream: "f5fffa",
                  mistyrose: "ffe4e1",
                  moccasin: "ffe4b5",
                  navajowhite: "ffdead",
                  navy: "000080",
                  oldlace: "fdf5e6",
                  olive: "808000",
                  olivedrab: "6b8e23",
                  orange: "ffa500",
                  orangered: "ff4500",
                  orchid: "da70d6",
                  palegoldenrod: "eee8aa",
                  palegreen: "98fb98",
                  paleturquoise: "afeeee",
                  palevioletred: "db7093",
                  papayawhip: "ffefd5",
                  peachpuff: "ffdab9",
                  peru: "cd853f",
                  pink: "ffc0cb",
                  plum: "dda0dd",
                  powderblue: "b0e0e6",
                  purple: "800080",
                  rebeccapurple: "663399",
                  red: "f00",
                  rosybrown: "bc8f8f",
                  royalblue: "4169e1",
                  saddlebrown: "8b4513",
                  salmon: "fa8072",
                  sandybrown: "f4a460",
                  seagreen: "2e8b57",
                  seashell: "fff5ee",
                  sienna: "a0522d",
                  silver: "c0c0c0",
                  skyblue: "87ceeb",
                  slateblue: "6a5acd",
                  slategray: "708090",
                  slategrey: "708090",
                  snow: "fffafa",
                  springgreen: "00ff7f",
                  steelblue: "4682b4",
                  tan: "d2b48c",
                  teal: "008080",
                  thistle: "d8bfd8",
                  tomato: "ff6347",
                  turquoise: "40e0d0",
                  violet: "ee82ee",
                  wheat: "f5deb3",
                  white: "fff",
                  whitesmoke: "f5f5f5",
                  yellow: "ff0",
                  yellowgreen: "9acd32"
                },
                C = u.hexNames = function (e) {
                  var t = {};
                  for (var n in e) e.hasOwnProperty(n) && (t[e[n]] = n);
                  return t;
                }(M);
              function k(e) {
                return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
              }
              function P(t, n) {
                (function (e) {
                  return "string" == typeof e && -1 != e.indexOf(".") && 1 === parseFloat(e);
                })(t) && (t = "100%");
                var r = function (e) {
                  return "string" == typeof e && -1 != e.indexOf("%");
                }(t);
                return t = a(n, s(0, parseFloat(t))), r && (t = parseInt(t * n, 10) / 100), e.abs(t - n) < 1e-6 ? 1 : t % n / parseFloat(n);
              }
              function O(e) {
                return a(1, s(0, e));
              }
              function R(e) {
                return parseInt(e, 16);
              }
              function I(e) {
                return 1 == e.length ? "0" + e : "" + e;
              }
              function j(e) {
                return e <= 1 && (e = 100 * e + "%"), e;
              }
              function N(t) {
                return e.round(255 * parseFloat(t)).toString(16);
              }
              function L(e) {
                return R(e) / 255;
              }
              var D,
                B,
                F,
                z = (B = "[\\s|\\(]+(" + (D = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + D + ")[,|\\s]+(" + D + ")\\s*\\)?", F = "[\\s|\\(]+(" + D + ")[,|\\s]+(" + D + ")[,|\\s]+(" + D + ")[,|\\s]+(" + D + ")\\s*\\)?", {
                  CSS_UNIT: new RegExp(D),
                  rgb: new RegExp("rgb" + B),
                  rgba: new RegExp("rgba" + F),
                  hsl: new RegExp("hsl" + B),
                  hsla: new RegExp("hsla" + F),
                  hsv: new RegExp("hsv" + B),
                  hsva: new RegExp("hsva" + F),
                  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
                });
              function U(e) {
                return !!z.CSS_UNIT.exec(e);
              }
              void 0 !== t && t.exports ? t.exports = u : window.tinycolor = u;
            }(Math);
          }, {}],
          342: [function (e, t, n) {
            "use strict";

            var r = e("parse-unit");
            function i(e, t) {
              var n = r(getComputedStyle(e).getPropertyValue(t));
              return n[0] * o(n[1], e);
            }
            function o(e, t) {
              switch (t = t || document.body, e = (e || "px").trim().toLowerCase(), t !== window && t !== document || (t = document.body), e) {
                case "%":
                  return t.clientHeight / 100;
                case "ch":
                case "ex":
                  return function (e, t) {
                    var n = document.createElement("div");
                    n.style["font-size"] = "128" + e, t.appendChild(n);
                    var r = i(n, "font-size") / 128;
                    return t.removeChild(n), r;
                  }(e, t);
                case "em":
                  return i(t, "font-size");
                case "rem":
                  return i(document.body, "font-size");
                case "vw":
                  return window.innerWidth / 100;
                case "vh":
                  return window.innerHeight / 100;
                case "vmin":
                  return Math.min(window.innerWidth, window.innerHeight) / 100;
                case "vmax":
                  return Math.max(window.innerWidth, window.innerHeight) / 100;
                case "in":
                  return 96;
                case "cm":
                  return 96 / 2.54;
                case "mm":
                  return 96 / 25.4;
                case "pt":
                  return 96 / 72;
                case "pc":
                  return 16;
              }
              return 1;
            }
            t.exports = o;
          }, {
            "parse-unit": 291
          }],
          343: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              if (e < 0) return [];
              if (0 === e) return [[0]];
              for (var t = 0 | Math.round(o(e + 1)), n = [], a = 0; a < t; ++a) {
                for (var s = r.unrank(e, a), l = [0], u = 0, c = 0; c < s.length; ++c) u += 1 << s[c], l.push(u);
                i(s) < 1 && (l[0] = u, l[e] = 0), n.push(l);
              }
              return n;
            };
            var r = e("permutation-rank"),
              i = e("permutation-parity"),
              o = e("gamma");
          }, {
            gamma: 94,
            "permutation-parity": 292,
            "permutation-rank": 293
          }],
          344: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = (e = e || {}).center || [0, 0, 0],
                n = e.up || [0, 1, 0],
                r = e.right || d(n),
                i = e.radius || 1,
                o = e.theta || 0,
                c = e.phi || 0;
              if (t = [].slice.call(t, 0, 3), n = [].slice.call(n, 0, 3), s(n, n), r = [].slice.call(r, 0, 3), s(r, r), "eye" in e) {
                var f = e.eye,
                  p = [f[0] - t[0], f[1] - t[1], f[2] - t[2]];
                a(r, p, n), u(r[0], r[1], r[2]) < 1e-6 ? r = d(n) : s(r, r), i = u(p[0], p[1], p[2]);
                var m = l(n, p) / i,
                  g = l(r, p) / i;
                c = Math.acos(m), o = Math.acos(g);
              }
              return i = Math.log(i), new h(e.zoomMin, e.zoomMax, t, n, r, i, o, c);
            };
            var r = e("filtered-vector"),
              i = e("gl-mat4/invert"),
              o = e("gl-mat4/rotate"),
              a = e("gl-vec3/cross"),
              s = e("gl-vec3/normalize"),
              l = e("gl-vec3/dot");
            function u(e, t, n) {
              return Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2) + Math.pow(n, 2));
            }
            function c(e) {
              return Math.min(1, Math.max(-1, e));
            }
            function d(e) {
              var t = Math.abs(e[0]),
                n = Math.abs(e[1]),
                r = Math.abs(e[2]),
                i = [0, 0, 0];
              t > Math.max(n, r) ? i[2] = 1 : n > Math.max(t, r) ? i[0] = 1 : i[1] = 1;
              for (var o = 0, a = 0, l = 0; l < 3; ++l) o += e[l] * e[l], a += i[l] * e[l];
              for (l = 0; l < 3; ++l) i[l] -= a / o * e[l];
              return s(i, i), i;
            }
            function h(e, t, n, i, o, a, s, l) {
              this.center = r(n), this.up = r(i), this.right = r(o), this.radius = r([a]), this.angle = r([s, l]), this.angle.bounds = [[-1 / 0, -Math.PI / 2], [1 / 0, Math.PI / 2]], this.setDistanceLimits(e, t), this.computedCenter = this.center.curve(0), this.computedUp = this.up.curve(0), this.computedRight = this.right.curve(0), this.computedRadius = this.radius.curve(0), this.computedAngle = this.angle.curve(0), this.computedToward = [0, 0, 0], this.computedEye = [0, 0, 0], this.computedMatrix = new Array(16);
              for (var u = 0; u < 16; ++u) this.computedMatrix[u] = .5;
              this.recalcMatrix(0);
            }
            var f = h.prototype;
            f.setDistanceLimits = function (e, t) {
              e = e > 0 ? Math.log(e) : -1 / 0, t = t > 0 ? Math.log(t) : 1 / 0, t = Math.max(t, e), this.radius.bounds[0][0] = e, this.radius.bounds[1][0] = t;
            }, f.getDistanceLimits = function (e) {
              var t = this.radius.bounds[0];
              return e ? (e[0] = Math.exp(t[0][0]), e[1] = Math.exp(t[1][0]), e) : [Math.exp(t[0][0]), Math.exp(t[1][0])];
            }, f.recalcMatrix = function (e) {
              this.center.curve(e), this.up.curve(e), this.right.curve(e), this.radius.curve(e), this.angle.curve(e);
              for (var t = this.computedUp, n = this.computedRight, r = 0, i = 0, o = 0; o < 3; ++o) i += t[o] * n[o], r += t[o] * t[o];
              var l = Math.sqrt(r),
                c = 0;
              for (o = 0; o < 3; ++o) n[o] -= t[o] * i / r, c += n[o] * n[o], t[o] /= l;
              var d = Math.sqrt(c);
              for (o = 0; o < 3; ++o) n[o] /= d;
              var h = this.computedToward;
              a(h, t, n), s(h, h);
              var f = Math.exp(this.computedRadius[0]),
                p = this.computedAngle[0],
                m = this.computedAngle[1],
                g = Math.cos(p),
                v = Math.sin(p),
                y = Math.cos(m),
                b = Math.sin(m),
                _ = this.computedCenter,
                x = g * y,
                w = v * y,
                S = b,
                A = -g * b,
                E = -v * b,
                T = y,
                M = this.computedEye,
                C = this.computedMatrix;
              for (o = 0; o < 3; ++o) {
                var k = x * n[o] + w * h[o] + S * t[o];
                C[4 * o + 1] = A * n[o] + E * h[o] + T * t[o], C[4 * o + 2] = k, C[4 * o + 3] = 0;
              }
              var P = C[1],
                O = C[5],
                R = C[9],
                I = C[2],
                j = C[6],
                N = C[10],
                L = O * N - R * j,
                D = R * I - P * N,
                B = P * j - O * I,
                F = u(L, D, B);
              for (L /= F, D /= F, B /= F, C[0] = L, C[4] = D, C[8] = B, o = 0; o < 3; ++o) M[o] = _[o] + C[2 + 4 * o] * f;
              for (o = 0; o < 3; ++o) {
                c = 0;
                for (var z = 0; z < 3; ++z) c += C[o + 4 * z] * M[z];
                C[12 + o] = -c;
              }
              C[15] = 1;
            }, f.getMatrix = function (e, t) {
              this.recalcMatrix(e);
              var n = this.computedMatrix;
              if (t) {
                for (var r = 0; r < 16; ++r) t[r] = n[r];
                return t;
              }
              return n;
            };
            var p = [0, 0, 0];
            f.rotate = function (e, t, n, r) {
              if (this.angle.move(e, t, n), r) {
                this.recalcMatrix(e);
                var i = this.computedMatrix;
                p[0] = i[2], p[1] = i[6], p[2] = i[10];
                for (var a = this.computedUp, s = this.computedRight, l = this.computedToward, u = 0; u < 3; ++u) i[4 * u] = a[u], i[4 * u + 1] = s[u], i[4 * u + 2] = l[u];
                for (o(i, i, r, p), u = 0; u < 3; ++u) a[u] = i[4 * u], s[u] = i[4 * u + 1];
                this.up.set(e, a[0], a[1], a[2]), this.right.set(e, s[0], s[1], s[2]);
              }
            }, f.pan = function (e, t, n, r) {
              t = t || 0, n = n || 0, r = r || 0, this.recalcMatrix(e);
              var i = this.computedMatrix,
                o = (Math.exp(this.computedRadius[0]), i[1]),
                a = i[5],
                s = i[9],
                l = u(o, a, s);
              o /= l, a /= l, s /= l;
              var c = i[0],
                d = i[4],
                h = i[8],
                f = c * o + d * a + h * s,
                p = u(c -= o * f, d -= a * f, h -= s * f),
                m = (c /= p) * t + o * n,
                g = (d /= p) * t + a * n,
                v = (h /= p) * t + s * n;
              this.center.move(e, m, g, v);
              var y = Math.exp(this.computedRadius[0]);
              y = Math.max(1e-4, y + r), this.radius.set(e, Math.log(y));
            }, f.translate = function (e, t, n, r) {
              this.center.move(e, t || 0, n || 0, r || 0);
            }, f.setMatrix = function (e, t, n, r) {
              var o = 1;
              "number" == typeof n && (o = 0 | n), (o < 0 || o > 3) && (o = 1);
              var a = (o + 2) % 3;
              t || (this.recalcMatrix(e), t = this.computedMatrix);
              var s = t[o],
                l = t[o + 4],
                d = t[o + 8];
              if (r) {
                var h = Math.abs(s),
                  f = Math.abs(l),
                  p = Math.abs(d),
                  m = Math.max(h, f, p);
                h === m ? (s = s < 0 ? -1 : 1, l = d = 0) : p === m ? (d = d < 0 ? -1 : 1, s = l = 0) : (l = l < 0 ? -1 : 1, s = d = 0);
              } else {
                var g = u(s, l, d);
                s /= g, l /= g, d /= g;
              }
              var v,
                y,
                b = t[a],
                _ = t[a + 4],
                x = t[a + 8],
                w = b * s + _ * l + x * d,
                S = u(b -= s * w, _ -= l * w, x -= d * w),
                A = l * (x /= S) - d * (_ /= S),
                E = d * (b /= S) - s * x,
                T = s * _ - l * b,
                M = u(A, E, T);
              if (A /= M, E /= M, T /= M, this.center.jump(e, H, q, W), this.radius.idle(e), this.up.jump(e, s, l, d), this.right.jump(e, b, _, x), 2 === o) {
                var C = t[1],
                  k = t[5],
                  P = t[9],
                  O = C * b + k * _ + P * x,
                  R = C * A + k * E + P * T;
                v = L < 0 ? -Math.PI / 2 : Math.PI / 2, y = Math.atan2(R, O);
              } else {
                var I = t[2],
                  j = t[6],
                  N = t[10],
                  L = I * s + j * l + N * d,
                  D = I * b + j * _ + N * x,
                  B = I * A + j * E + N * T;
                v = Math.asin(c(L)), y = Math.atan2(B, D);
              }
              this.angle.jump(e, y, v), this.recalcMatrix(e);
              var F = t[2],
                z = t[6],
                U = t[10],
                G = this.computedMatrix;
              i(G, t);
              var V = G[15],
                H = G[12] / V,
                q = G[13] / V,
                W = G[14] / V,
                $ = Math.exp(this.computedRadius[0]);
              this.center.jump(e, H - F * $, q - z * $, W - U * $);
            }, f.lastT = function () {
              return Math.max(this.center.lastT(), this.up.lastT(), this.right.lastT(), this.radius.lastT(), this.angle.lastT());
            }, f.idle = function (e) {
              this.center.idle(e), this.up.idle(e), this.right.idle(e), this.radius.idle(e), this.angle.idle(e);
            }, f.flush = function (e) {
              this.center.flush(e), this.up.flush(e), this.right.flush(e), this.radius.flush(e), this.angle.flush(e);
            }, f.setDistance = function (e, t) {
              t > 0 && this.radius.set(e, Math.log(t));
            }, f.lookAt = function (e, t, n, r) {
              this.recalcMatrix(e), t = t || this.computedEye, n = n || this.computedCenter;
              var i = (r = r || this.computedUp)[0],
                o = r[1],
                a = r[2],
                s = u(i, o, a);
              if (!(s < 1e-6)) {
                i /= s, o /= s, a /= s;
                var l = t[0] - n[0],
                  d = t[1] - n[1],
                  h = t[2] - n[2],
                  f = u(l, d, h);
                if (!(f < 1e-6)) {
                  l /= f, d /= f, h /= f;
                  var p = this.computedRight,
                    m = p[0],
                    g = p[1],
                    v = p[2],
                    y = i * m + o * g + a * v,
                    b = u(m -= y * i, g -= y * o, v -= y * a);
                  if (!(b < .01 && (b = u(m = o * h - a * d, g = a * l - i * h, v = i * d - o * l)) < 1e-6)) {
                    m /= b, g /= b, v /= b, this.up.set(e, i, o, a), this.right.set(e, m, g, v), this.center.set(e, n[0], n[1], n[2]), this.radius.set(e, Math.log(f));
                    var _ = o * v - a * g,
                      x = a * m - i * v,
                      w = i * g - o * m,
                      S = u(_, x, w),
                      A = i * l + o * d + a * h,
                      E = m * l + g * d + v * h,
                      T = (_ /= S) * l + (x /= S) * d + (w /= S) * h,
                      M = Math.asin(c(A)),
                      C = Math.atan2(T, E),
                      k = this.angle._state,
                      P = k[k.length - 1],
                      O = k[k.length - 2];
                    P %= 2 * Math.PI;
                    var R = Math.abs(P + 2 * Math.PI - C),
                      I = Math.abs(P - C),
                      j = Math.abs(P - 2 * Math.PI - C);
                    R < I && (P += 2 * Math.PI), j < I && (P -= 2 * Math.PI), this.angle.jump(this.angle.lastT(), P, O), this.angle.set(e, C, M);
                  }
                }
              }
            };
          }, {
            "filtered-vector": 92,
            "gl-mat4/invert": 125,
            "gl-mat4/rotate": 130,
            "gl-vec3/cross": 175,
            "gl-vec3/dot": 180,
            "gl-vec3/normalize": 197
          }],
          345: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              var i = e * t,
                o = r * e,
                a = o - (o - e),
                s = e - a,
                l = r * t,
                u = l - (l - t),
                c = t - u,
                d = s * c - (i - a * u - s * u - a * c);
              return n ? (n[0] = d, n[1] = i, n) : [d, i];
            };
            var r = +(Math.pow(2, 27) + 1);
          }, {}],
          346: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              var r = e + t,
                i = r - e,
                o = t - i,
                a = e - (r - i);
              return n ? (n[0] = a + o, n[1] = r, n) : [a + o, r];
            };
          }, {}],
          347: [function (e, n, r) {
            (function (t, n) {
              "use strict";

              var i = e("bit-twiddle"),
                o = e("dup");
              t.__TYPEDARRAY_POOL || (t.__TYPEDARRAY_POOL = {
                UINT8: o([32, 0]),
                UINT16: o([32, 0]),
                UINT32: o([32, 0]),
                INT8: o([32, 0]),
                INT16: o([32, 0]),
                INT32: o([32, 0]),
                FLOAT: o([32, 0]),
                DOUBLE: o([32, 0]),
                DATA: o([32, 0]),
                UINT8C: o([32, 0]),
                BUFFER: o([32, 0])
              });
              var a = "undefined" != typeof Uint8ClampedArray,
                s = t.__TYPEDARRAY_POOL;
              s.UINT8C || (s.UINT8C = o([32, 0])), s.BUFFER || (s.BUFFER = o([32, 0]));
              var l = s.DATA,
                u = s.BUFFER;
              function c(e) {
                if (e) {
                  var t = e.length || e.byteLength,
                    n = i.log2(t);
                  l[n].push(e);
                }
              }
              function d(e) {
                e = i.nextPow2(e);
                var t = i.log2(e),
                  n = l[t];
                return n.length > 0 ? n.pop() : new ArrayBuffer(e);
              }
              function h(e) {
                return new Uint8Array(d(e), 0, e);
              }
              function f(e) {
                return new Uint16Array(d(2 * e), 0, e);
              }
              function p(e) {
                return new Uint32Array(d(4 * e), 0, e);
              }
              function m(e) {
                return new Int8Array(d(e), 0, e);
              }
              function g(e) {
                return new Int16Array(d(2 * e), 0, e);
              }
              function v(e) {
                return new Int32Array(d(4 * e), 0, e);
              }
              function y(e) {
                return new Float32Array(d(4 * e), 0, e);
              }
              function b(e) {
                return new Float64Array(d(8 * e), 0, e);
              }
              function _(e) {
                return a ? new Uint8ClampedArray(d(e), 0, e) : h(e);
              }
              function x(e) {
                return new DataView(d(e), 0, e);
              }
              function w(e) {
                e = i.nextPow2(e);
                var t = i.log2(e),
                  r = u[t];
                return r.length > 0 ? r.pop() : new n(e);
              }
              r.free = function (e) {
                if (n.isBuffer(e)) u[i.log2(e.length)].push(e);else {
                  if ("[object ArrayBuffer]" !== Object.prototype.toString.call(e) && (e = e.buffer), !e) return;
                  var t = e.length || e.byteLength,
                    r = 0 | i.log2(t);
                  l[r].push(e);
                }
              }, r.freeUint8 = r.freeUint16 = r.freeUint32 = r.freeInt8 = r.freeInt16 = r.freeInt32 = r.freeFloat32 = r.freeFloat = r.freeFloat64 = r.freeDouble = r.freeUint8Clamped = r.freeDataView = function (e) {
                c(e.buffer);
              }, r.freeArrayBuffer = c, r.freeBuffer = function (e) {
                u[i.log2(e.length)].push(e);
              }, r.malloc = function (e, t) {
                if (void 0 === t || "arraybuffer" === t) return d(e);
                switch (t) {
                  case "uint8":
                    return h(e);
                  case "uint16":
                    return f(e);
                  case "uint32":
                    return p(e);
                  case "int8":
                    return m(e);
                  case "int16":
                    return g(e);
                  case "int32":
                    return v(e);
                  case "float":
                  case "float32":
                    return y(e);
                  case "double":
                  case "float64":
                    return b(e);
                  case "uint8_clamped":
                    return _(e);
                  case "buffer":
                    return w(e);
                  case "data":
                  case "dataview":
                    return x(e);
                  default:
                    return null;
                }
                return null;
              }, r.mallocArrayBuffer = d, r.mallocUint8 = h, r.mallocUint16 = f, r.mallocUint32 = p, r.mallocInt8 = m, r.mallocInt16 = g, r.mallocInt32 = v, r.mallocFloat32 = r.mallocFloat = y, r.mallocFloat64 = r.mallocDouble = b, r.mallocUint8Clamped = _, r.mallocDataView = x, r.mallocBuffer = w, r.clearCache = function () {
                for (var e = 0; e < 32; ++e) s.UINT8[e].length = 0, s.UINT16[e].length = 0, s.UINT32[e].length = 0, s.INT8[e].length = 0, s.INT16[e].length = 0, s.INT32[e].length = 0, s.FLOAT[e].length = 0, s.DOUBLE[e].length = 0, s.UINT8C[e].length = 0, l[e].length = 0, u[e].length = 0;
              };
            }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer);
          }, {
            "bit-twiddle": 37,
            buffer: 49,
            dup: 87
          }],
          348: [function (e, t, n) {
            "use strict";

            function r(e) {
              this.roots = new Array(e), this.ranks = new Array(e);
              for (var t = 0; t < e; ++t) this.roots[t] = t, this.ranks[t] = 0;
            }
            t.exports = r;
            var i = r.prototype;
            Object.defineProperty(i, "length", {
              get: function get() {
                return this.roots.length;
              }
            }), i.makeSet = function () {
              var e = this.roots.length;
              return this.roots.push(e), this.ranks.push(0), e;
            }, i.find = function (e) {
              for (var t = e, n = this.roots; n[e] !== e;) e = n[e];
              for (; n[t] !== e;) {
                var r = n[t];
                n[t] = e, t = r;
              }
              return e;
            }, i.link = function (e, t) {
              var n = this.find(e),
                r = this.find(t);
              if (n !== r) {
                var i = this.ranks,
                  o = this.roots,
                  a = i[n],
                  s = i[r];
                a < s ? o[n] = r : s < a ? o[r] = n : (o[r] = n, ++i[n]);
              }
            };
          }, {}],
          349: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              return 0 === e.length ? e : t ? (n || e.sort(t), function (e, t) {
                for (var n = 1, r = e.length, i = e[0], o = e[0], a = 1; a < r; ++a) if (o = i, t(i = e[a], o)) {
                  if (a === n) {
                    n++;
                    continue;
                  }
                  e[n++] = i;
                }
                return e.length = n, e;
              }(e, t)) : (n || e.sort(), function (e) {
                for (var t = 1, n = e.length, r = e[0], i = e[0], o = 1; o < n; ++o, i = r) if (i = r, (r = e[o]) !== i) {
                  if (o === t) {
                    t++;
                    continue;
                  }
                  e[t++] = r;
                }
                return e.length = t, e;
              }(e));
            };
          }, {}],
          350: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              return "object" == typeof t && null !== t || (t = {}), r(e, t.canvas || i, t.context || o, t);
            };
            var r = e("./lib/vtext"),
              i = null,
              o = null;
            "undefined" != typeof document && ((i = document.createElement("canvas")).width = 8192, i.height = 1024, o = i.getContext("2d"));
          }, {
            "./lib/vtext": 351
          }],
          351: [function (e, t, n) {
            t.exports = function (e, t, n, r) {
              var o = 64,
                a = 1.25,
                s = {
                  breaklines: !1,
                  bolds: !1,
                  italics: !1,
                  subscripts: !1,
                  superscripts: !1
                };
              return r && (r.size && r.size > 0 && (o = r.size), r.lineSpacing && r.lineSpacing > 0 && (a = r.lineSpacing), r.styletags && r.styletags.breaklines && (s.breaklines = !!r.styletags.breaklines), r.styletags && r.styletags.bolds && (s.bolds = !!r.styletags.bolds), r.styletags && r.styletags.italics && (s.italics = !!r.styletags.italics), r.styletags && r.styletags.subscripts && (s.subscripts = !!r.styletags.subscripts), r.styletags && r.styletags.superscripts && (s.superscripts = !!r.styletags.superscripts)), n.font = [r.fontStyle, r.fontVariant, r.fontWeight, o + "px", r.font].filter(function (e) {
                return e;
              }).join(" "), n.textAlign = "start", n.textBaseline = "alphabetic", n.direction = "ltr", w(function (e, t, n, r, o, a) {
                n = n.replace(/\n/g, ""), n = !0 === a.breaklines ? n.replace(/\<br\>/g, "\n") : n.replace(/\<br\>/g, " ");
                var s = "",
                  l = [];
                for (S = 0; S < n.length; ++S) l[S] = s;
                !0 === a.bolds && (l = b(u, c, n, l)), !0 === a.italics && (l = b(d, h, n, l)), !0 === a.superscripts && (l = b(f, m, n, l)), !0 === a.subscripts && (l = b(g, y, n, l));
                var _ = [],
                  x = "";
                for (S = 0; S < n.length; ++S) null !== l[S] && (x += n[S], _.push(l[S]));
                var w,
                  S,
                  A,
                  E,
                  T,
                  M = x.split("\n"),
                  C = M.length,
                  k = Math.round(o * r),
                  P = r,
                  O = 2 * r,
                  R = 0,
                  I = C * k + O;
                e.height < I && (e.height = I), t.fillStyle = "#000", t.fillRect(0, 0, e.width, e.height), t.fillStyle = "#fff";
                var j = 0,
                  N = "";
                function L() {
                  if ("" !== N) {
                    var e = t.measureText(N).width;
                    t.fillText(N, P + A, O + E), A += e;
                  }
                }
                function D() {
                  return Math.round(T) + "px ";
                }
                function B(e, n) {
                  var r = "" + t.font;
                  if (!0 === a.subscripts) {
                    var i = e.indexOf(v),
                      o = n.indexOf(v),
                      s = i > -1 ? parseInt(e[1 + i]) : 0,
                      l = o > -1 ? parseInt(n[1 + o]) : 0;
                    s !== l && (r = r.replace(D(), "?px "), T *= Math.pow(.75, l - s), r = r.replace("?px ", D())), E += .25 * k * (l - s);
                  }
                  if (!0 === a.superscripts) {
                    var u = e.indexOf(p),
                      d = n.indexOf(p),
                      f = u > -1 ? parseInt(e[1 + u]) : 0,
                      m = d > -1 ? parseInt(n[1 + d]) : 0;
                    f !== m && (r = r.replace(D(), "?px "), T *= Math.pow(.75, m - f), r = r.replace("?px ", D())), E -= .25 * k * (m - f);
                  }
                  if (!0 === a.bolds) {
                    var g = e.indexOf(c) > -1,
                      y = n.indexOf(c) > -1;
                    !g && y && (r = b ? r.replace("italic ", "italic bold ") : "bold " + r), g && !y && (r = r.replace("bold ", ""));
                  }
                  if (!0 === a.italics) {
                    var b = e.indexOf(h) > -1,
                      _ = n.indexOf(h) > -1;
                    !b && _ && (r = "italic " + r), b && !_ && (r = r.replace("italic ", ""));
                  }
                  t.font = r;
                }
                for (w = 0; w < C; ++w) {
                  var F = M[w] + "\n";
                  for (A = 0, E = w * k, T = r, N = "", S = 0; S < F.length; ++S) {
                    var z = S + j < _.length ? _[S + j] : _[_.length - 1];
                    s === z ? N += F[S] : (L(), N = F[S], void 0 !== z && (B(s, z), s = z));
                  }
                  L(), j += F.length;
                  var U = 0 | Math.round(A + 2 * P);
                  R < U && (R = U);
                }
                var G = R,
                  V = O + k * C;
                return i(t.getImageData(0, 0, G, V).data, [V, G, 4]).pick(-1, -1, 0).transpose(1, 0);
              }(t, n, e, o, a, s), r, o);
            }, t.exports.processPixels = w;
            var r = e("surface-nets"),
              i = e("ndarray"),
              o = e("simplify-planar-graph"),
              a = e("clean-pslg"),
              s = e("cdt2d"),
              l = e("planar-graph-to-polyline"),
              u = "b",
              c = "b|",
              d = "i",
              h = "i|",
              f = "sup",
              p = "+",
              m = "+1",
              g = "sub",
              v = "-",
              y = "-1";
            function b(e, t, n, r) {
              for (var i = "<" + e + ">", o = "</" + e + ">", a = i.length, s = o.length, l = t[0] === p || t[0] === v, u = 0, c = -s; u > -1 && -1 !== (u = n.indexOf(i, u)) && -1 !== (c = n.indexOf(o, u + a)) && !(c <= u);) {
                for (var d = u; d < c + s; ++d) if (d < u + a || d >= c) r[d] = null, n = n.substr(0, d) + " " + n.substr(d + 1);else if (null !== r[d]) {
                  var h = r[d].indexOf(t[0]);
                  -1 === h ? r[d] += t : l && (r[d] = r[d].substr(0, h + 1) + (1 + parseInt(r[d][h + 1])) + r[d].substr(h + 2));
                }
                var f = u + a,
                  m = n.substr(f, c - f).indexOf(i);
                u = -1 !== m ? m : c + s;
              }
              return r;
            }
            function _(e, t) {
              var n = r(e, 128);
              return t ? o(n.cells, n.positions, .25) : {
                edges: n.cells,
                positions: n.positions
              };
            }
            function x(e, t, n, r) {
              var i = _(e, r),
                o = function (e, t, n) {
                  for (var r = t.textAlign || "start", i = t.textBaseline || "alphabetic", o = [1 << 30, 1 << 30], a = [0, 0], s = e.length, l = 0; l < s; ++l) for (var u = e[l], c = 0; c < 2; ++c) o[c] = 0 | Math.min(o[c], u[c]), a[c] = 0 | Math.max(a[c], u[c]);
                  var d = 0;
                  switch (r) {
                    case "center":
                      d = -.5 * (o[0] + a[0]);
                      break;
                    case "right":
                    case "end":
                      d = -a[0];
                      break;
                    case "left":
                    case "start":
                      d = -o[0];
                      break;
                    default:
                      throw new Error("vectorize-text: Unrecognized textAlign: '" + r + "'");
                  }
                  var h = 0;
                  switch (i) {
                    case "hanging":
                    case "top":
                      h = -o[1];
                      break;
                    case "middle":
                      h = -.5 * (o[1] + a[1]);
                      break;
                    case "alphabetic":
                    case "ideographic":
                      h = -3 * n;
                      break;
                    case "bottom":
                      h = -a[1];
                      break;
                    default:
                      throw new Error("vectorize-text: Unrecoginized textBaseline: '" + i + "'");
                  }
                  var f = 1 / n;
                  return "lineHeight" in t ? f *= +t.lineHeight : "width" in t ? f = t.width / (a[0] - o[0]) : "height" in t && (f = t.height / (a[1] - o[1])), e.map(function (e) {
                    return [f * (e[0] + d), f * (e[1] + h)];
                  });
                }(i.positions, t, n),
                u = i.edges,
                c = "ccw" === t.orientation;
              if (a(o, u), t.polygons || t.polygon || t.polyline) {
                for (var d = l(u, o), h = new Array(d.length), f = 0; f < d.length; ++f) {
                  for (var p = d[f], m = new Array(p.length), g = 0; g < p.length; ++g) {
                    for (var v = p[g], y = new Array(v.length), b = 0; b < v.length; ++b) y[b] = o[v[b]].slice();
                    c && y.reverse(), m[g] = y;
                  }
                  h[f] = m;
                }
                return h;
              }
              return t.triangles || t.triangulate || t.triangle ? {
                cells: s(o, u, {
                  delaunay: !1,
                  exterior: !1,
                  interior: !0
                }),
                positions: o
              } : {
                edges: u,
                positions: o
              };
            }
            function w(e, t, n) {
              try {
                return x(e, t, n, !0);
              } catch (e) {}
              try {
                return x(e, t, n, !1);
              } catch (e) {}
              return t.polygons || t.polyline || t.polygon ? [] : t.triangles || t.triangulate || t.triangle ? {
                cells: [],
                positions: []
              } : {
                edges: [],
                positions: []
              };
            }
          }, {
            cdt2d: 50,
            "clean-pslg": 60,
            ndarray: 285,
            "planar-graph-to-polyline": 296,
            "simplify-planar-graph": 335,
            "surface-nets": 340
          }],
          352: [function (e, t, n) {
            !function () {
              "use strict";

              if ("undefined" == typeof ses || !ses.ok || ses.ok()) {
                "undefined" != typeof ses && (ses.weakMapPermitHostObjects = g);
                var e = !1;
                if ("function" == typeof WeakMap) {
                  var n = WeakMap;
                  if ("undefined" != typeof navigator && /Firefox/.test(navigator.userAgent)) ;else {
                    var r = new n(),
                      i = Object.freeze({});
                    if (r.set(i, 1), 1 === r.get(i)) return void (t.exports = WeakMap);
                    e = !0;
                  }
                }
                Object.prototype.hasOwnProperty;
                var o = Object.getOwnPropertyNames,
                  a = Object.defineProperty,
                  s = Object.isExtensible,
                  l = "weakmap:",
                  u = l + "ident:" + Math.random() + "___";
                if ("undefined" != typeof crypto && "function" == typeof crypto.getRandomValues && "function" == typeof ArrayBuffer && "function" == typeof Uint8Array) {
                  var c = new ArrayBuffer(25),
                    d = new Uint8Array(c);
                  crypto.getRandomValues(d), u = l + "rand:" + Array.prototype.map.call(d, function (e) {
                    return (e % 36).toString(36);
                  }).join("") + "___";
                }
                if (a(Object, "getOwnPropertyNames", {
                  value: function value(e) {
                    return o(e).filter(v);
                  }
                }), "getPropertyNames" in Object) {
                  var h = Object.getPropertyNames;
                  a(Object, "getPropertyNames", {
                    value: function value(e) {
                      return h(e).filter(v);
                    }
                  });
                }
                !function () {
                  var e = Object.freeze;
                  a(Object, "freeze", {
                    value: function value(t) {
                      return y(t), e(t);
                    }
                  });
                  var t = Object.seal;
                  a(Object, "seal", {
                    value: function value(e) {
                      return y(e), t(e);
                    }
                  });
                  var n = Object.preventExtensions;
                  a(Object, "preventExtensions", {
                    value: function value(e) {
                      return y(e), n(e);
                    }
                  });
                }();
                var f = !1,
                  p = 0,
                  m = function m() {
                    this instanceof m || _();
                    var e = [],
                      t = [],
                      n = p++;
                    return Object.create(m.prototype, {
                      get___: {
                        value: b(function (r, i) {
                          var o,
                            a = y(r);
                          return a ? n in a ? a[n] : i : (o = e.indexOf(r)) >= 0 ? t[o] : i;
                        })
                      },
                      has___: {
                        value: b(function (t) {
                          var r = y(t);
                          return r ? n in r : e.indexOf(t) >= 0;
                        })
                      },
                      set___: {
                        value: b(function (r, i) {
                          var o,
                            a = y(r);
                          return a ? a[n] = i : (o = e.indexOf(r)) >= 0 ? t[o] = i : (o = e.length, t[o] = i, e[o] = r), this;
                        })
                      },
                      delete___: {
                        value: b(function (r) {
                          var i,
                            o,
                            a = y(r);
                          return a ? n in a && delete a[n] : !((i = e.indexOf(r)) < 0 || (o = e.length - 1, e[i] = void 0, t[i] = t[o], e[i] = e[o], e.length = o, t.length = o, 0));
                        })
                      }
                    });
                  };
                m.prototype = Object.create(Object.prototype, {
                  get: {
                    value: function value(e, t) {
                      return this.get___(e, t);
                    },
                    writable: !0,
                    configurable: !0
                  },
                  has: {
                    value: function value(e) {
                      return this.has___(e);
                    },
                    writable: !0,
                    configurable: !0
                  },
                  set: {
                    value: function value(e, t) {
                      return this.set___(e, t);
                    },
                    writable: !0,
                    configurable: !0
                  },
                  delete: {
                    value: function value(e) {
                      return this.delete___(e);
                    },
                    writable: !0,
                    configurable: !0
                  }
                }), "function" == typeof n ? function () {
                  function r() {
                    this instanceof m || _();
                    var t,
                      r = new n(),
                      i = void 0,
                      o = !1;
                    return t = e ? function (e, t) {
                      return r.set(e, t), r.has(e) || (i || (i = new m()), i.set(e, t)), this;
                    } : function (e, t) {
                      if (o) try {
                        r.set(e, t);
                      } catch (n) {
                        i || (i = new m()), i.set___(e, t);
                      } else r.set(e, t);
                      return this;
                    }, Object.create(m.prototype, {
                      get___: {
                        value: b(function (e, t) {
                          return i ? r.has(e) ? r.get(e) : i.get___(e, t) : r.get(e, t);
                        })
                      },
                      has___: {
                        value: b(function (e) {
                          return r.has(e) || !!i && i.has___(e);
                        })
                      },
                      set___: {
                        value: b(t)
                      },
                      delete___: {
                        value: b(function (e) {
                          var t = !!r.delete(e);
                          return i && i.delete___(e) || t;
                        })
                      },
                      permitHostObjects___: {
                        value: b(function (e) {
                          if (e !== g) throw new Error("bogus call to permitHostObjects___");
                          o = !0;
                        })
                      }
                    });
                  }
                  e && "undefined" != typeof Proxy && (Proxy = void 0), r.prototype = m.prototype, t.exports = r, Object.defineProperty(WeakMap.prototype, "constructor", {
                    value: WeakMap,
                    enumerable: !1,
                    configurable: !0,
                    writable: !0
                  });
                }() : ("undefined" != typeof Proxy && (Proxy = void 0), t.exports = m);
              }
              function g(e) {
                e.permitHostObjects___ && e.permitHostObjects___(g);
              }
              function v(e) {
                return !(e.substr(0, l.length) == l && "___" === e.substr(e.length - 3));
              }
              function y(e) {
                if (e !== Object(e)) throw new TypeError("Not an object: " + e);
                var t = e[u];
                if (t && t.key === e) return t;
                if (s(e)) {
                  t = {
                    key: e
                  };
                  try {
                    return a(e, u, {
                      value: t,
                      writable: !1,
                      enumerable: !1,
                      configurable: !1
                    }), t;
                  } catch (e) {
                    return;
                  }
                }
              }
              function b(e) {
                return e.prototype = null, Object.freeze(e);
              }
              function _() {
                f || "undefined" == typeof console || (f = !0, console.warn("WeakMap should be invoked as new WeakMap(), not WeakMap(). This will be an error in the future."));
              }
            }();
          }, {}],
          353: [function (e, t, n) {
            var r = e("./hidden-store.js");
            t.exports = function () {
              var e = {};
              return function (t) {
                if (("object" != typeof t || null === t) && "function" != typeof t) throw new Error("Weakmap-shim: Key must be object");
                var n = t.valueOf(e);
                return n && n.identity === e ? n : r(t, e);
              };
            };
          }, {
            "./hidden-store.js": 354
          }],
          354: [function (e, t, n) {
            t.exports = function (e, t) {
              var n = {
                  identity: t
                },
                r = e.valueOf;
              return Object.defineProperty(e, "valueOf", {
                value: function value(e) {
                  return e !== t ? r.apply(this, arguments) : n;
                },
                writable: !0
              }), n;
            };
          }, {}],
          355: [function (e, t, n) {
            var r = e("./create-store.js");
            t.exports = function () {
              var e = r();
              return {
                get: function get(t, n) {
                  var r = e(t);
                  return r.hasOwnProperty("value") ? r.value : n;
                },
                set: function set(t, n) {
                  return e(t).value = n, this;
                },
                has: function has(t) {
                  return "value" in e(t);
                },
                delete: function _delete(t) {
                  return delete e(t).value;
                }
              };
            };
          }, {
            "./create-store.js": 353
          }],
          356: [function (e, t, n) {
            var r = e("get-canvas-context");
            t.exports = function (e) {
              return r("webgl", e);
            };
          }, {
            "get-canvas-context": 95
          }],
          357: [function (e, t, n) {
            t.exports = e("cwise-compiler")({
              args: ["array", {
                offset: [1],
                array: 0
              }, "scalar", "scalar", "index"],
              pre: {
                body: "{}",
                args: [],
                thisVars: [],
                localVars: []
              },
              post: {
                body: "{}",
                args: [],
                thisVars: [],
                localVars: []
              },
              body: {
                body: "{\n        var _inline_1_da = _inline_1_arg0_ - _inline_1_arg3_\n        var _inline_1_db = _inline_1_arg1_ - _inline_1_arg3_\n        if((_inline_1_da >= 0) !== (_inline_1_db >= 0)) {\n          _inline_1_arg2_.push(_inline_1_arg4_[0] + 0.5 + 0.5 * (_inline_1_da + _inline_1_db) / (_inline_1_da - _inline_1_db))\n        }\n      }",
                args: [{
                  name: "_inline_1_arg0_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }, {
                  name: "_inline_1_arg1_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }, {
                  name: "_inline_1_arg2_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }, {
                  name: "_inline_1_arg3_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 2
                }, {
                  name: "_inline_1_arg4_",
                  lvalue: !1,
                  rvalue: !0,
                  count: 1
                }],
                thisVars: [],
                localVars: ["_inline_1_da", "_inline_1_db"]
              },
              funcName: "zeroCrossings"
            });
          }, {
            "cwise-compiler": 78
          }],
          358: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              var n = [];
              return t = +t || 0, r(e.hi(e.shape[0] - 1), n, t), n;
            };
            var r = e("./lib/zc-core");
          }, {
            "./lib/zc-core": 357
          }],
          359: [function (e, t, n) {
            "use strict";

            t.exports = [{
              path: "",
              backoff: 0
            }, {
              path: "M-2.4,-3V3L0.6,0Z",
              backoff: .6
            }, {
              path: "M-3.7,-2.5V2.5L1.3,0Z",
              backoff: 1.3
            }, {
              path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
              backoff: 1.55
            }, {
              path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
              backoff: 1.6
            }, {
              path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
              backoff: 2
            }, {
              path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
              backoff: 0,
              noRotate: !0
            }, {
              path: "M2,2V-2H-2V2Z",
              backoff: 0,
              noRotate: !0
            }];
          }, {}],
          360: [function (e, t, n) {
            "use strict";

            var r = e("./arrow_paths"),
              i = e("../../plots/font_attributes"),
              o = e("../../plots/cartesian/constants"),
              a = e("../../plot_api/plot_template").templatedArray;
            t.exports = a("annotation", {
              visible: {
                valType: "boolean",
                dflt: !0,
                editType: "calc+arraydraw"
              },
              text: {
                valType: "string",
                editType: "calc+arraydraw"
              },
              textangle: {
                valType: "angle",
                dflt: 0,
                editType: "calc+arraydraw"
              },
              font: i({
                editType: "calc+arraydraw",
                colorEditType: "arraydraw"
              }),
              width: {
                valType: "number",
                min: 1,
                dflt: null,
                editType: "calc+arraydraw"
              },
              height: {
                valType: "number",
                min: 1,
                dflt: null,
                editType: "calc+arraydraw"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 1,
                editType: "arraydraw"
              },
              align: {
                valType: "enumerated",
                values: ["left", "center", "right"],
                dflt: "center",
                editType: "arraydraw"
              },
              valign: {
                valType: "enumerated",
                values: ["top", "middle", "bottom"],
                dflt: "middle",
                editType: "arraydraw"
              },
              bgcolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)",
                editType: "arraydraw"
              },
              bordercolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)",
                editType: "arraydraw"
              },
              borderpad: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "calc+arraydraw"
              },
              borderwidth: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "calc+arraydraw"
              },
              showarrow: {
                valType: "boolean",
                dflt: !0,
                editType: "calc+arraydraw"
              },
              arrowcolor: {
                valType: "color",
                editType: "arraydraw"
              },
              arrowhead: {
                valType: "integer",
                min: 0,
                max: r.length,
                dflt: 1,
                editType: "arraydraw"
              },
              startarrowhead: {
                valType: "integer",
                min: 0,
                max: r.length,
                dflt: 1,
                editType: "arraydraw"
              },
              arrowside: {
                valType: "flaglist",
                flags: ["end", "start"],
                extras: ["none"],
                dflt: "end",
                editType: "arraydraw"
              },
              arrowsize: {
                valType: "number",
                min: .3,
                dflt: 1,
                editType: "calc+arraydraw"
              },
              startarrowsize: {
                valType: "number",
                min: .3,
                dflt: 1,
                editType: "calc+arraydraw"
              },
              arrowwidth: {
                valType: "number",
                min: .1,
                editType: "calc+arraydraw"
              },
              standoff: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "calc+arraydraw"
              },
              startstandoff: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "calc+arraydraw"
              },
              ax: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              ay: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              axref: {
                valType: "enumerated",
                dflt: "pixel",
                values: ["pixel", o.idRegex.x.toString()],
                editType: "calc"
              },
              ayref: {
                valType: "enumerated",
                dflt: "pixel",
                values: ["pixel", o.idRegex.y.toString()],
                editType: "calc"
              },
              xref: {
                valType: "enumerated",
                values: ["paper", o.idRegex.x.toString()],
                editType: "calc"
              },
              x: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              xanchor: {
                valType: "enumerated",
                values: ["auto", "left", "center", "right"],
                dflt: "auto",
                editType: "calc+arraydraw"
              },
              xshift: {
                valType: "number",
                dflt: 0,
                editType: "calc+arraydraw"
              },
              yref: {
                valType: "enumerated",
                values: ["paper", o.idRegex.y.toString()],
                editType: "calc"
              },
              y: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              yanchor: {
                valType: "enumerated",
                values: ["auto", "top", "middle", "bottom"],
                dflt: "auto",
                editType: "calc+arraydraw"
              },
              yshift: {
                valType: "number",
                dflt: 0,
                editType: "calc+arraydraw"
              },
              clicktoshow: {
                valType: "enumerated",
                values: [!1, "onoff", "onout"],
                dflt: !1,
                editType: "arraydraw"
              },
              xclick: {
                valType: "any",
                editType: "arraydraw"
              },
              yclick: {
                valType: "any",
                editType: "arraydraw"
              },
              hovertext: {
                valType: "string",
                editType: "arraydraw"
              },
              hoverlabel: {
                bgcolor: {
                  valType: "color",
                  editType: "arraydraw"
                },
                bordercolor: {
                  valType: "color",
                  editType: "arraydraw"
                },
                font: i({
                  editType: "arraydraw"
                }),
                editType: "arraydraw"
              },
              captureevents: {
                valType: "boolean",
                editType: "arraydraw"
              },
              editType: "calc",
              _deprecated: {
                ref: {
                  valType: "string",
                  editType: "calc"
                }
              }
            });
          }, {
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/constants": 547,
            "../../plots/font_attributes": 567,
            "./arrow_paths": 359
          }],
          361: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes"),
              o = e("./draw").draw;
            function a(e) {
              var t = e._fullLayout;
              r.filterVisible(t.annotations).forEach(function (t) {
                var n = i.getFromId(e, t.xref),
                  r = i.getFromId(e, t.yref);
                t._extremes = {}, n && s(t, n), r && s(t, r);
              });
            }
            function s(e, t) {
              var n,
                r = t._id,
                o = r.charAt(0),
                a = e[o],
                s = e["a" + o],
                l = e[o + "ref"],
                u = e["a" + o + "ref"],
                c = e["_" + o + "padplus"],
                d = e["_" + o + "padminus"],
                h = {
                  x: 1,
                  y: -1
                }[o] * e[o + "shift"],
                f = 3 * e.arrowsize * e.arrowwidth || 0,
                p = f + h,
                m = f - h,
                g = 3 * e.startarrowsize * e.arrowwidth || 0,
                v = g + h,
                y = g - h;
              if (u === l) {
                var b = i.findExtremes(t, [t.r2c(a)], {
                    ppadplus: p,
                    ppadminus: m
                  }),
                  _ = i.findExtremes(t, [t.r2c(s)], {
                    ppadplus: Math.max(c, v),
                    ppadminus: Math.max(d, y)
                  });
                n = {
                  min: [b.min[0], _.min[0]],
                  max: [b.max[0], _.max[0]]
                };
              } else v = s ? v + s : v, y = s ? y - s : y, n = i.findExtremes(t, [t.r2c(a)], {
                ppadplus: Math.max(c, p, v),
                ppadminus: Math.max(d, m, y)
              });
              e._extremes[r] = n;
            }
            t.exports = function (e) {
              var t = e._fullLayout;
              if (r.filterVisible(t.annotations).length && e._fullData.length) return r.syncOrAsync([o, a], e);
            };
          }, {
            "../../lib": 495,
            "../../plots/cartesian/axes": 541,
            "./draw": 366
          }],
          362: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../registry"),
              o = e("../../plot_api/plot_template").arrayEditor;
            function a(e, t) {
              var n,
                r,
                i,
                o,
                a,
                l,
                u,
                c = e._fullLayout.annotations,
                d = [],
                h = [],
                f = [],
                p = (t || []).length;
              for (n = 0; n < c.length; n++) if (o = (i = c[n]).clicktoshow) {
                for (r = 0; r < p; r++) if (l = (a = t[r]).xaxis, u = a.yaxis, l._id === i.xref && u._id === i.yref && l.d2r(a.x) === s(i._xclick, l) && u.d2r(a.y) === s(i._yclick, u)) {
                  (i.visible ? "onout" === o ? h : f : d).push(n);
                  break;
                }
                r === p && i.visible && "onout" === o && h.push(n);
              }
              return {
                on: d,
                off: h,
                explicitOff: f
              };
            }
            function s(e, t) {
              return "log" === t.type ? t.l2r(e) : t.d2r(e);
            }
            t.exports = {
              hasClickToShow: function hasClickToShow(e, t) {
                var n = a(e, t);
                return n.on.length > 0 || n.explicitOff.length > 0;
              },
              onClick: function onClick(e, t) {
                var n,
                  s,
                  l = a(e, t),
                  u = l.on,
                  c = l.off.concat(l.explicitOff),
                  d = {},
                  h = e._fullLayout.annotations;
                if (u.length || c.length) {
                  for (n = 0; n < u.length; n++) (s = o(e.layout, "annotations", h[u[n]])).modifyItem("visible", !0), r.extendFlat(d, s.getUpdateObj());
                  for (n = 0; n < c.length; n++) (s = o(e.layout, "annotations", h[c[n]])).modifyItem("visible", !1), r.extendFlat(d, s.getUpdateObj());
                  return i.call("update", e, {}, d);
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../registry": 593
          }],
          363: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../color");
            t.exports = function (e, t, n, o) {
              o("opacity");
              var a = o("bgcolor"),
                s = o("bordercolor"),
                l = i.opacity(s);
              o("borderpad");
              var u = o("borderwidth"),
                c = o("showarrow");
              if (o("text", c ? " " : n._dfltTitle.annotation), o("textangle"), r.coerceFont(o, "font", n.font), o("width"), o("align"), o("height") && o("valign"), c) {
                var d,
                  h,
                  f = o("arrowside");
                -1 !== f.indexOf("end") && (d = o("arrowhead"), h = o("arrowsize")), -1 !== f.indexOf("start") && (o("startarrowhead", d), o("startarrowsize", h)), o("arrowcolor", l ? t.bordercolor : i.defaultLine), o("arrowwidth", 2 * (l && u || 1)), o("standoff"), o("startstandoff");
              }
              var p = o("hovertext"),
                m = n.hoverlabel || {};
              if (p) {
                var g = o("hoverlabel.bgcolor", m.bgcolor || (i.opacity(a) ? i.rgb(a) : i.defaultLine)),
                  v = o("hoverlabel.bordercolor", m.bordercolor || i.contrast(g));
                r.coerceFont(o, "hoverlabel.font", {
                  family: m.font.family,
                  size: m.font.size,
                  color: m.font.color || v
                });
              }
              o("captureevents", !!p);
            };
          }, {
            "../../lib": 495,
            "../color": 375
          }],
          364: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib/to_log_range");
            t.exports = function (e, t, n, o) {
              t = t || {};
              var a = "log" === n && "linear" === t.type,
                s = "linear" === n && "log" === t.type;
              if (a || s) for (var l, u, c = e._fullLayout.annotations, d = t._id.charAt(0), h = 0; h < c.length; h++) l = c[h], u = "annotations[" + h + "].", l[d + "ref"] === t._id && f(d), l["a" + d + "ref"] === t._id && f("a" + d);
              function f(e) {
                var n = l[e],
                  s = null;
                s = a ? i(n, t.range) : Math.pow(10, n), r(s) || (s = null), o(u + e, s);
              }
            };
          }, {
            "../../lib/to_log_range": 520,
            "fast-isnumeric": 91
          }],
          365: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes"),
              o = e("../../plots/array_container_defaults"),
              a = e("./common_defaults"),
              s = e("./attributes");
            function l(e, t, n) {
              function o(n, i) {
                return r.coerce(e, t, s, n, i);
              }
              var l = o("visible"),
                u = o("clicktoshow");
              if (l || u) {
                a(e, t, n, o);
                for (var c = t.showarrow, d = ["x", "y"], h = [-10, -30], f = {
                    _fullLayout: n
                  }, p = 0; p < 2; p++) {
                  var m = d[p],
                    g = i.coerceRef(e, t, f, m, "", "paper");
                  if ("paper" !== g && i.getFromId(f, g)._annIndices.push(t._index), i.coercePosition(t, f, o, g, m, .5), c) {
                    var v = "a" + m,
                      y = i.coerceRef(e, t, f, v, "pixel");
                    "pixel" !== y && y !== g && (y = t[v] = "pixel");
                    var b = "pixel" === y ? h[p] : .4;
                    i.coercePosition(t, f, o, y, v, b);
                  }
                  o(m + "anchor"), o(m + "shift");
                }
                if (r.noneOrAll(e, t, ["x", "y"]), c && r.noneOrAll(e, t, ["ax", "ay"]), u) {
                  var _ = o("xclick"),
                    x = o("yclick");
                  t._xclick = void 0 === _ ? t.x : i.cleanPosition(_, f, t.xref), t._yclick = void 0 === x ? t.y : i.cleanPosition(x, f, t.yref);
                }
              }
            }
            t.exports = function (e, t) {
              o(e, t, {
                name: "annotations",
                handleItemDefaults: l
              });
            };
          }, {
            "../../lib": 495,
            "../../plots/array_container_defaults": 537,
            "../../plots/cartesian/axes": 541,
            "./attributes": 360,
            "./common_defaults": 363
          }],
          366: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../plots/plots"),
              a = e("../../lib"),
              s = e("../../plots/cartesian/axes"),
              l = e("../color"),
              u = e("../drawing"),
              c = e("../fx"),
              d = e("../../lib/svg_text_utils"),
              h = e("../../lib/setcursor"),
              f = e("../dragelement"),
              p = e("../../plot_api/plot_template").arrayEditor,
              m = e("./draw_arrow_head");
            function g(e, t) {
              var n = e._fullLayout.annotations[t] || {},
                r = s.getFromId(e, n.xref),
                i = s.getFromId(e, n.yref);
              r && r.setScale(), i && i.setScale(), v(e, n, t, !1, r, i);
            }
            function v(e, t, n, o, s, g) {
              var v,
                y,
                b = e._fullLayout,
                _ = e._fullLayout._size,
                x = e._context.edits;
              o ? (v = "annotation-" + o, y = o + ".annotations") : (v = "annotation", y = "annotations");
              var w = p(e.layout, y, t),
                S = w.modifyBase,
                A = w.modifyItem,
                E = w.getUpdateObj;
              b._infolayer.selectAll("." + v + '[data-index="' + n + '"]').remove();
              var T = "clip" + b._uid + "_ann" + n;
              if (t._input && !1 !== t.visible) {
                var M = {
                    x: {},
                    y: {}
                  },
                  C = +t.textangle || 0,
                  k = b._infolayer.append("g").classed(v, !0).attr("data-index", String(n)).style("opacity", t.opacity),
                  P = k.append("g").classed("annotation-text-g", !0),
                  O = x[t.showarrow ? "annotationTail" : "annotationPosition"],
                  R = t.captureevents || x.annotationText || O,
                  I = P.append("g").style("pointer-events", R ? "all" : null).call(h, "pointer").on("click", function () {
                    e._dragging = !1, e.emit("plotly_clickannotation", V(r.event));
                  });
                t.hovertext && I.on("mouseover", function () {
                  var n = t.hoverlabel,
                    r = n.font,
                    i = this.getBoundingClientRect(),
                    o = e.getBoundingClientRect();
                  c.loneHover({
                    x0: i.left - o.left,
                    x1: i.right - o.left,
                    y: (i.top + i.bottom) / 2 - o.top,
                    text: t.hovertext,
                    color: n.bgcolor,
                    borderColor: n.bordercolor,
                    fontFamily: r.family,
                    fontSize: r.size,
                    fontColor: r.color
                  }, {
                    container: b._hoverlayer.node(),
                    outerContainer: b._paper.node(),
                    gd: e
                  });
                }).on("mouseout", function () {
                  c.loneUnhover(b._hoverlayer.node());
                });
                var j = t.borderwidth,
                  N = t.borderpad,
                  L = j + N,
                  D = I.append("rect").attr("class", "bg").style("stroke-width", j + "px").call(l.stroke, t.bordercolor).call(l.fill, t.bgcolor),
                  B = t.width || t.height,
                  F = b._topclips.selectAll("#" + T).data(B ? [0] : []);
                F.enter().append("clipPath").classed("annclip", !0).attr("id", T).append("rect"), F.exit().remove();
                var z = t.font,
                  U = b._meta ? a.templateString(t.text, b._meta) : t.text,
                  G = I.append("text").classed("annotation-text", !0).text(U);
                x.annotationText ? G.call(d.makeEditable, {
                  delegate: I,
                  gd: e
                }).call(H).on("edit", function (n) {
                  t.text = n, this.call(H), A("text", n), s && s.autorange && S(s._name + ".autorange", !0), g && g.autorange && S(g._name + ".autorange", !0), i.call("_guiRelayout", e, E());
                }) : G.call(H);
              } else r.selectAll("#" + T).remove();
              function V(e) {
                var r = {
                  index: n,
                  annotation: t._input,
                  fullAnnotation: t,
                  event: e
                };
                return o && (r.subplotId = o), r;
              }
              function H(n) {
                return n.call(u.font, z).attr({
                  "text-anchor": {
                    left: "start",
                    right: "end"
                  }[t.align] || "middle"
                }), d.convertToTspans(n, e, q), n;
              }
              function q() {
                var n = G.selectAll("a");
                1 === n.size() && n.text() === G.text() && I.insert("a", ":first-child").attr({
                  "xlink:xlink:href": n.attr("xlink:href"),
                  "xlink:xlink:show": n.attr("xlink:show")
                }).style({
                  cursor: "pointer"
                }).node().appendChild(D.node());
                var r = I.select(".annotation-text-math-group"),
                  c = !r.empty(),
                  p = u.bBox((c ? r : G).node()),
                  v = p.width,
                  y = p.height,
                  w = t.width || v,
                  R = t.height || y,
                  N = Math.round(w + 2 * L),
                  z = Math.round(R + 2 * L);
                function U(e, t) {
                  return "auto" === t && (t = e < 1 / 3 ? "left" : e > 2 / 3 ? "right" : "center"), {
                    center: 0,
                    middle: 0,
                    left: .5,
                    bottom: -.5,
                    right: -.5,
                    top: .5
                  }[t];
                }
                for (var H = !1, q = ["x", "y"], W = 0; W < q.length; W++) {
                  var $,
                    X,
                    Y,
                    K,
                    Z,
                    Q = q[W],
                    J = t[Q + "ref"] || Q,
                    ee = t["a" + Q + "ref"],
                    te = {
                      x: s,
                      y: g
                    }[Q],
                    ne = (C + ("x" === Q ? 0 : -90)) * Math.PI / 180,
                    re = N * Math.cos(ne),
                    ie = z * Math.sin(ne),
                    oe = Math.abs(re) + Math.abs(ie),
                    ae = t[Q + "anchor"],
                    se = t[Q + "shift"] * ("x" === Q ? 1 : -1),
                    le = M[Q];
                  if (te) {
                    var ue = te.r2fraction(t[Q]);
                    (ue < 0 || ue > 1) && (ee === J ? ((ue = te.r2fraction(t["a" + Q])) < 0 || ue > 1) && (H = !0) : H = !0), $ = te._offset + te.r2p(t[Q]), K = .5;
                  } else "x" === Q ? (Y = t[Q], $ = _.l + _.w * Y) : (Y = 1 - t[Q], $ = _.t + _.h * Y), K = t.showarrow ? .5 : Y;
                  if (t.showarrow) {
                    le.head = $;
                    var ce = t["a" + Q];
                    Z = re * U(.5, t.xanchor) - ie * U(.5, t.yanchor), ee === J ? (le.tail = te._offset + te.r2p(ce), X = Z) : (le.tail = $ + ce, X = Z + ce), le.text = le.tail + Z;
                    var de = b["x" === Q ? "width" : "height"];
                    if ("paper" === J && (le.head = a.constrain(le.head, 1, de - 1)), "pixel" === ee) {
                      var he = -Math.max(le.tail - 3, le.text),
                        fe = Math.min(le.tail + 3, le.text) - de;
                      he > 0 ? (le.tail += he, le.text += he) : fe > 0 && (le.tail -= fe, le.text -= fe);
                    }
                    le.tail += se, le.head += se;
                  } else X = Z = oe * U(K, ae), le.text = $ + Z;
                  le.text += se, Z += se, X += se, t["_" + Q + "padplus"] = oe / 2 + X, t["_" + Q + "padminus"] = oe / 2 - X, t["_" + Q + "size"] = oe, t["_" + Q + "shift"] = Z;
                }
                if (H) I.remove();else {
                  var pe = 0,
                    me = 0;
                  if ("left" !== t.align && (pe = (w - v) * ("center" === t.align ? .5 : 1)), "top" !== t.valign && (me = (R - y) * ("middle" === t.valign ? .5 : 1)), c) r.select("svg").attr({
                    x: L + pe - 1,
                    y: L + me
                  }).call(u.setClipUrl, B ? T : null, e);else {
                    var ge = L + me - p.top,
                      ve = L + pe - p.left;
                    G.call(d.positionText, ve, ge).call(u.setClipUrl, B ? T : null, e);
                  }
                  F.select("rect").call(u.setRect, L, L, w, R), D.call(u.setRect, j / 2, j / 2, N - j, z - j), I.call(u.setTranslate, Math.round(M.x.text - N / 2), Math.round(M.y.text - z / 2)), P.attr({
                    transform: "rotate(" + C + "," + M.x.text + "," + M.y.text + ")"
                  });
                  var ye,
                    be = function be(n, r) {
                      k.selectAll(".annotation-arrow-g").remove();
                      var c = M.x.head,
                        d = M.y.head,
                        h = M.x.tail + n,
                        p = M.y.tail + r,
                        v = M.x.text + n,
                        y = M.y.text + r,
                        b = a.rotationXYMatrix(C, v, y),
                        w = a.apply2DTransform(b),
                        T = a.apply2DTransform2(b),
                        O = +D.attr("width"),
                        R = +D.attr("height"),
                        j = v - .5 * O,
                        N = j + O,
                        L = y - .5 * R,
                        B = L + R,
                        F = [[j, L, j, B], [j, B, N, B], [N, B, N, L], [N, L, j, L]].map(T);
                      if (!F.reduce(function (e, t) {
                        return e ^ !!a.segmentsIntersect(c, d, c + 1e6, d + 1e6, t[0], t[1], t[2], t[3]);
                      }, !1)) {
                        F.forEach(function (e) {
                          var t = a.segmentsIntersect(h, p, c, d, e[0], e[1], e[2], e[3]);
                          t && (h = t.x, p = t.y);
                        });
                        var z = t.arrowwidth,
                          U = t.arrowcolor,
                          G = t.arrowside,
                          V = k.append("g").style({
                            opacity: l.opacity(U)
                          }).classed("annotation-arrow-g", !0),
                          H = V.append("path").attr("d", "M" + h + "," + p + "L" + c + "," + d).style("stroke-width", z + "px").call(l.stroke, l.rgb(U));
                        if (m(H, G, t), x.annotationPosition && H.node().parentNode && !o) {
                          var q = c,
                            W = d;
                          if (t.standoff) {
                            var $ = Math.sqrt(Math.pow(c - h, 2) + Math.pow(d - p, 2));
                            q += t.standoff * (h - c) / $, W += t.standoff * (p - d) / $;
                          }
                          var X,
                            Y,
                            K = V.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                              d: "M3,3H-3V-3H3ZM0,0L" + (h - q) + "," + (p - W),
                              transform: "translate(" + q + "," + W + ")"
                            }).style("stroke-width", z + 6 + "px").call(l.stroke, "rgba(0,0,0,0)").call(l.fill, "rgba(0,0,0,0)");
                          f.init({
                            element: K.node(),
                            gd: e,
                            prepFn: function prepFn() {
                              var e = u.getTranslate(I);
                              X = e.x, Y = e.y, s && s.autorange && S(s._name + ".autorange", !0), g && g.autorange && S(g._name + ".autorange", !0);
                            },
                            moveFn: function moveFn(e, n) {
                              var r = w(X, Y),
                                i = r[0] + e,
                                o = r[1] + n;
                              I.call(u.setTranslate, i, o), A("x", s ? s.p2r(s.r2p(t.x) + e) : t.x + e / _.w), A("y", g ? g.p2r(g.r2p(t.y) + n) : t.y - n / _.h), t.axref === t.xref && A("ax", s.p2r(s.r2p(t.ax) + e)), t.ayref === t.yref && A("ay", g.p2r(g.r2p(t.ay) + n)), V.attr("transform", "translate(" + e + "," + n + ")"), P.attr({
                                transform: "rotate(" + C + "," + i + "," + o + ")"
                              });
                            },
                            doneFn: function doneFn() {
                              i.call("_guiRelayout", e, E());
                              var t = document.querySelector(".js-notes-box-panel");
                              t && t.redraw(t.selectedObj);
                            }
                          });
                        }
                      }
                    };
                  t.showarrow && be(0, 0), O && f.init({
                    element: I.node(),
                    gd: e,
                    prepFn: function prepFn() {
                      ye = P.attr("transform");
                    },
                    moveFn: function moveFn(e, n) {
                      var r = "pointer";
                      if (t.showarrow) t.axref === t.xref ? A("ax", s.p2r(s.r2p(t.ax) + e)) : A("ax", t.ax + e), t.ayref === t.yref ? A("ay", g.p2r(g.r2p(t.ay) + n)) : A("ay", t.ay + n), be(e, n);else {
                        if (o) return;
                        var i, a;
                        if (s) i = s.p2r(s.r2p(t.x) + e);else {
                          var l = t._xsize / _.w,
                            u = t.x + (t._xshift - t.xshift) / _.w - l / 2;
                          i = f.align(u + e / _.w, l, 0, 1, t.xanchor);
                        }
                        if (g) a = g.p2r(g.r2p(t.y) + n);else {
                          var c = t._ysize / _.h,
                            d = t.y - (t._yshift + t.yshift) / _.h - c / 2;
                          a = f.align(d - n / _.h, c, 0, 1, t.yanchor);
                        }
                        A("x", i), A("y", a), s && g || (r = f.getCursor(s ? .5 : i, g ? .5 : a, t.xanchor, t.yanchor));
                      }
                      P.attr({
                        transform: "translate(" + e + "," + n + ")" + ye
                      }), h(I, r);
                    },
                    clickFn: function clickFn(n, r) {
                      t.captureevents && e.emit("plotly_clickannotation", V(r));
                    },
                    doneFn: function doneFn() {
                      h(I), i.call("_guiRelayout", e, E());
                      var t = document.querySelector(".js-notes-box-panel");
                      t && t.redraw(t.selectedObj);
                    }
                  });
                }
              }
            }
            t.exports = {
              draw: function draw(e) {
                var t = e._fullLayout;
                t._infolayer.selectAll(".annotation").remove();
                for (var n = 0; n < t.annotations.length; n++) t.annotations[n].visible && g(e, n);
                return o.previousPromises(e);
              },
              drawOne: g,
              drawRaw: v
            };
          }, {
            "../../lib": 495,
            "../../lib/setcursor": 514,
            "../../lib/svg_text_utils": 518,
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/axes": 541,
            "../../plots/plots": 584,
            "../../registry": 593,
            "../color": 375,
            "../dragelement": 393,
            "../drawing": 396,
            "../fx": 413,
            "./draw_arrow_head": 367,
            d3: 82
          }],
          367: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../color"),
              o = e("./arrow_paths");
            t.exports = function (e, t, n) {
              var a,
                s,
                l,
                u,
                c = e.node(),
                d = o[n.arrowhead || 0],
                h = o[n.startarrowhead || 0],
                f = (n.arrowwidth || 1) * (n.arrowsize || 1),
                p = (n.arrowwidth || 1) * (n.startarrowsize || 1),
                m = t.indexOf("start") >= 0,
                g = t.indexOf("end") >= 0,
                v = d.backoff * f + n.standoff,
                y = h.backoff * p + n.startstandoff;
              if ("line" === c.nodeName) {
                a = {
                  x: +e.attr("x1"),
                  y: +e.attr("y1")
                }, s = {
                  x: +e.attr("x2"),
                  y: +e.attr("y2")
                };
                var b = a.x - s.x,
                  _ = a.y - s.y;
                if (u = (l = Math.atan2(_, b)) + Math.PI, v && y && v + y > Math.sqrt(b * b + _ * _)) return void O();
                if (v) {
                  if (v * v > b * b + _ * _) return void O();
                  var x = v * Math.cos(l),
                    w = v * Math.sin(l);
                  s.x += x, s.y += w, e.attr({
                    x2: s.x,
                    y2: s.y
                  });
                }
                if (y) {
                  if (y * y > b * b + _ * _) return void O();
                  var S = y * Math.cos(l),
                    A = y * Math.sin(l);
                  a.x -= S, a.y -= A, e.attr({
                    x1: a.x,
                    y1: a.y
                  });
                }
              } else if ("path" === c.nodeName) {
                var E = c.getTotalLength(),
                  T = "";
                if (E < v + y) return void O();
                var M = c.getPointAtLength(0),
                  C = c.getPointAtLength(.1);
                l = Math.atan2(M.y - C.y, M.x - C.x), a = c.getPointAtLength(Math.min(y, E)), T = "0px," + y + "px,";
                var k = c.getPointAtLength(E),
                  P = c.getPointAtLength(E - .1);
                u = Math.atan2(k.y - P.y, k.x - P.x), s = c.getPointAtLength(Math.max(0, E - v)), T += E - (T ? y + v : v) + "px," + E + "px", e.style("stroke-dasharray", T);
              }
              function O() {
                e.style("stroke-dasharray", "0px,100px");
              }
              function R(t, o, a, s) {
                t.path && (t.noRotate && (a = 0), r.select(c.parentNode).append("path").attr({
                  class: e.attr("class"),
                  d: t.path,
                  transform: "translate(" + o.x + "," + o.y + ")" + (a ? "rotate(" + 180 * a / Math.PI + ")" : "") + "scale(" + s + ")"
                }).style({
                  fill: i.rgb(n.arrowcolor),
                  "stroke-width": 0
                }));
              }
              m && R(h, a, l, p), g && R(d, s, u, f);
            };
          }, {
            "../color": 375,
            "./arrow_paths": 359,
            d3: 82
          }],
          368: [function (e, t, n) {
            "use strict";

            var r = e("./draw"),
              i = e("./click");
            t.exports = {
              moduleType: "component",
              name: "annotations",
              layoutAttributes: e("./attributes"),
              supplyLayoutDefaults: e("./defaults"),
              includeBasePlot: e("../../plots/cartesian/include_components")("annotations"),
              calcAutorange: e("./calc_autorange"),
              draw: r.draw,
              drawOne: r.drawOne,
              drawRaw: r.drawRaw,
              hasClickToShow: i.hasClickToShow,
              onClick: i.onClick,
              convertCoords: e("./convert_coords")
            };
          }, {
            "../../plots/cartesian/include_components": 551,
            "./attributes": 360,
            "./calc_autorange": 361,
            "./click": 362,
            "./convert_coords": 364,
            "./defaults": 365,
            "./draw": 366
          }],
          369: [function (e, t, n) {
            "use strict";

            var r = e("../annotations/attributes"),
              i = e("../../plot_api/edit_types").overrideAll,
              o = e("../../plot_api/plot_template").templatedArray;
            t.exports = i(o("annotation", {
              visible: r.visible,
              x: {
                valType: "any"
              },
              y: {
                valType: "any"
              },
              z: {
                valType: "any"
              },
              ax: {
                valType: "number"
              },
              ay: {
                valType: "number"
              },
              xanchor: r.xanchor,
              xshift: r.xshift,
              yanchor: r.yanchor,
              yshift: r.yshift,
              text: r.text,
              textangle: r.textangle,
              font: r.font,
              width: r.width,
              height: r.height,
              opacity: r.opacity,
              align: r.align,
              valign: r.valign,
              bgcolor: r.bgcolor,
              bordercolor: r.bordercolor,
              borderpad: r.borderpad,
              borderwidth: r.borderwidth,
              showarrow: r.showarrow,
              arrowcolor: r.arrowcolor,
              arrowhead: r.arrowhead,
              startarrowhead: r.startarrowhead,
              arrowside: r.arrowside,
              arrowsize: r.arrowsize,
              startarrowsize: r.startarrowsize,
              arrowwidth: r.arrowwidth,
              standoff: r.standoff,
              startstandoff: r.startstandoff,
              hovertext: r.hovertext,
              hoverlabel: r.hoverlabel,
              captureevents: r.captureevents
            }), "calc", "from-root");
          }, {
            "../../plot_api/edit_types": 524,
            "../../plot_api/plot_template": 531,
            "../annotations/attributes": 360
          }],
          370: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes");
            function o(e, t) {
              var n = t.fullSceneLayout.domain,
                o = t.fullLayout._size,
                a = {
                  pdata: null,
                  type: "linear",
                  autorange: !1,
                  range: [-1 / 0, 1 / 0]
                };
              e._xa = {}, r.extendFlat(e._xa, a), i.setConvert(e._xa), e._xa._offset = o.l + n.x[0] * o.w, e._xa.l2p = function () {
                return .5 * (1 + e._pdata[0] / e._pdata[3]) * o.w * (n.x[1] - n.x[0]);
              }, e._ya = {}, r.extendFlat(e._ya, a), i.setConvert(e._ya), e._ya._offset = o.t + (1 - n.y[1]) * o.h, e._ya.l2p = function () {
                return .5 * (1 - e._pdata[1] / e._pdata[3]) * o.h * (n.y[1] - n.y[0]);
              };
            }
            t.exports = function (e) {
              for (var t = e.fullSceneLayout.annotations, n = 0; n < t.length; n++) o(t[n], e);
              e.fullLayout._infolayer.selectAll(".annotation-" + e.id).remove();
            };
          }, {
            "../../lib": 495,
            "../../plots/cartesian/axes": 541
          }],
          371: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes"),
              o = e("../../plots/array_container_defaults"),
              a = e("../annotations/common_defaults"),
              s = e("./attributes");
            function l(e, t, n, o) {
              function l(n, i) {
                return r.coerce(e, t, s, n, i);
              }
              function u(e) {
                var r = e + "axis",
                  o = {
                    _fullLayout: {}
                  };
                return o._fullLayout[r] = n[r], i.coercePosition(t, o, l, e, e, .5);
              }
              l("visible") && (a(e, t, o.fullLayout, l), u("x"), u("y"), u("z"), r.noneOrAll(e, t, ["x", "y", "z"]), t.xref = "x", t.yref = "y", t.zref = "z", l("xanchor"), l("yanchor"), l("xshift"), l("yshift"), t.showarrow && (t.axref = "pixel", t.ayref = "pixel", l("ax", -10), l("ay", -30), r.noneOrAll(e, t, ["ax", "ay"])));
            }
            t.exports = function (e, t, n) {
              o(e, t, {
                name: "annotations",
                handleItemDefaults: l,
                fullLayout: n.fullLayout
              });
            };
          }, {
            "../../lib": 495,
            "../../plots/array_container_defaults": 537,
            "../../plots/cartesian/axes": 541,
            "../annotations/common_defaults": 363,
            "./attributes": 369
          }],
          372: [function (e, t, n) {
            "use strict";

            var r = e("../annotations/draw").drawRaw,
              i = e("../../plots/gl3d/project"),
              o = ["x", "y", "z"];
            t.exports = function (e) {
              for (var t = e.fullSceneLayout, n = e.dataScale, a = t.annotations, s = 0; s < a.length; s++) {
                for (var l = a[s], u = !1, c = 0; c < 3; c++) {
                  var d = o[c],
                    h = l[d],
                    f = t[d + "axis"].r2fraction(h);
                  if (f < 0 || f > 1) {
                    u = !0;
                    break;
                  }
                }
                u ? e.fullLayout._infolayer.select(".annotation-" + e.id + '[data-index="' + s + '"]').remove() : (l._pdata = i(e.glplot.cameraParams, [t.xaxis.r2l(l.x) * n[0], t.yaxis.r2l(l.y) * n[1], t.zaxis.r2l(l.z) * n[2]]), r(e.graphDiv, l, s, e.id, l._xa, l._ya));
              }
            };
          }, {
            "../../plots/gl3d/project": 579,
            "../annotations/draw": 366
          }],
          373: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib");
            t.exports = {
              moduleType: "component",
              name: "annotations3d",
              schema: {
                subplots: {
                  scene: {
                    annotations: e("./attributes")
                  }
                }
              },
              layoutAttributes: e("./attributes"),
              handleDefaults: e("./defaults"),
              includeBasePlot: function includeBasePlot(e, t) {
                var n = r.subplotsRegistry.gl3d;
                if (n) for (var o = n.attrRegex, a = Object.keys(e), s = 0; s < a.length; s++) {
                  var l = a[s];
                  o.test(l) && (e[l].annotations || []).length && (i.pushUnique(t._basePlotModules, n), i.pushUnique(t._subplots.gl3d, l));
                }
              },
              convert: e("./convert"),
              draw: e("./draw")
            };
          }, {
            "../../lib": 495,
            "../../registry": 593,
            "./attributes": 369,
            "./convert": 370,
            "./defaults": 371,
            "./draw": 372
          }],
          374: [function (e, t, n) {
            "use strict";

            n.defaults = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"], n.defaultLine = "#444", n.lightLine = "#eee", n.background = "#fff", n.borderLine = "#BEC8D9", n.lightFraction = 1e3 / 11;
          }, {}],
          375: [function (e, t, n) {
            "use strict";

            var r = e("tinycolor2"),
              i = e("fast-isnumeric"),
              o = t.exports = {},
              a = e("./attributes");
            o.defaults = a.defaults;
            var s = o.defaultLine = a.defaultLine;
            o.lightLine = a.lightLine;
            var l = o.background = a.background;
            function u(e) {
              if (i(e) || "string" != typeof e) return e;
              var t = e.trim();
              if ("rgb" !== t.substr(0, 3)) return e;
              var n = t.match(/^rgba?\s*\(([^()]*)\)$/);
              if (!n) return e;
              var r = n[1].trim().split(/\s*[\s,]\s*/),
                o = "a" === t.charAt(3) && 4 === r.length;
              if (!o && 3 !== r.length) return e;
              for (var a = 0; a < r.length; a++) {
                if (!r[a].length) return e;
                if (r[a] = Number(r[a]), !(r[a] >= 0)) return e;
                if (3 === a) r[a] > 1 && (r[a] = 1);else if (r[a] >= 1) return e;
              }
              var s = Math.round(255 * r[0]) + ", " + Math.round(255 * r[1]) + ", " + Math.round(255 * r[2]);
              return o ? "rgba(" + s + ", " + r[3] + ")" : "rgb(" + s + ")";
            }
            o.tinyRGB = function (e) {
              var t = e.toRgb();
              return "rgb(" + Math.round(t.r) + ", " + Math.round(t.g) + ", " + Math.round(t.b) + ")";
            }, o.rgb = function (e) {
              return o.tinyRGB(r(e));
            }, o.opacity = function (e) {
              return e ? r(e).getAlpha() : 0;
            }, o.addOpacity = function (e, t) {
              var n = r(e).toRgb();
              return "rgba(" + Math.round(n.r) + ", " + Math.round(n.g) + ", " + Math.round(n.b) + ", " + t + ")";
            }, o.combine = function (e, t) {
              var n = r(e).toRgb();
              if (1 === n.a) return r(e).toRgbString();
              var i = r(t || l).toRgb(),
                o = 1 === i.a ? i : {
                  r: 255 * (1 - i.a) + i.r * i.a,
                  g: 255 * (1 - i.a) + i.g * i.a,
                  b: 255 * (1 - i.a) + i.b * i.a
                },
                a = {
                  r: o.r * (1 - n.a) + n.r * n.a,
                  g: o.g * (1 - n.a) + n.g * n.a,
                  b: o.b * (1 - n.a) + n.b * n.a
                };
              return r(a).toRgbString();
            }, o.contrast = function (e, t, n) {
              var i = r(e);
              return 1 !== i.getAlpha() && (i = r(o.combine(e, l))), (i.isDark() ? t ? i.lighten(t) : l : n ? i.darken(n) : s).toString();
            }, o.stroke = function (e, t) {
              var n = r(t);
              e.style({
                stroke: o.tinyRGB(n),
                "stroke-opacity": n.getAlpha()
              });
            }, o.fill = function (e, t) {
              var n = r(t);
              e.style({
                fill: o.tinyRGB(n),
                "fill-opacity": n.getAlpha()
              });
            }, o.clean = function (e) {
              if (e && "object" == typeof e) {
                var t,
                  n,
                  r,
                  i,
                  a = Object.keys(e);
                for (t = 0; t < a.length; t++) if (i = e[r = a[t]], "color" === r.substr(r.length - 5)) {
                  if (Array.isArray(i)) for (n = 0; n < i.length; n++) i[n] = u(i[n]);else e[r] = u(i);
                } else if ("colorscale" === r.substr(r.length - 10) && Array.isArray(i)) for (n = 0; n < i.length; n++) Array.isArray(i[n]) && (i[n][1] = u(i[n][1]));else if (Array.isArray(i)) {
                  var s = i[0];
                  if (!Array.isArray(s) && s && "object" == typeof s) for (n = 0; n < i.length; n++) o.clean(i[n]);
                } else i && "object" == typeof i && o.clean(i);
              }
            };
          }, {
            "./attributes": 374,
            "fast-isnumeric": 91,
            tinycolor2: 341
          }],
          376: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/cartesian/layout_attributes"),
              i = e("../../plots/font_attributes"),
              o = e("../../lib/extend").extendFlat,
              a = e("../../plot_api/edit_types").overrideAll;
            t.exports = a({
              thicknessmode: {
                valType: "enumerated",
                values: ["fraction", "pixels"],
                dflt: "pixels"
              },
              thickness: {
                valType: "number",
                min: 0,
                dflt: 30
              },
              lenmode: {
                valType: "enumerated",
                values: ["fraction", "pixels"],
                dflt: "fraction"
              },
              len: {
                valType: "number",
                min: 0,
                dflt: 1
              },
              x: {
                valType: "number",
                dflt: 1.02,
                min: -2,
                max: 3
              },
              xanchor: {
                valType: "enumerated",
                values: ["left", "center", "right"],
                dflt: "left"
              },
              xpad: {
                valType: "number",
                min: 0,
                dflt: 10
              },
              y: {
                valType: "number",
                dflt: .5,
                min: -2,
                max: 3
              },
              yanchor: {
                valType: "enumerated",
                values: ["top", "middle", "bottom"],
                dflt: "middle"
              },
              ypad: {
                valType: "number",
                min: 0,
                dflt: 10
              },
              outlinecolor: r.linecolor,
              outlinewidth: r.linewidth,
              bordercolor: r.linecolor,
              borderwidth: {
                valType: "number",
                min: 0,
                dflt: 0
              },
              bgcolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)"
              },
              tickmode: r.tickmode,
              nticks: r.nticks,
              tick0: r.tick0,
              dtick: r.dtick,
              tickvals: r.tickvals,
              ticktext: r.ticktext,
              ticks: o({}, r.ticks, {
                dflt: ""
              }),
              ticklen: r.ticklen,
              tickwidth: r.tickwidth,
              tickcolor: r.tickcolor,
              showticklabels: r.showticklabels,
              tickfont: i({}),
              tickangle: r.tickangle,
              tickformat: r.tickformat,
              tickformatstops: r.tickformatstops,
              tickprefix: r.tickprefix,
              showtickprefix: r.showtickprefix,
              ticksuffix: r.ticksuffix,
              showticksuffix: r.showticksuffix,
              separatethousands: r.separatethousands,
              exponentformat: r.exponentformat,
              showexponent: r.showexponent,
              title: {
                text: {
                  valType: "string"
                },
                font: i({}),
                side: {
                  valType: "enumerated",
                  values: ["right", "top", "bottom"],
                  dflt: "top"
                }
              },
              _deprecated: {
                title: {
                  valType: "string"
                },
                titlefont: i({}),
                titleside: {
                  valType: "enumerated",
                  values: ["right", "top", "bottom"],
                  dflt: "top"
                }
              }
            }, "colorbars", "from-root");
          }, {
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plots/cartesian/layout_attributes": 553,
            "../../plots/font_attributes": 567
          }],
          377: [function (e, t, n) {
            "use strict";

            t.exports = {
              cn: {
                colorbar: "colorbar",
                cbbg: "cbbg",
                cbfill: "cbfill",
                cbfills: "cbfills",
                cbline: "cbline",
                cblines: "cblines",
                cbaxis: "cbaxis",
                cbtitleunshift: "cbtitleunshift",
                cbtitle: "cbtitle",
                cboutline: "cboutline",
                crisp: "crisp",
                jsPlaceholder: "js-placeholder"
              }
            };
          }, {}],
          378: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plot_api/plot_template"),
              o = e("../../plots/cartesian/tick_value_defaults"),
              a = e("../../plots/cartesian/tick_mark_defaults"),
              s = e("../../plots/cartesian/tick_label_defaults"),
              l = e("./attributes");
            t.exports = function (e, t, n) {
              var u = i.newContainer(t, "colorbar"),
                c = e.colorbar || {};
              function d(e, t) {
                return r.coerce(c, u, l, e, t);
              }
              var h = d("thicknessmode");
              d("thickness", "fraction" === h ? 30 / (n.width - n.margin.l - n.margin.r) : 30);
              var f = d("lenmode");
              d("len", "fraction" === f ? 1 : n.height - n.margin.t - n.margin.b), d("x"), d("xanchor"), d("xpad"), d("y"), d("yanchor"), d("ypad"), r.noneOrAll(c, u, ["x", "y"]), d("outlinecolor"), d("outlinewidth"), d("bordercolor"), d("borderwidth"), d("bgcolor"), o(c, u, d, "linear");
              var p = {
                outerTicks: !1,
                font: n.font
              };
              s(c, u, d, "linear", p), a(c, u, d, "linear", p), d("title.text", n._dfltTitle.colorbar), r.coerceFont(d, "title.font", n.font), d("title.side");
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/tick_label_defaults": 560,
            "../../plots/cartesian/tick_mark_defaults": 561,
            "../../plots/cartesian/tick_value_defaults": 562,
            "./attributes": 376
          }],
          379: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("tinycolor2"),
              o = e("../../plots/plots"),
              a = e("../../registry"),
              s = e("../../plots/cartesian/axes"),
              l = e("../dragelement"),
              u = e("../../lib"),
              c = e("../../lib/extend").extendFlat,
              d = e("../../lib/setcursor"),
              h = e("../drawing"),
              f = e("../color"),
              p = e("../titles"),
              m = e("../../lib/svg_text_utils"),
              g = e("../colorscale/helpers").flipScale,
              v = e("../../plots/cartesian/axis_defaults"),
              y = e("../../plots/cartesian/position_defaults"),
              b = e("../../plots/cartesian/layout_attributes"),
              _ = e("../../constants/alignment"),
              x = _.LINE_SPACING,
              w = _.FROM_TL,
              S = _.FROM_BR,
              A = e("./constants").cn;
            t.exports = {
              draw: function draw(e) {
                var t = e._fullLayout._infolayer.selectAll("g." + A.colorbar).data(function (e) {
                  var t,
                    n,
                    r,
                    i,
                    o = e._fullLayout,
                    a = e.calcdata,
                    s = [];
                  function l(e) {
                    return c(e, {
                      _fillcolor: null,
                      _line: {
                        color: null,
                        width: null,
                        dash: null
                      },
                      _levels: {
                        start: null,
                        end: null,
                        size: null
                      },
                      _filllevels: null,
                      _fillgradient: null,
                      _zrange: null
                    });
                  }
                  function u() {
                    "function" == typeof i.calc ? i.calc(e, r, t) : (t._fillgradient = n.reversescale ? g(n.colorscale) : n.colorscale, t._zrange = [n[i.min], n[i.max]]);
                  }
                  for (var d = 0; d < a.length; d++) {
                    var h = a[d],
                      f = (r = h[0].trace)._module.colorbar;
                    if (!0 === r.visible && f) for (var p = Array.isArray(f), m = p ? f : [f], v = 0; v < m.length; v++) {
                      var y = (i = m[v]).container;
                      (n = y ? r[y] : r) && n.showscale && ((t = l(n.colorbar))._id = "cb" + r.uid + (p && y ? "-" + y : ""), t._traceIndex = r.index, t._propPrefix = (y ? y + "." : "") + "colorbar.", t._meta = r._meta, u(), s.push(t));
                    }
                  }
                  for (var b in o._colorAxes) if ((n = o[b]).showscale) {
                    var _ = o._colorAxes[b];
                    (t = l(n.colorbar))._id = "cb" + b, t._propPrefix = b + ".colorbar.", t._meta = o._meta, i = {
                      min: "cmin",
                      max: "cmax"
                    }, "heatmap" !== _[0] && (r = _[1], i.calc = r._module.colorbar.calc), u(), s.push(t);
                  }
                  return s;
                }(e), function (e) {
                  return e._id;
                });
                t.enter().append("g").attr("class", function (e) {
                  return e._id;
                }).classed(A.colorbar, !0), t.each(function (t) {
                  var n = r.select(this);
                  u.ensureSingle(n, "rect", A.cbbg), u.ensureSingle(n, "g", A.cbfills), u.ensureSingle(n, "g", A.cblines), u.ensureSingle(n, "g", A.cbaxis, function (e) {
                    e.classed(A.crisp, !0);
                  }), u.ensureSingle(n, "g", A.cbtitleunshift, function (e) {
                    e.append("g").classed(A.cbtitle, !0);
                  }), u.ensureSingle(n, "rect", A.cboutline);
                  var g = function (e, t, n) {
                    var a = n._fullLayout,
                      l = a._size,
                      d = t._fillcolor,
                      g = t._line,
                      _ = t.title,
                      E = _.side,
                      T = t._zrange || r.extent(("function" == typeof d ? d : g.color).domain()),
                      M = "function" == typeof g.color ? g.color : function () {
                        return g.color;
                      },
                      C = "function" == typeof d ? d : function () {
                        return d;
                      },
                      k = t._levels,
                      P = function (e, t, n) {
                        var r,
                          i,
                          o = t._levels,
                          a = [],
                          s = [],
                          l = o.end + o.size / 100,
                          u = o.size,
                          c = 1.001 * n[0] - .001 * n[1],
                          d = 1.001 * n[1] - .001 * n[0];
                        for (i = 0; i < 1e5 && (r = o.start + i * u, !(u > 0 ? r >= l : r <= l)); i++) r > c && r < d && a.push(r);
                        if (t._fillgradient) s = [0];else if ("function" == typeof t._fillcolor) {
                          var h = t._filllevels;
                          if (h) for (l = h.end + h.size / 100, u = h.size, i = 0; i < 1e5 && (r = h.start + i * u, !(u > 0 ? r >= l : r <= l)); i++) r > n[0] && r < n[1] && s.push(r);else (s = a.map(function (e) {
                            return e - o.size / 2;
                          })).push(s[s.length - 1] + o.size);
                        } else t._fillcolor && "string" == typeof t._fillcolor && (s = [0]);
                        return o.size < 0 && (a.reverse(), s.reverse()), {
                          line: a,
                          fill: s
                        };
                      }(0, t, T),
                      O = P.fill,
                      R = P.line,
                      I = Math.round(t.thickness * ("fraction" === t.thicknessmode ? l.w : 1)),
                      j = I / l.w,
                      N = Math.round(t.len * ("fraction" === t.lenmode ? l.h : 1)),
                      L = N / l.h,
                      D = t.xpad / l.w,
                      B = (t.borderwidth + t.outlinewidth) / 2,
                      F = t.ypad / l.h,
                      z = Math.round(t.x * l.w + t.xpad),
                      U = t.x - j * ({
                        middle: .5,
                        right: 1
                      }[t.xanchor] || 0),
                      G = t.y + L * (({
                        top: -.5,
                        bottom: .5
                      }[t.yanchor] || 0) - .5),
                      V = Math.round(l.h * (1 - G)),
                      H = V - N;
                    t._lenFrac = L, t._thickFrac = j, t._xLeftFrac = U, t._yBottomFrac = G;
                    var q = t._axis = function (e, t, n) {
                      var r = e._fullLayout,
                        i = {
                          type: "linear",
                          range: n,
                          tickmode: t.tickmode,
                          nticks: t.nticks,
                          tick0: t.tick0,
                          dtick: t.dtick,
                          tickvals: t.tickvals,
                          ticktext: t.ticktext,
                          ticks: t.ticks,
                          ticklen: t.ticklen,
                          tickwidth: t.tickwidth,
                          tickcolor: t.tickcolor,
                          showticklabels: t.showticklabels,
                          tickfont: t.tickfont,
                          tickangle: t.tickangle,
                          tickformat: t.tickformat,
                          exponentformat: t.exponentformat,
                          separatethousands: t.separatethousands,
                          showexponent: t.showexponent,
                          showtickprefix: t.showtickprefix,
                          tickprefix: t.tickprefix,
                          showticksuffix: t.showticksuffix,
                          ticksuffix: t.ticksuffix,
                          title: t.title,
                          showline: !0,
                          anchor: "free",
                          side: "right",
                          position: 1
                        },
                        o = {
                          type: "linear",
                          _id: "y" + t._id
                        },
                        a = {
                          letter: "y",
                          font: r.font,
                          noHover: !0,
                          noTickson: !0,
                          calendar: r.calendar
                        };
                      function s(e, t) {
                        return u.coerce(i, o, b, e, t);
                      }
                      return v(i, o, s, a, r), y(i, o, s, a), o;
                    }(n, t, T);
                    if (q.position = t.x + D + j, -1 !== ["top", "bottom"].indexOf(E) && (q.title.side = E, q.titlex = t.x + D, q.titley = G + ("top" === _.side ? L - F : F)), g.color && "auto" === t.tickmode) {
                      q.tickmode = "linear", q.tick0 = k.start;
                      var W = k.size,
                        $ = u.constrain((V - H) / 50, 4, 15) + 1,
                        X = (T[1] - T[0]) / ((t.nticks || $) * W);
                      if (X > 1) {
                        var Y = Math.pow(10, Math.floor(Math.log(X) / Math.LN10));
                        W *= Y * u.roundUp(X / Y, [2, 5, 10]), (Math.abs(k.start) / k.size + 1e-6) % 1 < 2e-6 && (q.tick0 = 0);
                      }
                      q.dtick = W;
                    }
                    q.domain = [G + F, G + L - F], q.setScale(), e.attr("transform", "translate(" + Math.round(l.l) + "," + Math.round(l.t) + ")");
                    var K,
                      Z = e.select("." + A.cbtitleunshift).attr("transform", "translate(-" + Math.round(l.l) + ",-" + Math.round(l.t) + ")"),
                      Q = e.select("." + A.cbaxis),
                      J = 0;
                    function ee(r, i) {
                      var o = {
                          propContainer: q,
                          propName: t._propPrefix + "title",
                          traceIndex: t._traceIndex,
                          _meta: t._meta,
                          placeholder: a._dfltTitle.colorbar,
                          containerGroup: e.select("." + A.cbtitle)
                        },
                        s = "h" === r.charAt(0) ? r.substr(1) : "h" + r;
                      e.selectAll("." + s + ",." + s + "-math-group").remove(), p.draw(n, r, c(o, i || {}));
                    }
                    return u.syncOrAsync([o.previousPromises, function () {
                      if (-1 !== ["top", "bottom"].indexOf(E)) {
                        var e,
                          n = l.l + (t.x + D) * l.w,
                          r = q.title.font.size;
                        e = "top" === E ? (1 - (G + L - F)) * l.h + l.t + 3 + .75 * r : (1 - (G + F)) * l.h + l.t - 3 - .25 * r, ee(q._id + "title", {
                          attributes: {
                            x: n,
                            y: e,
                            "text-anchor": "start"
                          }
                        });
                      }
                    }, function () {
                      if (-1 !== ["top", "bottom"].indexOf(E)) {
                        var o = e.select("." + A.cbtitle),
                          a = o.select("text"),
                          c = [-t.outlinewidth / 2, t.outlinewidth / 2],
                          d = o.select(".h" + q._id + "title-math-group").node(),
                          f = 15.6;
                        if (a.node() && (f = parseInt(a.node().style.fontSize, 10) * x), d ? (J = h.bBox(d).height) > f && (c[1] -= (J - f) / 2) : a.node() && !a.classed(A.jsPlaceholder) && (J = h.bBox(a.node()).height), J) {
                          if (J += 5, "top" === E) q.domain[1] -= J / l.h, c[1] *= -1;else {
                            q.domain[0] += J / l.h;
                            var p = m.lineCount(a);
                            c[1] += (1 - p) * f;
                          }
                          o.attr("transform", "translate(" + c + ")"), q.setScale();
                        }
                      }
                      e.selectAll("." + A.cbfills + ",." + A.cblines).attr("transform", "translate(0," + Math.round(l.h * (1 - q.domain[1])) + ")"), Q.attr("transform", "translate(0," + Math.round(-l.t) + ")");
                      var v = e.select("." + A.cbfills).selectAll("rect." + A.cbfill).data(O);
                      v.enter().append("rect").classed(A.cbfill, !0).style("stroke", "none"), v.exit().remove();
                      var y = T.map(q.c2p).map(Math.round).sort(function (e, t) {
                        return e - t;
                      });
                      v.each(function (e, o) {
                        var a = [0 === o ? T[0] : (O[o] + O[o - 1]) / 2, o === O.length - 1 ? T[1] : (O[o] + O[o + 1]) / 2].map(q.c2p).map(Math.round);
                        a[1] = u.constrain(a[1] + (a[1] > a[0]) ? 1 : -1, y[0], y[1]);
                        var s = r.select(this).attr({
                          x: z,
                          width: Math.max(I, 2),
                          y: r.min(a),
                          height: Math.max(r.max(a) - r.min(a), 2)
                        });
                        if (t._fillgradient) h.gradient(s, n, t._id, "vertical", t._fillgradient, "fill");else {
                          var l = C(e).replace("e-", "");
                          s.attr("fill", i(l).toHexString());
                        }
                      });
                      var b = e.select("." + A.cblines).selectAll("path." + A.cbline).data(g.color && g.width ? R : []);
                      b.enter().append("path").classed(A.cbline, !0), b.exit().remove(), b.each(function (e) {
                        r.select(this).attr("d", "M" + z + "," + (Math.round(q.c2p(e)) + g.width / 2 % 1) + "h" + I).call(h.lineGroupStyle, g.width, M(e), g.dash);
                      }), Q.selectAll("g." + q._id + "tick,path").remove();
                      var _ = z + I + (t.outlinewidth || 0) / 2 - ("outside" === t.ticks ? 1 : 0),
                        w = s.calcTicks(q),
                        S = s.makeTransFn(q),
                        k = s.getTickSigns(q)[2];
                      return s.drawTicks(n, q, {
                        vals: "inside" === q.ticks ? s.clipEnds(q, w) : w,
                        layer: Q,
                        path: s.makeTickPath(q, _, k),
                        transFn: S
                      }), s.drawLabels(n, q, {
                        vals: w,
                        layer: Q,
                        transFn: S,
                        labelFns: s.makeLabelFns(q, _)
                      });
                    }, function () {
                      if (-1 === ["top", "bottom"].indexOf(E)) {
                        var e = q.title.font.size,
                          t = q._offset + q._length / 2,
                          i = l.l + (q.position || 0) * l.w + ("right" === q.side ? 10 + e * (q.showticklabels ? 1 : .5) : -10 - e * (q.showticklabels ? .5 : 0));
                        ee("h" + q._id + "title", {
                          avoid: {
                            selection: r.select(n).selectAll("g." + q._id + "tick"),
                            side: E,
                            offsetLeft: l.l,
                            offsetTop: 0,
                            maxShift: a.width
                          },
                          attributes: {
                            x: i,
                            y: t,
                            "text-anchor": "middle"
                          },
                          transform: {
                            rotate: "-90",
                            offset: 0
                          }
                        });
                      }
                    }, o.previousPromises, function () {
                      var r = I + t.outlinewidth / 2 + h.bBox(Q.node()).width;
                      if ((K = Z.select("text")).node() && !K.classed(A.jsPlaceholder)) {
                        var i,
                          a = Z.select(".h" + q._id + "title-math-group").node();
                        i = a && -1 !== ["top", "bottom"].indexOf(E) ? h.bBox(a).width : h.bBox(Z.node()).right - z - l.l, r = Math.max(r, i);
                      }
                      var s = 2 * t.xpad + r + t.borderwidth + t.outlinewidth / 2,
                        u = V - H;
                      e.select("." + A.cbbg).attr({
                        x: z - t.xpad - (t.borderwidth + t.outlinewidth) / 2,
                        y: H - B,
                        width: Math.max(s, 2),
                        height: Math.max(u + 2 * B, 2)
                      }).call(f.fill, t.bgcolor).call(f.stroke, t.bordercolor).style("stroke-width", t.borderwidth), e.selectAll("." + A.cboutline).attr({
                        x: z,
                        y: H + t.ypad + ("top" === E ? J : 0),
                        width: Math.max(I, 2),
                        height: Math.max(u - 2 * t.ypad - J, 2)
                      }).call(f.stroke, t.outlinecolor).style({
                        fill: "none",
                        "stroke-width": t.outlinewidth
                      });
                      var c = ({
                        center: .5,
                        right: 1
                      }[t.xanchor] || 0) * s;
                      e.attr("transform", "translate(" + (l.l - c) + "," + l.t + ")");
                      var d = {},
                        p = w[t.yanchor],
                        m = S[t.yanchor];
                      "pixels" === t.lenmode ? (d.y = t.y, d.t = u * p, d.b = u * m) : (d.t = d.b = 0, d.yt = t.y + t.len * p, d.yb = t.y - t.len * m);
                      var g = w[t.xanchor],
                        v = S[t.xanchor];
                      if ("pixels" === t.thicknessmode) d.x = t.x, d.l = s * g, d.r = s * v;else {
                        var y = s - I;
                        d.l = y * g, d.r = y * v, d.xl = t.x - t.thickness * g, d.xr = t.x + t.thickness * v;
                      }
                      o.autoMargin(n, t._id, d);
                    }], n);
                  }(n, t, e);
                  g && g.then && (e._promises || []).push(g), e._context.edits.colorbarPosition && function (e, t, n) {
                    var r,
                      i,
                      o,
                      s = n._fullLayout._size;
                    l.init({
                      element: e.node(),
                      gd: n,
                      prepFn: function prepFn() {
                        r = e.attr("transform"), d(e);
                      },
                      moveFn: function moveFn(n, a) {
                        e.attr("transform", r + " translate(" + n + "," + a + ")"), i = l.align(t._xLeftFrac + n / s.w, t._thickFrac, 0, 1, t.xanchor), o = l.align(t._yBottomFrac - a / s.h, t._lenFrac, 0, 1, t.yanchor);
                        var u = l.getCursor(i, o, t.xanchor, t.yanchor);
                        d(e, u);
                      },
                      doneFn: function doneFn() {
                        if (d(e), void 0 !== i && void 0 !== o) {
                          var r = {};
                          r[t._propPrefix + "x"] = i, r[t._propPrefix + "y"] = o, void 0 !== t._traceIndex ? a.call("_guiRestyle", n, r, t._traceIndex) : a.call("_guiRelayout", n, r);
                        }
                      }
                    });
                  }(n, t, e);
                }), t.exit().each(function (t) {
                  o.autoMargin(e, t._id);
                }).remove(), t.order();
              }
            };
          }, {
            "../../constants/alignment": 469,
            "../../lib": 495,
            "../../lib/extend": 489,
            "../../lib/setcursor": 514,
            "../../lib/svg_text_utils": 518,
            "../../plots/cartesian/axes": 541,
            "../../plots/cartesian/axis_defaults": 543,
            "../../plots/cartesian/layout_attributes": 553,
            "../../plots/cartesian/position_defaults": 556,
            "../../plots/plots": 584,
            "../../registry": 593,
            "../color": 375,
            "../colorscale/helpers": 386,
            "../dragelement": 393,
            "../drawing": 396,
            "../titles": 462,
            "./constants": 377,
            d3: 82,
            tinycolor2: 341
          }],
          380: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            t.exports = function (e) {
              return r.isPlainObject(e.colorbar);
            };
          }, {
            "../../lib": 495
          }],
          381: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "component",
              name: "colorbar",
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              draw: e("./draw").draw,
              hasColorbar: e("./has_colorbar")
            };
          }, {
            "./attributes": 376,
            "./defaults": 378,
            "./draw": 379,
            "./has_colorbar": 380
          }],
          382: [function (e, t, n) {
            "use strict";

            var r = e("../colorbar/attributes"),
              i = e("../../lib/regex").counter,
              o = e("./scales.js").scales;
            function a(e) {
              return "`" + e + "`";
            }
            Object.keys(o), t.exports = function (e, t) {
              e = e || "";
              var n,
                s = (t = t || {}).cLetter || "c",
                l = ("onlyIfNumerical" in t ? t.onlyIfNumerical : Boolean(e), "noScale" in t ? t.noScale : "marker.line" === e),
                u = "showScaleDflt" in t ? t.showScaleDflt : "z" === s,
                c = "string" == typeof t.colorscaleDflt ? o[t.colorscaleDflt] : null,
                d = t.editTypeOverride || "",
                h = e ? e + "." : "";
              "colorAttr" in t ? (n = t.colorAttr, t.colorAttr) : a(h + (n = {
                z: "z",
                c: "color"
              }[s]));
              var f = s + "auto",
                p = s + "min",
                m = s + "max",
                g = s + "mid",
                v = (a(h + f), a(h + p), a(h + m), {});
              v[p] = v[m] = void 0;
              var y = {};
              y[f] = !1;
              var b = {};
              return "color" === n && (b.color = {
                valType: "color",
                arrayOk: !0,
                editType: d || "style"
              }, t.anim && (b.color.anim = !0)), b[f] = {
                valType: "boolean",
                dflt: !0,
                editType: "calc",
                impliedEdits: v
              }, b[p] = {
                valType: "number",
                dflt: null,
                editType: d || "plot",
                impliedEdits: y
              }, b[m] = {
                valType: "number",
                dflt: null,
                editType: d || "plot",
                impliedEdits: y
              }, b[g] = {
                valType: "number",
                dflt: null,
                editType: "calc",
                impliedEdits: v
              }, b.colorscale = {
                valType: "colorscale",
                editType: "calc",
                dflt: c,
                impliedEdits: {
                  autocolorscale: !1
                }
              }, b.autocolorscale = {
                valType: "boolean",
                dflt: !1 !== t.autoColorDflt,
                editType: "calc",
                impliedEdits: {
                  colorscale: void 0
                }
              }, b.reversescale = {
                valType: "boolean",
                dflt: !1,
                editType: "plot"
              }, l || (b.showscale = {
                valType: "boolean",
                dflt: u,
                editType: "calc"
              }, b.colorbar = r), t.noColorAxis || (b.coloraxis = {
                valType: "subplotid",
                regex: i("coloraxis"),
                dflt: null,
                editType: "calc"
              }), b;
            };
          }, {
            "../../lib/regex": 510,
            "../colorbar/attributes": 376,
            "./scales.js": 390
          }],
          383: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib"),
              o = e("./helpers").extractOpts;
            t.exports = function (e, t, n) {
              var a,
                s = e._fullLayout,
                l = n.vals,
                u = n.containerStr,
                c = u ? i.nestedProperty(t, u).get() : t,
                d = o(c),
                h = !1 !== d.auto,
                f = d.min,
                p = d.max,
                m = d.mid,
                g = function g() {
                  return i.aggNums(Math.min, null, l);
                },
                v = function v() {
                  return i.aggNums(Math.max, null, l);
                };
              void 0 === f ? f = g() : h && (f = c._colorAx && r(f) ? Math.min(f, g()) : g()), void 0 === p ? p = v() : h && (p = c._colorAx && r(p) ? Math.max(p, v()) : v()), h && void 0 !== m && (p - m > m - f ? f = m - (p - m) : p - m < m - f && (p = m + (m - f))), f === p && (f -= .5, p += .5), d._sync("min", f), d._sync("max", p), d.autocolorscale && (a = f * p < 0 ? s.colorscale.diverging : f >= 0 ? s.colorscale.sequential : s.colorscale.sequentialminus, d._sync("colorscale", a));
            };
          }, {
            "../../lib": 495,
            "./helpers": 386,
            "fast-isnumeric": 91
          }],
          384: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./helpers").hasColorscale,
              o = e("./helpers").extractOpts;
            t.exports = function (e, t) {
              function n(e, t) {
                var n = e["_" + t];
                void 0 !== n && (e[t] = n);
              }
              function a(e, i) {
                var a = i.container ? r.nestedProperty(e, i.container).get() : e;
                if (a) if (a.coloraxis) a._colorAx = t[a.coloraxis];else {
                  var s = o(a),
                    l = s.auto;
                  (l || void 0 === s.min) && n(a, i.min), (l || void 0 === s.max) && n(a, i.max), s.autocolorscale && n(a, "colorscale");
                }
              }
              for (var s = 0; s < e.length; s++) {
                var l = e[s],
                  u = l._module.colorbar;
                if (u) if (Array.isArray(u)) for (var c = 0; c < u.length; c++) a(l, u[c]);else a(l, u);
                i(l, "marker.line") && a(l, {
                  container: "marker.line",
                  min: "cmin",
                  max: "cmax"
                });
              }
              for (var d in t._colorAxes) a(t[d], {
                min: "cmin",
                max: "cmax"
              });
            };
          }, {
            "../../lib": 495,
            "./helpers": 386
          }],
          385: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib"),
              o = e("../colorbar/has_colorbar"),
              a = e("../colorbar/defaults"),
              s = e("./scales").isValid,
              l = e("../../registry").traceIs;
            function u(e, t) {
              var n = t.slice(0, t.length - 1);
              return t ? i.nestedProperty(e, n).get() || {} : e;
            }
            t.exports = function e(t, n, c, d, h) {
              var f = h.prefix,
                p = h.cLetter,
                m = ("_module" in n),
                g = u(t, f),
                v = u(n, f),
                y = u(n._template || {}, f) || {},
                b = function b() {
                  return delete t.coloraxis, delete n.coloraxis, e(t, n, c, d, h);
                };
              if (m) {
                var _ = c._colorAxes || {},
                  x = d(f + "coloraxis");
                if (x) {
                  var w = l(n, "contour") && i.nestedProperty(n, "contours.coloring").get() || "heatmap",
                    S = _[x];
                  return void (S ? (S[2].push(b), S[0] !== w && (S[0] = !1, i.warn(["Ignoring coloraxis:", x, "setting", "as it is linked to incompatible colorscales."].join(" ")))) : _[x] = [w, n, [b]]);
                }
              }
              var A = g[p + "min"],
                E = g[p + "max"],
                T = r(A) && r(E) && A < E;
              d(f + p + "auto", !T) ? d(f + p + "mid") : (d(f + p + "min"), d(f + p + "max"));
              var M,
                C,
                k = g.colorscale,
                P = y.colorscale;
              void 0 !== k && (M = !s(k)), void 0 !== P && (M = !s(P)), d(f + "autocolorscale", M), d(f + "colorscale"), d(f + "reversescale"), "marker.line." !== f && (f && m && (C = o(g)), d(f + "showscale", C) && (f && y && (v._template = y), a(g, v, c)));
            };
          }, {
            "../../lib": 495,
            "../../registry": 593,
            "../colorbar/defaults": 378,
            "../colorbar/has_colorbar": 380,
            "./scales": 390,
            "fast-isnumeric": 91
          }],
          386: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("tinycolor2"),
              o = e("fast-isnumeric"),
              a = e("../../lib"),
              s = e("../color"),
              l = e("./scales").isValid,
              u = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"],
              c = ["min", "max", "mid", "auto"];
            function d(e) {
              var t,
                n,
                r,
                i = e._colorAx,
                o = i || e,
                a = {};
              for (n = 0; n < u.length; n++) a[r = u[n]] = o[r];
              if (i) for (t = "c", n = 0; n < c.length; n++) a[r = c[n]] = o["c" + r];else {
                var s;
                for (n = 0; n < c.length; n++) ((s = "c" + (r = c[n])) in o || (s = "z" + r) in o) && (a[r] = o[s]);
                t = s.charAt(0);
              }
              return a._sync = function (e, n) {
                var r = -1 !== c.indexOf(e) ? t + e : e;
                o[r] = o["_" + r] = n;
              }, a;
            }
            function h(e) {
              for (var t = d(e), n = t.min, r = t.max, i = t.reversescale ? f(t.colorscale) : t.colorscale, o = i.length, a = new Array(o), s = new Array(o), l = 0; l < o; l++) {
                var u = i[l];
                a[l] = n + u[0] * (r - n), s[l] = u[1];
              }
              return {
                domain: a,
                range: s
              };
            }
            function f(e) {
              for (var t = e.length, n = new Array(t), r = t - 1, i = 0; r >= 0; r--, i++) {
                var o = e[r];
                n[i] = [1 - o[0], o[1]];
              }
              return n;
            }
            function p(e, t) {
              t = t || {};
              for (var n = e.domain, a = e.range, l = a.length, u = new Array(l), c = 0; c < l; c++) {
                var d = i(a[c]).toRgb();
                u[c] = [d.r, d.g, d.b, d.a];
              }
              var h,
                f = r.scale.linear().domain(n).range(u).clamp(!0),
                p = t.noNumericCheck,
                g = t.returnArray;
              return (h = p && g ? f : p ? function (e) {
                return m(f(e));
              } : g ? function (e) {
                return o(e) ? f(e) : i(e).isValid() ? e : s.defaultLine;
              } : function (e) {
                return o(e) ? m(f(e)) : i(e).isValid() ? e : s.defaultLine;
              }).domain = f.domain, h.range = function () {
                return a;
              }, h;
            }
            function m(e) {
              var t = {
                r: e[0],
                g: e[1],
                b: e[2],
                a: e[3]
              };
              return i(t).toRgbString();
            }
            t.exports = {
              hasColorscale: function hasColorscale(e, t, n) {
                var r = t ? a.nestedProperty(e, t).get() || {} : e,
                  i = r[n || "color"],
                  s = !1;
                if (a.isArrayOrTypedArray(i)) for (var u = 0; u < i.length; u++) if (o(i[u])) {
                  s = !0;
                  break;
                }
                return a.isPlainObject(r) && (s || !0 === r.showscale || o(r.cmin) && o(r.cmax) || l(r.colorscale) || a.isPlainObject(r.colorbar));
              },
              extractOpts: d,
              extractScale: h,
              flipScale: f,
              makeColorScaleFunc: p,
              makeColorScaleFuncFromTrace: function makeColorScaleFuncFromTrace(e, t) {
                return p(h(e), t);
              }
            };
          }, {
            "../../lib": 495,
            "../color": 375,
            "./scales": 390,
            d3: 82,
            "fast-isnumeric": 91,
            tinycolor2: 341
          }],
          387: [function (e, t, n) {
            "use strict";

            var r = e("./scales"),
              i = e("./helpers");
            t.exports = {
              moduleType: "component",
              name: "colorscale",
              attributes: e("./attributes"),
              layoutAttributes: e("./layout_attributes"),
              supplyLayoutDefaults: e("./layout_defaults"),
              handleDefaults: e("./defaults"),
              crossTraceDefaults: e("./cross_trace_defaults"),
              calc: e("./calc"),
              scales: r.scales,
              defaultScale: r.defaultScale,
              getScale: r.get,
              isValidScale: r.isValid,
              hasColorscale: i.hasColorscale,
              extractOpts: i.extractOpts,
              extractScale: i.extractScale,
              flipScale: i.flipScale,
              makeColorScaleFunc: i.makeColorScaleFunc,
              makeColorScaleFuncFromTrace: i.makeColorScaleFuncFromTrace
            };
          }, {
            "./attributes": 382,
            "./calc": 383,
            "./cross_trace_defaults": 384,
            "./defaults": 385,
            "./helpers": 386,
            "./layout_attributes": 388,
            "./layout_defaults": 389,
            "./scales": 390
          }],
          388: [function (e, t, n) {
            "use strict";

            var r = e("../../lib/extend").extendFlat,
              i = e("./attributes"),
              o = e("./scales").scales;
            t.exports = {
              editType: "calc",
              colorscale: {
                editType: "calc",
                sequential: {
                  valType: "colorscale",
                  dflt: o.Reds,
                  editType: "calc"
                },
                sequentialminus: {
                  valType: "colorscale",
                  dflt: o.Blues,
                  editType: "calc"
                },
                diverging: {
                  valType: "colorscale",
                  dflt: o.RdBu,
                  editType: "calc"
                }
              },
              coloraxis: r({
                _isSubplotObj: !0,
                editType: "calc"
              }, i("", {
                colorAttr: "corresponding trace color array(s)",
                noColorAxis: !0,
                showScaleDflt: !0
              }))
            };
          }, {
            "../../lib/extend": 489,
            "./attributes": 382,
            "./scales": 390
          }],
          389: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plot_api/plot_template"),
              o = e("./layout_attributes"),
              a = e("./defaults");
            t.exports = function (e, t) {
              function n(n, i) {
                return r.coerce(e, t, o, n, i);
              }
              n("colorscale.sequential"), n("colorscale.sequentialminus"), n("colorscale.diverging");
              var s,
                l,
                u = t._colorAxes;
              function c(e, t) {
                return r.coerce(s, l, o.coloraxis, e, t);
              }
              for (var d in u) {
                var h = u[d];
                if (h[0]) s = e[d] || {}, (l = i.newContainer(t, d, "coloraxis"))._name = d, a(s, l, t, c, {
                  prefix: "",
                  cLetter: "c"
                });else {
                  for (var f = 0; f < h[2].length; f++) h[2][f]();
                  delete t._colorAxes[d];
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "./defaults": 385,
            "./layout_attributes": 388
          }],
          390: [function (e, t, n) {
            "use strict";

            var r = e("tinycolor2"),
              i = {
                Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]],
                YlGnBu: [[0, "rgb(8,29,88)"], [.125, "rgb(37,52,148)"], [.25, "rgb(34,94,168)"], [.375, "rgb(29,145,192)"], [.5, "rgb(65,182,196)"], [.625, "rgb(127,205,187)"], [.75, "rgb(199,233,180)"], [.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]],
                Greens: [[0, "rgb(0,68,27)"], [.125, "rgb(0,109,44)"], [.25, "rgb(35,139,69)"], [.375, "rgb(65,171,93)"], [.5, "rgb(116,196,118)"], [.625, "rgb(161,217,155)"], [.75, "rgb(199,233,192)"], [.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]],
                YlOrRd: [[0, "rgb(128,0,38)"], [.125, "rgb(189,0,38)"], [.25, "rgb(227,26,28)"], [.375, "rgb(252,78,42)"], [.5, "rgb(253,141,60)"], [.625, "rgb(254,178,76)"], [.75, "rgb(254,217,118)"], [.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]],
                Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]],
                RdBu: [[0, "rgb(5,10,172)"], [.35, "rgb(106,137,247)"], [.5, "rgb(190,190,190)"], [.6, "rgb(220,170,132)"], [.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]],
                Reds: [[0, "rgb(220,220,220)"], [.2, "rgb(245,195,157)"], [.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]],
                Blues: [[0, "rgb(5,10,172)"], [.35, "rgb(40,60,190)"], [.5, "rgb(70,100,245)"], [.6, "rgb(90,120,245)"], [.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]],
                Picnic: [[0, "rgb(0,0,255)"], [.1, "rgb(51,153,255)"], [.2, "rgb(102,204,255)"], [.3, "rgb(153,204,255)"], [.4, "rgb(204,204,255)"], [.5, "rgb(255,255,255)"], [.6, "rgb(255,204,255)"], [.7, "rgb(255,153,255)"], [.8, "rgb(255,102,204)"], [.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]],
                Rainbow: [[0, "rgb(150,0,90)"], [.125, "rgb(0,0,200)"], [.25, "rgb(0,25,255)"], [.375, "rgb(0,152,255)"], [.5, "rgb(44,255,150)"], [.625, "rgb(151,255,0)"], [.75, "rgb(255,234,0)"], [.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]],
                Portland: [[0, "rgb(12,51,131)"], [.25, "rgb(10,136,186)"], [.5, "rgb(242,211,56)"], [.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]],
                Jet: [[0, "rgb(0,0,131)"], [.125, "rgb(0,60,170)"], [.375, "rgb(5,255,255)"], [.625, "rgb(255,255,0)"], [.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]],
                Hot: [[0, "rgb(0,0,0)"], [.3, "rgb(230,0,0)"], [.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]],
                Blackbody: [[0, "rgb(0,0,0)"], [.2, "rgb(230,0,0)"], [.4, "rgb(230,210,0)"], [.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]],
                Earth: [[0, "rgb(0,0,130)"], [.1, "rgb(0,180,180)"], [.2, "rgb(40,210,40)"], [.4, "rgb(230,230,50)"], [.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]],
                Electric: [[0, "rgb(0,0,0)"], [.15, "rgb(30,0,100)"], [.4, "rgb(120,0,100)"], [.6, "rgb(160,90,0)"], [.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]],
                Viridis: [[0, "#440154"], [.06274509803921569, "#48186a"], [.12549019607843137, "#472d7b"], [.18823529411764706, "#424086"], [.25098039215686274, "#3b528b"], [.3137254901960784, "#33638d"], [.3764705882352941, "#2c728e"], [.4392156862745098, "#26828e"], [.5019607843137255, "#21918c"], [.5647058823529412, "#1fa088"], [.6274509803921569, "#28ae80"], [.6901960784313725, "#3fbc73"], [.7529411764705882, "#5ec962"], [.8156862745098039, "#84d44b"], [.8784313725490196, "#addc30"], [.9411764705882353, "#d8e219"], [1, "#fde725"]],
                Cividis: [[0, "rgb(0,32,76)"], [.058824, "rgb(0,42,102)"], [.117647, "rgb(0,52,110)"], [.176471, "rgb(39,63,108)"], [.235294, "rgb(60,74,107)"], [.294118, "rgb(76,85,107)"], [.352941, "rgb(91,95,109)"], [.411765, "rgb(104,106,112)"], [.470588, "rgb(117,117,117)"], [.529412, "rgb(131,129,120)"], [.588235, "rgb(146,140,120)"], [.647059, "rgb(161,152,118)"], [.705882, "rgb(176,165,114)"], [.764706, "rgb(192,177,109)"], [.823529, "rgb(209,191,102)"], [.882353, "rgb(225,204,92)"], [.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]]
              },
              o = i.RdBu;
            function a(e) {
              var t = 0;
              if (!Array.isArray(e) || e.length < 2) return !1;
              if (!e[0] || !e[e.length - 1]) return !1;
              if (0 != +e[0][0] || 1 != +e[e.length - 1][0]) return !1;
              for (var n = 0; n < e.length; n++) {
                var i = e[n];
                if (2 !== i.length || +i[0] < t || !r(i[1]).isValid()) return !1;
                t = +i[0];
              }
              return !0;
            }
            t.exports = {
              scales: i,
              defaultScale: o,
              get: function get(e, t) {
                if (t || (t = o), !e) return t;
                function n() {
                  try {
                    e = i[e] || JSON.parse(e);
                  } catch (n) {
                    e = t;
                  }
                }
                return "string" == typeof e && (n(), "string" == typeof e && n()), a(e) ? e : t;
              },
              isValid: function isValid(e) {
                return void 0 !== i[e] || a(e);
              }
            };
          }, {
            tinycolor2: 341
          }],
          391: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, r, i) {
              var o = (e - n) / (r - n),
                a = o + t / (r - n),
                s = (o + a) / 2;
              return "left" === i || "bottom" === i ? o : "center" === i || "middle" === i ? s : "right" === i || "top" === i ? a : o < 2 / 3 - s ? o : a > 4 / 3 - s ? a : s;
            };
          }, {}],
          392: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];
            t.exports = function (e, t, n, o) {
              return e = "left" === n ? 0 : "center" === n ? 1 : "right" === n ? 2 : r.constrain(Math.floor(3 * e), 0, 2), t = "bottom" === o ? 0 : "middle" === o ? 1 : "top" === o ? 2 : r.constrain(Math.floor(3 * t), 0, 2), i[t][e];
            };
          }, {
            "../../lib": 495
          }],
          393: [function (e, t, n) {
            "use strict";

            var r = e("mouse-event-offset"),
              i = e("has-hover"),
              o = e("has-passive-events"),
              a = e("../../lib").removeElement,
              s = e("../../plots/cartesian/constants"),
              l = t.exports = {};
            l.align = e("./align"), l.getCursor = e("./cursor");
            var u = e("./unhover");
            function c() {
              var e = document.createElement("div");
              e.className = "dragcover";
              var t = e.style;
              return t.position = "fixed", t.left = 0, t.right = 0, t.top = 0, t.bottom = 0, t.zIndex = 999999999, t.background = "none", document.body.appendChild(e), e;
            }
            function d(e) {
              return r(e.changedTouches ? e.changedTouches[0] : e, document.body);
            }
            l.unhover = u.wrapped, l.unhoverRaw = u.raw, l.init = function (e) {
              var t,
                n,
                r,
                u,
                h,
                f,
                p,
                m,
                g = e.gd,
                v = 1,
                y = g._context.doubleClickDelay,
                b = e.element;
              g._mouseDownTime || (g._mouseDownTime = 0), b.style.pointerEvents = "all", b.onmousedown = x, o ? (b._ontouchstart && b.removeEventListener("touchstart", b._ontouchstart), b._ontouchstart = x, b.addEventListener("touchstart", x, {
                passive: !1
              })) : b.ontouchstart = x;
              var _ = e.clampFn || function (e, t, n) {
                return Math.abs(e) < n && (e = 0), Math.abs(t) < n && (t = 0), [e, t];
              };
              function x(o) {
                g._dragged = !1, g._dragging = !0;
                var a = d(o);
                t = a[0], n = a[1], p = o.target, f = o, m = 2 === o.buttons || o.ctrlKey, void 0 === o.clientX && void 0 === o.clientY && (o.clientX = t, o.clientY = n), (r = new Date().getTime()) - g._mouseDownTime < y ? v += 1 : (v = 1, g._mouseDownTime = r), e.prepFn && e.prepFn(o, t, n), i && !m ? (h = c()).style.cursor = window.getComputedStyle(b).cursor : i || (h = document, u = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(b).cursor), document.addEventListener("mouseup", S), document.addEventListener("touchend", S), !1 !== e.dragmode && (o.preventDefault(), document.addEventListener("mousemove", w), document.addEventListener("touchmove", w, {
                  passive: !1
                }));
              }
              function w(r) {
                r.preventDefault();
                var i = d(r),
                  o = e.minDrag || s.MINDRAG,
                  a = _(i[0] - t, i[1] - n, o),
                  u = a[0],
                  c = a[1];
                (u || c) && (g._dragged = !0, l.unhover(g)), g._dragged && e.moveFn && !m && (g._dragdata = {
                  element: b,
                  dx: u,
                  dy: c
                }, e.moveFn(u, c));
              }
              function S(t) {
                if (delete g._dragdata, !1 !== e.dragmode && (t.preventDefault(), document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w)), document.removeEventListener("mouseup", S), document.removeEventListener("touchend", S), i ? a(h) : u && (h.documentElement.style.cursor = u, u = null), g._dragging) {
                  if (g._dragging = !1, new Date().getTime() - g._mouseDownTime > y && (v = Math.max(v - 1, 1)), g._dragged) e.doneFn && e.doneFn();else if (e.clickFn && e.clickFn(v, f), !m) {
                    var n;
                    try {
                      n = new MouseEvent("click", t);
                    } catch (e) {
                      var r = d(t);
                      (n = document.createEvent("MouseEvents")).initMouseEvent("click", t.bubbles, t.cancelable, t.view, t.detail, t.screenX, t.screenY, r[0], r[1], t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, t.button, t.relatedTarget);
                    }
                    p.dispatchEvent(n);
                  }
                  g._dragging = !1, g._dragged = !1;
                } else g._dragged = !1;
              }
            }, l.coverSlip = c;
          }, {
            "../../lib": 495,
            "../../plots/cartesian/constants": 547,
            "./align": 391,
            "./cursor": 392,
            "./unhover": 394,
            "has-hover": 250,
            "has-passive-events": 251,
            "mouse-event-offset": 271
          }],
          394: [function (e, t, n) {
            "use strict";

            var r = e("../../lib/events"),
              i = e("../../lib/throttle"),
              o = e("../../lib/dom").getGraphDiv,
              a = e("../fx/constants"),
              s = t.exports = {};
            s.wrapped = function (e, t, n) {
              (e = o(e))._fullLayout && i.clear(e._fullLayout._uid + a.HOVERID), s.raw(e, t, n);
            }, s.raw = function (e, t) {
              var n = e._fullLayout,
                i = e._hoverdata;
              t || (t = {}), t.target && !1 === r.triggerHandler(e, "plotly_beforehover", t) || (n._hoverlayer.selectAll("g").remove(), n._hoverlayer.selectAll("line").remove(), n._hoverlayer.selectAll("circle").remove(), e._hoverdata = void 0, t.target && i && e.emit("plotly_unhover", {
                event: t,
                points: i
              }));
            };
          }, {
            "../../lib/dom": 487,
            "../../lib/events": 488,
            "../../lib/throttle": 519,
            "../fx/constants": 408
          }],
          395: [function (e, t, n) {
            "use strict";

            n.dash = {
              valType: "string",
              values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"],
              dflt: "solid",
              editType: "style"
            };
          }, {}],
          396: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("tinycolor2"),
              a = e("../../registry"),
              s = e("../color"),
              l = e("../colorscale"),
              u = e("../../lib"),
              c = e("../../lib/svg_text_utils"),
              d = e("../../constants/xmlns_namespaces"),
              h = e("../../constants/alignment").LINE_SPACING,
              f = e("../../constants/interactions").DESELECTDIM,
              p = e("../../traces/scatter/subtypes"),
              m = e("../../traces/scatter/make_bubble_size_func"),
              g = e("../../components/fx/helpers").appendArrayPointValue,
              v = t.exports = {};
            v.font = function (e, t, n, r) {
              u.isPlainObject(t) && (r = t.color, n = t.size, t = t.family), t && e.style("font-family", t), n + 1 && e.style("font-size", n + "px"), r && e.call(s.fill, r);
            }, v.setPosition = function (e, t, n) {
              e.attr("x", t).attr("y", n);
            }, v.setSize = function (e, t, n) {
              e.attr("width", t).attr("height", n);
            }, v.setRect = function (e, t, n, r, i) {
              e.call(v.setPosition, t, n).call(v.setSize, r, i);
            }, v.translatePoint = function (e, t, n, r) {
              var o = n.c2p(e.x),
                a = r.c2p(e.y);
              return !!(i(o) && i(a) && t.node()) && ("text" === t.node().nodeName ? t.attr("x", o).attr("y", a) : t.attr("transform", "translate(" + o + "," + a + ")"), !0);
            }, v.translatePoints = function (e, t, n) {
              e.each(function (e) {
                var i = r.select(this);
                v.translatePoint(e, i, t, n);
              });
            }, v.hideOutsideRangePoint = function (e, t, n, r, i, o) {
              t.attr("display", n.isPtWithinRange(e, i) && r.isPtWithinRange(e, o) ? null : "none");
            }, v.hideOutsideRangePoints = function (e, t) {
              if (t._hasClipOnAxisFalse) {
                var n = t.xaxis,
                  i = t.yaxis;
                e.each(function (t) {
                  var o = t[0].trace,
                    s = o.xcalendar,
                    l = o.ycalendar,
                    u = a.traceIs(o, "bar-like") ? ".bartext" : ".point,.textpoint";
                  e.selectAll(u).each(function (e) {
                    v.hideOutsideRangePoint(e, r.select(this), n, i, s, l);
                  });
                });
              }
            }, v.crispRound = function (e, t, n) {
              return t && i(t) ? e._context.staticPlot ? t : t < 1 ? 1 : Math.round(t) : n || 0;
            }, v.singleLineStyle = function (e, t, n, r, i) {
              t.style("fill", "none");
              var o = (((e || [])[0] || {}).trace || {}).line || {},
                a = n || o.width || 0,
                l = i || o.dash || "";
              s.stroke(t, r || o.color), v.dashLine(t, l, a);
            }, v.lineGroupStyle = function (e, t, n, i) {
              e.style("fill", "none").each(function (e) {
                var o = (((e || [])[0] || {}).trace || {}).line || {},
                  a = t || o.width || 0,
                  l = i || o.dash || "";
                r.select(this).call(s.stroke, n || o.color).call(v.dashLine, l, a);
              });
            }, v.dashLine = function (e, t, n) {
              n = +n || 0, t = v.dashStyle(t, n), e.style({
                "stroke-dasharray": t,
                "stroke-width": n + "px"
              });
            }, v.dashStyle = function (e, t) {
              t = +t || 1;
              var n = Math.max(t, 3);
              return "solid" === e ? e = "" : "dot" === e ? e = n + "px," + n + "px" : "dash" === e ? e = 3 * n + "px," + 3 * n + "px" : "longdash" === e ? e = 5 * n + "px," + 5 * n + "px" : "dashdot" === e ? e = 3 * n + "px," + n + "px," + n + "px," + n + "px" : "longdashdot" === e && (e = 5 * n + "px," + 2 * n + "px," + n + "px," + 2 * n + "px"), e;
            }, v.singleFillStyle = function (e) {
              var t = (((r.select(e.node()).data()[0] || [])[0] || {}).trace || {}).fillcolor;
              t && e.call(s.fill, t);
            }, v.fillGroupStyle = function (e) {
              e.style("stroke-width", 0).each(function (e) {
                var t = r.select(this);
                e[0].trace && t.call(s.fill, e[0].trace.fillcolor);
              });
            };
            var y = e("./symbol_defs");
            v.symbolNames = [], v.symbolFuncs = [], v.symbolNeedLines = {}, v.symbolNoDot = {}, v.symbolNoFill = {}, v.symbolList = [], Object.keys(y).forEach(function (e) {
              var t = y[e],
                n = t.n;
              v.symbolList.push(n, e, n + 100, e + "-open"), v.symbolNames[n] = e, v.symbolFuncs[n] = t.f, t.needLine && (v.symbolNeedLines[n] = !0), t.noDot ? v.symbolNoDot[n] = !0 : v.symbolList.push(n + 200, e + "-dot", n + 300, e + "-open-dot"), t.noFill && (v.symbolNoFill[n] = !0);
            });
            var b = v.symbolNames.length;
            function _(e, t) {
              var n = e % 100;
              return v.symbolFuncs[n](t) + (e >= 200 ? "M0,0.5L0.5,0L0,-0.5L-0.5,0Z" : "");
            }
            v.symbolNumber = function (e) {
              if ("string" == typeof e) {
                var t = 0;
                e.indexOf("-open") > 0 && (t = 100, e = e.replace("-open", "")), e.indexOf("-dot") > 0 && (t += 200, e = e.replace("-dot", "")), (e = v.symbolNames.indexOf(e)) >= 0 && (e += t);
              }
              return e % 100 >= b || e >= 400 ? 0 : Math.floor(Math.max(e, 0));
            };
            var x = {
                x1: 1,
                x2: 0,
                y1: 0,
                y2: 0
              },
              w = {
                x1: 0,
                x2: 0,
                y1: 1,
                y2: 0
              },
              S = r.format("~.1f"),
              A = {
                radial: {
                  node: "radialGradient"
                },
                radialreversed: {
                  node: "radialGradient",
                  reversed: !0
                },
                horizontal: {
                  node: "linearGradient",
                  attrs: x
                },
                horizontalreversed: {
                  node: "linearGradient",
                  attrs: x,
                  reversed: !0
                },
                vertical: {
                  node: "linearGradient",
                  attrs: w
                },
                verticalreversed: {
                  node: "linearGradient",
                  attrs: w,
                  reversed: !0
                }
              };
            v.gradient = function (e, t, n, i, a, l) {
              for (var c = a.length, d = A[i], h = new Array(c), f = 0; f < c; f++) d.reversed ? h[c - 1 - f] = [S(100 * (1 - a[f][0])), a[f][1]] : h[f] = [S(100 * a[f][0]), a[f][1]];
              var p = t._fullLayout,
                m = "g" + p._uid + "-" + n,
                g = p._defs.select(".gradients").selectAll("#" + m).data([i + h.join(";")], u.identity);
              g.exit().remove(), g.enter().append(d.node).each(function () {
                var e = r.select(this);
                d.attrs && e.attr(d.attrs), e.attr("id", m);
                var t = e.selectAll("stop").data(h);
                t.exit().remove(), t.enter().append("stop"), t.each(function (e) {
                  var t = o(e[1]);
                  r.select(this).attr({
                    offset: e[0] + "%",
                    "stop-color": s.tinyRGB(t),
                    "stop-opacity": t.getAlpha()
                  });
                });
              }), e.style(l, I(m, t)).style(l + "-opacity", null);
              var v = function v(e) {
                  return "." + e.attr("class").replace(/\s/g, ".");
                },
                y = v(r.select(e.node().parentNode)) + ">" + v(e);
              p._gradientUrlQueryParts[y] = 1;
            }, v.initGradients = function (e) {
              var t = e._fullLayout;
              u.ensureSingle(t._defs, "g", "gradients").selectAll("linearGradient,radialGradient").remove(), t._gradientUrlQueryParts = {};
            }, v.pointStyle = function (e, t, n) {
              if (e.size()) {
                var i = v.makePointStyleFns(t);
                e.each(function (e) {
                  v.singlePointStyle(e, r.select(this), t, i, n);
                });
              }
            }, v.singlePointStyle = function (e, t, n, r, i) {
              var o = n.marker,
                a = o.line;
              if (t.style("opacity", r.selectedOpacityFn ? r.selectedOpacityFn(e) : void 0 === e.mo ? o.opacity : e.mo), r.ms2mrc) {
                var l;
                l = "various" === e.ms || "various" === o.size ? 3 : r.ms2mrc(e.ms), e.mrc = l, r.selectedSizeFn && (l = e.mrc = r.selectedSizeFn(e));
                var c = v.symbolNumber(e.mx || o.symbol) || 0;
                e.om = c % 200 >= 100, t.attr("d", _(c, l));
              }
              var d,
                h,
                f,
                p = !1;
              if (e.so) f = a.outlierwidth, h = a.outliercolor, d = o.outliercolor;else {
                var m = (a || {}).width;
                f = (e.mlw + 1 || m + 1 || (e.trace ? (e.trace.marker.line || {}).width : 0) + 1) - 1 || 0, h = "mlc" in e ? e.mlcc = r.lineScale(e.mlc) : u.isArrayOrTypedArray(a.color) ? s.defaultLine : a.color, u.isArrayOrTypedArray(o.color) && (d = s.defaultLine, p = !0), d = "mc" in e ? e.mcc = r.markerScale(e.mc) : o.color || "rgba(0,0,0,0)", r.selectedColorFn && (d = r.selectedColorFn(e));
              }
              if (e.om) t.call(s.stroke, d).style({
                "stroke-width": (f || 1) + "px",
                fill: "none"
              });else {
                t.style("stroke-width", (e.isBlank ? 0 : f) + "px");
                var g = o.gradient,
                  y = e.mgt;
                if (y ? p = !0 : y = g && g.type, Array.isArray(y) && (y = y[0], A[y] || (y = 0)), y && "none" !== y) {
                  var b = e.mgc;
                  b ? p = !0 : b = g.color;
                  var x = n.uid;
                  p && (x += "-" + e.i), v.gradient(t, i, x, y, [[0, b], [1, d]], "fill");
                } else s.fill(t, d);
                f && s.stroke(t, h);
              }
            }, v.makePointStyleFns = function (e) {
              var t = {},
                n = e.marker;
              return t.markerScale = v.tryColorscale(n, ""), t.lineScale = v.tryColorscale(n, "line"), a.traceIs(e, "symbols") && (t.ms2mrc = p.isBubble(e) ? m(e) : function () {
                return (n.size || 6) / 2;
              }), e.selectedpoints && u.extendFlat(t, v.makeSelectedPointStyleFns(e)), t;
            }, v.makeSelectedPointStyleFns = function (e) {
              var t = {},
                n = e.selected || {},
                r = e.unselected || {},
                i = e.marker || {},
                o = n.marker || {},
                s = r.marker || {},
                l = i.opacity,
                c = o.opacity,
                d = s.opacity,
                h = void 0 !== c,
                p = void 0 !== d;
              (u.isArrayOrTypedArray(l) || h || p) && (t.selectedOpacityFn = function (e) {
                var t = void 0 === e.mo ? i.opacity : e.mo;
                return e.selected ? h ? c : t : p ? d : f * t;
              });
              var m = i.color,
                g = o.color,
                v = s.color;
              (g || v) && (t.selectedColorFn = function (e) {
                var t = e.mcc || m;
                return e.selected ? g || t : v || t;
              });
              var y = i.size,
                b = o.size,
                _ = s.size,
                x = void 0 !== b,
                w = void 0 !== _;
              return a.traceIs(e, "symbols") && (x || w) && (t.selectedSizeFn = function (e) {
                var t = e.mrc || y / 2;
                return e.selected ? x ? b / 2 : t : w ? _ / 2 : t;
              }), t;
            }, v.makeSelectedTextStyleFns = function (e) {
              var t = {},
                n = e.selected || {},
                r = e.unselected || {},
                i = e.textfont || {},
                o = n.textfont || {},
                a = r.textfont || {},
                l = i.color,
                u = o.color,
                c = a.color;
              return t.selectedTextColorFn = function (e) {
                var t = e.tc || l;
                return e.selected ? u || t : c || (u ? t : s.addOpacity(t, f));
              }, t;
            }, v.selectedPointStyle = function (e, t) {
              if (e.size() && t.selectedpoints) {
                var n = v.makeSelectedPointStyleFns(t),
                  i = t.marker || {},
                  o = [];
                n.selectedOpacityFn && o.push(function (e, t) {
                  e.style("opacity", n.selectedOpacityFn(t));
                }), n.selectedColorFn && o.push(function (e, t) {
                  s.fill(e, n.selectedColorFn(t));
                }), n.selectedSizeFn && o.push(function (e, t) {
                  var r = t.mx || i.symbol || 0,
                    o = n.selectedSizeFn(t);
                  e.attr("d", _(v.symbolNumber(r), o)), t.mrc2 = o;
                }), o.length && e.each(function (e) {
                  for (var t = r.select(this), n = 0; n < o.length; n++) o[n](t, e);
                });
              }
            }, v.tryColorscale = function (e, t) {
              var n = t ? u.nestedProperty(e, t).get() : e;
              if (n) {
                var r = n.color;
                if ((n.colorscale || n._colorAx) && u.isArrayOrTypedArray(r)) return l.makeColorScaleFuncFromTrace(n);
              }
              return u.identity;
            };
            var E = {
              start: 1,
              end: -1,
              middle: 0,
              bottom: 1,
              top: -1
            };
            function T(e, t, n, i) {
              var o = r.select(e.node().parentNode),
                a = -1 !== t.indexOf("top") ? "top" : -1 !== t.indexOf("bottom") ? "bottom" : "middle",
                s = -1 !== t.indexOf("left") ? "end" : -1 !== t.indexOf("right") ? "start" : "middle",
                l = i ? i / .8 + 1 : 0,
                u = (c.lineCount(e) - 1) * h + 1,
                d = E[s] * l,
                f = .75 * n + E[a] * l + (E[a] - 1) * u * n / 2;
              e.attr("text-anchor", s), o.attr("transform", "translate(" + d + "," + f + ")");
            }
            function M(e, t) {
              var n = e.ts || t.textfont.size;
              return i(n) && n > 0 ? n : 0;
            }
            function C(e, t, n, i) {
              var o = e[0] - t[0],
                a = e[1] - t[1],
                s = n[0] - t[0],
                l = n[1] - t[1],
                u = Math.pow(o * o + a * a, .25),
                c = Math.pow(s * s + l * l, .25),
                d = (c * c * o - u * u * s) * i,
                h = (c * c * a - u * u * l) * i,
                f = 3 * c * (u + c),
                p = 3 * u * (u + c);
              return [[r.round(t[0] + (f && d / f), 2), r.round(t[1] + (f && h / f), 2)], [r.round(t[0] - (p && d / p), 2), r.round(t[1] - (p && h / p), 2)]];
            }
            v.textPointStyle = function (e, t, n) {
              if (e.size()) {
                var i;
                if (t.selectedpoints) {
                  var o = v.makeSelectedTextStyleFns(t);
                  i = o.selectedTextColorFn;
                }
                var a = t.texttemplate,
                  s = n._fullLayout;
                e.each(function (e) {
                  var o = r.select(this),
                    l = a ? u.extractOption(e, t, "txt", "texttemplate") : u.extractOption(e, t, "tx", "text");
                  if (l || 0 === l) {
                    if (a) {
                      var d = t._module.formatLabels ? t._module.formatLabels(e, t, s) : {},
                        h = {};
                      g(h, t, e.i);
                      var f = t._meta || {};
                      l = u.texttemplateString(l, d, s._d3locale, h, e, f);
                    }
                    var p = e.tp || t.textposition,
                      m = M(e, t),
                      y = i ? i(e) : e.tc || t.textfont.color;
                    o.call(v.font, e.tf || t.textfont.family, m, y).text(l).call(c.convertToTspans, n).call(T, p, m, e.mrc);
                  } else o.remove();
                });
              }
            }, v.selectedTextStyle = function (e, t) {
              if (e.size() && t.selectedpoints) {
                var n = v.makeSelectedTextStyleFns(t);
                e.each(function (e) {
                  var i = r.select(this),
                    o = n.selectedTextColorFn(e),
                    a = e.tp || t.textposition,
                    l = M(e, t);
                  s.fill(i, o), T(i, a, l, e.mrc2 || e.mrc);
                });
              }
            }, v.smoothopen = function (e, t) {
              if (e.length < 3) return "M" + e.join("L");
              var n,
                r = "M" + e[0],
                i = [];
              for (n = 1; n < e.length - 1; n++) i.push(C(e[n - 1], e[n], e[n + 1], t));
              for (r += "Q" + i[0][0] + " " + e[1], n = 2; n < e.length - 1; n++) r += "C" + i[n - 2][1] + " " + i[n - 1][0] + " " + e[n];
              return r + "Q" + i[e.length - 3][1] + " " + e[e.length - 1];
            }, v.smoothclosed = function (e, t) {
              if (e.length < 3) return "M" + e.join("L") + "Z";
              var n,
                r = "M" + e[0],
                i = e.length - 1,
                o = [C(e[i], e[0], e[1], t)];
              for (n = 1; n < i; n++) o.push(C(e[n - 1], e[n], e[n + 1], t));
              for (o.push(C(e[i - 1], e[i], e[0], t)), n = 1; n <= i; n++) r += "C" + o[n - 1][1] + " " + o[n][0] + " " + e[n];
              return r + "C" + o[i][1] + " " + o[0][0] + " " + e[0] + "Z";
            };
            var k = {
                hv: function hv(e, t) {
                  return "H" + r.round(t[0], 2) + "V" + r.round(t[1], 2);
                },
                vh: function vh(e, t) {
                  return "V" + r.round(t[1], 2) + "H" + r.round(t[0], 2);
                },
                hvh: function hvh(e, t) {
                  return "H" + r.round((e[0] + t[0]) / 2, 2) + "V" + r.round(t[1], 2) + "H" + r.round(t[0], 2);
                },
                vhv: function vhv(e, t) {
                  return "V" + r.round((e[1] + t[1]) / 2, 2) + "H" + r.round(t[0], 2) + "V" + r.round(t[1], 2);
                }
              },
              P = function P(e, t) {
                return "L" + r.round(t[0], 2) + "," + r.round(t[1], 2);
              };
            v.steps = function (e) {
              var t = k[e] || P;
              return function (e) {
                for (var n = "M" + r.round(e[0][0], 2) + "," + r.round(e[0][1], 2), i = 1; i < e.length; i++) n += t(e[i - 1], e[i]);
                return n;
              };
            }, v.makeTester = function () {
              var e = u.ensureSingleById(r.select("body"), "svg", "js-plotly-tester", function (e) {
                  e.attr(d.svgAttrs).style({
                    position: "absolute",
                    left: "-10000px",
                    top: "-10000px",
                    width: "9000px",
                    height: "9000px",
                    "z-index": "1"
                  });
                }),
                t = u.ensureSingle(e, "path", "js-reference-point", function (e) {
                  e.attr("d", "M0,0H1V1H0Z").style({
                    "stroke-width": 0,
                    fill: "black"
                  });
                });
              v.tester = e, v.testref = t;
            }, v.savedBBoxes = {};
            var O = 0;
            function R(e) {
              var t = e.getAttribute("data-unformatted");
              if (null !== t) return t + e.getAttribute("data-math") + e.getAttribute("text-anchor") + e.getAttribute("style");
            }
            function I(e, t) {
              if (!e) return null;
              var n = t._context;
              return "url('" + (n._exportedPlot ? "" : n._baseUrl || "") + "#" + e + "')";
            }
            v.bBox = function (e, t, n) {
              var i, o, a;
              if (n || (n = R(e)), n) {
                if (i = v.savedBBoxes[n]) return u.extendFlat({}, i);
              } else if (1 === e.childNodes.length) {
                var s = e.childNodes[0];
                if (n = R(s)) {
                  var l = +s.getAttribute("x") || 0,
                    d = +s.getAttribute("y") || 0,
                    h = s.getAttribute("transform");
                  if (!h) {
                    var f = v.bBox(s, !1, n);
                    return l && (f.left += l, f.right += l), d && (f.top += d, f.bottom += d), f;
                  }
                  if (n += "~" + l + "~" + d + "~" + h, i = v.savedBBoxes[n]) return u.extendFlat({}, i);
                }
              }
              t ? o = e : (a = v.tester.node(), o = e.cloneNode(!0), a.appendChild(o)), r.select(o).attr("transform", null).call(c.positionText, 0, 0);
              var p = o.getBoundingClientRect(),
                m = v.testref.node().getBoundingClientRect();
              t || a.removeChild(o);
              var g = {
                height: p.height,
                width: p.width,
                left: p.left - m.left,
                top: p.top - m.top,
                right: p.right - m.left,
                bottom: p.bottom - m.top
              };
              return O >= 1e4 && (v.savedBBoxes = {}, O = 0), n && (v.savedBBoxes[n] = g), O++, u.extendFlat({}, g);
            }, v.setClipUrl = function (e, t, n) {
              e.attr("clip-path", I(t, n));
            }, v.getTranslate = function (e) {
              var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, function (e, t, n) {
                return [t, n].join(" ");
              }).split(" ");
              return {
                x: +t[0] || 0,
                y: +t[1] || 0
              };
            }, v.setTranslate = function (e, t, n) {
              var r = e.attr ? "attr" : "getAttribute",
                i = e.attr ? "attr" : "setAttribute",
                o = e[r]("transform") || "";
              return t = t || 0, n = n || 0, o = o.replace(/(\btranslate\(.*?\);?)/, "").trim(), o = (o += " translate(" + t + ", " + n + ")").trim(), e[i]("transform", o), o;
            }, v.getScale = function (e) {
              var t = (e[e.attr ? "attr" : "getAttribute"]("transform") || "").replace(/.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, function (e, t, n) {
                return [t, n].join(" ");
              }).split(" ");
              return {
                x: +t[0] || 1,
                y: +t[1] || 1
              };
            }, v.setScale = function (e, t, n) {
              var r = e.attr ? "attr" : "getAttribute",
                i = e.attr ? "attr" : "setAttribute",
                o = e[r]("transform") || "";
              return t = t || 1, n = n || 1, o = o.replace(/(\bscale\(.*?\);?)/, "").trim(), o = (o += " scale(" + t + ", " + n + ")").trim(), e[i]("transform", o), o;
            };
            var j = /\s*sc.*/;
            v.setPointGroupScale = function (e, t, n) {
              if (t = t || 1, n = n || 1, e) {
                var r = 1 === t && 1 === n ? "" : " scale(" + t + "," + n + ")";
                e.each(function () {
                  var e = (this.getAttribute("transform") || "").replace(j, "");
                  e = (e += r).trim(), this.setAttribute("transform", e);
                });
              }
            };
            var N = /translate\([^)]*\)\s*$/;
            v.setTextPointsScale = function (e, t, n) {
              e && e.each(function () {
                var e,
                  i = r.select(this),
                  o = i.select("text");
                if (o.node()) {
                  var a = parseFloat(o.attr("x") || 0),
                    s = parseFloat(o.attr("y") || 0),
                    l = (i.attr("transform") || "").match(N);
                  e = 1 === t && 1 === n ? [] : ["translate(" + a + "," + s + ")", "scale(" + t + "," + n + ")", "translate(" + -a + "," + -s + ")"], l && e.push(l), i.attr("transform", e.join(" "));
                }
              });
            };
          }, {
            "../../components/fx/helpers": 410,
            "../../constants/alignment": 469,
            "../../constants/interactions": 473,
            "../../constants/xmlns_namespaces": 475,
            "../../lib": 495,
            "../../lib/svg_text_utils": 518,
            "../../registry": 593,
            "../../traces/scatter/make_bubble_size_func": 639,
            "../../traces/scatter/subtypes": 646,
            "../color": 375,
            "../colorscale": 387,
            "./symbol_defs": 397,
            d3: 82,
            "fast-isnumeric": 91,
            tinycolor2: 341
          }],
          397: [function (e, t, n) {
            "use strict";

            var r = e("d3");
            t.exports = {
              circle: {
                n: 0,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + ",0A" + t + "," + t + " 0 1,1 0,-" + t + "A" + t + "," + t + " 0 0,1 " + t + ",0Z";
                }
              },
              square: {
                n: 1,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + "," + t + "H-" + t + "V-" + t + "H" + t + "Z";
                }
              },
              diamond: {
                n: 2,
                f: function f(e) {
                  var t = r.round(1.3 * e, 2);
                  return "M" + t + ",0L0," + t + "L-" + t + ",0L0,-" + t + "Z";
                }
              },
              cross: {
                n: 3,
                f: function f(e) {
                  var t = r.round(.4 * e, 2),
                    n = r.round(1.2 * e, 2);
                  return "M" + n + "," + t + "H" + t + "V" + n + "H-" + t + "V" + t + "H-" + n + "V-" + t + "H-" + t + "V-" + n + "H" + t + "V-" + t + "H" + n + "Z";
                }
              },
              x: {
                n: 4,
                f: function f(e) {
                  var t = r.round(.8 * e / Math.sqrt(2), 2),
                    n = "l" + t + "," + t,
                    i = "l" + t + ",-" + t,
                    o = "l-" + t + ",-" + t,
                    a = "l-" + t + "," + t;
                  return "M0," + t + n + i + o + i + o + a + o + a + n + a + n + "Z";
                }
              },
              "triangle-up": {
                n: 5,
                f: function f(e) {
                  var t = r.round(2 * e / Math.sqrt(3), 2);
                  return "M-" + t + "," + r.round(e / 2, 2) + "H" + t + "L0,-" + r.round(e, 2) + "Z";
                }
              },
              "triangle-down": {
                n: 6,
                f: function f(e) {
                  var t = r.round(2 * e / Math.sqrt(3), 2);
                  return "M-" + t + ",-" + r.round(e / 2, 2) + "H" + t + "L0," + r.round(e, 2) + "Z";
                }
              },
              "triangle-left": {
                n: 7,
                f: function f(e) {
                  var t = r.round(2 * e / Math.sqrt(3), 2);
                  return "M" + r.round(e / 2, 2) + ",-" + t + "V" + t + "L-" + r.round(e, 2) + ",0Z";
                }
              },
              "triangle-right": {
                n: 8,
                f: function f(e) {
                  var t = r.round(2 * e / Math.sqrt(3), 2);
                  return "M-" + r.round(e / 2, 2) + ",-" + t + "V" + t + "L" + r.round(e, 2) + ",0Z";
                }
              },
              "triangle-ne": {
                n: 9,
                f: function f(e) {
                  var t = r.round(.6 * e, 2),
                    n = r.round(1.2 * e, 2);
                  return "M-" + n + ",-" + t + "H" + t + "V" + n + "Z";
                }
              },
              "triangle-se": {
                n: 10,
                f: function f(e) {
                  var t = r.round(.6 * e, 2),
                    n = r.round(1.2 * e, 2);
                  return "M" + t + ",-" + n + "V" + t + "H-" + n + "Z";
                }
              },
              "triangle-sw": {
                n: 11,
                f: function f(e) {
                  var t = r.round(.6 * e, 2),
                    n = r.round(1.2 * e, 2);
                  return "M" + n + "," + t + "H-" + t + "V-" + n + "Z";
                }
              },
              "triangle-nw": {
                n: 12,
                f: function f(e) {
                  var t = r.round(.6 * e, 2),
                    n = r.round(1.2 * e, 2);
                  return "M-" + t + "," + n + "V-" + t + "H" + n + "Z";
                }
              },
              pentagon: {
                n: 13,
                f: function f(e) {
                  var t = r.round(.951 * e, 2),
                    n = r.round(.588 * e, 2),
                    i = r.round(-e, 2),
                    o = r.round(-.309 * e, 2);
                  return "M" + t + "," + o + "L" + n + "," + r.round(.809 * e, 2) + "H-" + n + "L-" + t + "," + o + "L0," + i + "Z";
                }
              },
              hexagon: {
                n: 14,
                f: function f(e) {
                  var t = r.round(e, 2),
                    n = r.round(e / 2, 2),
                    i = r.round(e * Math.sqrt(3) / 2, 2);
                  return "M" + i + ",-" + n + "V" + n + "L0," + t + "L-" + i + "," + n + "V-" + n + "L0,-" + t + "Z";
                }
              },
              hexagon2: {
                n: 15,
                f: function f(e) {
                  var t = r.round(e, 2),
                    n = r.round(e / 2, 2),
                    i = r.round(e * Math.sqrt(3) / 2, 2);
                  return "M-" + n + "," + i + "H" + n + "L" + t + ",0L" + n + ",-" + i + "H-" + n + "L-" + t + ",0Z";
                }
              },
              octagon: {
                n: 16,
                f: function f(e) {
                  var t = r.round(.924 * e, 2),
                    n = r.round(.383 * e, 2);
                  return "M-" + n + ",-" + t + "H" + n + "L" + t + ",-" + n + "V" + n + "L" + n + "," + t + "H-" + n + "L-" + t + "," + n + "V-" + n + "Z";
                }
              },
              star: {
                n: 17,
                f: function f(e) {
                  var t = 1.4 * e,
                    n = r.round(.225 * t, 2),
                    i = r.round(.951 * t, 2),
                    o = r.round(.363 * t, 2),
                    a = r.round(.588 * t, 2),
                    s = r.round(-t, 2),
                    l = r.round(-.309 * t, 2),
                    u = r.round(.118 * t, 2),
                    c = r.round(.809 * t, 2);
                  return "M" + n + "," + l + "H" + i + "L" + o + "," + u + "L" + a + "," + c + "L0," + r.round(.382 * t, 2) + "L-" + a + "," + c + "L-" + o + "," + u + "L-" + i + "," + l + "H-" + n + "L0," + s + "Z";
                }
              },
              hexagram: {
                n: 18,
                f: function f(e) {
                  var t = r.round(.66 * e, 2),
                    n = r.round(.38 * e, 2),
                    i = r.round(.76 * e, 2);
                  return "M-" + i + ",0l-" + n + ",-" + t + "h" + i + "l" + n + ",-" + t + "l" + n + "," + t + "h" + i + "l-" + n + "," + t + "l" + n + "," + t + "h-" + i + "l-" + n + "," + t + "l-" + n + ",-" + t + "h-" + i + "Z";
                }
              },
              "star-triangle-up": {
                n: 19,
                f: function f(e) {
                  var t = r.round(e * Math.sqrt(3) * .8, 2),
                    n = r.round(.8 * e, 2),
                    i = r.round(1.6 * e, 2),
                    o = r.round(4 * e, 2),
                    a = "A " + o + "," + o + " 0 0 1 ";
                  return "M-" + t + "," + n + a + t + "," + n + a + "0,-" + i + a + "-" + t + "," + n + "Z";
                }
              },
              "star-triangle-down": {
                n: 20,
                f: function f(e) {
                  var t = r.round(e * Math.sqrt(3) * .8, 2),
                    n = r.round(.8 * e, 2),
                    i = r.round(1.6 * e, 2),
                    o = r.round(4 * e, 2),
                    a = "A " + o + "," + o + " 0 0 1 ";
                  return "M" + t + ",-" + n + a + "-" + t + ",-" + n + a + "0," + i + a + t + ",-" + n + "Z";
                }
              },
              "star-square": {
                n: 21,
                f: function f(e) {
                  var t = r.round(1.1 * e, 2),
                    n = r.round(2 * e, 2),
                    i = "A " + n + "," + n + " 0 0 1 ";
                  return "M-" + t + ",-" + t + i + "-" + t + "," + t + i + t + "," + t + i + t + ",-" + t + i + "-" + t + ",-" + t + "Z";
                }
              },
              "star-diamond": {
                n: 22,
                f: function f(e) {
                  var t = r.round(1.4 * e, 2),
                    n = r.round(1.9 * e, 2),
                    i = "A " + n + "," + n + " 0 0 1 ";
                  return "M-" + t + ",0" + i + "0," + t + i + t + ",0" + i + "0,-" + t + i + "-" + t + ",0Z";
                }
              },
              "diamond-tall": {
                n: 23,
                f: function f(e) {
                  var t = r.round(.7 * e, 2),
                    n = r.round(1.4 * e, 2);
                  return "M0," + n + "L" + t + ",0L0,-" + n + "L-" + t + ",0Z";
                }
              },
              "diamond-wide": {
                n: 24,
                f: function f(e) {
                  var t = r.round(1.4 * e, 2),
                    n = r.round(.7 * e, 2);
                  return "M0," + n + "L" + t + ",0L0,-" + n + "L-" + t + ",0Z";
                }
              },
              hourglass: {
                n: 25,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + "," + t + "H-" + t + "L" + t + ",-" + t + "H-" + t + "Z";
                },
                noDot: !0
              },
              bowtie: {
                n: 26,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + "," + t + "V-" + t + "L-" + t + "," + t + "V-" + t + "Z";
                },
                noDot: !0
              },
              "circle-cross": {
                n: 27,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M0," + t + "V-" + t + "M" + t + ",0H-" + t + "M" + t + ",0A" + t + "," + t + " 0 1,1 0,-" + t + "A" + t + "," + t + " 0 0,1 " + t + ",0Z";
                },
                needLine: !0,
                noDot: !0
              },
              "circle-x": {
                n: 28,
                f: function f(e) {
                  var t = r.round(e, 2),
                    n = r.round(e / Math.sqrt(2), 2);
                  return "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n + "M" + t + ",0A" + t + "," + t + " 0 1,1 0,-" + t + "A" + t + "," + t + " 0 0,1 " + t + ",0Z";
                },
                needLine: !0,
                noDot: !0
              },
              "square-cross": {
                n: 29,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M0," + t + "V-" + t + "M" + t + ",0H-" + t + "M" + t + "," + t + "H-" + t + "V-" + t + "H" + t + "Z";
                },
                needLine: !0,
                noDot: !0
              },
              "square-x": {
                n: 30,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + "," + t + "L-" + t + ",-" + t + "M" + t + ",-" + t + "L-" + t + "," + t + "M" + t + "," + t + "H-" + t + "V-" + t + "H" + t + "Z";
                },
                needLine: !0,
                noDot: !0
              },
              "diamond-cross": {
                n: 31,
                f: function f(e) {
                  var t = r.round(1.3 * e, 2);
                  return "M" + t + ",0L0," + t + "L-" + t + ",0L0,-" + t + "ZM0,-" + t + "V" + t + "M-" + t + ",0H" + t;
                },
                needLine: !0,
                noDot: !0
              },
              "diamond-x": {
                n: 32,
                f: function f(e) {
                  var t = r.round(1.3 * e, 2),
                    n = r.round(.65 * e, 2);
                  return "M" + t + ",0L0," + t + "L-" + t + ",0L0,-" + t + "ZM-" + n + ",-" + n + "L" + n + "," + n + "M-" + n + "," + n + "L" + n + ",-" + n;
                },
                needLine: !0,
                noDot: !0
              },
              "cross-thin": {
                n: 33,
                f: function f(e) {
                  var t = r.round(1.4 * e, 2);
                  return "M0," + t + "V-" + t + "M" + t + ",0H-" + t;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "x-thin": {
                n: 34,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + "," + t + "L-" + t + ",-" + t + "M" + t + ",-" + t + "L-" + t + "," + t;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              asterisk: {
                n: 35,
                f: function f(e) {
                  var t = r.round(1.2 * e, 2),
                    n = r.round(.85 * e, 2);
                  return "M0," + t + "V-" + t + "M" + t + ",0H-" + t + "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              hash: {
                n: 36,
                f: function f(e) {
                  var t = r.round(e / 2, 2),
                    n = r.round(e, 2);
                  return "M" + t + "," + n + "V-" + n + "m-" + n + ",0V" + n + "M" + n + "," + t + "H-" + n + "m0,-" + n + "H" + n;
                },
                needLine: !0,
                noFill: !0
              },
              "y-up": {
                n: 37,
                f: function f(e) {
                  var t = r.round(1.2 * e, 2),
                    n = r.round(1.6 * e, 2),
                    i = r.round(.8 * e, 2);
                  return "M-" + t + "," + i + "L0,0M" + t + "," + i + "L0,0M0,-" + n + "L0,0";
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "y-down": {
                n: 38,
                f: function f(e) {
                  var t = r.round(1.2 * e, 2),
                    n = r.round(1.6 * e, 2),
                    i = r.round(.8 * e, 2);
                  return "M-" + t + ",-" + i + "L0,0M" + t + ",-" + i + "L0,0M0," + n + "L0,0";
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "y-left": {
                n: 39,
                f: function f(e) {
                  var t = r.round(1.2 * e, 2),
                    n = r.round(1.6 * e, 2),
                    i = r.round(.8 * e, 2);
                  return "M" + i + "," + t + "L0,0M" + i + ",-" + t + "L0,0M-" + n + ",0L0,0";
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "y-right": {
                n: 40,
                f: function f(e) {
                  var t = r.round(1.2 * e, 2),
                    n = r.round(1.6 * e, 2),
                    i = r.round(.8 * e, 2);
                  return "M-" + i + "," + t + "L0,0M-" + i + ",-" + t + "L0,0M" + n + ",0L0,0";
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "line-ew": {
                n: 41,
                f: function f(e) {
                  var t = r.round(1.4 * e, 2);
                  return "M" + t + ",0H-" + t;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "line-ns": {
                n: 42,
                f: function f(e) {
                  var t = r.round(1.4 * e, 2);
                  return "M0," + t + "V-" + t;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "line-ne": {
                n: 43,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + ",-" + t + "L-" + t + "," + t;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              },
              "line-nw": {
                n: 44,
                f: function f(e) {
                  var t = r.round(e, 2);
                  return "M" + t + "," + t + "L-" + t + ",-" + t;
                },
                needLine: !0,
                noDot: !0,
                noFill: !0
              }
            };
          }, {
            d3: 82
          }],
          398: [function (e, t, n) {
            "use strict";

            t.exports = {
              visible: {
                valType: "boolean",
                editType: "calc"
              },
              type: {
                valType: "enumerated",
                values: ["percent", "constant", "sqrt", "data"],
                editType: "calc"
              },
              symmetric: {
                valType: "boolean",
                editType: "calc"
              },
              array: {
                valType: "data_array",
                editType: "calc"
              },
              arrayminus: {
                valType: "data_array",
                editType: "calc"
              },
              value: {
                valType: "number",
                min: 0,
                dflt: 10,
                editType: "calc"
              },
              valueminus: {
                valType: "number",
                min: 0,
                dflt: 10,
                editType: "calc"
              },
              traceref: {
                valType: "integer",
                min: 0,
                dflt: 0,
                editType: "style"
              },
              tracerefminus: {
                valType: "integer",
                min: 0,
                dflt: 0,
                editType: "style"
              },
              copy_ystyle: {
                valType: "boolean",
                editType: "plot"
              },
              copy_zstyle: {
                valType: "boolean",
                editType: "style"
              },
              color: {
                valType: "color",
                editType: "style"
              },
              thickness: {
                valType: "number",
                min: 0,
                dflt: 2,
                editType: "style"
              },
              width: {
                valType: "number",
                min: 0,
                editType: "plot"
              },
              editType: "calc",
              _deprecated: {
                opacity: {
                  valType: "number",
                  editType: "style"
                }
              }
            };
          }, {}],
          399: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../registry"),
              o = e("../../plots/cartesian/axes"),
              a = e("../../lib"),
              s = e("./compute_error");
            function l(e, t, n, i) {
              var l = t["error_" + i] || {},
                u = [];
              if (l.visible && -1 !== ["linear", "log"].indexOf(n.type)) {
                for (var c = s(l), d = 0; d < e.length; d++) {
                  var h = e[d],
                    f = h.i;
                  if (void 0 === f) f = d;else if (null === f) continue;
                  var p = h[i];
                  if (r(n.c2l(p))) {
                    var m = c(p, f);
                    if (r(m[0]) && r(m[1])) {
                      var g = h[i + "s"] = p - m[0],
                        v = h[i + "h"] = p + m[1];
                      u.push(g, v);
                    }
                  }
                }
                var y = n._id,
                  b = t._extremes[y],
                  _ = o.findExtremes(n, u, a.extendFlat({
                    tozero: b.opts.tozero
                  }, {
                    padded: !0
                  }));
                b.min = b.min.concat(_.min), b.max = b.max.concat(_.max);
              }
            }
            t.exports = function (e) {
              for (var t = e.calcdata, n = 0; n < t.length; n++) {
                var r = t[n],
                  a = r[0].trace;
                if (!0 === a.visible && i.traceIs(a, "errorBarsOK")) {
                  var s = o.getFromId(e, a.xaxis),
                    u = o.getFromId(e, a.yaxis);
                  l(r, a, s, "x"), l(r, a, u, "y");
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../plots/cartesian/axes": 541,
            "../../registry": 593,
            "./compute_error": 400,
            "fast-isnumeric": 91
          }],
          400: [function (e, t, n) {
            "use strict";

            function r(e, t) {
              return "percent" === e ? function (e) {
                return Math.abs(e * t / 100);
              } : "constant" === e ? function () {
                return Math.abs(t);
              } : "sqrt" === e ? function (e) {
                return Math.sqrt(Math.abs(e));
              } : void 0;
            }
            t.exports = function (e) {
              var t = e.type,
                n = e.symmetric;
              if ("data" === t) {
                var i = e.array || [];
                if (n) return function (e, t) {
                  var n = +i[t];
                  return [n, n];
                };
                var o = e.arrayminus || [];
                return function (e, t) {
                  var n = +i[t],
                    r = +o[t];
                  return isNaN(n) && isNaN(r) ? [NaN, NaN] : [r || 0, n || 0];
                };
              }
              var a = r(t, e.value),
                s = r(t, e.valueminus);
              return n || void 0 === e.valueminus ? function (e) {
                var t = a(e);
                return [t, t];
              } : function (e) {
                return [s(e), a(e)];
              };
            };
          }, {}],
          401: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../registry"),
              o = e("../../lib"),
              a = e("../../plot_api/plot_template"),
              s = e("./attributes");
            t.exports = function (e, t, n, l) {
              var u = "error_" + l.axis,
                c = a.newContainer(t, u),
                d = e[u] || {};
              function h(e, t) {
                return o.coerce(d, c, s, e, t);
              }
              if (!1 !== h("visible", void 0 !== d.array || void 0 !== d.value || "sqrt" === d.type)) {
                var f = h("type", "array" in d ? "data" : "percent"),
                  p = !0;
                "sqrt" !== f && (p = h("symmetric", !(("data" === f ? "arrayminus" : "valueminus") in d))), "data" === f ? (h("array"), h("traceref"), p || (h("arrayminus"), h("tracerefminus"))) : "percent" !== f && "constant" !== f || (h("value"), p || h("valueminus"));
                var m = "copy_" + l.inherit + "style";
                l.inherit && (t["error_" + l.inherit] || {}).visible && h(m, !(d.color || r(d.thickness) || r(d.width))), l.inherit && c[m] || (h("color", n), h("thickness"), h("width", i.traceIs(t, "gl3d") ? 0 : 4));
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../registry": 593,
            "./attributes": 398,
            "fast-isnumeric": 91
          }],
          402: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plot_api/edit_types").overrideAll,
              o = e("./attributes"),
              a = {
                error_x: r.extendFlat({}, o),
                error_y: r.extendFlat({}, o)
              };
            delete a.error_x.copy_zstyle, delete a.error_y.copy_zstyle, delete a.error_y.copy_ystyle;
            var s = {
              error_x: r.extendFlat({}, o),
              error_y: r.extendFlat({}, o),
              error_z: r.extendFlat({}, o)
            };
            delete s.error_x.copy_ystyle, delete s.error_y.copy_ystyle, delete s.error_z.copy_ystyle, delete s.error_z.copy_zstyle, t.exports = {
              moduleType: "component",
              name: "errorbars",
              schema: {
                traces: {
                  scatter: a,
                  bar: a,
                  histogram: a,
                  scatter3d: i(s, "calc", "nested"),
                  scattergl: i(a, "calc", "nested")
                }
              },
              supplyDefaults: e("./defaults"),
              calc: e("./calc"),
              makeComputeError: e("./compute_error"),
              plot: e("./plot"),
              style: e("./style"),
              hoverInfo: function hoverInfo(e, t, n) {
                (t.error_y || {}).visible && (n.yerr = e.yh - e.y, t.error_y.symmetric || (n.yerrneg = e.y - e.ys)), (t.error_x || {}).visible && (n.xerr = e.xh - e.x, t.error_x.symmetric || (n.xerrneg = e.x - e.xs));
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/edit_types": 524,
            "./attributes": 398,
            "./calc": 399,
            "./compute_error": 400,
            "./defaults": 401,
            "./plot": 403,
            "./style": 404
          }],
          403: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../drawing"),
              a = e("../../traces/scatter/subtypes");
            t.exports = function (e, t, n, s) {
              var l = n.xaxis,
                u = n.yaxis,
                c = s && s.duration > 0;
              t.each(function (t) {
                var d,
                  h = t[0].trace,
                  f = h.error_x || {},
                  p = h.error_y || {};
                h.ids && (d = function d(e) {
                  return e.id;
                });
                var m = a.hasMarkers(h) && h.marker.maxdisplayed > 0;
                p.visible || f.visible || (t = []);
                var g = r.select(this).selectAll("g.errorbar").data(t, d);
                if (g.exit().remove(), t.length) {
                  f.visible || g.selectAll("path.xerror").remove(), p.visible || g.selectAll("path.yerror").remove(), g.style("opacity", 1);
                  var v = g.enter().append("g").classed("errorbar", !0);
                  c && v.style("opacity", 0).transition().duration(s.duration).style("opacity", 1), o.setClipUrl(g, n.layerClipId, e), g.each(function (e) {
                    var t = r.select(this),
                      n = function (e, t, n) {
                        var r = {
                          x: t.c2p(e.x),
                          y: n.c2p(e.y)
                        };
                        return void 0 !== e.yh && (r.yh = n.c2p(e.yh), r.ys = n.c2p(e.ys), i(r.ys) || (r.noYS = !0, r.ys = n.c2p(e.ys, !0))), void 0 !== e.xh && (r.xh = t.c2p(e.xh), r.xs = t.c2p(e.xs), i(r.xs) || (r.noXS = !0, r.xs = t.c2p(e.xs, !0))), r;
                      }(e, l, u);
                    if (!m || e.vis) {
                      var o,
                        a = t.select("path.yerror");
                      if (p.visible && i(n.x) && i(n.yh) && i(n.ys)) {
                        var d = p.width;
                        o = "M" + (n.x - d) + "," + n.yh + "h" + 2 * d + "m-" + d + ",0V" + n.ys, n.noYS || (o += "m-" + d + ",0h" + 2 * d), a.size() ? c && (a = a.transition().duration(s.duration).ease(s.easing)) : a = t.append("path").style("vector-effect", "non-scaling-stroke").classed("yerror", !0), a.attr("d", o);
                      } else a.remove();
                      var h = t.select("path.xerror");
                      if (f.visible && i(n.y) && i(n.xh) && i(n.xs)) {
                        var g = (f.copy_ystyle ? p : f).width;
                        o = "M" + n.xh + "," + (n.y - g) + "v" + 2 * g + "m0,-" + g + "H" + n.xs, n.noXS || (o += "m0,-" + g + "v" + 2 * g), h.size() ? c && (h = h.transition().duration(s.duration).ease(s.easing)) : h = t.append("path").style("vector-effect", "non-scaling-stroke").classed("xerror", !0), h.attr("d", o);
                      } else h.remove();
                    }
                  });
                }
              });
            };
          }, {
            "../../traces/scatter/subtypes": 646,
            "../drawing": 396,
            d3: 82,
            "fast-isnumeric": 91
          }],
          404: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../color");
            t.exports = function (e) {
              e.each(function (e) {
                var t = e[0].trace,
                  n = t.error_y || {},
                  o = t.error_x || {},
                  a = r.select(this);
                a.selectAll("path.yerror").style("stroke-width", n.thickness + "px").call(i.stroke, n.color), o.copy_ystyle && (o = n), a.selectAll("path.xerror").style("stroke-width", o.thickness + "px").call(i.stroke, o.color);
              });
            };
          }, {
            "../color": 375,
            d3: 82
          }],
          405: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/font_attributes"),
              i = e("./layout_attributes").hoverlabel,
              o = e("../../lib/extend").extendFlat;
            t.exports = {
              hoverlabel: {
                bgcolor: o({}, i.bgcolor, {
                  arrayOk: !0
                }),
                bordercolor: o({}, i.bordercolor, {
                  arrayOk: !0
                }),
                font: r({
                  arrayOk: !0,
                  editType: "none"
                }),
                align: o({}, i.align, {
                  arrayOk: !0
                }),
                namelength: o({}, i.namelength, {
                  arrayOk: !0
                }),
                editType: "none"
              }
            };
          }, {
            "../../lib/extend": 489,
            "../../plots/font_attributes": 567,
            "./layout_attributes": 414
          }],
          406: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../registry");
            function o(e, t, n, i) {
              i = i || r.identity, Array.isArray(e) && (t[0][n] = i(e));
            }
            t.exports = function (e) {
              var t = e.calcdata,
                n = e._fullLayout;
              function a(e) {
                return function (t) {
                  return r.coerceHoverinfo({
                    hoverinfo: t
                  }, {
                    _module: e._module
                  }, n);
                };
              }
              for (var s = 0; s < t.length; s++) {
                var l = t[s],
                  u = l[0].trace;
                if (!i.traceIs(u, "pie-like")) {
                  var c = i.traceIs(u, "2dMap") ? o : r.fillArray;
                  c(u.hoverinfo, l, "hi", a(u)), u.hovertemplate && c(u.hovertemplate, l, "ht"), u.hoverlabel && (c(u.hoverlabel.bgcolor, l, "hbg"), c(u.hoverlabel.bordercolor, l, "hbc"), c(u.hoverlabel.font.size, l, "hts"), c(u.hoverlabel.font.color, l, "htc"), c(u.hoverlabel.font.family, l, "htf"), c(u.hoverlabel.namelength, l, "hnl"), c(u.hoverlabel.align, l, "hta"));
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../registry": 593
          }],
          407: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("./hover").hover;
            t.exports = function (e, t, n) {
              var o = r.getComponentMethod("annotations", "onClick")(e, e._hoverdata);
              function a() {
                e.emit("plotly_click", {
                  points: e._hoverdata,
                  event: t
                });
              }
              void 0 !== n && i(e, t, n, !0), e._hoverdata && t && t.target && (o && o.then ? o.then(a) : a(), t.stopImmediatePropagation && t.stopImmediatePropagation());
            };
          }, {
            "../../registry": 593,
            "./hover": 411
          }],
          408: [function (e, t, n) {
            "use strict";

            t.exports = {
              YANGLE: 60,
              HOVERARROWSIZE: 6,
              HOVERTEXTPAD: 3,
              HOVERFONTSIZE: 13,
              HOVERFONT: "Arial, sans-serif",
              HOVERMINTIME: 50,
              HOVERID: "-hover"
            };
          }, {}],
          409: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./attributes"),
              o = e("./hoverlabel_defaults");
            t.exports = function (e, t, n, a) {
              var s = r.extendFlat({}, a.hoverlabel);
              t.hovertemplate && (s.namelength = -1), o(e, t, function (n, o) {
                return r.coerce(e, t, i, n, o);
              }, s);
            };
          }, {
            "../../lib": 495,
            "./attributes": 405,
            "./hoverlabel_defaults": 412
          }],
          410: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            n.getSubplot = function (e) {
              return e.subplot || e.xaxis + e.yaxis || e.geo;
            }, n.isTraceInSubplots = function (e, t) {
              if ("splom" === e.type) {
                for (var r = e.xaxes || [], i = e.yaxes || [], o = 0; o < r.length; o++) for (var a = 0; a < i.length; a++) if (-1 !== t.indexOf(r[o] + i[a])) return !0;
                return !1;
              }
              return -1 !== t.indexOf(n.getSubplot(e));
            }, n.flat = function (e, t) {
              for (var n = new Array(e.length), r = 0; r < e.length; r++) n[r] = t;
              return n;
            }, n.p2c = function (e, t) {
              for (var n = new Array(e.length), r = 0; r < e.length; r++) n[r] = e[r].p2c(t);
              return n;
            }, n.getDistanceFunction = function (e, t, r, i) {
              return "closest" === e ? i || n.quadrature(t, r) : "x" === e ? t : r;
            }, n.getClosest = function (e, t, n) {
              if (!1 !== n.index) n.index >= 0 && n.index < e.length ? n.distance = 0 : n.index = !1;else for (var r = 0; r < e.length; r++) {
                var i = t(e[r]);
                i <= n.distance && (n.index = r, n.distance = i);
              }
              return n;
            }, n.inbox = function (e, t, n) {
              return e * t < 0 || 0 === e ? n : 1 / 0;
            }, n.quadrature = function (e, t) {
              return function (n) {
                var r = e(n),
                  i = t(n);
                return Math.sqrt(r * r + i * i);
              };
            }, n.makeEventData = function (e, t, r) {
              var i = "index" in e ? e.index : e.pointNumber,
                o = {
                  data: t._input,
                  fullData: t,
                  curveNumber: t.index,
                  pointNumber: i
                };
              if (t._indexToPoints) {
                var a = t._indexToPoints[i];
                1 === a.length ? o.pointIndex = a[0] : o.pointIndices = a;
              } else o.pointIndex = i;
              return t._module.eventData ? o = t._module.eventData(o, e, t, r, i) : ("xVal" in e ? o.x = e.xVal : "x" in e && (o.x = e.x), "yVal" in e ? o.y = e.yVal : "y" in e && (o.y = e.y), e.xa && (o.xaxis = e.xa), e.ya && (o.yaxis = e.ya), void 0 !== e.zLabelVal && (o.z = e.zLabelVal)), n.appendArrayPointValue(o, t, i), o;
            }, n.appendArrayPointValue = function (e, t, n) {
              var i = t._arrayAttrs;
              if (i) for (var s = 0; s < i.length; s++) {
                var l = i[s],
                  u = o(l);
                if (void 0 === e[u]) {
                  var c = a(r.nestedProperty(t, l).get(), n);
                  void 0 !== c && (e[u] = c);
                }
              }
            }, n.appendArrayMultiPointValues = function (e, t, n) {
              var i = t._arrayAttrs;
              if (i) for (var s = 0; s < i.length; s++) {
                var l = i[s],
                  u = o(l);
                if (void 0 === e[u]) {
                  for (var c = r.nestedProperty(t, l).get(), d = new Array(n.length), h = 0; h < n.length; h++) d[h] = a(c, n[h]);
                  e[u] = d;
                }
              }
            };
            var i = {
              ids: "id",
              locations: "location",
              labels: "label",
              values: "value",
              "marker.colors": "color",
              parents: "parent"
            };
            function o(e) {
              return i[e] || e;
            }
            function a(e, t) {
              return Array.isArray(t) ? Array.isArray(e) && Array.isArray(e[t[0]]) ? e[t[0]][t[1]] : void 0 : e[t];
            }
          }, {
            "../../lib": 495
          }],
          411: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("tinycolor2"),
              a = e("../../lib"),
              s = e("../../lib/events"),
              l = e("../../lib/svg_text_utils"),
              u = e("../../lib/override_cursor"),
              c = e("../drawing"),
              d = e("../color"),
              h = e("../dragelement"),
              f = e("../../plots/cartesian/axes"),
              p = e("../../registry"),
              m = e("./helpers"),
              g = e("./constants"),
              v = g.YANGLE,
              y = Math.PI * v / 180,
              b = 1 / Math.sin(y),
              _ = Math.cos(y),
              x = Math.sin(y),
              w = g.HOVERARROWSIZE,
              S = g.HOVERTEXTPAD;
            n.hover = function (e, t, n, o) {
              e = a.getGraphDiv(e), a.throttle(e._fullLayout._uid + g.HOVERID, g.HOVERMINTIME, function () {
                !function (e, t, n, o) {
                  n || (n = "xy");
                  var l = Array.isArray(n) ? n : [n],
                    c = e._fullLayout,
                    f = c._plots || [],
                    g = f[n],
                    v = c._has("cartesian");
                  if (g) {
                    var y = g.overlays.map(function (e) {
                      return e.id;
                    });
                    l = l.concat(y);
                  }
                  for (var _ = l.length, x = new Array(_), w = new Array(_), S = !1, A = 0; A < _; A++) {
                    var P = l[A];
                    if (f[P]) S = !0, x[A] = f[P].xaxis, w[A] = f[P].yaxis;else {
                      if (!c[P] || !c[P]._subplot) return void a.warn("Unrecognized subplot: " + P);
                      var O = c[P]._subplot;
                      x[A] = O.xaxis, w[A] = O.yaxis;
                    }
                  }
                  var R = t.hovermode || c.hovermode;
                  if (R && !S && (R = "closest"), -1 === ["x", "y", "closest"].indexOf(R) || !e.calcdata || e.querySelector(".zoombox") || e._dragging) return h.unhoverRaw(e, t);
                  var I,
                    j,
                    N,
                    L,
                    D,
                    B,
                    F,
                    z,
                    U,
                    G,
                    V,
                    H,
                    q,
                    W = -1 === c.hoverdistance ? 1 / 0 : c.hoverdistance,
                    $ = -1 === c.spikedistance ? 1 / 0 : c.spikedistance,
                    X = [],
                    Y = [],
                    K = {
                      hLinePoint: null,
                      vLinePoint: null
                    },
                    Z = !1;
                  if (Array.isArray(t)) for (R = "array", N = 0; N < t.length; N++) (D = e.calcdata[t[N].curveNumber || 0]) && (B = D[0].trace, "skip" !== D[0].trace.hoverinfo && (Y.push(D), "h" === B.orientation && (Z = !0)));else {
                    for (L = 0; L < e.calcdata.length; L++) "skip" !== (B = (D = e.calcdata[L])[0].trace).hoverinfo && m.isTraceInSubplots(B, l) && (Y.push(D), "h" === B.orientation && (Z = !0));
                    var Q, J;
                    if (t.target) {
                      if (!1 === s.triggerHandler(e, "plotly_beforehover", t)) return;
                      var ee = t.target.getBoundingClientRect();
                      if (Q = t.clientX - ee.left, J = t.clientY - ee.top, Q < 0 || Q > x[0]._length || J < 0 || J > w[0]._length) return h.unhoverRaw(e, t);
                    } else Q = "xpx" in t ? t.xpx : x[0]._length / 2, J = "ypx" in t ? t.ypx : w[0]._length / 2;
                    if (t.pointerX = Q + x[0]._offset, t.pointerY = J + w[0]._offset, I = "xval" in t ? m.flat(l, t.xval) : m.p2c(x, Q), j = "yval" in t ? m.flat(l, t.yval) : m.p2c(w, J), !i(I[0]) || !i(j[0])) return a.warn("Fx.hover failed", t, e), h.unhoverRaw(e, t);
                  }
                  var te = 1 / 0;
                  for (L = 0; L < Y.length; L++) if ((D = Y[L]) && D[0] && D[0].trace && !0 === (B = D[0].trace).visible && 0 !== B._length && -1 === ["carpet", "contourcarpet"].indexOf(B._module.name)) {
                    if ("splom" === B.type ? F = l[z = 0] : (F = m.getSubplot(B), z = l.indexOf(F)), U = R, H = {
                      cd: D,
                      trace: B,
                      xa: x[z],
                      ya: w[z],
                      maxHoverDistance: W,
                      maxSpikeDistance: $,
                      index: !1,
                      distance: Math.min(te, W),
                      spikeDistance: 1 / 0,
                      xSpike: void 0,
                      ySpike: void 0,
                      color: d.defaultLine,
                      name: B.name,
                      x0: void 0,
                      x1: void 0,
                      y0: void 0,
                      y1: void 0,
                      xLabelVal: void 0,
                      yLabelVal: void 0,
                      zLabelVal: void 0,
                      text: void 0
                    }, c[F] && (H.subplot = c[F]._subplot), c._splomScenes && c._splomScenes[B.uid] && (H.scene = c._splomScenes[B.uid]), q = X.length, "array" === U) {
                      var ne = t[L];
                      "pointNumber" in ne ? (H.index = ne.pointNumber, U = "closest") : (U = "", "xval" in ne && (G = ne.xval, U = "x"), "yval" in ne && (V = ne.yval, U = U ? "closest" : "y"));
                    } else G = I[z], V = j[z];
                    if (0 !== W) if (B._module && B._module.hoverPoints) {
                      var re = B._module.hoverPoints(H, G, V, U, c._hoverlayer);
                      if (re) for (var ie, oe = 0; oe < re.length; oe++) ie = re[oe], i(ie.x0) && i(ie.y0) && X.push(M(ie, R));
                    } else a.log("Unrecognized trace type in hover:", B);
                    if ("closest" === R && X.length > q && (X.splice(0, q), te = X[0].distance), v && 0 !== $ && 0 === X.length) {
                      H.distance = $, H.index = !1;
                      var ae = B._module.hoverPoints(H, G, V, "closest", c._hoverlayer);
                      if (ae && (ae = ae.filter(function (e) {
                        return e.spikeDistance <= $;
                      })), ae && ae.length) {
                        var se,
                          le = ae.filter(function (e) {
                            return e.xa.showspikes;
                          });
                        if (le.length) {
                          var ue = le[0];
                          i(ue.x0) && i(ue.y0) && (se = fe(ue), (!K.vLinePoint || K.vLinePoint.spikeDistance > se.spikeDistance) && (K.vLinePoint = se));
                        }
                        var ce = ae.filter(function (e) {
                          return e.ya.showspikes;
                        });
                        if (ce.length) {
                          var de = ce[0];
                          i(de.x0) && i(de.y0) && (se = fe(de), (!K.hLinePoint || K.hLinePoint.spikeDistance > se.spikeDistance) && (K.hLinePoint = se));
                        }
                      }
                    }
                  }
                  function he(e, t) {
                    for (var n, r = null, i = 1 / 0, o = 0; o < e.length; o++) (n = e[o].spikeDistance) < i && n <= t && (r = e[o], i = n);
                    return r;
                  }
                  function fe(e) {
                    return e ? {
                      xa: e.xa,
                      ya: e.ya,
                      x: void 0 !== e.xSpike ? e.xSpike : (e.x0 + e.x1) / 2,
                      y: void 0 !== e.ySpike ? e.ySpike : (e.y0 + e.y1) / 2,
                      distance: e.distance,
                      spikeDistance: e.spikeDistance,
                      curveNumber: e.trace.index,
                      color: e.color,
                      pointNumber: e.index
                    } : null;
                  }
                  var pe = {
                      fullLayout: c,
                      container: c._hoverlayer,
                      outerContainer: c._paperdiv,
                      event: t
                    },
                    me = e._spikepoints,
                    ge = {
                      vLinePoint: K.vLinePoint,
                      hLinePoint: K.hLinePoint
                    };
                  if (e._spikepoints = ge, v && 0 !== $ && 0 !== X.length) {
                    var ve = he(X.filter(function (e) {
                      return e.ya.showspikes;
                    }), $);
                    K.hLinePoint = fe(ve);
                    var ye = he(X.filter(function (e) {
                      return e.xa.showspikes;
                    }), $);
                    K.vLinePoint = fe(ye);
                  }
                  if (0 === X.length) {
                    var be = h.unhoverRaw(e, t);
                    return !v || null === K.hLinePoint && null === K.vLinePoint || k(me) && C(e, K, pe), be;
                  }
                  v && k(me) && C(e, K, pe), X.sort(function (e, t) {
                    return e.distance - t.distance;
                  });
                  var _e = e._hoverdata,
                    xe = [];
                  for (N = 0; N < X.length; N++) {
                    var we = X[N],
                      Se = m.makeEventData(we, we.trace, we.cd);
                    if (!1 !== we.hovertemplate) {
                      var Ae = !1;
                      we.cd[we.index] && we.cd[we.index].ht && (Ae = we.cd[we.index].ht), we.hovertemplate = Ae || we.trace.hovertemplate || !1;
                    }
                    we.eventData = [Se], xe.push(Se);
                  }
                  e._hoverdata = xe;
                  var Ee = "y" === R && (Y.length > 1 || X.length > 1) || "closest" === R && Z && X.length > 1,
                    Te = E(X, {
                      hovermode: R,
                      rotateLabels: Ee,
                      bgColor: d.combine(c.plot_bgcolor || d.background, c.paper_bgcolor),
                      container: c._hoverlayer,
                      outerContainer: c._paperdiv,
                      commonLabelOpts: c.hoverlabel,
                      hoverdistance: c.hoverdistance
                    }, e);
                  if (function (e, t, n) {
                    var r,
                      i,
                      o,
                      a,
                      s,
                      l,
                      u,
                      c = 0,
                      d = 1,
                      h = e.size(),
                      f = new Array(h),
                      p = 0;
                    function m(e) {
                      var t = e[0],
                        n = e[e.length - 1];
                      if (i = t.pmin - t.pos - t.dp + t.size, o = n.pos + n.dp + n.size - t.pmax, i > .01) {
                        for (s = e.length - 1; s >= 0; s--) e[s].dp += i;
                        r = !1;
                      }
                      if (!(o < .01)) {
                        if (i < -.01) {
                          for (s = e.length - 1; s >= 0; s--) e[s].dp -= o;
                          r = !1;
                        }
                        if (r) {
                          var u = 0;
                          for (a = 0; a < e.length; a++) (l = e[a]).pos + l.dp + l.size > t.pmax && u++;
                          for (a = e.length - 1; a >= 0 && !(u <= 0); a--) (l = e[a]).pos > t.pmax - 1 && (l.del = !0, u--);
                          for (a = 0; a < e.length && !(u <= 0); a++) if ((l = e[a]).pos < t.pmin + 1) for (l.del = !0, u--, o = 2 * l.size, s = e.length - 1; s >= 0; s--) e[s].dp -= o;
                          for (a = e.length - 1; a >= 0 && !(u <= 0); a--) (l = e[a]).pos + l.dp + l.size > t.pmax && (l.del = !0, u--);
                        }
                      }
                    }
                    for (e.each(function (e) {
                      var r = e[t],
                        i = "x" === r._id.charAt(0),
                        o = r.range;
                      0 === p && o && o[0] > o[1] !== i && (d = -1), f[p++] = [{
                        datum: e,
                        traceIndex: e.trace.index,
                        dp: 0,
                        pos: e.pos,
                        posref: e.posref,
                        size: e.by * (i ? b : 1) / 2,
                        pmin: 0,
                        pmax: i ? n.width : n.height
                      }];
                    }), f.sort(function (e, t) {
                      return e[0].posref - t[0].posref || d * (t[0].traceIndex - e[0].traceIndex);
                    }); !r && c <= h;) {
                      for (c++, r = !0, a = 0; a < f.length - 1;) {
                        var g = f[a],
                          v = f[a + 1],
                          y = g[g.length - 1],
                          _ = v[0];
                        if ((i = y.pos + y.dp + y.size - _.pos - _.dp + _.size) > .01 && y.pmin === _.pmin && y.pmax === _.pmax) {
                          for (s = v.length - 1; s >= 0; s--) v[s].dp += i;
                          for (g.push.apply(g, v), f.splice(a + 1, 1), u = 0, s = g.length - 1; s >= 0; s--) u += g[s].dp;
                          for (o = u / g.length, s = g.length - 1; s >= 0; s--) g[s].dp -= o;
                          r = !1;
                        } else a++;
                      }
                      f.forEach(m);
                    }
                    for (a = f.length - 1; a >= 0; a--) {
                      var x = f[a];
                      for (s = x.length - 1; s >= 0; s--) {
                        var w = x[s],
                          S = w.datum;
                        S.offset = w.dp, S.del = w.del;
                      }
                    }
                  }(Te, Ee ? "xa" : "ya", c), T(Te, Ee), t.target && t.target.tagName) {
                    var Me = p.getComponentMethod("annotations", "hasClickToShow")(e, xe);
                    u(r.select(t.target), Me ? "pointer" : "");
                  }
                  t.target && !o && function (e, t, n) {
                    if (!n || n.length !== e._hoverdata.length) return !0;
                    for (var r = n.length - 1; r >= 0; r--) {
                      var i = n[r],
                        o = e._hoverdata[r];
                      if (i.curveNumber !== o.curveNumber || String(i.pointNumber) !== String(o.pointNumber) || String(i.pointNumbers) !== String(o.pointNumbers)) return !0;
                    }
                    return !1;
                  }(e, 0, _e) && (_e && e.emit("plotly_unhover", {
                    event: t,
                    points: _e
                  }), e.emit("plotly_hover", {
                    event: t,
                    points: e._hoverdata,
                    xaxes: x,
                    yaxes: w,
                    xvals: I,
                    yvals: j
                  }));
                }(e, t, n, o);
              });
            }, n.loneHover = function (e, t) {
              var n = !0;
              Array.isArray(e) || (n = !1, e = [e]);
              var i = e.map(function (e) {
                  return {
                    color: e.color || d.defaultLine,
                    x0: e.x0 || e.x || 0,
                    x1: e.x1 || e.x || 0,
                    y0: e.y0 || e.y || 0,
                    y1: e.y1 || e.y || 0,
                    xLabel: e.xLabel,
                    yLabel: e.yLabel,
                    zLabel: e.zLabel,
                    text: e.text,
                    name: e.name,
                    idealAlign: e.idealAlign,
                    borderColor: e.borderColor,
                    fontFamily: e.fontFamily,
                    fontSize: e.fontSize,
                    fontColor: e.fontColor,
                    nameLength: e.nameLength,
                    textAlign: e.textAlign,
                    trace: e.trace || {
                      index: 0,
                      hoverinfo: ""
                    },
                    xa: {
                      _offset: 0
                    },
                    ya: {
                      _offset: 0
                    },
                    index: 0,
                    hovertemplate: e.hovertemplate || !1,
                    eventData: e.eventData || !1,
                    hovertemplateLabels: e.hovertemplateLabels || !1
                  };
                }),
                o = r.select(t.container),
                a = t.outerContainer ? r.select(t.outerContainer) : o,
                s = {
                  hovermode: "closest",
                  rotateLabels: !1,
                  bgColor: t.bgColor || d.background,
                  container: o,
                  outerContainer: a
                },
                l = E(i, s, t.gd),
                u = 0,
                c = 0;
              return l.sort(function (e, t) {
                return e.y0 - t.y0;
              }).each(function (e, n) {
                var r = e.y0 - e.by / 2;
                e.offset = r - 5 < u ? u - r + 5 : 0, u = r + e.by + e.offset, n === t.anchorIndex && (c = e.offset);
              }).each(function (e) {
                e.offset -= c;
              }), T(l, s.rotateLabels), n ? l : l.node();
            };
            var A = /<extra>([\s\S]*)<\/extra>/;
            function E(e, t, n) {
              var i = n._fullLayout,
                o = t.hovermode,
                s = t.rotateLabels,
                u = t.bgColor,
                h = t.container,
                f = t.outerContainer,
                p = t.commonLabelOpts || {},
                m = t.fontFamily || g.HOVERFONT,
                y = t.fontSize || g.HOVERFONTSIZE,
                b = e[0],
                _ = b.xa,
                x = b.ya,
                E = "y" === o ? "yLabel" : "xLabel",
                T = b[E],
                M = (String(T) || "").split(" ")[0],
                C = f.node().getBoundingClientRect(),
                k = C.top,
                O = C.width,
                R = C.height,
                I = void 0 !== T && b.distance <= t.hoverdistance && ("x" === o || "y" === o);
              if (I) {
                var j,
                  N,
                  L = !0;
                for (j = 0; j < e.length; j++) if (L && void 0 === e[j].zLabel && (L = !1), N = e[j].hoverinfo || e[j].trace.hoverinfo) {
                  var D = Array.isArray(N) ? N : N.split("+");
                  if (-1 === D.indexOf("all") && -1 === D.indexOf(o)) {
                    I = !1;
                    break;
                  }
                }
                L && (I = !1);
              }
              var B = h.selectAll("g.axistext").data(I ? [0] : []);
              B.enter().append("g").classed("axistext", !0), B.exit().remove(), B.each(function () {
                var t = r.select(this),
                  s = a.ensureSingle(t, "path", "", function (e) {
                    e.style({
                      "stroke-width": "1px"
                    });
                  }),
                  u = a.ensureSingle(t, "text", "", function (e) {
                    e.attr("data-notex", 1);
                  }),
                  h = p.bgcolor || d.defaultLine,
                  f = p.bordercolor || d.contrast(h),
                  g = d.contrast(h),
                  v = {
                    family: p.font.family || m,
                    size: p.font.size || y,
                    color: p.font.color || g
                  };
                s.style({
                  fill: h,
                  stroke: f
                }), u.text(T).call(c.font, v).call(l.positionText, 0, 0).call(l.convertToTspans, n), t.attr("transform", "");
                var A,
                  C,
                  P = u.node().getBoundingClientRect();
                if ("x" === o) {
                  var O = "top" === _.side ? "-" : "";
                  u.attr("text-anchor", "middle").call(l.positionText, 0, "top" === _.side ? k - P.bottom - w - S : k - P.top + w + S), A = _._offset + (b.x0 + b.x1) / 2, C = x._offset + ("top" === _.side ? 0 : x._length);
                  var R = P.width / 2 + S;
                  A < R ? (A = R, s.attr("d", "M-" + (R - w) + ",0L-" + (R - 2 * w) + "," + O + w + "H" + (S + P.width / 2) + "v" + O + (2 * S + P.height) + "H-" + R + "V" + O + w + "Z")) : A > i.width - R ? (A = i.width - R, s.attr("d", "M" + (R - w) + ",0L" + R + "," + O + w + "v" + O + (2 * S + P.height) + "H-" + R + "V" + O + w + "H" + (R - 2 * w) + "Z")) : s.attr("d", "M0,0L" + w + "," + O + w + "H" + (S + P.width / 2) + "v" + O + (2 * S + P.height) + "H-" + (S + P.width / 2) + "V" + O + w + "H-" + w + "Z");
                } else {
                  var I, j, N;
                  "right" === x.side ? (I = "start", j = 1, N = "", A = _._offset + _._length) : (I = "end", j = -1, N = "-", A = _._offset), C = x._offset + (b.y0 + b.y1) / 2, u.attr("text-anchor", I), s.attr("d", "M0,0L" + N + w + "," + w + "V" + (S + P.height / 2) + "h" + N + (2 * S + P.width) + "V-" + (S + P.height / 2) + "H" + N + w + "V-" + w + "Z");
                  var L,
                    D = P.height / 2,
                    B = k - P.top - D,
                    F = "clip" + i._uid + "commonlabel" + x._id;
                  if (A < P.width + 2 * S + w) {
                    L = "M-" + (w + S) + "-" + D + "h-" + (P.width - S) + "V" + D + "h" + (P.width - S) + "Z";
                    var z = P.width - A + S;
                    l.positionText(u, z, B), "end" === I && u.selectAll("tspan").each(function () {
                      var e = r.select(this),
                        t = c.tester.append("text").text(e.text()).call(c.font, v),
                        n = t.node().getBoundingClientRect();
                      Math.round(n.width) < Math.round(P.width) && e.attr("x", z - n.width), t.remove();
                    });
                  } else l.positionText(u, j * (S + w), B), L = null;
                  var U = i._topclips.selectAll("#" + F).data(L ? [0] : []);
                  U.enter().append("clipPath").attr("id", F).append("path"), U.exit().remove(), U.select("path").attr("d", L), c.setClipUrl(u, L ? F : null, n);
                }
                t.attr("transform", "translate(" + A + "," + C + ")"), e = e.filter(function (e) {
                  return void 0 !== e.zLabelVal || (e[E] || "").split(" ")[0] === M;
                });
              });
              var F = h.selectAll("g.hovertext").data(e, function (e) {
                return [e.trace.index, e.index, e.x0, e.y0, e.name, e.attr, e.xa, e.ya || ""].join(",");
              });
              return F.enter().append("g").classed("hovertext", !0).each(function () {
                var e = r.select(this);
                e.append("rect").call(d.fill, d.addOpacity(u, .8)), e.append("text").classed("name", !0), e.append("path").style("stroke-width", "1px"), e.append("text").classed("nums", !0).call(c.font, m, y);
              }), F.exit().remove(), F.each(function (e) {
                var t = r.select(this).attr("transform", ""),
                  h = "",
                  f = "",
                  p = e.bgcolor || e.color,
                  g = d.combine(d.opacity(p) ? p : d.defaultLine, u),
                  b = d.combine(d.opacity(e.color) ? e.color : d.defaultLine, u),
                  _ = e.borderColor || d.contrast(g);
                void 0 !== e.nameOverride && (e.name = e.nameOverride), e.name && (e.trace._meta && (e.name = a.templateString(e.name, e.trace._meta)), h = P(e.name, e.nameLength)), void 0 !== e.zLabel ? (void 0 !== e.xLabel && (f += "x: " + e.xLabel + "<br>"), void 0 !== e.yLabel && (f += "y: " + e.yLabel + "<br>"), "choropleth" !== e.trace.type && "choroplethmapbox" !== e.trace.type && (f += (f ? "z: " : "") + e.zLabel)) : I && e[o + "Label"] === T ? f = e[("x" === o ? "y" : "x") + "Label"] || "" : void 0 === e.xLabel ? void 0 !== e.yLabel && "scattercarpet" !== e.trace.type && (f = e.yLabel) : f = void 0 === e.yLabel ? e.xLabel : "(" + e.xLabel + ", " + e.yLabel + ")", !e.text && 0 !== e.text || Array.isArray(e.text) || (f += (f ? "<br>" : "") + e.text), void 0 !== e.extraText && (f += (f ? "<br>" : "") + e.extraText), "" !== f || e.hovertemplate || ("" === h && t.remove(), f = h);
                var x = i._d3locale,
                  E = e.hovertemplate || !1,
                  M = e.hovertemplateLabels || e,
                  C = e.eventData[0] || {};
                E && (f = (f = a.hovertemplateString(E, M, x, C, e.trace._meta)).replace(A, function (t, n) {
                  return h = P(n, e.nameLength), "";
                }));
                var j = t.select("text.nums").call(c.font, e.fontFamily || m, e.fontSize || y, e.fontColor || _).text(f).attr("data-notex", 1).call(l.positionText, 0, 0).call(l.convertToTspans, n),
                  N = t.select("text.name"),
                  L = 0,
                  D = 0;
                if (h && h !== f) {
                  N.call(c.font, e.fontFamily || m, e.fontSize || y, b).text(h).attr("data-notex", 1).call(l.positionText, 0, 0).call(l.convertToTspans, n);
                  var B = N.node().getBoundingClientRect();
                  L = B.width + 2 * S, D = B.height + 2 * S;
                } else N.remove(), t.select("rect").remove();
                t.select("path").style({
                  fill: g,
                  stroke: _
                });
                var F,
                  z,
                  U = j.node().getBoundingClientRect(),
                  G = e.xa._offset + (e.x0 + e.x1) / 2,
                  V = e.ya._offset + (e.y0 + e.y1) / 2,
                  H = Math.abs(e.x1 - e.x0),
                  q = Math.abs(e.y1 - e.y0),
                  W = U.width + w + S + L;
                if (e.ty0 = k - U.top, e.bx = U.width + 2 * S, e.by = Math.max(U.height + 2 * S, D), e.anchor = "start", e.txwidth = U.width, e.tx2width = L, e.offset = 0, s) e.pos = G, F = V + q / 2 + W <= R, z = V - q / 2 - W >= 0, "top" !== e.idealAlign && F || !z ? F ? (V += q / 2, e.anchor = "start") : e.anchor = "middle" : (V -= q / 2, e.anchor = "end");else if (e.pos = V, F = G + H / 2 + W <= O, z = G - H / 2 - W >= 0, "left" !== e.idealAlign && F || !z) {
                  if (F) G += H / 2, e.anchor = "start";else {
                    e.anchor = "middle";
                    var $ = W / 2,
                      X = G + $ - O,
                      Y = G - $;
                    X > 0 && (G -= X), Y < 0 && (G += -Y);
                  }
                } else G -= H / 2, e.anchor = "end";
                j.attr("text-anchor", e.anchor), L && N.attr("text-anchor", e.anchor), t.attr("transform", "translate(" + G + "," + V + ")" + (s ? "rotate(" + v + ")" : ""));
              }), F;
            }
            function T(e, t) {
              e.each(function (e) {
                var n = r.select(this);
                if (e.del) return n.remove();
                var i = n.select("text.nums"),
                  o = e.anchor,
                  a = "end" === o ? -1 : 1,
                  s = {
                    start: 1,
                    end: -1,
                    middle: 0
                  }[o],
                  u = s * (w + S),
                  d = u + s * (e.txwidth + S),
                  h = 0,
                  f = e.offset;
                "middle" === o && (u -= e.tx2width / 2, d += e.txwidth / 2 + S), t && (f *= -x, h = e.offset * _), n.select("path").attr("d", "middle" === o ? "M-" + (e.bx / 2 + e.tx2width / 2) + "," + (f - e.by / 2) + "h" + e.bx + "v" + e.by + "h-" + e.bx + "Z" : "M0,0L" + (a * w + h) + "," + (w + f) + "v" + (e.by / 2 - w) + "h" + a * e.bx + "v-" + e.by + "H" + (a * w + h) + "V" + (f - w) + "Z");
                var p = u + h,
                  m = f + e.ty0 - e.by / 2 + S,
                  g = e.textAlign || "auto";
                "auto" !== g && ("left" === g && "start" !== o ? (i.attr("text-anchor", "start"), p = "middle" === o ? -e.bx / 2 - e.tx2width / 2 + S : -e.bx - S) : "right" === g && "end" !== o && (i.attr("text-anchor", "end"), p = "middle" === o ? e.bx / 2 - e.tx2width / 2 - S : e.bx + S)), i.call(l.positionText, p, m), e.tx2width && (n.select("text.name").call(l.positionText, d + s * S + h, f + e.ty0 - e.by / 2 + S), n.select("rect").call(c.setRect, d + (s - 1) * e.tx2width / 2 + h, f - e.by / 2 - 1, e.tx2width, e.by + 2));
              });
            }
            function M(e, t) {
              var n = e.index,
                r = e.trace || {},
                o = e.cd[0],
                s = e.cd[n] || {};
              function l(e) {
                return e || i(e) && 0 === e;
              }
              var u = Array.isArray(n) ? function (e, t) {
                var i = a.castOption(o, n, e);
                return l(i) ? i : a.extractOption({}, r, "", t);
              } : function (e, t) {
                return a.extractOption(s, r, e, t);
              };
              function c(t, n, r) {
                var i = u(n, r);
                l(i) && (e[t] = i);
              }
              if (c("hoverinfo", "hi", "hoverinfo"), c("bgcolor", "hbg", "hoverlabel.bgcolor"), c("borderColor", "hbc", "hoverlabel.bordercolor"), c("fontFamily", "htf", "hoverlabel.font.family"), c("fontSize", "hts", "hoverlabel.font.size"), c("fontColor", "htc", "hoverlabel.font.color"), c("nameLength", "hnl", "hoverlabel.namelength"), c("textAlign", "hta", "hoverlabel.align"), e.posref = "y" === t || "closest" === t && "h" === r.orientation ? e.xa._offset + (e.x0 + e.x1) / 2 : e.ya._offset + (e.y0 + e.y1) / 2, e.x0 = a.constrain(e.x0, 0, e.xa._length), e.x1 = a.constrain(e.x1, 0, e.xa._length), e.y0 = a.constrain(e.y0, 0, e.ya._length), e.y1 = a.constrain(e.y1, 0, e.ya._length), void 0 !== e.xLabelVal && (e.xLabel = "xLabel" in e ? e.xLabel : f.hoverLabelText(e.xa, e.xLabelVal), e.xVal = e.xa.c2d(e.xLabelVal)), void 0 !== e.yLabelVal && (e.yLabel = "yLabel" in e ? e.yLabel : f.hoverLabelText(e.ya, e.yLabelVal), e.yVal = e.ya.c2d(e.yLabelVal)), void 0 !== e.zLabelVal && void 0 === e.zLabel && (e.zLabel = String(e.zLabelVal)), !(isNaN(e.xerr) || "log" === e.xa.type && e.xerr <= 0)) {
                var d = f.tickText(e.xa, e.xa.c2l(e.xerr), "hover").text;
                void 0 !== e.xerrneg ? e.xLabel += " +" + d + " / -" + f.tickText(e.xa, e.xa.c2l(e.xerrneg), "hover").text : e.xLabel += " ± " + d, "x" === t && (e.distance += 1);
              }
              if (!(isNaN(e.yerr) || "log" === e.ya.type && e.yerr <= 0)) {
                var h = f.tickText(e.ya, e.ya.c2l(e.yerr), "hover").text;
                void 0 !== e.yerrneg ? e.yLabel += " +" + h + " / -" + f.tickText(e.ya, e.ya.c2l(e.yerrneg), "hover").text : e.yLabel += " ± " + h, "y" === t && (e.distance += 1);
              }
              var p = e.hoverinfo || e.trace.hoverinfo;
              return p && "all" !== p && (-1 === (p = Array.isArray(p) ? p : p.split("+")).indexOf("x") && (e.xLabel = void 0), -1 === p.indexOf("y") && (e.yLabel = void 0), -1 === p.indexOf("z") && (e.zLabel = void 0), -1 === p.indexOf("text") && (e.text = void 0), -1 === p.indexOf("name") && (e.name = void 0)), e;
            }
            function C(e, t, n) {
              var r,
                i,
                a = n.container,
                s = n.fullLayout,
                l = s._size,
                u = n.event,
                h = !!t.hLinePoint,
                p = !!t.vLinePoint;
              if (a.selectAll(".spikeline").remove(), p || h) {
                var m = d.combine(s.plot_bgcolor, s.paper_bgcolor);
                if (h) {
                  var g,
                    v,
                    y = t.hLinePoint;
                  r = y && y.xa, "cursor" === (i = y && y.ya).spikesnap ? (g = u.pointerX, v = u.pointerY) : (g = r._offset + y.x, v = i._offset + y.y);
                  var b,
                    _,
                    x = o.readability(y.color, m) < 1.5 ? d.contrast(m) : y.color,
                    w = i.spikemode,
                    S = i.spikethickness,
                    A = i.spikecolor || x,
                    E = f.getPxPosition(e, i);
                  if (-1 !== w.indexOf("toaxis") || -1 !== w.indexOf("across")) {
                    if (-1 !== w.indexOf("toaxis") && (b = E, _ = g), -1 !== w.indexOf("across")) {
                      var T = i._counterDomainMin,
                        M = i._counterDomainMax;
                      "free" === i.anchor && (T = Math.min(T, i.position), M = Math.max(M, i.position)), b = l.l + T * l.w, _ = l.l + M * l.w;
                    }
                    a.insert("line", ":first-child").attr({
                      x1: b,
                      x2: _,
                      y1: v,
                      y2: v,
                      "stroke-width": S,
                      stroke: A,
                      "stroke-dasharray": c.dashStyle(i.spikedash, S)
                    }).classed("spikeline", !0).classed("crisp", !0), a.insert("line", ":first-child").attr({
                      x1: b,
                      x2: _,
                      y1: v,
                      y2: v,
                      "stroke-width": S + 2,
                      stroke: m
                    }).classed("spikeline", !0).classed("crisp", !0);
                  }
                  -1 !== w.indexOf("marker") && a.insert("circle", ":first-child").attr({
                    cx: E + ("right" !== i.side ? S : -S),
                    cy: v,
                    r: S,
                    fill: A
                  }).classed("spikeline", !0);
                }
                if (p) {
                  var C,
                    k,
                    P = t.vLinePoint;
                  r = P && P.xa, i = P && P.ya, "cursor" === r.spikesnap ? (C = u.pointerX, k = u.pointerY) : (C = r._offset + P.x, k = i._offset + P.y);
                  var O,
                    R,
                    I = o.readability(P.color, m) < 1.5 ? d.contrast(m) : P.color,
                    j = r.spikemode,
                    N = r.spikethickness,
                    L = r.spikecolor || I,
                    D = f.getPxPosition(e, r);
                  if (-1 !== j.indexOf("toaxis") || -1 !== j.indexOf("across")) {
                    if (-1 !== j.indexOf("toaxis") && (O = D, R = k), -1 !== j.indexOf("across")) {
                      var B = r._counterDomainMin,
                        F = r._counterDomainMax;
                      "free" === r.anchor && (B = Math.min(B, r.position), F = Math.max(F, r.position)), O = l.t + (1 - F) * l.h, R = l.t + (1 - B) * l.h;
                    }
                    a.insert("line", ":first-child").attr({
                      x1: C,
                      x2: C,
                      y1: O,
                      y2: R,
                      "stroke-width": N,
                      stroke: L,
                      "stroke-dasharray": c.dashStyle(r.spikedash, N)
                    }).classed("spikeline", !0).classed("crisp", !0), a.insert("line", ":first-child").attr({
                      x1: C,
                      x2: C,
                      y1: O,
                      y2: R,
                      "stroke-width": N + 2,
                      stroke: m
                    }).classed("spikeline", !0).classed("crisp", !0);
                  }
                  -1 !== j.indexOf("marker") && a.insert("circle", ":first-child").attr({
                    cx: C,
                    cy: D - ("top" !== r.side ? N : -N),
                    r: N,
                    fill: L
                  }).classed("spikeline", !0);
                }
              }
            }
            function k(e, t) {
              return !t || t.vLinePoint !== e._spikepoints.vLinePoint || t.hLinePoint !== e._spikepoints.hLinePoint;
            }
            function P(e, t) {
              return l.plainText(e || "", {
                len: t,
                allowedTags: ["br", "sub", "sup", "b", "i", "em"]
              });
            }
          }, {
            "../../lib": 495,
            "../../lib/events": 488,
            "../../lib/override_cursor": 506,
            "../../lib/svg_text_utils": 518,
            "../../plots/cartesian/axes": 541,
            "../../registry": 593,
            "../color": 375,
            "../dragelement": 393,
            "../drawing": 396,
            "./constants": 408,
            "./helpers": 410,
            d3: 82,
            "fast-isnumeric": 91,
            tinycolor2: 341
          }],
          412: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            t.exports = function (e, t, n, i) {
              n("hoverlabel.bgcolor", (i = i || {}).bgcolor), n("hoverlabel.bordercolor", i.bordercolor), n("hoverlabel.namelength", i.namelength), r.coerceFont(n, "hoverlabel.font", i.font), n("hoverlabel.align", i.align);
            };
          }, {
            "../../lib": 495
          }],
          413: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../lib"),
              o = e("../dragelement"),
              a = e("./helpers"),
              s = e("./layout_attributes"),
              l = e("./hover");
            t.exports = {
              moduleType: "component",
              name: "fx",
              constants: e("./constants"),
              schema: {
                layout: s
              },
              attributes: e("./attributes"),
              layoutAttributes: s,
              supplyLayoutGlobalDefaults: e("./layout_global_defaults"),
              supplyDefaults: e("./defaults"),
              supplyLayoutDefaults: e("./layout_defaults"),
              calc: e("./calc"),
              getDistanceFunction: a.getDistanceFunction,
              getClosest: a.getClosest,
              inbox: a.inbox,
              quadrature: a.quadrature,
              appendArrayPointValue: a.appendArrayPointValue,
              castHoverOption: function castHoverOption(e, t, n) {
                return i.castOption(e, t, "hoverlabel." + n);
              },
              castHoverinfo: function castHoverinfo(e, t, n) {
                return i.castOption(e, n, "hoverinfo", function (n) {
                  return i.coerceHoverinfo({
                    hoverinfo: n
                  }, {
                    _module: e._module
                  }, t);
                });
              },
              hover: l.hover,
              unhover: o.unhover,
              loneHover: l.loneHover,
              loneUnhover: function loneUnhover(e) {
                var t = i.isD3Selection(e) ? e : r.select(e);
                t.selectAll("g.hovertext").remove(), t.selectAll(".spikeline").remove();
              },
              click: e("./click")
            };
          }, {
            "../../lib": 495,
            "../dragelement": 393,
            "./attributes": 405,
            "./calc": 406,
            "./click": 407,
            "./constants": 408,
            "./defaults": 409,
            "./helpers": 410,
            "./hover": 411,
            "./layout_attributes": 414,
            "./layout_defaults": 415,
            "./layout_global_defaults": 416,
            d3: 82
          }],
          414: [function (e, t, n) {
            "use strict";

            var r = e("./constants"),
              i = e("../../plots/font_attributes")({
                editType: "none"
              });
            i.family.dflt = r.HOVERFONT, i.size.dflt = r.HOVERFONTSIZE, t.exports = {
              clickmode: {
                valType: "flaglist",
                flags: ["event", "select"],
                dflt: "event",
                editType: "plot",
                extras: ["none"]
              },
              dragmode: {
                valType: "enumerated",
                values: ["zoom", "pan", "select", "lasso", "orbit", "turntable", !1],
                dflt: "zoom",
                editType: "modebar"
              },
              hovermode: {
                valType: "enumerated",
                values: ["x", "y", "closest", !1],
                editType: "modebar"
              },
              hoverdistance: {
                valType: "integer",
                min: -1,
                dflt: 20,
                editType: "none"
              },
              spikedistance: {
                valType: "integer",
                min: -1,
                dflt: 20,
                editType: "none"
              },
              hoverlabel: {
                bgcolor: {
                  valType: "color",
                  editType: "none"
                },
                bordercolor: {
                  valType: "color",
                  editType: "none"
                },
                font: i,
                align: {
                  valType: "enumerated",
                  values: ["left", "right", "auto"],
                  dflt: "auto",
                  editType: "none"
                },
                namelength: {
                  valType: "integer",
                  min: -1,
                  dflt: 15,
                  editType: "none"
                },
                editType: "none"
              },
              selectdirection: {
                valType: "enumerated",
                values: ["h", "v", "d", "any"],
                dflt: "any",
                editType: "none"
              }
            };
          }, {
            "../../plots/font_attributes": 567,
            "./constants": 408
          }],
          415: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./layout_attributes");
            t.exports = function (e, t, n) {
              function o(n, o) {
                return r.coerce(e, t, i, n, o);
              }
              var a,
                s = o("clickmode");
              "select" === o("dragmode") && o("selectdirection"), t._has("cartesian") ? s.indexOf("select") > -1 ? a = "closest" : (t._isHoriz = function (e, t) {
                for (var n = t._scatterStackOpts || {}, r = 0; r < e.length; r++) {
                  var i = e[r],
                    o = (n[i.xaxis + i.yaxis] || {})[i.stackgroup] || {};
                  if ("h" !== i.orientation && "h" !== o.orientation) return !1;
                }
                return !0;
              }(n, t), a = t._isHoriz ? "y" : "x") : a = "closest", o("hovermode", a) && (o("hoverdistance"), o("spikedistance"));
              var l = t._has("mapbox"),
                u = t._has("geo"),
                c = t._basePlotModules.length;
              "zoom" === t.dragmode && ((l || u) && 1 === c || l && u && 2 === c) && (t.dragmode = "pan");
            };
          }, {
            "../../lib": 495,
            "./layout_attributes": 414
          }],
          416: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./hoverlabel_defaults"),
              o = e("./layout_attributes");
            t.exports = function (e, t) {
              i(e, t, function (n, i) {
                return r.coerce(e, t, o, n, i);
              });
            };
          }, {
            "../../lib": 495,
            "./hoverlabel_defaults": 412,
            "./layout_attributes": 414
          }],
          417: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../lib/regex").counter,
              o = e("../../plots/domain").attributes,
              a = e("../../plots/cartesian/constants").idRegex,
              s = e("../../plot_api/plot_template"),
              l = {
                rows: {
                  valType: "integer",
                  min: 1,
                  editType: "plot"
                },
                roworder: {
                  valType: "enumerated",
                  values: ["top to bottom", "bottom to top"],
                  dflt: "top to bottom",
                  editType: "plot"
                },
                columns: {
                  valType: "integer",
                  min: 1,
                  editType: "plot"
                },
                subplots: {
                  valType: "info_array",
                  freeLength: !0,
                  dimensions: 2,
                  items: {
                    valType: "enumerated",
                    values: [i("xy").toString(), ""],
                    editType: "plot"
                  },
                  editType: "plot"
                },
                xaxes: {
                  valType: "info_array",
                  freeLength: !0,
                  items: {
                    valType: "enumerated",
                    values: [a.x.toString(), ""],
                    editType: "plot"
                  },
                  editType: "plot"
                },
                yaxes: {
                  valType: "info_array",
                  freeLength: !0,
                  items: {
                    valType: "enumerated",
                    values: [a.y.toString(), ""],
                    editType: "plot"
                  },
                  editType: "plot"
                },
                pattern: {
                  valType: "enumerated",
                  values: ["independent", "coupled"],
                  dflt: "coupled",
                  editType: "plot"
                },
                xgap: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: "plot"
                },
                ygap: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: "plot"
                },
                domain: o({
                  name: "grid",
                  editType: "plot",
                  noGridCell: !0
                }, {}),
                xside: {
                  valType: "enumerated",
                  values: ["bottom", "bottom plot", "top plot", "top"],
                  dflt: "bottom plot",
                  editType: "plot"
                },
                yside: {
                  valType: "enumerated",
                  values: ["left", "left plot", "right plot", "right"],
                  dflt: "left plot",
                  editType: "plot"
                },
                editType: "plot"
              };
            function u(e, t, n) {
              var r = t[n + "axes"],
                i = Object.keys((e._splomAxes || {})[n] || {});
              return Array.isArray(r) ? r : i.length ? i : void 0;
            }
            function c(e, t, n, r, i, o) {
              var a = t(e + "gap", n),
                s = t("domain." + e);
              t(e + "side", r);
              for (var l = new Array(i), u = s[0], c = (s[1] - u) / (i - a), d = c * (1 - a), h = 0; h < i; h++) {
                var f = u + c * h;
                l[o ? i - 1 - h : h] = [f, f + d];
              }
              return l;
            }
            function d(e, t, n, r, i) {
              var o,
                a = new Array(n);
              function s(e, n) {
                -1 !== t.indexOf(n) && void 0 === r[n] ? (a[e] = n, r[n] = e) : a[e] = "";
              }
              if (Array.isArray(e)) for (o = 0; o < n; o++) s(o, e[o]);else for (s(0, i), o = 1; o < n; o++) s(o, i + (o + 1));
              return a;
            }
            t.exports = {
              moduleType: "component",
              name: "grid",
              schema: {
                layout: {
                  grid: l
                }
              },
              layoutAttributes: l,
              sizeDefaults: function sizeDefaults(e, t) {
                var n = e.grid || {},
                  i = u(t, n, "x"),
                  o = u(t, n, "y");
                if (e.grid || i || o) {
                  var a,
                    d,
                    h = Array.isArray(n.subplots) && Array.isArray(n.subplots[0]),
                    f = Array.isArray(i),
                    p = Array.isArray(o),
                    m = f && i !== n.xaxes && p && o !== n.yaxes;
                  h ? (a = n.subplots.length, d = n.subplots[0].length) : (p && (a = o.length), f && (d = i.length));
                  var g = s.newContainer(t, "grid"),
                    v = A("rows", a),
                    y = A("columns", d);
                  if (v * y > 1) {
                    h || f || p || "independent" === A("pattern") && (h = !0), g._hasSubplotGrid = h;
                    var b,
                      _,
                      x = "top to bottom" === A("roworder"),
                      w = h ? .2 : .1,
                      S = h ? .3 : .1;
                    m && t._splomGridDflt && (b = t._splomGridDflt.xside, _ = t._splomGridDflt.yside), g._domains = {
                      x: c("x", A, w, b, y),
                      y: c("y", A, S, _, v, x)
                    };
                  } else delete t.grid;
                }
                function A(e, t) {
                  return r.coerce(n, g, l, e, t);
                }
              },
              contentDefaults: function contentDefaults(e, t) {
                var n = t.grid;
                if (n && n._domains) {
                  var r,
                    i,
                    o,
                    a,
                    s,
                    l,
                    c,
                    h = e.grid || {},
                    f = t._subplots,
                    p = n._hasSubplotGrid,
                    m = n.rows,
                    g = n.columns,
                    v = "independent" === n.pattern,
                    y = n._axisMap = {};
                  if (p) {
                    var b = h.subplots || [];
                    l = n.subplots = new Array(m);
                    var _ = 1;
                    for (r = 0; r < m; r++) {
                      var x = l[r] = new Array(g),
                        w = b[r] || [];
                      for (i = 0; i < g; i++) if (v ? (s = 1 === _ ? "xy" : "x" + _ + "y" + _, _++) : s = w[i], x[i] = "", -1 !== f.cartesian.indexOf(s)) {
                        if (c = s.indexOf("y"), o = s.slice(0, c), a = s.slice(c), void 0 !== y[o] && y[o] !== i || void 0 !== y[a] && y[a] !== r) continue;
                        x[i] = s, y[o] = i, y[a] = r;
                      }
                    }
                  } else {
                    var S = u(t, h, "x"),
                      A = u(t, h, "y");
                    n.xaxes = d(S, f.xaxis, g, y, "x"), n.yaxes = d(A, f.yaxis, m, y, "y");
                  }
                  var E = n._anchors = {},
                    T = "top to bottom" === n.roworder;
                  for (var M in y) {
                    var C,
                      k,
                      P,
                      O = M.charAt(0),
                      R = n[O + "side"];
                    if (R.length < 8) E[M] = "free";else if ("x" === O) {
                      if ("t" === R.charAt(0) === T ? (C = 0, k = 1, P = m) : (C = m - 1, k = -1, P = -1), p) {
                        var I = y[M];
                        for (r = C; r !== P; r += k) if ((s = l[r][I]) && (c = s.indexOf("y"), s.slice(0, c) === M)) {
                          E[M] = s.slice(c);
                          break;
                        }
                      } else for (r = C; r !== P; r += k) if (a = n.yaxes[r], -1 !== f.cartesian.indexOf(M + a)) {
                        E[M] = a;
                        break;
                      }
                    } else if ("l" === R.charAt(0) ? (C = 0, k = 1, P = g) : (C = g - 1, k = -1, P = -1), p) {
                      var j = y[M];
                      for (r = C; r !== P; r += k) if ((s = l[j][r]) && (c = s.indexOf("y"), s.slice(c) === M)) {
                        E[M] = s.slice(0, c);
                        break;
                      }
                    } else for (r = C; r !== P; r += k) if (o = n.xaxes[r], -1 !== f.cartesian.indexOf(o + M)) {
                      E[M] = o;
                      break;
                    }
                  }
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../lib/regex": 510,
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/constants": 547,
            "../../plots/domain": 566
          }],
          418: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/cartesian/constants"),
              i = e("../../plot_api/plot_template").templatedArray;
            t.exports = i("image", {
              visible: {
                valType: "boolean",
                dflt: !0,
                editType: "arraydraw"
              },
              source: {
                valType: "string",
                editType: "arraydraw"
              },
              layer: {
                valType: "enumerated",
                values: ["below", "above"],
                dflt: "above",
                editType: "arraydraw"
              },
              sizex: {
                valType: "number",
                dflt: 0,
                editType: "arraydraw"
              },
              sizey: {
                valType: "number",
                dflt: 0,
                editType: "arraydraw"
              },
              sizing: {
                valType: "enumerated",
                values: ["fill", "contain", "stretch"],
                dflt: "contain",
                editType: "arraydraw"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 1,
                editType: "arraydraw"
              },
              x: {
                valType: "any",
                dflt: 0,
                editType: "arraydraw"
              },
              y: {
                valType: "any",
                dflt: 0,
                editType: "arraydraw"
              },
              xanchor: {
                valType: "enumerated",
                values: ["left", "center", "right"],
                dflt: "left",
                editType: "arraydraw"
              },
              yanchor: {
                valType: "enumerated",
                values: ["top", "middle", "bottom"],
                dflt: "top",
                editType: "arraydraw"
              },
              xref: {
                valType: "enumerated",
                values: ["paper", r.idRegex.x.toString()],
                dflt: "paper",
                editType: "arraydraw"
              },
              yref: {
                valType: "enumerated",
                values: ["paper", r.idRegex.y.toString()],
                dflt: "paper",
                editType: "arraydraw"
              },
              editType: "arraydraw"
            });
          }, {
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/constants": 547
          }],
          419: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib/to_log_range");
            t.exports = function (e, t, n, o) {
              t = t || {};
              var a = "log" === n && "linear" === t.type,
                s = "linear" === n && "log" === t.type;
              if (a || s) for (var l, u, c = e._fullLayout.images, d = t._id.charAt(0), h = 0; h < c.length; h++) if (u = "images[" + h + "].", (l = c[h])[d + "ref"] === t._id) {
                var f = l[d],
                  p = l["size" + d],
                  m = null,
                  g = null;
                if (a) {
                  m = i(f, t.range);
                  var v = p / Math.pow(10, m) / 2;
                  g = 2 * Math.log(v + Math.sqrt(1 + v * v)) / Math.LN10;
                } else g = (m = Math.pow(10, f)) * (Math.pow(10, p / 2) - Math.pow(10, -p / 2));
                r(m) ? r(g) || (g = null) : (m = null, g = null), o(u + d, m), o(u + "size" + d, g);
              }
            };
          }, {
            "../../lib/to_log_range": 520,
            "fast-isnumeric": 91
          }],
          420: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes"),
              o = e("../../plots/array_container_defaults"),
              a = e("./attributes");
            function s(e, t, n) {
              function o(n, i) {
                return r.coerce(e, t, a, n, i);
              }
              var s = o("source");
              if (!o("visible", !!s)) return t;
              o("layer"), o("xanchor"), o("yanchor"), o("sizex"), o("sizey"), o("sizing"), o("opacity");
              for (var l = {
                  _fullLayout: n
                }, u = ["x", "y"], c = 0; c < 2; c++) {
                var d = u[c],
                  h = i.coerceRef(e, t, l, d, "paper");
                "paper" !== h && i.getFromId(l, h)._imgIndices.push(t._index), i.coercePosition(t, l, o, h, d, 0);
              }
              return t;
            }
            t.exports = function (e, t) {
              o(e, t, {
                name: "images",
                handleItemDefaults: s
              });
            };
          }, {
            "../../lib": 495,
            "../../plots/array_container_defaults": 537,
            "../../plots/cartesian/axes": 541,
            "./attributes": 418
          }],
          421: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../drawing"),
              o = e("../../plots/cartesian/axes"),
              a = e("../../constants/xmlns_namespaces");
            t.exports = function (e) {
              var t,
                n,
                s = e._fullLayout,
                l = [],
                u = {},
                c = [];
              for (n = 0; n < s.images.length; n++) {
                var d = s.images[n];
                if (d.visible) if ("below" === d.layer && "paper" !== d.xref && "paper" !== d.yref) {
                  t = d.xref + d.yref;
                  var h = s._plots[t];
                  if (!h) {
                    c.push(d);
                    continue;
                  }
                  h.mainplot && (t = h.mainplot.id), u[t] || (u[t] = []), u[t].push(d);
                } else "above" === d.layer ? l.push(d) : c.push(d);
              }
              var f = {
                  left: {
                    sizing: "xMin",
                    offset: 0
                  },
                  center: {
                    sizing: "xMid",
                    offset: -.5
                  },
                  right: {
                    sizing: "xMax",
                    offset: -1
                  }
                },
                p = {
                  top: {
                    sizing: "YMin",
                    offset: 0
                  },
                  middle: {
                    sizing: "YMid",
                    offset: -.5
                  },
                  bottom: {
                    sizing: "YMax",
                    offset: -1
                  }
                };
              function m(t) {
                var n = r.select(this);
                if (this._imgSrc !== t.source) if (n.attr("xmlns", a.svg), t.source && "data:" === t.source.slice(0, 5)) n.attr("xlink:href", t.source), this._imgSrc = t.source;else {
                  var i = new Promise(function (e) {
                    var r = new Image();
                    function i() {
                      n.remove(), e();
                    }
                    this.img = r, r.setAttribute("crossOrigin", "anonymous"), r.onerror = i, r.onload = function () {
                      var t = document.createElement("canvas");
                      t.width = this.width, t.height = this.height, t.getContext("2d").drawImage(this, 0, 0);
                      var r = t.toDataURL("image/png");
                      n.attr("xlink:href", r), e();
                    }, n.on("error", i), r.src = t.source, this._imgSrc = t.source;
                  }.bind(this));
                  e._promises.push(i);
                }
              }
              function g(t) {
                var n = r.select(this),
                  a = o.getFromId(e, t.xref),
                  l = o.getFromId(e, t.yref),
                  u = s._size,
                  c = a ? Math.abs(a.l2p(t.sizex) - a.l2p(0)) : t.sizex * u.w,
                  d = l ? Math.abs(l.l2p(t.sizey) - l.l2p(0)) : t.sizey * u.h,
                  h = c * f[t.xanchor].offset,
                  m = d * p[t.yanchor].offset,
                  g = f[t.xanchor].sizing + p[t.yanchor].sizing,
                  v = (a ? a.r2p(t.x) + a._offset : t.x * u.w + u.l) + h,
                  y = (l ? l.r2p(t.y) + l._offset : u.h - t.y * u.h + u.t) + m;
                switch (t.sizing) {
                  case "fill":
                    g += " slice";
                    break;
                  case "stretch":
                    g = "none";
                }
                n.attr({
                  x: v,
                  y: y,
                  width: c,
                  height: d,
                  preserveAspectRatio: g,
                  opacity: t.opacity
                });
                var b = (a ? a._id : "") + (l ? l._id : "");
                i.setClipUrl(n, b ? "clip" + s._uid + b : null, e);
              }
              var v = s._imageLowerLayer.selectAll("image").data(c),
                y = s._imageUpperLayer.selectAll("image").data(l);
              v.enter().append("image"), y.enter().append("image"), v.exit().remove(), y.exit().remove(), v.each(function (e) {
                m.bind(this)(e), g.bind(this)(e);
              }), y.each(function (e) {
                m.bind(this)(e), g.bind(this)(e);
              });
              var b = Object.keys(s._plots);
              for (n = 0; n < b.length; n++) {
                t = b[n];
                var _ = s._plots[t];
                if (_.imagelayer) {
                  var x = _.imagelayer.selectAll("image").data(u[t] || []);
                  x.enter().append("image"), x.exit().remove(), x.each(function (e) {
                    m.bind(this)(e), g.bind(this)(e);
                  });
                }
              }
            };
          }, {
            "../../constants/xmlns_namespaces": 475,
            "../../plots/cartesian/axes": 541,
            "../drawing": 396,
            d3: 82
          }],
          422: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "component",
              name: "images",
              layoutAttributes: e("./attributes"),
              supplyLayoutDefaults: e("./defaults"),
              includeBasePlot: e("../../plots/cartesian/include_components")("images"),
              draw: e("./draw"),
              convertCoords: e("./convert_coords")
            };
          }, {
            "../../plots/cartesian/include_components": 551,
            "./attributes": 418,
            "./convert_coords": 419,
            "./defaults": 420,
            "./draw": 421
          }],
          423: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/font_attributes"),
              i = e("../color/attributes");
            t.exports = {
              bgcolor: {
                valType: "color",
                editType: "legend"
              },
              bordercolor: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "legend"
              },
              borderwidth: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "legend"
              },
              font: r({
                editType: "legend"
              }),
              orientation: {
                valType: "enumerated",
                values: ["v", "h"],
                dflt: "v",
                editType: "legend"
              },
              traceorder: {
                valType: "flaglist",
                flags: ["reversed", "grouped"],
                extras: ["normal"],
                editType: "legend"
              },
              tracegroupgap: {
                valType: "number",
                min: 0,
                dflt: 10,
                editType: "legend"
              },
              itemsizing: {
                valType: "enumerated",
                values: ["trace", "constant"],
                dflt: "trace",
                editType: "legend"
              },
              itemclick: {
                valType: "enumerated",
                values: ["toggle", "toggleothers", !1],
                dflt: "toggle",
                editType: "legend"
              },
              itemdoubleclick: {
                valType: "enumerated",
                values: ["toggle", "toggleothers", !1],
                dflt: "toggleothers",
                editType: "legend"
              },
              x: {
                valType: "number",
                min: -2,
                max: 3,
                editType: "legend"
              },
              xanchor: {
                valType: "enumerated",
                values: ["auto", "left", "center", "right"],
                dflt: "left",
                editType: "legend"
              },
              y: {
                valType: "number",
                min: -2,
                max: 3,
                editType: "legend"
              },
              yanchor: {
                valType: "enumerated",
                values: ["auto", "top", "middle", "bottom"],
                editType: "legend"
              },
              uirevision: {
                valType: "any",
                editType: "none"
              },
              valign: {
                valType: "enumerated",
                values: ["top", "middle", "bottom"],
                dflt: "middle",
                editType: "legend"
              },
              title: {
                text: {
                  valType: "string",
                  dflt: "",
                  editType: "legend"
                },
                font: r({
                  editType: "legend"
                }),
                side: {
                  valType: "enumerated",
                  values: ["top", "left", "top left"],
                  editType: "legend"
                },
                editType: "legend"
              },
              editType: "legend"
            };
          }, {
            "../../plots/font_attributes": 567,
            "../color/attributes": 374
          }],
          424: [function (e, t, n) {
            "use strict";

            t.exports = {
              scrollBarWidth: 6,
              scrollBarMinHeight: 20,
              scrollBarColor: "#808BA4",
              scrollBarMargin: 4,
              scrollBarEnterAttrs: {
                rx: 20,
                ry: 3,
                width: 0,
                height: 0
              },
              titlePad: 2,
              textGap: 40,
              itemGap: 5
            };
          }, {}],
          425: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib"),
              o = e("../../plot_api/plot_template"),
              a = e("./attributes"),
              s = e("../../plots/layout_attributes"),
              l = e("./helpers");
            t.exports = function (e, t, n) {
              for (var u = e.legend || {}, c = 0, d = !1, h = "normal", f = 0; f < n.length; f++) {
                var p = n[f];
                p.visible && ((p.showlegend || p._dfltShowLegend && !(p._module && p._module.attributes && p._module.attributes.showlegend && !1 === p._module.attributes.showlegend.dflt)) && (c++, p.showlegend && (d = !0, (r.traceIs(p, "pie-like") || !0 === p._input.showlegend) && c++)), (r.traceIs(p, "bar") && "stack" === t.barmode || -1 !== ["tonextx", "tonexty"].indexOf(p.fill)) && (h = l.isGrouped({
                  traceorder: h
                }) ? "grouped+reversed" : "reversed"), void 0 !== p.legendgroup && "" !== p.legendgroup && (h = l.isReversed({
                  traceorder: h
                }) ? "reversed+grouped" : "grouped"));
              }
              var m = i.coerce(e, t, s, "showlegend", d && c > 1);
              if (!1 !== m || u.uirevision) {
                var g = o.newContainer(t, "legend");
                if (x("uirevision", t.uirevision), !1 !== m) {
                  x("bgcolor", t.paper_bgcolor), x("bordercolor"), x("borderwidth"), i.coerceFont(x, "font", t.font);
                  var v,
                    y,
                    b,
                    _ = x("orientation");
                  "h" === _ ? (v = 0, r.getComponentMethod("rangeslider", "isVisible")(e.xaxis) ? (y = 1.1, b = "bottom") : (y = -.1, b = "top")) : (v = 1.02, y = 1, b = "auto"), x("traceorder", h), l.isGrouped(t.legend) && x("tracegroupgap"), x("itemsizing"), x("itemclick"), x("itemdoubleclick"), x("x", v), x("xanchor"), x("y", y), x("yanchor", b), x("valign"), i.noneOrAll(u, g, ["x", "y"]), x("title.text") && (x("title.side", "h" === _ ? "left" : "top"), i.coerceFont(x, "title.font", t.font));
                }
              }
              function x(e, t) {
                return i.coerce(u, g, a, e, t);
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../plots/layout_attributes": 582,
            "../../registry": 593,
            "./attributes": 423,
            "./helpers": 429
          }],
          426: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../lib"),
              o = e("../../plots/plots"),
              a = e("../../registry"),
              s = e("../../lib/events"),
              l = e("../dragelement"),
              u = e("../drawing"),
              c = e("../color"),
              d = e("../../lib/svg_text_utils"),
              h = e("./handle_click"),
              f = e("./constants"),
              p = e("../../constants/alignment"),
              m = p.LINE_SPACING,
              g = p.FROM_TL,
              v = p.FROM_BR,
              y = e("./get_legend_data"),
              b = e("./style"),
              _ = e("./helpers");
            function x(e, t, n, r, i) {
              var o = n.data()[0][0].trace,
                l = {
                  event: i,
                  node: n.node(),
                  curveNumber: o.index,
                  expandedIndex: o._expandedIndex,
                  data: e.data,
                  layout: e.layout,
                  frames: e._transitionData._frames,
                  config: e._context,
                  fullData: e._fullData,
                  fullLayout: e._fullLayout
                };
              o._group && (l.group = o._group), a.traceIs(o, "pie-like") && (l.label = n.datum()[0].label), !1 !== s.triggerHandler(e, "plotly_legendclick", l) && (1 === r ? t._clickTimeout = setTimeout(function () {
                h(n, e, r);
              }, e._context.doubleClickDelay) : 2 === r && (t._clickTimeout && clearTimeout(t._clickTimeout), e._legendMouseDownTime = 0, !1 !== s.triggerHandler(e, "plotly_legenddoubleclick", l) && h(n, e, r)));
            }
            function w(e, t) {
              var n = e.data()[0][0],
                r = t._fullLayout.legend,
                o = n.trace,
                s = a.traceIs(o, "pie-like"),
                l = o.index,
                c = t._context.edits.legendText && !s,
                h = r._maxNameLength,
                p = s ? n.label : o.name;
              o._meta && (p = i.templateString(p, o._meta));
              var m = i.ensureSingle(e, "text", "legendtext");
              m.attr("text-anchor", "start").classed("user-select-none", !0).call(u.font, r.font).text(c ? S(p, h) : p), d.positionText(m, f.textGap, 0), c ? m.call(d.makeEditable, {
                gd: t,
                text: p
              }).call(E, e, t).on("edit", function (r) {
                this.text(S(r, h)).call(E, e, t);
                var o = n.trace._fullInput || {},
                  s = {};
                if (a.hasTransform(o, "groupby")) {
                  var u = a.getTransformIndices(o, "groupby"),
                    c = u[u.length - 1],
                    d = i.keyedContainer(o, "transforms[" + c + "].styles", "target", "value.name");
                  d.set(n.trace._group, r), s = d.constructUpdate();
                } else s.name = r;
                return a.call("_guiRestyle", t, s, l);
              }) : E(m, e, t);
            }
            function S(e, t) {
              var n = Math.max(4, t);
              if (e && e.trim().length >= n / 2) return e;
              for (var r = n - (e = e || "").length; r > 0; r--) e += " ";
              return e;
            }
            function A(e, t) {
              var n,
                o = t._context.doubleClickDelay,
                a = 1,
                s = i.ensureSingle(e, "rect", "legendtoggle", function (e) {
                  e.style("cursor", "pointer").attr("pointer-events", "all").call(c.fill, "rgba(0,0,0,0)");
                });
              s.on("mousedown", function () {
                (n = new Date().getTime()) - t._legendMouseDownTime < o ? a += 1 : (a = 1, t._legendMouseDownTime = n);
              }), s.on("mouseup", function () {
                if (!t._dragged && !t._editing) {
                  var n = t._fullLayout.legend;
                  new Date().getTime() - t._legendMouseDownTime > o && (a = Math.max(a - 1, 1)), x(t, n, e, a, r.event);
                }
              });
            }
            function E(e, t, n) {
              d.convertToTspans(e, n, function () {
                !function (e, t) {
                  var n = e.data()[0][0];
                  if (!n || n.trace.showlegend) {
                    var r,
                      i,
                      o = e.select("g[class*=math-group]"),
                      a = o.node(),
                      s = t._fullLayout.legend.borderwidth,
                      l = t._fullLayout.legend,
                      c = (n ? l : l.title).font.size * m;
                    if (a) {
                      var h = u.bBox(a);
                      r = h.height, i = h.width, n ? u.setTranslate(o, 0, .25 * r) : u.setTranslate(o, s, .75 * r + s);
                    } else {
                      var p = e.select(n ? ".legendtext" : ".legendtitletext"),
                        g = d.lineCount(p),
                        v = p.node();
                      r = c * g, i = v ? u.bBox(v).width : 0;
                      var y = c * ((g - 1) / 2 - .3);
                      n ? d.positionText(p, f.textGap, -y) : d.positionText(p, f.titlePad + s, c + s);
                    }
                    n ? (n.lineHeight = c, n.height = Math.max(r, 16) + 3, n.width = i) : (l._titleWidth = i, l._titleHeight = r);
                  } else e.remove();
                }(t, n);
              });
            }
            function T(e) {
              return i.isRightAnchor(e) ? "right" : i.isCenterAnchor(e) ? "center" : "left";
            }
            function M(e) {
              return i.isBottomAnchor(e) ? "bottom" : i.isMiddleAnchor(e) ? "middle" : "top";
            }
            t.exports = function (e) {
              var t = e._fullLayout,
                n = "legend" + t._uid;
              if (t._infolayer && e.calcdata) {
                e._legendMouseDownTime || (e._legendMouseDownTime = 0);
                var s = t.legend,
                  d = t.showlegend && y(e.calcdata, s),
                  h = t.hiddenlabels || [];
                if (!t.showlegend || !d.length) return t._infolayer.selectAll(".legend").remove(), t._topdefs.select("#" + n).remove(), o.autoMargin(e, "legend");
                var p = i.ensureSingle(t._infolayer, "g", "legend", function (e) {
                    e.attr("pointer-events", "all");
                  }),
                  m = i.ensureSingleById(t._topdefs, "clipPath", n, function (e) {
                    e.append("rect");
                  }),
                  S = i.ensureSingle(p, "rect", "bg", function (e) {
                    e.attr("shape-rendering", "crispEdges");
                  });
                S.call(c.stroke, s.bordercolor).call(c.fill, s.bgcolor).style("stroke-width", s.borderwidth + "px");
                var C = i.ensureSingle(p, "g", "scrollbox"),
                  k = s.title;
                if (s._titleWidth = 0, s._titleHeight = 0, k.text) {
                  var P = i.ensureSingle(C, "text", "legendtitletext");
                  P.attr("text-anchor", "start").classed("user-select-none", !0).call(u.font, k.font).text(k.text), E(P, C, e);
                }
                var O = i.ensureSingle(p, "rect", "scrollbar", function (e) {
                    e.attr(f.scrollBarEnterAttrs).call(c.fill, f.scrollBarColor);
                  }),
                  R = C.selectAll("g.groups").data(d);
                R.enter().append("g").attr("class", "groups"), R.exit().remove();
                var I = R.selectAll("g.traces").data(i.identity);
                I.enter().append("g").attr("class", "traces"), I.exit().remove(), I.style("opacity", function (e) {
                  var t = e[0].trace;
                  return a.traceIs(t, "pie-like") ? -1 !== h.indexOf(e[0].label) ? .5 : 1 : "legendonly" === t.visible ? .5 : 1;
                }).each(function () {
                  r.select(this).call(w, e);
                }).call(b, e).each(function () {
                  r.select(this).call(A, e);
                }), i.syncOrAsync([o.previousPromises, function () {
                  return function (e, t, n) {
                    var i = e._fullLayout,
                      o = i.legend,
                      a = i._size,
                      s = _.isVertical(o),
                      l = _.isGrouped(o),
                      c = o.borderwidth,
                      d = 2 * c,
                      h = f.textGap,
                      p = f.itemGap,
                      m = 2 * (c + p),
                      g = M(o),
                      v = o.y < 0 || 0 === o.y && "top" === g,
                      y = o.y > 1 || 1 === o.y && "bottom" === g;
                    o._maxHeight = Math.max(v || y ? i.height / 2 : a.h, 30);
                    var b = 0;
                    o._width = 0, o._height = 0;
                    var x = function (e) {
                      var t = 0,
                        n = 0,
                        r = e.title.side;
                      return r && (-1 !== r.indexOf("left") && (t = e._titleWidth), -1 !== r.indexOf("top") && (n = e._titleHeight)), [t, n];
                    }(o);
                    if (s) n.each(function (e) {
                      var t = e[0].height;
                      u.setTranslate(this, c + x[0], c + x[1] + o._height + t / 2 + p), o._height += t, o._width = Math.max(o._width, e[0].width);
                    }), b = h + o._width, o._width += p + h + d, o._height += m, l && (t.each(function (e, t) {
                      u.setTranslate(this, 0, t * o.tracegroupgap);
                    }), o._height += (o._lgroupsLength - 1) * o.tracegroupgap);else {
                      var w = T(o),
                        S = o.x < 0 || 0 === o.x && "right" === w,
                        A = o.x > 1 || 1 === o.x && "left" === w,
                        E = y || v,
                        C = i.width / 2;
                      o._maxWidth = Math.max(S ? E && "left" === w ? a.l + a.w : C : A ? E && "right" === w ? a.r + a.w : C : a.w, 2 * h);
                      var k = 0,
                        P = 0;
                      n.each(function (e) {
                        var t = e[0].width + h;
                        k = Math.max(k, t), P += t;
                      }), b = null;
                      var O = 0;
                      if (l) {
                        var R = 0,
                          I = 0,
                          j = 0;
                        t.each(function () {
                          var e = 0,
                            t = 0;
                          r.select(this).selectAll("g.traces").each(function (n) {
                            var r = n[0].height;
                            u.setTranslate(this, x[0], x[1] + c + p + r / 2 + t), t += r, e = Math.max(e, h + n[0].width);
                          }), R = Math.max(R, t);
                          var n = e + p;
                          n + c + I > o._maxWidth && (O = Math.max(O, I), I = 0, j += R + o.tracegroupgap, R = t), u.setTranslate(this, I, j), I += n;
                        }), o._width = Math.max(O, I) + c, o._height = j + R + m;
                      } else {
                        var N = n.size(),
                          L = P + d + (N - 1) * p < o._maxWidth,
                          D = 0,
                          B = 0,
                          F = 0,
                          z = 0;
                        n.each(function (e) {
                          var t = e[0].height,
                            n = h + e[0].width,
                            r = (L ? n : k) + p;
                          r + c + B > o._maxWidth && (O = Math.max(O, z), B = 0, F += D, o._height += D, D = 0), u.setTranslate(this, x[0] + c + B, x[1] + c + F + t / 2 + p), z = B + n + p, B += r, D = Math.max(D, t);
                        }), L ? (o._width = B + d, o._height = D + m) : (o._width = Math.max(O, z) + d, o._height += D + m);
                      }
                    }
                    o._width = Math.ceil(Math.max(o._width + x[0], o._titleWidth + 2 * (c + f.titlePad))), o._height = Math.ceil(Math.max(o._height + x[1], o._titleHeight + 2 * (c + f.itemGap))), o._effHeight = Math.min(o._height, o._maxHeight);
                    var U = e._context.edits,
                      G = U.legendText || U.legendPosition;
                    n.each(function (e) {
                      var t = r.select(this).select(".legendtoggle"),
                        n = e[0].height,
                        i = G ? h : b || h + e[0].width;
                      s || (i += p / 2), u.setRect(t, 0, -n / 2, i, n);
                    });
                  }(e, R, I);
                }, function () {
                  if (!function (e) {
                    var t = e._fullLayout.legend,
                      n = T(t),
                      r = M(t);
                    return o.autoMargin(e, "legend", {
                      x: t.x,
                      y: t.y,
                      l: t._width * g[n],
                      r: t._width * v[n],
                      b: t._effHeight * v[r],
                      t: t._effHeight * g[r]
                    });
                  }(e)) {
                    var c,
                      d,
                      h,
                      y,
                      b = t._size,
                      _ = s.borderwidth,
                      w = b.l + b.w * s.x - g[T(s)] * s._width,
                      A = b.t + b.h * (1 - s.y) - g[M(s)] * s._effHeight;
                    if (t.margin.autoexpand) {
                      var E = w,
                        k = A;
                      w = i.constrain(w, 0, t.width - s._width), A = i.constrain(A, 0, t.height - s._effHeight), w !== E && i.log("Constrain legend.x to make legend fit inside graph"), A !== k && i.log("Constrain legend.y to make legend fit inside graph");
                    }
                    if (u.setTranslate(p, w, A), O.on(".drag", null), p.on("wheel", null), s._height <= s._maxHeight || e._context.staticPlot) S.attr({
                      width: s._width - _,
                      height: s._effHeight - _,
                      x: _ / 2,
                      y: _ / 2
                    }), u.setTranslate(C, 0, 0), m.select("rect").attr({
                      width: s._width - 2 * _,
                      height: s._effHeight - 2 * _,
                      x: _,
                      y: _
                    }), u.setClipUrl(C, n, e), u.setRect(O, 0, 0, 0, 0), delete s._scrollY;else {
                      var P,
                        R,
                        I,
                        j = Math.max(f.scrollBarMinHeight, s._effHeight * s._effHeight / s._height),
                        N = s._effHeight - j - 2 * f.scrollBarMargin,
                        L = s._height - s._effHeight,
                        D = N / L,
                        B = Math.min(s._scrollY || 0, L);
                      S.attr({
                        width: s._width - 2 * _ + f.scrollBarWidth + f.scrollBarMargin,
                        height: s._effHeight - _,
                        x: _ / 2,
                        y: _ / 2
                      }), m.select("rect").attr({
                        width: s._width - 2 * _ + f.scrollBarWidth + f.scrollBarMargin,
                        height: s._effHeight - 2 * _,
                        x: _,
                        y: _ + B
                      }), u.setClipUrl(C, n, e), U(B, j, D), p.on("wheel", function () {
                        U(B = i.constrain(s._scrollY + r.event.deltaY / N * L, 0, L), j, D), 0 !== B && B !== L && r.event.preventDefault();
                      });
                      var F = r.behavior.drag().on("dragstart", function () {
                        var e = r.event.sourceEvent;
                        P = "touchstart" === e.type ? e.changedTouches[0].clientY : e.clientY, I = B;
                      }).on("drag", function () {
                        var e = r.event.sourceEvent;
                        2 === e.buttons || e.ctrlKey || (R = "touchmove" === e.type ? e.changedTouches[0].clientY : e.clientY, U(B = function (e, t, n) {
                          var r = (n - t) / D + e;
                          return i.constrain(r, 0, L);
                        }(I, P, R), j, D));
                      });
                      O.call(F);
                      var z = r.behavior.drag().on("dragstart", function () {
                        var e = r.event.sourceEvent;
                        "touchstart" === e.type && (P = e.changedTouches[0].clientY, I = B);
                      }).on("drag", function () {
                        var e = r.event.sourceEvent;
                        "touchmove" === e.type && (R = e.changedTouches[0].clientY, U(B = function (e, t, n) {
                          var r = (t - n) / D + e;
                          return i.constrain(r, 0, L);
                        }(I, P, R), j, D));
                      });
                      C.call(z);
                    }
                    e._context.edits.legendPosition && (p.classed("cursor-move", !0), l.init({
                      element: p.node(),
                      gd: e,
                      prepFn: function prepFn() {
                        var e = u.getTranslate(p);
                        h = e.x, y = e.y;
                      },
                      moveFn: function moveFn(e, t) {
                        var n = h + e,
                          r = y + t;
                        u.setTranslate(p, n, r), c = l.align(n, 0, b.l, b.l + b.w, s.xanchor), d = l.align(r, 0, b.t + b.h, b.t, s.yanchor);
                      },
                      doneFn: function doneFn() {
                        void 0 !== c && void 0 !== d && a.call("_guiRelayout", e, {
                          "legend.x": c,
                          "legend.y": d
                        });
                      },
                      clickFn: function clickFn(n, r) {
                        var i = t._infolayer.selectAll("g.traces").filter(function () {
                          var e = this.getBoundingClientRect();
                          return r.clientX >= e.left && r.clientX <= e.right && r.clientY >= e.top && r.clientY <= e.bottom;
                        });
                        i.size() > 0 && x(e, p, i, n, r);
                      }
                    }));
                  }
                  function U(t, n, r) {
                    s._scrollY = e._fullLayout.legend._scrollY = t, u.setTranslate(C, 0, -t), u.setRect(O, s._width, f.scrollBarMargin + t * r, f.scrollBarWidth, n), m.select("rect").attr("y", _ + t);
                  }
                }], e);
              }
            };
          }, {
            "../../constants/alignment": 469,
            "../../lib": 495,
            "../../lib/events": 488,
            "../../lib/svg_text_utils": 518,
            "../../plots/plots": 584,
            "../../registry": 593,
            "../color": 375,
            "../dragelement": 393,
            "../drawing": 396,
            "./constants": 424,
            "./get_legend_data": 427,
            "./handle_click": 428,
            "./helpers": 429,
            "./style": 431,
            d3: 82
          }],
          427: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("./helpers");
            t.exports = function (e, t) {
              var n,
                o,
                a = {},
                s = [],
                l = !1,
                u = {},
                c = 0,
                d = 0;
              function h(e, n) {
                if ("" !== e && i.isGrouped(t)) -1 === s.indexOf(e) ? (s.push(e), l = !0, a[e] = [[n]]) : a[e].push([n]);else {
                  var r = "~~i" + c;
                  s.push(r), a[r] = [[n]], c++;
                }
              }
              for (n = 0; n < e.length; n++) {
                var f = e[n],
                  p = f[0],
                  m = p.trace,
                  g = m.legendgroup;
                if (m.visible && m.showlegend) if (r.traceIs(m, "pie-like")) for (u[g] || (u[g] = {}), o = 0; o < f.length; o++) {
                  var v = f[o].label;
                  u[g][v] || (h(g, {
                    label: v,
                    color: f[o].color,
                    i: f[o].i,
                    trace: m,
                    pts: f[o].pts
                  }), u[g][v] = !0, d = Math.max(d, (v || "").length));
                } else h(g, p), d = Math.max(d, (m.name || "").length);
              }
              if (!s.length) return [];
              var y,
                b,
                _ = s.length;
              if (l && i.isGrouped(t)) for (b = new Array(_), n = 0; n < _; n++) y = a[s[n]], b[n] = i.isReversed(t) ? y.reverse() : y;else {
                for (b = [new Array(_)], n = 0; n < _; n++) y = a[s[n]][0], b[0][i.isReversed(t) ? _ - n - 1 : n] = y;
                _ = 1;
              }
              return t._lgroupsLength = _, t._maxNameLength = d, b;
            };
          }, {
            "../../registry": 593,
            "./helpers": 429
          }],
          428: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../registry"),
              o = !0;
            t.exports = function (e, t, n) {
              var a = t._fullLayout;
              if (!t._dragged && !t._editing) {
                var s,
                  l = a.legend.itemclick,
                  u = a.legend.itemdoubleclick;
                if (1 === n && "toggle" === l && "toggleothers" === u && o && t.data && t._context.showTips ? (r.notifier(r._(t, "Double-click on legend to isolate one trace"), "long"), o = !1) : o = !1, 1 === n ? s = l : 2 === n && (s = u), s) {
                  var c,
                    d,
                    h,
                    f,
                    p,
                    m = a.hiddenlabels ? a.hiddenlabels.slice() : [],
                    g = e.data()[0][0],
                    v = t._fullData,
                    y = g.trace,
                    b = y.legendgroup,
                    _ = {},
                    x = [],
                    w = [],
                    S = [];
                  if (i.traceIs(y, "pie-like")) {
                    var A = g.label,
                      E = m.indexOf(A);
                    "toggle" === s ? -1 === E ? m.push(A) : m.splice(E, 1) : "toggleothers" === s && (m = [], t.calcdata[0].forEach(function (e) {
                      A !== e.label && m.push(e.label);
                    }), t._fullLayout.hiddenlabels && t._fullLayout.hiddenlabels.length === m.length && -1 === E && (m = [])), i.call("_guiRelayout", t, "hiddenlabels", m);
                  } else {
                    var T,
                      M = b && b.length,
                      C = [];
                    if (M) for (c = 0; c < v.length; c++) (T = v[c]).visible && T.legendgroup === b && C.push(c);
                    if ("toggle" === s) {
                      var k;
                      switch (y.visible) {
                        case !0:
                          k = "legendonly";
                          break;
                        case !1:
                          k = !1;
                          break;
                        case "legendonly":
                          k = !0;
                      }
                      if (M) for (c = 0; c < v.length; c++) !1 !== v[c].visible && v[c].legendgroup === b && B(v[c], k);else B(y, k);
                    } else if ("toggleothers" === s) {
                      var P,
                        O,
                        R,
                        I,
                        j = !0;
                      for (c = 0; c < v.length; c++) if (P = v[c] === y, R = !0 !== v[c].showlegend, !(P || R || (O = M && v[c].legendgroup === b) || !0 !== v[c].visible || i.traceIs(v[c], "notLegendIsolatable"))) {
                        j = !1;
                        break;
                      }
                      for (c = 0; c < v.length; c++) if (!1 !== v[c].visible && !i.traceIs(v[c], "notLegendIsolatable")) switch (y.visible) {
                        case "legendonly":
                          B(v[c], !0);
                          break;
                        case !0:
                          I = !!j || "legendonly", P = v[c] === y, R = !0 !== v[c].showlegend && !v[c].legendgroup, O = P || M && v[c].legendgroup === b, B(v[c], !(!O && !R) || I);
                      }
                    }
                    for (c = 0; c < w.length; c++) if (h = w[c]) {
                      var N = h.constructUpdate(),
                        L = Object.keys(N);
                      for (d = 0; d < L.length; d++) f = L[d], (_[f] = _[f] || [])[S[c]] = N[f];
                    }
                    for (p = Object.keys(_), c = 0; c < p.length; c++) for (f = p[c], d = 0; d < x.length; d++) _[f].hasOwnProperty(d) || (_[f][d] = void 0);
                    i.call("_guiRestyle", t, _, x);
                  }
                }
              }
              function D(e, t, n) {
                var r = x.indexOf(e),
                  i = _[t];
                return i || (i = _[t] = []), -1 === x.indexOf(e) && (x.push(e), r = x.length - 1), i[r] = n, r;
              }
              function B(e, t) {
                var n = e._fullInput;
                if (i.hasTransform(n, "groupby")) {
                  var o = w[n.index];
                  if (!o) {
                    var a = i.getTransformIndices(n, "groupby"),
                      s = a[a.length - 1];
                    o = r.keyedContainer(n, "transforms[" + s + "].styles", "target", "value.visible"), w[n.index] = o;
                  }
                  var l = o.get(e._group);
                  void 0 === l && (l = !0), !1 !== l && o.set(e._group, t), S[n.index] = D(n.index, "visible", !1 !== n.visible);
                } else {
                  var u = !1 !== n.visible && t;
                  D(n.index, "visible", u);
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../registry": 593
          }],
          429: [function (e, t, n) {
            "use strict";

            n.isGrouped = function (e) {
              return -1 !== (e.traceorder || "").indexOf("grouped");
            }, n.isVertical = function (e) {
              return "h" !== e.orientation;
            }, n.isReversed = function (e) {
              return -1 !== (e.traceorder || "").indexOf("reversed");
            };
          }, {}],
          430: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "component",
              name: "legend",
              layoutAttributes: e("./attributes"),
              supplyLayoutDefaults: e("./defaults"),
              draw: e("./draw"),
              style: e("./style")
            };
          }, {
            "./attributes": 423,
            "./defaults": 425,
            "./draw": 426,
            "./style": 431
          }],
          431: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../lib"),
              a = e("../drawing"),
              s = e("../color"),
              l = e("../colorscale/helpers").extractOpts,
              u = e("../../traces/scatter/subtypes"),
              c = e("../../traces/pie/style_one"),
              d = e("../../traces/pie/helpers").castOption;
            function h(e, t) {
              return (t ? "radial" : "horizontal") + (e ? "" : "reversed");
            }
            t.exports = function (e, t) {
              var n = t._fullLayout.legend,
                f = "constant" === n.itemsizing,
                p = function p(e, t, n, r) {
                  var i;
                  if (e + 1) i = e;else {
                    if (!(t && t.width > 0)) return 0;
                    i = t.width;
                  }
                  return f ? r : Math.min(i, n);
                };
              function m(e, t, n) {
                var o = e[0].trace,
                  a = o.marker || {},
                  l = a.line || {},
                  u = n ? o.visible && o.type === n : i.traceIs(o, "bar"),
                  c = r.select(t).select("g.legendpoints").selectAll("path.legend" + n).data(u ? [e] : []);
                c.enter().append("path").classed("legend" + n, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", "translate(20,0)"), c.exit().remove(), c.each(function (e) {
                  var t = r.select(this),
                    n = e[0],
                    i = p(n.mlw, a.line, 5, 2);
                  t.style("stroke-width", i + "px").call(s.fill, n.mc || a.color), i && s.stroke(t, n.mlc || l.color);
                });
              }
              function g(e, t, n) {
                var a = e[0],
                  s = a.trace,
                  l = n ? s.visible && s.type === n : i.traceIs(s, n),
                  u = r.select(t).select("g.legendpoints").selectAll("path.legend" + n).data(l ? [e] : []);
                if (u.enter().append("path").classed("legend" + n, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", "translate(20,0)"), u.exit().remove(), u.size()) {
                  var h = (s.marker || {}).line,
                    f = p(d(h.width, a.pts), h, 5, 2),
                    m = o.minExtend(s, {
                      marker: {
                        line: {
                          width: f
                        }
                      }
                    });
                  m.marker.line.color = h.color;
                  var g = o.minExtend(a, {
                    trace: m
                  });
                  c(u, g, m);
                }
              }
              e.each(function (e) {
                var t = r.select(this),
                  i = o.ensureSingle(t, "g", "layers");
                i.style("opacity", e[0].trace.opacity);
                var a = n.valign,
                  s = e[0].lineHeight,
                  l = e[0].height;
                if ("middle" !== a && s && l) {
                  var u = {
                    top: 1,
                    bottom: -1
                  }[a] * (.5 * (s - l + 3));
                  i.attr("transform", "translate(0," + u + ")");
                } else i.attr("transform", null);
                i.selectAll("g.legendfill").data([e]).enter().append("g").classed("legendfill", !0), i.selectAll("g.legendlines").data([e]).enter().append("g").classed("legendlines", !0);
                var c = i.selectAll("g.legendsymbols").data([e]);
                c.enter().append("g").classed("legendsymbols", !0), c.selectAll("g.legendpoints").data([e]).enter().append("g").classed("legendpoints", !0);
              }).each(function (e) {
                var n,
                  i = e[0].trace,
                  u = [];
                if (i.visible) switch (i.type) {
                  case "histogram2d":
                  case "heatmap":
                    u = [["M-15,-2V4H15V-2Z"]], n = !0;
                    break;
                  case "choropleth":
                  case "choroplethmapbox":
                    u = [["M-6,-6V6H6V-6Z"]], n = !0;
                    break;
                  case "densitymapbox":
                    u = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]], n = "radial";
                    break;
                  case "cone":
                    u = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]], n = !1;
                    break;
                  case "streamtube":
                    u = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]], n = !1;
                    break;
                  case "surface":
                    u = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]], n = !0;
                    break;
                  case "mesh3d":
                    u = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], n = !1;
                    break;
                  case "volume":
                    u = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], n = !0;
                    break;
                  case "isosurface":
                    u = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]], n = !1;
                }
                var c = r.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(u);
                c.enter().append("path").classed("legend3dandfriends", !0).attr("transform", "translate(20,0)").style("stroke-miterlimit", 1), c.exit().remove(), c.each(function (e, u) {
                  var c,
                    d = r.select(this),
                    f = l(i),
                    p = f.colorscale,
                    m = f.reversescale;
                  if (p) {
                    if (!n) {
                      var g = p.length;
                      c = 0 === u ? p[m ? g - 1 : 0][1] : 1 === u ? p[m ? 0 : g - 1][1] : p[Math.floor((g - 1) / 2)][1];
                    }
                  } else {
                    var v = i.vertexcolor || i.facecolor || i.color;
                    c = o.isArrayOrTypedArray(v) ? v[u] || v[0] : v;
                  }
                  d.attr("d", e[0]), c ? d.call(s.fill, c) : d.call(function (e) {
                    if (e.size()) {
                      var r = "legendfill-" + i.uid;
                      a.gradient(e, t, r, h(m, "radial" === n), p, "fill");
                    }
                  });
                });
              }).each(function (e) {
                var t = e[0].trace,
                  n = [];
                t.visible && "waterfall" === t.type && (n = e[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]]);
                var i = r.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(n);
                i.enter().append("path").classed("legendwaterfall", !0).attr("transform", "translate(20,0)").style("stroke-miterlimit", 1), i.exit().remove(), i.each(function (e) {
                  var n = r.select(this),
                    i = t[e[0]].marker,
                    o = p(void 0, i.line, 5, 2);
                  n.attr("d", e[1]).style("stroke-width", o + "px").call(s.fill, i.color), o && n.call(s.stroke, i.line.color);
                });
              }).each(function (e) {
                m(e, this, "funnel");
              }).each(function (e) {
                m(e, this);
              }).each(function (e) {
                var n = e[0].trace,
                  l = r.select(this).select("g.legendpoints").selectAll("path.legendbox").data(n.visible && i.traceIs(n, "box-violin") ? [e] : []);
                l.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", "translate(20,0)"), l.exit().remove(), l.each(function () {
                  var e = r.select(this);
                  if ("all" !== n.boxpoints && "all" !== n.points || 0 !== s.opacity(n.fillcolor) || 0 !== s.opacity((n.line || {}).color)) {
                    var i = p(void 0, n.line, 5, 2);
                    e.style("stroke-width", i + "px").call(s.fill, n.fillcolor), i && s.stroke(e, n.line.color);
                  } else {
                    var u = o.minExtend(n, {
                      marker: {
                        size: f ? 12 : o.constrain(n.marker.size, 2, 16),
                        sizeref: 1,
                        sizemin: 1,
                        sizemode: "diameter"
                      }
                    });
                    l.call(a.pointStyle, u, t);
                  }
                });
              }).each(function (e) {
                g(e, this, "funnelarea");
              }).each(function (e) {
                g(e, this, "pie");
              }).each(function (e) {
                var n,
                  i,
                  s = e[0],
                  c = s.trace,
                  d = c.visible && c.fill && "none" !== c.fill,
                  f = u.hasLines(c),
                  m = c.contours,
                  g = !1,
                  v = !1,
                  y = l(c),
                  b = y.colorscale,
                  _ = y.reversescale;
                if (m) {
                  var x = m.coloring;
                  "lines" === x ? g = !0 : f = "none" === x || "heatmap" === x || m.showlines, "constraint" === m.type ? d = "=" !== m._operation : "fill" !== x && "heatmap" !== x || (v = !0);
                }
                var w = u.hasMarkers(c) || u.hasText(c) || !d && !v ? "M5,0" : f || g ? "M5,-2" : "M5,-3",
                  S = r.select(this),
                  A = S.select(".legendfill").selectAll("path").data(d || v ? [e] : []);
                if (A.enter().append("path").classed("js-fill", !0), A.exit().remove(), A.attr("d", w + "h30v6h-30z").call(d ? a.fillGroupStyle : function (e) {
                  if (e.size()) {
                    var n = "legendfill-" + c.uid;
                    a.gradient(e, t, n, h(_), b, "fill");
                  }
                }), f || g) {
                  var E = p(void 0, c.line, 10, 5);
                  i = o.minExtend(c, {
                    line: {
                      width: E
                    }
                  }), n = [o.minExtend(s, {
                    trace: i
                  })];
                }
                var T = S.select(".legendlines").selectAll("path").data(f || g ? [n] : []);
                T.enter().append("path").classed("js-line", !0), T.exit().remove(), T.attr("d", w + (g ? "l30,0.0001" : "h30")).call(f ? a.lineGroupStyle : function (e) {
                  if (e.size()) {
                    var n = "legendline-" + c.uid;
                    a.lineGroupStyle(e), a.gradient(e, t, n, h(_), b, "stroke");
                  }
                });
              }).each(function (e) {
                var n,
                  i,
                  s = e[0],
                  l = s.trace,
                  c = u.hasMarkers(l),
                  d = u.hasText(l),
                  h = u.hasLines(l);
                function p(e, t, n, r) {
                  var i = o.nestedProperty(l, e).get(),
                    a = o.isArrayOrTypedArray(i) && t ? t(i) : i;
                  if (f && a && void 0 !== r && (a = r), n) {
                    if (a < n[0]) return n[0];
                    if (a > n[1]) return n[1];
                  }
                  return a;
                }
                function m(e) {
                  return e[0];
                }
                if (c || d || h) {
                  var g = {},
                    v = {};
                  if (c) {
                    g.mc = p("marker.color", m), g.mx = p("marker.symbol", m), g.mo = p("marker.opacity", o.mean, [.2, 1]), g.mlc = p("marker.line.color", m), g.mlw = p("marker.line.width", o.mean, [0, 5], 2), v.marker = {
                      sizeref: 1,
                      sizemin: 1,
                      sizemode: "diameter"
                    };
                    var y = p("marker.size", o.mean, [2, 16], 12);
                    g.ms = y, v.marker.size = y;
                  }
                  h && (v.line = {
                    width: p("line.width", m, [0, 10], 5)
                  }), d && (g.tx = "Aa", g.tp = p("textposition", m), g.ts = 10, g.tc = p("textfont.color", m), g.tf = p("textfont.family", m)), n = [o.minExtend(s, g)], (i = o.minExtend(l, v)).selectedpoints = null, i.texttemplate = null;
                }
                var b = r.select(this).select("g.legendpoints"),
                  _ = b.selectAll("path.scatterpts").data(c ? n : []);
                _.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", "translate(20,0)"), _.exit().remove(), _.call(a.pointStyle, i, t), c && (n[0].mrc = 3);
                var x = b.selectAll("g.pointtext").data(d ? n : []);
                x.enter().append("g").classed("pointtext", !0).append("text").attr("transform", "translate(20,0)"), x.exit().remove(), x.selectAll("text").call(a.textPointStyle, i, t);
              }).each(function (e) {
                var t = e[0].trace,
                  n = r.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(t.visible && "candlestick" === t.type ? [e, e] : []);
                n.enter().append("path").classed("legendcandle", !0).attr("d", function (e, t) {
                  return t ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
                }).attr("transform", "translate(20,0)").style("stroke-miterlimit", 1), n.exit().remove(), n.each(function (e, n) {
                  var i = r.select(this),
                    o = t[n ? "increasing" : "decreasing"],
                    a = p(void 0, o.line, 5, 2);
                  i.style("stroke-width", a + "px").call(s.fill, o.fillcolor), a && s.stroke(i, o.line.color);
                });
              }).each(function (e) {
                var t = e[0].trace,
                  n = r.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(t.visible && "ohlc" === t.type ? [e, e] : []);
                n.enter().append("path").classed("legendohlc", !0).attr("d", function (e, t) {
                  return t ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
                }).attr("transform", "translate(20,0)").style("stroke-miterlimit", 1), n.exit().remove(), n.each(function (e, n) {
                  var i = r.select(this),
                    o = t[n ? "increasing" : "decreasing"],
                    l = p(void 0, o.line, 5, 2);
                  i.style("fill", "none").call(a.dashLine, o.line.dash, l), l && s.stroke(i, o.line.color);
                });
              });
            };
          }, {
            "../../lib": 495,
            "../../registry": 593,
            "../../traces/pie/helpers": 619,
            "../../traces/pie/style_one": 620,
            "../../traces/scatter/subtypes": 646,
            "../color": 375,
            "../colorscale/helpers": 386,
            "../drawing": 396,
            d3: 82
          }],
          432: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../plots/plots"),
              o = e("../../plots/cartesian/axis_ids"),
              a = e("../../lib"),
              s = e("../../fonts/ploticon"),
              l = a._,
              u = t.exports = {};
            function c(e, t) {
              var n,
                i,
                a = t.currentTarget,
                s = a.getAttribute("data-attr"),
                l = a.getAttribute("data-val") || !0,
                u = e._fullLayout,
                c = {},
                d = o.list(e, null, !0),
                h = u._cartesianSpikesEnabled;
              if ("zoom" === s) {
                var f,
                  p = "in" === l ? .5 : 2,
                  m = (1 + p) / 2,
                  g = (1 - p) / 2;
                for (i = 0; i < d.length; i++) if (!(n = d[i]).fixedrange) if (f = n._name, "auto" === l) c[f + ".autorange"] = !0;else if ("reset" === l) {
                  if (void 0 === n._rangeInitial) c[f + ".autorange"] = !0;else {
                    var v = n._rangeInitial.slice();
                    c[f + ".range[0]"] = v[0], c[f + ".range[1]"] = v[1];
                  }
                  void 0 !== n._showSpikeInitial && (c[f + ".showspikes"] = n._showSpikeInitial, "on" !== h || n._showSpikeInitial || (h = "off"));
                } else {
                  var y = [n.r2l(n.range[0]), n.r2l(n.range[1])],
                    b = [m * y[0] + g * y[1], m * y[1] + g * y[0]];
                  c[f + ".range[0]"] = n.l2r(b[0]), c[f + ".range[1]"] = n.l2r(b[1]);
                }
              } else "hovermode" !== s || "x" !== l && "y" !== l || (l = u._isHoriz ? "y" : "x", a.setAttribute("data-val", l)), c[s] = l;
              u._cartesianSpikesEnabled = h, r.call("_guiRelayout", e, c);
            }
            function d(e, t) {
              for (var n = t.currentTarget, i = n.getAttribute("data-attr"), o = n.getAttribute("data-val") || !0, a = e._fullLayout._subplots.gl3d || [], s = {}, l = i.split("."), u = 0; u < a.length; u++) s[a[u] + "." + l[1]] = o;
              var c = "pan" === o ? o : "zoom";
              s.dragmode = c, r.call("_guiRelayout", e, s);
            }
            function h(e, t) {
              for (var n = t.currentTarget.getAttribute("data-attr"), i = e._fullLayout, o = i._subplots.gl3d || [], a = {}, s = 0; s < o.length; s++) {
                var l,
                  u = o[s],
                  c = u + ".camera",
                  d = u + ".aspectratio",
                  h = u + ".aspectmode",
                  f = i[u]._scene;
                "resetLastSave" === n ? (a[c + ".up"] = f.viewInitial.up, a[c + ".eye"] = f.viewInitial.eye, a[c + ".center"] = f.viewInitial.center, l = !0) : "resetDefault" === n && (a[c + ".up"] = null, a[c + ".eye"] = null, a[c + ".center"] = null, l = !0), l && (a[d + ".x"] = f.viewInitial.aspectratio.x, a[d + ".y"] = f.viewInitial.aspectratio.y, a[d + ".z"] = f.viewInitial.aspectratio.z, a[h] = f.viewInitial.aspectmode);
              }
              r.call("_guiRelayout", e, a);
            }
            function f(e, t) {
              var n = t.currentTarget,
                r = n._previousVal,
                i = e._fullLayout,
                o = i._subplots.gl3d || [],
                a = ["xaxis", "yaxis", "zaxis"],
                s = {},
                l = {};
              if (r) l = r, n._previousVal = null;else {
                for (var u = 0; u < o.length; u++) {
                  var c = o[u],
                    d = i[c],
                    h = c + ".hovermode";
                  s[h] = d.hovermode, l[h] = !1;
                  for (var f = 0; f < 3; f++) {
                    var p = a[f],
                      m = c + "." + p + ".showspikes";
                    l[m] = !1, s[m] = d[p].showspikes;
                  }
                }
                n._previousVal = s;
              }
              return l;
            }
            function p(e, t) {
              for (var n = t.currentTarget, i = n.getAttribute("data-attr"), o = n.getAttribute("data-val") || !0, a = e._fullLayout, s = a._subplots.geo || [], l = 0; l < s.length; l++) {
                var u = s[l],
                  c = a[u];
                if ("zoom" === i) {
                  var d = c.projection.scale,
                    h = "in" === o ? 2 * d : .5 * d;
                  r.call("_guiRelayout", e, u + ".projection.scale", h);
                }
              }
              "reset" === i && y(e, "geo");
            }
            function m(e) {
              var t = e._fullLayout;
              return !t.hovermode && (t._has("cartesian") ? t._isHoriz ? "y" : "x" : "closest");
            }
            function g(e) {
              var t = m(e);
              r.call("_guiRelayout", e, "hovermode", t);
            }
            function v(e, t) {
              for (var n = t.currentTarget.getAttribute("data-val"), i = e._fullLayout, o = i._subplots.mapbox || [], a = {}, s = 0; s < o.length; s++) {
                var l = o[s],
                  u = i[l].zoom,
                  c = "in" === n ? 1.05 * u : u / 1.05;
                a[l + ".zoom"] = c;
              }
              r.call("_guiRelayout", e, a);
            }
            function y(e, t) {
              for (var n = e._fullLayout, i = n._subplots[t] || [], o = {}, a = 0; a < i.length; a++) for (var s = i[a], l = n[s]._subplot.viewInitial, u = Object.keys(l), c = 0; c < u.length; c++) {
                var d = u[c];
                o[s + "." + d] = l[d];
              }
              r.call("_guiRelayout", e, o);
            }
            u.toImage = {
              name: "toImage",
              title: function title(e) {
                var t = (e._context.toImageButtonOptions || {}).format || "png";
                return l(e, "png" === t ? "Download plot as a png" : "Download plot");
              },
              icon: s.camera,
              click: function click(e) {
                var t = e._context.toImageButtonOptions,
                  n = {
                    format: t.format || "png"
                  };
                a.notifier(l(e, "Taking snapshot - this may take a few seconds"), "long"), "svg" !== n.format && a.isIE() && (a.notifier(l(e, "IE only supports svg.  Changing format to svg."), "long"), n.format = "svg"), ["filename", "width", "height", "scale"].forEach(function (e) {
                  e in t && (n[e] = t[e]);
                }), r.call("downloadImage", e, n).then(function (t) {
                  a.notifier(l(e, "Snapshot succeeded") + " - " + t, "long");
                }).catch(function () {
                  a.notifier(l(e, "Sorry, there was a problem downloading your snapshot!"), "long");
                });
              }
            }, u.sendDataToCloud = {
              name: "sendDataToCloud",
              title: function title(e) {
                return l(e, "Edit in Chart Studio");
              },
              icon: s.disk,
              click: function click(e) {
                i.sendDataToCloud(e);
              }
            }, u.editInChartStudio = {
              name: "editInChartStudio",
              title: function title(e) {
                return l(e, "Edit in Chart Studio");
              },
              icon: s.pencil,
              click: function click(e) {
                i.sendDataToCloud(e);
              }
            }, u.zoom2d = {
              name: "zoom2d",
              title: function title(e) {
                return l(e, "Zoom");
              },
              attr: "dragmode",
              val: "zoom",
              icon: s.zoombox,
              click: c
            }, u.pan2d = {
              name: "pan2d",
              title: function title(e) {
                return l(e, "Pan");
              },
              attr: "dragmode",
              val: "pan",
              icon: s.pan,
              click: c
            }, u.select2d = {
              name: "select2d",
              title: function title(e) {
                return l(e, "Box Select");
              },
              attr: "dragmode",
              val: "select",
              icon: s.selectbox,
              click: c
            }, u.lasso2d = {
              name: "lasso2d",
              title: function title(e) {
                return l(e, "Lasso Select");
              },
              attr: "dragmode",
              val: "lasso",
              icon: s.lasso,
              click: c
            }, u.zoomIn2d = {
              name: "zoomIn2d",
              title: function title(e) {
                return l(e, "Zoom in");
              },
              attr: "zoom",
              val: "in",
              icon: s.zoom_plus,
              click: c
            }, u.zoomOut2d = {
              name: "zoomOut2d",
              title: function title(e) {
                return l(e, "Zoom out");
              },
              attr: "zoom",
              val: "out",
              icon: s.zoom_minus,
              click: c
            }, u.autoScale2d = {
              name: "autoScale2d",
              title: function title(e) {
                return l(e, "Autoscale");
              },
              attr: "zoom",
              val: "auto",
              icon: s.autoscale,
              click: c
            }, u.resetScale2d = {
              name: "resetScale2d",
              title: function title(e) {
                return l(e, "Reset axes");
              },
              attr: "zoom",
              val: "reset",
              icon: s.home,
              click: c
            }, u.hoverClosestCartesian = {
              name: "hoverClosestCartesian",
              title: function title(e) {
                return l(e, "Show closest data on hover");
              },
              attr: "hovermode",
              val: "closest",
              icon: s.tooltip_basic,
              gravity: "ne",
              click: c
            }, u.hoverCompareCartesian = {
              name: "hoverCompareCartesian",
              title: function title(e) {
                return l(e, "Compare data on hover");
              },
              attr: "hovermode",
              val: function val(e) {
                return e._fullLayout._isHoriz ? "y" : "x";
              },
              icon: s.tooltip_compare,
              gravity: "ne",
              click: c
            }, u.zoom3d = {
              name: "zoom3d",
              title: function title(e) {
                return l(e, "Zoom");
              },
              attr: "scene.dragmode",
              val: "zoom",
              icon: s.zoombox,
              click: d
            }, u.pan3d = {
              name: "pan3d",
              title: function title(e) {
                return l(e, "Pan");
              },
              attr: "scene.dragmode",
              val: "pan",
              icon: s.pan,
              click: d
            }, u.orbitRotation = {
              name: "orbitRotation",
              title: function title(e) {
                return l(e, "Orbital rotation");
              },
              attr: "scene.dragmode",
              val: "orbit",
              icon: s["3d_rotate"],
              click: d
            }, u.tableRotation = {
              name: "tableRotation",
              title: function title(e) {
                return l(e, "Turntable rotation");
              },
              attr: "scene.dragmode",
              val: "turntable",
              icon: s["z-axis"],
              click: d
            }, u.resetCameraDefault3d = {
              name: "resetCameraDefault3d",
              title: function title(e) {
                return l(e, "Reset camera to default");
              },
              attr: "resetDefault",
              icon: s.home,
              click: h
            }, u.resetCameraLastSave3d = {
              name: "resetCameraLastSave3d",
              title: function title(e) {
                return l(e, "Reset camera to last save");
              },
              attr: "resetLastSave",
              icon: s.movie,
              click: h
            }, u.hoverClosest3d = {
              name: "hoverClosest3d",
              title: function title(e) {
                return l(e, "Toggle show closest data on hover");
              },
              attr: "hovermode",
              val: null,
              toggle: !0,
              icon: s.tooltip_basic,
              gravity: "ne",
              click: function click(e, t) {
                var n = f(e, t);
                r.call("_guiRelayout", e, n);
              }
            }, u.zoomInGeo = {
              name: "zoomInGeo",
              title: function title(e) {
                return l(e, "Zoom in");
              },
              attr: "zoom",
              val: "in",
              icon: s.zoom_plus,
              click: p
            }, u.zoomOutGeo = {
              name: "zoomOutGeo",
              title: function title(e) {
                return l(e, "Zoom out");
              },
              attr: "zoom",
              val: "out",
              icon: s.zoom_minus,
              click: p
            }, u.resetGeo = {
              name: "resetGeo",
              title: function title(e) {
                return l(e, "Reset");
              },
              attr: "reset",
              val: null,
              icon: s.autoscale,
              click: p
            }, u.hoverClosestGeo = {
              name: "hoverClosestGeo",
              title: function title(e) {
                return l(e, "Toggle show closest data on hover");
              },
              attr: "hovermode",
              val: null,
              toggle: !0,
              icon: s.tooltip_basic,
              gravity: "ne",
              click: g
            }, u.hoverClosestGl2d = {
              name: "hoverClosestGl2d",
              title: function title(e) {
                return l(e, "Toggle show closest data on hover");
              },
              attr: "hovermode",
              val: null,
              toggle: !0,
              icon: s.tooltip_basic,
              gravity: "ne",
              click: g
            }, u.hoverClosestPie = {
              name: "hoverClosestPie",
              title: function title(e) {
                return l(e, "Toggle show closest data on hover");
              },
              attr: "hovermode",
              val: "closest",
              icon: s.tooltip_basic,
              gravity: "ne",
              click: g
            }, u.resetViewSankey = {
              name: "resetSankeyGroup",
              title: function title(e) {
                return l(e, "Reset view");
              },
              icon: s.home,
              click: function click(e) {
                for (var t = {
                    "node.groups": [],
                    "node.x": [],
                    "node.y": []
                  }, n = 0; n < e._fullData.length; n++) {
                  var i = e._fullData[n]._viewInitial;
                  t["node.groups"].push(i.node.groups.slice()), t["node.x"].push(i.node.x.slice()), t["node.y"].push(i.node.y.slice());
                }
                r.call("restyle", e, t);
              }
            }, u.toggleHover = {
              name: "toggleHover",
              title: function title(e) {
                return l(e, "Toggle show closest data on hover");
              },
              attr: "hovermode",
              val: null,
              toggle: !0,
              icon: s.tooltip_basic,
              gravity: "ne",
              click: function click(e, t) {
                var n = f(e, t);
                n.hovermode = m(e), r.call("_guiRelayout", e, n);
              }
            }, u.resetViews = {
              name: "resetViews",
              title: function title(e) {
                return l(e, "Reset views");
              },
              icon: s.home,
              click: function click(e, t) {
                var n = t.currentTarget;
                n.setAttribute("data-attr", "zoom"), n.setAttribute("data-val", "reset"), c(e, t), n.setAttribute("data-attr", "resetLastSave"), h(e, t), y(e, "geo"), y(e, "mapbox");
              }
            }, u.toggleSpikelines = {
              name: "toggleSpikelines",
              title: function title(e) {
                return l(e, "Toggle Spike Lines");
              },
              icon: s.spikeline,
              attr: "_cartesianSpikesEnabled",
              val: "on",
              click: function click(e) {
                var t = e._fullLayout,
                  n = t._cartesianSpikesEnabled;
                t._cartesianSpikesEnabled = "on" === n ? "off" : "on", r.call("_guiRelayout", e, function (e) {
                  for (var t = "on" === e._fullLayout._cartesianSpikesEnabled, n = o.list(e, null, !0), r = {}, i = 0; i < n.length; i++) {
                    var a = n[i];
                    r[a._name + ".showspikes"] = !!t || a._showSpikeInitial;
                  }
                  return r;
                }(e));
              }
            }, u.resetViewMapbox = {
              name: "resetViewMapbox",
              title: function title(e) {
                return l(e, "Reset view");
              },
              attr: "reset",
              icon: s.home,
              click: function click(e) {
                y(e, "mapbox");
              }
            }, u.zoomInMapbox = {
              name: "zoomInMapbox",
              title: function title(e) {
                return l(e, "Zoom in");
              },
              attr: "zoom",
              val: "in",
              icon: s.zoom_plus,
              click: v
            }, u.zoomOutMapbox = {
              name: "zoomOutMapbox",
              title: function title(e) {
                return l(e, "Zoom out");
              },
              attr: "zoom",
              val: "out",
              icon: s.zoom_minus,
              click: v
            };
          }, {
            "../../fonts/ploticon": 478,
            "../../lib": 495,
            "../../plots/cartesian/axis_ids": 544,
            "../../plots/plots": 584,
            "../../registry": 593
          }],
          433: [function (e, t, n) {
            "use strict";

            n.manage = e("./manage");
          }, {
            "./manage": 434
          }],
          434: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/cartesian/axis_ids"),
              i = e("../../traces/scatter/subtypes"),
              o = e("../../registry"),
              a = e("./modebar"),
              s = e("./buttons");
            t.exports = function (e) {
              var t = e._fullLayout,
                n = e._context,
                l = t._modeBar;
              if (n.displayModeBar || n.watermark) {
                if (!Array.isArray(n.modeBarButtonsToRemove)) throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
                if (!Array.isArray(n.modeBarButtonsToAdd)) throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
                var u,
                  c = n.modeBarButtons;
                u = Array.isArray(c) && c.length ? function (e) {
                  for (var t = 0; t < e.length; t++) for (var n = e[t], r = 0; r < n.length; r++) {
                    var i = n[r];
                    if ("string" == typeof i) {
                      if (void 0 === s[i]) throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
                      e[t][r] = s[i];
                    }
                  }
                  return e;
                }(c) : !n.displayModeBar && n.watermark ? [] : function (e) {
                  var t = e._fullLayout,
                    n = e._fullData,
                    a = e._context,
                    l = a.modeBarButtonsToRemove,
                    u = a.modeBarButtonsToAdd,
                    c = t._has("cartesian"),
                    d = t._has("gl3d"),
                    h = t._has("geo"),
                    f = t._has("pie"),
                    p = t._has("funnelarea"),
                    m = t._has("gl2d"),
                    g = t._has("ternary"),
                    v = t._has("mapbox"),
                    y = t._has("polar"),
                    b = t._has("sankey"),
                    _ = function (e) {
                      for (var t = r.list({
                          _fullLayout: e
                        }, null, !0), n = 0; n < t.length; n++) if (!t[n].fixedrange) return !1;
                      return !0;
                    }(t),
                    x = [];
                  function w(e) {
                    if (e.length) {
                      for (var t = [], n = 0; n < e.length; n++) {
                        var r = e[n];
                        -1 === l.indexOf(r) && t.push(s[r]);
                      }
                      x.push(t);
                    }
                  }
                  var S = ["toImage"];
                  a.showEditInChartStudio ? S.push("editInChartStudio") : a.showSendToCloud && S.push("sendDataToCloud"), w(S);
                  var A = [],
                    E = [],
                    T = [],
                    M = [];
                  return (c || m || f || p || g) + h + d + v + y > 1 ? (E = ["toggleHover"], T = ["resetViews"]) : h ? (A = ["zoomInGeo", "zoomOutGeo"], E = ["hoverClosestGeo"], T = ["resetGeo"]) : d ? (E = ["hoverClosest3d"], T = ["resetCameraDefault3d", "resetCameraLastSave3d"]) : v ? (A = ["zoomInMapbox", "zoomOutMapbox"], E = ["toggleHover"], T = ["resetViewMapbox"]) : m ? E = ["hoverClosestGl2d"] : f ? E = ["hoverClosestPie"] : b ? (E = ["hoverClosestCartesian", "hoverCompareCartesian"], T = ["resetViewSankey"]) : E = ["toggleHover"], c && (E = ["toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"]), function (e) {
                    for (var t = 0; t < e.length; t++) if (!o.traceIs(e[t], "noHover")) return !1;
                    return !0;
                  }(n) && (E = []), !c && !m || _ || (A = ["zoomIn2d", "zoomOut2d", "autoScale2d"], "resetViews" !== T[0] && (T = ["resetScale2d"])), d ? M = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"] : (c || m) && !_ || g ? M = ["zoom2d", "pan2d"] : v || h ? M = ["pan2d"] : y && (M = ["zoom2d"]), function (e) {
                    for (var t = !1, n = 0; n < e.length && !t; n++) {
                      var r = e[n];
                      r._module && r._module.selectPoints && (o.traceIs(r, "scatter-like") ? (i.hasMarkers(r) || i.hasText(r)) && (t = !0) : o.traceIs(r, "box-violin") && "all" !== r.boxpoints && "all" !== r.points || (t = !0));
                    }
                    return t;
                  }(n) && M.push("select2d", "lasso2d"), w(M), w(A.concat(T)), w(E), function (e, t) {
                    if (t.length) if (Array.isArray(t[0])) for (var n = 0; n < t.length; n++) e.push(t[n]);else e.push(t);
                    return e;
                  }(x, u);
                }(e), l ? l.update(e, u) : t._modeBar = a(e, u);
              } else l && (l.destroy(), delete t._modeBar);
            };
          }, {
            "../../plots/cartesian/axis_ids": 544,
            "../../registry": 593,
            "../../traces/scatter/subtypes": 646,
            "./buttons": 432,
            "./modebar": 435
          }],
          435: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../../lib"),
              a = e("../../fonts/ploticon"),
              s = new DOMParser();
            function l(e) {
              this.container = e.container, this.element = document.createElement("div"), this.update(e.graphInfo, e.buttons), this.container.appendChild(this.element);
            }
            var u = l.prototype;
            u.update = function (e, t) {
              this.graphInfo = e;
              var n = this.graphInfo._context,
                r = this.graphInfo._fullLayout,
                i = "modebar-" + r._uid;
              this.element.setAttribute("id", i), this._uid = i, this.element.className = "modebar", "hover" === n.displayModeBar && (this.element.className += " modebar--hover ease-bg"), "v" === r.modebar.orientation && (this.element.className += " vertical", t = t.reverse());
              var a = r.modebar,
                s = "hover" === n.displayModeBar ? ".js-plotly-plot .plotly:hover " : "";
              o.deleteRelatedStyleRule(i), o.addRelatedStyleRule(i, s + "#" + i + " .modebar-group", "background-color: " + a.bgcolor), o.addRelatedStyleRule(i, "#" + i + " .modebar-btn .icon path", "fill: " + a.color), o.addRelatedStyleRule(i, "#" + i + " .modebar-btn:hover .icon path", "fill: " + a.activecolor), o.addRelatedStyleRule(i, "#" + i + " .modebar-btn.active .icon path", "fill: " + a.activecolor);
              var l = !this.hasButtons(t),
                u = this.hasLogo !== n.displaylogo,
                c = this.locale !== n.locale;
              if (this.locale = n.locale, (l || u || c) && (this.removeAllButtons(), this.updateButtons(t), n.watermark || n.displaylogo)) {
                var d = this.getLogo();
                n.watermark && (d.className = d.className + " watermark"), "v" === r.modebar.orientation ? this.element.insertBefore(d, this.element.childNodes[0]) : this.element.appendChild(d), this.hasLogo = !0;
              }
              this.updateActiveButton();
            }, u.updateButtons = function (e) {
              var t = this;
              this.buttons = e, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function (e) {
                var n = t.createGroup();
                e.forEach(function (e) {
                  var r = e.name;
                  if (!r) throw new Error("must provide button 'name' in button config");
                  if (-1 !== t.buttonsNames.indexOf(r)) throw new Error("button name '" + r + "' is taken");
                  t.buttonsNames.push(r);
                  var i = t.createButton(e);
                  t.buttonElements.push(i), n.appendChild(i);
                }), t.element.appendChild(n);
              });
            }, u.createGroup = function () {
              var e = document.createElement("div");
              return e.className = "modebar-group", e;
            }, u.createButton = function (e) {
              var t = this,
                n = document.createElement("a");
              n.setAttribute("rel", "tooltip"), n.className = "modebar-btn";
              var i = e.title;
              void 0 === i ? i = e.name : "function" == typeof i && (i = i(this.graphInfo)), (i || 0 === i) && n.setAttribute("data-title", i), void 0 !== e.attr && n.setAttribute("data-attr", e.attr);
              var o = e.val;
              if (void 0 !== o && ("function" == typeof o && (o = o(this.graphInfo)), n.setAttribute("data-val", o)), "function" != typeof e.click) throw new Error("must provide button 'click' function in button config");
              n.addEventListener("click", function (n) {
                e.click(t.graphInfo, n), t.updateActiveButton(n.currentTarget);
              }), n.setAttribute("data-toggle", e.toggle || !1), e.toggle && r.select(n).classed("active", !0);
              var s = e.icon;
              return "function" == typeof s ? n.appendChild(s()) : n.appendChild(this.createIcon(s || a.question)), n.setAttribute("data-gravity", e.gravity || "n"), n;
            }, u.createIcon = function (e) {
              var t,
                n = i(e.height) ? Number(e.height) : e.ascent - e.descent,
                r = "http://www.w3.org/2000/svg";
              if (e.path) {
                (t = document.createElementNS(r, "svg")).setAttribute("viewBox", [0, 0, e.width, n].join(" ")), t.setAttribute("class", "icon");
                var o = document.createElementNS(r, "path");
                o.setAttribute("d", e.path), e.transform ? o.setAttribute("transform", e.transform) : void 0 !== e.ascent && o.setAttribute("transform", "matrix(1 0 0 -1 0 " + e.ascent + ")"), t.appendChild(o);
              }
              return e.svg && (t = s.parseFromString(e.svg, "application/xml").childNodes[0]), t.setAttribute("height", "1em"), t.setAttribute("width", "1em"), t;
            }, u.updateActiveButton = function (e) {
              var t = this.graphInfo._fullLayout,
                n = void 0 !== e ? e.getAttribute("data-attr") : null;
              this.buttonElements.forEach(function (e) {
                var i = e.getAttribute("data-val") || !0,
                  a = e.getAttribute("data-attr"),
                  s = "true" === e.getAttribute("data-toggle"),
                  l = r.select(e);
                if (s) a === n && l.classed("active", !l.classed("active"));else {
                  var u = null === a ? a : o.nestedProperty(t, a).get();
                  l.classed("active", u === i);
                }
              });
            }, u.hasButtons = function (e) {
              var t = this.buttons;
              if (!t) return !1;
              if (e.length !== t.length) return !1;
              for (var n = 0; n < e.length; ++n) {
                if (e[n].length !== t[n].length) return !1;
                for (var r = 0; r < e[n].length; r++) if (e[n][r].name !== t[n][r].name) return !1;
              }
              return !0;
            }, u.getLogo = function () {
              var e = this.createGroup(),
                t = document.createElement("a");
              return t.href = "https://plot.ly/", t.target = "_blank", t.setAttribute("data-title", o._(this.graphInfo, "Produced with Plotly")), t.className = "modebar-btn plotlyjsicon modebar-btn--logo", t.appendChild(this.createIcon(a.newplotlylogo)), e.appendChild(t), e;
            }, u.removeAllButtons = function () {
              for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
              this.hasLogo = !1;
            }, u.destroy = function () {
              o.removeElement(this.container.querySelector(".modebar")), o.deleteRelatedStyleRule(this._uid);
            }, t.exports = function (e, t) {
              var n = e._fullLayout,
                i = new l({
                  graphInfo: e,
                  container: n._modebardiv.node(),
                  buttons: t
                });
              return n._privateplot && r.select(i.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), i;
            };
          }, {
            "../../fonts/ploticon": 478,
            "../../lib": 495,
            d3: 82,
            "fast-isnumeric": 91
          }],
          436: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/font_attributes"),
              i = e("../color/attributes"),
              o = (0, e("../../plot_api/plot_template").templatedArray)("button", {
                visible: {
                  valType: "boolean",
                  dflt: !0,
                  editType: "plot"
                },
                step: {
                  valType: "enumerated",
                  values: ["month", "year", "day", "hour", "minute", "second", "all"],
                  dflt: "month",
                  editType: "plot"
                },
                stepmode: {
                  valType: "enumerated",
                  values: ["backward", "todate"],
                  dflt: "backward",
                  editType: "plot"
                },
                count: {
                  valType: "number",
                  min: 0,
                  dflt: 1,
                  editType: "plot"
                },
                label: {
                  valType: "string",
                  editType: "plot"
                },
                editType: "plot"
              });
            t.exports = {
              visible: {
                valType: "boolean",
                editType: "plot"
              },
              buttons: o,
              x: {
                valType: "number",
                min: -2,
                max: 3,
                editType: "plot"
              },
              xanchor: {
                valType: "enumerated",
                values: ["auto", "left", "center", "right"],
                dflt: "left",
                editType: "plot"
              },
              y: {
                valType: "number",
                min: -2,
                max: 3,
                editType: "plot"
              },
              yanchor: {
                valType: "enumerated",
                values: ["auto", "top", "middle", "bottom"],
                dflt: "bottom",
                editType: "plot"
              },
              font: r({
                editType: "plot"
              }),
              bgcolor: {
                valType: "color",
                dflt: i.lightLine,
                editType: "plot"
              },
              activecolor: {
                valType: "color",
                editType: "plot"
              },
              bordercolor: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "plot"
              },
              borderwidth: {
                valType: "number",
                min: 0,
                dflt: 0,
                editType: "plot"
              },
              editType: "plot"
            };
          }, {
            "../../plot_api/plot_template": 531,
            "../../plots/font_attributes": 567,
            "../color/attributes": 374
          }],
          437: [function (e, t, n) {
            "use strict";

            t.exports = {
              yPad: .02,
              minButtonWidth: 30,
              rx: 3,
              ry: 3,
              lightAmount: 25,
              darkAmount: 10
            };
          }, {}],
          438: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../color"),
              o = e("../../plot_api/plot_template"),
              a = e("../../plots/array_container_defaults"),
              s = e("./attributes"),
              l = e("./constants");
            function u(e, t, n, i) {
              var o = i.calendar;
              function a(n, i) {
                return r.coerce(e, t, s.buttons, n, i);
              }
              if (a("visible")) {
                var l = a("step");
                "all" !== l && (!o || "gregorian" === o || "month" !== l && "year" !== l ? a("stepmode") : t.stepmode = "backward", a("count")), a("label");
              }
            }
            t.exports = function (e, t, n, c, d) {
              var h = e.rangeselector || {},
                f = o.newContainer(t, "rangeselector");
              function p(e, t) {
                return r.coerce(h, f, s, e, t);
              }
              if (p("visible", a(h, f, {
                name: "buttons",
                handleItemDefaults: u,
                calendar: d
              }).length > 0)) {
                var m = function (e, t, n) {
                  for (var r = n.filter(function (n) {
                      return t[n].anchor === e._id;
                    }), i = 0, o = 0; o < r.length; o++) {
                    var a = t[r[o]].domain;
                    a && (i = Math.max(a[1], i));
                  }
                  return [e.domain[0], i + l.yPad];
                }(t, n, c);
                p("x", m[0]), p("y", m[1]), r.noneOrAll(e, t, ["x", "y"]), p("xanchor"), p("yanchor"), r.coerceFont(p, "font", n.font);
                var g = p("bgcolor");
                p("activecolor", i.contrast(g, l.lightAmount, l.darkAmount)), p("bordercolor"), p("borderwidth");
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../plots/array_container_defaults": 537,
            "../color": 375,
            "./attributes": 436,
            "./constants": 437
          }],
          439: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../plots/plots"),
              a = e("../color"),
              s = e("../drawing"),
              l = e("../../lib"),
              u = e("../../lib/svg_text_utils"),
              c = e("../../plots/cartesian/axis_ids"),
              d = e("../../constants/alignment"),
              h = d.LINE_SPACING,
              f = d.FROM_TL,
              p = d.FROM_BR,
              m = e("./constants"),
              g = e("./get_update_object");
            function v(e) {
              return e._id;
            }
            function y(e, t, n) {
              var r = l.ensureSingle(e, "rect", "selector-rect", function (e) {
                e.attr("shape-rendering", "crispEdges");
              });
              r.attr({
                rx: m.rx,
                ry: m.ry
              }), r.call(a.stroke, t.bordercolor).call(a.fill, function (e, t) {
                return t._isActive || t._isHovered ? e.activecolor : e.bgcolor;
              }(t, n)).style("stroke-width", t.borderwidth + "px");
            }
            function b(e, t, n, r) {
              l.ensureSingle(e, "text", "selector-text", function (e) {
                e.classed("user-select-none", !0).attr("text-anchor", "middle");
              }).call(s.font, t.font).text(function (e, t) {
                return e.label ? t ? l.templateString(e.label, t) : e.label : "all" === e.step ? "all" : e.count + e.step.charAt(0);
              }(n, r._fullLayout._meta)).call(function (e) {
                u.convertToTspans(e, r);
              });
            }
            t.exports = function (e) {
              var t = e._fullLayout._infolayer.selectAll(".rangeselector").data(function (e) {
                for (var t = c.list(e, "x", !0), n = [], r = 0; r < t.length; r++) {
                  var i = t[r];
                  i.rangeselector && i.rangeselector.visible && n.push(i);
                }
                return n;
              }(e), v);
              t.enter().append("g").classed("rangeselector", !0), t.exit().remove(), t.style({
                cursor: "pointer",
                "pointer-events": "all"
              }), t.each(function (t) {
                var n = r.select(this),
                  a = t,
                  c = a.rangeselector,
                  d = n.selectAll("g.button").data(l.filterVisible(c.buttons));
                d.enter().append("g").classed("button", !0), d.exit().remove(), d.each(function (t) {
                  var n = r.select(this),
                    o = g(a, t);
                  t._isActive = function (e, t, n) {
                    if ("all" === t.step) return !0 === e.autorange;
                    var r = Object.keys(n);
                    return e.range[0] === n[r[0]] && e.range[1] === n[r[1]];
                  }(a, t, o), n.call(y, c, t), n.call(b, c, t, e), n.on("click", function () {
                    e._dragged || i.call("_guiRelayout", e, o);
                  }), n.on("mouseover", function () {
                    t._isHovered = !0, n.call(y, c, t);
                  }), n.on("mouseout", function () {
                    t._isHovered = !1, n.call(y, c, t);
                  });
                }), function (e, t, n, i, a) {
                  var c = 0,
                    d = 0,
                    g = n.borderwidth;
                  t.each(function () {
                    var e = r.select(this).select(".selector-text"),
                      t = n.font.size * h,
                      i = Math.max(t * u.lineCount(e), 16) + 3;
                    d = Math.max(d, i);
                  }), t.each(function () {
                    var e = r.select(this),
                      t = e.select(".selector-rect"),
                      i = e.select(".selector-text"),
                      o = i.node() && s.bBox(i.node()).width,
                      a = n.font.size * h,
                      l = u.lineCount(i),
                      f = Math.max(o + 10, m.minButtonWidth);
                    e.attr("transform", "translate(" + (g + c) + "," + g + ")"), t.attr({
                      x: 0,
                      y: 0,
                      width: f,
                      height: d
                    }), u.positionText(i, f / 2, d / 2 - (l - 1) * a / 2 + 3), c += f + 5;
                  });
                  var v = e._fullLayout._size,
                    y = v.l + v.w * n.x,
                    b = v.t + v.h * (1 - n.y),
                    _ = "left";
                  l.isRightAnchor(n) && (y -= c, _ = "right"), l.isCenterAnchor(n) && (y -= c / 2, _ = "center");
                  var x = "top";
                  l.isBottomAnchor(n) && (b -= d, x = "bottom"), l.isMiddleAnchor(n) && (b -= d / 2, x = "middle"), c = Math.ceil(c), d = Math.ceil(d), y = Math.round(y), b = Math.round(b), o.autoMargin(e, i + "-range-selector", {
                    x: n.x,
                    y: n.y,
                    l: c * f[_],
                    r: c * p[_],
                    b: d * p[x],
                    t: d * f[x]
                  }), a.attr("transform", "translate(" + y + "," + b + ")");
                }(e, d, c, a._name, n);
              });
            };
          }, {
            "../../constants/alignment": 469,
            "../../lib": 495,
            "../../lib/svg_text_utils": 518,
            "../../plots/cartesian/axis_ids": 544,
            "../../plots/plots": 584,
            "../../registry": 593,
            "../color": 375,
            "../drawing": 396,
            "./constants": 437,
            "./get_update_object": 440,
            d3: 82
          }],
          440: [function (e, t, n) {
            "use strict";

            var r = e("d3");
            t.exports = function (e, t) {
              var n = e._name,
                i = {};
              if ("all" === t.step) i[n + ".autorange"] = !0;else {
                var o = function (e, t) {
                  var n,
                    i = e.range,
                    o = new Date(e.r2l(i[1])),
                    a = t.step,
                    s = t.count;
                  switch (t.stepmode) {
                    case "backward":
                      n = e.l2r(+r.time[a].utc.offset(o, -s));
                      break;
                    case "todate":
                      var l = r.time[a].utc.offset(o, -s);
                      n = e.l2r(+r.time[a].utc.ceil(l));
                  }
                  return [n, i[1]];
                }(e, t);
                i[n + ".range[0]"] = o[0], i[n + ".range[1]"] = o[1];
              }
              return i;
            };
          }, {
            d3: 82
          }],
          441: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "component",
              name: "rangeselector",
              schema: {
                subplots: {
                  xaxis: {
                    rangeselector: e("./attributes")
                  }
                }
              },
              layoutAttributes: e("./attributes"),
              handleDefaults: e("./defaults"),
              draw: e("./draw")
            };
          }, {
            "./attributes": 436,
            "./defaults": 438,
            "./draw": 439
          }],
          442: [function (e, t, n) {
            "use strict";

            var r = e("../color/attributes");
            t.exports = {
              bgcolor: {
                valType: "color",
                dflt: r.background,
                editType: "plot"
              },
              bordercolor: {
                valType: "color",
                dflt: r.defaultLine,
                editType: "plot"
              },
              borderwidth: {
                valType: "integer",
                dflt: 0,
                min: 0,
                editType: "plot"
              },
              autorange: {
                valType: "boolean",
                dflt: !0,
                editType: "calc",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              range: {
                valType: "info_array",
                items: [{
                  valType: "any",
                  editType: "calc",
                  impliedEdits: {
                    "^autorange": !1
                  }
                }, {
                  valType: "any",
                  editType: "calc",
                  impliedEdits: {
                    "^autorange": !1
                  }
                }],
                editType: "calc",
                impliedEdits: {
                  autorange: !1
                }
              },
              thickness: {
                valType: "number",
                dflt: .15,
                min: 0,
                max: 1,
                editType: "plot"
              },
              visible: {
                valType: "boolean",
                dflt: !0,
                editType: "calc"
              },
              editType: "calc"
            };
          }, {
            "../color/attributes": 374
          }],
          443: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/cartesian/axis_ids").list,
              i = e("../../plots/cartesian/autorange").getAutoRange,
              o = e("./constants");
            t.exports = function (e) {
              for (var t = r(e, "x", !0), n = 0; n < t.length; n++) {
                var a = t[n],
                  s = a[o.name];
                s && s.visible && s.autorange && (s._input.autorange = !0, s._input.range = s.range = i(e, a));
              }
            };
          }, {
            "../../plots/cartesian/autorange": 540,
            "../../plots/cartesian/axis_ids": 544,
            "./constants": 444
          }],
          444: [function (e, t, n) {
            "use strict";

            t.exports = {
              name: "rangeslider",
              containerClassName: "rangeslider-container",
              bgClassName: "rangeslider-bg",
              rangePlotClassName: "rangeslider-rangeplot",
              maskMinClassName: "rangeslider-mask-min",
              maskMaxClassName: "rangeslider-mask-max",
              slideBoxClassName: "rangeslider-slidebox",
              grabberMinClassName: "rangeslider-grabber-min",
              grabAreaMinClassName: "rangeslider-grabarea-min",
              handleMinClassName: "rangeslider-handle-min",
              grabberMaxClassName: "rangeslider-grabber-max",
              grabAreaMaxClassName: "rangeslider-grabarea-max",
              handleMaxClassName: "rangeslider-handle-max",
              maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
              maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
              maskColor: "rgba(0,0,0,0.4)",
              maskOppAxisColor: "rgba(0,0,0,0.2)",
              slideBoxFill: "transparent",
              slideBoxCursor: "ew-resize",
              grabAreaFill: "transparent",
              grabAreaCursor: "col-resize",
              grabAreaWidth: 10,
              handleWidth: 4,
              handleRadius: 1,
              handleStrokeWidth: 1,
              extraPad: 15
            };
          }, {}],
          445: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plot_api/plot_template"),
              o = e("../../plots/cartesian/axis_ids"),
              a = e("./attributes"),
              s = e("./oppaxis_attributes");
            t.exports = function (e, t, n) {
              var l = e[n],
                u = t[n];
              if (l.rangeslider || t._requestRangeslider[u._id]) {
                r.isPlainObject(l.rangeslider) || (l.rangeslider = {});
                var c,
                  d,
                  h = l.rangeslider,
                  f = i.newContainer(u, "rangeslider");
                if (x("visible")) {
                  x("bgcolor", t.plot_bgcolor), x("bordercolor"), x("borderwidth"), x("thickness"), x("autorange", !u.isValidRange(h.range)), x("range");
                  var p = t._subplots;
                  if (p) for (var m = p.cartesian.filter(function (e) {
                      return e.substr(0, e.indexOf("y")) === o.name2id(n);
                    }).map(function (e) {
                      return e.substr(e.indexOf("y"), e.length);
                    }), g = r.simpleMap(m, o.id2name), v = 0; v < g.length; v++) {
                    var y = g[v];
                    c = h[y] || {}, d = i.newContainer(f, y, "yaxis");
                    var b,
                      _ = t[y];
                    c.range && _.isValidRange(c.range) && (b = "fixed"), "match" !== w("rangemode", b) && w("range", _.range.slice());
                  }
                  f._input = h;
                }
              }
              function x(e, t) {
                return r.coerce(h, f, a, e, t);
              }
              function w(e, t) {
                return r.coerce(c, d, s, e, t);
              }
            };
          }, {
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/axis_ids": 544,
            "./attributes": 442,
            "./oppaxis_attributes": 449
          }],
          446: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../plots/plots"),
              a = e("../../lib"),
              s = e("../drawing"),
              l = e("../color"),
              u = e("../titles"),
              c = e("../../plots/cartesian"),
              d = e("../../plots/cartesian/axis_ids"),
              h = e("../dragelement"),
              f = e("../../lib/setcursor"),
              p = e("./constants");
            function m(e, t, n, r) {
              var i = a.ensureSingle(e, "rect", p.bgClassName, function (e) {
                  e.attr({
                    x: 0,
                    y: 0,
                    "shape-rendering": "crispEdges"
                  });
                }),
                o = r.borderwidth % 2 == 0 ? r.borderwidth : r.borderwidth - 1,
                l = -r._offsetShift,
                u = s.crispRound(t, r.borderwidth);
              i.attr({
                width: r._width + o,
                height: r._height + o,
                transform: "translate(" + l + "," + l + ")",
                fill: r.bgcolor,
                stroke: r.bordercolor,
                "stroke-width": u
              });
            }
            function g(e, t, n, r) {
              var i = t._fullLayout;
              a.ensureSingleById(i._topdefs, "clipPath", r._clipId, function (e) {
                e.append("rect").attr({
                  x: 0,
                  y: 0
                });
              }).select("rect").attr({
                width: r._width,
                height: r._height
              });
            }
            function v(e, t, n, i) {
              var l,
                u = t.calcdata,
                h = e.selectAll("g." + p.rangePlotClassName).data(n._subplotsWith, a.identity);
              h.enter().append("g").attr("class", function (e) {
                return p.rangePlotClassName + " " + e;
              }).call(s.setClipUrl, i._clipId, t), h.order(), h.exit().remove(), h.each(function (e, a) {
                var s = r.select(this),
                  h = 0 === a,
                  f = d.getFromId(t, e, "y"),
                  p = f._name,
                  m = i[p],
                  g = {
                    data: [],
                    layout: {
                      xaxis: {
                        type: n.type,
                        domain: [0, 1],
                        range: i.range.slice(),
                        calendar: n.calendar
                      },
                      width: i._width,
                      height: i._height,
                      margin: {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                      }
                    },
                    _context: t._context
                  };
                g.layout[p] = {
                  type: f.type,
                  domain: [0, 1],
                  range: "match" !== m.rangemode ? m.range.slice() : f.range.slice(),
                  calendar: f.calendar
                }, o.supplyDefaults(g);
                var v = g._fullLayout.xaxis,
                  y = g._fullLayout[p];
                v.clearCalc(), v.setScale(), y.clearCalc(), y.setScale();
                var b = {
                  id: e,
                  plotgroup: s,
                  xaxis: v,
                  yaxis: y,
                  isRangePlot: !0
                };
                h ? l = b : (b.mainplot = "xy", b.mainplotinfo = l), c.rangePlot(t, b, function (e, t) {
                  for (var n = [], r = 0; r < e.length; r++) {
                    var i = e[r],
                      o = i[0].trace;
                    o.xaxis + o.yaxis === t && n.push(i);
                  }
                  return n;
                }(u, e));
              });
            }
            function y(e, t, n, r, i) {
              a.ensureSingle(e, "rect", p.maskMinClassName, function (e) {
                e.attr({
                  x: 0,
                  y: 0,
                  "shape-rendering": "crispEdges"
                });
              }).attr("height", r._height).call(l.fill, p.maskColor), a.ensureSingle(e, "rect", p.maskMaxClassName, function (e) {
                e.attr({
                  y: 0,
                  "shape-rendering": "crispEdges"
                });
              }).attr("height", r._height).call(l.fill, p.maskColor), "match" !== i.rangemode && (a.ensureSingle(e, "rect", p.maskMinOppAxisClassName, function (e) {
                e.attr({
                  y: 0,
                  "shape-rendering": "crispEdges"
                });
              }).attr("width", r._width).call(l.fill, p.maskOppAxisColor), a.ensureSingle(e, "rect", p.maskMaxOppAxisClassName, function (e) {
                e.attr({
                  y: 0,
                  "shape-rendering": "crispEdges"
                });
              }).attr("width", r._width).style("border-top", p.maskOppBorder).call(l.fill, p.maskOppAxisColor));
            }
            function b(e, t, n, r) {
              t._context.staticPlot || a.ensureSingle(e, "rect", p.slideBoxClassName, function (e) {
                e.attr({
                  y: 0,
                  cursor: p.slideBoxCursor,
                  "shape-rendering": "crispEdges"
                });
              }).attr({
                height: r._height,
                fill: p.slideBoxFill
              });
            }
            function _(e, t, n, r) {
              var i = a.ensureSingle(e, "g", p.grabberMinClassName),
                o = a.ensureSingle(e, "g", p.grabberMaxClassName),
                s = {
                  x: 0,
                  width: p.handleWidth,
                  rx: p.handleRadius,
                  fill: l.background,
                  stroke: l.defaultLine,
                  "stroke-width": p.handleStrokeWidth,
                  "shape-rendering": "crispEdges"
                },
                u = {
                  y: Math.round(r._height / 4),
                  height: Math.round(r._height / 2)
                };
              if (a.ensureSingle(i, "rect", p.handleMinClassName, function (e) {
                e.attr(s);
              }).attr(u), a.ensureSingle(o, "rect", p.handleMaxClassName, function (e) {
                e.attr(s);
              }).attr(u), !t._context.staticPlot) {
                var c = {
                  width: p.grabAreaWidth,
                  x: 0,
                  y: 0,
                  fill: p.grabAreaFill,
                  cursor: p.grabAreaCursor
                };
                a.ensureSingle(i, "rect", p.grabAreaMinClassName, function (e) {
                  e.attr(c);
                }).attr("height", r._height), a.ensureSingle(o, "rect", p.grabAreaMaxClassName, function (e) {
                  e.attr(c);
                }).attr("height", r._height);
              }
            }
            t.exports = function (e) {
              for (var t = e._fullLayout, n = t._rangeSliderData, o = 0; o < n.length; o++) {
                var s = n[o][p.name];
                s._clipId = s._id + "-" + t._uid;
              }
              var l = t._infolayer.selectAll("g." + p.containerClassName).data(n, function (e) {
                return e._name;
              });
              l.exit().each(function (e) {
                var n = e[p.name];
                t._topdefs.select("#" + n._clipId).remove();
              }).remove(), 0 !== n.length && (l.enter().append("g").classed(p.containerClassName, !0).attr("pointer-events", "all"), l.each(function (n) {
                var o = r.select(this),
                  s = n[p.name],
                  l = t[d.id2name(n.anchor)],
                  c = s[d.id2name(n.anchor)];
                if (s.range) {
                  var x,
                    w = a.simpleMap(s.range, n.r2l),
                    S = a.simpleMap(n.range, n.r2l);
                  x = S[0] < S[1] ? [Math.min(w[0], S[0]), Math.max(w[1], S[1])] : [Math.max(w[0], S[0]), Math.min(w[1], S[1])], s.range = s._input.range = a.simpleMap(x, n.l2r);
                }
                n.cleanRange("rangeslider.range");
                var A = t._size,
                  E = n.domain;
                s._width = A.w * (E[1] - E[0]);
                var T = Math.round(A.l + A.w * E[0]),
                  M = Math.round(A.t + A.h * (1 - n._counterDomainMin) + ("bottom" === n.side ? n._depth : 0) + s._offsetShift + p.extraPad);
                o.attr("transform", "translate(" + T + "," + M + ")");
                var C = n.r2l(s.range[0]),
                  k = n.r2l(s.range[1]),
                  P = k - C;
                if (s.p2d = function (e) {
                  return e / s._width * P + C;
                }, s.d2p = function (e) {
                  return (e - C) / P * s._width;
                }, s._rl = [C, k], "match" !== c.rangemode) {
                  var O = l.r2l(c.range[0]),
                    R = l.r2l(c.range[1]) - O;
                  s.d2pOppAxis = function (e) {
                    return (e - O) / R * s._height;
                  };
                }
                o.call(m, e, n, s).call(g, e, n, s).call(v, e, n, s).call(y, e, n, s, c).call(b, e, n, s).call(_, e, n, s), function (e, t, n, o) {
                  var s = e.select("rect." + p.slideBoxClassName).node(),
                    l = e.select("rect." + p.grabAreaMinClassName).node(),
                    u = e.select("rect." + p.grabAreaMaxClassName).node();
                  e.on("mousedown", function () {
                    var c = r.event,
                      d = c.target,
                      p = c.clientX,
                      m = p - e.node().getBoundingClientRect().left,
                      g = o.d2p(n._rl[0]),
                      v = o.d2p(n._rl[1]),
                      y = h.coverSlip();
                    function b(e) {
                      var c,
                        h,
                        b,
                        _ = +e.clientX - p;
                      switch (d) {
                        case s:
                          b = "ew-resize", c = g + _, h = v + _;
                          break;
                        case l:
                          b = "col-resize", c = g + _, h = v;
                          break;
                        case u:
                          b = "col-resize", c = g, h = v + _;
                          break;
                        default:
                          b = "ew-resize", c = m, h = m + _;
                      }
                      if (h < c) {
                        var x = h;
                        h = c, c = x;
                      }
                      o._pixelMin = c, o._pixelMax = h, f(r.select(y), b), function (e, t, n, r) {
                        function o(e) {
                          return n.l2r(a.constrain(e, r._rl[0], r._rl[1]));
                        }
                        var s = o(r.p2d(r._pixelMin)),
                          l = o(r.p2d(r._pixelMax));
                        window.requestAnimationFrame(function () {
                          i.call("_guiRelayout", t, n._name + ".range", [s, l]);
                        });
                      }(0, t, n, o);
                    }
                    y.addEventListener("mousemove", b), y.addEventListener("mouseup", function e() {
                      y.removeEventListener("mousemove", b), y.removeEventListener("mouseup", e), a.removeElement(y);
                    });
                  });
                }(o, e, n, s), function (e, t, n, r, i, o) {
                  var s = p.handleWidth / 2;
                  function l(e) {
                    return a.constrain(e, 0, r._width);
                  }
                  function u(e) {
                    return a.constrain(e, 0, r._height);
                  }
                  function c(e) {
                    return a.constrain(e, -s, r._width + s);
                  }
                  var d = l(r.d2p(n._rl[0])),
                    h = l(r.d2p(n._rl[1]));
                  if (e.select("rect." + p.slideBoxClassName).attr("x", d).attr("width", h - d), e.select("rect." + p.maskMinClassName).attr("width", d), e.select("rect." + p.maskMaxClassName).attr("x", h).attr("width", r._width - h), "match" !== o.rangemode) {
                    var f = r._height - u(r.d2pOppAxis(i._rl[1])),
                      m = r._height - u(r.d2pOppAxis(i._rl[0]));
                    e.select("rect." + p.maskMinOppAxisClassName).attr("x", d).attr("height", f).attr("width", h - d), e.select("rect." + p.maskMaxOppAxisClassName).attr("x", d).attr("y", m).attr("height", r._height - m).attr("width", h - d), e.select("rect." + p.slideBoxClassName).attr("y", f).attr("height", m - f);
                  }
                  var g = Math.round(c(d - s)) - .5,
                    v = Math.round(c(h - s)) + .5;
                  e.select("g." + p.grabberMinClassName).attr("transform", "translate(" + g + ",0.5)"), e.select("g." + p.grabberMaxClassName).attr("transform", "translate(" + v + ",0.5)");
                }(o, 0, n, s, l, c), "bottom" === n.side && u.draw(e, n._id + "title", {
                  propContainer: n,
                  propName: n._name + ".title",
                  placeholder: t._dfltTitle.x,
                  attributes: {
                    x: n._offset + n._length / 2,
                    y: M + s._height + s._offsetShift + 10 + 1.5 * n.title.font.size,
                    "text-anchor": "middle"
                  }
                });
              }));
            };
          }, {
            "../../lib": 495,
            "../../lib/setcursor": 514,
            "../../plots/cartesian": 552,
            "../../plots/cartesian/axis_ids": 544,
            "../../plots/plots": 584,
            "../../registry": 593,
            "../color": 375,
            "../dragelement": 393,
            "../drawing": 396,
            "../titles": 462,
            "./constants": 444,
            d3: 82
          }],
          447: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/cartesian/axis_ids"),
              i = e("../../lib/svg_text_utils"),
              o = e("./constants"),
              a = e("../../constants/alignment").LINE_SPACING,
              s = o.name;
            function l(e) {
              var t = e && e[s];
              return t && t.visible;
            }
            n.isVisible = l, n.makeData = function (e) {
              var t = r.list({
                  _fullLayout: e
                }, "x", !0),
                n = e.margin,
                i = [];
              if (!e._has("gl2d")) for (var o = 0; o < t.length; o++) {
                var a = t[o];
                if (l(a)) {
                  i.push(a);
                  var u = a[s];
                  u._id = s + a._id, u._height = (e.height - n.b - n.t) * u.thickness, u._offsetShift = Math.floor(u.borderwidth / 2);
                }
              }
              e._rangeSliderData = i;
            }, n.autoMarginOpts = function (e, t) {
              var n = e._fullLayout,
                r = t[s],
                l = t._id.charAt(0),
                u = 0,
                c = 0;
              return "bottom" === t.side && (u = t._depth, t.title.text !== n._dfltTitle[l] && (c = 1.5 * t.title.font.size + 10 + r._offsetShift, c += (t.title.text.match(i.BR_TAG_ALL) || []).length * t.title.font.size * a)), {
                x: 0,
                y: t._counterDomainMin,
                l: 0,
                r: 0,
                t: 0,
                b: r._height + u + Math.max(n.margin.b, c),
                pad: o.extraPad + 2 * r._offsetShift
              };
            };
          }, {
            "../../constants/alignment": 469,
            "../../lib/svg_text_utils": 518,
            "../../plots/cartesian/axis_ids": 544,
            "./constants": 444
          }],
          448: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./attributes"),
              o = e("./oppaxis_attributes"),
              a = e("./helpers");
            t.exports = {
              moduleType: "component",
              name: "rangeslider",
              schema: {
                subplots: {
                  xaxis: {
                    rangeslider: r.extendFlat({}, i, {
                      yaxis: o
                    })
                  }
                }
              },
              layoutAttributes: e("./attributes"),
              handleDefaults: e("./defaults"),
              calcAutorange: e("./calc_autorange"),
              draw: e("./draw"),
              isVisible: a.isVisible,
              makeData: a.makeData,
              autoMarginOpts: a.autoMarginOpts
            };
          }, {
            "../../lib": 495,
            "./attributes": 442,
            "./calc_autorange": 443,
            "./defaults": 445,
            "./draw": 446,
            "./helpers": 447,
            "./oppaxis_attributes": 449
          }],
          449: [function (e, t, n) {
            "use strict";

            t.exports = {
              _isSubplotObj: !0,
              rangemode: {
                valType: "enumerated",
                values: ["auto", "fixed", "match"],
                dflt: "match",
                editType: "calc"
              },
              range: {
                valType: "info_array",
                items: [{
                  valType: "any",
                  editType: "plot"
                }, {
                  valType: "any",
                  editType: "plot"
                }],
                editType: "plot"
              },
              editType: "calc"
            };
          }, {}],
          450: [function (e, t, n) {
            "use strict";

            var r = e("../annotations/attributes"),
              i = e("../../traces/scatter/attributes").line,
              o = e("../drawing/attributes").dash,
              a = e("../../lib/extend").extendFlat,
              s = e("../../plot_api/plot_template").templatedArray;
            t.exports = s("shape", {
              visible: {
                valType: "boolean",
                dflt: !0,
                editType: "calc+arraydraw"
              },
              type: {
                valType: "enumerated",
                values: ["circle", "rect", "path", "line"],
                editType: "calc+arraydraw"
              },
              layer: {
                valType: "enumerated",
                values: ["below", "above"],
                dflt: "above",
                editType: "arraydraw"
              },
              xref: a({}, r.xref, {}),
              xsizemode: {
                valType: "enumerated",
                values: ["scaled", "pixel"],
                dflt: "scaled",
                editType: "calc+arraydraw"
              },
              xanchor: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              x0: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              x1: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              yref: a({}, r.yref, {}),
              ysizemode: {
                valType: "enumerated",
                values: ["scaled", "pixel"],
                dflt: "scaled",
                editType: "calc+arraydraw"
              },
              yanchor: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              y0: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              y1: {
                valType: "any",
                editType: "calc+arraydraw"
              },
              path: {
                valType: "string",
                editType: "calc+arraydraw"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 1,
                editType: "arraydraw"
              },
              line: {
                color: a({}, i.color, {
                  editType: "arraydraw"
                }),
                width: a({}, i.width, {
                  editType: "calc+arraydraw"
                }),
                dash: a({}, o, {
                  editType: "arraydraw"
                }),
                editType: "calc+arraydraw"
              },
              fillcolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)",
                editType: "arraydraw"
              },
              editType: "arraydraw"
            });
          }, {
            "../../lib/extend": 489,
            "../../plot_api/plot_template": 531,
            "../../traces/scatter/attributes": 622,
            "../annotations/attributes": 360,
            "../drawing/attributes": 395
          }],
          451: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes"),
              o = e("./constants"),
              a = e("./helpers");
            function s(e) {
              return u(e.line.width, e.xsizemode, e.x0, e.x1, e.path, !1);
            }
            function l(e) {
              return u(e.line.width, e.ysizemode, e.y0, e.y1, e.path, !0);
            }
            function u(e, t, n, i, s, l) {
              var u = e / 2,
                c = l;
              if ("pixel" === t) {
                var d = s ? a.extractPathCoords(s, l ? o.paramIsY : o.paramIsX) : [n, i],
                  h = r.aggNums(Math.max, null, d),
                  f = r.aggNums(Math.min, null, d),
                  p = f < 0 ? Math.abs(f) + u : u,
                  m = h > 0 ? h + u : u;
                return {
                  ppad: u,
                  ppadplus: c ? p : m,
                  ppadminus: c ? m : p
                };
              }
              return {
                ppad: u
              };
            }
            function c(e, t, n, r, i) {
              var s = "category" === e.type || "multicategory" === e.type ? e.r2c : e.d2c;
              if (void 0 !== t) return [s(t), s(n)];
              if (r) {
                var l,
                  u,
                  c,
                  d,
                  h = 1 / 0,
                  f = -1 / 0,
                  p = r.match(o.segmentRE);
                for ("date" === e.type && (s = a.decodeDate(s)), l = 0; l < p.length; l++) void 0 !== (u = i[p[l].charAt(0)].drawn) && (!(c = p[l].substr(1).match(o.paramRE)) || c.length < u || ((d = s(c[u])) < h && (h = d), d > f && (f = d)));
                return f >= h ? [h, f] : void 0;
              }
            }
            t.exports = function (e) {
              var t = e._fullLayout,
                n = r.filterVisible(t.shapes);
              if (n.length && e._fullData.length) for (var a = 0; a < n.length; a++) {
                var u,
                  d,
                  h = n[a];
                if (h._extremes = {}, "paper" !== h.xref) {
                  var f = "pixel" === h.xsizemode ? h.xanchor : h.x0,
                    p = "pixel" === h.xsizemode ? h.xanchor : h.x1;
                  (d = c(u = i.getFromId(e, h.xref), f, p, h.path, o.paramIsX)) && (h._extremes[u._id] = i.findExtremes(u, d, s(h)));
                }
                if ("paper" !== h.yref) {
                  var m = "pixel" === h.ysizemode ? h.yanchor : h.y0,
                    g = "pixel" === h.ysizemode ? h.yanchor : h.y1;
                  (d = c(u = i.getFromId(e, h.yref), m, g, h.path, o.paramIsY)) && (h._extremes[u._id] = i.findExtremes(u, d, l(h)));
                }
              }
            };
          }, {
            "../../lib": 495,
            "../../plots/cartesian/axes": 541,
            "./constants": 452,
            "./helpers": 455
          }],
          452: [function (e, t, n) {
            "use strict";

            t.exports = {
              segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
              paramRE: /[^\s,]+/g,
              paramIsX: {
                M: {
                  0: !0,
                  drawn: 0
                },
                L: {
                  0: !0,
                  drawn: 0
                },
                H: {
                  0: !0,
                  drawn: 0
                },
                V: {},
                Q: {
                  0: !0,
                  2: !0,
                  drawn: 2
                },
                C: {
                  0: !0,
                  2: !0,
                  4: !0,
                  drawn: 4
                },
                T: {
                  0: !0,
                  drawn: 0
                },
                S: {
                  0: !0,
                  2: !0,
                  drawn: 2
                },
                Z: {}
              },
              paramIsY: {
                M: {
                  1: !0,
                  drawn: 1
                },
                L: {
                  1: !0,
                  drawn: 1
                },
                H: {},
                V: {
                  0: !0,
                  drawn: 0
                },
                Q: {
                  1: !0,
                  3: !0,
                  drawn: 3
                },
                C: {
                  1: !0,
                  3: !0,
                  5: !0,
                  drawn: 5
                },
                T: {
                  1: !0,
                  drawn: 1
                },
                S: {
                  1: !0,
                  3: !0,
                  drawn: 5
                },
                Z: {}
              },
              numParams: {
                M: 2,
                L: 2,
                H: 1,
                V: 1,
                Q: 4,
                C: 6,
                T: 2,
                S: 4,
                Z: 0
              }
            };
          }, {}],
          453: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/cartesian/axes"),
              o = e("../../plots/array_container_defaults"),
              a = e("./attributes"),
              s = e("./helpers");
            function l(e, t, n) {
              function o(n, i) {
                return r.coerce(e, t, a, n, i);
              }
              if (o("visible")) {
                o("layer"), o("opacity"), o("fillcolor"), o("line.color"), o("line.width"), o("line.dash");
                for (var l = o("type", e.path ? "path" : "rect"), u = o("xsizemode"), c = o("ysizemode"), d = ["x", "y"], h = 0; h < 2; h++) {
                  var f,
                    p,
                    m,
                    g = d[h],
                    v = g + "anchor",
                    y = "x" === g ? u : c,
                    b = {
                      _fullLayout: n
                    },
                    _ = i.coerceRef(e, t, b, g, "", "paper");
                  if ("paper" !== _ ? ((f = i.getFromId(b, _))._shapeIndices.push(t._index), m = s.rangeToShapePosition(f), p = s.shapePositionToRange(f)) : p = m = r.identity, "path" !== l) {
                    var x = g + "0",
                      w = g + "1",
                      S = e[x],
                      A = e[w];
                    e[x] = p(e[x], !0), e[w] = p(e[w], !0), "pixel" === y ? (o(x, 0), o(w, 10)) : (i.coercePosition(t, b, o, _, x, .25), i.coercePosition(t, b, o, _, w, .75)), t[x] = m(t[x]), t[w] = m(t[w]), e[x] = S, e[w] = A;
                  }
                  if ("pixel" === y) {
                    var E = e[v];
                    e[v] = p(e[v], !0), i.coercePosition(t, b, o, _, v, .25), t[v] = m(t[v]), e[v] = E;
                  }
                }
                "path" === l ? o("path") : r.noneOrAll(e, t, ["x0", "x1", "y0", "y1"]);
              }
            }
            t.exports = function (e, t) {
              o(e, t, {
                name: "shapes",
                handleItemDefaults: l
              });
            };
          }, {
            "../../lib": 495,
            "../../plots/array_container_defaults": 537,
            "../../plots/cartesian/axes": 541,
            "./attributes": 450,
            "./helpers": 455
          }],
          454: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib"),
              o = e("../../plots/cartesian/axes"),
              a = e("../color"),
              s = e("../drawing"),
              l = e("../../plot_api/plot_template").arrayEditor,
              u = e("../dragelement"),
              c = e("../../lib/setcursor"),
              d = e("./constants"),
              h = e("./helpers");
            function f(e, t) {
              e._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + t + '"]').remove();
              var n = e._fullLayout.shapes[t] || {};
              if (n._input && !1 !== n.visible) if ("below" !== n.layer) v(e._fullLayout._shapeUpperLayer);else if ("paper" === n.xref || "paper" === n.yref) v(e._fullLayout._shapeLowerLayer);else {
                var f = e._fullLayout._plots[n.xref + n.yref];
                v(f ? (f.mainplotinfo || f).shapelayer : e._fullLayout._shapeLowerLayer);
              }
              function v(f) {
                var v = {
                    "data-index": t,
                    "fill-rule": "evenodd",
                    d: m(e, n)
                  },
                  y = n.line.width ? n.line.color : "rgba(0,0,0,0)",
                  b = f.append("path").attr(v).style("opacity", n.opacity).call(a.stroke, y).call(a.fill, n.fillcolor).call(s.dashLine, n.line.dash, n.line.width);
                p(b, e, n), e._context.edits.shapePosition && function (e, t, n, a, f) {
                  var v,
                    y,
                    b,
                    _,
                    x,
                    w,
                    S,
                    A,
                    E,
                    T,
                    M,
                    C,
                    k,
                    P,
                    O,
                    R,
                    I = "pixel" === n.xsizemode,
                    j = "pixel" === n.ysizemode,
                    N = "line" === n.type,
                    L = "path" === n.type,
                    D = l(e.layout, "shapes", n),
                    B = D.modifyItem,
                    F = o.getFromId(e, n.xref),
                    z = o.getFromId(e, n.yref),
                    U = h.getDataToPixel(e, F),
                    G = h.getDataToPixel(e, z, !0),
                    V = h.getPixelToData(e, F),
                    H = h.getPixelToData(e, z, !0),
                    q = N ? function () {
                      var e = Math.max(n.line.width, 10),
                        r = f.append("g").attr("data-index", a);
                      r.append("path").attr("d", t.attr("d")).style({
                        cursor: "move",
                        "stroke-width": e,
                        "stroke-opacity": "0"
                      });
                      var i = {
                          "fill-opacity": "0"
                        },
                        o = e / 2 > 10 ? e / 2 : 10;
                      return r.append("circle").attr({
                        "data-line-point": "start-point",
                        cx: I ? U(n.xanchor) + n.x0 : U(n.x0),
                        cy: j ? G(n.yanchor) - n.y0 : G(n.y0),
                        r: o
                      }).style(i).classed("cursor-grab", !0), r.append("circle").attr({
                        "data-line-point": "end-point",
                        cx: I ? U(n.xanchor) + n.x1 : U(n.x1),
                        cy: j ? G(n.yanchor) - n.y1 : G(n.y1),
                        r: o
                      }).style(i).classed("cursor-grab", !0), r;
                    }() : t,
                    W = {
                      element: q.node(),
                      gd: e,
                      prepFn: function prepFn(r) {
                        I && (x = U(n.xanchor)), j && (w = G(n.yanchor)), "path" === n.type ? O = n.path : (v = I ? n.x0 : U(n.x0), y = j ? n.y0 : G(n.y0), b = I ? n.x1 : U(n.x1), _ = j ? n.y1 : G(n.y1)), v < b ? (E = v, k = "x0", T = b, P = "x1") : (E = b, k = "x1", T = v, P = "x0"), !j && y < _ || j && y > _ ? (S = y, M = "y0", A = _, C = "y1") : (S = _, M = "y1", A = y, C = "y0"), $(r), K(f, n), function (e, t, n) {
                          var r = t.xref,
                            i = t.yref,
                            a = o.getFromId(n, r),
                            l = o.getFromId(n, i),
                            u = "";
                          "paper" === r || a.autorange || (u += r), "paper" === i || l.autorange || (u += i), s.setClipUrl(e, u ? "clip" + n._fullLayout._uid + u : null, n);
                        }(t, n, e), W.moveFn = "move" === R ? X : Y;
                      },
                      doneFn: function doneFn() {
                        c(t), Z(f), p(t, e, n), r.call("_guiRelayout", e, D.getUpdateObj());
                      },
                      clickFn: function clickFn() {
                        Z(f);
                      }
                    };
                  function $(e) {
                    if (N) R = "path" === e.target.tagName ? "move" : "start-point" === e.target.attributes["data-line-point"].value ? "resize-over-start-point" : "resize-over-end-point";else {
                      var n = W.element.getBoundingClientRect(),
                        r = n.right - n.left,
                        i = n.bottom - n.top,
                        o = e.clientX - n.left,
                        a = e.clientY - n.top,
                        s = !L && r > 10 && i > 10 && !e.shiftKey ? u.getCursor(o / r, 1 - a / i) : "move";
                      c(t, s), R = s.split("-")[0];
                    }
                  }
                  function X(r, i) {
                    if ("path" === n.type) {
                      var o = function o(e) {
                          return e;
                        },
                        a = o,
                        s = o;
                      I ? B("xanchor", n.xanchor = V(x + r)) : (a = function a(e) {
                        return V(U(e) + r);
                      }, F && "date" === F.type && (a = h.encodeDate(a))), j ? B("yanchor", n.yanchor = H(w + i)) : (s = function s(e) {
                        return H(G(e) + i);
                      }, z && "date" === z.type && (s = h.encodeDate(s))), B("path", n.path = g(O, a, s));
                    } else I ? B("xanchor", n.xanchor = V(x + r)) : (B("x0", n.x0 = V(v + r)), B("x1", n.x1 = V(b + r))), j ? B("yanchor", n.yanchor = H(w + i)) : (B("y0", n.y0 = H(y + i)), B("y1", n.y1 = H(_ + i)));
                    t.attr("d", m(e, n)), K(f, n);
                  }
                  function Y(r, i) {
                    if (L) {
                      var o = function o(e) {
                          return e;
                        },
                        a = o,
                        s = o;
                      I ? B("xanchor", n.xanchor = V(x + r)) : (a = function a(e) {
                        return V(U(e) + r);
                      }, F && "date" === F.type && (a = h.encodeDate(a))), j ? B("yanchor", n.yanchor = H(w + i)) : (s = function s(e) {
                        return H(G(e) + i);
                      }, z && "date" === z.type && (s = h.encodeDate(s))), B("path", n.path = g(O, a, s));
                    } else if (N) {
                      if ("resize-over-start-point" === R) {
                        var l = v + r,
                          u = j ? y - i : y + i;
                        B("x0", n.x0 = I ? l : V(l)), B("y0", n.y0 = j ? u : H(u));
                      } else if ("resize-over-end-point" === R) {
                        var c = b + r,
                          d = j ? _ - i : _ + i;
                        B("x1", n.x1 = I ? c : V(c)), B("y1", n.y1 = j ? d : H(d));
                      }
                    } else {
                      var p = ~R.indexOf("n") ? S + i : S,
                        D = ~R.indexOf("s") ? A + i : A,
                        q = ~R.indexOf("w") ? E + r : E,
                        W = ~R.indexOf("e") ? T + r : T;
                      ~R.indexOf("n") && j && (p = S - i), ~R.indexOf("s") && j && (D = A - i), (!j && D - p > 10 || j && p - D > 10) && (B(M, n[M] = j ? p : H(p)), B(C, n[C] = j ? D : H(D))), W - q > 10 && (B(k, n[k] = I ? q : V(q)), B(P, n[P] = I ? W : V(W)));
                    }
                    t.attr("d", m(e, n)), K(f, n);
                  }
                  function K(e, t) {
                    (I || j) && function () {
                      var n = "path" !== t.type,
                        r = e.selectAll(".visual-cue").data([0]);
                      r.enter().append("path").attr({
                        fill: "#fff",
                        "fill-rule": "evenodd",
                        stroke: "#000",
                        "stroke-width": 1
                      }).classed("visual-cue", !0);
                      var o = U(I ? t.xanchor : i.midRange(n ? [t.x0, t.x1] : h.extractPathCoords(t.path, d.paramIsX))),
                        a = G(j ? t.yanchor : i.midRange(n ? [t.y0, t.y1] : h.extractPathCoords(t.path, d.paramIsY)));
                      if (o = h.roundPositionForSharpStrokeRendering(o, 1), a = h.roundPositionForSharpStrokeRendering(a, 1), I && j) {
                        var s = "M" + (o - 1 - 1) + "," + (a - 1 - 1) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                        r.attr("d", s);
                      } else if (I) {
                        var l = "M" + (o - 1 - 1) + "," + (a - 9 - 1) + "v18 h2 v-18 Z";
                        r.attr("d", l);
                      } else {
                        var u = "M" + (o - 9 - 1) + "," + (a - 1 - 1) + "h18 v2 h-18 Z";
                        r.attr("d", u);
                      }
                    }();
                  }
                  function Z(e) {
                    e.selectAll(".visual-cue").remove();
                  }
                  u.init(W), q.node().onmousemove = $;
                }(e, b, n, t, f);
              }
            }
            function p(e, t, n) {
              var r = (n.xref + n.yref).replace(/paper/g, "");
              s.setClipUrl(e, r ? "clip" + t._fullLayout._uid + r : null, t);
            }
            function m(e, t) {
              var n,
                r,
                a,
                s,
                l,
                u,
                c,
                f,
                p = t.type,
                m = o.getFromId(e, t.xref),
                g = o.getFromId(e, t.yref),
                v = e._fullLayout._size;
              if (m ? (n = h.shapePositionToRange(m), r = function r(e) {
                return m._offset + m.r2p(n(e, !0));
              }) : r = function r(e) {
                return v.l + v.w * e;
              }, g ? (a = h.shapePositionToRange(g), s = function s(e) {
                return g._offset + g.r2p(a(e, !0));
              }) : s = function s(e) {
                return v.t + v.h * (1 - e);
              }, "path" === p) return m && "date" === m.type && (r = h.decodeDate(r)), g && "date" === g.type && (s = h.decodeDate(s)), function (e, t, n) {
                var r = e.path,
                  o = e.xsizemode,
                  a = e.ysizemode,
                  s = e.xanchor,
                  l = e.yanchor;
                return r.replace(d.segmentRE, function (e) {
                  var r = 0,
                    u = e.charAt(0),
                    c = d.paramIsX[u],
                    h = d.paramIsY[u],
                    f = d.numParams[u],
                    p = e.substr(1).replace(d.paramRE, function (e) {
                      return c[r] ? e = "pixel" === o ? t(s) + Number(e) : t(e) : h[r] && (e = "pixel" === a ? n(l) - Number(e) : n(e)), ++r > f && (e = "X"), e;
                    });
                  return r > f && (p = p.replace(/[\s,]*X.*/, ""), i.log("Ignoring extra params in segment " + e)), u + p;
                });
              }(t, r, s);
              if ("pixel" === t.xsizemode) {
                var y = r(t.xanchor);
                l = y + t.x0, u = y + t.x1;
              } else l = r(t.x0), u = r(t.x1);
              if ("pixel" === t.ysizemode) {
                var b = s(t.yanchor);
                c = b - t.y0, f = b - t.y1;
              } else c = s(t.y0), f = s(t.y1);
              if ("line" === p) return "M" + l + "," + c + "L" + u + "," + f;
              if ("rect" === p) return "M" + l + "," + c + "H" + u + "V" + f + "H" + l + "Z";
              var _ = (l + u) / 2,
                x = (c + f) / 2,
                w = Math.abs(_ - l),
                S = Math.abs(x - c),
                A = "A" + w + "," + S,
                E = _ + w + "," + x;
              return "M" + E + A + " 0 1,1 " + _ + "," + (x - S) + A + " 0 0,1 " + E + "Z";
            }
            function g(e, t, n) {
              return e.replace(d.segmentRE, function (e) {
                var r = 0,
                  i = e.charAt(0),
                  o = d.paramIsX[i],
                  a = d.paramIsY[i],
                  s = d.numParams[i];
                return i + e.substr(1).replace(d.paramRE, function (e) {
                  return r >= s || (o[r] ? e = t(e) : a[r] && (e = n(e)), r++), e;
                });
              });
            }
            t.exports = {
              draw: function draw(e) {
                var t = e._fullLayout;
                for (var n in t._shapeUpperLayer.selectAll("path").remove(), t._shapeLowerLayer.selectAll("path").remove(), t._plots) {
                  var r = t._plots[n].shapelayer;
                  r && r.selectAll("path").remove();
                }
                for (var i = 0; i < t.shapes.length; i++) t.shapes[i].visible && f(e, i);
              },
              drawOne: f
            };
          }, {
            "../../lib": 495,
            "../../lib/setcursor": 514,
            "../../plot_api/plot_template": 531,
            "../../plots/cartesian/axes": 541,
            "../../registry": 593,
            "../color": 375,
            "../dragelement": 393,
            "../drawing": 396,
            "./constants": 452,
            "./helpers": 455
          }],
          455: [function (e, t, n) {
            "use strict";

            var r = e("./constants"),
              i = e("../../lib");
            n.rangeToShapePosition = function (e) {
              return "log" === e.type ? e.r2d : function (e) {
                return e;
              };
            }, n.shapePositionToRange = function (e) {
              return "log" === e.type ? e.d2r : function (e) {
                return e;
              };
            }, n.decodeDate = function (e) {
              return function (t) {
                return t.replace && (t = t.replace("_", " ")), e(t);
              };
            }, n.encodeDate = function (e) {
              return function (t) {
                return e(t).replace(" ", "_");
              };
            }, n.extractPathCoords = function (e, t) {
              var n = [];
              return e.match(r.segmentRE).forEach(function (e) {
                var o = t[e.charAt(0)].drawn;
                if (void 0 !== o) {
                  var a = e.substr(1).match(r.paramRE);
                  !a || a.length < o || n.push(i.cleanNumber(a[o]));
                }
              }), n;
            }, n.getDataToPixel = function (e, t, r) {
              var i,
                o = e._fullLayout._size;
              if (t) {
                var a = n.shapePositionToRange(t);
                i = function i(e) {
                  return t._offset + t.r2p(a(e, !0));
                }, "date" === t.type && (i = n.decodeDate(i));
              } else i = r ? function (e) {
                return o.t + o.h * (1 - e);
              } : function (e) {
                return o.l + o.w * e;
              };
              return i;
            }, n.getPixelToData = function (e, t, r) {
              var i,
                o = e._fullLayout._size;
              if (t) {
                var a = n.rangeToShapePosition(t);
                i = function i(e) {
                  return a(t.p2r(e - t._offset));
                };
              } else i = r ? function (e) {
                return 1 - (e - o.t) / o.h;
              } : function (e) {
                return (e - o.l) / o.w;
              };
              return i;
            }, n.roundPositionForSharpStrokeRendering = function (e, t) {
              var n = 1 === Math.round(t % 2),
                r = Math.round(e);
              return n ? r + .5 : r;
            };
          }, {
            "../../lib": 495,
            "./constants": 452
          }],
          456: [function (e, t, n) {
            "use strict";

            var r = e("./draw");
            t.exports = {
              moduleType: "component",
              name: "shapes",
              layoutAttributes: e("./attributes"),
              supplyLayoutDefaults: e("./defaults"),
              includeBasePlot: e("../../plots/cartesian/include_components")("shapes"),
              calcAutorange: e("./calc_autorange"),
              draw: r.draw,
              drawOne: r.drawOne
            };
          }, {
            "../../plots/cartesian/include_components": 551,
            "./attributes": 450,
            "./calc_autorange": 451,
            "./defaults": 453,
            "./draw": 454
          }],
          457: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/font_attributes"),
              i = e("../../plots/pad_attributes"),
              o = e("../../lib/extend").extendDeepAll,
              a = e("../../plot_api/edit_types").overrideAll,
              s = e("../../plots/animation_attributes"),
              l = e("../../plot_api/plot_template").templatedArray,
              u = e("./constants"),
              c = l("step", {
                visible: {
                  valType: "boolean",
                  dflt: !0
                },
                method: {
                  valType: "enumerated",
                  values: ["restyle", "relayout", "animate", "update", "skip"],
                  dflt: "restyle"
                },
                args: {
                  valType: "info_array",
                  freeLength: !0,
                  items: [{
                    valType: "any"
                  }, {
                    valType: "any"
                  }, {
                    valType: "any"
                  }]
                },
                label: {
                  valType: "string"
                },
                value: {
                  valType: "string"
                },
                execute: {
                  valType: "boolean",
                  dflt: !0
                }
              });
            t.exports = a(l("slider", {
              visible: {
                valType: "boolean",
                dflt: !0
              },
              active: {
                valType: "number",
                min: 0,
                dflt: 0
              },
              steps: c,
              lenmode: {
                valType: "enumerated",
                values: ["fraction", "pixels"],
                dflt: "fraction"
              },
              len: {
                valType: "number",
                min: 0,
                dflt: 1
              },
              x: {
                valType: "number",
                min: -2,
                max: 3,
                dflt: 0
              },
              pad: o(i({
                editType: "arraydraw"
              }), {}, {
                t: {
                  dflt: 20
                }
              }),
              xanchor: {
                valType: "enumerated",
                values: ["auto", "left", "center", "right"],
                dflt: "left"
              },
              y: {
                valType: "number",
                min: -2,
                max: 3,
                dflt: 0
              },
              yanchor: {
                valType: "enumerated",
                values: ["auto", "top", "middle", "bottom"],
                dflt: "top"
              },
              transition: {
                duration: {
                  valType: "number",
                  min: 0,
                  dflt: 150
                },
                easing: {
                  valType: "enumerated",
                  values: s.transition.easing.values,
                  dflt: "cubic-in-out"
                }
              },
              currentvalue: {
                visible: {
                  valType: "boolean",
                  dflt: !0
                },
                xanchor: {
                  valType: "enumerated",
                  values: ["left", "center", "right"],
                  dflt: "left"
                },
                offset: {
                  valType: "number",
                  dflt: 10
                },
                prefix: {
                  valType: "string"
                },
                suffix: {
                  valType: "string"
                },
                font: r({})
              },
              font: r({}),
              activebgcolor: {
                valType: "color",
                dflt: u.gripBgActiveColor
              },
              bgcolor: {
                valType: "color",
                dflt: u.railBgColor
              },
              bordercolor: {
                valType: "color",
                dflt: u.railBorderColor
              },
              borderwidth: {
                valType: "number",
                min: 0,
                dflt: u.railBorderWidth
              },
              ticklen: {
                valType: "number",
                min: 0,
                dflt: u.tickLength
              },
              tickcolor: {
                valType: "color",
                dflt: u.tickColor
              },
              tickwidth: {
                valType: "number",
                min: 0,
                dflt: 1
              },
              minorticklen: {
                valType: "number",
                min: 0,
                dflt: u.minorTickLength
              }
            }), "arraydraw", "from-root");
          }, {
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plot_api/plot_template": 531,
            "../../plots/animation_attributes": 536,
            "../../plots/font_attributes": 567,
            "../../plots/pad_attributes": 583,
            "./constants": 458
          }],
          458: [function (e, t, n) {
            "use strict";

            t.exports = {
              name: "sliders",
              containerClassName: "slider-container",
              groupClassName: "slider-group",
              inputAreaClass: "slider-input-area",
              railRectClass: "slider-rail-rect",
              railTouchRectClass: "slider-rail-touch-rect",
              gripRectClass: "slider-grip-rect",
              tickRectClass: "slider-tick-rect",
              inputProxyClass: "slider-input-proxy",
              labelsClass: "slider-labels",
              labelGroupClass: "slider-label-group",
              labelClass: "slider-label",
              currentValueClass: "slider-current-value",
              railHeight: 5,
              menuIndexAttrName: "slider-active-index",
              autoMarginIdRoot: "slider-",
              minWidth: 30,
              minHeight: 30,
              textPadX: 40,
              arrowOffsetX: 4,
              railRadius: 2,
              railWidth: 5,
              railBorder: 4,
              railBorderWidth: 1,
              railBorderColor: "#bec8d9",
              railBgColor: "#f8fafc",
              railInset: 8,
              stepInset: 10,
              gripRadius: 10,
              gripWidth: 20,
              gripHeight: 20,
              gripBorder: 20,
              gripBorderWidth: 1,
              gripBorderColor: "#bec8d9",
              gripBgColor: "#f6f8fa",
              gripBgActiveColor: "#dbdde0",
              labelPadding: 8,
              labelOffset: 0,
              tickWidth: 1,
              tickColor: "#333",
              tickOffset: 25,
              tickLength: 7,
              minorTickOffset: 25,
              minorTickColor: "#333",
              minorTickLength: 4,
              currentValuePadding: 8,
              currentValueInset: 0
            };
          }, {}],
          459: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/array_container_defaults"),
              o = e("./attributes"),
              a = e("./constants").name,
              s = o.steps;
            function l(e, t, n) {
              function a(n, i) {
                return r.coerce(e, t, o, n, i);
              }
              for (var s = i(e, t, {
                  name: "steps",
                  handleItemDefaults: u
                }), l = 0, c = 0; c < s.length; c++) s[c].visible && l++;
              if (l < 2 ? t.visible = !1 : a("visible")) {
                t._stepCount = l;
                var d = t._visibleSteps = r.filterVisible(s);
                (s[a("active")] || {}).visible || (t.active = d[0]._index), a("x"), a("y"), r.noneOrAll(e, t, ["x", "y"]), a("xanchor"), a("yanchor"), a("len"), a("lenmode"), a("pad.t"), a("pad.r"), a("pad.b"), a("pad.l"), r.coerceFont(a, "font", n.font), a("currentvalue.visible") && (a("currentvalue.xanchor"), a("currentvalue.prefix"), a("currentvalue.suffix"), a("currentvalue.offset"), r.coerceFont(a, "currentvalue.font", t.font)), a("transition.duration"), a("transition.easing"), a("bgcolor"), a("activebgcolor"), a("bordercolor"), a("borderwidth"), a("ticklen"), a("tickwidth"), a("tickcolor"), a("minorticklen");
              }
            }
            function u(e, t) {
              function n(n, i) {
                return r.coerce(e, t, s, n, i);
              }
              if ("skip" === e.method || Array.isArray(e.args) ? n("visible") : t.visible = !1) {
                n("method"), n("args");
                var i = n("label", "step-" + t._index);
                n("value", i), n("execute");
              }
            }
            t.exports = function (e, t) {
              i(e, t, {
                name: a,
                handleItemDefaults: l
              });
            };
          }, {
            "../../lib": 495,
            "../../plots/array_container_defaults": 537,
            "./attributes": 457,
            "./constants": 458
          }],
          460: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../plots/plots"),
              o = e("../color"),
              a = e("../drawing"),
              s = e("../../lib"),
              l = e("../../lib/svg_text_utils"),
              u = e("../../plot_api/plot_template").arrayEditor,
              c = e("./constants"),
              d = e("../../constants/alignment"),
              h = d.LINE_SPACING,
              f = d.FROM_TL,
              p = d.FROM_BR;
            function m(e) {
              return c.autoMarginIdRoot + e._index;
            }
            function g(e) {
              return e._index;
            }
            function v(e, t) {
              var n = a.tester.selectAll("g." + c.labelGroupClass).data(t._visibleSteps);
              n.enter().append("g").classed(c.labelGroupClass, !0);
              var o = 0,
                u = 0;
              n.each(function (e) {
                var n = _(r.select(this), {
                  step: e
                }, t).node();
                if (n) {
                  var i = a.bBox(n);
                  u = Math.max(u, i.height), o = Math.max(o, i.width);
                }
              }), n.remove();
              var d = t._dims = {};
              d.inputAreaWidth = Math.max(c.railWidth, c.gripHeight);
              var h = e._fullLayout._size;
              d.lx = h.l + h.w * t.x, d.ly = h.t + h.h * (1 - t.y), "fraction" === t.lenmode ? d.outerLength = Math.round(h.w * t.len) : d.outerLength = t.len, d.inputAreaStart = 0, d.inputAreaLength = Math.round(d.outerLength - t.pad.l - t.pad.r);
              var g = (d.inputAreaLength - 2 * c.stepInset) / (t._stepCount - 1),
                v = o + c.labelPadding;
              if (d.labelStride = Math.max(1, Math.ceil(v / g)), d.labelHeight = u, d.currentValueMaxWidth = 0, d.currentValueHeight = 0, d.currentValueTotalHeight = 0, d.currentValueMaxLines = 1, t.currentvalue.visible) {
                var b = a.tester.append("g");
                n.each(function (e) {
                  var n = y(b, t, e.label),
                    r = n.node() && a.bBox(n.node()) || {
                      width: 0,
                      height: 0
                    },
                    i = l.lineCount(n);
                  d.currentValueMaxWidth = Math.max(d.currentValueMaxWidth, Math.ceil(r.width)), d.currentValueHeight = Math.max(d.currentValueHeight, Math.ceil(r.height)), d.currentValueMaxLines = Math.max(d.currentValueMaxLines, i);
                }), d.currentValueTotalHeight = d.currentValueHeight + t.currentvalue.offset, b.remove();
              }
              d.height = d.currentValueTotalHeight + c.tickOffset + t.ticklen + c.labelOffset + d.labelHeight + t.pad.t + t.pad.b;
              var x = "left";
              s.isRightAnchor(t) && (d.lx -= d.outerLength, x = "right"), s.isCenterAnchor(t) && (d.lx -= d.outerLength / 2, x = "center");
              var w = "top";
              s.isBottomAnchor(t) && (d.ly -= d.height, w = "bottom"), s.isMiddleAnchor(t) && (d.ly -= d.height / 2, w = "middle"), d.outerLength = Math.ceil(d.outerLength), d.height = Math.ceil(d.height), d.lx = Math.round(d.lx), d.ly = Math.round(d.ly);
              var S = {
                y: t.y,
                b: d.height * p[w],
                t: d.height * f[w]
              };
              "fraction" === t.lenmode ? (S.l = 0, S.xl = t.x - t.len * f[x], S.r = 0, S.xr = t.x + t.len * p[x]) : (S.x = t.x, S.l = d.outerLength * f[x], S.r = d.outerLength * p[x]), i.autoMargin(e, m(t), S);
            }
            function y(e, t, n) {
              if (t.currentvalue.visible) {
                var r,
                  i,
                  o = t._dims;
                switch (t.currentvalue.xanchor) {
                  case "right":
                    r = o.inputAreaLength - c.currentValueInset - o.currentValueMaxWidth, i = "left";
                    break;
                  case "center":
                    r = .5 * o.inputAreaLength, i = "middle";
                    break;
                  default:
                    r = c.currentValueInset, i = "left";
                }
                var u = s.ensureSingle(e, "text", c.labelClass, function (e) {
                    e.classed("user-select-none", !0).attr({
                      "text-anchor": i,
                      "data-notex": 1
                    });
                  }),
                  d = t.currentvalue.prefix ? t.currentvalue.prefix : "";
                if ("string" == typeof n) d += n;else {
                  var f = t.steps[t.active].label,
                    p = t._gd._fullLayout._meta;
                  p && (f = s.templateString(f, p)), d += f;
                }
                t.currentvalue.suffix && (d += t.currentvalue.suffix), u.call(a.font, t.currentvalue.font).text(d).call(l.convertToTspans, t._gd);
                var m = l.lineCount(u),
                  g = (o.currentValueMaxLines + 1 - m) * t.currentvalue.font.size * h;
                return l.positionText(u, r, g), u;
              }
            }
            function b(e, t, n) {
              s.ensureSingle(e, "rect", c.gripRectClass, function (r) {
                r.call(A, t, e, n).style("pointer-events", "all");
              }).attr({
                width: c.gripWidth,
                height: c.gripHeight,
                rx: c.gripRadius,
                ry: c.gripRadius
              }).call(o.stroke, n.bordercolor).call(o.fill, n.bgcolor).style("stroke-width", n.borderwidth + "px");
            }
            function _(e, t, n) {
              var r = s.ensureSingle(e, "text", c.labelClass, function (e) {
                  e.classed("user-select-none", !0).attr({
                    "text-anchor": "middle",
                    "data-notex": 1
                  });
                }),
                i = t.step.label,
                o = n._gd._fullLayout._meta;
              return o && (i = s.templateString(i, o)), r.call(a.font, n.font).text(i).call(l.convertToTspans, n._gd), r;
            }
            function x(e, t) {
              var n = s.ensureSingle(e, "g", c.labelsClass),
                i = t._dims,
                o = n.selectAll("g." + c.labelGroupClass).data(i.labelSteps);
              o.enter().append("g").classed(c.labelGroupClass, !0), o.exit().remove(), o.each(function (e) {
                var n = r.select(this);
                n.call(_, e, t), a.setTranslate(n, M(t, e.fraction), c.tickOffset + t.ticklen + t.font.size * h + c.labelOffset + i.currentValueTotalHeight);
              });
            }
            function w(e, t, n, r, i) {
              var o = Math.round(r * (n._stepCount - 1)),
                a = n._visibleSteps[o]._index;
              a !== n.active && S(e, t, n, a, !0, i);
            }
            function S(e, t, n, r, o, a) {
              var s = n.active;
              n.active = r, u(e.layout, c.name, n).applyUpdate("active", r);
              var l = n.steps[n.active];
              t.call(T, n, a), t.call(y, n), e.emit("plotly_sliderchange", {
                slider: n,
                step: n.steps[n.active],
                interaction: o,
                previousActive: s
              }), l && l.method && o && (t._nextMethod ? (t._nextMethod.step = l, t._nextMethod.doCallback = o, t._nextMethod.doTransition = a) : (t._nextMethod = {
                step: l,
                doCallback: o,
                doTransition: a
              }, t._nextMethodRaf = window.requestAnimationFrame(function () {
                var n = t._nextMethod.step;
                n.method && (n.execute && i.executeAPICommand(e, n.method, n.args), t._nextMethod = null, t._nextMethodRaf = null);
              })));
            }
            function A(e, t, n) {
              var i = n.node(),
                a = r.select(t);
              function s() {
                return n.data()[0];
              }
              e.on("mousedown", function () {
                var e = s();
                t.emit("plotly_sliderstart", {
                  slider: e
                });
                var l = n.select("." + c.gripRectClass);
                r.event.stopPropagation(), r.event.preventDefault(), l.call(o.fill, e.activebgcolor);
                var u = C(e, r.mouse(i)[0]);
                w(t, n, e, u, !0), e._dragging = !0, a.on("mousemove", function () {
                  var e = s(),
                    o = C(e, r.mouse(i)[0]);
                  w(t, n, e, o, !1);
                }), a.on("mouseup", function () {
                  var e = s();
                  e._dragging = !1, l.call(o.fill, e.bgcolor), a.on("mouseup", null), a.on("mousemove", null), t.emit("plotly_sliderend", {
                    slider: e,
                    step: e.steps[e.active]
                  });
                });
              });
            }
            function E(e, t) {
              var n = e.selectAll("rect." + c.tickRectClass).data(t._visibleSteps),
                i = t._dims;
              n.enter().append("rect").classed(c.tickRectClass, !0), n.exit().remove(), n.attr({
                width: t.tickwidth + "px",
                "shape-rendering": "crispEdges"
              }), n.each(function (e, n) {
                var s = n % i.labelStride == 0,
                  l = r.select(this);
                l.attr({
                  height: s ? t.ticklen : t.minorticklen
                }).call(o.fill, t.tickcolor), a.setTranslate(l, M(t, n / (t._stepCount - 1)) - .5 * t.tickwidth, (s ? c.tickOffset : c.minorTickOffset) + i.currentValueTotalHeight);
              });
            }
            function T(e, t, n) {
              for (var r = e.select("rect." + c.gripRectClass), i = 0, o = 0; o < t._stepCount; o++) if (t._visibleSteps[o]._index === t.active) {
                i = o;
                break;
              }
              var a = M(t, i / (t._stepCount - 1));
              if (!t._invokingCommand) {
                var s = r;
                n && t.transition.duration > 0 && (s = s.transition().duration(t.transition.duration).ease(t.transition.easing)), s.attr("transform", "translate(" + (a - .5 * c.gripWidth) + "," + t._dims.currentValueTotalHeight + ")");
              }
            }
            function M(e, t) {
              var n = e._dims;
              return n.inputAreaStart + c.stepInset + (n.inputAreaLength - 2 * c.stepInset) * Math.min(1, Math.max(0, t));
            }
            function C(e, t) {
              var n = e._dims;
              return Math.min(1, Math.max(0, (t - c.stepInset - n.inputAreaStart) / (n.inputAreaLength - 2 * c.stepInset - 2 * n.inputAreaStart)));
            }
            function k(e, t, n) {
              var r = n._dims,
                i = s.ensureSingle(e, "rect", c.railTouchRectClass, function (r) {
                  r.call(A, t, e, n).style("pointer-events", "all");
                });
              i.attr({
                width: r.inputAreaLength,
                height: Math.max(r.inputAreaWidth, c.tickOffset + n.ticklen + r.labelHeight)
              }).call(o.fill, n.bgcolor).attr("opacity", 0), a.setTranslate(i, 0, r.currentValueTotalHeight);
            }
            function P(e, t) {
              var n = t._dims,
                r = n.inputAreaLength - 2 * c.railInset,
                i = s.ensureSingle(e, "rect", c.railRectClass);
              i.attr({
                width: r,
                height: c.railWidth,
                rx: c.railRadius,
                ry: c.railRadius,
                "shape-rendering": "crispEdges"
              }).call(o.stroke, t.bordercolor).call(o.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px"), a.setTranslate(i, c.railInset, .5 * (n.inputAreaWidth - c.railWidth) + n.currentValueTotalHeight);
            }
            t.exports = function (e) {
              var t = e._fullLayout,
                n = function (e, t) {
                  for (var n = e[c.name], r = [], i = 0; i < n.length; i++) {
                    var o = n[i];
                    o.visible && (o._gd = t, r.push(o));
                  }
                  return r;
                }(t, e),
                o = t._infolayer.selectAll("g." + c.containerClassName).data(n.length > 0 ? [0] : []);
              function s(t) {
                t._commandObserver && (t._commandObserver.remove(), delete t._commandObserver), i.autoMargin(e, m(t));
              }
              if (o.enter().append("g").classed(c.containerClassName, !0).style("cursor", "ew-resize"), o.exit().each(function () {
                r.select(this).selectAll("g." + c.groupClassName).each(s);
              }).remove(), 0 !== n.length) {
                var l = o.selectAll("g." + c.groupClassName).data(n, g);
                l.enter().append("g").classed(c.groupClassName, !0), l.exit().each(s).remove();
                for (var u = 0; u < n.length; u++) {
                  var d = n[u];
                  v(e, d);
                }
                l.each(function (t) {
                  var n = r.select(this);
                  !function (e) {
                    var t = e._dims;
                    t.labelSteps = [];
                    for (var n = e._stepCount, r = 0; r < n; r += t.labelStride) t.labelSteps.push({
                      fraction: r / (n - 1),
                      step: e._visibleSteps[r]
                    });
                  }(t), i.manageCommandObserver(e, t, t._visibleSteps, function (t) {
                    var r = n.data()[0];
                    r.active !== t.index && (r._dragging || S(e, n, r, t.index, !1, !0));
                  }), function (e, t, n) {
                    (n.steps[n.active] || {}).visible || (n.active = n._visibleSteps[0]._index), t.call(y, n).call(P, n).call(x, n).call(E, n).call(k, e, n).call(b, e, n);
                    var r = n._dims;
                    a.setTranslate(t, r.lx + n.pad.l, r.ly + n.pad.t), t.call(T, n, !1), t.call(y, n);
                  }(e, r.select(this), t);
                });
              }
            };
          }, {
            "../../constants/alignment": 469,
            "../../lib": 495,
            "../../lib/svg_text_utils": 518,
            "../../plot_api/plot_template": 531,
            "../../plots/plots": 584,
            "../color": 375,
            "../drawing": 396,
            "./constants": 458,
            d3: 82
          }],
          461: [function (e, t, n) {
            "use strict";

            var r = e("./constants");
            t.exports = {
              moduleType: "component",
              name: r.name,
              layoutAttributes: e("./attributes"),
              supplyLayoutDefaults: e("./defaults"),
              draw: e("./draw")
            };
          }, {
            "./attributes": 457,
            "./constants": 458,
            "./defaults": 459,
            "./draw": 460
          }],
          462: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../../plots/plots"),
              a = e("../../registry"),
              s = e("../../lib"),
              l = e("../drawing"),
              u = e("../color"),
              c = e("../../lib/svg_text_utils"),
              d = e("../../constants/interactions"),
              h = e("../../constants/alignment").OPPOSITE_SIDE,
              f = / [XY][0-9]* /;
            t.exports = {
              draw: function draw(e, t, n) {
                var p,
                  m = n.propContainer,
                  g = n.propName,
                  v = n.placeholder,
                  y = n.traceIndex,
                  b = n.avoid || {},
                  _ = n.attributes,
                  x = n.transform,
                  w = n.containerGroup,
                  S = e._fullLayout,
                  A = 1,
                  E = !1,
                  T = m.title,
                  M = (T && T.text ? T.text : "").trim(),
                  C = T && T.font ? T.font : {},
                  k = C.family,
                  P = C.size,
                  O = C.color;
                "title.text" === g ? p = "titleText" : -1 !== g.indexOf("axis") ? p = "axisTitleText" : g.indexOf(!0) && (p = "colorbarTitleText");
                var R = e._context.edits[p];
                "" === M ? A = 0 : M.replace(f, " % ") === v.replace(f, " % ") && (A = .2, E = !0, R || (M = "")), n._meta ? M = s.templateString(M, n._meta) : S._meta && (M = s.templateString(M, S._meta));
                var I = M || R;
                w || (w = s.ensureSingle(S._infolayer, "g", "g-" + t));
                var j = w.selectAll("text").data(I ? [0] : []);
                if (j.enter().append("text"), j.text(M).attr("class", t), j.exit().remove(), !I) return w;
                function N(e) {
                  s.syncOrAsync([L, D], e);
                }
                function L(t) {
                  var n;
                  return x ? (n = "", x.rotate && (n += "rotate(" + [x.rotate, _.x, _.y] + ")"), x.offset && (n += "translate(0, " + x.offset + ")")) : n = null, t.attr("transform", n), t.style({
                    "font-family": k,
                    "font-size": r.round(P, 2) + "px",
                    fill: u.rgb(O),
                    opacity: A * u.opacity(O),
                    "font-weight": o.fontWeight
                  }).attr(_).call(c.convertToTspans, e), o.previousPromises(e);
                }
                function D(e) {
                  var t = r.select(e.node().parentNode);
                  if (b && b.selection && b.side && M) {
                    t.attr("transform", null);
                    var n = h[b.side],
                      o = "left" === b.side || "top" === b.side ? -1 : 1,
                      a = i(b.pad) ? b.pad : 2,
                      u = l.bBox(t.node()),
                      c = {
                        left: 0,
                        top: 0,
                        right: S.width,
                        bottom: S.height
                      },
                      d = b.maxShift || o * (c[b.side] - u[b.side]),
                      f = 0;
                    if (d < 0) f = d;else {
                      var p = b.offsetLeft || 0,
                        m = b.offsetTop || 0;
                      u.left -= p, u.right -= p, u.top -= m, u.bottom -= m, b.selection.each(function () {
                        var e = l.bBox(this);
                        s.bBoxIntersect(u, e, a) && (f = Math.max(f, o * (e[b.side] - u[n]) + a));
                      }), f = Math.min(d, f);
                    }
                    if (f > 0 || d < 0) {
                      var g = {
                        left: [-f, 0],
                        right: [f, 0],
                        top: [0, -f],
                        bottom: [0, f]
                      }[b.side];
                      t.attr("transform", "translate(" + g + ")");
                    }
                  }
                }
                return j.call(N), R && (M ? j.on(".opacity", null) : (A = 0, E = !0, j.text(v).on("mouseover.opacity", function () {
                  r.select(this).transition().duration(d.SHOW_PLACEHOLDER).style("opacity", 1);
                }).on("mouseout.opacity", function () {
                  r.select(this).transition().duration(d.HIDE_PLACEHOLDER).style("opacity", 0);
                })), j.call(c.makeEditable, {
                  gd: e
                }).on("edit", function (t) {
                  void 0 !== y ? a.call("_guiRestyle", e, g, t, y) : a.call("_guiRelayout", e, g, t);
                }).on("cancel", function () {
                  this.text(this.attr("data-unformatted")).call(N);
                }).on("input", function (e) {
                  this.text(e || " ").call(c.positionText, _.x, _.y);
                })), j.classed("js-placeholder", E), w;
              }
            };
          }, {
            "../../constants/alignment": 469,
            "../../constants/interactions": 473,
            "../../lib": 495,
            "../../lib/svg_text_utils": 518,
            "../../plots/plots": 584,
            "../../registry": 593,
            "../color": 375,
            "../drawing": 396,
            d3: 82,
            "fast-isnumeric": 91
          }],
          463: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/font_attributes"),
              i = e("../color/attributes"),
              o = e("../../lib/extend").extendFlat,
              a = e("../../plot_api/edit_types").overrideAll,
              s = e("../../plots/pad_attributes"),
              l = e("../../plot_api/plot_template").templatedArray,
              u = l("button", {
                visible: {
                  valType: "boolean"
                },
                method: {
                  valType: "enumerated",
                  values: ["restyle", "relayout", "animate", "update", "skip"],
                  dflt: "restyle"
                },
                args: {
                  valType: "info_array",
                  freeLength: !0,
                  items: [{
                    valType: "any"
                  }, {
                    valType: "any"
                  }, {
                    valType: "any"
                  }]
                },
                args2: {
                  valType: "info_array",
                  freeLength: !0,
                  items: [{
                    valType: "any"
                  }, {
                    valType: "any"
                  }, {
                    valType: "any"
                  }]
                },
                label: {
                  valType: "string",
                  dflt: ""
                },
                execute: {
                  valType: "boolean",
                  dflt: !0
                }
              });
            t.exports = a(l("updatemenu", {
              _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
              visible: {
                valType: "boolean"
              },
              type: {
                valType: "enumerated",
                values: ["dropdown", "buttons"],
                dflt: "dropdown"
              },
              direction: {
                valType: "enumerated",
                values: ["left", "right", "up", "down"],
                dflt: "down"
              },
              active: {
                valType: "integer",
                min: -1,
                dflt: 0
              },
              showactive: {
                valType: "boolean",
                dflt: !0
              },
              buttons: u,
              x: {
                valType: "number",
                min: -2,
                max: 3,
                dflt: -.05
              },
              xanchor: {
                valType: "enumerated",
                values: ["auto", "left", "center", "right"],
                dflt: "right"
              },
              y: {
                valType: "number",
                min: -2,
                max: 3,
                dflt: 1
              },
              yanchor: {
                valType: "enumerated",
                values: ["auto", "top", "middle", "bottom"],
                dflt: "top"
              },
              pad: o(s({
                editType: "arraydraw"
              }), {}),
              font: r({}),
              bgcolor: {
                valType: "color"
              },
              bordercolor: {
                valType: "color",
                dflt: i.borderLine
              },
              borderwidth: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "arraydraw"
              }
            }), "arraydraw", "from-root");
          }, {
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plot_api/plot_template": 531,
            "../../plots/font_attributes": 567,
            "../../plots/pad_attributes": 583,
            "../color/attributes": 374
          }],
          464: [function (e, t, n) {
            "use strict";

            t.exports = {
              name: "updatemenus",
              containerClassName: "updatemenu-container",
              headerGroupClassName: "updatemenu-header-group",
              headerClassName: "updatemenu-header",
              headerArrowClassName: "updatemenu-header-arrow",
              dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
              dropdownButtonClassName: "updatemenu-dropdown-button",
              buttonClassName: "updatemenu-button",
              itemRectClassName: "updatemenu-item-rect",
              itemTextClassName: "updatemenu-item-text",
              menuIndexAttrName: "updatemenu-active-index",
              autoMarginIdRoot: "updatemenu-",
              blankHeaderOpts: {
                label: "  "
              },
              minWidth: 30,
              minHeight: 30,
              textPadX: 24,
              arrowPadX: 16,
              rx: 2,
              ry: 2,
              textOffsetX: 12,
              textOffsetY: 3,
              arrowOffsetX: 4,
              gapButtonHeader: 5,
              gapButton: 2,
              activeColor: "#F4FAFF",
              hoverColor: "#F4FAFF",
              arrowSymbol: {
                left: "◄",
                right: "►",
                up: "▲",
                down: "▼"
              }
            };
          }, {}],
          465: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../plots/array_container_defaults"),
              o = e("./attributes"),
              a = e("./constants").name,
              s = o.buttons;
            function l(e, t, n) {
              function a(n, i) {
                return r.coerce(e, t, o, n, i);
              }
              a("visible", i(e, t, {
                name: "buttons",
                handleItemDefaults: u
              }).length > 0) && (a("active"), a("direction"), a("type"), a("showactive"), a("x"), a("y"), r.noneOrAll(e, t, ["x", "y"]), a("xanchor"), a("yanchor"), a("pad.t"), a("pad.r"), a("pad.b"), a("pad.l"), r.coerceFont(a, "font", n.font), a("bgcolor", n.paper_bgcolor), a("bordercolor"), a("borderwidth"));
            }
            function u(e, t) {
              function n(n, i) {
                return r.coerce(e, t, s, n, i);
              }
              n("visible", "skip" === e.method || Array.isArray(e.args)) && (n("method"), n("args"), n("args2"), n("label"), n("execute"));
            }
            t.exports = function (e, t) {
              i(e, t, {
                name: a,
                handleItemDefaults: l
              });
            };
          }, {
            "../../lib": 495,
            "../../plots/array_container_defaults": 537,
            "./attributes": 463,
            "./constants": 464
          }],
          466: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../plots/plots"),
              o = e("../color"),
              a = e("../drawing"),
              s = e("../../lib"),
              l = e("../../lib/svg_text_utils"),
              u = e("../../plot_api/plot_template").arrayEditor,
              c = e("../../constants/alignment").LINE_SPACING,
              d = e("./constants"),
              h = e("./scrollbox");
            function f(e) {
              return e._index;
            }
            function p(e, t) {
              return +e.attr(d.menuIndexAttrName) === t._index;
            }
            function m(e, t, n, r, i, o, a, s) {
              t.active = a, u(e.layout, d.name, t).applyUpdate("active", a), "buttons" === t.type ? v(e, r, null, null, t) : "dropdown" === t.type && (i.attr(d.menuIndexAttrName, "-1"), g(e, r, i, o, t), s || v(e, r, i, o, t));
            }
            function g(e, t, n, r, i) {
              var o = s.ensureSingle(t, "g", d.headerClassName, function (e) {
                  e.style("pointer-events", "all");
                }),
                l = i._dims,
                u = i.active,
                c = i.buttons[u] || d.blankHeaderOpts,
                h = {
                  y: i.pad.t,
                  yPad: 0,
                  x: i.pad.l,
                  xPad: 0,
                  index: 0
                },
                f = {
                  width: l.headerWidth,
                  height: l.headerHeight
                };
              o.call(y, i, c, e).call(T, i, h, f), s.ensureSingle(t, "text", d.headerArrowClassName, function (e) {
                e.classed("user-select-none", !0).attr("text-anchor", "end").call(a.font, i.font).text(d.arrowSymbol[i.direction]);
              }).attr({
                x: l.headerWidth - d.arrowOffsetX + i.pad.l,
                y: l.headerHeight / 2 + d.textOffsetY + i.pad.t
              }), o.on("click", function () {
                n.call(M, String(p(n, i) ? -1 : i._index)), v(e, t, n, r, i);
              }), o.on("mouseover", function () {
                o.call(w);
              }), o.on("mouseout", function () {
                o.call(S, i);
              }), a.setTranslate(t, l.lx, l.ly);
            }
            function v(e, t, n, o, a) {
              n || (n = t).attr("pointer-events", "all");
              var l = function (e) {
                  return -1 == +e.attr(d.menuIndexAttrName);
                }(n) && "buttons" !== a.type ? [] : a.buttons,
                u = "dropdown" === a.type ? d.dropdownButtonClassName : d.buttonClassName,
                c = n.selectAll("g." + u).data(s.filterVisible(l)),
                h = c.enter().append("g").classed(u, !0),
                f = c.exit();
              "dropdown" === a.type ? (h.attr("opacity", "0").transition().attr("opacity", "1"), f.transition().attr("opacity", "0").remove()) : f.remove();
              var p = 0,
                g = 0,
                v = a._dims,
                b = -1 !== ["up", "down"].indexOf(a.direction);
              "dropdown" === a.type && (b ? g = v.headerHeight + d.gapButtonHeader : p = v.headerWidth + d.gapButtonHeader), "dropdown" === a.type && "up" === a.direction && (g = -d.gapButtonHeader + d.gapButton - v.openHeight), "dropdown" === a.type && "left" === a.direction && (p = -d.gapButtonHeader + d.gapButton - v.openWidth);
              var _ = {
                  x: v.lx + p + a.pad.l,
                  y: v.ly + g + a.pad.t,
                  yPad: d.gapButton,
                  xPad: d.gapButton,
                  index: 0
                },
                A = {
                  l: _.x + a.borderwidth,
                  t: _.y + a.borderwidth
                };
              c.each(function (s, l) {
                var u = r.select(this);
                u.call(y, a, s, e).call(T, a, _), u.on("click", function () {
                  r.event.defaultPrevented || (s.execute && (s.args2 && a.active === l ? (m(e, a, 0, t, n, o, -1), i.executeAPICommand(e, s.method, s.args2)) : (m(e, a, 0, t, n, o, l), i.executeAPICommand(e, s.method, s.args))), e.emit("plotly_buttonclicked", {
                    menu: a,
                    button: s,
                    active: a.active
                  }));
                }), u.on("mouseover", function () {
                  u.call(w);
                }), u.on("mouseout", function () {
                  u.call(S, a), c.call(x, a);
                });
              }), c.call(x, a), b ? (A.w = Math.max(v.openWidth, v.headerWidth), A.h = _.y - A.t) : (A.w = _.x - A.l, A.h = Math.max(v.openHeight, v.headerHeight)), A.direction = a.direction, o && (c.size() ? function (e, t, n, r, i, o) {
                var a,
                  s,
                  l,
                  u = i.direction,
                  c = "up" === u || "down" === u,
                  h = i._dims,
                  f = i.active;
                if (c) for (s = 0, l = 0; l < f; l++) s += h.heights[l] + d.gapButton;else for (a = 0, l = 0; l < f; l++) a += h.widths[l] + d.gapButton;
                r.enable(o, a, s), r.hbar && r.hbar.attr("opacity", "0").transition().attr("opacity", "1"), r.vbar && r.vbar.attr("opacity", "0").transition().attr("opacity", "1");
              }(0, 0, 0, o, a, A) : function (e) {
                var t = !!e.hbar,
                  n = !!e.vbar;
                t && e.hbar.transition().attr("opacity", "0").each("end", function () {
                  t = !1, n || e.disable();
                }), n && e.vbar.transition().attr("opacity", "0").each("end", function () {
                  n = !1, t || e.disable();
                });
              }(o));
            }
            function y(e, t, n, r) {
              e.call(b, t).call(_, t, n, r);
            }
            function b(e, t) {
              s.ensureSingle(e, "rect", d.itemRectClassName, function (e) {
                e.attr({
                  rx: d.rx,
                  ry: d.ry,
                  "shape-rendering": "crispEdges"
                });
              }).call(o.stroke, t.bordercolor).call(o.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
            }
            function _(e, t, n, r) {
              var i = s.ensureSingle(e, "text", d.itemTextClassName, function (e) {
                  e.classed("user-select-none", !0).attr({
                    "text-anchor": "start",
                    "data-notex": 1
                  });
                }),
                o = n.label,
                u = r._fullLayout._meta;
              u && (o = s.templateString(o, u)), i.call(a.font, t.font).text(o).call(l.convertToTspans, r);
            }
            function x(e, t) {
              var n = t.active;
              e.each(function (e, i) {
                var a = r.select(this);
                i === n && t.showactive && a.select("rect." + d.itemRectClassName).call(o.fill, d.activeColor);
              });
            }
            function w(e) {
              e.select("rect." + d.itemRectClassName).call(o.fill, d.hoverColor);
            }
            function S(e, t) {
              e.select("rect." + d.itemRectClassName).call(o.fill, t.bgcolor);
            }
            function A(e, t) {
              var n = t._dims = {
                  width1: 0,
                  height1: 0,
                  heights: [],
                  widths: [],
                  totalWidth: 0,
                  totalHeight: 0,
                  openWidth: 0,
                  openHeight: 0,
                  lx: 0,
                  ly: 0
                },
                o = a.tester.selectAll("g." + d.dropdownButtonClassName).data(s.filterVisible(t.buttons));
              o.enter().append("g").classed(d.dropdownButtonClassName, !0);
              var u = -1 !== ["up", "down"].indexOf(t.direction);
              o.each(function (i, o) {
                var s = r.select(this);
                s.call(y, t, i, e);
                var h = s.select("." + d.itemTextClassName),
                  f = h.node() && a.bBox(h.node()).width,
                  p = Math.max(f + d.textPadX, d.minWidth),
                  m = t.font.size * c,
                  g = l.lineCount(h),
                  v = Math.max(m * g, d.minHeight) + d.textOffsetY;
                v = Math.ceil(v), p = Math.ceil(p), n.widths[o] = p, n.heights[o] = v, n.height1 = Math.max(n.height1, v), n.width1 = Math.max(n.width1, p), u ? (n.totalWidth = Math.max(n.totalWidth, p), n.openWidth = n.totalWidth, n.totalHeight += v + d.gapButton, n.openHeight += v + d.gapButton) : (n.totalWidth += p + d.gapButton, n.openWidth += p + d.gapButton, n.totalHeight = Math.max(n.totalHeight, v), n.openHeight = n.totalHeight);
              }), u ? n.totalHeight -= d.gapButton : n.totalWidth -= d.gapButton, n.headerWidth = n.width1 + d.arrowPadX, n.headerHeight = n.height1, "dropdown" === t.type && (u ? (n.width1 += d.arrowPadX, n.totalHeight = n.height1) : n.totalWidth = n.width1, n.totalWidth += d.arrowPadX), o.remove();
              var h = n.totalWidth + t.pad.l + t.pad.r,
                f = n.totalHeight + t.pad.t + t.pad.b,
                p = e._fullLayout._size;
              n.lx = p.l + p.w * t.x, n.ly = p.t + p.h * (1 - t.y);
              var m = "left";
              s.isRightAnchor(t) && (n.lx -= h, m = "right"), s.isCenterAnchor(t) && (n.lx -= h / 2, m = "center");
              var g = "top";
              s.isBottomAnchor(t) && (n.ly -= f, g = "bottom"), s.isMiddleAnchor(t) && (n.ly -= f / 2, g = "middle"), n.totalWidth = Math.ceil(n.totalWidth), n.totalHeight = Math.ceil(n.totalHeight), n.lx = Math.round(n.lx), n.ly = Math.round(n.ly), i.autoMargin(e, E(t), {
                x: t.x,
                y: t.y,
                l: h * ({
                  right: 1,
                  center: .5
                }[m] || 0),
                r: h * ({
                  left: 1,
                  center: .5
                }[m] || 0),
                b: f * ({
                  top: 1,
                  middle: .5
                }[g] || 0),
                t: f * ({
                  bottom: 1,
                  middle: .5
                }[g] || 0)
              });
            }
            function E(e) {
              return d.autoMarginIdRoot + e._index;
            }
            function T(e, t, n, r) {
              r = r || {};
              var i = e.select("." + d.itemRectClassName),
                o = e.select("." + d.itemTextClassName),
                s = t.borderwidth,
                u = n.index,
                h = t._dims;
              a.setTranslate(e, s + n.x, s + n.y);
              var f = -1 !== ["up", "down"].indexOf(t.direction),
                p = r.height || (f ? h.heights[u] : h.height1);
              i.attr({
                x: 0,
                y: 0,
                width: r.width || (f ? h.width1 : h.widths[u]),
                height: p
              });
              var m = t.font.size * c,
                g = (l.lineCount(o) - 1) * m / 2;
              l.positionText(o, d.textOffsetX, p / 2 - g + d.textOffsetY), f ? n.y += h.heights[u] + n.yPad : n.x += h.widths[u] + n.xPad, n.index++;
            }
            function M(e, t) {
              e.attr(d.menuIndexAttrName, t || "-1").selectAll("g." + d.dropdownButtonClassName).remove();
            }
            t.exports = function (e) {
              var t = e._fullLayout,
                n = s.filterVisible(t[d.name]);
              function o(t) {
                i.autoMargin(e, E(t));
              }
              var a = t._menulayer.selectAll("g." + d.containerClassName).data(n.length > 0 ? [0] : []);
              if (a.enter().append("g").classed(d.containerClassName, !0).style("cursor", "pointer"), a.exit().each(function () {
                r.select(this).selectAll("g." + d.headerGroupClassName).each(o);
              }).remove(), 0 !== n.length) {
                var l = a.selectAll("g." + d.headerGroupClassName).data(n, f);
                l.enter().append("g").classed(d.headerGroupClassName, !0);
                for (var u = s.ensureSingle(a, "g", d.dropdownButtonGroupClassName, function (e) {
                    e.style("pointer-events", "all");
                  }), c = 0; c < n.length; c++) {
                  var y = n[c];
                  A(e, y);
                }
                var b = "updatemenus" + t._uid,
                  _ = new h(e, u, b);
                l.enter().size() && (u.node().parentNode.appendChild(u.node()), u.call(M)), l.exit().each(function (e) {
                  u.call(M), o(e);
                }).remove(), l.each(function (t) {
                  var n = r.select(this),
                    o = "dropdown" === t.type ? u : null;
                  i.manageCommandObserver(e, t, t.buttons, function (r) {
                    m(e, t, t.buttons[r.index], n, o, _, r.index, !0);
                  }), "dropdown" === t.type ? (g(e, n, u, _, t), p(u, t) && v(e, n, u, _, t)) : v(e, n, null, null, t);
                });
              }
            };
          }, {
            "../../constants/alignment": 469,
            "../../lib": 495,
            "../../lib/svg_text_utils": 518,
            "../../plot_api/plot_template": 531,
            "../../plots/plots": 584,
            "../color": 375,
            "../drawing": 396,
            "./constants": 464,
            "./scrollbox": 468,
            d3: 82
          }],
          467: [function (e, t, n) {
            arguments[4][461][0].apply(n, arguments);
          }, {
            "./attributes": 463,
            "./constants": 464,
            "./defaults": 465,
            "./draw": 466,
            dup: 461
          }],
          468: [function (e, t, n) {
            "use strict";

            t.exports = s;
            var r = e("d3"),
              i = e("../color"),
              o = e("../drawing"),
              a = e("../../lib");
            function s(e, t, n) {
              this.gd = e, this.container = t, this.id = n, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
                opacity: 0,
                x: 0,
                y: 0,
                width: 0,
                height: 0
              });
            }
            s.barWidth = 2, s.barLength = 20, s.barRadius = 2, s.barPad = 1, s.barColor = "#808BA4", s.prototype.enable = function (e, t, n) {
              var a = this.gd._fullLayout,
                l = a.width,
                u = a.height;
              this.position = e;
              var c,
                d,
                h,
                f,
                p = this.position.l,
                m = this.position.w,
                g = this.position.t,
                v = this.position.h,
                y = this.position.direction,
                b = "down" === y,
                _ = "left" === y,
                x = "up" === y,
                w = m,
                S = v;
              b || _ || "right" === y || x || (this.position.direction = "down", b = !0), b || x ? (d = (c = p) + w, b ? (h = g, S = (f = Math.min(h + S, u)) - h) : S = (f = g + S) - (h = Math.max(f - S, 0))) : (f = (h = g) + S, _ ? w = (d = p + w) - (c = Math.max(d - w, 0)) : (c = p, w = (d = Math.min(c + w, l)) - c)), this._box = {
                l: c,
                t: h,
                w: w,
                h: S
              };
              var A = m > w,
                E = s.barLength + 2 * s.barPad,
                T = s.barWidth + 2 * s.barPad,
                M = p,
                C = g + v;
              C + T > u && (C = u - T);
              var k = this.container.selectAll("rect.scrollbar-horizontal").data(A ? [0] : []);
              k.exit().on(".drag", null).remove(), k.enter().append("rect").classed("scrollbar-horizontal", !0).call(i.fill, s.barColor), A ? (this.hbar = k.attr({
                rx: s.barRadius,
                ry: s.barRadius,
                x: M,
                y: C,
                width: E,
                height: T
              }), this._hbarXMin = M + E / 2, this._hbarTranslateMax = w - E) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
              var P = v > S,
                O = s.barWidth + 2 * s.barPad,
                R = s.barLength + 2 * s.barPad,
                I = p + m,
                j = g;
              I + O > l && (I = l - O);
              var N = this.container.selectAll("rect.scrollbar-vertical").data(P ? [0] : []);
              N.exit().on(".drag", null).remove(), N.enter().append("rect").classed("scrollbar-vertical", !0).call(i.fill, s.barColor), P ? (this.vbar = N.attr({
                rx: s.barRadius,
                ry: s.barRadius,
                x: I,
                y: j,
                width: O,
                height: R
              }), this._vbarYMin = j + R / 2, this._vbarTranslateMax = S - R) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
              var L = this.id,
                D = c - .5,
                B = P ? d + O + .5 : d + .5,
                F = h - .5,
                z = A ? f + T + .5 : f + .5,
                U = a._topdefs.selectAll("#" + L).data(A || P ? [0] : []);
              if (U.exit().remove(), U.enter().append("clipPath").attr("id", L).append("rect"), A || P ? (this._clipRect = U.select("rect").attr({
                x: Math.floor(D),
                y: Math.floor(F),
                width: Math.ceil(B) - Math.floor(D),
                height: Math.ceil(z) - Math.floor(F)
              }), this.container.call(o.setClipUrl, L, this.gd), this.bg.attr({
                x: p,
                y: g,
                width: m,
                height: v
              })) : (this.bg.attr({
                width: 0,
                height: 0
              }), this.container.on("wheel", null).on(".drag", null).call(o.setClipUrl, null), delete this._clipRect), A || P) {
                var G = r.behavior.drag().on("dragstart", function () {
                  r.event.sourceEvent.preventDefault();
                }).on("drag", this._onBoxDrag.bind(this));
                this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(G);
                var V = r.behavior.drag().on("dragstart", function () {
                  r.event.sourceEvent.preventDefault(), r.event.sourceEvent.stopPropagation();
                }).on("drag", this._onBarDrag.bind(this));
                A && this.hbar.on(".drag", null).call(V), P && this.vbar.on(".drag", null).call(V);
              }
              this.setTranslate(t, n);
            }, s.prototype.disable = function () {
              (this.hbar || this.vbar) && (this.bg.attr({
                width: 0,
                height: 0
              }), this.container.on("wheel", null).on(".drag", null).call(o.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
            }, s.prototype._onBoxDrag = function () {
              var e = this.translateX,
                t = this.translateY;
              this.hbar && (e -= r.event.dx), this.vbar && (t -= r.event.dy), this.setTranslate(e, t);
            }, s.prototype._onBoxWheel = function () {
              var e = this.translateX,
                t = this.translateY;
              this.hbar && (e += r.event.deltaY), this.vbar && (t += r.event.deltaY), this.setTranslate(e, t);
            }, s.prototype._onBarDrag = function () {
              var e = this.translateX,
                t = this.translateY;
              if (this.hbar) {
                var n = e + this._hbarXMin,
                  i = n + this._hbarTranslateMax;
                e = (a.constrain(r.event.x, n, i) - n) / (i - n) * (this.position.w - this._box.w);
              }
              if (this.vbar) {
                var o = t + this._vbarYMin,
                  s = o + this._vbarTranslateMax;
                t = (a.constrain(r.event.y, o, s) - o) / (s - o) * (this.position.h - this._box.h);
              }
              this.setTranslate(e, t);
            }, s.prototype.setTranslate = function (e, t) {
              var n = this.position.w - this._box.w,
                r = this.position.h - this._box.h;
              if (e = a.constrain(e || 0, 0, n), t = a.constrain(t || 0, 0, r), this.translateX = e, this.translateY = t, this.container.call(o.setTranslate, this._box.l - this.position.l - e, this._box.t - this.position.t - t), this._clipRect && this._clipRect.attr({
                x: Math.floor(this.position.l + e - .5),
                y: Math.floor(this.position.t + t - .5)
              }), this.hbar) {
                var i = e / n;
                this.hbar.call(o.setTranslate, e + i * this._hbarTranslateMax, t);
              }
              if (this.vbar) {
                var s = t / r;
                this.vbar.call(o.setTranslate, e, t + s * this._vbarTranslateMax);
              }
            };
          }, {
            "../../lib": 495,
            "../color": 375,
            "../drawing": 396,
            d3: 82
          }],
          469: [function (e, t, n) {
            "use strict";

            t.exports = {
              FROM_BL: {
                left: 0,
                center: .5,
                right: 1,
                bottom: 0,
                middle: .5,
                top: 1
              },
              FROM_TL: {
                left: 0,
                center: .5,
                right: 1,
                bottom: 1,
                middle: .5,
                top: 0
              },
              FROM_BR: {
                left: 1,
                center: .5,
                right: 0,
                bottom: 0,
                middle: .5,
                top: 1
              },
              LINE_SPACING: 1.3,
              CAP_SHIFT: .7,
              MID_SHIFT: .35,
              OPPOSITE_SIDE: {
                left: "right",
                right: "left",
                top: "bottom",
                bottom: "top"
              }
            };
          }, {}],
          470: [function (e, t, n) {
            "use strict";

            t.exports = {
              FORMAT_LINK: "https://github.com/d3/d3-3.x-api-reference/blob/master/Formatting.md#d3_format",
              DATE_FORMAT_LINK: "https://github.com/d3/d3-3.x-api-reference/blob/master/Time-Formatting.md#format"
            };
          }, {}],
          471: [function (e, t, n) {
            "use strict";

            t.exports = {
              solid: [[], 0],
              dot: [[.5, 1], 200],
              dash: [[.5, 1], 50],
              longdash: [[.5, 1], 10],
              dashdot: [[.5, .625, .875, 1], 50],
              longdashdot: [[.5, .7, .8, 1], 10]
            };
          }, {}],
          472: [function (e, t, n) {
            "use strict";

            t.exports = {
              circle: "●",
              "circle-open": "○",
              square: "■",
              "square-open": "□",
              diamond: "◆",
              "diamond-open": "◇",
              cross: "+",
              x: "❌"
            };
          }, {}],
          473: [function (e, t, n) {
            "use strict";

            t.exports = {
              SHOW_PLACEHOLDER: 100,
              HIDE_PLACEHOLDER: 1e3,
              DESELECTDIM: .2
            };
          }, {}],
          474: [function (e, t, n) {
            "use strict";

            t.exports = {
              BADNUM: void 0,
              FP_SAFE: Number.MAX_VALUE / 1e4,
              ONEAVGYEAR: 315576e5,
              ONEAVGMONTH: 26298e5,
              ONEDAY: 864e5,
              ONEHOUR: 36e5,
              ONEMIN: 6e4,
              ONESEC: 1e3,
              EPOCHJD: 2440587.5,
              ALMOST_EQUAL: .999999,
              LOG_CLIP: 10,
              MINUS_SIGN: "−"
            };
          }, {}],
          475: [function (e, t, n) {
            "use strict";

            n.xmlns = "http://www.w3.org/2000/xmlns/", n.svg = "http://www.w3.org/2000/svg", n.xlink = "http://www.w3.org/1999/xlink", n.svgAttrs = {
              xmlns: n.svg,
              "xmlns:xlink": n.xlink
            };
          }, {}],
          476: [function (e, t, n) {
            "use strict";

            n.version = "1.52.3", e("es6-promise").polyfill(), e("../build/plotcss"), e("./fonts/mathjax_config")();
            for (var r = e("./registry"), i = n.register = r.register, o = e("./plot_api"), a = Object.keys(o), s = 0; s < a.length; s++) {
              var l = a[s];
              "_" !== l.charAt(0) && (n[l] = o[l]), i({
                moduleType: "apiMethod",
                name: l,
                fn: o[l]
              });
            }
            i(e("./traces/scatter")), i([e("./components/fx"), e("./components/legend"), e("./components/annotations"), e("./components/annotations3d"), e("./components/shapes"), e("./components/images"), e("./components/updatemenus"), e("./components/sliders"), e("./components/rangeslider"), e("./components/rangeselector"), e("./components/grid"), e("./components/errorbars"), e("./components/colorscale"), e("./components/colorbar")]), i([e("./locale-en"), e("./locale-en-us")]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (i(window.PlotlyLocales), delete window.PlotlyLocales), n.Icons = e("./fonts/ploticon"), n.Plots = e("./plots/plots"), n.Fx = e("./components/fx"), n.Snapshot = e("./snapshot"), n.PlotSchema = e("./plot_api/plot_schema"), n.Queue = e("./lib/queue"), n.d3 = e("d3");
          }, {
            "../build/plotcss": 1,
            "./components/annotations": 368,
            "./components/annotations3d": 373,
            "./components/colorbar": 381,
            "./components/colorscale": 387,
            "./components/errorbars": 402,
            "./components/fx": 413,
            "./components/grid": 417,
            "./components/images": 422,
            "./components/legend": 430,
            "./components/rangeselector": 441,
            "./components/rangeslider": 448,
            "./components/shapes": 456,
            "./components/sliders": 461,
            "./components/updatemenus": 467,
            "./fonts/mathjax_config": 477,
            "./fonts/ploticon": 478,
            "./lib/queue": 509,
            "./locale-en": 522,
            "./locale-en-us": 521,
            "./plot_api": 526,
            "./plot_api/plot_schema": 530,
            "./plots/plots": 584,
            "./registry": 593,
            "./snapshot": 598,
            "./traces/scatter": 634,
            d3: 82,
            "es6-promise": 89
          }],
          477: [function (e, t, n) {
            "use strict";

            t.exports = function () {
              "undefined" != typeof MathJax && "local" !== (window.PlotlyConfig || {}).MathJaxConfig && (MathJax.Hub.Config({
                messageStyle: "none",
                skipStartupTypeset: !0,
                displayAlign: "left",
                tex2jax: {
                  inlineMath: [["$", "$"], ["\\(", "\\)"]]
                }
              }), MathJax.Hub.Configured());
            };
          }, {}],
          478: [function (e, t, n) {
            "use strict";

            t.exports = {
              undo: {
                width: 857.1,
                height: 1e3,
                path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              home: {
                width: 928.6,
                height: 1e3,
                path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              "camera-retro": {
                width: 1e3,
                height: 1e3,
                path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              zoombox: {
                width: 1e3,
                height: 1e3,
                path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              pan: {
                width: 1e3,
                height: 1e3,
                path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              zoom_plus: {
                width: 875,
                height: 1e3,
                path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              zoom_minus: {
                width: 875,
                height: 1e3,
                path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              autoscale: {
                width: 1e3,
                height: 1e3,
                path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              tooltip_basic: {
                width: 1500,
                height: 1e3,
                path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              tooltip_compare: {
                width: 1125,
                height: 1e3,
                path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              plotlylogo: {
                width: 1542,
                height: 1e3,
                path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              "z-axis": {
                width: 1e3,
                height: 1e3,
                path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              "3d_rotate": {
                width: 1e3,
                height: 1e3,
                path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              camera: {
                width: 1e3,
                height: 1e3,
                path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              movie: {
                width: 1e3,
                height: 1e3,
                path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              question: {
                width: 857.1,
                height: 1e3,
                path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              disk: {
                width: 857.1,
                height: 1e3,
                path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              lasso: {
                width: 1031,
                height: 1e3,
                path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              selectbox: {
                width: 1e3,
                height: 1e3,
                path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
                transform: "matrix(1 0 0 -1 0 850)"
              },
              spikeline: {
                width: 1e3,
                height: 1e3,
                path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
                transform: "matrix(1.5 0 0 -1.5 0 850)"
              },
              pencil: {
                width: 1792,
                height: 1792,
                path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
                transform: "matrix(1 0 0 1 0 1)"
              },
              newplotlylogo: {
                name: "newplotlylogo",
                svg: "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'><defs><style>.cls-1 {fill: #119dff;} .cls-2 {fill: #25fefd;} .cls-3 {fill: #fff;}</style></defs><title>plotly-logomark</title><g id='symbol'><rect class='cls-1' width='132' height='132' rx='6' ry='6'/><circle class='cls-2' cx='78' cy='54' r='6'/><circle class='cls-2' cx='102' cy='30' r='6'/><circle class='cls-2' cx='78' cy='30' r='6'/><circle class='cls-2' cx='54' cy='30' r='6'/><circle class='cls-2' cx='30' cy='30' r='6'/><circle class='cls-2' cx='30' cy='54' r='6'/><path class='cls-3' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/><path class='cls-3' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/><path class='cls-3' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/><path class='cls-3' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/></g></svg>"
              }
            };
          }, {}],
          479: [function (e, t, n) {
            "use strict";

            n.isLeftAnchor = function (e) {
              return "left" === e.xanchor || "auto" === e.xanchor && e.x <= 1 / 3;
            }, n.isCenterAnchor = function (e) {
              return "center" === e.xanchor || "auto" === e.xanchor && e.x > 1 / 3 && e.x < 2 / 3;
            }, n.isRightAnchor = function (e) {
              return "right" === e.xanchor || "auto" === e.xanchor && e.x >= 2 / 3;
            }, n.isTopAnchor = function (e) {
              return "top" === e.yanchor || "auto" === e.yanchor && e.y >= 2 / 3;
            }, n.isMiddleAnchor = function (e) {
              return "middle" === e.yanchor || "auto" === e.yanchor && e.y > 1 / 3 && e.y < 2 / 3;
            }, n.isBottomAnchor = function (e) {
              return "bottom" === e.yanchor || "auto" === e.yanchor && e.y <= 1 / 3;
            };
          }, {}],
          480: [function (e, t, n) {
            "use strict";

            var r = e("./mod"),
              i = r.mod,
              o = r.modHalf,
              a = Math.PI,
              s = 2 * a;
            function l(e) {
              return Math.abs(e[1] - e[0]) > s - 1e-14;
            }
            function u(e, t) {
              return o(t - e, s);
            }
            function c(e, t) {
              if (l(t)) return !0;
              var n, r;
              t[0] < t[1] ? (n = t[0], r = t[1]) : (n = t[1], r = t[0]), (n = i(n, s)) > (r = i(r, s)) && (r += s);
              var o = i(e, s),
                a = o + s;
              return o >= n && o <= r || a >= n && a <= r;
            }
            function d(e, t, n, r, i, o, u) {
              i = i || 0, o = o || 0;
              var c,
                d,
                h,
                f,
                p,
                m = l([n, r]);
              function g(e, t) {
                return [e * Math.cos(t) + i, o - e * Math.sin(t)];
              }
              m ? (c = 0, d = a, h = s) : n < r ? (c = n, h = r) : (c = r, h = n), e < t ? (f = e, p = t) : (f = t, p = e);
              var v,
                y = Math.abs(h - c) <= a ? 0 : 1;
              function b(e, t, n) {
                return "A" + [e, e] + " " + [0, y, n] + " " + g(e, t);
              }
              return m ? v = null === f ? "M" + g(p, c) + b(p, d, 0) + b(p, h, 0) + "Z" : "M" + g(f, c) + b(f, d, 0) + b(f, h, 0) + "ZM" + g(p, c) + b(p, d, 1) + b(p, h, 1) + "Z" : null === f ? (v = "M" + g(p, c) + b(p, h, 0), u && (v += "L0,0Z")) : v = "M" + g(f, c) + "L" + g(p, c) + b(p, h, 0) + "L" + g(f, h) + b(f, c, 1) + "Z", v;
            }
            t.exports = {
              deg2rad: function deg2rad(e) {
                return e / 180 * a;
              },
              rad2deg: function rad2deg(e) {
                return e / a * 180;
              },
              angleDelta: u,
              angleDist: function angleDist(e, t) {
                return Math.abs(u(e, t));
              },
              isFullCircle: l,
              isAngleInsideSector: c,
              isPtInsideSector: function isPtInsideSector(e, t, n, r) {
                return !!c(t, r) && (n[0] < n[1] ? (i = n[0], o = n[1]) : (i = n[1], o = n[0]), e >= i && e <= o);
                var i, o;
              },
              pathArc: function pathArc(e, t, n, r, i) {
                return d(null, e, t, n, r, i, 0);
              },
              pathSector: function pathSector(e, t, n, r, i) {
                return d(null, e, t, n, r, i, 1);
              },
              pathAnnulus: function pathAnnulus(e, t, n, r, i, o) {
                return d(e, t, n, r, i, o, 1);
              }
            };
          }, {
            "./mod": 502
          }],
          481: [function (e, t, n) {
            "use strict";

            var r = Array.isArray,
              i = "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer : {
                isView: function isView() {
                  return !1;
                }
              },
              o = "undefined" == typeof DataView ? function () {} : DataView;
            function a(e) {
              return i.isView(e) && !(e instanceof o);
            }
            function s(e) {
              return r(e) || a(e);
            }
            function l(e, t, n) {
              if (s(e)) {
                if (s(e[0])) {
                  for (var r = n, i = 0; i < e.length; i++) r = t(r, e[i].length);
                  return r;
                }
                return e.length;
              }
              return 0;
            }
            n.isTypedArray = a, n.isArrayOrTypedArray = s, n.isArray1D = function (e) {
              return !s(e[0]);
            }, n.ensureArray = function (e, t) {
              return r(e) || (e = []), e.length = t, e;
            }, n.concat = function () {
              var e,
                t,
                n,
                i,
                o,
                a,
                s,
                l,
                u = [],
                c = !0,
                d = 0;
              for (n = 0; n < arguments.length; n++) (a = (i = arguments[n]).length) && (t ? u.push(i) : (t = i, o = a), r(i) ? e = !1 : (c = !1, d ? e !== i.constructor && (e = !1) : e = i.constructor), d += a);
              if (!d) return [];
              if (!u.length) return t;
              if (c) return t.concat.apply(t, u);
              if (e) {
                for ((s = new e(d)).set(t), n = 0; n < u.length; n++) i = u[n], s.set(i, o), o += i.length;
                return s;
              }
              for (s = new Array(d), l = 0; l < t.length; l++) s[l] = t[l];
              for (n = 0; n < u.length; n++) {
                for (i = u[n], l = 0; l < i.length; l++) s[o + l] = i[l];
                o += l;
              }
              return s;
            }, n.maxRowLength = function (e) {
              return l(e, Math.max, 0);
            }, n.minRowLength = function (e) {
              return l(e, Math.min, 1 / 0);
            };
          }, {}],
          482: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../constants/numerical").BADNUM,
              o = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
            t.exports = function (e) {
              return "string" == typeof e && (e = e.replace(o, "")), r(e) ? Number(e) : i;
            };
          }, {
            "../constants/numerical": 474,
            "fast-isnumeric": 91
          }],
          483: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e._fullLayout;
              t._glcanvas && t._glcanvas.size() && t._glcanvas.each(function (e) {
                e.regl && e.regl.clear({
                  color: !0,
                  depth: !0
                });
              });
            };
          }, {}],
          484: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              e._responsiveChartHandler && (window.removeEventListener("resize", e._responsiveChartHandler), delete e._responsiveChartHandler);
            };
          }, {}],
          485: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("tinycolor2"),
              o = e("../plots/attributes"),
              a = e("../components/colorscale/scales"),
              s = e("../constants/interactions").DESELECTDIM,
              l = e("./nested_property"),
              u = e("./regex").counter,
              c = e("./mod").modHalf,
              d = e("./array").isArrayOrTypedArray;
            function h(e, t) {
              var r = n.valObjectMeta[t.valType];
              if (t.arrayOk && d(e)) return !0;
              if (r.validateFunction) return r.validateFunction(e, t);
              var i = {},
                o = i,
                a = {
                  set: function set(e) {
                    o = e;
                  }
                };
              return r.coerceFunction(e, a, i, t), o !== i;
            }
            n.valObjectMeta = {
              data_array: {
                coerceFunction: function coerceFunction(e, t, n) {
                  d(e) ? t.set(e) : void 0 !== n && t.set(n);
                }
              },
              enumerated: {
                coerceFunction: function coerceFunction(e, t, n, r) {
                  r.coerceNumber && (e = +e), -1 === r.values.indexOf(e) ? t.set(n) : t.set(e);
                },
                validateFunction: function validateFunction(e, t) {
                  t.coerceNumber && (e = +e);
                  for (var n = t.values, r = 0; r < n.length; r++) {
                    var i = String(n[r]);
                    if ("/" === i.charAt(0) && "/" === i.charAt(i.length - 1)) {
                      if (new RegExp(i.substr(1, i.length - 2)).test(e)) return !0;
                    } else if (e === n[r]) return !0;
                  }
                  return !1;
                }
              },
              boolean: {
                coerceFunction: function coerceFunction(e, t, n) {
                  !0 === e || !1 === e ? t.set(e) : t.set(n);
                }
              },
              number: {
                coerceFunction: function coerceFunction(e, t, n, i) {
                  !r(e) || void 0 !== i.min && e < i.min || void 0 !== i.max && e > i.max ? t.set(n) : t.set(+e);
                }
              },
              integer: {
                coerceFunction: function coerceFunction(e, t, n, i) {
                  e % 1 || !r(e) || void 0 !== i.min && e < i.min || void 0 !== i.max && e > i.max ? t.set(n) : t.set(+e);
                }
              },
              string: {
                coerceFunction: function coerceFunction(e, t, n, r) {
                  if ("string" != typeof e) {
                    var i = "number" == typeof e;
                    !0 !== r.strict && i ? t.set(String(e)) : t.set(n);
                  } else r.noBlank && !e ? t.set(n) : t.set(e);
                }
              },
              color: {
                coerceFunction: function coerceFunction(e, t, n) {
                  i(e).isValid() ? t.set(e) : t.set(n);
                }
              },
              colorlist: {
                coerceFunction: function coerceFunction(e, t, n) {
                  Array.isArray(e) && e.length && e.every(function (e) {
                    return i(e).isValid();
                  }) ? t.set(e) : t.set(n);
                }
              },
              colorscale: {
                coerceFunction: function coerceFunction(e, t, n) {
                  t.set(a.get(e, n));
                }
              },
              angle: {
                coerceFunction: function coerceFunction(e, t, n) {
                  "auto" === e ? t.set("auto") : r(e) ? t.set(c(+e, 360)) : t.set(n);
                }
              },
              subplotid: {
                coerceFunction: function coerceFunction(e, t, n, r) {
                  var i = r.regex || u(n);
                  "string" == typeof e && i.test(e) ? t.set(e) : t.set(n);
                },
                validateFunction: function validateFunction(e, t) {
                  var n = t.dflt;
                  return e === n || "string" == typeof e && !!u(n).test(e);
                }
              },
              flaglist: {
                coerceFunction: function coerceFunction(e, t, n, r) {
                  if ("string" == typeof e) {
                    if (-1 === (r.extras || []).indexOf(e)) {
                      for (var i = e.split("+"), o = 0; o < i.length;) {
                        var a = i[o];
                        -1 === r.flags.indexOf(a) || i.indexOf(a) < o ? i.splice(o, 1) : o++;
                      }
                      i.length ? t.set(i.join("+")) : t.set(n);
                    } else t.set(e);
                  } else t.set(n);
                }
              },
              any: {
                coerceFunction: function coerceFunction(e, t, n) {
                  void 0 === e ? t.set(n) : t.set(e);
                }
              },
              info_array: {
                coerceFunction: function coerceFunction(e, t, r, i) {
                  function o(e, t, r) {
                    var i,
                      o = {
                        set: function set(e) {
                          i = e;
                        }
                      };
                    return void 0 === r && (r = t.dflt), n.valObjectMeta[t.valType].coerceFunction(e, o, r, t), i;
                  }
                  var a = 2 === i.dimensions || "1-2" === i.dimensions && Array.isArray(e) && Array.isArray(e[0]);
                  if (Array.isArray(e)) {
                    var s,
                      l,
                      u,
                      c,
                      d,
                      h,
                      f = i.items,
                      p = [],
                      m = Array.isArray(f),
                      g = m && a && Array.isArray(f[0]),
                      v = a && m && !g,
                      y = m && !v ? f.length : e.length;
                    if (r = Array.isArray(r) ? r : [], a) for (s = 0; s < y; s++) for (p[s] = [], u = Array.isArray(e[s]) ? e[s] : [], d = v ? f.length : m ? f[s].length : u.length, l = 0; l < d; l++) c = v ? f[l] : m ? f[s][l] : f, void 0 !== (h = o(u[l], c, (r[s] || [])[l])) && (p[s][l] = h);else for (s = 0; s < y; s++) void 0 !== (h = o(e[s], m ? f[s] : f, r[s])) && (p[s] = h);
                    t.set(p);
                  } else t.set(r);
                },
                validateFunction: function validateFunction(e, t) {
                  if (!Array.isArray(e)) return !1;
                  var n = t.items,
                    r = Array.isArray(n),
                    i = 2 === t.dimensions;
                  if (!t.freeLength && e.length !== n.length) return !1;
                  for (var o = 0; o < e.length; o++) if (i) {
                    if (!Array.isArray(e[o]) || !t.freeLength && e[o].length !== n[o].length) return !1;
                    for (var a = 0; a < e[o].length; a++) if (!h(e[o][a], r ? n[o][a] : n)) return !1;
                  } else if (!h(e[o], r ? n[o] : n)) return !1;
                  return !0;
                }
              }
            }, n.coerce = function (e, t, r, i, o) {
              var a = l(r, i).get(),
                s = l(e, i),
                u = l(t, i),
                c = s.get(),
                f = t._template;
              if (void 0 === c && f && (c = l(f, i).get(), f = 0), void 0 === o && (o = a.dflt), a.arrayOk && d(c)) return u.set(c), c;
              var p = n.valObjectMeta[a.valType].coerceFunction;
              p(c, u, o, a);
              var m = u.get();
              return f && m === o && !h(c, a) && (p(c = l(f, i).get(), u, o, a), m = u.get()), m;
            }, n.coerce2 = function (e, t, r, i, o) {
              var a = l(e, i),
                s = n.coerce(e, t, r, i, o);
              return null != a.get() && s;
            }, n.coerceFont = function (e, t, n) {
              var r = {};
              return n = n || {}, r.family = e(t + ".family", n.family), r.size = e(t + ".size", n.size), r.color = e(t + ".color", n.color), r;
            }, n.coerceHoverinfo = function (e, t, r) {
              var i,
                a = t._module.attributes,
                s = a.hoverinfo ? a : o,
                l = s.hoverinfo;
              if (1 === r._dataLength) {
                var u = "all" === l.dflt ? l.flags.slice() : l.dflt.split("+");
                u.splice(u.indexOf("name"), 1), i = u.join("+");
              }
              return n.coerce(e, t, s, "hoverinfo", i);
            }, n.coerceSelectionMarkerOpacity = function (e, t) {
              if (e.marker) {
                var n,
                  r,
                  i = e.marker.opacity;
                void 0 !== i && (d(i) || e.selected || e.unselected || (n = i, r = s * i), t("selected.marker.opacity", n), t("unselected.marker.opacity", r));
              }
            }, n.validate = h;
          }, {
            "../components/colorscale/scales": 390,
            "../constants/interactions": 473,
            "../plots/attributes": 538,
            "./array": 481,
            "./mod": 502,
            "./nested_property": 503,
            "./regex": 510,
            "fast-isnumeric": 91,
            tinycolor2: 341
          }],
          486: [function (e, t, n) {
            "use strict";

            var r,
              i,
              o = e("d3"),
              a = e("fast-isnumeric"),
              s = e("./loggers"),
              l = e("./mod").mod,
              u = e("../constants/numerical"),
              c = u.BADNUM,
              d = u.ONEDAY,
              h = u.ONEHOUR,
              f = u.ONEMIN,
              p = u.ONESEC,
              m = u.EPOCHJD,
              g = e("../registry"),
              v = o.time.format.utc,
              y = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d:?\d\d)?)?)?)?)?\s*$/m,
              b = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d:?\d\d)?)?)?)?)?\s*$/m,
              _ = new Date().getFullYear() - 70;
            function x(e) {
              return e && g.componentsRegistry.calendars && "string" == typeof e && "gregorian" !== e;
            }
            function w(e, t) {
              return String(e + Math.pow(10, t)).substr(1);
            }
            n.dateTick0 = function (e, t) {
              return x(e) ? t ? g.getComponentMethod("calendars", "CANONICAL_SUNDAY")[e] : g.getComponentMethod("calendars", "CANONICAL_TICK")[e] : t ? "2000-01-02" : "2000-01-01";
            }, n.dfltRange = function (e) {
              return x(e) ? g.getComponentMethod("calendars", "DFLTRANGE")[e] : ["2000-01-01", "2001-01-01"];
            }, n.isJSDate = function (e) {
              return "object" == typeof e && null !== e && "function" == typeof e.getTime;
            }, n.dateTime2ms = function (e, t) {
              if (n.isJSDate(e)) {
                var o = e.getTimezoneOffset() * f,
                  a = (e.getUTCMinutes() - e.getMinutes()) * f + (e.getUTCSeconds() - e.getSeconds()) * p + (e.getUTCMilliseconds() - e.getMilliseconds());
                if (a) {
                  var s = 3 * f;
                  o = o - s / 2 + l(a - o + s / 2, s);
                }
                return (e = Number(e) - o) >= r && e <= i ? e : c;
              }
              if ("string" != typeof e && "number" != typeof e) return c;
              e = String(e);
              var u = x(t),
                v = e.charAt(0);
              !u || "G" !== v && "g" !== v || (e = e.substr(1), t = "");
              var w = u && "chinese" === t.substr(0, 7),
                S = e.match(w ? b : y);
              if (!S) return c;
              var A = S[1],
                E = S[3] || "1",
                T = Number(S[5] || 1),
                M = Number(S[7] || 0),
                C = Number(S[9] || 0),
                k = Number(S[11] || 0);
              if (u) {
                if (2 === A.length) return c;
                var P;
                A = Number(A);
                try {
                  var O = g.getComponentMethod("calendars", "getCal")(t);
                  if (w) {
                    var R = "i" === E.charAt(E.length - 1);
                    E = parseInt(E, 10), P = O.newDate(A, O.toMonthIndex(A, E, R), T);
                  } else P = O.newDate(A, Number(E), T);
                } catch (e) {
                  return c;
                }
                return P ? (P.toJD() - m) * d + M * h + C * f + k * p : c;
              }
              A = 2 === A.length ? (Number(A) + 2e3 - _) % 100 + _ : Number(A), E -= 1;
              var I = new Date(Date.UTC(2e3, E, T, M, C));
              return I.setUTCFullYear(A), I.getUTCMonth() !== E || I.getUTCDate() !== T ? c : I.getTime() + k * p;
            }, r = n.MIN_MS = n.dateTime2ms("-9999"), i = n.MAX_MS = n.dateTime2ms("9999-12-31 23:59:59.9999"), n.isDateTime = function (e, t) {
              return n.dateTime2ms(e, t) !== c;
            };
            var S = 90 * d,
              A = 3 * h,
              E = 5 * f;
            function T(e, t, n, r, i) {
              if ((t || n || r || i) && (e += " " + w(t, 2) + ":" + w(n, 2), (r || i) && (e += ":" + w(r, 2), i))) {
                for (var o = 4; i % 10 == 0;) o -= 1, i /= 10;
                e += "." + w(i, o);
              }
              return e;
            }
            n.ms2DateTime = function (e, t, n) {
              if ("number" != typeof e || !(e >= r && e <= i)) return c;
              t || (t = 0);
              var o,
                a,
                s,
                u,
                y,
                b,
                _ = Math.floor(10 * l(e + .05, 1)),
                w = Math.round(e - _ / 10);
              if (x(n)) {
                var M = Math.floor(w / d) + m,
                  C = Math.floor(l(e, d));
                try {
                  o = g.getComponentMethod("calendars", "getCal")(n).fromJD(M).formatDate("yyyy-mm-dd");
                } catch (e) {
                  o = v("G%Y-%m-%d")(new Date(w));
                }
                if ("-" === o.charAt(0)) for (; o.length < 11;) o = "-0" + o.substr(1);else for (; o.length < 10;) o = "0" + o;
                a = t < S ? Math.floor(C / h) : 0, s = t < S ? Math.floor(C % h / f) : 0, u = t < A ? Math.floor(C % f / p) : 0, y = t < E ? C % p * 10 + _ : 0;
              } else b = new Date(w), o = v("%Y-%m-%d")(b), a = t < S ? b.getUTCHours() : 0, s = t < S ? b.getUTCMinutes() : 0, u = t < A ? b.getUTCSeconds() : 0, y = t < E ? 10 * b.getUTCMilliseconds() + _ : 0;
              return T(o, a, s, u, y);
            }, n.ms2DateTimeLocal = function (e) {
              if (!(e >= r + d && e <= i - d)) return c;
              var t = Math.floor(10 * l(e + .05, 1)),
                n = new Date(Math.round(e - t / 10));
              return T(o.time.format("%Y-%m-%d")(n), n.getHours(), n.getMinutes(), n.getSeconds(), 10 * n.getUTCMilliseconds() + t);
            }, n.cleanDate = function (e, t, r) {
              if (e === c) return t;
              if (n.isJSDate(e) || "number" == typeof e && isFinite(e)) {
                if (x(r)) return s.error("JS Dates and milliseconds are incompatible with world calendars", e), t;
                if (!(e = n.ms2DateTimeLocal(+e)) && void 0 !== t) return t;
              } else if (!n.isDateTime(e, r)) return s.error("unrecognized date", e), t;
              return e;
            };
            var M = /%\d?f/g;
            function C(e, t, n, r) {
              e = e.replace(M, function (e) {
                var n = Math.min(+e.charAt(1) || 6, 6);
                return (t / 1e3 % 1 + 2).toFixed(n).substr(2).replace(/0+$/, "") || "0";
              });
              var i = new Date(Math.floor(t + .05));
              if (x(r)) try {
                e = g.getComponentMethod("calendars", "worldCalFmt")(e, t, r);
              } catch (e) {
                return "Invalid";
              }
              return n(e)(i);
            }
            var k = [59, 59.9, 59.99, 59.999, 59.9999];
            n.formatDate = function (e, t, n, r, i, o) {
              if (i = x(i) && i, !t) if ("y" === n) t = o.year;else if ("m" === n) t = o.month;else {
                if ("d" !== n) return function (e, t) {
                  var n = l(e + .05, d),
                    r = w(Math.floor(n / h), 2) + ":" + w(l(Math.floor(n / f), 60), 2);
                  if ("M" !== t) {
                    a(t) || (t = 0);
                    var i = (100 + Math.min(l(e / p, 60), k[t])).toFixed(t).substr(1);
                    t > 0 && (i = i.replace(/0+$/, "").replace(/[\.]$/, "")), r += ":" + i;
                  }
                  return r;
                }(e, n) + "\n" + C(o.dayMonthYear, e, r, i);
                t = o.dayMonth + "\n" + o.year;
              }
              return C(t, e, r, i);
            };
            var P = 3 * d;
            n.incrementMonth = function (e, t, n) {
              n = x(n) && n;
              var r = l(e, d);
              if (e = Math.round(e - r), n) try {
                var i = Math.round(e / d) + m,
                  o = g.getComponentMethod("calendars", "getCal")(n),
                  a = o.fromJD(i);
                return t % 12 ? o.add(a, t, "m") : o.add(a, t / 12, "y"), (a.toJD() - m) * d + r;
              } catch (t) {
                s.error("invalid ms " + e + " in calendar " + n);
              }
              var u = new Date(e + P);
              return u.setUTCMonth(u.getUTCMonth() + t) + r - P;
            }, n.findExactDates = function (e, t) {
              for (var n, r, i = 0, o = 0, s = 0, l = 0, u = x(t) && g.getComponentMethod("calendars", "getCal")(t), c = 0; c < e.length; c++) if (r = e[c], a(r)) {
                if (!(r % d)) if (u) try {
                  1 === (n = u.fromJD(r / d + m)).day() ? 1 === n.month() ? i++ : o++ : s++;
                } catch (e) {} else 1 === (n = new Date(r)).getUTCDate() ? 0 === n.getUTCMonth() ? i++ : o++ : s++;
              } else l++;
              s += o += i;
              var h = e.length - l;
              return {
                exactYears: i / h,
                exactMonths: o / h,
                exactDays: s / h
              };
            };
          }, {
            "../constants/numerical": 474,
            "../registry": 593,
            "./loggers": 499,
            "./mod": 502,
            d3: 82,
            "fast-isnumeric": 91
          }],
          487: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("./loggers");
            function o(e) {
              var t = e && e.parentNode;
              t && t.removeChild(e);
            }
            function a(e, t, n) {
              var r = "plotly.js-style-" + e,
                o = document.getElementById(r);
              o || ((o = document.createElement("style")).setAttribute("id", r), o.appendChild(document.createTextNode("")), document.head.appendChild(o));
              var a = o.sheet;
              a.insertRule ? a.insertRule(t + "{" + n + "}", 0) : a.addRule ? a.addRule(t, n, 0) : i.warn("addStyleRule failed");
            }
            t.exports = {
              getGraphDiv: function getGraphDiv(e) {
                var t;
                if ("string" == typeof e) {
                  if (null === (t = document.getElementById(e))) throw new Error("No DOM element with id '" + e + "' exists on the page.");
                  return t;
                }
                if (null == e) throw new Error("DOM element provided is null or undefined");
                return e;
              },
              isPlotDiv: function isPlotDiv(e) {
                var t = r.select(e);
                return t.node() instanceof HTMLElement && t.size() && t.classed("js-plotly-plot");
              },
              removeElement: o,
              addStyleRule: function addStyleRule(e, t) {
                a("global", e, t);
              },
              addRelatedStyleRule: a,
              deleteRelatedStyleRule: function deleteRelatedStyleRule(e) {
                var t = "plotly.js-style-" + e,
                  n = document.getElementById(t);
                n && o(n);
              }
            };
          }, {
            "./loggers": 499,
            d3: 82
          }],
          488: [function (e, t, n) {
            "use strict";

            var r = e("events").EventEmitter,
              i = {
                init: function init(e) {
                  if (e._ev instanceof r) return e;
                  var t = new r(),
                    n = new r();
                  return e._ev = t, e._internalEv = n, e.on = t.on.bind(t), e.once = t.once.bind(t), e.removeListener = t.removeListener.bind(t), e.removeAllListeners = t.removeAllListeners.bind(t), e._internalOn = n.on.bind(n), e._internalOnce = n.once.bind(n), e._removeInternalListener = n.removeListener.bind(n), e._removeAllInternalListeners = n.removeAllListeners.bind(n), e.emit = function (r, i) {
                    "undefined" != typeof jQuery && jQuery(e).trigger(r, i), t.emit(r, i), n.emit(r, i);
                  }, e;
                },
                triggerHandler: function triggerHandler(e, t, n) {
                  var r, i;
                  "undefined" != typeof jQuery && (r = jQuery(e).triggerHandler(t, n));
                  var o = e._ev;
                  if (!o) return r;
                  var a,
                    s = o._events[t];
                  if (!s) return r;
                  function l(e) {
                    return e.listener ? (o.removeListener(t, e.listener), e.fired ? void 0 : (e.fired = !0, e.listener.apply(o, [n]))) : e.apply(o, [n]);
                  }
                  for (s = Array.isArray(s) ? s : [s], a = 0; a < s.length - 1; a++) l(s[a]);
                  return i = l(s[a]), void 0 !== r ? r : i;
                },
                purge: function purge(e) {
                  return delete e._ev, delete e.on, delete e.once, delete e.removeListener, delete e.removeAllListeners, delete e.emit, delete e._ev, delete e._internalEv, delete e._internalOn, delete e._internalOnce, delete e._removeInternalListener, delete e._removeAllInternalListeners, e;
                }
              };
            t.exports = i;
          }, {
            events: 48
          }],
          489: [function (e, t, n) {
            "use strict";

            var r = e("./is_plain_object.js"),
              i = Array.isArray;
            function o(e, t, n, a) {
              var s,
                l,
                u,
                c,
                d,
                h,
                f = e[0],
                p = e.length;
              if (2 === p && i(f) && i(e[1]) && 0 === f.length) {
                if (function (e, t) {
                  var n, r;
                  for (n = 0; n < e.length; n++) {
                    if (null !== (r = e[n]) && "object" == typeof r) return !1;
                    void 0 !== r && (t[n] = r);
                  }
                  return !0;
                }(e[1], f)) return f;
                f.splice(0, f.length);
              }
              for (var m = 1; m < p; m++) for (l in s = e[m]) u = f[l], c = s[l], a && i(c) ? f[l] = c : t && c && (r(c) || (d = i(c))) ? (d ? (d = !1, h = u && i(u) ? u : []) : h = u && r(u) ? u : {}, f[l] = o([h, c], t, n, a)) : (void 0 !== c || n) && (f[l] = c);
              return f;
            }
            n.extendFlat = function () {
              return o(arguments, !1, !1, !1);
            }, n.extendDeep = function () {
              return o(arguments, !0, !1, !1);
            }, n.extendDeepAll = function () {
              return o(arguments, !0, !0, !1);
            }, n.extendDeepNoArrays = function () {
              return o(arguments, !0, !1, !0);
            };
          }, {
            "./is_plain_object.js": 496
          }],
          490: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = {}, n = [], r = 0, i = 0; i < e.length; i++) {
                var o = e[i];
                1 !== t[o] && (t[o] = 1, n[r++] = o);
              }
              return n;
            };
          }, {}],
          491: [function (e, t, n) {
            "use strict";

            function r(e) {
              return !0 === e.visible;
            }
            function i(e) {
              var t = e[0].trace;
              return !0 === t.visible && 0 !== t._length;
            }
            t.exports = function (e) {
              for (var t, n = (t = e, Array.isArray(t) && Array.isArray(t[0]) && t[0][0] && t[0][0].trace ? i : r), o = [], a = 0; a < e.length; a++) {
                var s = e[a];
                n(s) && o.push(s);
              }
              return o;
            };
          }, {}],
          492: [function (e, t, n) {
            "use strict";

            var r,
              i,
              o,
              a = e("./mod").mod;
            function s(e, t, n, r, i, o, a, s) {
              var l = n - e,
                u = i - e,
                c = a - i,
                d = r - t,
                h = o - t,
                f = s - o,
                p = l * f - c * d;
              if (0 === p) return null;
              var m = (u * f - c * h) / p,
                g = (u * d - l * h) / p;
              return g < 0 || g > 1 || m < 0 || m > 1 ? null : {
                x: e + l * m,
                y: t + d * m
              };
            }
            function l(e, t, n, r, i) {
              var o = r * e + i * t;
              if (o < 0) return r * r + i * i;
              if (o > n) {
                var a = r - e,
                  s = i - t;
                return a * a + s * s;
              }
              var l = r * t - i * e;
              return l * l / n;
            }
            n.segmentsIntersect = s, n.segmentDistance = function (e, t, n, r, i, o, a, u) {
              if (s(e, t, n, r, i, o, a, u)) return 0;
              var c = n - e,
                d = r - t,
                h = a - i,
                f = u - o,
                p = c * c + d * d,
                m = h * h + f * f,
                g = Math.min(l(c, d, p, i - e, o - t), l(c, d, p, a - e, u - t), l(h, f, m, e - i, t - o), l(h, f, m, n - i, r - o));
              return Math.sqrt(g);
            }, n.getTextLocation = function (e, t, n, s) {
              if (e === i && s === o || (r = {}, i = e, o = s), r[n]) return r[n];
              var l = e.getPointAtLength(a(n - s / 2, t)),
                u = e.getPointAtLength(a(n + s / 2, t)),
                c = Math.atan((u.y - l.y) / (u.x - l.x)),
                d = e.getPointAtLength(a(n, t)),
                h = {
                  x: (4 * d.x + l.x + u.x) / 6,
                  y: (4 * d.y + l.y + u.y) / 6,
                  theta: c
                };
              return r[n] = h, h;
            }, n.clearLocationCache = function () {
              i = null;
            }, n.getVisibleSegment = function (e, t, n) {
              var r,
                i,
                o = t.left,
                a = t.right,
                s = t.top,
                l = t.bottom,
                u = 0,
                c = e.getTotalLength(),
                d = c;
              function h(t) {
                var n = e.getPointAtLength(t);
                0 === t ? r = n : t === c && (i = n);
                var u = n.x < o ? o - n.x : n.x > a ? n.x - a : 0,
                  d = n.y < s ? s - n.y : n.y > l ? n.y - l : 0;
                return Math.sqrt(u * u + d * d);
              }
              for (var f = h(u); f;) {
                if ((u += f + n) > d) return;
                f = h(u);
              }
              for (f = h(d); f;) {
                if (u > (d -= f + n)) return;
                f = h(d);
              }
              return {
                min: u,
                max: d,
                len: d - u,
                total: c,
                isClosed: 0 === u && d === c && Math.abs(r.x - i.x) < .1 && Math.abs(r.y - i.y) < .1
              };
            }, n.findPointOnPath = function (e, t, n, r) {
              for (var i, o, a, s = (r = r || {}).pathLength || e.getTotalLength(), l = r.tolerance || .001, u = r.iterationLimit || 30, c = e.getPointAtLength(0)[n] > e.getPointAtLength(s)[n] ? -1 : 1, d = 0, h = 0, f = s; d < u;) {
                if (i = (h + f) / 2, a = (o = e.getPointAtLength(i))[n] - t, Math.abs(a) < l) return o;
                c * a > 0 ? f = i : h = i, d++;
              }
              return o;
            };
          }, {
            "./mod": 502
          }],
          493: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("tinycolor2"),
              o = e("color-normalize"),
              a = e("../components/colorscale"),
              s = e("../components/color/attributes").defaultLine,
              l = e("./array").isArrayOrTypedArray,
              u = o(s);
            function c(e, t) {
              var n = e;
              return n[3] *= t, n;
            }
            function d(e) {
              if (r(e)) return u;
              var t = o(e);
              return t.length ? t : u;
            }
            function h(e) {
              return r(e) ? e : 1;
            }
            t.exports = {
              formatColor: function formatColor(e, t, n) {
                var r,
                  i,
                  s,
                  f,
                  p,
                  m = e.color,
                  g = l(m),
                  v = l(t),
                  y = a.extractOpts(e),
                  b = [];
                if (r = void 0 !== y.colorscale ? a.makeColorScaleFuncFromTrace(e) : d, i = g ? function (e, t) {
                  return void 0 === e[t] ? u : o(r(e[t]));
                } : d, s = v ? function (e, t) {
                  return void 0 === e[t] ? 1 : h(e[t]);
                } : h, g || v) for (var _ = 0; _ < n; _++) f = i(m, _), p = s(t, _), b[_] = c(f, p);else b = c(o(m), t);
                return b;
              },
              parseColorScale: function parseColorScale(e, t) {
                void 0 === t && (t = 1);
                var n = a.extractOpts(e);
                return (n.reversescale ? a.flipScale(n.colorscale) : n.colorscale).map(function (e) {
                  var n = e[0],
                    r = i(e[1]).toRgb();
                  return {
                    index: n,
                    rgb: [r.r, r.g, r.b, t]
                  };
                });
              }
            };
          }, {
            "../components/color/attributes": 374,
            "../components/colorscale": 387,
            "./array": 481,
            "color-normalize": 63,
            "fast-isnumeric": 91,
            tinycolor2: 341
          }],
          494: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              return e;
            };
          }, {}],
          495: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../constants/numerical"),
              a = o.FP_SAFE,
              s = o.BADNUM,
              l = t.exports = {};
            l.nestedProperty = e("./nested_property"), l.keyedContainer = e("./keyed_container"), l.relativeAttr = e("./relative_attr"), l.isPlainObject = e("./is_plain_object"), l.toLogRange = e("./to_log_range"), l.relinkPrivateKeys = e("./relink_private");
            var u = e("./array");
            l.isTypedArray = u.isTypedArray, l.isArrayOrTypedArray = u.isArrayOrTypedArray, l.isArray1D = u.isArray1D, l.ensureArray = u.ensureArray, l.concat = u.concat, l.maxRowLength = u.maxRowLength, l.minRowLength = u.minRowLength;
            var c = e("./mod");
            l.mod = c.mod, l.modHalf = c.modHalf;
            var d = e("./coerce");
            l.valObjectMeta = d.valObjectMeta, l.coerce = d.coerce, l.coerce2 = d.coerce2, l.coerceFont = d.coerceFont, l.coerceHoverinfo = d.coerceHoverinfo, l.coerceSelectionMarkerOpacity = d.coerceSelectionMarkerOpacity, l.validate = d.validate;
            var h = e("./dates");
            l.dateTime2ms = h.dateTime2ms, l.isDateTime = h.isDateTime, l.ms2DateTime = h.ms2DateTime, l.ms2DateTimeLocal = h.ms2DateTimeLocal, l.cleanDate = h.cleanDate, l.isJSDate = h.isJSDate, l.formatDate = h.formatDate, l.incrementMonth = h.incrementMonth, l.dateTick0 = h.dateTick0, l.dfltRange = h.dfltRange, l.findExactDates = h.findExactDates, l.MIN_MS = h.MIN_MS, l.MAX_MS = h.MAX_MS;
            var f = e("./search");
            l.findBin = f.findBin, l.sorterAsc = f.sorterAsc, l.sorterDes = f.sorterDes, l.distinctVals = f.distinctVals, l.roundUp = f.roundUp, l.sort = f.sort, l.findIndexOfMin = f.findIndexOfMin;
            var p = e("./stats");
            l.aggNums = p.aggNums, l.len = p.len, l.mean = p.mean, l.median = p.median, l.midRange = p.midRange, l.variance = p.variance, l.stdev = p.stdev, l.interp = p.interp;
            var m = e("./matrix");
            l.init2dArray = m.init2dArray, l.transposeRagged = m.transposeRagged, l.dot = m.dot, l.translationMatrix = m.translationMatrix, l.rotationMatrix = m.rotationMatrix, l.rotationXYMatrix = m.rotationXYMatrix, l.apply2DTransform = m.apply2DTransform, l.apply2DTransform2 = m.apply2DTransform2;
            var g = e("./angles");
            l.deg2rad = g.deg2rad, l.rad2deg = g.rad2deg, l.angleDelta = g.angleDelta, l.angleDist = g.angleDist, l.isFullCircle = g.isFullCircle, l.isAngleInsideSector = g.isAngleInsideSector, l.isPtInsideSector = g.isPtInsideSector, l.pathArc = g.pathArc, l.pathSector = g.pathSector, l.pathAnnulus = g.pathAnnulus;
            var v = e("./anchor_utils");
            l.isLeftAnchor = v.isLeftAnchor, l.isCenterAnchor = v.isCenterAnchor, l.isRightAnchor = v.isRightAnchor, l.isTopAnchor = v.isTopAnchor, l.isMiddleAnchor = v.isMiddleAnchor, l.isBottomAnchor = v.isBottomAnchor;
            var y = e("./geometry2d");
            l.segmentsIntersect = y.segmentsIntersect, l.segmentDistance = y.segmentDistance, l.getTextLocation = y.getTextLocation, l.clearLocationCache = y.clearLocationCache, l.getVisibleSegment = y.getVisibleSegment, l.findPointOnPath = y.findPointOnPath;
            var b = e("./extend");
            l.extendFlat = b.extendFlat, l.extendDeep = b.extendDeep, l.extendDeepAll = b.extendDeepAll, l.extendDeepNoArrays = b.extendDeepNoArrays;
            var _ = e("./loggers");
            l.log = _.log, l.warn = _.warn, l.error = _.error;
            var x = e("./regex");
            l.counterRegex = x.counter;
            var w = e("./throttle");
            l.throttle = w.throttle, l.throttleDone = w.done, l.clearThrottle = w.clear;
            var S = e("./dom");
            function A(e) {
              var t = {};
              for (var n in e) for (var r = e[n], i = 0; i < r.length; i++) t[r[i]] = +n;
              return t;
            }
            l.getGraphDiv = S.getGraphDiv, l.isPlotDiv = S.isPlotDiv, l.removeElement = S.removeElement, l.addStyleRule = S.addStyleRule, l.addRelatedStyleRule = S.addRelatedStyleRule, l.deleteRelatedStyleRule = S.deleteRelatedStyleRule, l.clearResponsive = e("./clear_responsive"), l.makeTraceGroups = e("./make_trace_groups"), l._ = e("./localize"), l.notifier = e("./notifier"), l.filterUnique = e("./filter_unique"), l.filterVisible = e("./filter_visible"), l.pushUnique = e("./push_unique"), l.cleanNumber = e("./clean_number"), l.ensureNumber = function (e) {
              return i(e) ? (e = Number(e)) < -a || e > a ? s : i(e) ? Number(e) : s : s;
            }, l.isIndex = function (e, t) {
              return !(void 0 !== t && e >= t) && i(e) && e >= 0 && e % 1 == 0;
            }, l.noop = e("./noop"), l.identity = e("./identity"), l.repeat = function (e, t) {
              for (var n = new Array(t), r = 0; r < t; r++) n[r] = e;
              return n;
            }, l.swapAttrs = function (e, t, n, r) {
              n || (n = "x"), r || (r = "y");
              for (var i = 0; i < t.length; i++) {
                var o = t[i],
                  a = l.nestedProperty(e, o.replace("?", n)),
                  s = l.nestedProperty(e, o.replace("?", r)),
                  u = a.get();
                a.set(s.get()), s.set(u);
              }
            }, l.raiseToTop = function (e) {
              e.parentNode.appendChild(e);
            }, l.cancelTransition = function (e) {
              return e.transition().duration(0);
            }, l.constrain = function (e, t, n) {
              return t > n ? Math.max(n, Math.min(t, e)) : Math.max(t, Math.min(n, e));
            }, l.bBoxIntersect = function (e, t, n) {
              return n = n || 0, e.left <= t.right + n && t.left <= e.right + n && e.top <= t.bottom + n && t.top <= e.bottom + n;
            }, l.simpleMap = function (e, t, n, r) {
              for (var i = e.length, o = new Array(i), a = 0; a < i; a++) o[a] = t(e[a], n, r);
              return o;
            }, l.randstr = function e(t, n, r, i) {
              if (r || (r = 16), void 0 === n && (n = 24), n <= 0) return "0";
              var o,
                a,
                s = Math.log(Math.pow(2, n)) / Math.log(r),
                u = "";
              for (o = 2; s === 1 / 0; o *= 2) s = Math.log(Math.pow(2, n / o)) / Math.log(r) * o;
              var c = s - Math.floor(s);
              for (o = 0; o < Math.floor(s); o++) u = Math.floor(Math.random() * r).toString(r) + u;
              c && (a = Math.pow(r, c), u = Math.floor(Math.random() * a).toString(r) + u);
              var d = parseInt(u, r);
              return t && t[u] || d !== 1 / 0 && d >= Math.pow(2, n) ? i > 10 ? (l.warn("randstr failed uniqueness"), u) : e(t, n, r, (i || 0) + 1) : u;
            }, l.OptionControl = function (e, t) {
              e || (e = {}), t || (t = "opt");
              var n = {
                optionList: [],
                _newoption: function _newoption(r) {
                  r[t] = e, n[r.name] = r, n.optionList.push(r);
                }
              };
              return n["_" + t] = e, n;
            }, l.smooth = function (e, t) {
              if ((t = Math.round(t) || 0) < 2) return e;
              var n,
                r,
                i,
                o,
                a = e.length,
                s = 2 * a,
                l = 2 * t - 1,
                u = new Array(l),
                c = new Array(a);
              for (n = 0; n < l; n++) u[n] = (1 - Math.cos(Math.PI * (n + 1) / t)) / (2 * t);
              for (n = 0; n < a; n++) {
                for (o = 0, r = 0; r < l; r++) (i = n + r + 1 - t) < -a ? i -= s * Math.round(i / s) : i >= s && (i -= s * Math.floor(i / s)), i < 0 ? i = -1 - i : i >= a && (i = s - 1 - i), o += e[i] * u[r];
                c[n] = o;
              }
              return c;
            }, l.syncOrAsync = function (e, t, n) {
              var r;
              function i() {
                return l.syncOrAsync(e, t, n);
              }
              for (; e.length;) if ((r = (0, e.splice(0, 1)[0])(t)) && r.then) return r.then(i).then(void 0, l.promiseError);
              return n && n(t);
            }, l.stripTrailingSlash = function (e) {
              return "/" === e.substr(-1) ? e.substr(0, e.length - 1) : e;
            }, l.noneOrAll = function (e, t, n) {
              if (e) {
                var r,
                  i = !1,
                  o = !0;
                for (r = 0; r < n.length; r++) null != e[n[r]] ? i = !0 : o = !1;
                if (i && !o) for (r = 0; r < n.length; r++) e[n[r]] = t[n[r]];
              }
            }, l.mergeArray = function (e, t, n, r) {
              var i = "function" == typeof r;
              if (l.isArrayOrTypedArray(e)) for (var o = Math.min(e.length, t.length), a = 0; a < o; a++) {
                var s = e[a];
                t[a][n] = i ? r(s) : s;
              }
            }, l.mergeArrayCastPositive = function (e, t, n) {
              return l.mergeArray(e, t, n, function (e) {
                var t = +e;
                return isFinite(t) && t > 0 ? t : 0;
              });
            }, l.fillArray = function (e, t, n, r) {
              if (r = r || l.identity, l.isArrayOrTypedArray(e)) for (var i = 0; i < t.length; i++) t[i][n] = r(e[i]);
            }, l.castOption = function (e, t, n, r) {
              r = r || l.identity;
              var i = l.nestedProperty(e, n).get();
              return l.isArrayOrTypedArray(i) ? Array.isArray(t) && l.isArrayOrTypedArray(i[t[0]]) ? r(i[t[0]][t[1]]) : r(i[t]) : i;
            }, l.extractOption = function (e, t, n, r) {
              if (n in e) return e[n];
              var i = l.nestedProperty(t, r).get();
              return Array.isArray(i) ? void 0 : i;
            }, l.tagSelected = function (e, t, n) {
              var r,
                i,
                o = t.selectedpoints,
                a = t._indexToPoints;
              a && (r = A(a));
              for (var s = 0; s < o.length; s++) {
                var u = o[s];
                if (l.isIndex(u) || l.isArrayOrTypedArray(u) && l.isIndex(u[0]) && l.isIndex(u[1])) {
                  var c = r ? r[u] : u,
                    d = n ? n[c] : c;
                  void 0 !== (i = d) && i < e.length && (e[d].selected = 1);
                }
              }
            }, l.selIndices2selPoints = function (e) {
              var t = e.selectedpoints,
                n = e._indexToPoints;
              if (n) {
                for (var r = A(n), i = [], o = 0; o < t.length; o++) {
                  var a = t[o];
                  if (l.isIndex(a)) {
                    var s = r[a];
                    l.isIndex(s) && i.push(s);
                  }
                }
                return i;
              }
              return t;
            }, l.getTargetArray = function (e, t) {
              var n = t.target;
              if ("string" == typeof n && n) {
                var r = l.nestedProperty(e, n).get();
                return !!Array.isArray(r) && r;
              }
              return !!Array.isArray(n) && n;
            }, l.minExtend = function (e, t) {
              var n = {};
              "object" != typeof t && (t = {});
              var r,
                i,
                o,
                a = Object.keys(e);
              for (r = 0; r < a.length; r++) o = e[i = a[r]], "_" !== i.charAt(0) && "function" != typeof o && ("module" === i ? n[i] = o : Array.isArray(o) ? n[i] = "colorscale" === i ? o.slice() : o.slice(0, 3) : l.isTypedArray(o) ? n[i] = o.subarray(0, 3) : n[i] = o && "object" == typeof o ? l.minExtend(e[i], t[i]) : o);
              for (a = Object.keys(t), r = 0; r < a.length; r++) "object" == typeof (o = t[i = a[r]]) && i in n && "object" == typeof n[i] || (n[i] = o);
              return n;
            }, l.titleCase = function (e) {
              return e.charAt(0).toUpperCase() + e.substr(1);
            }, l.containsAny = function (e, t) {
              for (var n = 0; n < t.length; n++) if (-1 !== e.indexOf(t[n])) return !0;
              return !1;
            }, l.isIE = function () {
              return void 0 !== window.navigator.msSaveBlob;
            };
            var E = /MSIE [1-9]\./;
            l.isIE9orBelow = function () {
              return l.isIE() && E.test(window.navigator.userAgent);
            };
            var T = /Version\/[\d\.]+.*Safari/;
            l.isSafari = function () {
              return T.test(window.navigator.userAgent);
            }, l.isD3Selection = function (e) {
              return e && "function" == typeof e.classed;
            }, l.ensureSingle = function (e, t, n, r) {
              var i = e.select(t + (n ? "." + n : ""));
              if (i.size()) return i;
              var o = e.append(t);
              return n && o.classed(n, !0), r && o.call(r), o;
            }, l.ensureSingleById = function (e, t, n, r) {
              var i = e.select(t + "#" + n);
              if (i.size()) return i;
              var o = e.append(t).attr("id", n);
              return r && o.call(r), o;
            }, l.objectFromPath = function (e, t) {
              for (var n, r = e.split("."), i = n = {}, o = 0; o < r.length; o++) {
                var a = r[o],
                  s = null,
                  l = r[o].match(/(.*)\[([0-9]+)\]/);
                l ? (a = l[1], s = l[2], n = n[a] = [], o === r.length - 1 ? n[s] = t : n[s] = {}, n = n[s]) : (o === r.length - 1 ? n[a] = t : n[a] = {}, n = n[a]);
              }
              return i;
            };
            var M = /^([^\[\.]+)\.(.+)?/,
              C = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
            l.expandObjectPaths = function (e) {
              var t, n, r, i, o, a, s;
              if ("object" == typeof e && !Array.isArray(e)) for (n in e) e.hasOwnProperty(n) && ((t = n.match(M)) ? (i = e[n], r = t[1], delete e[n], e[r] = l.extendDeepNoArrays(e[r] || {}, l.objectFromPath(n, l.expandObjectPaths(i))[r])) : (t = n.match(C)) ? (i = e[n], r = t[1], o = parseInt(t[2]), delete e[n], e[r] = e[r] || [], "." === t[3] ? (s = t[4], a = e[r][o] = e[r][o] || {}, l.extendDeepNoArrays(a, l.objectFromPath(s, l.expandObjectPaths(i)))) : e[r][o] = l.expandObjectPaths(i)) : e[n] = l.expandObjectPaths(e[n]));
              return e;
            }, l.numSeparate = function (e, t, n) {
              if (n || (n = !1), "string" != typeof t || 0 === t.length) throw new Error("Separator string required for formatting!");
              "number" == typeof e && (e = String(e));
              var r = /(\d+)(\d{3})/,
                i = t.charAt(0),
                o = t.charAt(1),
                a = e.split("."),
                s = a[0],
                l = a.length > 1 ? i + a[1] : "";
              if (o && (a.length > 1 || s.length > 4 || n)) for (; r.test(s);) s = s.replace(r, "$1" + o + "$2");
              return s + l;
            }, l.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
            var k = /^\w*$/;
            l.templateString = function (e, t) {
              var n = {};
              return e.replace(l.TEMPLATE_STRING_REGEX, function (e, r) {
                var i;
                return k.test(r) ? i = t[r] : (n[r] = n[r] || l.nestedProperty(t, r).get, i = n[r]()), l.isValidTextValue(i) ? i : "";
              });
            };
            var P = {
              max: 10,
              count: 0,
              name: "hovertemplate"
            };
            l.hovertemplateString = function () {
              return I.apply(P, arguments);
            };
            var O = {
              max: 10,
              count: 0,
              name: "texttemplate"
            };
            l.texttemplateString = function () {
              return I.apply(O, arguments);
            };
            var R = /^[:|\|]/;
            function I(e, t, n) {
              var i = this,
                o = arguments;
              t || (t = {});
              var a = {};
              return e.replace(l.TEMPLATE_STRING_REGEX, function (e, s, u) {
                var c, d, h, f;
                for (h = 3; h < o.length; h++) if (c = o[h]) {
                  if (c.hasOwnProperty(s)) {
                    d = c[s];
                    break;
                  }
                  if (k.test(s) || (d = a[s] || l.nestedProperty(c, s).get()) && (a[s] = d), void 0 !== d) break;
                }
                if (void 0 === d && i) return i.count < i.max && (l.warn("Variable '" + s + "' in " + i.name + " could not be found!"), d = e), i.count === i.max && l.warn("Too many " + i.name + " warnings - additional warnings will be suppressed"), i.count++, e;
                if (u) {
                  if (":" === u[0] && (d = (f = n ? n.numberFormat : r.format)(u.replace(R, ""))(d)), "|" === u[0]) {
                    f = n ? n.timeFormat.utc : r.time.format.utc;
                    var p = l.dateTime2ms(d);
                    d = l.formatDate(p, u.replace(R, ""), !1, f);
                  }
                } else t.hasOwnProperty(s + "Label") && (d = t[s + "Label"]);
                return d;
              });
            }
            l.subplotSort = function (e, t) {
              for (var n = Math.min(e.length, t.length) + 1, r = 0, i = 0, o = 0; o < n; o++) {
                var a = e.charCodeAt(o) || 0,
                  s = t.charCodeAt(o) || 0,
                  l = a >= 48 && a <= 57,
                  u = s >= 48 && s <= 57;
                if (l && (r = 10 * r + a - 48), u && (i = 10 * i + s - 48), !l || !u) {
                  if (r !== i) return r - i;
                  if (a !== s) return a - s;
                }
              }
              return i - r;
            };
            var j = 2e9;
            l.seedPseudoRandom = function () {
              j = 2e9;
            }, l.pseudoRandom = function () {
              var e = j;
              return j = (69069 * j + 1) % 4294967296, Math.abs(j - e) < 429496729 ? l.pseudoRandom() : j / 4294967296;
            }, l.fillText = function (e, t, n) {
              var r = Array.isArray(n) ? function (e) {
                  n.push(e);
                } : function (e) {
                  n.text = e;
                },
                i = l.extractOption(e, t, "htx", "hovertext");
              if (l.isValidTextValue(i)) return r(i);
              var o = l.extractOption(e, t, "tx", "text");
              return l.isValidTextValue(o) ? r(o) : void 0;
            }, l.isValidTextValue = function (e) {
              return e || 0 === e;
            }, l.formatPercent = function (e, t) {
              t = t || 0;
              for (var n = (Math.round(100 * e * Math.pow(10, t)) * Math.pow(.1, t)).toFixed(t) + "%", r = 0; r < t; r++) -1 !== n.indexOf(".") && (n = (n = n.replace("0%", "%")).replace(".%", "%"));
              return n;
            }, l.isHidden = function (e) {
              var t = window.getComputedStyle(e).display;
              return !t || "none" === t;
            }, l.getTextTransform = function (e) {
              var t = e.noCenter,
                n = e.textX,
                r = e.textY,
                i = e.targetX,
                o = e.targetY,
                a = e.anchorX || 0,
                s = e.anchorY || 0,
                l = e.rotate,
                u = e.scale;
              return u ? u > 1 && (u = 1) : u = 0, "translate(" + (i - u * (n + a)) + "," + (o - u * (r + s)) + ")" + (u < 1 ? "scale(" + u + ")" : "") + (l ? "rotate(" + l + (t ? "" : " " + n + " " + r) + ")" : "");
            }, l.ensureUniformFontSize = function (e, t) {
              var n = l.extendFlat({}, t);
              return n.size = Math.max(t.size, e._fullLayout.uniformtext.minsize || 0), n;
            };
          }, {
            "../constants/numerical": 474,
            "./anchor_utils": 479,
            "./angles": 480,
            "./array": 481,
            "./clean_number": 482,
            "./clear_responsive": 484,
            "./coerce": 485,
            "./dates": 486,
            "./dom": 487,
            "./extend": 489,
            "./filter_unique": 490,
            "./filter_visible": 491,
            "./geometry2d": 492,
            "./identity": 494,
            "./is_plain_object": 496,
            "./keyed_container": 497,
            "./localize": 498,
            "./loggers": 499,
            "./make_trace_groups": 500,
            "./matrix": 501,
            "./mod": 502,
            "./nested_property": 503,
            "./noop": 504,
            "./notifier": 505,
            "./push_unique": 508,
            "./regex": 510,
            "./relative_attr": 511,
            "./relink_private": 512,
            "./search": 513,
            "./stats": 516,
            "./throttle": 519,
            "./to_log_range": 520,
            d3: 82,
            "fast-isnumeric": 91
          }],
          496: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              return window && window.process && window.process.versions ? "[object Object]" === Object.prototype.toString.call(e) : "[object Object]" === Object.prototype.toString.call(e) && Object.getPrototypeOf(e) === Object.prototype;
            };
          }, {}],
          497: [function (e, t, n) {
            "use strict";

            var r = e("./nested_property"),
              i = /^\w*$/;
            t.exports = function (e, t, n, o) {
              var a, s, l;
              n = n || "name", o = o || "value";
              var u = {};
              t && t.length ? (l = r(e, t), s = l.get()) : s = e, t = t || "";
              var c = {};
              if (s) for (a = 0; a < s.length; a++) c[s[a][n]] = a;
              var d = i.test(o),
                h = {
                  set: function set(e, t) {
                    var i = null === t ? 4 : 0;
                    if (!s) {
                      if (!l || 4 === i) return;
                      s = [], l.set(s);
                    }
                    var a = c[e];
                    if (void 0 === a) {
                      if (4 === i) return;
                      i |= 3, a = s.length, c[e] = a;
                    } else t !== (d ? s[a][o] : r(s[a], o).get()) && (i |= 2);
                    var f = s[a] = s[a] || {};
                    return f[n] = e, d ? f[o] = t : r(f, o).set(t), null !== t && (i &= -5), u[a] = u[a] | i, h;
                  },
                  get: function get(e) {
                    if (s) {
                      var t = c[e];
                      return void 0 === t ? void 0 : d ? s[t][o] : r(s[t], o).get();
                    }
                  },
                  rename: function rename(e, t) {
                    var r = c[e];
                    return void 0 === r || (u[r] = 1 | u[r], c[t] = r, delete c[e], s[r][n] = t), h;
                  },
                  remove: function remove(e) {
                    var t = c[e];
                    if (void 0 === t) return h;
                    var i = s[t];
                    if (Object.keys(i).length > 2) return u[t] = 2 | u[t], h.set(e, null);
                    if (d) {
                      for (a = t; a < s.length; a++) u[a] = 3 | u[a];
                      for (a = t; a < s.length; a++) c[s[a][n]]--;
                      s.splice(t, 1), delete c[e];
                    } else r(i, o).set(null), u[t] = 6 | u[t];
                    return h;
                  },
                  constructUpdate: function constructUpdate() {
                    for (var e, i, a = {}, l = Object.keys(u), c = 0; c < l.length; c++) i = l[c], e = t + "[" + i + "]", s[i] ? (1 & u[i] && (a[e + "." + n] = s[i][n]), 2 & u[i] && (a[e + "." + o] = d ? 4 & u[i] ? null : s[i][o] : 4 & u[i] ? null : r(s[i], o).get())) : a[e] = null;
                    return a;
                  }
                };
              return h;
            };
          }, {
            "./nested_property": 503
          }],
          498: [function (e, t, n) {
            "use strict";

            var r = e("../registry");
            t.exports = function (e, t) {
              for (var n = e._context.locale, i = 0; i < 2; i++) {
                for (var o = e._context.locales, a = 0; a < 2; a++) {
                  var s = (o[n] || {}).dictionary;
                  if (s) {
                    var l = s[t];
                    if (l) return l;
                  }
                  o = r.localeRegistry;
                }
                var u = n.split("-")[0];
                if (u === n) break;
                n = u;
              }
              return t;
            };
          }, {
            "../registry": 593
          }],
          499: [function (e, t, n) {
            "use strict";

            var r = e("../plot_api/plot_config").dfltConfig,
              i = e("./notifier"),
              o = t.exports = {};
            function a(e, t) {
              if (e && e.apply) try {
                return void e.apply(console, t);
              } catch (e) {}
              for (var n = 0; n < t.length; n++) try {
                e(t[n]);
              } catch (e) {
                console.log(t[n]);
              }
            }
            o.log = function () {
              var e;
              if (r.logging > 1) {
                var t = ["LOG:"];
                for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
                a(console.trace || console.log, t);
              }
              if (r.notifyOnLogging > 1) {
                var n = [];
                for (e = 0; e < arguments.length; e++) n.push(arguments[e]);
                i(n.join("<br>"), "long");
              }
            }, o.warn = function () {
              var e;
              if (r.logging > 0) {
                var t = ["WARN:"];
                for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
                a(console.trace || console.log, t);
              }
              if (r.notifyOnLogging > 0) {
                var n = [];
                for (e = 0; e < arguments.length; e++) n.push(arguments[e]);
                i(n.join("<br>"), "stick");
              }
            }, o.error = function () {
              var e;
              if (r.logging > 0) {
                var t = ["ERROR:"];
                for (e = 0; e < arguments.length; e++) t.push(arguments[e]);
                a(console.error, t);
              }
              if (r.notifyOnLogging > 0) {
                var n = [];
                for (e = 0; e < arguments.length; e++) n.push(arguments[e]);
                i(n.join("<br>"), "stick");
              }
            };
          }, {
            "../plot_api/plot_config": 529,
            "./notifier": 505
          }],
          500: [function (e, t, n) {
            "use strict";

            var r = e("d3");
            t.exports = function (e, t, n) {
              var i = e.selectAll("g." + n.replace(/\s/g, ".")).data(t, function (e) {
                return e[0].trace.uid;
              });
              i.exit().remove(), i.enter().append("g").attr("class", n), i.order();
              var o = e.classed("rangeplot") ? "nodeRangePlot3" : "node3";
              return i.each(function (e) {
                e[0][o] = r.select(this);
              }), i;
            };
          }, {
            d3: 82
          }],
          501: [function (e, t, n) {
            "use strict";

            n.init2dArray = function (e, t) {
              for (var n = new Array(e), r = 0; r < e; r++) n[r] = new Array(t);
              return n;
            }, n.transposeRagged = function (e) {
              var t,
                n,
                r = 0,
                i = e.length;
              for (t = 0; t < i; t++) r = Math.max(r, e[t].length);
              var o = new Array(r);
              for (t = 0; t < r; t++) for (o[t] = new Array(i), n = 0; n < i; n++) o[t][n] = e[n][t];
              return o;
            }, n.dot = function (e, t) {
              if (!e.length || !t.length || e.length !== t.length) return null;
              var r,
                i,
                o = e.length;
              if (e[0].length) for (r = new Array(o), i = 0; i < o; i++) r[i] = n.dot(e[i], t);else if (t[0].length) {
                var a = n.transposeRagged(t);
                for (r = new Array(a.length), i = 0; i < a.length; i++) r[i] = n.dot(e, a[i]);
              } else for (r = 0, i = 0; i < o; i++) r += e[i] * t[i];
              return r;
            }, n.translationMatrix = function (e, t) {
              return [[1, 0, e], [0, 1, t], [0, 0, 1]];
            }, n.rotationMatrix = function (e) {
              var t = e * Math.PI / 180;
              return [[Math.cos(t), -Math.sin(t), 0], [Math.sin(t), Math.cos(t), 0], [0, 0, 1]];
            }, n.rotationXYMatrix = function (e, t, r) {
              return n.dot(n.dot(n.translationMatrix(t, r), n.rotationMatrix(e)), n.translationMatrix(-t, -r));
            }, n.apply2DTransform = function (e) {
              return function () {
                var t = arguments;
                3 === t.length && (t = t[0]);
                var r = 1 === arguments.length ? t[0] : [t[0], t[1]];
                return n.dot(e, [r[0], r[1], 1]).slice(0, 2);
              };
            }, n.apply2DTransform2 = function (e) {
              var t = n.apply2DTransform(e);
              return function (e) {
                return t(e.slice(0, 2)).concat(t(e.slice(2, 4)));
              };
            };
          }, {}],
          502: [function (e, t, n) {
            "use strict";

            t.exports = {
              mod: function mod(e, t) {
                var n = e % t;
                return n < 0 ? n + t : n;
              },
              modHalf: function modHalf(e, t) {
                return Math.abs(e) > t / 2 ? e - Math.round(e / t) * t : e;
              }
            };
          }, {}],
          503: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("./array").isArrayOrTypedArray;
            function o(e, t) {
              return function () {
                var n,
                  r,
                  a,
                  s,
                  l,
                  u = e;
                for (s = 0; s < t.length - 1; s++) {
                  if (-1 === (n = t[s])) {
                    for (r = !0, a = [], l = 0; l < u.length; l++) a[l] = o(u[l], t.slice(s + 1))(), a[l] !== a[0] && (r = !1);
                    return r ? a[0] : a;
                  }
                  if ("number" == typeof n && !i(u)) return;
                  if ("object" != typeof (u = u[n]) || null === u) return;
                }
                if ("object" == typeof u && null !== u && null !== (a = u[t[s]])) return a;
              };
            }
            t.exports = function (e, t) {
              if (r(t)) t = String(t);else if ("string" != typeof t || "[-1]" === t.substr(t.length - 4)) throw "bad property string";
              for (var n, i, a, s = 0, u = t.split("."); s < u.length;) {
                if (n = String(u[s]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/)) {
                  if (n[1]) u[s] = n[1];else {
                    if (0 !== s) throw "bad property string";
                    u.splice(0, 1);
                  }
                  for (i = n[2].substr(1, n[2].length - 2).split("]["), a = 0; a < i.length; a++) s++, u.splice(s, 0, Number(i[a]));
                }
                s++;
              }
              return "object" != typeof e ? function (e, t, n) {
                return {
                  set: function set() {
                    throw "bad container";
                  },
                  get: function get() {},
                  astr: t,
                  parts: n,
                  obj: e
                };
              }(e, t, u) : {
                set: l(e, u, t),
                get: o(e, u),
                astr: t,
                parts: u,
                obj: e
              };
            };
            var a = /(^|\.)args\[/;
            function s(e, t) {
              return void 0 === e || null === e && !t.match(a);
            }
            function l(e, t, n) {
              return function (r) {
                var o,
                  a,
                  l = e,
                  h = "",
                  f = [[e, h]],
                  p = s(r, n);
                for (a = 0; a < t.length - 1; a++) {
                  if ("number" == typeof (o = t[a]) && !i(l)) throw "array index but container is not an array";
                  if (-1 === o) {
                    if (p = !c(l, t.slice(a + 1), r, n)) break;
                    return;
                  }
                  if (!d(l, o, t[a + 1], p)) break;
                  if ("object" != typeof (l = l[o]) || null === l) throw "container is not an object";
                  h = u(h, o), f.push([l, h]);
                }
                if (p) {
                  if (a === t.length - 1 && (delete l[t[a]], Array.isArray(l) && +t[a] == l.length - 1)) for (; l.length && void 0 === l[l.length - 1];) l.pop();
                } else l[t[a]] = r;
              };
            }
            function u(e, t) {
              var n = t;
              return r(t) ? n = "[" + t + "]" : e && (n = "." + t), e + n;
            }
            function c(e, t, n, r) {
              var o,
                a = i(n),
                u = !0,
                c = n,
                h = r.replace("-1", 0),
                f = !a && s(n, h),
                p = t[0];
              for (o = 0; o < e.length; o++) h = r.replace("-1", o), a && (f = s(c = n[o % n.length], h)), f && (u = !1), d(e, o, p, f) && l(e[o], t, r.replace("-1", o))(c);
              return u;
            }
            function d(e, t, n, r) {
              if (void 0 === e[t]) {
                if (r) return !1;
                e[t] = "number" == typeof n ? [] : {};
              }
              return !0;
            }
          }, {
            "./array": 481,
            "fast-isnumeric": 91
          }],
          504: [function (e, t, n) {
            "use strict";

            t.exports = function () {};
          }, {}],
          505: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = [];
            t.exports = function (e, t) {
              if (-1 === o.indexOf(e)) {
                o.push(e);
                var n = 1e3;
                i(t) ? n = t : "long" === t && (n = 3e3);
                var a = r.select("body").selectAll(".plotly-notifier").data([0]);
                a.enter().append("div").classed("plotly-notifier", !0), a.selectAll(".notifier-note").data(o).enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function (e) {
                  var i = r.select(this);
                  i.append("button").classed("notifier-close", !0).html("&times;").on("click", function () {
                    i.transition().call(s);
                  });
                  for (var o = i.append("p"), a = e.split(/<br\s*\/?>/g), l = 0; l < a.length; l++) l && o.append("br"), o.append("span").text(a[l]);
                  "stick" === t ? i.transition().duration(350).style("opacity", 1) : i.transition().duration(700).style("opacity", 1).transition().delay(n).call(s);
                });
              }
              function s(e) {
                e.duration(700).style("opacity", 0).each("end", function (e) {
                  var t = o.indexOf(e);
                  -1 !== t && o.splice(t, 1), r.select(this).remove();
                });
              }
            };
          }, {
            d3: 82,
            "fast-isnumeric": 91
          }],
          506: [function (e, t, n) {
            "use strict";

            var r = e("./setcursor"),
              i = "data-savedcursor";
            t.exports = function (e, t) {
              var n = e.attr(i);
              if (t) {
                if (!n) {
                  for (var o = (e.attr("class") || "").split(" "), a = 0; a < o.length; a++) {
                    var s = o[a];
                    0 === s.indexOf("cursor-") && e.attr(i, s.substr(7)).classed(s, !1);
                  }
                  e.attr(i) || e.attr(i, "!!");
                }
                r(e, t);
              } else n && (e.attr(i, null), "!!" === n ? r(e) : r(e, n));
            };
          }, {
            "./setcursor": 514
          }],
          507: [function (e, t, n) {
            "use strict";

            var r = e("./matrix").dot,
              i = e("../constants/numerical").BADNUM,
              o = t.exports = {};
            o.tester = function (e) {
              var t,
                n = e.slice(),
                r = n[0][0],
                o = r,
                a = n[0][1],
                s = a;
              for (n.push(n[0]), t = 1; t < n.length; t++) r = Math.min(r, n[t][0]), o = Math.max(o, n[t][0]), a = Math.min(a, n[t][1]), s = Math.max(s, n[t][1]);
              var l,
                u = !1;
              5 === n.length && (n[0][0] === n[1][0] ? n[2][0] === n[3][0] && n[0][1] === n[3][1] && n[1][1] === n[2][1] && (u = !0, l = function l(e) {
                return e[0] === n[0][0];
              }) : n[0][1] === n[1][1] && n[2][1] === n[3][1] && n[0][0] === n[3][0] && n[1][0] === n[2][0] && (u = !0, l = function l(e) {
                return e[1] === n[0][1];
              }));
              var c = !0,
                d = n[0];
              for (t = 1; t < n.length; t++) if (d[0] !== n[t][0] || d[1] !== n[t][1]) {
                c = !1;
                break;
              }
              return {
                xmin: r,
                xmax: o,
                ymin: a,
                ymax: s,
                pts: n,
                contains: u ? function (e, t) {
                  var n = e[0],
                    u = e[1];
                  return !(n === i || n < r || n > o || u === i || u < a || u > s || t && l(e));
                } : function (e, t) {
                  var l = e[0],
                    u = e[1];
                  if (l === i || l < r || l > o || u === i || u < a || u > s) return !1;
                  var c,
                    d,
                    h,
                    f,
                    p,
                    m = n.length,
                    g = n[0][0],
                    v = n[0][1],
                    y = 0;
                  for (c = 1; c < m; c++) if (d = g, h = v, g = n[c][0], v = n[c][1], !(l < (f = Math.min(d, g)) || l > Math.max(d, g) || u > Math.max(h, v))) if (u < Math.min(h, v)) l !== f && y++;else {
                    if (u === (p = g === d ? u : h + (l - d) * (v - h) / (g - d))) return 1 !== c || !t;
                    u <= p && l !== f && y++;
                  }
                  return y % 2 == 1;
                },
                isRect: u,
                degenerate: c
              };
            }, o.isSegmentBent = function (e, t, n, i) {
              var o,
                a,
                s,
                l = e[t],
                u = [e[n][0] - l[0], e[n][1] - l[1]],
                c = r(u, u),
                d = Math.sqrt(c),
                h = [-u[1] / d, u[0] / d];
              for (o = t + 1; o < n; o++) if (a = [e[o][0] - l[0], e[o][1] - l[1]], (s = r(a, u)) < 0 || s > c || Math.abs(r(a, h)) > i) return !0;
              return !1;
            }, o.filter = function (e, t) {
              var n = [e[0]],
                r = 0,
                i = 0;
              function a(a) {
                e.push(a);
                var s = n.length,
                  l = r;
                n.splice(i + 1);
                for (var u = l + 1; u < e.length; u++) (u === e.length - 1 || o.isSegmentBent(e, l, u + 1, t)) && (n.push(e[u]), n.length < s - 2 && (r = u, i = n.length - 1), l = u);
              }
              return e.length > 1 && a(e.pop()), {
                addPt: a,
                raw: e,
                filtered: n
              };
            };
          }, {
            "../constants/numerical": 474,
            "./matrix": 501
          }],
          508: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              if (t instanceof RegExp) {
                for (var n = t.toString(), r = 0; r < e.length; r++) if (e[r] instanceof RegExp && e[r].toString() === n) return e;
                e.push(t);
              } else !t && 0 !== t || -1 !== e.indexOf(t) || e.push(t);
              return e;
            };
          }, {}],
          509: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("../plot_api/plot_config").dfltConfig,
              o = {
                add: function add(e, t, n, r, o) {
                  var a, s;
                  e.undoQueue = e.undoQueue || {
                    index: 0,
                    queue: [],
                    sequence: !1
                  }, s = e.undoQueue.index, e.autoplay ? e.undoQueue.inSequence || (e.autoplay = !1) : (!e.undoQueue.sequence || e.undoQueue.beginSequence ? (a = {
                    undo: {
                      calls: [],
                      args: []
                    },
                    redo: {
                      calls: [],
                      args: []
                    }
                  }, e.undoQueue.queue.splice(s, e.undoQueue.queue.length - s, a), e.undoQueue.index += 1) : a = e.undoQueue.queue[s - 1], e.undoQueue.beginSequence = !1, a && (a.undo.calls.unshift(t), a.undo.args.unshift(n), a.redo.calls.push(r), a.redo.args.push(o)), e.undoQueue.queue.length > i.queueLength && (e.undoQueue.queue.shift(), e.undoQueue.index--));
                },
                startSequence: function startSequence(e) {
                  e.undoQueue = e.undoQueue || {
                    index: 0,
                    queue: [],
                    sequence: !1
                  }, e.undoQueue.sequence = !0, e.undoQueue.beginSequence = !0;
                },
                stopSequence: function stopSequence(e) {
                  e.undoQueue = e.undoQueue || {
                    index: 0,
                    queue: [],
                    sequence: !1
                  }, e.undoQueue.sequence = !1, e.undoQueue.beginSequence = !1;
                },
                undo: function undo(e) {
                  var t, n;
                  if (e.framework && e.framework.isPolar) e.framework.undo();else if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index <= 0)) {
                    for (e.undoQueue.index--, t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, n = 0; n < t.undo.calls.length; n++) o.plotDo(e, t.undo.calls[n], t.undo.args[n]);
                    e.undoQueue.inSequence = !1, e.autoplay = !1;
                  }
                },
                redo: function redo(e) {
                  var t, n;
                  if (e.framework && e.framework.isPolar) e.framework.redo();else if (!(void 0 === e.undoQueue || isNaN(e.undoQueue.index) || e.undoQueue.index >= e.undoQueue.queue.length)) {
                    for (t = e.undoQueue.queue[e.undoQueue.index], e.undoQueue.inSequence = !0, n = 0; n < t.redo.calls.length; n++) o.plotDo(e, t.redo.calls[n], t.redo.args[n]);
                    e.undoQueue.inSequence = !1, e.autoplay = !1, e.undoQueue.index++;
                  }
                },
                plotDo: function plotDo(e, t, n) {
                  e.autoplay = !0, n = function (e, t) {
                    for (var n, i = [], o = 0; o < t.length; o++) n = t[o], i[o] = n === e ? n : "object" == typeof n ? Array.isArray(n) ? r.extendDeep([], n) : r.extendDeepAll({}, n) : n;
                    return i;
                  }(e, n), t.apply(null, n);
                }
              };
            t.exports = o;
          }, {
            "../lib": 495,
            "../plot_api/plot_config": 529
          }],
          510: [function (e, t, n) {
            "use strict";

            n.counter = function (e, t, n, r) {
              var i = (t || "") + (n ? "" : "$"),
                o = !1 === r ? "" : "^";
              return "xy" === e ? new RegExp(o + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + i) : new RegExp(o + e + "([2-9]|[1-9][0-9]+)?" + i);
            };
          }, {}],
          511: [function (e, t, n) {
            "use strict";

            var r = /^(.*)(\.[^\.\[\]]+|\[\d\])$/,
              i = /^[^\.\[\]]+$/;
            t.exports = function (e, t) {
              for (; t;) {
                var n = e.match(r);
                if (n) e = n[1];else {
                  if (!e.match(i)) throw new Error("bad relativeAttr call:" + [e, t]);
                  e = "";
                }
                if ("^" !== t.charAt(0)) break;
                t = t.slice(1);
              }
              return e && "[" !== t.charAt(0) ? e + "." + t : e + t;
            };
          }, {}],
          512: [function (e, t, n) {
            "use strict";

            var r = e("./array").isArrayOrTypedArray,
              i = e("./is_plain_object");
            t.exports = function e(t, n) {
              for (var o in n) {
                var a = n[o],
                  s = t[o];
                if (s !== a) if ("_" === o.charAt(0) || "function" == typeof a) {
                  if (o in t) continue;
                  t[o] = a;
                } else if (r(a) && r(s) && i(a[0])) {
                  if ("customdata" === o || "ids" === o) continue;
                  for (var l = Math.min(a.length, s.length), u = 0; u < l; u++) s[u] !== a[u] && i(a[u]) && i(s[u]) && e(s[u], a[u]);
                } else i(a) && i(s) && (e(s, a), Object.keys(s).length || delete t[o]);
              }
            };
          }, {
            "./array": 481,
            "./is_plain_object": 496
          }],
          513: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("./loggers"),
              o = e("./identity");
            function a(e, t) {
              return e < t;
            }
            function s(e, t) {
              return e <= t;
            }
            function l(e, t) {
              return e > t;
            }
            function u(e, t) {
              return e >= t;
            }
            n.findBin = function (e, t, n) {
              if (r(t.start)) return n ? Math.ceil((e - t.start) / t.size - 1e-9) - 1 : Math.floor((e - t.start) / t.size + 1e-9);
              var o,
                c,
                d = 0,
                h = t.length,
                f = 0,
                p = h > 1 ? (t[h - 1] - t[0]) / (h - 1) : 1;
              for (c = p >= 0 ? n ? a : s : n ? u : l, e += 1e-9 * p * (n ? -1 : 1) * (p >= 0 ? 1 : -1); d < h && f++ < 100;) c(t[o = Math.floor((d + h) / 2)], e) ? d = o + 1 : h = o;
              return f > 90 && i.log("Long binary search..."), d - 1;
            }, n.sorterAsc = function (e, t) {
              return e - t;
            }, n.sorterDes = function (e, t) {
              return t - e;
            }, n.distinctVals = function (e) {
              var t = e.slice();
              t.sort(n.sorterAsc);
              for (var r = t.length - 1, i = t[r] - t[0] || 1, o = i / (r || 1) / 1e4, a = [t[0]], s = 0; s < r; s++) t[s + 1] > t[s] + o && (i = Math.min(i, t[s + 1] - t[s]), a.push(t[s + 1]));
              return {
                vals: a,
                minDiff: i
              };
            }, n.roundUp = function (e, t, n) {
              for (var r, i = 0, o = t.length - 1, a = 0, s = n ? 0 : 1, l = n ? 1 : 0, u = n ? Math.ceil : Math.floor; i < o && a++ < 100;) t[r = u((i + o) / 2)] <= e ? i = r + s : o = r - l;
              return t[i];
            }, n.sort = function (e, t) {
              for (var n = 0, r = 0, i = 1; i < e.length; i++) {
                var o = t(e[i], e[i - 1]);
                if (o < 0 ? n = 1 : o > 0 && (r = 1), n && r) return e.sort(t);
              }
              return r ? e : e.reverse();
            }, n.findIndexOfMin = function (e, t) {
              t = t || o;
              for (var n, r = 1 / 0, i = 0; i < e.length; i++) {
                var a = t(e[i]);
                a < r && (r = a, n = i);
              }
              return n;
            };
          }, {
            "./identity": 494,
            "./loggers": 499,
            "fast-isnumeric": 91
          }],
          514: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t) {
              (e.attr("class") || "").split(" ").forEach(function (t) {
                0 === t.indexOf("cursor-") && e.classed(t, !1);
              }), t && e.classed("cursor-" + t, !0);
            };
          }, {}],
          515: [function (e, t, n) {
            "use strict";

            var r = e("../components/color"),
              i = function i() {};
            t.exports = function (e) {
              for (var t in e) "function" == typeof e[t] && (e[t] = i);
              e.destroy = function () {
                e.container.parentNode.removeChild(e.container);
              };
              var n = document.createElement("div");
              n.className = "no-webgl", n.style.cursor = "pointer", n.style.fontSize = "24px", n.style.color = r.defaults[0], n.style.position = "absolute", n.style.left = n.style.top = "0px", n.style.width = n.style.height = "100%", n.style["background-color"] = r.lightLine, n.style["z-index"] = 30;
              var o = document.createElement("p");
              return o.textContent = "WebGL is not supported by your browser - visit https://get.webgl.org for more info", o.style.position = "relative", o.style.top = "50%", o.style.left = "50%", o.style.height = "30%", o.style.width = "50%", o.style.margin = "-15% 0 0 -25%", n.appendChild(o), e.container.appendChild(n), e.container.style.background = "#FFFFFF", e.container.onclick = function () {
                window.open("https://get.webgl.org");
              }, !1;
            };
          }, {
            "../components/color": 375
          }],
          516: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("./array").isArrayOrTypedArray;
            n.aggNums = function (e, t, o, a) {
              var s, l;
              if ((!a || a > o.length) && (a = o.length), r(t) || (t = !1), i(o[0])) {
                for (l = new Array(a), s = 0; s < a; s++) l[s] = n.aggNums(e, t, o[s]);
                o = l;
              }
              for (s = 0; s < a; s++) r(t) ? r(o[s]) && (t = e(+t, +o[s])) : t = o[s];
              return t;
            }, n.len = function (e) {
              return n.aggNums(function (e) {
                return e + 1;
              }, 0, e);
            }, n.mean = function (e, t) {
              return t || (t = n.len(e)), n.aggNums(function (e, t) {
                return e + t;
              }, 0, e) / t;
            }, n.midRange = function (e) {
              if (void 0 !== e && 0 !== e.length) return (n.aggNums(Math.max, null, e) + n.aggNums(Math.min, null, e)) / 2;
            }, n.variance = function (e, t, i) {
              return t || (t = n.len(e)), r(i) || (i = n.mean(e, t)), n.aggNums(function (e, t) {
                return e + Math.pow(t - i, 2);
              }, 0, e) / t;
            }, n.stdev = function (e, t, r) {
              return Math.sqrt(n.variance(e, t, r));
            }, n.median = function (e) {
              var t = e.slice().sort();
              return n.interp(t, .5);
            }, n.interp = function (e, t) {
              if (!r(t)) throw "n should be a finite number";
              if ((t = t * e.length - .5) < 0) return e[0];
              if (t > e.length - 1) return e[e.length - 1];
              var n = t % 1;
              return n * e[Math.ceil(t)] + (1 - n) * e[Math.floor(t)];
            };
          }, {
            "./array": 481,
            "fast-isnumeric": 91
          }],
          517: [function (e, t, n) {
            "use strict";

            var r = e("color-normalize");
            t.exports = function (e) {
              return e ? r(e) : [0, 0, 0, 1];
            };
          }, {
            "color-normalize": 63
          }],
          518: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../lib"),
              o = e("../constants/xmlns_namespaces"),
              a = e("../constants/alignment").LINE_SPACING;
            function s(e, t) {
              return e.node().getBoundingClientRect()[t];
            }
            var l = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
            n.convertToTspans = function (e, t, T) {
              var M = e.text(),
                k = !e.attr("data-notex") && "undefined" != typeof MathJax && M.match(l),
                P = r.select(e.node().parentNode);
              if (!P.empty()) {
                var O = e.attr("class") ? e.attr("class").split(" ")[0] : "text";
                return O += "-math", P.selectAll("svg." + O).remove(), P.selectAll("g." + O + "-group").remove(), e.style("display", null).attr({
                  "data-unformatted": M,
                  "data-math": "N"
                }), k ? (t && t._promises || []).push(new Promise(function (t) {
                  e.style("display", "none");
                  var n = parseInt(e.node().style.fontSize, 10),
                    o = {
                      fontSize: n
                    };
                  !function (e, t, n) {
                    var o, a, s, l;
                    MathJax.Hub.Queue(function () {
                      return a = i.extendDeepAll({}, MathJax.Hub.config), s = MathJax.Hub.processSectionDelay, void 0 !== MathJax.Hub.processSectionDelay && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                        messageStyle: "none",
                        tex2jax: {
                          inlineMath: [["$", "$"], ["\\(", "\\)"]]
                        },
                        displayAlign: "left"
                      });
                    }, function () {
                      if ("SVG" !== (o = MathJax.Hub.config.menuSettings.renderer)) return MathJax.Hub.setRenderer("SVG");
                    }, function () {
                      var n = "math-output-" + i.randstr({}, 64);
                      return l = r.select("body").append("div").attr({
                        id: n
                      }).style({
                        visibility: "hidden",
                        position: "absolute"
                      }).style({
                        "font-size": t.fontSize + "px"
                      }).text(e.replace(u, "\\lt ").replace(c, "\\gt ")), MathJax.Hub.Typeset(l.node());
                    }, function () {
                      var t = r.select("body").select("#MathJax_SVG_glyphs");
                      if (l.select(".MathJax_SVG").empty() || !l.select("svg").node()) i.log("There was an error in the tex syntax.", e), n();else {
                        var a = l.select("svg").node().getBoundingClientRect();
                        n(l.select(".MathJax_SVG"), t, a);
                      }
                      if (l.remove(), "SVG" !== o) return MathJax.Hub.setRenderer(o);
                    }, function () {
                      return void 0 !== s && (MathJax.Hub.processSectionDelay = s), MathJax.Hub.Config(a);
                    });
                  }(k[2], o, function (r, i, o) {
                    P.selectAll("svg." + O).remove(), P.selectAll("g." + O + "-group").remove();
                    var a = r && r.select("svg");
                    if (!a || !a.node()) return R(), void t();
                    var l = P.append("g").classed(O + "-group", !0).attr({
                      "pointer-events": "none",
                      "data-unformatted": M,
                      "data-math": "Y"
                    });
                    l.node().appendChild(a.node()), i && i.node() && a.node().insertBefore(i.node().cloneNode(!0), a.node().firstChild), a.attr({
                      class: O,
                      height: o.height,
                      preserveAspectRatio: "xMinYMin meet"
                    }).style({
                      overflow: "visible",
                      "pointer-events": "none"
                    });
                    var u = e.node().style.fill || "black",
                      c = a.select("g");
                    c.attr({
                      fill: u,
                      stroke: u
                    });
                    var d = s(c, "width"),
                      h = s(c, "height"),
                      f = +e.attr("x") - d * {
                        start: 0,
                        middle: .5,
                        end: 1
                      }[e.attr("text-anchor") || "start"],
                      p = -(n || s(e, "height")) / 4;
                    "y" === O[0] ? (l.attr({
                      transform: "rotate(" + [-90, +e.attr("x"), +e.attr("y")] + ") translate(" + [-d / 2, p - h / 2] + ")"
                    }), a.attr({
                      x: +e.attr("x"),
                      y: +e.attr("y")
                    })) : "l" === O[0] ? a.attr({
                      x: e.attr("x"),
                      y: p - h / 2
                    }) : "a" === O[0] && 0 !== O.indexOf("atitle") ? a.attr({
                      x: 0,
                      y: p
                    }) : a.attr({
                      x: f,
                      y: +e.attr("y") + p - h / 2
                    }), T && T.call(e, l), t(l);
                  });
                })) : R(), e;
              }
              function R() {
                P.empty() || (O = e.attr("class") + "-math", P.select("svg." + O).remove()), e.text("").style("white-space", "pre"), function (e, t) {
                  t = t.replace(g, " ");
                  var n,
                    s = !1,
                    l = [],
                    u = -1;
                  function c() {
                    u++;
                    var t = document.createElementNS(o.svg, "tspan");
                    r.select(t).attr({
                      class: "line",
                      dy: u * a + "em"
                    }), e.appendChild(t), n = t;
                    var i = l;
                    if (l = [{
                      node: t
                    }], i.length > 1) for (var s = 1; s < i.length; s++) T(i[s]);
                  }
                  function T(e) {
                    var t,
                      i = e.type,
                      a = {};
                    if ("a" === i) {
                      t = "a";
                      var s = e.target,
                        u = e.href,
                        c = e.popup;
                      u && (a = {
                        "xlink:xlink:show": "_blank" === s || "_" !== s.charAt(0) ? "new" : "replace",
                        target: s,
                        "xlink:xlink:href": u
                      }, c && (a.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + c + '");return false;'));
                    } else t = "tspan";
                    e.style && (a.style = e.style);
                    var d = document.createElementNS(o.svg, t);
                    if ("sup" === i || "sub" === i) {
                      M(n, p), n.appendChild(d);
                      var m = document.createElementNS(o.svg, "tspan");
                      M(m, p), r.select(m).attr("dy", f[i]), a.dy = h[i], n.appendChild(d), n.appendChild(m);
                    } else n.appendChild(d);
                    r.select(d).attr(a), n = e.node = d, l.push(e);
                  }
                  function M(e, t) {
                    e.appendChild(document.createTextNode(t));
                  }
                  function k(e) {
                    if (1 !== l.length) {
                      var r = l.pop();
                      e !== r.type && i.log("Start tag <" + r.type + "> doesnt match end tag <" + e + ">. Pretending it did match.", t), n = l[l.length - 1].node;
                    } else i.log("Ignoring unexpected end tag </" + e + ">.", t);
                  }
                  b.test(t) ? c() : (n = e, l = [{
                    node: e
                  }]);
                  for (var P = t.split(v), O = 0; O < P.length; O++) {
                    var R = P[O],
                      I = R.match(y),
                      j = I && I[2].toLowerCase(),
                      N = d[j];
                    if ("br" === j) c();else if (void 0 === N) M(n, C(R));else if (I[1]) k(j);else {
                      var L = I[4],
                        D = {
                          type: j
                        },
                        B = A(L, _);
                      if (B ? (B = B.replace(E, "$1 fill:"), N && (B += ";" + N)) : N && (B = N), B && (D.style = B), "a" === j) {
                        s = !0;
                        var F = A(L, x);
                        if (F) {
                          var z = document.createElement("a");
                          z.href = F, -1 !== m.indexOf(z.protocol) && (D.href = encodeURI(decodeURI(F)), D.target = A(L, w) || "_blank", D.popup = A(L, S));
                        }
                      }
                      T(D);
                    }
                  }
                  return s;
                }(e.node(), M) && e.style("pointer-events", "all"), n.positionText(e), T && T.call(e);
              }
            };
            var u = /(<|&lt;|&#60;)/g,
              c = /(>|&gt;|&#62;)/g,
              d = {
                sup: "font-size:70%",
                sub: "font-size:70%",
                b: "font-weight:bold",
                i: "font-style:italic",
                a: "cursor:pointer",
                span: "",
                em: "font-style:italic;font-weight:bold"
              },
              h = {
                sub: "0.3em",
                sup: "-0.6em"
              },
              f = {
                sub: "-0.21em",
                sup: "0.42em"
              },
              p = "​",
              m = ["http:", "https:", "mailto:", "", void 0, ":"],
              g = n.NEWLINES = /(\r\n?|\n)/g,
              v = /(<[^<>]*>)/,
              y = /<(\/?)([^ >]*)(\s+(.*))?>/i,
              b = /<br(\s+.*)?>/i;
            n.BR_TAG_ALL = /<br(\s+.*)?>/gi;
            var _ = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i,
              x = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i,
              w = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i,
              S = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
            function A(e, t) {
              if (!e) return null;
              var n = e.match(t),
                r = n && (n[3] || n[4]);
              return r && C(r);
            }
            var E = /(^|;)\s*color:/;
            n.plainText = function (e, t) {
              for (var n = void 0 !== (t = t || {}).len && -1 !== t.len ? t.len : 1 / 0, r = void 0 !== t.allowedTags ? t.allowedTags : ["br"], i = "...".length, o = e.split(v), a = [], s = "", l = 0, u = 0; u < o.length; u++) {
                var c = o[u],
                  d = c.match(y),
                  h = d && d[2].toLowerCase();
                if (h) -1 !== r.indexOf(h) && (a.push(c), s = h);else {
                  var f = c.length;
                  if (l + f < n) a.push(c), l += f;else if (l < n) {
                    var p = n - l;
                    s && ("br" !== s || p <= i || f <= i) && a.pop(), n > i ? a.push(c.substr(0, p - i) + "...") : a.push(c.substr(0, p));
                    break;
                  }
                  s = "";
                }
              }
              return a.join("");
            };
            var T = {
                mu: "μ",
                amp: "&",
                lt: "<",
                gt: ">",
                nbsp: " ",
                times: "×",
                plusmn: "±",
                deg: "°"
              },
              M = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
            function C(e) {
              return e.replace(M, function (e, t) {
                return ("#" === t.charAt(0) ? function (e) {
                  if (!(e > 1114111)) {
                    var t = String.fromCodePoint;
                    if (t) return t(e);
                    var n = String.fromCharCode;
                    return e <= 65535 ? n(e) : n(55232 + (e >> 10), e % 1024 + 56320);
                  }
                }("x" === t.charAt(1) ? parseInt(t.substr(2), 16) : parseInt(t.substr(1), 10)) : T[t]) || e;
              });
            }
            function k(e, t, n) {
              var r,
                i,
                o,
                a = n.horizontalAlign,
                s = n.verticalAlign || "top",
                l = e.node().getBoundingClientRect(),
                u = t.node().getBoundingClientRect();
              return i = "bottom" === s ? function () {
                return l.bottom - r.height;
              } : "middle" === s ? function () {
                return l.top + (l.height - r.height) / 2;
              } : function () {
                return l.top;
              }, o = "right" === a ? function () {
                return l.right - r.width;
              } : "center" === a ? function () {
                return l.left + (l.width - r.width) / 2;
              } : function () {
                return l.left;
              }, function () {
                return r = this.node().getBoundingClientRect(), this.style({
                  top: i() - u.top + "px",
                  left: o() - u.left + "px",
                  "z-index": 1e3
                }), this;
              };
            }
            n.convertEntities = C, n.lineCount = function (e) {
              return e.selectAll("tspan.line").size() || 1;
            }, n.positionText = function (e, t, n) {
              return e.each(function () {
                var e = r.select(this);
                function i(t, n) {
                  return void 0 === n ? null === (n = e.attr(t)) && (e.attr(t, 0), n = 0) : e.attr(t, n), n;
                }
                var o = i("x", t),
                  a = i("y", n);
                "text" === this.nodeName && e.selectAll("tspan.line").attr({
                  x: o,
                  y: a
                });
              });
            }, n.makeEditable = function (e, t) {
              var n = t.gd,
                i = t.delegate,
                o = r.dispatch("edit", "input", "cancel"),
                a = i || e;
              if (e.style({
                "pointer-events": i ? "none" : "all"
              }), 1 !== e.size()) throw new Error("boo");
              function s() {
                !function () {
                  var i = r.select(n).select(".svg-container"),
                    a = i.append("div"),
                    s = e.node().style,
                    u = parseFloat(s.fontSize || 12),
                    c = t.text;
                  void 0 === c && (c = e.attr("data-unformatted")), a.classed("plugin-editable editable", !0).style({
                    position: "absolute",
                    "font-family": s.fontFamily || "Arial",
                    "font-size": u,
                    color: t.fill || s.fill || "black",
                    opacity: 1,
                    "background-color": t.background || "transparent",
                    outline: "#ffffff33 1px solid",
                    margin: [-u / 8 + 1, 0, 0, -1].join("px ") + "px",
                    padding: "0",
                    "box-sizing": "border-box"
                  }).attr({
                    contenteditable: !0
                  }).text(c).call(k(e, i, t)).on("blur", function () {
                    n._editing = !1, e.text(this.textContent).style({
                      opacity: 1
                    });
                    var t,
                      i = r.select(this).attr("class");
                    (t = i ? "." + i.split(" ")[0] + "-math-group" : "[class*=-math-group]") && r.select(e.node().parentNode).select(t).style({
                      opacity: 0
                    });
                    var a = this.textContent;
                    r.select(this).transition().duration(0).remove(), r.select(document).on("mouseup", null), o.edit.call(e, a);
                  }).on("focus", function () {
                    var e = this;
                    n._editing = !0, r.select(document).on("mouseup", function () {
                      if (r.event.target === e) return !1;
                      document.activeElement === a.node() && a.node().blur();
                    });
                  }).on("keyup", function () {
                    27 === r.event.which ? (n._editing = !1, e.style({
                      opacity: 1
                    }), r.select(this).style({
                      opacity: 0
                    }).on("blur", function () {
                      return !1;
                    }).transition().remove(), o.cancel.call(e, this.textContent)) : (o.input.call(e, this.textContent), r.select(this).call(k(e, i, t)));
                  }).on("keydown", function () {
                    13 === r.event.which && this.blur();
                  }).call(l);
                }(), e.style({
                  opacity: 0
                });
                var i,
                  s = a.attr("class");
                (i = s ? "." + s.split(" ")[0] + "-math-group" : "[class*=-math-group]") && r.select(e.node().parentNode).select(i).style({
                  opacity: 0
                });
              }
              function l(e) {
                var t = e.node(),
                  n = document.createRange();
                n.selectNodeContents(t);
                var r = window.getSelection();
                r.removeAllRanges(), r.addRange(n), t.focus();
              }
              return t.immediate ? s() : a.on("click", s), r.rebind(e, o, "on");
            };
          }, {
            "../constants/alignment": 469,
            "../constants/xmlns_namespaces": 475,
            "../lib": 495,
            d3: 82
          }],
          519: [function (e, t, n) {
            "use strict";

            var r = {};
            function i(e) {
              e && null !== e.timer && (clearTimeout(e.timer), e.timer = null);
            }
            n.throttle = function (e, t, n) {
              var o = r[e],
                a = Date.now();
              if (!o) {
                for (var s in r) r[s].ts < a - 6e4 && delete r[s];
                o = r[e] = {
                  ts: 0,
                  timer: null
                };
              }
              function l() {
                n(), o.ts = Date.now(), o.onDone && (o.onDone(), o.onDone = null);
              }
              i(o), a > o.ts + t ? l() : o.timer = setTimeout(function () {
                l(), o.timer = null;
              }, t);
            }, n.done = function (e) {
              var t = r[e];
              return t && t.timer ? new Promise(function (e) {
                var n = t.onDone;
                t.onDone = function () {
                  n && n(), e(), t.onDone = null;
                };
              }) : Promise.resolve();
            }, n.clear = function (e) {
              if (e) i(r[e]), delete r[e];else for (var t in r) n.clear(t);
            };
          }, {}],
          520: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric");
            t.exports = function (e, t) {
              if (e > 0) return Math.log(e) / Math.LN10;
              var n = Math.log(Math.min(t[0], t[1])) / Math.LN10;
              return r(n) || (n = Math.log(Math.max(t[0], t[1])) / Math.LN10 - 6), n;
            };
          }, {
            "fast-isnumeric": 91
          }],
          521: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "locale",
              name: "en-US",
              dictionary: {
                "Click to enter Colorscale title": "Click to enter Colorscale title"
              },
              format: {
                date: "%m/%d/%Y"
              }
            };
          }, {}],
          522: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "locale",
              name: "en",
              dictionary: {
                "Click to enter Colorscale title": "Click to enter Colourscale title"
              },
              format: {
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                periods: ["AM", "PM"],
                dateTime: "%a %b %e %X %Y",
                date: "%d/%m/%Y",
                time: "%H:%M:%S",
                decimal: ".",
                thousands: ",",
                grouping: [3],
                currency: ["$", ""],
                year: "%Y",
                month: "%b %Y",
                dayMonth: "%b %-d",
                dayMonthYear: "%b %-d, %Y"
              }
            };
          }, {}],
          523: [function (e, t, n) {
            "use strict";

            var r = e("../registry");
            t.exports = function (e) {
              for (var t, n, i = r.layoutArrayContainers, o = r.layoutArrayRegexes, a = e.split("[")[0], s = 0; s < o.length; s++) if ((n = e.match(o[s])) && 0 === n.index) {
                t = n[0];
                break;
              }
              if (t || (t = i[i.indexOf(a)]), !t) return !1;
              var l = e.substr(t.length);
              return l ? !!(n = l.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/)) && {
                array: t,
                index: Number(n[1]),
                property: n[3] || ""
              } : {
                array: t,
                index: "",
                property: ""
              };
            };
          }, {
            "../registry": 593
          }],
          524: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = r.extendFlat,
              o = r.isPlainObject,
              a = {
                valType: "flaglist",
                extras: ["none"],
                flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"]
              },
              s = {
                valType: "flaglist",
                extras: ["none"],
                flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"]
              },
              l = a.flags.slice().concat(["fullReplot"]),
              u = s.flags.slice().concat("layoutReplot");
            function c(e) {
              for (var t = {}, n = 0; n < e.length; n++) t[e[n]] = !1;
              return t;
            }
            function d(e, t, n) {
              var r = i({}, e);
              for (var a in r) {
                var s = r[a];
                o(s) && (r[a] = h(s, t, 0, a));
              }
              return "from-root" === n && (r.editType = t), r;
            }
            function h(e, t, n, r) {
              if (e.valType) {
                var o = i({}, e);
                if (o.editType = t, Array.isArray(e.items)) {
                  o.items = new Array(e.items.length);
                  for (var a = 0; a < e.items.length; a++) o.items[a] = h(e.items[a], t);
                }
                return o;
              }
              return d(e, t, "_" === r.charAt(0) ? "nested" : "from-root");
            }
            t.exports = {
              traces: a,
              layout: s,
              traceFlags: function traceFlags() {
                return c(l);
              },
              layoutFlags: function layoutFlags() {
                return c(u);
              },
              update: function update(e, t) {
                var n = t.editType;
                if (n && "none" !== n) for (var r = n.split("+"), i = 0; i < r.length; i++) e[r[i]] = !0;
              },
              overrideAll: d
            };
          }, {
            "../lib": 495
          }],
          525: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("gl-mat4/fromQuat"),
              o = e("../registry"),
              a = e("../lib"),
              s = e("../plots/plots"),
              l = e("../plots/cartesian/axis_ids"),
              u = e("../components/color"),
              c = l.cleanId,
              d = l.getFromTrace,
              h = o.traceIs;
            function f(e, t) {
              var n = e[t],
                r = t.charAt(0);
              n && "paper" !== n && (e[t] = c(n, r));
            }
            function p(e) {
              function t(t, n) {
                var r = e[t],
                  i = e.title && e.title[n];
                r && !i && (e.title || (e.title = {}), e.title[n] = e[t], delete e[t]);
              }
              e && ("string" != typeof e.title && "number" != typeof e.title || (e.title = {
                text: e.title
              }), t("titlefont", "font"), t("titleposition", "position"), t("titleside", "side"), t("titleoffset", "offset"));
            }
            function m(e) {
              if (!a.isPlainObject(e)) return !1;
              var t = e.name;
              return delete e.name, delete e.showlegend, ("string" == typeof t || "number" == typeof t) && String(t);
            }
            function g(e, t, n, r) {
              if (n && !r) return e;
              if (r && !n) return t;
              if (!e.trim()) return t;
              if (!t.trim()) return e;
              var i,
                o = Math.min(e.length, t.length);
              for (i = 0; i < o && e.charAt(i) === t.charAt(i); i++);
              return e.substr(0, i).trim();
            }
            function v(e) {
              var t = "middle",
                n = "center";
              return "string" == typeof e && (-1 !== e.indexOf("top") ? t = "top" : -1 !== e.indexOf("bottom") && (t = "bottom"), -1 !== e.indexOf("left") ? n = "left" : -1 !== e.indexOf("right") && (n = "right")), t + " " + n;
            }
            function y(e, t) {
              return t in e && "object" == typeof e[t] && 0 === Object.keys(e[t]).length;
            }
            n.clearPromiseQueue = function (e) {
              Array.isArray(e._promises) && e._promises.length > 0 && a.log("Clearing previous rejected promises from queue."), e._promises = [];
            }, n.cleanLayout = function (e) {
              var t, r;
              e || (e = {}), e.xaxis1 && (e.xaxis || (e.xaxis = e.xaxis1), delete e.xaxis1), e.yaxis1 && (e.yaxis || (e.yaxis = e.yaxis1), delete e.yaxis1), e.scene1 && (e.scene || (e.scene = e.scene1), delete e.scene1);
              var o = (s.subplotsRegistry.cartesian || {}).attrRegex,
                l = (s.subplotsRegistry.polar || {}).attrRegex,
                d = (s.subplotsRegistry.ternary || {}).attrRegex,
                h = (s.subplotsRegistry.gl3d || {}).attrRegex,
                m = Object.keys(e);
              for (t = 0; t < m.length; t++) {
                var g = m[t];
                if (o && o.test(g)) {
                  var v = e[g];
                  v.anchor && "free" !== v.anchor && (v.anchor = c(v.anchor)), v.overlaying && (v.overlaying = c(v.overlaying)), v.type || (v.isdate ? v.type = "date" : v.islog ? v.type = "log" : !1 === v.isdate && !1 === v.islog && (v.type = "linear")), "withzero" !== v.autorange && "tozero" !== v.autorange || (v.autorange = !0, v.rangemode = "tozero"), delete v.islog, delete v.isdate, delete v.categories, y(v, "domain") && delete v.domain, void 0 !== v.autotick && (void 0 === v.tickmode && (v.tickmode = v.autotick ? "auto" : "linear"), delete v.autotick), p(v);
                } else if (l && l.test(g)) p(e[g].radialaxis);else if (d && d.test(g)) {
                  var b = e[g];
                  p(b.aaxis), p(b.baxis), p(b.caxis);
                } else if (h && h.test(g)) {
                  var _ = e[g],
                    x = _.cameraposition;
                  if (Array.isArray(x) && 4 === x[0].length) {
                    var w = x[0],
                      S = x[1],
                      A = x[2],
                      E = i([], w),
                      T = [];
                    for (r = 0; r < 3; ++r) T[r] = S[r] + A * E[2 + 4 * r];
                    _.camera = {
                      eye: {
                        x: T[0],
                        y: T[1],
                        z: T[2]
                      },
                      center: {
                        x: S[0],
                        y: S[1],
                        z: S[2]
                      },
                      up: {
                        x: 0,
                        y: 0,
                        z: 1
                      }
                    }, delete _.cameraposition;
                  }
                  p(_.xaxis), p(_.yaxis), p(_.zaxis);
                }
              }
              var M = Array.isArray(e.annotations) ? e.annotations.length : 0;
              for (t = 0; t < M; t++) {
                var C = e.annotations[t];
                a.isPlainObject(C) && (C.ref && ("paper" === C.ref ? (C.xref = "paper", C.yref = "paper") : "data" === C.ref && (C.xref = "x", C.yref = "y"), delete C.ref), f(C, "xref"), f(C, "yref"));
              }
              var k = Array.isArray(e.shapes) ? e.shapes.length : 0;
              for (t = 0; t < k; t++) {
                var P = e.shapes[t];
                a.isPlainObject(P) && (f(P, "xref"), f(P, "yref"));
              }
              var O = e.legend;
              return O && (O.x > 3 ? (O.x = 1.02, O.xanchor = "left") : O.x < -2 && (O.x = -.02, O.xanchor = "right"), O.y > 3 ? (O.y = 1.02, O.yanchor = "bottom") : O.y < -2 && (O.y = -.02, O.yanchor = "top")), p(e), "rotate" === e.dragmode && (e.dragmode = "orbit"), u.clean(e), e.template && e.template.layout && n.cleanLayout(e.template.layout), e;
            }, n.cleanData = function (e) {
              for (var t = 0; t < e.length; t++) {
                var r,
                  i = e[t];
                if ("histogramy" === i.type && "xbins" in i && !("ybins" in i) && (i.ybins = i.xbins, delete i.xbins), i.error_y && "opacity" in i.error_y) {
                  var l = u.defaults,
                    d = i.error_y.color || (h(i, "bar") ? u.defaultLine : l[t % l.length]);
                  i.error_y.color = u.addOpacity(u.rgb(d), u.opacity(d) * i.error_y.opacity), delete i.error_y.opacity;
                }
                if ("bardir" in i && ("h" !== i.bardir || !h(i, "bar") && "histogram" !== i.type.substr(0, 9) || (i.orientation = "h", n.swapXYData(i)), delete i.bardir), "histogramy" === i.type && n.swapXYData(i), "histogramx" !== i.type && "histogramy" !== i.type || (i.type = "histogram"), "scl" in i && !("colorscale" in i) && (i.colorscale = i.scl, delete i.scl), "reversescl" in i && !("reversescale" in i) && (i.reversescale = i.reversescl, delete i.reversescl), i.xaxis && (i.xaxis = c(i.xaxis, "x")), i.yaxis && (i.yaxis = c(i.yaxis, "y")), h(i, "gl3d") && i.scene && (i.scene = s.subplotsRegistry.gl3d.cleanId(i.scene)), !h(i, "pie-like") && !h(i, "bar-like")) if (Array.isArray(i.textposition)) for (r = 0; r < i.textposition.length; r++) i.textposition[r] = v(i.textposition[r]);else i.textposition && (i.textposition = v(i.textposition));
                var f = o.getModule(i);
                if (f && f.colorbar) {
                  var b = f.colorbar.container,
                    _ = b ? i[b] : i;
                  _ && _.colorscale && ("YIGnBu" === _.colorscale && (_.colorscale = "YlGnBu"), "YIOrRd" === _.colorscale && (_.colorscale = "YlOrRd"));
                }
                if ("surface" === i.type && a.isPlainObject(i.contours)) {
                  var x = ["x", "y", "z"];
                  for (r = 0; r < x.length; r++) {
                    var w = i.contours[x[r]];
                    a.isPlainObject(w) && (w.highlightColor && (w.highlightcolor = w.highlightColor, delete w.highlightColor), w.highlightWidth && (w.highlightwidth = w.highlightWidth, delete w.highlightWidth));
                  }
                }
                if ("candlestick" === i.type || "ohlc" === i.type) {
                  var S = !1 !== (i.increasing || {}).showlegend,
                    A = !1 !== (i.decreasing || {}).showlegend,
                    E = m(i.increasing),
                    T = m(i.decreasing);
                  if (!1 !== E && !1 !== T) {
                    var M = g(E, T, S, A);
                    M && (i.name = M);
                  } else !E && !T || i.name || (i.name = E || T);
                }
                if (Array.isArray(i.transforms)) {
                  var C = i.transforms;
                  for (r = 0; r < C.length; r++) {
                    var k = C[r];
                    if (a.isPlainObject(k)) switch (k.type) {
                      case "filter":
                        k.filtersrc && (k.target = k.filtersrc, delete k.filtersrc), k.calendar && (k.valuecalendar || (k.valuecalendar = k.calendar), delete k.calendar);
                        break;
                      case "groupby":
                        if (k.styles = k.styles || k.style, k.styles && !Array.isArray(k.styles)) {
                          var P = k.styles,
                            O = Object.keys(P);
                          k.styles = [];
                          for (var R = 0; R < O.length; R++) k.styles.push({
                            target: O[R],
                            value: P[O[R]]
                          });
                        }
                    }
                  }
                }
                y(i, "line") && delete i.line, "marker" in i && (y(i.marker, "line") && delete i.marker.line, y(i, "marker") && delete i.marker), u.clean(i), i.autobinx && (delete i.autobinx, delete i.xbins), i.autobiny && (delete i.autobiny, delete i.ybins), p(i), i.colorbar && p(i.colorbar), i.marker && i.marker.colorbar && p(i.marker.colorbar), i.line && i.line.colorbar && p(i.line.colorbar), i.aaxis && p(i.aaxis), i.baxis && p(i.baxis);
              }
            }, n.swapXYData = function (e) {
              var t;
              if (a.swapAttrs(e, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]), Array.isArray(e.z) && Array.isArray(e.z[0]) && (e.transpose ? delete e.transpose : e.transpose = !0), e.error_x && e.error_y) {
                var n = e.error_y,
                  r = "copy_ystyle" in n ? n.copy_ystyle : !(n.color || n.thickness || n.width);
                a.swapAttrs(e, ["error_?.copy_ystyle"]), r && a.swapAttrs(e, ["error_?.color", "error_?.thickness", "error_?.width"]);
              }
              if ("string" == typeof e.hoverinfo) {
                var i = e.hoverinfo.split("+");
                for (t = 0; t < i.length; t++) "x" === i[t] ? i[t] = "y" : "y" === i[t] && (i[t] = "x");
                e.hoverinfo = i.join("+");
              }
            }, n.coerceTraceIndices = function (e, t) {
              if (r(t)) return [t];
              if (!Array.isArray(t) || !t.length) return e.data.map(function (e, t) {
                return t;
              });
              if (Array.isArray(t)) {
                for (var n = [], i = 0; i < t.length; i++) a.isIndex(t[i], e.data.length) ? n.push(t[i]) : a.warn("trace index (", t[i], ") is not a number or is out of bounds");
                return n;
              }
              return t;
            }, n.manageArrayContainers = function (e, t, n) {
              var i = e.obj,
                o = e.parts,
                s = o.length,
                l = o[s - 1],
                u = r(l);
              if (u && null === t) {
                var c = o.slice(0, s - 1).join(".");
                a.nestedProperty(i, c).get().splice(l, 1);
              } else u && void 0 === e.get() ? (void 0 === e.get() && (n[e.astr] = null), e.set(t)) : e.set(t);
            };
            var b = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
            function _(e) {
              var t = e.search(b);
              if (t > 0) return e.substr(0, t);
            }
            n.hasParent = function (e, t) {
              for (var n = _(t); n;) {
                if (n in e) return !0;
                n = _(n);
              }
              return !1;
            };
            var x = ["x", "y", "z"];
            n.clearAxisTypes = function (e, t, n) {
              for (var r = 0; r < t.length; r++) for (var i = e._fullData[r], o = 0; o < 3; o++) {
                var s = d(e, i, x[o]);
                if (s && "log" !== s.type) {
                  var l = s._name,
                    u = s._id.substr(1);
                  if ("scene" === u.substr(0, 5)) {
                    if (void 0 !== n[u]) continue;
                    l = u + "." + l;
                  }
                  var c = l + ".type";
                  void 0 === n[l] && void 0 === n[c] && a.nestedProperty(e.layout, c).set(null);
                }
              }
            };
          }, {
            "../components/color": 375,
            "../lib": 495,
            "../plots/cartesian/axis_ids": 544,
            "../plots/plots": 584,
            "../registry": 593,
            "fast-isnumeric": 91,
            "gl-mat4/fromQuat": 122
          }],
          526: [function (e, t, n) {
            "use strict";

            var r = e("./plot_api");
            n.plot = r.plot, n.newPlot = r.newPlot, n.restyle = r.restyle, n.relayout = r.relayout, n.redraw = r.redraw, n.update = r.update, n._guiRestyle = r._guiRestyle, n._guiRelayout = r._guiRelayout, n._guiUpdate = r._guiUpdate, n._storeDirectGUIEdit = r._storeDirectGUIEdit, n.react = r.react, n.extendTraces = r.extendTraces, n.prependTraces = r.prependTraces, n.addTraces = r.addTraces, n.deleteTraces = r.deleteTraces, n.moveTraces = r.moveTraces, n.purge = r.purge, n.addFrames = r.addFrames, n.deleteFrames = r.deleteFrames, n.animate = r.animate, n.setPlotConfig = r.setPlotConfig, n.toImage = e("./to_image"), n.validate = e("./validate"), n.downloadImage = e("../snapshot/download");
            var i = e("./template_api");
            n.makeTemplate = i.makeTemplate, n.validateTemplate = i.validateTemplate;
          }, {
            "../snapshot/download": 595,
            "./plot_api": 528,
            "./template_api": 533,
            "./to_image": 534,
            "./validate": 535
          }],
          527: [function (e, t, n) {
            "use strict";

            var r = e("../lib/is_plain_object"),
              i = e("../lib/noop"),
              o = e("../lib/loggers"),
              a = e("../lib/search").sorterAsc,
              s = e("../registry");
            n.containerArrayMatch = e("./container_array_match");
            var l = n.isAddVal = function (e) {
                return "add" === e || r(e);
              },
              u = n.isRemoveVal = function (e) {
                return null === e || "remove" === e;
              };
            n.applyContainerArrayChanges = function (e, t, n, r, c) {
              var d = t.astr,
                h = s.getComponentMethod(d, "supplyLayoutDefaults"),
                f = s.getComponentMethod(d, "draw"),
                p = s.getComponentMethod(d, "drawOne"),
                m = r.replot || r.recalc || h === i || f === i,
                g = e.layout,
                v = e._fullLayout;
              if (n[""]) {
                Object.keys(n).length > 1 && o.warn("Full array edits are incompatible with other edits", d);
                var y = n[""][""];
                if (u(y)) t.set(null);else {
                  if (!Array.isArray(y)) return o.warn("Unrecognized full array edit value", d, y), !0;
                  t.set(y);
                }
                return !m && (h(g, v), f(e), !0);
              }
              var b,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M = Object.keys(n).map(Number).sort(a),
                C = t.get(),
                k = C || [],
                P = c(v, d).get(),
                O = [],
                R = -1,
                I = k.length;
              for (b = 0; b < M.length; b++) if (w = n[x = M[b]], S = Object.keys(w), A = w[""], E = l(A), x < 0 || x > k.length - (E ? 0 : 1)) o.warn("index out of range", d, x);else if (void 0 !== A) S.length > 1 && o.warn("Insertion & removal are incompatible with edits to the same index.", d, x), u(A) ? O.push(x) : E ? ("add" === A && (A = {}), k.splice(x, 0, A), P && P.splice(x, 0, {})) : o.warn("Unrecognized full object edit value", d, x, A), -1 === R && (R = x);else for (_ = 0; _ < S.length; _++) T = d + "[" + x + "].", c(k[x], S[_], T).set(w[S[_]]);
              for (b = O.length - 1; b >= 0; b--) k.splice(O[b], 1), P && P.splice(O[b], 1);
              if (k.length ? C || t.set(k) : t.set(null), m) return !1;
              if (h(g, v), p !== i) {
                var j;
                if (-1 === R) j = M;else {
                  for (I = Math.max(k.length, I), j = [], b = 0; b < M.length && !((x = M[b]) >= R); b++) j.push(x);
                  for (b = R; b < I; b++) j.push(b);
                }
                for (b = 0; b < j.length; b++) p(e, j[b]);
              } else f(e);
              return !0;
            };
          }, {
            "../lib/is_plain_object": 496,
            "../lib/loggers": 499,
            "../lib/noop": 504,
            "../lib/search": 513,
            "../registry": 593,
            "./container_array_match": 523
          }],
          528: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("has-hover"),
              a = e("../lib"),
              s = a.nestedProperty,
              l = e("../lib/events"),
              u = e("../lib/queue"),
              c = e("../registry"),
              d = e("./plot_schema"),
              h = e("../plots/plots"),
              f = e("../plots/polar/legacy"),
              p = e("../plots/cartesian/axes"),
              m = e("../components/drawing"),
              g = e("../components/color"),
              v = e("../plots/cartesian/graph_interact").initInteractions,
              y = e("../constants/xmlns_namespaces"),
              b = e("../lib/svg_text_utils"),
              _ = e("../plots/cartesian/select").clearSelect,
              x = e("./plot_config").dfltConfig,
              w = e("./manage_arrays"),
              S = e("./helpers"),
              A = e("./subroutines"),
              E = e("./edit_types"),
              T = e("../plots/cartesian/constants").AX_NAME_PATTERN,
              M = 0;
            function C(e) {
              var t = e._fullLayout;
              t._redrawFromAutoMarginCount ? t._redrawFromAutoMarginCount-- : e.emit("plotly_afterplot");
            }
            function k(e, t) {
              try {
                e._fullLayout._paper.style("background", t);
              } catch (e) {
                a.error(e);
              }
            }
            function P(e, t) {
              k(e, g.combine(t, "white"));
            }
            function O(e, t) {
              if (!e._context) {
                e._context = a.extendDeep({}, x);
                var n = r.select("base");
                e._context._baseUrl = n.size() && n.attr("href") ? window.location.href.split("#")[0] : "";
              }
              var i,
                s,
                l,
                u = e._context;
              if (t) {
                for (s = Object.keys(t), i = 0; i < s.length; i++) "editable" !== (l = s[i]) && "edits" !== l && l in u && ("setBackground" === l && "opaque" === t[l] ? u[l] = P : u[l] = t[l]);
                t.plot3dPixelRatio && !u.plotGlPixelRatio && (u.plotGlPixelRatio = u.plot3dPixelRatio);
                var c = t.editable;
                if (void 0 !== c) for (u.editable = c, s = Object.keys(u.edits), i = 0; i < s.length; i++) u.edits[s[i]] = c;
                if (t.edits) for (s = Object.keys(t.edits), i = 0; i < s.length; i++) (l = s[i]) in u.edits && (u.edits[l] = t.edits[l]);
                u._exportedPlot = t._exportedPlot;
              }
              u.staticPlot && (u.editable = !1, u.edits = {}, u.autosizable = !1, u.scrollZoom = !1, u.doubleClick = !1, u.showTips = !1, u.showLink = !1, u.displayModeBar = !1), "hover" !== u.displayModeBar || o || (u.displayModeBar = !0), "transparent" !== u.setBackground && "function" == typeof u.setBackground || (u.setBackground = k), u._hasZeroHeight = u._hasZeroHeight || 0 === e.clientHeight, u._hasZeroWidth = u._hasZeroWidth || 0 === e.clientWidth;
              var d = u.scrollZoom,
                h = u._scrollZoom = {};
              if (!0 === d) h.cartesian = 1, h.gl3d = 1, h.geo = 1, h.mapbox = 1;else if ("string" == typeof d) {
                var f = d.split("+");
                for (i = 0; i < f.length; i++) h[f[i]] = 1;
              } else !1 !== d && (h.gl3d = 1, h.geo = 1, h.mapbox = 1);
            }
            function R(e, t) {
              var n,
                r,
                i = t + 1,
                o = [];
              for (n = 0; n < e.length; n++) (r = e[n]) < 0 ? o.push(i + r) : o.push(r);
              return o;
            }
            function I(e, t, n) {
              var r, i;
              for (r = 0; r < t.length; r++) {
                if ((i = t[r]) !== parseInt(i, 10)) throw new Error("all values in " + n + " must be integers");
                if (i >= e.data.length || i < -e.data.length) throw new Error(n + " must be valid indices for gd.data.");
                if (t.indexOf(i, r + 1) > -1 || i >= 0 && t.indexOf(-e.data.length + i) > -1 || i < 0 && t.indexOf(e.data.length + i) > -1) throw new Error("each index in " + n + " must be unique.");
              }
            }
            function j(e, t, n) {
              if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
              if (void 0 === t) throw new Error("currentIndices is a required argument.");
              if (Array.isArray(t) || (t = [t]), I(e, t, "currentIndices"), void 0 === n || Array.isArray(n) || (n = [n]), void 0 !== n && I(e, n, "newIndices"), void 0 !== n && t.length !== n.length) throw new Error("current and new indices must be of equal length.");
            }
            function N(e, t, n, r, o) {
              !function (e, t, n, r) {
                var i = a.isPlainObject(r);
                if (!Array.isArray(e.data)) throw new Error("gd.data must be an array");
                if (!a.isPlainObject(t)) throw new Error("update must be a key:value object");
                if (void 0 === n) throw new Error("indices must be an integer or array of integers");
                for (var o in I(e, n, "indices"), t) {
                  if (!Array.isArray(t[o]) || t[o].length !== n.length) throw new Error("attribute " + o + " must be an array of length equal to indices array length");
                  if (i && (!(o in r) || !Array.isArray(r[o]) || r[o].length !== t[o].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
                }
              }(e, t, n, r);
              for (var l = function (e, t, n, r) {
                  var o,
                    l,
                    u,
                    c,
                    d,
                    h = a.isPlainObject(r),
                    f = [];
                  for (var p in Array.isArray(n) || (n = [n]), n = R(n, e.data.length - 1), t) for (var m = 0; m < n.length; m++) {
                    if (o = e.data[n[m]], l = (u = s(o, p)).get(), c = t[p][m], !a.isArrayOrTypedArray(c)) throw new Error("attribute: " + p + " index: " + m + " must be an array");
                    if (!a.isArrayOrTypedArray(l)) throw new Error("cannot extend missing or non-array attribute: " + p);
                    if (l.constructor !== c.constructor) throw new Error("cannot extend array with an array of a different type: " + p);
                    d = h ? r[p][m] : r, i(d) || (d = -1), f.push({
                      prop: u,
                      target: l,
                      insert: c,
                      maxp: Math.floor(d)
                    });
                  }
                  return f;
                }(e, t, n, r), u = {}, c = {}, d = 0; d < l.length; d++) {
                var h = l[d].prop,
                  f = l[d].maxp,
                  p = o(l[d].target, l[d].insert, f);
                h.set(p[0]), Array.isArray(u[h.astr]) || (u[h.astr] = []), u[h.astr].push(p[1]), Array.isArray(c[h.astr]) || (c[h.astr] = []), c[h.astr].push(l[d].target.length);
              }
              return {
                update: u,
                maxPoints: c
              };
            }
            function L(e, t) {
              var n = new e.constructor(e.length + t.length);
              return n.set(e), n.set(t, e.length), n;
            }
            function D(e, t, r, i) {
              e = a.getGraphDiv(e), S.clearPromiseQueue(e);
              var o = {};
              if ("string" == typeof t) o[t] = r;else {
                if (!a.isPlainObject(t)) return a.warn("Restyle fail.", t, r, i), Promise.reject();
                o = a.extendFlat({}, t), void 0 === i && (i = r);
              }
              Object.keys(o).length && (e.changed = !0);
              var s = S.coerceTraceIndices(e, i),
                l = U(e, o, s),
                c = l.flags;
              c.calc && (e.calcdata = void 0), c.clearAxisTypes && S.clearAxisTypes(e, s, {});
              var d = [];
              c.fullReplot ? d.push(n.plot) : (d.push(h.previousPromises), h.supplyDefaults(e), c.markerSize && (h.doCalcdata(e), q(d)), c.style && d.push(A.doTraceStyle), c.colorbars && d.push(A.doColorBars), d.push(C)), d.push(h.rehover, h.redrag), u.add(e, D, [e, l.undoit, l.traces], D, [e, l.redoit, l.traces]);
              var f = a.syncOrAsync(d, e);
              return f && f.then || (f = Promise.resolve()), f.then(function () {
                return e.emit("plotly_restyle", l.eventData), e;
              });
            }
            function B(e) {
              return void 0 === e ? null : e;
            }
            function F(e, t) {
              return t ? function (t, n, r) {
                var i = s(t, n),
                  o = i.set;
                return i.set = function (t) {
                  z((r || "") + n, i.get(), t, e), o(t);
                }, i;
              } : s;
            }
            function z(e, t, n, r) {
              if (Array.isArray(t) || Array.isArray(n)) for (var i = Array.isArray(t) ? t : [], o = Array.isArray(n) ? n : [], s = Math.max(i.length, o.length), l = 0; l < s; l++) z(e + "[" + l + "]", i[l], o[l], r);else if (a.isPlainObject(t) || a.isPlainObject(n)) {
                var u = a.isPlainObject(t) ? t : {},
                  c = a.isPlainObject(n) ? n : {},
                  d = a.extendFlat({}, u, c);
                for (var h in d) z(e + "." + h, u[h], c[h], r);
              } else void 0 === r[e] && (r[e] = B(t));
            }
            function U(e, t, n) {
              var r,
                i = e._fullLayout,
                o = e._fullData,
                l = e.data,
                u = i._guiEditing,
                f = F(i._preGUI, u),
                m = a.extendDeepAll({}, t);
              G(t);
              var g,
                v = E.traceFlags(),
                y = {},
                b = {};
              function _() {
                return n.map(function () {});
              }
              function x(e) {
                var t = p.id2name(e);
                -1 === g.indexOf(t) && g.push(t);
              }
              function w(e) {
                return "LAYOUT" + e + ".autorange";
              }
              function A(e) {
                return "LAYOUT" + e + ".range";
              }
              function T(e) {
                for (var t = e; t < o.length; t++) if (o[t]._input === l[e]) return o[t];
              }
              function M(r, o, a) {
                if (Array.isArray(r)) r.forEach(function (e) {
                  M(e, o, a);
                });else if (!(r in t) && !S.hasParent(t, r)) {
                  var s;
                  if ("LAYOUT" === r.substr(0, 6)) s = f(e.layout, r.replace("LAYOUT", ""));else {
                    var c = n[a];
                    s = F(i._tracePreGUI[T(c)._fullInput.uid], u)(l[c], r);
                  }
                  r in b || (b[r] = _()), void 0 === b[r][a] && (b[r][a] = B(s.get())), void 0 !== o && s.set(o);
                }
              }
              function C(e) {
                return function (t) {
                  return o[t][e];
                };
              }
              function k(e) {
                return function (t, r) {
                  return !1 === t ? o[n[r]][e] : null;
                };
              }
              for (var P in t) {
                if (S.hasParent(t, P)) throw new Error("cannot set " + P + " and a parent attribute simultaneously");
                var O,
                  R,
                  I,
                  j,
                  N,
                  L,
                  D = t[P];
                if ("autobinx" !== P && "autobiny" !== P || (P = P.charAt(P.length - 1) + "bins", D = Array.isArray(D) ? D.map(k(P)) : !1 === D ? n.map(C(P)) : null), y[P] = D, "LAYOUT" !== P.substr(0, 6)) {
                  for (b[P] = _(), r = 0; r < n.length; r++) if (O = l[n[r]], R = T(n[r]), j = (I = F(i._tracePreGUI[R._fullInput.uid], u)(O, P)).get(), void 0 !== (N = Array.isArray(D) ? D[r % D.length] : D)) {
                    var z = I.parts[I.parts.length - 1],
                      U = P.substr(0, P.length - z.length - 1),
                      V = U ? U + "." : "",
                      H = U ? s(R, U).get() : R;
                    if ((L = d.getTraceValObject(R, I.parts)) && L.impliedEdits && null !== N) for (var q in L.impliedEdits) M(a.relativeAttr(P, q), L.impliedEdits[q], r);else if ("thicknessmode" !== z && "lenmode" !== z || j === N || "fraction" !== N && "pixels" !== N || !H) {
                      if ("type" === P && ("pie" === N != ("pie" === j) || "funnelarea" === N != ("funnelarea" === j))) {
                        var W = "x",
                          $ = "y";
                        "bar" !== N && "bar" !== j || "h" !== O.orientation || (W = "y", $ = "x"), a.swapAttrs(O, ["?", "?src"], "labels", W), a.swapAttrs(O, ["d?", "?0"], "label", W), a.swapAttrs(O, ["?", "?src"], "values", $), "pie" === j || "funnelarea" === j ? (s(O, "marker.color").set(s(O, "marker.colors").get()), i._pielayer.selectAll("g.trace").remove()) : c.traceIs(O, "cartesian") && s(O, "marker.colors").set(s(O, "marker.color").get());
                      }
                    } else {
                      var X = i._size,
                        Y = H.orient,
                        K = "top" === Y || "bottom" === Y;
                      if ("thicknessmode" === z) {
                        var Z = K ? X.h : X.w;
                        M(V + "thickness", H.thickness * ("fraction" === N ? 1 / Z : Z), r);
                      } else {
                        var Q = K ? X.w : X.h;
                        M(V + "len", H.len * ("fraction" === N ? 1 / Q : Q), r);
                      }
                    }
                    if (b[P][r] = B(j), -1 !== ["swapxy", "swapxyaxes", "orientation", "orientationaxes"].indexOf(P)) {
                      if ("orientation" === P) {
                        I.set(N);
                        var J = O.x && !O.y ? "h" : "v";
                        if ((I.get() || J) === R.orientation) continue;
                      } else "orientationaxes" === P && (O.orientation = {
                        v: "h",
                        h: "v"
                      }[R.orientation]);
                      S.swapXYData(O), v.calc = v.clearAxisTypes = !0;
                    } else -1 !== h.dataArrayContainers.indexOf(I.parts[0]) ? (S.manageArrayContainers(I, N, b), v.calc = !0) : (L ? L.arrayOk && !c.traceIs(R, "regl") && (a.isArrayOrTypedArray(N) || a.isArrayOrTypedArray(j)) ? v.calc = !0 : E.update(v, L) : v.calc = !0, I.set(N));
                  }
                  if (-1 !== ["swapxyaxes", "orientationaxes"].indexOf(P) && p.swap(e, n), "orientationaxes" === P) {
                    var ee = s(e.layout, "hovermode");
                    "x" === ee.get() ? ee.set("y") : "y" === ee.get() && ee.set("x");
                  }
                  if (-1 !== ["orientation", "type"].indexOf(P)) {
                    for (g = [], r = 0; r < n.length; r++) {
                      var te = l[n[r]];
                      c.traceIs(te, "cartesian") && (x(te.xaxis || "x"), x(te.yaxis || "y"));
                    }
                    M(g.map(w), !0, 0), M(g.map(A), [0, 1], 0);
                  }
                } else I = f(e.layout, P.replace("LAYOUT", "")), b[P] = [B(I.get())], I.set(Array.isArray(D) ? D[0] : D), v.calc = !0;
              }
              return (v.calc || v.plot) && (v.fullReplot = !0), {
                flags: v,
                undoit: b,
                redoit: y,
                traces: n,
                eventData: a.extendDeepNoArrays([], [m, n])
              };
            }
            function G(e) {
              var t,
                n,
                r,
                i = a.counterRegex("axis", ".title", !1, !1),
                o = /colorbar\.title$/,
                s = Object.keys(e);
              for (t = 0; t < s.length; t++) n = s[t], r = e[n], "title" !== n && !i.test(n) && !o.test(n) || "string" != typeof r && "number" != typeof r ? n.indexOf("titlefont") > -1 ? l(n, n.replace("titlefont", "title.font")) : n.indexOf("titleposition") > -1 ? l(n, n.replace("titleposition", "title.position")) : n.indexOf("titleside") > -1 ? l(n, n.replace("titleside", "title.side")) : n.indexOf("titleoffset") > -1 && l(n, n.replace("titleoffset", "title.offset")) : l(n, n.replace("title", "title.text"));
              function l(t, n) {
                e[n] = e[t], delete e[t];
              }
            }
            function V(e, t, n) {
              if (e = a.getGraphDiv(e), S.clearPromiseQueue(e), e.framework && e.framework.isPolar) return Promise.resolve(e);
              var r = {};
              if ("string" == typeof t) r[t] = n;else {
                if (!a.isPlainObject(t)) return a.warn("Relayout fail.", t, n), Promise.reject();
                r = a.extendFlat({}, t);
              }
              Object.keys(r).length && (e.changed = !0);
              var i = Y(e, r),
                o = i.flags;
              o.calc && (e.calcdata = void 0);
              var s = [h.previousPromises];
              o.layoutReplot ? s.push(A.layoutReplot) : Object.keys(r).length && (H(e, o, i) || h.supplyDefaults(e), o.legend && s.push(A.doLegend), o.layoutstyle && s.push(A.layoutStyles), o.axrange && q(s, i.rangesAltered), o.ticks && s.push(A.doTicksRelayout), o.modebar && s.push(A.doModeBar), o.camera && s.push(A.doCamera), o.colorbars && s.push(A.doColorBars), s.push(C)), s.push(h.rehover, h.redrag), u.add(e, V, [e, i.undoit], V, [e, i.redoit]);
              var l = a.syncOrAsync(s, e);
              return l && l.then || (l = Promise.resolve(e)), l.then(function () {
                return e.emit("plotly_relayout", i.eventData), e;
              });
            }
            function H(e, t, n) {
              var r = e._fullLayout;
              if (!t.axrange) return !1;
              for (var i in t) if ("axrange" !== i && t[i]) return !1;
              for (var o in n.rangesAltered) {
                var a = p.id2name(o),
                  s = e.layout[a],
                  l = r[a];
                if (l.autorange = s.autorange, l.range = s.range.slice(), l.cleanRange(), l._matchGroup) for (var u in l._matchGroup) if (u !== o) {
                  var c = r[p.id2name(u)];
                  c.autorange = l.autorange, c.range = l.range.slice(), c._input.range = l.range.slice();
                }
              }
              return !0;
            }
            function q(e, t) {
              var n = t ? function (e) {
                var n = [],
                  r = !0;
                for (var i in t) {
                  var o = p.getFromId(e, i);
                  if (n.push(i), o._matchGroup) for (var a in o._matchGroup) t[a] || n.push(a);
                  o.automargin && (r = !1);
                }
                return p.draw(e, n, {
                  skipTitle: r
                });
              } : function (e) {
                return p.draw(e, "redraw");
              };
              e.push(_, A.doAutoRangeAndConstraints, n, A.drawData, A.finalDraw);
            }
            var W = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/,
              $ = /^[xyz]axis[0-9]*\.autorange$/,
              X = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
            function Y(e, t) {
              var n,
                r,
                i,
                o = e.layout,
                l = e._fullLayout,
                u = l._guiEditing,
                h = F(l._preGUI, u),
                f = Object.keys(t),
                m = p.list(e),
                g = a.extendDeepAll({}, t),
                v = {};
              for (G(t), f = Object.keys(t), r = 0; r < f.length; r++) if (0 === f[r].indexOf("allaxes")) {
                for (i = 0; i < m.length; i++) {
                  var y = m[i]._id.substr(1),
                    b = -1 !== y.indexOf("scene") ? y + "." : "",
                    _ = f[r].replace("allaxes", b + m[i]._name);
                  t[_] || (t[_] = t[f[r]]);
                }
                delete t[f[r]];
              }
              var x = E.layoutFlags(),
                A = {},
                M = {};
              function C(e, n) {
                if (Array.isArray(e)) e.forEach(function (e) {
                  C(e, n);
                });else if (!(e in t) && !S.hasParent(t, e)) {
                  var r = h(o, e);
                  e in M || (M[e] = B(r.get())), void 0 !== n && r.set(n);
                }
              }
              var k,
                P = {};
              function O(e) {
                var t = p.name2id(e.split(".")[0]);
                return P[t] = 1, t;
              }
              for (var R in t) {
                if (S.hasParent(t, R)) throw new Error("cannot set " + R + " and a parent attribute simultaneously");
                for (var I = h(o, R), j = t[R], N = I.parts.length - 1; N > 0 && "string" != typeof I.parts[N];) N--;
                var L = I.parts[N],
                  D = I.parts[N - 1] + "." + L,
                  z = I.parts.slice(0, N).join("."),
                  U = s(e.layout, z).get(),
                  V = s(l, z).get(),
                  H = I.get();
                if (void 0 !== j) {
                  A[R] = j, M[R] = "reverse" === L ? j : B(H);
                  var q = d.getLayoutValObject(l, I.parts);
                  if (q && q.impliedEdits && null !== j) for (var Y in q.impliedEdits) C(a.relativeAttr(R, Y), q.impliedEdits[Y]);
                  if (-1 !== ["width", "height"].indexOf(R)) {
                    if (j) {
                      C("autosize", null);
                      var Z = "height" === R ? "width" : "height";
                      C(Z, l[Z]);
                    } else l[R] = e._initialAutoSize[R];
                  } else if ("autosize" === R) C("width", j ? null : l.width), C("height", j ? null : l.height);else if (D.match(W)) O(D), s(l, z + "._inputRange").set(null);else if (D.match($)) {
                    O(D), s(l, z + "._inputRange").set(null);
                    var Q = s(l, z).get();
                    Q._inputDomain && (Q._input.domain = Q._inputDomain.slice());
                  } else D.match(X) && s(l, z + "._inputDomain").set(null);
                  if ("type" === L) {
                    var J = U,
                      ee = "linear" === V.type && "log" === j,
                      te = "log" === V.type && "linear" === j;
                    if (ee || te) {
                      if (J && J.range) {
                        if (V.autorange) ee && (J.range = J.range[1] > J.range[0] ? [1, 2] : [2, 1]);else {
                          var ne = J.range[0],
                            re = J.range[1];
                          ee ? (ne <= 0 && re <= 0 && C(z + ".autorange", !0), ne <= 0 ? ne = re / 1e6 : re <= 0 && (re = ne / 1e6), C(z + ".range[0]", Math.log(ne) / Math.LN10), C(z + ".range[1]", Math.log(re) / Math.LN10)) : (C(z + ".range[0]", Math.pow(10, ne)), C(z + ".range[1]", Math.pow(10, re)));
                        }
                      } else C(z + ".autorange", !0);
                      Array.isArray(l._subplots.polar) && l._subplots.polar.length && l[I.parts[0]] && "radialaxis" === I.parts[1] && delete l[I.parts[0]]._subplot.viewInitial["radialaxis.range"], c.getComponentMethod("annotations", "convertCoords")(e, V, j, C), c.getComponentMethod("images", "convertCoords")(e, V, j, C);
                    } else C(z + ".autorange", !0), C(z + ".range", null);
                    s(l, z + "._inputRange").set(null);
                  } else if (L.match(T)) {
                    var ie = s(l, R).get(),
                      oe = (j || {}).type;
                    oe && "-" !== oe || (oe = "linear"), c.getComponentMethod("annotations", "convertCoords")(e, ie, oe, C), c.getComponentMethod("images", "convertCoords")(e, ie, oe, C);
                  }
                  var ae = w.containerArrayMatch(R);
                  if (ae) {
                    n = ae.array, r = ae.index;
                    var se = ae.property,
                      le = q || {
                        editType: "calc"
                      };
                    "" !== r && "" === se && (w.isAddVal(j) ? M[R] = null : w.isRemoveVal(j) ? M[R] = (s(o, n).get() || [])[r] : a.warn("unrecognized full object value", t)), E.update(x, le), v[n] || (v[n] = {});
                    var ue = v[n][r];
                    ue || (ue = v[n][r] = {}), ue[se] = j, delete t[R];
                  } else "reverse" === L ? (U.range ? U.range.reverse() : (C(z + ".autorange", !0), U.range = [1, 0]), V.autorange ? x.calc = !0 : x.plot = !0) : (l._has("scatter-like") && l._has("regl") && "dragmode" === R && ("lasso" === j || "select" === j) && "lasso" !== H && "select" !== H || l._has("gl2d") ? x.plot = !0 : q ? E.update(x, q) : x.calc = !0, I.set(j));
                }
              }
              for (n in v) w.applyContainerArrayChanges(e, h(o, n), v[n], x, h) || (x.plot = !0);
              var ce = l._axisConstraintGroups || [];
              for (k in P) for (r = 0; r < ce.length; r++) {
                var de = ce[r];
                if (de[k]) for (var he in x.calc = !0, de) P[he] || (p.getFromId(e, he)._constraintShrinkable = !0);
              }
              return (K(e) || t.height || t.width) && (x.plot = !0), (x.plot || x.calc) && (x.layoutReplot = !0), {
                flags: x,
                rangesAltered: P,
                undoit: M,
                redoit: A,
                eventData: g
              };
            }
            function K(e) {
              var t = e._fullLayout,
                n = t.width,
                r = t.height;
              return e.layout.autosize && h.plotAutoSize(e, e.layout, t), t.width !== n || t.height !== r;
            }
            function Z(e, t, r, i) {
              if (e = a.getGraphDiv(e), S.clearPromiseQueue(e), e.framework && e.framework.isPolar) return Promise.resolve(e);
              a.isPlainObject(t) || (t = {}), a.isPlainObject(r) || (r = {}), Object.keys(t).length && (e.changed = !0), Object.keys(r).length && (e.changed = !0);
              var o = S.coerceTraceIndices(e, i),
                s = U(e, a.extendFlat({}, t), o),
                l = s.flags,
                c = Y(e, a.extendFlat({}, r)),
                d = c.flags;
              (l.calc || d.calc) && (e.calcdata = void 0), l.clearAxisTypes && S.clearAxisTypes(e, o, r);
              var f = [];
              d.layoutReplot ? f.push(A.layoutReplot) : l.fullReplot ? f.push(n.plot) : (f.push(h.previousPromises), H(e, d, c) || h.supplyDefaults(e), l.style && f.push(A.doTraceStyle), (l.colorbars || d.colorbars) && f.push(A.doColorBars), d.legend && f.push(A.doLegend), d.layoutstyle && f.push(A.layoutStyles), d.axrange && q(f, c.rangesAltered), d.ticks && f.push(A.doTicksRelayout), d.modebar && f.push(A.doModeBar), d.camera && f.push(A.doCamera), f.push(C)), f.push(h.rehover, h.redrag), u.add(e, Z, [e, s.undoit, c.undoit, s.traces], Z, [e, s.redoit, c.redoit, s.traces]);
              var p = a.syncOrAsync(f, e);
              return p && p.then || (p = Promise.resolve(e)), p.then(function () {
                return e.emit("plotly_update", {
                  data: s.eventData,
                  layout: c.eventData
                }), e;
              });
            }
            function Q(e) {
              return function (t) {
                t._fullLayout._guiEditing = !0;
                var n = e.apply(null, arguments);
                return t._fullLayout._guiEditing = !1, n;
              };
            }
            var J = [{
                pattern: /^hiddenlabels/,
                attr: "legend.uirevision"
              }, {
                pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
              }, {
                pattern: /axis\d*\.showspikes$/,
                attr: "modebar.uirevision"
              }, {
                pattern: /(hover|drag)mode$/,
                attr: "modebar.uirevision"
              }, {
                pattern: /^(scene\d*)\.camera/
              }, {
                pattern: /^(geo\d*)\.(projection|center|fitbounds)/
              }, {
                pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
              }, {
                pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
              }, {
                pattern: /^(polar\d*\.angularaxis)\.rotation/
              }, {
                pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
              }, {
                pattern: /^legend\.(x|y)$/,
                attr: "editrevision"
              }, {
                pattern: /^(shapes|annotations)/,
                attr: "editrevision"
              }, {
                pattern: /^title\.text$/,
                attr: "editrevision"
              }],
              ee = [{
                pattern: /^selectedpoints$/,
                attr: "selectionrevision"
              }, {
                pattern: /(^|value\.)visible$/,
                attr: "legend.uirevision"
              }, {
                pattern: /^dimensions\[\d+\]\.constraintrange/
              }, {
                pattern: /^node\.(x|y|groups)/
              }, {
                pattern: /^level$/
              }, {
                pattern: /(^|value\.)name$/
              }, {
                pattern: /colorbar\.title\.text$/
              }, {
                pattern: /colorbar\.(x|y)$/,
                attr: "editrevision"
              }];
            function te(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n],
                  i = e.match(r.pattern);
                if (i) return {
                  head: i[1],
                  attr: r.attr
                };
              }
            }
            function ne(e, t) {
              var n = s(t, e).get();
              if (void 0 !== n) return n;
              var r = e.split(".");
              for (r.pop(); r.length > 1;) if (r.pop(), void 0 !== (n = s(t, r.join(".") + ".uirevision").get())) return n;
              return t.uirevision;
            }
            function re(e, t) {
              for (var n = 0; n < t.length; n++) if (t[n]._fullInput.uid === e) return n;
              return -1;
            }
            function ie(e, t, n) {
              for (var r = 0; r < t.length; r++) if (t[r].uid === e) return r;
              return !t[n] || t[n].uid ? -1 : n;
            }
            function oe(e, t) {
              var n = a.isPlainObject(e),
                r = Array.isArray(e);
              return n || r ? (n && a.isPlainObject(t) || r && Array.isArray(t)) && JSON.stringify(e) === JSON.stringify(t) : e === t;
            }
            function ae(e, t, n, r) {
              var i,
                o,
                l,
                u = r.getValObject,
                c = r.flags,
                d = r.immutable,
                h = r.inArray,
                f = r.arrayIndex;
              function p() {
                var e = i.editType;
                h && -1 !== e.indexOf("arraydraw") ? a.pushUnique(c.arrays[h], f) : (E.update(c, i), "none" !== e && c.nChanges++, r.transition && i.anim && c.nChangesAnim++, (W.test(l) || $.test(l)) && (c.rangesAltered[n[0]] = 1), X.test(l) && s(t, "_inputDomain").set(null), "datarevision" === o && (c.newDataRevision = 1));
              }
              function m(e) {
                return "data_array" === e.valType || e.arrayOk;
              }
              for (o in e) {
                if (c.calc && !r.transition) return;
                var g = e[o],
                  v = t[o],
                  y = n.concat(o);
                if (l = y.join("."), "_" !== o.charAt(0) && "function" != typeof g && g !== v) {
                  if (("tick0" === o || "dtick" === o) && "geo" !== n[0]) {
                    var b = t.tickmode;
                    if ("auto" === b || "array" === b || !b) continue;
                  }
                  if (("range" !== o || !t.autorange) && ("zmin" !== o && "zmax" !== o || "contourcarpet" !== t.type) && (i = u(y)) && (!i._compareAsJSON || JSON.stringify(g) !== JSON.stringify(v))) {
                    var _,
                      x = i.valType,
                      w = m(i),
                      S = Array.isArray(g),
                      A = Array.isArray(v);
                    if (S && A) {
                      var T = "_input_" + o,
                        M = e[T],
                        C = t[T];
                      if (Array.isArray(M) && M === C) continue;
                    }
                    if (void 0 === v) w && S ? c.calc = !0 : p();else if (i._isLinkedToArray) {
                      var k = [],
                        P = !1;
                      h || (c.arrays[o] = k);
                      var O = Math.min(g.length, v.length),
                        R = Math.max(g.length, v.length);
                      if (O !== R) {
                        if ("arraydraw" !== i.editType) {
                          p();
                          continue;
                        }
                        P = !0;
                      }
                      for (_ = 0; _ < O; _++) ae(g[_], v[_], y.concat(_), a.extendFlat({
                        inArray: o,
                        arrayIndex: _
                      }, r));
                      if (P) for (_ = O; _ < R; _++) k.push(_);
                    } else !x && a.isPlainObject(g) ? ae(g, v, y, r) : w ? S && A ? (d && (c.calc = !0), (d || r.newDataRevision) && p()) : S !== A ? c.calc = !0 : p() : S && A && g.length === v.length && String(g) === String(v) || p();
                  }
                }
              }
              for (o in t) if (!(o in e) && "_" !== o.charAt(0) && "function" != typeof t[o]) {
                if (m(i = u(n.concat(o))) && Array.isArray(t[o])) return void (c.calc = !0);
                p();
              }
            }
            function se(e) {
              var t = r.select(e),
                n = e._fullLayout;
              if (n._container = t.selectAll(".plot-container").data([0]), n._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0), n._paperdiv = n._container.selectAll(".svg-container").data([0]), n._paperdiv.enter().append("div").classed("svg-container", !0).style("position", "relative"), n._glcontainer = n._paperdiv.selectAll(".gl-container").data([{}]), n._glcontainer.enter().append("div").classed("gl-container", !0), n._paperdiv.selectAll(".main-svg").remove(), n._paperdiv.select(".modebar-container").remove(), n._paper = n._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), n._toppaper = n._paperdiv.append("svg").classed("main-svg", !0), n._modebardiv = n._paperdiv.append("div"), n._hoverpaper = n._paperdiv.append("svg").classed("main-svg", !0), !n._uid) {
                var i = {};
                r.selectAll("defs").each(function () {
                  this.id && (i[this.id.split("-")[1]] = 1);
                }), n._uid = a.randstr(i);
              }
              n._paperdiv.selectAll(".main-svg").attr(y.svgAttrs), n._defs = n._paper.append("defs").attr("id", "defs-" + n._uid), n._clips = n._defs.append("g").classed("clips", !0), n._topdefs = n._toppaper.append("defs").attr("id", "topdefs-" + n._uid), n._topclips = n._topdefs.append("g").classed("clips", !0), n._bgLayer = n._paper.append("g").classed("bglayer", !0), n._draggers = n._paper.append("g").classed("draglayer", !0);
              var o = n._paper.append("g").classed("layer-below", !0);
              n._imageLowerLayer = o.append("g").classed("imagelayer", !0), n._shapeLowerLayer = o.append("g").classed("shapelayer", !0), n._cartesianlayer = n._paper.append("g").classed("cartesianlayer", !0), n._polarlayer = n._paper.append("g").classed("polarlayer", !0), n._ternarylayer = n._paper.append("g").classed("ternarylayer", !0), n._geolayer = n._paper.append("g").classed("geolayer", !0), n._funnelarealayer = n._paper.append("g").classed("funnelarealayer", !0), n._pielayer = n._paper.append("g").classed("pielayer", !0), n._treemaplayer = n._paper.append("g").classed("treemaplayer", !0), n._sunburstlayer = n._paper.append("g").classed("sunburstlayer", !0), n._indicatorlayer = n._toppaper.append("g").classed("indicatorlayer", !0), n._glimages = n._paper.append("g").classed("glimages", !0);
              var s = n._toppaper.append("g").classed("layer-above", !0);
              n._imageUpperLayer = s.append("g").classed("imagelayer", !0), n._shapeUpperLayer = s.append("g").classed("shapelayer", !0), n._infolayer = n._toppaper.append("g").classed("infolayer", !0), n._menulayer = n._toppaper.append("g").classed("menulayer", !0), n._zoomlayer = n._toppaper.append("g").classed("zoomlayer", !0), n._hoverlayer = n._hoverpaper.append("g").classed("hoverlayer", !0), n._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), e.emit("plotly_framework");
            }
            n.animate = function (e, t, n) {
              if (e = a.getGraphDiv(e), !a.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plot.ly/javascript/animations/");
              var r = e._transitionData;
              r._frameQueue || (r._frameQueue = []);
              var i = (n = h.supplyAnimationDefaults(n)).transition,
                o = n.frame;
              function s(e) {
                return Array.isArray(i) ? e >= i.length ? i[0] : i[e] : i;
              }
              function l(e) {
                return Array.isArray(o) ? e >= o.length ? o[0] : o[e] : o;
              }
              function u(e, t) {
                var n = 0;
                return function () {
                  if (e && ++n === t) return e();
                };
              }
              return void 0 === r._frameWaitingCnt && (r._frameWaitingCnt = 0), new Promise(function (o, c) {
                function d() {
                  e.emit("plotly_animating"), r._lastFrameAt = -1 / 0, r._timeToNext = 0, r._runningTransitions = 0, r._currentFrame = null;
                  var t = function t() {
                    r._animationRaf = window.requestAnimationFrame(t), Date.now() - r._lastFrameAt > r._timeToNext && function () {
                      r._currentFrame && r._currentFrame.onComplete && r._currentFrame.onComplete();
                      var t = r._currentFrame = r._frameQueue.shift();
                      if (t) {
                        var n = t.name ? t.name.toString() : null;
                        e._fullLayout._currentFrame = n, r._lastFrameAt = Date.now(), r._timeToNext = t.frameOpts.duration, h.transition(e, t.frame.data, t.frame.layout, S.coerceTraceIndices(e, t.frame.traces), t.frameOpts, t.transitionOpts).then(function () {
                          t.onComplete && t.onComplete();
                        }), e.emit("plotly_animatingframe", {
                          name: n,
                          frame: t.frame,
                          animation: {
                            frame: t.frameOpts,
                            transition: t.transitionOpts
                          }
                        });
                      } else e.emit("plotly_animated"), window.cancelAnimationFrame(r._animationRaf), r._animationRaf = null;
                    }();
                  };
                  t();
                }
                var f,
                  p,
                  m = 0;
                function g(e) {
                  return Array.isArray(i) ? m >= i.length ? e.transitionOpts = i[m] : e.transitionOpts = i[0] : e.transitionOpts = i, m++, e;
                }
                var v = [],
                  y = null == t,
                  b = Array.isArray(t);
                if (y || b || !a.isPlainObject(t)) {
                  if (y || -1 !== ["string", "number"].indexOf(typeof t)) for (f = 0; f < r._frames.length; f++) (p = r._frames[f]) && (y || String(p.group) === String(t)) && v.push({
                    type: "byname",
                    name: String(p.name),
                    data: g({
                      name: p.name
                    })
                  });else if (b) for (f = 0; f < t.length; f++) {
                    var _ = t[f];
                    -1 !== ["number", "string"].indexOf(typeof _) ? (_ = String(_), v.push({
                      type: "byname",
                      name: _,
                      data: g({
                        name: _
                      })
                    })) : a.isPlainObject(_) && v.push({
                      type: "object",
                      data: g(a.extendFlat({}, _))
                    });
                  }
                } else v.push({
                  type: "object",
                  data: g(a.extendFlat({}, t))
                });
                for (f = 0; f < v.length; f++) if ("byname" === (p = v[f]).type && !r._frameHash[p.data.name]) return a.warn('animate failure: frame not found: "' + p.data.name + '"'), void c();
                -1 !== ["next", "immediate"].indexOf(n.mode) && function () {
                  if (0 !== r._frameQueue.length) {
                    for (; r._frameQueue.length;) {
                      var t = r._frameQueue.pop();
                      t.onInterrupt && t.onInterrupt();
                    }
                    e.emit("plotly_animationinterrupted", []);
                  }
                }(), "reverse" === n.direction && v.reverse();
                var x = e._fullLayout._currentFrame;
                if (x && n.fromcurrent) {
                  var w = -1;
                  for (f = 0; f < v.length; f++) if ("byname" === (p = v[f]).type && p.name === x) {
                    w = f;
                    break;
                  }
                  if (w > 0 && w < v.length - 1) {
                    var A = [];
                    for (f = 0; f < v.length; f++) p = v[f], ("byname" !== v[f].type || f > w) && A.push(p);
                    v = A;
                  }
                }
                v.length > 0 ? function (t) {
                  if (0 !== t.length) {
                    for (var i = 0; i < t.length; i++) {
                      var a;
                      a = "byname" === t[i].type ? h.computeFrame(e, t[i].name) : t[i].data;
                      var f = l(i),
                        p = s(i);
                      p.duration = Math.min(p.duration, f.duration);
                      var m = {
                        frame: a,
                        name: t[i].name,
                        frameOpts: f,
                        transitionOpts: p
                      };
                      i === t.length - 1 && (m.onComplete = u(o, 2), m.onInterrupt = c), r._frameQueue.push(m);
                    }
                    "immediate" === n.mode && (r._lastFrameAt = -1 / 0), r._animationRaf || d();
                  }
                }(v) : (e.emit("plotly_animated"), o());
              });
            }, n.addFrames = function (e, t, n) {
              if (e = a.getGraphDiv(e), null == t) return Promise.resolve();
              if (!a.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plot.ly/javascript/animations/");
              var r,
                i,
                o,
                s,
                l = e._transitionData._frames,
                c = e._transitionData._frameHash;
              if (!Array.isArray(t)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + t);
              var d = l.length + 2 * t.length,
                f = [],
                p = {};
              for (r = t.length - 1; r >= 0; r--) if (a.isPlainObject(t[r])) {
                var m = t[r].name,
                  g = (c[m] || p[m] || {}).name,
                  v = t[r].name,
                  y = c[g] || p[g];
                g && v && "number" == typeof v && y && M < 5 && (M++, a.warn('addFrames: overwriting frame "' + (c[g] || p[g]).name + '" with a frame whose name of type "number" also equates to "' + g + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), 5 === M && a.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), p[m] = {
                  name: m
                }, f.push({
                  frame: h.supplyFrameDefaults(t[r]),
                  index: n && void 0 !== n[r] && null !== n[r] ? n[r] : d + r
                });
              }
              f.sort(function (e, t) {
                return e.index > t.index ? -1 : e.index < t.index ? 1 : 0;
              });
              var b = [],
                _ = [],
                x = l.length;
              for (r = f.length - 1; r >= 0; r--) {
                if ("number" == typeof (i = f[r].frame).name && a.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !i.name) for (; c[i.name = "frame " + e._transitionData._counter++];);
                if (c[i.name]) {
                  for (o = 0; o < l.length && (l[o] || {}).name !== i.name; o++);
                  b.push({
                    type: "replace",
                    index: o,
                    value: i
                  }), _.unshift({
                    type: "replace",
                    index: o,
                    value: l[o]
                  });
                } else s = Math.max(0, Math.min(f[r].index, x)), b.push({
                  type: "insert",
                  index: s,
                  value: i
                }), _.unshift({
                  type: "delete",
                  index: s
                }), x++;
              }
              var w = h.modifyFrames,
                S = h.modifyFrames,
                A = [e, _],
                E = [e, b];
              return u && u.add(e, w, A, S, E), h.modifyFrames(e, b);
            }, n.deleteFrames = function (e, t) {
              if (e = a.getGraphDiv(e), !a.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
              var n,
                r,
                i = e._transitionData._frames,
                o = [],
                s = [];
              if (!t) for (t = [], n = 0; n < i.length; n++) t.push(n);
              for ((t = t.slice()).sort(), n = t.length - 1; n >= 0; n--) r = t[n], o.push({
                type: "delete",
                index: r
              }), s.unshift({
                type: "insert",
                index: r,
                value: i[r]
              });
              var l = h.modifyFrames,
                c = h.modifyFrames,
                d = [e, s],
                f = [e, o];
              return u && u.add(e, l, d, c, f), h.modifyFrames(e, o);
            }, n.addTraces = function e(t, r, i) {
              t = a.getGraphDiv(t);
              var o,
                s,
                l = [],
                c = n.deleteTraces,
                d = e,
                h = [t, l],
                f = [t, r];
              for (function (e, t, n) {
                var r, i;
                if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
                if (void 0 === t) throw new Error("traces must be defined.");
                for (Array.isArray(t) || (t = [t]), r = 0; r < t.length; r++) if ("object" != typeof (i = t[r]) || Array.isArray(i) || null === i) throw new Error("all values in traces array must be non-array objects");
                if (void 0 === n || Array.isArray(n) || (n = [n]), void 0 !== n && n.length !== t.length) throw new Error("if indices is specified, traces.length must equal indices.length");
              }(t, r, i), Array.isArray(r) || (r = [r]), r = r.map(function (e) {
                return a.extendFlat({}, e);
              }), S.cleanData(r), o = 0; o < r.length; o++) t.data.push(r[o]);
              for (o = 0; o < r.length; o++) l.push(-r.length + o);
              if (void 0 === i) return s = n.redraw(t), u.add(t, c, h, d, f), s;
              Array.isArray(i) || (i = [i]);
              try {
                j(t, l, i);
              } catch (e) {
                throw t.data.splice(t.data.length - r.length, r.length), e;
              }
              return u.startSequence(t), u.add(t, c, h, d, f), s = n.moveTraces(t, l, i), u.stopSequence(t), s;
            }, n.deleteTraces = function e(t, r) {
              t = a.getGraphDiv(t);
              var i,
                o,
                s = [],
                l = n.addTraces,
                c = e,
                d = [t, s, r],
                h = [t, r];
              if (void 0 === r) throw new Error("indices must be an integer or array of integers.");
              for (Array.isArray(r) || (r = [r]), I(t, r, "indices"), (r = R(r, t.data.length - 1)).sort(a.sorterDes), i = 0; i < r.length; i += 1) o = t.data.splice(r[i], 1)[0], s.push(o);
              var f = n.redraw(t);
              return u.add(t, l, d, c, h), f;
            }, n.extendTraces = function e(t, r, i, o) {
              var s = N(t = a.getGraphDiv(t), r, i, o, function (e, t, n) {
                  var r, i;
                  if (a.isTypedArray(e)) {
                    if (n < 0) {
                      var o = new e.constructor(0),
                        s = L(e, t);
                      n < 0 ? (r = s, i = o) : (r = o, i = s);
                    } else if (r = new e.constructor(n), i = new e.constructor(e.length + t.length - n), n === t.length) r.set(t), i.set(e);else if (n < t.length) {
                      var l = t.length - n;
                      r.set(t.subarray(l)), i.set(e), i.set(t.subarray(0, l), e.length);
                    } else {
                      var u = n - t.length,
                        c = e.length - u;
                      r.set(e.subarray(c)), r.set(t, u), i.set(e.subarray(0, c));
                    }
                  } else r = e.concat(t), i = n >= 0 && n < r.length ? r.splice(0, r.length - n) : [];
                  return [r, i];
                }),
                l = n.redraw(t),
                c = [t, s.update, i, s.maxPoints];
              return u.add(t, n.prependTraces, c, e, arguments), l;
            }, n.moveTraces = function e(t, r, i) {
              var o,
                s = [],
                l = [],
                c = e,
                d = e,
                h = [t = a.getGraphDiv(t), i, r],
                f = [t, r, i];
              if (j(t, r, i), r = Array.isArray(r) ? r : [r], void 0 === i) for (i = [], o = 0; o < r.length; o++) i.push(-r.length + o);
              for (i = Array.isArray(i) ? i : [i], r = R(r, t.data.length - 1), i = R(i, t.data.length - 1), o = 0; o < t.data.length; o++) -1 === r.indexOf(o) && s.push(t.data[o]);
              for (o = 0; o < r.length; o++) l.push({
                newIndex: i[o],
                trace: t.data[r[o]]
              });
              for (l.sort(function (e, t) {
                return e.newIndex - t.newIndex;
              }), o = 0; o < l.length; o += 1) s.splice(l[o].newIndex, 0, l[o].trace);
              t.data = s;
              var p = n.redraw(t);
              return u.add(t, c, h, d, f), p;
            }, n.prependTraces = function e(t, r, i, o) {
              var s = N(t = a.getGraphDiv(t), r, i, o, function (e, t, n) {
                  var r, i;
                  if (a.isTypedArray(e)) {
                    if (n <= 0) {
                      var o = new e.constructor(0),
                        s = L(t, e);
                      n < 0 ? (r = s, i = o) : (r = o, i = s);
                    } else if (r = new e.constructor(n), i = new e.constructor(e.length + t.length - n), n === t.length) r.set(t), i.set(e);else if (n < t.length) {
                      var l = t.length - n;
                      r.set(t.subarray(0, l)), i.set(t.subarray(l)), i.set(e, l);
                    } else {
                      var u = n - t.length;
                      r.set(t), r.set(e.subarray(0, u), t.length), i.set(e.subarray(u));
                    }
                  } else r = t.concat(e), i = n >= 0 && n < r.length ? r.splice(n, r.length) : [];
                  return [r, i];
                }),
                l = n.redraw(t),
                c = [t, s.update, i, s.maxPoints];
              return u.add(t, n.extendTraces, c, e, arguments), l;
            }, n.newPlot = function (e, t, r, i) {
              return e = a.getGraphDiv(e), h.cleanPlot([], {}, e._fullData || [], e._fullLayout || {}), h.purge(e), n.plot(e, t, r, i);
            }, n.plot = function (e, t, i, o) {
              var s;
              if (e = a.getGraphDiv(e), l.init(e), a.isPlainObject(t)) {
                var u = t;
                t = u.data, i = u.layout, o = u.config, s = u.frames;
              }
              if (!1 === l.triggerHandler(e, "plotly_beforeplot", [t, i, o])) return Promise.reject();
              t || i || a.isPlotDiv(e) || a.warn("Calling Plotly.plot as if redrawing but this container doesn't yet have a plot.", e), O(e, o), i || (i = {}), r.select(e).classed("js-plotly-plot", !0), m.makeTester(), Array.isArray(e._promises) || (e._promises = []);
              var d = 0 === (e.data || []).length && Array.isArray(t);
              Array.isArray(t) && (S.cleanData(t), d ? e.data = t : e.data.push.apply(e.data, t), e.empty = !1), e.layout && !d || (e.layout = S.cleanLayout(i)), h.supplyDefaults(e);
              var g = e._fullLayout,
                y = g._has("cartesian");
              if (!g._has("polar") && t && t[0] && t[0].r) return a.log("Legacy polar charts are deprecated!"), function (e, t, n) {
                var i = r.select(e).selectAll(".plot-container").data([0]);
                i.enter().insert("div", ":first-child").classed("plot-container plotly", !0);
                var o = i.selectAll(".svg-container").data([0]);
                o.enter().append("div").classed("svg-container", !0).style("position", "relative"), o.html(""), t && (e.data = t), n && (e.layout = n), f.manager.fillLayout(e), o.style({
                  width: e._fullLayout.width + "px",
                  height: e._fullLayout.height + "px"
                }), e.framework = f.manager.framework(e), e.framework({
                  data: e.data,
                  layout: e.layout
                }, o.node()), e.framework.setUndoPoint();
                var s = e.framework.svg(),
                  l = 1,
                  u = e._fullLayout.title ? e._fullLayout.title.text : "";
                "" !== u && u || (l = 0);
                var c = function c() {
                    this.call(b.convertToTspans, e);
                  },
                  d = s.select(".title-group text").call(c);
                if (e._context.edits.titleText) {
                  var p = a._(e, "Click to enter Plot title");
                  u && u !== p || (l = .2, d.attr({
                    "data-unformatted": p
                  }).text(p).style({
                    opacity: l
                  }).on("mouseover.opacity", function () {
                    r.select(this).transition().duration(100).style("opacity", 1);
                  }).on("mouseout.opacity", function () {
                    r.select(this).transition().duration(1e3).style("opacity", 0);
                  }));
                  var m = function m() {
                    this.call(b.makeEditable, {
                      gd: e
                    }).on("edit", function (t) {
                      e.framework({
                        layout: {
                          title: {
                            text: t
                          }
                        }
                      }), this.text(t).call(c), this.call(m);
                    }).on("cancel", function () {
                      var e = this.attr("data-unformatted");
                      this.text(e).call(c);
                    });
                  };
                  d.call(m);
                }
                return e._context.setBackground(e, e._fullLayout.paper_bgcolor), h.addLinks(e), Promise.resolve();
              }(e, t, i);
              g._replotting = !0, d && se(e), e.framework !== se && (e.framework = se, se(e)), m.initGradients(e), d && p.saveShowSpikeInitial(e);
              var _ = !e.calcdata || e.calcdata.length !== (e._fullData || []).length;
              _ && h.doCalcdata(e);
              for (var x = 0; x < e.calcdata.length; x++) e.calcdata[x][0].trace = e._fullData[x];
              e._context.responsive ? e._responsiveChartHandler || (e._responsiveChartHandler = function () {
                a.isHidden(e) || h.resize(e);
              }, window.addEventListener("resize", e._responsiveChartHandler)) : a.clearResponsive(e);
              var w = a.extendFlat({}, g._size),
                E = 0;
              function T() {
                if (h.clearAutoMarginIds(e), A.drawMarginPushers(e), p.allowAutoMargin(e), g._has("pie")) for (var t = e._fullData, n = 0; n < t.length; n++) {
                  var r = t[n];
                  "pie" === r.type && r.automargin && h.allowAutoMargin(e, "pie." + r.uid + ".automargin");
                }
                return h.doAutoMargin(e), h.previousPromises(e);
              }
              function M() {
                e._transitioning || (A.doAutoRangeAndConstraints(e), d && p.saveRangeInitial(e), c.getComponentMethod("rangeslider", "calcAutorange")(e));
              }
              var k = [h.previousPromises, function () {
                if (s) return n.addFrames(e, s);
              }, function t() {
                for (var n = g._basePlotModules, r = 0; r < n.length; r++) n[r].drawFramework && n[r].drawFramework(e);
                if (!g._glcanvas && g._has("gl") && (g._glcanvas = g._glcontainer.selectAll(".gl-canvas").data([{
                  key: "contextLayer",
                  context: !0,
                  pick: !1
                }, {
                  key: "focusLayer",
                  context: !1,
                  pick: !1
                }, {
                  key: "pickLayer",
                  context: !1,
                  pick: !0
                }], function (e) {
                  return e.key;
                }), g._glcanvas.enter().append("canvas").attr("class", function (e) {
                  return "gl-canvas gl-canvas-" + e.key.replace("Layer", "");
                }).style({
                  position: "absolute",
                  top: 0,
                  left: 0,
                  overflow: "visible",
                  "pointer-events": "none"
                })), g._glcanvas) {
                  g._glcanvas.attr("width", g.width).attr("height", g.height);
                  var i = g._glcanvas.data()[0].regl;
                  if (i && (Math.floor(g.width) !== i._gl.drawingBufferWidth || Math.floor(g.height) !== i._gl.drawingBufferHeight)) {
                    var o = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                    if (!E) return a.log(o + " Clearing graph and plotting again."), h.cleanPlot([], {}, e._fullData, g), h.supplyDefaults(e), g = e._fullLayout, h.doCalcdata(e), E++, t();
                    a.error(o);
                  }
                }
                return "h" === g.modebar.orientation ? g._modebardiv.style("height", null).style("width", "100%") : g._modebardiv.style("width", null).style("height", g.height + "px"), h.previousPromises(e);
              }, T, function () {
                if (h.didMarginChange(w, g._size)) return a.syncOrAsync([T, A.layoutStyles], e);
              }];
              y && k.push(function () {
                if (_) return a.syncOrAsync([c.getComponentMethod("shapes", "calcAutorange"), c.getComponentMethod("annotations", "calcAutorange"), M], e);
                M();
              }), k.push(A.layoutStyles), y && k.push(function () {
                return p.draw(e, d ? "" : "redraw");
              }), k.push(A.drawData, A.finalDraw, v, h.addLinks, h.rehover, h.redrag, h.doAutoMargin, h.previousPromises);
              var P = a.syncOrAsync(k, e);
              return P && P.then || (P = Promise.resolve()), P.then(function () {
                return C(e), e;
              });
            }, n.purge = function (e) {
              var t = (e = a.getGraphDiv(e))._fullLayout || {},
                n = e._fullData || [];
              return h.cleanPlot([], {}, n, t), h.purge(e), l.purge(e), t._container && t._container.remove(), delete e._context, e;
            }, n.react = function (e, t, r, i) {
              var o, l;
              e = a.getGraphDiv(e), S.clearPromiseQueue(e);
              var u = e._fullData,
                f = e._fullLayout;
              if (a.isPlotDiv(e) && u && f) {
                if (a.isPlainObject(t)) {
                  var p = t;
                  t = p.data, r = p.layout, i = p.config, o = p.frames;
                }
                var m = !1;
                if (i) {
                  var g = a.extendDeep({}, e._context);
                  e._context = void 0, O(e, i), m = function e(t, n) {
                    var r;
                    for (r in t) if ("_" !== r.charAt(0)) {
                      var i = t[r],
                        o = n[r];
                      if (i !== o) if (a.isPlainObject(i) && a.isPlainObject(o)) {
                        if (e(i, o)) return !0;
                      } else {
                        if (!Array.isArray(i) || !Array.isArray(o)) return !0;
                        if (i.length !== o.length) return !0;
                        for (var s = 0; s < i.length; s++) if (i[s] !== o[s]) {
                          if (!a.isPlainObject(i[s]) || !a.isPlainObject(o[s])) return !0;
                          if (e(i[s], o[s])) return !0;
                        }
                      }
                    }
                  }(g, e._context);
                }
                e.data = t || [], S.cleanData(e.data), e.layout = r || {}, S.cleanLayout(e.layout), function (e, t, n, r) {
                  var i,
                    o,
                    l,
                    u,
                    c,
                    d,
                    h,
                    f,
                    p = r._preGUI,
                    m = [],
                    g = {};
                  for (i in p) {
                    if (c = te(i, J)) {
                      if (o = c.attr || c.head + ".uirevision", (u = (l = s(r, o).get()) && ne(o, t)) && u === l && (null === (d = p[i]) && (d = void 0), oe(f = (h = s(t, i)).get(), d))) {
                        void 0 === f && "autorange" === i.substr(i.length - 9) && m.push(i.substr(0, i.length - 10)), h.set(B(s(r, i).get()));
                        continue;
                      }
                    } else a.warn("unrecognized GUI edit: " + i);
                    delete p[i], "range[" === i.substr(i.length - 8, 6) && (g[i.substr(0, i.length - 9)] = 1);
                  }
                  for (var v = 0; v < m.length; v++) {
                    var y = m[v];
                    if (g[y]) {
                      var b = s(t, y).get();
                      b && delete b.autorange;
                    }
                  }
                  var _ = r._tracePreGUI;
                  for (var x in _) {
                    var w,
                      S = _[x],
                      A = null;
                    for (i in S) {
                      if (!A) {
                        var E = re(x, n);
                        if (E < 0) {
                          delete _[x];
                          break;
                        }
                        var T = ie(x, e, (w = n[E]._fullInput).index);
                        if (T < 0) {
                          delete _[x];
                          break;
                        }
                        A = e[T];
                      }
                      if (c = te(i, ee)) {
                        if (c.attr ? u = (l = s(r, c.attr).get()) && ne(c.attr, t) : (l = w.uirevision, void 0 === (u = A.uirevision) && (u = t.uirevision)), u && u === l && (null === (d = S[i]) && (d = void 0), oe(f = (h = s(A, i)).get(), d))) {
                          h.set(B(s(w, i).get()));
                          continue;
                        }
                      } else a.warn("unrecognized GUI edit: " + i + " in trace uid " + x);
                      delete S[i];
                    }
                  }
                }(e.data, e.layout, u, f), h.supplyDefaults(e, {
                  skipUpdateCalc: !0
                });
                var v = e._fullData,
                  y = e._fullLayout,
                  b = void 0 === y.datarevision,
                  _ = y.transition,
                  x = function (e, t, n, r, i) {
                    var o = E.layoutFlags();
                    return o.arrays = {}, o.rangesAltered = {}, o.nChanges = 0, o.nChangesAnim = 0, ae(t, n, [], {
                      getValObject: function getValObject(e) {
                        return d.getLayoutValObject(n, e);
                      },
                      flags: o,
                      immutable: r,
                      transition: i,
                      gd: e
                    }), (o.plot || o.calc) && (o.layoutReplot = !0), i && o.nChanges && o.nChangesAnim && (o.anim = o.nChanges === o.nChangesAnim ? "all" : "some"), o;
                  }(e, f, y, b, _),
                  w = x.newDataRevision,
                  T = function (e, t, n, r, i, o) {
                    var a = t.length === n.length;
                    if (!i && !a) return {
                      fullReplot: !0,
                      calc: !0
                    };
                    var s,
                      l,
                      u = E.traceFlags();
                    u.arrays = {}, u.nChanges = 0, u.nChangesAnim = 0;
                    var c = {
                        getValObject: function getValObject(e) {
                          var t = d.getTraceValObject(l, e);
                          return !l._module.animatable && t.anim && (t.anim = !1), t;
                        },
                        flags: u,
                        immutable: r,
                        transition: i,
                        newDataRevision: o,
                        gd: e
                      },
                      f = {};
                    for (s = 0; s < t.length; s++) if (n[s]) {
                      if (l = n[s]._fullInput, h.hasMakesDataTransform(l) && (l = n[s]), f[l.uid]) continue;
                      f[l.uid] = 1, ae(t[s]._fullInput, l, [], c);
                    }
                    return (u.calc || u.plot) && (u.fullReplot = !0), i && u.nChanges && u.nChangesAnim && (u.anim = u.nChanges === u.nChangesAnim && a ? "all" : "some"), u;
                  }(e, u, v, b, _, w);
                K(e) && (x.layoutReplot = !0), T.calc || x.calc ? e.calcdata = void 0 : h.supplyDefaultsUpdateCalc(e.calcdata, v);
                var M = [];
                if (o && (e._transitionData = {}, h.createTransitionData(e), M.push(function () {
                  return n.addFrames(e, o);
                })), y.transition && !m && (T.anim || x.anim)) h.doCalcdata(e), A.doAutoRangeAndConstraints(e), M.push(function () {
                  return h.transitionFromReact(e, T, x, f);
                });else if (T.fullReplot || x.layoutReplot || m) e._fullLayout._skipDefaults = !0, M.push(n.plot);else {
                  for (var k in x.arrays) {
                    var P = x.arrays[k];
                    if (P.length) {
                      var R = c.getComponentMethod(k, "drawOne");
                      if (R !== a.noop) for (var I = 0; I < P.length; I++) R(e, P[I]);else {
                        var j = c.getComponentMethod(k, "draw");
                        if (j === a.noop) throw new Error("cannot draw components: " + k);
                        j(e);
                      }
                    }
                  }
                  M.push(h.previousPromises), T.style && M.push(A.doTraceStyle), (T.colorbars || x.colorbars) && M.push(A.doColorBars), x.legend && M.push(A.doLegend), x.layoutstyle && M.push(A.layoutStyles), x.axrange && q(M), x.ticks && M.push(A.doTicksRelayout), x.modebar && M.push(A.doModeBar), x.camera && M.push(A.doCamera), M.push(C);
                }
                M.push(h.rehover, h.redrag), (l = a.syncOrAsync(M, e)) && l.then || (l = Promise.resolve(e));
              } else l = n.newPlot(e, t, r, i);
              return l.then(function () {
                return e.emit("plotly_react", {
                  data: t,
                  layout: r
                }), e;
              });
            }, n.redraw = function (e) {
              if (e = a.getGraphDiv(e), !a.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
              return S.cleanData(e.data), S.cleanLayout(e.layout), e.calcdata = void 0, n.plot(e).then(function () {
                return e.emit("plotly_redraw"), e;
              });
            }, n.relayout = V, n.restyle = D, n.setPlotConfig = function (e) {
              return a.extendFlat(x, e);
            }, n.update = Z, n._guiRelayout = Q(V), n._guiRestyle = Q(D), n._guiUpdate = Q(Z), n._storeDirectGUIEdit = function (e, t, n) {
              for (var r in n) z(r, s(e, r).get(), n[r], t);
            };
          }, {
            "../components/color": 375,
            "../components/drawing": 396,
            "../constants/xmlns_namespaces": 475,
            "../lib": 495,
            "../lib/events": 488,
            "../lib/queue": 509,
            "../lib/svg_text_utils": 518,
            "../plots/cartesian/axes": 541,
            "../plots/cartesian/constants": 547,
            "../plots/cartesian/graph_interact": 550,
            "../plots/cartesian/select": 558,
            "../plots/plots": 584,
            "../plots/polar/legacy": 587,
            "../registry": 593,
            "./edit_types": 524,
            "./helpers": 525,
            "./manage_arrays": 527,
            "./plot_config": 529,
            "./plot_schema": 530,
            "./subroutines": 532,
            d3: 82,
            "fast-isnumeric": 91,
            "has-hover": 250
          }],
          529: [function (e, t, n) {
            "use strict";

            var r = {
                staticPlot: {
                  valType: "boolean",
                  dflt: !1
                },
                plotlyServerURL: {
                  valType: "string",
                  dflt: "https://plot.ly"
                },
                editable: {
                  valType: "boolean",
                  dflt: !1
                },
                edits: {
                  annotationPosition: {
                    valType: "boolean",
                    dflt: !1
                  },
                  annotationTail: {
                    valType: "boolean",
                    dflt: !1
                  },
                  annotationText: {
                    valType: "boolean",
                    dflt: !1
                  },
                  axisTitleText: {
                    valType: "boolean",
                    dflt: !1
                  },
                  colorbarPosition: {
                    valType: "boolean",
                    dflt: !1
                  },
                  colorbarTitleText: {
                    valType: "boolean",
                    dflt: !1
                  },
                  legendPosition: {
                    valType: "boolean",
                    dflt: !1
                  },
                  legendText: {
                    valType: "boolean",
                    dflt: !1
                  },
                  shapePosition: {
                    valType: "boolean",
                    dflt: !1
                  },
                  titleText: {
                    valType: "boolean",
                    dflt: !1
                  }
                },
                autosizable: {
                  valType: "boolean",
                  dflt: !1
                },
                responsive: {
                  valType: "boolean",
                  dflt: !1
                },
                fillFrame: {
                  valType: "boolean",
                  dflt: !1
                },
                frameMargins: {
                  valType: "number",
                  dflt: 0,
                  min: 0,
                  max: .5
                },
                scrollZoom: {
                  valType: "flaglist",
                  flags: ["cartesian", "gl3d", "geo", "mapbox"],
                  extras: [!0, !1],
                  dflt: "gl3d+geo+mapbox"
                },
                doubleClick: {
                  valType: "enumerated",
                  values: [!1, "reset", "autosize", "reset+autosize"],
                  dflt: "reset+autosize"
                },
                doubleClickDelay: {
                  valType: "number",
                  dflt: 300,
                  min: 0
                },
                showAxisDragHandles: {
                  valType: "boolean",
                  dflt: !0
                },
                showAxisRangeEntryBoxes: {
                  valType: "boolean",
                  dflt: !0
                },
                showTips: {
                  valType: "boolean",
                  dflt: !0
                },
                showLink: {
                  valType: "boolean",
                  dflt: !1
                },
                linkText: {
                  valType: "string",
                  dflt: "Edit chart",
                  noBlank: !0
                },
                sendData: {
                  valType: "boolean",
                  dflt: !0
                },
                showSources: {
                  valType: "any",
                  dflt: !1
                },
                displayModeBar: {
                  valType: "enumerated",
                  values: ["hover", !0, !1],
                  dflt: "hover"
                },
                showSendToCloud: {
                  valType: "boolean",
                  dflt: !1
                },
                showEditInChartStudio: {
                  valType: "boolean",
                  dflt: !1
                },
                modeBarButtonsToRemove: {
                  valType: "any",
                  dflt: []
                },
                modeBarButtonsToAdd: {
                  valType: "any",
                  dflt: []
                },
                modeBarButtons: {
                  valType: "any",
                  dflt: !1
                },
                toImageButtonOptions: {
                  valType: "any",
                  dflt: {}
                },
                displaylogo: {
                  valType: "boolean",
                  dflt: !0
                },
                watermark: {
                  valType: "boolean",
                  dflt: !1
                },
                plotGlPixelRatio: {
                  valType: "number",
                  dflt: 2,
                  min: 1,
                  max: 4
                },
                setBackground: {
                  valType: "any",
                  dflt: "transparent"
                },
                topojsonURL: {
                  valType: "string",
                  noBlank: !0,
                  dflt: "https://cdn.plot.ly/"
                },
                mapboxAccessToken: {
                  valType: "string",
                  dflt: null
                },
                logging: {
                  valType: "integer",
                  min: 0,
                  max: 2,
                  dflt: 1
                },
                notifyOnLogging: {
                  valType: "integer",
                  min: 0,
                  max: 2,
                  dflt: 0
                },
                queueLength: {
                  valType: "integer",
                  min: 0,
                  dflt: 0
                },
                globalTransforms: {
                  valType: "any",
                  dflt: []
                },
                locale: {
                  valType: "string",
                  dflt: "en-US"
                },
                locales: {
                  valType: "any",
                  dflt: {}
                }
              },
              i = {};
            !function e(t, n) {
              for (var r in t) {
                var i = t[r];
                i.valType ? n[r] = i.dflt : (n[r] || (n[r] = {}), e(i, n[r]));
              }
            }(r, i), t.exports = {
              configAttributes: r,
              dfltConfig: i
            };
          }, {}],
          530: [function (e, t, n) {
            "use strict";

            var r = e("../registry"),
              i = e("../lib"),
              o = e("../plots/attributes"),
              a = e("../plots/layout_attributes"),
              s = e("../plots/frame_attributes"),
              l = e("../plots/animation_attributes"),
              u = e("./plot_config").configAttributes,
              c = e("../plots/polar/legacy/area_attributes"),
              d = e("../plots/polar/legacy/axis_attributes"),
              h = e("./edit_types"),
              f = i.extendFlat,
              p = i.extendDeepAll,
              m = i.isPlainObject,
              g = i.isArrayOrTypedArray,
              v = i.nestedProperty,
              y = i.valObjectMeta,
              b = "_isSubplotObj",
              _ = "_isLinkedToArray",
              x = [b, _, "_arrayAttrRegexps", "_deprecated"];
            function w(e, t, n) {
              if (!e) return !1;
              if (e._isLinkedToArray) if (S(t[n])) n++;else if (n < t.length) return !1;
              for (; n < t.length; n++) {
                var r = e[t[n]];
                if (!m(r)) break;
                if (e = r, n === t.length - 1) break;
                if (e._isLinkedToArray) {
                  if (!S(t[++n])) return !1;
                } else if ("info_array" === e.valType) {
                  var i = t[++n];
                  if (!S(i)) return !1;
                  var o = e.items;
                  if (Array.isArray(o)) {
                    if (i >= o.length) return !1;
                    if (2 === e.dimensions) {
                      if (n++, t.length === n) return e;
                      var a = t[n];
                      if (!S(a)) return !1;
                      e = o[i][a];
                    } else e = o[i];
                  } else e = o;
                }
              }
              return e;
            }
            function S(e) {
              return e === Math.round(e) && e >= 0;
            }
            function A() {
              var e,
                t,
                n = {};
              for (e in p(n, a), r.subplotsRegistry) if ((t = r.subplotsRegistry[e]).layoutAttributes) if (Array.isArray(t.attr)) for (var i = 0; i < t.attr.length; i++) M(n, t, t.attr[i]);else M(n, t, "subplot" === t.attr ? t.name : t.attr);
              for (e in n = function (e) {
                return f(e, {
                  radialaxis: d.radialaxis,
                  angularaxis: d.angularaxis
                }), f(e, d.layout), e;
              }(n), r.componentsRegistry) {
                var o = (t = r.componentsRegistry[e]).schema;
                if (o && (o.subplots || o.layout)) {
                  var s = o.subplots;
                  if (s && s.xaxis && !s.yaxis) for (var l in s.xaxis) delete n.yaxis[l];
                } else "colorscale" === t.name ? p(n, t.layoutAttributes) : t.layoutAttributes && C(n, t.layoutAttributes, t.name);
              }
              return {
                layoutAttributes: T(n)
              };
            }
            function E() {
              var e = {
                frames: p({}, s)
              };
              return T(e), e.frames;
            }
            function T(e) {
              return function (e) {
                n.crawl(e, function (e, t, r) {
                  n.isValObject(e) ? "data_array" === e.valType ? (e.role = "data", r[t + "src"] = {
                    valType: "string",
                    editType: "none"
                  }) : !0 === e.arrayOk && (r[t + "src"] = {
                    valType: "string",
                    editType: "none"
                  }) : m(e) && (e.role = "object");
                });
              }(e), function (e) {
                n.crawl(e, function (e, t, n) {
                  if (e) {
                    var r = e[_];
                    r && (delete e[_], n[t] = {
                      items: {}
                    }, n[t].items[r] = e, n[t].role = "object");
                  }
                });
              }(e), function (e) {
                !function e(t) {
                  for (var n in t) if (m(t[n])) e(t[n]);else if (Array.isArray(t[n])) for (var r = 0; r < t[n].length; r++) e(t[n][r]);else t[n] instanceof RegExp && (t[n] = t[n].toString());
                }(e);
              }(e), e;
            }
            function M(e, t, n) {
              var r = v(e, n),
                i = p({}, t.layoutAttributes);
              i[b] = !0, r.set(i);
            }
            function C(e, t, n) {
              var r = v(e, n);
              r.set(p(r.get() || {}, t));
            }
            n.IS_SUBPLOT_OBJ = b, n.IS_LINKED_TO_ARRAY = _, n.DEPRECATED = "_deprecated", n.UNDERSCORE_ATTRS = x, n.get = function () {
              var e = {};
              r.allTypes.concat("area").forEach(function (t) {
                e[t] = function (e) {
                  var t, i;
                  "area" === e ? (t = {
                    attributes: c
                  }, i = {}) : i = (t = r.modules[e]._module).basePlotModule;
                  var a = {
                      type: null
                    },
                    s = p({}, o),
                    l = p({}, t.attributes);
                  n.crawl(l, function (e, t, n, r, i) {
                    v(s, i).set(void 0), void 0 === e && v(l, i).set(void 0);
                  }), p(a, s), r.traceIs(e, "noOpacity") && delete a.opacity, r.traceIs(e, "showLegend") || (delete a.showlegend, delete a.legendgroup), r.traceIs(e, "noHover") && (delete a.hoverinfo, delete a.hoverlabel), t.selectPoints || delete a.selectedpoints, p(a, l), i.attributes && p(a, i.attributes), a.type = e;
                  var u = {
                    meta: t.meta || {},
                    categories: t.categories || {},
                    animatable: Boolean(t.animatable),
                    type: e,
                    attributes: T(a)
                  };
                  if (t.layoutAttributes) {
                    var d = {};
                    p(d, t.layoutAttributes), u.layoutAttributes = T(d);
                  }
                  return t.animatable || n.crawl(u, function (e) {
                    n.isValObject(e) && "anim" in e && delete e.anim;
                  }), u;
                }(t);
              });
              var t = {};
              return Object.keys(r.transformsRegistry).forEach(function (e) {
                t[e] = function (e) {
                  var t = r.transformsRegistry[e],
                    n = p({}, t.attributes);
                  return Object.keys(r.componentsRegistry).forEach(function (t) {
                    var i = r.componentsRegistry[t];
                    i.schema && i.schema.transforms && i.schema.transforms[e] && Object.keys(i.schema.transforms[e]).forEach(function (t) {
                      C(n, i.schema.transforms[e][t], t);
                    });
                  }), {
                    attributes: T(n)
                  };
                }(e);
              }), {
                defs: {
                  valObjects: y,
                  metaKeys: x.concat(["description", "role", "editType", "impliedEdits"]),
                  editType: {
                    traces: h.traces,
                    layout: h.layout
                  },
                  impliedEdits: {}
                },
                traces: e,
                layout: A(),
                transforms: t,
                frames: E(),
                animation: T(l),
                config: T(u)
              };
            }, n.crawl = function (e, t, r, i) {
              var o = r || 0;
              i = i || "", Object.keys(e).forEach(function (r) {
                var a = e[r];
                if (-1 === x.indexOf(r)) {
                  var s = (i ? i + "." : "") + r;
                  t(a, r, e, o, s), n.isValObject(a) || m(a) && "impliedEdits" !== r && n.crawl(a, t, o + 1, s);
                }
              });
            }, n.isValObject = function (e) {
              return e && void 0 !== e.valType;
            }, n.findArrayAttributes = function (e) {
              var t,
                r,
                i = [],
                a = [],
                s = [];
              function l(e, n, o, l) {
                a = a.slice(0, l).concat([n]), s = s.slice(0, l).concat([e && e._isLinkedToArray]), e && ("data_array" === e.valType || !0 === e.arrayOk) && ("colorbar" !== a[l - 1] || "ticktext" !== n && "tickvals" !== n) && function e(t, n, o) {
                  var l = t[a[n]],
                    u = o + a[n];
                  if (n === a.length - 1) g(l) && i.push(r + u);else if (s[n]) {
                    if (Array.isArray(l)) for (var c = 0; c < l.length; c++) m(l[c]) && e(l[c], n + 1, u + "[" + c + "].");
                  } else m(l) && e(l, n + 1, u + ".");
                }(t, 0, "");
              }
              t = e, r = "", n.crawl(o, l), e._module && e._module.attributes && n.crawl(e._module.attributes, l);
              var u = e.transforms;
              if (u) for (var c = 0; c < u.length; c++) {
                var d = u[c],
                  h = d._module;
                h && (r = "transforms[" + c + "].", t = d, n.crawl(h.attributes, l));
              }
              return i;
            }, n.getTraceValObject = function (e, t) {
              var n,
                i,
                a = t[0],
                s = 1;
              if ("transforms" === a) {
                if (1 === t.length) return o.transforms;
                var l = e.transforms;
                if (!Array.isArray(l) || !l.length) return !1;
                var u = t[1];
                if (!S(u) || u >= l.length) return !1;
                i = (n = (r.transformsRegistry[l[u].type] || {}).attributes) && n[t[2]], s = 3;
              } else if ("area" === e.type) i = c[a];else {
                var d = e._module;
                if (d || (d = (r.modules[e.type || o.type.dflt] || {})._module), !d) return !1;
                if (!(i = (n = d.attributes) && n[a])) {
                  var h = d.basePlotModule;
                  h && h.attributes && (i = h.attributes[a]);
                }
                i || (i = o[a]);
              }
              return w(i, t, s);
            }, n.getLayoutValObject = function (e, t) {
              return w(function (e, t) {
                var n,
                  i,
                  o,
                  s,
                  l = e._basePlotModules;
                if (l) {
                  var u;
                  for (n = 0; n < l.length; n++) {
                    if ((o = l[n]).attrRegex && o.attrRegex.test(t)) {
                      if (o.layoutAttrOverrides) return o.layoutAttrOverrides;
                      !u && o.layoutAttributes && (u = o.layoutAttributes);
                    }
                    var c = o.baseLayoutAttrOverrides;
                    if (c && t in c) return c[t];
                  }
                  if (u) return u;
                }
                var h = e._modules;
                if (h) for (n = 0; n < h.length; n++) if ((s = h[n].layoutAttributes) && t in s) return s[t];
                for (i in r.componentsRegistry) {
                  if ("colorscale" === (o = r.componentsRegistry[i]).name && 0 === t.indexOf("coloraxis")) return o.layoutAttributes[t];
                  if (!o.schema && t === o.name) return o.layoutAttributes;
                }
                return t in a ? a[t] : "radialaxis" === t || "angularaxis" === t ? d[t] : d.layout[t] || !1;
              }(e, t[0]), t, 1);
            };
          }, {
            "../lib": 495,
            "../plots/animation_attributes": 536,
            "../plots/attributes": 538,
            "../plots/frame_attributes": 568,
            "../plots/layout_attributes": 582,
            "../plots/polar/legacy/area_attributes": 585,
            "../plots/polar/legacy/axis_attributes": 586,
            "../registry": 593,
            "./edit_types": 524,
            "./plot_config": 529
          }],
          531: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("../plots/attributes"),
              o = "templateitemname",
              a = {
                name: {
                  valType: "string",
                  editType: "none"
                }
              };
            function s(e) {
              return e && "string" == typeof e;
            }
            function l(e) {
              var t = e.length - 1;
              return "s" !== e.charAt(t) && r.warn("bad argument to arrayDefaultKey: " + e), e.substr(0, e.length - 1) + "defaults";
            }
            a[o] = {
              valType: "string",
              editType: "calc"
            }, n.templatedArray = function (e, t) {
              return t._isLinkedToArray = e, t.name = a.name, t[o] = a[o], t;
            }, n.traceTemplater = function (e) {
              var t,
                n,
                o = {};
              for (t in e) n = e[t], Array.isArray(n) && n.length && (o[t] = 0);
              return {
                newTrace: function newTrace(a) {
                  var s = {
                    type: t = r.coerce(a, {}, i, "type"),
                    _template: null
                  };
                  if (t in o) {
                    n = e[t];
                    var l = o[t] % n.length;
                    o[t]++, s._template = n[l];
                  }
                  return s;
                }
              };
            }, n.newContainer = function (e, t, n) {
              var i = e._template,
                o = i && (i[t] || n && i[n]);
              return r.isPlainObject(o) || (o = null), e[t] = {
                _template: o
              };
            }, n.arrayTemplater = function (e, t, n) {
              var r = e._template,
                i = r && r[l(t)],
                a = r && r[t];
              Array.isArray(a) && a.length || (a = []);
              var u = {};
              return {
                newItem: function newItem(e) {
                  var t = {
                      name: e.name,
                      _input: e
                    },
                    r = t[o] = e[o];
                  if (!s(r)) return t._template = i, t;
                  for (var l = 0; l < a.length; l++) {
                    var c = a[l];
                    if (c.name === r) return u[r] = 1, t._template = c, t;
                  }
                  return t[n] = e[n] || !1, t._template = !1, t;
                },
                defaultItems: function defaultItems() {
                  for (var e = [], t = 0; t < a.length; t++) {
                    var n = a[t],
                      r = n.name;
                    if (s(r) && !u[r]) {
                      var i = {
                        _template: n,
                        name: r,
                        _input: {
                          _templateitemname: r
                        }
                      };
                      i[o] = n[o], e.push(i), u[r] = 1;
                    }
                  }
                  return e;
                }
              };
            }, n.arrayDefaultKey = l, n.arrayEditor = function (e, t, n) {
              var i = (r.nestedProperty(e, t).get() || []).length,
                a = n._index,
                s = a >= i && (n._input || {})._templateitemname;
              s && (a = i);
              var l,
                u = t + "[" + a + "]";
              function c() {
                l = {}, s && (l[u] = {}, l[u][o] = s);
              }
              function d(e, t) {
                s ? r.nestedProperty(l[u], e).set(t) : l[u + "." + e] = t;
              }
              function h() {
                var e = l;
                return c(), e;
              }
              return c(), {
                modifyBase: function modifyBase(e, t) {
                  l[e] = t;
                },
                modifyItem: d,
                getUpdateObj: h,
                applyUpdate: function applyUpdate(t, n) {
                  t && d(t, n);
                  var i = h();
                  for (var o in i) r.nestedProperty(e, o).set(i[o]);
                }
              };
            };
          }, {
            "../lib": 495,
            "../plots/attributes": 538
          }],
          532: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../registry"),
              o = e("../plots/plots"),
              a = e("../lib"),
              s = e("../lib/clear_gl_canvases"),
              l = e("../components/color"),
              u = e("../components/drawing"),
              c = e("../components/titles"),
              d = e("../components/modebar"),
              h = e("../plots/cartesian/axes"),
              f = e("../constants/alignment"),
              p = e("../plots/cartesian/constraints"),
              m = p.enforce,
              g = p.clean,
              v = e("../plots/cartesian/autorange").doAutoRange,
              y = "start";
            function b(e, t, n) {
              for (var r = 0; r < n.length; r++) {
                var i = n[r][0],
                  o = n[r][1];
                if (!(i[0] >= e[1] || i[1] <= e[0]) && o[0] < t[1] && o[1] > t[0]) return !0;
              }
              return !1;
            }
            function _(e) {
              var t,
                i,
                s,
                c,
                p,
                m,
                g = e._fullLayout,
                v = g._size,
                y = v.p,
                _ = h.list(e, "", !0);
              if (g._paperdiv.style({
                width: e._context.responsive && g.autosize && !e._context._hasZeroWidth && !e.layout.width ? "100%" : g.width + "px",
                height: e._context.responsive && g.autosize && !e._context._hasZeroHeight && !e.layout.height ? "100%" : g.height + "px"
              }).selectAll(".main-svg").call(u.setSize, g.width, g.height), e._context.setBackground(e, g.paper_bgcolor), n.drawMainTitle(e), d.manage(e), !g._has("cartesian")) return o.previousPromises(e);
              function w(e, t, n) {
                var r = e._lw / 2;
                return "x" === e._id.charAt(0) ? t ? "top" === n ? t._offset - y - r : t._offset + t._length + y + r : v.t + v.h * (1 - (e.position || 0)) + r % 1 : t ? "right" === n ? t._offset + t._length + y + r : t._offset - y - r : v.l + v.w * (e.position || 0) + r % 1;
              }
              for (t = 0; t < _.length; t++) {
                var A = (c = _[t])._anchorAxis;
                c._linepositions = {}, c._lw = u.crispRound(e, c.linewidth, 1), c._mainLinePosition = w(c, A, c.side), c._mainMirrorPosition = c.mirror && A ? w(c, A, f.OPPOSITE_SIDE[c.side]) : null;
              }
              var E = [],
                T = [],
                M = [],
                C = 1 === l.opacity(g.paper_bgcolor) && 1 === l.opacity(g.plot_bgcolor) && g.paper_bgcolor === g.plot_bgcolor;
              for (i in g._plots) if ((s = g._plots[i]).mainplot) s.bg && s.bg.remove(), s.bg = void 0;else {
                var k = s.xaxis.domain,
                  P = s.yaxis.domain,
                  O = s.plotgroup;
                if (b(k, P, M)) {
                  var R = O.node(),
                    I = s.bg = a.ensureSingle(O, "rect", "bg");
                  R.insertBefore(I.node(), R.childNodes[0]), T.push(i);
                } else O.select("rect.bg").remove(), M.push([k, P]), C || (E.push(i), T.push(i));
              }
              var j,
                N,
                L,
                D,
                B,
                F,
                z,
                U,
                G,
                V,
                H,
                q,
                W,
                $ = g._bgLayer.selectAll(".bg").data(E);
              for ($.enter().append("rect").classed("bg", !0), $.exit().remove(), $.each(function (e) {
                g._plots[e].bg = r.select(this);
              }), t = 0; t < T.length; t++) s = g._plots[T[t]], p = s.xaxis, m = s.yaxis, s.bg && s.bg.call(u.setRect, p._offset - y, m._offset - y, p._length + 2 * y, m._length + 2 * y).call(l.fill, g.plot_bgcolor).style("stroke-width", 0);
              if (!g._hasOnlyLargeSploms) for (i in g._plots) {
                s = g._plots[i], p = s.xaxis, m = s.yaxis;
                var X,
                  Y,
                  K = s.clipId = "clip" + g._uid + i + "plot",
                  Z = a.ensureSingleById(g._clips, "clipPath", K, function (e) {
                    e.classed("plotclip", !0).append("rect");
                  });
                s.clipRect = Z.select("rect").attr({
                  width: p._length,
                  height: m._length
                }), u.setTranslate(s.plot, p._offset, m._offset), s._hasClipOnAxisFalse ? (X = null, Y = K) : (X = K, Y = null), u.setClipUrl(s.plot, X, e), s.layerClipId = Y;
              }
              function Q(e) {
                return "M" + j + "," + e + "H" + N;
              }
              function J(e) {
                return "M" + p._offset + "," + e + "h" + p._length;
              }
              function ee(e) {
                return "M" + e + "," + U + "V" + z;
              }
              function te(e) {
                return "M" + e + "," + m._offset + "v" + m._length;
              }
              function ne(e, t, n) {
                if (!e.showline || i !== e._mainSubplot) return "";
                if (!e._anchorAxis) return n(e._mainLinePosition);
                var r = t(e._mainLinePosition);
                return e.mirror && (r += t(e._mainMirrorPosition)), r;
              }
              for (i in g._plots) {
                s = g._plots[i], p = s.xaxis, m = s.yaxis;
                var re = "M0,0";
                x(p, i) && (B = S(p, "left", m, _), j = p._offset - (B ? y + B : 0), F = S(p, "right", m, _), N = p._offset + p._length + (F ? y + F : 0), L = w(p, m, "bottom"), D = w(p, m, "top"), !(W = !p._anchorAxis || i !== p._mainSubplot) || "allticks" !== p.mirror && "all" !== p.mirror || (p._linepositions[i] = [L, D]), re = ne(p, Q, J), W && p.showline && ("all" === p.mirror || "allticks" === p.mirror) && (re += Q(L) + Q(D)), s.xlines.style("stroke-width", p._lw + "px").call(l.stroke, p.showline ? p.linecolor : "rgba(0,0,0,0)")), s.xlines.attr("d", re);
                var ie = "M0,0";
                x(m, i) && (H = S(m, "bottom", p, _), z = m._offset + m._length + (H ? y : 0), q = S(m, "top", p, _), U = m._offset - (q ? y : 0), G = w(m, p, "left"), V = w(m, p, "right"), !(W = !m._anchorAxis || i !== m._mainSubplot) || "allticks" !== m.mirror && "all" !== m.mirror || (m._linepositions[i] = [G, V]), ie = ne(m, ee, te), W && m.showline && ("all" === m.mirror || "allticks" === m.mirror) && (ie += ee(G) + ee(V)), s.ylines.style("stroke-width", m._lw + "px").call(l.stroke, m.showline ? m.linecolor : "rgba(0,0,0,0)")), s.ylines.attr("d", ie);
              }
              return h.makeClipPaths(e), o.previousPromises(e);
            }
            function x(e, t) {
              return (e.ticks || e.showline) && (t === e._mainSubplot || "all" === e.mirror || "allticks" === e.mirror);
            }
            function w(e, t, n) {
              if (!n.showline || !n._lw) return !1;
              if ("all" === n.mirror || "allticks" === n.mirror) return !0;
              var r = n._anchorAxis;
              if (!r) return !1;
              var i = f.FROM_BL[t];
              return n.side === t ? r.domain[i] === e.domain[i] : n.mirror && r.domain[1 - i] === e.domain[1 - i];
            }
            function S(e, t, n, r) {
              if (w(e, t, n)) return n._lw;
              for (var i = 0; i < r.length; i++) {
                var o = r[i];
                if (o._mainAxis === n._mainAxis && w(e, t, o)) return o._lw;
              }
              return 0;
            }
            function A(e, t) {
              var n = e.title,
                r = e._size,
                i = 0;
              switch (t === y ? i = n.pad.l : "end" === t && (i = -n.pad.r), n.xref) {
                case "paper":
                  return r.l + r.w * n.x + i;
                case "container":
                default:
                  return e.width * n.x + i;
              }
            }
            function E(e, t) {
              var n = e.title,
                r = e._size,
                i = 0;
              if ("0em" !== t && t ? t === f.CAP_SHIFT + "em" && (i = n.pad.t) : i = -n.pad.b, "auto" === n.y) return r.t / 2;
              switch (n.yref) {
                case "paper":
                  return r.t + r.h - r.h * n.y + i;
                case "container":
                default:
                  return e.height - e.height * n.y + i;
              }
            }
            n.layoutStyles = function (e) {
              return a.syncOrAsync([o.doAutoMargin, _], e);
            }, n.drawMainTitle = function (e) {
              var t = e._fullLayout,
                n = function (e) {
                  var t = e.title,
                    n = "middle";
                  return a.isRightAnchor(t) ? n = "end" : a.isLeftAnchor(t) && (n = y), n;
                }(t),
                r = function (e) {
                  var t = e.title,
                    n = "0em";
                  return a.isTopAnchor(t) ? n = f.CAP_SHIFT + "em" : a.isMiddleAnchor(t) && (n = f.MID_SHIFT + "em"), n;
                }(t);
              c.draw(e, "gtitle", {
                propContainer: t,
                propName: "title.text",
                placeholder: t._dfltTitle.plot,
                attributes: {
                  x: A(t, n),
                  y: E(t, r),
                  "text-anchor": n,
                  dy: r
                }
              });
            }, n.doTraceStyle = function (e) {
              var t,
                r = e.calcdata,
                a = [];
              for (t = 0; t < r.length; t++) {
                var l = r[t],
                  u = l[0] || {},
                  c = u.trace || {},
                  d = c._module || {},
                  h = d.arraysToCalcdata;
                h && h(l, c);
                var f = d.editStyle;
                f && a.push({
                  fn: f,
                  cd0: u
                });
              }
              if (a.length) {
                for (t = 0; t < a.length; t++) {
                  var p = a[t];
                  p.fn(e, p.cd0);
                }
                s(e), n.redrawReglTraces(e);
              }
              return o.style(e), i.getComponentMethod("legend", "draw")(e), o.previousPromises(e);
            }, n.doColorBars = function (e) {
              return i.getComponentMethod("colorbar", "draw")(e), o.previousPromises(e);
            }, n.layoutReplot = function (e) {
              var t = e.layout;
              return e.layout = void 0, i.call("plot", e, "", t);
            }, n.doLegend = function (e) {
              return i.getComponentMethod("legend", "draw")(e), o.previousPromises(e);
            }, n.doTicksRelayout = function (e) {
              return h.draw(e, "redraw"), e._fullLayout._hasOnlyLargeSploms && (i.subplotsRegistry.splom.updateGrid(e), s(e), n.redrawReglTraces(e)), n.drawMainTitle(e), o.previousPromises(e);
            }, n.doModeBar = function (e) {
              var t = e._fullLayout;
              d.manage(e);
              for (var n = 0; n < t._basePlotModules.length; n++) {
                var r = t._basePlotModules[n].updateFx;
                r && r(e);
              }
              return o.previousPromises(e);
            }, n.doCamera = function (e) {
              for (var t = e._fullLayout, n = t._subplots.gl3d, r = 0; r < n.length; r++) {
                var i = t[n[r]];
                i._scene.setViewport(i);
              }
            }, n.drawData = function (e) {
              var t = e._fullLayout;
              s(e);
              for (var r = t._basePlotModules, a = 0; a < r.length; a++) r[a].plot(e);
              return n.redrawReglTraces(e), o.style(e), i.getComponentMethod("shapes", "draw")(e), i.getComponentMethod("annotations", "draw")(e), i.getComponentMethod("images", "draw")(e), t._replotting = !1, o.previousPromises(e);
            }, n.redrawReglTraces = function (e) {
              var t = e._fullLayout;
              if (t._has("regl")) {
                var n,
                  r,
                  i = e._fullData,
                  o = [],
                  s = [];
                for (t._hasOnlyLargeSploms && t._splomGrid.draw(), n = 0; n < i.length; n++) {
                  var l = i[n];
                  !0 === l.visible && 0 !== l._length && ("splom" === l.type ? t._splomScenes[l.uid].draw() : "scattergl" === l.type ? a.pushUnique(o, l.xaxis + l.yaxis) : "scatterpolargl" === l.type && a.pushUnique(s, l.subplot));
                }
                for (n = 0; n < o.length; n++) (r = t._plots[o[n]])._scene && r._scene.draw();
                for (n = 0; n < s.length; n++) (r = t[s[n]]._subplot)._scene && r._scene.draw();
              }
            }, n.doAutoRangeAndConstraints = function (e) {
              for (var t, n, r = e._fullLayout, i = h.list(e, "", !0), o = r._axisMatchGroups || [], s = {}, l = 0; l < i.length; l++) t = i[l], g(e, t), v(e, t), s[t._id] = 1;
              m(e);
              e: for (var u = 0; u < o.length; u++) {
                var c,
                  d = o[u],
                  f = null;
                for (c in d) if (s[(t = h.getFromId(e, c))._id]) {
                  if (!1 === t.autorange) continue e;
                  n = a.simpleMap(t.range, t.r2l), f ? f[0] < f[1] ? (f[0] = Math.min(f[0], n[0]), f[1] = Math.max(f[1], n[1])) : (f[0] = Math.max(f[0], n[0]), f[1] = Math.min(f[1], n[1])) : f = n;
                }
                for (c in d) (t = h.getFromId(e, c)).range = a.simpleMap(f, t.l2r), t._input.range = t.range.slice(), t.setScale();
              }
            }, n.finalDraw = function (e) {
              i.getComponentMethod("rangeslider", "draw")(e), i.getComponentMethod("rangeselector", "draw")(e);
            }, n.drawMarginPushers = function (e) {
              i.getComponentMethod("legend", "draw")(e), i.getComponentMethod("rangeselector", "draw")(e), i.getComponentMethod("sliders", "draw")(e), i.getComponentMethod("updatemenus", "draw")(e), i.getComponentMethod("colorbar", "draw")(e);
            };
          }, {
            "../components/color": 375,
            "../components/drawing": 396,
            "../components/modebar": 433,
            "../components/titles": 462,
            "../constants/alignment": 469,
            "../lib": 495,
            "../lib/clear_gl_canvases": 483,
            "../plots/cartesian/autorange": 540,
            "../plots/cartesian/axes": 541,
            "../plots/cartesian/constraints": 548,
            "../plots/plots": 584,
            "../registry": 593,
            d3: 82
          }],
          533: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = r.isPlainObject,
              o = e("./plot_schema"),
              a = e("../plots/plots"),
              s = e("../plots/attributes"),
              l = e("./plot_template"),
              u = e("./plot_config").dfltConfig;
            function c(e, t) {
              e = r.extendDeep({}, e);
              var n,
                o,
                a = Object.keys(e).sort();
              function s(t, n, r) {
                if (i(n) && i(t)) c(t, n);else if (Array.isArray(n) && Array.isArray(t)) {
                  var a = l.arrayTemplater({
                    _template: e
                  }, r);
                  for (o = 0; o < n.length; o++) {
                    var s = n[o],
                      u = a.newItem(s)._template;
                    u && c(u, s);
                  }
                  var d = a.defaultItems();
                  for (o = 0; o < d.length; o++) n.push(d[o]._template);
                  for (o = 0; o < n.length; o++) delete n[o].templateitemname;
                }
              }
              for (n = 0; n < a.length; n++) {
                var u = a[n],
                  h = e[u];
                if (u in t ? s(h, t[u], u) : t[u] = h, d(u) === u) for (var f in t) {
                  var p = d(f);
                  f === p || p !== u || f in e || s(h, t[f], u);
                }
              }
            }
            function d(e) {
              return e.replace(/[0-9]+$/, "");
            }
            function h(e, t, n, o, a) {
              var s = a && n(a);
              for (var u in e) {
                var c = e[u],
                  p = f(e, u, o),
                  m = f(e, u, a),
                  g = n(m);
                if (!g) {
                  var v = d(u);
                  v !== u && (g = n(m = f(e, v, a)));
                }
                if (!(s && s === g || !g || g._noTemplating || "data_array" === g.valType || g.arrayOk && Array.isArray(c))) if (!g.valType && i(c)) h(c, t, n, p, m);else if (g._isLinkedToArray && Array.isArray(c)) for (var y = !1, b = 0, _ = {}, x = 0; x < c.length; x++) {
                  var w = c[x];
                  if (i(w)) {
                    var S = w.name;
                    if (S) _[S] || (h(w, t, n, f(c, b, p), f(c, b, m)), b++, _[S] = 1);else if (!y) {
                      var A = f(e, l.arrayDefaultKey(u), o),
                        E = f(c, b, p);
                      h(w, t, n, E, f(c, b, m));
                      var T = r.nestedProperty(t, E);
                      r.nestedProperty(t, A).set(T.get()), T.set(null), y = !0;
                    }
                  }
                } else r.nestedProperty(t, p).set(c);
              }
            }
            function f(e, t, n) {
              return n ? Array.isArray(e) ? n + "[" + t + "]" : n + "." + t : t;
            }
            function p(e) {
              for (var t = 0; t < e.length; t++) if (i(e[t])) return !0;
            }
            function m(e) {
              var t;
              switch (e.code) {
                case "data":
                  t = "The template has no key data.";
                  break;
                case "layout":
                  t = "The template has no key layout.";
                  break;
                case "missing":
                  t = e.path ? "There are no templates for item " + e.path + " with name " + e.templateitemname : "There are no templates for trace " + e.index + ", of type " + e.traceType + ".";
                  break;
                case "unused":
                  t = e.path ? "The template item at " + e.path + " was not used in constructing the plot." : e.dataCount ? "Some of the templates of type " + e.traceType + " were not used. The template has " + e.templateCount + " traces, the data only has " + e.dataCount + " of this type." : "The template has " + e.templateCount + " traces of type " + e.traceType + " but there are none in the data.";
                  break;
                case "reused":
                  t = "Some of the templates of type " + e.traceType + " were used more than once. The template has " + e.templateCount + " traces, the data has " + e.dataCount + " of this type.";
              }
              return e.msg = t, e;
            }
            n.makeTemplate = function (e) {
              e = r.isPlainObject(e) ? e : r.getGraphDiv(e), e = r.extendDeep({
                _context: u
              }, {
                data: e.data,
                layout: e.layout
              }), a.supplyDefaults(e);
              var t = e.data || [],
                n = e.layout || {};
              n._basePlotModules = e._fullLayout._basePlotModules, n._modules = e._fullLayout._modules;
              var l = {
                data: {},
                layout: {}
              };
              t.forEach(function (e) {
                var t = {};
                h(e, t, function (e, t) {
                  return o.getTraceValObject(e, r.nestedProperty({}, t).parts);
                }.bind(null, e));
                var n = r.coerce(e, {}, s, "type"),
                  i = l.data[n];
                i || (i = l.data[n] = []), i.push(t);
              }), h(n, l.layout, function (e, t) {
                return o.getLayoutValObject(e, r.nestedProperty({}, t).parts);
              }.bind(null, n)), delete l.layout.template;
              var d = n.template;
              if (i(d)) {
                var f,
                  p,
                  m,
                  g,
                  v,
                  y,
                  b = d.layout;
                i(b) && c(b, l.layout);
                var _ = d.data;
                if (i(_)) {
                  for (p in l.data) if (m = _[p], Array.isArray(m)) {
                    for (y = (v = l.data[p]).length, g = m.length, f = 0; f < y; f++) c(m[f % g], v[f]);
                    for (f = y; f < g; f++) v.push(r.extendDeep({}, m[f]));
                  }
                  for (p in _) p in l.data || (l.data[p] = r.extendDeep([], _[p]));
                }
              }
              return l;
            }, n.validateTemplate = function (e, t) {
              var n = r.extendDeep({}, {
                  _context: u,
                  data: e.data,
                  layout: e.layout
                }),
                o = n.layout || {};
              i(t) || (t = o.template || {});
              var s = t.layout,
                l = t.data,
                c = [];
              n.layout = o, n.layout.template = t, a.supplyDefaults(n);
              var h = n._fullLayout,
                g = n._fullData,
                v = {};
              if (i(s) ? (function e(t, n) {
                for (var r in t) if ("_" !== r.charAt(0) && i(t[r])) {
                  var o,
                    a = d(r),
                    s = [];
                  for (o = 0; o < n.length; o++) s.push(f(t, r, n[o])), a !== r && s.push(f(t, a, n[o]));
                  for (o = 0; o < s.length; o++) v[s[o]] = 1;
                  e(t[r], s);
                }
              }(h, ["layout"]), function e(t, n) {
                for (var r in t) if (-1 === r.indexOf("defaults") && i(t[r])) {
                  var o = f(t, r, n);
                  v[o] ? e(t[r], o) : c.push({
                    code: "unused",
                    path: o
                  });
                }
              }(s, "layout")) : c.push({
                code: "layout"
              }), i(l)) {
                for (var y, b = {}, _ = 0; _ < g.length; _++) {
                  var x = g[_];
                  b[y = x.type] = (b[y] || 0) + 1, x._fullInput._template || c.push({
                    code: "missing",
                    index: x._fullInput.index,
                    traceType: y
                  });
                }
                for (y in l) {
                  var w = l[y].length,
                    S = b[y] || 0;
                  w > S ? c.push({
                    code: "unused",
                    traceType: y,
                    templateCount: w,
                    dataCount: S
                  }) : S > w && c.push({
                    code: "reused",
                    traceType: y,
                    templateCount: w,
                    dataCount: S
                  });
                }
              } else c.push({
                code: "data"
              });
              if (function e(t, n) {
                for (var r in t) if ("_" !== r.charAt(0)) {
                  var o = t[r],
                    a = f(t, r, n);
                  i(o) ? (Array.isArray(t) && !1 === o._template && o.templateitemname && c.push({
                    code: "missing",
                    path: a,
                    templateitemname: o.templateitemname
                  }), e(o, a)) : Array.isArray(o) && p(o) && e(o, a);
                }
              }({
                data: g,
                layout: h
              }, ""), c.length) return c.map(m);
            };
          }, {
            "../lib": 495,
            "../plots/attributes": 538,
            "../plots/plots": 584,
            "./plot_config": 529,
            "./plot_schema": 530,
            "./plot_template": 531
          }],
          534: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("./plot_api"),
              o = e("../lib"),
              a = e("../snapshot/helpers"),
              s = e("../snapshot/tosvg"),
              l = e("../snapshot/svgtoimg"),
              u = {
                format: {
                  valType: "enumerated",
                  values: ["png", "jpeg", "webp", "svg"],
                  dflt: "png"
                },
                width: {
                  valType: "number",
                  min: 1
                },
                height: {
                  valType: "number",
                  min: 1
                },
                scale: {
                  valType: "number",
                  min: 0,
                  dflt: 1
                },
                setBackground: {
                  valType: "any",
                  dflt: !1
                },
                imageDataOnly: {
                  valType: "boolean",
                  dflt: !1
                }
              };
            t.exports = function (e, t) {
              var n, c, d, h;
              function f(e) {
                return !(e in t) || o.validate(t[e], u[e]);
              }
              if (t = t || {}, o.isPlainObject(e) ? (n = e.data || [], c = e.layout || {}, d = e.config || {}, h = {}) : (e = o.getGraphDiv(e), n = o.extendDeep([], e.data), c = o.extendDeep({}, e.layout), d = e._context, h = e._fullLayout || {}), !f("width") && null !== t.width || !f("height") && null !== t.height) throw new Error("Height and width should be pixel values.");
              if (!f("format")) throw new Error("Image format is not jpeg, png, svg or webp.");
              var p = {};
              function m(e, n) {
                return o.coerce(t, p, u, e, n);
              }
              var g = m("format"),
                v = m("width"),
                y = m("height"),
                b = m("scale"),
                _ = m("setBackground"),
                x = m("imageDataOnly"),
                w = document.createElement("div");
              w.style.position = "absolute", w.style.left = "-5000px", document.body.appendChild(w);
              var S = o.extendFlat({}, c);
              v ? S.width = v : null === t.width && r(h.width) && (S.width = h.width), y ? S.height = y : null === t.height && r(h.height) && (S.height = h.height);
              var A = o.extendFlat({}, d, {
                  _exportedPlot: !0,
                  staticPlot: !0,
                  setBackground: _
                }),
                E = a.getRedrawFunc(w);
              function T() {
                return new Promise(function (e) {
                  setTimeout(e, a.getDelay(w._fullLayout));
                });
              }
              function M() {
                return new Promise(function (e, t) {
                  var n = s(w, g, b),
                    r = w._fullLayout.width,
                    u = w._fullLayout.height;
                  if (i.purge(w), document.body.removeChild(w), "svg" === g) return e(x ? n : a.encodeSVG(n));
                  var c = document.createElement("canvas");
                  c.id = o.randstr(), l({
                    format: g,
                    width: r,
                    height: u,
                    scale: b,
                    canvas: c,
                    svg: n,
                    promise: !0
                  }).then(e).catch(t);
                });
              }
              return new Promise(function (e, t) {
                i.plot(w, n, S, A).then(E).then(T).then(M).then(function (t) {
                  e(function (e) {
                    return x ? e.replace(a.IMAGE_URL_PREFIX, "") : e;
                  }(t));
                }).catch(function (e) {
                  t(e);
                });
              });
            };
          }, {
            "../lib": 495,
            "../snapshot/helpers": 597,
            "../snapshot/svgtoimg": 599,
            "../snapshot/tosvg": 601,
            "./plot_api": 528,
            "fast-isnumeric": 91
          }],
          535: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("../plots/plots"),
              o = e("./plot_schema"),
              a = e("./plot_config").dfltConfig,
              s = r.isPlainObject,
              l = Array.isArray,
              u = r.isArrayOrTypedArray;
            function c(e, t, n, i, o, a) {
              a = a || [];
              for (var d = Object.keys(e), h = 0; h < d.length; h++) {
                var g = d[h];
                if ("transforms" !== g) {
                  var v = a.slice();
                  v.push(g);
                  var y = e[g],
                    b = t[g],
                    _ = m(n, g),
                    x = (_ || {}).valType,
                    w = "info_array" === x,
                    S = "colorscale" === x,
                    A = (_ || {}).items;
                  if (p(n, g)) {
                    if (s(y) && s(b) && "any" !== x) c(y, b, _, i, o, v);else if (w && l(y)) {
                      y.length > b.length && i.push(f("unused", o, v.concat(b.length)));
                      var E,
                        T,
                        M,
                        C,
                        k,
                        P = b.length,
                        O = Array.isArray(A);
                      if (O && (P = Math.min(P, A.length)), 2 === _.dimensions) {
                        for (T = 0; T < P; T++) if (l(y[T])) {
                          y[T].length > b[T].length && i.push(f("unused", o, v.concat(T, b[T].length)));
                          var R = b[T].length;
                          for (E = 0; E < (O ? Math.min(R, A[T].length) : R); E++) M = O ? A[T][E] : A, C = y[T][E], k = b[T][E], r.validate(C, M) ? k !== C && k !== +C && i.push(f("dynamic", o, v.concat(T, E), C, k)) : i.push(f("value", o, v.concat(T, E), C));
                        } else i.push(f("array", o, v.concat(T), y[T]));
                      } else for (T = 0; T < P; T++) M = O ? A[T] : A, C = y[T], k = b[T], r.validate(C, M) ? k !== C && k !== +C && i.push(f("dynamic", o, v.concat(T), C, k)) : i.push(f("value", o, v.concat(T), C));
                    } else if (_.items && !w && l(y)) {
                      var I,
                        j,
                        N = A[Object.keys(A)[0]],
                        L = [];
                      for (I = 0; I < b.length; I++) {
                        var D = b[I]._index || I;
                        if ((j = v.slice()).push(D), s(y[D]) && s(b[I])) {
                          L.push(D);
                          var B = y[D],
                            F = b[I];
                          s(B) && !1 !== B.visible && !1 === F.visible ? i.push(f("invisible", o, j)) : c(B, F, N, i, o, j);
                        }
                      }
                      for (I = 0; I < y.length; I++) (j = v.slice()).push(I), s(y[I]) ? -1 === L.indexOf(I) && i.push(f("unused", o, j)) : i.push(f("object", o, j, y[I]));
                    } else !s(y) && s(b) ? i.push(f("object", o, v, y)) : u(y) || !u(b) || w || S ? g in t ? r.validate(y, _) ? "enumerated" === _.valType && (_.coerceNumber && y !== +b || y !== b) && i.push(f("dynamic", o, v, y, b)) : i.push(f("value", o, v, y)) : i.push(f("unused", o, v, y)) : i.push(f("array", o, v, y));
                  } else i.push(f("schema", o, v));
                }
              }
              return i;
            }
            t.exports = function (e, t) {
              var n,
                u,
                d = o.get(),
                h = [],
                p = {
                  _context: r.extendFlat({}, a)
                };
              l(e) ? (p.data = r.extendDeep([], e), n = e) : (p.data = [], n = [], h.push(f("array", "data"))), s(t) ? (p.layout = r.extendDeep({}, t), u = t) : (p.layout = {}, u = {}, arguments.length > 1 && h.push(f("object", "layout"))), i.supplyDefaults(p);
              for (var m = p._fullData, g = n.length, v = 0; v < g; v++) {
                var y = n[v],
                  b = ["data", v];
                if (s(y)) {
                  var _ = m[v],
                    x = _.type,
                    w = d.traces[x].attributes;
                  w.type = {
                    valType: "enumerated",
                    values: [x]
                  }, !1 === _.visible && !1 !== y.visible && h.push(f("invisible", b)), c(y, _, w, h, b);
                  var S = y.transforms,
                    A = _.transforms;
                  if (S) {
                    l(S) || h.push(f("array", b, ["transforms"])), b.push("transforms");
                    for (var E = 0; E < S.length; E++) {
                      var T = ["transforms", E],
                        M = S[E].type;
                      if (s(S[E])) {
                        var C = d.transforms[M] ? d.transforms[M].attributes : {};
                        C.type = {
                          valType: "enumerated",
                          values: Object.keys(d.transforms)
                        }, c(S[E], A[E], C, h, b, T);
                      } else h.push(f("object", b, T));
                    }
                  }
                } else h.push(f("object", b));
              }
              return c(u, p._fullLayout, function (e, t) {
                for (var n = e.layout.layoutAttributes, i = 0; i < t.length; i++) {
                  var o = t[i],
                    a = e.traces[o.type],
                    s = a.layoutAttributes;
                  s && (o.subplot ? r.extendFlat(n[a.attributes.subplot.dflt], s) : r.extendFlat(n, s));
                }
                return n;
              }(d, m), h, "layout"), 0 === h.length ? void 0 : h;
            };
            var d = {
              object: function object(e, t) {
                return ("layout" === e && "" === t ? "The layout argument" : "data" === e[0] && "" === t ? "Trace " + e[1] + " in the data argument" : h(e) + "key " + t) + " must be linked to an object container";
              },
              array: function array(e, t) {
                return ("data" === e ? "The data argument" : h(e) + "key " + t) + " must be linked to an array container";
              },
              schema: function schema(e, t) {
                return h(e) + "key " + t + " is not part of the schema";
              },
              unused: function unused(e, t, n) {
                var r = s(n) ? "container" : "key";
                return h(e) + r + " " + t + " did not get coerced";
              },
              dynamic: function dynamic(e, t, n, r) {
                return [h(e) + "key", t, "(set to '" + n + "')", "got reset to", "'" + r + "'", "during defaults."].join(" ");
              },
              invisible: function invisible(e, t) {
                return (t ? h(e) + "item " + t : "Trace " + e[1]) + " got defaulted to be not visible";
              },
              value: function value(e, t, n) {
                return [h(e) + "key " + t, "is set to an invalid value (" + n + ")"].join(" ");
              }
            };
            function h(e) {
              return l(e) ? "In data trace " + e[1] + ", " : "In " + e + ", ";
            }
            function f(e, t, n, i, o) {
              var a, s;
              n = n || "", l(t) ? (a = t[0], s = t[1]) : (a = t, s = null);
              var u = function (e) {
                  if (!l(e)) return String(e);
                  for (var t = "", n = 0; n < e.length; n++) {
                    var r = e[n];
                    "number" == typeof r ? t = t.substr(0, t.length - 1) + "[" + r + "]" : t += r, n < e.length - 1 && (t += ".");
                  }
                  return t;
                }(n),
                c = d[e](t, u, i, o);
              return r.log(c), {
                code: e,
                container: a,
                trace: s,
                path: n,
                astr: u,
                msg: c
              };
            }
            function p(e, t) {
              var n = v(t),
                r = n.keyMinusId,
                i = n.id;
              return !!(r in e && e[r]._isSubplotObj && i) || t in e;
            }
            function m(e, t) {
              return t in e ? e[t] : e[v(t).keyMinusId];
            }
            var g = r.counterRegex("([a-z]+)");
            function v(e) {
              var t = e.match(g);
              return {
                keyMinusId: t && t[1],
                id: t && t[2]
              };
            }
          }, {
            "../lib": 495,
            "../plots/plots": 584,
            "./plot_config": 529,
            "./plot_schema": 530
          }],
          536: [function (e, t, n) {
            "use strict";

            t.exports = {
              mode: {
                valType: "enumerated",
                dflt: "afterall",
                values: ["immediate", "next", "afterall"]
              },
              direction: {
                valType: "enumerated",
                values: ["forward", "reverse"],
                dflt: "forward"
              },
              fromcurrent: {
                valType: "boolean",
                dflt: !1
              },
              frame: {
                duration: {
                  valType: "number",
                  min: 0,
                  dflt: 500
                },
                redraw: {
                  valType: "boolean",
                  dflt: !0
                }
              },
              transition: {
                duration: {
                  valType: "number",
                  min: 0,
                  dflt: 500,
                  editType: "none"
                },
                easing: {
                  valType: "enumerated",
                  dflt: "cubic-in-out",
                  values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"],
                  editType: "none"
                },
                ordering: {
                  valType: "enumerated",
                  values: ["layout first", "traces first"],
                  dflt: "layout first",
                  editType: "none"
                }
              }
            };
          }, {}],
          537: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("../plot_api/plot_template");
            t.exports = function (e, t, n) {
              var o,
                a,
                s = n.name,
                l = n.inclusionAttr || "visible",
                u = t[s],
                c = r.isArrayOrTypedArray(e[s]) ? e[s] : [],
                d = t[s] = [],
                h = i.arrayTemplater(t, s, l);
              for (o = 0; o < c.length; o++) {
                var f = c[o];
                r.isPlainObject(f) ? a = h.newItem(f) : (a = h.newItem({}))[l] = !1, a._index = o, !1 !== a[l] && n.handleItemDefaults(f, a, t, n), d.push(a);
              }
              var p = h.defaultItems();
              for (o = 0; o < p.length; o++) (a = p[o])._index = d.length, n.handleItemDefaults({}, a, t, n, {}), d.push(a);
              if (r.isArrayOrTypedArray(u)) {
                var m = Math.min(u.length, d.length);
                for (o = 0; o < m; o++) r.relinkPrivateKeys(d[o], u[o]);
              }
              return d;
            };
          }, {
            "../lib": 495,
            "../plot_api/plot_template": 531
          }],
          538: [function (e, t, n) {
            "use strict";

            var r = e("../components/fx/attributes");
            t.exports = {
              type: {
                valType: "enumerated",
                values: [],
                dflt: "scatter",
                editType: "calc+clearAxisTypes",
                _noTemplating: !0
              },
              visible: {
                valType: "enumerated",
                values: [!0, !1, "legendonly"],
                dflt: !0,
                editType: "calc"
              },
              showlegend: {
                valType: "boolean",
                dflt: !0,
                editType: "style"
              },
              legendgroup: {
                valType: "string",
                dflt: "",
                editType: "style"
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 1,
                editType: "style"
              },
              name: {
                valType: "string",
                editType: "style"
              },
              uid: {
                valType: "string",
                editType: "plot",
                anim: !0
              },
              ids: {
                valType: "data_array",
                editType: "calc",
                anim: !0
              },
              customdata: {
                valType: "data_array",
                editType: "calc"
              },
              meta: {
                valType: "any",
                arrayOk: !0,
                editType: "plot"
              },
              selectedpoints: {
                valType: "any",
                editType: "calc"
              },
              hoverinfo: {
                valType: "flaglist",
                flags: ["x", "y", "z", "text", "name"],
                extras: ["all", "none", "skip"],
                arrayOk: !0,
                dflt: "all",
                editType: "none"
              },
              hoverlabel: r.hoverlabel,
              stream: {
                token: {
                  valType: "string",
                  noBlank: !0,
                  strict: !0,
                  editType: "calc"
                },
                maxpoints: {
                  valType: "number",
                  min: 0,
                  max: 1e4,
                  dflt: 500,
                  editType: "calc"
                },
                editType: "calc"
              },
              transforms: {
                _isLinkedToArray: "transform",
                editType: "calc"
              },
              uirevision: {
                valType: "any",
                editType: "none"
              }
            };
          }, {
            "../components/fx/attributes": 405
          }],
          539: [function (e, t, n) {
            "use strict";

            t.exports = {
              xaxis: {
                valType: "subplotid",
                dflt: "x",
                editType: "calc+clearAxisTypes"
              },
              yaxis: {
                valType: "subplotid",
                dflt: "y",
                editType: "calc+clearAxisTypes"
              }
            };
          }, {}],
          540: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib"),
              o = e("../../constants/numerical").FP_SAFE,
              a = e("../../registry");
            function s(e, t) {
              var n,
                r,
                o = [],
                a = l(t),
                s = u(e, t),
                c = s.min,
                d = s.max;
              if (0 === c.length || 0 === d.length) return i.simpleMap(t.range, t.r2l);
              var h = c[0].val,
                f = d[0].val;
              for (n = 1; n < c.length && h === f; n++) h = Math.min(h, c[n].val);
              for (n = 1; n < d.length && h === f; n++) f = Math.max(f, d[n].val);
              var p = !1;
              if (t.range) {
                var m = i.simpleMap(t.range, t.r2l);
                p = m[1] < m[0];
              }
              "reversed" === t.autorange && (p = !0, t.autorange = !0);
              var g,
                v,
                y,
                b,
                _,
                x,
                w = t.rangemode,
                S = "tozero" === w,
                A = "nonnegative" === w,
                E = t._length,
                T = E / 10,
                M = 0;
              for (n = 0; n < c.length; n++) for (g = c[n], r = 0; r < d.length; r++) (x = (v = d[r]).val - g.val) > 0 && ((_ = E - a(g) - a(v)) > T ? x / _ > M && (y = g, b = v, M = x / _) : x / E > M && (y = {
                val: g.val,
                pad: 0
              }, b = {
                val: v.val,
                pad: 0
              }, M = x / E));
              if (h === f) {
                var C = h - 1,
                  k = h + 1;
                if (S) {
                  if (0 === h) o = [0, 1];else {
                    var P = (h > 0 ? d : c).reduce(function (e, t) {
                        return Math.max(e, a(t));
                      }, 0),
                      O = h / (1 - Math.min(.5, P / E));
                    o = h > 0 ? [0, O] : [O, 0];
                  }
                } else o = A ? [Math.max(0, C), Math.max(1, k)] : [C, k];
              } else S ? (y.val >= 0 && (y = {
                val: 0,
                pad: 0
              }), b.val <= 0 && (b = {
                val: 0,
                pad: 0
              })) : A && (y.val - M * a(y) < 0 && (y = {
                val: 0,
                pad: 0
              }), b.val <= 0 && (b = {
                val: 1,
                pad: 0
              })), M = (b.val - y.val) / (E - a(y) - a(b)), o = [y.val - M * a(y), b.val + M * a(b)];
              return p && o.reverse(), i.simpleMap(o, t.l2r || Number);
            }
            function l(e) {
              var t = e._length / 20;
              return "domain" === e.constrain && e._inputDomain && (t *= (e._inputDomain[1] - e._inputDomain[0]) / (e.domain[1] - e.domain[0])), function (e) {
                return e.pad + (e.extrapad ? t : 0);
              };
            }
            function u(e, t) {
              var n,
                r,
                i,
                o = t._id,
                a = e._fullData,
                s = e._fullLayout,
                l = [],
                u = [];
              function h(e, t) {
                for (n = 0; n < t.length; n++) {
                  var a = e[t[n]],
                    s = (a._extremes || {})[o];
                  if (!0 === a.visible && s) {
                    for (r = 0; r < s.min.length; r++) i = s.min[r], c(l, i.val, i.pad, {
                      extrapad: i.extrapad
                    });
                    for (r = 0; r < s.max.length; r++) i = s.max[r], d(u, i.val, i.pad, {
                      extrapad: i.extrapad
                    });
                  }
                }
              }
              return h(a, t._traceIndices), h(s.annotations || [], t._annIndices || []), h(s.shapes || [], t._shapeIndices || []), {
                min: l,
                max: u
              };
            }
            function c(e, t, n, r) {
              h(e, t, n, r, p);
            }
            function d(e, t, n, r) {
              h(e, t, n, r, m);
            }
            function h(e, t, n, r, i) {
              for (var o = r.tozero, a = r.extrapad, s = !0, l = 0; l < e.length && s; l++) {
                var u = e[l];
                if (i(u.val, t) && u.pad >= n && (u.extrapad || !a)) {
                  s = !1;
                  break;
                }
                i(t, u.val) && u.pad <= n && (a || !u.extrapad) && (e.splice(l, 1), l--);
              }
              if (s) {
                var c = o && 0 === t;
                e.push({
                  val: t,
                  pad: c ? 0 : n,
                  extrapad: !c && a
                });
              }
            }
            function f(e) {
              return r(e) && Math.abs(e) < o;
            }
            function p(e, t) {
              return e <= t;
            }
            function m(e, t) {
              return e >= t;
            }
            t.exports = {
              getAutoRange: s,
              makePadFn: l,
              doAutoRange: function doAutoRange(e, t) {
                if (t.setScale(), t.autorange) {
                  t.range = s(e, t), t._r = t.range.slice(), t._rl = i.simpleMap(t._r, t.r2l);
                  var n = t._input,
                    r = {};
                  r[t._attr + ".range"] = t.range, r[t._attr + ".autorange"] = t.autorange, a.call("_storeDirectGUIEdit", e.layout, e._fullLayout._preGUI, r), n.range = t.range.slice(), n.autorange = t.autorange;
                }
                var o = t._anchorAxis;
                if (o && o.rangeslider) {
                  var l = o.rangeslider[t._name];
                  l && "auto" === l.rangemode && (l.range = s(e, t)), o._input.rangeslider[t._name] = i.extendFlat({}, l);
                }
              },
              findExtremes: function findExtremes(e, t, n) {
                n || (n = {}), e._m || e.setScale();
                var i,
                  a,
                  s,
                  l,
                  u,
                  h,
                  p,
                  m,
                  g,
                  v = [],
                  y = [],
                  b = t.length,
                  _ = n.padded || !1,
                  x = n.tozero && ("linear" === e.type || "-" === e.type),
                  w = "log" === e.type,
                  S = !1,
                  A = n.vpadLinearized || !1;
                function E(e) {
                  if (Array.isArray(e)) return S = !0, function (t) {
                    return Math.max(Number(e[t] || 0), 0);
                  };
                  var t = Math.max(Number(e || 0), 0);
                  return function () {
                    return t;
                  };
                }
                var T = E((e._m > 0 ? n.ppadplus : n.ppadminus) || n.ppad || 0),
                  M = E((e._m > 0 ? n.ppadminus : n.ppadplus) || n.ppad || 0),
                  C = E(n.vpadplus || n.vpad),
                  k = E(n.vpadminus || n.vpad);
                if (!S) {
                  if (m = 1 / 0, g = -1 / 0, w) for (i = 0; i < b; i++) (a = t[i]) < m && a > 0 && (m = a), a > g && a < o && (g = a);else for (i = 0; i < b; i++) (a = t[i]) < m && a > -o && (m = a), a > g && a < o && (g = a);
                  t = [m, g], b = 2;
                }
                var P = {
                  tozero: x,
                  extrapad: _
                };
                function O(n) {
                  s = t[n], r(s) && (h = T(n), p = M(n), A ? (l = e.c2l(s) - k(n), u = e.c2l(s) + C(n)) : (m = s - k(n), g = s + C(n), w && m < g / 10 && (m = g / 10), l = e.c2l(m), u = e.c2l(g)), x && (l = Math.min(0, l), u = Math.max(0, u)), f(l) && c(v, l, p, P), f(u) && d(y, u, h, P));
                }
                var R = Math.min(6, b);
                for (i = 0; i < R; i++) O(i);
                for (i = b - 1; i >= R; i--) O(i);
                return {
                  min: v,
                  max: y,
                  opts: n
                };
              },
              concatExtremes: u
            };
          }, {
            "../../constants/numerical": 474,
            "../../lib": 495,
            "../../registry": 593,
            "fast-isnumeric": 91
          }],
          541: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../../plots/plots"),
              a = e("../../registry"),
              s = e("../../lib"),
              l = e("../../lib/svg_text_utils"),
              u = e("../../components/titles"),
              c = e("../../components/color"),
              d = e("../../components/drawing"),
              h = e("./layout_attributes"),
              f = e("./clean_ticks"),
              p = e("../../constants/numerical"),
              m = p.ONEAVGYEAR,
              g = p.ONEAVGMONTH,
              v = p.ONEDAY,
              y = p.ONEHOUR,
              b = p.ONEMIN,
              _ = p.ONESEC,
              x = p.MINUS_SIGN,
              w = p.BADNUM,
              S = e("../../constants/alignment"),
              A = S.MID_SHIFT,
              E = S.CAP_SHIFT,
              T = S.LINE_SPACING,
              M = S.OPPOSITE_SIDE,
              C = t.exports = {};
            C.setConvert = e("./set_convert");
            var k = e("./axis_autotype"),
              P = e("./axis_ids");
            C.id2name = P.id2name, C.name2id = P.name2id, C.cleanId = P.cleanId, C.list = P.list, C.listIds = P.listIds, C.getFromId = P.getFromId, C.getFromTrace = P.getFromTrace;
            var O = e("./autorange");
            C.getAutoRange = O.getAutoRange, C.findExtremes = O.findExtremes, C.coerceRef = function (e, t, n, r, i, o) {
              var a = r.charAt(r.length - 1),
                l = n._fullLayout._subplots[a + "axis"],
                u = r + "ref",
                c = {};
              return i || (i = l[0] || o), o || (o = i), c[u] = {
                valType: "enumerated",
                values: l.concat(o ? [o] : []),
                dflt: i
              }, s.coerce(e, t, c, u);
            }, C.coercePosition = function (e, t, n, r, i, o) {
              var a, l;
              if ("paper" === r || "pixel" === r) a = s.ensureNumber, l = n(i, o);else {
                var u = C.getFromId(t, r);
                l = n(i, o = u.fraction2r(o)), a = u.cleanPos;
              }
              e[i] = a(l);
            }, C.cleanPosition = function (e, t, n) {
              return ("paper" === n || "pixel" === n ? s.ensureNumber : C.getFromId(t, n).cleanPos)(e);
            }, C.redrawComponents = function (e, t) {
              t = t || C.listIds(e);
              var n = e._fullLayout;
              function r(r, i, o, s) {
                for (var l = a.getComponentMethod(r, i), u = {}, c = 0; c < t.length; c++) for (var d = n[C.id2name(t[c])][o], h = 0; h < d.length; h++) {
                  var f = d[h];
                  if (!u[f] && (l(e, f), u[f] = 1, s)) return;
                }
              }
              r("annotations", "drawOne", "_annIndices"), r("shapes", "drawOne", "_shapeIndices"), r("images", "draw", "_imgIndices", !0);
            };
            var R = C.getDataConversions = function (e, t, n, r) {
              var i,
                o = "x" === n || "y" === n || "z" === n ? n : r;
              if (Array.isArray(o)) {
                if (i = {
                  type: k(r),
                  _categories: []
                }, C.setConvert(i), "category" === i.type) for (var a = 0; a < r.length; a++) i.d2c(r[a]);
              } else i = C.getFromTrace(e, t, o);
              return i ? {
                d2c: i.d2c,
                c2d: i.c2d
              } : "ids" === o ? {
                d2c: j,
                c2d: j
              } : {
                d2c: I,
                c2d: I
              };
            };
            function I(e) {
              return +e;
            }
            function j(e) {
              return String(e);
            }
            C.getDataToCoordFunc = function (e, t, n, r) {
              return R(e, t, n, r).d2c;
            }, C.counterLetter = function (e) {
              var t = e.charAt(0);
              return "x" === t ? "y" : "y" === t ? "x" : void 0;
            }, C.minDtick = function (e, t, n, r) {
              -1 === ["log", "category", "multicategory"].indexOf(e.type) && r ? void 0 === e._minDtick ? (e._minDtick = t, e._forceTick0 = n) : e._minDtick && ((e._minDtick / t + 1e-6) % 1 < 2e-6 && ((n - e._forceTick0) / t % 1 + 1.000001) % 1 < 2e-6 ? (e._minDtick = t, e._forceTick0 = n) : ((t / e._minDtick + 1e-6) % 1 > 2e-6 || ((n - e._forceTick0) / e._minDtick % 1 + 1.000001) % 1 > 2e-6) && (e._minDtick = 0)) : e._minDtick = 0;
            }, C.saveRangeInitial = function (e, t) {
              for (var n = C.list(e, "", !0), r = !1, i = 0; i < n.length; i++) {
                var o = n[i],
                  a = void 0 === o._rangeInitial,
                  s = a || !(o.range[0] === o._rangeInitial[0] && o.range[1] === o._rangeInitial[1]);
                (a && !1 === o.autorange || t && s) && (o._rangeInitial = o.range.slice(), r = !0);
              }
              return r;
            }, C.saveShowSpikeInitial = function (e, t) {
              for (var n = C.list(e, "", !0), r = !1, i = "on", o = 0; o < n.length; o++) {
                var a = n[o],
                  s = void 0 === a._showSpikeInitial,
                  l = s || !(a.showspikes === a._showspikes);
                (s || t && l) && (a._showSpikeInitial = a.showspikes, r = !0), "on" !== i || a.showspikes || (i = "off");
              }
              return e._fullLayout._cartesianSpikesEnabled = i, r;
            }, C.autoBin = function (e, t, n, r, o, a) {
              var l,
                u = s.aggNums(Math.min, null, e),
                c = s.aggNums(Math.max, null, e);
              if ("category" === t.type || "multicategory" === t.type) return {
                start: u - .5,
                end: c + .5,
                size: Math.max(1, Math.round(a) || 1),
                _dataSpan: c - u
              };
              if (o || (o = t.calendar), l = "log" === t.type ? {
                type: "linear",
                range: [u, c]
              } : {
                type: t.type,
                range: s.simpleMap([u, c], t.c2r, 0, o),
                calendar: o
              }, C.setConvert(l), a = a && f.dtick(a, l.type)) l.dtick = a, l.tick0 = f.tick0(void 0, l.type, o);else {
                var d;
                if (n) d = (c - u) / n;else {
                  var h = s.distinctVals(e),
                    p = Math.pow(10, Math.floor(Math.log(h.minDiff) / Math.LN10)),
                    m = p * s.roundUp(h.minDiff / p, [.9, 1.9, 4.9, 9.9], !0);
                  d = Math.max(m, 2 * s.stdev(e) / Math.pow(e.length, r ? .25 : .4)), i(d) || (d = 1);
                }
                C.autoTicks(l, d);
              }
              var g,
                y = l.dtick,
                b = C.tickIncrement(C.tickFirst(l), y, "reverse", o);
              if ("number" == typeof y) g = (b = function (e, t, n, r, o) {
                var a = 0,
                  s = 0,
                  l = 0,
                  u = 0;
                function c(t) {
                  return (1 + 100 * (t - e) / n.dtick) % 100 < 2;
                }
                for (var d = 0; d < t.length; d++) t[d] % 1 == 0 ? l++ : i(t[d]) || u++, c(t[d]) && a++, c(t[d] + n.dtick / 2) && s++;
                var h = t.length - u;
                if (l === h && "date" !== n.type) n.dtick < 1 ? e = r - .5 * n.dtick : (e -= .5) + n.dtick < r && (e += n.dtick);else if (s < .1 * h && (a > .3 * h || c(r) || c(o))) {
                  var f = n.dtick / 2;
                  e += e + f < r ? f : -f;
                }
                return e;
              }(b, e, l, u, c)) + (1 + Math.floor((c - b) / y)) * y;else for ("M" === l.dtick.charAt(0) && (b = function (e, t, n, r, i) {
                var o = s.findExactDates(t, i);
                if (o.exactDays > .8) {
                  var a = Number(n.substr(1));
                  o.exactYears > .8 && a % 12 == 0 ? e = C.tickIncrement(e, "M6", "reverse") + 1.5 * v : o.exactMonths > .8 ? e = C.tickIncrement(e, "M1", "reverse") + 15.5 * v : e -= v / 2;
                  var l = C.tickIncrement(e, n);
                  if (l <= r) return l;
                }
                return e;
              }(b, e, y, u, o)), g = b; g <= c;) g = C.tickIncrement(g, y, !1, o);
              return {
                start: t.c2r(b, 0, o),
                end: t.c2r(g, 0, o),
                size: y,
                _dataSpan: c - u
              };
            }, C.prepTicks = function (e) {
              var t = s.simpleMap(e.range, e.r2l);
              if ("auto" === e.tickmode || !e.dtick) {
                var n,
                  r = e.nticks;
                r || ("category" === e.type || "multicategory" === e.type ? (n = e.tickfont ? 1.2 * (e.tickfont.size || 12) : 15, r = e._length / n) : (n = "y" === e._id.charAt(0) ? 40 : 80, r = s.constrain(e._length / n, 4, 9) + 1), "radialaxis" === e._name && (r *= 2)), "array" === e.tickmode && (r *= 100), C.autoTicks(e, Math.abs(t[1] - t[0]) / r), e._minDtick > 0 && e.dtick < 2 * e._minDtick && (e.dtick = e._minDtick, e.tick0 = e.l2r(e._forceTick0));
              }
              e.tick0 || (e.tick0 = "date" === e.type ? "2000-01-01" : 0), "date" === e.type && e.dtick < .1 && (e.dtick = .1), V(e);
            }, C.calcTicks = function (e) {
              C.prepTicks(e);
              var t = s.simpleMap(e.range, e.r2l);
              if ("array" === e.tickmode) return function (e) {
                var t = e.tickvals,
                  n = e.ticktext,
                  r = new Array(t.length),
                  i = s.simpleMap(e.range, e.r2l),
                  o = 1.0001 * i[0] - 1e-4 * i[1],
                  a = 1.0001 * i[1] - 1e-4 * i[0],
                  l = Math.min(o, a),
                  u = Math.max(o, a),
                  c = 0;
                Array.isArray(n) || (n = []);
                var d = "category" === e.type ? e.d2l_noadd : e.d2l;
                "log" === e.type && "L" !== String(e.dtick).charAt(0) && (e.dtick = "L" + Math.pow(10, Math.floor(Math.min(e.range[0], e.range[1])) - 1));
                for (var h = 0; h < t.length; h++) {
                  var f = d(t[h]);
                  f > l && f < u && (void 0 === n[h] ? r[c] = C.tickText(e, f) : r[c] = H(e, f, String(n[h])), c++);
                }
                return c < t.length && r.splice(c, t.length - c), r;
              }(e);
              e._tmin = C.tickFirst(e);
              var n = 1.0001 * t[0] - 1e-4 * t[1],
                r = 1.0001 * t[1] - 1e-4 * t[0],
                o = t[1] < t[0];
              if (e._tmin < n !== o) return [];
              var a = [];
              "category" !== e.type && "multicategory" !== e.type || (r = o ? Math.max(-.5, r) : Math.min(e._categories.length - .5, r));
              for (var l = "log" === e.type && !(i(e.dtick) || "L" === e.dtick.charAt(0)), u = null, c = Math.max(1e3, e._length || 0), d = e._tmin; (o ? d >= r : d <= r) && !(a.length > c || d === u); d = C.tickIncrement(d, e.dtick, o, e.calendar)) {
                u = d;
                var h = !1;
                l && d !== (0 | d) && (h = !0), a.push({
                  minor: h,
                  value: d
                });
              }
              ae(e) && 360 === Math.abs(t[1] - t[0]) && a.pop(), e._tmax = (a[a.length - 1] || {}).value, e._prevDateHead = "", e._inCalcTicks = !0;
              for (var f = new Array(a.length), p = 0; p < a.length; p++) f[p] = C.tickText(e, a[p].value, !1, a[p].minor);
              return e._inCalcTicks = !1, f;
            };
            var N = [2, 5, 10],
              L = [1, 2, 3, 6, 12],
              D = [1, 2, 5, 10, 15, 30],
              B = [1, 2, 3, 7, 14],
              F = [-.046, 0, .301, .477, .602, .699, .778, .845, .903, .954, 1],
              z = [-.301, 0, .301, .699, 1],
              U = [15, 30, 45, 90, 180];
            function G(e, t, n) {
              return t * s.roundUp(e / t, n);
            }
            function V(e) {
              var t = e.dtick;
              if (e._tickexponent = 0, i(t) || "string" == typeof t || (t = 1), "category" !== e.type && "multicategory" !== e.type || (e._tickround = null), "date" === e.type) {
                var n = e.r2l(e.tick0),
                  r = e.l2r(n).replace(/(^-|i)/g, ""),
                  o = r.length;
                if ("M" === String(t).charAt(0)) o > 10 || "01-01" !== r.substr(5) ? e._tickround = "d" : e._tickround = +t.substr(1) % 12 == 0 ? "y" : "m";else if (t >= v && o <= 10 || t >= 15 * v) e._tickround = "d";else if (t >= b && o <= 16 || t >= y) e._tickround = "M";else if (t >= _ && o <= 19 || t >= b) e._tickround = "S";else {
                  var a = e.l2r(n + t).replace(/^-/, "").length;
                  e._tickround = Math.max(o, a) - 20, e._tickround < 0 && (e._tickround = 4);
                }
              } else if (i(t) || "L" === t.charAt(0)) {
                var s = e.range.map(e.r2d || Number);
                i(t) || (t = Number(t.substr(1))), e._tickround = 2 - Math.floor(Math.log(t) / Math.LN10 + .01);
                var l = Math.max(Math.abs(s[0]), Math.abs(s[1])),
                  u = Math.floor(Math.log(l) / Math.LN10 + .01);
                Math.abs(u) > 3 && (W(e.exponentformat) && !$(u) ? e._tickexponent = 3 * Math.round((u - 1) / 3) : e._tickexponent = u);
              } else e._tickround = null;
            }
            function H(e, t, n) {
              var r = e.tickfont || {};
              return {
                x: t,
                dx: 0,
                dy: 0,
                text: n || "",
                fontSize: r.size,
                font: r.family,
                fontColor: r.color
              };
            }
            C.autoTicks = function (e, t) {
              var n;
              function r(e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.LN10));
              }
              if ("date" === e.type) {
                e.tick0 = s.dateTick0(e.calendar);
                var o = 2 * t;
                o > m ? (t /= m, n = r(10), e.dtick = "M" + 12 * G(t, n, N)) : o > g ? (t /= g, e.dtick = "M" + G(t, 1, L)) : o > v ? (e.dtick = G(t, v, B), e.tick0 = s.dateTick0(e.calendar, !0)) : o > y ? e.dtick = G(t, y, L) : o > b ? e.dtick = G(t, b, D) : o > _ ? e.dtick = G(t, _, D) : (n = r(10), e.dtick = G(t, n, N));
              } else if ("log" === e.type) {
                e.tick0 = 0;
                var a = s.simpleMap(e.range, e.r2l);
                if (t > .7) e.dtick = Math.ceil(t);else if (Math.abs(a[1] - a[0]) < 1) {
                  var l = 1.5 * Math.abs((a[1] - a[0]) / t);
                  t = Math.abs(Math.pow(10, a[1]) - Math.pow(10, a[0])) / l, n = r(10), e.dtick = "L" + G(t, n, N);
                } else e.dtick = t > .3 ? "D2" : "D1";
              } else "category" === e.type || "multicategory" === e.type ? (e.tick0 = 0, e.dtick = Math.ceil(Math.max(t, 1))) : ae(e) ? (e.tick0 = 0, n = 1, e.dtick = G(t, n, U)) : (e.tick0 = 0, n = r(10), e.dtick = G(t, n, N));
              if (0 === e.dtick && (e.dtick = 1), !i(e.dtick) && "string" != typeof e.dtick) {
                var u = e.dtick;
                throw e.dtick = 1, "ax.dtick error: " + String(u);
              }
            }, C.tickIncrement = function (e, t, n, o) {
              var a = n ? -1 : 1;
              if (i(t)) return e + a * t;
              var l = t.charAt(0),
                u = a * Number(t.substr(1));
              if ("M" === l) return s.incrementMonth(e, u, o);
              if ("L" === l) return Math.log(Math.pow(10, e) + u) / Math.LN10;
              if ("D" === l) {
                var c = "D2" === t ? z : F,
                  d = e + .01 * a,
                  h = s.roundUp(s.mod(d, 1), c, n);
                return Math.floor(d) + Math.log(r.round(Math.pow(10, h), 1)) / Math.LN10;
              }
              throw "unrecognized dtick " + String(t);
            }, C.tickFirst = function (e) {
              var t = e.r2l || Number,
                n = s.simpleMap(e.range, t),
                o = n[1] < n[0],
                a = o ? Math.floor : Math.ceil,
                l = 1.0001 * n[0] - 1e-4 * n[1],
                u = e.dtick,
                c = t(e.tick0);
              if (i(u)) {
                var d = a((l - c) / u) * u + c;
                return "category" !== e.type && "multicategory" !== e.type || (d = s.constrain(d, 0, e._categories.length - 1)), d;
              }
              var h = u.charAt(0),
                f = Number(u.substr(1));
              if ("M" === h) {
                for (var p, m, g, v = 0, y = c; v < 10;) {
                  if (((p = C.tickIncrement(y, u, o, e.calendar)) - l) * (y - l) <= 0) return o ? Math.min(y, p) : Math.max(y, p);
                  m = (l - (y + p) / 2) / (p - y), g = h + (Math.abs(Math.round(m)) || 1) * f, y = C.tickIncrement(y, g, m < 0 ? !o : o, e.calendar), v++;
                }
                return s.error("tickFirst did not converge", e), y;
              }
              if ("L" === h) return Math.log(a((Math.pow(10, l) - c) / f) * f + c) / Math.LN10;
              if ("D" === h) {
                var b = "D2" === u ? z : F,
                  _ = s.roundUp(s.mod(l, 1), b, o);
                return Math.floor(l) + Math.log(r.round(Math.pow(10, _), 1)) / Math.LN10;
              }
              throw "unrecognized dtick " + String(u);
            }, C.tickText = function (e, t, n, r) {
              var o,
                a = H(e, t),
                l = "array" === e.tickmode,
                u = n || l,
                c = e.type,
                d = "category" === c ? e.d2l_noadd : e.d2l;
              if (l && Array.isArray(e.ticktext)) {
                var h = s.simpleMap(e.range, e.r2l),
                  f = Math.abs(h[1] - h[0]) / 1e4;
                for (o = 0; o < e.ticktext.length && !(Math.abs(t - d(e.tickvals[o])) < f); o++);
                if (o < e.ticktext.length) return a.text = String(e.ticktext[o]), a;
              }
              function p(r) {
                if (void 0 === r) return !0;
                if (n) return "none" === r;
                var i = {
                  first: e._tmin,
                  last: e._tmax
                }[r];
                return "all" !== r && t !== i;
              }
              var m = n ? "never" : "none" !== e.exponentformat && p(e.showexponent) ? "hide" : "";
              if ("date" === c ? function (e, t, n, r) {
                var o = e._tickround,
                  a = n && e.hoverformat || C.getTickFormat(e);
                r && (o = i(o) ? 4 : {
                  y: "m",
                  m: "d",
                  d: "M",
                  M: "S",
                  S: 4
                }[o]);
                var l,
                  u = s.formatDate(t.x, a, o, e._dateFormat, e.calendar, e._extraFormat),
                  c = u.indexOf("\n");
                -1 !== c && (l = u.substr(c + 1), u = u.substr(0, c)), r && ("00:00:00" === u || "00:00" === u ? (u = l, l = "") : 8 === u.length && (u = u.replace(/:00$/, ""))), l && (n ? "d" === o ? u += ", " + l : u = l + (u ? ", " + u : "") : e._inCalcTicks && l === e._prevDateHead || (u += "<br>" + l, e._prevDateHead = l)), t.text = u;
              }(e, a, n, u) : "log" === c ? function (e, t, n, r, o) {
                var a = e.dtick,
                  l = t.x,
                  u = e.tickformat,
                  c = "string" == typeof a && a.charAt(0);
                if ("never" === o && (o = ""), r && "L" !== c && (a = "L3", c = "L"), u || "L" === c) t.text = X(Math.pow(10, l), e, o, r);else if (i(a) || "D" === c && s.mod(l + .01, 1) < .1) {
                  var d = Math.round(l),
                    h = Math.abs(d),
                    f = e.exponentformat;
                  "power" === f || W(f) && $(d) ? (t.text = 0 === d ? 1 : 1 === d ? "10" : "10<sup>" + (d > 1 ? "" : x) + h + "</sup>", t.fontSize *= 1.25) : ("e" === f || "E" === f) && h > 2 ? t.text = "1" + f + (d > 0 ? "+" : x) + h : (t.text = X(Math.pow(10, l), e, "", "fakehover"), "D1" === a && "y" === e._id.charAt(0) && (t.dy -= t.fontSize / 6));
                } else {
                  if ("D" !== c) throw "unrecognized dtick " + String(a);
                  t.text = String(Math.round(Math.pow(10, s.mod(l, 1)))), t.fontSize *= .75;
                }
                if ("D1" === e.dtick) {
                  var p = String(t.text).charAt(0);
                  "0" !== p && "1" !== p || ("y" === e._id.charAt(0) ? t.dx -= t.fontSize / 4 : (t.dy += t.fontSize / 2, t.dx += (e.range[1] > e.range[0] ? 1 : -1) * t.fontSize * (l < 0 ? .5 : .25)));
                }
              }(e, a, 0, u, m) : "category" === c ? function (e, t) {
                var n = e._categories[Math.round(t.x)];
                void 0 === n && (n = ""), t.text = String(n);
              }(e, a) : "multicategory" === c ? function (e, t, n) {
                var r = Math.round(t.x),
                  i = e._categories[r] || [],
                  o = void 0 === i[1] ? "" : String(i[1]),
                  a = void 0 === i[0] ? "" : String(i[0]);
                n ? t.text = a + " - " + o : (t.text = o, t.text2 = a);
              }(e, a, n) : ae(e) ? function (e, t, n, r, i) {
                if ("radians" !== e.thetaunit || n) t.text = X(t.x, e, i, r);else {
                  var o = t.x / 180;
                  if (0 === o) t.text = "0";else {
                    var a = function (e) {
                      function t(e, t) {
                        return Math.abs(e - t) <= 1e-6;
                      }
                      var n = function (e) {
                          for (var n = 1; !t(Math.round(e * n) / n, e);) n *= 10;
                          return n;
                        }(e),
                        r = e * n,
                        i = Math.abs(function e(n, r) {
                          return t(r, 0) ? n : e(r, n % r);
                        }(r, n));
                      return [Math.round(r / i), Math.round(n / i)];
                    }(o);
                    if (a[1] >= 100) t.text = X(s.deg2rad(t.x), e, i, r);else {
                      var l = t.x < 0;
                      1 === a[1] ? 1 === a[0] ? t.text = "π" : t.text = a[0] + "π" : t.text = ["<sup>", a[0], "</sup>", "⁄", "<sub>", a[1], "</sub>", "π"].join(""), l && (t.text = x + t.text);
                    }
                  }
                }
              }(e, a, n, u, m) : function (e, t, n, r, i) {
                "never" === i ? i = "" : "all" === e.showexponent && Math.abs(t.x / e.dtick) < 1e-6 && (i = "hide"), t.text = X(t.x, e, i, r);
              }(e, a, 0, u, m), r || (e.tickprefix && !p(e.showtickprefix) && (a.text = e.tickprefix + a.text), e.ticksuffix && !p(e.showticksuffix) && (a.text += e.ticksuffix)), "boundaries" === e.tickson || e.showdividers) {
                var g = function g(t) {
                  var n = e.l2p(t);
                  return n >= 0 && n <= e._length ? t : null;
                };
                a.xbnd = [g(a.x - .5), g(a.x + e.dtick - .5)];
              }
              return a;
            }, C.hoverLabelText = function (e, t, n) {
              if (n !== w && n !== t) return C.hoverLabelText(e, t) + " - " + C.hoverLabelText(e, n);
              var r = "log" === e.type && t <= 0,
                i = C.tickText(e, e.c2l(r ? -t : t), "hover").text;
              return r ? 0 === t ? "0" : x + i : i;
            };
            var q = ["f", "p", "n", "μ", "m", "", "k", "M", "G", "T"];
            function W(e) {
              return "SI" === e || "B" === e;
            }
            function $(e) {
              return e > 14 || e < -15;
            }
            function X(e, t, n, r) {
              var o = e < 0,
                a = t._tickround,
                l = n || t.exponentformat || "B",
                u = t._tickexponent,
                c = C.getTickFormat(t),
                d = t.separatethousands;
              if (r) {
                var h = {
                  exponentformat: l,
                  dtick: "none" === t.showexponent ? t.dtick : i(e) && Math.abs(e) || 1,
                  range: "none" === t.showexponent ? t.range.map(t.r2d) : [0, e || 1]
                };
                V(h), a = (Number(h._tickround) || 0) + 4, u = h._tickexponent, t.hoverformat && (c = t.hoverformat);
              }
              if (c) return t._numFormat(c)(e).replace(/-/g, x);
              var f,
                p = Math.pow(10, -a) / 2;
              if ("none" === l && (u = 0), (e = Math.abs(e)) < p) e = "0", o = !1;else {
                if (e += p, u && (e *= Math.pow(10, -u), a += u), 0 === a) e = String(Math.floor(e));else if (a < 0) {
                  e = (e = String(Math.round(e))).substr(0, e.length + a);
                  for (var m = a; m < 0; m++) e += "0";
                } else {
                  var g = (e = String(e)).indexOf(".") + 1;
                  g && (e = e.substr(0, g + a).replace(/\.?0+$/, ""));
                }
                e = s.numSeparate(e, t._separators, d);
              }
              return u && "hide" !== l && (W(l) && $(u) && (l = "power"), f = u < 0 ? x + -u : "power" !== l ? "+" + u : String(u), "e" === l || "E" === l ? e += l + f : "power" === l ? e += "×10<sup>" + f + "</sup>" : "B" === l && 9 === u ? e += "B" : W(l) && (e += q[u / 3 + 5])), o ? x + e : e;
            }
            function Y(e, t) {
              for (var n = [], r = {}, i = 0; i < t.length; i++) {
                var o = t[i];
                r[o.text2] ? r[o.text2].push(o.x) : r[o.text2] = [o.x];
              }
              for (var a in r) n.push(H(e, s.interp(r[a], .5), a));
              return n;
            }
            function K(e) {
              return [e.text, e.x, e.axInfo, e.font, e.fontSize, e.fontColor].join("_");
            }
            function Z(e) {
              var t = e.title.font.size,
                n = (e.title.text.match(l.BR_TAG_ALL) || []).length;
              return e.title.hasOwnProperty("standoff") ? n ? t * (E + n * T) : t * E : n ? t * (n + 1) * T : t;
            }
            function Q(e, t) {
              var n = e.l2p(t);
              return n > 1 && n < e._length - 1;
            }
            function J(e) {
              var t = r.select(e),
                n = t.select(".text-math-group");
              return n.empty() ? t.select("text") : n;
            }
            function ee(e) {
              return e._id + ".automargin";
            }
            function te(e) {
              return ee(e) + ".mirror";
            }
            function ne(e) {
              return e._id + ".rangeslider";
            }
            function re(e, t) {
              for (var n = 0; n < t.length; n++) -1 === e.indexOf(t[n]) && e.push(t[n]);
            }
            function ie(e, t, n) {
              var r,
                i,
                o = [],
                a = [],
                l = e.layout;
              for (r = 0; r < t.length; r++) o.push(C.getFromId(e, t[r]));
              for (r = 0; r < n.length; r++) a.push(C.getFromId(e, n[r]));
              var u = Object.keys(h),
                c = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"],
                d = ["linear", "log"];
              for (r = 0; r < u.length; r++) {
                var f = u[r],
                  p = o[0][f],
                  m = a[0][f],
                  g = !0,
                  v = !1,
                  y = !1;
                if ("_" !== f.charAt(0) && "function" != typeof p && -1 === c.indexOf(f)) {
                  for (i = 1; i < o.length && g; i++) {
                    var b = o[i][f];
                    "type" === f && -1 !== d.indexOf(p) && -1 !== d.indexOf(b) && p !== b ? v = !0 : b !== p && (g = !1);
                  }
                  for (i = 1; i < a.length && g; i++) {
                    var _ = a[i][f];
                    "type" === f && -1 !== d.indexOf(m) && -1 !== d.indexOf(_) && m !== _ ? y = !0 : a[i][f] !== m && (g = !1);
                  }
                  g && (v && (l[o[0]._name].type = "linear"), y && (l[a[0]._name].type = "linear"), oe(l, f, o, a, e._fullLayout._dfltTitle));
                }
              }
              for (r = 0; r < e._fullLayout.annotations.length; r++) {
                var x = e._fullLayout.annotations[r];
                -1 !== t.indexOf(x.xref) && -1 !== n.indexOf(x.yref) && s.swapAttrs(l.annotations[r], ["?"]);
              }
            }
            function oe(e, t, n, r, i) {
              var o,
                a = s.nestedProperty,
                l = a(e[n[0]._name], t).get(),
                u = a(e[r[0]._name], t).get();
              for ("title" === t && (l && l.text === i.x && (l.text = i.y), u && u.text === i.y && (u.text = i.x)), o = 0; o < n.length; o++) a(e, n[o]._name + "." + t).set(u);
              for (o = 0; o < r.length; o++) a(e, r[o]._name + "." + t).set(l);
            }
            function ae(e) {
              return "angularaxis" === e._id;
            }
            C.getTickFormat = function (e) {
              var t, n, r, i, o, a, s, l;
              function u(e) {
                return "string" != typeof e ? e : Number(e.replace("M", "")) * g;
              }
              function c(e, t) {
                var n = ["L", "D"];
                if (typeof e == typeof t) {
                  if ("number" == typeof e) return e - t;
                  var r = n.indexOf(e.charAt(0)),
                    i = n.indexOf(t.charAt(0));
                  return r === i ? Number(e.replace(/(L|D)/g, "")) - Number(t.replace(/(L|D)/g, "")) : r - i;
                }
                return "number" == typeof e ? 1 : -1;
              }
              function d(e, t) {
                var n = null === t[0],
                  r = null === t[1],
                  i = c(e, t[0]) >= 0,
                  o = c(e, t[1]) <= 0;
                return (n || i) && (r || o);
              }
              if (e.tickformatstops && e.tickformatstops.length > 0) switch (e.type) {
                case "date":
                case "linear":
                  for (t = 0; t < e.tickformatstops.length; t++) if ((r = e.tickformatstops[t]).enabled && (i = e.dtick, a = void 0, a = u || function (e) {
                    return e;
                  }, s = (o = r.dtickrange)[0], l = o[1], (!s && "number" != typeof s || a(s) <= a(i)) && (!l && "number" != typeof l || a(l) >= a(i)))) {
                    n = r;
                    break;
                  }
                  break;
                case "log":
                  for (t = 0; t < e.tickformatstops.length; t++) if ((r = e.tickformatstops[t]).enabled && d(e.dtick, r.dtickrange)) {
                    n = r;
                    break;
                  }
              }
              return n ? n.value : e.tickformat;
            }, C.getSubplots = function (e, t) {
              var n = e._fullLayout._subplots,
                r = n.cartesian.concat(n.gl2d || []),
                i = t ? C.findSubplotsWithAxis(r, t) : r;
              return i.sort(function (e, t) {
                var n = e.substr(1).split("y"),
                  r = t.substr(1).split("y");
                return n[0] === r[0] ? +n[1] - +r[1] : +n[0] - +r[0];
              }), i;
            }, C.findSubplotsWithAxis = function (e, t) {
              for (var n = new RegExp("x" === t._id.charAt(0) ? "^" + t._id + "y" : t._id + "$"), r = [], i = 0; i < e.length; i++) {
                var o = e[i];
                n.test(o) && r.push(o);
              }
              return r;
            }, C.makeClipPaths = function (e) {
              var t = e._fullLayout;
              if (!t._hasOnlyLargeSploms) {
                var n,
                  i,
                  o = {
                    _offset: 0,
                    _length: t.width,
                    _id: ""
                  },
                  a = {
                    _offset: 0,
                    _length: t.height,
                    _id: ""
                  },
                  s = C.list(e, "x", !0),
                  l = C.list(e, "y", !0),
                  u = [];
                for (n = 0; n < s.length; n++) for (u.push({
                  x: s[n],
                  y: a
                }), i = 0; i < l.length; i++) 0 === n && u.push({
                  x: o,
                  y: l[i]
                }), u.push({
                  x: s[n],
                  y: l[i]
                });
                var c = t._clips.selectAll(".axesclip").data(u, function (e) {
                  return e.x._id + e.y._id;
                });
                c.enter().append("clipPath").classed("axesclip", !0).attr("id", function (e) {
                  return "clip" + t._uid + e.x._id + e.y._id;
                }).append("rect"), c.exit().remove(), c.each(function (e) {
                  r.select(this).select("rect").attr({
                    x: e.x._offset || 0,
                    y: e.y._offset || 0,
                    width: e.x._length || 1,
                    height: e.y._length || 1
                  });
                });
              }
            }, C.draw = function (e, t, n) {
              var r = e._fullLayout;
              "redraw" === t && r._paper.selectAll("g.subplot").each(function (e) {
                var t = e[0],
                  n = r._plots[t],
                  i = n.xaxis,
                  o = n.yaxis;
                n.xaxislayer.selectAll("." + i._id + "tick").remove(), n.yaxislayer.selectAll("." + o._id + "tick").remove(), n.xaxislayer.selectAll("." + i._id + "tick2").remove(), n.yaxislayer.selectAll("." + o._id + "tick2").remove(), n.xaxislayer.selectAll("." + i._id + "divider").remove(), n.yaxislayer.selectAll("." + o._id + "divider").remove(), n.gridlayer && n.gridlayer.selectAll("path").remove(), n.zerolinelayer && n.zerolinelayer.selectAll("path").remove(), r._infolayer.select(".g-" + i._id + "title").remove(), r._infolayer.select(".g-" + o._id + "title").remove();
              });
              var i = t && "redraw" !== t ? t : C.listIds(e);
              return s.syncOrAsync(i.map(function (t) {
                return function () {
                  if (t) {
                    var r = C.getFromId(e, t),
                      i = C.drawOne(e, r, n);
                    return r._r = r.range.slice(), r._rl = s.simpleMap(r._r, r.r2l), i;
                  }
                };
              }));
            }, C.drawOne = function (e, t, n) {
              var r, i, l;
              n = n || {}, t.setScale();
              var h = e._fullLayout,
                f = t._id,
                p = f.charAt(0),
                m = C.counterLetter(f),
                g = h._plots[t._mainSubplot];
              if (g) {
                var v = g[p + "axislayer"],
                  y = t._mainLinePosition,
                  b = t._mainMirrorPosition,
                  _ = t._vals = C.calcTicks(t),
                  x = [t.mirror, y, b].join("_");
                for (r = 0; r < _.length; r++) _[r].axInfo = x;
                t._selections = {}, t._tickAngles && (t._prevTickAngles = t._tickAngles), t._tickAngles = {}, t._depth = null;
                var w = {};
                if (t.visible) {
                  var S,
                    A,
                    E = C.makeTransFn(t);
                  if ("boundaries" === t.tickson) {
                    var k = function (e, t) {
                      var n,
                        r = [],
                        i = function i(e, t) {
                          var n = e.xbnd[t];
                          null !== n && r.push(s.extendFlat({}, e, {
                            x: n
                          }));
                        };
                      if (t.length) {
                        for (n = 0; n < t.length; n++) i(t[n], 0);
                        i(t[n - 1], 1);
                      }
                      return r;
                    }(0, _);
                    A = C.clipEnds(t, k), S = "inside" === t.ticks ? A : k;
                  } else A = C.clipEnds(t, _), S = "inside" === t.ticks ? A : _;
                  var P = t._gridVals = A,
                    O = function (e, t) {
                      var n,
                        r,
                        i = [],
                        o = function o(e, t) {
                          var n = e.xbnd[t];
                          null !== n && i.push(s.extendFlat({}, e, {
                            x: n
                          }));
                        };
                      if (e.showdividers && t.length) {
                        for (n = 0; n < t.length; n++) {
                          var a = t[n];
                          a.text2 !== r && o(a, 0), r = a.text2;
                        }
                        o(t[n - 1], 1);
                      }
                      return i;
                    }(t, _);
                  if (!h._hasOnlyLargeSploms) {
                    var R = t._subplotsWith,
                      I = {};
                    for (r = 0; r < R.length; r++) {
                      i = R[r];
                      var j = (l = h._plots[i])[m + "axis"],
                        N = j._mainAxis._id;
                      if (!I[N]) {
                        I[N] = 1;
                        var L = "x" === p ? "M0," + j._offset + "v" + j._length : "M" + j._offset + ",0h" + j._length;
                        C.drawGrid(e, t, {
                          vals: P,
                          counterAxis: j,
                          layer: l.gridlayer.select("." + f),
                          path: L,
                          transFn: E
                        }), C.drawZeroLine(e, t, {
                          counterAxis: j,
                          layer: l.zerolinelayer,
                          path: L,
                          transFn: E
                        });
                      }
                    }
                  }
                  var D = C.getTickSigns(t),
                    B = [];
                  if (t.ticks) {
                    var F,
                      z,
                      U,
                      G = C.makeTickPath(t, y, D[2]);
                    if (t._anchorAxis && t.mirror && !0 !== t.mirror ? (F = C.makeTickPath(t, b, D[3]), z = G + F) : (F = "", z = G), t.showdividers && "outside" === t.ticks && "boundaries" === t.tickson) {
                      var V = {};
                      for (r = 0; r < O.length; r++) V[O[r].x] = 1;
                      U = function U(e) {
                        return V[e.x] ? F : z;
                      };
                    } else U = z;
                    C.drawTicks(e, t, {
                      vals: S,
                      layer: v,
                      path: U,
                      transFn: E
                    }), "allticks" === t.mirror && (B = Object.keys(t._linepositions || {}));
                  }
                  for (r = 0; r < B.length; r++) {
                    i = B[r], l = h._plots[i];
                    var H = t._linepositions[i] || [],
                      q = C.makeTickPath(t, H[0], D[0]) + C.makeTickPath(t, H[1], D[1]);
                    C.drawTicks(e, t, {
                      vals: S,
                      layer: l[p + "axislayer"],
                      path: q,
                      transFn: E
                    });
                  }
                  var W = [];
                  if (W.push(function () {
                    return C.drawLabels(e, t, {
                      vals: _,
                      layer: v,
                      transFn: E,
                      labelFns: C.makeLabelFns(t, y)
                    });
                  }), "multicategory" === t.type) {
                    var $ = {
                      x: 2,
                      y: 10
                    }[p];
                    W.push(function () {
                      var n = {
                          x: "height",
                          y: "width"
                        }[p],
                        r = Q()[n] + $ + (t._tickAngles[f + "tick"] ? t.tickfont.size * T : 0);
                      return C.drawLabels(e, t, {
                        vals: Y(t, _),
                        layer: v,
                        cls: f + "tick2",
                        repositionOnUpdate: !0,
                        secondary: !0,
                        transFn: E,
                        labelFns: C.makeLabelFns(t, y + r * D[4])
                      });
                    }), W.push(function () {
                      return t._depth = D[4] * (Q("tick2")[t.side] - y), function (e, t, n) {
                        var r = t._id + "divider",
                          i = n.vals,
                          o = n.layer.selectAll("path." + r).data(i, K);
                        o.exit().remove(), o.enter().insert("path", ":first-child").classed(r, 1).classed("crisp", 1).call(c.stroke, t.dividercolor).style("stroke-width", d.crispRound(e, t.dividerwidth, 1) + "px"), o.attr("transform", n.transFn).attr("d", n.path);
                      }(e, t, {
                        vals: O,
                        layer: v,
                        path: C.makeTickPath(t, y, D[4], t._depth),
                        transFn: E
                      });
                    });
                  } else t.title.hasOwnProperty("standoff") && W.push(function () {
                    t._depth = D[4] * (Q()[t.side] - y);
                  });
                  var X = a.getComponentMethod("rangeslider", "isVisible")(t);
                  return W.push(function () {
                    var n,
                      r,
                      i,
                      s,
                      l = t.side.charAt(0),
                      u = M[t.side].charAt(0),
                      c = C.getPxPosition(e, t),
                      d = "outside" === t.ticks ? t.ticklen : 0;
                    if ((t.automargin || X) && ("multicategory" === t.type ? n = Q("tick2") : (n = Q(), "x" === p && "b" === l && (t._depth = Math.max(n.width > 0 ? n.bottom - c : 0, d)))), t.automargin) {
                      r = {
                        x: 0,
                        y: 0,
                        r: 0,
                        l: 0,
                        t: 0,
                        b: 0
                      };
                      var f = [0, 1];
                      if ("x" === p) {
                        if ("b" === l ? r[l] = t._depth : (r[l] = t._depth = Math.max(n.width > 0 ? c - n.top : 0, d), f.reverse()), n.width > 0) {
                          var g = n.right - (t._offset + t._length);
                          g > 0 && (r.xr = 1, r.r = g);
                          var v = t._offset - n.left;
                          v > 0 && (r.xl = 0, r.l = v);
                        }
                      } else if ("l" === l ? r[l] = t._depth = Math.max(n.height > 0 ? c - n.left : 0, d) : (r[l] = t._depth = Math.max(n.height > 0 ? n.right - c : 0, d), f.reverse()), n.height > 0) {
                        var y = n.bottom - (t._offset + t._length);
                        y > 0 && (r.yb = 0, r.b = y);
                        var b = t._offset - n.top;
                        b > 0 && (r.yt = 1, r.t = b);
                      }
                      r[m] = "free" === t.anchor ? t.position : t._anchorAxis.domain[f[0]], t.title.text !== h._dfltTitle[p] && (r[l] += Z(t) + (t.title.standoff || 0)), t.mirror && "free" !== t.anchor && ((i = {
                        x: 0,
                        y: 0,
                        r: 0,
                        l: 0,
                        t: 0,
                        b: 0
                      })[u] = t.linewidth, t.mirror && !0 !== t.mirror && (i[u] += d), !0 === t.mirror || "ticks" === t.mirror ? i[m] = t._anchorAxis.domain[f[1]] : "all" !== t.mirror && "allticks" !== t.mirror || (i[m] = [t._counterDomainMin, t._counterDomainMax][f[1]]));
                    }
                    X && (s = a.getComponentMethod("rangeslider", "autoMarginOpts")(e, t)), o.autoMargin(e, ee(t), r), o.autoMargin(e, te(t), i), o.autoMargin(e, ne(t), s);
                  }), n.skipTitle || X && "bottom" === t.side || W.push(function () {
                    return function (e, t) {
                      var n,
                        r = e._fullLayout,
                        i = t._id,
                        o = i.charAt(0),
                        a = t.title.font.size;
                      t.title.hasOwnProperty("standoff") ? n = t._depth + t.title.standoff + Z(t) : (n = "multicategory" === t.type ? t._depth : 10 + 1.5 * a + (t.linewidth ? t.linewidth - 1 : 0), n += "x" === o ? "top" === t.side ? a * (t.showticklabels ? 1 : 0) : a * (t.showticklabels ? 1.5 : .5) : "right" === t.side ? a * (t.showticklabels ? 1 : .5) : a * (t.showticklabels ? .5 : 0));
                      var s,
                        l,
                        c,
                        h,
                        f = C.getPxPosition(e, t);
                      if ("x" === o ? (l = t._offset + t._length / 2, c = "top" === t.side ? f - n : f + n) : (c = t._offset + t._length / 2, l = "right" === t.side ? f + n : f - n, s = {
                        rotate: "-90",
                        offset: 0
                      }), "multicategory" !== t.type) {
                        var p = t._selections[t._id + "tick"];
                        if (h = {
                          selection: p,
                          side: t.side
                        }, p && p.node() && p.node().parentNode) {
                          var m = d.getTranslate(p.node().parentNode);
                          h.offsetLeft = m.x, h.offsetTop = m.y;
                        }
                        t.title.hasOwnProperty("standoff") && (h.pad = 0);
                      }
                      return u.draw(e, i + "title", {
                        propContainer: t,
                        propName: t._name + ".title.text",
                        placeholder: r._dfltTitle[o],
                        avoid: h,
                        transform: s,
                        attributes: {
                          x: l,
                          y: c,
                          "text-anchor": "middle"
                        }
                      });
                    }(e, t);
                  }), s.syncOrAsync(W);
                }
              }
              function Q(e) {
                var n = f + (e || "tick");
                return w[n] || (w[n] = function (e, t) {
                  var n, r, i, o;
                  return e._selections[t].size() ? (n = 1 / 0, r = -1 / 0, i = 1 / 0, o = -1 / 0, e._selections[t].each(function () {
                    var e = J(this),
                      t = d.bBox(e.node().parentNode);
                    n = Math.min(n, t.top), r = Math.max(r, t.bottom), i = Math.min(i, t.left), o = Math.max(o, t.right);
                  })) : (n = 0, r = 0, i = 0, o = 0), {
                    top: n,
                    bottom: r,
                    left: i,
                    right: o,
                    height: r - n,
                    width: o - i
                  };
                }(t, n)), w[n];
              }
            }, C.getTickSigns = function (e) {
              var t = e._id.charAt(0),
                n = {
                  x: "top",
                  y: "right"
                }[t],
                r = e.side === n ? 1 : -1,
                i = [-1, 1, r, -r];
              return "inside" !== e.ticks == ("x" === t) && (i = i.map(function (e) {
                return -e;
              })), e.side && i.push({
                l: -1,
                t: -1,
                r: 1,
                b: 1
              }[e.side.charAt(0)]), i;
            }, C.makeTransFn = function (e) {
              var t = e._id.charAt(0),
                n = e._offset;
              return "x" === t ? function (t) {
                return "translate(" + (n + e.l2p(t.x)) + ",0)";
              } : function (t) {
                return "translate(0," + (n + e.l2p(t.x)) + ")";
              };
            }, C.makeTickPath = function (e, t, n, r) {
              r = void 0 !== r ? r : e.ticklen;
              var i = e._id.charAt(0),
                o = (e.linewidth || 1) / 2;
              return "x" === i ? "M0," + (t + o * n) + "v" + r * n : "M" + (t + o * n) + ",0h" + r * n;
            }, C.makeLabelFns = function (e, t, n) {
              var r = e._id.charAt(0),
                o = "boundaries" !== e.tickson && "outside" === e.ticks,
                a = 0,
                l = 0;
              if (o && (a += e.ticklen), n && "outside" === e.ticks) {
                var u = s.deg2rad(n);
                a = e.ticklen * Math.cos(u) + 1, l = e.ticklen * Math.sin(u);
              }
              e.showticklabels && (o || e.showline) && (a += .2 * e.tickfont.size);
              var c,
                d,
                h,
                f,
                p = {
                  labelStandoff: a += (e.linewidth || 1) / 2,
                  labelShift: l
                };
              return "x" === r ? (f = "bottom" === e.side ? 1 : -1, c = l * f, d = t + a * f, h = "bottom" === e.side ? 1 : -.2, p.xFn = function (e) {
                return e.dx + c;
              }, p.yFn = function (e) {
                return e.dy + d + e.fontSize * h;
              }, p.anchorFn = function (e, t) {
                return i(t) && 0 !== t && 180 !== t ? t * f < 0 ? "end" : "start" : "middle";
              }, p.heightFn = function (t, n, r) {
                return n < -60 || n > 60 ? -.5 * r : "top" === e.side ? -r : 0;
              }) : "y" === r && (f = "right" === e.side ? 1 : -1, c = a, d = -l * f, h = 90 === Math.abs(e.tickangle) ? .5 : 0, p.xFn = function (e) {
                return e.dx + t + (c + e.fontSize * h) * f;
              }, p.yFn = function (e) {
                return e.dy + d + e.fontSize * A;
              }, p.anchorFn = function (t, n) {
                return i(n) && 90 === Math.abs(n) ? "middle" : "right" === e.side ? "start" : "end";
              }, p.heightFn = function (t, n, r) {
                return (n *= "left" === e.side ? 1 : -1) < -30 ? -r : n < 30 ? -.5 * r : 0;
              }), p;
            }, C.drawTicks = function (e, t, n) {
              n = n || {};
              var r = t._id + "tick",
                i = n.layer.selectAll("path." + r).data(t.ticks ? n.vals : [], K);
              i.exit().remove(), i.enter().append("path").classed(r, 1).classed("ticks", 1).classed("crisp", !1 !== n.crisp).call(c.stroke, t.tickcolor).style("stroke-width", d.crispRound(e, t.tickwidth, 1) + "px").attr("d", n.path), i.attr("transform", n.transFn);
            }, C.drawGrid = function (e, t, n) {
              n = n || {};
              var r = t._id + "grid",
                i = n.vals,
                o = n.counterAxis;
              if (!1 === t.showgrid) i = [];else if (o && C.shouldShowZeroLine(e, t, o)) for (var a = "array" === t.tickmode, s = 0; s < i.length; s++) {
                var l = i[s].x;
                if (a ? !l : Math.abs(l) < t.dtick / 100) {
                  if (i = i.slice(0, s).concat(i.slice(s + 1)), !a) break;
                  s--;
                }
              }
              var u = n.layer.selectAll("path." + r).data(i, K);
              u.exit().remove(), u.enter().append("path").classed(r, 1).classed("crisp", !1 !== n.crisp), t._gw = d.crispRound(e, t.gridwidth, 1), u.attr("transform", n.transFn).attr("d", n.path).call(c.stroke, t.gridcolor || "#ddd").style("stroke-width", t._gw + "px"), "function" == typeof n.path && u.attr("d", n.path);
            }, C.drawZeroLine = function (e, t, n) {
              n = n || n;
              var r = t._id + "zl",
                i = C.shouldShowZeroLine(e, t, n.counterAxis),
                o = n.layer.selectAll("path." + r).data(i ? [{
                  x: 0,
                  id: t._id
                }] : []);
              o.exit().remove(), o.enter().append("path").classed(r, 1).classed("zl", 1).classed("crisp", !1 !== n.crisp).each(function () {
                n.layer.selectAll("path").sort(function (e, t) {
                  return P.idSort(e.id, t.id);
                });
              }), o.attr("transform", n.transFn).attr("d", n.path).call(c.stroke, t.zerolinecolor || c.defaultLine).style("stroke-width", d.crispRound(e, t.zerolinewidth, t._gw || 1) + "px");
            }, C.drawLabels = function (e, t, n) {
              n = n || {};
              var o = e._fullLayout,
                a = t._id,
                u = a.charAt(0),
                c = n.cls || a + "tick",
                h = n.vals,
                f = n.labelFns,
                p = n.secondary ? 0 : t.tickangle,
                m = (t._prevTickAngles || {})[c],
                g = n.layer.selectAll("g." + c).data(t.showticklabels ? h : [], K),
                v = [];
              function y(e, t) {
                e.each(function (e) {
                  var o = r.select(this),
                    a = o.select(".text-math-group"),
                    s = f.anchorFn(e, t),
                    u = n.transFn.call(o.node(), e) + (i(t) && 0 != +t ? " rotate(" + t + "," + f.xFn(e) + "," + (f.yFn(e) - e.fontSize / 2) + ")" : ""),
                    c = l.lineCount(o),
                    h = T * e.fontSize,
                    p = f.heightFn(e, i(t) ? +t : 0, (c - 1) * h);
                  if (p && (u += " translate(0, " + p + ")"), a.empty()) o.select("text").attr({
                    transform: u,
                    "text-anchor": s
                  });else {
                    var m = d.bBox(a.node()).width * {
                      end: -.5,
                      start: .5
                    }[s];
                    a.attr("transform", u + (m ? "translate(" + m + ",0)" : ""));
                  }
                });
              }
              g.enter().append("g").classed(c, 1).append("text").attr("text-anchor", "middle").each(function (t) {
                var n = r.select(this),
                  i = e._promises.length;
                n.call(l.positionText, f.xFn(t), f.yFn(t)).call(d.font, t.font, t.fontSize, t.fontColor).text(t.text).call(l.convertToTspans, e), e._promises[i] ? v.push(e._promises.pop().then(function () {
                  y(n, p);
                })) : y(n, p);
              }), g.exit().remove(), n.repositionOnUpdate && g.each(function (e) {
                r.select(this).select("text").call(l.positionText, f.xFn(e), f.yFn(e));
              }), y(g, m + 1 ? m : p);
              var b = null;
              t._selections && (t._selections[c] = g);
              var _ = [function () {
                return v.length && Promise.all(v);
              }];
              t.automargin && o._redrawFromAutoMarginCount && 90 === m ? (b = 90, _.push(function () {
                y(g, m);
              })) : _.push(function () {
                if (y(g, p), h.length && "x" === u && !i(p) && ("log" !== t.type || "D" !== String(t.dtick).charAt(0))) {
                  b = 0;
                  var e,
                    r = 0,
                    o = [];
                  if (g.each(function (e) {
                    r = Math.max(r, e.fontSize);
                    var n = t.l2p(e.x),
                      i = J(this),
                      a = d.bBox(i.node());
                    o.push({
                      top: 0,
                      bottom: 10,
                      height: 10,
                      left: n - a.width / 2,
                      right: n + a.width / 2 + 2,
                      width: a.width + 2
                    });
                  }), "boundaries" !== t.tickson && !t.showdividers || n.secondary) {
                    var a = h.length,
                      l = Math.abs((h[a - 1].x - h[0].x) * t._m) / (a - 1) < 2.5 * r || "multicategory" === t.type;
                    for (e = 0; e < o.length - 1; e++) if (s.bBoxIntersect(o[e], o[e + 1])) {
                      b = l ? 90 : 30;
                      break;
                    }
                  } else {
                    var c = 2;
                    for (t.ticks && (c += t.tickwidth / 2), e = 0; e < o.length; e++) {
                      var f = h[e].xbnd,
                        m = o[e];
                      if (null !== f[0] && m.left - t.l2p(f[0]) < c || null !== f[1] && t.l2p(f[1]) - m.right < c) {
                        b = 90;
                        break;
                      }
                    }
                  }
                  b && y(g, b);
                }
              }), t._tickAngles && _.push(function () {
                t._tickAngles[c] = null === b ? i(p) ? p : 0 : b;
              });
              var x = s.syncOrAsync(_);
              return x && x.then && e._promises.push(x), x;
            }, C.getPxPosition = function (e, t) {
              var n,
                r = e._fullLayout._size,
                i = t._id.charAt(0),
                o = t.side;
              return "free" !== t.anchor ? n = t._anchorAxis : "x" === i ? n = {
                _offset: r.t + (1 - (t.position || 0)) * r.h,
                _length: 0
              } : "y" === i && (n = {
                _offset: r.l + (t.position || 0) * r.w,
                _length: 0
              }), "top" === o || "left" === o ? n._offset : "bottom" === o || "right" === o ? n._offset + n._length : void 0;
            }, C.shouldShowZeroLine = function (e, t, n) {
              var r = s.simpleMap(t.range, t.r2l);
              return r[0] * r[1] <= 0 && t.zeroline && ("linear" === t.type || "-" === t.type) && (Q(t, 0) || !function (e, t, n, r) {
                var i = n._mainAxis;
                if (i) {
                  var o = e._fullLayout,
                    a = t._id.charAt(0),
                    s = C.counterLetter(t._id),
                    l = t._offset + (Math.abs(r[0]) < Math.abs(r[1]) == ("x" === a) ? 0 : t._length),
                    u = o._plots[n._mainSubplot];
                  if (!(u.mainplotinfo || u).overlays.length) return f(n);
                  for (var c = C.list(e, s), d = 0; d < c.length; d++) {
                    var h = c[d];
                    if (h._mainAxis === i && f(h)) return !0;
                  }
                }
                function f(e) {
                  if (!e.showline || !e.linewidth) return !1;
                  var n = Math.max((e.linewidth + t.zerolinewidth) / 2, 1);
                  function r(e) {
                    return "number" == typeof e && Math.abs(e - l) < n;
                  }
                  if (r(e._mainLinePosition) || r(e._mainMirrorPosition)) return !0;
                  var i = e._linepositions || {};
                  for (var o in i) if (r(i[o][0]) || r(i[o][1])) return !0;
                }
              }(e, t, n, r) || function (e, t) {
                for (var n = e._fullData, r = t._mainSubplot, i = t._id.charAt(0), o = 0; o < n.length; o++) {
                  var s = n[o];
                  if (!0 === s.visible && s.xaxis + s.yaxis === r) {
                    if (a.traceIs(s, "bar-like") && s.orientation === {
                      x: "h",
                      y: "v"
                    }[i]) return !0;
                    if (s.fill && s.fill.charAt(s.fill.length - 1) === i) return !0;
                  }
                }
                return !1;
              }(e, t));
            }, C.clipEnds = function (e, t) {
              return t.filter(function (t) {
                return Q(e, t.x);
              });
            }, C.allowAutoMargin = function (e) {
              for (var t = C.list(e, "", !0), n = 0; n < t.length; n++) {
                var r = t[n];
                r.automargin && (o.allowAutoMargin(e, ee(r)), r.mirror && o.allowAutoMargin(e, te(r))), a.getComponentMethod("rangeslider", "isVisible")(r) && o.allowAutoMargin(e, ne(r));
              }
            }, C.swap = function (e, t) {
              for (var n = function (e, t) {
                  var n,
                    r,
                    i = [];
                  for (n = 0; n < t.length; n++) {
                    var o = [],
                      a = e._fullData[t[n]].xaxis,
                      s = e._fullData[t[n]].yaxis;
                    if (a && s) {
                      for (r = 0; r < i.length; r++) -1 === i[r].x.indexOf(a) && -1 === i[r].y.indexOf(s) || o.push(r);
                      if (o.length) {
                        var l,
                          u = i[o[0]];
                        if (o.length > 1) for (r = 1; r < o.length; r++) l = i[o[r]], re(u.x, l.x), re(u.y, l.y);
                        re(u.x, [a]), re(u.y, [s]);
                      } else i.push({
                        x: [a],
                        y: [s]
                      });
                    }
                  }
                  return i;
                }(e, t), r = 0; r < n.length; r++) ie(e, n[r].x, n[r].y);
            };
          }, {
            "../../components/color": 375,
            "../../components/drawing": 396,
            "../../components/titles": 462,
            "../../constants/alignment": 469,
            "../../constants/numerical": 474,
            "../../lib": 495,
            "../../lib/svg_text_utils": 518,
            "../../plots/plots": 584,
            "../../registry": 593,
            "./autorange": 540,
            "./axis_autotype": 542,
            "./axis_ids": 544,
            "./clean_ticks": 546,
            "./layout_attributes": 553,
            "./set_convert": 559,
            d3: 82,
            "fast-isnumeric": 91
          }],
          542: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib"),
              o = e("../../constants/numerical").BADNUM;
            t.exports = function (e, t, n) {
              return !(n = n || {}).noMultiCategory && (a = e, i.isArrayOrTypedArray(a[0]) && i.isArrayOrTypedArray(a[1])) ? "multicategory" : function (e, t) {
                for (var n = Math.max(1, (e.length - 1) / 1e3), o = 0, a = 0, s = {}, l = 0; l < e.length; l += n) {
                  var u = e[Math.round(l)],
                    c = String(u);
                  s[c] || (s[c] = 1, i.isDateTime(u, t) && (o += 1), r(u) && (a += 1));
                }
                return o > 2 * a;
              }(e, t) ? "date" : function (e) {
                for (var t = Math.max(1, (e.length - 1) / 1e3), n = 0, r = 0, a = {}, s = 0; s < e.length; s += t) {
                  var l = e[Math.round(s)],
                    u = String(l);
                  a[u] || (a[u] = 1, "boolean" == typeof l ? r++ : i.cleanNumber(l) !== o ? n++ : "string" == typeof l && r++);
                }
                return r > 2 * n;
              }(e) ? "category" : function (e) {
                if (!e) return !1;
                for (var t = 0; t < e.length; t++) if (r(e[t])) return !0;
                return !1;
              }(e) ? "linear" : "-";
              var a;
            };
          }, {
            "../../constants/numerical": 474,
            "../../lib": 495,
            "fast-isnumeric": 91
          }],
          543: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib"),
              o = e("./layout_attributes"),
              a = e("./tick_value_defaults"),
              s = e("./tick_mark_defaults"),
              l = e("./tick_label_defaults"),
              u = e("./category_order_defaults"),
              c = e("./line_grid_defaults"),
              d = e("./set_convert");
            t.exports = function (e, t, n, h, f) {
              var p = h.letter,
                m = h.font || {},
                g = h.splomStash || {},
                v = n("visible", !h.visibleDflt),
                y = t.type;
              "date" === y && r.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar", h.calendar), d(t, f);
              var b = !t.isValidRange(e.range);
              b && h.reverseDflt && (b = "reversed"), !n("autorange", b) || "linear" !== y && "-" !== y || n("rangemode"), n("range"), t.cleanRange(), u(e, t, n, h), "category" === y || h.noHover || n("hoverformat");
              var _ = n("color"),
                x = _ !== o.color.dflt ? _ : m.color,
                w = g.label || f._dfltTitle[p];
              if (l(e, t, n, y, h, {
                pass: 1
              }), !v) return t;
              n("title.text", w), i.coerceFont(n, "title.font", {
                family: m.family,
                size: Math.round(1.2 * m.size),
                color: x
              }), a(e, t, n, y), l(e, t, n, y, h, {
                pass: 2
              }), s(e, t, n, h), c(e, t, n, {
                dfltColor: _,
                bgColor: h.bgColor,
                showGrid: h.showGrid,
                attributes: o
              }), (t.showline || t.ticks) && n("mirror"), h.automargin && n("automargin");
              var S,
                A = "multicategory" === t.type;
              return h.noTickson || "category" !== t.type && !A || !t.ticks && !t.showgrid || (A && (S = "boundaries"), n("tickson", S)), A && n("showdividers") && (n("dividercolor"), n("dividerwidth")), t;
            };
          }, {
            "../../lib": 495,
            "../../registry": 593,
            "./category_order_defaults": 545,
            "./layout_attributes": 553,
            "./line_grid_defaults": 555,
            "./set_convert": 559,
            "./tick_label_defaults": 560,
            "./tick_mark_defaults": 561,
            "./tick_value_defaults": 562
          }],
          544: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("./constants");
            n.id2name = function (e) {
              if ("string" == typeof e && e.match(i.AX_ID_PATTERN)) {
                var t = e.substr(1);
                return "1" === t && (t = ""), e.charAt(0) + "axis" + t;
              }
            }, n.name2id = function (e) {
              if (e.match(i.AX_NAME_PATTERN)) {
                var t = e.substr(5);
                return "1" === t && (t = ""), e.charAt(0) + t;
              }
            }, n.cleanId = function (e, t) {
              if (e.match(i.AX_ID_PATTERN) && (!t || e.charAt(0) === t)) {
                var n = e.substr(1).replace(/^0+/, "");
                return "1" === n && (n = ""), e.charAt(0) + n;
              }
            }, n.list = function (e, t, r) {
              var i = e._fullLayout;
              if (!i) return [];
              var o,
                a = n.listIds(e, t),
                s = new Array(a.length);
              for (o = 0; o < a.length; o++) {
                var l = a[o];
                s[o] = i[l.charAt(0) + "axis" + l.substr(1)];
              }
              if (!r) {
                var u = i._subplots.gl3d || [];
                for (o = 0; o < u.length; o++) {
                  var c = i[u[o]];
                  t ? s.push(c[t + "axis"]) : s.push(c.xaxis, c.yaxis, c.zaxis);
                }
              }
              return s;
            }, n.listIds = function (e, t) {
              var n = e._fullLayout;
              if (!n) return [];
              var r = n._subplots;
              return t ? r[t + "axis"] : r.xaxis.concat(r.yaxis);
            }, n.getFromId = function (e, t, r) {
              var i = e._fullLayout;
              return "x" === r ? t = t.replace(/y[0-9]*/, "") : "y" === r && (t = t.replace(/x[0-9]*/, "")), i[n.id2name(t)];
            }, n.getFromTrace = function (e, t, i) {
              var o = e._fullLayout,
                a = null;
              if (r.traceIs(t, "gl3d")) {
                var s = t.scene;
                "scene" === s.substr(0, 5) && (a = o[s][i + "axis"]);
              } else a = n.getFromId(e, t[i + "axis"] || i);
              return a;
            }, n.idSort = function (e, t) {
              var n = e.charAt(0),
                r = t.charAt(0);
              return n !== r ? n > r ? 1 : -1 : +(e.substr(1) || 1) - +(t.substr(1) || 1);
            }, n.getAxisGroup = function (e, t) {
              for (var n = e._axisMatchGroups, r = 0; r < n.length; r++) if (n[r][t]) return "g" + r;
              return t;
            };
          }, {
            "../../registry": 593,
            "./constants": 547
          }],
          545: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, r) {
              if ("category" === t.type) {
                var i,
                  o = e.categoryarray,
                  a = Array.isArray(o) && o.length > 0;
                a && (i = "array");
                var s,
                  l = n("categoryorder", i);
                "array" === l && (s = n("categoryarray")), a || "array" !== l || (l = t.categoryorder = "trace"), "trace" === l ? t._initialCategories = [] : "array" === l ? t._initialCategories = s.slice() : (s = function (e, t) {
                  var n,
                    r,
                    i,
                    o = t.dataAttr || e._id.charAt(0),
                    a = {};
                  if (t.axData) n = t.axData;else for (n = [], r = 0; r < t.data.length; r++) {
                    var s = t.data[r];
                    s[o + "axis"] === e._id && n.push(s);
                  }
                  for (r = 0; r < n.length; r++) {
                    var l = n[r][o];
                    for (i = 0; i < l.length; i++) {
                      var u = l[i];
                      null != u && (a[u] = 1);
                    }
                  }
                  return Object.keys(a);
                }(t, r).sort(), "category ascending" === l ? t._initialCategories = s : "category descending" === l && (t._initialCategories = s.reverse()));
              }
            };
          }, {}],
          546: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib"),
              o = e("../../constants/numerical").ONEDAY;
            n.dtick = function (e, t) {
              var n = "log" === t,
                i = "date" === t,
                a = "category" === t,
                s = i ? o : 1;
              if (!e) return s;
              if (r(e)) return (e = Number(e)) <= 0 ? s : a ? Math.max(1, Math.round(e)) : i ? Math.max(.1, e) : e;
              if ("string" != typeof e || !i && !n) return s;
              var l = e.charAt(0),
                u = e.substr(1);
              return (u = r(u) ? Number(u) : 0) <= 0 || !(i && "M" === l && u === Math.round(u) || n && "L" === l || n && "D" === l && (1 === u || 2 === u)) ? s : e;
            }, n.tick0 = function (e, t, n, o) {
              return "date" === t ? i.cleanDate(e, i.dateTick0(n)) : "D1" !== o && "D2" !== o ? r(e) ? Number(e) : 0 : void 0;
            };
          }, {
            "../../constants/numerical": 474,
            "../../lib": 495,
            "fast-isnumeric": 91
          }],
          547: [function (e, t, n) {
            "use strict";

            var r = e("../../lib/regex").counter;
            t.exports = {
              idRegex: {
                x: r("x"),
                y: r("y")
              },
              attrRegex: r("[xy]axis"),
              xAxisMatch: r("xaxis"),
              yAxisMatch: r("yaxis"),
              AX_ID_PATTERN: /^[xyz][0-9]*$/,
              AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
              SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
              MINDRAG: 8,
              MINSELECT: 12,
              MINZOOM: 20,
              DRAGGERSIZE: 20,
              BENDPX: 1.5,
              REDRAWDELAY: 50,
              SELECTDELAY: 100,
              SELECTID: "-select",
              DFLTRANGEX: [-1, 6],
              DFLTRANGEY: [-1, 4],
              traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"],
              clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"],
              layerValue2layerClass: {
                "above traces": "above",
                "below traces": "below"
              }
            };
          }, {
            "../../lib/regex": 510
          }],
          548: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./axis_ids").id2name,
              o = e("./scale_zoom"),
              a = e("./autorange").makePadFn,
              s = e("./autorange").concatExtremes,
              l = e("../../constants/numerical").ALMOST_EQUAL,
              u = e("../../constants/alignment").FROM_BL;
            function c(e, t, n, r, o) {
              var a,
                s,
                l,
                u,
                c = "range" !== o,
                d = r[i(t)].type,
                h = [];
              for (s = 0; s < n.length; s++) (l = n[s]) !== t && (u = r[i(l)]).type === d && (u.fixedrange ? c && u.anchor && r[i(u.anchor)].fixedrange && h.push(l) : h.push(l));
              for (a = 0; a < e.length; a++) if (e[a][t]) {
                var f = e[a],
                  p = [];
                for (s = 0; s < h.length; s++) f[l = h[s]] || p.push(l);
                return {
                  linkableAxes: p,
                  thisGroup: f
                };
              }
              return {
                linkableAxes: h,
                thisGroup: null
              };
            }
            function d(e, t, n, r, i) {
              var o, a, s, l, u;
              null === t ? ((t = {})[n] = 1, u = e.length, e.push(t)) : u = e.indexOf(t);
              var c = Object.keys(t);
              for (o = 0; o < e.length; o++) if (s = e[o], o !== u && s[r]) {
                var d = s[r];
                for (a = 0; a < c.length; a++) s[l = c[a]] = d * i * t[l];
                return void e.splice(u, 1);
              }
              if (1 !== i) for (a = 0; a < c.length; a++) t[c[a]] *= i;
              t[r] = 1;
            }
            function h(e, t) {
              var n = e._inputDomain,
                r = u[e.constraintoward],
                i = n[0] + (n[1] - n[0]) * r;
              e.domain = e._input.domain = [i + (n[0] - i) / t, i + (n[1] - i) / t], e.setScale();
            }
            n.handleConstraintDefaults = function (e, t, n, i) {
              var o,
                a,
                s,
                l,
                u = i.allAxisIds,
                h = i.layoutOut,
                f = i.scaleanchorDflt,
                p = i.constrainDflt,
                m = h._axisConstraintGroups,
                g = h._axisMatchGroups,
                v = t._id,
                y = v.charAt(0),
                b = ((h._splomAxes || {})[y] || {})[v] || {},
                _ = t._id,
                x = _.charAt(0),
                w = n("constrain", p);
              if (r.coerce(e, t, {
                constraintoward: {
                  valType: "enumerated",
                  values: "x" === x ? ["left", "center", "right"] : ["bottom", "middle", "top"],
                  dflt: "x" === x ? "center" : "middle"
                }
              }, "constraintoward"), !e.matches && !b.matches || t.fixedrange || (a = c(g, _, u, h), o = r.coerce(e, t, {
                matches: {
                  valType: "enumerated",
                  values: a.linkableAxes || [],
                  dflt: b.matches
                }
              }, "matches")), o || t.fixedrange && "domain" !== w || !e.scaleanchor && !f || (l = c(m, _, u, h, w), s = r.coerce(e, t, {
                scaleanchor: {
                  valType: "enumerated",
                  values: l.linkableAxes || []
                }
              }, "scaleanchor", f)), o ? (delete t.constrain, d(g, a.thisGroup, _, o, 1)) : -1 !== u.indexOf(e.matches) && r.warn("ignored " + t._name + '.matches: "' + e.matches + '" to avoid either an infinite loop or because the target axis has fixed range.'), s) {
                var S = n("scaleratio");
                S || (S = t.scaleratio = 1), d(m, l.thisGroup, _, s, S);
              } else -1 !== u.indexOf(e.scaleanchor) && r.warn("ignored " + t._name + '.scaleanchor: "' + e.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because the target axis has fixed range or this axis declares a *matches* constraint.');
            }, n.enforce = function (e) {
              var t,
                n,
                r,
                u,
                c,
                d,
                f,
                p = e._fullLayout,
                m = p._axisConstraintGroups || [];
              for (t = 0; t < m.length; t++) {
                var g = m[t],
                  v = Object.keys(g),
                  y = 1 / 0,
                  b = 0,
                  _ = 1 / 0,
                  x = {},
                  w = {},
                  S = !1;
                for (n = 0; n < v.length; n++) w[r = v[n]] = u = p[i(r)], u._inputDomain ? u.domain = u._inputDomain.slice() : u._inputDomain = u.domain.slice(), u._inputRange || (u._inputRange = u.range.slice()), u.setScale(), x[r] = c = Math.abs(u._m) / g[r], y = Math.min(y, c), "domain" !== u.constrain && u._constraintShrinkable || (_ = Math.min(_, c)), delete u._constraintShrinkable, b = Math.max(b, c), "domain" === u.constrain && (S = !0);
                if (!(y > l * b) || S) for (n = 0; n < v.length; n++) if (c = x[r = v[n]], d = (u = w[r]).constrain, c !== _ || "domain" === d) if (f = c / _, "range" === d) o(u, f);else {
                  var A = u._inputDomain,
                    E = (u.domain[1] - u.domain[0]) / (A[1] - A[0]),
                    T = (u.r2l(u.range[1]) - u.r2l(u.range[0])) / (u.r2l(u._inputRange[1]) - u.r2l(u._inputRange[0]));
                  if ((f /= E) * T < 1) {
                    u.domain = u._input.domain = A.slice(), o(u, f);
                    continue;
                  }
                  if (T < 1 && (u.range = u._input.range = u._inputRange.slice(), f *= T), u.autorange) {
                    var M = u.r2l(u.range[0]),
                      C = u.r2l(u.range[1]),
                      k = (M + C) / 2,
                      P = k,
                      O = k,
                      R = Math.abs(C - k),
                      I = k - R * f * 1.0001,
                      j = k + R * f * 1.0001,
                      N = a(u);
                    h(u, f);
                    var L,
                      D,
                      B = Math.abs(u._m),
                      F = s(e, u),
                      z = F.min,
                      U = F.max;
                    for (D = 0; D < z.length; D++) (L = z[D].val - N(z[D]) / B) > I && L < P && (P = L);
                    for (D = 0; D < U.length; D++) (L = U[D].val + N(U[D]) / B) < j && L > O && (O = L);
                    f /= (O - P) / (2 * R), P = u.l2r(P), O = u.l2r(O), u.range = u._input.range = M < C ? [P, O] : [O, P];
                  }
                  h(u, f);
                }
              }
            }, n.clean = function (e, t) {
              if (t._inputDomain) {
                for (var n = !1, r = t._id, i = e._fullLayout._axisConstraintGroups, o = 0; o < i.length; o++) if (i[o][r]) {
                  n = !0;
                  break;
                }
                n && "domain" === t.constrain || (t._input.domain = t.domain = t._inputDomain, delete t._inputDomain);
              }
            };
          }, {
            "../../constants/alignment": 469,
            "../../constants/numerical": 474,
            "../../lib": 495,
            "./autorange": 540,
            "./axis_ids": 544,
            "./scale_zoom": 557
          }],
          549: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("tinycolor2"),
              o = e("has-passive-events"),
              a = e("../../registry"),
              s = e("../../lib"),
              l = e("../../lib/svg_text_utils"),
              u = e("../../components/color"),
              c = e("../../components/drawing"),
              d = e("../../components/fx"),
              h = e("./axes"),
              f = e("../../lib/setcursor"),
              p = e("../../components/dragelement"),
              m = e("../../constants/alignment").FROM_TL,
              g = e("../../lib/clear_gl_canvases"),
              v = e("../../plot_api/subroutines").redrawReglTraces,
              y = e("../plots"),
              b = e("./axis_ids").getFromId,
              _ = e("./select").prepSelect,
              x = e("./select").clearSelect,
              w = e("./select").selectOnClick,
              S = e("./scale_zoom"),
              A = e("./constants"),
              E = A.MINDRAG,
              T = A.MINZOOM,
              M = !0;
            function C(e, t, n, r) {
              var i = s.ensureSingle(e.draglayer, t, n, function (t) {
                t.classed("drag", !0).style({
                  fill: "transparent",
                  "stroke-width": 0
                }).attr("data-subplot", e.id);
              });
              return i.call(f, r), i.node();
            }
            function k(e, t, n, i, o, a, s) {
              var l = C(e, "rect", t, n);
              return r.select(l).call(c.setRect, i, o, a, s), l;
            }
            function P(e, t) {
              for (var n = 0; n < e.length; n++) if (!e[n].fixedrange) return t;
              return "";
            }
            function O(e, t, n, r, i) {
              for (var o = 0; o < e.length; o++) {
                var a = e[o];
                if (!a.fixedrange) {
                  var s = a._rl[0],
                    l = a._rl[1] - s;
                  r[a._name + ".range[0]"] = a.l2r(s + l * t), r[a._name + ".range[1]"] = a.l2r(s + l * n);
                }
              }
              if (i && i.length) {
                var u = (t + (1 - n)) / 2;
                O(i, u, 1 - u, r, []);
              }
            }
            function R(e, t) {
              for (var n = 0; n < e.length; n++) {
                var r = e[n];
                r.fixedrange || (r.range = [r.l2r(r._rl[0] - t / r._m), r.l2r(r._rl[1] - t / r._m)]);
              }
            }
            function I(e) {
              return 1 - (e >= 0 ? Math.min(e, .9) : 1 / (1 / Math.max(e, -.3) + 3.222));
            }
            function j(e, t, n, r, i) {
              return e.append("path").attr("class", "zoombox").style({
                fill: t > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                "stroke-width": 0
              }).attr("transform", "translate(" + n + ", " + r + ")").attr("d", i + "Z");
            }
            function N(e, t, n) {
              return e.append("path").attr("class", "zoombox-corners").style({
                fill: u.background,
                stroke: u.defaultLine,
                "stroke-width": 1,
                opacity: 0
              }).attr("transform", "translate(" + t + ", " + n + ")").attr("d", "M0,0Z");
            }
            function L(e, t, n, r, i, o) {
              e.attr("d", r + "M" + n.l + "," + n.t + "v" + n.h + "h" + n.w + "v-" + n.h + "h-" + n.w + "Z"), D(e, t, i, o);
            }
            function D(e, t, n, r) {
              n || (e.transition().style("fill", r > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), t.transition().style("opacity", 1).duration(200));
            }
            function B(e) {
              r.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
            }
            function F(e) {
              M && e.data && e._context.showTips && (s.notifier(s._(e, "Double-click to zoom back out"), "long"), M = !1);
            }
            function z(e) {
              return "lasso" === e || "select" === e;
            }
            function U(e) {
              var t = Math.floor(Math.min(e.b - e.t, e.r - e.l, T) / 2);
              return "M" + (e.l - 3.5) + "," + (e.t - .5 + t) + "h3v" + -t + "h" + t + "v-3h-" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.t - .5 + t) + "h-3v" + -t + "h" + -t + "v-3h" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.b + .5 - t) + "h-3v" + t + "h" + -t + "v3h" + (t + 3) + "ZM" + (e.l - 3.5) + "," + (e.b + .5 - t) + "h3v" + t + "h" + t + "v3h-" + (t + 3) + "Z";
            }
            function G(e, t, n, r) {
              for (var i, o, a, l, u = !1, c = {}, d = {}, h = 0; h < t.length; h++) {
                var f = t[h];
                for (i in n) if (f[i]) {
                  for (a in f) ("x" === a.charAt(0) ? n : r)[a] || (c[a] = i);
                  for (o in r) f[o] && (u = !0);
                }
                for (o in r) if (f[o]) for (l in f) ("x" === l.charAt(0) ? n : r)[l] || (d[l] = o);
              }
              u && (s.extendFlat(c, d), d = {});
              var p = {},
                m = [];
              for (a in c) {
                var g = b(e, a);
                m.push(g), p[g._id] = g;
              }
              var v = {},
                y = [];
              for (l in d) {
                var _ = b(e, l);
                y.push(_), v[_._id] = _;
              }
              return {
                xaHash: p,
                yaHash: v,
                xaxes: m,
                yaxes: y,
                xLinks: c,
                yLinks: d,
                isSubplotConstrained: u
              };
            }
            function V(e, t) {
              if (o) {
                var n = void 0 !== e.onwheel ? "wheel" : "mousewheel";
                e._onwheel && e.removeEventListener(n, e._onwheel), e._onwheel = t, e.addEventListener(n, t, {
                  passive: !1
                });
              } else void 0 !== e.onwheel ? e.onwheel = t : void 0 !== e.onmousewheel && (e.onmousewheel = t);
            }
            function H(e) {
              var t = [];
              for (var n in e) t.push(e[n]);
              return t;
            }
            t.exports = {
              makeDragBox: function makeDragBox(e, t, n, o, u, f, M, C) {
                var D,
                  q,
                  W,
                  $,
                  X,
                  Y,
                  K,
                  Z,
                  Q,
                  J,
                  ee,
                  te,
                  ne,
                  re,
                  ie,
                  oe,
                  ae,
                  se,
                  le,
                  ue,
                  ce,
                  de = e._fullLayout._zoomlayer,
                  he = M + C === "nsew",
                  fe = 1 === (M + C).length;
                function pe() {
                  if (D = t.xaxis, q = t.yaxis, Q = D._length, J = q._length, K = D._offset, Z = q._offset, (W = {})[D._id] = D, ($ = {})[q._id] = q, M && C) for (var n = t.overlays, r = 0; r < n.length; r++) {
                    var i = n[r].xaxis;
                    W[i._id] = i;
                    var o = n[r].yaxis;
                    $[o._id] = o;
                  }
                  X = H(W), Y = H($), ne = P(X, C), re = P(Y, M), ie = !re && !ne, ee = G(e, e._fullLayout._axisConstraintGroups, W, $), te = G(e, e._fullLayout._axisMatchGroups, W, $), oe = C || ee.isSubplotConstrained || te.isSubplotConstrained, ae = M || ee.isSubplotConstrained || te.isSubplotConstrained;
                  var a = e._fullLayout;
                  se = a._has("scattergl"), le = a._has("splom"), ue = a._has("svg");
                }
                pe();
                var me = function (e, t, n) {
                    return e ? "nsew" === e ? n ? "" : "pan" === t ? "move" : "crosshair" : e.toLowerCase() + "-resize" : "pointer";
                  }(re + ne, e._fullLayout.dragmode, he),
                  ge = k(t, M + C + "drag", me, n, o, u, f);
                if (ie && !he) return ge.onmousedown = null, ge.style.pointerEvents = "none", ge;
                var ve,
                  ye,
                  be,
                  _e,
                  xe,
                  we,
                  Se,
                  Ae,
                  Ee,
                  Te,
                  Me = {
                    element: ge,
                    gd: e,
                    plotinfo: t
                  };
                function Ce() {
                  Me.plotinfo.selection = !1, x(e);
                }
                function ke(n, i) {
                  var o = e._fullLayout.clickmode;
                  if (B(e), 2 !== n || fe || function () {
                    if (!e._transitioningWithDuration) {
                      var t = e._context.doubleClick,
                        n = [];
                      ne && (n = n.concat(X)), re && (n = n.concat(Y)), te.xaxes && (n = n.concat(te.xaxes)), te.yaxes && (n = n.concat(te.yaxes));
                      var r,
                        i,
                        o,
                        s = {};
                      if ("reset+autosize" === t) for (t = "autosize", i = 0; i < n.length; i++) if ((r = n[i])._rangeInitial && (r.range[0] !== r._rangeInitial[0] || r.range[1] !== r._rangeInitial[1]) || !r._rangeInitial && !r.autorange) {
                        t = "reset";
                        break;
                      }
                      if ("autosize" === t) for (i = 0; i < n.length; i++) (r = n[i]).fixedrange || (s[r._name + ".autorange"] = !0);else if ("reset" === t) for ((ne || ee.isSubplotConstrained) && (n = n.concat(ee.xaxes)), re && !ee.isSubplotConstrained && (n = n.concat(ee.yaxes)), ee.isSubplotConstrained && (ne ? re || (n = n.concat(Y)) : n = n.concat(X)), i = 0; i < n.length; i++) (r = n[i]).fixedrange || (r._rangeInitial ? (o = r._rangeInitial, s[r._name + ".range[0]"] = o[0], s[r._name + ".range[1]"] = o[1]) : s[r._name + ".autorange"] = !0);
                      e.emit("plotly_doubleclick", null), a.call("_guiRelayout", e, s);
                    }
                  }(), he) o.indexOf("select") > -1 && w(i, e, X, Y, t.id, Me), o.indexOf("event") > -1 && d.click(e, i, t.id);else if (1 === n && fe) {
                    var s = M ? q : D,
                      u = "s" === M || "w" === C ? 0 : 1,
                      c = s._name + ".range[" + u + "]",
                      h = function (e, t) {
                        var n,
                          i = e.range[t],
                          o = Math.abs(i - e.range[1 - t]);
                        return "date" === e.type ? i : "log" === e.type ? (n = Math.ceil(Math.max(0, -Math.log(o) / Math.LN10)) + 3, r.format("." + n + "g")(Math.pow(10, i))) : (n = Math.floor(Math.log(Math.abs(i)) / Math.LN10) - Math.floor(Math.log(o) / Math.LN10) + 4, r.format("." + String(n) + "g")(i));
                      }(s, u),
                      f = "left",
                      p = "middle";
                    if (s.fixedrange) return;
                    M ? (p = "n" === M ? "top" : "bottom", "right" === s.side && (f = "right")) : "e" === C && (f = "right"), e._context.showAxisRangeEntryBoxes && r.select(ge).call(l.makeEditable, {
                      gd: e,
                      immediate: !0,
                      background: e._fullLayout.paper_bgcolor,
                      text: String(h),
                      fill: s.tickfont ? s.tickfont.color : "#444",
                      horizontalAlign: f,
                      verticalAlign: p
                    }).on("edit", function (t) {
                      var n = s.d2r(t);
                      void 0 !== n && a.call("_guiRelayout", e, c, n);
                    });
                  }
                }
                function Pe(t, n) {
                  if (e._transitioningWithDuration) return !1;
                  var r = Math.max(0, Math.min(Q, t + ve)),
                    i = Math.max(0, Math.min(J, n + ye)),
                    o = Math.abs(r - ve),
                    a = Math.abs(i - ye);
                  function s() {
                    Se = "", be.r = be.l, be.t = be.b, Ee.attr("d", "M0,0Z");
                  }
                  if (be.l = Math.min(ve, r), be.r = Math.max(ve, r), be.t = Math.min(ye, i), be.b = Math.max(ye, i), ee.isSubplotConstrained) o > T || a > T ? (Se = "xy", o / Q > a / J ? (a = o * J / Q, ye > i ? be.t = ye - a : be.b = ye + a) : (o = a * Q / J, ve > r ? be.l = ve - o : be.r = ve + o), Ee.attr("d", U(be))) : s();else if (te.isSubplotConstrained) {
                    if (o > T || a > T) {
                      Se = "xy";
                      var l = Math.min(be.l / Q, (J - be.b) / J),
                        u = Math.max(be.r / Q, (J - be.t) / J);
                      be.l = l * Q, be.r = u * Q, be.b = (1 - l) * J, be.t = (1 - u) * J, Ee.attr("d", U(be));
                    } else s();
                  } else !re || a < Math.min(Math.max(.6 * o, E), T) ? o < E || !ne ? s() : (be.t = 0, be.b = J, Se = "x", Ee.attr("d", function (e, t) {
                    return "M" + (e.l - .5) + "," + (t - T - .5) + "h-3v" + (2 * T + 1) + "h3ZM" + (e.r + .5) + "," + (t - T - .5) + "h3v" + (2 * T + 1) + "h-3Z";
                  }(be, ye))) : !ne || o < Math.min(.6 * a, T) ? (be.l = 0, be.r = Q, Se = "y", Ee.attr("d", function (e, t) {
                    return "M" + (t - T - .5) + "," + (e.t - .5) + "v-3h" + (2 * T + 1) + "v3ZM" + (t - T - .5) + "," + (e.b + .5) + "v3h" + (2 * T + 1) + "v-3Z";
                  }(be, ve))) : (Se = "xy", Ee.attr("d", U(be)));
                  be.w = be.r - be.l, be.h = be.b - be.t, Se && (Te = !0), e._dragged = Te, L(Ae, Ee, be, xe, we, _e), Oe(), e.emit("plotly_relayouting", ce), we = !0;
                }
                function Oe() {
                  ce = {}, "xy" !== Se && "x" !== Se || (O(X, be.l / Q, be.r / Q, ce, ee.xaxes), Be("x", ce)), "xy" !== Se && "y" !== Se || (O(Y, (J - be.b) / J, (J - be.t) / J, ce, ee.yaxes), Be("y", ce));
                }
                function Re() {
                  Oe(), B(e), ze(), F(e);
                }
                Me.prepFn = function (t, n, r) {
                  var o = Me.dragmode,
                    a = e._fullLayout.dragmode;
                  a !== o && (Me.dragmode = a), pe(), ie || (he ? t.shiftKey ? "pan" === a ? a = "zoom" : z(a) || (a = "pan") : t.ctrlKey && (a = "pan") : a = "pan"), Me.minDrag = "lasso" === a ? 1 : void 0, z(a) ? (Me.xaxes = X, Me.yaxes = Y, _(t, n, r, Me, a)) : (Me.clickFn = ke, z(o) && Ce(), ie || ("zoom" === a ? (Me.moveFn = Pe, Me.doneFn = Re, Me.minDrag = 1, function (t, n, r) {
                    var o = ge.getBoundingClientRect();
                    ve = n - o.left, ye = r - o.top, be = {
                      l: ve,
                      r: ve,
                      w: 0,
                      t: ye,
                      b: ye,
                      h: 0
                    }, _e = e._hmpixcount ? e._hmlumcount / e._hmpixcount : i(e._fullLayout.plot_bgcolor).getLuminance(), we = !1, Se = "xy", Te = !1, Ae = j(de, _e, K, Z, xe = "M0,0H" + Q + "V" + J + "H0V0"), Ee = N(de, K, Z);
                  }(0, n, r)) : "pan" === a && (Me.moveFn = De, Me.doneFn = ze))), e._fullLayout._redrag = function () {
                    var t = e._dragdata;
                    t && t.element === ge && (z(e._fullLayout.dragmode) || (pe(), Ue([0, 0, Q, J]), Me.moveFn(t.dx, t.dy)));
                  };
                }, p.init(Me);
                var Ie = [0, 0, Q, J],
                  je = null,
                  Ne = A.REDRAWDELAY,
                  Le = t.mainplot ? e._fullLayout._plots[t.mainplot] : t;
                function De(t, n) {
                  if (!e._transitioningWithDuration) {
                    if (e._fullLayout._replotting = !0, "ew" === ne || "ns" === re) return ne && (R(X, t), Be("x")), re && (R(Y, n), Be("y")), Ue([ne ? -t : 0, re ? -n : 0, Q, J]), Fe(), void e.emit("plotly_relayouting", ce);
                    if (ee.isSubplotConstrained && ne && re) {
                      var r = "w" === ne == ("n" === re) ? 1 : -1,
                        i = (t / Q + r * n / J) / 2;
                      t = i * Q, n = r * i * J;
                    }
                    "w" === ne ? t = l(X, 0, t) : "e" === ne ? t = l(X, 1, -t) : ne || (t = 0), "n" === re ? n = l(Y, 1, n) : "s" === re ? n = l(Y, 0, -n) : re || (n = 0);
                    var o = "w" === ne ? t : 0,
                      a = "n" === re ? n : 0;
                    if (ee.isSubplotConstrained) {
                      var s;
                      if (!ne && 1 === re.length) {
                        for (s = 0; s < X.length; s++) X[s].range = X[s]._r.slice(), S(X[s], 1 - n / J);
                        o = (t = n * Q / J) / 2;
                      }
                      if (!re && 1 === ne.length) {
                        for (s = 0; s < Y.length; s++) Y[s].range = Y[s]._r.slice(), S(Y[s], 1 - t / Q);
                        a = (n = t * J / Q) / 2;
                      }
                    }
                    Be("x"), Be("y"), Ue([o, a, Q - t, J - n]), Fe(), e.emit("plotly_relayouting", ce);
                  }
                  function l(e, t, n) {
                    for (var r, i, o = 1 - t, a = 0; a < e.length; a++) {
                      var s = e[a];
                      if (!s.fixedrange) {
                        r = s, i = s._rl[o] + (s._rl[t] - s._rl[o]) / I(n / s._length);
                        var l = s.l2r(i);
                        !1 !== l && void 0 !== l && (s.range[t] = l);
                      }
                    }
                    return r._length * (r._rl[t] - i) / (r._rl[t] - r._rl[o]);
                  }
                }
                function Be(e, t) {
                  for (var n = te.isSubplotConstrained ? {
                      x: Y,
                      y: X
                    }[e] : te[e + "axes"], r = te.isSubplotConstrained ? {
                      x: X,
                      y: Y
                    }[e] : [], i = 0; i < n.length; i++) {
                    var o = n[i],
                      a = o._id,
                      s = te.xLinks[a] || te.yLinks[a],
                      l = r[0] || W[s] || $[s];
                    l && (t ? (t[o._name + ".range[0]"] = t[l._name + ".range[0]"], t[o._name + ".range[1]"] = t[l._name + ".range[1]"]) : o.range = l.range.slice());
                  }
                }
                function Fe() {
                  var t,
                    n = [];
                  function r(e) {
                    for (t = 0; t < e.length; t++) e[t].fixedrange || n.push(e[t]._id);
                  }
                  for (oe && (r(X), r(ee.xaxes), r(te.xaxes)), ae && (r(Y), r(ee.yaxes), r(te.yaxes)), ce = {}, t = 0; t < n.length; t++) {
                    var i = n[t],
                      o = b(e, i);
                    h.drawOne(e, o, {
                      skipTitle: !0
                    }), ce[o._name + ".range[0]"] = o.range[0], ce[o._name + ".range[1]"] = o.range[1];
                  }
                  h.redrawComponents(e, n);
                }
                function ze() {
                  Ue([0, 0, Q, J]), s.syncOrAsync([y.previousPromises, function () {
                    e._fullLayout._replotting = !1, a.call("_guiRelayout", e, ce);
                  }], e);
                }
                function Ue(t) {
                  var n,
                    r,
                    i,
                    o,
                    l = e._fullLayout,
                    u = l._plots,
                    d = l._subplots.cartesian;
                  if (le && a.subplotsRegistry.splom.drag(e), se) for (n = 0; n < d.length; n++) if (i = (r = u[d[n]]).xaxis, o = r.yaxis, r._scene) {
                    var h = s.simpleMap(i.range, i.r2l),
                      f = s.simpleMap(o.range, o.r2l);
                    r._scene.update({
                      range: [h[0], f[0], h[1], f[1]]
                    });
                  }
                  if ((le || se) && (g(e), v(e)), ue) {
                    var p = t[2] / D._length,
                      m = t[3] / q._length;
                    for (n = 0; n < d.length; n++) {
                      i = (r = u[d[n]]).xaxis, o = r.yaxis;
                      var y,
                        b,
                        _,
                        x,
                        w = oe && !i.fixedrange && W[i._id],
                        S = ae && !o.fixedrange && $[o._id];
                      if (w ? (y = p, _ = C ? t[0] : He(i, y)) : te.xaHash[i._id] ? (y = p, _ = t[0] * i._length / D._length) : te.yaHash[i._id] ? (y = m, _ = "ns" === re ? -t[1] * i._length / q._length : He(i, y, {
                        n: "top",
                        s: "bottom"
                      }[re])) : _ = Ve(i, y = Ge(i, p, m)), S ? (b = m, x = M ? t[1] : He(o, b)) : te.yaHash[o._id] ? (b = m, x = t[1] * o._length / q._length) : te.xaHash[o._id] ? (b = p, x = "ew" === ne ? -t[0] * o._length / D._length : He(o, b, {
                        e: "right",
                        w: "left"
                      }[ne])) : x = Ve(o, b = Ge(o, p, m)), y || b) {
                        y || (y = 1), b || (b = 1);
                        var A = i._offset - _ / y,
                          E = o._offset - x / b;
                        r.clipRect.call(c.setTranslate, _, x).call(c.setScale, y, b), r.plot.call(c.setTranslate, A, E).call(c.setScale, 1 / y, 1 / b), y === r.xScaleFactor && b === r.yScaleFactor || (c.setPointGroupScale(r.zoomScalePts, y, b), c.setTextPointsScale(r.zoomScaleTxt, y, b)), c.hideOutsideRangePoints(r.clipOnAxisFalseTraces, r), r.xScaleFactor = y, r.yScaleFactor = b;
                      }
                    }
                  }
                }
                function Ge(e, t, n) {
                  return e.fixedrange ? 0 : oe && ee.xaHash[e._id] ? t : ae && (ee.isSubplotConstrained ? ee.xaHash : ee.yaHash)[e._id] ? n : 0;
                }
                function Ve(e, t) {
                  return t ? (e.range = e._r.slice(), S(e, t), He(e, t)) : 0;
                }
                function He(e, t, n) {
                  return e._length * (1 - t) * m[n || e.constraintoward || "middle"];
                }
                return M.length * C.length != 1 && V(ge, function (t) {
                  if (e._context._scrollZoom.cartesian || e._fullLayout._enablescrollzoom) {
                    if (Ce(), e._transitioningWithDuration) return t.preventDefault(), void t.stopPropagation();
                    pe(), clearTimeout(je);
                    var n = -t.deltaY;
                    if (isFinite(n) || (n = t.wheelDelta / 10), isFinite(n)) {
                      var r,
                        i = Math.exp(-Math.min(Math.max(n, -20), 20) / 200),
                        o = Le.draglayer.select(".nsewdrag").node().getBoundingClientRect(),
                        a = (t.clientX - o.left) / o.width,
                        l = (o.bottom - t.clientY) / o.height;
                      if (oe) {
                        for (C || (a = .5), r = 0; r < X.length; r++) u(X[r], a, i);
                        Be("x"), Ie[2] *= i, Ie[0] += Ie[2] * a * (1 / i - 1);
                      }
                      if (ae) {
                        for (M || (l = .5), r = 0; r < Y.length; r++) u(Y[r], l, i);
                        Be("y"), Ie[3] *= i, Ie[1] += Ie[3] * (1 - l) * (1 / i - 1);
                      }
                      Ue(Ie), Fe(), e.emit("plotly_relayouting", ce), je = setTimeout(function () {
                        Ie = [0, 0, Q, J], ze();
                      }, Ne), t.preventDefault();
                    } else s.log("Did not find wheel motion attributes: ", t);
                  }
                  function u(e, t, n) {
                    if (!e.fixedrange) {
                      var r = s.simpleMap(e.range, e.r2l),
                        i = r[0] + (r[1] - r[0]) * t;
                      e.range = r.map(function (t) {
                        return e.l2r(i + (t - i) * n);
                      });
                    }
                  }
                }), ge;
              },
              makeDragger: C,
              makeRectDragger: k,
              makeZoombox: j,
              makeCorners: N,
              updateZoombox: L,
              xyCorners: U,
              transitionZoombox: D,
              removeZoombox: B,
              showDoubleClickNotifier: F,
              attachWheelEventHandler: V
            };
          }, {
            "../../components/color": 375,
            "../../components/dragelement": 393,
            "../../components/drawing": 396,
            "../../components/fx": 413,
            "../../constants/alignment": 469,
            "../../lib": 495,
            "../../lib/clear_gl_canvases": 483,
            "../../lib/setcursor": 514,
            "../../lib/svg_text_utils": 518,
            "../../plot_api/subroutines": 532,
            "../../registry": 593,
            "../plots": 584,
            "./axes": 541,
            "./axis_ids": 544,
            "./constants": 547,
            "./scale_zoom": 557,
            "./select": 558,
            d3: 82,
            "has-passive-events": 251,
            tinycolor2: 341
          }],
          550: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../components/fx"),
              o = e("../../components/dragelement"),
              a = e("../../lib/setcursor"),
              s = e("./dragbox").makeDragBox,
              l = e("./constants").DRAGGERSIZE;
            n.initInteractions = function (e) {
              var t = e._fullLayout;
              if (e._context.staticPlot) r.select(e).selectAll(".drag").remove();else if (t._has("cartesian") || t._has("splom")) {
                Object.keys(t._plots || {}).sort(function (e, n) {
                  if ((t._plots[e].mainplot && !0) === (t._plots[n].mainplot && !0)) {
                    var r = e.split("y"),
                      i = n.split("y");
                    return r[0] === i[0] ? Number(r[1] || 1) - Number(i[1] || 1) : Number(r[0] || 1) - Number(i[0] || 1);
                  }
                  return t._plots[e].mainplot ? 1 : -1;
                }).forEach(function (n) {
                  var r = t._plots[n],
                    a = r.xaxis,
                    u = r.yaxis;
                  if (!r.mainplot) {
                    var c = s(e, r, a._offset, u._offset, a._length, u._length, "ns", "ew");
                    c.onmousemove = function (t) {
                      e._fullLayout._rehover = function () {
                        e._fullLayout._hoversubplot === n && e._fullLayout._plots[n] && i.hover(e, t, n);
                      }, i.hover(e, t, n), e._fullLayout._lasthover = c, e._fullLayout._hoversubplot = n;
                    }, c.onmouseout = function (t) {
                      e._dragging || (e._fullLayout._hoversubplot = null, o.unhover(e, t));
                    }, e._context.showAxisDragHandles && (s(e, r, a._offset - l, u._offset - l, l, l, "n", "w"), s(e, r, a._offset + a._length, u._offset - l, l, l, "n", "e"), s(e, r, a._offset - l, u._offset + u._length, l, l, "s", "w"), s(e, r, a._offset + a._length, u._offset + u._length, l, l, "s", "e"));
                  }
                  if (e._context.showAxisDragHandles) {
                    if (n === a._mainSubplot) {
                      var d = a._mainLinePosition;
                      "top" === a.side && (d -= l), s(e, r, a._offset + .1 * a._length, d, .8 * a._length, l, "", "ew"), s(e, r, a._offset, d, .1 * a._length, l, "", "w"), s(e, r, a._offset + .9 * a._length, d, .1 * a._length, l, "", "e");
                    }
                    if (n === u._mainSubplot) {
                      var h = u._mainLinePosition;
                      "right" !== u.side && (h -= l), s(e, r, h, u._offset + .1 * u._length, l, .8 * u._length, "ns", ""), s(e, r, h, u._offset + .9 * u._length, l, .1 * u._length, "s", ""), s(e, r, h, u._offset, l, .1 * u._length, "n", "");
                    }
                  }
                });
                var a = t._hoverlayer.node();
                a.onmousemove = function (n) {
                  n.target = e._fullLayout._lasthover, i.hover(e, n, t._hoversubplot);
                }, a.onclick = function (t) {
                  t.target = e._fullLayout._lasthover, i.click(e, t);
                }, a.onmousedown = function (t) {
                  e._fullLayout._lasthover.onmousedown(t);
                }, n.updateFx(e);
              }
            }, n.updateFx = function (e) {
              var t = e._fullLayout,
                n = "pan" === t.dragmode ? "move" : "crosshair";
              a(t._draggers, n);
            };
          }, {
            "../../components/dragelement": 393,
            "../../components/fx": 413,
            "../../lib/setcursor": 514,
            "./constants": 547,
            "./dragbox": 549,
            d3: 82
          }],
          551: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib");
            t.exports = function (e) {
              return function (t, n) {
                var o = t[e];
                if (Array.isArray(o)) for (var a = r.subplotsRegistry.cartesian, s = a.idRegex, l = n._subplots, u = l.xaxis, c = l.yaxis, d = l.cartesian, h = n._has("cartesian") || n._has("gl2d"), f = 0; f < o.length; f++) {
                  var p = o[f];
                  if (i.isPlainObject(p)) {
                    var m = p.xref,
                      g = p.yref,
                      v = s.x.test(m),
                      y = s.y.test(g);
                    if (v || y) {
                      h || i.pushUnique(n._basePlotModules, a);
                      var b = !1;
                      v && -1 === u.indexOf(m) && (u.push(m), b = !0), y && -1 === c.indexOf(g) && (c.push(g), b = !0), b && v && y && d.push(m + g);
                    }
                  }
                }
              };
            };
          }, {
            "../../lib": 495,
            "../../registry": 593
          }],
          552: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../lib"),
              a = e("../plots"),
              s = e("../../components/drawing"),
              l = e("../get_data").getModuleCalcData,
              u = e("./axis_ids"),
              c = e("./constants"),
              d = e("../../constants/xmlns_namespaces"),
              h = o.ensureSingle;
            function f(e, t, n) {
              return o.ensureSingle(e, t, n, function (e) {
                e.datum(n);
              });
            }
            function p(e, t, n, o, a) {
              for (var u, d, h, f = c.traceLayerClasses, p = e._fullLayout, m = p._modules, g = [], v = [], y = 0; y < m.length; y++) {
                var b = (u = m[y]).name,
                  _ = i.modules[b].categories;
                if (_.svg) {
                  var x = u.layerName || b + "layer",
                    w = u.plot;
                  h = (d = l(n, w))[0], n = d[1], h.length && g.push({
                    i: f.indexOf(x),
                    className: x,
                    plotMethod: w,
                    cdModule: h
                  }), _.zoomScale && v.push("." + x);
                }
              }
              g.sort(function (e, t) {
                return e.i - t.i;
              });
              var S = t.plot.selectAll("g.mlayer").data(g, function (e) {
                return e.className;
              });
              if (S.enter().append("g").attr("class", function (e) {
                return e.className;
              }).classed("mlayer", !0).classed("rangeplot", t.isRangePlot), S.exit().remove(), S.order(), S.each(function (n) {
                var i = r.select(this),
                  l = n.className;
                n.plotMethod(e, t, n.cdModule, i, o, a), -1 === c.clipOnAxisFalseQuery.indexOf("." + l) && s.setClipUrl(i, t.layerClipId, e);
              }), p._has("scattergl") && (u = i.getModule("scattergl"), h = l(n, u)[0], u.plot(e, t, h)), !e._context.staticPlot && (t._hasClipOnAxisFalse && (t.clipOnAxisFalseTraces = t.plot.selectAll(c.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), v.length)) {
                var A = t.plot.selectAll(v.join(",")).selectAll(".trace");
                t.zoomScalePts = A.selectAll("path.point"), t.zoomScaleTxt = A.selectAll(".textpoint");
              }
            }
            function m(e, t) {
              var n = t.plotgroup,
                r = t.id,
                i = c.layerValue2layerClass[t.xaxis.layer],
                o = c.layerValue2layerClass[t.yaxis.layer],
                a = e._fullLayout._hasOnlyLargeSploms;
              if (t.mainplot) {
                var s = t.mainplotinfo,
                  l = s.plotgroup,
                  d = r + "-x",
                  p = r + "-y";
                t.gridlayer = s.gridlayer, t.zerolinelayer = s.zerolinelayer, h(s.overlinesBelow, "path", d), h(s.overlinesBelow, "path", p), h(s.overaxesBelow, "g", d), h(s.overaxesBelow, "g", p), t.plot = h(s.overplot, "g", r), h(s.overlinesAbove, "path", d), h(s.overlinesAbove, "path", p), h(s.overaxesAbove, "g", d), h(s.overaxesAbove, "g", p), t.xlines = l.select(".overlines-" + i).select("." + d), t.ylines = l.select(".overlines-" + o).select("." + p), t.xaxislayer = l.select(".overaxes-" + i).select("." + d), t.yaxislayer = l.select(".overaxes-" + o).select("." + p);
              } else if (a) t.xlines = h(n, "path", "xlines-above"), t.ylines = h(n, "path", "ylines-above"), t.xaxislayer = h(n, "g", "xaxislayer-above"), t.yaxislayer = h(n, "g", "yaxislayer-above");else {
                var m = h(n, "g", "layer-subplot");
                t.shapelayer = h(m, "g", "shapelayer"), t.imagelayer = h(m, "g", "imagelayer"), t.gridlayer = h(n, "g", "gridlayer"), t.zerolinelayer = h(n, "g", "zerolinelayer"), h(n, "path", "xlines-below"), h(n, "path", "ylines-below"), t.overlinesBelow = h(n, "g", "overlines-below"), h(n, "g", "xaxislayer-below"), h(n, "g", "yaxislayer-below"), t.overaxesBelow = h(n, "g", "overaxes-below"), t.plot = h(n, "g", "plot"), t.overplot = h(n, "g", "overplot"), t.xlines = h(n, "path", "xlines-above"), t.ylines = h(n, "path", "ylines-above"), t.overlinesAbove = h(n, "g", "overlines-above"), h(n, "g", "xaxislayer-above"), h(n, "g", "yaxislayer-above"), t.overaxesAbove = h(n, "g", "overaxes-above"), t.xlines = n.select(".xlines-" + i), t.ylines = n.select(".ylines-" + o), t.xaxislayer = n.select(".xaxislayer-" + i), t.yaxislayer = n.select(".yaxislayer-" + o);
              }
              a || (f(t.gridlayer, "g", t.xaxis._id), f(t.gridlayer, "g", t.yaxis._id), t.gridlayer.selectAll("g").map(function (e) {
                return e[0];
              }).sort(u.idSort)), t.xlines.style("fill", "none").classed("crisp", !0), t.ylines.style("fill", "none").classed("crisp", !0);
            }
            function g(e, t) {
              if (e) {
                var n = {};
                for (var i in e.each(function (e) {
                  var i = e[0];
                  r.select(this).remove(), v(i, t), n[i] = !0;
                }), t._plots) for (var o = t._plots[i].overlays || [], a = 0; a < o.length; a++) {
                  var s = o[a];
                  n[s.id] && s.plot.selectAll(".trace").remove();
                }
              }
            }
            function v(e, t) {
              t._draggers.selectAll("g." + e).remove(), t._defs.select("#clip" + t._uid + e + "plot").remove();
            }
            n.name = "cartesian", n.attr = ["xaxis", "yaxis"], n.idRoot = ["x", "y"], n.idRegex = c.idRegex, n.attrRegex = c.attrRegex, n.attributes = e("./attributes"), n.layoutAttributes = e("./layout_attributes"), n.supplyLayoutDefaults = e("./layout_defaults"), n.transitionAxes = e("./transition_axes"), n.finalizeSubplots = function (e, t) {
              var n,
                r,
                i,
                a = t._subplots,
                s = a.xaxis,
                l = a.yaxis,
                d = a.cartesian,
                h = d.concat(a.gl2d || []),
                f = {},
                p = {};
              for (n = 0; n < h.length; n++) {
                var m = h[n].split("y");
                f[m[0]] = 1, p["y" + m[1]] = 1;
              }
              for (n = 0; n < s.length; n++) f[r = s[n]] || (i = (e[u.id2name(r)] || {}).anchor, c.idRegex.y.test(i) || (i = "y"), d.push(r + i), h.push(r + i), p[i] || (p[i] = 1, o.pushUnique(l, i)));
              for (n = 0; n < l.length; n++) p[i = l[n]] || (r = (e[u.id2name(i)] || {}).anchor, c.idRegex.x.test(r) || (r = "x"), d.push(r + i), h.push(r + i), f[r] || (f[r] = 1, o.pushUnique(s, r)));
              if (!h.length) {
                for (var g in r = "", i = "", e) c.attrRegex.test(g) && ("x" === g.charAt(0) ? (!r || +g.substr(5) < +r.substr(5)) && (r = g) : (!i || +g.substr(5) < +i.substr(5)) && (i = g));
                r = r ? u.name2id(r) : "x", i = i ? u.name2id(i) : "y", s.push(r), l.push(i), d.push(r + i);
              }
            }, n.plot = function (e, t, n, r) {
              var i,
                o = e._fullLayout,
                a = o._subplots.cartesian,
                s = e.calcdata;
              if (!Array.isArray(t)) for (t = [], i = 0; i < s.length; i++) t.push(i);
              for (i = 0; i < a.length; i++) {
                for (var l, u = a[i], c = o._plots[u], d = [], h = 0; h < s.length; h++) {
                  var f = s[h],
                    m = f[0].trace;
                  m.xaxis + m.yaxis === u && ((-1 !== t.indexOf(m.index) || m.carpet) && (l && l[0].trace.xaxis + l[0].trace.yaxis === u && -1 !== ["tonextx", "tonexty", "tonext"].indexOf(m.fill) && -1 === d.indexOf(l) && d.push(l), d.push(f)), l = f);
                }
                p(e, c, d, n, r);
              }
            }, n.clean = function (e, t, n, r) {
              var i,
                o,
                a,
                s = r._plots || {},
                l = t._plots || {},
                c = r._subplots || {};
              if (r._hasOnlyLargeSploms && !t._hasOnlyLargeSploms) for (a in s) (i = s[a]).plotgroup && i.plotgroup.remove();
              var d = r._has && r._has("gl"),
                h = t._has && t._has("gl");
              if (d && !h) for (a in s) (i = s[a])._scene && i._scene.destroy();
              if (c.xaxis && c.yaxis) {
                var f = u.listIds({
                  _fullLayout: r
                });
                for (o = 0; o < f.length; o++) {
                  var p = f[o];
                  t[u.id2name(p)] || r._infolayer.selectAll(".g-" + p + "title").remove();
                }
              }
              var m = r._has && r._has("cartesian"),
                y = t._has && t._has("cartesian");
              if (m && !y) g(r._cartesianlayer.selectAll(".subplot"), r), r._defs.selectAll(".axesclip").remove(), delete r._axisConstraintGroups;else if (c.cartesian) for (o = 0; o < c.cartesian.length; o++) {
                var b = c.cartesian[o];
                if (!l[b]) {
                  var _ = "." + b + ",." + b + "-x,." + b + "-y";
                  r._cartesianlayer.selectAll(_).remove(), v(b, r);
                }
              }
            }, n.drawFramework = function (e) {
              var t = e._fullLayout,
                n = function (e) {
                  var t,
                    n,
                    r,
                    i,
                    o,
                    a,
                    s = e._fullLayout,
                    l = s._subplots.cartesian,
                    u = l.length,
                    c = [],
                    d = [];
                  for (t = 0; t < u; t++) {
                    r = l[t], o = (i = s._plots[r]).xaxis, a = i.yaxis;
                    var h = o._mainAxis,
                      f = a._mainAxis,
                      p = h._id + f._id,
                      m = s._plots[p];
                    i.overlays = [], p !== r && m ? (i.mainplot = p, i.mainplotinfo = m, d.push(r)) : (i.mainplot = void 0, i.mainPlotinfo = void 0, c.push(r));
                  }
                  for (t = 0; t < d.length; t++) r = d[t], (i = s._plots[r]).mainplotinfo.overlays.push(i);
                  var g = c.concat(d),
                    v = new Array(u);
                  for (t = 0; t < u; t++) {
                    r = g[t], o = (i = s._plots[r]).xaxis, a = i.yaxis;
                    var y = [r, o.layer, a.layer, o.overlaying || "", a.overlaying || ""];
                    for (n = 0; n < i.overlays.length; n++) y.push(i.overlays[n].id);
                    v[t] = y;
                  }
                  return v;
                }(e),
                i = t._cartesianlayer.selectAll(".subplot").data(n, String);
              i.enter().append("g").attr("class", function (e) {
                return "subplot " + e[0];
              }), i.order(), i.exit().call(g, t), i.each(function (n) {
                var i = n[0],
                  o = t._plots[i];
                o.plotgroup = r.select(this), m(e, o), o.draglayer = h(t._draggers, "g", i);
              });
            }, n.rangePlot = function (e, t, n) {
              m(e, t), p(e, t, n), a.style(e);
            }, n.toSVG = function (e) {
              var t = e._fullLayout._glimages,
                n = r.select(e).selectAll(".svg-container");
              n.filter(function (e, t) {
                return t === n.size() - 1;
              }).selectAll(".gl-canvas-context, .gl-canvas-focus").each(function () {
                var e = this.toDataURL("image/png");
                t.append("svg:image").attr({
                  xmlns: d.svg,
                  "xlink:href": e,
                  preserveAspectRatio: "none",
                  x: 0,
                  y: 0,
                  width: this.width,
                  height: this.height
                });
              });
            }, n.updateFx = e("./graph_interact").updateFx;
          }, {
            "../../components/drawing": 396,
            "../../constants/xmlns_namespaces": 475,
            "../../lib": 495,
            "../../registry": 593,
            "../get_data": 569,
            "../plots": 584,
            "./attributes": 539,
            "./axis_ids": 544,
            "./constants": 547,
            "./graph_interact": 550,
            "./layout_attributes": 553,
            "./layout_defaults": 554,
            "./transition_axes": 563,
            d3: 82
          }],
          553: [function (e, t, n) {
            "use strict";

            var r = e("../font_attributes"),
              i = e("../../components/color/attributes"),
              o = e("../../components/drawing/attributes").dash,
              a = e("../../lib/extend").extendFlat,
              s = e("../../plot_api/plot_template").templatedArray,
              l = (e("../../constants/docs").FORMAT_LINK, e("../../constants/docs").DATE_FORMAT_LINK, e("./constants"));
            t.exports = {
              visible: {
                valType: "boolean",
                editType: "plot"
              },
              color: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "ticks"
              },
              title: {
                text: {
                  valType: "string",
                  editType: "ticks"
                },
                font: r({
                  editType: "ticks"
                }),
                standoff: {
                  valType: "number",
                  min: 0,
                  editType: "ticks"
                },
                editType: "ticks"
              },
              type: {
                valType: "enumerated",
                values: ["-", "linear", "log", "date", "category", "multicategory"],
                dflt: "-",
                editType: "calc",
                _noTemplating: !0
              },
              autorange: {
                valType: "enumerated",
                values: [!0, !1, "reversed"],
                dflt: !0,
                editType: "axrange",
                impliedEdits: {
                  "range[0]": void 0,
                  "range[1]": void 0
                }
              },
              rangemode: {
                valType: "enumerated",
                values: ["normal", "tozero", "nonnegative"],
                dflt: "normal",
                editType: "plot"
              },
              range: {
                valType: "info_array",
                items: [{
                  valType: "any",
                  editType: "axrange",
                  impliedEdits: {
                    "^autorange": !1
                  },
                  anim: !0
                }, {
                  valType: "any",
                  editType: "axrange",
                  impliedEdits: {
                    "^autorange": !1
                  },
                  anim: !0
                }],
                editType: "axrange",
                impliedEdits: {
                  autorange: !1
                },
                anim: !0
              },
              fixedrange: {
                valType: "boolean",
                dflt: !1,
                editType: "calc"
              },
              scaleanchor: {
                valType: "enumerated",
                values: [l.idRegex.x.toString(), l.idRegex.y.toString()],
                editType: "plot"
              },
              scaleratio: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "plot"
              },
              constrain: {
                valType: "enumerated",
                values: ["range", "domain"],
                dflt: "range",
                editType: "plot"
              },
              constraintoward: {
                valType: "enumerated",
                values: ["left", "center", "right", "top", "middle", "bottom"],
                editType: "plot"
              },
              matches: {
                valType: "enumerated",
                values: [l.idRegex.x.toString(), l.idRegex.y.toString()],
                editType: "calc"
              },
              tickmode: {
                valType: "enumerated",
                values: ["auto", "linear", "array"],
                editType: "ticks",
                impliedEdits: {
                  tick0: void 0,
                  dtick: void 0
                }
              },
              nticks: {
                valType: "integer",
                min: 0,
                dflt: 0,
                editType: "ticks"
              },
              tick0: {
                valType: "any",
                editType: "ticks",
                impliedEdits: {
                  tickmode: "linear"
                }
              },
              dtick: {
                valType: "any",
                editType: "ticks",
                impliedEdits: {
                  tickmode: "linear"
                }
              },
              tickvals: {
                valType: "data_array",
                editType: "ticks"
              },
              ticktext: {
                valType: "data_array",
                editType: "ticks"
              },
              ticks: {
                valType: "enumerated",
                values: ["outside", "inside", ""],
                editType: "ticks"
              },
              tickson: {
                valType: "enumerated",
                values: ["labels", "boundaries"],
                dflt: "labels",
                editType: "ticks"
              },
              mirror: {
                valType: "enumerated",
                values: [!0, "ticks", !1, "all", "allticks"],
                dflt: !1,
                editType: "ticks+layoutstyle"
              },
              ticklen: {
                valType: "number",
                min: 0,
                dflt: 5,
                editType: "ticks"
              },
              tickwidth: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "ticks"
              },
              tickcolor: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "ticks"
              },
              showticklabels: {
                valType: "boolean",
                dflt: !0,
                editType: "ticks"
              },
              automargin: {
                valType: "boolean",
                dflt: !1,
                editType: "ticks"
              },
              showspikes: {
                valType: "boolean",
                dflt: !1,
                editType: "modebar"
              },
              spikecolor: {
                valType: "color",
                dflt: null,
                editType: "none"
              },
              spikethickness: {
                valType: "number",
                dflt: 3,
                editType: "none"
              },
              spikedash: a({}, o, {
                dflt: "dash",
                editType: "none"
              }),
              spikemode: {
                valType: "flaglist",
                flags: ["toaxis", "across", "marker"],
                dflt: "toaxis",
                editType: "none"
              },
              spikesnap: {
                valType: "enumerated",
                values: ["data", "cursor"],
                dflt: "data",
                editType: "none"
              },
              tickfont: r({
                editType: "ticks"
              }),
              tickangle: {
                valType: "angle",
                dflt: "auto",
                editType: "ticks"
              },
              tickprefix: {
                valType: "string",
                dflt: "",
                editType: "ticks"
              },
              showtickprefix: {
                valType: "enumerated",
                values: ["all", "first", "last", "none"],
                dflt: "all",
                editType: "ticks"
              },
              ticksuffix: {
                valType: "string",
                dflt: "",
                editType: "ticks"
              },
              showticksuffix: {
                valType: "enumerated",
                values: ["all", "first", "last", "none"],
                dflt: "all",
                editType: "ticks"
              },
              showexponent: {
                valType: "enumerated",
                values: ["all", "first", "last", "none"],
                dflt: "all",
                editType: "ticks"
              },
              exponentformat: {
                valType: "enumerated",
                values: ["none", "e", "E", "power", "SI", "B"],
                dflt: "B",
                editType: "ticks"
              },
              separatethousands: {
                valType: "boolean",
                dflt: !1,
                editType: "ticks"
              },
              tickformat: {
                valType: "string",
                dflt: "",
                editType: "ticks"
              },
              tickformatstops: s("tickformatstop", {
                enabled: {
                  valType: "boolean",
                  dflt: !0,
                  editType: "ticks"
                },
                dtickrange: {
                  valType: "info_array",
                  items: [{
                    valType: "any",
                    editType: "ticks"
                  }, {
                    valType: "any",
                    editType: "ticks"
                  }],
                  editType: "ticks"
                },
                value: {
                  valType: "string",
                  dflt: "",
                  editType: "ticks"
                },
                editType: "ticks"
              }),
              hoverformat: {
                valType: "string",
                dflt: "",
                editType: "none"
              },
              showline: {
                valType: "boolean",
                dflt: !1,
                editType: "ticks+layoutstyle"
              },
              linecolor: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "layoutstyle"
              },
              linewidth: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "ticks+layoutstyle"
              },
              showgrid: {
                valType: "boolean",
                editType: "ticks"
              },
              gridcolor: {
                valType: "color",
                dflt: i.lightLine,
                editType: "ticks"
              },
              gridwidth: {
                valType: "number",
                min: 0,
                dflt: 1,
                editType: "ticks"
              },
              zeroline: {
                valType: "boolean",
                editType: "ticks"
              },
              zerolinecolor: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "ticks"
              },
              zerolinewidth: {
                valType: "number",
                dflt: 1,
                editType: "ticks"
              },
              showdividers: {
                valType: "boolean",
                dflt: !0,
                editType: "ticks"
              },
              dividercolor: {
                valType: "color",
                dflt: i.defaultLine,
                editType: "ticks"
              },
              dividerwidth: {
                valType: "number",
                dflt: 1,
                editType: "ticks"
              },
              anchor: {
                valType: "enumerated",
                values: ["free", l.idRegex.x.toString(), l.idRegex.y.toString()],
                editType: "plot"
              },
              side: {
                valType: "enumerated",
                values: ["top", "bottom", "left", "right"],
                editType: "plot"
              },
              overlaying: {
                valType: "enumerated",
                values: ["free", l.idRegex.x.toString(), l.idRegex.y.toString()],
                editType: "plot"
              },
              layer: {
                valType: "enumerated",
                values: ["above traces", "below traces"],
                dflt: "above traces",
                editType: "plot"
              },
              domain: {
                valType: "info_array",
                items: [{
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: "plot"
                }, {
                  valType: "number",
                  min: 0,
                  max: 1,
                  editType: "plot"
                }],
                dflt: [0, 1],
                editType: "plot"
              },
              position: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 0,
                editType: "plot"
              },
              categoryorder: {
                valType: "enumerated",
                values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "median ascending", "median descending"],
                dflt: "trace",
                editType: "calc"
              },
              categoryarray: {
                valType: "data_array",
                editType: "calc"
              },
              uirevision: {
                valType: "any",
                editType: "none"
              },
              editType: "calc",
              _deprecated: {
                autotick: {
                  valType: "boolean",
                  editType: "ticks"
                },
                title: {
                  valType: "string",
                  editType: "ticks"
                },
                titlefont: r({
                  editType: "ticks"
                })
              }
            };
          }, {
            "../../components/color/attributes": 374,
            "../../components/drawing/attributes": 395,
            "../../constants/docs": 470,
            "../../lib/extend": 489,
            "../../plot_api/plot_template": 531,
            "../font_attributes": 567,
            "./constants": 547
          }],
          554: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../components/color"),
              o = e("../../plot_api/plot_template"),
              a = e("../layout_attributes"),
              s = e("./layout_attributes"),
              l = e("./type_defaults"),
              u = e("./axis_defaults"),
              c = e("./constraints").handleConstraintDefaults,
              d = e("./position_defaults"),
              h = e("./axis_ids"),
              f = h.id2name,
              p = h.name2id,
              m = e("./constants").AX_ID_PATTERN,
              g = e("../../registry"),
              v = g.traceIs,
              y = g.getComponentMethod;
            function b(e, t, n) {
              Array.isArray(e[t]) ? e[t].push(n) : e[t] = [n];
            }
            t.exports = function (e, t, n) {
              var h,
                g,
                _ = {},
                x = {},
                w = {},
                S = {},
                A = {},
                E = {},
                T = {},
                M = {},
                C = {},
                k = {};
              for (h = 0; h < n.length; h++) {
                var P = n[h];
                if (v(P, "cartesian") || v(P, "gl2d")) {
                  var O, R;
                  if (P.xaxis) O = f(P.xaxis), b(_, O, P);else if (P.xaxes) for (g = 0; g < P.xaxes.length; g++) b(_, f(P.xaxes[g]), P);
                  if (P.yaxis) R = f(P.yaxis), b(_, R, P);else if (P.yaxes) for (g = 0; g < P.yaxes.length; g++) b(_, f(P.yaxes[g]), P);
                  "funnel" === P.type ? "h" === P.orientation ? (O && (x[O] = !0), R && (T[R] = !0)) : R && (w[R] = !0) : "image" === P.type ? (R && (M[R] = !0), O && (M[O] = !0)) : (R && (A[R] = !0, E[R] = !0), v(P, "carpet") && ("carpet" !== P.type || P._cheater) || O && (S[O] = !0)), "carpet" === P.type && P._cheater && O && (x[O] = !0), v(P, "2dMap") && (C[O] = !0, C[R] = !0), v(P, "oriented") && (k["h" === P.orientation ? R : O] = !0);
                }
              }
              var I = t._subplots,
                j = I.xaxis,
                N = I.yaxis,
                L = r.simpleMap(j, f),
                D = r.simpleMap(N, f),
                B = L.concat(D),
                F = i.background;
              j.length && N.length && (F = r.coerce(e, t, a, "plot_bgcolor"));
              var z,
                U,
                G,
                V,
                H,
                q = i.combine(F, t.paper_bgcolor);
              function W() {
                var e = _[z] || [];
                H._traceIndices = e.map(function (e) {
                  return e._expandedIndex;
                }), H._annIndices = [], H._shapeIndices = [], H._imgIndices = [], H._subplotsWith = [], H._counterAxes = [], H._name = H._attr = z, H._id = U;
              }
              function $(e, t) {
                return r.coerce(V, H, s, e, t);
              }
              function X(e, t) {
                return r.coerce2(V, H, s, e, t);
              }
              function Y(e) {
                return "x" === e ? N : j;
              }
              function K(t, n) {
                for (var r = "x" === t ? L : D, i = [], o = 0; o < r.length; o++) {
                  var a = r[o];
                  a === n || (e[a] || {}).overlaying || i.push(p(a));
                }
                return i;
              }
              var Z = {
                  x: Y("x"),
                  y: Y("y")
                },
                Q = Z.x.concat(Z.y),
                J = {},
                ee = [];
              function te() {
                var e = V.matches;
                m.test(e) && -1 === Q.indexOf(e) && (J[e] = V.type, ee = Object.keys(J));
              }
              for (h = 0; h < B.length; h++) {
                z = B[h], U = p(z), G = z.charAt(0), r.isPlainObject(e[z]) || (e[z] = {}), V = e[z], H = o.newContainer(t, z, G + "axis"), W();
                var ne = "x" === G && !S[z] && x[z] || "y" === G && !A[z] && w[z],
                  re = "y" === G && (!E[z] && T[z] || M[z]),
                  ie = {
                    letter: G,
                    font: t.font,
                    outerTicks: C[z],
                    showGrid: !k[z],
                    data: _[z] || [],
                    bgColor: q,
                    calendar: t.calendar,
                    automargin: !0,
                    visibleDflt: ne,
                    reverseDflt: re,
                    splomStash: ((t._splomAxes || {})[G] || {})[U]
                  };
                $("uirevision", t.uirevision), l(V, H, $, ie), u(V, H, $, ie, t);
                var oe = X("spikecolor"),
                  ae = X("spikethickness"),
                  se = X("spikedash"),
                  le = X("spikemode"),
                  ue = X("spikesnap");
                $("showspikes", !!(oe || ae || se || le || ue)) || (delete H.spikecolor, delete H.spikethickness, delete H.spikedash, delete H.spikemode, delete H.spikesnap), d(V, H, $, {
                  letter: G,
                  counterAxes: Z[G],
                  overlayableAxes: K(G, z),
                  grid: t.grid
                }), $("title.standoff"), te(), H._input = V;
              }
              for (h = 0; h < ee.length;) {
                U = ee[h++], G = (z = f(U)).charAt(0), r.isPlainObject(e[z]) || (e[z] = {}), V = e[z], H = o.newContainer(t, z, G + "axis"), W();
                var ce = {
                  letter: G,
                  font: t.font,
                  outerTicks: C[z],
                  showGrid: !k[z],
                  data: [],
                  bgColor: q,
                  calendar: t.calendar,
                  automargin: !0,
                  visibleDflt: !1,
                  reverseDflt: !1,
                  splomStash: ((t._splomAxes || {})[G] || {})[U]
                };
                $("uirevision", t.uirevision), H.type = J[U] || "linear", u(V, H, $, ce, t), d(V, H, $, {
                  letter: G,
                  counterAxes: Z[G],
                  overlayableAxes: K(G, z),
                  grid: t.grid
                }), $("fixedrange"), te(), H._input = V;
              }
              var de = y("rangeslider", "handleDefaults"),
                he = y("rangeselector", "handleDefaults");
              for (h = 0; h < L.length; h++) z = L[h], V = e[z], H = t[z], de(e, t, z), "date" === H.type && he(V, H, t, D, H.calendar), $("fixedrange");
              for (h = 0; h < D.length; h++) {
                z = D[h], V = e[z], H = t[z];
                var fe = t[f(H.anchor)];
                $("fixedrange", y("rangeslider", "isVisible")(fe));
              }
              var pe = t._axisConstraintGroups = [],
                me = t._axisMatchGroups = [],
                ge = Q.concat(ee),
                ve = B.concat(r.simpleMap(ee, f));
              for (h = 0; h < ve.length; h++) {
                var ye, be;
                G = (z = ve[h]).charAt(0), V = e[z], H = t[z], ye = "y" === G && !V.hasOwnProperty("scaleanchor") && M[z] ? H.anchor : void 0, be = !V.hasOwnProperty("constrain") && M[z] ? "domain" : void 0, c(V, H, $, {
                  allAxisIds: ge,
                  layoutOut: t,
                  scaleanchorDflt: ye,
                  constrainDflt: be
                });
              }
              for (h = 0; h < me.length; h++) {
                var _e = me[h],
                  xe = null,
                  we = null;
                for (U in _e) (H = t[f(U)]).matches || (xe = H.range, we = H.autorange);
                if (null === xe || null === we) for (U in _e) {
                  xe = (H = t[f(U)]).range, we = H.autorange;
                  break;
                }
                for (U in _e) (H = t[f(U)]).matches && (H.range = xe.slice(), H.autorange = we), H._matchGroup = _e;
                if (pe.length) for (U in _e) for (g = 0; g < pe.length; g++) {
                  var Se = pe[g];
                  for (var Ae in Se) U === Ae && (r.warn("Axis " + Ae + " is set with both a *scaleanchor* and *matches* constraint; ignoring the scale constraint."), delete Se[Ae], Object.keys(Se).length < 2 && pe.splice(g, 1));
                }
              }
            };
          }, {
            "../../components/color": 375,
            "../../lib": 495,
            "../../plot_api/plot_template": 531,
            "../../registry": 593,
            "../layout_attributes": 582,
            "./axis_defaults": 543,
            "./axis_ids": 544,
            "./constants": 547,
            "./constraints": 548,
            "./layout_attributes": 553,
            "./position_defaults": 556,
            "./type_defaults": 564
          }],
          555: [function (e, t, n) {
            "use strict";

            var r = e("tinycolor2").mix,
              i = e("../../components/color/attributes").lightFraction,
              o = e("../../lib");
            t.exports = function (e, t, n, a) {
              var s = (a = a || {}).dfltColor;
              function l(n, r) {
                return o.coerce2(e, t, a.attributes, n, r);
              }
              var u = l("linecolor", s),
                c = l("linewidth");
              n("showline", a.showLine || !!u || !!c) || (delete t.linecolor, delete t.linewidth);
              var d = l("gridcolor", r(s, a.bgColor, a.blend || i).toRgbString()),
                h = l("gridwidth");
              if (n("showgrid", a.showGrid || !!d || !!h) || (delete t.gridcolor, delete t.gridwidth), !a.noZeroLine) {
                var f = l("zerolinecolor", s),
                  p = l("zerolinewidth");
                n("zeroline", a.showGrid || !!f || !!p) || (delete t.zerolinecolor, delete t.zerolinewidth);
              }
            };
          }, {
            "../../components/color/attributes": 374,
            "../../lib": 495,
            tinycolor2: 341
          }],
          556: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib");
            t.exports = function (e, t, n, o) {
              var a,
                s,
                l,
                u,
                c = o.counterAxes || [],
                d = o.overlayableAxes || [],
                h = o.letter,
                f = o.grid;
              f && (s = f._domains[h][f._axisMap[t._id]], a = f._anchors[t._id], s && (l = f[h + "side"].split(" ")[0], u = f.domain[h]["right" === l || "top" === l ? 1 : 0])), s = s || [0, 1], a = a || (r(e.position) ? "free" : c[0] || "free"), l = l || ("x" === h ? "bottom" : "left"), u = u || 0, "free" === i.coerce(e, t, {
                anchor: {
                  valType: "enumerated",
                  values: ["free"].concat(c),
                  dflt: a
                }
              }, "anchor") && n("position", u), i.coerce(e, t, {
                side: {
                  valType: "enumerated",
                  values: "x" === h ? ["bottom", "top"] : ["left", "right"],
                  dflt: l
                }
              }, "side");
              var p = !1;
              if (d.length && (p = i.coerce(e, t, {
                overlaying: {
                  valType: "enumerated",
                  values: [!1].concat(d),
                  dflt: !1
                }
              }, "overlaying")), !p) {
                var m = n("domain", s);
                m[0] > m[1] - 1 / 4096 && (t.domain = s), i.noneOrAll(e.domain, t.domain, s);
              }
              return n("layer"), t;
            };
          }, {
            "../../lib": 495,
            "fast-isnumeric": 91
          }],
          557: [function (e, t, n) {
            "use strict";

            var r = e("../../constants/alignment").FROM_BL;
            t.exports = function (e, t, n) {
              void 0 === n && (n = r[e.constraintoward || "center"]);
              var i = [e.r2l(e.range[0]), e.r2l(e.range[1])],
                o = i[0] + (i[1] - i[0]) * n;
              e.range = e._input.range = [e.l2r(o + (i[0] - o) * t), e.l2r(o + (i[1] - o) * t)];
            };
          }, {
            "../../constants/alignment": 469
          }],
          558: [function (e, t, n) {
            "use strict";

            var r = e("polybooljs"),
              i = e("../../registry"),
              o = e("../../components/color"),
              a = e("../../components/fx"),
              s = e("../../lib"),
              l = e("../../lib/polygon"),
              u = e("../../lib/throttle"),
              c = e("../../components/fx/helpers").makeEventData,
              d = e("./axis_ids").getFromId,
              h = e("../../lib/clear_gl_canvases"),
              f = e("../../plot_api/subroutines").redrawReglTraces,
              p = e("./constants"),
              m = p.MINSELECT,
              g = l.filter,
              v = l.tester;
            function y(e) {
              return e._id;
            }
            function b(e, t, n, r, i, o, a) {
              var s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g = t._hoverdata,
                v = t._fullLayout.clickmode.indexOf("event") > -1,
                y = [];
              if (function (e) {
                return e && Array.isArray(e) && !0 !== e[0].hoverOnBox;
              }(g)) {
                S(e, t, o);
                var b = function (e, t) {
                  var n,
                    r,
                    i = e[0],
                    o = -1,
                    a = [];
                  for (r = 0; r < t.length; r++) if (n = t[r], i.fullData._expandedIndex === n.cd[0].trace._expandedIndex) {
                    if (!0 === i.hoverOnBox) break;
                    void 0 !== i.pointNumber ? o = i.pointNumber : void 0 !== i.binNumber && (o = i.binNumber, a = i.pointNumbers);
                    break;
                  }
                  return {
                    pointNumber: o,
                    pointNumbers: a,
                    searchInfo: n
                  };
                }(g, s = E(t, n, r, i));
                if (b.pointNumbers.length > 0 ? function (e, t) {
                  var n,
                    r,
                    i,
                    o = [];
                  for (i = 0; i < e.length; i++) (n = e[i]).cd[0].trace.selectedpoints && n.cd[0].trace.selectedpoints.length > 0 && o.push(n);
                  if (1 === o.length && o[0] === t.searchInfo && (r = t.searchInfo.cd[0].trace).selectedpoints.length === t.pointNumbers.length) {
                    for (i = 0; i < t.pointNumbers.length; i++) if (r.selectedpoints.indexOf(t.pointNumbers[i]) < 0) return !1;
                    return !0;
                  }
                  return !1;
                }(s, b) : function (e) {
                  var t,
                    n,
                    r = 0;
                  for (n = 0; n < e.length; n++) if ((t = e[n].cd[0].trace).selectedpoints) {
                    if (t.selectedpoints.length > 1) return !1;
                    if ((r += t.selectedpoints.length) > 1) return !1;
                  }
                  return 1 === r;
                }(s) && (h = M(b))) {
                  for (a && a.remove(), m = 0; m < s.length; m++) (l = s[m])._module.selectPoints(l, !1);
                  C(t, s), A(o), v && t.emit("plotly_deselect", null);
                } else {
                  for (f = e.shiftKey && (void 0 !== h ? h : M(b)), u = function (e, t, n) {
                    return {
                      pointNumber: e,
                      searchInfo: t,
                      subtract: n
                    };
                  }(b.pointNumber, b.searchInfo, f), c = w(o.selectionDefs.concat([u])), m = 0; m < s.length; m++) if (d = k(s[m]._module.selectPoints(s[m], c), s[m]), y.length) for (var _ = 0; _ < d.length; _++) y.push(d[_]);else y = d;
                  C(t, s, p = {
                    points: y
                  }), u && o && o.selectionDefs.push(u), a && T(o.mergedPolygons, a), v && t.emit("plotly_selected", p);
                }
              }
            }
            function _(e) {
              return "pointNumber" in e && "searchInfo" in e;
            }
            function x(e) {
              return {
                xmin: 0,
                xmax: 0,
                ymin: 0,
                ymax: 0,
                pts: [],
                contains: function contains(t, n, r, i) {
                  var o = e.searchInfo.cd[0].trace._expandedIndex;
                  return i.cd[0].trace._expandedIndex === o && r === e.pointNumber;
                },
                isRect: !1,
                degenerate: !1,
                subtract: e.subtract
              };
            }
            function w(e) {
              for (var t = [], n = _(e[0]) ? 0 : e[0][0][0], r = n, i = _(e[0]) ? 0 : e[0][0][1], o = i, a = 0; a < e.length; a++) if (_(e[a])) t.push(x(e[a]));else {
                var s = l.tester(e[a]);
                s.subtract = e[a].subtract, t.push(s), n = Math.min(n, s.xmin), r = Math.max(r, s.xmax), i = Math.min(i, s.ymin), o = Math.max(o, s.ymax);
              }
              return {
                xmin: n,
                xmax: r,
                ymin: i,
                ymax: o,
                pts: [],
                contains: function contains(e, n, r, i) {
                  for (var o = !1, a = 0; a < t.length; a++) t[a].contains(e, n, r, i) && (o = !1 === t[a].subtract);
                  return o;
                },
                isRect: !1,
                degenerate: !1
              };
            }
            function S(e, t, n) {
              var r = t._fullLayout,
                i = n.plotinfo,
                o = r._lastSelectedSubplot && r._lastSelectedSubplot === i.id,
                a = e.shiftKey || e.altKey;
              o && a && i.selection && i.selection.selectionDefs && !n.selectionDefs ? (n.selectionDefs = i.selection.selectionDefs, n.mergedPolygons = i.selection.mergedPolygons) : a && i.selection || A(n), o || (P(t), r._lastSelectedSubplot = i.id);
            }
            function A(e) {
              var t = e.plotinfo;
              t.selection = {}, t.selection.selectionDefs = e.selectionDefs = [], t.selection.mergedPolygons = e.mergedPolygons = [];
            }
            function E(e, t, n, r) {
              var i,
                o,
                a,
                s = [],
                l = t.map(y),
                u = n.map(y);
              for (a = 0; a < e.calcdata.length; a++) if (!0 === (o = (i = e.calcdata[a])[0].trace).visible && o._module && o._module.selectPoints) if (!r || o.subplot !== r && o.geo !== r) {
                if ("splom" === o.type && o._xaxes[l[0]] && o._yaxes[u[0]]) {
                  var c = f(o._module, i, t[0], n[0]);
                  c.scene = e._fullLayout._splomScenes[o.uid], s.push(c);
                } else if ("sankey" === o.type) {
                  var h = f(o._module, i, t[0], n[0]);
                  s.push(h);
                } else {
                  if (-1 === l.indexOf(o.xaxis)) continue;
                  if (-1 === u.indexOf(o.yaxis)) continue;
                  s.push(f(o._module, i, d(e, o.xaxis), d(e, o.yaxis)));
                }
              } else s.push(f(o._module, i, t[0], n[0]));
              return s;
              function f(e, t, n, r) {
                return {
                  _module: e,
                  cd: t,
                  xaxis: n,
                  yaxis: r
                };
              }
            }
            function T(e, t) {
              var n,
                r,
                i = [];
              for (n = 0; n < e.length; n++) {
                var o = e[n];
                i.push(o.join("L") + "L" + o[0]);
              }
              r = e.length > 0 ? "M" + i.join("M") + "Z" : "M0,0Z", t.attr("d", r);
            }
            function M(e) {
              var t = e.searchInfo.cd[0].trace,
                n = e.pointNumber,
                r = e.pointNumbers,
                i = r.length > 0 ? r[0] : n;
              return !!t.selectedpoints && t.selectedpoints.indexOf(i) > -1;
            }
            function C(e, t, n) {
              var r, o, a, s;
              for (r = 0; r < t.length; r++) {
                var l = t[r].cd[0].trace._fullInput,
                  u = e._fullLayout._tracePreGUI[l.uid] || {};
                void 0 === u.selectedpoints && (u.selectedpoints = l._input.selectedpoints || null);
              }
              if (n) {
                var c = n.points || [];
                for (r = 0; r < t.length; r++) (s = t[r].cd[0].trace)._input.selectedpoints = s._fullInput.selectedpoints = [], s._fullInput !== s && (s.selectedpoints = []);
                for (r = 0; r < c.length; r++) {
                  var d = c[r],
                    p = d.data,
                    m = d.fullData;
                  d.pointIndices ? ([].push.apply(p.selectedpoints, d.pointIndices), s._fullInput !== s && [].push.apply(m.selectedpoints, d.pointIndices)) : (p.selectedpoints.push(d.pointIndex), s._fullInput !== s && m.selectedpoints.push(d.pointIndex));
                }
              } else for (r = 0; r < t.length; r++) delete (s = t[r].cd[0].trace).selectedpoints, delete s._input.selectedpoints, s._fullInput !== s && delete s._fullInput.selectedpoints;
              var g = !1;
              for (r = 0; r < t.length; r++) {
                s = (a = (o = t[r]).cd)[0].trace, i.traceIs(s, "regl") && (g = !0);
                var v = o._module,
                  y = v.styleOnSelect || v.style;
                y && (y(e, a, a[0].node3), a[0].nodeRangePlot3 && y(e, a, a[0].nodeRangePlot3));
              }
              g && (h(e), f(e));
            }
            function k(e, t) {
              if (Array.isArray(e)) for (var n = t.cd, r = t.cd[0].trace, i = 0; i < e.length; i++) e[i] = c(e[i], r, n);
              return e;
            }
            function P(e) {
              var t = (e._fullLayout || {})._zoomlayer;
              t && t.selectAll(".select-outline").remove();
            }
            t.exports = {
              prepSelect: function prepSelect(e, t, n, i, l) {
                var c,
                  d,
                  h,
                  f,
                  y,
                  _,
                  x,
                  M = i.gd,
                  P = M._fullLayout,
                  O = P._zoomlayer,
                  R = i.element.getBoundingClientRect(),
                  I = i.plotinfo,
                  j = I.xaxis._offset,
                  N = I.yaxis._offset,
                  L = t - R.left,
                  D = n - R.top,
                  B = L,
                  F = D,
                  z = "M" + L + "," + D,
                  U = i.xaxes[0]._length,
                  G = i.yaxes[0]._length,
                  V = i.xaxes.concat(i.yaxes),
                  H = e.altKey;
                S(e, M, i), "lasso" === l && (c = g([[L, D]], p.BENDPX));
                var q = O.selectAll("path.select-outline-" + I.id).data([1, 2]);
                q.enter().append("path").attr("class", function (e) {
                  return "select-outline select-outline-" + e + " select-outline-" + I.id;
                }).attr("transform", "translate(" + j + ", " + N + ")").attr("d", z + "Z");
                var W,
                  $ = O.append("path").attr("class", "zoombox-corners").style({
                    fill: o.background,
                    stroke: o.defaultLine,
                    "stroke-width": 1
                  }).attr("transform", "translate(" + j + ", " + N + ")").attr("d", "M0,0Z"),
                  X = P._uid + p.SELECTID,
                  Y = [],
                  K = E(M, i.xaxes, i.yaxes, i.subplot);
                function Z(e, t) {
                  return "log" === e.type ? e.p2d(t) : e.p2r(t);
                }
                function Q(e) {
                  var t = "y" === e._id.charAt(0) ? 1 : 0;
                  return function (n) {
                    return Z(e, n[t]);
                  };
                }
                function J(e, t) {
                  return e - t;
                }
                W = I.fillRangeItems ? I.fillRangeItems : "select" === l ? function (e, t) {
                  var n = e.range = {};
                  for (y = 0; y < V.length; y++) {
                    var r = V[y],
                      i = r._id.charAt(0);
                    n[r._id] = [Z(r, t[i + "min"]), Z(r, t[i + "max"])].sort(J);
                  }
                } : function (e, t, n) {
                  var r = e.lassoPoints = {};
                  for (y = 0; y < V.length; y++) {
                    var i = V[y];
                    r[i._id] = n.filtered.map(Q(i));
                  }
                }, i.moveFn = function (e, t) {
                  B = Math.max(0, Math.min(U, e + L)), F = Math.max(0, Math.min(G, t + D));
                  var n = Math.abs(B - L),
                    o = Math.abs(F - D);
                  if ("select" === l) {
                    var a = P.selectdirection;
                    "h" === (a = "any" === P.selectdirection ? o < Math.min(.6 * n, m) ? "h" : n < Math.min(.6 * o, m) ? "v" : "d" : P.selectdirection) ? ((f = [[L, 0], [L, G], [B, G], [B, 0]]).xmin = Math.min(L, B), f.xmax = Math.max(L, B), f.ymin = Math.min(0, G), f.ymax = Math.max(0, G), $.attr("d", "M" + f.xmin + "," + (D - m) + "h-4v" + 2 * m + "h4ZM" + (f.xmax - 1) + "," + (D - m) + "h4v" + 2 * m + "h-4Z")) : "v" === a ? ((f = [[0, D], [0, F], [U, F], [U, D]]).xmin = Math.min(0, U), f.xmax = Math.max(0, U), f.ymin = Math.min(D, F), f.ymax = Math.max(D, F), $.attr("d", "M" + (L - m) + "," + f.ymin + "v-4h" + 2 * m + "v4ZM" + (L - m) + "," + (f.ymax - 1) + "v4h" + 2 * m + "v-4Z")) : "d" === a && ((f = [[L, D], [L, F], [B, F], [B, D]]).xmin = Math.min(L, B), f.xmax = Math.max(L, B), f.ymin = Math.min(D, F), f.ymax = Math.max(D, F), $.attr("d", "M0,0Z"));
                  } else "lasso" === l && (c.addPt([B, F]), f = c.filtered);
                  i.selectionDefs && i.selectionDefs.length ? (h = function (e, t, n) {
                    return n ? r.difference({
                      regions: e,
                      inverted: !1
                    }, {
                      regions: [t],
                      inverted: !1
                    }).regions : r.union({
                      regions: e,
                      inverted: !1
                    }, {
                      regions: [t],
                      inverted: !1
                    }).regions;
                  }(i.mergedPolygons, f, H), f.subtract = H, d = w(i.selectionDefs.concat([f]))) : (h = [f], d = v(f)), T(h, q), u.throttle(X, p.SELECTDELAY, function () {
                    var e;
                    Y = [];
                    var t,
                      n = [];
                    for (y = 0; y < K.length; y++) if (t = (_ = K[y])._module.selectPoints(_, d), n.push(t), e = k(t, _), Y.length) for (var r = 0; r < e.length; r++) Y.push(e[r]);else Y = e;
                    C(M, K, x = {
                      points: Y
                    }), W(x, f, c), i.gd.emit("plotly_selecting", x);
                  });
                }, i.clickFn = function (e, t) {
                  var n = P.clickmode;
                  $.remove(), u.done(X).then(function () {
                    if (u.clear(X), 2 === e) {
                      for (q.remove(), y = 0; y < K.length; y++) (_ = K[y])._module.selectPoints(_, !1);
                      C(M, K), A(i), M.emit("plotly_deselect", null);
                    } else n.indexOf("select") > -1 && b(t, M, i.xaxes, i.yaxes, i.subplot, i, q), "event" === n && M.emit("plotly_selected", void 0);
                    a.click(M, t);
                  }).catch(s.error);
                }, i.doneFn = function () {
                  $.remove(), u.done(X).then(function () {
                    u.clear(X), i.gd.emit("plotly_selected", x), f && i.selectionDefs && (f.subtract = H, i.selectionDefs.push(f), i.mergedPolygons.length = 0, [].push.apply(i.mergedPolygons, h)), i.doneFnCompleted && i.doneFnCompleted(Y);
                  }).catch(s.error);
                };
              },
              clearSelect: P,
              selectOnClick: b
            };
          }, {
            "../../components/color": 375,
            "../../components/fx": 413,
            "../../components/fx/helpers": 410,
            "../../lib": 495,
            "../../lib/clear_gl_canvases": 483,
            "../../lib/polygon": 507,
            "../../lib/throttle": 519,
            "../../plot_api/subroutines": 532,
            "../../registry": 593,
            "./axis_ids": 544,
            "./constants": 547,
            polybooljs: 298
          }],
          559: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../../lib"),
              a = o.cleanNumber,
              s = o.ms2DateTime,
              l = o.dateTime2ms,
              u = o.ensureNumber,
              c = o.isArrayOrTypedArray,
              d = e("../../constants/numerical"),
              h = d.FP_SAFE,
              f = d.BADNUM,
              p = d.LOG_CLIP,
              m = e("./constants"),
              g = e("./axis_ids");
            function v(e) {
              return Math.pow(10, e);
            }
            function y(e) {
              return null != e;
            }
            t.exports = function (e, t) {
              t = t || {};
              var n = e._id || "x",
                d = n.charAt(0);
              function b(t, n) {
                if (t > 0) return Math.log(t) / Math.LN10;
                if (t <= 0 && n && e.range && 2 === e.range.length) {
                  var r = e.range[0],
                    i = e.range[1];
                  return .5 * (r + i - 2 * p * Math.abs(r - i));
                }
                return f;
              }
              function _(t, n, r) {
                var a = l(t, r || e.calendar);
                if (a === f) {
                  if (!i(t)) return f;
                  t = +t;
                  var s = Math.floor(10 * o.mod(t + .05, 1)),
                    u = Math.round(t - s / 10);
                  a = l(new Date(u)) + s / 10;
                }
                return a;
              }
              function x(t, n, r) {
                return s(t, n, r || e.calendar);
              }
              function w(t) {
                return e._categories[Math.round(t)];
              }
              function S(t) {
                if (y(t)) {
                  if (void 0 === e._categoriesMap && (e._categoriesMap = {}), void 0 !== e._categoriesMap[t]) return e._categoriesMap[t];
                  e._categories.push("number" == typeof t ? String(t) : t);
                  var n = e._categories.length - 1;
                  return e._categoriesMap[t] = n, n;
                }
                return f;
              }
              function A(t) {
                if (e._categoriesMap) return e._categoriesMap[t];
              }
              function E(e) {
                var t = A(e);
                return void 0 !== t ? t : i(e) ? +e : void 0;
              }
              function T(t) {
                return i(t) ? r.round(e._b + e._m * t, 2) : f;
              }
              function M(t) {
                return (t - e._b) / e._m;
              }
              e.c2l = "log" === e.type ? b : u, e.l2c = "log" === e.type ? v : u, e.l2p = T, e.p2l = M, e.c2p = "log" === e.type ? function (e, t) {
                return T(b(e, t));
              } : T, e.p2c = "log" === e.type ? function (e) {
                return v(M(e));
              } : M, -1 !== ["linear", "-"].indexOf(e.type) ? (e.d2r = e.r2d = e.d2c = e.r2c = e.d2l = e.r2l = a, e.c2d = e.c2r = e.l2d = e.l2r = u, e.d2p = e.r2p = function (t) {
                return e.l2p(a(t));
              }, e.p2d = e.p2r = M, e.cleanPos = u) : "log" === e.type ? (e.d2r = e.d2l = function (e, t) {
                return b(a(e), t);
              }, e.r2d = e.r2c = function (e) {
                return v(a(e));
              }, e.d2c = e.r2l = a, e.c2d = e.l2r = u, e.c2r = b, e.l2d = v, e.d2p = function (t, n) {
                return e.l2p(e.d2r(t, n));
              }, e.p2d = function (e) {
                return v(M(e));
              }, e.r2p = function (t) {
                return e.l2p(a(t));
              }, e.p2r = M, e.cleanPos = u) : "date" === e.type ? (e.d2r = e.r2d = o.identity, e.d2c = e.r2c = e.d2l = e.r2l = _, e.c2d = e.c2r = e.l2d = e.l2r = x, e.d2p = e.r2p = function (t, n, r) {
                return e.l2p(_(t, 0, r));
              }, e.p2d = e.p2r = function (e, t, n) {
                return x(M(e), t, n);
              }, e.cleanPos = function (t) {
                return o.cleanDate(t, f, e.calendar);
              }) : "category" === e.type ? (e.d2c = e.d2l = S, e.r2d = e.c2d = e.l2d = w, e.d2r = e.d2l_noadd = E, e.r2c = function (t) {
                var n = E(t);
                return void 0 !== n ? n : e.fraction2r(.5);
              }, e.l2r = e.c2r = u, e.r2l = E, e.d2p = function (t) {
                return e.l2p(e.r2c(t));
              }, e.p2d = function (e) {
                return w(M(e));
              }, e.r2p = e.d2p, e.p2r = M, e.cleanPos = function (e) {
                return "string" == typeof e && "" !== e ? e : u(e);
              }) : "multicategory" === e.type && (e.r2d = e.c2d = e.l2d = w, e.d2r = e.d2l_noadd = E, e.r2c = function (t) {
                var n = E(t);
                return void 0 !== n ? n : e.fraction2r(.5);
              }, e.r2c_just_indices = A, e.l2r = e.c2r = u, e.r2l = E, e.d2p = function (t) {
                return e.l2p(e.r2c(t));
              }, e.p2d = function (e) {
                return w(M(e));
              }, e.r2p = e.d2p, e.p2r = M, e.cleanPos = function (e) {
                return Array.isArray(e) || "string" == typeof e && "" !== e ? e : u(e);
              }, e.setupMultiCategory = function (r) {
                var i,
                  a,
                  s = e._traceIndices,
                  l = t._axisMatchGroups;
                if (l && l.length && 0 === e._categories.length) for (i = 0; i < l.length; i++) {
                  var u = l[i];
                  if (u[n]) for (var h in u) if (h !== n) {
                    var f = t[g.id2name(h)];
                    s = s.concat(f._traceIndices);
                  }
                }
                var p = [[0, {}], [0, {}]],
                  m = [];
                for (i = 0; i < s.length; i++) {
                  var v = r[s[i]];
                  if (d in v) {
                    var b = v[d],
                      _ = v._length || o.minRowLength(b);
                    if (c(b[0]) && c(b[1])) for (a = 0; a < _; a++) {
                      var x = b[0][a],
                        w = b[1][a];
                      y(x) && y(w) && (m.push([x, w]), x in p[0][1] || (p[0][1][x] = p[0][0]++), w in p[1][1] || (p[1][1][w] = p[1][0]++));
                    }
                  }
                }
                for (m.sort(function (e, t) {
                  var n = p[0][1],
                    r = n[e[0]] - n[t[0]];
                  if (r) return r;
                  var i = p[1][1];
                  return i[e[1]] - i[t[1]];
                }), i = 0; i < m.length; i++) S(m[i]);
              }), e.fraction2r = function (t) {
                var n = e.r2l(e.range[0]),
                  r = e.r2l(e.range[1]);
                return e.l2r(n + t * (r - n));
              }, e.r2fraction = function (t) {
                var n = e.r2l(e.range[0]),
                  r = e.r2l(e.range[1]);
                return (e.r2l(t) - n) / (r - n);
              }, e.cleanRange = function (t, n) {
                n || (n = {}), t || (t = "range");
                var r,
                  a,
                  s = o.nestedProperty(e, t).get();
                if (a = (a = "date" === e.type ? o.dfltRange(e.calendar) : "y" === d ? m.DFLTRANGEY : n.dfltRange || m.DFLTRANGEX).slice(), "tozero" !== e.rangemode && "nonnegative" !== e.rangemode || (a[0] = 0), s && 2 === s.length) {
                  for ("date" !== e.type || e.autorange || (s[0] = o.cleanDate(s[0], f, e.calendar), s[1] = o.cleanDate(s[1], f, e.calendar)), r = 0; r < 2; r++) if ("date" === e.type) {
                    if (!o.isDateTime(s[r], e.calendar)) {
                      e[t] = a;
                      break;
                    }
                    if (e.r2l(s[0]) === e.r2l(s[1])) {
                      var l = o.constrain(e.r2l(s[0]), o.MIN_MS + 1e3, o.MAX_MS - 1e3);
                      s[0] = e.l2r(l - 1e3), s[1] = e.l2r(l + 1e3);
                      break;
                    }
                  } else {
                    if (!i(s[r])) {
                      if (!i(s[1 - r])) {
                        e[t] = a;
                        break;
                      }
                      s[r] = s[1 - r] * (r ? 10 : .1);
                    }
                    if (s[r] < -h ? s[r] = -h : s[r] > h && (s[r] = h), s[0] === s[1]) {
                      var u = Math.max(1, Math.abs(1e-6 * s[0]));
                      s[0] -= u, s[1] += u;
                    }
                  }
                } else o.nestedProperty(e, t).set(a);
              }, e.setScale = function (n) {
                var r = t._size;
                if (e.overlaying) {
                  var i = g.getFromId({
                    _fullLayout: t
                  }, e.overlaying);
                  e.domain = i.domain;
                }
                var o = n && e._r ? "_r" : "range",
                  a = e.calendar;
                e.cleanRange(o);
                var s = e.r2l(e[o][0], a),
                  l = e.r2l(e[o][1], a);
                if ("y" === d ? (e._offset = r.t + (1 - e.domain[1]) * r.h, e._length = r.h * (e.domain[1] - e.domain[0]), e._m = e._length / (s - l), e._b = -e._m * l) : (e._offset = r.l + e.domain[0] * r.w, e._length = r.w * (e.domain[1] - e.domain[0]), e._m = e._length / (l - s), e._b = -e._m * s), !isFinite(e._m) || !isFinite(e._b) || e._length < 0) throw t._replotting = !1, new Error("Something went wrong with axis scaling");
              }, e.makeCalcdata = function (t, n) {
                var r,
                  i,
                  a,
                  s,
                  l = e.type,
                  u = "date" === l && t[n + "calendar"];
                if (n in t) {
                  if (r = t[n], s = t._length || o.minRowLength(r), o.isTypedArray(r) && ("linear" === l || "log" === l)) {
                    if (s === r.length) return r;
                    if (r.subarray) return r.subarray(0, s);
                  }
                  if ("multicategory" === l) return function (e, t) {
                    for (var n = new Array(t), r = 0; r < t; r++) {
                      var i = (e[0] || [])[r],
                        o = (e[1] || [])[r];
                      n[r] = A([i, o]);
                    }
                    return n;
                  }(r, s);
                  for (i = new Array(s), a = 0; a < s; a++) i[a] = e.d2c(r[a], 0, u);
                } else {
                  var c = n + "0" in t ? e.d2c(t[n + "0"], 0, u) : 0,
                    d = t["d" + n] ? Number(t["d" + n]) : 1;
                  for (r = t[{
                    x: "y",
                    y: "x"
                  }[n]], s = t._length || r.length, i = new Array(s), a = 0; a < s; a++) i[a] = c + a * d;
                }
                return i;
              }, e.isValidRange = function (t) {
                return Array.isArray(t) && 2 === t.length && i(e.r2l(t[0])) && i(e.r2l(t[1]));
              }, e.isPtWithinRange = function (t, n) {
                var r = e.c2l(t[d], null, n),
                  i = e.r2l(e.range[0]),
                  o = e.r2l(e.range[1]);
                return i < o ? i <= r && r <= o : o <= r && r <= i;
              }, e.clearCalc = function () {
                var r = function r() {
                    e._categories = [], e._categoriesMap = {};
                  },
                  i = t._axisMatchGroups;
                if (i && i.length) {
                  for (var o = !1, a = 0; a < i.length; a++) {
                    var s = i[a];
                    if (s[n]) {
                      o = !0;
                      var l = null,
                        u = null;
                      for (var c in s) {
                        var d = t[g.id2name(c)];
                        if (d._categories) {
                          l = d._categories, u = d._categoriesMap;
                          break;
                        }
                      }
                      l && u ? (e._categories = l, e._categoriesMap = u) : r();
                      break;
                    }
                  }
                  o || r();
                } else r();
                if (e._initialCategories) for (var h = 0; h < e._initialCategories.length; h++) S(e._initialCategories[h]);
              }, e.sortByInitialCategories = function () {
                var r = [];
                if (e._categories = [], e._categoriesMap = {}, e._initialCategories) for (var i = 0; i < e._initialCategories.length; i++) S(e._initialCategories[i]);
                r = r.concat(e._traceIndices);
                var o = e._matchGroup;
                for (var a in o) if (n !== a) {
                  var s = t[g.id2name(a)];
                  s._categories = e._categories, s._categoriesMap = e._categoriesMap, r = r.concat(s._traceIndices);
                }
                return r;
              };
              var C = t._d3locale;
              "date" === e.type && (e._dateFormat = C ? C.timeFormat.utc : r.time.format.utc, e._extraFormat = t._extraFormat), e._separators = t.separators, e._numFormat = C ? C.numberFormat : r.format, delete e._minDtick, delete e._forceTick0;
            };
          }, {
            "../../constants/numerical": 474,
            "../../lib": 495,
            "./axis_ids": 544,
            "./constants": 547,
            d3: 82,
            "fast-isnumeric": 91
          }],
          560: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./layout_attributes"),
              o = e("../array_container_defaults");
            function a(e) {
              var t = ["showexponent", "showtickprefix", "showticksuffix"].filter(function (t) {
                return void 0 !== e[t];
              });
              if (t.every(function (n) {
                return e[n] === e[t[0]];
              }) || 1 === t.length) return e[t[0]];
            }
            function s(e, t) {
              function n(n, o) {
                return r.coerce(e, t, i.tickformatstops, n, o);
              }
              n("enabled") && (n("dtickrange"), n("value"));
            }
            t.exports = function (e, t, n, l, u, c) {
              c && 1 !== c.pass || function (e, t, n, r, i) {
                var o = a(e);
                n("tickprefix") && n("showtickprefix", o), n("ticksuffix", i.tickSuffixDflt) && n("showticksuffix", o);
              }(e, 0, n, 0, u), c && 2 !== c.pass || function (e, t, n, l, u) {
                var c = a(e);
                if (n("tickprefix") && n("showtickprefix", c), n("ticksuffix", u.tickSuffixDflt) && n("showticksuffix", c), n("showticklabels")) {
                  var d = u.font || {},
                    h = t.color,
                    f = h && h !== i.color.dflt ? h : d.color;
                  if (r.coerceFont(n, "tickfont", {
                    family: d.family,
                    size: d.size,
                    color: f
                  }), n("tickangle"), "category" !== l) {
                    var p = n("tickformat"),
                      m = e.tickformatstops;
                    Array.isArray(m) && m.length && o(e, t, {
                      name: "tickformatstops",
                      inclusionAttr: "enabled",
                      handleItemDefaults: s
                    }), p || "date" === l || (n("showexponent", c), n("exponentformat"), n("separatethousands"));
                  }
                }
              }(e, t, n, l, u);
            };
          }, {
            "../../lib": 495,
            "../array_container_defaults": 537,
            "./layout_attributes": 553
          }],
          561: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./layout_attributes");
            t.exports = function (e, t, n, o) {
              var a = r.coerce2(e, t, i, "ticklen"),
                s = r.coerce2(e, t, i, "tickwidth"),
                l = r.coerce2(e, t, i, "tickcolor", t.color);
              n("ticks", o.outerTicks || a || s || l ? "outside" : "") || (delete t.ticklen, delete t.tickwidth, delete t.tickcolor);
            };
          }, {
            "../../lib": 495,
            "./layout_attributes": 553
          }],
          562: [function (e, t, n) {
            "use strict";

            var r = e("./clean_ticks");
            t.exports = function (e, t, n, i) {
              var o;
              if ("auto" === (o = "array" !== e.tickmode || "log" !== i && "date" !== i ? n("tickmode", Array.isArray(e.tickvals) ? "array" : e.dtick ? "linear" : "auto") : t.tickmode = "auto")) n("nticks");else if ("linear" === o) {
                var a = t.dtick = r.dtick(e.dtick, i);
                t.tick0 = r.tick0(e.tick0, i, t.calendar, a);
              } else "multicategory" !== i && (void 0 === n("tickvals") ? t.tickmode = "auto" : n("ticktext"));
            };
          }, {
            "./clean_ticks": 546
          }],
          563: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../lib"),
              a = e("../../components/drawing"),
              s = e("./axes");
            t.exports = function (e, t, n, l) {
              var u = e._fullLayout;
              if (0 !== t.length) {
                var c, d, h, f;
                l && (c = l());
                var p = r.ease(n.easing);
                return e._transitionData._interruptCallbacks.push(function () {
                  return window.cancelAnimationFrame(f), f = null, function () {
                    for (var n = {}, r = 0; r < t.length; r++) {
                      var o = t[r],
                        a = o.plotinfo.xaxis,
                        s = o.plotinfo.yaxis;
                      o.xr0 && (n[a._name + ".range"] = o.xr0.slice()), o.yr0 && (n[s._name + ".range"] = o.yr0.slice());
                    }
                    return i.call("relayout", e, n).then(function () {
                      for (var e = 0; e < t.length; e++) m(t[e].plotinfo);
                    });
                  }();
                }), d = Date.now(), f = window.requestAnimationFrame(function r() {
                  h = Date.now();
                  for (var o = Math.min(1, (h - d) / n.duration), a = p(o), s = 0; s < t.length; s++) g(t[s], a);
                  h - d > n.duration ? (function () {
                    for (var n = {}, r = 0; r < t.length; r++) {
                      var o = t[r],
                        a = o.plotinfo.xaxis,
                        s = o.plotinfo.yaxis;
                      o.xr1 && (n[a._name + ".range"] = o.xr1.slice()), o.yr1 && (n[s._name + ".range"] = o.yr1.slice());
                    }
                    c && c(), i.call("relayout", e, n).then(function () {
                      for (var e = 0; e < t.length; e++) m(t[e].plotinfo);
                    });
                  }(), f = window.cancelAnimationFrame(r)) : f = window.requestAnimationFrame(r);
                }), Promise.resolve();
              }
              function m(e) {
                var t = e.xaxis,
                  n = e.yaxis;
                u._defs.select("#" + e.clipId + "> rect").call(a.setTranslate, 0, 0).call(a.setScale, 1, 1), e.plot.call(a.setTranslate, t._offset, n._offset).call(a.setScale, 1, 1);
                var r = e.plot.selectAll(".scatterlayer .trace");
                r.selectAll(".point").call(a.setPointGroupScale, 1, 1), r.selectAll(".textpoint").call(a.setTextPointsScale, 1, 1), r.call(a.hideOutsideRangePoints, e);
              }
              function g(t, n) {
                var r = t.plotinfo,
                  i = r.xaxis,
                  l = r.yaxis,
                  u = i._length,
                  c = l._length,
                  d = !!t.xr1,
                  h = !!t.yr1,
                  f = [];
                if (d) {
                  var p = o.simpleMap(t.xr0, i.r2l),
                    m = o.simpleMap(t.xr1, i.r2l),
                    g = p[1] - p[0],
                    v = m[1] - m[0];
                  f[0] = (p[0] * (1 - n) + n * m[0] - p[0]) / (p[1] - p[0]) * u, f[2] = u * (1 - n + n * v / g), i.range[0] = i.l2r(p[0] * (1 - n) + n * m[0]), i.range[1] = i.l2r(p[1] * (1 - n) + n * m[1]);
                } else f[0] = 0, f[2] = u;
                if (h) {
                  var y = o.simpleMap(t.yr0, l.r2l),
                    b = o.simpleMap(t.yr1, l.r2l),
                    _ = y[1] - y[0],
                    x = b[1] - b[0];
                  f[1] = (y[1] * (1 - n) + n * b[1] - y[1]) / (y[0] - y[1]) * c, f[3] = c * (1 - n + n * x / _), l.range[0] = i.l2r(y[0] * (1 - n) + n * b[0]), l.range[1] = l.l2r(y[1] * (1 - n) + n * b[1]);
                } else f[1] = 0, f[3] = c;
                s.drawOne(e, i, {
                  skipTitle: !0
                }), s.drawOne(e, l, {
                  skipTitle: !0
                }), s.redrawComponents(e, [i._id, l._id]);
                var w = d ? u / f[2] : 1,
                  S = h ? c / f[3] : 1,
                  A = d ? f[0] : 0,
                  E = h ? f[1] : 0,
                  T = d ? f[0] / f[2] * u : 0,
                  M = h ? f[1] / f[3] * c : 0,
                  C = i._offset - T,
                  k = l._offset - M;
                r.clipRect.call(a.setTranslate, A, E).call(a.setScale, 1 / w, 1 / S), r.plot.call(a.setTranslate, C, k).call(a.setScale, w, S), a.setPointGroupScale(r.zoomScalePts, 1 / w, 1 / S), a.setTextPointsScale(r.zoomScaleTxt, 1 / w, 1 / S);
              }
              s.redrawComponents(e);
            };
          }, {
            "../../components/drawing": 396,
            "../../lib": 495,
            "../../registry": 593,
            "./axes": 541,
            d3: 82
          }],
          564: [function (e, t, n) {
            "use strict";

            var r = e("../../registry").traceIs,
              i = e("./axis_autotype");
            function o(e) {
              return {
                v: "x",
                h: "y"
              }[e.orientation || "v"];
            }
            function a(e, t) {
              var n = o(e),
                i = r(e, "box-violin"),
                a = r(e._fullInput || {}, "candlestick");
              return i && !a && t === n && void 0 === e[n] && void 0 === e[n + "0"];
            }
            t.exports = function (e, t, n, s) {
              "-" === n("type", (s.splomStash || {}).type) && (function (e, t) {
                if ("-" === e.type) {
                  var n,
                    s = e._id,
                    l = s.charAt(0);
                  -1 !== s.indexOf("scene") && (s = l);
                  var u = function (e, t, n) {
                    for (var r = 0; r < e.length; r++) {
                      var i = e[r];
                      if ("splom" === i.type && i._length > 0 && (i["_" + n + "axes"] || {})[t]) return i;
                      if ((i[n + "axis"] || n) === t) {
                        if (a(i, n)) return i;
                        if ((i[n] || []).length || i[n + "0"]) return i;
                      }
                    }
                  }(t, s, l);
                  if (u) if ("histogram" !== u.type || l !== {
                    v: "y",
                    h: "x"
                  }[u.orientation || "v"]) {
                    var c = l + "calendar",
                      d = u[c],
                      h = {
                        noMultiCategory: !r(u, "cartesian") || r(u, "noMultiCategory")
                      };
                    if ("box" === u.type && u._hasPreCompStats && l === {
                      h: "x",
                      v: "y"
                    }[u.orientation || "v"] && (h.noMultiCategory = !0), a(u, l)) {
                      var f = o(u),
                        p = [];
                      for (n = 0; n < t.length; n++) {
                        var m = t[n];
                        r(m, "box-violin") && (m[l + "axis"] || l) === s && (void 0 !== m[f] ? p.push(m[f][0]) : void 0 !== m.name ? p.push(m.name) : p.push("text"), m[c] !== d && (d = void 0));
                      }
                      e.type = i(p, d, h);
                    } else if ("splom" === u.type) {
                      var g = u.dimensions[u._axesDim[s]];
                      g.visible && (e.type = i(g.values, d, h));
                    } else e.type = i(u[l] || [u[l + "0"]], d, h);
                  } else e.type = "linear";
                }
              }(t, s.data), "-" === t.type ? t.type = "linear" : e.type = t.type);
            };
          }, {
            "../../registry": 593,
            "./axis_autotype": 542
          }],
          565: [function (e, t, n) {
            "use strict";

            var r = e("../registry"),
              i = e("../lib");
            function o(e, t, n) {
              var r,
                o,
                a,
                s = !1;
              if ("data" === t.type) r = e._fullData[null !== t.traces ? t.traces[0] : 0];else {
                if ("layout" !== t.type) return !1;
                r = e._fullLayout;
              }
              return o = i.nestedProperty(r, t.prop).get(), (a = n[t.type] = n[t.type] || {}).hasOwnProperty(t.prop) && a[t.prop] !== o && (s = !0), a[t.prop] = o, {
                changed: s,
                value: o
              };
            }
            function a(e, t) {
              var n = [],
                r = t[0],
                o = {};
              if ("string" == typeof r) o[r] = t[1];else {
                if (!i.isPlainObject(r)) return n;
                o = r;
              }
              return l(o, function (e, t, r) {
                n.push({
                  type: "layout",
                  prop: e,
                  value: r
                });
              }, "", 0), n;
            }
            function s(e, t) {
              var n,
                r,
                o,
                a,
                s = [];
              if (r = t[0], o = t[1], n = t[2], a = {}, "string" == typeof r) a[r] = o;else {
                if (!i.isPlainObject(r)) return s;
                a = r, void 0 === n && (n = o);
              }
              return void 0 === n && (n = null), l(a, function (t, r, i) {
                var o, a;
                if (Array.isArray(i)) {
                  a = i.slice();
                  var l = Math.min(a.length, e.data.length);
                  n && (l = Math.min(l, n.length)), o = [];
                  for (var u = 0; u < l; u++) o[u] = n ? n[u] : u;
                } else a = i, o = n ? n.slice() : null;
                if (null === o) Array.isArray(a) && (a = a[0]);else if (Array.isArray(o)) {
                  if (!Array.isArray(a)) {
                    var c = a;
                    a = [];
                    for (var d = 0; d < o.length; d++) a[d] = c;
                  }
                  a.length = Math.min(o.length, a.length);
                }
                s.push({
                  type: "data",
                  prop: t,
                  traces: o,
                  value: a
                });
              }, "", 0), s;
            }
            function l(e, t, n, r) {
              Object.keys(e).forEach(function (o) {
                var a = e[o];
                if ("_" !== o[0]) {
                  var s = n + (r > 0 ? "." : "") + o;
                  i.isPlainObject(a) ? l(a, t, s, r + 1) : t(s, o, a);
                }
              });
            }
            n.manageCommandObserver = function (e, t, r, a) {
              var s = {},
                l = !0;
              t && t._commandObserver && (s = t._commandObserver), s.cache || (s.cache = {}), s.lookupTable = {};
              var u = n.hasSimpleAPICommandBindings(e, r, s.lookupTable);
              if (t && t._commandObserver) {
                if (u) return s;
                if (t._commandObserver.remove) return t._commandObserver.remove(), t._commandObserver = null, s;
              }
              if (u) {
                o(e, u, s.cache), s.check = function () {
                  if (l) {
                    var t = o(e, u, s.cache);
                    return t.changed && a && void 0 !== s.lookupTable[t.value] && (s.disable(), Promise.resolve(a({
                      value: t.value,
                      type: u.type,
                      prop: u.prop,
                      traces: u.traces,
                      index: s.lookupTable[t.value]
                    })).then(s.enable, s.enable)), t.changed;
                  }
                };
                for (var c = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"], d = 0; d < c.length; d++) e._internalOn(c[d], s.check);
                s.remove = function () {
                  for (var t = 0; t < c.length; t++) e._removeInternalListener(c[t], s.check);
                };
              } else i.log("Unable to automatically bind plot updates to API command"), s.lookupTable = {}, s.remove = function () {};
              return s.disable = function () {
                l = !1;
              }, s.enable = function () {
                l = !0;
              }, t && (t._commandObserver = s), s;
            }, n.hasSimpleAPICommandBindings = function (e, t, r) {
              var i,
                o,
                a = t.length;
              for (i = 0; i < a; i++) {
                var s,
                  l = t[i],
                  u = l.method,
                  c = l.args;
                if (Array.isArray(c) || (c = []), !u) return !1;
                var d = n.computeAPICommandBindings(e, u, c);
                if (1 !== d.length) return !1;
                if (o) {
                  if ((s = d[0]).type !== o.type) return !1;
                  if (s.prop !== o.prop) return !1;
                  if (Array.isArray(o.traces)) {
                    if (!Array.isArray(s.traces)) return !1;
                    s.traces.sort();
                    for (var h = 0; h < o.traces.length; h++) if (o.traces[h] !== s.traces[h]) return !1;
                  } else if (s.prop !== o.prop) return !1;
                } else o = d[0], Array.isArray(o.traces) && o.traces.sort();
                var f = (s = d[0]).value;
                if (Array.isArray(f)) {
                  if (1 !== f.length) return !1;
                  f = f[0];
                }
                r && (r[f] = i);
              }
              return o;
            }, n.executeAPICommand = function (e, t, n) {
              if ("skip" === t) return Promise.resolve();
              var o = r.apiMethodRegistry[t],
                a = [e];
              Array.isArray(n) || (n = []);
              for (var s = 0; s < n.length; s++) a.push(n[s]);
              return o.apply(null, a).catch(function (e) {
                return i.warn("API call to Plotly." + t + " rejected.", e), Promise.reject(e);
              });
            }, n.computeAPICommandBindings = function (e, t, n) {
              var r;
              switch (Array.isArray(n) || (n = []), t) {
                case "restyle":
                  r = s(e, n);
                  break;
                case "relayout":
                  r = a(0, n);
                  break;
                case "update":
                  r = s(e, [n[0], n[2]]).concat(a(0, [n[1]]));
                  break;
                case "animate":
                  r = function (e, t) {
                    return Array.isArray(t[0]) && 1 === t[0].length && -1 !== ["string", "number"].indexOf(typeof t[0][0]) ? [{
                      type: "layout",
                      prop: "_currentFrame",
                      value: t[0][0].toString()
                    }] : [];
                  }(0, n);
                  break;
                default:
                  r = [];
              }
              return r;
            };
          }, {
            "../lib": 495,
            "../registry": 593
          }],
          566: [function (e, t, n) {
            "use strict";

            var r = e("../lib/extend").extendFlat;
            n.attributes = function (e, t) {
              t = t || {};
              var n = {
                  valType: "info_array",
                  editType: (e = e || {}).editType,
                  items: [{
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: e.editType
                  }, {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: e.editType
                  }],
                  dflt: [0, 1]
                },
                i = (e.name && e.name, e.trace, t.description && t.description, {
                  x: r({}, n, {}),
                  y: r({}, n, {}),
                  editType: e.editType
                });
              return e.noGridCell || (i.row = {
                valType: "integer",
                min: 0,
                dflt: 0,
                editType: e.editType
              }, i.column = {
                valType: "integer",
                min: 0,
                dflt: 0,
                editType: e.editType
              }), i;
            }, n.defaults = function (e, t, n, r) {
              var i = r && r.x || [0, 1],
                o = r && r.y || [0, 1],
                a = t.grid;
              if (a) {
                var s = n("domain.column");
                void 0 !== s && (s < a.columns ? i = a._domains.x[s] : delete e.domain.column);
                var l = n("domain.row");
                void 0 !== l && (l < a.rows ? o = a._domains.y[l] : delete e.domain.row);
              }
              var u = n("domain.x", i),
                c = n("domain.y", o);
              u[0] < u[1] || (e.domain.x = i.slice()), c[0] < c[1] || (e.domain.y = o.slice());
            };
          }, {
            "../lib/extend": 489
          }],
          567: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.editType,
                n = e.colorEditType;
              void 0 === n && (n = t);
              var r = {
                family: {
                  valType: "string",
                  noBlank: !0,
                  strict: !0,
                  editType: t
                },
                size: {
                  valType: "number",
                  min: 1,
                  editType: t
                },
                color: {
                  valType: "color",
                  editType: n
                },
                editType: t
              };
              return e.arrayOk && (r.family.arrayOk = !0, r.size.arrayOk = !0, r.color.arrayOk = !0), r;
            };
          }, {}],
          568: [function (e, t, n) {
            "use strict";

            t.exports = {
              _isLinkedToArray: "frames_entry",
              group: {
                valType: "string"
              },
              name: {
                valType: "string"
              },
              traces: {
                valType: "any"
              },
              baseframe: {
                valType: "string"
              },
              data: {
                valType: "any"
              },
              layout: {
                valType: "any"
              }
            };
          }, {}],
          569: [function (e, t, n) {
            "use strict";

            var r = e("../registry"),
              i = e("./cartesian/constants").SUBPLOT_PATTERN;
            n.getSubplotCalcData = function (e, t, n) {
              var i = r.subplotsRegistry[t];
              if (!i) return [];
              for (var o = i.attr, a = [], s = 0; s < e.length; s++) {
                var l = e[s];
                l[0].trace[o] === n && a.push(l);
              }
              return a;
            }, n.getModuleCalcData = function (e, t) {
              var n,
                i = [],
                o = [];
              if (!(n = "string" == typeof t ? r.getModule(t).plot : "function" == typeof t ? t : t.plot)) return [i, e];
              for (var a = 0; a < e.length; a++) {
                var s = e[a],
                  l = s[0].trace;
                !0 === l.visible && 0 !== l._length && (l._module.plot === n ? i.push(s) : o.push(s));
              }
              return [i, o];
            }, n.getSubplotData = function (e, t, n) {
              if (!r.subplotsRegistry[t]) return [];
              var o,
                a,
                s,
                l = r.subplotsRegistry[t].attr,
                u = [];
              if ("gl2d" === t) {
                var c = n.match(i);
                a = "x" + c[1], s = "y" + c[2];
              }
              for (var d = 0; d < e.length; d++) o = e[d], "gl2d" === t && r.traceIs(o, "gl2d") ? o[l[0]] === a && o[l[1]] === s && u.push(o) : o[l] === n && u.push(o);
              return u;
            };
          }, {
            "../registry": 593,
            "./cartesian/constants": 547
          }],
          570: [function (e, t, n) {
            "use strict";

            var r = e("../../plot_api/edit_types").overrideAll,
              i = e("../../components/fx/layout_attributes"),
              o = e("./scene"),
              a = e("../get_data").getSubplotData,
              s = e("../../lib"),
              l = e("../../constants/xmlns_namespaces");
            n.name = "gl3d", n.attr = "scene", n.idRoot = "scene", n.idRegex = n.attrRegex = s.counterRegex("scene"), n.attributes = e("./layout/attributes"), n.layoutAttributes = e("./layout/layout_attributes"), n.baseLayoutAttrOverrides = r({
              hoverlabel: i.hoverlabel
            }, "plot", "nested"), n.supplyLayoutDefaults = e("./layout/defaults"), n.plot = function (e) {
              for (var t = e._fullLayout, n = e._fullData, r = t._subplots.gl3d, i = 0; i < r.length; i++) {
                var s = r[i],
                  l = a(n, "gl3d", s),
                  u = t[s],
                  c = u.camera,
                  d = u._scene;
                d || (d = new o({
                  id: s,
                  graphDiv: e,
                  container: e.querySelector(".gl-container"),
                  staticPlot: e._context.staticPlot,
                  plotGlPixelRatio: e._context.plotGlPixelRatio,
                  camera: c
                }, t), u._scene = d), d.viewInitial || (d.viewInitial = {
                  up: {
                    x: c.up.x,
                    y: c.up.y,
                    z: c.up.z
                  },
                  eye: {
                    x: c.eye.x,
                    y: c.eye.y,
                    z: c.eye.z
                  },
                  center: {
                    x: c.center.x,
                    y: c.center.y,
                    z: c.center.z
                  }
                }), d.plot(l, t, e.layout);
              }
            }, n.clean = function (e, t, n, r) {
              for (var i = r._subplots.gl3d || [], o = 0; o < i.length; o++) {
                var a = i[o];
                !t[a] && r[a]._scene && (r[a]._scene.destroy(), r._infolayer && r._infolayer.selectAll(".annotation-" + a).remove());
              }
            }, n.toSVG = function (e) {
              for (var t = e._fullLayout, n = t._subplots.gl3d, r = t._size, i = 0; i < n.length; i++) {
                var o = t[n[i]],
                  a = o.domain,
                  s = o._scene,
                  u = s.toImage("png");
                t._glimages.append("svg:image").attr({
                  xmlns: l.svg,
                  "xlink:href": u,
                  x: r.l + r.w * a.x[0],
                  y: r.t + r.h * (1 - a.y[1]),
                  width: r.w * (a.x[1] - a.x[0]),
                  height: r.h * (a.y[1] - a.y[0]),
                  preserveAspectRatio: "none"
                }), s.destroy();
              }
            }, n.cleanId = function (e) {
              if (e.match(/^scene[0-9]*$/)) {
                var t = e.substr(5);
                return "1" === t && (t = ""), "scene" + t;
              }
            }, n.updateFx = function (e) {
              for (var t = e._fullLayout, n = t._subplots.gl3d, r = 0; r < n.length; r++) t[n[r]]._scene.updateFx(t.dragmode, t.hovermode);
            };
          }, {
            "../../components/fx/layout_attributes": 414,
            "../../constants/xmlns_namespaces": 475,
            "../../lib": 495,
            "../../plot_api/edit_types": 524,
            "../get_data": 569,
            "./layout/attributes": 571,
            "./layout/defaults": 575,
            "./layout/layout_attributes": 576,
            "./scene": 580
          }],
          571: [function (e, t, n) {
            "use strict";

            t.exports = {
              scene: {
                valType: "subplotid",
                dflt: "scene",
                editType: "calc+clearAxisTypes"
              }
            };
          }, {}],
          572: [function (e, t, n) {
            "use strict";

            var r = e("../../../components/color"),
              i = e("../../cartesian/layout_attributes"),
              o = e("../../../lib/extend").extendFlat,
              a = e("../../../plot_api/edit_types").overrideAll;
            t.exports = a({
              visible: i.visible,
              showspikes: {
                valType: "boolean",
                dflt: !0
              },
              spikesides: {
                valType: "boolean",
                dflt: !0
              },
              spikethickness: {
                valType: "number",
                min: 0,
                dflt: 2
              },
              spikecolor: {
                valType: "color",
                dflt: r.defaultLine
              },
              showbackground: {
                valType: "boolean",
                dflt: !1
              },
              backgroundcolor: {
                valType: "color",
                dflt: "rgba(204, 204, 204, 0.5)"
              },
              showaxeslabels: {
                valType: "boolean",
                dflt: !0
              },
              color: i.color,
              categoryorder: i.categoryorder,
              categoryarray: i.categoryarray,
              title: {
                text: i.title.text,
                font: i.title.font
              },
              type: o({}, i.type, {
                values: ["-", "linear", "log", "date", "category"]
              }),
              autorange: i.autorange,
              rangemode: i.rangemode,
              range: o({}, i.range, {
                items: [{
                  valType: "any",
                  editType: "plot",
                  impliedEdits: {
                    "^autorange": !1
                  }
                }, {
                  valType: "any",
                  editType: "plot",
                  impliedEdits: {
                    "^autorange": !1
                  }
                }],
                anim: !1
              }),
              tickmode: i.tickmode,
              nticks: i.nticks,
              tick0: i.tick0,
              dtick: i.dtick,
              tickvals: i.tickvals,
              ticktext: i.ticktext,
              ticks: i.ticks,
              mirror: i.mirror,
              ticklen: i.ticklen,
              tickwidth: i.tickwidth,
              tickcolor: i.tickcolor,
              showticklabels: i.showticklabels,
              tickfont: i.tickfont,
              tickangle: i.tickangle,
              tickprefix: i.tickprefix,
              showtickprefix: i.showtickprefix,
              ticksuffix: i.ticksuffix,
              showticksuffix: i.showticksuffix,
              showexponent: i.showexponent,
              exponentformat: i.exponentformat,
              separatethousands: i.separatethousands,
              tickformat: i.tickformat,
              tickformatstops: i.tickformatstops,
              hoverformat: i.hoverformat,
              showline: i.showline,
              linecolor: i.linecolor,
              linewidth: i.linewidth,
              showgrid: i.showgrid,
              gridcolor: o({}, i.gridcolor, {
                dflt: "rgb(204, 204, 204)"
              }),
              gridwidth: i.gridwidth,
              zeroline: i.zeroline,
              zerolinecolor: i.zerolinecolor,
              zerolinewidth: i.zerolinewidth,
              _deprecated: {
                title: i._deprecated.title,
                titlefont: i._deprecated.titlefont
              }
            }, "plot", "from-root");
          }, {
            "../../../components/color": 375,
            "../../../lib/extend": 489,
            "../../../plot_api/edit_types": 524,
            "../../cartesian/layout_attributes": 553
          }],
          573: [function (e, t, n) {
            "use strict";

            var r = e("tinycolor2").mix,
              i = e("../../../lib"),
              o = e("../../../plot_api/plot_template"),
              a = e("./axis_attributes"),
              s = e("../../cartesian/type_defaults"),
              l = e("../../cartesian/axis_defaults"),
              u = ["xaxis", "yaxis", "zaxis"];
            t.exports = function (e, t, n) {
              var c, d;
              function h(e, t) {
                return i.coerce(c, d, a, e, t);
              }
              for (var f = 0; f < u.length; f++) {
                var p = u[f];
                c = e[p] || {}, (d = o.newContainer(t, p))._id = p[0] + n.scene, d._name = p, s(c, d, h, n), l(c, d, h, {
                  font: n.font,
                  letter: p[0],
                  data: n.data,
                  showGrid: !0,
                  noTickson: !0,
                  bgColor: n.bgColor,
                  calendar: n.calendar
                }, n.fullLayout), h("gridcolor", r(d.color, n.bgColor, 13600 / 187).toRgbString()), h("title.text", p[0]), d.setScale = i.noop, h("showspikes") && (h("spikesides"), h("spikethickness"), h("spikecolor", d.color)), h("showaxeslabels"), h("showbackground") && h("backgroundcolor");
              }
            };
          }, {
            "../../../lib": 495,
            "../../../plot_api/plot_template": 531,
            "../../cartesian/axis_defaults": 543,
            "../../cartesian/type_defaults": 564,
            "./axis_attributes": 572,
            tinycolor2: 341
          }],
          574: [function (e, t, n) {
            "use strict";

            var r = e("../../../lib/str2rgbarray"),
              i = e("../../../lib"),
              o = ["xaxis", "yaxis", "zaxis"];
            function a() {
              this.bounds = [[-10, -10, -10], [10, 10, 10]], this.ticks = [[], [], []], this.tickEnable = [!0, !0, !0], this.tickFont = ["sans-serif", "sans-serif", "sans-serif"], this.tickSize = [12, 12, 12], this.tickAngle = [0, 0, 0], this.tickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.tickPad = [18, 18, 18], this.labels = ["x", "y", "z"], this.labelEnable = [!0, !0, !0], this.labelFont = ["Open Sans", "Open Sans", "Open Sans"], this.labelSize = [20, 20, 20], this.labelColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.labelPad = [30, 30, 30], this.lineEnable = [!0, !0, !0], this.lineMirror = [!1, !1, !1], this.lineWidth = [1, 1, 1], this.lineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.lineTickEnable = [!0, !0, !0], this.lineTickMirror = [!1, !1, !1], this.lineTickLength = [10, 10, 10], this.lineTickWidth = [1, 1, 1], this.lineTickColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.gridEnable = [!0, !0, !0], this.gridWidth = [1, 1, 1], this.gridColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroEnable = [!0, !0, !0], this.zeroLineColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.zeroLineWidth = [2, 2, 2], this.backgroundEnable = [!0, !0, !0], this.backgroundColor = [[.8, .8, .8, .5], [.8, .8, .8, .5], [.8, .8, .8, .5]], this._defaultTickPad = this.tickPad.slice(), this._defaultLabelPad = this.labelPad.slice(), this._defaultLineTickLength = this.lineTickLength.slice();
            }
            a.prototype.merge = function (e, t) {
              for (var n = 0; n < 3; ++n) {
                var a = t[o[n]];
                a.visible ? (this.labels[n] = e._meta ? i.templateString(a.title.text, e._meta) : a.title.text, "font" in a.title && (a.title.font.color && (this.labelColor[n] = r(a.title.font.color)), a.title.font.family && (this.labelFont[n] = a.title.font.family), a.title.font.size && (this.labelSize[n] = a.title.font.size)), "showline" in a && (this.lineEnable[n] = a.showline), "linecolor" in a && (this.lineColor[n] = r(a.linecolor)), "linewidth" in a && (this.lineWidth[n] = a.linewidth), "showgrid" in a && (this.gridEnable[n] = a.showgrid), "gridcolor" in a && (this.gridColor[n] = r(a.gridcolor)), "gridwidth" in a && (this.gridWidth[n] = a.gridwidth), "log" === a.type ? this.zeroEnable[n] = !1 : "zeroline" in a && (this.zeroEnable[n] = a.zeroline), "zerolinecolor" in a && (this.zeroLineColor[n] = r(a.zerolinecolor)), "zerolinewidth" in a && (this.zeroLineWidth[n] = a.zerolinewidth), "ticks" in a && a.ticks ? this.lineTickEnable[n] = !0 : this.lineTickEnable[n] = !1, "ticklen" in a && (this.lineTickLength[n] = this._defaultLineTickLength[n] = a.ticklen), "tickcolor" in a && (this.lineTickColor[n] = r(a.tickcolor)), "tickwidth" in a && (this.lineTickWidth[n] = a.tickwidth), "tickangle" in a && (this.tickAngle[n] = "auto" === a.tickangle ? -3600 : Math.PI * -a.tickangle / 180), "showticklabels" in a && (this.tickEnable[n] = a.showticklabels), "tickfont" in a && (a.tickfont.color && (this.tickColor[n] = r(a.tickfont.color)), a.tickfont.family && (this.tickFont[n] = a.tickfont.family), a.tickfont.size && (this.tickSize[n] = a.tickfont.size)), "mirror" in a ? -1 !== ["ticks", "all", "allticks"].indexOf(a.mirror) ? (this.lineTickMirror[n] = !0, this.lineMirror[n] = !0) : !0 === a.mirror ? (this.lineTickMirror[n] = !1, this.lineMirror[n] = !0) : (this.lineTickMirror[n] = !1, this.lineMirror[n] = !1) : this.lineMirror[n] = !1, "showbackground" in a && !1 !== a.showbackground ? (this.backgroundEnable[n] = !0, this.backgroundColor[n] = r(a.backgroundcolor)) : this.backgroundEnable[n] = !1) : (this.tickEnable[n] = !1, this.labelEnable[n] = !1, this.lineEnable[n] = !1, this.lineTickEnable[n] = !1, this.gridEnable[n] = !1, this.zeroEnable[n] = !1, this.backgroundEnable[n] = !1);
              }
            }, t.exports = function (e, t) {
              var n = new a();
              return n.merge(e, t), n;
            };
          }, {
            "../../../lib": 495,
            "../../../lib/str2rgbarray": 517
          }],
          575: [function (e, t, n) {
            "use strict";

            var r = e("../../../lib"),
              i = e("../../../components/color"),
              o = e("../../../registry"),
              a = e("../../subplot_defaults"),
              s = e("./axis_defaults"),
              l = e("./layout_attributes"),
              u = e("../../get_data").getSubplotData,
              c = "gl3d";
            function d(e, t, n, r) {
              for (var a = n("bgcolor"), l = i.combine(a, r.paper_bgcolor), d = ["up", "center", "eye"], h = 0; h < d.length; h++) n("camera." + d[h] + ".x"), n("camera." + d[h] + ".y"), n("camera." + d[h] + ".z");
              n("camera.projection.type");
              var f = !!n("aspectratio.x") && !!n("aspectratio.y") && !!n("aspectratio.z"),
                p = n("aspectmode", f ? "manual" : "auto");
              f || (e.aspectratio = t.aspectratio = {
                x: 1,
                y: 1,
                z: 1
              }, "manual" === p && (t.aspectmode = "auto"), e.aspectmode = t.aspectmode);
              var m = u(r.fullData, c, r.id);
              s(e, t, {
                font: r.font,
                scene: r.id,
                data: m,
                bgColor: l,
                calendar: r.calendar,
                fullLayout: r.fullLayout
              }), o.getComponentMethod("annotations3d", "handleDefaults")(e, t, r);
              var g = r.getDfltFromLayout("dragmode");
              if (!1 !== g && !g) if (g = "orbit", e.camera && e.camera.up) {
                var v = e.camera.up.x,
                  y = e.camera.up.y,
                  b = e.camera.up.z;
                0 !== b && (v && y && b ? b / Math.sqrt(v * v + y * y + b * b) > .999 && (g = "turntable") : g = "turntable");
              } else g = "turntable";
              n("dragmode", g), n("hovermode", r.getDfltFromLayout("hovermode"));
            }
            t.exports = function (e, t, n) {
              var i = t._basePlotModules.length > 1;
              a(e, t, n, {
                type: c,
                attributes: l,
                handleDefaults: d,
                fullLayout: t,
                font: t.font,
                fullData: n,
                getDfltFromLayout: function getDfltFromLayout(t) {
                  if (!i) return r.validate(e[t], l[t]) ? e[t] : void 0;
                },
                paper_bgcolor: t.paper_bgcolor,
                calendar: t.calendar
              });
            };
          }, {
            "../../../components/color": 375,
            "../../../lib": 495,
            "../../../registry": 593,
            "../../get_data": 569,
            "../../subplot_defaults": 591,
            "./axis_defaults": 573,
            "./layout_attributes": 576
          }],
          576: [function (e, t, n) {
            "use strict";

            var r = e("./axis_attributes"),
              i = e("../../domain").attributes,
              o = e("../../../lib/extend").extendFlat,
              a = e("../../../lib").counterRegex;
            function s(e, t, n) {
              return {
                x: {
                  valType: "number",
                  dflt: e,
                  editType: "camera"
                },
                y: {
                  valType: "number",
                  dflt: t,
                  editType: "camera"
                },
                z: {
                  valType: "number",
                  dflt: n,
                  editType: "camera"
                },
                editType: "camera"
              };
            }
            t.exports = {
              _arrayAttrRegexps: [a("scene", ".annotations", !0)],
              bgcolor: {
                valType: "color",
                dflt: "rgba(0,0,0,0)",
                editType: "plot"
              },
              camera: {
                up: o(s(0, 0, 1), {}),
                center: o(s(0, 0, 0), {}),
                eye: o(s(1.25, 1.25, 1.25), {}),
                projection: {
                  type: {
                    valType: "enumerated",
                    values: ["perspective", "orthographic"],
                    dflt: "perspective",
                    editType: "calc"
                  },
                  editType: "calc"
                },
                editType: "camera"
              },
              domain: i({
                name: "scene",
                editType: "plot"
              }),
              aspectmode: {
                valType: "enumerated",
                values: ["auto", "cube", "data", "manual"],
                dflt: "auto",
                editType: "plot",
                impliedEdits: {
                  "aspectratio.x": void 0,
                  "aspectratio.y": void 0,
                  "aspectratio.z": void 0
                }
              },
              aspectratio: {
                x: {
                  valType: "number",
                  min: 0,
                  editType: "plot",
                  impliedEdits: {
                    "^aspectmode": "manual"
                  }
                },
                y: {
                  valType: "number",
                  min: 0,
                  editType: "plot",
                  impliedEdits: {
                    "^aspectmode": "manual"
                  }
                },
                z: {
                  valType: "number",
                  min: 0,
                  editType: "plot",
                  impliedEdits: {
                    "^aspectmode": "manual"
                  }
                },
                editType: "plot",
                impliedEdits: {
                  aspectmode: "manual"
                }
              },
              xaxis: r,
              yaxis: r,
              zaxis: r,
              dragmode: {
                valType: "enumerated",
                values: ["orbit", "turntable", "zoom", "pan", !1],
                editType: "plot"
              },
              hovermode: {
                valType: "enumerated",
                values: ["closest", !1],
                dflt: "closest",
                editType: "modebar"
              },
              uirevision: {
                valType: "any",
                editType: "none"
              },
              editType: "plot",
              _deprecated: {
                cameraposition: {
                  valType: "info_array",
                  editType: "camera"
                }
              }
            };
          }, {
            "../../../lib": 495,
            "../../../lib/extend": 489,
            "../../domain": 566,
            "./axis_attributes": 572
          }],
          577: [function (e, t, n) {
            "use strict";

            var r = e("../../../lib/str2rgbarray"),
              i = ["xaxis", "yaxis", "zaxis"];
            function o() {
              this.enabled = [!0, !0, !0], this.colors = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]], this.drawSides = [!0, !0, !0], this.lineWidth = [1, 1, 1];
            }
            o.prototype.merge = function (e) {
              for (var t = 0; t < 3; ++t) {
                var n = e[i[t]];
                n.visible ? (this.enabled[t] = n.showspikes, this.colors[t] = r(n.spikecolor), this.drawSides[t] = n.spikesides, this.lineWidth[t] = n.spikethickness) : (this.enabled[t] = !1, this.drawSides[t] = !1);
              }
            }, t.exports = function (e) {
              var t = new o();
              return t.merge(e), t;
            };
          }, {
            "../../../lib/str2rgbarray": 517
          }],
          578: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = e.axesOptions, n = e.glplot.axesPixels, s = e.fullSceneLayout, l = [[], [], []], u = 0; u < 3; ++u) {
                var c = s[o[u]];
                if (c._length = (n[u].hi - n[u].lo) * n[u].pixelsPerDataUnit / e.dataScale[u], Math.abs(c._length) === 1 / 0 || isNaN(c._length)) l[u] = [];else {
                  c._input_range = c.range.slice(), c.range[0] = n[u].lo / e.dataScale[u], c.range[1] = n[u].hi / e.dataScale[u], c._m = 1 / (e.dataScale[u] * n[u].pixelsPerDataUnit), c.range[0] === c.range[1] && (c.range[0] -= 1, c.range[1] += 1);
                  var d = c.tickmode;
                  if ("auto" === c.tickmode) {
                    c.tickmode = "linear";
                    var h = c.nticks || i.constrain(c._length / 40, 4, 9);
                    r.autoTicks(c, Math.abs(c.range[1] - c.range[0]) / h);
                  }
                  for (var f = r.calcTicks(c), p = 0; p < f.length; ++p) f[p].x = f[p].x * e.dataScale[u], "date" === c.type && (f[p].text = f[p].text.replace(/\<br\>/g, " "));
                  l[u] = f, c.tickmode = d;
                }
              }
              for (t.ticks = l, u = 0; u < 3; ++u) for (a[u] = .5 * (e.glplot.bounds[0][u] + e.glplot.bounds[1][u]), p = 0; p < 2; ++p) t.bounds[p][u] = e.glplot.bounds[p][u];
              e.contourLevels = function (e) {
                for (var t = new Array(3), n = 0; n < 3; ++n) {
                  for (var r = e[n], i = new Array(r.length), o = 0; o < r.length; ++o) i[o] = r[o].x;
                  t[n] = i;
                }
                return t;
              }(l);
            };
            var r = e("../../cartesian/axes"),
              i = e("../../../lib"),
              o = ["xaxis", "yaxis", "zaxis"],
              a = [0, 0, 0];
          }, {
            "../../../lib": 495,
            "../../cartesian/axes": 541
          }],
          579: [function (e, t, n) {
            "use strict";

            function r(e, t) {
              var n,
                r,
                i = [0, 0, 0, 0];
              for (n = 0; n < 4; ++n) for (r = 0; r < 4; ++r) i[r] += e[4 * n + r] * t[n];
              return i;
            }
            t.exports = function (e, t) {
              return r(e.projection, r(e.view, r(e.model, [t[0], t[1], t[2], 1])));
            };
          }, {}],
          580: [function (e, t, n) {
            "use strict";

            var r,
              i,
              o = e("gl-plot3d"),
              a = o.createCamera,
              s = o.createScene,
              l = e("webgl-context"),
              u = e("has-passive-events"),
              c = e("../../registry"),
              d = e("../../lib"),
              h = e("../../plots/cartesian/axes"),
              f = e("../../components/fx"),
              p = e("../../lib/str2rgbarray"),
              m = e("../../lib/show_no_webgl_msg"),
              g = e("./project"),
              v = e("./layout/convert"),
              y = e("./layout/spikes"),
              b = e("./layout/tick_marks"),
              _ = e("is-mobile")({
                tablet: !0,
                featureDetect: !0
              });
            function x(e, t) {
              var n = document.createElement("div"),
                r = e.container;
              this.graphDiv = e.graphDiv;
              var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
              i.style.position = "absolute", i.style.top = i.style.left = "0px", i.style.width = i.style.height = "100%", i.style["z-index"] = 20, i.style["pointer-events"] = "none", n.appendChild(i), this.svgContainer = i, n.id = e.id, n.style.position = "absolute", n.style.top = n.style.left = "0px", n.style.width = n.style.height = "100%", r.appendChild(n), this.fullLayout = t, this.id = e.id || "scene", this.fullSceneLayout = t[this.id], this.plotArgs = [[], {}, {}], this.axesOptions = v(t, t[this.id]), this.spikeOptions = y(t[this.id]), this.container = n, this.staticMode = !!e.staticPlot, this.pixelRatio = this.pixelRatio || e.plotGlPixelRatio || 2, this.dataScale = [1, 1, 1], this.contourLevels = [[], [], []], this.convertAnnotations = c.getComponentMethod("annotations3d", "convert"), this.drawAnnotations = c.getComponentMethod("annotations3d", "draw"), this.initializeGLPlot();
            }
            var w = x.prototype;
            w.prepareOptions = function () {
              var e = {
                canvas: this.canvas,
                gl: this.gl,
                glOptions: {
                  preserveDrawingBuffer: _,
                  premultipliedAlpha: !0,
                  antialias: !0
                },
                container: this.container,
                axes: this.axesOptions,
                spikes: this.spikeOptions,
                pickRadius: 10,
                snapToData: !0,
                autoScale: !0,
                autoBounds: !1,
                cameraObject: this.camera,
                pixelRatio: this.pixelRatio
              };
              if (this.staticMode) {
                if (!(i || (r = document.createElement("canvas"), i = l({
                  canvas: r,
                  preserveDrawingBuffer: !0,
                  premultipliedAlpha: !0,
                  antialias: !0
                })))) throw new Error("error creating static canvas/context for image server");
                e.gl = i, e.canvas = r;
              }
              return e;
            }, w.tryCreatePlot = function () {
              var e = this.prepareOptions(),
                t = !0;
              try {
                this.glplot = s(e);
              } catch (n) {
                if (this.staticMode) t = !1;else try {
                  d.warn(["webgl setup failed possibly due to", _ ? "disabling" : "enabling", "preserveDrawingBuffer config.", "The device may not be supported by is-mobile module!", "Inverting preserveDrawingBuffer option in second attempt to create webgl scene."].join(" ")), _ = e.glOptions.preserveDrawingBuffer = !e.glOptions.preserveDrawingBuffer, this.glplot = s(e);
                } catch (e) {
                  t = !1;
                }
              }
              return t;
            }, w.initializeGLCamera = function () {
              var e = this.fullSceneLayout.camera,
                t = "orthographic" === e.projection.type;
              this.camera = a(this.container, {
                center: [e.center.x, e.center.y, e.center.z],
                eye: [e.eye.x, e.eye.y, e.eye.z],
                up: [e.up.x, e.up.y, e.up.z],
                _ortho: t,
                zoomMin: .01,
                zoomMax: 100,
                mode: "orbit"
              });
            }, w.initializeGLPlot = function () {
              var e = this;
              if (e.initializeGLCamera(), !e.tryCreatePlot()) return m(e);
              e.traces = {}, e.make4thDimension();
              var t = e.graphDiv,
                n = t.layout,
                r = function r() {
                  var t = {};
                  return e.isCameraChanged(n) && (t[e.id + ".camera"] = e.getCamera()), e.isAspectChanged(n) && (t[e.id + ".aspectratio"] = e.glplot.getAspectratio(), "manual" !== n[e.id].aspectmode && (e.fullSceneLayout.aspectmode = n[e.id].aspectmode = t[e.id + ".aspectmode"] = "manual")), t;
                },
                i = function i(e) {
                  if (!1 !== e.fullSceneLayout.dragmode) {
                    var t = r();
                    e.saveLayout(n), e.graphDiv.emit("plotly_relayout", t);
                  }
                };
              return e.glplot.canvas.addEventListener("mouseup", function () {
                i(e);
              }), e.glplot.canvas.addEventListener("wheel", function (n) {
                if (t._context._scrollZoom.gl3d) {
                  if (e.camera._ortho) {
                    var r = n.deltaX > n.deltaY ? 1.1 : 1 / 1.1,
                      o = e.glplot.getAspectratio();
                    e.glplot.setAspectratio({
                      x: r * o.x,
                      y: r * o.y,
                      z: r * o.z
                    });
                  }
                  i(e);
                }
              }, !!u && {
                passive: !1
              }), e.glplot.canvas.addEventListener("mousemove", function () {
                if (!1 !== e.fullSceneLayout.dragmode && 0 !== e.camera.mouseListener.buttons) {
                  var t = r();
                  e.graphDiv.emit("plotly_relayouting", t);
                }
              }), e.staticMode || e.glplot.canvas.addEventListener("webglcontextlost", function (n) {
                t && t.emit && t.emit("plotly_webglcontextlost", {
                  event: n,
                  layer: e.id
                });
              }, !1), e.glplot.oncontextloss = function () {
                e.recoverContext();
              }, e.glplot.onrender = function () {
                e.render();
              }, !0;
            }, w.render = function () {
              var e,
                t = this,
                n = t.graphDiv,
                r = t.svgContainer,
                i = t.container.getBoundingClientRect(),
                o = i.width,
                a = i.height;
              r.setAttributeNS(null, "viewBox", "0 0 " + o + " " + a), r.setAttributeNS(null, "width", o), r.setAttributeNS(null, "height", a), b(t), t.glplot.axes.update(t.axesOptions);
              for (var s, l = Object.keys(t.traces), u = null, c = t.glplot.selection, p = 0; p < l.length; ++p) "skip" !== (e = t.traces[l[p]]).data.hoverinfo && e.handlePick(c) && (u = e), e.setContourLevels && e.setContourLevels();
              function m(e, n) {
                var r = t.fullSceneLayout[e];
                return h.tickText(r, r.d2l(n), "hover").text;
              }
              if (null !== u) {
                var v = g(t.glplot.cameraParams, c.dataCoordinate);
                e = u.data;
                var y,
                  _ = n._fullData[e.index],
                  x = c.index,
                  w = {
                    xLabel: m("xaxis", c.traceCoordinate[0]),
                    yLabel: m("yaxis", c.traceCoordinate[1]),
                    zLabel: m("zaxis", c.traceCoordinate[2])
                  },
                  S = f.castHoverinfo(_, t.fullLayout, x),
                  A = (S || "").split("+"),
                  E = S && "all" === S;
                _.hovertemplate || E || (-1 === A.indexOf("x") && (w.xLabel = void 0), -1 === A.indexOf("y") && (w.yLabel = void 0), -1 === A.indexOf("z") && (w.zLabel = void 0), -1 === A.indexOf("text") && (c.textLabel = void 0), -1 === A.indexOf("name") && (u.name = void 0));
                var T = [];
                "cone" === e.type || "streamtube" === e.type ? (w.uLabel = m("xaxis", c.traceCoordinate[3]), (E || -1 !== A.indexOf("u")) && T.push("u: " + w.uLabel), w.vLabel = m("yaxis", c.traceCoordinate[4]), (E || -1 !== A.indexOf("v")) && T.push("v: " + w.vLabel), w.wLabel = m("zaxis", c.traceCoordinate[5]), (E || -1 !== A.indexOf("w")) && T.push("w: " + w.wLabel), w.normLabel = c.traceCoordinate[6].toPrecision(3), (E || -1 !== A.indexOf("norm")) && T.push("norm: " + w.normLabel), "streamtube" === e.type && (w.divergenceLabel = c.traceCoordinate[7].toPrecision(3), (E || -1 !== A.indexOf("divergence")) && T.push("divergence: " + w.divergenceLabel)), c.textLabel && T.push(c.textLabel), y = T.join("<br>")) : "isosurface" === e.type || "volume" === e.type ? (w.valueLabel = h.tickText(t._mockAxis, t._mockAxis.d2l(c.traceCoordinate[3]), "hover").text, T.push("value: " + w.valueLabel), c.textLabel && T.push(c.textLabel), y = T.join("<br>")) : y = c.textLabel;
                var M = {
                  x: c.traceCoordinate[0],
                  y: c.traceCoordinate[1],
                  z: c.traceCoordinate[2],
                  data: _._input,
                  fullData: _,
                  curveNumber: _.index,
                  pointNumber: x
                };
                f.appendArrayPointValue(M, _, x), e._module.eventData && (M = _._module.eventData(M, c, _, {}, x));
                var C = {
                  points: [M]
                };
                t.fullSceneLayout.hovermode && f.loneHover({
                  trace: _,
                  x: (.5 + .5 * v[0] / v[3]) * o,
                  y: (.5 - .5 * v[1] / v[3]) * a,
                  xLabel: w.xLabel,
                  yLabel: w.yLabel,
                  zLabel: w.zLabel,
                  text: y,
                  name: u.name,
                  color: f.castHoverOption(_, x, "bgcolor") || u.color,
                  borderColor: f.castHoverOption(_, x, "bordercolor"),
                  fontFamily: f.castHoverOption(_, x, "font.family"),
                  fontSize: f.castHoverOption(_, x, "font.size"),
                  fontColor: f.castHoverOption(_, x, "font.color"),
                  nameLength: f.castHoverOption(_, x, "namelength"),
                  textAlign: f.castHoverOption(_, x, "align"),
                  hovertemplate: d.castOption(_, x, "hovertemplate"),
                  hovertemplateLabels: d.extendFlat({}, M, w),
                  eventData: [M]
                }, {
                  container: r,
                  gd: n
                }), c.buttons && c.distance < 5 ? n.emit("plotly_click", C) : n.emit("plotly_hover", C), s = C;
              } else f.loneUnhover(r), n.emit("plotly_unhover", s);
              t.drawAnnotations(t);
            }, w.recoverContext = function () {
              var e = this;
              e.glplot.dispose();
              var t = function t() {
                e.glplot.gl.isContextLost() ? requestAnimationFrame(t) : e.initializeGLPlot() ? e.plot.apply(e, e.plotArgs) : d.error("Catastrophic and unrecoverable WebGL error. Context lost.");
              };
              requestAnimationFrame(t);
            };
            var S = ["xaxis", "yaxis", "zaxis"];
            function A(e, t, n) {
              for (var r = e.fullSceneLayout, i = 0; i < 3; i++) {
                var o = S[i],
                  a = o.charAt(0),
                  s = r[o],
                  l = t[a],
                  u = t[a + "calendar"],
                  c = t["_" + a + "length"];
                if (d.isArrayOrTypedArray(l)) {
                  for (var h, f = 0; f < (c || l.length); f++) if (d.isArrayOrTypedArray(l[f])) for (var p = 0; p < l[f].length; ++p) h = s.d2l(l[f][p], 0, u), !isNaN(h) && isFinite(h) && (n[0][i] = Math.min(n[0][i], h), n[1][i] = Math.max(n[1][i], h));else h = s.d2l(l[f], 0, u), !isNaN(h) && isFinite(h) && (n[0][i] = Math.min(n[0][i], h), n[1][i] = Math.max(n[1][i], h));
                } else n[0][i] = Math.min(n[0][i], 0), n[1][i] = Math.max(n[1][i], c - 1);
              }
            }
            w.plot = function (e, t, n) {
              if (this.plotArgs = [e, t, n], !this.glplot.contextLost) {
                var r,
                  i,
                  o,
                  a,
                  s,
                  l,
                  u = t[this.id],
                  c = n[this.id];
                this.fullLayout = t, this.fullSceneLayout = u, this.axesOptions.merge(t, u), this.spikeOptions.merge(u), this.setViewport(u), this.updateFx(u.dragmode, u.hovermode), this.camera.enableWheel = this.graphDiv._context._scrollZoom.gl3d, this.glplot.setClearColor(p(u.bgcolor)), this.setConvert(s), e ? Array.isArray(e) || (e = [e]) : e = [];
                var d = [[1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]];
                for (o = 0; o < e.length; ++o) !0 === (r = e[o]).visible && 0 !== r._length && A(this, r, d);
                !function (e, t) {
                  for (var n = e.fullSceneLayout, r = n.annotations || [], i = 0; i < 3; i++) for (var o = S[i], a = o.charAt(0), s = n[o], l = 0; l < r.length; l++) {
                    var u = r[l];
                    if (u.visible) {
                      var c = s.r2l(u[a]);
                      !isNaN(c) && isFinite(c) && (t[0][i] = Math.min(t[0][i], c), t[1][i] = Math.max(t[1][i], c));
                    }
                  }
                }(this, d);
                var h = [1, 1, 1];
                for (a = 0; a < 3; ++a) d[1][a] === d[0][a] ? h[a] = 1 : h[a] = 1 / (d[1][a] - d[0][a]);
                for (this.dataScale = h, this.convertAnnotations(this), o = 0; o < e.length; ++o) !0 === (r = e[o]).visible && 0 !== r._length && ((i = this.traces[r.uid]) ? i.data.type === r.type ? i.update(r) : (i.dispose(), i = r._module.plot(this, r), this.traces[r.uid] = i) : (i = r._module.plot(this, r), this.traces[r.uid] = i), i.name = r.name);
                var f = Object.keys(this.traces);
                e: for (o = 0; o < f.length; ++o) {
                  for (a = 0; a < e.length; ++a) if (e[a].uid === f[o] && !0 === e[a].visible && 0 !== e[a]._length) continue e;
                  (i = this.traces[f[o]]).dispose(), delete this.traces[f[o]];
                }
                this.glplot.objects.sort(function (e, t) {
                  return e._trace.data.index - t._trace.data.index;
                });
                var m,
                  g = [[0, 0, 0], [0, 0, 0]],
                  v = [],
                  y = {};
                for (o = 0; o < 3; ++o) {
                  if ((l = (s = u[S[o]]).type) in y ? (y[l].acc *= h[o], y[l].count += 1) : y[l] = {
                    acc: h[o],
                    count: 1
                  }, s.autorange) {
                    g[0][o] = 1 / 0, g[1][o] = -1 / 0;
                    var b = this.glplot.objects,
                      _ = this.fullSceneLayout.annotations || [],
                      x = s._name.charAt(0);
                    for (a = 0; a < b.length; a++) {
                      var w = b[a],
                        E = w.bounds,
                        T = w._trace.data._pad || 0;
                      "ErrorBars" === w.constructor.name && s._lowerLogErrorBound ? g[0][o] = Math.min(g[0][o], s._lowerLogErrorBound) : g[0][o] = Math.min(g[0][o], E[0][o] / h[o] - T), g[1][o] = Math.max(g[1][o], E[1][o] / h[o] + T);
                    }
                    for (a = 0; a < _.length; a++) {
                      var M = _[a];
                      if (M.visible) {
                        var C = s.r2l(M[x]);
                        g[0][o] = Math.min(g[0][o], C), g[1][o] = Math.max(g[1][o], C);
                      }
                    }
                    if ("rangemode" in s && "tozero" === s.rangemode && (g[0][o] = Math.min(g[0][o], 0), g[1][o] = Math.max(g[1][o], 0)), g[0][o] > g[1][o]) g[0][o] = -1, g[1][o] = 1;else {
                      var k = g[1][o] - g[0][o];
                      g[0][o] -= k / 32, g[1][o] += k / 32;
                    }
                    if ("reversed" === s.autorange) {
                      var P = g[0][o];
                      g[0][o] = g[1][o], g[1][o] = P;
                    }
                  } else {
                    var O = s.range;
                    g[0][o] = s.r2l(O[0]), g[1][o] = s.r2l(O[1]);
                  }
                  g[0][o] === g[1][o] && (g[0][o] -= 1, g[1][o] += 1), v[o] = g[1][o] - g[0][o], this.glplot.setBounds(o, {
                    min: g[0][o] * h[o],
                    max: g[1][o] * h[o]
                  });
                }
                var R = u.aspectmode;
                if ("cube" === R) m = [1, 1, 1];else if ("manual" === R) {
                  var I = u.aspectratio;
                  m = [I.x, I.y, I.z];
                } else {
                  if ("auto" !== R && "data" !== R) throw new Error("scene.js aspectRatio was not one of the enumerated types");
                  var j = [1, 1, 1];
                  for (o = 0; o < 3; ++o) {
                    var N = y[l = (s = u[S[o]]).type];
                    j[o] = Math.pow(N.acc, 1 / N.count) / h[o];
                  }
                  m = "data" === R || Math.max.apply(null, j) / Math.min.apply(null, j) <= 4 ? j : [1, 1, 1];
                }
                u.aspectratio.x = c.aspectratio.x = m[0], u.aspectratio.y = c.aspectratio.y = m[1], u.aspectratio.z = c.aspectratio.z = m[2], this.glplot.setAspectratio(u.aspectratio), this.viewInitial.aspectratio || (this.viewInitial.aspectratio = {
                  x: u.aspectratio.x,
                  y: u.aspectratio.y,
                  z: u.aspectratio.z
                }), this.viewInitial.aspectmode || (this.viewInitial.aspectmode = u.aspectmode);
                var L = u.domain || null,
                  D = t._size || null;
                if (L && D) {
                  var B = this.container.style;
                  B.position = "absolute", B.left = D.l + L.x[0] * D.w + "px", B.top = D.t + (1 - L.y[1]) * D.h + "px", B.width = D.w * (L.x[1] - L.x[0]) + "px", B.height = D.h * (L.y[1] - L.y[0]) + "px";
                }
                this.glplot.redraw();
              }
            }, w.destroy = function () {
              this.glplot && (this.camera.mouseListener.enabled = !1, this.container.removeEventListener("wheel", this.camera.wheelListener), this.camera = null, this.glplot.dispose(), this.container.parentNode.removeChild(this.container), this.glplot = null);
            }, w.getCamera = function () {
              var e;
              return this.camera.view.recalcMatrix(this.camera.view.lastT()), {
                up: {
                  x: (e = this.camera).up[0],
                  y: e.up[1],
                  z: e.up[2]
                },
                center: {
                  x: e.center[0],
                  y: e.center[1],
                  z: e.center[2]
                },
                eye: {
                  x: e.eye[0],
                  y: e.eye[1],
                  z: e.eye[2]
                },
                projection: {
                  type: !0 === e._ortho ? "orthographic" : "perspective"
                }
              };
            }, w.setViewport = function (e) {
              var t,
                n = e.camera;
              this.camera.lookAt.apply(this, [[(t = n).eye.x, t.eye.y, t.eye.z], [t.center.x, t.center.y, t.center.z], [t.up.x, t.up.y, t.up.z]]), this.glplot.setAspectratio(e.aspectratio), "orthographic" === n.projection.type !== this.camera._ortho && (this.glplot.redraw(), this.glplot.clearRGBA(), this.glplot.dispose(), this.initializeGLPlot());
            }, w.isCameraChanged = function (e) {
              var t = this.getCamera(),
                n = d.nestedProperty(e, this.id + ".camera").get();
              function r(e, t, n, r) {
                var i = ["up", "center", "eye"],
                  o = ["x", "y", "z"];
                return t[i[n]] && e[i[n]][o[r]] === t[i[n]][o[r]];
              }
              var i = !1;
              if (void 0 === n) i = !0;else {
                for (var o = 0; o < 3; o++) for (var a = 0; a < 3; a++) if (!r(t, n, o, a)) {
                  i = !0;
                  break;
                }
                (!n.projection || t.projection && t.projection.type !== n.projection.type) && (i = !0);
              }
              return i;
            }, w.isAspectChanged = function (e) {
              var t = this.glplot.getAspectratio(),
                n = d.nestedProperty(e, this.id + ".aspectratio").get();
              return void 0 === n || n.x !== t.x || n.y !== t.y || n.z !== t.z;
            }, w.saveLayout = function (e) {
              var t,
                n,
                r,
                i,
                o,
                a,
                s = this.fullLayout,
                l = this.isCameraChanged(e),
                u = this.isAspectChanged(e),
                h = l || u;
              if (h) {
                var f = {};
                l && (t = this.getCamera(), r = (n = d.nestedProperty(e, this.id + ".camera")).get(), f[this.id + ".camera"] = r), u && (i = this.glplot.getAspectratio(), a = (o = d.nestedProperty(e, this.id + ".aspectratio")).get(), f[this.id + ".aspectratio"] = a), c.call("_storeDirectGUIEdit", e, s._preGUI, f), l && (n.set(t), d.nestedProperty(s, this.id + ".camera").set(t)), u && (o.set(i), d.nestedProperty(s, this.id + ".aspectratio").set(i), this.glplot.redraw());
              }
              return h;
            }, w.updateFx = function (e, t) {
              var n = this.camera;
              if (n) if ("orbit" === e) n.mode = "orbit", n.keyBindingMode = "rotate";else if ("turntable" === e) {
                n.up = [0, 0, 1], n.mode = "turntable", n.keyBindingMode = "rotate";
                var r = this.graphDiv,
                  i = r._fullLayout,
                  o = this.fullSceneLayout.camera,
                  a = o.up.x,
                  s = o.up.y,
                  l = o.up.z;
                if (l / Math.sqrt(a * a + s * s + l * l) < .999) {
                  var u = this.id + ".camera.up",
                    h = {
                      x: 0,
                      y: 0,
                      z: 1
                    },
                    f = {};
                  f[u] = h;
                  var p = r.layout;
                  c.call("_storeDirectGUIEdit", p, i._preGUI, f), o.up = h, d.nestedProperty(p, u).set(h);
                }
              } else n.keyBindingMode = e;
              this.fullSceneLayout.hovermode = t;
            }, w.toImage = function (e) {
              e || (e = "png"), this.staticMode && this.container.appendChild(r), this.glplot.redraw();
              var t = this.glplot.gl,
                n = t.drawingBufferWidth,
                i = t.drawingBufferHeight;
              t.bindFramebuffer(t.FRAMEBUFFER, null);
              var o = new Uint8Array(n * i * 4);
              t.readPixels(0, 0, n, i, t.RGBA, t.UNSIGNED_BYTE, o);
              for (var a = 0, s = i - 1; a < s; ++a, --s) for (var l = 0; l < n; ++l) for (var u = 0; u < 4; ++u) {
                var c = o[4 * (n * a + l) + u];
                o[4 * (n * a + l) + u] = o[4 * (n * s + l) + u], o[4 * (n * s + l) + u] = c;
              }
              var d = document.createElement("canvas");
              d.width = n, d.height = i;
              var h,
                f = d.getContext("2d"),
                p = f.createImageData(n, i);
              switch (p.data.set(o), f.putImageData(p, 0, 0), e) {
                case "jpeg":
                  h = d.toDataURL("image/jpeg");
                  break;
                case "webp":
                  h = d.toDataURL("image/webp");
                  break;
                default:
                  h = d.toDataURL("image/png");
              }
              return this.staticMode && this.container.removeChild(r), h;
            }, w.setConvert = function () {
              for (var e = 0; e < 3; e++) {
                var t = this.fullSceneLayout[S[e]];
                h.setConvert(t, this.fullLayout), t.setScale = d.noop;
              }
            }, w.make4thDimension = function () {
              var e = this.graphDiv._fullLayout;
              this._mockAxis = {
                type: "linear",
                showexponent: "all",
                exponentformat: "B"
              }, h.setConvert(this._mockAxis, e);
            }, t.exports = x;
          }, {
            "../../components/fx": 413,
            "../../lib": 495,
            "../../lib/show_no_webgl_msg": 515,
            "../../lib/str2rgbarray": 517,
            "../../plots/cartesian/axes": 541,
            "../../registry": 593,
            "./layout/convert": 574,
            "./layout/spikes": 577,
            "./layout/tick_marks": 578,
            "./project": 579,
            "gl-plot3d": 143,
            "has-passive-events": 251,
            "is-mobile": 259,
            "webgl-context": 356
          }],
          581: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n, r) {
              r = r || e.length;
              for (var i = new Array(r), o = 0; o < r; o++) i[o] = [e[o], t[o], n[o]];
              return i;
            };
          }, {}],
          582: [function (e, t, n) {
            "use strict";

            var r = e("./font_attributes"),
              i = e("./animation_attributes"),
              o = e("../components/color/attributes"),
              a = e("./pad_attributes"),
              s = e("../lib/extend").extendFlat,
              l = r({
                editType: "calc"
              });
            l.family.dflt = '"Open Sans", verdana, arial, sans-serif', l.size.dflt = 12, l.color.dflt = o.defaultLine, t.exports = {
              font: l,
              title: {
                text: {
                  valType: "string",
                  editType: "layoutstyle"
                },
                font: r({
                  editType: "layoutstyle"
                }),
                xref: {
                  valType: "enumerated",
                  dflt: "container",
                  values: ["container", "paper"],
                  editType: "layoutstyle"
                },
                yref: {
                  valType: "enumerated",
                  dflt: "container",
                  values: ["container", "paper"],
                  editType: "layoutstyle"
                },
                x: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: .5,
                  editType: "layoutstyle"
                },
                y: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: "auto",
                  editType: "layoutstyle"
                },
                xanchor: {
                  valType: "enumerated",
                  dflt: "auto",
                  values: ["auto", "left", "center", "right"],
                  editType: "layoutstyle"
                },
                yanchor: {
                  valType: "enumerated",
                  dflt: "auto",
                  values: ["auto", "top", "middle", "bottom"],
                  editType: "layoutstyle"
                },
                pad: s(a({
                  editType: "layoutstyle"
                }), {}),
                editType: "layoutstyle"
              },
              uniformtext: {
                mode: {
                  valType: "enumerated",
                  values: [!1, "hide", "show"],
                  dflt: !1,
                  editType: "plot"
                },
                minsize: {
                  valType: "number",
                  min: 0,
                  dflt: 0,
                  editType: "plot"
                },
                editType: "plot"
              },
              autosize: {
                valType: "boolean",
                dflt: !1,
                editType: "none"
              },
              width: {
                valType: "number",
                min: 10,
                dflt: 700,
                editType: "plot"
              },
              height: {
                valType: "number",
                min: 10,
                dflt: 450,
                editType: "plot"
              },
              margin: {
                l: {
                  valType: "number",
                  min: 0,
                  dflt: 80,
                  editType: "plot"
                },
                r: {
                  valType: "number",
                  min: 0,
                  dflt: 80,
                  editType: "plot"
                },
                t: {
                  valType: "number",
                  min: 0,
                  dflt: 100,
                  editType: "plot"
                },
                b: {
                  valType: "number",
                  min: 0,
                  dflt: 80,
                  editType: "plot"
                },
                pad: {
                  valType: "number",
                  min: 0,
                  dflt: 0,
                  editType: "plot"
                },
                autoexpand: {
                  valType: "boolean",
                  dflt: !0,
                  editType: "plot"
                },
                editType: "plot"
              },
              paper_bgcolor: {
                valType: "color",
                dflt: o.background,
                editType: "plot"
              },
              plot_bgcolor: {
                valType: "color",
                dflt: o.background,
                editType: "layoutstyle"
              },
              separators: {
                valType: "string",
                editType: "plot"
              },
              hidesources: {
                valType: "boolean",
                dflt: !1,
                editType: "plot"
              },
              showlegend: {
                valType: "boolean",
                editType: "legend"
              },
              colorway: {
                valType: "colorlist",
                dflt: o.defaults,
                editType: "calc"
              },
              datarevision: {
                valType: "any",
                editType: "calc"
              },
              uirevision: {
                valType: "any",
                editType: "none"
              },
              editrevision: {
                valType: "any",
                editType: "none"
              },
              selectionrevision: {
                valType: "any",
                editType: "none"
              },
              template: {
                valType: "any",
                editType: "calc"
              },
              modebar: {
                orientation: {
                  valType: "enumerated",
                  values: ["v", "h"],
                  dflt: "h",
                  editType: "modebar"
                },
                bgcolor: {
                  valType: "color",
                  editType: "modebar"
                },
                color: {
                  valType: "color",
                  editType: "modebar"
                },
                activecolor: {
                  valType: "color",
                  editType: "modebar"
                },
                uirevision: {
                  valType: "any",
                  editType: "none"
                },
                editType: "modebar"
              },
              meta: {
                valType: "any",
                arrayOk: !0,
                editType: "plot"
              },
              transition: s({}, i.transition, {
                editType: "none"
              }),
              _deprecated: {
                title: {
                  valType: "string",
                  editType: "layoutstyle"
                },
                titlefont: r({
                  editType: "layoutstyle"
                })
              }
            };
          }, {
            "../components/color/attributes": 374,
            "../lib/extend": 489,
            "./animation_attributes": 536,
            "./font_attributes": 567,
            "./pad_attributes": 583
          }],
          583: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              var t = e.editType;
              return {
                t: {
                  valType: "number",
                  dflt: 0,
                  editType: t
                },
                r: {
                  valType: "number",
                  dflt: 0,
                  editType: t
                },
                b: {
                  valType: "number",
                  dflt: 0,
                  editType: t
                },
                l: {
                  valType: "number",
                  dflt: 0,
                  editType: t
                },
                editType: t
              };
            };
          }, {}],
          584: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("fast-isnumeric"),
              o = e("../registry"),
              a = e("../plot_api/plot_schema"),
              s = e("../plot_api/plot_template"),
              l = e("../lib"),
              u = e("../components/color"),
              c = e("../constants/numerical").BADNUM,
              d = e("./cartesian/axis_ids"),
              h = e("./animation_attributes"),
              f = e("./frame_attributes"),
              p = e("../plots/get_data").getModuleCalcData,
              m = l.relinkPrivateKeys,
              g = l._,
              v = t.exports = {};
            l.extendFlat(v, o), v.attributes = e("./attributes"), v.attributes.type.values = v.allTypes, v.fontAttrs = e("./font_attributes"), v.layoutAttributes = e("./layout_attributes"), v.fontWeight = "normal";
            var y = v.transformsRegistry,
              b = e("./command");
            v.executeAPICommand = b.executeAPICommand, v.computeAPICommandBindings = b.computeAPICommandBindings, v.manageCommandObserver = b.manageCommandObserver, v.hasSimpleAPICommandBindings = b.hasSimpleAPICommandBindings, v.redrawText = function (e) {
              var t = (e = l.getGraphDiv(e))._fullLayout || {};
              if (t._has && t._has("polar") || !e.data || !e.data[0] || !e.data[0].r) return new Promise(function (t) {
                setTimeout(function () {
                  o.getComponentMethod("annotations", "draw")(e), o.getComponentMethod("legend", "draw")(e), o.getComponentMethod("colorbar", "draw")(e), t(v.previousPromises(e));
                }, 300);
              });
            }, v.resize = function (e) {
              var t;
              e = l.getGraphDiv(e);
              var n = new Promise(function (n, r) {
                e && !l.isHidden(e) || r(new Error("Resize must be passed a displayed plot div element.")), e._redrawTimer && clearTimeout(e._redrawTimer), e._resolveResize && (t = e._resolveResize), e._resolveResize = n, e._redrawTimer = setTimeout(function () {
                  if (!e.layout || e.layout.width && e.layout.height || l.isHidden(e)) n(e);else {
                    delete e.layout.width, delete e.layout.height;
                    var t = e.changed;
                    e.autoplay = !0, o.call("relayout", e, {
                      autosize: !0
                    }).then(function () {
                      e.changed = t, e._resolveResize === n && (delete e._resolveResize, n(e));
                    });
                  }
                }, 100);
              });
              return t && t(n), n;
            }, v.previousPromises = function (e) {
              if ((e._promises || []).length) return Promise.all(e._promises).then(function () {
                e._promises = [];
              });
            }, v.addLinks = function (e) {
              if (e._context.showLink || e._context.showSources) {
                var t = e._fullLayout,
                  n = l.ensureSingle(t._paper, "text", "js-plot-link-container", function (e) {
                    e.style({
                      "font-family": '"Open Sans", Arial, sans-serif',
                      "font-size": "12px",
                      fill: u.defaultLine,
                      "pointer-events": "all"
                    }).each(function () {
                      var e = r.select(this);
                      e.append("tspan").classed("js-link-to-tool", !0), e.append("tspan").classed("js-link-spacer", !0), e.append("tspan").classed("js-sourcelinks", !0);
                    });
                  }),
                  i = n.node(),
                  o = {
                    y: t._paper.attr("height") - 9
                  };
                document.body.contains(i) && i.getComputedTextLength() >= t.width - 20 ? (o["text-anchor"] = "start", o.x = 5) : (o["text-anchor"] = "end", o.x = t._paper.attr("width") - 7), n.attr(o);
                var a = n.select(".js-link-to-tool"),
                  s = n.select(".js-link-spacer"),
                  c = n.select(".js-sourcelinks");
                e._context.showSources && e._context.showSources(e), e._context.showLink && function (e, t) {
                  t.text("");
                  var n = t.append("a").attr({
                    "xlink:xlink:href": "#",
                    class: "link--impt link--embedview",
                    "font-weight": "bold"
                  }).text(e._context.linkText + " " + String.fromCharCode(187));
                  if (e._context.sendData) n.on("click", function () {
                    v.sendDataToCloud(e);
                  });else {
                    var r = window.location.pathname.split("/"),
                      i = window.location.search;
                    n.attr({
                      "xlink:xlink:show": "new",
                      "xlink:xlink:href": "/" + r[2].split(".")[0] + "/" + r[1] + i
                    });
                  }
                }(e, a), s.text(a.text() && c.text() ? " - " : "");
              }
            }, v.sendDataToCloud = function (e) {
              e.emit("plotly_beforeexport");
              var t = (window.PLOTLYENV || {}).BASE_URL || e._context.plotlyServerURL,
                n = r.select(e).append("div").attr("id", "hiddenform").style("display", "none"),
                i = n.append("form").attr({
                  action: t + "/external",
                  method: "post",
                  target: "_blank"
                });
              return i.append("input").attr({
                type: "text",
                name: "data"
              }).node().value = v.graphJson(e, !1, "keepdata"), i.node().submit(), n.remove(), e.emit("plotly_afterexport"), !1;
            };
            var _ = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"],
              x = ["year", "month", "dayMonth", "dayMonthYear"];
            function w(e, t) {
              var n = e._context.locale,
                r = !1,
                i = {};
              function a(e) {
                for (var n = !0, o = 0; o < t.length; o++) {
                  var a = t[o];
                  i[a] || (e[a] ? i[a] = e[a] : n = !1);
                }
                n && (r = !0);
              }
              for (var s = 0; s < 2; s++) {
                for (var l = e._context.locales, u = 0; u < 2; u++) {
                  var c = (l[n] || {}).format;
                  if (c && (a(c), r)) break;
                  l = o.localeRegistry;
                }
                var d = n.split("-")[0];
                if (r || d === n) break;
                n = d;
              }
              return r || a(o.localeRegistry.en.format), i;
            }
            function S(e, t) {
              var n = {
                  _fullLayout: t
                },
                r = "x" === e._id.charAt(0),
                i = e._mainAxis._anchorAxis,
                o = "",
                a = "",
                s = "";
              if (i && (s = i._mainAxis._id, o = r ? e._id + s : s + e._id), !o || !t._plots[o]) {
                o = "";
                for (var l = e._counterAxes, u = 0; u < l.length; u++) {
                  var c = l[u],
                    h = r ? e._id + c : c + e._id;
                  a || (a = h);
                  var f = d.getFromId(n, c);
                  if (s && f.overlaying === s) {
                    o = h;
                    break;
                  }
                }
              }
              return o || a;
            }
            function A(e) {
              var t = e.transforms;
              if (Array.isArray(t) && t.length) for (var n = 0; n < t.length; n++) {
                var r = t[n],
                  i = r._module || y[r.type];
                if (i && i.makesData) return !0;
              }
              return !1;
            }
            function E(e, t, n, r) {
              for (var i = e.transforms, o = [e], a = 0; a < i.length; a++) {
                var s = i[a],
                  l = y[s.type];
                l && l.transform && (o = l.transform(o, {
                  transform: s,
                  fullTrace: e,
                  fullData: t,
                  layout: n,
                  fullLayout: r,
                  transformIndex: a
                }));
              }
              return o;
            }
            function T(e) {
              var t = e.margin;
              if (!e._size) {
                var n = e._size = {
                  l: Math.round(t.l),
                  r: Math.round(t.r),
                  t: Math.round(t.t),
                  b: Math.round(t.b),
                  p: Math.round(t.pad)
                };
                n.w = Math.round(e.width) - n.l - n.r, n.h = Math.round(e.height) - n.t - n.b;
              }
              e._pushmargin || (e._pushmargin = {}), e._pushmarginIds || (e._pushmarginIds = {});
            }
            v.supplyDefaults = function (e, t) {
              var n = t && t.skipUpdateCalc,
                i = e._fullLayout || {};
              if (i._skipDefaults) delete i._skipDefaults;else {
                var a,
                  s = e._fullLayout = {},
                  u = e.layout || {},
                  c = e._fullData || [],
                  d = e._fullData = [],
                  h = e.data || [],
                  f = e.calcdata || [],
                  p = e._context || {};
                e._transitionData || v.createTransitionData(e), s._dfltTitle = {
                  plot: g(e, "Click to enter Plot title"),
                  x: g(e, "Click to enter X axis title"),
                  y: g(e, "Click to enter Y axis title"),
                  colorbar: g(e, "Click to enter Colorscale title"),
                  annotation: g(e, "new text")
                }, s._traceWord = g(e, "trace");
                var y = w(e, _);
                if (s._mapboxAccessToken = p.mapboxAccessToken, i._initialAutoSizeIsDone) {
                  var b = i.width,
                    S = i.height;
                  v.supplyLayoutGlobalDefaults(u, s, y), u.width || (s.width = b), u.height || (s.height = S), v.sanitizeMargins(s);
                } else {
                  v.supplyLayoutGlobalDefaults(u, s, y);
                  var A = !u.width || !u.height,
                    E = s.autosize,
                    M = p.autosizable;
                  A && (E || M) ? v.plotAutoSize(e, u, s) : A && v.sanitizeMargins(s), !E && A && (u.width = s.width, u.height = s.height);
                }
                s._d3locale = function (e, t) {
                  return e.decimal = t.charAt(0), e.thousands = t.charAt(1), r.locale(e);
                }(y, s.separators), s._extraFormat = w(e, x), s._initialAutoSizeIsDone = !0, s._dataLength = h.length, s._modules = [], s._visibleModules = [], s._basePlotModules = [];
                var C = s._subplots = function () {
                    var e,
                      t,
                      n = o.collectableSubplotTypes,
                      r = {};
                    if (!n) {
                      n = [];
                      var i = o.subplotsRegistry;
                      for (var a in i) {
                        var s = i[a].attr;
                        if (s && (n.push(a), Array.isArray(s))) for (t = 0; t < s.length; t++) l.pushUnique(n, s[t]);
                      }
                    }
                    for (e = 0; e < n.length; e++) r[n[e]] = [];
                    return r;
                  }(),
                  k = s._splomAxes = {
                    x: {},
                    y: {}
                  },
                  P = s._splomSubplots = {};
                s._splomGridDflt = {}, s._scatterStackOpts = {}, s._firstScatter = {}, s._alignmentOpts = {}, s._colorAxes = {}, s._requestRangeslider = {}, s._traceUids = function (e, t) {
                  var n,
                    r,
                    i = t.length,
                    o = [];
                  for (n = 0; n < e.length; n++) {
                    var a = e[n]._fullInput;
                    a !== r && o.push(a), r = a;
                  }
                  var s = o.length,
                    u = new Array(i),
                    c = {};
                  function d(e, t) {
                    u[t] = e, c[e] = 1;
                  }
                  function h(e, t) {
                    if (e && "string" == typeof e && !c[e]) return d(e, t), !0;
                  }
                  for (n = 0; n < i; n++) {
                    var f = t[n].uid;
                    "number" == typeof f && (f = String(f)), h(f, n) || n < s && h(o[n].uid, n) || d(l.randstr(c), n);
                  }
                  return u;
                }(c, h), s._globalTransforms = (e._context || {}).globalTransforms, v.supplyDataDefaults(h, d, u, s);
                var O = Object.keys(k.x),
                  R = Object.keys(k.y);
                if (O.length > 1 && R.length > 1) {
                  for (o.getComponentMethod("grid", "sizeDefaults")(u, s), a = 0; a < O.length; a++) l.pushUnique(C.xaxis, O[a]);
                  for (a = 0; a < R.length; a++) l.pushUnique(C.yaxis, R[a]);
                  for (var I in P) l.pushUnique(C.cartesian, I);
                }
                if (s._has = v._hasPlotType.bind(s), c.length === d.length) for (a = 0; a < d.length; a++) m(d[a], c[a]);
                v.supplyLayoutModuleDefaults(u, s, d, e._transitionData);
                var j = s._visibleModules,
                  N = [];
                for (a = 0; a < j.length; a++) {
                  var L = j[a].crossTraceDefaults;
                  L && l.pushUnique(N, L);
                }
                for (a = 0; a < N.length; a++) N[a](d, s);
                s._hasOnlyLargeSploms = 1 === s._basePlotModules.length && "splom" === s._basePlotModules[0].name && O.length > 15 && R.length > 15 && 0 === s.shapes.length && 0 === s.images.length, s._hasCartesian = s._has("cartesian"), s._hasGeo = s._has("geo"), s._hasGL3D = s._has("gl3d"), s._hasGL2D = s._has("gl2d"), s._hasTernary = s._has("ternary"), s._hasPie = s._has("pie"), v.linkSubplots(d, s, c, i), v.cleanPlot(d, s, c, i), i._zoomlayer && !e._dragging && i._zoomlayer.selectAll(".select-outline").remove(), function (e, t) {
                  var n,
                    r = [];
                  t.meta && (n = t._meta = {
                    meta: t.meta,
                    layout: {
                      meta: t.meta
                    }
                  });
                  for (var i = 0; i < e.length; i++) {
                    var o = e[i];
                    o.meta ? r[o.index] = o._meta = {
                      meta: o.meta
                    } : t.meta && (o._meta = {
                      meta: t.meta
                    }), t.meta && (o._meta.layout = {
                      meta: t.meta
                    });
                  }
                  r.length && (n || (n = t._meta = {}), n.data = r);
                }(d, s), m(s, i), o.getComponentMethod("colorscale", "crossTraceDefaults")(d, s), s._preGUI || (s._preGUI = {}), s._tracePreGUI || (s._tracePreGUI = {});
                var D,
                  B = s._tracePreGUI,
                  F = {};
                for (D in B) F[D] = "old";
                for (a = 0; a < d.length; a++) F[D = d[a]._fullInput.uid] || (B[D] = {}), F[D] = "new";
                for (D in F) "old" === F[D] && delete B[D];
                T(s), o.getComponentMethod("rangeslider", "makeData")(s), n || f.length !== d.length || v.supplyDefaultsUpdateCalc(f, d);
              }
            }, v.supplyDefaultsUpdateCalc = function (e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n],
                  i = (e[n] || [])[0];
                if (i && i.trace) {
                  var o = i.trace;
                  if (o._hasCalcTransform) {
                    var a,
                      s,
                      u,
                      c = o._arrayAttrs;
                    for (a = 0; a < c.length; a++) s = c[a], u = l.nestedProperty(o, s).get().slice(), l.nestedProperty(r, s).set(u);
                  }
                  i.trace = r;
                }
              }
            }, v.createTransitionData = function (e) {
              e._transitionData || (e._transitionData = {}), e._transitionData._frames || (e._transitionData._frames = []), e._transitionData._frameHash || (e._transitionData._frameHash = {}), e._transitionData._counter || (e._transitionData._counter = 0), e._transitionData._interruptCallbacks || (e._transitionData._interruptCallbacks = []);
            }, v._hasPlotType = function (e) {
              var t,
                n = this._basePlotModules || [];
              for (t = 0; t < n.length; t++) if (n[t].name === e) return !0;
              var r = this._modules || [];
              for (t = 0; t < r.length; t++) {
                var i = r[t].name;
                if (i === e) return !0;
                var a = o.modules[i];
                if (a && a.categories[e]) return !0;
              }
              return !1;
            }, v.cleanPlot = function (e, t, n, r) {
              var i,
                o,
                a = r._basePlotModules || [];
              for (i = 0; i < a.length; i++) {
                var s = a[i];
                s.clean && s.clean(e, t, n, r);
              }
              var l = r._has && r._has("gl"),
                u = t._has && t._has("gl");
              l && !u && void 0 !== r._glcontainer && (r._glcontainer.selectAll(".gl-canvas").remove(), r._glcontainer.selectAll(".no-webgl").remove(), r._glcanvas = null);
              var c = !!r._infolayer;
              e: for (i = 0; i < n.length; i++) {
                var d = n[i].uid;
                for (o = 0; o < e.length; o++) if (d === e[o].uid) continue e;
                c && r._infolayer.select(".cb" + d).remove();
              }
            }, v.linkSubplots = function (e, t, n, r) {
              var i,
                a,
                s = r._plots || {},
                u = t._plots = {},
                c = t._subplots,
                h = {
                  _fullData: e,
                  _fullLayout: t
                },
                f = c.cartesian.concat(c.gl2d || []);
              for (i = 0; i < f.length; i++) {
                var p,
                  m = f[i],
                  g = s[m],
                  v = d.getFromId(h, m, "x"),
                  y = d.getFromId(h, m, "y");
                for (g ? p = u[m] = g : (p = u[m] = {}).id = m, v._counterAxes.push(y._id), y._counterAxes.push(v._id), v._subplotsWith.push(m), y._subplotsWith.push(m), p.xaxis = v, p.yaxis = y, p._hasClipOnAxisFalse = !1, a = 0; a < e.length; a++) {
                  var b = e[a];
                  if (b.xaxis === p.xaxis._id && b.yaxis === p.yaxis._id && !1 === b.cliponaxis) {
                    p._hasClipOnAxisFalse = !0;
                    break;
                  }
                }
              }
              var _,
                x = d.list(h, null, !0);
              for (i = 0; i < x.length; i++) {
                var w = null;
                (_ = x[i]).overlaying && (w = d.getFromId(h, _.overlaying)) && w.overlaying && (_.overlaying = !1, w = null), _._mainAxis = w || _, w && (_.domain = w.domain.slice()), _._anchorAxis = "free" === _.anchor ? null : d.getFromId(h, _.anchor);
              }
              for (i = 0; i < x.length; i++) if ((_ = x[i])._counterAxes.sort(d.idSort), _._subplotsWith.sort(l.subplotSort), _._mainSubplot = S(_, t), _._counterAxes.length && (_.spikemode && -1 !== _.spikemode.indexOf("across") || _.automargin && _.mirror && "free" !== _.anchor || o.getComponentMethod("rangeslider", "isVisible")(_))) {
                var A = 1,
                  E = 0;
                for (a = 0; a < _._counterAxes.length; a++) {
                  var T = d.getFromId(h, _._counterAxes[a]);
                  A = Math.min(A, T.domain[0]), E = Math.max(E, T.domain[1]);
                }
                A < E && (_._counterDomainMin = A, _._counterDomainMax = E);
              }
            }, v.clearExpandedTraceDefaultColors = function (e) {
              var t, n, r;
              for (n = [], (t = e._module._colorAttrs) || (e._module._colorAttrs = t = [], a.crawl(e._module.attributes, function (e, r, i, o) {
                n[o] = r, n.length = o + 1, "color" === e.valType && void 0 === e.dflt && t.push(n.join("."));
              })), r = 0; r < t.length; r++) l.nestedProperty(e, "_input." + t[r]).get() || l.nestedProperty(e, t[r]).set(null);
            }, v.supplyDataDefaults = function (e, t, n, r) {
              var i,
                a,
                u,
                c = r._modules,
                d = r._visibleModules,
                h = r._basePlotModules,
                f = 0,
                p = 0;
              function g(e) {
                t.push(e);
                var n = e._module;
                n && (l.pushUnique(c, n), !0 === e.visible && l.pushUnique(d, n), l.pushUnique(h, e._module.basePlotModule), f++, !1 !== e._input.visible && p++);
              }
              r._transformModules = [];
              var y = {},
                b = [],
                _ = (n.template || {}).data || {},
                x = s.traceTemplater(_);
              for (i = 0; i < e.length; i++) {
                if (u = e[i], (a = x.newTrace(u)).uid = r._traceUids[i], v.supplyTraceDefaults(u, a, p, r, i), a.index = i, a._input = u, a._expandedIndex = f, a.transforms && a.transforms.length) for (var w = !1 !== u.visible && !1 === a.visible, S = E(a, t, n, r), A = 0; A < S.length; A++) {
                  var T = S[A],
                    M = {
                      _template: a._template,
                      type: a.type,
                      uid: a.uid + A
                    };
                  w && !1 === T.visible && delete T.visible, v.supplyTraceDefaults(T, M, f, r, i), m(M, T), M.index = i, M._input = u, M._fullInput = a, M._expandedIndex = f, M._expandedInput = T, g(M);
                } else a._fullInput = a, a._expandedInput = a, g(a);
                o.traceIs(a, "carpetAxis") && (y[a.carpet] = a), o.traceIs(a, "carpetDependent") && b.push(i);
              }
              for (i = 0; i < b.length; i++) if ((a = t[b[i]]).visible) {
                var C = y[a.carpet];
                a._carpet = C, C && C.visible ? (a.xaxis = C.xaxis, a.yaxis = C.yaxis) : a.visible = !1;
              }
            }, v.supplyAnimationDefaults = function (e) {
              var t;
              e = e || {};
              var n = {};
              function r(t, r) {
                return l.coerce(e || {}, n, h, t, r);
              }
              if (r("mode"), r("direction"), r("fromcurrent"), Array.isArray(e.frame)) for (n.frame = [], t = 0; t < e.frame.length; t++) n.frame[t] = v.supplyAnimationFrameDefaults(e.frame[t] || {});else n.frame = v.supplyAnimationFrameDefaults(e.frame || {});
              if (Array.isArray(e.transition)) for (n.transition = [], t = 0; t < e.transition.length; t++) n.transition[t] = v.supplyAnimationTransitionDefaults(e.transition[t] || {});else n.transition = v.supplyAnimationTransitionDefaults(e.transition || {});
              return n;
            }, v.supplyAnimationFrameDefaults = function (e) {
              var t = {};
              function n(n, r) {
                return l.coerce(e || {}, t, h.frame, n, r);
              }
              return n("duration"), n("redraw"), t;
            }, v.supplyAnimationTransitionDefaults = function (e) {
              var t = {};
              function n(n, r) {
                return l.coerce(e || {}, t, h.transition, n, r);
              }
              return n("duration"), n("easing"), t;
            }, v.supplyFrameDefaults = function (e) {
              var t = {};
              function n(n, r) {
                return l.coerce(e, t, f, n, r);
              }
              return n("group"), n("name"), n("traces"), n("baseframe"), n("data"), n("layout"), t;
            }, v.supplyTraceDefaults = function (e, t, n, r, i) {
              var a,
                s = r.colorway || u.defaults,
                c = s[n % s.length];
              function d(n, r) {
                return l.coerce(e, t, v.attributes, n, r);
              }
              var h = d("visible");
              d("type"), d("name", r._traceWord + " " + i), d("uirevision", r.uirevision);
              var f = v.getModule(t);
              if (t._module = f, f) {
                var p = f.basePlotModule,
                  m = p.attr,
                  g = p.attributes;
                if (m && g) {
                  var y = r._subplots,
                    b = "";
                  if (h || "gl2d" !== p.name) {
                    if (Array.isArray(m)) for (a = 0; a < m.length; a++) {
                      var _ = m[a],
                        x = l.coerce(e, t, g, _);
                      y[_] && l.pushUnique(y[_], x), b += x;
                    } else b = l.coerce(e, t, g, m);
                    y[p.name] && l.pushUnique(y[p.name], b);
                  }
                }
              }
              return h && (d("customdata"), d("ids"), d("meta"), o.traceIs(t, "showLegend") ? (l.coerce(e, t, f.attributes.showlegend ? f.attributes : v.attributes, "showlegend"), d("legendgroup"), t._dfltShowLegend = !0) : t._dfltShowLegend = !1, f && f.supplyDefaults(e, t, c, r), o.traceIs(t, "noOpacity") || d("opacity"), o.traceIs(t, "notLegendIsolatable") && (t.visible = !!t.visible), o.traceIs(t, "noHover") || (t.hovertemplate || l.coerceHoverinfo(e, t, r), "parcats" !== t.type && o.getComponentMethod("fx", "supplyDefaults")(e, t, c, r)), f && f.selectPoints && d("selectedpoints"), v.supplyTransformDefaults(e, t, r)), t;
            }, v.hasMakesDataTransform = A, v.supplyTransformDefaults = function (e, t, n) {
              if (t._length || A(e)) {
                var r = n._globalTransforms || [],
                  i = n._transformModules || [];
                if (Array.isArray(e.transforms) || 0 !== r.length) for (var o = e.transforms || [], a = r.concat(o), s = t.transforms = [], u = 0; u < a.length; u++) {
                  var c,
                    d = a[u],
                    h = d.type,
                    f = y[h],
                    p = !(d._module && d._module === f),
                    m = f && "function" == typeof f.transform;
                  f || l.warn("Unrecognized transform type " + h + "."), f && f.supplyDefaults && (p || m) ? ((c = f.supplyDefaults(d, t, n, e)).type = h, c._module = f, l.pushUnique(i, f)) : c = l.extendFlat({}, d), s.push(c);
                }
              }
            }, v.supplyLayoutGlobalDefaults = function (e, t, n) {
              function r(n, r) {
                return l.coerce(e, t, v.layoutAttributes, n, r);
              }
              var i = e.template;
              l.isPlainObject(i) && (t.template = i, t._template = i.layout, t._dataTemplate = i.data);
              var a = l.coerceFont(r, "font");
              r("title.text", t._dfltTitle.plot), l.coerceFont(r, "title.font", {
                family: a.family,
                size: Math.round(1.4 * a.size),
                color: a.color
              }), r("title.xref"), r("title.yref"), r("title.x"), r("title.y"), r("title.xanchor"), r("title.yanchor"), r("title.pad.t"), r("title.pad.r"), r("title.pad.b"), r("title.pad.l"), r("uniformtext.mode") && r("uniformtext.minsize"), r("autosize", !(e.width && e.height)), r("width"), r("height"), r("margin.l"), r("margin.r"), r("margin.t"), r("margin.b"), r("margin.pad"), r("margin.autoexpand"), e.width && e.height && v.sanitizeMargins(t), o.getComponentMethod("grid", "sizeDefaults")(e, t), r("paper_bgcolor"), r("separators", n.decimal + n.thousands), r("hidesources"), r("colorway"), r("datarevision");
              var s = r("uirevision");
              r("editrevision", s), r("selectionrevision", s), r("modebar.orientation"), r("modebar.bgcolor", u.addOpacity(t.paper_bgcolor, .5));
              var c = u.contrast(u.rgb(t.modebar.bgcolor));
              r("modebar.color", u.addOpacity(c, .3)), r("modebar.activecolor", u.addOpacity(c, .7)), r("modebar.uirevision", s), r("meta"), l.isPlainObject(e.transition) && (r("transition.duration"), r("transition.easing"), r("transition.ordering")), o.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar"), o.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(e, t, r);
            }, v.plotAutoSize = function (e, t, n) {
              var r,
                o,
                a = e._context || {},
                s = a.frameMargins,
                u = l.isPlotDiv(e);
              if (u && e.emit("plotly_autosize"), a.fillFrame) r = window.innerWidth, o = window.innerHeight, document.body.style.overflow = "hidden";else {
                var c = u ? window.getComputedStyle(e) : {};
                if (r = parseFloat(c.width) || parseFloat(c.maxWidth) || n.width, o = parseFloat(c.height) || parseFloat(c.maxHeight) || n.height, i(s) && s > 0) {
                  var d = 1 - 2 * s;
                  r = Math.round(d * r), o = Math.round(d * o);
                }
              }
              var h = v.layoutAttributes.width.min,
                f = v.layoutAttributes.height.min;
              r < h && (r = h), o < f && (o = f);
              var p = !t.width && Math.abs(n.width - r) > 1,
                m = !t.height && Math.abs(n.height - o) > 1;
              (m || p) && (p && (n.width = r), m && (n.height = o)), e._initialAutoSize || (e._initialAutoSize = {
                width: r,
                height: o
              }), v.sanitizeMargins(n);
            }, v.supplyLayoutModuleDefaults = function (e, t, n, r) {
              var i,
                a,
                s,
                u = o.componentsRegistry,
                c = t._basePlotModules,
                d = o.subplotsRegistry.cartesian;
              for (i in u) (s = u[i]).includeBasePlot && s.includeBasePlot(e, t);
              for (var h in c.length || c.push(d), t._has("cartesian") && (o.getComponentMethod("grid", "contentDefaults")(e, t), d.finalizeSubplots(e, t)), t._subplots) t._subplots[h].sort(l.subplotSort);
              for (a = 0; a < c.length; a++) (s = c[a]).supplyLayoutDefaults && s.supplyLayoutDefaults(e, t, n);
              var f = t._modules;
              for (a = 0; a < f.length; a++) (s = f[a]).supplyLayoutDefaults && s.supplyLayoutDefaults(e, t, n);
              var p = t._transformModules;
              for (a = 0; a < p.length; a++) (s = p[a]).supplyLayoutDefaults && s.supplyLayoutDefaults(e, t, n, r);
              for (i in u) (s = u[i]).supplyLayoutDefaults && s.supplyLayoutDefaults(e, t, n);
            }, v.purge = function (e) {
              var t = e._fullLayout || {};
              void 0 !== t._glcontainer && (t._glcontainer.selectAll(".gl-canvas").remove(), t._glcontainer.remove(), t._glcanvas = null), t._modeBar && t._modeBar.destroy(), e._transitionData && (e._transitionData._interruptCallbacks && (e._transitionData._interruptCallbacks.length = 0), e._transitionData._animationRaf && window.cancelAnimationFrame(e._transitionData._animationRaf)), l.clearThrottle(), l.clearResponsive(e), delete e.data, delete e.layout, delete e._fullData, delete e._fullLayout, delete e.calcdata, delete e.framework, delete e.empty, delete e.fid, delete e.undoqueue, delete e.undonum, delete e.autoplay, delete e.changed, delete e._promises, delete e._redrawTimer, delete e._hmlumcount, delete e._hmpixcount, delete e._transitionData, delete e._transitioning, delete e._initialAutoSize, delete e._transitioningWithDuration, delete e._dragging, delete e._dragged, delete e._dragdata, delete e._hoverdata, delete e._snapshotInProgress, delete e._editing, delete e._mouseDownTime, delete e._legendMouseDownTime, e.removeAllListeners && e.removeAllListeners();
            }, v.style = function (e) {
              var t,
                n = e._fullLayout._visibleModules,
                r = [];
              for (t = 0; t < n.length; t++) {
                var i = n[t];
                i.style && l.pushUnique(r, i.style);
              }
              for (t = 0; t < r.length; t++) r[t](e);
            }, v.sanitizeMargins = function (e) {
              if (e && e.margin) {
                var t,
                  n = e.width,
                  r = e.height,
                  i = e.margin,
                  o = n - (i.l + i.r),
                  a = r - (i.t + i.b);
                o < 0 && (t = (n - 1) / (i.l + i.r), i.l = Math.floor(t * i.l), i.r = Math.floor(t * i.r)), a < 0 && (t = (r - 1) / (i.t + i.b), i.t = Math.floor(t * i.t), i.b = Math.floor(t * i.b));
              }
            }, v.clearAutoMarginIds = function (e) {
              e._fullLayout._pushmarginIds = {};
            }, v.allowAutoMargin = function (e, t) {
              e._fullLayout._pushmarginIds[t] = 1;
            }, v.autoMargin = function (e, t, n) {
              var r = e._fullLayout,
                i = r._pushmargin,
                o = r._pushmarginIds;
              if (!1 !== r.margin.autoexpand) {
                if (n) {
                  var a = n.pad;
                  if (void 0 === a) {
                    var s = r.margin;
                    a = Math.min(12, s.l, s.r, s.t, s.b);
                  }
                  n.l + n.r > .5 * r.width && (l.log("Margin push", t, "is too big in x, dropping"), n.l = n.r = 0), n.b + n.t > .5 * r.height && (l.log("Margin push", t, "is too big in y, dropping"), n.b = n.t = 0);
                  var u = void 0 !== n.xl ? n.xl : n.x,
                    c = void 0 !== n.xr ? n.xr : n.x,
                    d = void 0 !== n.yt ? n.yt : n.y,
                    h = void 0 !== n.yb ? n.yb : n.y;
                  i[t] = {
                    l: {
                      val: u,
                      size: n.l + a
                    },
                    r: {
                      val: c,
                      size: n.r + a
                    },
                    b: {
                      val: h,
                      size: n.b + a
                    },
                    t: {
                      val: d,
                      size: n.t + a
                    }
                  }, o[t] = 1;
                } else delete i[t], delete o[t];
                if (!r._replotting) return v.doAutoMargin(e);
              }
            }, v.doAutoMargin = function (e) {
              var t = e._fullLayout;
              t._size || (t._size = {}), T(t);
              var n = t._size,
                r = t.margin,
                a = l.extendFlat({}, n),
                s = r.l,
                u = r.r,
                c = r.t,
                d = r.b,
                h = t.width,
                f = t.height,
                p = t._pushmargin,
                m = t._pushmarginIds;
              if (!1 !== t.margin.autoexpand) {
                for (var g in p) m[g] || delete p[g];
                for (var y in p.base = {
                  l: {
                    val: 0,
                    size: s
                  },
                  r: {
                    val: 1,
                    size: u
                  },
                  t: {
                    val: 1,
                    size: c
                  },
                  b: {
                    val: 0,
                    size: d
                  }
                }, p) {
                  var b = p[y].l || {},
                    _ = p[y].b || {},
                    x = b.val,
                    w = b.size,
                    S = _.val,
                    A = _.size;
                  for (var E in p) {
                    if (i(w) && p[E].r) {
                      var M = p[E].r.val,
                        C = p[E].r.size;
                      if (M > x) {
                        var k = (w * M + (C - h) * x) / (M - x),
                          P = (C * (1 - x) + (w - h) * (1 - M)) / (M - x);
                        k >= 0 && P >= 0 && h - (k + P) > 0 && k + P > s + u && (s = k, u = P);
                      }
                    }
                    if (i(A) && p[E].t) {
                      var O = p[E].t.val,
                        R = p[E].t.size;
                      if (O > S) {
                        var I = (A * O + (R - f) * S) / (O - S),
                          j = (R * (1 - S) + (A - f) * (1 - O)) / (O - S);
                        I >= 0 && j >= 0 && f - (j + I) > 0 && I + j > d + c && (d = I, c = j);
                      }
                    }
                  }
                }
              }
              if (n.l = Math.round(s), n.r = Math.round(u), n.t = Math.round(c), n.b = Math.round(d), n.p = Math.round(r.pad), n.w = Math.round(h) - n.l - n.r, n.h = Math.round(f) - n.t - n.b, !t._replotting && v.didMarginChange(a, n)) {
                "_redrawFromAutoMarginCount" in t ? t._redrawFromAutoMarginCount++ : t._redrawFromAutoMarginCount = 1;
                var N = 3 * (1 + Object.keys(m).length);
                if (t._redrawFromAutoMarginCount < N) return o.call("plot", e);
                l.warn("Too many auto-margin redraws.");
              }
            };
            var M = ["l", "r", "t", "b", "p", "w", "h"];
            function C(e, t, n) {
              var r = !1,
                i = [v.previousPromises, function () {
                  if (e._transitionData) return e._transitioning = !1, function (e) {
                    var t = Promise.resolve();
                    if (!e) return t;
                    for (; e.length;) t = t.then(e.shift());
                    return t;
                  }(e._transitionData._interruptCallbacks);
                }, n.prepareFn, v.rehover, function () {
                  return e.emit("plotly_transitioning", []), new Promise(function (i) {
                    e._transitioning = !0, t.duration > 0 && (e._transitioningWithDuration = !0), e._transitionData._interruptCallbacks.push(function () {
                      r = !0;
                    }), n.redraw && e._transitionData._interruptCallbacks.push(function () {
                      return o.call("redraw", e);
                    }), e._transitionData._interruptCallbacks.push(function () {
                      e.emit("plotly_transitioninterrupted", []);
                    });
                    var a = 0,
                      s = 0;
                    function l() {
                      return a++, function () {
                        var t;
                        s++, r || s !== a || (t = i, e._transitionData && (function (e) {
                          if (e) for (; e.length;) e.shift();
                        }(e._transitionData._interruptCallbacks), Promise.resolve().then(function () {
                          if (n.redraw) return o.call("redraw", e);
                        }).then(function () {
                          e._transitioning = !1, e._transitioningWithDuration = !1, e.emit("plotly_transitioned", []);
                        }).then(t)));
                      };
                    }
                    n.runFn(l), setTimeout(l());
                  });
                }],
                a = l.syncOrAsync(i, e);
              return a && a.then || (a = Promise.resolve()), a.then(function () {
                return e;
              });
            }
            v.didMarginChange = function (e, t) {
              for (var n = 0; n < M.length; n++) {
                var r = M[n],
                  o = e[r],
                  a = t[r];
                if (!i(o) || Math.abs(a - o) > 1) return !0;
              }
              return !1;
            }, v.graphJson = function (e, t, n, r, i) {
              (i && t && !e._fullData || i && !t && !e._fullLayout) && v.supplyDefaults(e);
              var o = i ? e._fullData : e.data,
                a = i ? e._fullLayout : e.layout,
                s = (e._transitionData || {})._frames;
              function u(e) {
                if ("function" == typeof e) return null;
                if (l.isPlainObject(e)) {
                  var t,
                    r,
                    i = {};
                  for (t in e) if ("function" != typeof e[t] && -1 === ["_", "["].indexOf(t.charAt(0))) {
                    if ("keepdata" === n) {
                      if ("src" === t.substr(t.length - 3)) continue;
                    } else if ("keepstream" === n) {
                      if ("string" == typeof (r = e[t + "src"]) && r.indexOf(":") > 0 && !l.isPlainObject(e.stream)) continue;
                    } else if ("keepall" !== n && "string" == typeof (r = e[t + "src"]) && r.indexOf(":") > 0) continue;
                    i[t] = u(e[t]);
                  }
                  return i;
                }
                return Array.isArray(e) ? e.map(u) : l.isTypedArray(e) ? l.simpleMap(e, l.identity) : l.isJSDate(e) ? l.ms2DateTimeLocal(+e) : e;
              }
              var c = {
                data: (o || []).map(function (e) {
                  var n = u(e);
                  return t && delete n.fit, n;
                })
              };
              return t || (c.layout = u(a)), e.framework && e.framework.isPolar && (c = e.framework.getConfig()), s && (c.frames = u(s)), "object" === r ? c : JSON.stringify(c);
            }, v.modifyFrames = function (e, t) {
              var n,
                r,
                i,
                o = e._transitionData._frames,
                a = e._transitionData._frameHash;
              for (n = 0; n < t.length; n++) switch ((r = t[n]).type) {
                case "replace":
                  i = r.value;
                  var s = (o[r.index] || {}).name,
                    l = i.name;
                  o[r.index] = a[l] = i, l !== s && (delete a[s], a[l] = i);
                  break;
                case "insert":
                  a[(i = r.value).name] = i, o.splice(r.index, 0, i);
                  break;
                case "delete":
                  delete a[(i = o[r.index]).name], o.splice(r.index, 1);
              }
              return Promise.resolve();
            }, v.computeFrame = function (e, t) {
              var n,
                r,
                i,
                o,
                a = e._transitionData._frameHash;
              if (!t) throw new Error("computeFrame must be given a string frame name");
              var s = a[t.toString()];
              if (!s) return !1;
              for (var l = [s], u = [s.name]; s.baseframe && (s = a[s.baseframe.toString()]) && -1 === u.indexOf(s.name);) l.push(s), u.push(s.name);
              for (var c = {}; s = l.pop();) if (s.layout && (c.layout = v.extendLayout(c.layout, s.layout)), s.data) {
                if (c.data || (c.data = []), !(r = s.traces)) for (r = [], n = 0; n < s.data.length; n++) r[n] = n;
                for (c.traces || (c.traces = []), n = 0; n < s.data.length; n++) null != (i = r[n]) && (-1 === (o = c.traces.indexOf(i)) && (o = c.data.length, c.traces[o] = i), c.data[o] = v.extendTrace(c.data[o], s.data[n]));
              }
              return c;
            }, v.recomputeFrameHash = function (e) {
              for (var t = e._transitionData._frameHash = {}, n = e._transitionData._frames, r = 0; r < n.length; r++) {
                var i = n[r];
                i && i.name && (t[i.name] = i);
              }
            }, v.extendObjectWithContainers = function (e, t, n) {
              var r,
                i,
                o,
                a,
                s,
                u,
                c,
                d = l.extendDeepNoArrays({}, t || {}),
                h = l.expandObjectPaths(d),
                f = {};
              if (n && n.length) for (o = 0; o < n.length; o++) void 0 === (i = (r = l.nestedProperty(h, n[o])).get()) ? l.nestedProperty(f, n[o]).set(null) : (r.set(null), l.nestedProperty(f, n[o]).set(i));
              if (e = l.extendDeepNoArrays(e || {}, h), n && n.length) for (o = 0; o < n.length; o++) if (u = l.nestedProperty(f, n[o]).get()) {
                for (c = (s = l.nestedProperty(e, n[o])).get(), Array.isArray(c) || (c = [], s.set(c)), a = 0; a < u.length; a++) {
                  var p = u[a];
                  c[a] = null === p ? null : v.extendObjectWithContainers(c[a], p);
                }
                s.set(c);
              }
              return e;
            }, v.dataArrayContainers = ["transforms", "dimensions"], v.layoutArrayContainers = o.layoutArrayContainers, v.extendTrace = function (e, t) {
              return v.extendObjectWithContainers(e, t, v.dataArrayContainers);
            }, v.extendLayout = function (e, t) {
              return v.extendObjectWithContainers(e, t, v.layoutArrayContainers);
            }, v.transition = function (e, t, n, r, i, o) {
              var a = {
                  redraw: i.redraw
                },
                s = {},
                u = [];
              return a.prepareFn = function () {
                for (var i = Array.isArray(t) ? t.length : 0, o = r.slice(0, i), a = 0; a < o.length; a++) {
                  var c = o[a],
                    d = e._fullData[c]._module;
                  if (d) {
                    if (d.animatable) {
                      var h = d.basePlotModule.name;
                      s[h] || (s[h] = []), s[h].push(c);
                    }
                    e.data[o[a]] = v.extendTrace(e.data[o[a]], t[a]);
                  }
                }
                var f = l.expandObjectPaths(l.extendDeepNoArrays({}, n)),
                  p = /^[xy]axis[0-9]*$/;
                for (var m in f) p.test(m) && delete f[m].range;
                v.extendLayout(e.layout, f), delete e.calcdata, v.supplyDefaults(e), v.doCalcdata(e);
                var g = l.expandObjectPaths(n);
                if (g) {
                  var y = e._fullLayout._plots;
                  for (var b in y) {
                    var _ = y[b],
                      x = _.xaxis,
                      w = _.yaxis,
                      S = x.range.slice(),
                      A = w.range.slice(),
                      E = null,
                      T = null,
                      M = null,
                      C = null;
                    Array.isArray(g[x._name + ".range"]) ? E = g[x._name + ".range"].slice() : Array.isArray((g[x._name] || {}).range) && (E = g[x._name].range.slice()), Array.isArray(g[w._name + ".range"]) ? T = g[w._name + ".range"].slice() : Array.isArray((g[w._name] || {}).range) && (T = g[w._name].range.slice()), S && E && (x.r2l(S[0]) !== x.r2l(E[0]) || x.r2l(S[1]) !== x.r2l(E[1])) && (M = {
                      xr0: S,
                      xr1: E
                    }), A && T && (w.r2l(A[0]) !== w.r2l(T[0]) || w.r2l(A[1]) !== w.r2l(T[1])) && (C = {
                      yr0: A,
                      yr1: T
                    }), (M || C) && u.push(l.extendFlat({
                      plotinfo: _
                    }, M, C));
                  }
                }
                return Promise.resolve();
              }, a.runFn = function (t) {
                var r,
                  i,
                  a = e._fullLayout._basePlotModules,
                  c = u.length;
                if (n) for (i = 0; i < a.length; i++) a[i].transitionAxes && a[i].transitionAxes(e, u, o, t);
                for (var d in c ? ((r = l.extendFlat({}, o)).duration = 0, delete s.cartesian) : r = o, s) {
                  var h = s[d];
                  e._fullData[h[0]]._module.basePlotModule.plot(e, h, r, t);
                }
              }, C(e, o, a);
            }, v.transitionFromReact = function (e, t, n, r) {
              var i = e._fullLayout,
                o = i.transition,
                a = {},
                s = [];
              return a.prepareFn = function () {
                var e = i._plots;
                for (var o in a.redraw = !1, "some" === t.anim && (a.redraw = !0), "some" === n.anim && (a.redraw = !0), e) {
                  var u = e[o],
                    c = u.xaxis,
                    d = u.yaxis,
                    h = r[c._name].range.slice(),
                    f = r[d._name].range.slice(),
                    p = c.range.slice(),
                    m = d.range.slice();
                  c.setScale(), d.setScale();
                  var g = null,
                    v = null;
                  c.r2l(h[0]) === c.r2l(p[0]) && c.r2l(h[1]) === c.r2l(p[1]) || (g = {
                    xr0: h,
                    xr1: p
                  }), d.r2l(f[0]) === d.r2l(m[0]) && d.r2l(f[1]) === d.r2l(m[1]) || (v = {
                    yr0: f,
                    yr1: m
                  }), (g || v) && s.push(l.extendFlat({
                    plotinfo: u
                  }, g, v));
                }
                return Promise.resolve();
              }, a.runFn = function (n) {
                for (var r, i, a, u = e._fullData, c = e._fullLayout._basePlotModules, d = [], h = 0; h < u.length; h++) d.push(h);
                function f() {
                  for (var t = 0; t < c.length; t++) c[t].transitionAxes && c[t].transitionAxes(e, s, r, n);
                }
                function p() {
                  for (var t = 0; t < c.length; t++) c[t].plot(e, a, i, n);
                }
                s.length && t.anim ? "traces first" === o.ordering ? (r = l.extendFlat({}, o, {
                  duration: 0
                }), a = d, i = o, setTimeout(f, o.duration), p()) : (r = o, a = null, i = l.extendFlat({}, o, {
                  duration: 0
                }), setTimeout(p, r.duration), f()) : s.length ? (r = o, f()) : t.anim && (a = d, i = o, p());
              }, C(e, o, a);
            }, v.doCalcdata = function (e, t) {
              var n,
                r,
                i,
                s,
                u = d.list(e),
                h = e._fullData,
                f = e._fullLayout,
                p = new Array(h.length),
                m = (e.calcdata || []).slice();
              for (e.calcdata = p, f._numBoxes = 0, f._numViolins = 0, f._violinScaleGroupStats = {}, e._hmpixcount = 0, e._hmlumcount = 0, f._piecolormap = {}, f._sunburstcolormap = {}, f._treemapcolormap = {}, f._funnelareacolormap = {}, i = 0; i < h.length; i++) Array.isArray(t) && -1 === t.indexOf(i) && (p[i] = m[i]);
              for (i = 0; i < h.length; i++) (n = h[i])._arrayAttrs = a.findArrayAttributes(n), n._extremes = {};
              var g = f._subplots.polar || [];
              for (i = 0; i < g.length; i++) u.push(f[g[i]].radialaxis, f[g[i]].angularaxis);
              for (var v in f._colorAxes) {
                var b = f[v];
                !1 !== b.cauto && (delete b.cmin, delete b.cmax);
              }
              var _ = !1;
              function x(t) {
                if (n = h[t], r = n._module, !0 === n.visible && n.transforms) {
                  if (r && r.calc) {
                    var i = r.calc(e, n);
                    i[0] && i[0].t && i[0].t._scene && delete i[0].t._scene.dirty;
                  }
                  for (s = 0; s < n.transforms.length; s++) {
                    var o = n.transforms[s];
                    (r = y[o.type]) && r.calcTransform && (n._hasCalcTransform = !0, _ = !0, r.calcTransform(e, n, o));
                  }
                }
              }
              function w(t, i) {
                if (n = h[t], !!(r = n._module).isContainer === i) {
                  var o = [];
                  if (!0 === n.visible && 0 !== n._length) {
                    delete n._indexToPoints;
                    var a = n.transforms || [];
                    for (s = a.length - 1; s >= 0; s--) if (a[s].enabled) {
                      n._indexToPoints = a[s]._indexToPoints;
                      break;
                    }
                    r && r.calc && (o = r.calc(e, n));
                  }
                  Array.isArray(o) && o[0] || (o = [{
                    x: c,
                    y: c
                  }]), o[0].t || (o[0].t = {}), o[0].trace = n, p[t] = o;
                }
              }
              for (P(u, h, f), i = 0; i < h.length; i++) w(i, !0);
              for (i = 0; i < h.length; i++) x(i);
              for (_ && P(u, h, f), i = 0; i < h.length; i++) w(i, !0);
              for (i = 0; i < h.length; i++) w(i, !1);
              O(e);
              var S = function (e, t) {
                var n,
                  r,
                  i,
                  a,
                  s,
                  u = [];
                function c(e, n, r) {
                  var i = n._id.charAt(0);
                  if ("histogram2dcontour" === e) {
                    var o = n._counterAxes[0],
                      a = d.getFromId(t, o),
                      s = "x" === i || "x" === o && "category" === a.type,
                      l = "y" === i || "y" === o && "category" === a.type;
                    return function (e, t) {
                      return 0 === e || 0 === t || s && e === r[t].length - 1 || l && t === r.length - 1 ? -1 : ("y" === i ? t : e) - 1;
                    };
                  }
                  return function (e, t) {
                    return "y" === i ? t : e;
                  };
                }
                var h = {
                  min: function min(e) {
                    return l.aggNums(Math.min, null, e);
                  },
                  max: function max(e) {
                    return l.aggNums(Math.max, null, e);
                  },
                  sum: function sum(e) {
                    return l.aggNums(function (e, t) {
                      return e + t;
                    }, null, e);
                  },
                  total: function total(e) {
                    return l.aggNums(function (e, t) {
                      return e + t;
                    }, null, e);
                  },
                  mean: function mean(e) {
                    return l.mean(e);
                  },
                  median: function median(e) {
                    return l.median(e);
                  }
                };
                for (n = 0; n < e.length; n++) {
                  var f = e[n];
                  if ("category" === f.type) {
                    var p = f.categoryorder.match(k);
                    if (p) {
                      var m = p[1],
                        g = p[2],
                        v = [];
                      for (r = 0; r < f._categories.length; r++) v.push([f._categories[r], []]);
                      for (r = 0; r < f._traceIndices.length; r++) {
                        var y = f._traceIndices[r],
                          b = t._fullData[y],
                          _ = f._id.charAt(0);
                        if (!0 === b.visible) {
                          var x = b.type;
                          o.traceIs(b, "histogram") && (delete b._xautoBinFinished, delete b._yautoBinFinished);
                          var w = t.calcdata[y];
                          for (i = 0; i < w.length; i++) {
                            var S,
                              A,
                              E,
                              T = w[i];
                            if ("splom" === x) {
                              var M = b._axesDim[f._id];
                              if ("y" === _) {
                                var C = b._diag[M][0];
                                C && (f = t._fullLayout[d.id2name(C)]);
                              }
                              var P = T.trace.dimensions[M].values;
                              for (a = 0; a < P.length; a++) for (S = P[a], A = f._categoriesMap[S], s = 0; s < T.trace.dimensions.length; s++) if (s !== M) {
                                var O = T.trace.dimensions[s];
                                v[A][1].push(O.values[a]);
                              }
                            } else if ("scattergl" === x) {
                              for (a = 0; a < T.t.x.length; a++) "x" === _ && (A = S = T.t.x[a], E = T.t.y[a]), "y" === _ && (A = S = T.t.y[a], E = T.t.x[a]), v[A][1].push(E);
                              T.t && T.t._scene && delete T.t._scene.dirty;
                            } else if (T.hasOwnProperty("z")) {
                              E = T.z;
                              var R = c(b.type, f, E);
                              for (a = 0; a < E.length; a++) for (s = 0; s < E[a].length; s++) (A = R(s, a)) + 1 && v[A][1].push(E[a][s]);
                            } else for ("x" === _ ? (S = T.p + 1 ? T.p : T.x, E = T.s || T.v || T.y) : "y" === _ && (S = T.p + 1 ? T.p : T.y, E = T.s || T.v || T.x), Array.isArray(E) || (E = [E]), a = 0; a < E.length; a++) v[S][1].push(E[a]);
                          }
                        }
                      }
                      f._categoriesValue = v;
                      var I = [];
                      for (r = 0; r < v.length; r++) I.push([v[r][0], h[m](v[r][1])]);
                      I.sort(function (e, t) {
                        return e[1] - t[1];
                      }), f._categoriesAggregatedValue = I, f._initialCategories = I.map(function (e) {
                        return e[0];
                      }), "descending" === g && f._initialCategories.reverse(), u = u.concat(f.sortByInitialCategories());
                    }
                  }
                }
                return u;
              }(u, e);
              if (S.length) {
                for (f._numBoxes = 0, f._numViolins = 0, i = 0; i < S.length; i++) w(S[i], !0);
                for (i = 0; i < S.length; i++) w(S[i], !1);
                O(e);
              }
              o.getComponentMethod("fx", "calc")(e), o.getComponentMethod("errorbars", "calc")(e);
            };
            var k = /(total|sum|min|max|mean|median) (ascending|descending)/;
            function P(e, t, n) {
              var r,
                i,
                o,
                a = {};
              for (r = 0; r < e.length; r++) o = (i = e[r])._id, i.clearCalc(), "multicategory" === i.type && i.setupMultiCategory(t), a[i._id] = 1;
              var s = n._axisMatchGroups || [];
              for (r = 0; r < s.length; r++) for (o in s[r]) a[o] || (i = n[d.id2name(o)]).clearCalc();
            }
            function O(e) {
              var t,
                n,
                r,
                i = e._fullLayout,
                o = i._visibleModules,
                a = {};
              for (n = 0; n < o.length; n++) {
                var s = o[n],
                  u = s.crossTraceCalc;
                if (u) {
                  var c = s.basePlotModule.name;
                  a[c] ? l.pushUnique(a[c], u) : a[c] = [u];
                }
              }
              for (r in a) {
                var d = a[r],
                  h = i._subplots[r];
                if (Array.isArray(h)) for (t = 0; t < h.length; t++) {
                  var f = h[t],
                    p = "cartesian" === r ? i._plots[f] : i[f];
                  for (n = 0; n < d.length; n++) d[n](e, p, f);
                } else for (n = 0; n < d.length; n++) d[n](e);
              }
            }
            v.rehover = function (e) {
              e._fullLayout._rehover && e._fullLayout._rehover();
            }, v.redrag = function (e) {
              e._fullLayout._redrag && e._fullLayout._redrag();
            }, v.generalUpdatePerTraceModule = function (e, t, n, r) {
              var i,
                o = t.traceHash,
                a = {};
              for (i = 0; i < n.length; i++) {
                var s = n[i],
                  u = s[0].trace;
                u.visible && (a[u.type] = a[u.type] || [], a[u.type].push(s));
              }
              for (var c in o) if (!a[c]) {
                var d = o[c][0];
                d[0].trace.visible = !1, a[c] = [d];
              }
              for (var h in a) {
                var f = a[h];
                f[0][0].trace._module.plot(e, t, l.filterVisible(f), r);
              }
              t.traceHash = a;
            }, v.plotBasePlot = function (e, t, n, r, i) {
              var a = o.getModule(e),
                s = p(t.calcdata, a)[0];
              a.plot(t, s, r, i);
            }, v.cleanBasePlot = function (e, t, n, r, i) {
              var o = i._has && i._has(e),
                a = n._has && n._has(e);
              o && !a && i["_" + e + "layer"].selectAll("g.trace").remove();
            };
          }, {
            "../components/color": 375,
            "../constants/numerical": 474,
            "../lib": 495,
            "../plot_api/plot_schema": 530,
            "../plot_api/plot_template": 531,
            "../plots/get_data": 569,
            "../registry": 593,
            "./animation_attributes": 536,
            "./attributes": 538,
            "./cartesian/axis_ids": 544,
            "./command": 565,
            "./font_attributes": 567,
            "./frame_attributes": 568,
            "./layout_attributes": 582,
            d3: 82,
            "fast-isnumeric": 91
          }],
          585: [function (e, t, n) {
            "use strict";

            var r = e("../../../traces/scatter/attributes"),
              i = r.marker,
              o = e("../../../lib/extend").extendFlat;
            ["Area traces are deprecated!", "Please switch to the *barpolar* trace type."].join(" "), t.exports = {
              r: o({}, r.r, {}),
              t: o({}, r.t, {}),
              marker: {
                color: o({}, i.color, {}),
                size: o({}, i.size, {}),
                symbol: o({}, i.symbol, {}),
                opacity: o({}, i.opacity, {}),
                editType: "calc"
              }
            };
          }, {
            "../../../lib/extend": 489,
            "../../../traces/scatter/attributes": 622
          }],
          586: [function (e, t, n) {
            "use strict";

            var r = e("../../cartesian/layout_attributes"),
              i = e("../../../lib/extend").extendFlat,
              o = e("../../../plot_api/edit_types").overrideAll,
              a = ["Legacy polar charts are deprecated!", "Please switch to *polar* subplots."].join(" "),
              s = i({}, r.domain, {});
            function l(e, t) {
              return i({}, t, {
                showline: {
                  valType: "boolean"
                },
                showticklabels: {
                  valType: "boolean"
                },
                tickorientation: {
                  valType: "enumerated",
                  values: ["horizontal", "vertical"]
                },
                ticklen: {
                  valType: "number",
                  min: 0
                },
                tickcolor: {
                  valType: "color"
                },
                ticksuffix: {
                  valType: "string"
                },
                endpadding: {
                  valType: "number",
                  description: a
                },
                visible: {
                  valType: "boolean"
                }
              });
            }
            t.exports = o({
              radialaxis: l(0, {
                range: {
                  valType: "info_array",
                  items: [{
                    valType: "number"
                  }, {
                    valType: "number"
                  }]
                },
                domain: s,
                orientation: {
                  valType: "number"
                }
              }),
              angularaxis: l(0, {
                range: {
                  valType: "info_array",
                  items: [{
                    valType: "number",
                    dflt: 0
                  }, {
                    valType: "number",
                    dflt: 360
                  }]
                },
                domain: s
              }),
              layout: {
                direction: {
                  valType: "enumerated",
                  values: ["clockwise", "counterclockwise"]
                },
                orientation: {
                  valType: "angle"
                }
              }
            }, "plot", "nested");
          }, {
            "../../../lib/extend": 489,
            "../../../plot_api/edit_types": 524,
            "../../cartesian/layout_attributes": 553
          }],
          587: [function (e, t, n) {
            "use strict";

            (t.exports = e("./micropolar")).manager = e("./micropolar_manager");
          }, {
            "./micropolar": 588,
            "./micropolar_manager": 589
          }],
          588: [function (e, t, n) {
            var r = e("d3"),
              i = e("../../../lib").extendDeepAll,
              o = e("../../../constants/alignment").MID_SHIFT,
              a = t.exports = {
                version: "0.2.2"
              };
            a.Axis = function () {
              var e,
                t,
                n,
                s,
                l = {
                  data: [],
                  layout: {}
                },
                u = {},
                c = {},
                d = r.dispatch("hover"),
                h = {
                  render: function render(u) {
                    return function (u) {
                      t = u || t;
                      var d = l.data,
                        h = l.layout;
                      ("string" == typeof t || t.nodeName) && (t = r.select(t)), t.datum(d).each(function (t, l) {
                        var u = t.slice();
                        c = {
                          data: a.util.cloneJson(u),
                          layout: a.util.cloneJson(h)
                        };
                        var d = 0;
                        u.forEach(function (e, t) {
                          e.color || (e.color = h.defaultColorRange[d], d = (d + 1) % h.defaultColorRange.length), e.strokeColor || (e.strokeColor = "LinePlot" === e.geometry ? e.color : r.rgb(e.color).darker().toString()), c.data[t].color = e.color, c.data[t].strokeColor = e.strokeColor, c.data[t].strokeDash = e.strokeDash, c.data[t].strokeSize = e.strokeSize;
                        });
                        var f = u.filter(function (e, t) {
                            var n = e.visible;
                            return void 0 === n || !0 === n;
                          }),
                          p = !1,
                          m = f.map(function (e, t) {
                            return p = p || void 0 !== e.groupId, e;
                          });
                        if (p) {
                          var g = r.nest().key(function (e, t) {
                              return void 0 !== e.groupId ? e.groupId : "unstacked";
                            }).entries(m),
                            v = [],
                            y = g.map(function (e, t) {
                              if ("unstacked" === e.key) return e.values;
                              var n = e.values[0].r.map(function (e, t) {
                                return 0;
                              });
                              return e.values.forEach(function (e, t, r) {
                                e.yStack = [n], v.push(n), n = a.util.sumArrays(e.r, n);
                              }), e.values;
                            });
                          f = r.merge(y);
                        }
                        f.forEach(function (e, t) {
                          e.t = Array.isArray(e.t[0]) ? e.t : [e.t], e.r = Array.isArray(e.r[0]) ? e.r : [e.r];
                        });
                        var b = Math.min(h.width - h.margin.left - h.margin.right, h.height - h.margin.top - h.margin.bottom) / 2;
                        b = Math.max(10, b);
                        var _,
                          x = [h.margin.left + b, h.margin.top + b];
                        _ = p ? [0, r.max(a.util.sumArrays(a.util.arrayLast(f).r[0], a.util.arrayLast(v)))] : r.extent(a.util.flattenArray(f.map(function (e, t) {
                          return e.r;
                        }))), h.radialAxis.domain != a.DATAEXTENT && (_[0] = 0), n = r.scale.linear().domain(h.radialAxis.domain != a.DATAEXTENT && h.radialAxis.domain ? h.radialAxis.domain : _).range([0, b]), c.layout.radialAxis.domain = n.domain();
                        var w,
                          S = a.util.flattenArray(f.map(function (e, t) {
                            return e.t;
                          })),
                          A = "string" == typeof S[0];
                        A && (S = a.util.deduplicate(S), w = S.slice(), S = r.range(S.length), f = f.map(function (e, t) {
                          var n = e;
                          return e.t = [S], p && (n.yStack = e.yStack), n;
                        }));
                        var E = f.filter(function (e, t) {
                            return "LinePlot" === e.geometry || "DotPlot" === e.geometry;
                          }).length === f.length,
                          T = null === h.needsEndSpacing ? A || !E : h.needsEndSpacing,
                          M = h.angularAxis.domain && h.angularAxis.domain != a.DATAEXTENT && !A && h.angularAxis.domain[0] >= 0 ? h.angularAxis.domain : r.extent(S),
                          C = Math.abs(S[1] - S[0]);
                        E && !A && (C = 0);
                        var k = M.slice();
                        T && A && (k[1] += C);
                        var P = h.angularAxis.ticksCount || 4;
                        P > 8 && (P = P / (P / 8) + P % 8), h.angularAxis.ticksStep && (P = (k[1] - k[0]) / P);
                        var O = h.angularAxis.ticksStep || (k[1] - k[0]) / (P * (h.minorTicks + 1));
                        w && (O = Math.max(Math.round(O), 1)), k[2] || (k[2] = O);
                        var R = r.range.apply(this, k);
                        if (R = R.map(function (e, t) {
                          return parseFloat(e.toPrecision(12));
                        }), s = r.scale.linear().domain(k.slice(0, 2)).range("clockwise" === h.direction ? [0, 360] : [360, 0]), c.layout.angularAxis.domain = s.domain(), c.layout.angularAxis.endPadding = T ? C : 0, void 0 === (e = r.select(this).select("svg.chart-root")) || e.empty()) {
                          var I = new DOMParser().parseFromString("<svg xmlns='http://www.w3.org/2000/svg' class='chart-root'>' + '<g class='outer-group'>' + '<g class='chart-group'>' + '<circle class='background-circle'></circle>' + '<g class='geometry-group'></g>' + '<g class='radial axis-group'>' + '<circle class='outside-circle'></circle>' + '</g>' + '<g class='angular axis-group'></g>' + '<g class='guides-group'><line></line><circle r='0'></circle></g>' + '</g>' + '<g class='legend-group'></g>' + '<g class='tooltips-group'></g>' + '<g class='title-group'><text></text></g>' + '</g>' + '</svg>", "application/xml"),
                            j = this.appendChild(this.ownerDocument.importNode(I.documentElement, !0));
                          e = r.select(j);
                        }
                        e.select(".guides-group").style({
                          "pointer-events": "none"
                        }), e.select(".angular.axis-group").style({
                          "pointer-events": "none"
                        }), e.select(".radial.axis-group").style({
                          "pointer-events": "none"
                        });
                        var N,
                          L = e.select(".chart-group"),
                          D = {
                            fill: "none",
                            stroke: h.tickColor
                          },
                          B = {
                            "font-size": h.font.size,
                            "font-family": h.font.family,
                            fill: h.font.color,
                            "text-shadow": ["-1px 0px", "1px -1px", "-1px 1px", "1px 1px"].map(function (e, t) {
                              return " " + e + " 0 " + h.font.outlineColor;
                            }).join(",")
                          };
                        if (h.showLegend) {
                          N = e.select(".legend-group").attr({
                            transform: "translate(" + [b, h.margin.top] + ")"
                          }).style({
                            display: "block"
                          });
                          var F = f.map(function (e, t) {
                            var n = a.util.cloneJson(e);
                            return n.symbol = "DotPlot" === e.geometry ? e.dotType || "circle" : "LinePlot" != e.geometry ? "square" : "line", n.visibleInLegend = void 0 === e.visibleInLegend || e.visibleInLegend, n.color = "LinePlot" === e.geometry ? e.strokeColor : e.color, n;
                          });
                          a.Legend().config({
                            data: f.map(function (e, t) {
                              return e.name || "Element" + t;
                            }),
                            legendConfig: i({}, a.Legend.defaultConfig().legendConfig, {
                              container: N,
                              elements: F,
                              reverseOrder: h.legend.reverseOrder
                            })
                          })();
                          var z = N.node().getBBox();
                          b = Math.min(h.width - z.width - h.margin.left - h.margin.right, h.height - h.margin.top - h.margin.bottom) / 2, b = Math.max(10, b), x = [h.margin.left + b, h.margin.top + b], n.range([0, b]), c.layout.radialAxis.domain = n.domain(), N.attr("transform", "translate(" + [x[0] + b, x[1] - b] + ")");
                        } else N = e.select(".legend-group").style({
                          display: "none"
                        });
                        e.attr({
                          width: h.width,
                          height: h.height
                        }).style({
                          opacity: h.opacity
                        }), L.attr("transform", "translate(" + x + ")").style({
                          cursor: "crosshair"
                        });
                        var U = [(h.width - (h.margin.left + h.margin.right + 2 * b + (z ? z.width : 0))) / 2, (h.height - (h.margin.top + h.margin.bottom + 2 * b)) / 2];
                        if (U[0] = Math.max(0, U[0]), U[1] = Math.max(0, U[1]), e.select(".outer-group").attr("transform", "translate(" + U + ")"), h.title && h.title.text) {
                          var G = e.select("g.title-group text").style(B).text(h.title.text),
                            V = G.node().getBBox();
                          G.attr({
                            x: x[0] - V.width / 2,
                            y: x[1] - b - 20
                          });
                        }
                        var H = e.select(".radial.axis-group");
                        if (h.radialAxis.gridLinesVisible) {
                          var q = H.selectAll("circle.grid-circle").data(n.ticks(5));
                          q.enter().append("circle").attr({
                            class: "grid-circle"
                          }).style(D), q.attr("r", n), q.exit().remove();
                        }
                        H.select("circle.outside-circle").attr({
                          r: b
                        }).style(D);
                        var W = e.select("circle.background-circle").attr({
                          r: b
                        }).style({
                          fill: h.backgroundColor,
                          stroke: h.stroke
                        });
                        function $(e, t) {
                          return s(e) % 360 + h.orientation;
                        }
                        if (h.radialAxis.visible) {
                          var X = r.svg.axis().scale(n).ticks(5).tickSize(5);
                          H.call(X).attr({
                            transform: "rotate(" + h.radialAxis.orientation + ")"
                          }), H.selectAll(".domain").style(D), H.selectAll("g>text").text(function (e, t) {
                            return this.textContent + h.radialAxis.ticksSuffix;
                          }).style(B).style({
                            "text-anchor": "start"
                          }).attr({
                            x: 0,
                            y: 0,
                            dx: 0,
                            dy: 0,
                            transform: function transform(e, t) {
                              return "horizontal" === h.radialAxis.tickOrientation ? "rotate(" + -h.radialAxis.orientation + ") translate(" + [0, B["font-size"]] + ")" : "translate(" + [0, B["font-size"]] + ")";
                            }
                          }), H.selectAll("g>line").style({
                            stroke: "black"
                          });
                        }
                        var Y = e.select(".angular.axis-group").selectAll("g.angular-tick").data(R),
                          K = Y.enter().append("g").classed("angular-tick", !0);
                        Y.attr({
                          transform: function transform(e, t) {
                            return "rotate(" + $(e) + ")";
                          }
                        }).style({
                          display: h.angularAxis.visible ? "block" : "none"
                        }), Y.exit().remove(), K.append("line").classed("grid-line", !0).classed("major", function (e, t) {
                          return t % (h.minorTicks + 1) == 0;
                        }).classed("minor", function (e, t) {
                          return !(t % (h.minorTicks + 1) == 0);
                        }).style(D), K.selectAll(".minor").style({
                          stroke: h.minorTickColor
                        }), Y.select("line.grid-line").attr({
                          x1: h.tickLength ? b - h.tickLength : 0,
                          x2: b
                        }).style({
                          display: h.angularAxis.gridLinesVisible ? "block" : "none"
                        }), K.append("text").classed("axis-text", !0).style(B);
                        var Z = Y.select("text.axis-text").attr({
                          x: b + h.labelOffset,
                          dy: o + "em",
                          transform: function transform(e, t) {
                            var n = $(e),
                              r = b + h.labelOffset,
                              i = h.angularAxis.tickOrientation;
                            return "horizontal" == i ? "rotate(" + -n + " " + r + " 0)" : "radial" == i ? n < 270 && n > 90 ? "rotate(180 " + r + " 0)" : null : "rotate(" + (n <= 180 && n > 0 ? -90 : 90) + " " + r + " 0)";
                          }
                        }).style({
                          "text-anchor": "middle",
                          display: h.angularAxis.labelsVisible ? "block" : "none"
                        }).text(function (e, t) {
                          return t % (h.minorTicks + 1) != 0 ? "" : w ? w[e] + h.angularAxis.ticksSuffix : e + h.angularAxis.ticksSuffix;
                        }).style(B);
                        h.angularAxis.rewriteTicks && Z.text(function (e, t) {
                          return t % (h.minorTicks + 1) != 0 ? "" : h.angularAxis.rewriteTicks(this.textContent, t);
                        });
                        var Q = r.max(L.selectAll(".angular-tick text")[0].map(function (e, t) {
                          return e.getCTM().e + e.getBBox().width;
                        }));
                        N.attr({
                          transform: "translate(" + [b + Q, h.margin.top] + ")"
                        });
                        var J = e.select("g.geometry-group").selectAll("g").size() > 0,
                          ee = e.select("g.geometry-group").selectAll("g.geometry").data(f);
                        if (ee.enter().append("g").attr({
                          class: function _class(e, t) {
                            return "geometry geometry" + t;
                          }
                        }), ee.exit().remove(), f[0] || J) {
                          var te = [];
                          f.forEach(function (e, t) {
                            var r = {};
                            r.radialScale = n, r.angularScale = s, r.container = ee.filter(function (e, n) {
                              return n == t;
                            }), r.geometry = e.geometry, r.orientation = h.orientation, r.direction = h.direction, r.index = t, te.push({
                              data: e,
                              geometryConfig: r
                            });
                          });
                          var ne = r.nest().key(function (e, t) {
                              return void 0 !== e.data.groupId || "unstacked";
                            }).entries(te),
                            re = [];
                          ne.forEach(function (e, t) {
                            "unstacked" === e.key ? re = re.concat(e.values.map(function (e, t) {
                              return [e];
                            })) : re.push(e.values);
                          }), re.forEach(function (e, t) {
                            var n;
                            n = Array.isArray(e) ? e[0].geometryConfig.geometry : e.geometryConfig.geometry;
                            var r = e.map(function (e, t) {
                              return i(a[n].defaultConfig(), e);
                            });
                            a[n]().config(r)();
                          });
                        }
                        var ie,
                          oe,
                          ae = e.select(".guides-group"),
                          se = e.select(".tooltips-group"),
                          le = a.tooltipPanel().config({
                            container: se,
                            fontSize: 8
                          })(),
                          ue = a.tooltipPanel().config({
                            container: se,
                            fontSize: 8
                          })(),
                          ce = a.tooltipPanel().config({
                            container: se,
                            hasTick: !0
                          })();
                        if (!A) {
                          var de = ae.select("line").attr({
                            x1: 0,
                            y1: 0,
                            y2: 0
                          }).style({
                            stroke: "grey",
                            "pointer-events": "none"
                          });
                          L.on("mousemove.angular-guide", function (e, t) {
                            var n = a.util.getMousePos(W).angle;
                            de.attr({
                              x2: -b,
                              transform: "rotate(" + n + ")"
                            }).style({
                              opacity: .5
                            });
                            var r = (n + 180 + 360 - h.orientation) % 360;
                            ie = s.invert(r);
                            var i = a.util.convertToCartesian(b + 12, n + 180);
                            le.text(a.util.round(ie)).move([i[0] + x[0], i[1] + x[1]]);
                          }).on("mouseout.angular-guide", function (e, t) {
                            ae.select("line").style({
                              opacity: 0
                            });
                          });
                        }
                        var he = ae.select("circle").style({
                          stroke: "grey",
                          fill: "none"
                        });
                        L.on("mousemove.radial-guide", function (e, t) {
                          var r = a.util.getMousePos(W).radius;
                          he.attr({
                            r: r
                          }).style({
                            opacity: .5
                          }), oe = n.invert(a.util.getMousePos(W).radius);
                          var i = a.util.convertToCartesian(r, h.radialAxis.orientation);
                          ue.text(a.util.round(oe)).move([i[0] + x[0], i[1] + x[1]]);
                        }).on("mouseout.radial-guide", function (e, t) {
                          he.style({
                            opacity: 0
                          }), ce.hide(), le.hide(), ue.hide();
                        }), e.selectAll(".geometry-group .mark").on("mouseover.tooltip", function (t, n) {
                          var i = r.select(this),
                            o = this.style.fill,
                            s = "black",
                            l = this.style.opacity || 1;
                          if (i.attr({
                            "data-opacity": l
                          }), o && "none" !== o) {
                            i.attr({
                              "data-fill": o
                            }), s = r.hsl(o).darker().toString(), i.style({
                              fill: s,
                              opacity: 1
                            });
                            var u = {
                              t: a.util.round(t[0]),
                              r: a.util.round(t[1])
                            };
                            A && (u.t = w[t[0]]);
                            var c = "t: " + u.t + ", r: " + u.r,
                              d = this.getBoundingClientRect(),
                              h = e.node().getBoundingClientRect(),
                              f = [d.left + d.width / 2 - U[0] - h.left, d.top + d.height / 2 - U[1] - h.top];
                            ce.config({
                              color: s
                            }).text(c), ce.move(f);
                          } else o = this.style.stroke || "black", i.attr({
                            "data-stroke": o
                          }), s = r.hsl(o).darker().toString(), i.style({
                            stroke: s,
                            opacity: 1
                          });
                        }).on("mousemove.tooltip", function (e, t) {
                          if (0 != r.event.which) return !1;
                          r.select(this).attr("data-fill") && ce.show();
                        }).on("mouseout.tooltip", function (e, t) {
                          ce.hide();
                          var n = r.select(this),
                            i = n.attr("data-fill");
                          i ? n.style({
                            fill: i,
                            opacity: n.attr("data-opacity")
                          }) : n.style({
                            stroke: n.attr("data-stroke"),
                            opacity: n.attr("data-opacity")
                          });
                        });
                      });
                    }(u), this;
                  },
                  config: function config(e) {
                    if (!arguments.length) return l;
                    var t = a.util.cloneJson(e);
                    return t.data.forEach(function (e, t) {
                      l.data[t] || (l.data[t] = {}), i(l.data[t], a.Axis.defaultConfig().data[0]), i(l.data[t], e);
                    }), i(l.layout, a.Axis.defaultConfig().layout), i(l.layout, t.layout), this;
                  },
                  getLiveConfig: function getLiveConfig() {
                    return c;
                  },
                  getinputConfig: function getinputConfig() {
                    return u;
                  },
                  radialScale: function radialScale(e) {
                    return n;
                  },
                  angularScale: function angularScale(e) {
                    return s;
                  },
                  svg: function svg() {
                    return e;
                  }
                };
              return r.rebind(h, d, "on"), h;
            }, a.Axis.defaultConfig = function (e, t) {
              return {
                data: [{
                  t: [1, 2, 3, 4],
                  r: [10, 11, 12, 13],
                  name: "Line1",
                  geometry: "LinePlot",
                  color: null,
                  strokeDash: "solid",
                  strokeColor: null,
                  strokeSize: "1",
                  visibleInLegend: !0,
                  opacity: 1
                }],
                layout: {
                  defaultColorRange: r.scale.category10().range(),
                  title: null,
                  height: 450,
                  width: 500,
                  margin: {
                    top: 40,
                    right: 40,
                    bottom: 40,
                    left: 40
                  },
                  font: {
                    size: 12,
                    color: "gray",
                    outlineColor: "white",
                    family: "Tahoma, sans-serif"
                  },
                  direction: "clockwise",
                  orientation: 0,
                  labelOffset: 10,
                  radialAxis: {
                    domain: null,
                    orientation: -45,
                    ticksSuffix: "",
                    visible: !0,
                    gridLinesVisible: !0,
                    tickOrientation: "horizontal",
                    rewriteTicks: null
                  },
                  angularAxis: {
                    domain: [0, 360],
                    ticksSuffix: "",
                    visible: !0,
                    gridLinesVisible: !0,
                    labelsVisible: !0,
                    tickOrientation: "horizontal",
                    rewriteTicks: null,
                    ticksCount: null,
                    ticksStep: null
                  },
                  minorTicks: 0,
                  tickLength: null,
                  tickColor: "silver",
                  minorTickColor: "#eee",
                  backgroundColor: "none",
                  needsEndSpacing: null,
                  showLegend: !0,
                  legend: {
                    reverseOrder: !1
                  },
                  opacity: 1
                }
              };
            }, a.util = {}, a.DATAEXTENT = "dataExtent", a.AREA = "AreaChart", a.LINE = "LinePlot", a.DOT = "DotPlot", a.BAR = "BarChart", a.util._override = function (e, t) {
              for (var n in e) n in t && (t[n] = e[n]);
            }, a.util._extend = function (e, t) {
              for (var n in e) t[n] = e[n];
            }, a.util._rndSnd = function () {
              return 2 * Math.random() - 1 + (2 * Math.random() - 1) + (2 * Math.random() - 1);
            }, a.util.dataFromEquation2 = function (e, t) {
              var n = t || 6;
              return r.range(0, 360 + n, n).map(function (t, n) {
                var r = t * Math.PI / 180;
                return [t, e(r)];
              });
            }, a.util.dataFromEquation = function (e, t, n) {
              var i = t || 6,
                o = [],
                a = [];
              r.range(0, 360 + i, i).forEach(function (t, n) {
                var r = t * Math.PI / 180,
                  i = e(r);
                o.push(t), a.push(i);
              });
              var s = {
                t: o,
                r: a
              };
              return n && (s.name = n), s;
            }, a.util.ensureArray = function (e, t) {
              if (void 0 === e) return null;
              var n = [].concat(e);
              return r.range(t).map(function (e, t) {
                return n[t] || n[0];
              });
            }, a.util.fillArrays = function (e, t, n) {
              return t.forEach(function (t, r) {
                e[t] = a.util.ensureArray(e[t], n);
              }), e;
            }, a.util.cloneJson = function (e) {
              return JSON.parse(JSON.stringify(e));
            }, a.util.validateKeys = function (e, t) {
              "string" == typeof t && (t = t.split("."));
              var n = t.shift();
              return e[n] && (!t.length || objHasKeys(e[n], t));
            }, a.util.sumArrays = function (e, t) {
              return r.zip(e, t).map(function (e, t) {
                return r.sum(e);
              });
            }, a.util.arrayLast = function (e) {
              return e[e.length - 1];
            }, a.util.arrayEqual = function (e, t) {
              for (var n = Math.max(e.length, t.length, 1); n-- >= 0 && e[n] === t[n];);
              return -2 === n;
            }, a.util.flattenArray = function (e) {
              for (var t = []; !a.util.arrayEqual(t, e);) t = e, e = [].concat.apply([], e);
              return e;
            }, a.util.deduplicate = function (e) {
              return e.filter(function (e, t, n) {
                return n.indexOf(e) == t;
              });
            }, a.util.convertToCartesian = function (e, t) {
              var n = t * Math.PI / 180;
              return [e * Math.cos(n), e * Math.sin(n)];
            }, a.util.round = function (e, t) {
              var n = t || 2,
                r = Math.pow(10, n);
              return Math.round(e * r) / r;
            }, a.util.getMousePos = function (e) {
              var t = r.mouse(e.node()),
                n = t[0],
                i = t[1],
                o = {};
              return o.x = n, o.y = i, o.pos = t, o.angle = 180 * (Math.atan2(i, n) + Math.PI) / Math.PI, o.radius = Math.sqrt(n * n + i * i), o;
            }, a.util.duplicatesCount = function (e) {
              for (var t, n = {}, r = {}, i = 0, o = e.length; i < o; i++) (t = e[i]) in n ? (n[t]++, r[t] = n[t]) : n[t] = 1;
              return r;
            }, a.util.duplicates = function (e) {
              return Object.keys(a.util.duplicatesCount(e));
            }, a.util.translator = function (e, t, n, r) {
              if (r) {
                var i = n.slice();
                n = t, t = i;
              }
              var o = t.reduce(function (e, t) {
                if (void 0 !== e) return e[t];
              }, e);
              void 0 !== o && (t.reduce(function (e, n, r) {
                if (void 0 !== e) return r === t.length - 1 && delete e[n], e[n];
              }, e), n.reduce(function (e, t, r) {
                return void 0 === e[t] && (e[t] = {}), r === n.length - 1 && (e[t] = o), e[t];
              }, e));
            }, a.PolyChart = function () {
              var e = [a.PolyChart.defaultConfig()],
                t = r.dispatch("hover"),
                n = {
                  solid: "none",
                  dash: [5, 2],
                  dot: [2, 5]
                };
              function o() {
                var t = e[0].geometryConfig,
                  i = t.container;
                "string" == typeof i && (i = r.select(i)), i.datum(e).each(function (e, i) {
                  var o = !!e[0].data.yStack,
                    a = e.map(function (e, t) {
                      return o ? r.zip(e.data.t[0], e.data.r[0], e.data.yStack[0]) : r.zip(e.data.t[0], e.data.r[0]);
                    }),
                    s = t.angularScale,
                    l = t.radialScale.domain()[0],
                    u = {
                      bar: function bar(n, i, o) {
                        var a = e[o].data,
                          l = t.radialScale(n[1]) - t.radialScale(0),
                          u = t.radialScale(n[2] || 0),
                          c = a.barWidth;
                        r.select(this).attr({
                          class: "mark bar",
                          d: "M" + [[l + u, -c / 2], [l + u, c / 2], [u, c / 2], [u, -c / 2]].join("L") + "Z",
                          transform: function transform(e, n) {
                            return "rotate(" + (t.orientation + s(e[0])) + ")";
                          }
                        });
                      },
                      dot: function dot(n, i, o) {
                        var a = n[2] ? [n[0], n[1] + n[2]] : n,
                          s = r.svg.symbol().size(e[o].data.dotSize).type(e[o].data.dotType)(n, i);
                        r.select(this).attr({
                          class: "mark dot",
                          d: s,
                          transform: function transform(e, n) {
                            var r,
                              i = {
                                x: (r = function (e, n) {
                                  return {
                                    r: t.radialScale(e[1]),
                                    t: (t.angularScale(e[0]) + t.orientation) * Math.PI / 180
                                  };
                                }(a)).r * Math.cos(r.t),
                                y: r.r * Math.sin(r.t)
                              };
                            return "translate(" + [i.x, i.y] + ")";
                          }
                        });
                      }
                    },
                    c = r.svg.line.radial().interpolate(e[0].data.lineInterpolation).radius(function (e) {
                      return t.radialScale(e[1]);
                    }).angle(function (e) {
                      return t.angularScale(e[0]) * Math.PI / 180;
                    });
                  u.line = function (n, i, o) {
                    var s = n[2] ? a[o].map(function (e, t) {
                      return [e[0], e[1] + e[2]];
                    }) : a[o];
                    if (r.select(this).each(u.dot).style({
                      opacity: function opacity(t, n) {
                        return +e[o].data.dotVisible;
                      },
                      fill: p.stroke(n, i, o)
                    }).attr({
                      class: "mark dot"
                    }), !(i > 0)) {
                      var l = r.select(this.parentNode).selectAll("path.line").data([0]);
                      l.enter().insert("path"), l.attr({
                        class: "line",
                        d: c(s),
                        transform: function transform(e, n) {
                          return "rotate(" + (t.orientation + 90) + ")";
                        },
                        "pointer-events": "none"
                      }).style({
                        fill: function fill(e, t) {
                          return p.fill(n, i, o);
                        },
                        "fill-opacity": 0,
                        stroke: function stroke(e, t) {
                          return p.stroke(n, i, o);
                        },
                        "stroke-width": function strokeWidth(e, t) {
                          return p["stroke-width"](n, i, o);
                        },
                        "stroke-dasharray": function strokeDasharray(e, t) {
                          return p["stroke-dasharray"](n, i, o);
                        },
                        opacity: function opacity(e, t) {
                          return p.opacity(n, i, o);
                        },
                        display: function display(e, t) {
                          return p.display(n, i, o);
                        }
                      });
                    }
                  };
                  var d = t.angularScale.range(),
                    h = Math.abs(d[1] - d[0]) / a[0].length * Math.PI / 180,
                    f = r.svg.arc().startAngle(function (e) {
                      return -h / 2;
                    }).endAngle(function (e) {
                      return h / 2;
                    }).innerRadius(function (e) {
                      return t.radialScale(l + (e[2] || 0));
                    }).outerRadius(function (e) {
                      return t.radialScale(l + (e[2] || 0)) + t.radialScale(e[1]);
                    });
                  u.arc = function (e, n, i) {
                    r.select(this).attr({
                      class: "mark arc",
                      d: f,
                      transform: function transform(e, n) {
                        return "rotate(" + (t.orientation + s(e[0]) + 90) + ")";
                      }
                    });
                  };
                  var p = {
                      fill: function fill(t, n, r) {
                        return e[r].data.color;
                      },
                      stroke: function stroke(t, n, r) {
                        return e[r].data.strokeColor;
                      },
                      "stroke-width": function strokeWidth(t, n, r) {
                        return e[r].data.strokeSize + "px";
                      },
                      "stroke-dasharray": function strokeDasharray(t, r, i) {
                        return n[e[i].data.strokeDash];
                      },
                      opacity: function opacity(t, n, r) {
                        return e[r].data.opacity;
                      },
                      display: function display(t, n, r) {
                        return void 0 === e[r].data.visible || e[r].data.visible ? "block" : "none";
                      }
                    },
                    m = r.select(this).selectAll("g.layer").data(a);
                  m.enter().append("g").attr({
                    class: "layer"
                  });
                  var g = m.selectAll("path.mark").data(function (e, t) {
                    return e;
                  });
                  g.enter().append("path").attr({
                    class: "mark"
                  }), g.style(p).each(u[t.geometryType]), g.exit().remove(), m.exit().remove();
                });
              }
              return o.config = function (t) {
                return arguments.length ? (t.forEach(function (t, n) {
                  e[n] || (e[n] = {}), i(e[n], a.PolyChart.defaultConfig()), i(e[n], t);
                }), this) : e;
              }, o.getColorScale = function () {}, r.rebind(o, t, "on"), o;
            }, a.PolyChart.defaultConfig = function () {
              return {
                data: {
                  name: "geom1",
                  t: [[1, 2, 3, 4]],
                  r: [[1, 2, 3, 4]],
                  dotType: "circle",
                  dotSize: 64,
                  dotVisible: !1,
                  barWidth: 20,
                  color: "#ffa500",
                  strokeSize: 1,
                  strokeColor: "silver",
                  strokeDash: "solid",
                  opacity: 1,
                  index: 0,
                  visible: !0,
                  visibleInLegend: !0
                },
                geometryConfig: {
                  geometry: "LinePlot",
                  geometryType: "arc",
                  direction: "clockwise",
                  orientation: 0,
                  container: "body",
                  radialScale: null,
                  angularScale: null,
                  colorScale: r.scale.category20()
                }
              };
            }, a.BarChart = function () {
              return a.PolyChart();
            }, a.BarChart.defaultConfig = function () {
              return {
                geometryConfig: {
                  geometryType: "bar"
                }
              };
            }, a.AreaChart = function () {
              return a.PolyChart();
            }, a.AreaChart.defaultConfig = function () {
              return {
                geometryConfig: {
                  geometryType: "arc"
                }
              };
            }, a.DotPlot = function () {
              return a.PolyChart();
            }, a.DotPlot.defaultConfig = function () {
              return {
                geometryConfig: {
                  geometryType: "dot",
                  dotType: "circle"
                }
              };
            }, a.LinePlot = function () {
              return a.PolyChart();
            }, a.LinePlot.defaultConfig = function () {
              return {
                geometryConfig: {
                  geometryType: "line"
                }
              };
            }, a.Legend = function () {
              var e = a.Legend.defaultConfig(),
                t = r.dispatch("hover");
              function n() {
                var t = e.legendConfig,
                  o = e.data.map(function (e, n) {
                    return [].concat(e).map(function (e, r) {
                      var o = i({}, t.elements[n]);
                      return o.name = e, o.color = [].concat(t.elements[n].color)[r], o;
                    });
                  }),
                  a = r.merge(o);
                a = a.filter(function (e, n) {
                  return t.elements[n] && (t.elements[n].visibleInLegend || void 0 === t.elements[n].visibleInLegend);
                }), t.reverseOrder && (a = a.reverse());
                var s = t.container;
                ("string" == typeof s || s.nodeName) && (s = r.select(s));
                var l = a.map(function (e, t) {
                    return e.color;
                  }),
                  u = t.fontSize,
                  c = null == t.isContinuous ? "number" == typeof a[0] : t.isContinuous,
                  d = c ? t.height : u * a.length,
                  h = s.classed("legend-group", !0).selectAll("svg").data([0]),
                  f = h.enter().append("svg").attr({
                    width: 300,
                    height: d + u,
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    version: "1.1"
                  });
                f.append("g").classed("legend-axis", !0), f.append("g").classed("legend-marks", !0);
                var p = r.range(a.length),
                  m = r.scale[c ? "linear" : "ordinal"]().domain(p).range(l),
                  g = r.scale[c ? "linear" : "ordinal"]().domain(p)[c ? "range" : "rangePoints"]([0, d]);
                if (c) {
                  var v = h.select(".legend-marks").append("defs").append("linearGradient").attr({
                    id: "grad1",
                    x1: "0%",
                    y1: "0%",
                    x2: "0%",
                    y2: "100%"
                  }).selectAll("stop").data(l);
                  v.enter().append("stop"), v.attr({
                    offset: function offset(e, t) {
                      return t / (l.length - 1) * 100 + "%";
                    }
                  }).style({
                    "stop-color": function stopColor(e, t) {
                      return e;
                    }
                  }), h.append("rect").classed("legend-mark", !0).attr({
                    height: t.height,
                    width: t.colorBandWidth,
                    fill: "url(#grad1)"
                  });
                } else {
                  var y = h.select(".legend-marks").selectAll("path.legend-mark").data(a);
                  y.enter().append("path").classed("legend-mark", !0), y.attr({
                    transform: function transform(e, t) {
                      return "translate(" + [u / 2, g(t) + u / 2] + ")";
                    },
                    d: function d(e, t) {
                      var n,
                        i,
                        o,
                        a = e.symbol;
                      return o = 3 * (i = u), "line" === (n = a) ? "M" + [[-i / 2, -i / 12], [i / 2, -i / 12], [i / 2, i / 12], [-i / 2, i / 12]] + "Z" : -1 != r.svg.symbolTypes.indexOf(n) ? r.svg.symbol().type(n).size(o)() : r.svg.symbol().type("square").size(o)();
                    },
                    fill: function fill(e, t) {
                      return m(t);
                    }
                  }), y.exit().remove();
                }
                var b = r.svg.axis().scale(g).orient("right"),
                  _ = h.select("g.legend-axis").attr({
                    transform: "translate(" + [c ? t.colorBandWidth : u, u / 2] + ")"
                  }).call(b);
                return _.selectAll(".domain").style({
                  fill: "none",
                  stroke: "none"
                }), _.selectAll("line").style({
                  fill: "none",
                  stroke: c ? t.textColor : "none"
                }), _.selectAll("text").style({
                  fill: t.textColor,
                  "font-size": t.fontSize
                }).text(function (e, t) {
                  return a[t].name;
                }), n;
              }
              return n.config = function (t) {
                return arguments.length ? (i(e, t), this) : e;
              }, r.rebind(n, t, "on"), n;
            }, a.Legend.defaultConfig = function (e, t) {
              return {
                data: ["a", "b", "c"],
                legendConfig: {
                  elements: [{
                    symbol: "line",
                    color: "red"
                  }, {
                    symbol: "square",
                    color: "yellow"
                  }, {
                    symbol: "diamond",
                    color: "limegreen"
                  }],
                  height: 150,
                  colorBandWidth: 30,
                  fontSize: 12,
                  container: "body",
                  isContinuous: null,
                  textColor: "grey",
                  reverseOrder: !1
                }
              };
            }, a.tooltipPanel = function () {
              var e,
                t,
                n,
                o = {
                  container: null,
                  hasTick: !1,
                  fontSize: 12,
                  color: "white",
                  padding: 5
                },
                s = "tooltip-" + a.tooltipPanel.uid++,
                l = 10,
                u = function u() {
                  var r = (e = o.container.selectAll("g." + s).data([0])).enter().append("g").classed(s, !0).style({
                    "pointer-events": "none",
                    display: "none"
                  });
                  return n = r.append("path").style({
                    fill: "white",
                    "fill-opacity": .9
                  }).attr({
                    d: "M0 0"
                  }), t = r.append("text").attr({
                    dx: o.padding + l,
                    dy: .3 * +o.fontSize
                  }), u;
                };
              return u.text = function (i) {
                var a = r.hsl(o.color).l,
                  s = a >= .5 ? "#aaa" : "white",
                  c = a >= .5 ? "black" : "white",
                  d = i || "";
                t.style({
                  fill: c,
                  "font-size": o.fontSize + "px"
                }).text(d);
                var h = o.padding,
                  f = t.node().getBBox(),
                  p = {
                    fill: o.color,
                    stroke: s,
                    "stroke-width": "2px"
                  },
                  m = f.width + 2 * h + l,
                  g = f.height + 2 * h;
                return n.attr({
                  d: "M" + [[l, -g / 2], [l, -g / 4], [o.hasTick ? 0 : l, 0], [l, g / 4], [l, g / 2], [m, g / 2], [m, -g / 2]].join("L") + "Z"
                }).style(p), e.attr({
                  transform: "translate(" + [l, -g / 2 + 2 * h] + ")"
                }), e.style({
                  display: "block"
                }), u;
              }, u.move = function (t) {
                if (e) return e.attr({
                  transform: "translate(" + [t[0], t[1]] + ")"
                }).style({
                  display: "block"
                }), u;
              }, u.hide = function () {
                if (e) return e.style({
                  display: "none"
                }), u;
              }, u.show = function () {
                if (e) return e.style({
                  display: "block"
                }), u;
              }, u.config = function (e) {
                return i(o, e), u;
              }, u;
            }, a.tooltipPanel.uid = 1, a.adapter = {}, a.adapter.plotly = function () {
              return {
                convert: function convert(e, t) {
                  var n = {};
                  if (e.data && (n.data = e.data.map(function (e, n) {
                    var r = i({}, e);
                    return [[r, ["marker", "color"], ["color"]], [r, ["marker", "opacity"], ["opacity"]], [r, ["marker", "line", "color"], ["strokeColor"]], [r, ["marker", "line", "dash"], ["strokeDash"]], [r, ["marker", "line", "width"], ["strokeSize"]], [r, ["marker", "symbol"], ["dotType"]], [r, ["marker", "size"], ["dotSize"]], [r, ["marker", "barWidth"], ["barWidth"]], [r, ["line", "interpolation"], ["lineInterpolation"]], [r, ["showlegend"], ["visibleInLegend"]]].forEach(function (e, n) {
                      a.util.translator.apply(null, e.concat(t));
                    }), t || delete r.marker, t && delete r.groupId, t ? ("LinePlot" === r.geometry ? (r.type = "scatter", !0 === r.dotVisible ? (delete r.dotVisible, r.mode = "lines+markers") : r.mode = "lines") : "DotPlot" === r.geometry ? (r.type = "scatter", r.mode = "markers") : "AreaChart" === r.geometry ? r.type = "area" : "BarChart" === r.geometry && (r.type = "bar"), delete r.geometry) : ("scatter" === r.type ? "lines" === r.mode ? r.geometry = "LinePlot" : "markers" === r.mode ? r.geometry = "DotPlot" : "lines+markers" === r.mode && (r.geometry = "LinePlot", r.dotVisible = !0) : "area" === r.type ? r.geometry = "AreaChart" : "bar" === r.type && (r.geometry = "BarChart"), delete r.mode, delete r.type), r;
                  }), !t && e.layout && "stack" === e.layout.barmode)) {
                    var o = a.util.duplicates(n.data.map(function (e, t) {
                      return e.geometry;
                    }));
                    n.data.forEach(function (e, t) {
                      var r = o.indexOf(e.geometry);
                      -1 != r && (n.data[t].groupId = r);
                    });
                  }
                  if (e.layout) {
                    var s = i({}, e.layout);
                    if ([[s, ["plot_bgcolor"], ["backgroundColor"]], [s, ["showlegend"], ["showLegend"]], [s, ["radialaxis"], ["radialAxis"]], [s, ["angularaxis"], ["angularAxis"]], [s.angularaxis, ["showline"], ["gridLinesVisible"]], [s.angularaxis, ["showticklabels"], ["labelsVisible"]], [s.angularaxis, ["nticks"], ["ticksCount"]], [s.angularaxis, ["tickorientation"], ["tickOrientation"]], [s.angularaxis, ["ticksuffix"], ["ticksSuffix"]], [s.angularaxis, ["range"], ["domain"]], [s.angularaxis, ["endpadding"], ["endPadding"]], [s.radialaxis, ["showline"], ["gridLinesVisible"]], [s.radialaxis, ["tickorientation"], ["tickOrientation"]], [s.radialaxis, ["ticksuffix"], ["ticksSuffix"]], [s.radialaxis, ["range"], ["domain"]], [s.angularAxis, ["showline"], ["gridLinesVisible"]], [s.angularAxis, ["showticklabels"], ["labelsVisible"]], [s.angularAxis, ["nticks"], ["ticksCount"]], [s.angularAxis, ["tickorientation"], ["tickOrientation"]], [s.angularAxis, ["ticksuffix"], ["ticksSuffix"]], [s.angularAxis, ["range"], ["domain"]], [s.angularAxis, ["endpadding"], ["endPadding"]], [s.radialAxis, ["showline"], ["gridLinesVisible"]], [s.radialAxis, ["tickorientation"], ["tickOrientation"]], [s.radialAxis, ["ticksuffix"], ["ticksSuffix"]], [s.radialAxis, ["range"], ["domain"]], [s.font, ["outlinecolor"], ["outlineColor"]], [s.legend, ["traceorder"], ["reverseOrder"]], [s, ["labeloffset"], ["labelOffset"]], [s, ["defaultcolorrange"], ["defaultColorRange"]]].forEach(function (e, n) {
                      a.util.translator.apply(null, e.concat(t));
                    }), t ? (void 0 !== s.tickLength && (s.angularaxis.ticklen = s.tickLength, delete s.tickLength), s.tickColor && (s.angularaxis.tickcolor = s.tickColor, delete s.tickColor)) : (s.angularAxis && void 0 !== s.angularAxis.ticklen && (s.tickLength = s.angularAxis.ticklen), s.angularAxis && void 0 !== s.angularAxis.tickcolor && (s.tickColor = s.angularAxis.tickcolor)), s.legend && "boolean" != typeof s.legend.reverseOrder && (s.legend.reverseOrder = "normal" != s.legend.reverseOrder), s.legend && "boolean" == typeof s.legend.traceorder && (s.legend.traceorder = s.legend.traceorder ? "reversed" : "normal", delete s.legend.reverseOrder), s.margin && void 0 !== s.margin.t) {
                      var l = ["t", "r", "b", "l", "pad"],
                        u = ["top", "right", "bottom", "left", "pad"],
                        c = {};
                      r.entries(s.margin).forEach(function (e, t) {
                        c[u[l.indexOf(e.key)]] = e.value;
                      }), s.margin = c;
                    }
                    t && (delete s.needsEndSpacing, delete s.minorTickColor, delete s.minorTicks, delete s.angularaxis.ticksCount, delete s.angularaxis.ticksCount, delete s.angularaxis.ticksStep, delete s.angularaxis.rewriteTicks, delete s.angularaxis.nticks, delete s.radialaxis.ticksCount, delete s.radialaxis.ticksCount, delete s.radialaxis.ticksStep, delete s.radialaxis.rewriteTicks, delete s.radialaxis.nticks), n.layout = s;
                  }
                  return n;
                }
              };
            };
          }, {
            "../../../constants/alignment": 469,
            "../../../lib": 495,
            d3: 82
          }],
          589: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../../lib"),
              o = e("../../../components/color"),
              a = e("./micropolar"),
              s = e("./undo_manager"),
              l = i.extendDeepAll,
              u = t.exports = {};
            u.framework = function (e) {
              var t,
                n,
                i,
                o,
                c,
                d = new s();
              function h(n, s) {
                return s && (c = s), r.select(r.select(c).node().parentNode).selectAll(".svg-container>*:not(.chart-root)").remove(), t = t ? l(t, n) : n, i || (i = a.Axis()), o = a.adapter.plotly().convert(t), i.config(o).render(c), e.data = t.data, e.layout = t.layout, u.fillLayout(e), t;
              }
              return h.isPolar = !0, h.svg = function () {
                return i.svg();
              }, h.getConfig = function () {
                return t;
              }, h.getLiveConfig = function () {
                return a.adapter.plotly().convert(i.getLiveConfig(), !0);
              }, h.getLiveScales = function () {
                return {
                  t: i.angularScale(),
                  r: i.radialScale()
                };
              }, h.setUndoPoint = function () {
                var e,
                  r,
                  i = this,
                  o = a.util.cloneJson(t);
                e = o, r = n, d.add({
                  undo: function undo() {
                    r && i(r);
                  },
                  redo: function redo() {
                    i(e);
                  }
                }), n = a.util.cloneJson(o);
              }, h.undo = function () {
                d.undo();
              }, h.redo = function () {
                d.redo();
              }, h;
            }, u.fillLayout = function (e) {
              var t = r.select(e).selectAll(".plot-container"),
                n = t.selectAll(".svg-container"),
                i = e.framework && e.framework.svg && e.framework.svg(),
                a = {
                  width: 800,
                  height: 600,
                  paper_bgcolor: o.background,
                  _container: t,
                  _paperdiv: n,
                  _paper: i
                };
              e._fullLayout = l(a, e.layout);
            };
          }, {
            "../../../components/color": 375,
            "../../../lib": 495,
            "./micropolar": 588,
            "./undo_manager": 590,
            d3: 82
          }],
          590: [function (e, t, n) {
            "use strict";

            t.exports = function () {
              var e,
                t = [],
                n = -1,
                r = !1;
              function i(e, t) {
                return e ? (r = !0, e[t](), r = !1, this) : this;
              }
              return {
                add: function add(e) {
                  return r || (t.splice(n + 1, t.length - n), t.push(e), n = t.length - 1), this;
                },
                setCallback: function setCallback(t) {
                  e = t;
                },
                undo: function undo() {
                  var r = t[n];
                  return r ? (i(r, "undo"), n -= 1, e && e(r.undo), this) : this;
                },
                redo: function redo() {
                  var r = t[n + 1];
                  return r ? (i(r, "redo"), n += 1, e && e(r.redo), this) : this;
                },
                clear: function clear() {
                  t = [], n = -1;
                },
                hasUndo: function hasUndo() {
                  return -1 !== n;
                },
                hasRedo: function hasRedo() {
                  return n < t.length - 1;
                },
                getCommands: function getCommands() {
                  return t;
                },
                getPreviousCommand: function getPreviousCommand() {
                  return t[n - 1];
                },
                getIndex: function getIndex() {
                  return n;
                }
              };
            };
          }, {}],
          591: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("../plot_api/plot_template"),
              o = e("./domain").defaults;
            t.exports = function (e, t, n, a) {
              var s,
                l,
                u = a.type,
                c = a.attributes,
                d = a.handleDefaults,
                h = a.partition || "x",
                f = t._subplots[u],
                p = f.length,
                m = p && f[0].replace(/\d+$/, "");
              function g(e, t) {
                return r.coerce(s, l, c, e, t);
              }
              for (var v = 0; v < p; v++) {
                var y = f[v];
                s = e[y] ? e[y] : e[y] = {}, l = i.newContainer(t, y, m), g("uirevision", t.uirevision);
                var b = {};
                b[h] = [v / p, (v + 1) / p], o(l, t, g, b), a.id = y, d(s, l, g, a);
              }
            };
          }, {
            "../lib": 495,
            "../plot_api/plot_template": 531,
            "./domain": 566
          }],
          592: [function (e, t, n) {
            "use strict";

            function r(e) {
              var t = e.description ? " " + e.description : "",
                n = e.keys || [];
              if (n.length > 0) {
                for (var r = [], i = 0; i < n.length; i++) r[i] = "`" + n[i] + "`";
                t += "Finally, the template string has access to ", t = 1 === n.length ? "variable " + r[0] : "variables " + r.slice(0, -1).join(", ") + " and " + r.slice(-1) + ".";
              }
              return t;
            }
            ['Variables are inserted using %{variable}, for example "y: %{y}".', 'Numbers are formatted using d3-format\'s syntax %{variable:d3-format}, for example "Price: %{y:$.2f}".', e("../constants/docs").FORMAT_LINK, "for details on the formatting syntax.", 'Dates are formatted using d3-time-format\'s syntax %{variable|d3-time-format}, for example "Day: %{2019-01-01|%A}".', e("../constants/docs").DATE_FORMAT_LINK, "for details on the date formatting syntax."].join(" "), n.hovertemplateAttrs = function (e, t) {
              e = e || {}, r(t = t || {});
              var n = {
                valType: "string",
                dflt: "",
                editType: e.editType || "none"
              };
              return !1 !== e.arrayOk && (n.arrayOk = !0), n;
            }, n.texttemplateAttrs = function (e, t) {
              e = e || {}, r(t = t || {});
              var n = {
                valType: "string",
                dflt: "",
                editType: e.editType || "calc"
              };
              return !1 !== e.arrayOk && (n.arrayOk = !0), n;
            };
          }, {
            "../constants/docs": 470
          }],
          593: [function (e, t, n) {
            "use strict";

            var r = e("./lib/loggers"),
              i = e("./lib/noop"),
              o = e("./lib/push_unique"),
              a = e("./lib/is_plain_object"),
              s = e("./lib/dom").addStyleRule,
              l = e("./lib/extend"),
              u = e("./plots/attributes"),
              c = e("./plots/layout_attributes"),
              d = l.extendFlat,
              h = l.extendDeepAll;
            function f(e) {
              var t = e.name,
                i = e.categories,
                o = e.meta;
              if (n.modules[t]) r.log("Type " + t + " already registered");else {
                n.subplotsRegistry[e.basePlotModule.name] || function (e) {
                  var t = e.name;
                  if (n.subplotsRegistry[t]) r.log("Plot type " + t + " already registered.");else for (var i in v(e), n.subplotsRegistry[t] = e, n.componentsRegistry) _(i, e.name);
                }(e.basePlotModule);
                for (var a = {}, l = 0; l < i.length; l++) a[i[l]] = !0, n.allCategories[i[l]] = !0;
                for (var u in n.modules[t] = {
                  _module: e,
                  categories: a
                }, o && Object.keys(o).length && (n.modules[t].meta = o), n.allTypes.push(t), n.componentsRegistry) y(u, t);
                e.layoutAttributes && d(n.traceLayoutAttributes, e.layoutAttributes);
                var c = e.basePlotModule,
                  h = c.name;
                if ("mapbox" === h) {
                  var f = c.constants.styleRules;
                  for (var p in f) s(".js-plotly-plot .plotly .mapboxgl-" + p, f[p]);
                }
                "geo" !== h && "mapbox" !== h || void 0 === typeof window || void 0 !== window.PlotlyGeoAssets || (window.PlotlyGeoAssets = {
                  topojson: {}
                });
              }
            }
            function p(e) {
              if ("string" != typeof e.name) throw new Error("Component module *name* must be a string.");
              var t = e.name;
              for (var r in n.componentsRegistry[t] = e, e.layoutAttributes && (e.layoutAttributes._isLinkedToArray && o(n.layoutArrayContainers, t), v(e)), n.modules) y(t, r);
              for (var i in n.subplotsRegistry) _(t, i);
              for (var a in n.transformsRegistry) b(t, a);
              e.schema && e.schema.layout && h(c, e.schema.layout);
            }
            function m(e) {
              if ("string" != typeof e.name) throw new Error("Transform module *name* must be a string.");
              var t = "Transform module " + e.name,
                i = "function" == typeof e.transform,
                o = "function" == typeof e.calcTransform;
              if (!i && !o) throw new Error(t + " is missing a *transform* or *calcTransform* method.");
              for (var s in i && o && r.log([t + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" ")), a(e.attributes) || r.log(t + " registered without an *attributes* object."), "function" != typeof e.supplyDefaults && r.log(t + " registered without a *supplyDefaults* method."), n.transformsRegistry[e.name] = e, n.componentsRegistry) b(s, e.name);
            }
            function g(e) {
              var t = e.name,
                r = t.split("-")[0],
                i = e.dictionary,
                o = e.format,
                a = i && Object.keys(i).length,
                s = o && Object.keys(o).length,
                l = n.localeRegistry,
                u = l[t];
              if (u || (l[t] = u = {}), r !== t) {
                var c = l[r];
                c || (l[r] = c = {}), a && c.dictionary === u.dictionary && (c.dictionary = i), s && c.format === u.format && (c.format = o);
              }
              a && (u.dictionary = i), s && (u.format = o);
            }
            function v(e) {
              if (e.layoutAttributes) {
                var t = e.layoutAttributes._arrayAttrRegexps;
                if (t) for (var r = 0; r < t.length; r++) o(n.layoutArrayRegexes, t[r]);
              }
            }
            function y(e, t) {
              var r = n.componentsRegistry[e].schema;
              if (r && r.traces) {
                var i = r.traces[t];
                i && h(n.modules[t]._module.attributes, i);
              }
            }
            function b(e, t) {
              var r = n.componentsRegistry[e].schema;
              if (r && r.transforms) {
                var i = r.transforms[t];
                i && h(n.transformsRegistry[t].attributes, i);
              }
            }
            function _(e, t) {
              var r = n.componentsRegistry[e].schema;
              if (r && r.subplots) {
                var i = n.subplotsRegistry[t],
                  o = i.layoutAttributes,
                  a = "subplot" === i.attr ? i.name : i.attr;
                Array.isArray(a) && (a = a[0]);
                var s = r.subplots[a];
                o && s && h(o, s);
              }
            }
            function x(e) {
              return "object" == typeof e && (e = e.type), e;
            }
            n.modules = {}, n.allCategories = {}, n.allTypes = [], n.subplotsRegistry = {}, n.transformsRegistry = {}, n.componentsRegistry = {}, n.layoutArrayContainers = [], n.layoutArrayRegexes = [], n.traceLayoutAttributes = {}, n.localeRegistry = {}, n.apiMethodRegistry = {}, n.collectableSubplotTypes = null, n.register = function (e) {
              if (n.collectableSubplotTypes = null, !e) throw new Error("No argument passed to Plotly.register.");
              e && !Array.isArray(e) && (e = [e]);
              for (var t = 0; t < e.length; t++) {
                var r = e[t];
                if (!r) throw new Error("Invalid module was attempted to be registered!");
                switch (r.moduleType) {
                  case "trace":
                    f(r);
                    break;
                  case "transform":
                    m(r);
                    break;
                  case "component":
                    p(r);
                    break;
                  case "locale":
                    g(r);
                    break;
                  case "apiMethod":
                    var i = r.name;
                    n.apiMethodRegistry[i] = r.fn;
                    break;
                  default:
                    throw new Error("Invalid module was attempted to be registered!");
                }
              }
            }, n.getModule = function (e) {
              var t = n.modules[x(e)];
              return !!t && t._module;
            }, n.traceIs = function (e, t) {
              if ("various" === (e = x(e))) return !1;
              var i = n.modules[e];
              return i || (e && "area" !== e && r.log("Unrecognized trace type " + e + "."), i = n.modules[u.type.dflt]), !!i.categories[t];
            }, n.getTransformIndices = function (e, t) {
              for (var n = [], r = e.transforms || [], i = 0; i < r.length; i++) r[i].type === t && n.push(i);
              return n;
            }, n.hasTransform = function (e, t) {
              for (var n = e.transforms || [], r = 0; r < n.length; r++) if (n[r].type === t) return !0;
              return !1;
            }, n.getComponentMethod = function (e, t) {
              var r = n.componentsRegistry[e];
              return r && r[t] || i;
            }, n.call = function () {
              var e = arguments[0],
                t = [].slice.call(arguments, 1);
              return n.apiMethodRegistry[e].apply(null, t);
            };
          }, {
            "./lib/dom": 487,
            "./lib/extend": 489,
            "./lib/is_plain_object": 496,
            "./lib/loggers": 499,
            "./lib/noop": 504,
            "./lib/push_unique": 508,
            "./plots/attributes": 538,
            "./plots/layout_attributes": 582
          }],
          594: [function (e, t, n) {
            "use strict";

            var r = e("../registry"),
              i = e("../lib"),
              o = i.extendFlat,
              a = i.extendDeep;
            function s(e) {
              var t;
              switch (e) {
                case "themes__thumb":
                  t = {
                    autosize: !0,
                    width: 150,
                    height: 150,
                    title: {
                      text: ""
                    },
                    showlegend: !1,
                    margin: {
                      l: 5,
                      r: 5,
                      t: 5,
                      b: 5,
                      pad: 0
                    },
                    annotations: []
                  };
                  break;
                case "thumbnail":
                  t = {
                    title: {
                      text: ""
                    },
                    hidesources: !0,
                    showlegend: !1,
                    borderwidth: 0,
                    bordercolor: "",
                    margin: {
                      l: 1,
                      r: 1,
                      t: 1,
                      b: 1,
                      pad: 0
                    },
                    annotations: []
                  };
                  break;
                default:
                  t = {};
              }
              return t;
            }
            t.exports = function (e, t) {
              var n;
              e.framework && e.framework.isPolar && (e = e.framework.getConfig());
              var i,
                l = e.data,
                u = e.layout,
                c = a([], l),
                d = a({}, u, s(t.tileClass)),
                h = e._context || {};
              if (t.width && (d.width = t.width), t.height && (d.height = t.height), "thumbnail" === t.tileClass || "themes__thumb" === t.tileClass) {
                d.annotations = [];
                var f = Object.keys(d);
                for (n = 0; n < f.length; n++) i = f[n], ["xaxis", "yaxis", "zaxis"].indexOf(i.slice(0, 5)) > -1 && (d[f[n]].title = {
                  text: ""
                });
                for (n = 0; n < c.length; n++) {
                  var p = c[n];
                  p.showscale = !1, p.marker && (p.marker.showscale = !1), r.traceIs(p, "pie-like") && (p.textposition = "none");
                }
              }
              if (Array.isArray(t.annotations)) for (n = 0; n < t.annotations.length; n++) d.annotations.push(t.annotations[n]);
              var m = Object.keys(d).filter(function (e) {
                return e.match(/^scene\d*$/);
              });
              if (m.length) {
                var g = {};
                for ("thumbnail" === t.tileClass && (g = {
                  title: {
                    text: ""
                  },
                  showaxeslabels: !1,
                  showticklabels: !1,
                  linetickenable: !1
                }), n = 0; n < m.length; n++) {
                  var v = d[m[n]];
                  v.xaxis || (v.xaxis = {}), v.yaxis || (v.yaxis = {}), v.zaxis || (v.zaxis = {}), o(v.xaxis, g), o(v.yaxis, g), o(v.zaxis, g), v._scene = null;
                }
              }
              var y = document.createElement("div");
              t.tileClass && (y.className = t.tileClass);
              var b = {
                gd: y,
                td: y,
                layout: d,
                data: c,
                config: {
                  staticPlot: void 0 === t.staticPlot || t.staticPlot,
                  plotGlPixelRatio: void 0 === t.plotGlPixelRatio ? 2 : t.plotGlPixelRatio,
                  displaylogo: t.displaylogo || !1,
                  showLink: t.showLink || !1,
                  showTips: t.showTips || !1,
                  mapboxAccessToken: h.mapboxAccessToken
                }
              };
              return "transparent" !== t.setBackground && (b.config.setBackground = t.setBackground || "opaque"), b.gd.defaultLayout = s(t.tileClass), b;
            };
          }, {
            "../lib": 495,
            "../registry": 593
          }],
          595: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("../plot_api/to_image"),
              o = e("./filesaver"),
              a = e("./helpers");
            t.exports = function (e, t) {
              var n;
              return r.isPlainObject(e) || (n = r.getGraphDiv(e)), (t = t || {}).format = t.format || "png", t.imageDataOnly = !0, new Promise(function (s, l) {
                n && n._snapshotInProgress && l(new Error("Snapshotting already in progress.")), r.isIE() && "svg" !== t.format && l(new Error(a.MSG_IE_BAD_FORMAT)), n && (n._snapshotInProgress = !0);
                var u = i(e, t),
                  c = t.filename || e.fn || "newplot";
                c += "." + t.format, u.then(function (e) {
                  return n && (n._snapshotInProgress = !1), o(e, c, t.format);
                }).then(function (e) {
                  s(e);
                }).catch(function (e) {
                  n && (n._snapshotInProgress = !1), l(e);
                });
              });
            };
          }, {
            "../lib": 495,
            "../plot_api/to_image": 534,
            "./filesaver": 596,
            "./helpers": 597
          }],
          596: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("./helpers");
            t.exports = function (e, t, n) {
              var o = document.createElement("a"),
                a = ("download" in o);
              return new Promise(function (s, l) {
                var u, c;
                if (r.isIE9orBelow() && l(new Error("IE < 10 unsupported")), r.isSafari()) {
                  var d = "svg" === n ? "," : ";base64,";
                  return i.octetStream(d + encodeURIComponent(e)), s(t);
                }
                return r.isIE() ? (u = i.createBlob(e, "svg"), window.navigator.msSaveBlob(u, t), u = null, s(t)) : a ? (u = i.createBlob(e, n), c = i.createObjectURL(u), o.href = c, o.download = t, document.body.appendChild(o), o.click(), document.body.removeChild(o), i.revokeObjectURL(c), u = null, s(t)) : void l(new Error("download error"));
              });
            };
          }, {
            "../lib": 495,
            "./helpers": 597
          }],
          597: [function (e, t, n) {
            "use strict";

            var r = e("../registry");
            n.getDelay = function (e) {
              return e._has && (e._has("gl3d") || e._has("gl2d") || e._has("mapbox")) ? 500 : 0;
            }, n.getRedrawFunc = function (e) {
              return function () {
                var t = e._fullLayout || {};
                (!t._has || !t._has("polar")) && e.data && e.data[0] && e.data[0].r || r.getComponentMethod("colorbar", "draw")(e);
              };
            }, n.encodeSVG = function (e) {
              return "data:image/svg+xml," + encodeURIComponent(e);
            };
            var i = window.URL || window.webkitURL;
            n.createObjectURL = function (e) {
              return i.createObjectURL(e);
            }, n.revokeObjectURL = function (e) {
              return i.revokeObjectURL(e);
            }, n.createBlob = function (e, t) {
              if ("svg" === t) return new window.Blob([e], {
                type: "image/svg+xml;charset=utf-8"
              });
              var n = function (e) {
                for (var t = e.length, n = new ArrayBuffer(t), r = new Uint8Array(n), i = 0; i < t; i++) r[i] = e.charCodeAt(i);
                return n;
              }(window.atob(e));
              return new window.Blob([n], {
                type: "image/" + t
              });
            }, n.octetStream = function (e) {
              document.location.href = "data:application/octet-stream" + e;
            }, n.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/, n.MSG_IE_BAD_FORMAT = "Sorry IE does not support downloading from canvas. Try {format:'svg'} instead.";
          }, {
            "../registry": 593
          }],
          598: [function (e, t, n) {
            "use strict";

            var r = e("./helpers"),
              i = {
                getDelay: r.getDelay,
                getRedrawFunc: r.getRedrawFunc,
                clone: e("./cloneplot"),
                toSVG: e("./tosvg"),
                svgToImg: e("./svgtoimg"),
                toImage: e("./toimage"),
                downloadImage: e("./download")
              };
            t.exports = i;
          }, {
            "./cloneplot": 594,
            "./download": 595,
            "./helpers": 597,
            "./svgtoimg": 599,
            "./toimage": 600,
            "./tosvg": 601
          }],
          599: [function (e, t, n) {
            "use strict";

            var r = e("../lib"),
              i = e("events").EventEmitter,
              o = e("./helpers");
            t.exports = function (e) {
              var t = e.emitter || new i(),
                n = new Promise(function (i, a) {
                  var s = window.Image,
                    l = e.svg,
                    u = e.format || "png";
                  if (r.isIE() && "svg" !== u) {
                    var c = new Error(o.MSG_IE_BAD_FORMAT);
                    return a(c), e.promise ? n : t.emit("error", c);
                  }
                  var d,
                    h,
                    f = e.canvas,
                    p = e.scale || 1,
                    m = e.width || 300,
                    g = e.height || 150,
                    v = p * m,
                    y = p * g,
                    b = f.getContext("2d"),
                    _ = new s();
                  "svg" === u || r.isIE9orBelow() || r.isSafari() ? h = o.encodeSVG(l) : (d = o.createBlob(l, "svg"), h = o.createObjectURL(d)), f.width = v, f.height = y, _.onload = function () {
                    var n;
                    switch (d = null, o.revokeObjectURL(h), "svg" !== u && b.drawImage(_, 0, 0, v, y), u) {
                      case "jpeg":
                        n = f.toDataURL("image/jpeg");
                        break;
                      case "png":
                        n = f.toDataURL("image/png");
                        break;
                      case "webp":
                        n = f.toDataURL("image/webp");
                        break;
                      case "svg":
                        n = h;
                        break;
                      default:
                        var r = "Image format is not jpeg, png, svg or webp.";
                        if (a(new Error(r)), !e.promise) return t.emit("error", r);
                    }
                    i(n), e.promise || t.emit("success", n);
                  }, _.onerror = function (n) {
                    if (d = null, o.revokeObjectURL(h), a(n), !e.promise) return t.emit("error", n);
                  }, _.src = h;
                });
              return e.promise ? n : t;
            };
          }, {
            "../lib": 495,
            "./helpers": 597,
            events: 48
          }],
          600: [function (e, t, n) {
            "use strict";

            var r = e("events").EventEmitter,
              i = e("../registry"),
              o = e("../lib"),
              a = e("./helpers"),
              s = e("./cloneplot"),
              l = e("./tosvg"),
              u = e("./svgtoimg");
            t.exports = function (e, t) {
              var n = new r(),
                c = s(e, {
                  format: "png"
                }),
                d = c.gd;
              d.style.position = "absolute", d.style.left = "-5000px", document.body.appendChild(d);
              var h = a.getRedrawFunc(d);
              return i.call("plot", d, c.data, c.layout, c.config).then(h).then(function () {
                var e = a.getDelay(d._fullLayout);
                setTimeout(function () {
                  var e = l(d),
                    r = document.createElement("canvas");
                  r.id = o.randstr(), (n = u({
                    format: t.format,
                    width: d._fullLayout.width,
                    height: d._fullLayout.height,
                    canvas: r,
                    emitter: n,
                    svg: e
                  })).clean = function () {
                    d && document.body.removeChild(d);
                  };
                }, e);
              }).catch(function (e) {
                n.emit("error", e);
              }), n;
            };
          }, {
            "../lib": 495,
            "../registry": 593,
            "./cloneplot": 594,
            "./helpers": 597,
            "./svgtoimg": 599,
            "./tosvg": 601,
            events: 48
          }],
          601: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../lib"),
              o = e("../components/drawing"),
              a = e("../components/color"),
              s = e("../constants/xmlns_namespaces"),
              l = /"/g,
              u = new RegExp('("TOBESTRIPPED)|(TOBESTRIPPED")', "g");
            t.exports = function (e, t, n) {
              var c,
                d = e._fullLayout,
                h = d._paper,
                f = d._toppaper,
                p = d.width,
                m = d.height;
              h.insert("rect", ":first-child").call(o.setRect, 0, 0, p, m).call(a.fill, d.paper_bgcolor);
              var g = d._basePlotModules || [];
              for (c = 0; c < g.length; c++) {
                var v = g[c];
                v.toSVG && v.toSVG(e);
              }
              if (f) {
                var y = f.node().childNodes,
                  b = Array.prototype.slice.call(y);
                for (c = 0; c < b.length; c++) {
                  var _ = b[c];
                  _.childNodes.length && h.node().appendChild(_);
                }
              }
              if (d._draggers && d._draggers.remove(), h.node().style.background = "", h.selectAll("text").attr({
                "data-unformatted": null,
                "data-math": null
              }).each(function () {
                var e = r.select(this);
                if ("hidden" !== this.style.visibility && "none" !== this.style.display) {
                  e.style({
                    visibility: null,
                    display: null
                  });
                  var t = this.style.fontFamily;
                  t && -1 !== t.indexOf('"') && e.style("font-family", t.replace(l, "TOBESTRIPPED"));
                } else e.remove();
              }), d._gradientUrlQueryParts) {
                var x = [];
                for (var w in d._gradientUrlQueryParts) x.push(w);
                x.length && h.selectAll(x.join(",")).each(function () {
                  var e = r.select(this),
                    t = this.style.fill;
                  t && -1 !== t.indexOf("url(") && e.style("fill", t.replace(l, "TOBESTRIPPED"));
                  var n = this.style.stroke;
                  n && -1 !== n.indexOf("url(") && e.style("stroke", n.replace(l, "TOBESTRIPPED"));
                });
              }
              "pdf" !== t && "eps" !== t || h.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), h.node().setAttributeNS(s.xmlns, "xmlns", s.svg), h.node().setAttributeNS(s.xmlns, "xmlns:xlink", s.xlink), "svg" === t && n && (h.attr("width", n * p), h.attr("height", n * m), h.attr("viewBox", "0 0 " + p + " " + m));
              var S = new window.XMLSerializer().serializeToString(h.node());
              return S = (S = (S = function (e) {
                var t = r.select("body").append("div").style({
                    display: "none"
                  }).html(""),
                  n = e.replace(/(&[^;]*;)/gi, function (e) {
                    return "&lt;" === e ? "&#60;" : "&rt;" === e ? "&#62;" : -1 !== e.indexOf("<") || -1 !== e.indexOf(">") ? "" : t.html(e).text();
                  });
                return t.remove(), n;
              }(S)).replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;")).replace(u, "'"), i.isIE() && (S = (S = (S = S.replace(/"/gi, "'")).replace(/(\('#)([^']*)('\))/gi, '("#$2")')).replace(/(\\')/gi, '"')), S;
            };
          }, {
            "../components/color": 375,
            "../components/drawing": 396,
            "../constants/xmlns_namespaces": 475,
            "../lib": 495,
            d3: 82
          }],
          602: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/attributes"),
              i = e("../../plots/template_attributes").hovertemplateAttrs,
              o = e("../mesh3d/attributes"),
              a = e("../../plots/attributes"),
              s = e("../../lib/extend").extendFlat,
              l = {
                x: {
                  valType: "data_array",
                  editType: "calc+clearAxisTypes"
                },
                y: {
                  valType: "data_array",
                  editType: "calc+clearAxisTypes"
                },
                z: {
                  valType: "data_array",
                  editType: "calc+clearAxisTypes"
                },
                u: {
                  valType: "data_array",
                  editType: "calc"
                },
                v: {
                  valType: "data_array",
                  editType: "calc"
                },
                w: {
                  valType: "data_array",
                  editType: "calc"
                },
                sizemode: {
                  valType: "enumerated",
                  values: ["scaled", "absolute"],
                  editType: "calc",
                  dflt: "scaled"
                },
                sizeref: {
                  valType: "number",
                  editType: "calc",
                  min: 0
                },
                anchor: {
                  valType: "enumerated",
                  editType: "calc",
                  values: ["tip", "tail", "cm", "center"],
                  dflt: "cm"
                },
                text: {
                  valType: "string",
                  dflt: "",
                  arrayOk: !0,
                  editType: "calc"
                },
                hovertext: {
                  valType: "string",
                  dflt: "",
                  arrayOk: !0,
                  editType: "calc"
                },
                hovertemplate: i({
                  editType: "calc"
                }, {
                  keys: ["norm"]
                }),
                showlegend: s({}, a.showlegend, {
                  dflt: !1
                })
              };
            s(l, r("", {
              colorAttr: "u/v/w norm",
              showScaleDflt: !0,
              editTypeOverride: "calc"
            })), ["opacity", "lightposition", "lighting"].forEach(function (e) {
              l[e] = o[e];
            }), l.hoverinfo = s({}, a.hoverinfo, {
              editType: "calc",
              flags: ["x", "y", "z", "u", "v", "w", "norm", "text", "name"],
              dflt: "x+y+z+norm+text+name"
            }), l.transforms = void 0, t.exports = l;
          }, {
            "../../components/colorscale/attributes": 382,
            "../../lib/extend": 489,
            "../../plots/attributes": 538,
            "../../plots/template_attributes": 592,
            "../mesh3d/attributes": 614
          }],
          603: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/calc");
            t.exports = function (e, t) {
              for (var n = t.u, i = t.v, o = t.w, a = Math.min(t.x.length, t.y.length, t.z.length, n.length, i.length, o.length), s = -1 / 0, l = 1 / 0, u = 0; u < a; u++) {
                var c = n[u],
                  d = i[u],
                  h = o[u],
                  f = Math.sqrt(c * c + d * d + h * h);
                s = Math.max(s, f), l = Math.min(l, f);
              }
              t._len = a, t._normMax = s, r(e, t, {
                vals: [l, s],
                containerStr: "",
                cLetter: "c"
              });
            };
          }, {
            "../../components/colorscale/calc": 383
          }],
          604: [function (e, t, n) {
            "use strict";

            var r = e("gl-cone3d"),
              i = e("gl-cone3d").createConeMesh,
              o = e("../../lib").simpleMap,
              a = e("../../lib/gl_format_color").parseColorScale,
              s = e("../../components/colorscale").extractOpts,
              l = e("../../plots/gl3d/zip3");
            function u(e, t) {
              this.scene = e, this.uid = t, this.mesh = null, this.data = null;
            }
            var c = u.prototype;
            c.handlePick = function (e) {
              if (e.object === this.mesh) {
                var t = e.index = e.data.index,
                  n = this.data.x[t],
                  r = this.data.y[t],
                  i = this.data.z[t],
                  o = this.data.u[t],
                  a = this.data.v[t],
                  s = this.data.w[t];
                e.traceCoordinate = [n, r, i, o, a, s, Math.sqrt(o * o + a * a + s * s)];
                var l = this.data.hovertext || this.data.text;
                return Array.isArray(l) && void 0 !== l[t] ? e.textLabel = l[t] : l && (e.textLabel = l), !0;
              }
            };
            var d = {
                xaxis: 0,
                yaxis: 1,
                zaxis: 2
              },
              h = {
                tip: 1,
                tail: 0,
                cm: .25,
                center: .5
              },
              f = {
                tip: 1,
                tail: 1,
                cm: .75,
                center: .5
              };
            function p(e, t) {
              var n = e.fullSceneLayout,
                i = e.dataScale,
                u = {};
              function c(e, t) {
                var r = n[t],
                  a = i[d[t]];
                return o(e, function (e) {
                  return r.d2l(e) * a;
                });
              }
              u.vectors = l(c(t.u, "xaxis"), c(t.v, "yaxis"), c(t.w, "zaxis"), t._len), u.positions = l(c(t.x, "xaxis"), c(t.y, "yaxis"), c(t.z, "zaxis"), t._len);
              var p = s(t);
              u.colormap = a(t), u.vertexIntensityBounds = [p.min / t._normMax, p.max / t._normMax], u.coneOffset = h[t.anchor], "scaled" === t.sizemode ? u.coneSize = t.sizeref || .5 : u.coneSize = t.sizeref && t._normMax ? t.sizeref / t._normMax : .5;
              var m = r(u),
                g = t.lightposition;
              return m.lightPosition = [g.x, g.y, g.z], m.ambient = t.lighting.ambient, m.diffuse = t.lighting.diffuse, m.specular = t.lighting.specular, m.roughness = t.lighting.roughness, m.fresnel = t.lighting.fresnel, m.opacity = t.opacity, t._pad = f[t.anchor] * m.vectorScale * m.coneScale * t._normMax, m;
            }
            c.update = function (e) {
              this.data = e;
              var t = p(this.scene, e);
              this.mesh.update(t);
            }, c.dispose = function () {
              this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            }, t.exports = function (e, t) {
              var n = e.glplot.gl,
                r = p(e, t),
                o = i(n, r),
                a = new u(e, t.uid);
              return a.mesh = o, a.data = t, o._trace = a, e.glplot.add(o), a;
            };
          }, {
            "../../components/colorscale": 387,
            "../../lib": 495,
            "../../lib/gl_format_color": 493,
            "../../plots/gl3d/zip3": 581,
            "gl-cone3d": 105
          }],
          605: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../components/colorscale/defaults"),
              o = e("./attributes");
            t.exports = function (e, t, n, a) {
              function s(n, i) {
                return r.coerce(e, t, o, n, i);
              }
              var l = s("u"),
                u = s("v"),
                c = s("w"),
                d = s("x"),
                h = s("y"),
                f = s("z");
              l && l.length && u && u.length && c && c.length && d && d.length && h && h.length && f && f.length ? (s("sizeref"), s("sizemode"), s("anchor"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(e, t, a, s, {
                prefix: "",
                cLetter: "c"
              }), s("text"), s("hovertext"), s("hovertemplate"), t._length = null) : t.visible = !1;
            };
          }, {
            "../../components/colorscale/defaults": 385,
            "../../lib": 495,
            "./attributes": 602
          }],
          606: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "trace",
              name: "cone",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "showLegend"],
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              colorbar: {
                min: "cmin",
                max: "cmax"
              },
              calc: e("./calc"),
              plot: e("./convert"),
              eventData: function eventData(e, t) {
                return e.norm = t.traceCoordinate[6], e;
              },
              meta: {}
            };
          }, {
            "../../plots/gl3d": 570,
            "./attributes": 602,
            "./calc": 603,
            "./convert": 604,
            "./defaults": 605
          }],
          607: [function (e, t, n) {
            "use strict";

            var r = e("../../lib").maxRowLength;
            t.exports = function (e) {
              var t,
                n,
                i,
                o,
                a,
                s,
                l,
                u,
                c = [],
                d = {},
                h = [],
                f = e[0],
                p = [],
                m = [0, 0, 0],
                g = r(e);
              for (n = 0; n < e.length; n++) for (t = p, p = f, f = e[n + 1] || [], i = 0; i < g; i++) void 0 === p[i] && ((s = (void 0 !== p[i - 1] ? 1 : 0) + (void 0 !== p[i + 1] ? 1 : 0) + (void 0 !== t[i] ? 1 : 0) + (void 0 !== f[i] ? 1 : 0)) ? (0 === n && s++, 0 === i && s++, n === e.length - 1 && s++, i === p.length - 1 && s++, s < 4 && (d[[n, i]] = [n, i, s]), c.push([n, i, s])) : h.push([n, i]));
              for (; h.length;) {
                for (l = {}, u = !1, a = h.length - 1; a >= 0; a--) (s = ((d[[(n = (o = h[a])[0]) - 1, i = o[1]]] || m)[2] + (d[[n + 1, i]] || m)[2] + (d[[n, i - 1]] || m)[2] + (d[[n, i + 1]] || m)[2]) / 20) && (l[o] = [n, i, s], h.splice(a, 1), u = !0);
                if (!u) throw "findEmpties iterated with no new neighbors";
                for (o in l) d[o] = l[o], c.push(l[o]);
              }
              return c.sort(function (e, t) {
                return t[2] - e[2];
              });
            };
          }, {
            "../../lib": 495
          }],
          608: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = [[-1, 0], [1, 0], [0, -1], [0, 1]];
            function o(e) {
              return .5 - .25 * Math.min(1, .5 * e);
            }
            function a(e, t, n) {
              var r,
                o,
                a,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m,
                g,
                v = 0;
              for (s = 0; s < t.length; s++) {
                for (o = (r = t[s])[0], a = r[1], p = e[o][a], f = 0, h = 0, l = 0; l < 4; l++) (c = e[o + (u = i[l])[0]]) && void 0 !== (d = c[a + u[1]]) && (0 === f ? m = g = d : (m = Math.min(m, d), g = Math.max(g, d)), h++, f += d);
                if (0 === h) throw "iterateInterp2d order is wrong: no defined neighbors";
                e[o][a] = f / h, void 0 === p ? h < 4 && (v = 1) : (e[o][a] = (1 + n) * e[o][a] - n * p, g > m && (v = Math.max(v, Math.abs(e[o][a] - p) / (g - m))));
              }
              return v;
            }
            t.exports = function (e, t) {
              var n,
                i = 1;
              for (a(e, t), n = 0; n < t.length && !(t[n][2] < 4); n++);
              for (t = t.slice(n), n = 0; n < 100 && i > .01; n++) i = a(e, t, o(i));
              return i > .01 && r.log("interp2d didn't converge quickly", i), e;
            };
          }, {
            "../../lib": 495
          }],
          609: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/attributes"),
              i = e("../../plots/template_attributes").hovertemplateAttrs,
              o = e("../mesh3d/attributes"),
              a = e("../../plots/attributes"),
              s = e("../../lib/extend").extendFlat,
              l = e("../../plot_api/edit_types").overrideAll,
              u = t.exports = l(s({
                x: {
                  valType: "data_array"
                },
                y: {
                  valType: "data_array"
                },
                z: {
                  valType: "data_array"
                },
                value: {
                  valType: "data_array"
                },
                isomin: {
                  valType: "number"
                },
                isomax: {
                  valType: "number"
                },
                surface: {
                  show: {
                    valType: "boolean",
                    dflt: !0
                  },
                  count: {
                    valType: "integer",
                    dflt: 2,
                    min: 1
                  },
                  fill: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1
                  },
                  pattern: {
                    valType: "flaglist",
                    flags: ["A", "B", "C", "D", "E"],
                    extras: ["all", "odd", "even"],
                    dflt: "all"
                  }
                },
                spaceframe: {
                  show: {
                    valType: "boolean",
                    dflt: !1
                  },
                  fill: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .15
                  }
                },
                slices: {
                  x: {
                    show: {
                      valType: "boolean",
                      dflt: !1
                    },
                    locations: {
                      valType: "data_array",
                      dflt: []
                    },
                    fill: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    }
                  },
                  y: {
                    show: {
                      valType: "boolean",
                      dflt: !1
                    },
                    locations: {
                      valType: "data_array",
                      dflt: []
                    },
                    fill: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    }
                  },
                  z: {
                    show: {
                      valType: "boolean",
                      dflt: !1
                    },
                    locations: {
                      valType: "data_array",
                      dflt: []
                    },
                    fill: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    }
                  }
                },
                caps: {
                  x: {
                    show: {
                      valType: "boolean",
                      dflt: !0
                    },
                    fill: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    }
                  },
                  y: {
                    show: {
                      valType: "boolean",
                      dflt: !0
                    },
                    fill: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    }
                  },
                  z: {
                    show: {
                      valType: "boolean",
                      dflt: !0
                    },
                    fill: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    }
                  }
                },
                text: {
                  valType: "string",
                  dflt: "",
                  arrayOk: !0
                },
                hovertext: {
                  valType: "string",
                  dflt: "",
                  arrayOk: !0
                },
                hovertemplate: i(),
                showlegend: s({}, a.showlegend, {
                  dflt: !1
                })
              }, r("", {
                colorAttr: "`value`",
                showScaleDflt: !0,
                editTypeOverride: "calc"
              }), {
                opacity: o.opacity,
                lightposition: o.lightposition,
                lighting: o.lighting,
                flatshading: o.flatshading,
                contour: o.contour,
                hoverinfo: s({}, a.hoverinfo)
              }), "calc", "nested");
            u.flatshading.dflt = !0, u.lighting.facenormalsepsilon.dflt = 0, u.x.editType = u.y.editType = u.z.editType = u.value.editType = "calc+clearAxisTypes", u.transforms = void 0;
          }, {
            "../../components/colorscale/attributes": 382,
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plots/attributes": 538,
            "../../plots/template_attributes": 592,
            "../mesh3d/attributes": 614
          }],
          610: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/calc"),
              i = e("../streamtube/calc").processGrid,
              o = e("../streamtube/calc").filter;
            t.exports = function (e, t) {
              t._len = Math.min(t.x.length, t.y.length, t.z.length, t.value.length), t._x = o(t.x, t._len), t._y = o(t.y, t._len), t._z = o(t.z, t._len), t._value = o(t.value, t._len);
              var n = i(t);
              t._gridFill = n.fill, t._Xs = n.Xs, t._Ys = n.Ys, t._Zs = n.Zs, t._len = n.len;
              for (var a = 1 / 0, s = -1 / 0, l = 0; l < t._len; l++) {
                var u = t._value[l];
                a = Math.min(a, u), s = Math.max(s, u);
              }
              t._minValues = a, t._maxValues = s, t._vMin = void 0 === t.isomin || null === t.isomin ? a : t.isomin, t._vMax = void 0 === t.isomax || null === t.isomin ? s : t.isomax, r(e, t, {
                vals: [t._vMin, t._vMax],
                containerStr: "",
                cLetter: "c"
              });
            };
          }, {
            "../../components/colorscale/calc": 383,
            "../streamtube/calc": 656
          }],
          611: [function (e, t, n) {
            "use strict";

            var r = e("gl-mesh3d"),
              i = e("../../lib/gl_format_color").parseColorScale,
              o = e("../../lib/str2rgbarray"),
              a = e("../../components/colorscale").extractOpts,
              s = e("../../plots/gl3d/zip3"),
              l = function l(e, t) {
                for (var n = t.length - 1; n > 0; n--) {
                  var r = Math.min(t[n], t[n - 1]),
                    i = Math.max(t[n], t[n - 1]);
                  if (i > r && r < e && e <= i) return {
                    id: n,
                    distRatio: (i - e) / (i - r)
                  };
                }
                return {
                  id: 0,
                  distRatio: 0
                };
              };
            function u(e, t, n) {
              this.scene = e, this.uid = n, this.mesh = t, this.name = "", this.data = null, this.showContour = !1;
            }
            var c = u.prototype;
            c.handlePick = function (e) {
              if (e.object === this.mesh) {
                var t = e.data.index,
                  n = this.data._meshX[t],
                  r = this.data._meshY[t],
                  i = this.data._meshZ[t],
                  o = this.data._Ys.length,
                  a = this.data._Zs.length,
                  s = l(n, this.data._Xs).id,
                  u = l(r, this.data._Ys).id,
                  c = l(i, this.data._Zs).id,
                  d = e.index = c + a * u + a * o * s;
                e.traceCoordinate = [this.data._meshX[d], this.data._meshY[d], this.data._meshZ[d], this.data._value[d]];
                var h = this.data.hovertext || this.data.text;
                return Array.isArray(h) && void 0 !== h[d] ? e.textLabel = h[d] : h && (e.textLabel = h), !0;
              }
            }, c.update = function (e) {
              var t = this.scene,
                n = t.fullSceneLayout;
              function r(e, t, n, r) {
                return t.map(function (t) {
                  return e.d2l(t, 0, r) * n;
                });
              }
              this.data = h(e);
              var l = {
                  positions: s(r(n.xaxis, e._meshX, t.dataScale[0], e.xcalendar), r(n.yaxis, e._meshY, t.dataScale[1], e.ycalendar), r(n.zaxis, e._meshZ, t.dataScale[2], e.zcalendar)),
                  cells: s(e._meshI, e._meshJ, e._meshK),
                  lightPosition: [e.lightposition.x, e.lightposition.y, e.lightposition.z],
                  ambient: e.lighting.ambient,
                  diffuse: e.lighting.diffuse,
                  specular: e.lighting.specular,
                  roughness: e.lighting.roughness,
                  fresnel: e.lighting.fresnel,
                  vertexNormalsEpsilon: e.lighting.vertexnormalsepsilon,
                  faceNormalsEpsilon: e.lighting.facenormalsepsilon,
                  opacity: e.opacity,
                  contourEnable: e.contour.show,
                  contourColor: o(e.contour.color).slice(0, 3),
                  contourWidth: e.contour.width,
                  useFacetNormals: e.flatshading
                },
                u = a(e);
              l.vertexIntensity = e._meshIntensity, l.vertexIntensityBounds = [u.min, u.max], l.colormap = i(e), this.mesh.update(l);
            }, c.dispose = function () {
              this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            };
            var d = ["xyz", "xzy", "yxz", "yzx", "zxy", "zyx"];
            function h(e) {
              e._meshI = [], e._meshJ = [], e._meshK = [];
              var t,
                n,
                r,
                i,
                o,
                a,
                s,
                u = e.surface.show,
                c = e.spaceframe.show,
                h = e.surface.fill,
                f = e.spaceframe.fill,
                p = !1,
                m = !1,
                g = 0,
                v = e._Xs,
                y = e._Ys,
                b = e._Zs,
                _ = v.length,
                x = y.length,
                w = b.length,
                S = d.indexOf(e._gridFill.replace(/-/g, "").replace(/\+/g, "")),
                A = function A(e, t, n) {
                  switch (S) {
                    case 5:
                      return n + w * t + w * x * e;
                    case 4:
                      return n + w * e + w * _ * t;
                    case 3:
                      return t + x * n + x * w * e;
                    case 2:
                      return t + x * e + x * _ * n;
                    case 1:
                      return e + _ * n + _ * w * t;
                    default:
                      return e + _ * t + _ * x * n;
                  }
                },
                E = e._minValues,
                T = e._maxValues,
                M = e._vMin,
                C = e._vMax;
              function k(e, t, s) {
                for (var l = a.length, u = n; u < l; u++) if (e === r[u] && t === i[u] && s === o[u]) return u;
                return -1;
              }
              function P() {
                n = t;
              }
              function O() {
                r = [], i = [], o = [], a = [], t = 0, P();
              }
              function R(e, n, s, l) {
                return r.push(e), i.push(n), o.push(s), a.push(l), ++t - 1;
              }
              function I(e, t, n) {
                for (var r = [], i = 0; i < e.length; i++) r[i] = e[i] * (1 - n) + n * t[i];
                return r;
              }
              function j(e) {
                s = e;
              }
              function N(e, t) {
                return "all" === e || null === e || e.indexOf(t) > -1;
              }
              function L(e, t) {
                return null === e ? t : e;
              }
              function D(t, n, r) {
                P();
                var i,
                  o,
                  a,
                  l = [n],
                  u = [r];
                if (s >= 1) l = [n], u = [r];else if (s > 0) {
                  var c = function (e, t) {
                    var n = e[0],
                      r = e[1],
                      i = e[2],
                      o = function (e, t, n) {
                        for (var r = [], i = 0; i < e.length; i++) r[i] = (e[i] + t[i] + n[i]) / 3;
                        return r;
                      }(n, r, i),
                      a = Math.sqrt(1 - s),
                      l = I(o, n, a),
                      u = I(o, r, a),
                      c = I(o, i, a),
                      d = t[0],
                      h = t[1],
                      f = t[2];
                    return {
                      xyzv: [[n, r, u], [u, l, n], [r, i, c], [c, u, r], [i, n, l], [l, c, i]],
                      abc: [[d, h, -1], [-1, -1, d], [h, f, -1], [-1, -1, h], [f, d, -1], [-1, -1, f]]
                    };
                  }(n, r);
                  l = c.xyzv, u = c.abc;
                }
                for (var d = 0; d < l.length; d++) {
                  n = l[d], r = u[d];
                  for (var h = [], f = 0; f < 3; f++) {
                    var p = n[f][0],
                      m = n[f][1],
                      v = n[f][2],
                      y = n[f][3],
                      b = r[f] > -1 ? r[f] : k(p, m, v);
                    h[f] = b > -1 ? b : R(p, m, v, L(t, y));
                  }
                  i = h[0], o = h[1], a = h[2], e._meshI.push(i), e._meshJ.push(o), e._meshK.push(a), ++g;
                }
              }
              function B(e, t, n, r) {
                var i = e[3];
                i < n && (i = n), i > r && (i = r);
                for (var o = (e[3] - i) / (e[3] - t[3] + 1e-9), a = [], s = 0; s < 4; s++) a[s] = (1 - o) * e[s] + o * t[s];
                return a;
              }
              function F(e, t, n) {
                return e >= t && e <= n;
              }
              function z(e) {
                var t = .001 * (C - M);
                return e >= M - t && e <= C + t;
              }
              function U(t) {
                for (var n = [], r = 0; r < 4; r++) {
                  var i = t[r];
                  n.push([e._x[i], e._y[i], e._z[i], e._value[i]]);
                }
                return n;
              }
              function G(e, t, n, r, i, o) {
                o || (o = 1), n = [-1, -1, -1];
                var a = !1,
                  s = [F(t[0][3], r, i), F(t[1][3], r, i), F(t[2][3], r, i)];
                if (!s[0] && !s[1] && !s[2]) return !1;
                var l = function l(e, t, n) {
                  return z(t[0][3]) && z(t[1][3]) && z(t[2][3]) ? (D(e, t, n), !0) : o < 3 && G(e, t, n, M, C, ++o);
                };
                if (s[0] && s[1] && s[2]) return l(e, t, n) || a;
                var u = !1;
                return [[0, 1, 2], [2, 0, 1], [1, 2, 0]].forEach(function (o) {
                  if (s[o[0]] && s[o[1]] && !s[o[2]]) {
                    var c = t[o[0]],
                      d = t[o[1]],
                      h = t[o[2]],
                      f = B(h, c, r, i),
                      p = B(h, d, r, i);
                    a = l(e, [p, f, c], [-1, -1, n[o[0]]]) || a, a = l(e, [c, d, p], [n[o[0]], n[o[1]], -1]) || a, u = !0;
                  }
                }), u || [[0, 1, 2], [1, 2, 0], [2, 0, 1]].forEach(function (o) {
                  if (s[o[0]] && !s[o[1]] && !s[o[2]]) {
                    var c = t[o[0]],
                      d = t[o[1]],
                      h = t[o[2]],
                      f = B(d, c, r, i),
                      p = B(h, c, r, i);
                    a = l(e, [p, f, c], [-1, -1, n[o[0]]]) || a, u = !0;
                  }
                }), a;
              }
              function V(e, t, n, r) {
                var i = !1,
                  o = U(t),
                  a = [F(o[0][3], n, r), F(o[1][3], n, r), F(o[2][3], n, r), F(o[3][3], n, r)];
                if (!(a[0] || a[1] || a[2] || a[3])) return i;
                if (a[0] && a[1] && a[2] && a[3]) return m && (i = function (e, t, n) {
                  var r = function r(_r9, i, o) {
                    D(e, [t[_r9], t[i], t[o]], [n[_r9], n[i], n[o]]);
                  };
                  r(0, 1, 2), r(3, 0, 1), r(2, 3, 0), r(1, 2, 3);
                }(e, o, t) || i), i;
                var s = !1;
                return [[0, 1, 2, 3], [3, 0, 1, 2], [2, 3, 0, 1], [1, 2, 3, 0]].forEach(function (l) {
                  if (a[l[0]] && a[l[1]] && a[l[2]] && !a[l[3]]) {
                    var u = o[l[0]],
                      c = o[l[1]],
                      d = o[l[2]],
                      h = o[l[3]];
                    if (m) i = D(e, [u, c, d], [t[l[0]], t[l[1]], t[l[2]]]) || i;else {
                      var f = B(h, u, n, r),
                        p = B(h, c, n, r),
                        g = B(h, d, n, r);
                      i = D(null, [f, p, g], [-1, -1, -1]) || i;
                    }
                    s = !0;
                  }
                }), s || ([[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2], [0, 2, 3, 1], [1, 3, 2, 0]].forEach(function (l) {
                  if (a[l[0]] && a[l[1]] && !a[l[2]] && !a[l[3]]) {
                    var u = o[l[0]],
                      c = o[l[1]],
                      d = o[l[2]],
                      h = o[l[3]],
                      f = B(d, u, n, r),
                      p = B(d, c, n, r),
                      g = B(h, c, n, r),
                      v = B(h, u, n, r);
                    m ? (i = D(e, [u, v, f], [t[l[0]], -1, -1]) || i, i = D(e, [c, p, g], [t[l[1]], -1, -1]) || i) : i = function (e, t, n) {
                      var r = function r(e, _r10, i) {
                        D(null, [t[e], t[_r10], t[i]], [n[e], n[_r10], n[i]]);
                      };
                      r(0, 1, 2), r(2, 3, 0);
                    }(0, [f, p, g, v], [-1, -1, -1, -1]) || i, s = !0;
                  }
                }), s || [[0, 1, 2, 3], [1, 2, 3, 0], [2, 3, 0, 1], [3, 0, 1, 2]].forEach(function (l) {
                  if (a[l[0]] && !a[l[1]] && !a[l[2]] && !a[l[3]]) {
                    var u = o[l[0]],
                      c = o[l[1]],
                      d = o[l[2]],
                      h = o[l[3]],
                      f = B(c, u, n, r),
                      p = B(d, u, n, r),
                      g = B(h, u, n, r);
                    m ? (i = D(e, [u, f, p], [t[l[0]], -1, -1]) || i, i = D(e, [u, p, g], [t[l[0]], -1, -1]) || i, i = D(e, [u, g, f], [t[l[0]], -1, -1]) || i) : i = D(null, [f, p, g], [-1, -1, -1]) || i, s = !0;
                  }
                })), i;
              }
              function H(e, t, n, r, i, o, a, s, l, u, c) {
                var d = !1;
                return p && (N(e, "A") && (d = V(null, [t, n, r, o], u, c) || d), N(e, "B") && (d = V(null, [n, r, i, l], u, c) || d), N(e, "C") && (d = V(null, [n, o, a, l], u, c) || d), N(e, "D") && (d = V(null, [r, o, s, l], u, c) || d), N(e, "E") && (d = V(null, [n, r, o, l], u, c) || d)), m && (d = V(e, [n, r, o, l], u, c) || d), d;
              }
              function q(e, t, n, r, i, o, a, s) {
                return [!0 === s[0] || G(e, U([t, n, r]), [t, n, r], o, a), !0 === s[1] || G(e, U([r, i, t]), [r, i, t], o, a)];
              }
              function W(e, t, n, r, i, o, a, s, l) {
                return s ? q(e, t, n, i, r, o, a, l) : q(e, n, i, r, t, o, a, l);
              }
              function $(e, t, n, r, i, o, a) {
                var s,
                  l,
                  u,
                  c,
                  d = !1,
                  h = function h() {
                    d = G(e, [s, l, u], [-1, -1, -1], i, o) || d, d = G(e, [u, c, s], [-1, -1, -1], i, o) || d;
                  },
                  f = a[0],
                  p = a[1],
                  m = a[2];
                return f && (s = I(U([A(t, n - 0, r - 0)])[0], U([A(t - 1, n - 0, r - 0)])[0], f), l = I(U([A(t, n - 0, r - 1)])[0], U([A(t - 1, n - 0, r - 1)])[0], f), u = I(U([A(t, n - 1, r - 1)])[0], U([A(t - 1, n - 1, r - 1)])[0], f), c = I(U([A(t, n - 1, r - 0)])[0], U([A(t - 1, n - 1, r - 0)])[0], f), h()), p && (s = I(U([A(t - 0, n, r - 0)])[0], U([A(t - 0, n - 1, r - 0)])[0], p), l = I(U([A(t - 0, n, r - 1)])[0], U([A(t - 0, n - 1, r - 1)])[0], p), u = I(U([A(t - 1, n, r - 1)])[0], U([A(t - 1, n - 1, r - 1)])[0], p), c = I(U([A(t - 1, n, r - 0)])[0], U([A(t - 1, n - 1, r - 0)])[0], p), h()), m && (s = I(U([A(t - 0, n - 0, r)])[0], U([A(t - 0, n - 0, r - 1)])[0], m), l = I(U([A(t - 0, n - 1, r)])[0], U([A(t - 0, n - 1, r - 1)])[0], m), u = I(U([A(t - 1, n - 1, r)])[0], U([A(t - 1, n - 1, r - 1)])[0], m), c = I(U([A(t - 1, n - 0, r)])[0], U([A(t - 1, n - 0, r - 1)])[0], m), h()), d;
              }
              function X(e, t, n, r, i, o, a, s, l, u, c, d) {
                var h = e;
                return d ? (p && "even" === e && (h = null), H(h, t, n, r, i, o, a, s, l, u, c)) : (p && "odd" === e && (h = null), H(h, l, s, a, o, i, r, n, t, u, c));
              }
              function Y(e, t, n, r, i) {
                for (var o = [], a = 0, s = 0; s < t.length; s++) for (var l = t[s], u = 1; u < w; u++) for (var c = 1; c < x; c++) o.push(W(e, A(l, c - 1, u - 1), A(l, c - 1, u), A(l, c, u - 1), A(l, c, u), n, r, (l + c + u) % 2, i && i[a] ? i[a] : [])), a++;
                return o;
              }
              function K(e, t, n, r, i) {
                for (var o = [], a = 0, s = 0; s < t.length; s++) for (var l = t[s], u = 1; u < _; u++) for (var c = 1; c < w; c++) o.push(W(e, A(u - 1, l, c - 1), A(u, l, c - 1), A(u - 1, l, c), A(u, l, c), n, r, (u + l + c) % 2, i && i[a] ? i[a] : [])), a++;
                return o;
              }
              function Z(e, t, n, r, i) {
                for (var o = [], a = 0, s = 0; s < t.length; s++) for (var l = t[s], u = 1; u < x; u++) for (var c = 1; c < _; c++) o.push(W(e, A(c - 1, u - 1, l), A(c - 1, u, l), A(c, u - 1, l), A(c, u, l), n, r, (c + u + l) % 2, i && i[a] ? i[a] : [])), a++;
                return o;
              }
              function Q(e, t, n) {
                for (var r = 1; r < w; r++) for (var i = 1; i < x; i++) for (var o = 1; o < _; o++) X(e, A(o - 1, i - 1, r - 1), A(o - 1, i - 1, r), A(o - 1, i, r - 1), A(o - 1, i, r), A(o, i - 1, r - 1), A(o, i - 1, r), A(o, i, r - 1), A(o, i, r), t, n, (o + i + r) % 2);
              }
              function J(e, t, n) {
                p = !0, Q(e, t, n), p = !1;
              }
              function ee(e, t, n, r, i, o) {
                for (var a = [], s = 0, l = 0; l < t.length; l++) for (var u = t[l], c = 1; c < w; c++) for (var d = 1; d < x; d++) a.push($(e, u, d, c, n, r, i[l], o && o[s] && o[s])), s++;
                return a;
              }
              function te(e, t, n, r, i, o) {
                for (var a = [], s = 0, l = 0; l < t.length; l++) for (var u = t[l], c = 1; c < _; c++) for (var d = 1; d < w; d++) a.push($(e, c, u, d, n, r, i[l], o && o[s] && o[s])), s++;
                return a;
              }
              function ne(e, t, n, r, i, o) {
                for (var a = [], s = 0, l = 0; l < t.length; l++) for (var u = t[l], c = 1; c < x; c++) for (var d = 1; d < _; d++) a.push($(e, d, c, u, n, r, i[l], o && o[s] && o[s])), s++;
                return a;
              }
              function re(e, t) {
                for (var n = [], r = e; r < t; r++) n.push(r);
                return n;
              }
              return function () {
                if (O(), function () {
                  for (var t = 0; t < _; t++) for (var n = 0; n < x; n++) for (var r = 0; r < w; r++) {
                    var i = A(t, n, r);
                    R(e._x[i], e._y[i], e._z[i], e._value[i]);
                  }
                }(), c && f && (j(f), m = !0, Q(null, M, C), m = !1), u && h) {
                  j(h);
                  for (var t = e.surface.pattern, n = e.surface.count, s = 0; s < n; s++) {
                    var d = 1 === n ? .5 : s / (n - 1),
                      p = (1 - d) * M + d * C,
                      S = Math.abs(p - E) > Math.abs(p - T) ? [E, p] : [p, T];
                    J(t, S[0], S[1]);
                  }
                }
                var k = [[Math.min(M, T), Math.max(M, T)], [Math.min(E, C), Math.max(E, C)]];
                ["x", "y", "z"].forEach(function (t) {
                  for (var n = [], r = 0; r < k.length; r++) {
                    var i = 0,
                      o = k[r][0],
                      a = k[r][1],
                      s = e.slices[t];
                    if (s.show && s.fill) {
                      j(s.fill);
                      var u = [],
                        c = [],
                        d = [];
                      if (s.locations.length) for (var h = 0; h < s.locations.length; h++) {
                        var f = l(s.locations[h], "x" === t ? v : "y" === t ? y : b);
                        0 === f.distRatio ? u.push(f.id) : f.id > 0 && (c.push(f.id), "x" === t ? d.push([f.distRatio, 0, 0]) : "y" === t ? d.push([0, f.distRatio, 0]) : d.push([0, 0, f.distRatio]));
                      } else u = re(1, "x" === t ? _ - 1 : "y" === t ? x - 1 : w - 1);
                      c.length > 0 && (n[i] = "x" === t ? ee(null, c, o, a, d, n[i]) : "y" === t ? te(null, c, o, a, d, n[i]) : ne(null, c, o, a, d, n[i]), i++), u.length > 0 && (n[i] = "x" === t ? Y(null, u, o, a, n[i]) : "y" === t ? K(null, u, o, a, n[i]) : Z(null, u, o, a, n[i]), i++);
                    }
                    var p = e.caps[t];
                    p.show && p.fill && (j(p.fill), n[i] = "x" === t ? Y(null, [0, _ - 1], o, a, n[i]) : "y" === t ? K(null, [0, x - 1], o, a, n[i]) : Z(null, [0, w - 1], o, a, n[i]), i++);
                  }
                }), 0 === g && O(), e._meshX = r, e._meshY = i, e._meshZ = o, e._meshIntensity = a, e._Xs = v, e._Ys = y, e._Zs = b;
              }(), e;
            }
            t.exports = {
              findNearestOnAxis: l,
              generateIsoMeshes: h,
              createIsosurfaceTrace: function createIsosurfaceTrace(e, t) {
                var n = e.glplot.gl,
                  i = r({
                    gl: n
                  }),
                  o = new u(e, i, t.uid);
                return i._trace = o, o.update(t), e.glplot.add(i), o;
              }
            };
          }, {
            "../../components/colorscale": 387,
            "../../lib/gl_format_color": 493,
            "../../lib/str2rgbarray": 517,
            "../../plots/gl3d/zip3": 581,
            "gl-mesh3d": 140
          }],
          612: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../registry"),
              o = e("./attributes"),
              a = e("../../components/colorscale/defaults");
            function s(e, t, n, r, o) {
              var s = o("isomin"),
                l = o("isomax");
              null != l && null != s && s > l && (t.isomin = null, t.isomax = null);
              var u = o("x"),
                c = o("y"),
                d = o("z"),
                h = o("value");
              u && u.length && c && c.length && d && d.length && h && h.length ? (i.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y", "z"], r), ["x", "y", "z"].forEach(function (e) {
                var t = "caps." + e;
                o(t + ".show") && o(t + ".fill");
                var n = "slices." + e;
                o(n + ".show") && (o(n + ".fill"), o(n + ".locations"));
              }), o("spaceframe.show") && o("spaceframe.fill"), o("surface.show") && (o("surface.count"), o("surface.fill"), o("surface.pattern")), o("contour.show") && (o("contour.color"), o("contour.width")), ["text", "hovertext", "hovertemplate", "lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lighting.vertexnormalsepsilon", "lighting.facenormalsepsilon", "lightposition.x", "lightposition.y", "lightposition.z", "flatshading", "opacity"].forEach(function (e) {
                o(e);
              }), a(e, t, r, o, {
                prefix: "",
                cLetter: "c"
              }), t._length = null) : t.visible = !1;
            }
            t.exports = {
              supplyDefaults: function supplyDefaults(e, t, n, i) {
                s(e, t, 0, i, function (n, i) {
                  return r.coerce(e, t, o, n, i);
                });
              },
              supplyIsoDefaults: s
            };
          }, {
            "../../components/colorscale/defaults": 385,
            "../../lib": 495,
            "../../registry": 593,
            "./attributes": 609
          }],
          613: [function (e, t, n) {
            "use strict";

            t.exports = {
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults").supplyDefaults,
              calc: e("./calc"),
              colorbar: {
                min: "cmin",
                max: "cmax"
              },
              plot: e("./convert").createIsosurfaceTrace,
              moduleType: "trace",
              name: "isosurface",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "showLegend"],
              meta: {}
            };
          }, {
            "../../plots/gl3d": 570,
            "./attributes": 609,
            "./calc": 610,
            "./convert": 611,
            "./defaults": 612
          }],
          614: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/attributes"),
              i = e("../../plots/template_attributes").hovertemplateAttrs,
              o = e("../surface/attributes"),
              a = e("../../plots/attributes"),
              s = e("../../lib/extend").extendFlat;
            t.exports = s({
              x: {
                valType: "data_array",
                editType: "calc+clearAxisTypes"
              },
              y: {
                valType: "data_array",
                editType: "calc+clearAxisTypes"
              },
              z: {
                valType: "data_array",
                editType: "calc+clearAxisTypes"
              },
              i: {
                valType: "data_array",
                editType: "calc"
              },
              j: {
                valType: "data_array",
                editType: "calc"
              },
              k: {
                valType: "data_array",
                editType: "calc"
              },
              text: {
                valType: "string",
                dflt: "",
                arrayOk: !0,
                editType: "calc"
              },
              hovertext: {
                valType: "string",
                dflt: "",
                arrayOk: !0,
                editType: "calc"
              },
              hovertemplate: i({
                editType: "calc"
              }),
              delaunayaxis: {
                valType: "enumerated",
                values: ["x", "y", "z"],
                dflt: "z",
                editType: "calc"
              },
              alphahull: {
                valType: "number",
                dflt: -1,
                editType: "calc"
              },
              intensity: {
                valType: "data_array",
                editType: "calc"
              },
              intensitymode: {
                valType: "enumerated",
                values: ["vertex", "cell"],
                dflt: "vertex",
                editType: "calc"
              },
              color: {
                valType: "color",
                editType: "calc"
              },
              vertexcolor: {
                valType: "data_array",
                editType: "calc"
              },
              facecolor: {
                valType: "data_array",
                editType: "calc"
              },
              transforms: void 0
            }, r("", {
              colorAttr: "`intensity`",
              showScaleDflt: !0,
              editTypeOverride: "calc"
            }), {
              opacity: o.opacity,
              flatshading: {
                valType: "boolean",
                dflt: !1,
                editType: "calc"
              },
              contour: {
                show: s({}, o.contours.x.show, {}),
                color: o.contours.x.color,
                width: o.contours.x.width,
                editType: "calc"
              },
              lightposition: {
                x: s({}, o.lightposition.x, {
                  dflt: 1e5
                }),
                y: s({}, o.lightposition.y, {
                  dflt: 1e5
                }),
                z: s({}, o.lightposition.z, {
                  dflt: 0
                }),
                editType: "calc"
              },
              lighting: s({
                vertexnormalsepsilon: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: 1e-12,
                  editType: "calc"
                },
                facenormalsepsilon: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: 1e-6,
                  editType: "calc"
                },
                editType: "calc"
              }, o.lighting),
              hoverinfo: s({}, a.hoverinfo, {
                editType: "calc"
              }),
              showlegend: s({}, a.showlegend, {
                dflt: !1
              })
            });
          }, {
            "../../components/colorscale/attributes": 382,
            "../../lib/extend": 489,
            "../../plots/attributes": 538,
            "../../plots/template_attributes": 592,
            "../surface/attributes": 660
          }],
          615: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/calc");
            t.exports = function (e, t) {
              t.intensity && r(e, t, {
                vals: t.intensity,
                containerStr: "",
                cLetter: "c"
              });
            };
          }, {
            "../../components/colorscale/calc": 383
          }],
          616: [function (e, t, n) {
            "use strict";

            var r = e("gl-mesh3d"),
              i = e("delaunay-triangulate"),
              o = e("alpha-shape"),
              a = e("convex-hull"),
              s = e("../../lib/gl_format_color").parseColorScale,
              l = e("../../lib/str2rgbarray"),
              u = e("../../components/colorscale").extractOpts,
              c = e("../../plots/gl3d/zip3");
            function d(e, t, n) {
              this.scene = e, this.uid = n, this.mesh = t, this.name = "", this.color = "#fff", this.data = null, this.showContour = !1;
            }
            var h = d.prototype;
            function f(e) {
              for (var t = [], n = e.length, r = 0; r < n; r++) t[r] = l(e[r]);
              return t;
            }
            function p(e, t, n, r) {
              for (var i = [], o = t.length, a = 0; a < o; a++) i[a] = e.d2l(t[a], 0, r) * n;
              return i;
            }
            function m(e) {
              for (var t = [], n = e.length, r = 0; r < n; r++) t[r] = Math.round(e[r]);
              return t;
            }
            function g(e, t) {
              for (var n = e.length, r = 0; r < n; r++) if (e[r] <= -.5 || e[r] >= t - .5) return !1;
              return !0;
            }
            h.handlePick = function (e) {
              if (e.object === this.mesh) {
                var t = e.index = e.data.index;
                e.data._cellCenter ? e.traceCoordinate = e.data.dataCoordinate : e.traceCoordinate = [this.data.x[t], this.data.y[t], this.data.z[t]];
                var n = this.data.hovertext || this.data.text;
                return Array.isArray(n) && void 0 !== n[t] ? e.textLabel = n[t] : n && (e.textLabel = n), !0;
              }
            }, h.update = function (e) {
              var t = this.scene,
                n = t.fullSceneLayout;
              this.data = e;
              var r,
                d = e.x.length,
                h = c(p(n.xaxis, e.x, t.dataScale[0], e.xcalendar), p(n.yaxis, e.y, t.dataScale[1], e.ycalendar), p(n.zaxis, e.z, t.dataScale[2], e.zcalendar));
              if (e.i && e.j && e.k) {
                if (e.i.length !== e.j.length || e.j.length !== e.k.length || !g(e.i, d) || !g(e.j, d) || !g(e.k, d)) return;
                r = c(m(e.i), m(e.j), m(e.k));
              } else r = 0 === e.alphahull ? a(h) : e.alphahull > 0 ? o(e.alphahull, h) : function (e, t) {
                for (var n = ["x", "y", "z"].indexOf(e), r = [], o = t.length, a = 0; a < o; a++) r[a] = [t[a][(n + 1) % 3], t[a][(n + 2) % 3]];
                return i(r);
              }(e.delaunayaxis, h);
              var v = {
                positions: h,
                cells: r,
                lightPosition: [e.lightposition.x, e.lightposition.y, e.lightposition.z],
                ambient: e.lighting.ambient,
                diffuse: e.lighting.diffuse,
                specular: e.lighting.specular,
                roughness: e.lighting.roughness,
                fresnel: e.lighting.fresnel,
                vertexNormalsEpsilon: e.lighting.vertexnormalsepsilon,
                faceNormalsEpsilon: e.lighting.facenormalsepsilon,
                opacity: e.opacity,
                contourEnable: e.contour.show,
                contourColor: l(e.contour.color).slice(0, 3),
                contourWidth: e.contour.width,
                useFacetNormals: e.flatshading
              };
              if (e.intensity) {
                var y = u(e);
                this.color = "#fff";
                var b = e.intensitymode;
                v[b + "Intensity"] = e.intensity, v[b + "IntensityBounds"] = [y.min, y.max], v.colormap = s(e);
              } else e.vertexcolor ? (this.color = e.vertexcolor[0], v.vertexColors = f(e.vertexcolor)) : e.facecolor ? (this.color = e.facecolor[0], v.cellColors = f(e.facecolor)) : (this.color = e.color, v.meshColor = l(e.color));
              this.mesh.update(v);
            }, h.dispose = function () {
              this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            }, t.exports = function (e, t) {
              var n = e.glplot.gl,
                i = r({
                  gl: n
                }),
                o = new d(e, i, t.uid);
              return i._trace = o, o.update(t), e.glplot.add(i), o;
            };
          }, {
            "../../components/colorscale": 387,
            "../../lib/gl_format_color": 493,
            "../../lib/str2rgbarray": 517,
            "../../plots/gl3d/zip3": 581,
            "alpha-shape": 16,
            "convex-hull": 73,
            "delaunay-triangulate": 84,
            "gl-mesh3d": 140
          }],
          617: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib"),
              o = e("../../components/colorscale/defaults"),
              a = e("./attributes");
            t.exports = function (e, t, n, s) {
              function l(n, r) {
                return i.coerce(e, t, a, n, r);
              }
              function u(e) {
                var t = e.map(function (e) {
                  var t = l(e);
                  return t && i.isArrayOrTypedArray(t) ? t : null;
                });
                return t.every(function (e) {
                  return e && e.length === t[0].length;
                }) && t;
              }
              u(["x", "y", "z"]) ? (u(["i", "j", "k"]), (!t.i || t.j && t.k) && (!t.j || t.k && t.i) && (!t.k || t.i && t.j) ? (r.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y", "z"], s), ["lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lighting.vertexnormalsepsilon", "lighting.facenormalsepsilon", "lightposition.x", "lightposition.y", "lightposition.z", "flatshading", "alphahull", "delaunayaxis", "opacity"].forEach(function (e) {
                l(e);
              }), l("contour.show") && (l("contour.color"), l("contour.width")), "intensity" in e ? (l("intensity"), l("intensitymode"), o(e, t, s, l, {
                prefix: "",
                cLetter: "c"
              })) : (t.showscale = !1, "facecolor" in e ? l("facecolor") : "vertexcolor" in e ? l("vertexcolor") : l("color", n)), l("text"), l("hovertext"), l("hovertemplate"), t._length = null) : t.visible = !1) : t.visible = !1;
            };
          }, {
            "../../components/colorscale/defaults": 385,
            "../../lib": 495,
            "../../registry": 593,
            "./attributes": 614
          }],
          618: [function (e, t, n) {
            "use strict";

            t.exports = {
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              calc: e("./calc"),
              colorbar: {
                min: "cmin",
                max: "cmax"
              },
              plot: e("./convert"),
              moduleType: "trace",
              name: "mesh3d",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "showLegend"],
              meta: {}
            };
          }, {
            "../../plots/gl3d": 570,
            "./attributes": 614,
            "./calc": 615,
            "./convert": 616,
            "./defaults": 617
          }],
          619: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            n.formatPiePercent = function (e, t) {
              var n = (100 * e).toPrecision(3);
              return -1 !== n.lastIndexOf(".") && (n = n.replace(/[.]?0+$/, "")), r.numSeparate(n, t) + "%";
            }, n.formatPieValue = function (e, t) {
              var n = e.toPrecision(10);
              return -1 !== n.lastIndexOf(".") && (n = n.replace(/[.]?0+$/, "")), r.numSeparate(n, t);
            }, n.getFirstFilled = function (e, t) {
              if (Array.isArray(e)) for (var n = 0; n < t.length; n++) {
                var r = e[t[n]];
                if (r || 0 === r || "" === r) return r;
              }
            }, n.castOption = function (e, t) {
              return Array.isArray(e) ? n.getFirstFilled(e, t) : e || void 0;
            };
          }, {
            "../../lib": 495
          }],
          620: [function (e, t, n) {
            "use strict";

            var r = e("../../components/color"),
              i = e("./helpers").castOption;
            t.exports = function (e, t, n) {
              var o = n.marker.line,
                a = i(o.color, t.pts) || r.defaultLine,
                s = i(o.width, t.pts) || 0;
              e.style("stroke-width", s).call(r.fill, t.color).call(r.stroke, a);
            };
          }, {
            "../../components/color": 375,
            "./helpers": 619
          }],
          621: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            t.exports = function (e, t) {
              for (var n = 0; n < e.length; n++) e[n].i = n;
              r.mergeArray(t.text, e, "tx"), r.mergeArray(t.texttemplate, e, "txt"), r.mergeArray(t.hovertext, e, "htx"), r.mergeArray(t.customdata, e, "data"), r.mergeArray(t.textposition, e, "tp"), t.textfont && (r.mergeArrayCastPositive(t.textfont.size, e, "ts"), r.mergeArray(t.textfont.color, e, "tc"), r.mergeArray(t.textfont.family, e, "tf"));
              var i = t.marker;
              if (i) {
                r.mergeArrayCastPositive(i.size, e, "ms"), r.mergeArrayCastPositive(i.opacity, e, "mo"), r.mergeArray(i.symbol, e, "mx"), r.mergeArray(i.color, e, "mc");
                var o = i.line;
                i.line && (r.mergeArray(o.color, e, "mlc"), r.mergeArrayCastPositive(o.width, e, "mlw"));
                var a = i.gradient;
                a && "none" !== a.type && (r.mergeArray(a.type, e, "mgt"), r.mergeArray(a.color, e, "mgc"));
              }
            };
          }, {
            "../../lib": 495
          }],
          622: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/template_attributes").texttemplateAttrs,
              i = e("../../plots/template_attributes").hovertemplateAttrs,
              o = e("../../components/colorscale/attributes"),
              a = e("../../plots/font_attributes"),
              s = e("../../components/drawing/attributes").dash,
              l = e("../../components/drawing"),
              u = e("./constants"),
              c = e("../../lib/extend").extendFlat;
            t.exports = {
              x: {
                valType: "data_array",
                editType: "calc+clearAxisTypes",
                anim: !0
              },
              x0: {
                valType: "any",
                dflt: 0,
                editType: "calc+clearAxisTypes",
                anim: !0
              },
              dx: {
                valType: "number",
                dflt: 1,
                editType: "calc",
                anim: !0
              },
              y: {
                valType: "data_array",
                editType: "calc+clearAxisTypes",
                anim: !0
              },
              y0: {
                valType: "any",
                dflt: 0,
                editType: "calc+clearAxisTypes",
                anim: !0
              },
              dy: {
                valType: "number",
                dflt: 1,
                editType: "calc",
                anim: !0
              },
              stackgroup: {
                valType: "string",
                dflt: "",
                editType: "calc"
              },
              orientation: {
                valType: "enumerated",
                values: ["v", "h"],
                editType: "calc"
              },
              groupnorm: {
                valType: "enumerated",
                values: ["", "fraction", "percent"],
                dflt: "",
                editType: "calc"
              },
              stackgaps: {
                valType: "enumerated",
                values: ["infer zero", "interpolate"],
                dflt: "infer zero",
                editType: "calc"
              },
              text: {
                valType: "string",
                dflt: "",
                arrayOk: !0,
                editType: "calc"
              },
              texttemplate: r({}, {}),
              hovertext: {
                valType: "string",
                dflt: "",
                arrayOk: !0,
                editType: "style"
              },
              mode: {
                valType: "flaglist",
                flags: ["lines", "markers", "text"],
                extras: ["none"],
                editType: "calc"
              },
              hoveron: {
                valType: "flaglist",
                flags: ["points", "fills"],
                editType: "style"
              },
              hovertemplate: i({}, {
                keys: u.eventDataKeys
              }),
              line: {
                color: {
                  valType: "color",
                  editType: "style",
                  anim: !0
                },
                width: {
                  valType: "number",
                  min: 0,
                  dflt: 2,
                  editType: "style",
                  anim: !0
                },
                shape: {
                  valType: "enumerated",
                  values: ["linear", "spline", "hv", "vh", "hvh", "vhv"],
                  dflt: "linear",
                  editType: "plot"
                },
                smoothing: {
                  valType: "number",
                  min: 0,
                  max: 1.3,
                  dflt: 1,
                  editType: "plot"
                },
                dash: c({}, s, {
                  editType: "style"
                }),
                simplify: {
                  valType: "boolean",
                  dflt: !0,
                  editType: "plot"
                },
                editType: "plot"
              },
              connectgaps: {
                valType: "boolean",
                dflt: !1,
                editType: "calc"
              },
              cliponaxis: {
                valType: "boolean",
                dflt: !0,
                editType: "plot"
              },
              fill: {
                valType: "enumerated",
                values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"],
                editType: "calc"
              },
              fillcolor: {
                valType: "color",
                editType: "style",
                anim: !0
              },
              marker: c({
                symbol: {
                  valType: "enumerated",
                  values: l.symbolList,
                  dflt: "circle",
                  arrayOk: !0,
                  editType: "style"
                },
                opacity: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  arrayOk: !0,
                  editType: "style",
                  anim: !0
                },
                size: {
                  valType: "number",
                  min: 0,
                  dflt: 6,
                  arrayOk: !0,
                  editType: "calc",
                  anim: !0
                },
                maxdisplayed: {
                  valType: "number",
                  min: 0,
                  dflt: 0,
                  editType: "plot"
                },
                sizeref: {
                  valType: "number",
                  dflt: 1,
                  editType: "calc"
                },
                sizemin: {
                  valType: "number",
                  min: 0,
                  dflt: 0,
                  editType: "calc"
                },
                sizemode: {
                  valType: "enumerated",
                  values: ["diameter", "area"],
                  dflt: "diameter",
                  editType: "calc"
                },
                line: c({
                  width: {
                    valType: "number",
                    min: 0,
                    arrayOk: !0,
                    editType: "style",
                    anim: !0
                  },
                  editType: "calc"
                }, o("marker.line", {
                  anim: !0
                })),
                gradient: {
                  type: {
                    valType: "enumerated",
                    values: ["radial", "horizontal", "vertical", "none"],
                    arrayOk: !0,
                    dflt: "none",
                    editType: "calc"
                  },
                  color: {
                    valType: "color",
                    arrayOk: !0,
                    editType: "calc"
                  },
                  editType: "calc"
                },
                editType: "calc"
              }, o("marker", {
                anim: !0
              })),
              selected: {
                marker: {
                  opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "style"
                  },
                  color: {
                    valType: "color",
                    editType: "style"
                  },
                  size: {
                    valType: "number",
                    min: 0,
                    editType: "style"
                  },
                  editType: "style"
                },
                textfont: {
                  color: {
                    valType: "color",
                    editType: "style"
                  },
                  editType: "style"
                },
                editType: "style"
              },
              unselected: {
                marker: {
                  opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "style"
                  },
                  color: {
                    valType: "color",
                    editType: "style"
                  },
                  size: {
                    valType: "number",
                    min: 0,
                    editType: "style"
                  },
                  editType: "style"
                },
                textfont: {
                  color: {
                    valType: "color",
                    editType: "style"
                  },
                  editType: "style"
                },
                editType: "style"
              },
              textposition: {
                valType: "enumerated",
                values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"],
                dflt: "middle center",
                arrayOk: !0,
                editType: "calc"
              },
              textfont: a({
                editType: "calc",
                colorEditType: "style",
                arrayOk: !0
              }),
              r: {
                valType: "data_array",
                editType: "calc"
              },
              t: {
                valType: "data_array",
                editType: "calc"
              }
            };
          }, {
            "../../components/colorscale/attributes": 382,
            "../../components/drawing": 396,
            "../../components/drawing/attributes": 395,
            "../../lib/extend": 489,
            "../../plots/font_attributes": 567,
            "../../plots/template_attributes": 592,
            "./constants": 626
          }],
          623: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric"),
              i = e("../../lib"),
              o = e("../../plots/cartesian/axes"),
              a = e("../../constants/numerical").BADNUM,
              s = e("./subtypes"),
              l = e("./colorscale_calc"),
              u = e("./arrays_to_calcdata"),
              c = e("./calc_selection");
            function d(e, t, n, r, i, a, l) {
              var u = t._length,
                c = e._fullLayout,
                d = n._id,
                h = r._id,
                f = c._firstScatter[p(t)] === t.uid,
                g = (m(t, c, n, r) || {}).orientation,
                v = t.fill;
              n._minDtick = 0, r._minDtick = 0;
              var y = {
                  padded: !0
                },
                b = {
                  padded: !0
                };
              l && (y.ppad = b.ppad = l);
              var _ = u < 2 || i[0] !== i[u - 1] || a[0] !== a[u - 1];
              _ && ("tozerox" === v || "tonextx" === v && (f || "h" === g)) ? y.tozero = !0 : (t.error_y || {}).visible || "tonexty" !== v && "tozeroy" !== v && (s.hasMarkers(t) || s.hasText(t)) || (y.padded = !1, y.ppad = 0), _ && ("tozeroy" === v || "tonexty" === v && (f || "v" === g)) ? b.tozero = !0 : "tonextx" !== v && "tozerox" !== v || (b.padded = !1), d && (t._extremes[d] = o.findExtremes(n, i, y)), h && (t._extremes[h] = o.findExtremes(r, a, b));
            }
            function h(e, t) {
              if (s.hasMarkers(e)) {
                var n,
                  r = e.marker,
                  a = 1.6 * (e.marker.sizeref || 1);
                if (n = "area" === e.marker.sizemode ? function (e) {
                  return Math.max(Math.sqrt((e || 0) / a), 3);
                } : function (e) {
                  return Math.max((e || 0) / a, 3);
                }, i.isArrayOrTypedArray(r.size)) {
                  var l = {
                    type: "linear"
                  };
                  o.setConvert(l);
                  for (var u = l.makeCalcdata(e.marker, "size"), c = new Array(t), d = 0; d < t; d++) c[d] = n(u[d]);
                  return c;
                }
                return n(r.size);
              }
            }
            function f(e, t) {
              var n = p(t),
                r = e._firstScatter;
              r[n] || (r[n] = t.uid);
            }
            function p(e) {
              var t = e.stackgroup;
              return e.xaxis + e.yaxis + e.type + (t ? "-" + t : "");
            }
            function m(e, t, n, r) {
              var i = e.stackgroup;
              if (i) {
                var o = t._scatterStackOpts[n._id + r._id][i],
                  a = "v" === o.orientation ? r : n;
                return "linear" === a.type || "log" === a.type ? o : void 0;
              }
            }
            t.exports = {
              calc: function calc(e, t) {
                var n,
                  s,
                  p,
                  g,
                  v,
                  y,
                  b = e._fullLayout,
                  _ = o.getFromId(e, t.xaxis || "x"),
                  x = o.getFromId(e, t.yaxis || "y"),
                  w = _.makeCalcdata(t, "x"),
                  S = x.makeCalcdata(t, "y"),
                  A = t._length,
                  E = new Array(A),
                  T = t.ids,
                  M = m(t, b, _, x),
                  C = !1;
                f(b, t);
                var k,
                  P = "x",
                  O = "y";
                for (M ? (i.pushUnique(M.traceIndices, t._expandedIndex), (n = "v" === M.orientation) ? (O = "s", k = "x") : (P = "s", k = "y"), v = "interpolate" === M.stackgaps) : d(e, t, _, x, w, S, h(t, A)), s = 0; s < A; s++) {
                  var R = E[s] = {},
                    I = r(w[s]),
                    j = r(S[s]);
                  I && j ? (R[P] = w[s], R[O] = S[s]) : M && (n ? I : j) ? (R[k] = n ? w[s] : S[s], R.gap = !0, v ? (R.s = a, C = !0) : R.s = 0) : R[P] = R[O] = a, T && (R.id = String(T[s]));
                }
                if (u(E, t), l(e, t), c(E, t), M) {
                  for (s = 0; s < E.length;) E[s][k] === a ? E.splice(s, 1) : s++;
                  if (i.sort(E, function (e, t) {
                    return e[k] - t[k] || e.i - t.i;
                  }), C) {
                    for (s = 0; s < E.length - 1 && E[s].gap;) s++;
                    for ((y = E[s].s) || (y = E[s].s = 0), p = 0; p < s; p++) E[p].s = y;
                    for (g = E.length - 1; g > s && E[g].gap;) g--;
                    for (y = E[g].s, p = E.length - 1; p > g; p--) E[p].s = y;
                    for (; s < g;) if (E[++s].gap) {
                      for (p = s + 1; E[p].gap;) p++;
                      for (var N = E[s - 1][k], L = E[s - 1].s, D = (E[p].s - L) / (E[p][k] - N); s < p;) E[s].s = L + (E[s][k] - N) * D, s++;
                    }
                  }
                }
                return E;
              },
              calcMarkerSize: h,
              calcAxisExpansion: d,
              setFirstScatter: f,
              getStackOpts: m
            };
          }, {
            "../../constants/numerical": 474,
            "../../lib": 495,
            "../../plots/cartesian/axes": 541,
            "./arrays_to_calcdata": 621,
            "./calc_selection": 624,
            "./colorscale_calc": 625,
            "./subtypes": 646,
            "fast-isnumeric": 91
          }],
          624: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            t.exports = function (e, t) {
              r.isArrayOrTypedArray(t.selectedpoints) && r.tagSelected(e, t);
            };
          }, {
            "../../lib": 495
          }],
          625: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/helpers").hasColorscale,
              i = e("../../components/colorscale/calc"),
              o = e("./subtypes");
            t.exports = function (e, t) {
              o.hasLines(t) && r(t, "line") && i(e, t, {
                vals: t.line.color,
                containerStr: "line",
                cLetter: "c"
              }), o.hasMarkers(t) && (r(t, "marker") && i(e, t, {
                vals: t.marker.color,
                containerStr: "marker",
                cLetter: "c"
              }), r(t, "marker.line") && i(e, t, {
                vals: t.marker.line.color,
                containerStr: "marker.line",
                cLetter: "c"
              }));
            };
          }, {
            "../../components/colorscale/calc": 383,
            "../../components/colorscale/helpers": 386,
            "./subtypes": 646
          }],
          626: [function (e, t, n) {
            "use strict";

            t.exports = {
              PTS_LINESONLY: 20,
              minTolerance: .2,
              toleranceGrowth: 10,
              maxScreensAway: 20,
              eventDataKeys: []
            };
          }, {}],
          627: [function (e, t, n) {
            "use strict";

            var r = e("./calc");
            function i(e, t, n, r, i, o, a) {
              i[r] = !0;
              var s = {
                i: null,
                gap: !0,
                s: 0
              };
              if (s[a] = n, e.splice(t, 0, s), t && n === e[t - 1][a]) {
                var l = e[t - 1];
                s.s = l.s, s.i = l.i, s.gap = l.gap;
              } else o && (s.s = function (e, t, n, r) {
                var i = e[t - 1],
                  o = e[t + 1];
                return o ? i ? i.s + (o.s - i.s) * (n - i[r]) / (o[r] - i[r]) : o.s : i.s;
              }(e, t, n, a));
              t || (e[0].t = e[1].t, e[0].trace = e[1].trace, delete e[1].t, delete e[1].trace);
            }
            t.exports = function (e, t) {
              var n = t.xaxis,
                o = t.yaxis,
                a = n._id + o._id,
                s = e._fullLayout._scatterStackOpts[a];
              if (s) {
                var l,
                  u,
                  c,
                  d,
                  h,
                  f,
                  p,
                  m,
                  g,
                  v,
                  y,
                  b,
                  _,
                  x,
                  w,
                  S = e.calcdata;
                for (var A in s) {
                  var E = (v = s[A]).traceIndices;
                  if (E.length) {
                    for (y = "interpolate" === v.stackgaps, b = v.groupnorm, "v" === v.orientation ? (_ = "x", x = "y") : (_ = "y", x = "x"), w = new Array(E.length), l = 0; l < w.length; l++) w[l] = !1;
                    f = S[E[0]];
                    var T = new Array(f.length);
                    for (l = 0; l < f.length; l++) T[l] = f[l][_];
                    for (l = 1; l < E.length; l++) {
                      for (h = S[E[l]], u = c = 0; u < h.length; u++) {
                        for (p = h[u][_]; p > T[c] && c < T.length; c++) i(h, u, T[c], l, w, y, _), u++;
                        if (p !== T[c]) {
                          for (d = 0; d < l; d++) i(S[E[d]], c, p, d, w, y, _);
                          T.splice(c, 0, p);
                        }
                        c++;
                      }
                      for (; c < T.length; c++) i(h, u, T[c], l, w, y, _), u++;
                    }
                    var M = T.length;
                    for (u = 0; u < f.length; u++) {
                      for (m = f[u][x] = f[u].s, l = 1; l < E.length; l++) (h = S[E[l]])[0].trace._rawLength = h[0].trace._length, h[0].trace._length = M, m += h[u].s, h[u][x] = m;
                      if (b) for (g = ("fraction" === b ? m : m / 100) || 1, l = 0; l < E.length; l++) {
                        var C = S[E[l]][u];
                        C[x] /= g, C.sNorm = C.s / g;
                      }
                    }
                    for (l = 0; l < E.length; l++) {
                      var k = (h = S[E[l]])[0].trace,
                        P = r.calcMarkerSize(k, k._rawLength),
                        O = Array.isArray(P);
                      if (P && w[l] || O) {
                        var R = P;
                        for (P = new Array(M), u = 0; u < M; u++) P[u] = h[u].gap ? 0 : O ? R[h[u].i] : R;
                      }
                      var I = new Array(M),
                        j = new Array(M);
                      for (u = 0; u < M; u++) I[u] = h[u].x, j[u] = h[u].y;
                      r.calcAxisExpansion(e, k, n, o, I, j, P), h[0].t.orientation = v.orientation;
                    }
                  }
                }
              }
            };
          }, {
            "./calc": 623
          }],
          628: [function (e, t, n) {
            "use strict";

            t.exports = function (e) {
              for (var t = 0; t < e.length; t++) {
                var n = e[t];
                if ("scatter" === n.type) {
                  var r = n.fill;
                  if ("none" !== r && "toself" !== r && (n.opacity = void 0, "tonexty" === r || "tonextx" === r)) for (var i = t - 1; i >= 0; i--) {
                    var o = e[i];
                    if ("scatter" === o.type && o.xaxis === n.xaxis && o.yaxis === n.yaxis) {
                      o.opacity = void 0;
                      break;
                    }
                  }
                }
              }
            };
          }, {}],
          629: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../registry"),
              o = e("./attributes"),
              a = e("./constants"),
              s = e("./subtypes"),
              l = e("./xy_defaults"),
              u = e("./stack_defaults"),
              c = e("./marker_defaults"),
              d = e("./line_defaults"),
              h = e("./line_shape_defaults"),
              f = e("./text_defaults"),
              p = e("./fillcolor_defaults");
            t.exports = function (e, t, n, m) {
              function g(n, i) {
                return r.coerce(e, t, o, n, i);
              }
              var v = l(e, t, m, g);
              if (v || (t.visible = !1), t.visible) {
                var y = u(e, t, m, g),
                  b = !y && v < a.PTS_LINESONLY ? "lines+markers" : "lines";
                g("text"), g("hovertext"), g("mode", b), s.hasLines(t) && (d(e, t, n, m, g), h(e, t, g), g("connectgaps"), g("line.simplify")), s.hasMarkers(t) && c(e, t, n, m, g, {
                  gradient: !0
                }), s.hasText(t) && (g("texttemplate"), f(e, t, m, g));
                var _ = [];
                (s.hasMarkers(t) || s.hasText(t)) && (g("cliponaxis"), g("marker.maxdisplayed"), _.push("points")), g("fill", y ? y.fillDflt : "none"), "none" !== t.fill && (p(e, t, n, g), s.hasLines(t) || h(e, t, g));
                var x = (t.line || {}).color,
                  w = (t.marker || {}).color;
                "tonext" !== t.fill && "toself" !== t.fill || _.push("fills"), g("hoveron", _.join("+") || "points"), "fills" !== t.hoveron && g("hovertemplate");
                var S = i.getComponentMethod("errorbars", "supplyDefaults");
                S(e, t, x || w || n, {
                  axis: "y"
                }), S(e, t, x || w || n, {
                  axis: "x",
                  inherit: "y"
                }), r.coerceSelectionMarkerOpacity(t, g);
              }
            };
          }, {
            "../../lib": 495,
            "../../registry": 593,
            "./attributes": 622,
            "./constants": 626,
            "./fillcolor_defaults": 630,
            "./line_defaults": 635,
            "./line_shape_defaults": 637,
            "./marker_defaults": 641,
            "./stack_defaults": 644,
            "./subtypes": 646,
            "./text_defaults": 647,
            "./xy_defaults": 648
          }],
          630: [function (e, t, n) {
            "use strict";

            var r = e("../../components/color"),
              i = e("../../lib").isArrayOrTypedArray;
            t.exports = function (e, t, n, o) {
              var a = !1;
              if (t.marker) {
                var s = t.marker.color,
                  l = (t.marker.line || {}).color;
                s && !i(s) ? a = s : l && !i(l) && (a = l);
              }
              o("fillcolor", r.addOpacity((t.line || {}).color || a || n, .5));
            };
          }, {
            "../../components/color": 375,
            "../../lib": 495
          }],
          631: [function (e, t, n) {
            "use strict";

            var r = e("../../plots/cartesian/axes");
            t.exports = function (e, t, n) {
              var i = {},
                o = {
                  _fullLayout: n
                },
                a = r.getFromTrace(o, t, "x"),
                s = r.getFromTrace(o, t, "y");
              return i.xLabel = r.tickText(a, e.x, !0).text, i.yLabel = r.tickText(s, e.y, !0).text, i;
            };
          }, {
            "../../plots/cartesian/axes": 541
          }],
          632: [function (e, t, n) {
            "use strict";

            var r = e("../../components/color"),
              i = e("./subtypes");
            t.exports = function (e, t) {
              var n, o;
              if ("lines" === e.mode) return (n = e.line.color) && r.opacity(n) ? n : e.fillcolor;
              if ("none" === e.mode) return e.fill ? e.fillcolor : "";
              var a = t.mcc || (e.marker || {}).color,
                s = t.mlcc || ((e.marker || {}).line || {}).color;
              return (o = a && r.opacity(a) ? a : s && r.opacity(s) && (t.mlw || ((e.marker || {}).line || {}).width) ? s : "") ? r.opacity(o) < .3 ? r.addOpacity(o, .3) : o : (n = (e.line || {}).color) && r.opacity(n) && i.hasLines(e) && e.line.width ? n : e.fillcolor;
            };
          }, {
            "../../components/color": 375,
            "./subtypes": 646
          }],
          633: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../components/fx"),
              o = e("../../registry"),
              a = e("./get_trace_color"),
              s = e("../../components/color"),
              l = r.fillText;
            t.exports = function (e, t, n, u) {
              var c = e.cd,
                d = c[0].trace,
                h = e.xa,
                f = e.ya,
                p = h.c2p(t),
                m = f.c2p(n),
                g = [p, m],
                v = d.hoveron || "",
                y = -1 !== d.mode.indexOf("markers") ? 3 : .5;
              if (-1 !== v.indexOf("points")) {
                var b = function b(e) {
                    var t = Math.max(y, e.mrc || 0),
                      n = h.c2p(e.x) - p,
                      r = f.c2p(e.y) - m;
                    return Math.max(Math.sqrt(n * n + r * r) - t, 1 - y / t);
                  },
                  _ = i.getDistanceFunction(u, function (e) {
                    var t = Math.max(3, e.mrc || 0),
                      n = 1 - 1 / t,
                      r = Math.abs(h.c2p(e.x) - p);
                    return r < t ? n * r / t : r - t + n;
                  }, function (e) {
                    var t = Math.max(3, e.mrc || 0),
                      n = 1 - 1 / t,
                      r = Math.abs(f.c2p(e.y) - m);
                    return r < t ? n * r / t : r - t + n;
                  }, b);
                if (i.getClosest(c, _, e), !1 !== e.index) {
                  var x = c[e.index],
                    w = h.c2p(x.x, !0),
                    S = f.c2p(x.y, !0),
                    A = x.mrc || 1;
                  e.index = x.i;
                  var E = c[0].t.orientation,
                    T = E && (x.sNorm || x.s),
                    M = "h" === E ? T : x.x,
                    C = "v" === E ? T : x.y;
                  return r.extendFlat(e, {
                    color: a(d, x),
                    x0: w - A,
                    x1: w + A,
                    xLabelVal: M,
                    y0: S - A,
                    y1: S + A,
                    yLabelVal: C,
                    spikeDistance: b(x),
                    hovertemplate: d.hovertemplate
                  }), l(x, d, e), o.getComponentMethod("errorbars", "hoverInfo")(x, d, e), [e];
                }
              }
              if (-1 !== v.indexOf("fills") && d._polygons) {
                var k,
                  P,
                  O,
                  R,
                  I,
                  j,
                  N,
                  L,
                  D,
                  B = d._polygons,
                  F = [],
                  z = !1,
                  U = 1 / 0,
                  G = -1 / 0,
                  V = 1 / 0,
                  H = -1 / 0;
                for (k = 0; k < B.length; k++) (O = B[k]).contains(g) && (z = !z, F.push(O), V = Math.min(V, O.ymin), H = Math.max(H, O.ymax));
                if (z) {
                  var q = ((V = Math.max(V, 0)) + (H = Math.min(H, f._length))) / 2;
                  for (k = 0; k < F.length; k++) for (R = F[k].pts, P = 1; P < R.length; P++) (L = R[P - 1][1]) > q != (D = R[P][1]) >= q && (j = R[P - 1][0], N = R[P][0], D - L && (I = j + (N - j) * (q - L) / (D - L), U = Math.min(U, I), G = Math.max(G, I)));
                  U = Math.max(U, 0), G = Math.min(G, h._length);
                  var W = s.defaultLine;
                  return s.opacity(d.fillcolor) ? W = d.fillcolor : s.opacity((d.line || {}).color) && (W = d.line.color), r.extendFlat(e, {
                    distance: e.maxHoverDistance,
                    x0: U,
                    x1: G,
                    y0: q,
                    y1: q,
                    color: W,
                    hovertemplate: !1
                  }), delete e.index, d.text && !Array.isArray(d.text) ? e.text = String(d.text) : e.text = d.name, [e];
                }
              }
            };
          }, {
            "../../components/color": 375,
            "../../components/fx": 413,
            "../../lib": 495,
            "../../registry": 593,
            "./get_trace_color": 632
          }],
          634: [function (e, t, n) {
            "use strict";

            var r = e("./subtypes");
            t.exports = {
              hasLines: r.hasLines,
              hasMarkers: r.hasMarkers,
              hasText: r.hasText,
              isBubble: r.isBubble,
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              crossTraceDefaults: e("./cross_trace_defaults"),
              calc: e("./calc").calc,
              crossTraceCalc: e("./cross_trace_calc"),
              arraysToCalcdata: e("./arrays_to_calcdata"),
              plot: e("./plot"),
              colorbar: e("./marker_colorbar"),
              formatLabels: e("./format_labels"),
              style: e("./style").style,
              styleOnSelect: e("./style").styleOnSelect,
              hoverPoints: e("./hover"),
              selectPoints: e("./select"),
              animatable: !0,
              moduleType: "trace",
              name: "scatter",
              basePlotModule: e("../../plots/cartesian"),
              categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"],
              meta: {}
            };
          }, {
            "../../plots/cartesian": 552,
            "./arrays_to_calcdata": 621,
            "./attributes": 622,
            "./calc": 623,
            "./cross_trace_calc": 627,
            "./cross_trace_defaults": 628,
            "./defaults": 629,
            "./format_labels": 631,
            "./hover": 633,
            "./marker_colorbar": 640,
            "./plot": 642,
            "./select": 643,
            "./style": 645,
            "./subtypes": 646
          }],
          635: [function (e, t, n) {
            "use strict";

            var r = e("../../lib").isArrayOrTypedArray,
              i = e("../../components/colorscale/helpers").hasColorscale,
              o = e("../../components/colorscale/defaults");
            t.exports = function (e, t, n, a, s, l) {
              var u = (e.marker || {}).color;
              s("line.color", n), i(e, "line") ? o(e, t, a, s, {
                prefix: "line.",
                cLetter: "c"
              }) : s("line.color", !r(u) && u || n), s("line.width"), (l || {}).noDash || s("line.dash");
            };
          }, {
            "../../components/colorscale/defaults": 385,
            "../../components/colorscale/helpers": 386,
            "../../lib": 495
          }],
          636: [function (e, t, n) {
            "use strict";

            var r = e("../../constants/numerical"),
              i = r.BADNUM,
              o = r.LOG_CLIP,
              a = o + .5,
              s = o - .5,
              l = e("../../lib"),
              u = l.segmentsIntersect,
              c = l.constrain,
              d = e("./constants");
            t.exports = function (e, t) {
              var n,
                r,
                o,
                h,
                f,
                p,
                m,
                g,
                v,
                y,
                b,
                _,
                x,
                w,
                S,
                A,
                E,
                T,
                M = t.xaxis,
                C = t.yaxis,
                k = "log" === M.type,
                P = "log" === C.type,
                O = M._length,
                R = C._length,
                I = t.connectGaps,
                j = t.baseTolerance,
                N = t.shape,
                L = "linear" === N,
                D = t.fill && "none" !== t.fill,
                B = [],
                F = d.minTolerance,
                z = e.length,
                U = new Array(z),
                G = 0;
              function V(n) {
                var r = e[n];
                if (!r) return !1;
                var o = t.linearized ? M.l2p(r.x) : M.c2p(r.x),
                  l = t.linearized ? C.l2p(r.y) : C.c2p(r.y);
                if (o === i) {
                  if (k && (o = M.c2p(r.x, !0)), o === i) return !1;
                  P && l === i && (o *= Math.abs(M._m * R * (M._m > 0 ? a : s) / (C._m * O * (C._m > 0 ? a : s)))), o *= 1e3;
                }
                if (l === i) {
                  if (P && (l = C.c2p(r.y, !0)), l === i) return !1;
                  l *= 1e3;
                }
                return [o, l];
              }
              function H(e, t, n, r) {
                var i = n - e,
                  o = r - t,
                  a = .5 - e,
                  s = .5 - t,
                  l = i * i + o * o,
                  u = i * a + o * s;
                if (u > 0 && u < l) {
                  var c = a * o - s * i;
                  if (c * c < l) return !0;
                }
              }
              function q(e, t) {
                var n = e[0] / O,
                  r = e[1] / R,
                  i = Math.max(0, -n, n - 1, -r, r - 1);
                return i && void 0 !== E && H(n, r, E, T) && (i = 0), i && t && H(n, r, t[0] / O, t[1] / R) && (i = 0), (1 + d.toleranceGrowth * i) * j;
              }
              function W(e, t) {
                var n = e[0] - t[0],
                  r = e[1] - t[1];
                return Math.sqrt(n * n + r * r);
              }
              var $,
                X,
                Y,
                K,
                Z,
                Q,
                J,
                ee = d.maxScreensAway,
                te = -O * ee,
                ne = O * (1 + ee),
                re = -R * ee,
                ie = R * (1 + ee),
                oe = [[te, re, ne, re], [ne, re, ne, ie], [ne, ie, te, ie], [te, ie, te, re]];
              function ae(e) {
                if (e[0] < te || e[0] > ne || e[1] < re || e[1] > ie) return [c(e[0], te, ne), c(e[1], re, ie)];
              }
              function se(e, t) {
                return e[0] === t[0] && (e[0] === te || e[0] === ne) || e[1] === t[1] && (e[1] === re || e[1] === ie) || void 0;
              }
              function le(e, t, n) {
                return function (r, i) {
                  var o = ae(r),
                    a = ae(i),
                    s = [];
                  if (o && a && se(o, a)) return s;
                  o && s.push(o), a && s.push(a);
                  var u = 2 * l.constrain((r[e] + i[e]) / 2, t, n) - ((o || r)[e] + (a || i)[e]);
                  return u && ((o && a ? u > 0 == o[e] > a[e] ? o : a : o || a)[e] += u), s;
                };
              }
              function ue(e) {
                var t = e[0],
                  n = e[1],
                  r = t === U[G - 1][0],
                  i = n === U[G - 1][1];
                if (!r || !i) if (G > 1) {
                  var o = t === U[G - 2][0],
                    a = n === U[G - 2][1];
                  r && (t === te || t === ne) && o ? a ? G-- : U[G - 1] = e : i && (n === re || n === ie) && a ? o ? G-- : U[G - 1] = e : U[G++] = e;
                } else U[G++] = e;
              }
              function ce(e) {
                U[G - 1][0] !== e[0] && U[G - 1][1] !== e[1] && ue([Y, K]), ue(e), Z = null, Y = K = 0;
              }
              function de(e) {
                if (E = e[0] / O, T = e[1] / R, $ = e[0] < te ? te : e[0] > ne ? ne : 0, X = e[1] < re ? re : e[1] > ie ? ie : 0, $ || X) {
                  if (G) {
                    if (Z) {
                      var t = J(Z, e);
                      t.length > 1 && (ce(t[0]), U[G++] = t[1]);
                    } else Q = J(U[G - 1], e)[0], U[G++] = Q;
                  } else U[G++] = [$ || e[0], X || e[1]];
                  var n = U[G - 1];
                  $ && X && (n[0] !== $ || n[1] !== X) ? (Z && (Y !== $ && K !== X ? ue(Y && K ? (r = Z, o = (i = e)[0] - r[0], a = (i[1] - r[1]) / o, (r[1] * i[0] - i[1] * r[0]) / o > 0 ? [a > 0 ? te : ne, ie] : [a > 0 ? ne : te, re]) : [Y || $, K || X]) : Y && K && ue([Y, K])), ue([$, X])) : Y - $ && K - X && ue([$ || Y, X || K]), Z = e, Y = $, K = X;
                } else Z && ce(J(Z, e)[0]), U[G++] = e;
                var r, i, o, a;
              }
              for ("linear" === N || "spline" === N ? J = function J(e, t) {
                for (var n = [], r = 0, i = 0; i < 4; i++) {
                  var o = oe[i],
                    a = u(e[0], e[1], t[0], t[1], o[0], o[1], o[2], o[3]);
                  a && (!r || Math.abs(a.x - n[0][0]) > 1 || Math.abs(a.y - n[0][1]) > 1) && (a = [a.x, a.y], r && W(a, e) < W(n[0], e) ? n.unshift(a) : n.push(a), r++);
                }
                return n;
              } : "hv" === N || "vh" === N ? J = function J(e, t) {
                var n = [],
                  r = ae(e),
                  i = ae(t);
                return r && i && se(r, i) || (r && n.push(r), i && n.push(i)), n;
              } : "hvh" === N ? J = le(0, te, ne) : "vhv" === N && (J = le(1, re, ie)), n = 0; n < z; n++) if (r = V(n)) {
                for (G = 0, Z = null, de(r), n++; n < z; n++) {
                  if (!(h = V(n))) {
                    if (I) continue;
                    break;
                  }
                  if (L && t.simplify) {
                    var he = V(n + 1);
                    if (y = W(h, r), D && (0 === G || G === z - 1) || !(y < q(h, he) * F)) {
                      for (g = [(h[0] - r[0]) / y, (h[1] - r[1]) / y], f = r, b = y, _ = w = S = 0, m = !1, o = h, n++; n < e.length; n++) {
                        if (p = he, he = V(n + 1), !p) {
                          if (I) continue;
                          break;
                        }
                        if (A = (v = [p[0] - r[0], p[1] - r[1]])[0] * g[1] - v[1] * g[0], w = Math.min(w, A), (S = Math.max(S, A)) - w > q(p, he)) break;
                        o = p, (x = v[0] * g[0] + v[1] * g[1]) > b ? (b = x, h = p, m = !1) : x < _ && (_ = x, f = p, m = !0);
                      }
                      if (m ? (de(h), o !== f && de(f)) : (f !== r && de(f), o !== h && de(h)), de(o), n >= e.length || !p) break;
                      de(p), r = p;
                    }
                  } else de(h);
                }
                Z && ue([Y || Z[0], K || Z[1]]), B.push(U.slice(0, G));
              }
              return B;
            };
          }, {
            "../../constants/numerical": 474,
            "../../lib": 495,
            "./constants": 626
          }],
          637: [function (e, t, n) {
            "use strict";

            t.exports = function (e, t, n) {
              "spline" === n("line.shape") && n("line.smoothing");
            };
          }, {}],
          638: [function (e, t, n) {
            "use strict";

            var r = {
              tonextx: 1,
              tonexty: 1,
              tonext: 1
            };
            t.exports = function (e, t, n) {
              var i,
                o,
                a,
                s,
                l,
                u = {},
                c = !1,
                d = -1,
                h = 0,
                f = -1;
              for (o = 0; o < n.length; o++) (a = (i = n[o][0].trace).stackgroup || "") ? a in u ? l = u[a] : (l = u[a] = h, h++) : i.fill in r && f >= 0 ? l = f : (l = f = h, h++), l < d && (c = !0), i._groupIndex = d = l;
              var p = n.slice();
              c && p.sort(function (e, t) {
                var n = e[0].trace,
                  r = t[0].trace;
                return n._groupIndex - r._groupIndex || n.index - r.index;
              });
              var m = {};
              for (o = 0; o < p.length; o++) a = (i = p[o][0].trace).stackgroup || "", !0 === i.visible ? (i._nexttrace = null, i.fill in r && (s = m[a], i._prevtrace = s || null, s && (s._nexttrace = i)), i._ownfill = i.fill && ("tozero" === i.fill.substr(0, 6) || "toself" === i.fill || "to" === i.fill.substr(0, 2) && !i._prevtrace), m[a] = i) : i._prevtrace = i._nexttrace = i._ownfill = null;
              return p;
            };
          }, {}],
          639: [function (e, t, n) {
            "use strict";

            var r = e("fast-isnumeric");
            t.exports = function (e) {
              var t = e.marker,
                n = t.sizeref || 1,
                i = t.sizemin || 0,
                o = "area" === t.sizemode ? function (e) {
                  return Math.sqrt(e / n);
                } : function (e) {
                  return e / n;
                };
              return function (e) {
                var t = o(e / 2);
                return r(t) && t > 0 ? Math.max(t, i) : 0;
              };
            };
          }, {
            "fast-isnumeric": 91
          }],
          640: [function (e, t, n) {
            "use strict";

            t.exports = {
              container: "marker",
              min: "cmin",
              max: "cmax"
            };
          }, {}],
          641: [function (e, t, n) {
            "use strict";

            var r = e("../../components/color"),
              i = e("../../components/colorscale/helpers").hasColorscale,
              o = e("../../components/colorscale/defaults"),
              a = e("./subtypes");
            t.exports = function (e, t, n, s, l, u) {
              var c = a.isBubble(e),
                d = (e.line || {}).color;
              u = u || {}, d && (n = d), l("marker.symbol"), l("marker.opacity", c ? .7 : 1), l("marker.size"), l("marker.color", n), i(e, "marker") && o(e, t, s, l, {
                prefix: "marker.",
                cLetter: "c"
              }), u.noSelect || (l("selected.marker.color"), l("unselected.marker.color"), l("selected.marker.size"), l("unselected.marker.size")), u.noLine || (l("marker.line.color", d && !Array.isArray(d) && t.marker.color !== d ? d : c ? r.background : r.defaultLine), i(e, "marker.line") && o(e, t, s, l, {
                prefix: "marker.line.",
                cLetter: "c"
              }), l("marker.line.width", c ? 1 : 0)), c && (l("marker.sizeref"), l("marker.sizemin"), l("marker.sizemode")), u.gradient && "none" !== l("marker.gradient.type") && l("marker.gradient.color");
            };
          }, {
            "../../components/color": 375,
            "../../components/colorscale/defaults": 385,
            "../../components/colorscale/helpers": 386,
            "./subtypes": 646
          }],
          642: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../registry"),
              o = e("../../lib"),
              a = o.ensureSingle,
              s = o.identity,
              l = e("../../components/drawing"),
              u = e("./subtypes"),
              c = e("./line_points"),
              d = e("./link_traces"),
              h = e("../../lib/polygon").tester;
            function f(e, t, n, d, f, p, m) {
              var g;
              !function (e, t, n, i, a) {
                var s = n.xaxis,
                  l = n.yaxis,
                  c = r.extent(o.simpleMap(s.range, s.r2c)),
                  d = r.extent(o.simpleMap(l.range, l.r2c)),
                  h = i[0].trace;
                if (u.hasMarkers(h)) {
                  var f = h.marker.maxdisplayed;
                  if (0 !== f) {
                    var p = i.filter(function (e) {
                        return e.x >= c[0] && e.x <= c[1] && e.y >= d[0] && e.y <= d[1];
                      }),
                      m = Math.ceil(p.length / f),
                      g = 0;
                    a.forEach(function (e, n) {
                      var r = e[0].trace;
                      u.hasMarkers(r) && r.marker.maxdisplayed > 0 && n < t && g++;
                    });
                    var v = Math.round(g * m / 3 + Math.floor(g / 3) * m / 7.1);
                    i.forEach(function (e) {
                      delete e.vis;
                    }), p.forEach(function (e, t) {
                      0 === Math.round((t + v) % m) && (e.vis = !0);
                    });
                  }
                }
              }(0, t, n, d, f);
              var v = !!m && m.duration > 0;
              function y(e) {
                return v ? e.transition() : e;
              }
              var b = n.xaxis,
                _ = n.yaxis,
                x = d[0].trace,
                w = x.line,
                S = r.select(p),
                A = a(S, "g", "errorbars"),
                E = a(S, "g", "lines"),
                T = a(S, "g", "points"),
                M = a(S, "g", "text");
              if (i.getComponentMethod("errorbars", "plot")(e, A, n, m), !0 === x.visible) {
                var C, k;
                y(S).style("opacity", x.opacity);
                var P = x.fill.charAt(x.fill.length - 1);
                "x" !== P && "y" !== P && (P = ""), d[0][n.isRangePlot ? "nodeRangePlot3" : "node3"] = S;
                var O,
                  R,
                  I = "",
                  j = [],
                  N = x._prevtrace;
                N && (I = N._prevRevpath || "", k = N._nextFill, j = N._polygons);
                var L,
                  D,
                  B,
                  F,
                  z,
                  U,
                  G,
                  V = "",
                  H = "",
                  q = [],
                  W = o.noop;
                if (C = x._ownFill, u.hasLines(x) || "none" !== x.fill) {
                  for (k && k.datum(d), -1 !== ["hv", "vh", "hvh", "vhv"].indexOf(w.shape) ? (L = l.steps(w.shape), D = l.steps(w.shape.split("").reverse().join(""))) : L = D = "spline" === w.shape ? function (e) {
                    var t = e[e.length - 1];
                    return e.length > 1 && e[0][0] === t[0] && e[0][1] === t[1] ? l.smoothclosed(e.slice(1), w.smoothing) : l.smoothopen(e, w.smoothing);
                  } : function (e) {
                    return "M" + e.join("L");
                  }, B = function B(e) {
                    return D(e.reverse());
                  }, q = c(d, {
                    xaxis: b,
                    yaxis: _,
                    connectGaps: x.connectgaps,
                    baseTolerance: Math.max(w.width || 1, 3) / 4,
                    shape: w.shape,
                    simplify: w.simplify,
                    fill: x.fill
                  }), G = x._polygons = new Array(q.length), g = 0; g < q.length; g++) x._polygons[g] = h(q[g]);
                  q.length && (F = q[0][0], U = (z = q[q.length - 1])[z.length - 1]), W = function W(e) {
                    return function (t) {
                      if (O = L(t), R = B(t), V ? P ? (V += "L" + O.substr(1), H = R + "L" + H.substr(1)) : (V += "Z" + O, H = R + "Z" + H) : (V = O, H = R), u.hasLines(x) && t.length > 1) {
                        var n = r.select(this);
                        if (n.datum(d), e) y(n.style("opacity", 0).attr("d", O).call(l.lineGroupStyle)).style("opacity", 1);else {
                          var i = y(n);
                          i.attr("d", O), l.singleLineStyle(d, i);
                        }
                      }
                    };
                  };
                }
                var $ = E.selectAll(".js-line").data(q);
                y($.exit()).style("opacity", 0).remove(), $.each(W(!1)), $.enter().append("path").classed("js-line", !0).style("vector-effect", "non-scaling-stroke").call(l.lineGroupStyle).each(W(!0)), l.setClipUrl($, n.layerClipId, e), q.length ? (C ? (C.datum(d), F && U && (P ? ("y" === P ? F[1] = U[1] = _.c2p(0, !0) : "x" === P && (F[0] = U[0] = b.c2p(0, !0)), y(C).attr("d", "M" + U + "L" + F + "L" + V.substr(1)).call(l.singleFillStyle)) : y(C).attr("d", V + "Z").call(l.singleFillStyle))) : k && ("tonext" === x.fill.substr(0, 6) && V && I ? ("tonext" === x.fill ? y(k).attr("d", V + "Z" + I + "Z").call(l.singleFillStyle) : y(k).attr("d", V + "L" + I.substr(1) + "Z").call(l.singleFillStyle), x._polygons = x._polygons.concat(j)) : (Y(k), x._polygons = null)), x._prevRevpath = H, x._prevPolygons = G) : (C ? Y(C) : k && Y(k), x._polygons = x._prevRevpath = x._prevPolygons = null), T.datum(d), M.datum(d), function (t, i, o) {
                  var a,
                    c = o[0].trace,
                    d = u.hasMarkers(c),
                    h = u.hasText(c),
                    f = function (e) {
                      if (e.ids) return J;
                    }(c),
                    p = ee,
                    m = ee;
                  if (d || h) {
                    var g = s,
                      x = c.stackgroup,
                      w = x && "infer zero" === e._fullLayout._scatterStackOpts[b._id + _._id][x].stackgaps;
                    c.marker.maxdisplayed || c._needsCull ? g = w ? Z : K : x && !w && (g = Q), d && (p = g), h && (m = g);
                  }
                  var S,
                    A = (a = t.selectAll("path.point").data(p, f)).enter().append("path").classed("point", !0);
                  v && A.call(l.pointStyle, c, e).call(l.translatePoints, b, _).style("opacity", 0).transition().style("opacity", 1), a.order(), d && (S = l.makePointStyleFns(c)), a.each(function (t) {
                    var i = r.select(this),
                      o = y(i);
                    l.translatePoint(t, o, b, _) ? (l.singlePointStyle(t, o, c, S, e), n.layerClipId && l.hideOutsideRangePoint(t, o, b, _, c.xcalendar, c.ycalendar), c.customdata && i.classed("plotly-customdata", null !== t.data && void 0 !== t.data)) : o.remove();
                  }), v ? a.exit().transition().style("opacity", 0).remove() : a.exit().remove(), (a = i.selectAll("g").data(m, f)).enter().append("g").classed("textpoint", !0).append("text"), a.order(), a.each(function (e) {
                    var t = r.select(this),
                      i = y(t.select("text"));
                    l.translatePoint(e, i, b, _) ? n.layerClipId && l.hideOutsideRangePoint(e, t, b, _, c.xcalendar, c.ycalendar) : t.remove();
                  }), a.selectAll("text").call(l.textPointStyle, c, e).each(function (e) {
                    var t = b.c2p(e.x),
                      n = _.c2p(e.y);
                    r.select(this).selectAll("tspan.line").each(function () {
                      y(r.select(this)).attr({
                        x: t,
                        y: n
                      });
                    });
                  }), a.exit().remove();
                }(T, M, d);
                var X = !1 === x.cliponaxis ? null : n.layerClipId;
                l.setClipUrl(T, X, e), l.setClipUrl(M, X, e);
              }
              function Y(e) {
                y(e).attr("d", "M0,0Z");
              }
              function K(e) {
                return e.filter(function (e) {
                  return !e.gap && e.vis;
                });
              }
              function Z(e) {
                return e.filter(function (e) {
                  return e.vis;
                });
              }
              function Q(e) {
                return e.filter(function (e) {
                  return !e.gap;
                });
              }
              function J(e) {
                return e.id;
              }
              function ee() {
                return !1;
              }
            }
            t.exports = function (e, t, n, i, o, u) {
              var c,
                h,
                p = !o,
                m = !!o && o.duration > 0,
                g = d(e, t, n);
              (c = i.selectAll("g.trace").data(g, function (e) {
                return e[0].trace.uid;
              })).enter().append("g").attr("class", function (e) {
                return "trace scatter trace" + e[0].trace.uid;
              }).style("stroke-miterlimit", 2), c.order(), function (e, t, n) {
                t.each(function (t) {
                  var i = a(r.select(this), "g", "fills");
                  l.setClipUrl(i, n.layerClipId, e);
                  var o = t[0].trace,
                    u = [];
                  o._ownfill && u.push("_ownFill"), o._nexttrace && u.push("_nextFill");
                  var c = i.selectAll("g").data(u, s);
                  c.enter().append("g"), c.exit().each(function (e) {
                    o[e] = null;
                  }).remove(), c.order().each(function (e) {
                    o[e] = a(r.select(this), "path", "js-fill");
                  });
                });
              }(e, c, t), m ? (u && (h = u()), r.transition().duration(o.duration).ease(o.easing).each("end", function () {
                h && h();
              }).each("interrupt", function () {
                h && h();
              }).each(function () {
                i.selectAll("g.trace").each(function (n, r) {
                  f(e, r, t, n, g, this, o);
                });
              })) : c.each(function (n, r) {
                f(e, r, t, n, g, this, o);
              }), p && c.exit().remove(), i.selectAll("path:not([d])").remove();
            };
          }, {
            "../../components/drawing": 396,
            "../../lib": 495,
            "../../lib/polygon": 507,
            "../../registry": 593,
            "./line_points": 636,
            "./link_traces": 638,
            "./subtypes": 646,
            d3: 82
          }],
          643: [function (e, t, n) {
            "use strict";

            var r = e("./subtypes");
            t.exports = function (e, t) {
              var n,
                i,
                o,
                a,
                s = e.cd,
                l = e.xaxis,
                u = e.yaxis,
                c = [],
                d = s[0].trace;
              if (!r.hasMarkers(d) && !r.hasText(d)) return [];
              if (!1 === t) for (n = 0; n < s.length; n++) s[n].selected = 0;else for (n = 0; n < s.length; n++) i = s[n], o = l.c2p(i.x), a = u.c2p(i.y), null !== i.i && t.contains([o, a], !1, n, e) ? (c.push({
                pointNumber: i.i,
                x: l.c2d(i.x),
                y: u.c2d(i.y)
              }), i.selected = 1) : i.selected = 0;
              return c;
            };
          }, {
            "./subtypes": 646
          }],
          644: [function (e, t, n) {
            "use strict";

            var r = ["orientation", "groupnorm", "stackgaps"];
            t.exports = function (e, t, n, i) {
              var o = n._scatterStackOpts,
                a = i("stackgroup");
              if (a) {
                var s = t.xaxis + t.yaxis,
                  l = o[s];
                l || (l = o[s] = {});
                var u = l[a],
                  c = !1;
                u ? u.traces.push(t) : (u = l[a] = {
                  traceIndices: [],
                  traces: [t]
                }, c = !0);
                for (var d = {
                    orientation: t.x && !t.y ? "h" : "v"
                  }, h = 0; h < r.length; h++) {
                  var f = r[h],
                    p = f + "Found";
                  if (!u[p]) {
                    var m = void 0 !== e[f],
                      g = "orientation" === f;
                    if ((m || c) && (u[f] = i(f, d[f]), g && (u.fillDflt = "h" === u[f] ? "tonextx" : "tonexty"), m && (u[p] = !0, !c && (delete u.traces[0][f], g)))) for (var v = 0; v < u.traces.length - 1; v++) {
                      var y = u.traces[v];
                      y._input.fill !== y.fill && (y.fill = u.fillDflt);
                    }
                  }
                }
                return u;
              }
            };
          }, {}],
          645: [function (e, t, n) {
            "use strict";

            var r = e("d3"),
              i = e("../../components/drawing"),
              o = e("../../registry");
            function a(e, t, n) {
              i.pointStyle(e.selectAll("path.point"), t, n);
            }
            function s(e, t, n) {
              i.textPointStyle(e.selectAll("text"), t, n);
            }
            t.exports = {
              style: function style(e) {
                var t = r.select(e).selectAll("g.trace.scatter");
                t.style("opacity", function (e) {
                  return e[0].trace.opacity;
                }), t.selectAll("g.points").each(function (t) {
                  a(r.select(this), t.trace || t[0].trace, e);
                }), t.selectAll("g.text").each(function (t) {
                  s(r.select(this), t.trace || t[0].trace, e);
                }), t.selectAll("g.trace path.js-line").call(i.lineGroupStyle), t.selectAll("g.trace path.js-fill").call(i.fillGroupStyle), o.getComponentMethod("errorbars", "style")(t);
              },
              stylePoints: a,
              styleText: s,
              styleOnSelect: function styleOnSelect(e, t, n) {
                var r = t[0].trace;
                r.selectedpoints ? (i.selectedPointStyle(n.selectAll("path.point"), r), i.selectedTextStyle(n.selectAll("text"), r)) : (a(n, r, e), s(n, r, e));
              }
            };
          }, {
            "../../components/drawing": 396,
            "../../registry": 593,
            d3: 82
          }],
          646: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            t.exports = {
              hasLines: function hasLines(e) {
                return e.visible && e.mode && -1 !== e.mode.indexOf("lines");
              },
              hasMarkers: function hasMarkers(e) {
                return e.visible && (e.mode && -1 !== e.mode.indexOf("markers") || "splom" === e.type);
              },
              hasText: function hasText(e) {
                return e.visible && e.mode && -1 !== e.mode.indexOf("text");
              },
              isBubble: function isBubble(e) {
                return r.isPlainObject(e.marker) && r.isArrayOrTypedArray(e.marker.size);
              }
            };
          }, {
            "../../lib": 495
          }],
          647: [function (e, t, n) {
            "use strict";

            var r = e("../../lib");
            t.exports = function (e, t, n, i, o) {
              o = o || {}, i("textposition"), r.coerceFont(i, "textfont", n.font), o.noSelect || (i("selected.textfont.color"), i("unselected.textfont.color"));
            };
          }, {
            "../../lib": 495
          }],
          648: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../registry");
            t.exports = function (e, t, n, o) {
              var a,
                s = o("x"),
                l = o("y");
              if (i.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y"], n), s) {
                var u = r.minRowLength(s);
                l ? a = Math.min(u, r.minRowLength(l)) : (a = u, o("y0"), o("dy"));
              } else {
                if (!l) return 0;
                a = r.minRowLength(l), o("x0"), o("dx");
              }
              return t._length = a, a;
            };
          }, {
            "../../lib": 495,
            "../../registry": 593
          }],
          649: [function (e, t, n) {
            "use strict";

            var r = e("../scatter/attributes"),
              i = e("../../components/colorscale/attributes"),
              o = e("../../plots/template_attributes").hovertemplateAttrs,
              a = e("../../plots/template_attributes").texttemplateAttrs,
              s = e("../../plots/attributes"),
              l = e("../../constants/gl3d_dashes"),
              u = e("../../constants/gl3d_markers"),
              c = e("../../lib/extend").extendFlat,
              d = e("../../plot_api/edit_types").overrideAll,
              h = r.line,
              f = r.marker,
              p = f.line,
              m = c({
                width: h.width,
                dash: {
                  valType: "enumerated",
                  values: Object.keys(l),
                  dflt: "solid"
                }
              }, i("line")),
              g = t.exports = d({
                x: r.x,
                y: r.y,
                z: {
                  valType: "data_array"
                },
                text: c({}, r.text, {}),
                texttemplate: a({}, {}),
                hovertext: c({}, r.hovertext, {}),
                hovertemplate: o(),
                mode: c({}, r.mode, {
                  dflt: "lines+markers"
                }),
                surfaceaxis: {
                  valType: "enumerated",
                  values: [-1, 0, 1, 2],
                  dflt: -1
                },
                surfacecolor: {
                  valType: "color"
                },
                projection: {
                  x: {
                    show: {
                      valType: "boolean",
                      dflt: !1
                    },
                    opacity: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    },
                    scale: {
                      valType: "number",
                      min: 0,
                      max: 10,
                      dflt: 2 / 3
                    }
                  },
                  y: {
                    show: {
                      valType: "boolean",
                      dflt: !1
                    },
                    opacity: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    },
                    scale: {
                      valType: "number",
                      min: 0,
                      max: 10,
                      dflt: 2 / 3
                    }
                  },
                  z: {
                    show: {
                      valType: "boolean",
                      dflt: !1
                    },
                    opacity: {
                      valType: "number",
                      min: 0,
                      max: 1,
                      dflt: 1
                    },
                    scale: {
                      valType: "number",
                      min: 0,
                      max: 10,
                      dflt: 2 / 3
                    }
                  }
                },
                connectgaps: r.connectgaps,
                line: m,
                marker: c({
                  symbol: {
                    valType: "enumerated",
                    values: Object.keys(u),
                    dflt: "circle",
                    arrayOk: !0
                  },
                  size: c({}, f.size, {
                    dflt: 8
                  }),
                  sizeref: f.sizeref,
                  sizemin: f.sizemin,
                  sizemode: f.sizemode,
                  opacity: c({}, f.opacity, {
                    arrayOk: !1
                  }),
                  colorbar: f.colorbar,
                  line: c({
                    width: c({}, p.width, {
                      arrayOk: !1
                    })
                  }, i("marker.line"))
                }, i("marker")),
                textposition: c({}, r.textposition, {
                  dflt: "top center"
                }),
                textfont: {
                  color: r.textfont.color,
                  size: r.textfont.size,
                  family: c({}, r.textfont.family, {
                    arrayOk: !1
                  })
                },
                hoverinfo: c({}, s.hoverinfo)
              }, "calc", "nested");
            g.x.editType = g.y.editType = g.z.editType = "calc+clearAxisTypes";
          }, {
            "../../components/colorscale/attributes": 382,
            "../../constants/gl3d_dashes": 471,
            "../../constants/gl3d_markers": 472,
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plots/attributes": 538,
            "../../plots/template_attributes": 592,
            "../scatter/attributes": 622
          }],
          650: [function (e, t, n) {
            "use strict";

            var r = e("../scatter/arrays_to_calcdata"),
              i = e("../scatter/colorscale_calc");
            t.exports = function (e, t) {
              var n = [{
                x: !1,
                y: !1,
                trace: t,
                t: {}
              }];
              return r(n, t), i(e, t), n;
            };
          }, {
            "../scatter/arrays_to_calcdata": 621,
            "../scatter/colorscale_calc": 625
          }],
          651: [function (e, t, n) {
            "use strict";

            var r = e("../../registry");
            function i(e, t, n, i) {
              if (!t || !t.visible) return null;
              for (var o = r.getComponentMethod("errorbars", "makeComputeError")(t), a = new Array(e.length), s = 0; s < e.length; s++) {
                var l = o(+e[s], s);
                if ("log" === i.type) {
                  var u = i.c2l(e[s]),
                    c = e[s] - l[0],
                    d = e[s] + l[1];
                  if (a[s] = [(i.c2l(c, !0) - u) * n, (i.c2l(d, !0) - u) * n], c > 0) {
                    var h = i.c2l(c);
                    i._lowerLogErrorBound || (i._lowerLogErrorBound = h), i._lowerErrorBound = Math.min(i._lowerLogErrorBound, h);
                  }
                } else a[s] = [-l[0] * n, l[1] * n];
              }
              return a;
            }
            t.exports = function (e, t, n) {
              var r = [i(e.x, e.error_x, t[0], n.xaxis), i(e.y, e.error_y, t[1], n.yaxis), i(e.z, e.error_z, t[2], n.zaxis)],
                o = function (e) {
                  for (var t = 0; t < e.length; t++) if (e[t]) return e[t].length;
                  return 0;
                }(r);
              if (0 === o) return null;
              for (var a = new Array(o), s = 0; s < o; s++) {
                for (var l = [[0, 0, 0], [0, 0, 0]], u = 0; u < 3; u++) if (r[u]) for (var c = 0; c < 2; c++) l[c][u] = r[u][s][c];
                a[s] = l;
              }
              return a;
            };
          }, {
            "../../registry": 593
          }],
          652: [function (e, t, n) {
            "use strict";

            var r = e("gl-line3d"),
              i = e("gl-scatter3d"),
              o = e("gl-error3d"),
              a = e("gl-mesh3d"),
              s = e("delaunay-triangulate"),
              l = e("../../lib"),
              u = e("../../lib/str2rgbarray"),
              c = e("../../lib/gl_format_color").formatColor,
              d = e("../scatter/make_bubble_size_func"),
              h = e("../../constants/gl3d_dashes"),
              f = e("../../constants/gl3d_markers"),
              p = e("../../plots/cartesian/axes"),
              m = e("../../components/fx/helpers").appendArrayPointValue,
              g = e("./calc_errors");
            function v(e, t) {
              this.scene = e, this.uid = t, this.linePlot = null, this.scatterPlot = null, this.errorBars = null, this.textMarkers = null, this.delaunayMesh = null, this.color = null, this.mode = "", this.dataPoints = [], this.axesBounds = [[-1 / 0, -1 / 0, -1 / 0], [1 / 0, 1 / 0, 1 / 0]], this.textLabels = null, this.data = null;
            }
            var y = v.prototype;
            function b(e) {
              return null == e ? 0 : e.indexOf("left") > -1 ? -1 : e.indexOf("right") > -1 ? 1 : 0;
            }
            function _(e) {
              return null == e ? 0 : e.indexOf("top") > -1 ? -1 : e.indexOf("bottom") > -1 ? 1 : 0;
            }
            function x(e, t) {
              return t(4 * e);
            }
            function w(e) {
              return f[e];
            }
            function S(e, t, n, r, i) {
              var o = null;
              if (l.isArrayOrTypedArray(e)) {
                o = [];
                for (var a = 0; a < t; a++) void 0 === e[a] ? o[a] = r : o[a] = n(e[a], i);
              } else o = n(e, l.identity);
              return o;
            }
            function A(e, t) {
              var n,
                r,
                i,
                o,
                a,
                s,
                h = [],
                f = e.fullSceneLayout,
                v = e.dataScale,
                y = f.xaxis,
                A = f.yaxis,
                E = f.zaxis,
                T = t.marker,
                M = t.line,
                C = t.x || [],
                k = t.y || [],
                P = t.z || [],
                O = C.length,
                R = t.xcalendar,
                I = t.ycalendar,
                j = t.zcalendar;
              for (a = 0; a < O; a++) n = y.d2l(C[a], 0, R) * v[0], r = A.d2l(k[a], 0, I) * v[1], i = E.d2l(P[a], 0, j) * v[2], h[a] = [n, r, i];
              if (Array.isArray(t.text)) s = t.text;else if (void 0 !== t.text) for (s = new Array(O), a = 0; a < O; a++) s[a] = t.text;
              function N(e, t) {
                var n = f[e];
                return p.tickText(n, n.d2l(t), !0).text;
              }
              var L = t.texttemplate;
              if (L) {
                var D = e.fullLayout._d3locale,
                  B = Array.isArray(L),
                  F = B ? Math.min(L.length, O) : O,
                  z = B ? function (e) {
                    return L[e];
                  } : function () {
                    return L;
                  };
                for (s = new Array(F), a = 0; a < F; a++) {
                  var U = {
                      x: C[a],
                      y: k[a],
                      z: P[a]
                    },
                    G = {
                      xLabel: N("xaxis", C[a]),
                      yLabel: N("yaxis", k[a]),
                      zLabel: N("zaxis", P[a])
                    },
                    V = {};
                  m(V, t, a);
                  var H = t._meta || {};
                  s[a] = l.texttemplateString(z(a), G, D, V, U, H);
                }
              }
              if (o = {
                position: h,
                mode: t.mode,
                text: s
              }, "line" in t && (o.lineColor = c(M, 1, O), o.lineWidth = M.width, o.lineDashes = M.dash), "marker" in t) {
                var q = d(t);
                o.scatterColor = c(T, 1, O), o.scatterSize = S(T.size, O, x, 20, q), o.scatterMarker = S(T.symbol, O, w, "●"), o.scatterLineWidth = T.line.width, o.scatterLineColor = c(T.line, 1, O), o.scatterAngle = 0;
              }
              "textposition" in t && (o.textOffset = function (e) {
                var t = [0, 0];
                if (Array.isArray(e)) for (var n = 0; n < e.length; n++) t[n] = [0, 0], e[n] && (t[n][0] = b(e[n]), t[n][1] = _(e[n]));else t[0] = b(e), t[1] = _(e);
                return t;
              }(t.textposition), o.textColor = c(t.textfont, 1, O), o.textSize = S(t.textfont.size, O, l.identity, 12), o.textFont = t.textfont.family, o.textAngle = 0);
              var W = ["x", "y", "z"];
              for (o.project = [!1, !1, !1], o.projectScale = [1, 1, 1], o.projectOpacity = [1, 1, 1], a = 0; a < 3; ++a) {
                var $ = t.projection[W[a]];
                (o.project[a] = $.show) && (o.projectOpacity[a] = $.opacity, o.projectScale[a] = $.scale);
              }
              o.errorBounds = g(t, v, f);
              var X = function (e) {
                for (var t = [0, 0, 0], n = [[0, 0, 0], [0, 0, 0], [0, 0, 0]], r = [1, 1, 1], i = 0; i < 3; i++) {
                  var o = e[i];
                  o && !1 !== o.copy_zstyle && !1 !== e[2].visible && (o = e[2]), o && o.visible && (t[i] = o.width / 2, n[i] = u(o.color), r[i] = o.thickness);
                }
                return {
                  capSize: t,
                  color: n,
                  lineWidth: r
                };
              }([t.error_x, t.error_y, t.error_z]);
              return o.errorColor = X.color, o.errorLineWidth = X.lineWidth, o.errorCapSize = X.capSize, o.delaunayAxis = t.surfaceaxis, o.delaunayColor = u(t.surfacecolor), o;
            }
            function E(e) {
              if (Array.isArray(e)) {
                var t = e[0];
                return Array.isArray(t) && (e = t), "rgb(" + e.slice(0, 3).map(function (e) {
                  return Math.round(255 * e);
                }) + ")";
              }
              return null;
            }
            y.handlePick = function (e) {
              if (e.object && (e.object === this.linePlot || e.object === this.delaunayMesh || e.object === this.textMarkers || e.object === this.scatterPlot)) {
                var t = e.index = e.data.index;
                return e.object.highlight && e.object.highlight(null), this.scatterPlot && (e.object = this.scatterPlot, this.scatterPlot.highlight(e.data)), e.textLabel = "", this.textLabels && (Array.isArray(this.textLabels) ? (this.textLabels[t] || 0 === this.textLabels[t]) && (e.textLabel = this.textLabels[t]) : e.textLabel = this.textLabels), e.traceCoordinate = [this.data.x[t], this.data.y[t], this.data.z[t]], !0;
              }
            }, y.update = function (e) {
              var t,
                n,
                l,
                u,
                c = this.scene.glplot.gl,
                d = h.solid;
              this.data = e;
              var f = A(this.scene, e);
              "mode" in f && (this.mode = f.mode), "lineDashes" in f && f.lineDashes in h && (d = h[f.lineDashes]), this.color = E(f.scatterColor) || E(f.lineColor), this.dataPoints = f.position, t = {
                gl: this.scene.glplot.gl,
                position: f.position,
                color: f.lineColor,
                lineWidth: f.lineWidth || 1,
                dashes: d[0],
                dashScale: d[1],
                opacity: e.opacity,
                connectGaps: e.connectgaps
              }, -1 !== this.mode.indexOf("lines") ? this.linePlot ? this.linePlot.update(t) : (this.linePlot = r(t), this.linePlot._trace = this, this.scene.glplot.add(this.linePlot)) : this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose(), this.linePlot = null);
              var p = e.opacity;
              if (e.marker && e.marker.opacity && (p *= e.marker.opacity), n = {
                gl: this.scene.glplot.gl,
                position: f.position,
                color: f.scatterColor,
                size: f.scatterSize,
                glyph: f.scatterMarker,
                opacity: p,
                orthographic: !0,
                lineWidth: f.scatterLineWidth,
                lineColor: f.scatterLineColor,
                project: f.project,
                projectScale: f.projectScale,
                projectOpacity: f.projectOpacity
              }, -1 !== this.mode.indexOf("markers") ? this.scatterPlot ? this.scatterPlot.update(n) : (this.scatterPlot = i(n), this.scatterPlot._trace = this, this.scatterPlot.highlightScale = 1, this.scene.glplot.add(this.scatterPlot)) : this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose(), this.scatterPlot = null), u = {
                gl: this.scene.glplot.gl,
                position: f.position,
                glyph: f.text,
                color: f.textColor,
                size: f.textSize,
                angle: f.textAngle,
                alignment: f.textOffset,
                font: f.textFont,
                orthographic: !0,
                lineWidth: 0,
                project: !1,
                opacity: e.opacity
              }, this.textLabels = e.hovertext || e.text, -1 !== this.mode.indexOf("text") ? this.textMarkers ? this.textMarkers.update(u) : (this.textMarkers = i(u), this.textMarkers._trace = this, this.textMarkers.highlightScale = 1, this.scene.glplot.add(this.textMarkers)) : this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose(), this.textMarkers = null), l = {
                gl: this.scene.glplot.gl,
                position: f.position,
                color: f.errorColor,
                error: f.errorBounds,
                lineWidth: f.errorLineWidth,
                capSize: f.errorCapSize,
                opacity: e.opacity
              }, this.errorBars ? f.errorBounds ? this.errorBars.update(l) : (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose(), this.errorBars = null) : f.errorBounds && (this.errorBars = o(l), this.errorBars._trace = this, this.scene.glplot.add(this.errorBars)), f.delaunayAxis >= 0) {
                var m = function (e, t, n) {
                  var r,
                    i = (n + 1) % 3,
                    o = (n + 2) % 3,
                    a = [],
                    l = [];
                  for (r = 0; r < e.length; ++r) {
                    var u = e[r];
                    !isNaN(u[i]) && isFinite(u[i]) && !isNaN(u[o]) && isFinite(u[o]) && (a.push([u[i], u[o]]), l.push(r));
                  }
                  var c = s(a);
                  for (r = 0; r < c.length; ++r) for (var d = c[r], h = 0; h < d.length; ++h) d[h] = l[d[h]];
                  return {
                    positions: e,
                    cells: c,
                    meshColor: t
                  };
                }(f.position, f.delaunayColor, f.delaunayAxis);
                m.opacity = e.opacity, this.delaunayMesh ? this.delaunayMesh.update(m) : (m.gl = c, this.delaunayMesh = a(m), this.delaunayMesh._trace = this, this.scene.glplot.add(this.delaunayMesh));
              } else this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose(), this.delaunayMesh = null);
            }, y.dispose = function () {
              this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose()), this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose()), this.errorBars && (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose()), this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose()), this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose());
            }, t.exports = function (e, t) {
              var n = new v(e, t.uid);
              return n.update(t), n;
            };
          }, {
            "../../components/fx/helpers": 410,
            "../../constants/gl3d_dashes": 471,
            "../../constants/gl3d_markers": 472,
            "../../lib": 495,
            "../../lib/gl_format_color": 493,
            "../../lib/str2rgbarray": 517,
            "../../plots/cartesian/axes": 541,
            "../scatter/make_bubble_size_func": 639,
            "./calc_errors": 651,
            "delaunay-triangulate": 84,
            "gl-error3d": 110,
            "gl-line3d": 115,
            "gl-mesh3d": 140,
            "gl-scatter3d": 148
          }],
          653: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib"),
              o = e("../scatter/subtypes"),
              a = e("../scatter/marker_defaults"),
              s = e("../scatter/line_defaults"),
              l = e("../scatter/text_defaults"),
              u = e("./attributes");
            t.exports = function (e, t, n, c) {
              function d(n, r) {
                return i.coerce(e, t, u, n, r);
              }
              if (function (e, t, n, i) {
                var o = 0,
                  a = n("x"),
                  s = n("y"),
                  l = n("z");
                return r.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y", "z"], i), a && s && l && (o = Math.min(a.length, s.length, l.length), t._length = t._xlength = t._ylength = t._zlength = o), o;
              }(e, t, d, c)) {
                d("text"), d("hovertext"), d("hovertemplate"), d("mode"), o.hasLines(t) && (d("connectgaps"), s(e, t, n, c, d)), o.hasMarkers(t) && a(e, t, n, c, d, {
                  noSelect: !0
                }), o.hasText(t) && (d("texttemplate"), l(e, t, c, d, {
                  noSelect: !0
                }));
                var h = (t.line || {}).color,
                  f = (t.marker || {}).color;
                d("surfaceaxis") >= 0 && d("surfacecolor", h || f);
                for (var p = ["x", "y", "z"], m = 0; m < 3; ++m) {
                  var g = "projection." + p[m];
                  d(g + ".show") && (d(g + ".opacity"), d(g + ".scale"));
                }
                var v = r.getComponentMethod("errorbars", "supplyDefaults");
                v(e, t, h || f || n, {
                  axis: "z"
                }), v(e, t, h || f || n, {
                  axis: "y",
                  inherit: "z"
                }), v(e, t, h || f || n, {
                  axis: "x",
                  inherit: "z"
                });
              } else t.visible = !1;
            };
          }, {
            "../../lib": 495,
            "../../registry": 593,
            "../scatter/line_defaults": 635,
            "../scatter/marker_defaults": 641,
            "../scatter/subtypes": 646,
            "../scatter/text_defaults": 647,
            "./attributes": 649
          }],
          654: [function (e, t, n) {
            "use strict";

            t.exports = {
              plot: e("./convert"),
              attributes: e("./attributes"),
              markerSymbols: e("../../constants/gl3d_markers"),
              supplyDefaults: e("./defaults"),
              colorbar: [{
                container: "marker",
                min: "cmin",
                max: "cmax"
              }, {
                container: "line",
                min: "cmin",
                max: "cmax"
              }],
              calc: e("./calc"),
              moduleType: "trace",
              name: "scatter3d",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "symbols", "showLegend", "scatter-like"],
              meta: {}
            };
          }, {
            "../../constants/gl3d_markers": 472,
            "../../plots/gl3d": 570,
            "./attributes": 649,
            "./calc": 650,
            "./convert": 652,
            "./defaults": 653
          }],
          655: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/attributes"),
              i = e("../../plots/template_attributes").hovertemplateAttrs,
              o = e("../mesh3d/attributes"),
              a = e("../../plots/attributes"),
              s = e("../../lib/extend").extendFlat,
              l = {
                x: {
                  valType: "data_array",
                  editType: "calc+clearAxisTypes"
                },
                y: {
                  valType: "data_array",
                  editType: "calc+clearAxisTypes"
                },
                z: {
                  valType: "data_array",
                  editType: "calc+clearAxisTypes"
                },
                u: {
                  valType: "data_array",
                  editType: "calc"
                },
                v: {
                  valType: "data_array",
                  editType: "calc"
                },
                w: {
                  valType: "data_array",
                  editType: "calc"
                },
                starts: {
                  x: {
                    valType: "data_array",
                    editType: "calc"
                  },
                  y: {
                    valType: "data_array",
                    editType: "calc"
                  },
                  z: {
                    valType: "data_array",
                    editType: "calc"
                  },
                  editType: "calc"
                },
                maxdisplayed: {
                  valType: "integer",
                  min: 0,
                  dflt: 1e3,
                  editType: "calc"
                },
                sizeref: {
                  valType: "number",
                  editType: "calc",
                  min: 0,
                  dflt: 1
                },
                text: {
                  valType: "string",
                  dflt: "",
                  editType: "calc"
                },
                hovertext: {
                  valType: "string",
                  dflt: "",
                  editType: "calc"
                },
                hovertemplate: i({
                  editType: "calc"
                }, {
                  keys: ["tubex", "tubey", "tubez", "tubeu", "tubev", "tubew", "norm", "divergence"]
                }),
                showlegend: s({}, a.showlegend, {
                  dflt: !1
                })
              };
            s(l, r("", {
              colorAttr: "u/v/w norm",
              showScaleDflt: !0,
              editTypeOverride: "calc"
            })), ["opacity", "lightposition", "lighting"].forEach(function (e) {
              l[e] = o[e];
            }), l.hoverinfo = s({}, a.hoverinfo, {
              editType: "calc",
              flags: ["x", "y", "z", "u", "v", "w", "norm", "divergence", "text", "name"],
              dflt: "x+y+z+norm+text+name"
            }), l.transforms = void 0, t.exports = l;
          }, {
            "../../components/colorscale/attributes": 382,
            "../../lib/extend": 489,
            "../../plots/attributes": 538,
            "../../plots/template_attributes": 592,
            "../mesh3d/attributes": 614
          }],
          656: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../components/colorscale/calc");
            function o(e) {
              var t,
                n,
                i,
                o,
                s,
                l,
                u,
                c,
                d,
                h,
                f,
                p,
                m = e._x,
                g = e._y,
                v = e._z,
                y = e._len,
                b = -1 / 0,
                _ = 1 / 0,
                x = -1 / 0,
                w = 1 / 0,
                S = -1 / 0,
                A = 1 / 0,
                E = "";
              for (y && (u = m[0], d = g[0], f = v[0]), y > 1 && (c = m[y - 1], h = g[y - 1], p = v[y - 1]), t = 0; t < y; t++) b = Math.max(b, m[t]), _ = Math.min(_, m[t]), x = Math.max(x, g[t]), w = Math.min(w, g[t]), S = Math.max(S, v[t]), A = Math.min(A, v[t]), o || m[t] === u || (o = !0, E += "x"), s || g[t] === d || (s = !0, E += "y"), l || v[t] === f || (l = !0, E += "z");
              o || (E += "x"), s || (E += "y"), l || (E += "z");
              var T = a(e._x),
                M = a(e._y),
                C = a(e._z);
              E = (E = (E = E.replace("x", (u > c ? "-" : "+") + "x")).replace("y", (d > h ? "-" : "+") + "y")).replace("z", (f > p ? "-" : "+") + "z");
              var k = function k() {
                y = 0, T = [], M = [], C = [];
              };
              (!y || y < T.length * M.length * C.length) && k();
              var P = function P(e) {
                  return "x" === e ? m : "y" === e ? g : v;
                },
                O = function O(e) {
                  return "x" === e ? T : "y" === e ? M : C;
                },
                R = function R(e) {
                  return e[y - 1] < e[0] ? -1 : 1;
                },
                I = P(E[1]),
                j = P(E[3]),
                N = P(E[5]),
                L = O(E[1]).length,
                D = O(E[3]).length,
                B = O(E[5]).length,
                F = !1,
                z = function z(e, t, n) {
                  return L * (D * e + t) + n;
                },
                U = R(P(E[1])),
                G = R(P(E[3])),
                V = R(P(E[5]));
              for (t = 0; t < B - 1; t++) {
                for (n = 0; n < D - 1; n++) {
                  for (i = 0; i < L - 1; i++) {
                    var H = z(t, n, i),
                      q = z(t, n, i + 1),
                      W = z(t, n + 1, i),
                      $ = z(t + 1, n, i);
                    if (I[H] * U < I[q] * U && j[H] * G < j[W] * G && N[H] * V < N[$] * V || (F = !0), F) break;
                  }
                  if (F) break;
                }
                if (F) break;
              }
              return F && (r.warn("Encountered arbitrary coordinates! Unable to input data grid."), k()), {
                xMin: _,
                yMin: w,
                zMin: A,
                xMax: b,
                yMax: x,
                zMax: S,
                Xs: T,
                Ys: M,
                Zs: C,
                len: y,
                fill: E
              };
            }
            function a(e) {
              return r.distinctVals(e).vals;
            }
            function s(e, t) {
              if (void 0 === t && (t = e.length), r.isTypedArray(e)) return e.subarray(0, t);
              for (var n = [], i = 0; i < t; i++) n[i] = +e[i];
              return n;
            }
            t.exports = {
              calc: function calc(e, t) {
                t._len = Math.min(t.u.length, t.v.length, t.w.length, t.x.length, t.y.length, t.z.length), t._u = s(t.u, t._len), t._v = s(t.v, t._len), t._w = s(t.w, t._len), t._x = s(t.x, t._len), t._y = s(t.y, t._len), t._z = s(t.z, t._len);
                var n = o(t);
                t._gridFill = n.fill, t._Xs = n.Xs, t._Ys = n.Ys, t._Zs = n.Zs, t._len = n.len;
                var r,
                  a,
                  l,
                  u = 0;
                t.starts && (r = s(t.starts.x || []), a = s(t.starts.y || []), l = s(t.starts.z || []), u = Math.min(r.length, a.length, l.length)), t._startsX = r || [], t._startsY = a || [], t._startsZ = l || [];
                var c,
                  d = 0,
                  h = 1 / 0;
                for (c = 0; c < t._len; c++) {
                  var f = t._u[c],
                    p = t._v[c],
                    m = t._w[c],
                    g = Math.sqrt(f * f + p * p + m * m);
                  d = Math.max(d, g), h = Math.min(h, g);
                }
                for (i(e, t, {
                  vals: [h, d],
                  containerStr: "",
                  cLetter: "c"
                }), c = 0; c < u; c++) {
                  var v = r[c];
                  n.xMax = Math.max(n.xMax, v), n.xMin = Math.min(n.xMin, v);
                  var y = a[c];
                  n.yMax = Math.max(n.yMax, y), n.yMin = Math.min(n.yMin, y);
                  var b = l[c];
                  n.zMax = Math.max(n.zMax, b), n.zMin = Math.min(n.zMin, b);
                }
                t._slen = u, t._normMax = d, t._xbnds = [n.xMin, n.xMax], t._ybnds = [n.yMin, n.yMax], t._zbnds = [n.zMin, n.zMax];
              },
              filter: s,
              processGrid: o
            };
          }, {
            "../../components/colorscale/calc": 383,
            "../../lib": 495
          }],
          657: [function (e, t, n) {
            "use strict";

            var r = e("gl-streamtube3d"),
              i = r.createTubeMesh,
              o = e("../../lib"),
              a = e("../../lib/gl_format_color").parseColorScale,
              s = e("../../components/colorscale").extractOpts,
              l = e("../../plots/gl3d/zip3"),
              u = {
                xaxis: 0,
                yaxis: 1,
                zaxis: 2
              };
            function c(e, t) {
              this.scene = e, this.uid = t, this.mesh = null, this.data = null;
            }
            var d = c.prototype;
            function h(e) {
              var t = e.length;
              return t > 2 ? e.slice(1, t - 1) : 2 === t ? [(e[0] + e[1]) / 2] : e;
            }
            function f(e) {
              var t = e.length;
              return 1 === t ? [.5, .5] : [e[1] - e[0], e[t - 1] - e[t - 2]];
            }
            function p(e, t) {
              var n = e.fullSceneLayout,
                i = e.dataScale,
                c = t._len,
                d = {};
              function p(e, t) {
                var r = n[t],
                  a = i[u[t]];
                return o.simpleMap(e, function (e) {
                  return r.d2l(e) * a;
                });
              }
              if (d.vectors = l(p(t._u, "xaxis"), p(t._v, "yaxis"), p(t._w, "zaxis"), c), !c) return {
                positions: [],
                cells: []
              };
              var m = p(t._Xs, "xaxis"),
                g = p(t._Ys, "yaxis"),
                v = p(t._Zs, "zaxis");
              if (d.meshgrid = [m, g, v], d.gridFill = t._gridFill, t._slen) d.startingPositions = l(p(t._startsX, "xaxis"), p(t._startsY, "yaxis"), p(t._startsZ, "zaxis"));else {
                for (var y = g[0], b = h(m), _ = h(v), x = new Array(b.length * _.length), w = 0, S = 0; S < b.length; S++) for (var A = 0; A < _.length; A++) x[w++] = [b[S], y, _[A]];
                d.startingPositions = x;
              }
              d.colormap = a(t), d.tubeSize = t.sizeref, d.maxLength = t.maxdisplayed;
              var E = p(t._xbnds, "xaxis"),
                T = p(t._ybnds, "yaxis"),
                M = p(t._zbnds, "zaxis"),
                C = f(m),
                k = f(g),
                P = f(v),
                O = [[E[0] - C[0], T[0] - k[0], M[0] - P[0]], [E[1] + C[1], T[1] + k[1], M[1] + P[1]]],
                R = r(d, O),
                I = s(t);
              R.vertexIntensityBounds = [I.min / t._normMax, I.max / t._normMax];
              var j = t.lightposition;
              return R.lightPosition = [j.x, j.y, j.z], R.ambient = t.lighting.ambient, R.diffuse = t.lighting.diffuse, R.specular = t.lighting.specular, R.roughness = t.lighting.roughness, R.fresnel = t.lighting.fresnel, R.opacity = t.opacity, t._pad = R.tubeScale * t.sizeref * 2, R;
            }
            d.handlePick = function (e) {
              var t = this.scene.fullSceneLayout,
                n = this.scene.dataScale;
              function r(e, r) {
                var i = t[r],
                  o = n[u[r]];
                return i.l2c(e) / o;
              }
              if (e.object === this.mesh) {
                var i = e.data.position,
                  o = e.data.velocity;
                return e.traceCoordinate = [r(i[0], "xaxis"), r(i[1], "yaxis"), r(i[2], "zaxis"), r(o[0], "xaxis"), r(o[1], "yaxis"), r(o[2], "zaxis"), e.data.intensity * this.data._normMax, e.data.divergence], e.textLabel = this.data.hovertext || this.data.text, !0;
              }
            }, d.update = function (e) {
              this.data = e;
              var t = p(this.scene, e);
              this.mesh.update(t);
            }, d.dispose = function () {
              this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            }, t.exports = function (e, t) {
              var n = e.glplot.gl,
                r = p(e, t),
                o = i(n, r),
                a = new c(e, t.uid);
              return a.mesh = o, a.data = t, o._trace = a, e.glplot.add(o), a;
            };
          }, {
            "../../components/colorscale": 387,
            "../../lib": 495,
            "../../lib/gl_format_color": 493,
            "../../plots/gl3d/zip3": 581,
            "gl-streamtube3d": 160
          }],
          658: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("../../components/colorscale/defaults"),
              o = e("./attributes");
            t.exports = function (e, t, n, a) {
              function s(n, i) {
                return r.coerce(e, t, o, n, i);
              }
              var l = s("u"),
                u = s("v"),
                c = s("w"),
                d = s("x"),
                h = s("y"),
                f = s("z");
              l && l.length && u && u.length && c && c.length && d && d.length && h && h.length && f && f.length ? (s("starts.x"), s("starts.y"), s("starts.z"), s("maxdisplayed"), s("sizeref"), s("lighting.ambient"), s("lighting.diffuse"), s("lighting.specular"), s("lighting.roughness"), s("lighting.fresnel"), s("lightposition.x"), s("lightposition.y"), s("lightposition.z"), i(e, t, a, s, {
                prefix: "",
                cLetter: "c"
              }), s("text"), s("hovertext"), s("hovertemplate"), t._length = null) : t.visible = !1;
            };
          }, {
            "../../components/colorscale/defaults": 385,
            "../../lib": 495,
            "./attributes": 655
          }],
          659: [function (e, t, n) {
            "use strict";

            t.exports = {
              moduleType: "trace",
              name: "streamtube",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "showLegend"],
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              colorbar: {
                min: "cmin",
                max: "cmax"
              },
              calc: e("./calc").calc,
              plot: e("./convert"),
              eventData: function eventData(e, t) {
                return e.tubex = e.x, e.tubey = e.y, e.tubez = e.z, e.tubeu = t.traceCoordinate[3], e.tubev = t.traceCoordinate[4], e.tubew = t.traceCoordinate[5], e.norm = t.traceCoordinate[6], e.divergence = t.traceCoordinate[7], delete e.x, delete e.y, delete e.z, e;
              },
              meta: {}
            };
          }, {
            "../../plots/gl3d": 570,
            "./attributes": 655,
            "./calc": 656,
            "./convert": 657,
            "./defaults": 658
          }],
          660: [function (e, t, n) {
            "use strict";

            var r = e("../../components/color"),
              i = e("../../components/colorscale/attributes"),
              o = e("../../plots/template_attributes").hovertemplateAttrs,
              a = e("../../plots/attributes"),
              s = e("../../lib/extend").extendFlat,
              l = e("../../plot_api/edit_types").overrideAll;
            function u(e) {
              return {
                show: {
                  valType: "boolean",
                  dflt: !1
                },
                start: {
                  valType: "number",
                  dflt: null,
                  editType: "plot"
                },
                end: {
                  valType: "number",
                  dflt: null,
                  editType: "plot"
                },
                size: {
                  valType: "number",
                  dflt: null,
                  min: 0,
                  editType: "plot"
                },
                project: {
                  x: {
                    valType: "boolean",
                    dflt: !1
                  },
                  y: {
                    valType: "boolean",
                    dflt: !1
                  },
                  z: {
                    valType: "boolean",
                    dflt: !1
                  }
                },
                color: {
                  valType: "color",
                  dflt: r.defaultLine
                },
                usecolormap: {
                  valType: "boolean",
                  dflt: !1
                },
                width: {
                  valType: "number",
                  min: 1,
                  max: 16,
                  dflt: 2
                },
                highlight: {
                  valType: "boolean",
                  dflt: !0
                },
                highlightcolor: {
                  valType: "color",
                  dflt: r.defaultLine
                },
                highlightwidth: {
                  valType: "number",
                  min: 1,
                  max: 16,
                  dflt: 2
                }
              };
            }
            var c = t.exports = l(s({
              z: {
                valType: "data_array"
              },
              x: {
                valType: "data_array"
              },
              y: {
                valType: "data_array"
              },
              text: {
                valType: "string",
                dflt: "",
                arrayOk: !0
              },
              hovertext: {
                valType: "string",
                dflt: "",
                arrayOk: !0
              },
              hovertemplate: o(),
              connectgaps: {
                valType: "boolean",
                dflt: !1,
                editType: "calc"
              },
              surfacecolor: {
                valType: "data_array"
              }
            }, i("", {
              colorAttr: "z or surfacecolor",
              showScaleDflt: !0,
              autoColorDflt: !1,
              editTypeOverride: "calc"
            }), {
              contours: {
                x: u(),
                y: u(),
                z: u()
              },
              hidesurface: {
                valType: "boolean",
                dflt: !1
              },
              lightposition: {
                x: {
                  valType: "number",
                  min: -1e5,
                  max: 1e5,
                  dflt: 10
                },
                y: {
                  valType: "number",
                  min: -1e5,
                  max: 1e5,
                  dflt: 1e4
                },
                z: {
                  valType: "number",
                  min: -1e5,
                  max: 1e5,
                  dflt: 0
                }
              },
              lighting: {
                ambient: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: .8
                },
                diffuse: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: .8
                },
                specular: {
                  valType: "number",
                  min: 0,
                  max: 2,
                  dflt: .05
                },
                roughness: {
                  valType: "number",
                  min: 0,
                  max: 1,
                  dflt: .5
                },
                fresnel: {
                  valType: "number",
                  min: 0,
                  max: 5,
                  dflt: .2
                }
              },
              opacity: {
                valType: "number",
                min: 0,
                max: 1,
                dflt: 1
              },
              _deprecated: {
                zauto: s({}, i.zauto, {}),
                zmin: s({}, i.zmin, {}),
                zmax: s({}, i.zmax, {})
              },
              hoverinfo: s({}, a.hoverinfo),
              showlegend: s({}, a.showlegend, {
                dflt: !1
              })
            }), "calc", "nested");
            c.x.editType = c.y.editType = c.z.editType = "calc+clearAxisTypes", c.transforms = void 0;
          }, {
            "../../components/color": 375,
            "../../components/colorscale/attributes": 382,
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plots/attributes": 538,
            "../../plots/template_attributes": 592
          }],
          661: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/calc");
            t.exports = function (e, t) {
              t.surfacecolor ? r(e, t, {
                vals: t.surfacecolor,
                containerStr: "",
                cLetter: "c"
              }) : r(e, t, {
                vals: t.z,
                containerStr: "",
                cLetter: "c"
              });
            };
          }, {
            "../../components/colorscale/calc": 383
          }],
          662: [function (e, t, n) {
            "use strict";

            var r = e("gl-surface3d"),
              i = e("ndarray"),
              o = e("ndarray-homography"),
              a = e("ndarray-fill"),
              s = e("../../lib").isArrayOrTypedArray,
              l = e("../../lib/gl_format_color").parseColorScale,
              u = e("../../lib/str2rgbarray"),
              c = e("../../components/colorscale").extractOpts,
              d = e("../heatmap/interp2d"),
              h = e("../heatmap/find_empties");
            function f(e, t, n) {
              this.scene = e, this.uid = n, this.surface = t, this.data = null, this.showContour = [!1, !1, !1], this.contourStart = [null, null, null], this.contourEnd = [null, null, null], this.contourSize = [0, 0, 0], this.minValues = [1 / 0, 1 / 0, 1 / 0], this.maxValues = [-1 / 0, -1 / 0, -1 / 0], this.dataScaleX = 1, this.dataScaleY = 1, this.refineData = !0, this.objectOffset = [0, 0, 0];
            }
            var p = f.prototype;
            p.getXat = function (e, t, n, r) {
              var i = s(this.data.x) ? s(this.data.x[0]) ? this.data.x[t][e] : this.data.x[e] : e;
              return void 0 === n ? i : r.d2l(i, 0, n);
            }, p.getYat = function (e, t, n, r) {
              var i = s(this.data.y) ? s(this.data.y[0]) ? this.data.y[t][e] : this.data.y[t] : t;
              return void 0 === n ? i : r.d2l(i, 0, n);
            }, p.getZat = function (e, t, n, r) {
              var i = this.data.z[t][e];
              return null === i && this.data.connectgaps && this.data._interpolatedZ && (i = this.data._interpolatedZ[t][e]), void 0 === n ? i : r.d2l(i, 0, n);
            }, p.handlePick = function (e) {
              if (e.object === this.surface) {
                var t = (e.data.index[0] - 1) / this.dataScaleX - 1,
                  n = (e.data.index[1] - 1) / this.dataScaleY - 1,
                  r = Math.max(Math.min(Math.round(t), this.data.z[0].length - 1), 0),
                  i = Math.max(Math.min(Math.round(n), this.data._ylength - 1), 0);
                e.index = [r, i], e.traceCoordinate = [this.getXat(r, i), this.getYat(r, i), this.getZat(r, i)], e.dataCoordinate = [this.getXat(r, i, this.data.xcalendar, this.scene.fullSceneLayout.xaxis), this.getYat(r, i, this.data.ycalendar, this.scene.fullSceneLayout.yaxis), this.getZat(r, i, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)];
                for (var o = 0; o < 3; o++) null != e.dataCoordinate[o] && (e.dataCoordinate[o] *= this.scene.dataScale[o]);
                var a = this.data.hovertext || this.data.text;
                return Array.isArray(a) && a[i] && void 0 !== a[i][r] ? e.textLabel = a[i][r] : e.textLabel = a || "", e.data.dataCoordinate = e.dataCoordinate.slice(), this.surface.highlight(e.data), this.scene.glplot.spikes.position = e.dataCoordinate, !0;
              }
            };
            var m = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997, 1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097, 1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297, 1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399, 1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499, 1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597, 1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699, 1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789, 1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889, 1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999, 2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099, 2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179, 2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297, 2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399, 2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477, 2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593, 2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699, 2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797, 2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897, 2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999];
            function g(e, t) {
              if (e < t) return 0;
              for (var n = 0; 0 === Math.floor(e % t);) e /= t, n++;
              return n;
            }
            function v(e) {
              for (var t = [], n = 0; n < m.length; n++) {
                var r = m[n];
                t.push(g(e, r));
              }
              return t;
            }
            function y(e) {
              for (var t = v(e), n = e, r = 0; r < m.length; r++) if (t[r] > 0) {
                n = m[r];
                break;
              }
              return n;
            }
            function b(e, t) {
              if (!(e < 1 || t < 1)) {
                for (var n = v(e), r = v(t), i = 1, o = 0; o < m.length; o++) i *= Math.pow(m[o], Math.max(n[o], r[o]));
                return i;
              }
            }
            p.calcXnums = function (e) {
              var t,
                n = [];
              for (t = 1; t < e; t++) {
                var r = this.getXat(t - 1, 0),
                  i = this.getXat(t, 0);
                n[t - 1] = i !== r && null != r && null != i ? Math.abs(i - r) : 0;
              }
              var o = 0;
              for (t = 1; t < e; t++) o += n[t - 1];
              for (t = 1; t < e; t++) 0 === n[t - 1] ? n[t - 1] = 1 : n[t - 1] = Math.round(o / n[t - 1]);
              return n;
            }, p.calcYnums = function (e) {
              var t,
                n = [];
              for (t = 1; t < e; t++) {
                var r = this.getYat(0, t - 1),
                  i = this.getYat(0, t);
                n[t - 1] = i !== r && null != r && null != i ? Math.abs(i - r) : 0;
              }
              var o = 0;
              for (t = 1; t < e; t++) o += n[t - 1];
              for (t = 1; t < e; t++) 0 === n[t - 1] ? n[t - 1] = 1 : n[t - 1] = Math.round(o / n[t - 1]);
              return n;
            };
            var _ = [1, 2, 4, 6, 12, 24, 36, 48, 60, 120, 180, 240, 360, 720, 840, 1260],
              x = _[9],
              w = _[13];
            function S(e, t) {
              for (var n = !1, r = 0; r < e.length; r++) if (t === e[r]) {
                n = !0;
                break;
              }
              !1 === n && e.push(t);
            }
            p.estimateScale = function (e, t) {
              for (var n = 1 + function (e) {
                if (0 !== e.length) {
                  for (var t = 1, n = 0; n < e.length; n++) t = b(t, e[n]);
                  return t;
                }
              }(0 === t ? this.calcXnums(e) : this.calcYnums(e)); n < x;) n *= 2;
              for (; n > w;) n--, n /= y(n), ++n < x && (n = w);
              var r = Math.round(n / e);
              return r > 1 ? r : 1;
            }, p.refineCoords = function (e) {
              for (var t = this.dataScaleX, n = this.dataScaleY, r = e[0].shape[0], a = e[0].shape[1], s = 0 | Math.floor(e[0].shape[0] * t + 1), l = 0 | Math.floor(e[0].shape[1] * n + 1), u = 1 + r + 1, c = 1 + a + 1, d = i(new Float32Array(u * c), [u, c]), h = 0; h < e.length; ++h) {
                this.surface.padField(d, e[h]);
                var f = i(new Float32Array(s * l), [s, l]);
                o(f, d, [t, 0, 0, 0, n, 0, 0, 0, 1]), e[h] = f;
              }
            }, p.setContourLevels = function () {
              var e,
                t,
                n,
                r = [[], [], []],
                i = [!1, !1, !1],
                o = !1;
              for (e = 0; e < 3; ++e) if (this.showContour[e] && (o = !0, this.contourSize[e] > 0 && null !== this.contourStart[e] && null !== this.contourEnd[e] && this.contourEnd[e] > this.contourStart[e])) for (i[e] = !0, t = this.contourStart[e]; t < this.contourEnd[e]; t += this.contourSize[e]) n = t * this.scene.dataScale[e], S(r[e], n);
              if (o) {
                var a = [[], [], []];
                for (e = 0; e < 3; ++e) this.showContour[e] && (a[e] = i[e] ? r[e] : this.scene.contourLevels[e]);
                this.surface.update({
                  levels: a
                });
              }
            }, p.update = function (e) {
              var t,
                n,
                r,
                o,
                s = this.scene,
                f = s.fullSceneLayout,
                p = this.surface,
                m = e.opacity,
                g = l(e, m),
                v = s.dataScale,
                y = e.z[0].length,
                b = e._ylength,
                _ = s.contourLevels;
              this.data = e;
              var x = [];
              for (t = 0; t < 3; t++) for (x[t] = [], n = 0; n < y; n++) x[t][n] = [];
              for (n = 0; n < y; n++) for (r = 0; r < b; r++) x[0][n][r] = this.getXat(n, r, e.xcalendar, f.xaxis), x[1][n][r] = this.getYat(n, r, e.ycalendar, f.yaxis), x[2][n][r] = this.getZat(n, r, e.zcalendar, f.zaxis);
              if (e.connectgaps) for (e._emptypoints = h(x[2]), d(x[2], e._emptypoints), e._interpolatedZ = [], n = 0; n < y; n++) for (e._interpolatedZ[n] = [], r = 0; r < b; r++) e._interpolatedZ[n][r] = x[2][n][r];
              for (t = 0; t < 3; t++) for (n = 0; n < y; n++) for (r = 0; r < b; r++) null == (o = x[t][n][r]) ? x[t][n][r] = NaN : o = x[t][n][r] *= v[t];
              for (t = 0; t < 3; t++) for (n = 0; n < y; n++) for (r = 0; r < b; r++) null != (o = x[t][n][r]) && (this.minValues[t] > o && (this.minValues[t] = o), this.maxValues[t] < o && (this.maxValues[t] = o));
              for (t = 0; t < 3; t++) this.objectOffset[t] = .5 * (this.minValues[t] + this.maxValues[t]);
              for (t = 0; t < 3; t++) for (n = 0; n < y; n++) for (r = 0; r < b; r++) null != (o = x[t][n][r]) && (x[t][n][r] -= this.objectOffset[t]);
              var S = [i(new Float32Array(y * b), [y, b]), i(new Float32Array(y * b), [y, b]), i(new Float32Array(y * b), [y, b])];
              a(S[0], function (e, t) {
                return x[0][e][t];
              }), a(S[1], function (e, t) {
                return x[1][e][t];
              }), a(S[2], function (e, t) {
                return x[2][e][t];
              }), x = [];
              var A = {
                  colormap: g,
                  levels: [[], [], []],
                  showContour: [!0, !0, !0],
                  showSurface: !e.hidesurface,
                  contourProject: [[!1, !1, !1], [!1, !1, !1], [!1, !1, !1]],
                  contourWidth: [1, 1, 1],
                  contourColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
                  contourTint: [1, 1, 1],
                  dynamicColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
                  dynamicWidth: [1, 1, 1],
                  dynamicTint: [1, 1, 1],
                  opacity: e.opacity
                },
                E = c(e);
              if (A.intensityBounds = [E.min, E.max], e.surfacecolor) {
                var T = i(new Float32Array(y * b), [y, b]);
                a(T, function (t, n) {
                  return e.surfacecolor[n][t];
                }), S.push(T);
              } else A.intensityBounds[0] *= v[2], A.intensityBounds[1] *= v[2];
              (w < S[0].shape[0] || w < S[0].shape[1]) && (this.refineData = !1), !0 === this.refineData && (this.dataScaleX = this.estimateScale(S[0].shape[0], 0), this.dataScaleY = this.estimateScale(S[0].shape[1], 1), 1 === this.dataScaleX && 1 === this.dataScaleY || this.refineCoords(S)), e.surfacecolor && (A.intensity = S.pop());
              var M = [!0, !0, !0],
                C = ["x", "y", "z"];
              for (t = 0; t < 3; ++t) {
                var k = e.contours[C[t]];
                M[t] = k.highlight, A.showContour[t] = k.show || k.highlight, A.showContour[t] && (A.contourProject[t] = [k.project.x, k.project.y, k.project.z], k.show ? (this.showContour[t] = !0, A.levels[t] = _[t], p.highlightColor[t] = A.contourColor[t] = u(k.color), k.usecolormap ? p.highlightTint[t] = A.contourTint[t] = 0 : p.highlightTint[t] = A.contourTint[t] = 1, A.contourWidth[t] = k.width, this.contourStart[t] = k.start, this.contourEnd[t] = k.end, this.contourSize[t] = k.size) : (this.showContour[t] = !1, this.contourStart[t] = null, this.contourEnd[t] = null, this.contourSize[t] = 0), k.highlight && (A.dynamicColor[t] = u(k.highlightcolor), A.dynamicWidth[t] = k.highlightwidth));
              }
              (function (e) {
                var t = e[0].rgb,
                  n = e[e.length - 1].rgb;
                return t[0] === n[0] && t[1] === n[1] && t[2] === n[2] && t[3] === n[3];
              })(g) && (A.vertexColor = !0), A.objectOffset = this.objectOffset, A.coords = S, p.update(A), p.visible = e.visible, p.enableDynamic = M, p.enableHighlight = M, p.snapToData = !0, "lighting" in e && (p.ambientLight = e.lighting.ambient, p.diffuseLight = e.lighting.diffuse, p.specularLight = e.lighting.specular, p.roughness = e.lighting.roughness, p.fresnel = e.lighting.fresnel), "lightposition" in e && (p.lightPosition = [e.lightposition.x, e.lightposition.y, e.lightposition.z]), m && m < 1 && (p.supportsTransparency = !0);
            }, p.dispose = function () {
              this.scene.glplot.remove(this.surface), this.surface.dispose();
            }, t.exports = function (e, t) {
              var n = e.glplot.gl,
                i = r({
                  gl: n
                }),
                o = new f(e, i, t.uid);
              return i._trace = o, o.update(t), e.glplot.add(i), o;
            };
          }, {
            "../../components/colorscale": 387,
            "../../lib": 495,
            "../../lib/gl_format_color": 493,
            "../../lib/str2rgbarray": 517,
            "../heatmap/find_empties": 607,
            "../heatmap/interp2d": 608,
            "gl-surface3d": 163,
            ndarray: 285,
            "ndarray-fill": 275,
            "ndarray-homography": 277
          }],
          663: [function (e, t, n) {
            "use strict";

            var r = e("../../registry"),
              i = e("../../lib"),
              o = e("../../components/colorscale/defaults"),
              a = e("./attributes");
            function s(e, t, n) {
              t in e && !(n in e) && (e[n] = e[t]);
            }
            t.exports = function (e, t, n, l) {
              var u, c;
              function d(n, r) {
                return i.coerce(e, t, a, n, r);
              }
              var h = d("x"),
                f = d("y"),
                p = d("z");
              if (!p || !p.length || h && h.length < 1 || f && f.length < 1) t.visible = !1;else {
                t._xlength = Array.isArray(h) && i.isArrayOrTypedArray(h[0]) ? p.length : p[0].length, t._ylength = p.length, r.getComponentMethod("calendars", "handleTraceDefaults")(e, t, ["x", "y", "z"], l), d("text"), d("hovertext"), d("hovertemplate"), ["lighting.ambient", "lighting.diffuse", "lighting.specular", "lighting.roughness", "lighting.fresnel", "lightposition.x", "lightposition.y", "lightposition.z", "hidesurface", "connectgaps", "opacity"].forEach(function (e) {
                  d(e);
                });
                var m = d("surfacecolor"),
                  g = ["x", "y", "z"];
                for (u = 0; u < 3; ++u) {
                  var v = "contours." + g[u],
                    y = d(v + ".show"),
                    b = d(v + ".highlight");
                  if (y || b) for (c = 0; c < 3; ++c) d(v + ".project." + g[c]);
                  y && (d(v + ".color"), d(v + ".width"), d(v + ".usecolormap")), b && (d(v + ".highlightcolor"), d(v + ".highlightwidth")), d(v + ".start"), d(v + ".end"), d(v + ".size");
                }
                m || (s(e, "zmin", "cmin"), s(e, "zmax", "cmax"), s(e, "zauto", "cauto")), o(e, t, l, d, {
                  prefix: "",
                  cLetter: "c"
                }), t._length = null;
              }
            };
          }, {
            "../../components/colorscale/defaults": 385,
            "../../lib": 495,
            "../../registry": 593,
            "./attributes": 660
          }],
          664: [function (e, t, n) {
            "use strict";

            t.exports = {
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              colorbar: {
                min: "cmin",
                max: "cmax"
              },
              calc: e("./calc"),
              plot: e("./convert"),
              moduleType: "trace",
              name: "surface",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "2dMap", "showLegend"],
              meta: {}
            };
          }, {
            "../../plots/gl3d": 570,
            "./attributes": 660,
            "./calc": 661,
            "./convert": 662,
            "./defaults": 663
          }],
          665: [function (e, t, n) {
            "use strict";

            var r = e("../../components/colorscale/attributes"),
              i = e("../isosurface/attributes"),
              o = e("../../plots/attributes"),
              a = e("../../lib/extend").extendFlat,
              s = e("../../plot_api/edit_types").overrideAll,
              l = t.exports = s(a({
                x: i.x,
                y: i.y,
                z: i.z,
                value: i.value,
                isomin: i.isomin,
                isomax: i.isomax,
                surface: i.surface,
                spaceframe: {
                  show: {
                    valType: "boolean",
                    dflt: !1
                  },
                  fill: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1
                  }
                },
                slices: i.slices,
                caps: i.caps,
                text: i.text,
                hovertext: i.hovertext,
                hovertemplate: i.hovertemplate
              }, r("", {
                colorAttr: "`value`",
                showScaleDflt: !0,
                editTypeOverride: "calc"
              }), {
                colorbar: i.colorbar,
                opacity: i.opacity,
                opacityscale: {
                  valType: "any",
                  editType: "calc"
                },
                lightposition: i.lightposition,
                lighting: i.lighting,
                flatshading: i.flatshading,
                contour: i.contour,
                hoverinfo: a({}, o.hoverinfo),
                showlegend: a({}, o.showlegend, {
                  dflt: !1
                })
              }), "calc", "nested");
            l.x.editType = l.y.editType = l.z.editType = l.value.editType = "calc+clearAxisTypes", l.transforms = void 0;
          }, {
            "../../components/colorscale/attributes": 382,
            "../../lib/extend": 489,
            "../../plot_api/edit_types": 524,
            "../../plots/attributes": 538,
            "../isosurface/attributes": 609
          }],
          666: [function (e, t, n) {
            "use strict";

            var r = e("gl-mesh3d"),
              i = e("../../lib/gl_format_color").parseColorScale,
              o = e("../../lib/str2rgbarray"),
              a = e("../../components/colorscale").extractOpts,
              s = e("../../plots/gl3d/zip3"),
              l = e("../isosurface/convert").findNearestOnAxis,
              u = e("../isosurface/convert").generateIsoMeshes;
            function c(e, t, n) {
              this.scene = e, this.uid = n, this.mesh = t, this.name = "", this.data = null, this.showContour = !1;
            }
            var d = c.prototype;
            d.handlePick = function (e) {
              if (e.object === this.mesh) {
                var t = e.data.index,
                  n = this.data._meshX[t],
                  r = this.data._meshY[t],
                  i = this.data._meshZ[t],
                  o = this.data._Ys.length,
                  a = this.data._Zs.length,
                  s = l(n, this.data._Xs).id,
                  u = l(r, this.data._Ys).id,
                  c = l(i, this.data._Zs).id,
                  d = e.index = c + a * u + a * o * s;
                e.traceCoordinate = [this.data._meshX[d], this.data._meshY[d], this.data._meshZ[d], this.data._value[d]];
                var h = this.data.hovertext || this.data.text;
                return Array.isArray(h) && void 0 !== h[d] ? e.textLabel = h[d] : h && (e.textLabel = h), !0;
              }
            }, d.update = function (e) {
              var t = this.scene,
                n = t.fullSceneLayout;
              function r(e, t, n, r) {
                return t.map(function (t) {
                  return e.d2l(t, 0, r) * n;
                });
              }
              this.data = u(e);
              var l = {
                  positions: s(r(n.xaxis, e._meshX, t.dataScale[0], e.xcalendar), r(n.yaxis, e._meshY, t.dataScale[1], e.ycalendar), r(n.zaxis, e._meshZ, t.dataScale[2], e.zcalendar)),
                  cells: s(e._meshI, e._meshJ, e._meshK),
                  lightPosition: [e.lightposition.x, e.lightposition.y, e.lightposition.z],
                  ambient: e.lighting.ambient,
                  diffuse: e.lighting.diffuse,
                  specular: e.lighting.specular,
                  roughness: e.lighting.roughness,
                  fresnel: e.lighting.fresnel,
                  vertexNormalsEpsilon: e.lighting.vertexnormalsepsilon,
                  faceNormalsEpsilon: e.lighting.facenormalsepsilon,
                  opacity: e.opacity,
                  opacityscale: e.opacityscale,
                  contourEnable: e.contour.show,
                  contourColor: o(e.contour.color).slice(0, 3),
                  contourWidth: e.contour.width,
                  useFacetNormals: e.flatshading
                },
                c = a(e);
              l.vertexIntensity = e._meshIntensity, l.vertexIntensityBounds = [c.min, c.max], l.colormap = i(e), this.mesh.update(l);
            }, d.dispose = function () {
              this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            }, t.exports = function (e, t) {
              var n = e.glplot.gl,
                i = r({
                  gl: n
                }),
                o = new c(e, i, t.uid);
              return i._trace = o, o.update(t), e.glplot.add(i), o;
            };
          }, {
            "../../components/colorscale": 387,
            "../../lib/gl_format_color": 493,
            "../../lib/str2rgbarray": 517,
            "../../plots/gl3d/zip3": 581,
            "../isosurface/convert": 611,
            "gl-mesh3d": 140
          }],
          667: [function (e, t, n) {
            "use strict";

            var r = e("../../lib"),
              i = e("./attributes"),
              o = e("../isosurface/defaults").supplyIsoDefaults;
            t.exports = function (e, t, n, a) {
              function s(n, o) {
                return r.coerce(e, t, i, n, o);
              }
              o(e, t, n, a, s);
              var l = s("opacityscale");
              "max" === l ? t.opacityscale = [[0, .1], [1, 1]] : "min" === l ? t.opacityscale = [[0, 1], [1, .1]] : "extremes" === l ? t.opacityscale = function (e, t) {
                for (var n = [], r = 0; r < 32; r++) {
                  var i = r / 31,
                    o = .1 + .9 * (1 - Math.pow(Math.sin(1 * i * Math.PI), 2));
                  n.push([i, Math.max(1, Math.min(0, o))]);
                }
                return n;
              }() : function (e) {
                var t = 0;
                if (!Array.isArray(e) || e.length < 2) return !1;
                if (!e[0] || !e[e.length - 1]) return !1;
                if (0 != +e[0][0] || 1 != +e[e.length - 1][0]) return !1;
                for (var n = 0; n < e.length; n++) {
                  var r = e[n];
                  if (2 !== r.length || +r[0] < t) return !1;
                  t = +r[0];
                }
                return !0;
              }(l) || (t.opacityscale = void 0);
            };
          }, {
            "../../lib": 495,
            "../isosurface/defaults": 612,
            "./attributes": 665
          }],
          668: [function (e, t, n) {
            "use strict";

            t.exports = {
              attributes: e("./attributes"),
              supplyDefaults: e("./defaults"),
              calc: e("../isosurface/calc"),
              colorbar: {
                min: "cmin",
                max: "cmax"
              },
              plot: e("./convert"),
              moduleType: "trace",
              name: "volume",
              basePlotModule: e("../../plots/gl3d"),
              categories: ["gl3d", "showLegend"],
              meta: {}
            };
          }, {
            "../../plots/gl3d": 570,
            "../isosurface/calc": 610,
            "./attributes": 665,
            "./convert": 666,
            "./defaults": 667
          }]
        }, {}, [4])(4);
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/popper.js/dist/esm/popper.js": function node_modulesPopperJsDistEsmPopperJs(e, t, n) {
      "use strict";

      (function (e) {
        /**!
         * @fileOverview Kickass library to create and place poppers near their reference elements.
         * @version 1.16.1
         * @license
         * Copyright (c) 2016 Federico Zivolo and contributors
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in all
         * copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
         * SOFTWARE.
         */
        var n = "undefined" != typeof window && "undefined" != typeof document && "undefined" != typeof navigator,
          r = function () {
            for (var e = ["Edge", "Trident", "Firefox"], t = 0; t < e.length; t += 1) if (n && navigator.userAgent.indexOf(e[t]) >= 0) return 1;
            return 0;
          }();
        var i = n && window.Promise ? function (e) {
          var t = !1;
          return function () {
            t || (t = !0, window.Promise.resolve().then(function () {
              t = !1, e();
            }));
          };
        } : function (e) {
          var t = !1;
          return function () {
            t || (t = !0, setTimeout(function () {
              t = !1, e();
            }, r));
          };
        };
        function o(e) {
          return e && "[object Function]" === {}.toString.call(e);
        }
        function a(e, t) {
          if (1 !== e.nodeType) return [];
          var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
          return t ? n[t] : n;
        }
        function s(e) {
          return "HTML" === e.nodeName ? e : e.parentNode || e.host;
        }
        function l(e) {
          if (!e) return document.body;
          switch (e.nodeName) {
            case "HTML":
            case "BODY":
              return e.ownerDocument.body;
            case "#document":
              return e.body;
          }
          var t = a(e),
            n = t.overflow,
            r = t.overflowX,
            i = t.overflowY;
          return /(auto|scroll|overlay)/.test(n + i + r) ? e : l(s(e));
        }
        function u(e) {
          return e && e.referenceNode ? e.referenceNode : e;
        }
        var c = n && !(!window.MSInputMethodContext || !document.documentMode),
          d = n && /MSIE 10/.test(navigator.userAgent);
        function h(e) {
          return 11 === e ? c : 10 === e ? d : c || d;
        }
        function f(e) {
          if (!e) return document.documentElement;
          for (var t = h(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;) n = (e = e.nextElementSibling).offsetParent;
          var r = n && n.nodeName;
          return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === a(n, "position") ? f(n) : n : e ? e.ownerDocument.documentElement : document.documentElement;
        }
        function p(e) {
          return null !== e.parentNode ? p(e.parentNode) : e;
        }
        function m(e, t) {
          if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
          var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
            r = n ? e : t,
            i = n ? t : e,
            o = document.createRange();
          o.setStart(r, 0), o.setEnd(i, 0);
          var a,
            s,
            l = o.commonAncestorContainer;
          if (e !== l && t !== l || r.contains(i)) return "BODY" === (s = (a = l).nodeName) || "HTML" !== s && f(a.firstElementChild) !== a ? f(l) : l;
          var u = p(e);
          return u.host ? m(u.host, t) : m(e, p(t).host);
        }
        function g(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top",
            n = "top" === t ? "scrollTop" : "scrollLeft",
            r = e.nodeName;
          if ("BODY" === r || "HTML" === r) {
            var i = e.ownerDocument.documentElement,
              o = e.ownerDocument.scrollingElement || i;
            return o[n];
          }
          return e[n];
        }
        function v(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = g(t, "top"),
            i = g(t, "left"),
            o = n ? -1 : 1;
          return e.top += r * o, e.bottom += r * o, e.left += i * o, e.right += i * o, e;
        }
        function y(e, t) {
          var n = "x" === t ? "Left" : "Top",
            r = "Left" === n ? "Right" : "Bottom";
          return parseFloat(e["border" + n + "Width"]) + parseFloat(e["border" + r + "Width"]);
        }
        function b(e, t, n, r) {
          return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], h(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0);
        }
        function _(e) {
          var t = e.body,
            n = e.documentElement,
            r = h(10) && getComputedStyle(n);
          return {
            height: b("Height", t, n, r),
            width: b("Width", t, n, r)
          };
        }
        var x = function x(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          },
          w = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }
            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          }(),
          S = function S(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          },
          A = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          };
        function E(e) {
          return A({}, e, {
            right: e.left + e.width,
            bottom: e.top + e.height
          });
        }
        function T(e) {
          var t = {};
          try {
            if (h(10)) {
              t = e.getBoundingClientRect();
              var n = g(e, "top"),
                r = g(e, "left");
              t.top += n, t.left += r, t.bottom += n, t.right += r;
            } else t = e.getBoundingClientRect();
          } catch (e) {}
          var i = {
              left: t.left,
              top: t.top,
              width: t.right - t.left,
              height: t.bottom - t.top
            },
            o = "HTML" === e.nodeName ? _(e.ownerDocument) : {},
            s = o.width || e.clientWidth || i.width,
            l = o.height || e.clientHeight || i.height,
            u = e.offsetWidth - s,
            c = e.offsetHeight - l;
          if (u || c) {
            var d = a(e);
            u -= y(d, "x"), c -= y(d, "y"), i.width -= u, i.height -= c;
          }
          return E(i);
        }
        function M(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = h(10),
            i = "HTML" === t.nodeName,
            o = T(e),
            s = T(t),
            u = l(e),
            c = a(t),
            d = parseFloat(c.borderTopWidth),
            f = parseFloat(c.borderLeftWidth);
          n && i && (s.top = Math.max(s.top, 0), s.left = Math.max(s.left, 0));
          var p = E({
            top: o.top - s.top - d,
            left: o.left - s.left - f,
            width: o.width,
            height: o.height
          });
          if (p.marginTop = 0, p.marginLeft = 0, !r && i) {
            var m = parseFloat(c.marginTop),
              g = parseFloat(c.marginLeft);
            p.top -= d - m, p.bottom -= d - m, p.left -= f - g, p.right -= f - g, p.marginTop = m, p.marginLeft = g;
          }
          return (r && !n ? t.contains(u) : t === u && "BODY" !== u.nodeName) && (p = v(p, t)), p;
        }
        function C(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = e.ownerDocument.documentElement,
            r = M(e, n),
            i = Math.max(n.clientWidth, window.innerWidth || 0),
            o = Math.max(n.clientHeight, window.innerHeight || 0),
            a = t ? 0 : g(n),
            s = t ? 0 : g(n, "left"),
            l = {
              top: a - r.top + r.marginTop,
              left: s - r.left + r.marginLeft,
              width: i,
              height: o
            };
          return E(l);
        }
        function k(e) {
          var t = e.nodeName;
          if ("BODY" === t || "HTML" === t) return !1;
          if ("fixed" === a(e, "position")) return !0;
          var n = s(e);
          return !!n && k(n);
        }
        function P(e) {
          if (!e || !e.parentElement || h()) return document.documentElement;
          for (var t = e.parentElement; t && "none" === a(t, "transform");) t = t.parentElement;
          return t || document.documentElement;
        }
        function O(e, t, n, r) {
          var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            o = {
              top: 0,
              left: 0
            },
            a = i ? P(e) : m(e, u(t));
          if ("viewport" === r) o = C(a, i);else {
            var c = void 0;
            "scrollParent" === r ? "BODY" === (c = l(s(t))).nodeName && (c = e.ownerDocument.documentElement) : c = "window" === r ? e.ownerDocument.documentElement : r;
            var d = M(c, a, i);
            if ("HTML" !== c.nodeName || k(a)) o = d;else {
              var h = _(e.ownerDocument),
                f = h.height,
                p = h.width;
              o.top += d.top - d.marginTop, o.bottom = f + d.top, o.left += d.left - d.marginLeft, o.right = p + d.left;
            }
          }
          var g = "number" == typeof (n = n || 0);
          return o.left += g ? n : n.left || 0, o.top += g ? n : n.top || 0, o.right -= g ? n : n.right || 0, o.bottom -= g ? n : n.bottom || 0, o;
        }
        function R(e) {
          return e.width * e.height;
        }
        function I(e, t, n, r, i) {
          var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
          if (-1 === e.indexOf("auto")) return e;
          var a = O(n, r, o, i),
            s = {
              top: {
                width: a.width,
                height: t.top - a.top
              },
              right: {
                width: a.right - t.right,
                height: a.height
              },
              bottom: {
                width: a.width,
                height: a.bottom - t.bottom
              },
              left: {
                width: t.left - a.left,
                height: a.height
              }
            },
            l = Object.keys(s).map(function (e) {
              return A({
                key: e
              }, s[e], {
                area: R(s[e])
              });
            }).sort(function (e, t) {
              return t.area - e.area;
            }),
            u = l.filter(function (e) {
              var t = e.width,
                r = e.height;
              return t >= n.clientWidth && r >= n.clientHeight;
            }),
            c = u.length > 0 ? u[0].key : l[0].key,
            d = e.split("-")[1];
          return c + (d ? "-" + d : "");
        }
        function j(e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            i = r ? P(t) : m(t, u(n));
          return M(n, i, r);
        }
        function N(e) {
          var t = e.ownerDocument.defaultView.getComputedStyle(e),
            n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
            r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
          return {
            width: e.offsetWidth + r,
            height: e.offsetHeight + n
          };
        }
        function L(e) {
          var t = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
          };
          return e.replace(/left|right|bottom|top/g, function (e) {
            return t[e];
          });
        }
        function D(e, t, n) {
          n = n.split("-")[0];
          var r = N(e),
            i = {
              width: r.width,
              height: r.height
            },
            o = -1 !== ["right", "left"].indexOf(n),
            a = o ? "top" : "left",
            s = o ? "left" : "top",
            l = o ? "height" : "width",
            u = o ? "width" : "height";
          return i[a] = t[a] + t[l] / 2 - r[l] / 2, i[s] = n === s ? t[s] - r[u] : t[L(s)], i;
        }
        function B(e, t) {
          return Array.prototype.find ? e.find(t) : e.filter(t)[0];
        }
        function F(e, t, n) {
          return (void 0 === n ? e : e.slice(0, function (e, t, n) {
            if (Array.prototype.findIndex) return e.findIndex(function (e) {
              return e[t] === n;
            });
            var r = B(e, function (e) {
              return e[t] === n;
            });
            return e.indexOf(r);
          }(e, "name", n))).forEach(function (e) {
            e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
            var n = e.function || e.fn;
            e.enabled && o(n) && (t.offsets.popper = E(t.offsets.popper), t.offsets.reference = E(t.offsets.reference), t = n(t, e));
          }), t;
        }
        function z() {
          if (!this.state.isDestroyed) {
            var e = {
              instance: this,
              styles: {},
              arrowStyles: {},
              attributes: {},
              flipped: !1,
              offsets: {}
            };
            e.offsets.reference = j(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = I(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = D(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = F(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
          }
        }
        function U(e, t) {
          return e.some(function (e) {
            var n = e.name;
            return e.enabled && n === t;
          });
        }
        function G(e) {
          for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
            var i = t[r],
              o = i ? "" + i + n : e;
            if (void 0 !== document.body.style[o]) return o;
          }
          return null;
        }
        function V() {
          return this.state.isDestroyed = !0, U(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[G("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
        }
        function H(e) {
          var t = e.ownerDocument;
          return t ? t.defaultView : window;
        }
        function q(e, t, n, r) {
          n.updateBound = r, H(e).addEventListener("resize", n.updateBound, {
            passive: !0
          });
          var i = l(e);
          return function e(t, n, r, i) {
            var o = "BODY" === t.nodeName,
              a = o ? t.ownerDocument.defaultView : t;
            a.addEventListener(n, r, {
              passive: !0
            }), o || e(l(a.parentNode), n, r, i), i.push(a);
          }(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
        }
        function W() {
          this.state.eventsEnabled || (this.state = q(this.reference, this.options, this.state, this.scheduleUpdate));
        }
        function $() {
          var e, t;
          this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, H(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function (e) {
            e.removeEventListener("scroll", t.updateBound);
          }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t));
        }
        function X(e) {
          return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
        }
        function Y(e, t) {
          Object.keys(t).forEach(function (n) {
            var r = "";
            -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && X(t[n]) && (r = "px"), e.style[n] = t[n] + r;
          });
        }
        var K = n && /Firefox/i.test(navigator.userAgent);
        function Z(e, t, n) {
          var r = B(e, function (e) {
              return e.name === t;
            }),
            i = !!r && e.some(function (e) {
              return e.name === n && e.enabled && e.order < r.order;
            });
          if (!i) {
            var o = "`" + t + "`",
              a = "`" + n + "`";
            console.warn(a + " modifier is required by " + o + " modifier in order to work, be sure to include it before " + o + "!");
          }
          return i;
        }
        var Q = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
          J = Q.slice(3);
        function ee(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = J.indexOf(e),
            r = J.slice(n + 1).concat(J.slice(0, n));
          return t ? r.reverse() : r;
        }
        var te = "flip",
          ne = "clockwise",
          re = "counterclockwise";
        function ie(e, t, n, r) {
          var i = [0, 0],
            o = -1 !== ["right", "left"].indexOf(r),
            a = e.split(/(\+|\-)/).map(function (e) {
              return e.trim();
            }),
            s = a.indexOf(B(a, function (e) {
              return -1 !== e.search(/,|\s/);
            }));
          a[s] && -1 === a[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
          var l = /\s*,\s*|\s+/,
            u = -1 !== s ? [a.slice(0, s).concat([a[s].split(l)[0]]), [a[s].split(l)[1]].concat(a.slice(s + 1))] : [a];
          return (u = u.map(function (e, r) {
            var i = (1 === r ? !o : o) ? "height" : "width",
              a = !1;
            return e.reduce(function (e, t) {
              return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, a = !0, e) : a ? (e[e.length - 1] += t, a = !1, e) : e.concat(t);
            }, []).map(function (e) {
              return function (e, t, n, r) {
                var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                  o = +i[1],
                  a = i[2];
                if (!o) return e;
                if (0 === a.indexOf("%")) {
                  var s = void 0;
                  switch (a) {
                    case "%p":
                      s = n;
                      break;
                    case "%":
                    case "%r":
                    default:
                      s = r;
                  }
                  return E(s)[t] / 100 * o;
                }
                if ("vh" === a || "vw" === a) {
                  return ("vh" === a ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * o;
                }
                return o;
              }(e, i, t, n);
            });
          })).forEach(function (e, t) {
            e.forEach(function (n, r) {
              X(n) && (i[t] += n * ("-" === e[r - 1] ? -1 : 1));
            });
          }), i;
        }
        var oe = {
            placement: "bottom",
            positionFixed: !1,
            eventsEnabled: !0,
            removeOnDestroy: !1,
            onCreate: function onCreate() {},
            onUpdate: function onUpdate() {},
            modifiers: {
              shift: {
                order: 100,
                enabled: !0,
                fn: function fn(e) {
                  var t = e.placement,
                    n = t.split("-")[0],
                    r = t.split("-")[1];
                  if (r) {
                    var i = e.offsets,
                      o = i.reference,
                      a = i.popper,
                      s = -1 !== ["bottom", "top"].indexOf(n),
                      l = s ? "left" : "top",
                      u = s ? "width" : "height",
                      c = {
                        start: S({}, l, o[l]),
                        end: S({}, l, o[l] + o[u] - a[u])
                      };
                    e.offsets.popper = A({}, a, c[r]);
                  }
                  return e;
                }
              },
              offset: {
                order: 200,
                enabled: !0,
                fn: function fn(e, t) {
                  var n = t.offset,
                    r = e.placement,
                    i = e.offsets,
                    o = i.popper,
                    a = i.reference,
                    s = r.split("-")[0],
                    l = void 0;
                  return l = X(+n) ? [+n, 0] : ie(n, o, a, s), "left" === s ? (o.top += l[0], o.left -= l[1]) : "right" === s ? (o.top += l[0], o.left += l[1]) : "top" === s ? (o.left += l[0], o.top -= l[1]) : "bottom" === s && (o.left += l[0], o.top += l[1]), e.popper = o, e;
                },
                offset: 0
              },
              preventOverflow: {
                order: 300,
                enabled: !0,
                fn: function fn(e, t) {
                  var n = t.boundariesElement || f(e.instance.popper);
                  e.instance.reference === n && (n = f(n));
                  var r = G("transform"),
                    i = e.instance.popper.style,
                    o = i.top,
                    a = i.left,
                    s = i[r];
                  i.top = "", i.left = "", i[r] = "";
                  var l = O(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                  i.top = o, i.left = a, i[r] = s, t.boundaries = l;
                  var u = t.priority,
                    c = e.offsets.popper,
                    d = {
                      primary: function primary(e) {
                        var n = c[e];
                        return c[e] < l[e] && !t.escapeWithReference && (n = Math.max(c[e], l[e])), S({}, e, n);
                      },
                      secondary: function secondary(e) {
                        var n = "right" === e ? "left" : "top",
                          r = c[n];
                        return c[e] > l[e] && !t.escapeWithReference && (r = Math.min(c[n], l[e] - ("right" === e ? c.width : c.height))), S({}, n, r);
                      }
                    };
                  return u.forEach(function (e) {
                    var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                    c = A({}, c, d[t](e));
                  }), e.offsets.popper = c, e;
                },
                priority: ["left", "right", "top", "bottom"],
                padding: 5,
                boundariesElement: "scrollParent"
              },
              keepTogether: {
                order: 400,
                enabled: !0,
                fn: function fn(e) {
                  var t = e.offsets,
                    n = t.popper,
                    r = t.reference,
                    i = e.placement.split("-")[0],
                    o = Math.floor,
                    a = -1 !== ["top", "bottom"].indexOf(i),
                    s = a ? "right" : "bottom",
                    l = a ? "left" : "top",
                    u = a ? "width" : "height";
                  return n[s] < o(r[l]) && (e.offsets.popper[l] = o(r[l]) - n[u]), n[l] > o(r[s]) && (e.offsets.popper[l] = o(r[s])), e;
                }
              },
              arrow: {
                order: 500,
                enabled: !0,
                fn: function fn(e, t) {
                  var n;
                  if (!Z(e.instance.modifiers, "arrow", "keepTogether")) return e;
                  var r = t.element;
                  if ("string" == typeof r) {
                    if (!(r = e.instance.popper.querySelector(r))) return e;
                  } else if (!e.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
                  var i = e.placement.split("-")[0],
                    o = e.offsets,
                    s = o.popper,
                    l = o.reference,
                    u = -1 !== ["left", "right"].indexOf(i),
                    c = u ? "height" : "width",
                    d = u ? "Top" : "Left",
                    h = d.toLowerCase(),
                    f = u ? "left" : "top",
                    p = u ? "bottom" : "right",
                    m = N(r)[c];
                  l[p] - m < s[h] && (e.offsets.popper[h] -= s[h] - (l[p] - m)), l[h] + m > s[p] && (e.offsets.popper[h] += l[h] + m - s[p]), e.offsets.popper = E(e.offsets.popper);
                  var g = l[h] + l[c] / 2 - m / 2,
                    v = a(e.instance.popper),
                    y = parseFloat(v["margin" + d]),
                    b = parseFloat(v["border" + d + "Width"]),
                    _ = g - e.offsets.popper[h] - y - b;
                  return _ = Math.max(Math.min(s[c] - m, _), 0), e.arrowElement = r, e.offsets.arrow = (S(n = {}, h, Math.round(_)), S(n, f, ""), n), e;
                },
                element: "[x-arrow]"
              },
              flip: {
                order: 600,
                enabled: !0,
                fn: function fn(e, t) {
                  if (U(e.instance.modifiers, "inner")) return e;
                  if (e.flipped && e.placement === e.originalPlacement) return e;
                  var n = O(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                    r = e.placement.split("-")[0],
                    i = L(r),
                    o = e.placement.split("-")[1] || "",
                    a = [];
                  switch (t.behavior) {
                    case te:
                      a = [r, i];
                      break;
                    case ne:
                      a = ee(r);
                      break;
                    case re:
                      a = ee(r, !0);
                      break;
                    default:
                      a = t.behavior;
                  }
                  return a.forEach(function (s, l) {
                    if (r !== s || a.length === l + 1) return e;
                    r = e.placement.split("-")[0], i = L(r);
                    var u = e.offsets.popper,
                      c = e.offsets.reference,
                      d = Math.floor,
                      h = "left" === r && d(u.right) > d(c.left) || "right" === r && d(u.left) < d(c.right) || "top" === r && d(u.bottom) > d(c.top) || "bottom" === r && d(u.top) < d(c.bottom),
                      f = d(u.left) < d(n.left),
                      p = d(u.right) > d(n.right),
                      m = d(u.top) < d(n.top),
                      g = d(u.bottom) > d(n.bottom),
                      v = "left" === r && f || "right" === r && p || "top" === r && m || "bottom" === r && g,
                      y = -1 !== ["top", "bottom"].indexOf(r),
                      b = !!t.flipVariations && (y && "start" === o && f || y && "end" === o && p || !y && "start" === o && m || !y && "end" === o && g),
                      _ = !!t.flipVariationsByContent && (y && "start" === o && p || y && "end" === o && f || !y && "start" === o && g || !y && "end" === o && m),
                      x = b || _;
                    (h || v || x) && (e.flipped = !0, (h || v) && (r = a[l + 1]), x && (o = function (e) {
                      return "end" === e ? "start" : "start" === e ? "end" : e;
                    }(o)), e.placement = r + (o ? "-" + o : ""), e.offsets.popper = A({}, e.offsets.popper, D(e.instance.popper, e.offsets.reference, e.placement)), e = F(e.instance.modifiers, e, "flip"));
                  }), e;
                },
                behavior: "flip",
                padding: 5,
                boundariesElement: "viewport",
                flipVariations: !1,
                flipVariationsByContent: !1
              },
              inner: {
                order: 700,
                enabled: !1,
                fn: function fn(e) {
                  var t = e.placement,
                    n = t.split("-")[0],
                    r = e.offsets,
                    i = r.popper,
                    o = r.reference,
                    a = -1 !== ["left", "right"].indexOf(n),
                    s = -1 === ["top", "left"].indexOf(n);
                  return i[a ? "left" : "top"] = o[n] - (s ? i[a ? "width" : "height"] : 0), e.placement = L(t), e.offsets.popper = E(i), e;
                }
              },
              hide: {
                order: 800,
                enabled: !0,
                fn: function fn(e) {
                  if (!Z(e.instance.modifiers, "hide", "preventOverflow")) return e;
                  var t = e.offsets.reference,
                    n = B(e.instance.modifiers, function (e) {
                      return "preventOverflow" === e.name;
                    }).boundaries;
                  if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                    if (!0 === e.hide) return e;
                    e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
                  } else {
                    if (!1 === e.hide) return e;
                    e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
                  }
                  return e;
                }
              },
              computeStyle: {
                order: 850,
                enabled: !0,
                fn: function fn(e, t) {
                  var n = t.x,
                    r = t.y,
                    i = e.offsets.popper,
                    o = B(e.instance.modifiers, function (e) {
                      return "applyStyle" === e.name;
                    }).gpuAcceleration;
                  void 0 !== o && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                  var a = void 0 !== o ? o : t.gpuAcceleration,
                    s = f(e.instance.popper),
                    l = T(s),
                    u = {
                      position: i.position
                    },
                    c = function (e, t) {
                      var n = e.offsets,
                        r = n.popper,
                        i = n.reference,
                        o = Math.round,
                        a = Math.floor,
                        s = function s(e) {
                          return e;
                        },
                        l = o(i.width),
                        u = o(r.width),
                        c = -1 !== ["left", "right"].indexOf(e.placement),
                        d = -1 !== e.placement.indexOf("-"),
                        h = t ? c || d || l % 2 == u % 2 ? o : a : s,
                        f = t ? o : s;
                      return {
                        left: h(l % 2 == 1 && u % 2 == 1 && !d && t ? r.left - 1 : r.left),
                        top: f(r.top),
                        bottom: f(r.bottom),
                        right: h(r.right)
                      };
                    }(e, window.devicePixelRatio < 2 || !K),
                    d = "bottom" === n ? "top" : "bottom",
                    h = "right" === r ? "left" : "right",
                    p = G("transform"),
                    m = void 0,
                    g = void 0;
                  if (g = "bottom" === d ? "HTML" === s.nodeName ? -s.clientHeight + c.bottom : -l.height + c.bottom : c.top, m = "right" === h ? "HTML" === s.nodeName ? -s.clientWidth + c.right : -l.width + c.right : c.left, a && p) u[p] = "translate3d(" + m + "px, " + g + "px, 0)", u[d] = 0, u[h] = 0, u.willChange = "transform";else {
                    var v = "bottom" === d ? -1 : 1,
                      y = "right" === h ? -1 : 1;
                    u[d] = g * v, u[h] = m * y, u.willChange = d + ", " + h;
                  }
                  var b = {
                    "x-placement": e.placement
                  };
                  return e.attributes = A({}, b, e.attributes), e.styles = A({}, u, e.styles), e.arrowStyles = A({}, e.offsets.arrow, e.arrowStyles), e;
                },
                gpuAcceleration: !0,
                x: "bottom",
                y: "right"
              },
              applyStyle: {
                order: 900,
                enabled: !0,
                fn: function fn(e) {
                  var t, n;
                  return Y(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach(function (e) {
                    !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e);
                  }), e.arrowElement && Object.keys(e.arrowStyles).length && Y(e.arrowElement, e.arrowStyles), e;
                },
                onLoad: function onLoad(e, t, n, r, i) {
                  var o = j(i, t, e, n.positionFixed),
                    a = I(n.placement, o, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                  return t.setAttribute("x-placement", a), Y(t, {
                    position: n.positionFixed ? "fixed" : "absolute"
                  }), n;
                },
                gpuAcceleration: void 0
              }
            }
          },
          ae = function () {
            function e(t, n) {
              var r = this,
                a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              x(this, e), this.scheduleUpdate = function () {
                return requestAnimationFrame(r.update);
              }, this.update = i(this.update.bind(this)), this.options = A({}, e.Defaults, a), this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: []
              }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(A({}, e.Defaults.modifiers, a.modifiers)).forEach(function (t) {
                r.options.modifiers[t] = A({}, e.Defaults.modifiers[t] || {}, a.modifiers ? a.modifiers[t] : {});
              }), this.modifiers = Object.keys(this.options.modifiers).map(function (e) {
                return A({
                  name: e
                }, r.options.modifiers[e]);
              }).sort(function (e, t) {
                return e.order - t.order;
              }), this.modifiers.forEach(function (e) {
                e.enabled && o(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state);
              }), this.update();
              var s = this.options.eventsEnabled;
              s && this.enableEventListeners(), this.state.eventsEnabled = s;
            }
            return w(e, [{
              key: "update",
              value: function value() {
                return z.call(this);
              }
            }, {
              key: "destroy",
              value: function value() {
                return V.call(this);
              }
            }, {
              key: "enableEventListeners",
              value: function value() {
                return W.call(this);
              }
            }, {
              key: "disableEventListeners",
              value: function value() {
                return $.call(this);
              }
            }]), e;
          }();
        ae.Utils = ("undefined" != typeof window ? window : e).PopperUtils, ae.placements = Q, ae.Defaults = oe, t.a = ae;
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/process-nextick-args/index.js": function node_modulesProcessNextickArgsIndexJs(e, t, n) {
      "use strict";

      (function (t) {
        void 0 === t || !t.version || 0 === t.version.indexOf("v0.") || 0 === t.version.indexOf("v1.") && 0 !== t.version.indexOf("v1.8.") ? e.exports = {
          nextTick: function nextTick(e, n, r, i) {
            if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
            var o,
              a,
              s = arguments.length;
            switch (s) {
              case 0:
              case 1:
                return t.nextTick(e);
              case 2:
                return t.nextTick(function () {
                  e.call(null, n);
                });
              case 3:
                return t.nextTick(function () {
                  e.call(null, n, r);
                });
              case 4:
                return t.nextTick(function () {
                  e.call(null, n, r, i);
                });
              default:
                for (o = new Array(s - 1), a = 0; a < o.length;) o[a++] = arguments[a];
                return t.nextTick(function () {
                  e.apply(null, o);
                });
            }
          }
        } : e.exports = t;
      }).call(this, n("./node_modules/process/browser.js"));
    },
    "./node_modules/process/browser.js": function node_modulesProcessBrowserJs(e, t) {
      var n,
        r,
        i = e.exports = {};
      function o() {
        throw new Error("setTimeout has not been defined");
      }
      function a() {
        throw new Error("clearTimeout has not been defined");
      }
      function s(e) {
        if (n === setTimeout) return setTimeout(e, 0);
        if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
        try {
          return n(e, 0);
        } catch (t) {
          try {
            return n.call(null, e, 0);
          } catch (t) {
            return n.call(this, e, 0);
          }
        }
      }
      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : o;
        } catch (e) {
          n = o;
        }
        try {
          r = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (e) {
          r = a;
        }
      }();
      var l,
        u = [],
        c = !1,
        d = -1;
      function h() {
        c && l && (c = !1, l.length ? u = l.concat(u) : d = -1, u.length && f());
      }
      function f() {
        if (!c) {
          var e = s(h);
          c = !0;
          for (var t = u.length; t;) {
            for (l = u, u = []; ++d < t;) l && l[d].run();
            d = -1, t = u.length;
          }
          l = null, c = !1, function (e) {
            if (r === clearTimeout) return clearTimeout(e);
            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
            try {
              r(e);
            } catch (t) {
              try {
                return r.call(null, e);
              } catch (t) {
                return r.call(this, e);
              }
            }
          }(e);
        }
      }
      function p(e, t) {
        this.fun = e, this.array = t;
      }
      function m() {}
      i.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        u.push(new p(e, t)), 1 !== u.length || c || s(f);
      }, p.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = m, i.addListener = m, i.once = m, i.off = m, i.removeListener = m, i.removeAllListeners = m, i.emit = m, i.prependListener = m, i.prependOnceListener = m, i.listeners = function (e) {
        return [];
      }, i.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, i.cwd = function () {
        return "/";
      }, i.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, i.umask = function () {
        return 0;
      };
    },
    "./node_modules/prop-types/factoryWithThrowingShims.js": function node_modulesPropTypesFactoryWithThrowingShimsJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
      function i() {}
      function o() {}
      o.resetWarningCache = i, e.exports = function () {
        function e(e, t, n, i, o, a) {
          if (a !== r) {
            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw s.name = "Invariant Violation", s;
          }
        }
        function t() {
          return e;
        }
        e.isRequired = e;
        var n = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: o,
          resetWarningCache: i
        };
        return n.PropTypes = n, n;
      };
    },
    "./node_modules/prop-types/index.js": function node_modulesPropTypesIndexJs(e, t, n) {
      e.exports = n("./node_modules/prop-types/factoryWithThrowingShims.js")();
    },
    "./node_modules/prop-types/lib/ReactPropTypesSecret.js": function node_modulesPropTypesLibReactPropTypesSecretJs(e, t, n) {
      "use strict";

      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    "./node_modules/public-encrypt/browser.js": function node_modulesPublicEncryptBrowserJs(e, t, n) {
      t.publicEncrypt = n("./node_modules/public-encrypt/publicEncrypt.js"), t.privateDecrypt = n("./node_modules/public-encrypt/privateDecrypt.js"), t.privateEncrypt = function (e, n) {
        return t.publicEncrypt(e, n, !0);
      }, t.publicDecrypt = function (e, n) {
        return t.privateDecrypt(e, n, !0);
      };
    },
    "./node_modules/public-encrypt/mgf.js": function node_modulesPublicEncryptMgfJs(e, t, n) {
      var r = n("./node_modules/create-hash/browser.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer;
      function o(e) {
        var t = i.allocUnsafe(4);
        return t.writeUInt32BE(e, 0), t;
      }
      e.exports = function (e, t) {
        for (var n, a = i.alloc(0), s = 0; a.length < t;) n = o(s++), a = i.concat([a, r("sha1").update(e).update(n).digest()]);
        return a.slice(0, t);
      };
    },
    "./node_modules/public-encrypt/privateDecrypt.js": function node_modulesPublicEncryptPrivateDecryptJs(e, t, n) {
      var r = n("./node_modules/parse-asn1/index.js"),
        i = n("./node_modules/public-encrypt/mgf.js"),
        o = n("./node_modules/public-encrypt/xor.js"),
        a = n("./node_modules/bn.js/lib/bn.js"),
        s = n("./node_modules/browserify-rsa/index.js"),
        l = n("./node_modules/create-hash/browser.js"),
        u = n("./node_modules/public-encrypt/withPublic.js"),
        c = n("./node_modules/safe-buffer/index.js").Buffer;
      e.exports = function (e, t, n) {
        var d;
        d = e.padding ? e.padding : n ? 1 : 4;
        var h,
          f = r(e),
          p = f.modulus.byteLength();
        if (t.length > p || new a(t).cmp(f.modulus) >= 0) throw new Error("decryption error");
        h = n ? u(new a(t), f) : s(t, f);
        var m = c.alloc(p - h.length);
        if (h = c.concat([m, h], p), 4 === d) return function (e, t) {
          var n = e.modulus.byteLength(),
            r = l("sha1").update(c.alloc(0)).digest(),
            a = r.length;
          if (0 !== t[0]) throw new Error("decryption error");
          var s = t.slice(1, a + 1),
            u = t.slice(a + 1),
            d = o(s, i(u, a)),
            h = o(u, i(d, n - a - 1));
          if (function (e, t) {
            e = c.from(e), t = c.from(t);
            var n = 0,
              r = e.length;
            e.length !== t.length && (n++, r = Math.min(e.length, t.length));
            var i = -1;
            for (; ++i < r;) n += e[i] ^ t[i];
            return n;
          }(r, h.slice(0, a))) throw new Error("decryption error");
          var f = a;
          for (; 0 === h[f];) f++;
          if (1 !== h[f++]) throw new Error("decryption error");
          return h.slice(f);
        }(f, h);
        if (1 === d) return function (e, t, n) {
          var r = t.slice(0, 2),
            i = 2,
            o = 0;
          for (; 0 !== t[i++];) if (i >= t.length) {
            o++;
            break;
          }
          var a = t.slice(2, i - 1);
          ("0002" !== r.toString("hex") && !n || "0001" !== r.toString("hex") && n) && o++;
          a.length < 8 && o++;
          if (o) throw new Error("decryption error");
          return t.slice(i);
        }(0, h, n);
        if (3 === d) return h;
        throw new Error("unknown padding");
      };
    },
    "./node_modules/public-encrypt/publicEncrypt.js": function node_modulesPublicEncryptPublicEncryptJs(e, t, n) {
      var r = n("./node_modules/parse-asn1/index.js"),
        i = n("./node_modules/randombytes/browser.js"),
        o = n("./node_modules/create-hash/browser.js"),
        a = n("./node_modules/public-encrypt/mgf.js"),
        s = n("./node_modules/public-encrypt/xor.js"),
        l = n("./node_modules/bn.js/lib/bn.js"),
        u = n("./node_modules/public-encrypt/withPublic.js"),
        c = n("./node_modules/browserify-rsa/index.js"),
        d = n("./node_modules/safe-buffer/index.js").Buffer;
      e.exports = function (e, t, n) {
        var h;
        h = e.padding ? e.padding : n ? 1 : 4;
        var f,
          p = r(e);
        if (4 === h) f = function (e, t) {
          var n = e.modulus.byteLength(),
            r = t.length,
            u = o("sha1").update(d.alloc(0)).digest(),
            c = u.length,
            h = 2 * c;
          if (r > n - h - 2) throw new Error("message too long");
          var f = d.alloc(n - r - h - 2),
            p = n - c - 1,
            m = i(c),
            g = s(d.concat([u, f, d.alloc(1, 1), t], p), a(m, p)),
            v = s(m, a(g, c));
          return new l(d.concat([d.alloc(1), v, g], n));
        }(p, t);else if (1 === h) f = function (e, t, n) {
          var r,
            o = t.length,
            a = e.modulus.byteLength();
          if (o > a - 11) throw new Error("message too long");
          r = n ? d.alloc(a - o - 3, 255) : function (e) {
            var t,
              n = d.allocUnsafe(e),
              r = 0,
              o = i(2 * e),
              a = 0;
            for (; r < e;) a === o.length && (o = i(2 * e), a = 0), (t = o[a++]) && (n[r++] = t);
            return n;
          }(a - o - 3);
          return new l(d.concat([d.from([0, n ? 1 : 2]), r, d.alloc(1), t], a));
        }(p, t, n);else {
          if (3 !== h) throw new Error("unknown padding");
          if ((f = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
        }
        return n ? c(f, p) : u(f, p);
      };
    },
    "./node_modules/public-encrypt/withPublic.js": function node_modulesPublicEncryptWithPublicJs(e, t, n) {
      var r = n("./node_modules/bn.js/lib/bn.js"),
        i = n("./node_modules/safe-buffer/index.js").Buffer;
      e.exports = function (e, t) {
        return i.from(e.toRed(r.mont(t.modulus)).redPow(new r(t.publicExponent)).fromRed().toArray());
      };
    },
    "./node_modules/public-encrypt/xor.js": function node_modulesPublicEncryptXorJs(e, t) {
      e.exports = function (e, t) {
        for (var n = e.length, r = -1; ++r < n;) e[r] ^= t[r];
        return e;
      };
    },
    "./node_modules/randombytes/browser.js": function node_modulesRandombytesBrowserJs(e, t, n) {
      "use strict";

      (function (t, r) {
        var i = n("./node_modules/safe-buffer/index.js").Buffer,
          o = t.crypto || t.msCrypto;
        o && o.getRandomValues ? e.exports = function (e, t) {
          if (e > 4294967295) throw new RangeError("requested too many random bytes");
          var n = i.allocUnsafe(e);
          if (e > 0) if (e > 65536) for (var a = 0; a < e; a += 65536) o.getRandomValues(n.slice(a, a + 65536));else o.getRandomValues(n);
          if ("function" == typeof t) return r.nextTick(function () {
            t(null, n);
          });
          return n;
        } : e.exports = function () {
          throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
        };
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
    },
    "./node_modules/randomfill/browser.js": function node_modulesRandomfillBrowserJs(e, t, n) {
      "use strict";

      (function (e, r) {
        function i() {
          throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
        }
        var o = n("./node_modules/safe-buffer/index.js"),
          a = n("./node_modules/randombytes/browser.js"),
          s = o.Buffer,
          l = o.kMaxLength,
          u = e.crypto || e.msCrypto,
          c = Math.pow(2, 32) - 1;
        function d(e, t) {
          if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
          if (e > c || e < 0) throw new TypeError("offset must be a uint32");
          if (e > l || e > t) throw new RangeError("offset out of range");
        }
        function h(e, t, n) {
          if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
          if (e > c || e < 0) throw new TypeError("size must be a uint32");
          if (e + t > n || e > l) throw new RangeError("buffer too small");
        }
        function f(e, t, n, i) {
          if (r.browser) {
            var o = e.buffer,
              s = new Uint8Array(o, t, n);
            return u.getRandomValues(s), i ? void r.nextTick(function () {
              i(null, e);
            }) : e;
          }
          if (!i) return a(n).copy(e, t), e;
          a(n, function (n, r) {
            if (n) return i(n);
            r.copy(e, t), i(null, e);
          });
        }
        u && u.getRandomValues || !r.browser ? (t.randomFill = function (t, n, r, i) {
          if (!(s.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
          if ("function" == typeof n) i = n, n = 0, r = t.length;else if ("function" == typeof r) i = r, r = t.length - n;else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
          return d(n, t.length), h(r, n, t.length), f(t, n, r, i);
        }, t.randomFillSync = function (t, n, r) {
          void 0 === n && (n = 0);
          if (!(s.isBuffer(t) || t instanceof e.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
          d(n, t.length), void 0 === r && (r = t.length - n);
          return h(r, n, t.length), f(t, n, r);
        }) : (t.randomFill = i, t.randomFillSync = i);
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
    },
    "./node_modules/rc-slider/assets/index.css": function node_modulesRcSliderAssetsIndexCss(e, t, n) {
      var r = n("./node_modules/mini-css-extract-plugin/dist/loader.js?!./node_modules/css-loader/index.js!./node_modules/rc-slider/assets/index.css");
      "string" == typeof r && (r = [[e.i, r, ""]]);
      var i = {
        hmr: !0,
        transform: void 0,
        insertInto: void 0
      };
      n("./node_modules/style-loader/lib/addStyles.js")(r, i);
      r.locals && (e.exports = r.locals);
    },
    "./node_modules/rc-slider/es/index.js": function node_modulesRcSliderEsIndexJs(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "Range", function () {
        return ue;
      }), n.d(t, "Handle", function () {
        return B;
      }), n.d(t, "createSliderWithTooltip", function () {
        return Nn;
      });
      var r = n("./node_modules/babel-runtime/helpers/extends.js"),
        i = n.n(r),
        o = n("./node_modules/babel-runtime/helpers/classCallCheck.js"),
        a = n.n(o),
        s = n("./node_modules/babel-runtime/helpers/createClass.js"),
        l = n.n(s),
        u = n("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js"),
        c = n.n(u),
        d = n("./node_modules/babel-runtime/helpers/inherits.js"),
        h = n.n(d),
        f = n("react"),
        p = n.n(f),
        m = n("./node_modules/prop-types/index.js"),
        g = n.n(m),
        v = n("./node_modules/warning/warning.js"),
        y = n.n(v),
        b = n("./node_modules/babel-runtime/helpers/defineProperty.js"),
        _ = n.n(b),
        x = function x(e) {
          var t,
            n,
            r = e.className,
            o = e.included,
            a = e.vertical,
            s = e.offset,
            l = e.length,
            u = e.style,
            c = e.reverse,
            d = a ? (t = {}, _()(t, c ? "top" : "bottom", s + "%"), _()(t, c ? "bottom" : "top", "auto"), _()(t, "height", l + "%"), t) : (n = {}, _()(n, c ? "right" : "left", s + "%"), _()(n, c ? "left" : "right", "auto"), _()(n, "width", l + "%"), n),
            h = i()({}, u, d);
          return o ? p.a.createElement("div", {
            className: r,
            style: h
          }) : null;
        },
        w = n("./node_modules/babel-runtime/helpers/objectWithoutProperties.js"),
        S = n.n(w),
        A = n("./node_modules/babel-runtime/helpers/get.js"),
        E = n.n(A),
        T = n("./node_modules/add-dom-event-listener/lib/index.js"),
        M = n.n(T),
        C = n("react-dom"),
        k = n.n(C);
      function P(e, t, n, r) {
        var i = k.a.unstable_batchedUpdates ? function (e) {
          k.a.unstable_batchedUpdates(n, e);
        } : n;
        return M()(e, t, i, r);
      }
      var O = n("./node_modules/classnames/index.js"),
        R = n.n(O),
        I = function I(e) {
          var t = e.prefixCls,
            n = e.vertical,
            r = e.reverse,
            o = e.marks,
            a = e.dots,
            s = e.step,
            l = e.included,
            u = e.lowerBound,
            c = e.upperBound,
            d = e.max,
            h = e.min,
            f = e.dotStyle,
            m = e.activeDotStyle,
            g = d - h,
            v = function (e, t, n, r, i, o) {
              y()(!n || r > 0, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
              var a = Object.keys(t).map(parseFloat).sort(function (e, t) {
                return e - t;
              });
              if (n && r) for (var s = i; s <= o; s += r) -1 === a.indexOf(s) && a.push(s);
              return a;
            }(0, o, a, s, h, d).map(function (e) {
              var o,
                a = Math.abs(e - h) / g * 100 + "%",
                s = !l && e === c || l && e <= c && e >= u,
                d = n ? i()({}, f, _()({}, r ? "top" : "bottom", a)) : i()({}, f, _()({}, r ? "right" : "left", a));
              s && (d = i()({}, d, m));
              var v = R()((o = {}, _()(o, t + "-dot", !0), _()(o, t + "-dot-active", s), _()(o, t + "-dot-reverse", r), o));
              return p.a.createElement("span", {
                className: v,
                style: d,
                key: e
              });
            });
          return p.a.createElement("div", {
            className: t + "-step"
          }, v);
        };
      I.propTypes = {
        prefixCls: g.a.string,
        activeDotStyle: g.a.object,
        dotStyle: g.a.object,
        min: g.a.number,
        max: g.a.number,
        upperBound: g.a.number,
        lowerBound: g.a.number,
        included: g.a.bool,
        dots: g.a.bool,
        step: g.a.number,
        marks: g.a.object,
        vertical: g.a.bool,
        reverse: g.a.bool
      };
      var j = I,
        N = function N(e) {
          var t = e.className,
            n = e.vertical,
            r = e.reverse,
            o = e.marks,
            a = e.included,
            s = e.upperBound,
            l = e.lowerBound,
            u = e.max,
            c = e.min,
            d = e.onClickLabel,
            h = Object.keys(o),
            f = u - c,
            m = h.map(parseFloat).sort(function (e, t) {
              return e - t;
            }).map(function (e) {
              var u,
                h = o[e],
                m = "object" == typeof h && !p.a.isValidElement(h),
                g = m ? h.label : h;
              if (!g && 0 !== g) return null;
              var v = !a && e === s || a && e <= s && e >= l,
                y = R()((u = {}, _()(u, t + "-text", !0), _()(u, t + "-text-active", v), u)),
                b = _()({
                  marginBottom: "-50%"
                }, r ? "top" : "bottom", (e - c) / f * 100 + "%"),
                x = _()({
                  transform: "translateX(-50%)",
                  msTransform: "translateX(-50%)"
                }, r ? "right" : "left", r ? (e - c / 4) / f * 100 + "%" : (e - c) / f * 100 + "%"),
                w = n ? b : x,
                S = m ? i()({}, w, h.style) : w;
              return p.a.createElement("span", {
                className: y,
                style: S,
                key: e,
                onMouseDown: function onMouseDown(t) {
                  return d(t, e);
                },
                onTouchStart: function onTouchStart(t) {
                  return d(t, e);
                }
              }, g);
            });
          return p.a.createElement("div", {
            className: t
          }, m);
        };
      N.propTypes = {
        className: g.a.string,
        vertical: g.a.bool,
        reverse: g.a.bool,
        marks: g.a.object,
        included: g.a.bool,
        upperBound: g.a.number,
        lowerBound: g.a.number,
        max: g.a.number,
        min: g.a.number,
        onClickLabel: g.a.func
      };
      var L = N,
        D = function (e) {
          function t() {
            var e, n, r, i;
            a()(this, t);
            for (var o = arguments.length, s = Array(o), l = 0; l < o; l++) s[l] = arguments[l];
            return n = r = c()(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), r.state = {
              clickFocused: !1
            }, r.setHandleRef = function (e) {
              r.handle = e;
            }, r.handleMouseUp = function () {
              document.activeElement === r.handle && r.setClickFocus(!0);
            }, r.handleMouseDown = function () {
              r.focus();
            }, r.handleBlur = function () {
              r.setClickFocus(!1);
            }, r.handleKeyDown = function () {
              r.setClickFocus(!1);
            }, i = n, c()(r, i);
          }
          return h()(t, e), l()(t, [{
            key: "componentDidMount",
            value: function value() {
              this.onMouseUpListener = P(document, "mouseup", this.handleMouseUp);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.onMouseUpListener && this.onMouseUpListener.remove();
            }
          }, {
            key: "setClickFocus",
            value: function value(e) {
              this.setState({
                clickFocused: e
              });
            }
          }, {
            key: "clickFocus",
            value: function value() {
              this.setClickFocus(!0), this.focus();
            }
          }, {
            key: "focus",
            value: function value() {
              this.handle.focus();
            }
          }, {
            key: "blur",
            value: function value() {
              this.handle.blur();
            }
          }, {
            key: "render",
            value: function value() {
              var e,
                t,
                n = this.props,
                r = n.prefixCls,
                o = n.vertical,
                a = n.reverse,
                s = n.offset,
                l = n.style,
                u = n.disabled,
                c = n.min,
                d = n.max,
                h = n.value,
                f = n.tabIndex,
                m = S()(n, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex"]),
                g = R()(this.props.className, _()({}, r + "-handle-click-focused", this.state.clickFocused)),
                v = o ? (e = {}, _()(e, a ? "top" : "bottom", s + "%"), _()(e, a ? "bottom" : "top", "auto"), _()(e, "transform", "translateY(+50%)"), e) : (t = {}, _()(t, a ? "right" : "left", s + "%"), _()(t, a ? "left" : "right", "auto"), _()(t, "transform", "translateX(" + (a ? "+" : "-") + "50%)"), t),
                y = i()({}, l, v),
                b = f || 0;
              return (u || null === f) && (b = null), p.a.createElement("div", i()({
                ref: this.setHandleRef,
                tabIndex: b
              }, m, {
                className: g,
                style: y,
                onBlur: this.handleBlur,
                onKeyDown: this.handleKeyDown,
                onMouseDown: this.handleMouseDown,
                role: "slider",
                "aria-valuemin": c,
                "aria-valuemax": d,
                "aria-valuenow": h,
                "aria-disabled": !!u
              }));
            }
          }]), t;
        }(p.a.Component),
        B = D;
      D.propTypes = {
        prefixCls: g.a.string,
        className: g.a.string,
        vertical: g.a.bool,
        offset: g.a.number,
        style: g.a.object,
        disabled: g.a.bool,
        min: g.a.number,
        max: g.a.number,
        value: g.a.number,
        tabIndex: g.a.number,
        reverse: g.a.bool
      };
      var F = n("./node_modules/babel-runtime/helpers/toConsumableArray.js"),
        z = n.n(F),
        U = {
          MAC_ENTER: 3,
          BACKSPACE: 8,
          TAB: 9,
          NUM_CENTER: 12,
          ENTER: 13,
          SHIFT: 16,
          CTRL: 17,
          ALT: 18,
          PAUSE: 19,
          CAPS_LOCK: 20,
          ESC: 27,
          SPACE: 32,
          PAGE_UP: 33,
          PAGE_DOWN: 34,
          END: 35,
          HOME: 36,
          LEFT: 37,
          UP: 38,
          RIGHT: 39,
          DOWN: 40,
          PRINT_SCREEN: 44,
          INSERT: 45,
          DELETE: 46,
          ZERO: 48,
          ONE: 49,
          TWO: 50,
          THREE: 51,
          FOUR: 52,
          FIVE: 53,
          SIX: 54,
          SEVEN: 55,
          EIGHT: 56,
          NINE: 57,
          QUESTION_MARK: 63,
          A: 65,
          B: 66,
          C: 67,
          D: 68,
          E: 69,
          F: 70,
          G: 71,
          H: 72,
          I: 73,
          J: 74,
          K: 75,
          L: 76,
          M: 77,
          N: 78,
          O: 79,
          P: 80,
          Q: 81,
          R: 82,
          S: 83,
          T: 84,
          U: 85,
          V: 86,
          W: 87,
          X: 88,
          Y: 89,
          Z: 90,
          META: 91,
          WIN_KEY_RIGHT: 92,
          CONTEXT_MENU: 93,
          NUM_ZERO: 96,
          NUM_ONE: 97,
          NUM_TWO: 98,
          NUM_THREE: 99,
          NUM_FOUR: 100,
          NUM_FIVE: 101,
          NUM_SIX: 102,
          NUM_SEVEN: 103,
          NUM_EIGHT: 104,
          NUM_NINE: 105,
          NUM_MULTIPLY: 106,
          NUM_PLUS: 107,
          NUM_MINUS: 109,
          NUM_PERIOD: 110,
          NUM_DIVISION: 111,
          F1: 112,
          F2: 113,
          F3: 114,
          F4: 115,
          F5: 116,
          F6: 117,
          F7: 118,
          F8: 119,
          F9: 120,
          F10: 121,
          F11: 122,
          F12: 123,
          NUMLOCK: 144,
          SEMICOLON: 186,
          DASH: 189,
          EQUALS: 187,
          COMMA: 188,
          PERIOD: 190,
          SLASH: 191,
          APOSTROPHE: 192,
          SINGLE_QUOTE: 222,
          OPEN_SQUARE_BRACKET: 219,
          BACKSLASH: 220,
          CLOSE_SQUARE_BRACKET: 221,
          WIN_KEY: 224,
          MAC_FF_META: 224,
          WIN_IME: 229,
          isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
            var t = e.keyCode;
            if (e.altKey && !e.ctrlKey || e.metaKey || t >= U.F1 && t <= U.F12) return !1;
            switch (t) {
              case U.ALT:
              case U.CAPS_LOCK:
              case U.CONTEXT_MENU:
              case U.CTRL:
              case U.DOWN:
              case U.END:
              case U.ESC:
              case U.HOME:
              case U.INSERT:
              case U.LEFT:
              case U.MAC_FF_META:
              case U.META:
              case U.NUMLOCK:
              case U.NUM_CENTER:
              case U.PAGE_DOWN:
              case U.PAGE_UP:
              case U.PAUSE:
              case U.PRINT_SCREEN:
              case U.RIGHT:
              case U.SHIFT:
              case U.UP:
              case U.WIN_KEY:
              case U.WIN_KEY_RIGHT:
                return !1;
              default:
                return !0;
            }
          },
          isCharacterKey: function isCharacterKey(e) {
            if (e >= U.ZERO && e <= U.NINE) return !0;
            if (e >= U.NUM_ZERO && e <= U.NUM_MULTIPLY) return !0;
            if (e >= U.A && e <= U.Z) return !0;
            if (-1 !== window.navigation.userAgent.indexOf("WebKit") && 0 === e) return !0;
            switch (e) {
              case U.SPACE:
              case U.QUESTION_MARK:
              case U.NUM_PLUS:
              case U.NUM_MINUS:
              case U.NUM_PERIOD:
              case U.NUM_DIVISION:
              case U.SEMICOLON:
              case U.DASH:
              case U.EQUALS:
              case U.COMMA:
              case U.PERIOD:
              case U.SLASH:
              case U.APOSTROPHE:
              case U.SINGLE_QUOTE:
              case U.OPEN_SQUARE_BRACKET:
              case U.BACKSLASH:
              case U.CLOSE_SQUARE_BRACKET:
                return !0;
              default:
                return !1;
            }
          }
        },
        G = U;
      function V(e, t) {
        try {
          return Object.keys(t).some(function (n) {
            return e.target === Object(C.findDOMNode)(t[n]);
          });
        } catch (e) {
          return !1;
        }
      }
      function H(e, t) {
        var n = t.min,
          r = t.max;
        return e < n || e > r;
      }
      function q(e) {
        return e.touches.length > 1 || "touchend" === e.type.toLowerCase() && e.touches.length > 0;
      }
      function W(e, t) {
        var n = t.marks,
          r = t.step,
          i = t.min,
          o = t.max,
          a = Object.keys(n).map(parseFloat);
        if (null !== r) {
          var s = Math.floor((o - i) / r),
            l = Math.min((e - i) / r, s),
            u = Math.round(l) * r + i;
          a.push(u);
        }
        var c = a.map(function (t) {
          return Math.abs(e - t);
        });
        return a[c.indexOf(Math.min.apply(Math, z()(c)))];
      }
      function $(e, t) {
        return e ? t.clientY : t.pageX;
      }
      function X(e, t) {
        return e ? t.touches[0].clientY : t.touches[0].pageX;
      }
      function Y(e, t) {
        var n = t.getBoundingClientRect();
        return e ? n.top + .5 * n.height : window.pageXOffset + n.left + .5 * n.width;
      }
      function K(e, t) {
        var n = t.max,
          r = t.min;
        return e <= r ? r : e >= n ? n : e;
      }
      function Z(e, t) {
        var n = t.step,
          r = isFinite(W(e, t)) ? W(e, t) : 0;
        return null === n ? r : parseFloat(r.toFixed(function (e) {
          var t = e.toString(),
            n = 0;
          return t.indexOf(".") >= 0 && (n = t.length - t.indexOf(".") - 1), n;
        }(n)));
      }
      function Q(e) {
        e.stopPropagation(), e.preventDefault();
      }
      function J(e, t, n) {
        var r = "increase";
        switch (e.keyCode) {
          case G.UP:
            r = t && n ? "decrease" : "increase";
            break;
          case G.RIGHT:
            r = !t && n ? "decrease" : "increase";
            break;
          case G.DOWN:
            r = t && n ? "increase" : "decrease";
            break;
          case G.LEFT:
            r = !t && n ? "increase" : "decrease";
            break;
          case G.END:
            return function (e, t) {
              return t.max;
            };
          case G.HOME:
            return function (e, t) {
              return t.min;
            };
          case G.PAGE_UP:
            return function (e, t) {
              return e + 2 * t.step;
            };
          case G.PAGE_DOWN:
            return function (e, t) {
              return e - 2 * t.step;
            };
          default:
            return;
        }
        return function (e, t) {
          return function (e, t, n) {
            var r = {
                increase: function increase(e, t) {
                  return e + t;
                },
                decrease: function decrease(e, t) {
                  return e - t;
                }
              },
              i = r[e](Object.keys(n.marks).indexOf(JSON.stringify(t)), 1),
              o = Object.keys(n.marks)[i];
            return n.step ? r[e](t, n.step) : Object.keys(n.marks).length && n.marks[o] ? n.marks[o] : t;
          }(r, e, t);
        };
      }
      function ee() {}
      function te(e) {
        var t, n;
        return n = t = function (e) {
          function t(e) {
            a()(this, t);
            var n = c()(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
            n.onMouseDown = function (e) {
              if (0 === e.button) {
                var t = n.props.vertical,
                  r = $(t, e);
                if (V(e, n.handlesRefs)) {
                  var i = Y(t, e.target);
                  n.dragOffset = r - i, r = i;
                } else n.dragOffset = 0;
                n.removeDocumentEvents(), n.onStart(r), n.addDocumentMouseEvents();
              }
            }, n.onTouchStart = function (e) {
              if (!q(e)) {
                var t = n.props.vertical,
                  r = X(t, e);
                if (V(e, n.handlesRefs)) {
                  var i = Y(t, e.target);
                  n.dragOffset = r - i, r = i;
                } else n.dragOffset = 0;
                n.onStart(r), n.addDocumentTouchEvents(), Q(e);
              }
            }, n.onFocus = function (e) {
              var t = n.props,
                r = t.onFocus,
                i = t.vertical;
              if (V(e, n.handlesRefs)) {
                var o = Y(i, e.target);
                n.dragOffset = 0, n.onStart(o), Q(e), r && r(e);
              }
            }, n.onBlur = function (e) {
              var t = n.props.onBlur;
              n.onEnd(), t && t(e);
            }, n.onMouseUp = function () {
              n.handlesRefs[n.prevMovedHandleIndex] && n.handlesRefs[n.prevMovedHandleIndex].clickFocus();
            }, n.onMouseMove = function (e) {
              if (n.sliderRef) {
                var t = $(n.props.vertical, e);
                n.onMove(e, t - n.dragOffset);
              } else n.onEnd();
            }, n.onTouchMove = function (e) {
              if (!q(e) && n.sliderRef) {
                var t = X(n.props.vertical, e);
                n.onMove(e, t - n.dragOffset);
              } else n.onEnd();
            }, n.onKeyDown = function (e) {
              n.sliderRef && V(e, n.handlesRefs) && n.onKeyboard(e);
            }, n.onClickMarkLabel = function (e, t) {
              e.stopPropagation(), n.onChange({
                value: t
              }), n.setState({
                value: t
              }, function () {
                return n.onEnd(!0);
              });
            }, n.saveSlider = function (e) {
              n.sliderRef = e;
            };
            var r = e.step,
              i = e.max,
              o = e.min,
              s = !isFinite(i - o) || (i - o) % r == 0;
            return y()(!r || Math.floor(r) !== r || s, "Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)", i - o, r), n.handlesRefs = {}, n;
          }
          return h()(t, e), l()(t, [{
            key: "componentDidMount",
            value: function value() {
              this.document = this.sliderRef && this.sliderRef.ownerDocument;
              var e = this.props,
                t = e.autoFocus,
                n = e.disabled;
              t && !n && this.focus();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              E()(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "componentWillUnmount", this) && E()(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "componentWillUnmount", this).call(this), this.removeDocumentEvents();
            }
          }, {
            key: "getSliderStart",
            value: function value() {
              var e = this.sliderRef,
                t = this.props,
                n = t.vertical,
                r = t.reverse,
                i = e.getBoundingClientRect();
              return n ? r ? i.bottom : i.top : window.pageXOffset + (r ? i.right : i.left);
            }
          }, {
            key: "getSliderLength",
            value: function value() {
              var e = this.sliderRef;
              if (!e) return 0;
              var t = e.getBoundingClientRect();
              return this.props.vertical ? t.height : t.width;
            }
          }, {
            key: "addDocumentTouchEvents",
            value: function value() {
              this.onTouchMoveListener = P(this.document, "touchmove", this.onTouchMove), this.onTouchUpListener = P(this.document, "touchend", this.onEnd);
            }
          }, {
            key: "addDocumentMouseEvents",
            value: function value() {
              this.onMouseMoveListener = P(this.document, "mousemove", this.onMouseMove), this.onMouseUpListener = P(this.document, "mouseup", this.onEnd);
            }
          }, {
            key: "removeDocumentEvents",
            value: function value() {
              this.onTouchMoveListener && this.onTouchMoveListener.remove(), this.onTouchUpListener && this.onTouchUpListener.remove(), this.onMouseMoveListener && this.onMouseMoveListener.remove(), this.onMouseUpListener && this.onMouseUpListener.remove();
            }
          }, {
            key: "focus",
            value: function value() {
              this.props.disabled || this.handlesRefs[0].focus();
            }
          }, {
            key: "blur",
            value: function value() {
              var e = this;
              this.props.disabled || Object.keys(this.handlesRefs).forEach(function (t) {
                e.handlesRefs[t] && e.handlesRefs[t].blur && e.handlesRefs[t].blur();
              });
            }
          }, {
            key: "calcValue",
            value: function value(e) {
              var t = this.props,
                n = t.vertical,
                r = t.min,
                i = t.max,
                o = Math.abs(Math.max(e, 0) / this.getSliderLength());
              return n ? (1 - o) * (i - r) + r : o * (i - r) + r;
            }
          }, {
            key: "calcValueByPos",
            value: function value(e) {
              var t = (this.props.reverse ? -1 : 1) * (e - this.getSliderStart());
              return this.trimAlignValue(this.calcValue(t));
            }
          }, {
            key: "calcOffset",
            value: function value(e) {
              var t = this.props,
                n = t.min;
              return 100 * ((e - n) / (t.max - n));
            }
          }, {
            key: "saveHandle",
            value: function value(e, t) {
              this.handlesRefs[e] = t;
            }
          }, {
            key: "render",
            value: function value() {
              var e,
                n = this.props,
                r = n.prefixCls,
                o = n.className,
                a = n.marks,
                s = n.dots,
                l = n.step,
                u = n.included,
                c = n.disabled,
                d = n.vertical,
                h = n.reverse,
                f = n.min,
                m = n.max,
                g = n.children,
                v = n.maximumTrackStyle,
                y = n.style,
                b = n.railStyle,
                x = n.dotStyle,
                w = n.activeDotStyle,
                S = E()(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "render", this).call(this),
                A = S.tracks,
                T = S.handles,
                M = R()(r, (e = {}, _()(e, r + "-with-marks", Object.keys(a).length), _()(e, r + "-disabled", c), _()(e, r + "-vertical", d), _()(e, o, o), e));
              return p.a.createElement("div", {
                ref: this.saveSlider,
                className: M,
                onTouchStart: c ? ee : this.onTouchStart,
                onMouseDown: c ? ee : this.onMouseDown,
                onMouseUp: c ? ee : this.onMouseUp,
                onKeyDown: c ? ee : this.onKeyDown,
                onFocus: c ? ee : this.onFocus,
                onBlur: c ? ee : this.onBlur,
                style: y
              }, p.a.createElement("div", {
                className: r + "-rail",
                style: i()({}, v, b)
              }), A, p.a.createElement(j, {
                prefixCls: r,
                vertical: d,
                reverse: h,
                marks: a,
                dots: s,
                step: l,
                included: u,
                lowerBound: this.getLowerBound(),
                upperBound: this.getUpperBound(),
                max: m,
                min: f,
                dotStyle: x,
                activeDotStyle: w
              }), T, p.a.createElement(L, {
                className: r + "-mark",
                onClickLabel: c ? ee : this.onClickMarkLabel,
                vertical: d,
                marks: a,
                included: u,
                lowerBound: this.getLowerBound(),
                upperBound: this.getUpperBound(),
                max: m,
                min: f,
                reverse: h
              }), g);
            }
          }]), t;
        }(e), t.displayName = "ComponentEnhancer(" + e.displayName + ")", t.propTypes = i()({}, e.propTypes, {
          min: g.a.number,
          max: g.a.number,
          step: g.a.number,
          marks: g.a.object,
          included: g.a.bool,
          className: g.a.string,
          prefixCls: g.a.string,
          disabled: g.a.bool,
          children: g.a.any,
          onBeforeChange: g.a.func,
          onChange: g.a.func,
          onAfterChange: g.a.func,
          handle: g.a.func,
          dots: g.a.bool,
          vertical: g.a.bool,
          style: g.a.object,
          reverse: g.a.bool,
          minimumTrackStyle: g.a.object,
          maximumTrackStyle: g.a.object,
          handleStyle: g.a.oneOfType([g.a.object, g.a.arrayOf(g.a.object)]),
          trackStyle: g.a.oneOfType([g.a.object, g.a.arrayOf(g.a.object)]),
          railStyle: g.a.object,
          dotStyle: g.a.object,
          activeDotStyle: g.a.object,
          autoFocus: g.a.bool,
          onFocus: g.a.func,
          onBlur: g.a.func
        }), t.defaultProps = i()({}, e.defaultProps, {
          prefixCls: "rc-slider",
          className: "",
          min: 0,
          max: 100,
          step: 1,
          marks: {},
          handle: function handle(e) {
            var t = e.index,
              n = S()(e, ["index"]);
            return delete n.dragging, null === n.value ? null : p.a.createElement(B, i()({}, n, {
              key: t
            }));
          },
          onBeforeChange: ee,
          onChange: ee,
          onAfterChange: ee,
          included: !0,
          disabled: !1,
          dots: !1,
          vertical: !1,
          reverse: !1,
          trackStyle: [{}],
          handleStyle: [{}],
          railStyle: {},
          dotStyle: {},
          activeDotStyle: {}
        }), n;
      }
      var ne = function (e) {
        function t(e) {
          a()(this, t);
          var n = c()(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          n.onEnd = function (e) {
            var t = n.state.dragging;
            n.removeDocumentEvents(), (t || e) && n.props.onAfterChange(n.getValue()), n.setState({
              dragging: !1
            });
          };
          var r = void 0 !== e.defaultValue ? e.defaultValue : e.min,
            i = void 0 !== e.value ? e.value : r;
          return n.state = {
            value: n.trimAlignValue(i),
            dragging: !1
          }, y()(!("minimumTrackStyle" in e), "minimumTrackStyle will be deprecated, please use trackStyle instead."), y()(!("maximumTrackStyle" in e), "maximumTrackStyle will be deprecated, please use railStyle instead."), n;
        }
        return h()(t, e), l()(t, [{
          key: "componentDidUpdate",
          value: function value(e, t) {
            if ("value" in this.props || "min" in this.props || "max" in this.props) {
              var n = this.props,
                r = n.value,
                i = n.onChange,
                o = void 0 !== r ? r : t.value,
                a = this.trimAlignValue(o, this.props);
              a !== t.value && (this.setState({
                value: a
              }), H(o, this.props) && i(a));
            }
          }
        }, {
          key: "onChange",
          value: function value(e) {
            var t = this.props,
              n = !("value" in t),
              r = e.value > this.props.max ? i()({}, e, {
                value: this.props.max
              }) : e;
            n && this.setState(r);
            var o = r.value;
            t.onChange(o);
          }
        }, {
          key: "onStart",
          value: function value(e) {
            this.setState({
              dragging: !0
            });
            var t = this.props,
              n = this.getValue();
            t.onBeforeChange(n);
            var r = this.calcValueByPos(e);
            this.startValue = r, this.startPosition = e, r !== n && (this.prevMovedHandleIndex = 0, this.onChange({
              value: r
            }));
          }
        }, {
          key: "onMove",
          value: function value(e, t) {
            Q(e);
            var n = this.state.value,
              r = this.calcValueByPos(t);
            r !== n && this.onChange({
              value: r
            });
          }
        }, {
          key: "onKeyboard",
          value: function value(e) {
            var t = this.props,
              n = t.reverse,
              r = J(e, t.vertical, n);
            if (r) {
              Q(e);
              var i = this.state.value,
                o = r(i, this.props),
                a = this.trimAlignValue(o);
              if (a === i) return;
              this.onChange({
                value: a
              }), this.props.onAfterChange(a), this.onEnd();
            }
          }
        }, {
          key: "getValue",
          value: function value() {
            return this.state.value;
          }
        }, {
          key: "getLowerBound",
          value: function value() {
            return this.props.min;
          }
        }, {
          key: "getUpperBound",
          value: function value() {
            return this.state.value;
          }
        }, {
          key: "trimAlignValue",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (null === e) return null;
            var n = i()({}, this.props, t),
              r = K(e, n);
            return Z(r, n);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.prefixCls,
              r = t.vertical,
              o = t.included,
              a = t.disabled,
              s = t.minimumTrackStyle,
              l = t.trackStyle,
              u = t.handleStyle,
              c = t.tabIndex,
              d = t.min,
              h = t.max,
              f = t.reverse,
              m = t.handle,
              g = this.state,
              v = g.value,
              y = g.dragging,
              b = this.calcOffset(v),
              _ = m({
                className: n + "-handle",
                prefixCls: n,
                vertical: r,
                offset: b,
                value: v,
                dragging: y,
                disabled: a,
                min: d,
                max: h,
                reverse: f,
                index: 0,
                tabIndex: c,
                style: u[0] || u,
                ref: function ref(t) {
                  return e.saveHandle(0, t);
                }
              }),
              w = l[0] || l;
            return {
              tracks: p.a.createElement(x, {
                className: n + "-track",
                vertical: r,
                included: o,
                offset: 0,
                reverse: f,
                length: b,
                style: i()({}, s, w)
              }),
              handles: _
            };
          }
        }]), t;
      }(p.a.Component);
      ne.propTypes = {
        defaultValue: g.a.number,
        value: g.a.number,
        disabled: g.a.bool,
        autoFocus: g.a.bool,
        tabIndex: g.a.number,
        reverse: g.a.bool,
        min: g.a.number,
        max: g.a.number
      };
      var re = te(ne),
        ie = n("./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js"),
        oe = n("./node_modules/shallowequal/index.js"),
        ae = n.n(oe),
        se = function se(e) {
          var t = e.value,
            n = e.handle,
            r = e.bounds,
            i = e.props,
            o = i.allowCross,
            a = i.pushable,
            s = Number(a),
            l = K(t, i),
            u = l;
          return o || null == n || void 0 === r || (n > 0 && l <= r[n - 1] + s && (u = r[n - 1] + s), n < r.length - 1 && l >= r[n + 1] - s && (u = r[n + 1] - s)), Z(u, i);
        },
        le = function (e) {
          function t(e) {
            a()(this, t);
            var n = c()(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
            n.onEnd = function (e) {
              var t = n.state.handle;
              n.removeDocumentEvents(), (null !== t || e) && n.props.onAfterChange(n.getValue()), n.setState({
                handle: null
              });
            };
            var r = e.count,
              i = e.min,
              o = e.max,
              s = Array.apply(void 0, z()(Array(r + 1))).map(function () {
                return i;
              }),
              l = "defaultValue" in e ? e.defaultValue : s,
              u = (void 0 !== e.value ? e.value : l).map(function (t, n) {
                return se({
                  value: t,
                  handle: n,
                  props: e
                });
              }),
              d = u[0] === o ? 0 : u.length - 1;
            return n.state = {
              handle: null,
              recent: d,
              bounds: u
            }, n;
          }
          return h()(t, e), l()(t, [{
            key: "componentDidUpdate",
            value: function value(e, t) {
              var n = this;
              if (("value" in this.props || "min" in this.props || "max" in this.props) && (this.props.min !== e.min || this.props.max !== e.max || !ae()(this.props.value, e.value))) {
                var r = this.props,
                  i = r.onChange,
                  o = r.value || t.bounds;
                if (o.some(function (e) {
                  return H(e, n.props);
                })) i(o.map(function (e) {
                  return K(e, n.props);
                }));
              }
            }
          }, {
            key: "onChange",
            value: function value(e) {
              var t = this.props;
              if (!("value" in t)) this.setState(e);else {
                var n = {};
                ["handle", "recent"].forEach(function (t) {
                  void 0 !== e[t] && (n[t] = e[t]);
                }), Object.keys(n).length && this.setState(n);
              }
              var r = i()({}, this.state, e).bounds;
              t.onChange(r);
            }
          }, {
            key: "onStart",
            value: function value(e) {
              var t = this.props,
                n = this.state,
                r = this.getValue();
              t.onBeforeChange(r);
              var i = this.calcValueByPos(e);
              this.startValue = i, this.startPosition = e;
              var o = this.getClosestBound(i);
              if (this.prevMovedHandleIndex = this.getBoundNeedMoving(i, o), this.setState({
                handle: this.prevMovedHandleIndex,
                recent: this.prevMovedHandleIndex
              }), i !== r[this.prevMovedHandleIndex]) {
                var a = [].concat(z()(n.bounds));
                a[this.prevMovedHandleIndex] = i, this.onChange({
                  bounds: a
                });
              }
            }
          }, {
            key: "onMove",
            value: function value(e, t) {
              Q(e);
              var n = this.state,
                r = this.calcValueByPos(t);
              r !== n.bounds[n.handle] && this.moveTo(r);
            }
          }, {
            key: "onKeyboard",
            value: function value(e) {
              var t = this.props,
                n = t.reverse,
                r = J(e, t.vertical, n);
              if (r) {
                Q(e);
                var i = this.state,
                  o = this.props,
                  a = i.bounds,
                  s = i.handle,
                  l = a[null === s ? i.recent : s],
                  u = r(l, o),
                  c = se({
                    value: u,
                    handle: s,
                    bounds: i.bounds,
                    props: o
                  });
                if (c === l) return;
                this.moveTo(c, !0);
              }
            }
          }, {
            key: "getValue",
            value: function value() {
              return this.state.bounds;
            }
          }, {
            key: "getClosestBound",
            value: function value(e) {
              for (var t = this.state.bounds, n = 0, r = 1; r < t.length - 1; ++r) e >= t[r] && (n = r);
              return Math.abs(t[n + 1] - e) < Math.abs(t[n] - e) && (n += 1), n;
            }
          }, {
            key: "getBoundNeedMoving",
            value: function value(e, t) {
              var n = this.state,
                r = n.bounds,
                i = n.recent,
                o = t,
                a = r[t + 1] === r[t];
              return a && r[i] === r[t] && (o = i), a && e !== r[t + 1] && (o = e < r[t + 1] ? t : t + 1), o;
            }
          }, {
            key: "getLowerBound",
            value: function value() {
              return this.state.bounds[0];
            }
          }, {
            key: "getUpperBound",
            value: function value() {
              var e = this.state.bounds;
              return e[e.length - 1];
            }
          }, {
            key: "getPoints",
            value: function value() {
              var e = this.props,
                t = e.marks,
                n = e.step,
                r = e.min,
                o = e.max,
                a = this._getPointsCache;
              if (!a || a.marks !== t || a.step !== n) {
                var s = i()({}, t);
                if (null !== n) for (var l = r; l <= o; l += n) s[l] = l;
                var u = Object.keys(s).map(parseFloat);
                u.sort(function (e, t) {
                  return e - t;
                }), this._getPointsCache = {
                  marks: t,
                  step: n,
                  points: u
                };
              }
              return this._getPointsCache.points;
            }
          }, {
            key: "moveTo",
            value: function value(e, t) {
              var n = this,
                r = this.state,
                i = this.props,
                o = [].concat(z()(r.bounds)),
                a = null === r.handle ? r.recent : r.handle;
              o[a] = e;
              var s = a;
              !1 !== i.pushable ? this.pushSurroundingHandles(o, s) : i.allowCross && (o.sort(function (e, t) {
                return e - t;
              }), s = o.indexOf(e)), this.onChange({
                recent: s,
                handle: s,
                bounds: o
              }), t && (this.props.onAfterChange(o), this.setState({}, function () {
                n.handlesRefs[s].focus();
              }), this.onEnd());
            }
          }, {
            key: "pushSurroundingHandles",
            value: function value(e, t) {
              var n = e[t],
                r = this.props.pushable;
              r = Number(r);
              var i = 0;
              if (e[t + 1] - n < r && (i = 1), n - e[t - 1] < r && (i = -1), 0 !== i) {
                var o = t + i,
                  a = i * (e[o] - n);
                this.pushHandle(e, o, i, r - a) || (e[t] = e[o] - i * r);
              }
            }
          }, {
            key: "pushHandle",
            value: function value(e, t, n, r) {
              for (var i = e[t], o = e[t]; n * (o - i) < r;) {
                if (!this.pushHandleOnePoint(e, t, n)) return e[t] = i, !1;
                o = e[t];
              }
              return !0;
            }
          }, {
            key: "pushHandleOnePoint",
            value: function value(e, t, n) {
              var r = this.getPoints(),
                i = r.indexOf(e[t]) + n;
              if (i >= r.length || i < 0) return !1;
              var o = t + n,
                a = r[i],
                s = this.props.pushable,
                l = n * (e[o] - a);
              return !!this.pushHandle(e, o, n, s - l) && (e[t] = a, !0);
            }
          }, {
            key: "trimAlignValue",
            value: function value(e) {
              var t = this.state,
                n = t.handle,
                r = t.bounds;
              return se({
                value: e,
                handle: n,
                bounds: r,
                props: this.props
              });
            }
          }, {
            key: "render",
            value: function value() {
              var e = this,
                t = this.state,
                n = t.handle,
                r = t.bounds,
                i = this.props,
                o = i.prefixCls,
                a = i.vertical,
                s = i.included,
                l = i.disabled,
                u = i.min,
                c = i.max,
                d = i.reverse,
                h = i.handle,
                f = i.trackStyle,
                m = i.handleStyle,
                g = i.tabIndex,
                v = r.map(function (t) {
                  return e.calcOffset(t);
                }),
                y = o + "-handle",
                b = r.map(function (t, r) {
                  var i,
                    s = g[r] || 0;
                  return (l || null === g[r]) && (s = null), h({
                    className: R()((i = {}, _()(i, y, !0), _()(i, y + "-" + (r + 1), !0), i)),
                    prefixCls: o,
                    vertical: a,
                    offset: v[r],
                    value: t,
                    dragging: n === r,
                    index: r,
                    tabIndex: s,
                    min: u,
                    max: c,
                    reverse: d,
                    disabled: l,
                    style: m[r],
                    ref: function ref(t) {
                      return e.saveHandle(r, t);
                    }
                  });
                });
              return {
                tracks: r.slice(0, -1).map(function (e, t) {
                  var n,
                    r = t + 1,
                    i = R()((n = {}, _()(n, o + "-track", !0), _()(n, o + "-track-" + r, !0), n));
                  return p.a.createElement(x, {
                    className: i,
                    vertical: a,
                    reverse: d,
                    included: s,
                    offset: v[r - 1],
                    length: v[r] - v[r - 1],
                    style: f[t],
                    key: r
                  });
                }),
                handles: b
              };
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function value(e, t) {
              if ("value" in e || "min" in e || "max" in e) {
                var n = (e.value || t.bounds).map(function (n, r) {
                  return se({
                    value: n,
                    handle: r,
                    bounds: t.bounds,
                    props: e
                  });
                });
                return n.length === t.bounds.length && n.every(function (e, n) {
                  return e === t.bounds[n];
                }) ? null : i()({}, t, {
                  bounds: n
                });
              }
              return null;
            }
          }]), t;
        }(p.a.Component);
      le.displayName = "Range", le.propTypes = {
        autoFocus: g.a.bool,
        defaultValue: g.a.arrayOf(g.a.number),
        value: g.a.arrayOf(g.a.number),
        count: g.a.number,
        pushable: g.a.oneOfType([g.a.bool, g.a.number]),
        allowCross: g.a.bool,
        disabled: g.a.bool,
        reverse: g.a.bool,
        tabIndex: g.a.arrayOf(g.a.number),
        min: g.a.number,
        max: g.a.number
      }, le.defaultProps = {
        count: 1,
        allowCross: !0,
        pushable: !1,
        tabIndex: []
      }, Object(ie.a)(le);
      var ue = te(le);
      function ce(e, t) {
        for (var n = t; n;) {
          if (n === e) return !0;
          n = n.parentNode;
        }
        return !1;
      }
      function de(e) {
        return (de = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function he(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function fe(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function pe(e, t) {
        return !t || "object" !== de(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function me(e) {
        return (me = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function ge(e, t) {
        return (ge = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      var ve = function (e) {
        function t() {
          var e, n;
          he(this, t);
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
          return (n = pe(this, (e = me(t)).call.apply(e, [this].concat(i)))).removeContainer = function () {
            n.container && (k.a.unmountComponentAtNode(n.container), n.container.parentNode.removeChild(n.container), n.container = null);
          }, n.renderComponent = function (e, t) {
            var r = n.props,
              i = r.visible,
              o = r.getComponent,
              a = r.forceRender,
              s = r.getContainer,
              l = r.parent;
            (i || l._component || a) && (n.container || (n.container = s()), k.a.unstable_renderSubtreeIntoContainer(l, o(e), n.container, function () {
              t && t.call(this);
            }));
          }, n;
        }
        var n, r, i;
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && ge(e, t);
        }(t, e), n = t, (r = [{
          key: "componentDidMount",
          value: function value() {
            this.props.autoMount && this.renderComponent();
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.props.autoMount && this.renderComponent();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.props.autoDestroy && this.removeContainer();
          }
        }, {
          key: "render",
          value: function value() {
            return this.props.children({
              renderComponent: this.renderComponent,
              removeContainer: this.removeContainer
            });
          }
        }]) && fe(n.prototype, r), i && fe(n, i), t;
      }(p.a.Component);
      function ye(e) {
        return (ye = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function be(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function _e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function xe(e, t) {
        return !t || "object" !== ye(t) && "function" != typeof t ? function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e) : t;
      }
      function we(e) {
        return (we = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function Se(e, t) {
        return (Se = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      ve.propTypes = {
        autoMount: g.a.bool,
        autoDestroy: g.a.bool,
        visible: g.a.bool,
        forceRender: g.a.bool,
        parent: g.a.any,
        getComponent: g.a.func.isRequired,
        getContainer: g.a.func.isRequired,
        children: g.a.func.isRequired
      }, ve.defaultProps = {
        autoMount: !0,
        autoDestroy: !0,
        forceRender: !1
      };
      var Ae,
        Ee = function (e) {
          function t() {
            return be(this, t), xe(this, we(t).apply(this, arguments));
          }
          var n, r, i;
          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && Se(e, t);
          }(t, e), n = t, (r = [{
            key: "componentDidMount",
            value: function value() {
              this.createContainer();
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              var t = this.props.didUpdate;
              t && t(e);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.removeContainer();
            }
          }, {
            key: "createContainer",
            value: function value() {
              this._container = this.props.getContainer(), this.forceUpdate();
            }
          }, {
            key: "removeContainer",
            value: function value() {
              this._container && this._container.parentNode.removeChild(this._container);
            }
          }, {
            key: "render",
            value: function value() {
              return this._container ? k.a.createPortal(this.props.children, this._container) : null;
            }
          }]) && _e(n.prototype, r), i && _e(n, i), t;
        }(p.a.Component);
      function Te(e, t, n) {
        return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
      }
      function Me(e, t) {
        this[e] = t;
      }
      function Ce(e) {
        return (Ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function ke(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function Pe(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      Ee.propTypes = {
        getContainer: g.a.func.isRequired,
        children: g.a.node.isRequired,
        didUpdate: g.a.func
      };
      var Oe = {
        Webkit: "-webkit-",
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-"
      };
      function Re() {
        if (void 0 !== Ae) return Ae;
        Ae = "";
        var e = document.createElement("p").style;
        for (var t in Oe) t + "Transform" in e && (Ae = t);
        return Ae;
      }
      function Ie() {
        return Re() ? "".concat(Re(), "TransitionProperty") : "transitionProperty";
      }
      function je() {
        return Re() ? "".concat(Re(), "Transform") : "transform";
      }
      function Ne(e, t) {
        var n = Ie();
        n && (e.style[n] = t, "transitionProperty" !== n && (e.style.transitionProperty = t));
      }
      function Le(e, t) {
        var n = je();
        n && (e.style[n] = t, "transform" !== n && (e.style.transform = t));
      }
      var De,
        Be = /matrix\((.*)\)/,
        Fe = /matrix3d\((.*)\)/;
      function ze(e) {
        var t = e.style.display;
        e.style.display = "none", e.offsetHeight, e.style.display = t;
      }
      function Ue(e, t, n) {
        var r = n;
        if ("object" !== Ce(t)) return void 0 !== r ? ("number" == typeof r && (r = "".concat(r, "px")), void (e.style[t] = r)) : De(e, t);
        for (var i in t) t.hasOwnProperty(i) && Ue(e, i, t[i]);
      }
      function Ge(e, t) {
        var n = e["page".concat(t ? "Y" : "X", "Offset")],
          r = "scroll".concat(t ? "Top" : "Left");
        if ("number" != typeof n) {
          var i = e.document;
          "number" != typeof (n = i.documentElement[r]) && (n = i.body[r]);
        }
        return n;
      }
      function Ve(e) {
        return Ge(e);
      }
      function He(e) {
        return Ge(e, !0);
      }
      function qe(e) {
        var t = function (e) {
            var t,
              n,
              r,
              i = e.ownerDocument,
              o = i.body,
              a = i && i.documentElement;
            return n = (t = e.getBoundingClientRect()).left, r = t.top, {
              left: n -= a.clientLeft || o.clientLeft || 0,
              top: r -= a.clientTop || o.clientTop || 0
            };
          }(e),
          n = e.ownerDocument,
          r = n.defaultView || n.parentWindow;
        return t.left += Ve(r), t.top += He(r), t;
      }
      function We(e) {
        return null != e && e == e.window;
      }
      function $e(e) {
        return We(e) ? e.document : 9 === e.nodeType ? e : e.ownerDocument;
      }
      var Xe = new RegExp("^(".concat(/[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, ")(?!px)[a-z%]+$"), "i"),
        Ye = /^(top|right|bottom|left)$/,
        Ke = "left";
      function Ze(e, t) {
        return "left" === e ? t.useCssRight ? "right" : e : t.useCssBottom ? "bottom" : e;
      }
      function Qe(e) {
        return "left" === e ? "right" : "right" === e ? "left" : "top" === e ? "bottom" : "bottom" === e ? "top" : void 0;
      }
      function Je(e, t, n) {
        "static" === Ue(e, "position") && (e.style.position = "relative");
        var r = -999,
          i = -999,
          o = Ze("left", n),
          a = Ze("top", n),
          s = Qe(o),
          l = Qe(a);
        "left" !== o && (r = 999), "top" !== a && (i = 999);
        var u,
          c = "",
          d = qe(e);
        ("left" in t || "top" in t) && (c = (u = e).style.transitionProperty || u.style[Ie()] || "", Ne(e, "none")), "left" in t && (e.style[s] = "", e.style[o] = "".concat(r, "px")), "top" in t && (e.style[l] = "", e.style[a] = "".concat(i, "px")), ze(e);
        var h = qe(e),
          f = {};
        for (var p in t) if (t.hasOwnProperty(p)) {
          var m = Ze(p, n),
            g = "left" === p ? r : i,
            v = d[p] - h[p];
          f[m] = m === p ? g + v : g - v;
        }
        Ue(e, f), ze(e), ("left" in t || "top" in t) && Ne(e, c);
        var y = {};
        for (var b in t) if (t.hasOwnProperty(b)) {
          var _ = Ze(b, n),
            x = t[b] - d[b];
          y[_] = b === _ ? f[_] + x : f[_] - x;
        }
        Ue(e, y);
      }
      function et(e, t) {
        var n = qe(e),
          r = function (e) {
            var t = window.getComputedStyle(e, null),
              n = t.getPropertyValue("transform") || t.getPropertyValue(je());
            if (n && "none" !== n) {
              var r = n.replace(/[^0-9\-.,]/g, "").split(",");
              return {
                x: parseFloat(r[12] || r[4], 0),
                y: parseFloat(r[13] || r[5], 0)
              };
            }
            return {
              x: 0,
              y: 0
            };
          }(e),
          i = {
            x: r.x,
            y: r.y
          };
        "left" in t && (i.x = r.x + t.left - n.left), "top" in t && (i.y = r.y + t.top - n.top), function (e, t) {
          var n = window.getComputedStyle(e, null),
            r = n.getPropertyValue("transform") || n.getPropertyValue(je());
          if (r && "none" !== r) {
            var i,
              o = r.match(Be);
            if (o) (i = (o = o[1]).split(",").map(function (e) {
              return parseFloat(e, 10);
            }))[4] = t.x, i[5] = t.y, Le(e, "matrix(".concat(i.join(","), ")"));else (i = r.match(Fe)[1].split(",").map(function (e) {
              return parseFloat(e, 10);
            }))[12] = t.x, i[13] = t.y, Le(e, "matrix3d(".concat(i.join(","), ")"));
          } else Le(e, "translateX(".concat(t.x, "px) translateY(").concat(t.y, "px) translateZ(0)"));
        }(e, i);
      }
      function tt(e, t) {
        for (var n = 0; n < e.length; n++) t(e[n]);
      }
      function nt(e) {
        return "border-box" === De(e, "boxSizing");
      }
      "undefined" != typeof window && (De = window.getComputedStyle ? function (e, t, n) {
        var r = n,
          i = "",
          o = $e(e);
        return (r = r || o.defaultView.getComputedStyle(e, null)) && (i = r.getPropertyValue(t) || r[t]), i;
      } : function (e, t) {
        var n = e.currentStyle && e.currentStyle[t];
        if (Xe.test(n) && !Ye.test(t)) {
          var r = e.style,
            i = r[Ke],
            o = e.runtimeStyle[Ke];
          e.runtimeStyle[Ke] = e.currentStyle[Ke], r[Ke] = "fontSize" === t ? "1em" : n || 0, n = r.pixelLeft + "px", r[Ke] = i, e.runtimeStyle[Ke] = o;
        }
        return "" === n ? "auto" : n;
      });
      var rt = ["margin", "border", "padding"];
      function it(e, t, n) {
        var r,
          i = {},
          o = e.style;
        for (r in t) t.hasOwnProperty(r) && (i[r] = o[r], o[r] = t[r]);
        for (r in n.call(e), t) t.hasOwnProperty(r) && (o[r] = i[r]);
      }
      function ot(e, t, n) {
        var r,
          i,
          o,
          a = 0;
        for (i = 0; i < t.length; i++) if (r = t[i]) for (o = 0; o < n.length; o++) {
          var s = void 0;
          s = "border" === r ? "".concat(r).concat(n[o], "Width") : r + n[o], a += parseFloat(De(e, s)) || 0;
        }
        return a;
      }
      var at = {
        getParent: function getParent(e) {
          var t = e;
          do {
            t = 11 === t.nodeType && t.host ? t.host : t.parentNode;
          } while (t && 1 !== t.nodeType && 9 !== t.nodeType);
          return t;
        }
      };
      function st(e, t, n) {
        var r = n;
        if (We(e)) return "width" === t ? at.viewportWidth(e) : at.viewportHeight(e);
        if (9 === e.nodeType) return "width" === t ? at.docWidth(e) : at.docHeight(e);
        var i = "width" === t ? ["Left", "Right"] : ["Top", "Bottom"],
          o = "width" === t ? e.getBoundingClientRect().width : e.getBoundingClientRect().height,
          a = (De(e), nt(e)),
          s = 0;
        (null == o || o <= 0) && (o = void 0, (null == (s = De(e, t)) || Number(s) < 0) && (s = e.style[t] || 0), s = parseFloat(s) || 0), void 0 === r && (r = a ? 1 : -1);
        var l = void 0 !== o || a,
          u = o || s;
        return -1 === r ? l ? u - ot(e, ["border", "padding"], i) : s : l ? 1 === r ? u : u + (2 === r ? -ot(e, ["border"], i) : ot(e, ["margin"], i)) : s + ot(e, rt.slice(r), i);
      }
      tt(["Width", "Height"], function (e) {
        at["doc".concat(e)] = function (t) {
          var n = t.document;
          return Math.max(n.documentElement["scroll".concat(e)], n.body["scroll".concat(e)], at["viewport".concat(e)](n));
        }, at["viewport".concat(e)] = function (t) {
          var n = "client".concat(e),
            r = t.document,
            i = r.body,
            o = r.documentElement[n];
          return "CSS1Compat" === r.compatMode && o || i && i[n] || o;
        };
      });
      var lt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
      };
      function ut() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        var r,
          i = t[0];
        return 0 !== i.offsetWidth ? r = st.apply(void 0, t) : it(i, lt, function () {
          r = st.apply(void 0, t);
        }), r;
      }
      function ct(e, t) {
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        return e;
      }
      tt(["width", "height"], function (e) {
        var t = e.charAt(0).toUpperCase() + e.slice(1);
        at["outer".concat(t)] = function (t, n) {
          return t && ut(t, e, n ? 0 : 1);
        };
        var n = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"];
        at[e] = function (t, r) {
          var i = r;
          if (void 0 === i) return t && ut(t, e, -1);
          if (t) {
            De(t);
            return nt(t) && (i += ot(t, ["padding", "border"], n)), Ue(t, e, i);
          }
        };
      });
      var dt = {
        getWindow: function getWindow(e) {
          if (e && e.document && e.setTimeout) return e;
          var t = e.ownerDocument || e;
          return t.defaultView || t.parentWindow;
        },
        getDocument: $e,
        offset: function offset(e, t, n) {
          if (void 0 === t) return qe(e);
          !function (e, t, n) {
            if (n.ignoreShake) {
              var r = qe(e),
                i = r.left.toFixed(0),
                o = r.top.toFixed(0),
                a = t.left.toFixed(0),
                s = t.top.toFixed(0);
              if (i === a && o === s) return;
            }
            n.useCssRight || n.useCssBottom ? Je(e, t, n) : n.useCssTransform && je() in document.body.style ? et(e, t) : Je(e, t, n);
          }(e, t, n || {});
        },
        isWindow: We,
        each: tt,
        css: Ue,
        clone: function clone(e) {
          var t,
            n = {};
          for (t in e) e.hasOwnProperty(t) && (n[t] = e[t]);
          if (e.overflow) for (t in e) e.hasOwnProperty(t) && (n.overflow[t] = e.overflow[t]);
          return n;
        },
        mix: ct,
        getWindowScrollLeft: function getWindowScrollLeft(e) {
          return Ve(e);
        },
        getWindowScrollTop: function getWindowScrollTop(e) {
          return He(e);
        },
        merge: function merge() {
          for (var e = {}, t = 0; t < arguments.length; t++) dt.mix(e, t < 0 || arguments.length <= t ? void 0 : arguments[t]);
          return e;
        },
        viewportWidth: 0,
        viewportHeight: 0
      };
      ct(dt, at);
      var ht = dt.getParent;
      function ft(e) {
        if (dt.isWindow(e) || 9 === e.nodeType) return null;
        var t,
          n = dt.getDocument(e).body,
          r = dt.css(e, "position");
        if (!("fixed" === r || "absolute" === r)) return "html" === e.nodeName.toLowerCase() ? null : ht(e);
        for (t = ht(e); t && t !== n; t = ht(t)) if ("static" !== (r = dt.css(t, "position"))) return t;
        return null;
      }
      var pt = dt.getParent;
      function mt(e) {
        for (var t = {
            left: 0,
            right: 1 / 0,
            top: 0,
            bottom: 1 / 0
          }, n = ft(e), r = dt.getDocument(e), i = r.defaultView || r.parentWindow, o = r.body, a = r.documentElement; n;) {
          if (-1 !== navigator.userAgent.indexOf("MSIE") && 0 === n.clientWidth || n === o || n === a || "visible" === dt.css(n, "overflow")) {
            if (n === o || n === a) break;
          } else {
            var s = dt.offset(n);
            s.left += n.clientLeft, s.top += n.clientTop, t.top = Math.max(t.top, s.top), t.right = Math.min(t.right, s.left + n.clientWidth), t.bottom = Math.min(t.bottom, s.top + n.clientHeight), t.left = Math.max(t.left, s.left);
          }
          n = ft(n);
        }
        var l = null;
        dt.isWindow(e) || 9 === e.nodeType || (l = e.style.position, "absolute" === dt.css(e, "position") && (e.style.position = "fixed"));
        var u = dt.getWindowScrollLeft(i),
          c = dt.getWindowScrollTop(i),
          d = dt.viewportWidth(i),
          h = dt.viewportHeight(i),
          f = a.scrollWidth,
          p = a.scrollHeight,
          m = window.getComputedStyle(o);
        if ("hidden" === m.overflowX && (f = i.innerWidth), "hidden" === m.overflowY && (p = i.innerHeight), e.style && (e.style.position = l), function (e) {
          if (dt.isWindow(e) || 9 === e.nodeType) return !1;
          var t = dt.getDocument(e).body,
            n = null;
          for (n = pt(e); n && n !== t; n = pt(n)) {
            if ("fixed" === dt.css(n, "position")) return !0;
          }
          return !1;
        }(e)) t.left = Math.max(t.left, u), t.top = Math.max(t.top, c), t.right = Math.min(t.right, u + d), t.bottom = Math.min(t.bottom, c + h);else {
          var g = Math.max(f, u + d);
          t.right = Math.min(t.right, g);
          var v = Math.max(p, c + h);
          t.bottom = Math.min(t.bottom, v);
        }
        return t.top >= 0 && t.left >= 0 && t.bottom > t.top && t.right > t.left ? t : null;
      }
      function gt(e) {
        var t, n, r;
        if (dt.isWindow(e) || 9 === e.nodeType) {
          var i = dt.getWindow(e);
          t = {
            left: dt.getWindowScrollLeft(i),
            top: dt.getWindowScrollTop(i)
          }, n = dt.viewportWidth(i), r = dt.viewportHeight(i);
        } else t = dt.offset(e), n = dt.outerWidth(e), r = dt.outerHeight(e);
        return t.width = n, t.height = r, t;
      }
      function vt(e, t) {
        var n = t.charAt(0),
          r = t.charAt(1),
          i = e.width,
          o = e.height,
          a = e.left,
          s = e.top;
        return "c" === n ? s += o / 2 : "b" === n && (s += o), "c" === r ? a += i / 2 : "r" === r && (a += i), {
          left: a,
          top: s
        };
      }
      function yt(e, t, n, r, i) {
        var o = vt(t, n[1]),
          a = vt(e, n[0]),
          s = [a.left - o.left, a.top - o.top];
        return {
          left: Math.round(e.left - s[0] + r[0] - i[0]),
          top: Math.round(e.top - s[1] + r[1] - i[1])
        };
      }
      function bt(e, t, n) {
        return e.left < n.left || e.left + t.width > n.right;
      }
      function _t(e, t, n) {
        return e.top < n.top || e.top + t.height > n.bottom;
      }
      function xt(e, t, n) {
        var r = [];
        return dt.each(e, function (e) {
          r.push(e.replace(t, function (e) {
            return n[e];
          }));
        }), r;
      }
      function wt(e, t) {
        return e[t] = -e[t], e;
      }
      function St(e, t) {
        return (/%$/.test(e) ? parseInt(e.substring(0, e.length - 1), 10) / 100 * t : parseInt(e, 10)) || 0;
      }
      function At(e, t) {
        e[0] = St(e[0], t.width), e[1] = St(e[1], t.height);
      }
      function Et(e, t, n, r) {
        var i = n.points,
          o = n.offset || [0, 0],
          a = n.targetOffset || [0, 0],
          s = n.overflow,
          l = n.source || e;
        o = [].concat(o), a = [].concat(a), s = s || {};
        var u = {},
          c = 0,
          d = mt(l),
          h = gt(l);
        At(o, h), At(a, t);
        var f = yt(h, t, i, o, a),
          p = dt.merge(h, f);
        if (d && (s.adjustX || s.adjustY) && r) {
          if (s.adjustX && bt(f, h, d)) {
            var m = xt(i, /[lr]/gi, {
                l: "r",
                r: "l"
              }),
              g = wt(o, 0),
              v = wt(a, 0);
            (function (e, t, n) {
              return e.left > n.right || e.left + t.width < n.left;
            })(yt(h, t, m, g, v), h, d) || (c = 1, i = m, o = g, a = v);
          }
          if (s.adjustY && _t(f, h, d)) {
            var y = xt(i, /[tb]/gi, {
                t: "b",
                b: "t"
              }),
              b = wt(o, 1),
              _ = wt(a, 1);
            (function (e, t, n) {
              return e.top > n.bottom || e.top + t.height < n.top;
            })(yt(h, t, y, b, _), h, d) || (c = 1, i = y, o = b, a = _);
          }
          c && (f = yt(h, t, i, o, a), dt.mix(p, f));
          var x = bt(f, h, d),
            w = _t(f, h, d);
          (x || w) && (i = n.points, o = n.offset || [0, 0], a = n.targetOffset || [0, 0]), u.adjustX = s.adjustX && x, u.adjustY = s.adjustY && w, (u.adjustX || u.adjustY) && (p = function (e, t, n, r) {
            var i = dt.clone(e),
              o = {
                width: t.width,
                height: t.height
              };
            return r.adjustX && i.left < n.left && (i.left = n.left), r.resizeWidth && i.left >= n.left && i.left + o.width > n.right && (o.width -= i.left + o.width - n.right), r.adjustX && i.left + o.width > n.right && (i.left = Math.max(n.right - o.width, n.left)), r.adjustY && i.top < n.top && (i.top = n.top), r.resizeHeight && i.top >= n.top && i.top + o.height > n.bottom && (o.height -= i.top + o.height - n.bottom), r.adjustY && i.top + o.height > n.bottom && (i.top = Math.max(n.bottom - o.height, n.top)), dt.mix(i, o);
          }(f, h, d, u));
        }
        return p.width !== h.width && dt.css(l, "width", dt.width(l) + p.width - h.width), p.height !== h.height && dt.css(l, "height", dt.height(l) + p.height - h.height), dt.offset(l, {
          left: p.left,
          top: p.top
        }, {
          useCssRight: n.useCssRight,
          useCssBottom: n.useCssBottom,
          useCssTransform: n.useCssTransform,
          ignoreShake: n.ignoreShake
        }), {
          points: i,
          offset: o,
          targetOffset: a,
          overflow: u
        };
      }
      function Tt(e, t, n) {
        var r = n.target || t;
        return Et(e, gt(r), n, !function (e) {
          var t = mt(e),
            n = gt(e);
          return !t || n.left + n.width <= t.left || n.top + n.height <= t.top || n.left >= t.right || n.top >= t.bottom;
        }(r));
      }
      function Mt(e, t, n) {
        var r,
          i,
          o = dt.getDocument(e),
          a = o.defaultView || o.parentWindow,
          s = dt.getWindowScrollLeft(a),
          l = dt.getWindowScrollTop(a),
          u = dt.viewportWidth(a),
          c = dt.viewportHeight(a);
        r = "pageX" in t ? t.pageX : s + t.clientX, i = "pageY" in t ? t.pageY : l + t.clientY;
        var d = r >= 0 && r <= s + u && i >= 0 && i <= l + c;
        return Et(e, {
          left: r,
          top: i,
          width: 0,
          height: 0
        }, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Pe(n, !0).forEach(function (t) {
              ke(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pe(n).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }({}, n, {
          points: [n.points[0], "cc"]
        }), d);
      }
      Tt.__getOffsetParent = ft, Tt.__getVisibleRectForElement = mt;
      function Ct(e) {
        return e && "object" == typeof e && e.window === e;
      }
      function kt(e, t) {
        var n = Math.floor(e),
          r = Math.floor(t);
        return Math.abs(n - r) <= 1;
      }
      function Pt(e, t) {
        e !== document.activeElement && ce(t, e) && e.focus();
      }
      function Ot(e) {
        return "function" == typeof e && e ? e() : null;
      }
      function Rt(e) {
        return "object" == typeof e && e ? e : null;
      }
      var It = function (e) {
        function t() {
          var e, n, r, i;
          a()(this, t);
          for (var o = arguments.length, s = Array(o), l = 0; l < o; l++) s[l] = arguments[l];
          return n = r = c()(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), r.forceAlign = function () {
            var e = r.props,
              t = e.disabled,
              n = e.target,
              i = e.align,
              o = e.onAlign;
            if (!t && n) {
              var a = k.a.findDOMNode(r),
                s = void 0,
                l = Ot(n),
                u = Rt(n),
                c = document.activeElement;
              l ? s = Tt(a, l, i) : u && (s = Mt(a, u, i)), Pt(c, a), o && o(a, s);
            }
          }, i = n, c()(r, i);
        }
        return h()(t, e), l()(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this.props;
            this.forceAlign(), !e.disabled && e.monitorWindowResize && this.startMonitorWindowResize();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            var t,
              n,
              r = !1,
              i = this.props;
            if (!i.disabled) {
              var o = k.a.findDOMNode(this),
                a = o ? o.getBoundingClientRect() : null;
              if (e.disabled) r = !0;else {
                var s = Ot(e.target),
                  l = Ot(i.target),
                  u = Rt(e.target),
                  c = Rt(i.target);
                Ct(s) && Ct(l) ? r = !1 : (s !== l || s && !l && c || u && c && l || c && !((t = u) === (n = c) || t && n && ("pageX" in n && "pageY" in n ? t.pageX === n.pageX && t.pageY === n.pageY : "clientX" in n && "clientY" in n && t.clientX === n.clientX && t.clientY === n.clientY))) && (r = !0);
                var d = this.sourceRect || {};
                r || !o || kt(d.width, a.width) && kt(d.height, a.height) || (r = !0);
              }
              this.sourceRect = a;
            }
            r && this.forceAlign(), i.monitorWindowResize && !i.disabled ? this.startMonitorWindowResize() : this.stopMonitorWindowResize();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.stopMonitorWindowResize();
          }
        }, {
          key: "startMonitorWindowResize",
          value: function value() {
            this.resizeHandler || (this.bufferMonitor = function (e, t) {
              var n = void 0;
              function r() {
                n && (clearTimeout(n), n = null);
              }
              function i() {
                r(), n = setTimeout(e, t);
              }
              return i.clear = r, i;
            }(this.forceAlign, this.props.monitorBufferTime), this.resizeHandler = P(window, "resize", this.bufferMonitor));
          }
        }, {
          key: "stopMonitorWindowResize",
          value: function value() {
            this.resizeHandler && (this.bufferMonitor.clear(), this.resizeHandler.remove(), this.resizeHandler = null);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = t.childrenProps,
              r = t.children,
              i = p.a.Children.only(r);
            if (n) {
              var o = {};
              return Object.keys(n).forEach(function (t) {
                o[t] = e.props[n[t]];
              }), p.a.cloneElement(i, o);
            }
            return i;
          }
        }]), t;
      }(f.Component);
      It.propTypes = {
        childrenProps: g.a.object,
        align: g.a.object.isRequired,
        target: g.a.oneOfType([g.a.func, g.a.shape({
          clientX: g.a.number,
          clientY: g.a.number,
          pageX: g.a.number,
          pageY: g.a.number
        })]),
        onAlign: g.a.func,
        monitorBufferTime: g.a.number,
        monitorWindowResize: g.a.bool,
        disabled: g.a.bool,
        children: g.a.any
      }, It.defaultProps = {
        target: function target() {
          return window;
        },
        monitorBufferTime: 50,
        monitorWindowResize: !1,
        disabled: !1
      };
      var jt = It;
      function Nt(e) {
        var t = [];
        return p.a.Children.forEach(e, function (e) {
          t.push(e);
        }), t;
      }
      function Lt(e, t) {
        var n = null;
        return e && e.forEach(function (e) {
          n || e && e.key === t && (n = e);
        }), n;
      }
      function Dt(e, t, n) {
        var r = null;
        return e && e.forEach(function (e) {
          if (e && e.key === t && e.props[n]) {
            if (r) throw new Error("two child with same key for <rc-animate> children");
            r = e;
          }
        }), r;
      }
      var Bt = n("./node_modules/babel-runtime/helpers/typeof.js"),
        Ft = n.n(Bt),
        zt = {
          transitionstart: {
            transition: "transitionstart",
            WebkitTransition: "webkitTransitionStart",
            MozTransition: "mozTransitionStart",
            OTransition: "oTransitionStart",
            msTransition: "MSTransitionStart"
          },
          animationstart: {
            animation: "animationstart",
            WebkitAnimation: "webkitAnimationStart",
            MozAnimation: "mozAnimationStart",
            OAnimation: "oAnimationStart",
            msAnimation: "MSAnimationStart"
          }
        },
        Ut = {
          transitionend: {
            transition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "mozTransitionEnd",
            OTransition: "oTransitionEnd",
            msTransition: "MSTransitionEnd"
          },
          animationend: {
            animation: "animationend",
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "mozAnimationEnd",
            OAnimation: "oAnimationEnd",
            msAnimation: "MSAnimationEnd"
          }
        },
        Gt = [],
        Vt = [];
      function Ht(e, t, n) {
        e.addEventListener(t, n, !1);
      }
      function qt(e, t, n) {
        e.removeEventListener(t, n, !1);
      }
      "undefined" != typeof window && "undefined" != typeof document && function () {
        var e = document.createElement("div").style;
        function t(t, n) {
          for (var r in t) if (t.hasOwnProperty(r)) {
            var i = t[r];
            for (var o in i) if (o in e) {
              n.push(i[o]);
              break;
            }
          }
        }
        "AnimationEvent" in window || (delete zt.animationstart.animation, delete Ut.animationend.animation), "TransitionEvent" in window || (delete zt.transitionstart.transition, delete Ut.transitionend.transition), t(zt, Gt), t(Ut, Vt);
      }();
      var Wt = {
          startEvents: Gt,
          addStartEventListener: function addStartEventListener(e, t) {
            0 !== Gt.length ? Gt.forEach(function (n) {
              Ht(e, n, t);
            }) : window.setTimeout(t, 0);
          },
          removeStartEventListener: function removeStartEventListener(e, t) {
            0 !== Gt.length && Gt.forEach(function (n) {
              qt(e, n, t);
            });
          },
          endEvents: Vt,
          addEndEventListener: function addEndEventListener(e, t) {
            0 !== Vt.length ? Vt.forEach(function (n) {
              Ht(e, n, t);
            }) : window.setTimeout(t, 0);
          },
          removeEndEventListener: function removeEndEventListener(e, t) {
            0 !== Vt.length && Vt.forEach(function (n) {
              qt(e, n, t);
            });
          }
        },
        $t = n("./node_modules/component-classes/index.js"),
        Xt = n.n($t),
        Yt = 0 !== Wt.endEvents.length,
        Kt = ["Webkit", "Moz", "O", "ms"],
        Zt = ["-webkit-", "-moz-", "-o-", "ms-", ""];
      function Qt(e, t) {
        for (var n = window.getComputedStyle(e, null), r = "", i = 0; i < Zt.length && !(r = n.getPropertyValue(Zt[i] + t)); i++);
        return r;
      }
      function Jt(e) {
        if (Yt) {
          var t = parseFloat(Qt(e, "transition-delay")) || 0,
            n = parseFloat(Qt(e, "transition-duration")) || 0,
            r = parseFloat(Qt(e, "animation-delay")) || 0,
            i = parseFloat(Qt(e, "animation-duration")) || 0,
            o = Math.max(n + t, i + r);
          e.rcEndAnimTimeout = setTimeout(function () {
            e.rcEndAnimTimeout = null, e.rcEndListener && e.rcEndListener();
          }, 1e3 * o + 200);
        }
      }
      function en(e) {
        e.rcEndAnimTimeout && (clearTimeout(e.rcEndAnimTimeout), e.rcEndAnimTimeout = null);
      }
      var tn = function tn(e, t, n) {
        var r = "object" === (void 0 === t ? "undefined" : Ft()(t)),
          i = r ? t.name : t,
          o = r ? t.active : t + "-active",
          a = n,
          s = void 0,
          l = void 0,
          u = Xt()(e);
        return n && "[object Object]" === Object.prototype.toString.call(n) && (a = n.end, s = n.start, l = n.active), e.rcEndListener && e.rcEndListener(), e.rcEndListener = function (t) {
          t && t.target !== e || (e.rcAnimTimeout && (clearTimeout(e.rcAnimTimeout), e.rcAnimTimeout = null), en(e), u.remove(i), u.remove(o), Wt.removeEndEventListener(e, e.rcEndListener), e.rcEndListener = null, a && a());
        }, Wt.addEndEventListener(e, e.rcEndListener), s && s(), u.add(i), e.rcAnimTimeout = setTimeout(function () {
          e.rcAnimTimeout = null, u.add(o), l && setTimeout(l, 0), Jt(e);
        }, 30), {
          stop: function stop() {
            e.rcEndListener && e.rcEndListener();
          }
        };
      };
      tn.style = function (e, t, n) {
        e.rcEndListener && e.rcEndListener(), e.rcEndListener = function (t) {
          t && t.target !== e || (e.rcAnimTimeout && (clearTimeout(e.rcAnimTimeout), e.rcAnimTimeout = null), en(e), Wt.removeEndEventListener(e, e.rcEndListener), e.rcEndListener = null, n && n());
        }, Wt.addEndEventListener(e, e.rcEndListener), e.rcAnimTimeout = setTimeout(function () {
          for (var n in t) t.hasOwnProperty(n) && (e.style[n] = t[n]);
          e.rcAnimTimeout = null, Jt(e);
        }, 0);
      }, tn.setTransition = function (e, t, n) {
        var r = t,
          i = n;
        void 0 === n && (i = r, r = ""), r = r || "", Kt.forEach(function (t) {
          e.style[t + "Transition" + r] = i;
        });
      }, tn.isCssAnimationSupported = Yt;
      var nn = tn,
        rn = {
          isAppearSupported: function isAppearSupported(e) {
            return e.transitionName && e.transitionAppear || e.animation.appear;
          },
          isEnterSupported: function isEnterSupported(e) {
            return e.transitionName && e.transitionEnter || e.animation.enter;
          },
          isLeaveSupported: function isLeaveSupported(e) {
            return e.transitionName && e.transitionLeave || e.animation.leave;
          },
          allowAppearCallback: function allowAppearCallback(e) {
            return e.transitionAppear || e.animation.appear;
          },
          allowEnterCallback: function allowEnterCallback(e) {
            return e.transitionEnter || e.animation.enter;
          },
          allowLeaveCallback: function allowLeaveCallback(e) {
            return e.transitionLeave || e.animation.leave;
          }
        },
        on = {
          enter: "transitionEnter",
          appear: "transitionAppear",
          leave: "transitionLeave"
        },
        an = function (e) {
          function t() {
            return a()(this, t), c()(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
          }
          return h()(t, e), l()(t, [{
            key: "componentWillUnmount",
            value: function value() {
              this.stop();
            }
          }, {
            key: "componentWillEnter",
            value: function value(e) {
              rn.isEnterSupported(this.props) ? this.transition("enter", e) : e();
            }
          }, {
            key: "componentWillAppear",
            value: function value(e) {
              rn.isAppearSupported(this.props) ? this.transition("appear", e) : e();
            }
          }, {
            key: "componentWillLeave",
            value: function value(e) {
              rn.isLeaveSupported(this.props) ? this.transition("leave", e) : e();
            }
          }, {
            key: "transition",
            value: function value(e, t) {
              var n = this,
                r = k.a.findDOMNode(this),
                i = this.props,
                o = i.transitionName,
                a = "object" == typeof o;
              this.stop();
              var s = function s() {
                n.stopper = null, t();
              };
              if ((Yt || !i.animation[e]) && o && i[on[e]]) {
                var l = a ? o[e] : o + "-" + e,
                  u = l + "-active";
                a && o[e + "Active"] && (u = o[e + "Active"]), this.stopper = nn(r, {
                  name: l,
                  active: u
                }, s);
              } else this.stopper = i.animation[e](r, s);
            }
          }, {
            key: "stop",
            value: function value() {
              var e = this.stopper;
              e && (this.stopper = null, e.stop());
            }
          }, {
            key: "render",
            value: function value() {
              return this.props.children;
            }
          }]), t;
        }(p.a.Component);
      an.propTypes = {
        children: g.a.any,
        animation: g.a.any,
        transitionName: g.a.any
      };
      var sn = an,
        ln = "rc_animate_" + Date.now();
      function un(e) {
        var t = e.children;
        return p.a.isValidElement(t) && !t.key ? p.a.cloneElement(t, {
          key: ln
        }) : t;
      }
      function cn() {}
      var dn = function (e) {
        function t(e) {
          a()(this, t);
          var n = c()(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return hn.call(n), n.currentlyAnimatingKeys = {}, n.keysToEnter = [], n.keysToLeave = [], n.state = {
            children: Nt(un(e))
          }, n.childrenRefs = {}, n;
        }
        return h()(t, e), l()(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this,
              t = this.props.showProp,
              n = this.state.children;
            t && (n = n.filter(function (e) {
              return !!e.props[t];
            })), n.forEach(function (t) {
              t && e.performAppear(t.key);
            });
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            var t = this;
            this.nextProps = e;
            var n = Nt(un(e)),
              r = this.props;
            r.exclusive && Object.keys(this.currentlyAnimatingKeys).forEach(function (e) {
              t.stop(e);
            });
            var i,
              o,
              a,
              s,
              l = r.showProp,
              u = this.currentlyAnimatingKeys,
              c = r.exclusive ? Nt(un(r)) : this.state.children,
              d = [];
            l ? (c.forEach(function (e) {
              var t = e && Lt(n, e.key),
                r = void 0;
              (r = t && t.props[l] || !e.props[l] ? t : p.a.cloneElement(t || e, _()({}, l, !0))) && d.push(r);
            }), n.forEach(function (e) {
              e && Lt(c, e.key) || d.push(e);
            })) : (i = n, o = [], a = {}, s = [], c.forEach(function (e) {
              e && Lt(i, e.key) ? s.length && (a[e.key] = s, s = []) : s.push(e);
            }), i.forEach(function (e) {
              e && Object.prototype.hasOwnProperty.call(a, e.key) && (o = o.concat(a[e.key])), o.push(e);
            }), d = o = o.concat(s)), this.setState({
              children: d
            }), n.forEach(function (e) {
              var n = e && e.key;
              if (!e || !u[n]) {
                var r = e && Lt(c, n);
                if (l) {
                  var i = e.props[l];
                  if (r) !Dt(c, n, l) && i && t.keysToEnter.push(n);else i && t.keysToEnter.push(n);
                } else r || t.keysToEnter.push(n);
              }
            }), c.forEach(function (e) {
              var r = e && e.key;
              if (!e || !u[r]) {
                var i = e && Lt(n, r);
                if (l) {
                  var o = e.props[l];
                  if (i) !Dt(n, r, l) && o && t.keysToLeave.push(r);else o && t.keysToLeave.push(r);
                } else i || t.keysToLeave.push(r);
              }
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            var e = this.keysToEnter;
            this.keysToEnter = [], e.forEach(this.performEnter);
            var t = this.keysToLeave;
            this.keysToLeave = [], t.forEach(this.performLeave);
          }
        }, {
          key: "isValidChildByKey",
          value: function value(e, t) {
            var n = this.props.showProp;
            return n ? Dt(e, t, n) : Lt(e, t);
          }
        }, {
          key: "stop",
          value: function value(e) {
            delete this.currentlyAnimatingKeys[e];
            var t = this.childrenRefs[e];
            t && t.stop();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props;
            this.nextProps = t;
            var n = this.state.children,
              r = null;
            n && (r = n.map(function (n) {
              if (null == n) return n;
              if (!n.key) throw new Error("must set key for <rc-animate> children");
              return p.a.createElement(sn, {
                key: n.key,
                ref: function ref(t) {
                  e.childrenRefs[n.key] = t;
                },
                animation: t.animation,
                transitionName: t.transitionName,
                transitionEnter: t.transitionEnter,
                transitionAppear: t.transitionAppear,
                transitionLeave: t.transitionLeave
              }, n);
            }));
            var o = t.component;
            if (o) {
              var a = t;
              return "string" == typeof o && (a = i()({
                className: t.className,
                style: t.style
              }, t.componentProps)), p.a.createElement(o, a, r);
            }
            return r[0] || null;
          }
        }]), t;
      }(p.a.Component);
      dn.isAnimate = !0, dn.propTypes = {
        className: g.a.string,
        style: g.a.object,
        component: g.a.any,
        componentProps: g.a.object,
        animation: g.a.object,
        transitionName: g.a.oneOfType([g.a.string, g.a.object]),
        transitionEnter: g.a.bool,
        transitionAppear: g.a.bool,
        exclusive: g.a.bool,
        transitionLeave: g.a.bool,
        onEnd: g.a.func,
        onEnter: g.a.func,
        onLeave: g.a.func,
        onAppear: g.a.func,
        showProp: g.a.string,
        children: g.a.node
      }, dn.defaultProps = {
        animation: {},
        component: "span",
        componentProps: {},
        transitionEnter: !0,
        transitionLeave: !0,
        transitionAppear: !1,
        onEnd: cn,
        onEnter: cn,
        onLeave: cn,
        onAppear: cn
      };
      var hn = function hn() {
          var e = this;
          this.performEnter = function (t) {
            e.childrenRefs[t] && (e.currentlyAnimatingKeys[t] = !0, e.childrenRefs[t].componentWillEnter(e.handleDoneAdding.bind(e, t, "enter")));
          }, this.performAppear = function (t) {
            e.childrenRefs[t] && (e.currentlyAnimatingKeys[t] = !0, e.childrenRefs[t].componentWillAppear(e.handleDoneAdding.bind(e, t, "appear")));
          }, this.handleDoneAdding = function (t, n) {
            var r = e.props;
            if (delete e.currentlyAnimatingKeys[t], !r.exclusive || r === e.nextProps) {
              var i = Nt(un(r));
              e.isValidChildByKey(i, t) ? "appear" === n ? rn.allowAppearCallback(r) && (r.onAppear(t), r.onEnd(t, !0)) : rn.allowEnterCallback(r) && (r.onEnter(t), r.onEnd(t, !0)) : e.performLeave(t);
            }
          }, this.performLeave = function (t) {
            e.childrenRefs[t] && (e.currentlyAnimatingKeys[t] = !0, e.childrenRefs[t].componentWillLeave(e.handleDoneLeaving.bind(e, t)));
          }, this.handleDoneLeaving = function (t) {
            var n = e.props;
            if (delete e.currentlyAnimatingKeys[t], !n.exclusive || n === e.nextProps) {
              var r,
                i,
                o,
                a,
                s = Nt(un(n));
              if (e.isValidChildByKey(s, t)) e.performEnter(t);else {
                var l = function l() {
                  rn.allowLeaveCallback(n) && (n.onLeave(t), n.onEnd(t, !1));
                };
                r = e.state.children, i = s, o = n.showProp, (a = r.length === i.length) && r.forEach(function (e, t) {
                  var n = i[t];
                  e && n && (e && !n || !e && n || e.key !== n.key || o && e.props[o] !== n.props[o]) && (a = !1);
                }), a ? l() : e.setState({
                  children: s
                }, l);
              }
            }
          };
        },
        fn = dn,
        pn = function (e) {
          function t() {
            return a()(this, t), c()(this, e.apply(this, arguments));
          }
          return h()(t, e), t.prototype.shouldComponentUpdate = function (e) {
            return e.hiddenClassName || e.visible;
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.hiddenClassName,
              n = e.visible,
              r = S()(e, ["hiddenClassName", "visible"]);
            return t || p.a.Children.count(r.children) > 1 ? (!n && t && (r.className += " " + t), p.a.createElement("div", r)) : p.a.Children.only(r.children);
          }, t;
        }(f.Component);
      pn.propTypes = {
        children: g.a.any,
        className: g.a.string,
        visible: g.a.bool,
        hiddenClassName: g.a.string
      };
      var mn = pn,
        gn = function (e) {
          function t() {
            return a()(this, t), c()(this, e.apply(this, arguments));
          }
          return h()(t, e), t.prototype.render = function () {
            var e = this.props,
              t = e.className;
            return e.visible || (t += " " + e.hiddenClassName), p.a.createElement("div", {
              className: t,
              onMouseEnter: e.onMouseEnter,
              onMouseLeave: e.onMouseLeave,
              onMouseDown: e.onMouseDown,
              onTouchStart: e.onTouchStart,
              style: e.style
            }, p.a.createElement(mn, {
              className: e.prefixCls + "-content",
              visible: e.visible
            }, e.children));
          }, t;
        }(f.Component);
      gn.propTypes = {
        hiddenClassName: g.a.string,
        className: g.a.string,
        prefixCls: g.a.string,
        onMouseEnter: g.a.func,
        onMouseLeave: g.a.func,
        onMouseDown: g.a.func,
        onTouchStart: g.a.func,
        children: g.a.any
      };
      var vn = gn,
        yn = function (e) {
          function t(n) {
            a()(this, t);
            var r = c()(this, e.call(this, n));
            return bn.call(r), r.state = {
              stretchChecked: !1,
              targetWidth: void 0,
              targetHeight: void 0
            }, r.savePopupRef = Me.bind(r, "popupInstance"), r.saveAlignRef = Me.bind(r, "alignInstance"), r;
          }
          return h()(t, e), t.prototype.componentDidMount = function () {
            this.rootNode = this.getPopupDomNode(), this.setStretchSize();
          }, t.prototype.componentDidUpdate = function () {
            this.setStretchSize();
          }, t.prototype.getPopupDomNode = function () {
            return k.a.findDOMNode(this.popupInstance);
          }, t.prototype.getMaskTransitionName = function () {
            var e = this.props,
              t = e.maskTransitionName,
              n = e.maskAnimation;
            return !t && n && (t = e.prefixCls + "-" + n), t;
          }, t.prototype.getTransitionName = function () {
            var e = this.props,
              t = e.transitionName;
            return !t && e.animation && (t = e.prefixCls + "-" + e.animation), t;
          }, t.prototype.getClassName = function (e) {
            return this.props.prefixCls + " " + this.props.className + " " + e;
          }, t.prototype.getPopupElement = function () {
            var e = this,
              t = this.savePopupRef,
              n = this.state,
              r = n.stretchChecked,
              o = n.targetHeight,
              a = n.targetWidth,
              s = this.props,
              l = s.align,
              u = s.visible,
              c = s.prefixCls,
              d = s.style,
              h = s.getClassNameFromAlign,
              f = s.destroyPopupOnHide,
              m = s.stretch,
              g = s.children,
              v = s.onMouseEnter,
              y = s.onMouseLeave,
              b = s.onMouseDown,
              _ = s.onTouchStart,
              x = this.getClassName(this.currentAlignClassName || h(l)),
              w = c + "-hidden";
            u || (this.currentAlignClassName = null);
            var S = {};
            m && (-1 !== m.indexOf("height") ? S.height = o : -1 !== m.indexOf("minHeight") && (S.minHeight = o), -1 !== m.indexOf("width") ? S.width = a : -1 !== m.indexOf("minWidth") && (S.minWidth = a), r || (S.visibility = "hidden", setTimeout(function () {
              e.alignInstance && e.alignInstance.forceAlign();
            }, 0)));
            var A = {
              className: x,
              prefixCls: c,
              ref: t,
              onMouseEnter: v,
              onMouseLeave: y,
              onMouseDown: b,
              onTouchStart: _,
              style: i()({}, S, d, this.getZIndexStyle())
            };
            return f ? p.a.createElement(fn, {
              component: "",
              exclusive: !0,
              transitionAppear: !0,
              transitionName: this.getTransitionName()
            }, u ? p.a.createElement(jt, {
              target: this.getAlignTarget(),
              key: "popup",
              ref: this.saveAlignRef,
              monitorWindowResize: !0,
              align: l,
              onAlign: this.onAlign
            }, p.a.createElement(vn, i()({
              visible: !0
            }, A), g)) : null) : p.a.createElement(fn, {
              component: "",
              exclusive: !0,
              transitionAppear: !0,
              transitionName: this.getTransitionName(),
              showProp: "xVisible"
            }, p.a.createElement(jt, {
              target: this.getAlignTarget(),
              key: "popup",
              ref: this.saveAlignRef,
              monitorWindowResize: !0,
              xVisible: u,
              childrenProps: {
                visible: "xVisible"
              },
              disabled: !u,
              align: l,
              onAlign: this.onAlign
            }, p.a.createElement(vn, i()({
              hiddenClassName: w
            }, A), g)));
          }, t.prototype.getZIndexStyle = function () {
            var e = {},
              t = this.props;
            return void 0 !== t.zIndex && (e.zIndex = t.zIndex), e;
          }, t.prototype.getMaskElement = function () {
            var e = this.props,
              t = void 0;
            if (e.mask) {
              var n = this.getMaskTransitionName();
              t = p.a.createElement(mn, {
                style: this.getZIndexStyle(),
                key: "mask",
                className: e.prefixCls + "-mask",
                hiddenClassName: e.prefixCls + "-mask-hidden",
                visible: e.visible
              }), n && (t = p.a.createElement(fn, {
                key: "mask",
                showProp: "visible",
                transitionAppear: !0,
                component: "",
                transitionName: n
              }, t));
            }
            return t;
          }, t.prototype.render = function () {
            return p.a.createElement("div", null, this.getMaskElement(), this.getPopupElement());
          }, t;
        }(f.Component);
      yn.propTypes = {
        visible: g.a.bool,
        style: g.a.object,
        getClassNameFromAlign: g.a.func,
        onAlign: g.a.func,
        getRootDomNode: g.a.func,
        align: g.a.any,
        destroyPopupOnHide: g.a.bool,
        className: g.a.string,
        prefixCls: g.a.string,
        onMouseEnter: g.a.func,
        onMouseLeave: g.a.func,
        onMouseDown: g.a.func,
        onTouchStart: g.a.func,
        stretch: g.a.string,
        children: g.a.node,
        point: g.a.shape({
          pageX: g.a.number,
          pageY: g.a.number
        })
      };
      var bn = function bn() {
          var e = this;
          this.onAlign = function (t, n) {
            var r = e.props,
              i = r.getClassNameFromAlign(n);
            e.currentAlignClassName !== i && (e.currentAlignClassName = i, t.className = e.getClassName(i)), r.onAlign(t, n);
          }, this.setStretchSize = function () {
            var t = e.props,
              n = t.stretch,
              r = t.getRootDomNode,
              i = t.visible,
              o = e.state,
              a = o.stretchChecked,
              s = o.targetHeight,
              l = o.targetWidth;
            if (n && i) {
              var u = r();
              if (u) {
                var c = u.offsetHeight,
                  d = u.offsetWidth;
                s === c && l === d && a || e.setState({
                  stretchChecked: !0,
                  targetHeight: c,
                  targetWidth: d
                });
              }
            } else a && e.setState({
              stretchChecked: !1
            });
          }, this.getTargetElement = function () {
            return e.props.getRootDomNode();
          }, this.getAlignTarget = function () {
            var t = e.props.point;
            return t || e.getTargetElement;
          };
        },
        _n = yn;
      function xn() {}
      var wn = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"],
        Sn = !!C.createPortal,
        An = {
          rcTrigger: g.a.shape({
            onPopupMouseDown: g.a.func
          })
        },
        En = function (e) {
          function t(n) {
            a()(this, t);
            var r = c()(this, e.call(this, n));
            Tn.call(r);
            var i = void 0;
            return i = "popupVisible" in n ? !!n.popupVisible : !!n.defaultPopupVisible, r.state = {
              prevPopupVisible: i,
              popupVisible: i
            }, wn.forEach(function (e) {
              r["fire" + e] = function (t) {
                r.fireEvents(e, t);
              };
            }), r;
          }
          return h()(t, e), t.prototype.getChildContext = function () {
            return {
              rcTrigger: {
                onPopupMouseDown: this.onPopupMouseDown
              }
            };
          }, t.prototype.componentDidMount = function () {
            this.componentDidUpdate({}, {
              popupVisible: this.state.popupVisible
            });
          }, t.prototype.componentDidUpdate = function (e, t) {
            var n = this.props,
              r = this.state;
            if (Sn || this.renderComponent(null, function () {
              t.popupVisible !== r.popupVisible && n.afterPopupVisibleChange(r.popupVisible);
            }), r.popupVisible) {
              var i = void 0;
              return this.clickOutsideHandler || !this.isClickToHide() && !this.isContextMenuToShow() || (i = n.getDocument(), this.clickOutsideHandler = P(i, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (i = i || n.getDocument(), this.touchOutsideHandler = P(i, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (i = i || n.getDocument(), this.contextMenuOutsideHandler1 = P(i, "scroll", this.onContextMenuClose)), void (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = P(window, "blur", this.onContextMenuClose)));
            }
            this.clearOutsideHandler();
          }, t.prototype.componentWillUnmount = function () {
            this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout);
          }, t.getDerivedStateFromProps = function (e, t) {
            var n = e.popupVisible,
              r = {};
            return void 0 !== n && t.popupVisible !== n && (r.popupVisible = n, r.prevPopupVisible = t.popupVisible), r;
          }, t.prototype.getPopupDomNode = function () {
            return this._component && this._component.getPopupDomNode ? this._component.getPopupDomNode() : null;
          }, t.prototype.getPopupAlign = function () {
            var e = this.props,
              t = e.popupPlacement,
              n = e.popupAlign,
              r = e.builtinPlacements;
            return t && r ? function (e, t, n) {
              var r = e[t] || {};
              return i()({}, r, n);
            }(r, t, n) : n;
          }, t.prototype.setPopupVisible = function (e, t) {
            var n = this.props.alignPoint,
              r = this.state.popupVisible;
            this.clearDelayTimer(), r !== e && ("popupVisible" in this.props || this.setState({
              popupVisible: e,
              prevPopupVisible: r
            }), this.props.onPopupVisibleChange(e)), n && t && this.setPoint(t);
          }, t.prototype.delaySetPopupVisible = function (e, t, n) {
            var r = this,
              i = 1e3 * t;
            if (this.clearDelayTimer(), i) {
              var o = n ? {
                pageX: n.pageX,
                pageY: n.pageY
              } : null;
              this.delayTimer = setTimeout(function () {
                r.setPopupVisible(e, o), r.clearDelayTimer();
              }, i);
            } else this.setPopupVisible(e, n);
          }, t.prototype.clearDelayTimer = function () {
            this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
          }, t.prototype.clearOutsideHandler = function () {
            this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
          }, t.prototype.createTwoChains = function (e) {
            var t = this.props.children.props,
              n = this.props;
            return t[e] && n[e] ? this["fire" + e] : t[e] || n[e];
          }, t.prototype.isClickToShow = function () {
            var e = this.props,
              t = e.action,
              n = e.showAction;
            return -1 !== t.indexOf("click") || -1 !== n.indexOf("click");
          }, t.prototype.isContextMenuToShow = function () {
            var e = this.props,
              t = e.action,
              n = e.showAction;
            return -1 !== t.indexOf("contextMenu") || -1 !== n.indexOf("contextMenu");
          }, t.prototype.isClickToHide = function () {
            var e = this.props,
              t = e.action,
              n = e.hideAction;
            return -1 !== t.indexOf("click") || -1 !== n.indexOf("click");
          }, t.prototype.isMouseEnterToShow = function () {
            var e = this.props,
              t = e.action,
              n = e.showAction;
            return -1 !== t.indexOf("hover") || -1 !== n.indexOf("mouseEnter");
          }, t.prototype.isMouseLeaveToHide = function () {
            var e = this.props,
              t = e.action,
              n = e.hideAction;
            return -1 !== t.indexOf("hover") || -1 !== n.indexOf("mouseLeave");
          }, t.prototype.isFocusToShow = function () {
            var e = this.props,
              t = e.action,
              n = e.showAction;
            return -1 !== t.indexOf("focus") || -1 !== n.indexOf("focus");
          }, t.prototype.isBlurToHide = function () {
            var e = this.props,
              t = e.action,
              n = e.hideAction;
            return -1 !== t.indexOf("focus") || -1 !== n.indexOf("blur");
          }, t.prototype.forcePopupAlign = function () {
            this.state.popupVisible && this._component && this._component.alignInstance && this._component.alignInstance.forceAlign();
          }, t.prototype.fireEvents = function (e, t) {
            var n = this.props.children.props[e];
            n && n(t);
            var r = this.props[e];
            r && r(t);
          }, t.prototype.close = function () {
            this.setPopupVisible(!1);
          }, t.prototype.render = function () {
            var e = this,
              t = this.state.popupVisible,
              n = this.props,
              r = n.children,
              i = n.forceRender,
              o = n.alignPoint,
              a = n.className,
              s = p.a.Children.only(r),
              l = {
                key: "trigger"
              };
            this.isContextMenuToShow() ? l.onContextMenu = this.onContextMenu : l.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (l.onClick = this.onClick, l.onMouseDown = this.onMouseDown, l.onTouchStart = this.onTouchStart) : (l.onClick = this.createTwoChains("onClick"), l.onMouseDown = this.createTwoChains("onMouseDown"), l.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (l.onMouseEnter = this.onMouseEnter, o && (l.onMouseMove = this.onMouseMove)) : l.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? l.onMouseLeave = this.onMouseLeave : l.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (l.onFocus = this.onFocus, l.onBlur = this.onBlur) : (l.onFocus = this.createTwoChains("onFocus"), l.onBlur = this.createTwoChains("onBlur"));
            var u = R()(s && s.props && s.props.className, a);
            u && (l.className = u);
            var c = p.a.cloneElement(s, l);
            if (!Sn) return p.a.createElement(ve, {
              parent: this,
              visible: t,
              autoMount: !1,
              forceRender: i,
              getComponent: this.getComponent,
              getContainer: this.getContainer
            }, function (t) {
              var n = t.renderComponent;
              return e.renderComponent = n, c;
            });
            var d = void 0;
            return (t || this._component || i) && (d = p.a.createElement(Ee, {
              key: "portal",
              getContainer: this.getContainer,
              didUpdate: this.handlePortalUpdate
            }, this.getComponent())), [c, d];
          }, t;
        }(p.a.Component);
      En.propTypes = {
        children: g.a.any,
        action: g.a.oneOfType([g.a.string, g.a.arrayOf(g.a.string)]),
        showAction: g.a.any,
        hideAction: g.a.any,
        getPopupClassNameFromAlign: g.a.any,
        onPopupVisibleChange: g.a.func,
        afterPopupVisibleChange: g.a.func,
        popup: g.a.oneOfType([g.a.node, g.a.func]).isRequired,
        popupStyle: g.a.object,
        prefixCls: g.a.string,
        popupClassName: g.a.string,
        className: g.a.string,
        popupPlacement: g.a.string,
        builtinPlacements: g.a.object,
        popupTransitionName: g.a.oneOfType([g.a.string, g.a.object]),
        popupAnimation: g.a.any,
        mouseEnterDelay: g.a.number,
        mouseLeaveDelay: g.a.number,
        zIndex: g.a.number,
        focusDelay: g.a.number,
        blurDelay: g.a.number,
        getPopupContainer: g.a.func,
        getDocument: g.a.func,
        forceRender: g.a.bool,
        destroyPopupOnHide: g.a.bool,
        mask: g.a.bool,
        maskClosable: g.a.bool,
        onPopupAlign: g.a.func,
        popupAlign: g.a.object,
        popupVisible: g.a.bool,
        defaultPopupVisible: g.a.bool,
        maskTransitionName: g.a.oneOfType([g.a.string, g.a.object]),
        maskAnimation: g.a.string,
        stretch: g.a.string,
        alignPoint: g.a.bool
      }, En.contextTypes = An, En.childContextTypes = An, En.defaultProps = {
        prefixCls: "rc-trigger-popup",
        getPopupClassNameFromAlign: function getPopupClassNameFromAlign() {
          return "";
        },
        getDocument: function getDocument() {
          return window.document;
        },
        onPopupVisibleChange: xn,
        afterPopupVisibleChange: xn,
        onPopupAlign: xn,
        popupClassName: "",
        mouseEnterDelay: 0,
        mouseLeaveDelay: .1,
        focusDelay: 0,
        blurDelay: .15,
        popupStyle: {},
        destroyPopupOnHide: !1,
        popupAlign: {},
        defaultPopupVisible: !1,
        mask: !1,
        maskClosable: !0,
        action: [],
        showAction: [],
        hideAction: []
      };
      var Tn = function Tn() {
        var e = this;
        this.onMouseEnter = function (t) {
          var n = e.props.mouseEnterDelay;
          e.fireEvents("onMouseEnter", t), e.delaySetPopupVisible(!0, n, n ? null : t);
        }, this.onMouseMove = function (t) {
          e.fireEvents("onMouseMove", t), e.setPoint(t);
        }, this.onMouseLeave = function (t) {
          e.fireEvents("onMouseLeave", t), e.delaySetPopupVisible(!1, e.props.mouseLeaveDelay);
        }, this.onPopupMouseEnter = function () {
          e.clearDelayTimer();
        }, this.onPopupMouseLeave = function (t) {
          t.relatedTarget && !t.relatedTarget.setTimeout && e._component && e._component.getPopupDomNode && ce(e._component.getPopupDomNode(), t.relatedTarget) || e.delaySetPopupVisible(!1, e.props.mouseLeaveDelay);
        }, this.onFocus = function (t) {
          e.fireEvents("onFocus", t), e.clearDelayTimer(), e.isFocusToShow() && (e.focusTime = Date.now(), e.delaySetPopupVisible(!0, e.props.focusDelay));
        }, this.onMouseDown = function (t) {
          e.fireEvents("onMouseDown", t), e.preClickTime = Date.now();
        }, this.onTouchStart = function (t) {
          e.fireEvents("onTouchStart", t), e.preTouchTime = Date.now();
        }, this.onBlur = function (t) {
          e.fireEvents("onBlur", t), e.clearDelayTimer(), e.isBlurToHide() && e.delaySetPopupVisible(!1, e.props.blurDelay);
        }, this.onContextMenu = function (t) {
          t.preventDefault(), e.fireEvents("onContextMenu", t), e.setPopupVisible(!0, t);
        }, this.onContextMenuClose = function () {
          e.isContextMenuToShow() && e.close();
        }, this.onClick = function (t) {
          if (e.fireEvents("onClick", t), e.focusTime) {
            var n = void 0;
            if (e.preClickTime && e.preTouchTime ? n = Math.min(e.preClickTime, e.preTouchTime) : e.preClickTime ? n = e.preClickTime : e.preTouchTime && (n = e.preTouchTime), Math.abs(n - e.focusTime) < 20) return;
            e.focusTime = 0;
          }
          e.preClickTime = 0, e.preTouchTime = 0, e.isClickToShow() && (e.isClickToHide() || e.isBlurToHide()) && t && t.preventDefault && t.preventDefault();
          var r = !e.state.popupVisible;
          (e.isClickToHide() && !r || r && e.isClickToShow()) && e.setPopupVisible(!e.state.popupVisible, t);
        }, this.onPopupMouseDown = function () {
          var t = e.context.rcTrigger,
            n = void 0 === t ? {} : t;
          e.hasPopupMouseDown = !0, clearTimeout(e.mouseDownTimeout), e.mouseDownTimeout = setTimeout(function () {
            e.hasPopupMouseDown = !1;
          }, 0), n.onPopupMouseDown && n.onPopupMouseDown.apply(n, arguments);
        }, this.onDocumentClick = function (t) {
          if (!e.props.mask || e.props.maskClosable) {
            var n = t.target;
            ce(Object(C.findDOMNode)(e), n) || e.hasPopupMouseDown || e.close();
          }
        }, this.getRootDomNode = function () {
          return Object(C.findDOMNode)(e);
        }, this.getPopupClassNameFromAlign = function (t) {
          var n = [],
            r = e.props,
            i = r.popupPlacement,
            o = r.builtinPlacements,
            a = r.prefixCls,
            s = r.alignPoint,
            l = r.getPopupClassNameFromAlign;
          return i && o && n.push(function (e, t, n, r) {
            var i = n.points;
            for (var o in e) if (e.hasOwnProperty(o) && Te(e[o].points, i, r)) return t + "-placement-" + o;
            return "";
          }(o, a, t, s)), l && n.push(l(t)), n.join(" ");
        }, this.getComponent = function () {
          var t = e.props,
            n = t.prefixCls,
            r = t.destroyPopupOnHide,
            o = t.popupClassName,
            a = t.action,
            s = t.onPopupAlign,
            l = t.popupAnimation,
            u = t.popupTransitionName,
            c = t.popupStyle,
            d = t.mask,
            h = t.maskAnimation,
            f = t.maskTransitionName,
            m = t.zIndex,
            g = t.popup,
            v = t.stretch,
            y = t.alignPoint,
            b = e.state,
            _ = b.popupVisible,
            x = b.point,
            w = e.getPopupAlign(),
            S = {};
          return e.isMouseEnterToShow() && (S.onMouseEnter = e.onPopupMouseEnter), e.isMouseLeaveToHide() && (S.onMouseLeave = e.onPopupMouseLeave), S.onMouseDown = e.onPopupMouseDown, S.onTouchStart = e.onPopupMouseDown, p.a.createElement(_n, i()({
            prefixCls: n,
            destroyPopupOnHide: r,
            visible: _,
            point: y && x,
            className: o,
            action: a,
            align: w,
            onAlign: s,
            animation: l,
            getClassNameFromAlign: e.getPopupClassNameFromAlign
          }, S, {
            stretch: v,
            getRootDomNode: e.getRootDomNode,
            style: c,
            mask: d,
            zIndex: m,
            transitionName: u,
            maskAnimation: h,
            maskTransitionName: f,
            ref: e.savePopup
          }), "function" == typeof g ? g() : g);
        }, this.getContainer = function () {
          var t = e.props,
            n = document.createElement("div");
          return n.style.position = "absolute", n.style.top = "0", n.style.left = "0", n.style.width = "100%", (t.getPopupContainer ? t.getPopupContainer(Object(C.findDOMNode)(e)) : t.getDocument().body).appendChild(n), n;
        }, this.setPoint = function (t) {
          e.props.alignPoint && t && e.setState({
            point: {
              pageX: t.pageX,
              pageY: t.pageY
            }
          });
        }, this.handlePortalUpdate = function () {
          e.state.prevPopupVisible !== e.state.popupVisible && e.props.afterPopupVisibleChange(e.state.popupVisible);
        }, this.savePopup = function (t) {
          e._component = t;
        };
      };
      Object(ie.a)(En);
      var Mn = En,
        Cn = {
          adjustX: 1,
          adjustY: 1
        },
        kn = [0, 0],
        Pn = {
          left: {
            points: ["cr", "cl"],
            overflow: Cn,
            offset: [-4, 0],
            targetOffset: kn
          },
          right: {
            points: ["cl", "cr"],
            overflow: Cn,
            offset: [4, 0],
            targetOffset: kn
          },
          top: {
            points: ["bc", "tc"],
            overflow: Cn,
            offset: [0, -4],
            targetOffset: kn
          },
          bottom: {
            points: ["tc", "bc"],
            overflow: Cn,
            offset: [0, 4],
            targetOffset: kn
          },
          topLeft: {
            points: ["bl", "tl"],
            overflow: Cn,
            offset: [0, -4],
            targetOffset: kn
          },
          leftTop: {
            points: ["tr", "tl"],
            overflow: Cn,
            offset: [-4, 0],
            targetOffset: kn
          },
          topRight: {
            points: ["br", "tr"],
            overflow: Cn,
            offset: [0, -4],
            targetOffset: kn
          },
          rightTop: {
            points: ["tl", "tr"],
            overflow: Cn,
            offset: [4, 0],
            targetOffset: kn
          },
          bottomRight: {
            points: ["tr", "br"],
            overflow: Cn,
            offset: [0, 4],
            targetOffset: kn
          },
          rightBottom: {
            points: ["bl", "br"],
            overflow: Cn,
            offset: [4, 0],
            targetOffset: kn
          },
          bottomLeft: {
            points: ["tl", "bl"],
            overflow: Cn,
            offset: [0, 4],
            targetOffset: kn
          },
          leftBottom: {
            points: ["br", "bl"],
            overflow: Cn,
            offset: [-4, 0],
            targetOffset: kn
          }
        },
        On = function (e) {
          function t() {
            return a()(this, t), c()(this, e.apply(this, arguments));
          }
          return h()(t, e), t.prototype.componentDidUpdate = function () {
            var e = this.props.trigger;
            e && e.forcePopupAlign();
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.overlay,
              n = e.prefixCls,
              r = e.id;
            return p.a.createElement("div", {
              className: n + "-inner",
              id: r,
              role: "tooltip"
            }, "function" == typeof t ? t() : t);
          }, t;
        }(p.a.Component);
      On.propTypes = {
        prefixCls: g.a.string,
        overlay: g.a.oneOfType([g.a.node, g.a.func]).isRequired,
        id: g.a.string,
        trigger: g.a.any
      };
      var Rn = On,
        In = function (e) {
          function t() {
            var n, r, i;
            a()(this, t);
            for (var o = arguments.length, s = Array(o), l = 0; l < o; l++) s[l] = arguments[l];
            return n = r = c()(this, e.call.apply(e, [this].concat(s))), r.getPopupElement = function () {
              var e = r.props,
                t = e.arrowContent,
                n = e.overlay,
                i = e.prefixCls,
                o = e.id;
              return [p.a.createElement("div", {
                className: i + "-arrow",
                key: "arrow"
              }, t), p.a.createElement(Rn, {
                key: "content",
                trigger: r.trigger,
                prefixCls: i,
                id: o,
                overlay: n
              })];
            }, r.saveTrigger = function (e) {
              r.trigger = e;
            }, i = n, c()(r, i);
          }
          return h()(t, e), t.prototype.getPopupDomNode = function () {
            return this.trigger.getPopupDomNode();
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.overlayClassName,
              n = e.trigger,
              r = e.mouseEnterDelay,
              o = e.mouseLeaveDelay,
              a = e.overlayStyle,
              s = e.prefixCls,
              l = e.children,
              u = e.onVisibleChange,
              c = e.afterVisibleChange,
              d = e.transitionName,
              h = e.animation,
              f = e.placement,
              m = e.align,
              g = e.destroyTooltipOnHide,
              v = e.defaultVisible,
              y = e.getTooltipContainer,
              b = S()(e, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer"]),
              _ = i()({}, b);
            return "visible" in this.props && (_.popupVisible = this.props.visible), p.a.createElement(Mn, i()({
              popupClassName: t,
              ref: this.saveTrigger,
              prefixCls: s,
              popup: this.getPopupElement,
              action: n,
              builtinPlacements: Pn,
              popupPlacement: f,
              popupAlign: m,
              getPopupContainer: y,
              onPopupVisibleChange: u,
              afterPopupVisibleChange: c,
              popupTransitionName: d,
              popupAnimation: h,
              defaultPopupVisible: v,
              destroyPopupOnHide: g,
              mouseLeaveDelay: o,
              popupStyle: a,
              mouseEnterDelay: r
            }, _), l);
          }, t;
        }(f.Component);
      In.propTypes = {
        trigger: g.a.any,
        children: g.a.any,
        defaultVisible: g.a.bool,
        visible: g.a.bool,
        placement: g.a.string,
        transitionName: g.a.oneOfType([g.a.string, g.a.object]),
        animation: g.a.any,
        onVisibleChange: g.a.func,
        afterVisibleChange: g.a.func,
        overlay: g.a.oneOfType([g.a.node, g.a.func]).isRequired,
        overlayStyle: g.a.object,
        overlayClassName: g.a.string,
        prefixCls: g.a.string,
        mouseEnterDelay: g.a.number,
        mouseLeaveDelay: g.a.number,
        getTooltipContainer: g.a.func,
        destroyTooltipOnHide: g.a.bool,
        align: g.a.object,
        arrowContent: g.a.any,
        id: g.a.string
      }, In.defaultProps = {
        prefixCls: "rc-tooltip",
        mouseEnterDelay: 0,
        destroyTooltipOnHide: !1,
        mouseLeaveDelay: .1,
        align: {},
        placement: "right",
        trigger: ["hover"],
        arrowContent: null
      };
      var jn = In;
      function Nn(e) {
        var t, n;
        return n = t = function (t) {
          function n() {
            var e, t, r, o;
            a()(this, n);
            for (var s = arguments.length, l = Array(s), u = 0; u < s; u++) l[u] = arguments[u];
            return t = r = c()(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(l))), r.state = {
              visibles: {}
            }, r.handleTooltipVisibleChange = function (e, t) {
              r.setState(function (n) {
                return {
                  visibles: i()({}, n.visibles, _()({}, e, t))
                };
              });
            }, r.handleWithTooltip = function (e) {
              var t = e.value,
                n = e.dragging,
                o = e.index,
                a = e.disabled,
                s = S()(e, ["value", "dragging", "index", "disabled"]),
                l = r.props,
                u = l.tipFormatter,
                c = l.tipProps,
                d = l.handleStyle,
                h = c.prefixCls,
                f = void 0 === h ? "rc-slider-tooltip" : h,
                m = c.overlay,
                g = void 0 === m ? u(t) : m,
                v = c.placement,
                y = void 0 === v ? "top" : v,
                b = c.visible,
                _ = void 0 !== b && b,
                x = S()(c, ["prefixCls", "overlay", "placement", "visible"]),
                w = void 0;
              return w = Array.isArray(d) ? d[o] || d[0] : d, p.a.createElement(jn, i()({}, x, {
                prefixCls: f,
                overlay: g,
                placement: y,
                visible: !a && (r.state.visibles[o] || n) || _,
                key: o
              }), p.a.createElement(B, i()({}, s, {
                style: i()({}, w),
                value: t,
                onMouseEnter: function onMouseEnter() {
                  return r.handleTooltipVisibleChange(o, !0);
                },
                onMouseLeave: function onMouseLeave() {
                  return r.handleTooltipVisibleChange(o, !1);
                }
              })));
            }, o = t, c()(r, o);
          }
          return h()(n, t), l()(n, [{
            key: "render",
            value: function value() {
              return p.a.createElement(e, i()({}, this.props, {
                handle: this.handleWithTooltip
              }));
            }
          }]), n;
        }(p.a.Component), t.propTypes = {
          tipFormatter: g.a.func,
          handleStyle: g.a.oneOfType([g.a.object, g.a.arrayOf(g.a.object)]),
          tipProps: g.a.object
        }, t.defaultProps = {
          tipFormatter: function tipFormatter(e) {
            return e;
          },
          handleStyle: [{}],
          tipProps: {}
        }, n;
      }
      re.Range = ue, re.Handle = B, re.createSliderWithTooltip = Nn;
      t.default = re;
    },
    "./node_modules/react-dom/cjs/react-dom-server.browser.production.min.js": function node_modulesReactDomCjsReactDomServerBrowserProductionMinJs(e, t, n) {
      "use strict";

      /** @license React v16.13.0
       * react-dom-server.browser.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var r = n("./node_modules/object-assign/index.js"),
        i = n("react");
      function o(e) {
        for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
        return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      }
      var a = "function" == typeof Symbol && Symbol.for,
        s = a ? Symbol.for("react.portal") : 60106,
        l = a ? Symbol.for("react.fragment") : 60107,
        u = a ? Symbol.for("react.strict_mode") : 60108,
        c = a ? Symbol.for("react.profiler") : 60114,
        d = a ? Symbol.for("react.provider") : 60109,
        h = a ? Symbol.for("react.context") : 60110,
        f = a ? Symbol.for("react.concurrent_mode") : 60111,
        p = a ? Symbol.for("react.forward_ref") : 60112,
        m = a ? Symbol.for("react.suspense") : 60113,
        g = a ? Symbol.for("react.suspense_list") : 60120,
        v = a ? Symbol.for("react.memo") : 60115,
        y = a ? Symbol.for("react.lazy") : 60116,
        b = a ? Symbol.for("react.block") : 60121,
        _ = a ? Symbol.for("react.fundamental") : 60117,
        x = a ? Symbol.for("react.scope") : 60119;
      function w(e) {
        if (null == e) return null;
        if ("function" == typeof e) return e.displayName || e.name || null;
        if ("string" == typeof e) return e;
        switch (e) {
          case l:
            return "Fragment";
          case s:
            return "Portal";
          case c:
            return "Profiler";
          case u:
            return "StrictMode";
          case m:
            return "Suspense";
          case g:
            return "SuspenseList";
        }
        if ("object" == typeof e) switch (e.$$typeof) {
          case h:
            return "Context.Consumer";
          case d:
            return "Context.Provider";
          case p:
            var t = e.render;
            return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
          case v:
            return w(e.type);
          case b:
            return w(e.render);
          case y:
            if (e = 1 === e._status ? e._result : null) return w(e);
        }
        return null;
      }
      var S = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      S.hasOwnProperty("ReactCurrentDispatcher") || (S.ReactCurrentDispatcher = {
        current: null
      }), S.hasOwnProperty("ReactCurrentBatchConfig") || (S.ReactCurrentBatchConfig = {
        suspense: null
      });
      var A = {};
      function E(e, t) {
        for (var n = 0 | e._threadCount; n <= t; n++) e[n] = e._currentValue2, e._threadCount = n + 1;
      }
      for (var T = new Uint16Array(16), M = 0; 15 > M; M++) T[M] = M + 1;
      T[15] = 0;
      var C = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
        k = Object.prototype.hasOwnProperty,
        P = {},
        O = {};
      function R(e) {
        return !!k.call(O, e) || !k.call(P, e) && (C.test(e) ? O[e] = !0 : (P[e] = !0, !1));
      }
      function I(e, t, n, r, i, o) {
        this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o;
      }
      var j = {};
      "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
        j[e] = new I(e, 0, !1, e, null, !1);
      }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
        var t = e[0];
        j[t] = new I(t, 1, !1, e[1], null, !1);
      }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
        j[e] = new I(e, 2, !1, e.toLowerCase(), null, !1);
      }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
        j[e] = new I(e, 2, !1, e, null, !1);
      }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
        j[e] = new I(e, 3, !1, e.toLowerCase(), null, !1);
      }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
        j[e] = new I(e, 3, !0, e, null, !1);
      }), ["capture", "download"].forEach(function (e) {
        j[e] = new I(e, 4, !1, e, null, !1);
      }), ["cols", "rows", "size", "span"].forEach(function (e) {
        j[e] = new I(e, 6, !1, e, null, !1);
      }), ["rowSpan", "start"].forEach(function (e) {
        j[e] = new I(e, 5, !1, e.toLowerCase(), null, !1);
      });
      var N = /[\-:]([a-z])/g;
      function L(e) {
        return e[1].toUpperCase();
      }
      "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
        var t = e.replace(N, L);
        j[t] = new I(t, 1, !1, e, null, !1);
      }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
        var t = e.replace(N, L);
        j[t] = new I(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
      }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
        var t = e.replace(N, L);
        j[t] = new I(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
      }), ["tabIndex", "crossOrigin"].forEach(function (e) {
        j[e] = new I(e, 1, !1, e.toLowerCase(), null, !1);
      }), j.xlinkHref = new I("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (e) {
        j[e] = new I(e, 1, !1, e.toLowerCase(), null, !0);
      });
      var D = /["'&<>]/;
      function B(e) {
        if ("boolean" == typeof e || "number" == typeof e) return "" + e;
        e = "" + e;
        var t = D.exec(e);
        if (t) {
          var n,
            r = "",
            i = 0;
          for (n = t.index; n < e.length; n++) {
            switch (e.charCodeAt(n)) {
              case 34:
                t = "&quot;";
                break;
              case 38:
                t = "&amp;";
                break;
              case 39:
                t = "&#x27;";
                break;
              case 60:
                t = "&lt;";
                break;
              case 62:
                t = "&gt;";
                break;
              default:
                continue;
            }
            i !== n && (r += e.substring(i, n)), i = n + 1, r += t;
          }
          e = i !== n ? r + e.substring(i, n) : r;
        }
        return e;
      }
      function F(e, t) {
        var n,
          r = j.hasOwnProperty(e) ? j[e] : null;
        return (n = "style" !== e) && (n = null !== r ? 0 === r.type : 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])), n || function (e, t, n, r) {
          if (null == t || function (e, t, n, r) {
            if (null !== n && 0 === n.type) return !1;
            switch (typeof t) {
              case "function":
              case "symbol":
                return !0;
              case "boolean":
                return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
              default:
                return !1;
            }
          }(e, t, n, r)) return !0;
          if (r) return !1;
          if (null !== n) switch (n.type) {
            case 3:
              return !t;
            case 4:
              return !1 === t;
            case 5:
              return isNaN(t);
            case 6:
              return isNaN(t) || 1 > t;
          }
          return !1;
        }(e, t, r, !1) ? "" : null !== r ? (e = r.attributeName, 3 === (n = r.type) || 4 === n && !0 === t ? e + '=""' : (r.sanitizeURL && (t = "" + t), e + '="' + B(t) + '"')) : R(e) ? e + '="' + B(t) + '"' : "";
      }
      var z = "function" == typeof Object.is ? Object.is : function (e, t) {
          return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
        },
        U = null,
        G = null,
        V = null,
        H = !1,
        q = !1,
        W = null,
        $ = 0;
      function X() {
        if (null === U) throw Error(o(321));
        return U;
      }
      function Y() {
        if (0 < $) throw Error(o(312));
        return {
          memoizedState: null,
          queue: null,
          next: null
        };
      }
      function K() {
        return null === V ? null === G ? (H = !1, G = V = Y()) : (H = !0, V = G) : null === V.next ? (H = !1, V = V.next = Y()) : (H = !0, V = V.next), V;
      }
      function Z(e, t, n, r) {
        for (; q;) q = !1, $ += 1, V = null, n = e(t, r);
        return G = U = null, $ = 0, V = W = null, n;
      }
      function Q(e, t) {
        return "function" == typeof t ? t(e) : t;
      }
      function J(e, t, n) {
        if (U = X(), V = K(), H) {
          var r = V.queue;
          if (t = r.dispatch, null !== W && void 0 !== (n = W.get(r))) {
            W.delete(r), r = V.memoizedState;
            do {
              r = e(r, n.action), n = n.next;
            } while (null !== n);
            return V.memoizedState = r, [r, t];
          }
          return [V.memoizedState, t];
        }
        return e = e === Q ? "function" == typeof t ? t() : t : void 0 !== n ? n(t) : t, V.memoizedState = e, e = (e = V.queue = {
          last: null,
          dispatch: null
        }).dispatch = ee.bind(null, U, e), [V.memoizedState, e];
      }
      function ee(e, t, n) {
        if (!(25 > $)) throw Error(o(301));
        if (e === U) if (q = !0, e = {
          action: n,
          next: null
        }, null === W && (W = new Map()), void 0 === (n = W.get(t))) W.set(t, e);else {
          for (t = n; null !== t.next;) t = t.next;
          t.next = e;
        }
      }
      function te() {}
      var ne = 0,
        re = {
          readContext: function readContext(e) {
            var t = ne;
            return E(e, t), e[t];
          },
          useContext: function useContext(e) {
            X();
            var t = ne;
            return E(e, t), e[t];
          },
          useMemo: function useMemo(e, t) {
            if (U = X(), t = void 0 === t ? null : t, null !== (V = K())) {
              var n = V.memoizedState;
              if (null !== n && null !== t) {
                e: {
                  var r = n[1];
                  if (null === r) r = !1;else {
                    for (var i = 0; i < r.length && i < t.length; i++) if (!z(t[i], r[i])) {
                      r = !1;
                      break e;
                    }
                    r = !0;
                  }
                }
                if (r) return n[0];
              }
            }
            return e = e(), V.memoizedState = [e, t], e;
          },
          useReducer: J,
          useRef: function useRef(e) {
            U = X();
            var t = (V = K()).memoizedState;
            return null === t ? (e = {
              current: e
            }, V.memoizedState = e) : t;
          },
          useState: function useState(e) {
            return J(Q, e);
          },
          useLayoutEffect: function useLayoutEffect() {},
          useCallback: function useCallback(e) {
            return e;
          },
          useImperativeHandle: te,
          useEffect: te,
          useDebugValue: te,
          useResponder: function useResponder(e, t) {
            return {
              props: t,
              responder: e
            };
          },
          useDeferredValue: function useDeferredValue(e) {
            return X(), e;
          },
          useTransition: function useTransition() {
            return X(), [function (e) {
              e();
            }, !1];
          }
        },
        ie = "http://www.w3.org/1999/xhtml";
      function oe(e) {
        switch (e) {
          case "svg":
            return "http://www.w3.org/2000/svg";
          case "math":
            return "http://www.w3.org/1998/Math/MathML";
          default:
            return "http://www.w3.org/1999/xhtml";
        }
      }
      var ae = {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0
        },
        se = r({
          menuitem: !0
        }, ae),
        le = {
          animationIterationCount: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridArea: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0
        },
        ue = ["Webkit", "ms", "Moz", "O"];
      Object.keys(le).forEach(function (e) {
        ue.forEach(function (t) {
          t = t + e.charAt(0).toUpperCase() + e.substring(1), le[t] = le[e];
        });
      });
      var ce = /([A-Z])/g,
        de = /^ms-/,
        he = i.Children.toArray,
        fe = S.ReactCurrentDispatcher,
        pe = {
          listing: !0,
          pre: !0,
          textarea: !0
        },
        me = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
        ge = {},
        ve = {};
      var ye = Object.prototype.hasOwnProperty,
        be = {
          children: null,
          dangerouslySetInnerHTML: null,
          suppressContentEditableWarning: null,
          suppressHydrationWarning: null
        };
      function _e(e, t) {
        if (void 0 === e) throw Error(o(152, w(t) || "Component"));
      }
      function xe(e, t, n) {
        function a(i, a) {
          var s = a.prototype && a.prototype.isReactComponent,
            l = function (e, t, n, r) {
              if (r && "object" == typeof (r = e.contextType) && null !== r) return E(r, n), r[n];
              if (e = e.contextTypes) {
                for (var i in n = {}, e) n[i] = t[i];
                t = n;
              } else t = A;
              return t;
            }(a, t, n, s),
            u = [],
            c = !1,
            d = {
              isMounted: function isMounted() {
                return !1;
              },
              enqueueForceUpdate: function enqueueForceUpdate() {
                if (null === u) return null;
              },
              enqueueReplaceState: function enqueueReplaceState(e, t) {
                c = !0, u = [t];
              },
              enqueueSetState: function enqueueSetState(e, t) {
                if (null === u) return null;
                u.push(t);
              }
            };
          if (s) {
            if (s = new a(i.props, l, d), "function" == typeof a.getDerivedStateFromProps) {
              var h = a.getDerivedStateFromProps.call(null, i.props, s.state);
              null != h && (s.state = r({}, s.state, h));
            }
          } else if (U = {}, s = a(i.props, l, d), null == (s = Z(a, i.props, s, l)) || null == s.render) return void _e(e = s, a);
          if (s.props = i.props, s.context = l, s.updater = d, void 0 === (d = s.state) && (s.state = d = null), "function" == typeof s.UNSAFE_componentWillMount || "function" == typeof s.componentWillMount) if ("function" == typeof s.componentWillMount && "function" != typeof a.getDerivedStateFromProps && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && "function" != typeof a.getDerivedStateFromProps && s.UNSAFE_componentWillMount(), u.length) {
            d = u;
            var f = c;
            if (u = null, c = !1, f && 1 === d.length) s.state = d[0];else {
              h = f ? d[0] : s.state;
              var p = !0;
              for (f = f ? 1 : 0; f < d.length; f++) {
                var m = d[f];
                null != (m = "function" == typeof m ? m.call(s, h, i.props, l) : m) && (p ? (p = !1, h = r({}, h, m)) : r(h, m));
              }
              s.state = h;
            }
          } else u = null;
          if (_e(e = s.render(), a), "function" == typeof s.getChildContext && "object" == typeof (i = a.childContextTypes)) {
            var g = s.getChildContext();
            for (var v in g) if (!(v in i)) throw Error(o(108, w(a) || "Unknown", v));
          }
          g && (t = r({}, t, g));
        }
        for (; i.isValidElement(e);) {
          var s = e,
            l = s.type;
          if ("function" != typeof l) break;
          a(s, l);
        }
        return {
          child: e,
          context: t
        };
      }
      var we = function () {
          function e(e, t) {
            i.isValidElement(e) ? e.type !== l ? e = [e] : (e = e.props.children, e = i.isValidElement(e) ? [e] : he(e)) : e = he(e), e = {
              type: null,
              domNamespace: ie,
              children: e,
              childIndex: 0,
              context: A,
              footer: ""
            };
            var n = T[0];
            if (0 === n) {
              var r = T,
                a = 2 * (n = r.length);
              if (!(65536 >= a)) throw Error(o(304));
              var s = new Uint16Array(a);
              for (s.set(r), (T = s)[0] = n + 1, r = n; r < a - 1; r++) T[r] = r + 1;
              T[a - 1] = 0;
            } else T[0] = T[n];
            this.threadID = n, this.stack = [e], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = t, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
          }
          var t = e.prototype;
          return t.destroy = function () {
            if (!this.exhausted) {
              this.exhausted = !0, this.clearProviders();
              var e = this.threadID;
              T[e] = T[0], T[0] = e;
            }
          }, t.pushProvider = function (e) {
            var t = ++this.contextIndex,
              n = e.type._context,
              r = this.threadID;
            E(n, r);
            var i = n[r];
            this.contextStack[t] = n, this.contextValueStack[t] = i, n[r] = e.props.value;
          }, t.popProvider = function () {
            var e = this.contextIndex,
              t = this.contextStack[e],
              n = this.contextValueStack[e];
            this.contextStack[e] = null, this.contextValueStack[e] = null, this.contextIndex--, t[this.threadID] = n;
          }, t.clearProviders = function () {
            for (var e = this.contextIndex; 0 <= e; e--) this.contextStack[e][this.threadID] = this.contextValueStack[e];
          }, t.read = function (e) {
            if (this.exhausted) return null;
            var t = ne;
            ne = this.threadID;
            var n = fe.current;
            fe.current = re;
            try {
              for (var r = [""], i = !1; r[0].length < e;) {
                if (0 === this.stack.length) {
                  this.exhausted = !0;
                  var a = this.threadID;
                  T[a] = T[0], T[0] = a;
                  break;
                }
                var s = this.stack[this.stack.length - 1];
                if (i || s.childIndex >= s.children.length) {
                  var l = s.footer;
                  if ("" !== l && (this.previousWasTextNode = !1), this.stack.pop(), "select" === s.type) this.currentSelectValue = null;else if (null != s.type && null != s.type.type && s.type.type.$$typeof === d) this.popProvider(s.type);else if (s.type === m) {
                    this.suspenseDepth--;
                    var u = r.pop();
                    if (i) {
                      i = !1;
                      var c = s.fallbackFrame;
                      if (!c) throw Error(o(303));
                      this.stack.push(c), r[this.suspenseDepth] += "\x3c!--$!--\x3e";
                      continue;
                    }
                    r[this.suspenseDepth] += u;
                  }
                  r[this.suspenseDepth] += l;
                } else {
                  var h = s.children[s.childIndex++],
                    f = "";
                  try {
                    f += this.render(h, s.context, s.domNamespace);
                  } catch (e) {
                    if (null != e && "function" == typeof e.then) throw Error(o(294));
                    throw e;
                  }
                  r.length <= this.suspenseDepth && r.push(""), r[this.suspenseDepth] += f;
                }
              }
              return r[0];
            } finally {
              fe.current = n, ne = t;
            }
          }, t.render = function (e, t, n) {
            if ("string" == typeof e || "number" == typeof e) return "" === (n = "" + e) ? "" : this.makeStaticMarkup ? B(n) : this.previousWasTextNode ? "\x3c!-- --\x3e" + B(n) : (this.previousWasTextNode = !0, B(n));
            if (e = (t = xe(e, t, this.threadID)).child, t = t.context, null === e || !1 === e) return "";
            if (!i.isValidElement(e)) {
              if (null != e && null != e.$$typeof) {
                if ((n = e.$$typeof) === s) throw Error(o(257));
                throw Error(o(258, n.toString()));
              }
              return e = he(e), this.stack.push({
                type: null,
                domNamespace: n,
                children: e,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            }
            var a = e.type;
            if ("string" == typeof a) return this.renderDOM(e, t, n);
            switch (a) {
              case u:
              case f:
              case c:
              case g:
              case l:
                return e = he(e.props.children), this.stack.push({
                  type: null,
                  domNamespace: n,
                  children: e,
                  childIndex: 0,
                  context: t,
                  footer: ""
                }), "";
              case m:
                throw Error(o(294));
            }
            if ("object" == typeof a && null !== a) switch (a.$$typeof) {
              case p:
                U = {};
                var b = a.render(e.props, e.ref);
                return b = Z(a.render, e.props, b, e.ref), b = he(b), this.stack.push({
                  type: null,
                  domNamespace: n,
                  children: b,
                  childIndex: 0,
                  context: t,
                  footer: ""
                }), "";
              case v:
                return e = [i.createElement(a.type, r({
                  ref: e.ref
                }, e.props))], this.stack.push({
                  type: null,
                  domNamespace: n,
                  children: e,
                  childIndex: 0,
                  context: t,
                  footer: ""
                }), "";
              case d:
                return n = {
                  type: e,
                  domNamespace: n,
                  children: a = he(e.props.children),
                  childIndex: 0,
                  context: t,
                  footer: ""
                }, this.pushProvider(e), this.stack.push(n), "";
              case h:
                a = e.type, b = e.props;
                var w = this.threadID;
                return E(a, w), a = he(b.children(a[w])), this.stack.push({
                  type: e,
                  domNamespace: n,
                  children: a,
                  childIndex: 0,
                  context: t,
                  footer: ""
                }), "";
              case _:
                throw Error(o(338));
              case y:
                switch (function (e) {
                  if (-1 === e._status) {
                    e._status = 0;
                    var t = e._ctor;
                    t = t(), e._result = t, t.then(function (t) {
                      0 === e._status && (t = t.default, e._status = 1, e._result = t);
                    }, function (t) {
                      0 === e._status && (e._status = 2, e._result = t);
                    });
                  }
                }(a = e.type), a._status) {
                  case 1:
                    return e = [i.createElement(a._result, r({
                      ref: e.ref
                    }, e.props))], this.stack.push({
                      type: null,
                      domNamespace: n,
                      children: e,
                      childIndex: 0,
                      context: t,
                      footer: ""
                    }), "";
                  case 2:
                    throw a._result;
                  default:
                    throw Error(o(295));
                }
              case x:
                throw Error(o(343));
            }
            throw Error(o(130, null == a ? a : typeof a, ""));
          }, t.renderDOM = function (e, t, n) {
            var a = e.type.toLowerCase();
            if (n === ie && oe(a), !ge.hasOwnProperty(a)) {
              if (!me.test(a)) throw Error(o(65, a));
              ge[a] = !0;
            }
            var s = e.props;
            if ("input" === a) s = r({
              type: void 0
            }, s, {
              defaultChecked: void 0,
              defaultValue: void 0,
              value: null != s.value ? s.value : s.defaultValue,
              checked: null != s.checked ? s.checked : s.defaultChecked
            });else if ("textarea" === a) {
              var l = s.value;
              if (null == l) {
                l = s.defaultValue;
                var u = s.children;
                if (null != u) {
                  if (null != l) throw Error(o(92));
                  if (Array.isArray(u)) {
                    if (!(1 >= u.length)) throw Error(o(93));
                    u = u[0];
                  }
                  l = "" + u;
                }
                null == l && (l = "");
              }
              s = r({}, s, {
                value: void 0,
                children: "" + l
              });
            } else if ("select" === a) this.currentSelectValue = null != s.value ? s.value : s.defaultValue, s = r({}, s, {
              value: void 0
            });else if ("option" === a) {
              u = this.currentSelectValue;
              var c = function (e) {
                if (null == e) return e;
                var t = "";
                return i.Children.forEach(e, function (e) {
                  null != e && (t += e);
                }), t;
              }(s.children);
              if (null != u) {
                var d = null != s.value ? s.value + "" : c;
                if (l = !1, Array.isArray(u)) {
                  for (var h = 0; h < u.length; h++) if ("" + u[h] === d) {
                    l = !0;
                    break;
                  }
                } else l = "" + u === d;
                s = r({
                  selected: void 0,
                  children: void 0
                }, s, {
                  selected: l,
                  children: c
                });
              }
            }
            if (l = s) {
              if (se[a] && (null != l.children || null != l.dangerouslySetInnerHTML)) throw Error(o(137, a, ""));
              if (null != l.dangerouslySetInnerHTML) {
                if (null != l.children) throw Error(o(60));
                if ("object" != typeof l.dangerouslySetInnerHTML || !("__html" in l.dangerouslySetInnerHTML)) throw Error(o(61));
              }
              if (null != l.style && "object" != typeof l.style) throw Error(o(62, ""));
            }
            for (_ in l = s, u = this.makeStaticMarkup, c = 1 === this.stack.length, d = "<" + e.type, l) if (ye.call(l, _)) {
              var f = l[_];
              if (null != f) {
                if ("style" === _) {
                  h = void 0;
                  var p = "",
                    m = "";
                  for (h in f) if (f.hasOwnProperty(h)) {
                    var g = 0 === h.indexOf("--"),
                      v = f[h];
                    if (null != v) {
                      if (g) var y = h;else if (y = h, ve.hasOwnProperty(y)) y = ve[y];else {
                        var b = y.replace(ce, "-$1").toLowerCase().replace(de, "-ms-");
                        y = ve[y] = b;
                      }
                      p += m + y + ":", m = h, p += g = null == v || "boolean" == typeof v || "" === v ? "" : g || "number" != typeof v || 0 === v || le.hasOwnProperty(m) && le[m] ? ("" + v).trim() : v + "px", m = ";";
                    }
                  }
                  f = p || null;
                }
                h = null;
                e: if (g = a, v = l, -1 === g.indexOf("-")) g = "string" == typeof v.is;else switch (g) {
                  case "annotation-xml":
                  case "color-profile":
                  case "font-face":
                  case "font-face-src":
                  case "font-face-uri":
                  case "font-face-format":
                  case "font-face-name":
                  case "missing-glyph":
                    g = !1;
                    break e;
                  default:
                    g = !0;
                }
                g ? be.hasOwnProperty(_) || (h = R(h = _) && null != f ? h + '="' + B(f) + '"' : "") : h = F(_, f), h && (d += " " + h);
              }
            }
            u || c && (d += ' data-reactroot=""');
            var _ = d;
            l = "", ae.hasOwnProperty(a) ? _ += "/>" : (_ += ">", l = "</" + e.type + ">");
            e: {
              if (null != (u = s.dangerouslySetInnerHTML)) {
                if (null != u.__html) {
                  u = u.__html;
                  break e;
                }
              } else if ("string" == typeof (u = s.children) || "number" == typeof u) {
                u = B(u);
                break e;
              }
              u = null;
            }
            return null != u ? (s = [], pe.hasOwnProperty(a) && "\n" === u.charAt(0) && (_ += "\n"), _ += u) : s = he(s.children), e = e.type, n = null == n || "http://www.w3.org/1999/xhtml" === n ? oe(e) : "http://www.w3.org/2000/svg" === n && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : n, this.stack.push({
              domNamespace: n,
              type: a,
              children: s,
              childIndex: 0,
              context: t,
              footer: l
            }), this.previousWasTextNode = !1, _;
          }, e;
        }(),
        Se = {
          renderToString: function renderToString(e) {
            e = new we(e, !1);
            try {
              return e.read(1 / 0);
            } finally {
              e.destroy();
            }
          },
          renderToStaticMarkup: function renderToStaticMarkup(e) {
            e = new we(e, !0);
            try {
              return e.read(1 / 0);
            } finally {
              e.destroy();
            }
          },
          renderToNodeStream: function renderToNodeStream() {
            throw Error(o(207));
          },
          renderToStaticNodeStream: function renderToStaticNodeStream() {
            throw Error(o(208));
          },
          version: "16.13.0"
        };
      e.exports = Se.default || Se;
    },
    "./node_modules/react-dom/server.browser.js": function node_modulesReactDomServerBrowserJs(e, t, n) {
      "use strict";

      e.exports = n("./node_modules/react-dom/cjs/react-dom-server.browser.production.min.js");
    },
    "./node_modules/react-iframe-comm/dist/IframeComm.js": function node_modulesReactIframeCommDistIframeCommJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        },
        i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        },
        o = function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        }(),
        a = n("react"),
        s = u(a),
        l = u(n("./node_modules/prop-types/index.js"));
      function u(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      var c = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var e = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
          return e.onReceiveMessage = e.onReceiveMessage.bind(e), e.onLoad = e.onLoad.bind(e), e.sendMessage = e.sendMessage.bind(e), e;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, e), o(t, [{
          key: "componentDidMount",
          value: function value() {
            window.addEventListener("message", this.onReceiveMessage), this._frame.addEventListener("load", this.onLoad);
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            window.removeEventListener("message", this.onReceiveMessage, !1);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.props.postMessageData !== e.postMessageData && this.sendMessage(e.postMessageData);
          }
        }, {
          key: "onReceiveMessage",
          value: function value(e) {
            var t = this.props.handleReceiveMessage;
            t && t(e);
          }
        }, {
          key: "onLoad",
          value: function value() {
            var e = this.props.handleReady;
            e && e(), this.sendMessage(this.props.postMessageData);
          }
        }, {
          key: "serializePostMessageData",
          value: function value(e) {
            return this.props.serializeMessage ? "object" === (void 0 === e ? "undefined" : i(e)) ? JSON.stringify(e) : "string" == typeof e ? e : "" + e : e;
          }
        }, {
          key: "sendMessage",
          value: function value(e) {
            var t = this.props.targetOrigin,
              n = this.serializePostMessageData(e);
            this._frame.contentWindow.postMessage(n, t);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props.attributes,
              n = Object.assign({}, {
                allowFullScreen: !1,
                frameBorder: 0
              }, t);
            return s.default.createElement("iframe", r({
              ref: function ref(t) {
                e._frame = t;
              }
            }, n));
          }
        }]), t;
      }(a.Component);
      c.defaultProps = {
        serializeMessage: !0,
        targetOrigin: "*",
        postMessageData: ""
      }, c.propTypes = {
        attributes: l.default.shape({
          allowFullScreen: l.default.oneOfType([l.default.string, l.default.bool]),
          frameBorder: l.default.oneOfType([l.default.string, l.default.number]),
          height: l.default.oneOfType([l.default.string, l.default.number]),
          name: l.default.string,
          scrolling: l.default.string,
          sandbox: l.default.string,
          srcDoc: l.default.string,
          src: l.default.string.isRequired,
          width: l.default.oneOfType([l.default.string, l.default.number])
        }),
        handleReceiveMessage: l.default.func,
        handleReady: l.default.func,
        postMessageData: l.default.any.isRequired,
        serializeMessage: l.default.bool,
        targetOrigin: l.default.string
      }, t.default = c;
    },
    "./node_modules/react-is/cjs/react-is.production.min.js": function node_modulesReactIsCjsReactIsProductionMinJs(e, t, n) {
      "use strict";

      /** @license React v16.13.0
       * react-is.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */
      var r = "function" == typeof Symbol && Symbol.for,
        i = r ? Symbol.for("react.element") : 60103,
        o = r ? Symbol.for("react.portal") : 60106,
        a = r ? Symbol.for("react.fragment") : 60107,
        s = r ? Symbol.for("react.strict_mode") : 60108,
        l = r ? Symbol.for("react.profiler") : 60114,
        u = r ? Symbol.for("react.provider") : 60109,
        c = r ? Symbol.for("react.context") : 60110,
        d = r ? Symbol.for("react.async_mode") : 60111,
        h = r ? Symbol.for("react.concurrent_mode") : 60111,
        f = r ? Symbol.for("react.forward_ref") : 60112,
        p = r ? Symbol.for("react.suspense") : 60113,
        m = r ? Symbol.for("react.suspense_list") : 60120,
        g = r ? Symbol.for("react.memo") : 60115,
        v = r ? Symbol.for("react.lazy") : 60116,
        y = r ? Symbol.for("react.block") : 60121,
        b = r ? Symbol.for("react.fundamental") : 60117,
        _ = r ? Symbol.for("react.responder") : 60118,
        x = r ? Symbol.for("react.scope") : 60119;
      function w(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;
          switch (t) {
            case i:
              switch (e = e.type) {
                case d:
                case h:
                case a:
                case l:
                case s:
                case p:
                  return e;
                default:
                  switch (e = e && e.$$typeof) {
                    case c:
                    case f:
                    case v:
                    case g:
                    case u:
                      return e;
                    default:
                      return t;
                  }
              }
            case o:
              return t;
          }
        }
      }
      function S(e) {
        return w(e) === h;
      }
      t.AsyncMode = d, t.ConcurrentMode = h, t.ContextConsumer = c, t.ContextProvider = u, t.Element = i, t.ForwardRef = f, t.Fragment = a, t.Lazy = v, t.Memo = g, t.Portal = o, t.Profiler = l, t.StrictMode = s, t.Suspense = p, t.isAsyncMode = function (e) {
        return S(e) || w(e) === d;
      }, t.isConcurrentMode = S, t.isContextConsumer = function (e) {
        return w(e) === c;
      }, t.isContextProvider = function (e) {
        return w(e) === u;
      }, t.isElement = function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === i;
      }, t.isForwardRef = function (e) {
        return w(e) === f;
      }, t.isFragment = function (e) {
        return w(e) === a;
      }, t.isLazy = function (e) {
        return w(e) === v;
      }, t.isMemo = function (e) {
        return w(e) === g;
      }, t.isPortal = function (e) {
        return w(e) === o;
      }, t.isProfiler = function (e) {
        return w(e) === l;
      }, t.isStrictMode = function (e) {
        return w(e) === s;
      }, t.isSuspense = function (e) {
        return w(e) === p;
      }, t.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === a || e === h || e === l || e === s || e === p || e === m || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === g || e.$$typeof === u || e.$$typeof === c || e.$$typeof === f || e.$$typeof === b || e.$$typeof === _ || e.$$typeof === x || e.$$typeof === y);
      }, t.typeOf = w;
    },
    "./node_modules/react-is/index.js": function node_modulesReactIsIndexJs(e, t, n) {
      "use strict";

      e.exports = n("./node_modules/react-is/cjs/react-is.production.min.js");
    },
    "./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js": function node_modulesReactLifecyclesCompatReactLifecyclesCompatEsJs(e, t, n) {
      "use strict";

      function r() {
        var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
        null != e && this.setState(e);
      }
      function i(e) {
        this.setState(function (t) {
          var n = this.constructor.getDerivedStateFromProps(e, t);
          return null != n ? n : null;
        }.bind(this));
      }
      function o(e, t) {
        try {
          var n = this.props,
            r = this.state;
          this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, r);
        } finally {
          this.props = n, this.state = r;
        }
      }
      function a(e) {
        var t = e.prototype;
        if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
        if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
        var n = null,
          a = null,
          s = null;
        if ("function" == typeof t.componentWillMount ? n = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? a = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (a = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? s = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (s = "UNSAFE_componentWillUpdate"), null !== n || null !== a || null !== s) {
          var l = e.displayName || e.name,
            u = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
          throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + l + " uses " + u + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== a ? "\n  " + a : "") + (null !== s ? "\n  " + s : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
        }
        if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = r, t.componentWillReceiveProps = i), "function" == typeof t.getSnapshotBeforeUpdate) {
          if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
          t.componentWillUpdate = o;
          var c = t.componentDidUpdate;
          t.componentDidUpdate = function (e, t, n) {
            var r = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n;
            c.call(this, e, t, r);
          };
        }
        return e;
      }
      n.d(t, "a", function () {
        return a;
      }), r.__suppressDeprecationWarning = !0, i.__suppressDeprecationWarning = !0, o.__suppressDeprecationWarning = !0;
    },
    "./node_modules/react-redux/es/index.js": function node_modulesReactReduxEsIndexJs(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "Provider", function () {
        return c;
      }), n.d(t, "connectAdvanced", function () {
        return A;
      }), n.d(t, "ReactReduxContext", function () {
        return o;
      }), n.d(t, "connect", function () {
        return U;
      }), n.d(t, "batch", function () {
        return Z.unstable_batchedUpdates;
      }), n.d(t, "useDispatch", function () {
        return W;
      }), n.d(t, "createDispatchHook", function () {
        return q;
      }), n.d(t, "useSelector", function () {
        return K;
      }), n.d(t, "createSelectorHook", function () {
        return X;
      }), n.d(t, "useStore", function () {
        return H;
      }), n.d(t, "createStoreHook", function () {
        return V;
      }), n.d(t, "shallowEqual", function () {
        return T;
      });
      var r = n("react"),
        i = n.n(r),
        o = (n("./node_modules/prop-types/index.js"), i.a.createContext(null));
      var a = function a(e) {
          e();
        },
        s = {
          notify: function notify() {}
        };
      function l() {
        var e = a,
          t = null,
          n = null;
        return {
          clear: function clear() {
            t = null, n = null;
          },
          notify: function notify() {
            e(function () {
              for (var e = t; e;) e.callback(), e = e.next;
            });
          },
          get: function get() {
            for (var e = [], n = t; n;) e.push(n), n = n.next;
            return e;
          },
          subscribe: function subscribe(e) {
            var r = !0,
              i = n = {
                callback: e,
                next: null,
                prev: n
              };
            return i.prev ? i.prev.next = i : t = i, function () {
              r && null !== t && (r = !1, i.next ? i.next.prev = i.prev : n = i.prev, i.prev ? i.prev.next = i.next : t = i.next);
            };
          }
        };
      }
      var u = function () {
        function e(e, t) {
          this.store = e, this.parentSub = t, this.unsubscribe = null, this.listeners = s, this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
        }
        var t = e.prototype;
        return t.addNestedSub = function (e) {
          return this.trySubscribe(), this.listeners.subscribe(e);
        }, t.notifyNestedSubs = function () {
          this.listeners.notify();
        }, t.handleChangeWrapper = function () {
          this.onStateChange && this.onStateChange();
        }, t.isSubscribed = function () {
          return Boolean(this.unsubscribe);
        }, t.trySubscribe = function () {
          this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper), this.listeners = l());
        }, t.tryUnsubscribe = function () {
          this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = s);
        }, e;
      }();
      var c = function c(e) {
          var t = e.store,
            n = e.context,
            a = e.children,
            s = Object(r.useMemo)(function () {
              var e = new u(t);
              return e.onStateChange = e.notifyNestedSubs, {
                store: t,
                subscription: e
              };
            }, [t]),
            l = Object(r.useMemo)(function () {
              return t.getState();
            }, [t]);
          Object(r.useEffect)(function () {
            var e = s.subscription;
            return e.trySubscribe(), l !== t.getState() && e.notifyNestedSubs(), function () {
              e.tryUnsubscribe(), e.onStateChange = null;
            };
          }, [s, l]);
          var c = n || o;
          return i.a.createElement(c.Provider, {
            value: s
          }, a);
        },
        d = n("./node_modules/@babel/runtime/helpers/esm/extends.js"),
        h = n("./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js"),
        f = n("./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"),
        p = n.n(f),
        m = n("./node_modules/react-is/index.js"),
        g = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? r.useLayoutEffect : r.useEffect,
        v = [],
        y = [null, null];
      function b(e, t) {
        var n = e[1];
        return [t.payload, n + 1];
      }
      function _(e, t, n) {
        g(function () {
          return e.apply(void 0, t);
        }, n);
      }
      function x(e, t, n, r, i, o, a) {
        e.current = r, t.current = i, n.current = !1, o.current && (o.current = null, a());
      }
      function w(e, t, n, r, i, o, a, s, l, u) {
        if (e) {
          var c = !1,
            d = null,
            h = function h() {
              if (!c) {
                var e,
                  n,
                  h = t.getState();
                try {
                  e = r(h, i.current);
                } catch (e) {
                  n = e, d = e;
                }
                n || (d = null), e === o.current ? a.current || l() : (o.current = e, s.current = e, a.current = !0, u({
                  type: "STORE_UPDATED",
                  payload: {
                    error: n
                  }
                }));
              }
            };
          n.onStateChange = h, n.trySubscribe(), h();
          return function () {
            if (c = !0, n.tryUnsubscribe(), n.onStateChange = null, d) throw d;
          };
        }
      }
      var S = function S() {
        return [null, 0];
      };
      function A(e, t) {
        void 0 === t && (t = {});
        var n = t,
          a = n.getDisplayName,
          s = void 0 === a ? function (e) {
            return "ConnectAdvanced(" + e + ")";
          } : a,
          l = n.methodName,
          c = void 0 === l ? "connectAdvanced" : l,
          f = n.renderCountProp,
          g = void 0 === f ? void 0 : f,
          A = n.shouldHandleStateChanges,
          E = void 0 === A || A,
          T = n.storeKey,
          M = void 0 === T ? "store" : T,
          C = (n.withRef, n.forwardRef),
          k = void 0 !== C && C,
          P = n.context,
          O = void 0 === P ? o : P,
          R = Object(h.a)(n, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]),
          I = O;
        return function (t) {
          var n = t.displayName || t.name || "Component",
            o = s(n),
            a = Object(d.a)({}, R, {
              getDisplayName: s,
              methodName: c,
              renderCountProp: g,
              shouldHandleStateChanges: E,
              storeKey: M,
              displayName: o,
              wrappedComponentName: n,
              WrappedComponent: t
            }),
            l = R.pure;
          var f = l ? r.useMemo : function (e) {
            return e();
          };
          function A(n) {
            var o = Object(r.useMemo)(function () {
                var e = n.forwardedRef,
                  t = Object(h.a)(n, ["forwardedRef"]);
                return [n.context, e, t];
              }, [n]),
              s = o[0],
              l = o[1],
              c = o[2],
              p = Object(r.useMemo)(function () {
                return s && s.Consumer && Object(m.isContextConsumer)(i.a.createElement(s.Consumer, null)) ? s : I;
              }, [s, I]),
              g = Object(r.useContext)(p),
              A = Boolean(n.store) && Boolean(n.store.getState) && Boolean(n.store.dispatch);
            Boolean(g) && Boolean(g.store);
            var T = A ? n.store : g.store,
              M = Object(r.useMemo)(function () {
                return function (t) {
                  return e(t.dispatch, a);
                }(T);
              }, [T]),
              C = Object(r.useMemo)(function () {
                if (!E) return y;
                var e = new u(T, A ? null : g.subscription),
                  t = e.notifyNestedSubs.bind(e);
                return [e, t];
              }, [T, A, g]),
              k = C[0],
              P = C[1],
              O = Object(r.useMemo)(function () {
                return A ? g : Object(d.a)({}, g, {
                  subscription: k
                });
              }, [A, g, k]),
              R = Object(r.useReducer)(b, v, S),
              j = R[0][0],
              N = R[1];
            if (j && j.error) throw j.error;
            var L = Object(r.useRef)(),
              D = Object(r.useRef)(c),
              B = Object(r.useRef)(),
              F = Object(r.useRef)(!1),
              z = f(function () {
                return B.current && c === D.current ? B.current : M(T.getState(), c);
              }, [T, j, c]);
            _(x, [D, L, F, c, z, B, P]), _(w, [E, T, k, M, D, L, F, B, P, N], [T, k, M]);
            var U = Object(r.useMemo)(function () {
              return i.a.createElement(t, Object(d.a)({}, z, {
                ref: l
              }));
            }, [l, t, z]);
            return Object(r.useMemo)(function () {
              return E ? i.a.createElement(p.Provider, {
                value: O
              }, U) : U;
            }, [p, U, O]);
          }
          var T = l ? i.a.memo(A) : A;
          if (T.WrappedComponent = t, T.displayName = o, k) {
            var C = i.a.forwardRef(function (e, t) {
              return i.a.createElement(T, Object(d.a)({}, e, {
                forwardedRef: t
              }));
            });
            return C.displayName = o, C.WrappedComponent = t, p()(C, t);
          }
          return p()(T, t);
        };
      }
      function E(e, t) {
        return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
      }
      function T(e, t) {
        if (E(e, t)) return !0;
        if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
        var n = Object.keys(e),
          r = Object.keys(t);
        if (n.length !== r.length) return !1;
        for (var i = 0; i < n.length; i++) if (!Object.prototype.hasOwnProperty.call(t, n[i]) || !E(e[n[i]], t[n[i]])) return !1;
        return !0;
      }
      var M = n("./node_modules/redux/es/redux.js");
      function C(e) {
        return function (t, n) {
          var r = e(t, n);
          function i() {
            return r;
          }
          return i.dependsOnOwnProps = !1, i;
        };
      }
      function k(e) {
        return null !== e.dependsOnOwnProps && void 0 !== e.dependsOnOwnProps ? Boolean(e.dependsOnOwnProps) : 1 !== e.length;
      }
      function P(e, t) {
        return function (t, n) {
          n.displayName;
          var r = function r(e, t) {
            return r.dependsOnOwnProps ? r.mapToProps(e, t) : r.mapToProps(e);
          };
          return r.dependsOnOwnProps = !0, r.mapToProps = function (t, n) {
            r.mapToProps = e, r.dependsOnOwnProps = k(e);
            var i = r(t, n);
            return "function" == typeof i && (r.mapToProps = i, r.dependsOnOwnProps = k(i), i = r(t, n)), i;
          }, r;
        };
      }
      var O = [function (e) {
        return "function" == typeof e ? P(e) : void 0;
      }, function (e) {
        return e ? void 0 : C(function (e) {
          return {
            dispatch: e
          };
        });
      }, function (e) {
        return e && "object" == typeof e ? C(function (t) {
          return Object(M.bindActionCreators)(e, t);
        }) : void 0;
      }];
      var R = [function (e) {
        return "function" == typeof e ? P(e) : void 0;
      }, function (e) {
        return e ? void 0 : C(function () {
          return {};
        });
      }];
      function I(e, t, n) {
        return Object(d.a)({}, n, {}, e, {}, t);
      }
      var j = [function (e) {
        return "function" == typeof e ? function (e) {
          return function (t, n) {
            n.displayName;
            var r,
              i = n.pure,
              o = n.areMergedPropsEqual,
              a = !1;
            return function (t, n, s) {
              var l = e(t, n, s);
              return a ? i && o(l, r) || (r = l) : (a = !0, r = l), r;
            };
          };
        }(e) : void 0;
      }, function (e) {
        return e ? void 0 : function () {
          return I;
        };
      }];
      function N(e, t, n, r) {
        return function (i, o) {
          return n(e(i, o), t(r, o), o);
        };
      }
      function L(e, t, n, r, i) {
        var o,
          a,
          s,
          l,
          u,
          c = i.areStatesEqual,
          d = i.areOwnPropsEqual,
          h = i.areStatePropsEqual,
          f = !1;
        function p(i, f) {
          var p,
            m,
            g = !d(f, a),
            v = !c(i, o);
          return o = i, a = f, g && v ? (s = e(o, a), t.dependsOnOwnProps && (l = t(r, a)), u = n(s, l, a)) : g ? (e.dependsOnOwnProps && (s = e(o, a)), t.dependsOnOwnProps && (l = t(r, a)), u = n(s, l, a)) : v ? (p = e(o, a), m = !h(p, s), s = p, m && (u = n(s, l, a)), u) : u;
        }
        return function (i, c) {
          return f ? p(i, c) : (s = e(o = i, a = c), l = t(r, a), u = n(s, l, a), f = !0, u);
        };
      }
      function D(e, t) {
        var n = t.initMapStateToProps,
          r = t.initMapDispatchToProps,
          i = t.initMergeProps,
          o = Object(h.a)(t, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]),
          a = n(e, o),
          s = r(e, o),
          l = i(e, o);
        return (o.pure ? L : N)(a, s, l, e, o);
      }
      function B(e, t, n) {
        for (var r = t.length - 1; r >= 0; r--) {
          var i = t[r](e);
          if (i) return i;
        }
        return function (t, r) {
          throw new Error("Invalid value of type " + typeof e + " for " + n + " argument when connecting component " + r.wrappedComponentName + ".");
        };
      }
      function F(e, t) {
        return e === t;
      }
      function z(e) {
        var t = void 0 === e ? {} : e,
          n = t.connectHOC,
          r = void 0 === n ? A : n,
          i = t.mapStateToPropsFactories,
          o = void 0 === i ? R : i,
          a = t.mapDispatchToPropsFactories,
          s = void 0 === a ? O : a,
          l = t.mergePropsFactories,
          u = void 0 === l ? j : l,
          c = t.selectorFactory,
          f = void 0 === c ? D : c;
        return function (e, t, n, i) {
          void 0 === i && (i = {});
          var a = i,
            l = a.pure,
            c = void 0 === l || l,
            p = a.areStatesEqual,
            m = void 0 === p ? F : p,
            g = a.areOwnPropsEqual,
            v = void 0 === g ? T : g,
            y = a.areStatePropsEqual,
            b = void 0 === y ? T : y,
            _ = a.areMergedPropsEqual,
            x = void 0 === _ ? T : _,
            w = Object(h.a)(a, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]),
            S = B(e, o, "mapStateToProps"),
            A = B(t, s, "mapDispatchToProps"),
            E = B(n, u, "mergeProps");
          return r(f, Object(d.a)({
            methodName: "connect",
            getDisplayName: function getDisplayName(e) {
              return "Connect(" + e + ")";
            },
            shouldHandleStateChanges: Boolean(e),
            initMapStateToProps: S,
            initMapDispatchToProps: A,
            initMergeProps: E,
            pure: c,
            areStatesEqual: m,
            areOwnPropsEqual: v,
            areStatePropsEqual: b,
            areMergedPropsEqual: x
          }, w));
        };
      }
      var U = z();
      function G() {
        return Object(r.useContext)(o);
      }
      function V(e) {
        void 0 === e && (e = o);
        var t = e === o ? G : function () {
          return Object(r.useContext)(e);
        };
        return function () {
          return t().store;
        };
      }
      var H = V();
      function q(e) {
        void 0 === e && (e = o);
        var t = e === o ? H : V(e);
        return function () {
          return t().dispatch;
        };
      }
      var W = q(),
        $ = function $(e, t) {
          return e === t;
        };
      function X(e) {
        void 0 === e && (e = o);
        var t = e === o ? G : function () {
          return Object(r.useContext)(e);
        };
        return function (e, n) {
          void 0 === n && (n = $);
          var i = t();
          return function (e, t, n, i) {
            var o,
              a = Object(r.useReducer)(function (e) {
                return e + 1;
              }, 0)[1],
              s = Object(r.useMemo)(function () {
                return new u(n, i);
              }, [n, i]),
              l = Object(r.useRef)(),
              c = Object(r.useRef)(),
              d = Object(r.useRef)();
            try {
              o = e !== c.current || l.current ? e(n.getState()) : d.current;
            } catch (e) {
              throw l.current && (e.message += "\nThe error may be correlated with this previous error:\n" + l.current.stack + "\n\n"), e;
            }
            return g(function () {
              c.current = e, d.current = o, l.current = void 0;
            }), g(function () {
              function e() {
                try {
                  var e = c.current(n.getState());
                  if (t(e, d.current)) return;
                  d.current = e;
                } catch (e) {
                  l.current = e;
                }
                a({});
              }
              return s.onStateChange = e, s.trySubscribe(), e(), function () {
                return s.tryUnsubscribe();
              };
            }, [n, s]), o;
          }(e, n, i.store, i.subscription);
        };
      }
      var Y,
        K = X(),
        Z = n("react-dom");
      Y = Z.unstable_batchedUpdates, a = Y;
    },
    "./node_modules/readable-stream/duplex-browser.js": function node_modulesReadableStreamDuplexBrowserJs(e, t, n) {
      e.exports = n("./node_modules/readable-stream/lib/_stream_duplex.js");
    },
    "./node_modules/readable-stream/lib/_stream_duplex.js": function node_modulesReadableStreamLib_stream_duplexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/process-nextick-args/index.js"),
        i = Object.keys || function (e) {
          var t = [];
          for (var n in e) t.push(n);
          return t;
        };
      e.exports = d;
      var o = Object.create(n("./node_modules/core-util-is/lib/util.js"));
      o.inherits = n("./node_modules/inherits/inherits_browser.js");
      var a = n("./node_modules/readable-stream/lib/_stream_readable.js"),
        s = n("./node_modules/readable-stream/lib/_stream_writable.js");
      o.inherits(d, a);
      for (var l = i(s.prototype), u = 0; u < l.length; u++) {
        var c = l[u];
        d.prototype[c] || (d.prototype[c] = s.prototype[c]);
      }
      function d(e) {
        if (!(this instanceof d)) return new d(e);
        a.call(this, e), s.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", h);
      }
      function h() {
        this.allowHalfOpen || this._writableState.ended || r.nextTick(f, this);
      }
      function f(e) {
        e.end();
      }
      Object.defineProperty(d.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), Object.defineProperty(d.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(e) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
        }
      }), d.prototype._destroy = function (e, t) {
        this.push(null), this.end(), r.nextTick(t, e);
      };
    },
    "./node_modules/readable-stream/lib/_stream_passthrough.js": function node_modulesReadableStreamLib_stream_passthroughJs(e, t, n) {
      "use strict";

      e.exports = o;
      var r = n("./node_modules/readable-stream/lib/_stream_transform.js"),
        i = Object.create(n("./node_modules/core-util-is/lib/util.js"));
      function o(e) {
        if (!(this instanceof o)) return new o(e);
        r.call(this, e);
      }
      i.inherits = n("./node_modules/inherits/inherits_browser.js"), i.inherits(o, r), o.prototype._transform = function (e, t, n) {
        n(null, e);
      };
    },
    "./node_modules/readable-stream/lib/_stream_readable.js": function node_modulesReadableStreamLib_stream_readableJs(e, t, n) {
      "use strict";

      (function (t, r) {
        var i = n("./node_modules/process-nextick-args/index.js");
        e.exports = b;
        var o,
          a = n("./node_modules/isarray/index.js");
        b.ReadableState = y;
        n("./node_modules/events/events.js").EventEmitter;
        var s = function s(e, t) {
            return e.listeners(t).length;
          },
          l = n("./node_modules/readable-stream/lib/internal/streams/stream-browser.js"),
          u = n("./node_modules/safe-buffer/index.js").Buffer,
          c = t.Uint8Array || function () {};
        var d = Object.create(n("./node_modules/core-util-is/lib/util.js"));
        d.inherits = n("./node_modules/inherits/inherits_browser.js");
        var h = n(0),
          f = void 0;
        f = h && h.debuglog ? h.debuglog("stream") : function () {};
        var p,
          m = n("./node_modules/readable-stream/lib/internal/streams/BufferList.js"),
          g = n("./node_modules/readable-stream/lib/internal/streams/destroy.js");
        d.inherits(b, l);
        var v = ["error", "close", "destroy", "pause", "resume"];
        function y(e, t) {
          e = e || {};
          var r = t instanceof (o = o || n("./node_modules/readable-stream/lib/_stream_duplex.js"));
          this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.readableObjectMode);
          var i = e.highWaterMark,
            a = e.readableHighWaterMark,
            s = this.objectMode ? 16 : 16384;
          this.highWaterMark = i || 0 === i ? i : r && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (p || (p = n("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder), this.decoder = new p(e.encoding), this.encoding = e.encoding);
        }
        function b(e) {
          if (o = o || n("./node_modules/readable-stream/lib/_stream_duplex.js"), !(this instanceof b)) return new b(e);
          this._readableState = new y(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), l.call(this);
        }
        function _(e, t, n, r, i) {
          var o,
            a = e._readableState;
          null === t ? (a.reading = !1, function (e, t) {
            if (t.ended) return;
            if (t.decoder) {
              var n = t.decoder.end();
              n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
            }
            t.ended = !0, S(e);
          }(e, a)) : (i || (o = function (e, t) {
            var n;
            r = t, u.isBuffer(r) || r instanceof c || "string" == typeof t || void 0 === t || e.objectMode || (n = new TypeError("Invalid non-string/buffer chunk"));
            var r;
            return n;
          }(a, t)), o ? e.emit("error", o) : a.objectMode || t && t.length > 0 ? ("string" == typeof t || a.objectMode || Object.getPrototypeOf(t) === u.prototype || (t = function (e) {
            return u.from(e);
          }(t)), r ? a.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : x(e, a, t, !0) : a.ended ? e.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !n ? (t = a.decoder.write(t), a.objectMode || 0 !== t.length ? x(e, a, t, !1) : E(e, a)) : x(e, a, t, !1))) : r || (a.reading = !1));
          return function (e) {
            return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
          }(a);
        }
        function x(e, t, n, r) {
          t.flowing && 0 === t.length && !t.sync ? (e.emit("data", n), e.read(0)) : (t.length += t.objectMode ? 1 : n.length, r ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && S(e)), E(e, t);
        }
        Object.defineProperty(b.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(e) {
            this._readableState && (this._readableState.destroyed = e);
          }
        }), b.prototype.destroy = g.destroy, b.prototype._undestroy = g.undestroy, b.prototype._destroy = function (e, t) {
          this.push(null), t(e);
        }, b.prototype.push = function (e, t) {
          var n,
            r = this._readableState;
          return r.objectMode ? n = !0 : "string" == typeof e && ((t = t || r.defaultEncoding) !== r.encoding && (e = u.from(e, t), t = ""), n = !0), _(this, e, t, !1, n);
        }, b.prototype.unshift = function (e) {
          return _(this, e, null, !0, !1);
        }, b.prototype.isPaused = function () {
          return !1 === this._readableState.flowing;
        }, b.prototype.setEncoding = function (e) {
          return p || (p = n("./node_modules/string_decoder/lib/string_decoder.js").StringDecoder), this._readableState.decoder = new p(e), this._readableState.encoding = e, this;
        };
        function w(e, t) {
          return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function (e) {
            return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
          }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
        }
        function S(e) {
          var t = e._readableState;
          t.needReadable = !1, t.emittedReadable || (f("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(A, e) : A(e));
        }
        function A(e) {
          f("emit readable"), e.emit("readable"), k(e);
        }
        function E(e, t) {
          t.readingMore || (t.readingMore = !0, i.nextTick(T, e, t));
        }
        function T(e, t) {
          for (var n = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (f("maybeReadMore read 0"), e.read(0), n !== t.length);) n = t.length;
          t.readingMore = !1;
        }
        function M(e) {
          f("readable nexttick read 0"), e.read(0);
        }
        function C(e, t) {
          t.reading || (f("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), k(e), t.flowing && !t.reading && e.read(0);
        }
        function k(e) {
          var t = e._readableState;
          for (f("flow", t.flowing); t.flowing && null !== e.read(););
        }
        function P(e, t) {
          return 0 === t.length ? null : (t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : n = function (e, t, n) {
            var r;
            e < t.head.data.length ? (r = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : r = e === t.head.data.length ? t.shift() : n ? function (e, t) {
              var n = t.head,
                r = 1,
                i = n.data;
              e -= i.length;
              for (; n = n.next;) {
                var o = n.data,
                  a = e > o.length ? o.length : e;
                if (a === o.length ? i += o : i += o.slice(0, e), 0 === (e -= a)) {
                  a === o.length ? (++r, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = o.slice(a));
                  break;
                }
                ++r;
              }
              return t.length -= r, i;
            }(e, t) : function (e, t) {
              var n = u.allocUnsafe(e),
                r = t.head,
                i = 1;
              r.data.copy(n), e -= r.data.length;
              for (; r = r.next;) {
                var o = r.data,
                  a = e > o.length ? o.length : e;
                if (o.copy(n, n.length - e, 0, a), 0 === (e -= a)) {
                  a === o.length ? (++i, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = o.slice(a));
                  break;
                }
                ++i;
              }
              return t.length -= i, n;
            }(e, t);
            return r;
          }(e, t.buffer, t.decoder), n);
          var n;
        }
        function O(e) {
          var t = e._readableState;
          if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
          t.endEmitted || (t.ended = !0, i.nextTick(R, t, e));
        }
        function R(e, t) {
          e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
        }
        function I(e, t) {
          for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
          return -1;
        }
        b.prototype.read = function (e) {
          f("read", e), e = parseInt(e, 10);
          var t = this._readableState,
            n = e;
          if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return f("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : S(this), null;
          if (0 === (e = w(e, t)) && t.ended) return 0 === t.length && O(this), null;
          var r,
            i = t.needReadable;
          return f("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && f("length less than watermark", i = !0), t.ended || t.reading ? f("reading or ended", i = !1) : i && (f("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = w(n, t))), null === (r = e > 0 ? P(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), n !== e && t.ended && O(this)), null !== r && this.emit("data", r), r;
        }, b.prototype._read = function (e) {
          this.emit("error", new Error("_read() is not implemented"));
        }, b.prototype.pipe = function (e, t) {
          var n = this,
            o = this._readableState;
          switch (o.pipesCount) {
            case 0:
              o.pipes = e;
              break;
            case 1:
              o.pipes = [o.pipes, e];
              break;
            default:
              o.pipes.push(e);
          }
          o.pipesCount += 1, f("pipe count=%d opts=%j", o.pipesCount, t);
          var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? c : b;
          function u(t, r) {
            f("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, f("cleanup"), e.removeListener("close", v), e.removeListener("finish", y), e.removeListener("drain", d), e.removeListener("error", g), e.removeListener("unpipe", u), n.removeListener("end", c), n.removeListener("end", b), n.removeListener("data", m), h = !0, !o.awaitDrain || e._writableState && !e._writableState.needDrain || d());
          }
          function c() {
            f("onend"), e.end();
          }
          o.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", u);
          var d = function (e) {
            return function () {
              var t = e._readableState;
              f("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, k(e));
            };
          }(n);
          e.on("drain", d);
          var h = !1;
          var p = !1;
          function m(t) {
            f("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === o.pipesCount && o.pipes === e || o.pipesCount > 1 && -1 !== I(o.pipes, e)) && !h && (f("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, p = !0), n.pause());
          }
          function g(t) {
            f("onerror", t), b(), e.removeListener("error", g), 0 === s(e, "error") && e.emit("error", t);
          }
          function v() {
            e.removeListener("finish", y), b();
          }
          function y() {
            f("onfinish"), e.removeListener("close", v), b();
          }
          function b() {
            f("unpipe"), n.unpipe(e);
          }
          return n.on("data", m), function (e, t, n) {
            if ("function" == typeof e.prependListener) return e.prependListener(t, n);
            e._events && e._events[t] ? a(e._events[t]) ? e._events[t].unshift(n) : e._events[t] = [n, e._events[t]] : e.on(t, n);
          }(e, "error", g), e.once("close", v), e.once("finish", y), e.emit("pipe", n), o.flowing || (f("pipe resume"), n.resume()), e;
        }, b.prototype.unpipe = function (e) {
          var t = this._readableState,
            n = {
              hasUnpiped: !1
            };
          if (0 === t.pipesCount) return this;
          if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, n)), this;
          if (!e) {
            var r = t.pipes,
              i = t.pipesCount;
            t.pipes = null, t.pipesCount = 0, t.flowing = !1;
            for (var o = 0; o < i; o++) r[o].emit("unpipe", this, n);
            return this;
          }
          var a = I(t.pipes, e);
          return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, n)), this;
        }, b.prototype.on = function (e, t) {
          var n = l.prototype.on.call(this, e, t);
          if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
            var r = this._readableState;
            r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && S(this) : i.nextTick(M, this));
          }
          return n;
        }, b.prototype.addListener = b.prototype.on, b.prototype.resume = function () {
          var e = this._readableState;
          return e.flowing || (f("resume"), e.flowing = !0, function (e, t) {
            t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(C, e, t));
          }(this, e)), this;
        }, b.prototype.pause = function () {
          return f("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (f("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
        }, b.prototype.wrap = function (e) {
          var t = this,
            n = this._readableState,
            r = !1;
          for (var i in e.on("end", function () {
            if (f("wrapped end"), n.decoder && !n.ended) {
              var e = n.decoder.end();
              e && e.length && t.push(e);
            }
            t.push(null);
          }), e.on("data", function (i) {
            (f("wrapped data"), n.decoder && (i = n.decoder.write(i)), n.objectMode && null == i) || (n.objectMode || i && i.length) && (t.push(i) || (r = !0, e.pause()));
          }), e) void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
            return function () {
              return e[t].apply(e, arguments);
            };
          }(i));
          for (var o = 0; o < v.length; o++) e.on(v[o], this.emit.bind(this, v[o]));
          return this._read = function (t) {
            f("wrapped _read", t), r && (r = !1, e.resume());
          }, this;
        }, Object.defineProperty(b.prototype, "readableHighWaterMark", {
          enumerable: !1,
          get: function get() {
            return this._readableState.highWaterMark;
          }
        }), b._fromList = P;
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
    },
    "./node_modules/readable-stream/lib/_stream_transform.js": function node_modulesReadableStreamLib_stream_transformJs(e, t, n) {
      "use strict";

      e.exports = a;
      var r = n("./node_modules/readable-stream/lib/_stream_duplex.js"),
        i = Object.create(n("./node_modules/core-util-is/lib/util.js"));
      function o(e, t) {
        var n = this._transformState;
        n.transforming = !1;
        var r = n.writecb;
        if (!r) return this.emit("error", new Error("write callback called multiple times"));
        n.writechunk = null, n.writecb = null, null != t && this.push(t), r(e);
        var i = this._readableState;
        i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
      function a(e) {
        if (!(this instanceof a)) return new a(e);
        r.call(this, e), this._transformState = {
          afterTransform: o.bind(this),
          needTransform: !1,
          transforming: !1,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", s);
      }
      function s() {
        var e = this;
        "function" == typeof this._flush ? this._flush(function (t, n) {
          l(e, t, n);
        }) : l(this, null, null);
      }
      function l(e, t, n) {
        if (t) return e.emit("error", t);
        if (null != n && e.push(n), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
        if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
        return e.push(null);
      }
      i.inherits = n("./node_modules/inherits/inherits_browser.js"), i.inherits(a, r), a.prototype.push = function (e, t) {
        return this._transformState.needTransform = !1, r.prototype.push.call(this, e, t);
      }, a.prototype._transform = function (e, t, n) {
        throw new Error("_transform() is not implemented");
      }, a.prototype._write = function (e, t, n) {
        var r = this._transformState;
        if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
          var i = this._readableState;
          (r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
        }
      }, a.prototype._read = function (e) {
        var t = this._transformState;
        null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
      }, a.prototype._destroy = function (e, t) {
        var n = this;
        r.prototype._destroy.call(this, e, function (e) {
          t(e), n.emit("close");
        });
      };
    },
    "./node_modules/readable-stream/lib/_stream_writable.js": function node_modulesReadableStreamLib_stream_writableJs(e, t, n) {
      "use strict";

      (function (t, r, i) {
        var o = n("./node_modules/process-nextick-args/index.js");
        function a(e) {
          var t = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (e, t, n) {
              var r = e.entry;
              e.entry = null;
              for (; r;) {
                var i = r.callback;
                t.pendingcb--, i(n), r = r.next;
              }
              t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
            }(t, e);
          };
        }
        e.exports = y;
        var s,
          l = !t.browser && ["v0.10", "v0.9."].indexOf(t.version.slice(0, 5)) > -1 ? r : o.nextTick;
        y.WritableState = v;
        var u = Object.create(n("./node_modules/core-util-is/lib/util.js"));
        u.inherits = n("./node_modules/inherits/inherits_browser.js");
        var c = {
            deprecate: n("./node_modules/util-deprecate/browser.js")
          },
          d = n("./node_modules/readable-stream/lib/internal/streams/stream-browser.js"),
          h = n("./node_modules/safe-buffer/index.js").Buffer,
          f = i.Uint8Array || function () {};
        var p,
          m = n("./node_modules/readable-stream/lib/internal/streams/destroy.js");
        function g() {}
        function v(e, t) {
          s = s || n("./node_modules/readable-stream/lib/_stream_duplex.js"), e = e || {};
          var r = t instanceof s;
          this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.writableObjectMode);
          var i = e.highWaterMark,
            u = e.writableHighWaterMark,
            c = this.objectMode ? 16 : 16384;
          this.highWaterMark = i || 0 === i ? i : r && (u || 0 === u) ? u : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
          var d = !1 === e.decodeStrings;
          this.decodeStrings = !d, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
            !function (e, t) {
              var n = e._writableState,
                r = n.sync,
                i = n.writecb;
              if (function (e) {
                e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
              }(n), t) !function (e, t, n, r, i) {
                --t.pendingcb, n ? (o.nextTick(i, r), o.nextTick(A, e, t), e._writableState.errorEmitted = !0, e.emit("error", r)) : (i(r), e._writableState.errorEmitted = !0, e.emit("error", r), A(e, t));
              }(e, n, r, t, i);else {
                var a = w(n);
                a || n.corked || n.bufferProcessing || !n.bufferedRequest || x(e, n), r ? l(_, e, n, a, i) : _(e, n, a, i);
              }
            }(t, e);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
        }
        function y(e) {
          if (s = s || n("./node_modules/readable-stream/lib/_stream_duplex.js"), !(p.call(y, this) || this instanceof s)) return new y(e);
          this._writableState = new v(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), d.call(this);
        }
        function b(e, t, n, r, i, o, a) {
          t.writelen = r, t.writecb = a, t.writing = !0, t.sync = !0, n ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
        }
        function _(e, t, n, r) {
          n || function (e, t) {
            0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
          }(e, t), t.pendingcb--, r(), A(e, t);
        }
        function x(e, t) {
          t.bufferProcessing = !0;
          var n = t.bufferedRequest;
          if (e._writev && n && n.next) {
            var r = t.bufferedRequestCount,
              i = new Array(r),
              o = t.corkedRequestsFree;
            o.entry = n;
            for (var s = 0, l = !0; n;) i[s] = n, n.isBuf || (l = !1), n = n.next, s += 1;
            i.allBuffers = l, b(e, t, !0, t.length, i, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new a(t), t.bufferedRequestCount = 0;
          } else {
            for (; n;) {
              var u = n.chunk,
                c = n.encoding,
                d = n.callback;
              if (b(e, t, !1, t.objectMode ? 1 : u.length, u, c, d), n = n.next, t.bufferedRequestCount--, t.writing) break;
            }
            null === n && (t.lastBufferedRequest = null);
          }
          t.bufferedRequest = n, t.bufferProcessing = !1;
        }
        function w(e) {
          return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
        }
        function S(e, t) {
          e._final(function (n) {
            t.pendingcb--, n && e.emit("error", n), t.prefinished = !0, e.emit("prefinish"), A(e, t);
          });
        }
        function A(e, t) {
          var n = w(t);
          return n && (!function (e, t) {
            t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, o.nextTick(S, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
          }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), n;
        }
        u.inherits(y, d), v.prototype.getBuffer = function () {
          for (var e = this.bufferedRequest, t = []; e;) t.push(e), e = e.next;
          return t;
        }, function () {
          try {
            Object.defineProperty(v.prototype, "buffer", {
              get: c.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (e) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
          value: function value(e) {
            return !!p.call(this, e) || this === y && e && e._writableState instanceof v;
          }
        })) : p = function p(e) {
          return e instanceof this;
        }, y.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, y.prototype.write = function (e, t, n) {
          var r,
            i = this._writableState,
            a = !1,
            s = !i.objectMode && (r = e, h.isBuffer(r) || r instanceof f);
          return s && !h.isBuffer(e) && (e = function (e) {
            return h.from(e);
          }(e)), "function" == typeof t && (n = t, t = null), s ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof n && (n = g), i.ended ? function (e, t) {
            var n = new Error("write after end");
            e.emit("error", n), o.nextTick(t, n);
          }(this, n) : (s || function (e, t, n, r) {
            var i = !0,
              a = !1;
            return null === n ? a = new TypeError("May not write null values to stream") : "string" == typeof n || void 0 === n || t.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (e.emit("error", a), o.nextTick(r, a), i = !1), i;
          }(this, i, e, n)) && (i.pendingcb++, a = function (e, t, n, r, i, o) {
            if (!n) {
              var a = function (e, t, n) {
                e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = h.from(t, n));
                return t;
              }(t, r, i);
              r !== a && (n = !0, i = "buffer", r = a);
            }
            var s = t.objectMode ? 1 : r.length;
            t.length += s;
            var l = t.length < t.highWaterMark;
            l || (t.needDrain = !0);
            if (t.writing || t.corked) {
              var u = t.lastBufferedRequest;
              t.lastBufferedRequest = {
                chunk: r,
                encoding: i,
                isBuf: n,
                callback: o,
                next: null
              }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
            } else b(e, t, !1, s, r, i, o);
            return l;
          }(this, i, s, e, t, n)), a;
        }, y.prototype.cork = function () {
          this._writableState.corked++;
        }, y.prototype.uncork = function () {
          var e = this._writableState;
          e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || x(this, e));
        }, y.prototype.setDefaultEncoding = function (e) {
          if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
          return this._writableState.defaultEncoding = e, this;
        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
          enumerable: !1,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), y.prototype._write = function (e, t, n) {
          n(new Error("_write() is not implemented"));
        }, y.prototype._writev = null, y.prototype.end = function (e, t, n) {
          var r = this._writableState;
          "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function (e, t, n) {
            t.ending = !0, A(e, t), n && (t.finished ? o.nextTick(n) : e.once("finish", n));
            t.ended = !0, e.writable = !1;
          }(this, r, n);
        }, Object.defineProperty(y.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(e) {
            this._writableState && (this._writableState.destroyed = e);
          }
        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function (e, t) {
          this.end(), t(e);
        };
      }).call(this, n("./node_modules/process/browser.js"), n("./node_modules/timers-browserify/main.js").setImmediate, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/readable-stream/lib/internal/streams/BufferList.js": function node_modulesReadableStreamLibInternalStreamsBufferListJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = n(1);
      e.exports = function () {
        function e() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.head = null, this.tail = null, this.length = 0;
        }
        return e.prototype.push = function (e) {
          var t = {
            data: e,
            next: null
          };
          this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
        }, e.prototype.unshift = function (e) {
          var t = {
            data: e,
            next: this.head
          };
          0 === this.length && (this.tail = t), this.head = t, ++this.length;
        }, e.prototype.shift = function () {
          if (0 !== this.length) {
            var e = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
          }
        }, e.prototype.clear = function () {
          this.head = this.tail = null, this.length = 0;
        }, e.prototype.join = function (e) {
          if (0 === this.length) return "";
          for (var t = this.head, n = "" + t.data; t = t.next;) n += e + t.data;
          return n;
        }, e.prototype.concat = function (e) {
          if (0 === this.length) return r.alloc(0);
          if (1 === this.length) return this.head.data;
          for (var t, n, i, o = r.allocUnsafe(e >>> 0), a = this.head, s = 0; a;) t = a.data, n = o, i = s, t.copy(n, i), s += a.data.length, a = a.next;
          return o;
        }, e;
      }(), i && i.inspect && i.inspect.custom && (e.exports.prototype[i.inspect.custom] = function () {
        var e = i.inspect({
          length: this.length
        });
        return this.constructor.name + " " + e;
      });
    },
    "./node_modules/readable-stream/lib/internal/streams/destroy.js": function node_modulesReadableStreamLibInternalStreamsDestroyJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/process-nextick-args/index.js");
      function i(e, t) {
        e.emit("error", t);
      }
      e.exports = {
        destroy: function destroy(e, t) {
          var n = this,
            o = this._readableState && this._readableState.destroyed,
            a = this._writableState && this._writableState.destroyed;
          return o || a ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || r.nextTick(i, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
            !t && e ? (r.nextTick(i, n, e), n._writableState && (n._writableState.errorEmitted = !0)) : t && t(e);
          }), this);
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        }
      };
    },
    "./node_modules/readable-stream/lib/internal/streams/stream-browser.js": function node_modulesReadableStreamLibInternalStreamsStreamBrowserJs(e, t, n) {
      e.exports = n("./node_modules/events/events.js").EventEmitter;
    },
    "./node_modules/readable-stream/passthrough.js": function node_modulesReadableStreamPassthroughJs(e, t, n) {
      e.exports = n("./node_modules/readable-stream/readable-browser.js").PassThrough;
    },
    "./node_modules/readable-stream/readable-browser.js": function node_modulesReadableStreamReadableBrowserJs(e, t, n) {
      (t = e.exports = n("./node_modules/readable-stream/lib/_stream_readable.js")).Stream = t, t.Readable = t, t.Writable = n("./node_modules/readable-stream/lib/_stream_writable.js"), t.Duplex = n("./node_modules/readable-stream/lib/_stream_duplex.js"), t.Transform = n("./node_modules/readable-stream/lib/_stream_transform.js"), t.PassThrough = n("./node_modules/readable-stream/lib/_stream_passthrough.js");
    },
    "./node_modules/readable-stream/transform.js": function node_modulesReadableStreamTransformJs(e, t, n) {
      e.exports = n("./node_modules/readable-stream/readable-browser.js").Transform;
    },
    "./node_modules/readable-stream/writable-browser.js": function node_modulesReadableStreamWritableBrowserJs(e, t, n) {
      e.exports = n("./node_modules/readable-stream/lib/_stream_writable.js");
    },
    "./node_modules/redux-logger/dist/redux-logger.js": function node_modulesReduxLoggerDistReduxLoggerJs(e, t, n) {
      (function (e) {
        !function (t) {
          "use strict";

          function n(e, t) {
            e.super_ = t, e.prototype = Object.create(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            });
          }
          function r(e, t) {
            Object.defineProperty(this, "kind", {
              value: e,
              enumerable: !0
            }), t && t.length && Object.defineProperty(this, "path", {
              value: t,
              enumerable: !0
            });
          }
          function i(e, t, n) {
            i.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
              value: t,
              enumerable: !0
            }), Object.defineProperty(this, "rhs", {
              value: n,
              enumerable: !0
            });
          }
          function o(e, t) {
            o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
              value: t,
              enumerable: !0
            });
          }
          function a(e, t) {
            a.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
              value: t,
              enumerable: !0
            });
          }
          function s(e, t, n) {
            s.super_.call(this, "A", e), Object.defineProperty(this, "index", {
              value: t,
              enumerable: !0
            }), Object.defineProperty(this, "item", {
              value: n,
              enumerable: !0
            });
          }
          function l(e, t, n) {
            var r = e.slice((n || t) + 1 || e.length);
            return e.length = t < 0 ? e.length + t : t, e.push.apply(e, r), e;
          }
          function u(e) {
            var t = void 0 === e ? "undefined" : S(e);
            return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
          }
          function c(e, t, n, r, d, h, f) {
            f = f || [];
            var p = (d = d || []).slice(0);
            if (void 0 !== h) {
              if (r) {
                if ("function" == typeof r && r(p, h)) return;
                if ("object" === (void 0 === r ? "undefined" : S(r))) {
                  if (r.prefilter && r.prefilter(p, h)) return;
                  if (r.normalize) {
                    var m = r.normalize(p, h, e, t);
                    m && (e = m[0], t = m[1]);
                  }
                }
              }
              p.push(h);
            }
            "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
            var g = void 0 === e ? "undefined" : S(e),
              v = void 0 === t ? "undefined" : S(t),
              y = "undefined" !== g || f && f[f.length - 1].lhs && f[f.length - 1].lhs.hasOwnProperty(h),
              b = "undefined" !== v || f && f[f.length - 1].rhs && f[f.length - 1].rhs.hasOwnProperty(h);
            if (!y && b) n(new o(p, t));else if (!b && y) n(new a(p, e));else if (u(e) !== u(t)) n(new i(p, e, t));else if ("date" === u(e) && e - t != 0) n(new i(p, e, t));else if ("object" === g && null !== e && null !== t) {
              if (f.filter(function (t) {
                return t.lhs === e;
              }).length) e !== t && n(new i(p, e, t));else {
                if (f.push({
                  lhs: e,
                  rhs: t
                }), Array.isArray(e)) {
                  var _;
                  for (e.length, _ = 0; _ < e.length; _++) _ >= t.length ? n(new s(p, _, new a(void 0, e[_]))) : c(e[_], t[_], n, r, p, _, f);
                  for (; _ < t.length;) n(new s(p, _, new o(void 0, t[_++])));
                } else {
                  var x = Object.keys(e),
                    w = Object.keys(t);
                  x.forEach(function (i, o) {
                    var a = w.indexOf(i);
                    a >= 0 ? (c(e[i], t[i], n, r, p, i, f), w = l(w, a)) : c(e[i], void 0, n, r, p, i, f);
                  }), w.forEach(function (e) {
                    c(void 0, t[e], n, r, p, e, f);
                  });
                }
                f.length = f.length - 1;
              }
            } else e !== t && ("number" === g && isNaN(e) && isNaN(t) || n(new i(p, e, t)));
          }
          function d(e, t, n, r) {
            return r = r || [], c(e, t, function (e) {
              e && r.push(e);
            }, n), r.length ? r : void 0;
          }
          function h(e, t, n) {
            if (e && t && n && n.kind) {
              for (var r = e, i = -1, o = n.path ? n.path.length - 1 : 0; ++i < o;) void 0 === r[n.path[i]] && (r[n.path[i]] = "number" == typeof n.path[i] ? [] : {}), r = r[n.path[i]];
              switch (n.kind) {
                case "A":
                  !function e(t, n, r) {
                    if (r.path && r.path.length) {
                      var i,
                        o = t[n],
                        a = r.path.length - 1;
                      for (i = 0; i < a; i++) o = o[r.path[i]];
                      switch (r.kind) {
                        case "A":
                          e(o[r.path[i]], r.index, r.item);
                          break;
                        case "D":
                          delete o[r.path[i]];
                          break;
                        case "E":
                        case "N":
                          o[r.path[i]] = r.rhs;
                      }
                    } else switch (r.kind) {
                      case "A":
                        e(t[n], r.index, r.item);
                        break;
                      case "D":
                        t = l(t, n);
                        break;
                      case "E":
                      case "N":
                        t[n] = r.rhs;
                    }
                    return t;
                  }(n.path ? r[n.path[i]] : r, n.index, n.item);
                  break;
                case "D":
                  delete r[n.path[i]];
                  break;
                case "E":
                case "N":
                  r[n.path[i]] = n.rhs;
              }
            }
          }
          function f(e) {
            return "color: " + T[e].color + "; font-weight: bold";
          }
          function p(e, t, n, r) {
            var i = d(e, t);
            try {
              r ? n.groupCollapsed("diff") : n.group("diff");
            } catch (e) {
              n.log("diff");
            }
            i ? i.forEach(function (e) {
              var t = e.kind,
                r = function (e) {
                  var t = e.kind,
                    n = e.path,
                    r = e.lhs,
                    i = e.rhs,
                    o = e.index,
                    a = e.item;
                  switch (t) {
                    case "E":
                      return [n.join("."), r, "→", i];
                    case "N":
                      return [n.join("."), i];
                    case "D":
                      return [n.join(".")];
                    case "A":
                      return [n.join(".") + "[" + o + "]", a];
                    default:
                      return [];
                  }
                }(e);
              n.log.apply(n, ["%c " + T[t].text, f(t)].concat(A(r)));
            }) : n.log("—— no diff ——");
            try {
              n.groupEnd();
            } catch (e) {
              n.log("—— diff end —— ");
            }
          }
          function m(e, t, n, r) {
            switch (void 0 === e ? "undefined" : S(e)) {
              case "object":
                return "function" == typeof e[r] ? e[r].apply(e, A(n)) : e[r];
              case "function":
                return e(t);
              default:
                return e;
            }
          }
          function g(e, t) {
            var n = t.logger,
              r = t.actionTransformer,
              i = t.titleFormatter,
              o = void 0 === i ? function (e) {
                var t = e.timestamp,
                  n = e.duration;
                return function (e, r, i) {
                  var o = ["action"];
                  return o.push("%c" + String(e.type)), t && o.push("%c@ " + r), n && o.push("%c(in " + i.toFixed(2) + " ms)"), o.join(" ");
                };
              }(t) : i,
              a = t.collapsed,
              s = t.colors,
              l = t.level,
              u = t.diff,
              c = void 0 === t.titleFormatter;
            e.forEach(function (i, d) {
              var h = i.started,
                f = i.startedTime,
                g = i.action,
                v = i.prevState,
                y = i.error,
                b = i.took,
                _ = i.nextState,
                w = e[d + 1];
              w && (_ = w.prevState, b = w.started - h);
              var S = r(g),
                A = "function" == typeof a ? a(function () {
                  return _;
                }, g, i) : a,
                E = x(f),
                T = s.title ? "color: " + s.title(S) + ";" : "",
                M = ["color: gray; font-weight: lighter;"];
              M.push(T), t.timestamp && M.push("color: gray; font-weight: lighter;"), t.duration && M.push("color: gray; font-weight: lighter;");
              var C = o(S, E, b);
              try {
                A ? s.title && c ? n.groupCollapsed.apply(n, ["%c " + C].concat(M)) : n.groupCollapsed(C) : s.title && c ? n.group.apply(n, ["%c " + C].concat(M)) : n.group(C);
              } catch (e) {
                n.log(C);
              }
              var k = m(l, S, [v], "prevState"),
                P = m(l, S, [S], "action"),
                O = m(l, S, [y, v], "error"),
                R = m(l, S, [_], "nextState");
              if (k) if (s.prevState) {
                var I = "color: " + s.prevState(v) + "; font-weight: bold";
                n[k]("%c prev state", I, v);
              } else n[k]("prev state", v);
              if (P) if (s.action) {
                var j = "color: " + s.action(S) + "; font-weight: bold";
                n[P]("%c action    ", j, S);
              } else n[P]("action    ", S);
              if (y && O) if (s.error) {
                var N = "color: " + s.error(y, v) + "; font-weight: bold;";
                n[O]("%c error     ", N, y);
              } else n[O]("error     ", y);
              if (R) if (s.nextState) {
                var L = "color: " + s.nextState(_) + "; font-weight: bold";
                n[R]("%c next state", L, _);
              } else n[R]("next state", _);
              u && p(v, _, n, A);
              try {
                n.groupEnd();
              } catch (e) {
                n.log("—— log end ——");
              }
            });
          }
          function v() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = Object.assign({}, M, e),
              n = t.logger,
              r = t.stateTransformer,
              i = t.errorTransformer,
              o = t.predicate,
              a = t.logErrors,
              s = t.diffPredicate;
            if (void 0 === n) return function () {
              return function (e) {
                return function (t) {
                  return e(t);
                };
              };
            };
            if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function () {
              return function (e) {
                return function (t) {
                  return e(t);
                };
              };
            };
            var l = [];
            return function (e) {
              var n = e.getState;
              return function (e) {
                return function (u) {
                  if ("function" == typeof o && !o(n, u)) return e(u);
                  var c = {};
                  l.push(c), c.started = w.now(), c.startedTime = new Date(), c.prevState = r(n()), c.action = u;
                  var d = void 0;
                  if (a) try {
                    d = e(u);
                  } catch (e) {
                    c.error = i(e);
                  } else d = e(u);
                  c.took = w.now() - c.started, c.nextState = r(n());
                  var h = t.diff && "function" == typeof s ? s(n, u) : t.diff;
                  if (g(l, Object.assign({}, t, {
                    diff: h
                  })), l.length = 0, c.error) throw c.error;
                  return d;
                };
              };
            };
          }
          var y,
            b,
            _ = function _(e, t) {
              return function (e, t) {
                return new Array(t + 1).join(e);
              }("0", t - e.toString().length) + e;
            },
            x = function x(e) {
              return _(e.getHours(), 2) + ":" + _(e.getMinutes(), 2) + ":" + _(e.getSeconds(), 2) + "." + _(e.getMilliseconds(), 3);
            },
            w = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date,
            S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            },
            A = function A(e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                return n;
              }
              return Array.from(e);
            },
            E = [];
          y = "object" === (void 0 === e ? "undefined" : S(e)) && e ? e : "undefined" != typeof window ? window : {}, (b = y.DeepDiff) && E.push(function () {
            void 0 !== b && y.DeepDiff === d && (y.DeepDiff = b, b = void 0);
          }), n(i, r), n(o, r), n(a, r), n(s, r), Object.defineProperties(d, {
            diff: {
              value: d,
              enumerable: !0
            },
            observableDiff: {
              value: c,
              enumerable: !0
            },
            applyDiff: {
              value: function value(e, t, n) {
                e && t && c(e, t, function (r) {
                  n && !n(e, t, r) || h(e, t, r);
                });
              },
              enumerable: !0
            },
            applyChange: {
              value: h,
              enumerable: !0
            },
            revertChange: {
              value: function value(e, t, n) {
                if (e && t && n && n.kind) {
                  var r,
                    i,
                    o = e;
                  for (i = n.path.length - 1, r = 0; r < i; r++) void 0 === o[n.path[r]] && (o[n.path[r]] = {}), o = o[n.path[r]];
                  switch (n.kind) {
                    case "A":
                      !function e(t, n, r) {
                        if (r.path && r.path.length) {
                          var i,
                            o = t[n],
                            a = r.path.length - 1;
                          for (i = 0; i < a; i++) o = o[r.path[i]];
                          switch (r.kind) {
                            case "A":
                              e(o[r.path[i]], r.index, r.item);
                              break;
                            case "D":
                            case "E":
                              o[r.path[i]] = r.lhs;
                              break;
                            case "N":
                              delete o[r.path[i]];
                          }
                        } else switch (r.kind) {
                          case "A":
                            e(t[n], r.index, r.item);
                            break;
                          case "D":
                          case "E":
                            t[n] = r.lhs;
                            break;
                          case "N":
                            t = l(t, n);
                        }
                        return t;
                      }(o[n.path[r]], n.index, n.item);
                      break;
                    case "D":
                    case "E":
                      o[n.path[r]] = n.lhs;
                      break;
                    case "N":
                      delete o[n.path[r]];
                  }
                }
              },
              enumerable: !0
            },
            isConflict: {
              value: function value() {
                return void 0 !== b;
              },
              enumerable: !0
            },
            noConflict: {
              value: function value() {
                return E && (E.forEach(function (e) {
                  e();
                }), E = null), d;
              },
              enumerable: !0
            }
          });
          var T = {
              E: {
                color: "#2196F3",
                text: "CHANGED:"
              },
              N: {
                color: "#4CAF50",
                text: "ADDED:"
              },
              D: {
                color: "#F44336",
                text: "DELETED:"
              },
              A: {
                color: "#2196F3",
                text: "ARRAY:"
              }
            },
            M = {
              level: "log",
              logger: console,
              logErrors: !0,
              collapsed: void 0,
              predicate: void 0,
              duration: !1,
              timestamp: !0,
              stateTransformer: function stateTransformer(e) {
                return e;
              },
              actionTransformer: function actionTransformer(e) {
                return e;
              },
              errorTransformer: function errorTransformer(e) {
                return e;
              },
              colors: {
                title: function title() {
                  return "inherit";
                },
                prevState: function prevState() {
                  return "#9E9E9E";
                },
                action: function action() {
                  return "#03A9F4";
                },
                nextState: function nextState() {
                  return "#4CAF50";
                },
                error: function error() {
                  return "#F20404";
                }
              },
              diff: !1,
              diffPredicate: void 0,
              transformer: void 0
            },
            C = function C() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = e.dispatch,
                n = e.getState;
              return "function" == typeof t || "function" == typeof n ? v()({
                dispatch: t,
                getState: n
              }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
            };
          t.defaults = M, t.createLogger = v, t.logger = C, t.default = C, Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }(t);
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/redux-thunk/es/index.js": function node_modulesReduxThunkEsIndexJs(e, t, n) {
      "use strict";

      function r(e) {
        return function (t) {
          var n = t.dispatch,
            r = t.getState;
          return function (t) {
            return function (i) {
              return "function" == typeof i ? i(n, r, e) : t(i);
            };
          };
        };
      }
      n.r(t);
      var i = r();
      i.withExtraArgument = r, t.default = i;
    },
    "./node_modules/redux/es/redux.js": function node_modulesReduxEsReduxJs(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "__DO_NOT_USE__ActionTypes", function () {
        return o;
      }), n.d(t, "applyMiddleware", function () {
        return g;
      }), n.d(t, "bindActionCreators", function () {
        return d;
      }), n.d(t, "combineReducers", function () {
        return u;
      }), n.d(t, "compose", function () {
        return m;
      }), n.d(t, "createStore", function () {
        return s;
      });
      var r = n("./node_modules/symbol-observable/es/index.js"),
        i = function i() {
          return Math.random().toString(36).substring(7).split("").join(".");
        },
        o = {
          INIT: "@@redux/INIT" + i(),
          REPLACE: "@@redux/REPLACE" + i(),
          PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
            return "@@redux/PROBE_UNKNOWN_ACTION" + i();
          }
        };
      function a(e) {
        if ("object" != typeof e || null === e) return !1;
        for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
        return Object.getPrototypeOf(e) === t;
      }
      function s(e, t, n) {
        var i;
        if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
        if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
          if ("function" != typeof n) throw new Error("Expected the enhancer to be a function.");
          return n(s)(e, t);
        }
        if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
        var l = e,
          u = t,
          c = [],
          d = c,
          h = !1;
        function f() {
          d === c && (d = c.slice());
        }
        function p() {
          if (h) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
          return u;
        }
        function m(e) {
          if ("function" != typeof e) throw new Error("Expected the listener to be a function.");
          if (h) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
          var t = !0;
          return f(), d.push(e), function () {
            if (t) {
              if (h) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribelistener for more details.");
              t = !1, f();
              var n = d.indexOf(e);
              d.splice(n, 1), c = null;
            }
          };
        }
        function g(e) {
          if (!a(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
          if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
          if (h) throw new Error("Reducers may not dispatch actions.");
          try {
            h = !0, u = l(u, e);
          } finally {
            h = !1;
          }
          for (var t = c = d, n = 0; n < t.length; n++) {
            (0, t[n])();
          }
          return e;
        }
        function v(e) {
          if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
          l = e, g({
            type: o.REPLACE
          });
        }
        function y() {
          var e,
            t = m;
          return (e = {
            subscribe: function subscribe(e) {
              if ("object" != typeof e || null === e) throw new TypeError("Expected the observer to be an object.");
              function n() {
                e.next && e.next(p());
              }
              return n(), {
                unsubscribe: t(n)
              };
            }
          })[r.a] = function () {
            return this;
          }, e;
        }
        return g({
          type: o.INIT
        }), (i = {
          dispatch: g,
          subscribe: m,
          getState: p,
          replaceReducer: v
        })[r.a] = y, i;
      }
      function l(e, t) {
        var n = t && t.type;
        return "Given " + (n && 'action "' + String(n) + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.';
      }
      function u(e) {
        for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
          var i = t[r];
          0, "function" == typeof e[i] && (n[i] = e[i]);
        }
        var a,
          s = Object.keys(n);
        try {
          !function (e) {
            Object.keys(e).forEach(function (t) {
              var n = e[t];
              if (void 0 === n(void 0, {
                type: o.INIT
              })) throw new Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
              if (void 0 === n(void 0, {
                type: o.PROBE_UNKNOWN_ACTION()
              })) throw new Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + o.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.');
            });
          }(n);
        } catch (e) {
          a = e;
        }
        return function (e, t) {
          if (void 0 === e && (e = {}), a) throw a;
          for (var r = !1, i = {}, o = 0; o < s.length; o++) {
            var u = s[o],
              c = n[u],
              d = e[u],
              h = c(d, t);
            if (void 0 === h) {
              var f = l(u, t);
              throw new Error(f);
            }
            i[u] = h, r = r || h !== d;
          }
          return (r = r || s.length !== Object.keys(e).length) ? i : e;
        };
      }
      function c(e, t) {
        return function () {
          return t(e.apply(this, arguments));
        };
      }
      function d(e, t) {
        if ("function" == typeof e) return c(e, t);
        if ("object" != typeof e || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : typeof e) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
        var n = {};
        for (var r in e) {
          var i = e[r];
          "function" == typeof i && (n[r] = c(i, t));
        }
        return n;
      }
      function h(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      function f(e, t) {
        var n = Object.keys(e);
        return Object.getOwnPropertySymbols && n.push.apply(n, Object.getOwnPropertySymbols(e)), t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n;
      }
      function p(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? f(n, !0).forEach(function (t) {
            h(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(n).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }
        return e;
      }
      function m() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return 0 === t.length ? function (e) {
          return e;
        } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
          return function () {
            return e(t.apply(void 0, arguments));
          };
        });
      }
      function g() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return function (e) {
          return function () {
            var n = e.apply(void 0, arguments),
              r = function r() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
              },
              i = {
                getState: n.getState,
                dispatch: function dispatch() {
                  return r.apply(void 0, arguments);
                }
              },
              o = t.map(function (e) {
                return e(i);
              });
            return p({}, n, {
              dispatch: r = m.apply(void 0, o)(n.dispatch)
            });
          };
        };
      }
    },
    "./node_modules/regexp.prototype.flags/implementation.js": function node_modulesRegexpPrototypeFlagsImplementationJs(e, t, n) {
      "use strict";

      var r = Object,
        i = TypeError;
      e.exports = function () {
        if (null != this && this !== r(this)) throw new i("RegExp.prototype.flags getter called on non-object");
        var e = "";
        return this.global && (e += "g"), this.ignoreCase && (e += "i"), this.multiline && (e += "m"), this.dotAll && (e += "s"), this.unicode && (e += "u"), this.sticky && (e += "y"), e;
      };
    },
    "./node_modules/regexp.prototype.flags/index.js": function node_modulesRegexpPrototypeFlagsIndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/define-properties/index.js"),
        i = n("./node_modules/es-abstract/helpers/callBind.js"),
        o = n("./node_modules/regexp.prototype.flags/implementation.js"),
        a = n("./node_modules/regexp.prototype.flags/polyfill.js"),
        s = n("./node_modules/regexp.prototype.flags/shim.js"),
        l = i(o);
      r(l, {
        getPolyfill: a,
        implementation: o,
        shim: s
      }), e.exports = l;
    },
    "./node_modules/regexp.prototype.flags/polyfill.js": function node_modulesRegexpPrototypeFlagsPolyfillJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/regexp.prototype.flags/implementation.js"),
        i = n("./node_modules/define-properties/index.js").supportsDescriptors,
        o = Object.getOwnPropertyDescriptor,
        a = TypeError;
      e.exports = function () {
        if (!i) throw new a("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
        if ("gim" === /a/gim.flags) {
          var e = o(RegExp.prototype, "flags");
          if (e && "function" == typeof e.get && "boolean" == typeof /a/.dotAll) return e.get;
        }
        return r;
      };
    },
    "./node_modules/regexp.prototype.flags/shim.js": function node_modulesRegexpPrototypeFlagsShimJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/define-properties/index.js").supportsDescriptors,
        i = n("./node_modules/regexp.prototype.flags/polyfill.js"),
        o = Object.getOwnPropertyDescriptor,
        a = Object.defineProperty,
        s = TypeError,
        l = Object.getPrototypeOf,
        u = /a/;
      e.exports = function () {
        if (!r || !l) throw new s("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
        var e = i(),
          t = l(u),
          n = o(t, "flags");
        return n && n.get === e || a(t, "flags", {
          configurable: !0,
          enumerable: !1,
          get: e
        }), e;
      };
    },
    "./node_modules/reselect/es/index.js": function node_modulesReselectEsIndexJs(e, t, n) {
      "use strict";

      function r(e, t) {
        return e === t;
      }
      function i(e, t, n) {
        if (null === t || null === n || t.length !== n.length) return !1;
        for (var r = t.length, i = 0; i < r; i++) if (!e(t[i], n[i])) return !1;
        return !0;
      }
      function o(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r,
          n = null,
          o = null;
        return function () {
          return i(t, n, arguments) || (o = e.apply(null, arguments)), n = arguments, o;
        };
      }
      function a(e) {
        var t = Array.isArray(e[0]) ? e[0] : e;
        if (!t.every(function (e) {
          return "function" == typeof e;
        })) {
          var n = t.map(function (e) {
            return typeof e;
          }).join(", ");
          throw new Error("Selector creators expect all input-selectors to be functions, instead received the following types: [" + n + "]");
        }
        return t;
      }
      function s(e) {
        for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
        return function () {
          for (var t = arguments.length, r = Array(t), i = 0; i < t; i++) r[i] = arguments[i];
          var o = 0,
            s = r.pop(),
            l = a(r),
            u = e.apply(void 0, [function () {
              return o++, s.apply(null, arguments);
            }].concat(n)),
            c = e(function () {
              for (var e = [], t = l.length, n = 0; n < t; n++) e.push(l[n].apply(null, arguments));
              return u.apply(null, e);
            });
          return c.resultFunc = s, c.dependencies = l, c.recomputations = function () {
            return o;
          }, c.resetRecomputations = function () {
            return o = 0;
          }, c;
        };
      }
      n.r(t), n.d(t, "defaultMemoize", function () {
        return o;
      }), n.d(t, "createSelectorCreator", function () {
        return s;
      }), n.d(t, "createSelector", function () {
        return l;
      }), n.d(t, "createStructuredSelector", function () {
        return u;
      });
      var l = s(o);
      function u(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l;
        if ("object" != typeof e) throw new Error("createStructuredSelector expects first argument to be an object where each property is a selector, instead received a " + typeof e);
        var n = Object.keys(e);
        return t(n.map(function (t) {
          return e[t];
        }), function () {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          return t.reduce(function (e, t, r) {
            return e[n[r]] = t, e;
          }, {});
        });
      }
    },
    "./node_modules/ripemd160/index.js": function node_modulesRipemd160IndexJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/buffer/index.js").Buffer,
        i = n("./node_modules/inherits/inherits_browser.js"),
        o = n("./node_modules/hash-base/index.js"),
        a = new Array(16),
        s = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        l = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        u = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        c = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
        d = [0, 1518500249, 1859775393, 2400959708, 2840853838],
        h = [1352829926, 1548603684, 1836072691, 2053994217, 0];
      function f() {
        o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
      }
      function p(e, t) {
        return e << t | e >>> 32 - t;
      }
      function m(e, t, n, r, i, o, a, s) {
        return p(e + (t ^ n ^ r) + o + a | 0, s) + i | 0;
      }
      function g(e, t, n, r, i, o, a, s) {
        return p(e + (t & n | ~t & r) + o + a | 0, s) + i | 0;
      }
      function v(e, t, n, r, i, o, a, s) {
        return p(e + ((t | ~n) ^ r) + o + a | 0, s) + i | 0;
      }
      function y(e, t, n, r, i, o, a, s) {
        return p(e + (t & r | n & ~r) + o + a | 0, s) + i | 0;
      }
      function b(e, t, n, r, i, o, a, s) {
        return p(e + (t ^ (n | ~r)) + o + a | 0, s) + i | 0;
      }
      i(f, o), f.prototype._update = function () {
        for (var e = a, t = 0; t < 16; ++t) e[t] = this._block.readInt32LE(4 * t);
        for (var n = 0 | this._a, r = 0 | this._b, i = 0 | this._c, o = 0 | this._d, f = 0 | this._e, _ = 0 | this._a, x = 0 | this._b, w = 0 | this._c, S = 0 | this._d, A = 0 | this._e, E = 0; E < 80; E += 1) {
          var T, M;
          E < 16 ? (T = m(n, r, i, o, f, e[s[E]], d[0], u[E]), M = b(_, x, w, S, A, e[l[E]], h[0], c[E])) : E < 32 ? (T = g(n, r, i, o, f, e[s[E]], d[1], u[E]), M = y(_, x, w, S, A, e[l[E]], h[1], c[E])) : E < 48 ? (T = v(n, r, i, o, f, e[s[E]], d[2], u[E]), M = v(_, x, w, S, A, e[l[E]], h[2], c[E])) : E < 64 ? (T = y(n, r, i, o, f, e[s[E]], d[3], u[E]), M = g(_, x, w, S, A, e[l[E]], h[3], c[E])) : (T = b(n, r, i, o, f, e[s[E]], d[4], u[E]), M = m(_, x, w, S, A, e[l[E]], h[4], c[E])), n = f, f = o, o = p(i, 10), i = r, r = T, _ = A, A = S, S = p(w, 10), w = x, x = M;
        }
        var C = this._b + i + S | 0;
        this._b = this._c + o + A | 0, this._c = this._d + f + _ | 0, this._d = this._e + n + x | 0, this._e = this._a + r + w | 0, this._a = C;
      }, f.prototype._digest = function () {
        this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
        var e = r.alloc ? r.alloc(20) : new r(20);
        return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
      }, e.exports = f;
    },
    "./node_modules/safe-buffer/index.js": function node_modulesSafeBufferIndexJs(e, t, n) {
      var r = n("./node_modules/buffer/index.js"),
        i = r.Buffer;
      function o(e, t) {
        for (var n in e) t[n] = e[n];
      }
      function a(e, t, n) {
        return i(e, t, n);
      }
      i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = r : (o(r, t), t.Buffer = a), a.prototype = Object.create(i.prototype), o(i, a), a.from = function (e, t, n) {
        if ("number" == typeof e) throw new TypeError("Argument must not be a number");
        return i(e, t, n);
      }, a.alloc = function (e, t, n) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        var r = i(e);
        return void 0 !== t ? "string" == typeof n ? r.fill(t, n) : r.fill(t) : r.fill(0), r;
      }, a.allocUnsafe = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return i(e);
      }, a.allocUnsafeSlow = function (e) {
        if ("number" != typeof e) throw new TypeError("Argument must be a number");
        return r.SlowBuffer(e);
      };
    },
    "./node_modules/semantic-ui-react/dist/es/index.js": function node_modulesSemanticUiReactDistEsIndexJs(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "Ref", function () {
        return S;
      }), n.d(t, "Confirm", function () {
        return Vr;
      }), n.d(t, "MountNode", function () {
        return kr;
      }), n.d(t, "Pagination", function () {
        return di;
      }), n.d(t, "PaginationItem", function () {
        return ci;
      }), n.d(t, "Portal", function () {
        return En;
      }), n.d(t, "PortalInner", function () {
        return Sn;
      }), n.d(t, "Radio", function () {
        return yi;
      }), n.d(t, "Responsive", function () {
        return _i;
      }), n.d(t, "Select", function () {
        return io;
      }), n.d(t, "TextArea", function () {
        return ao;
      }), n.d(t, "TransitionablePortal", function () {
        return bo;
      }), n.d(t, "Visibility", function () {
        return _o;
      }), n.d(t, "Breadcrumb", function () {
        return Eo;
      }), n.d(t, "BreadcrumbDivider", function () {
        return wo;
      }), n.d(t, "BreadcrumbSection", function () {
        return So;
      }), n.d(t, "Form", function () {
        return $o;
      }), n.d(t, "FormButton", function () {
        return ko;
      }), n.d(t, "FormCheckbox", function () {
        return Oo;
      }), n.d(t, "FormDropdown", function () {
        return Io;
      }), n.d(t, "FormField", function () {
        return Mo;
      }), n.d(t, "FormGroup", function () {
        return No;
      }), n.d(t, "FormInput", function () {
        return Fo;
      }), n.d(t, "FormRadio", function () {
        return Uo;
      }), n.d(t, "FormSelect", function () {
        return Vo;
      }), n.d(t, "FormTextArea", function () {
        return qo;
      }), n.d(t, "Grid", function () {
        return Jo;
      }), n.d(t, "GridColumn", function () {
        return Yo;
      }), n.d(t, "GridRow", function () {
        return Zo;
      }), n.d(t, "Menu", function () {
        return li;
      }), n.d(t, "MenuHeader", function () {
        return ti;
      }), n.d(t, "MenuItem", function () {
        return ii;
      }), n.d(t, "MenuMenu", function () {
        return ai;
      }), n.d(t, "Message", function () {
        return la;
      }), n.d(t, "MessageContent", function () {
        return ta;
      }), n.d(t, "MessageHeader", function () {
        return ra;
      }), n.d(t, "MessageItem", function () {
        return oa;
      }), n.d(t, "MessageList", function () {
        return sa;
      }), n.d(t, "Table", function () {
        return wa;
      }), n.d(t, "TableBody", function () {
        return ca;
      }), n.d(t, "TableCell", function () {
        return ha;
      }), n.d(t, "TableFooter", function () {
        return ga;
      }), n.d(t, "TableHeader", function () {
        return pa;
      }), n.d(t, "TableHeaderCell", function () {
        return ya;
      }), n.d(t, "TableRow", function () {
        return _a;
      }), n.d(t, "Button", function () {
        return Xn;
      }), n.d(t, "ButtonContent", function () {
        return zn;
      }), n.d(t, "ButtonGroup", function () {
        return Hn;
      }), n.d(t, "ButtonOr", function () {
        return Wn;
      }), n.d(t, "Container", function () {
        return Aa;
      }), n.d(t, "Divider", function () {
        return Ta;
      }), n.d(t, "Flag", function () {
        return Wi;
      }), n.d(t, "Header", function () {
        return Ra;
      }), n.d(t, "HeaderContent", function () {
        return Pa;
      }), n.d(t, "HeaderSubheader", function () {
        return Ca;
      }), n.d(t, "Icon", function () {
        return Ut;
      }), n.d(t, "IconGroup", function () {
        return Ft;
      }), n.d(t, "Image", function () {
        return In;
      }), n.d(t, "ImageGroup", function () {
        return On;
      }), n.d(t, "Input", function () {
        return Do;
      }), n.d(t, "Label", function () {
        return Bn;
      }), n.d(t, "LabelDetail", function () {
        return Nn;
      }), n.d(t, "LabelGroup", function () {
        return Dn;
      }), n.d(t, "List", function () {
        return Wa;
      }), n.d(t, "ListContent", function () {
        return Ba;
      }), n.d(t, "ListDescription", function () {
        return ja;
      }), n.d(t, "ListHeader", function () {
        return La;
      }), n.d(t, "ListIcon", function () {
        return za;
      }), n.d(t, "ListItem", function () {
        return Ga;
      }), n.d(t, "ListList", function () {
        return Ha;
      }), n.d(t, "Loader", function () {
        return Xa;
      }), n.d(t, "Placeholder", function () {
        return is;
      }), n.d(t, "PlaceholderHeader", function () {
        return Ka;
      }), n.d(t, "PlaceholderImage", function () {
        return Qa;
      }), n.d(t, "PlaceholderLine", function () {
        return es;
      }), n.d(t, "PlaceholderParagraph", function () {
        return ns;
      }), n.d(t, "Rail", function () {
        return as;
      }), n.d(t, "Reveal", function () {
        return cs;
      }), n.d(t, "RevealContent", function () {
        return ls;
      }), n.d(t, "Segment", function () {
        return gs;
      }), n.d(t, "SegmentGroup", function () {
        return hs;
      }), n.d(t, "SegmentInline", function () {
        return ps;
      }), n.d(t, "Step", function () {
        return Ts;
      }), n.d(t, "StepContent", function () {
        return ws;
      }), n.d(t, "StepDescription", function () {
        return ys;
      }), n.d(t, "StepGroup", function () {
        return As;
      }), n.d(t, "StepTitle", function () {
        return _s;
      }), n.d(t, "Accordion", function () {
        return js;
      }), n.d(t, "AccordionAccordion", function () {
        return Rs;
      }), n.d(t, "AccordionContent", function () {
        return ks;
      }), n.d(t, "AccordionPanel", function () {
        return Os;
      }), n.d(t, "AccordionTitle", function () {
        return Ms;
      }), n.d(t, "Checkbox", function () {
        return gi;
      }), n.d(t, "Dimmer", function () {
        return kn;
      }), n.d(t, "DimmerDimmable", function () {
        return Mn;
      }), n.d(t, "DimmerInner", function () {
        return Cn;
      }), n.d(t, "Dropdown", function () {
        return no;
      }), n.d(t, "DropdownDivider", function () {
        return Hi;
      }), n.d(t, "DropdownHeader", function () {
        return Ki;
      }), n.d(t, "DropdownItem", function () {
        return Xi;
      }), n.d(t, "DropdownMenu", function () {
        return Qi;
      }), n.d(t, "DropdownSearchInput", function () {
        return eo;
      }), n.d(t, "Embed", function () {
        return Ns;
      }), n.d(t, "Modal", function () {
        return Ur;
      }), n.d(t, "ModalActions", function () {
        return jr;
      }), n.d(t, "ModalContent", function () {
        return Ir;
      }), n.d(t, "ModalDescription", function () {
        return Lr;
      }), n.d(t, "ModalHeader", function () {
        return Or;
      }), n.d(t, "Popup", function () {
        return cl;
      }), n.d(t, "PopupContent", function () {
        return ll;
      }), n.d(t, "PopupHeader", function () {
        return ul;
      }), n.d(t, "Progress", function () {
        return gl;
      }), n.d(t, "Rating", function () {
        return _l;
      }), n.d(t, "RatingIcon", function () {
        return bl;
      }), n.d(t, "Search", function () {
        return Il;
      }), n.d(t, "SearchCategory", function () {
        return Cl;
      }), n.d(t, "SearchResult", function () {
        return Pl;
      }), n.d(t, "SearchResults", function () {
        return Rl;
      }), n.d(t, "Sidebar", function () {
        return Ul;
      }), n.d(t, "SidebarPushable", function () {
        return Dl;
      }), n.d(t, "SidebarPusher", function () {
        return Fl;
      }), n.d(t, "Sticky", function () {
        return Gl;
      }), n.d(t, "Tab", function () {
        return Wl;
      }), n.d(t, "TabPane", function () {
        return Hl;
      }), n.d(t, "Transition", function () {
        return yo;
      }), n.d(t, "TransitionGroup", function () {
        return go;
      }), n.d(t, "Advertisement", function () {
        return Xl;
      }), n.d(t, "Card", function () {
        return ou;
      }), n.d(t, "CardContent", function () {
        return nu;
      }), n.d(t, "CardDescription", function () {
        return Kl;
      }), n.d(t, "CardGroup", function () {
        return iu;
      }), n.d(t, "CardHeader", function () {
        return Ql;
      }), n.d(t, "CardMeta", function () {
        return eu;
      }), n.d(t, "Comment", function () {
        return Su;
      }), n.d(t, "CommentAction", function () {
        return su;
      }), n.d(t, "CommentActions", function () {
        return uu;
      }), n.d(t, "CommentAuthor", function () {
        return du;
      }), n.d(t, "CommentAvatar", function () {
        return fu;
      }), n.d(t, "CommentContent", function () {
        return mu;
      }), n.d(t, "CommentGroup", function () {
        return vu;
      }), n.d(t, "CommentMetadata", function () {
        return bu;
      }), n.d(t, "CommentText", function () {
        return xu;
      }), n.d(t, "Feed", function () {
        return Vu;
      }), n.d(t, "FeedContent", function () {
        return Du;
      }), n.d(t, "FeedDate", function () {
        return Eu;
      }), n.d(t, "FeedEvent", function () {
        return Uu;
      }), n.d(t, "FeedExtra", function () {
        return Mu;
      }), n.d(t, "FeedLabel", function () {
        return Fu;
      }), n.d(t, "FeedLike", function () {
        return ku;
      }), n.d(t, "FeedMeta", function () {
        return Ou;
      }), n.d(t, "FeedSummary", function () {
        return Nu;
      }), n.d(t, "FeedUser", function () {
        return Iu;
      }), n.d(t, "Item", function () {
        return oc;
      }), n.d(t, "ItemContent", function () {
        return Ju;
      }), n.d(t, "ItemDescription", function () {
        return $u;
      }), n.d(t, "ItemExtra", function () {
        return Yu;
      }), n.d(t, "ItemGroup", function () {
        return tc;
      }), n.d(t, "ItemHeader", function () {
        return qu;
      }), n.d(t, "ItemImage", function () {
        return rc;
      }), n.d(t, "ItemMeta", function () {
        return Zu;
      }), n.d(t, "Statistic", function () {
        return fc;
      }), n.d(t, "StatisticGroup", function () {
        return sc;
      }), n.d(t, "StatisticLabel", function () {
        return uc;
      }), n.d(t, "StatisticValue", function () {
        return dc;
      });
      var r = {};
      n.r(r), n.d(r, "someByType", function () {
        return te;
      }), n.d(r, "findByType", function () {
        return ne;
      }), n.d(r, "isNil", function () {
        return re;
      });
      var i = {};
      n.r(i), n.d(i, "COLORS", function () {
        return pe;
      }), n.d(i, "FLOATS", function () {
        return me;
      }), n.d(i, "SIZES", function () {
        return ge;
      }), n.d(i, "TEXT_ALIGNMENTS", function () {
        return ve;
      }), n.d(i, "VERTICAL_ALIGNMENTS", function () {
        return ye;
      }), n.d(i, "VISIBILITY", function () {
        return be;
      }), n.d(i, "WIDTHS", function () {
        return _e;
      }), n.d(i, "DIRECTIONAL_TRANSITIONS", function () {
        return xe;
      }), n.d(i, "STATIC_TRANSITIONS", function () {
        return we;
      }), n.d(i, "TRANSITIONS", function () {
        return Se;
      }), n.d(i, "ACCESSIBILITY", function () {
        return Ae;
      }), n.d(i, "ARROWS", function () {
        return Ee;
      }), n.d(i, "AUDIO_VIDEO", function () {
        return Te;
      }), n.d(i, "BUSINESS", function () {
        return Me;
      }), n.d(i, "CHESS", function () {
        return Ce;
      }), n.d(i, "CODE", function () {
        return ke;
      }), n.d(i, "COMMUNICATION", function () {
        return Pe;
      }), n.d(i, "COMPUTERS", function () {
        return Oe;
      }), n.d(i, "CURRENCY", function () {
        return Re;
      }), n.d(i, "DATE_TIME", function () {
        return Ie;
      }), n.d(i, "DESIGN", function () {
        return je;
      }), n.d(i, "EDITORS", function () {
        return Ne;
      }), n.d(i, "FILES", function () {
        return Le;
      }), n.d(i, "GENDERS", function () {
        return De;
      }), n.d(i, "HANDS_GESTURES", function () {
        return Be;
      }), n.d(i, "HEALTH", function () {
        return Fe;
      }), n.d(i, "IMAGES", function () {
        return ze;
      }), n.d(i, "INTERFACES", function () {
        return Ue;
      }), n.d(i, "LOGISTICS", function () {
        return Ge;
      }), n.d(i, "MAPS", function () {
        return Ve;
      }), n.d(i, "MEDICAL", function () {
        return He;
      }), n.d(i, "OBJECTS", function () {
        return qe;
      }), n.d(i, "PAYMENTS_SHOPPING", function () {
        return We;
      }), n.d(i, "SHAPES", function () {
        return $e;
      }), n.d(i, "SPINNERS", function () {
        return Xe;
      }), n.d(i, "SPORTS", function () {
        return Ye;
      }), n.d(i, "STATUS", function () {
        return Ke;
      }), n.d(i, "USERS_PEOPLE", function () {
        return Ze;
      }), n.d(i, "VEHICLES", function () {
        return Qe;
      }), n.d(i, "WRITING", function () {
        return Je;
      }), n.d(i, "BRANDS", function () {
        return et;
      }), n.d(i, "ICONS", function () {
        return tt;
      }), n.d(i, "ICON_ALIASES", function () {
        return nt;
      }), n.d(i, "ICONS_AND_ALIASES", function () {
        return rt;
      }), n.d(i, "COMPONENT_CONTEXT_SPECIFIC_ICONS", function () {
        return it;
      }), n.d(i, "ALL_ICONS_IN_ALL_CONTEXTS", function () {
        return ot;
      });
      n("./node_modules/prop-types/index.js");
      var o = n("react"),
        a = n.n(o),
        s = n("./node_modules/react-is/index.js");
      function l(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function u(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function c(e, t, n) {
        return t && u(e.prototype, t), n && u(e, n), e;
      }
      function d(e) {
        return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function h(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function f(e, t) {
        return !t || "object" !== d(t) && "function" != typeof t ? h(e) : t;
      }
      function p(e) {
        return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function m(e, t) {
        return (m = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function g(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && m(e, t);
      }
      function v(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      var y = n("react-dom"),
        b = function b(e, t) {
          "function" != typeof e ? null !== e && "object" === d(e) && (e.current = t) : e(t);
        },
        _ = function (e) {
          function t() {
            var e, n;
            l(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return v(h(n = f(this, (e = p(t)).call.apply(e, [this].concat(i)))), "prevNode", null), n;
          }
          return g(t, e), c(t, [{
            key: "componentDidMount",
            value: function value() {
              this.prevNode = y.findDOMNode(this), b(this.props.innerRef, this.prevNode);
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              var t = y.findDOMNode(this);
              this.prevNode !== t && (this.prevNode = t, b(this.props.innerRef, t)), e.innerRef !== this.props.innerRef && b(this.props.innerRef, t);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              b(this.props.innerRef, null);
            }
          }, {
            key: "render",
            value: function value() {
              return this.props.children;
            }
          }]), t;
        }(o.Component);
      v(_, "displayName", "RefFindNode"), v(_, "propTypes", {});
      var x = function (e) {
        function t() {
          var e, n;
          l(this, t);
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
          return v(h(n = f(this, (e = p(t)).call.apply(e, [this].concat(i)))), "handleRefOverride", function (e) {
            var t = n.props,
              r = t.children,
              i = t.innerRef;
            b(r.ref, e), b(i, e);
          }), n;
        }
        return g(t, e), c(t, [{
          key: "render",
          value: function value() {
            var e = this.props.children;
            return o.cloneElement(e, {
              ref: this.handleRefOverride
            });
          }
        }]), t;
      }(o.Component);
      v(x, "displayName", "RefForward"), v(x, "propTypes", {});
      var w = function w(e) {
        var t = e.children,
          n = e.innerRef,
          r = o.Children.only(t),
          i = s.isForwardRef(r) ? x : _;
        return o.createElement(i, {
          innerRef: n
        }, r);
      };
      w.displayName = "Ref";
      var S = w,
        A = n("./node_modules/@babel/runtime/helpers/extends.js"),
        E = n.n(A),
        T = n("./node_modules/@babel/runtime/helpers/classCallCheck.js"),
        M = n.n(T),
        C = n("./node_modules/@babel/runtime/helpers/createClass.js"),
        k = n.n(C),
        P = n("./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js"),
        O = n.n(P),
        R = n("./node_modules/@babel/runtime/helpers/getPrototypeOf.js"),
        I = n.n(R),
        j = n("./node_modules/@babel/runtime/helpers/assertThisInitialized.js"),
        N = n.n(j),
        L = n("./node_modules/@babel/runtime/helpers/inherits.js"),
        D = n.n(L),
        B = n("./node_modules/@babel/runtime/helpers/defineProperty.js"),
        F = n.n(B),
        z = n("./node_modules/lodash/has.js"),
        U = n.n(z),
        G = n("./node_modules/lodash/invoke.js"),
        V = n.n(G),
        H = function H(e, t) {
          var n = e.handledProps,
            r = void 0 === n ? [] : n;
          return Object.keys(t).reduce(function (e, n) {
            return "childKey" === n || -1 === r.indexOf(n) && (e[n] = t[n]), e;
          }, {});
        },
        q = n("./node_modules/@babel/runtime/helpers/toConsumableArray.js"),
        W = n.n(q),
        $ = n("./node_modules/lodash/isNil.js"),
        X = n.n($),
        Y = n("./node_modules/classnames/index.js"),
        K = n.n(Y),
        Z = n("./node_modules/lodash/find.js"),
        Q = n.n(Z),
        J = n("./node_modules/lodash/some.js"),
        ee = n.n(J),
        te = function te(e, t) {
          return ee()(o.Children.toArray(e), {
            type: t
          });
        },
        ne = function ne(e, t) {
          return Q()(o.Children.toArray(e), {
            type: t
          });
        },
        re = function re(e) {
          return null == e || Array.isArray(e) && 0 === e.length;
        },
        ie = n("./node_modules/lodash/uniq.js"),
        oe = n.n(ie),
        ae = n("./node_modules/lodash/values.js"),
        se = n.n(ae),
        le = n("./node_modules/lodash/keys.js"),
        ue = n.n(le),
        ce = n("./node_modules/@babel/runtime/helpers/typeof.js"),
        de = n.n(ce),
        he = {
          1: "one",
          2: "two",
          3: "three",
          4: "four",
          5: "five",
          6: "six",
          7: "seven",
          8: "eight",
          9: "nine",
          10: "ten",
          11: "eleven",
          12: "twelve",
          13: "thirteen",
          14: "fourteen",
          15: "fifteen",
          16: "sixteen"
        };
      function fe(e) {
        var t = de()(e);
        return "string" === t || "number" === t ? he[e] || e : "";
      }
      var pe = ["red", "orange", "yellow", "olive", "green", "teal", "blue", "violet", "purple", "pink", "brown", "grey", "black"],
        me = ["left", "right"],
        ge = ["mini", "tiny", "small", "medium", "large", "big", "huge", "massive"],
        ve = ["left", "center", "right", "justified"],
        ye = ["bottom", "middle", "top"],
        be = ["mobile", "tablet", "computer", "large screen", "widescreen"],
        _e = [].concat(W()(ue()(he)), W()(ue()(he).map(Number)), W()(se()(he))),
        xe = ["browse", "browse right", "drop", "fade", "fade up", "fade down", "fade left", "fade right", "fly up", "fly down", "fly left", "fly right", "horizontal flip", "vertical flip", "scale", "slide up", "slide down", "slide left", "slide right", "swing up", "swing down", "swing left", "swing right", "zoom"],
        we = ["jiggle", "flash", "shake", "pulse", "tada", "bounce", "glow"],
        Se = [].concat(xe, we),
        Ae = ["american sign language interpreting", "assistive listening systems", "audio description", "blind", "braille", "closed captioning", "closed captioning outline", "deaf", "low vision", "phone volume", "question circle", "question circle outline", "sign language", "tty", "universal access", "wheelchair"],
        Ee = ["angle double down", "angle double left", "angle double right", "angle double up", "angle down", "angle left", "angle right", "angle up", "arrow alternate circle down", "arrow alternate circle down outline", "arrow alternate circle left", "arrow alternate circle left outline", "arrow alternate circle right", "arrow alternate circle right outline", "arrow alternate circle up", "arrow alternate circle up outline", "arrow circle down", "arrow circle left", "arrow circle right", "arrow circle up", "arrow down", "arrow left", "arrow right", "arrow up", "arrows alternate", "arrows alternate horizontal", "arrows alternate vertical", "caret down", "caret left", "caret right", "caret square down", "caret square down outline", "caret square left", "caret square left outline", "caret square right", "caret square right outline", "caret square up", "caret square up outline", "caret up", "cart arrow down", "chart line", "chevron circle down", "chevron circle left", "chevron circle right", "chevron circle up", "chevron down", "chevron left", "chevron right", "chevron up", "cloud download", "cloud upload", "download", "exchange", "expand arrows alternate", "external alternate", "external square alternate", "hand point down", "hand point down outline", "hand point left", "hand point left outline", "hand point right", "hand point right outline", "hand point up", "hand point up outline", "hand pointer", "hand pointer outline", "history", "level down alternate", "level up alternate", "location arrow", "long arrow alternate down", "long arrow alternate left", "long arrow alternate right", "long arrow alternate up", "mouse pointer", "play", "random", "recycle", "redo", "redo alternate", "reply", "reply all", "retweet", "share", "share square", "share square outline", "sign-in", "sign-out", "sign-in alternate", "sign-out alternate", "sort", "sort alphabet down", "sort alphabet up", "sort amount down", "sort amount up", "sort down", "sort numeric down", "sort numeric up", "sort up", "sync", "sync alternate", "text height", "text width", "undo", "undo alternate", "upload", "zoom-in", "zoom-out"],
        Te = ["audio description", "backward", "circle", "circle outline", "closed captioning", "closed captioning outline", "compress", "eject", "expand", "expand arrows alternate", "fast backward", "fast forward", "file audio", "file audio outline", "file video", "file video outline", "film", "forward", "headphones", "microphone", "microphone slash", "music", "pause", "pause circle", "pause circle outline", "phone volume", "play", "play circle", "play circle outline", "podcast", "random", "redo", "redo alternate", "rss", "rss square", "step backward", "step forward", "stop", "stop circle", "stop circle outline", "sync", "sync alternate", "undo", "undo alternate", "video", "volume down", "volume off", "volume up"],
        Me = ["address book", "address book outline", "address card", "address card outline", "archive", "balance scale", "birthday cake", "book", "briefcase", "building", "building outline", "bullhorn", "bullseye", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "certificate", "chart area", "chart bar", "chart bar outline", "chart line", "chart pie", "clipboard", "clipboard outline", "coffee", "columns", "compass", "compass outline", "copy", "copy outline", "copyright", "copyright outline", "cut", "edit", "edit outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "envelope square", "eraser", "fax", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "globe", "industry", "paperclip", "paste", "pen square", "pencil alternate", "percent", "phone", "phone square", "phone volume", "registered", "registered outline", "save", "save outline", "sitemap", "sticky note", "sticky note outline", "suitcase", "table", "tag", "tags", "tasks", "thumbtack", "trademark"],
        Ce = ["chess", "chess bishop", "chess board", "chess king", "chess knight", "chess pawn", "chess queen", "chess rook", "square full"],
        ke = ["archive", "barcode", "bath", "bug", "code", "code branch", "coffee", "file", "file outline", "file alternate", "file alternate outline", "file code", "file code outline", "filter", "fire extinguisher", "folder", "folder outline", "folder open", "folder open outline", "keyboard", "keyboard outline", "microchip", "qrcode", "shield alternate", "sitemap", "terminal", "user secret", "window close", "window close outline", "window maximize", "window maximize outline", "window minimize", "window minimize outline", "window restore", "window restore outline"],
        Pe = ["address book", "address book outline", "address card", "address card outline", "american sign language interpreting", "assistive listening systems", "at", "bell", "bell outline", "bell slash", "bell slash outline", "bullhorn", "comment", "comment outline", "comment alternate", "comment alternate outline", "comments", "comments outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "envelope square", "fax", "inbox", "language", "microphone", "microphone slash", "mobile", "mobile alternate", "paper plane", "paper plane outline", "phone", "phone square", "phone volume", "rss", "rss square", "tty", "wifi"],
        Oe = ["desktop", "download", "hdd", "hdd outline", "headphones", "keyboard", "keyboard outline", "laptop", "microchip", "mobile", "mobile alternate", "plug", "power off", "print", "save", "save outline", "server", "tablet", "tablet alternate", "tv", "upload"],
        Re = ["dollar sign", "euro sign", "lira sign", "money bill alternate", "money bill alternate outline", "pound sign", "ruble sign", "rupee sign", "shekel sign", "won sign", "yen sign"],
        Ie = ["bell", "bell outline", "bell slash", "bell slash outline", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "clock", "clock outline", "hourglass", "hourglass outline", "hourglass end", "hourglass half", "hourglass start", "stopwatch"],
        je = ["adjust", "clone", "clone outline", "copy", "copy outline", "crop", "crosshairs", "cut", "edit", "edit outline", "eraser", "eye", "eye dropper", "eye slash", "eye slash outline", "object group", "object group outline", "object ungroup", "object ungroup outline", "paint brush", "paste", "pencil alternate", "save", "save outline", "tint"],
        Ne = ["align center", "align justify", "align left", "align right", "bold", "clipboard", "clipboard outline", "clone", "clone outline", "columns", "copy", "copy outline", "cut", "edit", "edit outline", "eraser", "file", "file outline", "file alternate", "file alternate outline", "font", "heading", "i cursor", "indent", "italic", "linkify", "list", "list alternate", "list alternate outline", "list ol", "list ul", "outdent", "paper plane", "paper plane outline", "paperclip", "paragraph", "paste", "pencil alternate", "print", "quote left", "quote right", "redo", "redo alternate", "reply", "reply all", "share", "strikethrough", "subscript", "superscript", "sync", "sync alternate", "table", "tasks", "text height", "text width", "th", "th large", "th list", "trash", "trash alternate", "trash alternate outline", "underline", "undo", "undo alternate", "unlink"],
        Le = ["archive", "clone", "clone outline", "copy", "copy outline", "cut", "file", "file outline", "file alternate", "file alternate outline", "file archive", "file archive outline", "file audio", "file audio outline", "file code", "file code outline", "file excel", "file excel outline", "file image", "file image outline", "file pdf", "file pdf outline", "file powerpoint", "file powerpoint outline", "file video", "file video outline", "file word", "file word outline", "folder", "folder outline", "folder open", "folder open outline", "paste", "save", "save outline", "sticky note", "sticky note outline"],
        De = ["genderless", "mars", "mars double", "mars stroke", "mars stroke horizontal", "mars stroke vertical", "mercury", "neuter", "transgender", "transgender alternate", "venus", "venus double", "venus mars"],
        Be = ["hand lizard", "hand lizard outline", "hand paper", "hand paper outline", "hand peace", "hand peace outline", "hand point down", "hand point down outline", "hand point left", "hand point left outline", "hand point right", "hand point right outline", "hand point up", "hand point up outline", "hand pointer", "hand pointer outline", "hand rock", "hand rock outline", "hand scissors", "hand scissors outline", "hand spock", "hand spock outline", "handshake", "handshake outline", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline"],
        Fe = ["ambulance", "h square", "heart", "heart outline", "heartbeat", "hospital", "hospital outline", "medkit", "plus square", "plus square outline", "stethoscope", "user md", "wheelchair"],
        ze = ["adjust", "bolt", "camera", "camera retro", "clone", "clone outline", "compress", "expand", "eye", "eye dropper", "eye slash", "eye slash outline", "file image", "file image outline", "film", "id badge", "id badge outline", "id card", "id card outline", "image", "image outline", "images", "images outline", "sliders horizontal", "tint"],
        Ue = ["ban", "barcode", "bars", "beer", "bell", "bell outline", "bell slash", "bell slash outline", "bug", "bullhorn", "bullseye", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "certificate", "check", "check circle", "check circle outline", "check square", "check square outline", "circle", "circle outline", "clipboard", "clipboard outline", "clone", "clone outline", "cloud", "cloud download", "cloud upload", "coffee", "cog", "cogs", "copy", "copy outline", "cut", "database", "dot circle", "dot circle outline", "download", "edit", "edit outline", "ellipsis horizontal", "ellipsis vertical", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "exclamation", "exclamation circle", "exclamation triangle", "external alternate", "external square alternate", "eye", "eye slash", "eye slash outline", "file", "file outline", "file alternate", "file alternate outline", "filter", "flag", "flag outline", "flag checkered", "folder", "folder outline", "folder open", "folder open outline", "frown", "frown outline", "hashtag", "heart", "heart outline", "history", "home", "i cursor", "info", "info circle", "language", "magic", "meh", "meh outline", "microphone", "microphone slash", "minus", "minus circle", "minus square", "minus square outline", "paste", "pencil alternate", "plus", "plus circle", "plus square", "plus square outline", "qrcode", "question", "question circle", "question circle outline", "quote left", "quote right", "redo", "redo alternate", "reply", "reply all", "rss", "rss square", "save", "save outline", "search", "search minus", "search plus", "share", "share alternate", "share alternate square", "share square", "share square outline", "shield alternate", "sign-in", "sign-out", "signal", "sitemap", "sliders horizontal", "smile", "smile outline", "sort", "sort alphabet down", "sort alphabet up", "sort amount down", "sort amount up", "sort down", "sort numeric down", "sort numeric up", "sort up", "star", "star outline", "star half", "star half outline", "sync", "sync alternate", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "times", "times circle", "times circle outline", "toggle off", "toggle on", "trash", "trash alternate", "trash alternate outline", "trophy", "undo", "undo alternate", "upload", "user", "user outline", "user circle", "user circle outline", "wifi"],
        Ge = ["box", "boxes", "clipboard check", "clipboard list", "dolly", "dolly flatbed", "pallet", "shipping fast", "truck", "warehouse"],
        Ve = ["ambulance", "anchor", "balance scale", "bath", "bed", "beer", "bell", "bell outline", "bell slash", "bell slash outline", "bicycle", "binoculars", "birthday cake", "blind", "bomb", "book", "bookmark", "bookmark outline", "briefcase", "building", "building outline", "car", "coffee", "crosshairs", "dollar sign", "eye", "eye slash", "eye slash outline", "fighter jet", "fire", "fire extinguisher", "flag", "flag outline", "flag checkered", "flask", "gamepad", "gavel", "gift", "glass martini", "globe", "graduation cap", "h square", "heart", "heart outline", "heartbeat", "home", "hospital", "hospital outline", "image", "image outline", "images", "images outline", "industry", "info", "info circle", "key", "leaf", "lemon", "lemon outline", "life ring", "life ring outline", "lightbulb", "lightbulb outline", "location arrow", "low vision", "magnet", "male", "map", "map outline", "map marker", "map marker alternate", "map pin", "map signs", "medkit", "money bill alternate", "money bill alternate outline", "motorcycle", "music", "newspaper", "newspaper outline", "paw", "phone", "phone square", "phone volume", "plane", "plug", "plus", "plus square", "plus square outline", "print", "recycle", "road", "rocket", "search", "search minus", "search plus", "ship", "shopping bag", "shopping basket", "shopping cart", "shower", "street view", "subway", "suitcase", "tag", "tags", "taxi", "thumbtack", "ticket alternate", "tint", "train", "tree", "trophy", "truck", "tty", "umbrella", "university", "utensil spoon", "utensils", "wheelchair", "wifi", "wrench"],
        He = ["ambulance", "band aid", "dna", "first aid", "heart", "heart outline", "heartbeat", "hospital", "hospital outline", "hospital symbol", "pills", "plus", "stethoscope", "syringe", "thermometer", "user md", "weight"],
        qe = ["ambulance", "anchor", "archive", "balance scale", "bath", "bed", "beer", "bell", "bell outline", "bicycle", "binoculars", "birthday cake", "bomb", "book", "bookmark", "bookmark outline", "briefcase", "bug", "building", "building outline", "bullhorn", "bullseye", "bus", "calculator", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "camera", "camera retro", "car", "clipboard", "clipboard outline", "cloud", "coffee", "cog", "cogs", "compass", "compass outline", "copy", "copy outline", "cube", "cubes", "cut", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "eye", "eye dropper", "fax", "fighter jet", "file", "file outline", "file alternate", "file alternate outline", "film", "fire", "fire extinguisher", "flag", "flag outline", "flag checkered", "flask", "futbol", "futbol outline", "gamepad", "gavel", "gem", "gem outline", "gift", "glass martini", "globe", "graduation cap", "hdd", "hdd outline", "headphones", "heart", "heart outline", "home", "hospital", "hospital outline", "hourglass", "hourglass outline", "image", "image outline", "images", "images outline", "industry", "key", "keyboard", "keyboard outline", "laptop", "leaf", "lemon", "lemon outline", "life ring", "life ring outline", "lightbulb", "lightbulb outline", "lock", "lock open", "magic", "magnet", "map", "map outline", "map marker", "map marker alternate", "map pin", "map signs", "medkit", "microchip", "microphone", "mobile", "mobile alternate", "money bill alternate", "money bill alternate outline", "moon", "moon outline", "motorcycle", "newspaper", "newspaper outline", "paint brush", "paper plane", "paper plane outline", "paperclip", "paste", "paw", "pencil alternate", "phone", "plane", "plug", "print", "puzzle piece", "road", "rocket", "save", "save outline", "search", "shield alternate", "shopping bag", "shopping basket", "shopping cart", "shower", "snowflake", "snowflake outline", "space shuttle", "star", "star outline", "sticky note", "sticky note outline", "stopwatch", "subway", "suitcase", "sun", "sun outline", "tablet", "tablet alternate", "tachometer alternate", "tag", "tags", "taxi", "thumbtack", "ticket alternate", "train", "trash", "trash alternate", "trash alternate outline", "tree", "trophy", "truck", "tv", "umbrella", "university", "unlock", "unlock alternate", "utensil spoon", "utensils", "wheelchair", "wrench"],
        We = ["bell", "bell outline", "bookmark", "bookmark outline", "bullhorn", "camera", "camera retro", "cart arrow down", "cart plus", "certificate", "credit card", "credit card outline", "gem", "gem outline", "gift", "handshake", "handshake outline", "heart", "heart outline", "key", "shopping bag", "shopping basket", "shopping cart", "star", "star outline", "tag", "tags", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "trophy"],
        $e = ["bookmark", "bookmark outline", "calendar", "calendar outline", "certificate", "circle", "circle outline", "cloud", "comment", "comment outline", "file", "file outline", "folder", "folder outline", "heart", "heart outline", "map marker", "play", "square", "square outline", "star", "star outline"],
        Xe = ["asterisk", "certificate", "circle notch", "cog", "compass", "compass outline", "crosshairs", "life ring", "life ring outline", "snowflake", "snowflake outline", "spinner", "sun", "sun outline", "sync"],
        Ye = ["baseball ball", "basketball ball", "bowling ball", "football ball", "futbol", "futbol outline", "golf ball", "hockey puck", "quidditch", "table tennis", "volleyball ball"],
        Ke = ["ban", "battery empty", "battery full", "battery half", "battery quarter", "battery three quarters", "bell", "bell outline", "bell slash", "bell slash outline", "calendar", "calendar outline", "calendar alternate", "calendar alternate outline", "calendar check", "calendar check outline", "calendar minus", "calendar minus outline", "calendar plus", "calendar plus outline", "calendar times", "calendar times outline", "cart arrow down", "cart plus", "exclamation", "exclamation circle", "exclamation triangle", "eye", "eye slash", "eye slash outline", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "info", "info circle", "lock", "lock open", "minus", "minus circle", "minus square", "minus square outline", "plus", "plus circle", "plus square", "plus square outline", "question", "question circle", "question circle outline", "shield alternate", "shopping cart", "sign in alternate", "sign out alternate", "thermometer empty", "thermometer full", "thermometer half", "thermometer quarter", "thermometer three quarters", "thumbs down", "thumbs down outline", "thumbs up", "thumbs up outline", "toggle off", "toggle on", "unlock", "unlock alternate"],
        Ze = ["address book", "address book outline", "address card", "address card outline", "bed", "blind", "child", "female", "frown", "frown outline", "id badge", "id badge outline", "id card", "id card outline", "male", "meh", "meh outline", "power off", "smile", "smile outline", "street view", "user", "user outline", "user circle", "user circle outline", "user md", "user plus", "user secret", "user times", "users", "wheelchair"],
        Qe = ["ambulance", "bicycle", "bus", "car", "fighter jet", "motorcycle", "paper plane", "paper plane outline", "plane", "rocket", "ship", "shopping cart", "space shuttle", "subway", "taxi", "train", "truck", "wheelchair"],
        Je = ["archive", "book", "bookmark", "bookmark outline", "edit", "edit outline", "envelope", "envelope outline", "envelope open", "envelope open outline", "eraser", "file", "file outline", "file alternate", "file alternate outline", "folder", "folder outline", "folder open", "folder open outline", "keyboard", "keyboard outline", "newspaper", "newspaper outline", "paper plane", "paper plane outline", "paperclip", "paragraph", "pen square", "pencil alternate", "quote left", "quote right", "sticky note", "sticky note outline", "thumbtack"],
        et = ["500px", "accessible", "accusoft", "adn", "adversal", "affiliatetheme", "algolia", "amazon", "amazon pay", "amilia", "android", "angellist", "angrycreative", "angular", "app store", "app store ios", "apper", "apple", "apple pay", "asymmetrik", "audible", "autoprefixer", "avianex", "aviato", "aws", "bandcamp", "behance", "behance square", "bimobject", "bitbucket", "bitcoin", "bity", "black tie", "blackberry", "blogger", "blogger b", "bluetooth", "bluetooth b", "btc", "buromobelexperte", "buysellads", "cc amazon pay", "cc amex", "cc apple pay", "cc diners club", "cc discover", "cc jcb", "cc mastercard", "cc paypal", "cc stripe", "cc visa", "centercode", "chrome", "cloudscale", "cloudsmith", "cloudversify", "codepen", "codiepie", "connectdevelop", "contao", "cpanel", "creative commons", "css3", "css3 alternate", "cuttlefish", "d and d", "dashcube", "delicious", "deploydog", "deskpro", "deviantart", "digg", "digital ocean", "discord", "discourse", "dochub", "docker", "draft2digital", "dribbble", "dribbble square", "dropbox", "drupal", "dyalog", "earlybirds", "edge", "elementor", "ember", "empire", "envira", "erlang", "ethereum", "etsy", "expeditedssl", "facebook", "facebook f", "facebook messenger", "facebook square", "firefox", "first order", "firstdraft", "flickr", "flipboard", "fly", "font awesome", "font awesome alternate", "font awesome flag", "fonticons", "fonticons fi", "fort awesome", "fort awesome alternate", "forumbee", "foursquare", "free code camp", "freebsd", "get pocket", "gg", "gg circle", "git", "git square", "github", "github alternate", "github square", "gitkraken", "gitlab", "gitter", "glide", "glide g", "gofore", "goodreads", "goodreads g", "google", "google drive", "google play", "google plus", "google plus g", "google plus square", "google wallet", "gratipay", "grav", "gripfire", "grunt", "gulp", "hacker news", "hacker news square", "hips", "hire a helper", "hooli", "hotjar", "houzz", "html5", "hubspot", "imdb", "instagram", "internet explorer", "ioxhost", "itunes", "itunes note", "jenkins", "joget", "joomla", "js", "js square", "jsfiddle", "keycdn", "kickstarter", "kickstarter k", "korvue", "laravel", "lastfm", "lastfm square", "leanpub", "less", "linechat", "linkedin", "linkedin alternate", "linode", "linux", "lyft", "magento", "maxcdn", "medapps", "medium", "medium m", "medrt", "meetup", "microsoft", "mix", "mixcloud", "mizuni", "modx", "monero", "napster", "nintendo switch", "node", "node js", "npm", "ns8", "nutritionix", "odnoklassniki", "odnoklassniki square", "opencart", "openid", "opera", "optin monster", "osi", "page4", "pagelines", "palfed", "patreon", "paypal", "periscope", "phabricator", "phoenix framework", "php", "pied piper", "pied piper alternate", "pied piper pp", "pinterest", "pinterest p", "pinterest square", "playstation", "product hunt", "pushed", "python", "qq", "quinscape", "quora", "ravelry", "react", "rebel", "redriver", "reddit", "reddit alien", "reddit square", "rendact", "renren", "replyd", "resolving", "rocketchat", "rockrms", "safari", "sass", "schlix", "scribd", "searchengin", "sellcast", "sellsy", "servicestack", "shirtsinbulk", "simplybuilt", "sistrix", "skyatlas", "skype", "slack", "slack hash", "slideshare", "snapchat", "snapchat ghost", "snapchat square", "soundcloud", "speakap", "spotify", "stack exchange", "stack overflow", "staylinked", "steam", "steam square", "steam symbol", "sticker mule", "strava", "stripe", "stripe s", "studiovinari", "stumbleupon", "stumbleupon circle", "superpowers", "supple", "telegram", "telegram plane", "tencent weibo", "themeisle", "trello", "tripadvisor", "tumblr", "tumblr square", "twitch", "twitter", "twitter square", "typo3", "uber", "uikit", "uniregistry", "untappd", "usb", "ussunnah", "vaadin", "viacoin", "viadeo", "viadeo square", "viber", "vimeo", "vimeo square", "vimeo v", "vine", "vk", "vnv", "vuejs", "wechat", "weibo", "weixin", "whatsapp", "whatsapp square", "whmcs", "wikipedia w", "windows", "wordpress", "wordpress simple", "wpbeginner", "wpexplorer", "wpforms", "xbox", "xing", "xing square", "y combinator", "yahoo", "yandex", "yandex international", "yelp", "yoast", "youtube", "youtube square"],
        tt = oe()([].concat(Ae, Ee, Te, Me, Ce, ke, Pe, Oe, Re, Ie, je, Ne, Le, De, Be, Fe, ze, Ue, Ge, Ve, He, qe, We, $e, Xe, Ye, Ke, Ze, Qe, Je, et)),
        nt = ["chess rock", "ordered list", "unordered list", "user doctor", "shield", "puzzle", "add circle", "add square", "add to calendar", "add to cart", "add user", "add", "alarm mute", "alarm", "ald", "als", "announcement", "area chart", "area graph", "arrow down cart", "asexual", "asl interpreting", "asl", "assistive listening devices", "attach", "attention", "balance", "bar", "bathtub", "battery four", "battery high", "battery low", "battery one", "battery three", "battery two", "battery zero", "birthday", "block layout", "bluetooth alternative", "broken chain", "browser", "call square", "call", "cancel", "cart", "cc", "chain", "chat", "checked calendar", "checkmark", "circle notched", "close", "cny", "cocktail", "commenting", "computer", "configure", "content", "deafness", "delete calendar", "delete", "detective", "discussions", "doctor", "dollar", "dont", "drivers license", "dropdown", "emergency", "envira gallery", "erase", "eur", "euro", "eyedropper", "factory", "favorite", "feed", "female homosexual", "file text", "file text outline", "find", "first aid", "fork", "game", "gay", "gbp", "google plus circle", "google plus official", "grab", "graduation", "grid layout", "group", "h", "hand victory", "handicap", "hard of hearing", "header", "help circle", "help", "heterosexual", "hide", "hotel", "hourglass four", "hourglass full", "hourglass one", "hourglass three", "hourglass two", "idea", "ils", "in cart", "inr", "intergender", "intersex", "jpy", "krw", "lab", "law", "legal", "lesbian", "lightning", "like", "line graph", "linkedin square", "linkify", "lira", "list layout", "magnify", "mail forward", "mail outline", "mail square", "mail", "male homosexual", "man", "marker", "mars alternate", "mars horizontal", "mars vertical", "microsoft edge", "military", "ms edge", "mute", "new pied piper", "non binary transgender", "numbered list", "options", "other gender horizontal", "other gender vertical", "other gender", "payment", "paypal card", "pencil square", "photo", "picture", "pie chart", "pie graph", "pied piper hat", "pin", "plus cart", "point", "pointing down", "pointing left", "pointing right", "pointing up", "pound", "power cord", "power", "privacy", "r circle", "rain", "record", "refresh", "remove circle", "remove from calendar", "remove user", "remove", "repeat", "rmb", "rouble", "rub", "ruble", "rupee", "s15", "selected radio", "send", "setting", "settings", "shekel", "sheqel", "shipping", "shop", "shuffle", "shutdown", "sidebar", "signing", "signup", "sliders", "soccer", "sort alphabet ascending", "sort alphabet descending", "sort ascending", "sort content ascending", "sort content descending", "sort descending", "sort numeric ascending", "sort numeric descending", "sound", "spy", "stripe card", "student", "talk", "target", "teletype", "television", "text cursor", "text telephone", "theme", "thermometer", "thumb tack", "time", "tm", "toggle down", "toggle left", "toggle right", "toggle up", "translate", "travel", "treatment", "triangle down", "triangle left", "triangle right", "triangle up", "try", "unhide", "unlinkify", "unmute", "usd", "user cancel", "user close", "user delete", "user x", "vcard", "video camera", "video play", "volume control phone", "wait", "warning circle", "warning sign", "warning", "wi-fi", "winner", "wizard", "woman", "won", "wordpress beginner", "wordpress forms", "world", "write square", "x", "yen", "zip", "zoom in", "zoom out", "zoom", "bitbucket square", "checkmark box", "circle thin", "cloud download", "cloud upload", "compose", "conversation", "credit card alternative", "currency", "dashboard", "diamond", "disk", "exchange", "external share", "external square", "external", "facebook official", "food", "hourglass zero", "level down", "level up", "log out", "meanpath", "money", "move", "pencil", "protect", "radio", "remove bookmark", "resize horizontal", "resize vertical", "sign in", "sign out", "spoon", "star half empty", "star half full", "ticket", "times rectangle", "write", "youtube play"],
        rt = oe()([].concat(W()(tt), nt)),
        it = ["left dropdown"],
        ot = oe()([].concat(W()(rt), it)),
        at = function at(e, t) {
          return e && t;
        },
        st = function st(e, t) {
          return e && !0 !== e && "".concat(e, " ").concat(t);
        },
        lt = function lt(e, t) {
          return e && (!0 === e ? t : "".concat(e, " ").concat(t));
        },
        ut = function ut(e, t) {
          return e && !0 !== e ? e.replace("large screen", "large-screen").replace(/ vertically/g, "-vertically").split(" ").map(function (e) {
            return "".concat(e.replace("-", " "), " ").concat(t);
          }).join(" ") : null;
        },
        ct = function ct(e) {
          return "justified" === e ? "justified" : st(e, "aligned");
        },
        dt = function dt(e) {
          return st(e, "aligned");
        },
        ht = function ht(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          if (n && "equal" === e) return "equal width";
          var r = de()(e);
          return "string" !== r && "number" !== r || !t ? fe(e) : "".concat(fe(e), " ").concat(t);
        };
      var ft = function ft(e, t, n) {
          var r = e.defaultProps,
            i = void 0 === r ? {} : r;
          if (t.as && t.as !== i.as) return t.as;
          if (n) {
            var o = n();
            if (o) return o;
          }
          return t.href ? "a" : i.as || "div";
        },
        pt = n("./node_modules/@babel/runtime/helpers/objectSpread.js"),
        mt = n.n(pt),
        gt = n("./node_modules/lodash/isArray.js"),
        vt = n.n(gt),
        yt = n("./node_modules/lodash/isPlainObject.js"),
        bt = n.n(yt),
        _t = n("./node_modules/lodash/isFunction.js"),
        xt = n.n(_t),
        wt = n("./node_modules/lodash/isNumber.js"),
        St = n.n(wt),
        At = n("./node_modules/lodash/isString.js"),
        Et = n.n(At),
        Tt = n("./node_modules/lodash/isBoolean.js"),
        Mt = n.n(Tt);
      function Ct(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        if ("function" != typeof e && "string" != typeof e) throw new Error("createShorthand() Component must be a string or function.");
        if (X()(n) || Mt()(n)) return null;
        var i = Et()(n),
          s = St()(n),
          l = xt()(n),
          u = Object(o.isValidElement)(n),
          c = bt()(n),
          d = i || s || vt()(n);
        if (!(l || u || c || d)) return null;
        var h = r.defaultProps,
          f = void 0 === h ? {} : h,
          p = u && n.props || c && n || d && t(n),
          m = r.overrideProps,
          g = void 0 === m ? {} : m;
        g = xt()(g) ? g(mt()({}, f, p)) : g;
        var v = mt()({}, f, p, g);
        if (f.className || g.className || p.className) {
          var y = K()(f.className, g.className, p.className);
          v.className = oe()(y.split(" ")).join(" ");
        }
        if ((f.style || g.style || p.style) && (v.style = mt()({}, f.style, p.style, g.style)), X()(v.key)) {
          var b = v.childKey,
            _ = r.autoGenerateKey,
            x = void 0 === _ || _;
          X()(b) ? x && (i || s) && (v.key = n) : (v.key = "function" == typeof b ? b(v) : b, delete v.childKey);
        }
        return u ? Object(o.cloneElement)(n, v) : d || c ? a.a.createElement(e, v) : l ? n(e, v, v.children) : void 0;
      }
      function kt(e, t) {
        if ("function" != typeof e && "string" != typeof e) throw new Error("createShorthandFactory() Component must be a string or function.");
        return function (n, r) {
          return Ct(e, t, n, r);
        };
      }
      Ct.handledProps = [];
      var Pt = kt("div", function (e) {
          return {
            children: e
          };
        }),
        Ot = kt("iframe", function (e) {
          return {
            src: e
          };
        }),
        Rt = kt("img", function (e) {
          return {
            src: e
          };
        }),
        It = kt("input", function (e) {
          return {
            type: e
          };
        }),
        jt = kt("label", function (e) {
          return {
            children: e
          };
        }),
        Nt = kt("p", function (e) {
          return {
            children: e
          };
        }),
        Lt = n("./node_modules/lodash/without.js"),
        Dt = n.n(Lt);
      function Bt(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.size,
          s = K()(o, "icons", n),
          l = H(Bt, e),
          u = ft(Bt, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      Bt.handledProps = ["as", "children", "className", "content", "size"], Bt.propTypes = {}, Bt.defaultProps = {
        as: "i"
      };
      var Ft = Bt,
        zt = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              n.props.disabled ? e.preventDefault() : V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "getIconAriaOptions",
            value: function value() {
              var e = {},
                t = this.props,
                n = t["aria-label"],
                r = t["aria-hidden"];
              return X()(n) ? e["aria-hidden"] = "true" : e["aria-label"] = n, X()(r) || (e["aria-hidden"] = r), e;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.bordered,
                r = e.circular,
                i = e.className,
                o = e.color,
                s = e.corner,
                l = e.disabled,
                u = e.fitted,
                c = e.flipped,
                d = e.inverted,
                h = e.link,
                f = e.loading,
                p = e.name,
                m = e.rotated,
                g = e.size,
                v = K()(o, p, g, at(n, "bordered"), at(r, "circular"), at(l, "disabled"), at(u, "fitted"), at(d, "inverted"), at(h, "link"), at(f, "loading"), lt(s, "corner"), st(c, "flipped"), st(m, "rotated"), "icon", i),
                y = H(t, this.props),
                b = ft(t, this.props),
                _ = this.getIconAriaOptions();
              return a.a.createElement(b, E()({}, y, _, {
                className: v,
                onClick: this.handleClick
              }));
            }
          }]), t;
        }(o.PureComponent);
      F()(zt, "defaultProps", {
        as: "i"
      }), F()(zt, "Group", Ft), F()(zt, "handledProps", ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"]), zt.propTypes = {}, zt.create = kt(zt, function (e) {
        return {
          name: e
        };
      });
      var Ut = zt,
        Gt = n("./node_modules/lodash/isUndefined.js"),
        Vt = n.n(Gt),
        Ht = n("./node_modules/@babel/runtime/helpers/slicedToArray.js"),
        qt = n.n(Ht),
        Wt = n("./node_modules/lodash/includes.js"),
        $t = n.n(Wt),
        Xt = n("./node_modules/lodash/forEach.js"),
        Yt = n.n(Xt),
        Kt = ["selected", "defaultValue", "defaultChecked", "accept", "autoCapitalize", "autoComplete", "autoCorrect", "autoFocus", "checked", "disabled", "form", "id", "lang", "list", "max", "maxLength", "min", "minLength", "multiple", "name", "pattern", "placeholder", "readOnly", "required", "step", "title", "type", "value"],
        Zt = [].concat(Kt, ["onKeyDown", "onKeyPress", "onKeyUp", "onFocus", "onBlur", "onChange", "onInput", "onClick", "onContextMenu", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp", "onSelect", "onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart"]),
        Qt = ["alt", "height", "src", "srcSet", "width"],
        Jt = function Jt(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.htmlProps,
            r = void 0 === n ? Zt : n,
            i = t.includeAria,
            o = void 0 === i || i,
            a = {},
            s = {};
          return Yt()(e, function (e, t) {
            var n = o && (/^aria-.*$/.test(t) || "role" === t);
            ($t()(r, t) || n ? a : s)[t] = e;
          }), [a, s];
        },
        en = "object" === ("undefined" == typeof document ? "undefined" : de()(document)) && null !== document,
        tn = "object" === ("undefined" == typeof window ? "undefined" : de()(window)) && null !== window && window.self === window,
        nn = function e() {
          return X()(e.override) ? en && tn : e.override;
        },
        rn = n("./node_modules/@semantic-ui-react/event-stack/lib/index.js"),
        on = n.n(rn),
        an = n("./node_modules/keyboard-key/src/keyboardKey.js"),
        sn = n.n(an),
        ln = n("./node_modules/lodash/inRange.js"),
        un = n.n(ln),
        cn = n("./node_modules/lodash/first.js"),
        dn = n.n(cn),
        hn = function hn(e, t) {
          if (ee()([t, e], X.a)) return !1;
          if (t.target && (V()(t.target, "setAttribute", "data-suir-click-target", !0), document.querySelector("[data-suir-click-target=true]"))) return V()(t.target, "removeAttribute", "data-suir-click-target"), e.contains(t.target);
          var n = t.clientX,
            r = t.clientY;
          if (ee()([n, r], X.a)) return !1;
          var i = e.getClientRects();
          if (!(e.offsetWidth && e.offsetHeight && i && i.length)) return !1;
          var o = dn()(i),
            a = o.top,
            s = o.bottom,
            l = o.left,
            u = o.right;
          return !ee()([a, s, l, u], X.a) && un()(r, a, s + .001) && un()(n, l, u + .001);
        },
        fn = (n("./node_modules/lodash/startsWith.js"), n("./node_modules/lodash/filter.js")),
        pn = n.n(fn),
        mn = n("./node_modules/lodash/isEmpty.js"),
        gn = n.n(mn),
        vn = (n("./node_modules/lodash/intersection.js"), n("./node_modules/lodash/each.js")),
        yn = n.n(vn),
        bn = function bn(e) {
          return "default".concat(e[0].toUpperCase() + e.slice(1));
        },
        _n = function _n(e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = t[e];
          if (void 0 !== i) return i;
          if (r) {
            var o = t[bn(e)];
            if (void 0 !== o) return o;
            if (n) {
              var a = n[e];
              if (void 0 !== a) return a;
            }
          }
          return "checked" !== e && ("value" === e ? t.multiple ? [] : "" : void 0);
        },
        xn = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "trySetState", function (e, t) {
              var r = Object.keys(e).reduce(function (t, r) {
                return void 0 !== n.props[r] || (t[r] = e[r]), t;
              }, {});
              Object.keys(r).length > 0 && n.setState(r, t);
            });
            var a = n.constructor.autoControlledProps,
              s = V()(N()(n), "getInitialAutoControlledState", n.props) || {},
              l = a.reduce(function (e, t) {
                return e[t] = _n(t, n.props, s, !0), e;
              }, {});
            return n.state = mt()({}, s, l), n;
          }
          return D()(t, e), k()(t, [{
            key: "UNSAFE_componentWillReceiveProps",
            value: function value(e) {
              var t = this.constructor.autoControlledProps.reduce(function (t, n) {
                return !Vt()(e[n]) && (t[n] = e[n]), t;
              }, {});
              Object.keys(t).length > 0 && this.setState(t);
            }
          }]), t;
        }(o.Component),
        wn = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleRef", function (e) {
              b(n.props.innerRef, e);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidMount",
            value: function value() {
              V()(this.props, "onMount", null, this.props);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              V()(this.props, "onUnmount", null, this.props);
            }
          }, {
            key: "render",
            value: function value() {
              if (!nn()) return null;
              var e = this.props,
                t = e.children,
                n = e.mountNode,
                r = void 0 === n ? document.body : n;
              return Object(y.createPortal)(a.a.createElement(S, {
                innerRef: this.handleRef
              }, t), r);
            }
          }]), t;
        }(o.Component);
      F()(wn, "handledProps", ["children", "innerRef", "mountNode", "onMount", "onUnmount"]), wn.propTypes = {};
      var Sn = wn,
        An = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "contentRef", Object(o.createRef)()), F()(N()(n), "triggerRef", Object(o.createRef)()), F()(N()(n), "latestDocumentMouseDownEvent", null), F()(N()(n), "handleDocumentMouseDown", function (e) {
              n.latestDocumentMouseDownEvent = e;
            }), F()(N()(n), "handleDocumentClick", function (e) {
              var t = n.props.closeOnDocumentClick,
                r = n.latestDocumentMouseDownEvent;
              n.latestDocumentMouseDownEvent = null, !n.contentRef.current || hn(n.triggerRef.current, e) || r && hn(n.contentRef.current, r) || hn(n.contentRef.current, e) || t && n.close(e);
            }), F()(N()(n), "handleEscape", function (e) {
              n.props.closeOnEscape && sn.a.getCode(e) === sn.a.Escape && n.close(e);
            }), F()(N()(n), "handlePortalMouseLeave", function (e) {
              var t = n.props,
                r = t.closeOnPortalMouseLeave,
                i = t.mouseLeaveDelay;
              r && e.target === n.contentRef.current && (n.mouseLeaveTimer = n.closeWithTimeout(e, i));
            }), F()(N()(n), "handlePortalMouseEnter", function () {
              n.props.closeOnPortalMouseLeave && clearTimeout(n.mouseLeaveTimer);
            }), F()(N()(n), "handleTriggerBlur", function (e) {
              for (var t = n.props, r = t.trigger, i = t.closeOnTriggerBlur, o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++) a[s - 1] = arguments[s];
              V.a.apply(void 0, [r, "props.onBlur", e].concat(a));
              var l = e.relatedTarget || document.activeElement,
                u = V()(n.contentRef.current, "contains", l);
              i && !u && n.close(e);
            }), F()(N()(n), "handleTriggerClick", function (e) {
              for (var t = n.props, r = t.trigger, i = t.closeOnTriggerClick, o = t.openOnTriggerClick, a = n.state.open, s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++) l[u - 1] = arguments[u];
              V.a.apply(void 0, [r, "props.onClick", e].concat(l)), a && i ? n.close(e) : !a && o && n.open(e);
            }), F()(N()(n), "handleTriggerFocus", function (e) {
              for (var t = n.props, r = t.trigger, i = t.openOnTriggerFocus, o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++) a[s - 1] = arguments[s];
              V.a.apply(void 0, [r, "props.onFocus", e].concat(a)), i && n.open(e);
            }), F()(N()(n), "handleTriggerMouseLeave", function (e) {
              clearTimeout(n.mouseEnterTimer);
              for (var t = n.props, r = t.trigger, i = t.closeOnTriggerMouseLeave, o = t.mouseLeaveDelay, a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++) s[l - 1] = arguments[l];
              V.a.apply(void 0, [r, "props.onMouseLeave", e].concat(s)), i && (n.mouseLeaveTimer = n.closeWithTimeout(e, o));
            }), F()(N()(n), "handleTriggerMouseEnter", function (e) {
              clearTimeout(n.mouseLeaveTimer);
              for (var t = n.props, r = t.trigger, i = t.mouseEnterDelay, o = t.openOnTriggerMouseEnter, a = arguments.length, s = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++) s[l - 1] = arguments[l];
              V.a.apply(void 0, [r, "props.onMouseEnter", e].concat(s)), o && (n.mouseEnterTimer = n.openWithTimeout(e, i));
            }), F()(N()(n), "open", function (e) {
              var t = n.props.onOpen;
              t && t(e, n.props), n.trySetState({
                open: !0
              });
            }), F()(N()(n), "openWithTimeout", function (e, t) {
              var r = mt()({}, e);
              return setTimeout(function () {
                return n.open(r);
              }, t || 0);
            }), F()(N()(n), "close", function (e) {
              var t = n.props.onClose;
              t && t(e, n.props), n.trySetState({
                open: !1
              });
            }), F()(N()(n), "closeWithTimeout", function (e, t) {
              var r = mt()({}, e);
              return setTimeout(function () {
                return n.close(r);
              }, t || 0);
            }), F()(N()(n), "handleMount", function () {
              V()(n.props, "onMount", null, n.props);
            }), F()(N()(n), "handleUnmount", function () {
              V()(n.props, "onUnmount", null, n.props);
            }), F()(N()(n), "handleTriggerRef", function (e) {
              n.triggerRef.current = e, b(n.props.triggerRef, e);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentWillUnmount",
            value: function value() {
              clearTimeout(this.mouseEnterTimer), clearTimeout(this.mouseLeaveTimer);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                t = e.children,
                n = e.eventPool,
                r = e.mountNode,
                i = e.trigger,
                s = this.state.open;
              return a.a.createElement(o.Fragment, null, s && a.a.createElement(o.Fragment, null, a.a.createElement(Sn, {
                innerRef: this.contentRef,
                mountNode: r,
                onMount: this.handleMount,
                onUnmount: this.handleUnmount
              }, t), a.a.createElement(on.a, {
                name: "mouseleave",
                on: this.handlePortalMouseLeave,
                pool: n,
                target: this.contentRef
              }), a.a.createElement(on.a, {
                name: "mouseenter",
                on: this.handlePortalMouseEnter,
                pool: n,
                target: this.contentRef
              }), a.a.createElement(on.a, {
                name: "mousedown",
                on: this.handleDocumentMouseDown,
                pool: n
              }), a.a.createElement(on.a, {
                name: "click",
                on: this.handleDocumentClick,
                pool: n
              }), a.a.createElement(on.a, {
                name: "keydown",
                on: this.handleEscape,
                pool: n
              })), i && a.a.createElement(S, {
                innerRef: this.handleTriggerRef
              }, Object(o.cloneElement)(i, {
                onBlur: this.handleTriggerBlur,
                onClick: this.handleTriggerClick,
                onFocus: this.handleTriggerFocus,
                onMouseLeave: this.handleTriggerMouseLeave,
                onMouseEnter: this.handleTriggerMouseEnter
              })));
            }
          }]), t;
        }(xn);
      F()(An, "defaultProps", {
        closeOnDocumentClick: !0,
        closeOnEscape: !0,
        eventPool: "default",
        openOnTriggerClick: !0
      }), F()(An, "autoControlledProps", ["open"]), F()(An, "Inner", Sn), F()(An, "handledProps", ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"]), An.propTypes = {};
      var En = An;
      function Tn(e) {
        var t = e.blurring,
          n = e.className,
          i = e.children,
          o = e.content,
          s = e.dimmed,
          l = K()(at(t, "blurring"), at(s, "dimmed"), "dimmable", n),
          u = H(Tn, e),
          c = ft(Tn, e);
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), r.isNil(i) ? o : i);
      }
      Tn.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"], Tn.propTypes = {};
      var Mn = Tn,
        Cn = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "containerRef", Object(o.createRef)()), F()(N()(n), "contentRef", Object(o.createRef)()), F()(N()(n), "handleClick", function (e) {
              var t = n.contentRef.current;
              V()(n.props, "onClick", e, n.props), t && t !== e.target && hn(t, e) || V()(n.props, "onClickOutside", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidMount",
            value: function value() {
              var e = this.props.active;
              this.toggleStyles(e);
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              var t = this.props.active;
              e.active !== t && this.toggleStyles(t);
            }
          }, {
            key: "toggleStyles",
            value: function value(e) {
              var t = this.containerRef.current;
              t && t.style && (e ? t.style.setProperty("display", "flex", "important") : t.style.removeProperty("display"));
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                o = e.className,
                s = e.content,
                l = e.disabled,
                u = e.inverted,
                c = e.page,
                d = e.simple,
                h = e.verticalAlign,
                f = K()("ui", at(n, "active transition visible"), at(l, "disabled"), at(u, "inverted"), at(c, "page"), at(d, "simple"), dt(h), "dimmer", o),
                p = H(t, this.props),
                m = ft(t, this.props),
                g = r.isNil(i) ? s : i;
              return a.a.createElement(S, {
                innerRef: this.containerRef
              }, a.a.createElement(m, E()({}, p, {
                className: f,
                onClick: this.handleClick
              }), g && a.a.createElement("div", {
                className: "content",
                ref: this.contentRef
              }, g)));
            }
          }]), t;
        }(o.Component);
      F()(Cn, "handledProps", ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"]), Cn.propTypes = {};
      var kn = function (e) {
        function t() {
          var e, n;
          M()(this, t);
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
          return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handlePortalMount", function () {
            nn() && (document.body.classList.add("dimmed"), document.body.classList.add("dimmable"));
          }), F()(N()(n), "handlePortalUnmount", function () {
            nn() && (document.body.classList.remove("dimmed"), document.body.classList.remove("dimmable"));
          }), n;
        }
        return D()(t, e), k()(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
              n = e.active,
              r = e.page,
              i = H(t, this.props);
            return r ? a.a.createElement(En, {
              closeOnEscape: !1,
              closeOnDocumentClick: !1,
              onMount: this.handlePortalMount,
              onUnmount: this.handlePortalUnmount,
              open: n,
              openOnTriggerClick: !1
            }, a.a.createElement(Cn, E()({}, i, {
              active: n,
              page: r
            }))) : a.a.createElement(Cn, E()({}, i, {
              active: n,
              page: r
            }));
          }
        }]), t;
      }(o.Component);
      function Pn(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.size,
          s = K()("ui", o, n, "images"),
          l = H(Pn, e),
          u = ft(Pn, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      F()(kn, "Dimmable", Mn), F()(kn, "Inner", Cn), F()(kn, "handledProps", ["active", "page"]), kn.propTypes = {}, kn.create = kt(kn, function (e) {
        return {
          content: e
        };
      }), Pn.handledProps = ["as", "children", "className", "content", "size"], Pn.propTypes = {};
      var On = Pn;
      function Rn(e) {
        var t = e.avatar,
          n = e.bordered,
          i = e.centered,
          o = e.children,
          s = e.circular,
          l = e.className,
          u = e.content,
          c = e.dimmer,
          d = e.disabled,
          h = e.floated,
          f = e.fluid,
          p = e.hidden,
          m = e.href,
          g = e.inline,
          v = e.label,
          y = e.rounded,
          b = e.size,
          _ = e.spaced,
          x = e.verticalAlign,
          w = e.wrapped,
          S = e.ui,
          A = K()(at(S, "ui"), b, at(t, "avatar"), at(n, "bordered"), at(s, "circular"), at(i, "centered"), at(d, "disabled"), at(f, "fluid"), at(p, "hidden"), at(g, "inline"), at(y, "rounded"), lt(_, "spaced"), st(h, "floated"), dt(x), "image", l),
          T = H(Rn, e),
          M = Jt(T, {
            htmlProps: Qt
          }),
          C = qt()(M, 2),
          k = C[0],
          P = C[1],
          O = ft(Rn, e, function () {
            if (!(X()(c) && X()(v) && X()(w) && r.isNil(o))) return "div";
          });
        return r.isNil(o) ? r.isNil(u) ? "img" === O ? a.a.createElement(O, E()({}, P, k, {
          className: A
        })) : a.a.createElement(O, E()({}, P, {
          className: A,
          href: m
        }), kn.create(c, {
          autoGenerateKey: !1
        }), Bn.create(v, {
          autoGenerateKey: !1
        }), a.a.createElement("img", k)) : a.a.createElement(O, E()({}, T, {
          className: A
        }), u) : a.a.createElement(O, E()({}, T, {
          className: A
        }), o);
      }
      Rn.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"], Rn.Group = On, Rn.propTypes = {}, Rn.defaultProps = {
        as: "img",
        ui: !0
      }, Rn.create = kt(Rn, function (e) {
        return {
          src: e
        };
      });
      var In = Rn;
      function jn(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("detail", n),
          s = H(jn, e),
          l = ft(jn, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      jn.handledProps = ["as", "children", "className", "content"], jn.propTypes = {}, jn.create = kt(jn, function (e) {
        return {
          content: e
        };
      });
      var Nn = jn;
      function Ln(e) {
        var t = e.children,
          n = e.circular,
          i = e.className,
          o = e.color,
          s = e.content,
          l = e.size,
          u = e.tag,
          c = K()("ui", o, l, at(n, "circular"), at(u, "tag"), "labels", i),
          d = H(Ln, e),
          h = ft(Ln, e);
        return a.a.createElement(h, E()({}, d, {
          className: c
        }), r.isNil(t) ? s : t);
      }
      Ln.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"], Ln.propTypes = {};
      var Dn = Ln,
        Bn = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              var t = n.props.onClick;
              t && t(e, n.props);
            }), F()(N()(n), "handleIconOverrides", function (e) {
              return {
                onClick: function onClick(t) {
                  V()(e, "onClick", t), V()(n.props, "onRemove", t, n.props);
                }
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.attached,
                o = e.basic,
                s = e.children,
                l = e.circular,
                u = e.className,
                c = e.color,
                d = e.content,
                h = e.corner,
                f = e.detail,
                p = e.empty,
                m = e.floating,
                g = e.horizontal,
                v = e.icon,
                y = e.image,
                b = e.onRemove,
                _ = e.pointing,
                x = e.prompt,
                w = e.removeIcon,
                S = e.ribbon,
                A = e.size,
                T = e.tag,
                M = (!0 === _ ? "pointing" : ("left" === _ || "right" === _) && "".concat(_, " pointing")) || ("above" === _ || "below" === _) && "pointing ".concat(_),
                C = K()("ui", c, M, A, at(n, "active"), at(o, "basic"), at(l, "circular"), at(p, "empty"), at(m, "floating"), at(g, "horizontal"), at(!0 === y, "image"), at(x, "prompt"), at(T, "tag"), lt(h, "corner"), lt(S, "ribbon"), st(i, "attached"), "label", u),
                k = H(t, this.props),
                P = ft(t, this.props);
              if (!r.isNil(s)) return a.a.createElement(P, E()({}, k, {
                className: C,
                onClick: this.handleClick
              }), s);
              var O = Vt()(w) ? "delete" : w;
              return a.a.createElement(P, E()({
                className: C,
                onClick: this.handleClick
              }, k), Ut.create(v, {
                autoGenerateKey: !1
              }), "boolean" != typeof y && In.create(y, {
                autoGenerateKey: !1
              }), d, Nn.create(f, {
                autoGenerateKey: !1
              }), b && Ut.create(O, {
                autoGenerateKey: !1,
                overrideProps: this.handleIconOverrides
              }));
            }
          }]), t;
        }(o.Component);
      function Fn(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.hidden,
          s = e.visible,
          l = K()(at(s, "visible"), at(o, "hidden"), "content", n),
          u = H(Fn, e),
          c = ft(Fn, e);
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), r.isNil(t) ? i : t);
      }
      F()(Bn, "Detail", Nn), F()(Bn, "Group", Dn), F()(Bn, "handledProps", ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"]), Bn.propTypes = {}, Bn.create = kt(Bn, function (e) {
        return {
          content: e
        };
      }), Fn.handledProps = ["as", "children", "className", "content", "hidden", "visible"], Fn.propTypes = {};
      var zn = Fn,
        Un = n("./node_modules/lodash/map.js"),
        Gn = n.n(Un);
      function Vn(e) {
        var t = e.attached,
          n = e.basic,
          i = e.buttons,
          o = e.children,
          s = e.className,
          l = e.color,
          u = e.compact,
          c = e.content,
          d = e.floated,
          h = e.fluid,
          f = e.icon,
          p = e.inverted,
          m = e.labeled,
          g = e.negative,
          v = e.positive,
          y = e.primary,
          b = e.secondary,
          _ = e.size,
          x = e.toggle,
          w = e.vertical,
          S = e.widths,
          A = K()("ui", l, _, at(n, "basic"), at(u, "compact"), at(h, "fluid"), at(f, "icon"), at(p, "inverted"), at(m, "labeled"), at(g, "negative"), at(v, "positive"), at(y, "primary"), at(b, "secondary"), at(x, "toggle"), at(w, "vertical"), lt(t, "attached"), st(d, "floated"), ht(S), "buttons", s),
          T = H(Vn, e),
          M = ft(Vn, e);
        return X()(i) ? a.a.createElement(M, E()({}, T, {
          className: A
        }), r.isNil(o) ? c : o) : a.a.createElement(M, E()({}, T, {
          className: A
        }), Gn()(i, function (e) {
          return Xn.create(e);
        }));
      }
      Vn.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"], Vn.propTypes = {};
      var Hn = Vn;
      function qn(e) {
        var t = e.className,
          n = e.text,
          r = K()("or", t),
          i = H(qn, e),
          o = ft(qn, e);
        return a.a.createElement(o, E()({}, i, {
          className: r,
          "data-text": n
        }));
      }
      qn.handledProps = ["as", "className", "text"], qn.propTypes = {};
      var Wn = qn,
        $n = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++) a[s] = arguments[s];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(a))), F()(N()(n), "ref", Object(o.createRef)()), F()(N()(n), "computeElementType", function () {
              var e = n.props,
                t = e.attached,
                r = e.label;
              if (!X()(t) || !X()(r)) return "div";
            }), F()(N()(n), "computeTabIndex", function (e) {
              var t = n.props,
                r = t.disabled,
                i = t.tabIndex;
              return X()(i) ? r ? -1 : "div" === e ? 0 : void 0 : i;
            }), F()(N()(n), "focus", function () {
              return V()(n.ref.current, "focus");
            }), F()(N()(n), "handleClick", function (e) {
              n.props.disabled ? e.preventDefault() : V()(n.props, "onClick", e, n.props);
            }), F()(N()(n), "hasIconClass", function () {
              var e = n.props,
                t = e.labelPosition,
                i = e.children,
                o = e.content,
                a = e.icon;
              return !0 === a || a && (t || r.isNil(i) && X()(o));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "computeButtonAriaRole",
            value: function value(e) {
              var t = this.props.role;
              return X()(t) ? "button" !== e ? "button" : void 0 : t;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.animated,
                o = e.attached,
                s = e.basic,
                l = e.children,
                u = e.circular,
                c = e.className,
                d = e.color,
                h = e.compact,
                f = e.content,
                p = e.disabled,
                m = e.floated,
                g = e.fluid,
                v = e.icon,
                y = e.inverted,
                b = e.label,
                _ = e.labelPosition,
                x = e.loading,
                w = e.negative,
                A = e.positive,
                T = e.primary,
                M = e.secondary,
                C = e.size,
                k = e.toggle,
                P = K()(d, C, at(n, "active"), at(s, "basic"), at(u, "circular"), at(h, "compact"), at(g, "fluid"), at(this.hasIconClass(), "icon"), at(y, "inverted"), at(x, "loading"), at(w, "negative"), at(A, "positive"), at(T, "primary"), at(M, "secondary"), at(k, "toggle"), lt(i, "animated"), lt(o, "attached")),
                O = K()(lt(_ || !!b, "labeled")),
                R = K()(at(p, "disabled"), st(m, "floated")),
                I = H(t, this.props),
                j = ft(t, this.props, this.computeElementType),
                N = this.computeTabIndex(j);
              if (!X()(b)) {
                var L = K()("ui", P, "button", c),
                  D = K()("ui", O, "button", c, R),
                  B = Bn.create(b, {
                    defaultProps: {
                      basic: !0,
                      pointing: "left" === _ ? "right" : "left"
                    },
                    autoGenerateKey: !1
                  });
                return a.a.createElement(j, E()({}, I, {
                  className: D,
                  onClick: this.handleClick
                }), "left" === _ && B, a.a.createElement(S, {
                  innerRef: this.ref
                }, a.a.createElement("button", {
                  className: L,
                  "aria-pressed": k ? !!n : void 0,
                  disabled: p,
                  tabIndex: N
                }, Ut.create(v, {
                  autoGenerateKey: !1
                }), " ", f)), ("right" === _ || !_) && B);
              }
              var F = K()("ui", P, R, O, "button", c),
                z = !r.isNil(l),
                U = this.computeButtonAriaRole(j);
              return a.a.createElement(S, {
                innerRef: this.ref
              }, a.a.createElement(j, E()({}, I, {
                className: F,
                "aria-pressed": k ? !!n : void 0,
                disabled: p && "button" === j || void 0,
                onClick: this.handleClick,
                role: U,
                tabIndex: N
              }), z && l, !z && Ut.create(v, {
                autoGenerateKey: !1
              }), !z && f));
            }
          }]), t;
        }(o.Component);
      F()($n, "defaultProps", {
        as: "button"
      }), F()($n, "Content", zn), F()($n, "Group", Hn), F()($n, "Or", Wn), F()($n, "handledProps", ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle"]), $n.propTypes = {}, $n.create = kt($n, function (e) {
        return {
          content: e
        };
      });
      var Xn = $n,
        Yn = n("./node_modules/lodash/pick.js"),
        Kn = n.n(Yn),
        Zn = n("./node_modules/lodash/reduce.js"),
        Qn = n.n(Zn),
        Jn = n("./node_modules/shallowequal/index.js"),
        er = n.n(Jn),
        tr = rn.instance,
        nr = function nr(e) {
          return null !== e && "object" === d(e) && e.hasOwnProperty("current");
        },
        rr = {
          current: null
        },
        ir = new WeakMap(),
        or = function or(e) {
          if (null === e) return rr;
          if (ir.has(e)) return ir.get(e);
          var t = {
            current: e
          };
          return ir.set(e, t), t;
        },
        ar = function ar(e) {
          var t = e.node;
          if (nn()) return nr(t) ? t : X()(t) ? or(document.body) : or(t);
        },
        sr = n("./node_modules/lodash/fp/uniq.js"),
        lr = n.n(sr),
        ur = n("./node_modules/lodash/fp/identity.js"),
        cr = n.n(ur),
        dr = n("./node_modules/lodash/fp/filter.js"),
        hr = n.n(dr),
        fr = n("./node_modules/lodash/fp/split.js"),
        pr = n.n(fr),
        mr = n("./node_modules/lodash/fp/flatMap.js"),
        gr = n.n(mr),
        vr = n("./node_modules/lodash/fp/map.js"),
        yr = n.n(vr),
        br = n("./node_modules/lodash/fp/toArray.js"),
        _r = n.n(br),
        xr = n("./node_modules/lodash/fp/flow.js"),
        wr = n.n(xr)()(_r.a, yr()("props.className"), gr()(pr()(/\s+/)), hr()(cr.a), lr.a),
        Sr = n("./node_modules/lodash/difference.js"),
        Ar = n.n(Sr),
        Er = function Er(e, t) {
          return [Ar()(t, e), Ar()(e, t)];
        },
        Tr = new Map(),
        Mr = function Mr(e, t) {
          var n = wr(t),
            r = Er(Tr.get(e), n),
            i = qt()(r, 2),
            o = i[0],
            a = i[1];
          e.current && (Yt()(o, function (t) {
            return e.current.classList.add(t);
          }), Yt()(a, function (t) {
            return e.current.classList.remove(t);
          })), Tr.set(e, n);
        },
        Cr = new function e() {
          var t = this;
          M()(this, e), F()(this, "add", function (e, n) {
            t.nodes.has(e) ? t.nodes.get(e).add(n) : t.nodes.set(e, new Set([n]));
          }), F()(this, "del", function (e, n) {
            if (t.nodes.has(e)) {
              var r = t.nodes.get(e);
              1 !== r.size ? r.delete(n) : t.nodes.delete(e);
            }
          }), F()(this, "emit", function (e, n) {
            n(e, t.nodes.get(e));
          }), this.nodes = new Map();
        }(),
        kr = function (e) {
          function t() {
            return M()(this, t), O()(this, I()(t).apply(this, arguments));
          }
          return D()(t, e), k()(t, [{
            key: "shouldComponentUpdate",
            value: function value(e) {
              return e.className !== this.props.className;
            }
          }, {
            key: "componentDidMount",
            value: function value() {
              var e = ar(this.props);
              Cr.add(e, this), Cr.emit(e, Mr);
            }
          }, {
            key: "componentDidUpdate",
            value: function value() {
              Cr.emit(ar(this.props), Mr);
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              var e = ar(this.props);
              Cr.del(e, this), Cr.emit(e, Mr);
            }
          }, {
            key: "render",
            value: function value() {
              return null;
            }
          }]), t;
        }(o.Component);
      function Pr(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()(n, "header"),
          s = H(Pr, e),
          l = ft(Pr, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      F()(kr, "handledProps", ["className", "node"]), kr.propTypes = {}, Pr.handledProps = ["as", "children", "className", "content"], Pr.propTypes = {}, Pr.create = kt(Pr, function (e) {
        return {
          content: e
        };
      });
      var Or = Pr;
      function Rr(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.image,
          s = e.scrolling,
          l = K()(n, at(o, "image"), at(s, "scrolling"), "content"),
          u = H(Rr, e),
          c = ft(Rr, e);
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), r.isNil(t) ? i : t);
      }
      Rr.handledProps = ["as", "children", "className", "content", "image", "scrolling"], Rr.propTypes = {}, Rr.create = kt(Rr, function (e) {
        return {
          content: e
        };
      });
      var Ir = Rr,
        jr = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleButtonOverrides", function (e) {
              return {
                onClick: function onClick(t, r) {
                  V()(e, "onClick", t, r), V()(n.props, "onActionClick", t, r);
                }
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this,
                n = this.props,
                i = n.actions,
                o = n.children,
                s = n.className,
                l = n.content,
                u = K()("actions", s),
                c = H(t, this.props),
                d = ft(t, this.props);
              return r.isNil(o) ? r.isNil(l) ? a.a.createElement(d, E()({}, c, {
                className: u
              }), Gn()(i, function (t) {
                return Xn.create(t, {
                  overrideProps: e.handleButtonOverrides
                });
              })) : a.a.createElement(d, E()({}, c, {
                className: u
              }), l) : a.a.createElement(d, E()({}, c, {
                className: u
              }), o);
            }
          }]), t;
        }(o.Component);
      function Nr(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("description", n),
          s = H(Nr, e),
          l = ft(Nr, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      F()(jr, "handledProps", ["actions", "as", "children", "className", "content", "onActionClick"]), jr.propTypes = {}, jr.create = kt(jr, function (e) {
        return {
          actions: e
        };
      }), Nr.handledProps = ["as", "children", "className", "content"], Nr.propTypes = {};
      var Lr = Nr,
        Dr = function Dr(e) {
          var t = e.height + 0,
            n = e.height + 0,
            r = window.innerHeight;
          return r / 2 + -n / 2 + t + 50 < r;
        },
        Br = function Br(e, t, n) {
          var r = t && e ? -n.height / 2 : 0;
          return {
            marginLeft: -n.width / 2,
            marginTop: r
          };
        },
        Fr = function Fr() {
          return !window.ActiveXObject && "ActiveXObject" in window;
        },
        zr = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var i = arguments.length, s = new Array(i), l = 0; l < i; l++) s[l] = arguments[l];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(s))), F()(N()(n), "legacy", nn() && Fr()), F()(N()(n), "ref", Object(o.createRef)()), F()(N()(n), "dimmerRef", Object(o.createRef)()), F()(N()(n), "latestDocumentMouseDownEvent", null), F()(N()(n), "getMountNode", function () {
              return nn() ? n.props.mountNode || document.body : null;
            }), F()(N()(n), "handleActionsOverrides", function (e) {
              return {
                onActionClick: function onActionClick(t, r) {
                  V()(e, "onActionClick", t, r), V()(n.props, "onActionClick", t, n.props), n.handleClose(t);
                }
              };
            }), F()(N()(n), "handleClose", function (e) {
              V()(n.props, "onClose", e, n.props), n.trySetState({
                open: !1
              });
            }), F()(N()(n), "handleDocumentMouseDown", function (e) {
              n.latestDocumentMouseDownEvent = e;
            }), F()(N()(n), "handleDocumentClick", function (e) {
              var t = n.props.closeOnDimmerClick,
                r = n.latestDocumentMouseDownEvent;
              n.latestDocumentMouseDownEvent = null, !t || hn(n.ref.current, r) || hn(n.ref.current, e) || (V()(n.props, "onClose", e, n.props), n.trySetState({
                open: !1
              }));
            }), F()(N()(n), "handleIconOverrides", function (e) {
              return {
                onClick: function onClick(t) {
                  V()(e, "onClick", t), n.handleClose(t);
                }
              };
            }), F()(N()(n), "handleOpen", function (e) {
              V()(n.props, "onOpen", e, n.props), n.trySetState({
                open: !0
              });
            }), F()(N()(n), "handlePortalMount", function (e) {
              var t = n.props.eventPool;
              n.setState({
                scrolling: !1
              }), n.setPositionAndClassNames(), tr.sub("mousedown", n.handleDocumentMouseDown, {
                pool: t,
                target: n.dimmerRef.current
              }), tr.sub("click", n.handleDocumentClick, {
                pool: t,
                target: n.dimmerRef.current
              }), V()(n.props, "onMount", e, n.props);
            }), F()(N()(n), "handlePortalUnmount", function (e) {
              var t = n.props.eventPool;
              cancelAnimationFrame(n.animationRequestId), tr.unsub("mousedown", n.handleDocumentMouseDown, {
                pool: t,
                target: n.dimmerRef.current
              }), tr.unsub("click", n.handleDocumentClick, {
                pool: t,
                target: n.dimmerRef.current
              }), V()(n.props, "onUnmount", e, n.props);
            }), F()(N()(n), "setDimmerNodeStyle", function () {
              var e = n.dimmerRef.current;
              e && e.style && "flex" !== e.style.display && e.style.setProperty("display", "flex", "important");
            }), F()(N()(n), "setPositionAndClassNames", function () {
              var e,
                t = n.props,
                r = t.centered,
                i = t.dimmer,
                o = {};
              if (n.ref.current) {
                var a = n.ref.current.getBoundingClientRect(),
                  s = Dr(a);
                e = !s;
                var l = n.legacy ? Br(s, r, a) : {};
                er()(n.state.legacyStyles, l) || (o.legacyStyles = l), n.state.scrolling !== e && (o.scrolling = e);
              }
              var u = K()(at(i, "dimmable dimmed"), at("blurring" === i, " blurring"), at(e, " scrolling"));
              n.state.mountClasses !== u && (o.mountClasses = u), gn()(o) || n.setState(o), n.animationRequestId = requestAnimationFrame(n.setPositionAndClassNames), n.setDimmerNodeStyle();
            }), F()(N()(n), "renderContent", function (e) {
              var i = n.props,
                s = i.actions,
                l = i.basic,
                u = i.children,
                c = i.className,
                d = i.closeIcon,
                h = i.content,
                f = i.header,
                p = i.mountNode,
                m = i.size,
                g = i.style,
                v = n.state,
                y = v.legacyStyles,
                b = v.mountClasses,
                _ = v.scrolling,
                x = K()("ui", m, at(l, "basic"), at(n.legacy, "legacy"), at(_, "scrolling"), "modal transition visible active", c),
                w = ft(t, n.props),
                A = !0 === d ? "close" : d,
                T = Ut.create(A, {
                  overrideProps: n.handleIconOverrides
                });
              return a.a.createElement(S, {
                innerRef: n.ref
              }, a.a.createElement(w, E()({}, e, {
                className: x,
                style: mt()({}, y, g)
              }), a.a.createElement(kr, {
                className: b,
                node: p
              }), T, r.isNil(u) ? a.a.createElement(o.Fragment, null, Or.create(f, {
                autoGenerateKey: !1
              }), Ir.create(h, {
                autoGenerateKey: !1
              }), jr.create(s, {
                overrideProps: n.handleActionsOverrides
              })) : u));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentWillUnmount",
            value: function value() {
              this.handlePortalUnmount();
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.state.open,
                n = this.props,
                r = n.centered,
                i = n.closeOnDocumentClick,
                s = n.dimmer,
                l = n.eventPool,
                u = n.trigger,
                c = this.getMountNode();
              if (!nn()) return Object(o.isValidElement)(u) ? u : null;
              var d = H(t, this.props),
                h = En.handledProps,
                f = Qn()(d, function (e, t, n) {
                  return $t()(h, n) || (e[n] = t), e;
                }, {}),
                p = Kn()(d, h),
                m = K()("ui", "inverted" === s && "inverted", !r && "top aligned", "page modals dimmer transition visible active");
              return a.a.createElement(En, E()({
                closeOnDocumentClick: i
              }, p, {
                trigger: u,
                eventPool: l,
                mountNode: c,
                open: e,
                onClose: this.handleClose,
                onMount: this.handlePortalMount,
                onOpen: this.handleOpen,
                onUnmount: this.handlePortalUnmount
              }), a.a.createElement("div", {
                className: m,
                ref: this.dimmerRef
              }, this.renderContent(f)));
            }
          }]), t;
        }(xn);
      F()(zr, "defaultProps", {
        centered: !0,
        dimmer: !0,
        closeOnDimmerClick: !0,
        closeOnDocumentClick: !1,
        eventPool: "Modal"
      }), F()(zr, "autoControlledProps", ["open"]), F()(zr, "Header", Or), F()(zr, "Content", Ir), F()(zr, "Description", Lr), F()(zr, "Actions", jr), F()(zr, "handledProps", ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"]), zr.propTypes = {};
      var Ur = zr,
        Gr = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleCancel", function (e) {
              V()(n.props, "onCancel", e, n.props);
            }), F()(N()(n), "handleCancelOverrides", function (e) {
              return {
                onClick: function onClick(t, r) {
                  V()(e, "onClick", t, r), n.handleCancel(t);
                }
              };
            }), F()(N()(n), "handleConfirmOverrides", function (e) {
              return {
                onClick: function onClick(t, r) {
                  V()(e, "onClick", t, r), V()(n.props, "onConfirm", t, n.props);
                }
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.cancelButton,
                r = e.confirmButton,
                i = e.content,
                o = e.header,
                s = e.open,
                l = e.size,
                u = H(t, this.props),
                c = {};
              return U()(this.props, "open") && (c.open = s), a.a.createElement(Ur, E()({}, u, c, {
                size: l,
                onClose: this.handleCancel
              }), Ur.Header.create(o, {
                autoGenerateKey: !1
              }), Ur.Content.create(i, {
                autoGenerateKey: !1
              }), a.a.createElement(Ur.Actions, null, Xn.create(n, {
                autoGenerateKey: !1,
                overrideProps: this.handleCancelOverrides
              }), Xn.create(r, {
                autoGenerateKey: !1,
                defaultProps: {
                  primary: !0
                },
                overrideProps: this.handleConfirmOverrides
              })));
            }
          }]), t;
        }(o.Component);
      F()(Gr, "defaultProps", {
        cancelButton: "Cancel",
        confirmButton: "OK",
        content: "Are you sure?",
        size: "small"
      }), F()(Gr, "handledProps", ["cancelButton", "confirmButton", "content", "header", "onCancel", "onConfirm", "open", "size"]), Gr.propTypes = {};
      var Vr = Gr,
        Hr = function Hr(e) {
          return {
            active: !1,
            type: "ellipsisItem",
            value: e
          };
        },
        qr = function qr(e) {
          return {
            active: !1,
            type: "prevItem",
            value: Math.max(1, e - 1)
          };
        },
        Wr = function Wr(e, t) {
          return {
            active: !1,
            type: "nextItem",
            value: Math.min(e + 1, t)
          };
        },
        $r = function $r(e) {
          return {
            active: !1,
            type: "lastItem",
            value: e
          };
        },
        Xr = n("./node_modules/lodash/range.js"),
        Yr = n.n(Xr),
        Kr = function Kr(e, t, n) {
          var r = t - 1;
          return (r !== e + 1 ? Hr : n)(r);
        },
        Zr = function Zr(e, t, n) {
          var r = e + 1;
          return (r !== t - 1 ? Hr : n)(r);
        },
        Qr = function Qr(e, t, n) {
          return Gn()(Yr()(e, t + 1), n);
        },
        Jr = function Jr(e) {
          var t,
            n,
            r,
            i = {
              activePage: +(t = e).activePage,
              boundaryRange: +t.boundaryRange,
              hideEllipsis: !!t.hideEllipsis,
              siblingRange: +t.siblingRange,
              totalPages: +t.totalPages
            },
            o = i.activePage,
            a = i.totalPages,
            s = function (e) {
              return function (t) {
                return {
                  active: e === t,
                  type: "pageItem",
                  value: t
                };
              };
            }(o),
            l = (r = (n = i).boundaryRange, 1 + (n.hideEllipsis ? 0 : 2) + 2 * n.siblingRange + 2 * r >= n.totalPages ? Qr(1, a, s) : function (e, t) {
              var n = e.activePage,
                r = e.boundaryRange,
                i = e.hideEllipsis,
                o = e.siblingRange,
                a = e.totalPages,
                s = i ? 0 : 1,
                l = r,
                u = Qr(1, l, t),
                c = a + 1 - r,
                d = Qr(c, a, t),
                h = Math.min(Math.max(n - o, l + s + 1), c - s - 2 * o - 1),
                f = h + 2 * o,
                p = Qr(h, f, t);
              return [].concat(W()(u), [!i && Kr(l, h, t)], W()(p), [!i && Zr(f, c, t)], W()(d)).filter(Boolean);
            }(i, s));
          return [{
            active: !1,
            type: "firstItem",
            value: 1
          }, qr(o)].concat(W()(l), [Wr(o, a), $r(a)]);
        };
      function ei(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("header", n),
          s = H(ei, e),
          l = ft(ei, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      ei.handledProps = ["as", "children", "className", "content"], ei.propTypes = {};
      var ti = ei,
        ni = n("./node_modules/lodash/startCase.js"),
        ri = n.n(ni),
        ii = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              n.props.disabled || V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                o = e.className,
                s = e.color,
                l = e.content,
                u = e.disabled,
                c = e.fitted,
                d = e.header,
                h = e.icon,
                f = e.link,
                p = e.name,
                m = e.onClick,
                g = e.position,
                v = K()(s, g, at(n, "active"), at(u, "disabled"), at(!0 === h || h && !(p || l), "icon"), at(d, "header"), at(f, "link"), lt(c, "fitted"), "item", o),
                y = ft(t, this.props, function () {
                  if (m) return "a";
                }),
                b = H(t, this.props);
              return r.isNil(i) ? a.a.createElement(y, E()({}, b, {
                className: v,
                onClick: this.handleClick
              }), Ut.create(h, {
                autoGenerateKey: !1
              }), r.isNil(l) ? ri()(p) : l) : a.a.createElement(y, E()({}, b, {
                className: v,
                onClick: this.handleClick
              }), i);
            }
          }]), t;
        }(o.Component);
      function oi(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.position,
          s = K()(o, "menu", n),
          l = H(oi, e),
          u = ft(oi, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      F()(ii, "handledProps", ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"]), ii.propTypes = {}, ii.create = kt(ii, function (e) {
        return {
          content: e,
          name: e
        };
      }), oi.handledProps = ["as", "children", "className", "content", "position"], oi.propTypes = {};
      var ai = oi,
        si = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleItemOverrides", function (e) {
              return {
                onClick: function onClick(t, r) {
                  var i = r.index;
                  n.trySetState({
                    activeIndex: i
                  }), V()(e, "onClick", t, r), V()(n.props, "onItemClick", t, r);
                }
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "renderItems",
            value: function value() {
              var e = this,
                t = this.props.items,
                n = this.state.activeIndex;
              return Gn()(t, function (t, r) {
                return ii.create(t, {
                  defaultProps: {
                    active: parseInt(n, 10) === r,
                    index: r
                  },
                  overrideProps: e.handleItemOverrides
                });
              });
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.attached,
                i = e.borderless,
                o = e.children,
                s = e.className,
                l = e.color,
                u = e.compact,
                c = e.fixed,
                d = e.floated,
                h = e.fluid,
                f = e.icon,
                p = e.inverted,
                m = e.pagination,
                g = e.pointing,
                v = e.secondary,
                y = e.size,
                b = e.stackable,
                _ = e.tabular,
                x = e.text,
                w = e.vertical,
                S = e.widths,
                A = K()("ui", l, y, at(i, "borderless"), at(u, "compact"), at(h, "fluid"), at(p, "inverted"), at(m, "pagination"), at(g, "pointing"), at(v, "secondary"), at(b, "stackable"), at(x, "text"), at(w, "vertical"), lt(n, "attached"), lt(d, "floated"), lt(f, "icon"), lt(_, "tabular"), st(c, "fixed"), ht(S, "item"), s, "menu"),
                T = H(t, this.props),
                M = ft(t, this.props);
              return a.a.createElement(M, E()({}, T, {
                className: A
              }), r.isNil(o) ? this.renderItems() : o);
            }
          }]), t;
        }(xn);
      F()(si, "autoControlledProps", ["activeIndex"]), F()(si, "Header", ti), F()(si, "Item", ii), F()(si, "Menu", ai), F()(si, "handledProps", ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"]), si.propTypes = {}, si.create = kt(si, function (e) {
        return {
          items: e
        };
      });
      var li = si,
        ui = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              V()(n.props, "onClick", e, n.props);
            }), F()(N()(n), "handleKeyDown", function (e) {
              V()(n.props, "onKeyDown", e, n.props), sn.a.getCode(e) === sn.a.Enter && V()(n.props, "onClick", e, n.props);
            }), F()(N()(n), "handleOverrides", function () {
              return {
                onClick: n.handleClick,
                onKeyDown: n.handleKeyDown
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                t = e.active,
                n = e.type,
                r = this.props.disabled || "ellipsisItem" === n;
              return ii.create(this.props, {
                defaultProps: {
                  active: t,
                  "aria-current": t,
                  "aria-disabled": r,
                  disabled: r,
                  onClick: this.handleClick,
                  onKeyDown: this.handleKeyDown,
                  tabIndex: r ? -1 : 0
                },
                overrideProps: this.handleOverrides
              });
            }
          }]), t;
        }(o.Component);
      F()(ui, "handledProps", ["active", "disabled", "onClick", "onKeyDown", "type"]), ui.propTypes = {}, ui.create = kt(ui, function (e) {
        return {
          content: e
        };
      });
      var ci = ui,
        di = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleItemClick", function (e, t) {
              var r = t.value;
              +n.state.activePage != +r && (n.trySetState({
                activePage: r
              }), V()(n.props, "onPageChange", e, mt()({}, n.props, {
                activePage: r
              })));
            }), F()(N()(n), "handleItemOverrides", function (e, t, r) {
              return function (i) {
                return {
                  active: e,
                  type: t,
                  key: "".concat(t, "-").concat(r),
                  onClick: function onClick(e, t) {
                    V()(i, "onClick", e, t), "ellipsisItem" !== t.type && n.handleItemClick(e, t);
                  }
                };
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this,
                n = this.props,
                r = n["aria-label"],
                i = n.boundaryRange,
                o = n.disabled,
                s = n.ellipsisItem,
                l = n.siblingRange,
                u = n.totalPages,
                c = this.state.activePage,
                d = Jr({
                  activePage: c,
                  boundaryRange: i,
                  hideEllipsis: X()(s),
                  siblingRange: l,
                  totalPages: u
                }),
                h = H(t, this.props);
              return a.a.createElement(li, E()({}, h, {
                "aria-label": r,
                pagination: !0,
                role: "navigation"
              }), Gn()(d, function (t) {
                var n = t.active,
                  r = t.type,
                  i = t.value;
                return ci.create(e.props[r], {
                  defaultProps: {
                    content: i,
                    disabled: o,
                    value: i
                  },
                  overrideProps: e.handleItemOverrides(n, r, i)
                });
              }));
            }
          }]), t;
        }(xn);
      F()(di, "autoControlledProps", ["activePage"]), F()(di, "defaultProps", {
        "aria-label": "Pagination Navigation",
        boundaryRange: 1,
        ellipsisItem: "...",
        firstItem: {
          "aria-label": "First item",
          content: "«"
        },
        lastItem: {
          "aria-label": "Last item",
          content: "»"
        },
        nextItem: {
          "aria-label": "Next item",
          content: "⟩"
        },
        pageItem: {},
        prevItem: {
          "aria-label": "Previous item",
          content: "⟨"
        },
        siblingRange: 1
      }), F()(di, "Item", ci), F()(di, "handledProps", ["activePage", "aria-label", "boundaryRange", "defaultActivePage", "disabled", "ellipsisItem", "firstItem", "lastItem", "nextItem", "onPageChange", "pageItem", "prevItem", "siblingRange", "totalPages"]), di.propTypes = {};
      var hi = n("./node_modules/lodash/set.js"),
        fi = n.n(hi),
        pi = n("./node_modules/lodash/get.js"),
        mi = n.n(pi),
        gi = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "inputRef", Object(o.createRef)()), F()(N()(n), "labelRef", Object(o.createRef)()), F()(N()(n), "canToggle", function () {
              var e = n.props,
                t = e.disabled,
                r = e.radio,
                i = e.readOnly,
                o = n.state.checked;
              return !(t || i || r && o);
            }), F()(N()(n), "computeTabIndex", function () {
              var e = n.props,
                t = e.disabled,
                r = e.tabIndex;
              return X()(r) ? t ? -1 : 0 : r;
            }), F()(N()(n), "handleClick", function (e) {
              var t = n.props.id,
                r = n.state,
                i = r.checked,
                o = r.indeterminate,
                a = V()(n.inputRef.current, "contains", e.target),
                s = V()(n.labelRef.current, "contains", e.target),
                l = !s && !a,
                u = !X()(t);
              s && u || V()(n.props, "onClick", e, mt()({}, n.props, {
                checked: !i,
                indeterminate: !!o
              })), n.isClickFromMouse && (n.isClickFromMouse = !1, s && !u && n.handleChange(e), l && n.handleChange(e), s && u && e.stopPropagation());
            }), F()(N()(n), "handleChange", function (e) {
              var t = n.state.checked;
              n.canToggle() && (V()(n.props, "onChange", e, mt()({}, n.props, {
                checked: !t,
                indeterminate: !1
              })), n.trySetState({
                checked: !t,
                indeterminate: !1
              }));
            }), F()(N()(n), "handleMouseDown", function (e) {
              var t = n.state,
                r = t.checked,
                i = t.indeterminate;
              V()(n.props, "onMouseDown", e, mt()({}, n.props, {
                checked: !!r,
                indeterminate: !!i
              })), e.defaultPrevented || V()(n.inputRef.current, "focus"), e.preventDefault();
            }), F()(N()(n), "handleMouseUp", function (e) {
              var t = n.state,
                r = t.checked,
                i = t.indeterminate;
              n.isClickFromMouse = !0, V()(n.props, "onMouseUp", e, mt()({}, n.props, {
                checked: !!r,
                indeterminate: !!i
              }));
            }), F()(N()(n), "setIndeterminate", function () {
              var e = n.state.indeterminate;
              fi()(n.inputRef, "current.indeterminate", !!e);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidMount",
            value: function value() {
              this.setIndeterminate();
            }
          }, {
            key: "componentDidUpdate",
            value: function value() {
              this.setIndeterminate();
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.className,
                r = e.disabled,
                i = e.label,
                o = e.id,
                s = e.name,
                l = e.radio,
                u = e.readOnly,
                c = e.slider,
                d = e.toggle,
                h = e.type,
                f = e.value,
                p = this.state,
                m = p.checked,
                g = p.indeterminate,
                v = K()("ui", at(m, "checked"), at(r, "disabled"), at(g, "indeterminate"), at(X()(i), "fitted"), at(l, "radio"), at(u, "read-only"), at(c, "slider"), at(d, "toggle"), "checkbox", n),
                y = H(t, this.props),
                b = ft(t, this.props),
                _ = Jt(y, {
                  htmlProps: Kt
                }),
                x = qt()(_, 2),
                w = x[0],
                A = x[1],
                T = jt(i, {
                  defaultProps: {
                    htmlFor: o
                  },
                  autoGenerateKey: !1
                }) || a.a.createElement("label", {
                  htmlFor: o
                });
              return a.a.createElement(b, E()({}, A, {
                className: v,
                onClick: this.handleClick,
                onChange: this.handleChange,
                onMouseDown: this.handleMouseDown,
                onMouseUp: this.handleMouseUp
              }), a.a.createElement(S, {
                innerRef: this.inputRef
              }, a.a.createElement("input", E()({}, w, {
                checked: m,
                className: "hidden",
                disabled: r,
                id: o,
                name: s,
                readOnly: !0,
                tabIndex: this.computeTabIndex(),
                type: h,
                value: f
              }))), a.a.createElement(S, {
                innerRef: this.labelRef
              }, T));
            }
          }]), t;
        }(xn);
      function vi(e) {
        var t = e.slider,
          n = e.toggle,
          r = e.type,
          i = H(vi, e),
          o = !(t || n) || void 0;
        return a.a.createElement(gi, E()({}, i, {
          type: r,
          radio: o,
          slider: t,
          toggle: n
        }));
      }
      F()(gi, "defaultProps", {
        type: "checkbox"
      }), F()(gi, "autoControlledProps", ["checked", "indeterminate"]), F()(gi, "handledProps", ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"]), gi.propTypes = {}, vi.handledProps = ["slider", "toggle", "type"], vi.propTypes = {}, vi.defaultProps = {
        type: "radio"
      };
      var yi = vi,
        bi = function bi(e, t) {
          var n = t.maxWidth;
          return function (e, t) {
            return !!X()(t) || e >= t;
          }(e, t.minWidth) && function (e, t) {
            return !!X()(t) || e <= t;
          }(e, n);
        },
        _i = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "state", {
              visible: !0
            }), F()(N()(n), "handleResize", function (e) {
              n.ticking || (n.ticking = !0, n.frameId = requestAnimationFrame(function () {
                return n.handleUpdate(e);
              }));
            }), F()(N()(n), "handleUpdate", function (e) {
              n.ticking = !1;
              var t = n.state.visible,
                r = V()(n.props, "getWidth"),
                i = bi(r, n.props);
              t !== i && n.setState({
                visible: i
              }), V()(n.props, "onUpdate", e, mt()({}, n.props, {
                width: r
              }));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidMount",
            value: function value() {
              var e = this.props.fireOnMount;
              tr.sub("resize", this.handleResize, {
                target: "window"
              }), e && this.handleUpdate();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              tr.unsub("resize", this.handleResize, {
                target: "window"
              }), cancelAnimationFrame(this.frameId);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props.children,
                n = this.state.visible,
                r = ft(t, this.props),
                i = H(t, this.props);
              return n ? a.a.createElement(r, i, e) : null;
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function value(e) {
              var t = V()(e, "getWidth");
              return {
                visible: bi(t, e)
              };
            }
          }]), t;
        }(o.Component);
      F()(_i, "defaultProps", {
        getWidth: function getWidth() {
          return nn() ? window.innerWidth : 0;
        }
      }), F()(_i, "onlyMobile", {
        minWidth: 320,
        maxWidth: 767
      }), F()(_i, "onlyTablet", {
        minWidth: 768,
        maxWidth: 991
      }), F()(_i, "onlyComputer", {
        minWidth: 992
      }), F()(_i, "onlyLargeScreen", {
        minWidth: 1200,
        maxWidth: 1919
      }), F()(_i, "onlyWidescreen", {
        minWidth: 1920
      }), F()(_i, "handledProps", ["as", "children", "fireOnMount", "getWidth", "maxWidth", "minWidth", "onUpdate"]), _i.propTypes = {};
      var xi = n("./node_modules/@babel/runtime/helpers/get.js"),
        wi = n.n(xi),
        Si = n("./node_modules/lodash/compact.js"),
        Ai = n.n(Si),
        Ei = n("./node_modules/lodash/every.js"),
        Ti = n.n(Ei),
        Mi = n("./node_modules/lodash/findIndex.js"),
        Ci = n.n(Mi),
        ki = n("./node_modules/lodash/escapeRegExp.js"),
        Pi = n.n(ki),
        Oi = n("./node_modules/lodash/deburr.js"),
        Ri = n.n(Oi),
        Ii = n("./node_modules/lodash/dropRight.js"),
        ji = n.n(Ii),
        Ni = n("./node_modules/lodash/size.js"),
        Li = n.n(Ni),
        Di = n("./node_modules/lodash/union.js"),
        Bi = n.n(Di),
        Fi = n("./node_modules/lodash/noop.js"),
        zi = n.n(Fi),
        Ui = n("./node_modules/lodash/isEqual.js"),
        Gi = n.n(Ui);
      function Vi(e) {
        var t = e.className,
          n = K()("divider", t),
          r = H(Vi, e),
          i = ft(Vi, e);
        return a.a.createElement(i, E()({}, r, {
          className: n
        }));
      }
      Vi.handledProps = ["as", "className"], Vi.propTypes = {};
      var Hi = Vi,
        qi = function (e) {
          function t() {
            return M()(this, t), O()(this, I()(t).apply(this, arguments));
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.className,
                r = e.name,
                i = K()(r, "flag", n),
                o = H(t, this.props),
                s = ft(t, this.props);
              return a.a.createElement(s, E()({}, o, {
                className: i
              }));
            }
          }]), t;
        }(o.PureComponent);
      F()(qi, "defaultProps", {
        as: "i"
      }), F()(qi, "handledProps", ["as", "className", "name"]), qi.propTypes = {}, qi.create = kt(qi, function (e) {
        return {
          name: e
        };
      });
      var Wi = qi,
        $i = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                o = e.className,
                s = e.content,
                l = e.disabled,
                u = e.description,
                c = e.flag,
                d = e.icon,
                h = e.image,
                f = e.label,
                p = e.selected,
                m = e.text,
                g = K()(at(n, "active"), at(l, "disabled"), at(p, "selected"), "item", o),
                v = X()(d) ? r.someByType(i, "DropdownMenu") && "dropdown" : d,
                y = H(t, this.props),
                b = ft(t, this.props),
                _ = {
                  role: "option",
                  "aria-disabled": l,
                  "aria-checked": n,
                  "aria-selected": p
                };
              if (!r.isNil(i)) return a.a.createElement(b, E()({}, y, _, {
                className: g,
                onClick: this.handleClick
              }), i);
              var x = Wi.create(c, {
                  autoGenerateKey: !1
                }),
                w = Ut.create(v, {
                  autoGenerateKey: !1
                }),
                S = In.create(h, {
                  autoGenerateKey: !1
                }),
                A = Bn.create(f, {
                  autoGenerateKey: !1
                }),
                T = Ct("span", function (e) {
                  return {
                    children: e
                  };
                }, u, {
                  defaultProps: {
                    className: "description"
                  },
                  autoGenerateKey: !1
                }),
                M = Ct("span", function (e) {
                  return {
                    children: e
                  };
                }, r.isNil(s) ? m : s, {
                  defaultProps: {
                    className: "text"
                  },
                  autoGenerateKey: !1
                });
              return a.a.createElement(b, E()({}, y, _, {
                className: g,
                onClick: this.handleClick
              }), S, w, x, A, T, M);
            }
          }]), t;
        }(o.Component);
      F()($i, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"]), $i.propTypes = {}, $i.create = kt($i, function (e) {
        return e;
      });
      var Xi = $i;
      function Yi(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.icon,
          s = K()("header", n),
          l = H(Yi, e),
          u = ft(Yi, e);
        return r.isNil(t) ? a.a.createElement(u, E()({}, l, {
          className: s
        }), Ut.create(o, {
          autoGenerateKey: !1
        }), i) : a.a.createElement(u, E()({}, l, {
          className: s
        }), t);
      }
      Yi.handledProps = ["as", "children", "className", "content", "icon"], Yi.propTypes = {}, Yi.create = kt(Yi, function (e) {
        return {
          content: e
        };
      });
      var Ki = Yi;
      function Zi(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.direction,
          s = e.open,
          l = e.scrolling,
          u = K()(o, at(s, "visible"), at(l, "scrolling"), "menu transition", n),
          c = H(Zi, e),
          d = ft(Zi, e);
        return a.a.createElement(d, E()({}, c, {
          className: u
        }), r.isNil(t) ? i : t);
      }
      Zi.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"], Zi.propTypes = {};
      var Qi = Zi,
        Ji = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleChange", function (e) {
              var t = mi()(e, "target.value");
              V()(n.props, "onChange", e, mt()({}, n.props, {
                value: t
              }));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.autoComplete,
                r = e.className,
                i = e.tabIndex,
                o = e.type,
                s = e.value,
                l = K()("search", r),
                u = H(t, this.props);
              return a.a.createElement("input", E()({}, u, {
                "aria-autocomplete": "list",
                autoComplete: n,
                className: l,
                onChange: this.handleChange,
                tabIndex: i,
                type: o,
                value: s
              }));
            }
          }]), t;
        }(o.Component);
      F()(Ji, "defaultProps", {
        autoComplete: "off",
        type: "text"
      }), F()(Ji, "handledProps", ["as", "autoComplete", "className", "tabIndex", "type", "value"]), Ji.propTypes = {}, Ji.create = kt(Ji, function (e) {
        return {
          type: e
        };
      });
      var eo = Ji,
        to = function to(e, t) {
          return X()(e) ? t : e;
        },
        no = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var i = arguments.length, s = new Array(i), l = 0; l < i; l++) s[l] = arguments[l];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(s))), F()(N()(n), "searchRef", Object(o.createRef)()), F()(N()(n), "sizerRef", Object(o.createRef)()), F()(N()(n), "ref", Object(o.createRef)()), F()(N()(n), "handleChange", function (e, t) {
              V()(n.props, "onChange", e, mt()({}, n.props, {
                value: t
              }));
            }), F()(N()(n), "closeOnChange", function (e) {
              var t = n.props,
                r = t.closeOnChange,
                i = t.multiple;
              (Vt()(r) ? !i : r) && n.close(e, zi.a);
            }), F()(N()(n), "closeOnEscape", function (e) {
              n.props.closeOnEscape && sn.a.getCode(e) === sn.a.Escape && (e.preventDefault(), n.close(e));
            }), F()(N()(n), "moveSelectionOnKeyDown", function (e) {
              var t,
                r = n.props,
                i = r.multiple,
                o = r.selectOnNavigation,
                a = (t = {}, F()(t, sn.a.ArrowDown, 1), F()(t, sn.a.ArrowUp, -1), t)[sn.a.getCode(e)];
              void 0 !== a && (e.preventDefault(), n.moveSelectionBy(a), !i && o && n.makeSelectedItemActive(e));
            }), F()(N()(n), "openOnSpace", function (e) {
              sn.a.getCode(e) === sn.a.Spacebar && (e.preventDefault(), n.open(e));
            }), F()(N()(n), "openOnArrow", function (e) {
              var t = sn.a.getCode(e);
              $t()([sn.a.ArrowDown, sn.a.ArrowUp], t) && (n.state.open || (e.preventDefault(), n.open(e)));
            }), F()(N()(n), "makeSelectedItemActive", function (e) {
              var t = n.state,
                r = t.open,
                i = t.value,
                o = n.props.multiple,
                a = n.getSelectedItem(),
                s = mi()(a, "value");
              if (!X()(s) && r) {
                var l = o ? Bi()(n.state.value, [s]) : s;
                (o ? !!Ar()(l, i).length : l !== i) && (n.setValue(l), n.setSelectedIndex(l), n.handleChange(e, l), a["data-additional"] && V()(n.props, "onAddItem", e, mt()({}, n.props, {
                  value: s
                })));
              }
            }), F()(N()(n), "selectItemOnEnter", function (e) {
              var t = n.props.search;
              if (sn.a.getCode(e) === sn.a.Enter || !t && sn.a.getCode(e) === sn.a.Spacebar) {
                e.preventDefault();
                var r = Li()(n.getMenuOptions());
                t && 0 === r || (n.makeSelectedItemActive(e), n.closeOnChange(e), n.clearSearchQuery(), t && V()(n.searchRef.current, "focus"));
              }
            }), F()(N()(n), "removeItemOnBackspace", function (e) {
              var t = n.props,
                r = t.multiple,
                i = t.search,
                o = n.state,
                a = o.searchQuery,
                s = o.value;
              if (sn.a.getCode(e) === sn.a.Backspace && !a && i && r && !gn()(s)) {
                e.preventDefault();
                var l = ji()(s);
                n.setValue(l), n.setSelectedIndex(l), n.handleChange(e, l);
              }
            }), F()(N()(n), "closeOnDocumentClick", function (e) {
              n.props.closeOnBlur && (n.ref.current && hn(n.ref.current, e) || n.close());
            }), F()(N()(n), "handleMouseDown", function (e) {
              n.isMouseDown = !0, V()(n.props, "onMouseDown", e, n.props), document.addEventListener("mouseup", n.handleDocumentMouseUp);
            }), F()(N()(n), "handleDocumentMouseUp", function () {
              n.isMouseDown = !1, document.removeEventListener("mouseup", n.handleDocumentMouseUp);
            }), F()(N()(n), "handleClick", function (e) {
              var t = n.props,
                r = t.minCharacters,
                i = t.search,
                o = n.state,
                a = o.open,
                s = o.searchQuery;
              if (V()(n.props, "onClick", e, n.props), e.stopPropagation(), !i) return n.toggle(e);
              a ? V()(n.searchRef.current, "focus") : s.length >= r || 1 === r ? n.open(e) : V()(n.searchRef.current, "focus");
            }), F()(N()(n), "handleIconClick", function (e) {
              var t = n.props.clearable,
                r = n.hasValue();
              V()(n.props, "onClick", e, n.props), e.stopPropagation(), t && r ? n.clearValue(e) : n.toggle(e);
            }), F()(N()(n), "handleItemClick", function (e, t) {
              var r = n.props,
                i = r.multiple,
                o = r.search,
                a = n.state.value,
                s = t.value;
              if (e.stopPropagation(), (i || t.disabled) && e.nativeEvent.stopImmediatePropagation(), !t.disabled) {
                var l = t["data-additional"],
                  u = i ? Bi()(n.state.value, [s]) : s;
                (i ? !!Ar()(u, a).length : u !== a) && (n.setValue(u), n.setSelectedIndex(s), n.handleChange(e, u)), n.clearSearchQuery(s), o ? V()(n.searchRef.current, "focus") : V()(n.ref.current, "focus"), n.closeOnChange(e), l && V()(n.props, "onAddItem", e, mt()({}, n.props, {
                  value: s
                }));
              }
            }), F()(N()(n), "handleFocus", function (e) {
              n.state.focus || (V()(n.props, "onFocus", e, n.props), n.setState({
                focus: !0
              }));
            }), F()(N()(n), "handleBlur", function (e) {
              var t = mi()(e, "currentTarget");
              if (!t || !t.contains(document.activeElement)) {
                var r = n.props,
                  i = r.closeOnBlur,
                  o = r.multiple,
                  a = r.selectOnBlur;
                n.isMouseDown || (V()(n.props, "onBlur", e, n.props), a && !o && (n.makeSelectedItemActive(e), i && n.close()), n.setState({
                  focus: !1
                }), n.clearSearchQuery());
              }
            }), F()(N()(n), "handleSearchChange", function (e, t) {
              var r = t.value;
              e.stopPropagation();
              var i = n.props.minCharacters,
                o = n.state.open,
                a = r;
              V()(n.props, "onSearchChange", e, mt()({}, n.props, {
                searchQuery: a
              })), n.trySetState({
                searchQuery: a,
                selectedIndex: 0
              }), !o && a.length >= i ? n.open() : o && 1 !== i && a.length < i && n.close();
            }), F()(N()(n), "getKeyAndValues", function (e) {
              return e ? e.map(function (e) {
                return Kn()(e, ["key", "value"]);
              }) : e;
            }), F()(N()(n), "getMenuOptions", function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.state.value,
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.props.options,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n.state.searchQuery,
                i = n.props,
                o = i.additionLabel,
                s = i.additionPosition,
                l = i.allowAdditions,
                u = i.deburr,
                c = i.multiple,
                d = i.search,
                h = t;
              if (c && (h = pn()(h, function (t) {
                return !$t()(e, t.value);
              })), d && r) if (xt()(d)) h = d(h, r);else {
                var f = u ? Ri()(r) : r,
                  p = new RegExp(Pi()(f), "i");
                h = pn()(h, function (e) {
                  return p.test(u ? Ri()(e.text) : e.text);
                });
              }
              if (l && d && r && !ee()(h, {
                text: r
              })) {
                var m = a.a.isValidElement(o) ? a.a.cloneElement(o, {
                    key: "addition-label"
                  }) : o || "",
                  g = {
                    key: "addition",
                    text: [m, a.a.createElement("b", {
                      key: "addition-query"
                    }, r)],
                    value: r,
                    className: "addition",
                    "data-additional": !0
                  };
                "top" === s ? h.unshift(g) : h.push(g);
              }
              return h;
            }), F()(N()(n), "getSelectedItem", function () {
              var e = n.state.selectedIndex,
                t = n.getMenuOptions();
              return mi()(t, "[".concat(e, "]"));
            }), F()(N()(n), "getEnabledIndices", function (e) {
              var t = e || n.getMenuOptions();
              return Qn()(t, function (e, t, n) {
                return t.disabled || e.push(n), e;
              }, []);
            }), F()(N()(n), "getItemByValue", function (e) {
              var t = n.props.options;
              return Q()(t, {
                value: e
              });
            }), F()(N()(n), "getMenuItemIndexByValue", function (e, t) {
              var r = t || n.getMenuOptions();
              return Ci()(r, ["value", e]);
            }), F()(N()(n), "getDropdownAriaOptions", function () {
              var e = n.props,
                t = e.loading,
                r = e.disabled,
                i = e.search,
                o = e.multiple,
                a = {
                  role: i ? "combobox" : "listbox",
                  "aria-busy": t,
                  "aria-disabled": r,
                  "aria-expanded": !!n.state.open
                };
              return "listbox" === a.role && (a["aria-multiselectable"] = o), a;
            }), F()(N()(n), "clearSearchQuery", function (e) {
              var t = n.state.searchQuery;
              void 0 !== t && "" !== t && (n.trySetState({
                searchQuery: ""
              }), n.setSelectedIndex(e, void 0, ""));
            }), F()(N()(n), "setValue", function (e) {
              n.trySetState({
                value: e
              });
            }), F()(N()(n), "setSelectedIndex", function () {
              var e,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.state.value,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.props.options,
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n.state.searchQuery,
                o = n.props.multiple,
                a = n.state.selectedIndex,
                s = n.getMenuOptions(t, r, i),
                l = n.getEnabledIndices(s);
              if (!a || a < 0) {
                var u = l[0];
                e = o ? u : n.getMenuItemIndexByValue(t, s) || l[0];
              } else if (o) a >= s.length - 1 && (e = l[l.length - 1]);else {
                var c = n.getMenuItemIndexByValue(t, s);
                e = $t()(l, c) ? c : void 0;
              }
              (!e || e < 0) && (e = l[0]), n.setState({
                selectedIndex: e
              });
            }), F()(N()(n), "handleLabelClick", function (e, t) {
              e.stopPropagation(), n.setState({
                selectedLabel: t.value
              }), V()(n.props, "onLabelClick", e, t);
            }), F()(N()(n), "handleLabelRemove", function (e, t) {
              e.stopPropagation();
              var r = n.state.value,
                i = Dt()(r, t.value);
              n.setValue(i), n.setSelectedIndex(i), n.handleChange(e, i);
            }), F()(N()(n), "moveSelectionBy", function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.state.selectedIndex,
                r = n.getMenuOptions();
              if (void 0 !== r && !Ti()(r, "disabled")) {
                var i = r.length - 1,
                  o = n.props.wrapSelection,
                  a = t + e;
                !o && (a > i || a < 0) ? a = t : a > i ? a = 0 : a < 0 && (a = i), r[a].disabled ? n.moveSelectionBy(e, a) : (n.setState({
                  selectedIndex: a
                }), n.scrollSelectedItemIntoView());
              }
            }), F()(N()(n), "handleIconOverrides", function (e) {
              var t = n.props.clearable;
              return {
                className: K()(t && n.hasValue() && "clear", e.className),
                onClick: function onClick(t) {
                  V()(e, "onClick", t, e), n.handleIconClick(t);
                }
              };
            }), F()(N()(n), "clearValue", function (e) {
              var t = n.props.multiple ? [] : "";
              n.setValue(t), n.setSelectedIndex(t), n.handleChange(e, t);
            }), F()(N()(n), "computeSearchInputTabIndex", function () {
              var e = n.props,
                t = e.disabled,
                r = e.tabIndex;
              return X()(r) ? t ? -1 : 0 : r;
            }), F()(N()(n), "computeSearchInputWidth", function () {
              var e = n.state.searchQuery;
              if (n.sizerRef.current && e) {
                n.sizerRef.current.style.display = "inline", n.sizerRef.current.textContent = e;
                var t = Math.ceil(n.sizerRef.current.getBoundingClientRect().width);
                return n.sizerRef.current.style.removeProperty("display"), t;
              }
            }), F()(N()(n), "computeTabIndex", function () {
              var e = n.props,
                t = e.disabled,
                r = e.search,
                i = e.tabIndex;
              if (!r) return t ? -1 : X()(i) ? 0 : i;
            }), F()(N()(n), "handleSearchInputOverrides", function (e) {
              return {
                onChange: function onChange(t, r) {
                  V()(e, "onChange", t, r), n.handleSearchChange(t, r);
                }
              };
            }), F()(N()(n), "hasValue", function () {
              var e = n.props.multiple,
                t = n.state.value;
              return e ? !gn()(t) : !X()(t) && "" !== t;
            }), F()(N()(n), "scrollSelectedItemIntoView", function () {
              if (n.ref.current) {
                var e = n.ref.current.querySelector(".menu.visible");
                if (e) {
                  var t = e.querySelector(".item.selected");
                  if (t) {
                    var r = t.offsetTop < e.scrollTop,
                      i = t.offsetTop + t.clientHeight > e.scrollTop + e.clientHeight;
                    r ? e.scrollTop = t.offsetTop : i && (e.scrollTop = t.offsetTop + t.clientHeight - e.clientHeight);
                  }
                }
              }
            }), F()(N()(n), "setOpenDirection", function () {
              if (n.ref.current) {
                var e = n.ref.current.querySelector(".menu.visible");
                if (e) {
                  var t = n.ref.current.getBoundingClientRect(),
                    r = e.clientHeight,
                    i = document.documentElement.clientHeight - t.top - t.height - r,
                    o = t.top - r,
                    a = i < 0 && o > i;
                  !a != !n.state.upward && n.trySetState({
                    upward: a
                  });
                }
              }
            }), F()(N()(n), "open", function (e) {
              var t = n.props,
                r = t.disabled,
                i = (t.open, t.search);
              r || (i && V()(n.searchRef.current, "focus"), V()(n.props, "onOpen", e, n.props), n.trySetState({
                open: !0
              }), n.scrollSelectedItemIntoView());
            }), F()(N()(n), "close", function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.handleClose,
                r = n.state.open;
              r && (V()(n.props, "onClose", e, n.props), n.trySetState({
                open: !1
              }, t));
            }), F()(N()(n), "handleClose", function () {
              var e = document.activeElement === n.searchRef.current;
              !e && n.ref.current && n.ref.current.blur();
              var t = document.activeElement === n.ref.current,
                r = e || t;
              n.setState({
                focus: r
              });
            }), F()(N()(n), "toggle", function (e) {
              return n.state.open ? n.close(e) : n.open(e);
            }), F()(N()(n), "renderText", function () {
              var e = n.props,
                t = e.multiple,
                r = e.placeholder,
                i = e.search,
                o = e.text,
                s = n.state,
                l = s.searchQuery,
                u = s.value,
                c = s.open,
                d = n.hasValue(),
                h = K()(r && !d && "default", "text", i && l && "filtered"),
                f = r;
              return o ? f = o : c && !t ? f = mi()(n.getSelectedItem(), "text") : d && (f = mi()(n.getItemByValue(u), "text")), a.a.createElement("div", {
                className: h,
                role: "alert",
                "aria-live": "polite",
                "aria-atomic": !0
              }, f);
            }), F()(N()(n), "renderSearchInput", function () {
              var e = n.props,
                t = e.search,
                r = e.searchInput,
                i = n.state.searchQuery;
              return t && a.a.createElement(S, {
                innerRef: n.searchRef
              }, eo.create(r, {
                defaultProps: {
                  style: {
                    width: n.computeSearchInputWidth()
                  },
                  tabIndex: n.computeSearchInputTabIndex(),
                  value: i
                },
                overrideProps: n.handleSearchInputOverrides
              }));
            }), F()(N()(n), "renderSearchSizer", function () {
              var e = n.props,
                t = e.search,
                r = e.multiple;
              return t && r && a.a.createElement("span", {
                className: "sizer",
                ref: n.sizerRef
              });
            }), F()(N()(n), "renderLabels", function () {
              var e = n.props,
                t = e.multiple,
                r = e.renderLabel,
                i = n.state,
                o = i.selectedLabel,
                a = i.value;
              if (t && !gn()(a)) {
                var s = Gn()(a, n.getItemByValue);
                return Gn()(Ai()(s), function (e, t) {
                  var i = {
                    active: e.value === o,
                    as: "a",
                    key: to(e.key, e.value),
                    onClick: n.handleLabelClick,
                    onRemove: n.handleLabelRemove,
                    value: e.value
                  };
                  return Bn.create(r(e, t, i), {
                    defaultProps: i
                  });
                });
              }
            }), F()(N()(n), "renderOptions", function () {
              var e = n.props,
                t = e.lazyLoad,
                r = e.multiple,
                i = e.search,
                o = e.noResultsMessage,
                s = n.state,
                l = s.open,
                u = s.selectedIndex,
                c = s.value;
              if (t && !l) return null;
              var d = n.getMenuOptions();
              if (null !== o && i && gn()(d)) return a.a.createElement("div", {
                className: "message"
              }, o);
              var h = r ? function (e) {
                return $t()(c, e);
              } : function (e) {
                return e === c;
              };
              return Gn()(d, function (e, t) {
                return Xi.create(mt()({
                  active: h(e.value),
                  onClick: n.handleItemClick,
                  selected: u === t
                }, e, {
                  key: to(e.key, e.value),
                  style: mt()({}, e.style, {
                    pointerEvents: "all"
                  })
                }));
              });
            }), F()(N()(n), "renderMenu", function () {
              var e = n.props,
                t = e.children,
                i = e.direction,
                s = e.header,
                l = n.state.open,
                u = n.getDropdownMenuAriaOptions();
              if (!r.isNil(t)) {
                var c = o.Children.only(t),
                  d = K()(i, at(l, "visible"), c.props.className);
                return Object(o.cloneElement)(c, mt()({
                  className: d
                }, u));
              }
              return a.a.createElement(Qi, E()({}, u, {
                direction: i,
                open: l
              }), Ki.create(s, {
                autoGenerateKey: !1
              }), n.renderOptions());
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "getInitialAutoControlledState",
            value: function value() {
              return {
                focus: !1,
                searchQuery: ""
              };
            }
          }, {
            key: "UNSAFE_componentWillMount",
            value: function value() {
              var e = this.state,
                t = e.open,
                n = e.value;
              this.setValue(n), this.setSelectedIndex(n), t && this.open();
            }
          }, {
            key: "UNSAFE_componentWillReceiveProps",
            value: function value(e) {
              wi()(I()(t.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, e), er()(e.value, this.props.value) || (this.setValue(e.value), this.setSelectedIndex(e.value)), Gi()(this.getKeyAndValues(e.options), this.getKeyAndValues(this.props.options)) || this.setSelectedIndex(void 0, e.options);
            }
          }, {
            key: "shouldComponentUpdate",
            value: function value(e, t) {
              return !er()(e, this.props) || !er()(t, this.state);
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e, t) {
              var n = this.props,
                r = n.closeOnBlur,
                i = n.minCharacters,
                o = n.openOnFocus,
                a = n.search;
              if (!t.focus && this.state.focus) {
                if (!this.isMouseDown) {
                  var s = !a || a && 1 === i && !this.state.open;
                  o && s && this.open();
                }
              } else t.focus && !this.state.focus && !this.isMouseDown && r && this.close();
              !t.open && this.state.open ? (this.setOpenDirection(), this.scrollSelectedItemIntoView()) : t.open && this.state.open;
            }
          }, {
            key: "getDropdownMenuAriaOptions",
            value: function value() {
              var e = this.props,
                t = e.search,
                n = e.multiple,
                r = {};
              return t && (r["aria-multiselectable"] = n, r.role = "listbox"), r;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.basic,
                r = e.button,
                i = e.className,
                o = e.compact,
                s = e.disabled,
                l = e.error,
                u = e.fluid,
                c = e.floating,
                d = e.icon,
                h = e.inline,
                f = e.item,
                p = e.labeled,
                m = e.loading,
                g = e.multiple,
                v = e.pointing,
                y = e.search,
                b = e.selection,
                _ = e.scrolling,
                x = e.simple,
                w = e.trigger,
                A = this.state,
                T = A.focus,
                M = A.open,
                C = A.upward,
                k = K()("ui", at(M, "active visible"), at(s, "disabled"), at(l, "error"), at(m, "loading"), at(n, "basic"), at(r, "button"), at(o, "compact"), at(u, "fluid"), at(c, "floating"), at(h, "inline"), at(p, "labeled"), at(f, "item"), at(g, "multiple"), at(y, "search"), at(b, "selection"), at(x, "simple"), at(_, "scrolling"), at(C, "upward"), lt(v, "pointing"), "dropdown", i),
                P = H(t, this.props),
                O = ft(t, this.props),
                R = this.getDropdownAriaOptions(O, this.props);
              return a.a.createElement(S, {
                innerRef: this.ref
              }, a.a.createElement(O, E()({}, P, R, {
                className: k,
                onBlur: this.handleBlur,
                onClick: this.handleClick,
                onMouseDown: this.handleMouseDown,
                onFocus: this.handleFocus,
                onChange: this.handleChange,
                tabIndex: this.computeTabIndex()
              }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), w || this.renderText(), Ut.create(d, {
                overrideProps: this.handleIconOverrides,
                autoGenerateKey: !1
              }), this.renderMenu(), M && a.a.createElement(on.a, {
                name: "keydown",
                on: this.closeOnEscape
              }), M && a.a.createElement(on.a, {
                name: "keydown",
                on: this.moveSelectionOnKeyDown
              }), M && a.a.createElement(on.a, {
                name: "click",
                on: this.closeOnDocumentClick
              }), M && a.a.createElement(on.a, {
                name: "keydown",
                on: this.selectItemOnEnter
              }), T && a.a.createElement(on.a, {
                name: "keydown",
                on: this.removeItemOnBackspace
              }), T && !M && a.a.createElement(on.a, {
                name: "keydown",
                on: this.openOnArrow
              }), T && !M && a.a.createElement(on.a, {
                name: "keydown",
                on: this.openOnSpace
              })));
            }
          }]), t;
        }(xn);
      function ro(e) {
        return a.a.createElement(no, E()({}, e, {
          selection: !0
        }));
      }
      F()(no, "defaultProps", {
        additionLabel: "Add ",
        additionPosition: "top",
        closeOnBlur: !0,
        closeOnEscape: !0,
        deburr: !1,
        icon: "dropdown",
        minCharacters: 1,
        noResultsMessage: "No results found.",
        openOnFocus: !0,
        renderLabel: function renderLabel(e) {
          return e.text;
        },
        searchInput: "text",
        selectOnBlur: !0,
        selectOnNavigation: !0,
        wrapSelection: !0
      }), F()(no, "autoControlledProps", ["open", "searchQuery", "selectedLabel", "value", "upward"]), F()(no, "Divider", Hi), F()(no, "Header", Ki), F()(no, "Item", Xi), F()(no, "Menu", Qi), F()(no, "SearchInput", eo), F()(no, "handledProps", ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"]), no.propTypes = {}, ro.handledProps = ["options"], ro.propTypes = {}, ro.Divider = no.Divider, ro.Header = no.Header, ro.Item = no.Item, ro.Menu = no.Menu;
      var io = ro,
        oo = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "ref", Object(o.createRef)()), F()(N()(n), "focus", function () {
              return n.ref.current.focus();
            }), F()(N()(n), "handleChange", function (e) {
              var t = mi()(e, "target.value");
              V()(n.props, "onChange", e, mt()({}, n.props, {
                value: t
              }));
            }), F()(N()(n), "handleInput", function (e) {
              var t = mi()(e, "target.value");
              V()(n.props, "onInput", e, mt()({}, n.props, {
                value: t
              }));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.rows,
                r = e.value,
                i = H(t, this.props),
                o = ft(t, this.props);
              return a.a.createElement(S, {
                innerRef: this.ref
              }, a.a.createElement(o, E()({}, i, {
                onChange: this.handleChange,
                onInput: this.handleInput,
                rows: n,
                value: r
              })));
            }
          }]), t;
        }(o.Component);
      F()(oo, "defaultProps", {
        as: "textarea",
        rows: 3
      }), F()(oo, "handledProps", ["as", "onChange", "onInput", "rows", "value"]), oo.propTypes = {};
      var ao = oo,
        so = function so(e, t) {
          return "number" == typeof e || "string" == typeof e ? e : e[t];
        },
        lo = n("./node_modules/lodash/mapValues.js"),
        uo = n.n(lo),
        co = n("./node_modules/lodash/keyBy.js"),
        ho = n.n(co),
        fo = function fo(e) {
          return ho()(pn()(o.Children.toArray(e), o.isValidElement), "key");
        },
        po = function po(e, t) {
          var n = {},
            r = [];
          return Yt()(ue()(e), function (e) {
            U()(t, e) ? r.length && (n[e] = r, r = []) : r.push(e);
          }), [n, r];
        },
        mo = function mo(e, t, n) {
          return U()(n, e) ? n[e] : t[e];
        },
        go = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleOnHide", function (e, t) {
              var r = t.reactKey;
              n.setState(function (e) {
                var t = mt()({}, e.children);
                return delete t[r], {
                  children: t
                };
              });
            }), F()(N()(n), "wrapChild", function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = n.props,
                i = r.animation,
                o = r.directional,
                s = r.duration,
                l = e.key,
                u = t.visible,
                c = void 0 === u || u,
                d = t.transitionOnMount,
                h = void 0 !== d && d;
              return a.a.createElement(yo, {
                animation: i,
                directional: o,
                duration: s,
                key: l,
                onHide: n.handleOnHide,
                reactKey: l,
                transitionOnMount: h,
                visible: c
              }, e);
            });
            var s = n.props.children;
            return n.state = {
              children: uo()(fo(s), function (e) {
                return n.wrapChild(e);
              })
            }, n;
          }
          return D()(t, e), k()(t, [{
            key: "UNSAFE_componentWillReceiveProps",
            value: function value(e) {
              var t = this,
                n = this.state.children,
                r = fo(e.children),
                i = function () {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = {},
                    r = po(e, t),
                    i = qt()(r, 2),
                    o = i[0],
                    a = i[1];
                  return Yt()(ue()(t), function (r) {
                    U()(o, r) && Yt()(o[r], function (r) {
                      n[r] = mo(r, e, t);
                    }), n[r] = mo(r, e, t);
                  }), Yt()(a, function (r) {
                    n[r] = mo(r, e, t);
                  }), n;
                }(n, r);
              Yt()(i, function (e, a) {
                var s = U()(n, a),
                  l = U()(r, a),
                  u = n[a],
                  c = !mi()(u, "props.visible");
                if (!l || s && !c) {
                  if (l || !s || c) {
                    var d = u.props,
                      h = d.visible,
                      f = d.transitionOnMount;
                    i[a] = t.wrapChild(e, {
                      transitionOnMount: f,
                      visible: h
                    });
                  } else i[a] = Object(o.cloneElement)(u, {
                    visible: !1
                  });
                } else i[a] = t.wrapChild(e, {
                  transitionOnMount: !0
                });
              }), this.setState({
                children: i
              });
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.state.children,
                n = ft(t, this.props),
                r = H(t, this.props);
              return a.a.createElement(n, r, se()(e));
            }
          }]), t;
        }(a.a.Component);
      F()(go, "defaultProps", {
        as: o.Fragment,
        animation: "fade",
        duration: 500
      }), F()(go, "handledProps", ["animation", "as", "children", "directional", "duration"]), go.propTypes = {};
      var vo = {
          ENTERING: "show",
          EXITING: "hide"
        },
        yo = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
            n = O()(this, (e = I()(t)).call.apply(e, [this].concat(o))), F()(N()(n), "handleStart", function () {
              var e = n.props.duration,
                t = n.nextStatus;
              n.nextStatus = null, n.setState({
                status: t,
                animating: !0
              }, function () {
                var r = so(e, vo[t]);
                V()(n.props, "onStart", null, mt()({}, n.props, {
                  status: t
                })), n.timeoutId = setTimeout(n.handleComplete, r);
              });
            }), F()(N()(n), "handleComplete", function () {
              var e = n.state.status;
              if (V()(n.props, "onComplete", null, mt()({}, n.props, {
                status: e
              })), n.nextStatus) n.handleStart();else {
                var r = n.computeCompletedStatus(),
                  i = e === t.ENTERING ? "onShow" : "onHide";
                n.setState({
                  status: r,
                  animating: !1
                }, function () {
                  V()(n.props, i, null, mt()({}, n.props, {
                    status: r
                  }));
                });
              }
            }), F()(N()(n), "updateStatus", function () {
              var e = n.state.animating;
              n.nextStatus && (n.nextStatus = n.computeNextStatus(), e || n.handleStart());
            }), F()(N()(n), "computeClasses", function () {
              var e = n.props,
                r = e.animation,
                o = e.directional,
                a = e.children,
                s = n.state,
                l = s.animating,
                u = s.status,
                c = mi()(a, "props.className");
              return (X()(o) ? $t()(i.DIRECTIONAL_TRANSITIONS, r) : o) ? K()(r, c, at(l, "animating"), at(u === t.ENTERING, "in"), at(u === t.EXITING, "out"), at(u === t.EXITED, "hidden"), at(u !== t.EXITED, "visible"), "transition") : K()(r, c, at(l, "animating transition"));
            }), F()(N()(n), "computeCompletedStatus", function () {
              var e = n.props.unmountOnHide;
              return n.state.status === t.ENTERING ? t.ENTERED : e ? t.UNMOUNTED : t.EXITED;
            }), F()(N()(n), "computeInitialStatuses", function () {
              var e = n.props,
                r = e.visible,
                i = e.mountOnShow,
                o = e.transitionOnMount,
                a = e.unmountOnHide;
              return r ? o ? {
                initial: t.EXITED,
                next: t.ENTERING
              } : {
                initial: t.ENTERED
              } : i || a ? {
                initial: t.UNMOUNTED
              } : {
                initial: t.EXITED
              };
            }), F()(N()(n), "computeNextStatus", function () {
              var e = n.state,
                r = e.animating,
                i = e.status;
              return r ? i === t.ENTERING ? t.EXITING : t.ENTERING : i === t.ENTERED ? t.EXITING : t.ENTERING;
            }), F()(N()(n), "computeStatuses", function (e) {
              var r = n.state.status;
              return e.visible ? {
                current: r === t.UNMOUNTED && t.EXITED,
                next: r !== t.ENTERING && r !== t.ENTERED && t.ENTERING
              } : {
                next: (r === t.ENTERING || r === t.ENTERED) && t.EXITING
              };
            }), F()(N()(n), "computeStyle", function () {
              var e = n.props,
                t = e.children,
                r = e.duration,
                i = n.state.status,
                o = mi()(t, "props.style"),
                a = vo[i],
                s = a && "".concat(so(r, a), "ms");
              return mt()({}, o, {
                animationDuration: s
              });
            });
            var s = n.computeInitialStatuses(),
              l = s.initial,
              u = s.next;
            return n.nextStatus = u, n.state = {
              status: l
            }, n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidMount",
            value: function value() {
              this.updateStatus();
            }
          }, {
            key: "UNSAFE_componentWillReceiveProps",
            value: function value(e) {
              var t = this.computeStatuses(e),
                n = t.current,
                r = t.next;
              this.nextStatus = r, n && this.setState({
                status: n
              });
            }
          }, {
            key: "componentDidUpdate",
            value: function value() {
              this.updateStatus();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              clearTimeout(this.timeoutId);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props.children;
              return this.state.status === t.UNMOUNTED ? null : Object(o.cloneElement)(e, {
                className: this.computeClasses(),
                style: this.computeStyle()
              });
            }
          }]), t;
        }(o.Component);
      F()(yo, "defaultProps", {
        animation: "fade",
        duration: 500,
        visible: !0,
        mountOnShow: !0,
        transitionOnMount: !1,
        unmountOnHide: !1
      }), F()(yo, "ENTERED", "ENTERED"), F()(yo, "ENTERING", "ENTERING"), F()(yo, "EXITED", "EXITED"), F()(yo, "EXITING", "EXITING"), F()(yo, "UNMOUNTED", "UNMOUNTED"), F()(yo, "Group", go), F()(yo, "handledProps", ["animation", "children", "directional", "duration", "mountOnShow", "onComplete", "onHide", "onShow", "onStart", "reactKey", "transitionOnMount", "unmountOnHide", "visible"]), yo.propTypes = {};
      var bo = function (e) {
        function t(e) {
          var n;
          return M()(this, t), n = O()(this, I()(t).call(this, e)), F()(N()(n), "handlePortalClose", function () {
            n.setState({
              portalOpen: !1
            });
          }), F()(N()(n), "handlePortalOpen", function () {
            n.setState({
              portalOpen: !0
            });
          }), F()(N()(n), "handleTransitionHide", function (e, t) {
            var r = n.state.portalOpen;
            n.setState({
              transitionVisible: !1
            }), V()(n.props, "onClose", null, mt()({}, t, {
              portalOpen: !1,
              transitionVisible: !1
            })), V()(n.props, "onHide", null, mt()({}, t, {
              portalOpen: r,
              transitionVisible: !1
            }));
          }), F()(N()(n), "handleTransitionStart", function (e, t) {
            var r = n.state.portalOpen,
              i = t.status === yo.ENTERING;
            V()(n.props, "onStart", null, mt()({}, t, {
              portalOpen: r,
              transitionVisible: i
            })), i && (n.setState({
              transitionVisible: i
            }), V()(n.props, "onOpen", null, mt()({}, t, {
              transitionVisible: i,
              portalOpen: !0
            })));
          }), n.state = {
            portalOpen: e.open
          }, n;
        }
        return D()(t, e), k()(t, [{
          key: "UNSAFE_componentWillReceiveProps",
          value: function value(e) {
            var t = e.open;
            this.setState({
              portalOpen: t
            });
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
              n = e.children,
              r = e.transition,
              i = this.state,
              o = i.portalOpen,
              s = i.transitionVisible,
              l = o || s,
              u = H(t, this.props);
            return a.a.createElement(En, E()({}, u, {
              open: l,
              onOpen: this.handlePortalOpen,
              onClose: this.handlePortalClose
            }), a.a.createElement(yo, E()({}, r, {
              transitionOnMount: !0,
              onStart: this.handleTransitionStart,
              onHide: this.handleTransitionHide,
              visible: o
            }), n));
          }
        }]), t;
      }(o.Component);
      F()(bo, "defaultProps", {
        transition: {
          animation: "scale",
          duration: 400
        }
      }), F()(bo, "handledProps", ["children", "onClose", "onHide", "onOpen", "onStart", "open", "transition"]), bo.propTypes = {};
      var _o = function (e) {
        function t() {
          var e, n;
          M()(this, t);
          for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
          return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "calculations", {
            bottomPassed: !1,
            bottomVisible: !1,
            fits: !1,
            passing: !1,
            offScreen: !1,
            onScreen: !1,
            topPassed: !1,
            topVisible: !1
          }), F()(N()(n), "firedCallbacks", []), F()(N()(n), "ref", Object(o.createRef)()), F()(N()(n), "fire", function (e, t) {
            var r = e.callback,
              i = e.name,
              o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              a = n.props,
              s = a.continuous,
              l = a.once,
              u = n.calculations[t] !== o,
              c = s || n.calculations[t] !== n.oldCalculations[t];
            u && c && n.execute(r, i), l || (n.firedCallbacks = Dt()(n.firedCallbacks, i));
          }), F()(N()(n), "handleUpdate", function () {
            n.ticking || (n.ticking = !0, n.frameId = requestAnimationFrame(n.update));
          }), F()(N()(n), "update", function () {
            if (n.mounted) {
              n.ticking = !1, n.oldCalculations = n.calculations, n.calculations = n.computeCalculations(), n.pageYOffset = n.getPageYOffset();
              var e = n.props,
                t = e.onBottomPassed,
                r = e.onBottomPassedReverse,
                i = e.onBottomVisible,
                o = e.onBottomVisibleReverse,
                a = e.onPassing,
                s = e.onPassingReverse,
                l = e.onTopPassed,
                u = e.onTopPassedReverse,
                c = e.onTopVisible,
                d = e.onTopVisibleReverse,
                h = e.onOffScreen,
                f = e.onOnScreen,
                p = e.updateOn,
                m = {
                  bottomPassed: {
                    callback: t,
                    name: "onBottomPassed"
                  },
                  bottomVisible: {
                    callback: i,
                    name: "onBottomVisible"
                  },
                  passing: {
                    callback: a,
                    name: "onPassing"
                  },
                  offScreen: {
                    callback: h,
                    name: "onOffScreen"
                  },
                  onScreen: {
                    callback: f,
                    name: "onOnScreen"
                  },
                  topPassed: {
                    callback: l,
                    name: "onTopPassed"
                  },
                  topVisible: {
                    callback: c,
                    name: "onTopVisible"
                  }
                },
                g = {
                  bottomPassed: {
                    callback: r,
                    name: "onBottomPassedReverse"
                  },
                  bottomVisible: {
                    callback: o,
                    name: "onBottomVisibleReverse"
                  },
                  passing: {
                    callback: s,
                    name: "onPassingReverse"
                  },
                  topPassed: {
                    callback: u,
                    name: "onTopPassedReverse"
                  },
                  topVisible: {
                    callback: d,
                    name: "onTopVisibleReverse"
                  }
                };
              V()(n.props, "onUpdate", null, mt()({}, n.props, {
                calculations: n.calculations
              })), n.fireOnPassed(), Yt()(g, function (e, t) {
                return n.fire(e, t, !0);
              }), Yt()(m, function (e, t) {
                return n.fire(e, t);
              }), "repaint" === p && n.handleUpdate();
            }
          }), n;
        }
        return D()(t, e), k()(t, [{
          key: "UNSAFE_componentWillReceiveProps",
          value: function value(e) {
            var t = e.continuous,
              n = e.once,
              r = e.context,
              i = e.updateOn;
            (t !== this.props.continuous || n !== this.props.once || i !== this.props.updateOn) && (this.firedCallbacks = []), r === this.props.context && i === this.props.updateOn || (this.unattachHandlers(this.props.context), this.attachHandlers(r, i));
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            if (this.mounted = !0, nn()) {
              var e = this.props,
                t = e.context,
                n = e.fireOnMount,
                r = e.updateOn;
              this.pageYOffset = this.getPageYOffset(), this.attachHandlers(t, r), n && this.update();
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            var e = this.props.context;
            this.unattachHandlers(e), this.mounted = !1;
          }
        }, {
          key: "attachHandlers",
          value: function value(e, t) {
            "events" !== t ? this.handleUpdate() : e && (tr.sub("resize", this.handleUpdate, {
              target: e
            }), tr.sub("scroll", this.handleUpdate, {
              target: e
            }));
          }
        }, {
          key: "unattachHandlers",
          value: function value(e) {
            e && (tr.unsub("resize", this.handleUpdate, {
              target: e
            }), tr.unsub("scroll", this.handleUpdate, {
              target: e
            })), this.frameId && cancelAnimationFrame(this.frameId);
          }
        }, {
          key: "execute",
          value: function value(e, t) {
            var n = this.props.continuous;
            e && (!n && $t()(this.firedCallbacks, t) || (e(null, mt()({}, this.props, {
              calculations: this.calculations
            })), this.firedCallbacks.push(t)));
          }
        }, {
          key: "fireOnPassed",
          value: function value() {
            var e = this,
              t = this.calculations,
              n = t.percentagePassed,
              r = t.pixelsPassed,
              i = this.props.onPassed;
            Yt()(i, function (t, i) {
              var o = Number(i);
              if (o && r >= o) e.execute(t, i);else {
                var a = "".concat(i).match(/^(\d+)%$/);
                if (a) {
                  var s = Number(a[1]) / 100;
                  n >= s && e.execute(t, i);
                }
              }
            });
          }
        }, {
          key: "computeCalculations",
          value: function value() {
            var e,
              t = this.props.offset,
              n = this.ref.current.getBoundingClientRect(),
              r = n.bottom,
              i = n.height,
              o = n.top,
              a = n.width,
              s = "number" == typeof (e = t) || "string" == typeof e ? [e, e] : e,
              l = qt()(s, 2),
              u = l[0],
              c = l[1],
              d = this.getPageYOffset() > this.pageYOffset ? "down" : "up",
              h = o < u,
              f = r < c,
              p = f ? 0 : Math.max(-1 * o, 0),
              m = p / i,
              g = r >= c && r <= window.innerHeight,
              v = o >= u && o <= window.innerHeight,
              y = (v || h) && !f;
            return {
              bottomPassed: f,
              bottomVisible: g,
              direction: d,
              fits: v && g,
              height: i,
              passing: h && !f,
              percentagePassed: m,
              pixelsPassed: p,
              offScreen: !y,
              onScreen: y,
              topPassed: h,
              topVisible: v,
              width: a
            };
          }
        }, {
          key: "getPageYOffset",
          value: function value() {
            var e = this.props.context;
            return e ? e === window ? window.pageYOffset : e.scrollTop : 0;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props.children,
              n = ft(t, this.props),
              r = H(t, this.props);
            return a.a.createElement(S, {
              innerRef: this.ref
            }, a.a.createElement(n, r, e));
          }
        }]), t;
      }(o.Component);
      function xo(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.icon,
          s = K()("divider", n),
          l = H(xo, e),
          u = ft(xo, e);
        return X()(o) ? X()(i) ? a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? "/" : t) : a.a.createElement(u, E()({}, l, {
          className: s
        }), i) : Ut.create(o, {
          defaultProps: mt()({}, l, {
            className: s
          }),
          autoGenerateKey: !1
        });
      }
      F()(_o, "defaultProps", {
        context: nn() ? window : null,
        continuous: !1,
        offset: [0, 0],
        once: !0,
        updateOn: "events"
      }), F()(_o, "handledProps", ["as", "children", "context", "continuous", "fireOnMount", "offset", "onBottomPassed", "onBottomPassedReverse", "onBottomVisible", "onBottomVisibleReverse", "onOffScreen", "onOnScreen", "onPassed", "onPassing", "onPassingReverse", "onTopPassed", "onTopPassedReverse", "onTopVisible", "onTopVisibleReverse", "onUpdate", "once", "updateOn"]), _o.propTypes = {}, xo.handledProps = ["as", "children", "className", "content", "icon"], xo.propTypes = {}, xo.create = kt(xo, function (e) {
        return {
          icon: e
        };
      });
      var wo = xo,
        So = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "computeElementType", function () {
              var e = n.props,
                t = e.link,
                r = e.onClick;
              if (t || r) return "a";
            }), F()(N()(n), "handleClick", function (e) {
              return V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                o = e.className,
                s = e.content,
                l = e.href,
                u = K()(at(n, "active"), "section", o),
                c = H(t, this.props),
                d = ft(t, this.props, this.computeElementType);
              return a.a.createElement(d, E()({}, c, {
                className: u,
                href: l,
                onClick: this.handleClick
              }), r.isNil(i) ? s : i);
            }
          }]), t;
        }(o.Component);
      function Ao(e) {
        var t = e.children,
          n = e.className,
          i = e.divider,
          o = e.icon,
          s = e.sections,
          l = e.size,
          u = K()("ui", l, "breadcrumb", n),
          c = H(Ao, e),
          d = ft(Ao, e);
        if (!r.isNil(t)) return a.a.createElement(d, E()({}, c, {
          className: u
        }), t);
        var h = [];
        return yn()(s, function (e, t) {
          var n = So.create(e);
          if (h.push(n), t !== s.length - 1) {
            var r = "".concat(n.key, "_divider") || !1;
            h.push(wo.create({
              content: i,
              icon: o,
              key: r
            }));
          }
        }), a.a.createElement(d, E()({}, c, {
          className: u
        }), h);
      }
      F()(So, "handledProps", ["active", "as", "children", "className", "content", "href", "link", "onClick"]), So.propTypes = {}, So.create = kt(So, function (e) {
        return {
          content: e,
          link: !0
        };
      }), Ao.handledProps = ["as", "children", "className", "divider", "icon", "sections", "size"], Ao.propTypes = {}, Ao.Divider = wo, Ao.Section = So;
      var Eo = Ao;
      function To(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          s = e.control,
          l = e.disabled,
          u = e.error,
          c = e.inline,
          d = e.label,
          h = e.required,
          f = e.type,
          p = e.width,
          m = e.id,
          g = K()(at(l, "disabled"), at(u, "error"), at(c, "inline"), at(h, "required"), ht(p, "wide"), "field", n),
          v = H(To, e),
          y = ft(To, e),
          b = mi()(u, "pointing", "above"),
          _ = Bn.create(u, {
            autoGenerateKey: !1,
            defaultProps: {
              prompt: !0,
              pointing: b,
              id: m ? "".concat(m, "-error-message") : void 0,
              role: "alert",
              "aria-atomic": !0
            }
          }),
          x = ("below" === b || "right" === b) && _,
          w = ("above" === b || "left" === b) && _;
        if (X()(s)) return X()(d) ? a.a.createElement(y, E()({}, v, {
          className: g
        }), r.isNil(t) ? i : t) : a.a.createElement(y, E()({}, v, {
          className: g
        }), x, jt(d, {
          autoGenerateKey: !1
        }), w);
        var S = {
            "aria-describedby": m && u ? "".concat(m, "-error-message") : null,
            "aria-invalid": void 0 !== u || void 0
          },
          A = mt()({}, v, {
            content: i,
            children: t,
            disabled: l,
            required: h,
            type: f,
            id: m
          });
        return "input" !== s || "checkbox" !== f && "radio" !== f ? s === gi || s === yi ? a.a.createElement(y, {
          className: g
        }, x, Object(o.createElement)(s, mt()({}, S, A, {
          label: d
        })), w) : a.a.createElement(y, {
          className: g
        }, jt(d, {
          defaultProps: {
            htmlFor: m
          },
          autoGenerateKey: !1
        }), x, Object(o.createElement)(s, mt()({}, S, A)), w) : a.a.createElement(y, {
          className: g
        }, a.a.createElement("label", null, x, Object(o.createElement)(s, mt()({}, S, A)), " ", d, w));
      }
      To.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "id", "inline", "label", "required", "type", "width"], To.propTypes = {};
      var Mo = To;
      function Co(e) {
        var t = e.control,
          n = H(Co, e),
          r = ft(Co, e);
        return a.a.createElement(r, E()({}, n, {
          control: t
        }));
      }
      Co.handledProps = ["as", "control"], Co.propTypes = {}, Co.defaultProps = {
        as: Mo,
        control: Xn
      };
      var ko = Co;
      function Po(e) {
        var t = e.control,
          n = H(Po, e),
          r = ft(Po, e);
        return a.a.createElement(r, E()({}, n, {
          control: t
        }));
      }
      Po.handledProps = ["as", "control"], Po.propTypes = {}, Po.defaultProps = {
        as: Mo,
        control: gi
      };
      var Oo = Po;
      function Ro(e) {
        var t = e.control,
          n = H(Ro, e),
          r = ft(Ro, e);
        return a.a.createElement(r, E()({}, n, {
          control: t
        }));
      }
      Ro.handledProps = ["as", "control"], Ro.propTypes = {}, Ro.defaultProps = {
        as: Mo,
        control: no
      };
      var Io = Ro;
      function jo(e) {
        var t = e.children,
          n = e.className,
          r = e.grouped,
          i = e.inline,
          o = e.unstackable,
          s = e.widths,
          l = K()(at(r, "grouped"), at(i, "inline"), at(o, "unstackable"), ht(s, null, !0), "fields", n),
          u = H(jo, e),
          c = ft(jo, e);
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), t);
      }
      jo.handledProps = ["as", "children", "className", "grouped", "inline", "unstackable", "widths"], jo.propTypes = {};
      var No = jo,
        Lo = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "inputRef", Object(o.createRef)()), F()(N()(n), "computeIcon", function () {
              var e = n.props,
                t = e.loading,
                r = e.icon;
              return X()(r) ? t ? "spinner" : void 0 : r;
            }), F()(N()(n), "computeTabIndex", function () {
              var e = n.props,
                t = e.disabled,
                r = e.tabIndex;
              return X()(r) ? t ? -1 : void 0 : r;
            }), F()(N()(n), "focus", function () {
              return n.inputRef.current.focus();
            }), F()(N()(n), "select", function () {
              return n.inputRef.current.select();
            }), F()(N()(n), "handleChange", function (e) {
              var t = mi()(e, "target.value");
              V()(n.props, "onChange", e, mt()({}, n.props, {
                value: t
              }));
            }), F()(N()(n), "handleChildOverrides", function (e, t) {
              return mt()({}, t, e.props, {
                ref: function ref(t) {
                  b(e.ref, t), n.inputRef.current = t;
                }
              });
            }), F()(N()(n), "partitionProps", function () {
              var e = n.props,
                r = e.disabled,
                i = e.type,
                o = n.computeTabIndex(),
                a = H(t, n.props),
                s = Jt(a),
                l = qt()(s, 2),
                u = l[0],
                c = l[1];
              return [mt()({}, u, {
                disabled: r,
                type: i,
                tabIndex: o,
                onChange: n.handleChange,
                ref: n.inputRef
              }), c];
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this,
                n = this.props,
                i = n.action,
                s = n.actionPosition,
                l = n.children,
                u = n.className,
                c = n.disabled,
                d = n.error,
                h = n.fluid,
                f = n.focus,
                p = n.icon,
                m = n.iconPosition,
                g = n.input,
                v = n.inverted,
                y = n.label,
                b = n.labelPosition,
                _ = n.loading,
                x = n.size,
                w = n.transparent,
                S = n.type,
                A = K()("ui", x, at(c, "disabled"), at(d, "error"), at(h, "fluid"), at(f, "focus"), at(v, "inverted"), at(_, "loading"), at(w, "transparent"), st(s, "action") || at(i, "action"), st(m, "icon") || at(p || _, "icon"), st(b, "labeled") || at(y, "labeled"), "input", u),
                T = ft(t, this.props),
                M = this.partitionProps(),
                C = qt()(M, 2),
                k = C[0],
                P = C[1];
              if (!r.isNil(l)) {
                var O = Gn()(o.Children.toArray(l), function (t) {
                  return "input" !== t.type ? t : Object(o.cloneElement)(t, e.handleChildOverrides(t, k));
                });
                return a.a.createElement(T, E()({}, P, {
                  className: A
                }), O);
              }
              var R = Xn.create(i, {
                  autoGenerateKey: !1
                }),
                I = Bn.create(y, {
                  defaultProps: {
                    className: K()("label", $t()(b, "corner") && b)
                  },
                  autoGenerateKey: !1
                });
              return a.a.createElement(T, E()({}, P, {
                className: A
              }), "left" === s && R, "right" !== b && I, It(g || S, {
                defaultProps: k,
                autoGenerateKey: !1
              }), Ut.create(this.computeIcon(), {
                autoGenerateKey: !1
              }), "left" !== s && R, "right" === b && I);
            }
          }]), t;
        }(o.Component);
      F()(Lo, "defaultProps", {
        type: "text"
      }), F()(Lo, "handledProps", ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"]), Lo.propTypes = {}, Lo.create = kt(Lo, function (e) {
        return {
          type: e
        };
      });
      var Do = Lo;
      function Bo(e) {
        var t = e.control,
          n = H(Bo, e),
          r = ft(Bo, e);
        return a.a.createElement(r, E()({}, n, {
          control: t
        }));
      }
      Bo.handledProps = ["as", "control"], Bo.propTypes = {}, Bo.defaultProps = {
        as: Mo,
        control: Do
      };
      var Fo = Bo;
      function zo(e) {
        var t = e.control,
          n = H(zo, e),
          r = ft(zo, e);
        return a.a.createElement(r, E()({}, n, {
          control: t
        }));
      }
      zo.handledProps = ["as", "control"], zo.propTypes = {}, zo.defaultProps = {
        as: Mo,
        control: yi
      };
      var Uo = zo;
      function Go(e) {
        var t = e.control,
          n = e.options,
          r = H(Go, e),
          i = ft(Go, e);
        return a.a.createElement(i, E()({}, r, {
          control: t,
          options: n
        }));
      }
      Go.handledProps = ["as", "control", "options"], Go.propTypes = {}, Go.defaultProps = {
        as: Mo,
        control: io
      };
      var Vo = Go;
      function Ho(e) {
        var t = e.control,
          n = H(Ho, e),
          r = ft(Ho, e);
        return a.a.createElement(r, E()({}, n, {
          control: t
        }));
      }
      Ho.handledProps = ["as", "control"], Ho.propTypes = {}, Ho.defaultProps = {
        as: Mo,
        control: ao
      };
      var qo = Ho,
        Wo = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleSubmit", function (e) {
              var t = n.props.action;
              "string" != typeof t && V()(e, "preventDefault");
              for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];
              V.a.apply(void 0, [n.props, "onSubmit", e, n.props].concat(i));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.action,
                r = e.children,
                i = e.className,
                o = e.error,
                s = e.inverted,
                l = e.loading,
                u = e.reply,
                c = e.size,
                d = e.success,
                h = e.unstackable,
                f = e.warning,
                p = e.widths,
                m = K()("ui", c, at(o, "error"), at(s, "inverted"), at(l, "loading"), at(u, "reply"), at(d, "success"), at(h, "unstackable"), at(f, "warning"), ht(p, null, !0), "form", i),
                g = H(t, this.props),
                v = ft(t, this.props);
              return a.a.createElement(v, E()({}, g, {
                action: n,
                className: m,
                onSubmit: this.handleSubmit
              }), r);
            }
          }]), t;
        }(o.Component);
      F()(Wo, "defaultProps", {
        as: "form"
      }), F()(Wo, "Field", Mo), F()(Wo, "Button", ko), F()(Wo, "Checkbox", Oo), F()(Wo, "Dropdown", Io), F()(Wo, "Group", No), F()(Wo, "Input", Fo), F()(Wo, "Radio", Uo), F()(Wo, "Select", Vo), F()(Wo, "TextArea", qo), F()(Wo, "handledProps", ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"]), Wo.propTypes = {};
      var $o = Wo;
      function Xo(e) {
        var t = e.children,
          n = e.className,
          r = e.computer,
          i = e.color,
          o = e.floated,
          s = e.largeScreen,
          l = e.mobile,
          u = e.only,
          c = e.stretched,
          d = e.tablet,
          h = e.textAlign,
          f = e.verticalAlign,
          p = e.widescreen,
          m = e.width,
          g = K()(i, at(c, "stretched"), ut(u, "only"), ct(h), st(o, "floated"), dt(f), ht(r, "wide computer"), ht(s, "wide large screen"), ht(l, "wide mobile"), ht(d, "wide tablet"), ht(p, "wide widescreen"), ht(m, "wide"), "column", n),
          v = H(Xo, e),
          y = ft(Xo, e);
        return a.a.createElement(y, E()({}, v, {
          className: g
        }), t);
      }
      Xo.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"], Xo.propTypes = {}, Xo.create = kt(Xo, function (e) {
        return {
          children: e
        };
      });
      var Yo = Xo;
      function Ko(e) {
        var t = e.centered,
          n = e.children,
          r = e.className,
          i = e.color,
          o = e.columns,
          s = e.divided,
          l = e.only,
          u = e.reversed,
          c = e.stretched,
          d = e.textAlign,
          h = e.verticalAlign,
          f = K()(i, at(t, "centered"), at(s, "divided"), at(c, "stretched"), ut(l, "only"), ut(u, "reversed"), ct(d), dt(h), ht(o, "column", !0), "row", r),
          p = H(Ko, e),
          m = ft(Ko, e);
        return a.a.createElement(m, E()({}, p, {
          className: f
        }), n);
      }
      Ko.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"], Ko.propTypes = {};
      var Zo = Ko;
      function Qo(e) {
        var t = e.celled,
          n = e.centered,
          r = e.children,
          i = e.className,
          o = e.columns,
          s = e.container,
          l = e.divided,
          u = e.doubling,
          c = e.inverted,
          d = e.padded,
          h = e.relaxed,
          f = e.reversed,
          p = e.stackable,
          m = e.stretched,
          g = e.textAlign,
          v = e.verticalAlign,
          y = K()("ui", at(n, "centered"), at(s, "container"), at(u, "doubling"), at(c, "inverted"), at(p, "stackable"), at(m, "stretched"), lt(t, "celled"), lt(l, "divided"), lt(d, "padded"), lt(h, "relaxed"), ut(f, "reversed"), ct(g), dt(v), ht(o, "column", !0), "grid", i),
          b = H(Qo, e),
          _ = ft(Qo, e);
        return a.a.createElement(_, E()({}, b, {
          className: y
        }), r);
      }
      Qo.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"], Qo.Column = Yo, Qo.Row = Zo, Qo.propTypes = {};
      var Jo = Qo;
      function ea(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("content", n),
          s = H(ea, e),
          l = ft(ea, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      ea.handledProps = ["as", "children", "className", "content"], ea.propTypes = {};
      var ta = ea;
      function na(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("header", n),
          s = H(na, e),
          l = ft(na, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      na.handledProps = ["as", "children", "className", "content"], na.propTypes = {}, na.create = kt(na, function (e) {
        return {
          content: e
        };
      });
      var ra = na;
      function ia(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("content", n),
          s = H(ia, e),
          l = ft(ia, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      ia.handledProps = ["as", "children", "className", "content"], ia.propTypes = {}, ia.defaultProps = {
        as: "li"
      }, ia.create = kt(ia, function (e) {
        return {
          content: e
        };
      });
      var oa = ia;
      function aa(e) {
        var t = e.children,
          n = e.className,
          i = e.items,
          o = K()("list", n),
          s = H(aa, e),
          l = ft(aa, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? Gn()(i, oa.create) : t);
      }
      aa.handledProps = ["as", "children", "className", "items"], aa.propTypes = {}, aa.defaultProps = {
        as: "ul"
      }, aa.create = kt(aa, function (e) {
        return {
          items: e
        };
      });
      var sa = aa,
        la = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleDismiss", function (e) {
              var t = n.props.onDismiss;
              t && t(e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.attached,
                i = e.children,
                o = e.className,
                s = e.color,
                l = e.compact,
                u = e.content,
                c = e.error,
                d = e.floating,
                h = e.header,
                f = e.hidden,
                p = e.icon,
                m = e.info,
                g = e.list,
                v = e.negative,
                y = e.onDismiss,
                b = e.positive,
                _ = e.size,
                x = e.success,
                w = e.visible,
                S = e.warning,
                A = K()("ui", s, _, at(l, "compact"), at(c, "error"), at(d, "floating"), at(f, "hidden"), at(p, "icon"), at(m, "info"), at(v, "negative"), at(b, "positive"), at(x, "success"), at(w, "visible"), at(S, "warning"), lt(n, "attached"), "message", o),
                T = y && a.a.createElement(Ut, {
                  name: "close",
                  onClick: this.handleDismiss
                }),
                M = H(t, this.props),
                C = ft(t, this.props);
              return r.isNil(i) ? a.a.createElement(C, E()({}, M, {
                className: A
              }), T, Ut.create(p, {
                autoGenerateKey: !1
              }), (!X()(h) || !X()(u) || !X()(g)) && a.a.createElement(ta, null, ra.create(h, {
                autoGenerateKey: !1
              }), sa.create(g, {
                autoGenerateKey: !1
              }), Nt(u, {
                autoGenerateKey: !1
              }))) : a.a.createElement(C, E()({}, M, {
                className: A
              }), T, i);
            }
          }]), t;
        }(o.Component);
      function ua(e) {
        var t = e.children,
          n = e.className,
          r = K()(n),
          i = H(ua, e),
          o = ft(ua, e);
        return a.a.createElement(o, E()({}, i, {
          className: r
        }), t);
      }
      F()(la, "Content", ta), F()(la, "Header", ra), F()(la, "List", sa), F()(la, "Item", oa), F()(la, "handledProps", ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"]), la.propTypes = {}, ua.handledProps = ["as", "children", "className"], ua.defaultProps = {
        as: "tbody"
      }, ua.propTypes = {};
      var ca = ua;
      function da(e) {
        var t = e.active,
          n = e.children,
          i = e.className,
          o = e.collapsing,
          s = e.content,
          l = e.disabled,
          u = e.error,
          c = e.icon,
          d = e.negative,
          h = e.positive,
          f = e.selectable,
          p = e.singleLine,
          m = e.textAlign,
          g = e.verticalAlign,
          v = e.warning,
          y = e.width,
          b = K()(at(t, "active"), at(o, "collapsing"), at(l, "disabled"), at(u, "error"), at(d, "negative"), at(h, "positive"), at(f, "selectable"), at(p, "single line"), at(v, "warning"), ct(m), dt(g), ht(y, "wide"), i),
          _ = H(da, e),
          x = ft(da, e);
        return r.isNil(n) ? a.a.createElement(x, E()({}, _, {
          className: b
        }), Ut.create(c), s) : a.a.createElement(x, E()({}, _, {
          className: b
        }), n);
      }
      da.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"], da.defaultProps = {
        as: "td"
      }, da.propTypes = {}, da.create = kt(da, function (e) {
        return {
          content: e
        };
      });
      var ha = da;
      function fa(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.fullWidth,
          s = K()(at(o, "full-width"), n),
          l = H(fa, e),
          u = ft(fa, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      fa.handledProps = ["as", "children", "className", "content", "fullWidth"], fa.defaultProps = {
        as: "thead"
      }, fa.propTypes = {};
      var pa = fa;
      function ma(e) {
        var t = e.as,
          n = H(ma, e);
        return a.a.createElement(pa, E()({}, n, {
          as: t
        }));
      }
      ma.handledProps = ["as"], ma.propTypes = {}, ma.defaultProps = {
        as: "tfoot"
      };
      var ga = ma;
      function va(e) {
        var t = e.as,
          n = e.className,
          r = e.sorted,
          i = K()(st(r, "sorted"), n),
          o = H(va, e);
        return a.a.createElement(ha, E()({}, o, {
          as: t,
          className: i
        }));
      }
      va.handledProps = ["as", "className", "sorted"], va.propTypes = {}, va.defaultProps = {
        as: "th"
      };
      var ya = va;
      function ba(e) {
        var t = e.active,
          n = e.cellAs,
          i = e.cells,
          o = e.children,
          s = e.className,
          l = e.disabled,
          u = e.error,
          c = e.negative,
          d = e.positive,
          h = e.textAlign,
          f = e.verticalAlign,
          p = e.warning,
          m = K()(at(t, "active"), at(l, "disabled"), at(u, "error"), at(c, "negative"), at(d, "positive"), at(p, "warning"), ct(h), dt(f), s),
          g = H(ba, e),
          v = ft(ba, e);
        return r.isNil(o) ? a.a.createElement(v, E()({}, g, {
          className: m
        }), Gn()(i, function (e) {
          return ha.create(e, {
            defaultProps: {
              as: n
            }
          });
        })) : a.a.createElement(v, E()({}, g, {
          className: m
        }), o);
      }
      ba.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"], ba.defaultProps = {
        as: "tr",
        cellAs: "td"
      }, ba.propTypes = {}, ba.create = kt(ba, function (e) {
        return {
          cells: e
        };
      });
      var _a = ba;
      function xa(e) {
        var t = e.attached,
          n = e.basic,
          i = e.celled,
          o = e.children,
          s = e.className,
          l = e.collapsing,
          u = e.color,
          c = e.columns,
          d = e.compact,
          h = e.definition,
          f = e.fixed,
          p = e.footerRow,
          m = e.headerRow,
          g = e.headerRows,
          v = e.inverted,
          y = e.padded,
          b = e.renderBodyRow,
          _ = e.selectable,
          x = e.singleLine,
          w = e.size,
          S = e.sortable,
          A = e.stackable,
          T = e.striped,
          M = e.structured,
          C = e.tableData,
          k = e.textAlign,
          P = e.unstackable,
          O = e.verticalAlign,
          R = K()("ui", u, w, at(i, "celled"), at(l, "collapsing"), at(h, "definition"), at(f, "fixed"), at(v, "inverted"), at(_, "selectable"), at(x, "single line"), at(S, "sortable"), at(A, "stackable"), at(T, "striped"), at(M, "structured"), at(P, "unstackable"), lt(t, "attached"), lt(n, "basic"), lt(d, "compact"), lt(y, "padded"), ct(k), dt(O), ht(c, "column"), "table", s),
          I = H(xa, e),
          j = ft(xa, e);
        if (!r.isNil(o)) return a.a.createElement(j, E()({}, I, {
          className: R
        }), o);
        var N = {
            defaultProps: {
              cellAs: "th"
            }
          },
          L = (m || g) && a.a.createElement(pa, null, _a.create(m, N), Gn()(g, function (e) {
            return _a.create(e, N);
          }));
        return a.a.createElement(j, E()({}, I, {
          className: R
        }), L, a.a.createElement(ca, null, b && Gn()(C, function (e, t) {
          return _a.create(b(e, t));
        })), p && a.a.createElement(ga, null, _a.create(p)));
      }
      xa.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"], xa.defaultProps = {
        as: "table"
      }, xa.propTypes = {}, xa.Body = ca, xa.Cell = ha, xa.Footer = ga, xa.Header = pa, xa.HeaderCell = ya, xa.Row = _a;
      var wa = xa;
      function Sa(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.fluid,
          s = e.text,
          l = e.textAlign,
          u = K()("ui", at(s, "text"), at(o, "fluid"), ct(l), "container", n),
          c = H(Sa, e),
          d = ft(Sa, e);
        return a.a.createElement(d, E()({}, c, {
          className: u
        }), r.isNil(t) ? i : t);
      }
      Sa.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"], Sa.propTypes = {};
      var Aa = Sa;
      function Ea(e) {
        var t = e.children,
          n = e.className,
          i = e.clearing,
          o = e.content,
          s = e.fitted,
          l = e.hidden,
          u = e.horizontal,
          c = e.inverted,
          d = e.section,
          h = e.vertical,
          f = K()("ui", at(i, "clearing"), at(s, "fitted"), at(l, "hidden"), at(u, "horizontal"), at(c, "inverted"), at(d, "section"), at(h, "vertical"), "divider", n),
          p = H(Ea, e),
          m = ft(Ea, e);
        return a.a.createElement(m, E()({}, p, {
          className: f
        }), r.isNil(t) ? o : t);
      }
      Ea.handledProps = ["as", "children", "className", "clearing", "content", "fitted", "hidden", "horizontal", "inverted", "section", "vertical"], Ea.propTypes = {};
      var Ta = Ea;
      function Ma(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("sub header", n),
          s = H(Ma, e),
          l = ft(Ma, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Ma.handledProps = ["as", "children", "className", "content"], Ma.propTypes = {}, Ma.create = kt(Ma, function (e) {
        return {
          content: e
        };
      });
      var Ca = Ma;
      function ka(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("content", n),
          s = H(ka, e),
          l = ft(ka, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      ka.handledProps = ["as", "children", "className", "content"], ka.propTypes = {};
      var Pa = ka;
      function Oa(e) {
        var t = e.attached,
          n = e.block,
          i = e.children,
          o = e.className,
          s = e.color,
          l = e.content,
          u = e.disabled,
          c = e.dividing,
          d = e.floated,
          h = e.icon,
          f = e.image,
          p = e.inverted,
          m = e.size,
          g = e.sub,
          v = e.subheader,
          y = e.textAlign,
          b = K()("ui", s, m, at(n, "block"), at(u, "disabled"), at(c, "dividing"), st(d, "floated"), at(!0 === h, "icon"), at(!0 === f, "image"), at(p, "inverted"), at(g, "sub"), lt(t, "attached"), ct(y), "header", o),
          _ = H(Oa, e),
          x = ft(Oa, e);
        if (!r.isNil(i)) return a.a.createElement(x, E()({}, _, {
          className: b
        }), i);
        var w = Ut.create(h, {
            autoGenerateKey: !1
          }),
          S = In.create(f, {
            autoGenerateKey: !1
          }),
          A = Ca.create(v, {
            autoGenerateKey: !1
          });
        return w || S ? a.a.createElement(x, E()({}, _, {
          className: b
        }), w || S, (l || A) && a.a.createElement(Pa, null, l, A)) : a.a.createElement(x, E()({}, _, {
          className: b
        }), l, A);
      }
      Oa.handledProps = ["as", "attached", "block", "children", "className", "color", "content", "disabled", "dividing", "floated", "icon", "image", "inverted", "size", "sub", "subheader", "textAlign"], Oa.propTypes = {}, Oa.Content = Pa, Oa.Subheader = Ca;
      var Ra = Oa;
      function Ia(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()(n, "description"),
          s = H(Ia, e),
          l = ft(Ia, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Ia.handledProps = ["as", "children", "className", "content"], Ia.propTypes = {}, Ia.create = kt(Ia, function (e) {
        return {
          content: e
        };
      });
      var ja = Ia;
      function Na(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("header", n),
          s = H(Na, e),
          l = ft(Na, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Na.handledProps = ["as", "children", "className", "content"], Na.propTypes = {}, Na.create = kt(Na, function (e) {
        return {
          content: e
        };
      });
      var La = Na;
      function Da(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.description,
          s = e.floated,
          l = e.header,
          u = e.verticalAlign,
          c = K()(st(s, "floated"), dt(u), "content", n),
          d = H(Da, e),
          h = ft(Da, e);
        return r.isNil(t) ? a.a.createElement(h, E()({}, d, {
          className: c
        }), La.create(l), ja.create(o), i) : a.a.createElement(h, E()({}, d, {
          className: c
        }), t);
      }
      Da.handledProps = ["as", "children", "className", "content", "description", "floated", "header", "verticalAlign"], Da.propTypes = {}, Da.create = kt(Da, function (e) {
        return {
          content: e
        };
      });
      var Ba = Da;
      function Fa(e) {
        var t = e.className,
          n = e.verticalAlign,
          r = K()(dt(n), t),
          i = H(Fa, e);
        return a.a.createElement(Ut, E()({}, i, {
          className: r
        }));
      }
      Fa.handledProps = ["className", "verticalAlign"], Fa.propTypes = {}, Fa.create = kt(Fa, function (e) {
        return {
          name: e
        };
      });
      var za = Fa,
        Ua = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              n.props.disabled || V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                s = e.className,
                l = e.content,
                u = e.description,
                c = e.disabled,
                d = e.header,
                h = e.icon,
                f = e.image,
                p = e.value,
                m = ft(t, this.props),
                g = K()(at(n, "active"), at(c, "disabled"), at("li" !== m, "item"), s),
                v = H(t, this.props),
                y = "li" === m ? {
                  value: p
                } : {
                  "data-value": p
                };
              if (!r.isNil(i)) return a.a.createElement(m, E()({}, y, {
                role: "listitem",
                className: g,
                onClick: this.handleClick
              }, v), i);
              var b = za.create(h, {
                  autoGenerateKey: !1
                }),
                _ = In.create(f, {
                  autoGenerateKey: !1
                });
              if (!Object(o.isValidElement)(l) && bt()(l)) return a.a.createElement(m, E()({}, y, {
                role: "listitem",
                className: g,
                onClick: this.handleClick
              }, v), b || _, Ba.create(l, {
                autoGenerateKey: !1,
                defaultProps: {
                  header: d,
                  description: u
                }
              }));
              var x = La.create(d, {
                  autoGenerateKey: !1
                }),
                w = ja.create(u, {
                  autoGenerateKey: !1
                });
              return b || _ ? a.a.createElement(m, E()({}, y, {
                role: "listitem",
                className: g,
                onClick: this.handleClick
              }, v), b || _, (l || x || w) && a.a.createElement(Ba, null, x, w, l)) : a.a.createElement(m, E()({}, y, {
                role: "listitem",
                className: g,
                onClick: this.handleClick
              }, v), x, w, l);
            }
          }]), t;
        }(o.Component);
      F()(Ua, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "header", "icon", "image", "onClick", "value"]), Ua.propTypes = {}, Ua.create = kt(Ua, function (e) {
        return {
          content: e
        };
      });
      var Ga = Ua;
      function Va(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = H(Va, e),
          s = ft(Va, e),
          l = K()(at("ul" !== s && "ol" !== s, "list"), n);
        return a.a.createElement(s, E()({}, o, {
          className: l
        }), r.isNil(t) ? i : t);
      }
      Va.handledProps = ["as", "children", "className", "content"], Va.propTypes = {};
      var Ha = Va,
        qa = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleItemOverrides", function (e) {
              return {
                onClick: function onClick(t, r) {
                  V()(e, "onClick", t, r), V()(n.props, "onItemClick", t, r);
                }
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this,
                n = this.props,
                i = n.animated,
                o = n.bulleted,
                s = n.celled,
                l = n.children,
                u = n.className,
                c = n.content,
                d = n.divided,
                h = n.floated,
                f = n.horizontal,
                p = n.inverted,
                m = n.items,
                g = n.link,
                v = n.ordered,
                y = n.relaxed,
                b = n.selection,
                _ = n.size,
                x = n.verticalAlign,
                w = K()("ui", _, at(i, "animated"), at(o, "bulleted"), at(s, "celled"), at(d, "divided"), at(f, "horizontal"), at(p, "inverted"), at(g, "link"), at(v, "ordered"), at(b, "selection"), lt(y, "relaxed"), st(h, "floated"), dt(x), "list", u),
                S = H(t, this.props),
                A = ft(t, this.props);
              return r.isNil(l) ? r.isNil(c) ? a.a.createElement(A, E()({
                role: "list",
                className: w
              }, S), Gn()(m, function (t) {
                return Ga.create(t, {
                  overrideProps: e.handleItemOverrides
                });
              })) : a.a.createElement(A, E()({
                role: "list",
                className: w
              }, S), c) : a.a.createElement(A, E()({
                role: "list",
                className: w
              }, S), l);
            }
          }]), t;
        }(o.Component);
      F()(qa, "Content", Ba), F()(qa, "Description", ja), F()(qa, "Header", La), F()(qa, "Icon", za), F()(qa, "Item", Ga), F()(qa, "List", Ha), F()(qa, "handledProps", ["animated", "as", "bulleted", "celled", "children", "className", "content", "divided", "floated", "horizontal", "inverted", "items", "link", "onItemClick", "ordered", "relaxed", "selection", "size", "verticalAlign"]), qa.propTypes = {};
      var Wa = qa;
      function $a(e) {
        var t = e.active,
          n = e.children,
          i = e.className,
          o = e.content,
          s = e.disabled,
          l = e.indeterminate,
          u = e.inline,
          c = e.inverted,
          d = e.size,
          h = K()("ui", d, at(t, "active"), at(s, "disabled"), at(l, "indeterminate"), at(c, "inverted"), at(n || o, "text"), lt(u, "inline"), "loader", i),
          f = H($a, e),
          p = ft($a, e);
        return a.a.createElement(p, E()({}, f, {
          className: h
        }), r.isNil(n) ? o : n);
      }
      $a.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"], $a.propTypes = {};
      var Xa = $a;
      function Ya(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.image,
          s = K()(at(o, "image"), "header", n),
          l = H(Ya, e),
          u = ft(Ya, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      Ya.handledProps = ["as", "children", "className", "content", "image"], Ya.propTypes = {};
      var Ka = Ya;
      function Za(e) {
        var t = e.className,
          n = e.square,
          r = e.rectangular,
          i = K()(at(n, "square"), at(r, "rectangular"), "image", t),
          o = H(Za, e),
          s = ft(Za, e);
        return a.a.createElement(s, E()({}, o, {
          className: i
        }));
      }
      Za.handledProps = ["as", "className", "rectangular", "square"], Za.propTypes = {};
      var Qa = Za;
      function Ja(e) {
        var t = e.className,
          n = e.length,
          r = K()("line", n, t),
          i = H(Ja, e),
          o = ft(Ja, e);
        return a.a.createElement(o, E()({}, i, {
          className: r
        }));
      }
      Ja.handledProps = ["as", "className", "length"], Ja.propTypes = {};
      var es = Ja;
      function ts(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("paragraph", n),
          s = H(ts, e),
          l = ft(ts, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      ts.handledProps = ["as", "children", "className", "content"], ts.propTypes = {};
      var ns = ts;
      function rs(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.fluid,
          s = e.inverted,
          l = K()("ui", at(o, "fluid"), at(s, "inverted"), "placeholder", n),
          u = H(rs, e),
          c = ft(rs, e);
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), r.isNil(t) ? i : t);
      }
      rs.handledProps = ["as", "children", "className", "content", "fluid", "inverted"], rs.propTypes = {}, rs.Header = Ka, rs.Image = Qa, rs.Line = es, rs.Paragraph = ns;
      var is = rs;
      function os(e) {
        var t = e.attached,
          n = e.children,
          i = e.className,
          o = e.close,
          s = e.content,
          l = e.dividing,
          u = e.internal,
          c = e.position,
          d = e.size,
          h = K()("ui", c, d, at(t, "attached"), at(l, "dividing"), at(u, "internal"), lt(o, "close"), "rail", i),
          f = H(os, e),
          p = ft(os, e);
        return a.a.createElement(p, E()({}, f, {
          className: h
        }), r.isNil(n) ? s : n);
      }
      os.handledProps = ["as", "attached", "children", "className", "close", "content", "dividing", "internal", "position", "size"], os.propTypes = {};
      var as = os;
      function ss(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.hidden,
          s = e.visible,
          l = K()("ui", at(o, "hidden"), at(s, "visible"), "content", n),
          u = H(ss, e),
          c = ft(ss, e);
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), r.isNil(t) ? i : t);
      }
      ss.handledProps = ["as", "children", "className", "content", "hidden", "visible"], ss.propTypes = {};
      var ls = ss;
      function us(e) {
        var t = e.active,
          n = e.animated,
          i = e.children,
          o = e.className,
          s = e.content,
          l = e.disabled,
          u = e.instant,
          c = K()("ui", n, at(t, "active"), at(l, "disabled"), at(u, "instant"), "reveal", o),
          d = H(us, e),
          h = ft(us, e);
        return a.a.createElement(h, E()({}, d, {
          className: c
        }), r.isNil(i) ? s : i);
      }
      us.handledProps = ["active", "animated", "as", "children", "className", "content", "disabled", "instant"], us.propTypes = {}, us.Content = ls;
      var cs = us;
      function ds(e) {
        var t = e.children,
          n = e.className,
          i = e.compact,
          o = e.content,
          s = e.horizontal,
          l = e.piled,
          u = e.raised,
          c = e.size,
          d = e.stacked,
          h = K()("ui", c, at(i, "compact"), at(s, "horizontal"), at(l, "piled"), at(u, "raised"), at(d, "stacked"), "segments", n),
          f = H(ds, e),
          p = ft(ds, e);
        return a.a.createElement(p, E()({}, f, {
          className: h
        }), r.isNil(t) ? o : t);
      }
      ds.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"], ds.propTypes = {};
      var hs = ds;
      function fs(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("inline", n),
          s = H(fs, e),
          l = ft(fs, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      fs.handledProps = ["as", "children", "className", "content"], fs.propTypes = {};
      var ps = fs;
      function ms(e) {
        var t = e.attached,
          n = e.basic,
          i = e.children,
          o = e.circular,
          s = e.className,
          l = e.clearing,
          u = e.color,
          c = e.compact,
          d = e.content,
          h = e.disabled,
          f = e.floated,
          p = e.inverted,
          m = e.loading,
          g = e.placeholder,
          v = e.padded,
          y = e.piled,
          b = e.raised,
          _ = e.secondary,
          x = e.size,
          w = e.stacked,
          S = e.tertiary,
          A = e.textAlign,
          T = e.vertical,
          M = K()("ui", u, x, at(n, "basic"), at(o, "circular"), at(l, "clearing"), at(c, "compact"), at(h, "disabled"), at(p, "inverted"), at(m, "loading"), at(g, "placeholder"), at(y, "piled"), at(b, "raised"), at(_, "secondary"), at(w, "stacked"), at(S, "tertiary"), at(T, "vertical"), lt(t, "attached"), lt(v, "padded"), ct(A), st(f, "floated"), "segment", s),
          C = H(ms, e),
          k = ft(ms, e);
        return a.a.createElement(k, E()({}, C, {
          className: M
        }), r.isNil(i) ? d : i);
      }
      ms.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"], ms.Group = hs, ms.Inline = ps, ms.propTypes = {};
      var gs = ms;
      function vs(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("description", n),
          s = H(vs, e),
          l = ft(vs, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      vs.handledProps = ["as", "children", "className", "content"], vs.propTypes = {}, vs.create = kt(vs, function (e) {
        return {
          content: e
        };
      });
      var ys = vs;
      function bs(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("title", n),
          s = H(bs, e),
          l = ft(bs, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      bs.handledProps = ["as", "children", "className", "content"], bs.propTypes = {}, bs.create = kt(bs, function (e) {
        return {
          content: e
        };
      });
      var _s = bs;
      function xs(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.description,
          s = e.title,
          l = K()("content", n),
          u = H(xs, e),
          c = ft(xs, e);
        return r.isNil(t) ? r.isNil(i) ? a.a.createElement(c, E()({}, u, {
          className: l
        }), _s.create(s, {
          autoGenerateKey: !1
        }), ys.create(o, {
          autoGenerateKey: !1
        })) : a.a.createElement(c, E()({}, u, {
          className: l
        }), i) : a.a.createElement(c, E()({}, u, {
          className: l
        }), t);
      }
      xs.handledProps = ["as", "children", "className", "content", "description", "title"], xs.propTypes = {}, xs.create = kt(xs, function (e) {
        return {
          content: e
        };
      });
      var ws = xs;
      n("./node_modules/lodash/pickBy.js");
      function Ss(e) {
        var t = e.attached,
          n = e.children,
          i = e.className,
          o = e.content,
          s = e.fluid,
          l = e.items,
          u = e.ordered,
          c = e.size,
          d = e.stackable,
          h = e.unstackable,
          f = e.vertical,
          p = e.widths,
          m = K()("ui", c, at(s, "fluid"), at(u, "ordered"), at(h, "unstackable"), at(f, "vertical"), lt(t, "attached"), st(d, "stackable"), ht(p), "steps", i),
          g = H(Ss, e),
          v = ft(Ss, e);
        return r.isNil(n) ? r.isNil(o) ? a.a.createElement(v, E()({}, g, {
          className: m
        }), Gn()(l, function (e) {
          return Ts.create(e);
        })) : a.a.createElement(v, E()({}, g, {
          className: m
        }), o) : a.a.createElement(v, E()({}, g, {
          className: m
        }), n);
      }
      Ss.handledProps = ["as", "attached", "children", "className", "content", "fluid", "items", "ordered", "size", "stackable", "unstackable", "vertical", "widths"], Ss.propTypes = {};
      var As = Ss,
        Es = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "computeElementType", function () {
              if (n.props.onClick) return "a";
            }), F()(N()(n), "handleClick", function (e) {
              n.props.disabled || V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                o = e.className,
                s = e.completed,
                l = e.content,
                u = e.description,
                c = e.disabled,
                d = e.href,
                h = e.icon,
                f = e.link,
                p = e.title,
                m = K()(at(n, "active"), at(s, "completed"), at(c, "disabled"), at(f, "link"), "step", o),
                g = H(t, this.props),
                v = ft(t, this.props, this.computeElementType);
              return r.isNil(i) ? r.isNil(l) ? a.a.createElement(v, E()({}, g, {
                className: m,
                href: d,
                onClick: this.handleClick
              }), Ut.create(h, {
                autoGenerateKey: !1
              }), ws.create({
                description: u,
                title: p
              }, {
                autoGenerateKey: !1
              })) : a.a.createElement(v, E()({}, g, {
                className: m,
                href: d,
                onClick: this.handleClick
              }), l) : a.a.createElement(v, E()({}, g, {
                className: m,
                href: d,
                onClick: this.handleClick
              }), i);
            }
          }]), t;
        }(o.Component);
      F()(Es, "Content", ws), F()(Es, "Description", ys), F()(Es, "Group", As), F()(Es, "Title", _s), F()(Es, "handledProps", ["active", "as", "children", "className", "completed", "content", "description", "disabled", "href", "icon", "link", "onClick", "ordered", "title"]), Es.propTypes = {}, Es.create = kt(Es, function (e) {
        return {
          content: e
        };
      });
      var Ts = Es,
        Ms = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              return V()(n.props, "onClick", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                i = e.children,
                o = e.className,
                s = e.content,
                l = e.icon,
                u = K()(at(n, "active"), "title", o),
                c = H(t, this.props),
                d = ft(t, this.props),
                h = X()(l) ? "dropdown" : l;
              return r.isNil(i) ? a.a.createElement(d, E()({}, c, {
                className: u,
                onClick: this.handleClick
              }), Ut.create(h, {
                autoGenerateKey: !1
              }), s) : a.a.createElement(d, E()({}, c, {
                className: u,
                onClick: this.handleClick
              }), i);
            }
          }]), t;
        }(o.Component);
      function Cs(e) {
        var t = e.active,
          n = e.children,
          i = e.className,
          o = e.content,
          s = K()("content", at(t, "active"), i),
          l = H(Cs, e),
          u = ft(Cs, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(n) ? o : n);
      }
      F()(Ms, "handledProps", ["active", "as", "children", "className", "content", "icon", "index", "onClick"]), Ms.propTypes = {}, Ms.create = kt(Ms, function (e) {
        return {
          content: e
        };
      }), Cs.handledProps = ["active", "as", "children", "className", "content"], Cs.propTypes = {}, Cs.create = kt(Cs, function (e) {
        return {
          content: e
        };
      });
      var ks = Cs,
        Ps = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleTitleOverrides", function (e) {
              return {
                onClick: function onClick(t, r) {
                  V()(e, "onClick", t, r), V()(n.props, "onTitleClick", t, r);
                }
              };
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                t = e.active,
                n = e.content,
                r = e.index,
                i = e.title;
              return a.a.createElement(o.Fragment, null, Ms.create(i, {
                autoGenerateKey: !1,
                defaultProps: {
                  active: t,
                  index: r
                },
                overrideProps: this.handleTitleOverrides
              }), ks.create(n, {
                autoGenerateKey: !1,
                defaultProps: {
                  active: t
                }
              }));
            }
          }]), t;
        }(o.Component);
      F()(Ps, "handledProps", ["active", "content", "index", "onTitleClick", "title"]), Ps.propTypes = {}, Ps.create = kt(Ps, null);
      var Os = Ps,
        Rs = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "computeNewIndex", function (e) {
              var t = n.props.exclusive,
                r = n.state.activeIndex;
              return t ? e === r ? -1 : e : $t()(r, e) ? Dt()(r, e) : [].concat(W()(r), [e]);
            }), F()(N()(n), "handleTitleClick", function (e, t) {
              var r = t.index;
              n.trySetState({
                activeIndex: n.computeNewIndex(r)
              }), V()(n.props, "onTitleClick", e, t);
            }), F()(N()(n), "isIndexActive", function (e) {
              var t = n.props.exclusive,
                r = n.state.activeIndex;
              return t ? r === e : $t()(r, e);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "getInitialAutoControlledState",
            value: function value(e) {
              return {
                activeIndex: e.exclusive ? -1 : []
              };
            }
          }, {
            key: "componentDidMount",
            value: function value() {
              0;
            }
          }, {
            key: "componentDidUpdate",
            value: function value() {
              0;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this,
                n = this.props,
                i = n.className,
                o = n.children,
                s = n.panels,
                l = K()("accordion", i),
                u = H(t, this.props),
                c = ft(t, this.props);
              return a.a.createElement(c, E()({}, u, {
                className: l
              }), r.isNil(o) ? Gn()(s, function (t, n) {
                return Os.create(t, {
                  defaultProps: {
                    active: e.isIndexActive(n),
                    index: n,
                    onTitleClick: e.handleTitleClick
                  }
                });
              }) : o);
            }
          }]), t;
        }(xn);
      function Is(e) {
        var t = e.className,
          n = e.fluid,
          r = e.inverted,
          i = e.styled,
          o = K()("ui", at(n, "fluid"), at(r, "inverted"), at(i, "styled"), t),
          s = H(Is, e);
        return a.a.createElement(Rs, E()({}, s, {
          className: o
        }));
      }
      F()(Rs, "defaultProps", {
        exclusive: !0
      }), F()(Rs, "autoControlledProps", ["activeIndex"]), F()(Rs, "handledProps", ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"]), Rs.propTypes = {}, Rs.create = kt(Rs, function (e) {
        return {
          content: e
        };
      }), Is.handledProps = ["className", "fluid", "inverted", "styled"], Is.propTypes = {}, Is.Accordion = Rs, Is.Content = ks, Is.Panel = Os, Is.Title = Ms;
      var js = Is,
        Ns = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              var t = n.props.onClick,
                r = n.state.active;
              t && t(e, mt()({}, n.props, {
                active: !0
              })), r || n.trySetState({
                active: !0
              });
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "getSrc",
            value: function value() {
              var e = this.props,
                t = e.autoplay,
                n = void 0 === t || t,
                r = e.brandedUI,
                i = void 0 !== r && r,
                o = e.color,
                a = void 0 === o ? "#444444" : o,
                s = e.hd,
                l = void 0 === s || s,
                u = e.id,
                c = e.source,
                d = e.url;
              return "youtube" === c ? ["//www.youtube.com/embed/".concat(u), "?autohide=true", "&amp;autoplay=".concat(n), "&amp;color=".concat(encodeURIComponent(a)), "&amp;hq=".concat(l), "&amp;jsapi=false", "&amp;modestbranding=".concat(i), "&amp;rel=".concat(i ? 0 : 1)].join("") : "vimeo" === c ? ["//player.vimeo.com/video/".concat(u), "?api=false", "&amp;autoplay=".concat(n), "&amp;byline=false", "&amp;color=".concat(encodeURIComponent(a)), "&amp;portrait=false", "&amp;title=false"].join("") : d;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.aspectRatio,
                r = e.className,
                i = e.icon,
                o = e.placeholder,
                s = this.state.active,
                l = K()("ui", n, at(s, "active"), "embed", r),
                u = H(t, this.props),
                c = ft(t, this.props),
                d = void 0 !== i ? i : "video play";
              return a.a.createElement(c, E()({}, u, {
                className: l,
                onClick: this.handleClick
              }), Ut.create(d, {
                autoGenerateKey: !1
              }), o && a.a.createElement("img", {
                className: "placeholder",
                src: o
              }), this.renderEmbed());
            }
          }, {
            key: "renderEmbed",
            value: function value() {
              var e = this.props,
                t = e.children,
                n = e.content,
                i = e.iframe,
                o = e.source;
              return this.state.active ? r.isNil(t) ? r.isNil(n) ? a.a.createElement("div", {
                className: "embed"
              }, Ot(r.isNil(i) ? this.getSrc() : i, {
                defaultProps: {
                  allowFullScreen: !1,
                  frameBorder: 0,
                  height: "100%",
                  scrolling: "no",
                  src: this.getSrc(),
                  title: "Embedded content from ".concat(o, "."),
                  width: "100%"
                },
                autoGenerateKey: !1
              })) : a.a.createElement("div", {
                className: "embed"
              }, n) : a.a.createElement("div", {
                className: "embed"
              }, t) : null;
            }
          }]), t;
        }(xn);
      F()(Ns, "autoControlledProps", ["active"]), F()(Ns, "handledProps", ["active", "as", "aspectRatio", "autoplay", "brandedUI", "children", "className", "color", "content", "defaultActive", "hd", "icon", "id", "iframe", "onClick", "placeholder", "source", "url"]), Ns.propTypes = {};
      var Ls = n("./node_modules/lodash/merge.js"),
        Ds = n.n(Ls),
        Bs = n("./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"),
        Fs = n.n(Bs),
        zs = n("./node_modules/@babel/runtime/helpers/inheritsLoose.js"),
        Us = n.n(zs),
        Gs = n("./node_modules/deep-equal/index.js"),
        Vs = n.n(Gs),
        Hs = n("./node_modules/popper.js/dist/esm/popper.js"),
        qs = n("./node_modules/create-react-context/lib/index.js"),
        Ws = n.n(qs),
        $s = Ws()(),
        Xs = Ws()(),
        Ys = (o.Component, function (e, t) {
          if ("function" == typeof e) return function (e) {
            if ("function" == typeof e) {
              for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
              return e.apply(void 0, n);
            }
          }(e, t);
          null != e && (e.current = t);
        }),
        Ks = {
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0,
          pointerEvents: "none"
        },
        Zs = {},
        Qs = function (e) {
          function t() {
            for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
            return t = e.call.apply(e, [this].concat(r)) || this, F()(N()(t), "state", {
              data: void 0,
              placement: void 0
            }), F()(N()(t), "popperInstance", void 0), F()(N()(t), "popperNode", null), F()(N()(t), "arrowNode", null), F()(N()(t), "setPopperNode", function (e) {
              e && t.popperNode !== e && (Ys(t.props.innerRef, e), t.popperNode = e, t.updatePopperInstance());
            }), F()(N()(t), "setArrowNode", function (e) {
              t.arrowNode = e;
            }), F()(N()(t), "updateStateModifier", {
              enabled: !0,
              order: 900,
              fn: function fn(e) {
                var n = e.placement;
                return t.setState({
                  data: e,
                  placement: n
                }), e;
              }
            }), F()(N()(t), "getOptions", function () {
              return {
                placement: t.props.placement,
                eventsEnabled: t.props.eventsEnabled,
                positionFixed: t.props.positionFixed,
                modifiers: E()({}, t.props.modifiers, {
                  arrow: E()({}, t.props.modifiers && t.props.modifiers.arrow, {
                    enabled: !!t.arrowNode,
                    element: t.arrowNode
                  }),
                  applyStyle: {
                    enabled: !1
                  },
                  updateStateModifier: t.updateStateModifier
                })
              };
            }), F()(N()(t), "getPopperStyle", function () {
              return t.popperNode && t.state.data ? E()({
                position: t.state.data.offsets.popper.position
              }, t.state.data.styles) : Ks;
            }), F()(N()(t), "getPopperPlacement", function () {
              return t.state.data ? t.state.placement : void 0;
            }), F()(N()(t), "getArrowStyle", function () {
              return t.arrowNode && t.state.data ? t.state.data.arrowStyles : Zs;
            }), F()(N()(t), "getOutOfBoundariesState", function () {
              return t.state.data ? t.state.data.hide : void 0;
            }), F()(N()(t), "destroyPopperInstance", function () {
              t.popperInstance && (t.popperInstance.destroy(), t.popperInstance = null);
            }), F()(N()(t), "updatePopperInstance", function () {
              t.destroyPopperInstance();
              var e = N()(t).popperNode,
                n = t.props.referenceElement;
              n && e && (t.popperInstance = new Hs.a(n, e, t.getOptions()));
            }), F()(N()(t), "scheduleUpdate", function () {
              t.popperInstance && t.popperInstance.scheduleUpdate();
            }), t;
          }
          Us()(t, e);
          var n = t.prototype;
          return n.componentDidUpdate = function (e, t) {
            this.props.placement === e.placement && this.props.referenceElement === e.referenceElement && this.props.positionFixed === e.positionFixed && Vs()(this.props.modifiers, e.modifiers, {
              strict: !0
            }) ? this.props.eventsEnabled !== e.eventsEnabled && this.popperInstance && (this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners()) : this.updatePopperInstance(), t.placement !== this.state.placement && this.scheduleUpdate();
          }, n.componentWillUnmount = function () {
            Ys(this.props.innerRef, null), this.destroyPopperInstance();
          }, n.render = function () {
            return (e = this.props.children, Array.isArray(e) ? e[0] : e)({
              ref: this.setPopperNode,
              style: this.getPopperStyle(),
              placement: this.getPopperPlacement(),
              outOfBoundaries: this.getOutOfBoundariesState(),
              scheduleUpdate: this.scheduleUpdate,
              arrowProps: {
                ref: this.setArrowNode,
                style: this.getArrowStyle()
              }
            });
            var e;
          }, t;
        }(o.Component);
      F()(Qs, "defaultProps", {
        placement: "bottom",
        eventsEnabled: !0,
        referenceElement: void 0,
        positionFixed: !1
      });
      Hs.a.placements;
      function Js(e) {
        var t = e.referenceElement,
          n = Fs()(e, ["referenceElement"]);
        return o.createElement($s.Consumer, null, function (e) {
          return o.createElement(Qs, E()({
            referenceElement: void 0 !== t ? t : e
          }, n));
        });
      }
      var el = n("./node_modules/lodash/invert.js"),
        tl = n.n(el),
        nl = {
          "top center": "top",
          "top left": "top-start",
          "top right": "top-end",
          "bottom center": "bottom",
          "bottom left": "bottom-start",
          "bottom right": "bottom-end",
          "right center": "right",
          "left center": "left"
        },
        rl = (ue()(nl), tl()(nl)),
        il = n("./node_modules/lodash/memoize.js"),
        ol = n.n(il),
        al = function () {
          function e(t) {
            M()(this, e), this.ref = t;
          }
          return k()(e, [{
            key: "getBoundingClientRect",
            value: function value() {
              return V()(this.ref.current, "getBoundingClientRect", {});
            }
          }, {
            key: "clientWidth",
            get: function get() {
              return this.getBoundingClientRect().width;
            }
          }, {
            key: "clientHeight",
            get: function get() {
              return this.getBoundingClientRect().height;
            }
          }, {
            key: "parentNode",
            get: function get() {
              return this.ref.current ? this.ref.current.parentNode : void 0;
            }
          }]), e;
        }(),
        sl = ol()(function (e) {
          return new al(nr(e) ? e : or(e));
        });
      function ll(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("content", n),
          s = H(ll, e),
          l = ft(ll, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      function ul(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("header", n),
          s = H(ul, e),
          l = ft(ul, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      ll.handledProps = ["as", "children", "className", "content"], ll.propTypes = {}, ll.create = kt(ll, function (e) {
        return {
          children: e
        };
      }), ul.handledProps = ["as", "children", "className", "content"], ul.propTypes = {}, ul.create = kt(ul, function (e) {
        return {
          children: e
        };
      });
      var cl = function (e) {
        function t() {
          var e, n;
          M()(this, t);
          for (var i = arguments.length, s = new Array(i), l = 0; l < i; l++) s[l] = arguments[l];
          return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(s))), F()(N()(n), "state", {}), F()(N()(n), "open", !1), F()(N()(n), "triggerRef", Object(o.createRef)()), F()(N()(n), "getPortalProps", function () {
            var e = {},
              t = n.props,
              r = t.on,
              i = t.hoverable,
              o = vt()(r) ? r : [r];
            return i && (e.closeOnPortalMouseLeave = !0, e.mouseLeaveDelay = 300), $t()(o, "hover") && (e.openOnTriggerClick = !1, e.closeOnTriggerClick = !1, e.openOnTriggerMouseEnter = !0, e.closeOnTriggerMouseLeave = !0, e.mouseLeaveDelay = 70, e.mouseEnterDelay = 50), $t()(o, "click") && (e.openOnTriggerClick = !0, e.closeOnTriggerClick = !0, e.closeOnDocumentClick = !0), $t()(o, "focus") && (e.openOnTriggerFocus = !0, e.closeOnTriggerBlur = !0), e;
          }), F()(N()(n), "hideOnScroll", function (e) {
            n.setState({
              closed: !0
            }), tr.unsub("scroll", n.hideOnScroll, {
              target: window
            }), n.timeoutId = setTimeout(function () {
              n.setState({
                closed: !1
              });
            }, 50), n.handleClose(e);
          }), F()(N()(n), "handleClose", function (e) {
            V()(n.props, "onClose", e, n.props);
          }), F()(N()(n), "handleOpen", function (e) {
            V()(n.props, "onOpen", e, n.props);
          }), F()(N()(n), "handlePortalMount", function (e) {
            V()(n.props, "onMount", e, n.props);
          }), F()(N()(n), "handlePortalUnmount", function (e) {
            n.positionUpdate = null, V()(n.props, "onUnmount", e, n.props);
          }), F()(N()(n), "renderContent", function (e) {
            var i = e.placement,
              o = e.ref,
              s = e.scheduleUpdate,
              l = e.style,
              u = n.props,
              c = u.basic,
              d = u.children,
              h = u.className,
              f = u.content,
              p = u.hideOnScroll,
              m = u.flowing,
              g = u.header,
              v = u.inverted,
              y = u.size,
              b = u.style,
              _ = u.wide,
              x = n.state.contentRestProps;
            n.positionUpdate = s;
            var w = K()("ui", rl[i], y, lt(_, "wide"), at(c, "basic"), at(m, "flowing"), at(v, "inverted"), "popup transition visible", h),
              A = ft(t, n.props),
              T = mt()({
                left: "auto",
                right: "auto"
              }, l, b);
            return a.a.createElement(S, {
              innerRef: o
            }, a.a.createElement(A, E()({}, x, {
              className: w,
              style: T
            }), r.isNil(d) ? a.a.createElement(a.a.Fragment, null, ul.create(g, {
              autoGenerateKey: !1
            }), ll.create(f, {
              autoGenerateKey: !1
            })) : d, p && a.a.createElement(on.a, {
              on: n.hideOnScroll,
              name: "scroll",
              target: "window"
            })));
          }), n;
        }
        return D()(t, e), k()(t, [{
          key: "componentDidUpdate",
          value: function value(e) {
            er()(this.props.popperDependencies, e.popperDependencies) || this.handleUpdate();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            clearTimeout(this.timeoutId);
          }
        }, {
          key: "handleUpdate",
          value: function value() {
            this.positionUpdate && this.positionUpdate();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
              t = e.context,
              n = e.disabled,
              r = e.eventsEnabled,
              i = e.offset,
              o = e.pinned,
              s = e.popperModifiers,
              l = e.position,
              u = e.positionFixed,
              c = e.trigger,
              d = this.state,
              h = d.closed,
              f = d.portalRestProps;
            if (h || n) return c;
            var p = Ds()({
                arrow: {
                  enabled: !1
                },
                flip: {
                  enabled: !o
                },
                keepTogether: {
                  enabled: !!i
                },
                offset: {
                  offset: i
                }
              }, s),
              m = sl(X()(t) ? this.triggerRef : t),
              g = mt()({}, this.getPortalProps(), f);
            return a.a.createElement(En, E()({}, g, {
              onClose: this.handleClose,
              onMount: this.handlePortalMount,
              onOpen: this.handleOpen,
              onUnmount: this.handlePortalUnmount,
              trigger: c,
              triggerRef: this.triggerRef
            }), a.a.createElement(Js, {
              eventsEnabled: r,
              modifiers: p,
              placement: nl[l],
              positionFixed: u,
              referenceElement: m
            }, this.renderContent));
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function value(e, n) {
            if (n.closed || n.disabled) return {};
            var r = H(t, e);
            return {
              contentRestProps: Qn()(r, function (e, t, n) {
                return $t()(En.handledProps, n) || (e[n] = t), e;
              }, {}),
              portalRestProps: Kn()(r, En.handledProps)
            };
          }
        }]), t;
      }(o.Component);
      F()(cl, "defaultProps", {
        disabled: !1,
        eventsEnabled: !0,
        offset: 0,
        on: ["click", "hover"],
        pinned: !1,
        position: "top left"
      }), F()(cl, "Content", ll), F()(cl, "Header", ul), F()(cl, "handledProps", ["as", "basic", "children", "className", "content", "context", "disabled", "eventsEnabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popperDependencies", "popperModifiers", "position", "positionFixed", "size", "style", "trigger", "wide"]), cl.propTypes = {};
      var dl = n("./node_modules/lodash/round.js"),
        hl = n.n(dl),
        fl = n("./node_modules/lodash/clamp.js"),
        pl = n.n(fl),
        ml = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) o[s] = arguments[s];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(o))), F()(N()(n), "calculatePercent", function () {
              var e = n.props,
                t = e.percent,
                r = e.total,
                i = e.value;
              return Vt()(t) ? Vt()(r) || Vt()(i) ? void 0 : i / r * 100 : t;
            }), F()(N()(n), "computeValueText", function (e) {
              var t = n.props,
                r = t.progress,
                i = t.total,
                o = t.value;
              return "value" === r ? o : "ratio" === r ? "".concat(o, "/").concat(i) : "".concat(e, "%");
            }), F()(N()(n), "getPercent", function () {
              var e = n.props,
                t = e.precision,
                r = e.progress,
                i = e.total,
                o = e.value,
                a = pl()(n.calculatePercent(), 0, 100);
              return Vt()(i) || Vt()(o) || "value" !== r ? "value" === r ? o : Vt()(t) ? a : hl()(a, t) : o / i * 100;
            }), F()(N()(n), "isAutoSuccess", function () {
              var e = n.props,
                t = e.autoSuccess,
                r = e.percent,
                i = e.total,
                o = e.value;
              return t && (r >= 100 || o >= i);
            }), F()(N()(n), "renderLabel", function () {
              var e = n.props,
                t = e.children,
                i = e.content,
                o = e.label;
              return r.isNil(t) ? r.isNil(i) ? Pt(o, {
                autoGenerateKey: !1,
                defaultProps: {
                  className: "label"
                }
              }) : a.a.createElement("div", {
                className: "label"
              }, i) : a.a.createElement("div", {
                className: "label"
              }, t);
            }), F()(N()(n), "renderProgress", function (e) {
              var t = n.props,
                r = t.precision;
              if (t.progress || !Vt()(r)) return a.a.createElement("div", {
                className: "progress"
              }, n.computeValueText(e));
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                r = e.attached,
                i = e.className,
                o = e.color,
                s = e.disabled,
                l = e.error,
                u = e.indicating,
                c = e.inverted,
                d = e.size,
                h = e.success,
                f = e.warning,
                p = K()("ui", o, d, at(n || u, "active"), at(s, "disabled"), at(l, "error"), at(u, "indicating"), at(c, "inverted"), at(h || this.isAutoSuccess(), "success"), at(f, "warning"), st(r, "attached"), "progress", i),
                m = H(t, this.props),
                g = ft(t, this.props),
                v = this.getPercent() || 0;
              return a.a.createElement(g, E()({}, m, {
                className: p,
                "data-percent": Math.floor(v)
              }), a.a.createElement("div", {
                className: "bar",
                style: {
                  width: "".concat(v, "%")
                }
              }, this.renderProgress(v)), this.renderLabel());
            }
          }]), t;
        }(o.Component);
      F()(ml, "handledProps", ["active", "as", "attached", "autoSuccess", "children", "className", "color", "content", "disabled", "error", "indicating", "inverted", "label", "percent", "precision", "progress", "size", "success", "total", "value", "warning"]), ml.propTypes = {};
      var gl = ml,
        vl = n("./node_modules/lodash/times.js"),
        yl = n.n(vl),
        bl = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              V()(n.props, "onClick", e, n.props);
            }), F()(N()(n), "handleKeyUp", function (e) {
              switch (V()(n.props, "onKeyUp", e, n.props), sn.a.getCode(e)) {
                case sn.a.Enter:
                case sn.a.Spacebar:
                  e.preventDefault(), V()(n.props, "onClick", e, n.props);
              }
            }), F()(N()(n), "handleMouseEnter", function (e) {
              V()(n.props, "onMouseEnter", e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.active,
                r = e.className,
                i = e.selected,
                o = K()(at(n, "active"), at(i, "selected"), "icon", r),
                s = H(t, this.props),
                l = ft(t, this.props);
              return a.a.createElement(l, E()({}, s, {
                className: o,
                onClick: this.handleClick,
                onKeyUp: this.handleKeyUp,
                onMouseEnter: this.handleMouseEnter,
                role: "radio"
              }));
            }
          }]), t;
        }(o.Component);
      F()(bl, "defaultProps", {
        as: "i"
      }), F()(bl, "handledProps", ["active", "as", "className", "index", "onClick", "onKeyUp", "onMouseEnter", "selected"]), bl.propTypes = {};
      var _l = function (e) {
        function t() {
          var e, n;
          M()(this, t);
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
          return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleIconClick", function (e, t) {
            var r = t.index,
              i = n.props,
              o = i.clearable,
              a = i.disabled,
              s = i.maxRating,
              l = i.onRate,
              u = n.state.rating;
            if (!a) {
              var c = r + 1;
              "auto" === o && 1 === s ? c = +!u : !0 === o && c === u && (c = 0), n.trySetState({
                rating: c,
                isSelecting: !1
              }), l && l(e, mt()({}, n.props, {
                rating: c
              }));
            }
          }), F()(N()(n), "handleIconMouseEnter", function (e, t) {
            var r = t.index;
            n.props.disabled || n.setState({
              selectedIndex: r,
              isSelecting: !0
            });
          }), F()(N()(n), "handleMouseLeave", function () {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            V.a.apply(void 0, [n.props, "onMouseLeave"].concat(t)), n.props.disabled || n.setState({
              selectedIndex: -1,
              isSelecting: !1
            });
          }), n;
        }
        return D()(t, e), k()(t, [{
          key: "render",
          value: function value() {
            var e = this,
              n = this.props,
              r = n.className,
              i = n.disabled,
              o = n.icon,
              s = n.maxRating,
              l = n.size,
              u = this.state,
              c = u.rating,
              d = u.selectedIndex,
              h = u.isSelecting,
              f = K()("ui", o, l, at(i, "disabled"), at(h && !i && d >= 0, "selected"), "rating", r),
              p = H(t, this.props),
              m = ft(t, this.props);
            return a.a.createElement(m, E()({}, p, {
              className: f,
              role: "radiogroup",
              onMouseLeave: this.handleMouseLeave,
              tabIndex: i ? 0 : -1
            }), yl()(s, function (t) {
              return a.a.createElement(bl, {
                tabIndex: i ? -1 : 0,
                active: c >= t + 1,
                "aria-checked": c === t + 1,
                "aria-posinset": t + 1,
                "aria-setsize": s,
                index: t,
                key: t,
                onClick: e.handleIconClick,
                onMouseEnter: e.handleIconMouseEnter,
                selected: d >= t && h
              });
            }));
          }
        }]), t;
      }(xn);
      F()(_l, "autoControlledProps", ["rating"]), F()(_l, "defaultProps", {
        clearable: "auto",
        maxRating: 1
      }), F()(_l, "Icon", bl), F()(_l, "handledProps", ["as", "className", "clearable", "defaultRating", "disabled", "icon", "maxRating", "onRate", "rating", "size"]), _l.propTypes = {};
      var xl = n("./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"),
        wl = n.n(xl),
        Sl = n("./node_modules/lodash/partialRight.js"),
        Al = n.n(Sl);
      function El(e) {
        var t = e.categoryContent,
          n = e.resultsContent;
        return a.a.createElement(a.a.Fragment, null, a.a.createElement("div", {
          className: "name"
        }, t), a.a.createElement("div", {
          className: "results"
        }, n));
      }
      El.handledProps = ["categoryContent", "resultsContent"], El.propTypes = {};
      var Tl = El;
      function Ml(e) {
        var t = e.active,
          n = e.children,
          i = e.className,
          o = e.content,
          s = e.layoutRenderer,
          l = e.renderer,
          u = K()(at(t, "active"), "category", i),
          c = H(Ml, e),
          d = ft(Ml, e),
          h = l(e),
          f = r.isNil(n) ? o : n;
        return a.a.createElement(d, E()({}, c, {
          className: u
        }), s({
          categoryContent: h,
          resultsContent: f
        }));
      }
      Ml.handledProps = ["active", "as", "children", "className", "content", "layoutRenderer", "name", "renderer", "results"], Ml.defaultProps = {
        layoutRenderer: Tl,
        renderer: function renderer(e) {
          return e.name;
        }
      }, Ml.propTypes = {};
      var Cl = Ml,
        kl = function kl(e) {
          var t = e.image,
            n = e.price,
            r = e.title,
            i = e.description;
          return [t && a.a.createElement("div", {
            key: "image",
            className: "image"
          }, Rt(t, {
            autoGenerateKey: !1
          })), a.a.createElement("div", {
            key: "content",
            className: "content"
          }, n && a.a.createElement("div", {
            className: "price"
          }, n), r && a.a.createElement("div", {
            className: "title"
          }, r), i && a.a.createElement("div", {
            className: "description"
          }, i))];
        };
      kl.handledProps = [];
      var Pl = function (e) {
        function t() {
          var e, n;
          M()(this, t);
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
          return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
            var t = n.props.onClick;
            t && t(e, n.props);
          }), n;
        }
        return D()(t, e), k()(t, [{
          key: "render",
          value: function value() {
            var e = this.props,
              n = e.active,
              r = e.className,
              i = e.renderer,
              o = K()(at(n, "active"), "result", r),
              s = H(t, this.props),
              l = ft(t, this.props);
            return a.a.createElement(l, E()({}, s, {
              className: o,
              onClick: this.handleClick
            }), i(this.props));
          }
        }]), t;
      }(o.Component);
      function Ol(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("results transition", n),
          s = H(Ol, e),
          l = ft(Ol, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      F()(Pl, "defaultProps", {
        renderer: kl
      }), F()(Pl, "handledProps", ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"]), Pl.propTypes = {}, Ol.handledProps = ["as", "children", "className", "content"], Ol.propTypes = {};
      var Rl = Ol,
        Il = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleResultSelect", function (e, t) {
              V()(n.props, "onResultSelect", e, mt()({}, n.props, {
                result: t
              }));
            }), F()(N()(n), "handleSelectionChange", function (e) {
              var t = n.getSelectedResult();
              V()(n.props, "onSelectionChange", e, mt()({}, n.props, {
                result: t
              }));
            }), F()(N()(n), "closeOnEscape", function (e) {
              sn.a.getCode(e) === sn.a.Escape && (e.preventDefault(), n.close());
            }), F()(N()(n), "moveSelectionOnKeyDown", function (e) {
              switch (sn.a.getCode(e)) {
                case sn.a.ArrowDown:
                  e.preventDefault(), n.moveSelectionBy(e, 1);
                  break;
                case sn.a.ArrowUp:
                  e.preventDefault(), n.moveSelectionBy(e, -1);
              }
            }), F()(N()(n), "selectItemOnEnter", function (e) {
              if (sn.a.getCode(e) === sn.a.Enter) {
                var t = n.getSelectedResult();
                t && (e.preventDefault(), n.setValue(t.title), n.handleResultSelect(e, t), n.close());
              }
            }), F()(N()(n), "closeOnDocumentClick", function (e) {
              n.close();
            }), F()(N()(n), "handleMouseDown", function (e) {
              n.isMouseDown = !0, V()(n.props, "onMouseDown", e, n.props), tr.sub("mouseup", n.handleDocumentMouseUp);
            }), F()(N()(n), "handleDocumentMouseUp", function () {
              n.isMouseDown = !1, tr.unsub("mouseup", n.handleDocumentMouseUp);
            }), F()(N()(n), "handleInputClick", function (e) {
              e.nativeEvent.stopImmediatePropagation(), n.tryOpen();
            }), F()(N()(n), "handleItemClick", function (e, t) {
              var r = t.id,
                i = n.getSelectedResult(r);
              e.nativeEvent.stopImmediatePropagation(), n.setValue(i.title), n.handleResultSelect(e, i), n.close();
            }), F()(N()(n), "handleItemMouseDown", function (e) {
              e.preventDefault();
            }), F()(N()(n), "handleFocus", function (e) {
              V()(n.props, "onFocus", e, n.props), n.setState({
                focus: !0
              });
            }), F()(N()(n), "handleBlur", function (e) {
              V()(n.props, "onBlur", e, n.props), n.setState({
                focus: !1
              });
            }), F()(N()(n), "handleSearchChange", function (e) {
              e.stopPropagation();
              var t = n.props.minCharacters,
                r = n.state.open,
                i = e.target.value;
              V()(n.props, "onSearchChange", e, mt()({}, n.props, {
                value: i
              })), i.length < t ? n.close() : r || n.tryOpen(i), n.setValue(i);
            }), F()(N()(n), "getFlattenedResults", function () {
              var e = n.props,
                t = e.category,
                r = e.results;
              return t ? Qn()(r, function (e, t) {
                return e.concat(t.results);
              }, []) : r;
            }), F()(N()(n), "getSelectedResult", function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.state.selectedIndex,
                t = n.getFlattenedResults();
              return mi()(t, e);
            }), F()(N()(n), "setValue", function (e) {
              var t = n.props.selectFirstResult;
              n.trySetState({
                value: e,
                selectedIndex: t ? 0 : -1
              });
            }), F()(N()(n), "moveSelectionBy", function (e, t) {
              var r = n.state.selectedIndex,
                i = n.getFlattenedResults().length - 1,
                o = r + t;
              o > i ? o = 0 : o < 0 && (o = i), n.setState({
                selectedIndex: o
              }), n.scrollSelectedItemIntoView(), n.handleSelectionChange(e);
            }), F()(N()(n), "scrollSelectedItemIntoView", function () {
              if (nn()) {
                var e = document.querySelector(".ui.search.active.visible .results.visible"),
                  t = e.querySelector(".result.active");
                if (t) {
                  var n = t.offsetTop < e.scrollTop,
                    r = t.offsetTop + t.clientHeight > e.scrollTop + e.clientHeight;
                  n ? e.scrollTop = t.offsetTop : r && (e.scrollTop = t.offsetTop + t.clientHeight - e.clientHeight);
                }
              }
            }), F()(N()(n), "tryOpen", function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.state.value,
                t = n.props.minCharacters;
              e.length < t || n.open();
            }), F()(N()(n), "open", function () {
              n.trySetState({
                open: !0
              });
            }), F()(N()(n), "close", function () {
              n.trySetState({
                open: !1
              });
            }), F()(N()(n), "renderSearchInput", function (e) {
              var t = n.props,
                r = t.icon,
                i = t.input,
                o = n.state.value;
              return Do.create(i, {
                autoGenerateKey: !1,
                defaultProps: mt()({}, e, {
                  icon: r,
                  input: {
                    className: "prompt",
                    tabIndex: "0",
                    autoComplete: "off"
                  },
                  onChange: n.handleSearchChange,
                  onClick: n.handleInputClick,
                  value: o
                })
              });
            }), F()(N()(n), "renderNoResults", function () {
              var e = n.props,
                t = e.noResultsDescription,
                r = e.noResultsMessage;
              return a.a.createElement("div", {
                className: "message empty"
              }, a.a.createElement("div", {
                className: "header"
              }, r), t && a.a.createElement("div", {
                className: "description"
              }, t));
            }), F()(N()(n), "renderResult", function (e, t, r) {
              var i = e.childKey,
                o = wl()(e, ["childKey"]),
                s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                l = n.props.resultRenderer,
                u = n.state.selectedIndex,
                c = t + s;
              return a.a.createElement(Pl, E()({
                key: i || o.id || o.title,
                active: u === c,
                onClick: n.handleItemClick,
                onMouseDown: n.handleItemMouseDown,
                renderer: l
              }, o, {
                id: c
              }));
            }), F()(N()(n), "renderResults", function () {
              var e = n.props.results;
              return Gn()(e, n.renderResult);
            }), F()(N()(n), "renderCategories", function () {
              var e = n.props,
                t = e.categoryLayoutRenderer,
                r = e.categoryRenderer,
                i = e.results,
                o = n.state.selectedIndex,
                s = 0;
              return Gn()(i, function (e) {
                var i = e.childKey,
                  l = wl()(e, ["childKey"]),
                  u = mt()({
                    key: i || l.name,
                    active: un()(o, s, s + l.results.length),
                    layoutRenderer: t,
                    renderer: r
                  }, l),
                  c = Al()(n.renderResult, s);
                return s += l.results.length, a.a.createElement(Cl, u, l.results.map(c));
              });
            }), F()(N()(n), "renderMenuContent", function () {
              var e = n.props,
                t = e.category,
                r = e.showNoResults,
                i = e.results;
              return gn()(i) ? r ? n.renderNoResults() : null : t ? n.renderCategories() : n.renderResults();
            }), F()(N()(n), "renderResultsMenu", function () {
              var e = n.state.open ? "visible" : "",
                t = n.renderMenuContent();
              if (t) return a.a.createElement(Rl, {
                className: e
              }, t);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "UNSAFE_componentWillMount",
            value: function value() {
              var e = this.state,
                t = e.open,
                n = e.value;
              this.setValue(n), t && this.open();
            }
          }, {
            key: "UNSAFE_componentWillReceiveProps",
            value: function value(e) {
              wi()(I()(t.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, e), er()(e.value, this.props.value) || this.setValue(e.value);
            }
          }, {
            key: "shouldComponentUpdate",
            value: function value(e, t) {
              return !er()(e, this.props) || !er()(t, this.state);
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e, t) {
              !t.focus && this.state.focus ? (this.isMouseDown || this.tryOpen(), this.state.open && tr.sub("keydown", [this.moveSelectionOnKeyDown, this.selectItemOnEnter])) : t.focus && !this.state.focus && (this.isMouseDown || this.close(), tr.unsub("keydown", [this.moveSelectionOnKeyDown, this.selectItemOnEnter])), !t.open && this.state.open ? (this.open(), tr.sub("click", this.closeOnDocumentClick), tr.sub("keydown", [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter])) : t.open && !this.state.open && (this.close(), tr.unsub("click", this.closeOnDocumentClick), tr.unsub("keydown", [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              tr.unsub("click", this.closeOnDocumentClick), tr.unsub("keydown", [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.state,
                n = e.searchClasses,
                r = e.focus,
                i = e.open,
                o = this.props,
                s = o.aligned,
                l = o.category,
                u = o.className,
                c = o.fluid,
                d = o.loading,
                h = o.size,
                f = K()("ui", i && "active visible", h, n, at(l, "category"), at(r, "focus"), at(c, "fluid"), at(d, "loading"), st(s, "aligned"), "search", u),
                p = H(t, this.props),
                m = ft(t, this.props),
                g = Jt(p, {
                  htmlProps: Kt
                }),
                v = qt()(g, 2),
                y = v[0],
                b = v[1];
              return a.a.createElement(m, E()({}, b, {
                className: f,
                onBlur: this.handleBlur,
                onFocus: this.handleFocus,
                onMouseDown: this.handleMouseDown
              }), this.renderSearchInput(y), this.renderResultsMenu());
            }
          }]), t;
        }(xn);
      F()(Il, "defaultProps", {
        icon: "search",
        input: "text",
        minCharacters: 1,
        noResultsMessage: "No results found.",
        showNoResults: !0
      }), F()(Il, "autoControlledProps", ["open", "value"]), F()(Il, "Category", Cl), F()(Il, "Result", Pl), F()(Il, "Results", Rl), F()(Il, "handledProps", ["aligned", "as", "category", "categoryLayoutRenderer", "categoryRenderer", "className", "defaultOpen", "defaultValue", "fluid", "icon", "input", "loading", "minCharacters", "noResultsDescription", "noResultsMessage", "onBlur", "onFocus", "onMouseDown", "onResultSelect", "onSearchChange", "onSelectionChange", "open", "resultRenderer", "results", "selectFirstResult", "showNoResults", "size", "value"]), Il.propTypes = {};
      var jl = n("./node_modules/@stardust-ui/react-component-event-listener/dist/es/EventListener.js"),
        Nl = n("./node_modules/@stardust-ui/react-component-event-listener/dist/es/index.js");
      function Ll(e) {
        var t = e.className,
          n = e.children,
          i = e.content,
          o = K()("pushable", t),
          s = H(Ll, e),
          l = ft(Ll, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(n) ? i : n);
      }
      Ll.handledProps = ["as", "children", "className", "content"], Ll.propTypes = {};
      var Dl = Ll;
      function Bl(e) {
        var t = e.className,
          n = e.dimmed,
          i = e.children,
          o = e.content,
          s = K()("pusher", at(n, "dimmed"), t),
          l = H(Bl, e),
          u = ft(Bl, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(i) ? o : i);
      }
      Bl.handledProps = ["as", "children", "className", "content", "dimmed"], Bl.propTypes = {};
      var Fl = Bl,
        zl = function (e) {
          function t(e) {
            var n;
            return M()(this, t), n = O()(this, I()(t).call(this, e)), F()(N()(n), "ref", Object(o.createRef)()), F()(N()(n), "handleAnimationStart", function () {
              var e = n.props.visible ? "onVisible" : "onHide";
              clearTimeout(n.animationTimer), n.animationTimer = setTimeout(n.handleAnimationEnd, t.animationDuration), n.skipNextCallback ? n.skipNextCallback = !1 : V()(n.props, e, null, n.props);
            }), F()(N()(n), "handleAnimationEnd", function () {
              var e = n.props.visible ? "onShow" : "onHidden";
              n.setState({
                animationTick: 0
              }), V()(n.props, e, null, n.props);
            }), F()(N()(n), "handleDocumentClick", function (e) {
              hn(n.ref.current, e) || (n.skipNextCallback = !0, V()(n.props, "onHide", e, mt()({}, n.props, {
                visible: !1
              })));
            }), n.state = {
              animationTick: 0,
              visible: e.visible
            }, n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidUpdate",
            value: function value(e, t) {
              this.state.animationTick > t.animationTick && this.handleAnimationStart();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              clearTimeout(this.animationTimer);
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.animation,
                i = e.className,
                o = e.children,
                s = e.content,
                l = e.direction,
                u = e.target,
                c = e.visible,
                d = e.width,
                h = this.state.animationTick,
                f = K()("ui", n, l, d, at(h > 0, "animating"), at(c, "visible"), "sidebar", i),
                p = H(t, this.props),
                m = ft(t, this.props),
                g = nr(u) ? u : or(u);
              return a.a.createElement(S, {
                innerRef: this.ref
              }, a.a.createElement(m, E()({}, p, {
                className: f
              }), r.isNil(o) ? s : o, c && a.a.createElement(jl.a, {
                listener: this.handleDocumentClick,
                targetRef: g,
                type: "click"
              })));
            }
          }], [{
            key: "getDerivedStateFromProps",
            value: function value(e, t) {
              var n = !!e.visible == !!t.visible ? 0 : 1;
              return {
                animationTick: t.animationTick + n,
                visible: e.visible
              };
            }
          }]), t;
        }(o.Component);
      F()(zl, "defaultProps", {
        direction: "left",
        target: Nl.documentRef,
        visible: !1
      }), F()(zl, "animationDuration", 500), F()(zl, "autoControlledProps", ["visible"]), F()(zl, "Pushable", Dl), F()(zl, "Pusher", Fl), F()(zl, "handledProps", ["animation", "as", "children", "className", "content", "direction", "onHidden", "onHide", "onShow", "onVisible", "target", "visible", "width"]), zl.propTypes = {};
      var Ul = zl,
        Gl = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "state", {
              sticky: !1
            }), F()(N()(n), "stickyRef", Object(o.createRef)()), F()(N()(n), "triggerRef", Object(o.createRef)()), F()(N()(n), "addListeners", function (e) {
              var t = e.scrollContext,
                r = nr(t) ? t.current : t;
              r && (tr.sub("resize", n.handleUpdate, {
                target: r
              }), tr.sub("scroll", n.handleUpdate, {
                target: r
              }));
            }), F()(N()(n), "removeListeners", function () {
              var e = n.props.scrollContext,
                t = nr(e) ? e.current : e;
              t && (tr.unsub("resize", n.handleUpdate, {
                target: t
              }), tr.unsub("scroll", n.handleUpdate, {
                target: t
              }));
            }), F()(N()(n), "update", function (e) {
              var t = n.state.pushing;
              if (n.ticking = !1, n.assignRects(), t) return n.didReachStartingPoint() ? n.stickToContextTop(e) : n.didTouchScreenBottom() ? n.stickToScreenBottom(e) : n.stickToContextBottom(e);
              if (n.isOversized()) {
                if (n.contextRect.top > 0) return n.stickToContextTop(e);
                if (n.contextRect.bottom < window.innerHeight) return n.stickToContextBottom(e);
              }
              return n.didTouchScreenTop() ? n.didReachContextBottom() ? n.stickToContextBottom(e) : n.stickToScreenTop(e) : n.stickToContextTop(e);
            }), F()(N()(n), "handleUpdate", function (e) {
              n.ticking || (n.ticking = !0, n.frameId = requestAnimationFrame(function () {
                return n.update(e);
              }));
            }), F()(N()(n), "assignRects", function () {
              var e = n.props.context,
                t = nr(e) ? e.current : e || document.body;
              n.triggerRect = n.triggerRef.current.getBoundingClientRect(), n.contextRect = t.getBoundingClientRect(), n.stickyRect = n.stickyRef.current.getBoundingClientRect();
            }), F()(N()(n), "didReachContextBottom", function () {
              var e = n.props.offset;
              return n.stickyRect.height + e >= n.contextRect.bottom;
            }), F()(N()(n), "didReachStartingPoint", function () {
              return n.stickyRect.top <= n.triggerRect.top;
            }), F()(N()(n), "didTouchScreenTop", function () {
              return n.triggerRect.top < n.props.offset;
            }), F()(N()(n), "didTouchScreenBottom", function () {
              var e = n.props.bottomOffset;
              return n.contextRect.bottom + e > window.innerHeight;
            }), F()(N()(n), "isOversized", function () {
              return n.stickyRect.height > window.innerHeight;
            }), F()(N()(n), "pushing", function (e) {
              n.props.pushing && n.setState({
                pushing: e
              });
            }), F()(N()(n), "stick", function (e, t) {
              n.setState({
                bound: t,
                sticky: !0
              }), V()(n.props, "onStick", e, n.props);
            }), F()(N()(n), "unstick", function (e, t) {
              n.setState({
                bound: t,
                sticky: !1
              }), V()(n.props, "onUnstick", e, n.props);
            }), F()(N()(n), "stickToContextBottom", function (e) {
              V()(n.props, "onBottom", e, n.props), n.stick(e, !0), n.pushing(!0);
            }), F()(N()(n), "stickToContextTop", function (e) {
              V()(n.props, "onTop", e, n.props), n.unstick(e, !1), n.pushing(!1);
            }), F()(N()(n), "stickToScreenBottom", function (e) {
              var t = n.props.bottomOffset;
              n.stick(e, !1), n.setState({
                bottom: t,
                top: null
              });
            }), F()(N()(n), "stickToScreenTop", function (e) {
              var t = n.props.offset;
              n.stick(e, !1), n.setState({
                top: t,
                bottom: null
              });
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "componentDidMount",
            value: function value() {
              nn() && this.props.active && (this.handleUpdate(), this.addListeners(this.props));
            }
          }, {
            key: "UNSAFE_componentWillReceiveProps",
            value: function value(e) {
              var t = this.props,
                n = t.active,
                r = t.scrollContext,
                i = e.active,
                o = e.scrollContext;
              if (n !== i) {
                if (i) return this.handleUpdate(), void this.addListeners(e);
                this.removeListeners(), this.setState({
                  sticky: !1
                });
              } else r !== o && (this.removeListeners(), this.addListeners(e));
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              nn() && this.props.active && (this.removeListeners(), cancelAnimationFrame(this.frameId));
            }
          }, {
            key: "computeStyle",
            value: function value() {
              var e = this.props.styleElement,
                t = this.state,
                n = t.bottom,
                r = t.bound,
                i = t.sticky,
                o = t.top;
              return i ? mt()({
                bottom: r ? 0 : n,
                top: r ? void 0 : o,
                width: this.triggerRect.width
              }, e) : e;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.children,
                r = e.className,
                i = this.state,
                o = i.bottom,
                s = i.bound,
                l = i.sticky,
                u = H(t, this.props),
                c = ft(t, this.props),
                d = K()(l && "ui", l && "stuck-container", l && (s ? "bound-container" : "fixed-container"), r),
                h = K()("ui", l && (s ? "bound bottom" : "fixed"), l && !s && (null === o ? "top" : "bottom"), "sticky"),
                f = l && this.stickyRect ? {
                  height: this.stickyRect.height
                } : {};
              return a.a.createElement(c, E()({}, u, {
                className: d
              }), a.a.createElement("div", {
                ref: this.triggerRef,
                style: f
              }), a.a.createElement("div", {
                className: h,
                ref: this.stickyRef,
                style: this.computeStyle()
              }, n));
            }
          }]), t;
        }(o.Component);
      function Vl(e) {
        var t = e.active,
          n = e.children,
          i = e.className,
          o = e.content,
          s = e.loading,
          l = K()(at(t, "active"), at(s, "loading"), "tab", i),
          u = H(Vl, e),
          c = ft(Vl, e),
          d = {};
        return c === gs && (d.attached = "bottom"), a.a.createElement(c, E()({}, d, u, {
          className: l
        }), r.isNil(n) ? o : n);
      }
      F()(Gl, "defaultProps", {
        active: !0,
        bottomOffset: 0,
        offset: 0,
        scrollContext: nn() ? window : null
      }), F()(Gl, "handledProps", ["active", "as", "bottomOffset", "children", "className", "context", "offset", "onBottom", "onStick", "onTop", "onUnstick", "pushing", "scrollContext", "styleElement"]), Gl.propTypes = {}, Vl.handledProps = ["active", "as", "children", "className", "content", "loading"], Vl.defaultProps = {
        as: gs,
        active: !0
      }, Vl.propTypes = {}, Vl.create = kt(Vl, function (e) {
        return {
          content: e
        };
      });
      var Hl = Vl,
        ql = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleItemClick", function (e, t) {
              var r = t.index;
              V()(n.props, "onTabChange", e, mt()({}, n.props, {
                activeIndex: r
              })), n.trySetState({
                activeIndex: r
              });
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "getInitialAutoControlledState",
            value: function value() {
              return {
                activeIndex: 0
              };
            }
          }, {
            key: "renderItems",
            value: function value() {
              var e = this.props,
                t = e.panes,
                n = e.renderActiveOnly,
                r = this.state.activeIndex;
              return n ? V()(mi()(t, "[".concat(r, "]")), "render", this.props) : Gn()(t, function (e, t) {
                var n = e.pane;
                return Hl.create(n, {
                  overrideProps: {
                    active: t === r
                  }
                });
              });
            }
          }, {
            key: "renderMenu",
            value: function value() {
              var e = this.props,
                t = e.menu,
                n = e.panes,
                r = e.menuPosition,
                i = this.state.activeIndex;
              return !0 === t.tabular && "right" === r && (t.tabular = "right"), li.create(t, {
                autoGenerateKey: !1,
                overrideProps: {
                  items: Gn()(n, "menuItem"),
                  onItemClick: this.handleItemClick,
                  activeIndex: i
                }
              });
            }
          }, {
            key: "renderVertical",
            value: function value(e) {
              var t = this.props,
                n = t.grid,
                r = t.menuPosition,
                i = n.paneWidth,
                o = n.tabWidth,
                s = wl()(n, ["paneWidth", "tabWidth"]),
                l = r || "right" === e.props.tabular && "right" || "left";
              return a.a.createElement(Jo, s, "left" === l && Yo.create({
                width: o,
                children: e
              }, {
                autoGenerateKey: !1
              }), Yo.create({
                width: i,
                children: this.renderItems(),
                stretched: !0
              }, {
                autoGenerateKey: !1
              }), "right" === l && Yo.create({
                width: o,
                children: e
              }, {
                autoGenerateKey: !1
              }));
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.renderMenu(),
                n = H(t, this.props),
                r = ft(t, this.props);
              return e.props.vertical ? a.a.createElement(r, n, this.renderVertical(e)) : a.a.createElement(r, n, "bottom" !== e.props.attached && e, this.renderItems(), "bottom" === e.props.attached && e);
            }
          }]), t;
        }(xn);
      F()(ql, "autoControlledProps", ["activeIndex"]), F()(ql, "defaultProps", {
        grid: {
          paneWidth: 12,
          tabWidth: 4
        },
        menu: {
          attached: !0,
          tabular: !0
        },
        renderActiveOnly: !0
      }), F()(ql, "Pane", Hl), F()(ql, "handledProps", ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"]), ql.propTypes = {};
      var Wl = ql;
      function $l(e) {
        var t = e.centered,
          n = e.children,
          i = e.className,
          o = e.content,
          s = e.test,
          l = e.unit,
          u = K()("ui", l, at(t, "centered"), at(s, "test"), "ad", i),
          c = H($l, e),
          d = ft($l, e);
        return a.a.createElement(d, E()({}, c, {
          className: u,
          "data-text": s
        }), r.isNil(n) ? o : n);
      }
      $l.handledProps = ["as", "centered", "children", "className", "content", "test", "unit"], $l.propTypes = {};
      var Xl = $l;
      function Yl(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.textAlign,
          s = K()(ct(o), "description", n),
          l = H(Yl, e),
          u = ft(Yl, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      Yl.handledProps = ["as", "children", "className", "content", "textAlign"], Yl.propTypes = {};
      var Kl = Yl;
      function Zl(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.textAlign,
          s = K()(ct(o), "header", n),
          l = H(Zl, e),
          u = ft(Zl, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      Zl.handledProps = ["as", "children", "className", "content", "textAlign"], Zl.propTypes = {};
      var Ql = Zl;
      function Jl(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.textAlign,
          s = K()(ct(o), "meta", n),
          l = H(Jl, e),
          u = ft(Jl, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      Jl.handledProps = ["as", "children", "className", "content", "textAlign"], Jl.propTypes = {};
      var eu = Jl;
      function tu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.description,
          s = e.extra,
          l = e.header,
          u = e.meta,
          c = e.textAlign,
          d = K()(at(s, "extra"), ct(c), "content", n),
          h = H(tu, e),
          f = ft(tu, e);
        return r.isNil(t) ? r.isNil(i) ? a.a.createElement(f, E()({}, h, {
          className: d
        }), Ct(Ql, function (e) {
          return {
            content: e
          };
        }, l, {
          autoGenerateKey: !1
        }), Ct(eu, function (e) {
          return {
            content: e
          };
        }, u, {
          autoGenerateKey: !1
        }), Ct(Kl, function (e) {
          return {
            content: e
          };
        }, o, {
          autoGenerateKey: !1
        })) : a.a.createElement(f, E()({}, h, {
          className: d
        }), i) : a.a.createElement(f, E()({}, h, {
          className: d
        }), t);
      }
      tu.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "textAlign"], tu.propTypes = {};
      var nu = tu;
      function ru(e) {
        var t = e.centered,
          n = e.children,
          i = e.className,
          o = e.content,
          s = e.doubling,
          l = e.items,
          u = e.itemsPerRow,
          c = e.stackable,
          d = e.textAlign,
          h = K()("ui", at(t, "centered"), at(s, "doubling"), at(c, "stackable"), ct(d), ht(u), "cards", i),
          f = H(ru, e),
          p = ft(ru, e);
        if (!r.isNil(n)) return a.a.createElement(p, E()({}, f, {
          className: h
        }), n);
        if (!r.isNil(o)) return a.a.createElement(p, E()({}, f, {
          className: h
        }), o);
        var m = Gn()(l, function (e) {
          var t = e.key || [e.header, e.description].join("-");
          return a.a.createElement(ou, E()({
            key: t
          }, e));
        });
        return a.a.createElement(p, E()({}, f, {
          className: h
        }), m);
      }
      ru.handledProps = ["as", "centered", "children", "className", "content", "doubling", "items", "itemsPerRow", "stackable", "textAlign"], ru.propTypes = {};
      var iu = ru,
        ou = function (e) {
          function t() {
            var e, n;
            M()(this, t);
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
            return n = O()(this, (e = I()(t)).call.apply(e, [this].concat(i))), F()(N()(n), "handleClick", function (e) {
              var t = n.props.onClick;
              t && t(e, n.props);
            }), n;
          }
          return D()(t, e), k()(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                n = e.centered,
                i = e.children,
                o = e.className,
                s = e.color,
                l = e.content,
                u = e.description,
                c = e.extra,
                d = e.fluid,
                h = e.header,
                f = e.href,
                p = e.image,
                m = e.link,
                g = e.meta,
                v = e.onClick,
                y = e.raised,
                b = K()("ui", s, at(n, "centered"), at(d, "fluid"), at(m, "link"), at(y, "raised"), "card", o),
                _ = H(t, this.props),
                x = ft(t, this.props, function () {
                  if (v) return "a";
                });
              return r.isNil(i) ? r.isNil(l) ? a.a.createElement(x, E()({}, _, {
                className: b,
                href: f,
                onClick: this.handleClick
              }), In.create(p, {
                autoGenerateKey: !1,
                defaultProps: {
                  ui: !1,
                  wrapped: !0
                }
              }), (u || h || g) && a.a.createElement(nu, {
                description: u,
                header: h,
                meta: g
              }), c && a.a.createElement(nu, {
                extra: !0
              }, c)) : a.a.createElement(x, E()({}, _, {
                className: b,
                href: f,
                onClick: this.handleClick
              }), l) : a.a.createElement(x, E()({}, _, {
                className: b,
                href: f,
                onClick: this.handleClick
              }), i);
            }
          }]), t;
        }(o.Component);
      function au(e) {
        var t = e.active,
          n = e.className,
          i = e.children,
          o = e.content,
          s = K()(at(t, "active"), n),
          l = H(au, e),
          u = ft(au, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(i) ? o : i);
      }
      F()(ou, "Content", nu), F()(ou, "Description", Kl), F()(ou, "Group", iu), F()(ou, "Header", Ql), F()(ou, "Meta", eu), F()(ou, "handledProps", ["as", "centered", "children", "className", "color", "content", "description", "extra", "fluid", "header", "href", "image", "link", "meta", "onClick", "raised"]), ou.propTypes = {}, au.handledProps = ["active", "as", "children", "className", "content"], au.defaultProps = {
        as: "a"
      }, au.propTypes = {};
      var su = au;
      function lu(e) {
        var t = e.className,
          n = e.children,
          i = e.content,
          o = K()("actions", t),
          s = H(lu, e),
          l = ft(lu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(n) ? i : n);
      }
      lu.handledProps = ["as", "children", "className", "content"], lu.propTypes = {};
      var uu = lu;
      function cu(e) {
        var t = e.className,
          n = e.children,
          i = e.content,
          o = K()("author", t),
          s = H(cu, e),
          l = ft(cu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(n) ? i : n);
      }
      cu.handledProps = ["as", "children", "className", "content"], cu.propTypes = {};
      var du = cu;
      function hu(e) {
        var t = e.className,
          n = e.src,
          r = K()("avatar", t),
          i = H(hu, e),
          o = Jt(i, {
            htmlProps: Qt
          }),
          s = qt()(o, 2),
          l = s[0],
          u = s[1],
          c = ft(hu, e);
        return a.a.createElement(c, E()({}, u, {
          className: r
        }), Rt(n, {
          autoGenerateKey: !1,
          defaultProps: l
        }));
      }
      hu.handledProps = ["as", "className", "src"], hu.propTypes = {};
      var fu = hu;
      function pu(e) {
        var t = e.className,
          n = e.children,
          i = e.content,
          o = K()(t, "content"),
          s = H(pu, e),
          l = ft(pu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(n) ? i : n);
      }
      pu.handledProps = ["as", "children", "className", "content"], pu.propTypes = {};
      var mu = pu;
      function gu(e) {
        var t = e.className,
          n = e.children,
          i = e.collapsed,
          o = e.content,
          s = e.minimal,
          l = e.size,
          u = e.threaded,
          c = K()("ui", l, at(i, "collapsed"), at(s, "minimal"), at(u, "threaded"), "comments", t),
          d = H(gu, e),
          h = ft(gu, e);
        return a.a.createElement(h, E()({}, d, {
          className: c
        }), r.isNil(n) ? o : n);
      }
      gu.handledProps = ["as", "children", "className", "collapsed", "content", "minimal", "size", "threaded"], gu.propTypes = {};
      var vu = gu;
      function yu(e) {
        var t = e.className,
          n = e.children,
          i = e.content,
          o = K()("metadata", t),
          s = H(yu, e),
          l = ft(yu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(n) ? i : n);
      }
      yu.handledProps = ["as", "children", "className", "content"], yu.propTypes = {};
      var bu = yu;
      function _u(e) {
        var t = e.className,
          n = e.children,
          i = e.content,
          o = K()(t, "text"),
          s = H(_u, e),
          l = ft(_u, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(n) ? i : n);
      }
      _u.handledProps = ["as", "children", "className", "content"], _u.propTypes = {};
      var xu = _u;
      function wu(e) {
        var t = e.className,
          n = e.children,
          i = e.collapsed,
          o = e.content,
          s = K()(at(i, "collapsed"), "comment", t),
          l = H(wu, e),
          u = ft(wu, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(n) ? o : n);
      }
      wu.handledProps = ["as", "children", "className", "collapsed", "content"], wu.propTypes = {}, wu.Author = du, wu.Action = su, wu.Actions = uu, wu.Avatar = fu, wu.Content = mu, wu.Group = vu, wu.Metadata = bu, wu.Text = xu;
      var Su = wu;
      function Au(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("date", n),
          s = H(Au, e),
          l = ft(Au, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Au.handledProps = ["as", "children", "className", "content"], Au.propTypes = {};
      var Eu = Au;
      function Tu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.images,
          s = e.text,
          l = K()(at(o, "images"), at(i || s, "text"), "extra", n),
          u = H(Tu, e),
          c = ft(Tu, e);
        if (!r.isNil(t)) return a.a.createElement(c, E()({}, u, {
          className: l
        }), t);
        var d = Gn()(o, function (e, t) {
          var n = [t, e].join("-");
          return Rt(e, {
            key: n
          });
        });
        return a.a.createElement(c, E()({}, u, {
          className: l
        }), i, d);
      }
      Tu.handledProps = ["as", "children", "className", "content", "images", "text"], Tu.propTypes = {};
      var Mu = Tu;
      function Cu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.icon,
          s = K()("like", n),
          l = H(Cu, e),
          u = ft(Cu, e);
        return r.isNil(t) ? a.a.createElement(u, E()({}, l, {
          className: s
        }), Ut.create(o, {
          autoGenerateKey: !1
        }), i) : a.a.createElement(u, E()({}, l, {
          className: s
        }), t);
      }
      Cu.handledProps = ["as", "children", "className", "content", "icon"], Cu.defaultProps = {
        as: "a"
      }, Cu.propTypes = {};
      var ku = Cu;
      function Pu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.like,
          s = K()("meta", n),
          l = H(Pu, e),
          u = ft(Pu, e);
        return r.isNil(t) ? a.a.createElement(u, E()({}, l, {
          className: s
        }), Ct(ku, function (e) {
          return {
            content: e
          };
        }, o, {
          autoGenerateKey: !1
        }), i) : a.a.createElement(u, E()({}, l, {
          className: s
        }), t);
      }
      Pu.handledProps = ["as", "children", "className", "content", "like"], Pu.propTypes = {};
      var Ou = Pu;
      function Ru(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("user", n),
          s = H(Ru, e),
          l = ft(Ru, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Ru.handledProps = ["as", "children", "className", "content"], Ru.propTypes = {}, Ru.defaultProps = {
        as: "a"
      };
      var Iu = Ru;
      function ju(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.date,
          s = e.user,
          l = K()("summary", n),
          u = H(ju, e),
          c = ft(ju, e);
        return r.isNil(t) ? a.a.createElement(c, E()({}, u, {
          className: l
        }), Ct(Iu, function (e) {
          return {
            content: e
          };
        }, s, {
          autoGenerateKey: !1
        }), i && " ", i, i && " ", Ct(Eu, function (e) {
          return {
            content: e
          };
        }, o, {
          autoGenerateKey: !1
        })) : a.a.createElement(c, E()({}, u, {
          className: l
        }), t);
      }
      ju.handledProps = ["as", "children", "className", "content", "date", "user"], ju.propTypes = {};
      var Nu = ju;
      function Lu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.extraImages,
          s = e.extraText,
          l = e.date,
          u = e.meta,
          c = e.summary,
          d = K()("content", n),
          h = H(Lu, e),
          f = ft(Lu, e);
        return r.isNil(t) ? a.a.createElement(f, E()({}, h, {
          className: d
        }), Ct(Eu, function (e) {
          return {
            content: e
          };
        }, l, {
          autoGenerateKey: !1
        }), Ct(Nu, function (e) {
          return {
            content: e
          };
        }, c, {
          autoGenerateKey: !1
        }), i, Ct(Mu, function (e) {
          return {
            text: !0,
            content: e
          };
        }, s, {
          autoGenerateKey: !1
        }), Ct(Mu, function (e) {
          return {
            images: e
          };
        }, o, {
          autoGenerateKey: !1
        }), Ct(Ou, function (e) {
          return {
            content: e
          };
        }, u, {
          autoGenerateKey: !1
        })) : a.a.createElement(f, E()({}, h, {
          className: d
        }), t);
      }
      Lu.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "meta", "summary"], Lu.propTypes = {};
      var Du = Lu;
      function Bu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.icon,
          s = e.image,
          l = K()("label", n),
          u = H(Bu, e),
          c = ft(Bu, e);
        return r.isNil(t) ? a.a.createElement(c, E()({}, u, {
          className: l
        }), i, Ut.create(o, {
          autoGenerateKey: !1
        }), Rt(s)) : a.a.createElement(c, E()({}, u, {
          className: l
        }), t);
      }
      Bu.handledProps = ["as", "children", "className", "content", "icon", "image"], Bu.propTypes = {};
      var Fu = Bu;
      function zu(e) {
        var t = e.content,
          n = e.children,
          r = e.className,
          i = e.date,
          o = e.extraImages,
          s = e.extraText,
          l = e.image,
          u = e.icon,
          c = e.meta,
          d = e.summary,
          h = K()("event", r),
          f = H(zu, e),
          p = ft(zu, e),
          m = t || i || o || s || c || d,
          g = {
            content: t,
            date: i,
            extraImages: o,
            extraText: s,
            meta: c,
            summary: d
          };
        return a.a.createElement(p, E()({}, f, {
          className: h
        }), Ct(Fu, function (e) {
          return {
            icon: e
          };
        }, u, {
          autoGenerateKey: !1
        }), Ct(Fu, function (e) {
          return {
            image: e
          };
        }, l, {
          autoGenerateKey: !1
        }), m && a.a.createElement(Du, g), n);
      }
      zu.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "icon", "image", "meta", "summary"], zu.propTypes = {};
      var Uu = zu;
      function Gu(e) {
        var t = e.children,
          n = e.className,
          i = e.events,
          o = e.size,
          s = K()("ui", o, "feed", n),
          l = H(Gu, e),
          u = ft(Gu, e);
        if (!r.isNil(t)) return a.a.createElement(u, E()({}, l, {
          className: s
        }), t);
        var c = Gn()(i, function (e) {
          var t = e.childKey,
            n = e.date,
            r = e.meta,
            i = e.summary,
            o = wl()(e, ["childKey", "date", "meta", "summary"]),
            s = t || [n, r, i].join("-");
          return a.a.createElement(Uu, E()({
            date: n,
            key: s,
            meta: r,
            summary: i
          }, o));
        });
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), c);
      }
      Gu.handledProps = ["as", "children", "className", "events", "size"], Gu.propTypes = {}, Gu.Content = Du, Gu.Date = Eu, Gu.Event = Uu, Gu.Extra = Mu, Gu.Label = Fu, Gu.Like = ku, Gu.Meta = Ou, Gu.Summary = Nu, Gu.User = Iu;
      var Vu = Gu;
      function Hu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("header", n),
          s = H(Hu, e),
          l = ft(Hu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Hu.handledProps = ["as", "children", "className", "content"], Hu.propTypes = {}, Hu.create = kt(Hu, function (e) {
        return {
          content: e
        };
      });
      var qu = Hu;
      function Wu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("description", n),
          s = H(Wu, e),
          l = ft(Wu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Wu.handledProps = ["as", "children", "className", "content"], Wu.propTypes = {}, Wu.create = kt(Wu, function (e) {
        return {
          content: e
        };
      });
      var $u = Wu;
      function Xu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("extra", n),
          s = H(Xu, e),
          l = ft(Xu, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Xu.handledProps = ["as", "children", "className", "content"], Xu.propTypes = {}, Xu.create = kt(Xu, function (e) {
        return {
          content: e
        };
      });
      var Yu = Xu;
      function Ku(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("meta", n),
          s = H(Ku, e),
          l = ft(Ku, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      Ku.handledProps = ["as", "children", "className", "content"], Ku.propTypes = {}, Ku.create = kt(Ku, function (e) {
        return {
          content: e
        };
      });
      var Zu = Ku;
      function Qu(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.description,
          s = e.extra,
          l = e.header,
          u = e.meta,
          c = e.verticalAlign,
          d = K()(dt(c), "content", n),
          h = H(Qu, e),
          f = ft(Qu, e);
        return r.isNil(t) ? a.a.createElement(f, E()({}, h, {
          className: d
        }), qu.create(l, {
          autoGenerateKey: !1
        }), Zu.create(u, {
          autoGenerateKey: !1
        }), $u.create(o, {
          autoGenerateKey: !1
        }), Yu.create(s, {
          autoGenerateKey: !1
        }), i) : a.a.createElement(f, E()({}, h, {
          className: d
        }), t);
      }
      Qu.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "verticalAlign"], Qu.propTypes = {};
      var Ju = Qu;
      function ec(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.divided,
          s = e.items,
          l = e.link,
          u = e.relaxed,
          c = e.unstackable,
          d = K()("ui", at(o, "divided"), at(l, "link"), at(c, "unstackable"), lt(u, "relaxed"), "items", n),
          h = H(ec, e),
          f = ft(ec, e);
        if (!r.isNil(t)) return a.a.createElement(f, E()({}, h, {
          className: d
        }), t);
        if (!r.isNil(i)) return a.a.createElement(f, E()({}, h, {
          className: d
        }), i);
        var p = Gn()(s, function (e) {
          var t = e.childKey,
            n = wl()(e, ["childKey"]),
            r = t || [n.content, n.description, n.header, n.meta].join("-");
          return a.a.createElement(oc, E()({}, n, {
            key: r
          }));
        });
        return a.a.createElement(f, E()({}, h, {
          className: d
        }), p);
      }
      ec.handledProps = ["as", "children", "className", "content", "divided", "items", "link", "relaxed", "unstackable"], ec.propTypes = {};
      var tc = ec;
      function nc(e) {
        var t = e.size,
          n = H(nc, e);
        return a.a.createElement(In, E()({}, n, {
          size: t,
          ui: !!t,
          wrapped: !0
        }));
      }
      nc.handledProps = ["size"], nc.propTypes = {}, nc.create = kt(nc, function (e) {
        return {
          src: e
        };
      });
      var rc = nc;
      function ic(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.description,
          s = e.extra,
          l = e.header,
          u = e.image,
          c = e.meta,
          d = K()("item", n),
          h = H(ic, e),
          f = ft(ic, e);
        return r.isNil(t) ? a.a.createElement(f, E()({}, h, {
          className: d
        }), rc.create(u, {
          autoGenerateKey: !1
        }), a.a.createElement(Ju, {
          content: i,
          description: o,
          extra: s,
          header: l,
          meta: c
        })) : a.a.createElement(f, E()({}, h, {
          className: d
        }), t);
      }
      ic.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "image", "meta"], ic.Content = Ju, ic.Description = $u, ic.Extra = Yu, ic.Group = tc, ic.Header = qu, ic.Image = rc, ic.Meta = Zu, ic.propTypes = {};
      var oc = ic;
      function ac(e) {
        var t = e.children,
          n = e.className,
          i = e.color,
          o = e.content,
          s = e.horizontal,
          l = e.inverted,
          u = e.items,
          c = e.size,
          d = e.widths,
          h = K()("ui", i, c, at(s, "horizontal"), at(l, "inverted"), ht(d), "statistics", n),
          f = H(ac, e),
          p = ft(ac, e);
        return r.isNil(t) ? r.isNil(o) ? a.a.createElement(p, E()({}, f, {
          className: h
        }), Gn()(u, function (e) {
          return fc.create(e);
        })) : a.a.createElement(p, E()({}, f, {
          className: h
        }), o) : a.a.createElement(p, E()({}, f, {
          className: h
        }), t);
      }
      ac.handledProps = ["as", "children", "className", "color", "content", "horizontal", "inverted", "items", "size", "widths"], ac.propTypes = {};
      var sc = ac;
      function lc(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = K()("label", n),
          s = H(lc, e),
          l = ft(lc, e);
        return a.a.createElement(l, E()({}, s, {
          className: o
        }), r.isNil(t) ? i : t);
      }
      lc.handledProps = ["as", "children", "className", "content"], lc.propTypes = {}, lc.create = kt(lc, function (e) {
        return {
          content: e
        };
      });
      var uc = lc;
      function cc(e) {
        var t = e.children,
          n = e.className,
          i = e.content,
          o = e.text,
          s = K()(at(o, "text"), "value", n),
          l = H(cc, e),
          u = ft(cc, e);
        return a.a.createElement(u, E()({}, l, {
          className: s
        }), r.isNil(t) ? i : t);
      }
      cc.handledProps = ["as", "children", "className", "content", "text"], cc.propTypes = {}, cc.create = kt(cc, function (e) {
        return {
          content: e
        };
      });
      var dc = cc;
      function hc(e) {
        var t = e.children,
          n = e.className,
          i = e.color,
          o = e.content,
          s = e.floated,
          l = e.horizontal,
          u = e.inverted,
          c = e.label,
          d = e.size,
          h = e.text,
          f = e.value,
          p = K()("ui", i, d, st(s, "floated"), at(l, "horizontal"), at(u, "inverted"), "statistic", n),
          m = H(hc, e),
          g = ft(hc, e);
        return r.isNil(t) ? r.isNil(o) ? a.a.createElement(g, E()({}, m, {
          className: p
        }), dc.create(f, {
          defaultProps: {
            text: h
          },
          autoGenerateKey: !1
        }), uc.create(c, {
          autoGenerateKey: !1
        })) : a.a.createElement(g, E()({}, m, {
          className: p
        }), o) : a.a.createElement(g, E()({}, m, {
          className: p
        }), t);
      }
      hc.handledProps = ["as", "children", "className", "color", "content", "floated", "horizontal", "inverted", "label", "size", "text", "value"], hc.propTypes = {}, hc.Group = sc, hc.Label = uc, hc.Value = dc, hc.create = kt(hc, function (e) {
        return {
          content: e
        };
      });
      var fc = hc;
    },
    "./node_modules/setimmediate/setImmediate.js": function node_modulesSetimmediateSetImmediateJs(e, t, n) {
      (function (e, t) {
        !function (e, n) {
          "use strict";

          if (!e.setImmediate) {
            var r,
              i,
              o,
              a,
              s,
              l = 1,
              u = {},
              c = !1,
              d = e.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(e);
            h = h && h.setTimeout ? h : e, "[object process]" === {}.toString.call(e.process) ? r = function r(e) {
              t.nextTick(function () {
                p(e);
              });
            } : !function () {
              if (e.postMessage && !e.importScripts) {
                var t = !0,
                  n = e.onmessage;
                return e.onmessage = function () {
                  t = !1;
                }, e.postMessage("", "*"), e.onmessage = n, t;
              }
            }() ? e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
              p(e.data);
            }, r = function r(e) {
              o.port2.postMessage(e);
            }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function r(e) {
              var t = d.createElement("script");
              t.onreadystatechange = function () {
                p(e), t.onreadystatechange = null, i.removeChild(t), t = null;
              }, i.appendChild(t);
            }) : r = function r(e) {
              setTimeout(p, 0, e);
            } : (a = "setImmediate$" + Math.random() + "$", s = function s(t) {
              t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && p(+t.data.slice(a.length));
            }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function r(t) {
              e.postMessage(a + t, "*");
            }), h.setImmediate = function (e) {
              "function" != typeof e && (e = new Function("" + e));
              for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) t[n] = arguments[n + 1];
              var i = {
                callback: e,
                args: t
              };
              return u[l] = i, r(l), l++;
            }, h.clearImmediate = f;
          }
          function f(e) {
            delete u[e];
          }
          function p(e) {
            if (c) setTimeout(p, 0, e);else {
              var t = u[e];
              if (t) {
                c = !0;
                try {
                  !function (e) {
                    var t = e.callback,
                      n = e.args;
                    switch (n.length) {
                      case 0:
                        t();
                        break;
                      case 1:
                        t(n[0]);
                        break;
                      case 2:
                        t(n[0], n[1]);
                        break;
                      case 3:
                        t(n[0], n[1], n[2]);
                        break;
                      default:
                        t.apply(void 0, n);
                    }
                  }(t);
                } finally {
                  f(e), c = !1;
                }
              }
            }
          }
        }("undefined" == typeof self ? void 0 === e ? this : e : self);
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/process/browser.js"));
    },
    "./node_modules/sha.js/hash.js": function node_modulesShaJsHashJs(e, t, n) {
      var r = n("./node_modules/safe-buffer/index.js").Buffer;
      function i(e, t) {
        this._block = r.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
      }
      i.prototype.update = function (e, t) {
        "string" == typeof e && (t = t || "utf8", e = r.from(e, t));
        for (var n = this._block, i = this._blockSize, o = e.length, a = this._len, s = 0; s < o;) {
          for (var l = a % i, u = Math.min(o - s, i - l), c = 0; c < u; c++) n[l + c] = e[s + c];
          s += u, (a += u) % i == 0 && this._update(n);
        }
        return this._len += o, this;
      }, i.prototype.digest = function (e) {
        var t = this._len % this._blockSize;
        this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
        var n = 8 * this._len;
        if (n <= 4294967295) this._block.writeUInt32BE(n, this._blockSize - 4);else {
          var r = (4294967295 & n) >>> 0,
            i = (n - r) / 4294967296;
          this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(r, this._blockSize - 4);
        }
        this._update(this._block);
        var o = this._hash();
        return e ? o.toString(e) : o;
      }, i.prototype._update = function () {
        throw new Error("_update must be implemented by subclass");
      }, e.exports = i;
    },
    "./node_modules/sha.js/index.js": function node_modulesShaJsIndexJs(e, t, n) {
      (t = e.exports = function (e) {
        e = e.toLowerCase();
        var n = t[e];
        if (!n) throw new Error(e + " is not supported (we accept pull requests)");
        return new n();
      }).sha = n("./node_modules/sha.js/sha.js"), t.sha1 = n("./node_modules/sha.js/sha1.js"), t.sha224 = n("./node_modules/sha.js/sha224.js"), t.sha256 = n("./node_modules/sha.js/sha256.js"), t.sha384 = n("./node_modules/sha.js/sha384.js"), t.sha512 = n("./node_modules/sha.js/sha512.js");
    },
    "./node_modules/sha.js/sha.js": function node_modulesShaJsShaJs(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/sha.js/hash.js"),
        o = n("./node_modules/safe-buffer/index.js").Buffer,
        a = [1518500249, 1859775393, -1894007588, -899497514],
        s = new Array(80);
      function l() {
        this.init(), this._w = s, i.call(this, 64, 56);
      }
      function u(e) {
        return e << 30 | e >>> 2;
      }
      function c(e, t, n, r) {
        return 0 === e ? t & n | ~t & r : 2 === e ? t & n | t & r | n & r : t ^ n ^ r;
      }
      r(l, i), l.prototype.init = function () {
        return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
      }, l.prototype._update = function (e) {
        for (var t, n = this._w, r = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, l = 0 | this._e, d = 0; d < 16; ++d) n[d] = e.readInt32BE(4 * d);
        for (; d < 80; ++d) n[d] = n[d - 3] ^ n[d - 8] ^ n[d - 14] ^ n[d - 16];
        for (var h = 0; h < 80; ++h) {
          var f = ~~(h / 20),
            p = 0 | ((t = r) << 5 | t >>> 27) + c(f, i, o, s) + l + n[h] + a[f];
          l = s, s = o, o = u(i), i = r, r = p;
        }
        this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = l + this._e | 0;
      }, l.prototype._hash = function () {
        var e = o.allocUnsafe(20);
        return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
      }, e.exports = l;
    },
    "./node_modules/sha.js/sha1.js": function node_modulesShaJsSha1Js(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/sha.js/hash.js"),
        o = n("./node_modules/safe-buffer/index.js").Buffer,
        a = [1518500249, 1859775393, -1894007588, -899497514],
        s = new Array(80);
      function l() {
        this.init(), this._w = s, i.call(this, 64, 56);
      }
      function u(e) {
        return e << 5 | e >>> 27;
      }
      function c(e) {
        return e << 30 | e >>> 2;
      }
      function d(e, t, n, r) {
        return 0 === e ? t & n | ~t & r : 2 === e ? t & n | t & r | n & r : t ^ n ^ r;
      }
      r(l, i), l.prototype.init = function () {
        return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
      }, l.prototype._update = function (e) {
        for (var t, n = this._w, r = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h) n[h] = e.readInt32BE(4 * h);
        for (; h < 80; ++h) n[h] = (t = n[h - 3] ^ n[h - 8] ^ n[h - 14] ^ n[h - 16]) << 1 | t >>> 31;
        for (var f = 0; f < 80; ++f) {
          var p = ~~(f / 20),
            m = u(r) + d(p, i, o, s) + l + n[f] + a[p] | 0;
          l = s, s = o, o = c(i), i = r, r = m;
        }
        this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = l + this._e | 0;
      }, l.prototype._hash = function () {
        var e = o.allocUnsafe(20);
        return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
      }, e.exports = l;
    },
    "./node_modules/sha.js/sha224.js": function node_modulesShaJsSha224Js(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/sha.js/sha256.js"),
        o = n("./node_modules/sha.js/hash.js"),
        a = n("./node_modules/safe-buffer/index.js").Buffer,
        s = new Array(64);
      function l() {
        this.init(), this._w = s, o.call(this, 64, 56);
      }
      r(l, i), l.prototype.init = function () {
        return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
      }, l.prototype._hash = function () {
        var e = a.allocUnsafe(28);
        return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
      }, e.exports = l;
    },
    "./node_modules/sha.js/sha256.js": function node_modulesShaJsSha256Js(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/sha.js/hash.js"),
        o = n("./node_modules/safe-buffer/index.js").Buffer,
        a = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
        s = new Array(64);
      function l() {
        this.init(), this._w = s, i.call(this, 64, 56);
      }
      function u(e, t, n) {
        return n ^ e & (t ^ n);
      }
      function c(e, t, n) {
        return e & t | n & (e | t);
      }
      function d(e) {
        return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
      }
      function h(e) {
        return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
      }
      function f(e) {
        return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
      }
      r(l, i), l.prototype.init = function () {
        return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
      }, l.prototype._update = function (e) {
        for (var t, n = this._w, r = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, g = 0 | this._h, v = 0; v < 16; ++v) n[v] = e.readInt32BE(4 * v);
        for (; v < 64; ++v) n[v] = 0 | (((t = n[v - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + n[v - 7] + f(n[v - 15]) + n[v - 16];
        for (var y = 0; y < 64; ++y) {
          var b = g + h(l) + u(l, p, m) + a[y] + n[y] | 0,
            _ = d(r) + c(r, i, o) | 0;
          g = m, m = p, p = l, l = s + b | 0, s = o, o = i, i = r, r = b + _ | 0;
        }
        this._a = r + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = g + this._h | 0;
      }, l.prototype._hash = function () {
        var e = o.allocUnsafe(32);
        return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
      }, e.exports = l;
    },
    "./node_modules/sha.js/sha384.js": function node_modulesShaJsSha384Js(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/sha.js/sha512.js"),
        o = n("./node_modules/sha.js/hash.js"),
        a = n("./node_modules/safe-buffer/index.js").Buffer,
        s = new Array(160);
      function l() {
        this.init(), this._w = s, o.call(this, 128, 112);
      }
      r(l, i), l.prototype.init = function () {
        return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
      }, l.prototype._hash = function () {
        var e = a.allocUnsafe(48);
        function t(t, n, r) {
          e.writeInt32BE(t, r), e.writeInt32BE(n, r + 4);
        }
        return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
      }, e.exports = l;
    },
    "./node_modules/sha.js/sha512.js": function node_modulesShaJsSha512Js(e, t, n) {
      var r = n("./node_modules/inherits/inherits_browser.js"),
        i = n("./node_modules/sha.js/hash.js"),
        o = n("./node_modules/safe-buffer/index.js").Buffer,
        a = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
        s = new Array(160);
      function l() {
        this.init(), this._w = s, i.call(this, 128, 112);
      }
      function u(e, t, n) {
        return n ^ e & (t ^ n);
      }
      function c(e, t, n) {
        return e & t | n & (e | t);
      }
      function d(e, t) {
        return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
      }
      function h(e, t) {
        return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
      }
      function f(e, t) {
        return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
      }
      function p(e, t) {
        return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
      }
      function m(e, t) {
        return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
      }
      function g(e, t) {
        return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
      }
      function v(e, t) {
        return e >>> 0 < t >>> 0 ? 1 : 0;
      }
      r(l, i), l.prototype.init = function () {
        return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
      }, l.prototype._update = function (e) {
        for (var t = this._w, n = 0 | this._ah, r = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, s = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, b = 0 | this._hh, _ = 0 | this._al, x = 0 | this._bl, w = 0 | this._cl, S = 0 | this._dl, A = 0 | this._el, E = 0 | this._fl, T = 0 | this._gl, M = 0 | this._hl, C = 0; C < 32; C += 2) t[C] = e.readInt32BE(4 * C), t[C + 1] = e.readInt32BE(4 * C + 4);
        for (; C < 160; C += 2) {
          var k = t[C - 30],
            P = t[C - 30 + 1],
            O = f(k, P),
            R = p(P, k),
            I = m(k = t[C - 4], P = t[C - 4 + 1]),
            j = g(P, k),
            N = t[C - 14],
            L = t[C - 14 + 1],
            D = t[C - 32],
            B = t[C - 32 + 1],
            F = R + L | 0,
            z = O + N + v(F, R) | 0;
          z = (z = z + I + v(F = F + j | 0, j) | 0) + D + v(F = F + B | 0, B) | 0, t[C] = z, t[C + 1] = F;
        }
        for (var U = 0; U < 160; U += 2) {
          z = t[U], F = t[U + 1];
          var G = c(n, r, i),
            V = c(_, x, w),
            H = d(n, _),
            q = d(_, n),
            W = h(s, A),
            $ = h(A, s),
            X = a[U],
            Y = a[U + 1],
            K = u(s, l, y),
            Z = u(A, E, T),
            Q = M + $ | 0,
            J = b + W + v(Q, M) | 0;
          J = (J = (J = J + K + v(Q = Q + Z | 0, Z) | 0) + X + v(Q = Q + Y | 0, Y) | 0) + z + v(Q = Q + F | 0, F) | 0;
          var ee = q + V | 0,
            te = H + G + v(ee, q) | 0;
          b = y, M = T, y = l, T = E, l = s, E = A, s = o + J + v(A = S + Q | 0, S) | 0, o = i, S = w, i = r, w = x, r = n, x = _, n = J + te + v(_ = Q + ee | 0, Q) | 0;
        }
        this._al = this._al + _ | 0, this._bl = this._bl + x | 0, this._cl = this._cl + w | 0, this._dl = this._dl + S | 0, this._el = this._el + A | 0, this._fl = this._fl + E | 0, this._gl = this._gl + T | 0, this._hl = this._hl + M | 0, this._ah = this._ah + n + v(this._al, _) | 0, this._bh = this._bh + r + v(this._bl, x) | 0, this._ch = this._ch + i + v(this._cl, w) | 0, this._dh = this._dh + o + v(this._dl, S) | 0, this._eh = this._eh + s + v(this._el, A) | 0, this._fh = this._fh + l + v(this._fl, E) | 0, this._gh = this._gh + y + v(this._gl, T) | 0, this._hh = this._hh + b + v(this._hl, M) | 0;
      }, l.prototype._hash = function () {
        var e = o.allocUnsafe(64);
        function t(t, n, r) {
          e.writeInt32BE(t, r), e.writeInt32BE(n, r + 4);
        }
        return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
      }, e.exports = l;
    },
    "./node_modules/shallowequal/index.js": function node_modulesShallowequalIndexJs(e, t) {
      e.exports = function (e, t, n, r) {
        var i = n ? n.call(r, e, t) : void 0;
        if (void 0 !== i) return !!i;
        if (e === t) return !0;
        if ("object" != typeof e || !e || "object" != typeof t || !t) return !1;
        var o = Object.keys(e),
          a = Object.keys(t);
        if (o.length !== a.length) return !1;
        for (var s = Object.prototype.hasOwnProperty.bind(t), l = 0; l < o.length; l++) {
          var u = o[l];
          if (!s(u)) return !1;
          var c = e[u],
            d = t[u];
          if (!1 === (i = n ? n.call(r, c, d, u) : void 0) || void 0 === i && c !== d) return !1;
        }
        return !0;
      };
    },
    "./node_modules/stream-browserify/index.js": function node_modulesStreamBrowserifyIndexJs(e, t, n) {
      e.exports = i;
      var r = n("./node_modules/events/events.js").EventEmitter;
      function i() {
        r.call(this);
      }
      n("./node_modules/inherits/inherits_browser.js")(i, r), i.Readable = n("./node_modules/readable-stream/readable-browser.js"), i.Writable = n("./node_modules/readable-stream/writable-browser.js"), i.Duplex = n("./node_modules/readable-stream/duplex-browser.js"), i.Transform = n("./node_modules/readable-stream/transform.js"), i.PassThrough = n("./node_modules/readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function (e, t) {
        var n = this;
        function i(t) {
          e.writable && !1 === e.write(t) && n.pause && n.pause();
        }
        function o() {
          n.readable && n.resume && n.resume();
        }
        n.on("data", i), e.on("drain", o), e._isStdio || t && !1 === t.end || (n.on("end", s), n.on("close", l));
        var a = !1;
        function s() {
          a || (a = !0, e.end());
        }
        function l() {
          a || (a = !0, "function" == typeof e.destroy && e.destroy());
        }
        function u(e) {
          if (c(), 0 === r.listenerCount(this, "error")) throw e;
        }
        function c() {
          n.removeListener("data", i), e.removeListener("drain", o), n.removeListener("end", s), n.removeListener("close", l), n.removeListener("error", u), e.removeListener("error", u), n.removeListener("end", c), n.removeListener("close", c), e.removeListener("close", c);
        }
        return n.on("error", u), e.on("error", u), n.on("end", c), n.on("close", c), e.on("close", c), e.emit("pipe", n), e;
      };
    },
    "./node_modules/string_decoder/lib/string_decoder.js": function node_modulesString_decoderLibString_decoderJs(e, t, n) {
      "use strict";

      var r = n("./node_modules/safe-buffer/index.js").Buffer,
        i = r.isEncoding || function (e) {
          switch ((e = "" + e) && e.toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
              return !0;
            default:
              return !1;
          }
        };
      function o(e) {
        var t;
        switch (this.encoding = function (e) {
          var t = function (e) {
            if (!e) return "utf8";
            for (var t;;) switch (e) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return e;
              default:
                if (t) return;
                e = ("" + e).toLowerCase(), t = !0;
            }
          }(e);
          if ("string" != typeof t && (r.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
          return t || e;
        }(e), this.encoding) {
          case "utf16le":
            this.text = l, this.end = u, t = 4;
            break;
          case "utf8":
            this.fillLast = s, t = 4;
            break;
          case "base64":
            this.text = c, this.end = d, t = 3;
            break;
          default:
            return this.write = h, void (this.end = f);
        }
        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(t);
      }
      function a(e) {
        return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
      }
      function s(e) {
        var t = this.lastTotal - this.lastNeed,
          n = function (e, t, n) {
            if (128 != (192 & t[0])) return e.lastNeed = 0, "�";
            if (e.lastNeed > 1 && t.length > 1) {
              if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
              if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
            }
          }(this, e);
        return void 0 !== n ? n : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
      }
      function l(e, t) {
        if ((e.length - t) % 2 == 0) {
          var n = e.toString("utf16le", t);
          if (n) {
            var r = n.charCodeAt(n.length - 1);
            if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], n.slice(0, -1);
          }
          return n;
        }
        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
      }
      function u(e) {
        var t = e && e.length ? this.write(e) : "";
        if (this.lastNeed) {
          var n = this.lastTotal - this.lastNeed;
          return t + this.lastChar.toString("utf16le", 0, n);
        }
        return t;
      }
      function c(e, t) {
        var n = (e.length - t) % 3;
        return 0 === n ? e.toString("base64", t) : (this.lastNeed = 3 - n, this.lastTotal = 3, 1 === n ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - n));
      }
      function d(e) {
        var t = e && e.length ? this.write(e) : "";
        return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
      }
      function h(e) {
        return e.toString(this.encoding);
      }
      function f(e) {
        return e && e.length ? this.write(e) : "";
      }
      t.StringDecoder = o, o.prototype.write = function (e) {
        if (0 === e.length) return "";
        var t, n;
        if (this.lastNeed) {
          if (void 0 === (t = this.fillLast(e))) return "";
          n = this.lastNeed, this.lastNeed = 0;
        } else n = 0;
        return n < e.length ? t ? t + this.text(e, n) : this.text(e, n) : t || "";
      }, o.prototype.end = function (e) {
        var t = e && e.length ? this.write(e) : "";
        return this.lastNeed ? t + "�" : t;
      }, o.prototype.text = function (e, t) {
        var n = function (e, t, n) {
          var r = t.length - 1;
          if (r < n) return 0;
          var i = a(t[r]);
          if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
          if (--r < n || -2 === i) return 0;
          if ((i = a(t[r])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
          if (--r < n || -2 === i) return 0;
          if ((i = a(t[r])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
          return 0;
        }(this, e, t);
        if (!this.lastNeed) return e.toString("utf8", t);
        this.lastTotal = n;
        var r = e.length - (n - this.lastNeed);
        return e.copy(this.lastChar, 0, r), e.toString("utf8", t, r);
      }, o.prototype.fillLast = function (e) {
        if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
      };
    },
    "./node_modules/style-loader/lib/addStyles.js": function node_modulesStyleLoaderLibAddStylesJs(e, t, n) {
      var r,
        i,
        o = {},
        a = (r = function r() {
          return window && document && document.all && !window.atob;
        }, function () {
          return void 0 === i && (i = r.apply(this, arguments)), i;
        }),
        s = function s(e, t) {
          return t ? t.querySelector(e) : document.querySelector(e);
        },
        l = function (e) {
          var t = {};
          return function (e, n) {
            if ("function" == typeof e) return e();
            if (void 0 === t[e]) {
              var r = s.call(this, e, n);
              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (e) {
                r = null;
              }
              t[e] = r;
            }
            return t[e];
          };
        }(),
        u = null,
        c = 0,
        d = [],
        h = n("./node_modules/style-loader/lib/urls.js");
      function f(e, t) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n],
            i = o[r.id];
          if (i) {
            i.refs++;
            for (var a = 0; a < i.parts.length; a++) i.parts[a](r.parts[a]);
            for (; a < r.parts.length; a++) i.parts.push(b(r.parts[a], t));
          } else {
            var s = [];
            for (a = 0; a < r.parts.length; a++) s.push(b(r.parts[a], t));
            o[r.id] = {
              id: r.id,
              refs: 1,
              parts: s
            };
          }
        }
      }
      function p(e, t) {
        for (var n = [], r = {}, i = 0; i < e.length; i++) {
          var o = e[i],
            a = t.base ? o[0] + t.base : o[0],
            s = {
              css: o[1],
              media: o[2],
              sourceMap: o[3]
            };
          r[a] ? r[a].parts.push(s) : n.push(r[a] = {
            id: a,
            parts: [s]
          });
        }
        return n;
      }
      function m(e, t) {
        var n = l(e.insertInto);
        if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
        var r = d[d.length - 1];
        if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), d.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
          if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
          var i = l(e.insertAt.before, n);
          n.insertBefore(t, i);
        }
      }
      function g(e) {
        if (null === e.parentNode) return !1;
        e.parentNode.removeChild(e);
        var t = d.indexOf(e);
        t >= 0 && d.splice(t, 1);
      }
      function v(e) {
        var t = document.createElement("style");
        if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
          var r = function () {
            0;
            return n.nc;
          }();
          r && (e.attrs.nonce = r);
        }
        return y(t, e.attrs), m(e, t), t;
      }
      function y(e, t) {
        Object.keys(t).forEach(function (n) {
          e.setAttribute(n, t[n]);
        });
      }
      function b(e, t) {
        var n, r, i, o;
        if (t.transform && e.css) {
          if (!(o = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
          e.css = o;
        }
        if (t.singleton) {
          var a = c++;
          n = u || (u = v(t)), r = w.bind(null, n, a, !1), i = w.bind(null, n, a, !0);
        } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
          var t = document.createElement("link");
          return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", y(t, e.attrs), m(e, t), t;
        }(t), r = A.bind(null, n, t), i = function i() {
          g(n), n.href && URL.revokeObjectURL(n.href);
        }) : (n = v(t), r = S.bind(null, n), i = function i() {
          g(n);
        });
        return r(e), function (t) {
          if (t) {
            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
            r(e = t);
          } else i();
        };
      }
      e.exports = function (e, t) {
        if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
        (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = a()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
        var n = p(e, t);
        return f(n, t), function (e) {
          for (var r = [], i = 0; i < n.length; i++) {
            var a = n[i];
            (s = o[a.id]).refs--, r.push(s);
          }
          e && f(p(e, t), t);
          for (i = 0; i < r.length; i++) {
            var s;
            if (0 === (s = r[i]).refs) {
              for (var l = 0; l < s.parts.length; l++) s.parts[l]();
              delete o[s.id];
            }
          }
        };
      };
      var _,
        x = (_ = [], function (e, t) {
          return _[e] = t, _.filter(Boolean).join("\n");
        });
      function w(e, t, n, r) {
        var i = n ? "" : r.css;
        if (e.styleSheet) e.styleSheet.cssText = x(t, i);else {
          var o = document.createTextNode(i),
            a = e.childNodes;
          a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
        }
      }
      function S(e, t) {
        var n = t.css,
          r = t.media;
        if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) e.removeChild(e.firstChild);
          e.appendChild(document.createTextNode(n));
        }
      }
      function A(e, t, n) {
        var r = n.css,
          i = n.sourceMap,
          o = void 0 === t.convertToAbsoluteUrls && i;
        (t.convertToAbsoluteUrls || o) && (r = h(r)), i && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        var a = new Blob([r], {
            type: "text/css"
          }),
          s = e.href;
        e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }
    },
    "./node_modules/style-loader/lib/urls.js": function node_modulesStyleLoaderLibUrlsJs(e, t) {
      e.exports = function (e) {
        var t = "undefined" != typeof window && window.location;
        if (!t) throw new Error("fixUrls requires window.location");
        if (!e || "string" != typeof e) return e;
        var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
        return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
          var i,
            o = t.trim().replace(/^"(.*)"$/, function (e, t) {
              return t;
            }).replace(/^'(.*)'$/, function (e, t) {
              return t;
            });
          return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? e : (i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
        });
      };
    },
    "./node_modules/stylis-rule-sheet/index.js": function node_modulesStylisRuleSheetIndexJs(e, t, n) {
      e.exports = function () {
        "use strict";

        return function (e) {
          function t(t) {
            if (t) try {
              e(t + "}");
            } catch (e) {}
          }
          return function (n, r, i, o, a, s, l, u, c, d) {
            switch (n) {
              case 1:
                if (0 === c && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                break;
              case 2:
                if (0 === u) return r + "/*|*/";
                break;
              case 3:
                switch (u) {
                  case 102:
                  case 112:
                    return e(i[0] + r), "";
                  default:
                    return r + (0 === d ? "/*|*/" : "");
                }
              case -2:
                r.split("/*|*/}").forEach(t);
            }
          };
        };
      }();
    },
    "./node_modules/stylis/stylis.min.js": function node_modulesStylisStylisMinJs(e, t, n) {
      e.exports = function e(t) {
        "use strict";

        var n = /^\0+/g,
          r = /[\0\r\f]/g,
          i = /: */g,
          o = /zoo|gra/,
          a = /([,: ])(transform)/g,
          s = /,+\s*(?![^(]*[)])/g,
          l = / +\s*(?![^(]*[)])/g,
          u = / *[\0] */g,
          c = /,\r+?/g,
          d = /([\t\r\n ])*\f?&/g,
          h = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
          f = /\W+/g,
          p = /@(k\w+)\s*(\S*)\s*/,
          m = /::(place)/g,
          g = /:(read-only)/g,
          v = /\s+(?=[{\];=:>])/g,
          y = /([[}=:>])\s+/g,
          b = /(\{[^{]+?);(?=\})/g,
          _ = /\s{2,}/g,
          x = /([^\(])(:+) */g,
          w = /[svh]\w+-[tblr]{2}/,
          S = /\(\s*(.*)\s*\)/g,
          A = /([\s\S]*?);/g,
          E = /-self|flex-/g,
          T = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
          M = /stretch|:\s*\w+\-(?:conte|avail)/,
          C = /([^-])(image-set\()/,
          k = "-webkit-",
          P = "-moz-",
          O = "-ms-",
          R = 59,
          I = 125,
          j = 123,
          N = 40,
          L = 41,
          D = 10,
          B = 13,
          F = 32,
          z = 45,
          U = 42,
          G = 44,
          V = 58,
          H = 47,
          q = 1,
          W = 1,
          $ = 0,
          X = 1,
          Y = 1,
          K = 1,
          Z = 0,
          Q = 0,
          J = 0,
          ee = [],
          te = [],
          ne = 0,
          re = null,
          ie = 0,
          oe = 1,
          ae = "",
          se = "",
          le = "";
        function ue(e, t, i, o, a) {
          for (var s, l, c = 0, d = 0, h = 0, f = 0, v = 0, y = 0, b = 0, _ = 0, w = 0, A = 0, E = 0, T = 0, M = 0, C = 0, P = 0, O = 0, Z = 0, te = 0, re = 0, de = i.length, ve = de - 1, ye = "", be = "", _e = "", xe = "", we = "", Se = ""; P < de;) {
            if (b = i.charCodeAt(P), P === ve && d + f + h + c !== 0 && (0 !== d && (b = d === H ? D : H), f = h = c = 0, de++, ve++), d + f + h + c === 0) {
              if (P === ve && (O > 0 && (be = be.replace(r, "")), be.trim().length > 0)) {
                switch (b) {
                  case F:
                  case 9:
                  case R:
                  case B:
                  case D:
                    break;
                  default:
                    be += i.charAt(P);
                }
                b = R;
              }
              if (1 === Z) switch (b) {
                case j:
                case I:
                case R:
                case 34:
                case 39:
                case N:
                case L:
                case G:
                  Z = 0;
                case 9:
                case B:
                case D:
                case F:
                  break;
                default:
                  for (Z = 0, re = P, v = b, P--, b = R; re < de;) switch (i.charCodeAt(re++)) {
                    case D:
                    case B:
                    case R:
                      ++P, b = v, re = de;
                      break;
                    case V:
                      O > 0 && (++P, b = v);
                    case j:
                      re = de;
                  }
              }
              switch (b) {
                case j:
                  for (v = (be = be.trim()).charCodeAt(0), E = 1, re = ++P; P < de;) {
                    switch (b = i.charCodeAt(P)) {
                      case j:
                        E++;
                        break;
                      case I:
                        E--;
                        break;
                      case H:
                        switch (y = i.charCodeAt(P + 1)) {
                          case U:
                          case H:
                            P = ge(y, P, ve, i);
                        }
                        break;
                      case 91:
                        b++;
                      case N:
                        b++;
                      case 34:
                      case 39:
                        for (; P++ < ve && i.charCodeAt(P) !== b;);
                    }
                    if (0 === E) break;
                    P++;
                  }
                  switch (_e = i.substring(re, P), 0 === v && (v = (be = be.replace(n, "").trim()).charCodeAt(0)), v) {
                    case 64:
                      switch (O > 0 && (be = be.replace(r, "")), y = be.charCodeAt(1)) {
                        case 100:
                        case 109:
                        case 115:
                        case z:
                          s = t;
                          break;
                        default:
                          s = ee;
                      }
                      if (re = (_e = ue(t, s, _e, y, a + 1)).length, J > 0 && 0 === re && (re = be.length), ne > 0 && (l = me(3, _e, s = ce(ee, be, te), t, W, q, re, y, a, o), be = s.join(""), void 0 !== l && 0 === (re = (_e = l.trim()).length) && (y = 0, _e = "")), re > 0) switch (y) {
                        case 115:
                          be = be.replace(S, pe);
                        case 100:
                        case 109:
                        case z:
                          _e = be + "{" + _e + "}";
                          break;
                        case 107:
                          _e = (be = be.replace(p, "$1 $2" + (oe > 0 ? ae : ""))) + "{" + _e + "}", _e = 1 === Y || 2 === Y && fe("@" + _e, 3) ? "@" + k + _e + "@" + _e : "@" + _e;
                          break;
                        default:
                          _e = be + _e, 112 === o && (xe += _e, _e = "");
                      } else _e = "";
                      break;
                    default:
                      _e = ue(t, ce(t, be, te), _e, o, a + 1);
                  }
                  we += _e, T = 0, Z = 0, C = 0, O = 0, te = 0, M = 0, be = "", _e = "", b = i.charCodeAt(++P);
                  break;
                case I:
                case R:
                  if ((re = (be = (O > 0 ? be.replace(r, "") : be).trim()).length) > 1) switch (0 === C && ((v = be.charCodeAt(0)) === z || v > 96 && v < 123) && (re = (be = be.replace(" ", ":")).length), ne > 0 && void 0 !== (l = me(1, be, t, e, W, q, xe.length, o, a, o)) && 0 === (re = (be = l.trim()).length) && (be = "\0\0"), v = be.charCodeAt(0), y = be.charCodeAt(1), v) {
                    case 0:
                      break;
                    case 64:
                      if (105 === y || 99 === y) {
                        Se += be + i.charAt(P);
                        break;
                      }
                    default:
                      if (be.charCodeAt(re - 1) === V) break;
                      xe += he(be, v, y, be.charCodeAt(2));
                  }
                  T = 0, Z = 0, C = 0, O = 0, te = 0, be = "", b = i.charCodeAt(++P);
              }
            }
            switch (b) {
              case B:
              case D:
                if (d + f + h + c + Q === 0) switch (A) {
                  case L:
                  case 39:
                  case 34:
                  case 64:
                  case 126:
                  case 62:
                  case U:
                  case 43:
                  case H:
                  case z:
                  case V:
                  case G:
                  case R:
                  case j:
                  case I:
                    break;
                  default:
                    C > 0 && (Z = 1);
                }
                d === H ? d = 0 : X + T === 0 && 107 !== o && be.length > 0 && (O = 1, be += "\0"), ne * ie > 0 && me(0, be, t, e, W, q, xe.length, o, a, o), q = 1, W++;
                break;
              case R:
              case I:
                if (d + f + h + c === 0) {
                  q++;
                  break;
                }
              default:
                switch (q++, ye = i.charAt(P), b) {
                  case 9:
                  case F:
                    if (f + c + d === 0) switch (_) {
                      case G:
                      case V:
                      case 9:
                      case F:
                        ye = "";
                        break;
                      default:
                        b !== F && (ye = " ");
                    }
                    break;
                  case 0:
                    ye = "\\0";
                    break;
                  case 12:
                    ye = "\\f";
                    break;
                  case 11:
                    ye = "\\v";
                    break;
                  case 38:
                    f + d + c === 0 && X > 0 && (te = 1, O = 1, ye = "\f" + ye);
                    break;
                  case 108:
                    if (f + d + c + $ === 0 && C > 0) switch (P - C) {
                      case 2:
                        112 === _ && i.charCodeAt(P - 3) === V && ($ = _);
                      case 8:
                        111 === w && ($ = w);
                    }
                    break;
                  case V:
                    f + d + c === 0 && (C = P);
                    break;
                  case G:
                    d + h + f + c === 0 && (O = 1, ye += "\r");
                    break;
                  case 34:
                  case 39:
                    0 === d && (f = f === b ? 0 : 0 === f ? b : f);
                    break;
                  case 91:
                    f + d + h === 0 && c++;
                    break;
                  case 93:
                    f + d + h === 0 && c--;
                    break;
                  case L:
                    f + d + c === 0 && h--;
                    break;
                  case N:
                    if (f + d + c === 0) {
                      if (0 === T) switch (2 * _ + 3 * w) {
                        case 533:
                          break;
                        default:
                          E = 0, T = 1;
                      }
                      h++;
                    }
                    break;
                  case 64:
                    d + h + f + c + C + M === 0 && (M = 1);
                    break;
                  case U:
                  case H:
                    if (f + c + h > 0) break;
                    switch (d) {
                      case 0:
                        switch (2 * b + 3 * i.charCodeAt(P + 1)) {
                          case 235:
                            d = H;
                            break;
                          case 220:
                            re = P, d = U;
                        }
                        break;
                      case U:
                        b === H && _ === U && re + 2 !== P && (33 === i.charCodeAt(re + 2) && (xe += i.substring(re, P + 1)), ye = "", d = 0);
                    }
                }
                if (0 === d) {
                  if (X + f + c + M === 0 && 107 !== o && b !== R) switch (b) {
                    case G:
                    case 126:
                    case 62:
                    case 43:
                    case L:
                    case N:
                      if (0 === T) {
                        switch (_) {
                          case 9:
                          case F:
                          case D:
                          case B:
                            ye += "\0";
                            break;
                          default:
                            ye = "\0" + ye + (b === G ? "" : "\0");
                        }
                        O = 1;
                      } else switch (b) {
                        case N:
                          C + 7 === P && 108 === _ && (C = 0), T = ++E;
                          break;
                        case L:
                          0 == (T = --E) && (O = 1, ye += "\0");
                      }
                      break;
                    case 9:
                    case F:
                      switch (_) {
                        case 0:
                        case j:
                        case I:
                        case R:
                        case G:
                        case 12:
                        case 9:
                        case F:
                        case D:
                        case B:
                          break;
                        default:
                          0 === T && (O = 1, ye += "\0");
                      }
                  }
                  be += ye, b !== F && 9 !== b && (A = b);
                }
            }
            w = _, _ = b, P++;
          }
          if (re = xe.length, J > 0 && 0 === re && 0 === we.length && 0 === t[0].length == 0 && (109 !== o || 1 === t.length && (X > 0 ? se : le) === t[0]) && (re = t.join(",").length + 2), re > 0) {
            if (s = 0 === X && 107 !== o ? function (e) {
              for (var t, n, i = 0, o = e.length, a = Array(o); i < o; ++i) {
                for (var s = e[i].split(u), l = "", c = 0, d = 0, h = 0, f = 0, p = s.length; c < p; ++c) if (!(0 === (d = (n = s[c]).length) && p > 1)) {
                  if (h = l.charCodeAt(l.length - 1), f = n.charCodeAt(0), t = "", 0 !== c) switch (h) {
                    case U:
                    case 126:
                    case 62:
                    case 43:
                    case F:
                    case N:
                      break;
                    default:
                      t = " ";
                  }
                  switch (f) {
                    case 38:
                      n = t + se;
                    case 126:
                    case 62:
                    case 43:
                    case F:
                    case L:
                    case N:
                      break;
                    case 91:
                      n = t + n + se;
                      break;
                    case V:
                      switch (2 * n.charCodeAt(1) + 3 * n.charCodeAt(2)) {
                        case 530:
                          if (K > 0) {
                            n = t + n.substring(8, d - 1);
                            break;
                          }
                        default:
                          (c < 1 || s[c - 1].length < 1) && (n = t + se + n);
                      }
                      break;
                    case G:
                      t = "";
                    default:
                      n = d > 1 && n.indexOf(":") > 0 ? t + n.replace(x, "$1" + se + "$2") : t + n + se;
                  }
                  l += n;
                }
                a[i] = l.replace(r, "").trim();
              }
              return a;
            }(t) : t, ne > 0 && void 0 !== (l = me(2, xe, s, e, W, q, re, o, a, o)) && 0 === (xe = l).length) return Se + xe + we;
            if (xe = s.join(",") + "{" + xe + "}", Y * $ != 0) {
              switch (2 !== Y || fe(xe, 2) || ($ = 0), $) {
                case 111:
                  xe = xe.replace(g, ":-moz-$1") + xe;
                  break;
                case 112:
                  xe = xe.replace(m, "::" + k + "input-$1") + xe.replace(m, "::-moz-$1") + xe.replace(m, ":-ms-input-$1") + xe;
              }
              $ = 0;
            }
          }
          return Se + xe + we;
        }
        function ce(e, t, n) {
          var r = t.trim().split(c),
            i = r,
            o = r.length,
            a = e.length;
          switch (a) {
            case 0:
            case 1:
              for (var s = 0, l = 0 === a ? "" : e[0] + " "; s < o; ++s) i[s] = de(l, i[s], n, a).trim();
              break;
            default:
              s = 0;
              var u = 0;
              for (i = []; s < o; ++s) for (var d = 0; d < a; ++d) i[u++] = de(e[d] + " ", r[s], n, a).trim();
          }
          return i;
        }
        function de(e, t, n, r) {
          var i = t,
            o = i.charCodeAt(0);
          switch (o < 33 && (o = (i = i.trim()).charCodeAt(0)), o) {
            case 38:
              switch (X + r) {
                case 0:
                case 1:
                  if (0 === e.trim().length) break;
                default:
                  return i.replace(d, "$1" + e.trim());
              }
              break;
            case V:
              switch (i.charCodeAt(1)) {
                case 103:
                  if (K > 0 && X > 0) return i.replace(h, "$1").replace(d, "$1" + le);
                  break;
                default:
                  return e.trim() + i.replace(d, "$1" + e.trim());
              }
            default:
              if (n * X > 0 && i.indexOf("\f") > 0) return i.replace(d, (e.charCodeAt(0) === V ? "" : "$1") + e.trim());
          }
          return e + i;
        }
        function he(e, t, n, r) {
          var u,
            c = 0,
            d = e + ";",
            h = 2 * t + 3 * n + 4 * r;
          if (944 === h) return function (e) {
            var t = e.length,
              n = e.indexOf(":", 9) + 1,
              r = e.substring(0, n).trim(),
              i = e.substring(n, t - 1).trim();
            switch (e.charCodeAt(9) * oe) {
              case 0:
                break;
              case z:
                if (110 !== e.charCodeAt(10)) break;
              default:
                var o = i.split((i = "", s)),
                  a = 0;
                for (n = 0, t = o.length; a < t; n = 0, ++a) {
                  for (var u = o[a], c = u.split(l); u = c[n];) {
                    var d = u.charCodeAt(0);
                    if (1 === oe && (d > 64 && d < 90 || d > 96 && d < 123 || 95 === d || d === z && u.charCodeAt(1) !== z)) switch (isNaN(parseFloat(u)) + (-1 !== u.indexOf("("))) {
                      case 1:
                        switch (u) {
                          case "infinite":
                          case "alternate":
                          case "backwards":
                          case "running":
                          case "normal":
                          case "forwards":
                          case "both":
                          case "none":
                          case "linear":
                          case "ease":
                          case "ease-in":
                          case "ease-out":
                          case "ease-in-out":
                          case "paused":
                          case "reverse":
                          case "alternate-reverse":
                          case "inherit":
                          case "initial":
                          case "unset":
                          case "step-start":
                          case "step-end":
                            break;
                          default:
                            u += ae;
                        }
                    }
                    c[n++] = u;
                  }
                  i += (0 === a ? "" : ",") + c.join(" ");
                }
            }
            return i = r + i + ";", 1 === Y || 2 === Y && fe(i, 1) ? k + i + i : i;
          }(d);
          if (0 === Y || 2 === Y && !fe(d, 1)) return d;
          switch (h) {
            case 1015:
              return 97 === d.charCodeAt(10) ? k + d + d : d;
            case 951:
              return 116 === d.charCodeAt(3) ? k + d + d : d;
            case 963:
              return 110 === d.charCodeAt(5) ? k + d + d : d;
            case 1009:
              if (100 !== d.charCodeAt(4)) break;
            case 969:
            case 942:
              return k + d + d;
            case 978:
              return k + d + P + d + d;
            case 1019:
            case 983:
              return k + d + P + d + O + d + d;
            case 883:
              return d.charCodeAt(8) === z ? k + d + d : d.indexOf("image-set(", 11) > 0 ? d.replace(C, "$1" + k + "$2") + d : d;
            case 932:
              if (d.charCodeAt(4) === z) switch (d.charCodeAt(5)) {
                case 103:
                  return k + "box-" + d.replace("-grow", "") + k + d + O + d.replace("grow", "positive") + d;
                case 115:
                  return k + d + O + d.replace("shrink", "negative") + d;
                case 98:
                  return k + d + O + d.replace("basis", "preferred-size") + d;
              }
              return k + d + O + d + d;
            case 964:
              return k + d + O + "flex-" + d + d;
            case 1023:
              if (99 !== d.charCodeAt(8)) break;
              return u = d.substring(d.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), k + "box-pack" + u + k + d + O + "flex-pack" + u + d;
            case 1005:
              return o.test(d) ? d.replace(i, ":" + k) + d.replace(i, ":" + P) + d : d;
            case 1e3:
              switch (c = (u = d.substring(13).trim()).indexOf("-") + 1, u.charCodeAt(0) + u.charCodeAt(c)) {
                case 226:
                  u = d.replace(w, "tb");
                  break;
                case 232:
                  u = d.replace(w, "tb-rl");
                  break;
                case 220:
                  u = d.replace(w, "lr");
                  break;
                default:
                  return d;
              }
              return k + d + O + u + d;
            case 1017:
              if (-1 === d.indexOf("sticky", 9)) return d;
            case 975:
              switch (c = (d = e).length - 10, h = (u = (33 === d.charCodeAt(c) ? d.substring(0, c) : d).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | u.charCodeAt(7))) {
                case 203:
                  if (u.charCodeAt(8) < 111) break;
                case 115:
                  d = d.replace(u, k + u) + ";" + d;
                  break;
                case 207:
                case 102:
                  d = d.replace(u, k + (h > 102 ? "inline-" : "") + "box") + ";" + d.replace(u, k + u) + ";" + d.replace(u, O + u + "box") + ";" + d;
              }
              return d + ";";
            case 938:
              if (d.charCodeAt(5) === z) switch (d.charCodeAt(6)) {
                case 105:
                  return u = d.replace("-items", ""), k + d + k + "box-" + u + O + "flex-" + u + d;
                case 115:
                  return k + d + O + "flex-item-" + d.replace(E, "") + d;
                default:
                  return k + d + O + "flex-line-pack" + d.replace("align-content", "").replace(E, "") + d;
              }
              break;
            case 973:
            case 989:
              if (d.charCodeAt(3) !== z || 122 === d.charCodeAt(4)) break;
            case 931:
            case 953:
              if (!0 === M.test(e)) return 115 === (u = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? he(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : d.replace(u, k + u) + d.replace(u, P + u.replace("fill-", "")) + d;
              break;
            case 962:
              if (d = k + d + (102 === d.charCodeAt(5) ? O + d : "") + d, n + r === 211 && 105 === d.charCodeAt(13) && d.indexOf("transform", 10) > 0) return d.substring(0, d.indexOf(";", 27) + 1).replace(a, "$1" + k + "$2") + d;
          }
          return d;
        }
        function fe(e, t) {
          var n = e.indexOf(1 === t ? ":" : "{"),
            r = e.substring(0, 3 !== t ? n : 10),
            i = e.substring(n + 1, e.length - 1);
          return re(2 !== t ? r : r.replace(T, "$1"), i, t);
        }
        function pe(e, t) {
          var n = he(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
          return n !== t + ";" ? n.replace(A, " or ($1)").substring(4) : "(" + t + ")";
        }
        function me(e, t, n, r, i, o, a, s, l, u) {
          for (var c, d = 0, h = t; d < ne; ++d) switch (c = te[d].call(ye, e, h, n, r, i, o, a, s, l, u)) {
            case void 0:
            case !1:
            case !0:
            case null:
              break;
            default:
              h = c;
          }
          if (h !== t) return h;
        }
        function ge(e, t, n, r) {
          for (var i = t + 1; i < n; ++i) switch (r.charCodeAt(i)) {
            case H:
              if (e === U && r.charCodeAt(i - 1) === U && t + 2 !== i) return i + 1;
              break;
            case D:
              if (e === H) return i + 1;
          }
          return i;
        }
        function ve(e) {
          for (var t in e) {
            var n = e[t];
            switch (t) {
              case "keyframe":
                oe = 0 | n;
                break;
              case "global":
                K = 0 | n;
                break;
              case "cascade":
                X = 0 | n;
                break;
              case "compress":
                Z = 0 | n;
                break;
              case "semicolon":
                Q = 0 | n;
                break;
              case "preserve":
                J = 0 | n;
                break;
              case "prefix":
                re = null, n ? "function" != typeof n ? Y = 1 : (Y = 2, re = n) : Y = 0;
            }
          }
          return ve;
        }
        function ye(t, n) {
          if (void 0 !== this && this.constructor === ye) return e(t);
          var i = t,
            o = i.charCodeAt(0);
          o < 33 && (o = (i = i.trim()).charCodeAt(0)), oe > 0 && (ae = i.replace(f, 91 === o ? "" : "-")), o = 1, 1 === X ? le = i : se = i;
          var a,
            s = [le];
          ne > 0 && void 0 !== (a = me(-1, n, s, s, W, q, 0, 0, 0, 0)) && "string" == typeof a && (n = a);
          var l = ue(ee, s, n, 0, 0);
          return ne > 0 && void 0 !== (a = me(-2, l, s, s, W, q, l.length, 0, 0, 0)) && "string" != typeof (l = a) && (o = 0), ae = "", le = "", se = "", $ = 0, W = 1, q = 1, Z * o == 0 ? l : l.replace(r, "").replace(v, "").replace(y, "$1").replace(b, "$1").replace(_, " ");
        }
        return ye.use = function e(t) {
          switch (t) {
            case void 0:
            case null:
              ne = te.length = 0;
              break;
            default:
              if ("function" == typeof t) te[ne++] = t;else if ("object" == typeof t) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else ie = 0 | !!t;
          }
          return e;
        }, ye.set = ve, void 0 !== t && ve(t), ye;
      }(null);
    },
    "./node_modules/symbol-observable/es/index.js": function node_modulesSymbolObservableEsIndexJs(e, t, n) {
      "use strict";

      (function (e, r) {
        var i,
          o = n("./node_modules/symbol-observable/es/ponyfill.js");
        i = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : r;
        var a = Object(o.a)(i);
        t.a = a;
      }).call(this, n("./node_modules/webpack/buildin/global.js"), n("./node_modules/webpack/buildin/harmony-module.js")(e));
    },
    "./node_modules/symbol-observable/es/ponyfill.js": function node_modulesSymbolObservableEsPonyfillJs(e, t, n) {
      "use strict";

      function r(e) {
        var t,
          n = e.Symbol;
        return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
      }
      n.d(t, "a", function () {
        return r;
      });
    },
    "./node_modules/timers-browserify/main.js": function node_modulesTimersBrowserifyMainJs(e, t, n) {
      (function (e) {
        var r = void 0 !== e && e || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;
        function o(e, t) {
          this._id = e, this._clearFn = t;
        }
        t.setTimeout = function () {
          return new o(i.call(setTimeout, r, arguments), clearTimeout);
        }, t.setInterval = function () {
          return new o(i.call(setInterval, r, arguments), clearInterval);
        }, t.clearTimeout = t.clearInterval = function (e) {
          e && e.close();
        }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
          this._clearFn.call(r, this._id);
        }, t.enroll = function (e, t) {
          clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
        }, t.unenroll = function (e) {
          clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
        }, t._unrefActive = t.active = function (e) {
          clearTimeout(e._idleTimeoutId);
          var t = e._idleTimeout;
          t >= 0 && (e._idleTimeoutId = setTimeout(function () {
            e._onTimeout && e._onTimeout();
          }, t));
        }, n("./node_modules/setimmediate/setImmediate.js"), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/tslib/tslib.es6.js": function node_modulesTslibTslibEs6Js(e, t, n) {
      "use strict";

      n.r(t), n.d(t, "__extends", function () {
        return i;
      }), n.d(t, "__assign", function () {
        return _o8;
      }), n.d(t, "__rest", function () {
        return a;
      }), n.d(t, "__decorate", function () {
        return s;
      }), n.d(t, "__param", function () {
        return l;
      }), n.d(t, "__metadata", function () {
        return u;
      }), n.d(t, "__awaiter", function () {
        return c;
      }), n.d(t, "__generator", function () {
        return d;
      }), n.d(t, "__exportStar", function () {
        return h;
      }), n.d(t, "__values", function () {
        return f;
      }), n.d(t, "__read", function () {
        return p;
      }), n.d(t, "__spread", function () {
        return m;
      }), n.d(t, "__spreadArrays", function () {
        return g;
      }), n.d(t, "__await", function () {
        return v;
      }), n.d(t, "__asyncGenerator", function () {
        return y;
      }), n.d(t, "__asyncDelegator", function () {
        return b;
      }), n.d(t, "__asyncValues", function () {
        return _;
      }), n.d(t, "__makeTemplateObject", function () {
        return x;
      }), n.d(t, "__importStar", function () {
        return w;
      }), n.d(t, "__importDefault", function () {
        return S;
      }), n.d(t, "__classPrivateFieldGet", function () {
        return A;
      }), n.d(t, "__classPrivateFieldSet", function () {
        return E;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      var _r11 = function r(e, t) {
        return (_r11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      };
      function i(e, t) {
        function n() {
          this.constructor = e;
        }
        _r11(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }
      var _o8 = function o() {
        return (_o8 = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }).apply(this, arguments);
      };
      function a(e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var i = 0;
          for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
        }
        return n;
      }
      function s(e, t, n, r) {
        var i,
          o = arguments.length,
          a = o < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (i = e[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(t, n, a) : i(t, n)) || a);
        return o > 3 && a && Object.defineProperty(t, n, a), a;
      }
      function l(e, t) {
        return function (n, r) {
          t(n, r, e);
        };
      }
      function u(e, t) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
      }
      function c(e, t, n, r) {
        return new (n || (n = Promise))(function (i, o) {
          function a(e) {
            try {
              l(r.next(e));
            } catch (e) {
              o(e);
            }
          }
          function s(e) {
            try {
              l(r.throw(e));
            } catch (e) {
              o(e);
            }
          }
          function l(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }
          l((r = r.apply(e, t || [])).next());
        });
      }
      function d(e, t) {
        var n,
          r,
          i,
          o,
          a = {
            label: 0,
            sent: function sent() {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;
        function s(o) {
          return function (s) {
            return function (o) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;
                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = o[1], o = [0];
                    continue;
                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }
                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }
                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }
                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                o = t.call(e, a);
              } catch (e) {
                o = [6, e], r = 0;
              } finally {
                n = i = 0;
              }
              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      }
      function h(e, t) {
        for (var n in e) t.hasOwnProperty(n) || (t[n] = e[n]);
      }
      function f(e) {
        var t = "function" == typeof Symbol && Symbol.iterator,
          n = t && e[t],
          r = 0;
        if (n) return n.call(e);
        if (e && "number" == typeof e.length) return {
          next: function next() {
            return e && r >= e.length && (e = void 0), {
              value: e && e[r++],
              done: !e
            };
          }
        };
        throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }
      function p(e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r,
          i,
          o = n.call(e),
          a = [];
        try {
          for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) a.push(r.value);
        } catch (e) {
          i = {
            error: e
          };
        } finally {
          try {
            r && !r.done && (n = o.return) && n.call(o);
          } finally {
            if (i) throw i.error;
          }
        }
        return a;
      }
      function m() {
        for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(p(arguments[t]));
        return e;
      }
      function g() {
        for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
        var r = Array(e),
          i = 0;
        for (t = 0; t < n; t++) for (var o = arguments[t], a = 0, s = o.length; a < s; a++, i++) r[i] = o[a];
        return r;
      }
      function v(e) {
        return this instanceof v ? (this.v = e, this) : new v(e);
      }
      function y(e, t, n) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var r,
          i = n.apply(e, t || []),
          o = [];
        return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
          return this;
        }, r;
        function a(e) {
          i[e] && (r[e] = function (t) {
            return new Promise(function (n, r) {
              o.push([e, t, n, r]) > 1 || s(e, t);
            });
          });
        }
        function s(e, t) {
          try {
            (n = i[e](t)).value instanceof v ? Promise.resolve(n.value.v).then(l, u) : c(o[0][2], n);
          } catch (e) {
            c(o[0][3], e);
          }
          var n;
        }
        function l(e) {
          s("next", e);
        }
        function u(e) {
          s("throw", e);
        }
        function c(e, t) {
          e(t), o.shift(), o.length && s(o[0][0], o[0][1]);
        }
      }
      function b(e) {
        var t, n;
        return t = {}, r("next"), r("throw", function (e) {
          throw e;
        }), r("return"), t[Symbol.iterator] = function () {
          return this;
        }, t;
        function r(r, i) {
          t[r] = e[r] ? function (t) {
            return (n = !n) ? {
              value: v(e[r](t)),
              done: "return" === r
            } : i ? i(t) : t;
          } : i;
        }
      }
      function _(e) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var t,
          n = e[Symbol.asyncIterator];
        return n ? n.call(e) : (e = f(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
          return this;
        }, t);
        function r(n) {
          t[n] = e[n] && function (t) {
            return new Promise(function (r, i) {
              (function (e, t, n, r) {
                Promise.resolve(r).then(function (t) {
                  e({
                    value: t,
                    done: n
                  });
                }, t);
              })(r, i, (t = e[n](t)).done, t.value);
            });
          };
        }
      }
      function x(e, t) {
        return Object.defineProperty ? Object.defineProperty(e, "raw", {
          value: t
        }) : e.raw = t, e;
      }
      function w(e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return t.default = e, t;
      }
      function S(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }
      function A(e, t) {
        if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
        return t.get(e);
      }
      function E(e, t, n) {
        if (!t.has(e)) throw new TypeError("attempted to set private field on non-instance");
        return t.set(e, n), n;
      }
    },
    "./node_modules/typesafe-actions/dist/index.umd.js": function node_modulesTypesafeActionsDistIndexUmdJs(e, t, n) {
      !function (e) {
        "use strict";

        function t(e, t, n) {
          return {
            type: e,
            payload: t,
            meta: n
          };
        }
        function n(e, t) {
          if (void 0 === t && (t = 1), null == e) throw new Error("Argument (#" + t + ") is missing");
          if ("string" != typeof e && "symbol" != typeof e) throw new Error("Argument (#" + t + ") should be of type: string | symbol");
        }
        function r(e, t) {
          var n = null != t ? t(e) : function () {
            return {
              type: e
            };
          };
          return Object.assign(n, {
            getType: function getType() {
              return e;
            },
            toString: function toString() {
              return e;
            }
          });
        }
        e.action = t, e.createAction = function (e, r) {
          n(e);
          var i = null == r ? function () {
            return t(e);
          } : r(t.bind(null, e));
          return Object.assign(i, {
            getType: function getType() {
              return e;
            },
            toString: function toString() {
              return e;
            }
          });
        }, e.createStandardAction = function (e) {
          return n(e), Object.assign(function () {
            return r(e, function (e) {
              return function (t, n) {
                return {
                  type: e,
                  payload: t,
                  meta: n
                };
              };
            });
          }, {
            map: function map(t) {
              return r(e, function (e) {
                return function (n, r) {
                  return Object.assign(t(n, r), {
                    type: e
                  });
                };
              });
            }
          });
        }, e.createAsyncAction = function (e, t, i) {
          return [e, t, i].forEach(function (e, t) {
            n(e, t + 1);
          }), Object.assign(function () {
            return {
              request: r(e, function (t) {
                return function (t) {
                  return {
                    type: e,
                    payload: t
                  };
                };
              }),
              success: r(t, function (e) {
                return function (e) {
                  return {
                    type: t,
                    payload: e
                  };
                };
              }),
              failure: r(i, function (e) {
                return function (e) {
                  return {
                    type: i,
                    payload: e
                  };
                };
              })
            };
          }, {});
        }, e.getType = function (e) {
          if (null == e) throw new Error("first argument is missing");
          if (null == e.getType) throw new Error('first argument is not an instance of "typesafe-actions"');
          return e.getType();
        }, e.isOfType = function (e, t) {
          Array.isArray(e) ? e.forEach(function (e) {
            return n(e);
          }) : n(e);
          var r = Array.isArray(e) ? function (t) {
            return e.includes(t.type);
          } : function (t) {
            return t.type === e;
          };
          return null == t ? r : r(t);
        }, e.isActionOf = function (e, t) {
          if (null == e) throw new Error("first argument is missing");
          if (Array.isArray(e)) e.forEach(function (e, t) {
            if (null == e.getType) throw new Error('first argument contains element\n        that is not created with "typesafe-actions" at index [' + t + "]");
          });else if (null == e.getType) throw new Error('first argument is not created with "typesafe-actions"');
          var n = function n(t) {
            return (Array.isArray(e) ? e : [e]).some(function (e, n) {
              return e.getType() === t.type;
            });
          };
          return null == t ? n : n(t);
        }, e.createActionDeprecated = function (e, t) {
          var n;
          if (null != t) {
            if ("function" != typeof t) throw new Error("second argument is not a function");
            n = t;
          } else n = function n() {
            return {
              type: e
            };
          };
          if (null == e) throw new Error("first argument is missing");
          if ("string" != typeof e && "symbol" != typeof e) throw new Error("first argument should be type of: string | symbol");
          return n;
        }, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }(t);
    },
    "./node_modules/umap-js/dist/heap.js": function node_modulesUmapJsDistHeapJs(e, t, n) {
      "use strict";

      var r = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return t.default = e, t;
      };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = r(n("./node_modules/umap-js/dist/utils.js"));
      function o(e, t) {
        var n = function n(_n18) {
            return i.empty(e).map(function () {
              return i.filled(t, _n18);
            });
          },
          r = [];
        return r.push(n(-1)), r.push(n(1 / 0)), r.push(n(0)), r;
      }
      function a(e, t, n, r, i) {
        t = Math.floor(t);
        var o = e[0][t],
          a = e[1][t];
        e[2][t];
        if (n >= a[0]) return 0;
        for (var l = 0; l < o.length; l++) if (r === o[l]) return 0;
        return s(e, t, n, r, i);
      }
      function s(e, t, n, r, i) {
        var o = e[0][t],
          a = e[1][t],
          s = e[2][t];
        if (n >= a[0]) return 0;
        a[0] = n, o[0] = r, s[0] = i;
        for (var l = 0, u = 0;;) {
          var c = 2 * l + 1,
            d = c + 1,
            h = e[0][0].length;
          if (c >= h) break;
          if (d >= h) {
            if (!(a[c] > n)) break;
            u = c;
          } else if (a[c] >= a[d]) {
            if (!(n < a[c])) break;
            u = c;
          } else {
            if (!(n < a[d])) break;
            u = d;
          }
          a[l] = a[u], o[l] = o[u], s[l] = s[u], l = u;
        }
        return a[l] = n, o[l] = r, s[l] = i, 1;
      }
      function l(e, t, n, r) {
        for (; 2 * r + 1 < n;) {
          var i = 2 * r + 1,
            o = i + 1,
            a = r;
          if (e[a] < e[i] && (a = i), o < n && e[a] < e[o] && (a = o), a === r) break;
          var s = e[r];
          e[r] = e[a], e[a] = s;
          var l = t[r];
          t[r] = t[a], t[a] = l, r = a;
        }
      }
      t.makeHeap = o, t.rejectionSample = function (e, t, n) {
        for (var r = i.zeros(e), o = 0; o < e; o++) {
          for (var a = !0, s = 0; a;) {
            s = i.tauRandInt(t, n);
            for (var l = !1, u = 0; u < o; u++) if (s === r[u]) {
              l = !0;
              break;
            }
            l || (a = !1);
          }
          r[o] = s;
        }
        return r;
      }, t.heapPush = a, t.uncheckedHeapPush = s, t.buildCandidates = function (e, t, n, r, s) {
        for (var l = o(t, r), u = 0; u < t; u++) for (var c = 0; c < n; c++) if (!(e[0][u][c] < 0)) {
          var d = e[0][u][c],
            h = e[2][u][c],
            f = i.tauRand(s);
          a(l, u, f, d, h), a(l, d, f, u, h), e[2][u][c] = 0;
        }
        return l;
      }, t.deheapSort = function (e) {
        for (var t = e[0], n = e[1], r = 0; r < t.length; r++) for (var i = t[r], o = n[r], a = 0; a < i.length - 1; a++) {
          var s = i.length - a - 1,
            u = o.length - a - 1,
            c = i[0];
          i[0] = i[s], i[s] = c;
          var d = o[0];
          o[0] = o[u], o[u] = d, l(o, i, u, 0);
        }
        return {
          indices: t,
          weights: n
        };
      }, t.smallestFlagged = function (e, t) {
        for (var n = e[0][t], r = e[1][t], i = e[2][t], o = 1 / 0, a = -1, s = 0; s > n.length; s++) 1 === i[s] && r[s] < o && (o = r[s], a = s);
        return a >= 0 ? (i[a] = 0, Math.floor(n[a])) : -1;
      };
    },
    "./node_modules/umap-js/dist/index.js": function node_modulesUmapJsDistIndexJs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/umap-js/dist/umap.js");
      t.UMAP = r.UMAP;
    },
    "./node_modules/umap-js/dist/matrix.js": function node_modulesUmapJsDistMatrixJs(e, t, n) {
      "use strict";

      var r,
        i = this && this.__read || function (e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            i,
            o = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) a.push(r.value);
          } catch (e) {
            i = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = o.return) && n.call(o);
            } finally {
              if (i) throw i.error;
            }
          }
          return a;
        },
        o = this && this.__values || function (e) {
          var t = "function" == typeof Symbol && e[Symbol.iterator],
            n = 0;
          return t ? t.call(e) : {
            next: function next() {
              return e && n >= e.length && (e = void 0), {
                value: e && e[n++],
                done: !e
              };
            }
          };
        },
        a = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t.default = e, t;
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var s = a(n("./node_modules/umap-js/dist/utils.js")),
        l = function () {
          function e(e, t, n, r) {
            if (this.entries = new Map(), this.nRows = 0, this.nCols = 0, e.length !== t.length || e.length !== n.length) throw new Error("rows, cols and values arrays must all have the same length");
            this.nRows = r[0], this.nCols = r[1];
            for (var i = 0; i < n.length; i++) {
              var o = e[i],
                a = t[i];
              this.checkDims(o, a);
              var s = this.makeKey(o, a);
              this.entries.set(s, {
                value: n[i],
                row: o,
                col: a
              });
            }
          }
          return e.prototype.makeKey = function (e, t) {
            return e + ":" + t;
          }, e.prototype.checkDims = function (e, t) {
            if (!(e < this.nRows && t < this.nCols)) throw new Error("row and/or col specified outside of matrix dimensions");
          }, e.prototype.set = function (e, t, n) {
            this.checkDims(e, t);
            var r = this.makeKey(e, t);
            this.entries.has(r) ? this.entries.get(r).value = n : this.entries.set(r, {
              value: n,
              row: e,
              col: t
            });
          }, e.prototype.get = function (e, t, n) {
            void 0 === n && (n = 0), this.checkDims(e, t);
            var r = this.makeKey(e, t);
            return this.entries.has(r) ? this.entries.get(r).value : n;
          }, e.prototype.getAll = function (e) {
            void 0 === e && (e = !0);
            var t = [];
            return this.entries.forEach(function (e) {
              t.push(e);
            }), e && t.sort(function (e, t) {
              return e.row === t.row ? e.col - t.col : e.row - t.row;
            }), t;
          }, e.prototype.getDims = function () {
            return [this.nRows, this.nCols];
          }, e.prototype.getRows = function () {
            return Array.from(this.entries, function (e) {
              var t = i(e, 2);
              t[0];
              return t[1].row;
            });
          }, e.prototype.getCols = function () {
            return Array.from(this.entries, function (e) {
              var t = i(e, 2);
              t[0];
              return t[1].col;
            });
          }, e.prototype.getValues = function () {
            return Array.from(this.entries, function (e) {
              var t = i(e, 2);
              t[0];
              return t[1].value;
            });
          }, e.prototype.forEach = function (e) {
            this.entries.forEach(function (t) {
              return e(t.value, t.row, t.col);
            });
          }, e.prototype.map = function (t) {
            var n = [];
            this.entries.forEach(function (e) {
              n.push(t(e.value, e.row, e.col));
            });
            var r = [this.nRows, this.nCols];
            return new e(this.getRows(), this.getCols(), n, r);
          }, e.prototype.toArray = function () {
            var e = this,
              t = s.empty(this.nRows).map(function () {
                return s.zeros(e.nCols);
              });
            return this.entries.forEach(function (e) {
              t[e.row][e.col] = e.value;
            }), t;
          }, e;
        }();
      t.SparseMatrix = l, t.transpose = function (e) {
        var t = [],
          n = [],
          r = [];
        e.forEach(function (e, i, o) {
          t.push(i), n.push(o), r.push(e);
        });
        var i = [e.nCols, e.nRows];
        return new l(n, t, r, i);
      }, t.identity = function (e) {
        for (var t = i(e, 1)[0], n = new l([], [], [], e), r = 0; r < t; r++) n.set(r, r, 1);
        return n;
      }, t.pairwiseMultiply = function (e, t) {
        return c(e, t, function (e, t) {
          return e * t;
        });
      }, t.add = function (e, t) {
        return c(e, t, function (e, t) {
          return e + t;
        });
      }, t.subtract = function (e, t) {
        return c(e, t, function (e, t) {
          return e - t;
        });
      }, t.maximum = function (e, t) {
        return c(e, t, function (e, t) {
          return e > t ? e : t;
        });
      }, t.multiplyScalar = function (e, t) {
        return e.map(function (e) {
          return e * t;
        });
      }, t.eliminateZeros = function (e) {
        for (var t = new Set(), n = e.getValues(), r = e.getRows(), i = e.getCols(), o = 0; o < n.length; o++) 0 === n[o] && t.add(o);
        var a = function a(e, n) {
            return !t.has(n);
          },
          s = n.filter(a),
          u = r.filter(a),
          c = i.filter(a);
        return new l(u, c, s, e.getDims());
      }, t.normalize = function (e, t) {
        var n, r;
        void 0 === t && (t = "l2");
        var i = u[t],
          a = new Map();
        e.forEach(function (e, t, n) {
          var r = a.get(t) || [];
          r.push(n), a.set(t, r);
        });
        var s = new l([], [], [], e.getDims()),
          c = function c(t) {
            for (var n = a.get(t).sort(), r = n.map(function (n) {
                return e.get(t, n);
              }), o = i(r), l = 0; l < o.length; l++) s.set(t, n[l], o[l]);
          };
        try {
          for (var d = o(a.keys()), h = d.next(); !h.done; h = d.next()) {
            c(h.value);
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            h && !h.done && (r = d.return) && r.call(d);
          } finally {
            if (n) throw n.error;
          }
        }
        return s;
      };
      var u = ((r = {}).max = function (e) {
        for (var t = -1 / 0, n = 0; n < e.length; n++) t = e[n] > t ? e[n] : t;
        return e.map(function (e) {
          return e / t;
        });
      }, r.l1 = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) t += e[n];
        return e.map(function (e) {
          return e / t;
        });
      }, r.l2 = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) t += Math.pow(e[n], 2);
        return e.map(function (e) {
          return Math.sqrt(Math.pow(e, 2) / t);
        });
      }, r);
      function c(e, t, n) {
        for (var r = new Set(), i = [], o = [], a = [], s = function s(r, _s4) {
            i.push(r), o.push(_s4);
            var l = n(e.get(r, _s4), t.get(r, _s4));
            a.push(l);
          }, u = e.getValues(), c = e.getRows(), d = e.getCols(), h = 0; h < u.length; h++) {
          var f = (v = c[h]) + ":" + (y = d[h]);
          r.add(f), s(v, y);
        }
        var p = t.getValues(),
          m = t.getRows(),
          g = t.getCols();
        for (h = 0; h < p.length; h++) {
          var v, y;
          f = (v = m[h]) + ":" + (y = g[h]);
          r.has(f) || s(v, y);
        }
        var b = [e.nRows, e.nCols];
        return new l(i, o, a, b);
      }
      t.getCSR = function (e) {
        var t = [];
        e.forEach(function (e, n, r) {
          t.push({
            value: e,
            row: n,
            col: r
          });
        }), t.sort(function (e, t) {
          return e.row === t.row ? e.col - t.col : e.row - t.row;
        });
        for (var n = [], r = [], i = [], o = -1, a = 0; a < t.length; a++) {
          var s = t[a],
            l = s.row,
            u = s.col,
            c = s.value;
          l !== o && (o = l, i.push(a)), n.push(u), r.push(c);
        }
        return {
          indices: n,
          values: r,
          indptr: i
        };
      };
    },
    "./node_modules/umap-js/dist/nn_descent.js": function node_modulesUmapJsDistNn_descentJs(e, t, n) {
      "use strict";

      var r = this && this.__values || function (e) {
          var t = "function" == typeof Symbol && e[Symbol.iterator],
            n = 0;
          return t ? t.call(e) : {
            next: function next() {
              return e && n >= e.length && (e = void 0), {
                value: e && e[n++],
                done: !e
              };
            }
          };
        },
        i = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t.default = e, t;
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = i(n("./node_modules/umap-js/dist/heap.js")),
        a = i(n("./node_modules/umap-js/dist/matrix.js")),
        s = i(n("./node_modules/umap-js/dist/tree.js")),
        l = i(n("./node_modules/umap-js/dist/utils.js"));
      t.makeNNDescent = function (e, t) {
        return function (n, r, i, a, s, u, c, d) {
          void 0 === a && (a = 10), void 0 === s && (s = 50), void 0 === u && (u = .001), void 0 === c && (c = .5), void 0 === d && (d = !0);
          for (var h = n.length, f = o.makeHeap(n.length, i), p = 0; p < n.length; p++) for (var m = o.rejectionSample(i, n.length, t), g = 0; g < m.length; g++) {
            var v = e(n[p], n[m[g]]);
            o.heapPush(f, p, v, m[g], 1), o.heapPush(f, m[g], v, p, 1);
          }
          if (d) for (var y = 0; y < r.length; y++) for (p = 0; p < r[y].length && !(r[y][p] < 0); p++) for (g = p + 1; g < r[y].length && !(r[y][g] < 0); g++) {
            v = e(n[r[y][p]], n[r[y][g]]);
            o.heapPush(f, r[y][p], v, r[y][g], 1), o.heapPush(f, r[y][g], v, r[y][p], 1);
          }
          for (y = 0; y < a; y++) {
            var b = o.buildCandidates(f, h, i, s, t),
              _ = 0;
            for (p = 0; p < h; p++) for (g = 0; g < s; g++) {
              var x = Math.floor(b[0][p][g]);
              if (!(x < 0 || l.tauRand(t) < c)) for (var w = 0; w < s; w++) {
                var S = Math.floor(b[0][p][w]),
                  A = b[2][p][g],
                  E = b[2][p][w];
                if (!(S < 0 || !A && !E)) {
                  v = e(n[x], n[S]);
                  _ += o.heapPush(f, x, v, S, 1), _ += o.heapPush(f, S, v, x, 1);
                }
              }
            }
            if (_ <= u * i * n.length) break;
          }
          return o.deheapSort(f);
        };
      }, t.makeInitializations = function (e) {
        return {
          initFromRandom: function initFromRandom(t, n, r, i, a) {
            for (var s = 0; s < r.length; s++) for (var u = l.rejectionSample(t, n.length, a), c = 0; c < u.length; c++) if (!(u[c] < 0)) {
              var d = e(n[u[c]], r[s]);
              o.heapPush(i, s, d, u[c], 1);
            }
          },
          initFromTree: function initFromTree(t, n, r, i, a) {
            for (var l = 0; l < r.length; l++) for (var u = s.searchFlatTree(r[l], t, a), c = 0; c < u.length; c++) {
              if (u[c] < 0) return;
              var d = e(n[u[c]], r[l]);
              o.heapPush(i, l, d, u[c], 1);
            }
          }
        };
      }, t.makeInitializedNNSearch = function (e) {
        return function (t, n, i, s) {
          for (var l, u, c = a.getCSR(n), d = c.indices, h = c.indptr, f = 0; f < s.length; f++) for (var p = new Set(i[0][f]);;) {
            var m = o.smallestFlagged(i, f);
            if (-1 === m) break;
            var g = d.slice(h[m], h[m + 1]);
            try {
              for (var v = r(g), y = v.next(); !y.done; y = v.next()) {
                var b = y.value;
                if (b !== m && -1 !== b && !p.has(b)) {
                  var _ = e(t[b], s[f]);
                  o.uncheckedHeapPush(i, f, _, b, 1), p.add(b);
                }
              }
            } catch (e) {
              l = {
                error: e
              };
            } finally {
              try {
                y && !y.done && (u = v.return) && u.call(v);
              } finally {
                if (l) throw l.error;
              }
            }
          }
          return i;
        };
      }, t.initializeSearch = function (e, t, n, i, a, s, l) {
        var u,
          c,
          d = o.makeHeap(n.length, i);
        if (a(i, t, n, d, l), e) try {
          for (var h = r(e), f = h.next(); !f.done; f = h.next()) {
            s(f.value, t, n, d, l);
          }
        } catch (e) {
          u = {
            error: e
          };
        } finally {
          try {
            f && !f.done && (c = h.return) && c.call(h);
          } finally {
            if (u) throw u.error;
          }
        }
        return d;
      };
    },
    "./node_modules/umap-js/dist/tree.js": function node_modulesUmapJsDistTreeJs(e, t, n) {
      "use strict";

      var r = this && this.__read || function (e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            i,
            o = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) a.push(r.value);
          } catch (e) {
            i = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = o.return) && n.call(o);
            } finally {
              if (i) throw i.error;
            }
          }
          return a;
        },
        i = this && this.__spread || function () {
          for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(r(arguments[t]));
          return e;
        },
        o = this && this.__values || function (e) {
          var t = "function" == typeof Symbol && e[Symbol.iterator],
            n = 0;
          return t ? t.call(e) : {
            next: function next() {
              return e && n >= e.length && (e = void 0), {
                value: e && e[n++],
                done: !e
              };
            }
          };
        },
        a = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t.default = e, t;
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var s = a(n("./node_modules/umap-js/dist/utils.js")),
        l = function l(e, t, n, r) {
          this.hyperplanes = e, this.offsets = t, this.children = n, this.indices = r;
        };
      function u(e, t, n, r) {
        for (var i = t, o = 0; o < n.length; o++) i += e[o] * n[o];
        return 0 === i ? s.tauRandInt(2, r) : i > 0 ? 0 : 1;
      }
      t.FlatTree = l, t.makeForest = function (e, t, n, r) {
        var o = Math.max(10, t);
        return s.range(n).map(function (t, n) {
          return function (e, t, n, r) {
            void 0 === t && (t = 30);
            var i = s.range(e.length);
            return function e(t, n, r, i, o) {
              void 0 === r && (r = 30);
              if (n.length > r) {
                var a = function (e, t, n) {
                    var r = e[0].length,
                      i = s.tauRandInt(t.length, n),
                      o = s.tauRandInt(t.length, n);
                    o = (o += i === o ? 1 : 0) % t.length;
                    for (var a = t[i], l = t[o], u = 0, c = s.zeros(r), d = 0; d < c.length; d++) c[d] = e[a][d] - e[l][d], u -= c[d] * (e[a][d] + e[l][d]) / 2;
                    var h = 0,
                      f = 0,
                      p = s.zeros(t.length);
                    for (d = 0; d < t.length; d++) {
                      for (var m = u, g = 0; g < r; g++) m += c[g] * e[t[d]][g];
                      0 === m ? (p[d] = s.tauRandInt(2, n), 0 === p[d] ? h += 1 : f += 1) : m > 0 ? (p[d] = 0, h += 1) : (p[d] = 1, f += 1);
                    }
                    var v = s.zeros(h),
                      y = s.zeros(f);
                    for (var d in h = 0, f = 0, s.range(p.length)) 0 === p[d] ? (v[h] = t[d], h += 1) : (y[f] = t[d], f += 1);
                    return {
                      indicesLeft: v,
                      indicesRight: y,
                      hyperplane: c,
                      offset: u
                    };
                  }(t, n, o),
                  l = a.indicesLeft,
                  u = a.indicesRight,
                  c = a.hyperplane,
                  d = a.offset,
                  h = e(t, l, r, i + 1, o),
                  f = e(t, u, r, i + 1, o);
                return {
                  leftChild: h,
                  rightChild: f,
                  isLeaf: !1,
                  hyperplane: c,
                  offset: d
                };
              }
              return {
                indices: n,
                isLeaf: !0
              };
            }(e, i, t, n, r);
          }(e, o, n, r);
        }).map(function (e) {
          return function (e, t) {
            var n = function e(t) {
                return t.isLeaf ? 1 : 1 + e(t.leftChild) + e(t.rightChild);
              }(e),
              r = function e(t) {
                return t.isLeaf ? 1 : e(t.leftChild) + e(t.rightChild);
              }(e),
              o = s.range(n).map(function () {
                return s.zeros(e.hyperplane ? e.hyperplane.length : 0);
              }),
              a = s.zeros(n),
              u = s.range(n).map(function () {
                return [-1, -1];
              }),
              c = s.range(r).map(function () {
                return s.range(t).map(function () {
                  return -1;
                });
              });
            return function e(t, n, r, o, a, s, l) {
              var u;
              if (t.isLeaf) return o[s][0] = -l, (u = a[l]).splice.apply(u, i([0, t.indices.length], t.indices)), {
                nodeNum: s,
                leafNum: l += 1
              };
              n[s] = t.hyperplane, r[s] = t.offset, o[s][0] = s + 1;
              var c = s,
                d = e(t.leftChild, n, r, o, a, s + 1, l);
              return s = d.nodeNum, l = d.leafNum, o[c][1] = s + 1, {
                nodeNum: (d = e(t.rightChild, n, r, o, a, s + 1, l)).nodeNum,
                leafNum: d.leafNum
              };
            }(e, o, a, u, c, 0, 0), new l(o, a, u, c);
          }(e, o);
        });
      }, t.makeLeafArray = function (e) {
        var t, n;
        if (e.length > 0) {
          var r = [];
          try {
            for (var a = o(e), s = a.next(); !s.done; s = a.next()) {
              var l = s.value;
              r.push.apply(r, i(l.indices));
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
          return r;
        }
        return [[-1]];
      }, t.searchFlatTree = function (e, t, n) {
        for (var r = 0; t.children[r][0] > 0;) {
          r = 0 === u(t.hyperplanes[r], t.offsets[r], e, n) ? t.children[r][0] : t.children[r][1];
        }
        var i = -1 * t.children[r][0];
        return t.indices[i];
      };
    },
    "./node_modules/umap-js/dist/umap.js": function node_modulesUmapJsDistUmapJs(e, t, n) {
      "use strict";

      var r = this && this.__awaiter || function (e, t, n, r) {
          return new (n || (n = Promise))(function (i, o) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                o(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                o(e);
              }
            }
            function l(e) {
              e.done ? i(e.value) : new n(function (t) {
                t(e.value);
              }).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        i = this && this.__generator || function (e, t) {
          var n,
            r,
            i,
            o,
            a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;
          function s(o) {
            return function (s) {
              return function (o) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a;) try {
                  if (n = 1, r && (i = 2 & o[0] ? r.return : o[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, o[1])).done) return i;
                  switch (r = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;
                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = o[1], o = [0];
                      continue;
                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(i = a.trys, (i = i.length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }
                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }
                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }
                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], r = 0;
                } finally {
                  n = i = 0;
                }
                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        },
        o = this && this.__read || function (e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            i,
            o = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = o.next()).done;) a.push(r.value);
          } catch (e) {
            i = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = o.return) && n.call(o);
            } finally {
              if (i) throw i.error;
            }
          }
          return a;
        },
        a = this && this.__spread || function () {
          for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(o(arguments[t]));
          return e;
        },
        s = this && this.__importStar || function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return t.default = e, t;
        },
        l = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var u = s(n("./node_modules/umap-js/dist/heap.js")),
        c = s(n("./node_modules/umap-js/dist/matrix.js")),
        d = s(n("./node_modules/umap-js/dist/nn_descent.js")),
        h = s(n("./node_modules/umap-js/dist/tree.js")),
        f = s(n("./node_modules/umap-js/dist/utils.js")),
        p = l(n("./node_modules/ml-levenberg-marquardt/src/index.js")),
        m = function () {
          function e(e) {
            void 0 === e && (e = {});
            var t = this;
            this.learningRate = 1, this.localConnectivity = 1, this.minDist = .1, this.nComponents = 2, this.nEpochs = 0, this.nNeighbors = 15, this.negativeSampleRate = 5, this.random = Math.random, this.repulsionStrength = 1, this.setOpMixRatio = 1, this.spread = 1, this.transformQueueSize = 4, this.targetMetric = "categorical", this.targetWeight = .5, this.targetNNeighbors = this.nNeighbors, this.distanceFn = g, this.isInitialized = !1, this.rpForest = [], this.embedding = [], this.optimizationState = new v();
            var n = function n(_n19) {
              void 0 !== e[_n19] && (t[_n19] = e[_n19]);
            };
            n("distanceFn"), n("learningRate"), n("localConnectivity"), n("minDist"), n("nComponents"), n("nEpochs"), n("nNeighbors"), n("negativeSampleRate"), n("random"), n("repulsionStrength"), n("setOpMixRatio"), n("spread"), n("transformQueueSize");
          }
          return e.prototype.fit = function (e) {
            return this.initializeFit(e), this.optimizeLayout(), this.embedding;
          }, e.prototype.fitAsync = function (e, t) {
            return void 0 === t && (t = function t() {
              return !0;
            }), r(this, void 0, void 0, function () {
              return i(this, function (n) {
                switch (n.label) {
                  case 0:
                    return this.initializeFit(e), [4, this.optimizeLayoutAsync(t)];
                  case 1:
                    return n.sent(), [2, this.embedding];
                }
              });
            });
          }, e.prototype.setSupervisedProjection = function (e, t) {
            void 0 === t && (t = {}), this.Y = e, this.targetMetric = t.targetMetric || this.targetMetric, this.targetWeight = t.targetWeight || this.targetWeight, this.targetNNeighbors = t.targetNNeighbors || this.targetNNeighbors;
          }, e.prototype.setPrecomputedKNN = function (e, t) {
            this.knnIndices = e, this.knnDistances = t;
          }, e.prototype.initializeFit = function (e) {
            if (e.length <= this.nNeighbors) throw new Error("Not enough data points (" + e.length + ") to create nNeighbors: " + this.nNeighbors + ".  Add more data points or adjust the configuration.");
            if (this.X === e && this.isInitialized) return this.getNEpochs();
            if (this.X = e, !this.knnIndices && !this.knnDistances) {
              var t = this.nearestNeighbors(e);
              this.knnIndices = t.knnIndices, this.knnDistances = t.knnDistances;
            }
            this.graph = this.fuzzySimplicialSet(e, this.nNeighbors, this.setOpMixRatio), this.makeSearchFns(), this.searchGraph = this.makeSearchGraph(e), this.processGraphForSupervisedProjection();
            var n = this.initializeSimplicialSetEmbedding(),
              r = n.head,
              i = n.tail,
              o = n.epochsPerSample;
            return this.optimizationState.head = r, this.optimizationState.tail = i, this.optimizationState.epochsPerSample = o, this.initializeOptimization(), this.prepareForOptimizationLoop(), this.isInitialized = !0, this.getNEpochs();
          }, e.prototype.makeSearchFns = function () {
            var e = d.makeInitializations(this.distanceFn),
              t = e.initFromTree,
              n = e.initFromRandom;
            this.initFromTree = t, this.initFromRandom = n, this.search = d.makeInitializedNNSearch(this.distanceFn);
          }, e.prototype.makeSearchGraph = function (e) {
            for (var t = this.knnIndices, n = this.knnDistances, r = [e.length, e.length], i = new c.SparseMatrix([], [], [], r), o = 0; o < t.length; o++) for (var a = t[o], s = n[o], l = 0; l < a.length; l++) {
              var u = a[l],
                d = s[l];
              d > 0 && i.set(o, u, d);
            }
            var h = c.transpose(i);
            return c.maximum(i, h);
          }, e.prototype.transform = function (e) {
            var t = this,
              n = this.X;
            if (void 0 === n || 0 === n.length) throw new Error("No data has been fit.");
            var r = Math.floor(this.nNeighbors * this.transformQueueSize);
            r = Math.min(n.length, r);
            var i = d.initializeSearch(this.rpForest, n, e, r, this.initFromRandom, this.initFromTree, this.random),
              o = this.search(n, this.searchGraph, i, e),
              a = u.deheapSort(o),
              s = a.indices,
              l = a.weights;
            s = s.map(function (e) {
              return e.slice(0, t.nNeighbors);
            }), l = l.map(function (e) {
              return e.slice(0, t.nNeighbors);
            });
            var h = Math.max(0, this.localConnectivity - 1),
              p = this.smoothKNNDistance(l, this.nNeighbors, h),
              m = p.sigmas,
              g = p.rhos,
              v = this.computeMembershipStrengths(s, l, m, g),
              y = v.rows,
              b = v.cols,
              _ = v.vals,
              x = [e.length, n.length],
              w = new c.SparseMatrix(y, b, _, x),
              A = c.normalize(w, "l1"),
              E = c.getCSR(A),
              T = e.length,
              M = S(f.reshape2d(E.indices, T, this.nNeighbors), f.reshape2d(E.values, T, this.nNeighbors), this.embedding),
              C = this.nEpochs ? this.nEpochs / 3 : w.nRows <= 1e4 ? 100 : 30,
              k = w.getValues().reduce(function (e, t) {
                return t > e ? t : e;
              }, 0);
            w = w.map(function (e) {
              return e < k / C ? 0 : e;
            }), w = c.eliminateZeros(w);
            var P = this.makeEpochsPerSample(w.getValues(), C),
              O = w.getRows(),
              R = w.getCols();
            return this.assignOptimizationStateParameters({
              headEmbedding: M,
              tailEmbedding: this.embedding,
              head: O,
              tail: R,
              currentEpoch: 0,
              nEpochs: C,
              nVertices: w.getDims()[1],
              epochsPerSample: P
            }), this.prepareForOptimizationLoop(), this.optimizeLayout();
          }, e.prototype.processGraphForSupervisedProjection = function () {
            var e = this.Y,
              t = this.X;
            if (e) {
              if (e.length !== t.length) throw new Error("Length of X and y must be equal");
              if ("categorical" === this.targetMetric) {
                var n = this.targetWeight < 1 ? 1 / (1 - this.targetWeight) * 2.5 : 1e12;
                this.graph = this.categoricalSimplicialSetIntersection(this.graph, e, n);
              }
            }
          }, e.prototype.step = function () {
            var e = this.optimizationState.currentEpoch;
            return e < this.getNEpochs() && this.optimizeLayoutStep(e), this.optimizationState.currentEpoch;
          }, e.prototype.getEmbedding = function () {
            return this.embedding;
          }, e.prototype.nearestNeighbors = function (e) {
            var t,
              n = this.distanceFn,
              r = this.nNeighbors,
              i = d.makeNNDescent(n, this.random),
              o = 5 + Math.floor(.5 === (t = Math.pow(e.length, .5) / 20) ? 0 : Math.round(t)),
              a = Math.max(5, Math.floor(Math.round(function (e) {
                return Math.log(e) / Math.log(2);
              }(e.length))));
            this.rpForest = h.makeForest(e, r, o, this.random);
            var s = i(e, h.makeLeafArray(this.rpForest), r, a);
            return {
              knnIndices: s.indices,
              knnDistances: s.weights
            };
          }, e.prototype.fuzzySimplicialSet = function (e, t, n) {
            void 0 === n && (n = 1);
            var r = this.knnIndices,
              i = void 0 === r ? [] : r,
              o = this.knnDistances,
              a = void 0 === o ? [] : o,
              s = this.localConnectivity,
              l = this.smoothKNNDistance(a, t, s),
              u = l.sigmas,
              d = l.rhos,
              h = this.computeMembershipStrengths(i, a, u, d),
              f = h.rows,
              p = h.cols,
              m = h.vals,
              g = [e.length, e.length],
              v = new c.SparseMatrix(f, p, m, g),
              y = c.transpose(v),
              b = c.pairwiseMultiply(v, y),
              _ = c.subtract(c.add(v, y), b),
              x = c.multiplyScalar(_, n),
              w = c.multiplyScalar(b, 1 - n);
            return c.add(x, w);
          }, e.prototype.categoricalSimplicialSetIntersection = function (e, t, n, r) {
            void 0 === r && (r = 1);
            var i = x(e, t, r, n);
            return w(i = c.eliminateZeros(i));
          }, e.prototype.smoothKNNDistance = function (e, t, n, r, i) {
            void 0 === n && (n = 1), void 0 === r && (r = 64), void 0 === i && (i = 1);
            for (var o = Math.log(t) / Math.log(2) * i, a = f.zeros(e.length), s = f.zeros(e.length), l = 0; l < e.length; l++) {
              var u = 0,
                c = 1 / 0,
                d = 1,
                h = e[l],
                p = h.filter(function (e) {
                  return e > 0;
                });
              if (p.length >= n) {
                var m = Math.floor(n),
                  g = n - m;
                m > 0 ? (a[l] = p[m - 1], g > 1e-5 && (a[l] += g * (p[m] - p[m - 1]))) : a[l] = g * p[0];
              } else p.length > 0 && (a[l] = f.max(p));
              for (var v = 0; v < r; v++) {
                for (var y = 0, b = 1; b < e[l].length; b++) {
                  var _ = e[l][b] - a[l];
                  y += _ > 0 ? Math.exp(-_ / d) : 1;
                }
                if (Math.abs(y - o) < 1e-5) break;
                y > o ? d = (u + (c = d)) / 2 : (u = d, c === 1 / 0 ? d *= 2 : d = (u + c) / 2);
              }
              if (s[l] = d, a[l] > 0) {
                var x = f.mean(h);
                s[l] < .001 * x && (s[l] = .001 * x);
              } else {
                var w = f.mean(e.map(f.mean));
                s[l] < .001 * w && (s[l] = .001 * w);
              }
            }
            return {
              sigmas: s,
              rhos: a
            };
          }, e.prototype.computeMembershipStrengths = function (e, t, n, r) {
            for (var i = e.length, o = e[0].length, a = f.zeros(i * o), s = f.zeros(i * o), l = f.zeros(i * o), u = 0; u < i; u++) for (var c = 0; c < o; c++) {
              var d = 0;
              -1 !== e[u][c] && (d = e[u][c] === u ? 0 : t[u][c] - r[u] <= 0 ? 1 : Math.exp(-(t[u][c] - r[u]) / n[u]), a[u * o + c] = u, s[u * o + c] = e[u][c], l[u * o + c] = d);
            }
            return {
              rows: a,
              cols: s,
              vals: l
            };
          }, e.prototype.initializeSimplicialSetEmbedding = function () {
            for (var e = this, t = this.getNEpochs(), n = this.nComponents, r = this.graph.getValues(), i = 0, o = 0; o < r.length; o++) {
              var a = r[o];
              i < r[o] && (i = a);
            }
            var s = this.graph.map(function (e) {
              return e < i / t ? 0 : e;
            });
            this.embedding = f.zeros(s.nRows).map(function () {
              return f.zeros(n).map(function () {
                return 20 * f.tauRand(e.random) - 10;
              });
            });
            var l = [],
              u = [],
              c = [],
              d = s.getAll();
            for (o = 0; o < d.length; o++) {
              var h = d[o];
              h.value && (l.push(h.value), c.push(h.row), u.push(h.col));
            }
            return {
              head: u,
              tail: c,
              epochsPerSample: this.makeEpochsPerSample(l, t)
            };
          }, e.prototype.makeEpochsPerSample = function (e, t) {
            var n = f.filled(e.length, -1),
              r = f.max(e),
              i = e.map(function (e) {
                return e / r * t;
              });
            return i.forEach(function (e, r) {
              e > 0 && (n[r] = t / i[r]);
            }), n;
          }, e.prototype.assignOptimizationStateParameters = function (e) {
            Object.assign(this.optimizationState, e);
          }, e.prototype.prepareForOptimizationLoop = function () {
            var e = this.repulsionStrength,
              t = this.learningRate,
              n = this.negativeSampleRate,
              r = this.optimizationState,
              i = r.epochsPerSample,
              o = r.headEmbedding,
              s = r.tailEmbedding,
              l = o[0].length,
              u = o.length === s.length,
              c = i.map(function (e) {
                return e / n;
              }),
              d = a(c),
              h = a(i);
            this.assignOptimizationStateParameters({
              epochOfNextSample: h,
              epochOfNextNegativeSample: d,
              epochsPerNegativeSample: c,
              moveOther: u,
              initialAlpha: t,
              alpha: t,
              gamma: e,
              dim: l
            });
          }, e.prototype.initializeOptimization = function () {
            var e = this.embedding,
              t = this.embedding,
              n = this.optimizationState,
              r = n.head,
              i = n.tail,
              o = n.epochsPerSample,
              a = this.getNEpochs(),
              s = this.graph.nCols,
              l = _(this.spread, this.minDist),
              u = l.a,
              c = l.b;
            this.assignOptimizationStateParameters({
              headEmbedding: e,
              tailEmbedding: t,
              head: r,
              tail: i,
              epochsPerSample: o,
              a: u,
              b: c,
              nEpochs: a,
              nVertices: s
            });
          }, e.prototype.optimizeLayoutStep = function (e) {
            for (var t = this.optimizationState, n = t.head, r = t.tail, i = t.headEmbedding, o = t.tailEmbedding, a = t.epochsPerSample, s = t.epochOfNextSample, l = t.epochOfNextNegativeSample, u = t.epochsPerNegativeSample, c = t.moveOther, d = t.initialAlpha, h = t.alpha, p = t.gamma, m = t.a, g = t.b, v = t.dim, _ = t.nEpochs, x = t.nVertices, w = 0; w < a.length; w++) if (!(s[w] > e)) {
              var S = n[w],
                A = r[w],
                E = i[S],
                T = o[A],
                M = b(E, T),
                C = 0;
              M > 0 && (C = -2 * m * g * Math.pow(M, g - 1), C /= m * Math.pow(M, g) + 1);
              for (var k = 0; k < v; k++) {
                var P = y(C * (E[k] - T[k]), 4);
                E[k] += P * h, c && (T[k] += -P * h);
              }
              s[w] += a[w];
              for (var O = Math.floor((e - l[w]) / u[w]), R = 0; R < O; R++) {
                var I = f.tauRandInt(x, this.random),
                  j = o[I],
                  N = b(E, j),
                  L = 0;
                if (N > 0) L = 2 * p * g, L /= (.001 + N) * (m * Math.pow(N, g) + 1);else if (S === I) continue;
                for (k = 0; k < v; k++) {
                  P = 4;
                  L > 0 && (P = y(L * (E[k] - j[k]), 4)), E[k] += P * h;
                }
              }
              l[w] += O * u[w];
            }
            return t.alpha = d * (1 - e / _), t.currentEpoch += 1, i;
          }, e.prototype.optimizeLayoutAsync = function (e) {
            var t = this;
            return void 0 === e && (e = function e() {
              return !0;
            }), new Promise(function (n, o) {
              var a = function a() {
                return r(t, void 0, void 0, function () {
                  var t, r, s, l, u, c;
                  return i(this, function (i) {
                    try {
                      if (t = this.optimizationState, r = t.nEpochs, s = t.currentEpoch, this.embedding = this.optimizeLayoutStep(s), l = this.optimizationState.currentEpoch, u = !1 === e(l), c = l === r, u || c) return [2, n(c)];
                      setTimeout(function () {
                        return a();
                      }, 0);
                    } catch (e) {
                      o(e);
                    }
                    return [2];
                  });
                });
              };
              setTimeout(function () {
                return a();
              }, 0);
            });
          }, e.prototype.optimizeLayout = function (e) {
            void 0 === e && (e = function e() {
              return !0;
            });
            for (var t = !1, n = []; !t;) {
              var r = this.optimizationState,
                i = r.nEpochs,
                o = r.currentEpoch;
              n = this.optimizeLayoutStep(o);
              var a = this.optimizationState.currentEpoch,
                s = !1 === e(a);
              t = a === i || s;
            }
            return n;
          }, e.prototype.getNEpochs = function () {
            var e = this.graph;
            if (this.nEpochs > 0) return this.nEpochs;
            var t = e.nRows;
            return t <= 2500 ? 500 : t <= 5e3 ? 400 : t <= 7500 ? 300 : 200;
          }, e;
        }();
      function g(e, t) {
        for (var n = 0, r = 0; r < e.length; r++) n += Math.pow(e[r] - t[r], 2);
        return Math.sqrt(n);
      }
      t.UMAP = m, t.euclidean = g, t.cosine = function (e, t) {
        for (var n = 0, r = 0, i = 0, o = 0; o < e.length; o++) n += e[o] * t[o], r += Math.pow(e[o], 2), i += Math.pow(t[o], 2);
        return 0 === r && 0 === i ? 0 : 0 === r || 0 === i ? 1 : 1 - n / Math.sqrt(r * i);
      };
      var v = function v() {
        this.currentEpoch = 0, this.headEmbedding = [], this.tailEmbedding = [], this.head = [], this.tail = [], this.epochsPerSample = [], this.epochOfNextSample = [], this.epochOfNextNegativeSample = [], this.epochsPerNegativeSample = [], this.moveOther = !0, this.initialAlpha = 1, this.alpha = 1, this.gamma = 1, this.a = 1.5769434603113077, this.b = .8950608779109733, this.dim = 2, this.nEpochs = 500, this.nVertices = 0;
      };
      function y(e, t) {
        return e > t ? t : e < -t ? -t : e;
      }
      function b(e, t) {
        for (var n = 0, r = 0; r < e.length; r++) n += Math.pow(e[r] - t[r], 2);
        return n;
      }
      function _(e, t) {
        var n = f.linear(0, 3 * e, 300).map(function (e) {
            return e < t ? 1 : e;
          }),
          r = f.zeros(n.length).map(function (r, i) {
            return n[i] >= t ? Math.exp(-(n[i] - t) / e) : r;
          }),
          i = {
            x: n,
            y: r
          },
          a = {
            damping: 1.5,
            initialValues: [.5, .5],
            gradientDifference: .1,
            maxIterations: 100,
            errorTolerance: .01
          },
          s = p.default(i, function (e) {
            var t = o(e, 2),
              n = t[0],
              r = t[1];
            return function (e) {
              return 1 / (1 + n * Math.pow(e, 2 * r));
            };
          }, a).parameterValues,
          l = o(s, 2);
        return {
          a: l[0],
          b: l[1]
        };
      }
      function x(e, t, n, r) {
        return void 0 === n && (n = 1), void 0 === r && (r = 5), e.map(function (e, i, o) {
          return -1 === t[i] || -1 === t[o] ? e * Math.exp(-n) : t[i] !== t[o] ? e * Math.exp(-r) : e;
        });
      }
      function w(e) {
        e = c.normalize(e, "max");
        var t = c.transpose(e),
          n = c.pairwiseMultiply(t, e);
        return e = c.add(e, c.subtract(t, n)), c.eliminateZeros(e);
      }
      function S(e, t, n) {
        for (var r = f.zeros(e.length).map(function (e) {
            return f.zeros(n[0].length);
          }), i = 0; i < e.length; i++) for (var o = 0; o < e[0].length; o++) for (var a = 0; a < n[0].length; a++) {
          var s = e[i][o];
          r[i][a] += t[i][o] * n[s][a];
        }
        return r;
      }
      t.findABParams = _, t.fastIntersection = x, t.resetLocalConnectivity = w, t.initTransform = S;
    },
    "./node_modules/umap-js/dist/utils.js": function node_modulesUmapJsDistUtilsJs(e, t, n) {
      "use strict";

      var r = this && this.__values || function (e) {
        var t = "function" == typeof Symbol && e[Symbol.iterator],
          n = 0;
        return t ? t.call(e) : {
          next: function next() {
            return e && n >= e.length && (e = void 0), {
              value: e && e[n++],
              done: !e
            };
          }
        };
      };
      function i(e, t) {
        return Math.floor(t() * e);
      }
      function o(e) {
        for (var t = [], n = 0; n < e; n++) t.push(void 0);
        return t;
      }
      function a(e, t) {
        return o(e).map(function () {
          return t;
        });
      }
      function s(e) {
        return a(e, 0);
      }
      function l(e) {
        return e.reduce(function (e, t) {
          return e + t;
        });
      }
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.tauRandInt = i, t.tauRand = function (e) {
        return e();
      }, t.norm = function (e) {
        var t,
          n,
          i = 0;
        try {
          for (var o = r(e), a = o.next(); !a.done; a = o.next()) {
            var s = a.value;
            i += Math.pow(s, 2);
          }
        } catch (e) {
          t = {
            error: e
          };
        } finally {
          try {
            a && !a.done && (n = o.return) && n.call(o);
          } finally {
            if (t) throw t.error;
          }
        }
        return Math.sqrt(i);
      }, t.empty = o, t.range = function (e) {
        return o(e).map(function (e, t) {
          return t;
        });
      }, t.filled = a, t.zeros = s, t.ones = function (e) {
        return a(e, 1);
      }, t.linear = function (e, t, n) {
        return o(n).map(function (r, i) {
          return e + i * ((t - e) / (n - 1));
        });
      }, t.sum = l, t.mean = function (e) {
        return l(e) / e.length;
      }, t.max = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) t = e[n] > t ? e[n] : t;
        return t;
      }, t.max2d = function (e) {
        for (var t = 0, n = 0; n < e.length; n++) for (var r = 0; r < e[n].length; r++) t = e[n][r] > t ? e[n][r] : t;
        return t;
      }, t.rejectionSample = function (e, t, n) {
        for (var r = s(e), o = 0; o < e; o++) for (var a = !0; a;) {
          for (var l = i(t, n), u = !1, c = 0; c < o; c++) if (l === r[c]) {
            u = !0;
            break;
          }
          u || (a = !1), r[o] = l;
        }
        return r;
      }, t.reshape2d = function (e, t, n) {
        var r = [],
          i = 0;
        if (e.length !== t * n) throw new Error("Array dimensions must match input length.");
        for (var o = 0; o < t; o++) {
          for (var a = [], s = 0; s < n; s++) a.push(e[i]), i += 1;
          r.push(a), 1;
        }
        return r;
      };
    },
    "./node_modules/urijs/src/IPv6.js": function node_modulesUrijsSrcIPv6Js(e, t, n) {
      var r, i;
      /*!
       * URI.js - Mutating URLs
       * IPv6 Support
       *
       * Version: 1.19.1
       *
       * Author: Rodney Rehm
       * Web: http://medialize.github.io/URI.js/
       *
       * Licensed under
       *   MIT License http://www.opensource.org/licenses/mit-license
       *
       */
      !function (o, a) {
        "use strict";

        e.exports ? e.exports = a() : void 0 === (i = "function" == typeof (r = a) ? r.call(t, n, t, e) : r) || (e.exports = i);
      }(0, function (e) {
        "use strict";

        var t = e && e.IPv6;
        return {
          best: function best(e) {
            var t,
              n,
              r = e.toLowerCase().split(":"),
              i = r.length,
              o = 8;
            for ("" === r[0] && "" === r[1] && "" === r[2] ? (r.shift(), r.shift()) : "" === r[0] && "" === r[1] ? r.shift() : "" === r[i - 1] && "" === r[i - 2] && r.pop(), -1 !== r[(i = r.length) - 1].indexOf(".") && (o = 7), t = 0; t < i && "" !== r[t]; t++);
            if (t < o) for (r.splice(t, 1, "0000"); r.length < o;) r.splice(t, 0, "0000");
            for (var a = 0; a < o; a++) {
              n = r[a].split("");
              for (var s = 0; s < 3 && "0" === n[0] && n.length > 1; s++) n.splice(0, 1);
              r[a] = n.join("");
            }
            var l = -1,
              u = 0,
              c = 0,
              d = -1,
              h = !1;
            for (a = 0; a < o; a++) h ? "0" === r[a] ? c += 1 : (h = !1, c > u && (l = d, u = c)) : "0" === r[a] && (h = !0, d = a, c = 1);
            c > u && (l = d, u = c), u > 1 && r.splice(l, u, ""), i = r.length;
            var f = "";
            for ("" === r[0] && (f = ":"), a = 0; a < i && (f += r[a], a !== i - 1); a++) f += ":";
            return "" === r[i - 1] && (f += ":"), f;
          },
          noConflict: function noConflict() {
            return e.IPv6 === this && (e.IPv6 = t), this;
          }
        };
      });
    },
    "./node_modules/urijs/src/SecondLevelDomains.js": function node_modulesUrijsSrcSecondLevelDomainsJs(e, t, n) {
      var r, i;
      /*!
       * URI.js - Mutating URLs
       * Second Level Domain (SLD) Support
       *
       * Version: 1.19.1
       *
       * Author: Rodney Rehm
       * Web: http://medialize.github.io/URI.js/
       *
       * Licensed under
       *   MIT License http://www.opensource.org/licenses/mit-license
       *
       */
      !function (o, a) {
        "use strict";

        e.exports ? e.exports = a() : void 0 === (i = "function" == typeof (r = a) ? r.call(t, n, t, e) : r) || (e.exports = i);
      }(0, function (e) {
        "use strict";

        var t = e && e.SecondLevelDomains,
          n = {
            list: {
              ac: " com gov mil net org ",
              ae: " ac co gov mil name net org pro sch ",
              af: " com edu gov net org ",
              al: " com edu gov mil net org ",
              ao: " co ed gv it og pb ",
              ar: " com edu gob gov int mil net org tur ",
              at: " ac co gv or ",
              au: " asn com csiro edu gov id net org ",
              ba: " co com edu gov mil net org rs unbi unmo unsa untz unze ",
              bb: " biz co com edu gov info net org store tv ",
              bh: " biz cc com edu gov info net org ",
              bn: " com edu gov net org ",
              bo: " com edu gob gov int mil net org tv ",
              br: " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
              bs: " com edu gov net org ",
              bz: " du et om ov rg ",
              ca: " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
              ck: " biz co edu gen gov info net org ",
              cn: " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
              co: " com edu gov mil net nom org ",
              cr: " ac c co ed fi go or sa ",
              cy: " ac biz com ekloges gov ltd name net org parliament press pro tm ",
              do: " art com edu gob gov mil net org sld web ",
              dz: " art asso com edu gov net org pol ",
              ec: " com edu fin gov info med mil net org pro ",
              eg: " com edu eun gov mil name net org sci ",
              er: " com edu gov ind mil net org rochest w ",
              es: " com edu gob nom org ",
              et: " biz com edu gov info name net org ",
              fj: " ac biz com info mil name net org pro ",
              fk: " ac co gov net nom org ",
              fr: " asso com f gouv nom prd presse tm ",
              gg: " co net org ",
              gh: " com edu gov mil org ",
              gn: " ac com gov net org ",
              gr: " com edu gov mil net org ",
              gt: " com edu gob ind mil net org ",
              gu: " com edu gov net org ",
              hk: " com edu gov idv net org ",
              hu: " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
              id: " ac co go mil net or sch web ",
              il: " ac co gov idf k12 muni net org ",
              in: " ac co edu ernet firm gen gov i ind mil net nic org res ",
              iq: " com edu gov i mil net org ",
              ir: " ac co dnssec gov i id net org sch ",
              it: " edu gov ",
              je: " co net org ",
              jo: " com edu gov mil name net org sch ",
              jp: " ac ad co ed go gr lg ne or ",
              ke: " ac co go info me mobi ne or sc ",
              kh: " com edu gov mil net org per ",
              ki: " biz com de edu gov info mob net org tel ",
              km: " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
              kn: " edu gov net org ",
              kr: " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
              kw: " com edu gov net org ",
              ky: " com edu gov net org ",
              kz: " com edu gov mil net org ",
              lb: " com edu gov net org ",
              lk: " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
              lr: " com edu gov net org ",
              lv: " asn com conf edu gov id mil net org ",
              ly: " com edu gov id med net org plc sch ",
              ma: " ac co gov m net org press ",
              mc: " asso tm ",
              me: " ac co edu gov its net org priv ",
              mg: " com edu gov mil nom org prd tm ",
              mk: " com edu gov inf name net org pro ",
              ml: " com edu gov net org presse ",
              mn: " edu gov org ",
              mo: " com edu gov net org ",
              mt: " com edu gov net org ",
              mv: " aero biz com coop edu gov info int mil museum name net org pro ",
              mw: " ac co com coop edu gov int museum net org ",
              mx: " com edu gob net org ",
              my: " com edu gov mil name net org sch ",
              nf: " arts com firm info net other per rec store web ",
              ng: " biz com edu gov mil mobi name net org sch ",
              ni: " ac co com edu gob mil net nom org ",
              np: " com edu gov mil net org ",
              nr: " biz com edu gov info net org ",
              om: " ac biz co com edu gov med mil museum net org pro sch ",
              pe: " com edu gob mil net nom org sld ",
              ph: " com edu gov i mil net ngo org ",
              pk: " biz com edu fam gob gok gon gop gos gov net org web ",
              pl: " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
              pr: " ac biz com edu est gov info isla name net org pro prof ",
              ps: " com edu gov net org plo sec ",
              pw: " belau co ed go ne or ",
              ro: " arts com firm info nom nt org rec store tm www ",
              rs: " ac co edu gov in org ",
              sb: " com edu gov net org ",
              sc: " com edu gov net org ",
              sh: " co com edu gov net nom org ",
              sl: " com edu gov net org ",
              st: " co com consulado edu embaixada gov mil net org principe saotome store ",
              sv: " com edu gob org red ",
              sz: " ac co org ",
              tr: " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
              tt: " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
              tw: " club com ebiz edu game gov idv mil net org ",
              mu: " ac co com gov net or org ",
              mz: " ac co edu gov org ",
              na: " co com ",
              nz: " ac co cri geek gen govt health iwi maori mil net org parliament school ",
              pa: " abo ac com edu gob ing med net nom org sld ",
              pt: " com edu gov int net nome org publ ",
              py: " com edu gov mil net org ",
              qa: " com edu gov mil net org ",
              re: " asso com nom ",
              ru: " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
              rw: " ac co com edu gouv gov int mil net ",
              sa: " com edu gov med net org pub sch ",
              sd: " com edu gov info med net org tv ",
              se: " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
              sg: " com edu gov idn net org per ",
              sn: " art com edu gouv org perso univ ",
              sy: " com edu gov mil net news org ",
              th: " ac co go in mi net or ",
              tj: " ac biz co com edu go gov info int mil name net nic org test web ",
              tn: " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
              tz: " ac co go ne or ",
              ua: " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
              ug: " ac co go ne or org sc ",
              uk: " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
              us: " dni fed isa kids nsn ",
              uy: " com edu gub mil net org ",
              ve: " co com edu gob info mil net org web ",
              vi: " co com k12 net org ",
              vn: " ac biz com edu gov health info int name net org pro ",
              ye: " co com gov ltd me net org plc ",
              yu: " ac co edu gov org ",
              za: " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
              zm: " ac co com edu gov net org sch ",
              com: "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
              net: "gb jp se uk ",
              org: "ae",
              de: "com "
            },
            has: function has(e) {
              var t = e.lastIndexOf(".");
              if (t <= 0 || t >= e.length - 1) return !1;
              var r = e.lastIndexOf(".", t - 1);
              if (r <= 0 || r >= t - 1) return !1;
              var i = n.list[e.slice(t + 1)];
              return !!i && i.indexOf(" " + e.slice(r + 1, t) + " ") >= 0;
            },
            is: function is(e) {
              var t = e.lastIndexOf(".");
              if (t <= 0 || t >= e.length - 1) return !1;
              if (e.lastIndexOf(".", t - 1) >= 0) return !1;
              var r = n.list[e.slice(t + 1)];
              return !!r && r.indexOf(" " + e.slice(0, t) + " ") >= 0;
            },
            get: function get(e) {
              var t = e.lastIndexOf(".");
              if (t <= 0 || t >= e.length - 1) return null;
              var r = e.lastIndexOf(".", t - 1);
              if (r <= 0 || r >= t - 1) return null;
              var i = n.list[e.slice(t + 1)];
              return i ? i.indexOf(" " + e.slice(r + 1, t) + " ") < 0 ? null : e.slice(r + 1) : null;
            },
            noConflict: function noConflict() {
              return e.SecondLevelDomains === this && (e.SecondLevelDomains = t), this;
            }
          };
        return n;
      });
    },
    "./node_modules/urijs/src/URI.js": function node_modulesUrijsSrcURIJs(e, t, n) {
      var r, i, o;
      /*!
       * URI.js - Mutating URLs
       *
       * Version: 1.19.1
       *
       * Author: Rodney Rehm
       * Web: http://medialize.github.io/URI.js/
       *
       * Licensed under
       *   MIT License http://www.opensource.org/licenses/mit-license
       *
       */
      !function (a, s) {
        "use strict";

        e.exports ? e.exports = s(n("./node_modules/urijs/src/punycode.js"), n("./node_modules/urijs/src/IPv6.js"), n("./node_modules/urijs/src/SecondLevelDomains.js")) : (i = [n("./node_modules/urijs/src/punycode.js"), n("./node_modules/urijs/src/IPv6.js"), n("./node_modules/urijs/src/SecondLevelDomains.js")], void 0 === (o = "function" == typeof (r = s) ? r.apply(t, i) : r) || (e.exports = o));
      }(0, function (e, t, n, r) {
        "use strict";

        var i = r && r.URI;
        function o(e, t) {
          var n = arguments.length >= 1,
            r = arguments.length >= 2;
          if (!(this instanceof o)) return n ? r ? new o(e, t) : new o(e) : new o();
          if (void 0 === e) {
            if (n) throw new TypeError("undefined is not a valid argument for URI");
            e = "undefined" != typeof location ? location.href + "" : "";
          }
          if (null === e && n) throw new TypeError("null is not a valid argument for URI");
          return this.href(e), void 0 !== t ? this.absoluteTo(t) : this;
        }
        o.version = "1.19.1";
        var a = o.prototype,
          s = Object.prototype.hasOwnProperty;
        function l(e) {
          return e.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        function u(e) {
          return void 0 === e ? "Undefined" : String(Object.prototype.toString.call(e)).slice(8, -1);
        }
        function c(e) {
          return "Array" === u(e);
        }
        function d(e, t) {
          var n,
            r,
            i = {};
          if ("RegExp" === u(t)) i = null;else if (c(t)) for (n = 0, r = t.length; n < r; n++) i[t[n]] = !0;else i[t] = !0;
          for (n = 0, r = e.length; n < r; n++) {
            (i && void 0 !== i[e[n]] || !i && t.test(e[n])) && (e.splice(n, 1), r--, n--);
          }
          return e;
        }
        function h(e, t) {
          var n, r;
          if (c(t)) {
            for (n = 0, r = t.length; n < r; n++) if (!h(e, t[n])) return !1;
            return !0;
          }
          var i = u(t);
          for (n = 0, r = e.length; n < r; n++) if ("RegExp" === i) {
            if ("string" == typeof e[n] && e[n].match(t)) return !0;
          } else if (e[n] === t) return !0;
          return !1;
        }
        function f(e, t) {
          if (!c(e) || !c(t)) return !1;
          if (e.length !== t.length) return !1;
          e.sort(), t.sort();
          for (var n = 0, r = e.length; n < r; n++) if (e[n] !== t[n]) return !1;
          return !0;
        }
        function p(e) {
          return e.replace(/^\/+|\/+$/g, "");
        }
        function m(e) {
          return escape(e);
        }
        function g(e) {
          return encodeURIComponent(e).replace(/[!'()*]/g, m).replace(/\*/g, "%2A");
        }
        o._parts = function () {
          return {
            protocol: null,
            username: null,
            password: null,
            hostname: null,
            urn: null,
            port: null,
            path: null,
            query: null,
            fragment: null,
            preventInvalidHostname: o.preventInvalidHostname,
            duplicateQueryParameters: o.duplicateQueryParameters,
            escapeQuerySpace: o.escapeQuerySpace
          };
        }, o.preventInvalidHostname = !1, o.duplicateQueryParameters = !1, o.escapeQuerySpace = !0, o.protocol_expression = /^[a-z][a-z0-9.+-]*$/i, o.idn_expression = /[^a-z0-9\._-]/i, o.punycode_expression = /(xn--)/i, o.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, o.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/, o.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi, o.findUri = {
          start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
          end: /[\s\r\n]|$/,
          trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
          parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
        }, o.defaultPorts = {
          http: "80",
          https: "443",
          ftp: "21",
          gopher: "70",
          ws: "80",
          wss: "443"
        }, o.hostProtocols = ["http", "https"], o.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/, o.domAttributes = {
          a: "href",
          blockquote: "cite",
          link: "href",
          base: "href",
          script: "src",
          form: "action",
          img: "src",
          area: "href",
          iframe: "src",
          embed: "src",
          source: "src",
          track: "src",
          input: "src",
          audio: "src",
          video: "src"
        }, o.getDomAttribute = function (e) {
          if (e && e.nodeName) {
            var t = e.nodeName.toLowerCase();
            if ("input" !== t || "image" === e.type) return o.domAttributes[t];
          }
        }, o.encode = g, o.decode = decodeURIComponent, o.iso8859 = function () {
          o.encode = escape, o.decode = unescape;
        }, o.unicode = function () {
          o.encode = g, o.decode = decodeURIComponent;
        }, o.characters = {
          pathname: {
            encode: {
              expression: /%(24|26|2B|2C|3B|3D|3A|40)/gi,
              map: {
                "%24": "$",
                "%26": "&",
                "%2B": "+",
                "%2C": ",",
                "%3B": ";",
                "%3D": "=",
                "%3A": ":",
                "%40": "@"
              }
            },
            decode: {
              expression: /[\/\?#]/g,
              map: {
                "/": "%2F",
                "?": "%3F",
                "#": "%23"
              }
            }
          },
          reserved: {
            encode: {
              expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/gi,
              map: {
                "%3A": ":",
                "%2F": "/",
                "%3F": "?",
                "%23": "#",
                "%5B": "[",
                "%5D": "]",
                "%40": "@",
                "%21": "!",
                "%24": "$",
                "%26": "&",
                "%27": "'",
                "%28": "(",
                "%29": ")",
                "%2A": "*",
                "%2B": "+",
                "%2C": ",",
                "%3B": ";",
                "%3D": "="
              }
            }
          },
          urnpath: {
            encode: {
              expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/gi,
              map: {
                "%21": "!",
                "%24": "$",
                "%27": "'",
                "%28": "(",
                "%29": ")",
                "%2A": "*",
                "%2B": "+",
                "%2C": ",",
                "%3B": ";",
                "%3D": "=",
                "%40": "@"
              }
            },
            decode: {
              expression: /[\/\?#:]/g,
              map: {
                "/": "%2F",
                "?": "%3F",
                "#": "%23",
                ":": "%3A"
              }
            }
          }
        }, o.encodeQuery = function (e, t) {
          var n = o.encode(e + "");
          return void 0 === t && (t = o.escapeQuerySpace), t ? n.replace(/%20/g, "+") : n;
        }, o.decodeQuery = function (e, t) {
          e += "", void 0 === t && (t = o.escapeQuerySpace);
          try {
            return o.decode(t ? e.replace(/\+/g, "%20") : e);
          } catch (t) {
            return e;
          }
        };
        var v,
          y = {
            encode: "encode",
            decode: "decode"
          },
          b = function b(e, t) {
            return function (n) {
              try {
                return o[t](n + "").replace(o.characters[e][t].expression, function (n) {
                  return o.characters[e][t].map[n];
                });
              } catch (e) {
                return n;
              }
            };
          };
        for (v in y) o[v + "PathSegment"] = b("pathname", y[v]), o[v + "UrnPathSegment"] = b("urnpath", y[v]);
        var _ = function _(e, t, n) {
          return function (r) {
            var i;
            i = n ? function (e) {
              return o[t](o[n](e));
            } : o[t];
            for (var a = (r + "").split(e), s = 0, l = a.length; s < l; s++) a[s] = i(a[s]);
            return a.join(e);
          };
        };
        function x(e) {
          return function (t, n) {
            return void 0 === t ? this._parts[e] || "" : (this._parts[e] = t || null, this.build(!n), this);
          };
        }
        function w(e, t) {
          return function (n, r) {
            return void 0 === n ? this._parts[e] || "" : (null !== n && (n += "").charAt(0) === t && (n = n.substring(1)), this._parts[e] = n, this.build(!r), this);
          };
        }
        o.decodePath = _("/", "decodePathSegment"), o.decodeUrnPath = _(":", "decodeUrnPathSegment"), o.recodePath = _("/", "encodePathSegment", "decode"), o.recodeUrnPath = _(":", "encodeUrnPathSegment", "decode"), o.encodeReserved = b("reserved", "encode"), o.parse = function (e, t) {
          var n;
          return t || (t = {
            preventInvalidHostname: o.preventInvalidHostname
          }), (n = e.indexOf("#")) > -1 && (t.fragment = e.substring(n + 1) || null, e = e.substring(0, n)), (n = e.indexOf("?")) > -1 && (t.query = e.substring(n + 1) || null, e = e.substring(0, n)), "//" === e.substring(0, 2) ? (t.protocol = null, e = e.substring(2), e = o.parseAuthority(e, t)) : (n = e.indexOf(":")) > -1 && (t.protocol = e.substring(0, n) || null, t.protocol && !t.protocol.match(o.protocol_expression) ? t.protocol = void 0 : "//" === e.substring(n + 1, n + 3) ? (e = e.substring(n + 3), e = o.parseAuthority(e, t)) : (e = e.substring(n + 1), t.urn = !0)), t.path = e, t;
        }, o.parseHost = function (e, t) {
          e || (e = "");
          var n,
            r,
            i = (e = e.replace(/\\/g, "/")).indexOf("/");
          if (-1 === i && (i = e.length), "[" === e.charAt(0)) n = e.indexOf("]"), t.hostname = e.substring(1, n) || null, t.port = e.substring(n + 2, i) || null, "/" === t.port && (t.port = null);else {
            var a = e.indexOf(":"),
              s = e.indexOf("/"),
              l = e.indexOf(":", a + 1);
            -1 !== l && (-1 === s || l < s) ? (t.hostname = e.substring(0, i) || null, t.port = null) : (r = e.substring(0, i).split(":"), t.hostname = r[0] || null, t.port = r[1] || null);
          }
          return t.hostname && "/" !== e.substring(i).charAt(0) && (i++, e = "/" + e), t.preventInvalidHostname && o.ensureValidHostname(t.hostname, t.protocol), t.port && o.ensureValidPort(t.port), e.substring(i) || "/";
        }, o.parseAuthority = function (e, t) {
          return e = o.parseUserinfo(e, t), o.parseHost(e, t);
        }, o.parseUserinfo = function (e, t) {
          var n,
            r = e.indexOf("/"),
            i = e.lastIndexOf("@", r > -1 ? r : e.length - 1);
          return i > -1 && (-1 === r || i < r) ? (n = e.substring(0, i).split(":"), t.username = n[0] ? o.decode(n[0]) : null, n.shift(), t.password = n[0] ? o.decode(n.join(":")) : null, e = e.substring(i + 1)) : (t.username = null, t.password = null), e;
        }, o.parseQuery = function (e, t) {
          if (!e) return {};
          if (!(e = e.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, ""))) return {};
          for (var n, r, i, a = {}, l = e.split("&"), u = l.length, c = 0; c < u; c++) n = l[c].split("="), r = o.decodeQuery(n.shift(), t), i = n.length ? o.decodeQuery(n.join("="), t) : null, s.call(a, r) ? ("string" != typeof a[r] && null !== a[r] || (a[r] = [a[r]]), a[r].push(i)) : a[r] = i;
          return a;
        }, o.build = function (e) {
          var t = "";
          return e.protocol && (t += e.protocol + ":"), e.urn || !t && !e.hostname || (t += "//"), t += o.buildAuthority(e) || "", "string" == typeof e.path && ("/" !== e.path.charAt(0) && "string" == typeof e.hostname && (t += "/"), t += e.path), "string" == typeof e.query && e.query && (t += "?" + e.query), "string" == typeof e.fragment && e.fragment && (t += "#" + e.fragment), t;
        }, o.buildHost = function (e) {
          var t = "";
          return e.hostname ? (o.ip6_expression.test(e.hostname) ? t += "[" + e.hostname + "]" : t += e.hostname, e.port && (t += ":" + e.port), t) : "";
        }, o.buildAuthority = function (e) {
          return o.buildUserinfo(e) + o.buildHost(e);
        }, o.buildUserinfo = function (e) {
          var t = "";
          return e.username && (t += o.encode(e.username)), e.password && (t += ":" + o.encode(e.password)), t && (t += "@"), t;
        }, o.buildQuery = function (e, t, n) {
          var r,
            i,
            a,
            l,
            u = "";
          for (i in e) if (s.call(e, i) && i) if (c(e[i])) for (r = {}, a = 0, l = e[i].length; a < l; a++) void 0 !== e[i][a] && void 0 === r[e[i][a] + ""] && (u += "&" + o.buildQueryParameter(i, e[i][a], n), !0 !== t && (r[e[i][a] + ""] = !0));else void 0 !== e[i] && (u += "&" + o.buildQueryParameter(i, e[i], n));
          return u.substring(1);
        }, o.buildQueryParameter = function (e, t, n) {
          return o.encodeQuery(e, n) + (null !== t ? "=" + o.encodeQuery(t, n) : "");
        }, o.addQuery = function (e, t, n) {
          if ("object" == typeof t) for (var r in t) s.call(t, r) && o.addQuery(e, r, t[r]);else {
            if ("string" != typeof t) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
            if (void 0 === e[t]) return void (e[t] = n);
            "string" == typeof e[t] && (e[t] = [e[t]]), c(n) || (n = [n]), e[t] = (e[t] || []).concat(n);
          }
        }, o.setQuery = function (e, t, n) {
          if ("object" == typeof t) for (var r in t) s.call(t, r) && o.setQuery(e, r, t[r]);else {
            if ("string" != typeof t) throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
            e[t] = void 0 === n ? null : n;
          }
        }, o.removeQuery = function (e, t, n) {
          var r, i, a;
          if (c(t)) for (r = 0, i = t.length; r < i; r++) e[t[r]] = void 0;else if ("RegExp" === u(t)) for (a in e) t.test(a) && (e[a] = void 0);else if ("object" == typeof t) for (a in t) s.call(t, a) && o.removeQuery(e, a, t[a]);else {
            if ("string" != typeof t) throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
            void 0 !== n ? "RegExp" === u(n) ? !c(e[t]) && n.test(e[t]) ? e[t] = void 0 : e[t] = d(e[t], n) : e[t] !== String(n) || c(n) && 1 !== n.length ? c(e[t]) && (e[t] = d(e[t], n)) : e[t] = void 0 : e[t] = void 0;
          }
        }, o.hasQuery = function (e, t, n, r) {
          switch (u(t)) {
            case "String":
              break;
            case "RegExp":
              for (var i in e) if (s.call(e, i) && t.test(i) && (void 0 === n || o.hasQuery(e, i, n))) return !0;
              return !1;
            case "Object":
              for (var a in t) if (s.call(t, a) && !o.hasQuery(e, a, t[a])) return !1;
              return !0;
            default:
              throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
          }
          switch (u(n)) {
            case "Undefined":
              return t in e;
            case "Boolean":
              return n === Boolean(c(e[t]) ? e[t].length : e[t]);
            case "Function":
              return !!n(e[t], t, e);
            case "Array":
              return !!c(e[t]) && (r ? h : f)(e[t], n);
            case "RegExp":
              return c(e[t]) ? !!r && h(e[t], n) : Boolean(e[t] && e[t].match(n));
            case "Number":
              n = String(n);
            case "String":
              return c(e[t]) ? !!r && h(e[t], n) : e[t] === n;
            default:
              throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
          }
        }, o.joinPaths = function () {
          for (var e = [], t = [], n = 0, r = 0; r < arguments.length; r++) {
            var i = new o(arguments[r]);
            e.push(i);
            for (var a = i.segment(), s = 0; s < a.length; s++) "string" == typeof a[s] && t.push(a[s]), a[s] && n++;
          }
          if (!t.length || !n) return new o("");
          var l = new o("").segment(t);
          return "" !== e[0].path() && "/" !== e[0].path().slice(0, 1) || l.path("/" + l.path()), l.normalize();
        }, o.commonPath = function (e, t) {
          var n,
            r = Math.min(e.length, t.length);
          for (n = 0; n < r; n++) if (e.charAt(n) !== t.charAt(n)) {
            n--;
            break;
          }
          return n < 1 ? e.charAt(0) === t.charAt(0) && "/" === e.charAt(0) ? "/" : "" : ("/" === e.charAt(n) && "/" === t.charAt(n) || (n = e.substring(0, n).lastIndexOf("/")), e.substring(0, n + 1));
        }, o.withinString = function (e, t, n) {
          n || (n = {});
          var r = n.start || o.findUri.start,
            i = n.end || o.findUri.end,
            a = n.trim || o.findUri.trim,
            s = n.parens || o.findUri.parens,
            l = /[a-z0-9-]=["']?$/i;
          for (r.lastIndex = 0;;) {
            var u = r.exec(e);
            if (!u) break;
            var c = u.index;
            if (n.ignoreHtml) {
              var d = e.slice(Math.max(c - 3, 0), c);
              if (d && l.test(d)) continue;
            }
            for (var h = c + e.slice(c).search(i), f = e.slice(c, h), p = -1;;) {
              var m = s.exec(f);
              if (!m) break;
              var g = m.index + m[0].length;
              p = Math.max(p, g);
            }
            if (!((f = p > -1 ? f.slice(0, p) + f.slice(p).replace(a, "") : f.replace(a, "")).length <= u[0].length || n.ignore && n.ignore.test(f))) {
              var v = t(f, c, h = c + f.length, e);
              void 0 !== v ? (v = String(v), e = e.slice(0, c) + v + e.slice(h), r.lastIndex = c + v.length) : r.lastIndex = h;
            }
          }
          return r.lastIndex = 0, e;
        }, o.ensureValidHostname = function (t, n) {
          var r = !!t,
            i = !1;
          if (!!n && (i = h(o.hostProtocols, n)), i && !r) throw new TypeError("Hostname cannot be empty, if protocol is " + n);
          if (t && t.match(o.invalid_hostname_characters)) {
            if (!e) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
            if (e.toASCII(t).match(o.invalid_hostname_characters)) throw new TypeError('Hostname "' + t + '" contains characters other than [A-Z0-9.-:_]');
          }
        }, o.ensureValidPort = function (e) {
          if (e) {
            var t = Number(e);
            if (!(/^[0-9]+$/.test(t) && t > 0 && t < 65536)) throw new TypeError('Port "' + e + '" is not a valid port');
          }
        }, o.noConflict = function (e) {
          if (e) {
            var t = {
              URI: this.noConflict()
            };
            return r.URITemplate && "function" == typeof r.URITemplate.noConflict && (t.URITemplate = r.URITemplate.noConflict()), r.IPv6 && "function" == typeof r.IPv6.noConflict && (t.IPv6 = r.IPv6.noConflict()), r.SecondLevelDomains && "function" == typeof r.SecondLevelDomains.noConflict && (t.SecondLevelDomains = r.SecondLevelDomains.noConflict()), t;
          }
          return r.URI === this && (r.URI = i), this;
        }, a.build = function (e) {
          return !0 === e ? this._deferred_build = !0 : (void 0 === e || this._deferred_build) && (this._string = o.build(this._parts), this._deferred_build = !1), this;
        }, a.clone = function () {
          return new o(this);
        }, a.valueOf = a.toString = function () {
          return this.build(!1)._string;
        }, a.protocol = x("protocol"), a.username = x("username"), a.password = x("password"), a.hostname = x("hostname"), a.port = x("port"), a.query = w("query", "?"), a.fragment = w("fragment", "#"), a.search = function (e, t) {
          var n = this.query(e, t);
          return "string" == typeof n && n.length ? "?" + n : n;
        }, a.hash = function (e, t) {
          var n = this.fragment(e, t);
          return "string" == typeof n && n.length ? "#" + n : n;
        }, a.pathname = function (e, t) {
          if (void 0 === e || !0 === e) {
            var n = this._parts.path || (this._parts.hostname ? "/" : "");
            return e ? (this._parts.urn ? o.decodeUrnPath : o.decodePath)(n) : n;
          }
          return this._parts.urn ? this._parts.path = e ? o.recodeUrnPath(e) : "" : this._parts.path = e ? o.recodePath(e) : "/", this.build(!t), this;
        }, a.path = a.pathname, a.href = function (e, t) {
          var n;
          if (void 0 === e) return this.toString();
          this._string = "", this._parts = o._parts();
          var r = e instanceof o,
            i = "object" == typeof e && (e.hostname || e.path || e.pathname);
          e.nodeName && (e = e[o.getDomAttribute(e)] || "", i = !1);
          if (!r && i && void 0 !== e.pathname && (e = e.toString()), "string" == typeof e || e instanceof String) this._parts = o.parse(String(e), this._parts);else {
            if (!r && !i) throw new TypeError("invalid input");
            var a = r ? e._parts : e;
            for (n in a) "query" !== n && s.call(this._parts, n) && (this._parts[n] = a[n]);
            a.query && this.query(a.query, !1);
          }
          return this.build(!t), this;
        }, a.is = function (e) {
          var t = !1,
            r = !1,
            i = !1,
            a = !1,
            s = !1,
            l = !1,
            u = !1,
            c = !this._parts.urn;
          switch (this._parts.hostname && (c = !1, r = o.ip4_expression.test(this._parts.hostname), i = o.ip6_expression.test(this._parts.hostname), s = (a = !(t = r || i)) && n && n.has(this._parts.hostname), l = a && o.idn_expression.test(this._parts.hostname), u = a && o.punycode_expression.test(this._parts.hostname)), e.toLowerCase()) {
            case "relative":
              return c;
            case "absolute":
              return !c;
            case "domain":
            case "name":
              return a;
            case "sld":
              return s;
            case "ip":
              return t;
            case "ip4":
            case "ipv4":
            case "inet4":
              return r;
            case "ip6":
            case "ipv6":
            case "inet6":
              return i;
            case "idn":
              return l;
            case "url":
              return !this._parts.urn;
            case "urn":
              return !!this._parts.urn;
            case "punycode":
              return u;
          }
          return null;
        };
        var S = a.protocol,
          A = a.port,
          E = a.hostname;
        a.protocol = function (e, t) {
          if (e && !(e = e.replace(/:(\/\/)?$/, "")).match(o.protocol_expression)) throw new TypeError('Protocol "' + e + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
          return S.call(this, e, t);
        }, a.scheme = a.protocol, a.port = function (e, t) {
          return this._parts.urn ? void 0 === e ? "" : this : (void 0 !== e && (0 === e && (e = null), e && (":" === (e += "").charAt(0) && (e = e.substring(1)), o.ensureValidPort(e))), A.call(this, e, t));
        }, a.hostname = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 !== e) {
            var n = {
              preventInvalidHostname: this._parts.preventInvalidHostname
            };
            if ("/" !== o.parseHost(e, n)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
            e = n.hostname, this._parts.preventInvalidHostname && o.ensureValidHostname(e, this._parts.protocol);
          }
          return E.call(this, e, t);
        }, a.origin = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e) {
            var n = this.protocol();
            return this.authority() ? (n ? n + "://" : "") + this.authority() : "";
          }
          var r = o(e);
          return this.protocol(r.protocol()).authority(r.authority()).build(!t), this;
        }, a.host = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e) return this._parts.hostname ? o.buildHost(this._parts) : "";
          if ("/" !== o.parseHost(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
          return this.build(!t), this;
        }, a.authority = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e) return this._parts.hostname ? o.buildAuthority(this._parts) : "";
          if ("/" !== o.parseAuthority(e, this._parts)) throw new TypeError('Hostname "' + e + '" contains characters other than [A-Z0-9.-]');
          return this.build(!t), this;
        }, a.userinfo = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e) {
            var n = o.buildUserinfo(this._parts);
            return n ? n.substring(0, n.length - 1) : n;
          }
          return "@" !== e[e.length - 1] && (e += "@"), o.parseUserinfo(e, this._parts), this.build(!t), this;
        }, a.resource = function (e, t) {
          var n;
          return void 0 === e ? this.path() + this.search() + this.hash() : (n = o.parse(e), this._parts.path = n.path, this._parts.query = n.query, this._parts.fragment = n.fragment, this.build(!t), this);
        }, a.subdomain = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e) {
            if (!this._parts.hostname || this.is("IP")) return "";
            var n = this._parts.hostname.length - this.domain().length - 1;
            return this._parts.hostname.substring(0, n) || "";
          }
          var r = this._parts.hostname.length - this.domain().length,
            i = this._parts.hostname.substring(0, r),
            a = new RegExp("^" + l(i));
          if (e && "." !== e.charAt(e.length - 1) && (e += "."), -1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
          return e && o.ensureValidHostname(e, this._parts.protocol), this._parts.hostname = this._parts.hostname.replace(a, e), this.build(!t), this;
        }, a.domain = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
            if (!this._parts.hostname || this.is("IP")) return "";
            var n = this._parts.hostname.match(/\./g);
            if (n && n.length < 2) return this._parts.hostname;
            var r = this._parts.hostname.length - this.tld(t).length - 1;
            return r = this._parts.hostname.lastIndexOf(".", r - 1) + 1, this._parts.hostname.substring(r) || "";
          }
          if (!e) throw new TypeError("cannot set domain empty");
          if (-1 !== e.indexOf(":")) throw new TypeError("Domains cannot contain colons");
          if (o.ensureValidHostname(e, this._parts.protocol), !this._parts.hostname || this.is("IP")) this._parts.hostname = e;else {
            var i = new RegExp(l(this.domain()) + "$");
            this._parts.hostname = this._parts.hostname.replace(i, e);
          }
          return this.build(!t), this;
        }, a.tld = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if ("boolean" == typeof e && (t = e, e = void 0), void 0 === e) {
            if (!this._parts.hostname || this.is("IP")) return "";
            var r = this._parts.hostname.lastIndexOf("."),
              i = this._parts.hostname.substring(r + 1);
            return !0 !== t && n && n.list[i.toLowerCase()] && n.get(this._parts.hostname) || i;
          }
          var o;
          if (!e) throw new TypeError("cannot set TLD empty");
          if (e.match(/[^a-zA-Z0-9-]/)) {
            if (!n || !n.is(e)) throw new TypeError('TLD "' + e + '" contains characters other than [A-Z0-9]');
            o = new RegExp(l(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(o, e);
          } else {
            if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
            o = new RegExp(l(this.tld()) + "$"), this._parts.hostname = this._parts.hostname.replace(o, e);
          }
          return this.build(!t), this;
        }, a.directory = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e || !0 === e) {
            if (!this._parts.path && !this._parts.hostname) return "";
            if ("/" === this._parts.path) return "/";
            var n = this._parts.path.length - this.filename().length - 1,
              r = this._parts.path.substring(0, n) || (this._parts.hostname ? "/" : "");
            return e ? o.decodePath(r) : r;
          }
          var i = this._parts.path.length - this.filename().length,
            a = this._parts.path.substring(0, i),
            s = new RegExp("^" + l(a));
          return this.is("relative") || (e || (e = "/"), "/" !== e.charAt(0) && (e = "/" + e)), e && "/" !== e.charAt(e.length - 1) && (e += "/"), e = o.recodePath(e), this._parts.path = this._parts.path.replace(s, e), this.build(!t), this;
        }, a.filename = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if ("string" != typeof e) {
            if (!this._parts.path || "/" === this._parts.path) return "";
            var n = this._parts.path.lastIndexOf("/"),
              r = this._parts.path.substring(n + 1);
            return e ? o.decodePathSegment(r) : r;
          }
          var i = !1;
          "/" === e.charAt(0) && (e = e.substring(1)), e.match(/\.?\//) && (i = !0);
          var a = new RegExp(l(this.filename()) + "$");
          return e = o.recodePath(e), this._parts.path = this._parts.path.replace(a, e), i ? this.normalizePath(t) : this.build(!t), this;
        }, a.suffix = function (e, t) {
          if (this._parts.urn) return void 0 === e ? "" : this;
          if (void 0 === e || !0 === e) {
            if (!this._parts.path || "/" === this._parts.path) return "";
            var n,
              r,
              i = this.filename(),
              a = i.lastIndexOf(".");
            return -1 === a ? "" : (n = i.substring(a + 1), r = /^[a-z0-9%]+$/i.test(n) ? n : "", e ? o.decodePathSegment(r) : r);
          }
          "." === e.charAt(0) && (e = e.substring(1));
          var s,
            u = this.suffix();
          if (u) s = e ? new RegExp(l(u) + "$") : new RegExp(l("." + u) + "$");else {
            if (!e) return this;
            this._parts.path += "." + o.recodePath(e);
          }
          return s && (e = o.recodePath(e), this._parts.path = this._parts.path.replace(s, e)), this.build(!t), this;
        }, a.segment = function (e, t, n) {
          var r = this._parts.urn ? ":" : "/",
            i = this.path(),
            o = "/" === i.substring(0, 1),
            a = i.split(r);
          if (void 0 !== e && "number" != typeof e && (n = t, t = e, e = void 0), void 0 !== e && "number" != typeof e) throw new Error('Bad segment "' + e + '", must be 0-based integer');
          if (o && a.shift(), e < 0 && (e = Math.max(a.length + e, 0)), void 0 === t) return void 0 === e ? a : a[e];
          if (null === e || void 0 === a[e]) {
            if (c(t)) {
              a = [];
              for (var s = 0, l = t.length; s < l; s++) (t[s].length || a.length && a[a.length - 1].length) && (a.length && !a[a.length - 1].length && a.pop(), a.push(p(t[s])));
            } else (t || "string" == typeof t) && (t = p(t), "" === a[a.length - 1] ? a[a.length - 1] = t : a.push(t));
          } else t ? a[e] = p(t) : a.splice(e, 1);
          return o && a.unshift(""), this.path(a.join(r), n);
        }, a.segmentCoded = function (e, t, n) {
          var r, i, a;
          if ("number" != typeof e && (n = t, t = e, e = void 0), void 0 === t) {
            if (c(r = this.segment(e, t, n))) for (i = 0, a = r.length; i < a; i++) r[i] = o.decode(r[i]);else r = void 0 !== r ? o.decode(r) : void 0;
            return r;
          }
          if (c(t)) for (i = 0, a = t.length; i < a; i++) t[i] = o.encode(t[i]);else t = "string" == typeof t || t instanceof String ? o.encode(t) : t;
          return this.segment(e, t, n);
        };
        var T = a.query;
        return a.query = function (e, t) {
          if (!0 === e) return o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
          if ("function" == typeof e) {
            var n = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace),
              r = e.call(this, n);
            return this._parts.query = o.buildQuery(r || n, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this;
          }
          return void 0 !== e && "string" != typeof e ? (this._parts.query = o.buildQuery(e, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), this.build(!t), this) : T.call(this, e, t);
        }, a.setQuery = function (e, t, n) {
          var r = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
          if ("string" == typeof e || e instanceof String) r[e] = void 0 !== t ? t : null;else {
            if ("object" != typeof e) throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
            for (var i in e) s.call(e, i) && (r[i] = e[i]);
          }
          return this._parts.query = o.buildQuery(r, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (n = t), this.build(!n), this;
        }, a.addQuery = function (e, t, n) {
          var r = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
          return o.addQuery(r, e, void 0 === t ? null : t), this._parts.query = o.buildQuery(r, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (n = t), this.build(!n), this;
        }, a.removeQuery = function (e, t, n) {
          var r = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
          return o.removeQuery(r, e, t), this._parts.query = o.buildQuery(r, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace), "string" != typeof e && (n = t), this.build(!n), this;
        }, a.hasQuery = function (e, t, n) {
          var r = o.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
          return o.hasQuery(r, e, t, n);
        }, a.setSearch = a.setQuery, a.addSearch = a.addQuery, a.removeSearch = a.removeQuery, a.hasSearch = a.hasQuery, a.normalize = function () {
          return this._parts.urn ? this.normalizeProtocol(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build() : this.normalizeProtocol(!1).normalizeHostname(!1).normalizePort(!1).normalizePath(!1).normalizeQuery(!1).normalizeFragment(!1).build();
        }, a.normalizeProtocol = function (e) {
          return "string" == typeof this._parts.protocol && (this._parts.protocol = this._parts.protocol.toLowerCase(), this.build(!e)), this;
        }, a.normalizeHostname = function (n) {
          return this._parts.hostname && (this.is("IDN") && e ? this._parts.hostname = e.toASCII(this._parts.hostname) : this.is("IPv6") && t && (this._parts.hostname = t.best(this._parts.hostname)), this._parts.hostname = this._parts.hostname.toLowerCase(), this.build(!n)), this;
        }, a.normalizePort = function (e) {
          return "string" == typeof this._parts.protocol && this._parts.port === o.defaultPorts[this._parts.protocol] && (this._parts.port = null, this.build(!e)), this;
        }, a.normalizePath = function (e) {
          var t,
            n = this._parts.path;
          if (!n) return this;
          if (this._parts.urn) return this._parts.path = o.recodeUrnPath(this._parts.path), this.build(!e), this;
          if ("/" === this._parts.path) return this;
          var r,
            i,
            a = "";
          for ("/" !== (n = o.recodePath(n)).charAt(0) && (t = !0, n = "/" + n), "/.." !== n.slice(-3) && "/." !== n.slice(-2) || (n += "/"), n = n.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/"), t && (a = n.substring(1).match(/^(\.\.\/)+/) || "") && (a = a[0]); -1 !== (r = n.search(/\/\.\.(\/|$)/));) 0 !== r ? (-1 === (i = n.substring(0, r).lastIndexOf("/")) && (i = r), n = n.substring(0, i) + n.substring(r + 3)) : n = n.substring(3);
          return t && this.is("relative") && (n = a + n.substring(1)), this._parts.path = n, this.build(!e), this;
        }, a.normalizePathname = a.normalizePath, a.normalizeQuery = function (e) {
          return "string" == typeof this._parts.query && (this._parts.query.length ? this.query(o.parseQuery(this._parts.query, this._parts.escapeQuerySpace)) : this._parts.query = null, this.build(!e)), this;
        }, a.normalizeFragment = function (e) {
          return this._parts.fragment || (this._parts.fragment = null, this.build(!e)), this;
        }, a.normalizeSearch = a.normalizeQuery, a.normalizeHash = a.normalizeFragment, a.iso8859 = function () {
          var e = o.encode,
            t = o.decode;
          o.encode = escape, o.decode = decodeURIComponent;
          try {
            this.normalize();
          } finally {
            o.encode = e, o.decode = t;
          }
          return this;
        }, a.unicode = function () {
          var e = o.encode,
            t = o.decode;
          o.encode = g, o.decode = unescape;
          try {
            this.normalize();
          } finally {
            o.encode = e, o.decode = t;
          }
          return this;
        }, a.readable = function () {
          var t = this.clone();
          t.username("").password("").normalize();
          var n = "";
          if (t._parts.protocol && (n += t._parts.protocol + "://"), t._parts.hostname && (t.is("punycode") && e ? (n += e.toUnicode(t._parts.hostname), t._parts.port && (n += ":" + t._parts.port)) : n += t.host()), t._parts.hostname && t._parts.path && "/" !== t._parts.path.charAt(0) && (n += "/"), n += t.path(!0), t._parts.query) {
            for (var r = "", i = 0, a = t._parts.query.split("&"), s = a.length; i < s; i++) {
              var l = (a[i] || "").split("=");
              r += "&" + o.decodeQuery(l[0], this._parts.escapeQuerySpace).replace(/&/g, "%26"), void 0 !== l[1] && (r += "=" + o.decodeQuery(l[1], this._parts.escapeQuerySpace).replace(/&/g, "%26"));
            }
            n += "?" + r.substring(1);
          }
          return n += o.decodeQuery(t.hash(), !0);
        }, a.absoluteTo = function (e) {
          var t,
            n,
            r,
            i = this.clone(),
            a = ["protocol", "username", "password", "hostname", "port"];
          if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
          if (e instanceof o || (e = new o(e)), i._parts.protocol) return i;
          if (i._parts.protocol = e._parts.protocol, this._parts.hostname) return i;
          for (n = 0; r = a[n]; n++) i._parts[r] = e._parts[r];
          return i._parts.path ? (".." === i._parts.path.substring(-2) && (i._parts.path += "/"), "/" !== i.path().charAt(0) && (t = (t = e.directory()) || (0 === e.path().indexOf("/") ? "/" : ""), i._parts.path = (t ? t + "/" : "") + i._parts.path, i.normalizePath())) : (i._parts.path = e._parts.path, i._parts.query || (i._parts.query = e._parts.query)), i.build(), i;
        }, a.relativeTo = function (e) {
          var t,
            n,
            r,
            i,
            a,
            s = this.clone().normalize();
          if (s._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
          if (e = new o(e).normalize(), t = s._parts, n = e._parts, i = s.path(), a = e.path(), "/" !== i.charAt(0)) throw new Error("URI is already relative");
          if ("/" !== a.charAt(0)) throw new Error("Cannot calculate a URI relative to another relative URI");
          if (t.protocol === n.protocol && (t.protocol = null), t.username !== n.username || t.password !== n.password) return s.build();
          if (null !== t.protocol || null !== t.username || null !== t.password) return s.build();
          if (t.hostname !== n.hostname || t.port !== n.port) return s.build();
          if (t.hostname = null, t.port = null, i === a) return t.path = "", s.build();
          if (!(r = o.commonPath(i, a))) return s.build();
          var l = n.path.substring(r.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
          return t.path = l + t.path.substring(r.length) || "./", s.build();
        }, a.equals = function (e) {
          var t,
            n,
            r,
            i,
            a,
            l = this.clone(),
            u = new o(e),
            d = {};
          if (l.normalize(), u.normalize(), l.toString() === u.toString()) return !0;
          if (r = l.query(), i = u.query(), l.query(""), u.query(""), l.toString() !== u.toString()) return !1;
          if (r.length !== i.length) return !1;
          for (a in t = o.parseQuery(r, this._parts.escapeQuerySpace), n = o.parseQuery(i, this._parts.escapeQuerySpace), t) if (s.call(t, a)) {
            if (c(t[a])) {
              if (!f(t[a], n[a])) return !1;
            } else if (t[a] !== n[a]) return !1;
            d[a] = !0;
          }
          for (a in n) if (s.call(n, a) && !d[a]) return !1;
          return !0;
        }, a.preventInvalidHostname = function (e) {
          return this._parts.preventInvalidHostname = !!e, this;
        }, a.duplicateQueryParameters = function (e) {
          return this._parts.duplicateQueryParameters = !!e, this;
        }, a.escapeQuerySpace = function (e) {
          return this._parts.escapeQuerySpace = !!e, this;
        }, o;
      });
    },
    "./node_modules/urijs/src/punycode.js": function node_modulesUrijsSrcPunycodeJs(e, t, n) {
      (function (e, r) {
        var i; /*! https://mths.be/punycode v1.4.0 by @mathias */
        !function (o) {
          t && t.nodeType, e && e.nodeType;
          var a = "object" == typeof r && r;
          a.global !== a && a.window !== a && a.self;
          var s,
            l = 2147483647,
            u = /^xn--/,
            c = /[^\x20-\x7E]/,
            d = /[\x2E\u3002\uFF0E\uFF61]/g,
            h = {
              overflow: "Overflow: input needs wider integers to process",
              "not-basic": "Illegal input >= 0x80 (not a basic code point)",
              "invalid-input": "Invalid input"
            },
            f = Math.floor,
            p = String.fromCharCode;
          function m(e) {
            throw new RangeError(h[e]);
          }
          function g(e, t) {
            for (var n = e.length, r = []; n--;) r[n] = t(e[n]);
            return r;
          }
          function v(e, t) {
            var n = e.split("@"),
              r = "";
            return n.length > 1 && (r = n[0] + "@", e = n[1]), r + g((e = e.replace(d, ".")).split("."), t).join(".");
          }
          function y(e) {
            for (var t, n, r = [], i = 0, o = e.length; i < o;) (t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < o ? 56320 == (64512 & (n = e.charCodeAt(i++))) ? r.push(((1023 & t) << 10) + (1023 & n) + 65536) : (r.push(t), i--) : r.push(t);
            return r;
          }
          function b(e) {
            return g(e, function (e) {
              var t = "";
              return e > 65535 && (t += p((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += p(e);
            }).join("");
          }
          function _(e, t) {
            return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
          }
          function x(e, t, n) {
            var r = 0;
            for (e = n ? f(e / 700) : e >> 1, e += f(e / t); e > 455; r += 36) e = f(e / 35);
            return f(r + 36 * e / (e + 38));
          }
          function w(e) {
            var t,
              n,
              r,
              i,
              o,
              a,
              s,
              u,
              c,
              d,
              h,
              p = [],
              g = e.length,
              v = 0,
              y = 128,
              _ = 72;
            for ((n = e.lastIndexOf("-")) < 0 && (n = 0), r = 0; r < n; ++r) e.charCodeAt(r) >= 128 && m("not-basic"), p.push(e.charCodeAt(r));
            for (i = n > 0 ? n + 1 : 0; i < g;) {
              for (o = v, a = 1, s = 36; i >= g && m("invalid-input"), ((u = (h = e.charCodeAt(i++)) - 48 < 10 ? h - 22 : h - 65 < 26 ? h - 65 : h - 97 < 26 ? h - 97 : 36) >= 36 || u > f((l - v) / a)) && m("overflow"), v += u * a, !(u < (c = s <= _ ? 1 : s >= _ + 26 ? 26 : s - _)); s += 36) a > f(l / (d = 36 - c)) && m("overflow"), a *= d;
              _ = x(v - o, t = p.length + 1, 0 == o), f(v / t) > l - y && m("overflow"), y += f(v / t), v %= t, p.splice(v++, 0, y);
            }
            return b(p);
          }
          function S(e) {
            var t,
              n,
              r,
              i,
              o,
              a,
              s,
              u,
              c,
              d,
              h,
              g,
              v,
              b,
              w,
              S = [];
            for (g = (e = y(e)).length, t = 128, n = 0, o = 72, a = 0; a < g; ++a) (h = e[a]) < 128 && S.push(p(h));
            for (r = i = S.length, i && S.push("-"); r < g;) {
              for (s = l, a = 0; a < g; ++a) (h = e[a]) >= t && h < s && (s = h);
              for (s - t > f((l - n) / (v = r + 1)) && m("overflow"), n += (s - t) * v, t = s, a = 0; a < g; ++a) if ((h = e[a]) < t && ++n > l && m("overflow"), h == t) {
                for (u = n, c = 36; !(u < (d = c <= o ? 1 : c >= o + 26 ? 26 : c - o)); c += 36) w = u - d, b = 36 - d, S.push(p(_(d + w % b, 0))), u = f(w / b);
                S.push(p(_(u, 0))), o = x(n, v, r == i), n = 0, ++r;
              }
              ++n, ++t;
            }
            return S.join("");
          }
          s = {
            version: "1.3.2",
            ucs2: {
              decode: y,
              encode: b
            },
            decode: w,
            encode: S,
            toASCII: function toASCII(e) {
              return v(e, function (e) {
                return c.test(e) ? "xn--" + S(e) : e;
              });
            },
            toUnicode: function toUnicode(e) {
              return v(e, function (e) {
                return u.test(e) ? w(e.slice(4).toLowerCase()) : e;
              });
            }
          }, void 0 === (i = function () {
            return s;
          }.call(t, n, t, e)) || (e.exports = i);
        }();
      }).call(this, n("./node_modules/webpack/buildin/module.js")(e), n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/util-deprecate/browser.js": function node_modulesUtilDeprecateBrowserJs(e, t, n) {
      (function (t) {
        function n(e) {
          try {
            if (!t.localStorage) return !1;
          } catch (e) {
            return !1;
          }
          var n = t.localStorage[e];
          return null != n && "true" === String(n).toLowerCase();
        }
        e.exports = function (e, t) {
          if (n("noDeprecation")) return e;
          var r = !1;
          return function () {
            if (!r) {
              if (n("throwDeprecation")) throw new Error(t);
              n("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
            }
            return e.apply(this, arguments);
          };
        };
      }).call(this, n("./node_modules/webpack/buildin/global.js"));
    },
    "./node_modules/util/support/isBufferBrowser.js": function node_modulesUtilSupportIsBufferBrowserJs(e, t) {
      e.exports = function (e) {
        return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
      };
    },
    "./node_modules/util/util.js": function node_modulesUtilUtilJs(e, t, n) {
      (function (e) {
        var r = Object.getOwnPropertyDescriptors || function (e) {
            for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) n[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
            return n;
          },
          i = /%[sdj%]/g;
        t.format = function (e) {
          if (!v(e)) {
            for (var t = [], n = 0; n < arguments.length; n++) t.push(s(arguments[n]));
            return t.join(" ");
          }
          n = 1;
          for (var r = arguments, o = r.length, a = String(e).replace(i, function (e) {
              if ("%%" === e) return "%";
              if (n >= o) return e;
              switch (e) {
                case "%s":
                  return String(r[n++]);
                case "%d":
                  return Number(r[n++]);
                case "%j":
                  try {
                    return JSON.stringify(r[n++]);
                  } catch (e) {
                    return "[Circular]";
                  }
                default:
                  return e;
              }
            }), l = r[n]; n < o; l = r[++n]) m(l) || !_(l) ? a += " " + l : a += " " + s(l);
          return a;
        }, t.deprecate = function (n, r) {
          if (void 0 !== e && !0 === e.noDeprecation) return n;
          if (void 0 === e) return function () {
            return t.deprecate(n, r).apply(this, arguments);
          };
          var i = !1;
          return function () {
            if (!i) {
              if (e.throwDeprecation) throw new Error(r);
              e.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
            }
            return n.apply(this, arguments);
          };
        };
        var o,
          a = {};
        function s(e, n) {
          var r = {
            seen: [],
            stylize: u
          };
          return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), p(n) ? r.showHidden = n : n && t._extend(r, n), y(r.showHidden) && (r.showHidden = !1), y(r.depth) && (r.depth = 2), y(r.colors) && (r.colors = !1), y(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = l), c(r, e, r.depth);
        }
        function l(e, t) {
          var n = s.styles[t];
          return n ? "[" + s.colors[n][0] + "m" + e + "[" + s.colors[n][1] + "m" : e;
        }
        function u(e, t) {
          return e;
        }
        function c(e, n, r) {
          if (e.customInspect && n && S(n.inspect) && n.inspect !== t.inspect && (!n.constructor || n.constructor.prototype !== n)) {
            var i = n.inspect(r, e);
            return v(i) || (i = c(e, i, r)), i;
          }
          var o = function (e, t) {
            if (y(t)) return e.stylize("undefined", "undefined");
            if (v(t)) {
              var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return e.stylize(n, "string");
            }
            if (g(t)) return e.stylize("" + t, "number");
            if (p(t)) return e.stylize("" + t, "boolean");
            if (m(t)) return e.stylize("null", "null");
          }(e, n);
          if (o) return o;
          var a = Object.keys(n),
            s = function (e) {
              var t = {};
              return e.forEach(function (e, n) {
                t[e] = !0;
              }), t;
            }(a);
          if (e.showHidden && (a = Object.getOwnPropertyNames(n)), w(n) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return d(n);
          if (0 === a.length) {
            if (S(n)) {
              var l = n.name ? ": " + n.name : "";
              return e.stylize("[Function" + l + "]", "special");
            }
            if (b(n)) return e.stylize(RegExp.prototype.toString.call(n), "regexp");
            if (x(n)) return e.stylize(Date.prototype.toString.call(n), "date");
            if (w(n)) return d(n);
          }
          var u,
            _ = "",
            A = !1,
            E = ["{", "}"];
          (f(n) && (A = !0, E = ["[", "]"]), S(n)) && (_ = " [Function" + (n.name ? ": " + n.name : "") + "]");
          return b(n) && (_ = " " + RegExp.prototype.toString.call(n)), x(n) && (_ = " " + Date.prototype.toUTCString.call(n)), w(n) && (_ = " " + d(n)), 0 !== a.length || A && 0 != n.length ? r < 0 ? b(n) ? e.stylize(RegExp.prototype.toString.call(n), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(n), u = A ? function (e, t, n, r, i) {
            for (var o = [], a = 0, s = t.length; a < s; ++a) C(t, String(a)) ? o.push(h(e, t, n, r, String(a), !0)) : o.push("");
            return i.forEach(function (i) {
              i.match(/^\d+$/) || o.push(h(e, t, n, r, i, !0));
            }), o;
          }(e, n, r, s, a) : a.map(function (t) {
            return h(e, n, r, s, t, A);
          }), e.seen.pop(), function (e, t, n) {
            if (e.reduce(function (e, t) {
              return t.indexOf("\n") >= 0 && 0, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0) > 60) return n[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1];
            return n[0] + t + " " + e.join(", ") + " " + n[1];
          }(u, _, E)) : E[0] + _ + E[1];
        }
        function d(e) {
          return "[" + Error.prototype.toString.call(e) + "]";
        }
        function h(e, t, n, r, i, o) {
          var a, s, l;
          if ((l = Object.getOwnPropertyDescriptor(t, i) || {
            value: t[i]
          }).get ? s = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (s = e.stylize("[Setter]", "special")), C(r, i) || (a = "[" + i + "]"), s || (e.seen.indexOf(l.value) < 0 ? (s = m(n) ? c(e, l.value, null) : c(e, l.value, n - 1)).indexOf("\n") > -1 && (s = o ? s.split("\n").map(function (e) {
            return "  " + e;
          }).join("\n").substr(2) : "\n" + s.split("\n").map(function (e) {
            return "   " + e;
          }).join("\n")) : s = e.stylize("[Circular]", "special")), y(a)) {
            if (o && i.match(/^\d+$/)) return s;
            (a = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
          }
          return a + ": " + s;
        }
        function f(e) {
          return Array.isArray(e);
        }
        function p(e) {
          return "boolean" == typeof e;
        }
        function m(e) {
          return null === e;
        }
        function g(e) {
          return "number" == typeof e;
        }
        function v(e) {
          return "string" == typeof e;
        }
        function y(e) {
          return void 0 === e;
        }
        function b(e) {
          return _(e) && "[object RegExp]" === A(e);
        }
        function _(e) {
          return "object" == typeof e && null !== e;
        }
        function x(e) {
          return _(e) && "[object Date]" === A(e);
        }
        function w(e) {
          return _(e) && ("[object Error]" === A(e) || e instanceof Error);
        }
        function S(e) {
          return "function" == typeof e;
        }
        function A(e) {
          return Object.prototype.toString.call(e);
        }
        function E(e) {
          return e < 10 ? "0" + e.toString(10) : e.toString(10);
        }
        t.debuglog = function (n) {
          if (y(o) && (o = e.env.NODE_DEBUG || ""), n = n.toUpperCase(), !a[n]) if (new RegExp("\\b" + n + "\\b", "i").test(o)) {
            var r = e.pid;
            a[n] = function () {
              var e = t.format.apply(t, arguments);
              console.error("%s %d: %s", n, r, e);
            };
          } else a[n] = function () {};
          return a[n];
        }, t.inspect = s, s.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39]
        }, s.styles = {
          special: "cyan",
          number: "yellow",
          boolean: "yellow",
          undefined: "grey",
          null: "bold",
          string: "green",
          date: "magenta",
          regexp: "red"
        }, t.isArray = f, t.isBoolean = p, t.isNull = m, t.isNullOrUndefined = function (e) {
          return null == e;
        }, t.isNumber = g, t.isString = v, t.isSymbol = function (e) {
          return "symbol" == typeof e;
        }, t.isUndefined = y, t.isRegExp = b, t.isObject = _, t.isDate = x, t.isError = w, t.isFunction = S, t.isPrimitive = function (e) {
          return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
        }, t.isBuffer = n("./node_modules/util/support/isBufferBrowser.js");
        var T = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        function M() {
          var e = new Date(),
            t = [E(e.getHours()), E(e.getMinutes()), E(e.getSeconds())].join(":");
          return [e.getDate(), T[e.getMonth()], t].join(" ");
        }
        function C(e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }
        t.log = function () {
          console.log("%s - %s", M(), t.format.apply(t, arguments));
        }, t.inherits = n("./node_modules/inherits/inherits_browser.js"), t._extend = function (e, t) {
          if (!t || !_(t)) return e;
          for (var n = Object.keys(t), r = n.length; r--;) e[n[r]] = t[n[r]];
          return e;
        };
        var k = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
        function P(e, t) {
          if (!e) {
            var n = new Error("Promise was rejected with a falsy value");
            n.reason = e, e = n;
          }
          return t(e);
        }
        t.promisify = function (e) {
          if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
          if (k && e[k]) {
            var t;
            if ("function" != typeof (t = e[k])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(t, k, {
              value: t,
              enumerable: !1,
              writable: !1,
              configurable: !0
            }), t;
          }
          function t() {
            for (var t, n, r = new Promise(function (e, r) {
                t = e, n = r;
              }), i = [], o = 0; o < arguments.length; o++) i.push(arguments[o]);
            i.push(function (e, r) {
              e ? n(e) : t(r);
            });
            try {
              e.apply(this, i);
            } catch (e) {
              n(e);
            }
            return r;
          }
          return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), k && Object.defineProperty(t, k, {
            value: t,
            enumerable: !1,
            writable: !1,
            configurable: !0
          }), Object.defineProperties(t, r(e));
        }, t.promisify.custom = k, t.callbackify = function (t) {
          if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');
          function n() {
            for (var n = [], r = 0; r < arguments.length; r++) n.push(arguments[r]);
            var i = n.pop();
            if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");
            var o = this,
              a = function a() {
                return i.apply(o, arguments);
              };
            t.apply(this, n).then(function (t) {
              e.nextTick(a, null, t);
            }, function (t) {
              e.nextTick(P, t, a);
            });
          }
          return Object.setPrototypeOf(n, Object.getPrototypeOf(t)), Object.defineProperties(n, r(t)), n;
        };
      }).call(this, n("./node_modules/process/browser.js"));
    },
    "./node_modules/vm-browserify/index.js": function node_modulesVmBrowserifyIndexJs(module, exports) {
      var indexOf = function indexOf(e, t) {
          if (e.indexOf) return e.indexOf(t);
          for (var n = 0; n < e.length; n++) if (e[n] === t) return n;
          return -1;
        },
        Object_keys = function Object_keys(e) {
          if (Object.keys) return Object.keys(e);
          var t = [];
          for (var n in e) t.push(n);
          return t;
        },
        forEach = function forEach(e, t) {
          if (e.forEach) return e.forEach(t);
          for (var n = 0; n < e.length; n++) t(e[n], n, e);
        },
        defineProp = function () {
          try {
            return Object.defineProperty({}, "_", {}), function (e, t, n) {
              Object.defineProperty(e, t, {
                writable: !0,
                enumerable: !1,
                configurable: !0,
                value: n
              });
            };
          } catch (e) {
            return function (e, t, n) {
              e[t] = n;
            };
          }
        }(),
        globals = ["Array", "Boolean", "Date", "Error", "EvalError", "Function", "Infinity", "JSON", "Math", "NaN", "Number", "Object", "RangeError", "ReferenceError", "RegExp", "String", "SyntaxError", "TypeError", "URIError", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "undefined", "unescape"];
      function Context() {}
      Context.prototype = {};
      var Script = exports.Script = function (e) {
        if (!(this instanceof Script)) return new Script(e);
        this.code = e;
      };
      Script.prototype.runInContext = function (e) {
        if (!(e instanceof Context)) throw new TypeError("needs a 'context' argument.");
        var t = document.createElement("iframe");
        t.style || (t.style = {}), t.style.display = "none", document.body.appendChild(t);
        var n = t.contentWindow,
          r = n.eval,
          i = n.execScript;
        !r && i && (i.call(n, "null"), r = n.eval), forEach(Object_keys(e), function (t) {
          n[t] = e[t];
        }), forEach(globals, function (t) {
          e[t] && (n[t] = e[t]);
        });
        var o = Object_keys(n),
          a = r.call(n, this.code);
        return forEach(Object_keys(n), function (t) {
          (t in e || -1 === indexOf(o, t)) && (e[t] = n[t]);
        }), forEach(globals, function (t) {
          t in e || defineProp(e, t, n[t]);
        }), document.body.removeChild(t), a;
      }, Script.prototype.runInThisContext = function () {
        return eval(this.code);
      }, Script.prototype.runInNewContext = function (e) {
        var t = Script.createContext(e),
          n = this.runInContext(t);
        return e && forEach(Object_keys(t), function (n) {
          e[n] = t[n];
        }), n;
      }, forEach(Object_keys(Script.prototype), function (e) {
        exports[e] = Script[e] = function (t) {
          var n = Script(t);
          return n[e].apply(n, [].slice.call(arguments, 1));
        };
      }), exports.isContext = function (e) {
        return e instanceof Context;
      }, exports.createScript = function (e) {
        return exports.Script(e);
      }, exports.createContext = Script.createContext = function (e) {
        var t = new Context();
        return "object" == typeof e && forEach(Object_keys(e), function (n) {
          t[n] = e[n];
        }), t;
      };
    },
    "./node_modules/warning/warning.js": function node_modulesWarningWarningJs(e, t, n) {
      "use strict";

      var r = function r() {};
      e.exports = r;
    },
    "./node_modules/webpack/buildin/global.js": function node_modulesWebpackBuildinGlobalJs(e, t) {
      var n;
      n = function () {
        return this;
      }();
      try {
        n = n || new Function("return this")();
      } catch (e) {
        "object" == typeof window && (n = window);
      }
      e.exports = n;
    },
    "./node_modules/webpack/buildin/harmony-module.js": function node_modulesWebpackBuildinHarmonyModuleJs(e, t) {
      e.exports = function (e) {
        if (!e.webpackPolyfill) {
          var t = Object.create(e);
          t.children || (t.children = []), Object.defineProperty(t, "loaded", {
            enumerable: !0,
            get: function get() {
              return t.l;
            }
          }), Object.defineProperty(t, "id", {
            enumerable: !0,
            get: function get() {
              return t.i;
            }
          }), Object.defineProperty(t, "exports", {
            enumerable: !0
          }), t.webpackPolyfill = 1;
        }
        return t;
      };
    },
    "./node_modules/webpack/buildin/module.js": function node_modulesWebpackBuildinModuleJs(e, t) {
      e.exports = function (e) {
        return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), e.webpackPolyfill = 1), e;
      };
    },
    "./src/action/ContainerAction.ts": function srcActionContainerActionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/typesafe-actions/dist/index.umd.js");
      t.createContainerActions = function (e, t) {
        void 0 === t && (t = "bioblocks");
        var n = (t + "/" + e).toUpperCase();
        return {
          add: r.createStandardAction(n + "_ADD").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          addMultiple: r.createStandardAction(n + "_ADD_MULTIPLE").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          clear: r.createStandardAction(n + "_CLEAR")(),
          remove: r.createStandardAction(n + "_REMOVE").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          removeMultiple: r.createStandardAction(n + "_REMOVE_MULTIPLE").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          set: r.createStandardAction(n + "_SET").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          })
        };
      };
    },
    "./src/action/DataAction.ts": function srcActionDataActionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/typesafe-actions/dist/index.umd.js");
      t.createDataActions = function (e, t) {
        void 0 === t && (t = "bioblocks");
        var n = (t + "/" + e).toUpperCase();
        return i.createAsyncAction(n + "_FETCH_DATA_REQUEST", n + "_FETCH_DATA_SUCCESS", n + "_FETCH_DATA_FAILURE")();
      }, t.fetchDataset = function (e, n, i) {
        return void 0 === i && (i = "bioblocks"), function (o) {
          return r.__awaiter(void 0, void 0, void 0, function () {
            var a, s, l;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  a = t.createDataActions(e, i), o(a.request()), r.label = 1;
                case 1:
                  return r.trys.push([1, 3,, 4]), [4, n()];
                case 2:
                  return s = r.sent(), o(a.success(s)), [3, 4];
                case 3:
                  return l = r.sent(), o(a.failure(l)), console.log("An error occurred: " + l), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        };
      };
    },
    "./src/action/ObjectAction.ts": function srcActionObjectActionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/typesafe-actions/dist/index.umd.js");
      t.createObjectActions = function (e, t) {
        void 0 === t && (t = "bioblocks");
        var n = (t + "/" + e).toUpperCase();
        return {
          add: r.createStandardAction(n + "_ADD").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          clear: r.createStandardAction(n + "_CLEAR")(),
          remove: r.createStandardAction(n + "_REMOVE").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          removeMultiple: r.createStandardAction(n + "_REMOVE_MULTIPLE").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          set: r.createStandardAction(n + "_SET").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          }),
          toggle: r.createStandardAction(n + "_TOGGLE").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          })
        };
      };
    },
    "./src/action/ResiduePairAction.ts": function srcActionResiduePairActionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./src/action/index.ts"),
        i = n("./src/reducer/index.ts");
      t.createResiduePairActions = function (e) {
        return void 0 === e && (e = "bioblocks"), {
          candidates: r.createContainerActions(i.RESIDUE_PAIR_DATASET_NAME + "/candidates", e),
          hovered: r.createContainerActions(i.RESIDUE_PAIR_DATASET_NAME + "/hovered", e),
          locked: r.createObjectActions(i.RESIDUE_PAIR_DATASET_NAME + "/locked", e)
        };
      };
    },
    "./src/action/SpringAction.ts": function srcActionSpringActionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/action/index.ts");
      t.fetchSpringGraphData = function (e, t) {
        return void 0 === t && (t = "bioblocks"), function (n) {
          return r.__awaiter(void 0, void 0, void 0, function () {
            var o, a, s;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  o = i.createDataActions("spring/graphData", t), n(o.request()), r.label = 1;
                case 1:
                  return r.trys.push([1, 3,, 4]), [4, e()];
                case 2:
                  return a = r.sent(), n(o.success(a)), [3, 4];
                case 3:
                  return s = r.sent(), n(o.failure(s)), console.log("An error occurred: " + s), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        };
      }, t.createSpringActions = function (e) {
        return void 0 === e && (e = "bioblocks"), {
          category: r.__assign({}, i.createValueActions("spring/category", e)),
          graphData: r.__assign({}, i.createDataActions("spring/graphData", e)),
          species: r.__assign({}, i.createValueActions("spring/species", e))
        };
      };
    },
    "./src/action/ValueAction.ts": function srcActionValueActionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/typesafe-actions/dist/index.umd.js");
      t.createValueActions = function (e, t) {
        void 0 === t && (t = "bioblocks");
        var n = (t + "/" + e).toUpperCase();
        return {
          clear: r.createStandardAction(n + "_CLEAR")(),
          set: r.createStandardAction(n + "_SET").map(function (t) {
            return {
              meta: e,
              payload: t
            };
          })
        };
      };
    },
    "./src/action/index.ts": function srcActionIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/action/ContainerAction.ts"), t), r.__exportStar(n("./src/action/DataAction.ts"), t), r.__exportStar(n("./src/action/ObjectAction.ts"), t), r.__exportStar(n("./src/action/ValueAction.ts"), t), r.__exportStar(n("./src/action/SpringAction.ts"), t), r.__exportStar(n("./src/action/ResiduePairAction.ts"), t);
    },
    "./src/component/ContactMapComponent.tsx": function srcComponentContactMapComponentTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = n("./src/component/index.ts"),
        s = n("./src/data/index.ts"),
        l = n("./src/helper/index.ts");
      t.initialContactMapState = {
        pointsToPlot: new Array()
      };
      var u = function (e) {
        function n(n) {
          var l = e.call(this, n) || this;
          return l.state = t.initialContactMapState, l.onNodeSelectionChange = function (e) {
            return function (t, n) {
              var i = l.state.pointsToPlot;
              l.setState({
                pointsToPlot: r.__spread(i.slice(0, e), [r.__assign(r.__assign({}, i[e]), {
                  hoverinfo: "skip" === i[e].hoverinfo ? "text" : "skip"
                })], i.slice(e + 1))
              });
            };
          }, l.onNodeSizeChange = function (e, t) {
            return function (n, i) {
              var o = l.state.pointsToPlot;
              l.setState({
                pointsToPlot: r.__spread(o.slice(0, e), [r.__assign(r.__assign({}, o[e]), {
                  nodeSize: Math.min(Math.max(Math.abs(o[e].nodeSize + t), 1), 10)
                })], o.slice(e + 1))
              });
            };
          }, l.applySavedNodeOptions = function (e) {
            var t = l.state.pointsToPlot,
              n = t.findIndex(function (t) {
                return t.name === e.name;
              });
            return n >= 0 ? r.__assign(r.__assign({}, e), {
              hoverinfo: t[n].hoverinfo,
              nodeSize: t[n].nodeSize
            }) : e;
          }, l.generateHoveredResiduePairs = function (e) {
            return e.length >= 1 ? [{
              i: e[0],
              j: 1 === e.length ? e[0] : e[1]
            }] : [];
          }, l.generateLockedResiduePairs = function (e) {
            return Object.keys(e).reduce(function (t, n) {
              var r = e[n];
              return r && 2 === r.length && t.push({
                i: r[0],
                j: r[1],
                dist: 0
              }), t;
            }, new Array());
          }, l.generateSelectedResiduesChartData = function (e, t, n, r) {
            return a.generateChartDataEntry("none", e, t, "", n, r, {
              marker: {
                color: new Array(2 * r.length).fill(e),
                line: {
                  color: e,
                  width: 3
                },
                symbol: "circle-open"
              }
            });
          }, l.getColorFromEntry = function (e) {
            if (e.marker) {
              if (e.marker.line && e.marker.line.color) return e.marker.line.color;
              if (e.marker.color) return Array.isArray(e.marker.color) ? e.marker.color[0] : e.marker.color;
              if (e.marker.colorscale) return Array.isArray(e.marker.colorscale) ? e.marker.colorscale[0][1] : e.marker.colorscale;
            }
            if (e.line && e.line.color) return e.line.color;
          }, l.getDockConfigs = function () {
            return [{
              isVisibleCb: function isVisibleCb() {
                return l.props.selectedSecondaryStructures.length >= 1 || Object.values(l.props.lockedResiduePairs).length >= 1;
              },
              onClick: function onClick() {
                l.props.removeAllLockedResiduePairs(), l.props.removeAllSelectedSecondaryStructures(), l.props.removeHoveredResidues();
              },
              text: "Clear Selections"
            }];
          }, l.getMenuConfigs = function (e, t) {
            return [{
              component: {
                configs: {
                  Filters: e
                },
                name: "POPUP"
              },
              description: "Filter",
              iconName: "filter"
            }, {
              component: {
                configs: l.getNodeOptionConfigs(t),
                name: "POPUP"
              },
              description: "Settings"
            }];
          }, l.getNodeOptionConfigs = function (e) {
            return {
              "Node Options": new (Array.bind.apply(Array, r.__spread([void 0, {
                id: "stuff-1-2-3",
                name: "",
                options: [i.createElement(o.Label, {
                  basic: !0,
                  style: {
                    border: 0
                  },
                  key: "node-selection-label"
                }, "Selectable?")],
                style: {
                  padding: 0
                },
                type: s.CONFIGURATION_COMPONENT_TYPE.BUTTON_GROUP
              }], e.map(function (e, t) {
                var n = l.getColorFromEntry(e),
                  r = [i.createElement(o.Checkbox, {
                    checked: "skip" !== l.state.pointsToPlot[t].hoverinfo,
                    key: "node-selection-checkbox-" + t,
                    onClick: l.onNodeSelectionChange(t)
                  }), i.createElement(o.Icon, {
                    key: "node-size-slider-" + t + "-minus",
                    name: "minus",
                    onClick: l.onNodeSizeChange(t, -1),
                    size: "small",
                    style: {
                      color: n
                    }
                  }), i.createElement(o.Icon, {
                    key: "node-size-slider-" + t + "-2",
                    name: "circle",
                    size: "small",
                    style: {
                      color: n
                    }
                  }), i.createElement(o.Icon, {
                    key: "node-size-slider-" + t + "-plus",
                    name: "plus",
                    onClick: l.onNodeSizeChange(t, 1),
                    size: "small",
                    style: {
                      color: n
                    }
                  })];
                return {
                  id: "node-option-config-" + t,
                  name: e.name,
                  options: r,
                  style: {
                    padding: ".5em"
                  },
                  type: s.CONFIGURATION_COMPONENT_TYPE.BUTTON_GROUP
                };
              }))))()
            };
          }, l.handleAxisClick = function (e) {
            var t,
              n,
              i,
              o,
              a = l.props,
              s = a.addSelectedSecondaryStructure,
              u = a.data,
              c = a.removeSecondaryStructure,
              d = a.selectedSecondaryStructures;
            try {
              for (var h = r.__values(u.secondaryStructures), f = h.next(); !f.done; f = h.next()) {
                var p = f.value;
                try {
                  for (var m = (i = void 0, r.__values(p)), g = m.next(); !g.done; g = m.next()) {
                    var v = g.value;
                    v.contains.apply(v, r.__spread(e.selectedPoints)) && (d.includes(v) ? c(v) : s(v));
                  }
                } catch (e) {
                  i = {
                    error: e
                  };
                } finally {
                  try {
                    g && !g.done && (o = m.return) && o.call(m);
                  } finally {
                    if (i) throw i.error;
                  }
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                f && !f.done && (n = h.return) && n.call(h);
              } finally {
                if (t) throw t.error;
              }
            }
          }, l.handleAxisEnter = function (e) {
            var t,
              n,
              i,
              o,
              a = l.props,
              s = a.addHoveredSecondaryStructure,
              u = a.hoveredSecondaryStructures,
              c = a.data;
            try {
              for (var d = r.__values(c.secondaryStructures), h = d.next(); !h.done; h = d.next()) {
                var f = h.value,
                  p = function p(t) {
                    t.contains.apply(t, r.__spread(e.selectedPoints)) && !u.find(function (e) {
                      return t.isEqual(e);
                    }) && s(t);
                  };
                try {
                  for (var m = (i = void 0, r.__values(f)), g = m.next(); !g.done; g = m.next()) {
                    p(g.value);
                  }
                } catch (e) {
                  i = {
                    error: e
                  };
                } finally {
                  try {
                    g && !g.done && (o = m.return) && o.call(m);
                  } finally {
                    if (i) throw i.error;
                  }
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                h && !h.done && (n = d.return) && n.call(d);
              } finally {
                if (t) throw t.error;
              }
            }
          }, l.handleAxisLeave = function (e) {
            var t,
              n,
              i,
              o,
              a = l.props,
              s = a.data,
              u = a.hoveredSecondaryStructures,
              c = a.removeHoveredSecondaryStructure;
            try {
              for (var d = r.__values(s.secondaryStructures), h = d.next(); !h.done; h = d.next()) {
                var f = h.value,
                  p = function p(t) {
                    var n = u.find(function (e) {
                      return t.isEqual(e);
                    });
                    t.contains.apply(t, r.__spread(e.selectedPoints)) && n && c(n);
                  };
                try {
                  for (var m = (i = void 0, r.__values(f)), g = m.next(); !g.done; g = m.next()) {
                    p(g.value);
                  }
                } catch (e) {
                  i = {
                    error: e
                  };
                } finally {
                  try {
                    g && !g.done && (o = m.return) && o.call(m);
                  } finally {
                    if (i) throw i.error;
                  }
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                h && !h.done && (n = d.return) && n.call(d);
              } finally {
                if (t) throw t.error;
              }
            }
          }, l.onMouseClick = function (e) {
            return function (t) {
              var n;
              t.isAxis() ? l.handleAxisClick(t) : e(((n = {})[t.selectedPoints.sort().toString()] = t.selectedPoints, n));
            };
          }, l.onMouseEnter = function (e) {
            return function (t) {
              t.isAxis() ? l.handleAxisEnter(t) : e(t.selectedPoints);
            };
          }, l.onMouseLeave = function (e) {
            return function (t) {
              t.isAxis() ? l.handleAxisLeave(t) : e && e(t.selectedPoints);
            };
          }, l.onMouseSelect = function (e) {
            return function (t) {
              e && e(t.selectedPoints.map(function (e) {
                return e;
              }));
            };
          }, l;
        }
        return r.__extends(n, e), n.prototype.componentDidMount = function () {
          this.setupPointsToPlot(this.props.data.couplingScores);
        }, n.prototype.componentDidUpdate = function (e) {
          var t = this.props,
            n = t.data,
            r = t.lockedResiduePairs;
          n === e.data && r === e.lockedResiduePairs || this.setupPointsToPlot(n.couplingScores);
        }, n.prototype.render = function () {
          var e = this.state.pointsToPlot;
          return this.renderContactMapChart(e);
        }, n.prototype.renderContactMapChart = function (e) {
          var t = this.props,
            n = t.addHoveredResidues,
            r = t.configurations,
            o = t.data,
            s = t.height,
            l = t.isDataLoading,
            u = t.onBoxSelection,
            c = t.removeHoveredResidues,
            d = t.secondaryStructureColors,
            h = t.selectedSecondaryStructures,
            f = t.showConfigurations,
            p = t.toggleLockedResiduePair,
            m = t.width,
            g = o.couplingScores.totalContacts >= 1 ? o.couplingScores.residueIndexRange.max : void 0;
          return i.createElement(a.ComponentCard, {
            componentName: "Contact Map",
            dockItems: this.getDockConfigs(),
            isDataReady: o.couplingScores.allContacts.length >= 1,
            menuItems: this.getMenuConfigs(r, e)
          }, i.createElement(a.ContactMapChart, {
            contactData: e,
            height: s,
            isDataLoading: l,
            onClickCallback: this.onMouseClick(p),
            onHoverCallback: this.onMouseEnter(n),
            onSelectedCallback: this.onMouseSelect(u),
            onUnHoverCallback: this.onMouseLeave(c),
            range: g,
            secondaryStructures: o.secondaryStructures ? o.secondaryStructures : [],
            secondaryStructureColors: d,
            selectedSecondaryStructures: [h],
            showConfigurations: f,
            width: m
          }));
        }, n.prototype.setupPointsToPlot = function (e) {
          var t = this.props,
            n = t.data,
            i = t.lockedResiduePairs,
            o = t.hoveredResidues,
            s = t.formattedPoints,
            u = t.observedColor,
            c = t.highlightColor,
            d = {
              selected: "Selected Residue Pair",
              structure: (n.pdbData ? n.pdbData.experimental ? "X-ray" : "Inferred" : "Unknown") + " Structure Contact"
            },
            h = e.getObservedContacts().sort(function (e, t) {
              return e.dist && t.dist ? t.dist - e.dist : 0;
            }),
            f = new (Array.bind.apply(Array, r.__spread([void 0, a.generateChartDataEntry("text", {
              start: u,
              end: "rgb(247,251,255)"
            }, "Structure Contact (" + (n.couplingScores.isDerivedFromCouplingScores ? "Coupling Scores" : "PDB") + ")", d.structure, 4, h, {
              text: h.map(l.generateCouplingScoreHoverText)
            })], s)))(),
            p = new Array();
          p.push.apply(p, r.__spread(this.generateHoveredResiduePairs(o))), p.push.apply(p, r.__spread(this.generateLockedResiduePairs(i))), f.push(this.generateSelectedResiduesChartData(c, d.selected, 4, p)), this.setState(r.__assign(r.__assign({}, this.state), {
            pointsToPlot: f.map(this.applySavedNodeOptions)
          }));
        }, n.defaultProps = {
          addHoveredResidues: l.EMPTY_FUNCTION,
          addHoveredSecondaryStructure: l.EMPTY_FUNCTION,
          addSelectedSecondaryStructure: l.EMPTY_FUNCTION,
          configurations: new Array(),
          data: {
            couplingScores: new s.CouplingContainer(),
            pdbData: {
              experimental: void 0,
              predicted: void 0
            },
            secondaryStructures: new Array()
          },
          enableSliders: !0,
          formattedPoints: new Array(),
          height: "100%",
          highlightColor: "#ff8800",
          hoveredResidues: [],
          hoveredSecondaryStructures: [],
          isDataLoading: !1,
          lockedResiduePairs: {},
          observedColor: "#0000ff",
          removeAllLockedResiduePairs: l.EMPTY_FUNCTION,
          removeAllSelectedSecondaryStructures: l.EMPTY_FUNCTION,
          removeHoveredResidues: l.EMPTY_FUNCTION,
          removeHoveredSecondaryStructure: l.EMPTY_FUNCTION,
          removeSecondaryStructure: l.EMPTY_FUNCTION,
          selectedSecondaryStructures: [],
          showConfigurations: !0,
          toggleLockedResiduePair: l.EMPTY_FUNCTION,
          width: "100%"
        }, n;
      }(i.Component);
      t.ContactMapComponent = u;
    },
    "./src/component/FeatureViewer.tsx": function srcComponentFeatureViewerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("react")),
        a = n("./src/component/index.ts"),
        s = n("./src/data/index.ts"),
        l = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.onFeatureHover = function (e) {
              for (var t, i, o = n.props, a = o.data, s = o.getTextForHover, l = -1, u = [e.selectedPoints[0], e.selectedPoints[2]], c = 0; c < a.length; ++c) try {
                for (var d = (t = void 0, r.__values(u)), h = d.next(); !h.done; h = d.next()) {
                  var f = h.value;
                  a[c].contains(f) && (l = c);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  h && !h.done && (i = d.return) && i.call(d);
                } finally {
                  if (t) throw t.error;
                }
              }
              n.setState({
                hoverAnnotationText: s && l >= 0 ? s(a[l].label, l) : "",
                hoveredFeatureIndex: l
              });
            }, n.onFeatureClick = function (e) {
              var t = n.props,
                r = t.data,
                i = t.onClickCallback,
                o = n.deriveFeatureIndices(r, e.selectedPoints);
              i && i(n.deriveSelectedFeatures(r, o.toArray())), n.setState({
                selectedFeatureIndices: o,
                selectedRange: new s.Bioblocks1DSection("selection", -1, -1)
              });
            }, n.onFeatureSelect = function (e) {
              var t = n.props,
                r = t.data,
                i = t.onSelectCallback,
                o = n.deriveFeatureIndices(r, e.selectedPoints),
                a = e.plotlyEvent,
                l = n.state.selectedRange;
              if (a.range) {
                var u = {
                  end: (l = new s.Bioblocks1DSection("selection", Math.floor(a.range.x[0]), Math.ceil(a.range.x[1]))).end,
                  featuresSelected: n.deriveSelectedFeatures(r, o.toArray()),
                  length: l.length,
                  start: l.start
                };
                i && i(u);
              }
              n.setState({
                selectedFeatureIndices: o,
                selectedRange: l
              });
            }, n.deriveFeatureIndices = function (e, t) {
              for (var n = i.Set(), o = function o(i) {
                  var o = t[i];
                  e.reduce(function (e, t, n) {
                    return t.contains(o) ? r.__spread(e, [n]) : e;
                  }, new Array()).forEach(function (e) {
                    n = n.add(e);
                  });
                }, a = 0; a < t.length; a += 2) o(a);
              return n;
            }, n.deriveSelectedFeatures = function (e, t) {
              return t.map(function (t) {
                return new s.Bioblocks1DSection(e[t].label, e[t].start, e[t].end);
              });
            }, n.state = {
              hoverAnnotationText: "",
              hoveredFeatureIndex: -1,
              plotlyConfig: {
                showAxisDragHandles: !1,
                showAxisRangeEntryBoxes: !1
              },
              plotlyData: [],
              plotlyLayout: {},
              selectedFeatureIndices: i.Set(),
              selectedRange: new s.Bioblocks1DSection("selection", -1, -1)
            }, n;
          }
          return r.__extends(t, e), t.getDerivedStateFromProps = function (e, n) {
            var i = e.backgroundBar,
              o = e.data,
              a = e.height,
              l = e.maxLength,
              u = e.showGrouped,
              c = e.title,
              d = e.width,
              h = n.hoverAnnotationText,
              f = n.hoveredFeatureIndex,
              p = n.selectedRange,
              m = -1,
              g = o.map(function (e, n) {
                var r = u ? n : o.findIndex(function (t) {
                  return 0 === e.label.localeCompare(t.label);
                });
                return m = Math.max(m, r), t.getPlotlyDataObject(e, u, r);
              }),
              v = t.getPlotlyBackgroundBarObject(i || new s.TintedBioblocks1DSection("", 0, o.reduce(function (e, t) {
                return Math.max(e, t.end);
              }, -1), "#b9bcb6"), u, m / 2),
              y = {
                fill: "toself",
                hoverinfo: "none",
                line: {
                  width: 0
                },
                marker: {
                  color: "#f9f69f",
                  opacity: .5
                },
                mode: "lines+markers",
                showlegend: !1,
                x: -1 !== p.start && -1 !== p.end ? [p.start, p.end, p.end, p.start] : [],
                y: [0, 0, m + 1, m + 1]
              },
              b = r.__spread([v, y], g);
            return {
              plotlyData: b,
              plotlyLayout: {
                annotations: t.getAnnotationPlotlyData(f, h, b[f]),
                dragmode: "select",
                height: a,
                hovermode: "closest",
                margin: {
                  b: 30,
                  t: 60
                },
                showlegend: !1,
                title: c,
                width: d,
                xaxis: o.length > 0 ? {
                  autorange: !1,
                  fixedrange: !0,
                  range: [0, l || o.reduce(function (e, t) {
                    return Math.max(e, t.end);
                  }, -1) + 200],
                  showgrid: !1,
                  tick0: 0,
                  tickmode: "auto",
                  ticks: "outside"
                } : {
                  visible: !1
                },
                yaxis: {
                  autorange: !1,
                  fixedrange: !0,
                  range: [-.25, u ? 2 : o.length],
                  visible: !1
                }
              }
            };
          }, t.getBoxForBioblocksSection = function (e) {
            return [e.end - (e.end - e.start) / 2, null, e.start, e.start, e.end, e.end, e.start];
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.width,
              n = e.height,
              r = this.state,
              i = r.plotlyConfig,
              s = r.plotlyData,
              l = r.plotlyLayout;
            return o.createElement("div", {
              style: {
                height: n,
                width: t
              }
            }, o.createElement(a.PlotlyChart, {
              config: i,
              data: s,
              layout: l,
              onClickCallback: this.onFeatureClick,
              onHoverCallback: this.onFeatureHover,
              onSelectedCallback: this.onFeatureSelect,
              showLoader: !1
            }));
          }, t.defaultProps = {
            data: [],
            height: 200,
            showGrouped: !1,
            title: "",
            width: 600
          }, t.getAnnotationPlotlyData = function (e, t, n) {
            return e >= 0 && n.x && n.y ? [{
              align: "left",
              arrowhead: 0,
              arrowsize: 1,
              arrowwidth: 1,
              ax: 0,
              ay: -25,
              bgcolor: "#ffffff",
              bordercolor: "#000000",
              borderpad: 5,
              showarrow: !0,
              text: t,
              x: n.x[0],
              xref: "x",
              y: n.y[n.y.length - 3],
              yref: "y"
            }] : [];
          }, t.getPlotlyBackgroundBarObject = function (e, n, i) {
            return r.__assign(r.__assign({}, t.getPlotlyDataObject(e, n, i)), {
              y: n ? [.25, null, .25, .75, .75, .25, .25] : [i + .5, null, i + 1, i, i, i + 1, i + 1]
            });
          }, t.getPlotlyDataObject = function (e, n, r) {
            return {
              fill: "toself",
              fillcolor: e.color.toString(),
              hoverinfo: "none",
              hoveron: "fills",
              line: {
                width: 0
              },
              mode: "text+lines",
              name: "" + e.label,
              text: [e.label],
              textfont: {
                color: ["#FFFFFF"]
              },
              type: "scatter",
              x: t.getBoxForBioblocksSection(e),
              y: n ? [.5, null, 0, 1, 1, 0, 0] : [r + .5, null, r + 1, r, r, r + 1, r + 1]
            };
          }, t;
        }(o.Component);
      t.FeatureViewer = l;
    },
    "./src/component/NGLComponent.tsx": function srcComponentNGLComponentTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/lodash/lodash.js"),
        o = r.__importStar(n("react")),
        a = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        s = n("./src/component/index.ts"),
        l = n("./src/data/index.ts"),
        u = n("./src/data/AminoAcid.ts"),
        c = n("./src/helper/index.ts");
      t.initialNGLState = {
        activeRepresentations: {
          experimental: {
            reps: new Array(),
            structType: "default"
          },
          predicted: {
            reps: new Array(),
            structType: "cartoon"
          }
        },
        isDistRepEnabled: !0,
        isMovePickEnabled: !1,
        stage: void 0,
        superpositionStatus: "NONE"
      };
      var d = function (e) {
        function n(n) {
          var i = e.call(this, n) || this;
          return i.state = t.initialNGLState, i.prevCanvas = null, i.canvas = null, i.addNewHoveredResidue = function (e, t) {
            var n = i.props,
              r = n.addHoveredResidues,
              o = n.hoveredResidueTooltipTextCb,
              a = e.atom || e.closestBondAtom;
            t.tooltip.textContent = o({
              atom: a,
              pickingProxy: e,
              stage: t
            }), r([a.resno]);
          }, i.canvasRefCallback = function (e) {
            if (i.prevCanvas = i.canvas, i.canvas = e, null === i.prevCanvas && null !== i.canvas && void 0 !== i.state.stage) {
              var t = i.state.stage.viewerControls.getOrientation();
              i.state.stage.removeAllComponents();
              var n = i.props,
                o = n.experimentalProteins,
                a = n.predictedProteins,
                s = i.state.superpositionStatus,
                l = r.__spread(o, a),
                u = i.state.stage.parameters,
                c = i.generateStage(i.canvas, u);
              l.map(function (e) {
                i.initData(c, e.nglStructure);
              }), i.handleSuperposition(c, s), c.viewerControls.orient(t), c.viewer.requestRender(), i.setState({
                stage: c
              });
            }
          }, i.centerCamera = function () {
            var e = i.state.stage;
            e && e.autoView();
          }, i.generateStage = function (e, t) {
            var n = i.props,
              r = n.cameraFov,
              o = n.cameraType,
              a = new c.NGLInstanceManager.instance.Stage(e, t);
            return a.mouseControls.add("hoverPick", function (e, t) {
              i.onHover(e, t);
            }), a.mouseControls.remove("clickPick-*", c.NGLInstanceManager.instance.MouseActions.movePick), a.keyBehavior.domElement.focus = function () {}, a.setParameters({
              cameraFov: r,
              cameraType: o
            }), a;
          }, i.getClearSelectionDockItem = function () {
            return {
              isVisibleCb: function isVisibleCb() {
                return i.props.selectedSecondaryStructures.length >= 1 || Object.values(i.props.lockedResiduePairs).length >= 1 || i.props.candidateResidues.length >= 1;
              },
              onClick: function onClick() {
                i.props.removeAllLockedResiduePairs(), i.props.removeAllSelectedSecondaryStructures(), i.props.removeCandidateResidues(), i.props.removeHoveredResidues();
              },
              text: "Clear Selections"
            };
          }, i.getDockItems = function () {
            var e = "NONE" !== i.state.superpositionStatus;
            return [i.getClearSelectionDockItem(), {
              onClick: i.centerCamera,
              text: "Center View"
            }, {
              isVisibleCb: function isVisibleCb() {
                return i.props.experimentalProteins.length + i.props.predictedProteins.length >= 2;
              },
              onClick: i.onSuperpositionToggle,
              text: "Superimpose: " + (e ? "On" : "Off")
            }, {
              onClick: i.switchCameraType,
              text: (i.state.stage && "stereo" === i.state.stage.parameters.cameraType ? "Disable" : "Enable") + " Stereo"
            }];
          }, i.getRepresentationConfigs = function () {
            var e = ["default", "spacefill", "backbone", "cartoon", "surface", "tube"];
            return {
              "Structure Representations": [{
                current: c.capitalizeFirstLetter(i.state.activeRepresentations.predicted.structType),
                name: "Predicted Structure Representation",
                onChange: function onChange(t) {
                  var n = i.props.predictedProteins,
                    o = i.state,
                    a = o.activeRepresentations,
                    s = o.stage;
                  s && (i.setState({
                    activeRepresentations: r.__assign(r.__assign({}, a), {
                      predicted: i.updateRepresentation(s, e[t], n)
                    })
                  }), s.viewer.requestRender());
                },
                options: ["Rainbow", "Spacefill", "Backbone", "Cartoon", "Surface", "Tube"],
                type: l.CONFIGURATION_COMPONENT_TYPE.RADIO
              }, {
                current: c.capitalizeFirstLetter(i.state.activeRepresentations.experimental.structType),
                name: "Experimental Structure Representation",
                onChange: function onChange(t) {
                  var n = i.props.experimentalProteins,
                    o = i.state,
                    a = o.activeRepresentations,
                    s = o.stage;
                  s && (i.setState({
                    activeRepresentations: r.__assign(r.__assign({}, a), {
                      experimental: i.updateRepresentation(s, e[t], n)
                    })
                  }), s.viewer.requestRender());
                },
                options: ["Rainbow", "Spacefill", "Backbone", "Cartoon", "Surface", "Tube"],
                type: l.CONFIGURATION_COMPONENT_TYPE.RADIO
              }]
            };
          }, i.getSettingsConfigurations = function () {
            var e = i.props.measuredProximity,
              t = i.state,
              n = t.isDistRepEnabled;
            return {
              "View Options": [{
                checked: t.isMovePickEnabled,
                name: "Zoom on Click",
                onChange: i.toggleMovePick,
                type: l.CONFIGURATION_COMPONENT_TYPE.CHECKBOX
              }, {
                checked: n,
                name: "Display Distance in Ångström",
                onChange: i.toggleDistRep,
                type: l.CONFIGURATION_COMPONENT_TYPE.CHECKBOX
              }, {
                current: e,
                name: "Proximity Metric",
                onChange: i.measuredProximityHandler,
                options: Object.values(l.CONTACT_DISTANCE_PROXIMITY).map(function (e) {
                  return c.capitalizeEveryWord(e);
                }),
                type: l.CONFIGURATION_COMPONENT_TYPE.RADIO
              }]
            };
          }, i.handleAtomClick = function (e) {
            var t,
              n = i.props,
              o = n.addLockedResiduePair,
              a = n.addCandidateResidues,
              s = n.candidateResidues,
              l = n.removeCandidateResidues,
              u = e.atom || e.closestBondAtom;
            s.length >= 1 ? (o(((t = {})[r.__spread(s, [u.resno]).sort().toString()] = r.__spread(s, [u.resno]), t)), l()) : a([u.resno]);
          }, i.handleBothSuperposition = function (e) {
            for (var t, n, i = 1; i < e.compList.length; ++i) c.NGLInstanceManager.instance.superpose(e.compList[i].object, e.compList[0].object, !0);
            try {
              for (var o = r.__values(e.compList), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                s.setPosition([0, 0, 0]), s.updateRepresentations({
                  position: !0
                });
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            e.compList[0] ? e.compList[0].autoView() : e.autoView();
          }, i.handleClickHover = function (e) {
            i.props.hoveredResidues.forEach(function (t) {
              i.handleHoveredDistances(t, e);
            });
          }, i.handleClickPick = function (e) {
            var t = i.props,
              n = t.removeLockedResiduePair,
              r = t.onResidueClick;
            e.picker && "distance" === e.picker.type ? n([e.distance.atom1.resno, e.distance.atom2.resno].sort().toString()) : (e.atom || e.closestBondAtom) && i.handleAtomClick(e);
            r(e);
          }, i.handleHoveredDistances = function (e, t) {
            var n,
              o,
              a = i.props,
              s = a.addLockedResiduePair,
              l = a.candidateResidues,
              u = a.removeCandidateResidues,
              c = a.removeNonLockedResidues,
              d = t.stage.mouseObserver,
              h = d.down,
              f = d.canvasPosition,
              p = d.position,
              m = [h, f, d.prevClickCP, d.prevPosition, p].map(function (n) {
                return function (n, r) {
                  for (var i = Number.MAX_SAFE_INTEGER, o = n.atomOffset[e], a = n.atomCount[e], s = 0; s < a; ++s) {
                    var l = t.structure.getAtomProxy(o + s),
                      u = t.stage.viewerControls.getPositionOnCanvas(l.positionToVector3());
                    i = Math.min(i, r.distanceTo(u));
                  }
                  return i;
                }(t.structure.residueStore, n);
              });
            (void 0 === o && (o = 100), m.filter(function (e) {
              return e < o;
            }).length >= 1) ? (s(((n = {})[r.__spread(l, [e]).sort().toString()] = r.__spread(l, [e]), n)), u()) : c();
          }, i.handleStructureClick = function (e, t) {
            var n = i.props,
              r = n.candidateResidues,
              o = n.hoveredResidues,
              a = n.removeNonLockedResidues;
            t ? i.handleClickPick(t) : r.length >= 1 && o.length >= 1 ? i.handleClickHover(e) : a();
          }, i.isExperimentalStructure = function (e) {
            return !i.props.predictedProteins.find(function (t) {
              return t.path === e.object.path;
            });
          }, i.isHighlightUpdateNeeded = function (e, t) {
            var n = i.props,
              r = n.candidateResidues,
              o = n.hoveredResidues,
              a = n.hoveredSecondaryStructures,
              s = n.lockedResiduePairs,
              l = n.measuredProximity,
              u = n.selectedSecondaryStructures,
              c = i.state.isDistRepEnabled;
            return r !== e.candidateResidues || o !== e.hoveredResidues || a !== e.hoveredSecondaryStructures || c !== t.isDistRepEnabled || s !== e.lockedResiduePairs || l !== e.measuredProximity || u !== e.selectedSecondaryStructures;
          }, i.measuredProximityHandler = function (e) {
            var t = i.props.onMeasuredProximityChange;
            t && t(e);
          }, i.onCanvasLeave = function () {
            (0, i.props.removeNonLockedResidues)();
          }, i.onClick = function (e) {
            var t,
              n,
              o = i.state.stage,
              a = i.props,
              s = a.candidateResidues,
              l = a.hoveredResidues,
              u = a.removeNonLockedResidues;
            if (o) if (e) i.handleClickPick(e);else if (s.length >= 1 && l.length >= 1) try {
              for (var c = r.__values(o.compList), d = c.next(); !d.done; d = c.next()) {
                var h = d.value;
                i.handleClickHover(h);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                d && !d.done && (n = c.return) && n.call(c);
              } finally {
                if (t) throw t.error;
              }
            } else u();
          }, i.onKeyDown = function (e) {
            e.preventDefault();
            27 !== e.which && 27 !== e.keyCode || (0, i.props.removeNonLockedResidues)();
          }, i.onResizeHandler = function (e) {
            var t = i.props.onResize,
              n = i.state.stage;
            n && n.handleResize(), t && t(e);
          }, i.onSuperpositionToggle = function (e) {
            "NONE" === i.state.superpositionStatus ? i.setState({
              superpositionStatus: "BOTH"
            }) : i.setState({
              superpositionStatus: "NONE"
            });
          }, i.switchCameraType = function () {
            var e = i.props.cameraFov,
              t = i.state.stage;
            t && ("stereo" === t.parameters.cameraType ? t.setParameters({
              cameraType: "perspective"
            }) : t.setParameters({
              cameraFov: e,
              cameraType: "stereo"
            }), i.forceUpdate());
          }, i.toggleDistRep = function (e) {
            var t = i.state.isDistRepEnabled;
            i.setState({
              isDistRepEnabled: !t
            });
          }, i.toggleMovePick = function (e) {
            var t = i.state,
              n = t.isMovePickEnabled,
              r = t.stage;
            r && (n ? r.mouseControls.remove("clickPick-*", c.NGLInstanceManager.instance.MouseActions.movePick) : r.mouseControls.add("clickPick-left", c.NGLInstanceManager.instance.MouseActions.movePick), i.setState({
              isMovePickEnabled: !n
            }));
          }, i.updateRepresentation = function (e, t, n) {
            var o,
              a,
              s = {
                reps: new Array(),
                structType: t
              },
              l = function l(o) {
                var a;
                n.find(function (e) {
                  return e.path === o.object.path;
                }) && (o.removeAllRepresentations(), "default" === t ? e.defaultFileRepresentation(o) : o.addRepresentation(t), (a = s.reps).push.apply(a, r.__spread(i.deriveActiveRepresentations(o))));
              };
            try {
              for (var u = r.__values(e.compList), c = u.next(); !c.done; c = u.next()) {
                l(c.value);
              }
            } catch (e) {
              o = {
                error: e
              };
            } finally {
              try {
                c && !c.done && (a = u.return) && a.call(u);
              } finally {
                if (o) throw o.error;
              }
            }
            return s;
          }, i;
        }
        return r.__extends(n, e), n.prototype.componentDidMount = function () {
          var e = this,
            t = this.props,
            n = t.backgroundColor,
            i = t.experimentalProteins,
            o = t.predictedProteins;
          if (this.canvas) {
            var a = this.generateStage(this.canvas, {
              backgroundColor: n
            });
            a.removeAllComponents(), r.__spread(i, o).map(function (t) {
              e.initData(a, t.nglStructure);
            }), this.setState({
              stage: a
            });
          }
          window.addEventListener("resize", this.onResizeHandler, !1);
        }, n.prototype.componentWillUnmount = function () {
          var e = this.state.stage;
          e && (e.viewer.renderer.forceContextLoss(), e.dispose(), this.setState({
            activeRepresentations: t.initialNGLState.activeRepresentations,
            stage: void 0
          })), window.removeEventListener("resize", this.onResizeHandler);
        }, n.prototype.componentDidUpdate = function (e, t) {
          var n = this,
            i = this.props,
            o = i.cameraFov,
            a = i.cameraType,
            s = i.experimentalProteins,
            u = i.predictedProteins,
            c = this.state,
            d = c.stage,
            h = c.superpositionStatus,
            f = r.__spread(s, u),
            p = !l.BioblocksPDB.arePDBArraysEqual(e.experimentalProteins, s) || !l.BioblocksPDB.arePDBArraysEqual(e.predictedProteins, u);
          d && p && (d.removeAllComponents(), f.map(function (e) {
            n.initData(d, e.nglStructure);
          }), this.handleSuperposition(d, h)), d && d.compList.length >= 1 && (h !== t.superpositionStatus && this.handleSuperposition(d, h), this.isHighlightUpdateNeeded(e, t) && this.setState({
            activeRepresentations: r.__assign({}, this.handleRepresentationUpdate(d))
          }), d.viewer.requestRender()), d && a !== e.cameraType && d.setParameters({
            cameraType: a
          }), d && "stereo" === d.parameters.cameraType && o !== e.cameraFov && d.setParameters({
            cameraFov: o
          });
        }, n.prototype.render = function () {
          var e = this.props,
            t = e.cardProps,
            n = e.experimentalProteins,
            i = e.height,
            l = e.isDataLoading,
            u = e.menuItems,
            c = e.predictedProteins,
            d = e.style,
            h = e.width,
            f = r.__assign(r.__assign({}, d), {
              height: i,
              width: h
            });
          return o.createElement(s.ComponentCard, r.__assign({}, r.__assign({
            componentName: "NGL Viewer",
            dockItems: this.getDockItems(),
            isDataReady: n.length >= 1 || c.length >= 1,
            menuItems: r.__spread(u, [{
              component: {
                configs: r.__assign(r.__assign({}, this.getSettingsConfigurations()), this.getRepresentationConfigs()),
                name: "POPUP",
                props: {
                  position: "top center"
                }
              },
              description: "Settings"
            }])
          }, t)), o.createElement("div", {
            className: "NGLComponent",
            style: f
          }, o.createElement(a.Dimmer, {
            active: l
          }, o.createElement(a.Loader, null)), o.createElement("div", {
            className: "NGLCanvas",
            onKeyDown: this.onKeyDown,
            onMouseLeave: this.onCanvasLeave,
            ref: this.canvasRefCallback,
            role: "img",
            style: {
              height: "100%",
              width: "100%"
            }
          })));
        }, n.prototype.addStructureToStage = function (e, t) {
          var n = t.addComponentFromObject(e),
            i = this.props.predictedProteins,
            o = this.state.activeRepresentations;
          t.signals.clicked.add(this.onClick), i.find(function (e) {
            return e.nglStructure.path === n.object.path;
          }) ? ("default" === o.predicted.structType ? t.defaultFileRepresentation(n) : n.addRepresentation(o.predicted.structType), this.setState({
            activeRepresentations: {
              experimental: r.__assign({}, o.experimental),
              predicted: r.__assign(r.__assign({}, o.predicted), {
                reps: r.__spread(this.deriveActiveRepresentations(n))
              })
            }
          })) : ("default" === o.experimental.structType ? t.defaultFileRepresentation(n) : n.addRepresentation(o.experimental.structType), this.setState({
            activeRepresentations: {
              experimental: r.__assign(r.__assign({}, o.experimental), {
                reps: r.__spread(this.deriveActiveRepresentations(n))
              }),
              predicted: r.__assign({}, o.predicted)
            }
          })), t.viewer.requestRender();
        }, n.prototype.deriveActiveRepresentations = function (e) {
          var t = this.props,
            n = t.candidateResidues,
            i = t.hoveredResidues,
            o = t.hoveredSecondaryStructures,
            a = t.lockedResiduePairs,
            s = t.selectedSecondaryStructures;
          return r.__spread(this.highlightCandidateResidues(e, r.__spread(n, i).filter(function (e, t, n) {
            return n.indexOf(e) === t;
          }).sort()), this.highlightLockedDistancePairs(e, a), this.highlightSecondaryStructures(e, r.__spread(o, s)));
        }, n.prototype.getDistanceRepForResidues = function (e, t) {
          var n = this.props,
            i = n.experimentalProteins,
            o = n.predictedProteins,
            a = n.measuredProximity,
            s = this.state.isDistRepEnabled,
            u = r.__spread(i, o).find(function (t) {
              return t.nglStructure.name === e.name;
            });
          if (a === l.CONTACT_DISTANCE_PROXIMITY.C_ALPHA) return c.createDistanceRepresentation(e, t.join(".CA, ") + ".CA", s);
          if (u) {
            var d = u.getMinDistBetweenResidues(t[0], t[1]),
              h = d.atomIndexI,
              f = d.atomIndexJ;
            return c.createDistanceRepresentation(e, [h, f], s);
          }
        }, n.prototype.handleRepresentationUpdate = function (e) {
          var t,
            n,
            i,
            o,
            a,
            s,
            l = this.state.activeRepresentations,
            u = {
              experimental: {
                reps: new Array(),
                structType: l.experimental.structType
              },
              predicted: {
                reps: new Array(),
                structType: l.predicted.structType
              }
            };
          try {
            for (var c = r.__values(e.compList), d = c.next(); !d.done; d = c.next()) {
              var h = d.value;
              if (h) {
                var f = this.isExperimentalStructure(h);
                try {
                  for (var p = (i = void 0, r.__values(r.__spread(l.experimental.reps, l.predicted.reps))), m = p.next(); !m.done; m = p.next()) {
                    var g = m.value;
                    h.reprList.includes(g) && h.removeRepresentation(g);
                  }
                } catch (e) {
                  i = {
                    error: e
                  };
                } finally {
                  try {
                    m && !m.done && (o = p.return) && o.call(p);
                  } finally {
                    if (i) throw i.error;
                  }
                }
                f ? (a = u.experimental.reps).push.apply(a, r.__spread(this.deriveActiveRepresentations(h))) : (s = u.predicted.reps).push.apply(s, r.__spread(this.deriveActiveRepresentations(h)));
              }
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              d && !d.done && (n = c.return) && n.call(c);
            } finally {
              if (t) throw t.error;
            }
          }
          return u;
        }, n.prototype.handleSuperposition = function (e, t) {
          "BOTH" === t ? this.handleBothSuperposition(e) : "NONE" === t && (e.compList.forEach(function (e, t) {
            e.setPosition([50 * t, 0, 0]), e.updateRepresentations({
              position: !0
            });
          }), e.autoView());
        }, n.prototype.highlightCandidateResidues = function (e, t) {
          var n = new Array();
          if (t.length >= 1 && (n.push(c.createBallStickRepresentation(e, t)), t.length >= 2)) {
            var r = this.getDistanceRepForResidues(e, t);
            r && n.push(r);
          }
          return n;
        }, n.prototype.highlightLockedDistancePairs = function (e, t) {
          var n,
            i,
            o = new Array();
          try {
            for (var a = r.__values(Object.values(t)), s = a.next(); !s.done; s = a.next()) {
              var l = s.value;
              if (o.push(c.createBallStickRepresentation(e, l)), l.length >= 2) {
                var u = this.getDistanceRepForResidues(e, l);
                u && o.push(u);
              }
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (i = a.return) && i.call(a);
            } finally {
              if (n) throw n.error;
            }
          }
          return o;
        }, n.prototype.highlightSecondaryStructures = function (e, t) {
          var n,
            i,
            o = new Array();
          try {
            for (var a = r.__values(t), s = a.next(); !s.done; s = a.next()) {
              var l = s.value;
              o.push(c.createSecStructRepresentation(e, l));
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (i = a.return) && i.call(a);
            } finally {
              if (n) throw n.error;
            }
          }
          return o;
        }, n.prototype.initData = function (e, t) {
          t && this.addStructureToStage(i.cloneDeep(t), e), e.viewer.requestRender();
        }, n.prototype.onHover = function (e, t) {
          var n = this.props,
            r = n.candidateResidues,
            i = n.hoveredResidues,
            o = n.removeHoveredResidues,
            a = this.state.stage;
          a && (t && (t.atom || t.closestBondAtom) ? this.addNewHoveredResidue(t, a) : 0 === r.length && 0 !== i.length && o());
        }, n.defaultProps = {
          addCandidateResidues: c.EMPTY_FUNCTION,
          addHoveredResidues: c.EMPTY_FUNCTION,
          addLockedResiduePair: c.EMPTY_FUNCTION,
          backgroundColor: "#ffffff",
          cameraFov: 65,
          cameraType: "perspective",
          candidateResidues: [],
          cardProps: {},
          experimentalProteins: [],
          height: "92%",
          hoveredResidueTooltipTextCb: function hoveredResidueTooltipTextCb(e) {
            var t = e.atom,
              n = u.AminoAcid.fromThreeLetterCode(t.resname);
            return "" + (n ? n.singleLetterCode : t.resname) + t.resno;
          },
          hoveredResidues: [],
          hoveredSecondaryStructures: [],
          isDataLoading: !1,
          lockedResiduePairs: {},
          measuredProximity: l.CONTACT_DISTANCE_PROXIMITY.C_ALPHA,
          menuItems: [],
          onMeasuredProximityChange: c.EMPTY_FUNCTION,
          onResidueClick: c.EMPTY_FUNCTION,
          onResize: c.EMPTY_FUNCTION,
          predictedProteins: [],
          removeAllLockedResiduePairs: c.EMPTY_FUNCTION,
          removeAllSelectedSecondaryStructures: c.EMPTY_FUNCTION,
          removeCandidateResidues: c.EMPTY_FUNCTION,
          removeHoveredResidues: c.EMPTY_FUNCTION,
          removeLockedResiduePair: c.EMPTY_FUNCTION,
          removeNonLockedResidues: c.EMPTY_FUNCTION,
          selectedSecondaryStructures: [],
          width: "100%"
        }, n;
      }(o.Component);
      t.NGLComponent = d;
    },
    "./src/component/TensorTComponent.tsx": function srcComponentTensorTComponentTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./src/component/index.ts"),
        a = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.getPlotlyCoordsFromTsne = function (e) {
              var t = n.props,
                r = t.currentCells;
              return [{
                marker: {
                  color: t.pointColor
                },
                mode: "markers",
                type: "scattergl",
                x: e.map(function (e) {
                  return e[0];
                }),
                y: e.map(function (e) {
                  return e[1];
                })
              }, {
                marker: {
                  color: n.props.pointColor,
                  line: {
                    color: "#ffaa00",
                    width: 2
                  }
                },
                mode: "markers",
                type: "scattergl",
                x: r.map(function (t) {
                  return e[t][0];
                }),
                y: r.map(function (t) {
                  return e[t][1];
                })
              }];
            }, n;
          }
          return r.__extends(t, e), t.prototype.render = function () {
            var e = this.props,
              t = e.onSelectedCallback,
              n = e.coordsArray;
            return i.createElement(o.PlotlyChart, {
              data: this.getPlotlyCoordsFromTsne(n),
              layout: r.__assign(r.__assign({}, o.defaultPlotlyLayout), {
                dragmode: "select",
                margin: {
                  b: 20
                },
                xaxis: {
                  autorange: !1,
                  range: [0, 1],
                  showline: !0
                },
                yaxis: {
                  autorange: !1,
                  range: [0, 1],
                  showline: !0
                }
              }),
              onSelectedCallback: t
            });
          }, t.defaultProps = {
            coordsArray: [],
            currentCells: [],
            pointColor: "#aa0000",
            pointsToPlot: []
          }, t;
        }(i.Component);
      t.TensorTComponent = function (e) {
        return i.createElement(a, r.__assign({}, e));
      };
    },
    "./src/component/UMAPVisualization.tsx": function srcComponentUMAPVisualizationTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("react")),
        a = n("./node_modules/umap-js/dist/index.js"),
        s = n("./node_modules/umap-js/dist/umap.js"),
        l = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        u = n("./src/component/index.ts"),
        c = n("./src/data/index.ts"),
        d = n("./src/helper/index.ts"),
        h = function (e) {
          function t(n) {
            var i = e.call(this, n) || this;
            return i.getLegendStats = function () {
              var e = i.state.plotlyData;
              return {
                legendWidth: document.getElementsByClassName("legend")[0] ? 200 : 0,
                showLegend: e.filter(function (e) {
                  return "selected" !== e.name;
                }).length >= 2 || 1 === e.length && (void 0 === e[0].name || void 0 !== e[0].name && !e[0].name.includes("Unannotated"))
              };
            }, i.render2D = function (e, t) {
              var n = i.state,
                a = n.currentEpoch,
                s = n.ranges,
                l = n.totalNumberEpochs;
              return o.createElement(u.PlotlyChart, {
                layout: r.__assign(r.__assign({}, u.defaultPlotlyLayout), {
                  dragmode: "select",
                  legend: {
                    itemdoubleclick: !1,
                    traceorder: "grouped",
                    x: 1,
                    y: .95
                  },
                  margin: {
                    b: 50,
                    l: 40
                  },
                  showlegend: e,
                  xaxis: {
                    autorange: !1,
                    range: [Math.floor(s.minX), Math.ceil(s.maxX)],
                    title: "Dim 1",
                    titlefont: {
                      size: 12
                    }
                  },
                  yaxis: {
                    autorange: !1,
                    range: [Math.floor(s.minY), Math.ceil(s.maxY)],
                    title: "Dim 2",
                    titlefont: {
                      size: 12
                    }
                  }
                }),
                data: t,
                onLegendClickCallback: i.onLegendClick,
                onSelectedCallback: a === l ? i.handlePointSelection : d.EMPTY_FUNCTION,
                showLoader: !0
              });
            }, i.render3D = function (e, t) {
              var n = i.state,
                a = n.currentEpoch,
                s = n.totalNumberEpochs,
                l = n.dragMode,
                c = n.ranges;
              return o.createElement(u.PlotlyChart, {
                config: r.__assign(r.__assign({}, u.defaultPlotlyConfig), {
                  displayModeBar: !1,
                  displaylogo: !1,
                  scrollZoom: !0
                }),
                layout: r.__assign(r.__assign({}, u.defaultPlotlyLayout), {
                  dragmode: l,
                  legend: {
                    itemdoubleclick: !1,
                    traceorder: "grouped",
                    x: .85,
                    y: .95
                  },
                  margin: {
                    b: 10,
                    l: 0,
                    r: 5
                  },
                  scene: {
                    aspectmode: "cube",
                    xaxis: {
                      autorange: !1,
                      range: [Math.floor(c.minX), Math.ceil(c.maxX)],
                      title: "Dim 1"
                    },
                    yaxis: {
                      autorange: !1,
                      range: [Math.floor(c.minY), Math.ceil(c.maxY)],
                      title: "Dim 2"
                    },
                    zaxis: {
                      autorange: !1,
                      range: [Math.floor(c.minZ), Math.ceil(c.maxZ)],
                      title: "Dim 3"
                    }
                  },
                  showlegend: e
                }),
                data: t,
                onLegendClickCallback: i.onLegendClick,
                onSelectedCallback: a === s ? i.handlePointSelection : d.EMPTY_FUNCTION,
                showLoader: !0
              });
            }, i.getData = function (e, t, n) {
              void 0 === t && (t = []), void 0 === n && (n = []);
              var o = e.length > 0 && e[0].length > 2 ? i.getData3D(e, t, n) : i.getData2D(e, t, n),
                a = Object.values(o),
                s = -1 === a.findIndex(function (e) {
                  return "Unannotated" === e.legendgroup;
                }) ? [] : a.splice(a.findIndex(function (e) {
                  return "Unannotated" === e.legendgroup;
                }), 1),
                l = -1 === a.findIndex(function (e) {
                  return "Not Styled" === e.legendgroup;
                }) ? [] : a.splice(a.findIndex(function (e) {
                  return "Not Styled" === e.legendgroup;
                }), 1),
                u = -1 === a.findIndex(function (e) {
                  return "selected" === e.name;
                }) ? [] : a.splice(a.findIndex(function (e) {
                  return "selected" === e.name;
                }), 1),
                c = i.state.dataVisibility;
              return r.__spread(l.map(function (e, t) {
                return e.visible = void 0 === c[t] || !0 === c[t] || "legendonly", e;
              }), a.sort(function (e, t) {
                return t.x.length - e.x.length;
              }).map(function (e, t) {
                if (e.visible = void 0 === c[t + l.length] || !0 === c[t + l.length] || "legendonly", e.name.length > 20) {
                  var n = e.name.lastIndexOf("("),
                    r = e.name.slice(n);
                  e.name = e.name.length - r.length - 1 > 20 ? e.name.slice(0, 20 - r.length + 1) + "... " + r : e.name;
                }
                return e;
              }), u.map(function (e, t) {
                return e.visible = void 0 === c[t + l.length + a.length] || !0 === c[t + l.length + a.length] || "legendonly", e;
              }), s.map(function (e, t) {
                return e.visible = void 0 === c[t + l.length + a.length + u.length] || !0 === c[t + l.length + a.length + u.length] || "legendonly", e;
              }));
            }, i.getData2D = function (e, t, n) {
              void 0 === t && (t = []), void 0 === n && (n = []);
              var r = i.props.currentCells,
                o = {
                  hoverinfo: "none",
                  marker: {
                    color: "#ff0000",
                    size: 8,
                    symbol: "circle-open"
                  },
                  mode: "markers",
                  name: "selected",
                  showlegend: !1,
                  type: "scattergl",
                  x: new Array(),
                  y: new Array()
                },
                a = e.reduce(function (e, i, a) {
                  var s = t[a];
                  s ? 0 === s.color.length && (s = {
                    color: "gray",
                    lineColor: "yellow",
                    name: "Not Styled"
                  }) : s = {
                    color: "gray",
                    name: "Unannotated"
                  };
                  var l = s.color,
                    u = s.name;
                  return e[u] ? (e[u].text.push(n[a]), e[u].x.push(i[0]), e[u].y.push(i[1]), e[u].name = u + " (" + e[u].x.length + ")") : e[u] = {
                    hoverinfo: "none",
                    hovertemplate: "%{data.name}<br>%{text}<extra></extra>",
                    legendgroup: "Unannotated" === u ? "Unannotated" : "Not Styled" === u ? "Not Styled" : "Annotated",
                    marker: {
                      color: l || "gray",
                      line: s.lineColor ? {
                        color: s.lineColor,
                        width: 1
                      } : void 0
                    },
                    mode: "markers",
                    name: u + " (1)",
                    text: [n[a]],
                    type: "scattergl",
                    x: [i[0]],
                    y: [i[1]]
                  }, r.contains(a) && (o.x.push(i[0]), o.y.push(i[1])), e;
                }, {});
              return a.BB_HIGHLIGHTED = o, a;
            }, i.getData3D = function (e, t, n) {
              void 0 === t && (t = []), void 0 === n && (n = []);
              var r = i.props.currentCells,
                o = {
                  hoverinfo: "none",
                  marker: {
                    color: "#ff0000",
                    size: 2,
                    symbol: "dot-open"
                  },
                  mode: "markers",
                  name: "selected",
                  showlegend: !1,
                  type: "scatter3d",
                  x: new Array(),
                  y: new Array(),
                  z: new Array()
                },
                a = e.reduce(function (e, i, a) {
                  var s = t[a];
                  s ? 0 === s.color.length && (s = {
                    color: "gray",
                    lineColor: "yellow",
                    name: "Not Styled"
                  }) : s = {
                    color: "gray",
                    name: "Unannotated"
                  };
                  var l = s.color,
                    u = s.name;
                  return e[u] ? (e[u].text.push(n[a]), e[u].x.push(i[0]), e[u].y.push(i[1]), e[u].z.push(i[2]), e[u].name = u + " (" + (e[u].x.length + 1) + ")") : e[u] = {
                    hoverinfo: "none",
                    hovertemplate: "%{data.name}<br>%{text}<extra></extra>",
                    legendgroup: "Unannotated" === u ? "Unannotated" : "Not Styled" === u ? "Not Styled" : "Annotated",
                    marker: {
                      color: l || "gray",
                      line: s.lineColor ? {
                        color: s.lineColor,
                        width: 1
                      } : void 0,
                      size: 4
                    },
                    mode: "markers",
                    name: u + " (1)",
                    text: [n[a]],
                    type: "scatter3d",
                    x: [i[0]],
                    y: [i[1]],
                    z: [i[2]]
                  }, r.contains(a) && (o.x.push(i[0]), o.y.push(i[1]), o.z.push(i[2])), e;
                }, {});
              return a.BB_HIGHLIGHTED = o, a;
            }, i.get3DMenuItems = function () {
              var e = i.state,
                t = e.currentEpoch,
                n = e.dragMode,
                r = e.totalNumberEpochs,
                o = void 0 === t || void 0 === r || t < r;
              return [{
                component: {
                  name: "BUTTON",
                  onClick: o ? d.EMPTY_FUNCTION : i.onZoomClick,
                  props: {
                    active: "zoom" === n,
                    disabled: o
                  }
                },
                description: "Zoom",
                iconName: "zoom"
              }, {
                component: {
                  name: "BUTTON",
                  onClick: o ? d.EMPTY_FUNCTION : i.onPanClick,
                  props: {
                    active: "pan" === n,
                    disabled: o
                  }
                },
                description: "Pan",
                iconName: "arrows alternate"
              }, {
                component: {
                  name: "BUTTON",
                  onClick: o ? d.EMPTY_FUNCTION : i.onOrbitClick,
                  props: {
                    active: "orbit" === n,
                    disabled: o
                  }
                },
                description: "Orbit",
                iconName: "sync alternate"
              }, {
                component: {
                  name: "BUTTON",
                  onClick: o ? d.EMPTY_FUNCTION : i.onTurntableClick,
                  props: {
                    active: "turntable" === n,
                    disabled: o
                  }
                },
                description: "Turntable",
                iconName: "weight"
              }];
            }, i.getMenuItems = function () {
              var e = i.state.umapEmbedding,
                t = [{
                  component: {
                    configs: i.getSettingsConfigs(),
                    name: "POPUP",
                    props: {
                      disabled: 0 === e.length,
                      position: "top center",
                      wide: !1
                    }
                  },
                  description: "Settings"
                }];
              return e.length >= 1 && 3 === e[0].length && t.push.apply(t, r.__spread(i.get3DMenuItems())), t;
            }, i.getSettingsConfigs = function () {
              var e = i.state,
                t = e.numDimensions,
                n = e.numMinDist,
                r = e.numNeighbors,
                o = e.numSpread;
              return {
                Settings: [{
                  marks: {
                    0: "0",
                    5: "5"
                  },
                  name: "Min Dist",
                  onChange: i.onMinDistChange,
                  step: .01,
                  type: c.CONFIGURATION_COMPONENT_TYPE.SLIDER,
                  values: {
                    current: n,
                    defaultValue: .99,
                    max: 5,
                    min: 0
                  }
                }, {
                  marks: {
                    0: "0",
                    30: "30"
                  },
                  name: "Neighbors",
                  onChange: i.onNumNeighborsChange,
                  step: 1,
                  type: c.CONFIGURATION_COMPONENT_TYPE.SLIDER,
                  values: {
                    current: r,
                    defaultValue: 15,
                    max: 30,
                    min: 0
                  }
                }, {
                  marks: {
                    0: "0",
                    10: "10"
                  },
                  name: "Spread",
                  onChange: i.onSpreadChange,
                  step: 1,
                  type: c.CONFIGURATION_COMPONENT_TYPE.SLIDER,
                  values: {
                    current: o,
                    defaultValue: 1,
                    max: 10,
                    min: 0
                  }
                }, {
                  current: t.toString(),
                  name: "Dimensions",
                  onChange: i.onDimensionChange,
                  options: ["2", "3"],
                  type: c.CONFIGURATION_COMPONENT_TYPE.RADIO
                }, {
                  name: "Re-Run UMAP",
                  onClick: i.executeUMAP,
                  type: c.CONFIGURATION_COMPONENT_TYPE.BUTTON
                }]
              };
            }, i.handlePointSelection = function (e) {
              for (var t = i.props.setCurrentCells, n = i.state.umapEmbedding, r = new Array(), o = function o(t) {
                  var i = e.selectedPoints[t],
                    o = e.selectedPoints[t + 1],
                    a = n.findIndex(function (e) {
                      return e[0] === i && e[1] === o;
                    });
                  a >= 0 && r.push(a);
                }, a = 0; a < e.selectedPoints.length - 1; a += 2) o(a);
              t(r);
            }, i.renderCategoryDropdown = function () {
              var e = i.props,
                t = e.currentLabel,
                n = e.labels;
              return n.length >= 1 && o.createElement("div", {
                style: {
                  float: "right",
                  fontSize: "14px",
                  paddingRight: "5px",
                  position: "relative",
                  width: "30%",
                  zIndex: 777
                }
              }, "Annotation:", " ", o.createElement(l.Dropdown, {
                direction: "right",
                fluid: !1,
                inline: !0,
                onChange: i.onLabelChange,
                options: n.map(function (e) {
                  return {
                    text: e,
                    value: e
                  };
                }),
                text: t
              }), " ");
            }, i.onDimensionChange = function (e) {
              i.setState({
                numDimensions: 0 === e ? 2 : 3
              });
            }, i.onLabelChange = function (e, t) {
              var n = i.props.onLabelChange;
              i.setState({
                dataVisibility: {}
              }), n(e, t);
            }, i.onMinDistChange = function (e) {
              i.setState({
                numMinDist: e
              });
            }, i.onNumNeighborsChange = function (e) {
              i.setState({
                numNeighbors: e
              });
            }, i.onOrbitClick = function () {
              i.setState({
                dragMode: "orbit"
              });
            }, i.onPanClick = function () {
              i.setState({
                dragMode: "pan"
              });
            }, i.onSpreadChange = function (e) {
              i.setState({
                numSpread: e
              });
            }, i.onTurntableClick = function () {
              i.setState({
                dragMode: "turntable"
              });
            }, i.onZoomClick = function () {
              i.setState({
                dragMode: "zoom"
              });
            }, i.executeUMAP = function () {
              var e = i.props,
                n = e.dataMatrix,
                o = e.distanceFn;
              clearTimeout(i.timeout1), clearTimeout(i.timeout2), i.setState({
                currentEpoch: void 0,
                plotlyData: new Array(),
                ranges: t.initialState.ranges,
                totalNumberEpochs: void 0,
                umapEmbedding: []
              });
              performance.now();
              i.timeout1 = setTimeout(function () {
                var e = i.state,
                  s = e.numDimensions,
                  l = e.numNeighbors,
                  u = e.numSpread,
                  c = e.numMinDist,
                  d = new a.UMAP({
                    distanceFn: o,
                    minDist: c,
                    nComponents: s,
                    nNeighbors: l,
                    spread: u
                  });
                if (0 !== n.length && 0 !== n[0].length) {
                  var h = d.initializeFit(n),
                    f = function f(e) {
                      if (d.step(), e % i.props.numIterationsBeforeReRender == 0 && e < h) {
                        var n = d.getEmbedding(),
                          o = r.__assign({}, t.initialState.ranges);
                        n.forEach(function (e) {
                          o.maxX = Math.max(o.maxX, e[0] + 2), o.maxY = Math.max(o.maxY, e[1] + 2), o.maxZ = Math.max(o.maxZ, e[2] + 2), o.minX = Math.min(o.minX, e[0] - 2), o.minY = Math.min(o.minY, e[1] - 2), o.minZ = Math.min(o.minZ, e[2] - 2);
                        });
                        var a = i.getData(n, i.props.dataLabels, i.props.tooltipNames);
                        i.setState({
                          currentEpoch: e + 1,
                          plotlyData: a,
                          ranges: o,
                          umapEmbedding: n
                        });
                      }
                      e < h && (i.timeout2 = setTimeout(function () {
                        f(e + 1);
                      }));
                    };
                  i.setState({
                    dataVisibility: {},
                    totalNumberEpochs: h
                  }), f(0);
                }
              });
            }, i.onLegendClick = function (e) {
              var t,
                n = i.props.onLabelChange,
                o = i.state,
                a = o.dataVisibility,
                s = o.plotlyData;
              if ("expandedIndex" in e.plotlyEvent && void 0 !== e.plotlyEvent.expandedIndex) {
                var l = e.plotlyEvent.expandedIndex,
                  u = s[l].name;
                n(u.slice(0, u.lastIndexOf("(") - 1)), i.setState({
                  dataVisibility: r.__assign(r.__assign({}, a), (t = {}, t[l] = void 0 !== a[l] && !a[l], t))
                });
              }
              return !1;
            }, i.state = r.__assign(r.__assign({}, t.initialState), {
              numDimensions: n.nComponents,
              numMinDist: n.minDist,
              numNeighbors: n.nNeighbors,
              numSpread: n.spread
            }), i;
          }
          return r.__extends(t, e), t.prototype.componentDidMount = function () {
            this.executeUMAP();
          }, t.prototype.componentDidUpdate = function (e, t) {
            var n = this.props,
              r = n.currentCells,
              i = n.dataLabels,
              o = n.dataMatrix,
              a = n.distanceFn,
              s = n.minDist,
              l = n.nComponents,
              u = n.nNeighbors,
              c = n.spread,
              h = n.tooltipNames,
              f = this.state,
              p = f.dataVisibility,
              m = f.umapEmbedding;
            a === e.distanceFn && d.areTwoArraysEqual(o, e.dataMatrix) ? i !== e.dataLabels || h !== e.tooltipNames || p !== t.dataVisibility || r !== e.currentCells ? this.setState({
              plotlyData: this.getData(m, i, h)
            }) : l !== e.nComponents ? this.setState({
              numDimensions: l
            }) : c !== e.spread ? this.setState({
              numSpread: c
            }) : s !== e.minDist ? this.setState({
              numMinDist: s
            }) : u !== e.nNeighbors && this.setState({
              numNeighbors: u
            }) : this.executeUMAP();
          }, t.prototype.render = function () {
            var e,
              t = this.props.iconSrc,
              n = this.state,
              r = n.currentEpoch,
              i = n.plotlyData,
              a = n.totalNumberEpochs,
              s = n.umapEmbedding;
            a && r && (e = "epoch " + r + "/" + a);
            var l = this.getLegendStats();
            return o.createElement("div", null, o.createElement(u.ComponentCard, {
              componentName: "UMAP",
              expandedStyle: {
                height: "80vh",
                width: "calc(" + l.legendWidth + "px + 80vh)"
              },
              dockItems: [{
                isLink: !1,
                text: s.length + " sequence" + (1 !== s.length ? "s" : "") + " | " + (e || "")
              }],
              height: "575px",
              iconSrc: t,
              isDataReady: void 0 !== e,
              menuItems: this.getMenuItems(),
              width: l.legendWidth + 535 + "px"
            }, this.renderCategoryDropdown(), s.length >= 1 && 3 === s[0].length ? this.render3D(l.showLegend, i) : this.render2D(l.showLegend, i)));
          }, t.defaultProps = {
            currentCells: i.Set(),
            currentLabel: "",
            distanceFn: s.euclidean,
            errorMessages: [],
            labels: [],
            minDist: .99,
            nComponents: 2,
            nNeighbors: 15,
            numIterationsBeforeReRender: 1,
            onLabelChange: d.EMPTY_FUNCTION,
            setCurrentCells: d.EMPTY_FUNCTION,
            spread: 1
          }, t.initialState = {
            currentEpoch: void 0,
            dataVisibility: {},
            dragMode: "turntable",
            numDimensions: t.defaultProps.nComponents,
            numMinDist: t.defaultProps.minDist,
            numNeighbors: t.defaultProps.nNeighbors,
            numSpread: t.defaultProps.spread,
            plotlyData: new Array(),
            ranges: {
              maxX: -20,
              maxY: -20,
              maxZ: -20,
              minX: 20,
              minY: 20,
              minZ: 20
            },
            totalNumberEpochs: void 0,
            umapEmbedding: new Array(new Array())
          }, t;
        }(o.Component);
      t.UMAPVisualization = h;
    },
    "./src/component/chart/AuxiliaryAxis.ts": function srcComponentChartAuxiliaryAxisTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/helper/index.ts"),
        o = function () {
          function e(e, t, n, o, a) {
            var s = this;
            void 0 === t && (t = 2), void 0 === n && (n = new i.ColorMapper()), void 0 === a && (a = function a() {
              return !1;
            }), this.sections = e, this.axisIndex = t, this.colorMap = n, this.dataTransformFn = o, this.filterFn = a, this.axes = new Map(), this.highlightedAxes = new Map(), this.generateXAxisSegment = function (e) {
              return r.__assign(r.__assign({}, s.auxiliaryAxisDefaults(e)), {
                orientation: "h",
                xaxis: "x",
                yaxis: "y" + s.axisIndex
              });
            }, this.generateHighlightedXAxisSegment = function (e) {
              return r.__assign(r.__assign({}, s.highlightedAuxiliaryAxisDefaults(e)), {
                orientation: "h",
                xaxis: "x",
                yaxis: "y" + s.axisIndex
              });
            }, this.generateYAxisSegment = function (e) {
              return r.__assign(r.__assign({}, s.auxiliaryAxisDefaults(e)), {
                orientation: "v",
                xaxis: "x" + s.axisIndex,
                yaxis: "y"
              });
            }, this.generateHighlightedYAxisSegment = function (e) {
              return r.__assign(r.__assign({}, s.highlightedAuxiliaryAxisDefaults(e)), {
                orientation: "v",
                xaxis: "x" + s.axisIndex,
                yaxis: "y"
              });
            }, this.auxiliaryAxisDefaults = function (e) {
              return {
                connectgaps: !1,
                hoverinfo: "none",
                line: {
                  color: s.colorMap.getColorFor(e),
                  shape: "spline",
                  smoothing: 1.3,
                  width: 1.5
                },
                marker: {
                  symbol: []
                },
                mode: "lines",
                name: e,
                showlegend: !1,
                type: "scatter",
                x: [],
                y: []
              };
            }, this.highlightedAuxiliaryAxisDefaults = function (e) {
              return r.__assign(r.__assign({}, s.auxiliaryAxisDefaults(e)), {
                fill: "toself",
                line: {
                  color: s.colorMap.getColorFor(e),
                  width: 0
                }
              });
            }, this.derivePointsInAxis = function (e) {
              for (var t = {
                  main: [e.start],
                  opposite: [null]
                }, n = e.start; n <= e.end; ++n) {
                var r = s.dataTransformFn && s.dataTransformFn[e.label] ? s.dataTransformFn[e.label](e, n) : {
                  main: n,
                  opposite: -1
                };
                t.main.push(r.main), t.opposite.push(r.opposite);
              }
              return t.main.push(e.end), t.opposite.push(null), t;
            }, this.deriveHighlightedPointsInAxis = function (e) {
              var t = {
                main: [e.start],
                opposite: [null]
              };
              return t.main.push(e.start), t.opposite.push(-1), t.main.push(e.start), t.opposite.push(1), t.main.push(e.end), t.opposite.push(1), t.main.push(e.end), t.opposite.push(-1), t.main.push(e.end), t.opposite.push(null), t;
            }, this.setupAuxiliaryAxis();
          }
          return Object.defineProperty(e.prototype, "axis", {
            get: function get() {
              return this.axes;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "xAxes", {
            get: function get() {
              var e = new Array();
              return this.axes.forEach(function (t) {
                e.push(t.x);
              }), e;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "highlightedXAxes", {
            get: function get() {
              var e = new Array();
              return this.highlightedAxes.forEach(function (t) {
                e.push(t.x);
              }), e;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "yAxes", {
            get: function get() {
              var e = new Array();
              return this.axes.forEach(function (t) {
                e.push(t.y);
              }), e;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "highlightedYAxes", {
            get: function get() {
              var e = new Array();
              return this.highlightedAxes.forEach(function (t) {
                e.push(t.y);
              }), e;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.getAxisById = function (e) {
            return this.axes.get(e);
          }, e.prototype.setupAuxiliaryAxis = function () {
            var e, t, n, i, o, a, s, l, u, c;
            try {
              for (var d = r.__values(this.sections), h = d.next(); !h.done; h = d.next()) {
                var f = h.value;
                if (!this.filterFn(f)) {
                  var p = f.label;
                  this.axes.has(p) || this.axes.set(p, {
                    x: this.generateXAxisSegment(p),
                    y: this.generateYAxisSegment(p)
                  }), this.highlightedAxes.has(p) || this.highlightedAxes.set(p, {
                    x: this.generateHighlightedXAxisSegment(p),
                    y: this.generateHighlightedYAxisSegment(p)
                  });
                  var m = this.axes.get(p),
                    g = this.highlightedAxes.get(p);
                  if (m && g) {
                    var v = this.derivePointsInAxis(f);
                    (n = m.x.x).push.apply(n, r.__spread(v.main)), (i = m.x.y).push.apply(i, r.__spread(v.opposite)), (o = m.y.y).push.apply(o, r.__spread(v.main)), (a = m.y.x).push.apply(a, r.__spread(v.opposite));
                    var y = this.deriveHighlightedPointsInAxis(f);
                    (s = g.x.x).push.apply(s, r.__spread(y.main)), (l = g.x.y).push.apply(l, r.__spread(y.opposite)), (u = g.y.y).push.apply(u, r.__spread(y.main)), (c = g.y.x).push.apply(c, r.__spread(y.opposite));
                  }
                }
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (t = d.return) && t.call(d);
              } finally {
                if (e) throw e.error;
              }
            }
          }, e;
        }();
      t.AuxiliaryAxis = o;
    },
    "./src/component/chart/ContactMapChart.tsx": function srcComponentChartContactMapChartTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./src/component/index.ts"),
        a = n("./src/helper/index.ts");
      t.generateChartDataEntry = function (e, t, n, i, o, a, s) {
        return void 0 === s && (s = {}), r.__assign({
          hoverinfo: e,
          marker: "string" == typeof t ? {
            color: new Array(2 * a.length).fill(t)
          } : {
            colorscale: [[0, t.start], [1, t.end]]
          },
          mode: "lines+markers",
          name: n,
          nodeSize: o,
          points: a,
          subtitle: i
        }, s);
      };
      var s = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;
          return n.toggleLegendVisibility = function () {
            n.setState({
              showlegend: !n.state.showlegend
            });
          }, n.state = {
            numLegends: 0,
            plotlyData: [],
            showlegend: !1
          }, n;
        }
        return r.__extends(t, e), t.prototype.componentDidMount = function () {
          this.setupData();
        }, t.prototype.componentDidUpdate = function (e) {
          var t = this.props,
            n = t.contactData,
            r = t.secondaryStructures,
            i = t.selectedSecondaryStructures;
          e.contactData === n && e.secondaryStructures === r && e.selectedSecondaryStructures === i || this.setupData();
        }, t.prototype.render = function () {
          var e = this.props,
            t = (e.configurations, e.contactData, e.isDataLoading),
            n = e.legendModifiers,
            a = e.marginModifiers,
            s = e.range,
            l = (e.showConfigurations, r.__rest(e, ["configurations", "contactData", "isDataLoading", "legendModifiers", "marginModifiers", "range", "showConfigurations"])),
            u = this.state,
            c = u.plotlyData,
            d = u.showlegend;
          return i.createElement(o.PlotlyChart, r.__assign({
            data: c,
            showLoader: t,
            layout: {
              legend: {
                orientation: "h",
                y: n.y,
                yanchor: "bottom"
              },
              margin: {
                b: a.b,
                l: a.l
              },
              showlegend: d,
              xaxis: {
                fixedrange: !0,
                nticks: 10,
                range: [0, s],
                rangemode: "nonnegative",
                showline: !0,
                tickmode: "auto",
                title: "Residue #"
              },
              yaxis: {
                fixedrange: !0,
                nticks: 10,
                range: [s, 0],
                rangemode: "nonnegative",
                showline: !0,
                tickmode: "auto",
                title: "Residue #"
              }
            }
          }, l));
        }, t.prototype.setupData = function () {
          var e = this.props,
            t = e.contactData,
            n = e.dataTransformFn,
            i = e.secondaryStructures,
            s = e.secondaryStructureColors,
            l = e.selectedSecondaryStructures,
            u = r.__spread(t.map(function (e) {
              return n(e, !0);
            }));
          i.forEach(function (e, t) {
            var n = new o.SecondaryStructureAxis(e, 3, t + 2, s);
            u.push.apply(u, r.__spread(n.xAxes, n.yAxes));
          });
          var c = new Array();
          l.forEach(function (e, t) {
            var n = new o.AuxiliaryAxis(e, t + 2, new a.ColorMapper(new Map(), "orange"));
            c.push.apply(c, r.__spread(n.highlightedXAxes, n.highlightedYAxes));
          }), this.setState({
            numLegends: new Set(u.filter(function (e) {
              return !1 !== e.showlegend && void 0 !== e.name;
            }).map(function (e) {
              return e.name;
            })).size,
            plotlyData: r.__spread(c, u)
          });
        }, t.defaultProps = {
          configurations: new Array(),
          dataTransformFn: a.generateScatterGLData,
          height: "100%",
          isDataLoading: !1,
          legendModifiers: {
            y: -.4
          },
          marginModifiers: {
            b: 67,
            l: 67
          },
          range: 33e3,
          secondaryStructures: [],
          selectedSecondaryStructures: [],
          selectedSecondaryStructuresColor: "#feb83f",
          showConfigurations: !0,
          width: "100%"
        }, t;
      }(i.Component);
      t.ContactMapChart = s;
    },
    "./src/component/chart/PlotlyChart.tsx": function srcComponentChartPlotlyChartTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("./node_modules/immutable/dist/immutable.js")),
        o = n("./node_modules/lodash/lodash.js"),
        a = r.__importStar(n("./node_modules/plotly.js-gl3d-dist-min/plotly-gl3d.min.js")),
        s = r.__importStar(n("react")),
        l = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        u = n("./src/data/index.ts");
      t.defaultPlotlyConfig = {
        displayModeBar: !1,
        doubleClick: "reset",
        scrollZoom: !1,
        showAxisDragHandles: !1,
        staticPlot: !1
      }, t.defaultPlotlyLayout = {
        autosize: !0,
        dragmode: "zoom",
        hovermode: "closest",
        legend: {},
        margin: {
          b: 10,
          l: 40,
          r: 10,
          t: 10
        },
        showlegend: !1,
        title: ""
      };
      var c = function (e) {
        function n() {
          var n = null !== e && e.apply(this, arguments) || this;
          return n.plotlyCanvas = null, n.isDoubleClickInProgress = !1, n.canvasRef = null, n.plotlyFormattedData = [], n.draw = function () {
            return r.__awaiter(n, void 0, void 0, function () {
              var e, t, n, i, o, s;
              return r.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this.props, t = e.config, n = e.layout, this.plotlyCanvas && this.canvasRef ? (i = this.getMergedLayout(n, this.plotlyFormattedData), o = this.getMergedConfig(t), this.plotlyFormattedData.forEach(function (e) {
                      return delete e.selectedpoints, e;
                    }), s = this, [4, a.react(this.canvasRef, this.plotlyFormattedData, i, o)]) : [3, 2];
                  case 1:
                    s.plotlyCanvas = r.sent(), r.label = 2;
                  case 2:
                    return [2];
                }
              });
            });
          }, n.resize = function () {
            n.plotlyCanvas && a.Plots.resize(n.plotlyCanvas);
          }, n.deriveChartPiece = function (e, t, n) {
            var r = e,
              i = t;
            if (n) {
              var o = n.xaxis && "x" !== n.xaxis,
                a = n.yaxis && "y" !== n.yaxis;
              if (o || a) return {
                chartPiece: u.BIOBLOCKS_CHART_PIECE.AXIS,
                selectedPoints: o ? [i] : [r]
              };
            }
            return {
              chartPiece: u.BIOBLOCKS_CHART_PIECE.POINT,
              selectedPoints: [r, i]
            };
          }, n.generateExtraPlotlyAxis = function (e) {
            return Array.from(e.values()).filter(function (e) {
              return e.length >= 2;
            }).map(function (e) {
              return n.generateExtraPlotlyAxisFromId(e);
            }).reduce(function (e, t) {
              return r.__assign(r.__assign({}, e), t);
            }, {});
          }, n.getMergedConfig = function (e) {
            void 0 === e && (e = {});
            var n = i.fromJS(r.__assign({}, t.defaultPlotlyConfig)),
              o = i.fromJS(r.__assign({}, e));
            return r.__assign({}, n.mergeDeep(o).toJS());
          }, n.getMergedLayout = function (e, o) {
            void 0 === e && (e = {}), void 0 === o && (o = []);
            var a = i.fromJS(r.__assign({}, e)),
              s = i.fromJS(r.__assign(r.__assign({}, t.defaultPlotlyLayout), n.deriveAxisParams(o))),
              l = r.__assign({}, s.mergeDeep(a).toJS());
            return n.savedAxisZoom && l.xaxis && l.yaxis ? (l.xaxis.range = n.savedAxisZoom.xaxis.range, l.yaxis.range = n.savedAxisZoom.yaxis.range) : n.savedCameraScene && (l.scene = r.__assign(r.__assign({}, l.scene), {
              camera: n.savedCameraScene
            })), l;
          }, n.onAfterPlot = function () {
            var e = n.props.onAfterPlotCallback;
            e && e(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.AFTER_PLOT));
          }, n.onClick = function (e) {
            if (!1 === n.isDoubleClickInProgress && void 0 !== e.points && e.points.length > 0) {
              var t = n.props.onClickCallback;
              if (t) {
                var r = e.points[0].x ? e.points[0].x : e.points[0].data.x[0],
                  i = e.points[0].y ? e.points[0].y : e.points[0].data.y[0],
                  o = n.deriveChartPiece(r, i, e.points[0].data),
                  a = o.chartPiece,
                  s = o.selectedPoints;
                t(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.CLICK, a, s));
              }
            }
          }, n.onDoubleClick = function () {
            n.isDoubleClickInProgress = !0;
            var e = n.props.onDoubleClickCallback;
            e && e(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.DOUBLE_CLICK));
          }, n.onHover = function (e) {
            var t = n.props.onHoverCallback;
            if (e.points && e.points[0] && t) {
              var r = e.points[0].x ? e.points[0].x : e.points[0].data.x[0],
                i = e.points[0].y ? e.points[0].y : e.points[0].data.y[0],
                o = n.deriveChartPiece(r, i, e.points[0].data),
                a = o.chartPiece,
                s = o.selectedPoints;
              t(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.HOVER, a, s));
            }
          }, n.onLegendClick = function (e) {
            var t = n.props.onLegendClickCallback;
            return !!t && t(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.LEGEND_CLICK, u.BIOBLOCKS_CHART_PIECE.LEGEND, [], e));
          }, n.onRelayout = function (e) {
            if (n.isDoubleClickInProgress = !1, void 0 !== e && "scene.camera" in e) n.savedCameraScene = e["scene.camera"];else if (void 0 !== e) {
              var t = ["xaxis.range[0]", "xaxis.range[1]", "yaxis.range[0]", "yaxis.range[1]"],
                r = void 0 !== e && !0 === t.reduce(function (t, n) {
                  return t && void 0 !== e[n];
                }, !0);
              n.savedAxisZoom = r ? {
                xaxis: {
                  autorange: !1,
                  range: [e[t[0]], e[t[1]]]
                },
                yaxis: {
                  autorange: !1,
                  range: [e[t[2]], e[t[3]]]
                }
              } : void 0;
            }
            var i = n.props.onRelayoutCallback;
            i && i(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.RELAYOUT));
          }, n.onSelect = function (e) {
            return r.__awaiter(n, void 0, void 0, function () {
              var t, n, i;
              return r.__generator(this, function (o) {
                switch (o.label) {
                  case 0:
                    return t = this.props.onSelectedCallback, e && t && (n = new Array(), e.points.length >= 1 ? n = e.points.reduce(function (e, t) {
                      return e.push.apply(e, r.__spread([t.x, t.y])), e;
                    }, n) : e.range && n.push(e.range.x[0], e.range.y[0], e.range.x[1], e.range.y[1]), i = (n.length > 0 ? this.deriveChartPiece(n[0], n[1]) : {
                      chartPiece: u.BIOBLOCKS_CHART_PIECE.POINT
                    }).chartPiece, t(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.SELECTION, i, n, e))), [4, this.draw()];
                  case 1:
                    return o.sent(), [2];
                }
              });
            });
          }, n.onUnHover = function (e) {
            var t = n.props.onUnHoverCallback;
            if (e && t) {
              var r = e.points[0],
                i = r.data,
                o = r.x,
                a = r.y,
                s = n.deriveChartPiece(o, a, i),
                l = s.chartPiece,
                c = s.selectedPoints;
              t(new u.BioblocksChartEvent(u.BIOBLOCKS_CHART_EVENT_TYPE.UNHOVER, l, c));
            }
          }, n;
        }
        return r.__extends(n, e), n.prototype.attachListeners = function () {
          this.plotlyCanvas && (this.plotlyCanvas.on("plotly_afterplot", this.onAfterPlot), this.plotlyCanvas.on("plotly_click", this.onClick), this.plotlyCanvas.on("plotly_doubleclick", this.onDoubleClick), this.plotlyCanvas.on("plotly_hover", this.onHover), this.plotlyCanvas.on("plotly_legendclick", this.onLegendClick), this.plotlyCanvas.on("plotly_relayout", this.onRelayout), this.plotlyCanvas.on("plotly_selected", this.onSelect), this.plotlyCanvas.on("plotly_unhover", this.onUnHover)), window.removeEventListener("resize", this.resize), window.addEventListener("resize", this.resize);
        }, n.prototype.componentDidMount = function () {
          return r.__awaiter(this, void 0, void 0, function () {
            var e, t, n;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  return !this.canvasRef || this.plotlyCanvas ? [3, 3] : (e = this.props.data, t = i.fromJS(e), this.plotlyFormattedData = t.toJS(), n = this, [4, a.react(this.canvasRef, this.plotlyFormattedData)]);
                case 1:
                  return n.plotlyCanvas = r.sent(), this.attachListeners(), [4, this.draw()];
                case 2:
                  r.sent(), r.label = 3;
                case 3:
                  return [2];
              }
            });
          });
        }, n.prototype.componentWillUnmount = function () {
          this.renderTimeout && clearTimeout(this.renderTimeout), this.plotlyCanvas && (a.purge(this.plotlyCanvas), this.plotlyCanvas = null, this.canvasRef = null), window.removeEventListener("resize", this.resize);
        }, n.prototype.componentDidUpdate = function (e) {
          return r.__awaiter(this, void 0, void 0, function () {
            var t, n, a, s, l;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  return t = this.props, n = t.data, a = t.layout, s = t.config, (l = n.length === e.data.length) && n.forEach(function (t, n) {
                    o.isEqual(t, e.data[n]) || (l = !1);
                  }), l && o.isEqual(a, e.layout) && o.isEqual(s, e.config) ? [3, 2] : (this.plotlyFormattedData = l ? this.plotlyFormattedData : i.fromJS(n).toJS(), [4, this.draw()]);
                case 1:
                  r.sent(), this.forceUpdate(), r.label = 2;
                case 2:
                  return [2];
              }
            });
          });
        }, n.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.height,
            i = t.showLoader,
            o = t.style,
            a = t.width;
          return s.createElement(s.Fragment, null, i && s.createElement(l.Dimmer, {
            active: !this.isDataLoaded()
          }, s.createElement(l.Loader, null)), s.createElement("div", {
            className: "plotly-chart",
            ref: function ref(t) {
              return e.canvasRef = t || null;
            },
            style: r.__assign(r.__assign({
              marginBottom: 5
            }, o), {
              height: n,
              width: a
            })
          }));
        }, n.prototype.deriveAxisParams = function (e) {
          var t,
            n,
            i = new Set(),
            o = new Set();
          try {
            for (var a = r.__values(e), s = a.next(); !s.done; s = a.next()) {
              var l = s.value,
                u = l.xaxis,
                c = l.yaxis;
              u && i.add(u), c && o.add(c);
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
          return r.__assign(r.__assign(r.__assign({}, this.generateExtraPlotlyAxis(i)), this.generateExtraPlotlyAxis(o)), {
            xaxis: {
              domain: [0, 1 - .05 * i.size],
              zeroline: !1
            },
            yaxis: {
              domain: [0, 1 - .05 * i.size],
              zeroline: !1
            }
          });
        }, n.prototype.generateExtraPlotlyAxisFromId = function (e) {
          var t,
            n = e.substr(0, 1),
            r = Number.parseInt(e.substr(1), 10);
          return (t = {})[n + "axis" + r] = {
            domain: [1 - .05 * (r - 1), 1 - .05 * (r - 2)],
            fixedrange: !0,
            visible: !1
          }, t;
        }, n.prototype.isDataLoaded = function () {
          var e = function e(_e18) {
            return _e18.filter(function (e) {
              return e.x && e.x.length >= 1 || e.xy && e.xy.length >= 1;
            }).length > 0;
          };
          return e(this.props.data) || e(this.plotlyFormattedData);
        }, n.defaultProps = {
          config: {},
          data: [],
          height: "100%",
          layout: {},
          showLoader: !0,
          width: "100%"
        }, n;
      }(s.Component);
      t.PlotlyChart = c;
    },
    "./src/component/chart/SecondaryStructureAxis.ts": function srcComponentChartSecondaryStructureAxisTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/component/chart/index.ts"),
        o = n("./src/helper/index.ts"),
        a = function (e) {
          function t(n, r, i, a, s, l) {
            void 0 === r && (r = 3), void 0 === i && (i = 2), void 0 === a && (a = new o.ColorMapper(new Map([["C", "red"], ["E", "green"], ["H", "blue"]]), "black")), void 0 === s && (s = {
              C: t.centerSectionPositionFn,
              E: t.centerSectionPositionFn,
              H: function H(e, t) {
                return {
                  main: t,
                  opposite: Math.sin(t)
                };
              }
            }), void 0 === l && (l = function l(e) {
              return e.length <= r;
            });
            var u = e.call(this, n, i, a, s) || this;
            return u.sections = n, u.minimumRequiredResidues = r, u.axisIndex = i, u.colorMap = a, u.dataTransformFn = s, u.filterFn = l, u;
          }
          return r.__extends(t, e), t.prototype.setupAuxiliaryAxis = function () {
            e.prototype.setupAuxiliaryAxis.call(this);
            var t = this.getAxisById("E");
            if (t && t.x.x && t.x.y) {
              for (var n = {
                  main: new Array(t.x.x.length).fill("line-ne"),
                  opposite: new Array(t.x.x.length).fill("line-ne")
                }, i = 1; i < t.x.x.length - 1; ++i) null === t.x.y[i + 1] && (n.main[i] = "triangle-right", n.opposite[i] = "triangle-down");
              t.x = r.__assign(r.__assign({}, t.x), this.generateBetaSheetStyle(t.x, n.main)), t.y = r.__assign(r.__assign({}, t.y), this.generateBetaSheetStyle(t.y, n.opposite));
            }
          }, t.prototype.generateBetaSheetStyle = function (e, t) {
            return {
              line: r.__assign(r.__assign({}, e.line), {
                width: 5
              }),
              marker: r.__assign(r.__assign({}, e.marker), {
                color: this.colorMap.getColorFor("E"),
                size: 10,
                symbol: t
              }),
              mode: "lines+markers"
            };
          }, t.centerSectionPositionFn = function (e, t) {
            return {
              main: t,
              opposite: 0
            };
          }, t;
        }(i.AuxiliaryAxis);
      t.SecondaryStructureAxis = a;
    },
    "./src/component/chart/index.ts": function srcComponentChartIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/component/chart/PlotlyChart.tsx"), t), r.__exportStar(n("./src/component/chart/AuxiliaryAxis.ts"), t), r.__exportStar(n("./src/component/chart/ContactMapChart.tsx"), t), r.__exportStar(n("./src/component/chart/SecondaryStructureAxis.ts"), t);
    },
    "./src/component/hoc/BBStoreHOC.tsx": function srcComponentHocBBStoreHOCTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/react-redux/es/index.js"),
        a = n("./src/reducer/index.ts");
      t.connectWithBBStore = function (e, n, r) {
        var i = o.connect(e, n)(r);
        return t.withBBStore(i);
      }, t.withBBStore = function (e) {
        return function (t) {
          return e.displayName = "withBBStore(" + e.displayName + ")", i.createElement(o.Provider, {
            store: a.BBStore
          }, i.createElement(e, r.__assign({}, t)));
        };
      };
    },
    "./src/component/hoc/index.ts": function srcComponentHocIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n("./node_modules/tslib/tslib.es6.js").__exportStar(n("./src/component/hoc/BBStoreHOC.tsx"), t);
    },
    "./src/component/index.ts": function srcComponentIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/component/chart/index.ts"), t), r.__exportStar(n("./src/component/hoc/index.ts"), t), r.__exportStar(n("./src/component/widget/index.ts"), t), r.__exportStar(n("./src/component/ContactMapComponent.tsx"), t), r.__exportStar(n("./src/component/FeatureViewer.tsx"), t), r.__exportStar(n("./src/component/NGLComponent.tsx"), t), r.__exportStar(n("./src/component/TensorTComponent.tsx"), t), r.__exportStar(n("./src/component/UMAPVisualization.tsx"), t);
    },
    "./src/component/widget/BioblocksRadioGroup.tsx": function srcComponentWidgetBioblocksRadioGroupTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            n.handleChange = function (e) {
              return function (t, r) {
                var i = n.props.onChange;
                n.setState({
                  selectedIndex: e
                }), i && i(e);
              };
            }, n.renderOptions = function (e, t, r, a) {
              return e.map(function (e, s) {
                return i.createElement(o.Grid.Column, {
                  key: t + "-" + e + "-" + s,
                  style: {
                    paddingBottom: 0,
                    paddingTop: "7px"
                  }
                }, i.createElement(o.Form.Radio, {
                  checked: n.state.selectedIndex === s,
                  disabled: r,
                  label: {
                    children: e,
                    style: a
                  },
                  name: e,
                  onChange: n.handleChange(s),
                  value: s
                }));
              });
            };
            var r = t.defaultOption,
              a = t.options,
              s = t.selectedOption,
              l = 0;
            return s && a.includes(s) ? l = a.indexOf(s) : r && a.includes(r) && (l = a.indexOf(r)), n.state = {
              selectedIndex: l
            }, n;
          }
          return r.__extends(t, e), t.prototype.render = function () {
            var e = this.props,
              t = e.disabled,
              n = e.id,
              r = e.options,
              a = e.style,
              s = e.title;
            return i.createElement("div", {
              style: a
            }, i.createElement(o.Form, null, i.createElement(o.Grid, {
              centered: !0,
              columns: 2,
              padded: !0
            }, i.createElement(o.Grid.Row, null, i.createElement("div", {
              style: {
                fontStyle: "italic",
                fontWeight: "bold",
                textDecoration: "underline"
              }
            }, s)), this.renderOptions(r, n, t, a))));
          }, t.defaultProps = {
            disabled: !1,
            style: {},
            title: "How to calculate distance between two residues:"
          }, t;
        }(i.Component);
      t.BioblocksRadioGroup = a;
    },
    "./src/component/widget/BioblocksRangeSlider.tsx": function srcComponentWidgetBioblocksRangeSliderTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/rc-slider/es/index.js"),
        o = r.__importStar(n("react"));
      n("./node_modules/rc-slider/assets/index.css");
      var a = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        s = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.onAfterChange = function (e) {
              return function (t) {
                e && e(t), n.setState({
                  range: t
                });
              };
            }, n.onChange = function (e) {
              return function (t) {
                e && e(t), n.setState({
                  range: t
                });
              };
            }, n.onReset = function () {
              n.onChange(n.props.onChange)(n.state.defaultValue);
            }, n.state = {
              defaultValue: t.defaultValue ? t.defaultValue : t.value,
              range: t.value
            }, n;
          }
          return r.__extends(t, e), t.prototype.componentDidUpdate = function (e) {
            var t = this.props,
              n = t.defaultValue,
              r = t.value;
            r && r !== e.value && this.setState({
              range: r
            });
            var i = n || r;
            i !== this.state.defaultValue && this.setState({
              defaultValue: i
            });
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.value,
              n = e.hideLabelValue,
              s = e.max,
              l = e.min,
              u = e.label,
              c = e.onAfterChange,
              d = e.onChange,
              h = e.style,
              f = r.__rest(e, ["value", "hideLabelValue", "max", "min", "label", "onAfterChange", "onChange", "style"]),
              p = this.state.range;
            return o.createElement("div", {
              style: h
            }, o.createElement(a.Grid.Column, {
              style: {
                float: "left",
                height: "100%",
                width: "75%"
              }
            }, !n && o.createElement("p", null, u + ": [" + p.join(" - ") + "]"), o.createElement(i.Range, r.__assign({
              allowCross: !1,
              pushable: !1,
              max: s,
              min: l,
              onAfterChange: this.onAfterChange(c),
              onChange: this.onChange(d),
              value: t
            }, f))), o.createElement(a.Grid.Column, {
              style: {
                float: "right",
                padding: "5% 0",
                width: "20%"
              },
              verticalAlign: "middle"
            }, o.createElement(a.Button, {
              icon: "undo",
              onClick: this.onReset,
              size: "small"
            })));
          }, t;
        }(o.Component);
      t.BioblocksRangeSlider = s;
    },
    "./src/component/widget/BioblocksSlider.tsx": function srcComponentWidgetBioblocksSliderTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importDefault(n("./node_modules/rc-slider/es/index.js")),
        o = r.__importStar(n("react"));
      n("./node_modules/rc-slider/assets/index.css");
      var a = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        s = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.onAfterChange = function (e) {
              return function (t) {
                e && e(t), n.setState({
                  value: t
                });
              };
            }, n.onChange = function (e) {
              return function (t) {
                e && e(t), n.setState({
                  value: t
                });
              };
            }, n.onReset = function () {
              n.onChange(n.props.onChange)(n.state.defaultValue);
            }, n.state = {
              defaultValue: t.defaultValue ? t.defaultValue : t.value,
              value: t.value
            }, n;
          }
          return r.__extends(t, e), t.prototype.componentDidUpdate = function (e) {
            var t = this.props,
              n = t.defaultValue,
              r = t.value;
            r && r !== e.value && this.setState({
              value: r
            });
            var i = n || r;
            -1 === this.state.defaultValue && i !== this.state.defaultValue && this.setState({
              defaultValue: i
            });
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.value,
              n = e.hideLabelValue,
              s = e.max,
              l = e.min,
              u = e.label,
              c = e.onAfterChange,
              d = e.onChange,
              h = e.style,
              f = r.__rest(e, ["value", "hideLabelValue", "max", "min", "label", "onAfterChange", "onChange", "style"]);
            return o.createElement("div", {
              style: h
            }, o.createElement(a.Grid.Column, {
              style: {
                float: "left",
                height: "100%",
                width: "75%"
              }
            }, !n && o.createElement("p", null, u + ": " + this.state.value), o.createElement(i.default, r.__assign({
              max: s,
              min: l,
              onAfterChange: this.onAfterChange(c),
              onChange: this.onChange(d),
              value: t
            }, f))), o.createElement(a.Grid.Column, {
              style: {
                float: "right",
                padding: "5% 0",
                width: "20%"
              },
              verticalAlign: "middle"
            }, o.createElement(a.Button, {
              icon: "undo",
              onClick: this.onReset,
              size: "small"
            })));
          }, t;
        }(o.Component);
      t.BioblocksSlider = s;
    },
    "./src/component/widget/CategorySelector.tsx": function srcComponentWidgetCategorySelectorTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = function (e) {
          function t(t) {
            return e.call(this, t) || this;
          }
          return r.__extends(t, e), t.prototype.render = function () {
            var e = this.props,
              t = e.categories,
              n = e.onCategoryChange;
            return this.props.categories && i.createElement(o.Dropdown, {
              fluid: !0,
              onChange: n,
              options: r.__spread(t.map(function (e) {
                return {
                  key: e,
                  text: e,
                  value: e
                };
              })),
              placeholder: "Select Category",
              search: !0
            });
          }, t.defaultProps = {
            categories: []
          }, t;
        }(i.Component);
      t.CategorySelector = a;
    },
    "./src/component/widget/ComponentCard.tsx": function srcComponentWidgetComponentCardTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = r.__importStar(n("react-dom")),
        a = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        s = n("./src/component/widget/index.ts"),
        l = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.cardRef = null, n.renderCard = function (e, t, o) {
              return t ? i.createElement(a.Modal, {
                closeOnDimmerClick: !0,
                closeOnEscape: !0,
                onClose: n.onFullPageToggle,
                open: !0,
                size: "large",
                style: r.__assign(r.__assign({}, o), {
                  willChange: "unset"
                })
              }, e) : e;
            }, n.renderCardChildren = function () {
              var e = n.props,
                t = e.children,
                r = e.headerHeight,
                o = e.isFramedComponent,
                a = n.state.framedStyle;
              return i.createElement(i.Fragment, null, i.createElement("div", {
                style: {
                  height: "7%"
                }
              }, n.renderTopMenu(r)), i.createElement("div", {
                style: {
                  height: "90%",
                  width: "100%"
                }
              }, o ? i.createElement("div", {
                style: a
              }, t) : t), i.createElement("div", {
                style: {
                  height: "3%"
                }
              }, n.renderDock()));
            }, n.renderDock = function () {
              var e = n.props,
                t = e.dockItems,
                r = e.isDataReady;
              return t.length >= 1 && i.createElement(s.ComponentDock, {
                dockItems: t,
                visible: r
              });
            }, n.renderTopMenu = function (e) {
              var t = n.props,
                r = t.componentName,
                o = t.iconSrc,
                a = t.menuItems,
                l = n.state.isFullPage;
              return i.createElement(s.ComponentMenuBar, {
                componentName: r,
                height: e,
                iconSrc: o,
                isExpanded: l,
                menuItems: a,
                onExpandToggleCb: n.onFullPageToggle
              });
            }, n.onBorderClick = function (e) {
              return r.__awaiter(n, void 0, void 0, function () {
                var t;
                return r.__generator(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return t = o.findDOMNode(this.cardRef), e.offsetX < 0 || e.offsetY < 0 || e.offsetX > t.clientWidth || e.offsetY > t.clientHeight ? [4, document.exitFullscreen()] : [3, 2];
                    case 1:
                      n.sent(), n.label = 2;
                    case 2:
                      return [2];
                  }
                });
              });
            }, n.onFullPageToggle = function () {
              return r.__awaiter(n, void 0, void 0, function () {
                var e, t;
                return r.__generator(this, function (n) {
                  switch (n.label) {
                    case 0:
                      return e = this.state.isFullPage, !(t = o.findDOMNode(this.cardRef)) || e ? [3, 2] : (t.onclick = this.onBorderClick, [4, t.requestFullscreen()]);
                    case 1:
                      return n.sent(), [3, 4];
                    case 2:
                      return [4, document.exitFullscreen()];
                    case 3:
                      n.sent(), t && t.removeEventListener("click", this.onBorderClick), n.label = 4;
                    case 4:
                      return [2];
                  }
                });
              });
            }, n.state = {
              framedStyle: {
                transformOrigin: "top left"
              },
              isFullPage: t.isFullPage
            }, n;
          }
          return r.__extends(t, e), t.prototype.componentDidMount = function () {
            return r.__awaiter(this, void 0, void 0, function () {
              var e = this;
              return r.__generator(this, function (t) {
                switch (t.label) {
                  case 0:
                    return this.props.isFramedComponent ? (window.onresize = function () {
                      return r.__awaiter(e, void 0, void 0, function () {
                        return r.__generator(this, function (e) {
                          switch (e.label) {
                            case 0:
                              return this.props.isFramedComponent ? [4, this.resizeFramedComponent()] : [3, 2];
                            case 1:
                              e.sent(), e.label = 2;
                            case 2:
                              return [2];
                          }
                        });
                      });
                    }, [4, this.resizeFramedComponent()]) : [3, 2];
                  case 1:
                    t.sent(), t.label = 2;
                  case 2:
                    return document.onfullscreenchange = function () {
                      var t = e.state.isFullPage;
                      e.setState({
                        isFullPage: !t
                      });
                    }, [2];
                }
              });
            });
          }, t.prototype.componentWillUnmount = function () {
            document.onfullscreenchange = null;
            var e = o.findDOMNode(this.cardRef);
            e && e.removeEventListener("click", this.onBorderClick);
          }, t.prototype.componentDidUpdate = function (e, t) {
            return r.__awaiter(this, void 0, void 0, function () {
              return r.__generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    return this.state.isFullPage === t.isFullPage ? [3, 2] : [4, this.resizeFramedComponent()];
                  case 1:
                    e.sent(), e.label = 2;
                  case 2:
                    return [2];
                }
              });
            });
          }, t.prototype.render = function () {
            var e = this,
              t = this.props,
              n = t.expandedStyle,
              o = t.height,
              s = t.width,
              l = this.state.isFullPage,
              u = "string" == typeof o ? parseInt(o, 10) : o,
              c = r.__assign({
                maxWidth: "unset",
                padding: "0 0 0 5px"
              }, l ? r.__assign(r.__assign({}, n), {
                padding: "5px",
                border: "5em black solid"
              }) : {
                height: 1.01 * u + "px",
                width: s
              });
            return i.createElement(a.Card, {
              centered: !0,
              className: "bioblocks-component-card",
              ref: function ref(t) {
                return e.cardRef = t;
              },
              style: c
            }, this.renderCardChildren());
          }, t.prototype.resizeFramedComponent = function () {
            return r.__awaiter(this, void 0, void 0, function () {
              var e, t, n, i, a, s, l, u, c, d, h;
              return r.__generator(this, function (f) {
                return e = this.props, t = e.frameHeight, n = e.frameWidth, i = e.headerHeight, a = this.state, s = a.framedStyle, l = a.isFullPage, (u = o.findDOMNode(this.cardRef)) && (c = window.getComputedStyle(u)) && null !== c.width && null !== c.height && (document.body.style.overflowY = l ? "hidden" : "auto", d = parseInt(c.height, 10) - 18, h = parseInt(c.width, 10) - 10, this.setState({
                  framedStyle: r.__assign(r.__assign({}, s), {
                    transform: "scale(calc(" + h + "/" + n + "),calc((" + d + " - " + i + ")/" + t + "))"
                  })
                })), [2];
              });
            });
          }, t.defaultProps = {
            dockItems: [],
            expandedStyle: {
              height: "85vh",
              width: "85vh"
            },
            frameHeight: 0,
            frameWidth: 0,
            headerHeight: 20,
            height: "575px",
            iconSrc: "assets/icons/bio-blocks-icon.svg",
            isDataReady: !1,
            isFramedComponent: !1,
            isFullPage: !1,
            menuItems: [],
            padding: 0,
            showSettings: !1,
            width: "575px"
          }, t;
        }(i.Component);
      t.ComponentCard = l;
    },
    "./src/component/widget/ComponentDock.tsx": function srcComponentWidgetComponentDockTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.renderSingleDockItem = function (e, t) {
              if (e.isVisibleCb && !1 === e.isVisibleCb()) return null;
              var n = void 0 === e.isLink || e.isLink;
              return i.createElement(o.Grid.Column, {
                key: "dock-item-" + t,
                style: {
                  padding: 0,
                  paddingTop: "3px"
                }
              }, n ? i.createElement("div", {
                style: {
                  userSelect: "none"
                }
              }, i.createElement("a", {
                "aria-pressed": !1,
                onClick: e.onClick,
                role: "button"
              }, e.text)) : i.createElement("div", null, e.text));
            }, n;
          }
          return r.__extends(t, e), t.prototype.render = function () {
            var e = this,
              t = this.props,
              n = t.dockItems;
            return t.visible && i.createElement(o.Grid, {
              centered: !0,
              columns: "equal",
              style: {
                marginLeft: "initial",
                marginRight: "initial",
                marginTop: "-0.5rem",
                padding: 0
              },
              stretched: !0
            }, n.map(function (t, n) {
              return e.renderSingleDockItem(t, n);
            }));
          }, t.defaultProps = {
            visible: !0
          }, t;
        }(i.Component);
      t.ComponentDock = a;
    },
    "./src/component/widget/ComponentMenuBar.tsx": function srcComponentWidgetComponentMenuBarTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = n("./src/component/widget/index.ts"),
        s = n("./src/data/index.ts"),
        l = n("./src/helper/index.ts");
      t.DEFAULT_POPUP_PROPS = {
        closeOnPortalMouseLeave: !1,
        closeOnTriggerClick: !0,
        closeOnTriggerMouseLeave: !1,
        hoverable: !1,
        openOnTriggerClick: !0,
        openOnTriggerFocus: !1,
        openOnTriggerMouseEnter: !1,
        position: "bottom left",
        style: {
          marginTop: 0,
          maxHeight: "350px",
          overflow: "auto",
          zIndex: 3
        }
      };
      var u = function (e) {
        function n(n) {
          var s = e.call(this, n) || this;
          return s.getPopupMenuItem = function (e, n, l) {
            var u = s.props.opacity,
              c = l || i.createElement(o.Icon, {
                fitted: !0,
                name: e.iconName ? e.iconName : "setting"
              }),
              d = r.__assign(r.__assign({}, t.DEFAULT_POPUP_PROPS), e.component.props),
              h = d.style,
              f = r.__rest(d, ["style"]);
            return e.component.configs ? i.createElement(o.Popup, r.__assign({
              key: n + "-popup",
              wide: !0
            }, f, {
              style: {
                opacity: u
              },
              trigger: c
            }), i.createElement(a.ConfigAccordion, {
              configs: s.renderConfigs(e.component.configs),
              gridStyle: h,
              title: "Config"
            })) : i.createElement(o.Popup, r.__assign({
              key: n + "-popup"
            }, f, {
              style: {
                opacity: u
              },
              trigger: c
            }));
          }, s.getButtonMenuItem = function (e) {
            var t = {};
            if (e.component.props) {
              var n = e.component.props;
              n.color, n.size;
              t = r.__rest(n, ["color", "size"]);
            }
            return i.createElement(o.Icon, r.__assign({
              fitted: !0,
              name: e.iconName ? e.iconName : "setting"
            }, t));
          }, s.onMenuEnter = function () {
            s.setState({
              isHovered: !0
            });
          }, s.onMenuLeave = function () {
            s.setState({
              isHovered: !1
            });
          }, s.renderComponentRightMenu = function () {
            var e = s.props,
              t = e.componentName,
              n = e.isExpanded,
              r = e.menuItems,
              a = e.onExpandToggleCb;
            return i.createElement(o.Menu.Item, {
              fitted: "horizontally",
              position: "right"
            }, i.createElement(o.Menu, {
              secondary: !0
            }, s.renderMenuItems(r, t), i.createElement(o.Menu.Item, {
              style: {
                flexDirection: "column"
              }
            }, i.createElement(o.Icon, {
              name: n ? "compress" : "expand arrows alternate",
              onClick: a,
              style: {
                margin: 0
              }
            }), s.renderMenuIconText(n ? "Close" : "Expand"))));
          }, s.renderComponentTitle = function (e, t, n) {
            return i.createElement(o.Menu, {
              secondary: !0,
              widths: 6,
              fluid: !1,
              style: {
                width: "auto"
              }
            }, i.createElement(o.Menu.Item, {
              fitted: "horizontally",
              style: {
                margin: 0,
                padding: 0
              }
            }, t && i.createElement("img", {
              alt: "component icon",
              src: n,
              style: {
                height: "32px",
                padding: "2px",
                width: "32px"
              }
            }), e));
          }, s.renderConfigs = function (e) {
            return Object.keys(e).map(function (t) {
              var n;
              return (n = {})[t] = e[t].map(function (e, n) {
                return i.createElement(o.Grid.Row, {
                  columns: 1,
                  key: "menu-bar-" + t + "-row-" + n,
                  style: {
                    padding: "5px 0",
                    width: "100%"
                  }
                }, s.renderSingleConfig(e, t + "-row-" + n));
              }), n;
            });
          }, s.state = {
            iconUrl: "assets/icons/bio-blocks-icon.svg",
            isHovered: !1
          }, s;
        }
        return r.__extends(n, e), n.prototype.componentDidMount = function () {
          return r.__awaiter(this, void 0, void 0, function () {
            var e, t;
            return r.__generator(this, function (n) {
              switch (n.label) {
                case 0:
                  return e = this.props.iconSrc, [4, fetch(e)];
                case 1:
                  return t = n.sent(), this.setState({
                    iconUrl: t.url
                  }), [2];
              }
            });
          });
        }, n.prototype.render = function () {
          var e = this.props,
            t = e.componentName,
            n = e.height,
            r = e.iconSrc,
            a = (e.isExpanded, e.menuItems, e.onExpandToggleCb, this.state.iconUrl);
          return i.createElement("div", {
            onMouseEnter: this.onMenuEnter,
            onMouseLeave: this.onMenuLeave
          }, i.createElement(o.Menu, {
            secondary: !0,
            style: {
              margin: 0,
              height: n
            }
          }, this.renderComponentTitle(t, r, a), this.renderComponentRightMenu()));
        }, n.prototype.renderConfigurationButton = function (e, t) {
          return i.createElement(o.Button, {
            compact: !0,
            key: t,
            onClick: e.onClick,
            style: e.style
          }, e.icon && i.createElement(o.Icon, {
            name: e.icon
          }), e.name);
        }, n.prototype.renderConfigurationButtonGroup = function (e, t) {
          return i.createElement(o.Grid, {
            padded: !0,
            style: {
              padding: "initial 0"
            }
          }, i.createElement(o.Grid.Row, {
            columns: 2
          }, i.createElement(o.Grid.Column, {
            width: 9
          }, e.name), i.createElement(o.Grid.Column, {
            width: 3
          }, i.createElement(o.Button.Group, null, e.options.map(function (n, r) {
            return i.createElement(o.Button, {
              icon: n,
              key: t + "-" + r,
              style: e.style,
              basic: !0,
              compact: !0
            });
          })))));
        }, n.prototype.renderConfigurationCheckbox = function (e, t) {
          return i.createElement(o.Checkbox, {
            key: t,
            checked: e.checked,
            label: e.name,
            onChange: e.onChange,
            style: e.style
          });
        }, n.prototype.renderConfigurationDropDown = function (e, t) {
          return i.createElement(o.Dropdown, {
            key: t,
            onChange: e.onChange,
            options: e.options
          });
        }, n.prototype.renderConfigurationLabel = function (e, t) {
          return i.createElement(o.Label, {
            basic: !0,
            key: t,
            style: e.style,
            color: "orange"
          }, e.name);
        }, n.prototype.renderConfigurationRadioButton = function (e, t) {
          return i.createElement(a.BioblocksRadioGroup, {
            defaultOption: e.defaultOption,
            id: t,
            key: t,
            options: e.options,
            onChange: e.onChange,
            selectedOption: e.current,
            style: e.style,
            title: e.name
          });
        }, n.prototype.renderConfigurationRangeSlider = function (e, t) {
          return i.createElement(a.BioblocksRangeSlider, {
            key: t,
            label: e.name,
            defaultValue: e.range.defaultRange,
            max: e.range.max,
            min: e.range.min,
            onAfterChange: e.onAfterChange,
            onChange: e.onChange,
            style: r.__assign({
              padding: "2px 0 3px 18px",
              width: "100%"
            }, e.style),
            value: e.range.current
          });
        }, n.prototype.renderConfigurationSlider = function (e, t) {
          return i.createElement(a.BioblocksSlider, {
            key: t,
            label: e.name,
            defaultValue: e.values.defaultValue,
            marks: e.marks,
            max: e.values.max,
            min: e.values.min,
            onAfterChange: e.onAfterChange,
            onChange: e.onChange,
            step: e.step,
            style: r.__assign({
              padding: "2px 0 3px 18px",
              width: "100%"
            }, e.style),
            value: e.values.current
          });
        }, n.prototype.renderMenuIconText = function (e) {
          var t = this.state.isHovered;
          return i.createElement("span", {
            style: {
              fontSize: "11px",
              visibility: t ? "visible" : "hidden"
            }
          }, e);
        }, n.prototype.renderMenuItems = function (e, t) {
          var n = this;
          return e.map(function (e, r) {
            var a = t + "-menu-item-" + r;
            if ("POPUP" === e.component.name) {
              var s = i.createElement(o.Menu.Item, {
                active: e.component.props ? e.component.props.active : void 0,
                key: a + "-trigger",
                style: {
                  flexDirection: "column"
                }
              }, i.createElement(o.Icon, {
                fitted: !0,
                name: e.iconName ? e.iconName : "setting"
              }), n.renderMenuIconText(e.description));
              return n.getPopupMenuItem(e, a, s);
            }
            var u = n.getButtonMenuItem(e);
            return u && i.createElement(o.Menu.Item, {
              active: e.component.props ? e.component.props.active : void 0,
              key: a,
              style: {
                flexDirection: "column"
              },
              onClick: "onClick" in e.component ? e.component.onClick : l.EMPTY_FUNCTION
            }, u, n.renderMenuIconText(e.description));
          });
        }, n.prototype.renderSingleConfig = function (e, t) {
          switch (e.type) {
            case s.CONFIGURATION_COMPONENT_TYPE.BUTTON:
              return this.renderConfigurationButton(e, "button-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.BUTTON_GROUP:
              return this.renderConfigurationButtonGroup(e, "button-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.CHECKBOX:
              return this.renderConfigurationCheckbox(e, "label-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.DROP_DOWN:
              return this.renderConfigurationDropDown(e, "label-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.LABEL:
              return this.renderConfigurationLabel(e, "label-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.RADIO:
              return this.renderConfigurationRadioButton(e, "radio-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.RANGE_SLIDER:
              return this.renderConfigurationRangeSlider(e, "range-slider-" + t);
            case s.CONFIGURATION_COMPONENT_TYPE.SLIDER:
              return this.renderConfigurationSlider(e, "slider-" + t);
            default:
              return "configuration for " + t;
          }
        }, n.defaultProps = {
          height: "100%",
          iconSrc: "assets/icons/bio-blocks-icon.svg",
          isExpanded: !1,
          menuItems: [],
          opacity: .85,
          width: "100%"
        }, n;
      }(i.Component);
      t.ComponentMenuBar = u;
    },
    "./src/component/widget/ConfigAccordion.tsx": function srcComponentWidgetConfigAccordionTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.renderConfigs = function (e, t) {
              return e.map(function (r, a) {
                return Object.keys(r).map(function (r) {
                  return i.createElement(o.Grid.Row, {
                    key: "accordion-" + r,
                    textAlign: "left"
                  }, i.createElement(o.Accordion.Title, {
                    active: t.includes(a),
                    index: a,
                    key: r + "-title",
                    onClick: n.onClick,
                    style: {
                      fontWeight: "bolder",
                      textAlign: "left"
                    }
                  }, i.createElement(o.Icon, {
                    name: "dropdown"
                  }), r), i.createElement(o.Accordion.Content, {
                    active: t.includes(a),
                    key: r + "-content",
                    style: {
                      width: "100%"
                    }
                  }, n.renderSingleConfig(Object.entries(e)[a])));
                });
              });
            }, n.onClick = function (e, t) {
              var i = n.props.allowMultipleOpen,
                o = n.state.activeIndices;
              void 0 !== t && void 0 !== t.index && (o.includes(t.index) ? n.setState({
                activeIndices: o.filter(function (e) {
                  return e !== t.index;
                })
              }) : i ? n.setState({
                activeIndices: r.__spread(o, [t.index])
              }) : n.setState({
                activeIndices: [t.index]
              }));
            }, n.renderSingleConfig = function (e) {
              return i.createElement(o.Grid.Row, {
                key: "accordion-" + e[0],
                textAlign: "left"
              }, i.createElement(o.Grid, {
                padded: !0,
                relaxed: !0,
                stretched: !0,
                style: {
                  marginTop: "7px"
                }
              }, Object.values(e[1])));
            }, n.state = {
              activeIndices: t.configs.length >= 1 ? [0] : []
            }, n;
          }
          return r.__extends(t, e), t.prototype.render = function () {
            var e = this.props,
              t = e.configs,
              n = e.gridStyle,
              r = this.state.activeIndices;
            return i.createElement(o.Accordion, null, i.createElement(o.Grid, {
              padded: !0,
              stretched: !0,
              style: n
            }, this.renderConfigs(t, r)));
          }, t.defaultProps = {
            allowMultipleOpen: !1,
            gridStyle: {}
          }, t;
        }(i.Component);
      t.ConfigAccordion = a;
    },
    "./src/component/widget/index.ts": function srcComponentWidgetIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/component/widget/BioblocksRadioGroup.tsx"), t), r.__exportStar(n("./src/component/widget/BioblocksRangeSlider.tsx"), t), r.__exportStar(n("./src/component/widget/BioblocksSlider.tsx"), t), r.__exportStar(n("./src/component/widget/CategorySelector.tsx"), t), r.__exportStar(n("./src/component/widget/ComponentCard.tsx"), t), r.__exportStar(n("./src/component/widget/ComponentDock.tsx"), t), r.__exportStar(n("./src/component/widget/ComponentMenuBar.tsx"), t), r.__exportStar(n("./src/component/widget/ConfigAccordion.tsx"), t);
    },
    "./src/container/AnatomogramContainer.tsx": function srcContainerAnatomogramContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importDefault(n("./node_modules/anatomogram/lib/index.js")),
        o = n("./node_modules/immutable/dist/immutable.js"),
        a = r.__importStar(n("react")),
        s = n("./node_modules/redux/es/redux.js"),
        l = n("./src/action/index.ts"),
        u = n("./src/component/index.ts"),
        c = n("./src/container/index.ts"),
        d = n("./src/data/index.ts"),
        h = n("./src/helper/index.ts"),
        f = n("./src/reducer/index.ts"),
        p = n("./src/selector/index.ts"),
        m = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.divRef = null, n.onClick = function (e) {
              var t = e[0],
                r = n.props,
                i = r.onLabelAdd,
                o = r.onLabelRemove;
              r.selectIds.includes(t) ? o(t) : i(t);
            }, n.deriveIdsFromSpecies = function (e) {
              return Object.keys(d.AnatomogramMapping[e]);
            }, n.onMouseOut = function (e) {}, n.onMouseOver = function (e) {}, n.parseCategory = function (e) {
              return e.split(/-|_/)[0];
            }, n.resizeSVGElement = function (e, t) {
              if (n.divRef) {
                var r = t.height.baseVal.value > t.width.baseVal.value;
                t.style.height = r ? "calc(" + n.divRef.style.height + " - 50px)" : "auto", t.style.padding = "0", t.style.width = r ? "auto" : "calc(" + n.divRef.style.width + " - 75px)";
              }
            }, n.state = {
              ids: n.deriveIdsFromSpecies(t.species)
            }, n;
          }
          return r.__extends(t, e), t.prototype.setupDataServices = function () {
            this.registerDataset("cells", []), this.registerDataset("labels", []), f.BioblocksMiddlewareTransformer.addTransform(this.getCellToLabelTransform()), f.BioblocksMiddlewareTransformer.addTransform(this.getLabelToCellTransform());
          }, t.prototype.componentDidUpdate = function (e) {
            var t = this.props.species;
            t !== e.species && this.setState({
              ids: this.deriveIdsFromSpecies(t)
            });
          }, t.prototype.render = function () {
            var e = this,
              t = this.props,
              n = t.iconSrc,
              r = t.species,
              o = t.selectIds,
              s = this.state.ids;
            return a.createElement("div", {
              className: "anatomogram-container",
              ref: function ref(t) {
                t && (e.divRef = t.getElementsByTagName("div")[0]);
              }
            }, a.createElement(u.ComponentCard, {
              componentName: "Anatomogram",
              iconSrc: n
            }, a.createElement(i.default, {
              atlasUrl: "",
              highlightColour: "yellow",
              onClick: this.onClick,
              onInjected: this.resizeSVGElement,
              onMouseOut: this.onMouseOut,
              onMouseOver: this.onMouseOver,
              selectColour: "ffaa00",
              selectIds: o.toArray(),
              showIds: s,
              species: r,
              selectedView: "mus_musculus" === r ? "female" : "male"
            })));
          }, t.prototype.getCellToLabelTransform = function () {
            var e = this;
            return {
              fn: function fn(t) {
                var n,
                  i,
                  a,
                  s,
                  l,
                  u,
                  c = e.props.species,
                  h = p.selectCurrentItems(t, "cells").toArray(),
                  f = p.getSpring(t),
                  m = f.category,
                  g = f.graphData,
                  v = o.Set();
                try {
                  for (var y = r.__values(h), b = y.next(); !b.done; b = y.next()) {
                    var _ = b.value,
                      x = g.nodes[_] ? g.nodes[_].labelForCategory : {},
                      w = d.AnatomogramMapping[c][x[m]];
                    w && w.forEach(function (e) {
                      return v = v.add(e);
                    });
                    try {
                      for (var S = (a = void 0, r.__values(Object.keys(d.AnatomogramMapping[c]))), A = S.next(); !A.done; A = S.next()) {
                        var E = A.value;
                        try {
                          for (var T = (l = void 0, r.__values(Object.values(x))), M = T.next(); !M.done; M = T.next()) {
                            var C = M.value;
                            d.AnatomogramMapping[c][E].includes(C) && (v = v.add(E));
                          }
                        } catch (e) {
                          l = {
                            error: e
                          };
                        } finally {
                          try {
                            M && !M.done && (u = T.return) && u.call(T);
                          } finally {
                            if (l) throw l.error;
                          }
                        }
                      }
                    } catch (e) {
                      a = {
                        error: e
                      };
                    } finally {
                      try {
                        A && !A.done && (s = S.return) && s.call(S);
                      } finally {
                        if (a) throw a.error;
                      }
                    }
                  }
                } catch (e) {
                  n = {
                    error: e
                  };
                } finally {
                  try {
                    b && !b.done && (i = y.return) && i.call(y);
                  } finally {
                    if (n) throw n.error;
                  }
                }
                return v;
              },
              fromState: {
                stateName: "cells"
              },
              toState: {
                stateName: "labels"
              }
            };
          }, t.prototype.getLabelToCellTransform = function () {
            var e = this;
            return {
              fn: function fn(t) {
                var n = e.props,
                  r = n.species,
                  i = n.selectIds,
                  a = p.getSpring(t).graphData,
                  s = d.AnatomogramMapping[r],
                  l = o.Set();
                i.forEach(function (e) {
                  l = e && s[e] ? l.merge(s[e]) : l;
                });
                var u = o.Set();
                return a.nodes.forEach(function (e) {
                  var t = Object.values(e.labelForCategory);
                  l.forEach(function (n) {
                    n && t.includes(n) && (u = u.add(e.number));
                  });
                }), u;
              },
              fromState: "bioblocks/labels",
              toState: "bioblocks/cells"
            };
          }, t.defaultProps = {
            iconSrc: "",
            onLabelAdd: h.EMPTY_FUNCTION,
            onLabelRemove: h.EMPTY_FUNCTION,
            selectIds: o.Set(),
            species: "homo_sapiens"
          }, t.displayName = "Anatomogram", t;
        }(c.BioblocksVisualization);
      t.AnatomogramContainerClass = m;
      t.AnatomogramContainer = u.connectWithBBStore(function (e) {
        return {
          selectIds: p.selectCurrentItems(e, "labels")
        };
      }, function (e) {
        return s.bindActionCreators({
          onLabelAdd: l.createContainerActions("labels").add,
          onLabelRemove: l.createContainerActions("labels").remove
        }, e);
      }, m);
    },
    "./src/container/BioblocksVisualization.tsx": function srcContainerBioblocksVisualizationTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("react")),
        a = n("./node_modules/util/util.js"),
        s = n("./src/data/index.ts"),
        l = n("./src/reducer/index.ts"),
        u = function (e) {
          function t(n) {
            var r = e.call(this, n) || this;
            return r.bioblocksHooks = {}, r.datasets = i.Set(), r.loadingStatus = 2, t.activeBioblocksVisualizations = t.activeBioblocksVisualizations.add(r), r.setupDataServices(), r;
          }
          return r.__extends(t, e), t.prototype.componentWillUnmount = function () {
            this.teardown();
          }, t.prototype.addBioblocksHook = function (e, t) {
            this.bioblocksHooks[e] = t;
          }, t.prototype.registerDataset = function (e, t, n) {
            void 0 === n && (n = "bioblocks"), this.datasets = this.datasets.add(new s.Dataset(e, n)), this.createReducer(e, t, n);
          }, t.prototype.finishLoading = function () {
            this.loadingStatus = 3;
          }, t.prototype.getDatasets = function () {
            return this.datasets;
          }, t.prototype.getComponentBioblocksHooks = function () {
            return this.bioblocksHooks;
          }, t.prototype.getLoadingStatus = function () {
            return this.loadingStatus;
          }, t.prototype.teardown = function () {
            t.activeBioblocksVisualizations = t.activeBioblocksVisualizations.remove(this);
          }, t.prototype.createReducer = function (e, t, n) {
            void 0 === n && (n = "bioblocks"), a.isArray(t) ? l.createContainerReducer(e, n) : "object" == typeof t ? l.createObjectReducer(e, n) : l.createValueReducer(e, t, n);
          }, t.getActiveBioblocksVisualizations = function () {
            return t.activeBioblocksVisualizations;
          }, t.activeBioblocksVisualizations = i.Set(), t;
        }(o.Component);
      t.BioblocksVisualization = u;
    },
    "./src/container/ContactMapContainer.tsx": function srcContainerContactMapContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/redux/es/redux.js"),
        a = n("./src/action/index.ts"),
        s = n("./src/component/index.ts"),
        l = n("./src/container/index.ts"),
        u = n("./src/data/index.ts"),
        c = n("./src/helper/index.ts"),
        d = n("./src/reducer/index.ts"),
        h = n("./src/selector/index.ts");
      t.initialContactMapContainerState = {
        linearDistFilter: 5,
        minimumProbability: .9,
        minimumScore: 0,
        numPredictionsToShow: -1,
        pointsToPlot: [],
        rankFilter: [1, 100]
      };
      var f = function (e) {
        function n(n) {
          var r = e.call(this, n) || this;
          return r.state = t.initialContactMapContainerState, r.onLinearDistFilterChange = function () {
            return function (e) {
              r.setState({
                linearDistFilter: e
              });
            };
          }, r.onMinimumProbabilityChange = function () {
            return function (e) {
              r.setState({
                minimumProbability: e
              });
            };
          }, r.onNumPredictionsToShowChange = function () {
            return function (e) {
              r.setState({
                numPredictionsToShow: e
              });
            };
          }, r.haveSettingsUpdated = function (e) {
            var t = r.state,
              n = t.linearDistFilter,
              i = t.minimumProbability,
              o = t.minimumScore,
              a = t.numPredictionsToShow,
              s = t.rankFilter;
            return n !== e.linearDistFilter || i !== e.minimumProbability || o !== e.minimumScore || a !== e.numPredictionsToShow || s !== e.rankFilter;
          }, r.getConfigs = function () {
            var e,
              n = r.state,
              i = n.linearDistFilter,
              o = n.minimumProbability,
              a = n.numPredictionsToShow,
              s = r.props.data.couplingScores.chainLength;
            return [{
              marks: (e = {}, e[Math.floor(s / 2)] = "L/2", e[Math.floor(s / 4)] = "L/4", e[0] = "0", e[s] = "L", e[2 * s] = "2L", e[3 * s] = "3L", e),
              name: "# Couplings to Display",
              onChange: r.onNumPredictionsToShowChange(),
              type: u.CONFIGURATION_COMPONENT_TYPE.SLIDER,
              values: {
                current: a,
                defaultValue: Math.floor(s / 2),
                max: 3 * s,
                min: 0
              }
            }, {
              name: "Linear Distance Filter (|i - j|)",
              onChange: r.onLinearDistFilterChange(),
              type: u.CONFIGURATION_COMPONENT_TYPE.SLIDER,
              values: {
                current: i,
                defaultValue: t.initialContactMapContainerState.linearDistFilter,
                max: 10,
                min: 1
              }
            }, {
              name: "Minimum Probability",
              onChange: r.onMinimumProbabilityChange(),
              step: .01,
              type: u.CONFIGURATION_COMPONENT_TYPE.SLIDER,
              values: {
                current: o,
                defaultValue: t.initialContactMapContainerState.minimumProbability,
                max: 1,
                min: 0
              }
            }];
          }, r.getPredictedFilters = function () {
            var e = r.state,
              t = e.linearDistFilter,
              n = e.minimumProbability,
              i = e.minimumScore;
            return new Array({
              filterFn: function filterFn(e) {
                return void 0 === e.probability || e.probability >= n;
              }
            }, {
              filterFn: function filterFn(e) {
                return void 0 === e.score || e.score >= i;
              }
            }, {
              filterFn: function filterFn(e) {
                return Math.abs(e.i - e.j) >= t;
              }
            });
          }, r;
        }
        return r.__extends(n, e), n.prototype.setupDataServices = function () {
          d.createContainerReducer("secondaryStructure/hovered"), d.createContainerReducer("secondaryStructure/selected"), d.createContainerReducer("pdb"), d.createResiduePairReducer();
        }, n.prototype.componentDidMount = function () {
          this.setupData(!0);
        }, n.prototype.componentDidUpdate = function (e, t) {
          var n = this.props,
            r = n.agreementColor,
            i = n.allColor,
            o = n.data;
          (r !== e.agreementColor || i !== e.allColor || o.couplingScores !== e.data.couplingScores || this.haveSettingsUpdated(t)) && this.setupData(o.couplingScores !== e.data.couplingScores);
        }, n.prototype.render = function () {
          var e = this.props,
            t = e.data,
            n = e.style,
            o = r.__rest(e, ["data", "style"]),
            a = this.state.pointsToPlot;
          return i.createElement("div", {
            className: "ContactMapContainer",
            style: n
          }, i.createElement(s.ContactMapComponent, r.__assign({
            configurations: this.getConfigs(),
            data: {
              couplingScores: t.couplingScores,
              pdbData: t.pdbData,
              secondaryStructures: t.secondaryStructures
            },
            formattedPoints: a
          }, o)));
        }, n.prototype.setupData = function (e) {
          var t = this.props,
            n = t.agreementColor,
            r = t.data,
            i = t.allColor,
            o = this.state,
            a = o.linearDistFilter,
            l = o.numPredictionsToShow,
            u = r.couplingScores,
            d = u.chainLength,
            h = new Array();
          if (u.isDerivedFromCouplingScores) {
            var f = u.getPredictedContacts(l, a, this.getPredictedFilters()),
              p = (f.correct.length / f.predicted.length * 100).toFixed(1);
            h.push(s.generateChartDataEntry("text", i, "Inferred Contact", "(N=" + l + ", L=" + d + ")", 4, f.predicted, {
              text: f.predicted.map(c.generateCouplingScoreHoverText)
            }), s.generateChartDataEntry("text", n, "Inferred Contact Agrees with PDB Contact", "(N=" + f.correct.length + ", " + p + "%)", 6, f.correct, {
              text: f.correct.map(c.generateCouplingScoreHoverText)
            }));
          }
          this.setState({
            numPredictionsToShow: e ? Math.floor(d / 2) : l,
            pointsToPlot: h
          });
        }, n.defaultProps = {
          addHoveredResidues: c.EMPTY_FUNCTION,
          addHoveredSecondaryStructure: c.EMPTY_FUNCTION,
          addSelectedSecondaryStructure: c.EMPTY_FUNCTION,
          agreementColor: "#ff0000",
          allColor: "#000000",
          data: {
            couplingScores: new u.CouplingContainer(),
            secondaryStructures: new Array()
          },
          filters: [],
          height: "100%",
          highlightColor: "#ff8800",
          isDataLoading: !1,
          observedColor: "#0000ff",
          onBoxSelection: c.EMPTY_FUNCTION,
          removeAllLockedResiduePairs: c.EMPTY_FUNCTION,
          removeAllSelectedSecondaryStructures: c.EMPTY_FUNCTION,
          removeHoveredResidues: c.EMPTY_FUNCTION,
          removeHoveredSecondaryStructure: c.EMPTY_FUNCTION,
          removeSecondaryStructure: c.EMPTY_FUNCTION,
          toggleLockedResiduePair: c.EMPTY_FUNCTION,
          width: "100%"
        }, n;
      }(l.BioblocksVisualization);
      t.ContactMapContainerClass = f;
      t.ContactMapContainer = s.connectWithBBStore(function (e) {
        return {
          hoveredResidues: h.getHovered(e).toArray(),
          hoveredSecondaryStructures: h.selectCurrentItems(e, "secondaryStructure/hovered").toArray(),
          lockedResiduePairs: h.getLocked(e).toJS(),
          selectedSecondaryStructures: h.selectCurrentItems(e, "secondaryStructure/selected").toArray()
        };
      }, function (e) {
        return o.bindActionCreators({
          addHoveredResidues: a.createResiduePairActions().hovered.set,
          addHoveredSecondaryStructure: a.createContainerActions("secondaryStructure/hovered").add,
          addSelectedSecondaryStructure: a.createContainerActions("secondaryStructure/selected").add,
          removeAllLockedResiduePairs: a.createResiduePairActions().locked.clear,
          removeAllSelectedSecondaryStructures: a.createContainerActions("secondaryStructure/selected").clear,
          removeHoveredResidues: a.createResiduePairActions().hovered.clear,
          removeHoveredSecondaryStructure: a.createContainerActions("secondaryStructure/hovered").remove,
          removeSecondaryStructure: a.createContainerActions("secondaryStructure/selected").remove,
          toggleLockedResiduePair: a.createResiduePairActions().locked.toggle
        }, e);
      }, f);
    },
    "./src/container/InfoPanelContainer.tsx": function srcContainerInfoPanelContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = n("./src/component/index.ts"),
        s = n("./src/data/index.ts"),
        l = n("./src/selector/index.ts"),
        u = function (e) {
          function t(t) {
            return e.call(this, t) || this;
          }
          return r.__extends(t, e), t.prototype.render = function () {
            var e = this,
              t = this.props,
              n = t.data,
              r = t.height,
              a = t.lockedResiduePairs,
              s = t.selectedSecondaryStructures,
              l = t.width,
              u = n.pdbData,
              c = u && u.experimental ? this.renderUnassignedResidues(u.experimental) : [i.createElement(o.Label, {
                key: "unassigned-residues-none"
              })];
            return i.createElement("div", {
              className: "InfoPanel",
              style: {
                height: r,
                width: l
              }
            }, i.createElement(o.Accordion, {
              exclusive: !1,
              panels: [u && u.experimental && u.experimental.secondaryStructureSections.map(function (t) {
                return {
                  content: e.renderSecondaryStructures(t),
                  key: "all-secondary-structures",
                  title: "All Secondary Structures (" + (u.experimental ? u.experimental.secondaryStructureSections.length : 0) + "):"
                };
              }), {
                content: c,
                key: "unassigned-residues",
                title: "Unassigned Residues (" + c.length + "):"
              }, {
                content: this.renderSecondaryStructures(s),
                key: "selected-secondary-structures",
                title: "Selected Secondary Structures (" + s.length + "):"
              }, {
                content: this.renderLockedResiduePairs(a),
                key: "selected-residue-pairs",
                title: "Selected Residue Pairs (" + a.size + "):"
              }]
            }));
          }, t.prototype.renderLockedResiduePairs = function (e) {
            return 0 === Object.keys(e).length ? [i.createElement(o.Label, {
              key: "locked-residue-pair-none"
            }, "None")] : Array.from(Object.values(e)).map(function (e, t) {
              return i.createElement(o.Label, {
                key: "locked-residue-pair-" + t
              }, e.join(", "));
            });
          }, t.prototype.renderSecondaryStructures = function (e) {
            return 0 === e.length ? [i.createElement(o.Label, {
              key: "sec-struct-none"
            }, "None")] : e.map(function (e, t) {
              return i.createElement(o.Label, {
                key: "sec-struct-" + t
              }, "[" + e.start + "-" + e.end + "]: " + e.label + " - " + s.SECONDARY_STRUCTURE_CODES[e.label]);
            });
          }, t.prototype.renderUnassignedResidues = function (e) {
            var t = new Array();
            return e.eachResidue(function (n) {
              var a, s, l, u;
              if (n.isProtein()) {
                var c = !0;
                try {
                  for (var d = r.__values(e.secondaryStructureSections), h = d.next(); !h.done; h = d.next()) {
                    var f = h.value;
                    try {
                      for (var p = (l = void 0, r.__values(f)), m = p.next(); !m.done; m = p.next()) {
                        if (m.value.contains(n.resno)) {
                          c = !1;
                          break;
                        }
                      }
                    } catch (e) {
                      l = {
                        error: e
                      };
                    } finally {
                      try {
                        m && !m.done && (u = p.return) && u.call(p);
                      } finally {
                        if (l) throw l.error;
                      }
                    }
                  }
                } catch (e) {
                  a = {
                    error: e
                  };
                } finally {
                  try {
                    h && !h.done && (s = d.return) && s.call(d);
                  } finally {
                    if (a) throw a.error;
                  }
                }
                c && t.push(i.createElement(o.Label, {
                  key: "unassigned-residue-" + n.resno
                }, "[" + n.resno + ": isCg? " + n.isCg() + ",               isDna? " + n.isDna() + ",               isHelix? " + n.isHelix() + ",               isNucleic? " + n.isNucleic() + ",               isProtein? " + n.isProtein() + ",               isPolymer? " + n.isPolymer() + ",               isSaccharide? " + n.isSaccharide() + ",               isSheet? " + n.isSheet() + ",              isTurn? " + n.isTurn(), "}"));
              }
            }), t;
          }, t.defaultProps = {
            data: {
              couplingScores: new s.CouplingContainer(),
              pdbData: {},
              secondaryStructures: new Array()
            },
            height: 400,
            lockedResiduePairs: {},
            selectedSecondaryStructures: [],
            width: 400
          }, t;
        }(i.Component);
      t.InfoPanelContainerClass = u;
      t.InfoPanelContainer = a.connectWithBBStore(function (e) {
        return {
          lockedResiduePairs: l.getLocked(e).toJS(),
          selectedSecondaryStructures: l.selectCurrentItems(e, "secondaryStructure/selected").toArray()
        };
      }, void 0, u);
    },
    "./src/container/NGLContainer.tsx": function srcContainerNGLContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("react")),
        a = n("./node_modules/redux/es/redux.js"),
        s = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        l = n("./src/action/index.ts"),
        u = n("./src/action/ResiduePairAction.ts"),
        c = n("./src/component/index.ts"),
        d = n("./src/container/index.ts"),
        h = n("./src/data/index.ts"),
        f = n("./src/helper/index.ts"),
        p = n("./src/reducer/index.ts"),
        m = n("./src/selector/index.ts"),
        g = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.onExperimentalProteinSelect = function (e, t) {
              var i = t.value.split(" ")[0];
              n.setState({
                selectedExperimentalProteins: t.checked ? r.__spread(n.state.selectedExperimentalProteins, [i]) : n.state.selectedExperimentalProteins.filter(function (e) {
                  return e !== i;
                })
              });
            }, n.onPredictedProteinSelect = function (e, t) {
              var i = t.value.split(" ")[0];
              n.setState({
                selectedPredictedProteins: t.checked ? r.__spread(n.state.selectedPredictedProteins, [i]) : n.state.selectedPredictedProteins.filter(function (e) {
                  return e !== i;
                })
              });
            }, n.renderPDBTableBody = function (e, t, r, i) {
              return o.createElement(s.Table.Body, null, n.renderPDBTableBodyRows(e, t, r, i));
            }, n.renderPDBTableBodyRows = function (e, t, r, i) {
              var a = n.state,
                l = a.selectedExperimentalProteins,
                u = a.selectedPredictedProteins;
              return e.map(function (e, a) {
                return o.createElement(s.Table.Row, {
                  key: "pdb-radio-" + t + "-" + a
                }, o.createElement(s.Table.Cell, {
                  style: r
                }, o.createElement(s.Popup, {
                  position: "bottom center",
                  pinned: !0,
                  trigger: o.createElement(s.Checkbox, {
                    checked: ("experimental" === t ? l : u).includes(e.uuid),
                    onChange: i,
                    value: e.uuid,
                    label: e.name.split("_").reverse().slice(0, 4).reverse().join("_")
                  })
                }, e.name)), n.renderPDBTableSequenceCell(t, r, e), n.renderPDBTableSourceCell(t, r, e), n.renderPDBTableRankCell(t, r, e));
              });
            }, n.renderPDBTableHeader = function (e, t) {
              return o.createElement(s.Table.Header, null, o.createElement(s.Table.Row, null, o.createElement(s.Table.HeaderCell, {
                style: t
              }, "Name"), n.renderPDBTableSequenceHeader(e, t), n.renderPDBTableSourceHeader(e, t), n.renderPDBTableRankHeader(e, t)));
            }, n.renderPDBTableRankCell = function (e, t, n) {
              return "predicted" === e && o.createElement(s.Table.Cell, {
                style: t
              }, n.rank);
            }, n.renderPDBTableRankHeader = function (e, t) {
              return "predicted" === e && o.createElement(s.Table.HeaderCell, {
                style: t
              }, "Rank");
            }, n.renderPDBTableSequenceCell = function (e, t, r) {
              return "experimental" === e && o.createElement(s.Table.Cell, {
                style: t
              }, n.state.predictedProteins.length >= 1 ? "" + n.sequenceSimilarityPercent(r.sequence, n.state.predictedProteins[0].sequence) : "N/A");
            }, n.renderPDBTableSequenceHeader = function (e, t) {
              return "experimental" === e && o.createElement(s.Table.HeaderCell, {
                style: t
              }, "Seq. ID");
            }, n.renderPDBTableSourceCell = function (e, t, n) {
              return "experimental" === e && o.createElement(s.Table.Cell, {
                style: t
              }, n.source);
            }, n.renderPDBTableSourceHeader = function (e, t) {
              return "experimental" === e && o.createElement(s.Table.HeaderCell, {
                style: t
              }, "Source");
            }, n.state = {
              experimentalProteins: [],
              predictedProteins: [],
              selectedExperimentalProteins: [],
              selectedPredictedProteins: []
            }, n.setupDataServices(), n;
          }
          return r.__extends(t, e), t.prototype.componentDidMount = function () {
            return r.__awaiter(this, void 0, void 0, function () {
              var e, t, n, i, o;
              return r.__generator(this, function (r) {
                return e = this.state, t = e.experimentalProteins, n = e.predictedProteins, i = t.length >= 1 ? [t[0].uuid] : [], o = n.length >= 1 ? [n[0].uuid] : [], this.setState({
                  selectedExperimentalProteins: i,
                  selectedPredictedProteins: o
                }), [2];
              });
            });
          }, t.prototype.componentDidUpdate = function (e, t) {
            return r.__awaiter(this, void 0, void 0, function () {
              var e,
                n,
                i,
                o,
                a,
                s,
                l,
                u,
                c,
                d = this;
              return r.__generator(this, function (f) {
                switch (f.label) {
                  case 0:
                    return e = this.props, n = e.experimentalProteins, i = e.predictedProteins, [4, Promise.all(n.map(function (e) {
                      return r.__awaiter(d, void 0, void 0, function () {
                        return r.__generator(this, function (t) {
                          return [2, "string" == typeof e ? h.BioblocksPDB.createPDB(e) : e];
                        });
                      });
                    }))];
                  case 1:
                    return o = f.sent(), [4, Promise.all(i.map(function (e) {
                      return r.__awaiter(d, void 0, void 0, function () {
                        return r.__generator(this, function (t) {
                          return [2, "string" == typeof e ? h.BioblocksPDB.createPDB(e) : e];
                        });
                      });
                    }))];
                  case 2:
                    return a = f.sent(), s = this.state, l = s.selectedExperimentalProteins, u = s.selectedPredictedProteins, c = !1, this.isBioblocksPDBArrayEqual(o, t.experimentalProteins) || (c = !0, l = 0 === o.length ? [] : [o[0].uuid]), this.isBioblocksPDBArrayEqual(a, t.predictedProteins) || (c = !0, u = 0 === a.length ? [] : [a[0].uuid]), c && this.setState({
                      experimentalProteins: o,
                      predictedProteins: a,
                      selectedExperimentalProteins: l,
                      selectedPredictedProteins: u
                    }), [2];
                }
              });
            });
          }, t.prototype.setupDataServices = function () {
            p.createContainerReducer("secondaryStructure/hovered"), p.createContainerReducer("secondaryStructure/selected"), p.createContainerReducer("pdb"), p.createResiduePairReducer();
          }, t.prototype.render = function () {
            var e = this.props,
              t = e.lockedResiduePairs,
              n = r.__rest(e, ["lockedResiduePairs"]),
              i = this.state,
              a = i.experimentalProteins,
              l = i.predictedProteins,
              u = i.selectedExperimentalProteins,
              d = i.selectedPredictedProteins;
            return o.createElement(s.Grid, {
              padded: !0
            }, o.createElement(s.Grid.Row, null, o.createElement(c.NGLComponent, r.__assign({}, n, {
              experimentalProteins: a.filter(function (e) {
                return u.includes(e.uuid);
              }),
              lockedResiduePairs: t.toJS(),
              menuItems: [{
                component: {
                  name: "POPUP",
                  props: {
                    children: this.renderPDBSelector(),
                    disabled: 0 === a.length && 0 === l.length,
                    position: "top center",
                    wide: "very"
                  }
                },
                description: "PDB Selector",
                iconName: "tasks"
              }],
              predictedProteins: l.filter(function (e) {
                return d.includes(e.uuid);
              })
            }))));
          }, t.prototype.isBioblocksPDBArrayEqual = function (e, t) {
            return e.length === t.length && e.reduce(function (e, n, r) {
              return e && n.uuid === t[r].uuid;
            }, !0);
          }, t.prototype.renderPDBSelector = function () {
            return o.createElement(s.Grid, {
              divided: !0,
              padded: !0
            }, o.createElement(s.Grid.Row, null, o.createElement(s.Grid.Column, null, o.createElement(s.Header, null, "Select Structures to Display"))), o.createElement(s.Grid.Row, {
              columns: 2,
              style: {
                padding: "5px 0"
              }
            }, o.createElement(s.Grid.Column, {
              width: 9
            }, "Experimental (" + this.state.selectedExperimentalProteins.length + "/" + this.props.experimentalProteins.length + ")", this.renderPDBTable(this.state.experimentalProteins, "experimental", this.onExperimentalProteinSelect)), o.createElement(s.Grid.Column, {
              width: 7
            }, "Predicted (" + this.state.selectedPredictedProteins.length + "/" + this.props.predictedProteins.length + ")", this.renderPDBTable(this.state.predictedProteins, "predicted", this.onPredictedProteinSelect))));
          }, t.prototype.renderPDBTable = function (e, t, n) {
            var r = this.props.maxPDBPerPopup,
              i = {
                padding: "5px 0"
              };
            return o.createElement("div", {
              style: {
                height: 50 * r + "px",
                overflow: "auto"
              }
            }, o.createElement(s.Table, {
              basic: "very",
              compact: !0,
              padded: !0
            }, this.renderPDBTableHeader(t, i), this.renderPDBTableBody(e, t, i, n)));
          }, t.prototype.sequenceSimilarityPercent = function (e, t, n) {
            void 0 === n && (n = 1);
            var r = e.split("").reduce(function (e, n, r) {
              return e + (n === t[r] ? 1 : 0);
            }, 0) / e.length * 100;
            return isNaN(r) ? "N/A" : r.toFixed(n) + "%";
          }, t.defaultProps = {
            dispatchNglFetch: f.EMPTY_FUNCTION,
            experimentalProteins: [],
            isDataLoading: !1,
            lockedResiduePairs: i.Map(),
            maxPDBPerPopup: 5,
            measuredProximity: h.CONTACT_DISTANCE_PROXIMITY.C_ALPHA,
            predictedProteins: [],
            showConfigurations: !0
          }, t;
        }(d.BioblocksVisualization);
      t.NGLContainerClass = g;
      t.NGLContainer = c.connectWithBBStore(function (e) {
        return {
          candidateResidues: m.getCandidates(e).toArray(),
          hoveredResidues: m.getHovered(e).toArray(),
          hoveredSecondaryStructures: m.selectCurrentItems(e, "secondaryStructure/hovered").toArray(),
          lockedResiduePairs: m.getLocked(e),
          removeNonLockedResidues: function removeNonLockedResidues() {
            var e = u.createResiduePairActions(),
              t = e.candidates,
              n = e.hovered;
            t.clear(), n.clear();
          },
          selectedSecondaryStructures: m.selectCurrentItems(e, "secondaryStructure/selected").toArray()
        };
      }, function (e) {
        return a.bindActionCreators({
          addCandidateResidues: u.createResiduePairActions().candidates.addMultiple,
          addHoveredResidues: u.createResiduePairActions().hovered.set,
          addLockedResiduePair: u.createResiduePairActions().locked.add,
          removeAllLockedResiduePairs: u.createResiduePairActions().locked.clear,
          removeAllSelectedSecondaryStructures: l.createContainerActions("secondaryStructure/selected").clear,
          removeCandidateResidues: u.createResiduePairActions().candidates.clear,
          removeHoveredResidues: u.createResiduePairActions().hovered.clear,
          removeLockedResiduePair: u.createResiduePairActions().locked.remove
        }, e);
      }, g);
    },
    "./src/container/ProteinFeatureViewer.tsx": function srcContainerProteinFeatureViewerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("react")),
        o = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        a = n("./src/component/index.ts"),
        s = n("./src/data/index.ts"),
        l = n("./src/helper/index.ts");
      t.SAMPLE_PROTEIN_IDS = {
        "3Domains": "Q8TDF5",
        "5Domains": "Q96L73",
        DLL3_HUMAN: "Q9NYJ7",
        SMAD4_HUMAN: "Q13485"
      };
      var u = function (e) {
        function n(t) {
          var n = e.call(this, t) || this;
          return n.getPFamFamilyLink = function (e) {
            return '<a href="http://pfam.xfam.org/family/' + e.id + '">PFAM</a>';
          }, n.getPFamDomainLink = function (e) {
            return '<a href="http://mutationaligner.org/domains/' + e.id + '">Mutagen Aligner</a>';
          }, n.getPFamLinks = function (e) {
            return n.getPFamFamilyLink(e[0]) + " " + n.getPFamDomainLink(e[0]);
          }, n.initializeProteinData = function (e) {
            var t = e.features.filter(function (e) {
                return "DOMAIN" === e.type;
              }),
              r = new l.ColorMapper(),
              i = t.map(function (e, t) {
                var n = e.begin,
                  i = e.description,
                  o = void 0 === i ? "" : i,
                  a = e.end,
                  l = o.split("-like")[0];
                return new s.TintedBioblocks1DSection(l, n ? Number.parseInt(n, 10) : -1, a ? Number.parseInt(a, 10) : -1, r.getColorFor(l));
              });
            n.setState({
              domainData: i,
              protein: e
            });
          }, n.onProteinInputChange = function (e, t) {
            n.setState({
              proteinId: t.value
            });
          }, n.onProteinInputSubmit = function (e, t) {
            return r.__awaiter(n, void 0, void 0, function () {
              return r.__generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    return [4, this.deriveProteinData()];
                  case 1:
                    return e.sent(), [2];
                }
              });
            });
          }, n.onShowGroupedChange = function (e, t) {
            n.setState({
              showGrouped: void 0 !== t.checked ? t.checked : n.state.showGrouped
            });
          }, n.renderAnnotationText = function (e, t) {
            var r = n.state,
              i = r.domainData,
              o = r.protein,
              a = o ? o.dbReferences.filter(function (e) {
                return "Pfam" === e.type;
              }).filter(function (n) {
                var r = n.properties,
                  i = r ? r["entry name"] : null;
                return i && (i === e || i.localeCompare(e + "-like " + t));
              }) : [];
            return a.length >= 1 ? e + ": " + e + " domain (" + i[t].start + " - " + i[t].end + ")<br />" + n.getPFamLinks(a) : "";
          }, n.renderProteinForm = function (e) {
            return i.createElement(o.Form, {
              onSubmit: n.onProteinInputSubmit
            }, i.createElement(o.Form.Input, {
              onChange: n.onProteinInputChange,
              value: e,
              fluid: !1,
              width: "three"
            }), i.createElement(o.Form.Button, null, "Submit Protein ID"), i.createElement(o.Form.Checkbox, {
              defaultChecked: !0,
              label: "Show grouped?",
              onChange: n.onShowGroupedChange
            }));
          }, n.state = {
            data: [],
            domainData: [],
            proteinId: t.initialProteinId,
            showGrouped: !0
          }, n;
        }
        return r.__extends(n, e), n.prototype.componentDidMount = function () {
          return r.__awaiter(this, void 0, void 0, function () {
            return r.__generator(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, this.deriveProteinData()];
                case 1:
                  return e.sent(), [2];
              }
            });
          });
        }, n.prototype.render = function () {
          var e = this.state,
            t = e.domainData,
            n = e.protein,
            r = e.proteinId,
            s = e.showGrouped;
          return i.createElement("div", {
            className: "protein-feature-viewer"
          }, i.createElement(o.GridRow, {
            centered: !0,
            stretched: !1
          }, i.createElement(o.GridColumn, null, i.createElement(a.FeatureViewer, {
            data: t,
            getTextForHover: this.renderAnnotationText,
            title: n ? n.id : "",
            showGrouped: s
          })), i.createElement(o.GridColumn, null, this.renderProteinForm(r))));
        }, n.prototype.deriveProteinData = function () {
          return r.__awaiter(this, void 0, void 0, function () {
            var e, t, n;
            return r.__generator(this, function (r) {
              switch (r.label) {
                case 0:
                  return r.trys.push([0, 4,, 5]), [4, fetch("https://www.ebi.ac.uk/proteins/api/proteins/" + this.state.proteinId)];
                case 1:
                  return (e = r.sent()) && e.ok ? [4, e.json()] : [3, 3];
                case 2:
                  t = r.sent(), this.initializeProteinData(t), r.label = 3;
                case 3:
                  return [3, 5];
                case 4:
                  return n = r.sent(), console.error(n), [3, 5];
                case 5:
                  return [2];
              }
            });
          });
        }, n.defaultProps = {
          initialProteinId: t.SAMPLE_PROTEIN_IDS.DLL3_HUMAN
        }, n;
      }(i.Component);
      t.ProteinFeatureViewer = u;
    },
    "./src/container/SpringContainer.tsx": function srcContainerSpringContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("react")),
        a = r.__importDefault(n("./node_modules/react-iframe-comm/dist/IframeComm.js")),
        s = n("./node_modules/redux/es/redux.js"),
        l = n("./src/action/index.ts"),
        u = n("./src/component/index.ts"),
        c = n("./src/container/index.ts"),
        d = n("./src/helper/index.ts"),
        h = n("./src/reducer/index.ts"),
        f = n("./src/selector/index.ts"),
        p = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.onReady = function () {}, n.onReceiveMessage = function (e) {
              var t = n.props,
                r = t.currentCells,
                i = t.setCurrentCategory,
                o = t.setCurrentCells,
                a = e.data;
              switch (a.type) {
                case "selected-category-update":
                case "selected-cells-update":
                  var s = a.payload,
                    l = s.currentCategory,
                    u = s.indices;
                  i(l || ""), o(u);
                  break;
                case "loaded":
                  n.setState({
                    postMessageData: {
                      payload: {
                        indices: r.toArray()
                      },
                      type: "init"
                    }
                  });
                  break;
                default:
                  if (e.isTrusted && 1 === Object.keys(e).length) return;
                  console.log("Got this msg for ya: " + JSON.stringify(e));
              }
            }, n.generateSpringURL = function (e) {
              return n.props.springSrc + "?../" + e;
            }, console.log("SpringContainer class"), n.state = {
              postMessageData: {
                payload: {},
                type: "init"
              },
              springUrl: n.generateSpringURL(n.props.datasetLocation)
            }, n;
          }
          return r.__extends(t, e), t.prototype.setupDataServices = function () {
            h.createSpringReducer(), this.registerDataset("cells", []), this.registerDataset("labels", []);
          }, t.prototype.componentDidMount = function () {
            var e = this,
              t = this.props,
              n = t.datasetLocation,
              i = t.datasetsURI;
            (0, t.dispatchSpringFetch)(function () {
              return r.__awaiter(e, void 0, void 0, function () {
                return r.__generator(this, function (e) {
                  return [2, d.fetchSpringData(window.location.href + "/" + i + "/" + n)];
                });
              });
            });
          }, t.prototype.componentDidUpdate = function (e, t) {
            var n = this.props,
              r = n.currentCells,
              i = n.datasetLocation;
            if (r !== e.currentCells) this.setState({
              postMessageData: {
                payload: {
                  indices: r.toArray()
                },
                type: "selected-cells-update"
              }
            });else if (e.datasetLocation !== i) {
              var o = this.generateSpringURL(i);
              this.setState({
                springUrl: o
              });
            }
          }, t.prototype.render = function () {
            var e = this.props,
              n = e.headerHeight,
              r = e.iconSrc,
              i = e.isFullPage,
              s = e.springHeight,
              l = e.springWidth,
              c = this.state,
              d = c.postMessageData,
              h = c.springUrl,
              f = {
                allowFullScreen: !0,
                height: s + n,
                src: h,
                width: l
              },
              p = h.split("/");
            return o.createElement(u.ComponentCard, {
              componentName: t.displayName,
              iconSrc: r,
              isFramedComponent: !0,
              isFullPage: i,
              frameHeight: s,
              frameWidth: l
            }, o.createElement(a.default, {
              attributes: f,
              postMessageData: d,
              handleReady: this.onReady,
              handleReceiveMessage: this.onReceiveMessage,
              targetOrigin: p[0] + "//" + p[2]
            }));
          }, t.defaultProps = {
            categories: i.Set(),
            currentCells: i.Set(),
            datasetLocation: "../datasets/hpc/full",
            datasetsURI: "",
            dispatchSpringFetch: d.EMPTY_FUNCTION,
            headerHeight: 0,
            isFullPage: !1,
            padding: 0,
            selectedCategory: "",
            setCurrentCategory: d.EMPTY_FUNCTION,
            setCurrentCells: d.EMPTY_FUNCTION,
            springGraphData: {
              links: new Array(),
              nodes: new Array()
            },
            springHeight: 1150,
            springSrc: window.location.origin + "/" + window.location.pathname.substr(0, window.location.pathname.lastIndexOf("/")) + "/SPRING/springViewer.html",
            springWidth: 1150
          }, t.displayName = "SPRING", t;
        }(c.BioblocksVisualization);
      t.SpringContainerClass = p;
      t.SpringContainer = u.connectWithBBStore(function (e) {
        return {
          categories: f.getCategories(e, void 0),
          currentCells: f.selectCurrentItems(e, "cells"),
          springGraphData: f.getGraphData(e)
        };
      }, function (e) {
        return s.bindActionCreators({
          dispatchSpringFetch: l.fetchSpringGraphData,
          setCurrentCategory: l.createSpringActions().category.set,
          setCurrentCells: l.createContainerActions("cells").set
        }, e);
      }, p);
    },
    "./src/container/TensorTContainer.tsx": function srcContainerTensorTContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("./node_modules/@tensorflow/tfjs-core/dist/tf-core.esm.js")),
        o = n("./node_modules/@tensorflow/tfjs-tsne/dist/tsne.js"),
        a = n("./node_modules/immutable/dist/immutable.js"),
        s = r.__importStar(n("react")),
        l = n("./node_modules/redux/es/redux.js"),
        u = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        c = n("./src/action/index.ts"),
        d = n("./src/component/index.ts"),
        h = n("./src/container/index.ts"),
        f = n("./src/data/index.ts"),
        p = n("./src/helper/index.ts"),
        m = n("./src/selector/ContainerSelectors.ts"),
        g = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.canvasContext = null, n.getPlotlyCoordsFromTsne = function (e) {
              var t = n.props,
                r = t.currentCells;
              return [{
                marker: {
                  color: t.pointColor
                },
                mode: "markers",
                type: "scattergl",
                x: e.map(function (e) {
                  return e[0];
                }),
                y: e.map(function (e) {
                  return e[1];
                })
              }, {
                marker: {
                  color: n.props.pointColor,
                  line: {
                    color: "#ffaa00",
                    width: 2
                  }
                },
                mode: "markers",
                type: "scattergl",
                x: r.toArray().map(function (t) {
                  return e[t][0];
                }),
                y: r.toArray().map(function (t) {
                  return e[t][1];
                })
              }];
            }, n.getPlotlyCoordsFromSpring = function (e, t) {
              return [{
                marker: {
                  color: n.props.pointColor
                },
                mode: "markers",
                type: "scattergl",
                x: e.map(function (e) {
                  return e[0];
                }),
                y: e.map(function (e) {
                  return e[1];
                })
              }, {
                marker: {
                  color: n.props.pointColor,
                  line: {
                    color: "#ffaa00",
                    width: 2
                  }
                },
                mode: "markers",
                type: "scattergl",
                x: t.map(function (t) {
                  return e[t][0];
                }),
                y: t.map(function (t) {
                  return e[t][1];
                })
              }];
            }, n.getTensorConfigs = function () {
              return [{
                name: "Iterate Once",
                onClick: n.onIterateForward(),
                type: f.CONFIGURATION_COMPONENT_TYPE.BUTTON
              }, {
                name: "Iterate Ten Times",
                onClick: n.onIterateForward(10),
                type: f.CONFIGURATION_COMPONENT_TYPE.BUTTON
              }, {
                name: "Iterate Fifty Times",
                onClick: n.onIterateForward(50),
                type: f.CONFIGURATION_COMPONENT_TYPE.BUTTON
              }, {
                name: "Reset",
                onClick: n.onReset(),
                type: f.CONFIGURATION_COMPONENT_TYPE.BUTTON
              }, {
                icon: "hashtag",
                name: "Total Iterations: " + n.state.numIterations,
                type: f.CONFIGURATION_COMPONENT_TYPE.LABEL
              }];
            }, n.handlePointSelection = function (e) {
              for (var t = n.props.setCurrentCells, r = n.state.coordsArray, i = new Array(), o = function o(t) {
                  var n = e.selectedPoints[t],
                    o = e.selectedPoints[t + 1],
                    a = r.findIndex(function (e) {
                      return e[0] === n && e[1] === o;
                    });
                  a >= 0 && i.push(a);
                }, a = 0; a < e.selectedPoints.length - 1; a += 2) o(a);
              t(i);
            }, n.renderIterateLabel = function () {
              return s.createElement("label", null, "iterations: " + n.state.numIterations);
            }, n.renderIterateButton = function () {
              return s.createElement(u.Radio, {
                label: s.createElement("label", {
                  style: {
                    fontSize: "14px",
                    fontWeight: "bold"
                  }
                }, "iterate"),
                onClick: n.onIterationToggle(),
                toggle: !0
              });
            }, n.renderResetButton = function () {
              return s.createElement(u.Icon, {
                name: "undo",
                onClick: n.onReset()
              });
            }, n.onIterateForward = function (e) {
              return void 0 === e && (e = 1), function () {
                return r.__awaiter(n, void 0, void 0, function () {
                  var t, n, i, o;
                  return r.__generator(this, function (r) {
                    switch (r.label) {
                      case 0:
                        return t = this.state, n = t.isComputing, !(i = t.tsne) || n ? [3, 3] : (this.setState({
                          isComputing: !0
                        }), [4, i.iterate(e)]);
                      case 1:
                        return r.sent(), [4, i.coordsArray()];
                      case 2:
                        o = r.sent(), this.getPlotlyCoordsFromTsne(o), this.setState({
                          coordsArray: o,
                          isComputing: !1,
                          numIterations: this.state.numIterations + e
                        }), r.label = 3;
                      case 3:
                        return [2];
                    }
                  });
                });
              };
            }, n.onIterationToggle = function () {
              return function () {
                var e = !n.state.isAnimating;
                if (e) {
                  var t = function t() {
                    return r.__awaiter(n, void 0, void 0, function () {
                      return r.__generator(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return [4, this.onIterateForward(1)()];
                          case 1:
                            return e.sent(), this.state.isAnimating && this.state.numIterations < 500 ? requestAnimationFrame(t) : this.setState({
                              isAnimating: !1
                            }), [2];
                        }
                      });
                    });
                  };
                  requestAnimationFrame(t);
                }
                n.setState({
                  isAnimating: e
                });
              };
            }, n.onReset = function () {
              return function () {
                return r.__awaiter(n, void 0, void 0, function () {
                  return r.__generator(this, function (e) {
                    switch (e.label) {
                      case 0:
                        return [4, this.computeTensorTsne(0)];
                      case 1:
                        return e.sent(), [2];
                    }
                  });
                });
              };
            }, n.renderPlaybackControls = function () {
              return s.createElement(u.Grid.Row, {
                columns: "equal",
                style: {
                  maxHeight: "42px",
                  padding: "14px 0 0 0"
                }
              }, s.createElement(u.Grid.Column, {
                floated: "left"
              }, n.renderIterateButton()), s.createElement(u.Grid.Column, null, n.renderIterateLabel()), s.createElement(u.Grid.Column, {
                floated: "right"
              }, n.renderResetButton()));
            }, n.state = {
              coordsArray: [],
              isAnimating: !1,
              isComputing: !1,
              numIterations: 0
            }, n;
          }
          return r.__extends(t, e), t.prototype.setupDataServices = function () {
            this.registerDataset("cells", []);
          }, t.prototype.componentDidMount = function () {
            return r.__awaiter(this, void 0, void 0, function () {
              var e, t, o, a;
              return r.__generator(this, function (s) {
                switch (s.label) {
                  case 0:
                    return s.trys.push([0, 4,, 5]), [4, p.fetchTensorTSneCoordinateData(this.props.datasetLocation)];
                  case 1:
                    return e = s.sent(), t = i.tensor(e), [4, Promise.resolve().then(function () {
                      return r.__importStar(n("./node_modules/@tensorflow/tfjs-tsne/dist-es6/index.js"));
                    })];
                  case 2:
                    return o = s.sent().tsne(t), this.setState({
                      tsne: o
                    }), [4, this.computeTensorTsne(this.state.numIterations)];
                  case 3:
                    return s.sent(), [3, 5];
                  case 4:
                    return a = s.sent(), console.log(a), [3, 5];
                  case 5:
                    return [2];
                }
              });
            });
          }, t.prototype.componentDidUpdate = function (e) {
            return r.__awaiter(this, void 0, void 0, function () {
              var t, n, i, o, a, s;
              return r.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return t = this.props, n = t.currentCells, i = t.datasetLocation, o = this.state.tsne, i === e.datasetLocation ? [3, 2] : [4, this.setupTensorData()];
                  case 1:
                    return r.sent(), [3, 4];
                  case 2:
                    return o ? n === e.currentCells ? [3, 4] : (a = this.setState, s = {}, [4, o.coordsArray()]) : [3, 4];
                  case 3:
                    a.apply(this, [(s.coordsArray = r.sent(), s)]), r.label = 4;
                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.render = function () {
            var e = this.props,
              n = e.currentCells,
              r = e.height,
              i = e.iconSrc,
              o = e.isFullPage,
              a = e.pointColor,
              l = this.state.coordsArray;
            return s.createElement(d.ComponentCard, {
              componentName: t.displayName,
              iconSrc: i,
              isFullPage: o,
              height: r
            }, s.createElement(u.Grid, {
              centered: !0,
              style: {
                height: "100%",
                marginLeft: 0,
                width: "100%"
              }
            }, this.renderPlaybackControls(), s.createElement(u.Grid.Row, {
              style: {
                height: "calc(100% - 3px)",
                margin: 0
              }
            }, s.createElement(d.TensorTComponent, {
              currentCells: n.toArray(),
              onSelectedCallback: this.handlePointSelection,
              coordsArray: l,
              pointColor: a
            }))));
          }, t.prototype.computeTensorTsne = function (e) {
            return r.__awaiter(this, void 0, void 0, function () {
              var t, n, i, o;
              return r.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return t = this.state, n = t.isComputing, !(i = t.tsne) || n ? [3, 3] : (this.setState({
                      isComputing: !0
                    }), [4, i.compute(e)]);
                  case 1:
                    return r.sent(), [4, i.coordsArray()];
                  case 2:
                    o = r.sent(), this.setState({
                      coordsArray: o,
                      isComputing: !1,
                      numIterations: e
                    }), r.label = 3;
                  case 3:
                    return [2];
                }
              });
            });
          }, t.prototype.setupTensorData = function () {
            return r.__awaiter(this, void 0, void 0, function () {
              var e, t, n, a, s, l;
              return r.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return r.trys.push([0, 4,, 5]), this.setState({
                      coordsArray: [],
                      isAnimating: !1,
                      isComputing: !0,
                      tsne: void 0
                    }), [4, p.fetchTensorTSneCoordinateData(this.props.datasetLocation)];
                  case 1:
                    return e = r.sent(), t = i.tensor(e), n = new o.TSNE(t), a = 0, [4, n.compute(a)];
                  case 2:
                    return r.sent(), [4, n.coordsArray()];
                  case 3:
                    return s = r.sent(), this.getPlotlyCoordsFromTsne(s), this.setState({
                      coordsArray: s,
                      isComputing: !1,
                      numIterations: a
                    }), [3, 5];
                  case 4:
                    return l = r.sent(), console.log(l), [3, 5];
                  case 5:
                    return [2];
                }
              });
            });
          }, t.defaultProps = {
            currentCells: a.Set(),
            datasetLocation: "hpc/full",
            height: "525px",
            isFullPage: !1,
            pointColor: "#aa0000",
            setCurrentCells: p.EMPTY_FUNCTION,
            style: {
              padding: 0
            },
            width: 400
          }, t.displayName = "tSNE - TensorFlow", t;
        }(h.BioblocksVisualization);
      t.TensorTContainerClass = g;
      t.TensorTContainer = d.connectWithBBStore(function (e) {
        return {
          currentCells: m.selectCurrentItems(e, "cells")
        };
      }, function (e) {
        return l.bindActionCreators({
          setCurrentCells: c.createContainerActions("cells").set
        }, e);
      }, g);
    },
    "./src/container/UMAPSequenceContainer.tsx": function srcContainerUMAPSequenceContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("./node_modules/papaparse/papaparse.min.js")),
        a = r.__importStar(n("react")),
        s = n("./node_modules/redux/es/redux.js"),
        l = n("./node_modules/semantic-ui-react/dist/es/index.js"),
        u = n("./src/action/index.ts"),
        c = n("./src/component/index.ts"),
        d = n("./src/data/index.ts"),
        h = n("./src/helper/index.ts"),
        f = n("./src/selector/index.ts"),
        p = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.equalityHammingDistance = function (e, t) {
              for (var n = 0, r = 0; r < e.length; r++) e[r] !== t[r] && (n += 1);
              return n;
            }, n.getDataLabels = function () {
              var e = n.state,
                t = e.labelCategory,
                r = e.seqNameToTaxonomyMetadata,
                i = e.subsampledSequences,
                o = new Array();
              if (r) {
                var a = i.map(function (e) {
                  if (e.annotations.name && r[e.annotations.name]) return r[e.annotations.name][t];
                });
                o = d.Marker.colors.autoColorFromStates(a);
              }
              return o;
            }, n.onLabelChange = function (e, t) {
              console.log(t), n.setState({
                labelCategory: t ? t.value : n.state.labelCategory
              });
            }, n.onTaxonomyUpload = function (e) {
              return r.__awaiter(n, void 0, void 0, function () {
                var t, n, i;
                return r.__generator(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return e.persist(), (t = e.target.files) ? (n = t.item(0), i = this.parseTaxonomy, [4, h.readFileAsText(n)]) : [2];
                    case 1:
                      return i.apply(this, [r.sent()]), [2];
                  }
                });
              });
            }, n.renderTaxonomyUpload = function () {
              return a.createElement(l.Popup, {
                trigger: n.renderTaxonomyTrigger(),
                content: a.createElement(a.Fragment, null, a.createElement("span", null, "A tab delimited file with 2 columns and optional headers:"), a.createElement("br", null), a.createElement("span", null, "- First column is sequence name."), a.createElement("br", null), a.createElement("span", null, "- Second column is how to group sequences."))
              });
            }, n.renderTaxonomyTrigger = function () {
              return a.createElement(l.Label, {
                as: "label",
                basic: !0,
                htmlFor: "upload-taxonomy"
              }, a.createElement(l.Button, {
                icon: "upload",
                label: {
                  basic: !0,
                  content: "Upload Taxonomy File"
                },
                labelPosition: "right"
              }), a.createElement("input", {
                hidden: !0,
                id: "upload-taxonomy",
                multiple: !1,
                onChange: n.onTaxonomyUpload,
                required: !0,
                type: "file"
              }));
            }, n.setupSequenceAnnotation = function (e, t) {
              n.setState({
                seqNameToTaxonomyMetadata: e.reduce(function (e, n) {
                  var r;
                  return n.annotations.name && n.annotations.metadata && (e[n.annotations.name] = ((r = {})[t] = n.annotations.metadata[t], r)), e;
                }, {})
              });
            }, n.state = {
              labelCategory: "",
              labels: new Array(),
              randomSequencesDataMatrix: new Array(new Array()),
              seqNameToTaxonomyMetadata: {},
              subsampledSequences: new Array(),
              tooltipNames: new Array()
            }, n;
          }
          return r.__extends(t, e), t.prototype.componentDidMount = function () {
            this.prepareData();
          }, t.prototype.componentDidUpdate = function (e, t) {
            var n = this.props,
              r = n.allSequences,
              i = n.labelCategory,
              o = n.numSequencesToShow,
              a = n.taxonomyText;
            if (e.allSequences !== r || e.numSequencesToShow !== o || e.labelCategory !== i || e.taxonomyText !== a) {
              var s = e.allSequences.length === r.length;
              e.allSequences.forEach(function (e, t) {
                r[t] && 0 === e.sequence.localeCompare(r[t].sequence) || (s = !1);
              }), s ? a ? this.parseTaxonomy(a) : this.setupSequenceAnnotation(r, i) : this.prepareData();
            }
          }, t.prototype.render = function () {
            var e = this.props,
              t = (e.allSequences, e.numIterationsBeforeReRender),
              n = e.showUploadButton,
              i = r.__rest(e, ["allSequences", "numIterationsBeforeReRender", "showUploadButton"]),
              o = this.state,
              s = o.labelCategory,
              u = o.labels,
              d = o.randomSequencesDataMatrix,
              h = o.tooltipNames,
              f = this.getDataLabels();
            return a.createElement(l.Grid, {
              centered: !0,
              padded: !0
            }, a.createElement(l.Grid.Row, null, a.createElement(c.UMAPVisualization, r.__assign({
              currentLabel: s,
              dataLabels: f,
              dataMatrix: d,
              distanceFn: this.equalityHammingDistance,
              errorMessages: [],
              labels: u,
              numIterationsBeforeReRender: t,
              onLabelChange: this.onLabelChange,
              tooltipNames: h
            }, i))), n && a.createElement(l.Grid.Row, null, this.renderTaxonomyUpload()));
          }, t.prototype.prepareData = function () {
            var e = this.props,
              t = e.allSequences,
              n = e.labelCategory,
              r = e.numSequencesToShow,
              i = e.taxonomyText;
            i ? this.parseTaxonomy(i) : this.setupSequenceAnnotation(t, n);
            var o = this.state.subsampledSequences;
            o && o.length === r || (o = h.subsample(this.props.allSequences, r)), this.setState({
              labelCategory: n,
              randomSequencesDataMatrix: o.map(function (e) {
                return e.integerRepresentation(["-"]);
              }),
              subsampledSequences: o,
              tooltipNames: o.map(function (e) {
                return e.annotations.name ? e.annotations.name : "";
              })
            });
          }, t.prototype.parseTaxonomy = function (e) {
            var t = this;
            if (e) {
              var n = e.split("\n")[0].includes("seq_name");
              o.parse(e, {
                complete: function complete(e) {
                  t.setState({
                    labels: n ? e.meta.fields.filter(function (e) {
                      return "sequence" !== e.toLocaleLowerCase();
                    }) : [],
                    seqNameToTaxonomyMetadata: e.data.reduce(function (e, r) {
                      var i;
                      if (n) e[r.seq_name] = r;else {
                        var o = r;
                        e[o[0]] = ((i = {
                          seq_name: o[0]
                        })[t.props.labelCategory] = o[1], i);
                      }
                      return e;
                    }, {})
                  });
                },
                header: n
              });
            }
          }, t.defaultProps = {
            currentCells: i.Set(),
            labelCategory: "class",
            numIterationsBeforeReRender: 1,
            numSequencesToShow: 4e3,
            setCurrentCells: h.EMPTY_FUNCTION,
            showUploadButton: !1
          }, t;
        }(a.Component);
      t.UMAPSequenceContainerClass = p;
      t.UMAPSequenceContainer = c.connectWithBBStore(function (e) {
        return {
          currentCells: f.selectCurrentItems(e, "cells")
        };
      }, function (e) {
        return s.bindActionCreators({
          setCurrentCells: u.createContainerActions("cells").set
        }, e);
      }, p);
    },
    "./src/container/UMAPTranscriptionalContainer.tsx": function srcContainerUMAPTranscriptionalContainerTsx(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/immutable/dist/immutable.js"),
        o = r.__importStar(n("react")),
        a = n("./node_modules/redux/es/redux.js"),
        s = n("./src/action/index.ts"),
        l = n("./src/component/index.ts"),
        u = n("./src/container/index.ts"),
        c = n("./src/data/index.ts"),
        d = n("./src/helper/index.ts"),
        h = n("./src/reducer/index.ts"),
        f = n("./src/selector/index.ts"),
        p = function (e) {
          function t(t) {
            var n = e.call(this, t) || this;
            return n.subsampledIndices = new Array(), n.getAnnotations = function () {
              var e = n.props.categoricalAnnotations,
                t = {};
              return e && Object.keys(e).forEach(function (n) {
                var r,
                  i = e[n].label_list,
                  o = e[n].label_colors;
                r = o && 0 !== Object.keys(o).length ? i.map(function (e) {
                  if (o[e]) return {
                    color: o[e],
                    name: e
                  };
                }) : c.Marker.colors.autoColorFromStates(i), t[n] = r;
              }), t;
            }, n.getErrorMessages = function (e) {
              var t = n.props,
                r = t.categoricalAnnotations,
                i = t.dataMatrix,
                o = t.sampleNames,
                a = new Array();
              return o && i.length !== o.length && a.push("The " + o.length + " sample names provided do not account for all " + i.length + " data matrix rows."), !1 === e && r && Object.keys(r).forEach(function (e) {
                r[e].label_list.length !== i.length && a.push("Label category " + e + " does not provide labels for all " + i.length + " samples in the data matrix.");
              }), a;
            }, n.onLabelChange = function (e) {
              var t = n.props,
                r = t.currentLabels,
                i = t.onLabelAdd,
                o = t.onLabelRemove;
              r.contains(e) ? o(e) : i(e);
            }, n.state = {
              completeSampleAnnotations: {},
              errorMessages: []
            }, n;
          }
          return r.__extends(t, e), t.prototype.setupDataServices = function () {
            this.registerDataset("cells", []), this.registerDataset("labels", []), h.BioblocksMiddlewareTransformer.addTransform(this.getLabelToCellTransform());
          }, t.prototype.componentDidMount = function () {
            this.prepareData();
          }, t.prototype.componentDidUpdate = function (e, t) {
            e.dataMatrix === this.props.dataMatrix && e.numSamplesToShow === this.props.numSamplesToShow && e.sampleNames === this.props.sampleNames && e.categoricalAnnotations === this.props.categoricalAnnotations && e.labelCategory === this.props.labelCategory || this.prepareData(e.categoricalAnnotations === this.props.categoricalAnnotations);
          }, t.prototype.render = function () {
            var e,
              t,
              n = this.props,
              i = n.dataMatrix,
              a = n.labelCategory,
              s = n.numIterationsBeforeReRender,
              u = (n.numSamplesToShow, r.__rest(n, ["dataMatrix", "labelCategory", "numIterationsBeforeReRender", "numSamplesToShow"])),
              c = this.state,
              d = c.completeSampleAnnotations,
              h = c.errorMessages,
              f = new Array(),
              p = new Array(),
              m = new Array();
            try {
              for (var g = r.__values(this.subsampledIndices), v = g.next(); !v.done; v = g.next()) {
                var y = v.value;
                if (i[y] && m.push(i[y]), a && d && d[a]) {
                  var b = d[a][y];
                  f.push(b), p.push(b ? b.name : "unannotated");
                }
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                v && !v.done && (t = g.return) && t.call(g);
              } finally {
                if (e) throw e.error;
              }
            }
            return o.createElement(l.UMAPVisualization, r.__assign({
              dataLabels: f,
              dataMatrix: m,
              errorMessages: h,
              numIterationsBeforeReRender: s,
              onLabelChange: this.onLabelChange,
              tooltipNames: p
            }, u));
          }, t.prototype.getLabelToCellTransform = function () {
            var e = this;
            return {
              fn: function fn(t) {
                var n = e.props.currentLabels,
                  r = f.getSpring(t).graphData,
                  o = i.Set();
                return r.nodes.forEach(function (e) {
                  var t = Object.values(e.labelForCategory);
                  n.forEach(function (n) {
                    n && t.includes(n) && (o = o.add(e.number));
                  });
                }), o;
              },
              fromState: "bioblocks/labels",
              toState: "bioblocks/cells"
            };
          }, t.prototype.prepareData = function (e) {
            void 0 === e && (e = !1);
            var t = this.props.numSamplesToShow,
              n = this.getErrorMessages(e),
              r = this.state.completeSampleAnnotations;
            !1 === e && (r = this.getAnnotations()), this.subsampledIndices && this.subsampledIndices.length === t || (this.subsampledIndices = d.subsample(this.props.dataMatrix, t, !0)), this.setState({
              completeSampleAnnotations: r,
              errorMessages: n
            });
          }, t.defaultProps = {
            currentCells: i.Set(),
            currentLabels: i.Set(),
            numIterationsBeforeReRender: 1,
            numSamplesToShow: 4e3,
            onLabelAdd: d.EMPTY_FUNCTION,
            onLabelRemove: d.EMPTY_FUNCTION,
            setCurrentCells: d.EMPTY_FUNCTION
          }, t;
        }(u.BioblocksVisualization);
      t.UMAPTranscriptionalContainerClass = p;
      t.UMAPTranscriptionalContainer = l.connectWithBBStore(function (e) {
        return {
          currentCells: f.selectCurrentItems(e, "cells"),
          currentLabels: f.selectCurrentItems(e, "labels")
        };
      }, function (e) {
        return a.bindActionCreators({
          onLabelAdd: s.createContainerActions("labels").add,
          onLabelRemove: s.createContainerActions("labels").remove,
          setCurrentCells: s.createContainerActions("cells").set
        }, e);
      }, p);
    },
    "./src/container/index.ts": function srcContainerIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/container/BioblocksVisualization.tsx"), t), r.__exportStar(n("./src/container/AnatomogramContainer.tsx"), t), r.__exportStar(n("./src/container/InfoPanelContainer.tsx"), t), r.__exportStar(n("./src/container/NGLContainer.tsx"), t), r.__exportStar(n("./src/container/ContactMapContainer.tsx"), t), r.__exportStar(n("./src/container/ProteinFeatureViewer.tsx"), t), r.__exportStar(n("./src/container/SpringContainer.tsx"), t), r.__exportStar(n("./src/container/TensorTContainer.tsx"), t), r.__exportStar(n("./src/container/UMAPSequenceContainer.tsx"), t), r.__exportStar(n("./src/container/UMAPTranscriptionalContainer.tsx"), t);
    },
    "./src/data/AminoAcid.ts": function srcDataAminoAcidTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/lodash/lodash.js"),
        i = function () {
          function e(e, t, n, r) {
            this.fullName = e, this.singleLetterCode = t, this.threeLetterCode = n, this.codons = r;
          }
          return e.getAllCanonicalAminoAcids = function () {
            return Object.keys(e).reduce(function (t, n) {
              var r = e[n];
              return r instanceof e && t.push(r), t;
            }, new Array());
          }, e.fromFullName = function (t) {
            return e.getAllCanonicalAminoAcids().find(function (e) {
              return e.fullName.toUpperCase() === t.toUpperCase();
            });
          }, e.fromSingleLetterCode = function (t) {
            return e.getAllCanonicalAminoAcids().find(function (e) {
              return e.singleLetterCode.toUpperCase() === t.toUpperCase();
            });
          }, e.fromThreeLetterCode = function (t) {
            return e.getAllCanonicalAminoAcids().find(function (e) {
              return e.threeLetterCode.toUpperCase() === t.toUpperCase();
            });
          }, e.fromCodon = function (t) {
            e.getAllCanonicalAminoAcids().forEach(function (e) {
              e.codons.forEach(function (n) {
                if (n.toUpperCase() === t.toUpperCase()) return e;
              });
            });
          }, e.Alanine = new e("Alanine", "A", "ALA", ["GCT", "GCC", "GCA", "GCG"]), e.Arginine = new e("Arginine", "R", "ARG", ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"]), e.Asparagine = new e("Asparagine", "N", "ASN", ["AAT", "AAC"]), e.AsparticAcid = new e("Aspartic Acid", "D", "ASP", ["GAT", "GAC"]), e.Cysteine = new e("Cysteine", "C", "CYS", ["TGT", "TGC"]), e.Glutamine = new e("Glutamine", "Q", "GLN", ["CAA", "CAG"]), e.GlutamicAcid = new e("Glutamic Acid", "E", "GLU", ["GAA", "GAG"]), e.Glycine = new e("Glycine", "G", "GLY", ["GGT", "GGC", "GGA", "GGG"]), e.Histidine = new e("Histidine", "H", "HIS", ["CAT", "CAC"]), e.Isoleucine = new e("Isoleucine", "I", "ILE", ["ATT", "ATC", "ATA"]), e.Leucine = new e("Leucine", "L", "LEU", ["TTA", "TTG", "CTT", "CTC", "CTA", "CTG"]), e.Lysine = new e("Lysine", "K", "LYS", ["AAA", "AAG"]), e.Methionine = new e("Methionine", "M", "MET", ["ATG"]), e.Phenylalanine = new e("Phenylalanine", "F", "PHE", ["TTT", "TTC"]), e.Proline = new e("Proline", "P", "PRO", ["CCT", "CCC", "CCA", "CCG"]), e.Serine = new e("Serine", "S", "SER", ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"]), e.Threonine = new e("Threonine", "T", "THR", ["ACT", "ACC", "ACA", "ACG"]), e.Tryptophan = new e("Tryptophan", "W", "TRP", ["TGG"]), e.Tyrosine = new e("Tyrosine", "Y", "TYR", ["TAT", "TAC"]), e.Valine = new e("Valine", "V", "VAL", ["GTT", "GTC", "GTA", "GTG"]), e.ALL_FULL_NAMES = function () {
            return e.getAllCanonicalAminoAcids().map(function (e) {
              return e.fullName;
            });
          }, e.ALL_1LETTER_CODES = function () {
            return e.getAllCanonicalAminoAcids().map(function (e) {
              return e.singleLetterCode;
            });
          }, e.ALL_3LETTER_CODES = function () {
            return e.getAllCanonicalAminoAcids().map(function (e) {
              return e.threeLetterCode;
            });
          }, e.ALL_CODONS = function () {
            return r.flatten(e.getAllCanonicalAminoAcids().map(function (e) {
              return e.codons;
            }));
          }, e;
        }();
      t.AminoAcid = i, t.getPDBAndCouplingMismatch = function (e, n) {
        var r = e.sequence,
          i = n.sequence,
          o = t.getSequenceMismatch(r, i);
        return 0 === o.length ? e.getResidueNumberingMismatches(n) : o;
      }, t.getSequenceMismatch = function (e, t) {
        var n = new Array();
        if (e.length === t.length) for (var r = 0; r < e.length; ++r) {
          var o = i.fromSingleLetterCode(e[r]),
            a = i.fromSingleLetterCode(t[r]);
          e[r] !== t[r] && o && a && n.push({
            couplingAminoAcid: o,
            pdbAminoAcid: a,
            resno: r
          });
        }
        return n;
      };
    },
    "./src/data/AnatomogramMapping.ts": function srcDataAnatomogramMappingTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.AnatomogramMapping = {
        homo_sapiens: {
          P11A: ["UBERON_0000178"],
          P11B: ["UBERON_0001155"],
          P12A: ["UBERON_0000955"],
          P9A: ["UBERON_0000977"],
          UBERON_0000178: ["P11A"],
          UBERON_0000955: ["P12A"],
          UBERON_0000977: ["P9A"],
          UBERON_0001155: ["P11B"]
        },
        mus_musculus: {
          UBERON_0000948: ["Heart", "Heart_and_Aorta", "Heart_and_Aorta-10X_P7_4"],
          UBERON_0001255: ["Bladder", "Bladder-10X_P4_3", "Bladder-10X_P4_4", "Bladder-10X_P7_7"],
          UBERON_0001723: ["Tongue", "Tongue-10X_P4_0", "Tongue-10X_P4_1", "Tongue-10X_P7_10"],
          UBERON_0001911: ["Mammary", "Mammary_Gland", "Mammary_Gland-10X_P7_12", "Mammary_Gland-10X_P7_13"],
          UBERON_0002048: ["Lung", "Lung-10X_P7_8", "Lung-10X_P7_9", "Lung-10X_P8_12", "Lung-10X_P8_13"],
          UBERON_0002106: ["Spleen", "Spleen-10X_P4_7", "Spleen-10X_P7_6"],
          UBERON_0002107: ["Liver", "Liver-10X_P4_2", "Liver-10X_P7_0", "Liver-10X_P7_1"],
          UBERON_0002113: ["Kidney", "Kidney-10X_P4_5", "Kidney-10X_P4_6", "Kidney-10X_P7_5"],
          UBERON_0002370: ["Thymus", "Thymus-10X_P7_11"],
          UBERON_0002371: ["Marrow", "Marrow-10X_P7_2", "Marrow-10X_P7_3"],
          UBERON_0003126: ["Trachea", "Trachea-10X_P8_14", "Trachea-10X_P8_15"],
          UBERON_0014892: ["Muscle", "Limb", "Limb_Muscle", "Limb_Muscle-10X_P7_14", "Limb_Muscle-10X_P7_15"]
        }
      };
    },
    "./src/data/Bioblocks1DSection.ts": function srcDataBioblocks1DSectionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = function () {
          function e(e, t, n) {
            void 0 === n && (n = t), this.label = e, this.sectionEnd = 0, this.sectionStart = 0, this.sectionEnd = Math.max(n, t), this.sectionStart = Math.min(t, n);
          }
          return Object.defineProperty(e.prototype, "end", {
            get: function get() {
              return this.sectionEnd;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "length", {
            get: function get() {
              return this.sectionEnd - this.sectionStart + 1;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "start", {
            get: function get() {
              return this.sectionStart;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype.contains = function () {
            for (var e, t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
            try {
              for (var o = r.__values(n), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                if (s < this.sectionStart || s > this.sectionEnd || void 0 === s) return !1;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (t = o.return) && t.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return !0;
          }, e.prototype.isEqual = function (e) {
            return e.end === this.end && e.label === this.label && e.start === this.start;
          }, e.prototype.updateStart = function (e) {
            e > this.sectionEnd ? (this.sectionStart = this.sectionEnd, this.sectionEnd = e) : this.sectionStart = e;
          }, e.prototype.updateEnd = function (e) {
            e < this.sectionStart ? (this.sectionEnd = this.sectionStart, this.sectionStart = e) : this.sectionEnd = e;
          }, e;
        }();
      t.Bioblocks1DSection = i;
    },
    "./src/data/BioblocksConfig.ts": function srcDataBioblocksConfigTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.BUTTON = "BUTTON", e.BUTTON_GROUP = "BUTTON_GROUP", e.DROP_DOWN = "DROP_DOWN", e.LABEL = "LABEL", e.CHECKBOX = "CHECKBOX", e.RADIO = "RADIO", e.RANGE_SLIDER = "RANGE_SLIDER", e.SLIDER = "SLIDER";
      }(t.CONFIGURATION_COMPONENT_TYPE || (t.CONFIGURATION_COMPONENT_TYPE = {}));
    },
    "./src/data/BioblocksData.ts": function srcDataBioblocksDataTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.ANATOMOGRAM = "Anatomogram", e.CONTACT_MAP = "Contact Map", e.INFO_PANEL = "Info Panel", e.NGL = "NGL", e.SPRING = "Spring", e.T_SNE = "T-SNE", e.UMAP_SEQUENCE = "UMAP Sequence", e.UMAP_TRANSCRIPTION = "UMAP Transcription";
      }(t.VIZ_TYPE || (t.VIZ_TYPE = {})), function (e) {
        e.cn = "cn", e.dist = "dist", e.dist_intra = "dist_intra", e.dist_multimer = "dist_multimer", e.fn = "fn", e.probability = "probability", e.precision = "precision", e.score = "score";
      }(t.COUPLING_SCORE_SOURCE || (t.COUPLING_SCORE_SOURCE = {})), function (e) {
        e.CLOSEST = "CLOSEST ATOM", e.C_ALPHA = "C-α";
      }(t.CONTACT_DISTANCE_PROXIMITY || (t.CONTACT_DISTANCE_PROXIMITY = {})), function (e) {
        e.G = "310_HELIX", e.H = "ALPHA_HELIX", e.I = "PI_HELIX", e.T = "HYDROGEN_BONDED_TURN", e.E = "BETA_SHEET", e.B = "BETA_BRIDGE", e.S = "BEND", e.C = "COIL";
      }(t.SECONDARY_STRUCTURE_CODES || (t.SECONDARY_STRUCTURE_CODES = {})), function (e) {
        e[e.AFTER_PLOT = 0] = "AFTER_PLOT", e[e.CLICK = 1] = "CLICK", e[e.DOUBLE_CLICK = 2] = "DOUBLE_CLICK", e[e.HOVER = 3] = "HOVER", e[e.LEGEND_CLICK = 4] = "LEGEND_CLICK", e[e.RELAYOUT = 5] = "RELAYOUT", e[e.SELECTION = 6] = "SELECTION", e[e.UNHOVER = 7] = "UNHOVER";
      }(t.BIOBLOCKS_CHART_EVENT_TYPE || (t.BIOBLOCKS_CHART_EVENT_TYPE = {})), function (e) {
        e[e.AXIS = 0] = "AXIS", e[e.LEGEND = 1] = "LEGEND", e[e.POINT = 2] = "POINT";
      }(t.BIOBLOCKS_CHART_PIECE || (t.BIOBLOCKS_CHART_PIECE = {}));
    },
    "./src/data/BioblocksPDB.ts": function srcDataBioblocksPDBTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("./node_modules/crypto-browserify/index.js")),
        o = n("./node_modules/util/util.js"),
        a = n("./src/data/index.ts"),
        s = n("./src/helper/index.ts"),
        l = function () {
          function e() {
            this.fileName = "", this.nglData = new s.NGLInstanceManager.instance.Structure(), this.id = "", this.getSecStructFromNGLResidue = function (e, t) {
              for (var n = e.chainIndex; !t[n];) t.push(new Array());
              var r = "C";
              e.isSheet() ? r = "E" : e.isHelix() && (r = "H"), t[n].length >= 1 && t[n][t[n].length - 1].label === r ? t[n][t[n].length - 1].updateEnd(e.resno) : t[n].push(new a.Bioblocks1DSection(r, e.resno));
            };
          }
          return Object.defineProperty(e.prototype, "contactInformation", {
            get: function get() {
              var e = this;
              if (!this.contactInfo) {
                var t = new a.CouplingContainer();
                this.nglData.eachResidue(function (n) {
                  if (n.isProtein()) {
                    var r = n.resno;
                    e.nglData.eachResidue(function (n) {
                      var i = n.resno;
                      n.isProtein() && r !== i && t.addCouplingScore({
                        dist: e.getMinDistBetweenResidues(r, i).dist,
                        i: r,
                        j: i
                      });
                    });
                  }
                }), this.contactInfo = t;
              }
              return this.contactInfo;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "name", {
            get: function get() {
              var e = this.fileName.split("/"),
                t = e[e.length - 1],
                n = t.lastIndexOf(".");
              return t.slice(0, -1 === n ? void 0 : n);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "nglStructure", {
            get: function get() {
              return this.nglData;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "rank", {
            get: function get() {
              return "UNK";
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "secondaryStructure", {
            get: function get() {
              var e = new Array();
              return this.nglData.eachResidue(function (t) {
                if (t.isProtein()) {
                  var n = "C";
                  if (t.isSheet()) n = "E";else if (t.isHelix()) n = "H";else if (t.isTurn()) return;
                  e.push({
                    resno: t.resno,
                    structId: n
                  });
                }
              }), e;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "secondaryStructureSections", {
            get: function get() {
              var e = this,
                t = new Array();
              return this.nglData.eachResidue(function (n) {
                n.isProtein() && e.getSecStructFromNGLResidue(n, t);
              }), t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "path", {
            get: function get() {
              return this.fileName;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "sequence", {
            get: function get() {
              return this.nglData ? this.nglData.getSequence().join("") : "";
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "source", {
            get: function get() {
              return "UKN";
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "uuid", {
            get: function get() {
              return this.id;
            },
            set: function set(e) {
              this.id = e;
            },
            enumerable: !0,
            configurable: !0
          }), e.createEmptyPDB = function () {
            return new e();
          }, e.createPDB = function (t, n) {
            return void 0 === t && (t = ""), void 0 === n && (n = {}), r.__awaiter(this, void 0, void 0, function () {
              var a, l, u;
              return r.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return a = new e(), l = a, [4, s.NGLInstanceManager.instance.autoLoad(t, n)];
                  case 1:
                    return l.nglData = r.sent(), a.fileName = "string" == typeof t ? t : t.name, (u = i.createHash("sha1")).update(o.inspect(a.nglData, !1, 2)), a.uuid = u.digest("hex"), [2, a];
                }
              });
            });
          }, e.createPDBFromNGLData = function (t) {
            var n = new e();
            n.nglData = t, n.fileName = t.path ? t.path : t.name;
            var r = i.createHash("sha1");
            return r.update(o.inspect(n.nglData, !1, 2)), n.uuid = r.digest("hex"), n;
          }, e.prototype.eachResidue = function (e) {
            this.nglData.eachResidue(e);
          }, e.prototype.amendPDBWithCouplingScores = function (t, n) {
            var r = this,
              i = new a.CouplingContainer(t),
              o = this.nglData.atomMap.dict[e.NGL_C_ALPHA_INDEX],
              s = {};
            return this.nglData.eachResidue(function (e) {
              r.nglData.eachResidue(function (t) {
                if (e.isProtein() && t.isProtein()) if (n === a.CONTACT_DISTANCE_PROXIMITY.C_ALPHA) {
                  var l = r.getCAlphaAtomIndexFromResidue(e.index, o),
                    u = r.getCAlphaAtomIndexFromResidue(t.index, o),
                    c = r.nglData.getAtomProxy(l).distanceTo(r.nglData.getAtomProxy(u));
                  0 !== c && i.addCouplingScore({
                    dist: c,
                    i: e.resno,
                    j: t.resno
                  });
                } else {
                  var d = Math.min(e.resno, t.resno) + "," + Math.max(e.resno, t.resno);
                  s[d] || (s[d] = r.getMinDistBetweenResidueIndices(e.index, t.index).dist), 0 !== s[d] && i.addCouplingScore({
                    dist: s[d],
                    i: e.resno,
                    j: t.resno
                  });
                }
              });
            }), this.contactInfo = i, this.contactInfo;
          }, e.prototype.getCAlphaAtomIndexFromResidue = function (e, t) {
            for (var n = this.nglData.residueStore, r = n.atomOffset[e], i = n.atomCount[e], o = r; n.residueTypeId[o] !== t && o < r + i;) o++;
            return o;
          }, e.prototype.getMinDistBetweenResidues = function (e, t) {
            return this.getMinDistBetweenResidueIndices(this.nglData.residueStore.resno.indexOf(e), this.nglData.residueStore.resno.indexOf(t));
          }, e.prototype.getResidueNumberingMismatches = function (e) {
            var t = new Array();
            return this.eachResidue(function (n) {
              var r = n.resname.toUpperCase(),
                i = e.getAminoAcidOfContact(n.resno);
              if (i && a.AminoAcid.fromSingleLetterCode(r) !== a.AminoAcid.fromSingleLetterCode(i.singleLetterCode)) {
                var o = a.AminoAcid.fromSingleLetterCode(i.singleLetterCode),
                  s = a.AminoAcid.fromFullName(r);
                void 0 !== o && void 0 !== s && t.push({
                  couplingAminoAcid: o,
                  pdbAminoAcid: s,
                  resno: n.resno
                });
              }
            }), t;
          }, e.prototype.getTrimmedName = function (e, t, n) {
            void 0 === e && (e = "_"), void 0 === t && (t = 3), void 0 === n && (n = "back");
            var r = this.name.split(e);
            return r.length > t ? ("back" === n ? r.slice(0, r.length - t) : r.slice(t)).join(e) : this.name;
          }, e.prototype.getMinDistBetweenResidueIndices = function (e, t) {
            for (var n = this.nglData.residueStore, r = n.atomCount[e], i = n.atomCount[t], o = n.atomOffset[e], a = n.atomOffset[t], s = {
                atomIndexI: -1,
                atomIndexJ: -1,
                dist: Number.MAX_SAFE_INTEGER
              }, l = 0; l < r; ++l) for (var u = 0; u < i; ++u) {
              var c = o + l,
                d = a + u,
                h = this.nglData.getAtomProxy(c).distanceTo(this.nglData.getAtomProxy(d));
              h < s.dist && (s = {
                atomIndexI: c,
                atomIndexJ: d,
                dist: h
              });
            }
            return s;
          }, e.NGL_C_ALPHA_INDEX = "CA|C", e.arePDBArraysEqual = function (e, t, n) {
            var i, o;
            void 0 === n && (n = function n(e, t) {
              return e.uuid === t.uuid;
            });
            var a = function a(e) {
              if (-1 === t.findIndex(function (t) {
                return n(t, e);
              })) return {
                value: !1
              };
            };
            try {
              for (var s = r.__values(e), l = s.next(); !l.done; l = s.next()) {
                var u = a(l.value);
                if ("object" == typeof u) return u.value;
              }
            } catch (e) {
              i = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (o = s.return) && o.call(s);
              } finally {
                if (i) throw i.error;
              }
            }
            return e.length === t.length;
          }, e;
        }();
      t.BioblocksPDB = l;
    },
    "./src/data/CodonTable.ts": function srcDataCodonTableTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = function () {
          function e(e, t, n, r, i, o) {
            this.id = e, this.name = t, this.altName = n, this.table = r, this.startCodons = i, this.stopCodons = o;
          }
          return e.rnaTableFromDNACodonTable = function (t, n, i, o) {
            return new e(t, n, i, Object.entries(o.table).reduce(function (e, t) {
              var n = r.__read(t, 2),
                i = n[0],
                o = n[1];
              return e[i.replace(/T/g, "U").replace(/t/g, "u")] = o, e;
            }, {}), o.startCodons.map(function (e) {
              return e.replace(/T/g, "U").replace(/t/g, "u");
            }), o.stopCodons.map(function (e) {
              return e.replace(/T/g, "U").replace(/t/g, "u");
            }));
          }, e;
        }();
      t.CodonTable = i, t.standardDnaCodonTable = new i(1, "standard", "SGC0", {
        AAA: "K",
        AAC: "N",
        AAG: "K",
        AAT: "N",
        ACA: "T",
        ACC: "T",
        ACG: "T",
        ACT: "T",
        AGA: "R",
        AGC: "S",
        AGG: "R",
        AGT: "S",
        ATA: "I",
        ATC: "I",
        ATG: "M",
        ATT: "I",
        CAA: "Q",
        CAC: "H",
        CAG: "Q",
        CAT: "H",
        CCA: "P",
        CCC: "P",
        CCG: "P",
        CCT: "P",
        CGA: "R",
        CGC: "R",
        CGG: "R",
        CGT: "R",
        CTA: "L",
        CTC: "L",
        CTG: "L",
        CTT: "L",
        GAA: "E",
        GAC: "D",
        GAG: "E",
        GAT: "D",
        GCA: "A",
        GCC: "A",
        GCG: "A",
        GCT: "A",
        GGA: "G",
        GGC: "G",
        GGG: "G",
        GGT: "G",
        GTA: "V",
        GTC: "V",
        GTG: "V",
        GTT: "V",
        TAC: "Y",
        TAT: "Y",
        TCA: "S",
        TCC: "S",
        TCG: "S",
        TCT: "S",
        TGC: "C",
        TGG: "W",
        TGT: "C",
        TTA: "L",
        TTC: "F",
        TTG: "L",
        TTT: "F"
      }, ["TAA", "TAG", "TGA"], ["TTG", "CTG", "ATG"]), t.standardRnaCodonTable = i.rnaTableFromDNACodonTable(2, "standard", "SGC0", t.standardDnaCodonTable);
    },
    "./src/data/CouplingContainer.ts": function srcDataCouplingContainerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/data/index.ts"),
        o = function () {
          function e(e, t) {
            var n, o;
            void 0 === e && (e = []), void 0 === t && (t = i.COUPLING_SCORE_SOURCE.cn), this.scoreSource = t, this.contacts = new Array(), this.indexRange = {
              max: 1,
              min: 1
            }, this.totalStoredContacts = 0, this.derivedFromCouplingScoresFlag = !0, this.rowCounter = 0, this.colCounter = 0;
            try {
              for (var a = r.__values(e), s = a.next(); !s.done; s = a.next()) {
                var l = s.value;
                this.addCouplingScore(l);
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
          }
          return e.fromJSON = function (t) {
            return Object.assign(new e(), t);
          }, e.getScore = function (e, t) {
            switch (t) {
              case "cn":
                return e.cn;
              case "dist":
                return e.dist;
              case "dist_intra":
                return e.dist_intra;
              case "dist_multimer":
                return e.dist_multimer;
              case "fn":
                return e.fn;
              case "probability":
                return e.probability;
              case "precision":
                return e.precision;
              case "score":
                return e.score;
              default:
                console.log("Unknown score source " + t);
            }
          }, Object.defineProperty(e.prototype, "isDerivedFromCouplingScores", {
            get: function get() {
              return this.derivedFromCouplingScoresFlag;
            },
            set: function set(e) {
              this.derivedFromCouplingScoresFlag = e;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "allContacts", {
            get: function get() {
              return this.contacts;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "chainLength", {
            get: function get() {
              return this.indexRange.max - this.indexRange.min + 1;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "rankedContacts", {
            get: function get() {
              var t = this;
              return Array.from(this).sort(function (n, r) {
                var i = e.getScore(n, t.scoreSource),
                  o = e.getScore(r, t.scoreSource);
                return i && o ? o - i : i && !o ? -1 : !i && o ? 1 : 0;
              });
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "residueIndexRange", {
            get: function get() {
              return this.indexRange;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "sequence", {
            get: function get() {
              for (var e = "", t = this.indexRange.min; t <= this.indexRange.max; ++t) {
                var n = this.getAminoAcidOfContact(t);
                n && (e += n.singleLetterCode);
              }
              return e;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(e.prototype, "totalContacts", {
            get: function get() {
              return this.totalStoredContacts;
            },
            enumerable: !0,
            configurable: !0
          }), e.prototype[Symbol.iterator] = function () {
            return this;
          }, e.prototype.addCouplingScore = function (e) {
            var t = e.A_i,
              n = e.A_j,
              i = e.i,
              o = e.j,
              a = Math.min(i, o) - 1,
              s = Math.max(i, o) - 1,
              l = a + 1 === o;
            this.contacts[a] || (this.contacts[a] = new Array()), this.contacts[a][s] || this.totalStoredContacts++, this.contacts[a][s] = r.__assign(r.__assign({}, this.contacts[a][s]), e), l && (this.contacts[a][s].i = o, this.contacts[a][s].j = i, t && n && (this.contacts[a][s].A_i = n, this.contacts[a][s].A_j = t)), this.indexRange = {
              max: Math.max(this.indexRange.max, s + 1),
              min: Math.min(this.indexRange.min, a + 1)
            };
          }, e.prototype.getAminoAcidOfContact = function (e) {
            var t, n, o, a;
            if (!(e > this.chainLength + 1)) try {
              for (var s = r.__values(this.allContacts), l = s.next(); !l.done; l = s.next()) {
                var u = l.value;
                if (u) try {
                  for (var c = (o = void 0, r.__values(u)), d = c.next(); !d.done; d = c.next()) {
                    var h = d.value;
                    if (h && h.i === e && h.A_i) return i.AminoAcid.fromSingleLetterCode(h.A_i);
                    if (h && h.j === e && h.A_j) return i.AminoAcid.fromSingleLetterCode(h.A_j);
                  }
                } catch (e) {
                  o = {
                    error: e
                  };
                } finally {
                  try {
                    d && !d.done && (a = c.return) && a.call(c);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (n = s.return) && n.call(s);
              } finally {
                if (t) throw t.error;
              }
            }
          }, e.prototype.getObservedContacts = function (e) {
            var t, n;
            void 0 === e && (e = 10);
            var i = new Array();
            try {
              for (var o = r.__values(this), a = o.next(); !a.done; a = o.next()) {
                var s = a.value;
                s.dist && s.dist <= e && i.push(s);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return i;
          }, e.prototype.getPredictedContacts = function (e, t, n) {
            var i, o;
            void 0 === t && (t = 5), void 0 === n && (n = []);
            var a = {
              correct: new Array(),
              predicted: new Array()
            };
            try {
              for (var s = r.__values(this.rankedContacts.filter(function (e) {
                  return n.reduce(function (t, n) {
                    return t && n.filterFn(e);
                  }, !0);
                }).slice(0, e)), l = s.next(); !l.done; l = s.next()) {
                var u = l.value;
                u.dist && u.dist < t && a.correct.push(u), a.predicted.push(u);
              }
            } catch (e) {
              i = {
                error: e
              };
            } finally {
              try {
                l && !l.done && (o = s.return) && o.call(s);
              } finally {
                if (i) throw i.error;
              }
            }
            return a;
          }, e.prototype.getCouplingScore = function (e, t) {
            var n = this.contacts[Math.min(e, t) - 1];
            return n ? n[Math.max(e, t) - 1] : void 0;
          }, e.prototype.includes = function (e, t) {
            return this.contacts[Math.min(e, t) - 1] && void 0 !== this.contacts[Math.min(e, t) - 1][Math.max(e, t) - 1];
          }, e.prototype.next = function () {
            for (var e = this.rowCounter; e < this.contacts.length; ++e) if (this.contacts[e]) {
              for (var t = this.colCounter; t < this.contacts[e].length; ++t) {
                var n = this.contacts[e][t];
                if (n) return this.rowCounter = e, this.colCounter = t + 1, {
                  done: !1,
                  value: n
                };
              }
              this.colCounter = 0;
            }
            return this.rowCounter = 0, this.colCounter = 0, {
              done: !0,
              value: null
            };
          }, e.prototype.updateContact = function (e, t, n) {
            this.addCouplingScore(r.__assign({
              i: e,
              j: t
            }, n));
          }, e;
        }();
      t.CouplingContainer = o;
    },
    "./src/data/Dataset.ts": function srcDataDatasetTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = function () {
        function e(e, t) {
          void 0 === t && (t = "bioblocks"), this.name = e, this.namespace = t;
        }
        return Object.defineProperty(e.prototype, "fullName", {
          get: function get() {
            return this.namespace + "/" + this.name;
          },
          enumerable: !0,
          configurable: !0
        }), e;
      }();
      t.Dataset = r;
    },
    "./src/data/IUPACData.ts": function srcDataIUPACDataTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      t.proteinLetters = "ACDEFGHIKLMNPQRSTVWY", t.extendedProteinLetters = "ACDEFGHIKLMNPQRSTVWYBXZJUO", t.proteinLetters1to3 = {
        A: "Ala",
        C: "Cys",
        D: "Asp",
        E: "Glu",
        F: "Phe",
        G: "Gly",
        H: "His",
        I: "Ile",
        K: "Lys",
        L: "Leu",
        M: "Met",
        N: "Asn",
        P: "Pro",
        Q: "Gln",
        R: "Arg",
        S: "Ser",
        T: "Thr",
        V: "Val",
        W: "Trp",
        Y: "Tyr"
      }, t.proteinLetters1to3Extended = r.__assign(r.__assign({}, t.proteinLetters1to3), {
        B: "Asx",
        J: "Xle",
        O: "Pyl",
        U: "Sec",
        X: "Xaa",
        Z: "Glx"
      }), t.proteinLetters3to1 = Object.assign.apply(Object, r.__spread([{}], Object.entries(t.proteinLetters1to3).map(function (e) {
        var t,
          n = r.__read(e, 2),
          i = n[0];
        return (t = {})[n[1]] = i, t;
      }))), t.proteinLetters3to1Extended = Object.assign.apply(Object, r.__spread([{}], Object.entries(t.proteinLetters1to3Extended).map(function (e) {
        var t,
          n = r.__read(e, 2),
          i = n[0];
        return (t = {})[n[1]] = i, t;
      }))), t.ambiguousDnaLetters = "GATCRYWSMKHBVDN", t.unambiguousDnaLetters = "GATC", t.ambiguousRnaLetters = "GAUCRYWSMKHBVDN", t.unambiguousRnaLetters = "GAUC", t.extendedDnaLetters = "GATCBDSW", t.ambiguousDnaValues = {
        A: "A",
        B: "CGT",
        C: "C",
        D: "AGT",
        G: "G",
        H: "ACT",
        K: "GT",
        M: "AC",
        N: "GATC",
        R: "AG",
        S: "CG",
        T: "T",
        V: "ACG",
        W: "AT",
        X: "GATC",
        Y: "CT"
      }, t.ambiguousRnaValues = {
        A: "A",
        B: "CGU",
        C: "C",
        D: "AGU",
        G: "G",
        H: "ACU",
        K: "GU",
        M: "AC",
        N: "GAUC",
        R: "AG",
        S: "CG",
        U: "U",
        V: "ACG",
        W: "AU",
        X: "GAUC",
        Y: "CU"
      }, t.ambiguousDnaComplement = {
        A: "T",
        B: "V",
        C: "G",
        D: "H",
        G: "C",
        H: "D",
        K: "M",
        M: "K",
        N: "N",
        R: "Y",
        S: "S",
        T: "A",
        V: "B",
        W: "W",
        X: "X",
        Y: "R"
      }, t.ambiguousRnaComplement = {
        A: "U",
        B: "V",
        C: "G",
        D: "H",
        G: "C",
        H: "D",
        K: "M",
        M: "K",
        N: "N",
        R: "Y",
        S: "S",
        U: "A",
        V: "B",
        W: "W",
        X: "X",
        Y: "R"
      }, t.unambiguousDnaWeights = {
        A: 331.2218,
        C: 307.1971,
        G: 347.2212,
        T: 322.2085
      }, t.monoisotopicUnambiguousDnaWeights = {
        A: 331.06817,
        C: 307.056936,
        G: 347.063084,
        T: 322.056602
      }, t.unambiguousRnaWeights = {
        A: 347.2212,
        C: 323.1965,
        G: 363.2206,
        U: 324.1813
      }, t.monoisotopicUnambiguousRnaWeights = {
        A: 347.063084,
        C: 323.051851,
        G: 363.057999,
        U: 324.035867
      }, t.proteinWeights = {
        A: 89.0932,
        C: 121.1582,
        D: 133.1027,
        E: 147.1293,
        F: 165.1891,
        G: 75.0666,
        H: 155.1546,
        I: 131.1729,
        K: 146.1876,
        L: 131.1729,
        M: 149.2113,
        N: 132.1179,
        O: 255.3134,
        P: 115.1305,
        Q: 146.1445,
        R: 174.201,
        S: 105.0926,
        T: 119.1192,
        U: 168.0532,
        V: 117.1463,
        W: 204.2252,
        Y: 181.1885
      }, t.monoisotopicProteinWeights = {
        A: 89.047678,
        C: 121.019749,
        D: 133.037508,
        E: 147.053158,
        F: 165.078979,
        G: 75.032028,
        H: 155.069477,
        I: 131.094629,
        K: 146.105528,
        L: 131.094629,
        M: 149.051049,
        N: 132.053492,
        O: 255.158292,
        P: 115.063329,
        Q: 146.069142,
        R: 174.111676,
        S: 105.042593,
        T: 119.058243,
        U: 168.964203,
        V: 117.078979,
        W: 204.089878,
        Y: 181.073893
      }, t.extendedProteinValues = {
        A: "A",
        B: "ND",
        C: "C",
        D: "D",
        E: "E",
        F: "F",
        G: "G",
        H: "H",
        I: "I",
        J: "IL",
        K: "K",
        L: "L",
        M: "M",
        N: "N",
        O: "O",
        P: "P",
        Q: "Q",
        R: "R",
        S: "S",
        T: "T",
        U: "U",
        V: "V",
        W: "W",
        X: "ACDEFGHIKLMNPQRSTVWY",
        Y: "Y",
        Z: "QE"
      }, t.atomWeights = {
        H: 1.00794,
        D: 2.0141,
        He: 4.002602,
        Li: 6.941,
        Be: 9.012182,
        B: 10.811,
        C: 12.0107,
        N: 14.0067,
        O: 15.9994,
        F: 18.9984032,
        Ne: 20.1797,
        Na: 22.98977,
        Mg: 24.305,
        Al: 26.981538,
        Si: 28.0855,
        P: 30.973761,
        S: 32.065,
        Cl: 35.453,
        Ar: 39.948,
        K: 39.0983,
        Ca: 40.078,
        Sc: 44.95591,
        Ti: 47.867,
        V: 50.9415,
        Cr: 51.9961,
        Mn: 54.938049,
        Fe: 55.845,
        Co: 58.9332,
        Ni: 58.6934,
        Cu: 63.546,
        Zn: 65.39,
        Ga: 69.723,
        Ge: 72.64,
        As: 74.9216,
        Se: 78.96,
        Br: 79.904,
        Kr: 83.8,
        Rb: 85.4678,
        Sr: 87.62,
        Y: 88.90585,
        Zr: 91.224,
        Nb: 92.90638,
        Mo: 95.94,
        Tc: 98,
        Ru: 101.07,
        Rh: 102.9055,
        Pd: 106.42,
        Ag: 107.8682,
        Cd: 112.411,
        In: 114.818,
        Sn: 118.71,
        Sb: 121.76,
        Te: 127.6,
        I: 126.90447,
        Xe: 131.293,
        Cs: 132.90545,
        Ba: 137.327,
        La: 138.9055,
        Ce: 140.116,
        Pr: 140.90765,
        Nd: 144.24,
        Pm: 145,
        Sm: 150.36,
        Eu: 151.964,
        Gd: 157.25,
        Tb: 158.92534,
        Dy: 162.5,
        Ho: 164.93032,
        Er: 167.259,
        Tm: 168.93421,
        Yb: 173.04,
        Lu: 174.967,
        Hf: 178.49,
        Ta: 180.9479,
        W: 183.84,
        Re: 186.207,
        Os: 190.23,
        Ir: 192.217,
        Pt: 195.078,
        Au: 196.96655,
        Hg: 200.59,
        Tl: 204.3833,
        Pb: 207.2,
        Bi: 208.98038,
        Po: 208.98,
        At: 209.99,
        Rn: 222.02,
        Fr: 223.02,
        Ra: 226.03,
        Ac: 227.03,
        Th: 232.0381,
        Pa: 231.03588,
        U: 238.02891,
        Np: 237.05,
        Pu: 244.06,
        Am: 243.06,
        Cm: 247.07,
        Bk: 247.07,
        Cf: 251.08,
        Es: 252.08,
        Fm: 257.1,
        Md: 258.1,
        No: 259.1,
        Lr: 262.11,
        Rf: 261.11,
        Db: 262.11,
        Sg: 266.12,
        Bh: 264.12,
        Hs: 269.13,
        Mt: 268.14
      };
    },
    "./src/data/Markers.ts": function srcDataMarkersTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = function () {
        function e() {}
        return e.colors = {
          autoColorFromStates: function autoColorFromStates(t, n) {
            void 0 === n && (n = e.colorSets.colorBrewer);
            var r = t.reduce(function (e, t) {
                return t && (e[t] || (e[t] = 0), e[t] += 1), e;
              }, {}),
              i = Object.entries(r).sort(function (e, t) {
                return e[1] === t[1] ? 0 : e[1] > t[1] ? -1 : 1;
              }).reduce(function (e, t, r) {
                return e[t[0]] = {
                  color: r < n.length ? n[r] : "",
                  name: t[0]
                }, e;
              }, {});
            return t.map(function (e) {
              if (e) return i[e];
            });
          }
        }, e.colorSets = {
          categorical: ["#069668", "#75e7dd", "#145a6a", "#c5d5f0", "#82269b", "#5361c7", "#e8a2de", "#479abc", "#11e38c", "#0b5313", "#bbcf7a", "#6e390d", "#f4d403", "#ae301f", "#34f50e", "#7c8a4f", "#f6bb86", "#b5753e", "#fe1d66", "#9bea30"],
          colorBrewer: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"]
        }, e;
      }();
      t.Marker = r;
    },
    "./src/data/Nucleotide.ts": function srcDataNucleotideTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = function () {
        function e(e, t) {
          this.fullName = e, this.singleLetterCode = t;
        }
        return e.fromSingleLetterCode = function (t) {
          var n = e.allNucleotides.find(function (e) {
            return e.singleLetterCode.toUpperCase() === t.toUpperCase();
          });
          return n || e.Unknown;
        }, e.fromFullName = function (t) {
          var n = e.allNucleotides.find(function (e) {
            return e.fullName.toUpperCase() === t.toUpperCase();
          });
          return n || e.Unknown;
        }, e.prototype.getComplementDNA = function () {
          return this === e.A ? e.T : this === e.T ? e.A : this === e.G ? e.C : this === e.C ? e.G : e.Unknown;
        }, e.prototype.getComplementRNA = function () {
          return this === e.T ? e.U : this === e.U ? e.T : this.getComplementDNA();
        }, e.A = new e("Adenine", "A"), e.C = new e("Cytosine", "C"), e.G = new e("Guanine", "G"), e.T = new e("Thymine", "T"), e.U = new e("Uracil", "U"), e.UKN = new e("Unknown", "-"), e.Adenine = e.A, e.Cytosine = e.C, e.Guanine = e.G, e.Thymine = e.T, e.Uracil = e.U, e.Unknown = e.UKN, e.allNucleotides = [e.A, e.C, e.G, e.T, e.U, e.UKN], e;
      }();
      t.Nucleotide = r;
    },
    "./src/data/PfamProtein.ts": function srcDataPfamProteinTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.DOMAIN = "Domain", e.FAMILY = "Family", e.MOTIF = "Motif", e.REPEAT = "Repeat";
      }(t.PFAM_A_TYPE || (t.PFAM_A_TYPE = {})), function (e) {
        e.P_FAM_A_SEARCH = "pfamASearch", e.P_FAM_B_SEARCH = "pfamBSearch";
      }(t.PFAM_SEARCH_TYPE || (t.PFAM_SEARCH_TYPE = {})), function (e) {
        e.FS = "fs", e.LS = "ls";
      }(t.PFAM_MODEL_TYPE || (t.PFAM_MODEL_TYPE = {})), function (e) {
        e.P_FAM_A = "Pfam-A", e.P_FAM_B = "Pfam-B";
      }(t.PFAM_ELEMENT_TYPE || (t.PFAM_ELEMENT_TYPE = {}));
    },
    "./src/data/PlotlyData.ts": function srcDataPlotlyDataTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.bar = "bar", e.pointcloud = "pointcloud", e.scatter = "scatter", e.scattergl = "scattergl", e.scatter3d = "scatter3d";
      }(t.PLOTLY_CHART_TYPE || (t.PLOTLY_CHART_TYPE = {}));
    },
    "./src/data/Protein.ts": function srcDataProteinTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e[e.DISEASE = 0] = "DISEASE", e[e.DOMAIN = 1] = "DOMAIN", e[e.FUNCTION = 2] = "FUNCTION", e[e.INTERACTION = 3] = "INTERACTION", e[e.MIM = 4] = "MIM", e[e.PTM = 5] = "PTM", e[e.SIMILARITY = 6] = "SIMILARITY", e[e.SUBCELLULAR_LOCATION = 7] = "SUBCELLULAR_LOCATION", e[e.SUBUNIT = 8] = "SUBUNIT", e[e.WEBRESOURCE = 9] = "WEBRESOURCE";
      }(t.PROTEIN_COMMENT_TYPE || (t.PROTEIN_COMMENT_TYPE = {}));
    },
    "./src/data/Seq.ts": function srcDataSeqTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r,
        i = n("./node_modules/tslib/tslib.es6.js"),
        o = n("./src/data/index.ts");
      !function (e) {
        e.generic_dna = "generic_dna", e.generic_rna = "generic_rna", e.generic_protein = "generic_protein";
      }(r = t.ALPHABET || (t.ALPHABET = {}));
      var a = function () {
        function e(e, t, n) {
          if (void 0 === n && (n = ["-"]), this.sequence = e, this.alphabet = t, this.ignoredCharacters = n || [], this.alphabet === r.generic_dna && !1 === this.isValidDNA(this.ignoredCharacters)) throw Error('Cannot create DNA Seq from sequence "' + this.sequence + '"');
          if (this.alphabet === r.generic_rna && !1 === this.isValidRNA(this.ignoredCharacters)) throw Error('Cannot create RNA Seq from sequence "' + this.sequence + '"');
          if (this.alphabet === r.generic_protein && !1 === this.isValidProtein(this.ignoredCharacters)) throw Error('Cannot create Protein Seq from sequence "' + this.sequence + '"');
        }
        return e.checkSequenceValidity = function (e, t, n) {
          var r = ("" + n.join().toLowerCase() + n.join().toUpperCase()).replace(/(.)(?=.*\1)/g, "");
          return new RegExp("^[" + t.toLowerCase() + t.toUpperCase() + r + "]+$").test(e);
        }, e.prototype.isValidProtein = function (t) {
          return void 0 === t && (t = this.ignoredCharacters), e.checkSequenceValidity(this.sequence, o.proteinLetters, t);
        }, e.prototype.isValidDNA = function (t) {
          return void 0 === t && (t = this.ignoredCharacters), e.checkSequenceValidity(this.sequence, o.unambiguousDnaLetters, t);
        }, e.prototype.isValidRNA = function (t) {
          return void 0 === t && (t = this.ignoredCharacters), e.checkSequenceValidity(this.sequence, o.unambiguousRnaLetters, t);
        }, e.prototype.determineAlphabet = function (e) {
          return void 0 === e && (e = ["-"]), this.alphabet ? this.alphabet : this.isValidDNA(e) ? r.generic_dna : this.isValidRNA(e) ? r.generic_rna : this.isValidProtein(e) ? r.generic_protein : void 0;
        }, e.prototype.equal = function (e) {
          return this.alphabet === e.alphabet && this.sequence.length === e.sequence.length && this.sequence.toUpperCase() === e.sequence.toUpperCase();
        }, e.prototype.binaryRepresentation = function (e) {
          void 0 === e && (e = ["-"]);
          var t = this.determineAlphabet(e),
            n = o.proteinLetters;
          t === r.generic_dna ? n = o.unambiguousDnaLetters : t === r.generic_rna && (n = o.unambiguousRnaLetters);
          var a = (n = (n += e.join()).toUpperCase()).length;
          return this.sequence.toUpperCase().split("").reduce(function (e, t) {
            var r = new Array(a).fill(0);
            return n.includes(t) && (r[n.indexOf(t)] = 1), e.push.apply(e, i.__spread(r)), e;
          }, new Array());
        }, e.prototype.integerRepresentation = function (e) {
          void 0 === e && (e = ["-"]);
          var t = this.determineAlphabet(e),
            n = o.proteinLetters;
          return t === r.generic_dna ? n = o.unambiguousDnaLetters : t === r.generic_rna && (n = o.unambiguousRnaLetters), n = (n += e.join()).toUpperCase(), this.sequence.toUpperCase().split("").map(function (e) {
            return n.indexOf(e);
          }, new Array());
        }, e.prototype.toString = function () {
          return this.sequence;
        }, e.prototype.upper = function () {
          return new e(this.sequence.toUpperCase(), this.alphabet);
        }, e.prototype.lower = function () {
          return new e(this.sequence.toLowerCase(), this.alphabet);
        }, e.prototype.subSequence = function (t, n) {
          return void 0 === t && (t = 0), new e(this.sequence.slice(t, n), this.alphabet);
        }, e.prototype.complement = function (t) {
          var n = this;
          if (void 0 === t && (t = !1), this.alphabet === r.generic_protein) throw Error("Proteins do not have complements!");
          if ((this.sequence.includes("U") || this.sequence.includes("u")) && (this.sequence.includes("T") || this.sequence.includes("t"))) throw Error("Mixed RNA/DNA found");
          var i = o.ambiguousDnaComplement,
            a = r.generic_dna;
          return (this.sequence.includes("U") || this.sequence.includes("u")) && (i = o.ambiguousRnaComplement, a = r.generic_rna), new e((t ? this.sequence.split("").reverse().join() : this.sequence).split("").map(function (e) {
            if (n.ignoredCharacters.includes(e)) return e;
            var t = e.toUpperCase();
            return t === e ? i[t] : i[t].toLowerCase();
          }).join(""), a, this.ignoredCharacters);
        }, e.prototype.reverse_complement = function () {
          return this.complement(!0);
        }, e.prototype.transcribe = function () {
          if (this.alphabet === r.generic_protein) throw Error("Proteins sequences cannot be transcribed!");
          return new e(this.sequence.replace(/T/g, "U").replace(/t/g, "u"), r.generic_rna);
        }, e.prototype.back_transcribe = function () {
          if (this.alphabet === r.generic_protein) throw Error("Proteins sequences cannot be back transcribed!");
          return new e(this.sequence.replace(/U/g, "T").replace(/u/g, "t"), r.generic_dna);
        }, e.prototype.translate = function (t, n, i) {
          if (void 0 === t && (t = "*"), void 0 === n && (n = !1), void 0 === i && (i = !1), this.alphabet === r.generic_protein) throw Error("Proteins sequences cannot be translated!");
          var a = o.standardDnaCodonTable;
          (this.sequence.includes("U") || this.sequence.includes("u")) && (a = o.standardRnaCodonTable);
          var s = this.sequence.match(/.{1,3}/g);
          if (i) {
            if (this.sequence.length % 3 != 0) throw Error("Invalid coding sequence - sequence length must be a multiple of 3!");
            if (this.sequence.length < 6 || s[0] in a.startCodons == !1 || s[s.length - 1] in a.stopCodons == !1) throw Error("Invalid coding sequence - sequence must have a valid start and stop codon!");
          }
          if (!s) return new e("", r.generic_protein);
          var l = "";
          return s.forEach(function (e) {
            if (3 === e.length) {
              var r = e.toUpperCase();
              if (r in a.table) l += a.table[r];else if (r in a.stopCodons && (l += t, n)) return;
            }
          }), new e(l, r.generic_protein);
        }, e.fromSeqOpts = function (t) {
          return new e(t.sequence, t.alphabet, t.ignoredCharacters);
        }, e;
      }();
      t.Seq = a;
    },
    "./src/data/SeqIO.ts": function srcDataSeqIOTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r,
        i = n("./node_modules/tslib/tslib.es6.js"),
        o = n("./src/data/index.ts");
      !function (e) {
        e.fasta = "fasta";
      }(r = t.SEQUENCE_FILE_TYPES || (t.SEQUENCE_FILE_TYPES = {}));
      var a = function () {
        function e() {}
        return e.parseFile = function (t, n, a) {
          var s = i.__assign(i.__assign({}, e.DEFAULT_SEQ_PROPERTIES), a),
            l = new Array();
          if (n !== r.fasta) throw Error('File type "' + n + '" not recognized');
          t.split(/\r|\n|\r\n/).reduce(function (e, t) {
            var n = t.trim();
            if (n.length > 0) if (">" === n[0]) e.push({
              annotations: {
                name: n.substr(1)
              },
              sequence: ""
            });else if (e.length > 0) {
              var r = n.replace(/\./g, "-");
              e[e.length - 1].sequence += r;
            }
            return e;
          }, l);
          return l.map(function (e) {
            s.alphabet, s.ignoredCharacters;
            return new o.SeqRecord(new o.Seq(e.sequence, s.alphabet, s.ignoredCharacters), {
              id: e.annotations.id,
              name: e.annotations.name
            });
          });
        }, e.getRandomSetOfSequences = function (e, t) {
          var n = i.__spread(e);
          if (t > e.length) return n;
          for (var r = new Array(); r.length < t;) {
            var o = Math.floor(Math.random() * n.length);
            r.push(n[o]), n.splice(o, 1);
          }
          return r;
        }, e.DEFAULT_SEQ_PROPERTIES = {
          alphabet: void 0,
          ignoredCharacters: []
        }, e;
      }();
      t.SeqIO = a;
    },
    "./src/data/SeqRecord.ts": function srcDataSeqRecordTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/data/index.ts"),
        o = function (e) {
          function t(n, o) {
            void 0 === o && (o = {});
            var a = e.call(this, n.sequence, n.alphabet, n.ignoredCharacters) || this;
            return a.annotations = o, a.annotations = r.__assign(r.__assign({}, t.DEFAULT_ANNOTATIONS), o), Object.keys(i.Seq.prototype).forEach(function (n) {
              var r = n,
                s = Reflect.getOwnPropertyDescriptor(i.Seq.prototype, n);
              "function" == typeof a[r] && s && s.writable && Reflect.set(a, r, function () {
                for (var n = [], s = 0; s < arguments.length; s++) n[s] = arguments[s];
                var l = e.prototype[r].call(a, n);
                return l instanceof i.Seq ? new t(l, o) : l;
              });
            }), a;
          }
          return r.__extends(t, e), t.DEFAULT_ANNOTATIONS = {
            dbxrefs: [],
            description: "<unknown description>",
            id: "<unknown id>",
            letterAnnotations: {},
            metadata: {},
            name: "<unknown name>"
          }, t.fromSeqRecordOpts = function (e) {
            return new t(new i.Seq(e.sequence.sequence, e.sequence.alphabet, e.sequence.ignoredCharacters), e.annotations);
          }, t;
        }(i.Seq);
      t.SeqRecord = o;
    },
    "./src/data/TintedBioblocks1DSection.ts": function srcDataTintedBioblocks1DSectionTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = function (e) {
          function t(t, n, r, i) {
            void 0 === r && (r = n), void 0 === i && (i = "orange");
            var o = e.call(this, t, n, r) || this;
            return o.label = t, o.sectionColor = "orange", o.sectionColor = i, o;
          }
          return r.__extends(t, e), Object.defineProperty(t.prototype, "color", {
            get: function get() {
              return this.sectionColor;
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.updateColor = function (e) {
            this.sectionColor = e;
          }, t;
        }(n("./src/data/index.ts").Bioblocks1DSection);
      t.TintedBioblocks1DSection = i;
    },
    "./src/data/event/BioblocksChartEvent.ts": function srcDataEventBioblocksChartEventTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./src/data/index.ts"),
        i = function () {
          function e(e, t, n, r) {
            void 0 === n && (n = []), void 0 === r && (r = {}), this.type = e, this.chartPiece = t, this.selectedPoints = n, this.plotlyEvent = r;
          }
          return e.prototype.isAxis = function () {
            return this.chartPiece === r.BIOBLOCKS_CHART_PIECE.AXIS;
          }, e;
        }();
      t.BioblocksChartEvent = i;
    },
    "./src/data/event/index.ts": function srcDataEventIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n("./node_modules/tslib/tslib.es6.js").__exportStar(n("./src/data/event/BioblocksChartEvent.ts"), t);
    },
    "./src/data/index.ts": function srcDataIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/data/AminoAcid.ts"), t), r.__exportStar(n("./src/data/Nucleotide.ts"), t), r.__exportStar(n("./src/data/AnatomogramMapping.ts"), t), r.__exportStar(n("./src/data/Bioblocks1DSection.ts"), t), r.__exportStar(n("./src/data/BioblocksConfig.ts"), t), r.__exportStar(n("./src/data/BioblocksData.ts"), t), r.__exportStar(n("./src/data/BioblocksPDB.ts"), t), r.__exportStar(n("./src/data/CodonTable.ts"), t), r.__exportStar(n("./src/data/CouplingContainer.ts"), t), r.__exportStar(n("./src/data/Dataset.ts"), t), r.__exportStar(n("./src/data/IUPACData.ts"), t), r.__exportStar(n("./src/data/Markers.ts"), t), r.__exportStar(n("./src/data/PfamProtein.ts"), t), r.__exportStar(n("./src/data/PlotlyData.ts"), t), r.__exportStar(n("./src/data/Protein.ts"), t), r.__exportStar(n("./src/data/Seq.ts"), t), r.__exportStar(n("./src/data/SeqIO.ts"), t), r.__exportStar(n("./src/data/SeqRecord.ts"), t), r.__exportStar(n("./src/data/TintedBioblocks1DSection.ts"), t), r.__exportStar(n("./src/data/event/index.ts"), t);
    },
    "./src/helper/ArrayHelper.ts": function srcHelperArrayHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.areTwoArraysEqual = function (e, t) {
        if (e.length !== t.length) return !1;
        for (var n = 0, r = e.length; n < r; ++n) if (e[n] !== t[n]) return !1;
        return !0;
      };
    },
    "./src/helper/ColorMapper.ts": function srcHelperColorMapperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = function () {
        function e(t, n, r) {
          void 0 === t && (t = new Map()), void 0 === n && (n = "black"), void 0 === r && (r = e.DEFAULT_COLORS), this.colorMap = t, this.defaultColor = n, this.colors = r;
        }
        return e.prototype.getColorFor = function (e) {
          return this.colorMap.has(e) || this.addColorToMapper(e), this.colorMap.get(e);
        }, e.prototype.addEntry = function (e, t, n) {
          void 0 === n && (n = !0), this.colorMap.has(e) || this.addColorToMapper(e, t, n);
        }, e.prototype.addColorToMapper = function (e, t, n) {
          void 0 === t && (t = this.defaultColor), this.colorMap.set(e, t), t && n && !this.colors.includes(t) && this.colors.push(t);
        }, e.DEFAULT_COLORS = ["red", "green", "blue", "orange", "purple", "teal", "pink", "yellow", "violet", "olive", "brown"], e;
      }();
      t.ColorMapper = r;
    },
    "./src/helper/CouplingMapper.ts": function srcHelperCouplingMapperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.generateDefaultHeaderIndices = function (e) {
        return {
          A_i: e.length - 2,
          A_j: e.length - 1,
          cn: 2,
          dist: 3,
          i: 0,
          j: 1
        };
      }, t.getCouplingHeaderIndices = function (e) {
        var t = {};
        return e.filter(function (e) {
          return e.length >= 1;
        }).map(function (n) {
          t[n.trim()] = e.indexOf(n);
        }), t;
      };
    },
    "./src/helper/DataHelper.ts": function srcHelperDataHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/data/index.ts"),
        o = n("./src/helper/index.ts");
      t.fetchAppropriateData = function (e, n) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          return r.__generator(this, function (r) {
            switch (e) {
              case i.VIZ_TYPE.T_SNE:
                return [2, t.fetchTSneCoordinateData(n)];
              case i.VIZ_TYPE.SPRING:
                return [2, t.fetchSpringData(n)];
              case i.VIZ_TYPE.NGL:
                return [2, t.fetchNGLDataFromDirectory(n)];
              case i.VIZ_TYPE.CONTACT_MAP:
              case i.VIZ_TYPE.INFO_PANEL:
                return [2, t.fetchContactMapData(n)];
              default:
                return [2, Promise.reject({
                  error: "Currently no appropriate data getter for " + e
                })];
            }
            return [2];
          });
        });
      }, t.fetchAppropriateDataFromFile = function (e, n) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var a, s;
          return r.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                switch (e) {
                  case i.VIZ_TYPE.NGL:
                    return [3, 1];
                  case i.VIZ_TYPE.CONTACT_MAP:
                    return [3, 2];
                }
                return [3, 4];
              case 1:
                return [2, t.fetchNGLDataFromFile(n)];
              case 2:
                return a = {}, s = t.getCouplingScoresData, [4, o.readFileAsText(n)];
              case 3:
                return [2, (a.couplingScores = s.apply(void 0, [r.sent()]), a)];
              case 4:
                return [2, Promise.reject({
                  error: "Currently no appropriate data getter for " + e + " files"
                })];
            }
          });
        });
      }, t.fetchSpringData = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n, i;
          return r.__generator(this, function (o) {
            switch (o.label) {
              case 0:
                return [4, a(e + "/categorical_coloring_data.json")];
              case 1:
                return t = o.sent(), n = new Array(), i = Object.keys(t), t[i[0]].label_list.forEach(function (e, o) {
                  n.push({
                    labelForCategory: i.reduce(function (e, n) {
                      var i;
                      return r.__assign(r.__assign({}, e), ((i = {})[n] = t[n].label_list[o], i));
                    }, {}),
                    number: o
                  });
                }), [2, {
                  nodes: n
                }];
            }
          });
        });
      };
      var a = function a(e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n, i, a, l, u, c, d, h;
          return r.__generator(this, function (f) {
            switch (f.label) {
              case 0:
                return [4, o.fetchJSONFile(e)];
              case 1:
                t = f.sent(), n = {};
                try {
                  for (i = r.__values(Object.keys(t)), a = i.next(); !a.done; a = i.next()) {
                    if (l = a.value, !(u = t[l]).label_colors || !u.label_list) throw new Error("Unable to parse color data - does it have keys named 'label_colors' and 'label_list'");
                    c = s(u, t), n[l] = c;
                  }
                } catch (e) {
                  d = {
                    error: e
                  };
                } finally {
                  try {
                    a && !a.done && (h = i.return) && h.call(i);
                  } finally {
                    if (d) throw d.error;
                  }
                }
                return [2, n];
            }
          });
        });
      };
      t.fetchSpringCoordinateData = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n;
          return r.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, o.fetchCSVFile(e)];
              case 1:
                return t = r.sent(), n = [], (t ? t.split("\n") : []).forEach(function (e, t, r) {
                  var i = e.split(",");
                  if (i.length >= 3) {
                    var o = parseFloat(i[1].trim()),
                      a = parseFloat(i[2].trim()),
                      s = parseInt(i[0].trim(), 10);
                    n[s] = [o, a];
                  } else if (0 !== e.localeCompare("")) throw new Error("Unable to parse coordinate data - Row " + t + " does not have at least 3 columns!");
                }), [2, n];
            }
          });
        });
      }, t.fetchMatrixData = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n;
          return r.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, o.fetchCSVFile("" + e)];
              case 1:
                return t = r.sent(), n = [], t.split("\n").forEach(function (e) {
                  if (e.length > 0) {
                    var t = e.split(",").map(Number.parseFloat);
                    n.push(t);
                  }
                }), [2, n];
            }
          });
        });
      }, t.fetchTSneCoordinateData = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n;
          return r.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, o.fetchCSVFile(e + "/tsne_output.csv")];
              case 1:
                return t = r.sent(), n = [], t.split("\n").forEach(function (e) {
                  if (e.length > 0) {
                    var t = e.split(","),
                      r = [parseFloat(t[0]), parseFloat(t[1])];
                    n.push(r);
                  }
                }), [2, n];
            }
          });
        });
      }, t.fetchTensorTSneCoordinateDataFromFile = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n, i, a, s, l, u;
          return r.__generator(this, function (c) {
            switch (c.label) {
              case 0:
                return [4, o.fetchCSVFile(e)];
              case 1:
                t = c.sent(), n = new Array();
                try {
                  for (i = r.__values(t.split("\n")), a = i.next(); !a.done; a = i.next()) (s = a.value).length >= 1 && n.push(s.split(",").map(parseFloat));
                } catch (e) {
                  l = {
                    error: e
                  };
                } finally {
                  try {
                    a && !a.done && (u = i.return) && u.call(i);
                  } finally {
                    if (l) throw l.error;
                  }
                }
                return [2, n];
            }
          });
        });
      }, t.fetchTensorTSneCoordinateData = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          return r.__generator(this, function (n) {
            return [2, t.fetchTensorTSneCoordinateDataFromFile(e + "/tsne_matrix.csv")];
          });
        });
      }, t.fetchGraphData = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t;
          return r.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, o.fetchJSONFile(e)];
              case 1:
                if (!(t = n.sent()).nodes || !t.links) throw new Error("Unable to parse graph data - does it have keys named 'nodes' and 'links'");
                return [2, t];
            }
          });
        });
      }, t.fetchNGLDataFromDirectory = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var n;
          return r.__generator(this, function (r) {
            return 0 === e.length ? [2, Promise.reject("Empty path.")] : (n = e + "/protein.pdb", [2, t.fetchNGLDataFromFile(n)]);
          });
        });
      }, t.fetchNGLDataFromFile = function (e, t) {
        return void 0 === t && (t = {}), r.__awaiter(void 0, void 0, void 0, function () {
          return r.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, o.NGLInstanceManager.instance.autoLoad(e, t)];
              case 1:
                return [2, n.sent()];
            }
          });
        });
      }, t.fetchContactMapData = function (e, n) {
        return void 0 === n && (n = "known"), r.__awaiter(void 0, void 0, void 0, function () {
          var a, s, l, u, c;
          return r.__generator(this, function (d) {
            switch (d.label) {
              case 0:
                return 0 === e.length ? [2, Promise.reject("Empty path.")] : (a = ["coupling_scores.csv", "residue_mapping.csv"], [4, Promise.all(a.map(function (t) {
                  return r.__awaiter(void 0, void 0, void 0, function () {
                    return r.__generator(this, function (n) {
                      return [2, o.fetchCSVFile(e + "/" + t)];
                    });
                  });
                }))]);
              case 1:
                return s = d.sent(), [4, i.BioblocksPDB.createPDB(e + "/protein.pdb")];
              case 2:
                return l = d.sent(), (c = {})[n] = l, u = c, [2, {
                  couplingScores: l.amendPDBWithCouplingScores(t.getCouplingScoresData(s[0], o.generateResidueMapping(s[1])).rankedContacts, i.CONTACT_DISTANCE_PROXIMITY.CLOSEST),
                  pdbData: u,
                  secondaryStructures: []
                }];
            }
          });
        });
      };
      var s = function s(e, t) {
        var n,
          i,
          o = {
            label_colors: {},
            label_list: e.label_list
          },
          a = t[Object.keys(t)[0]].label_colors;
        try {
          for (var s = r.__values(Object.keys(a)), l = s.next(); !l.done; l = s.next()) {
            var u = l.value,
              c = a[u];
            "number" == typeof c ? o.label_colors[u] = c : "#" === c.charAt(0) ? o.label_colors[u] = Number.parseInt("0x" + c.slice(1), 16) : o.label_colors[u] = Number.parseInt(c, 16);
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            l && !l.done && (i = s.return) && i.call(s);
          } finally {
            if (n) throw n.error;
          }
        }
        return o;
      };
      t.getCouplingScoresData = function (e, t) {
        void 0 === t && (t = []);
        var n = e.split("\n")[0].split(","),
          a = l(n),
          s = a ? o.getCouplingHeaderIndices(n) : o.generateDefaultHeaderIndices(n),
          c = new i.CouplingContainer();
        return e.split("\n").slice(a ? 1 : 0).filter(function (e) {
          return e.split(",").length >= 2;
        }).map(function (e) {
          var n = e.split(","),
            i = u(n, s);
          if (t.length >= 1) {
            var o = t.findIndex(function (e) {
                return e.couplingsResno === i.i;
              }),
              a = t.findIndex(function (e) {
                return e.couplingsResno === i.j;
              });
            c.addCouplingScore(r.__assign(r.__assign({}, i), {
              A_i: t[o].pdbResCode,
              A_j: t[a].pdbResCode,
              i: t[o].pdbResno,
              j: t[a].pdbResno
            }));
          } else c.addCouplingScore(i);
        }), c;
      };
      var l = function l(e) {
          return ["cn", "dist", "i", "j"].filter(function (t) {
            return e.includes(t);
          }).length >= 1;
        },
        u = function u(e, t) {
          return Object.entries(t).reduce(function (t, n) {
            var i,
              o = n[0],
              a = n[1];
            return r.__assign(r.__assign({}, t), ((i = {})[o] = isNaN(Number(e[a])) ? e[a] : Number(e[a]), i));
          }, {
            i: -1,
            j: -1
          });
        };
      t.augmentCouplingScoresWithResidueMapping = function (e, t) {
        var n, o;
        void 0 === t && (t = []);
        var a = new i.CouplingContainer(),
          s = function s(e) {
            var n = t.findIndex(function (t) {
                return t.couplingsResno === e.i;
              }),
              i = t.findIndex(function (t) {
                return t.couplingsResno === e.j;
              });
            a.addCouplingScore(r.__assign(r.__assign({}, e), {
              A_i: t[n].pdbResCode,
              A_j: t[i].pdbResCode,
              i: t[n].pdbResno,
              j: t[i].pdbResno
            }));
          };
        try {
          for (var l = r.__values(e), u = l.next(); !u.done; u = l.next()) {
            s(u.value);
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            u && !u.done && (o = l.return) && o.call(l);
          } finally {
            if (n) throw n.error;
          }
        }
        return a;
      }, t.getSecondaryStructureData = function (e) {
        return e.split("\n").slice(1).filter(function (e) {
          return e.split(",").length >= 3;
        }).map(function (e) {
          var t = e.split(",");
          return {
            resno: parseFloat(t[1]),
            structId: t[2]
          };
        });
      }, t.subsample = function (e, t, n) {
        void 0 === n && (n = !1);
        var i = n ? e.map(function (e, t) {
          return t;
        }) : r.__spread(e);
        if (t >= e.length) return i;
        for (var o = new Array(); o.length < t;) {
          var a = Math.floor(Math.random() * i.length);
          o.push(i[a]), i.splice(a, 1);
        }
        return o;
      };
    },
    "./src/helper/FetchHelper.ts": function srcHelperFetchHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/data/index.ts");
      t.fetchCSVFile = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t;
          return r.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, fetch(e)];
              case 1:
                if ((t = n.sent()).ok) return [2, t.text()];
                throw new Error(o("CSV", t));
            }
          });
        });
      }, t.fetchJSONFile = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t;
          return r.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, fetch(e)];
              case 1:
                if ((t = n.sent()).ok) return [2, t.json()];
                throw new Error(o("JSON", t));
            }
          });
        });
      }, t.fetchFastaFile = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t, n, o;
          return r.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, fetch(e)];
              case 1:
                return (t = r.sent()).ok ? (o = (n = i.SeqIO).parseFile, [4, t.text()]) : [3, 3];
              case 2:
                return [2, o.apply(n, [r.sent(), i.SEQUENCE_FILE_TYPES.fasta])];
              case 3:
                throw new Error("error " + t);
            }
          });
        });
      };
      var o = function o(e, t) {
        return "Bioblocks-viz error fetching " + e + " File!\nStatus: " + t.status + "\nMessage: " + t.statusText + "\n";
      };
      t.readFileAsText = function (e) {
        return r.__awaiter(void 0, void 0, void 0, function () {
          var t;
          return r.__generator(this, function (n) {
            return t = new FileReader(), [2, new Promise(function (n, r) {
              t.onerror = function () {
                t.abort(), r("Problem parsing input file.");
              }, t.onload = function () {
                n(t.result);
              }, t.readAsText(e);
            })];
          });
        });
      };
    },
    "./src/helper/FunctionHelper.ts": function srcHelperFunctionHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.EMPTY_FUNCTION = function () {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      };
    },
    "./src/helper/NGLHelper.ts": function srcHelperNGLHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = r.__importStar(n("./node_modules/ngl/dist/ngl.js")),
        o = function () {
          function e() {}
          return Object.defineProperty(e, "instance", {
            get: function get() {
              return e.nglInstance;
            },
            enumerable: !0,
            configurable: !0
          }), e.setNGLInstance = function (t) {
            e.nglInstance = t;
          }, e.nglInstance = i, e;
        }();
      t.NGLInstanceManager = o, t.defaultDistanceParams = {
        color: "red"
      }, t.defaultDistanceTooltipParams = {
        labelBackground: !0,
        labelBackgroundColor: "lightgrey",
        labelBackgroundMargin: .75,
        labelBorder: !0,
        labelBorderColor: "white",
        labelBorderWidth: .3,
        labelColor: "black",
        labelSize: 5,
        labelUnit: "angstrom",
        labelZOffset: 35
      }, t.createDistanceRepresentation = function (e, n, i, o) {
        void 0 === o && (o = {});
        var a = r.__assign(r.__assign(r.__assign({}, t.defaultDistanceParams), o), {
          atomPair: Array.isArray(n) ? [n] : [n.split(",")]
        });
        return i && (a = r.__assign(r.__assign({}, a), t.defaultDistanceTooltipParams)), e.addRepresentation("distance", a);
      }, t.createBallStickRepresentation = function (e, t) {
        return e.addRepresentation("ball+stick", {
          sele: t.join(", ")
        });
      }, t.createSecStructRepresentation = function (e, t, n, r) {
        void 0 === n && (n = 2), void 0 === r && (r = "#feb83f");
        var i = e.addRepresentation("cartoon", {
          color: r,
          radiusScale: n,
          sele: t.start + "-" + t.end
        });
        return i.setParameters({
          wireframe: !0
        }), i;
      };
    },
    "./src/helper/PlotlyHelper.ts": function srcHelperPlotlyHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./src/data/index.ts");
      t.generateScatterGLData = function (e, n) {
        return void 0 === n && (n = !1), r.__assign(r.__assign({}, t.generateScatterData(e, n)), {
          type: i.PLOTLY_CHART_TYPE.scattergl
        });
      }, t.generateScatterData = function (e, t) {
        void 0 === t && (t = !1);
        var n = e.marker,
          l = e.points,
          u = e.hoverinfo,
          c = e.subtitle,
          d = e.name,
          h = e.text,
          f = l.map(function (e) {
            return e.i;
          }),
          p = l.map(function (e) {
            return e.j;
          }),
          m = l.map(function (e) {
            return e.dist ? e.dist : -1;
          }),
          g = h ? Array.isArray(h) ? h : [h] : [];
        return {
          hoverinfo: u || "x+y+z",
          marker: r.__assign({
            color: o(t, m, e),
            size: e.nodeSize
          }, n),
          mode: "markers",
          name: d + " " + c,
          text: s(t, g),
          type: i.PLOTLY_CHART_TYPE.scatter,
          x: a(t, f, p),
          y: a(t, p, f),
          z: a(t, m, m)
        };
      };
      var o = function o(e, t, n) {
          var i = e ? 2 * t.length : t.length,
            o = new Array(i);
          if (n.marker && "string" == typeof n.marker.color) return o.fill(n.marker.color);
          var a = t.map(function (e) {
            return e.toString();
          });
          return e ? r.__spread(a, a) : a;
        },
        a = function a(e, t, n) {
          return e ? r.__spread(t, n) : t;
        },
        s = function s(e, t) {
          return e ? r.__spread(t, t.map(function (e) {
            if (e.includes("<br>") && e.includes("(")) {
              var t = e.indexOf("<br>");
              return "(" + e.substr(1, t - 2).split(", ").reverse().join(", ") + ")" + e.substring(t);
            }
            return e.includes("(") ? "(" + e.substr(1, e.length - 2).split(", ").reverse().join(", ") + ")" : "" + e.split(", ").reverse().join(", ");
          })) : t;
        };
      t.generateCouplingScoreHoverText = function (e) {
        var t = "";
        return e && (t = e.A_i && e.A_j ? "(" + e.i + e.A_i + ", " + e.j + e.A_j + ")" : "(" + e.i + ", " + e.j + ")", e.score && (t = t + "<br>Score: " + e.score), e.probability && (t = t + "<br>Probability: " + e.probability.toFixed(1))), t;
      }, t.generateFloat32ArrayFromContacts = function (e) {
        var t = new Float32Array(2 * e.length);
        return e.forEach(function (e, n) {
          t[2 * n] = e.i, t[2 * n + 1] = e.j;
        }), t;
      }, t.generatePointCloudData = function (e, n) {
        void 0 === n && (n = !1);
        var o = e.points,
          a = t.generateFloat32ArrayFromContacts(o);
        return {
          marker: r.__assign(r.__assign({}, e.marker), {
            sizemax: 2 * e.nodeSize,
            sizemin: e.nodeSize
          }),
          mode: "markers",
          type: i.PLOTLY_CHART_TYPE.pointcloud,
          xy: n ? new Float32Array(r.__spread(Array.from(a), Array.from(a).slice().reverse())) : a
        };
      };
    },
    "./src/helper/ResidueMapper.ts": function srcHelperResidueMapperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = ["up_index", "up_residue", "pdb_index", "pdb_residue"],
        o = ["id", "coord_id", "one_letter_code"];
      t.generateResidueMapping = function (e) {
        var t = /\t|,/,
          n = e.split("\n")[0].split(t),
          r = s(n),
          o = a(n, r),
          l = r ? o.id : o.up_index,
          u = r ? o.coord_id : o.pdb_index,
          c = r ? o.one_letter_code : o.pdb_residue;
        return e.split("\n").slice(1).reduce(function (e, n) {
          var a = n.split(t);
          return a.length >= i.length && e.push({
            couplingsResCode: r ? a[c] : a[o.up_residue],
            couplingsResno: parseInt(a[l], 10),
            pdbResCode: a[c],
            pdbResno: parseInt(a[u], 10)
          }), e;
        }, new Array());
      };
      var a = function a(e, t) {
          var n = {},
            r = t ? o : i;
          return e.length >= i.length && r.map(function (t) {
            if (!e.includes(t)) throw new Error("Missing error " + t + " in residue mapping file!");
            n[t] = e.indexOf(t);
          }), n;
        },
        s = function s(e) {
          var t, n;
          try {
            for (var i = r.__values(o), a = i.next(); !a.done; a = i.next()) {
              var s = a.value;
              if (!e.includes(s)) return !1;
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              a && !a.done && (n = i.return) && n.call(i);
            } finally {
              if (t) throw t.error;
            }
          }
          return !0;
        };
    },
    "./src/helper/StringHelper.ts": function srcHelperStringHelperTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.capitalizeFirstLetter = function (e) {
        return "" + e.substr(0, 1).toLocaleUpperCase() + e.substr(1).toLocaleLowerCase();
      }, t.capitalizeEveryWord = function (e, t) {
        return void 0 === t && (t = " "), e.split(t).map(function (e) {
          return "" + e.substr(0, 1).toLocaleUpperCase() + e.substr(1).toLocaleLowerCase();
        }).join(t);
      };
    },
    "./src/helper/index.ts": function srcHelperIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/helper/ArrayHelper.ts"), t), r.__exportStar(n("./src/helper/ColorMapper.ts"), t), r.__exportStar(n("./src/helper/CouplingMapper.ts"), t), r.__exportStar(n("./src/helper/DataHelper.ts"), t), r.__exportStar(n("./src/helper/FetchHelper.ts"), t), r.__exportStar(n("./src/helper/FunctionHelper.ts"), t), r.__exportStar(n("./src/helper/NGLHelper.ts"), t), r.__exportStar(n("./src/helper/PlotlyHelper.ts"), t), r.__exportStar(n("./src/helper/ResidueMapper.ts"), t), r.__exportStar(n("./src/helper/StringHelper.ts"), t);
    },
    "./src/index.ts": function srcIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/action/index.ts"), t), r.__exportStar(n("./src/component/index.ts"), t), r.__exportStar(n("./src/container/index.ts"), t), r.__exportStar(n("./src/data/index.ts"), t), r.__exportStar(n("./src/helper/index.ts"), t), r.__exportStar(n("./src/reducer/index.ts"), t), r.__exportStar(n("./src/selector/index.ts"), t);
    },
    "./src/reducer/BBStore.ts": function srcReducerBBStoreTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = n("./node_modules/redux/es/redux.js"),
        o = (n("./node_modules/redux-logger/dist/redux-logger.js"), r.__importStar(n("./node_modules/redux-thunk/es/index.js"))),
        a = n("./src/reducer/index.ts"),
        s = [o.default];
      s.push(a.BioblocksMiddleware);
      var l = {
          visualizations: new Array()
        },
        u = function u(e) {
          var t = Object.keys(e);
          return Object.keys(l).forEach(function (n) {
            -1 === t.indexOf(n) && (e[n] = function (e) {
              return void 0 === e && (e = null), e;
            });
          }), i.combineReducers(e);
        },
        c = u(a.ReducerRegistry.getReducers());
      a.ReducerRegistry.setChangeListener(function (e) {
        t.BBStore.replaceReducer(u(e));
      });
      t.BBStore = i.createStore(c, l, i.applyMiddleware.apply(void 0, r.__spread(s)));
    },
    "./src/reducer/BioblocksMiddleware.ts": function srcReducerBioblocksMiddlewareTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      t.BioblocksMiddleware = function (e) {
        return function (t) {
          return function (n) {
            var o,
              a,
              s = t(n);
            try {
              for (var l = r.__values(i.transforms.keys()), u = l.next(); !u.done; u = l.next()) {
                var c = u.value,
                  d = c.split("-");
                if (d[0].includes(n.meta)) {
                  var h = i.transforms.get(c);
                  if (h) {
                    var f = h(e.getState());
                    e.dispatch({
                      payload: f,
                      type: (d[d.length - 1] + "_SET").toUpperCase()
                    });
                  }
                }
              }
            } catch (e) {
              o = {
                error: e
              };
            } finally {
              try {
                u && !u.done && (a = l.return) && a.call(l);
              } finally {
                if (o) throw o.error;
              }
            }
            return s;
          };
        };
      };
      var i = function () {
        function e(e) {
          void 0 === e && (e = []), this.requiredDataSubs = e;
        }
        return e.addTransform = function (e) {
          var t = e.fromState,
            n = e.toState,
            r = "string" == typeof t ? t : (t.namespace ? t.namespace : "bioblocks") + "/" + t.stateName,
            i = "string" == typeof n ? n : (n.namespace ? n.namespace : "bioblocks") + "/" + n.stateName;
          this.transforms.set(r + "-" + i, e.fn);
        }, e.transforms = new Map(), e;
      }();
      t.BioblocksMiddlewareTransformer = i;
    },
    "./src/reducer/ContainerReducer.ts": function srcReducerContainerReducerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/immutable/dist/immutable.js"),
        i = n("./node_modules/typesafe-actions/dist/index.umd.js"),
        o = n("./src/action/index.ts"),
        a = n("./src/reducer/index.ts");
      t.ContainerReducer = function (e, t) {
        void 0 === t && (t = "bioblocks");
        var n = o.createContainerActions(e, t),
          a = r.Set();
        return function (e, t) {
          switch (void 0 === e && (e = a), t.type) {
            case i.getType(n.add):
              var o = t.payload;
              return e.add(o);
            case i.getType(n.addMultiple):
              return (o = t.payload).reduce(function (e, t) {
                return e.add(t);
              }, e);
            case i.getType(n.clear):
              return r.Set();
            case i.getType(n.remove):
              o = t.payload;
              return e.remove(o);
            case i.getType(n.removeMultiple):
              return (o = t.payload).reduce(function (e, t) {
                return e.remove(t);
              }, e);
            case i.getType(n.set):
              o = t.payload;
              return r.Set(o);
            default:
              return e;
          }
        };
      }, t.createContainerReducer = function (e, n) {
        void 0 === n && (n = "bioblocks");
        var r = t.ContainerReducer(e, n),
          i = n + "/" + e;
        a.ReducerRegistry.register(i, r);
      };
    },
    "./src/reducer/DataReducer.ts": function srcReducerDataReducerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/typesafe-actions/dist/index.umd.js"),
        i = n("./src/action/index.ts"),
        o = n("./src/reducer/index.ts");
      t.DataReducer = function (e, t, n) {
        void 0 === n && (n = "bioblocks");
        var o = i.createDataActions(e, n);
        return function (e, n) {
          switch (void 0 === e && (e = t), n.type) {
            case r.getType(o.success):
              return n.payload;
            case r.getType(o.failure):
              var i = n.payload;
              return console.error(i), t;
            default:
              return e;
          }
        };
      }, t.createDataReducer = function (e, n, r) {
        void 0 === r && (r = "bioblocks");
        var i = t.DataReducer(e, n, r),
          a = r + "/" + e;
        o.ReducerRegistry.register(a, i);
      };
    },
    "./src/reducer/ObjectReducer.ts": function srcReducerObjectReducerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/immutable/dist/immutable.js"),
        i = n("./node_modules/typesafe-actions/dist/index.umd.js"),
        o = n("./src/action/index.ts"),
        a = n("./src/reducer/index.ts");
      t.ObjectReducer = function (e, t) {
        void 0 === t && (t = "bioblocks");
        var n = o.createObjectActions(e, t),
          a = r.Map();
        return function (e, t) {
          switch (void 0 === e && (e = a), t.type) {
            case i.getType(n.add):
              var o = t.payload;
              return e.merge(o);
            case i.getType(n.clear):
              return r.Map();
            case i.getType(n.remove):
              o = t.payload;
              return e.remove(o);
            case i.getType(n.removeMultiple):
              return (o = t.payload).reduce(function (e, t) {
                return e.remove(t);
              }, e);
            case i.getType(n.set):
              o = t.payload;
              return r.Map(o);
            case i.getType(n.toggle):
              var s = t.payload,
                l = e;
              return Object.keys(s).forEach(function (t) {
                l = e.has(t) ? e.remove(t) : e.set(t, s[t]);
              }), l;
            default:
              return e;
          }
        };
      }, t.createObjectReducer = function (e, n) {
        void 0 === n && (n = "bioblocks");
        var r = t.ObjectReducer(e, n),
          i = n + "/" + e;
        a.ReducerRegistry.register(i, r);
      };
    },
    "./src/reducer/ResiduePairReducer.ts": function srcReducerResiduePairReducerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/redux/es/redux.js"),
        i = n("./src/reducer/index.ts");
      t.RESIDUE_PAIR_DATASET_NAME = "residuePair", t.ResiduePairReducer = function (e) {
        return void 0 === e && (e = "bioblocks"), r.combineReducers({
          candidates: i.ContainerReducer(t.RESIDUE_PAIR_DATASET_NAME + "/candidates", e),
          hovered: i.ContainerReducer(t.RESIDUE_PAIR_DATASET_NAME + "/hovered", e),
          locked: i.ObjectReducer(t.RESIDUE_PAIR_DATASET_NAME + "/locked", e)
        });
      }, t.createResiduePairReducer = function (e) {
        void 0 === e && (e = "bioblocks");
        var n = t.ResiduePairReducer(e),
          r = e + "/" + t.RESIDUE_PAIR_DATASET_NAME;
        i.ReducerRegistry.register(r, n);
      };
    },
    "./src/reducer/SpringReducer.ts": function srcReducerSpringReducerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/redux/es/redux.js"),
        i = n("./src/reducer/index.ts");
      t.SpringReducer = function (e) {
        return void 0 === e && (e = "bioblocks"), r.combineReducers({
          category: i.ValueReducer("spring/category", "", e),
          graphData: i.DataReducer("spring/graphData", {
            nodes: []
          }, e)
        });
      }, t.createSpringReducer = function (e) {
        void 0 === e && (e = "bioblocks");
        var n = t.SpringReducer(e),
          r = e + "/spring";
        i.ReducerRegistry.register(r, n);
      };
    },
    "./src/reducer/ValueReducer.ts": function srcReducerValueReducerTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/typesafe-actions/dist/index.umd.js"),
        i = n("./src/action/index.ts"),
        o = n("./src/reducer/index.ts");
      t.ValueReducer = function (e, t, n) {
        void 0 === n && (n = "bioblocks");
        var o = i.createValueActions(e, n);
        return function (e, n) {
          switch (void 0 === e && (e = t), n.type) {
            case r.getType(o.clear):
              return t;
            case r.getType(o.set):
              return n.payload;
            default:
              return e;
          }
        };
      }, t.createValueReducer = function (e, n, r) {
        void 0 === r && (r = "bioblocks");
        var i = t.ValueReducer(e, n, r),
          a = r + "/" + e;
        o.ReducerRegistry.register(a, i);
      };
    },
    "./src/reducer/index.ts": function srcReducerIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/reducer/registry/index.ts"), t), r.__exportStar(n("./src/reducer/BioblocksMiddleware.ts"), t), r.__exportStar(n("./src/reducer/ContainerReducer.ts"), t), r.__exportStar(n("./src/reducer/ObjectReducer.ts"), t), r.__exportStar(n("./src/reducer/DataReducer.ts"), t), r.__exportStar(n("./src/reducer/ResiduePairReducer.ts"), t), r.__exportStar(n("./src/reducer/SpringReducer.ts"), t), r.__exportStar(n("./src/reducer/ValueReducer.ts"), t), r.__exportStar(n("./src/reducer/BBStore.ts"), t);
    },
    "./src/reducer/registry/ReducerRegistry.ts": function srcReducerRegistryReducerRegistryTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js"),
        i = new (function () {
          function e() {
            this.reducers = {}, this.emitChange = null;
          }
          return e.prototype.getReducers = function () {
            return r.__assign({}, this.reducers);
          }, e.prototype.register = function (e, t) {
            var n;
            Object.keys(this.reducers).includes(e) ? console.log("Reducer '" + e + " already exists, not replacing") : this.reducers = r.__assign(r.__assign({}, this.reducers), ((n = {})[e] = t, n)), this.emitChange && this.emitChange(this.getReducers());
          }, e.prototype.setChangeListener = function (e) {
            this.emitChange = e;
          }, e;
        }())();
      t.ReducerRegistry = i;
    },
    "./src/reducer/registry/index.ts": function srcReducerRegistryIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n("./node_modules/tslib/tslib.es6.js").__exportStar(n("./src/reducer/registry/ReducerRegistry.ts"), t);
    },
    "./src/selector/ContainerSelectors.ts": function srcSelectorContainerSelectorsTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/immutable/dist/immutable.js");
      t.selectCurrentItems = function (e, t, n) {
        return void 0 === n && (n = "bioblocks"), e && e[n + "/" + t] ? e[n + "/" + t] : r.Set();
      };
    },
    "./src/selector/ObjectSelectors.ts": function srcSelectorObjectSelectorsTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/immutable/dist/immutable.js");
      t.selectObject = function (e, t, n) {
        return void 0 === n && (n = "bioblocks"), e && e[n + "/" + t] ? e[n + "/" + t] : r.Map();
      };
    },
    "./src/selector/ResiduePairSelectors.ts": function srcSelectorResiduePairSelectorsTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/immutable/dist/immutable.js");
      t.getResiduePairs = function (e, t) {
        return void 0 === t && (t = "bioblocks"), void 0 !== e && e[t + "/residuePair"] ? e[t + "/residuePair"] : {
          candidates: r.Set(),
          hovered: r.Set(),
          locked: r.Map()
        };
      }, t.getCandidates = function (e, n) {
        return void 0 === n && (n = "bioblocks"), t.getResiduePairs(e, n).candidates;
      }, t.getHovered = function (e, n) {
        return void 0 === n && (n = "bioblocks"), t.getResiduePairs(e, n).hovered;
      }, t.getLocked = function (e, n) {
        return void 0 === n && (n = "bioblocks"), t.getResiduePairs(e, n).locked;
      };
    },
    "./src/selector/SpringSelectors.ts": function srcSelectorSpringSelectorsTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/immutable/dist/immutable.js"),
        i = n("./node_modules/reselect/es/index.js");
      t.getSpring = function (e, t) {
        return void 0 === t && (t = "bioblocks"), void 0 !== e && e[t + "/spring"] ? e[t + "/spring"] : {
          category: "",
          graphData: {
            nodes: []
          }
        };
      }, t.getGraphData = function (e, n) {
        return void 0 === n && (n = "bioblocks"), t.getSpring(e, n).graphData;
      }, t.getCategories = i.createSelector([t.getGraphData], function (e) {
        var t = e && e.nodes ? e.nodes : [],
          n = r.Set(t.length >= 1 ? Object.keys(t[0].labelForCategory) : []),
          i = new Map();
        return n.forEach(function (e) {
          if (e) {
            var n = r.Set(Array.from(t.map(function (t) {
              return t.labelForCategory[e];
            })));
            i.set(e, n);
          }
        }), n;
      }), t.getLabels = i.createSelector([t.getGraphData], function (e) {
        var t = e && e.nodes ? e.nodes : [],
          n = r.Set(t.length >= 1 ? Object.keys(t[0].labelForCategory) : []),
          i = r.Set();
        return n.forEach(function (e) {
          e && (i = i.merge(r.Set(Array.from(t.map(function (t) {
            return t.labelForCategory[e];
          })))));
        }), i;
      });
    },
    "./src/selector/ValueSelectors.ts": function srcSelectorValueSelectorsTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.selectCurrentValue = function (e, t, n, r) {
        return void 0 === n && (n = null), void 0 === r && (r = "bioblocks"), e && e[r + "/" + t] ? e[r + "/" + t] : n;
      };
    },
    "./src/selector/index.ts": function srcSelectorIndexTs(e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var r = n("./node_modules/tslib/tslib.es6.js");
      r.__exportStar(n("./src/selector/ContainerSelectors.ts"), t), r.__exportStar(n("./src/selector/ObjectSelectors.ts"), t), r.__exportStar(n("./src/selector/ResiduePairSelectors.ts"), t), r.__exportStar(n("./src/selector/SpringSelectors.ts"), t), r.__exportStar(n("./src/selector/ValueSelectors.ts"), t);
    },
    0: function _(e, t) {},
    1: function _(e, t) {},
    2: function _(e, t) {},
    3: function _(e, t) {},
    react: function react(e, t) {
      e.exports = __WEBPACK_EXTERNAL_MODULE_react__;
    },
    "react-dom": function reactDom(e, t) {
      e.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;
    }
  });
});